const words = [
  {
    word: "a di đà phật",
    part_of_speech: "danh từ",
    meaning:
      "Phật A Di Đà (vị Phật lớn nhất ở Cõi Cực Lạc; người theo đạo Phật dùng để niệm Phật hoặc chào nhau): na mô A Di Đà Phật!",
    example: "na mô A Di Đà Phật!",
  },
  {
    word: "a dua",
    part_of_speech: "động từ",
    meaning:
      "làm theo, bắt chước theo việc làm sai trái của người khác: a dua theo bọn xấu làm bậy",
    example: "a dua theo bọn xấu làm bậy",
  },
  {
    word: "ả",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) người con gái: "Đầu lòng hai ả tố nga, Thuý Kiều là chị em là Thuý Vân." (TKiều)',
    example: 'Đầu lòng hai ả tố nga, Thuý Kiều là chị em là Thuý Vân." (TKiều)',
  },
  {
    word: "ả",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) từ dùng để chỉ người phụ nữ nào đó với ý coi thường: mấy ả gái điếm * ả đã thực hiện nhiều vụ lừa đảo",
    example: "mấy ả gái điếm * ả đã thực hiện nhiều vụ lừa đảo",
  },
  {
    word: "ả",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) chị: tại anh tại ả, tại cả đôi bên (tng)",
    example: "tại anh tại ả, tại cả đôi bên (tng)",
  },
  {
    word: "á",
    part_of_speech: "cảm từ",
    meaning:
      "tiếng thốt ra biểu lộ sự sửng sốt hoặc cảm giác đau đột ngột: á đau!",
    example: "á đau!",
  },
  {
    word: "á à",
    part_of_speech: "cảm từ",
    meaning:
      '(khẩu ngữ) tiếng thốt ra biểu thị ý ngạc nhiên như mới vỡ lẽ ra điều gì: "Á à, anh này giỏi nhỉ? Anh định sinh sự với tôi chắc." (NgĐLạp; 2)',
    example:
      'Á à, anh này giỏi nhỉ? Anh định sinh sự với tôi chắc." (NgĐLạp; 2)',
  },
  {
    word: "ạ",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý kính trọng hoặc thân mật khi nói chuyện với ai: cháu chào bà ạ! * thôi chị ạ, nghĩ làm gì cho thêm mệt!",
    example: "cháu chào bà ạ! * thôi chị ạ, nghĩ làm gì cho thêm mệt!",
  },
  {
    word: "à",
    part_of_speech: "trợ từ",
    meaning:
      "(khẩu ngữ) từ biểu thị ý hỏi để rõ thêm về điều mình có phần ngạc nhiên: vẫn còn ngủ đấy à? * mai đã chủ nhật rồi cơ à? * thế à?",
    example: "vẫn còn ngủ đấy à? * mai đã chủ nhật rồi cơ à? * thế à?",
  },
  {
    word: "à",
    part_of_speech: "cảm từ",
    meaning:
      "(khẩu ngữ) tiếng thốt ra trong đối thoại biểu lộ ý chợt nhận ra hay chợt nhớ ra điều gì: à, thì ra là thế! * à quên, anh vừa nói gì nhỉ?",
    example: "à, thì ra là thế! * à quên, anh vừa nói gì nhỉ?",
  },
  {
    word: "a di đà",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) A Di Đà Phật (nói tắt): na mô A Di Đà",
    example: "na mô A Di Đà",
  },
  {
    word: "à à",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) từ gợi tả sự chuyển động nhanh, mạnh và dồn dập với số lượng lớn theo một hướng nhất định: đàn ong bay theo à à  * bọn trẻ à à ra sân",
    example: "đàn ong bay theo à à  * bọn trẻ à à ra sân",
  },
  {
    word: "a",
    part_of_speech: "danh từ",
    meaning:
      "nông cụ gồm hai lưỡi cắt tra vào cán dài, để cắt cỏ hay gặt lúa: rèn một lưỡi a bằng ba lưỡi hái (tng)",
    example: "rèn một lưỡi a bằng ba lưỡi hái (tng)",
  },
  {
    word: "a",
    part_of_speech: "động từ",
    meaning: "sấn vào, xông vào: a vào giật cho bằng được",
    example: "a vào giật cho bằng được",
  },
  {
    word: "a",
    part_of_speech: "trợ từ",
    meaning:
      "(Ít dùng) từ biểu thị ý hỏi, hơi lấy làm lạ hoặc hơi mỉa mai: bây giờ mới đi a? * thật thế a?",
    example: "bây giờ mới đi a? * thật thế a?",
  },
  {
    word: "a",
    part_of_speech: "cảm từ",
    meaning:
      'tiếng thốt ra biểu lộ sự vui mừng, ngạc nhiên hoặc sực nhớ điều gì: a mẹ đã về! * a, mình nhớ ra rồi!  * "A a a... Anh Tràng! Anh Tràng đã về chúng mày ơi!" (KLân; 9)',
    example:
      'a mẹ đã về! * a, mình nhớ ra rồi!  * "A a a... Anh Tràng! Anh Tràng đã về chúng mày ơi!" (KLân; 9)',
  },
  {
    word: "a",
    part_of_speech: "cảm từ",
    meaning: ".  are (viết tắt).",
    example: "khán đài A * sản phẩm đạt loại A * số nhà 4A (trước 4B)",
  },
  {
    word: "a",
    part_of_speech: "cảm từ",
    meaning: "ampere (viết tắt).",
    example:
      "giấy khổ A4 (kích cỡ 210 x 297mm) * photocopy đồ án trên giấy A3 (kích cỡ 297 x 420mm)",
  },
  {
    word: "a ha",
    part_of_speech: "cảm từ",
    meaning:
      'tiếng thốt ra biểu lộ sự mừng rỡ, tán thưởng: a ha, thắng rồi! * "Chúng mày ơi! Thầy úp được con chó rồi!... a ha." (NCao; 30)',
    example:
      'a ha, thắng rồi! * "Chúng mày ơi! Thầy úp được con chó rồi!... a ha." (NCao; 30)',
  },
  {
    word: "a lô",
    part_of_speech: "cảm từ",
    meaning:
      "tiếng gọi dùng trong điện thoại hoặc khi gọi loa để gợi sự chú ý: alô, ai gọi đấy ạ? * alô, alô, đồng bào chú ý",
    example: "alô, ai gọi đấy ạ? * alô, alô, đồng bào chú ý",
  },
  {
    word: "a hoàn",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) người đầy tớ gái trong xã hội phong kiến Trung Quốc thời xưa: "A hoàn một lũ nối theo, Quạt tha thướt phẩy, lò dìu dặt mang." (NĐM)',
    example:
      'A hoàn một lũ nối theo, Quạt tha thướt phẩy, lò dìu dặt mang." (NĐM)',
  },
  {
    word: "á hậu",
    part_of_speech: "danh từ",
    meaning:
      "người chiếm giải nhì, sau hoa hậu (trong một cuộc thi sắc đẹp): đoạt danh hiệu á hậu thế giới",
    example: "đoạt danh hiệu á hậu thế giới",
  },
  {
    word: "a ma tơ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (phong cách, lối làm việc) phóng túng, tuỳ thích, không có sự chuyên tâm: thông minh nhưng chủ quan, học hành rất a ma tơ * tính a ma tơ",
    example: "thông minh nhưng chủ quan, học hành rất a ma tơ * tính a ma tơ",
  },
  {
    word: "á kim",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi chung các đơn chất không có ánh kim, dẫn điện và dẫn nhiệt kém: arsenic, silicium là những nguyên tố á kim",
    example: "arsenic, silicium là những nguyên tố á kim",
  },
  {
    word: "à ơi",
    part_of_speech: "cảm từ",
    meaning:
      'tiếng đệm trong lời ru: "À ơi! Cái ngủ mày ngủ cho lâu, Mẹ mày đi cấy đồng sâu chưa về." (ca dao)',
    example:
      'À ơi! Cái ngủ mày ngủ cho lâu, Mẹ mày đi cấy đồng sâu chưa về." (ca dao)',
  },
  {
    word: "ạ ơi",
    part_of_speech: "cảm từ",
    meaning:
      'tiếng đệm trong lời ru: "À ơi! Cái ngủ mày ngủ cho lâu, Mẹ mày đi cấy đồng sâu chưa về." (ca dao)',
    example:
      'À ơi! Cái ngủ mày ngủ cho lâu, Mẹ mày đi cấy đồng sâu chưa về." (ca dao)',
  },
  {
    word: "á thánh",
    part_of_speech: "danh từ",
    meaning:
      "danh hiệu người đời tặng cho bậc có vốn hiểu biết rộng và phẩm chất đạo đức cao, đứng sau bậc thánh trong nho giáo: Mạnh Tử được người đời xếp vào hàng á thánh, sau Khổng Tử",
    example: "Mạnh Tử được người đời xếp vào hàng á thánh, sau Khổng Tử",
  },
  {
    word: "á thánh",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) chào (theo cách nói của trẻ con): ạ bác đi con * ạ mẹ đi nào!",
    example: "ạ bác đi con * ạ mẹ đi nào!",
  },
  {
    word: "à uôm",
    part_of_speech: "",
    meaning: "(hiếm) lẫn lộn, mập mờ: công tư phải rạch ròi, đừng có à uôm",
    example: "công tư phải rạch ròi, đừng có à uôm",
  },
  {
    word: "à uôm",
    part_of_speech: "",
    meaning: "(khẩu ngữ) qua loa, cốt cho có, cho xong: quen thói à uôm",
    example: "quen thói à uôm",
  },
  {
    word: "a-mi-đan",
    part_of_speech: "danh từ",
    meaning:
      "mô bạch huyết ở họng người, tròn và to bằng đầu ngón tay: sưng amygdala * cắt amygdala",
    example: "sưng amygdala * cắt amygdala",
  },
  {
    word: "a tòng",
    part_of_speech: "động từ",
    meaning:
      "tham gia vào (việc làm sai trái dưới sự điều khiển của người khác) một cách thiếu suy nghĩ hoặc do bị cưỡng ép: xử tội kẻ chủ mưu, tha cho bọn a tòng",
    example: "xử tội kẻ chủ mưu, tha cho bọn a tòng",
  },
  {
    word: "ác báo",
    part_of_speech: "động từ",
    meaning:
      "(cũ) (người đã làm điều ác) lại gặp phải điều ác, theo quan niệm của đạo Phật: làm điều ác sẽ bị ác báo",
    example: "làm điều ác sẽ bị ác báo",
  },
  {
    word: "ác bá",
    part_of_speech: "danh từ",
    meaning:
      "(Từ cũ) kẻ có nhiều tội ác, dựa vào quyền thế đè nén, áp bức nông dân cả một vùng: bọn cường hào ác bá",
    example: "bọn cường hào ác bá",
  },
  {
    word: "abscess",
    part_of_speech: "danh từ",
    meaning:
      "khối mủ tụ trong một bộ phận cơ thể do nhiễm trùng mà thành: nhọt là một loại abscess trong da",
    example: "nhọt là một loại abscess trong da",
  },
  {
    word: "ác",
    part_of_speech: "tính từ",
    meaning:
      "(người hoặc việc) gây ra hoặc thích gây ra điều có hại cho người khác: việc/tội ác * Con người ở ác (= luôn làm chuyện hại người khác) sẽ gặp điều ác. * Thằng Tây nó ác lắm, đồng chí ạ. (Nguyễn Đình Thi) * Đợt lũ lần này ác (= gây hại nhiều) quá!",
    example:
      "việc/tội ác * Con người ở ác (= luôn làm chuyện hại người khác) sẽ gặp điều ác. * Thằng Tây nó ác lắm, đồng chí ạ. (Nguyễn Đình Thi) * Đợt lũ lần này ác (= gây hại nhiều) quá!",
  },
  {
    word: "ác",
    part_of_speech: "tính từ",
    meaning: "(Hán) dữ, không tốt lành: ác cảm * ác mộng",
    example: "ăn ở độc ác * thủ đoạn độc ác",
  },
  {
    word: "ác",
    part_of_speech: "tính từ",
    meaning:
      "(thông tục) xấu xa, khắt khe: Mày ác quá! Nó còn nhỏ mà đã bắt nó làm đủ thứ chuyện rồi. * Ông thầy đó ác với học trò lắm.",
    example: "quân ác ôn * Đồ ác ôn!",
  },
  {
    word: "ác",
    part_of_speech: "tính từ",
    meaning:
      "(thông tục) nghịch ngợm quá đáng:  Tụi nhỏ chơi ác quá! Cái áo mới mặc chưa gì đã bị tụi nó làm dơ.",
    example: "ác cảm * ác mộng",
  },
  {
    word: "ác",
    part_of_speech: "danh từ",
    meaning:
      "nhánh cây mới đâm ra, đầu nụ có hoa: Cây mới trồng đã đâm nhánh ác.",
    example: "Cây mới trồng đã đâm nhánh ác.",
  },
  {
    word: "ác",
    part_of_speech: "danh từ",
    meaning: "(cũ) con quạ: Ác tắm thì ráo, sáo tắm thì mưa. (tục ngữ)",
    example: "Ác tắm thì ráo, sáo tắm thì mưa.",
  },
  {
    word: "ác",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, văn chương) mặt trời: Trông ra ác đã ngậm gương non đoài. (Nguyễn Du) ĐỒNG ác vàng, kim ô",
    example: "Trông ra ác đã ngậm gương non đoài.",
  },
  {
    word: "ác",
    part_of_speech: "phụ từ",
    meaning:
      "(lóng) dùng sau từ cần nhấn mạnh: Con nhỏ kia đẹp ác! * Chiếc xe đó chạy nhanh ác!",
    example: "Con nhỏ kia đẹp ác! * Chiếc xe đó chạy nhanh ác!",
  },
  {
    word: "ác cái là",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) không may là, khó khăn là (cho nên việc nói đến bị trở ngại, không thực hiện được): đi sớm, nhưng ác cái là xe hỏng giữa đường",
    example: "đi sớm, nhưng ác cái là xe hỏng giữa đường",
  },
  {
    word: "ác giả ác báo",
    part_of_speech: "",
    meaning:
      'làm điều ác thì mình hoặc con cháu sẽ phải gánh chịu cái ác, theo quan niệm của đạo Phật: "Ác giả ác báo vần xoay, Hại nhân nhân hại sự nay đã thường." (ca dao)',
    example:
      'Ác giả ác báo vần xoay, Hại nhân nhân hại sự nay đã thường." (ca dao)',
  },
  {
    word: "ác cảm",
    part_of_speech: "",
    meaning:
      "có cảm giác không ưa, phần nào thấy ghét: mối ác cảm * không ai ác cảm gì với nó!",
    example: "mối ác cảm * không ai ác cảm gì với nó!",
  },
  {
    word: "ác hại",
    part_of_speech: "tính từ",
    meaning: "có hại lớn, gây tổn thất lớn: trận mưa đá ác hại",
    example: "trận mưa đá ác hại",
  },
  {
    word: "ác khẩu",
    part_of_speech: "tính từ",
    meaning:
      "hay nói những lời độc địa: đừng có ác khẩu! * ác khẩu nhưng không ác tâm",
    example: "đừng có ác khẩu! * ác khẩu nhưng không ác tâm",
  },
  {
    word: "ác đức",
    part_of_speech: "tính từ",
    meaning:
      "(cũ, hiếm) thường hay làm điều ác, không có cái đức (âm đức) để lại cho con cháu, theo tín ngưỡng dân gian: nghề ác đức * ăn ở ác đức",
    example: "nghề ác đức * ăn ở ác đức",
  },
  {
    word: "ác hiểm",
    part_of_speech: "tính từ",
    meaning: "nguy hiểm đáng sợ: mưu mô ác hiểm * ngón đòn ác hiểm",
    example: "mưu mô ác hiểm * ngón đòn ác hiểm",
  },
  {
    word: "ác chiến",
    part_of_speech: "động từ",
    meaning: "chiến đấu cực kì ác liệt, có nhiều thương vong: trận ác chiến",
    example: "trận ác chiến",
  },
  {
    word: "ác liệt",
    part_of_speech: "tính từ",
    meaning:
      "(hoạt động đối lập nhau) rất gay gắt, quyết liệt, gây ra nhiều thiệt hại đáng sợ: cuộc chiến ác liệt * địch đánh phá ngày càng ác liệt",
    example: "cuộc chiến ác liệt * địch đánh phá ngày càng ác liệt",
  },
  {
    word: "ác liệt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ, hiếm) (hiện tượng tự nhiên) xấu tồi tệ, gây nhiều thiệt hại: thời tiết ác liệt",
    example: "thời tiết ác liệt",
  },
  {
    word: "ác mỏ",
    part_of_speech: "danh từ",
    meaning:
      "con vẹt; thường dùng để ví người cay nghiệt: quằm quặm như con ác mỏ (tng)",
    example: "quằm quặm như con ác mỏ (tng)",
  },
  {
    word: "ác mộng",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương) giấc mơ dữ, thấy những điều không lành đáng sợ; cũng dùng để chỉ tai hoạ lớn đã trải qua, nghĩ đến còn thấy ghê sợ, tưởng như thực như hư: gặp ác mộng * cơn ác mộng",
    example: "gặp ác mộng * cơn ác mộng",
  },
  {
    word: "ác ôn",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) kẻ có quyền lực ở địa phương, có nhiều tội ác đối với nhân dân, đáng nguyền rủa (ví như ôn dịch): diệt ác ôn",
    example: "diệt ác ôn",
  },
  {
    word: "ác ôn",
    part_of_speech: "tính từ",
    meaning:
      '(khẩu ngữ) có nhiều hành động tàn ác, dã man (cũng dùng làm tiếng rủa): đồ ác ôn! * "Thằng Xăm ác ôn lắm, nó dám bắn bà mẹ như chơi." (AĐức; 16)',
    example:
      'đồ ác ôn! * "Thằng Xăm ác ôn lắm, nó dám bắn bà mẹ như chơi." (AĐức; 16)',
  },
  {
    word: "ác nhân",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) kẻ làm điều ác, kẻ xấu: "Dưới hoa dậy lũ ác nhân, Ầm ầm khốc quỷ kinh thần mọc ra." (TKiều)',
    example:
      'Dưới hoa dậy lũ ác nhân, Ầm ầm khốc quỷ kinh thần mọc ra." (TKiều)',
  },
  {
    word: "ác tâm",
    part_of_speech: "",
    meaning: "(cũ) lòng dạ độc ác: không có ác tâm hại người",
    example: "không có ác tâm hại người",
  },
  {
    word: "ác nghiệt",
    part_of_speech: "tính từ",
    meaning: "ác và khắt khe: đối xử ác nghiệt * người dì ghẻ ác nghiệt",
    example: "đối xử ác nghiệt * người dì ghẻ ác nghiệt",
  },
  {
    word: "ác nghiệp",
    part_of_speech: "danh từ",
    meaning:
      'hậu quả sẽ phải gánh chịu ở kiếp sau do tội ác ở kiếp này tạo nên, theo quan niệm của đạo Phật: "Làm cho thảm thiết đoạ đày, Cho bõ lại ngày ác nghiệp dương gian!" (BCB)',
    example:
      'Làm cho thảm thiết đoạ đày, Cho bõ lại ngày ác nghiệp dương gian!" (BCB)',
  },
  {
    word: "ác nghiệp",
    part_of_speech: "tính từ",
    meaning:
      '(cũ) như ác nghiệt: "Phải người ác nghiệp cơ cầu, Hai con quan Trạng rủ nhau ăn mày!" (PCCH)',
    example:
      'Phải người ác nghiệp cơ cầu, Hai con quan Trạng rủ nhau ăn mày!" (PCCH)',
  },
  {
    word: "ác thú",
    part_of_speech: "danh từ",
    meaning: "thú dữ, ăn thịt người: con ác thú",
    example: "con ác thú",
  },
  {
    word: "ác ý",
    part_of_speech: "danh từ",
    meaning: "dụng ý xấu: nói vui, không có ác ý gì",
    example: "nói vui, không có ác ý gì",
  },
  {
    word: "ách tắc",
    part_of_speech: "động từ",
    meaning: "(giao thông) tắc, nghẽn lại: ách tắc giao thông",
    example: "ách tắc giao thông",
  },
  {
    word: "ách tắc",
    part_of_speech: "động từ",
    meaning:
      "tắc nghẽn, đình trệ: công việc bị ách tắc vì thiếu vốn * giải quyết những chỗ ách tắc trong khâu quản lí",
    example:
      "công việc bị ách tắc vì thiếu vốn * giải quyết những chỗ ách tắc trong khâu quản lí",
  },
  {
    word: "ách tắc",
    part_of_speech: "danh từ",
    meaning:
      "sự tắc nghẽn, sự khó khăn trở ngại: công việc đang gặp ách tắc * ách tắc luôn xảy ra trong giờ cao điểm",
    example:
      "công việc đang gặp ách tắc * ách tắc luôn xảy ra trong giờ cao điểm",
  },
  {
    word: "ác vàng",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) mặt trời: "Lần lần thỏ bạc ác vàng, Xót người trong hội đoạn tràng đòi cơn!" (TKiều)',
    example:
      'Lần lần thỏ bạc ác vàng, Xót người trong hội đoạn tràng đòi cơn!" (TKiều)',
  },
  {
    word: "ách",
    part_of_speech: "danh từ",
    meaning: "đoạn gỗ cong mắc trên vai trâu bò để buộc dây kéo cày, kéo xe.",
    example: "ách nô lệ",
  },
  {
    word: "ách",
    part_of_speech: "động từ",
    meaning: "dừng lại, không tiếp tục tiến hành được: công việc bị ách lại",
    example: "công việc bị ách lại",
  },
  {
    word: "ách",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) ngăn lại, bắt phải dừng: bị công an ách lại hỏi giấy tờ",
    example: "bị công an ách lại hỏi giấy tờ",
  },
  {
    word: "ách",
    part_of_speech: "tính từ",
    meaning: "(bụng) đầy ứ, có cảm giác tức, khó chịu: ăn no ách bụng",
    example: "ăn no ách bụng",
  },
  {
    word: "ác tính",
    part_of_speech: "tính từ",
    meaning:
      "(bệnh tật) hiểm nghèo, có thể gây tử vong trong thời gian ngắn: u ác tính * sốt rét ác tính",
    example: "u ác tính * sốt rét ác tính",
  },
  {
    word: "ad hoc",
    part_of_speech: "phụ từ",
    meaning:
      "chỉ riêng cho một trường hợp, một việc cụ thể nào đó: một giải pháp ad hoc",
    example: "một giải pháp ad hoc",
  },
  {
    word: "ái chà",
    part_of_speech: "cảm từ",
    meaning:
      '(khẩu ngữ) tiếng thốt ra biểu lộ sự thích thú hay ngạc nhiên: ái chà, đẹp ghê! * "Ái chà! Thế thì nhất bu mày! Nhất vợ nhì trời." (NCao; 27)',
    example:
      'ái chà, đẹp ghê! * "Ái chà! Thế thì nhất bu mày! Nhất vợ nhì trời." (NCao; 27)',
  },
  {
    word: "ai bảo",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp dùng để giải thích và quy lỗi cho người nào đó về điều không hay đã xảy ra cho bản thân người ấy: bị mắng là phải, ai bảo không nghe lời!",
    example: "bị mắng là phải, ai bảo không nghe lời!",
  },
  {
    word: "ai điếu",
    part_of_speech: "",
    meaning: "bài văn viếng người chết để bày tỏ lòng thương tiếc: đọc ai điếu",
    example: "đọc ai điếu",
  },
  {
    word: "ái ân",
    part_of_speech: "danh từ",
    meaning:
      '(văn chương) tình yêu nam nữ thắm thiết: "Bây giờ trâm gãy gương tan, Kể làm sao xiết muôn vàn ái ân!" (TKiều)',
    example:
      'Bây giờ trâm gãy gương tan, Kể làm sao xiết muôn vàn ái ân!" (TKiều)',
  },
  {
    word: "ái",
    part_of_speech: "cảm từ",
    meaning: "tiếng thốt lên khi bị đau đột ngột: ái! đau quá",
    example: "ái! đau quá",
  },
  {
    word: "ai ai",
    part_of_speech: "đại từ",
    meaning:
      'mọi người, ai cũng như ai: "Máu rơi thịt nát tan tành, Ai ai trông thấy hồn kinh phách rời!" (TKiều)',
    example:
      'Máu rơi thịt nát tan tành, Ai ai trông thấy hồn kinh phách rời!" (TKiều)',
  },
  {
    word: "ai",
    part_of_speech: "đại từ",
    meaning:
      "từ dùng nói về người nào đó, không rõ (thường dùng để hỏi): ai gõ cửa đấy? * xin lỗi, anh là ai? * linh cảm có ai đang nhìn mình",
    example:
      "ai gõ cửa đấy? * xin lỗi, anh là ai? * linh cảm có ai đang nhìn mình",
  },
  {
    word: "ai",
    part_of_speech: "đại từ",
    meaning:
      'từ dùng chỉ người nào đó, bất kì: ai cũng được * tất cả, không trừ một ai * "Đố ai quét sạch lá rừng, Để ta khuyên gió, gió đừng rung cây." (ca dao)',
    example:
      'ai cũng được * tất cả, không trừ một ai * "Đố ai quét sạch lá rừng, Để ta khuyên gió, gió đừng rung cây." (ca dao)',
  },
  {
    word: "ai",
    part_of_speech: "đại từ",
    meaning:
      'từ dùng nói về người nào đó, có khi là chính mình, mà không muốn nêu rõ ra: ai biết đâu đấy! * "Cạn lòng chẳng biết nghĩ sâu, Để ai trăng tủi hoa sầu vì ai?" (TKiều)',
    example:
      'ai biết đâu đấy! * "Cạn lòng chẳng biết nghĩ sâu, Để ai trăng tủi hoa sầu vì ai?" (TKiều)',
  },
  {
    word: "ai đời",
    part_of_speech: "",
    meaning:
      '(khẩu ngữ) tổ hợp biểu thị ý nhấn mạnh về điều cho là trái với lẽ thường: "Ai đời chuột lại dám đánh đu ở miệng mèo!" (THoài; 31)',
    example: 'Ai đời chuột lại dám đánh đu ở miệng mèo!" (THoài; 31)',
  },
  {
    word: "ải",
    part_of_speech: "danh từ",
    meaning:
      "nơi hiểm trở ở biên giới hoặc trên đường tiến vào một nước: ải Chi Lăng",
    example: "ải Chi Lăng",
  },
  {
    word: "ải",
    part_of_speech: "danh từ",
    meaning:
      "bước thử thách hoặc trở ngại lớn cần phải vượt qua: phải qua biết bao nhiêu ải mới xin được chữ kí",
    example: "phải qua biết bao nhiêu ải mới xin được chữ kí",
  },
  {
    word: "ải",
    part_of_speech: "tính từ",
    meaning:
      "dễ gãy nát, không còn bền chắc do chịu tác động lâu ngày của mưa nắng: lạt đã ải",
    example: "lạt đã ải",
  },
  {
    word: "ải",
    part_of_speech: "tính từ",
    meaning:
      "(đất trồng trọt sau khi đã cày cuốc và phơi nắng) khô và dễ tơi nát: đất đã ải trắng",
    example: "đất đã ải trắng",
  },
  {
    word: "ải",
    part_of_speech: "động từ",
    meaning: "làm ải (nói tắt); phân biệt với dầm: chuyển ải sang dầm",
    example: "chuyển ải sang dầm",
  },
  {
    word: "ai mượn",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ, hiếm) tổ hợp dùng để quy lỗi nhẹ nhàng cho người nào đó, trách người ấy đã làm việc lẽ ra không nên làm để xảy ra điều ít nhiều không hay: ai mượn mày xía vào chuyện của người ta?",
    example: "ai mượn mày xía vào chuyện của người ta?",
  },
  {
    word: "ai khảo mà xưng",
    part_of_speech: "",
    meaning:
      'tự nói ra điều (thường là bí mật, thầm kín) mà không ai tra hỏi: "Nghĩ đà bưng kín miệng bình, Nào ai có khảo mà mình lại xưng?" (TKiều)',
    example:
      'Nghĩ đà bưng kín miệng bình, Nào ai có khảo mà mình lại xưng?" (TKiều)',
  },
  {
    word: "ai hoài",
    part_of_speech: "động từ",
    meaning:
      '(cũ, văn chương) buồn thương và nhớ da diết: "Cớ sao chàng chẳng vãng lai, Để em thổn thức ai hoài trót đêm." (ca dao)',
    example:
      'Cớ sao chàng chẳng vãng lai, Để em thổn thức ai hoài trót đêm." (ca dao)',
  },
  {
    word: "ai ngờ",
    part_of_speech: "",
    meaning:
      'nào ai có ngờ, chẳng ngờ: tưởng nói vui, ai ngờ là sự thật * "Ngỡ là phu quý, phụ vinh, Ai ngờ một phút tan tành thịt xương!" (TKiều)',
    example:
      'tưởng nói vui, ai ngờ là sự thật * "Ngỡ là phu quý, phụ vinh, Ai ngờ một phút tan tành thịt xương!" (TKiều)',
  },
  {
    word: "ai oán",
    part_of_speech: "tính từ",
    meaning:
      "(văn chương) bi thương và oán hận (thường nói về âm thanh, tiếng đàn, tiếng hát, v.v. của người có điều oan ức): tiếng đàn ai oán * lời ca ai oán",
    example: "tiếng đàn ai oán * lời ca ai oán",
  },
  {
    word: "ái mộ",
    part_of_speech: "động từ",
    meaning: "(cũ) mến chuộng và kính trọng: diễn viên được nhiều người ái mộ",
    example: "diễn viên được nhiều người ái mộ",
  },
  {
    word: "ái ngại",
    part_of_speech: "động từ",
    meaning:
      "không yên lòng, vì lo ngại, thương cảm (trước tình cảnh của người khác): ái ngại cho hoàn cảnh của bạn",
    example: "ái ngại cho hoàn cảnh của bạn",
  },
  {
    word: "ai lại",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị điều sắp nêu ra là hành vi, thái độ không bình thường đến mức vô lí: ai lại làm trò trẻ con như thế?",
    example: "ai lại làm trò trẻ con như thế?",
  },
  {
    word: "ai nấy",
    part_of_speech: "đại từ",
    meaning:
      "người nào cũng vậy, không trừ một ai: được mùa, ai nấy đều phấn khởi",
    example: "được mùa, ai nấy đều phấn khởi",
  },
  {
    word: "ái nữ",
    part_of_speech: "danh từ",
    meaning:
      "(trang trọng) từ dùng để gọi tôn con gái của người có địa vị cao: ái nữ của ngài tổng thống",
    example: "ái nữ của ngài tổng thống",
  },
  {
    word: "album",
    part_of_speech: "danh từ",
    meaning:
      "tập giấy cứng hoặc nylon được đóng thành quyển, để lưu giữ ảnh, tem, v.v.: tập album * album ảnh",
    example: "tập album * album ảnh",
  },
  {
    word: "album",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp những tác phẩm (thường là bản nhạc, bài hát) xuất bản ở dạng đĩa hoặc băng từ: phát hành album nhạc mới",
    example: "phát hành album nhạc mới",
  },
  {
    word: "ái tình",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương) tình yêu nam nữ: chuyện ái tình * sức mạnh của ái tình",
    example: "chuyện ái tình * sức mạnh của ái tình",
  },
  {
    word: "ái quốc",
    part_of_speech: "động từ",
    meaning: "(cũ) yêu nước: lòng ái quốc",
    example: "lòng ái quốc",
  },
  {
    word: "ái quần",
    part_of_speech: "động từ",
    meaning: "(cũ) yêu đồng loại, yêu đồng bào: tinh thần ái quốc ái quần",
    example: "tinh thần ái quốc ái quần",
  },
  {
    word: "ám ảnh",
    part_of_speech: "động từ",
    meaning:
      "(điều không hay) luôn luôn lởn vởn trong trí, làm phải băn khoăn hoặc lo lắng mà không sao xua đi được: câu hỏi cứ ám ảnh trong đầu * bị ám ảnh bởi những kí ức đau thương",
    example:
      "câu hỏi cứ ám ảnh trong đầu * bị ám ảnh bởi những kí ức đau thương",
  },
  {
    word: "ám hại",
    part_of_speech: "động từ",
    meaning: "hại người một cách ám muội: bị kẻ xấu ám hại",
    example: "bị kẻ xấu ám hại",
  },
  {
    word: "am hiểu",
    part_of_speech: "động từ",
    meaning:
      "hiểu biết rõ đến từng chi tiết: am hiểu thị trường * rất am hiểu về hội hoạ",
    example: "am hiểu thị trường * rất am hiểu về hội hoạ",
  },
  {
    word: "ảm đạm",
    part_of_speech: "tính từ",
    meaning:
      "(khung cảnh buổi chiều) thiếu ánh sáng mặt trời và toàn một màu xám, gợi sự buồn tẻ: trời đông ảm đạm",
    example: "trời đông ảm đạm",
  },
  {
    word: "ảm đạm",
    part_of_speech: "tính từ",
    meaning:
      "không sáng sủa, gợi cảm giác buồn: nét mặt ảm đạm * tiền đồ ảm đạm (b)",
    example: "nét mặt ảm đạm * tiền đồ ảm đạm (b)",
  },
  {
    word: "ám hiệu",
    part_of_speech: "danh từ",
    meaning:
      "tín hiệu để ngầm liên lạc với nhau: nháy đèn pin làm ám hiệu * ra ám hiệu rút lui",
    example: "nháy đèn pin làm ám hiệu * ra ám hiệu rút lui",
  },
  {
    word: "ám hiệu",
    part_of_speech: "động từ",
    meaning: "(hiếm) ngầm ra hiệu: ám hiệu cho nhau biết",
    example: "ám hiệu cho nhau biết",
  },
  {
    word: "ám",
    part_of_speech: "danh từ",
    meaning:
      "món ăn nấu nguyên cả con cá hoặc khúc cá to đã được rán vàng với gạo, nhiều nước và các thứ rau thơm: nấu món ám * cháo ám",
    example: "nấu món ám * cháo ám",
  },
  {
    word: "ám",
    part_of_speech: "động từ",
    meaning:
      "bám chặt vào làm cho bẩn, cho thành màu tối: trần nhà ám khói * quần áo ám đầy bụi đất",
    example: "trần nhà ám khói * quần áo ám đầy bụi đất",
  },
  {
    word: "ám",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) quấy rầy bên cạnh, làm ảnh hưởng đến việc đang làm: vẩn vơ như bị ma ám * ngồi ám bên cạnh",
    example: "vẩn vơ như bị ma ám * ngồi ám bên cạnh",
  },
  {
    word: "ám chỉ",
    part_of_speech: "động từ",
    meaning:
      "(nói một điều xấu) ngầm chỉ người nào, việc gì: nói vu vơ, không ám chỉ ai",
    example: "nói vu vơ, không ám chỉ ai",
  },
  {
    word: "ám muội",
    part_of_speech: "tính từ",
    meaning:
      "(việc làm) không rõ ràng, có điều gì đó không chính đáng, phải giấu kín: hành động ám muội * không làm điều gì ám muội",
    example: "hành động ám muội * không làm điều gì ám muội",
  },
  {
    word: "ám quẻ",
    part_of_speech: "động từ",
    meaning: "(ma quỷ) cản trở, quấy rầy việc gieo quẻ bói, theo mê tín.",
    example: "đã không giúp lại còn đến ám quẻ",
  },
  {
    word: "am tường",
    part_of_speech: "động từ",
    meaning: "hiểu biết tường tận: am tường luật lệ * am tường về lịch sử",
    example: "am tường luật lệ * am tường về lịch sử",
  },
  {
    word: "ám thị",
    part_of_speech: "động từ",
    meaning:
      "(dùng lời nói, và/hoặc ánh mắt, cử chỉ) tác động đến tâm lí, làm cho thụ động nghĩ theo hoặc làm theo ý của mình: ám thị bằng thôi miên * tự kỉ ám thị",
    example: "ám thị bằng thôi miên * tự kỉ ám thị",
  },
  {
    word: "ám sát",
    part_of_speech: "động từ",
    meaning:
      "giết người (thường là nhân vật quan trọng) một cách bí mật, có mưu tính trước: âm mưu ám sát * bị ám sát hụt",
    example: "âm mưu ám sát * bị ám sát hụt",
  },
  {
    word: "amygdala",
    part_of_speech: "danh từ",
    meaning:
      "mô bạch huyết ở họng người, tròn và to bằng đầu ngón tay: sưng amygdala * cắt amygdala",
    example: "sưng amygdala * cắt amygdala",
  },
  {
    word: "án",
    part_of_speech: "danh từ",
    meaning:
      "vụ phạm pháp hoặc tranh chấp quyền lợi cần được xét xử trước toà án: vụ án chưa xử * án giết người",
    example: "vụ án chưa xử * án giết người",
  },
  {
    word: "án",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) bản án (nói tắt): nhận án tử hình * làm đơn xin giảm án",
    example: "nhận án tử hình * làm đơn xin giảm án",
  },
  {
    word: "án",
    part_of_speech: "động từ",
    meaning: "chắn ngang, làm ngăn lại: núi án trước mặt * đứng án ở cửa",
    example: "núi án trước mặt * đứng án ở cửa",
  },
  {
    word: "án",
    part_of_speech: "động từ",
    meaning: "đóng quân lại một chỗ: án quân nằm chờ chi viện",
    example: "án quân nằm chờ chi viện",
  },
  {
    word: "an bài",
    part_of_speech: "động từ",
    meaning:
      "(tạo hoá) xếp đặt từ trước (theo quan niệm của thuyết định mệnh): số phận đã được an bài",
    example: "số phận đã được an bài",
  },
  {
    word: "an",
    part_of_speech: "tính từ",
    meaning: "(Từ cũ) yên ổn: biến nguy thành an * lòng không được an",
    example: "biến nguy thành an * lòng không được an",
  },
  {
    word: "an cư",
    part_of_speech: "động từ",
    meaning: "sinh sống yên ổn: có an cư thì mới lạc nghiệp",
    example: "có an cư thì mới lạc nghiệp",
  },
  {
    word: "án binh bất động",
    part_of_speech: "",
    meaning: "đóng quân ở yên, tạm thời không hành động, chờ thời cơ.",
    example: "bọn buôn lậu án binh bất động chờ thời cơ",
  },
  {
    word: "an dưỡng",
    part_of_speech: "động từ",
    meaning:
      "nghỉ ngơi và ăn uống theo một chế độ nhất định để bồi dưỡng sức khoẻ: trại an dưỡng * đi an dưỡng",
    example: "trại an dưỡng * đi an dưỡng",
  },
  {
    word: "an hưởng",
    part_of_speech: "động từ",
    meaning: "hưởng trong sự yên vui: an hưởng tuổi già",
    example: "an hưởng tuổi già",
  },
  {
    word: "an khang",
    part_of_speech: "tính từ",
    meaning: "bình yên và mạnh khoẻ: kính chúc gia đình an khang, thịnh vượng",
    example: "kính chúc gia đình an khang, thịnh vượng",
  },
  {
    word: "án mạng",
    part_of_speech: "danh từ",
    meaning: "vụ phạm tội làm chết người: đánh nhau để xảy ra án mạng",
    example: "đánh nhau để xảy ra án mạng",
  },
  {
    word: "an giấc ngàn thu",
    part_of_speech: "",
    meaning:
      "(cũ, vch, trang trọng) chết (ví như một giấc ngủ dài mãi mãi): ông cụ đã yên giấc nghìn thu",
    example: "ông cụ đã yên giấc nghìn thu",
  },
  {
    word: "án ngữ",
    part_of_speech: "động từ",
    meaning:
      "chắn lối qua lại, lối ra vào (một khu vực): dãy núi án ngữ trước mặt",
    example: "dãy núi án ngữ trước mặt",
  },
  {
    word: "an nghỉ",
    part_of_speech: "động từ",
    meaning: "như yên nghỉ: đưa đến nơi an nghỉ cuối cùng",
    example: "đưa đến nơi an nghỉ cuối cùng",
  },
  {
    word: "an giấc nghìn thu",
    part_of_speech: "",
    meaning:
      "(cũ, vch, trang trọng) chết (ví như một giấc ngủ dài mãi mãi): ông cụ đã yên giấc nghìn thu",
    example: "ông cụ đã yên giấc nghìn thu",
  },
  {
    word: "an nhàn",
    part_of_speech: "tính từ",
    meaning:
      "thảnh thơi và được yên ổn, không phải vất vả, khó nhọc: cuộc sống an nhàn",
    example: "cuộc sống an nhàn",
  },
  {
    word: "an nhiên",
    part_of_speech: "tính từ",
    meaning: "yên ổn, bình thản như tự nhiên vốn thế: thái độ an nhiên tự tại",
    example: "thái độ an nhiên tự tại",
  },
  {
    word: "an ninh",
    part_of_speech: "danh từ",
    meaning:
      "tình hình trật tự xã hội bình thường, yên ổn, không có rối loạn: an ninh được đảm bảo * giữ gìn an ninh, trật tự",
    example: "an ninh được đảm bảo * giữ gìn an ninh, trật tự",
  },
  {
    word: "an ninh",
    part_of_speech: "tính từ",
    meaning:
      "yên ổn về mặt trật tự xã hội, không có rối loạn: mất an ninh * lực lượng an ninh",
    example: "mất an ninh * lực lượng an ninh",
  },
  {
    word: "an phận",
    part_of_speech: "động từ",
    meaning:
      "yên với phận của mình và cảnh sống hiện tại, không phấn đấu để có được một sự thay đổi: sống an phận * không chịu an phận",
    example: "sống an phận * không chịu an phận",
  },
  {
    word: "an táng",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) xử lí thi thể người chết (bằng cách chôn cất, hoặc hoả táng, thiên táng, v.v.) theo nghi lễ: lễ an táng * an táng tại quê nhà",
    example: "lễ an táng * an táng tại quê nhà",
  },
  {
    word: "an thai",
    part_of_speech: "động từ",
    meaning: "giữ cho thai phát triển bình thường: thuốc an thai",
    example: "thuốc an thai",
  },
  {
    word: "an sinh",
    part_of_speech: "tính từ",
    meaning: "an toàn cuộc sống: vấn đề an sinh xã hội",
    example: "vấn đề an sinh xã hội",
  },
  {
    word: "an thân",
    part_of_speech: "động từ",
    meaning:
      '(cũ) nương thân: "Những mừng được chốn an thân, Vội vàng nào kịp tính gần, tính xa." (TKiều)',
    example:
      'Những mừng được chốn an thân, Vội vàng nào kịp tính gần, tính xa." (TKiều)',
  },
  {
    word: "an thân",
    part_of_speech: "động từ",
    meaning: "như yên thân: chỉ muốn được an thân",
    example: "chỉ muốn được an thân",
  },
  {
    word: "an thần",
    part_of_speech: "động từ",
    meaning:
      "làm êm dịu thần kinh (đang căng thẳng), thường để cho dễ ngủ: thuốc an thần",
    example: "thuốc an thần",
  },
  {
    word: "an toạ",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) (những người tham gia hội họp) ngồi vào chỗ, ổn định chỗ ngồi: sắp đến giờ khai mạc, xin mời các vị an toạ",
    example: "sắp đến giờ khai mạc, xin mời các vị an toạ",
  },
  {
    word: "an toàn",
    part_of_speech: "tính từ",
    meaning:
      "yên ổn, loại trừ nguy hiểm, hoặc tránh được sự cố: cầu đã được sửa, đi lại rất an toàn * van an toàn",
    example: "cầu đã được sửa, đi lại rất an toàn * van an toàn",
  },
  {
    word: "an toàn",
    part_of_speech: "danh từ",
    meaning:
      "điều kiện bảo đảm để không xảy ra sự cố hay nguy hiểm, nói chung: an toàn giao thông",
    example: "an toàn giao thông",
  },
  {
    word: "an ủi",
    part_of_speech: "động từ",
    meaning:
      "làm cho (người đang có điều đau buồn) dịu bớt nỗi đau khổ, buồn phiền, thường bằng lời khuyên giải: lựa lời an ủi bạn * tự an ủi",
    example: "lựa lời an ủi bạn * tự an ủi",
  },
  {
    word: "án treo",
    part_of_speech: "danh từ",
    meaning:
      "án tù chỉ thi hành nếu trong thời gian quy định người bị kết án lại phạm tội và bị xử kết án lần nữa: được hưởng án treo",
    example: "được hưởng án treo",
  },
  {
    word: "an-bom",
    part_of_speech: "danh từ",
    meaning:
      "tập giấy cứng hoặc nylon được đóng thành quyển, để lưu giữ ảnh, tem, v.v.: tập album * album ảnh",
    example: "tập album * album ảnh",
  },
  {
    word: "an-bom",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp những tác phẩm (thường là bản nhạc, bài hát) xuất bản ở dạng đĩa hoặc băng từ: phát hành album nhạc mới",
    example: "phát hành album nhạc mới",
  },
  {
    word: "an-bum",
    part_of_speech: "danh từ",
    meaning:
      "tập giấy cứng hoặc nylon được đóng thành quyển, để lưu giữ ảnh, tem, v.v.: tập album * album ảnh",
    example: "tập album * album ảnh",
  },
  {
    word: "an-bum",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp những tác phẩm (thường là bản nhạc, bài hát) xuất bản ở dạng đĩa hoặc băng từ: phát hành album nhạc mới",
    example: "phát hành album nhạc mới",
  },
  {
    word: "ang",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng đựng nước thời trước, làm bằng đất nung, thành hơi phình, miệng rộng: ang đựng nước",
    example: "ang đựng nước",
  },
  {
    word: "ang",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ đong lường thời trước, được làm bằng gỗ hoặc đan bằng tre, hình hộp, dung tích khoảng bảy tám lít, dùng ở một số địa phương để đong chất hạt rời: một ang gạo",
    example: "một ang gạo",
  },
  {
    word: "ang áng",
    part_of_speech: "động từ",
    meaning: "ước lượng một cách đại khái: tính ang áng",
    example: "tính ang áng",
  },
  {
    word: "áng",
    part_of_speech: "danh từ",
    meaning:
      '(Văn chương) từ dùng để chỉ từng đơn vị thuộc loại sự vật được coi là có vẻ đẹp rực rỡ: một áng văn kiệt tác * "Lòng còn gửi áng mây vàng, Hoạ vần, xin hãy chịu chàng hôm nay." (TKiều)',
    example:
      'một áng văn kiệt tác * "Lòng còn gửi áng mây vàng, Hoạ vần, xin hãy chịu chàng hôm nay." (TKiều)',
  },
  {
    word: "áng",
    part_of_speech: "động từ",
    meaning:
      "(Ít dùng) ước lượng, đoán định trên đại thể, không chính xác: cụ già áng ngoài tám mươi tuổi * áng theo đó mà làm",
    example: "cụ già áng ngoài tám mươi tuổi * áng theo đó mà làm",
  },
  {
    word: "anh",
    part_of_speech: "danh từ",
    meaning:
      "người con trai cùng một thế hệ trong gia đình, trong họ, nhưng thuộc hàng trên (sinh trước, là con nhà bác, v.v.; có thể dùng để xưng gọi): anh ruột * anh vợ * người anh con bác * chú lại đây anh bảo!",
    example: "anh ruột * anh vợ * người anh con bác * chú lại đây anh bảo!",
  },
  {
    word: "anh",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ hoặc gọi người đàn ông còn trẻ, hoặc người đàn ông cùng tuổi hoặc vai anh mình: anh thanh niên * anh giải phóng quân",
    example: "anh thanh niên * anh giải phóng quân",
  },
  {
    word: "anh",
    part_of_speech: "danh từ",
    meaning:
      'từ phụ nữ dùng để gọi chồng, người yêu hoặc người đàn ông dùng để tự xưng khi nói với vợ, người yêu: "Chồng gì anh, vợ gì tôi, Chẳng qua là cái nợ đời chi đây!" (Cdao)',
    example:
      'Chồng gì anh, vợ gì tôi, Chẳng qua là cái nợ đời chi đây!" (Cdao)',
  },
  {
    word: "áng chừng",
    part_of_speech: "động từ",
    meaning:
      "ước lượng trên đại thể, không tính con số chính xác: cuốn sách áng chừng khoảng 500 trang",
    example: "cuốn sách áng chừng khoảng 500 trang",
  },
  {
    word: "anh ánh",
    part_of_speech: "tính từ",
    meaning: "hơi ánh lên: mái tóc đen anh ánh",
    example: "mái tóc đen anh ánh",
  },
  {
    word: "anh dũng",
    part_of_speech: "tính từ",
    meaning: "dũng cảm quên mình: hi sinh anh dũng",
    example: "hi sinh anh dũng",
  },
  {
    word: "ảnh",
    part_of_speech: "danh từ",
    meaning:
      "hình người, vật, phong cảnh thu được bằng khí cụ quang học (như máy ảnh, camera, v.v.): chụp ảnh * kĩ thuật xử lí ảnh",
    example: "chụp ảnh * kĩ thuật xử lí ảnh",
  },
  {
    word: "ảnh",
    part_of_speech: "danh từ",
    meaning:
      "hình của vật thu được hoặc nhìn thấy qua một hệ quang học như gương, thấu kính, v.v.: ảnh ảo * ảnh thật",
    example: "ảnh ảo * ảnh thật",
  },
  {
    word: "ảnh",
    part_of_speech: "đại từ",
    meaning:
      "(Nam, khẩu ngữ) anh ấy: Dạo này chị có gặp ảnh không? Xem thêm bả, ổng, chỉ",
    example: "Dạo này chị có gặp ảnh không?",
  },
  {
    word: "anh chị em",
    part_of_speech: "danh từ",
    meaning:
      "những người còn trẻ, gồm cả nam lẫn nữ, có quan hệ ruột thịt hoặc gần gũi như ruột thịt (nói tổng quát): nhà có ba anh chị em * anh chị em trong cơ quan",
    example: "nhà có ba anh chị em * anh chị em trong cơ quan",
  },
  {
    word: "ánh",
    part_of_speech: "danh từ",
    meaning:
      'những tia sáng do một vật phát ra hoặc phản chiếu lại (nói tổng quát): ánh nắng * ánh đuốc * ánh mắt * "Hỡi cô tát nước bên đàng, Sao cô múc ánh trăng vàng đổ đi?" (ca dao)',
    example:
      'ánh nắng * ánh đuốc * ánh mắt * "Hỡi cô tát nước bên đàng, Sao cô múc ánh trăng vàng đổ đi?" (ca dao)',
  },
  {
    word: "ánh",
    part_of_speech: "danh từ",
    meaning: "mảng ánh sáng có màu sắc: có ánh xanh của lá cây * pha ánh hồng",
    example: "có ánh xanh của lá cây * pha ánh hồng",
  },
  {
    word: "ánh",
    part_of_speech: "tính từ",
    meaning:
      'có nhiều tia sáng phản chiếu lóng lánh: mái tóc đen ánh * "Mặt trời chiều ánh lên phía sau như lát vàng (...)" (LVThảo; 8)',
    example:
      'mái tóc đen ánh * "Mặt trời chiều ánh lên phía sau như lát vàng (...)" (LVThảo; 8)',
  },
  {
    word: "anh ách",
    part_of_speech: "tính từ",
    meaning:
      "như ách (nhưng mức độ nhiều hơn): no anh ách * nói chuyện với nó cứ tức anh ách",
    example: "no anh ách * nói chuyện với nó cứ tức anh ách",
  },
  {
    word: "anh chị",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) đàn anh sừng sỏ trong bọn lưu manh: dân anh chị * một tay anh chị",
    example: "dân anh chị * một tay anh chị",
  },
  {
    word: "anh chàng",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) người trai trẻ (hàm ý coi thường hoặc bông đùa): một anh chàng vui tính",
    example: "một anh chàng vui tính",
  },
  {
    word: "anh em",
    part_of_speech: "danh từ",
    meaning:
      "những người cùng một thế hệ có quan hệ ruột thịt hoặc họ hàng với nhau (nói khái quát): nhà có hai anh em",
    example: "nhà có hai anh em",
  },
  {
    word: "anh em",
    part_of_speech: "danh từ",
    meaning:
      "những người có quan hệ gần gũi, thân thiết, coi nhau như người thân trong nhà (nói khái quát): anh em bạn bè * các dân tộc anh em",
    example: "anh em bạn bè * các dân tộc anh em",
  },
  {
    word: "anh hào",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) anh hùng, hào kiệt (nói chung): "Đường đường một đấng anh hào, Côn quyền hơn sức, lược thao gồm tài." (TKiều)',
    example:
      'Đường đường một đấng anh hào, Côn quyền hơn sức, lược thao gồm tài." (TKiều)',
  },
  {
    word: "anh hoa",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) cái đẹp đẽ, tốt đẹp; cái tinh hoa (của một con người): "Anh hoa phát tiết ra ngoài, Nghìn thu bạc mệnh một đời tài hoa." (TKiều)',
    example:
      'Anh hoa phát tiết ra ngoài, Nghìn thu bạc mệnh một đời tài hoa." (TKiều)',
  },
  {
    word: "anh hùng ca",
    part_of_speech: "danh từ",
    meaning:
      "trường ca hoặc tiểu thuyết phản ánh những sự kiện lịch sử có ý nghĩa trọng đại hoặc lấy những truyền thuyết cổ đại làm nội dung, xây dựng những hình tượng anh hùng, mang nhiều sắc thái ảo tưởng và thần thoại: anh hùng ca Đam San của dân tộc Ê Đê",
    example: "anh hùng ca Đam San của dân tộc Ê Đê",
  },
  {
    word: "anh hùng",
    part_of_speech: "danh từ",
    meaning:
      "nhân vật thần thoại có sức mạnh và dũng khí phi thường, lập nên những kì tích đặc biệt (thường có trong truyện thần thoại Hi Lạp).",
    example: "vị anh hùng dân tộc",
  },
  {
    word: "anh hùng",
    part_of_speech: "danh từ",
    meaning:
      "người có tài năng và dũng khí hơn hẳn người thường, làm nên những việc được người đời ca tụng: vị anh hùng dân tộc",
    example: "anh hùng lực lượng vũ trang nhân dân * anh hùng lao động",
  },
  {
    word: "anh hùng",
    part_of_speech: "tính từ",
    meaning: "đặc biệt anh dũng: một dân tộc anh hùng",
    example: "một dân tộc anh hùng",
  },
  {
    word: "anh hùng chủ nghĩa",
    part_of_speech: "tính từ",
    meaning:
      "ít nhiều có tính chất anh hùng, nhưng phiêu lưu, mạo hiểm: mang nặng tư tưởng anh hùng chủ nghĩa",
    example: "mang nặng tư tưởng anh hùng chủ nghĩa",
  },
  {
    word: "anh kiệt",
    part_of_speech: "danh từ",
    meaning: "(cũ, văn chương) như anh hào: bậc anh kiệt",
    example: "bậc anh kiệt",
  },
  {
    word: "anh hùng rơm",
    part_of_speech: "danh từ",
    meaning:
      'kẻ huênh hoang cố làm ra vẻ có khí phách, nhưng thực chất lại là hèn nhát: "Anh hùng gì anh hùng rơm, Ta cho mớ lửa hết cơn anh hùng." (ca dao)',
    example:
      'Anh hùng gì anh hùng rơm, Ta cho mớ lửa hết cơn anh hùng." (ca dao)',
  },
  {
    word: "anh hùng rơm",
    part_of_speech: "tính từ",
    meaning:
      'có những lời lẽ khoe khoang làm ra vẻ có khí phách, nhưng thực chất lại là hèn nhát: "Rõ khéo! Chỉ anh hùng rơm! Nói thì một tấc đến giời mà chẳng dám kiện ai." (MPTư; 1)',
    example:
      'Rõ khéo! Chỉ anh hùng rơm! Nói thì một tấc đến giời mà chẳng dám kiện ai." (MPTư; 1)',
  },
  {
    word: "anh linh",
    part_of_speech: "danh từ",
    meaning:
      "linh hồn của người được tôn vinh: nghiêng mình trước anh linh các liệt sĩ",
    example: "nghiêng mình trước anh linh các liệt sĩ",
  },
  {
    word: "anh linh",
    part_of_speech: "tính từ",
    meaning:
      '(trang trọng) như linh thiêng: "Sống trung liệt, thác anh linh, Suối vàng thơm phách, mây xanh thoả hồn." (NĐM)',
    example:
      'Sống trung liệt, thác anh linh, Suối vàng thơm phách, mây xanh thoả hồn." (NĐM)',
  },
  {
    word: "ảnh hưởng",
    part_of_speech: "danh từ",
    meaning:
      "tác động (từ người, sự việc hoặc hiện tượng) có thể làm dần dần có những biến đổi nhất định trong tư tưởng, hành vi, hoặc trong quá trình phát triển ở sự vật hoặc người nào đó: ảnh hưởng của phim ảnh đối với trẻ em * gây ảnh hưởng xấu",
    example: "ảnh hưởng của phim ảnh đối với trẻ em * gây ảnh hưởng xấu",
  },
  {
    word: "ảnh hưởng",
    part_of_speech: "động từ",
    meaning:
      "có ảnh hưởng đến (ai/việc gì): nói chuyện làm ảnh hưởng đến người khác * chuyện đó không ảnh hưởng gì đến tôi",
    example:
      "nói chuyện làm ảnh hưởng đến người khác * chuyện đó không ảnh hưởng gì đến tôi",
  },
  {
    word: "ánh ỏi",
    part_of_speech: "tính từ",
    meaning:
      "(tiếng, giọng) ngân vang và hơi chói tai: tiếng chim hót ánh ỏi * ve kêu ánh ỏi",
    example: "tiếng chim hót ánh ỏi * ve kêu ánh ỏi",
  },
  {
    word: "anh minh",
    part_of_speech: "tính từ",
    meaning: "(cũ) (người lãnh đạo) tài giỏi và sáng suốt: vị vua anh minh",
    example: "vị vua anh minh",
  },
  {
    word: "anh trai",
    part_of_speech: "danh từ",
    meaning: "anh ruột, phân biệt với anh họ, anh rể: nhà có hai anh trai",
    example: "nhà có hai anh trai",
  },
  {
    word: "anh tài",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) người có tài năng và trí tuệ xuất chúng: "Thề không dung kẻ quyền gian, Vì dân trừ hại mới nên anh tài." (NĐM)',
    example:
      'Thề không dung kẻ quyền gian, Vì dân trừ hại mới nên anh tài." (NĐM)',
  },
  {
    word: "anh yến",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) như yến anh: "Muôn nghìn người thấy cũng yêu, Xôn xao anh yến, dập dìu trúc mai." (TKiều)',
    example:
      'Muôn nghìn người thấy cũng yêu, Xôn xao anh yến, dập dìu trúc mai." (TKiều)',
  },
  {
    word: "anh tuấn",
    part_of_speech: "tính từ",
    meaning:
      "(cũ, văn chương) (người đàn ông trẻ) có tướng mạo đẹp và tài giỏi hơn người: một thiếu niên anh tuấn",
    example: "một thiếu niên anh tuấn",
  },
  {
    word: "anh thư",
    part_of_speech: "danh từ",
    meaning: "(cũ, văn chương) người phụ nữ anh hùng: tỏ mặt anh thư",
    example: "tỏ mặt anh thư",
  },
  {
    word: "anh túc",
    part_of_speech: "danh từ",
    meaning: "cây thuốc phiện: hoa anh túc",
    example: "hoa anh túc",
  },
  {
    word: "ánh sáng",
    part_of_speech: "danh từ",
    meaning:
      "dạng vật chất do vật phát ra hoặc phản chiếu trên vật, nhờ nó mắt có thể cảm thụ mà nhìn thấy vật ấy: ánh sáng mặt trời * ngôi nhà ẩm thấp, thiếu ánh sáng",
    example: "ánh sáng mặt trời * ngôi nhà ẩm thấp, thiếu ánh sáng",
  },
  {
    word: "ánh sáng",
    part_of_speech: "danh từ",
    meaning:
      "sự soi sáng, sự hướng dẫn: ánh sáng của khoa học * vụ việc đã được đưa ra ánh sáng (nêu ra công khai)",
    example:
      "ánh sáng của khoa học * vụ việc đã được đưa ra ánh sáng (nêu ra công khai)",
  },
  {
    word: "anten",
    part_of_speech: "danh từ",
    meaning: "thiết bị trực tiếp thu hay phát sóng radio: cần anten vô tuyến",
    example: "cần anten vô tuyến",
  },
  {
    word: "ảo ảnh",
    part_of_speech: "danh từ",
    meaning:
      "hình ảnh giống như thật, nhưng không có thật: ảo ảnh quyền lực * chạy theo ảo ảnh",
    example: "ảo ảnh quyền lực * chạy theo ảo ảnh",
  },
  {
    word: "áo",
    part_of_speech: "danh từ",
    meaning:
      "đồ mặc từ cổ trở xuống, chủ yếu che lưng, ngực và bụng: tà áo * vạch áo cho người xem lưng (tng)",
    example: "tà áo * vạch áo cho người xem lưng (tng)",
  },
  {
    word: "áo",
    part_of_speech: "danh từ",
    meaning:
      "cái bọc bên ngoài một số đồ vật để che giữ: bánh gói thiếu lá áo * bóc lớp áo lụa của lạc",
    example: "bánh gói thiếu lá áo * bóc lớp áo lụa của lạc",
  },
  {
    word: "áo",
    part_of_speech: "danh từ",
    meaning:
      "lớp chất bột, chất đường bọc ngoài một số loại bánh kẹo hoặc thuốc viên: áo bánh gối * lớp đường làm áo",
    example: "áo bánh gối * lớp đường làm áo",
  },
  {
    word: "ào",
    part_of_speech: "động từ",
    meaning:
      'di chuyển đến với số lượng nhiều một cách rất nhanh và mạnh, không kể gì trở ngại: một cơn gió ào qua * bọn trẻ ào ra đường * "Mọi sự ào đến với Hạnh như một cơn lốc cuốn phăng mọi thứ." (DHướng; 1)',
    example:
      'một cơn gió ào qua * bọn trẻ ào ra đường * "Mọi sự ào đến với Hạnh như một cơn lốc cuốn phăng mọi thứ." (DHướng; 1)',
  },
  {
    word: "ào",
    part_of_speech: "phụ từ",
    meaning:
      "(làm việc gì) một cách nhanh và mạnh, không để ý đến những cái khác: lội ào xuống ruộng * ăn ào đi cho xong bữa",
    example: "lội ào xuống ruộng * ăn ào đi cho xong bữa",
  },
  {
    word: "ảo",
    part_of_speech: "tính từ",
    meaning: "giống như thật, nhưng không có thật: con số ảo",
    example: "con số ảo",
  },
  {
    word: "ào ạt",
    part_of_speech: "tính từ",
    meaning:
      '(di chuyển) nhanh, mạnh và dồn dập trên phạm vi lớn: tiến quân ào ạt * "Cũng có khi vô cớ, Biển ào ạt xô thuyền." (XQuỳnh; 8)',
    example:
      'tiến quân ào ạt * "Cũng có khi vô cớ, Biển ào ạt xô thuyền." (XQuỳnh; 8)',
  },
  {
    word: "ào ào",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng gió thổi mạnh, tiếng nước chảy xiết hay tiếng ồn ở chỗ đông người: gió thổi ào ào * ào ào như thác đổ",
    example: "gió thổi ào ào * ào ào như thác đổ",
  },
  {
    word: "áo ấm",
    part_of_speech: "danh từ",
    meaning:
      "áo mặc mùa đông cho ấm, nói chung: trời lạnh, phải mặc thêm áo ấm",
    example: "trời lạnh, phải mặc thêm áo ấm",
  },
  {
    word: "ao",
    part_of_speech: "danh từ",
    meaning:
      "chỗ đào sâu xuống đất, thường ở gần nhà, để giữ nước nuôi cá, thả bèo, trồng rau, v.v.: đào ao thả cá",
    example: "đào ao thả cá",
  },
  {
    word: "ao",
    part_of_speech: "động từ",
    meaning:
      '(hiếm) đong để ước lượng: ao thúng thóc * "Thói đời giọt nước làn mây, Đấu nào ao được vơi đầy mà tin." (HT)',
    example:
      'ao thúng thóc * "Thói đời giọt nước làn mây, Đấu nào ao được vơi đầy mà tin." (HT)',
  },
  {
    word: "ao chuôm",
    part_of_speech: "danh từ",
    meaning:
      "chỗ trũng có đọng nước, như ao, chuôm, v.v. (nói khái quát): trời mưa, ao chuôm đầy ắp nước",
    example: "trời mưa, ao chuôm đầy ắp nước",
  },
  {
    word: "ảo giác",
    part_of_speech: "danh từ",
    meaning:
      "tri giác không chính xác đối với sự vật khách quan do một nguyên nhân nào đó gây ra (như chiếc đũa đặt vào trong một bát nước, do có hiện tượng tia sáng khúc xạ nên thấy chiếc đũa như gãy gập): nhìn mặt trời thấy khi to khi nhỏ chỉ là ảo giác",
    example: "nhìn mặt trời thấy khi to khi nhỏ chỉ là ảo giác",
  },
  {
    word: "áo đầm",
    part_of_speech: "danh từ",
    meaning: "váy kiểu Âu, liền thân: áo đầm dạ hội",
    example: "áo đầm dạ hội",
  },
  {
    word: "áo cà sa",
    part_of_speech: "danh từ",
    meaning:
      'áo mặc ngoài của nhà sư (rất dài và rộng): "Áo xanh đổi lấy cà sa, Pháp danh lại đổi tên ra Trạc Tuyền." (TKiều)',
    example:
      'Áo xanh đổi lấy cà sa, Pháp danh lại đổi tên ra Trạc Tuyền." (TKiều)',
  },
  {
    word: "áo giáp",
    part_of_speech: "danh từ",
    meaning:
      "áo làm bằng chất liệu đặc biệt, có sức chống đỡ với binh khí hoặc nói chung với những vật gây tổn hại, nguy hiểm cho cơ thể: áo giáp sắt * mặc áo giáp ra trận",
    example: "áo giáp sắt * mặc áo giáp ra trận",
  },
  {
    word: "áo lá",
    part_of_speech: "danh từ",
    meaning:
      'áo che mưa không có tay, thường được làm bằng rơm hoặc lá cọ: "Trời mưa thì mặc trời mưa, Chồng tôi đi bừa đã có áo tơi." (ca dao)',
    example:
      'Trời mưa thì mặc trời mưa, Chồng tôi đi bừa đã có áo tơi." (ca dao)',
  },
  {
    word: "áo khăn",
    part_of_speech: "danh từ",
    meaning:
      'như khăn áo: "Một chàng vừa trạc thanh xuân, Hình dung chải chuốt, áo khăn dịu dàng." (TKiều)',
    example:
      'Một chàng vừa trạc thanh xuân, Hình dung chải chuốt, áo khăn dịu dàng." (TKiều)',
  },
  {
    word: "ảo huyền",
    part_of_speech: "tính từ",
    meaning:
      "(văn chương) như huyền ảo: đôi mắt đen ảo huyền * màu sắc ảo huyền",
    example: "đôi mắt đen ảo huyền * màu sắc ảo huyền",
  },
  {
    word: "ảo mộng",
    part_of_speech: "danh từ",
    meaning:
      '(văn chương) giấc mơ thấy những điều huyền ảo; thường dùng để ví cuộc đời với những cái thực mà như hư, cuối cùng chẳng có gì tồn tại, theo quan điểm yếm thế: "Cảnh cơ hàn nơi nước đọng bùn lầy, Thú xán lạn mơ hồ trong ảo mộng." (ThLữ; 2)',
    example:
      'Cảnh cơ hàn nơi nước đọng bùn lầy, Thú xán lạn mơ hồ trong ảo mộng." (ThLữ; 2)',
  },
  {
    word: "ảo mộng",
    part_of_speech: "danh từ",
    meaning: "điều mơ ước viển vông: nuôi ảo mộng * chạy theo ảo mộng",
    example: "nuôi ảo mộng * chạy theo ảo mộng",
  },
  {
    word: "ảo não",
    part_of_speech: "tính từ",
    meaning: "buồn thảm, não nuột: bộ mặt ảo não * thở dài ảo não",
    example: "bộ mặt ảo não * thở dài ảo não",
  },
  {
    word: "áo nước",
    part_of_speech: "danh từ",
    meaning:
      "hộp có chứa nước hoặc một chất lỏng làm nguội khác, lưu động tuần hoàn, bao quanh những bộ phận bị nung nóng nhiều của máy móc, thiết bị: áo nước của xi lanh",
    example: "áo nước của xi lanh",
  },
  {
    word: "áo rét",
    part_of_speech: "danh từ",
    meaning:
      'áo mặc để chống rét, giữ ấm cho cơ thể, nói chung: may sắm áo rét * "Dưới đèn giở thước xe tơ, Sửa sang áo rét đợi chờ thu qua." (TTK)',
    example:
      'may sắm áo rét * "Dưới đèn giở thước xe tơ, Sửa sang áo rét đợi chờ thu qua." (TTK)',
  },
  {
    word: "áo quan",
    part_of_speech: "danh từ",
    meaning: "hòm bằng gỗ để đựng xác người chết: cỗ áo quan",
    example: "cỗ áo quan",
  },
  {
    word: "ảo thuật",
    part_of_speech: "danh từ",
    meaning:
      "nghệ thuật dùng những động tác nhanh nhẹn, khéo léo hoặc sử dụng những vật liệu, thiết bị đặc biệt tạo ra ở người xem cảm giác thấy những sự biến hoá kì lạ không lường được: trò ảo thuật * nhà ảo thuật",
    example: "trò ảo thuật * nhà ảo thuật",
  },
  {
    word: "áo tế",
    part_of_speech: "danh từ",
    meaning:
      "áo dành cho người đứng tế, thường rất dài và rộng: rộng như áo tế",
    example: "rộng như áo tế",
  },
  {
    word: "áo tắm",
    part_of_speech: "danh từ",
    meaning: "đồ mặc để bơi hoặc tắm biển của phụ nữ: áo tắm hai mảnh",
    example: "áo tắm hai mảnh",
  },
  {
    word: "ảo tưởng",
    part_of_speech: "danh từ",
    meaning:
      "sự tưởng tượng (hướng về tương lai), dựa trên mong muốn, ước mơ, thoát li hiện thực: sống trong ảo tưởng * giấc mơ đầy ảo tưởng",
    example: "sống trong ảo tưởng * giấc mơ đầy ảo tưởng",
  },
  {
    word: "ảo tưởng",
    part_of_speech: "động từ",
    meaning:
      "có ý nghĩ viển vông, mơ hồ, thoát li hiện thực: ảo tưởng về một thế giới hoàn mĩ",
    example: "ảo tưởng về một thế giới hoàn mĩ",
  },
  {
    word: "áo tơi",
    part_of_speech: "danh từ",
    meaning:
      'áo che mưa không có tay, thường được làm bằng rơm hoặc lá cọ: "Trời mưa thì mặc trời mưa, Chồng tôi đi bừa đã có áo tơi." (ca dao)',
    example:
      'Trời mưa thì mặc trời mưa, Chồng tôi đi bừa đã có áo tơi." (ca dao)',
  },
  {
    word: "ao tù",
    part_of_speech: "danh từ",
    meaning:
      "ao đọng nước bẩn lâu ngày, không có chỗ chảy thoát: lấp các ao tù",
    example: "lấp các ao tù",
  },
  {
    word: "áo tứ thân",
    part_of_speech: "danh từ",
    meaning:
      'áo của phụ nữ miền Bắc thời trước, dài đến giữa ống chân, có bốn vạt, hai vạt trước rộng bằng nhau và thường buộc chéo vào nhau: "Mưa phùn ướt áo tứ thân, Mưa bao nhiêu hạt thương bầm bấy nhiêu." (THữu; 7)',
    example:
      'Mưa phùn ướt áo tứ thân, Mưa bao nhiêu hạt thương bầm bấy nhiêu." (THữu; 7)',
  },
  {
    word: "ao ước",
    part_of_speech: "động từ",
    meaning:
      "ước có được, đạt được điều gì một cách thiết tha: ao ước một cuộc sống gia đình hạnh phúc",
    example: "ao ước một cuộc sống gia đình hạnh phúc",
  },
  {
    word: "áo xống",
    part_of_speech: "danh từ",
    meaning:
      "đồ mặc, như áo, váy (xống), v.v. (nói khái quát; thường hàm ý chê): áo xống xộc xệch",
    example: "áo xống xộc xệch",
  },
  {
    word: "áo xiêm",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) như xiêm áo: "Tưng bừng sắm sửa áo xiêm, Biện dâng một lễ, xa đem tấc thành." (TKiều)',
    example:
      'Tưng bừng sắm sửa áo xiêm, Biện dâng một lễ, xa đem tấc thành." (TKiều)',
  },
  {
    word: "ảo vọng",
    part_of_speech: "danh từ",
    meaning: "(hiếm) hi vọng hão huyền: nuôi ảo vọng",
    example: "nuôi ảo vọng",
  },
  {
    word: "áp",
    part_of_speech: "danh từ",
    meaning: "điện áp (nói tắt): quá áp đột biến",
    example: "quá áp đột biến",
  },
  {
    word: "áp",
    part_of_speech: "danh từ",
    meaning: "huyết áp (nói tắt): thuốc hạ áp",
    example: "thuốc hạ áp",
  },
  {
    word: "áp",
    part_of_speech: "động từ",
    meaning:
      "làm cho bề mặt của một vật sát bề mặt của một vật khác: áp hai bàn tay vào má * nằm áp bụng xuống đất * thuyền áp bến",
    example: "áp hai bàn tay vào má * nằm áp bụng xuống đất * thuyền áp bến",
  },
  {
    word: "áp",
    part_of_speech: "động từ",
    meaning: "xông sát vào: hai người áp vào vật nhau",
    example: "hai người áp vào vật nhau",
  },
  {
    word: "áp",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) gần sát, liền sát: ngón áp út (cạnh ngón út) * những ngày áp Tết",
    example: "ngón áp út (cạnh ngón út) * những ngày áp Tết",
  },
  {
    word: "áp chế",
    part_of_speech: "động từ",
    meaning:
      '(cũ) đè nén và làm mất tự do: "Dân cày chỉ chết về cái rời rạc nhau quá, cho nên bị áp chế tàn nhẫn." (NgCHoan; 4)',
    example:
      'Dân cày chỉ chết về cái rời rạc nhau quá, cho nên bị áp chế tàn nhẫn." (NgCHoan; 4)',
  },
  {
    word: "áp bức",
    part_of_speech: "động từ",
    meaning:
      "dùng quyền lực, thế lực đè nén và tước hết mọi quyền tự do: chịu hai tầng áp bức * ách áp bức",
    example: "chịu hai tầng áp bức * ách áp bức",
  },
  {
    word: "áp chảo",
    part_of_speech: "động từ",
    meaning: "rán (thường là thịt) với rất ít mỡ: thịt áp chảo",
    example: "thịt áp chảo",
  },
  {
    word: "ảo tượng",
    part_of_speech: "danh từ",
    meaning: "ấm sinh (gọi tắt): ông ấm",
    example: "ông ấm",
  },
  {
    word: "ảo tượng",
    part_of_speech: "tính từ",
    meaning:
      "có nhiệt độ cao hơn mức trung bình một chút, gây cảm giác dễ chịu: cốc nước ấm * nắng ấm * trời ấm dần lên",
    example: "cốc nước ấm * nắng ấm * trời ấm dần lên",
  },
  {
    word: "ảo tượng",
    part_of_speech: "tính từ",
    meaning:
      "có tác dụng giữ ấm, không để cho cơ thể bị lạnh: mặc không đủ ấm * mới mua được chiếc áo ấm",
    example: "mặc không đủ ấm * mới mua được chiếc áo ấm",
  },
  {
    word: "ảo tượng",
    part_of_speech: "tính từ",
    meaning:
      "có tác dụng gây cảm giác êm dịu, dễ chịu: ấm lòng * giọng hát rất ấm",
    example: "ấm lòng * giọng hát rất ấm",
  },
  {
    word: "áp chót",
    part_of_speech: "tính từ",
    meaning:
      '(khẩu ngữ) liền sát với vị trí cuối cùng, hoặc với thời điểm kết thúc: xe máy đời áp chót * "Tôi là người đi áp chót, tức là sau tôi chỉ còn có chị Ba." (AĐức; 30)',
    example:
      'xe máy đời áp chót * "Tôi là người đi áp chót, tức là sau tôi chỉ còn có chị Ba." (AĐức; 30)',
  },
  {
    word: "áp dụng",
    part_of_speech: "động từ",
    meaning:
      "dùng trong thực tế điều đã nhận thức được: áp dụng kĩ thuật mới vào sản xuất",
    example: "áp dụng kĩ thuật mới vào sản xuất",
  },
  {
    word: "áp đảo",
    part_of_speech: "động từ",
    meaning:
      "dùng sức mạnh lấn át và dồn (đối phương) vào thế không thể trỗi dậy được nữa: tấn công áp đảo đối phương * áp đảo tinh thần * thắng với tỉ số áp đảo (tỉ số cao)",
    example:
      "tấn công áp đảo đối phương * áp đảo tinh thần * thắng với tỉ số áp đảo (tỉ số cao)",
  },
  {
    word: "áp điệu",
    part_of_speech: "động từ",
    meaning:
      '(cũ) như áp giải: "Tú bà tốc thẳng đến nơi, Hầm hầm áp điệu một hơi lại nhà." (TKiều)',
    example:
      'Tú bà tốc thẳng đến nơi, Hầm hầm áp điệu một hơi lại nhà." (TKiều)',
  },
  {
    word: "áp đặt",
    part_of_speech: "động từ",
    meaning: "đề ra và dùng sức ép bắt phải chấp nhận: áp đặt chế độ bảo hộ",
    example: "áp đặt chế độ bảo hộ",
  },
  {
    word: "áp giá",
    part_of_speech: "động từ",
    meaning:
      "(cơ quan chức năng) xác định giá bán bắt buộc theo quy định cho mỗi loại hàng hoá để làm căn cứ tính thuế: áp giá một mặt hàng mới",
    example: "áp giá một mặt hàng mới",
  },
  {
    word: "áp giải",
    part_of_speech: "động từ",
    meaning: "đi kèm để giải đi: áp giải tù binh",
    example: "áp giải tù binh",
  },
  {
    word: "áp lực",
    part_of_speech: "danh từ",
    meaning: "lực ép vuông góc với mặt bị ép: áp lực của không khí",
    example: "áp lực của không khí",
  },
  {
    word: "áp lực",
    part_of_speech: "danh từ",
    meaning: "như sức ép: áp lực tâm lí * gây áp lực",
    example: "áp lực tâm lí * gây áp lực",
  },
  {
    word: "áp suất",
    part_of_speech: "danh từ",
    meaning:
      "đại lượng vật lí có trị số bằng áp lực trên một đơn vị diện tích: áp suất khí quyển * vùng có áp suất thấp",
    example: "áp suất khí quyển * vùng có áp suất thấp",
  },
  {
    word: "áp tải",
    part_of_speech: "động từ",
    meaning:
      "đi theo để bảo vệ hàng hoá trong quá trình vận chuyển: áp tải lương thực * đi áp tải hàng",
    example: "áp tải lương thực * đi áp tải hàng",
  },
  {
    word: "áp-xe",
    part_of_speech: "danh từ",
    meaning:
      "khối mủ tụ trong một bộ phận cơ thể do nhiễm trùng mà thành: nhọt là một loại abscess trong da",
    example: "nhọt là một loại abscess trong da",
  },
  {
    word: "áp phe",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) việc buôn bán kiếm lợi lớn: vụ áp phe",
    example: "vụ áp phe",
  },
  {
    word: "áp phích",
    part_of_speech: "danh từ",
    meaning:
      "tờ giấy lớn có chữ hoặc tranh vẽ, dán ở nơi công cộng để tuyên truyền cổ động hay để quảng cáo: dán áp phích * áp phích quảng cáo",
    example: "dán áp phích * áp phích quảng cáo",
  },
  {
    word: "áp thuế",
    part_of_speech: "động từ",
    meaning:
      "(cơ quan chức năng) xác định thuế suất bắt buộc theo quy định cho mỗi loại hàng hoá: áp thuế doanh thu * thất thu một khoản tiền lớn do áp thuế sai",
    example: "áp thuế doanh thu * thất thu một khoản tiền lớn do áp thuế sai",
  },
  {
    word: "át",
    part_of_speech: "động từ",
    meaning:
      'làm cho che lấp và đánh bạt đi bằng một tác động mạnh hơn: mắng át đi * "Bà Phủ vội hỏi để át câu khiếm nhã của ông kia." (KhHưng; 4)',
    example:
      'mắng át đi * "Bà Phủ vội hỏi để át câu khiếm nhã của ông kia." (KhHưng; 4)',
  },
  {
    word: "át chủ bài",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) con bài có giá trị cao nhất trong ván bài tú lơ khơ; thường dùng để chỉ người, vật có vai trò quyết định trong một phạm vi, một hoàn cảnh cụ thể: anh ta là át chủ bài của đội tuyển",
    example: "anh ta là át chủ bài của đội tuyển",
  },
  {
    word: "au",
    part_of_speech: "tính từ",
    meaning:
      "(màu sắc, thường là đỏ) tươi ửng lên, trông thích mắt: quả cam vàng au * mái ngói đỏ au",
    example: "quả cam vàng au * mái ngói đỏ au",
  },
  {
    word: "áy náy",
    part_of_speech: "động từ",
    meaning:
      'cảm thấy lo ngại, không yên lòng về điều đã không làm được như ý muốn: áy náy vì không giúp được bạn * "Bà mẹ thấy Quỳ thơ thẩn, buồn rầu, cũng đâm áy náy." (ĐĐThu; 2)',
    example:
      'áy náy vì không giúp được bạn * "Bà mẹ thấy Quỳ thơ thẩn, buồn rầu, cũng đâm áy náy." (ĐĐThu; 2)',
  },
  {
    word: "ăn",
    part_of_speech: "động từ",
    meaning:
      "tự cho vào cơ thể thức nuôi sống: ăn cơm * lợn ăn cám * cỏ ăn hết màu * ăn có nhai, nói có nghĩ (tng)",
    example:
      "ăn cơm * lợn ăn cám * cỏ ăn hết màu * ăn có nhai, nói có nghĩ (tng)",
  },
  {
    word: "ăn",
    part_of_speech: "động từ",
    meaning: "nhai trầu hoặc hút thuốc: ăn một miếng trầu",
    example: "ăn một miếng trầu",
  },
  {
    word: "ăn",
    part_of_speech: "động từ",
    meaning:
      "ăn uống nhân dịp gì: đi ăn cưới * về quê ăn Tết * ăn cỗ đi trước, lội nước đi sau (tng)",
    example:
      "đi ăn cưới * về quê ăn Tết * ăn cỗ đi trước, lội nước đi sau (tng)",
  },
  {
    word: "ăn",
    part_of_speech: "động từ",
    meaning:
      "(máy móc, phương tiện vận tải) tiếp nhận cái cần thiết cho sự hoạt động: cho máy ăn dầu mỡ * loại xe này rất ăn xăng (tốn nhiều xăng hơn bình thường) * tàu đang ăn hàng (nhận hàng để chuyên chở)",
    example:
      "cho máy ăn dầu mỡ * loại xe này rất ăn xăng (tốn nhiều xăng hơn bình thường) * tàu đang ăn hàng (nhận hàng để chuyên chở)",
  },
  {
    word: "ăn",
    part_of_speech: "động từ",
    meaning:
      "nhận lấy để hưởng: ăn hoa hồng * lời ăn lỗ chịu * làm công ăn lương",
    example: "ăn hoa hồng * lời ăn lỗ chịu * làm công ăn lương",
  },
  {
    word: "ăn",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) phải nhận lấy, chịu lấy (cái không hay; hàm ý mỉa mai): ăn no đòn * ăn đạn",
    example: "ăn no đòn * ăn đạn",
  },
  {
    word: "ăn",
    part_of_speech: "động từ",
    meaning:
      "giành về mình phần hơn, phần thắng (trong cuộc thi đấu): ăn con xe * ăn giải * ăn nhau ở cái tinh thần",
    example: "ăn con xe * ăn giải * ăn nhau ở cái tinh thần",
  },
  {
    word: "ăn",
    part_of_speech: "động từ",
    meaning:
      "hấp thu cho thấm vào, nhiễm vào: vải ăn màu * mặt ăn phấn * cá không ăn muối, cá ươn (tng)",
    example: "vải ăn màu * mặt ăn phấn * cá không ăn muối, cá ươn (tng)",
  },
  {
    word: "ăn",
    part_of_speech: "động từ",
    meaning:
      "gắn, dính chặt vào nhau, khớp với nhau: hồ dán không ăn * phanh không ăn",
    example: "hồ dán không ăn * phanh không ăn",
  },
  {
    word: "ăn",
    part_of_speech: "động từ",
    meaning:
      "hợp với nhau, tạo nên sự hài hoà: chụp rất ăn ảnh * chiếc áo đen ăn với màu da trắng",
    example: "chụp rất ăn ảnh * chiếc áo đen ăn với màu da trắng",
  },
  {
    word: "ăn",
    part_of_speech: "động từ",
    meaning:
      "làm tiêu hao, huỷ hoại dần dần từng phần: nước ăn chân * sơn ăn mặt * gỉ ăn vào dây thép",
    example: "nước ăn chân * sơn ăn mặt * gỉ ăn vào dây thép",
  },
  {
    word: "ăn",
    part_of_speech: "động từ",
    meaning:
      "lan ra hoặc hướng đến nơi nào đó (nói về khu vực hoặc phạm vi tác động của cái gì): rễ mạ ăn nông * sông ăn ra biển * một thói quen đã ăn sâu trong tâm tưởng",
    example:
      "rễ mạ ăn nông * sông ăn ra biển * một thói quen đã ăn sâu trong tâm tưởng",
  },
  {
    word: "ăn",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) là một phần ở ngoài phụ vào; thuộc về: đám đất ăn về xã bên * khoản chi đó ăn vào ngân sách của năm trước",
    example:
      "đám đất ăn về xã bên * khoản chi đó ăn vào ngân sách của năm trước",
  },
  {
    word: "ăn",
    part_of_speech: "động từ",
    meaning:
      "(đơn vị tiền tệ, đo lường) có thể đổi ngang giá: một ăn 16.000 đồng Việt Nam",
    example: "một ăn 16.000 đồng Việt Nam",
  },
  {
    word: "ẵm",
    part_of_speech: "động từ",
    meaning:
      "bế (trẻ nhỏ) trên tay hoặc ôm trong lòng: ẵm con * bị kẻ giam ẵm mất cái ti vi (b)",
    example: "ẵm con * bị kẻ giam ẵm mất cái ti vi (b)",
  },
  {
    word: "ăm ắp",
    part_of_speech: "tính từ",
    meaning: "như ắp (nhưng mức độ nhiều hơn): ruộng ăm ắp nước * đầy ăm ắp",
    example: "ruộng ăm ắp nước * đầy ăm ắp",
  },
  {
    word: "ẵm ngửa",
    part_of_speech: "động từ",
    meaning:
      "bế ngửa trên tay (nói về trẻ mới sinh, còn ít tháng): con còn ẵm ngửa",
    example: "con còn ẵm ngửa",
  },
  {
    word: "ăn bám",
    part_of_speech: "động từ",
    meaning:
      "sống nhờ vào lao động của người khác (nói về người có khả năng lao động mà không chịu làm ăn gì): ăn bám cha mẹ",
    example: "ăn bám cha mẹ",
  },
  {
    word: "ăn bẫm",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) thu được nhiều lợi lộc, thường là không chính đáng: trót lọt vụ này, chúng sẽ ăn bẫm",
    example: "trót lọt vụ này, chúng sẽ ăn bẫm",
  },
  {
    word: "ăn cám",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) không được việc gì, chẳng thu được lợi lộc gì (dùng trong lời chê bai, phê phán): làm như thế thì có mà ăn cám!",
    example: "làm như thế thì có mà ăn cám!",
  },
  {
    word: "ăn bận",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) như ăn mặc: ăn bận sang trọng",
    example: "ăn bận sang trọng",
  },
  {
    word: "ăn bớt",
    part_of_speech: "động từ",
    meaning:
      "lấy bớt đi để hưởng riêng một phần: thợ may ăn bớt vải * ăn bớt tiền công của thợ",
    example: "thợ may ăn bớt vải * ăn bớt tiền công của thợ",
  },
  {
    word: "ăn cánh",
    part_of_speech: "động từ",
    meaning:
      "hợp thành một phe cánh với nhau: ăn cánh với nhau để làm hàng giả",
    example: "ăn cánh với nhau để làm hàng giả",
  },
  {
    word: "ăn cháo đái bát",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) ví thái độ chịu ơn rồi bội bạc, phụ ơn ngay: quân ăn cháo đái bát! (tiếng chửi)",
    example: "quân ăn cháo đái bát! (tiếng chửi)",
  },
  {
    word: "ăn cắp ăn nảy",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) ăn cắp (nói khái quát): sinh thói ăn cắp ăn nảy",
    example: "sinh thói ăn cắp ăn nảy",
  },
  {
    word: "ăn cắp",
    part_of_speech: "động từ",
    meaning:
      "lấy của người khác một cách lén lút, thường nhằm lúc sơ hở: ăn cắp vặt * ăn cắp quen tay, ngủ ngày quen mắt (tng)",
    example: "ăn cắp vặt * ăn cắp quen tay, ngủ ngày quen mắt (tng)",
  },
  {
    word: "ăn chay",
    part_of_speech: "động từ",
    meaning:
      "ăn loại thức ăn không có nguồn gốc động vật để tu hành, theo đạo Phật và một số tôn giáo khác: ăn chay niệm Phật * tháng ăn chay",
    example: "ăn chay niệm Phật * tháng ăn chay",
  },
  {
    word: "ăn chia",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) chia phần (giữa những người, những bên cùng tham gia một công việc): ăn chia lợi nhuận",
    example: "ăn chia lợi nhuận",
  },
  {
    word: "ăn chặn",
    part_of_speech: "động từ",
    meaning:
      "lợi dụng cương vị trung gian để lấy bớt phần của người khác: cai thầu ăn chặn tiền công của thợ",
    example: "cai thầu ăn chặn tiền công của thợ",
  },
  {
    word: "ăn chơi",
    part_of_speech: "động từ",
    meaning:
      'tiêu khiển bằng các thú vui vật chất (nói khái quát): ăn chơi trác táng * "Dạo tìm khắp chợ thì quê, Giả danh hầu hạ, dạy nghề ăn chơi." (TKiều)',
    example:
      'ăn chơi trác táng * "Dạo tìm khắp chợ thì quê, Giả danh hầu hạ, dạy nghề ăn chơi." (TKiều)',
  },
  {
    word: "ăn chơi",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có dáng vẻ, phong cách của dân ăn chơi: bộ quần áo trông rất ăn chơi",
    example: "bộ quần áo trông rất ăn chơi",
  },
  {
    word: "ăn chực",
    part_of_speech: "động từ",
    meaning:
      "ăn nhờ vào phần của người khác: ăn mày đòi xôi gấc, ăn chực đòi bánh chưng (tng)",
    example: "ăn mày đòi xôi gấc, ăn chực đòi bánh chưng (tng)",
  },
  {
    word: "ăn cướp",
    part_of_speech: "động từ",
    meaning:
      "đoạt lấy bằng cách cướp: đồ ăn cướp! (tiếng chửi) * vừa ăn cướp vừa la làng (tng)",
    example: "đồ ăn cướp! (tiếng chửi) * vừa ăn cướp vừa la làng (tng)",
  },
  {
    word: "bêu nắng",
    part_of_speech: "động từ",
    meaning: "(trẻ em) phơi đầu trần dưới nắng: mặt đỏ lựng vì bêu nắng",
    example: "mặt đỏ lựng vì bêu nắng",
  },
  {
    word: "bêu xấu",
    part_of_speech: "động từ",
    meaning:
      "làm cho người nào đó phải thấy xấu hổ bằng lời nói hoặc việc làm của mình: mẹ chồng bêu xấu con dâu * bêu xấu nhau",
    example: "mẹ chồng bêu xấu con dâu * bêu xấu nhau",
  },
  {
    word: "bị",
    part_of_speech: "danh từ",
    meaning:
      "đồ đựng thường đan bằng cói, có quai xách: bị cói * xách bị đi ăn mày",
    example: "bị cói * xách bị đi ăn mày",
  },
  {
    word: "bị",
    part_of_speech: "động từ",
    meaning:
      "từ biểu thị chủ thể là đối tượng chịu sự tác động của việc không hay, không có lợi đối với mình: bị đòn * mảnh vườn bị tàn phá nặng",
    example: "bị đòn * mảnh vườn bị tàn phá nặng",
  },
  {
    word: "bị",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) bên bị (nói tắt): nguyên nói nguyên phải, bị nói bị hay (tng)",
    example: "nguyên nói nguyên phải, bị nói bị hay (tng)",
  },
  {
    word: "bhxh",
    part_of_speech: "danh từ",
    meaning:
      "hình thức bảo hiểm cho người lao động mà đối tượng tham gia được hưởng những quyền lợi vật chất khi hết tuổi lao động hoặc khi không làm việc được vì ốm đau, sinh đẻ, bị tai nạn lao động: đóng bảo hiểm xã hội * hưởng trợ cấp bảo hiểm xã hội",
    example: "đóng bảo hiểm xã hội * hưởng trợ cấp bảo hiểm xã hội",
  },
  {
    word: "bêu riếu",
    part_of_speech: "động từ",
    meaning:
      "nói ra, phơi bày chuyện xấu ra cho người ta chê cười: bêu riếu cha mẹ",
    example: "bêu riếu cha mẹ",
  },
  {
    word: "bí",
    part_of_speech: "danh từ",
    meaning:
      'cây cùng họ với bầu, mọc leo hay mọc bò, có nhiều loài, quả dùng làm thức ăn: quả bí * "Bầu ơi thương lấy bí cùng, Tuy rằng khác giống nhưng chung một giàn." (Cdao)',
    example:
      'quả bí * "Bầu ơi thương lấy bí cùng, Tuy rằng khác giống nhưng chung một giàn." (Cdao)',
  },
  {
    word: "bí",
    part_of_speech: "tính từ",
    meaning:
      "không thông, không thoát ra ngoài được: bí tiểu tiện * bí hơi * căn phòng rất bí",
    example: "bí tiểu tiện * bí hơi * căn phòng rất bí",
  },
  {
    word: "bí",
    part_of_speech: "tính từ",
    meaning:
      "ở vào thế gặp khó khăn mà không sao tìm được cách giải quyết: bị dồn vào thế bí * cờ đang bí nước * gỡ bí cho bạn",
    example: "bị dồn vào thế bí * cờ đang bí nước * gỡ bí cho bạn",
  },
  {
    word: "bhyt",
    part_of_speech: "danh từ",
    meaning:
      "hình thức bảo hiểm mà đối tượng tham gia được hưởng các quyền lợi về chăm sóc sức khoẻ và điều trị bệnh: thẻ bảo hiểm y tế",
    example: "thẻ bảo hiểm y tế",
  },
  {
    word: "bi",
    part_of_speech: "danh từ",
    meaning:
      "viên cứng hình cầu, thường dùng trong trục quay của máy móc hoặc làm đồ chơi cho trẻ con: bi xe đạp * viên bi * chơi bắn bi",
    example: "bi xe đạp * viên bi * chơi bắn bi",
  },
  {
    word: "bi",
    part_of_speech: "tính từ",
    meaning:
      "có những yếu tố gây thương cảm: có cả tính bi lẫn hài trong vở kịch",
    example: "có cả tính bi lẫn hài trong vở kịch",
  },
  {
    word: "bi",
    part_of_speech: "tính từ",
    meaning:
      '(Khẩu ngữ) bi quan (nói tắt): tình cảnh rất bi  * "Ấy đấy, tôi bi lắm. Cứ quan sát kỹ thì rất nản." (NCao; 8)',
    example:
      'tình cảnh rất bi  * "Ấy đấy, tôi bi lắm. Cứ quan sát kỹ thì rất nản." (NCao; 8)',
  },
  {
    word: "bì",
    part_of_speech: "danh từ",
    meaning: "da của lợn, bò, v.v. dùng làm thức ăn: bì lợn * nem bì",
    example: "bì lợn * nem bì",
  },
  {
    word: "bì",
    part_of_speech: "danh từ",
    meaning: "mô bọc mặt ngoài cơ thể sinh vật.",
    example: "gọt bì phật thủ * tước bì xoan",
  },
  {
    word: "bì",
    part_of_speech: "danh từ",
    meaning:
      "lớp ngoài của vỏ ở một số cây, quả: gọt bì phật thủ * tước bì xoan",
    example: "cân chưa trừ bì",
  },
  {
    word: "bì",
    part_of_speech: "động từ",
    meaning:
      'sánh được, sánh có thể bằng được: khoẻ ít ai bì kịp * bì sao được với nó * "Bì sao bì phấn với vôi, Bì anh con một với tôi con đàn." (Cdao)',
    example:
      'khoẻ ít ai bì kịp * bì sao được với nó * "Bì sao bì phấn với vôi, Bì anh con một với tôi con đàn." (Cdao)',
  },
  {
    word: "bì",
    part_of_speech: "tính từ",
    meaning:
      '(da) dày và có vẻ nặng: mặt nặng da bì * "(...) thằng trưởng Khiếu, mặt lúc nào cũng bì ra những rượu." (THoài; 34)',
    example:
      'mặt nặng da bì * "(...) thằng trưởng Khiếu, mặt lúc nào cũng bì ra những rượu." (THoài; 34)',
  },
  {
    word: "bi a",
    part_of_speech: "danh từ",
    meaning:
      "trò chơi dành cho hai người với 16 quả bóng, người chơi dùng gậy để đẩy bóng vào những lỗ khoét ở rìa một cái bàn lớn hình chữ nhật có lót dạ, bốn cạnh có gờ: chơi bi a * bàn bi a",
    example: "chơi bi a * bàn bi a",
  },
  {
    word: "bí ẩn",
    part_of_speech: "tính từ",
    meaning: "có vẻ kín đáo, khó hiểu: nụ cười bí ẩn * cái nhìn đầy bí ẩn",
    example: "nụ cười bí ẩn * cái nhìn đầy bí ẩn",
  },
  {
    word: "bí ẩn",
    part_of_speech: "danh từ",
    meaning:
      "cái gì, điều gì đó có phần kín đáo, khó hiểu: khám phá bí ẩn của tự nhiên",
    example: "khám phá bí ẩn của tự nhiên",
  },
  {
    word: "bí bách",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) bí quá, không có lối thoát: hoàn cảnh bí bách",
    example: "hoàn cảnh bí bách",
  },
  {
    word: "bì bạch",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng vỗ nhẹ vào vật mềm, không đều nhau, phát ra liên tiếp: vỗ đùi bì bạch",
    example: "vỗ đùi bì bạch",
  },
  {
    word: "bì bạch",
    part_of_speech: "tính từ",
    meaning:
      "hoặc đg từ gợi tả dáng đi, chạy một cách chậm chạp, nặng nề: mấy con ngỗng bì bạch ở ngoài sân * chạy bì bạch",
    example: "mấy con ngỗng bì bạch ở ngoài sân * chạy bì bạch",
  },
  {
    word: "bi ai",
    part_of_speech: "tính từ",
    meaning:
      'buồn thảm, làm não lòng người: tiếng khóc bi ai * "Sụt sùi nhiều đoạn bi ai, Bóng trăng lìa gió, lạc loài phương xa." (ca dao)',
    example:
      'tiếng khóc bi ai * "Sụt sùi nhiều đoạn bi ai, Bóng trăng lìa gió, lạc loài phương xa." (ca dao)',
  },
  {
    word: "bỉ bai",
    part_of_speech: "động từ",
    meaning: "chê bai và khinh bỉ: buông lời bỉ bai",
    example: "buông lời bỉ bai",
  },
  {
    word: "bí bét",
    part_of_speech: "tính từ",
    meaning:
      "ở tình trạng sút kém, bê trễ, đến mức đình đốn dai dẳng, không tiến lên được: công việc làm ăn bí bét * tình hình sản xuất bí bét",
    example: "công việc làm ăn bí bét * tình hình sản xuất bí bét",
  },
  {
    word: "bỉ báng",
    part_of_speech: "động từ",
    meaning: "(cũ, hiếm) như phỉ báng: bị mọi người bỉ báng",
    example: "bị mọi người bỉ báng",
  },
  {
    word: "bi bô",
    part_of_speech: "động từ",
    meaning:
      "(trẻ em) nói chưa sõi, lặp đi lặp lại một số âm chưa phân biệt rành rọt: bi bô tập nói * trẻ bi bô gọi mẹ",
    example: "bi bô tập nói * trẻ bi bô gọi mẹ",
  },
  {
    word: "bì bõm",
    part_of_speech: "động từ",
    meaning:
      "từ mô phỏng tiếng lội hay tiếng đập nước nhẹ và liên tiếp: mái chèo khua bì bõm * lội bì bõm",
    example: "mái chèo khua bì bõm * lội bì bõm",
  },
  {
    word: "bì bì",
    part_of_speech: "tính từ",
    meaning:
      '(khuôn mặt) dày lên, như bị sưng lên, trông nặng nề và khó coi: "Gượng đau, lạy trước đan trì, áo tươm tướp rách, mặt bì bì sưng." (NĐM)',
    example:
      'Gượng đau, lạy trước đan trì, áo tươm tướp rách, mặt bì bì sưng." (NĐM)',
  },
  {
    word: "bi ca",
    part_of_speech: "danh từ",
    meaning: "bài hát trữ tình thể hiện nỗi buồn thảm, xót thương: khúc bi ca",
    example: "khúc bi ca",
  },
  {
    word: "bĩ cực thái lai",
    part_of_speech: "",
    meaning:
      '(cũ) hết cái rủi ro, long đong thì đến cái may mắn, yên vui: "Mới hay bĩ cực thái lai, Còn trong trần luỵ biết ai công hầu." (PT)',
    example:
      'Mới hay bĩ cực thái lai, Còn trong trần luỵ biết ai công hầu." (PT)',
  },
  {
    word: "bi cảm",
    part_of_speech: "động từ",
    meaning: "(cũ) như thương cảm: động lòng bi cảm",
    example: "động lòng bi cảm",
  },
  {
    word: "bi đát",
    part_of_speech: "tính từ",
    meaning: "rất đau thương: một số phận bi đát * tình cảnh bi đát",
    example: "một số phận bi đát * tình cảnh bi đát",
  },
  {
    word: "bí danh",
    part_of_speech: "danh từ",
    meaning:
      "tên dùng thay cho tên thật (để giấu tên thật): gọi bằng bí danh * Tống Văn Sơ là bí danh của Nguyễn Ái Quốc",
    example: "gọi bằng bí danh * Tống Văn Sơ là bí danh của Nguyễn Ái Quốc",
  },
  {
    word: "bi đông",
    part_of_speech: "danh từ",
    meaning:
      "đồ đựng bằng kim loại hoặc nhựa, miệng nhỏ, thân to và hơi dẹt, có nắp đậy bằng cách vặn, dùng đựng nước uống hoặc nói chung các chất lỏng để mang đi: một bi đông rượu * bi đông đựng nước",
    example: "một bi đông rượu * bi đông đựng nước",
  },
  {
    word: "bị gậy",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) cái bị và cái gậy; dùng để chỉ cảnh đi ăn mày: bị gậy đi ăn mày * lâm vào cảnh bị gậy",
    example: "bị gậy đi ăn mày * lâm vào cảnh bị gậy",
  },
  {
    word: "bi hài kịch",
    part_of_speech: "danh từ",
    meaning:
      "kịch vừa có nhân tố bi kịch vừa có nhân tố hài kịch, thường có kết cục tốt đẹp: trình diễn vở bi hài kịch",
    example: "trình diễn vở bi hài kịch",
  },
  {
    word: "bi hài kịch",
    part_of_speech: "danh từ",
    meaning: "cảnh vừa đau thương, vừa buồn cười: thật là một bi hài kịch",
    example: "thật là một bi hài kịch",
  },
  {
    word: "bị động",
    part_of_speech: "tính từ",
    meaning:
      "ở tình thế buộc phải hành động theo sự chi phối của người khác hoặc hoàn cảnh bên ngoài: rơi vào thế bị động * đối phó một cách bị động",
    example: "rơi vào thế bị động * đối phó một cách bị động",
  },
  {
    word: "bí hiểm",
    part_of_speech: "tính từ",
    meaning:
      "có chứa những cái rất khó biết, khó dò ra được ở bên trong: rừng núi âm u bí hiểm * nụ cười đầy bí hiểm",
    example: "rừng núi âm u bí hiểm * nụ cười đầy bí hiểm",
  },
  {
    word: "bí hiểm",
    part_of_speech: "danh từ",
    meaning:
      "cái gì, điều gì đó rất khó biết, khó dò ra được: khu rừng có nhiều bí hiểm",
    example: "khu rừng có nhiều bí hiểm",
  },
  {
    word: "bi kịch",
    part_of_speech: "danh từ",
    meaning:
      "kịch có nội dung phản ánh cuộc xung đột gay gắt giữa nhân vật chính diện với hiện thực, có kết cục bi thảm: bi kịch cổ điển Pháp",
    example: "bi kịch cổ điển Pháp",
  },
  {
    word: "bi kịch",
    part_of_speech: "danh từ",
    meaning: "cảnh éo le, trắc trở, đau thương: bi kịch trong gia đình",
    example: "bi kịch trong gia đình",
  },
  {
    word: "bi luỵ",
    part_of_speech: "tính từ",
    meaning:
      "(văn chương) buồn rơi nước mắt; buồn thương một cách yếu đuối: tình cảm bi luỵ",
    example: "tình cảm bi luỵ",
  },
  {
    word: "bí mật",
    part_of_speech: "tính từ",
    meaning:
      "được giữ kín trong phạm vi một số ít người, không để lộ cho người ngoài biết: điều ước bí mật * hầm bí mật * hoạt động bí mật",
    example: "điều ước bí mật * hầm bí mật * hoạt động bí mật",
  },
  {
    word: "bí mật",
    part_of_speech: "danh từ",
    meaning:
      "điều cần giữ kín trong phạm vi một số ít người, không để lộ cho người ngoài biết: giữ bí mật quốc gia * lộ bí mật quân sự",
    example: "giữ bí mật quốc gia * lộ bí mật quân sự",
  },
  {
    word: "bí mật",
    part_of_speech: "danh từ",
    meaning: "điều khó hiểu, chưa ai biết: khám phá bí mật của tự nhiên",
    example: "khám phá bí mật của tự nhiên",
  },
  {
    word: "bỉ ổi",
    part_of_speech: "tính từ",
    meaning: "xấu xa, hèn hạ, đáng khinh: thủ đoạn bỉ ổi * bộ mặt bỉ ổi",
    example: "thủ đoạn bỉ ổi * bộ mặt bỉ ổi",
  },
  {
    word: "bi phẫn",
    part_of_speech: "",
    meaning:
      "đau thương và căm giận, uất ức đến cao độ: những ý nghĩ bi phẫn * cơn bi phẫn",
    example: "những ý nghĩ bi phẫn * cơn bi phẫn",
  },
  {
    word: "bí quyết",
    part_of_speech: "danh từ",
    meaning:
      "phương pháp, cách thức đặc biệt hiệu nghiệm được giữ kín, ít người biết: bí quyết nghề nghiệp * bí quyết chinh phục nhân tâm",
    example: "bí quyết nghề nghiệp * bí quyết chinh phục nhân tâm",
  },
  {
    word: "bí rì",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) rất bí, không sao tìm được lối thoát: công việc bí rì",
    example: "công việc bí rì",
  },
  {
    word: "bí số",
    part_of_speech: "danh từ",
    meaning:
      "số dùng thay tên thật để giữ bí mật trong hoạt động tình báo gián điệp: điệp viên mang bí số T.6",
    example: "điệp viên mang bí số T.6",
  },
  {
    word: "bi quan",
    part_of_speech: "tính từ",
    meaning:
      "có cách nhìn nặng nề về mặt tiêu cực, không tin tưởng ở sự phát triển theo hướng tốt, ở tương lai: thái độ bi quan * nhìn đời bằng cặp mắt bi quan",
    example: "thái độ bi quan * nhìn đời bằng cặp mắt bi quan",
  },
  {
    word: "bi quan",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (tình hình) khó cứu vãn, tuyệt vọng: tình thế rất bi quan",
    example: "tình thế rất bi quan",
  },
  {
    word: "bị sị",
    part_of_speech: "tính từ",
    meaning: "(vẻ mặt) xịu xuống, lầm lì do có điều không vừa ý: mặt mày bị sị",
    example: "mặt mày bị sị",
  },
  {
    word: "bị thịt",
    part_of_speech: "danh từ",
    meaning: "(thông tục) ví người to xác mà đần độn, chậm chạp: đồ bị thịt!",
    example: "đồ bị thịt!",
  },
  {
    word: "bí thư",
    part_of_speech: "danh từ",
    meaning:
      "người được bầu ra để thay mặt ban chấp hành, lãnh đạo công việc hằng ngày (trong một số chính đảng hay đoàn thể): bầu bí thư chi bộ * bí thư thành đoàn * bí thư ban chấp hành trung ương",
    example:
      "bầu bí thư chi bộ * bí thư thành đoàn * bí thư ban chấp hành trung ương",
  },
  {
    word: "bi thảm",
    part_of_speech: "tính từ",
    meaning:
      "rất đau thương, khiến ai cũng phải động lòng thương xót: cái chết bi thảm * câu chuyện bi thảm",
    example: "cái chết bi thảm * câu chuyện bi thảm",
  },
  {
    word: "bì thư",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) phong bì: tem dán trên bì thư",
    example: "tem dán trên bì thư",
  },
  {
    word: "bi thương",
    part_of_speech: "tính từ",
    meaning:
      'rất đỗi thương tâm: khúc hát bi thương * "Lên cao trông thức mây lồng, Lòng nào là chẳng động lòng bi thương." (CPN)',
    example:
      'khúc hát bi thương * "Lên cao trông thức mây lồng, Lòng nào là chẳng động lòng bi thương." (CPN)',
  },
  {
    word: "bí tỉ",
    part_of_speech: "phụ từ",
    meaning:
      "(thông tục) (say rượu, bia) đến mức không còn biết gì nữa: nhậu một trận bí tỉ * say bí tỉ",
    example: "nhậu một trận bí tỉ * say bí tỉ",
  },
  {
    word: "bị thương",
    part_of_speech: "động từ",
    meaning:
      "(cơ thể) không còn lành lặn, nguyên vẹn, do bị tác động từ bên ngoài: bị thương ở vai * bị thương nặng/nhẹ",
    example: "bị thương ở vai *",
  },
  {
    word: "bỉ tiện",
    part_of_speech: "tính từ",
    meaning:
      "quê mùa và ngu dốt, ti tiện: giở trò bỉ tiện * đồ bỉ tiện! (tiếng chửi mắng)",
    example: "giở trò bỉ tiện * đồ bỉ tiện! (tiếng chửi mắng)",
  },
  {
    word: "bi tráng",
    part_of_speech: "tính từ",
    meaning:
      "(văn chương) vừa có tính chất bi ai, vừa có tính chất hùng tráng: bài ca bi tráng",
    example: "bài ca bi tráng",
  },
  {
    word: "bị trị",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) (dân tộc, tầng lớp) bị thống trị, bị áp bức: dân tộc bị trị * lớp người bị trị",
    example: "dân tộc bị trị * lớp người bị trị",
  },
  {
    word: "bí truyền",
    part_of_speech: "tính từ",
    meaning:
      "được bí mật truyền lại cho một số rất ít người: môn võ bí truyền * phương thuốc bí truyền",
    example: "môn võ bí truyền * phương thuốc bí truyền",
  },
  {
    word: "bia",
    part_of_speech: "danh từ",
    meaning:
      "tấm đá lớn có khắc chữ để ghi lại việc người đời cần ghi nhớ hoặc để làm mộ chí: bia mộ * dựng bia kỉ niệm",
    example: "bia mộ * dựng bia kỉ niệm",
  },
  {
    word: "bia",
    part_of_speech: "danh từ",
    meaning:
      "vật được làm mục tiêu để tập bắn hoặc thi bắn: ngắm bia để bắn * tập bắn bia ẩn hiện",
    example: "ngắm bia để bắn * tập bắn bia ẩn hiện",
  },
  {
    word: "bìa",
    part_of_speech: "danh từ",
    meaning:
      "tờ giấy dày hoặc vật hình tấm thay cho tờ giấy đóng ngoài quyển sách, quyển vở: vở rách bìa * bìa sách làm bằng da",
    example: "vở rách bìa * bìa sách làm bằng da",
  },
  {
    word: "bìa",
    part_of_speech: "danh từ",
    meaning:
      "phần ngoài cùng của cây gỗ được rọc để loại đi: tấm gỗ bìa * nhặt bìa gỗ về làm củi",
    example: "tấm gỗ bìa * nhặt bìa gỗ về làm củi",
  },
  {
    word: "bìa",
    part_of_speech: "danh từ",
    meaning: "từ dùng để chỉ từng đơn vị miếng đậu phụ: mua ba bìa đậu",
    example: "mua ba bìa đậu",
  },
  {
    word: "bìa",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) rìa, mép ngoài: nhà ở gần bìa rừng * bìa suối",
    example: "nhà ở gần bìa rừng * bìa suối",
  },
  {
    word: "bịa",
    part_of_speech: "động từ",
    meaning:
      "nghĩ ra và nói y như thật điều không có trong thực tế: bịa cớ thoái thác * bịa chuyện để hại người",
    example: "bịa cớ thoái thác * bịa chuyện để hại người",
  },
  {
    word: "bịa đặt",
    part_of_speech: "động từ",
    meaning:
      "bịa với mục đích xấu, thường gây hại đến người khác: bịa đặt chuyện ma quỷ * bịa đặt tin nhảm",
    example: "bịa đặt chuyện ma quỷ * bịa đặt tin nhảm",
  },
  {
    word: "bia bọt",
    part_of_speech: "",
    meaning: "(khẩu ngữ) bia để uống (nói chung): suốt ngày bia bọt, rượu chè",
    example: "suốt ngày bia bọt, rượu chè",
  },
  {
    word: "bia ôm",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) hình thức uống bia có tiếp viên nữ ngồi bên phục vụ và chiều chuộng theo kiểu không đứng đắn, cốt thu được nhiều tiền: quán bia ôm",
    example: "quán bia ôm",
  },
  {
    word: "bích",
    part_of_speech: "danh từ",
    meaning:
      "chi tiết máy có dạng vành, có mặt phẳng để ghép với mặt phẳng của vật khác cho kín khít bằng cách hàn lại hoặc chốt đinh ốc, v.v.: bích nối ống * mặt bích của khớp trục",
    example: "bích nối ống * mặt bích của khớp trục",
  },
  {
    word: "bích báo",
    part_of_speech: "danh từ",
    meaning: "(cũ) báo tường: viết bích báo",
    example: "viết bích báo",
  },
  {
    word: "bia miệng",
    part_of_speech: "danh từ",
    meaning:
      'tiếng xấu để lại, lưu truyền từ đời này sang đời khác: "Trăm năm bia đá cũng mòn, Nghìn năm bia miệng hãy còn trơ trơ." (ca dao)',
    example:
      'Trăm năm bia đá cũng mòn, Nghìn năm bia miệng hãy còn trơ trơ." (ca dao)',
  },
  {
    word: "bịch",
    part_of_speech: "danh từ",
    meaning:
      'đồ đựng bằng tre nứa, to hơn bồ, thường có hình trụ không đáy: bịch thóc * "Bởi anh chăm việc canh nông, Cho nên mới có bồ trong bịch ngoài." (ca dao)',
    example:
      'bịch thóc * "Bởi anh chăm việc canh nông, Cho nên mới có bồ trong bịch ngoài." (ca dao)',
  },
  {
    word: "bịch",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) túi, bao có chứa đồ ở trong: bịch sữa * mua một bịch trái cây",
    example: "bịch sữa * mua một bịch trái cây",
  },
  {
    word: "bịch",
    part_of_speech: "động từ",
    meaning: "(thông tục) đấm mạnh vào người: bịch mạnh vào ngực",
    example: "bịch mạnh vào ngực",
  },
  {
    word: "bịch",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng phát ra như tiếng của vật nặng rơi mạnh xuống nền đất hoặc va chạm với vật mềm: ba lô rơi bịch xuống đất * giậm chân cái bịch",
    example: "ba lô rơi bịch xuống đất * giậm chân cái bịch",
  },
  {
    word: "biếc",
    part_of_speech: "tính từ",
    meaning:
      'có màu xanh lam pha màu lục, nhìn thích mắt: chiếc lá biếc * "Đường vô xứ Nghệ quanh quanh, Non xanh, nước biếc như tranh hoạ đồ." (ca dao)',
    example:
      'chiếc lá biếc * "Đường vô xứ Nghệ quanh quanh, Non xanh, nước biếc như tranh hoạ đồ." (ca dao)',
  },
  {
    word: "biếm hoạ",
    part_of_speech: "danh từ",
    meaning: "tranh châm biếm có tính chất gây cười: tranh biếm hoạ",
    example: "tranh biếm hoạ",
  },
  {
    word: "biến",
    part_of_speech: "động từ",
    meaning:
      'thay đổi hoặc làm cho thay đổi từ trạng thái, hình thức này sang trạng thái, hình thức khác: mặt biến sắc * biến không thành có * "Hoàng hôn trên trảng đang đỏ rực biến dần sang sắc tím." (AĐức; 10)',
    example:
      'mặt biến sắc * biến không thành có * "Hoàng hôn trên trảng đang đỏ rực biến dần sang sắc tím." (AĐức; 10)',
  },
  {
    word: "biến",
    part_of_speech: "động từ",
    meaning:
      "đột nhiên không còn thấy đâu nữa mà không để lại dấu vết gì: ông tiên biến mất * túi tiền biến đâu mất * bao giận hờn vụt biến hết",
    example:
      "ông tiên biến mất * túi tiền biến đâu mất * bao giận hờn vụt biến hết",
  },
  {
    word: "biến",
    part_of_speech: "danh từ",
    meaning:
      "việc không hay bất ngờ xảy ra làm cho tình hình thay đổi đột ngột: đề phòng có biến * xảy ra biến lớn",
    example: "đề phòng có biến * xảy ra biến lớn",
  },
  {
    word: "biến",
    part_of_speech: "phụ từ",
    meaning:
      "(Khẩu ngữ) từ biểu thị hành động diễn ra rất nhanh và không để lại dấu vết gì: quên biến mất * giấu biến đi",
    example: "quên biến mất * giấu biến đi",
  },
  {
    word: "biên",
    part_of_speech: "danh từ",
    meaning:
      "phần sát cạnh của một bề mặt (như sân bóng, bàn cờ, tấm hàng dệt, v.v.): ăn con tốt biên * bóng đã ra ngoài biên dọc",
    example: "ăn con tốt biên * bóng đã ra ngoài biên dọc",
  },
  {
    word: "biên",
    part_of_speech: "danh từ",
    meaning: "biên giới (nói tắt): chợ vùng biên",
    example: "chợ vùng biên",
  },
  {
    word: "biên",
    part_of_speech: "động từ",
    meaning: "ghi ít chữ, ít dòng: biên tên * biên địa chỉ",
    example: "biên tên * biên địa chỉ",
  },
  {
    word: "biên",
    part_of_speech: "động từ",
    meaning: "biên soạn kịch (nói tắt): vở kịch tự biên tự diễn",
    example: "vở kịch tự biên tự diễn",
  },
  {
    word: "biển",
    part_of_speech: "danh từ",
    meaning:
      "vùng nước mặn rộng lớn trên bề mặt Trái Đất: nước biển * đáy biển * cá biển (cá sống ở biển)",
    example: "nước biển * đáy biển * cá biển (cá sống ở biển)",
  },
  {
    word: "biển",
    part_of_speech: "danh từ",
    meaning:
      "phần của đại dương ở ven đại lục, ít nhiều bị ngăn ra bởi đất liền hoặc đảo: biển Đông * vùng biển Nhật Bản",
    example: "biển Đông * vùng biển Nhật Bản",
  },
  {
    word: "biển",
    part_of_speech: "danh từ",
    meaning:
      '(văn chương) khối lượng to lớn (ví như biển) trên một diện tích rộng: biển lửa * một biển người * "Mênh mông biển lúa xanh rờn, Tháp cao sừng sững trăng vờn bóng cau." (ca dao)',
    example:
      'biển lửa * một biển người * "Mênh mông biển lúa xanh rờn, Tháp cao sừng sững trăng vờn bóng cau." (ca dao)',
  },
  {
    word: "biển",
    part_of_speech: "danh từ",
    meaning:
      "tấm gỗ, sắt hay bằng vật liệu nào đó, trên có chữ viết, hình vẽ thể hiện một nội dung nhất định, đặt ở chỗ mọi người dễ thấy: biển chỉ đường * biển số xe máy * tấm biển quảng cáo",
    example: "biển chỉ đường * biển số xe máy * tấm biển quảng cáo",
  },
  {
    word: "biên ải",
    part_of_speech: "danh từ",
    meaning: "cửa ải ở biên giới: miền biên ải * đóng quân ngoài biên ải",
    example: "miền biên ải * đóng quân ngoài biên ải",
  },
  {
    word: "biện",
    part_of_speech: "động từ",
    meaning:
      '(trang trọng) lo liệu, sắm sửa lễ vật hoặc bữa ăn uống: biện rượu * "Tưng bừng sắm sửa áo xiêm, Biện dâng một lễ, xa đem tấc thành." (TKiều)',
    example:
      'biện rượu * "Tưng bừng sắm sửa áo xiêm, Biện dâng một lễ, xa đem tấc thành." (TKiều)',
  },
  {
    word: "biện bạch",
    part_of_speech: "động từ",
    meaning:
      "nói rõ sự việc để tránh hiểu lầm hoặc để khỏi bị chê trách: biện bạch cho sai lầm của mình",
    example: "biện bạch cho sai lầm của mình",
  },
  {
    word: "biện bạch",
    part_of_speech: "động từ",
    meaning:
      'xử lí cho rõ ràng: "Quyết ngay biện bạch một bề, Dạy cho má phấn lại về lầu xanh!" (TKiều)',
    example:
      'Quyết ngay biện bạch một bề, Dạy cho má phấn lại về lầu xanh!" (TKiều)',
  },
  {
    word: "biến áp",
    part_of_speech: "động từ",
    meaning: "đổi hiệu thế của một dòng điện xoay chiều: trạm biến thế",
    example: "trạm biến thế",
  },
  {
    word: "biến áp",
    part_of_speech: "danh từ",
    meaning:
      "khí cụ đổi một dòng điện xoay chiều thành một dòng điện xoay chiều cùng tần số nhưng khác hiệu thế: mua thêm biến thế * sản xuất biến thế điện",
    example: "mua thêm biến thế * sản xuất biến thế điện",
  },
  {
    word: "biến âm",
    part_of_speech: "động từ",
    meaning:
      "biến đổi về âm thanh (của ngôn ngữ): quy luật biến âm * quá trình biến âm",
    example: "quy luật biến âm * quá trình biến âm",
  },
  {
    word: "biến âm",
    part_of_speech: "danh từ",
    meaning:
      "âm (của một ngôn ngữ) đã được biến đổi theo những quy luật nhất định: ‘chánh trị’ là biến âm của ‘chính trị’",
    example: "‘chánh trị’ là biến âm của ‘chính trị’",
  },
  {
    word: "biện bác",
    part_of_speech: "động từ",
    meaning:
      "tranh cãi, dùng lí lẽ, chứng cứ để bác ý kiến của đối phương: có tài biện bác * không dễ biện bác",
    example: "có tài biện bác * không dễ biện bác",
  },
  {
    word: "biến báo",
    part_of_speech: "động từ",
    meaning:
      "ứng đáp nhanh và khôn, thường là để chống chế: miệng lưỡi biến báo * giỏi biến báo",
    example: "miệng lưỡi biến báo * giỏi biến báo",
  },
  {
    word: "biến báo",
    part_of_speech: "động từ",
    meaning:
      "(từ trong các ngôn ngữ biến hình) biến đổi hình thái tuỳ theo các cách: sự biến cách của danh từ tiếng Nga",
    example: "sự biến cách của danh từ tiếng Nga",
  },
  {
    word: "biển cả",
    part_of_speech: "danh từ",
    meaning: "(văn chương) biển rộng lớn (nói khái quát): biển cả mênh mông",
    example: "biển cả mênh mông",
  },
  {
    word: "biên bản",
    part_of_speech: "danh từ",
    meaning:
      "bản ghi lại những gì thực tế đã xảy ra (về một sự việc cần ghi nhớ hoặc cần xử lí) để làm chứng cớ, làm căn cứ: biên bản hỏi cung * biên bản bàn giao * lập biên bản",
    example: "biên bản hỏi cung * biên bản bàn giao * lập biên bản",
  },
  {
    word: "biên bản",
    part_of_speech: "danh từ",
    meaning:
      "bản ghi lại tiến trình, đặc biệt là nội dung, kết quả thảo luận (của một cuộc họp, hội nghị): thư kí ghi biên bản cuộc họp",
    example: "thư kí ghi biên bản cuộc họp",
  },
  {
    word: "biển báo",
    part_of_speech: "danh từ",
    meaning:
      "biển đặt trên đường và nơi công cộng để thông báo về các hạn chế hoặc đặc điểm của điều kiện giao thông hoặc trật tự công cộng: biển báo đường một chiều * biển báo cấm hút thuốc",
    example: "biển báo đường một chiều * biển báo cấm hút thuốc",
  },
  {
    word: "biến cải",
    part_of_speech: "động từ",
    meaning:
      '(cũ) biến đổi thành khác trước: "Ngỡ là y ước sở cầu, Ai ngờ biến cải ra màu bạc đen." (NTT)',
    example: 'Ngỡ là y ước sở cầu, Ai ngờ biến cải ra màu bạc đen." (NTT)',
  },
  {
    word: "biên chế",
    part_of_speech: "động từ",
    meaning:
      "sắp xếp lực lượng theo một trật tự tổ chức nhất định: biên chế đội ngũ",
    example: "biên chế đội ngũ",
  },
  {
    word: "biên chế",
    part_of_speech: "danh từ",
    meaning:
      "cơ cấu của một tổ chức (của cơ quan nhà nước, hoặc đơn vị xí nghiệp, sự nghiệp), số lượng nhân viên, các chức danh, các mức lương, v.v. (nói tổng hợp): biên chế cồng kềnh * tinh giản biên chế",
    example: "biên chế cồng kềnh * tinh giản biên chế",
  },
  {
    word: "biên chế",
    part_of_speech: "danh từ",
    meaning: "số người trong biên chế: đưa vào biên chế * giảm biên chế",
    example: "đưa vào biên chế * giảm biên chế",
  },
  {
    word: "biền biệt",
    part_of_speech: "tính từ",
    meaning:
      '(đi, vắng) rất lâu mà không có tin tức gì: đi biền biệt không về * "Cụ chỉ biết buồn và giận, bởi con cụ quanh năm cứ biền biệt phương xa." (LKhai; 1)',
    example:
      'đi biền biệt không về * "Cụ chỉ biết buồn và giận, bởi con cụ quanh năm cứ biền biệt phương xa." (LKhai; 1)',
  },
  {
    word: "biến chất",
    part_of_speech: "động từ",
    meaning:
      "biến đổi về chất, không còn giữ được tính chất, phẩm chất ban đầu: rượu đã biến chất * một cán bộ thoái hoá, biến chất",
    example: "rượu đã biến chất * một cán bộ thoái hoá, biến chất",
  },
  {
    word: "biện chứng",
    part_of_speech: "tính từ",
    meaning:
      "hợp với quy luật vận động và phát triển khách quan của sự vật: sự phát triển biện chứng",
    example: "sự phát triển biện chứng",
  },
  {
    word: "biện chứng",
    part_of_speech: "tính từ",
    meaning:
      "hợp với phép biện chứng, dựa trên phép biện chứng: lập luận hết sức biện chứng",
    example: "lập luận hết sức biện chứng",
  },
  {
    word: "biến chứng",
    part_of_speech: "danh từ",
    meaning:
      "chứng bệnh mới phát sinh thêm trong quá trình mắc bệnh, làm cho bệnh phức tạp và nặng hơn: biến chứng của bệnh giang mai",
    example: "biến chứng của bệnh giang mai",
  },
  {
    word: "biến chứng",
    part_of_speech: "động từ",
    meaning:
      "gây ra chứng bệnh mới, làm cho bệnh nặng hơn: bệnh thấp khớp đã biến chứng vào tim",
    example: "bệnh thấp khớp đã biến chứng vào tim",
  },
  {
    word: "biến chuyển",
    part_of_speech: "",
    meaning:
      "chuyển sang, thay đổi sang trạng thái khác trước: vạn vật biến chuyển * những biến chuyển của tình hình thế giới",
    example: "vạn vật biến chuyển * những biến chuyển của tình hình thế giới",
  },
  {
    word: "biến cố",
    part_of_speech: "danh từ",
    meaning: "sự việc xảy ra có tác động lớn đến đời sống: gặp biến cố",
    example: "gặp biến cố",
  },
  {
    word: "biên dịch",
    part_of_speech: "động từ",
    meaning: "dịch (văn bản, sách): biên dịch sách * công tác biên dịch",
    example: "biên dịch sách * công tác biên dịch",
  },
  {
    word: "biến dị",
    part_of_speech: "",
    meaning:
      "(hiện tượng) thay đổi ít nhiều về hình dạng, cấu tạo, đặc tính sinh học ở cá thể sinh vật, do ảnh hưởng của các đột biến di truyền hoặc của môi trường khác nhau: những hiện tượng biến dị của di truyền",
    example: "những hiện tượng biến dị của di truyền",
  },
  {
    word: "biến dạng",
    part_of_speech: "động từ",
    meaning:
      "biến đổi về hình dạng: cái vung bị biến dạng * thi thể trong đám cháy đã bị biến dạng",
    example: "cái vung bị biến dạng * thi thể trong đám cháy đã bị biến dạng",
  },
  {
    word: "biến dạng",
    part_of_speech: "danh từ",
    meaning:
      "dạng đã biến đổi ít nhiều so với dạng gốc: hát phường vải là một biến dạng của hát nói",
    example: "hát phường vải là một biến dạng của hát nói",
  },
  {
    word: "biên đình",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) vùng biên giới hoặc sát biên giới: "Lần thâu gió mát, trăng thanh, Bỗng đâu có khách biên đình sang chơi." (TKiều)',
    example:
      'Lần thâu gió mát, trăng thanh, Bỗng đâu có khách biên đình sang chơi." (TKiều)',
  },
  {
    word: "biên đạo",
    part_of_speech: "động từ",
    meaning:
      "sáng tác và đạo diễn múa: nhà biên đạo múa * biên đạo vở ba lê mới",
    example: "nhà biên đạo múa * biên đạo vở ba lê mới",
  },
  {
    word: "biến đổi",
    part_of_speech: "động từ",
    meaning:
      "thay đổi hoặc làm cho thay đổi thành khác trước: biến đổi sắc mặt * biến đổi tính cách * quang cảnh biến đổi nhiều",
    example:
      "biến đổi sắc mặt * biến đổi tính cách * quang cảnh biến đổi nhiều",
  },
  {
    word: "biến đổi",
    part_of_speech: "danh từ",
    meaning:
      "sự thay đổi, điều thay đổi khác với trước: xã hội có nhiều biến đổi lớn",
    example: "xã hội có nhiều biến đổi lớn",
  },
  {
    word: "biến dịch",
    part_of_speech: "động từ",
    meaning:
      "đổi khác dần dần theo thời gian: sự biến dịch của thời tiết lúc giao mùa",
    example: "sự biến dịch của thời tiết lúc giao mùa",
  },
  {
    word: "biến động",
    part_of_speech: "động từ",
    meaning:
      "ở trong trạng thái đang có những thay đổi lớn: giá cả biến động trong những ngày giáp Tết * sự vật luôn luôn biến động",
    example:
      "giá cả biến động trong những ngày giáp Tết * sự vật luôn luôn biến động",
  },
  {
    word: "biến động",
    part_of_speech: "danh từ",
    meaning:
      "sự thay đổi, sự không ổn định: những biến động của thời tiết * xã hội có nhiều biến động",
    example: "những biến động của thời tiết * xã hội có nhiều biến động",
  },
  {
    word: "biên độ",
    part_of_speech: "danh từ",
    meaning:
      "trị số lớn nhất mà một đại lượng biến thiên tuần hoàn có thể đạt trong một nửa chu kì: biên độ dao động của quả lắc * biên độ của sóng",
    example: "biên độ dao động của quả lắc * biên độ của sóng",
  },
  {
    word: "biên giới",
    part_of_speech: "danh từ",
    meaning:
      "nơi hết phần đất của một nước và giáp với nước khác: biên giới Việt - Trung * đường biên giới",
    example: "biên giới Việt - Trung * đường biên giới",
  },
  {
    word: "biến hình",
    part_of_speech: "tính từ",
    meaning: "có thể thay đổi hình thái: các ngôn ngữ biến hình",
    example: "các ngôn ngữ biến hình",
  },
  {
    word: "biển hiệu",
    part_of_speech: "danh từ",
    meaning:
      "biển đề tên cửa hàng hoặc cơ sở kinh doanh và một số thông tin riêng khác (như địa chỉ, số điện thoại) để tiện cho việc giao dịch, kinh doanh, quảng cáo nói chung: treo biển hiệu",
    example: "treo biển hiệu",
  },
  {
    word: "biện giải",
    part_of_speech: "động từ",
    meaning: "giải thích rõ ràng bằng lí lẽ: biện giải cho hành động của mình",
    example: "biện giải cho hành động của mình",
  },
  {
    word: "biên khảo",
    part_of_speech: "động từ",
    meaning: "(Ít dùng) khảo cứu và biên soạn: biên khảo Truyện Kiều",
    example: "biên khảo Truyện Kiều",
  },
  {
    word: "biến hoá",
    part_of_speech: "động từ",
    meaning:
      "biến đổi thành ra cái khác, hoặc sang trạng thái, hình thức khác: có phép biến hoá * sự biến hoá khôn lường",
    example: "có phép biến hoá * sự biến hoá khôn lường",
  },
  {
    word: "biện hộ",
    part_of_speech: "động từ",
    meaning: "như bào chữa: luật sư biện hộ cho bị cáo * tự biện hộ cho mình",
    example: "luật sư biện hộ cho bị cáo * tự biện hộ cho mình",
  },
  {
    word: "biện hộ",
    part_of_speech: "động từ",
    meaning:
      "nêu lí lẽ hoặc chứng cứ nhằm chứng minh một kiến giải hay hành vi nào đó là đúng đắn, và nếu có sai lầm thì mức độ không nghiêm trọng (để bảo vệ người nào đó hoặc tự bảo vệ): viện đủ lí do biện hộ cho lỗi lầm",
    example: "viện đủ lí do biện hộ cho lỗi lầm",
  },
  {
    word: "biển lận",
    part_of_speech: "tính từ",
    meaning: "(hiếm) gian tham và keo kiệt: thói biển lận",
    example: "thói biển lận",
  },
  {
    word: "biển hồ",
    part_of_speech: "danh từ",
    meaning:
      "biển không được nối liền với các biển khác, tựa như một hồ rất lớn: biển Aral ở Tây á là một biển hồ",
    example: "biển Aral ở Tây á là một biển hồ",
  },
  {
    word: "biên lai",
    part_of_speech: "danh từ",
    meaning:
      "giấy theo mẫu in sẵn, ghi đã nhận tiền hoặc vật gì, trao lại làm bằng cho người nộp hoặc gửi: biên lai thu tiền điện * nộp tiền có nhận biên lai",
    example: "biên lai thu tiền điện * nộp tiền có nhận biên lai",
  },
  {
    word: "biện luận",
    part_of_speech: "động từ",
    meaning: "đưa ra lí lẽ để tranh luận phải trái: biện luận để phản bác",
    example: "biện luận để phản bác",
  },
  {
    word: "biến loạn",
    part_of_speech: "danh từ",
    meaning:
      "tình trạng trật tự xã hội rối loạn, do chiến tranh hoặc giặc giã: đất nước xảy ra biến loạn",
    example: "đất nước xảy ra biến loạn",
  },
  {
    word: "biện minh",
    part_of_speech: "động từ",
    meaning: "trình bày làm cho rõ ràng: biện minh cho hành động của mình",
    example: "biện minh cho hành động của mình",
  },
  {
    word: "biền ngẫu",
    part_of_speech: "tính từ",
    meaning:
      "(thể văn) có song song những cặp câu có hai hoặc nhiều vế đối nhau (như câu đối, phú và văn tế): văn biền ngẫu",
    example: "văn biền ngẫu",
  },
  {
    word: "biên nhận",
    part_of_speech: "động từ",
    meaning:
      "ghi và kí xác nhận đã nhận tiền hoặc vật gì: giấy biên nhận * kí biên nhận vào sổ bàn giao",
    example: "giấy biên nhận * kí biên nhận vào sổ bàn giao",
  },
  {
    word: "biên niên",
    part_of_speech: "tính từ",
    meaning:
      "(cũ) theo thứ tự thời gian từng năm một mà ghi các sự kiện lịch sử: chép sử theo lối biên niên * bộ sử biên niên",
    example: "chép sử theo lối biên niên * bộ sử biên niên",
  },
  {
    word: "biến sắc",
    part_of_speech: "động từ",
    meaning:
      "thay đổi sắc mặt, thường tái đi, một cách đột ngột (vì quá sợ hãi, quá đau buồn hay quá tức giận): chột dạ, mặt hơi biến sắc",
    example: "chột dạ, mặt hơi biến sắc",
  },
  {
    word: "biên soạn",
    part_of_speech: "động từ",
    meaning:
      "thu thập, chọn lọc tài liệu, nghiên cứu viết thành sách: biên soạn giáo trình * biên soạn từ điển",
    example: "biên soạn giáo trình * biên soạn từ điển",
  },
  {
    word: "biên tập",
    part_of_speech: "động từ",
    meaning:
      "biên soạn (công trình tương đối lớn): ban biên tập bộ sử Việt Nam",
    example: "ban biên tập bộ sử Việt Nam",
  },
  {
    word: "biên tập",
    part_of_speech: "động từ",
    meaning:
      "kiểm tra các sai sót, chỉnh lí (tài liệu, công trình đã có bản thảo), góp ý kiến với tác giả, hoàn thành về nội dung để sẵn sàng đưa xuất bản: biên tập bài vở * công tác biên tập * ban biên tập của toà soạn",
    example: "biên tập bài vở * công tác biên tập * ban biên tập của toà soạn",
  },
  {
    word: "biên phòng",
    part_of_speech: "động từ",
    meaning: "canh phòng nơi biên giới: đồn biên phòng * bộ đội biên phòng",
    example: "đồn biên phòng * bộ đội biên phòng",
  },
  {
    word: "biện pháp",
    part_of_speech: "danh từ",
    meaning:
      "cách thức xử lí công việc hoặc giải quyết vấn đề: áp dụng biện pháp kỉ luật * tìm biện pháp giải quyết",
    example: "áp dụng biện pháp kỉ luật * tìm biện pháp giải quyết",
  },
  {
    word: "biến thế",
    part_of_speech: "động từ",
    meaning: "đổi hiệu thế của một dòng điện xoay chiều: trạm biến thế",
    example: "trạm biến thế",
  },
  {
    word: "biến thế",
    part_of_speech: "danh từ",
    meaning:
      "khí cụ đổi một dòng điện xoay chiều thành một dòng điện xoay chiều cùng tần số nhưng khác hiệu thế: mua thêm biến thế * sản xuất biến thế điện",
    example: "mua thêm biến thế * sản xuất biến thế điện",
  },
  {
    word: "biến tấu",
    part_of_speech: "động từ",
    meaning:
      "nhắc đi nhắc lại giai điệu chủ đề bằng cách phát triển để làm phong phú thêm hình tượng âm nhạc: khúc biến tấu",
    example: "khúc biến tấu",
  },
  {
    word: "biến thiên",
    part_of_speech: "động từ",
    meaning: "(các biến trong toán học) thay đổi giá trị: hàm số biến thiên",
    example: "hàm số biến thiên",
  },
  {
    word: "biến thiên",
    part_of_speech: "động từ",
    meaning:
      '(cũ) sự biến đổi tương đối lớn, diễn ra từng bước: chứng kiến bao biến thiên trong lịch sử * "Khách du buồn nỗi buồn sông núi, Núi lở sông bồi cảnh biến thiên." (NgBính; 16)',
    example:
      'chứng kiến bao biến thiên trong lịch sử * "Khách du buồn nỗi buồn sông núi, Núi lở sông bồi cảnh biến thiên." (NgBính; 16)',
  },
  {
    word: "biến thái",
    part_of_speech: "danh từ",
    meaning:
      "sự biến đổi rõ rệt về hình dạng và cấu tạo của một số động vật qua từng giai đoạn, từ ấu trùng tới lúc trưởng thành: biến thái của sâu bọ",
    example: "biến thái của sâu bọ",
  },
  {
    word: "biến thể",
    part_of_speech: "danh từ",
    meaning:
      "thể có khác ít nhiều so với thể gốc: câu thơ lục bát biến thể (câu trên 6 chữ; câu dưới nhiều hơn 8 chữ) *  là biến thể ngữ âm của",
    example:
      "câu thơ lục bát biến thể (câu trên 6 chữ; câu dưới nhiều hơn 8 chữ) *  là biến thể ngữ âm của",
  },
  {
    word: "biên tập viên",
    part_of_speech: "danh từ",
    meaning: "người làm công tác biên tập: biên tập viên nhà xuất bản",
    example: "biên tập viên nhà xuất bản",
  },
  {
    word: "biên tập viên",
    part_of_speech: "danh từ",
    meaning:
      "người thu thập, chọn lọc tin tức, tài liệu, soạn thành bài để phát thanh: biên tập viên của đài truyền hình",
    example: "biên tập viên của đài truyền hình",
  },
  {
    word: "biên thuỳ",
    part_of_speech: "danh từ",
    meaning:
      '(Từ cũ, Văn chương) biên giới: "Nghênh ngang một cõi biên thuỳ, Thiếu gì cô quả, thiếu gì bá vương!" (TKiều)',
    example:
      'Nghênh ngang một cõi biên thuỳ, Thiếu gì cô quả, thiếu gì bá vương!" (TKiều)',
  },
  {
    word: "biển thủ",
    part_of_speech: "động từ",
    meaning:
      "dùng thủ đoạn gian trá rút lấy tiền (thường là tiền công quỹ) mà mình có trách nhiệm quản lí: biển thủ công quỹ",
    example: "biển thủ công quỹ",
  },
  {
    word: "biến tướng",
    part_of_speech: "tính từ",
    meaning:
      "có hình thức được đổi khác, che giấu nội dung không thay đổi: một tổ chức phản động biến tướng",
    example: "một tổ chức phản động biến tướng",
  },
  {
    word: "biến tướng",
    part_of_speech: "danh từ",
    meaning: "hình thái biến tướng: biến tướng của chủ nghĩa thực dân",
    example: "biến tướng của chủ nghĩa thực dân",
  },
  {
    word: "biếng nhác",
    part_of_speech: "tính từ",
    meaning: "biếng (nói khát quát): người mệt mỏi nên biếng nhác công việc",
    example: "người mệt mỏi nên biếng nhác công việc",
  },
  {
    word: "biếng",
    part_of_speech: "tính từ",
    meaning:
      'ở trong trạng thái không thiết làm (việc gì đó), do mệt mỏi về thể xác hoặc tinh thần: trẻ biếng ăn * "Nhớ ai ra đứng đầu cầu, Lược thưa biếng chải, gương tàu biếng soi." (ca dao)',
    example:
      'trẻ biếng ăn * "Nhớ ai ra đứng đầu cầu, Lược thưa biếng chải, gương tàu biếng soi." (ca dao)',
  },
  {
    word: "biếng",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ, hiếm) lười: biếng làm việc nhà",
    example: "biếng làm việc nhà",
  },
  {
    word: "biết",
    part_of_speech: "động từ",
    meaning:
      "có ý niệm về người, vật hoặc điều gì đó, để có thể nhận ra được hoặc có thể khẳng định được sự tồn tại của người, vật hoặc điều ấy: biết mặt, nhưng không biết tên * ăn không biết ngon * muốn biết phải hỏi, muốn giỏi phải học (tng)",
    example:
      "biết mặt, nhưng không biết tên * ăn không biết ngon * muốn biết phải hỏi, muốn giỏi phải học (tng)",
  },
  {
    word: "biết",
    part_of_speech: "động từ",
    meaning:
      "có khả năng làm được, vận dụng được do học tập, luyện tập hoặc do bản năng: biết bơi * trẻ đã biết bò * chưa biết chữ * biết cách ăn ở, đối xử",
    example:
      "biết bơi * trẻ đã biết bò * chưa biết chữ * biết cách ăn ở, đối xử",
  },
  {
    word: "biết",
    part_of_speech: "động từ",
    meaning:
      "nhận rõ được thực chất hoặc giá trị để có được sự đối xử thoả đáng: biết người biết ta * đường dài mới biết ngựa hay (tng)",
    example: "biết người biết ta * đường dài mới biết ngựa hay (tng)",
  },
  {
    word: "biệt",
    part_of_speech: "tính từ",
    meaning:
      'không để lại dấu vết hoặc tin tức gì cả: biệt tin nhau * giấu biệt đi * "Nhưng rồi người khách tình quân ấy, Đi biệt không về với núi sông." (NgBính; 5)',
    example:
      'biệt tin nhau * giấu biệt đi * "Nhưng rồi người khách tình quân ấy, Đi biệt không về với núi sông." (NgBính; 5)',
  },
  {
    word: "biêng biếc",
    part_of_speech: "tính từ",
    meaning: "như biếc (nhưng ở mức độ cao): xanh biêng biếc",
    example: "xanh biêng biếc",
  },
  {
    word: "biến tốc",
    part_of_speech: "động từ",
    meaning: "làm thay đổi tốc độ: hộp biến tốc",
    example: "hộp biến tốc",
  },
  {
    word: "biết chừng nào",
    part_of_speech: "phụ từ",
    meaning:
      'tổ hợp biểu thị một mức độ nghĩ là cao lắm: đau xót biết chừng nào! * "Rượu với thịt chó mà lại gặp khí trời mát thì ngon biết chừng nào là ngon!" (NCao; 30)',
    example:
      'đau xót biết chừng nào! * "Rượu với thịt chó mà lại gặp khí trời mát thì ngon biết chừng nào là ngon!" (NCao; 30)',
  },
  {
    word: "biết bao nhiêu",
    part_of_speech: "phụ từ",
    meaning:
      'tổ hợp biểu thị một số lượng hoặc mức độ không biết chính xác, nhưng nghĩ là nhiều lắm, cao lắm: hạnh phúc biết bao! * "Biết bao bướm lả ong lơi, Cuộc say đầy tháng, trận cười suốt đêm." (TKiều)',
    example:
      'hạnh phúc biết bao! * "Biết bao bướm lả ong lơi, Cuộc say đầy tháng, trận cười suốt đêm." (TKiều)',
  },
  {
    word: "biết bao",
    part_of_speech: "phụ từ",
    meaning:
      'tổ hợp biểu thị một số lượng hoặc mức độ không biết chính xác, nhưng nghĩ là nhiều lắm, cao lắm: hạnh phúc biết bao! * "Biết bao bướm lả ong lơi, Cuộc say đầy tháng, trận cười suốt đêm." (TKiều)',
    example:
      'hạnh phúc biết bao! * "Biết bao bướm lả ong lơi, Cuộc say đầy tháng, trận cười suốt đêm." (TKiều)',
  },
  {
    word: "biết đâu chừng",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ, hiếm) như biết đâu (nhưng có phần ít dè dặt hơn): nắng thế thôi, biết đâu chừng chiều lại mưa",
    example: "nắng thế thôi, biết đâu chừng chiều lại mưa",
  },
  {
    word: "biết đâu",
    part_of_speech: "phụ từ",
    meaning:
      "tổ hợp biểu thị ý phỏng đoán một cách rất dè dặt, như muốn đưa ra trao đổi thêm, chứ chưa dám khẳng định dứt khoát: cứ đi thử xem, biết đâu lại được việc * biết đâu mai trời lại nắng",
    example:
      "cứ đi thử xem, biết đâu lại được việc * biết đâu mai trời lại nắng",
  },
  {
    word: "biệt động",
    part_of_speech: "tính từ",
    meaning:
      "(lực lượng quân sự) cơ động, tổ chức và trang bị gọn nhẹ, có thể độc lập tác chiến để làm những nhiệm vụ đặc biệt: lính biệt động * chiến sĩ biệt động",
    example: "lính biệt động * chiến sĩ biệt động",
  },
  {
    word: "biết đâu đấy",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị ý như muốn đặt lại vấn đề tỏ ý hoài nghi, không tin vào một điều trước đó (hay ai đó) đã phỏng đoán, khẳng định: (- đời nào nó chịu?) - biết đâu đấy! * (- có thể cô ta không đến) - biết đâu đấy!",
    example:
      "(- đời nào nó chịu?) - biết đâu đấy! * (- có thể cô ta không đến) - biết đâu đấy!",
  },
  {
    word: "biết đâu đấy",
    part_of_speech: "",
    meaning:
      'tổ hợp biểu thị ý muốn thanh minh cho hành động sai lầm của mình, là do vô tình chứ không cố ý: "Đẻ bảo tôi thế thì tôi cứ thế, chứ tôi biết đâu đấy?" (VTrPhụng; 13)',
    example:
      'Đẻ bảo tôi thế thì tôi cứ thế, chứ tôi biết đâu đấy?" (VTrPhụng; 13)',
  },
  {
    word: "biệt đãi",
    part_of_speech: "động từ",
    meaning:
      "đối xử đặc biệt, biểu thị thái độ rất coi trọng: biệt đãi khách quý",
    example: "biệt đãi khách quý",
  },
  {
    word: "biết điều",
    part_of_speech: "tính từ",
    meaning: "biết lẽ phải trái, biết đối xử đúng mực: tỏ ra rất biết điều",
    example: "tỏ ra rất biết điều",
  },
  {
    word: "biệt lập",
    part_of_speech: "động từ",
    meaning:
      "tách riêng ra một mình: sống biệt lập * ngôi nhà biệt lập ở bìa rừng",
    example: "sống biệt lập * ngôi nhà biệt lập ở bìa rừng",
  },
  {
    word: "biệt hiệu",
    part_of_speech: "danh từ",
    meaning: "như tên hiệu: Lê Hữu Trác, biệt hiệu là Hải Thượng Lãn Ông",
    example: "Lê Hữu Trác, biệt hiệu là Hải Thượng Lãn Ông",
  },
  {
    word: "biệt hiệu",
    part_of_speech: "danh từ",
    meaning:
      '(khẩu ngữ) tên gọi có tính chất vui đùa, được đặt thêm cho một người nào đó (thường là một từ ngữ nôm na, nêu một đặc điểm đáng chú ý): "Bà tôi đã đặt cho dượng tôi cái biệt hiệu  *  nghĩa là chỉ ton hót giỏi (...)" (MPTư; 1)',
    example:
      'Bà tôi đã đặt cho dượng tôi cái biệt hiệu  *  nghĩa là chỉ ton hót giỏi (...)" (MPTư; 1)',
  },
  {
    word: "biệt li",
    part_of_speech: "động từ",
    meaning:
      '(văn chương) xa cách nhau, không được chung sống với nhau trong một thời gian tương đối dài: cảnh biệt li * "Biết bao nhiêu nỗi phong trần, Mưa hằng tuôn luỵ mấy lần biệt li." (ca dao)',
    example:
      'cảnh biệt li * "Biết bao nhiêu nỗi phong trần, Mưa hằng tuôn luỵ mấy lần biệt li." (ca dao)',
  },
  {
    word: "mì",
    part_of_speech: "danh từ",
    meaning: "lúa mì (nói tắt): bột mì",
    example: "bột mì",
  },
  {
    word: "mì",
    part_of_speech: "danh từ",
    meaning:
      "thức ăn làm bằng bột mì cán thành sợi hoặc bột gạo tráng mỏng cắt thành sợi: mì xào * mì sợi",
    example: "mì xào * mì sợi",
  },
  {
    word: "mì",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ) sắn: thu hoạch mì",
    example: "thu hoạch mì",
  },
  {
    word: "mi",
    part_of_speech: "danh từ",
    meaning:
      "màng da mỏng bảo vệ mắt, khép mở được: mi mắt khép hờ * khóc nhiều, mi mắt sưng húp",
    example: "mi mắt khép hờ * khóc nhiều, mi mắt sưng húp",
  },
  {
    word: "mi",
    part_of_speech: "danh từ",
    meaning: "lông mi (nói tắt): hàng mi dài cong vút",
    example: "hàng mi dài cong vút",
  },
  {
    word: "mi",
    part_of_speech: "đại từ",
    meaning:
      '(Phương ngữ) mày: "Muốn ăn mà chẳng muốn mần, Cha mi lại bỏ cái bần cho mi." (Cdao)',
    example: 'Muốn ăn mà chẳng muốn mần, Cha mi lại bỏ cái bần cho mi." (Cdao)',
  },
  {
    word: "mị dân",
    part_of_speech: "động từ",
    meaning:
      "phỉnh nịnh dân, phỉnh nịnh quần chúng để củng cố địa vị, thu lợi cho mình: thủ đoạn mị dân * chính sách mị dân",
    example: "thủ đoạn mị dân * chính sách mị dân",
  },
  {
    word: "mĩ dục",
    part_of_speech: "",
    meaning:
      "giáo dục khả năng nhận thức, thưởng thức và thể hiện cái đẹp: công tác mĩ dục",
    example: "công tác mĩ dục",
  },
  {
    word: "mĩ cảm",
    part_of_speech: "danh từ",
    meaning:
      "khả năng hiểu biết và cảm nhận về cái đẹp: mỗi người có một mĩ cảm khác nhau",
    example: "mỗi người có một mĩ cảm khác nhau",
  },
  {
    word: "mí",
    part_of_speech: "danh từ",
    meaning: "nếp gấp của mi mắt: mắt một mí",
    example: "mắt một mí",
  },
  {
    word: "mí",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ) rìa, mép ngoài cùng: mí vườn * đứng sát mí nước",
    example: "mí vườn * đứng sát mí nước",
  },
  {
    word: "mĩ học",
    part_of_speech: "danh từ",
    meaning:
      "khoa học nghiên cứu về cái đẹp và những hình thức, phương pháp phản ánh và sáng tạo cái đẹp trong nghệ thuật: nhà mĩ học * bộ môn mĩ học",
    example: "nhà mĩ học * bộ môn mĩ học",
  },
  {
    word: "mĩ kí",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) (đồ trang sức bằng vàng bạc) giả: gian hàng mĩ kí * nhẫn mĩ kí",
    example: "gian hàng mĩ kí * nhẫn mĩ kí",
  },
  {
    word: "mĩ lệ",
    part_of_speech: "tính từ",
    meaning:
      "(văn chương) đẹp một cách trang trọng (thường nói về cảnh vật): cung điện nguy nga, mĩ lệ",
    example: "cung điện nguy nga, mĩ lệ",
  },
  {
    word: "mĩ nghệ",
    part_of_speech: "danh từ",
    meaning:
      "nghề thủ công chuyên làm đồ trang sức, trang trí: hàng mĩ nghệ * đá mĩ nghệ",
    example: "hàng mĩ nghệ * đá mĩ nghệ",
  },
  {
    word: "mĩ nhân",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) người đàn bà đẹp: "Mĩ nhân lững thững thăm hoa rụng, Trâm ngọc quên cài tóc bỏ lơi." (ThCan; 2)',
    example:
      'Mĩ nhân lững thững thăm hoa rụng, Trâm ngọc quên cài tóc bỏ lơi." (ThCan; 2)',
  },
  {
    word: "mĩ phẩm",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi chung các chế phẩm dùng để trang điểm, để làm tăng sắc đẹp (như phấn, son, nước hoa, v.v.): chọn mua mĩ phẩm * cửa hàng mĩ phẩm",
    example: "chọn mua mĩ phẩm * cửa hàng mĩ phẩm",
  },
  {
    word: "mĩ mãn",
    part_of_speech: "tính từ",
    meaning:
      "tốt đẹp tới mức hài lòng nhất, hoàn toàn như mong muốn: đẹp mĩ mãn * buổi biểu diễn thành công mĩ mãn",
    example: "đẹp mĩ mãn * buổi biểu diễn thành công mĩ mãn",
  },
  {
    word: "mĩ nữ",
    part_of_speech: "danh từ",
    meaning: "(cũ, văn chương) người con gái đẹp: cung tần, mĩ nữ",
    example: "cung tần, mĩ nữ",
  },
  {
    word: "mĩ miều",
    part_of_speech: "tính từ",
    meaning:
      "đẹp một cách hào nhoáng, gây được ấn tượng mạnh (nhưng thường về hình thức bên ngoài): người con gái có vẻ đẹp mĩ miều * có một cái tên khá mĩ miều",
    example: "người con gái có vẻ đẹp mĩ miều * có một cái tên khá mĩ miều",
  },
  {
    word: "mĩ quan",
    part_of_speech: "danh từ",
    meaning:
      "vẻ đẹp trông thấy rõ ở bề ngoài, ở cách trang trí, sắp đặt: giữ gìn mĩ quan đô thị",
    example: "giữ gìn mĩ quan đô thị",
  },
  {
    word: "mĩ thuật",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) đẹp, khéo, hợp với thẩm mĩ: cách bày biện trang trí rất mĩ thuật",
    example: "cách bày biện trang trí rất mĩ thuật",
  },
  {
    word: "mĩ tục",
    part_of_speech: "danh từ",
    meaning: "tục lệ tốt đẹp: gìn giữ những mĩ tục của làng xã",
    example: "gìn giữ những mĩ tục của làng xã",
  },
  {
    word: "mĩ viện",
    part_of_speech: "danh từ",
    meaning:
      "nơi chuyên chăm sóc, làm tăng sắc đẹp (bằng xoa bóp, tiểu phẫu thuật, v.v.): đi mĩ viện",
    example: "đi mĩ viện",
  },
  {
    word: "mi-crô",
    part_of_speech: "danh từ",
    meaning:
      "thiết bị dùng thu âm hoặc làm giọng nói hoặc giọng hát nghe lớn hơn",
    example: "",
  },
  {
    word: "mi-ni",
    part_of_speech: "tính từ",
    meaning: "(kiểu, loại) nhỏ, bé: xe đạp mini * đồ chơi mini * từ điển mini",
    example: "xe đạp mini * đồ chơi mini * từ điển mini",
  },
  {
    word: "mỉa",
    part_of_speech: "động từ",
    meaning:
      'giễu cợt bằng cách nói cạnh khoé hoặc nói ngược lại điều ai cũng thấy rõ: câu nói mỉa * "Hồ sầu lại gượng làm tươi, Nữa mai nguyệt mỉa, huê cười không hay." (ca dao)',
    example:
      'câu nói mỉa * "Hồ sầu lại gượng làm tươi, Nữa mai nguyệt mỉa, huê cười không hay." (ca dao)',
  },
  {
    word: "mía",
    part_of_speech: "danh từ",
    meaning:
      "cây trồng thuộc họ lúa, thân đặc có đốt, chứa chất đường, dùng để ăn, kéo mật hoặc làm đường: mía sâu có đốt, nhà dột có nơi (tng)",
    example: "mía sâu có đốt, nhà dột có nơi (tng)",
  },
  {
    word: "mỉa móc",
    part_of_speech: "động từ",
    meaning:
      "moi móc những điều không hay của người khác ra để mỉa mai, giễu cợt, nhằm hạ nhục: làm gì mà mỉa móc nhau thế?",
    example: "làm gì mà mỉa móc nhau thế?",
  },
  {
    word: "micro",
    part_of_speech: "danh từ",
    meaning:
      "thiết bị dùng thu âm hoặc làm giọng nói hoặc giọng hát nghe lớn hơn",
    example: "",
  },
  {
    word: "miễn",
    part_of_speech: "động từ",
    meaning:
      "cho khỏi phải chịu, khỏi phải làm việc gì: miễn thuế * miễn không phải đóng học phí * miễn đi nghĩa vụ quân sự",
    example:
      "miễn thuế * miễn không phải đóng học phí * miễn đi nghĩa vụ quân sự",
  },
  {
    word: "miễn",
    part_of_speech: "động từ",
    meaning:
      "hoặc p từ biểu thị ý yêu cầu một cách lịch sự đừng làm việc gì đó: không phận sự miễn vào * miễn hỏi * miễn tham gia",
    example: "không phận sự miễn vào * miễn hỏi * miễn tham gia",
  },
  {
    word: "miễn",
    part_of_speech: "kết từ",
    meaning:
      "(Khẩu ngữ) chỉ cần là, cốt là: ít nhiều không quan trọng, miễn có là được",
    example: "ít nhiều không quan trọng, miễn có là được",
  },
  {
    word: "mỉa mai",
    part_of_speech: "động từ",
    meaning:
      'mỉa bằng cách nói ngược lại với ý mà mình muốn cho người ta hiểu: giọng mỉa mai * "Canh cải mà nấu với gừng, Không ăn thời chớ xin đừng mỉa mai." (ca dao)',
    example:
      'giọng mỉa mai * "Canh cải mà nấu với gừng, Không ăn thời chớ xin đừng mỉa mai." (ca dao)',
  },
  {
    word: "mỉa mai",
    part_of_speech: "tính từ",
    meaning:
      "trái ngược một cách đáng buồn với điều người ta nghĩ: thật là nực cười, thật là mỉa mai",
    example: "thật là nực cười, thật là mỉa mai",
  },
  {
    word: "miễn là",
    part_of_speech: "kết từ",
    meaning: "chỉ cần là: làm lúc nào thì làm, miễn là ngày mai phải xong",
    example: "làm lúc nào thì làm, miễn là ngày mai phải xong",
  },
  {
    word: "miến",
    part_of_speech: "danh từ",
    meaning:
      "thức ăn làm bằng tinh bột, chế biến thành sợi dài, nhỏ và khô, nấu chín có màu trong và dai: miến xào lòng gà * miến cua",
    example: "miến xào lòng gà * miến cua",
  },
  {
    word: "miễn cưỡng",
    part_of_speech: "động từ",
    meaning:
      "có vẻ không vừa lòng khi buộc phải làm việc mình không muốn: thái độ miễn cưỡng * nhận lời một cách miễn cưỡng",
    example: "thái độ miễn cưỡng * nhận lời một cách miễn cưỡng",
  },
  {
    word: "miễn giảm",
    part_of_speech: "động từ",
    meaning: "giảm một phần hoặc toàn bộ: miễn giảm thuế * miễn giảm học phí",
    example: "miễn giảm thuế * miễn giảm học phí",
  },
  {
    word: "miền",
    part_of_speech: "danh từ",
    meaning:
      "khu vực đất đai rộng lớn giống nhau về cảnh quan địa lí hoặc cùng thuộc về một phương hướng nhất định: dân miền biển * miền núi tiến kịp miền xuôi * quê ở miền Nam",
    example: "dân miền biển * miền núi tiến kịp miền xuôi * quê ở miền Nam",
  },
  {
    word: "miền",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) miền Nam Việt Nam (nói tắt; dùng trong thời kì Kháng chiến chống Mĩ): bộ đội chủ lực miền * tiến công và nổi dậy khắp toàn miền",
    example: "bộ đội chủ lực miền * tiến công và nổi dậy khắp toàn miền",
  },
  {
    word: "miễn chấp",
    part_of_speech: "động từ",
    meaning:
      "(cũ, hiếm) đừng trách móc, đừng cố chấp (dùng trong lời xin lỗi): ở đây thiếu thốn nhiều, xin cụ miễn chấp cho!",
    example: "ở đây thiếu thốn nhiều, xin cụ miễn chấp cho!",
  },
  {
    word: "miễn dịch",
    part_of_speech: "động từ",
    meaning:
      "(trạng thái của cơ thể) chống lại được sự xâm nhập của một căn bệnh nào đó: tăng cường khả năng miễn dịch của cơ thể",
    example: "tăng cường khả năng miễn dịch của cơ thể",
  },
  {
    word: "miên man",
    part_of_speech: "tính từ",
    meaning:
      "hết cái này sang cái khác, tiếp liền theo nhau không dứt: suy nghĩ miên man * sóng vỗ miên man",
    example: "suy nghĩ miên man * sóng vỗ miên man",
  },
  {
    word: "miền ngược",
    part_of_speech: "danh từ",
    meaning:
      "vùng ở nơi rừng núi, phía phải đi ngược dòng sông mới đến; phân biệt với miền xuôi: tàu từ miền ngược về",
    example: "tàu từ miền ngược về",
  },
  {
    word: "miễn tố",
    part_of_speech: "động từ",
    meaning:
      "miễn truy tố trước toà án: ở một số nước, tổng thống được hưởng quyền miễn tố",
    example: "ở một số nước, tổng thống được hưởng quyền miễn tố",
  },
  {
    word: "miễn nhiệm",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) cho thôi giữ một chức vụ nào đó (thường là chức vụ cao trong bộ máy nhà nước): miễn nhiệm chức tổng giám đốc",
    example: "miễn nhiệm chức tổng giám đốc",
  },
  {
    word: "miễn phí",
    part_of_speech: "động từ",
    meaning:
      "cho khỏi phải nộp tiền phí tổn: trẻ em dưới 6 tuổi được khám chữa bệnh miễn phí",
    example: "trẻ em dưới 6 tuổi được khám chữa bệnh miễn phí",
  },
  {
    word: "miễn sao",
    part_of_speech: "kết từ",
    meaning:
      'chỉ cần (là được): "Anh đây cũng chẳng tiếc công, Miễn sao cho đặng tấm lòng em thương." (ca dao)',
    example:
      'Anh đây cũng chẳng tiếc công, Miễn sao cho đặng tấm lòng em thương." (ca dao)',
  },
  {
    word: "miễn trách",
    part_of_speech: "động từ",
    meaning:
      "bỏ qua cho (dùng trong lời xin lỗi một cách xã giao): tôi đã làm phiền ngài, mong ngài miễn trách cho!",
    example: "tôi đã làm phiền ngài, mong ngài miễn trách cho!",
  },
  {
    word: "miễn thứ",
    part_of_speech: "động từ",
    meaning:
      "tha lỗi cho (dùng trong lời xin lỗi một cách xã giao): có gì không phải, xin cụ miễn thứ cho!",
    example: "có gì không phải, xin cụ miễn thứ cho!",
  },
  {
    word: "miễn trừ",
    part_of_speech: "động từ",
    meaning:
      "miễn cho khỏi phải chấp hành (thường nói về những điều quy định theo pháp luật): miễn trừ thuế * miễn trừ nghĩa vụ dân sự",
    example: "miễn trừ thuế * miễn trừ nghĩa vụ dân sự",
  },
  {
    word: "miền xuôi",
    part_of_speech: "danh từ",
    meaning:
      "vùng ở đồng bằng, ven biển, phía phải đi cùng chiều với dòng chảy tự nhiên của sông mới đến; phân biệt với miền ngược: miền núi tiến kịp miền xuôi",
    example: "miền núi tiến kịp miền xuôi",
  },
  {
    word: "miểng",
    part_of_speech: "danh từ",
    meaning: "(Nam) mảnh vỡ: miểng chai * bị miểng bom phang trúng nhà",
    example: "miểng chai * bị miểng bom phang trúng nhà",
  },
  {
    word: "miệng lưỡi",
    part_of_speech: "danh từ",
    meaning:
      "miệng và lưỡi của con người; dùng để chỉ lối ăn nói thớ lợ, không thật thà: miệng lưỡi con buôn",
    example: "miệng lưỡi con buôn",
  },
  {
    word: "miệng lưỡi",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có tài ăn nói hoạt bát lém lỉnh: nó cũng là đứa rất miệng lưỡi",
    example: "nó cũng là đứa rất miệng lưỡi",
  },
  {
    word: "miệng",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận trên mặt người hay ở phần trước của đầu động vật, dùng để ăn, để nói, kêu, hót, v.v.; thường được coi là biểu tượng của việc ăn uống hay nói năng của con người: ngậm miệng lại * miệng ăn núi lở (tng)",
    example: "ngậm miệng lại * miệng ăn núi lở (tng)",
  },
  {
    word: "miệng",
    part_of_speech: "danh từ",
    meaning:
      "(giao tiếp bằng) lời nói trực tiếp, không phải viết: câu hỏi miệng * dịch miệng * trả lời miệng",
    example: "câu hỏi miệng * dịch miệng * trả lời miệng",
  },
  {
    word: "miệng",
    part_of_speech: "danh từ",
    meaning:
      "phần trên cùng, ngoài cùng, thông với bên ngoài của vật có chiều sâu: miệng hang * miệng chén",
    example: "miệng hang * miệng chén",
  },
  {
    word: "miệng ăn",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) từng cá nhân trong một gia đình, coi như một đơn vị để tính về mặt những chi phí tối thiểu cho đời sống: nhà có bốn miệng ăn",
    example: "nhà có bốn miệng ăn",
  },
  {
    word: "miếng",
    part_of_speech: "danh từ",
    meaning:
      "phần nhỏ được tách ra từ một vật: quần có hai miếng vá * bán bớt một miếng đất",
    example: "quần có hai miếng vá * bán bớt một miếng đất",
  },
  {
    word: "miếng",
    part_of_speech: "danh từ",
    meaning:
      "lượng thức ăn vừa để cho vào miệng mỗi lần ăn: ăn vội mấy miếng cơm * miếng trầu",
    example: "ăn vội mấy miếng cơm * miếng trầu",
  },
  {
    word: "miếng",
    part_of_speech: "danh từ",
    meaning:
      "cái ăn: kiếm miếng ăn * miếng ngon nhớ lâu, đòn đau nhớ đời (tng)",
    example: "kiếm miếng ăn * miếng ngon nhớ lâu, đòn đau nhớ đời (tng)",
  },
  {
    word: "miếng",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) thế đánh (thường là đánh võ): miếng võ hiểm",
    example: "miếng võ hiểm",
  },
  {
    word: "miếng",
    part_of_speech: "danh từ",
    meaning:
      "(Nam, khẩu ngữ) đơn vị chỉ mảnh đất, về mặt có thể mua bán được: Tôi mới bán miếng đất ở Củ Chi dọn vào Sài Gòn sống.",
    example: "Tôi mới bán miếng đất ở Củ Chi dọn vào Sài Gòn sống.",
  },
  {
    word: "miệt",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) vùng, miền, thường không lớn lắm: nhà ở dưới miệt biển",
    example: "nhà ở dưới miệt biển",
  },
  {
    word: "miết",
    part_of_speech: "động từ",
    meaning:
      "dùng vật nhẵn vừa ép vừa trượt trên một vật khác, thường để lèn cho chặt hoặc làm cho nhẵn: miết xi măng * miết thêm hồ cho dính * miết ngón tay trên mặt bàn",
    example:
      "miết xi măng * miết thêm hồ cho dính * miết ngón tay trên mặt bàn",
  },
  {
    word: "miết",
    part_of_speech: "phụ từ",
    meaning:
      "(làm việc gì) liền một mạch, không chịu thôi, không chịu nghỉ: cắm đầu cắm cổ chạy miết * ở miết không chịu về",
    example: "cắm đầu cắm cổ chạy miết * ở miết không chịu về",
  },
  {
    word: "miệt mài",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái tập trung và bị lôi cuốn vào công việc đến mức như không thể rời ra: lao động miệt mài * miệt mài đọc sách",
    example: "lao động miệt mài * miệt mài đọc sách",
  },
  {
    word: "miệng thế",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) lời nhận xét, bàn tán, chê bai của người đời (nói khái quát): miệng thế cười chê",
    example: "miệng thế cười chê",
  },
  {
    word: "miệng tiếng",
    part_of_speech: "danh từ",
    meaning:
      "lời bàn tán, chê bai của người đời (nói khái quát): miệng tiếng của thiên hạ * không sợ gì miệng tiếng",
    example: "miệng tiếng của thiên hạ * không sợ gì miệng tiếng",
  },
  {
    word: "miệt vườn",
    part_of_speech: "danh từ",
    meaning:
      "vùng đất phù sa rộng lớn, có những vườn cây ăn quả đủ loại, dân cư đông đúc; thường chỉ vùng đồng bằng sông Cửu Long: du lịch miệt vườn",
    example: "du lịch miệt vườn",
  },
  {
    word: "miệt thị",
    part_of_speech: "động từ",
    meaning:
      "tỏ thái độ khinh rẻ, coi thường người khác vì cho là thấp hèn: lên giọng miệt thị",
    example: "lên giọng miệt thị",
  },
  {
    word: "miếu",
    part_of_speech: "danh từ",
    meaning:
      "đền thờ nhỏ, làm nơi thờ những nhân vật đã được phong thần, hoặc những nhân vật đã được thần thánh hoá: lập miếu thờ",
    example: "lập miếu thờ",
  },
  {
    word: "miếu đường",
    part_of_speech: "danh từ",
    meaning: "(cũ) triều đình: chốn miếu đường",
    example: "chốn miếu đường",
  },
  {
    word: "miêu tả",
    part_of_speech: "động từ",
    meaning:
      "dùng một phương tiện nào đó làm cho người khác có thể hình dung được cụ thể sự vật, sự việc hoặc thế giới nội tâm của con người: đoạn văn miêu tả cảnh mùa thu",
    example: "đoạn văn miêu tả cảnh mùa thu",
  },
  {
    word: "mìn",
    part_of_speech: "danh từ",
    meaning:
      "khối thuốc nổ dùng làm vũ khí chôn hoặc đặt để công phá, sát thương khi có lực tác động vào: dò mìn * phá mìn * mìn hẹn giờ",
    example: "dò mìn * phá mìn * mìn hẹn giờ",
  },
  {
    word: "mỉm",
    part_of_speech: "động từ",
    meaning:
      "hơi nhếch mép và chúm môi lại để cười không thành tiếng: mỉm miệng cười",
    example: "mỉm miệng cười",
  },
  {
    word: "mịn màng",
    part_of_speech: "tính từ",
    meaning:
      "mịn mặt và có cảm giác rất dễ chịu khi nhìn, khi chạm vào: làn da trắng trẻo mịn màng * đôi má mịn màng",
    example: "làn da trắng trẻo mịn màng * đôi má mịn màng",
  },
  {
    word: "miếu mạo",
    part_of_speech: "danh từ",
    meaning: "miếu (nói khái quát): tu sửa lại đình chùa, miếu mạo",
    example: "tu sửa lại đình chùa, miếu mạo",
  },
  {
    word: "mím",
    part_of_speech: "động từ",
    meaning: "ngậm chặt, khép chặt môi, miệng lại: mím miệng * mím chặt môi",
    example: "mím miệng * mím chặt môi",
  },
  {
    word: "mịn",
    part_of_speech: "tính từ",
    meaning:
      "nhỏ và mượt, sờ vào thấy nhẵn, mềm, không gợn tay: da rất mịn * mặt vải mịn * bột xay rất mịn",
    example: "da rất mịn * mặt vải mịn * bột xay rất mịn",
  },
  {
    word: "minh chứng",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) cái được dẫn ra để làm căn cứ chứng minh: ông là một minh chứng tiêu biểu của thời đại",
    example: "ông là một minh chứng tiêu biểu của thời đại",
  },
  {
    word: "minh chứng",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) chứng minh bằng sự việc cụ thể: thực tế đã minh chứng cho lời nói",
    example: "thực tế đã minh chứng cho lời nói",
  },
  {
    word: "mình",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận cơ thể của người, động vật, không kể đầu, đuôi (đối với động vật) và các chi: đau mình * để mình trần",
    example: "đau mình * để mình trần",
  },
  {
    word: "mình",
    part_of_speech: "danh từ",
    meaning:
      "cơ thể người, nói chung: lách mình qua khe đá * gieo mình xuống dòng nước",
    example: "lách mình qua khe đá * gieo mình xuống dòng nước",
  },
  {
    word: "mình",
    part_of_speech: "danh từ",
    meaning:
      "cái cá nhân của mỗi con người: sống hết mình * làm việc quên mình * một thân một mình",
    example: "sống hết mình * làm việc quên mình * một thân một mình",
  },
  {
    word: "mình",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận cơ bản tạo ra hình dáng bên ngoài của một số vật: con cá dày mình * con đò đắm mình trong màn mưa",
    example: "con cá dày mình * con đò đắm mình trong màn mưa",
  },
  {
    word: "mình",
    part_of_speech: "đại từ",
    meaning:
      "(khẩu ngữ) từ dùng để tự xưng hoặc để gộp bản thân cùng với người đối thoại một cách thân mật: cậu đi với mình * chúng mình * bọn mình học cùng một lớp",
    example: "cậu đi với mình * chúng mình * bọn mình học cùng một lớp",
  },
  {
    word: "mình",
    part_of_speech: "đại từ",
    meaning:
      "từ dùng để gọi nhau một cách thân mật giữa những người bạn trẻ tuổi: thỉnh thoảng cậu lại đến nhà mình chơi nhé!",
    example: "thỉnh thoảng cậu lại đến nhà mình chơi nhé!",
  },
  {
    word: "mình",
    part_of_speech: "đại từ",
    meaning:
      'từ vợ chồng hoặc người yêu gọi nhau một cách trìu mến, âu yếm: mình ở nhà, tôi sang đây có tí việc * "Khóc than khôn xiết sự tình, Khéo vô duyên bấy là mình với ta!" (TKiều)',
    example:
      'mình ở nhà, tôi sang đây có tí việc * "Khóc than khôn xiết sự tình, Khéo vô duyên bấy là mình với ta!" (TKiều)',
  },
  {
    word: "mình",
    part_of_speech: "đại từ",
    meaning:
      "từ dùng để chỉ bản thân chủ thể được nói đến: lúc nào cũng chỉ nghĩ đến mình * mình làm mình chịu, chứ trách ai",
    example:
      "lúc nào cũng chỉ nghĩ đến mình * mình làm mình chịu, chứ trách ai",
  },
  {
    word: "minh bạch",
    part_of_speech: "tính từ",
    meaning: "rõ ràng, rành mạch: tài chính thiếu minh bạch",
    example: "tài chính thiếu minh bạch",
  },
  {
    word: "minh chủ",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) bậc vua chúa có tài đức và sáng suốt, trong quan hệ với người bề tôi: Nguyễn Trãi coi Lê Lợi là bậc minh chủ và hết lòng phò tá",
    example: "Nguyễn Trãi coi Lê Lợi là bậc minh chủ và hết lòng phò tá",
  },
  {
    word: "minh chủ",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, hiếm) người đứng đầu một liên minh hoặc một đảng phái nào đó thời phong kiến: minh chủ võ lâm (người đứng đầu trong giới võ thuật)",
    example: "minh chủ võ lâm (người đứng đầu trong giới võ thuật)",
  },
  {
    word: "minh hoạ",
    part_of_speech: "động từ",
    meaning:
      "làm rõ thêm, sinh động thêm nội dung muốn trình bày, bằng hình vẽ hoặc những hình thức dễ thấy, dễ hiểu: tranh minh hoạ * đưa ví dụ để minh hoạ",
    example: "tranh minh hoạ * đưa ví dụ để minh hoạ",
  },
  {
    word: "minh mông",
    part_of_speech: "tính từ",
    meaning:
      'rộng lớn đến mức như không có giới hạn: đồng ruộng mênh mông * "Núi cao biển rộng mênh mông, Cù lao chín chữ ghi lòng con ơi!" (ca dao)',
    example:
      'đồng ruộng mênh mông * "Núi cao biển rộng mênh mông, Cù lao chín chữ ghi lòng con ơi!" (ca dao)',
  },
  {
    word: "minh mẫn",
    part_of_speech: "tính từ",
    meaning:
      "có khả năng nhận thức nhanh và rõ ràng, ít nhầm lẫn (thường nói về người già): tuổi cao nhưng đầu óc còn minh mẫn",
    example: "tuổi cao nhưng đầu óc còn minh mẫn",
  },
  {
    word: "mình mẩy",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) thân thể: mình mẩy lấm láp",
    example: "mình mẩy lấm láp",
  },
  {
    word: "minh sơn thệ hải",
    part_of_speech: "",
    meaning:
      '(cũ, văn chương) thề non hẹn biển: "Để lời thệ hải minh sơn, Làm con, trước phải đền ơn sinh thành." (TKiều)',
    example:
      'Để lời thệ hải minh sơn, Làm con, trước phải đền ơn sinh thành." (TKiều)',
  },
  {
    word: "minh oan",
    part_of_speech: "động từ",
    meaning: "làm sáng tỏ nỗi oan: tìm cách minh oan",
    example: "tìm cách minh oan",
  },
  {
    word: "minh quân",
    part_of_speech: "danh từ",
    meaning: "(cũ) vị vua sáng suốt: đấng minh quân",
    example: "đấng minh quân",
  },
  {
    word: "minh triết",
    part_of_speech: "tính từ",
    meaning: "(hiếm) sáng sủa, rõ ràng: lối lập luận rất minh triết",
    example: "lối lập luận rất minh triết",
  },
  {
    word: "minh tinh",
    part_of_speech: "danh từ",
    meaning:
      "ngôi sao sáng; thường dùng để ví các nghệ sĩ điện ảnh, có tài năng và danh tiếng lẫy lừng: minh tinh màn bạc",
    example: "minh tinh màn bạc",
  },
  {
    word: "minh tinh",
    part_of_speech: "danh từ",
    meaning:
      'dải lụa hay giấy có ghi tên tuổi, chức tước của người chết treo lên cao khi đưa đám ma theo tục lệ cổ truyền: "Cóc chết lại có minh tinh, Thất nghiệp nằm đình có trống cầm canh." (ca dao)',
    example:
      'Cóc chết lại có minh tinh, Thất nghiệp nằm đình có trống cầm canh." (ca dao)',
  },
  {
    word: "minh xét",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) xét cho rõ ràng, thường là nỗi oan ức: xin bệ hạ minh xét!",
    example: "xin bệ hạ minh xét!",
  },
  {
    word: "minh xác",
    part_of_speech: "tính từ",
    meaning: "rõ ràng và chính xác: một khái niệm rất minh xác",
    example: "một khái niệm rất minh xác",
  },
  {
    word: "minh xác",
    part_of_speech: "động từ",
    meaning: "(hiếm) như xác minh: vấn đề chưa được minh xác",
    example: "vấn đề chưa được minh xác",
  },
  {
    word: "mini",
    part_of_speech: "tính từ",
    meaning: "(kiểu, loại) nhỏ, bé: xe đạp mini * đồ chơi mini * từ điển mini",
    example: "xe đạp mini * đồ chơi mini * từ điển mini",
  },
  {
    word: "mịt",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái hoàn toàn bị bao phủ cả một khoảng không gian rộng lớn, khiến không nhìn thấy gì: tối mịt * sương mù xuống mịt trời",
    example: "tối mịt * sương mù xuống mịt trời",
  },
  {
    word: "mịt mùng",
    part_of_speech: "tính từ",
    meaning:
      "bị bóng tối bao trùm trên cả một khoảng không gian rộng lớn: đêm tối mịt mùng",
    example: "đêm tối mịt mùng",
  },
  {
    word: "mịt mờ",
    part_of_speech: "tính từ",
    meaning:
      '(văn chương, hiếm) như mờ mịt: "Bốn bề sương tuyết mịt mờ, Trăng nghiêng chênh chếch, gà đà gáy ran." (ca dao)',
    example:
      'Bốn bề sương tuyết mịt mờ, Trăng nghiêng chênh chếch, gà đà gáy ran." (ca dao)',
  },
  {
    word: "mít đặc",
    part_of_speech: "tính từ",
    meaning:
      "(thông tục) hoàn toàn không hiểu biết gì: mít đặc về môn toán * cờ vua thì nó mít đặc",
    example: "mít đặc về môn toán * cờ vua thì nó mít đặc",
  },
  {
    word: "mít đặc",
    part_of_speech: "tính từ",
    meaning:
      "ngu đần, không thông minh: trông mặt thì xinh nhưng đầu óc thì mít đặc",
    example: "trông mặt thì xinh nhưng đầu óc thì mít đặc",
  },
  {
    word: "mít",
    part_of_speech: "tính từ",
    meaning: "(Thông tục) dốt, không biết gì cả: người đâu mà mít thế!",
    example: "người đâu mà mít thế!",
  },
  {
    word: "mịt mù",
    part_of_speech: "tính từ",
    meaning: "như mù mịt: sương khói mịt mù",
    example: "sương khói mịt mù",
  },
  {
    word: "mít tinh",
    part_of_speech: "danh từ",
    meaning:
      "cuộc tụ tập quần chúng đông đảo để tham dự một sự kiện chính trị, xã hội quan trọng nào đó: đi dự mít tinh mừng quốc khánh",
    example: "đi dự mít tinh mừng quốc khánh",
  },
  {
    word: "mít tịt",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như tịt mít: chuyện thời sự thì chị ta mít tịt",
    example: "chuyện thời sự thì chị ta mít tịt",
  },
  {
    word: "mít ướt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có tính cách yếu đuối, dễ khóc và hay khóc (thường nói về trẻ con): đồ mít ướt! * con trai mà mít ướt",
    example: "đồ mít ướt! * con trai mà mít ướt",
  },
  {
    word: "mó",
    part_of_speech: "động từ",
    meaning:
      "sờ nhẹ vào bằng các đầu ngón tay: mó phải điện * mó đến chỗ nào cũng đầy bụi",
    example: "mó phải điện * mó đến chỗ nào cũng đầy bụi",
  },
  {
    word: "mó",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) động đến để làm việc gì: chơi suốt, không mó gì đến sách vở * người mệt mỏi, chả buồn mó đến việc gì!",
    example:
      "chơi suốt, không mó gì đến sách vở * người mệt mỏi, chả buồn mó đến việc gì!",
  },
  {
    word: "mỏ",
    part_of_speech: "danh từ",
    meaning:
      "phần sừng cứng, thường là nhọn, phủ ngoài xương hàm và chìa ra ở miệng loài chim: mỏ vịt * mỏ cò",
    example: "mỏ vịt * mỏ cò",
  },
  {
    word: "mỏ",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận của một số dụng cụ có hình dáng như mỏ chim: mỏ hàn * mỏ neo",
    example: "mỏ hàn * mỏ neo",
  },
  {
    word: "mỏ",
    part_of_speech: "danh từ",
    meaning: "(thông tục) miệng, môi (hàm ý coi khinh): mắt xanh mỏ đỏ",
    example: "mắt xanh mỏ đỏ",
  },
  {
    word: "mỏ",
    part_of_speech: "danh từ",
    meaning:
      "nơi tập trung khoáng sản với trữ lượng lớn: mỏ vàng * khai thác mỏ * mỏ dầu",
    example: "mỏ vàng * khai thác mỏ * mỏ dầu",
  },
  {
    word: "mõ",
    part_of_speech: "danh từ",
    meaning:
      "nhạc khí gõ làm bằng tre, gỗ, lòng rỗng, dùng để điểm nhịp hay để báo hiệu, phát hiệu lệnh: tụng kinh gõ mõ * mõ trâu khua lốc cốc",
    example: "tụng kinh gõ mõ * mõ trâu khua lốc cốc",
  },
  {
    word: "mõ",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người chuyên làm công việc đánh mõ rao việc làng thời trước (hàm ý coi khinh): làm mõ",
    example: "làm mõ",
  },
  {
    word: "mò",
    part_of_speech: "động từ",
    meaning:
      "sờ tìm vật gì đó khi không thể nhìn thấy được (thường là trong nước, trong bóng tối): mò cua bắt ốc * mất điện, mò mãi chẳng thấy diêm",
    example: "mò cua bắt ốc * mất điện, mò mãi chẳng thấy diêm",
  },
  {
    word: "mò",
    part_of_speech: "động từ",
    meaning:
      "lần tìm một cách hú hoạ, may ra thì được vì không có căn cứ: giải mò bài toán * đoán mò * ăn ốc nói mò (tng)",
    example: "giải mò bài toán * đoán mò * ăn ốc nói mò (tng)",
  },
  {
    word: "mò",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tự tìm đến, thường là không đàng hoàng: bị kẻ trộm mò vào nhà * xa xôi mấy cũng mò đến",
    example: "bị kẻ trộm mò vào nhà * xa xôi mấy cũng mò đến",
  },
  {
    word: "mo",
    part_of_speech: "danh từ",
    meaning:
      "lá bắc lớn hình thuyền bọc ngoài cụm hoa các cây họ ráy, họ cau, v.v..",
    example: "cứng như mo * quạt mo",
  },
  {
    word: "mỏ ác",
    part_of_speech: "danh từ",
    meaning: "xương nối các đầu sườn ở phía trước lồng ngực.",
    example: "thấy đau ở mỏ ác",
  },
  {
    word: "mỏ ác",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) thóp ở trẻ em: che mỏ ác cho bé",
    example: "che mỏ ác cho bé",
  },
  {
    word: "mó máy",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) mó vào, động vào, thường do tò mò hay nghịch ngợm: không phải của mình thì đừng có mó máy vào",
    example: "không phải của mình thì đừng có mó máy vào",
  },
  {
    word: "mỏ nhát",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) dẽ: bầy mỏ nhát",
    example: "bầy mỏ nhát",
  },
  {
    word: "mò mẫm",
    part_of_speech: "động từ",
    meaning:
      "dò tìm trong điều kiện không có ánh sáng hoặc không có đủ các kiến thức, phương pháp cần thiết (nói khái quát): mò mẫm tìm diêm châm đèn * tự mò mẫm sửa lấy cái đồng hồ",
    example: "mò mẫm tìm diêm châm đèn * tự mò mẫm sửa lấy cái đồng hồ",
  },
  {
    word: "mọc",
    part_of_speech: "danh từ",
    meaning:
      "món ăn làm bằng thịt nạc giã nhỏ, vê thành viên tròn, hấp chín, thường ăn với món ăn khác có nước dùng: bún mọc",
    example: "bún mọc",
  },
  {
    word: "mọc",
    part_of_speech: "động từ",
    meaning:
      "nhô lên khỏi bề mặt và tiếp tục lớn lên, cao lên: lạc mọc mầm * bé sốt vì mọc răng * mặt trời mọc",
    example: "lạc mọc mầm * bé sốt vì mọc răng * mặt trời mọc",
  },
  {
    word: "mọc",
    part_of_speech: "động từ",
    meaning:
      "được tạo ra và phát triển nhanh chóng: nhà cao tầng mọc lên san sát",
    example: "nhà cao tầng mọc lên san sát",
  },
  {
    word: "mo-rát",
    part_of_speech: "danh từ",
    meaning: "bản in thử để sửa: đọc morasse * sửa morasse lần hai",
    example: "đọc morasse * sửa morasse lần hai",
  },
  {
    word: "mó tay",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tham gia trực tiếp vào làm việc gì (nói về việc lao động chân tay): chẳng mó tay vào việc gì bao giờ",
    example: "chẳng mó tay vào việc gì bao giờ",
  },
  {
    word: "móc",
    part_of_speech: "danh từ",
    meaning:
      "vật có đầu cong hình lưỡi câu để lấy, giữ hoặc treo đồ vật: kim móc * móc áo",
    example: "kim móc * móc áo",
  },
  {
    word: "móc",
    part_of_speech: "động từ",
    meaning:
      "lấy ra từ chỗ sâu, hẹp bằng tay hoặc bằng cái móc: móc tiền trong túi ra * đi móc cua ngoài đồng * móc họng",
    example: "móc tiền trong túi ra * đi móc cua ngoài đồng * móc họng",
  },
  {
    word: "móc",
    part_of_speech: "động từ",
    meaning:
      "giữ, treo bằng cái móc: bị gai móc rách áo * móc quần áo lên dây phơi",
    example: "bị gai móc rách áo * móc quần áo lên dây phơi",
  },
  {
    word: "móc",
    part_of_speech: "động từ",
    meaning:
      "đan chỉ, len hoặc cước thành đồ dùng bằng kim móc: móc mũ * móc một cái túi bằng cước * tay móc nhanh thoăn thoắt",
    example: "móc mũ * móc một cái túi bằng cước * tay móc nhanh thoăn thoắt",
  },
  {
    word: "móc",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bắt liên lạc, tìm cơ sở để hoạt động bí mật: móc cơ sở trong lòng địch",
    example: "móc cơ sở trong lòng địch",
  },
  {
    word: "móc",
    part_of_speech: "động từ",
    meaning:
      "cố tình nói, gợi ra điều không hay của người khác nhằm làm cho người ta khó chịu: nói móc lẫn nhau * móc những chuyện từ đời nào ra mà nói",
    example: "nói móc lẫn nhau * móc những chuyện từ đời nào ra mà nói",
  },
  {
    word: "móc câu",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ có một cái móc hình lưỡi câu, thường dùng để móc vào mà kéo những vật ở bên trong hay ở xa: dùng móc câu kéo cái phao lên bờ",
    example: "dùng móc câu kéo cái phao lên bờ",
  },
  {
    word: "móc hàm",
    part_of_speech: "danh từ",
    meaning:
      "trọng lượng gia súc sau khi đã chọc tiết, cạo lông, và lấy hết lòng (phân biệt với trọng lượng gia súc khi còn sống): cân móc hàm * giá thịt lợn móc hàm",
    example: "cân móc hàm * giá thịt lợn móc hàm",
  },
  {
    word: "mọc mũi sủi tăm",
    part_of_speech: "",
    meaning:
      '(khẩu ngữ) ví tình trạng bắt đầu phát triển, khấm khá lên: "Đời đang lúc nhiễu nhương, muốn mọc mũi sủi tăm lên được, phải dám liều." (NgKiên; 16)',
    example:
      'Đời đang lúc nhiễu nhương, muốn mọc mũi sủi tăm lên được, phải dám liều." (NgKiên; 16)',
  },
  {
    word: "móc máy",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nói móc nhằm giễu cợt, chọc tức: hỏi móc máy * suốt ngày chỉ móc máy nhau",
    example: "hỏi móc máy * suốt ngày chỉ móc máy nhau",
  },
  {
    word: "móc xích",
    part_of_speech: "danh từ",
    meaning:
      "đốt móc vào với những đốt khác của một dây xích: tháo rời từng móc xích",
    example: "tháo rời từng móc xích",
  },
  {
    word: "móc xích",
    part_of_speech: "động từ",
    meaning:
      "nối liền thành chuỗi, dắt dây với nhau: móc xích các vấn đề có liên quan",
    example: "móc xích các vấn đề có liên quan",
  },
  {
    word: "móc ngoặc",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) thông đồng với nhau để cùng kiếm lợi: móc ngoặc với gian thương",
    example: "móc ngoặc với gian thương",
  },
  {
    word: "mọc sừng",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) có vợ ngoại tình: người chồng mọc sừng",
    example: "người chồng mọc sừng",
  },
  {
    word: "móc mưa",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) như mưa móc: "Móc mưa ơn đội thánh minh, Thanh bình hai chữ góp danh với đời." (TTK)',
    example:
      'Móc mưa ơn đội thánh minh, Thanh bình hai chữ góp danh với đời." (TTK)',
  },
  {
    word: "móc túi",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) lấy cắp tiền hay đồ vật trong túi người khác: bị kẻ gian móc túi",
    example: "bị kẻ gian móc túi",
  },
  {
    word: "móc nối",
    part_of_speech: "động từ",
    meaning:
      "bắt liên lạc, đặt quan hệ với nhau để hoạt động bí mật: móc nối cơ sở",
    example: "móc nối cơ sở",
  },
  {
    word: "model",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) kiểu, mốt: chiếc điện thoại model mới nhất",
    example: "chiếc điện thoại model mới nhất",
  },
  {
    word: "model",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (kiểu) mới, hợp thời trang: diện bộ trang phục rất model",
    example: "diện bộ trang phục rất model",
  },
  {
    word: "modern",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) mốt, hiện đại: chiếc xe trông rất modern.",
    example: "chiếc xe trông rất modern.",
  },
  {
    word: "mòi",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) tăm cá: trông mòi thả lưới",
    example: "trông mòi thả lưới",
  },
  {
    word: "mòi",
    part_of_speech: "danh từ",
    meaning:
      "vẻ, dấu hiệu nhờ đó có thể đoán biết được điều gì: nó ăn mãi, ngó mòi đã chán * công việc có mòi dễ dàng",
    example: "nó ăn mãi, ngó mòi đã chán * công việc có mòi dễ dàng",
  },
  {
    word: "mọi",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ người dân tộc thiểu số có văn hoá và đời sống còn lạc hậu với ý khinh miệt (theo quan điểm kì thị dân tộc thời phong kiến, thực dân).",
    example: "làm mọi không công",
  },
  {
    word: "mọi",
    part_of_speech: "danh từ",
    meaning:
      "từ chỉ số lượng không xác định, nhưng gồm tất cả những sự vật được nói đến: mọi người đều đã về hết * đi khắp mọi nơi * làm xong mọi việc",
    example: "mọi người đều đã về hết * đi khắp mọi nơi * làm xong mọi việc",
  },
  {
    word: "mọi",
    part_of_speech: "danh từ",
    meaning:
      "từ chỉ số lượng không xác định, nhưng gồm tất cả những khoảng thời gian được nói đến, thuộc về trước đây, cho đến nay: công việc vẫn như mọi hôm  * dậy sớm hơn mọi ngày",
    example: "công việc vẫn như mọi hôm  * dậy sớm hơn mọi ngày",
  },
  {
    word: "mỏi",
    part_of_speech: "",
    meaning:
      "có cảm giác gân cốt rão ra, thường do đã làm việc quá lâu và quá sức, như không vận động nổi nữa: viết mỏi cả tay mới xong * mỏi gối chồn chân * nói lắm mỏi mồm!",
    example: "viết mỏi cả tay mới xong * mỏi gối chồn chân * nói lắm mỏi mồm!",
  },
  {
    word: "mọi khi",
    part_of_speech: "danh từ",
    meaning:
      "những lần trước đây, trước kia: việc này mọi khi đều do anh ấy làm",
    example: "việc này mọi khi đều do anh ấy làm",
  },
  {
    word: "moi",
    part_of_speech: "danh từ",
    meaning:
      "tôm nhỏ ở biển, sống nổi thành đàn lớn, ăn sinh vật nổi, thường dùng làm mắm: mắm moi",
    example: "mắm moi",
  },
  {
    word: "moi",
    part_of_speech: "động từ",
    meaning:
      "lấy ra từ chỗ sâu kín bên dưới, bên trong, bằng cách gạt bớt hoặc luồn qua những gì phủ bên trên, bên ngoài: moi tiền trong túi * moi khuyết điểm của người ta ra mà nói (b)",
    example: "moi tiền trong túi * moi khuyết điểm của người ta ra mà nói (b)",
  },
  {
    word: "moi",
    part_of_speech: "động từ",
    meaning:
      "tìm cách làm cho người khác phải tiết lộ hoặc cung cấp cái, điều họ muốn giữ kín: moi tài liệu * moi thông tin * chỉ giỏi moi tiền của cha mẹ (kng)",
    example:
      "moi tài liệu * moi thông tin * chỉ giỏi moi tiền của cha mẹ (kng)",
  },
  {
    word: "mỏi mắt",
    part_of_speech: "tính từ",
    meaning:
      "trạng thái mong chờ đã lâu lắm rồi mà vẫn không thấy đâu: mỏi mắt chờ đợi",
    example: "mỏi mắt chờ đợi",
  },
  {
    word: "mỏi mệt",
    part_of_speech: "tính từ",
    meaning: "như mệt mỏi: dáng điệu có vẻ mỏi mệt * khuôn mặt mỏi mệt",
    example: "dáng điệu có vẻ mỏi mệt * khuôn mặt mỏi mệt",
  },
  {
    word: "moi móc",
    part_of_speech: "động từ",
    meaning:
      "lấy, lôi ra bằng hết, từ chỗ kín, chỗ chật hẹp (nói khái quát): moi móc từ trong túi ra một đống các thứ linh tinh",
    example: "moi móc từ trong túi ra một đống các thứ linh tinh",
  },
  {
    word: "moi móc",
    part_of_speech: "động từ",
    meaning:
      "nói ra, trực tiếp hoặc gián tiếp, những chuyện riêng tư, sai sót nhỏ nhặt của người khác, với dụng ý xấu: moi móc chuyện của người khác ra mà nói",
    example: "moi móc chuyện của người khác ra mà nói",
  },
  {
    word: "mỏi mòn",
    part_of_speech: "tính từ",
    meaning: "như mòn mỏi: mỏi mòn ngóng trông",
    example: "mỏi mòn ngóng trông",
  },
  {
    word: "móm",
    part_of_speech: "tính từ",
    meaning:
      "có miệng và má hõm vào, cằm như nhô ra, thường do bị rụng nhiều hay không còn răng: bà cụ bị móm * cô bé có cái miệng hơi móm",
    example: "bà cụ bị móm * cô bé có cái miệng hơi móm",
  },
  {
    word: "mom",
    part_of_speech: "danh từ",
    meaning:
      'phần đất ở bờ nhô ra phía lòng sông: "Quanh năm buôn bán ở mom sông, Nuôi đủ năm con với một chồng." (TrTXương; 4)',
    example:
      'Quanh năm buôn bán ở mom sông, Nuôi đủ năm con với một chồng." (TrTXương; 4)',
  },
  {
    word: "mõm",
    part_of_speech: "danh từ",
    meaning: "miệng có dáng nhô ra ở một số loài thú: mõm lợn * mõm chó",
    example: "mõm lợn * mõm chó",
  },
  {
    word: "mõm",
    part_of_speech: "danh từ",
    meaning:
      "(thông tục) miệng của người (hàm ý coi khinh): câm mõm đi! * đừng có chõ mõm vào việc của người khác!",
    example: "câm mõm đi! * đừng có chõ mõm vào việc của người khác!",
  },
  {
    word: "mõm",
    part_of_speech: "danh từ",
    meaning: "phần đầu mũi của một số vật: mõm cày * đôi giày bị há mõm",
    example: "mõm cày * đôi giày bị há mõm",
  },
  {
    word: "móm mém",
    part_of_speech: "tính từ",
    meaning: "móm nhiều, do rụng hết răng: miệng móm mém nhai trầu",
    example: "miệng móm mém nhai trầu",
  },
  {
    word: "mỏm",
    part_of_speech: "danh từ",
    meaning:
      "phần đất hoặc đá nhô cao lên hoặc chìa ra trên một địa hình: mỏm núi * mỏm đồi",
    example: "mỏm núi * mỏm đồi",
  },
  {
    word: "mòn",
    part_of_speech: "động từ",
    meaning:
      "bị mất dần từng ít một trên bề mặt do bị cọ xát nhiều: guốc đã bị mòn gót * nước chảy đá mòn (tng)",
    example: "guốc đã bị mòn gót * nước chảy đá mòn (tng)",
  },
  {
    word: "mòn",
    part_of_speech: "động từ",
    meaning:
      "bị mất dần, tiêu hao dần do không được bổ sung, củng cố thường xuyên: kiến thức mòn dần * người héo dần héo mòn",
    example: "kiến thức mòn dần * người héo dần héo mòn",
  },
  {
    word: "mòn",
    part_of_speech: "động từ",
    meaning:
      "đã được nhiều người, nhiều nơi dùng, đến mức trở thành nhàm (thường nói về hình thức diễn đạt): nói mãi một kiểu, nghe mòn tai * lối diễn đạt hơi mòn",
    example: "nói mãi một kiểu, nghe mòn tai * lối diễn đạt hơi mòn",
  },
  {
    word: "món",
    part_of_speech: "danh từ",
    meaning:
      "từ chỉ từng kiểu thức ăn đã được chế biến theo một cách thức nhất định: món cá chép om dưa * thực đơn gồm có chín món",
    example: "món cá chép om dưa * thực đơn gồm có chín món",
  },
  {
    word: "món",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp gồm những cái cùng loại, có số lượng đáng kể, làm thành một đơn vị: tặng bạn một món quà * món nợ",
    example: "tặng bạn một món quà * món nợ",
  },
  {
    word: "món",
    part_of_speech: "danh từ",
    meaning: "(Khẩu ngữ) như môn (ng2): món võ * chỉ có món nói phét là giỏi!",
    example: "món võ * chỉ có món nói phét là giỏi!",
  },
  {
    word: "mọn",
    part_of_speech: "tính từ",
    meaning:
      "nhỏ bé, không đáng kể (thường dùng để nói về cái của mình với ý khiêm tốn, nhún nhường): quà mọn * xin bày chút ý kiến mọn",
    example: "quà mọn * xin bày chút ý kiến mọn",
  },
  {
    word: "mon men",
    part_of_speech: "động từ",
    meaning:
      "tiến lại, nhích gần lại từng quãng ngắn một cách dè dặt, thận trọng: mon men lại gần * mon men dò hỏi",
    example: "mon men lại gần * mon men dò hỏi",
  },
  {
    word: "mòn vẹt",
    part_of_speech: "động từ",
    meaning:
      "mòn và vẹt hẳn đi do bị cọ xát nhiều (nói khái quát): chiếc lốp xe đã mòn vẹt * đôi giày mòn vẹt cả gót",
    example: "chiếc lốp xe đã mòn vẹt * đôi giày mòn vẹt cả gót",
  },
  {
    word: "móng",
    part_of_speech: "danh từ",
    meaning:
      "phần cứng như sừng ở đầu ngón chân, ngón tay: cắt móng chân * móng lợn * vỏ quýt dày có móng tay nhọn (tng)",
    example: "cắt móng chân * móng lợn * vỏ quýt dày có móng tay nhọn (tng)",
  },
  {
    word: "móng",
    part_of_speech: "danh từ",
    meaning:
      "miếng sắt có hình vòng cung gắn vào dưới móng của một số động vật nuôi để lấy sức kéo (như ngựa): đóng móng cho ngựa",
    example: "đóng móng cho ngựa",
  },
  {
    word: "móng",
    part_of_speech: "danh từ",
    meaning: "bong bóng nhỏ do cá đớp trên mặt nước tạo thành: cá ăn móng",
    example: "cá ăn móng",
  },
  {
    word: "móng",
    part_of_speech: "động từ",
    meaning:
      "(cá) đớp trên mặt nước tạo thành những bong bóng nhỏ: cá móng đâu buông câu đó (tng)",
    example: "cá móng đâu buông câu đó (tng)",
  },
  {
    word: "móng",
    part_of_speech: "danh từ",
    meaning:
      "lớp vật liệu xây ở dưới cùng, thường nằm trong đất, để đỡ sức nặng của công trình xây dựng: xây móng * đổ móng đắp nền * gia cố lại móng cầu",
    example: "xây móng * đổ móng đắp nền * gia cố lại móng cầu",
  },
  {
    word: "mòn mỏi",
    part_of_speech: "tính từ",
    meaning:
      'ở trạng thái hao sút dần theo thời gian: "Phũ phàng chi bấy Hoá công!, Ngày xanh mòn mỏi, má hồng phôi pha." (TKiều)',
    example:
      'Phũ phàng chi bấy Hoá công!, Ngày xanh mòn mỏi, má hồng phôi pha." (TKiều)',
  },
  {
    word: "mong",
    part_of_speech: "động từ",
    meaning:
      "ở trạng thái đang muốn điều gì, việc gì đó sớm xảy ra: mong ngày mong đêm * mong như mong mẹ về chợ (tng)",
    example: "mong ngày mong đêm * mong như mong mẹ về chợ (tng)",
  },
  {
    word: "mong",
    part_of_speech: "động từ",
    meaning:
      "có nguyện vọng rằng, ước muốn rằng (thường dùng không có chủ ngữ, để nói lên điều mong ước của mình với người khác): mong anh thông cảm * mong sao mọi sự bình an",
    example: "mong anh thông cảm * mong sao mọi sự bình an",
  },
  {
    word: "mong",
    part_of_speech: "động từ",
    meaning: "có thể có được điều tốt đẹp: phải học thật chăm mới mong thi đỗ",
    example: "phải học thật chăm mới mong thi đỗ",
  },
  {
    word: "mong chờ",
    part_of_speech: "động từ",
    meaning: "như chờ mong: khắc khoải mong chờ",
    example: "khắc khoải mong chờ",
  },
  {
    word: "mỏng",
    part_of_speech: "tính từ",
    meaning:
      'có bề dày nhỏ hơn mức bình thường hoặc nhỏ hơn so với những vật khác: vải mỏng * chuối mỏng vỏ * "Mong manh phận mỏng như tờ, Tìm nơi kiếm chốn nương nhờ độ thân." (ca dao)',
    example:
      'vải mỏng * chuối mỏng vỏ * "Mong manh phận mỏng như tờ, Tìm nơi kiếm chốn nương nhờ độ thân." (ca dao)',
  },
  {
    word: "mỏng",
    part_of_speech: "tính từ",
    meaning: "ở trạng thái thưa ra, phân tán ra: dàn mỏng lực lượng",
    example: "dàn mỏng lực lượng",
  },
  {
    word: "mỏng dinh dính",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) như mỏng dính (nhưng ý mức độ nhiều hơn): tờ giấy mỏng dinh dính",
    example: "tờ giấy mỏng dinh dính",
  },
  {
    word: "mọng",
    part_of_speech: "tính từ",
    meaning:
      "căng đầy ra như có chứa nhiều nước ở bên trong (thường nói về quả cây hay một số bộ phận của cơ thể): quả chín mọng * đôi môi đỏ mọng * mắt sưng mọng",
    example: "quả chín mọng * đôi môi đỏ mọng * mắt sưng mọng",
  },
  {
    word: "mỏng dính",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) mỏng đến mức như không thể mỏng hơn được nữa: vải mỏng dính * cặp môi mỏng dính",
    example: "vải mỏng dính * cặp môi mỏng dính",
  },
  {
    word: "mong đợi",
    part_of_speech: "động từ",
    meaning:
      "mong điều đang muốn sẽ xảy ra với nhiều hi vọng: mong đợi ngày chiến thắng * điều không mong đợi đã xảy đến",
    example: "mong đợi ngày chiến thắng * điều không mong đợi đã xảy đến",
  },
  {
    word: "mong manh",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái có rất ít, không bao nhiêu, mà lại không bền chắc, dễ mất đi, dễ tan biến đi: khả năng sống rất mong manh * hi vọng mong manh",
    example: "khả năng sống rất mong manh * hi vọng mong manh",
  },
  {
    word: "mong manh",
    part_of_speech: "tính từ",
    meaning: "như mỏng manh (ng1): tấm áo mong manh",
    example: "tấm áo mong manh",
  },
  {
    word: "mong manh",
    part_of_speech: "tính từ",
    meaning:
      "(nghe, biết) không có gì là chắc chắn, rõ ràng: chỉ biết mong manh, không chính xác * nghe mong manh",
    example: "chỉ biết mong manh, không chính xác * nghe mong manh",
  },
  {
    word: "móng giò",
    part_of_speech: "danh từ",
    meaning: "đoạn ngắn của chân giò lợn từ khuỷu đến các móng: bún móng giò",
    example: "bún móng giò",
  },
  {
    word: "mỏng manh",
    part_of_speech: "tính từ",
    meaning:
      "rất mỏng, gây cảm giác không đủ sức chịu đựng: mặc một chiếc áo mỏng manh",
    example: "mặc một chiếc áo mỏng manh",
  },
  {
    word: "mỏng manh",
    part_of_speech: "tính từ",
    meaning: "như mong manh (ng1): hi vọng mỏng manh",
    example: "hi vọng mỏng manh",
  },
  {
    word: "mòng mọng",
    part_of_speech: "tính từ",
    meaning: "hơi mọng: cặp môi mòng mọng * mắt mòng mọng như sắp khóc",
    example: "cặp môi mòng mọng * mắt mòng mọng như sắp khóc",
  },
  {
    word: "mỏng mảnh",
    part_of_speech: "tính từ",
    meaning:
      "mỏng và kém độ bền chắc, kém sức chịu đựng trước những tác động bất lợi từ bên ngoài: thân hình mỏng mảnh",
    example: "thân hình mỏng mảnh",
  },
  {
    word: "mong muốn",
    part_of_speech: "động từ",
    meaning:
      "muốn và hi vọng có được, đạt được: mong muốn một gia đình hạnh phúc * đạt kết quả như mong muốn",
    example: "mong muốn một gia đình hạnh phúc * đạt kết quả như mong muốn",
  },
  {
    word: "mỏng môi",
    part_of_speech: "tính từ",
    meaning:
      '(khẩu ngữ) hay mách lẻo, hay nói trước những lời mà người khác chưa kịp nói (hàm ý coi khinh): "Thế mới đẹp mặt giống mỏng môi! Cứ để người ta đánh, người ta xé nó ra, cho nó chừa cái tính hay hớt!" (Vũ Thị Thường; 2)',
    example:
      'Thế mới đẹp mặt giống mỏng môi! Cứ để người ta đánh, người ta xé nó ra, cho nó chừa cái tính hay hớt!" (Vũ Thị Thường; 2)',
  },
  {
    word: "mong ngóng",
    part_of_speech: "động từ",
    meaning: "mong đợi đến bồn chồn: ngày đêm mong ngóng",
    example: "ngày đêm mong ngóng",
  },
  {
    word: "mong mỏi",
    part_of_speech: "động từ",
    meaning:
      "mong một cách tha thiết, kéo dài: mong mỏi ngày hoà bình * thoả lòng mong mỏi",
    example: "mong mỏi ngày hoà bình * thoả lòng mong mỏi",
  },
  {
    word: "mong nhớ",
    part_of_speech: "động từ",
    meaning: "nhớ da diết và mong được gặp lại: mong nhớ người yêu",
    example: "mong nhớ người yêu",
  },
  {
    word: "mỏng tang",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) rất mỏng và nhẹ: cái áo mỏng tang",
    example: "cái áo mỏng tang",
  },
  {
    word: "mỏng tanh",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) quá mỏng, không được như yêu cầu: vải mỏng tanh * tấm liếp mỏng tanh",
    example: "vải mỏng tanh * tấm liếp mỏng tanh",
  },
  {
    word: "moóc",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) rơmoóc (nói tắt): xe kéo moóc",
    example: "xe kéo moóc",
  },
  {
    word: "móp",
    part_of_speech: "tính từ",
    meaning:
      "có chỗ bị lõm vào do từng chịu tác động của lực ép: mui xe bị móp vì đâm vào gốc cây",
    example: "mui xe bị móp vì đâm vào gốc cây",
  },
  {
    word: "móp",
    part_of_speech: "tính từ",
    meaning:
      "bị nhỏ đi về thể tích, như bị lõm vào (nói về bộ phận cơ thể người, động vật): đói móp * gầy móp * hai má móp vào",
    example: "đói móp * gầy móp * hai má móp vào",
  },
  {
    word: "moóc-xơ",
    part_of_speech: "danh từ",
    meaning:
      "hệ thống những tổ hợp chấm và gạch, âm hay là tia loé sáng ngắn và dài, biểu thị các chữ cái, chữ số, v.v., dùng trong điện báo, trong các phương thức truyền tin: đánh morse",
    example: "đánh morse",
  },
  {
    word: "mong ước",
    part_of_speech: "động từ",
    meaning:
      "mong và ước muốn có được, đạt được một cách tha thiết: mong ước một cuộc sống hạnh phúc * điều mong ước",
    example: "mong ước một cuộc sống hạnh phúc * điều mong ước",
  },
  {
    word: "mong ước",
    part_of_speech: "danh từ",
    meaning: "điều mong muốn, ước ao: không có mong ước gì",
    example: "không có mong ước gì",
  },
  {
    word: "mọp",
    part_of_speech: "động từ",
    meaning:
      "ép, cúi mình thật sát xuống và cố thu nhỏ người lại đến mức tối đa, vì sợ hãi hay để tránh tai hoạ: mọp đầu cúi chào * nằm mọp xuống đất",
    example: "mọp đầu cúi chào * nằm mọp xuống đất",
  },
  {
    word: "mono",
    part_of_speech: "danh từ",
    meaning:
      "kĩ thuật thu và phát lại âm thanh chỉ bằng một kênh, nghe tất cả âm thanh như đều từ chỉ một nguồn âm; phân biệt với stereo: đĩa nhạc mono * âm thanh mono",
    example: "đĩa nhạc mono * âm thanh mono",
  },
  {
    word: "mọt",
    part_of_speech: "danh từ",
    meaning:
      "bọ cánh cứng có hàm khoẻ, chuyên đục khoét tre, gỗ, hạt ngũ cốc khô: cái bàn===== bị mọt đục ===== * tiếng mọt nghiến ken két",
    example: "cái bàn===== bị mọt đục ===== * tiếng mọt nghiến ken két",
  },
  {
    word: "mọt",
    part_of_speech: "tính từ",
    meaning: "bị mọt đục: ngô mọt * gỗ mọt",
    example: "ngô mọt * gỗ mọt",
  },
  {
    word: "mọt gông",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (bị tù) rất lâu, không biết đến ngày nào mới được ra: tù mọt gông!",
    example: "tù mọt gông!",
  },
  {
    word: "morse",
    part_of_speech: "danh từ",
    meaning:
      "hệ thống những tổ hợp chấm và gạch, âm hay là tia loé sáng ngắn và dài, biểu thị các chữ cái, chữ số, v.v., dùng trong điện báo, trong các phương thức truyền tin: đánh morse",
    example: "đánh morse",
  },
  {
    word: "mót",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) (Nam mắc) cảm thấy muốn ỉa, đái đến mức không thể nén nhịn được: mót đái",
    example: "mót đái",
  },
  {
    word: "mót",
    part_of_speech: "động từ",
    meaning:
      "nhặt nhạnh của để rơi vãi hoặc bỏ sót của người khác, thường là ngoài đồng ruộng: mót lúa * ra đồng mót khoai",
    example: "mót lúa * ra đồng mót khoai",
  },
  {
    word: "mọt dân",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để ví những kẻ chuyên lợi dụng chức quyền đục khoét, bòn rút của dân: kẻ tham nhũng mọt dân",
    example: "kẻ tham nhũng mọt dân",
  },
  {
    word: "morasse",
    part_of_speech: "danh từ",
    meaning: "bản in thử để sửa: đọc morasse * sửa morasse lần hai",
    example: "đọc morasse * sửa morasse lần hai",
  },
  {
    word: "mọt sách",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) từ dùng để ví người không biết gì ngoài sách vở, sống xa rời thực tế: anh ta là con mọt sách",
    example: "anh ta là con mọt sách",
  },
  {
    word: "mọt ruỗng",
    part_of_speech: "tính từ",
    meaning:
      "mọt đến mức rỗng hết bên trong; thường dùng để ví tình trạng thối nát từ bên trong của một chế độ, một tầng lớp xã hội: triều đình phong kiến mọt ruỗng",
    example: "triều đình phong kiến mọt ruỗng",
  },
  {
    word: "mồ",
    part_of_speech: "danh từ",
    meaning: "mộ (thường dùng trong văn chương): nấm mồ",
    example: "nấm mồ",
  },
  {
    word: "mô",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp những tế bào có cùng một chức năng: phương pháp cấy mô * mô xương * mô thần kinh * mô thực vật",
    example: "phương pháp cấy mô * mô xương * mô thần kinh * mô thực vật",
  },
  {
    word: "mô",
    part_of_speech: "danh từ",
    meaning:
      "khối đất đá không lớn lắm, nổi cao hơn xung quanh: san phẳng mô đất * trèo qua mấy mô đá",
    example: "san phẳng mô đất * trèo qua mấy mô đá",
  },
  {
    word: "mô",
    part_of_speech: "đại từ",
    meaning: "(Phương ngữ) đâu: đi mô? * chuyện nớ tui không biết mô",
    example: "đi mô? * chuyện nớ tui không biết mô",
  },
  {
    word: "mô",
    part_of_speech: "đại từ",
    meaning: "nào: khi mô? * đứa mô?",
    example: "khi mô? * đứa mô?",
  },
  {
    word: "mố",
    part_of_speech: "danh từ",
    meaning: "công trình xây tựa vào nền đường để đỡ rầm cầu: mố cầu",
    example: "mố cầu",
  },
  {
    word: "mố",
    part_of_speech: "danh từ",
    meaning: "công trình xây tựa vào nền đường để dẫn xuống phà: mố phà",
    example: "mố phà",
  },
  {
    word: "mổ",
    part_of_speech: "động từ",
    meaning:
      "(chim, gà, v.v.) dùng mỏ nhặt thức ăn hoặc đánh nhau: gà mổ thóc * hai con chim đang mổ nhau",
    example: "gà mổ thóc * hai con chim đang mổ nhau",
  },
  {
    word: "mổ",
    part_of_speech: "động từ",
    meaning:
      "dùng dao rạch lớp bên ngoài của một bộ phận của cơ thể rồi mở rộng ra: mổ cá * mổ ruột thừa * bác sĩ phòng mổ",
    example: "mổ cá * mổ ruột thừa * bác sĩ phòng mổ",
  },
  {
    word: "mổ",
    part_of_speech: "động từ",
    meaning: "giết gia súc để lấy thịt: mổ bò * mổ lợn khao quân * mổ gà",
    example: "mổ bò * mổ lợn khao quân * mổ gà",
  },
  {
    word: "mộ",
    part_of_speech: "danh từ",
    meaning:
      "nơi chôn cất người chết (hoặc chôn cất tượng trưng) được đắp hoặc xây cao hơn xung quanh: đắp mộ * viếng mộ * đi tảo mộ",
    example: "đắp mộ * viếng mộ * đi tảo mộ",
  },
  {
    word: "mộ",
    part_of_speech: "động từ",
    meaning:
      "(cũ) tìm người từ các nơi, làm cho người ta tự nguyện đến, để tập hợp, tổ chức lại thành lực lượng làm việc gì: mộ phu * mộ lính",
    example: "mộ phu * mộ lính",
  },
  {
    word: "mộ",
    part_of_speech: "động từ",
    meaning:
      '(cũ) mến, thích đến mức muốn tìm đến: "Hoa khôi mộ tiếng Kiều nhi, Thiếp hồng tìm đến hương khuê gửi vào." (TKiều)',
    example:
      'Hoa khôi mộ tiếng Kiều nhi, Thiếp hồng tìm đến hương khuê gửi vào." (TKiều)',
  },
  {
    word: "mồ côi",
    part_of_speech: "tính từ",
    meaning:
      "bị mất cha và/hoặc mẹ khi còn bé dại: mồ côi cha từ lúc 2 tuổi * trẻ mồ côi",
    example: "mồ côi cha từ lúc 2 tuổi * trẻ mồ côi",
  },
  {
    word: "mồ cha",
    part_of_speech: "",
    meaning: "(thông tục) từ dùng để chửi: mồ cha mày!",
    example: "mồ cha mày!",
  },
  {
    word: "mổ cò",
    part_of_speech: "động từ",
    meaning:
      "ví cách đánh máy chậm, từng chữ một và chỉ bằng một vài ngón tay: đánh máy theo kiểu mổ cò",
    example: "đánh máy theo kiểu mổ cò",
  },
  {
    word: "mỗ",
    part_of_speech: "đại từ",
    meaning:
      '(khẩu ngữ) từ dùng để tự xưng (thường với người ngang hàng hoặc hàng dưới): "Chẳng may vợ mỗ mới qua, Triều đình cử mỗ phải ra trận này." (PCCH)',
    example:
      'Chẳng may vợ mỗ mới qua, Triều đình cử mỗ phải ra trận này." (PCCH)',
  },
  {
    word: "mộ đạo",
    part_of_speech: "động từ",
    meaning:
      "tin và một lòng theo đạo (thường nói về đạo Kitô): tấm lòng mộ đạo",
    example: "tấm lòng mộ đạo",
  },
  {
    word: "mồ hôi",
    part_of_speech: "danh từ",
    meaning:
      "chất nước bài tiết qua lỗ chân lông: sợ toát mồ hôi * trời nóng, mồ hôi vã ra như tắm",
    example: "sợ toát mồ hôi * trời nóng, mồ hôi vã ra như tắm",
  },
  {
    word: "mồ hôi",
    part_of_speech: "danh từ",
    meaning:
      "mồ hôi đổ ra của con người, được coi là tượng trưng cho công sức lao động khó nhọc: phải đổ mồ hôi mới kiếm được miếng cơm",
    example: "phải đổ mồ hôi mới kiếm được miếng cơm",
  },
  {
    word: "mồ hôi mồ kê",
    part_of_speech: "",
    meaning: "(khẩu ngữ) mồ hôi chảy ra nhiều: mồ hôi mồ kê nhễ nhại",
    example: "mồ hôi mồ kê nhễ nhại",
  },
  {
    word: "mộ điệu",
    part_of_speech: "tính từ",
    meaning:
      "rất hâm mộ và biết thưởng thức, đánh giá về một lĩnh vực nào đó (thường là về nghệ thuật, thể thao): giới mộ điệu",
    example: "giới mộ điệu",
  },
  {
    word: "mô hình",
    part_of_speech: "danh từ",
    meaning:
      "vật cùng hình dạng nhưng được làm thu nhỏ lại nhiều lần, mô phỏng cấu tạo và hoạt động của một vật khác để tiện trình bày, nghiên cứu: mô hình máy bay * mô hình khu đô thị mới",
    example: "mô hình máy bay * mô hình khu đô thị mới",
  },
  {
    word: "mô hình",
    part_of_speech: "danh từ",
    meaning:
      "hình thức diễn đạt hết sức gọn các đặc trưng chủ yếu của một đối tượng theo một phương tiện nào đó để nghiên cứu đối tượng ấy: mô hình của câu đơn",
    example: "mô hình của câu đơn",
  },
  {
    word: "mồ mả",
    part_of_speech: "danh từ",
    meaning: "nơi chôn cất người chết (nói khái quát): chăm sóc mồ mả tổ tiên",
    example: "chăm sóc mồ mả tổ tiên",
  },
  {
    word: "mô phạm",
    part_of_speech: "tính từ",
    meaning: "mẫu mực, chuẩn mực để mọi người noi theo: con người rất mô phạm",
    example: "con người rất mô phạm",
  },
  {
    word: "mồ ma",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) thời còn sống của một người nào đó đã chết tương đối lâu: căn nhà được xây từ hồi còn mồ ma ông cụ",
    example: "căn nhà được xây từ hồi còn mồ ma ông cụ",
  },
  {
    word: "mộ táng",
    part_of_speech: "danh từ",
    meaning: "mộ từ thời xa xưa: phát hiện một khu mộ táng lớn",
    example: "phát hiện một khu mộ táng lớn",
  },
  {
    word: "mô phỏng",
    part_of_speech: "động từ",
    meaning:
      "phỏng theo, lấy làm mẫu (để tạo ra cái gì):  là âm thanh mô phỏng tiếng mèo kêu",
    example: "là âm thanh mô phỏng tiếng mèo kêu",
  },
  {
    word: "mô tả",
    part_of_speech: "động từ",
    meaning: "như miêu tả: mô tả chi tiết các thành phần cấu tạo của máy",
    example: "mô tả chi tiết các thành phần cấu tạo của máy",
  },
  {
    word: "mô tê",
    part_of_speech: "trợ từ",
    meaning:
      "(khẩu ngữ) từ ngữ dùng để nhấn mạnh ý phủ định, hoàn toàn không hiểu, không hề biết gì cả: chẳng hiểu mô tê gì!",
    example: "chẳng hiểu mô tê gì!",
  },
  {
    word: "mô tô",
    part_of_speech: "danh từ",
    meaning:
      "xe hai bánh chạy bằng động cơ, có hình dáng to, nặng và công suất lớn hơn xe máy: đi mô tô phân khối lớn",
    example: "đi mô tô phân khối lớn",
  },
  {
    word: "mô típ",
    part_of_speech: "danh từ",
    meaning:
      "yếu tố cơ bản trong cấu tạo đề tài của tác phẩm nghệ thuật: vở kịch được xây dựng theo một mô típ quen thuộc",
    example: "vở kịch được xây dựng theo một mô típ quen thuộc",
  },
  {
    word: "mô tơ",
    part_of_speech: "danh từ",
    meaning: "động cơ: mô tơ điện",
    example: "mô tơ điện",
  },
  {
    word: "mổ xẻ",
    part_of_speech: "động từ",
    meaning:
      "phân tích một cách tỉ mỉ, cặn kẽ để hiểu thật thấu đáo: vấn đề được đưa ra mổ xẻ giữa buổi họp",
    example: "vấn đề được đưa ra mổ xẻ giữa buổi họp",
  },
  {
    word: "mô-đen",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) kiểu, mốt: chiếc điện thoại model mới nhất",
    example: "chiếc điện thoại model mới nhất",
  },
  {
    word: "mô-đen",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (kiểu) mới, hợp thời trang: diện bộ trang phục rất model",
    example: "diện bộ trang phục rất model",
  },
  {
    word: "mô-đéc",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) mốt, hiện đại: chiếc xe trông rất modern.",
    example: "chiếc xe trông rất modern.",
  },
  {
    word: "mô-nô",
    part_of_speech: "danh từ",
    meaning:
      "kĩ thuật thu và phát lại âm thanh chỉ bằng một kênh, nghe tất cả âm thanh như đều từ chỉ một nguồn âm; phân biệt với stereo: đĩa nhạc mono * âm thanh mono",
    example: "đĩa nhạc mono * âm thanh mono",
  },
  {
    word: "mốc",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi chung một số loại nấm nhỏ hay mọc trên các chất hữu cơ ẩm ướt: mốc tương * gạo bị ẩm, lên mốc",
    example: "mốc tương * gạo bị ẩm, lên mốc",
  },
  {
    word: "mốc",
    part_of_speech: "tính từ",
    meaning: "có mốc làm cho bẩn hoặc kém phẩm chất: gạo mốc * quần áo bị mốc",
    example: "gạo mốc * quần áo bị mốc",
  },
  {
    word: "mốc",
    part_of_speech: "trợ từ",
    meaning:
      "(khẩu ngữ) từ nhấn mạnh ý phủ định, không có hoặc không có giá trị: chẳng còn xu mốc nào trong túi",
    example: "chẳng còn xu mốc nào trong túi",
  },
  {
    word: "mốc",
    part_of_speech: "danh từ",
    meaning: "cột cắm để đánh dấu ranh giới: cột mốc biên giới * cắm mốc",
    example: "cột mốc biên giới * cắm mốc",
  },
  {
    word: "mốc",
    part_of_speech: "danh từ",
    meaning:
      "sự kiện hay thời điểm quan trọng đánh dấu một giai đoạn, một bước ngoặt trong quá trình lịch sử: cách mạng tháng Tám là một cái mốc quan trọng trong lịch sử nước nhà",
    example:
      "cách mạng tháng Tám là một cái mốc quan trọng trong lịch sử nước nhà",
  },
  {
    word: "mốc giới",
    part_of_speech: "danh từ",
    meaning:
      "mốc đánh dấu giới hạn giữa hai khu vực, hai địa phận liền nhau: mốc giới địa chính",
    example: "mốc giới địa chính",
  },
  {
    word: "mộc",
    part_of_speech: "danh từ",
    meaning: "đồ gỗ (nói khái quát): đồ mộc * theo học nghề mộc",
    example: "đồ mộc * theo học nghề mộc",
  },
  {
    word: "mộc",
    part_of_speech: "tính từ",
    meaning:
      "(đồ gỗ, gạch ngói, vải lụa, v.v.) ở trạng thái thô sơ, chưa được gia công thêm cho đẹp, bóng: guốc mộc * chiếu mộc * vải để mộc, không nhuộm",
    example: "guốc mộc * chiếu mộc * vải để mộc, không nhuộm",
  },
  {
    word: "mốc meo",
    part_of_speech: "tính từ",
    meaning: "mốc nhiều và dày đặc (nói khái quát): tường nhà mốc meo",
    example: "tường nhà mốc meo",
  },
  {
    word: "mộc mạc",
    part_of_speech: "tính từ",
    meaning:
      "giản dị, đơn sơ, giữ nguyên vẻ tự nhiên: ăn nói mộc mạc * sống giản dị, mộc mạc",
    example: "ăn nói mộc mạc * sống giản dị, mộc mạc",
  },
  {
    word: "mốc xì",
    part_of_speech: "tính từ",
    meaning:
      "(Ít dùng) mốc nhiều đến mức xám đen lại, do để quá lâu ngày: gạo để mốc xì",
    example: "gạo để mốc xì",
  },
  {
    word: "mốc xì",
    part_of_speech: "trợ từ",
    meaning:
      "(Thông tục) như mốc (nhưng nghĩa mạnh hơn): có cái mốc xì gì đâu!",
    example: "có cái mốc xì gì đâu!",
  },
  {
    word: "mỗi",
    part_of_speech: "danh từ",
    meaning:
      "từ chỉ một phần tử bất kì của một tập hợp cùng loại, được xét riêng lẻ, nhưng nhằm để qua đó nói chung cho mọi phần tử của tập hợp: mỗi giờ đi được 40 kilomet * mỗi mâm có sáu người",
    example: "mỗi giờ đi được 40 kilomet * mỗi mâm có sáu người",
  },
  {
    word: "mỗi",
    part_of_speech: "trợ từ",
    meaning:
      "(khẩu ngữ) từ dùng để nhấn mạnh thêm về mức chỉ có chừng ấy (thường là một) mà thôi, không có hơn: mỗi mình nó làm được * được mỗi một điểm mười",
    example: "mỗi mình nó làm được * được mỗi một điểm mười",
  },
  {
    word: "môi",
    part_of_speech: "danh từ",
    meaning:
      "nếp cơ mềm làm thành cửa miệng: bĩu môi * Môi hở răng lạnh. (tục ngữ)",
    example: "bĩu môi * Môi hở răng lạnh.",
  },
  {
    word: "môi",
    part_of_speech: "danh từ",
    meaning:
      "(Bắc) (cũng muôi) (Nam vá) đồ dùng gần giống như thìa, nhưng to và sâu lòng hơn, cán dài, dùng để múc thức ăn: Lành làm gáo, vỡ làm môi. (tục ngữ)",
    example: "Lành làm gáo, vỡ làm môi.",
  },
  {
    word: "mối",
    part_of_speech: "danh từ",
    meaning:
      "bọ cánh thẳng, sống thành tổ dưới đất, thường hay xông làm hỏng đồ gỗ, quần áo, sách vở: tổ mối * quần áo bị mối xông",
    example: "tổ mối * quần áo bị mối xông",
  },
  {
    word: "mối",
    part_of_speech: "danh từ",
    meaning:
      "đoạn đầu của sợi dây, sợi chỉ dùng để buộc, thắt lại với nhau: gỡ các mối dây * trăm mối tơ vò * quy về một mối (b)",
    example: "gỡ các mối dây * trăm mối tơ vò * quy về một mối (b)",
  },
  {
    word: "mối",
    part_of_speech: "danh từ",
    meaning: "chỗ nối, chỗ thắt: mối lạt * bong mối hàn",
    example: "mối lạt * bong mối hàn",
  },
  {
    word: "mối",
    part_of_speech: "danh từ",
    meaning:
      "chỗ từ đó có thể tạo cơ sở cho mối quan hệ với một tổ chức: tìm mối liên lạc",
    example: "tìm mối liên lạc",
  },
  {
    word: "mối",
    part_of_speech: "danh từ",
    meaning: "chỗ từ đó có thể lần ra sự việc: một mối quan trọng của vụ án",
    example: "một mối quan trọng của vụ án",
  },
  {
    word: "mối",
    part_of_speech: "danh từ",
    meaning:
      "từ chỉ từng hiện tượng, trạng thái riêng lẻ thuộc phạm vi tình cảm, quan hệ xã hội của con người: mối lo * dẹp mối bất bình * mối tình chung thuỷ",
    example: "mối lo * dẹp mối bất bình * mối tình chung thuỷ",
  },
  {
    word: "mối",
    part_of_speech: "danh từ",
    meaning:
      'người đứng ra làm môi giới cho việc hôn nhân, buôn bán: bà mối * "Ghế trên ngồi tót sỗ sàng, Buồng trong mối đã giục nàng kíp ra." (TKiều)',
    example:
      'bà mối * "Ghế trên ngồi tót sỗ sàng, Buồng trong mối đã giục nàng kíp ra." (TKiều)',
  },
  {
    word: "mối",
    part_of_speech: "động từ",
    meaning: "(Khẩu ngữ) làm mối: mối cho một đám ở làng bên",
    example: "mối cho một đám ở làng bên",
  },
  {
    word: "mội",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) mạch nước ngầm: đào giếng đúng mội",
    example: "đào giếng đúng mội",
  },
  {
    word: "mốc thếch",
    part_of_speech: "tính từ",
    meaning:
      "mốc đến mức trắng xám ra: trời hanh, da dẻ mốc thếch * cái túi vải mốc thếch",
    example: "trời hanh, da dẻ mốc thếch * cái túi vải mốc thếch",
  },
  {
    word: "mồi",
    part_of_speech: "danh từ",
    meaning: "đồi mồi (nói tắt): da mồi tóc sương",
    example: "da mồi tóc sương",
  },
  {
    word: "mồi",
    part_of_speech: "danh từ",
    meaning:
      "thức ăn của các loài động vật, nói chung: cọp rình mồi * chim mẹ đang mớm mồi cho con * kiến tha mồi",
    example: "cọp rình mồi * chim mẹ đang mớm mồi cho con * kiến tha mồi",
  },
  {
    word: "mồi",
    part_of_speech: "danh từ",
    meaning:
      "(Phương ngữ, Khẩu ngữ) thức nhắm: kiếm ít mồi về nhậu * mồi nhậu là mấy con khô mực",
    example: "kiếm ít mồi về nhậu * mồi nhậu là mấy con khô mực",
  },
  {
    word: "mồi",
    part_of_speech: "danh từ",
    meaning:
      "thức ăn mắc vào lưỡi câu hay cho vào bẫy để nhử bắt động vật: mồi giun * mồi bẫy chuột",
    example: "mồi giun * mồi bẫy chuột",
  },
  {
    word: "mồi",
    part_of_speech: "danh từ",
    meaning: "con vật dùng để nhử bắt các con vật khác cùng loài: chim mồi",
    example: "chim mồi",
  },
  {
    word: "mồi",
    part_of_speech: "danh từ",
    meaning:
      "cái có sức quyến rũ lớn, khiến người ta dễ mắc vào tròng: đem tiền ra làm mồi",
    example: "đem tiền ra làm mồi",
  },
  {
    word: "mồi",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) (quần áo) đẹp, sang nhất, chuyên dùng để chưng diện: cái áo mồi * diện bộ mồi",
    example: "cái áo mồi * diện bộ mồi",
  },
  {
    word: "mồi",
    part_of_speech: "danh từ",
    meaning:
      "vật khô, dễ cháy, thường được bện lại, dùng để giữ hay dẫn lửa: mồi rơm * mồi thuốc nổ",
    example: "mồi rơm * mồi thuốc nổ",
  },
  {
    word: "mồi",
    part_of_speech: "danh từ",
    meaning:
      "lượng thuốc lào vê tròn, đủ một lần hút: đặt mồi thuốc vào nõ điếu",
    example: "đặt mồi thuốc vào nõ điếu",
  },
  {
    word: "mồi",
    part_of_speech: "động từ",
    meaning:
      "đốt tiếp bằng cách cho chạm sát vào vật đang cháy: mồi thêm một viên than * anh cho mồi nhờ điếu thuốc!",
    example: "mồi thêm một viên than * anh cho mồi nhờ điếu thuốc!",
  },
  {
    word: "môi giới",
    part_of_speech: "",
    meaning:
      "(người) làm trung gian để cho hai bên gặp gỡ, tiếp xúc, giao thiệp với nhau: môi giới làm ăn * người môi giới",
    example: "môi giới làm ăn * người môi giới",
  },
  {
    word: "mồi chài",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) quyến rũ để đưa vào tròng: dùng gái đẹp để mồi chài",
    example: "dùng gái đẹp để mồi chài",
  },
  {
    word: "mối giường",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, hiếm) giường mối: "Trộm nghe kẻ lớn trong nhà, ở vào khuôn phép, nói ra mối giường." (TKiều)',
    example:
      'Trộm nghe kẻ lớn trong nhà, ở vào khuôn phép, nói ra mối giường." (TKiều)',
  },
  {
    word: "mối hàng",
    part_of_speech: "danh từ",
    meaning: "khách hàng quen thuộc: mất mối hàng",
    example: "mất mối hàng",
  },
  {
    word: "mối lái",
    part_of_speech: "động từ",
    meaning:
      "làm mối (nói khái quát): làm trung gian mối lái * nhờ người mối lái",
    example: "làm trung gian mối lái * nhờ người mối lái",
  },
  {
    word: "mối lái",
    part_of_speech: "danh từ",
    meaning: "người làm mối: lấy nhau qua mối lái",
    example: "lấy nhau qua mối lái",
  },
  {
    word: "mỗi một",
    part_of_speech: "",
    meaning:
      "như mỗi (ng1; nhưng nghĩa mạnh hơn): mỗi một nhà đóng 100 nghìn đồng * mỗi một năm một khác",
    example: "mỗi một nhà đóng 100 nghìn đồng * mỗi một năm một khác",
  },
  {
    word: "mối manh",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) như manh mối: tìm ra mối manh của vụ việc * mối manh làm ăn",
    example: "tìm ra mối manh của vụ việc * mối manh làm ăn",
  },
  {
    word: "mối manh",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) làm mối: nhờ bạn bè mối manh cho một đám",
    example: "nhờ bạn bè mối manh cho một đám",
  },
  {
    word: "môi sinh",
    part_of_speech: "danh từ",
    meaning: "môi trường sống của sinh vật: bảo vệ môi sinh",
    example: "bảo vệ môi sinh",
  },
  {
    word: "môi trường",
    part_of_speech: "danh từ",
    meaning:
      "nơi xảy ra một hiện tượng hoặc diễn ra một quá trình, trong quan hệ với hiện tượng, quá trình ấy: môi trường acid",
    example: "môi trường acid",
  },
  {
    word: "môi trường",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ những điều kiện tự nhiên, xã hội, trong đó con người hay một sinh vật tồn tại, phát triển, trong quan hệ với con người, với sinh vật ấy: bảo vệ môi trường sống * môi trường công tác thuận lợi",
    example: "bảo vệ môi trường sống * môi trường công tác thuận lợi",
  },
  {
    word: "môi trường sinh thái",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ các điều kiện vô cơ và hữu cơ của các hệ sinh thái ảnh hưởng đến đời sống của xã hội loài người: cải thiện môi trường sinh thái",
    example: "cải thiện môi trường sinh thái",
  },
  {
    word: "mỗi tội",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) như chỉ mỗi tội: thông minh, nhanh nhẹn nhưng mỗi tội lười",
    example: "thông minh, nhanh nhẹn nhưng mỗi tội lười",
  },
  {
    word: "mồm loa mép giải",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) to tiếng và lắm lời, nói át cả người khác (hàm ý chê): hơi một tí là mồm loa mép giải",
    example: "hơi một tí là mồm loa mép giải",
  },
  {
    word: "mồm",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) miệng của con người, thường được coi là biểu tượng cho việc nói năng không hay, không đúng lúc: lắm mồm * không biết gì cũng chõ mồm vào",
    example: "lắm mồm * không biết gì cũng chõ mồm vào",
  },
  {
    word: "mồm mép",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) mồm và mép; thường dùng để chỉ khả năng ăn nói hoạt bát, lém lỉnh: mồm mép liến thoắng",
    example: "mồm mép liến thoắng",
  },
  {
    word: "mồm mép",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (ăn nói) hoạt bát, lém lỉnh (hàm ý chê): anh chàng cũng mồm mép ra phết!",
    example: "anh chàng cũng mồm mép ra phết!",
  },
  {
    word: "môn",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) môn học hoặc bộ môn (nói tắt): môn toán * học giỏi môn văn",
    example: "môn toán * học giỏi môn văn",
  },
  {
    word: "môn",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) mặt đặc biệt (nói về một tính cách, một hoạt động nào đó của con người; thường dùng với hàm ý châm biếm hoặc mỉa mai): môn nói phét thì không ai bằng",
    example: "môn nói phét thì không ai bằng",
  },
  {
    word: "môn",
    part_of_speech: "danh từ",
    meaning: "phương thuốc đông y: môn thuốc gia truyền",
    example: "môn thuốc gia truyền",
  },
  {
    word: "môn bài",
    part_of_speech: "danh từ",
    meaning:
      "giấy phép mở cửa hàng buôn bán, kinh doanh: đóng thuế môn bài (thuế kinh doanh buôn bán)",
    example: "đóng thuế môn bài (thuế kinh doanh buôn bán)",
  },
  {
    word: "mồn một",
    part_of_speech: "tính từ",
    meaning: "rõ đến từng chi tiết: nghe rõ mồn một",
    example: "nghe rõ mồn một",
  },
  {
    word: "môn đệ",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, trang trọng) học trò của một người thầy đáng kính: Nhan Hồi là môn đệ của Khổng Tử",
    example: "Nhan Hồi là môn đệ của Khổng Tử",
  },
  {
    word: "môn phái",
    part_of_speech: "danh từ",
    meaning: "(cũ) như trường phái.",
    example: "đệ tử của môn phái Thiếu Lâm",
  },
  {
    word: "mống",
    part_of_speech: "danh từ",
    meaning:
      "đoạn cầu vồng hiện ra ở chân trời: mống bên đông, vồng bên tây, chẳng mưa dây thì bão giật (tng)",
    example: "mống bên đông, vồng bên tây, chẳng mưa dây thì bão giật (tng)",
  },
  {
    word: "mống",
    part_of_speech: "danh từ",
    meaning: "mầm mới nhú: mống khoai",
    example: "mống khoai",
  },
  {
    word: "mống",
    part_of_speech: "danh từ",
    meaning:
      "(thông tục) từ dùng để chỉ từng cá thể người hoặc động vật, thường với số lượng ít (hàm ý coi thường): không còn một mống * nhà chỉ có mấy mống",
    example: "không còn một mống * nhà chỉ có mấy mống",
  },
  {
    word: "mống",
    part_of_speech: "tính từ",
    meaning: "(Từ cũ) dại, không khôn ngoan: khôn sống mống chết (tng)",
    example: "khôn sống mống chết (tng)",
  },
  {
    word: "môn sinh",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) học trò, trong mối quan hệ với thầy dạy: môn sinh của trường phái yoga",
    example: "môn sinh của trường phái yoga",
  },
  {
    word: "mông",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) mông má (nói tắt): mông lại chiếc xe cũ",
    example: "mông lại chiếc xe cũ",
  },
  {
    word: "mông",
    part_of_speech: "tính từ",
    meaning:
      '(nhìn) xa về phía trước, vẻ như đang nghĩ ngợi, trông mong điều gì: "(...) anh không nhìn nữa mà ngó mông ra biển, vẻ mặt trở nên buồn bã, nghĩ ngợi." (AĐức; 20)',
    example:
      '(...) anh không nhìn nữa mà ngó mông ra biển, vẻ mặt trở nên buồn bã, nghĩ ngợi." (AĐức; 20)',
  },
  {
    word: "mồng",
    part_of_speech: "danh từ",
    meaning:
      "(Nam) mào (= phần lông hay thịt nhô cao trên đầu loài vật): đỏ như cái mồng gà",
    example: "đỏ như cái mồng gà",
  },
  {
    word: "mồng",
    part_of_speech: "danh từ",
    meaning:
      "từ đặt trước các danh từ chỉ số trong những tổ hợp chỉ mười ngày đầu của tháng, theo âm lịch: ngày mồng hai * mồng mười sẽ khởi hành",
    example: "ngày mồng hai * mồng mười sẽ khởi hành",
  },
  {
    word: "mộng",
    part_of_speech: "danh từ",
    meaning: "mầm mới nhú ra ở hạt: thóc giống ủ đã mọc mộng",
    example: "thóc giống ủ đã mọc mộng",
  },
  {
    word: "mộng",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức xơ mọc từ kết mạc, lan dần vào giác mạc và có thể che lấp đồng tử: mắt có mộng",
    example: "mắt có mộng",
  },
  {
    word: "mộng",
    part_of_speech: "danh từ",
    meaning:
      "gờ trên một chi tiết khớp vào rãnh hay ổ có hình dáng và kích thước tương ứng của một chi tiết khác, để liên kết các chi tiết này với nhau: mộng tủ * mộng không khớp",
    example: "mộng tủ * mộng không khớp",
  },
  {
    word: "mộng",
    part_of_speech: "danh từ",
    meaning:
      "hiện tượng thấy người hay sự việc hiện ra như thật trong giấc ngủ: gặp nhau trong mộng * giấc mộng",
    example: "gặp nhau trong mộng * giấc mộng",
  },
  {
    word: "mộng",
    part_of_speech: "danh từ",
    meaning:
      "điều luôn luôn được hình dung, tưởng tượng tới và mong muốn trở thành sự thật: ôm mộng văn chương * người yêu trong mộng * vỡ mộng",
    example: "ôm mộng văn chương * người yêu trong mộng * vỡ mộng",
  },
  {
    word: "mộng",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) thấy người hay sự việc hiện ra trong giấc ngủ: mộng thấy chuyện chẳng lành",
    example: "mộng thấy chuyện chẳng lành",
  },
  {
    word: "mộng",
    part_of_speech: "tính từ",
    meaning:
      "(trâu bò) to béo (thường đã thiến): bò mộng * to như con trâu mộng",
    example: "bò mộng * to như con trâu mộng",
  },
  {
    word: "mộng du",
    part_of_speech: "động từ",
    meaning:
      "(trạng thái bệnh lí của con người) đi lại và hoạt động trong khi đang ngủ: bị mộng du",
    example: "bị mộng du",
  },
  {
    word: "mống cụt",
    part_of_speech: "danh từ",
    meaning:
      "đoạn cầu vồng hiện ra ở chân trời: mống bên đông, vồng bên tây, chẳng mưa dây thì bão giật (tng)",
    example: "mống bên đông, vồng bên tây, chẳng mưa dây thì bão giật (tng)",
  },
  {
    word: "mống cụt",
    part_of_speech: "danh từ",
    meaning: "mầm mới nhú: mống khoai",
    example: "mống khoai",
  },
  {
    word: "mống cụt",
    part_of_speech: "danh từ",
    meaning:
      "(thông tục) từ dùng để chỉ từng cá thể người hoặc động vật, thường với số lượng ít (hàm ý coi thường): không còn một mống * nhà chỉ có mấy mống",
    example: "không còn một mống * nhà chỉ có mấy mống",
  },
  {
    word: "mống cụt",
    part_of_speech: "tính từ",
    meaning: "(Từ cũ) dại, không khôn ngoan: khôn sống mống chết (tng)",
    example: "khôn sống mống chết (tng)",
  },
  {
    word: "mộng ảo",
    part_of_speech: "danh từ",
    meaning: "(văn chương) như ảo mộng (ng2): thế giới mộng ảo",
    example: "thế giới mộng ảo",
  },
  {
    word: "mộng mị",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) hão huyền, không thực, tựa như trong chiêm bao: chiêm bao là mộng mị, không nên tin",
    example: "chiêm bao là mộng mị, không nên tin",
  },
  {
    word: "mộng mơ",
    part_of_speech: "động từ",
    meaning: "như mơ mộng: thời áo trắng mộng mơ",
    example: "thời áo trắng mộng mơ",
  },
  {
    word: "mông má",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) sửa sang, trau chuốt lại làm cho có vẻ như mới: mông má lại chiếc xe cũ để đem bán",
    example: "mông má lại chiếc xe cũ để đem bán",
  },
  {
    word: "mộng mẹo",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) mộng để lắp, ghép cho chặt, khít (nói khái quát): chiếc bàn cũ, mộng mẹo lỏng lẻo hết cả",
    example: "chiếc bàn cũ, mộng mẹo lỏng lẻo hết cả",
  },
  {
    word: "mông lung",
    part_of_speech: "tính từ",
    meaning:
      "(khoảng không gian) rộng và lờ mờ, không rõ nét, gây cảm giác hư ảo: khoảng tối mông lung * cảnh vật mông lung, huyền ảo",
    example: "khoảng tối mông lung * cảnh vật mông lung, huyền ảo",
  },
  {
    word: "mông lung",
    part_of_speech: "tính từ",
    meaning:
      "(ý nghĩ) rộng và lan man, không tập trung, không rõ nét: suy nghĩ mông lung",
    example: "suy nghĩ mông lung",
  },
  {
    word: "mông mênh",
    part_of_speech: "tính từ",
    meaning: "(văn chương) như mênh mông: cánh đồng rộng mông mênh",
    example: "cánh đồng rộng mông mênh",
  },
  {
    word: "mồng thất",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) ngày không có trong lịch; ý nói chẳng bao giờ có ngày đó cả: đợi đến mồng thất * làm thế thì đến mồng thất mới xong",
    example: "đợi đến mồng thất * làm thế thì đến mồng thất mới xong",
  },
  {
    word: "mông mốc",
    part_of_speech: "tính từ",
    meaning: "hơi mốc: điếu thuốc lá đã mông mốc",
    example: "điếu thuốc lá đã mông mốc",
  },
  {
    word: "mông muội",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về giai đoạn hình thành và phát triển đầu tiên của xã hội nguyên thuỷ, khi đời sống con người chưa khác đời sống thú vật bao nhiêu, con người chủ yếu sống bằng hái lượm: thời kì mông muội * giai đoạn mông muội",
    example: "thời kì mông muội * giai đoạn mông muội",
  },
  {
    word: "mông muội",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) ngu dại, tối tăm: đầu óc còn mông muội * một con người mông muội",
    example: "đầu óc còn mông muội * một con người mông muội",
  },
  {
    word: "một bề",
    part_of_speech: "",
    meaning:
      'chỉ một cách như vậy, không có cách nào khác: chịu lép một bề * "Nàng rằng: Đã quyết một bề, Nhện này vương lấy tơ kia mấy lần!" (TKiều)',
    example:
      'chịu lép một bề * "Nàng rằng: Đã quyết một bề, Nhện này vương lấy tơ kia mấy lần!" (TKiều)',
  },
  {
    word: "một bề",
    part_of_speech: "",
    meaning:
      "(việc sinh con) chỉ toàn trai, hoặc chỉ toàn gái: sinh con một bề",
    example: "sinh con một bề",
  },
  {
    word: "mông quạnh",
    part_of_speech: "tính từ",
    meaning:
      "(đồng, ruộng) rộng nhưng trống trải và vắng lặng: chốn đồng không mông quạnh",
    example: "chốn đồng không mông quạnh",
  },
  {
    word: "mộng tưởng",
    part_of_speech: "danh từ",
    meaning:
      "điều mong ước quá cao xa, chỉ thấy được trong mộng, trong tưởng tượng: sống trong mộng tưởng",
    example: "sống trong mộng tưởng",
  },
  {
    word: "một",
    part_of_speech: "danh từ",
    meaning:
      "số (ghi bằng 1) đầu tiên trong dãy số tự nhiên: đếm từ một đến mười * nhà ở tầng một * chỉ có một người",
    example: "đếm từ một đến mười * nhà ở tầng một * chỉ có một người",
  },
  {
    word: "một",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) tháng mười một âm lịch (nói tắt): tháng một * một, chạp, giêng, hai",
    example: "tháng một * một, chạp, giêng, hai",
  },
  {
    word: "một",
    part_of_speech: "danh từ",
    meaning:
      "từ biểu thị tính chất lần lượt của từng đơn vị giống nhau nối tiếp nhau: đọc tên từng người một * nói gằn từng tiếng một * ăn dè từng tí một",
    example:
      "đọc tên từng người một * nói gằn từng tiếng một * ăn dè từng tí một",
  },
  {
    word: "một",
    part_of_speech: "danh từ",
    meaning:
      "từ biểu thị tính chất toàn khối không thể chia cắt, hoặc tính chất thống nhất, nhất trí như một khối: trước sau như một * trên dưới như một * Bắc Nam sum họp một nhà",
    example: "trước sau như một * trên dưới như một * Bắc Nam sum họp một nhà",
  },
  {
    word: "một",
    part_of_speech: "tính từ",
    meaning: "độc nhất (chứ không phải là có nhiều): con một",
    example: "con một",
  },
  {
    word: "một",
    part_of_speech: "tính từ",
    meaning: "chỉ dùng cho một người; phân biệt với đôi: giường một * màn một",
    example: "giường một * màn một",
  },
  {
    word: "mốt",
    part_of_speech: "danh từ",
    meaning:
      "kiểu sinh hoạt, thường là kiểu ăn mặc, được số đông ưa chuộng trong một thời gian nào đó: mốt mới * chạy theo mốt * ăn mặc không hợp mốt",
    example: "mốt mới * chạy theo mốt * ăn mặc không hợp mốt",
  },
  {
    word: "mốt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) đúng mốt, hợp với mốt đang thịnh hành: bộ quần áo rất mốt",
    example: "bộ quần áo rất mốt",
  },
  {
    word: "mốt",
    part_of_speech: "danh từ",
    meaning:
      "một: sáu mươi mốt * hai mốt (hai mươi mốt) * ba nghìn mốt (ba nghìn===== một =====",
    example:
      "sáu mươi mốt * hai mốt (hai mươi mốt) * ba nghìn mốt (ba nghìn===== một =====",
  },
  {
    word: "mốt",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) ngày kia: không mai thì mốt",
    example: "không mai thì mốt",
  },
  {
    word: "mồng tơi",
    part_of_speech: "danh từ",
    meaning:
      "cây trồng thân leo, lá tròn, mềm, to và dày, có nhiều chất nhớt, lá và ngọn thường dùng nấu canh: rau mồng tơi",
    example: "rau mồng tơi",
  },
  {
    word: "mộng ước",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương) điều tốt đẹp luôn luôn mơ ước có được: mộng ước không thành * nuôi mộng ước trở thành phi công",
    example: "mộng ước không thành * nuôi mộng ước trở thành phi công",
  },
  {
    word: "một chiều",
    part_of_speech: "danh từ",
    meaning:
      "hướng duy nhất, không có hướng ngược lại: đường một chiều * dòng điện một chiều",
    example: "đường một chiều * dòng điện một chiều",
  },
  {
    word: "một chiều",
    part_of_speech: "danh từ",
    meaning:
      "chỉ một phía, một mặt, thiếu hẳn những phía khác, mặt khác: suy nghĩ một chiều * thông tin một chiều * đoàn kết một chiều",
    example: "suy nghĩ một chiều * thông tin một chiều * đoàn kết một chiều",
  },
  {
    word: "một cách",
    part_of_speech: "danh từ",
    meaning:
      "cách thức diễn ra như thế nào đó của hành động, hiện tượng, sự việc: nói một cách dứt khoát * xử sự một cách có văn hoá",
    example: "nói một cách dứt khoát * xử sự một cách có văn hoá",
  },
  {
    word: "một cách",
    part_of_speech: "danh từ",
    meaning:
      "vẻ biểu hiện ra như thế nào đó của tính chất: xấu một cách khủng khiếp * im lặng một cách đáng sợ",
    example: "xấu một cách khủng khiếp * im lặng một cách đáng sợ",
  },
  {
    word: "một chạp",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) tháng một và tháng chạp (nói gộp); chỉ cuối năm: hai người sẽ tổ chức vào cữ một chạp",
    example: "hai người sẽ tổ chức vào cữ một chạp",
  },
  {
    word: "một chút",
    part_of_speech: "danh từ",
    meaning: "mức độ không đáng kể: hơi buồn một chút * không một chút hối hận",
    example: "hơi buồn một chút * không một chút hối hận",
  },
  {
    word: "một đôi",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) như một vài: bày tỏ một đôi lời * có gặp nhau một đôi lần",
    example: "bày tỏ một đôi lời * có gặp nhau một đôi lần",
  },
  {
    word: "một đồng một chữ",
    part_of_speech: "",
    meaning:
      "một khoản tiền rất nhỏ, rất ít ỏi: một đồng một chữ cũng không có",
    example: "một đồng một chữ cũng không có",
  },
  {
    word: "một hai",
    part_of_speech: "phụ từ",
    meaning:
      '(khẩu ngữ) một cách nhất quyết, nhất định không thay đổi ý kiến: cứ một hai đòi đi * "Trót lời gắn bó một hai, Càng sâu nghĩa bể càng dài tình sông." (ca dao)',
    example:
      'cứ một hai đòi đi * "Trót lời gắn bó một hai, Càng sâu nghĩa bể càng dài tình sông." (ca dao)',
  },
  {
    word: "một ít",
    part_of_speech: "danh từ",
    meaning:
      "một phần nào đó, thường là rất nhỏ: bỏ thêm một ít muối * còn thiếu một ít tiền",
    example: "bỏ thêm một ít muối * còn thiếu một ít tiền",
  },
  {
    word: "một khi",
    part_of_speech: "",
    meaning:
      "tổ hợp biểu thị ý nhấn mạnh điều xảy ra sau đó là tất yếu phải thế, khó có thể khác đi được: một khi đã quyết thì phải làm",
    example: "một khi đã quyết thì phải làm",
  },
  {
    word: "một lòng một dạ",
    part_of_speech: "",
    meaning: "như một lòng (ng1; nhưng nghĩa mạnh hơn).",
    example: "một lòng một dạ phục vụ nhân dân",
  },
  {
    word: "một hơi",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) một cách liên tục từ đầu đến cuối không nghỉ chút nào (thường nói về khoảng thời gian tương đối ngắn): chạy thẳng một hơi về nhà * uống một hơi hết chén rượu",
    example: "chạy thẳng một hơi về nhà * uống một hơi hết chén rượu",
  },
  {
    word: "một lòng",
    part_of_speech: "danh từ",
    meaning: "tình cảm trước sau như một: một lòng yêu kính mẹ cha",
    example: "một lòng yêu kính mẹ cha",
  },
  {
    word: "một lòng",
    part_of_speech: "danh từ",
    meaning:
      "tình cảm của tất cả mọi người như một trong một việc gì: đoàn kết một lòng * trên dưới một lòng",
    example: "đoàn kết một lòng * trên dưới một lòng",
  },
  {
    word: "một lèo",
    part_of_speech: "",
    meaning: "(khẩu ngữ) như một mạch: chạy thẳng một lèo * kể luôn một lèo",
    example: "chạy thẳng một lèo * kể luôn một lèo",
  },
  {
    word: "một mai",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) một ngày nào đó sắp tới: "Một mai cha yếu, mẹ già, Bát cơm ai đỡ, chén trà ai dâng?" (ca dao)',
    example:
      'Một mai cha yếu, mẹ già, Bát cơm ai đỡ, chén trà ai dâng?" (ca dao)',
  },
  {
    word: "một mạch",
    part_of_speech: "",
    meaning:
      "một cách liên tục từ đầu đến cuối, không nghỉ, không cách quãng giữa chừng: chạy thẳng một mạch * ngủ một mạch đến sáng",
    example: "chạy thẳng một mạch * ngủ một mạch đến sáng",
  },
  {
    word: "một mực",
    part_of_speech: "phụ từ",
    meaning:
      "(làm việc gì) từ biểu thị ý dứt khoát, trước sau không thay đổi: nói thế nào cũng một mực từ chối",
    example: "nói thế nào cũng một mực từ chối",
  },
  {
    word: "một số",
    part_of_speech: "danh từ",
    meaning:
      "số lượng nào đó (thường là ít) trong quan hệ với toàn thể, tổng thể: thu thập một số chứng cứ * tham khảo một số tài liệu",
    example: "thu thập một số chứng cứ * tham khảo một số tài liệu",
  },
  {
    word: "một nghìn lẻ một",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) nhiều và đa dạng, như không thể nào kể hết: viện cả một nghìn lẻ một lí do để từ chối",
    example: "viện cả một nghìn lẻ một lí do để từ chối",
  },
  {
    word: "một mất một còn",
    part_of_speech: "",
    meaning:
      "tả sự đấu tranh gay gắt, quyết liệt, không thể thoả hiệp, nhân nhượng: cuộc chiến đấu một mất một còn",
    example: "cuộc chiến đấu một mất một còn",
  },
  {
    word: "một phép",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) (làm theo, nghe theo) một cách hoàn toàn, không hề có chút biểu hiện chống đối, kháng cự nào: sợ một phép",
    example: "sợ một phép",
  },
  {
    word: "một mình",
    part_of_speech: "",
    meaning:
      "chỉ một cá nhân mình, không cùng với ai: sống một mình * ăn một mình đau tức, làm một mình cực thân (tng)",
    example: "sống một mình * ăn một mình đau tức, làm một mình cực thân (tng)",
  },
  {
    word: "một thể",
    part_of_speech: "phụ từ",
    meaning:
      "(làm việc gì) cùng hoặc liền một lúc: làm luôn một thể * anh đợi tôi rồi ta cùng về một thể",
    example: "làm luôn một thể * anh đợi tôi rồi ta cùng về một thể",
  },
  {
    word: "một sớm một chiều",
    part_of_speech: "",
    meaning:
      "khoảng thời gian hết sức ngắn (thường hàm ý khó có thể đạt kết quả): không thể giải quyết được trong một sớm một chiều",
    example: "không thể giải quyết được trong một sớm một chiều",
  },
  {
    word: "một vừa hai phải",
    part_of_speech: "",
    meaning:
      'ở mức độ giữ cho vừa phải: "Chị ấy là chị, có quyền thật, nhưng cũng một vừa hai phải thôi. Quá lắm thì tôi phải cãi." (ĐĐThu; 2)',
    example:
      'Chị ấy là chị, có quyền thật, nhưng cũng một vừa hai phải thôi. Quá lắm thì tôi phải cãi." (ĐĐThu; 2)',
  },
  {
    word: "một thôi một hồi",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) nhiều và dồn dập trong một khoảng thời gian tương đối dài: mắng một thôi một hồi",
    example: "mắng một thôi một hồi",
  },
  {
    word: "mợ",
    part_of_speech: "danh từ",
    meaning: "vợ của cậu (có thể dùng để xưng gọi).",
    example: "mợ phán",
  },
  {
    word: "một tí",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) mức độ rất nhỏ, rất ít, gần như không: còn một tí cơm * đợi một tí * chẳng biết một tí gì",
    example: "còn một tí cơm * đợi một tí * chẳng biết một tí gì",
  },
  {
    word: "mớ",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp gồm một số vật cùng loại được gộp lại thành đơn vị: mua mớ rau muống * mớ tép",
    example: "mua mớ rau muống * mớ tép",
  },
  {
    word: "mớ",
    part_of_speech: "danh từ",
    meaning:
      "số lượng tương đối nhiều những vật, những thứ cùng loại (thường bị coi là ít có giá trị) nhưng khác nhau nhiều và ở tình trạng lộn xộn, không có trật tự (hàm ý chê): rối như mớ bòng bong * đưa ra một mớ lí thuyết * cầm theo một mớ giấy tờ",
    example:
      "rối như mớ bòng bong * đưa ra một mớ lí thuyết * cầm theo một mớ giấy tờ",
  },
  {
    word: "mớ",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) nói mê trong khi ngủ: ngủ hay mớ",
    example: "ngủ hay mớ",
  },
  {
    word: "một vài",
    part_of_speech: "danh từ",
    meaning:
      "một hoặc vài ba (nói về số lượng rất ít, không xác định): nói một vài câu ngắn gọn * ở lại chơi một vài ngày",
    example: "nói một vài câu ngắn gọn * ở lại chơi một vài ngày",
  },
  {
    word: "mơ",
    part_of_speech: "danh từ",
    meaning:
      "cây ăn quả, lá có răng nhỏ, hoa màu trắng, quả chín màu vàng lục, có lông mịn, vị chua: quả mơ * ô mai mơ",
    example: "quả mơ * ô mai mơ",
  },
  {
    word: "mơ",
    part_of_speech: "danh từ",
    meaning:
      "cây leo mọc hoang, lá có lông ở cả hai mặt, thường dùng để chữa kiết lị hoặc làm rau ăn: hấp trứng gà với lá mơ",
    example: "hấp trứng gà với lá mơ",
  },
  {
    word: "mơ",
    part_of_speech: "động từ",
    meaning:
      "thấy trong khi ngủ người hay việc mà thường ngày có thể nghĩ tới: một giấc mơ đẹp * bé mơ được đi chơi công viên",
    example: "một giấc mơ đẹp * bé mơ được đi chơi công viên",
  },
  {
    word: "mơ",
    part_of_speech: "động từ",
    meaning:
      "nghĩ tới và mong có được (những điều tốt đẹp ở trước mắt hoặc chưa hề có): mơ được bay đến các vì sao * mơ trở thành diễn viên danh tiếng",
    example: "mơ được bay đến các vì sao * mơ trở thành diễn viên danh tiếng",
  },
  {
    word: "mỡ",
    part_of_speech: "danh từ",
    meaning:
      "chất béo ở cơ thể động vật thường dùng làm thức ăn: thịt mỡ * mỡ nước * rán sành ra mỡ (tng)",
    example: "thịt mỡ * mỡ nước * rán sành ra mỡ (tng)",
  },
  {
    word: "mỡ",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) mỡ máy (nói tắt): bôi mỡ vào vòng bi",
    example: "bôi mỡ vào vòng bi",
  },
  {
    word: "mỡ",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) thuốc mỡ (nói tắt): bôi mỡ tetracyclin",
    example: "bôi mỡ tetracyclin",
  },
  {
    word: "mỡ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (da thịt, cây lá) mượt mà, có sắc thái tươi tốt: mầm cây non mỡ * đàn lợn nhanh lớn, trơn lông mỡ da",
    example: "mầm cây non mỡ * đàn lợn nhanh lớn, trơn lông mỡ da",
  },
  {
    word: "mở",
    part_of_speech: "động từ",
    meaning:
      "làm cho hoặc ở trạng thái không còn bị đóng kín, bịt kín, mà thông được với nhau: mở cổng đón khách * mở van nước * mở nắp chai * nền kinh tế mở",
    example: "mở cổng đón khách * mở van nước * mở nắp chai * nền kinh tế mở",
  },
  {
    word: "mở",
    part_of_speech: "động từ",
    meaning:
      "làm cho hoặc ở trạng thái không còn bị thu nhỏ, hạn chế, dồn, ép, gấp, v.v. lại, mà được trải rộng, xoè rộng ra, v.v.: mở tờ báo ra xem * mở túi lấy tiền * máy mở hết công suất",
    example: "mở tờ báo ra xem * mở túi lấy tiền * máy mở hết công suất",
  },
  {
    word: "mở",
    part_of_speech: "động từ",
    meaning:
      "đưa máy móc, thiết bị vào trạng thái hoạt động: mở máy phát điện * mở băng hoạt hình * mở đài",
    example: "mở máy phát điện * mở băng hoạt hình * mở đài",
  },
  {
    word: "mở",
    part_of_speech: "động từ",
    meaning:
      "tổ chức ra các cơ sở kinh tế, văn hoá, v.v. và làm cho bắt đầu hoạt động: mở cửa hàng * mở văn phòng đại diện * mở trường tư thục",
    example: "mở cửa hàng * mở văn phòng đại diện * mở trường tư thục",
  },
  {
    word: "mở",
    part_of_speech: "động từ",
    meaning:
      "tổ chức ra và bắt đầu tiến hành: mở cuộc điều tra dân số * mở hội * mở khoa thi",
    example: "mở cuộc điều tra dân số * mở hội * mở khoa thi",
  },
  {
    word: "mở",
    part_of_speech: "động từ",
    meaning:
      "làm xuất hiện một tình hình, một thời kì mới đầy triển vọng: một tương lai đầy hứa hẹn đang mở ra trước mắt",
    example: "một tương lai đầy hứa hẹn đang mở ra trước mắt",
  },
  {
    word: "mờ",
    part_of_speech: "tính từ",
    meaning:
      "(ánh sáng) yếu ớt, không rõ, không đủ sức chiếu sáng các vật xung quanh: ngọn đèn mờ * đi từ lúc mờ sáng",
    example: "ngọn đèn mờ * đi từ lúc mờ sáng",
  },
  {
    word: "mờ",
    part_of_speech: "tính từ",
    meaning:
      "(mắt) kém, không còn đủ khả năng nhìn rõ nét các vật xung quanh: mắt mờ chân chậm * bị đồng tiền làm cho mờ mắt (b)",
    example: "mắt mờ chân chậm * bị đồng tiền làm cho mờ mắt (b)",
  },
  {
    word: "mờ",
    part_of_speech: "tính từ",
    meaning:
      "(sự vật) trông không rõ nét: chữ rất mờ * cảnh vật mờ trong hơi sương",
    example: "chữ rất mờ * cảnh vật mờ trong hơi sương",
  },
  {
    word: "mờ",
    part_of_speech: "tính từ",
    meaning:
      "không láng bóng hoặc không trong suốt: bóng đèn mờ * thuỷ tinh để lâu ngày bị mờ",
    example: "bóng đèn mờ * thuỷ tinh để lâu ngày bị mờ",
  },
  {
    word: "mờ ảo",
    part_of_speech: "tính từ",
    meaning:
      "không rõ nét, gây cảm giác như không có thật: cảnh vật mờ ảo qua màn sương * ánh sáng mờ ảo",
    example: "cảnh vật mờ ảo qua màn sương * ánh sáng mờ ảo",
  },
  {
    word: "mờ ám",
    part_of_speech: "tính từ",
    meaning:
      "(suy nghĩ, hành động) không rõ ràng, có cái gì đó xấu xa giấu giếm bên trong: quan hệ mờ ám * việc làm mờ ám",
    example: "quan hệ mờ ám * việc làm mờ ám",
  },
  {
    word: "mở cờ",
    part_of_speech: "động từ",
    meaning:
      "ví trạng thái hết sức hân hoan, vui sướng trong lòng: lòng vui như mở cờ",
    example: "lòng vui như mở cờ",
  },
  {
    word: "mớ bảy mớ ba",
    part_of_speech: "",
    meaning:
      '(cũ) áo trong áo ngoài, cái đơn cái kép đủ thứ; thường dùng để tả vẻ giàu sang trong sự ăn mặc: "Người thì mớ bảy mớ ba, Người thì áo rách như là áo tơi." (ca dao)',
    example:
      'Người thì mớ bảy mớ ba, Người thì áo rách như là áo tơi." (ca dao)',
  },
  {
    word: "mở cờ trong bụng",
    part_of_speech: "",
    meaning: "như mở cờ: được tin con thi đỗ, bà mẹ như mở cờ trong bụng",
    example: "được tin con thi đỗ, bà mẹ như mở cờ trong bụng",
  },
  {
    word: "mở cửa",
    part_of_speech: "động từ",
    meaning:
      "không ngăn cản, mà để cho dễ dàng có quan hệ rộng rãi với bên ngoài, về kinh tế, xã hội: chính sách mở cửa * thời kì mở cửa",
    example: "chính sách mở cửa * thời kì mở cửa",
  },
  {
    word: "mở đầu",
    part_of_speech: "động từ",
    meaning:
      "bắt đầu diễn ra một quá trình, một sự kiện nào đó: mở đầu câu chuyện * tiết mục mở đầu chương trình",
    example: "mở đầu câu chuyện * tiết mục mở đầu chương trình",
  },
  {
    word: "mở đường",
    part_of_speech: "động từ",
    meaning:
      "tạo ra hướng mới hoặc điều kiện thuận lợi cho một quá trình hoạt động nào đó: người mở đường cho việc chinh phục vũ trụ",
    example: "người mở đường cho việc chinh phục vũ trụ",
  },
  {
    word: "mỡ gà",
    part_of_speech: "danh từ",
    meaning: "màu vàng nhạt như màu mỡ của con gà: cái áo len màu mỡ gà",
    example: "cái áo len màu mỡ gà",
  },
  {
    word: "mơ hồ",
    part_of_speech: "tính từ",
    meaning: "không rõ ràng, không xác thực: câu nói mơ hồ * lòng mơ hồ buồn",
    example: "câu nói mơ hồ * lòng mơ hồ buồn",
  },
  {
    word: "mở hàng",
    part_of_speech: "động từ",
    meaning:
      "mua hay bán lần đầu tiên trong ngày (thường được coi là dấu hiệu may mắn hoặc không may mắn cho việc buôn bán trong ngày, theo quan niệm dân gian): bán mở hàng * từ sáng đến giờ chưa có ai mở hàng",
    example: "bán mở hàng * từ sáng đến giờ chưa có ai mở hàng",
  },
  {
    word: "mở hàng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) cho tiền, quà mừng tuổi trẻ em vào dịp Tết năm mới: mở hàng cho cháu đồng bạc mới",
    example: "mở hàng cho cháu đồng bạc mới",
  },
  {
    word: "mở màn",
    part_of_speech: "động từ",
    meaning:
      "(buổi biểu diễn trên sân khấu) kéo màn sân khấu để bắt đầu buổi biểu diễn: chương trình biểu diễn sắp đến giờ mở màn",
    example: "chương trình biểu diễn sắp đến giờ mở màn",
  },
  {
    word: "mở màn",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bắt đầu tiến hành một việc gì đó: chiến dịch phản công đã mở màn",
    example: "chiến dịch phản công đã mở màn",
  },
  {
    word: "mơ màng",
    part_of_speech: "",
    meaning:
      "thấy phảng phất, không rõ ràng, trong trạng thái không hoàn toàn tỉnh táo: giấc ngủ mơ màng * “Thuốc mê đâu đã rưới vào, Mơ màng như giấc chiêm bao biết gì!” (TKiều)",
    example:
      "giấc ngủ mơ màng * “Thuốc mê đâu đã rưới vào, Mơ màng như giấc chiêm bao biết gì!” (TKiều)",
  },
  {
    word: "mơ màng",
    part_of_speech: "",
    meaning:
      "ở trạng thái say mê theo đuổi những hình ảnh xa xôi, thoát li thực tại: đôi mắt mơ màng",
    example: "đôi mắt mơ màng",
  },
  {
    word: "mơ màng",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) luôn luôn nghĩ tới, tưởng tới điều mình mong muốn (thường là không thiết thực): suốt ngày mơ màng viển vông",
    example: "suốt ngày mơ màng viển vông",
  },
  {
    word: "mở mang",
    part_of_speech: "động từ",
    meaning:
      "làm cho rộng lớn thêm lên (về phạm vi, tầm cỡ, trình độ): mở mang bờ cõi * mở mang kiến thức * đầu óc được mở mang ra nhiều",
    example:
      "mở mang bờ cõi * mở mang kiến thức * đầu óc được mở mang ra nhiều",
  },
  {
    word: "mở mày mở mặt",
    part_of_speech: "",
    meaning:
      "hãnh diện được với mọi người xung quanh: mở mày mở mặt với làng xóm",
    example: "mở mày mở mặt với làng xóm",
  },
  {
    word: "mỡ màng",
    part_of_speech: "danh từ",
    meaning: "mỡ để ăn (nói khái quát): mỡ màng dính đầy tay",
    example: "mỡ màng dính đầy tay",
  },
  {
    word: "mỡ màng",
    part_of_speech: "tính từ",
    meaning: "có vẻ mượt mà, tươi tốt: quả ổi trông mỡ màng * da dẻ mỡ màng",
    example: "quả ổi trông mỡ màng * da dẻ mỡ màng",
  },
  {
    word: "mở mặt",
    part_of_speech: "động từ",
    meaning:
      "có thể ít nhiều hãnh diện được với mọi người (do đã khá giả, thành đạt): được mở mặt với thiên hạ",
    example: "được mở mặt với thiên hạ",
  },
  {
    word: "mở mắt",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) mới ngủ dậy lúc sáng sớm (đã làm ngay việc gì rồi; thường hàm ý phàn nàn, chê trách): mới mở mắt đã kêu đói * vừa mở mắt ra đã rủ nhau đi chơi",
    example: "mới mở mắt đã kêu đói * vừa mở mắt ra đã rủ nhau đi chơi",
  },
  {
    word: "mở mắt",
    part_of_speech: "động từ",
    meaning:
      "(một số loài thú) bắt đầu mở được mắt ra để nhìn, sau khi đẻ ra được ít lâu; mới sinh: chó con mới mở mắt",
    example: "chó con mới mở mắt",
  },
  {
    word: "mở mắt",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) thấy được hoặc làm cho thấy được những sai lầm của mình: nói cho nó mở mắt ra",
    example: "nói cho nó mở mắt ra",
  },
  {
    word: "mỡ màu",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như màu mỡ: lớp đất tươi xốp mỡ màu",
    example: "lớp đất tươi xốp mỡ màu",
  },
  {
    word: "mở miệng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nói ra điều gì đó (hàm ý coi thường): ngồi im không dám mở miệng * mụ ta cứ mở miệng ra là khoe của",
    example: "ngồi im không dám mở miệng * mụ ta cứ mở miệng ra là khoe của",
  },
  {
    word: "mơ mòng",
    part_of_speech: "động từ",
    meaning:
      '(cũ, hiếm) như mơ màng (ng3): "Gác nguyệt nọ mơ mòng vẻ mặt, Lầu hoa kia phảng phất hơi hương." (CPN)',
    example:
      'Gác nguyệt nọ mơ mòng vẻ mặt, Lầu hoa kia phảng phất hơi hương." (CPN)',
  },
  {
    word: "mơ mộng",
    part_of_speech: "động từ",
    meaning:
      "say mê theo những hình ảnh tốt đẹp nhưng xa vời, không thực tế: mơ mộng viển vông * người hay mơ mộng",
    example: "mơ mộng viển vông * người hay mơ mộng",
  },
  {
    word: "mờ mịt",
    part_of_speech: "tính từ",
    meaning:
      "mờ đi, đến mức không còn nhìn thấy rõ gì được nữa: sương mù mờ mịt * trời tối tăm mờ mịt",
    example: "sương mù mờ mịt * trời tối tăm mờ mịt",
  },
  {
    word: "mờ mịt",
    part_of_speech: "tính từ",
    meaning: "không có gì sáng sủa, không có gì để hi vọng: tương lai mờ mịt",
    example: "tương lai mờ mịt",
  },
  {
    word: "mở rộng",
    part_of_speech: "động từ",
    meaning:
      "làm cho có phạm vi, quy mô trở nên rộng lớn hơn trước: mở rộng phạm vi hoạt động * được mở rộng tầm mắt",
    example: "mở rộng phạm vi hoạt động * được mở rộng tầm mắt",
  },
  {
    word: "mờ nhạt",
    part_of_speech: "tính từ",
    meaning:
      "mờ, không rõ nét: ánh trăng non mờ nhạt * một người mờ nhạt, không có gì nổi trội",
    example: "ánh trăng non mờ nhạt * một người mờ nhạt, không có gì nổi trội",
  },
  {
    word: "mơ ngủ",
    part_of_speech: "động từ",
    meaning: "ở trạng thái đang mơ trong giấc ngủ: nói như người mơ ngủ!",
    example: "nói như người mơ ngủ!",
  },
  {
    word: "mở toang",
    part_of_speech: "động từ",
    meaning: "mở tung ra, rộng ra hết mức: hai cánh cửa mở toang, thông thống",
    example: "hai cánh cửa mở toang, thông thống",
  },
  {
    word: "mở thầu",
    part_of_speech: "động từ",
    meaning:
      "mở hồ sơ dự thầu tại thời điểm đã được ấn định: kí biên bản mở thầu",
    example: "kí biên bản mở thầu",
  },
  {
    word: "mơ tưởng",
    part_of_speech: "động từ",
    meaning:
      "mong mỏi, ước mơ điều xa vời, chỉ có thể có trong tưởng tượng: mơ tưởng hão huyền * đừng có mơ tưởng cao xa",
    example: "mơ tưởng hão huyền * đừng có mơ tưởng cao xa",
  },
  {
    word: "mơ ước",
    part_of_speech: "động từ",
    meaning:
      "mong muốn, ước ao một cách thiết tha điều tốt đẹp trong tương lai: mơ ước một cuộc sống giàu có",
    example: "mơ ước một cuộc sống giàu có",
  },
  {
    word: "mơ ước",
    part_of_speech: "danh từ",
    meaning:
      "điều mong muốn tốt đẹp trong tương lai: mơ ước đã trở thành sự thật",
    example: "mơ ước đã trở thành sự thật",
  },
  {
    word: "mới",
    part_of_speech: "tính từ",
    meaning:
      "vừa được làm ra hay là chưa dùng hoặc dùng chưa lâu: mặc bộ quần áo mới * ngôi nhà mới * cơm gạo mới",
    example: "mặc bộ quần áo mới * ngôi nhà mới * cơm gạo mới",
  },
  {
    word: "mới",
    part_of_speech: "tính từ",
    meaning: "vừa có, vừa xuất hiện: tin mới * người bạn mới * sách mới",
    example: "tin mới * người bạn mới * sách mới",
  },
  {
    word: "mới",
    part_of_speech: "tính từ",
    meaning:
      "(người) vừa làm nghề nghiệp, chức vụ, v.v. nào đó chưa lâu: thợ mới * lính mới * ma cũ bắt nạt ma mới (tng)",
    example: "thợ mới * lính mới * ma cũ bắt nạt ma mới (tng)",
  },
  {
    word: "mới",
    part_of_speech: "tính từ",
    meaning:
      "phù hợp với thời đại ngày nay, với xu thế tiến bộ: tư duy mới * cách làm việc mới * con người mới * xã hội mới",
    example: "tư duy mới * cách làm việc mới * con người mới * xã hội mới",
  },
  {
    word: "mới",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị sự việc hoặc thời gian xảy ra không lâu trước thời điểm nói, hoặc trước một thời điểm nào đó trong quá khứ: mới về nước * vừa mới thi học kì xong * mới lập gia đình",
    example: "mới về nước * vừa mới thi học kì xong * mới lập gia đình",
  },
  {
    word: "mới",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị tính chất quá sớm của thời gian, hoặc quá ít của số lượng, mức độ: con bé mới lên sáu * mới thế mà đã kêu ầm lên",
    example: "con bé mới lên sáu * mới thế mà đã kêu ầm lên",
  },
  {
    word: "mới",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị sự việc, hiện tượng xảy ra muộn, và không sớm hơn thời điểm nào đó: học đến tận sáng mới đi ngủ * đến tháng sáu mới được nghỉ hè * hẹn đến Tết mới về",
    example:
      "học đến tận sáng mới đi ngủ * đến tháng sáu mới được nghỉ hè * hẹn đến Tết mới về",
  },
  {
    word: "mới",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nói đến chỉ được thực hiện khi đã có điều kiện vừa nói trước đó: làm bằng xong mới nghỉ * có bột mới gột nên hồ (tng)",
    example: "làm bằng xong mới nghỉ * có bột mới gột nên hồ (tng)",
  },
  {
    word: "mới",
    part_of_speech: "trợ từ",
    meaning:
      "(khẩu ngữ) từ biểu thị ý nhấn mạnh mức độ ngạc nhiên, như vừa mới thấy: quyển sách mới hay làm sao! * trông cái mặt mới đẹp chứ!",
    example: "quyển sách mới hay làm sao! * trông cái mặt mới đẹp chứ!",
  },
  {
    word: "mời",
    part_of_speech: "động từ",
    meaning:
      "tỏ ý mong muốn, yêu cầu ai đó làm việc gì một cách lịch sự, trân trọng: mời anh đến nhà tôi chơi * đưa tay mời ngồi * giấy mời họp",
    example: "mời anh đến nhà tôi chơi * đưa tay mời ngồi * giấy mời họp",
  },
  {
    word: "mời",
    part_of_speech: "động từ",
    meaning:
      "ăn hoặc uống (nói về người đối thoại, một cách lịch sự): chị mời nước * bác mời cơm với nhà em",
    example: "chị mời nước * bác mời cơm với nhà em",
  },
  {
    word: "mơi",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) dùng lời nói, cử chỉ khéo léo để lôi cuốn người khác làm theo ý mình: mơi tiền của khách * gái làm tiền mơi khách",
    example: "mơi tiền của khách * gái làm tiền mơi khách",
  },
  {
    word: "mời chào",
    part_of_speech: "động từ",
    meaning:
      "chào đón, mời mọc một cách lịch sự (nói khái quát): mời chào vồn vã",
    example: "mời chào vồn vã",
  },
  {
    word: "mới cứng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) như mới tinh: chiếc xe máy mới cứng * tờ tiền mới cứng",
    example: "chiếc xe máy mới cứng * tờ tiền mới cứng",
  },
  {
    word: "mới coong",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như mới tinh: chiếc xe mới coong",
    example: "chiếc xe mới coong",
  },
  {
    word: "mới đó",
    part_of_speech: "",
    meaning: "chỉ vừa mới đấy thôi (hàm ý nhanh quá): mới đó mà đã hai năm rồi",
    example: "mới đó mà đã hai năm rồi",
  },
  {
    word: "mới đây",
    part_of_speech: "",
    meaning:
      "cách đây không lâu: chuyện vừa xảy ra mới đây * mới đây tôi còn gặp nó",
    example: "chuyện vừa xảy ra mới đây * mới đây tôi còn gặp nó",
  },
  {
    word: "mới đầu",
    part_of_speech: "",
    meaning: "lúc mới bắt đầu: lúc mới đầu * mới đầu thì ngại, sau thành quen",
    example: "lúc mới đầu * mới đầu thì ngại, sau thành quen",
  },
  {
    word: "mời gọi",
    part_of_speech: "động từ",
    meaning:
      "mời và kêu gọi tham gia: lập dự án mời gọi đầu tư * phong cảnh hùng vĩ như mời gọi khách tham quan",
    example:
      "lập dự án mời gọi đầu tư * phong cảnh hùng vĩ như mời gọi khách tham quan",
  },
  {
    word: "mới khự",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) rất mới: chiếc xe máy mới khự",
    example: "chiếc xe máy mới khự",
  },
  {
    word: "mới lạ",
    part_of_speech: "tính từ",
    meaning:
      "chưa từng thấy, chưa từng biết: trò chơi mới lạ * tư tưởng mới lạ",
    example: "trò chơi mới lạ * tư tưởng mới lạ",
  },
  {
    word: "mới mẻ",
    part_of_speech: "tính từ",
    meaning:
      "mới hoàn toàn, khác hẳn với những gì trước đó: cách làm mới mẻ * chuyện ấy lâu rồi chứ mới mẻ gì!",
    example: "cách làm mới mẻ * chuyện ấy lâu rồi chứ mới mẻ gì!",
  },
  {
    word: "mơi mới",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) hơi mới: cái áo trông vẫn còn mơi mới",
    example: "cái áo trông vẫn còn mơi mới",
  },
  {
    word: "mời mọc",
    part_of_speech: "động từ",
    meaning: "mời (nói khái quát): ân cần mời mọc * mời mọc khách hàng",
    example: "ân cần mời mọc * mời mọc khách hàng",
  },
  {
    word: "mới phải",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị ý nhận định về điều đáng lẽ phải được làm hoặc nên làm như thế: đúng ra anh nên đi mới phải",
    example: "đúng ra anh nên đi mới phải",
  },
  {
    word: "mới rồi",
    part_of_speech: "",
    meaning: "(khẩu ngữ) vừa mới đây thôi: mới rồi còn thấy hắn ở đây",
    example: "mới rồi còn thấy hắn ở đây",
  },
  {
    word: "mới toanh",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) như mới tinh: bộ bàn ghế mới toanh * chiếc xe mới toanh",
    example: "bộ bàn ghế mới toanh * chiếc xe mới toanh",
  },
  {
    word: "mớm",
    part_of_speech: "động từ",
    meaning:
      "cho con ăn bằng cách chuyển thức ăn trực tiếp từ miệng mình sang miệng con: chim mớm mồi cho con * mớm cơm",
    example: "chim mớm mồi cho con * mớm cơm",
  },
  {
    word: "mớm",
    part_of_speech: "động từ",
    meaning:
      "gợi cho những lời đã xếp đặt sẵn một cách khéo léo, kín đáo để cứ thế mà nói theo (hàm ý chê): nói mớm * mớm cung",
    example: "nói mớm * mớm cung",
  },
  {
    word: "mớm",
    part_of_speech: "động từ",
    meaning: "làm ướm thử trước: khâu mớm * đặt mớm thử xem có vừa không",
    example: "khâu mớm * đặt mớm thử xem có vừa không",
  },
  {
    word: "mớm",
    part_of_speech: "động từ",
    meaning:
      "(tiếp xúc) sát với mép ngoài của vật: ngồi mớm vào bên thành giường",
    example: "ngồi mớm vào bên thành giường",
  },
  {
    word: "mới tinh",
    part_of_speech: "tính từ",
    meaning:
      "còn mới nguyên, chưa hề dùng đến: bộ quần áo mới tinh * trang giấy mới tinh",
    example: "bộ quần áo mới tinh * trang giấy mới tinh",
  },
  {
    word: "mời rơi",
    part_of_speech: "động từ",
    meaning: "(hiếm) như mời lơi: lời mời rơi",
    example: "lời mời rơi",
  },
  {
    word: "mớn",
    part_of_speech: "danh từ",
    meaning:
      "khoang tàu thuyền, dùng làm nơi chứa người hoặc hàng hoá khi chuyên chở.",
    example: "tàu buộc phải dỡ bớt hàng để giảm mớn trước khi vào cảng",
  },
  {
    word: "mơn",
    part_of_speech: "động từ",
    meaning:
      "xoa, vuốt rất nhẹ bên trên, gây cảm giác dễ chịu: mơn nhẹ lên chỗ đau",
    example: "mơn nhẹ lên chỗ đau",
  },
  {
    word: "mơn man",
    part_of_speech: "động từ",
    meaning:
      "lướt nhẹ trên bề mặt, gây cảm giác dễ chịu: gió thổi mơn man * dòng nước mơn man trên da thịt",
    example: "gió thổi mơn man * dòng nước mơn man trên da thịt",
  },
  {
    word: "mơn mởn",
    part_of_speech: "tính từ",
    meaning:
      "(cây, lá) non mượt và tươi tốt, đầy sức sống: đồng lúa non mơn mởn * tuổi xuân mơn mởn",
    example: "đồng lúa non mơn mởn * tuổi xuân mơn mởn",
  },
  {
    word: "mù",
    part_of_speech: "danh từ",
    meaning: "sương mù (nói tắt): mây tạnh mù tan * quá mù ra mưa (tng)",
    example: "mây tạnh mù tan * quá mù ra mưa (tng)",
  },
  {
    word: "mù",
    part_of_speech: "tính từ",
    meaning:
      "(mắt) mất khả năng nhìn: ông lão mù * bị mù một mắt * có mắt như mù (không nhận thấy, không hiểu biết gì cả)",
    example:
      "ông lão mù * bị mù một mắt * có mắt như mù (không nhận thấy, không hiểu biết gì cả)",
  },
  {
    word: "mù",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái ranh giới với xung quanh bị xoá nhoà, không còn nhận biết ra cái gì nữa: bụi mù trời * quay tít mù * tối mù",
    example: "bụi mù trời * quay tít mù * tối mù",
  },
  {
    word: "mù",
    part_of_speech: "phụ từ",
    meaning:
      "(Khẩu ngữ) (mùi khó chịu) đến mức độ cao, xông lên mạnh mẽ và lan toả khắp xung quanh: khai mù * quần áo cháy khét mù",
    example: "khai mù * quần áo cháy khét mù",
  },
  {
    word: "mũ",
    part_of_speech: "danh từ",
    meaning:
      "(Nam thường nón) đồ dùng để đội trên đầu, úp chụp sát tóc, để che mưa, nắng, v.v.: đội mũ * đan mũ len * mũ sắt chống đạn",
    example: "đội mũ * đan mũ len * mũ sắt chống đạn",
  },
  {
    word: "mũ",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận có hình dáng giống như cái mũ trên đầu một số vật: mũ đinh * mũ nấm",
    example: "mũ đinh * mũ nấm",
  },
  {
    word: "mũ",
    part_of_speech: "danh từ",
    meaning: "(toán) số mũ (nói tắt): a mũ 3 (a3)",
    example: "a mũ 3 (a3)",
  },
  {
    word: "mơn trớn",
    part_of_speech: "động từ",
    meaning:
      "vuốt ve nhẹ, cốt để gây cảm giác dễ chịu, thích thú: vuốt ve mơn trớn",
    example: "vuốt ve mơn trớn",
  },
  {
    word: "mơn trớn",
    part_of_speech: "động từ",
    meaning:
      "dùng lời nói, thái độ tác động nhẹ nhàng đến tình cảm, cốt làm cho thích thú, vừa lòng: giọng mơn trớn",
    example: "giọng mơn trớn",
  },
  {
    word: "mụ",
    part_of_speech: "danh từ",
    meaning:
      "người đàn bà đã có tuổi (thường hàm ý coi khinh): mụ o * mụ tú bà",
    example: "mụ o * mụ tú bà",
  },
  {
    word: "mụ",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) từ người chồng già gọi người vợ già (với ý thân mật).",
    example: "cúng mụ * tuổi mụ",
  },
  {
    word: "mu",
    part_of_speech: "danh từ",
    meaning: "mai của rùa, cua: mu rùa",
    example: "mu rùa",
  },
  {
    word: "mu",
    part_of_speech: "danh từ",
    meaning:
      "phần nhô lên có hình khum khum ở một số bộ phận trên cơ thể như bàn tay, bàn chân, v.v.: mu bàn tay",
    example: "mu bàn tay",
  },
  {
    word: "mủ",
    part_of_speech: "danh từ",
    meaning:
      "chất nước đặc màu trắng vàng hay xanh nhạt ở mụn nhọt hoặc vết thương bị nhiễm trùng: nhọt mưng mủ * vết thương đã lên mủ",
    example: "nhọt mưng mủ * vết thương đã lên mủ",
  },
  {
    word: "mủ",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) nhựa cây: mủ cao su * mủ mít",
    example: "mủ cao su * mủ mít",
  },
  {
    word: "mù chữ",
    part_of_speech: "tính từ",
    meaning:
      "không biết đọc, không biết viết (tuy ở độ tuổi đáng lẽ đã được học, đã biết chữ): xoá nạn mù chữ",
    example: "xoá nạn mù chữ",
  },
  {
    word: "mù khơi",
    part_of_speech: "tính từ",
    meaning: "(văn chương) rất xa: xa tít mù khơi",
    example: "xa tít mù khơi",
  },
  {
    word: "mù loà",
    part_of_speech: "tính từ",
    meaning: "mù (chỉ nói về người; nói khái quát): sống trong cảnh mù loà",
    example: "sống trong cảnh mù loà",
  },
  {
    word: "mũ mãng",
    part_of_speech: "danh từ",
    meaning: "(cũ) mũ áo của quan lại (nói khái quát): mũ mãng cân đai",
    example: "mũ mãng cân đai",
  },
  {
    word: "mũ mãng",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) mũ để đội (nói khái quát): mũ mãng chỉnh tề",
    example: "mũ mãng chỉnh tề",
  },
  {
    word: "mũ mão",
    part_of_speech: "danh từ",
    meaning: "(cũ, hiếm) như mũ mãng (ng1): cân đai, mũ mão chỉnh tề",
    example: "cân đai, mũ mão chỉnh tề",
  },
  {
    word: "mù màu",
    part_of_speech: "tính từ",
    meaning:
      "(mắt) không phân biệt được một số màu, đặc biệt là màu đỏ và xanh, do bị tật: bị bệnh loạn sắc",
    example: "bị bệnh loạn sắc",
  },
  {
    word: "mụ mẫm",
    part_of_speech: "",
    meaning: "mụ người đi (nói khái quát): đầu óc mụ mẫm * mụ mẫm cả người",
    example: "đầu óc mụ mẫm * mụ mẫm cả người",
  },
  {
    word: "mủ mỉ",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) hiền lành ít nói: anh chàng mủ mỉ như con gái!",
    example: "anh chàng mủ mỉ như con gái!",
  },
  {
    word: "mụ mị",
    part_of_speech: "",
    meaning: "mụ mẫm đến mức như ngây dại, không còn biết gì nữa: mụ mị đầu óc",
    example: "mụ mị đầu óc",
  },
  {
    word: "mù mịt",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái không nhìn thấy gì, do bị bao phủ bởi một lớp bụi hay không khí, hơi nước, v.v. dày đặc: bụi mù mịt * hơi nước bốc lên mù mịt",
    example: "bụi mù mịt * hơi nước bốc lên mù mịt",
  },
  {
    word: "mù mịt",
    part_of_speech: "tính từ",
    meaning:
      "tăm tối, không có gì là sáng sủa đáng để hi vọng: tương lai mù mịt",
    example: "tương lai mù mịt",
  },
  {
    word: "mù mờ",
    part_of_speech: "tính từ",
    meaning: "mờ, không nhìn rõ được gì: ánh sáng mù mờ của ngọn đèn dầu",
    example: "ánh sáng mù mờ của ngọn đèn dầu",
  },
  {
    word: "mù mờ",
    part_of_speech: "tính từ",
    meaning: "lơ mơ, không rõ ràng: hiểu mù mờ * trả lời một cách mù mờ",
    example: "hiểu mù mờ * trả lời một cách mù mờ",
  },
  {
    word: "mũ ni",
    part_of_speech: "danh từ",
    meaning:
      "mũ mềm bằng len, sợi, có diềm che kín hai tai và sau gáy, thường dùng cho người già: mũ ni che tai (tng)",
    example: "mũ ni che tai (tng)",
  },
  {
    word: "mù tạt",
    part_of_speech: "danh từ",
    meaning: "cây họ cải, hoa vàng, hạt dùng chế gia vị: gỏi cá ăn với mù tạt",
    example: "gỏi cá ăn với mù tạt",
  },
  {
    word: "mù quáng",
    part_of_speech: "tính từ",
    meaning:
      "mê muội, không còn phân biệt được phải trái, đúng sai: hành động mù quáng * yêu một cách mù quáng",
    example: "hành động mù quáng * yêu một cách mù quáng",
  },
  {
    word: "mù tăm",
    part_of_speech: "tính từ",
    meaning:
      '(khẩu ngữ) quá xa xôi, hoàn toàn không thấy tăm hơi đâu cả: "Nhìn sông chỉ thấy sông dài, Nhìn non non ngất, trông người mù tăm." (ca dao)',
    example:
      'Nhìn sông chỉ thấy sông dài, Nhìn non non ngất, trông người mù tăm." (ca dao)',
  },
  {
    word: "mù tịt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) hoàn toàn không hay biết, hoặc không có chút hiểu biết hay kiến thức gì: mù tịt tin tức",
    example: "mù tịt tin tức",
  },
  {
    word: "mũ trụ",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) mũ làm bằng chất liệu cứng có sức chống đỡ với binh khí, ngày xưa dùng đội khi ra trận: viên tướng mình mặc áo bào, đầu đội mũ trụ",
    example: "viên tướng mình mặc áo bào, đầu đội mũ trụ",
  },
  {
    word: "mũ trụ",
    part_of_speech: "danh từ",
    meaning:
      "trở nên mất sáng suốt, mất trí nhớ do đầu óc phải làm việc quá nhiều: học nhiều quá, mụ cả người * nằm cả ngày cũng mụ người ra * nghĩ nhiều, mụ hết đầu",
    example:
      "học nhiều quá, mụ cả người * nằm cả ngày cũng mụ người ra * nghĩ nhiều, mụ hết đầu",
  },
  {
    word: "mùa",
    part_of_speech: "danh từ",
    meaning:
      "phần của năm, phân chia theo những đặc điểm về thiên văn thành những khoảng thời gian xấp xỉ bằng nhau: một năm có bốn mùa * chim én báo hiệu mùa xuân về",
    example: "một năm có bốn mùa * chim én báo hiệu mùa xuân về",
  },
  {
    word: "mùa",
    part_of_speech: "danh từ",
    meaning:
      "phần của năm, phân chia theo những đặc điểm và diễn biến về khí hậu, có thể dài ngắn, sớm muộn tuỳ khu vực, tuỳ năm: mùa mưa * mùa khô đã đến * mùa gió chướng",
    example: "mùa mưa * mùa khô đã đến * mùa gió chướng",
  },
  {
    word: "mùa",
    part_of_speech: "danh từ",
    meaning:
      "phần của năm, phân chia theo những đặc điểm về sản xuất nông nghiệp, tuỳ nơi và tuỳ năm có thể dài ngắn, sớm muộn khác nhau: mùa cải ra hoa * mùa nhãn * được mùa lúa úa mùa cau (tng)",
    example: "mùa cải ra hoa * mùa nhãn * được mùa lúa úa mùa cau (tng)",
  },
  {
    word: "mùa",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian thường diễn ra một hoạt động chung nào đó của con người, đã thành thường lệ hằng năm: chuẩn bị vào mùa cưới * mùa lễ hội",
    example: "chuẩn bị vào mùa cưới * mùa lễ hội",
  },
  {
    word: "mùa",
    part_of_speech: "tính từ",
    meaning:
      "(lúa) gieo cấy vào đầu hay giữa mùa mưa (tháng năm, tháng sáu), thu hoạch vào cuối mùa mưa hay đầu mùa khô (tháng mười, tháng mười một); phân biệt với chiêm: lúa mùa * vụ mùa",
    example: "lúa mùa * vụ mùa",
  },
  {
    word: "mùa",
    part_of_speech: "danh từ",
    meaning: "(Khẩu ngữ) lúa mùa (nói tắt): cấy mùa * cánh đồng mùa",
    example: "cấy mùa * cánh đồng mùa",
  },
  {
    word: "mua",
    part_of_speech: "động từ",
    meaning:
      "đổi tiền lấy hàng hoá, đồ vật: mua hàng * đi chợ mua thức ăn trái bán",
    example: "mua hàng * đi chợ mua thức ăn",
  },
  {
    word: "mua",
    part_of_speech: "động từ",
    meaning:
      "dùng tiền bạc, lợi lộc để đổi cái có lợi cho mình một cách không chính đáng: mua lòng cấp trên * mua danh bán tước",
    example: "mua lòng cấp trên * mua danh bán tước",
  },
  {
    word: "mua",
    part_of_speech: "động từ",
    meaning:
      "bỏ nhiều công sức để rồi thu về cái không hay, ngoài ý muốn: mua cái bực vào người * mua thù chuốc oán",
    example: "mua cái bực vào người * mua thù chuốc oán",
  },
  {
    word: "múa",
    part_of_speech: "động từ",
    meaning:
      "làm những động tác mềm mại, nhịp nhàng nối tiếp nhau để biểu hiện tư tưởng, tình cảm hoặc để rèn luyện thân thể: vừa hát vừa múa * múa kiếm",
    example: "vừa hát vừa múa * múa kiếm",
  },
  {
    word: "múa",
    part_of_speech: "danh từ",
    meaning:
      "loại hình nghệ thuật dùng động tác múa làm phương tiện biểu hiện tư tưởng, tình cảm: diễn viên múa * khai giảng lớp múa",
    example: "diễn viên múa * khai giảng lớp múa",
  },
  {
    word: "mua bán",
    part_of_speech: "động từ",
    meaning: "mua và bán (nói khái quát): không quen việc mua bán",
    example: "không quen việc mua bán",
  },
  {
    word: "mua dâm",
    part_of_speech: "động từ",
    meaning: "trả tiền để được quan hệ tình dục: khách mua dâm",
    example: "khách mua dâm",
  },
  {
    word: "mua đường",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đi phải con đường xa hơn, vừa tốn thời gian vừa vất vả một cách vô ích: đi mua đường thế thì làm gì mà chẳng lâu",
    example: "đi mua đường thế thì làm gì mà chẳng lâu",
  },
  {
    word: "mua chuộc",
    part_of_speech: "động từ",
    meaning:
      "dùng vật chất, địa vị làm cho người khác sa ngã mà làm theo ý mình: bị mua chuộc * dùng tiền để mua chuộc",
    example: "bị mua chuộc * dùng tiền để mua chuộc",
  },
  {
    word: "mua gom",
    part_of_speech: "động từ",
    meaning:
      "mua từ nhiều nguồn để gom dần lại cho thành một số lượng lớn: mua gom cà phê * mua gom thóc lúa của bà con nông dân",
    example: "mua gom cà phê * mua gom thóc lúa của bà con nông dân",
  },
  {
    word: "múa may",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ, hiếm) múa (nói khái quát; hàm ý chê): suốt ngày múa may",
    example: "suốt ngày múa may",
  },
  {
    word: "múa may",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) làm những động tác tựa như múa (thường trong khi nói), gây ấn tượng lố lăng, buồn cười: tay chân múa may",
    example: "tay chân múa may",
  },
  {
    word: "múa may",
    part_of_speech: "động từ",
    meaning:
      "hoạt động một cách ồn ào nhằm gây ảnh hưởng, nhưng vô ích, gây ấn tượng lố lăng: múa may trên vũ đài chính trị",
    example: "múa may trên vũ đài chính trị",
  },
  {
    word: "mùa màng",
    part_of_speech: "danh từ",
    meaning:
      "cây trồng trong vụ sản xuất nông nghiệp (nói khái quát): bảo vệ mùa màng * châu chấu phá hoại mùa màng",
    example: "bảo vệ mùa màng * châu chấu phá hoại mùa màng",
  },
  {
    word: "mùa màng",
    part_of_speech: "danh từ",
    meaning:
      "mùa thu hoạch, vụ thu hoạch sản phẩm nông nghiệp: mùa màng bội thu * mùa màng thất bát",
    example: "mùa màng bội thu * mùa màng thất bát",
  },
  {
    word: "múa mép",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nói năng ba hoa, khoác lác: chỉ giỏi múa mép! * khua môi múa mép (tng)",
    example: "chỉ giỏi múa mép! * khua môi múa mép (tng)",
  },
  {
    word: "múa rối",
    part_of_speech: "danh từ",
    meaning:
      "loại hình nghệ thuật sân khấu biểu diễn bằng cách điều khiển các hình mẫu giống như người, vật: nhà hát múa rối * đi xem múa rối",
    example: "nhà hát múa rối * đi xem múa rối",
  },
  {
    word: "mua sỉ",
    part_of_speech: "động từ",
    meaning: "như mua buôn: lên tỉnh mua sỉ hàng về bán ở chợ huyện",
    example: "lên tỉnh mua sỉ hàng về bán ở chợ huyện",
  },
  {
    word: "mua sỉ",
    part_of_speech: "động từ",
    meaning: "(Từ cũ, hoặc ph) mua lẻ: mua sỉ ít một để dùng",
    example: "mua sỉ ít một để dùng",
  },
  {
    word: "mua sắm",
    part_of_speech: "động từ",
    meaning: "mua các thứ để dùng (nói khái quát): mua sắm đồ đạc",
    example: "mua sắm đồ đạc",
  },
  {
    word: "mua việc",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bày thêm việc ra mà làm, khiến cho vất vả và lãng phí thời gian: chớ dại mua việc vào người",
    example: "chớ dại mua việc vào người",
  },
  {
    word: "mục",
    part_of_speech: "danh từ",
    meaning:
      "phần, chương trình trên báo, trên đài phát thanh, truyền hình dành riêng cho một thể loại: mục ý kiến bạn nghe đài * mục hộp thư truyền hình * mục kết bạn trên báo",
    example:
      "mục ý kiến bạn nghe đài * mục hộp thư truyền hình * mục kết bạn trên báo",
  },
  {
    word: "mục",
    part_of_speech: "danh từ",
    meaning: "phần của văn bản trình bày trọn vẹn một điểm hoặc một vấn đề.",
    example: "bàn kĩ từng mục một",
  },
  {
    word: "mục",
    part_of_speech: "tính từ",
    meaning:
      "(chất rắn, cây cối hoặc chất có nguồn gốc thực vật) bị biến chất trở nên mềm, bở, dễ bị rã nát do tác động huỷ hoại của môi trường, của vi sinh vật trong thời gian dài: gỗ mục * gạo mục * củi mục",
    example: "gỗ mục * gạo mục * củi mục",
  },
  {
    word: "mục đích",
    part_of_speech: "danh từ",
    meaning:
      "cái vạch ra làm đích nhằm đạt cho được: xác định rõ mục đích để phấn đấu * một việc làm không có mục đích",
    example:
      "xác định rõ mục đích để phấn đấu * một việc làm không có mục đích",
  },
  {
    word: "mua vui",
    part_of_speech: "động từ",
    meaning:
      'tìm cách giải trí, tiêu khiển: bày trò mua vui * "Lời quê chắp nhặt dông dài, Mua vui cũng được một vài trống canh." (TKiều)',
    example:
      'bày trò mua vui * "Lời quê chắp nhặt dông dài, Mua vui cũng được một vài trống canh." (TKiều)',
  },
  {
    word: "múc",
    part_of_speech: "động từ",
    meaning:
      "dùng các dụng cụ nhỏ cầm tay như môi, thìa, gáo, v.v. lấy chất lỏng hoặc chất đặc sánh ra: múc nước * múc bát canh * tiền trao cháo múc (tng)",
    example: "múc nước * múc bát canh * tiền trao cháo múc (tng)",
  },
  {
    word: "mùa vụ",
    part_of_speech: "danh từ",
    meaning:
      "mùa, vụ gieo trồng hoặc thu hoạch, trong sản xuất nông nghiệp (nói khái quát): gieo trồng đúng mùa vụ * chuyển đổi cơ cấu mùa vụ",
    example: "gieo trồng đúng mùa vụ * chuyển đổi cơ cấu mùa vụ",
  },
  {
    word: "mùa vụ",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian nhất định (thường là ngắn) gắn với một công việc nào đó: hợp đồng lao động theo mùa vụ * công việc có tính chất mùa vụ",
    example: "hợp đồng lao động theo mùa vụ * công việc có tính chất mùa vụ",
  },
  {
    word: "mục đồng",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, văn chương) trẻ chăn trâu, chăn bò: lũ mục đồng * tiếng sáo của mục đồng",
    example: "lũ mục đồng * tiếng sáo của mục đồng",
  },
  {
    word: "mục kỉnh",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) kính đeo mắt cho người già hoặc người mắt kém: giương mục kỉnh",
    example: "giương mục kỉnh",
  },
  {
    word: "mục kích",
    part_of_speech: "động từ",
    meaning: "nhìn thấy tận mắt: phải được mục kích mới tin",
    example: "phải được mục kích mới tin",
  },
  {
    word: "mục hạ vô nhân",
    part_of_speech: "",
    meaning:
      "dưới mắt không có ai; ví thái độ hết sức ngạo mạn, không coi ai ra gì: thái độ mục hạ vô nhân",
    example: "thái độ mục hạ vô nhân",
  },
  {
    word: "mục lục",
    part_of_speech: "danh từ",
    meaning:
      "bản ghi các đề mục với số trang tương ứng, theo trình tự trình bày trong sách, tạp chí (để ở đầu hoặc cuối sách, tạp chí): cuốn sách bị mất trang mục lục",
    example: "cuốn sách bị mất trang mục lục",
  },
  {
    word: "mục lục",
    part_of_speech: "danh từ",
    meaning:
      "danh mục sách báo, tư liệu, v.v. lập theo những quy tắc nhất định: tra mục lục sách của thư viện",
    example: "tra mục lục sách của thư viện",
  },
  {
    word: "mục ruỗng",
    part_of_speech: "tính từ",
    meaning:
      "mục và ruỗng hết, hư hỏng hết từ bên trong, chỉ còn lại cái vỏ bên ngoài: cột nhà mục ruỗng vì mối mọt",
    example: "cột nhà mục ruỗng vì mối mọt",
  },
  {
    word: "mục nát",
    part_of_speech: "tính từ",
    meaning:
      "mục và hư hỏng đến mức không còn hình dạng như cũ: túp lều xiêu vẹo, mục nát",
    example: "túp lều xiêu vẹo, mục nát",
  },
  {
    word: "mục nát",
    part_of_speech: "tính từ",
    meaning: "hư hỏng, suy đồi đến mức tồi tệ: chế độ phong kiến mục nát",
    example: "chế độ phong kiến mục nát",
  },
  {
    word: "mùi",
    part_of_speech: "danh từ",
    meaning:
      "hơi toả ra được nhận biết bằng mũi: mùi thơm * mùi hương ngào ngạt * tanh mùi cá * thức ăn đã bốc mùi khó chịu",
    example:
      "mùi thơm * mùi hương ngào ngạt * tanh mùi cá * thức ăn đã bốc mùi khó chịu",
  },
  {
    word: "mùi",
    part_of_speech: "danh từ",
    meaning:
      "vị của thức ăn, nói về mặt sự cảm nhận của con người: ăn cho biết mùi",
    example: "ăn cho biết mùi",
  },
  {
    word: "mùi",
    part_of_speech: "danh từ",
    meaning:
      "cái nếm trải, hưởng, chịu trong cuộc đời, nói về mặt sự cảm nhận của con người: mùi vinh hoa phú quý * chưa biết mùi đời",
    example: "mùi vinh hoa phú quý * chưa biết mùi đời",
  },
  {
    word: "mùi",
    part_of_speech: "danh từ",
    meaning:
      "(thường viết hoa) kí hiệu thứ tám trong địa chi (lấy dê làm tượng trưng; sau ngọ, trước thân), dùng trong phép đếm thời gian cổ truyền của Trung Quốc và một số nước châu á, trong đó có Việt Nam: giờ Mùi (từ 1 giờ trưa đến 3 giờ chiều) * tuổi Mùi",
    example: "giờ Mùi (từ 1 giờ trưa đến 3 giờ chiều) * tuổi Mùi",
  },
  {
    word: "mùi",
    part_of_speech: "tính từ",
    meaning:
      "(Phương ngữ, Khẩu ngữ) (đàn, hát) hay, có sức lay động và cuốn hút lòng người: giọng ca rất mùi",
    example: "giọng ca rất mùi",
  },
  {
    word: "mục tiêu",
    part_of_speech: "danh từ",
    meaning:
      "chỗ, điểm để nhằm vào: bắn trúng mục tiêu * phát hiện đúng mục tiêu",
    example: "bắn trúng mục tiêu * phát hiện đúng mục tiêu",
  },
  {
    word: "mục tiêu",
    part_of_speech: "danh từ",
    meaning:
      "đích cần đạt tới để thực hiện nhiệm vụ: đạt được mục tiêu * đặt mục tiêu cụ thể cho từng giai đoạn",
    example: "đạt được mục tiêu * đặt mục tiêu cụ thể cho từng giai đoạn",
  },
  {
    word: "mục sở thị",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) thực mục sở thị (nói rút gọn): chỉ nghe nói, chứ không được mục sở thị",
    example: "chỉ nghe nói, chứ không được mục sở thị",
  },
  {
    word: "mục từ",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị được nêu thành mục trong từ điển: mục từ được xếp theo trật tự A, B, C",
    example: "mục từ được xếp theo trật tự A, B, C",
  },
  {
    word: "mui",
    part_of_speech: "danh từ",
    meaning:
      "mái che thuyền hay xe, thường có hình khum khum: ngồi ở mui thuyền * mui xe",
    example: "ngồi ở mui thuyền * mui xe",
  },
  {
    word: "múi",
    part_of_speech: "danh từ",
    meaning:
      "phần của quả, có màng bọc riêng rẽ, trong có chứa hạt và có thể có chứa các tép nhỏ: múi bưởi * múi quýt * múi mít",
    example: "múi bưởi * múi quýt * múi mít",
  },
  {
    word: "múi",
    part_of_speech: "danh từ",
    meaning:
      "phần có hình giống như các múi quả ở bắp thịt và ở một số vật: bắp tay nổi múi * múi đèn xếp",
    example: "bắp tay nổi múi * múi đèn xếp",
  },
  {
    word: "múi",
    part_of_speech: "danh từ",
    meaning: "phần mặt đất giới hạn bởi hai kinh tuyến: múi giờ",
    example: "múi giờ",
  },
  {
    word: "múi",
    part_of_speech: "danh từ",
    meaning:
      "đầu mối của sợi dây hoặc phần góc của chăn, màn, v.v.: kéo múi chăn đắp kín cổ * tém múi màn * thắt lưng bỏ múi",
    example: "kéo múi chăn đắp kín cổ * tém múi màn * thắt lưng bỏ múi",
  },
  {
    word: "múi",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) nút buộc, múi buộc: múi lạt * thắt lại múi dây * múi bao tượng",
    example: "múi lạt * thắt lại múi dây * múi bao tượng",
  },
  {
    word: "múi",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) giáp mối của hai đường giao thông: từ trong làng ra đến múi đường cái",
    example: "từ trong làng ra đến múi đường cái",
  },
  {
    word: "mũi",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận nhô lên ở giữa mặt người và động vật có xương sống, dùng để thở và ngửi: viêm mũi * ngạt mũi * hai cánh mũi phập phồng",
    example: "viêm mũi * ngạt mũi * hai cánh mũi phập phồng",
  },
  {
    word: "mũi",
    part_of_speech: "danh từ",
    meaning: "nước mũi (nói tắt): xì mũi * sổ mũi * mũi dãi",
    example: "xì mũi * sổ mũi * mũi dãi",
  },
  {
    word: "mũi",
    part_of_speech: "danh từ",
    meaning:
      "chất nhầy giống như nước mũi có lẫn trong phân của người bị bệnh kiết lị.",
    example: "mũi kim * mũi giày * đứng phía mũi thuyền * mũi tên hòn đạn",
  },
  {
    word: "mũi",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận có đầu nhọn nhô ra phía trước ở một số vật: mũi kim * mũi giày * đứng phía mũi thuyền * mũi tên hòn đạn",
    example: "mũi Cà Mau * vùng đất mũi Năm Căn",
  },
  {
    word: "mũi",
    part_of_speech: "danh từ",
    meaning: "mỏm đất nhô ra phía biển: mũi Cà Mau * vùng đất mũi Năm Căn",
    example: "khâu thêm mấy mũi cho chắc * ngày tiêm hai mũi",
  },
  {
    word: "mũi",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị lần sử dụng vật có mũi nhọn vào việc gì, hoặc kết quả cụ thể của việc ấy: khâu thêm mấy mũi cho chắc * ngày tiêm hai mũi",
    example: "mũi tiến công * chia làm hai mũi chủ lực",
  },
  {
    word: "mũi đất",
    part_of_speech: "danh từ",
    meaning: "(ng5): mũi đất Cà Mau",
    example: "mũi đất Cà Mau",
  },
  {
    word: "mũi dãi",
    part_of_speech: "danh từ",
    meaning: "nước mũi và nước dãi (nói khái quát): mũi dãi đầy ngực",
    example: "mũi dãi đầy ngực",
  },
  {
    word: "mùi gì",
    part_of_speech: "",
    meaning: "(khẩu ngữ) có đáng gì, có thấm gì: ngần này với nó thì mùi gì!",
    example: "ngần này với nó thì mùi gì!",
  },
  {
    word: "múi giờ",
    part_of_speech: "danh từ",
    meaning:
      "phần mặt đất nằm giữa hai kinh tuyến cách nhau 150, trên đó được quy ước dùng chung một giờ, theo giờ của kinh tuyến giữa: Trái Đất có hai mươi bốn múi giờ",
    example: "Trái Đất có hai mươi bốn múi giờ",
  },
  {
    word: "mũi dùi",
    part_of_speech: "danh từ",
    meaning:
      "mũi nhọn của cái dùi; dùng để tượng trưng cho sự tập trung phê phán, đả kích một đối tượng, mục tiêu nào đó: chĩa mũi dùi vào nạn tham ô",
    example: "chĩa mũi dùi vào nạn tham ô",
  },
  {
    word: "mùi mẫn",
    part_of_speech: "tính từ",
    meaning:
      "ngọt ngào, thấm thía, làm rung động lòng người: khóc rất mùi mẫn * giọng ca mùi mẫn",
    example: "khóc rất mùi mẫn * giọng ca mùi mẫn",
  },
  {
    word: "mùi mẽ gì",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) như mùi gì (nhưng nghĩa mạnh hơn): cả hai tên ấy cũng chẳng mùi mẽ gì!",
    example: "cả hai tên ấy cũng chẳng mùi mẽ gì!",
  },
  {
    word: "mùi mẽ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) mùi vị của đồ ăn, thức uống, v.v. (nói khái quát; hàm ý chê): chè nấu nhạt thếch, chẳng có mùi mẽ gì",
    example: "chè nấu nhạt thếch, chẳng có mùi mẽ gì",
  },
  {
    word: "mủi lòng",
    part_of_speech: "động từ",
    meaning:
      "thương cảm đến mức như muốn khóc: mủi lòng thương * trông cảnh ấy ai mà chẳng mủi lòng",
    example: "mủi lòng thương * trông cảnh ấy ai mà chẳng mủi lòng",
  },
  {
    word: "mũi nhọn",
    part_of_speech: "danh từ",
    meaning:
      "lực lượng đi đầu, đi tiên phong theo một hướng nhất định: ngành công nghiệp mũi nhọn * mũi nhọn tấn công",
    example: "ngành công nghiệp mũi nhọn * mũi nhọn tấn công",
  },
  {
    word: "mùi vị",
    part_of_speech: "danh từ",
    meaning:
      "mùi và vị cảm nhận được (nói khái quát): sầu riêng có mùi vị rất đặc biệt * mùi vị của đồng quê * nếm trải đủ mùi vị của cuộc đời",
    example:
      "sầu riêng có mùi vị rất đặc biệt * mùi vị của đồng quê * nếm trải đủ mùi vị của cuộc đời",
  },
  {
    word: "mùi soa",
    part_of_speech: "danh từ",
    meaning:
      "khăn nhỏ và mỏng, thường bỏ túi, để dùng vào các việc vệ sinh cá nhân: khăn mùi soa",
    example: "khăn mùi soa",
  },
  {
    word: "mũi tên",
    part_of_speech: "danh từ",
    meaning:
      "tên bắn đi bằng cung, nỏ: một mũi tên bắn trúng hai đích * mũi tên hòn đạn",
    example: "một mũi tên bắn trúng hai đích * mũi tên hòn đạn",
  },
  {
    word: "mũi tên",
    part_of_speech: "danh từ",
    meaning:
      "dấu hiệu có hình mũi tên, thường dùng để chỉ hướng: vạch một mũi tên * đi theo hướng chỉ của mũi tên",
    example: "vạch một mũi tên * đi theo hướng chỉ của mũi tên",
  },
  {
    word: "mũi tên hòn đạn",
    part_of_speech: "",
    meaning:
      "mũi tên và viên đạn; thường dùng để chỉ chiến trường, về mặt là nơi dễ bị thương vong: xông pha nơi mũi tên hòn đạn",
    example: "xông pha nơi mũi tên hòn đạn",
  },
  {
    word: "múm mím",
    part_of_speech: "động từ",
    meaning: "từ gợi tả dáng cử động nhẹ của đôi môi hơi mím lại: múm mím cười",
    example: "múm mím cười",
  },
  {
    word: "mủm mỉm",
    part_of_speech: "động từ",
    meaning:
      "từ gợi tả kiểu cười hơi hé môi và cử động nhẹ, không phát thành tiếng: cười mủm mỉm",
    example: "cười mủm mỉm",
  },
  {
    word: "mũm mĩm",
    part_of_speech: "tính từ",
    meaning:
      "béo và tròn trĩnh, trông thích mắt (thường nói về trẻ em): chân tay mũm mĩm",
    example: "chân tay mũm mĩm",
  },
  {
    word: "mủn",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ bủn) dễ bị nát vụn ra khi đụng đến, do tác động của thời gian, của mưa nắng: cái chiếu nát mủn * tờ giấy ngấm nước đã mủn ra",
    example: "cái chiếu nát mủn * tờ giấy ngấm nước đã mủn ra",
  },
  {
    word: "mủn",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như mùn: mủn rơm",
    example: "mủn rơm",
  },
  {
    word: "mum múp",
    part_of_speech: "tính từ",
    meaning:
      "béo căng tròn, trông đầy đặn và ngắn ngủn: con lợn béo mum múp * đầu mum múp",
    example: "con lợn béo mum múp * đầu mum múp",
  },
  {
    word: "mùn",
    part_of_speech: "danh từ",
    meaning:
      "hợp chất màu đen hoặc nâu do các chất hữu cơ trong đất phân giải thành: đất nhiều mùn * mùn ao",
    example: "đất nhiều mùn * mùn ao",
  },
  {
    word: "mùn",
    part_of_speech: "danh từ",
    meaning:
      "(cũng mủn) chất vụn nát: mùn cưa * mùn rơm * mùn thớt (mùn tạo ra trên mặt thớt do băm, chặt)",
    example:
      "mùn cưa * mùn rơm * mùn thớt (mùn tạo ra trên mặt thớt do băm, chặt)",
  },
  {
    word: "mụn nhọt",
    part_of_speech: "danh từ",
    meaning: "mụn và nhọt (nói khái quát): người nổi đầy mụn nhọt",
    example: "người nổi đầy mụn nhọt",
  },
  {
    word: "mùn cưa",
    part_of_speech: "danh từ",
    meaning: "vụn gỗ nhỏ rơi ra khi cưa, xẻ: đun bếp bằng mùn cưa",
    example: "đun bếp bằng mùn cưa",
  },
  {
    word: "mụn",
    part_of_speech: "danh từ",
    meaning: "nốt viêm nổi trên cơ thể, thường ít gây đau: mặt nổi mụn",
    example: "mặt nổi mụn",
  },
  {
    word: "mụn",
    part_of_speech: "danh từ",
    meaning: "mảnh vụn nhỏ không đáng kể (thường nói về vải): mụn vải",
    example: "mụn vải",
  },
  {
    word: "mụn",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) đứa con, cháu (hàm ý hiếm hoi): nhà có mỗi một mụn con",
    example: "nhà có mỗi một mụn con",
  },
  {
    word: "mun",
    part_of_speech: "danh từ",
    meaning:
      "cây lấy gỗ cùng họ với thị, lá đơn mọc cách, hoa đơn tính màu vàng, gỗ thuộc loại quý, rất cứng, màu đen: đũa làm bằng gỗ mun",
    example: "đũa làm bằng gỗ mun",
  },
  {
    word: "mun",
    part_of_speech: "tính từ",
    meaning: "có màu như màu gỗ mun: mèo mun * tóc mun",
    example: "mèo mun * tóc mun",
  },
  {
    word: "mủng",
    part_of_speech: "danh từ",
    meaning:
      "đồ đan sít bằng tre, tròn và sâu lòng, nhỏ hơn thúng, dùng để đựng: mủng lạc",
    example: "mủng lạc",
  },
  {
    word: "mủng",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) thuyền thúng (nói tắt): bơi mủng",
    example: "bơi mủng",
  },
  {
    word: "mùng tơi",
    part_of_speech: "danh từ",
    meaning:
      "cây trồng thân leo, lá tròn, mềm, to và dày, có nhiều chất nhớt, lá và ngọn thường dùng nấu canh: rau mồng tơi",
    example: "rau mồng tơi",
  },
  {
    word: "mung lung",
    part_of_speech: "tính từ",
    meaning:
      "(khoảng không gian) rộng và lờ mờ, không rõ nét, gây cảm giác hư ảo: khoảng tối mông lung * cảnh vật mông lung, huyền ảo",
    example: "khoảng tối mông lung * cảnh vật mông lung, huyền ảo",
  },
  {
    word: "mung lung",
    part_of_speech: "tính từ",
    meaning:
      "(ý nghĩ) rộng và lan man, không tập trung, không rõ nét: suy nghĩ mông lung",
    example: "suy nghĩ mông lung",
  },
  {
    word: "mùng",
    part_of_speech: "danh từ",
    meaning: "màn (chống muỗi và côn trùng): vén mùng chui ra",
    example: "vén mùng chui ra",
  },
  {
    word: "mùng",
    part_of_speech: "danh từ",
    meaning: "mồng (= một trong mười ngày đầu âm lịch): ngày mùng một Tết",
    example: "ngày mùng một Tết",
  },
  {
    word: "muối",
    part_of_speech: "danh từ",
    meaning:
      'tinh thể trắng, vị mặn, thường được tách từ nước biển, dùng để ăn: "Muối ba năm muối hãy còn mặn, Gừng chín tháng gừng hãy còn cay." (ca dao)',
    example:
      'Muối ba năm muối hãy còn mặn, Gừng chín tháng gừng hãy còn cay." (ca dao)',
  },
  {
    word: "muối",
    part_of_speech: "động từ",
    meaning:
      "cho muối vào thịt cá, rau quả để giữ được lâu hoặc làm thức ăn chua: muối dưa * muối thịt để dành",
    example: "muối dưa * muối thịt để dành",
  },
  {
    word: "muồi",
    part_of_speech: "tính từ",
    meaning:
      '(phương ngữ) (ngủ) rất ngon, rất say (chỉ nói về trẻ con): "Ru em, em ngủ cho muồi, Cho mẹ đi chợ mua vôi ăn trầu." (ca dao)',
    example: 'Ru em, em ngủ cho muồi, Cho mẹ đi chợ mua vôi ăn trầu." (ca dao)',
  },
  {
    word: "muỗi",
    part_of_speech: "danh từ",
    meaning:
      "côn trùng nhỏ, cánh mỏng, có vòi châm hút máu người, gây ngứa: bị muỗi đốt * muỗi nhiều như vãi trấu",
    example: "bị muỗi đốt * muỗi nhiều như vãi trấu",
  },
  {
    word: "muội",
    part_of_speech: "danh từ",
    meaning:
      "bụi đen mịn do khói sinh ra, thường đóng thành mảng, thành lớp: lau sạch muội ở bóng đèn * muội than đen sì",
    example: "lau sạch muội ở bóng đèn * muội than đen sì",
  },
  {
    word: "muối bỏ biển",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) quá ít ỏi, chẳng thấm tháp gì, chẳng có tác dụng gì (ví như đem muối mà bỏ xuống biển thì biết bao nhiêu cho vừa): hạn hán kéo dài, trận mưa nhỏ chỉ như muối bỏ biển",
    example: "hạn hán kéo dài, trận mưa nhỏ chỉ như muối bỏ biển",
  },
  {
    word: "muối mặt",
    part_of_speech: "động từ",
    meaning:
      "chịu cho người ta coi khinh để làm hoặc để xảy ra một việc gì đó mà tự mình cũng biết là đáng hổ thẹn: chịu muối mặt để vay mượn",
    example: "chịu muối mặt để vay mượn",
  },
  {
    word: "muối tiêu",
    part_of_speech: "danh từ",
    meaning:
      "muối ăn trộn với hạt tiêu, giã nhỏ: thịt gà chấm muối tiêu * lọ muối tiêu",
    example: "thịt gà chấm muối tiêu * lọ muối tiêu",
  },
  {
    word: "muối tiêu",
    part_of_speech: "danh từ",
    meaning:
      "màu lốm đốm bạc của tóc, sợi đen sợi trắng như màu muối tiêu: mái đầu muối tiêu * tóc muối tiêu",
    example: "mái đầu muối tiêu * tóc muối tiêu",
  },
  {
    word: "muối mè",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) muối vừng: cơm nắm chấm muối mè",
    example: "cơm nắm chấm muối mè",
  },
  {
    word: "muối vừng",
    part_of_speech: "danh từ",
    meaning:
      "vừng và muối rang chín, giã nhỏ, trộn lẫn vào nhau, dùng làm thức ăn: cơm nắm muối vừng",
    example: "cơm nắm muối vừng",
  },
  {
    word: "muỗi mắt",
    part_of_speech: "danh từ",
    meaning: "muỗi nhỏ: bé như muỗi mắt",
    example: "bé như muỗi mắt",
  },
  {
    word: "muộn",
    part_of_speech: "tính từ",
    meaning:
      "sau thời điểm quy định hay sau thời điểm thường lệ tương đối lâu: đi ngủ muộn * rét muộn * hay đi làm về muộn * Chờ nó tới rồi đi cũng chưa muộn!",
    example:
      "đi ngủ muộn * rét muộn * hay đi làm về muộn * Chờ nó tới rồi đi cũng chưa muộn!",
  },
  {
    word: "muôn",
    part_of_speech: "danh từ",
    meaning: "(cũ) vạn: muôn tuổi * muôn năm",
    example: "muôn tuổi * muôn năm",
  },
  {
    word: "muôn",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ con số lớn lắm, không sao đếm xuể, hoặc bao quát toàn bộ: muôn người như một * muôn màu muôn vẻ",
    example: "muôn người như một * muôn màu muôn vẻ",
  },
  {
    word: "muốn",
    part_of_speech: "động từ",
    meaning:
      "cảm thấy có sự đòi hỏi được làm một việc gì hoặc có cái gì: muốn được điểm cao * muốn được đi chơi * chẳng muốn gì hết",
    example: "muốn được điểm cao * muốn được đi chơi * chẳng muốn gì hết",
  },
  {
    word: "muốn",
    part_of_speech: "động từ",
    meaning:
      "có dấu hiệu cho thấy sắp chuyển sang một trạng thái khác: trời có vẻ muốn mưa * con đò chao đảo như muốn lật * giọng run run như muốn khóc",
    example:
      "trời có vẻ muốn mưa * con đò chao đảo như muốn lật * giọng run run như muốn khóc",
  },
  {
    word: "muôn dân",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, hiếm) toàn thể dân chúng: muôn dân trăm họ * trị vì muôn dân",
    example: "muôn dân trăm họ * trị vì muôn dân",
  },
  {
    word: "muôn hình muôn vẻ",
    part_of_speech: "",
    meaning:
      "nhiều hình, nhiều vẻ khác nhau, rất đa dạng, phong phú: cuộc sống muôn hình muôn vẻ",
    example: "cuộc sống muôn hình muôn vẻ",
  },
  {
    word: "muôn đời",
    part_of_speech: "danh từ",
    meaning:
      "thời gian hết đời này qua đời khác, mãi mãi về sau: lưu danh muôn đời",
    example: "lưu danh muôn đời",
  },
  {
    word: "muôn hình vạn trạng",
    part_of_speech: "",
    meaning:
      "nhiều hình vẻ, trạng thái khác nhau: cuộc sống muôn hình vạn trạng",
    example: "cuộc sống muôn hình vạn trạng",
  },
  {
    word: "muộn mằn",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) quá muộn (nói khái quát): sự hối hận muộn mằn",
    example: "sự hối hận muộn mằn",
  },
  {
    word: "muộn mằn",
    part_of_speech: "tính từ",
    meaning:
      "chậm có con, muộn về đường con cái (nói khái quát): đường con cái muộn mằn",
    example: "đường con cái muộn mằn",
  },
  {
    word: "muôn năm",
    part_of_speech: "danh từ",
    meaning:
      "thời gian tồn tại năm này qua năm khác, lâu dài, mãi mãi (thường dùng trong lời tung hô, chúc tụng): hoà bình thế giới muôn năm!",
    example: "hoà bình thế giới muôn năm!",
  },
  {
    word: "muôn hồng nghìn tía",
    part_of_speech: "",
    meaning:
      "nhiều màu sắc rực rỡ, tạo nên cảnh sắc lộng lẫy: cả một rừng hoa muôn hồng nghìn tía đang khoe sắc",
    example: "cả một rừng hoa muôn hồng nghìn tía đang khoe sắc",
  },
  {
    word: "muôn muốt",
    part_of_speech: "tính từ",
    meaning: "như muốt (nhưng ý mức độ cao hơn): hàm răng trắng muôn muốt",
    example: "hàm răng trắng muôn muốt",
  },
  {
    word: "muôn một",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, hiếm) khả năng không hay rất hiếm khi xảy ra, chỉ là một trong muôn nghìn khả năng, nhưng cũng có thể xảy ra: "Chấp kinh nếu chẳng tòng quyền, Sợ khi muôn một chu tuyền làm sao?" (NĐM)',
    example:
      'Chấp kinh nếu chẳng tòng quyền, Sợ khi muôn một chu tuyền làm sao?" (NĐM)',
  },
  {
    word: "muôn ngàn",
    part_of_speech: "danh từ",
    meaning: "như muôn vàn: muôn ngàn con sóng dội vào bờ",
    example: "muôn ngàn con sóng dội vào bờ",
  },
  {
    word: "muộn màng",
    part_of_speech: "tính từ",
    meaning:
      "muộn (nói khái quát; thường là về đường tình duyên, con cái): đường con cái muộn màng * tình duyên muộn màng",
    example: "đường con cái muộn màng * tình duyên muộn màng",
  },
  {
    word: "muôn trùng",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương) số lượng lớn và cái này nối tiếp cái kia, không sao kể hết: muôn trùng sông núi * lênh đênh giữa muôn trùng sóng nước",
    example: "muôn trùng sông núi * lênh đênh giữa muôn trùng sóng nước",
  },
  {
    word: "muộn phiền",
    part_of_speech: "",
    meaning: "như phiền muộn: tâm trạng muộn phiền",
    example: "tâm trạng muộn phiền",
  },
  {
    word: "muôn vàn",
    part_of_speech: "danh từ",
    meaning: "số lượng nhiều đến mức không kể hết: khắc phục muôn vàn khó khăn",
    example: "khắc phục muôn vàn khó khăn",
  },
  {
    word: "muôn tâu",
    part_of_speech: "động từ",
    meaning:
      "từ dùng để mở đầu lời nói hoặc tâu trình với vua chúa, để tỏ sự cung kính: muôn tâu bệ hạ! * muôn tâu chúa thượng!",
    example: "muôn tâu bệ hạ! * muôn tâu chúa thượng!",
  },
  {
    word: "muôn thuở",
    part_of_speech: "danh từ",
    meaning:
      "thời gian từ xưa đến nay và cả sau này, mãi mãi: khát vọng muôn thuở * lưu danh muôn thuở",
    example: "khát vọng muôn thuở * lưu danh muôn thuở",
  },
  {
    word: "muỗng",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ có một đầu để cầm và một đầu lõm, dùng để múc thức ăn; lượng chứa trong một thìa: thìa xúp * thêm hai thìa muối vào canh",
    example: "thìa xúp * thêm hai thìa muối vào canh",
  },
  {
    word: "muông",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) chó: "Bỗng nghe ngoài chốn tường hoa, Tiếng con muông sủa từ xa lại gần." (TT)',
    example:
      'Bỗng nghe ngoài chốn tường hoa, Tiếng con muông sủa từ xa lại gần." (TT)',
  },
  {
    word: "muống",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng có một miệng loe rộng, dùng để rót chất lỏng vào vật đựng có miệng nhỏ: phễu nhựa * phễu rót dầu",
    example: "phễu nhựa * phễu rót dầu",
  },
  {
    word: "muôn nghìn",
    part_of_speech: "danh từ",
    meaning: "như muôn vàn: muôn ngàn con sóng dội vào bờ",
    example: "muôn ngàn con sóng dội vào bờ",
  },
  {
    word: "muông thú",
    part_of_speech: "danh từ",
    meaning: "thú rừng (nói khái quát): săn bắt muông thú",
    example: "săn bắt muông thú",
  },
  {
    word: "múp míp",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) béo múp (nói khái quát): béo múp míp",
    example: "béo múp míp",
  },
  {
    word: "muốt",
    part_of_speech: "tính từ",
    meaning:
      "(màu sắc sáng) toàn một màu trên cả một bề mặt mịn màng, nhìn thích mắt: làn da trắng muốt * sợi tơ vàng muốt",
    example: "làn da trắng muốt * sợi tơ vàng muốt",
  },
  {
    word: "mút",
    part_of_speech: "danh từ",
    meaning:
      "vật liệu xốp chế từ cao su, thường dùng làm đệm: lót một lớp mút * đệm mút",
    example: "lót một lớp mút * đệm mút",
  },
  {
    word: "mút",
    part_of_speech: "danh từ",
    meaning:
      "đầu tận cùng của vật hoặc một nơi có độ dài đáng kể: cầm một đầu mút của sợi dây",
    example: "cầm một đầu mút của sợi dây",
  },
  {
    word: "mút",
    part_of_speech: "tính từ",
    meaning: "xa đến tận cuối tầm nhìn: cao mút trời * ở mút xa tầm mắt",
    example: "cao mút trời * ở mút xa tầm mắt",
  },
  {
    word: "mút",
    part_of_speech: "động từ",
    meaning: "ngậm vào miệng rồi chúm môi lại hút: em bé mút vú mẹ * kẹo mút",
    example: "em bé mút vú mẹ * kẹo mút",
  },
  {
    word: "mút",
    part_of_speech: "động từ",
    meaning:
      "ngậm, kẹp giữ lại vật đang trong quá trình chuyển động, làm cho chuyển động khó khăn: xe bị mút côn * bùn mút chặt lấy chân, không rút lên được",
    example: "xe bị mút côn * bùn mút chặt lấy chân, không rút lên được",
  },
  {
    word: "mứa",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) thừa tới mức không thiết gì đến nữa: bỏ mứa * thừa mứa",
    example: "bỏ mứa * thừa mứa",
  },
  {
    word: "mưa",
    part_of_speech: "danh từ",
    meaning:
      "hiện tượng nước rơi thành giọt từ mây xuống mặt đất: cơn mưa * mùa mưa * giọt mưa * khóc như mưa (= khóc rất nhiều)",
    example: "cơn mưa * mùa mưa * giọt mưa * khóc như mưa",
  },
  {
    word: "mưa",
    part_of_speech: "động từ",
    meaning:
      "(thường trời mưa) xảy ra hiện tượng này: Trời đang mưa. * Đang mưa mà đi đâu? * Trời mưa như trút nước (= mưa rất lớn).",
    example:
      "Trời đang mưa. * Đang mưa mà đi đâu? * Trời mưa như trút nước (= mưa rất lớn).",
  },
  {
    word: "mụt",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ) mụn: mặt nổi mụt",
    example: "mặt nổi mụt",
  },
  {
    word: "mụt",
    part_of_speech: "danh từ",
    meaning: "chồi non mới nhú, chưa có lá: mụt măng * mụt mía",
    example: "mụt măng * mụt mía",
  },
  {
    word: "mưa bụi",
    part_of_speech: "danh từ",
    meaning: "mưa hạt nhỏ li ti như những hạt bụi: trời rắc mưa bụi",
    example: "trời rắc mưa bụi",
  },
  {
    word: "mưa gió",
    part_of_speech: "danh từ",
    meaning:
      "mưa và gió (nói khái quát); thường dùng để chỉ thời tiết: mưa gió thuận hoà",
    example: "mưa gió thuận hoà",
  },
  {
    word: "mửa",
    part_of_speech: "động từ",
    meaning: "(Khẩu ngữ) nôn ra: ăn được tí cháo lại mửa ra hết",
    example: "ăn được tí cháo lại mửa ra hết",
  },
  {
    word: "mửa mật",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) mửa cả ra mật; thường dùng để nói sự chịu đựng quá sức do vất vả, nặng nhọc: làm mửa mật mới xong",
    example: "làm mửa mật mới xong",
  },
  {
    word: "mưa móc",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, văn chương) mưa và sương; dùng để ví ân huệ trên ban xuống: đội ơn mưa móc",
    example: "đội ơn mưa móc",
  },
  {
    word: "mưa rào",
    part_of_speech: "danh từ",
    meaning:
      "mưa hạt to và nhiều, mau tạnh, thường do các đám mây dông gây ra: trận mưa rào",
    example: "trận mưa rào",
  },
  {
    word: "mưa nắng",
    part_of_speech: "danh từ",
    meaning:
      "mưa và nắng thất thường, nói về mặt thời tiết gây ảnh hưởng đến sức khoẻ, đời sống: dãi dầu mưa nắng",
    example: "dãi dầu mưa nắng",
  },
  {
    word: "mưa thuận gió hoà",
    part_of_speech: "",
    meaning:
      'thời tiết thuận lợi cho việc canh tác, trồng trọt: "Lạy trời mưa thuận gió hoà, Để cho chiêm tốt mùa tươi em mừng." (ca dao)',
    example:
      'Lạy trời mưa thuận gió hoà, Để cho chiêm tốt mùa tươi em mừng." (ca dao)',
  },
  {
    word: "mức",
    part_of_speech: "danh từ",
    meaning:
      "cái đã được xác định làm căn cứ để nhằm đạt tới trong hoạt động, để làm chuẩn so sánh, đánh giá: vượt mức kế hoạch * đánh giá đúng mức",
    example: "vượt mức kế hoạch * đánh giá đúng mức",
  },
  {
    word: "mưa mây",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) như mây mưa: "Cũng là lỡ một, lầm hai, Đá vàng sao nỡ ép nài mưa mây!" (TKiều)',
    example: 'Cũng là lỡ một, lầm hai, Đá vàng sao nỡ ép nài mưa mây!" (TKiều)',
  },
  {
    word: "mức sống",
    part_of_speech: "danh từ",
    meaning:
      "mức đạt được của các điều kiện sinh hoạt vật chất và tinh thần: mức sống của người dân đã được cải thiện",
    example: "mức sống của người dân đã được cải thiện",
  },
  {
    word: "mức độ",
    part_of_speech: "danh từ",
    meaning:
      "mức trên một thang độ, được xác định đại khái: mức độ trung bình * sự việc chưa tới mức độ trầm trọng",
    example: "mức độ trung bình * sự việc chưa tới mức độ trầm trọng",
  },
  {
    word: "mức nước",
    part_of_speech: "danh từ",
    meaning:
      "vị trí của mặt nước theo chiều cao so với mặt chuẩn: mức nước sông Hồng lên cao",
    example: "mức nước sông Hồng lên cao",
  },
  {
    word: "mực",
    part_of_speech: "danh từ",
    meaning:
      "động vật thân mềm ở biển, chân là các tua ở đầu, có túi chứa chất lỏng đen như mực, thịt ăn được: chả mực * mực khô",
    example: "chả mực * mực khô",
  },
  {
    word: "mực",
    part_of_speech: "danh từ",
    meaning:
      "chất nước màu đen dùng để viết chữ Hán bằng bút lông hoặc để vẽ: mài mực * ngoài trời tối đen như mực",
    example: "mài mực * ngoài trời tối đen như mực",
  },
  {
    word: "mực",
    part_of_speech: "danh từ",
    meaning:
      "chất có màu dùng hoà tan trong nước để viết, in: mực tím * mực in * bút mực * mực dây ra tay",
    example: "mực tím * mực in * bút mực * mực dây ra tay",
  },
  {
    word: "mực",
    part_of_speech: "danh từ",
    meaning: "dây mực (nói tắt): nẩy mực",
    example: "nẩy mực",
  },
  {
    word: "mực",
    part_of_speech: "tính từ",
    meaning: "(chó) có lông màu đen: chó mực",
    example: "chó mực",
  },
  {
    word: "mực",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như mức: mực nước biển",
    example: "mực nước biển",
  },
  {
    word: "mực tàu",
    part_of_speech: "danh từ",
    meaning:
      "mực đen đóng thành thỏi, dùng mài vào nước để viết chữ Hán bằng bút lông hoặc để vẽ: mài mực tàu",
    example: "mài mực tàu",
  },
  {
    word: "mưng",
    part_of_speech: "động từ",
    meaning:
      "(mụn nhọt, vết thương nhiễm trùng) sưng to và đang sinh mủ, gây đau: cái nhọt đang mưng mủ",
    example: "cái nhọt đang mưng mủ",
  },
  {
    word: "mửng",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) kiểu, điệu: cứ mửng này thì còn lâu mới tới",
    example: "cứ mửng này thì còn lâu mới tới",
  },
  {
    word: "mừng",
    part_of_speech: "động từ",
    meaning:
      "có tâm trạng rất thích thú vì đạt được, có được điều như mong muốn: mừng vì con thi đỗ đại học * tay bắt mặt mừng",
    example: "mừng vì con thi đỗ đại học * tay bắt mặt mừng",
  },
  {
    word: "mừng",
    part_of_speech: "động từ",
    meaning:
      "bày tỏ tình cảm của mình bằng lời nói hay tặng phẩm trước niềm vui của người khác: mừng tân gia * quà mừng đám cưới",
    example: "mừng tân gia * quà mừng đám cưới",
  },
  {
    word: "mừng quýnh",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) mừng quá, đến mức cuống cả lên: nghe thấy tiếng mẹ, thằng bé mừng quýnh",
    example: "nghe thấy tiếng mẹ, thằng bé mừng quýnh",
  },
  {
    word: "mực thước",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) cái dây mực và cái thước thợ mộc để lấy đường thẳng; những phép tắc, mẫu mực cần phải tuân theo: cha mẹ làm mực thước cho con cái",
    example: "cha mẹ làm mực thước cho con cái",
  },
  {
    word: "mực thước",
    part_of_speech: "tính từ",
    meaning: "theo đúng khuôn phép: lối sống rất mực thước",
    example: "lối sống rất mực thước",
  },
  {
    word: "mừng công",
    part_of_speech: "động từ",
    meaning:
      "(tập thể) vui liên hoan mừng thành tích, thắng lợi: buổi liên hoan mừng công",
    example: "buổi liên hoan mừng công",
  },
  {
    word: "mừng tuổi",
    part_of_speech: "động từ",
    meaning:
      "mừng người khác thêm một tuổi vào dịp năm mới, thường bằng cách cho quà hoặc tiền: mừng tuổi ông bà",
    example: "mừng tuổi ông bà",
  },
  {
    word: "mừng rỡ",
    part_of_speech: "",
    meaning:
      "mừng, biểu hiện rõ ra trên nét mặt, cử chỉ: được gặp lại nhau, ai nấy đều mừng rỡ * con chó ngoáy tít đuôi mừng rỡ",
    example:
      "được gặp lại nhau, ai nấy đều mừng rỡ * con chó ngoáy tít đuôi mừng rỡ",
  },
  {
    word: "mừng rơn",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) mừng đến mức có cảm giác rộn lên trong lòng: mọi người khấp khởi, mừng rơn",
    example: "mọi người khấp khởi, mừng rơn",
  },
  {
    word: "mừng thầm",
    part_of_speech: "động từ",
    meaning:
      "mừng lắm, nhưng giữ trong lòng, không bộc lộ ra ngoài: khấp khởi mừng thầm",
    example: "khấp khởi mừng thầm",
  },
  {
    word: "mười",
    part_of_speech: "danh từ",
    meaning:
      "số (ghi bằng 10) liền sau số chín trong dãy số tự nhiên: lên mười tuổi * đếm từ một đến mười",
    example: "lên mười tuổi * đếm từ một đến mười",
  },
  {
    word: "mười",
    part_of_speech: "danh từ",
    meaning:
      "từ chỉ số lượng không xác định, nhưng được coi là nhiều hoặc toàn vẹn: buôn một lãi mười * “Rằng trong ngọc đá vàng thau, Mười phần ta đã tin nhau cả mười.” (TKiều)",
    example:
      "buôn một lãi mười * “Rằng trong ngọc đá vàng thau, Mười phần ta đã tin nhau cả mười.” (TKiều)",
  },
  {
    word: "mươi",
    part_of_speech: "danh từ",
    meaning: "mười, chục: ba mươi lăm * tuổi đôi mươi * mấy mươi năm trôi qua",
    example: "ba mươi lăm * tuổi đôi mươi * mấy mươi năm trôi qua",
  },
  {
    word: "mươi",
    part_of_speech: "danh từ",
    meaning:
      "từ chỉ số lượng không xác định, khoảng mười hoặc trên dưới mười: có khoảng mươi, mười lăm người * việc này mất khoảng mươi hôm thì xong",
    example:
      "có khoảng mươi, mười lăm người * việc này mất khoảng mươi hôm thì xong",
  },
  {
    word: "mười mươi",
    part_of_speech: "tính từ",
    meaning:
      "được coi là hoàn toàn, là chắc chắn: sai mười mươi mà vẫn cãi * biết rõ mười mươi",
    example: "sai mười mươi mà vẫn cãi * biết rõ mười mươi",
  },
  {
    word: "mướn",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) thuê: mướn người làm * mướn nhà ở tạm * cày thuê cuốc mướn",
    example: "mướn người làm * mướn nhà ở tạm * cày thuê cuốc mướn",
  },
  {
    word: "mười phân vẹn mười",
    part_of_speech: "",
    meaning:
      '(văn chương) hoàn toàn trọn vẹn, hoàn hảo, không thiếu sót mặt nào (thường nói về vẻ đẹp của người phụ nữ): "Mai cốt cách, tuyết tinh thần, Mỗi người một vẻ, mười phân vẹn mười." (TKiều)',
    example:
      'Mai cốt cách, tuyết tinh thần, Mỗi người một vẻ, mười phân vẹn mười." (TKiều)',
  },
  {
    word: "mươn mướt",
    part_of_speech: "tính từ",
    meaning: "hơi nhẵn và trơn, trông thích mắt: lá non mươn mướt",
    example: "lá non mươn mướt",
  },
  {
    word: "mươi bữa nửa tháng",
    part_of_speech: "",
    meaning:
      "khoảng thời gian ước lượng, chừng trên dưới mười ngày đến trên dưới nửa tháng: đi mươi bữa nửa tháng thì về",
    example: "đi mươi bữa nửa tháng thì về",
  },
  {
    word: "mượn mõ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) hỏi mượn, thường là đã nhiều lần và khiến người ta khó chịu: suốt ngày mượn mõ * không mượn mõ gì cả",
    example: "suốt ngày mượn mõ * không mượn mõ gì cả",
  },
  {
    word: "mượn",
    part_of_speech: "động từ",
    meaning:
      "lấy dùng vật thuộc sở hữu của người khác trong một thời gian rồi sẽ trả lại, với sự đồng ý của người đó: hỏi mượn tiền * cho bạn mượn xe * có thẻ mượn sách ở thư viện",
    example: "hỏi mượn tiền * cho bạn mượn xe * có thẻ mượn sách ở thư viện",
  },
  {
    word: "mượn",
    part_of_speech: "động từ",
    meaning: "nhờ làm giúp việc gì: mượn người viết hộ lá đơn * ai mượn mà làm",
    example: "mượn người viết hộ lá đơn * ai mượn mà làm",
  },
  {
    word: "mượn",
    part_of_speech: "động từ",
    meaning: "nhờ làm rồi trả công: mượn thợ * mượn người gặt",
    example: "mượn thợ * mượn người gặt",
  },
  {
    word: "mượn",
    part_of_speech: "động từ",
    meaning:
      "nhờ, dựa vào, dùng làm phương tiện làm việc gì: mượn cớ * mượn lí do * mượn rượu để nói",
    example: "mượn cớ * mượn lí do * mượn rượu để nói",
  },
  {
    word: "mượn",
    part_of_speech: "động từ",
    meaning:
      "tiếp nhận cái vốn không phải của mình để dùng: từ mượn của tiếng nước ngoài",
    example: "từ mượn của tiếng nước ngoài",
  },
  {
    word: "mương",
    part_of_speech: "danh từ",
    meaning:
      "kênh nhỏ để tưới tiêu nước: đào mương dẫn nước * tát nước từ mương vào ruộng",
    example: "đào mương dẫn nước * tát nước từ mương vào ruộng",
  },
  {
    word: "mương máng",
    part_of_speech: "danh từ",
    meaning:
      "công trình nhỏ để dẫn nước và tưới tiêu nước (nói khái quát): hệ thống mương máng",
    example: "hệ thống mương máng",
  },
  {
    word: "mường tượng",
    part_of_speech: "động từ",
    meaning:
      "nhớ lại hoặc tưởng tượng ra trong trí hình ảnh nào đó không rõ ràng: mường tượng một tương lai tươi sáng",
    example: "mường tượng một tương lai tươi sáng",
  },
  {
    word: "mườn mượt",
    part_of_speech: "tính từ",
    meaning: "hơi mượt: mái tóc mườn mượt",
    example: "mái tóc mườn mượt",
  },
  {
    word: "mướp",
    part_of_speech: "danh từ",
    meaning:
      "cây trồng thân leo, hoa đơn tính màu vàng, quả dài, dùng làm thức ăn, khi già thì khô thành xơ: bắc giàn cho mướp leo",
    example: "bắc giàn cho mướp leo",
  },
  {
    word: "mướp",
    part_of_speech: "tính từ",
    meaning: "rách đến mức trông tả tơi, xơ xác: chiếc áo cánh mướp",
    example: "chiếc áo cánh mướp",
  },
  {
    word: "mượt mà",
    part_of_speech: "tính từ",
    meaning:
      "mượt (nói khái quát): mái tóc óng ả, mượt mà * giọng hát mượt mà sâu lắng",
    example: "mái tóc óng ả, mượt mà * giọng hát mượt mà sâu lắng",
  },
  {
    word: "mưu cầu",
    part_of_speech: "động từ",
    meaning:
      "lo làm sao thực hiện cho được điều mong muốn tốt đẹp: mưu cầu một cuộc sống ấm no * mưu cầu hạnh phúc",
    example: "mưu cầu một cuộc sống ấm no * mưu cầu hạnh phúc",
  },
  {
    word: "mướt mượt",
    part_of_speech: "tính từ",
    meaning:
      "rất mượt và mỡ màng trên cả một bề mặt, nhìn thấy thích mắt: mớ tóc dày mướt mượt",
    example: "mớ tóc dày mướt mượt",
  },
  {
    word: "mượt",
    part_of_speech: "tính từ",
    meaning:
      "bóng láng và mềm mại trên cả một bề mặt, nhìn thấy thích mắt: tóc mượt * mượt như nhung * lông vàng mượt",
    example: "tóc mượt * mượt như nhung * lông vàng mượt",
  },
  {
    word: "mứt",
    part_of_speech: "danh từ",
    meaning:
      "món ăn làm bằng những thứ củ, quả, v.v. rim đường: mứt sen * làm mứt * hộp mứt Tết",
    example: "mứt sen * làm mứt * hộp mứt Tết",
  },
  {
    word: "mướt mát",
    part_of_speech: "tính từ",
    meaning:
      "(xanh) mướt và đều khắp cả, trông thích mắt: bãi dâu xanh mướt mát",
    example: "bãi dâu xanh mướt mát",
  },
  {
    word: "mướt",
    part_of_speech: "tính từ",
    meaning:
      "bóng láng và mỡ màng, nhìn thấy thích mắt (thường nói về cỏ cây hay vật mềm): mái tóc đen mướt * cỏ non xanh mướt",
    example: "mái tóc đen mướt * cỏ non xanh mướt",
  },
  {
    word: "mướt",
    part_of_speech: "động từ",
    meaning: "(mồ hôi) toát ra ướt đầm: mồ hôi mướt ra đầm đìa",
    example: "mồ hôi mướt ra đầm đìa",
  },
  {
    word: "mướt",
    part_of_speech: "tính từ",
    meaning:
      "rất vất vả (như mướt cả mồ hôi mới làm được): còn mướt mới làm xong",
    example: "còn mướt mới làm xong",
  },
  {
    word: "mưu",
    part_of_speech: "danh từ",
    meaning:
      "cách khôn khéo nghĩ ra để đánh lừa đối phương nhằm đạt mục đích của mình: mưu cao * mắc mưu kẻ xấu",
    example: "mưu cao * mắc mưu kẻ xấu",
  },
  {
    word: "mưu",
    part_of_speech: "động từ",
    meaning:
      "lo toan tìm cách này cách khác nhằm thực hiện cho được: mưu chuyện hại người * mưu làm phản",
    example: "mưu chuyện hại người * mưu làm phản",
  },
  {
    word: "mưu chước",
    part_of_speech: "danh từ",
    meaning:
      "cách được coi là khôn khéo, có hiệu quả để thoát khỏi thế bí hay để làm được việc gì (nói khái quát): bày đặt mưu chước",
    example: "bày đặt mưu chước",
  },
  {
    word: "mưu hại",
    part_of_speech: "động từ",
    meaning: "bày mưu kế ngầm để hại người: mưu hại trung thần",
    example: "mưu hại trung thần",
  },
  {
    word: "mưu kế",
    part_of_speech: "danh từ",
    meaning:
      "cách khôn khéo được tính toán kĩ để đánh lừa đối phương, nhằm đạt mục đích của mình: bàn tính mưu kế * mưu kế thâm độc",
    example: "bàn tính mưu kế * mưu kế thâm độc",
  },
  {
    word: "mưu đồ",
    part_of_speech: "động từ",
    meaning:
      "tính toán, sắp đặt sẵn mọi việc nhằm thực hiện cho được ý định lớn: mưu đồ việc nước",
    example: "mưu đồ việc nước",
  },
  {
    word: "mưu đồ",
    part_of_speech: "danh từ",
    meaning:
      "sự tính toán, sắp đặt nhằm thực hiện cho được ý định (thường là lớn): thực hiện mưu đồ * một mưu đồ bẩn thỉu",
    example: "thực hiện mưu đồ * một mưu đồ bẩn thỉu",
  },
  {
    word: "mưu cơ",
    part_of_speech: "danh từ",
    meaning:
      "mưu kế sắp đặt công phu để thực hiện việc lớn, thường là về quân sự: bày đặt mưu cơ * mưu cơ bị bại lộ",
    example: "bày đặt mưu cơ * mưu cơ bị bại lộ",
  },
  {
    word: "mưu lược",
    part_of_speech: "danh từ",
    meaning: "mưu trí và sách lược (nói khái quát): mưu lược quân sự",
    example: "mưu lược quân sự",
  },
  {
    word: "mưu lược",
    part_of_speech: "tính từ",
    meaning: "(hiếm) có nhiều mưu trí: một vị tướng tài ba và mưu lược",
    example: "một vị tướng tài ba và mưu lược",
  },
  {
    word: "mưu mẹo",
    part_of_speech: "danh từ",
    meaning:
      "cách khôn khéo để đánh lừa đối phương nhằm thực hiện một ý định nào đó (nói khái quát): dùng mưu mẹo để lừa đối phương",
    example: "dùng mưu mẹo để lừa đối phương",
  },
  {
    word: "mưu mẹo",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có nhiều mưu mẹo: anh ta mưu mẹo lắm * một người mưu mẹo",
    example: "anh ta mưu mẹo lắm * một người mưu mẹo",
  },
  {
    word: "mưu mô",
    part_of_speech: "động từ",
    meaning:
      "tính toán, sắp đặt ngầm mọi sự nhằm làm việc bất chính: mưu mô làm phản",
    example: "mưu mô làm phản",
  },
  {
    word: "mưu mô",
    part_of_speech: "danh từ",
    meaning:
      "sự tính toán, sắp đặt ngầm nhằm làm việc bất chính: mưu mô quỷ quyệt * lắm mưu mô, thủ đoạn",
    example: "mưu mô quỷ quyệt * lắm mưu mô, thủ đoạn",
  },
  {
    word: "mưu tính",
    part_of_speech: "động từ",
    meaning:
      "lo tính, sắp đặt trước sau nhằm thực hiện cho được việc gì: mưu tính việc làm ăn * mưu tính chiếm đoạt của công",
    example: "mưu tính việc làm ăn * mưu tính chiếm đoạt của công",
  },
  {
    word: "mưu toan",
    part_of_speech: "động từ",
    meaning:
      "tính toán, sắp đặt mọi sự nhằm thực hiện ý đồ không chính đáng của mình: mưu toan chiếm dụng công quỹ",
    example: "mưu toan chiếm dụng công quỹ",
  },
  {
    word: "mưu toan",
    part_of_speech: "danh từ",
    meaning: "(hiếm) sự mưu toan: một người lắm mưu toan",
    example: "một người lắm mưu toan",
  },
  {
    word: "mưu sinh",
    part_of_speech: "động từ",
    meaning: "tìm cách để sinh sống: lo chuyện mưu sinh * tính kế mưu sinh",
    example: "lo chuyện mưu sinh * tính kế mưu sinh",
  },
  {
    word: "mưu sát",
    part_of_speech: "động từ",
    meaning:
      "sắp đặt mưu kế ngầm để giết người: vụ mưu sát không thành * tội mưu sát",
    example: "vụ mưu sát không thành * tội mưu sát",
  },
  {
    word: "mỹ",
    part_of_speech: "tính từ",
    meaning: "đẹp: cái chân, cái thiện, cái mĩ",
    example: "cái chân, cái thiện, cái mĩ",
  },
  {
    word: "mưu trí",
    part_of_speech: "danh từ",
    meaning: "mưu kế và tài trí (nói khái quát): dùng mưu trí để đối phó",
    example: "dùng mưu trí để đối phó",
  },
  {
    word: "mưu trí",
    part_of_speech: "tính từ",
    meaning: "khôn ngoan, có mưu trí: một chiến sĩ rất gan dạ và mưu trí",
    example: "một chiến sĩ rất gan dạ và mưu trí",
  },
  {
    word: "mỹ dục",
    part_of_speech: "",
    meaning:
      "giáo dục khả năng nhận thức, thưởng thức và thể hiện cái đẹp: công tác mĩ dục",
    example: "công tác mĩ dục",
  },
  {
    word: "mỹ học",
    part_of_speech: "danh từ",
    meaning:
      "khoa học nghiên cứu về cái đẹp và những hình thức, phương pháp phản ánh và sáng tạo cái đẹp trong nghệ thuật: nhà mĩ học * bộ môn mĩ học",
    example: "nhà mĩ học * bộ môn mĩ học",
  },
  {
    word: "mỹ cảm",
    part_of_speech: "danh từ",
    meaning:
      "khả năng hiểu biết và cảm nhận về cái đẹp: mỗi người có một mĩ cảm khác nhau",
    example: "mỗi người có một mĩ cảm khác nhau",
  },
  {
    word: "mỹ kí",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) (đồ trang sức bằng vàng bạc) giả: gian hàng mĩ kí * nhẫn mĩ kí",
    example: "gian hàng mĩ kí * nhẫn mĩ kí",
  },
  {
    word: "mỹ mãn",
    part_of_speech: "tính từ",
    meaning:
      "tốt đẹp tới mức hài lòng nhất, hoàn toàn như mong muốn: đẹp mĩ mãn * buổi biểu diễn thành công mĩ mãn",
    example: "đẹp mĩ mãn * buổi biểu diễn thành công mĩ mãn",
  },
  {
    word: "mỹ nghệ",
    part_of_speech: "danh từ",
    meaning:
      "nghề thủ công chuyên làm đồ trang sức, trang trí: hàng mĩ nghệ * đá mĩ nghệ",
    example: "hàng mĩ nghệ * đá mĩ nghệ",
  },
  {
    word: "mỹ miều",
    part_of_speech: "tính từ",
    meaning:
      "đẹp một cách hào nhoáng, gây được ấn tượng mạnh (nhưng thường về hình thức bên ngoài): người con gái có vẻ đẹp mĩ miều * có một cái tên khá mĩ miều",
    example: "người con gái có vẻ đẹp mĩ miều * có một cái tên khá mĩ miều",
  },
  {
    word: "mỹ phẩm",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi chung các chế phẩm dùng để trang điểm, để làm tăng sắc đẹp (như phấn, son, nước hoa, v.v.): chọn mua mĩ phẩm * cửa hàng mĩ phẩm",
    example: "chọn mua mĩ phẩm * cửa hàng mĩ phẩm",
  },
  {
    word: "mỹ thuật",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) đẹp, khéo, hợp với thẩm mĩ: cách bày biện trang trí rất mĩ thuật",
    example: "cách bày biện trang trí rất mĩ thuật",
  },
  {
    word: "mỹ quan",
    part_of_speech: "danh từ",
    meaning:
      "vẻ đẹp trông thấy rõ ở bề ngoài, ở cách trang trí, sắp đặt: giữ gìn mĩ quan đô thị",
    example: "giữ gìn mĩ quan đô thị",
  },
  {
    word: "mỹ tục",
    part_of_speech: "danh từ",
    meaning: "tục lệ tốt đẹp: gìn giữ những mĩ tục của làng xã",
    example: "gìn giữ những mĩ tục của làng xã",
  },
  {
    word: "mỹ viện",
    part_of_speech: "danh từ",
    meaning:
      "nơi chuyên chăm sóc, làm tăng sắc đẹp (bằng xoa bóp, tiểu phẫu thuật, v.v.): đi mĩ viện",
    example: "đi mĩ viện",
  },
  {
    word: "ná",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) nỏ: ná bắn chim",
    example: "ná bắn chim",
  },
  {
    word: "ná",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) ná thun (nói tắt): ná cao su",
    example: "ná cao su",
  },
  {
    word: "nả",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) khoảng thời gian hoặc số lượng, thường là không đáng kể: sức nó thì được bao nả",
    example: "sức nó thì được bao nả",
  },
  {
    word: "nã",
    part_of_speech: "động từ",
    meaning: "nhằm vào mà bắn liên tiếp: súng nã đạn * nã pháo vào đồn địch",
    example: "súng nã đạn * nã pháo vào đồn địch",
  },
  {
    word: "nã",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) đòi, lấy ở người khác cho bằng được: nã thuế * nã tiền của cha mẹ",
    example: "nã thuế * nã tiền của cha mẹ",
  },
  {
    word: "nà",
    part_of_speech: "danh từ",
    meaning: "bãi cát bồi ở bờ sông, trồng trọt được: trồng ngô ở ngoài nà",
    example: "trồng ngô ở ngoài nà",
  },
  {
    word: "nà",
    part_of_speech: "phụ từ",
    meaning: "===== (phương ngữ): rượt nà",
    example: "rượt nà",
  },
  {
    word: "nà",
    part_of_speech: "trợ từ",
    meaning: "(phương ngữ)",
    example: "bậy nà, đừng có nghĩ quẩn!",
  },
  {
    word: "na",
    part_of_speech: "danh từ",
    meaning:
      "(Nam mãng cầu) cây ăn quả, quả hình cầu, vỏ có nhiều mắt, thịt trắng, mềm và ngọt, hạt màu đen: quả na đã mở mắt (= kẽ giữa các mắt nở ra) * răng đen nhưng nhức hạt na",
    example:
      "quả na đã mở mắt (= kẽ giữa các mắt nở ra) * răng đen nhưng nhức hạt na",
  },
  {
    word: "na",
    part_of_speech: "động từ",
    meaning:
      "(Nam, cũng nơ) mang theo người một cách lôi thôi, vất vả: na theo đủ thứ * cái đó nặng quá, không na về được",
    example: "na theo đủ thứ * cái đó nặng quá, không na về được",
  },
  {
    word: "nạ dòng",
    part_of_speech: "danh từ",
    meaning:
      "người đàn bà đã có con và đứng tuổi (hàm ý coi thường): người đàn bà nạ dòng",
    example: "người đàn bà nạ dòng",
  },
  {
    word: "na mô",
    part_of_speech: "",
    meaning:
      "từ người theo đạo Phật dùng trong lời tụng niệm, có nghĩa tôn kính: na mô Phật * na mô Quan Thế Âm Bồ Tát",
    example: "na mô Phật * na mô Quan Thế Âm Bồ Tát",
  },
  {
    word: "na ná",
    part_of_speech: "tính từ",
    meaning:
      "hơi giống, gần giống: giọng na ná miền Nam * hai người trông na ná nhau",
    example: "giọng na ná miền Nam * hai người trông na ná nhau",
  },
  {
    word: "nách",
    part_of_speech: "danh từ",
    meaning:
      "mặt dưới chỗ cánh tay nối với ngực: cù vào nách * sách kẹp nách * xốc nách lôi đi",
    example: "cù vào nách * sách kẹp nách * xốc nách lôi đi",
  },
  {
    word: "nách",
    part_of_speech: "danh từ",
    meaning: "cạnh, góc, chỗ sát liền bên: hai nhà sát nách nhau",
    example: "hai nhà sát nách nhau",
  },
  {
    word: "nách",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) cắp ở nách để mang theo: nách con ở bên sườn",
    example: "nách con ở bên sườn",
  },
  {
    word: "na-pan",
    part_of_speech: "danh từ",
    meaning:
      "hỗn hợp nhiên liệu lỏng như xăng, dầu hoả, v.v., kết hợp với một số acid hữu cơ, cháy rất mạnh, dùng cho súng phun lửa, bom cháy, v.v.: bom napalm",
    example: "bom napalm",
  },
  {
    word: "nái",
    part_of_speech: "danh từ",
    meaning:
      "sợi tơ thô, ươm lẫn tơ gốc với tơ nõn, dùng dệt vải: quần nái đen",
    example: "quần nái đen",
  },
  {
    word: "nái",
    part_of_speech: "tính từ",
    meaning:
      "(súc vật) cái, nuôi để cho đẻ: lợn nái * ruộng sâu trâu nái không bằng con gái đầu lòng (tng)",
    example: "lợn nái * ruộng sâu trâu nái không bằng con gái đầu lòng (tng)",
  },
  {
    word: "nái",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) súc vật nái (nói tắt): chọn một con để gây nái * mua trâu lựa nái, mua gái lựa dòng (tng)",
    example:
      "chọn một con để gây nái * mua trâu lựa nái, mua gái lựa dòng (tng)",
  },
  {
    word: "nai",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ngây thơ, hiền lành tới mức nhẹ dạ do còn quá non nớt: thôi, đừng có giả nai nữa!",
    example: "thôi, đừng có giả nai nữa!",
  },
  {
    word: "nai",
    part_of_speech: "danh từ",
    meaning:
      "bình bằng sành, thân phình to, cổ dài, thời trước thường dùng để đựng rượu: nai rượu * tránh thằng một nai, phải thằng hai lọ (tng)",
    example: "nai rượu * tránh thằng một nai, phải thằng hai lọ (tng)",
  },
  {
    word: "nai",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) buộc chặt: nai chặt bao hàng vào xe",
    example: "nai chặt bao hàng vào xe",
  },
  {
    word: "nài",
    part_of_speech: "danh từ",
    meaning: "người trông nom và điều khiển voi hoặc ngựa: nài voi",
    example: "nài voi",
  },
  {
    word: "nài",
    part_of_speech: "danh từ",
    meaning:
      'vòng dây bắt tréo hình số 8, lồng vào chân để trèo cây có thân hình cột như cau, dừa, cho khỏi tuột: "Thương nhau chẳng đặng nhờ nhau, Khác chi con trẻ trèo cau đứt nài." (ca dao)',
    example:
      'Thương nhau chẳng đặng nhờ nhau, Khác chi con trẻ trèo cau đứt nài." (ca dao)',
  },
  {
    word: "nài",
    part_of_speech: "động từ",
    meaning:
      'xin, yêu cầu một cách thiết tha: nài hoa ép liễu * "Mối rằng: Đáng giá nghìn vàng, Rớp nhà nhờ lượng người thương dám nài!" (TKiều)',
    example:
      'nài hoa ép liễu * "Mối rằng: Đáng giá nghìn vàng, Rớp nhà nhờ lượng người thương dám nài!" (TKiều)',
  },
  {
    word: "nác",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ, cũ nác) chất lỏng không màu, không mùi và tồn tại trong tự nhiên ở ao hồ, sông biển, v.v.: nước giếng * nước mưa",
    example: "nước giếng * nước mưa",
  },
  {
    word: "nác",
    part_of_speech: "danh từ",
    meaning:
      "chất lỏng, nói chung: nước mắt * chanh mọng nước * vắt cam lấy nước * thuốc nước",
    example: "nước mắt * chanh mọng nước * vắt cam lấy nước * thuốc nước",
  },
  {
    word: "nác",
    part_of_speech: "danh từ",
    meaning:
      "lần, lượt sử dụng nước, cho một tác dụng nhất định nào đó: chè mới pha nước thứ nhất * thuốc sắc ba nước * giũ ba nước mới hết xà phòng",
    example:
      "chè mới pha nước thứ nhất * thuốc sắc ba nước * giũ ba nước mới hết xà phòng",
  },
  {
    word: "nác",
    part_of_speech: "danh từ",
    meaning:
      "lớp quét, phủ bên ngoài cho bền, đẹp: quét hai nước vôi * vải nhuộm một nước * tốt gỗ hơn tốt nước sơn (tng)",
    example:
      "quét hai nước vôi * vải nhuộm một nước * tốt gỗ hơn tốt nước sơn (tng)",
  },
  {
    word: "nác",
    part_of_speech: "danh từ",
    meaning:
      "vẻ ánh, bóng tự nhiên của một số vật, tựa như có một lớp mỏng chất phản chiếu ánh sáng nào đó phủ bên ngoài: gỗ lên nước bóng loáng * nước thép sáng ngời",
    example: "gỗ lên nước bóng loáng * nước thép sáng ngời",
  },
  {
    word: "nác",
    part_of_speech: "danh từ",
    meaning:
      "vùng đất trong đó những người thuộc một hay nhiều dân tộc cùng sống chung dưới một chế độ chính trị - xã hội và cùng thuộc về một nhà nước nhất định: các nước Đông Dương * tách ra thành lập một nước mới * sang thăm nước bạn",
    example:
      "các nước Đông Dương * tách ra thành lập một nước mới * sang thăm nước bạn",
  },
  {
    word: "nác",
    part_of_speech: "danh từ",
    meaning:
      "bước đi, về mặt nhanh chậm (của ngựa): chỉ xem qua nước chạy đã biết đó là con ngựa hay",
    example: "chỉ xem qua nước chạy đã biết đó là con ngựa hay",
  },
  {
    word: "nác",
    part_of_speech: "danh từ",
    meaning:
      "bước đi của quân cờ, về mặt ảnh hưởng đến thế cờ: đi một nước cờ cao * cờ đang bí nước",
    example: "đi một nước cờ cao * cờ đang bí nước",
  },
  {
    word: "nác",
    part_of_speech: "danh từ",
    meaning:
      "cách hành động, hoạt động để tác động đến tình hình, thoát khỏi thế bí hoặc tạo ra thế thuận lợi: xấu hổ chỉ còn nước chui xuống đất!",
    example: "xấu hổ chỉ còn nước chui xuống đất!",
  },
  {
    word: "nác",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) thế hơn kém: được nước làm già * xuống nước làm lành * nó chỉ có cái nước ăn hại!",
    example:
      "được nước làm già * xuống nước làm lành * nó chỉ có cái nước ăn hại!",
  },
  {
    word: "nác",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) mức độ khó có thể chịu đựng hơn: sao lại độc ác đến nước ấy! * đến nước này thì không thể nhịn được nữa",
    example:
      "sao lại độc ác đến nước ấy! * đến nước này thì không thể nhịn được nữa",
  },
  {
    word: "nải",
    part_of_speech: "danh từ",
    meaning:
      "cụm quả chuối xếp thành hai tầng trong buồng chuối: nải chuối tiêu * buồng chuối có năm nải",
    example: "nải chuối tiêu * buồng chuối có năm nải",
  },
  {
    word: "nạc",
    part_of_speech: "danh từ",
    meaning:
      "thịt không có mỡ: thịt nạc * miếng nạc vai * hết nạc vạc đến xương (tng)",
    example: "thịt nạc * miếng nạc vai * hết nạc vạc đến xương (tng)",
  },
  {
    word: "nạc",
    part_of_speech: "tính từ",
    meaning:
      "gồm toàn thành phần tốt, hữu ích: đất nạc * gỗ nạc (gỗ tốt, chỉ có lõi không có dác)",
    example: "đất nạc * gỗ nạc (gỗ tốt, chỉ có lõi không có dác)",
  },
  {
    word: "nài ép",
    part_of_speech: "động từ",
    meaning:
      "khẩn khoản yêu cầu và cố ép người khác làm theo ý mình: nài ép mãi mới ăn được bát cơm",
    example: "nài ép mãi mới ăn được bát cơm",
  },
  {
    word: "nái sề",
    part_of_speech: "danh từ",
    meaning: "lợn nái đã đẻ nhiều lần.",
    example:
      'Dù chàng năm thiếp bảy thê, Cũng chẳng bỏ được nái sề này đâu." (ca dao)',
  },
  {
    word: "nám",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) rám: bưởi nám vỏ * mặt bị nám",
    example: "bưởi nám vỏ * mặt bị nám",
  },
  {
    word: "nài xin",
    part_of_speech: "động từ",
    meaning:
      "xin, yêu cầu một cách tha thiết, khẩn khoản (nói khái quát): cố nài xin cho bằng được",
    example: "cố nài xin cho bằng được",
  },
  {
    word: "nam",
    part_of_speech: "danh từ",
    meaning:
      "người thuộc nam giới (nói khái quát); phân biệt với nữ: học sinh nam * nam nữ bình đẳng * một đôi nam nữ",
    example: "học sinh nam * nam nữ bình đẳng * một đôi nam nữ",
  },
  {
    word: "nam",
    part_of_speech: "tính từ",
    meaning:
      "(đồ dùng hoặc môn chơi) chuyên dành cho nam giới: quần nam * xe đạp nam * giải bóng đá nam",
    example: "quần nam * xe đạp nam * giải bóng đá nam",
  },
  {
    word: "nam",
    part_of_speech: "danh từ",
    meaning:
      "một trong bốn phương chính, đối diện với phương bắc: nhà quay mặt hướng nam * gió nam",
    example: "nhà quay mặt hướng nam * gió nam",
  },
  {
    word: "nam",
    part_of_speech: "danh từ",
    meaning:
      "(viết hoa) miền phía nam của nước Việt Nam, trong quan hệ với miền phía bắc (miền Bắc): nói giọng Nam * sống trong Nam * vào Nam ra Bắc",
    example: "nói giọng Nam * sống trong Nam * vào Nam ra Bắc",
  },
  {
    word: "nam",
    part_of_speech: "danh từ",
    meaning:
      "(thường viết hoa) khu vực nằm ở phía nam; thường dùng trước đây để chỉ nước Việt Nam, phân biệt với Bắc (nước Trung Quốc) và Tây (nước Pháp): cõi Nam * người Nam ta * thuốc Nam",
    example: "cõi Nam * người Nam ta * thuốc Nam",
  },
  {
    word: "nai lưng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) buộc phải đem hết sức ra mà làm hoặc chịu đựng một cách vất vả: nai lưng ra mà trả nợ",
    example: "nai lưng ra mà trả nợ",
  },
  {
    word: "nai nịt",
    part_of_speech: "động từ",
    meaning:
      "thắt, buộc chặt quần áo hoặc những thứ mang theo cho chặt và gọn vào thân (nói khái quát): nai nịt gọn gàng * vũ khí nai nịt đầy người",
    example: "nai nịt gọn gàng * vũ khí nai nịt đầy người",
  },
  {
    word: "nam bán cầu",
    part_of_speech: "danh từ",
    meaning:
      "nửa Trái Đất, kể từ xích đạo đến Nam Cực: các nước ở khu vực nam bán cầu",
    example: "các nước ở khu vực nam bán cầu",
  },
  {
    word: "nạm",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) thịt ở sườn bò, có lẫn cả gân: phở nạm",
    example: "phở nạm",
  },
  {
    word: "nạm",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) nắm: tay cầm một nạm gạo * hái một nạm lá",
    example: "tay cầm một nạm gạo * hái một nạm lá",
  },
  {
    word: "nạm",
    part_of_speech: "động từ",
    meaning:
      "gắn kim loại hoặc đá quý lên bề mặt đồ vật để trang trí: nhẫn nạm kim cương * chuôi gươm nạm bạc",
    example: "nhẫn nạm kim cương * chuôi gươm nạm bạc",
  },
  {
    word: "nài nỉ",
    part_of_speech: "động từ",
    meaning:
      "nài một cách thiết tha, dai dẳng đến mức người ta khó lòng từ chối: nài nỉ mãi mới chịu nhận * giọng nài nỉ, khẩn cầu",
    example: "nài nỉ mãi mới chịu nhận * giọng nài nỉ, khẩn cầu",
  },
  {
    word: "nam cao",
    part_of_speech: "danh từ",
    meaning:
      "giọng nam ở âm khu cao nhất, thường hát giai điệu chính trong hợp xướng: ca sĩ có giọng nam cao",
    example: "ca sĩ có giọng nam cao",
  },
  {
    word: "nam cực",
    part_of_speech: "danh từ",
    meaning:
      "cực phía nam của Trái Đất: khí hậu ở vùng Nam Cực * chim cánh cụt sống ở Nam Cực",
    example: "khí hậu ở vùng Nam Cực * chim cánh cụt sống ở Nam Cực",
  },
  {
    word: "nam bình",
    part_of_speech: "danh từ",
    meaning:
      "điệu ca Huế có tính chất dịu dàng, trìu mến: câu nam ai, nam bình",
    example: "câu nam ai, nam bình",
  },
  {
    word: "nam giới",
    part_of_speech: "danh từ",
    meaning:
      "những người thuộc về giới không thể đẻ con (nói tổng quát); phân biệt với nữ giới: cánh nam giới * không phân biệt nam giới, nữ giới",
    example: "cánh nam giới * không phân biệt nam giới, nữ giới",
  },
  {
    word: "nam mô",
    part_of_speech: "",
    meaning:
      "từ người theo đạo Phật dùng trong lời tụng niệm, có nghĩa tôn kính: na mô Phật * na mô Quan Thế Âm Bồ Tát",
    example: "na mô Phật * na mô Quan Thế Âm Bồ Tát",
  },
  {
    word: "nam nữ bình quyền",
    part_of_speech: "",
    meaning:
      "quyền lợi và nghĩa vụ của nam và nữ là như nhau, không có sự phân biệt: thực hiện nam nữ bình quyền",
    example: "thực hiện nam nữ bình quyền",
  },
  {
    word: "nam tính",
    part_of_speech: "danh từ",
    meaning: "giới tính nam; phân biệt với nữ tính: có nam tính mạnh mẽ",
    example: "có nam tính mạnh mẽ",
  },
  {
    word: "nam tính",
    part_of_speech: "tính từ",
    meaning:
      "có những đặc điểm, tính chất của giới tính nam (như mạnh mẽ, rắn rỏi, v.v.); phân biệt với nữ tính: gương mặt quyến rũ, rất nam tính",
    example: "gương mặt quyến rũ, rất nam tính",
  },
  {
    word: "nam nữ",
    part_of_speech: "danh từ",
    meaning:
      "nam và nữ (nói khái quát): một đôi nam nữ * tình yêu nam nữ * quan hệ nam nữ",
    example: "một đôi nam nữ * tình yêu nam nữ * quan hệ nam nữ",
  },
  {
    word: "nam trầm",
    part_of_speech: "danh từ",
    meaning: "giọng nam ở âm khu thấp, thường ấm và khoẻ: giọng nam trầm",
    example: "giọng nam trầm",
  },
  {
    word: "nam nhi",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, văn chương) đàn ông, con trai, thường nói về mặt có chí khí, có tính cách mạnh mẽ (nói khái quát); phân biệt với nữ nhi: đấng nam nhi * chí nam nhi",
    example: "đấng nam nhi * chí nam nhi",
  },
  {
    word: "nan",
    part_of_speech: "danh từ",
    meaning:
      "thanh tre, nứa, v.v. mỏng dùng để đan, ghép thành đồ vật: chẻ nan đan rổ * nan giường * quạt nan * mũ nan",
    example: "chẻ nan đan rổ * nan giường * quạt nan * mũ nan",
  },
  {
    word: "nam tử",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) người con trai: một trang nam tử * "Đổi thay quần áo đàn bà, Mặc đồ nam tử bước ra tức thì." (NTT)',
    example:
      'một trang nam tử * "Đổi thay quần áo đàn bà, Mặc đồ nam tử bước ra tức thì." (NTT)',
  },
  {
    word: "nản chí",
    part_of_speech: "động từ",
    meaning:
      "nản, không giữ vững được ý chí, thiếu kiên trì trước khó khăn, trở ngại: nản chí sờn lòng",
    example: "nản chí sờn lòng",
  },
  {
    word: "nam vô",
    part_of_speech: "",
    meaning:
      "từ người theo đạo Phật dùng trong lời tụng niệm, có nghĩa tôn kính: na mô Phật * na mô Quan Thế Âm Bồ Tát",
    example: "na mô Phật * na mô Quan Thế Âm Bồ Tát",
  },
  {
    word: "nán",
    part_of_speech: "động từ",
    meaning:
      "cố ở lại thêm ít lâu ở một nơi nào đó khi đáng lẽ đã phải rời đi: nán chờ thêm một lúc * ngồi nán thêm chút nữa",
    example: "nán chờ thêm một lúc * ngồi nán thêm chút nữa",
  },
  {
    word: "nan giải",
    part_of_speech: "tính từ",
    meaning:
      "khó giải quyết: vấn đề nan giải * bị đặt vào tình huống cực kì nan giải",
    example: "vấn đề nan giải * bị đặt vào tình huống cực kì nan giải",
  },
  {
    word: "nạn",
    part_of_speech: "danh từ",
    meaning:
      "hiện tượng trong thiên nhiên hoặc xã hội gây hại lớn cho con người: nạn đói * nạn lụt * nạn tham ô * gặp nạn * cứu người bị nạn",
    example: "nạn đói * nạn lụt * nạn tham ô * gặp nạn * cứu người bị nạn",
  },
  {
    word: "nản",
    part_of_speech: "động từ",
    meaning:
      "ở trạng thái thiếu tin tưởng, không muốn tiếp tục công việc đang làm vì thấy khó khăn hoặc vì quá mệt mỏi: thất bại nhiều cũng đâm nản",
    example: "thất bại nhiều cũng đâm nản",
  },
  {
    word: "nan hoa",
    part_of_speech: "danh từ",
    meaning:
      "thanh sắt nhỏ đan chéo nhau và nối trục bánh xe với vành bánh xe: xe bị gãy nan hoa * nan hoa xe đạp",
    example: "xe bị gãy nan hoa * nan hoa xe đạp",
  },
  {
    word: "nàng",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) từ dùng để chỉ hoặc gọi người phụ nữ trẻ tuổi, xinh đẹp, được yêu quý, tôn trọng: chàng và nàng * "Gió mưa là bệnh của trời, Tương tư là bệnh của tôi yêu nàng." (NgBính; 15)',
    example:
      'chàng và nàng * "Gió mưa là bệnh của trời, Tương tư là bệnh của tôi yêu nàng." (NgBính; 15)',
  },
  {
    word: "nàng",
    part_of_speech: "danh từ",
    meaning:
      "người phụ nữ trẻ tuổi được coi trọng: nàng tiên * nàng Tô Thị * mẹ chồng nàng dâu",
    example: "nàng tiên * nàng Tô Thị * mẹ chồng nàng dâu",
  },
  {
    word: "nan y",
    part_of_speech: "tính từ",
    meaning:
      "(bệnh) khó chữa khỏi (thường do chưa tìm ra cách chữa): mắc bệnh nan y * lao phổi là một trong tứ chứng nan y thời trước",
    example: "mắc bệnh nan y * lao phổi là một trong tứ chứng nan y thời trước",
  },
  {
    word: "nan y",
    part_of_speech: "động từ",
    meaning:
      "so bì, tính toán hơn thiệt giữa mình với người trước một công việc phải làm: nạnh nhau từng tí một",
    example: "nạnh nhau từng tí một",
  },
  {
    word: "nạn nhân",
    part_of_speech: "danh từ",
    meaning:
      "người bị tai nạn: cứu vớt nạn nhân bị đắm tàu * nạn nhân vụ hoả hoạn",
    example: "cứu vớt nạn nhân bị đắm tàu * nạn nhân vụ hoả hoạn",
  },
  {
    word: "nạn nhân",
    part_of_speech: "danh từ",
    meaning:
      "người phải chịu hậu quả của một tai hoạ xã hội hay một chế độ bất công: nạn nhân chiến tranh",
    example: "nạn nhân chiến tranh",
  },
  {
    word: "nang",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận giống như cái bao hoặc cơ quan nhỏ tiết dịch, có tác dụng để bọc, để che chở: nang mực",
    example: "nang mực",
  },
  {
    word: "náng",
    part_of_speech: "danh từ",
    meaning: "thanh tre, gỗ để đỡ bắp cày: náng cày",
    example: "náng cày",
  },
  {
    word: "nản lòng",
    part_of_speech: "động từ",
    meaning:
      "không còn muốn theo đuổi việc đang làm vì không tin là sẽ có kết quả: phải chờ đợi lâu nên cũng thấy nản lòng",
    example: "phải chờ đợi lâu nên cũng thấy nản lòng",
  },
  {
    word: "nàng thơ",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương) nguồn cảm hứng cho sáng tác thơ trong tâm hồn thi sĩ: đi tìm nàng thơ",
    example: "đi tìm nàng thơ",
  },
  {
    word: "nạng",
    part_of_speech: "danh từ",
    meaning:
      "gậy có ngáng ở đầu trên, dùng để chống, đỡ cho khỏi ngã, đổ: gãy chân nên phải đi nạng * chống nạng",
    example: "gãy chân nên phải đi nạng * chống nạng",
  },
  {
    word: "nanh",
    part_of_speech: "danh từ",
    meaning:
      "răng sắc ở giữa răng cửa và răng hàm, dùng để xé thức ăn: răng nanh * nanh cá sấu * con hổ nhe nanh, giơ vuốt",
    example: "răng nanh * nanh cá sấu * con hổ nhe nanh, giơ vuốt",
  },
  {
    word: "nanh",
    part_of_speech: "danh từ",
    meaning:
      "nốt trắng, cứng, mọc ở lợi trẻ sơ sinh hoặc lợn con, gây đau: trẻ mọc nanh * bẻ nanh cho lợn",
    example: "trẻ mọc nanh * bẻ nanh cho lợn",
  },
  {
    word: "nanh",
    part_of_speech: "danh từ",
    meaning: "mầm trong hạt vừa mới nhú ra khỏi vỏ: thóc đã nứt nanh",
    example: "thóc đã nứt nanh",
  },
  {
    word: "nanh nọc",
    part_of_speech: "tính từ",
    meaning:
      "đanh đá, dữ tợn và hiểm độc, thường lộ rõ ra một cách đáng sợ: người phụ nữ nanh nọc",
    example: "người phụ nữ nanh nọc",
  },
  {
    word: "nạnh",
    part_of_speech: "danh từ",
    meaning:
      "đoạn cây có chạc hai, chạc ba, dùng để chống: chặt cây làm nạnh chống",
    example: "chặt cây làm nạnh chống",
  },
  {
    word: "nanh ác",
    part_of_speech: "tính từ",
    meaning: "dữ tợn và độc ác: bà dì ghẻ nanh ác",
    example: "bà dì ghẻ nanh ác",
  },
  {
    word: "nào",
    part_of_speech: "đại từ",
    meaning:
      "từ dùng để hỏi về cái cần biết và cần xác định cụ thể trong một tập hợp những cái cùng loại: ngày nào thì đi? * cầu thủ nào vừa ghi bàn? * hai cái này, cái nào đẹp hơn?",
    example:
      "ngày nào thì đi? * cầu thủ nào vừa ghi bàn? * hai cái này, cái nào đẹp hơn?",
  },
  {
    word: "nào",
    part_of_speech: "đại từ",
    meaning:
      "từ dùng để chỉ ra mà không nói cụ thể, vì không thể hoặc không cần: có người nào vừa hỏi anh * tôi tin một ngày nào đó mình sẽ thành công",
    example:
      "có người nào vừa hỏi anh * tôi tin một ngày nào đó mình sẽ thành công",
  },
  {
    word: "nào",
    part_of_speech: "đại từ",
    meaning:
      "từ dùng để chỉ một cái bất kì trong một tập hợp những cái cùng loại: người nào đi cũng được * đằng nào chả thế * ăn cây nào, rào cây ấy (tng)",
    example:
      "người nào đi cũng được * đằng nào chả thế * ăn cây nào, rào cây ấy (tng)",
  },
  {
    word: "nào",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị ý phủ định dứt khoát, thường nhằm bác bỏ hoặc bác bỏ trước ý kiến trái lại: nào tôi có biết! * toàn người quen, chứ nào phải ai xa lạ!",
    example: "nào tôi có biết! * toàn người quen, chứ nào phải ai xa lạ!",
  },
  {
    word: "nào",
    part_of_speech: "trợ từ",
    meaning:
      "(Khẩu ngữ) từ biểu thị ý nhấn mạnh thêm về điều vừa nêu ra với người đối thoại, với ý thuyết phục hay ra lệnh: để tôi thử xem nào! * cháu ngoan nào! * im nào! * nhanh lên nào!",
    example: "để tôi thử xem nào! * cháu ngoan nào! * im nào! * nhanh lên nào!",
  },
  {
    word: "nào",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý nhấn mạnh tính chất tập trung vào cùng một nơi, một lúc của những sự vật, sự việc được liệt kê: nào quét dọn, nào giặt giũ, nào nấu nướng, bao nhiêu việc",
    example: "nào quét dọn, nào giặt giũ, nào nấu nướng, bao nhiêu việc",
  },
  {
    word: "nào",
    part_of_speech: "cảm từ",
    meaning:
      "tiếng thốt ra như để gọi người đối thoại, có ý thách thức, thúc giục: nào, nhanh lên đi chứ! * nào, ta đi thôi! * nào, có giỏi thì vào đi!",
    example:
      "nào, nhanh lên đi chứ! * nào, ta đi thôi! * nào, có giỏi thì vào đi!",
  },
  {
    word: "nanh sấu",
    part_of_speech: "danh từ",
    meaning:
      "nanh cá sấu, mọc cái ra cái vào; dùng để ví cách trồng cây thành từng hàng so le với nhau: cây trồng theo lối nanh sấu",
    example: "cây trồng theo lối nanh sấu",
  },
  {
    word: "nanh vuốt",
    part_of_speech: "danh từ",
    meaning:
      "nanh và vuốt của thú dữ; dùng để ví những kẻ giúp việc đắc lực như một thứ vũ khí sắc bén, tạo nên sức mạnh lợi hại (nói khái quát): viên tướng là nanh vuốt của nhà vua",
    example: "viên tướng là nanh vuốt của nhà vua",
  },
  {
    word: "nanh vuốt",
    part_of_speech: "danh từ",
    meaning: "sự kìm kẹp tàn ác, dã man: rơi vào nanh vuốt của kẻ thù",
    example: "rơi vào nanh vuốt của kẻ thù",
  },
  {
    word: "nao",
    part_of_speech: "đại từ",
    meaning: "(Văn chương) nào: nơi nao * biết khi nao gặp lại",
    example: "nơi nao * biết khi nao gặp lại",
  },
  {
    word: "nạo",
    part_of_speech: "động từ",
    meaning:
      "làm cho lớp mỏng bên ngoài bong ra bằng cách dùng vật có đầu hoặc mặt sắc cạo sát bề mặt: nạo cùi dừa * nạo vỏ khoai",
    example: "nạo cùi dừa * nạo vỏ khoai",
  },
  {
    word: "nạo",
    part_of_speech: "danh từ",
    meaning: "dụng cụ có đầu hoặc mặt sắc dùng để nạo: bàn nạo",
    example: "bàn nạo",
  },
  {
    word: "não",
    part_of_speech: "danh từ",
    meaning:
      "khối tập trung các thần kinh trung ương nằm trong hộp sọ: vỏ não * bộ não",
    example: "vỏ não * bộ não",
  },
  {
    word: "não",
    part_of_speech: "danh từ",
    meaning:
      'buồn rầu, đau khổ: lời ru nghe não ruột * "Cuộc đời chưa đến bể dâu, Bỗng dưng mua não chuốc sầu mà chơi." (HT)',
    example:
      'lời ru nghe não ruột * "Cuộc đời chưa đến bể dâu, Bỗng dưng mua não chuốc sầu mà chơi." (HT)',
  },
  {
    word: "náo",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) dậy lên sự ồn ào, nhốn nháo: cơn giông bất ngờ làm cả xóm náo lên",
    example: "cơn giông bất ngờ làm cả xóm náo lên",
  },
  {
    word: "náo động",
    part_of_speech: "động từ",
    meaning:
      "xôn xao, ồn ào khắp cả lên: tiếng nổ làm cả xóm náo động * Tôn Ngộ Không náo động thiên cung",
    example: "tiếng nổ làm cả xóm náo động * Tôn Ngộ Không náo động thiên cung",
  },
  {
    word: "nào hay",
    part_of_speech: "",
    meaning:
      'có biết đâu, có ngờ đâu: "Nào hay sông cạn bể vùi, Lòng trời tráo trở vận người biệt li." (ATV)',
    example:
      'Nào hay sông cạn bể vùi, Lòng trời tráo trở vận người biệt li." (ATV)',
  },
  {
    word: "não nề",
    part_of_speech: "tính từ",
    meaning:
      "buồn bã đến mức làm lây cả sang người khác: giọng ca não nề * dòng tâm sự não nề",
    example: "giọng ca não nề * dòng tâm sự não nề",
  },
  {
    word: "nào là",
    part_of_speech: "trợ từ",
    meaning: "như nào (ng2): khắp nhà nào là giấy, nào là bút, nào là guốc dép",
    example: "khắp nhà nào là giấy, nào là bút, nào là guốc dép",
  },
  {
    word: "nao nao",
    part_of_speech: "tính từ",
    meaning:
      "(tâm trạng) có cảm giác nôn nao do hơi lo sợ, không yên lòng hoặc hơi xao động vì một cảm xúc nào đó: trong lòng nao nao * nao nao buồn",
    example: "trong lòng nao nao * nao nao buồn",
  },
  {
    word: "náo nhiệt",
    part_of_speech: "tính từ",
    meaning: "nhộn nhịp, sôi nổi trong hoạt động: đường phố ồn ào, náo nhiệt",
    example: "đường phố ồn ào, náo nhiệt",
  },
  {
    word: "nào ngờ",
    part_of_speech: "",
    meaning:
      'không ngờ, ngoài dự tính: chuyện nhỏ, nào ngờ hậu quả lại lớn * "Ngỡ rằng nước chảy đá mòn, Nào ngờ nước chảy đá còn trơ trơ." (ca dao)',
    example:
      'chuyện nhỏ, nào ngờ hậu quả lại lớn * "Ngỡ rằng nước chảy đá mòn, Nào ngờ nước chảy đá còn trơ trơ." (ca dao)',
  },
  {
    word: "náo loạn",
    part_of_speech: "động từ",
    meaning:
      "ồn ào một cách hỗn loạn: cuộc cãi cọ làm náo loạn cả xóm * gây náo loạn thị trường",
    example: "cuộc cãi cọ làm náo loạn cả xóm * gây náo loạn thị trường",
  },
  {
    word: "não lòng",
    part_of_speech: "tính từ",
    meaning:
      "rầu lòng, đau đớn trong lòng: buồn não lòng * tiếng ru nghe não lòng",
    example: "buồn não lòng * tiếng ru nghe não lòng",
  },
  {
    word: "não nuột",
    part_of_speech: "tính từ",
    meaning:
      "buồn thảm lắng sâu và thấm thía: tiếng thở dài não nuột * lời thơ não nuột",
    example: "tiếng thở dài não nuột * lời thơ não nuột",
  },
  {
    word: "não nùng",
    part_of_speech: "tính từ",
    meaning:
      'buồn đau tê tái và day dứt: tiếng khóc than não nùng * "Lọt tai nghe suốt năm cung, Tiếng nào là chẳng não nùng xôn xao." (TKiều)',
    example:
      'tiếng khóc than não nùng * "Lọt tai nghe suốt năm cung, Tiếng nào là chẳng não nùng xôn xao." (TKiều)',
  },
  {
    word: "náo nức",
    part_of_speech: "động từ",
    meaning:
      "hăm hở, phấn khích với công việc gì: trai gái náo nức rủ nhau đi xem hội * náo nức chuẩn bị đón năm mới",
    example:
      "trai gái náo nức rủ nhau đi xem hội * náo nức chuẩn bị đón năm mới",
  },
  {
    word: "nao núng",
    part_of_speech: "động từ",
    meaning:
      "bắt đầu thấy lung lay, không còn vững vàng tinh thần nữa: nao núng tinh thần * không nao núng trước khó khăn",
    example: "nao núng tinh thần * không nao núng trước khó khăn",
  },
  {
    word: "nạp",
    part_of_speech: "động từ",
    meaning:
      "đưa vào, lắp vào (dụng cụ, máy móc, súng ống, v.v.) để làm cho sử dụng được, hoạt động được: súng chưa nạp đạn * nạp điện vào acquy * nạp tiền vào tài khoản điện thoại",
    example:
      "súng chưa nạp đạn * nạp điện vào acquy * nạp tiền vào tài khoản điện thoại",
  },
  {
    word: "nao nức",
    part_of_speech: "động từ",
    meaning: "như náo nức: học trò nao nức chuẩn bị ngày khai trường",
    example: "học trò nao nức chuẩn bị ngày khai trường",
  },
  {
    word: "nạo vét",
    part_of_speech: "động từ",
    meaning:
      "nạo và vét cho sạch lớp bùn đất dưới lòng sông, hồ, v.v. (nói khái quát): nạo vét bùn * nạo vét lòng sông",
    example: "nạo vét bùn * nạo vét lòng sông",
  },
  {
    word: "nạt",
    part_of_speech: "động từ",
    meaning: "(hiếm) như bắt nạt: nịnh trên nạt dưới",
    example: "nịnh trên nạt dưới",
  },
  {
    word: "nạt",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) quát mắng to cho phải sợ mà nghe theo: nạt con * nói như nạt",
    example: "nạt con * nói như nạt",
  },
  {
    word: "napalm",
    part_of_speech: "danh từ",
    meaning:
      "hỗn hợp nhiên liệu lỏng như xăng, dầu hoả, v.v., kết hợp với một số acid hữu cơ, cháy rất mạnh, dùng cho súng phun lửa, bom cháy, v.v.: bom napalm",
    example: "bom napalm",
  },
  {
    word: "nát",
    part_of_speech: "động từ",
    meaning:
      "(Phương ngữ, Từ cũ) nhát: thần hồn nát thần tính (tng) * người nhát nát người bạo (tng)",
    example: "thần hồn nát thần tính (tng) * người nhát nát người bạo (tng)",
  },
  {
    word: "nát",
    part_of_speech: "tính từ",
    meaning:
      "bị vỡ vụn ra hoặc bị giập tới mức không còn hình thù gì nữa: nghiền nát * bóp nát quả cam * nghĩ đến là nát cả ruột (b)",
    example: "nghiền nát * bóp nát quả cam * nghĩ đến là nát cả ruột (b)",
  },
  {
    word: "nát",
    part_of_speech: "tính từ",
    meaning:
      "mềm nhão hoặc nhàu tới mức bị biến dạng đi: cơm nát * vò nát tờ giấy",
    example: "cơm nát * vò nát tờ giấy",
  },
  {
    word: "nát",
    part_of_speech: "tính từ",
    meaning:
      "hư hỏng tới mức tồi tệ: manh chiếu nát * ngôi nhà cũ nát * bàn lắm chỉ tổ nát chuyện!",
    example: "manh chiếu nát * ngôi nhà cũ nát * bàn lắm chỉ tổ nát chuyện!",
  },
  {
    word: "nạt nộ",
    part_of_speech: "động từ",
    meaning: "quát tháo lớn tiếng để doạ dẫm: lớn tiếng nạt nộ em",
    example: "lớn tiếng nạt nộ em",
  },
  {
    word: "nát bàn",
    part_of_speech: "danh từ",
    meaning:
      "thế giới tưởng tượng, nơi con người thoát khỏi vòng luân hồi và mọi sự đau khổ (cái đích của sự tu hành theo đạo Phật): cõi niết bàn",
    example: "cõi niết bàn",
  },
  {
    word: "nát óc",
    part_of_speech: "tính từ",
    meaning:
      "(suy nghĩ) rất vất vả để cố tìm cách giải quyết một vấn đề khó khăn phức tạp: nghĩ nát óc",
    example: "nghĩ nát óc",
  },
  {
    word: "nát nước",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (suy nghĩ, bàn tính) kĩ lưỡng đủ mọi cách, không có cách nào không nghĩ đến (để tìm ra cách tốt nhất): bàn đến nát nước * tính nát nước mà vẫn chưa ra",
    example: "bàn đến nát nước * tính nát nước mà vẫn chưa ra",
  },
  {
    word: "nảy",
    part_of_speech: "động từ",
    meaning:
      "(mầm, chồi) bắt đầu nhú ra, mọc ra: thóc đã nảy mầm * cây đâm chồi nảy lộc",
    example: "thóc đã nảy mầm * cây đâm chồi nảy lộc",
  },
  {
    word: "nảy",
    part_of_speech: "động từ",
    meaning: "bắt đầu sinh ra: chợt nảy ra sáng kiến * nảy lòng tham",
    example: "chợt nảy ra sáng kiến * nảy lòng tham",
  },
  {
    word: "náu",
    part_of_speech: "động từ",
    meaning:
      "giấu mình vào nơi kín đáo để khỏi lộ ra: náu sau bụi cây * náu mình trong chiếc áo bành tô",
    example: "náu sau bụi cây * náu mình trong chiếc áo bành tô",
  },
  {
    word: "nay",
    part_of_speech: "đại từ",
    meaning:
      "từ dùng để chỉ thời gian hiện tại, phân biệt với quá khứ hoặc tương lai: ngày nay * từ xưa đến nay * vừa đi sáng nay * nay đây mai đó * mấy năm nay không gặp",
    example:
      "ngày nay * từ xưa đến nay * vừa đi sáng nay * nay đây mai đó * mấy năm nay không gặp",
  },
  {
    word: "nay",
    part_of_speech: "đại từ",
    meaning: "bây giờ: nay công bố...",
    example: "nay công bố...",
  },
  {
    word: "nạy",
    part_of_speech: "động từ",
    meaning:
      "làm bật ra bằng cách dùng vật cứng đặt vào kẽ hở rồi bẩy hoặc đẩy: nạy cửa * nạy từng viên gạch lên",
    example: "nạy cửa * nạy từng viên gạch lên",
  },
  {
    word: "nãy",
    part_of_speech: "đại từ",
    meaning:
      "từ dùng để chỉ khoảng thời gian ngắn vừa mới qua, trong phạm vi một buổi: nó vừa đi lúc nãy * khi nãy có người tìm anh",
    example: "nó vừa đi lúc nãy * khi nãy có người tìm anh",
  },
  {
    word: "nát rượu",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) nghiện rượu nặng đến mức luôn ở trạng thái say và nói càn bậy, mất cả nhân cách: kẻ nát rượu",
    example: "kẻ nát rượu",
  },
  {
    word: "nãy giờ",
    part_of_speech: "đại từ",
    meaning:
      "(khẩu ngữ) từ nãy đến giờ: đợi nãy giờ * đi từ nãy giờ mà vẫn chưa về",
    example: "đợi nãy giờ * đi từ nãy giờ mà vẫn chưa về",
  },
  {
    word: "này khác",
    part_of_speech: "đại từ",
    meaning:
      "(khẩu ngữ) thế này thế khác (không tiện nói cụ thể; hàm ý chê): tính hay nghi ngờ này khác",
    example: "tính hay nghi ngờ này khác",
  },
  {
    word: "này",
    part_of_speech: "đại từ",
    meaning:
      "từ dùng để chỉ đối tượng đang nói đến được xác định và ở ngay hoặc tựa như ở ngay trước mặt: nơi này * ngày này năm xưa * anh thích cái xe này hay cái xe kia?",
    example:
      "nơi này * ngày này năm xưa * anh thích cái xe này hay cái xe kia?",
  },
  {
    word: "này",
    part_of_speech: "trợ từ",
    meaning:
      'từ biểu thị ý nhấn mạnh tính cụ thể và xác định của những sự vật, sự việc, tính chất nào đó đang được liệt kê ra: đẹp trai này, thông minh này, tốt bụng này * "Này chồng, này mẹ, này cha, Này là em ruột, này là em dâu." (TKiều)',
    example:
      'đẹp trai này, thông minh này, tốt bụng này * "Này chồng, này mẹ, này cha, Này là em ruột, này là em dâu." (TKiều)',
  },
  {
    word: "này",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý nhấn mạnh thêm về điều vừa nêu ra, với ý bảo người đối thoại hãy chú ý làm theo: làm như thế này này! * con nghe mẹ dặn này! * ăn đi này!",
    example: "làm như thế này này! * con nghe mẹ dặn này! * ăn đi này!",
  },
  {
    word: "này",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị thái độ nghiêm khắc của lời nói, có hàm ý đe doạ trước một sự chống đối nào đó của người đối thoại: láo này! * này thì cãi này! * có muốn lười không này!",
    example: "láo này! * này thì cãi này! * có muốn lười không này!",
  },
  {
    word: "này",
    part_of_speech: "cảm từ",
    meaning:
      "tiếng thốt ra như để gọi người đối thoại, bảo hãy chú ý: này, cầm lấy! * này, này cái anh kia, đứng lại đã! * à này, còn chuyện này nữa!",
    example:
      "này, cầm lấy! * này, này cái anh kia, đứng lại đã! * à này, còn chuyện này nữa!",
  },
  {
    word: "nảy nòi",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tự nhiên bỗng sinh ra (hàm ý chê bai, khinh ghét): nhà này sao lại nảy nòi ra một đứa hỗn láo như thế?",
    example: "nhà này sao lại nảy nòi ra một đứa hỗn láo như thế?",
  },
  {
    word: "này nọ",
    part_of_speech: "đại từ",
    meaning:
      "(khẩu ngữ) thế này thế kia (không nói cụ thể, vì không muốn hoặc không tiện nói cụ thể; hàm ý chê): nghi ngờ này nọ * yêu cầu này nọ",
    example: "nghi ngờ này nọ * yêu cầu này nọ",
  },
  {
    word: "nảy nở",
    part_of_speech: "động từ",
    meaning: "sinh ra và phát triển: sinh sôi nảy nở * tình yêu nảy nở",
    example: "sinh sôi nảy nở * tình yêu nảy nở",
  },
  {
    word: "nảy lửa",
    part_of_speech: "tính từ",
    meaning:
      "rất kịch liệt, rất dữ dội (tựa như làm bật ra lửa): cái tát nảy lửa * cuộc tranh cãi nảy lửa",
    example: "cái tát nảy lửa * cuộc tranh cãi nảy lửa",
  },
  {
    word: "nảy sinh",
    part_of_speech: "động từ",
    meaning:
      "sinh ra, xuất hiện trong điều kiện, hoàn cảnh nào đó: nảy sinh sáng kiến * nảy sinh tình cảm",
    example: "nảy sinh sáng kiến * nảy sinh tình cảm",
  },
  {
    word: "nặc",
    part_of_speech: "tính từ",
    meaning:
      "có mùi hăng, gắt, khó ngửi, bốc lên mạnh: hơi thở nặc mùi rượu * cơm khê nặc",
    example: "hơi thở nặc mùi rượu * cơm khê nặc",
  },
  {
    word: "nắc nỏm",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) thấp thỏm, hồi hộp vì một việc biết là sắp đến nhưng chưa biết cụ thể ra sao: nắc nỏm chờ kết quả thi * nắc nỏm mừng thầm",
    example: "nắc nỏm chờ kết quả thi * nắc nỏm mừng thầm",
  },
  {
    word: "nắc nỏm",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ, hiếm) như tấm tắc: nắc nỏm khen đẹp",
    example: "nắc nỏm khen đẹp",
  },
  {
    word: "nặc danh",
    part_of_speech: "tính từ",
    meaning:
      "(thư từ, giấy tờ, điện thoại) giấu tên, không ghi, không xưng tên người viết, người gọi: thư nặc danh * đơn tố cáo nặc danh",
    example: "thư nặc danh * đơn tố cáo nặc danh",
  },
  {
    word: "nay mai",
    part_of_speech: "danh từ",
    meaning:
      "những ngày sắp tới, không cụ thể là ngày nào (nói khái quát): việc này chỉ nay mai là xong",
    example: "việc này chỉ nay mai là xong",
  },
  {
    word: "năm",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian Trái Đất di chuyển hết một vòng quanh Mặt Trời, bằng 365 ngày 5 giờ 48 phút 40 giây.",
    example: "bé đã được hai năm ba tháng * sinh viên năm thứ tư",
  },
  {
    word: "năm",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian mười hai tháng hoặc đại khái mười hai tháng: bé đã được hai năm ba tháng * sinh viên năm thứ tư",
    example: "ba tháng đầu năm * những ngày cuối năm",
  },
  {
    word: "năm",
    part_of_speech: "danh từ",
    meaning:
      "số (ghi bằng 5) liền sau số bốn trong dãy số tự nhiên: bé đã lên năm * nhà có năm người * nhà số 5A * năm lần bảy lượt",
    example: "bé đã lên năm * nhà có năm người * nhà số 5A * năm lần bảy lượt",
  },
  {
    word: "nắc nẻ",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi chung các loài bướm cỡ lớn, màu nâu, thường bay về đêm, đập cánh phành phạch: cười như nắc nẻ",
    example: "cười như nắc nẻ",
  },
  {
    word: "nặc nô",
    part_of_speech: "danh từ",
    meaning:
      "(thông tục) người đàn bà đanh đá, lắm lời, thô bỉ (thường dùng làm tiếng chửi, tiếng mắng): con nặc nô!",
    example: "con nặc nô!",
  },
  {
    word: "nằm",
    part_of_speech: "động từ",
    meaning:
      "ngả thân mình trên một vật có mặt phẳng, thường để nghỉ, để ngủ; phân biệt với đứng, ngồi: nằm ngủ * gà nằm ổ * canh một chưa nằm, canh năm đã dậy (tng)",
    example: "nằm ngủ * gà nằm ổ * canh một chưa nằm, canh năm đã dậy (tng)",
  },
  {
    word: "nằm",
    part_of_speech: "động từ",
    meaning:
      "ở một nơi nào đó, không đi ra khỏi, trong một thời gian tương đối lâu và do một yêu cầu nhất định: ốm nên phải nằm viện * án quân lại nằm chờ * anh ấy đã nằm lại ngoài chiến trường (b)",
    example:
      "ốm nên phải nằm viện * án quân lại nằm chờ * anh ấy đã nằm lại ngoài chiến trường (b)",
  },
  {
    word: "nằm",
    part_of_speech: "động từ",
    meaning:
      "được đặt ở yên một chỗ với thế ngang ra trên một vật nào đó: bom nằm rải rác trên mặt đất * đặt nằm cái thang xuống đất * chiếc bút vẫn nằm trong tay",
    example:
      "bom nằm rải rác trên mặt đất * đặt nằm cái thang xuống đất * chiếc bút vẫn nằm trong tay",
  },
  {
    word: "nằm",
    part_of_speech: "động từ",
    meaning:
      "ở hoặc ở trải ra trên một diện rộng, tại một vùng nào đó: ngôi chùa nằm lưng chừng đồi * làng nằm dọc bờ sông",
    example: "ngôi chùa nằm lưng chừng đồi * làng nằm dọc bờ sông",
  },
  {
    word: "nằm",
    part_of_speech: "động từ",
    meaning:
      "ở trong, thuộc trong phạm vi: việc đó nằm ngoài khả năng * khu vực nằm trong tầm kiểm soát của địch",
    example:
      "việc đó nằm ngoài khả năng * khu vực nằm trong tầm kiểm soát của địch",
  },
  {
    word: "nắm",
    part_of_speech: "động từ",
    meaning:
      "co các ngón tay vào lòng bàn tay và giữ chặt lại cho thành một khối: nắm tay lại * bàn tay xoè ra nắm vào",
    example: "nắm tay lại * bàn tay xoè ra nắm vào",
  },
  {
    word: "nắm",
    part_of_speech: "động từ",
    meaning:
      "bóp chặt lại trong lòng bàn tay cho nén thành khối nhỏ: cơm nắm muối vừng * than nắm thành từng bánh",
    example: "cơm nắm muối vừng * than nắm thành từng bánh",
  },
  {
    word: "nắm",
    part_of_speech: "động từ",
    meaning: "giữ chặt trong lòng bàn tay: nắm chặt sợi dây * nắm tay kéo đi",
    example: "nắm chặt sợi dây * nắm tay kéo đi",
  },
  {
    word: "nắm",
    part_of_speech: "động từ",
    meaning:
      "làm cho có được để sử dụng, vận dụng: nắm quyền * nắm lấy thời cơ * nắm vững kiến thức đã học",
    example: "nắm quyền * nắm lấy thời cơ * nắm vững kiến thức đã học",
  },
  {
    word: "nắm",
    part_of_speech: "danh từ",
    meaning: "bàn tay nắm lại thành một khối: to bằng nắm tay",
    example: "to bằng nắm tay",
  },
  {
    word: "nắm",
    part_of_speech: "danh từ",
    meaning: "khối nhỏ nén chặt lại bằng động tác nắm: một nắm xôi * nắm than",
    example: "một nắm xôi * nắm than",
  },
  {
    word: "nắm",
    part_of_speech: "danh từ",
    meaning:
      "lượng vật rời có thể nắm được trong lòng bàn tay: hái nắm lá * bốc một nắm gạo * nắm tro tàn * vơ đũa cả nắm (tng)",
    example: "hái nắm lá * bốc một nắm gạo * nắm tro tàn * vơ đũa cả nắm (tng)",
  },
  {
    word: "năm bảy",
    part_of_speech: "danh từ",
    meaning:
      'số lượng tương đối nhiều, khoảng từ năm đến bảy: ốm mất năm bảy ngày * "Đàn ông năm bảy lá gan, Lá ở cùng vợ, lá toan cùng người." (ca dao)',
    example:
      'ốm mất năm bảy ngày * "Đàn ông năm bảy lá gan, Lá ở cùng vợ, lá toan cùng người." (ca dao)',
  },
  {
    word: "nằm bếp",
    part_of_speech: "động từ",
    meaning: "(cũ, khẩu ngữ) như nằm ổ: vợ đang nằm bếp",
    example: "vợ đang nằm bếp",
  },
  {
    word: "năm ba",
    part_of_speech: "danh từ",
    meaning:
      "số lượng không nhiều nhưng cũng không ít, khoảng từ ba đến năm: mua năm ba tờ báo * nghỉ ngơi năm ba bữa cho lại sức",
    example: "mua năm ba tờ báo * nghỉ ngơi năm ba bữa cho lại sức",
  },
  {
    word: "nắm bắt",
    part_of_speech: "động từ",
    meaning:
      "nắm được, hiểu được để vận dụng, sử dụng (nói khái quát): nắm bắt tinh thần tác phẩm * nắm bắt thị hiếu của khách hàng * nắm bắt lấy cơ hội",
    example:
      "nắm bắt tinh thần tác phẩm * nắm bắt thị hiếu của khách hàng * nắm bắt lấy cơ hội",
  },
  {
    word: "năm châu bốn biển",
    part_of_speech: "",
    meaning: "khắp mọi nơi trên thế giới: bôn ba khắp năm châu bốn biển",
    example: "bôn ba khắp năm châu bốn biển",
  },
  {
    word: "nằm bẹp",
    part_of_speech: "động từ",
    meaning:
      "nằm yên một chỗ, không dậy nổi, không hoạt động nổi: ốm phải nằm bẹp ở nhà * máy hỏng, nằm bẹp một xó",
    example: "ốm phải nằm bẹp ở nhà * máy hỏng, nằm bẹp một xó",
  },
  {
    word: "nằm khoèo",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nằm yên một chỗ, không làm gì được hoặc không muốn làm gì: ăn no rồi lại nằm khoèo",
    example: "ăn no rồi lại nằm khoèo",
  },
  {
    word: "nằm khểnh",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nằm ngửa với tư thế hết sức thoải mái, trông có vẻ thảnh thơi: lên giường nằm khểnh * nắng nôi thế này, cứ nằm khểnh ở nhà cho mát",
    example:
      "lên giường nằm khểnh * nắng nôi thế này, cứ nằm khểnh ở nhà cho mát",
  },
  {
    word: "nắm đấm",
    part_of_speech: "danh từ",
    meaning: "như quả đấm: giơ nắm đấm lên doạ",
    example: "giơ nắm đấm lên doạ",
  },
  {
    word: "nằm khàn",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nằm không cả ngày vì quá nhàn rỗi, không biết làm gì: không có việc nên nằm khàn ở nhà cả ngày",
    example: "không có việc nên nằm khàn ở nhà cả ngày",
  },
  {
    word: "năm học",
    part_of_speech: "danh từ",
    meaning:
      "thời gian học ở trường, từ ngày khai giảng cho đến lúc nghỉ hè, đủ để học xong một lớp: kết thúc một năm học * khai giảng năm học mới",
    example: "kết thúc một năm học * khai giảng năm học mới",
  },
  {
    word: "năm kia",
    part_of_speech: "danh từ",
    meaning: "năm liền trước năm ngoái: Tết năm kia * ra trường từ năm kia",
    example: "Tết năm kia * ra trường từ năm kia",
  },
  {
    word: "nằm mê",
    part_of_speech: "động từ",
    meaning: "như chiêm bao: nằm mê được đi du lịch",
    example: "nằm mê được đi du lịch",
  },
  {
    word: "năm lần bảy lượt",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) (làm việc gì) rất nhiều lần, hết lần này đến lần khác: năm lần bảy lượt mới chịu nhận lời",
    example: "năm lần bảy lượt mới chịu nhận lời",
  },
  {
    word: "nằm mơ",
    part_of_speech: "động từ",
    meaning: "như chiêm bao: nằm mơ bắt được vàng",
    example: "nằm mơ bắt được vàng",
  },
  {
    word: "năm thì mười hoạ",
    part_of_speech: "",
    meaning:
      "rất hiếm khi, thỉnh thoảng lắm (mới có hoặc xảy ra): năm thì mười hoạ mới gặp",
    example: "năm thì mười hoạ mới gặp",
  },
  {
    word: "năm tao bảy tiết",
    part_of_speech: "",
    meaning:
      '(văn chương) như năm lần bảy lượt: "Nói ra chúng bạn cười chê, Năm tao bảy tiết đưa về làm dâu." (ca dao)',
    example:
      'Nói ra chúng bạn cười chê, Năm tao bảy tiết đưa về làm dâu." (ca dao)',
  },
  {
    word: "năm ngoái",
    part_of_speech: "danh từ",
    meaning: "năm vừa qua, liền trước năm hiện tại: chuyện xảy ra từ năm ngoái",
    example: "chuyện xảy ra từ năm ngoái",
  },
  {
    word: "năm tháng",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian dài, không xác định, thường là trong quá khứ: trải qua nhiều năm tháng gian khổ * nỗi đau đã chìm vào năm tháng",
    example:
      "trải qua nhiều năm tháng gian khổ * nỗi đau đã chìm vào năm tháng",
  },
  {
    word: "nằm xuống",
    part_of_speech: "động từ",
    meaning:
      "chết (lối nói trang trọng hoặc kiêng kị): anh ấy đã nằm xuống ngoài chiến trường",
    example: "anh ấy đã nằm xuống ngoài chiến trường",
  },
  {
    word: "nắn",
    part_of_speech: "động từ",
    meaning:
      "bóp nhẹ vào để biết bên trong ra sao: nắn túi * nắn chân nắn tay * nắn quả thị xem mềm hay cứng",
    example: "nắn túi * nắn chân nắn tay * nắn quả thị xem mềm hay cứng",
  },
  {
    word: "nắn",
    part_of_speech: "động từ",
    meaning:
      "uốn lại, sửa lại theo một yêu cầu nào đó: nắn vành xe * nắn từng nét chữ",
    example: "nắn vành xe * nắn từng nét chữ",
  },
  {
    word: "nằm vạ",
    part_of_speech: "động từ",
    meaning:
      "nằm ì ra để bắt đền, để đòi cho kì được: nài xin không được thì lăn ra đất nằm vạ",
    example: "nài xin không được thì lăn ra đất nằm vạ",
  },
  {
    word: "nặn",
    part_of_speech: "động từ",
    meaning:
      "tạo nên vật có hình khối bằng cách dùng lực bàn tay làm biến đổi hình dạng của vật liệu mềm dẻo: nặn tò he * nặn tượng",
    example: "nặn tò he * nặn tượng",
  },
  {
    word: "nặn",
    part_of_speech: "động từ",
    meaning:
      "bóp mạnh, làm cho cái ở trong tòi ra: nặn trứng cá * nặn nhọt * nặn sữa",
    example: "nặn trứng cá * nặn nhọt * nặn sữa",
  },
  {
    word: "nặn",
    part_of_speech: "động từ",
    meaning:
      "bịa ra, tạo ra cái không có cơ sở, cái giả tạo, nhằm mục đích nào đó: nặn chuyện * nặn điều nói xấu",
    example: "nặn chuyện * nặn điều nói xấu",
  },
  {
    word: "năn",
    part_of_speech: "danh từ",
    meaning: "cỏ năn (nói tắt): năn lác mọc đầy đồng",
    example: "năn lác mọc đầy đồng",
  },
  {
    word: "năn nỉ",
    part_of_speech: "động từ",
    meaning:
      "nói khẩn khoản để nài xin: năn nỉ mãi mới nhận lời * nói bằng giọng năn nỉ",
    example: "năn nỉ mãi mới nhận lời * nói bằng giọng năn nỉ",
  },
  {
    word: "nằm vùng",
    part_of_speech: "động từ",
    meaning:
      "ở lâu dài trong vùng của đối phương để bí mật hoạt động chống phá: gián điệp nằm vùng",
    example: "gián điệp nằm vùng",
  },
  {
    word: "nắn gân",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tác động bằng hành động, lời nói nhằm thăm dò xem sức phản ứng đến đâu: bắn một phát để nắn gân",
    example: "bắn một phát để nắn gân",
  },
  {
    word: "nằn nì",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) như năn nỉ: nằn nì xin đi theo * nằn nì mãi mới đồng ý",
    example: "nằn nì xin đi theo * nằn nì mãi mới đồng ý",
  },
  {
    word: "năng",
    part_of_speech: "phụ từ",
    meaning:
      "hay, thường: năng đến thăm nhau * dao năng liếc thì sắc, người năng chào thì quen (tng)",
    example:
      "năng đến thăm nhau * dao năng liếc thì sắc, người năng chào thì quen (tng)",
  },
  {
    word: "nắn nót",
    part_of_speech: "động từ",
    meaning:
      "làm cẩn thận từng li từng tí cho đẹp, cho chỉnh: chữ viết nắn nót * nắn nót chuốt từng sợi nan",
    example: "chữ viết nắn nót * nắn nót chuốt từng sợi nan",
  },
  {
    word: "nặng",
    part_of_speech: "tính từ",
    meaning:
      "có trọng lượng bao nhiêu đó: cân xem nặng bao nhiêu * đứa bé nặng 10kg",
    example: "cân xem nặng bao nhiêu * đứa bé nặng 10kg",
  },
  {
    word: "nặng",
    part_of_speech: "tính từ",
    meaning:
      "có trọng lượng lớn hơn mức bình thường hoặc lớn hơn so với trọng lượng của vật khác: hòn đá nặng * bao gạo nặng quá, không vác được",
    example: "hòn đá nặng * bao gạo nặng quá, không vác được",
  },
  {
    word: "nặng",
    part_of_speech: "tính từ",
    meaning: "(chất) có tỉ trọng lớn: kim loại nặng",
    example: "kim loại nặng",
  },
  {
    word: "nặng",
    part_of_speech: "tính từ",
    meaning:
      "ở mức độ cao, có tác dụng làm cho phải chịu đựng nhiều, đòi hỏi nhiều sự vất vả hoặc có thể dẫn đến hậu quả tai hại, nghiêm trọng: phạt cho thật nặng * sưu cao thuế nặng * máy bị hỏng nặng",
    example: "phạt cho thật nặng * sưu cao thuế nặng * máy bị hỏng nặng",
  },
  {
    word: "nặng",
    part_of_speech: "tính từ",
    meaning:
      "(đất) có nhiều sét, ít tơi xốp, cày cuốc nặng nhọc, vất vả: đất nặng",
    example: "đất nặng",
  },
  {
    word: "nặng",
    part_of_speech: "tính từ",
    meaning:
      "(ở một bộ phận nào đó của cơ thể) có cảm giác khó chịu, không thoải mái, tựa như có cái gì đó đè lên: mi mắt nặng trĩu vì buồn ngủ * ăn đêm nên bị nặng bụng * nỗi lo đè nặng tâm trí",
    example:
      "mi mắt nặng trĩu vì buồn ngủ * ăn đêm nên bị nặng bụng * nỗi lo đè nặng tâm trí",
  },
  {
    word: "nặng",
    part_of_speech: "tính từ",
    meaning:
      "(âm thanh hoặc mùi vị) có tác động không êm dịu đến giác quan, gây cảm giác khó chịu: giọng nói nghe rất nặng * rượu nặng * mùi mồ hôi hơi nặng",
    example: "giọng nói nghe rất nặng * rượu nặng * mùi mồ hôi hơi nặng",
  },
  {
    word: "nặng",
    part_of_speech: "tính từ",
    meaning:
      "có tình cảm gắn bó, không dễ dứt bỏ được: ơn nặng như núi * nặng lòng với nhau",
    example: "ơn nặng như núi * nặng lòng với nhau",
  },
  {
    word: "nặng",
    part_of_speech: "tính từ",
    meaning:
      "thiên về một phía nào đó, trong khi ít chú ý đến những phía khác: sống nặng về tình cảm * nặng về lí, nhẹ về tình",
    example: "sống nặng về tình cảm * nặng về lí, nhẹ về tình",
  },
  {
    word: "nặn óc",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) cố suy nghĩ rất lâu, rất vất vả: nặn óc tìm mưu kế * nhà văn đã nặn óc viết nên tác phẩm",
    example: "nặn óc tìm mưu kế * nhà văn đã nặn óc viết nên tác phẩm",
  },
  {
    word: "nặng è",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) nặng đến mức phải đưa hết sức lực ra mà làm: vác mấy bao hàng nặng è",
    example: "vác mấy bao hàng nặng è",
  },
  {
    word: "nặng ký",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có sức mạnh, có ưu thế đáng kể, đáng phải lưu ý: đối thủ nặng kí * ứng cử viên nặng kí của chức vô địch",
    example: "đối thủ nặng kí * ứng cử viên nặng kí của chức vô địch",
  },
  {
    word: "năng khiếu",
    part_of_speech: "danh từ",
    meaning:
      "tổng thể nói chung những phẩm chất sẵn có của con người giúp người đó có thể hoàn thành tốt một loại hoạt động ngay từ khi chưa được học tập và rèn luyện trong hoạt động đó: có năng khiếu hội hoạ",
    example: "có năng khiếu hội hoạ",
  },
  {
    word: "nắng",
    part_of_speech: "danh từ",
    meaning:
      'ánh sáng trực tiếp từ mặt trời chiếu xuống: trời loé nắng * "Tiếng bà ru cháu xế trưa, Chang chang nắng hạ võng đưa rầu rầu." (HCầm; 1)',
    example:
      'trời loé nắng * "Tiếng bà ru cháu xế trưa, Chang chang nắng hạ võng đưa rầu rầu." (HCầm; 1)',
  },
  {
    word: "năng động",
    part_of_speech: "tính từ",
    meaning:
      "luôn có những hoạt động tích cực để tác động biến đổi thế giới xung quanh nhằm thực hiện tốt mục đích đã định: năng động trong kinh doanh * tư duy năng động",
    example: "năng động trong kinh doanh * tư duy năng động",
  },
  {
    word: "năng động",
    part_of_speech: "tính từ",
    meaning: "có tính ưa hoạt động: thằng bé rất năng động",
    example: "thằng bé rất năng động",
  },
  {
    word: "nặng lãi",
    part_of_speech: "",
    meaning: "(cho vay) lãi suất rất cao: cho vay nặng lãi * món nợ nặng lãi",
    example: "cho vay nặng lãi * món nợ nặng lãi",
  },
  {
    word: "nặng gánh",
    part_of_speech: "tính từ",
    meaning:
      '(cũ) có tình cảm sâu đậm, không dễ dứt bỏ được: "Não người cữ gió, tuần mưa, Một ngày nặng gánh tương tư một ngày." (TKiều)',
    example:
      'Não người cữ gió, tuần mưa, Một ngày nặng gánh tương tư một ngày." (TKiều)',
  },
  {
    word: "nặng gánh",
    part_of_speech: "tính từ",
    meaning:
      "có trách nhiệm lớn, phải gánh vác công việc khó khăn, nặng nề: nặng gánh gia đình",
    example: "nặng gánh gia đình",
  },
  {
    word: "năng lực",
    part_of_speech: "danh từ",
    meaning:
      "khả năng, điều kiện chủ quan hoặc tự nhiên sẵn có để thực hiện một hoạt động nào đó: con người có năng lực tư duy * chứng minh năng lực tài chính",
    example: "con người có năng lực tư duy * chứng minh năng lực tài chính",
  },
  {
    word: "năng lực",
    part_of_speech: "danh từ",
    meaning:
      "phẩm chất tâm sinh lí và trình độ chuyên môn tạo cho con người khả năng hoàn thành một loại hoạt động nào đó với chất lượng cao: năng lực lãnh đạo * nâng cao năng lực chuyên môn",
    example: "năng lực lãnh đạo * nâng cao năng lực chuyên môn",
  },
  {
    word: "nắng lửa",
    part_of_speech: "danh từ",
    meaning: "nắng dữ dội như đổ lửa xuống: chang chang nắng lửa",
    example: "chang chang nắng lửa",
  },
  {
    word: "nặng lòng",
    part_of_speech: "tính từ",
    meaning:
      "có tình cảm hết sức sâu sắc và luôn luôn để tâm đến: nặng lòng yêu mến * hai người đã nặng lòng với nhau",
    example: "nặng lòng yêu mến * hai người đã nặng lòng với nhau",
  },
  {
    word: "nặng mùi",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có mùi khắm bốc lên mạnh: lọ mắm đã nặng mùi * nặng mùi triết lí (b)",
    example: "lọ mắm đã nặng mùi * nặng mùi triết lí (b)",
  },
  {
    word: "năng lượng",
    part_of_speech: "danh từ",
    meaning:
      "đại lượng vật lí đặc trưng cho khả năng sinh ra công của một vật: năng lượng nguyên tử * xe chạy bằng năng lượng mặt trời",
    example: "năng lượng nguyên tử * xe chạy bằng năng lượng mặt trời",
  },
  {
    word: "nằng nặng",
    part_of_speech: "tính từ",
    meaning: "hơi nặng: mí mắt nằng nặng",
    example: "mí mắt nằng nặng",
  },
  {
    word: "nằng nặc",
    part_of_speech: "phụ từ",
    meaning:
      "(đòi, xin) khăng khăng và dai dẳng, cho kì được: nằng nặc đòi về * nằng nặc xin cho bằng được",
    example: "nằng nặc đòi về * nằng nặc xin cho bằng được",
  },
  {
    word: "nặng kí",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có sức mạnh, có ưu thế đáng kể, đáng phải lưu ý: đối thủ nặng kí * ứng cử viên nặng kí của chức vô địch",
    example: "đối thủ nặng kí * ứng cử viên nặng kí của chức vô địch",
  },
  {
    word: "nặng lời",
    part_of_speech: "tính từ",
    meaning:
      '(cũ, văn chương) có những lời hứa hẹn gắn bó sâu nặng: nặng lời thề thốt * "Cùng nhau đã trót nặng lời, Dẫu thay mái tóc, dám dời lòng tơ!" (TKiều)',
    example:
      'nặng lời thề thốt * "Cùng nhau đã trót nặng lời, Dẫu thay mái tóc, dám dời lòng tơ!" (TKiều)',
  },
  {
    word: "nặng lời",
    part_of_speech: "tính từ",
    meaning:
      "có những lời lẽ gay gắt quá đáng đối với người có quan hệ thân thiết, gần gũi: phê bình hơi nặng lời",
    example: "phê bình hơi nặng lời",
  },
  {
    word: "nắng mưa",
    part_of_speech: "danh từ",
    meaning:
      '(văn chương) những vất vả gian truân trong cuộc sống: bao quản nắng mưa * "Những là nấn ná đợi tin, Nắng mưa biết đã mấy phen đổi dời?" (TKiều)',
    example:
      'bao quản nắng mưa * "Những là nấn ná đợi tin, Nắng mưa biết đã mấy phen đổi dời?" (TKiều)',
  },
  {
    word: "nắng nóng",
    part_of_speech: "tính từ",
    meaning:
      "(thời tiết) nắng và nóng với nhiệt độ cao hơn hẳn so với mức trung bình: đợt nắng nóng kéo dài",
    example: "đợt nắng nóng kéo dài",
  },
  {
    word: "năng nổ",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra ham hoạt động, hăng hái và chủ động trong các công việc chung: một phóng viên năng nổ * năng nổ trong công việc",
    example: "một phóng viên năng nổ * năng nổ trong công việc",
  },
  {
    word: "nắng nôi",
    part_of_speech: "danh từ",
    meaning:
      "nắng (về mặt gây nóng bức, vất vả; nói khái quát): nắng nôi thế này thì đi đâu? * trời nắng nôi",
    example: "nắng nôi thế này thì đi đâu? * trời nắng nôi",
  },
  {
    word: "năng suất",
    part_of_speech: "danh từ",
    meaning:
      "hiệu quả của lao động trong quá trình sản xuất, làm việc, được đo bằng số lượng sản phẩm hay khối lượng công việc làm ra được trong một đơn vị thời gian nhất định: trả công theo năng suất lao động * tăng năng suất hoạt động của máy",
    example:
      "trả công theo năng suất lao động * tăng năng suất hoạt động của máy",
  },
  {
    word: "năng suất",
    part_of_speech: "danh từ",
    meaning:
      "sản lượng đạt được trên một đơn vị diện tích gieo trồng, trong một đơn vị thời gian nhất định: giống mía cho năng suất cao",
    example: "giống mía cho năng suất cao",
  },
  {
    word: "nặng nề",
    part_of_speech: "tính từ",
    meaning:
      "nặng, khó mang vác, vận chuyển (nói khái quát): thân hình to béo nặng nề",
    example: "thân hình to béo nặng nề",
  },
  {
    word: "nặng nề",
    part_of_speech: "tính từ",
    meaning:
      "khó gánh vác, quá sức chịu đựng (nói khái quát): nhiệm vụ nặng nề * thất bại nặng nề * cơn bão gây thiệt hại nặng nề",
    example:
      "nhiệm vụ nặng nề * thất bại nặng nề * cơn bão gây thiệt hại nặng nề",
  },
  {
    word: "nặng nề",
    part_of_speech: "tính từ",
    meaning:
      "(vận động) có vẻ khó khăn, chậm chạp, do phải khắc phục một sức ì tương đối lớn: bước từng bước nặng nề * chiếc xe nặng nề leo lên dốc",
    example: "bước từng bước nặng nề * chiếc xe nặng nề leo lên dốc",
  },
  {
    word: "nặng nề",
    part_of_speech: "tính từ",
    meaning:
      "có tác động gây cảm giác khó chịu, căng thẳng về tinh thần: tiếng thở dài nặng nề * không khí gia đình rất nặng nề",
    example: "tiếng thở dài nặng nề * không khí gia đình rất nặng nề",
  },
  {
    word: "nắng nực",
    part_of_speech: "tính từ",
    meaning: "nắng nóng đến mức gây ngột ngạt, khó chịu: trưa hè nắng nực",
    example: "trưa hè nắng nực",
  },
  {
    word: "nặng nhọc",
    part_of_speech: "tính từ",
    meaning:
      "nặng nề và vất vả quá sức: công việc nặng nhọc * bước từng bước nặng nhọc",
    example: "công việc nặng nhọc * bước từng bước nặng nhọc",
  },
  {
    word: "nặng nợ",
    part_of_speech: "tính từ",
    meaning:
      "có mối quan hệ ràng buộc, dù cảm thấy phiền toái nhưng không thể dứt bỏ được: nặng nợ với đời * nặng nợ văn chương (thường hàm ý vui đùa)",
    example: "nặng nợ với đời * nặng nợ văn chương (thường hàm ý vui đùa)",
  },
  {
    word: "nặng tai",
    part_of_speech: "tính từ",
    meaning:
      "(tai) hơi điếc, nghe không rõ: ông lão nặng tai, phải nói to mới nghe được",
    example: "ông lão nặng tai, phải nói to mới nghe được",
  },
  {
    word: "nắng ráo",
    part_of_speech: "tính từ",
    meaning:
      "(sau những ngày mưa) có nắng và khô ráo (nói khái quát): trời nắng ráo",
    example: "trời nắng ráo",
  },
  {
    word: "nặng trĩu",
    part_of_speech: "tính từ",
    meaning:
      "(vật mang) nặng đến mức như níu, kéo hẳn xuống: cành cây nặng trĩu những quả * bước chân nặng trĩu * lòng nặng trĩu lo âu (b)",
    example:
      "cành cây nặng trĩu những quả * bước chân nặng trĩu * lòng nặng trĩu lo âu (b)",
  },
  {
    word: "nặng tay",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) cảm thấy nặng hơn khi nâng lên, khi cầm đến (hàm ý nhiều hơn, nặng hơn): chọn quả cam cầm nặng tay * món quà biếu nặng tay",
    example: "chọn quả cam cầm nặng tay * món quà biếu nặng tay",
  },
  {
    word: "nặng tay",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) không có sự nương nhẹ trong đối xử, trong sự trừng phạt: trừng phạt nặng tay",
    example: "trừng phạt nặng tay",
  },
  {
    word: "nặng trịch",
    part_of_speech: "tính từ",
    meaning:
      "nặng đến mức như không sao nhấc lên nổi: cái giỏ nặng trịch * đầu nặng trịch * buông ngay một câu nặng trịch",
    example:
      "cái giỏ nặng trịch * đầu nặng trịch * buông ngay một câu nặng trịch",
  },
  {
    word: "nặng trình trịch",
    part_of_speech: "tính từ",
    meaning:
      "như nặng trịch (nhưng ý mức độ nhiều hơn): cối đá nặng trình trịch",
    example: "cối đá nặng trình trịch",
  },
  {
    word: "nắp",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận dùng để đậy của một vật: đậy nắp hầm * cái nắp ấm * nắp bể * nắp hòm",
    example: "đậy nắp hầm * cái nắp ấm * nắp bể * nắp hòm",
  },
  {
    word: "nậm",
    part_of_speech: "danh từ",
    meaning:
      "bình nhỏ có bầu tròn, cổ dài, bằng sành hoặc sứ, dùng để đựng rượu: nậm rượu",
    example: "nậm rượu",
  },
  {
    word: "nấc",
    part_of_speech: "danh từ",
    meaning:
      "khoảng cách, thường chia đều, được đánh dấu bằng những khấc hoặc những hình thức nào đó: nấc thang * kéo khoá cò súng về nấc an toàn",
    example: "nấc thang * kéo khoá cò súng về nấc an toàn",
  },
  {
    word: "nấc",
    part_of_speech: "danh từ",
    meaning:
      "bước, giai đoạn trong một tiến trình: công việc phải qua mấy mươi nấc",
    example: "công việc phải qua mấy mươi nấc",
  },
  {
    word: "nấc",
    part_of_speech: "động từ",
    meaning:
      "bật mạnh hơi từ trong cổ ra thành từng tiếng cách quãng, do cơ hoành co bóp mạnh: khóc nấc lên * bị nấc",
    example: "khóc nấc lên * bị nấc",
  },
  {
    word: "nặng tình",
    part_of_speech: "tính từ",
    meaning:
      "có tình cảm sâu nặng, khó dứt bỏ: hai người đã nặng tình với nhau",
    example: "hai người đã nặng tình với nhau",
  },
  {
    word: "nấm",
    part_of_speech: "danh từ",
    meaning:
      "thực vật bậc thấp không có diệp lục, sống trên chất hữu cơ mục nát hoặc kí sinh trên các sinh vật, một số loài ăn được: vào rừng hái nấm * nấm độc * nhà cửa mọc lên như nấm",
    example: "vào rừng hái nấm * nấm độc * nhà cửa mọc lên như nấm",
  },
  {
    word: "nấm",
    part_of_speech: "danh từ",
    meaning:
      'mô đất đắp thành hình tròn, nhỏ, thấp, trông giống như cái mũ nấm: nấm mồ * "Sè sè nấm đất bên đường, Dầu dầu ngọn cỏ nửa vàng nửa xanh." (TKiều)',
    example:
      'nấm mồ * "Sè sè nấm đất bên đường, Dầu dầu ngọn cỏ nửa vàng nửa xanh." (TKiều)',
  },
  {
    word: "nầm",
    part_of_speech: "danh từ",
    meaning: "phần thịt ở giữa bụng lợn, trâu, bò, v.v.: miếng nầm * nầm dê",
    example: "miếng nầm * nầm dê",
  },
  {
    word: "nấm sò",
    part_of_speech: "danh từ",
    meaning: "nấm mỡ hình dáng giống như cái vỏ sò: xào nấm sò với thịt bò",
    example: "xào nấm sò với thịt bò",
  },
  {
    word: "nẫn",
    part_of_speech: "tính từ",
    meaning: "béo lẳn, tròn trịa: béo nẫn * người nẫn lên những thịt",
    example: "béo nẫn * người nẫn lên những thịt",
  },
  {
    word: "nấn ná",
    part_of_speech: "động từ",
    meaning:
      "cố kéo dài thêm thời gian, như có ý chờ đợi cái gì đó, tuy biết rằng lẽ ra phải rời đi ngay hoặc phải làm ngay việc gì: nấn ná để đợi tin * có việc phải đi gấp, không thể nấn ná được",
    example: "nấn ná để đợi tin * có việc phải đi gấp, không thể nấn ná được",
  },
  {
    word: "nâng",
    part_of_speech: "động từ",
    meaning:
      "đưa lên cao (thường bằng tay, một cách nhẹ nhàng): nâng chén rượu * nâng lên hạ xuống * nâng như nâng trứng, hứng như hứng hoa (tng)",
    example:
      "nâng chén rượu * nâng lên hạ xuống * nâng như nâng trứng, hứng như hứng hoa (tng)",
  },
  {
    word: "nâng",
    part_of_speech: "động từ",
    meaning:
      "đưa lên cao hoặc lên mức cao hơn: nâng nền nhà * nâng giá sản phẩm * nâng cao trình độ dân trí",
    example: "nâng nền nhà * nâng giá sản phẩm * nâng cao trình độ dân trí",
  },
  {
    word: "nâng",
    part_of_speech: "động từ",
    meaning: "đỡ dậy: nâng dậy * chị ngã em nâng (tng)",
    example: "nâng dậy * chị ngã em nâng (tng)",
  },
  {
    word: "nẫng",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) lấy mất đi một cách nhanh gọn, nhẹ nhàng: bị kẻ gian nẫng mất cái túi",
    example: "bị kẻ gian nẫng mất cái túi",
  },
  {
    word: "nần nẫn",
    part_of_speech: "tính từ",
    meaning: "như nẫn (nhưng ý mức độ nhiều hơn): tay chân nần nẫn",
    example: "tay chân nần nẫn",
  },
  {
    word: "nâng cấp",
    part_of_speech: "động từ",
    meaning:
      "cải tạo, sửa chữa hoặc trang bị thêm để nâng cao chất lượng: nâng cấp máy tính cũ * nâng cấp mặt đường",
    example: "nâng cấp máy tính cũ * nâng cấp mặt đường",
  },
  {
    word: "nâng đỡ",
    part_of_speech: "động từ",
    meaning: "giúp đỡ, tạo điều kiện cho phát triển: được cấp trên nâng đỡ",
    example: "được cấp trên nâng đỡ",
  },
  {
    word: "nâng giá",
    part_of_speech: "động từ",
    meaning:
      "đưa giá bán lên mức cao hơn: nâng giá sản phẩm * tự ý nâng giá mặt hàng",
    example: "nâng giá sản phẩm * tự ý nâng giá mặt hàng",
  },
  {
    word: "nâng giá",
    part_of_speech: "động từ",
    meaning:
      "(nhà nước) nâng tỉ giá đồng tiền so với các ngoại tệ và nâng hàm lượng vàng của đồng tiền: nâng giá đồng dollar",
    example: "nâng giá đồng dollar",
  },
  {
    word: "nâng cốc",
    part_of_speech: "động từ",
    meaning:
      "cầm cốc rượu, bia nâng lên (để chạm cốc, uống chúc mừng nhau): nâng cốc chúc mừng",
    example: "nâng cốc chúc mừng",
  },
  {
    word: "nấp",
    part_of_speech: "động từ",
    meaning:
      "giấu mình vào nơi có vật che khuất để trốn, để được che chở: nấp sau lưng mẹ * nấp dưới hầm",
    example: "nấp sau lưng mẹ * nấp dưới hầm",
  },
  {
    word: "nâng giấc",
    part_of_speech: "động từ",
    meaning:
      '(văn chương) chăm nom, săn sóc từng li từng tí: nâng giấc mẹ già * "Tôi ở cùng mẹ cùng cha, Mẹ cha nâng giấc như hoa trên cành." (ca dao)',
    example:
      'nâng giấc mẹ già * "Tôi ở cùng mẹ cùng cha, Mẹ cha nâng giấc như hoa trên cành." (ca dao)',
  },
  {
    word: "nấp bóng",
    part_of_speech: "động từ",
    meaning:
      "dựa vào uy thế hay vào sự che chở của ai hay cái gì đó: núp bóng từ bi * núp bóng quan lớn",
    example: "núp bóng từ bi * núp bóng quan lớn",
  },
  {
    word: "nấu",
    part_of_speech: "động từ",
    meaning:
      "đun trong nước cho sôi hoặc chín thành thức ăn, thức uống: nấu cơm * nấu chè * cá nấu dưa",
    example: "nấu cơm * nấu chè * cá nấu dưa",
  },
  {
    word: "nấu",
    part_of_speech: "động từ",
    meaning: "chế biến bằng cách đun: nấu rượu * nấu cao",
    example: "nấu rượu * nấu cao",
  },
  {
    word: "nâng niu",
    part_of_speech: "động từ",
    meaning:
      "cầm, giữ trên tay với tình cảm trân trọng, yêu quý: tay nâng niu bông hoa",
    example: "tay nâng niu bông hoa",
  },
  {
    word: "nâng niu",
    part_of_speech: "động từ",
    meaning:
      "chăm chút, giữ gìn cẩn thận với tình cảm yêu quý đặc biệt: nâng niu từng kỉ vật * được nâng niu từ tấm bé",
    example: "nâng niu từng kỉ vật * được nâng niu từ tấm bé",
  },
  {
    word: "nâu",
    part_of_speech: "danh từ",
    meaning:
      "cây leo ở rừng, rễ phồng to thành củ, sần sùi, chứa nhiều chất chát, thường dùng để nhuộm vải: củ nâu",
    example: "củ nâu",
  },
  {
    word: "nâu",
    part_of_speech: "tính từ",
    meaning:
      "có màu trung gian giữa đen và đỏ, tựa như màu nước củ nâu: áo nâu * mắt nâu * tóc nâu * nước da nâu",
    example: "áo nâu * mắt nâu * tóc nâu * nước da nâu",
  },
  {
    word: "nấu ăn",
    part_of_speech: "động từ",
    meaning: "nấu nướng cho bữa ăn: tự nấu ăn lấy * sách dạy nấu ăn",
    example: "tự nấu ăn lấy * sách dạy nấu ăn",
  },
  {
    word: "nẫu",
    part_of_speech: "tính từ",
    meaning:
      "mềm nhũn đến mức như sắp rữa ra: chuối chín nẫu * rau luộc lâu nên nẫu * ruột gan như nẫu ra",
    example: "chuối chín nẫu * rau luộc lâu nên nẫu * ruột gan như nẫu ra",
  },
  {
    word: "nâu non",
    part_of_speech: "tính từ",
    meaning: "nâu nhạt và tươi: chiếc áo nhuộm màu nâu non",
    example: "chiếc áo nhuộm màu nâu non",
  },
  {
    word: "nấu bếp",
    part_of_speech: "động từ",
    meaning: "nấu ăn (coi như một nghề): người nấu bếp",
    example: "người nấu bếp",
  },
  {
    word: "nậu",
    part_of_speech: "danh từ",
    meaning:
      '(phương ngữ) đầu nậu (nói tắt): dân nậu gỗ * "Mất chồng như nậu mất trâu (...)" (ca dao)',
    example: 'dân nậu gỗ * "Mất chồng như nậu mất trâu (...)" (ca dao)',
  },
  {
    word: "nẫu ruột",
    part_of_speech: "",
    meaning:
      "buồn phiền, xót xa trong lòng: buồn nẫu ruột * thương con đến nẫu ruột",
    example: "buồn nẫu ruột * thương con đến nẫu ruột",
  },
  {
    word: "nấu nướng",
    part_of_speech: "động từ",
    meaning:
      "nấu thức ăn (nói khái quát): có tài nấu nướng * lụi hụi nấu nướng trong bếp",
    example: "có tài nấu nướng * lụi hụi nấu nướng trong bếp",
  },
  {
    word: "nấu sử sôi kinh",
    part_of_speech: "",
    meaning:
      '(cũ, văn chương) khổ công học tập để đi thi: "Sĩ thì nấu sử sôi kinh, Làm nên khoa bảng công danh để truyền." (ca dao)',
    example:
      'Sĩ thì nấu sử sôi kinh, Làm nên khoa bảng công danh để truyền." (ca dao)',
  },
  {
    word: "nậu vựa",
    part_of_speech: "danh từ",
    meaning:
      "tư thương lợi dụng cơ chế tự phát của thị trường đứng ra thu mua hàng nông thuỷ sản ở những vùng nông thôn có trữ lượng lớn, sau đó bán lại thu lãi cao: nậu vựa ép giá nông sản của nông dân",
    example: "nậu vựa ép giá nông sản của nông dân",
  },
  {
    word: "nấy",
    part_of_speech: "đại từ",
    meaning:
      "từ dùng để chỉ chính cái vừa nói đến trước đó, chứ không phải cái nào khác; người ấy, cái ấy: ai về nhà nấy * ước gì được nấy * mạnh ai nấy chạy",
    example: "ai về nhà nấy * ước gì được nấy * mạnh ai nấy chạy",
  },
  {
    word: "nấy",
    part_of_speech: "đại từ",
    meaning:
      "từ dùng để chỉ tính tương ứng tất yếu với cái vừa nói đến trước đó: mùa nào thức nấy * tiền nào của nấy",
    example: "mùa nào thức nấy * tiền nào của nấy",
  },
  {
    word: "nấy",
    part_of_speech: "đại từ",
    meaning:
      "từ dùng để chỉ phạm vi toàn bộ của những cái được nói đến, không có ngoại lệ: mặt người nào người nấy tái mét * nhà nào nhà nấy đóng cửa im ỉm",
    example: "mặt người nào người nấy tái mét * nhà nào nhà nấy đóng cửa im ỉm",
  },
  {
    word: "nâu sồng",
    part_of_speech: "",
    meaning:
      "có màu được nhuộm từ củ nâu và lá sồng; dùng để chỉ quần áo của nhà chùa hay của người dân quê: bộ quần áo nâu sồng",
    example: "bộ quần áo nâu sồng",
  },
  {
    word: "nây",
    part_of_speech: "danh từ",
    meaning:
      "thịt mỡ bèo nhèo ở bụng lợn: nhiều tiền ăn thịt, ít tiền ăn nây (tng)",
    example: "nhiều tiền ăn thịt, ít tiền ăn nây (tng)",
  },
  {
    word: "nây",
    part_of_speech: "tính từ",
    meaning: "béo hoặc mập tròn, đầy đặn: quả mít tròn nây",
    example: "quả mít tròn nây",
  },
  {
    word: "nẩy",
    part_of_speech: "động từ",
    meaning:
      "bật thẳng lên cao khỏi mặt nền một cách đột ngột, nhanh, mạnh, rồi lại rơi xuống ngay tức khắc: giật nẩy người * quả bóng nẩy trên mặt đất * đường xóc, xe nẩy tưng tưng",
    example:
      "giật nẩy người * quả bóng nẩy trên mặt đất * đường xóc, xe nẩy tưng tưng",
  },
  {
    word: "né",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ bằng phên đan thưa, thường có nhét rơm, dùng đặt tằm khi đã chín để cho tằm làm kén: sẵn nong sẵn né (tng)",
    example: "sẵn nong sẵn né (tng)",
  },
  {
    word: "né",
    part_of_speech: "động từ",
    meaning:
      "nghiêng người hoặc nép về một bên để tránh: nghiêng mình né cái tát * né được cú đánh hiểm",
    example: "nghiêng mình né cái tát * né được cú đánh hiểm",
  },
  {
    word: "né",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) tránh đi để khỏi phải đương đầu: tạm né đi chỗ khác * tạo bằng chứng giả hòng né tội",
    example: "tạm né đi chỗ khác * tạo bằng chứng giả hòng né tội",
  },
  {
    word: "nè",
    part_of_speech: "",
    meaning: "(Phương ngữ) này: anh coi nè * đây nè",
    example: "anh coi nè * đây nè",
  },
  {
    word: "ne",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) xua cho dồn về một bên, một phía: ne bầy vịt vô một góc * ne gà vô chuồng",
    example: "ne bầy vịt vô một góc * ne gà vô chuồng",
  },
  {
    word: "nẻ",
    part_of_speech: "động từ",
    meaning:
      "(da người hoặc mặt đất) nứt ra thành đường, thành kẽ nhỏ trên bề mặt, do bị khô quá: mặt ruộng khô nẻ * da mặt bị nẻ",
    example: "mặt ruộng khô nẻ * da mặt bị nẻ",
  },
  {
    word: "nẻ",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) đánh mạnh, thường bằng vật nhỏ, dài: nẻ cho mấy phát",
    example: "nẻ cho mấy phát",
  },
  {
    word: "nem",
    part_of_speech: "danh từ",
    meaning:
      "món ăn làm bằng thịt lợn sống giã và bì lợn luộc thái nhỏ, bóp với thính.",
    example: "ăn bún với nem",
  },
  {
    word: "né tránh",
    part_of_speech: "động từ",
    meaning:
      "tránh khéo, không muốn phải đối mặt, đương đầu (nói khái quát): né tránh mọi người * cố tình né tránh trách nhiệm * trả lời né tránh",
    example:
      "né tránh mọi người * cố tình né tránh trách nhiệm * trả lời né tránh",
  },
  {
    word: "ném",
    part_of_speech: "động từ",
    meaning:
      "dùng sức của cánh tay làm cho vật đang cầm rời khỏi tay một cách đột ngột và di chuyển nhanh trong không gian đến một đích nhất định: ném bóng * ném tiền vào chiếu bạc * hòn đất ném đi, hòn chì ném lại (tng)",
    example:
      "ném bóng * ném tiền vào chiếu bạc * hòn đất ném đi, hòn chì ném lại (tng)",
  },
  {
    word: "ném",
    part_of_speech: "động từ",
    meaning:
      "để cho (ánh mắt, lời nói) phát ra nhanh và đột ngột, biểu thị một thái độ nhất định: ném ra một câu hỏi * ném cái nhìn trộm",
    example: "ném ra một câu hỏi * ném cái nhìn trộm",
  },
  {
    word: "nem nép",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả dáng vẻ sợ sệt như muốn cố thu nhỏ người lại: đi nem nép sau lưng",
    example: "đi nem nép sau lưng",
  },
  {
    word: "nén lòng",
    part_of_speech: "động từ",
    meaning:
      "nén tình cảm, cảm xúc lại, không để bộc lộ ra ngoài: nén lòng chờ đợi * tức giận nhưng cố nén lòng, không để bộc lộ ra",
    example:
      "nén lòng chờ đợi * tức giận nhưng cố nén lòng, không để bộc lộ ra",
  },
  {
    word: "nén",
    part_of_speech: "danh từ",
    meaning: "(Trang trọng) que, cây (hương): thắp mấy nén hương",
    example: "thắp mấy nén hương",
  },
  {
    word: "nén",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị đo khối lượng, bằng mười lạng ta, tức khoảng 375 gram: nén tơ * vàng nén * nén bạc đâm toạc tờ giấy (tng)",
    example: "nén tơ * vàng nén * nén bạc đâm toạc tờ giấy (tng)",
  },
  {
    word: "nén",
    part_of_speech: "động từ",
    meaning:
      "đè xuống, ép xuống hoặc làm cho chặt, cho nhỏ lại: nén bánh chưng * bình nén khí * nền đất chịu nén tốt * nén dữ liệu",
    example:
      "nén bánh chưng * bình nén khí * nền đất chịu nén tốt * nén dữ liệu",
  },
  {
    word: "nén",
    part_of_speech: "động từ",
    meaning: "dằn nặng cho chìm xuống trong nước muối: nén hành * cà nén",
    example: "nén hành * cà nén",
  },
  {
    word: "nén",
    part_of_speech: "động từ",
    meaning:
      "kìm giữ lại những tình cảm, cảm xúc đang trỗi lên mạnh mẽ trong lòng: nén tiếng thở dài * nén đau thương",
    example: "nén tiếng thở dài * nén đau thương",
  },
  {
    word: "nẻo",
    part_of_speech: "danh từ",
    meaning:
      "lối đi, đường đi về một phía nào đó: tìm khắp nẻo * chỉ nẻo đưa đường",
    example: "tìm khắp nẻo * chỉ nẻo đưa đường",
  },
  {
    word: "neo",
    part_of_speech: "danh từ",
    meaning:
      "vật nặng, thả chìm dưới nước cho cắm chặt ở đáy để giữ cho tàu, thuyền hoặc vật nổi nào đó ở vị trí nhất định, khỏi bị trôi: thả neo * tàu nhổ neo",
    example: "thả neo * tàu nhổ neo",
  },
  {
    word: "neo",
    part_of_speech: "động từ",
    meaning:
      "giữ cho ở yên tại vị trí nhất định trên mặt nước bằng neo: con tàu neo lại ở giữa sông",
    example: "con tàu neo lại ở giữa sông",
  },
  {
    word: "neo",
    part_of_speech: "tính từ",
    meaning:
      "(cảnh gia đình) có quá ít người có khả năng lao động (nên công việc làm ăn rất vất vả): nhà neo người",
    example: "nhà neo người",
  },
  {
    word: "néo",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ dùng để đập lúa, làm bằng hai đoạn tre hay gỗ nối với nhau bằng sợi dây thừng: cái néo tre * tra lúa vào néo",
    example: "cái néo tre * tra lúa vào néo",
  },
  {
    word: "néo",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ gồm một vòng dây bền, chắc, lồng vào một đoạn tre hoặc gỗ, dùng để buộc xoắn chặt các vật (thường là to, khó buộc bằng tay) vào với nhau: dây néo",
    example: "dây néo",
  },
  {
    word: "néo",
    part_of_speech: "động từ",
    meaning:
      "buộc chặt, chằng chặt, thường bằng cái néo: néo lúa lại để đập * già néo đứt dây (tng)",
    example: "néo lúa lại để đập * già néo đứt dây (tng)",
  },
  {
    word: "neon",
    part_of_speech: "danh từ",
    meaning:
      "khí trơ không màu và không mùi, dùng trong kĩ thuật ánh sáng: đèn neon",
    example: "đèn neon",
  },
  {
    word: "neo đơn",
    part_of_speech: "tính từ",
    meaning:
      "(cảnh gia đình) rất ít người và không có khả năng lao động, nên không biết trông cậy, nương tựa vào ai: giúp đỡ người già yếu, neo đơn",
    example: "giúp đỡ người già yếu, neo đơn",
  },
  {
    word: "nèo",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) cố nài cho được: nèo tiền mẹ * nèo mãi mới được đi",
    example: "nèo tiền mẹ * nèo mãi mới được đi",
  },
  {
    word: "neo bấn",
    part_of_speech: "tính từ",
    meaning: "neo đơn và túng bấn (nói khái quát): cảnh nhà neo bấn",
    example: "cảnh nhà neo bấn",
  },
  {
    word: "nép",
    part_of_speech: "động từ",
    meaning:
      "thu mình lại và áp sát vào người khác, vật khác để tránh hoặc để được che chở: nép sau lưng bạn * em bé nép đầu vào ngực mẹ",
    example: "nép sau lưng bạn * em bé nép đầu vào ngực mẹ",
  },
  {
    word: "nẹp",
    part_of_speech: "danh từ",
    meaning:
      "thanh tre, gỗ hoặc kim loại dài, mỏng được đính thêm vào, thường ở mép, để giữ cho chắc: nẹp thùng * nẹp liếp * chân gãy phải kẹp nẹp tre",
    example: "nẹp thùng * nẹp liếp * chân gãy phải kẹp nẹp tre",
  },
  {
    word: "nẹp",
    part_of_speech: "danh từ",
    meaning:
      "dải vải dài, may vào để giữ mép quần áo cho chắc hay để trang trí cho đẹp: áo có nẹp xanh",
    example: "áo có nẹp xanh",
  },
  {
    word: "nẹp",
    part_of_speech: "động từ",
    meaning:
      "làm cho được giữ chắc bằng cái nẹp: nẹp tờ báo tường * nẹp lại hàng rào * thùng đã được nẹp đai",
    example: "nẹp tờ báo tường * nẹp lại hàng rào * thùng đã được nẹp đai",
  },
  {
    word: "nẹt",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) quát nạt, răn đe: nẹt cho một trận",
    example: "nẹt cho một trận",
  },
  {
    word: "nét",
    part_of_speech: "danh từ",
    meaning:
      "đường vạch bằng bút, bằng phấn, v.v.: nét chữ khá đẹp * chữ viết thiếu nét * trên tường đầy những nét than nguệch ngoạc",
    example:
      "nét chữ khá đẹp * chữ viết thiếu nét * trên tường đầy những nét than nguệch ngoạc",
  },
  {
    word: "nét",
    part_of_speech: "danh từ",
    meaning:
      "đường tạo nên hình dáng riêng bên ngoài: nét mặt hài hoà * nét chạm trổ tinh vi * ngôi nhà vẫn giữ nguyên nét cổ kính",
    example:
      "nét mặt hài hoà * nét chạm trổ tinh vi * ngôi nhà vẫn giữ nguyên nét cổ kính",
  },
  {
    word: "nét",
    part_of_speech: "danh từ",
    meaning:
      "biểu hiện của tình cảm, cảm xúc, tính cách con người bằng những nét trên mặt: nghiêm nét mặt",
    example: "nghiêm nét mặt",
  },
  {
    word: "nét",
    part_of_speech: "danh từ",
    meaning:
      "điểm cơ bản tạo nên, khắc hoạ nên cái chung: nét nổi bật của tác phẩm * vài nét về tình hình thời sự trong nước tuần qua",
    example:
      "nét nổi bật của tác phẩm * vài nét về tình hình thời sự trong nước tuần qua",
  },
  {
    word: "nét",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có đường nét hay âm thanh rất rõ: ảnh mờ, không nét * ti vi xem rất nét",
    example: "ảnh mờ, không nét * ti vi xem rất nét",
  },
  {
    word: "nệ",
    part_of_speech: "động từ",
    meaning: "dựa theo một cách cứng nhắc, không linh hoạt: nệ theo lối cũ",
    example: "nệ theo lối cũ",
  },
  {
    word: "nệ cổ",
    part_of_speech: "động từ",
    meaning:
      "khư khư theo cái cũ, cái đã lỗi thời, không chịu đổi mới: một nhà nho nệ cổ",
    example: "một nhà nho nệ cổ",
  },
  {
    word: "nề",
    part_of_speech: "động từ",
    meaning: "(hiếm) phù: tay chân bị nề * mặt bị nề vì dị ứng",
    example: "tay chân bị nề * mặt bị nề vì dị ứng",
  },
  {
    word: "nề",
    part_of_speech: "động từ",
    meaning: "xoa, miết vữa cho nhẵn: nề tường * mặt sân nề vôi",
    example: "nề tường * mặt sân nề vôi",
  },
  {
    word: "nề",
    part_of_speech: "động từ",
    meaning:
      '(văn chương) quản, ngại: không nề gian khổ * "Yêu nhau vạn sự chẳng nề, Một trăm chỗ lệch cũng kê cho bằng." (ca dao)',
    example:
      'không nề gian khổ * "Yêu nhau vạn sự chẳng nề, Một trăm chỗ lệch cũng kê cho bằng." (ca dao)',
  },
  {
    word: "nể",
    part_of_speech: "động từ",
    meaning:
      "ngại làm trái ý, làm mất lòng, thường vì tôn trọng: nể tình nên chấp thuận * vuốt mặt không nể mũi (tng)",
    example: "nể tình nên chấp thuận * vuốt mặt không nể mũi (tng)",
  },
  {
    word: "nể",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) cảm phục, tôn trọng: tài năng của ông ấy, ai cũng phải nể * một con người đáng nể",
    example: "tài năng của ông ấy, ai cũng phải nể * một con người đáng nể",
  },
  {
    word: "nề hà",
    part_of_speech: "động từ",
    meaning: "như quản ngại: không nề hà khó nhọc",
    example: "không nề hà khó nhọc",
  },
  {
    word: "nể nang",
    part_of_speech: "động từ",
    meaning:
      "nể, không dám nói thẳng sự thật (nói khái quát): còn nể nang nên không dám nói",
    example: "còn nể nang nên không dám nói",
  },
  {
    word: "nể trọng",
    part_of_speech: "động từ",
    meaning: "nể và kính trọng: tài năng của ông ấy được mọi người nể trọng",
    example: "tài năng của ông ấy được mọi người nể trọng",
  },
  {
    word: "nề nếp",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ những quy định và thói quen để duy trì sự ổn định, trật tự, có tổ chức trong công việc hoặc sinh hoạt: giữ gìn nền nếp gia phong * công việc đã đi vào nền nếp",
    example: "giữ gìn nền nếp gia phong * công việc đã đi vào nền nếp",
  },
  {
    word: "nề nếp",
    part_of_speech: "tính từ",
    meaning: "có thói quen tốt, đáng để học tập: con nhà nền nếp",
    example: "con nhà nền nếp",
  },
  {
    word: "nể mặt",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) như nể (ng1; nhưng nghĩa mạnh hơn): xin anh nể mặt tôi mà tha lỗi cho cháu",
    example: "xin anh nể mặt tôi mà tha lỗi cho cháu",
  },
  {
    word: "nể vì",
    part_of_speech: "động từ",
    meaning: "như vì nể: được bạn bè nể vì",
    example: "được bạn bè nể vì",
  },
  {
    word: "nể nả",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ, hiếm) như nể nang: tính hay nể nả",
    example: "tính hay nể nả",
  },
  {
    word: "nê-ông",
    part_of_speech: "danh từ",
    meaning:
      "khí trơ không màu và không mùi, dùng trong kĩ thuật ánh sáng: đèn neon",
    example: "đèn neon",
  },
  {
    word: "nể sợ",
    part_of_speech: "động từ",
    meaning:
      "coi trọng và sợ, không dám trái ý: tính khí ngang tàng, chẳng biết nể sợ ai",
    example: "tính khí ngang tàng, chẳng biết nể sợ ai",
  },
  {
    word: "nêm",
    part_of_speech: "danh từ",
    meaning: "mảnh cứng, nhỏ dùng để chêm cho chặt: miếng nêm gỗ * tháo nêm",
    example: "miếng nêm gỗ * tháo nêm",
  },
  {
    word: "nêm",
    part_of_speech: "động từ",
    meaning: "nhét thêm vào để cho chặt: nêm cối * chật như nêm",
    example: "nêm cối * chật như nêm",
  },
  {
    word: "nêm",
    part_of_speech: "động từ",
    meaning:
      "(Phương ngữ) cho thêm một ít mắm muối vào thức ăn cho vừa miệng khi chế biến: nêm mì chính * nêm canh cho vừa miệng",
    example: "nêm mì chính * nêm canh cho vừa miệng",
  },
  {
    word: "nếm trải",
    part_of_speech: "động từ",
    meaning:
      '(văn chương) nếm qua, trải qua (nói khái quát): nếm trải sự đời * "Nàng rằng: Chút phận hoa rơi, Nửa đời nếm trải mọi mùi đắng cay." (TKiều)',
    example:
      'nếm trải sự đời * "Nàng rằng: Chút phận hoa rơi, Nửa đời nếm trải mọi mùi đắng cay." (TKiều)',
  },
  {
    word: "nệm",
    part_of_speech: "danh từ",
    meaning:
      "(Nam thường nệm) đồ dùng làm bằng chất liệu mềm, xốp, dùng để lót vào chỗ nằm, ngồi cho êm: giường trải đệm * ghế có bọc đệm * đệm da",
    example: "giường trải đệm * ghế có bọc đệm * đệm da",
  },
  {
    word: "nệm",
    part_of_speech: "danh từ",
    meaning:
      "vật đặt thêm vào ở giữa để cho không còn hở hoặc để giảm bớt cọ xát, va chạm: miếng đệm bằng cao su",
    example: "miếng đệm bằng cao su",
  },
  {
    word: "nệm",
    part_of_speech: "động từ",
    meaning:
      "đặt phụ thêm vào ở giữa để làm cho không còn hở, nhằm giảm bớt cọ xát, va chạm: đệm thêm một miếng xốp * đệm giấy xung quanh cho khỏi vỡ",
    example: "đệm thêm một miếng xốp * đệm giấy xung quanh cho khỏi vỡ",
  },
  {
    word: "nệm",
    part_of_speech: "động từ",
    meaning:
      "thêm vào một hay nhiều tiếng nào đó, nhằm mục đích nhất định: đệm thêm vào một câu",
    example: "đệm thêm vào một câu",
  },
  {
    word: "nệm",
    part_of_speech: "động từ",
    meaning:
      "biểu diễn bằng nhạc khí phụ thêm vào với người biểu diễn chính: đệm đàn piano * hát đệm * hát không có nhạc đệm",
    example: "đệm đàn piano * hát đệm * hát không có nhạc đệm",
  },
  {
    word: "nện",
    part_of_speech: "động từ",
    meaning:
      "dùng vật có sức nặng đập mạnh xuống vật khác: nện gót giầy * tiếng nện đất thậm thịch",
    example: "nện gót giầy * tiếng nện đất thậm thịch",
  },
  {
    word: "nện",
    part_of_speech: "động từ",
    meaning: "(thông tục) đánh thật mạnh, thật đau: nện cho một trận",
    example: "nện cho một trận",
  },
  {
    word: "nếm",
    part_of_speech: "động từ",
    meaning:
      "ăn hay uống một chút để biết vị của đồ ăn thức uống: nếm rượu * nếm xem đã vừa chưa * được nếm thử nhiều món ăn ngon",
    example: "nếm rượu * nếm xem đã vừa chưa * được nếm thử nhiều món ăn ngon",
  },
  {
    word: "nếm",
    part_of_speech: "động từ",
    meaning:
      "biết qua (thường là điều không hay): nếm mùi đời * nếm đòn * nếm thất bại",
    example: "nếm mùi đời * nếm đòn * nếm thất bại",
  },
  {
    word: "nền",
    part_of_speech: "danh từ",
    meaning:
      "mặt phẳng bên dưới của các buồng, phòng ở: gạch lát nền * nền nhà bằng gỗ * ngồi phệt xuống mặt nền",
    example: "gạch lát nền * nền nhà bằng gỗ * ngồi phệt xuống mặt nền",
  },
  {
    word: "nền",
    part_of_speech: "danh từ",
    meaning:
      "lớp đất đá ở bên dưới dùng để đỡ móng nhà: xây lại trên nền nhà cũ",
    example: "xây lại trên nền nhà cũ",
  },
  {
    word: "nền",
    part_of_speech: "danh từ",
    meaning:
      "lớp đất đá cứng, chắc ở sâu bên dưới của ruộng, lòng sông, lòng đường: nền đường * ruộng bị trôi hết màu chỉ còn trơ lại nền",
    example: "nền đường * ruộng bị trôi hết màu chỉ còn trơ lại nền",
  },
  {
    word: "nền",
    part_of_speech: "danh từ",
    meaning:
      "cái được trải rộng ra và làm nổi lên những gì ở trên đó: màu nền * vải nền trắng, hoa xanh * điệu múa có âm nhạc làm nền",
    example: "màu nền * vải nền trắng, hoa xanh * điệu múa có âm nhạc làm nền",
  },
  {
    word: "nền",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng lĩnh vực được xây dựng trong hoạt động của con người, làm cơ sở cho đời sống xã hội: nền văn hoá dân tộc * nền kinh tế ngày càng phát triển",
    example: "nền văn hoá dân tộc * nền kinh tế ngày càng phát triển",
  },
  {
    word: "nền",
    part_of_speech: "tính từ",
    meaning: "(ăn mặc) nhã nhặn nhưng đẹp, nổi: chiếc áo mặc rất nền",
    example: "chiếc áo mặc rất nền",
  },
  {
    word: "nên chăng",
    part_of_speech: "",
    meaning:
      'nên hay không, thành hay không thành: "Dầu khi lá thắm, chỉ hồng, Nên chăng thì cũng tại lòng mẹ cha." (TKiều)',
    example:
      'Dầu khi lá thắm, chỉ hồng, Nên chăng thì cũng tại lòng mẹ cha." (TKiều)',
  },
  {
    word: "nên chăng",
    part_of_speech: "",
    meaning:
      ".  tổ hợp biểu thị ý đề nghị một cách dè dặt, người nói nêu ra như muốn hỏi để thuyết phục người đối thoại: nên chăng cần phải có một giải pháp mới?",
    example: "nên chăng cần phải có một giải pháp mới?",
  },
  {
    word: "nến",
    part_of_speech: "danh từ",
    meaning:
      "(Nam đèn cầy) thanh trụ làm bằng sáp, có sợi dây ở giữa (gọi là bấc) dùng đốt để thắp sáng: thắp nến * ngọn nến",
    example: "thắp nến * ngọn nến",
  },
  {
    word: "nến",
    part_of_speech: "danh từ",
    meaning: "đơn vị cũ đo cường độ sáng: bóng đèn 100 nến",
    example: "bóng đèn 100 nến",
  },
  {
    word: "nên",
    part_of_speech: "động từ",
    meaning:
      "thành ra được (cái kết quả cuối cùng): làm nên nghiệp lớn * nói chẳng nên lời * hai người đã nên vợ nên chồng",
    example:
      "làm nên nghiệp lớn * nói chẳng nên lời * hai người đã nên vợ nên chồng",
  },
  {
    word: "nên",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị mối quan hệ giữa nguyên nhân và kết quả: vì lười nên dốt * bận nên không đến được",
    example: "vì lười nên dốt * bận nên không đến được",
  },
  {
    word: "nên",
    part_of_speech: "động từ",
    meaning:
      "từ biểu thị ý khuyên bảo, việc, điều đang nói đến là hay, có lợi, làm hoặc thực hiện được thì tốt hơn: việc đó nên làm * chuyện này không biết nên vui hay nên buồn",
    example: "việc đó nên làm * chuyện này không biết nên vui hay nên buồn",
  },
  {
    word: "nên danh",
    part_of_speech: "động từ",
    meaning: "(hiếm) như thành danh: nên danh anh hùng",
    example: "nên danh anh hùng",
  },
  {
    word: "nên chi",
    part_of_speech: "kết từ",
    meaning: "(cũ, hoặc ph) vì vậy cho nên: hư quá nên chi người ta ghét",
    example: "hư quá nên chi người ta ghét",
  },
  {
    word: "nền móng",
    part_of_speech: "danh từ",
    meaning:
      "cái làm cơ sở vững chắc để dựa trên đó xây dựng và phát triển những cái khác: đặt nền móng cho trào lưu văn học mới",
    example: "đặt nền móng cho trào lưu văn học mới",
  },
  {
    word: "nền tảng",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận vững chắc dựa trên đó các bộ phận khác tồn tại và phát triển: nền tảng tư tưởng * nền tảng kinh tế",
    example: "nền tảng tư tưởng * nền tảng kinh tế",
  },
  {
    word: "nền nếp",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ những quy định và thói quen để duy trì sự ổn định, trật tự, có tổ chức trong công việc hoặc sinh hoạt: giữ gìn nền nếp gia phong * công việc đã đi vào nền nếp",
    example: "giữ gìn nền nếp gia phong * công việc đã đi vào nền nếp",
  },
  {
    word: "nền nếp",
    part_of_speech: "tính từ",
    meaning: "có thói quen tốt, đáng để học tập: con nhà nền nếp",
    example: "con nhà nền nếp",
  },
  {
    word: "nền nã",
    part_of_speech: "tính từ",
    meaning:
      "nền (nói khái quát): bộ váy trông nền nã * bức tranh có gam màu nền nã",
    example: "bộ váy trông nền nã * bức tranh có gam màu nền nã",
  },
  {
    word: "nền nã",
    part_of_speech: "tính từ",
    meaning: "(hiếm) đứng đắn và thuỳ mị: tính nết nền nã",
    example: "tính nết nền nã",
  },
  {
    word: "nếp",
    part_of_speech: "danh từ",
    meaning:
      "lúa cho gạo hạt to và trắng, nấu chín thì trong và dẻo, thường dùng thổi xôi, làm bánh: lúa nếp * gạo nếp",
    example: "lúa nếp * gạo nếp",
  },
  {
    word: "nếp",
    part_of_speech: "tính từ",
    meaning:
      "(một số loại ngũ cốc, quả cây hoặc thực phẩm) dẻo, thơm và ngon hơn những loại khác; phân biệt với tẻ: ngô nếp * dưa chuột nếp * gan nếp",
    example: "ngô nếp * dưa chuột nếp * gan nếp",
  },
  {
    word: "nếp",
    part_of_speech: "danh từ",
    meaning:
      "vệt hằn trên bề mặt nơi bị gấp lại của vải, lụa, da, v.v.: quần áo là thẳng nếp * trán có nhiều nếp nhăn",
    example: "quần áo là thẳng nếp * trán có nhiều nếp nhăn",
  },
  {
    word: "nếp",
    part_of_speech: "danh từ",
    meaning:
      "lối, cách sống, hoạt động đã trở thành quen, khó thay đổi: thay đổi nếp suy nghĩ * nếp sống mới",
    example: "thay đổi nếp suy nghĩ * nếp sống mới",
  },
  {
    word: "nên thân",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (làm) được việc, có kết quả: chả làm được việc gì nên thân * quét cái nhà cũng không nên thân",
    example: "chả làm được việc gì nên thân * quét cái nhà cũng không nên thân",
  },
  {
    word: "nên thân",
    part_of_speech: "tính từ",
    meaning:
      "tương xứng với những gì không tốt đã gây ra: bị một trận đòn nên thân",
    example: "bị một trận đòn nên thân",
  },
  {
    word: "nên người",
    part_of_speech: "động từ",
    meaning: "thành người tốt, có ích: nuôi dạy con cho nên người",
    example: "nuôi dạy con cho nên người",
  },
  {
    word: "nên thơ",
    part_of_speech: "tính từ",
    meaning: "có vẻ đẹp, gợi nhiều cảm hứng: phong cảnh nên thơ",
    example: "phong cảnh nên thơ",
  },
  {
    word: "nếu",
    part_of_speech: "kết từ",
    meaning:
      "từ dùng để nêu một giả thiết hoặc một điều kiện nhằm nói rõ cái gì sẽ xảy ra hoặc có thể xảy ra: nếu mưa thì tôi không đi * nếu chậm là hỏng việc",
    example: "nếu mưa thì tôi không đi * nếu chậm là hỏng việc",
  },
  {
    word: "nếu",
    part_of_speech: "kết từ",
    meaning:
      "từ thường dùng phối hợp với thì ở vế sau của câu để biểu thị quan hệ tương ứng giữa hai sự việc có thật, có việc này thì mặt khác cũng có việc kia: nếu việc này bị đổ bể thì tất việc kia cũng không thành",
    example: "nếu việc này bị đổ bể thì tất việc kia cũng không thành",
  },
  {
    word: "nếu",
    part_of_speech: "kết từ",
    meaning:
      "từ dùng phối hợp với thì là, thì tức là ở vế sau của câu để biểu thị quan hệ giải thích, một khi có việc này thì có nghĩa là có việc kia: nếu giờ vẫn chưa thấy nó về, thì là nó ở lại đó",
    example: "nếu giờ vẫn chưa thấy nó về, thì là nó ở lại đó",
  },
  {
    word: "nết",
    part_of_speech: "danh từ",
    meaning:
      "những đặc điểm tâm lí riêng ổn định của mỗi người (thường là người còn trẻ và trẻ con), biểu hiện ở thái độ, lời nói, hành vi thường ngày đã thành thói quen: một cô gái tốt nết * cái nết đánh chết cái đẹp (tng)",
    example: "một cô gái tốt nết * cái nết đánh chết cái đẹp (tng)",
  },
  {
    word: "nếu mà",
    part_of_speech: "",
    meaning:
      "tổ hợp dùng để nêu một giả thiết ít có khả năng, có gì đó không bình thường hoặc trái với hiện thực: nếu mà biết trước thì đâu đến nỗi",
    example: "nếu mà biết trước thì đâu đến nỗi",
  },
  {
    word: "nếp tẻ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) (con cái sinh ra, có đủ) trai và gái: nhà đã có đủ nếp tẻ",
    example: "nhà đã có đủ nếp tẻ",
  },
  {
    word: "nếp tẻ",
    part_of_speech: "danh từ",
    meaning:
      "hoặc t (sự việc) thế này hay thế kia, phải hay trái, đúng hay sai, hay hay dở, v.v.: chưa biết nếp tẻ thế nào đã nổi đoá lên!",
    example: "chưa biết nếp tẻ thế nào đã nổi đoá lên!",
  },
  {
    word: "nêu",
    part_of_speech: "danh từ",
    meaning:
      "cây tre cao, trên thường có treo những thứ như trầu cau, bùa chú, v.v. để ếm ma quỷ, được trồng trước nhà trong những ngày Tết âm lịch, theo tục lệ cổ truyền: trồng cây nêu",
    example: "trồng cây nêu",
  },
  {
    word: "nêu",
    part_of_speech: "động từ",
    meaning:
      "đưa ra, làm nổi bật lên cho mọi người chú ý (thường nói về cái trừu tượng): nêu câu hỏi * nêu ý kiến * nêu bật vấn đề",
    example: "nêu câu hỏi * nêu ý kiến * nêu bật vấn đề",
  },
  {
    word: "ngã",
    part_of_speech: "danh từ",
    meaning:
      "chỗ có nhiều ngả đường, ngả sông toả đi các hướng khác nhau: ở ngã tư có đèn đỏ * ngã ba sông * đứng giữa ngã ba đường (b)",
    example: "ở ngã tư có đèn đỏ * ngã ba sông * đứng giữa ngã ba đường (b)",
  },
  {
    word: "ngã",
    part_of_speech: "động từ",
    meaning:
      "chuyển đột ngột xuống vị trí thân sát trên mặt nền do bị mất thăng bằng, ngoài ý muốn: trượt chân nên bị ngã * ngã vật xuống giường * trèo cao ngã đau (tng)",
    example:
      "trượt chân nên bị ngã * ngã vật xuống giường * trèo cao ngã đau (tng)",
  },
  {
    word: "ngã",
    part_of_speech: "động từ",
    meaning:
      "chết (lối nói trang trọng, hoặc kiêng kị): anh ấy đã ngã xuống trên mảnh đất này * trâu bò bị dịch, ngã nhiều",
    example:
      "anh ấy đã ngã xuống trên mảnh đất này * trâu bò bị dịch, ngã nhiều",
  },
  {
    word: "ngã",
    part_of_speech: "động từ",
    meaning:
      "không giữ vững được tinh thần, ý chí do không chịu nổi tác động từ bên ngoài: bị ngã trước sức cám dỗ của đồng tiền * chớ thấy sóng cả mà ngã tay chèo (tng)",
    example:
      "bị ngã trước sức cám dỗ của đồng tiền * chớ thấy sóng cả mà ngã tay chèo (tng)",
  },
  {
    word: "ngã",
    part_of_speech: "động từ",
    meaning:
      "làm cho rõ ràng, dứt khoát, không còn phải bàn cãi nữa: bàn cho ngã lẽ * ngã giá",
    example: "bàn cho ngã lẽ * ngã giá",
  },
  {
    word: "nết na",
    part_of_speech: "tính từ",
    meaning:
      "có nết tốt, dễ mến (chỉ nói về phụ nữ còn trẻ): người con gái nết na",
    example: "người con gái nết na",
  },
  {
    word: "nếu như",
    part_of_speech: "kết từ",
    meaning:
      "như nếu (nhưng thường nhấn mạnh ý giả thiết): nếu như anh đến giúp thì đâu đến nỗi * nếu như là tôi, tôi sẽ không làm thế",
    example:
      "nếu như anh đến giúp thì đâu đến nỗi * nếu như là tôi, tôi sẽ không làm thế",
  },
  {
    word: "ngà",
    part_of_speech: "danh từ",
    meaning:
      "răng nanh hàm trên của voi, mọc chìa dài ra ngoài hai bên miệng: đôi ngà voi * chiếc lược ngà (làm bằng ngà)",
    example: "đôi ngà voi * chiếc lược ngà (làm bằng ngà)",
  },
  {
    word: "ngà",
    part_of_speech: "tính từ",
    meaning:
      "có màu trắng hơi ngả màu vàng như màu ngà voi: ánh trăng ngà * hàm răng trắng ngà",
    example: "ánh trăng ngà * hàm răng trắng ngà",
  },
  {
    word: "ngã bệnh",
    part_of_speech: "động từ",
    meaning: "bị bệnh nặng: đau buồn quá mà ngã bệnh",
    example: "đau buồn quá mà ngã bệnh",
  },
  {
    word: "ngả nghiêng",
    part_of_speech: "động từ",
    meaning:
      "ngả sang bên này rồi lại nghiêng sang bên kia một cách liên tục: cây tre ngả nghiêng theo gió * thế nước ngả nghiêng",
    example: "cây tre ngả nghiêng theo gió * thế nước ngả nghiêng",
  },
  {
    word: "ngả nghiêng",
    part_of_speech: "động từ",
    meaning:
      "không giữ vững được ý chí, dễ thay đổi khi gặp khó khăn, trở lực: tư tưởng dễ ngả nghiêng, dao động",
    example: "tư tưởng dễ ngả nghiêng, dao động",
  },
  {
    word: "ngã giá",
    part_of_speech: "động từ",
    meaning:
      'thoả thuận xong về giá cả, không còn phải cò kè thêm bớt gì nữa: "Cò kè bớt một, thêm hai, Giờ lâu ngã giá vàng ngoài bốn trăm." (TKiều)',
    example:
      'Cò kè bớt một, thêm hai, Giờ lâu ngã giá vàng ngoài bốn trăm." (TKiều)',
  },
  {
    word: "ngả",
    part_of_speech: "danh từ chỉ phương hướng",
    meaning:
      "đường đi theo một hướng nào đó, phân biệt với những đường đi theo hướng khác: mỗi người đi một ngả * âm dương đôi ngả",
    example: "mỗi người đi một ngả * âm dương đôi ngả",
  },
  {
    word: "ngả",
    part_of_speech: "ngã: động từ",
    meaning:
      "chuyển từ vị trí thẳng đứng sang vị trí nghiêng, chếch hay nằm ngang: ngả người xuống giường * ngả đầu vào vai bạn * cây ngả theo chiều gió",
    example:
      "ngả người xuống giường * ngả đầu vào vai bạn * cây ngả theo chiều gió",
  },
  {
    word: "ngả",
    part_of_speech: "ngã: động từ",
    meaning:
      "chuyển từ thái độ đứng giữa sang thái độ đứng về một bên nào đó: ngả theo trào lưu mới",
    example: "ngả theo trào lưu mới",
  },
  {
    word: "ngả",
    part_of_speech: "ngã: động từ",
    meaning:
      "chuyển sang màu khác, trạng thái, tính chất khác: mái tóc đã ngả bạc * trời ngả sang thu",
    example: "mái tóc đã ngả bạc * trời ngả sang thu",
  },
  {
    word: "ngả",
    part_of_speech: "ngã: động từ",
    meaning:
      "lấy ra hoặc lấy xuống rồi đặt ngửa ra: ngả bài * ngả mâm dọn cơm * ngả chõng ra ngồi",
    example: "ngả bài * ngả mâm dọn cơm * ngả chõng ra ngồi",
  },
  {
    word: "ngả",
    part_of_speech: "ngã: động từ",
    meaning:
      "làm cho đổ xuống để lấy cây, lấy gỗ, hay giết gia súc để lấy thịt: ngả cây làm nhà * ngả lợn ăn mừng * chết như ngả rạ (tng)",
    example: "ngả cây làm nhà * ngả lợn ăn mừng * chết như ngả rạ (tng)",
  },
  {
    word: "ngả",
    part_of_speech: "ngã: động từ",
    meaning: "cày ngả (nói tắt): ngả ruộng",
    example: "ngả ruộng",
  },
  {
    word: "ngà ngà",
    part_of_speech: "tính từ",
    meaning: "có cảm giác hơi say do uống rượu, bia: ngà ngà say",
    example: "ngà ngà say",
  },
  {
    word: "ngả lưng",
    part_of_speech: "động từ",
    meaning:
      "ngả người xuống nằm tạm một lúc: ngả lưng xuống giường * ngả lưng một chút cho đỡ mỏi",
    example: "ngả lưng xuống giường * ngả lưng một chút cho đỡ mỏi",
  },
  {
    word: "ngả ngốn",
    part_of_speech: "tính từ",
    meaning:
      "(nằm) không ngay ngắn, không nghiêm chỉnh, mỗi người một kiểu không theo một trật tự nào: mấy người say rượu nằm ngả ngốn giữa nhà",
    example: "mấy người say rượu nằm ngả ngốn giữa nhà",
  },
  {
    word: "ngã lòng",
    part_of_speech: "động từ",
    meaning:
      "không còn giữ được ý chí, quyết tâm trước khó khăn, thử thách: thất bại nên đã ngã lòng",
    example: "thất bại nên đã ngã lòng",
  },
  {
    word: "ngả ngớn",
    part_of_speech: "tính từ",
    meaning:
      "có dáng điệu, cử chỉ không nghiêm chỉnh, không đứng đắn: cười đùa ngả ngớn",
    example: "cười đùa ngả ngớn",
  },
  {
    word: "ngã ngửa",
    part_of_speech: "động từ",
    meaning:
      "hết sức ngạc nhiên, sửng sốt trước sự việc bất ngờ đã xảy ra, không thể lường trước: đến lúc nó trở mặt thì mới ngã ngửa ra",
    example: "đến lúc nó trở mặt thì mới ngã ngửa ra",
  },
  {
    word: "ngã ngũ",
    part_of_speech: "động từ",
    meaning:
      "đi đến một kết luận dứt khoát, để không còn có gì phải bàn nữa: cuộc tranh luận vẫn chưa ngã ngũ",
    example: "cuộc tranh luận vẫn chưa ngã ngũ",
  },
  {
    word: "ngả vạ",
    part_of_speech: "động từ",
    meaning: "như bắt vạ: chửa hoang nên bị làng ngả vạ",
    example: "chửa hoang nên bị làng ngả vạ",
  },
  {
    word: "ngạc nhiên",
    part_of_speech: "động từ",
    meaning:
      "lấy làm lạ, cảm thấy hoàn toàn bất ngờ đối với mình: ngạc nhiên với kết quả thi * tỏ vẻ ngạc nhiên * không lấy gì làm ngạc nhiên",
    example:
      "ngạc nhiên với kết quả thi * tỏ vẻ ngạc nhiên * không lấy gì làm ngạc nhiên",
  },
  {
    word: "ngách",
    part_of_speech: "danh từ",
    meaning:
      "nhánh nhỏ, hẹp, rẽ ra từ hang động, hầm hào hay sông suối: hang sâu và nhiều ngách",
    example: "hang sâu và nhiều ngách",
  },
  {
    word: "ngách",
    part_of_speech: "danh từ",
    meaning:
      "lối đi nhỏ hẹp trong làng xóm, phố phường, được rẽ ra từ ngõ: nhà ở trong ngách",
    example: "nhà ở trong ngách",
  },
  {
    word: "ngạch bậc",
    part_of_speech: "danh từ",
    meaning: "thứ bậc trong một ngạch: trả lương theo ngạch bậc",
    example: "trả lương theo ngạch bậc",
  },
  {
    word: "ngai",
    part_of_speech: "danh từ",
    meaning:
      "ghế lớn có lưng tựa và tay vịn, thường được sơn son thếp vàng và đặt ở chính điện, là ghế đặc biệt dành riêng cho vua ngồi trong các buổi chầu.",
    example: "ngai thờ",
  },
  {
    word: "ngạch",
    part_of_speech: "danh từ",
    meaning: "phần bên dưới ngưỡng cửa, có chèn gạch hay đất: ngạch cửa",
    example: "ngạch cửa",
  },
  {
    word: "ngạch",
    part_of_speech: "danh từ",
    meaning:
      "hệ thống sắp xếp có thứ tự theo từng loại, do nhà nước quy định: ngạch chuyên viên * ngạch thuế",
    example: "ngạch chuyên viên * ngạch thuế",
  },
  {
    word: "ngã nước",
    part_of_speech: "",
    meaning:
      "bệnh sốt rét (theo cách gọi trong dân gian): da xanh bủng như người ngã nước",
    example: "da xanh bủng như người ngã nước",
  },
  {
    word: "ngã nước",
    part_of_speech: "",
    meaning:
      "từ gọi chung những hiện tượng ghẻ lở, ỉa chảy, gầy còm ở trâu bò chuyển từ miền núi về đồng bằng: trâu bị ngã nước",
    example: "trâu bị ngã nước",
  },
  {
    word: "ngái",
    part_of_speech: "tính từ",
    meaning:
      "có mùi vị là lạ, không dịu, gây cảm giác khó ngửi: quả còn xanh nên ăn hơi ngái",
    example: "quả còn xanh nên ăn hơi ngái",
  },
  {
    word: "ngái",
    part_of_speech: "tính từ",
    meaning:
      '(phương ngữ) xa: "Gặp nhau giữa quãng đường này, Xóm làng thì ngái, mẹ thầy thì xa." (ca dao)',
    example:
      'Gặp nhau giữa quãng đường này, Xóm làng thì ngái, mẹ thầy thì xa." (ca dao)',
  },
  {
    word: "ngãi",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ, Từ cũ) nghĩa, tình nghĩa: tham vàng bỏ ngãi",
    example: "tham vàng bỏ ngãi",
  },
  {
    word: "ngài",
    part_of_speech: "đại từ",
    meaning:
      "(trang trọng) từ dùng để chỉ hoặc gọi với ý tôn kính người đàn ông có địa vị cao trong xã hội: ngài bá tước * ngài tổng thống và phu nhân * kính thưa ngài",
    example: "ngài bá tước * ngài tổng thống và phu nhân * kính thưa ngài",
  },
  {
    word: "ngài",
    part_of_speech: "danh từ",
    meaning: "bướm do tằm biến thành: con ngài",
    example: "con ngài",
  },
  {
    word: "ngài ngại",
    part_of_speech: "động từ",
    meaning: "hơi ngại: muốn hỏi vay tiền bạn nhưng lại thấy ngài ngại",
    example: "muốn hỏi vay tiền bạn nhưng lại thấy ngài ngại",
  },
  {
    word: "ngai ngái",
    part_of_speech: "tính từ",
    meaning: "có mùi hơi ngái: mùi cỏ ngai ngái",
    example: "mùi cỏ ngai ngái",
  },
  {
    word: "ngại",
    part_of_speech: "động từ",
    meaning:
      "cảm thấy có phần muốn tránh vì nghĩ đến những gì không hay mà có thể mình sẽ phải chịu: có ý ngại khó * trời tối nên ngại đi * ngại phiền người khác",
    example: "có ý ngại khó * trời tối nên ngại đi * ngại phiền người khác",
  },
  {
    word: "ngại",
    part_of_speech: "động từ",
    meaning:
      "cảm thấy không yên lòng vì sợ rằng có thể xảy ra điều gì đó không hay: ngại rằng trời sẽ mưa * bệnh này không đáng ngại",
    example: "ngại rằng trời sẽ mưa * bệnh này không đáng ngại",
  },
  {
    word: "ngái ngủ",
    part_of_speech: "",
    meaning:
      "chưa hết buồn ngủ hoặc chưa tỉnh táo hẳn sau khi vừa ngủ dậy: giọng ngái ngủ",
    example: "giọng ngái ngủ",
  },
  {
    word: "ngại ngùng",
    part_of_speech: "động từ",
    meaning:
      'tỏ ra có điều e ngại, không dám làm việc gì (nói khái quát): chưa quen nên còn ngại ngùng * "Ngại ngùng rợn gió e sương, Nhìn hoa bóng thẹn, trông gương mặt dày." (TKiều)',
    example:
      'chưa quen nên còn ngại ngùng * "Ngại ngùng rợn gió e sương, Nhìn hoa bóng thẹn, trông gương mặt dày." (TKiều)',
  },
  {
    word: "ngàn",
    part_of_speech: "danh từ",
    meaning: "(văn chương) rừng: vượt suối băng ngàn",
    example: "vượt suối băng ngàn",
  },
  {
    word: "ngàn",
    part_of_speech: "danh từ",
    meaning: "(Nam) nghìn: một trăm ngàn đồng",
    example: "một trăm ngàn đồng",
  },
  {
    word: "ngai vàng",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) ngai của vua ngồi, thường được thếp vàng; dùng để chỉ ngôi vua: lật đổ ngai vàng",
    example: "lật đổ ngai vàng",
  },
  {
    word: "ngàn cân treo sợi tóc",
    part_of_speech: "",
    meaning:
      "ví tình thế, tình trạng hết sức nguy ngập, hiểm nghèo, khó bề vượt qua, cứu vãn nổi: vận mệnh đất nước đang ngàn cân treo sợi tóc",
    example: "vận mệnh đất nước đang ngàn cân treo sợi tóc",
  },
  {
    word: "ngán",
    part_of_speech: "động từ",
    meaning:
      'ở trạng thái không thể tiếp nhận, không thể chịu đựng thêm được nữa: ăn nhiều phát ngán * "Nghĩ đời mà ngán cho đời, Tài tình chi lắm cho trời đất ghen!" (TKiều)',
    example:
      'ăn nhiều phát ngán * "Nghĩ đời mà ngán cho đời, Tài tình chi lắm cho trời đất ghen!" (TKiều)',
  },
  {
    word: "ngán",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) ngại đến mức sợ: ngán đòn * chẳng ngán gì hết!",
    example: "ngán đòn * chẳng ngán gì hết!",
  },
  {
    word: "ngàn ngạt",
    part_of_speech: "tính từ",
    meaning:
      "(tiếng nói) hơi bị tắc, nghe như người bị ngạt mũi: giọng nói hơi ngàn ngạt",
    example: "giọng nói hơi ngàn ngạt",
  },
  {
    word: "ngan ngát",
    part_of_speech: "tính từ",
    meaning: "như ngát (ng1; nhưng ý mức độ ít hơn): hương hoa ngan ngát",
    example: "hương hoa ngan ngát",
  },
  {
    word: "ngán ngẩm",
    part_of_speech: "động từ",
    meaning:
      "chán đến mức không còn thiết gì nữa, vì đã thất vọng nhiều: thở dài ngán ngẩm",
    example: "thở dài ngán ngẩm",
  },
  {
    word: "ngàn trùng",
    part_of_speech: "danh từ",
    meaning:
      '(Văn chương) nơi xa lắm, cao lắm, như cách trở núi sông trùng trùng điệp điệp: đường xa nghìn trùng * "Nghe lời sửa áo cài trâm, Khấu đầu lạy tạ cao thâm nghìn trùng." (TKiều)',
    example:
      'đường xa nghìn trùng * "Nghe lời sửa áo cài trâm, Khấu đầu lạy tạ cao thâm nghìn trùng." (TKiều)',
  },
  {
    word: "ngãng",
    part_of_speech: "tính từ",
    meaning: "có khoảng cách rộng dần ra về cả hai bên: càng xe bò bị ngãng ra",
    example: "càng xe bò bị ngãng ra",
  },
  {
    word: "ngãng",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra có ý không tán thành, muốn từ chối không tham dự, hoặc muốn từ bỏ điều đã hứa hẹn trước: thấy khó khăn nhiều người ngãng ra",
    example: "thấy khó khăn nhiều người ngãng ra",
  },
  {
    word: "ngàn xưa",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương) thời gian rất lâu trong quá khứ, cách đây hàng nghìn năm: cổ vật từ nghìn xưa để lại",
    example: "cổ vật từ nghìn xưa để lại",
  },
  {
    word: "ngáng",
    part_of_speech: "động từ",
    meaning:
      "chắn ngang, làm cản trở sự hoạt động: lấy gậy ngáng ngang cửa * cây đổ ngáng giữa đường",
    example: "lấy gậy ngáng ngang cửa * cây đổ ngáng giữa đường",
  },
  {
    word: "ngang bướng",
    part_of_speech: "tính từ",
    meaning:
      "bướng, nhất định không chịu nghe theo ai cả mà cứ theo ý mình, dù có biết là sai trái đi nữa: đứa trẻ ngang bướng, không chịu nghe lời * sai rành rành mà vẫn còn ngang bướng",
    example:
      "đứa trẻ ngang bướng, không chịu nghe lời * sai rành rành mà vẫn còn ngang bướng",
  },
  {
    word: "ngàn thu",
    part_of_speech: "danh từ",
    meaning:
      '(văn chương) nghìn năm; mãi mãi: tiếng thơm để mãi đến nghìn thu * "Anh hoa phát tiết ra ngoài, Nghìn thu bạc mệnh một đời tài hoa." (TKiều)',
    example:
      'tiếng thơm để mãi đến nghìn thu * "Anh hoa phát tiết ra ngoài, Nghìn thu bạc mệnh một đời tài hoa." (TKiều)',
  },
  {
    word: "ngang cành bứa",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) rất ngang bướng, không chịu nghe theo lẽ phải: nói ngang cành bứa",
    example: "nói ngang cành bứa",
  },
  {
    word: "ngang dạ",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) có cảm giác hơi no, không muốn ăn, ăn không thấy ngon (do trước đó đã ăn một ít cái gì khác): ăn quà đã ngang dạ",
    example: "ăn quà đã ngang dạ",
  },
  {
    word: "ngang",
    part_of_speech: "tính từ",
    meaning:
      "có chiều song song với mặt đất, mặt nước hoặc theo chiều rộng: chiều ngang * dàn hàng ngang * băng ngang qua đường",
    example: "chiều ngang * dàn hàng ngang * băng ngang qua đường",
  },
  {
    word: "ngang",
    part_of_speech: "tính từ",
    meaning:
      "không thấp hơn, mà ở cùng mức với cái gì đó: tóc chấm ngang vai * cao ngang nhau * hai người ngang sức ngang tài",
    example:
      "tóc chấm ngang vai * cao ngang nhau * hai người ngang sức ngang tài",
  },
  {
    word: "ngang",
    part_of_speech: "tính từ",
    meaning:
      "ở giữa chừng và làm gián đoạn: chặt ngang thân cây * cắt ngang câu chuyện * nói chen ngang",
    example: "chặt ngang thân cây * cắt ngang câu chuyện * nói chen ngang",
  },
  {
    word: "ngang",
    part_of_speech: "tính từ",
    meaning:
      "không thuận theo lẽ thường, mà một mực theo ý riêng của mình trong cách nói năng, đối xử, làm khó chịu: cãi ngang * nói ngang * tính ngang như cua!",
    example: "cãi ngang * nói ngang * tính ngang như cua!",
  },
  {
    word: "ngang",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (mùi vị, âm điệu) không bình thường, mà có gì đó là lạ, gây cảm giác khó chịu, khó nghe: món canh ăn rất ngang * có mùi ngang ngang * câu thơ đọc ngang phè",
    example:
      "món canh ăn rất ngang * có mùi ngang ngang * câu thơ đọc ngang phè",
  },
  {
    word: "ngang",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) đi ngang qua: ngang qua mặt nhau mà không biết",
    example: "ngang qua mặt nhau mà không biết",
  },
  {
    word: "ngang ngạnh",
    part_of_speech: "tính từ",
    meaning:
      "rất ngang bướng, đã không chịu nghe theo mà nhiều khi còn cố ý làm khác đi: tính ương bướng, ngang ngạnh",
    example: "tính ương bướng, ngang ngạnh",
  },
  {
    word: "ngang ngửa",
    part_of_speech: "tính từ",
    meaning:
      "nhiều và lộn xộn, cái nằm ngang, cái để ngửa, không theo một hàng lối, trật tự nào cả: bàn ghế đổ ngang ngửa",
    example: "bàn ghế đổ ngang ngửa",
  },
  {
    word: "ngang ngửa",
    part_of_speech: "tính từ",
    meaning:
      "(nhìn, quay) hết bên này, lại sang bên kia, không theo một hướng nhất định nào cả: quay ngang quay ngửa * nhìn ngang nhìn ngửa",
    example: "quay ngang quay ngửa * nhìn ngang nhìn ngửa",
  },
  {
    word: "ngang ngửa",
    part_of_speech: "tính từ",
    meaning:
      "ngang sức, không hơn nhưng cũng không kém, không thắng được ngay nhưng cũng không thua trong cuộc đọ sức quyết liệt: cuộc so tài ngang ngửa * cạnh tranh ngang ngửa * hàng nội đắt ngang ngửa với hàng ngoại",
    example:
      "cuộc so tài ngang ngửa * cạnh tranh ngang ngửa * hàng nội đắt ngang ngửa với hàng ngoại",
  },
  {
    word: "ngang hàng",
    part_of_speech: "tính từ",
    meaning:
      "cùng thứ bậc trong quan hệ gia đình hoặc quan hệ xã hội: tuổi tác tuy chênh lệch nhưng ngang hàng nhau",
    example: "tuổi tác tuy chênh lệch nhưng ngang hàng nhau",
  },
  {
    word: "ngang tai",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) khó nghe vì trái với lẽ thường: câu nói nghe rất ngang tai",
    example: "câu nói nghe rất ngang tai",
  },
  {
    word: "ngang nhiên",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra bất chấp mọi quyền lực, mọi sự chống đối, cứ thản nhiên làm theo ý mình mà không chút e sợ: tên tội phạm sống ngang nhiên ngoài vòng pháp luật",
    example: "tên tội phạm sống ngang nhiên ngoài vòng pháp luật",
  },
  {
    word: "ngang dọc",
    part_of_speech: "",
    meaning: "ngang và dọc, đủ các hướng: đèn điện giăng mắc ngang dọc",
    example: "đèn điện giăng mắc ngang dọc",
  },
  {
    word: "ngang ngược",
    part_of_speech: "tính từ",
    meaning:
      "ngang ngạnh, bất chấp lẽ phải, tỏ ra không kể gì đến bất cứ ai: ăn nói ngang ngược",
    example: "ăn nói ngang ngược",
  },
  {
    word: "ngang trái",
    part_of_speech: "tính từ",
    meaning: "trái với đạo lí, với lẽ thường: hành vi ngang trái",
    example: "hành vi ngang trái",
  },
  {
    word: "ngang trái",
    part_of_speech: "tính từ",
    meaning:
      "ở tình trạng gặp phải tình cảnh trái với lẽ thường ở đời, chịu nhiều đau khổ: tình duyên ngang trái * cảnh ngộ ngang trái",
    example: "tình duyên ngang trái * cảnh ngộ ngang trái",
  },
  {
    word: "ngang tàng",
    part_of_speech: "tính từ",
    meaning:
      'tỏ ra bất chấp, không sợ gì, không chịu khuất phục ai: khí phách ngang tàng * "Năm năm trời bể ngang tàng, Đem mình đi bỏ chiến trường như không." (TKiều)',
    example:
      'khí phách ngang tàng * "Năm năm trời bể ngang tàng, Đem mình đi bỏ chiến trường như không." (TKiều)',
  },
  {
    word: "ngáng trở",
    part_of_speech: "",
    meaning: "gây cản trở sự hoạt động: ngáng trở công việc của người khác",
    example: "ngáng trở công việc của người khác",
  },
  {
    word: "ngành",
    part_of_speech: "danh từ",
    meaning: "bộ phận lớn trong một dòng họ: ngành trên * ngành trưởng",
    example: "ngành trên * ngành trưởng",
  },
  {
    word: "ngành",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị phân loại sinh học, dưới giới, trên lớp: ngành thực vật hạt kín * lớp thú thuộc ngành động vật có xương sống",
    example:
      "ngành thực vật hạt kín * lớp thú thuộc ngành động vật có xương sống",
  },
  {
    word: "ngành",
    part_of_speech: "danh từ",
    meaning:
      "hệ thống cơ quan chuyên môn của nhà nước từ trung ương đến địa phương: ngành bưu chính viễn thông * cơ quan liên ngành",
    example: "ngành bưu chính viễn thông * cơ quan liên ngành",
  },
  {
    word: "ngành",
    part_of_speech: "danh từ",
    meaning:
      "lĩnh vực hoạt động về chuyên môn, khoa học, văn hoá, kinh tế: ngành công nghiệp * ngành kinh tế * ngành dệt may",
    example: "ngành công nghiệp * ngành kinh tế * ngành dệt may",
  },
  {
    word: "ngạnh",
    part_of_speech: "danh từ",
    meaning:
      "mũi nhọn và sắc chĩa chéo ra ngược chiều với mũi nhọn chính để làm cho vật bị mắc vào khó tuột, khó giãy ra: ngạnh lưỡi câu",
    example: "ngạnh lưỡi câu",
  },
  {
    word: "ngạnh",
    part_of_speech: "danh từ",
    meaning: "gai xương cứng ở vây ngực một số loài cá: ngạnh cá trê",
    example: "ngạnh cá trê",
  },
  {
    word: "ngành nghề",
    part_of_speech: "danh từ",
    meaning:
      "nghề nghiệp chuyên môn (nói khái quát): lựa chọn ngành nghề * chuyển ngành nghề",
    example: "lựa chọn ngành nghề * chuyển ngành nghề",
  },
  {
    word: "ngành dọc",
    part_of_speech: "danh từ",
    meaning:
      "ngành chuyên môn có quan hệ từ trên xuống dưới trong một hệ thống tổ chức: chịu sự quản lí theo ngành dọc",
    example: "chịu sự quản lí theo ngành dọc",
  },
  {
    word: "ngảnh",
    part_of_speech: "động từ",
    meaning:
      "quay mặt về một phía nào đó: ngoảnh mặt đi, không nhìn * ngoảnh đầu nhìn lại",
    example: "ngoảnh mặt đi, không nhìn * ngoảnh đầu nhìn lại",
  },
  {
    word: "ngao",
    part_of_speech: "danh từ",
    meaning:
      "động vật cùng loài với hến nhưng lớn hơn, sống ở bãi cát ven biển: đi cào ngao",
    example: "đi cào ngao",
  },
  {
    word: "ngành ngọn",
    part_of_speech: "danh từ",
    meaning:
      'như ngọn ngành (nhưng ít dùng hơn): kể rõ ngành ngọn * "Nghe tường ngành ngọn tiêu hao, Lòng riêng, chàng luống lao đao thẫn thờ." (TKiều)',
    example:
      'kể rõ ngành ngọn * "Nghe tường ngành ngọn tiêu hao, Lòng riêng, chàng luống lao đao thẫn thờ." (TKiều)',
  },
  {
    word: "ngào",
    part_of_speech: "động từ",
    meaning:
      "cho vào trong nước đường đun nhỏ lửa và đảo đều cho thấm đường: cốm ngào đường * khoai lang ngào",
    example: "cốm ngào đường * khoai lang ngào",
  },
  {
    word: "ngào",
    part_of_speech: "động từ",
    meaning: "(hiếm) như nhào: ngào bột làm bánh * ngào đất cho nhuyễn",
    example: "ngào bột làm bánh * ngào đất cho nhuyễn",
  },
  {
    word: "ngành hàng",
    part_of_speech: "danh từ",
    meaning:
      "chủng loại hàng hoá được sản xuất, kinh doanh với quy mô lớn (nói khái quát): ngành hàng điện tử * ngành hàng may mặc",
    example: "ngành hàng điện tử * ngành hàng may mặc",
  },
  {
    word: "ngạo",
    part_of_speech: "động từ",
    meaning: "khinh thường, bất chấp: khinh đời ngạo của * ngạo đời",
    example: "khinh đời ngạo của * ngạo đời",
  },
  {
    word: "ngao du",
    part_of_speech: "động từ",
    meaning: "dạo chơi khắp đó đây: ngao du đây đó",
    example: "ngao du đây đó",
  },
  {
    word: "ngào ngạt",
    part_of_speech: "tính từ",
    meaning:
      "(mùi thơm) bốc lên lan toả rộng và kích thích mạnh vào khứu giác: hoa thơm ngào ngạt * mùi trầm hương ngào ngạt",
    example: "hoa thơm ngào ngạt * mùi trầm hương ngào ngạt",
  },
  {
    word: "ngạo mạn",
    part_of_speech: "tính từ",
    meaning: "kiêu ngạo đến mức hỗn xược: cười ngạo mạn * thái độ ngạo mạn",
    example: "cười ngạo mạn * thái độ ngạo mạn",
  },
  {
    word: "ngao ngán",
    part_of_speech: "",
    meaning:
      'buồn rầu, chán nản, không còn thấy thích thú gì nữa: thở dài ngao ngán * "Tuần trăng khuyết, đĩa dầu hao, Mặt mơ tưởng mặt, lòng ngao ngán lòng." (TKiều)',
    example:
      'thở dài ngao ngán * "Tuần trăng khuyết, đĩa dầu hao, Mặt mơ tưởng mặt, lòng ngao ngán lòng." (TKiều)',
  },
  {
    word: "ngáp",
    part_of_speech: "động từ",
    meaning:
      "há rộng miệng thở ra thật dài (thường do cơ thể mệt mỏi hoặc do buồn ngủ): ngáp ngủ * ngáp sái quai hàm * chết không kịp ngáp",
    example: "ngáp ngủ * ngáp sái quai hàm * chết không kịp ngáp",
  },
  {
    word: "ngát",
    part_of_speech: "tính từ",
    meaning: "(mùi) dễ chịu và toả lan ra xa: không gian ngát mùi hoa sữa",
    example: "không gian ngát mùi hoa sữa",
  },
  {
    word: "ngát",
    part_of_speech: "tính từ",
    meaning:
      "(màu sắc, thường là xanh, tím) tươi và dịu mát, trải ra rộng khắp: bầu trời xanh ngát * hoa bằng lăng tím ngát",
    example: "bầu trời xanh ngát * hoa bằng lăng tím ngát",
  },
  {
    word: "ngạo nghễ",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra không chút e sợ, mà coi thường, bất chấp tất cả: cười ngạo nghễ * ngôi biệt thự ngạo nghễ đứng giữa làng",
    example: "cười ngạo nghễ * ngôi biệt thự ngạo nghễ đứng giữa làng",
  },
  {
    word: "ngạt",
    part_of_speech: "tính từ",
    meaning:
      "(Nam thường nghẹt) có cảm giác khó thở hoặc không thở được do bí hơi, thiếu không khí: mũi bị ngạt * ngạt thở",
    example: "mũi bị ngạt * ngạt thở",
  },
  {
    word: "ngạo ngược",
    part_of_speech: "tính từ",
    meaning: "láo xược và ngang ngược, bất chấp tất cả: ăn nói ngạo ngược",
    example: "ăn nói ngạo ngược",
  },
  {
    word: "ngạt mũi",
    part_of_speech: "động từ",
    meaning: "cảm thấy khó thở đằng mũi (do mũi bị viêm nhiễm): bị ngạt mũi",
    example: "bị ngạt mũi",
  },
  {
    word: "ngàu",
    part_of_speech: "tính từ",
    meaning:
      "(nước) có nhiều vẩn, nhiều tạp chất nổi lên: dòng nước phù sa ngầu đỏ",
    example: "dòng nước phù sa ngầu đỏ",
  },
  {
    word: "ngày",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian Trái Đất tự xoay xung quanh nó đúng một vòng, bằng 24 giờ: một năm dương lịch có 365 ngày",
    example: "một năm dương lịch có 365 ngày",
  },
  {
    word: "ngày",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian 24 giờ, hoặc ước khoảng 24 giờ: làm hai ngày mới xong * ở lại chơi thêm mấy ngày",
    example: "làm hai ngày mới xong * ở lại chơi thêm mấy ngày",
  },
  {
    word: "ngày",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian từ khi mặt trời mọc đến khi mặt trời lặn: ngủ ngày * học ngày học đêm * ngày đi đêm nghỉ",
    example: "ngủ ngày * học ngày học đêm * ngày đi đêm nghỉ",
  },
  {
    word: "ngày",
    part_of_speech: "danh từ",
    meaning:
      "ngày cụ thể được xác định để ghi nhớ, kỉ niệm về một sự kiện nào đó: ngày Tết * ngày cưới * ngày sinh nhật",
    example: "ngày Tết * ngày cưới * ngày sinh nhật",
  },
  {
    word: "ngày",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian không xác định, nhưng là thời gian dài, nhiều ngày: ngày còn nhỏ * ngày trẻ",
    example: "ngày còn nhỏ * ngày trẻ",
  },
  {
    word: "ngay",
    part_of_speech: "tính từ",
    meaning:
      '(phương ngữ) thẳng, không chệch: ngay hàng thẳng lối * "Con sông khúc vạy, khúc ngay, Đò này chở khách chuyến đầy chuyến vơi." (ca dao)',
    example:
      'ngay hàng thẳng lối * "Con sông khúc vạy, khúc ngay, Đò này chở khách chuyến đầy chuyến vơi." (ca dao)',
  },
  {
    word: "ngay",
    part_of_speech: "tính từ",
    meaning:
      "ở tư thế thẳng đờ, không cử động hoặc không cử động được: người ngay đơ như tượng * nằm ngay như khúc gỗ",
    example: "người ngay đơ như tượng * nằm ngay như khúc gỗ",
  },
  {
    word: "ngay",
    part_of_speech: "tính từ",
    meaning:
      "thật thà, không gian dối: người ngay * tình ngay lí gian (tng) * ăn mặn nói ngay còn hơn ăn chay nói dối (tng)",
    example:
      "người ngay * tình ngay lí gian (tng) * ăn mặn nói ngay còn hơn ăn chay nói dối (tng)",
  },
  {
    word: "ngay",
    part_of_speech: "phụ từ",
    meaning:
      "(làm việc gì) liền sau đó, không chậm trễ: nhận được tin là đi ngay * ăn ngay cho nóng * im ngay! * biết ngay mà!",
    example:
      "nhận được tin là đi ngay * ăn ngay cho nóng * im ngay! * biết ngay mà!",
  },
  {
    word: "ngay",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý nhấn mạnh tính xác định của một địa điểm, thời điểm, đúng ở nơi hoặc vào lúc nói đến: sống ngay trong thành phố * trời Phật ở ngay trong tâm mỗi người",
    example: "sống ngay trong thành phố * trời Phật ở ngay trong tâm mỗi người",
  },
  {
    word: "ngay",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý nhấn mạnh mức độ của một sự việc đã không loại trừ cả trường hợp được nói đến: nó đối xử tệ ngay với cả mẹ nó",
    example: "nó đối xử tệ ngay với cả mẹ nó",
  },
  {
    word: "ngay cán tàn",
    part_of_speech: "",
    meaning: "(khẩu ngữ) (mặt, tư thế) đờ ra, thuỗn ra: mặt ngay cán tàn",
    example: "mặt ngay cán tàn",
  },
  {
    word: "ngày càng",
    part_of_speech: "",
    meaning:
      "tổ hợp biểu thị mức độ, số lượng tăng theo thời gian: sự việc ngày càng rắc rối * dân số ngày càng tăng",
    example: "sự việc ngày càng rắc rối * dân số ngày càng tăng",
  },
  {
    word: "ngày đường",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) quãng đường đi trung bình trong một ngày, dùng làm đơn vị đo độ dài trong dân gian: đi mấy ngày đường mới tới",
    example: "đi mấy ngày đường mới tới",
  },
  {
    word: "ngày đêm",
    part_of_speech: "danh từ",
    meaning: "như đêm ngày: ngày đêm miệt mài đèn sách * luyện tập ngày đêm",
    example: "ngày đêm miệt mài đèn sách * luyện tập ngày đêm",
  },
  {
    word: "ngày công",
    part_of_speech: "danh từ",
    meaning:
      "ngày làm việc được tính làm đơn vị trả công: tháng này làm 23 ngày công",
    example: "tháng này làm 23 ngày công",
  },
  {
    word: "ngày giờ",
    part_of_speech: "danh từ",
    meaning:
      "thời gian, về mặt dành cho một công việc cụ thể nào đó: có đủ ngày giờ để chuẩn bị",
    example: "có đủ ngày giờ để chuẩn bị",
  },
  {
    word: "ngày giờ",
    part_of_speech: "danh từ",
    meaning:
      "thời điểm được xác định để tiến hành một công việc cụ thể nào đó: đúng ngày giờ quy định * phải đi gấp cho kịp ngày giờ",
    example: "đúng ngày giờ quy định * phải đi gấp cho kịp ngày giờ",
  },
  {
    word: "ngày lành tháng tốt",
    part_of_speech: "",
    meaning:
      "ngày, tháng được coi là tốt lành để tiến hành công việc hệ trọng nào đó, theo tín ngưỡng dân gian: chọn ngày lành tháng tốt để tổ chức lễ cưới",
    example: "chọn ngày lành tháng tốt để tổ chức lễ cưới",
  },
  {
    word: "ngay lưng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) lười biếng, không chịu lao động: ngay lưng, sống bám vào bố mẹ * đồ ngay lưng!",
    example: "ngay lưng, sống bám vào bố mẹ * đồ ngay lưng!",
  },
  {
    word: "ngay lập tức",
    part_of_speech: "phụ từ",
    meaning: "(khẩu ngữ) như lập tức (nhưng nghĩa mạnh hơn): đi ngay lập tức",
    example: "đi ngay lập tức",
  },
  {
    word: "ngày mai",
    part_of_speech: "danh từ",
    meaning:
      "ngày liền ngay sau ngày hôm nay: hôm nay là thứ hai, ngày mai là thứ ba",
    example: "hôm nay là thứ hai, ngày mai là thứ ba",
  },
  {
    word: "ngày mai",
    part_of_speech: "danh từ",
    meaning:
      "những ngày sắp tới: hi vọng ở ngày mai * chuyện hôm nay chớ để ngày mai",
    example: "hi vọng ở ngày mai * chuyện hôm nay chớ để ngày mai",
  },
  {
    word: "ngày kia",
    part_of_speech: "danh từ",
    meaning: "ngày liền ngay sau ngày mai: ngày mai đi, ngày kia sẽ tới",
    example: "ngày mai đi, ngày kia sẽ tới",
  },
  {
    word: "ngày kia",
    part_of_speech: "danh từ",
    meaning:
      "một ngày nào đó trong quá khứ hoặc tương lai: một ngày kia, chúng ta sẽ gặp lại nhau",
    example: "một ngày kia, chúng ta sẽ gặp lại nhau",
  },
  {
    word: "ngày một ngày hai",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) khoảng thời gian ngắn, chỉ trong vòng ít ngày: việc đó không phải ngày một ngày hai mà xong",
    example: "việc đó không phải ngày một ngày hai mà xong",
  },
  {
    word: "ngay ngáy",
    part_of_speech: "tính từ",
    meaning:
      "không lúc nào được yên lòng, luôn luôn sợ sẽ xảy ra điều không hay nào đó: lo ngay ngáy",
    example: "lo ngay ngáy",
  },
  {
    word: "ngày nay",
    part_of_speech: "danh từ",
    meaning:
      "thời bây giờ: thời đại ngày nay * ngày nay, đời sống người nông dân đã được cải thiện",
    example:
      "thời đại ngày nay * ngày nay, đời sống người nông dân đã được cải thiện",
  },
  {
    word: "ngày một",
    part_of_speech: "",
    meaning:
      '(khẩu ngữ) như ngày càng: "Ruột tằm, ngày một héo hon, Tuyết sương ngày một hao mòn mình ve." (TKiều)',
    example:
      'Ruột tằm, ngày một héo hon, Tuyết sương ngày một hao mòn mình ve." (TKiều)',
  },
  {
    word: "ngày mùa",
    part_of_speech: "danh từ",
    meaning:
      "thời kì gặt hái, thu hoạch mùa màng (nói khái quát): ngày mùa bận rộn * công việc ngày mùa",
    example: "ngày mùa bận rộn * công việc ngày mùa",
  },
  {
    word: "ngày ngày",
    part_of_speech: "phụ từ",
    meaning:
      '(khẩu ngữ) ngày này sang ngày khác, ngày nào cũng thế (nói về hành động lặp đi lặp lại theo thời gian): ngày ngày cắp sách đến trường * "Song hồ nửa khép cánh mây, Tường đông ghé mắt, ngày ngày hằng trông." (TKiều)',
    example:
      'ngày ngày cắp sách đến trường * "Song hồ nửa khép cánh mây, Tường đông ghé mắt, ngày ngày hằng trông." (TKiều)',
  },
  {
    word: "ngay ngắn",
    part_of_speech: "tính từ",
    meaning:
      "được để ở vị trí hoặc được sắp xếp cho thẳng hàng, thẳng góc, không có chỗ nào bị lệch về bên nào: sách vở xếp ngay ngắn trên bàn * chữ viết ngay ngắn",
    example: "sách vở xếp ngay ngắn trên bàn * chữ viết ngay ngắn",
  },
  {
    word: "ngày qua tháng lại",
    part_of_speech: "",
    meaning:
      'thời gian trôi qua, tính bằng ngày, bằng tháng: "Tiểu đồng trước giữ mộ phần, Ngày qua tháng lại đã gần ba năm." (LVT)',
    example:
      'Tiểu đồng trước giữ mộ phần, Ngày qua tháng lại đã gần ba năm." (LVT)',
  },
  {
    word: "ngày rày",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương) ngày cùng ngày với ngày hôm nay nhưng thuộc một tháng khác hoặc một năm khác: ngày rày tháng trước * hẹn gặp lại nhau vào ngày rày năm sau",
    example: "ngày rày tháng trước * hẹn gặp lại nhau vào ngày rày năm sau",
  },
  {
    word: "ngày rày",
    part_of_speech: "danh từ",
    meaning:
      '(phương ngữ, khẩu ngữ) những ngày đã qua, cho đến lúc nói: ốm mấy ngày rày * "Kể mà cái đạo trò thầy, Ngày xưa có nghĩa ngày rày đền ơn." (MPXH)',
    example:
      'ốm mấy ngày rày * "Kể mà cái đạo trò thầy, Ngày xưa có nghĩa ngày rày đền ơn." (MPXH)',
  },
  {
    word: "ngày sau",
    part_of_speech: "danh từ",
    meaning:
      'ngày sẽ tới trong tương lai xa; sau này: "Công lênh chẳng quản bao lâu, Ngày nay nước bạc, ngày sau cơm vàng." (ca dao)',
    example:
      'Công lênh chẳng quản bao lâu, Ngày nay nước bạc, ngày sau cơm vàng." (ca dao)',
  },
  {
    word: "ngay tắp lự",
    part_of_speech: "phụ từ",
    meaning: "(khẩu ngữ) như tắp lự (nhưng nghĩa mạnh hơn): làm ngay tắp lự",
    example: "làm ngay tắp lự",
  },
  {
    word: "ngày tiết",
    part_of_speech: "danh từ",
    meaning: "(ng1): những ngày tiết trong năm",
    example: "những ngày tiết trong năm",
  },
  {
    word: "ngày tháng",
    part_of_speech: "danh từ",
    meaning:
      "ngày và tháng; dùng để chỉ thời gian: ngày tháng thoi đưa * đọc sách cho qua ngày tháng",
    example: "ngày tháng thoi đưa * đọc sách cho qua ngày tháng",
  },
  {
    word: "ngày tháng",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian trong quá khứ không xác định, nhưng là nhiều ngày, nhiều tháng: trải qua những ngày tháng chiến tranh",
    example: "trải qua những ngày tháng chiến tranh",
  },
  {
    word: "ngày trước",
    part_of_speech: "danh từ",
    meaning:
      "thời gian đã qua, cách thời nay tương đối lâu: ngày trước, cảnh nhà rất túng bấn",
    example: "ngày trước, cảnh nhà rất túng bấn",
  },
  {
    word: "ngay râu",
    part_of_speech: "tính từ",
    meaning:
      "(thông tục) ngây mặt ra, không nói lại được (nói về người đàn ông): đứng ngay râu ra, không nói được câu gì",
    example: "đứng ngay râu ra, không nói được câu gì",
  },
  {
    word: "ngày sinh",
    part_of_speech: "danh từ",
    meaning:
      "ngày ra đời của một người: kỉ niệm 100 năm ngày sinh của Chủ tịch Hồ Chí Minh",
    example: "kỉ niệm 100 năm ngày sinh của Chủ tịch Hồ Chí Minh",
  },
  {
    word: "ngay thẳng",
    part_of_speech: "tính từ",
    meaning:
      "chân thật và thẳng thắn, không gian dối, không thiên vị: giữ được lòng ngay thẳng",
    example: "giữ được lòng ngay thẳng",
  },
  {
    word: "ngày rộng tháng dài",
    part_of_speech: "",
    meaning:
      "thời gian còn rộng rãi (nên được thong thả, không phải vội vàng): để ra giêng ngày rộng tháng dài thì đi",
    example: "để ra giêng ngày rộng tháng dài thì đi",
  },
  {
    word: "ngay thật",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ngay thẳng, thật thà, không dối trá: ăn ở ngay thật * trả lời ngay thật",
    example: "ăn ở ngay thật * trả lời ngay thật",
  },
  {
    word: "ngay tức thì",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ, hiếm) như tức thì (nhưng nghĩa mạnh hơn): đi ngay tức thì",
    example: "đi ngay tức thì",
  },
  {
    word: "ngay tức khắc",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) như tức khắc (nhưng nghĩa mạnh hơn): làm ngay tức khắc",
    example: "làm ngay tức khắc",
  },
  {
    word: "ngày xưa",
    part_of_speech: "danh từ",
    meaning: "thời gian đã qua, cách thời nay rất lâu: chuyện ngày xưa",
    example: "chuyện ngày xưa",
  },
  {
    word: "ngăm",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) đe, doạ: mẹ đánh một trăm, không bằng cha ngăm một tiếng (tng)",
    example: "mẹ đánh một trăm, không bằng cha ngăm một tiếng (tng)",
  },
  {
    word: "ngăm",
    part_of_speech: "tính từ",
    meaning: "(nước da) hơi đen: nước da ngăm đen",
    example: "nước da ngăm đen",
  },
  {
    word: "ngắc nga ngắc ngứ",
    part_of_speech: "động từ",
    meaning: "ngắc ngứ nhiều và liên tiếp: đọc ngắc nga ngắc ngứ",
    example: "đọc ngắc nga ngắc ngứ",
  },
  {
    word: "ngắc ngoải",
    part_of_speech: "động từ",
    meaning: "ở tình trạng sống thoi thóp, chỉ còn chờ chết: sống ngắc ngoải",
    example: "sống ngắc ngoải",
  },
  {
    word: "ngắc ngứ",
    part_of_speech: "động từ",
    meaning:
      "dừng lại nhiều lần ở nhiều chỗ trong khi nói, đọc: trả lời ngắc ngứ",
    example: "trả lời ngắc ngứ",
  },
  {
    word: "ngắm",
    part_of_speech: "động từ",
    meaning:
      "nhìn lâu, nhìn kĩ cho thoả lòng yêu thích: ngắm phong cảnh * ngắm trăng * “Nghe càng đắm, ngắm càng say, Lạ cho mặt sắt cũng ngây vì tình!” (TKiều)",
    example:
      "ngắm phong cảnh * ngắm trăng * “Nghe càng đắm, ngắm càng say, Lạ cho mặt sắt cũng ngây vì tình!” (TKiều)",
  },
  {
    word: "ngắm",
    part_of_speech: "động từ",
    meaning:
      "nhìn kĩ theo một hướng nhất định để nhắm trúng mục tiêu (thường nheo một bên mắt): mục tiêu đã lọt vào tầm ngắm * ngắm kĩ rồi mới bắn",
    example: "mục tiêu đã lọt vào tầm ngắm * ngắm kĩ rồi mới bắn",
  },
  {
    word: "ngắc",
    part_of_speech: "động từ",
    meaning:
      "dừng lại đột ngột giữa chừng vì bị vướng, bị cản lại: đang nói thì bị ngắc giữa chừng",
    example: "đang nói thì bị ngắc giữa chừng",
  },
  {
    word: "ngăm ngăm",
    part_of_speech: "tính từ",
    meaning:
      'hơi ngăm đen: "Mình đen ta cũng ngăm ngăm, Mẹ ta thách cưới một trăm quan tiền." (ca dao)',
    example:
      'Mình đen ta cũng ngăm ngăm, Mẹ ta thách cưới một trăm quan tiền." (ca dao)',
  },
  {
    word: "ngăm ngăm",
    part_of_speech: "tính từ",
    meaning:
      "ở mức độ hơi hơi, không rõ lắm: ngăm ngăm đau bụng * ngăm ngăm đắng",
    example: "ngăm ngăm đau bụng * ngăm ngăm đắng",
  },
  {
    word: "ngắm vuốt",
    part_of_speech: "động từ",
    meaning:
      "ngắm mình trong gương để chải chuốt, trang điểm (nói khái quát): con gái ưa ngắm vuốt",
    example: "con gái ưa ngắm vuốt",
  },
  {
    word: "ngăn cấm",
    part_of_speech: "động từ",
    meaning:
      "cấm, không cho phép làm việc gì đó (nói khái quát): ngăn cấm trẻ em hút thuốc",
    example: "ngăn cấm trẻ em hút thuốc",
  },
  {
    word: "ngăn cản",
    part_of_speech: "động từ",
    meaning:
      "gây trở ngại không cho tiếp tục hoạt động, phát triển nữa (nói khái quát): ngăn cản không cho làm bậy",
    example: "ngăn cản không cho làm bậy",
  },
  {
    word: "ngăn cách",
    part_of_speech: "động từ",
    meaning:
      "ngăn ra, cho không còn thông liền nhau nữa: giữa hai nhà có bức tường rào ngăn cách",
    example: "giữa hai nhà có bức tường rào ngăn cách",
  },
  {
    word: "ngắn",
    part_of_speech: "tính từ",
    meaning:
      "có chiều dài dưới mức bình thường, hoặc không bằng so với những vật khác: khẩu súng ngắn * quần may hơi ngắn * ngắn tay với chẳng tới trời (tng)",
    example:
      "khẩu súng ngắn * quần may hơi ngắn * ngắn tay với chẳng tới trời (tng)",
  },
  {
    word: "ngắn",
    part_of_speech: "tính từ",
    meaning:
      "(hiện tượng, sự việc) chiếm ít thời gian hơn so với mức bình thường, hoặc ít hơn những hiện tượng, sự việc khác: mẩu chuyện ngắn * cho vay ngắn hạn * cây công nghiệp ngắn ngày",
    example: "mẩu chuyện ngắn * cho vay ngắn hạn * cây công nghiệp ngắn ngày",
  },
  {
    word: "ngăn",
    part_of_speech: "danh từ",
    meaning:
      "khoảng, ô được chia tách ra trong lòng một vật nào đó: tủ có ba ngăn * ngăn bàn * ngăn cặp",
    example: "tủ có ba ngăn * ngăn bàn * ngăn cặp",
  },
  {
    word: "ngăn",
    part_of_speech: "động từ",
    meaning:
      "chia thành ngăn bằng vật che chắn: căn phòng được ngăn làm hai * ngăn vườn thành từng ô",
    example: "căn phòng được ngăn làm hai * ngăn vườn thành từng ô",
  },
  {
    word: "ngăn",
    part_of_speech: "động từ",
    meaning:
      "chặn lại, giữ lại không cho vượt qua, không cho tiếp tục hoạt động: đắp bờ ngăn nước * dựng rào ngăn lối đi * đã quyết thì không ai ngăn nổi",
    example:
      "đắp bờ ngăn nước * dựng rào ngăn lối đi * đã quyết thì không ai ngăn nổi",
  },
  {
    word: "ngắn gọn",
    part_of_speech: "tính từ",
    meaning:
      "không nhiều lời mà vẫn đủ ý: nói ngắn gọn * trả lời một cách ngắn gọn * lời bình ngắn gọn, súc tích",
    example:
      "nói ngắn gọn * trả lời một cách ngắn gọn * lời bình ngắn gọn, súc tích",
  },
  {
    word: "ngắm nghía",
    part_of_speech: "động từ",
    meaning:
      "ngắm đi ngắm lại một cách chăm chú, kĩ càng (thường là thích thú): ngắm nghía mình trước gương",
    example: "ngắm nghía mình trước gương",
  },
  {
    word: "ngắn hạn",
    part_of_speech: "tính từ",
    meaning:
      "có thời hạn tương đối ngắn; phân biệt với dài hạn, trung hạn: vay ngắn hạn * khoá huấn luyện ngắn hạn",
    example: "vay ngắn hạn * khoá huấn luyện ngắn hạn",
  },
  {
    word: "ngăn chặn",
    part_of_speech: "động từ",
    meaning:
      "chặn lại ngay từ đầu, không để cho gây tác hại (nói khái quát): tìm biện pháp ngăn chặn dịch bệnh * ngăn chặn nạn đua xe trái phép",
    example:
      "tìm biện pháp ngăn chặn dịch bệnh * ngăn chặn nạn đua xe trái phép",
  },
  {
    word: "ngăn kéo",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận hình hộp có thể kéo ra đẩy vào bên trong bàn, tủ, v.v.: tủ có nhiều ngăn kéo",
    example: "tủ có nhiều ngăn kéo",
  },
  {
    word: "ngăn ngừa",
    part_of_speech: "động từ",
    meaning:
      "ngừa trước, không để cho xảy ra cái xấu, cái không hay (nói khát quát): tích cực tiêm phòng để ngăn ngừa dịch bệnh",
    example: "tích cực tiêm phòng để ngăn ngừa dịch bệnh",
  },
  {
    word: "ngăn ngắt",
    part_of_speech: "phụ từ",
    meaning:
      "như ngắt (nhưng ý mức độ nhiều hơn): lạnh ngăn ngắt * lúa chiêm xanh ngăn ngắt",
    example: "lạnh ngăn ngắt * lúa chiêm xanh ngăn ngắt",
  },
  {
    word: "ngăn ngắn",
    part_of_speech: "tính từ",
    meaning: "hơi ngắn: mái tóc ngăn ngắn",
    example: "mái tóc ngăn ngắn",
  },
  {
    word: "ngắn ngủi",
    part_of_speech: "tính từ",
    meaning:
      'quá ngắn, quá ít so với mong muốn, yêu cầu: buông một câu ngắn ngủi * "Trăm nghìn gửi lại tình quân, Tơ duyên ngắn ngủi có ngần ấy thôi." (TKiều)',
    example:
      'buông một câu ngắn ngủi * "Trăm nghìn gửi lại tình quân, Tơ duyên ngắn ngủi có ngần ấy thôi." (TKiều)',
  },
  {
    word: "ngăn trở",
    part_of_speech: "động từ",
    meaning:
      "gây trở ngại, làm cho gặp khó khăn: ngăn trở công việc của người khác",
    example: "ngăn trở công việc của người khác",
  },
  {
    word: "ngằn ngặt",
    part_of_speech: "tính từ",
    meaning:
      "(khóc) không thành tiếng và kéo dài từng cơn rồi lặng đi, nghe như bị nghẹt hơi (thường của trẻ con): đứa bé khóc ngằn ngặt",
    example: "đứa bé khóc ngằn ngặt",
  },
  {
    word: "ngắn ngủn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) quá ngắn, trông giống như bị hụt, bị cụt đi: chiếc áo ngắn ngủn * tóc cắt ngắn ngủn",
    example: "chiếc áo ngắn ngủn * tóc cắt ngắn ngủn",
  },
  {
    word: "ngắn tun hủn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) quá ngắn, đến mức không bình thường (hàm ý chê): ngón tay mập và ngắn tun hủn * cái váy ngắn tun hủn",
    example: "ngón tay mập và ngắn tun hủn * cái váy ngắn tun hủn",
  },
  {
    word: "ngăn nắp",
    part_of_speech: "tính từ",
    meaning: "(xếp đặt) có thứ tự, gọn gàng, đâu ra đấy: nhà cửa ngăn nắp",
    example: "nhà cửa ngăn nắp",
  },
  {
    word: "ngẳng",
    part_of_speech: "tính từ",
    meaning: "gầy đến mức trông như dài hẳn ra, mất cân đối: người cao ngẳng",
    example: "người cao ngẳng",
  },
  {
    word: "ngặt một nỗi",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị điều sắp nói là nỗi khó khăn, gây cản trở cho việc thực hiện điều vừa nói đến trước đó: muốn mua nhưng ngặt một nỗi không đủ tiền",
    example: "muốn mua nhưng ngặt một nỗi không đủ tiền",
  },
  {
    word: "ngặt",
    part_of_speech: "tính từ",
    meaning:
      "chặt chẽ, không một chút sơ hở, lỏng lẻo: kiểm soát rất ngặt * cấm ngặt không cho đến",
    example: "kiểm soát rất ngặt * cấm ngặt không cho đến",
  },
  {
    word: "ngặt",
    part_of_speech: "tính từ",
    meaning:
      "khó khăn đến mức như không có lối thoát: tình thế rất ngặt  * muốn đi nhưng ngặt đường sá xa xôi",
    example: "tình thế rất ngặt  * muốn đi nhưng ngặt đường sá xa xôi",
  },
  {
    word: "ngắt",
    part_of_speech: "động từ",
    meaning:
      "bấm cành, hoa, lá cho đứt lìa ra bằng móng tay hoặc đầu ngón tay: ngắt một bông hoa",
    example: "ngắt một bông hoa",
  },
  {
    word: "ngắt",
    part_of_speech: "động từ",
    meaning:
      "làm cho bị đứt quãng, không còn liên tục: ngắt lời bạn * ngắt ngang câu chuyện * ngắt mạch điện",
    example: "ngắt lời bạn * ngắt ngang câu chuyện * ngắt mạch điện",
  },
  {
    word: "ngắt",
    part_of_speech: "phụ từ",
    meaning:
      "đến mức độ cao và thuần một màu, một vị hay một tính chất, thường gợi cảm giác không ưa thích: bầu trời xanh ngắt * mồm miệng đắng ngắt * câu chuyện tẻ ngắt",
    example: "bầu trời xanh ngắt * mồm miệng đắng ngắt * câu chuyện tẻ ngắt",
  },
  {
    word: "ngặt nghèo",
    part_of_speech: "tính từ",
    meaning:
      "quá ngặt, đến mức gây khó khăn, khó chịu: quy định ngặt nghèo * bị vây lùng ngặt nghèo",
    example: "quy định ngặt nghèo * bị vây lùng ngặt nghèo",
  },
  {
    word: "ngặt nghèo",
    part_of_speech: "tính từ",
    meaning:
      "khó khăn hay nguy hiểm đến mức khó mà vượt qua: tình thế ngặt nghèo * bệnh đã đến lúc ngặt nghèo",
    example: "tình thế ngặt nghèo * bệnh đã đến lúc ngặt nghèo",
  },
  {
    word: "ngẳng nghiu",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như khẳng khiu: cành cây ngẳng nghiu * người ngẳng nghiu",
    example: "cành cây ngẳng nghiu * người ngẳng nghiu",
  },
  {
    word: "ngẵng",
    part_of_speech: "tính từ",
    meaning: "hẹp lại ở khoảng giữa: thắt ngẵng cổ bồng",
    example: "thắt ngẵng cổ bồng",
  },
  {
    word: "ngặt nghẽo",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả cách cười (đôi khi cách khóc) nghiêng ngả cả người, có lúc như đứt hơi không thành tiếng mà không sao nín nhịn được: cười ngặt nghẽo * khóc ngặt nghẽo",
    example: "cười ngặt nghẽo * khóc ngặt nghẽo",
  },
  {
    word: "ngắt quãng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) ở tình trạng ngắt ra thành từng quãng, từng đoạn một, không liền nhau, không liên tục: giọng nói yếu ớt và ngắt quãng * tiếng súng bắn ngắt quãng",
    example: "giọng nói yếu ớt và ngắt quãng * tiếng súng bắn ngắt quãng",
  },
  {
    word: "ngâm",
    part_of_speech: "động từ",
    meaning:
      "đọc thơ với giọng ngân nga, diễn cảm không theo một khuôn nhịp cố định: ngâm một bài thơ",
    example: "ngâm một bài thơ",
  },
  {
    word: "ngâm",
    part_of_speech: "động từ",
    meaning:
      "dìm lâu trong chất lỏng để cho thấm, cho tác động vào: ngâm gạo thổi xôi * rượu ngâm thuốc bắc * ngâm mình trong nước",
    example: "ngâm gạo thổi xôi * rượu ngâm thuốc bắc * ngâm mình trong nước",
  },
  {
    word: "ngâm",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) để rất lâu không xem xét, giải quyết: vụ việc bị ngâm mãi chưa được giải quyết",
    example: "vụ việc bị ngâm mãi chưa được giải quyết",
  },
  {
    word: "ngầm",
    part_of_speech: "tính từ",
    meaning:
      "ở sâu bên trong, bên dưới, không trông thấy: hầm ngầm * đường ngầm xuyên qua núi * nước chảy ngầm trong lòng đất",
    example:
      "hầm ngầm * đường ngầm xuyên qua núi * nước chảy ngầm trong lòng đất",
  },
  {
    word: "ngầm",
    part_of_speech: "tính từ",
    meaning:
      "kín đáo, không cho người ngoài biết: ngầm giúp đỡ bạn * ngầm hiểu với nhau * ngầm theo dõi",
    example: "ngầm giúp đỡ bạn * ngầm hiểu với nhau * ngầm theo dõi",
  },
  {
    word: "ngầm",
    part_of_speech: "danh từ",
    meaning:
      "đoạn đường làm ngầm dưới nước để cho xe vượt qua suối (thường là trong chiến tranh): xe qua ngầm",
    example: "xe qua ngầm",
  },
  {
    word: "ngậm",
    part_of_speech: "động từ",
    meaning: "giữ cho miệng ở trạng thái khép kín: miệng há ra, ngậm lại",
    example: "miệng há ra, ngậm lại",
  },
  {
    word: "ngậm",
    part_of_speech: "động từ",
    meaning:
      "giữ (vật gì) ở miệng hoặc trong miệng: miệng ngậm tăm * chim ngậm mồi * ngậm máu phun người (tng)",
    example: "miệng ngậm tăm * chim ngậm mồi * ngậm máu phun người (tng)",
  },
  {
    word: "ngậm",
    part_of_speech: "động từ",
    meaning:
      'nén chịu ở trong lòng, không nói ra được: ngậm hờn nơi chín suối * "Ông tơ lật lọng lừa nhau, Cực thân nên phải ngậm sầu bước ra." (HT)',
    example:
      'ngậm hờn nơi chín suối * "Ông tơ lật lọng lừa nhau, Cực thân nên phải ngậm sầu bước ra." (HT)',
  },
  {
    word: "ngẫm",
    part_of_speech: "động từ",
    meaning:
      "nghĩ đi nghĩ lại kĩ càng để đưa ra sự đánh giá, kết luận: ngẫm sự đời * càng ngẫm càng thấy hay",
    example: "ngẫm sự đời * càng ngẫm càng thấy hay",
  },
  {
    word: "ngấm",
    part_of_speech: "động từ",
    meaning:
      "thấm hoàn toàn một chất lỏng nào đó do đã được ngâm lâu, hoặc đã chịu đầy đủ tác động của nó: chè pha chưa ngấm * bị ngấm nước mưa",
    example: "chè pha chưa ngấm * bị ngấm nước mưa",
  },
  {
    word: "ngấm",
    part_of_speech: "động từ",
    meaning:
      "đã dần dần chịu một tác dụng nào đó đến mức thấy rõ: ngấm men say * chất độc ngấm vào cơ thể * thói quen đó đã ngấm vào máu thịt",
    example:
      "ngấm men say * chất độc ngấm vào cơ thể * thói quen đó đã ngấm vào máu thịt",
  },
  {
    word: "ngầm ẩn",
    part_of_speech: "tính từ",
    meaning:
      "ẩn chứa bên trong, không lộ rõ ra: dịch bệnh vẫn ngầm ẩn nguy cơ bùng phát * câu nói ngầm ẩn sự đe doạ",
    example:
      "dịch bệnh vẫn ngầm ẩn nguy cơ bùng phát * câu nói ngầm ẩn sự đe doạ",
  },
  {
    word: "ngấc",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) ngước, ngẩng: ngấc mặt lên",
    example: "ngấc mặt lên",
  },
  {
    word: "ngậm đắng nuốt cay",
    part_of_speech: "",
    meaning:
      'phải nhẫn nhục chịu đựng điều cay đắng mà không nói ra được: "Rằng: Hay thì thật là hay, Nghe ra ngậm đắng nuốt cay thế nào!" (TKiều)',
    example:
      'Rằng: Hay thì thật là hay, Nghe ra ngậm đắng nuốt cay thế nào!" (TKiều)',
  },
  {
    word: "ngậm hột thị",
    part_of_speech: "",
    meaning:
      "ấp úng, nói không thành tiếng, không nên lời, thường vì lúng túng hay sợ hãi: lúng búng như ngậm hột thị",
    example: "lúng búng như ngậm hột thị",
  },
  {
    word: "ngâm ngẩm",
    part_of_speech: "tính từ",
    meaning: "như lâm râm: ngâm ngẩm đau bụng",
    example: "ngâm ngẩm đau bụng",
  },
  {
    word: "ngấm ngầm",
    part_of_speech: "tính từ",
    meaning:
      "(làm việc gì) kín đáo, không để có những biểu hiện cho người ngoài có thể thấy được: ghen tức ngấm ngầm * ngấm ngầm chia rẽ nội bộ",
    example: "ghen tức ngấm ngầm * ngấm ngầm chia rẽ nội bộ",
  },
  {
    word: "ngậm miệng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) im lặng, không nói năng gì: đuối lí nên đành ngậm miệng",
    example: "đuối lí nên đành ngậm miệng",
  },
  {
    word: "ngẫm nghĩ",
    part_of_speech: "động từ",
    meaning:
      "nghĩ rất kĩ và sâu: ngẫm nghĩ sự đời * ngẫm nghĩ một lúc mới trả lời",
    example: "ngẫm nghĩ sự đời * ngẫm nghĩ một lúc mới trả lời",
  },
  {
    word: "ngấm nguẩy",
    part_of_speech: "động từ",
    meaning: "(hiếm) như ngúng nguẩy: con bé còn ngấm nguẩy chưa chịu",
    example: "con bé còn ngấm nguẩy chưa chịu",
  },
  {
    word: "ngâm ngợi",
    part_of_speech: "động từ",
    meaning:
      '(hiếm) như ngâm vịnh: "Khi khoé hạnh, khi nét ngài, Khi ngâm ngợi nguyệt, khi cười cợt hoa." (TKiều)',
    example:
      'Khi khoé hạnh, khi nét ngài, Khi ngâm ngợi nguyệt, khi cười cợt hoa." (TKiều)',
  },
  {
    word: "ngâm nga",
    part_of_speech: "động từ",
    meaning:
      "vừa ngâm vừa tỏ vẻ khề khà như để tự thưởng thức, để thoả mãn ý thích (nói khái quát): ngâm nga mấy câu Kiều * giọng đọc ngâm nga",
    example: "ngâm nga mấy câu Kiều * giọng đọc ngâm nga",
  },
  {
    word: "ngấm nguýt",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) lườm nguýt tỏ vẻ khó chịu hoặc ghen tức, hậm hực: ra vào ngấm nguýt",
    example: "ra vào ngấm nguýt",
  },
  {
    word: "ngẫm ngợi",
    part_of_speech: "động từ",
    meaning:
      "suy nghĩ kĩ và sâu sắc để đánh giá, kết luận: ngẫm ngợi mới hiểu ra được",
    example: "ngẫm ngợi mới hiểu ra được",
  },
  {
    word: "ngậm sữa",
    part_of_speech: "tính từ",
    meaning:
      "(lúa) mới trổ thành bông, hạt bắt đầu có chất đặc màu trắng đục: lúa đã ngậm sữa",
    example: "lúa đã ngậm sữa",
  },
  {
    word: "ngậm ngùi",
    part_of_speech: "động từ",
    meaning:
      'buồn và thương xót một cách âm thầm, lặng lẽ: "Động phòng dìu dặt chén mồi, Bâng khuâng duyên mới, ngậm ngùi tình xưa." (TKiều)',
    example:
      'Động phòng dìu dặt chén mồi, Bâng khuâng duyên mới, ngậm ngùi tình xưa." (TKiều)',
  },
  {
    word: "ngậm tăm",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) im lặng tuyệt đối, không há miệng nói một lời: biết mà đành phải ngậm tăm",
    example: "biết mà đành phải ngậm tăm",
  },
  {
    word: "ngâm vịnh",
    part_of_speech: "động từ",
    meaning:
      "làm thơ và ngâm thơ để thưởng thức hoặc để biểu lộ tâm trạng (nói khái quát): thú tiêu dao ngâm vịnh",
    example: "thú tiêu dao ngâm vịnh",
  },
  {
    word: "ngâm tôm",
    part_of_speech: "động từ",
    meaning:
      "trói cong người lại như con tôm rồi đem dìm xuống nước (một nhục hình thời phong kiến).",
    example: "vụ việc để ngâm tôm mấy năm trời",
  },
  {
    word: "ngần",
    part_of_speech: "danh từ",
    meaning:
      'số lượng, mức độ đại khái đã được xác định rõ ràng và được coi là nhiều hay ít tuỳ theo cách nhìn chủ quan: ngần này tiền thì hơi ít * "Trăm nghìn gửi lại tình quân, Tơ duyên ngắn ngủi có ngần ấy thôi." (TKiều)',
    example:
      'ngần này tiền thì hơi ít * "Trăm nghìn gửi lại tình quân, Tơ duyên ngắn ngủi có ngần ấy thôi." (TKiều)',
  },
  {
    word: "ngẩn",
    part_of_speech: "tính từ",
    meaning:
      "ngây người ra do tinh thần bị tác động mạnh và đột ngột: sướng quá, ngẩn cả người * ngồi ngẩn ra không trả lời được",
    example: "sướng quá, ngẩn cả người * ngồi ngẩn ra không trả lời được",
  },
  {
    word: "ngân hà",
    part_of_speech: "danh từ",
    meaning:
      "thiên hà hình xoắn ốc, trong đó có Hệ Mặt Trời, mà ta nhìn thấy như một dải sáng màu trắng nhờ vắt ngang bầu trời ban đêm: dải ngân hà",
    example: "dải ngân hà",
  },
  {
    word: "ngân",
    part_of_speech: "danh từ",
    meaning:
      "tiền do cơ quan nghiệp vụ thu vào hay phát ra: quầy thu ngân * giấy chuyển ngân * các hình thức giải ngân",
    example: "quầy thu ngân * giấy chuyển ngân * các hình thức giải ngân",
  },
  {
    word: "ngân",
    part_of_speech: "động từ",
    meaning:
      "(âm thanh) kéo dài và vang xa: chuông nhà thờ ngân vang * tiếng hát ngân lên",
    example: "chuông nhà thờ ngân vang * tiếng hát ngân lên",
  },
  {
    word: "ngấn",
    part_of_speech: "danh từ",
    meaning:
      "dấu vết còn để lại thành đường nét của chất lỏng đã rút, đã cạn: ngấn nước chè trong chén * nước rút còn lại ngấn trên tường",
    example: "ngấn nước chè trong chén * nước rút còn lại ngấn trên tường",
  },
  {
    word: "ngấn",
    part_of_speech: "danh từ",
    meaning: "nếp gấp trên da người không phải người già: cổ cao ba ngấn",
    example: "cổ cao ba ngấn",
  },
  {
    word: "ngấn",
    part_of_speech: "động từ",
    meaning:
      "in, đọng lại thành ngấn: mắt ngấn lệ * những vết nhăn ngấn sâu trên trán",
    example: "mắt ngấn lệ * những vết nhăn ngấn sâu trên trán",
  },
  {
    word: "ngân khố",
    part_of_speech: "danh từ",
    meaning: "kho tiền của nhà nước: ngân khố quốc gia",
    example: "ngân khố quốc gia",
  },
  {
    word: "ngân khố",
    part_of_speech: "danh từ",
    meaning: "(cũ) kho bạc: đến ngân khố nộp tiền",
    example: "đến ngân khố nộp tiền",
  },
  {
    word: "ngân hàng",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức kinh tế hoạt động trong lĩnh vực kinh doanh và quản lí các nghiệp vụ về tiền tệ, tín dụng: chuyển tiền qua ngân hàng * vay vốn của ngân hàng để làm ăn",
    example: "chuyển tiền qua ngân hàng * vay vốn của ngân hàng để làm ăn",
  },
  {
    word: "ngân hàng",
    part_of_speech: "danh từ",
    meaning:
      "kho lưu trữ những thành phần, bộ phận của cơ thể để sử dụng khi cần: ngân hàng máu",
    example: "ngân hàng máu",
  },
  {
    word: "ngân hàng dữ liệu",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp dữ liệu liên quan tới một hay nhiều lĩnh vực, được tổ chức theo những cách thức nhất định để có thể khai thác và sử dụng dễ dàng khi cần: xây dựng ngân hàng dữ liệu tiếng Việt",
    example: "xây dựng ngân hàng dữ liệu tiếng Việt",
  },
  {
    word: "ngân nga",
    part_of_speech: "động từ",
    meaning:
      "(âm thanh) ngân như kéo dài mãi: tiếng chuông ngân nga * giọng nói ngân nga như hát",
    example: "tiếng chuông ngân nga * giọng nói ngân nga như hát",
  },
  {
    word: "ngần ngại",
    part_of_speech: "động từ",
    meaning:
      "tỏ ra có điều e ngại, nên còn đắn đo chưa dám: còn ngần ngại nên chưa dám nói",
    example: "còn ngần ngại nên chưa dám nói",
  },
  {
    word: "ngần ngừ",
    part_of_speech: "động từ",
    meaning:
      "còn suy tính, lưỡng lự, chưa dứt khoát trong hành động: ngần ngừ một lúc mới dám vào * còn ngần ngừ chưa dám nói",
    example: "ngần ngừ một lúc mới dám vào * còn ngần ngừ chưa dám nói",
  },
  {
    word: "ngân ngấn",
    part_of_speech: "tính từ",
    meaning:
      "(nước mắt) ứa ra và đọng nhiều quanh khoé mắt: ngân ngấn nước mắt",
    example: "ngân ngấn nước mắt",
  },
  {
    word: "ngân ngất",
    part_of_speech: "tính từ",
    meaning: "như ngất (nhưng ý mức độ ít hơn): non cao ngân ngất",
    example: "non cao ngân ngất",
  },
  {
    word: "ngẩn ngơ",
    part_of_speech: "tính từ",
    meaning:
      'thẫn thờ như không còn chú ý gì đến xung quanh, vì tâm trí đang để ở đâu đâu: đứng ngẩn ngơ nhìn theo * "Từ phen đá biết tuổi vàng, Tình càng thấm thía, dạ càng ngẩn ngơ." (TKiều)',
    example:
      'đứng ngẩn ngơ nhìn theo * "Từ phen đá biết tuổi vàng, Tình càng thấm thía, dạ càng ngẩn ngơ." (TKiều)',
  },
  {
    word: "ngẩn ngơ",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) ngu ngơ, khờ khạo: đồ ngẩn ngơ!",
    example: "đồ ngẩn ngơ!",
  },
  {
    word: "ngân phiếu",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) phiếu có ghi số tiền, dùng làm căn cứ nhận tiền tại ngân hàng hoặc nhận tiền gửi qua bưu điện.",
    example:
      "tờ ngân phiếu có mệnh giá 5 triệu đồng * thanh toán bằng ngân phiếu",
  },
  {
    word: "ngập",
    part_of_speech: "động từ",
    meaning:
      "(chất lỏng) tràn lên và phủ kín hoàn toàn: nước dâng ngập đường * đê vỡ làm ngập nhà cửa * đổ cho nước ngập gạo",
    example:
      "nước dâng ngập đường * đê vỡ làm ngập nhà cửa * đổ cho nước ngập gạo",
  },
  {
    word: "ngập",
    part_of_speech: "động từ",
    meaning:
      "ở sâu dưới bề mặt một khối gì đó, bị phủ lấp hết hoặc gần hết: lưỡi dao ngập sâu vào thân cây * chân ngập dưới bùn",
    example: "lưỡi dao ngập sâu vào thân cây * chân ngập dưới bùn",
  },
  {
    word: "ngập",
    part_of_speech: "động từ",
    meaning:
      "có nhiều và khắp cả trên một diện tích, đến mức như bao phủ, che lấp tất cả: cánh đồng ngập cỏ * công việc ngập đầu",
    example: "cánh đồng ngập cỏ * công việc ngập đầu",
  },
  {
    word: "ngẩn tò te",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) ngẩn người ra, ngơ ngác: nghe xong, mặt ngẩn tò te * đứng ngẩn tò te",
    example: "nghe xong, mặt ngẩn tò te * đứng ngẩn tò te",
  },
  {
    word: "ngân sách",
    part_of_speech: "danh từ",
    meaning:
      "tổng số tiền thu và chi trong một thời gian nhất định của nhà nước, của xí nghiệp hoặc của một cá nhân: ngân sách nhà nước * bội chi ngân sách",
    example: "ngân sách nhà nước * bội chi ngân sách",
  },
  {
    word: "ngân quỹ",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) quỹ tiền của nhà nước hay của một tổ chức, đoàn thể: ngân quỹ nhà nước * đầu tư cho ngân quỹ giáo dục",
    example: "ngân quỹ nhà nước * đầu tư cho ngân quỹ giáo dục",
  },
  {
    word: "ngân vang",
    part_of_speech: "động từ",
    meaning:
      "(âm thanh) ngân xa mãi và âm vang như kéo dài không dứt: giọng hò ngân vang",
    example: "giọng hò ngân vang",
  },
  {
    word: "ngẩng",
    part_of_speech: "động từ",
    meaning:
      "hướng đầu, hướng mặt lên phía trên: ngẩng mặt lên nhìn * ngẩng cao đầu",
    example: "ngẩng mặt lên nhìn * ngẩng cao đầu",
  },
  {
    word: "ngập đầu",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) quá nhiều việc phải lo liệu, gánh vác: nợ ngập đầu * công việc ngập đầu",
    example: "nợ ngập đầu * công việc ngập đầu",
  },
  {
    word: "ngập chìm",
    part_of_speech: "động từ",
    meaning: "như chìm ngập: bản làng ngập chìm trong sương trắng",
    example: "bản làng ngập chìm trong sương trắng",
  },
  {
    word: "ngập mặn",
    part_of_speech: "tính từ",
    meaning:
      "(vùng đất) thường bị ngập trong nước mặn: rừng ngập mặn * nuôi tôm sú ở vùng ngập mặn",
    example: "rừng ngập mặn * nuôi tôm sú ở vùng ngập mặn",
  },
  {
    word: "ngập lụt",
    part_of_speech: "động từ",
    meaning: "ngập do lũ lụt (nói khái quát): vùng ngập lụt",
    example: "vùng ngập lụt",
  },
  {
    word: "ngấp nghé",
    part_of_speech: "động từ",
    meaning: "(hiếm) như mấp mé: nước ngấp nghé mặt đê * tuổi ngấp nghé 80",
    example: "nước ngấp nghé mặt đê * tuổi ngấp nghé 80",
  },
  {
    word: "ngấp nghé",
    part_of_speech: "động từ",
    meaning:
      "đến gần nhìn vào một cách kín đáo, rồi lại lùi ra, muốn vào mà chưa dám: đứng ngấp nghé ngoài cổng",
    example: "đứng ngấp nghé ngoài cổng",
  },
  {
    word: "ngấp nghé",
    part_of_speech: "động từ",
    meaning:
      "để ý tới người con gái nào đó với ý muốn làm quen để đặt quan hệ yêu đương, nhưng còn ngại ngùng: được nhiều chàng trai ngấp nghé",
    example: "được nhiều chàng trai ngấp nghé",
  },
  {
    word: "ngập úng",
    part_of_speech: "động từ",
    meaning: "ngập lâu nên bị úng: ruộng trũng nên thường xuyên bị ngập úng",
    example: "ruộng trũng nên thường xuyên bị ngập úng",
  },
  {
    word: "ngập tràn",
    part_of_speech: "động từ",
    meaning:
      "như tràn ngập: lòng ngập tràn hạnh phúc * không gian ngập tràn hương hoa sữa",
    example: "lòng ngập tràn hạnh phúc * không gian ngập tràn hương hoa sữa",
  },
  {
    word: "ngập ngụa",
    part_of_speech: "tính từ",
    meaning:
      "đầy rẫy, tràn ngập (thường là những thứ bẩn thỉu): đường sá ngập ngụa bùn đất",
    example: "đường sá ngập ngụa bùn đất",
  },
  {
    word: "ngất",
    part_of_speech: "động từ",
    meaning:
      "bị bất tỉnh đột ngột, tim ngừng đập, phổi ngừng thở trong thời gian ngắn, vì thiếu máu trong óc hoặc vì ức chế thần kinh quá mạnh: ngất đi vì sợ hãi",
    example: "ngất đi vì sợ hãi",
  },
  {
    word: "ngất",
    part_of_speech: "tính từ",
    meaning:
      'cao quá tầm mắt: cao ngất * "Ngày ngày em đứng em trông, Trông non, non ngất, trông sông, sông dài." (ca dao)',
    example:
      'cao ngất * "Ngày ngày em đứng em trông, Trông non, non ngất, trông sông, sông dài." (ca dao)',
  },
  {
    word: "ngập ngừng",
    part_of_speech: "động từ",
    meaning:
      "tỏ ra do dự, rụt rè, vừa muốn lại vừa e ngại, không quả quyết: bước chân ngập ngừng * ngập ngừng mãi mới dám hỏi",
    example: "bước chân ngập ngừng * ngập ngừng mãi mới dám hỏi",
  },
  {
    word: "ngật",
    part_of_speech: "động từ",
    meaning:
      "(đầu hoặc thứ đội trên đầu) ngả hẳn về một phía: chiếc nón bị gió thổi ngật ra đằng sau",
    example: "chiếc nón bị gió thổi ngật ra đằng sau",
  },
  {
    word: "ngất ngây",
    part_of_speech: "tính từ",
    meaning: "như ngây ngất (ng2): ngất ngây hạnh phúc",
    example: "ngất ngây hạnh phúc",
  },
  {
    word: "ngất ngưởng",
    part_of_speech: "tính từ",
    meaning:
      "ở thế không vững, lắc lư nghiêng ngả như chực ngã (thường do say quá): say rượu, bước đi ngất ngưởng",
    example: "say rượu, bước đi ngất ngưởng",
  },
  {
    word: "ngất ngưởng",
    part_of_speech: "tính từ",
    meaning:
      "quá cao và gây cảm giác không vững, dễ đổ: đứa trẻ ngồi ngất ngưởng trên mình trâu",
    example: "đứa trẻ ngồi ngất ngưởng trên mình trâu",
  },
  {
    word: "ngất trời",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) rất cao, tưởng như đụng tới trời: núi cao ngất trời * lửa cháy ngất trời * ăn diện ngất trời (diện lắm)",
    example:
      "núi cao ngất trời * lửa cháy ngất trời * ăn diện ngất trời (diện lắm)",
  },
  {
    word: "ngất ngư",
    part_of_speech: "tính từ",
    meaning:
      "ở thế lắc lư, nghiêng ngả như chực đổ: cười ngất ngư * say ngất ngư",
    example: "cười ngất ngư * say ngất ngư",
  },
  {
    word: "ngất nghểu",
    part_of_speech: "tính từ",
    meaning: "như ngất ngưởng: ngồi ngất nghểu trên nóc xe",
    example: "ngồi ngất nghểu trên nóc xe",
  },
  {
    word: "ngật ngưỡng",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả dáng đi, nghiêng ngả như chực ngã, chực đổ: say ngật ngưỡng * bước đi ngật ngưỡng",
    example: "say ngật ngưỡng * bước đi ngật ngưỡng",
  },
  {
    word: "ngâu",
    part_of_speech: "danh từ",
    meaning:
      "cây cùng họ với xoan, lá nhỏ, hoa lấm tấm từng chùm, màu vàng, có hương thơm, thường dùng để ướp chè: hoa ngâu",
    example: "hoa ngâu",
  },
  {
    word: "ngâu",
    part_of_speech: "tính từ",
    meaning:
      "(thời gian) có mưa ngâu: tháng ngâu (tháng 7 âm lịch) * tiết ngâu",
    example: "tháng ngâu (tháng 7 âm lịch) * tiết ngâu",
  },
  {
    word: "ngầu",
    part_of_speech: "tính từ",
    meaning:
      "(nước) có nhiều vẩn, nhiều tạp chất nổi lên: dòng nước phù sa ngầu đỏ",
    example: "dòng nước phù sa ngầu đỏ",
  },
  {
    word: "ngấu",
    part_of_speech: "tính từ",
    meaning:
      "(tương, mắm) đã ngấm kĩ muối và nhuyễn ra, đã có thể ăn được: tương chưa ngấu * mắm ngấu",
    example: "tương chưa ngấu * mắm ngấu",
  },
  {
    word: "ngấu",
    part_of_speech: "tính từ",
    meaning:
      "(phân, đất) đã thấm nước đều và nát nhuyễn: ải thâm hơn dầm ngấu (tng)",
    example: "ải thâm hơn dầm ngấu (tng)",
  },
  {
    word: "ngấu",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ngấu nghiến (nói tắt): đọc ngấu một lúc hết cả quyển sách dày * đói quá, ăn ngấu cả đĩa xôi",
    example:
      "đọc ngấu một lúc hết cả quyển sách dày * đói quá, ăn ngấu cả đĩa xôi",
  },
  {
    word: "ngẫu hứng",
    part_of_speech: "danh từ",
    meaning:
      "cảm hứng ngẫu nhiên mà có: ngẫu hứng sáng tác * làm theo ngẫu hứng",
    example: "ngẫu hứng sáng tác * làm theo ngẫu hứng",
  },
  {
    word: "ngẫu nhiên",
    part_of_speech: "tính từ",
    meaning:
      "tình cờ sinh ra, xảy ra chứ không phải do những nguyên nhân bên trong quyết định: chọn ngẫu nhiên * sự trùng hợp ngẫu nhiên",
    example: "chọn ngẫu nhiên * sự trùng hợp ngẫu nhiên",
  },
  {
    word: "ngây",
    part_of_speech: "tính từ",
    meaning:
      'đờ người ra, không còn biết nói năng, cử động gì: người ngây như khúc gỗ * đứng ngây ra, không biết làm gì * "Nghe càng đắm, ngắm càng say, Lạ cho mặt sắt cũng ngây vì tình!" (TKiều)',
    example:
      'người ngây như khúc gỗ * đứng ngây ra, không biết làm gì * "Nghe càng đắm, ngắm càng say, Lạ cho mặt sắt cũng ngây vì tình!" (TKiều)',
  },
  {
    word: "ngấu nghiến",
    part_of_speech: "tính từ",
    meaning:
      "rất nhanh và mải miết, chỉ cốt cho được nhiều trong thời gian ngắn nhất: ăn ngấu nghiến * đọc ngấu nghiến (đọc một cách mải miết và say sưa)",
    example:
      "ăn ngấu nghiến * đọc ngấu nghiến (đọc một cách mải miết và say sưa)",
  },
  {
    word: "ngậu",
    part_of_speech: "tính từ",
    meaning:
      "(thông tục) to tiếng một cách ầm ĩ, gây cảm giác khó chịu: gắt ngậu cả lên",
    example: "gắt ngậu cả lên",
  },
  {
    word: "ngậu xị",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) như ngậu (nhưng ý nhấn mạnh hơn): hơi một tí là ngậu xị lên!",
    example: "hơi một tí là ngậu xị lên!",
  },
  {
    word: "ngây dại",
    part_of_speech: "tính từ",
    meaning:
      "ngây ngô, dại dột, không biết gì: nét mặt ngây dại * nghĩ ngợi nhiều mà đâm ra ngây dại",
    example: "nét mặt ngây dại * nghĩ ngợi nhiều mà đâm ra ngây dại",
  },
  {
    word: "ngấy",
    part_of_speech: "động từ",
    meaning:
      "có cảm giác sợ đối với một loại thức ăn nào đó (thường là chất béo hay chất ngọt): món xào có nhiều mỡ nên ngấy * ăn nhiều đến phát ngấy",
    example: "món xào có nhiều mỡ nên ngấy * ăn nhiều đến phát ngấy",
  },
  {
    word: "ngấy",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) chán đến mức không chịu được (cái vốn không ưa): suốt ngày kêu ca, nghe đến phát ngấy",
    example: "suốt ngày kêu ca, nghe đến phát ngấy",
  },
  {
    word: "ngậy",
    part_of_speech: "tính từ",
    meaning:
      "(món ăn) béo và thơm, ngon: lạc ăn vừa ngậy vừa bùi * mùi cá nướng thơm ngậy",
    example: "lạc ăn vừa ngậy vừa bùi * mùi cá nướng thơm ngậy",
  },
  {
    word: "ngây ngất",
    part_of_speech: "tính từ",
    meaning:
      "cảm thấy hơi hoa mắt, chóng mặt, khó chịu: đi nắng, người thấy ngây ngất",
    example: "đi nắng, người thấy ngây ngất",
  },
  {
    word: "ngây ngất",
    part_of_speech: "tính từ",
    meaning:
      "có cảm giác như say, như mê đi vì được thoả mãn quá đầy đủ về tình cảm: hương thơm ngây ngất * tâm hồn ngây ngất",
    example: "hương thơm ngây ngất * tâm hồn ngây ngất",
  },
  {
    word: "ngây đờ",
    part_of_speech: "tính từ",
    meaning: "ngây ra, đờ ra như không còn phản ứng gì: mặt ngây đờ như vô cảm",
    example: "mặt ngây đờ như vô cảm",
  },
  {
    word: "ngầy",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) ngầy ngà (nói tắt): việc đó ngầy lắm!",
    example: "việc đó ngầy lắm!",
  },
  {
    word: "ngây ngô",
    part_of_speech: "tính từ",
    meaning:
      "kém tinh khôn hoặc kém hiểu biết đến mức như khờ dại: văn viết rất ngây ngô * vẻ mặt ngây ngô",
    example: "văn viết rất ngây ngô * vẻ mặt ngây ngô",
  },
  {
    word: "ngầy ngậy",
    part_of_speech: "tính từ",
    meaning: "hơi ngậy: món thịt bò xào ngầy ngậy",
    example: "món thịt bò xào ngầy ngậy",
  },
  {
    word: "ngây thơ",
    part_of_speech: "tính từ",
    meaning:
      "nhỏ dại và trong sáng, chưa hiểu biết và cũng chưa bị tác động bởi sự đời: đôi mắt ngây thơ * tâm hồn ngây thơ",
    example: "đôi mắt ngây thơ * tâm hồn ngây thơ",
  },
  {
    word: "ngây thơ",
    part_of_speech: "tính từ",
    meaning:
      "không hiểu biết hoặc rất ít hiểu biết về đời, do còn non trẻ, ít kinh nghiệm: ngây thơ về chính trị * tin một cách ngây thơ * ngây thơ trong cuộc sống",
    example:
      "ngây thơ về chính trị * tin một cách ngây thơ * ngây thơ trong cuộc sống",
  },
  {
    word: "ngấy sốt",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như gấy sốt: người hơi ngấy sốt",
    example: "người hơi ngấy sốt",
  },
  {
    word: "ngây ngấy",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như gây gấy: người ngây ngấy như lên cơn sốt",
    example: "người ngây ngấy như lên cơn sốt",
  },
  {
    word: "nghe",
    part_of_speech: "động từ",
    meaning:
      "nhận biết âm thanh bằng tai: nghe có tiếng động lạ * ồn quá, không nghe thấy gì * nặng tai nên khó nghe",
    example:
      "nghe có tiếng động lạ * ồn quá, không nghe thấy gì * nặng tai nên khó nghe",
  },
  {
    word: "nghe",
    part_of_speech: "động từ",
    meaning:
      "chú ý để có thể nghe thấy: nghe giảng * nghe kể chuyện * nghe nhạc",
    example: "nghe giảng * nghe kể chuyện * nghe nhạc",
  },
  {
    word: "nghe",
    part_of_speech: "động từ",
    meaning:
      "cho là đúng và làm theo lời: nghe lời cha mẹ * ai bảo cũng không nghe",
    example: "nghe lời cha mẹ * ai bảo cũng không nghe",
  },
  {
    word: "nghe",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) xuôi tai, có thể đồng ý, chấp nhận được: bản nhạc này nghe được * nói như thế mà nghe được à?",
    example: "bản nhạc này nghe được * nói như thế mà nghe được à?",
  },
  {
    word: "nghe",
    part_of_speech: "động từ",
    meaning:
      "có cảm giác thấy: nghe khó chịu trong người * tình hình nghe có vẻ khả quan",
    example: "nghe khó chịu trong người * tình hình nghe có vẻ khả quan",
  },
  {
    word: "nghe",
    part_of_speech: "trợ từ",
    meaning: "(Phương ngữ) nhé: nhớ à nghe! * chờ chút nghe! * con đi nghe má!",
    example: "nhớ à nghe! * chờ chút nghe! * con đi nghe má!",
  },
  {
    word: "nghe chừng",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị ý phỏng đoán một cách dè dặt, dựa trên những gì đã quan sát thấy hoặc đã cảm nhận được: tình hình nghe chừng rất căng * nghe chừng nó đã thuận",
    example: "tình hình nghe chừng rất căng * nghe chừng nó đã thuận",
  },
  {
    word: "nghe hơi nồi chõ",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) chỉ nghe qua lời đồn đại, không có gì chắc chắn: lão cũng chỉ nghe hơi nồi chõ, chứ chưa thực mục sở thị",
    example: "lão cũng chỉ nghe hơi nồi chõ, chứ chưa thực mục sở thị",
  },
  {
    word: "nghe lỏm",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) chú ý để nghe những điều người ta nói riêng với nhau: nghe lỏm chuyện của người khác",
    example: "nghe lỏm chuyện của người khác",
  },
  {
    word: "nghé",
    part_of_speech: "danh từ",
    meaning: "trâu con: cưa sừng làm nghé (tng)",
    example: "cưa sừng làm nghé (tng)",
  },
  {
    word: "nghé",
    part_of_speech: "động từ",
    meaning: "nghiêng mắt nhìn, không nhìn thẳng: nghé mắt nhòm qua khe cửa",
    example: "nghé mắt nhòm qua khe cửa",
  },
  {
    word: "nghe đâu",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) có nghe nhưng không đảm bảo là chắc chắn: nghe đâu ông ấy sắp được thăng chức",
    example: "nghe đâu ông ấy sắp được thăng chức",
  },
  {
    word: "nghe lóm",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) nghe lỏm: nghe lóm được mỗi một câu",
    example: "nghe lóm được mỗi một câu",
  },
  {
    word: "nghe ra",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) hiểu được, nhận ra được (điều hay, lẽ phải): giảng giải cho nó nghe ra",
    example: "giảng giải cho nó nghe ra",
  },
  {
    word: "nghe ra",
    part_of_speech: "danh từ",
    meaning: "miếu thờ thần: ngói đỏ lợp nghè, lớp trên đè lớp dưới (câu đối)",
    example: "ngói đỏ lợp nghè, lớp trên đè lớp dưới (câu đối)",
  },
  {
    word: "nghen",
    part_of_speech: "trợ từ",
    meaning:
      "(phương ngữ, khẩu ngữ) nhé: con đi nghen má! * coi chừng đó nghen!",
    example: "con đi nghen má! * coi chừng đó nghen!",
  },
  {
    word: "nghe ngóng",
    part_of_speech: "động từ",
    meaning:
      "lắng nghe (tin tức, dư luận) xem sao (để qua đó quyết định hành động của mình): lắng tai nghe ngóng * nghe ngóng tình hình * nghe ngóng xem có động tĩnh gì không",
    example:
      "lắng tai nghe ngóng * nghe ngóng tình hình * nghe ngóng xem có động tĩnh gì không",
  },
  {
    word: "nghe nhìn",
    part_of_speech: "",
    meaning:
      "kĩ thuật sử dụng cả âm thanh và hình ảnh, vừa tác động đến thính giác, vừa tác động đến thị giác: thiết bị nghe nhìn * băng nghe nhìn",
    example: "thiết bị nghe nhìn * băng nghe nhìn",
  },
  {
    word: "nghẹn",
    part_of_speech: "động từ",
    meaning:
      "bị tắc trong cổ họng: mắc nghẹn * tiếng nói nghẹn lại trong cổ họng",
    example: "mắc nghẹn * tiếng nói nghẹn lại trong cổ họng",
  },
  {
    word: "nghẹn",
    part_of_speech: "động từ",
    meaning:
      "(cây) ngừng phát triển, không lớn lên được vì điều kiện không thuận lợi: lúa bị nghẹn, không lớn được",
    example: "lúa bị nghẹn, không lớn được",
  },
  {
    word: "nghẽn",
    part_of_speech: "động từ",
    meaning:
      "tắc lại, không thông (thường nói về đường sá, đường truyền): cây đổ làm nghẽn đường * nghẽn mạch * đường truyền bị nghẽn",
    example: "cây đổ làm nghẽn đường * nghẽn mạch * đường truyền bị nghẽn",
  },
  {
    word: "nghẹn cứng",
    part_of_speech: "động từ",
    meaning:
      "nghẹn ứ lại, không sao nói được, nuốt được: miếng cơm nghẹn cứng trong cổ họng",
    example: "miếng cơm nghẹn cứng trong cổ họng",
  },
  {
    word: "nghẹn ngào",
    part_of_speech: "động từ",
    meaning:
      "nghẹn lời, không nói được vì quá xúc động: giọng nghẹn ngào xúc động",
    example: "giọng nghẹn ngào xúc động",
  },
  {
    word: "nghèn nghẹn",
    part_of_speech: "động từ",
    meaning:
      "hơi bị nghẹn, bị tắc trong cổ họng (thường do xúc động mạnh): cổ thấy nghèn nghẹn * giọng nghèn nghẹn, sắp khóc",
    example: "cổ thấy nghèn nghẹn * giọng nghèn nghẹn, sắp khóc",
  },
  {
    word: "nghẹn ứ",
    part_of_speech: "động từ",
    meaning:
      "nghẹn ngào đến mức như ứ lại, không thể thoát ra được: cổ họng nghẹn ứ lại vì uất ức",
    example: "cổ họng nghẹn ứ lại vì uất ức",
  },
  {
    word: "nghèn nghẹt",
    part_of_speech: "tính từ",
    meaning:
      "hơi nghẹt vì chặt quá, sít quá: cảm thấy nghèn nghẹt trong lồng ngực",
    example: "cảm thấy nghèn nghẹt trong lồng ngực",
  },
  {
    word: "nghèo",
    part_of_speech: "tính từ",
    meaning:
      "có rất ít tiền của, không đủ để đáp ứng những yêu cầu tối thiểu của đời sống vật chất: người nghèo * cảnh nghèo * nghèo xơ nghèo xác",
    example: "người nghèo * cảnh nghèo * nghèo xơ nghèo xác",
  },
  {
    word: "nghèo",
    part_of_speech: "tính từ",
    meaning:
      "có rất ít những gì được coi là tối thiểu cần thiết: thức ăn nghèo dinh dưỡng * bài văn nghèo ý",
    example: "thức ăn nghèo dinh dưỡng * bài văn nghèo ý",
  },
  {
    word: "nghèo hèn",
    part_of_speech: "tính từ",
    meaning:
      "nghèo và ở địa vị xã hội thấp kém (nói khái quát): số kiếp nghèo hèn",
    example: "số kiếp nghèo hèn",
  },
  {
    word: "nghèo đói",
    part_of_speech: "tính từ",
    meaning:
      "nghèo đến mức không có cái ăn (nói khái quát): sống trong cảnh nghèo đói",
    example: "sống trong cảnh nghèo đói",
  },
  {
    word: "nghèo nàn",
    part_of_speech: "tính từ",
    meaning:
      "nghèo và thiếu thốn nhiều mặt (nói khái quát): gia cảnh nghèo nàn * nền kinh tế còn nghèo nàn lạc hậu",
    example: "gia cảnh nghèo nàn * nền kinh tế còn nghèo nàn lạc hậu",
  },
  {
    word: "nghèo nàn",
    part_of_speech: "tính từ",
    meaning:
      "nghèo, thiếu những gì cần thiết để làm nên nội dung có ý nghĩa: bài văn nghèo nàn về ý",
    example: "bài văn nghèo nàn về ý",
  },
  {
    word: "nghèo khổ",
    part_of_speech: "tính từ",
    meaning:
      'nghèo đến mức khổ cực (nói khái quát): cuộc sống nghèo khổ * "Mấy ai hay nghĩ việc đời, Nhớ nơi nghèo khổ quên nơi sang giầu?" (LVT)',
    example:
      'cuộc sống nghèo khổ * "Mấy ai hay nghĩ việc đời, Nhớ nơi nghèo khổ quên nơi sang giầu?" (LVT)',
  },
  {
    word: "nghèo khó",
    part_of_speech: "tính từ",
    meaning: "nghèo và thiếu thốn đủ thứ (nói khái quát): cảnh nhà nghèo khó",
    example: "cảnh nhà nghèo khó",
  },
  {
    word: "nghèo túng",
    part_of_speech: "tính từ",
    meaning:
      "nghèo và luôn trong cảnh túng thiếu (nói khái quát): cảnh nhà nghèo túng",
    example: "cảnh nhà nghèo túng",
  },
  {
    word: "nghèo rớt",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như nghèo rớt mùng tơi: nhà hắn nghèo rớt",
    example: "nhà hắn nghèo rớt",
  },
  {
    word: "nghèo xác xơ",
    part_of_speech: "tính từ",
    meaning:
      "nghèo đến mức chẳng có thứ gì là đáng kể, trông xơ xác, thảm hại: nhà nghèo xác xơ",
    example: "nhà nghèo xác xơ",
  },
  {
    word: "nghệ",
    part_of_speech: "danh từ",
    meaning:
      "cây trồng cùng họ với gừng, củ có thịt màu vàng, thường dùng để làm gia vị: đỏ như vang, vàng như nghệ (tng)",
    example: "đỏ như vang, vàng như nghệ (tng)",
  },
  {
    word: "nghẹt thở",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ở trong tình trạng khó thở; thường dùng để ví tình cảnh sống bị o ép, gò bó đến mức mất hết tự do: người dân bị nghẹt thở dưới ách áp bức",
    example: "người dân bị nghẹt thở dưới ách áp bức",
  },
  {
    word: "nghẹt",
    part_of_speech: "",
    meaning:
      "bị vướng, tắc, không thông, vì chặt quá, sít quá: mũi bị nghẹt, rất khó thở * cửa bị nghẹt, không đóng được",
    example: "mũi bị nghẹt, rất khó thở * cửa bị nghẹt, không đóng được",
  },
  {
    word: "nghề đời",
    part_of_speech: "danh từ",
    meaning: "(cũ, khẩu ngữ) như thói đời: nghề đời trâu buộc ghét trâu ăn",
    example: "nghề đời trâu buộc ghét trâu ăn",
  },
  {
    word: "nghề",
    part_of_speech: "danh từ",
    meaning:
      "công việc chuyên làm theo sự phân công lao động của xã hội (thường phải do rèn luyện, học tập mới có): làm nghề thợ mộc * học nghề * một nghề thì sống, đống nghề thì chết (tng)",
    example:
      "làm nghề thợ mộc * học nghề * một nghề thì sống, đống nghề thì chết (tng)",
  },
  {
    word: "nghề",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) giỏi, thành thạo (trong một việc làm nào đó): bắn rất nghề * tay thợ ấy nghề lắm!",
    example: "bắn rất nghề * tay thợ ấy nghề lắm!",
  },
  {
    word: "nghề nghiệp",
    part_of_speech: "danh từ",
    meaning:
      "nghề (nói khái quát): có lòng say mê nghề nghiệp * đạo đức nghề nghiệp",
    example: "có lòng say mê nghề nghiệp * đạo đức nghề nghiệp",
  },
  {
    word: "nghề ngỗng",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) như nghề nghiệp (hàm ý chê bai): chẳng có nghề ngỗng gì",
    example: "chẳng có nghề ngỗng gì",
  },
  {
    word: "nghề đời nó thế",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị ý khẳng định điều sắp nêu ra chẳng qua cũng là việc thường thấy, thường gặp ở đời: nghề đời nó thế, thua rồi có lúc lại được",
    example: "nghề đời nó thế, thua rồi có lúc lại được",
  },
  {
    word: "nghệ nhân",
    part_of_speech: "danh từ",
    meaning:
      "người chuyên nghề biểu diễn một bộ môn nghệ thuật hoặc chuyên làm một nghề thủ công mĩ nghệ, có tài nghệ cao: nghệ nhân tuồng * nghệ nhân đúc đồng",
    example: "nghệ nhân tuồng * nghệ nhân đúc đồng",
  },
  {
    word: "nghệ sĩ",
    part_of_speech: "danh từ",
    meaning:
      "người chuyên hoạt động (sáng tác hoặc biểu diễn) trong một bộ môn nghệ thuật: nghệ sĩ nhiếp ảnh * tâm hồn nghệ sĩ * phong cách rất nghệ sĩ",
    example: "nghệ sĩ nhiếp ảnh * tâm hồn nghệ sĩ * phong cách rất nghệ sĩ",
  },
  {
    word: "nghếch",
    part_of_speech: "động từ",
    meaning:
      "đưa (thường là vật có điểm đầu) hơi chếch lên cao: đầu hơi nghếch lên * nghếch nòng súng lên cao",
    example: "đầu hơi nghếch lên * nghếch nòng súng lên cao",
  },
  {
    word: "nghề tự do",
    part_of_speech: "danh từ",
    meaning:
      "các nghề làm tư, không chịu sự quản lí của ai hay tổ chức, cơ quan nào, nói chung: làm nghề tự do",
    example: "làm nghề tự do",
  },
  {
    word: "nghệ thuật",
    part_of_speech: "danh từ",
    meaning:
      "hình thái ý thức xã hội đặc biệt, dùng hình tượng sinh động, cụ thể và gợi cảm để phản ánh hiện thực và truyền đạt tư tưởng, tình cảm: nghệ thuật điêu khắc * trượt băng nghệ thuật * hình tượng nghệ thuật trong tác phẩm văn học",
    example:
      "nghệ thuật điêu khắc * trượt băng nghệ thuật * hình tượng nghệ thuật trong tác phẩm văn học",
  },
  {
    word: "nghệ thuật",
    part_of_speech: "danh từ",
    meaning:
      "phương pháp, phương thức giàu tính sáng tạo, đem lại hiệu quả cao: nghệ thuật dùng binh * nghệ thuật kinh doanh",
    example: "nghệ thuật dùng binh * nghệ thuật kinh doanh",
  },
  {
    word: "nghênh",
    part_of_speech: "động từ",
    meaning:
      "đưa cao lên (đầu hay bộ phận của đầu) và hướng về phía cần chú ý: con trâu nghênh nghênh cặp sừng * nghênh mặt tỏ ý thách thức",
    example: "con trâu nghênh nghênh cặp sừng * nghênh mặt tỏ ý thách thức",
  },
  {
    word: "nghệch",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (mặt) đờ ra, trông có vẻ khờ dại: mặt nghệch ra, không hiểu gì",
    example: "mặt nghệch ra, không hiểu gì",
  },
  {
    word: "nghền nghệt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) hơi nghệt ra, do xúc động mạnh, hoặc do bị cuốn hút vào một điều gì đó: vẻ mặt nghền nghệt",
    example: "vẻ mặt nghền nghệt",
  },
  {
    word: "nghểnh",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) như nghển: nghểnh cổ * nghểnh đầu",
    example: "nghểnh cổ * nghểnh đầu",
  },
  {
    word: "nghển",
    part_of_speech: "động từ",
    meaning: "vươn cao cổ lên: nghển đầu nhìn qua tường rào * nghển cổ nhìn",
    example: "nghển đầu nhìn qua tường rào * nghển cổ nhìn",
  },
  {
    word: "nghễnh ngãng",
    part_of_speech: "tính từ",
    meaning:
      "bị điếc nhẹ, tai nghe lúc rõ lúc không: tai nghễnh ngãng, nghe câu được câu chăng * già nên sinh ra nghễnh ngãng",
    example:
      "tai nghễnh ngãng, nghe câu được câu chăng * già nên sinh ra nghễnh ngãng",
  },
  {
    word: "nghênh ngang",
    part_of_speech: "tính từ",
    meaning:
      "(ở tư thế) choán nhiều chỗ, bất chấp trật tự, quy định chung, gây trở ngại cho việc đi lại: xe cộ để nghênh ngang * đi nghênh ngang ngoài đường",
    example: "xe cộ để nghênh ngang * đi nghênh ngang ngoài đường",
  },
  {
    word: "nghênh ngang",
    part_of_speech: "tính từ",
    meaning:
      'tỏ ra không kiêng sợ gì ai, ngang nhiên làm những việc biết rằng mọi người có thể phản đối: điệu bộ nghênh ngang * "Nghênh ngang một cõi biên thuỳ, Thiếu gì cô quả, thiếu gì bá vương!" (TKiều)',
    example:
      'điệu bộ nghênh ngang * "Nghênh ngang một cõi biên thuỳ, Thiếu gì cô quả, thiếu gì bá vương!" (TKiều)',
  },
  {
    word: "nghênh chiến",
    part_of_speech: "động từ",
    meaning: "đón đánh trực diện, mặt đối mặt: sẵn sàng nghênh chiến với địch",
    example: "sẵn sàng nghênh chiến với địch",
  },
  {
    word: "nghềnh nghệch",
    part_of_speech: "tính từ",
    meaning: "(vẻ mặt) hơi dại, hơi nghệch ra: mặt lúc nào cũng nghềnh nghệch",
    example: "mặt lúc nào cũng nghềnh nghệch",
  },
  {
    word: "nghênh ngáo",
    part_of_speech: "tính từ",
    meaning: "vênh váo, nghênh ngang: bộ dạng nghênh ngáo * mặt nghênh ngáo",
    example: "bộ dạng nghênh ngáo * mặt nghênh ngáo",
  },
  {
    word: "nghêu ngao",
    part_of_speech: "động từ",
    meaning:
      "hát hoặc đọc to một mình cốt cho vui chứ không chú ý gì đến nội dung: hát nghêu ngao",
    example: "hát nghêu ngao",
  },
  {
    word: "nghênh tiếp",
    part_of_speech: "động từ",
    meaning:
      "(cũ, trang trọng) đón tiếp một cách trọng thể: sửa soạn nghênh tiếp sứ thần",
    example: "sửa soạn nghênh tiếp sứ thần",
  },
  {
    word: "nghệt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (mặt) đờ ra, ngây ra như không còn cảm giác gì: mặt nghệt ra, chẳng hiểu gì",
    example: "mặt nghệt ra, chẳng hiểu gì",
  },
  {
    word: "nghêu",
    part_of_speech: "danh từ",
    meaning:
      "động vật cùng loài với hến nhưng lớn hơn, sống ở bãi cát ven biển: đi cào ngao",
    example: "đi cào ngao",
  },
  {
    word: "nghĩ",
    part_of_speech: "động từ",
    meaning:
      "vận dụng trí tuệ vào những gì đã nhận biết được, rút ra nhận thức mới để có ý kiến, sự phán đoán, thái độ: nghĩ cách đối phó * ăn có nhai, nói có nghĩ (tng)",
    example: "nghĩ cách đối phó * ăn có nhai, nói có nghĩ (tng)",
  },
  {
    word: "nghĩ",
    part_of_speech: "động từ",
    meaning: "nhớ đến, tưởng đến: nghĩ tới tương lai * nghĩ về cha mẹ",
    example: "nghĩ tới tương lai * nghĩ về cha mẹ",
  },
  {
    word: "nghĩ",
    part_of_speech: "động từ",
    meaning:
      "cho là, cho rằng (sau khi đã nghĩ): mình vẫn nghĩ là anh ấy sẽ đến * nghĩ là thuận lợi, ai ngờ",
    example: "mình vẫn nghĩ là anh ấy sẽ đến * nghĩ là thuận lợi, ai ngờ",
  },
  {
    word: "nghễu nghện",
    part_of_speech: "tính từ",
    meaning:
      "có dáng vẻ hoặc ở vị trí cao, trông như vượt lên trên những gì ở xung quanh: ngồi nghễu nghện trên lưng trâu",
    example: "ngồi nghễu nghện trên lưng trâu",
  },
  {
    word: "nghi án",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) vụ án chưa có kết luận do chưa biết thủ phạm, chưa rõ manh mối: nghi án về vụ giết người",
    example: "nghi án về vụ giết người",
  },
  {
    word: "nghỉ",
    part_of_speech: "động từ",
    meaning:
      "tạm ngừng một hoạt động nào đó: nghỉ giải lao * ngày đi đêm nghỉ * cho máy nghỉ một lúc rồi chạy tiếp",
    example:
      "nghỉ giải lao * ngày đi đêm nghỉ * cho máy nghỉ một lúc rồi chạy tiếp",
  },
  {
    word: "nghỉ",
    part_of_speech: "động từ",
    meaning:
      "thôi, không tiếp tục công việc nghề nghiệp, chức vụ đang làm: nhà nghèo nên phải nghỉ học sớm * nghỉ kinh doanh  * xin nghỉ mất sức",
    example:
      "nhà nghèo nên phải nghỉ học sớm * nghỉ kinh doanh  * xin nghỉ mất sức",
  },
  {
    word: "nghỉ",
    part_of_speech: "động từ",
    meaning: "(Kiểu cách) ngủ: đêm đã khuya, mời cụ đi nghỉ",
    example: "đêm đã khuya, mời cụ đi nghỉ",
  },
  {
    word: "nghi",
    part_of_speech: "động từ",
    meaning:
      'nghĩ có thể là người nào đó, là đã xảy ra việc nào đó, thường là không tốt, nhưng không có đủ cơ sở để khẳng định: trông bộ dạng hắn có vẻ đáng nghi * "Nghe lời, nàng đã sinh nghi, Song đà quá đỗi, quản gì được thân." (TKiều)',
    example:
      'trông bộ dạng hắn có vẻ đáng nghi * "Nghe lời, nàng đã sinh nghi, Song đà quá đỗi, quản gì được thân." (TKiều)',
  },
  {
    word: "nghi binh",
    part_of_speech: "động từ",
    meaning:
      "hành động nhằm đánh lừa đối phương trong chiến đấu: cắm cờ hiệu để nghi binh * đốt lửa sau thành làm kế nghi binh",
    example: "cắm cờ hiệu để nghi binh * đốt lửa sau thành làm kế nghi binh",
  },
  {
    word: "nghị án",
    part_of_speech: "động từ",
    meaning:
      "(toà án) thảo luận riêng để quyết định hình thức xử lí về một vụ án: nói lời sau cùng trước khi toà nghị án",
    example: "nói lời sau cùng trước khi toà nghị án",
  },
  {
    word: "nghị định",
    part_of_speech: "danh từ",
    meaning:
      "văn bản do cơ quan nhà nước cấp cao ban hành, quy định chi tiết thi hành luật hoặc những vấn đề hết sức cần thiết nhưng chưa được xây dựng thành luật: nghị định của chính phủ * ra nghị định",
    example: "nghị định của chính phủ * ra nghị định",
  },
  {
    word: "nghỉ hè",
    part_of_speech: "động từ",
    meaning:
      "(học sinh) nghỉ vào mùa hè, trong một thời gian nhất định, sau khi kết thúc một năm học: kì nghỉ hè",
    example: "kì nghỉ hè",
  },
  {
    word: "nghi hoặc",
    part_of_speech: "động từ",
    meaning:
      "có điều còn nghi ngờ vì không rõ, không hiểu sự thật ra sao: trong việc này còn nhiều điều nghi hoặc",
    example: "trong việc này còn nhiều điều nghi hoặc",
  },
  {
    word: "nghĩ bụng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) suy nghĩ và có nhận định, đánh giá thầm trong lòng, không nói ra: nghĩ bụng là mình sẽ thắng * chỉ nghĩ bụng thế chứ không nói ra",
    example: "nghĩ bụng là mình sẽ thắng * chỉ nghĩ bụng thế chứ không nói ra",
  },
  {
    word: "nghi kỵ",
    part_of_speech: "động từ",
    meaning: "nghi ngờ mà sinh ra ghét: sinh lòng nghi kị",
    example: "sinh lòng nghi kị",
  },
  {
    word: "nghi kị",
    part_of_speech: "động từ",
    meaning: "nghi ngờ mà sinh ra ghét: sinh lòng nghi kị",
    example: "sinh lòng nghi kị",
  },
  {
    word: "nghỉ dưỡng",
    part_of_speech: "động từ",
    meaning:
      "nghỉ ngơi để dưỡng sức: nhu cầu nghỉ dưỡng * khu du lịch nghỉ dưỡng",
    example: "nhu cầu nghỉ dưỡng * khu du lịch nghỉ dưỡng",
  },
  {
    word: "nghĩ lại",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) suy xét lại điều đã nghĩ, đã làm, để có sự thay đổi ý kiến, thái độ: việc này cũng khó, mong ông nghĩ lại cho",
    example: "việc này cũng khó, mong ông nghĩ lại cho",
  },
  {
    word: "nghỉ chân",
    part_of_speech: "động từ",
    meaning:
      "(trên đường đi) tạm dừng chân để nghỉ cho đỡ mỏi, đỡ mệt: vào quán ngồi nghỉ chân",
    example: "vào quán ngồi nghỉ chân",
  },
  {
    word: "nghị luận",
    part_of_speech: "động từ",
    meaning:
      "bàn và đánh giá cho thật rõ về một vấn đề nào đó: nghị luận về chính trị * văn nghị luận",
    example: "nghị luận về chính trị * văn nghị luận",
  },
  {
    word: "nghị lực",
    part_of_speech: "danh từ",
    meaning:
      "sức mạnh tinh thần tạo cho con người sự kiên quyết trong hành động, không lùi bước trước khó khăn, thử thách: nghị lực phi thường * không đủ nghị lực để vượt qua thử thách",
    example: "nghị lực phi thường * không đủ nghị lực để vượt qua thử thách",
  },
  {
    word: "nghi ngại",
    part_of_speech: "động từ",
    meaning:
      "còn chưa rõ thực hư ra sao nên chưa dám có thái độ, hành động rõ ràng: không có gì phải nghi ngại * nhìn bằng ánh mắt nghi ngại",
    example: "không có gì phải nghi ngại * nhìn bằng ánh mắt nghi ngại",
  },
  {
    word: "nghỉ mát",
    part_of_speech: "động từ",
    meaning:
      "nghỉ để dưỡng sức ở nơi có không gian và khí hậu thoáng mát: đi nghỉ mát * lên Đà Lạt nghỉ mát",
    example: "đi nghỉ mát * lên Đà Lạt nghỉ mát",
  },
  {
    word: "nghi lễ",
    part_of_speech: "danh từ",
    meaning:
      "như lễ nghi: nghi lễ thờ cúng * đám tang được cử hành theo nghi lễ",
    example: "nghi lễ thờ cúng * đám tang được cử hành theo nghi lễ",
  },
  {
    word: "nghi ngờ",
    part_of_speech: "động từ",
    meaning:
      "nghi, không tin (nói khái quát): thấy lạ nên nghi ngờ * nghi ngờ lòng tốt của bạn",
    example: "thấy lạ nên nghi ngờ * nghi ngờ lòng tốt của bạn",
  },
  {
    word: "nghĩ ngợi",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bận tâm đến, nghĩ kĩ và lâu (nói khái quát): đăm chiêu nghĩ ngợi * không có gì phải nghĩ ngợi",
    example: "đăm chiêu nghĩ ngợi * không có gì phải nghĩ ngợi",
  },
  {
    word: "nghí ngoáy",
    part_of_speech: "động từ",
    meaning: "(hiếm) như hí hoáy: nghí ngoáy viết * nghí ngoáy nặn đất",
    example: "nghí ngoáy viết * nghí ngoáy nặn đất",
  },
  {
    word: "nghỉ ngơi",
    part_of_speech: "động từ",
    meaning:
      "nghỉ để hồi phục sức khoẻ (nói khái quát): nghỉ ngơi cho lại sức * ăn uống, nghỉ ngơi hợp lí",
    example: "nghỉ ngơi cho lại sức * ăn uống, nghỉ ngơi hợp lí",
  },
  {
    word: "nghi ngút",
    part_of_speech: "tính từ",
    meaning:
      "(khói, hơi) bốc lên nhiều và toả ra không ngớt: khói hương nghi ngút",
    example: "khói hương nghi ngút",
  },
  {
    word: "nghỉ tay",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tạm ngừng công việc chân tay để nghỉ cho khỏi mệt: nghỉ tay uống chén nước",
    example: "nghỉ tay uống chén nước",
  },
  {
    word: "nghị quyết",
    part_of_speech: "danh từ",
    meaning:
      "quyết định đã được chính thức thông qua ở hội nghị, sau khi vấn đề đã được tập thể thảo luận: dự thảo nghị quyết * nghị quyết của Đại hội",
    example: "dự thảo nghị quyết * nghị quyết của Đại hội",
  },
  {
    word: "nghĩ suy",
    part_of_speech: "động từ",
    meaning: "(văn chương) như suy nghĩ: nghĩ suy về công việc",
    example: "nghĩ suy về công việc",
  },
  {
    word: "nghị sĩ",
    part_of_speech: "danh từ",
    meaning:
      "người được bầu vào nghị viện (hay quốc hội ở một số nước dân chủ): nghị sĩ quốc hội * nghị sĩ của đảng cộng hoà",
    example: "nghị sĩ quốc hội * nghị sĩ của đảng cộng hoà",
  },
  {
    word: "nghỉ phép",
    part_of_speech: "động từ",
    meaning:
      "nghỉ hằng năm trong một thời gian nhất định, theo quy định chung của nhà nước đối với người lao động: xin nghỉ phép * kì nghỉ phép",
    example: "xin nghỉ phép * kì nghỉ phép",
  },
  {
    word: "nghi thức",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ nói chung những điều quy định có tính chất nghiêm túc, theo quy ước của xã hội hoặc theo thói quen, cần phải làm đúng trong giao tiếp, ứng xử, v.v.: nghi thức giao tiếp * đám cưới được tổ chức theo nghi thức cổ truyền",
    example:
      "nghi thức giao tiếp * đám cưới được tổ chức theo nghi thức cổ truyền",
  },
  {
    word: "nghi trang",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) nguỵ trang: nghi trang cửa hầm",
    example: "nghi trang cửa hầm",
  },
  {
    word: "nghị sự",
    part_of_speech: "động từ",
    meaning:
      "bàn bạc, thảo luận ở hội nghị những vấn đề có tính chất thời sự: chương trình nghị sự",
    example: "chương trình nghị sự",
  },
  {
    word: "nghi tiết",
    part_of_speech: "danh từ",
    meaning: "(cũ) như nghi thức: nghi tiết lễ tế thần",
    example: "nghi tiết lễ tế thần",
  },
  {
    word: "nghị trường",
    part_of_speech: "danh từ",
    meaning: "nơi hội họp của nghị viện: cuộc đấu trí trong nghị trường",
    example: "cuộc đấu trí trong nghị trường",
  },
  {
    word: "nghi vấn",
    part_of_speech: "tính từ",
    meaning:
      "nghi ngờ và thấy cần được xem xét, giải đáp: đối tượng nghi vấn * có nhiều dấu hiệu đáng nghi vấn * làm rõ điều nghi vấn",
    example:
      "đối tượng nghi vấn * có nhiều dấu hiệu đáng nghi vấn * làm rõ điều nghi vấn",
  },
  {
    word: "nghi vấn",
    part_of_speech: "tính từ",
    meaning: "(hình thức câu) đặt ra để hỏi và yêu cầu trả lời: câu nghi vấn",
    example: "câu nghi vấn",
  },
  {
    word: "nghĩa bóng",
    part_of_speech: "danh từ",
    meaning:
      "nghĩa của từ ngữ vốn chỉ một vật, sự việc cụ thể, được dùng để gợi ý hiểu cái trừu tượng; phân biệt với nghĩa đen: nghĩa của từ  *  trong  *  là nghĩa bóng",
    example: "nghĩa của từ  *  trong  *  là nghĩa bóng",
  },
  {
    word: "nghĩa",
    part_of_speech: "danh từ",
    meaning:
      "điều được coi là hợp lẽ phải, làm khuôn phép cho cách xử thế của con người trong xã hội: việc nghĩa * hi sinh vì nghĩa lớn",
    example: "việc nghĩa * hi sinh vì nghĩa lớn",
  },
  {
    word: "nghĩa",
    part_of_speech: "danh từ",
    meaning:
      "quan hệ tình cảm thuỷ chung, phù hợp với những quan niệm đạo đức nhất định: nghĩa vợ chồng keo sơn gắn bó",
    example: "nghĩa vợ chồng keo sơn gắn bó",
  },
  {
    word: "nghĩa",
    part_of_speech: "danh từ",
    meaning:
      "nội dung diễn đạt của một kí hiệu(đặc biệt là của kí hiệu ngôn ngữ),từ,câu: giải nghĩa từ * tìm hiểu nghĩa của câu ca dao",
    example: "giải nghĩa từ * tìm hiểu nghĩa của câu ca dao",
  },
  {
    word: "nghĩa",
    part_of_speech: "danh từ",
    meaning:
      "cái nội dung làm thành giá trị: điều đó chẳng có nghĩa gì hết * một việc làm có nghĩa",
    example: "điều đó chẳng có nghĩa gì hết * một việc làm có nghĩa",
  },
  {
    word: "nghi trượng",
    part_of_speech: "danh từ",
    meaning:
      "vật trang hoàng nơi cung thất, dinh thự hay dùng khi vua quan đi đường, như tàn, cờ, quạt, binh khí, v.v. (nói khái quát): bày biện nghi trượng",
    example: "bày biện nghi trượng",
  },
  {
    word: "nghỉ việc",
    part_of_speech: "động từ",
    meaning:
      "nghỉ hẳn hoặc nghỉ một thời gian dài, không tiếp tục công việc hoặc nghề nghiệp đang làm: xin nghỉ việc * cho công nhân nghỉ việc * phải nghỉ việc vì lí do sức khoẻ",
    example:
      "xin nghỉ việc * cho công nhân nghỉ việc * phải nghỉ việc vì lí do sức khoẻ",
  },
  {
    word: "nghĩa đen",
    part_of_speech: "danh từ",
    meaning:
      "nghĩa của từ ngữ được coi là có trước những nghĩa khác về mặt logic hay về mặt lịch sử; phân biệt với nghĩa bóng: từ  *  trong  *  được dùng với nghĩa đen",
    example: "từ  *  trong  *  được dùng với nghĩa đen",
  },
  {
    word: "nghị viện",
    part_of_speech: "danh từ",
    meaning:
      "cơ quan lập pháp ở nước dân chủ, toàn bộ hay một bộ phận được thành lập trên nguyên tắc bầu cử: đại biểu nghị viện * họp nghị viện",
    example: "đại biểu nghị viện * họp nghị viện",
  },
  {
    word: "nghĩa cử",
    part_of_speech: "danh từ",
    meaning: "việc làm, hành động vì nghĩa: một nghĩa cử cao đẹp",
    example: "một nghĩa cử cao đẹp",
  },
  {
    word: "nghĩa binh",
    part_of_speech: "danh từ",
    meaning: "(cũ) nghĩa quân: chiêu tập nghĩa binh",
    example: "chiêu tập nghĩa binh",
  },
  {
    word: "nghĩa khí",
    part_of_speech: "danh từ",
    meaning: "chí khí của người nghĩa hiệp: trọng nghĩa khí",
    example: "trọng nghĩa khí",
  },
  {
    word: "nghĩa hiệp",
    part_of_speech: "tính từ",
    meaning:
      "có tinh thần quên mình vì việc nghĩa, cứu giúp người gặp khó khăn hoạn nạn: một hành động nghĩa hiệp * người có nghĩa hiệp",
    example: "một hành động nghĩa hiệp * người có nghĩa hiệp",
  },
  {
    word: "nghĩa lí",
    part_of_speech: "danh từ",
    meaning: "ý nghĩa quan trọng: việc đó giờ chẳng còn nghĩa lí gì!",
    example: "việc đó giờ chẳng còn nghĩa lí gì!",
  },
  {
    word: "nghĩa tình",
    part_of_speech: "danh từ",
    meaning:
      'như tình nghĩa: "Mình đi, mình lại nhớ mình, Nguồn bao nhiêu nước, nghĩa tình bấy nhiêu." (THữu; 39)',
    example:
      'Mình đi, mình lại nhớ mình, Nguồn bao nhiêu nước, nghĩa tình bấy nhiêu." (THữu; 39)',
  },
  {
    word: "nghĩa quân",
    part_of_speech: "danh từ",
    meaning:
      "quân đội được tổ chức nên trong cuộc khởi nghĩa: nghĩa quân Tây Sơn",
    example: "nghĩa quân Tây Sơn",
  },
  {
    word: "nghĩa lý",
    part_of_speech: "danh từ",
    meaning: "ý nghĩa quan trọng: việc đó giờ chẳng còn nghĩa lí gì!",
    example: "việc đó giờ chẳng còn nghĩa lí gì!",
  },
  {
    word: "nghĩa sĩ",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người có nghĩa khí, dám hi sinh vì nghĩa lớn: trung thần nghĩa sĩ * chiêu tập nghĩa sĩ bốn phương",
    example: "trung thần nghĩa sĩ * chiêu tập nghĩa sĩ bốn phương",
  },
  {
    word: "nghĩa là",
    part_of_speech: "",
    meaning:
      "tổ hợp dùng để mở đầu phần giải thích nội dung của điều vừa nói đến, nêu ra cái ý cơ bản cần suy ra để hiểu: như thế, nghĩa là anh đã đồng ý?",
    example: "như thế, nghĩa là anh đã đồng ý?",
  },
  {
    word: "nghĩa trang",
    part_of_speech: "danh từ",
    meaning: "(trang trọng) nghĩa địa",
    example: "nghĩa trang liệt sĩ",
  },
  {
    word: "nghĩa vụ quân sự",
    part_of_speech: "danh từ",
    meaning:
      "nghĩa vụ của công dân tham gia lực lượng vũ trang: đi nghĩa vụ quân sự * trúng tuyển nghĩa vụ quân sự",
    example: "đi nghĩa vụ quân sự * trúng tuyển nghĩa vụ quân sự",
  },
  {
    word: "nghĩa vụ",
    part_of_speech: "danh từ",
    meaning:
      "việc bắt buộc phải làm đối với xã hội, đối với người khác mà pháp luật hay đạo đức quy định: thực hiện nghĩa vụ công dân",
    example: "thực hiện nghĩa vụ công dân",
  },
  {
    word: "nghĩa vụ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) nghĩa vụ quân sự (nói tắt): đi nghĩa vụ * hết thời hạn nghĩa vụ * khám nghĩa vụ",
    example: "đi nghĩa vụ * hết thời hạn nghĩa vụ * khám nghĩa vụ",
  },
  {
    word: "nghịch cảnh",
    part_of_speech: "danh từ",
    meaning:
      "cảnh ngộ trắc trở, trái với lẽ thường: nghịch cảnh trớ trêu * trải qua nhiều nghịch cảnh",
    example: "nghịch cảnh trớ trêu * trải qua nhiều nghịch cảnh",
  },
  {
    word: "nghịch lí",
    part_of_speech: "danh từ",
    meaning:
      "điều có vẻ ngược với logic thông thường, nhưng vẫn đúng hoặc khó bác bỏ: một nghịch lí khó tin",
    example: "một nghịch lí khó tin",
  },
  {
    word: "nghịch đảo",
    part_of_speech: "tính từ",
    meaning:
      "(hai số hoặc hai biểu thức) nhân với nhau thì bằng 1: M và N là hai số nghịch đảo nhau",
    example: "M và N là hai số nghịch đảo nhau",
  },
  {
    word: "nghịch đảo",
    part_of_speech: "danh từ",
    meaning:
      "số hoặc biểu thức mà nhân với số hoặc biểu thức đã cho thì bằng 1: M là nghịch đảo của N",
    example: "M là nghịch đảo của N",
  },
  {
    word: "nghịch ngợm",
    part_of_speech: "tính từ",
    meaning: "hay nghịch, thích nghịch (nói khái quát): tính hay nghịch ngợm",
    example: "tính hay nghịch ngợm",
  },
  {
    word: "nghịch",
    part_of_speech: "động từ",
    meaning:
      "(trẻ con) chơi đùa những trò không nên hoặc không được phép vì có thể gây hại: nghịch đất * nghịch dao * thằng bé nghịch quá!",
    example: "nghịch đất * nghịch dao * thằng bé nghịch quá!",
  },
  {
    word: "nghịch",
    part_of_speech: "tính từ",
    meaning:
      "không thuận, ngược lại với thuận: phản ứng nghịch * trông nghịch mắt",
    example: "phản ứng nghịch * trông nghịch mắt",
  },
  {
    word: "nghịch lý",
    part_of_speech: "danh từ",
    meaning:
      "điều có vẻ ngược với logic thông thường, nhưng vẫn đúng hoặc khó bác bỏ: một nghịch lí khó tin",
    example: "một nghịch lí khó tin",
  },
  {
    word: "nghịch tặc",
    part_of_speech: "danh từ",
    meaning: "(cũ) kẻ phản nghịch: quân nghịch tặc * đám nghịch tặc",
    example: "quân nghịch tặc * đám nghịch tặc",
  },
  {
    word: "nghịch tử",
    part_of_speech: "danh từ",
    meaning: "(cũ) đứa con ngỗ nghịch, bất hiếu: đồ nghịch tử! (tiếng mắng)",
    example: "đồ nghịch tử! (tiếng mắng)",
  },
  {
    word: "nghịch nhĩ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) chướng tai, khó nghe: ăn nói lếu láo, nghe nghịch nhĩ lắm!",
    example: "ăn nói lếu láo, nghe nghịch nhĩ lắm!",
  },
  {
    word: "nghiêm",
    part_of_speech: "tính từ",
    meaning:
      "chặt chẽ, không cho phép có một sự vi phạm, dù là nhỏ và bất cứ với ai, đối với những điều quy định: xử lí nghiêm các trường hợp vi phạm * giữ nghiêm kỉ luật",
    example: "xử lí nghiêm các trường hợp vi phạm * giữ nghiêm kỉ luật",
  },
  {
    word: "nghiêm",
    part_of_speech: "tính từ",
    meaning:
      "có dáng vẻ, thái độ tỏ ra cứng rắn, chặt chẽ, gây cảm giác nể sợ: nghiêm nét mặt * nghiêm giọng phê bình",
    example: "nghiêm nét mặt * nghiêm giọng phê bình",
  },
  {
    word: "nghiêm",
    part_of_speech: "tính từ",
    meaning: "(tư thế đứng) thẳng, ngay ngắn, chỉnh tề: đứng nghiêm chào cờ",
    example: "đứng nghiêm chào cờ",
  },
  {
    word: "nghiệm đúng",
    part_of_speech: "động từ",
    meaning:
      "kiểm tra tính đúng đắn của vấn đề qua thực nghiệm: phương pháp kiểm tra đã không còn nghiệm đúng",
    example: "phương pháp kiểm tra đã không còn nghiệm đúng",
  },
  {
    word: "nghiêm chỉnh",
    part_of_speech: "tính từ",
    meaning:
      "(ăn mặc, đi đứng) theo đúng phép tắc, quy định: ăn mặc nghiêm chỉnh * hàng ngũ nghiêm chỉnh",
    example: "ăn mặc nghiêm chỉnh * hàng ngũ nghiêm chỉnh",
  },
  {
    word: "nghiêm chỉnh",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra tuân theo các nguyên tắc và các quy định, không tự cho phép mình làm gì vượt ra ngoài: nghiêm chỉnh chấp hành luật lệ giao thông",
    example: "nghiêm chỉnh chấp hành luật lệ giao thông",
  },
  {
    word: "nghiêm cấm",
    part_of_speech: "động từ",
    meaning:
      "cấm ngặt, hoàn toàn không cho phép: nghiêm cấm sử dụng tài liệu trong phòng thi",
    example: "nghiêm cấm sử dụng tài liệu trong phòng thi",
  },
  {
    word: "nghiêm lệnh",
    part_of_speech: "danh từ",
    meaning: "lệnh bắt buộc phải theo: ra nghiêm lệnh * giữ nghiêm lệnh",
    example: "ra nghiêm lệnh * giữ nghiêm lệnh",
  },
  {
    word: "nghiêm khắc",
    part_of_speech: "tính từ",
    meaning:
      "rất nghiêm, không dễ dàng tha thứ hoặc bỏ qua một sai sót nào: nghiêm khắc phê bình * tính rất nghiêm khắc",
    example: "nghiêm khắc phê bình * tính rất nghiêm khắc",
  },
  {
    word: "nghiêm minh",
    part_of_speech: "tính từ",
    meaning:
      "nghiêm ngặt và rõ ràng, áp dụng cho mọi người, ai cũng như ai và trong mọi trường hợp: kỉ luật nghiêm minh * bảo đảm tính nghiêm minh của pháp luật",
    example: "kỉ luật nghiêm minh * bảo đảm tính nghiêm minh của pháp luật",
  },
  {
    word: "nghiêm huấn",
    part_of_speech: "danh từ",
    meaning: "(cũ, trang trọng) lời dạy bảo của cha: làm theo lời nghiêm huấn",
    example: "làm theo lời nghiêm huấn",
  },
  {
    word: "nghiêm mật",
    part_of_speech: "tính từ",
    meaning:
      "hết sức nghiêm ngặt và chặt chẽ, không để có sơ hở nào: canh phòng nghiêm mật",
    example: "canh phòng nghiêm mật",
  },
  {
    word: "nghiêm ngắn",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) nghiêm chỉnh, đứng đắn (nói khái quát): ngồi nghiêm ngắn * một con người nghiêm ngắn, đàng hoàng",
    example: "ngồi nghiêm ngắn * một con người nghiêm ngắn, đàng hoàng",
  },
  {
    word: "nghiêm nghị",
    part_of_speech: "tính từ",
    meaning: "tỏ ra nghiêm với vẻ quả quyết, dứt khoát: đôi mắt nghiêm nghị",
    example: "đôi mắt nghiêm nghị",
  },
  {
    word: "nghiệm",
    part_of_speech: "động từ",
    meaning:
      "ngẫm thấy, suy xét ra điều nào đó là đúng qua kinh nghiệm thực tế: điều đó càng nghiệm càng thấy đúng * nghiệm ra rằng",
    example: "điều đó càng nghiệm càng thấy đúng * nghiệm ra rằng",
  },
  {
    word: "nghiệm",
    part_of_speech: "danh từ",
    meaning:
      "giá trị hoặc hệ thống giá trị mà khi thay vào ẩn hoặc các ẩn thì làm cho một phương trình, bất phương trình, hoặc hệ phương trình, hệ bất phương trình trở thành những đẳng thức hoặc bất đẳng thức: tìm nghiệm của phương trình * phương trình có hai nghiệm",
    example: "tìm nghiệm của phương trình * phương trình có hai nghiệm",
  },
  {
    word: "nghiệm",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) hiệu nghiệm hoặc linh nghiệm (nói tắt): phép màu rất nghiệm",
    example: "phép màu rất nghiệm",
  },
  {
    word: "nghiêm ngặt",
    part_of_speech: "tính từ",
    meaning:
      "có yêu cầu chặt chẽ, gắt gao đối với những quy định đã đề ra: canh phòng nghiêm ngặt * giám sát nghiêm ngặt",
    example: "canh phòng nghiêm ngặt * giám sát nghiêm ngặt",
  },
  {
    word: "nghiễm nhiên",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) thản nhiên như không trước sự việc nghiêm trọng: nghiễm nhiên như không * thái độ nghiễm nhiên trước cái chết",
    example: "nghiễm nhiên như không * thái độ nghiễm nhiên trước cái chết",
  },
  {
    word: "nghiễm nhiên",
    part_of_speech: "phụ từ",
    meaning:
      "(trở thành hoặc đạt được) một cách tự nhiên, như từ đâu đưa đến, không hề mất công sức: thành công không phải nghiễm nhiên mà được * trúng xổ số, anh ta nghiễm nhiên trở thành triệu phú",
    example:
      "thành công không phải nghiễm nhiên mà được * trúng xổ số, anh ta nghiễm nhiên trở thành triệu phú",
  },
  {
    word: "nghiêm trị",
    part_of_speech: "động từ",
    meaning:
      "trừng trị nghiêm khắc theo pháp luật: nghiêm trị kẻ bán nước buôn dân * ai làm sai sẽ bị nghiêm trị",
    example: "nghiêm trị kẻ bán nước buôn dân * ai làm sai sẽ bị nghiêm trị",
  },
  {
    word: "nghiêm phụ",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, trang trọng) cha: "Nàng từ dời gót tới nơi, Lạy mừng nghiêm phụ giãi bày khúc nhôi." (LNT)',
    example:
      'Nàng từ dời gót tới nơi, Lạy mừng nghiêm phụ giãi bày khúc nhôi." (LNT)',
  },
  {
    word: "nghiệm thu",
    part_of_speech: "động từ",
    meaning:
      "kiểm tra chất lượng, số lượng hàng hoá hoặc công trình để tiếp nhận: nghiệm thu công trình để đưa vào sử dụng * nghiệm thu đề tài nghiên cứu",
    example:
      "nghiệm thu công trình để đưa vào sử dụng * nghiệm thu đề tài nghiên cứu",
  },
  {
    word: "nghiến",
    part_of_speech: "động từ",
    meaning:
      "(vật cứng) cọ xát rất mạnh vào nhau (thường phát ra tiếng kêu): nghiến răng * tiếng cửa sắt nghiến rin rít",
    example: "nghiến răng * tiếng cửa sắt nghiến rin rít",
  },
  {
    word: "nghiến",
    part_of_speech: "động từ",
    meaning:
      "(vật sắc và nặng) siết mạnh hoặc lăn đè mạnh lên, làm cho đứt hoặc giập nát: xích xe đạp nghiến nát gấu quần",
    example: "xích xe đạp nghiến nát gấu quần",
  },
  {
    word: "nghiến",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) ngay lập tức và rất nhanh: trói nghiến lại * bỏ nghiến xấp tiền vào túi",
    example: "trói nghiến lại * bỏ nghiến xấp tiền vào túi",
  },
  {
    word: "nghiêm trọng",
    part_of_speech: "tính từ",
    meaning:
      "ở trong tình trạng xấu đến mức trầm trọng, có nguy cơ dẫn đến những hậu quả hết sức tai hại: hậu quả nghiêm trọng * tình hình rất nghiêm trọng",
    example: "hậu quả nghiêm trọng * tình hình rất nghiêm trọng",
  },
  {
    word: "nghiên",
    part_of_speech: "danh từ",
    meaning: "đồ dùng để mài mực hoặc son (khi viết chữ Hán): nghiên mực",
    example: "nghiên mực",
  },
  {
    word: "nghiền",
    part_of_speech: "động từ",
    meaning:
      "ép và chà xát nhiều lần cho nát vụn ra: nghiền ngô * nghiền thức ăn cho gia súc",
    example: "nghiền ngô * nghiền thức ăn cho gia súc",
  },
  {
    word: "nghiền",
    part_of_speech: "động từ",
    meaning:
      '(khẩu ngữ) đọc, học rất kĩ: "Tôi lại đọc những tờ Tiểu Thuyết Thứ Bảy bán cân, đọc hết lại nghiền lại." (THoài; 9)',
    example:
      'Tôi lại đọc những tờ Tiểu Thuyết Thứ Bảy bán cân, đọc hết lại nghiền lại." (THoài; 9)',
  },
  {
    word: "nghiện",
    part_of_speech: "động từ",
    meaning:
      "ham thích đến mức thành thói quen khó bỏ: nghiện thuốc lá * nghiện rượu",
    example: "nghiện thuốc lá * nghiện rượu",
  },
  {
    word: "nghiện",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nghiện ma tuý (nói tắt): con nghiện * đưa đi cai nghiện",
    example: "con nghiện * đưa đi cai nghiện",
  },
  {
    word: "nghiêm trang",
    part_of_speech: "tính từ",
    meaning:
      "(ăn mặc, cử chỉ, nói năng) hết sức đứng đắn, biểu thị thái độ tôn kính: nét mặt nghiêm trang * đi đứng nghiêm trang",
    example: "nét mặt nghiêm trang * đi đứng nghiêm trang",
  },
  {
    word: "nghiêm túc",
    part_of_speech: "tính từ",
    meaning:
      "có ý thức coi trọng đúng mức những yêu cầu đối với mình, biểu hiện ở thái độ, hành động: làm việc rất nghiêm túc * thái độ thiếu nghiêm túc trong thi cử",
    example: "làm việc rất nghiêm túc * thái độ thiếu nghiêm túc trong thi cử",
  },
  {
    word: "nghiên cứu",
    part_of_speech: "động từ",
    meaning:
      "xem xét, tìm hiểu kĩ để nắm vững vấn đề, giải quyết vấn đề hay để rút ra những hiểu biết mới: nghiên cứu thị trường * đề tài nghiên cứu khoa học",
    example: "nghiên cứu thị trường * đề tài nghiên cứu khoa học",
  },
  {
    word: "nghiên cứu khả thi",
    part_of_speech: "",
    meaning:
      "nghiên cứu tính chất hay khả năng có thể thực hiện được: dự án đang trong giai đoạn nghiên cứu khả thi",
    example: "dự án đang trong giai đoạn nghiên cứu khả thi",
  },
  {
    word: "nghiện hút",
    part_of_speech: "động từ",
    meaning:
      "nghiện ma tuý (nói khái quát): đối tượng nghiện hút * tệ nạn nghiện hút ma tuý",
    example: "đối tượng nghiện hút * tệ nạn nghiện hút ma tuý",
  },
  {
    word: "nghiền ngẫm",
    part_of_speech: "động từ",
    meaning:
      "suy nghĩ kĩ và lâu để tìm tòi, hiểu biết cho thấu đáo: nghiền ngẫm bộ Kinh Dịch * nghiền ngẫm từng câu từng chữ",
    example: "nghiền ngẫm bộ Kinh Dịch * nghiền ngẫm từng câu từng chữ",
  },
  {
    word: "nghiện ngập",
    part_of_speech: "động từ",
    meaning: "nghiện (nói khái quát): nghiện ngập rượu chè",
    example: "nghiện ngập rượu chè",
  },
  {
    word: "nghiêng ngả",
    part_of_speech: "động từ",
    meaning:
      "như ngả nghiêng: cây tre nghiêng ngả trước gió * khủng hoảng tài chính làm nghiêng ngả nền kinh tế (b)",
    example:
      "cây tre nghiêng ngả trước gió * khủng hoảng tài chính làm nghiêng ngả nền kinh tế (b)",
  },
  {
    word: "nghiến ngấu",
    part_of_speech: "tính từ",
    meaning: "như ngấu nghiến: nhai nghiến ngấu * đọc nghiến ngấu quyển truyện",
    example: "nhai nghiến ngấu * đọc nghiến ngấu quyển truyện",
  },
  {
    word: "nghiêng",
    part_of_speech: "tính từ",
    meaning:
      "có vị trí lệch so với chiều thẳng đứng hoặc so với mặt phẳng nằm ngang: chữ viết hơi nghiêng * bức tường bị nghiêng * mái ngói xô nghiêng",
    example:
      "chữ viết hơi nghiêng * bức tường bị nghiêng * mái ngói xô nghiêng",
  },
  {
    word: "nghiêng",
    part_of_speech: "tính từ",
    meaning:
      "lệch về một bên so với hướng thẳng đứng, hướng chính diện: nằm nghiêng * đứng nghiêng người * nhìn nghiêng",
    example: "nằm nghiêng * đứng nghiêng người * nhìn nghiêng",
  },
  {
    word: "nghiêng",
    part_of_speech: "động từ",
    meaning:
      "làm cho nghiêng về một bên: nghiêng đầu * nghiêng người tránh * nghiêng thùng chắt nước",
    example: "nghiêng đầu * nghiêng người tránh * nghiêng thùng chắt nước",
  },
  {
    word: "nghiêng",
    part_of_speech: "động từ",
    meaning: "hơi ngả về một phía: ưu thế nghiêng về đội chủ nhà",
    example: "ưu thế nghiêng về đội chủ nhà",
  },
  {
    word: "nghiêng mình",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) cúi đầu để tưởng nhớ hoặc để tỏ lòng kính phục: nghiêng mình trước linh hồn các liệt sĩ * nghiêng mình thi lễ",
    example: "nghiêng mình trước linh hồn các liệt sĩ * nghiêng mình thi lễ",
  },
  {
    word: "nghiêng ngửa",
    part_of_speech: "tính từ",
    meaning:
      "bị nghiêng qua ngả lại; thường dùng để ví cảnh điêu đứng: cây cối nghiêng ngửa vì gió bão * bị nhiều phen nghiêng ngửa",
    example: "cây cối nghiêng ngửa vì gió bão * bị nhiều phen nghiêng ngửa",
  },
  {
    word: "nghiêng ngó",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nghiêng đầu bên nọ bên kia để ngó vào, nhìn vào: nghiêng ngó mọi xó xỉnh",
    example: "nghiêng ngó mọi xó xỉnh",
  },
  {
    word: "nghiêng thành",
    part_of_speech: "động từ",
    meaning:
      "(cũ, văn chương) như nghiêng nước nghiêng thành: sắc đẹp nghiêng thành",
    example: "sắc đẹp nghiêng thành",
  },
  {
    word: "nghiêng nước nghiêng thành",
    part_of_speech: "",
    meaning:
      '(cũ, văn chương) ví sắc đẹp lộng lẫy của người phụ nữ có sức làm cho người ta say đắm mà để mất thành, mất nước: "Một hai nghiêng nước nghiêng thành, Sắc đành đòi một, tài đành hoạ hai." (TKiều)',
    example:
      'Một hai nghiêng nước nghiêng thành, Sắc đành đòi một, tài đành hoạ hai." (TKiều)',
  },
  {
    word: "nghiệp",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ, hiếm) nghề làm ăn, sinh sống: nghiệp nhà nông * dùng văn chương làm nghiệp sống",
    example: "nghiệp nhà nông * dùng văn chương làm nghiệp sống",
  },
  {
    word: "nghiệp",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ, hiếm) cơ nghiệp (nói tắt): sạt nghiệp * bán cả nghiệp vì cờ bạc",
    example: "sạt nghiệp * bán cả nghiệp vì cờ bạc",
  },
  {
    word: "nghiệp",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, văn chương) sự nghiệp (nói tắt): làm nên nghiệp lớn * dựng nghiệp * dấy nghiệp trung hưng",
    example: "làm nên nghiệp lớn * dựng nghiệp * dấy nghiệp trung hưng",
  },
  {
    word: "nghiệp",
    part_of_speech: "danh từ",
    meaning:
      'tổng thể nói chung những điều một người làm ở kiếp này, tạo thành cái nhân mà kiếp sau người đó phải chịu cái quả, theo quan niệm của đạo Phật: "Đã mang lấy nghiệp vào thân, Cũng đừng trách lẫn trời gần, trời xa." (TKiều)',
    example:
      'Đã mang lấy nghiệp vào thân, Cũng đừng trách lẫn trời gần, trời xa." (TKiều)',
  },
  {
    word: "nghiệp chướng",
    part_of_speech: "danh từ",
    meaning:
      "hậu quả phải gánh chịu ở kiếp này do tội ác ở kiếp trước gây ra, theo quan niệm của đạo Phật: vướng vào vòng nghiệp chướng",
    example: "vướng vào vòng nghiệp chướng",
  },
  {
    word: "nghiệp đoàn",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức của những người cùng nghề nghiệp, để bảo vệ quyền lợi chung: nghiệp đoàn nhiếp ảnh",
    example: "nghiệp đoàn nhiếp ảnh",
  },
  {
    word: "nghiệp dư",
    part_of_speech: "tính từ",
    meaning:
      "không chuyên nghiệp, không phải nghề nghiệp chính thức: ca sĩ nghiệp dư * thám tử nghiệp dư * lối diễn còn rất nghiệp dư",
    example: "ca sĩ nghiệp dư * thám tử nghiệp dư * lối diễn còn rất nghiệp dư",
  },
  {
    word: "nghỉm",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) đến mức hoàn toàn không còn thấy dấu vết gì nữa: chìm nghỉm * tiếng đại bác bỗng dưng tắt nghỉm",
    example: "chìm nghỉm * tiếng đại bác bỗng dưng tắt nghỉm",
  },
  {
    word: "nghiệp vụ",
    part_of_speech: "danh từ",
    meaning:
      "kĩ năng, biện pháp thực hiện công việc chuyên môn của một nghề: nghiệp vụ điều tra * bồi dưỡng nghiệp vụ",
    example: "nghiệp vụ điều tra * bồi dưỡng nghiệp vụ",
  },
  {
    word: "nghiệt ngã",
    part_of_speech: "tính từ",
    meaning:
      "khắt khe đến mức gắt gao, khó chịu đựng nổi: khí hậu thật nghiệt ngã * số phận nghiệt ngã",
    example: "khí hậu thật nghiệt ngã * số phận nghiệt ngã",
  },
  {
    word: "nghìn nghịt",
    part_of_speech: "tính từ",
    meaning:
      "đông đến mức như đặc kín hết cả, không còn chen vào đâu được nữa: người đông nghìn nghịt",
    example: "người đông nghìn nghịt",
  },
  {
    word: "nghìn",
    part_of_speech: "danh từ",
    meaning: "(Nam ngàn) số 1.000: in một nghìn bản * mấy nghìn đồng",
    example: "in một nghìn bản * mấy nghìn đồng",
  },
  {
    word: "nghìn",
    part_of_speech: "danh từ",
    meaning:
      "số lượng rất lớn, không xác định: đông đến nghìn người * đường xa nghìn dặm * lời nói đáng giá nghìn vàng",
    example:
      "đông đến nghìn người * đường xa nghìn dặm * lời nói đáng giá nghìn vàng",
  },
  {
    word: "nghìn xưa",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương) thời gian rất lâu trong quá khứ, cách đây hàng nghìn năm: cổ vật từ nghìn xưa để lại",
    example: "cổ vật từ nghìn xưa để lại",
  },
  {
    word: "nghìn thu",
    part_of_speech: "danh từ",
    meaning:
      '(văn chương) nghìn năm; mãi mãi: tiếng thơm để mãi đến nghìn thu * "Anh hoa phát tiết ra ngoài, Nghìn thu bạc mệnh một đời tài hoa." (TKiều)',
    example:
      'tiếng thơm để mãi đến nghìn thu * "Anh hoa phát tiết ra ngoài, Nghìn thu bạc mệnh một đời tài hoa." (TKiều)',
  },
  {
    word: "nghịt",
    part_of_speech: "tính từ",
    meaning:
      "nhiều đến mức như đặc kín hết, không còn chen vào đâu được nữa: đông nghịt * sương mù dày nghịt",
    example: "đông nghịt * sương mù dày nghịt",
  },
  {
    word: "nghìn trùng",
    part_of_speech: "danh từ",
    meaning:
      '(Văn chương) nơi xa lắm, cao lắm, như cách trở núi sông trùng trùng điệp điệp: đường xa nghìn trùng * "Nghe lời sửa áo cài trâm, Khấu đầu lạy tạ cao thâm nghìn trùng." (TKiều)',
    example:
      'đường xa nghìn trùng * "Nghe lời sửa áo cài trâm, Khấu đầu lạy tạ cao thâm nghìn trùng." (TKiều)',
  },
  {
    word: "ngó",
    part_of_speech: "danh từ",
    meaning:
      "mầm non của một số loài cây, mọc từ dưới bùn, dưới nước lên: ngó cần * gỏi ngó sen",
    example: "ngó cần * gỏi ngó sen",
  },
  {
    word: "ngò",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ) (rau) mùi: rau ngò",
    example: "rau ngò",
  },
  {
    word: "ngõ",
    part_of_speech: "danh từ",
    meaning:
      "đường nhỏ và hẹp trong làng xóm, phố phường: nhà ở ngay đầu ngõ * đường ngang ngõ tắt",
    example: "nhà ở ngay đầu ngõ * đường ngang ngõ tắt",
  },
  {
    word: "ngỏ",
    part_of_speech: "động từ",
    meaning:
      'để mở, không đóng, không đậy kín: vấn đề còn để ngỏ * "Đêm qua ngỏ cửa chờ ai, Đêm nay cửa đóng then cài khăng khăng." (ca dao)',
    example:
      'vấn đề còn để ngỏ * "Đêm qua ngỏ cửa chờ ai, Đêm nay cửa đóng then cài khăng khăng." (ca dao)',
  },
  {
    word: "ngỏ",
    part_of_speech: "động từ",
    meaning:
      '(trang trọng) bày tỏ tình cảm, ý nghĩ: ngỏ lời cầu hôn * ngỏ ý giúp đỡ * "Sự lòng ngỏ với băng nhân, Tin sương đồn đại xa gần xôn xao." (TKiều)',
    example:
      'ngỏ lời cầu hôn * ngỏ ý giúp đỡ * "Sự lòng ngỏ với băng nhân, Tin sương đồn đại xa gần xôn xao." (TKiều)',
  },
  {
    word: "ngõ hầu",
    part_of_speech: "kết từ",
    meaning:
      "(cũ, trang trọng) từ biểu thị điều sắp nêu ra là mục đích mà việc làm vừa nói đến mong sao đạt cho được: cố gắng học, ngõ hầu có ngày thành đạt",
    example: "cố gắng học, ngõ hầu có ngày thành đạt",
  },
  {
    word: "ngõ hẻm",
    part_of_speech: "danh từ",
    meaning:
      "ngõ rất nhỏ và hẹp giữa các đường phố: nhà trong ngõ hẻm * hang cùng ngõ hẻm",
    example: "nhà trong ngõ hẻm * hang cùng ngõ hẻm",
  },
  {
    word: "ngó ngàng",
    part_of_speech: "động từ",
    meaning:
      "quan tâm, để ý đến: không ngó ngàng đến nhà cửa * chẳng ma nào ngó ngàng tới",
    example: "không ngó ngàng đến nhà cửa * chẳng ma nào ngó ngàng tới",
  },
  {
    word: "ngõ ngách",
    part_of_speech: "danh từ",
    meaning:
      "đường nhỏ, hẹp và ngoắt ngoéo với nhiều lối rẽ ngang (ở trong làng xóm, phố phường; nói khái quát): thuộc mọi ngõ ngách trong làng",
    example: "thuộc mọi ngõ ngách trong làng",
  },
  {
    word: "ngọ",
    part_of_speech: "danh từ",
    meaning:
      "(thường viết hoa) kí hiệu thứ bảy trong địa chi (lấy ngựa làm tượng trưng; sau tị trước mùi), dùng trong phép đếm thời gian cổ truyền của Trung Quốc và một số nước châu á, trong đó có Việt Nam: giờ Ngọ (từ 11 giờ đến 13 giờ) * vừa đúng ngọ",
    example: "giờ Ngọ (từ 11 giờ đến 13 giờ) * vừa đúng ngọ",
  },
  {
    word: "ngõ cụt",
    part_of_speech: "danh từ",
    meaning:
      "ngõ chỉ có một lối vào (đến cuối ngõ là cùng đường); thường dùng để ví sự bế tắc, cùng đường: bị đẩy vào ngõ cụt",
    example: "bị đẩy vào ngõ cụt",
  },
  {
    word: "ngo ngoe",
    part_of_speech: "động từ",
    meaning: "cử động một cách nhẹ nhàng, yếu ớt: con đỉa ngo ngoe dưới nước",
    example: "con đỉa ngo ngoe dưới nước",
  },
  {
    word: "ngo ngoe",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) (phần tử xấu) có biểu hiện hoạt động hoặc chống đối: bị doạ một trận nên hết dám ngo ngoe",
    example: "bị doạ một trận nên hết dám ngo ngoe",
  },
  {
    word: "ngoa dụ",
    part_of_speech: "danh từ",
    meaning:
      "cách nói so sánh phóng đại nhằm diễn đạt ý một cách mạnh mẽ:  là cách nói ngoa dụ",
    example: "là cách nói ngoa dụ",
  },
  {
    word: "ngoạc",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) như ngoác (nhưng thường hàm ý chê): ngoạc mồm ra khóc",
    example: "ngoạc mồm ra khóc",
  },
  {
    word: "ngó ngoáy",
    part_of_speech: "động từ",
    meaning:
      "động đậy, cựa quậy liên tiếp (thường nói về bộ phận cơ thể): con chó ngó ngoáy cái đuôi",
    example: "con chó ngó ngoáy cái đuôi",
  },
  {
    word: "ngoa ngoắt",
    part_of_speech: "tính từ",
    meaning:
      "ngoa và lắm lời một cách quá quắt, hỗn hào: người đàn bà ngoa ngoắt * nói ngoa ngoắt",
    example: "người đàn bà ngoa ngoắt * nói ngoa ngoắt",
  },
  {
    word: "ngoa",
    part_of_speech: "tính từ",
    meaning:
      "(nói) sai, không đúng sự thật, làm cho vấn đề, sự việc trầm trọng thêm: nói ngoa * có nói như thế cũng không ngoa",
    example: "nói ngoa * có nói như thế cũng không ngoa",
  },
  {
    word: "ngoác",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) (mồm) há to hết cỡ: ngoác mồm cãi * cười ngoác miệng đến tận mang tai",
    example: "ngoác mồm cãi * cười ngoác miệng đến tận mang tai",
  },
  {
    word: "ngoái",
    part_of_speech: "động từ",
    meaning: "quay (đầu) lại phía sau lưng: ngoái đầu nhìn lại * ngoái trông",
    example: "ngoái đầu nhìn lại * ngoái trông",
  },
  {
    word: "ngoài",
    part_of_speech: "danh từ",
    meaning:
      "phía những vị trí không thuộc phạm vi được xác định nào đó; đối lập với trong: đứng ngoài không được vào * dư luận trong và ngoài nước * ngoài tầm kiểm soát",
    example:
      "đứng ngoài không được vào * dư luận trong và ngoài nước * ngoài tầm kiểm soát",
  },
  {
    word: "ngoài",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp những vị trí tuy thuộc phạm vi được xác định nào đó, nhưng nằm ở bề mặt hoặc ở ranh giới và hướng ra phía những vật xung quanh: mặt ngoài của ngôi nhà * mắc bệnh ngoài da * nhìn dáng vẻ bên ngoài",
    example:
      "mặt ngoài của ngôi nhà * mắc bệnh ngoài da * nhìn dáng vẻ bên ngoài",
  },
  {
    word: "ngoài",
    part_of_speech: "danh từ",
    meaning:
      "phía trước so với phía sau, hoặc phía những vị trí ở xa trung tâm so với phía những vị trí ở gần trung tâm: nhà ngoài * đứng vòng trong vòng ngoài * đội bóng bị loại từ vòng ngoài",
    example:
      "nhà ngoài * đứng vòng trong vòng ngoài * đội bóng bị loại từ vòng ngoài",
  },
  {
    word: "ngoài",
    part_of_speech: "danh từ",
    meaning:
      "vùng địa lí ở vào phía bắc so với địa phương được xác định làm mốc, trong phạm vi đất nước Việt Nam: đàng ngoài * trong Nam ngoài Bắc * sống ngoài Hà Nội",
    example: "đàng ngoài * trong Nam ngoài Bắc * sống ngoài Hà Nội",
  },
  {
    word: "ngoài",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian không lâu sau thời điểm xác định làm mốc: ngoài rằm hẵng đi * tuổi ngoài sáu mươi * chuyện xảy ra ngoài một năm rồi",
    example:
      "ngoài rằm hẵng đi * tuổi ngoài sáu mươi * chuyện xảy ra ngoài một năm rồi",
  },
  {
    word: "ngoài",
    part_of_speech: "danh từ",
    meaning:
      "phạm vi không nằm trong phạm vi được xác định: việc xảy ra ngoài dự tính * làm thêm ngoài giờ * thu nhập ngoài lương",
    example:
      "việc xảy ra ngoài dự tính * làm thêm ngoài giờ * thu nhập ngoài lương",
  },
  {
    word: "ngoài",
    part_of_speech: "danh từ",
    meaning:
      "phạm vi những gì khác, không kể những cái được xác định: ngoài anh ta, không ai làm được * mâm cơm chẳng có gì ngoài đĩa rau muống với mấy quả cà",
    example:
      "ngoài anh ta, không ai làm được * mâm cơm chẳng có gì ngoài đĩa rau muống với mấy quả cà",
  },
  {
    word: "ngoài",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị vị trí của sự kiện, hiện tượng, hành động tồn tại hoặc xảy ra được coi là ở phía ngoài, vùng ngoài so với vị trí lấy làm mốc: ngoài trời mây đen vần vũ * nhận xét ở ngoài lề * trong nhà chưa tỏ, ngoài ngõ đã tường (tng)",
    example:
      "ngoài trời mây đen vần vũ * nhận xét ở ngoài lề * trong nhà chưa tỏ, ngoài ngõ đã tường (tng)",
  },
  {
    word: "ngọ nguậy",
    part_of_speech: "động từ",
    meaning:
      "cựa quậy liên tiếp, không chịu nằm yên, không chịu để yên: chân tay ngọ nguậy * con sâu còn ngọ nguậy, chưa chết",
    example: "chân tay ngọ nguậy * con sâu còn ngọ nguậy, chưa chết",
  },
  {
    word: "ngoải",
    part_of_speech: "đại từ",
    meaning:
      "(phương ngữ, khẩu ngữ) ngoài ấy: ở ngoải * con ở đây, dì ra ngoải một chút!",
    example: "ở ngoải * con ở đây, dì ra ngoải một chút!",
  },
  {
    word: "ngoại",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về nước ngoài, do nước ngoài sản xuất; phân biệt với nội: hàng ngoại * rượu ngoại * sính của ngoại",
    example: "hàng ngoại * rượu ngoại * sính của ngoại",
  },
  {
    word: "ngoại",
    part_of_speech: "tính từ",
    meaning:
      "thuộc gia đình, họ hàng của mẹ hoặc của vợ; phân biệt với nội: ông bà ngoại * về quê ngoại * anh em đằng ngoại * họ ngoại",
    example: "ông bà ngoại * về quê ngoại * anh em đằng ngoại * họ ngoại",
  },
  {
    word: "ngoại",
    part_of_speech: "tính từ",
    meaning:
      'đã quá, đã vượt qua (thường dùng chỉ tuổi tác, từ tuổi bốn mươi trở đi, theo số chẵn hàng chục): tuổi ngoại bảy mươi * "Quá niên trạc ngoại tứ tuần, Mày râu nhẵn nhụi, áo quần bảnh bao." (TKiều)',
    example:
      'tuổi ngoại bảy mươi * "Quá niên trạc ngoại tứ tuần, Mày râu nhẵn nhụi, áo quần bảnh bao." (TKiều)',
  },
  {
    word: "ngoại",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ, khẩu ngữ) ông ngoại hay bà ngoại (gọi tắt một cách thân mật): con chào ngoại",
    example: "con chào ngoại",
  },
  {
    word: "ngoại",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) khoa ngoại (nói tắt): bác sĩ ngoại * phòng khám ngoại",
    example: "bác sĩ ngoại * phòng khám ngoại",
  },
  {
    word: "ngoại cảm",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) bệnh do thời tiết tác động đột ngột đến cơ thể (nói khái quát; theo cách gọi của đông y); phân biệt với nội thương: bệnh ngoại cảm",
    example: "bệnh ngoại cảm",
  },
  {
    word: "ngoại cảm",
    part_of_speech: "danh từ",
    meaning:
      "khả năng cảm nhận những điều mà người thường không cảm nhận được, nhờ vào một giác quan đặc biệt, gọi là giác quan thứ sáu (ngoài năm giác quan: thị giác, thính giác, xúc giác, vị giác, khứu giác): nhà ngoại cảm",
    example: "nhà ngoại cảm",
  },
  {
    word: "ngoại cảnh",
    part_of_speech: "danh từ",
    meaning:
      "những điều kiện bên ngoài tác động đến đời sống của sinh vật (nói tổng quát): nhiều sinh vật phải biến đổi để thích nghi với ngoại cảnh",
    example: "nhiều sinh vật phải biến đổi để thích nghi với ngoại cảnh",
  },
  {
    word: "ngoại cảnh",
    part_of_speech: "danh từ",
    meaning:
      "hoàn cảnh, điều kiện khách quan có ảnh hưởng đến đời sống của con người (nói tổng quát); phân biệt với nội tâm: bị ngoại cảnh chi phối",
    example: "bị ngoại cảnh chi phối",
  },
  {
    word: "ngoại đạo",
    part_of_speech: "danh từ",
    meaning: "tôn giáo khác, trong quan hệ với tôn giáo được nói đến.",
    example: "về hội hoạ, tôi vốn là kẻ ngoại đạo",
  },
  {
    word: "ngoại giao",
    part_of_speech: "danh từ",
    meaning:
      "hoạt động của một nước về mặt quan hệ quốc tế: đặt quan hệ ngoại giao với nước ngoài * chính sách ngoại giao * nhà ngoại giao",
    example:
      "đặt quan hệ ngoại giao với nước ngoài * chính sách ngoại giao * nhà ngoại giao",
  },
  {
    word: "ngoại giao",
    part_of_speech: "động từ",
    meaning: "(Khẩu ngữ) giao thiệp với người ngoài: có tài ngoại giao",
    example: "có tài ngoại giao",
  },
  {
    word: "ngoại cỡ",
    part_of_speech: "danh từ",
    meaning: "cỡ lớn hơn tất cả những cỡ thường có: một đôi giày ngoại cỡ",
    example: "một đôi giày ngoại cỡ",
  },
  {
    word: "ngoại động",
    part_of_speech: "tính từ",
    meaning:
      "(động từ) đòi hỏi phải có bổ ngữ đối tượng trực tiếp để cho nghĩa được đầy đủ; phân biệt với nội động: ,  *  là những động từ ngoại động",
    example: ",  *  là những động từ ngoại động",
  },
  {
    word: "ngoại hối",
    part_of_speech: "danh từ",
    meaning:
      "chứng từ tín dụng và thanh toán thể hiện bằng ngoại tệ, dùng trong thanh toán quốc tế (nói khái quát): kinh doanh ngoại hối * dự trữ ngoại hối",
    example: "kinh doanh ngoại hối * dự trữ ngoại hối",
  },
  {
    word: "ngoại hạng",
    part_of_speech: "danh từ",
    meaning:
      "hạng đặc biệt, trên tất cả các hạng xếp theo bình thường: giải bóng đá ngoại hạng * sản phẩm ngoại hạng",
    example: "giải bóng đá ngoại hạng * sản phẩm ngoại hạng",
  },
  {
    word: "ngoại hình",
    part_of_speech: "danh từ",
    meaning:
      "hình dáng bên ngoài của con người: ngoại hình cân đối * có ngoại hình đẹp",
    example: "ngoại hình cân đối * có ngoại hình đẹp",
  },
  {
    word: "ngoại lai",
    part_of_speech: "tính từ",
    meaning:
      "có sự ảnh hưởng hoặc lai tạp từ những yếu tố của nước ngoài: yếu tố ngoại lai * văn hoá ngoại lai * từ ngoại lai (từ mượn của tiếng nước ngoài)",
    example:
      "yếu tố ngoại lai * văn hoá ngoại lai * từ ngoại lai (từ mượn của tiếng nước ngoài)",
  },
  {
    word: "ngoại lệ",
    part_of_speech: "danh từ",
    meaning:
      "cái nằm ngoài cái chung, ngoài những cái thông thường: trường hợp ngoại lệ * quy tắc nào cũng có những ngoại lệ",
    example: "trường hợp ngoại lệ * quy tắc nào cũng có những ngoại lệ",
  },
  {
    word: "ngoại lực",
    part_of_speech: "danh từ",
    meaning:
      "lực tác động từ bên ngoài; phân biệt với nội lực: bị ngoại lực tác động vào * thu hút nguồn ngoại lực",
    example: "bị ngoại lực tác động vào * thu hút nguồn ngoại lực",
  },
  {
    word: "ngoại khoá",
    part_of_speech: "danh từ",
    meaning:
      "môn học hoặc hoạt động giáo dục ngoài giờ, ngoài chương trình chính thức; phân biệt với nội khoá: giờ học ngoại khoá * sinh hoạt ngoại khoá * các hoạt động ngoại khoá",
    example:
      "giờ học ngoại khoá * sinh hoạt ngoại khoá * các hoạt động ngoại khoá",
  },
  {
    word: "ngoài mặt",
    part_of_speech: "",
    meaning:
      "(thái độ, tình cảm) được biểu hiện ra bên ngoài, bằng nét mặt, cử chỉ, v.v., đối lập với những suy nghĩ, tình cảm thật sự có trong lòng: ngoài mặt thì tử tế nhưng trong lòng thì độc ác, nham hiểm",
    example: "ngoài mặt thì tử tế nhưng trong lòng thì độc ác, nham hiểm",
  },
  {
    word: "ngoài luồng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) không thuộc luồng quản lí, không được thừa nhận là chính thức: phim ngoài luồng * băng, đĩa nhạc ngoài luồng",
    example: "phim ngoài luồng * băng, đĩa nhạc ngoài luồng",
  },
  {
    word: "ngoài lề",
    part_of_speech: "",
    meaning:
      "ở phía ngoài, không thuộc phạm vi chính thức: chuyện ngoài lề cuộc họp",
    example: "chuyện ngoài lề cuộc họp",
  },
  {
    word: "ngoại sinh",
    part_of_speech: "tính từ",
    meaning:
      "được sinh ra từ bên ngoài bản thân sự vật; phân biệt với nội sinh: yếu tố ngoại sinh * những tác động ngoại sinh",
    example: "yếu tố ngoại sinh * những tác động ngoại sinh",
  },
  {
    word: "ngoại ô",
    part_of_speech: "danh từ",
    meaning: "vùng ở rìa nội thành của thành phố: khu vực ngoại ô thành phố",
    example: "khu vực ngoại ô thành phố",
  },
  {
    word: "ngoại ô",
    part_of_speech: "danh từ",
    meaning: "(cũ, hiếm) ngoại thành; phân biệt với nội ô: các huyện ngoại ô",
    example: "các huyện ngoại ô",
  },
  {
    word: "ngoại ngữ",
    part_of_speech: "danh từ",
    meaning: "tiếng nước ngoài: học ngoại ngữ * biết hai ngoại ngữ",
    example: "học ngoại ngữ * biết hai ngoại ngữ",
  },
  {
    word: "ngoài miệng",
    part_of_speech: "",
    meaning:
      "ở lời lẽ nói ra, khác với ý nghĩ và việc làm thực tế: ngoài miệng thì cứng cỏi, song trong lòng cũng hơi lo ngại",
    example: "ngoài miệng thì cứng cỏi, song trong lòng cũng hơi lo ngại",
  },
  {
    word: "ngoại phạm",
    part_of_speech: "động từ",
    meaning:
      "(người bị tình nghi trong một vụ án) ở ngoài mọi khả năng và điều kiện phạm tội: bằng chứng ngoại phạm",
    example: "bằng chứng ngoại phạm",
  },
  {
    word: "ngoài ra",
    part_of_speech: "",
    meaning:
      "ngoài cái, điều vừa nói đến là chính, thì còn có thể có cái, điều khác nào đó nữa: muốn thi đỗ thì phải học, ngoài ra không có cách nào khác",
    example: "muốn thi đỗ thì phải học, ngoài ra không có cách nào khác",
  },
  {
    word: "ngoại nhập",
    part_of_speech: "động từ",
    meaning:
      "nhập từ nước ngoài vào (thường nói về hàng hoá): thuốc lá nhập ngoại * linh kiện nhập ngoại * công nghệ nhập ngoại",
    example:
      "thuốc lá nhập ngoại * linh kiện nhập ngoại * công nghệ nhập ngoại",
  },
  {
    word: "ngoại quốc",
    part_of_speech: "danh từ",
    meaning: "(cũ) nước ngoài: người ngoại quốc * tiếng ngoại quốc",
    example: "người ngoại quốc * tiếng ngoại quốc",
  },
  {
    word: "ngoại suy",
    part_of_speech: "động từ",
    meaning:
      "mở rộng các kết luận có được từ sự quan sát một hiện tượng sang những hiện tượng ngoài phạm vi đã được xem xét: phương pháp ngoại suy",
    example: "phương pháp ngoại suy",
  },
  {
    word: "ngoại tệ mạnh",
    part_of_speech: "danh từ",
    meaning:
      "đồng tiền nước ngoài có khả năng chuyển đổi dễ dàng trên thị trường quốc tế: đồng Việt Nam lên giá so với một số ngoại tệ mạnh * tích trữ ngoại tệ mạnh",
    example:
      "đồng Việt Nam lên giá so với một số ngoại tệ mạnh * tích trữ ngoại tệ mạnh",
  },
  {
    word: "ngoại tệ",
    part_of_speech: "danh từ",
    meaning:
      "tiền nước ngoài; phân biệt với nội tệ: dự trữ ngoại tệ * mua bán ngoại tệ",
    example: "dự trữ ngoại tệ * mua bán ngoại tệ",
  },
  {
    word: "ngoại thành",
    part_of_speech: "danh từ",
    meaning:
      "khu vực bao quanh bên ngoài thành phố, nhưng thuộc về thành phố về mặt hành chính; phân biệt với nội thành: Đông Anh là một huyện ngoại thành Hà Nội",
    example: "Đông Anh là một huyện ngoại thành Hà Nội",
  },
  {
    word: "ngoại tiết",
    part_of_speech: "tính từ",
    meaning:
      "(tuyến) có ống dẫn chất được tiết từ bên trong cơ thể ra ngoài: tuyến mồ hôi, tuyến nước bọt là những tuyến ngoại tiết",
    example: "tuyến mồ hôi, tuyến nước bọt là những tuyến ngoại tiết",
  },
  {
    word: "ngoại thương",
    part_of_speech: "danh từ",
    meaning:
      "việc buôn bán của một nước với nước ngoài (nói khái quát); phân biệt với nội thương: hoạt động ngoại thương * ngân hàng ngoại thương",
    example: "hoạt động ngoại thương * ngân hàng ngoại thương",
  },
  {
    word: "ngoại tộc",
    part_of_speech: "danh từ",
    meaning: "họ ngoại; phân biệt với nội tộc.",
    example: "người ngoại tộc",
  },
  {
    word: "ngoại tỉnh",
    part_of_speech: "danh từ",
    meaning:
      "khu vực bên ngoài một tỉnh hoặc một thành phố (đang được nói đến); phân biệt với nội tỉnh: bến xe ngoại tỉnh * sinh viên ngoại tỉnh * cước gọi điện thoại đi ngoại tỉnh",
    example:
      "bến xe ngoại tỉnh * sinh viên ngoại tỉnh * cước gọi điện thoại đi ngoại tỉnh",
  },
  {
    word: "ngoại thất",
    part_of_speech: "danh từ",
    meaning:
      "cảnh quan phía bên ngoài của ngôi nhà (nói tổng quát); phân biệt với nội thất: thiết kế ngoại thất * trang trí ngoại thất",
    example: "thiết kế ngoại thất * trang trí ngoại thất",
  },
  {
    word: "ngoài trời",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) ở chỗ trống, thoáng, không phải ở trong nhà hay nơi có mái che kiên cố: sân khấu ngoài trời",
    example: "sân khấu ngoài trời",
  },
  {
    word: "ngoại tiếp",
    part_of_speech: "tính từ",
    meaning:
      "(đường tròn, mặt cầu) đi qua tất cả các đỉnh của một đa giác, đa diện: đường tròn ngoại tiếp",
    example: "đường tròn ngoại tiếp",
  },
  {
    word: "ngoại tiếp",
    part_of_speech: "tính từ",
    meaning:
      "(đa giác, đa diện) chứa trọn một hình tròn hoặc hình cầu và có tất cả các cạnh hoặc các mặt tiếp xúc với đường tròn hoặc mặt cầu: đa giác ngoại tiếp với một hình tròn",
    example: "đa giác ngoại tiếp với một hình tròn",
  },
  {
    word: "ngoại trú",
    part_of_speech: "động từ",
    meaning:
      "(học sinh, người bệnh) không ăn ở ngay trong trường, trong bệnh viện; phân biệt với nội trú: sinh viên ngoại trú * điều trị ngoại trú",
    example: "sinh viên ngoại trú * điều trị ngoại trú",
  },
  {
    word: "ngoại trừ",
    part_of_speech: "động từ",
    meaning: "trừ ra, không kể: tất cả, không ngoại trừ một ai",
    example: "tất cả, không ngoại trừ một ai",
  },
  {
    word: "ngoại văn",
    part_of_speech: "danh từ",
    meaning:
      "sách báo tiếng nước ngoài nói chung; phân biệt với quốc văn: hiệu sách ngoại văn",
    example: "hiệu sách ngoại văn",
  },
  {
    word: "ngoại vụ",
    part_of_speech: "danh từ",
    meaning:
      "công việc hay bộ phận đối ngoại, giao dịch với bên ngoài: sở ngoại vụ * công tác ngoại vụ",
    example: "sở ngoại vụ * công tác ngoại vụ",
  },
  {
    word: "ngoạm",
    part_of_speech: "động từ",
    meaning:
      "cắn hoặc giữ miếng to bằng cách mở rộng miệng: con chó ngoạm khúc xương * ngoạm mấy miếng là hết cái bánh",
    example: "con chó ngoạm khúc xương * ngoạm mấy miếng là hết cái bánh",
  },
  {
    word: "ngoạm",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) gàu ngoạm (nói tắt): bốc hàng bằng ngoạm",
    example: "bốc hàng bằng ngoạm",
  },
  {
    word: "ngoại vi",
    part_of_speech: "danh từ",
    meaning:
      "vùng xa trung tâm thành phố (nói tổng quát): vùng ngoại vi thị xã * sống ở ngoại vi thành phố",
    example: "vùng ngoại vi thị xã * sống ở ngoại vi thành phố",
  },
  {
    word: "ngoại vi",
    part_of_speech: "danh từ",
    meaning:
      "thiết bị ngoại vi (nói tắt): bộ nhớ ngoại vi * máy tính được lắp thêm một số ngoại vi khác",
    example: "bộ nhớ ngoại vi * máy tính được lắp thêm một số ngoại vi khác",
  },
  {
    word: "ngoạn cảnh",
    part_of_speech: "động từ",
    meaning: "(trang trọng) ngắm xem phong cảnh: ngoạn cảnh Hồ Tây",
    example: "ngoạn cảnh Hồ Tây",
  },
  {
    word: "ngoan cường",
    part_of_speech: "tính từ",
    meaning:
      "bền bỉ và kiên cường: các chiến sĩ đã chiến đấu rất ngoan cường * tinh thần thi đấu ngoan cường",
    example:
      "các chiến sĩ đã chiến đấu rất ngoan cường * tinh thần thi đấu ngoan cường",
  },
  {
    word: "ngoan",
    part_of_speech: "tính từ",
    meaning:
      "dễ bảo, biết nghe lời (thường nói về trẻ em): đứa trẻ rất ngoan * con ngoan trò giỏi * ngủ ngoan",
    example: "đứa trẻ rất ngoan * con ngoan trò giỏi * ngủ ngoan",
  },
  {
    word: "ngoan",
    part_of_speech: "tính từ",
    meaning:
      '(cũ) khôn khéo và tài giỏi (thường nói về phụ nữ): "Nước lã mà vã nên hồ, Tay không mà nổi cơ đồ mới ngoan." (ca dao)',
    example:
      'Nước lã mà vã nên hồ, Tay không mà nổi cơ đồ mới ngoan." (ca dao)',
  },
  {
    word: "ngoan cố",
    part_of_speech: "tính từ",
    meaning:
      "khăng khăng không chịu từ bỏ ý nghĩ, hành động sai trái của mình, mặc dù bị phản đối, chống đối mạnh mẽ: ngoan cố chống cự * phần tử ngoan cố",
    example: "ngoan cố chống cự * phần tử ngoan cố",
  },
  {
    word: "ngoại xâm",
    part_of_speech: "danh từ",
    meaning:
      "sự xâm lược do quân đội nước ngoài tiến hành bằng chiến tranh: nạn ngoại xâm * giặc ngoại xâm * kháng chiến chống ngoại xâm",
    example: "nạn ngoại xâm * giặc ngoại xâm * kháng chiến chống ngoại xâm",
  },
  {
    word: "ngoạn mục",
    part_of_speech: "tính từ",
    meaning:
      "đẹp, trông thích mắt: cú sút ngoạn mục * phong cảnh rất ngoạn mục",
    example: "cú sút ngoạn mục * phong cảnh rất ngoạn mục",
  },
  {
    word: "ngoan đạo",
    part_of_speech: "tính từ",
    meaning:
      "có lòng tin và làm theo đạo một cách tuyệt đối (từ thường dùng trong đạo Kitô): con chiên ngoan đạo",
    example: "con chiên ngoan đạo",
  },
  {
    word: "ngoảnh",
    part_of_speech: "động từ",
    meaning:
      "quay mặt về một phía nào đó: ngoảnh mặt đi, không nhìn * ngoảnh đầu nhìn lại",
    example: "ngoảnh mặt đi, không nhìn * ngoảnh đầu nhìn lại",
  },
  {
    word: "ngoan ngoãn",
    part_of_speech: "tính từ",
    meaning:
      "có nết tốt, dễ bảo, biết nghe lời người trên: con chó ngoan ngoãn đi theo chủ",
    example: "con chó ngoan ngoãn đi theo chủ",
  },
  {
    word: "ngoảnh đi ngoảnh lại",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tả khoảng thời gian trôi đi rất nhanh (tựa như chỉ kịp ngoảnh đầu đi rồi ngoảnh lại): mới đấy mà ngoảnh đi ngoảnh lại đã đến Tết",
    example: "mới đấy mà ngoảnh đi ngoảnh lại đã đến Tết",
  },
  {
    word: "ngoáy",
    part_of_speech: "động từ",
    meaning:
      "thọc một vật vào chỗ sâu rồi xoay đi xoay lại thành những vòng tròn: ngoáy tai * ngoáy mũi * dùng que ngoáy nồi cám đang sôi",
    example: "ngoáy tai * ngoáy mũi * dùng que ngoáy nồi cám đang sôi",
  },
  {
    word: "ngoáy",
    part_of_speech: "động từ",
    meaning:
      "(mông, đuôi) đưa đi đưa lại theo hình tròn: ngoáy mông * con chó sướng quá, ngoáy tít cái đuôi",
    example: "ngoáy mông * con chó sướng quá, ngoáy tít cái đuôi",
  },
  {
    word: "ngoáy",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) viết bằng cách đưa ngòi bút rất nhanh: ngoáy vội mấy chữ * chữ viết ngoáy, rất khó đọc",
    example: "ngoáy vội mấy chữ * chữ viết ngoáy, rất khó đọc",
  },
  {
    word: "ngoay ngoáy",
    part_of_speech: "động từ",
    meaning: "ngoáy liên tiếp: viết ngoay ngoáy",
    example: "viết ngoay ngoáy",
  },
  {
    word: "ngoáo ộp",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi một quái vật bịa ra để doạ trẻ con; thường dùng khẩu ngữ để ví vật đưa ra để doạ dẫm, uy hiếp tinh thần: ông ngoáo ộp",
    example: "ông ngoáo ộp",
  },
  {
    word: "ngoắc",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) móc, mắc: ngoắc ngón tay giao hẹn * ngoắc khẩu súng lên tường",
    example: "ngoắc ngón tay giao hẹn * ngoắc khẩu súng lên tường",
  },
  {
    word: "ngoặc",
    part_of_speech: "danh từ",
    meaning:
      "ngoặc đơn, ngoặc kép, hoặc ngoặc vuông (nói tắt): mở ngoặc * đóng ngoặc * câu trích dẫn phải đưa vào trong ngoặc",
    example: "mở ngoặc * đóng ngoặc * câu trích dẫn phải đưa vào trong ngoặc",
  },
  {
    word: "ngoặc",
    part_of_speech: "động từ",
    meaning:
      "dùng một dấu móc (() để viết thêm vào: ngoặc thêm vào mấy chữ chép thiếu",
    example: "ngoặc thêm vào mấy chữ chép thiếu",
  },
  {
    word: "ngoặc",
    part_of_speech: "động từ",
    meaning: "(hiếm) như ngoắc: ngoặc cái túi vào ghi đông xe đạp",
    example: "ngoặc cái túi vào ghi đông xe đạp",
  },
  {
    word: "ngoặc",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) móc ngoặc (nói tắt): ngoặc với nhau để tham ô",
    example: "ngoặc với nhau để tham ô",
  },
  {
    word: "ngoắc ngoặc",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ, hiếm) như móc ngoặc: thủ kho ngoắc ngoặc với con buôn",
    example: "thủ kho ngoắc ngoặc với con buôn",
  },
  {
    word: "ngoắc ngoải",
    part_of_speech: "động từ",
    meaning: "ở tình trạng sống thoi thóp, chỉ còn chờ chết: sống ngắc ngoải",
    example: "sống ngắc ngoải",
  },
  {
    word: "ngoằn ngoèo",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả dáng vẻ cong queo uốn lượn theo nhiều hướng khác nhau: con đường ngoằn ngoèo * chữ viết ngoằn ngoèo",
    example: "con đường ngoằn ngoèo * chữ viết ngoằn ngoèo",
  },
  {
    word: "ngoắt",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ, khẩu ngữ) vẫy: con chó ngoắt đuôi * ngoắt tay ra hiệu",
    example: "con chó ngoắt đuôi * ngoắt tay ra hiệu",
  },
  {
    word: "ngoắt",
    part_of_speech: "động từ",
    meaning: "như ngoặt: ngoắt vào một ngõ hẻm * quay ngoắt đi",
    example: "ngoắt vào một ngõ hẻm * quay ngoắt đi",
  },
  {
    word: "ngoắt ngoéo",
    part_of_speech: "tính từ",
    meaning: "(đường đi) uốn lượn, quanh co nhiều: đường đi ngoắt ngoéo",
    example: "đường đi ngoắt ngoéo",
  },
  {
    word: "ngoắt ngoéo",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) quanh co, rắc rối, làm cho phiền phức hoặc khó nhận biết sự thật: ăn nói ngoắt ngoéo * làm nhiều chuyện ngoắt ngoéo",
    example: "ăn nói ngoắt ngoéo * làm nhiều chuyện ngoắt ngoéo",
  },
  {
    word: "ngoặc tay",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) (hai người) ngoắc ngón tay trỏ hoặc ngón tay út vào với nhau, coi là làm dấu hiệu đã đồng ý cùng nhau giao ước một điều gì: ngoặc tay giao hẹn",
    example: "ngoặc tay giao hẹn",
  },
  {
    word: "ngoặt",
    part_of_speech: "động từ",
    meaning:
      "chuyển đột ngột sang hướng khác: rẽ ngoặt về bên phải * bẻ ngoặt tay lái * khúc ngoặt của cuộc đời",
    example:
      "rẽ ngoặt về bên phải * bẻ ngoặt tay lái * khúc ngoặt của cuộc đời",
  },
  {
    word: "ngọc",
    part_of_speech: "danh từ",
    meaning:
      "đá quý, thường dùng làm vật trang sức, trang trí: vòng ngọc * nuôi trai lấy ngọc",
    example: "vòng ngọc * nuôi trai lấy ngọc",
  },
  {
    word: "ngoặt ngoẹo",
    part_of_speech: "tính từ",
    meaning: "mềm, yếu, không đứng thẳng được: thân cây ngoặt ngoẹo",
    example: "thân cây ngoặt ngoẹo",
  },
  {
    word: "ngóc",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như ngách: nhà ở tận cuối ngóc",
    example: "nhà ở tận cuối ngóc",
  },
  {
    word: "ngóc",
    part_of_speech: "động từ",
    meaning:
      "cất cao (thường là đầu) lên: con chó ngóc mõm lên * bị chèn ép đến không ngóc đầu lên được",
    example: "con chó ngóc mõm lên * bị chèn ép đến không ngóc đầu lên được",
  },
  {
    word: "ngọc bích",
    part_of_speech: "danh từ",
    meaning:
      "ngọc màu xanh biếc, trông rất đẹp, thường dùng làm đồ trang sức: trời xanh màu ngọc bích * vòng ngọc bích",
    example: "trời xanh màu ngọc bích * vòng ngọc bích",
  },
  {
    word: "ngọc bội",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) đồ trang sức bằng ngọc, thường để đeo ở cổ; cũng dùng để chỉ người đức hạnh, đáng quý: miếng ngọc bội * "Nàng rằng: Trộm liếc dung quang, Chẳng sân ngọc bội thì phường kim môn." (TKiều)',
    example:
      'miếng ngọc bội * "Nàng rằng: Trộm liếc dung quang, Chẳng sân ngọc bội thì phường kim môn." (TKiều)',
  },
  {
    word: "ngọc ngà",
    part_of_speech: "danh từ",
    meaning:
      "ngọc và ngà; dùng trong văn chương để ví vẻ đẹp của thân thể người phụ nữ: cánh tay ngọc ngà * tấm thân ngọc ngà",
    example: "cánh tay ngọc ngà * tấm thân ngọc ngà",
  },
  {
    word: "ngọc nữ",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) như tiên nữ: "Êm như lọt tiếng tơ tình, Đẹp như Ngọc nữ uốn mình trong không." (ThLữ; 6)',
    example:
      'Êm như lọt tiếng tơ tình, Đẹp như Ngọc nữ uốn mình trong không." (ThLữ; 6)',
  },
  {
    word: "ngọc phả",
    part_of_speech: "danh từ",
    meaning:
      "sách ghi chép lai lịch, thân thế và sự nghiệp của những người được người đời tôn sùng: cuốn ngọc phả * ngọc phả Hùng Vương",
    example: "cuốn ngọc phả * ngọc phả Hùng Vương",
  },
  {
    word: "ngọc thỏ",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) con thỏ ngọc; dùng để chỉ mặt trăng: "Chút nghĩa đã nguyền vầng ngọc thỏ, Tấm lòng phó mặc bóng kim ô." (TT)',
    example:
      'Chút nghĩa đã nguyền vầng ngọc thỏ, Tấm lòng phó mặc bóng kim ô." (TT)',
  },
  {
    word: "ngọc thể",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, trtr hoặc kc) từ tôn xưng thân thể người mà mình kính trọng: ngọc thể bất an * giữ gìn ngọc thể",
    example: "ngọc thể bất an * giữ gìn ngọc thể",
  },
  {
    word: "ngọc thạch",
    part_of_speech: "danh từ",
    meaning:
      "ngọc màu xanh nhạt, nửa trong suốt, thường dùng làm đồ trang sức, trang trí: chiếc vòng ngọc thạch",
    example: "chiếc vòng ngọc thạch",
  },
  {
    word: "ngóc ngách",
    part_of_speech: "danh từ",
    meaning:
      "ngách (nói khái quát): hang sâu có nhiều ngóc ngách * thông thạo mọi ngóc ngách trong xóm",
    example:
      "hang sâu có nhiều ngóc ngách * thông thạo mọi ngóc ngách trong xóm",
  },
  {
    word: "ngóc ngách",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) nơi sâu kín, lắt léo, khó thấy: những ngóc ngách của vấn đề",
    example: "những ngóc ngách của vấn đề",
  },
  {
    word: "ngọc trai",
    part_of_speech: "danh từ",
    meaning:
      "viên ngọc lấy trong con trai, dùng làm đồ trang sức: vòng ngọc trai",
    example: "vòng ngọc trai",
  },
  {
    word: "ngoé",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) nhái nhỏ, thường sống ở bờ ruộng, trong bãi cỏ: giết người như ngoé (kng; giết một cách dã man, không ghê tay)",
    example: "giết người như ngoé (kng; giết một cách dã man, không ghê tay)",
  },
  {
    word: "ngoe nguẩy",
    part_of_speech: "động từ",
    meaning:
      "khẽ uốn qua uốn lại, cử động một cách mềm mại: cá ngoe nguẩy dưới nước * con chó ngoe nguẩy đuôi mừng rỡ",
    example: "cá ngoe nguẩy dưới nước * con chó ngoe nguẩy đuôi mừng rỡ",
  },
  {
    word: "ngoen ngoẻn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (cách nói năng) dối trá hay trở mặt một cách trơn tru, trơ tráo không biết ngượng: chối ngoen ngoẻn * vừa mắng xong đã lại ngoen ngoẻn",
    example: "chối ngoen ngoẻn * vừa mắng xong đã lại ngoen ngoẻn",
  },
  {
    word: "ngoẹo",
    part_of_speech: "động từ",
    meaning: "(đầu, cổ) nghiêng hẳn về một bên: ngoẹo đầu về một bên",
    example: "ngoẹo đầu về một bên",
  },
  {
    word: "ngoẹo",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) quẹo: ngoẹo vô một ngõ nhỏ * đến ngã ba thì ngoẹo phải",
    example: "ngoẹo vô một ngõ nhỏ * đến ngã ba thì ngoẹo phải",
  },
  {
    word: "ngoéo",
    part_of_speech: "danh từ",
    meaning: "như cù nèo (ng1): dùng ngoéo để hái quả",
    example: "dùng ngoéo để hái quả",
  },
  {
    word: "ngoẻo",
    part_of_speech: "động từ",
    meaning: "(hiếm) như ngoẹo: ngoẻo đầu xuống vai chị mà ngủ",
    example: "ngoẻo đầu xuống vai chị mà ngủ",
  },
  {
    word: "ngoẻo",
    part_of_speech: "động từ",
    meaning: "(thông tục) chết (hàm ý coi khinh): hắn ngoẻo rồi",
    example: "hắn ngoẻo rồi",
  },
  {
    word: "ngoéo tay",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) như ngoặc tay: ngoéo tay giao hẹn",
    example: "ngoéo tay giao hẹn",
  },
  {
    word: "ngòi",
    part_of_speech: "danh từ",
    meaning: "đường nước nhỏ chảy thông với sông hoặc đầm, hồ: khơi ngòi",
    example: "khơi ngòi",
  },
  {
    word: "ngòi",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận ở cuối phần bụng của con ong, hình mũi kim, có thể thò ra thụt vào được, thường chứa nọc độc.",
    example: "bút bị gãy ngòi",
  },
  {
    word: "ngòi",
    part_of_speech: "danh từ",
    meaning: "ngòi bút (ng1; nói tắt): bút bị gãy ngòi",
    example: "ngòi bộc phá * pháo bị tịt ngòi",
  },
  {
    word: "ngòi",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận dẫn lửa để làm nổ, thường nhỏ và dài: ngòi bộc phá * pháo bị tịt ngòi",
    example: "đắp lá táo lên nhọt để hút ngòi",
  },
  {
    word: "ngoi",
    part_of_speech: "động từ",
    meaning:
      "(cũng nhoi) nhô lên một cách khó khăn từ trong nước hay trong bùn, đất: ngoi mình lên trên mặt nước",
    example: "ngoi mình lên trên mặt nước",
  },
  {
    word: "ngoi",
    part_of_speech: "động từ",
    meaning:
      "cố sức vươn lên vị trí cao hơn một cách khó nhọc (thường hàm ý khinh): ngoi mãi mới lên tới chức trưởng phòng",
    example: "ngoi mãi mới lên tới chức trưởng phòng",
  },
  {
    word: "ngòi bút",
    part_of_speech: "danh từ",
    meaning:
      "vật bằng kim loại có đầu nhọn ở đầu cái bút, để viết: chiếc ngòi bút bằng sắt",
    example: "chiếc ngòi bút bằng sắt",
  },
  {
    word: "ngòi bút",
    part_of_speech: "danh từ",
    meaning:
      "giọng, lối hành văn của một cá nhân: ngòi bút tả thực * tâm trạng nhân vật được diễn tả bằng ngòi bút tinh tế",
    example:
      "ngòi bút tả thực * tâm trạng nhân vật được diễn tả bằng ngòi bút tinh tế",
  },
  {
    word: "ngòi bút",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) nghề viết, các sản phẩm được viết ra nói chung, về mặt có thể coi như một thứ phương tiện: dùng ngòi bút làm vũ khí đấu tranh",
    example: "dùng ngòi bút làm vũ khí đấu tranh",
  },
  {
    word: "ngói",
    part_of_speech: "danh từ",
    meaning:
      "vật liệu lợp nhà, thường ở dạng tấm nhỏ, chế tạo từ đất sét đã nung hay từ xi măng: nhà lợp ngói",
    example: "nhà lợp ngói",
  },
  {
    word: "ngòi nổ",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận dùng để châm lửa, đưa lửa vào thuốc nổ làm cho phát nổ: châm ngòi nổ",
    example: "châm ngòi nổ",
  },
  {
    word: "ngòi nổ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) tác nhân trực tiếp gây ra xung đột: tháo ngòi nổ cho những vấn đề gay cấn trong khu vực",
    example: "tháo ngòi nổ cho những vấn đề gay cấn trong khu vực",
  },
  {
    word: "ngoi ngóp",
    part_of_speech: "động từ",
    meaning:
      "cố ngoi lên, nhưng lại bị chìm xuống, liên tiếp nhiều lần một cách mệt nhọc: lội ngoi ngóp dưới sông",
    example: "lội ngoi ngóp dưới sông",
  },
  {
    word: "ngỏm",
    part_of_speech: "động từ",
    meaning: "(hiếm) như nhổm: ngỏm dậy",
    example: "ngỏm dậy",
  },
  {
    word: "ngỏm",
    part_of_speech: "động từ",
    meaning: "(thông tục) như ngóm: tịt ngỏm * đống lửa đã tắt ngỏm",
    example: "tịt ngỏm * đống lửa đã tắt ngỏm",
  },
  {
    word: "ngỏm",
    part_of_speech: "động từ",
    meaning: "chết (hàm ý coi khinh): đòm một phát là ngỏm luôn",
    example: "đòm một phát là ngỏm luôn",
  },
  {
    word: "ngon",
    part_of_speech: "tính từ",
    meaning:
      "(thức ăn, thức uống) gây được cảm giác thích thú, làm cho ăn hoặc uống không thấy chán: thức ăn ngon * chè ngon * miếng ngon nhớ lâu, đòn đau nhớ đời (tng)",
    example:
      "thức ăn ngon * chè ngon * miếng ngon nhớ lâu, đòn đau nhớ đời (tng)",
  },
  {
    word: "ngon",
    part_of_speech: "tính từ",
    meaning: "(ngủ) say và yên giấc, đem lại cảm giác khoan khoái: ngủ ngon",
    example: "ngủ ngon",
  },
  {
    word: "ngon",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (làm việc gì) nhanh, gọn và rất dễ dàng, coi như không có gì khó khăn cả: bài toán này thì nó giải ngon",
    example: "bài toán này thì nó giải ngon",
  },
  {
    word: "ngon",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ, khẩu ngữ) giỏi, cừ: có ngon thì nhào vô!",
    example: "có ngon thì nhào vô!",
  },
  {
    word: "ngon",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) tốt, đẹp, đem lại sự hài lòng: chiếc xe vẫn còn ngon chán!",
    example: "chiếc xe vẫn còn ngon chán!",
  },
  {
    word: "ngọn",
    part_of_speech: "danh từ",
    meaning:
      "phần trên cùng của cây, là phần cao nhất và có hình nón, đối lập với gốc: ngọn tre * ngọn rau muống * trèo lên tận ngọn cây",
    example: "ngọn tre * ngọn rau muống * trèo lên tận ngọn cây",
  },
  {
    word: "ngọn",
    part_of_speech: "danh từ",
    meaning:
      "phần đầu nhọn hoặc có hình nón của một số vật: ngọn bút lông * trèo lên tận ngọn tháp * bát cơm đầy có ngọn",
    example: "ngọn bút lông * trèo lên tận ngọn tháp * bát cơm đầy có ngọn",
  },
  {
    word: "ngọn",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị một số cây hay một số vật có đầu nhọn hoặc có hình nón: ngọn cỏ * ngọn đèn * vượt qua mấy ngọn núi",
    example: "ngọn cỏ * ngọn đèn * vượt qua mấy ngọn núi",
  },
  {
    word: "ngọn",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị những vật chuyển động thành làn, luồng: ngọn lửa * đầu sóng ngọn gió (tng)",
    example: "ngọn lửa * đầu sóng ngọn gió (tng)",
  },
  {
    word: "ngóm",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) mất hẳn, hết hẳn đi, không còn thấy một biểu hiện gì nữa: đèn đóm tắt ngóm * ngòi pháo bị tịt ngóm",
    example: "đèn đóm tắt ngóm * ngòi pháo bị tịt ngóm",
  },
  {
    word: "ngón",
    part_of_speech: "danh từ",
    meaning:
      "phần cử động được ở đầu bàn tay, bàn chân người và một số động vật: ngón chân * năm ngón tay có ngón dài ngón ngắn (tng)",
    example: "ngón chân * năm ngón tay có ngón dài ngón ngắn (tng)",
  },
  {
    word: "ngón",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) tài nghệ, sở trường riêng: ngón đòn hiểm * ngón võ nhà nghề",
    example: "ngón đòn hiểm * ngón võ nhà nghề",
  },
  {
    word: "ngón",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) mánh khoé, thủ đoạn riêng: giở ngón bịp",
    example: "giở ngón bịp",
  },
  {
    word: "ngon giấc",
    part_of_speech: "động từ",
    meaning:
      "ngủ say và yên giấc: ngủ ngon giấc * đương ngon giấc thì bị gọi dậy",
    example: "ngủ ngon giấc * đương ngon giấc thì bị gọi dậy",
  },
  {
    word: "ngon ăn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) dễ làm, dễ được kết quả tốt, có lợi: tưởng ngon ăn, nào có ai ngờ!",
    example: "tưởng ngon ăn, nào có ai ngờ!",
  },
  {
    word: "ngon mắt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) đẹp mắt, gây được cảm giác thích thú, nhìn không biết chán: con bé trông khá ngon mắt",
    example: "con bé trông khá ngon mắt",
  },
  {
    word: "ngọn ngành",
    part_of_speech: "danh từ",
    meaning:
      "đầu đuôi, cùng với chi tiết tỉ mỉ của sự việc (nói khái quát): tìm hiểu ngọn ngành * nói rõ ngọn ngành",
    example: "tìm hiểu ngọn ngành * nói rõ ngọn ngành",
  },
  {
    word: "ngón nghề",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) bí quyết hoặc mánh khoé nghề nghiệp: xoay xở đủ ngón nghề để kiếm sống",
    example: "xoay xở đủ ngón nghề để kiếm sống",
  },
  {
    word: "ngỏn ngoẻn",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả cách cười há miệng, nhưng không thành tiếng, một cách tự nhiên: miệng cười ngỏn ngoẻn",
    example: "miệng cười ngỏn ngoẻn",
  },
  {
    word: "ngon miệng",
    part_of_speech: "tính từ",
    meaning:
      "(ăn) thấy ngon, biết ngon: bữa cơm ngon miệng * người mệt nên ăn không thấy ngon miệng",
    example: "bữa cơm ngon miệng * người mệt nên ăn không thấy ngon miệng",
  },
  {
    word: "ngon lành",
    part_of_speech: "tính từ",
    meaning: "ngon (nói khái quát): ăn ngon lành * ngủ một giấc ngon lành",
    example: "ăn ngon lành * ngủ một giấc ngon lành",
  },
  {
    word: "ngon ngót",
    part_of_speech: "tính từ",
    meaning: "hơi ngót đi một chút: ăn từ sáng, giờ bụng đã ngon ngót",
    example: "ăn từ sáng, giờ bụng đã ngon ngót",
  },
  {
    word: "ngọn nguồn",
    part_of_speech: "danh từ",
    meaning:
      "nơi bắt đầu của dòng sông, dòng suối; thường dùng để chỉ nguyên do, gốc tích của sự việc, hiện tượng: ngọn nguồn của câu chuyện * tìm hiểu rõ ngọn nguồn",
    example: "ngọn nguồn của câu chuyện * tìm hiểu rõ ngọn nguồn",
  },
  {
    word: "ngòn ngọt",
    part_of_speech: "tính từ",
    meaning: "hơi ngọt: nước pha hơi ngòn ngọt",
    example: "nước pha hơi ngòn ngọt",
  },
  {
    word: "ngon ngọt",
    part_of_speech: "tính từ",
    meaning:
      "(lời lẽ) khéo léo, ngọt ngào, dễ làm xiêu lòng: dỗ dành ngon ngọt",
    example: "dỗ dành ngon ngọt",
  },
  {
    word: "ngon xơi",
    part_of_speech: "tính từ",
    meaning: "(thông tục) như ngon ăn: tưởng ngon xơi hoá ra chẳng dễ chút nào",
    example: "tưởng ngon xơi hoá ra chẳng dễ chút nào",
  },
  {
    word: "ngon ơ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) dễ làm, dễ được, chẳng có gì khó: làm ngon ơ * nặng như thế mà nó vác cứ ngon ơ",
    example: "làm ngon ơ * nặng như thế mà nó vác cứ ngon ơ",
  },
  {
    word: "ngõng",
    part_of_speech: "danh từ",
    meaning:
      "mấu hình trụ để tra vào lỗ của một vật làm điểm tựa cho vật đó quay: ngõng cối xay",
    example: "ngõng cối xay",
  },
  {
    word: "ngóng",
    part_of_speech: "động từ",
    meaning:
      "ở trạng thái tỏ ra bồn chồn không yên vì muốn điều gì đó nhanh đến với mình: ngóng mẹ về chợ * sốt ruột, thỉnh thoảng lại chạy ra cổng ngóng",
    example: "ngóng mẹ về chợ * sốt ruột, thỉnh thoảng lại chạy ra cổng ngóng",
  },
  {
    word: "ngỏng",
    part_of_speech: "động từ",
    meaning:
      "(đầu, cổ) cất cao, vươn cao lên: đầu ngỏng lên * ngỏng cổ lên nhòm",
    example: "đầu ngỏng lên * ngỏng cổ lên nhòm",
  },
  {
    word: "ngỏng",
    part_of_speech: "tính từ",
    meaning:
      "(cổ hoặc thân hình) cao quá mức, trông khó coi: cổ cao ngỏng * cao chê ngỏng, thấp chê lùn (tng)",
    example: "cổ cao ngỏng * cao chê ngỏng, thấp chê lùn (tng)",
  },
  {
    word: "ngóng đợi",
    part_of_speech: "động từ",
    meaning: "như ngóng chờ: ngóng đợi tin nhà",
    example: "ngóng đợi tin nhà",
  },
  {
    word: "ngóng chờ",
    part_of_speech: "động từ",
    meaning: "trông đợi đến bồn chồn: ngóng chờ tin tức",
    example: "ngóng chờ tin tức",
  },
  {
    word: "ngọng",
    part_of_speech: "tính từ",
    meaning:
      "không phát âm được đúng một số âm do có tật hoặc do nói chưa sõi: có tật nói ngọng * ngọng líu ngọng lo",
    example: "có tật nói ngọng * ngọng líu ngọng lo",
  },
  {
    word: "ngọng",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) dại, khờ: ngọng gì mà phải chịu thiệt!",
    example: "ngọng gì mà phải chịu thiệt!",
  },
  {
    word: "ngọng nghịu",
    part_of_speech: "tính từ",
    meaning: "ngọng (ng1; nói khái quát): giọng nói ngọng nghịu",
    example: "giọng nói ngọng nghịu",
  },
  {
    word: "ngong ngóng",
    part_of_speech: "động từ",
    meaning: "như ngóng (nhưng ý nhấn mạnh hơn): ngong ngóng chờ đợi",
    example: "ngong ngóng chờ đợi",
  },
  {
    word: "ngọt bùi",
    part_of_speech: "tính từ",
    meaning:
      'có vị ngon, ngọt và thơm; dùng để ví sự sung sướng, hạnh phúc: chia sẻ ngọt bùi * "Một thuyền, một bến, một dây, Ngọt bùi ta hưởng, đắng cay ta chịu cùng." (ca dao)',
    example:
      'chia sẻ ngọt bùi * "Một thuyền, một bến, một dây, Ngọt bùi ta hưởng, đắng cay ta chịu cùng." (ca dao)',
  },
  {
    word: "ngót dạ",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) hơi đói: ăn từ sáng, giờ đã ngót dạ",
    example: "ăn từ sáng, giờ đã ngót dạ",
  },
  {
    word: "ngót",
    part_of_speech: "tính từ",
    meaning:
      "có thể tích giảm đi rõ rệt, thường do mất đi một lượng chất nước đáng kể trong quá trình đun nấu: rau xào bị ngót * tích cực ăn kiêng nên cũng ngót đi được vài cân (kng)",
    example:
      "rau xào bị ngót * tích cực ăn kiêng nên cũng ngót đi được vài cân (kng)",
  },
  {
    word: "ngót",
    part_of_speech: "tính từ",
    meaning:
      "gần đủ một số tròn, chỉ thiếu ít thôi: tiêu ngót một triệu đồng * tuổi ngót hai mươi",
    example: "tiêu ngót một triệu đồng * tuổi ngót hai mươi",
  },
  {
    word: "ngọt lừ",
    part_of_speech: "tính từ",
    meaning:
      'rất ngọt, vị ngọt như còn đọng mãi ở miệng: "Chồng chê thì mặc chồng chê, Dưa khú nấu với cá trê ngọt lừ." (ca dao)',
    example:
      'Chồng chê thì mặc chồng chê, Dưa khú nấu với cá trê ngọt lừ." (ca dao)',
  },
  {
    word: "ngọt",
    part_of_speech: "tính từ",
    meaning:
      "có vị như vị của đường, mật: bưởi ngọt * kẹo ngọt * ngọt như mía lùi * mật ngọt chết ruồi (tng)",
    example:
      "bưởi ngọt * kẹo ngọt * ngọt như mía lùi * mật ngọt chết ruồi (tng)",
  },
  {
    word: "ngọt",
    part_of_speech: "tính từ",
    meaning:
      "(món ăn) có vị ngon như vị mì chính: gà ngọt thịt * gia thêm mì chính cho ngọt nước",
    example: "gà ngọt thịt * gia thêm mì chính cho ngọt nước",
  },
  {
    word: "ngọt",
    part_of_speech: "tính từ",
    meaning:
      "(lời nói, âm thanh) dễ nghe, êm tai, dễ làm xiêu lòng: dỗ ngọt * ngọt giọng hò * nói ngọt lọt đến xương (tng)",
    example: "dỗ ngọt * ngọt giọng hò * nói ngọt lọt đến xương (tng)",
  },
  {
    word: "ngọt",
    part_of_speech: "tính từ",
    meaning:
      "hay p ở mức độ cao, gây cảm giác như tác động êm nhẹ nhưng thấm sâu: dao sắc ngọt * trời rét ngọt",
    example: "dao sắc ngọt * trời rét ngọt",
  },
  {
    word: "ngọt lịm",
    part_of_speech: "tính từ",
    meaning:
      "rất ngọt, vị ngọt như thấm sâu vào người, gây cảm giác dễ chịu, thích thú: nước dừa ngọt lịm",
    example: "nước dừa ngọt lịm",
  },
  {
    word: "ngọt ngào",
    part_of_speech: "tính từ",
    meaning:
      "ngọt, gây cảm giác dễ chịu (nói khái quát): tình yêu ngọt ngào * sự cám dỗ ngọt ngào",
    example: "tình yêu ngọt ngào * sự cám dỗ ngọt ngào",
  },
  {
    word: "ngọt lự",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như ngọt lừ (nhưng nghĩa mạnh hơn): quả na ngọt lự",
    example: "quả na ngọt lự",
  },
  {
    word: "ngọt sắc",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) rất ngọt, có thể gây khé cổ (thường nói về độ ngọt của đường): bát chè ngọt sắc",
    example: "bát chè ngọt sắc",
  },
  {
    word: "ngọt nhạt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (nói năng) ngọt ngào nhưng thiếu chân tình, cốt cho người khác tin theo, nghe theo: ngọt nhạt dỗ dành",
    example: "ngọt nhạt dỗ dành",
  },
  {
    word: "ngổ",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) bạo, táo tợn đến mức không kiêng nể ai: tính rất ngổ",
    example: "tính rất ngổ",
  },
  {
    word: "ngót nghét",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) gần đủ, gần sát một số tròn, chỉ thiếu rất ít thôi: tuổi ngót nghét bảy mươi * đạt ngót nghét 3 tạ một sào",
    example: "tuổi ngót nghét bảy mươi * đạt ngót nghét 3 tạ một sào",
  },
  {
    word: "ngộ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) hơi có vẻ khác lạ, gây được sự chú ý, thường là làm cho thấy hay hay, có cảm tình: cái tên nghe ngộ quá * thằng bé trông rất ngộ",
    example: "cái tên nghe ngộ quá * thằng bé trông rất ngộ",
  },
  {
    word: "ngộ",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) dại, điên: chó ngộ",
    example: "chó ngộ",
  },
  {
    word: "ngộ",
    part_of_speech: "kết từ",
    meaning:
      "(phương ngữ, khẩu ngữ) ngộ nhỡ (nói tắt): cứ mang theo cái áo ấm, ngộ trời trở lạnh",
    example: "cứ mang theo cái áo ấm, ngộ trời trở lạnh",
  },
  {
    word: "ngộ",
    part_of_speech: "động từ",
    meaning:
      '(cũ, hiếm) gặp: "Đôi ta mới ngộ hôm nay, Một đêm là ngãi, một ngày là duyên." (ca dao)',
    example:
      'Đôi ta mới ngộ hôm nay, Một đêm là ngãi, một ngày là duyên." (ca dao)',
  },
  {
    word: "ngố",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ngốc nghếch, ngây ngô: có thế mà cũng không biết, ngố thật!",
    example: "có thế mà cũng không biết, ngố thật!",
  },
  {
    word: "ngô",
    part_of_speech: "danh từ",
    meaning:
      "cây lương thực, thân thẳng, quả có dạng hạt tụ lại thành bắp ở lưng chừng thân, hạt dùng để ăn: ngô đã ra bắp * râu ngô * chuyện nở như ngô rang",
    example: "ngô đã ra bắp * râu ngô * chuyện nở như ngô rang",
  },
  {
    word: "ngổ ngáo",
    part_of_speech: "tính từ",
    meaning:
      "có thái độ, hành động ngang ngược, liều lĩnh: tính khí ngổ ngáo, hay gây sự",
    example: "tính khí ngổ ngáo, hay gây sự",
  },
  {
    word: "ngộ độc",
    part_of_speech: "động từ",
    meaning:
      "bị nhiễm độc tố của vi khuẩn hoặc bị nhiễm chất độc qua đường ăn uống: ngộ độc thực phẩm",
    example: "ngộ độc thực phẩm",
  },
  {
    word: "ngỗ nghịch",
    part_of_speech: "tính từ",
    meaning:
      "bướng bỉnh, ương ngạnh, không chịu ghép mình vào khuôn phép, kỉ luật (thường nói về trẻ con): đứa con ngỗ nghịch",
    example: "đứa con ngỗ nghịch",
  },
  {
    word: "ngọt xớt",
    part_of_speech: "tính từ",
    meaning:
      "(giọng nói) rất ngọt và dịu dàng dễ nghe, nhưng thường không thật, nhằm một mục đích không tốt nào đó: anh anh em em ngọt xớt * giọng dỗ dành ngọt xớt",
    example: "anh anh em em ngọt xớt * giọng dỗ dành ngọt xớt",
  },
  {
    word: "ngọt xớt",
    part_of_speech: "tính từ",
    meaning:
      "(đường cắt) sắc và gọn, gây cảm giác rất nhẹ nhàng: rạch một đường ngọt xớt",
    example: "rạch một đường ngọt xớt",
  },
  {
    word: "ngô nghê",
    part_of_speech: "tính từ",
    meaning:
      "thiếu tinh khôn, có vẻ ngớ ngẩn, buồn cười: vẻ mặt ngô nghê * văn viết còn ngô nghê",
    example: "vẻ mặt ngô nghê * văn viết còn ngô nghê",
  },
  {
    word: "ngộ nghĩnh",
    part_of_speech: "tính từ",
    meaning:
      "có những nét khác lạ, gợi cảm giác hay hay, buồn cười một cách đáng yêu: đứa bé trông rất ngộ nghĩnh * hình vẽ ngộ nghĩnh",
    example: "đứa bé trông rất ngộ nghĩnh * hình vẽ ngộ nghĩnh",
  },
  {
    word: "ngô ngố",
    part_of_speech: "tính từ",
    meaning: "hơi ngố: thằng bé trông ngô ngố",
    example: "thằng bé trông ngô ngố",
  },
  {
    word: "ngồ ngộ",
    part_of_speech: "tính từ",
    meaning:
      "hơi ngộ, trông hơi buồn cười nhưng với vẻ đáng yêu: con bé có cái bím tóc trông ngồ ngộ",
    example: "con bé có cái bím tóc trông ngồ ngộ",
  },
  {
    word: "ngộ nhận",
    part_of_speech: "động từ",
    meaning: "hiểu sai, nhận thức sai: tự ngộ nhận về chính mình",
    example: "tự ngộ nhận về chính mình",
  },
  {
    word: "ngộc nghệch",
    part_of_speech: "tính từ",
    meaning:
      "có vóc dáng to lớn nhưng vụng dại: to xác nhưng còn ngộc nghệch lắm!",
    example: "to xác nhưng còn ngộc nghệch lắm!",
  },
  {
    word: "ngộ nhỡ",
    part_of_speech: "kết từ",
    meaning:
      "(phương ngữ, khẩu ngữ) như nhỡ ra: thế ngộ nhỡ người ta không bằng lòng thì sao?",
    example: "thế ngộ nhỡ người ta không bằng lòng thì sao?",
  },
  {
    word: "ngôi",
    part_of_speech: "danh từ",
    meaning:
      "chức vị thường được coi là cao nhất trong làng, trong nước, theo thể chế phong kiến: lên ngôi thiên tử * ngôi tiên chỉ * giành ngôi bá chủ",
    example: "lên ngôi thiên tử * ngôi tiên chỉ * giành ngôi bá chủ",
  },
  {
    word: "ngôi",
    part_of_speech: "danh từ",
    meaning: "ngôi vua (nói tắt): truất ngôi * cướp ngôi * chọn người nối ngôi",
    example: "truất ngôi * cướp ngôi * chọn người nối ngôi",
  },
  {
    word: "ngôi",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị một số loại sự vật nhất định: ngôi nhà lá * ngôi chùa * những ngôi sao lung linh trên nền trời",
    example: "ngôi nhà lá * ngôi chùa * những ngôi sao lung linh trên nền trời",
  },
  {
    word: "ngôi",
    part_of_speech: "danh từ",
    meaning:
      "phạm trù ngữ pháp gắn với các loại từ như đại từ, động từ, v.v., biểu thị vị trí của các nhân vật trong giao tiếp: là người nói, người nghe hay người hoặc vật được nói đến:  là đại từ nhân xưng ngôi thứ nhất * động từ tiếng Nga có ba ngôi",
    example: "là đại từ nhân xưng ngôi thứ nhất * động từ tiếng Nga có ba ngôi",
  },
  {
    word: "ngôi",
    part_of_speech: "danh từ",
    meaning:
      "thế nằm của thai nhi gần ngày sinh, xét về mặt bộ phận nào ở sát nhất lối ra cửa mình: ngôi đầu * ngôi ngang (thai nằm ngang)",
    example: "ngôi đầu * ngôi ngang (thai nằm ngang)",
  },
  {
    word: "ngôi",
    part_of_speech: "danh từ",
    meaning: "đường ngôi (nói tắt): rẽ ngôi giữa",
    example: "rẽ ngôi giữa",
  },
  {
    word: "ngộ sát",
    part_of_speech: "động từ",
    meaning: "lỡ làm chết người, hoàn toàn không có chủ ý: tội ngộ sát",
    example: "tội ngộ sát",
  },
  {
    word: "ngốc",
    part_of_speech: "tính từ",
    meaning:
      "kém về trí khôn, về khả năng suy xét, ứng phó, xử sự: đồ ngốc! * ngốc quá, dễ thế mà cũng không biết",
    example: "đồ ngốc! * ngốc quá, dễ thế mà cũng không biết",
  },
  {
    word: "ngỗ ngược",
    part_of_speech: "tính từ",
    meaning:
      "bướng bỉnh, ngang ngược, coi thường người trên: ăn nói ngỗ ngược * thái độ ngỗ ngược",
    example: "ăn nói ngỗ ngược * thái độ ngỗ ngược",
  },
  {
    word: "ngốc nghếch",
    part_of_speech: "tính từ",
    meaning:
      "ngốc (nói khái quát): làm một việc ngốc nghếch * ăn nói ngốc nghếch",
    example: "làm một việc ngốc nghếch * ăn nói ngốc nghếch",
  },
  {
    word: "ngồi",
    part_of_speech: "động từ",
    meaning:
      "ở tư thế đít đặt trên mặt nền hoặc chân gập lại để đỡ toàn thân; phân biệt với đứng, nằm: ngồi thu lu trên phản * ổn định chỗ ngồi",
    example: "ngồi thu lu trên phản * ổn định chỗ ngồi",
  },
  {
    word: "ngồi",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) ở nơi, ở vị trí nào đó trong thời gian tương đối lâu để làm việc gì: ngồi nhà đá * ngồi ghế giám đốc",
    example: "ngồi nhà đá * ngồi ghế giám đốc",
  },
  {
    word: "ngồi bệt",
    part_of_speech: "động từ",
    meaning:
      "ngồi sát xuống đất, xuống sàn, không kê lót gì ở dưới: ngồi bệt xuống đất",
    example: "ngồi bệt xuống đất",
  },
  {
    word: "ngôi báu",
    part_of_speech: "danh từ",
    meaning: "(cũ, trang trọng) ngôi vua: tranh giành ngôi báu",
    example: "tranh giành ngôi báu",
  },
  {
    word: "ngồi bó gối",
    part_of_speech: "động từ",
    meaning:
      "ngồi ở tư thế co gập chân, hai tay vòng ra, ôm lấy đầu gối: ngồi bó gối trên giường",
    example: "ngồi bó gối trên giường",
  },
  {
    word: "ngồi chưa ấm chỗ",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tả trường hợp không ngồi yên được lâu ở một chỗ, thường vì sốt ruột hay bận rộn: ngồi chưa ấm chỗ đã phải đi",
    example: "ngồi chưa ấm chỗ đã phải đi",
  },
  {
    word: "ngồi dưng",
    part_of_speech: "động từ",
    meaning: "(hiếm) như ngồi không: thất nghiệp, phải ngồi dưng cả tháng trời",
    example: "thất nghiệp, phải ngồi dưng cả tháng trời",
  },
  {
    word: "ngồi dãi thẻ",
    part_of_speech: "động từ",
    meaning:
      "ngồi bệt xuống và duỗi thẳng hai chân ra: con bé ngồi dãi thẻ giữa nhà chơi chuyền",
    example: "con bé ngồi dãi thẻ giữa nhà chơi chuyền",
  },
  {
    word: "ngồi đồng",
    part_of_speech: "động từ",
    meaning: "ngồi để lên đồng: bà cốt ngồi đồng",
    example: "bà cốt ngồi đồng",
  },
  {
    word: "ngồi lê mách lẻo",
    part_of_speech: "",
    meaning: "(khẩu ngữ) như ngồi lê đôi mách: quen thói ngồi lê mách lẻo",
    example: "quen thói ngồi lê mách lẻo",
  },
  {
    word: "ngồi không",
    part_of_speech: "động từ",
    meaning:
      "không làm gì hoặc không có việc gì để làm: bói rẻ còn hơn ngồi không (tng)",
    example: "bói rẻ còn hơn ngồi không (tng)",
  },
  {
    word: "ngôi thứ",
    part_of_speech: "danh từ",
    meaning: "địa vị và cấp bậc (nói khái quát): tranh giành ngôi thứ",
    example: "tranh giành ngôi thứ",
  },
  {
    word: "ngôi sao",
    part_of_speech: "danh từ",
    meaning:
      "người đạt thành tích nổi bật trong biểu diễn nghệ thuật hoặc hoạt động thể thao (thường là còn trẻ), được công chúng hâm mộ, ví như ngôi sao sáng trên bầu trời: ngôi sao màn bạc * ngôi sao trên sân cỏ * trở thành ngôi sao trong làng ca nhạc",
    example:
      "ngôi sao màn bạc * ngôi sao trên sân cỏ * trở thành ngôi sao trong làng ca nhạc",
  },
  {
    word: "ngồi thiền",
    part_of_speech: "động từ",
    meaning:
      "ngồi im lặng theo kiểu riêng, giữ cho thân và tâm không động, theo đạo Phật: sự cụ toạ thiền",
    example: "sự cụ toạ thiền",
  },
  {
    word: "ngôi vị",
    part_of_speech: "danh từ",
    meaning:
      "ngôi thứ, danh vị (nói khái quát): mất ngôi vị độc tôn * bảo vệ ngôi vị quán quân",
    example: "mất ngôi vị độc tôn * bảo vệ ngôi vị quán quân",
  },
  {
    word: "ngồi xếp bằng",
    part_of_speech: "động từ",
    meaning:
      "ngồi gập hai chân lại và xếp chéo vào nhau, đùi và mông sát xuống mặt nền: ngồi xếp bằng trên sập",
    example: "ngồi xếp bằng trên sập",
  },
  {
    word: "ngồi tù",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) bị giam trong nhà tù: tham ô nên phải ngồi tù",
    example: "tham ô nên phải ngồi tù",
  },
  {
    word: "ngồm ngoàm",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như nhồm nhoàm: mồm nhai ngồm ngoàm",
    example: "mồm nhai ngồm ngoàm",
  },
  {
    word: "ngốn",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) ăn nhanh và nhiều một cách thô tục: ngốn một lúc hết mấy quả chuối",
    example: "ngốn một lúc hết mấy quả chuối",
  },
  {
    word: "ngốn",
    part_of_speech: "động từ",
    meaning:
      "tiêu thụ mất nhiều và nhanh quá mức bình thường: xe ngốn xăng * việc này ngốn nhiều thời gian",
    example: "xe ngốn xăng * việc này ngốn nhiều thời gian",
  },
  {
    word: "ngồn ngộn",
    part_of_speech: "tính từ",
    meaning: "đầy ngộn lên, trông ngợp mắt: đống thóc ngồn ngộn giữa sân",
    example: "đống thóc ngồn ngộn giữa sân",
  },
  {
    word: "ngộn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) nhiều đến mức đầy ứ lên, chồng chất lên, nhìn ngợp mắt: mâm cỗ đầy ngộn * công việc cứ ngộn lên",
    example: "mâm cỗ đầy ngộn * công việc cứ ngộn lên",
  },
  {
    word: "ngôn luận",
    part_of_speech: "động từ",
    meaning:
      "phát biểu, bày tỏ ý kiến một cách công khai, rộng rãi về những vấn đề chung như chính trị, kinh tế, xã hội, v.v.: quyền tự do ngôn luận * cơ quan ngôn luận",
    example: "quyền tự do ngôn luận * cơ quan ngôn luận",
  },
  {
    word: "ngốn ngấu",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) ngốn nhiều và liên tục: ngốn ngấu một lúc hết nải chuối",
    example: "ngốn ngấu một lúc hết nải chuối",
  },
  {
    word: "ngốn ngấu",
    part_of_speech: "động từ",
    meaning:
      "hoặc t (ăn, đọc) vội vã, liền một mạch, cốt lấy nhanh, lấy nhiều: đọc ngốn ngấu * ăn ngốn ngấu",
    example: "đọc ngốn ngấu * ăn ngốn ngấu",
  },
  {
    word: "ngôn ngữ",
    part_of_speech: "danh từ",
    meaning:
      "hệ thống những âm, những từ và những quy tắc kết hợp chúng, làm phương tiện để giao tiếp chung trong một cộng đồng: tiếng Anh là ngôn ngữ chính của người Anh, Mĩ * ngôn ngữ bất đồng",
    example:
      "tiếng Anh là ngôn ngữ chính của người Anh, Mĩ * ngôn ngữ bất đồng",
  },
  {
    word: "ngôn ngữ",
    part_of_speech: "danh từ",
    meaning:
      "hệ thống kí hiệu dùng làm phương tiện để diễn đạt, thông báo: ngôn ngữ nghệ thuật * ngôn ngữ hội hoạ * ngôn ngữ múa",
    example: "ngôn ngữ nghệ thuật * ngôn ngữ hội hoạ * ngôn ngữ múa",
  },
  {
    word: "ngôn ngữ",
    part_of_speech: "danh từ",
    meaning:
      "cách thức, nghệ thuật hay trình độ sử dụng ngôn ngữ có tính chất riêng: ngôn ngữ thơ * ngôn ngữ trẻ em",
    example: "ngôn ngữ thơ * ngôn ngữ trẻ em",
  },
  {
    word: "ngổn ngang",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái để chồng chất ở mọi chỗ, mọi nơi một cách không có hàng lối, không có trật tự: cây cối đổ ngổn ngang * trên bàn ngổn ngang sách vở",
    example: "cây cối đổ ngổn ngang * trên bàn ngổn ngang sách vở",
  },
  {
    word: "ngổn ngang",
    part_of_speech: "tính từ",
    meaning:
      '(ý nghĩ) lộn xộn và chồng chất, tựa như không gỡ, không thoát ra được: những ý nghĩ ngổn ngang trong đầu * "Cái bần là cái dở dang, Làm cho trăm mối ngổn ngang vì bần." (ca dao)',
    example:
      'những ý nghĩ ngổn ngang trong đầu * "Cái bần là cái dở dang, Làm cho trăm mối ngổn ngang vì bần." (ca dao)',
  },
  {
    word: "ngồn ngột",
    part_of_speech: "tính từ",
    meaning:
      "có cảm giác rất bức bối, khó thở vì quá nóng như ở nơi chật hẹp có đông người: căn phòng ngồn ngột hơi người",
    example: "căn phòng ngồn ngột hơi người",
  },
  {
    word: "ngồn ngột",
    part_of_speech: "tính từ",
    meaning: "như ngàn ngạt: tiếng nói ngồn ngột trong hơi thở",
    example: "tiếng nói ngồn ngột trong hơi thở",
  },
  {
    word: "ngôn ngữ lập trình",
    part_of_speech: "danh từ",
    meaning:
      "ngôn ngữ dùng để viết chương trình cho máy tính: ngôn ngữ lập trình Pascal",
    example: "ngôn ngữ lập trình Pascal",
  },
  {
    word: "ngôn từ",
    part_of_speech: "danh từ",
    meaning:
      "từ ngữ được diễn đạt thành lời, thành văn bản (nói khái quát): nghệ thuật sử dụng ngôn từ * ngôn từ sắc sảo",
    example: "nghệ thuật sử dụng ngôn từ * ngôn từ sắc sảo",
  },
  {
    word: "ngôn ngữ học",
    part_of_speech: "danh từ",
    meaning: "khoa học nghiên cứu về ngôn ngữ: nhà ngôn ngữ học",
    example: "nhà ngôn ngữ học",
  },
  {
    word: "ngông",
    part_of_speech: "tính từ",
    meaning:
      "có những lời nói, việc làm ngang tàng, khác lẽ thường, bất chấp sự khen chê của người đời: tính thích chơi ngông * nói ngông",
    example: "tính thích chơi ngông * nói ngông",
  },
  {
    word: "ngỗng",
    part_of_speech: "danh từ",
    meaning:
      "chim cùng họ với vịt, nhưng mình to và cổ dài hơn: trứng ngỗng * cổ dài như cổ ngỗng",
    example: "trứng ngỗng * cổ dài như cổ ngỗng",
  },
  {
    word: "ngỗng",
    part_of_speech: "danh từ",
    meaning: "be cổ dài, thời trước dùng đựng rượu: cái ngỗng rượu bằng sành",
    example: "cái ngỗng rượu bằng sành",
  },
  {
    word: "ngồng",
    part_of_speech: "danh từ",
    meaning:
      "thân non của một số cây, như cải, thuốc lá, v.v., mọc cao vổng lên và mang hoa: ngồng cải",
    example: "ngồng cải",
  },
  {
    word: "ngồng",
    part_of_speech: "tính từ",
    meaning: "cao, lớn vượt hẳn lên, trông hơi khác thường: người cao ngồng",
    example: "người cao ngồng",
  },
  {
    word: "ngông cuồng",
    part_of_speech: "tính từ",
    meaning:
      "có những suy nghĩ, hành động ngược với lẽ thường đến mức như cuồng dại mà không còn có đủ tự chủ để suy xét đúng sai nữa: ăn nói ngông cuồng * hành động ngông cuồng",
    example: "ăn nói ngông cuồng * hành động ngông cuồng",
  },
  {
    word: "ngông nghênh",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra tự đắc, coi thường mọi người, bằng những thái độ, cử chỉ gây cảm giác khó chịu: tính khí ngông nghênh * lời lẽ ngông nghênh",
    example: "tính khí ngông nghênh * lời lẽ ngông nghênh",
  },
  {
    word: "ngột",
    part_of_speech: "",
    meaning: "(phương ngữ) ngạt: ngột thở",
    example: "ngột thở",
  },
  {
    word: "ngộp",
    part_of_speech: "",
    meaning: "(Nam) ngạt (= không thở được): ngộp thở * chết ngộp",
    example: "ngộp thở * chết ngộp",
  },
  {
    word: "ngộp",
    part_of_speech: "",
    meaning: "ngợp: lên cao thấy hơi ngộp",
    example: "lên cao thấy hơi ngộp",
  },
  {
    word: "ngột ngạt",
    part_of_speech: "tính từ",
    meaning:
      "có cảm giác rất khó thở do nóng bức hoặc thiếu không khí (nói khái quát): hơi nóng ngột ngạt * căn phòng ngột ngạt",
    example: "hơi nóng ngột ngạt * căn phòng ngột ngạt",
  },
  {
    word: "ngột ngạt",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái cảm thấy bức bối, không chịu đựng nổi cuộc sống vì tinh thần bị đè nén nặng nề: cuộc sống ngột ngạt",
    example: "cuộc sống ngột ngạt",
  },
  {
    word: "ngốt",
    part_of_speech: "tính từ",
    meaning:
      "cảm thấy ngột ngạt, bức bối, khó chịu vì nóng bức: nóng ngốt người * việc nhiều trông phát ngốt",
    example: "nóng ngốt người * việc nhiều trông phát ngốt",
  },
  {
    word: "ngốt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) cảm thấy thèm muốn cái đang nhìn thấy trước mắt, đến mức choáng ngợp không còn thấy cái gì khác nữa: ngốt của * thấy tiền mà ngốt",
    example: "ngốt của * thấy tiền mà ngốt",
  },
  {
    word: "ngơ",
    part_of_speech: "động từ",
    meaning:
      "lờ đi như không biết để bỏ qua: ngoảnh mặt làm ngơ * xin ông thương tình mà ngơ đi cho!",
    example: "ngoảnh mặt làm ngơ * xin ông thương tình mà ngơ đi cho!",
  },
  {
    word: "ngớ",
    part_of_speech: "động từ",
    meaning:
      "lặng người đi, không kịp phản ứng gì trước một sự việc, một hiện tượng đột ngột xảy ra: ngớ người trước câu hỏi bất ngờ * đứng ngớ ra nhìn",
    example: "ngớ người trước câu hỏi bất ngờ * đứng ngớ ra nhìn",
  },
  {
    word: "ngờ",
    part_of_speech: "động từ",
    meaning:
      "cảm thấy khó tin và nghĩ là có thể không phải như thế, nhưng không có cơ sở để khẳng định: những con số đáng ngờ * nửa tin nửa ngờ * một mất mười ngờ (tng)",
    example: "những con số đáng ngờ * nửa tin nửa ngờ * một mất mười ngờ (tng)",
  },
  {
    word: "ngờ",
    part_of_speech: "động từ",
    meaning:
      'cứ nghĩ là như thế (nhưng thực ra lại không phải thế): điều không ngờ tới * "Tưởng bây giờ là bao giờ, Rõ ràng mở mắt còn ngờ chiêm bao!" (TKiều)',
    example:
      'điều không ngờ tới * "Tưởng bây giờ là bao giờ, Rõ ràng mở mắt còn ngờ chiêm bao!" (TKiều)',
  },
  {
    word: "ngờ",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ, hoặc kng) nghi ngờ (nói tắt): sự việc rất rõ ràng, không còn ngờ gì nữa * bị ngờ oan",
    example: "sự việc rất rõ ràng, không còn ngờ gì nữa * bị ngờ oan",
  },
  {
    word: "ngỡ",
    part_of_speech: "động từ",
    meaning:
      'nghĩ là, cho là như thế nào đó khi sự thật không phải thế, vì không kịp suy xét mà đã nhầm hoặc vì quá bất ngờ nên không dám tin: chuyện đùa mà ngỡ thật * "Thế gian lắm kẻ mơ màng, Thấy hòn son thắm ngỡ vàng nhặt đeo." (ca dao)',
    example:
      'chuyện đùa mà ngỡ thật * "Thế gian lắm kẻ mơ màng, Thấy hòn son thắm ngỡ vàng nhặt đeo." (ca dao)',
  },
  {
    word: "ngợ",
    part_of_speech: "động từ",
    meaning:
      "hơi ngờ, chưa dám chắc, dám tin hẳn vào điều đã nghe, đã thấy: thấy tên trong danh sách rồi mà vẫn còn ngợ",
    example: "thấy tên trong danh sách rồi mà vẫn còn ngợ",
  },
  {
    word: "ngơ ngác",
    part_of_speech: "",
    meaning:
      "ở trạng thái không định thần được trước cảnh vật quá xa lạ hoặc sự việc diễn biến quá bất ngờ: vẻ mặt ngơ ngác",
    example: "vẻ mặt ngơ ngác",
  },
  {
    word: "ngờ ngạc",
    part_of_speech: "tính từ",
    meaning: "như ngơ ngác (nhưng nghĩa mạnh hơn): ngờ ngạc nhìn quanh",
    example: "ngờ ngạc nhìn quanh",
  },
  {
    word: "ngờ đâu",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị điều thực tế sắp nêu ra là trái ngược với điều suy nghĩ trước đó, là hoàn toàn không ngờ tới: ngờ đâu cơ sự lại đến nông nỗi này!",
    example: "ngờ đâu cơ sự lại đến nông nỗi này!",
  },
  {
    word: "ngỡ ngàng",
    part_of_speech: "tính từ",
    meaning:
      "cảm thấy hết sức ngạc nhiên trước những điều mới lạ hoặc những điều trước đó không nghĩ tới, không ngờ tới: ngỡ ngàng trước sự đổi thay",
    example: "ngỡ ngàng trước sự đổi thay",
  },
  {
    word: "ngơ ngáo",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ngơ ngác, vẻ ngạc nhiên, ngỡ ngàng như chẳng hiểu gì: vẻ mặt ngơ ngáo",
    example: "vẻ mặt ngơ ngáo",
  },
  {
    word: "ngơ ngơ",
    part_of_speech: "tính từ",
    meaning:
      'ngẩn người ra, có vẻ như không hiểu, không ứng phó kịp thời đối với những hiện tượng, sự việc xảy ra xung quanh: "(…) đầu óc tôi lú lẫn, tôi chỉ nhìn ngơ ngơ chứ không biết hỏi họ câu gì!" (NgKiên; 16)',
    example:
      '(…) đầu óc tôi lú lẫn, tôi chỉ nhìn ngơ ngơ chứ không biết hỏi họ câu gì!" (NgKiên; 16)',
  },
  {
    word: "ngờ nghệch",
    part_of_speech: "tính từ",
    meaning:
      "dại dột, vụng về trong cách ứng phó với hoàn cảnh, do chưa từng trải hoặc kém tinh khôn: bộ mặt ngờ nghệch * ngây thơ đến ngờ nghệch",
    example: "bộ mặt ngờ nghệch * ngây thơ đến ngờ nghệch",
  },
  {
    word: "ngơ ngẩn",
    part_of_speech: "tính từ",
    meaning:
      'như ngẩn ngơ (ng1): ngơ ngẩn nhìn theo * "Ngọn đèn khi tỏ khi mờ, Khiến người ngồi đó cũng ngơ ngẩn sầu." (TKiều)',
    example:
      'ngơ ngẩn nhìn theo * "Ngọn đèn khi tỏ khi mờ, Khiến người ngồi đó cũng ngơ ngẩn sầu." (TKiều)',
  },
  {
    word: "ngớ ngẩn",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái ngờ nghệch, không hiểu biết gì, lạc lõng với hoàn cảnh xung quanh: bộ mặt ngớ ngẩn * ăn nói rõ ngớ ngẩn!",
    example: "bộ mặt ngớ ngẩn * ăn nói rõ ngớ ngẩn!",
  },
  {
    word: "ngờ ngợ",
    part_of_speech: "động từ",
    meaning:
      "hơi ngờ, nửa tin nửa còn chưa tin hẳn vào điều đã thấy, đã nghe: trông ngờ ngợ như đã gặp ở đâu rồi",
    example: "trông ngờ ngợ như đã gặp ở đâu rồi",
  },
  {
    word: "ngơ ngơ ngẩn ngẩn",
    part_of_speech: "tính từ",
    meaning:
      "như ngẩn ngơ (ng2; nhưng ý nhấn mạnh hơn): sau trận ốm, người cứ ngơ ngơ ngẩn ngẩn",
    example: "sau trận ốm, người cứ ngơ ngơ ngẩn ngẩn",
  },
  {
    word: "ngờ vực",
    part_of_speech: "động từ",
    meaning:
      "chưa tin, vì cho rằng có thể không đúng sự thật: ánh mắt ngờ vực * không mảy may ngờ vực",
    example: "ánh mắt ngờ vực * không mảy may ngờ vực",
  },
  {
    word: "ngời",
    part_of_speech: "tính từ",
    meaning:
      "sáng bừng lên, đẹp nổi bật hẳn lên: đôi mắt rạng ngời * “Trăng sáng soi thẳng vào khuôn mặt Nguyệt làm cho khuôn mặt tươi mát ngời lên và đẹp lạ thường!” (NgMChâu; 4)",
    example:
      "đôi mắt rạng ngời * “Trăng sáng soi thẳng vào khuôn mặt Nguyệt làm cho khuôn mặt tươi mát ngời lên và đẹp lạ thường!” (NgMChâu; 4)",
  },
  {
    word: "ngơi nghỉ",
    part_of_speech: "động từ",
    meaning: "như nghỉ ngơi: làm việc không ngơi nghỉ",
    example: "làm việc không ngơi nghỉ",
  },
  {
    word: "ngờm ngợp",
    part_of_speech: "",
    meaning: "hơi ngợp: bãi dâu xanh ngờm ngợp",
    example: "bãi dâu xanh ngờm ngợp",
  },
  {
    word: "ngợi khen",
    part_of_speech: "động từ",
    meaning:
      '(văn chương) như khen ngợi: "Đã nên có nghĩa, có nhân, Trước sau trọn vẹn, xa gần ngợi khen." (TKiều)',
    example:
      'Đã nên có nghĩa, có nhân, Trước sau trọn vẹn, xa gần ngợi khen." (TKiều)',
  },
  {
    word: "ngơm ngớp",
    part_of_speech: "động từ",
    meaning: "(hiếm) như nơm nớp: lo ngơm ngớp * ngơm ngớp lo sợ",
    example: "lo ngơm ngớp * ngơm ngớp lo sợ",
  },
  {
    word: "ngời ngợi",
    part_of_speech: "tính từ",
    meaning: "như ngời ngời: bầu trời tuyết trắng ngời ngợi",
    example: "bầu trời tuyết trắng ngời ngợi",
  },
  {
    word: "ngơi ngớt",
    part_of_speech: "động từ",
    meaning:
      "(mức độ) giảm dần, ngớt dần đi: nỗi đau đã ngơi ngớt * cơn mưa ngơi ngớt dần",
    example: "nỗi đau đã ngơi ngớt * cơn mưa ngơi ngớt dần",
  },
  {
    word: "ngời ngời",
    part_of_speech: "tính từ",
    meaning: "như ngời (nhưng ý nhấn mạnh hơn): đẹp ngời ngời",
    example: "đẹp ngời ngời",
  },
  {
    word: "ngơn ngớt",
    part_of_speech: "động từ",
    meaning: "ngớt dần đi: đợi ngơn ngớt mưa hãy đi",
    example: "đợi ngơn ngớt mưa hãy đi",
  },
  {
    word: "ngớp",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như ngốt (ng2): ngớp của",
    example: "ngớp của",
  },
  {
    word: "ngợm",
    part_of_speech: "danh từ",
    meaning:
      "con vật tưởng tượng, có vẻ giống người nhưng hình thù rất xấu xí: nửa người, nửa ngợm",
    example: "nửa người, nửa ngợm",
  },
  {
    word: "ngớt",
    part_of_speech: "động từ",
    meaning:
      "giảm đi một phần về mức độ: trời đã ngớt mưa * ngớt tiếng súng * khen không ngớt lời",
    example: "trời đã ngớt mưa * ngớt tiếng súng * khen không ngớt lời",
  },
  {
    word: "ngù",
    part_of_speech: "danh từ",
    meaning:
      "(Từ cũ) núm tròn chụp lên chóp mũ nón, cán cờ, cán binh khí thời trước, thường có đính những tua màu đẹp rủ xuống hoặc chòm lông dài: ngù giáo * ngù mũ",
    example: "ngù giáo * ngù mũ",
  },
  {
    word: "ngợp",
    part_of_speech: "động từ",
    meaning:
      "có cảm giác như chóng mặt và sợ hãi, khi bỗng nhiên cảm thấy mình thật nhỏ bé và bất lực trước cái gì đó quá lớn, quá cao, quá rộng: bị ngợp trước biển rộng mênh mông * càng lên cao càng thấy ngợp",
    example: "bị ngợp trước biển rộng mênh mông * càng lên cao càng thấy ngợp",
  },
  {
    word: "ngợp",
    part_of_speech: "động từ",
    meaning:
      "chiếm đầy khắp, như bao trùm cả không gian, gây cảm giác như thấy mình thật bé nhỏ: khói lửa ngợp trời * cờ xí ngợp đường",
    example: "khói lửa ngợp trời * cờ xí ngợp đường",
  },
  {
    word: "ngủ",
    part_of_speech: "động từ",
    meaning:
      "nhắm mắt lại, tạm dừng mọi hoạt động chân tay và tri giác, bắp thịt dãn mềm, các hoạt động hô hấp, tuần hoàn chậm lại, toàn bộ cơ thể được nghỉ ngơi (một trạng thái sinh lí thường có tính chất chu kì theo ngày đêm): ru cho bé ngủ * mắt lim dim buồn ngủ",
    example: "ru cho bé ngủ * mắt lim dim buồn ngủ",
  },
  {
    word: "ngủ",
    part_of_speech: "động từ",
    meaning:
      "(động, thực vật) ở trạng thái giảm hẳn sự hoạt động và phát triển trong một thời gian: thời gian ngủ của mầm * gấu ngủ đông",
    example: "thời gian ngủ của mầm * gấu ngủ đông",
  },
  {
    word: "ngu",
    part_of_speech: "tính từ",
    meaning:
      'rất kém về trí lực, không hiểu biết gì về cả những điều ai cũng hiểu, cũng biết: đồ ngu! (tiếng mắng) * "Rồng vàng tắm nước ao tù, Người khôn ở với người ngu bực mình." (Cdao)',
    example:
      'đồ ngu! (tiếng mắng) * "Rồng vàng tắm nước ao tù, Người khôn ở với người ngu bực mình." (Cdao)',
  },
  {
    word: "ngụ",
    part_of_speech: "động từ",
    meaning: "ở, cư trú: ngụ ở một làng chài * xin ngụ đỡ một đêm",
    example: "ngụ ở một làng chài * xin ngụ đỡ một đêm",
  },
  {
    word: "ngụ",
    part_of_speech: "động từ",
    meaning: "ngụ ý (nói tắt): ánh mắt ngụ vẻ trìu mến",
    example: "ánh mắt ngụ vẻ trìu mến",
  },
  {
    word: "ngũ âm",
    part_of_speech: "danh từ",
    meaning:
      'hệ thống âm nhạc có năm nốt trong phạm vi một quãng tám, thường gặp ở âm nhạc dân gian: "Cung thương làu bậc ngũ âm, Nghề riêng ăn đứt hồ cầm một trương." (TKiều)',
    example:
      'Cung thương làu bậc ngũ âm, Nghề riêng ăn đứt hồ cầm một trương." (TKiều)',
  },
  {
    word: "ngũ âm",
    part_of_speech: "danh từ",
    meaning:
      "dàn nhạc nhỏ gồm năm thứ nhạc khí, chuyên dùng trong hội hè đình đám ngày xưa ở miền Nam Việt Nam: nhạc ngũ âm",
    example: "nhạc ngũ âm",
  },
  {
    word: "ngũ cúng",
    part_of_speech: "danh từ",
    meaning:
      'năm thứ đồ lễ để cúng Phật (nước, hương, hoa, cơm, đèn), theo tín ngưỡng dân gian: "Tâng tâng trời mới bình minh, Hương hoa, ngũ cúng, sắm sanh lễ thường." (TKiều)',
    example:
      'Tâng tâng trời mới bình minh, Hương hoa, ngũ cúng, sắm sanh lễ thường." (TKiều)',
  },
  {
    word: "ngu dân",
    part_of_speech: "động từ",
    meaning:
      "(cũ) kìm hãm dân chúng trong vòng ngu dốt, tối tăm để dễ bề cai trị: chính sách ngu dân",
    example: "chính sách ngu dân",
  },
  {
    word: "ngụ cư",
    part_of_speech: "động từ",
    meaning:
      "sinh sống ở một nơi không phải quê hương bản quán của mình: dân ngụ cư",
    example: "dân ngụ cư",
  },
  {
    word: "ngủ đậu",
    part_of_speech: "động từ",
    meaning: "ngủ nhờ, ngủ tạm ở nhà người khác: lỡ đường, xin ngủ đậu một đêm",
    example: "lỡ đường, xin ngủ đậu một đêm",
  },
  {
    word: "ngủ gà",
    part_of_speech: "động từ",
    meaning:
      "ngủ lơ mơ, mắt khép không chặt, thỉnh thoảng lại choàng tỉnh, giống như gà ngủ: mắt lơ mơ như ngủ gà",
    example: "mắt lơ mơ như ngủ gà",
  },
  {
    word: "ngu dốt",
    part_of_speech: "tính từ",
    meaning:
      "ngu và dốt nát, không hiểu biết gì (nói khái quát): đầu óc ngu dốt",
    example: "đầu óc ngu dốt",
  },
  {
    word: "ngu dại",
    part_of_speech: "tính từ",
    meaning: "vừa ngu vừa dại (nói khái quát): đầu óc ngu dại",
    example: "đầu óc ngu dại",
  },
  {
    word: "ngu đần",
    part_of_speech: "tính từ",
    meaning: "ngu và đần (nói khái quát): đầu óc ngu đần",
    example: "đầu óc ngu đần",
  },
  {
    word: "ngu độn",
    part_of_speech: "tính từ",
    meaning: "như ngu đần: hạng người ngu độn",
    example: "hạng người ngu độn",
  },
  {
    word: "ngủ đông",
    part_of_speech: "động từ",
    meaning:
      "ngủ kéo dài vào mùa đông (một trạng thái sinh lí của nhiều động vật ở xứ lạnh): gấu ngủ đông",
    example: "gấu ngủ đông",
  },
  {
    word: "ngũ đoản",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) (người) thấp lùn, chân tay đều ngắn: người có tướng ngũ đoản",
    example: "người có tướng ngũ đoản",
  },
  {
    word: "ngũ giác",
    part_of_speech: "danh từ",
    meaning: "đa giác có năm cạnh: hình ngũ giác",
    example: "hình ngũ giác",
  },
  {
    word: "ngũ kinh",
    part_of_speech: "danh từ",
    meaning:
      "năm bộ sách được coi là kinh điển của nho giáo: kinh Thi, kinh Thư, kinh Lễ, kinh Dịch, kinh Xuân Thu (nói tổng quát): sách ngũ kinh",
    example: "sách ngũ kinh",
  },
  {
    word: "ngũ giới",
    part_of_speech: "danh từ",
    meaning:
      "năm điều răn của đạo Phật: không sát sinh, không trộm cắp, không tà dâm, không nói càn, không uống rượu ăn thịt (nói tổng quát): phạm phải một trong ngũ giới",
    example: "phạm phải một trong ngũ giới",
  },
  {
    word: "ngủ gật",
    part_of_speech: "động từ",
    meaning:
      "ngủ ở tư thế ngồi hoặc đứng, đầu thỉnh thoảng lại gật một cái: ngủ gật trong lớp * ngồi ngủ gật",
    example: "ngủ gật trong lớp * ngồi ngủ gật",
  },
  {
    word: "ngũ kim",
    part_of_speech: "danh từ",
    meaning:
      "các thứ kim loại để chế tạo đồ dùng, như đồng, sắt, nhôm, v.v. (nói khái quát): buôn bán đồ ngũ kim",
    example: "buôn bán đồ ngũ kim",
  },
  {
    word: "ngũ hành",
    part_of_speech: "danh từ",
    meaning:
      "năm nguyên tố cấu tạo nên vạn vật, theo quan niệm triết học Trung Quốc cổ đại: kim kim loại, mộc gỗ, thuỷ nước, hoả lửa, thổ đất (nói tổng quát): thuyết âm dương, ngũ hành",
    example: "thuyết âm dương, ngũ hành",
  },
  {
    word: "ngủ khì",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) ngủ rất say, không biết gì hết: đứa bé bú no đã ngủ khì",
    example: "đứa bé bú no đã ngủ khì",
  },
  {
    word: "ngủ ngáy",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) như ngủ nghê: mới đặt lưng chứ đã ngủ ngáy gì đâu!",
    example: "mới đặt lưng chứ đã ngủ ngáy gì đâu!",
  },
  {
    word: "ngũ liên",
    part_of_speech: "danh từ",
    meaning:
      'tiếng trống liên tiếp, dồn dập, mỗi nhịp năm tiếng, để thúc giục hay báo động khẩn cấp: "Thùng thùng trống đánh ngũ liên, Bước chân xuống thuyền nước mắt như mưa." (ca dao)',
    example:
      'Thùng thùng trống đánh ngũ liên, Bước chân xuống thuyền nước mắt như mưa." (ca dao)',
  },
  {
    word: "ngu muội",
    part_of_speech: "tính từ",
    meaning: "ngu dốt, tối tăm, không hiểu biết gì: đầu óc ngu muội",
    example: "đầu óc ngu muội",
  },
  {
    word: "ngu ngơ",
    part_of_speech: "tính từ",
    meaning: "ngây ngô, khờ dại: bộ mặt ngu ngơ * hỏi một câu rất ngu ngơ",
    example: "bộ mặt ngu ngơ * hỏi một câu rất ngu ngơ",
  },
  {
    word: "ngủ nghê",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) ngủ (nói khái quát): ăn uống, ngủ nghê điều độ",
    example: "ăn uống, ngủ nghê điều độ",
  },
  {
    word: "ngủ mê",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) ngủ rất say: vừa nằm xuống đã ngủ mê",
    example: "vừa nằm xuống đã ngủ mê",
  },
  {
    word: "ngủ mê",
    part_of_speech: "động từ",
    meaning:
      'như nằm mơ: "Đêm qua trằn trọc canh dài, Ngủ mê cứ tưởng rằng người đắp chung." (ca dao)',
    example:
      'Đêm qua trằn trọc canh dài, Ngủ mê cứ tưởng rằng người đắp chung." (ca dao)',
  },
  {
    word: "ngụ ngôn",
    part_of_speech: "danh từ",
    meaning:
      "bài thơ hoặc truyện ngắn mượn chuyện loài vật để nói về việc đời, nhằm giáo dục về đạo lí, về kinh nghiệm sống: thơ ngụ ngôn * truyện ngụ ngôn của La Fontaine",
    example: "thơ ngụ ngôn * truyện ngụ ngôn của La Fontaine",
  },
  {
    word: "ngu ngốc",
    part_of_speech: "tính từ",
    meaning: "rất ngốc (nói khái quát): cách xử sự thật ngu ngốc",
    example: "cách xử sự thật ngu ngốc",
  },
  {
    word: "ngũ ngôn",
    part_of_speech: "danh từ",
    meaning: "thể thơ mỗi câu có năm âm tiết: thơ ngũ ngôn",
    example: "thơ ngũ ngôn",
  },
  {
    word: "ngù ngờ",
    part_of_speech: "tính từ",
    meaning:
      '(khẩu ngữ) chậm chạp, lờ đờ, thiếu tinh nhanh: đầu óc ngù ngờ * "Sông sâu cá lội ngù ngờ, Biết em có đợi mà chờ uổng công." (ca dao)',
    example:
      'đầu óc ngù ngờ * "Sông sâu cá lội ngù ngờ, Biết em có đợi mà chờ uổng công." (ca dao)',
  },
  {
    word: "ngũ quả",
    part_of_speech: "danh từ",
    meaning:
      "các thứ hoa quả (ngày trước vốn gồm năm thứ, là chuối tiêu, bưởi (hoặc phật thủ), quýt, nho, táo) được bày chung với nhau trong ngày Tết Nguyên Đán (nói tổng quát): mâm ngũ quả",
    example: "mâm ngũ quả",
  },
  {
    word: "ngũ sắc",
    part_of_speech: "danh từ",
    meaning:
      "năm màu chính thường dùng trong trang trí: xanh, vàng, đỏ, trắng, đen (nói tổng quát): chỉ ngũ sắc * pháo hoa ngũ sắc",
    example: "chỉ ngũ sắc * pháo hoa ngũ sắc",
  },
  {
    word: "ngu si",
    part_of_speech: "tính từ",
    meaning:
      "rất ngu, hầu như chẳng biết gì: đầu óc ngu si * kẻ ngu si dốt nát",
    example: "đầu óc ngu si * kẻ ngu si dốt nát",
  },
  {
    word: "nguẩy",
    part_of_speech: "động từ",
    meaning:
      "quay ngoắt đi, biểu thị thái độ không bằng lòng: nguẩy đầu từ chối * nguẩy một cái rồi đi thẳng",
    example: "nguẩy đầu từ chối * nguẩy một cái rồi đi thẳng",
  },
  {
    word: "ngu tối",
    part_of_speech: "tính từ",
    meaning: "như ngu muội: đầu óc ngu tối",
    example: "đầu óc ngu tối",
  },
  {
    word: "ngũ vị",
    part_of_speech: "danh từ",
    meaning: "năm vị: ngọt, chua, đắng, cay, mặn (nói tổng quát): mứt ngũ vị",
    example: "mứt ngũ vị",
  },
  {
    word: "ngũ tuần",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, trang trọng) năm mươi tuổi: tuổi ngoại ngũ tuần (ngoài năm mươi tuổi)",
    example: "tuổi ngoại ngũ tuần (ngoài năm mươi tuổi)",
  },
  {
    word: "ngụ ý",
    part_of_speech: "",
    meaning:
      "ý kín đáo, ẩn trong câu nói, bài văn hay trong cử chỉ, dáng điệu để người khác tự suy ra mà hiểu: hiểu được ngụ ý của tác giả * cái nhìn đầy ngụ ý",
    example: "hiểu được ngụ ý của tác giả * cái nhìn đầy ngụ ý",
  },
  {
    word: "ngu xuẩn",
    part_of_speech: "tính từ",
    meaning:
      "rất ngu, đến mức như không có một chút trí khôn nào: làm điều ngu xuẩn * ăn nói ngu xuẩn",
    example: "làm điều ngu xuẩn * ăn nói ngu xuẩn",
  },
  {
    word: "ngục tù",
    part_of_speech: "danh từ",
    meaning: "nhà tù, nhà lao (nói khái quát): chốn ngục tù",
    example: "chốn ngục tù",
  },
  {
    word: "nguây nguẩy",
    part_of_speech: "động từ",
    meaning:
      "từ gợi tả bộ điệu tỏ ý không bằng lòng, không đồng ý bằng những động tác như vung vẩy tay chân, lắc đầu, nhún vai, v.v.: lắc đầu nguây nguẩy * chưa nghe hết đã nguây nguẩy quay đi",
    example: "lắc đầu nguây nguẩy * chưa nghe hết đã nguây nguẩy quay đi",
  },
  {
    word: "ngục",
    part_of_speech: "danh từ",
    meaning: "(Từ cũ) nhà tù: bị giam vào ngục * lính cai ngục * vượt ngục",
    example: "bị giam vào ngục * lính cai ngục * vượt ngục",
  },
  {
    word: "ngục thất",
    part_of_speech: "danh từ",
    meaning: "(cũ) nhà tù: giam trong ngục thất",
    example: "giam trong ngục thất",
  },
  {
    word: "nguếch ngoác",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như nguệch ngoạc: chữ viết nguếch ngoác",
    example: "chữ viết nguếch ngoác",
  },
  {
    word: "nguệch ngoạc",
    part_of_speech: "tính từ",
    meaning:
      "(nét viết hoặc vẽ) xiên xẹo, méo mó, do chưa thạo hoặc do vội vàng, cẩu thả: nét chữ nguệch ngoạc",
    example: "nét chữ nguệch ngoạc",
  },
  {
    word: "ngúc ngắc",
    part_of_speech: "động từ",
    meaning: "lắc qua lắc lại: vừa nói vừa ngúc ngắc cái đầu",
    example: "vừa nói vừa ngúc ngắc cái đầu",
  },
  {
    word: "ngúc ngắc",
    part_of_speech: "tính từ",
    meaning:
      "có chỗ vấp váp, vướng mắc, không trôi chảy: đọc ngúc ngắc * công việc còn có chỗ ngúc ngắc",
    example: "đọc ngúc ngắc * công việc còn có chỗ ngúc ngắc",
  },
  {
    word: "ngùi",
    part_of_speech: "tính từ",
    meaning:
      '(hiếm) như bùi ngùi: "Tôi ra đứng ở đầu làng, Ngùi trông theo chị khuất ngàn dâu thưa." (NgBính; 11)',
    example:
      'Tôi ra đứng ở đầu làng, Ngùi trông theo chị khuất ngàn dâu thưa." (NgBính; 11)',
  },
  {
    word: "ngùi ngùi",
    part_of_speech: "tính từ",
    meaning:
      'như bùi ngùi: trong dạ ngùi ngùi * "Chiều chiều ra ngõ ngó xuôi, Ngó không thấy mẹ, ngùi ngùi nhớ thương." (ca dao)',
    example:
      'trong dạ ngùi ngùi * "Chiều chiều ra ngõ ngó xuôi, Ngó không thấy mẹ, ngùi ngùi nhớ thương." (ca dao)',
  },
  {
    word: "ngụm",
    part_of_speech: "danh từ",
    meaning:
      "lượng chất lỏng trong miệng mỗi lần uống: ngụm rượu * ngụm nước * uống từng ngụm nhỏ",
    example: "ngụm rượu * ngụm nước * uống từng ngụm nhỏ",
  },
  {
    word: "ngún",
    part_of_speech: "động từ",
    meaning: "cháy ngầm, không bốc thành ngọn: đám trấu cháy ngún",
    example: "đám trấu cháy ngún",
  },
  {
    word: "ngun ngút",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như nghi ngút: khói bốc lên ngun ngút",
    example: "khói bốc lên ngun ngút",
  },
  {
    word: "ngùn ngụt",
    part_of_speech: "tính từ",
    meaning:
      "(lửa, khói bốc lên) mạnh thành ngọn, thành luồng lớn: nước sôi bốc hơi ngùn ngụt * lửa cháy ngùn ngụt",
    example: "nước sôi bốc hơi ngùn ngụt * lửa cháy ngùn ngụt",
  },
  {
    word: "ngủng ngẳng",
    part_of_speech: "động từ",
    meaning:
      "từ gợi tả dáng vẻ, cử chỉ tỏ ra lạnh nhạt, không mặn mà, đằm thắm do không ưa, không vừa ý hoặc không thích có quan hệ: lợn ngủng nghỉnh chê cám * vợ chồng ngủng nghỉnh",
    example: "lợn ngủng nghỉnh chê cám * vợ chồng ngủng nghỉnh",
  },
  {
    word: "ngùng ngoằng",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như loằng ngoằng: dây dợ ngùng ngoằng",
    example: "dây dợ ngùng ngoằng",
  },
  {
    word: "ngủng nghỉnh",
    part_of_speech: "động từ",
    meaning:
      "từ gợi tả dáng vẻ, cử chỉ tỏ ra lạnh nhạt, không mặn mà, đằm thắm do không ưa, không vừa ý hoặc không thích có quan hệ: lợn ngủng nghỉnh chê cám * vợ chồng ngủng nghỉnh",
    example: "lợn ngủng nghỉnh chê cám * vợ chồng ngủng nghỉnh",
  },
  {
    word: "nguội lạnh",
    part_of_speech: "tính từ",
    meaning:
      "nguội đến mức như lạnh đi: mâm cơm nguội lạnh * bàn thờ để nguội lạnh không hương khói",
    example: "mâm cơm nguội lạnh * bàn thờ để nguội lạnh không hương khói",
  },
  {
    word: "nguôi ngoai",
    part_of_speech: "động từ",
    meaning:
      "nguôi (nói khái quát): nỗi đau cũng nguôi ngoai dần theo năm tháng",
    example: "nỗi đau cũng nguôi ngoai dần theo năm tháng",
  },
  {
    word: "ngủng ngoẳng",
    part_of_speech: "động từ",
    meaning:
      "từ gợi tả dáng vẻ, cử chỉ tỏ ra lạnh nhạt, không mặn mà, đằm thắm do không ưa, không vừa ý hoặc không thích có quan hệ: lợn ngủng nghỉnh chê cám * vợ chồng ngủng nghỉnh",
    example: "lợn ngủng nghỉnh chê cám * vợ chồng ngủng nghỉnh",
  },
  {
    word: "ngúng nguẩy",
    part_of_speech: "động từ",
    meaning:
      "từ gợi tả bộ điệu vùng vằng tỏ ra không vừa lòng hay giận dỗi, bằng những động tác như vung vẩy tay chân, lắc đầu, quay ngoắt người đi, v.v.: dáng đi ngúng nguẩy * ngúng nguẩy từ chối",
    example: "dáng đi ngúng nguẩy * ngúng nguẩy từ chối",
  },
  {
    word: "nguôi",
    part_of_speech: "động từ",
    meaning:
      "(trạng thái tình cảm hay cảm xúc mạnh) giảm bớt dần mức độ: nguôi lòng * nguôi cơn giận * nỗi buồn khôn nguôi",
    example: "nguôi lòng * nguôi cơn giận * nỗi buồn khôn nguôi",
  },
  {
    word: "nguội",
    part_of_speech: "tính từ",
    meaning:
      "không còn nóng nữa, trở thành có nhiệt độ bình thường: cơm nguội * nước đun sôi để nguội * bếp lửa đã nguội",
    example: "cơm nguội * nước đun sôi để nguội * bếp lửa đã nguội",
  },
  {
    word: "nguội",
    part_of_speech: "danh từ",
    meaning:
      "phương pháp chế tạo, sửa chữa, lắp ráp các sản phẩm kim loại theo lối thủ công: phân xưởng nguội * làm nguội * thợ nguội",
    example: "phân xưởng nguội * làm nguội * thợ nguội",
  },
  {
    word: "nguội ngắt",
    part_of_speech: "tính từ",
    meaning:
      "nguội hoàn toàn, không còn chút hơi nóng nào: cơm canh nguội ngắt",
    example: "cơm canh nguội ngắt",
  },
  {
    word: "nguôi quên",
    part_of_speech: "động từ",
    meaning: "nguôi dần, quên dần đi: nỗi đau không thể nguôi quên",
    example: "nỗi đau không thể nguôi quên",
  },
  {
    word: "nguồn",
    part_of_speech: "danh từ",
    meaning: "nơi bắt đầu của sông, suối: nguồn sông * nơi đầu nguồn",
    example: "nguồn sông * nơi đầu nguồn",
  },
  {
    word: "nguồn",
    part_of_speech: "danh từ",
    meaning:
      "nơi bắt đầu, nơi phát sinh ra hoặc nơi có thể cung cấp: nguồn bệnh * nguồn vốn * khơi nguồn cảm xúc",
    example: "nguồn bệnh * nguồn vốn * khơi nguồn cảm xúc",
  },
  {
    word: "nguồn cơn",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương) đầu đuôi, ngọn ngành của sự việc: kể lể nguồn cơn * chưa tỏ nguồn cơn",
    example: "kể lể nguồn cơn * chưa tỏ nguồn cơn",
  },
  {
    word: "nguồn cội",
    part_of_speech: "danh từ",
    meaning: "như nguồn gốc: trở về nguồn cội",
    example: "trở về nguồn cội",
  },
  {
    word: "nguồn gốc",
    part_of_speech: "danh từ",
    meaning:
      "nơi từ đó nảy sinh ra: nguồn gốc loài người * lô hàng không rõ nguồn gốc",
    example: "nguồn gốc loài người * lô hàng không rõ nguồn gốc",
  },
  {
    word: "ngụp",
    part_of_speech: "động từ",
    meaning:
      "tự làm cho cả người chìm hẳn xuống dưới mặt nước một lúc: ngụp xuống nước một lát * ngoi lên ngụp xuống",
    example: "ngụp xuống nước một lát * ngoi lên ngụp xuống",
  },
  {
    word: "nguồn lực",
    part_of_speech: "danh từ",
    meaning:
      "nguồn sức mạnh vật chất, tinh thần phải bỏ ra để tiến hành một hoạt động nào đó: nguồn lực tài chính * thu hút nguồn lực đầu tư",
    example: "nguồn lực tài chính * thu hút nguồn lực đầu tư",
  },
  {
    word: "ngụp lặn",
    part_of_speech: "động từ",
    meaning:
      "ngoi lên ngụp xuống dưới nước sâu (nói khái quát): bọn trẻ ngụp lặn dưới sông * ngụp lặn trong cảnh ăn chơi sa đoạ (b)",
    example:
      "bọn trẻ ngụp lặn dưới sông * ngụp lặn trong cảnh ăn chơi sa đoạ (b)",
  },
  {
    word: "ngút",
    part_of_speech: "động từ",
    meaning:
      "bốc lên liên tục và ngày càng cao, như vượt ra ngoài tầm mắt (thường nói về lửa, khói): khói lửa ngút trời",
    example: "khói lửa ngút trời",
  },
  {
    word: "ngút",
    part_of_speech: "động từ",
    meaning:
      "trải rộng ra mãi như vượt quá tầm mắt: bãi dâu trải ngút tầm mắt * biển lúa xanh ngút tận chân trời",
    example: "bãi dâu trải ngút tầm mắt * biển lúa xanh ngút tận chân trời",
  },
  {
    word: "nguội tanh",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như nguội ngắt: bát phở nguội tanh",
    example: "bát phở nguội tanh",
  },
  {
    word: "ngút ngàn",
    part_of_speech: "tính từ",
    meaning:
      "nhiều và trải rộng ra, đến mức tựa như vượt quá tầm mắt: đồng lúa non ngút ngàn",
    example: "đồng lúa non ngút ngàn",
  },
  {
    word: "nguỵ",
    part_of_speech: "",
    meaning: "nguỵ quyền hoặc nguỵ quân (nói tắt): lính nguỵ * sĩ quan nguỵ",
    example: "lính nguỵ * sĩ quan nguỵ",
  },
  {
    word: "ngút ngát",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như ngút ngàn: bãi dâu ngút ngát",
    example: "bãi dâu ngút ngát",
  },
  {
    word: "nguy",
    part_of_speech: "tính từ",
    meaning:
      "ở vào tình trạng dễ có khả năng xảy ra tai nạn, thiệt hại lớn (thường đe doạ sự sống): bệnh để lâu có thể nguy đến tính mạng * lúc này mà mưa thì nguy to",
    example:
      "bệnh để lâu có thể nguy đến tính mạng * lúc này mà mưa thì nguy to",
  },
  {
    word: "nguy biến",
    part_of_speech: "danh từ",
    meaning: "việc bất ngờ có thể gây ra tai hoạ lớn: gặp nguy biến",
    example: "gặp nguy biến",
  },
  {
    word: "nguy biến",
    part_of_speech: "tính từ",
    meaning:
      "có thể gây ra tai hoạ lớn bất ngờ: vượt qua giây phút nguy biến nhất",
    example: "vượt qua giây phút nguy biến nhất",
  },
  {
    word: "nguỵ biện",
    part_of_speech: "động từ",
    meaning:
      "cố ý dùng những lí lẽ bề ngoài có vẻ đúng nhưng thật ra là sai, để rút ra những kết luận không đúng sự thật: nguỵ biện cho hành vi sai trái của mình * luận điệu nguỵ biện",
    example: "nguỵ biện cho hành vi sai trái của mình * luận điệu nguỵ biện",
  },
  {
    word: "nguy cơ",
    part_of_speech: "danh từ",
    meaning:
      "cái có thể gây ra tai hoạ lớn trong một thời gian rất gần: doanh nghiệp có nguy cơ phá sản * loài động vật đang đứng trước nguy cơ tuyệt chủng",
    example:
      "doanh nghiệp có nguy cơ phá sản * loài động vật đang đứng trước nguy cơ tuyệt chủng",
  },
  {
    word: "nguy cấp",
    part_of_speech: "tính từ",
    meaning:
      "rất nguy, đòi hỏi phải ứng phó gấp, không thể chậm trễ: tình thế nguy cấp",
    example: "tình thế nguy cấp",
  },
  {
    word: "nguy hiểm",
    part_of_speech: "tính từ",
    meaning:
      "có thể gây tai hại lớn: tên tội phạm nguy hiểm * bệnh để lâu có thể nguy hiểm đến tính mạng",
    example:
      "tên tội phạm nguy hiểm * bệnh để lâu có thể nguy hiểm đến tính mạng",
  },
  {
    word: "nguy hiểm",
    part_of_speech: "danh từ",
    meaning:
      "(cũng hiểm nguy) điều gây tai hại lớn: bất chấp nguy hiểm * coi thường nguy hiểm",
    example: "bất chấp nguy hiểm * coi thường nguy hiểm",
  },
  {
    word: "nguy hại",
    part_of_speech: "tính từ",
    meaning:
      "nguy hiểm và gây tổn thất cho con người: sự ô nhiễm môi trường rất nguy hại cho sức khoẻ",
    example: "sự ô nhiễm môi trường rất nguy hại cho sức khoẻ",
  },
  {
    word: "nguy kịch",
    part_of_speech: "tính từ",
    meaning:
      "hết sức nguy hiểm, đe doạ nghiêm trọng đến sự sống còn (thường nói về bệnh tật): nạn nhân đang trong cơn nguy kịch",
    example: "nạn nhân đang trong cơn nguy kịch",
  },
  {
    word: "nguy nan",
    part_of_speech: "tính từ",
    meaning:
      "ở vào tình trạng hết sức gay go, hiểm nghèo, rất khó thoát ra: xã tắc nguy nan",
    example: "xã tắc nguy nan",
  },
  {
    word: "nguy khốn",
    part_of_speech: "tính từ",
    meaning:
      "nguy hiểm tới mức rất khó hoặc không thể tìm ra lối thoát: gặp cơn nguy khốn * tình thế nguy khốn",
    example: "gặp cơn nguy khốn * tình thế nguy khốn",
  },
  {
    word: "nguy nga",
    part_of_speech: "tính từ",
    meaning:
      "(công trình kiến trúc) to lớn, đẹp đẽ và uy nghi: cung điện nguy nga * toà lâu đài nguy nga, tráng lệ",
    example: "cung điện nguy nga * toà lâu đài nguy nga, tráng lệ",
  },
  {
    word: "nguỵ trang",
    part_of_speech: "động từ",
    meaning:
      "che phủ bên ngoài nhằm làm cho đối phương không phát hiện ra được: nắp hầm được nguỵ trang rất kĩ * người cán bộ nguỵ trang làm một dân chài",
    example:
      "nắp hầm được nguỵ trang rất kĩ * người cán bộ nguỵ trang làm một dân chài",
  },
  {
    word: "nguỵ trang",
    part_of_speech: "động từ",
    meaning:
      "che giấu dưới cái vỏ tốt đẹp bên ngoài, làm cho người ta không thấy được cái thực chất xấu xa: âm mưu xâm lược được nguỵ trang dưới chiêu bài khai hoá văn minh",
    example: "âm mưu xâm lược được nguỵ trang dưới chiêu bài khai hoá văn minh",
  },
  {
    word: "nguy ngập",
    part_of_speech: "tính từ",
    meaning:
      "rất nguy khốn, khó cứu vãn: tình thế vô cùng nguy ngập * bệnh tình nguy ngập",
    example: "tình thế vô cùng nguy ngập * bệnh tình nguy ngập",
  },
  {
    word: "nguỵ tạo",
    part_of_speech: "động từ",
    meaning: "tạo ra cái giả nhằm lừa dối: chứng cứ nguỵ tạo",
    example: "chứng cứ nguỵ tạo",
  },
  {
    word: "nguyền",
    part_of_speech: "động từ",
    meaning: "(văn chương)",
    example:
      "lời nguyền * \"Đã nguyền hai chữ 'đồng tâm', Trăm năm thề chẳng ôm cầm thuyền ai.\" (TKiều)",
  },
  {
    word: "nguyên",
    part_of_speech: "danh từ",
    meaning:
      "cái gốc, cái ban đầu, lúc ban đầu: ông giám đốc nguyên là bộ đội xuất ngũ * nơi này nguyên là bãi đất hoang",
    example:
      "ông giám đốc nguyên là bộ đội xuất ngũ * nơi này nguyên là bãi đất hoang",
  },
  {
    word: "nguyên",
    part_of_speech: "tính từ",
    meaning:
      "được giữ hoàn toàn như thế, không có gì khác đi, không có gì thay đổi: cơm canh còn nóng nguyên * số tiền vẫn nguyên",
    example: "cơm canh còn nóng nguyên * số tiền vẫn nguyên",
  },
  {
    word: "nguyên",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) chỉ có như thế, không có gì thêm hoặc không có gì khác: chỉ nguyên việc đó thôi cũng đủ rắc rối",
    example: "chỉ nguyên việc đó thôi cũng đủ rắc rối",
  },
  {
    word: "nguyên âm",
    part_of_speech: "danh từ",
    meaning:
      "âm mà khi phát âm, luồng hơi từ trong phổi đi ra không gặp phải trở ngại đáng kể; phân biệt với phụ âm: a, e, i là những nguyên âm",
    example: "a, e, i là những nguyên âm",
  },
  {
    word: "nguyên bản",
    part_of_speech: "danh từ",
    meaning:
      "bản gốc của một tác phẩm, một tài liệu: nguyên bản Truyện Kiều * đối chiếu bản dịch với nguyên bản",
    example: "nguyên bản Truyện Kiều * đối chiếu bản dịch với nguyên bản",
  },
  {
    word: "nguyện",
    part_of_speech: "động từ",
    meaning:
      "tự nhủ, tự cam kết sẽ làm đúng như vậy (nói về điều mà cho là thiêng liêng, là đáng trân trọng): nguyện sẽ cố gắng học tập chăm chỉ",
    example: "nguyện sẽ cố gắng học tập chăm chỉ",
  },
  {
    word: "nguyên chất",
    part_of_speech: "tính từ",
    meaning:
      "chỉ thuần một chất, không có chất khác lẫn vào hoặc không có sự pha chế: vàng nguyên chất * rượu nguyên chất",
    example: "vàng nguyên chất * rượu nguyên chất",
  },
  {
    word: "nguyên cớ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) như duyên cớ: nguyên cớ của sự việc * không biết nguyên cớ tại đâu",
    example: "nguyên cớ của sự việc * không biết nguyên cớ tại đâu",
  },
  {
    word: "nguyên đại",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị tuổi lớn nhất của Trái Đất, dài tới hàng nghìn triệu năm: nguyên đại cổ sinh * nguyên đại trung sinh",
    example: "nguyên đại cổ sinh * nguyên đại trung sinh",
  },
  {
    word: "nguyên dạng",
    part_of_speech: "danh từ",
    meaning:
      "dạng gốc, dạng vốn có: khôi phục nguyên dạng ngôi thành cổ * viết nguyên dạng tên riêng nước ngoài",
    example:
      "khôi phục nguyên dạng ngôi thành cổ * viết nguyên dạng tên riêng nước ngoài",
  },
  {
    word: "nguyện cầu",
    part_of_speech: "động từ",
    meaning: "(hiếm) như cầu nguyện: lời nguyện cầu",
    example: "lời nguyện cầu",
  },
  {
    word: "nguyên do",
    part_of_speech: "danh từ",
    meaning: "nguyên nhân sâu xa: tìm hiểu nguyên do sự việc",
    example: "tìm hiểu nguyên do sự việc",
  },
  {
    word: "nguyên hình",
    part_of_speech: "danh từ",
    meaning: "hình thù vốn có, bộ mặt thật: con yêu tinh đã hiện nguyên hình",
    example: "con yêu tinh đã hiện nguyên hình",
  },
  {
    word: "nguyên lão",
    part_of_speech: "danh từ",
    meaning: "(cũ) thượng nghị sĩ: nguyên lão nghị viện",
    example: "nguyên lão nghị viện",
  },
  {
    word: "nguyên lành",
    part_of_speech: "tính từ",
    meaning:
      "còn nguyên, không bị sứt mẻ, hư hại: chiếc tách bị rơi nhưng vẫn còn nguyên lành",
    example: "chiếc tách bị rơi nhưng vẫn còn nguyên lành",
  },
  {
    word: "nguyên khai",
    part_of_speech: "tính từ",
    meaning:
      "(khoáng sản) vừa được khai thác, chưa qua sàng lọc, tuyển chọn: than nguyên khai * quặng sắt nguyên khai",
    example: "than nguyên khai * quặng sắt nguyên khai",
  },
  {
    word: "nguyên khí",
    part_of_speech: "danh từ",
    meaning:
      "khí đầu tiên sinh ra các khí khác; cũng dùng để chỉ nhân tố chủ chốt để làm nên sức mạnh: nhân tài là nguyên khí của quốc gia",
    example: "nhân tài là nguyên khí của quốc gia",
  },
  {
    word: "nguyên lí",
    part_of_speech: "danh từ",
    meaning: "luận điểm cơ bản của một học thuyết: nguyên lí của nho giáo",
    example: "nguyên lí của nho giáo",
  },
  {
    word: "nguyên lí",
    part_of_speech: "danh từ",
    meaning:
      "định luật cơ bản có tính chất tổng quát, chi phối cả một loạt hiện tượng: nguyên lí cấu tạo * nguyên lí hoạt động của máy",
    example: "nguyên lí cấu tạo * nguyên lí hoạt động của máy",
  },
  {
    word: "nguyên liệu",
    part_of_speech: "danh từ",
    meaning:
      "đối tượng lao động đã được con người khai thác hoặc sản xuất, thường được sử dụng tiếp để tạo nên sản phẩm mới: cao su là nguyên liệu để sản xuất lốp ô tô * nguyên liệu chế biến món ăn",
    example:
      "cao su là nguyên liệu để sản xuất lốp ô tô * nguyên liệu chế biến món ăn",
  },
  {
    word: "nguyên niên",
    part_of_speech: "danh từ",
    meaning: "năm đầu tiên mang một niên hiệu: Gia Long nguyên niên",
    example: "Gia Long nguyên niên",
  },
  {
    word: "nguyên ngữ",
    part_of_speech: "danh từ",
    meaning:
      "ngôn ngữ của nguyên bản hoặc ngôn ngữ gốc, trong quan hệ với ngôn ngữ của bản dịch hoặc với ngôn ngữ có những từ mượn: tên riêng được viết theo nguyên ngữ * đối chiếu bản dịch với bản nguyên ngữ",
    example:
      "tên riêng được viết theo nguyên ngữ * đối chiếu bản dịch với bản nguyên ngữ",
  },
  {
    word: "nguyên nhân",
    part_of_speech: "danh từ",
    meaning:
      "nhân tố tạo ra kết quả hoặc làm nảy sinh sự việc (đang nói đến): nguyên nhân gây bệnh * tìm hiểu nguyên nhân của vụ việc",
    example: "nguyên nhân gây bệnh * tìm hiểu nguyên nhân của vụ việc",
  },
  {
    word: "nguyên lý",
    part_of_speech: "danh từ",
    meaning: "luận điểm cơ bản của một học thuyết: nguyên lí của nho giáo",
    example: "nguyên lí của nho giáo",
  },
  {
    word: "nguyên lý",
    part_of_speech: "danh từ",
    meaning:
      "định luật cơ bản có tính chất tổng quát, chi phối cả một loạt hiện tượng: nguyên lí cấu tạo * nguyên lí hoạt động của máy",
    example: "nguyên lí cấu tạo * nguyên lí hoạt động của máy",
  },
  {
    word: "nguyên mẫu",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) vật vốn có từ trước, được dùng làm mẫu: sản phẩm được làm theo nguyên mẫu",
    example: "sản phẩm được làm theo nguyên mẫu",
  },
  {
    word: "nguyên mẫu",
    part_of_speech: "danh từ",
    meaning:
      "người, việc có thực ngoài đời, được dùng làm mẫu để xây dựng hình tượng nghệ thuật hoặc phản ánh vào tác phẩm: nhân vật trong phim được lấy nguyên mẫu từ một doanh nhân",
    example: "nhân vật trong phim được lấy nguyên mẫu từ một doanh nhân",
  },
  {
    word: "nguyên phát",
    part_of_speech: "động từ",
    meaning:
      "(hiện tượng bệnh lí) phát sinh ra tại chỗ ngay từ giai đoạn đầu; phân biệt với thứ phát: vô sinh nguyên phát",
    example: "vô sinh nguyên phát",
  },
  {
    word: "nguyên phi",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) vợ lẽ của vua, đứng đầu hàng phi; phân biệt với thứ phi: lập làm nguyên phi",
    example: "lập làm nguyên phi",
  },
  {
    word: "nguyên quán",
    part_of_speech: "danh từ",
    meaning: "quê quán gốc; phân biệt với trú quán: trở về nguyên quán",
    example: "trở về nguyên quán",
  },
  {
    word: "nguyên sơ",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về lúc ban đầu, lúc mới hình thành, chưa phát triển: thuở nguyên sơ * cảnh quan còn đậm vẻ nguyên sơ",
    example: "thuở nguyên sơ * cảnh quan còn đậm vẻ nguyên sơ",
  },
  {
    word: "nguyên thủ",
    part_of_speech: "danh từ",
    meaning:
      "(trang trọng) người đứng đầu một nước: lễ đón các nguyên thủ quốc gia tham dự hội nghị",
    example: "lễ đón các nguyên thủ quốc gia tham dự hội nghị",
  },
  {
    word: "nguyên sinh",
    part_of_speech: "tính từ",
    meaning:
      "(rừng) mọc tự nhiên từ thời xa xưa, chưa hề bị chặt phá; phân biệt với thứ sinh: rừng nguyên sinh",
    example: "rừng nguyên sinh",
  },
  {
    word: "nguyên thuỷ",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về giai đoạn hình thành và phát triển đầu tiên của loài người, cho đến trước khi bước vào xã hội có giai cấp và có nhà nước: người nguyên thuỷ * xã hội nguyên thuỷ",
    example: "người nguyên thuỷ * xã hội nguyên thuỷ",
  },
  {
    word: "nguyên tắc",
    part_of_speech: "danh từ",
    meaning:
      "điều cơ bản định ra, nhất thiết phải tuân theo: nguyên tắc sống * làm việc có nguyên tắc",
    example: "nguyên tắc sống * làm việc có nguyên tắc",
  },
  {
    word: "nguyên tiêu",
    part_of_speech: "danh từ",
    meaning: "đêm rằm tháng giêng: tết nguyên tiêu",
    example: "tết nguyên tiêu",
  },
  {
    word: "nguyên tác",
    part_of_speech: "danh từ",
    meaning:
      "tác phẩm gốc: đối chiếu nguyên tác với bản dịch * xác định nguyên tác Truyện Kiều",
    example:
      "đối chiếu nguyên tác với bản dịch * xác định nguyên tác Truyện Kiều",
  },
  {
    word: "nguyền rủa",
    part_of_speech: "động từ",
    meaning:
      "nói những lời độc địa, cầu mong có tai hoạ, sự trừng phạt đối với kẻ mà mình căm tức, oán thù: lời nguyền rủa * tội ác đáng nguyền rủa",
    example: "lời nguyền rủa * tội ác đáng nguyền rủa",
  },
  {
    word: "biệt ly",
    part_of_speech: "động từ",
    meaning:
      '(văn chương) xa cách nhau, không được chung sống với nhau trong một thời gian tương đối dài: cảnh biệt li * "Biết bao nhiêu nỗi phong trần, Mưa hằng tuôn luỵ mấy lần biệt li." (ca dao)',
    example:
      'cảnh biệt li * "Biết bao nhiêu nỗi phong trần, Mưa hằng tuôn luỵ mấy lần biệt li." (ca dao)',
  },
  {
    word: "biệt mù",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) xa tít: con thuyền ở biệt mù ngoài khơi",
    example: "con thuyền ở biệt mù ngoài khơi",
  },
  {
    word: "biết mấy",
    part_of_speech: "phụ từ",
    meaning:
      '(khẩu ngữ) như biết chừng nào: hạnh phúc biết mấy! * "Chàng ơi! Có thấu chăng chàng, Một bát cơm vàng, biết mấy công lênh." (ca dao)',
    example:
      'hạnh phúc biết mấy! * "Chàng ơi! Có thấu chăng chàng, Một bát cơm vàng, biết mấy công lênh." (ca dao)',
  },
  {
    word: "biết nghĩ",
    part_of_speech: "động từ",
    meaning:
      "biết suy xét, nhìn nhận sự việc một cách đúng đắn: còn non dại nên chưa biết nghĩ * tỏ ra biết nghĩ",
    example: "còn non dại nên chưa biết nghĩ * tỏ ra biết nghĩ",
  },
  {
    word: "biệt tài",
    part_of_speech: "danh từ",
    meaning: "tài năng đặc biệt, hiếm có: có biệt tài về hội hoạ",
    example: "có biệt tài về hội hoạ",
  },
  {
    word: "biệt phái",
    part_of_speech: "động từ",
    meaning:
      "cử (cán bộ) đến công tác ở nơi khác hoặc đi công tác xa, tạm thời trong một thời gian, với nhiệm vụ không thuộc sự quản lí của cơ quan: chuyến biệt phái công tác * cán bộ biệt phái",
    example: "chuyến biệt phái công tác * cán bộ biệt phái",
  },
  {
    word: "biệt phái",
    part_of_speech: "tính từ",
    meaning:
      "có tư tưởng đối lập với số đông trong một chính đảng, hoặc một tổ chức học thuật, tôn giáo, tự tách ra thành lập một phái riêng, do có sự bất đồng về chủ trương (thường dùng với nghĩa xấu): tư tưởng biệt phái * khuynh hướng biệt phái",
    example: "tư tưởng biệt phái * khuynh hướng biệt phái",
  },
  {
    word: "biết ơn",
    part_of_speech: "động từ",
    meaning:
      "hiểu và ghi nhớ công ơn của người khác đối với mình: tỏ lòng biết ơn * biết ơn cha mẹ",
    example: "tỏ lòng biết ơn * biết ơn cha mẹ",
  },
  {
    word: "biết tay",
    part_of_speech: "động từ",
    meaning:
      '(khẩu ngữ) (làm cho người nào đó) thấy rõ thủ đoạn hoặc sức mạnh (của đối phương) mà sợ: phải cho nó biết tay! * "Ngàn xưa mấy kẻ gian ngay, Xem cơ báo ứng biết tay trời già." (TKiều)',
    example:
      'phải cho nó biết tay! * "Ngàn xưa mấy kẻ gian ngay, Xem cơ báo ứng biết tay trời già." (TKiều)',
  },
  {
    word: "biệt tăm biệt tích",
    part_of_speech: "",
    meaning:
      "hoàn toàn không còn thấy tăm hơi, tung tích đâu cả: đi biệt tăm biệt tích",
    example: "đi biệt tăm biệt tích",
  },
  {
    word: "biết thỏm",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ, khẩu ngữ) biết tỏng: biết thỏm là ngại nên mới không dám đi",
    example: "biết thỏm là ngại nên mới không dám đi",
  },
  {
    word: "biệt tăm",
    part_of_speech: "tính từ",
    meaning:
      'biệt đi hoàn toàn, không còn thấy tăm hơi đâu cả: trốn biệt tăm * "Sông dài cá lội biệt tăm, Chín tháng cũng đợi một năm cũng chờ." (ca dao)',
    example:
      'trốn biệt tăm * "Sông dài cá lội biệt tăm, Chín tháng cũng đợi một năm cũng chờ." (ca dao)',
  },
  {
    word: "biệt tích",
    part_of_speech: "tính từ",
    meaning: "hoàn toàn không còn thấy tung tích đâu cả: trốn biệt tích",
    example: "trốn biệt tích",
  },
  {
    word: "biệt thự",
    part_of_speech: "danh từ",
    meaning:
      "nhà ở có vườn và đầy đủ tiện nghi, làm riêng biệt ở nơi yên tĩnh, thường dùng làm nơi nghỉ ngơi: toà biệt thự",
    example: "toà biệt thự",
  },
  {
    word: "biết thóp",
    part_of_speech: "động từ",
    meaning:
      'biết rõ điểm yếu hay chỗ sơ hở để có thể lợi dụng: "Ông lý nhà ta biết thóp anh chồng non mặt, nên đến loè anh ta đủ thứ." (NCao; 28)',
    example:
      'Ông lý nhà ta biết thóp anh chồng non mặt, nên đến loè anh ta đủ thứ." (NCao; 28)',
  },
  {
    word: "biết thân",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) như biết thân biết phận: đã nghèo lại không biết thân, còn thích chơi trèo!",
    example: "đã nghèo lại không biết thân, còn thích chơi trèo!",
  },
  {
    word: "biết thân",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) thấy được rõ tác hại đối với bản thân mà hối hận, tránh lặp lại việc làm sai trái, dại dột của mình: có thế mới biết thân! * đánh cho một trận cho nó biết thân!",
    example: "có thế mới biết thân! * đánh cho một trận cho nó biết thân!",
  },
  {
    word: "biết tỏng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) biết rõ cái điều mà người khác tưởng là không thể biết được hoặc muốn giấu: biết tỏng là nói dối",
    example: "biết tỏng là nói dối",
  },
  {
    word: "biệt vô âm tín",
    part_of_speech: "",
    meaning:
      "hoàn toàn biệt tin, đã lâu không có tin tức gì: sáu bảy tháng rồi vẫn biệt vô âm tín",
    example: "sáu bảy tháng rồi vẫn biệt vô âm tín",
  },
  {
    word: "biệt xứ",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) xa hẳn xứ sở của mình: bỏ làng đi biệt xứ",
    example: "bỏ làng đi biệt xứ",
  },
  {
    word: "biệt xứ",
    part_of_speech: "tính từ",
    meaning:
      "(đày hoặc đưa đi an trí) xa hẳn xứ sở (một hình phạt đối với tù nhân thời trước): bị án biệt xứ",
    example: "bị án biệt xứ",
  },
  {
    word: "biếu",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) cho, tặng (thường người thuộc hàng trên, bậc trên): sách biếu * quà biếu mẹ",
    example: "sách biếu * quà biếu mẹ",
  },
  {
    word: "biểu bì",
    part_of_speech: "danh từ",
    meaning:
      "mô phủ mặt ngoài cơ thể sinh vật hoặc lót mặt trong các cơ quan của cơ thể, có tác dụng che chở hoặc đảm nhiệm các chức năng khác như tiêu hoá, bài tiết, v.v.: lớp biểu bì * tế bào biểu bì",
    example: "lớp biểu bì * tế bào biểu bì",
  },
  {
    word: "biểu",
    part_of_speech: "danh từ",
    meaning:
      "bảng kê hạng mục, số liệu để làm căn cứ đối chiếu: tính thuế theo biểu thuế",
    example: "tính thuế theo biểu thuế",
  },
  {
    word: "biểu",
    part_of_speech: "danh từ",
    meaning: "biểu thống kê (nói tắt): lập biểu * lên biểu",
    example: "lập biểu * lên biểu",
  },
  {
    word: "biểu",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) bài văn tâu lên vua để chúc mừng, tạ ơn hoặc trình bày ý kiến, bày tỏ nguyện vọng về sự việc quan trọng: biểu trần tình * dâng biểu vạch tội tham quan",
    example: "biểu trần tình * dâng biểu vạch tội tham quan",
  },
  {
    word: "biểu dương",
    part_of_speech: "động từ",
    meaning:
      "công khai khen ngợi (người tốt, việc tốt) cho mọi người biết: biểu dương tinh thần tương thân tương ái",
    example: "biểu dương tinh thần tương thân tương ái",
  },
  {
    word: "biểu dương",
    part_of_speech: "động từ",
    meaning:
      "phô bày cái mạnh của mình để gây tin tưởng hoặc gây thanh thế: cuộc diễu hành biểu dương lực lượng",
    example: "cuộc diễu hành biểu dương lực lượng",
  },
  {
    word: "biểu đồ",
    part_of_speech: "danh từ",
    meaning:
      "hình vẽ biểu diễn một khái niệm, quy luật hay quan hệ nào đó: vẽ biểu đồ * biểu đồ phát triển dân số",
    example: "vẽ biểu đồ * biểu đồ phát triển dân số",
  },
  {
    word: "biểu cảm",
    part_of_speech: "động từ",
    meaning:
      "(ngôn ngữ) biểu hiện tình cảm, cảm xúc: ngôn ngữ giàu sức biểu cảm",
    example: "ngôn ngữ giàu sức biểu cảm",
  },
  {
    word: "biểu đạt",
    part_of_speech: "động từ",
    meaning:
      "(dùng ngôn ngữ hoặc hình thức nào đó) làm cho tư tưởng, tình cảm được tỏ rõ ra: ngôn ngữ là công cụ để biểu đạt tư duy",
    example: "ngôn ngữ là công cụ để biểu đạt tư duy",
  },
  {
    word: "biểu diễn",
    part_of_speech: "động từ",
    meaning:
      "diễn (các loại hình nghệ thuật hay võ thuật) cho công chúng thưởng thức: biểu diễn văn nghệ * biểu diễn một điệu múa * biểu diễn vài đường quyền",
    example:
      "biểu diễn văn nghệ * biểu diễn một điệu múa * biểu diễn vài đường quyền",
  },
  {
    word: "biểu diễn",
    part_of_speech: "động từ",
    meaning: "diễn tả bằng công thức hoặc hình vẽ: đường biểu diễn một hàm số",
    example: "đường biểu diễn một hàm số",
  },
  {
    word: "biểu hiện",
    part_of_speech: "động từ",
    meaning:
      "hiện rõ ra (nói về cái nội dung trừu tượng): biểu hiện tình cảm * niềm vui biểu hiện trên gương mặt * mâu thuẫn biểu hiện dưới nhiều hình thức",
    example:
      "biểu hiện tình cảm * niềm vui biểu hiện trên gương mặt * mâu thuẫn biểu hiện dưới nhiều hình thức",
  },
  {
    word: "biểu hiện",
    part_of_speech: "động từ",
    meaning:
      "làm cho thấy rõ bằng phương tiện nghệ thuật: văn học biểu hiện cuộc sống",
    example: "văn học biểu hiện cuộc sống",
  },
  {
    word: "biểu hiện",
    part_of_speech: "danh từ",
    meaning:
      "cái biểu hiện ra ở bên ngoài: biểu hiện của lòng tự trọng * có nhiều biểu hiện tích cực",
    example: "biểu hiện của lòng tự trọng * có nhiều biểu hiện tích cực",
  },
  {
    word: "biểu mẫu",
    part_of_speech: "danh từ",
    meaning:
      "mẫu để theo đó mà lập biểu thống kê: biểu mẫu thống kê * lập đúng biểu mẫu quy định",
    example: "biểu mẫu thống kê * lập đúng biểu mẫu quy định",
  },
  {
    word: "biểu mẫu",
    part_of_speech: "danh từ",
    meaning:
      "mẫu được thiết kế trên máy tính, dựa theo đó mà nhập dữ liệu cho đúng cách: thiết kế biểu mẫu xuất nhập hàng hoá",
    example: "thiết kế biểu mẫu xuất nhập hàng hoá",
  },
  {
    word: "biểu lộ",
    part_of_speech: "động từ",
    meaning:
      "cho thấy rõ (tư tưởng, tình cảm) một cách tự nhiên: nụ cười biểu lộ sự thông cảm * ánh mắt biểu lộ vẻ ngạc nhiên",
    example: "nụ cười biểu lộ sự thông cảm * ánh mắt biểu lộ vẻ ngạc nhiên",
  },
  {
    word: "biểu kiến",
    part_of_speech: "tính từ",
    meaning:
      "(hiện tượng) có vẻ như vậy, nhưng thật ra không đúng như những gì ta thấy hoặc đo được: chuyển động biểu kiến của Mặt Trời",
    example: "chuyển động biểu kiến của Mặt Trời",
  },
  {
    word: "biểu thị",
    part_of_speech: "động từ",
    meaning:
      "(thường bằng lời nói, hoặc việc làm) tỏ cho thấy, cho biết (tư tưởng, tình cảm, thái độ): biểu thị quyết tâm * biểu thị thái độ đồng tình",
    example: "biểu thị quyết tâm * biểu thị thái độ đồng tình",
  },
  {
    word: "biểu thức",
    part_of_speech: "danh từ",
    meaning:
      "kí hiệu hoặc tổ hợp kí hiệu toán học nối liền với nhau bằng các dấu phép toán: biểu thức đại số * tính giá trị của biểu thức",
    example: "biểu thức đại số * tính giá trị của biểu thức",
  },
  {
    word: "biểu ngữ",
    part_of_speech: "danh từ",
    meaning:
      "băng vải, tấm ván, v.v., có viết khẩu hiệu, trương lên ở nơi đông người qua lại hoặc trong các cuộc mít tinh, biểu tình: đoàn biểu tình trương biểu ngữ",
    example: "đoàn biểu tình trương biểu ngữ",
  },
  {
    word: "biểu thống kê",
    part_of_speech: "danh từ",
    meaning:
      "bảng thống kê số liệu làm theo mẫu quy định trước: lập biểu thống kê",
    example: "lập biểu thống kê",
  },
  {
    word: "biểu quyết",
    part_of_speech: "động từ",
    meaning:
      "(hội nghị) tỏ ý kiến quyết định (tán thành hay không tán thành, đồng ý hay không đồng ý) về một vấn đề đã qua thảo luận (bằng cách bỏ phiếu hoặc giơ tay): đại hội biểu quyết tán thành với đa số tuyệt đối",
    example: "đại hội biểu quyết tán thành với đa số tuyệt đối",
  },
  {
    word: "biểu quyết",
    part_of_speech: "động từ",
    meaning:
      "(đại biểu dự hội nghị) tham gia biểu quyết: đại biểu dự thính không có quyền biểu quyết",
    example: "đại biểu dự thính không có quyền biểu quyết",
  },
  {
    word: "biểu quyết",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) ý kiến biểu quyết (của hội nghị) bằng giơ tay: lấy biểu quyết",
    example: "lấy biểu quyết",
  },
  {
    word: "biểu tình",
    part_of_speech: "động từ",
    meaning:
      "tụ họp đông đảo một cách có tổ chức để biểu dương lực lượng và/hoặc để đấu tranh, bày tỏ ý chí, nguyện vọng: biểu tình chống chiến tranh xâm lược * biểu tình tuần hành",
    example: "biểu tình chống chiến tranh xâm lược * biểu tình tuần hành",
  },
  {
    word: "biểu trưng",
    part_of_speech: "động từ",
    meaning:
      "biểu hiện một cách tượng trưng và tiêu biểu nhất: búa và liềm biểu trưng cho tình đoàn kết công nông",
    example: "búa và liềm biểu trưng cho tình đoàn kết công nông",
  },
  {
    word: "biểu trưng",
    part_of_speech: "danh từ",
    meaning:
      "cái, vật cụ thể được dùng làm hình ảnh tượng trưng (cho một ý niệm): cán cân là biểu trưng của công lí",
    example: "cán cân là biểu trưng của công lí",
  },
  {
    word: "biếu xén",
    part_of_speech: "động từ",
    meaning: "biếu (nói khái quát; thường hàm ý chê): biếu xén quà cáp",
    example: "biếu xén quà cáp",
  },
  {
    word: "biểu tượng",
    part_of_speech: "danh từ",
    meaning:
      "hình ảnh sáng tạo nghệ thuật có một ý nghĩa tượng trưng trừu tượng: chim bồ câu là biểu tượng của hoà bình",
    example: "chim bồ câu là biểu tượng của hoà bình",
  },
  {
    word: "bím",
    part_of_speech: "danh từ",
    meaning:
      "dải tóc kết lại, thường buông thõng xuống sau lưng: bím tóc * tóc tết thành hai bím",
    example: "bím tóc * tóc tết thành hai bím",
  },
  {
    word: "bỉm",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) tã giấy: đóng bỉm cho bé",
    example: "đóng bỉm cho bé",
  },
  {
    word: "binh",
    part_of_speech: "danh từ",
    meaning: "quân lính, quân đội: binh hùng, tướng mạnh * toà án binh",
    example: "binh hùng, tướng mạnh * toà án binh",
  },
  {
    word: "bìm",
    part_of_speech: "danh từ",
    meaning: "bìm bìm (nói tắt): giậu đổ bìm leo (tng)",
    example: "giậu đổ bìm leo (tng)",
  },
  {
    word: "bình",
    part_of_speech: "danh từ",
    meaning:
      "đồ đựng có bầu chứa, miệng thường nhỏ và không có nắp đậy: bình vôi * bình rượu * bình cắm hoa",
    example: "bình vôi * bình rượu * bình cắm hoa",
  },
  {
    word: "bình",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) ấm để pha trà: pha một bình trà mới",
    example: "pha một bình trà mới",
  },
  {
    word: "bình",
    part_of_speech: "danh từ",
    meaning:
      "đồ đựng nói chung, để chứa chất lỏng hoặc chất khí: bình gas * bình cứu hoả * bình xăng",
    example: "bình gas * bình cứu hoả * bình xăng",
  },
  {
    word: "bình",
    part_of_speech: "động từ",
    meaning:
      "đọc với âm điệu ngân nga và thường có kèm những lời giảng giải cái hay để nhiều người cùng thưởng thức: bình văn * bình một bài thơ",
    example: "bình văn * bình một bài thơ",
  },
  {
    word: "bình",
    part_of_speech: "động từ",
    meaning:
      "bày tỏ ý kiến, thái độ khen chê, đánh giá, thường về một sự vật hoặc sự việc nào đó: lời bình ở cuối sách * viết lời bình cho tác phẩm",
    example: "lời bình ở cuối sách * viết lời bình cho tác phẩm",
  },
  {
    word: "bình",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bàn bạc, cân nhắc trong tập thể để đánh giá, lựa chọn): bình điểm * bình công",
    example: "bình điểm * bình công",
  },
  {
    word: "bình",
    part_of_speech: "tính từ",
    meaning:
      "yên ổn, không có chiến tranh, không có loạn lạc: trai thời chiến, gái thời bình (tng)",
    example: "trai thời chiến, gái thời bình (tng)",
  },
  {
    word: "bình",
    part_of_speech: "tính từ",
    meaning:
      "(cũ) khá, trong hệ thống phê điểm để xếp hạng (ưu, bình, thứ, liệt) trong học tập, thi cử ngày trước: xếp hạng bình * đỗ hạng bình",
    example: "xếp hạng bình * đỗ hạng bình",
  },
  {
    word: "bịn rịn",
    part_of_speech: "động từ",
    meaning:
      'không muốn dứt ra khi phải chia tay (vì tình cảm gắn bó sâu đậm): phút bịn rịn lúc chia tay * "Chẳng yêu chẳng xót chẳng vì, Lại còn bịn rịn làm chi cảnh này." (PT)',
    example:
      'phút bịn rịn lúc chia tay * "Chẳng yêu chẳng xót chẳng vì, Lại còn bịn rịn làm chi cảnh này." (PT)',
  },
  {
    word: "bình an vô sự",
    part_of_speech: "",
    meaning: "như bình yên: cả nhà vẫn bình yên vô sự",
    example: "cả nhà vẫn bình yên vô sự",
  },
  {
    word: "binh biến",
    part_of_speech: "danh từ",
    meaning:
      "cuộc nổi dậy vũ trang của một bộ phận trong quân đội: nghĩa quân làm binh biến * cuộc binh biến",
    example: "nghĩa quân làm binh biến * cuộc binh biến",
  },
  {
    word: "bình chân",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) bình thản, thờ ơ, vì coi như không liên quan, không ảnh hưởng gì đến mình: thấy nhà hàng xóm cháy lại bình chân ngồi nhìn",
    example: "thấy nhà hàng xóm cháy lại bình chân ngồi nhìn",
  },
  {
    word: "binh bị",
    part_of_speech: "danh từ",
    meaning:
      "vũ khí, trang bị, khí tài và quân số dùng vào mục đích chiến tranh (nói tổng quát): tăng cường binh bị * sắp đặt việc binh bị",
    example: "tăng cường binh bị * sắp đặt việc binh bị",
  },
  {
    word: "bình bầu",
    part_of_speech: "động từ",
    meaning:
      "bàn bạc cân nhắc trong tập thể để chọn người xứng đáng được khen thưởng: bình bầu chiến sĩ thi đua * được bình bầu là cá nhân xuất sắc",
    example: "bình bầu chiến sĩ thi đua * được bình bầu là cá nhân xuất sắc",
  },
  {
    word: "bình bịch",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) mô tô: xe bình bịch",
    example: "xe bình bịch",
  },
  {
    word: "bình bịch",
    part_of_speech: "tính từ",
    meaning:
      "như bịch (nhưng với ý liên tiếp và mức độ nhiều hơn): chân giậm bình bịch xuống đất",
    example: "chân giậm bình bịch xuống đất",
  },
  {
    word: "bình bồng",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) cánh bèo và cỏ bồng trôi lênh đênh trên mặt nước; dùng để ví thân phận lênh đênh, phiêu bạt nay đây mai đó: "Bình bồng ở giữa giang tân, Bên tình bên nghĩa bên thân thế nào?" (ca dao)',
    example:
      'Bình bồng ở giữa giang tân, Bên tình bên nghĩa bên thân thế nào?" (ca dao)',
  },
  {
    word: "binh cách",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) khí giới và áo giáp (hoặc cái mộc) bằng da; dùng để chỉ việc chiến tranh, về mặt giặc giã, loạn lạc: "Rằng: Nàng chút phận hồng nhan, Gặp cơn binh cách nhiều nàn cũng thương!" (TKiều)',
    example:
      'Rằng: Nàng chút phận hồng nhan, Gặp cơn binh cách nhiều nàn cũng thương!" (TKiều)',
  },
  {
    word: "bình chú",
    part_of_speech: "động từ",
    meaning: "(hiếm) bình luận và chú thích: bình chú thơ văn cổ",
    example: "bình chú thơ văn cổ",
  },
  {
    word: "binh cơ",
    part_of_speech: "danh từ",
    meaning: "(cũ) mưu lược quân sự: bàn việc binh cơ * giỏi binh cơ",
    example: "bàn việc binh cơ * giỏi binh cơ",
  },
  {
    word: "bình chọn",
    part_of_speech: "động từ",
    meaning:
      "chọn qua xem xét và đánh giá: bình chọn cầu thủ xuất sắc * được bình chọn là doanh nhân tiêu biểu",
    example:
      "bình chọn cầu thủ xuất sắc * được bình chọn là doanh nhân tiêu biểu",
  },
  {
    word: "bình dân học vụ",
    part_of_speech: "",
    meaning:
      "công tác thanh toán nạn mù chữ cho nhân dân (mấy năm sau Cách mạng tháng Tám): phong trào bình dân học vụ",
    example: "phong trào bình dân học vụ",
  },
  {
    word: "bình địa ba đào",
    part_of_speech: "",
    meaning:
      '(cũ, văn chương) đất bằng nổi sóng; ví cảnh đang yên lành bỗng dưng có tai biến: "Gặp cơn bình địa ba đào, Vậy đem duyên chị buộc vào cho em." (TKiều)',
    example:
      'Gặp cơn bình địa ba đào, Vậy đem duyên chị buộc vào cho em." (TKiều)',
  },
  {
    word: "bình diện",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như phương diện: xét vấn đề trên nhiều bình diện",
    example: "xét vấn đề trên nhiều bình diện",
  },
  {
    word: "bình dị",
    part_of_speech: "tính từ",
    meaning:
      "(tác phong, thái độ của người có danh vọng) giản dị, khiêm tốn: lối sống bình dị",
    example: "lối sống bình dị",
  },
  {
    word: "bình dị",
    part_of_speech: "tính từ",
    meaning: "(có nội dung) dễ hiểu: câu thơ bình dị",
    example: "câu thơ bình dị",
  },
  {
    word: "bình dân",
    part_of_speech: "danh từ",
    meaning: "(cũ) người dân thường (nói khái quát): tầng lớp bình dân",
    example: "tầng lớp bình dân",
  },
  {
    word: "bình dân",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) bình dân học vụ (nói tắt): theo học lớp bình dân",
    example: "theo học lớp bình dân",
  },
  {
    word: "bình dân",
    part_of_speech: "tính từ",
    meaning:
      "của tầng lớp bình dân, dành riêng cho tầng lớp bình dân: ngôn ngữ bình dân * quán trọ bình dân",
    example: "ngôn ngữ bình dân * quán trọ bình dân",
  },
  {
    word: "bình dân",
    part_of_speech: "tính từ",
    meaning:
      "(người không phải dân thường) giản dị, gần gũi với quần chúng: tác phong rất bình dân",
    example: "tác phong rất bình dân",
  },
  {
    word: "bình đẳng",
    part_of_speech: "tính từ",
    meaning:
      "ngang hàng nhau (về mặt nào đó trong xã hội): mọi công dân đều bình đẳng trước pháp luật * nam nữ bình đẳng * quyền bình đẳng",
    example:
      "mọi công dân đều bình đẳng trước pháp luật * nam nữ bình đẳng * quyền bình đẳng",
  },
  {
    word: "binh đao",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) binh khí như gươm, đao, v.v. (nói khái quát); dùng để chỉ việc chiến tranh: nạn binh đao * "Ngẫm từ gây việc binh đao, Đống xương Vô định đã cao bằng đầu." (TKiều)',
    example:
      'nạn binh đao * "Ngẫm từ gây việc binh đao, Đống xương Vô định đã cao bằng đầu." (TKiều)',
  },
  {
    word: "binh hùng tướng mạnh",
    part_of_speech: "",
    meaning:
      "đội quân có đầy đủ sức mạnh: quân Tây Sơn binh hùng tướng mạnh, đánh đâu thắng đó",
    example: "quân Tây Sơn binh hùng tướng mạnh, đánh đâu thắng đó",
  },
  {
    word: "bình giải",
    part_of_speech: "động từ",
    meaning:
      "bình luận và giải thích về một vấn đề, ý kiến nào đó: bình giải một câu tục ngữ",
    example: "bình giải một câu tục ngữ",
  },
  {
    word: "bình lặng",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như phẳng lặng: mặt hồ bình lặng",
    example: "mặt hồ bình lặng",
  },
  {
    word: "bình lặng",
    part_of_speech: "tính từ",
    meaning:
      "lặng lẽ và yên ổn: cuộc sống bình lặng * ngày tháng bình lặng trôi đi",
    example: "cuộc sống bình lặng * ngày tháng bình lặng trôi đi",
  },
  {
    word: "bình luận viên",
    part_of_speech: "danh từ",
    meaning:
      "người chuyên bình luận về một vấn đề nào đó trên báo, đài phát thanh, vô tuyến truyền hình: bình luận viên thể thao * một bình luận viên sắc sảo",
    example: "bình luận viên thể thao * một bình luận viên sắc sảo",
  },
  {
    word: "binh lực",
    part_of_speech: "danh từ",
    meaning:
      "quân số và vũ khí, thiết bị của quân đội: binh lực mạnh * hao tổn binh lực",
    example: "binh lực mạnh * hao tổn binh lực",
  },
  {
    word: "bình luận",
    part_of_speech: "động từ",
    meaning:
      "phân tích và nhận định về tình hình, vấn đề nào đó: bình luận thời sự * bình luận bóng đá * miễn bình luận",
    example: "bình luận thời sự * bình luận bóng đá * miễn bình luận",
  },
  {
    word: "binh mã",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) binh sĩ và ngựa chiến; quân đội (nói tổng quát): "Ròng ròng binh mã thương đao, Cờ chiêu trống giục binh reo hai hàng." (MPXH)',
    example:
      'Ròng ròng binh mã thương đao, Cờ chiêu trống giục binh reo hai hàng." (MPXH)',
  },
  {
    word: "binh lửa",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) chiến tranh, về mặt lửa đạn tàn khốc: "Bỗng đâu binh lửa ầm ầm, Gió bay nhà bạc, cát lầm cửa thưa." (PT)',
    example:
      'Bỗng đâu binh lửa ầm ầm, Gió bay nhà bạc, cát lầm cửa thưa." (PT)',
  },
  {
    word: "bình minh",
    part_of_speech: "danh từ",
    meaning:
      "lúc trời tang tảng sáng, trước khi mặt trời mọc: ánh bình minh * buổi bình minh của cuộc đời (b)",
    example: "ánh bình minh * buổi bình minh của cuộc đời (b)",
  },
  {
    word: "binh nghiệp",
    part_of_speech: "danh từ",
    meaning: "(cũ) nghề binh, sự nghiệp quân sự: cuộc đời binh nghiệp",
    example: "cuộc đời binh nghiệp",
  },
  {
    word: "bình nghị",
    part_of_speech: "động từ",
    meaning:
      "bàn bạc, đánh giá để cùng nhau xét định (thường là trong hợp tác xã nông nghiệp trước đây): bình nghị sản lượng của từng khoảnh ruộng",
    example: "bình nghị sản lượng của từng khoảnh ruộng",
  },
  {
    word: "bình nhật",
    part_of_speech: "phụ từ",
    meaning: "(hiếm) thường ngày: bình nhật nó vẫn dậy sớm",
    example: "bình nhật nó vẫn dậy sớm",
  },
  {
    word: "bình phục",
    part_of_speech: "động từ",
    meaning:
      "(người bị đau ốm) trở lại trạng thái sức khoẻ bình thường, sau khi được điều trị: bệnh đã khỏi, nhưng sức khoẻ chưa bình phục",
    example: "bệnh đã khỏi, nhưng sức khoẻ chưa bình phục",
  },
  {
    word: "bình ổn",
    part_of_speech: "",
    meaning:
      "ổn định (giá cả): bình ổn thị trường lương thực * giá xăng dầu đã tương đối bình ổn",
    example:
      "bình ổn thị trường lương thực * giá xăng dầu đã tương đối bình ổn",
  },
  {
    word: "bình phong",
    part_of_speech: "danh từ",
    meaning:
      "vật dùng để chắn gió hoặc chắn một đoạn tầm mắt, hay che cho đỡ trống trải, thường xây bằng gạch trước sân hay làm bằng những khung gỗ có căng vải đặt trong phòng: tấm bình phong",
    example: "tấm bình phong",
  },
  {
    word: "bình phong",
    part_of_speech: "danh từ",
    meaning:
      "cái để nguỵ trang, để che đậy, nói chung: bị người khác lợi dụng làm bình phong",
    example: "bị người khác lợi dụng làm bình phong",
  },
  {
    word: "bình phương",
    part_of_speech: "danh từ",
    meaning:
      "tích của một số hoặc một biểu thức với chính nó: 4 là bình phương của 2",
    example: "4 là bình phương của 2",
  },
  {
    word: "bình phương",
    part_of_speech: "động từ",
    meaning:
      "lấy một số hoặc một biểu thức nhân với chính nó: 3 bình phương bằng 9",
    example: "3 bình phương bằng 9",
  },
  {
    word: "binh pháp",
    part_of_speech: "danh từ",
    meaning: "(cũ) phép dùng binh trong chiến tranh: vận dụng binh pháp",
    example: "vận dụng binh pháp",
  },
  {
    word: "bình phẩm",
    part_of_speech: "động từ",
    meaning:
      "phân tích và bày tỏ ý khen chê, đánh giá, thường về một người nào đó: buông lời bình phẩm",
    example: "buông lời bình phẩm",
  },
  {
    word: "bình quyền",
    part_of_speech: "tính từ",
    meaning: "bình đẳng về quyền lợi: thực hiện nam nữ bình quyền",
    example: "thực hiện nam nữ bình quyền",
  },
  {
    word: "binh sĩ",
    part_of_speech: "danh từ",
    meaning:
      "binh lính và hạ sĩ quan (nói tổng quát): anh em binh sĩ * chỉ huy binh sĩ",
    example: "anh em binh sĩ * chỉ huy binh sĩ",
  },
  {
    word: "binh quyền",
    part_of_speech: "danh từ",
    meaning: "quyền chỉ huy và điều động quân đội: nắm giữ binh quyền",
    example: "nắm giữ binh quyền",
  },
  {
    word: "bình sinh",
    part_of_speech: "danh từ",
    meaning:
      "trong cả một đời người (nói về cái tốt, cái đẹp trong lối sống): bình sinh ông ta sống rất trung hậu * thoả chí bình sinh",
    example: "bình sinh ông ta sống rất trung hậu * thoả chí bình sinh",
  },
  {
    word: "bình quân",
    part_of_speech: "tính từ",
    meaning:
      "được tính chia đều, hơn bù kém, lấy con số trung bình: thu nhập bình quân đầu người * sản lượng bình quân là 3 tạ một sào * tính bình quân",
    example:
      "thu nhập bình quân đầu người * sản lượng bình quân là 3 tạ một sào * tính bình quân",
  },
  {
    word: "bình thuỷ",
    part_of_speech: "danh từ",
    meaning:
      "bình bằng kim loại hoặc thuỷ tinh tráng thuỷ ngân, có hai lớp vỏ, giữa là khoảng chân không cách nhiệt, dùng để giữ nguyên nhiệt độ của vật chứa đựng trong đó trong nhiều giờ (Nam thường bình thuỷ nếu chứa nước nóng): rót nước sôi vào phích * phích đá",
    example: "rót nước sôi vào phích * phích đá",
  },
  {
    word: "bình thuỷ",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ để cắm vào ổ cắm nối dòng điện với đồ dùng điện: hỏng mất cái phích cắm",
    example: "hỏng mất cái phích cắm",
  },
  {
    word: "bình thản",
    part_of_speech: "tính từ",
    meaning:
      'tự nhiên như thường, coi như không có việc gì xảy ra (trước việc dễ làm lo sợ, hoảng hốt hoặc tức giận): nét mặt bình thản * "Lão nói bình thản thế, nhưng trong lòng lão vẫn còn rối lên như mớ bòng bong." (ĐVũ; 1)',
    example:
      'nét mặt bình thản * "Lão nói bình thản thế, nhưng trong lòng lão vẫn còn rối lên như mớ bòng bong." (ĐVũ; 1)',
  },
  {
    word: "bình tâm",
    part_of_speech: "động từ",
    meaning:
      "bình tĩnh trong lòng, làm chủ được lí trí, tình cảm của mình (trước sự việc không hay): sau mấy phút giận dữ, anh ta bình tâm nghĩ lại * bình tâm tĩnh trí",
    example:
      "sau mấy phút giận dữ, anh ta bình tâm nghĩ lại * bình tâm tĩnh trí",
  },
  {
    word: "binh thư",
    part_of_speech: "danh từ",
    meaning: "(cũ) sách viết về quân sự thời cổ: nghiên cứu binh thư",
    example: "nghiên cứu binh thư",
  },
  {
    word: "bình thường hoá",
    part_of_speech: "động từ",
    meaning:
      "làm cho trở thành bình thường: bình thường hoá quan hệ ngoại giao giữa hai nước",
    example: "bình thường hoá quan hệ ngoại giao giữa hai nước",
  },
  {
    word: "bình thường",
    part_of_speech: "tính từ",
    meaning:
      "không có gì khác thường, không có gì đặc biệt: sức khoẻ bình thường * mọi sự vẫn bình thường, không có gì thay đổi",
    example:
      "sức khoẻ bình thường * mọi sự vẫn bình thường, không có gì thay đổi",
  },
  {
    word: "bình thường",
    part_of_speech: "tính từ",
    meaning: "thường ngày: bình thường anh ấy dậy rất sớm",
    example: "bình thường anh ấy dậy rất sớm",
  },
  {
    word: "bình tuyển",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) (tập thể) lựa chọn trên cơ sở nhận xét, so sánh: xã viên bình tuyển giống lúa",
    example: "xã viên bình tuyển giống lúa",
  },
  {
    word: "binh tình",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) tình hình quân sự: "Đêm khuya lét thấy binh tình, Ngọn cờ ngơ ngác trống canh trễ tràng." (HT)',
    example:
      'Đêm khuya lét thấy binh tình, Ngọn cờ ngơ ngác trống canh trễ tràng." (HT)',
  },
  {
    word: "binh tình",
    part_of_speech: "danh từ",
    meaning:
      "tình hình diễn biến (của một sự việc rắc rối, phức tạp): nghe ngóng binh tình",
    example: "nghe ngóng binh tình",
  },
  {
    word: "bình vôi",
    part_of_speech: "danh từ",
    meaning:
      "bình bằng sành, bụng thường phình to, đít thót, dùng đựng vôi đã tôi để têm trầu.",
    example: "đầu bịt khăn rằn",
  },
  {
    word: "binh vận",
    part_of_speech: "động từ",
    meaning:
      "tuyên truyền, vận động chính trị (theo cách mạng) trong binh sĩ và sĩ quan đối phương (trong hoàn cảnh đang có chiến tranh): công tác binh vận",
    example: "công tác binh vận",
  },
  {
    word: "bình tĩnh",
    part_of_speech: "tính từ",
    meaning:
      '(trước tình thế dễ làm mất tự chủ) không bối rối, mà làm chủ được tình cảm, hành động của mình: mất bình tĩnh * bình tĩnh nghe xong câu chuyện * "Nàng cố giữ bình tĩnh nhưng đã thấy nghẹn ngào." (ĐĐThu; 2)',
    example:
      'mất bình tĩnh * bình tĩnh nghe xong câu chuyện * "Nàng cố giữ bình tĩnh nhưng đã thấy nghẹn ngào." (ĐĐThu; 2)',
  },
  {
    word: "bình xét",
    part_of_speech: "động từ",
    meaning:
      "bàn bạc, xem xét để đánh giá (thường là trong tập thể; nói khái quát): bình xét chất lượng sản phẩm * bình xét giải thưởng văn học trong năm",
    example:
      "bình xét chất lượng sản phẩm * bình xét giải thưởng văn học trong năm",
  },
  {
    word: "bình toong",
    part_of_speech: "danh từ",
    meaning:
      "đồ đựng bằng kim loại hoặc nhựa, miệng nhỏ, thân to và hơi dẹt, có nắp đậy bằng cách vặn, dùng đựng nước uống hoặc nói chung các chất lỏng để mang đi: một bi đông rượu * bi đông đựng nước",
    example: "một bi đông rượu * bi đông đựng nước",
  },
  {
    word: "bình yên vô sự",
    part_of_speech: "",
    meaning: "như bình yên: cả nhà vẫn bình yên vô sự",
    example: "cả nhà vẫn bình yên vô sự",
  },
  {
    word: "bình yên",
    part_of_speech: "tính từ",
    meaning:
      "ở tình trạng không gặp điều gì không hay xảy ra, làm ảnh hưởng đến sức khoẻ, đời sống: cuộc sống bình yên * gia đình được bình yên, khoẻ mạnh",
    example: "cuộc sống bình yên * gia đình được bình yên, khoẻ mạnh",
  },
  {
    word: "bình xịt",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) bình chứa chất khí hoặc chất lỏng, có nén áp lực, khi ấn vào nút van xả, khí hoặc chất lỏng xì mạnh ra: bình xịt muỗi * bình xịt hơi cay * bình xịt thuốc trừ sâu",
    example: "bình xịt muỗi * bình xịt hơi cay * bình xịt thuốc trừ sâu",
  },
  {
    word: "bịp bợm",
    part_of_speech: "tính từ",
    meaning:
      "xảo trá, chỉ nhằm đánh lừa người để mưu lợi riêng: giở trò bịp bợm * kẻ bịp bợm",
    example: "giở trò bịp bợm * kẻ bịp bợm",
  },
  {
    word: "bis",
    part_of_speech: "tính từ",
    meaning:
      "(cũ) thứ hai, lặp lại lần thứ hai (thường dùng trong các số nhà): nhà số 32 bis (số 32B)",
    example: "nhà số 32 bis (số 32B)",
  },
  {
    word: "bịp",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đánh lừa bằng những mánh khoé xảo trá: giở ngón bịp * cờ bạc bịp",
    example: "giở ngón bịp * cờ bạc bịp",
  },
  {
    word: "bíp tết",
    part_of_speech: "danh từ",
    meaning:
      "món ăn kiểu Âu, làm bằng thịt bò rán cả miếng: thịt bò bíp tết * bánh mì bíp tết",
    example: "thịt bò bíp tết * bánh mì bíp tết",
  },
  {
    word: "bit",
    part_of_speech: "danh từ",
    meaning:
      "(A: binary digit con số nhị phân, viết tắt) đơn vị thông tin nhỏ nhất, được lưu giữ trong bộ nhớ của máy tính, tương đương với sự lựa chọn giữa một trong hai giá trị (thường được kí hiệu bằng 0 và 1): một byte bằng 8 bit",
    example: "một byte bằng 8 bit",
  },
  {
    word: "bịt bùng",
    part_of_speech: "tính từ",
    meaning:
      'kín mít, không còn chỗ nào hở: cửa đóng bịt bùng * "Bốn bề đá lấp bịt bùng, Mẹ con than khóc không trông ra rồi." (LVT)',
    example:
      'cửa đóng bịt bùng * "Bốn bề đá lấp bịt bùng, Mẹ con than khóc không trông ra rồi." (LVT)',
  },
  {
    word: "bịt",
    part_of_speech: "động từ",
    meaning:
      "làm cho chỗ hở được che kín lại (bằng cách phủ cái gì đó lên trên): bịt miệng cười * lấy vải bịt miệng hũ * bịt kín cửa hang * giết người bịt đầu mối (b)",
    example:
      "bịt miệng cười * lấy vải bịt miệng hũ * bịt kín cửa hang * giết người bịt đầu mối (b)",
  },
  {
    word: "bịt",
    part_of_speech: "động từ",
    meaning:
      "bọc quanh phía ngoài hoặc mép ngoài (bằng kim khí): răng bịt vàng * đũa ngà bịt bạc",
    example: "răng bịt vàng * đũa ngà bịt bạc",
  },
  {
    word: "bít đốc",
    part_of_speech: "danh từ",
    meaning:
      "phần vách đứng hình tam giác từ đỉnh mái hồi đến nóc nhà: xây bít đốc",
    example: "xây bít đốc",
  },
  {
    word: "bít",
    part_of_speech: "động từ",
    meaning:
      "làm cho chỗ hở hoặc lối thông với bên ngoài trở thành kín đi, bị tắc đi: nhét giấy bít khe hở * cửa hang bị bít lại",
    example: "nhét giấy bít khe hở * cửa hang bị bít lại",
  },
  {
    word: "bịt mắt bắt dê",
    part_of_speech: "",
    meaning:
      "trò chơi dân gian trong đó người bị bịt mắt tìm bắt người giả làm dê: chơi trò bịt mắt bắt dê",
    example: "chơi trò bịt mắt bắt dê",
  },
  {
    word: "bịt mắt",
    part_of_speech: "động từ",
    meaning: "che đậy để đánh lừa: bịt mắt thiên hạ",
    example: "bịt mắt thiên hạ",
  },
  {
    word: "bíu",
    part_of_speech: "động từ",
    meaning:
      "nắm chặt lấy để bám vào: đứa bé bíu chặt lấy tay mẹ * hai tay bíu lấy thành giường",
    example: "đứa bé bíu chặt lấy tay mẹ * hai tay bíu lấy thành giường",
  },
  {
    word: "bịu xịu",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) từ gợi tả vẻ mặt chảy xệ xuống, trông như nặng ra lúc hờn dỗi hay lúc có điều gì đó thất vọng, không vừa lòng: mặt bịu xịu muốn khóc",
    example: "mặt bịu xịu muốn khóc",
  },
  {
    word: "bĩu",
    part_of_speech: "động từ",
    meaning:
      'trề môi dưới ra tỏ ý chê bai, khinh bỉ hay hờn dỗi: bĩu môi chê đắt * "Nỗi khinh bỉ của anh phì cả ra ngoài, theo cái bĩu môi dài thườn thượt." (NCao; 8)',
    example:
      'bĩu môi chê đắt * "Nỗi khinh bỉ của anh phì cả ra ngoài, theo cái bĩu môi dài thườn thượt." (NCao; 8)',
  },
  {
    word: "bít tất",
    part_of_speech: "danh từ",
    meaning:
      "đồ dệt hoặc đan bằng sợi, len, nylon, v.v., dùng mang ở chân: chân đi bít tất",
    example: "chân đi bít tất",
  },
  {
    word: "blốc",
    part_of_speech: "danh từ",
    meaning:
      "khối giấy gồm các tờ lịch của một năm, mỗi tờ ghi một ngày: mua một lốc lịch",
    example: "mua một lốc lịch",
  },
  {
    word: "bìu díu",
    part_of_speech: "động từ",
    meaning:
      "từ gợi tả cảnh bận bịu, vướng víu về con cái, khó dứt ra được: suốt ngày bìu díu con cái * vợ bìu con díu",
    example: "suốt ngày bìu díu con cái * vợ bìu con díu",
  },
  {
    word: "bó",
    part_of_speech: "động từ",
    meaning:
      "làm cho nhiều vật dài, rời được giữ chặt lại với nhau bằng dây buộc: bó củi thành từng bó * lúa đã ngả nhưng chưa bó",
    example: "bó củi thành từng bó * lúa đã ngả nhưng chưa bó",
  },
  {
    word: "bó",
    part_of_speech: "động từ",
    meaning:
      "(quần áo) bọc chặt lấy thân mình: quần bó * chiếc váy bó chặt lấy cơ thể",
    example: "quần bó * chiếc váy bó chặt lấy cơ thể",
  },
  {
    word: "bó",
    part_of_speech: "động từ",
    meaning: "buộc và cố định chỗ xương bị gãy: bó chỗ xương bị gãy",
    example: "bó chỗ xương bị gãy",
  },
  {
    word: "bó",
    part_of_speech: "động từ",
    meaning: "bao thành một vành xung quanh: thềm nhà bó gạch",
    example: "thềm nhà bó gạch",
  },
  {
    word: "bó",
    part_of_speech: "động từ",
    meaning:
      "kìm giữ lại trong một phạm vi chật hẹp, không cho tự do hoạt động: bó chân ở nhà",
    example: "bó chân ở nhà",
  },
  {
    word: "bó",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ nói chung những vật rời được bó lại với nhau: bó hoa * bó đũa * một bó củi",
    example: "bó hoa * bó đũa * một bó củi",
  },
  {
    word: "bõ",
    part_of_speech: "danh từ",
    meaning: "người hầu hạ linh mục hoặc phục dịch trong nhà thờ.",
    example:
      'nói cho bõ tức * "Lấy chồng cho đáng tấm chồng, Bõ công trang điểm má hồng răng đen." (Cdao)',
  },
  {
    word: "bo",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) thưởng tiền riêng cho người trực tiếp phục vụ ở cửa hàng ăn uống, khách sạn, các cơ sở dịch vụ, v.v.: tiền bo * được khách bo",
    example: "tiền bo * được khách bo",
  },
  {
    word: "bỏ",
    part_of_speech: "động từ",
    meaning:
      "để, cho vào nơi nào đó nhằm mục đích nhất định: bỏ sách vào cặp * tay bỏ túi quần * như muối bỏ biển (không có tác dụng gì) * Cuốn sách này bỏ ở đâu?",
    example:
      "bỏ sách vào cặp * tay bỏ túi quần * như muối bỏ biển (không có tác dụng gì) * Cuốn sách này bỏ ở đâu?",
  },
  {
    word: "bỏ",
    part_of_speech: "động từ",
    meaning:
      "đưa ra để dùng vào việc gì: bỏ vốn kinh doanh * bỏ sức ra làm * bỏ ra hẳn một buổi để nghỉ ngơi",
    example:
      "bỏ vốn kinh doanh * bỏ sức ra làm * bỏ ra hẳn một buổi để nghỉ ngơi",
  },
  {
    word: "bỏ",
    part_of_speech: "động từ",
    meaning:
      'để vào tình trạng, trạng thái không hay nào đó: đất bỏ hoang * bỏ quên quyển sách * "Yêu nhau chẳng lấy được nhau, Con lợn bỏ đói, buồng cau bỏ già." (Cdao)',
    example:
      'đất bỏ hoang * bỏ quên quyển sách * "Yêu nhau chẳng lấy được nhau, Con lợn bỏ đói, buồng cau bỏ già." (Cdao)',
  },
  {
    word: "bỏ",
    part_of_speech: "động từ",
    meaning:
      "để cho rời khỏi ra, không cầm hoặc không mang trên người nữa, nhằm một mục đích nhất định: bỏ súng quy hàng * bỏ mũ ra chào * bỏ dép đi chân không",
    example: "bỏ súng quy hàng * bỏ mũ ra chào * bỏ dép đi chân không",
  },
  {
    word: "bỏ",
    part_of_speech: "động từ",
    meaning:
      "làm cho rơi xuống, buông xuống nhằm mục đích nhất định: thuyền bỏ neo * máy bay bỏ bom * bỏ màn đi ngủ",
    example: "thuyền bỏ neo * máy bay bỏ bom * bỏ màn đi ngủ",
  },
  {
    word: "bỏ",
    part_of_speech: "động từ",
    meaning:
      "rời khỏi, để cho tách ra hẳn, không còn có quan hệ gì nữa đối với mình: bỏ nhà ra đi * sợ quá bỏ chạy",
    example: "bỏ nhà ra đi * sợ quá bỏ chạy",
  },
  {
    word: "bỏ",
    part_of_speech: "động từ",
    meaning:
      "không giữ lại, coi là không có giá trị, không có tác dụng: gạch bỏ đi một chữ * xoá bỏ tệ nạn xã hội * chọn xem cái nào được thì lấy, không thì bỏ",
    example:
      "gạch bỏ đi một chữ * xoá bỏ tệ nạn xã hội * chọn xem cái nào được thì lấy, không thì bỏ",
  },
  {
    word: "bỏ",
    part_of_speech: "động từ",
    meaning:
      "thôi không tiếp tục nữa: bỏ học * bỏ thuốc lá * khó quá đành bỏ dở",
    example: "bỏ học * bỏ thuốc lá * khó quá đành bỏ dở",
  },
  {
    word: "bỏ",
    part_of_speech: "động từ",
    meaning:
      'không quan tâm đến nữa, coi là không còn có quan hệ với nhau nữa: không bỏ bạn bè khi hoạn nạn * "Gió đưa bụi chuối sau hè, Anh mê vợ bé bỏ bè con thơ." (Cdao)',
    example:
      'không bỏ bạn bè khi hoạn nạn * "Gió đưa bụi chuối sau hè, Anh mê vợ bé bỏ bè con thơ." (Cdao)',
  },
  {
    word: "bọ",
    part_of_speech: "danh từ",
    meaning: "sâu bọ đã trưởng thành.",
    example: "mắm để lâu ngày có bọ",
  },
  {
    word: "bỏ bà",
    part_of_speech: "",
    meaning: "(thông tục) như bỏ mẹ: làm ăn như thế thì bỏ bà!",
    example: "làm ăn như thế thì bỏ bà!",
  },
  {
    word: "bõ bèn",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tương xứng và thoả mãn được yêu cầu cần có: ngần này thì chẳng bõ bèn! * được thì được nhưng không bõ bèn gì!",
    example:
      "ngần này thì chẳng bõ bèn! * được thì được nhưng không bõ bèn gì!",
  },
  {
    word: "bò",
    part_of_speech: "danh từ",
    meaning:
      "động vật nhai lại, chân có hai móng, sừng rỗng và ngắn, lông thường vàng, nuôi để lấy sức kéo, ăn thịt hay lấy sữa: bò sữa (bò nuôi để lấy sữa) * yếu trâu còn hơn khoẻ bò (tng)",
    example: "bò sữa (bò nuôi để lấy sữa) * yếu trâu còn hơn khoẻ bò (tng)",
  },
  {
    word: "bò",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) đơn vị dân gian để đong lường chất hạt rời, bằng lượng đựng của một hộp sữa bò: vay mấy bò gạo * mỗi bữa thổi ba bò",
    example: "vay mấy bò gạo * mỗi bữa thổi ba bò",
  },
  {
    word: "bò",
    part_of_speech: "động từ",
    meaning:
      "(động vật) di chuyển thân thể ở tư thế bụng áp xuống, bằng cử động của toàn thân hoặc của những chân ngắn: cua bò lổm ngổm * rắn bò vào hang",
    example: "cua bò lổm ngổm * rắn bò vào hang",
  },
  {
    word: "bò",
    part_of_speech: "động từ",
    meaning:
      "(người) di chuyển thân thể một cách chậm chạp, ở tư thế nằm sấp, bằng cử động đồng thời của cả tay và đầu gối: bé đã biết bò * chưa tập bò đã lo tập chạy (tng)",
    example: "bé đã biết bò * chưa tập bò đã lo tập chạy (tng)",
  },
  {
    word: "bò",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) di chuyển một cách khó khăn, chậm chạp: chiếc xe ì ạch bò lên dốc * đi bò ra đường thì bao giờ mới tới?",
    example: "chiếc xe ì ạch bò lên dốc * đi bò ra đường thì bao giờ mới tới?",
  },
  {
    word: "bò",
    part_of_speech: "động từ",
    meaning:
      "(cây thân leo) mọc vươn dài ra dần dần, thân bám sát vào bề mặt vật nào đó: cỏ gà bò lan khắp vườn * mướp bò lên giàn",
    example: "cỏ gà bò lan khắp vườn * mướp bò lên giàn",
  },
  {
    word: "bỏ bễ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) như bỏ bê (thường nói về công việc chung): bỏ bễ công việc",
    example: "bỏ bễ công việc",
  },
  {
    word: "bo bo",
    part_of_speech: "danh từ",
    meaning:
      'tên gọi thông thường của ý dĩ: "Chim quyên ăn trái bo bo, Thương người dệt lụa trao go một mình." (ca dao)',
    example:
      'Chim quyên ăn trái bo bo, Thương người dệt lụa trao go một mình." (ca dao)',
  },
  {
    word: "bo bo",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) cao lương: cơm trộn bo bo",
    example: "cơm trộn bo bo",
  },
  {
    word: "bo bo",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ, khẩu ngữ) xuồng máy: cho bo bo chạy dọc theo bờ sông",
    example: "cho bo bo chạy dọc theo bờ sông",
  },
  {
    word: "bo bo",
    part_of_speech: "danh từ",
    meaning:
      'không chịu rời ra, bỏ ra (tiền bạc, của cải) cho ai, cứ một mực giữ chặt lấy: bo bo giữ của * "Của mình thì giữ bo bo, Của người thì thả cho bò nó ăn." (ca dao)',
    example:
      'bo bo giữ của * "Của mình thì giữ bo bo, Của người thì thả cho bò nó ăn." (ca dao)',
  },
  {
    word: "bỏ bê",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bỏ mặc, không quan tâm, chăm nom gì đến: bỏ bê con cái * mải chơi, bỏ bê việc học hành",
    example: "bỏ bê con cái * mải chơi, bỏ bê việc học hành",
  },
  {
    word: "bó buộc",
    part_of_speech: "động từ",
    meaning:
      "kìm giữ trong phạm vi hạn hẹp, không cho tự do hành động: do hoàn cảnh bó buộc * không bó buộc về thời gian * bị bó buộc trong vòng lễ giáo",
    example:
      "do hoàn cảnh bó buộc * không bó buộc về thời gian * bị bó buộc trong vòng lễ giáo",
  },
  {
    word: "bó cẳng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) chịu cảnh buộc phải ở một chỗ, không đi đâu được: mưa gió đành bó cẳng ở nhà",
    example: "mưa gió đành bó cẳng ở nhà",
  },
  {
    word: "bỏ cuộc",
    part_of_speech: "động từ",
    meaning:
      "bỏ không tham dự cuộc thi hoặc tham dự nửa chừng rồi bỏ: đến chậm, coi như bỏ cuộc * thua cũng không bỏ cuộc",
    example: "đến chậm, coi như bỏ cuộc * thua cũng không bỏ cuộc",
  },
  {
    word: "bỏ cuộc",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bỏ dở, không theo đuổi đến cùng (việc cùng làm với nhiều người): thấy khó thì bỏ cuộc",
    example: "thấy khó thì bỏ cuộc",
  },
  {
    word: "bỏ dở",
    part_of_speech: "động từ",
    meaning:
      "làm nửa chừng rồi để lại: ăn cho hết, không được bỏ dở *  tiếp tục câu chuyện còn đang bỏ dở",
    example:
      "ăn cho hết, không được bỏ dở *  tiếp tục câu chuyện còn đang bỏ dở",
  },
  {
    word: "bỏ đời",
    part_of_speech: "động từ",
    meaning: "như bỏ mạng: đòm cho một phát là bỏ đời!",
    example: "đòm cho một phát là bỏ đời!",
  },
  {
    word: "bỏ đời",
    part_of_speech: "động từ",
    meaning: ".  (thông tục) như bỏ mẹ: sướng bỏ đời lại còn kêu!",
    example: "sướng bỏ đời lại còn kêu!",
  },
  {
    word: "bó chiếu",
    part_of_speech: "động từ",
    meaning:
      "bó xác vào chiếu để chôn; tả cảnh chết khổ cực: hàng săng chết bó chiếu (tng)",
    example: "hàng săng chết bó chiếu (tng)",
  },
  {
    word: "nguyên trạng",
    part_of_speech: "danh từ",
    meaning:
      "tình trạng, trạng thái vốn có từ trước: phục hồi lại nguyên trạng * bảo vệ nguyên trạng di tích lịch sử",
    example: "phục hồi lại nguyên trạng * bảo vệ nguyên trạng di tích lịch sử",
  },
  {
    word: "nguyên tử",
    part_of_speech: "danh từ",
    meaning:
      "(Hoá) phần tử nhỏ nhất của nguyên tố hoá học, gồm một hạt nhân ở giữa và một hay nhiều electron xung quanh: nhà máy điện nguyên tử * vũ khí nguyên tử",
    example: "nhà máy điện nguyên tử * vũ khí nguyên tử",
  },
  {
    word: "nguyên tố",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như yếu tố: tiền là nguyên tố quan trọng trong kinh doanh",
    example: "tiền là nguyên tố quan trọng trong kinh doanh",
  },
  {
    word: "nguyên tố",
    part_of_speech: "danh từ",
    meaning:
      "chất cơ sở có điện tích hạt nhân nguyên tử không thay đổi trong các phản ứng hoá học, tạo nên đơn chất hoặc hợp chất: nguyên tố carbon * nguyên tố phóng xạ",
    example: "nguyên tố carbon * nguyên tố phóng xạ",
  },
  {
    word: "nguyện ước",
    part_of_speech: "động từ",
    meaning:
      "hoặc d mong muốn thiết tha: thoả lòng nguyện ước * thực hiện nguyện ước của người đã khuất",
    example: "thoả lòng nguyện ước * thực hiện nguyện ước của người đã khuất",
  },
  {
    word: "nguyện ước",
    part_of_speech: "động từ",
    meaning:
      'hẹn ước, thề nguyền với nhau (thường nói về tình cảm nam nữ): "Nhớ lời nguyện ước ba sinh, Xa xôi ai có thấu tình chăng ai?" (TKiều)',
    example:
      'Nhớ lời nguyện ước ba sinh, Xa xôi ai có thấu tình chăng ai?" (TKiều)',
  },
  {
    word: "nguyên văn",
    part_of_speech: "danh từ",
    meaning:
      "bản viết, lời nói hoàn toàn đúng như của người đã viết ra, nói ra: dịch nguyên văn * đăng nguyên văn tác phẩm",
    example: "dịch nguyên văn * đăng nguyên văn tác phẩm",
  },
  {
    word: "nguyên vẹn",
    part_of_speech: "tính từ",
    meaning:
      "còn nguyên như cũ, không bị suy suyển hay mất mát gì: đồ đạc trong nhà vẫn nguyên vẹn * tình cảm không còn nguyên vẹn như xưa",
    example:
      "đồ đạc trong nhà vẫn nguyên vẹn * tình cảm không còn nguyên vẹn như xưa",
  },
  {
    word: "nguyện vọng",
    part_of_speech: "danh từ",
    meaning: "điều mong muốn: bày tỏ nguyện vọng * nguyện vọng chính đáng",
    example: "bày tỏ nguyện vọng * nguyện vọng chính đáng",
  },
  {
    word: "nguyên vị",
    part_of_speech: "tính từ",
    meaning:
      "ở nguyên vị trí, nguyên chỗ cũ: ngồi nguyên vị một chỗ * vẫn nguyên vị ở chức trưởng phòng",
    example: "ngồi nguyên vị một chỗ * vẫn nguyên vị ở chức trưởng phòng",
  },
  {
    word: "nguyên vật liệu",
    part_of_speech: "danh từ",
    meaning:
      "nguyên liệu và vật liệu (nói gộp): cửa hàng bán nguyên vật liệu xây dựng",
    example: "cửa hàng bán nguyên vật liệu xây dựng",
  },
  {
    word: "nguyệt",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) mặt trăng: "Chênh chênh bóng nguyệt xế mành, Tựa ngồi bên triện một mình thiu thiu." (TKiều)',
    example:
      'Chênh chênh bóng nguyệt xế mành, Tựa ngồi bên triện một mình thiu thiu." (TKiều)',
  },
  {
    word: "nguyệt quế",
    part_of_speech: "danh từ",
    meaning:
      "cây bụi, mọc nhiều ở vùng Địa Trung Hải, lá mềm có màu sáng như dát vàng, được người La Mã và người Hi Lạp cổ dùng làm biểu tượng của sự vinh quang: vòng nguyệt quế",
    example: "vòng nguyệt quế",
  },
  {
    word: "nguyệt thực",
    part_of_speech: "danh từ",
    meaning:
      "hiện tượng mắt ta thấy Mặt Trăng bị tối đi một phần hoặc hoàn toàn trong một lúc vì bị Trái Đất che mất ánh sáng Mặt Trời: nguyệt thực toàn phần",
    example: "nguyệt thực toàn phần",
  },
  {
    word: "nguyệt hoa",
    part_of_speech: "danh từ",
    meaning: "(cũ, văn chương) như hoa nguyệt: vui thú nguyệt hoa",
    example: "vui thú nguyệt hoa",
  },
  {
    word: "nguyệt lão",
    part_of_speech: "danh từ",
    meaning:
      'ông già ngồi dưới trăng, chuyên việc xe duyên cho người đời, theo một điển tích của Trung Quốc: "Đôi ta duyên nợ không thành, Cũng do Nguyệt Lão chỉ mành xe lơi." (ca dao)',
    example:
      'Đôi ta duyên nợ không thành, Cũng do Nguyệt Lão chỉ mành xe lơi." (ca dao)',
  },
  {
    word: "nguyên xi",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) còn nguyên như mới, như hoàn toàn chưa dùng đến: cái áo còn mới nguyên xi",
    example: "cái áo còn mới nguyên xi",
  },
  {
    word: "nguyên xi",
    part_of_speech: "tính từ",
    meaning:
      "còn nguyên như vốn có, không có sự thay đổi hay thêm bớt gì: đồ đạc trong nhà vẫn nguyên xi * chép nguyên xi, không sai một chữ",
    example:
      "đồ đạc trong nhà vẫn nguyên xi * chép nguyên xi, không sai một chữ",
  },
  {
    word: "ngự",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) ngồi ở nơi cao nhất, trang trọng nhất: Phật ngự toà sen",
    example: "Phật ngự toà sen",
  },
  {
    word: "ngự",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) ngồi chễm chệ, đàng hoàng (hàm ý châm biếm, hài hước): ngự ngay lên bàn mà nghịch",
    example: "ngự ngay lên bàn mà nghịch",
  },
  {
    word: "ngự",
    part_of_speech: "tính từ",
    meaning:
      "(đồ dùng) dành riêng cho vua, thuộc về vua: ghế ngự * giường ngự * áo ngự",
    example: "ghế ngự * giường ngự * áo ngự",
  },
  {
    word: "ngự",
    part_of_speech: "động từ",
    meaning:
      "từ dùng để nói về những hoạt động, thường là đi lại, của vua, hàm ý tôn kính: vua ngự thuyền rồng * hoàng thượng ngự triều",
    example: "vua ngự thuyền rồng * hoàng thượng ngự triều",
  },
  {
    word: "ngữ âm học",
    part_of_speech: "danh từ",
    meaning:
      "bộ môn ngôn ngữ học chuyên nghiên cứu ngữ âm của ngôn ngữ: ngữ âm học thực nghiệm",
    example: "ngữ âm học thực nghiệm",
  },
  {
    word: "ngữ",
    part_of_speech: "danh từ",
    meaning:
      "mức được dùng làm chuẩn, được xác định hoặc giới hạn (thường là theo thói quen): tiêu pha phải có ngữ * chợ có phiên, tiền có ngữ (tng)",
    example: "tiêu pha phải có ngữ * chợ có phiên, tiền có ngữ (tng)",
  },
  {
    word: "ngữ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) khoảng thời gian ước chừng (thường để so sánh): ngữ này sang năm là hoàn thành",
    example: "ngữ này sang năm là hoàn thành",
  },
  {
    word: "ngữ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) loại, hạng người hoặc vật (hàm ý coi khinh hoặc chê): ngữ mày thì làm được gì! * mua làm gì cái ngữ ấy!",
    example: "ngữ mày thì làm được gì! * mua làm gì cái ngữ ấy!",
  },
  {
    word: "ngữ",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị ngữ pháp trung gian giữa từ và câu: ngữ danh từ * ngữ cố định",
    example: "ngữ danh từ * ngữ cố định",
  },
  {
    word: "ngữ",
    part_of_speech: "danh từ",
    meaning:
      "ngôn ngữ (của một nước nào đó; nói tắt): Việt ngữ * Anh ngữ * Hán ngữ hiện đại * học sinh chuyên ngữ",
    example: "Việt ngữ * Anh ngữ * Hán ngữ hiện đại * học sinh chuyên ngữ",
  },
  {
    word: "ngữ cảm",
    part_of_speech: "danh từ",
    meaning: "cảm nhận về ngôn ngữ: dựa vào ngữ cảm * ngữ cảm tinh tế",
    example: "dựa vào ngữ cảm * ngữ cảm tinh tế",
  },
  {
    word: "ngữ cảnh",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ nói chung những đơn vị đứng trước và đứng sau một đơn vị ngôn ngữ đang xét, quy định ý nghĩa và giá trị cụ thể của đơn vị ngôn ngữ đó trong chuỗi lời nói: mở rộng ngữ cảnh * xác định ngữ cảnh vừa đủ để hiểu nghĩa một từ",
    example: "mở rộng ngữ cảnh * xác định ngữ cảnh vừa đủ để hiểu nghĩa một từ",
  },
  {
    word: "nguýt",
    part_of_speech: "động từ",
    meaning:
      "đưa mắt nhìn nghiêng thật nhanh rồi quay đi ngay, tỏ ý không bằng lòng, tức giận hoặc ghen ghét: ra lườm vào nguýt * nguýt yêu",
    example: "ra lườm vào nguýt * nguýt yêu",
  },
  {
    word: "ngư cụ",
    part_of_speech: "danh từ",
    meaning: "đồ dùng để đánh bắt cá: trang bị ngư cụ",
    example: "trang bị ngư cụ",
  },
  {
    word: "ngữ điệu",
    part_of_speech: "danh từ",
    meaning:
      "sự diễn biến của cao độ, cường độ, tốc độ âm thanh của một ngữ đoạn lời nói, biểu thị một số ý nghĩa tình thái bổ sung: ngữ điệu hỏi * phát âm không đúng ngữ điệu",
    example: "ngữ điệu hỏi * phát âm không đúng ngữ điệu",
  },
  {
    word: "ngữ đoạn",
    part_of_speech: "danh từ",
    meaning:
      "tổ hợp nhiều yếu tố bất kì làm thành một đơn vị trong chuỗi lời nói: ,  *  là những ngữ đoạn",
    example: ",  *  là những ngữ đoạn",
  },
  {
    word: "ngư hộ",
    part_of_speech: "danh từ",
    meaning:
      "hộ gia đình chuyên sống bằng nghề đánh cá: quản lí các ngư hộ theo địa bàn cư trú",
    example: "quản lí các ngư hộ theo địa bàn cư trú",
  },
  {
    word: "ngữ hệ",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp những ngôn ngữ có cùng một nguồn gốc, họ ngôn ngữ: tiếng Việt thuộc ngữ hệ Nam á",
    example: "tiếng Việt thuộc ngữ hệ Nam á",
  },
  {
    word: "ngữ khí",
    part_of_speech: "danh từ",
    meaning:
      "tư tưởng, ý chí, thái độ của người sử dụng ngôn ngữ bộc lộ ra qua cách nói, cách viết: bài thơ có ngữ khí hào hùng",
    example: "bài thơ có ngữ khí hào hùng",
  },
  {
    word: "ngữ nghĩa",
    part_of_speech: "danh từ",
    meaning:
      "nghĩa của từ, câu, v.v. trong ngôn ngữ (nói khái quát): ngữ nghĩa của từ * phân tích ngữ nghĩa của câu thơ",
    example: "ngữ nghĩa của từ * phân tích ngữ nghĩa của câu thơ",
  },
  {
    word: "ngự lãm",
    part_of_speech: "động từ",
    meaning: "(cũ) (vua) xem: dâng bức tranh lên vua ngự lãm",
    example: "dâng bức tranh lên vua ngự lãm",
  },
  {
    word: "ngư nghiệp",
    part_of_speech: "danh từ",
    meaning: "nghề đánh bắt, nuôi và chế biến cá biển: phát triển ngư nghiệp",
    example: "phát triển ngư nghiệp",
  },
  {
    word: "ngư lôi",
    part_of_speech: "danh từ",
    meaning:
      "loại đạn phóng ngầm ở dưới nước để đánh phá tàu thuyền và các công trình biển: phóng ngư lôi tiêu diệt tàu địch",
    example: "phóng ngư lôi tiêu diệt tàu địch",
  },
  {
    word: "ngữ liệu",
    part_of_speech: "danh từ",
    meaning:
      "tư liệu ngôn ngữ được dùng làm căn cứ để nghiên cứu ngôn ngữ: thu thập ngữ liệu * phân tích ngữ liệu",
    example: "thu thập ngữ liệu * phân tích ngữ liệu",
  },
  {
    word: "ngư phủ",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) người làm nghề chài lưới: "Bên sông thanh vắng một mình, Có ông ngư phủ biết tình mà thôi." (ca dao)',
    example:
      'Bên sông thanh vắng một mình, Có ông ngư phủ biết tình mà thôi." (ca dao)',
  },
  {
    word: "ngữ pháp",
    part_of_speech: "danh từ",
    meaning:
      "hệ thống những phương thức và quy tắc cấu tạo từ, cấu tạo câu trong một ngôn ngữ: nắm vững quy tắc ngữ pháp",
    example: "nắm vững quy tắc ngữ pháp",
  },
  {
    word: "ngữ pháp",
    part_of_speech: "danh từ",
    meaning:
      "những quy tắc cần theo để nói và viết cho đúng một ngôn ngữ (nói tổng quát): viết sai ngữ pháp",
    example: "viết sai ngữ pháp",
  },
  {
    word: "ngữ văn",
    part_of_speech: "danh từ",
    meaning:
      "ngôn ngữ học và văn học (nói tổng quát): giáo viên ngữ văn * sinh viên ngành ngữ văn",
    example: "giáo viên ngữ văn * sinh viên ngành ngữ văn",
  },
  {
    word: "ngư trường",
    part_of_speech: "danh từ",
    meaning:
      "khu vực biển có cá tôm tập trung với mật độ cao, thuận tiện cho việc đánh bắt: vùng biển Khánh Hoà là ngư trường trọng điểm của cả nước",
    example: "vùng biển Khánh Hoà là ngư trường trọng điểm của cả nước",
  },
  {
    word: "ngự trị",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) chiếm vị trí cao hơn hẳn tất cả một vùng xung quanh: đài quan sát ngự trị trên đỉnh cao",
    example: "đài quan sát ngự trị trên đỉnh cao",
  },
  {
    word: "ngự trị",
    part_of_speech: "động từ",
    meaning:
      "chiếm địa vị chi phối đối với tất cả những cái khác: quan hệ tình cảm mất đi khi đồng tiền ngự trị",
    example: "quan hệ tình cảm mất đi khi đồng tiền ngự trị",
  },
  {
    word: "ngự uyển",
    part_of_speech: "danh từ",
    meaning: "(cũ) vườn hoa trong cung vua: vườn ngự uyển",
    example: "vườn ngự uyển",
  },
  {
    word: "ngự y",
    part_of_speech: "danh từ",
    meaning: "(cũ) chức quan trông coi việc chữa bệnh cho vua: quan ngự y",
    example: "quan ngự y",
  },
  {
    word: "ngửa",
    part_of_speech: "tính từ",
    meaning:
      "ở tư thế mặt và phần trước cơ thể ở bên trên, gáy và lưng ở bên dưới: nằm ngửa * ngã ngửa",
    example: "nằm ngửa * ngã ngửa",
  },
  {
    word: "ngửa",
    part_of_speech: "tính từ",
    meaning:
      "ở vị trí phía mặt hay phía lòng trũng được đặt ở bên trên: để ngửa cái vung * lật ngửa con bài",
    example: "để ngửa cái vung * lật ngửa con bài",
  },
  {
    word: "ngửa",
    part_of_speech: "động từ",
    meaning:
      "làm cho ở tư thế, ở vị trí ngửa: ngửa mặt lên trời * đầu hơi ngửa về đằng sau * ngửa bát lên hứng nước",
    example:
      "ngửa mặt lên trời * đầu hơi ngửa về đằng sau * ngửa bát lên hứng nước",
  },
  {
    word: "ngứa",
    part_of_speech: "",
    meaning:
      "có cảm giác khó chịu ở ngoài da, cần được xoa, gãi: đầu bẩn nên ngứa * gãi cho đã ngứa * ăn khoai ngứa miệng",
    example: "đầu bẩn nên ngứa * gãi cho đã ngứa * ăn khoai ngứa miệng",
  },
  {
    word: "ngứa",
    part_of_speech: "",
    meaning:
      "(Khẩu ngữ) cảm thấy khó chịu, muốn làm ngay một cử chỉ, động tác nào đó, hay muốn biểu thị ngay sự phản ứng: nghe mà ngứa cái lỗ tai * ngứa chân đá cho một cái",
    example: "nghe mà ngứa cái lỗ tai * ngứa chân đá cho một cái",
  },
  {
    word: "ngừa",
    part_of_speech: "động từ",
    meaning:
      "giữ gìn, ngăn cản không để cho cái xấu, cái hại có thể xảy ra: ngừa kẻ gian * ngừa nạn tham nhũng",
    example: "ngừa kẻ gian * ngừa nạn tham nhũng",
  },
  {
    word: "ngừa",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) phòng: ngừa bệnh cho cây trồng * thuốc ngừa thai",
    example: "ngừa bệnh cho cây trồng * thuốc ngừa thai",
  },
  {
    word: "ngựa chứng",
    part_of_speech: "danh từ",
    meaning:
      "ngựa chưa thuần, không chịu đóng cương, hay lồng và nhảy dựng lên khi có người muốn cưỡi: động một tí là lồng lên như ngựa chứng",
    example: "động một tí là lồng lên như ngựa chứng",
  },
  {
    word: "ngựa hồng",
    part_of_speech: "danh từ",
    meaning:
      'ngựa có lông màu hung đỏ: "Chàng về để thiếp ngoài này, Ngựa hồng ai cỡi, dù tay ai cầm." (ca dao)',
    example:
      'Chàng về để thiếp ngoài này, Ngựa hồng ai cỡi, dù tay ai cầm." (ca dao)',
  },
  {
    word: "ngựa",
    part_of_speech: "danh từ",
    meaning:
      "thú có guốc, cổ có bờm, chân chỉ có một ngón, chạy nhanh, nuôi để cưỡi, để kéo xe: bờm ngựa * cưỡi ngựa xem hoa (tng)",
    example: "bờm ngựa * cưỡi ngựa xem hoa (tng)",
  },
  {
    word: "ngựa",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) sức ngựa (nói tắt): động cơ 10 ngựa * tàu có công suất 100 ngựa",
    example: "động cơ 10 ngựa * tàu có công suất 100 ngựa",
  },
  {
    word: "ngựa",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ thể dục, gồm một bộ phận bọc da có chân đứng, hơi giống hình con ngựa, dùng để tập nhảy: môn nhảy ngựa",
    example: "môn nhảy ngựa",
  },
  {
    word: "ngứa mắt",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) cảm thấy bực dọc, khó chịu khi nhìn thấy điều chướng mắt: trông nó làm mà ngứa mắt!",
    example: "trông nó làm mà ngứa mắt!",
  },
  {
    word: "ngứa gan",
    part_of_speech: "động từ",
    meaning:
      '(khẩu ngữ) cảm thấy tức giận, khó chịu mà phải nén lại trong lòng: "Trái tai vả lại ngứa gan, Đang tay đập vóc hoa tàn tả tơi." (BC)',
    example: 'Trái tai vả lại ngứa gan, Đang tay đập vóc hoa tàn tả tơi." (BC)',
  },
  {
    word: "ngựa nghẽo",
    part_of_speech: "danh từ",
    meaning:
      "ngựa (nói khái quát; hàm ý chê): ngựa nghẽo gì mà gầy trơ xương ra thế kia?",
    example: "ngựa nghẽo gì mà gầy trơ xương ra thế kia?",
  },
  {
    word: "ngứa nghề",
    part_of_speech: "động từ",
    meaning:
      '(thông tục) cảm thấy bị kích thích, muốn trổ tài nghệ riêng của mình (thường hàm ý chê bai, châm biếm): "Cớ sao chịu tót một bề, Gái tơ mà đã ngứa nghề sớm sao!" (TKiều)',
    example: 'Cớ sao chịu tót một bề, Gái tơ mà đã ngứa nghề sớm sao!" (TKiều)',
  },
  {
    word: "ngứa ngáy",
    part_of_speech: "động từ",
    meaning:
      "ngứa (nói khái quát): người ngứa ngáy khó chịu * không có việc làm nên chân tay ngứa ngáy",
    example:
      "người ngứa ngáy khó chịu * không có việc làm nên chân tay ngứa ngáy",
  },
  {
    word: "ngứa miệng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) có điều thấy muốn nói và cảm thấy muốn nói ngay, không kìm lại được: ngứa miệng nói chêm vào một câu",
    example: "ngứa miệng nói chêm vào một câu",
  },
  {
    word: "ngửa nghiêng",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) như nghiêng ngửa: ngửa nghiêng trước sóng gió của cuộc đời",
    example: "ngửa nghiêng trước sóng gió của cuộc đời",
  },
  {
    word: "ngứa tai",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) cảm thấy bực dọc khó chịu khi nghe thấy điều trái tai: nghe nó nói mà ngứa tai",
    example: "nghe nó nói mà ngứa tai",
  },
  {
    word: "ngứa tay",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) cảm thấy khó chịu muốn làm ngay một động tác nào đó mà không suy nghĩ, không tính đến hậu quả: ngứa tay táng cho một phát",
    example: "ngứa tay táng cho một phát",
  },
  {
    word: "ngực",
    part_of_speech: "danh từ",
    meaning:
      "phần thân từ cổ tới bụng, chứa tim và phổi, ứng với bộ xương sườn: mặc áo phanh ngực * nằm sấp bị tức ngực * vỗ ngực tự xưng",
    example: "mặc áo phanh ngực * nằm sấp bị tức ngực * vỗ ngực tự xưng",
  },
  {
    word: "ngực",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) vú của phụ nữ (thường còn trẻ; lối nói kiêng tránh): thẩm mĩ nâng ngực",
    example: "thẩm mĩ nâng ngực",
  },
  {
    word: "ngửa tay",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) ví hành động tự hạ mình để cầu xin: ngửa tay xin tiền",
    example: "ngửa tay xin tiền",
  },
  {
    word: "ngứa tiết",
    part_of_speech: "động từ",
    meaning: "(thông tục) tức điên lên: ngứa tiết đánh cho một trận",
    example: "ngứa tiết đánh cho một trận",
  },
  {
    word: "ngựa ô",
    part_of_speech: "danh từ",
    meaning:
      'ngựa có lông màu đen: "Ngựa ô anh thắng kiệu vàng, Anh tra khớp bạc đưa nàng về dinh." (ca dao)',
    example:
      'Ngựa ô anh thắng kiệu vàng, Anh tra khớp bạc đưa nàng về dinh." (ca dao)',
  },
  {
    word: "ngửi",
    part_of_speech: "động từ",
    meaning:
      "hít vào bằng mũi để nhận biết, phân biệt mùi: đưa lên mũi ngửi * ngửi thấy mùi khét * con chó ngửi hơi chủ",
    example: "đưa lên mũi ngửi * ngửi thấy mùi khét * con chó ngửi hơi chủ",
  },
  {
    word: "ngửi",
    part_of_speech: "động từ",
    meaning: "(thông tục) chịu được, chấp nhận được: nói thế ai mà ngửi được!",
    example: "nói thế ai mà ngửi được!",
  },
  {
    word: "ngừng nghỉ",
    part_of_speech: "động từ",
    meaning:
      "ngừng lại không hoạt động nữa, trong một thời gian: xe chạy liên tục không ngừng nghỉ",
    example: "xe chạy liên tục không ngừng nghỉ",
  },
  {
    word: "ngưng đọng",
    part_of_speech: "động từ",
    meaning:
      "ở vào tình trạng dồn ứ lại, không lưu thông: nước ngưng đọng lại thành từng vũng",
    example: "nước ngưng đọng lại thành từng vũng",
  },
  {
    word: "ngưng tụ",
    part_of_speech: "động từ",
    meaning:
      "chuyển từ trạng thái khí hoặc hơi sang trạng thái lỏng: hơi nước trong khí quyển ngưng tụ lại thành mây",
    example: "hơi nước trong khí quyển ngưng tụ lại thành mây",
  },
  {
    word: "ngừng bắn",
    part_of_speech: "động từ",
    meaning:
      "tạm ngừng chiến sự, do sự thoả thuận giữa hai bên: kí hiệp định ngừng bắn",
    example: "kí hiệp định ngừng bắn",
  },
  {
    word: "ngừng",
    part_of_speech: "động từ",
    meaning:
      "không tiếp tục hoạt động, phát triển: tim ngừng đập * trời ngừng mưa * thế giới thay đổi không ngừng",
    example: "tim ngừng đập * trời ngừng mưa * thế giới thay đổi không ngừng",
  },
  {
    word: "ngước",
    part_of_speech: "động từ",
    meaning: "đưa mắt nhìn lên cao: ngước mắt nhìn trời",
    example: "ngước mắt nhìn trời",
  },
  {
    word: "ngưng trệ",
    part_of_speech: "động từ",
    meaning:
      "như ngừng trệ: sản xuất bị ngưng trệ * mọi hoạt động kinh tế đều bị ngưng trệ",
    example: "sản xuất bị ngưng trệ * mọi hoạt động kinh tế đều bị ngưng trệ",
  },
  {
    word: "ngừng trệ",
    part_of_speech: "động từ",
    meaning:
      "lâm vào tình trạng bị ngừng lại, sinh ra dồn ứ, chậm trễ: sản xuất bị ngừng trệ * giao thông ngừng trệ",
    example: "sản xuất bị ngừng trệ * giao thông ngừng trệ",
  },
  {
    word: "ngược",
    part_of_speech: "tính từ",
    meaning:
      "(vận động) theo chiều trái lại: xe đi ngược chiều * quay ngược kim đồng hồ * ngược gió",
    example: "xe đi ngược chiều * quay ngược kim đồng hồ * ngược gió",
  },
  {
    word: "ngược",
    part_of_speech: "tính từ",
    meaning:
      "có các mặt hoặc các phía bị đảo trái thành phải, dưới lên trên, sau ra trước: mặc áo ngược * cầm ngược quyển sách * lật ngược vấn đề (b)",
    example: "mặc áo ngược * cầm ngược quyển sách * lật ngược vấn đề (b)",
  },
  {
    word: "ngược",
    part_of_speech: "tính từ",
    meaning:
      "ở vị trí dựng đứng lên một cách không bình thường: sợ quá, tóc gáy dựng ngược * sợi râu mọc ngược * vách đá dựng ngược",
    example:
      "sợ quá, tóc gáy dựng ngược * sợi râu mọc ngược * vách đá dựng ngược",
  },
  {
    word: "ngược",
    part_of_speech: "tính từ",
    meaning:
      "hoặc d (vùng) ở nơi rừng núi, ở phía phải đi ngược dòng sông mới đến: miền ngược * sống ở mạn ngược",
    example: "miền ngược * sống ở mạn ngược",
  },
  {
    word: "ngược",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đi lên phía miền ngược, hoặc theo một hướng thường được coi là ngược chiều: thuyền ngược dòng sông Lô * ngược lên trên một đoạn là tới",
    example: "thuyền ngược dòng sông Lô * ngược lên trên một đoạn là tới",
  },
  {
    word: "ngược đãi",
    part_of_speech: "động từ",
    meaning:
      "đối xử tàn tệ, trái với đạo lí: bị dì ghẻ ngược đãi * ngược đãi người làm thuê",
    example: "bị dì ghẻ ngược đãi * ngược đãi người làm thuê",
  },
  {
    word: "ngược lại",
    part_of_speech: "",
    meaning:
      "tổ hợp biểu thị điều sắp nêu ra (hoặc hàm ý muốn nói) có nội dung hoặc có quan hệ ngược lại với điều vừa nói đến: đã không phạt, ngược lại còn trọng thưởng",
    example: "đã không phạt, ngược lại còn trọng thưởng",
  },
  {
    word: "ngược đời",
    part_of_speech: "tính từ",
    meaning: "trái với lẽ thường ở đời: chuyện ngược đời",
    example: "chuyện ngược đời",
  },
  {
    word: "ngược xuôi",
    part_of_speech: "động từ",
    meaning:
      'đi theo những hướng khác nhau, trái chiều nhau (nói khái quát): dòng người ngược xuôi * "Những là đo đắn ngược xuôi, Tiếng gà nghe đã gáy sôi mé tường." (TKiều)',
    example:
      'dòng người ngược xuôi * "Những là đo đắn ngược xuôi, Tiếng gà nghe đã gáy sôi mé tường." (TKiều)',
  },
  {
    word: "ngược ngạo",
    part_of_speech: "tính từ",
    meaning:
      "trái với lẽ thường, lẽ phải, bất chấp tất cả: ăn nói ngược ngạo * cách cư xử ngược ngạo",
    example: "ăn nói ngược ngạo * cách cư xử ngược ngạo",
  },
  {
    word: "ngươi",
    part_of_speech: "đại từ",
    meaning:
      "(cũ) từ dùng để gọi người đối thoại thuộc bề dưới: các ngươi hãy bình thân!",
    example: "các ngươi hãy bình thân!",
  },
  {
    word: "người bệnh",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) người có bệnh, cần được cứu chữa: chăm sóc người bệnh",
    example: "chăm sóc người bệnh",
  },
  {
    word: "người",
    part_of_speech: "danh từ",
    meaning:
      "động vật tiến hoá nhất, có khả năng nói, tư duy, sáng tạo và sử dụng công cụ trong quá trình lao động xã hội: xã hội loài người * mặt người dạ thú",
    example: "xã hội loài người * mặt người dạ thú",
  },
  {
    word: "người",
    part_of_speech: "danh từ",
    meaning:
      "cơ thể, thân thể con người nói chung: người cao lớn, vạm vỡ * lách người qua khe đá * thấy trong người khoẻ ra",
    example:
      "người cao lớn, vạm vỡ * lách người qua khe đá * thấy trong người khoẻ ra",
  },
  {
    word: "người",
    part_of_speech: "danh từ",
    meaning: "con người trưởng thành có đầy đủ tư cách: con cái đã nên người",
    example: "con cái đã nên người",
  },
  {
    word: "người",
    part_of_speech: "danh từ",
    meaning:
      "người khác, người xa lạ, trong quan hệ đối lập với ta, với mình: bơ vơ nơi xứ người * làm dâu nhà người * của người phúc ta (tng)",
    example: "bơ vơ nơi xứ người * làm dâu nhà người * của người phúc ta (tng)",
  },
  {
    word: "người",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng cá thể người thuộc một loại, một tầng lớp nào đó: người lính * người thiếu nữ * người lao động",
    example: "người lính * người thiếu nữ * người lao động",
  },
  {
    word: "người",
    part_of_speech: "danh từ",
    meaning:
      "(viết hoa) từ dùng để chỉ người ở ngôi thứ ba với ý coi trọng đặc biệt: Hồ Chủ tịch và sự nghiệp của Người * làm theo lời Người dạy",
    example: "Hồ Chủ tịch và sự nghiệp của Người * làm theo lời Người dạy",
  },
  {
    word: "người",
    part_of_speech: "danh từ",
    meaning:
      'từ dùng để gọi người đối thoại với ý thân mật, hoặc khinh thường: các người lui ra * "Người ơi người ở đừng về (...)" (ca dao)',
    example: 'các người lui ra * "Người ơi người ở đừng về (...)" (ca dao)',
  },
  {
    word: "người dưng",
    part_of_speech: "danh từ",
    meaning:
      'người không có quan hệ họ hàng, thân thích với mình: "Người dưng có ngãi thì đãi người dưng, Anh em không ngãi thì đừng anh em." (ca dao)',
    example:
      'Người dưng có ngãi thì đãi người dưng, Anh em không ngãi thì đừng anh em." (ca dao)',
  },
  {
    word: "người bị hại",
    part_of_speech: "danh từ",
    meaning:
      "người bị thiệt hại về thể chất, vật chất hoặc tinh thần do tội phạm gây ra: liên hệ với thân nhân người bị hại",
    example: "liên hệ với thân nhân người bị hại",
  },
  {
    word: "người đời",
    part_of_speech: "danh từ",
    meaning:
      "con người sống ở đời, nói chung: được người đời kính trọng * miệng tiếng của người đời",
    example: "được người đời kính trọng * miệng tiếng của người đời",
  },
  {
    word: "người đời",
    part_of_speech: "danh từ",
    meaning:
      '(khẩu ngữ) người không tinh nhạy, ngây ngô, kém cỏi (dùng trong tiếng mắng): "Rõ người đời! Bao nhiêu tuổi mà cũng không nhớ." (MPTư; 1)',
    example: 'Rõ người đời! Bao nhiêu tuổi mà cũng không nhớ." (MPTư; 1)',
  },
  {
    word: "người làm",
    part_of_speech: "danh từ",
    meaning: "người chuyên làm thuê cho tư nhân: thuê người làm",
    example: "thuê người làm",
  },
  {
    word: "người mẫu",
    part_of_speech: "danh từ",
    meaning:
      "người làm mẫu để vẽ, chụp ảnh, nặn tượng, v.v. hoặc chuyên trình diễn các mẫu thời trang nào đó như quần áo, giày dép, v.v.: người mẫu thời trang * làm người mẫu cho phòng tranh",
    example: "người mẫu thời trang * làm người mẫu cho phòng tranh",
  },
  {
    word: "người ngợm",
    part_of_speech: "danh từ",
    meaning: "thân hình con người nói chung (hàm ý chê): người ngợm xấu xí",
    example: "người ngợm xấu xí",
  },
  {
    word: "người nhà",
    part_of_speech: "danh từ",
    meaning:
      "người trong cùng một gia đình, có quan hệ thân thiết với nhau (nói khái quát); phân biệt với người ngoài: người nhà của bệnh nhân * coi nhau như người nhà",
    example: "người nhà của bệnh nhân * coi nhau như người nhà",
  },
  {
    word: "người lớn",
    part_of_speech: "danh từ",
    meaning:
      "người đã ở độ tuổi trưởng thành, được coi là đứng đắn, đủ tư cách: chuyện người lớn, trẻ con không được xen vào",
    example: "chuyện người lớn, trẻ con không được xen vào",
  },
  {
    word: "người ngoài",
    part_of_speech: "danh từ",
    meaning:
      "người không có quan hệ gia đình với mình (nói khái quát); phân biệt với người nhà: chuyện trong nhà, không nên để người ngoài biết",
    example: "chuyện trong nhà, không nên để người ngoài biết",
  },
  {
    word: "người ngoài",
    part_of_speech: "danh từ",
    meaning:
      "người không có liên quan gì đến sự việc đang xảy ra, trong quan hệ với người trong cuộc (nói khái quát): việc này người ngoài không hiểu được",
    example: "việc này người ngoài không hiểu được",
  },
  {
    word: "người máy",
    part_of_speech: "danh từ",
    meaning:
      "máy thường có hình dạng giống người, có thể làm thay cho con người một số việc, thực hiện một số thao tác kĩ thuật phức tạp: chế tạo robot",
    example: "chế tạo robot",
  },
  {
    word: "người người",
    part_of_speech: "danh từ",
    meaning:
      "tất cả mọi người, không trừ một ai: người người như một * người người thi đua",
    example: "người người như một * người người thi đua",
  },
  {
    word: "người hùng",
    part_of_speech: "danh từ",
    meaning:
      "người tài giỏi hơn nhiều người, làm được những việc phi thường, được mọi người chú ý (thường hàm ý mỉa mai): người hùng trên sân cỏ",
    example: "người hùng trên sân cỏ",
  },
  {
    word: "người ở",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người đến ở để làm thuê, giúp các việc sinh hoạt cho một gia đình: mướn người ở",
    example: "mướn người ở",
  },
  {
    word: "người phát ngôn",
    part_of_speech: "danh từ",
    meaning:
      "người thay mặt chính thức cho một cơ quan nhà nước hoặc cho một tổ chức, một hội nghị, v.v. chịu trách nhiệm tuyên bố hoặc giải thích về những vấn đề nhất định: người phát ngôn của bộ ngoại giao",
    example: "người phát ngôn của bộ ngoại giao",
  },
  {
    word: "người thân",
    part_of_speech: "danh từ",
    meaning:
      "người có quan hệ ruột thịt hoặc gắn bó thân thiết với mình: ở nhờ nhà một người thân * đón người thân trở về",
    example: "ở nhờ nhà một người thân * đón người thân trở về",
  },
  {
    word: "người quen kẻ thuộc",
    part_of_speech: "",
    meaning:
      '(khẩu ngữ) những người quen thuộc, thân thiết (nói khái quát): "Người quen kẻ thuộc chung quanh, Nhủ nàng hãy tạm lánh mình một nơi." (TKiều)',
    example:
      'Người quen kẻ thuộc chung quanh, Nhủ nàng hãy tạm lánh mình một nơi." (TKiều)',
  },
  {
    word: "người ta",
    part_of_speech: "danh từ",
    meaning:
      'con người (nói khái quát): người ta, ai chẳng có sai lầm * "Trăm năm trong cõi người ta, Chữ Tài, chữ Mệnh, khéo là ghét nhau." (TKiều)',
    example:
      'người ta, ai chẳng có sai lầm * "Trăm năm trong cõi người ta, Chữ Tài, chữ Mệnh, khéo là ghét nhau." (TKiều)',
  },
  {
    word: "người ta",
    part_of_speech: "đại từ",
    meaning:
      "(Khẩu ngữ) từ dùng để chỉ chung những người bất kì, ngoài mình hay ngoài những người đang trong cuộc: chuyện nhà người ta, liên quan gì đến mình * làm thế người ta cười cho",
    example:
      "chuyện nhà người ta, liên quan gì đến mình * làm thế người ta cười cho",
  },
  {
    word: "người ta",
    part_of_speech: "đại từ",
    meaning:
      "từ dùng để chỉ người nào đó mà không muốn nêu rõ ra (thường hàm ý giễu cợt hay oán trách): người ta có coi mình ra cái gì đâu!",
    example: "người ta có coi mình ra cái gì đâu!",
  },
  {
    word: "người ta",
    part_of_speech: "đại từ",
    meaning:
      "từ dùng để tự xưng trong đối thoại (thường với ý thân mật hay trịch thượng): thấy chưa, người ta đã bảo rồi mà!",
    example: "thấy chưa, người ta đã bảo rồi mà!",
  },
  {
    word: "người thương",
    part_of_speech: "danh từ",
    meaning:
      '(phương ngữ) người yêu: "Đói lòng ăn nửa trái sim, Uống lưng bát nước đi tìm người thương." (ca dao)',
    example:
      'Đói lòng ăn nửa trái sim, Uống lưng bát nước đi tìm người thương." (ca dao)',
  },
  {
    word: "người tình",
    part_of_speech: "danh từ",
    meaning:
      "người có quan hệ yêu đương không chính đáng với người khác, trong quan hệ với người ấy: có nhân tình * bỏ nhà theo nhân tình",
    example: "có nhân tình * bỏ nhà theo nhân tình",
  },
  {
    word: "người tình",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) người yêu: "Cô nhân tình bé của tôi ơi!, Tôi muốn môi cô chỉ mỉm cười." (NgBính; 6)',
    example:
      'Cô nhân tình bé của tôi ơi!, Tôi muốn môi cô chỉ mỉm cười." (NgBính; 6)',
  },
  {
    word: "người tình",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) tình cảm giữa con người với nhau; tình người (nói khái quát): "Trước đèn xem truyện Tây minh, Gẫm cười hai chữ nhân tình éo le." (LVT)',
    example:
      'Trước đèn xem truyện Tây minh, Gẫm cười hai chữ nhân tình éo le." (LVT)',
  },
  {
    word: "người vượn",
    part_of_speech: "danh từ",
    meaning:
      "động vật thời xa xưa, còn mang nhiều tính chất vượn nhưng đã dần dần chuyển hoá thành người, do biết sử dụng công cụ để lao động: quá trình người vượn tiến hoá thành người",
    example: "quá trình người vượn tiến hoá thành người",
  },
  {
    word: "người xưa",
    part_of_speech: "danh từ",
    meaning:
      "người đời xưa, sống cách ngày nay đã lâu đời (nói khái quát; hàm ý tôn kính): kinh nghiệm của người xưa để lại",
    example: "kinh nghiệm của người xưa để lại",
  },
  {
    word: "người xưa",
    part_of_speech: "danh từ",
    meaning:
      '(văn chương) người yêu cũ: gặp lại người xưa * "Ai về nhắn với người xưa, Lời thề phai lạt nhưng chưa thay lòng." (ca dao)',
    example:
      'gặp lại người xưa * "Ai về nhắn với người xưa, Lời thề phai lạt nhưng chưa thay lòng." (ca dao)',
  },
  {
    word: "người yêu",
    part_of_speech: "danh từ",
    meaning:
      "người có quan hệ tình cảm thắm thiết, có ý muốn chung sống và gắn bó cuộc đời với một người nào đó: chưa có người yêu * người yêu cũ",
    example: "chưa có người yêu * người yêu cũ",
  },
  {
    word: "ngưỡng",
    part_of_speech: "danh từ",
    meaning:
      "đại lượng xác định của một dạng năng lượng (ánh sáng, âm thanh, mùi vị, v.v.) mà phải vượt qua nó mới gây ra được cảm giác tương ứng: ngưỡng nhìn",
    example: "ngưỡng nhìn",
  },
  {
    word: "ngưỡng",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) giới hạn: vượt quá ngưỡng của tình bạn * giá cà phê đã chạm ngưỡng thấp nhất",
    example:
      "vượt quá ngưỡng của tình bạn * giá cà phê đã chạm ngưỡng thấp nhất",
  },
  {
    word: "ngượng",
    part_of_speech: "",
    meaning:
      "có cảm giác cử động không được tự nhiên, thoải mái như ý muốn: mới tập làm nên ngượng tay * chân đau, bước đi còn ngượng",
    example: "mới tập làm nên ngượng tay * chân đau, bước đi còn ngượng",
  },
  {
    word: "ngượng",
    part_of_speech: "",
    meaning:
      "cảm thấy xấu hổ hoặc thấy bối rối, mất tự nhiên trước những người khác: ngượng chín người * nói dối không biết ngượng",
    example: "ngượng chín người * nói dối không biết ngượng",
  },
  {
    word: "ngưỡng cửa",
    part_of_speech: "danh từ",
    meaning: "thanh dưới của khung cửa ra vào: bước qua ngưỡng cửa",
    example: "bước qua ngưỡng cửa",
  },
  {
    word: "ngưỡng cửa",
    part_of_speech: "danh từ",
    meaning:
      "lúc mới đầu của cả một quá trình, lúc bước vào một giai đoạn: bước vào ngưỡng cửa đại học",
    example: "bước vào ngưỡng cửa đại học",
  },
  {
    word: "ngưỡng mộ",
    part_of_speech: "động từ",
    meaning:
      "kính phục và yêu mến: ngưỡng mộ tài năng * nhìn bằng ánh mắt ngưỡng mộ",
    example: "ngưỡng mộ tài năng * nhìn bằng ánh mắt ngưỡng mộ",
  },
  {
    word: "ngượng mặt",
    part_of_speech: "động từ",
    meaning:
      "cảm thấy có điều xấu hổ, không muốn gặp người khác: nói đến thế mà không biết ngượng mặt!",
    example: "nói đến thế mà không biết ngượng mặt!",
  },
  {
    word: "ngượng nghịu",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra không được tự nhiên trong các cử chỉ, cách đi đứng, nói năng: nụ cười ngượng nghịu * mới làm nên chân tay còn ngượng nghịu",
    example: "nụ cười ngượng nghịu * mới làm nên chân tay còn ngượng nghịu",
  },
  {
    word: "ngượng ngập",
    part_of_speech: "tính từ",
    meaning:
      "có vẻ ngượng, có những biểu hiện, cử chỉ không được tự nhiên: bước chân ngượng ngập * cử chỉ e dè, ngượng ngập",
    example: "bước chân ngượng ngập * cử chỉ e dè, ngượng ngập",
  },
  {
    word: "ngượng mồm",
    part_of_speech: "động từ",
    meaning: "cảm thấy ngượng, khó nói: nói dối không ngượng mồm!",
    example: "nói dối không ngượng mồm!",
  },
  {
    word: "ngượng ngùng",
    part_of_speech: "tính từ",
    meaning:
      "cảm thấy ngượng, để biểu lộ ra bằng dáng vẻ, cử chỉ (nói khái quát): cử chỉ ngượng ngùng * ánh mắt ngượng ngùng",
    example: "cử chỉ ngượng ngùng * ánh mắt ngượng ngùng",
  },
  {
    word: "ngưỡng vọng",
    part_of_speech: "động từ",
    meaning:
      "hướng đến với lòng hi vọng, trông đợi hoặc với lòng kính trọng, khâm phục: một vĩ nhân được người đời ngưỡng vọng",
    example: "một vĩ nhân được người đời ngưỡng vọng",
  },
  {
    word: "ngường ngượng",
    part_of_speech: "",
    meaning: "hơi ngượng: bị trêu nên cũng thấy ngường ngượng",
    example: "bị trêu nên cũng thấy ngường ngượng",
  },
  {
    word: "nhà",
    part_of_speech: "danh từ",
    meaning:
      "công trình xây dựng có mái, có tường vách để ở hay để sử dụng vào một việc nào đó: xây nhà * căn nhà lá * đồ đạc để đầy nhà * nhà dột từ nóc dột xuống (tng)",
    example:
      "xây nhà * căn nhà lá * đồ đạc để đầy nhà * nhà dột từ nóc dột xuống (tng)",
  },
  {
    word: "nhà",
    part_of_speech: "danh từ",
    meaning:
      "chỗ ở riêng, thường cùng với gia đình: ốm nên phải nghỉ ở nhà * sang nhà hàng xóm chơi",
    example: "ốm nên phải nghỉ ở nhà * sang nhà hàng xóm chơi",
  },
  {
    word: "nhà",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp người có quan hệ gia đình cùng ở trong một nhà: người trong nhà * bận việc nhà * ăn cơm nhà vác tù và hàng tổng (tng)",
    example:
      "người trong nhà * bận việc nhà * ăn cơm nhà vác tù và hàng tổng (tng)",
  },
  {
    word: "nhà",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp những vua cùng một dòng họ kế tiếp nhau trị vì: nhà Lý lập đô ở Thăng Long * đời nhà Lê",
    example: "nhà Lý lập đô ở Thăng Long * đời nhà Lê",
  },
  {
    word: "nhà",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) từ dùng để chỉ vợ hay chồng mình khi nói với người khác, hoặc vợ chồng dùng để gọi nhau trong đối thoại: nhà tôi đi vắng",
    example: "nhà tôi đi vắng",
  },
  {
    word: "nhà",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) từ dùng trong đối thoại để chỉ cá nhân người khác một cách thân mật hoặc với ý coi thường: cái nhà chị này hay nhỉ!",
    example: "cái nhà chị này hay nhỉ!",
  },
  {
    word: "nhà",
    part_of_speech: "danh từ",
    meaning:
      "người hoặc những gì có quan hệ rất gần gũi, thuộc về, hoặc coi như thuộc về gia đình mình, tập thể mình: chị nhà đã về chưa? * sống ở quê nhà * cây nhà lá vườn",
    example: "chị nhà đã về chưa? * sống ở quê nhà * cây nhà lá vườn",
  },
  {
    word: "nhà",
    part_of_speech: "danh từ",
    meaning:
      "(Trang trọng) người chuyên một ngành nghề, một lĩnh vực hoạt động nào đó, đạt trình độ nhất định: nhà chính trị * nhà sử học * nhà nghiên cứu",
    example: "nhà chính trị * nhà sử học * nhà nghiên cứu",
  },
  {
    word: "nhá",
    part_of_speech: "động từ",
    meaning:
      "nhai kĩ cho giập, cho nát (thường vật dai, cứng, khó ăn): nhá cơm * nhá không nổi phải nhè ra (b)",
    example: "nhá cơm * nhá không nổi phải nhè ra (b)",
  },
  {
    word: "nhá",
    part_of_speech: "trợ từ",
    meaning: "(khẩu ngữ) nhé: thôi nhá! * tôi đi nhá!",
    example: "thôi nhá! * tôi đi nhá!",
  },
  {
    word: "nhã",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (cơm, bột) nát và ướt vì cho quá nhiều nước: cơm nấu bị nhã",
    example: "cơm nấu bị nhã",
  },
  {
    word: "nhã",
    part_of_speech: "tính từ",
    meaning: "lịch sự, có lễ độ: lời nói nhã * thú chơi nhã",
    example: "lời nói nhã * thú chơi nhã",
  },
  {
    word: "nhã",
    part_of_speech: "tính từ",
    meaning:
      "đẹp một cách giản dị, lịch sự, không cầu kì, loè loẹt: chiếc áo có màu rất nhã",
    example: "chiếc áo có màu rất nhã",
  },
  {
    word: "nha",
    part_of_speech: "danh từ",
    meaning:
      "(Từ cũ) cơ quan hành chính cấp cao trong tổ chức hành chính trước đây, có chức năng, quyền hạn tương đương với tổng cục: nha cảnh sát",
    example: "nha cảnh sát",
  },
  {
    word: "nhả",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) mẻ: xay một nhả lúa",
    example: "xay một nhả lúa",
  },
  {
    word: "nhả",
    part_of_speech: "động từ",
    meaning:
      "làm cho rời ra khỏi miệng, không ngậm nữa: ăn mía nhả bã * tằm nhả tơ",
    example: "ăn mía nhả bã * tằm nhả tơ",
  },
  {
    word: "nhả",
    part_of_speech: "động từ",
    meaning:
      "rời ra, buông ra, không giữ lại nữa: nhả tay ga * nhả phanh cho xe lao nhanh",
    example: "nhả tay ga * nhả phanh cho xe lao nhanh",
  },
  {
    word: "nhả",
    part_of_speech: "động từ",
    meaning:
      "rời ra, không còn kết dính được nữa: sơn nhả ra từng mảng * giấy dán tường đã nhả",
    example: "sơn nhả ra từng mảng * giấy dán tường đã nhả",
  },
  {
    word: "nhả",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bắn ra, phun ra hàng loạt dài: xe nhả khói mù mịt * đại bác nhả lửa",
    example: "xe nhả khói mù mịt * đại bác nhả lửa",
  },
  {
    word: "nhà ăn",
    part_of_speech: "danh từ",
    meaning:
      "nhà dành làm nơi ăn uống của một tập thể: nhà ăn tập thể * ăn ở nhà ăn của xí nghiệp",
    example: "nhà ăn tập thể * ăn ở nhà ăn của xí nghiệp",
  },
  {
    word: "nhà buôn",
    part_of_speech: "danh từ",
    meaning: "người làm nghề buôn bán lớn: một nhà buôn lớn",
    example: "một nhà buôn lớn",
  },
  {
    word: "nhà băng",
    part_of_speech: "danh từ",
    meaning: "(cũ) ngân hàng: gửi tiền vào nhà băng",
    example: "gửi tiền vào nhà băng",
  },
  {
    word: "nhà băng",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) băng nhân: "Trước thầy sau tớ lao xao, Nhà băng đưa mối, rước vào lầu trang." (TKiều)',
    example:
      'Trước thầy sau tớ lao xao, Nhà băng đưa mối, rước vào lầu trang." (TKiều)',
  },
  {
    word: "nhà bếp",
    part_of_speech: "danh từ",
    meaning: "nhà dùng làm nơi nấu ăn: dụng cụ nhà bếp",
    example: "dụng cụ nhà bếp",
  },
  {
    word: "nhà binh",
    part_of_speech: "danh từ",
    meaning: "(cũ) quân đội: kỉ luật nhà binh * chào theo kiểu nhà binh",
    example: "kỉ luật nhà binh * chào theo kiểu nhà binh",
  },
  {
    word: "nhà chọc trời",
    part_of_speech: "danh từ",
    meaning: "nhà rất cao, có tới hàng mấy chục tầng: toà nhà chọc trời",
    example: "toà nhà chọc trời",
  },
  {
    word: "nhà chức trách",
    part_of_speech: "danh từ",
    meaning:
      "người có quyền và có trách nhiệm đại diện chính quyền để giải quyết công việc cho nhân dân (nói khái quát): lẩn tránh con mắt của nhà chức trách",
    example: "lẩn tránh con mắt của nhà chức trách",
  },
  {
    word: "nhà doanh nghiệp",
    part_of_speech: "danh từ",
    meaning: "như nhà kinh doanh: nhà doanh nghiệp trẻ",
    example: "nhà doanh nghiệp trẻ",
  },
  {
    word: "nhà cửa",
    part_of_speech: "danh từ",
    meaning: "nhà ở (nói khái quát): nhà cửa sạch sẽ * nhà cửa mọc lên san sát",
    example: "nhà cửa sạch sẽ * nhà cửa mọc lên san sát",
  },
  {
    word: "nhà chùa",
    part_of_speech: "danh từ",
    meaning:
      "nơi thờ Phật hoặc những người tu hành theo đạo Phật (nói khái quát): mặc áo nhà chùa",
    example: "mặc áo nhà chùa",
  },
  {
    word: "nhà đá",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) như nhà tù: nằm nhà đá",
    example: "nằm nhà đá",
  },
  {
    word: "nhà điều dưỡng",
    part_of_speech: "danh từ",
    meaning:
      "cơ sở điều trị bệnh và bồi dưỡng sức khoẻ, thường ở nơi có khí hậu và môi trường thuận lợi: nghỉ ở nhà điều dưỡng",
    example: "nghỉ ở nhà điều dưỡng",
  },
  {
    word: "nhà gái",
    part_of_speech: "danh từ",
    meaning:
      "những người phía gia đình cô dâu ở một đám cưới, đám hỏi, trong quan hệ với nhà trai (nói tổng quát): đến nhà gái đón dâu",
    example: "đến nhà gái đón dâu",
  },
  {
    word: "nhà đất",
    part_of_speech: "danh từ",
    meaning:
      "nhà ở và đất đai (nói khái quát): quản lí nhà đất * kinh doanh nhà đất",
    example: "quản lí nhà đất * kinh doanh nhà đất",
  },
  {
    word: "nhà giam",
    part_of_speech: "danh từ",
    meaning: "nơi giam giữ những người bị bắt: bị tống vào nhà giam",
    example: "bị tống vào nhà giam",
  },
  {
    word: "nhà giáo",
    part_of_speech: "danh từ",
    meaning: "(trang trọng) người làm nghề dạy học: một nhà giáo có tên tuổi",
    example: "một nhà giáo có tên tuổi",
  },
  {
    word: "nhà ga",
    part_of_speech: "danh từ",
    meaning: "ga tàu hoả: ngồi đợi tàu ở nhà ga",
    example: "ngồi đợi tàu ở nhà ga",
  },
  {
    word: "nhà ga",
    part_of_speech: "danh từ",
    meaning:
      "những nhân viên công tác ở ga và các tổ chức của ga, trong quan hệ với hành khách (nói tổng quát): nhà ga phục vụ rất chu đáo",
    example: "nhà ga phục vụ rất chu đáo",
  },
  {
    word: "nhà hát",
    part_of_speech: "danh từ",
    meaning:
      "nhà lớn chuyên dùng làm nơi trình diễn các tiết mục nghệ thuật sân khấu cho công chúng xem: nhà hát thành phố",
    example: "nhà hát thành phố",
  },
  {
    word: "nhà hát",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị hành chính của ngành sân khấu: nhà hát cải lương * nhà hát kịch trung ương",
    example: "nhà hát cải lương * nhà hát kịch trung ương",
  },
  {
    word: "nhà in",
    part_of_speech: "danh từ",
    meaning:
      "nơi chuyên làm các công việc về in ấn: bản thảo đã chuyển sang nhà in",
    example: "bản thảo đã chuyển sang nhà in",
  },
  {
    word: "nhà hàng",
    part_of_speech: "danh từ",
    meaning: "(Từ cũ) cửa hiệu: nhà hàng thuốc bắc",
    example: "nhà hàng thuốc bắc",
  },
  {
    word: "nhà hàng",
    part_of_speech: "danh từ",
    meaning:
      "cửa hàng, cửa hiệu ăn uống (thường là lớn): nhà hàng đặc sản * đi ăn ở nhà hàng",
    example: "nhà hàng đặc sản * đi ăn ở nhà hàng",
  },
  {
    word: "nhà hàng",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) tất cả những người làm việc trong cửa hàng, cửa hiệu (nói khái quát): nhà hàng chiều khách",
    example: "nhà hàng chiều khách",
  },
  {
    word: "nhà huyên",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, văn chương) như huyên đường: “Thưa nhà huyên hết mọi tình, Nỗi chàng ở bạc, nỗi mình chịu đen.” (TKiều)",
    example:
      "“Thưa nhà huyên hết mọi tình, Nỗi chàng ở bạc, nỗi mình chịu đen.” (TKiều)",
  },
  {
    word: "nhà khách",
    part_of_speech: "danh từ",
    meaning:
      "nhà của cơ quan hoặc tổ chức dùng riêng để tiếp khách hoặc để cho khách lưu trú khi đến công tác: nhà khách bộ quốc phòng * nhà khách Chính phủ",
    example: "nhà khách bộ quốc phòng * nhà khách Chính phủ",
  },
  {
    word: "nha khoa",
    part_of_speech: "danh từ",
    meaning:
      "khoa chữa các bệnh về răng: bác sĩ nha khoa * phòng khám nha khoa",
    example: "bác sĩ nha khoa * phòng khám nha khoa",
  },
  {
    word: "nhà kho",
    part_of_speech: "danh từ",
    meaning: "nhà chuyên dùng để làm kho: hàng đã chuyển xuống nhà kho",
    example: "hàng đã chuyển xuống nhà kho",
  },
  {
    word: "nhà kính",
    part_of_speech: "danh từ",
    meaning:
      "nhà kín bằng kính để trồng một số cây ở vùng giá lạnh hoặc về mùa đông: rau trồng trong nhà kính",
    example: "rau trồng trong nhà kính",
  },
  {
    word: "nhà lao",
    part_of_speech: "danh từ",
    meaning: "như nhà tù: ngồi trong nhà lao",
    example: "ngồi trong nhà lao",
  },
  {
    word: "nhà máy",
    part_of_speech: "danh từ",
    meaning:
      "cơ sở sản xuất công nghiệp, sử dụng máy móc hiện đại và dùng một nguồn năng lượng tương đối lớn: nhà máy đường * nhà máy dệt * làm việc ở nhà máy",
    example: "nhà máy đường * nhà máy dệt * làm việc ở nhà máy",
  },
  {
    word: "nhà lầu",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) nhà tầng: xây nhà lầu",
    example: "xây nhà lầu",
  },
  {
    word: "nha môn",
    part_of_speech: "danh từ",
    meaning: "(cũ) cửa quan: chốn nha môn",
    example: "chốn nha môn",
  },
  {
    word: "nhà may",
    part_of_speech: "danh từ",
    meaning: "cửa hiệu, cửa hàng may đo quần áo: mở nhà may * nhà may cao cấp",
    example: "mở nhà may * nhà may cao cấp",
  },
  {
    word: "nhả ngọc phun châu",
    part_of_speech: "",
    meaning:
      '(cũ, văn chương) ví tài văn chương đặc biệt, từng lời, từng chữ thốt ra tựa như viên ngọc, hạt châu: "Khen: Tài nhả ngọc phun châu, Nàng Ban, ả Tạ cũng đâu thế này!" (TKiều)',
    example:
      'Khen: Tài nhả ngọc phun châu, Nàng Ban, ả Tạ cũng đâu thế này!" (TKiều)',
  },
  {
    word: "nhà mồ",
    part_of_speech: "danh từ",
    meaning:
      "nhà xây cất trên mộ, coi là nhà ở của người chết ở thế giới bên kia, theo tín ngưỡng dân gian: lạnh lẽo như cái nhà mồ",
    example: "lạnh lẽo như cái nhà mồ",
  },
  {
    word: "nhà nghề",
    part_of_speech: "danh từ",
    meaning:
      "người rất tinh thông một nghề gì (nói khái quát): con nhà nghề * bí quyết nhà nghề * giải quyền Anh nhà nghề",
    example: "con nhà nghề * bí quyết nhà nghề * giải quyền Anh nhà nghề",
  },
  {
    word: "nhà ngươi",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) tổ hợp dùng để gọi người dưới quyền (hàm ý coi thường): có việc gì, nhà ngươi cứ nói trẫm nghe",
    example: "có việc gì, nhà ngươi cứ nói trẫm nghe",
  },
  {
    word: "nhà nhà",
    part_of_speech: "danh từ",
    meaning: "mọi nhà, không trừ một nhà nào: nhà nhà thi đua yêu nước",
    example: "nhà nhà thi đua yêu nước",
  },
  {
    word: "nhà nông",
    part_of_speech: "danh từ",
    meaning:
      "người chuyên sống bằng nghề làm ruộng (nói khái quát): một nhà nông chuyên cần * cày sâu cuốc bẫm là nghiệp của nhà nông",
    example:
      "một nhà nông chuyên cần * cày sâu cuốc bẫm là nghiệp của nhà nông",
  },
  {
    word: "nhã nhạc",
    part_of_speech: "danh từ",
    meaning:
      "nhạc dùng trong các buổi lễ trang nghiêm, nơi tôn miếu, triều đình thời phong kiến: nhã nhạc cung đình Huế",
    example: "nhã nhạc cung đình Huế",
  },
  {
    word: "nhà nho",
    part_of_speech: "danh từ",
    meaning: "(cũ) người trí thức nho học thời phong kiến: một nhà nho nệ cổ",
    example: "một nhà nho nệ cổ",
  },
  {
    word: "nhà nòi",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) gia đình có truyền thống về một nghề hay một lĩnh vực nào đó, có người giỏi, thạo về nghề hay lĩnh vực ấy: một tay vật nhà nòi * con nhà nòi",
    example: "một tay vật nhà nòi * con nhà nòi",
  },
  {
    word: "nhả nhớt",
    part_of_speech: "",
    meaning:
      "có thái độ đùa cợt thái quá, thiếu đứng đắn, không lịch sự: trêu đùa nhả nhớt",
    example: "trêu đùa nhả nhớt",
  },
  {
    word: "nhá nhem",
    part_of_speech: "tính từ",
    meaning:
      "(trời) mờ mờ tối, khó nhìn rõ mọi vật, lúc mặt trời đã lặn: trời nhá nhem tối",
    example: "trời nhá nhem tối",
  },
  {
    word: "nhã nhặn",
    part_of_speech: "tính từ",
    meaning:
      "lễ độ, đúng mực trong quan hệ tiếp xúc: ăn nói nhã nhặn * cư xử nhã nhặn",
    example: "ăn nói nhã nhặn * cư xử nhã nhặn",
  },
  {
    word: "nhã nhặn",
    part_of_speech: "tính từ",
    meaning:
      "đẹp một cách giản dị, không phô trương, không cầu kì: màu sắc nhã nhặn * ăn mặc nhã nhặn",
    example: "màu sắc nhã nhặn * ăn mặc nhã nhặn",
  },
  {
    word: "nhà nước",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức, đứng đầu là chính phủ, quản lí công việc chung của một nước: nhà nước Việt Nam * cải cách bộ máy nhà nước",
    example: "nhà nước Việt Nam * cải cách bộ máy nhà nước",
  },
  {
    word: "nhà nước",
    part_of_speech: "danh từ",
    meaning: "phạm vi cả nước: ngân hàng nhà nước * doanh nghiệp nhà nước",
    example: "ngân hàng nhà nước * doanh nghiệp nhà nước",
  },
  {
    word: "nhà ổ chuột",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) nhà thấp, chật hẹp và tồi tàn, bẩn thỉu, thường làm chen chúc vào nhau thành một khu ở vùng đô thị: cải tạo các khu nhà ổ chuột",
    example: "cải tạo các khu nhà ổ chuột",
  },
  {
    word: "nhà riêng",
    part_of_speech: "danh từ",
    meaning:
      "chỗ ở riêng và thuộc quyền sở hữu của mỗi gia đình: con cái đều đã lập gia đình, có nhà riêng",
    example: "con cái đều đã lập gia đình, có nhà riêng",
  },
  {
    word: "nhà quê",
    part_of_speech: "danh từ",
    meaning:
      "như nông thôn: người nhà quê chất phác * sống ở nhà quê * từ nhà quê ra tỉnh",
    example: "người nhà quê chất phác * sống ở nhà quê * từ nhà quê ra tỉnh",
  },
  {
    word: "nhà quê",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) quê mùa, mộc mạc, kém vẻ thanh tao, lịch sự (hàm ý chê): ăn mặc nhà quê * đồ nhà quê!",
    example: "ăn mặc nhà quê * đồ nhà quê!",
  },
  {
    word: "nhà sách",
    part_of_speech: "danh từ",
    meaning:
      "cửa hàng sách, hiệu sách: mở một nhà sách mới * nhà sách ngoại văn",
    example: "mở một nhà sách mới * nhà sách ngoại văn",
  },
  {
    word: "nha sĩ",
    part_of_speech: "danh từ",
    meaning: "(hiếm) y sĩ hoặc bác sĩ nha khoa: ông ấy là một nha sĩ",
    example: "ông ấy là một nha sĩ",
  },
  {
    word: "nhà sư",
    part_of_speech: "danh từ",
    meaning: "sư, theo cách gọi kính trọng: nhà sư ngồi niệm Phật",
    example: "nhà sư ngồi niệm Phật",
  },
  {
    word: "nhà thầu",
    part_of_speech: "danh từ",
    meaning:
      "đối tượng dự thầu hoặc đã trúng thầu: có năm nhà thầu tham gia đấu thầu công trình",
    example: "có năm nhà thầu tham gia đấu thầu công trình",
  },
  {
    word: "nhà tầng",
    part_of_speech: "danh từ",
    meaning: "nhà ở, có từ hai tầng trở lên: xây nhà tầng * ở nhà tầng",
    example: "xây nhà tầng * ở nhà tầng",
  },
  {
    word: "nhà tạo mẫu",
    part_of_speech: "danh từ",
    meaning:
      "người chuyên thiết kế, sáng tạo ra mẫu mới: nhà tạo mẫu kim hoàn * nhà tạo mẫu thời trang",
    example: "nhà tạo mẫu kim hoàn * nhà tạo mẫu thời trang",
  },
  {
    word: "nhà thơ",
    part_of_speech: "danh từ",
    meaning:
      "người chuyên sáng tác thơ và đã có tác phẩm có giá trị được công nhận: một nhà thơ yêu nước * trở thành nhà thơ nổi tiếng",
    example: "một nhà thơ yêu nước * trở thành nhà thơ nổi tiếng",
  },
  {
    word: "nhà thuyền",
    part_of_speech: "danh từ",
    meaning:
      "nơi tổ chức các trò vui chơi giải trí bằng thuyền (thường ở các hồ): nhà thuyền Hồ Tây",
    example: "nhà thuyền Hồ Tây",
  },
  {
    word: "nhà thương",
    part_of_speech: "danh từ",
    meaning: "(cũ) bệnh viện: bị bệnh, phải nằm ở nhà thương",
    example: "bị bệnh, phải nằm ở nhà thương",
  },
  {
    word: "nhà thờ",
    part_of_speech: "danh từ",
    meaning: "nhà dùng để làm nơi thờ phụng tổ tiên: nhà thờ họ",
    example: "nhà thờ họ",
  },
  {
    word: "nhà thờ",
    part_of_speech: "danh từ",
    meaning:
      "nơi thờ chúa Jesus và để giáo dân đến lễ: đi lễ nhà thờ * nhà thờ Đức Bà * chuông nhà thờ",
    example: "đi lễ nhà thờ * nhà thờ Đức Bà * chuông nhà thờ",
  },
  {
    word: "nhà thờ",
    part_of_speech: "danh từ",
    meaning: "tổ chức nắm quyền hành trong Công giáo: thế lực của nhà thờ",
    example: "thế lực của nhà thờ",
  },
  {
    word: "nhà trẻ",
    part_of_speech: "danh từ",
    meaning:
      "cơ sở giáo dục mầm non, nuôi dạy trẻ dưới ba tuổi: bé đi nhà trẻ * nhà trẻ tư thục",
    example: "bé đi nhà trẻ * nhà trẻ tư thục",
  },
  {
    word: "nhà trai",
    part_of_speech: "danh từ",
    meaning:
      "những người phía gia đình chú rể trong một đám cưới, đám hỏi, trong quan hệ với nhà gái (nói tổng quát): họ nhà trai",
    example: "họ nhà trai",
  },
  {
    word: "nhà trường",
    part_of_speech: "danh từ",
    meaning: "trường học (nói khát quát): rời ghế nhà trường",
    example: "rời ghế nhà trường",
  },
  {
    word: "nhà trường",
    part_of_speech: "danh từ",
    meaning:
      "những người làm công tác quản lí, giảng dạy ở trường học (nói tổng quát): học giỏi nên được nhà trường cấp học bổng",
    example: "học giỏi nên được nhà trường cấp học bổng",
  },
  {
    word: "nhà trọ",
    part_of_speech: "danh từ",
    meaning:
      "nhà có phòng, giường chuyên cho khách thuê ngủ trọ, thường tiện nghi rất sơ sài: thuê nhà trọ * nhỡ đường, đành ngủ ở nhà trọ",
    example: "thuê nhà trọ * nhỡ đường, đành ngủ ở nhà trọ",
  },
  {
    word: "nhà thuốc",
    part_of_speech: "danh từ",
    meaning: "hiệu thuốc, cửa hàng thuốc: nhà thuốc tây y",
    example: "nhà thuốc tây y",
  },
  {
    word: "nhà tư tưởng",
    part_of_speech: "danh từ",
    meaning:
      "người đề xướng ra những tư tưởng triết học sâu sắc: K. Marx và F. Engels là hai nhà tư tưởng vĩ đại",
    example: "K. Marx và F. Engels là hai nhà tư tưởng vĩ đại",
  },
  {
    word: "nhà văn hoá",
    part_of_speech: "danh từ",
    meaning:
      "nhà làm nơi tổ chức sinh hoạt câu lạc bộ cho đông đảo quần chúng: nhà văn hoá xã * nhà văn hoá thiếu nhi",
    example: "nhà văn hoá xã * nhà văn hoá thiếu nhi",
  },
  {
    word: "nhà văn hoá",
    part_of_speech: "danh từ",
    meaning:
      "người nghiên cứu về văn hoá và đã có những công trình văn hoá có giá trị: Lê Thánh Tông là một nhà văn hoá lớn",
    example: "Lê Thánh Tông là một nhà văn hoá lớn",
  },
  {
    word: "nhà vua",
    part_of_speech: "danh từ",
    meaning:
      "(trang trọng) vua (hàm ý yêu mến và quý trọng): vâng mệnh nhà vua",
    example: "vâng mệnh nhà vua",
  },
  {
    word: "nhà văn",
    part_of_speech: "danh từ",
    meaning:
      "người chuyên sáng tác văn xuôi và đã có tác phẩm có giá trị được công nhận: một nhà văn nổi tiếng * nhà văn nghiệp dư",
    example: "một nhà văn nổi tiếng * nhà văn nghiệp dư",
  },
  {
    word: "nhà vệ sinh",
    part_of_speech: "danh từ",
    meaning: "nhà, phòng làm nơi đại, tiểu tiện: nhà vệ sinh công cộng",
    example: "nhà vệ sinh công cộng",
  },
  {
    word: "nhà xe",
    part_of_speech: "danh từ",
    meaning: "nhà chuyên dùng để cất giữ xe đạp, xe máy: gửi xe trong nhà xe",
    example: "gửi xe trong nhà xe",
  },
  {
    word: "nhà xe",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) lái xe, phụ xe và nhân viên công tác ở bến xe, trong quan hệ với hành khách: nhà xe phục vụ hành khách chu đáo",
    example: "nhà xe phục vụ hành khách chu đáo",
  },
  {
    word: "nhà vườn",
    part_of_speech: "danh từ",
    meaning:
      "nhà có vườn hoặc người chủ có vườn chuyên trồng các loại cây giống, hoa quả: mua trái cây tại nhà vườn * nhà vườn trồng hoa * ông chủ nhà vườn",
    example:
      "mua trái cây tại nhà vườn * nhà vườn trồng hoa * ông chủ nhà vườn",
  },
  {
    word: "nhác",
    part_of_speech: "động từ",
    meaning:
      'trông thấy thoáng qua rất nhanh, một cách không có chủ định: nhác thấy có bóng người * "Bóng hồng nhác thấy nẻo xa, Xuân lan, thu cúc, mặn mà cả hai." (TKiều)',
    example:
      'nhác thấy có bóng người * "Bóng hồng nhác thấy nẻo xa, Xuân lan, thu cúc, mặn mà cả hai." (TKiều)',
  },
  {
    word: "nhác",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) như lười: việc nhà thì nhác, việc chú bác thì siêng (tng)",
    example: "việc nhà thì nhác, việc chú bác thì siêng (tng)",
  },
  {
    word: "nhã ý",
    part_of_speech: "danh từ",
    meaning:
      "ý tốt, thể hiện sự quan tâm, quý mến (nói một cách lịch sự về tình cảm, cử chỉ của người khác): có nhã ý giúp đỡ * khước từ nhã ý của mọi người",
    example: "có nhã ý giúp đỡ * khước từ nhã ý của mọi người",
  },
  {
    word: "nhạc điệu",
    part_of_speech: "danh từ",
    meaning:
      "nhịp trầm bổng của âm thanh trong bản nhạc, bài thơ (nói khái quát): nhạc điệu trầm hùng của bài thơ",
    example: "nhạc điệu trầm hùng của bài thơ",
  },
  {
    word: "nhạc cụ",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ dùng trong âm nhạc: nhạc cụ dân tộc * chơi được hai loại nhạc cụ",
    example: "nhạc cụ dân tộc * chơi được hai loại nhạc cụ",
  },
  {
    word: "nhà xưởng",
    part_of_speech: "danh từ",
    meaning: "nhà đặt máy móc, thiết bị để sản xuất: xây dựng nhà xưởng",
    example: "xây dựng nhà xưởng",
  },
  {
    word: "nhạc",
    part_of_speech: "danh từ",
    meaning:
      'chuông nhỏ, thường làm bằng đồng, có hạt cứng ở bên trong, khi rung kêu thành tiếng, thường đeo ở cổ ngựa: nhạc ngựa * "Dùng dằng nửa ở, nửa về, Nhạc vàng đâu đã tiếng nghe gần gần." (TKiều)',
    example:
      'nhạc ngựa * "Dùng dằng nửa ở, nửa về, Nhạc vàng đâu đã tiếng nghe gần gần." (TKiều)',
  },
  {
    word: "nhạc",
    part_of_speech: "danh từ",
    meaning: "âm nhạc (nói tắt): đĩa nhạc * nghe nhạc * phổ nhạc cho thơ",
    example: "đĩa nhạc * nghe nhạc * phổ nhạc cho thơ",
  },
  {
    word: "nhạc hiệu",
    part_of_speech: "danh từ",
    meaning:
      "đoạn nhạc dạo đầu, báo hiệu cho một chương trình phát thanh hoặc truyền hình: nhạc hiệu của chương trình phim truyện",
    example: "nhạc hiệu của chương trình phim truyện",
  },
  {
    word: "nhạc kịch",
    part_of_speech: "danh từ",
    meaning: "loại hình nghệ thuật sân khấu chủ yếu dùng âm nhạc để thể hiện.",
    example: "vở nhạc kịch hồ thiên nga",
  },
  {
    word: "nhạc gia",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, trang trọng) cha mẹ vợ: "Đường trường chẳng quản xa khơi, Đưa tin sang đấy rước mời nhạc gia." (PCCH)',
    example:
      'Đường trường chẳng quản xa khơi, Đưa tin sang đấy rước mời nhạc gia." (PCCH)',
  },
  {
    word: "nhạc lí",
    part_of_speech: "danh từ",
    meaning: "lí thuyết về âm nhạc: nắm vững nhạc lí",
    example: "nắm vững nhạc lí",
  },
  {
    word: "nhạc khúc",
    part_of_speech: "danh từ",
    meaning: "bài nhạc: một nhạc khúc trữ tình",
    example: "một nhạc khúc trữ tình",
  },
  {
    word: "nhạc lý",
    part_of_speech: "danh từ",
    meaning: "lí thuyết về âm nhạc: nắm vững nhạc lí",
    example: "nắm vững nhạc lí",
  },
  {
    word: "nhạc nhẹ",
    part_of_speech: "danh từ",
    meaning:
      "loại nhạc có nội dung phản ánh cuộc sống bình thường, mang nhiều tính chất giải trí, dàn nhạc gọn nhẹ, có thể biểu diễn bất cứ nơi nào: ca sĩ nhạc nhẹ",
    example: "ca sĩ nhạc nhẹ",
  },
  {
    word: "nhạc phẩm",
    part_of_speech: "danh từ",
    meaning: "tác phẩm âm nhạc: nhạc phẩm trữ tình",
    example: "nhạc phẩm trữ tình",
  },
  {
    word: "nhạc tính",
    part_of_speech: "danh từ",
    meaning: "tính chất âm nhạc: câu thơ đầy nhạc tính",
    example: "câu thơ đầy nhạc tính",
  },
  {
    word: "nhạc sĩ",
    part_of_speech: "danh từ",
    meaning: "người chuyên soạn nhạc, sáng tác bài hát: nhạc sĩ Trịnh Công Sơn",
    example: "nhạc sĩ Trịnh Công Sơn",
  },
  {
    word: "nhài",
    part_of_speech: "danh từ",
    meaning:
      'cây nhỡ, lá hình bầu dục, hoa màu trắng mọc thành cụm, nở về đêm, rất thơm, thường dùng để ướp chè: "Chẳng thơm cũng thể hoa nhài. Dẫu không thanh lịch cũng người Tràng An." (ca dao)',
    example:
      'Chẳng thơm cũng thể hoa nhài. Dẫu không thanh lịch cũng người Tràng An." (ca dao)',
  },
  {
    word: "nhài",
    part_of_speech: "danh từ",
    meaning:
      'mảnh kim loại nhỏ, tròn, giữ hai đầu chốt quạt giấy: "Ai làm cái quạt long nhài, Cầu ô long nhịp, cửa cài long then." (ca dao)',
    example:
      'Ai làm cái quạt long nhài, Cầu ô long nhịp, cửa cài long then." (ca dao)',
  },
  {
    word: "nhách",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) từng cá thể một số loại động vật (thường là động vật nuôi còn nhỏ, thuộc thế hệ con): nhách chó con",
    example: "nhách chó con",
  },
  {
    word: "nhách",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) (động vật) còn rất nhỏ: gà nhách * chó nhách",
    example: "gà nhách * chó nhách",
  },
  {
    word: "nhại",
    part_of_speech: "động từ",
    meaning:
      "bắt chước tiếng nói, điệu bộ của người khác để trêu chọc, giễu cợt: nhại giọng * nói câu nào nhại câu ấy",
    example: "nhại giọng * nói câu nào nhại câu ấy",
  },
  {
    word: "nhại",
    part_of_speech: "động từ",
    meaning:
      "bắt chước, phỏng theo lời bài thơ có sẵn để làm ra bài mới, thường để giễu cợt, châm biếm: nhại thơ",
    example: "nhại thơ",
  },
  {
    word: "nhai",
    part_of_speech: "động từ",
    meaning:
      "nghiền nhỏ, nghiền nát giữa hai hàm răng: nhai kẹo * nhai trầu * ăn có nhai, nói có nghĩ (tng)",
    example: "nhai kẹo * nhai trầu * ăn có nhai, nói có nghĩ (tng)",
  },
  {
    word: "nhai",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) lặp đi lặp lại nhiều lần ở cửa miệng (hàm ý chê): nhai đi nhai lại một luận điệu",
    example: "nhai đi nhai lại một luận điệu",
  },
  {
    word: "nhãi",
    part_of_speech: "",
    meaning:
      "(Khẩu ngữ) trẻ con hay động vật còn nhỏ, chẳng đáng phải chú ý: đứa trẻ nhãi * thằng nhãi!",
    example: "đứa trẻ nhãi * thằng nhãi!",
  },
  {
    word: "nhãi ranh",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) trẻ con, ít tuổi, non dạ, chưa hiểu biết gì (hàm ý khinh thường): lũ nhãi ranh!",
    example: "lũ nhãi ranh!",
  },
  {
    word: "nhái",
    part_of_speech: "động từ",
    meaning:
      "nhại, bắt chước: nhái giọng * hàng nhái * nhái theo mẫu mã của nước ngoài",
    example: "nhái giọng * hàng nhái * nhái theo mẫu mã của nước ngoài",
  },
  {
    word: "nhãi con",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) trẻ con, còn rất ít tuổi (hàm ý khinh thường): nhãi con mà cũng đòi ti toe",
    example: "nhãi con mà cũng đòi ti toe",
  },
  {
    word: "nhai lại",
    part_of_speech: "động từ",
    meaning:
      "(đặc tính của một số loài động vật như trâu, bò, v.v.) ợ thức ăn ra để nhai thêm lần nữa: động vật nhai lại",
    example: "động vật nhai lại",
  },
  {
    word: "nhảm",
    part_of_speech: "tính từ",
    meaning:
      "bậy bạ, không có căn cứ hoặc không đúng sự thật: chuyện nhảm * nói nhảm * tung tin nhảm",
    example: "chuyện nhảm * nói nhảm * tung tin nhảm",
  },
  {
    word: "nhãi nhép",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) người tầm thường, nhỏ nhoi, đáng khinh (nói khái quát): đồ nhãi nhép!",
    example: "đồ nhãi nhép!",
  },
  {
    word: "nhai nhải",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) như lải nhải: chỉ có thế mà cứ nhai nhải mãi",
    example: "chỉ có thế mà cứ nhai nhải mãi",
  },
  {
    word: "nhàm chán",
    part_of_speech: "tính từ",
    meaning:
      "nhàm đến mức phát chán, không còn thú vị gì nữa: công việc nhàm chán",
    example: "công việc nhàm chán",
  },
  {
    word: "nhảm nhí",
    part_of_speech: "tính từ",
    meaning:
      "nhảm (nói khái quát): trò nhảm nhí * tuyên truyền nhảm nhí * tin vào những điều nhảm nhí",
    example:
      "trò nhảm nhí * tuyên truyền nhảm nhí * tin vào những điều nhảm nhí",
  },
  {
    word: "nham hiểm",
    part_of_speech: "tính từ",
    meaning:
      'độc ác một cách sâu kín, không ai lường được: nụ cười nham hiểm * "Bề ngoài thơn thớt nói cười, Mà trong nham hiểm giết người không dao." (TKiều)',
    example:
      'nụ cười nham hiểm * "Bề ngoài thơn thớt nói cười, Mà trong nham hiểm giết người không dao." (TKiều)',
  },
  {
    word: "nham nháp",
    part_of_speech: "tính từ",
    meaning: "như ram ráp: mặt gỗ hơi nham nháp",
    example: "mặt gỗ hơi nham nháp",
  },
  {
    word: "nham nháp",
    part_of_speech: "tính từ",
    meaning: "có cảm giác dấp dính ướt và nhớp: tay dính nham nháp",
    example: "tay dính nham nháp",
  },
  {
    word: "nham nhở",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều chỗ, nhiều vết không đều, không gọn đẹp, thường do làm dở dang, cẩu thả: bờ ao bị đào bới nham nhở * chiếc chiếu rách nham nhở",
    example: "bờ ao bị đào bới nham nhở * chiếc chiếu rách nham nhở",
  },
  {
    word: "nhàm",
    part_of_speech: "tính từ",
    meaning:
      'cảm thấy chán, hoặc gây cảm giác chán, vì lặp đi lặp lại nhiều lần, không có gì mới lạ: xem mãi đâm nhàm * "Rượu lạt uống lắm cũng say, Người khôn nói lắm dẫu hay cũng nhàm." (ca dao)',
    example:
      'xem mãi đâm nhàm * "Rượu lạt uống lắm cũng say, Người khôn nói lắm dẫu hay cũng nhàm." (ca dao)',
  },
  {
    word: "nhàm tai",
    part_of_speech: "tính từ",
    meaning:
      "chán không muốn nghe nữa, hoặc không có phản ứng gì nữa, vì đã phải nghe nhiều lần: nghe mãi hoá nhàm tai",
    example: "nghe mãi hoá nhàm tai",
  },
  {
    word: "nhám sì",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) rất ráp: mặt bàn nhám sì * bàn tay nhám sì",
    example: "mặt bàn nhám sì * bàn tay nhám sì",
  },
  {
    word: "nham nhảm",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) (nói, cãi) nhiều và không ngớt miệng: cãi nham nhảm",
    example: "cãi nham nhảm",
  },
  {
    word: "nham thạch",
    part_of_speech: "danh từ",
    meaning:
      "chất cấu tạo nên vỏ cứng của Trái Đất, như đá, đất, cát (thường được nung chảy và phun lên mặt đất ở nơi có núi lửa): lớp nham thạch",
    example: "lớp nham thạch",
  },
  {
    word: "nhàn",
    part_of_speech: "tính từ",
    meaning:
      "có ít hoặc không có việc gì phải làm, phải lo nghĩ: nhàn đầu óc * dạo này việc ít nên cũng nhàn",
    example: "nhàn đầu óc * dạo này việc ít nên cũng nhàn",
  },
  {
    word: "nhãn",
    part_of_speech: "danh từ",
    meaning:
      "mảnh giấy nhỏ dán ở ngoài một vật để ghi tên và ghi tóm tắt những điều cốt yếu cần thiết về vật đó (như loại gì, của ai, ở đâu, v.v.): dán nhãn vở * nhãn hàng hoá * dán nhãn lên bao bì sản phẩm",
    example: "dán nhãn vở * nhãn hàng hoá * dán nhãn lên bao bì sản phẩm",
  },
  {
    word: "nhạn",
    part_of_speech: "danh từ",
    meaning:
      'chim nhỏ, cánh dài nhọn, đuôi chẻ đôi, mỏ ngắn, thường bay thành đàn: "Đôi ta chẳng đặng sum vầy, Cũng như chim nhạn lạc bầy kêu sương." (ca dao)',
    example:
      'Đôi ta chẳng đặng sum vầy, Cũng như chim nhạn lạc bầy kêu sương." (ca dao)',
  },
  {
    word: "nhàn hạ",
    part_of_speech: "tính từ",
    meaning:
      "rảnh rỗi, không bận rộn, không phải vất vả, mệt nhọc (nói khái quát): cuộc sống nhàn hạ * công việc nhàn hạ",
    example: "cuộc sống nhàn hạ * công việc nhàn hạ",
  },
  {
    word: "nhàn lãm",
    part_of_speech: "động từ",
    meaning: "(cũ)",
    example: "xin biếu cụ tập thơ để cụ nhàn lãm",
  },
  {
    word: "nhàn đàm",
    part_of_speech: "động từ",
    meaning:
      "chuyện trò, bàn bạc về những vấn đề không quan trọng, không có trọng tâm: mục nhàn đàm trên báo",
    example: "mục nhàn đàm trên báo",
  },
  {
    word: "nhãn hiệu",
    part_of_speech: "danh từ",
    meaning:
      "dấu hiệu riêng của nơi sản xuất, được dán hoặc in trên mặt hàng: nhãn hiệu của sản phẩm * hàng may mặc mang nhãn hiệu Việt Nam",
    example: "nhãn hiệu của sản phẩm * hàng may mặc mang nhãn hiệu Việt Nam",
  },
  {
    word: "nhan đề",
    part_of_speech: "danh từ",
    meaning: "tên đặt cho một tác phẩm, bài viết: nhan đề của quyển sách",
    example: "nhan đề của quyển sách",
  },
  {
    word: "nhãn mác",
    part_of_speech: "danh từ",
    meaning:
      "nhãn và mác dán trên sản phẩm (nói khái quát): nhãn mác hàng hoá * quần áo mang nhãn mác nước ngoài",
    example: "nhãn mác hàng hoá * quần áo mang nhãn mác nước ngoài",
  },
  {
    word: "nhãn lực",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như thị lực: tập trung nhãn lực",
    example: "tập trung nhãn lực",
  },
  {
    word: "nhãn lực",
    part_of_speech: "danh từ",
    meaning: "như nhãn quan: có nhãn lực hơn người",
    example: "có nhãn lực hơn người",
  },
  {
    word: "nhàn rỗi",
    part_of_speech: "tính từ",
    meaning:
      "rỗi rãi, không phải làm việc gì: thích đọc báo những lúc nhàn rỗi",
    example: "thích đọc báo những lúc nhàn rỗi",
  },
  {
    word: "nhàn rỗi",
    part_of_speech: "tính từ",
    meaning:
      "(sức lao động, vốn liếng) để không, chưa được huy động, chưa được sử dụng vào việc gì: lao động nhàn rỗi * thu hút nguồn vốn nhàn rỗi",
    example: "lao động nhàn rỗi * thu hút nguồn vốn nhàn rỗi",
  },
  {
    word: "nhàn nhã",
    part_of_speech: "tính từ",
    meaning:
      "rỗi rãi, nhàn cả về thể xác lẫn tinh thần (nói khái quát): công việc nhàn nhã * cuộc sống hết sức nhàn nhã",
    example: "công việc nhàn nhã * cuộc sống hết sức nhàn nhã",
  },
  {
    word: "nhãn quan",
    part_of_speech: "danh từ",
    meaning:
      "tầm nhìn, tầm hiểu biết, khả năng nhận thức, xem xét và đánh giá vấn đề: có nhãn quan chính trị",
    example: "có nhãn quan chính trị",
  },
  {
    word: "nhàn nhạt",
    part_of_speech: "tính từ",
    meaning: "hơi nhạt: canh nấu nhàn nhạt * nắng chiều nhàn nhạt",
    example: "canh nấu nhàn nhạt * nắng chiều nhàn nhạt",
  },
  {
    word: "nhan nhản",
    part_of_speech: "tính từ",
    meaning:
      "nhiều đến mức tràn ngập, chỗ nào cũng thấy, cũng gặp: hàng quán mọc lên nhan nhản * hàng giả nhan nhản trên thị trường",
    example: "hàng quán mọc lên nhan nhản * hàng giả nhan nhản trên thị trường",
  },
  {
    word: "nhan sắc",
    part_of_speech: "danh từ",
    meaning:
      "sắc đẹp, vẻ đẹp của người phụ nữ (nói khái quát): nhan sắc tuyệt trần * người đàn bà có nhan sắc",
    example: "nhan sắc tuyệt trần * người đàn bà có nhan sắc",
  },
  {
    word: "nhãn tiền",
    part_of_speech: "tính từ",
    meaning:
      "ngay trước mắt (nói về việc không hay): hậu quả nhãn tiền * chỉ thấy cái lợi nhãn tiền",
    example: "hậu quả nhãn tiền * chỉ thấy cái lợi nhãn tiền",
  },
  {
    word: "nhang",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) hương: thắp một nén nhang",
    example: "thắp một nén nhang",
  },
  {
    word: "nhàng nhàng",
    part_of_speech: "tính từ",
    meaning: "(tạng người) không béo cũng không gầy: vóc người nhàng nhàng",
    example: "vóc người nhàng nhàng",
  },
  {
    word: "nhàng nhàng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ở mức trung bình, không tốt, cũng không xấu: sức học nhàng nhàng * chiếc xe đã nhàng nhàng",
    example: "sức học nhàng nhàng * chiếc xe đã nhàng nhàng",
  },
  {
    word: "nhãng",
    part_of_speech: "động từ",
    meaning:
      "quên, không để ý đến trong chốc lát: nhãng đi một cái là hỏng việc",
    example: "nhãng đi một cái là hỏng việc",
  },
  {
    word: "nhàn tản",
    part_of_speech: "tính từ",
    meaning:
      "rỗi rãi và thảnh thơi, không có gì câu thúc: dáng điệu ung dung như một người nhàn tản",
    example: "dáng điệu ung dung như một người nhàn tản",
  },
  {
    word: "nhanh",
    part_of_speech: "tính từ",
    meaning:
      "có tốc độ, nhịp độ trên mức bình thường: xe chạy nhanh * nói nhanh * tốc độ phát triển nhanh * đồng hồ chạy nhanh",
    example:
      "xe chạy nhanh * nói nhanh * tốc độ phát triển nhanh * đồng hồ chạy nhanh",
  },
  {
    word: "nhanh",
    part_of_speech: "tính từ",
    meaning:
      "có hoạt động kịp thời do có phản ứng linh hoạt: nhanh chân chạy thoát * nhanh mắt nhìn thấy trước * nhanh mồm nhanh miệng",
    example:
      "nhanh chân chạy thoát * nhanh mắt nhìn thấy trước * nhanh mồm nhanh miệng",
  },
  {
    word: "nhanh",
    part_of_speech: "tính từ",
    meaning:
      "(việc làm) chỉ diễn ra trong thời gian rất ngắn: đọc lướt nhanh * bản tin nhanh * tóm tắt nhanh các sự kiện",
    example: "đọc lướt nhanh * bản tin nhanh * tóm tắt nhanh các sự kiện",
  },
  {
    word: "nhanh",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra có khả năng tiếp thu, phản ứng, hoạt động ngay tức khắc hoặc liền sau một thời gian rất ngắn: ứng đáp nhanh * nhanh hiểu bài * xử trí nhanh",
    example: "ứng đáp nhanh * nhanh hiểu bài * xử trí nhanh",
  },
  {
    word: "nhánh",
    part_of_speech: "danh từ",
    meaning:
      "cây hoặc củ con mới sinh ra thêm từ gốc: bẻ một nhánh gừng * nhánh cỏ * lúa đẻ nhánh",
    example: "bẻ một nhánh gừng * nhánh cỏ * lúa đẻ nhánh",
  },
  {
    word: "nhánh",
    part_of_speech: "danh từ",
    meaning:
      "cành nhỏ mọc ra từ thân hay từ cành lớn: nhánh hoa * cành cây có nhiều nhánh",
    example: "nhánh hoa * cành cây có nhiều nhánh",
  },
  {
    word: "nhánh",
    part_of_speech: "danh từ",
    meaning:
      "cái nhỏ hơn, phân ra từ cái chính, nhưng vẫn nối liền với cái chính: nhánh sông * hang sâu, lại có nhiều nhánh",
    example: "nhánh sông * hang sâu, lại có nhiều nhánh",
  },
  {
    word: "nhành",
    part_of_speech: "danh từ",
    meaning: "(văn chương) cành nhỏ: nhành hoa rung rinh trước gió",
    example: "nhành hoa rung rinh trước gió",
  },
  {
    word: "nhành",
    part_of_speech: "động từ",
    meaning: "(hiếm) như chành: nhành miệng ra cười",
    example: "nhành miệng ra cười",
  },
  {
    word: "nhanh nhạy",
    part_of_speech: "tính từ",
    meaning: "nhanh và nhạy bén: đầu óc nhanh nhạy",
    example: "đầu óc nhanh nhạy",
  },
  {
    word: "nhanh nhảu",
    part_of_speech: "tính từ",
    meaning:
      "nhanh trong nói năng, việc làm, không để người khác phải chờ đợi: nhanh nhảu trả lời * mồm miệng nhanh nhảu * dáng điệu nhanh nhảu",
    example: "nhanh nhảu trả lời * mồm miệng nhanh nhảu * dáng điệu nhanh nhảu",
  },
  {
    word: "nhanh chóng",
    part_of_speech: "tính từ",
    meaning:
      "nhanh, chỉ trong một thời gian ngắn, không để chậm trễ (nói khái quát): công việc kết thúc nhanh chóng * nhanh chóng thích nghi với hoàn cảnh",
    example:
      "công việc kết thúc nhanh chóng * nhanh chóng thích nghi với hoàn cảnh",
  },
  {
    word: "nhanh nhách",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng nhỏ, không đều và dai dẳng, như tiếng chó con sủa: chó sủa nhanh nhách",
    example: "chó sủa nhanh nhách",
  },
  {
    word: "nhanh nhẩu đoảng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) nhanh, nhưng hấp tấp, vội vàng nên thường hay làm hỏng việc: chỉ được cái nhanh nhảu đoảng",
    example: "chỉ được cái nhanh nhảu đoảng",
  },
  {
    word: "nhanh nhảu đoảng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) nhanh, nhưng hấp tấp, vội vàng nên thường hay làm hỏng việc: chỉ được cái nhanh nhảu đoảng",
    example: "chỉ được cái nhanh nhảu đoảng",
  },
  {
    word: "nhanh nhẹn",
    part_of_speech: "tính từ",
    meaning:
      "nhanh trong mọi cử chỉ, động tác: bước đi nhanh nhẹn * dáng người nhanh nhẹn, hoạt bát",
    example: "bước đi nhanh nhẹn * dáng người nhanh nhẹn, hoạt bát",
  },
  {
    word: "nhào",
    part_of_speech: "động từ",
    meaning:
      "rơi nhanh và đột ngột từ trên cao, đầu chúc xuống dưới: xe bị lật nhào * ngã nhào xuống đất * nhào người xuống nước",
    example: "xe bị lật nhào * ngã nhào xuống đất * nhào người xuống nước",
  },
  {
    word: "nhào",
    part_of_speech: "động từ",
    meaning: "lao vội theo một hướng nào đó: mọi người nhào đi tìm",
    example: "mọi người nhào đi tìm",
  },
  {
    word: "nhào",
    part_of_speech: "động từ",
    meaning:
      "trộn đều với một ít nước rồi làm cho dẻo, cho nhuyễn: nhào bột làm bánh * nhào vôi lẫn cát",
    example: "nhào bột làm bánh * nhào vôi lẫn cát",
  },
  {
    word: "nhao",
    part_of_speech: "động từ",
    meaning:
      "lao nhanh, mạnh, đột ngột theo một hướng, thường là về phía trước: con thuyền nhao về phía trước",
    example: "con thuyền nhao về phía trước",
  },
  {
    word: "nhao",
    part_of_speech: "động từ",
    meaning: "ngoi mạnh lên với số lượng nhiều: đàn cá nhao lên đớp mồi",
    example: "đàn cá nhao lên đớp mồi",
  },
  {
    word: "nhao",
    part_of_speech: "động từ",
    meaning:
      "(đám đông) rộ lên, ồn ào, rối rít lên: mọi người đều nhao lên về tin đồn ấy",
    example: "mọi người đều nhao lên về tin đồn ấy",
  },
  {
    word: "nhạo báng",
    part_of_speech: "động từ",
    meaning: "chế nhạo nhằm chỉ trích, bài bác: nhạo báng thói đạo đức giả",
    example: "nhạo báng thói đạo đức giả",
  },
  {
    word: "nhào nặn",
    part_of_speech: "động từ",
    meaning:
      "nhào và nặn; thường dùng để ví hoạt động, tác động làm cho biến đổi dần, hình thành nên cái mới: đồng tiền đã nhào nặn họ thành những kẻ tha hoá",
    example: "đồng tiền đã nhào nặn họ thành những kẻ tha hoá",
  },
  {
    word: "nhào lộn",
    part_of_speech: "động từ",
    meaning:
      "làm động tác lao lên nhào xuống nhiều vòng liên tiếp: máy bay nhào lộn trên không",
    example: "máy bay nhào lộn trên không",
  },
  {
    word: "nháo",
    part_of_speech: "",
    meaning:
      "có những hành động vội vã và thiếu tự chủ, biểu lộ sự hốt hoảng, lo sợ: cả nhà nháo đi tìm * chưa chi đã nháo cả lên",
    example: "cả nhà nháo đi tìm * chưa chi đã nháo cả lên",
  },
  {
    word: "nhão",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái chứa nhiều nước, quá mềm, không khô rời mà dính lại với nhau: cơm nhão * đất nhão * bột nhào hơi nhão",
    example: "cơm nhão * đất nhão * bột nhào hơi nhão",
  },
  {
    word: "nhão",
    part_of_speech: "tính từ",
    meaning: "mềm, không còn săn chắc (thường nói về cơ bắp): bắp thịt nhão",
    example: "bắp thịt nhão",
  },
  {
    word: "nhạo",
    part_of_speech: "động từ",
    meaning:
      "nêu ra để cười mỉa mai, tỏ ý coi thường: cười nhạo * nhạo thói háo danh",
    example: "cười nhạo * nhạo thói háo danh",
  },
  {
    word: "nhạo",
    part_of_speech: "danh từ",
    meaning:
      'bình nhỏ có vòi, dùng đựng rượu: "Rượu nằm trong nhạo chờ nem, Anh nằm phòng vắng chờ em lâu về." (ca dao)',
    example:
      'Rượu nằm trong nhạo chờ nem, Anh nằm phòng vắng chờ em lâu về." (ca dao)',
  },
  {
    word: "nhanh trí",
    part_of_speech: "tính từ",
    meaning:
      "có khả năng nghĩ nhanh và ứng phó nhanh (trước sự việc xảy ra bất ngờ): thằng bé rất nhanh trí * nhanh trí hiểu ngay ra vấn đề",
    example: "thằng bé rất nhanh trí * nhanh trí hiểu ngay ra vấn đề",
  },
  {
    word: "nhao nhác",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như nháo nhác: nghe tiếng nổ, đàn chim nhao nhác bay lên",
    example: "nghe tiếng nổ, đàn chim nhao nhác bay lên",
  },
  {
    word: "nháo nhác",
    part_of_speech: "tính từ",
    meaning:
      "hỗn loạn lên, đầy vẻ sợ hãi, hốt hoảng: gà con nháo nhác tìm mẹ * bọn trẻ bị đuổi, nháo nhác chạy",
    example: "gà con nháo nhác tìm mẹ * bọn trẻ bị đuổi, nháo nhác chạy",
  },
  {
    word: "nháp",
    part_of_speech: "động từ",
    meaning:
      "viết phác ra, viết thử trước khi viết chính thức: giấy nháp * nháp ra giấy trước khi viết vào bài thi",
    example: "giấy nháp * nháp ra giấy trước khi viết vào bài thi",
  },
  {
    word: "nháo nhào",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) lộn xộn, lung tung, do bị đảo tung lên một cách vội vã: quần áo bị bới nháo nhào * lục tìm nháo nhào",
    example: "quần áo bị bới nháo nhào * lục tìm nháo nhào",
  },
  {
    word: "nháo nhào",
    part_of_speech: "tính từ",
    meaning: "nháo cả lên, rối rít, lộn xộn: cả nhà nháo nhào bổ đi tìm",
    example: "cả nhà nháo nhào bổ đi tìm",
  },
  {
    word: "nhát",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị động tác chặt, cắt, đâm, bổ, v.v.: thân dừa có nhiều nhát dao chém * quơ vài nhát chổi cho sạch",
    example: "thân dừa có nhiều nhát dao chém * quơ vài nhát chổi cho sạch",
  },
  {
    word: "nhát",
    part_of_speech: "tính từ",
    meaning:
      "hay sợ sệt: tính nhát * nhát như cáy * người nhát nát người bạo (tng)",
    example: "tính nhát * nhát như cáy * người nhát nát người bạo (tng)",
  },
  {
    word: "nhao nhao",
    part_of_speech: "động từ",
    meaning:
      "nhao lên cùng một lúc, gây ồn ào, mất trật tự: nhao nhao phản đối",
    example: "nhao nhao phản đối",
  },
  {
    word: "nhát gái",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có tính ngại tiếp xúc với con gái (thường nói về nam thanh niên): một anh chàng nhát gái",
    example: "một anh chàng nhát gái",
  },
  {
    word: "nhão nhoét",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) nhão đến mức dính bết lại với nhau: cơm nhão nhoét",
    example: "cơm nhão nhoét",
  },
  {
    word: "nhạt",
    part_of_speech: "tính từ",
    meaning:
      "(thức ăn uống) có độ đậm thấp hơn so với khẩu vị bình thường: canh bị nhạt * chén rượu nhạt * nhạt như nước ốc",
    example: "canh bị nhạt * chén rượu nhạt * nhạt như nước ốc",
  },
  {
    word: "nhạt",
    part_of_speech: "tính từ",
    meaning:
      "(màu sắc) không đậm bằng màu bình thường hoặc không đậm bằng như vốn có trước đó: tường sơn màu hồng nhạt * nắng chiều vàng nhạt * áo đã nhạt màu",
    example: "tường sơn màu hồng nhạt * nắng chiều vàng nhạt * áo đã nhạt màu",
  },
  {
    word: "nhạt",
    part_of_speech: "tính từ",
    meaning:
      "(trò vui, chuyện kể) ít gây hứng thú, không hấp dẫn: chuyện nhạt * pha trò nhạt",
    example: "chuyện nhạt * pha trò nhạt",
  },
  {
    word: "nhạt",
    part_of_speech: "tính từ",
    meaning:
      'không được mặn mà trong tình cảm, trong đối xử: tiếp đãi nhạt * "Dám đâu học thói yến oanh, Mặn tình trăng gió, nhạt tình lửa hương." (BC)',
    example:
      'tiếp đãi nhạt * "Dám đâu học thói yến oanh, Mặn tình trăng gió, nhạt tình lửa hương." (BC)',
  },
  {
    word: "nhão nhoẹt",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như nhão nhoét: bùn đất nhão nhoẹt",
    example: "bùn đất nhão nhoẹt",
  },
  {
    word: "nhát gừng",
    part_of_speech: "tính từ",
    meaning:
      "(cách nói) từng lời ngắn và rời rạc, tỏ ý lúng túng hoặc không muốn nói chuyện: nói nhát gừng * trả lời nhát gừng",
    example: "nói nhát gừng * trả lời nhát gừng",
  },
  {
    word: "nhạt nhẽo",
    part_of_speech: "tính từ",
    meaning:
      "nhạt đến mức gây cảm giác vô vị, phát chán: món canh nấu nhạt nhẽo * câu pha trò nhạt nhẽo",
    example: "món canh nấu nhạt nhẽo * câu pha trò nhạt nhẽo",
  },
  {
    word: "nhạt nhẽo",
    part_of_speech: "tính từ",
    meaning:
      "hờ hững, không có một chút biểu hiện tình cảm nào: nụ cười nhạt nhẽo * đối xử nhạt nhẽo",
    example: "nụ cười nhạt nhẽo * đối xử nhạt nhẽo",
  },
  {
    word: "nhạt phai",
    part_of_speech: "động từ",
    meaning: "(hiếm) như phai nhạt: tình cảm đã nhạt phai",
    example: "tình cảm đã nhạt phai",
  },
  {
    word: "nhát gan",
    part_of_speech: "tính từ",
    meaning: "thiếu can đảm, hay sợ sệt: đồ nhát gan!",
    example: "đồ nhát gan!",
  },
  {
    word: "nhạt thếch",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) rất nhạt, thiếu hẳn cái vị tối thiểu cần có: rượu nhạt thếch * chè pha nhạt thếch * mới ốm dậy, mồm miệng nhạt thếch",
    example:
      "rượu nhạt thếch * chè pha nhạt thếch * mới ốm dậy, mồm miệng nhạt thếch",
  },
  {
    word: "nhạt thếch",
    part_of_speech: "tính từ",
    meaning: "hoàn toàn vô vị, vô duyên: câu chuyện nhạt thếch",
    example: "câu chuyện nhạt thếch",
  },
  {
    word: "nhạt phèo",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) rất nhạt, tựa như không có chút mùi vị gì: canh nhạt phèo * rượu nhạt phèo",
    example: "canh nhạt phèo * rượu nhạt phèo",
  },
  {
    word: "nhạt phèo",
    part_of_speech: "tính từ",
    meaning:
      "rất nhạt, không có sức hấp dẫn, không gây được chút hứng thú nào: câu chuyện nhạt phèo",
    example: "câu chuyện nhạt phèo",
  },
  {
    word: "nhàu",
    part_of_speech: "tính từ",
    meaning:
      "(giấy, vải, v.v.) có nhiều nếp nhăn, không phẳng: vò nhàu tờ giấy * áo đã bị nhàu",
    example: "vò nhàu tờ giấy * áo đã bị nhàu",
  },
  {
    word: "nhàu nát",
    part_of_speech: "tính từ",
    meaning:
      "nhàu đến mức như bị vò nát ra: lá thư nhàu nát * bộ quần áo nhàu nát",
    example: "lá thư nhàu nát * bộ quần áo nhàu nát",
  },
  {
    word: "nhạt nhoà",
    part_of_speech: "tính từ",
    meaning:
      "mờ đi, như bị nhoà vào với cái khác, không còn rõ nét: cảnh vật nhạt nhoà * kỉ niệm cũ nhạt nhoà trong kí ức",
    example: "cảnh vật nhạt nhoà * kỉ niệm cũ nhạt nhoà trong kí ức",
  },
  {
    word: "nháy",
    part_of_speech: "động từ",
    meaning: "nhắm mắt lại rồi mở ra ngay: mắt nháy lia lịa",
    example: "mắt nháy lia lịa",
  },
  {
    word: "nháy",
    part_of_speech: "động từ",
    meaning: "ra hiệu bằng cách nháy mắt: nháy mắt chào * nháy nhau ra một chỗ",
    example: "nháy mắt chào * nháy nhau ra một chỗ",
  },
  {
    word: "nháy",
    part_of_speech: "động từ",
    meaning:
      "loé, hoặc làm cho loé sáng rồi vụt tắt ngay, thường nhiều lần: chớp nháy loằng ngoằng * nháy đèn ra hiệu",
    example: "chớp nháy loằng ngoằng * nháy đèn ra hiệu",
  },
  {
    word: "nháy",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) ấn rồi thả nhanh một nút bấm trên con chuột của máy tính để thực hiện một thao tác: nháy chuột vào biểu tượng",
    example: "nháy chuột vào biểu tượng",
  },
  {
    word: "nhay",
    part_of_speech: "động từ",
    meaning: "cắn và nghiến đi nghiến lại nhè nhẹ: chó nhay giẻ rách",
    example: "chó nhay giẻ rách",
  },
  {
    word: "nhay",
    part_of_speech: "động từ",
    meaning: "cứa đi cứa lại nhiều lần cho đứt: dao cùn, nhay mãi không đứt",
    example: "dao cùn, nhay mãi không đứt",
  },
  {
    word: "nhạy",
    part_of_speech: "tính từ",
    meaning:
      "có khả năng phản ứng tức thời và chính xác trước những kích thích rất nhỏ: cân nhạy * con chó có cái mũi nhạy * xăng rất nhạy lửa",
    example: "cân nhạy * con chó có cái mũi nhạy * xăng rất nhạy lửa",
  },
  {
    word: "nhau",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận đặc biệt ở dạ con, có chức năng trao đổi chất dinh dưỡng giữa cơ thể mẹ và thai: cuống nhau * nơi chôn nhau cắt rốn",
    example: "cuống nhau * nơi chôn nhau cắt rốn",
  },
  {
    word: "nhau",
    part_of_speech: "danh từ",
    meaning:
      "từ biểu thị quan hệ tác động qua lại giữa các bên: cãi nhau * xoa hai tay vào nhau * hai người đã lấy nhau",
    example: "cãi nhau * xoa hai tay vào nhau * hai người đã lấy nhau",
  },
  {
    word: "nhau",
    part_of_speech: "danh từ",
    meaning:
      "từ biểu thị quan hệ tác động một chiều của bên này đến bên kia, giữa các bên có quan hệ gắn bó mật thiết: hai anh em dắt nhau đi chơi",
    example: "hai anh em dắt nhau đi chơi",
  },
  {
    word: "nhau",
    part_of_speech: "danh từ",
    meaning:
      "từ biểu thị quan hệ liên hợp cùng hoạt động giữa nhiều bên: xúm nhau lại mà làm * cùng nhau bàn bạc, trao đổi",
    example: "xúm nhau lại mà làm * cùng nhau bàn bạc, trao đổi",
  },
  {
    word: "nhảy cà tưng",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) nhảy cẫng: thằng nhỏ sướng quá nhảy cà tưng quanh sân",
    example: "thằng nhỏ sướng quá nhảy cà tưng quanh sân",
  },
  {
    word: "nhảy bổ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nhảy thẳng tới như lao vào: nhảy bổ xuống đất * chưa hiểu nếp tẻ đã nhảy bổ vào đánh nhau",
    example: "nhảy bổ xuống đất * chưa hiểu nếp tẻ đã nhảy bổ vào đánh nhau",
  },
  {
    word: "nhảy",
    part_of_speech: "động từ",
    meaning:
      "làm động tác bật mạnh toàn thân lên, thường để vượt qua một khoảng cách hoặc một chướng ngại: nhảy qua mương * tôm nhảy tanh tách * nước đến chân mới nhảy (tng)",
    example:
      "nhảy qua mương * tôm nhảy tanh tách * nước đến chân mới nhảy (tng)",
  },
  {
    word: "nhảy",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tham gia vào một cách nhanh, dứt khoát để làm việc gì: nhảy vào can * nhảy ngay vào cuộc",
    example: "nhảy vào can * nhảy ngay vào cuộc",
  },
  {
    word: "nhảy",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) chuyển đột ngột sang một vấn đề khác hẳn, không ăn nhập gì: đang nói chuyện này lại nhảy ngay sang chuyện khác",
    example: "đang nói chuyện này lại nhảy ngay sang chuyện khác",
  },
  {
    word: "nhảy",
    part_of_speech: "động từ",
    meaning:
      "bỏ qua các vị trí liền kề để chuyển thẳng đến vị trí sau đó: viết nhảy dòng * từ anh trưởng phòng nhảy luôn lên chức giám đốc (kng)",
    example:
      "viết nhảy dòng * từ anh trưởng phòng nhảy luôn lên chức giám đốc (kng)",
  },
  {
    word: "nhảy",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) làm những động tác thân thể nhịp nhàng, uyển chuyển, nối tiếp nhau theo nhạc điệu, trong các cuộc vui: nhảy đôi * nhảy điệu vals",
    example: "nhảy đôi * nhảy điệu vals",
  },
  {
    word: "nhảy",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) (súc vật đực) giao cấu với súc vật cái: bò nhảy cái",
    example: "bò nhảy cái",
  },
  {
    word: "nhạy cảm",
    part_of_speech: "tính từ",
    meaning:
      "có khả năng nhận biết nhanh và tinh bằng các giác quan, bằng cảm tính: nhạy cảm với thời tiết * một cô gái nhạy cảm",
    example: "nhạy cảm với thời tiết * một cô gái nhạy cảm",
  },
  {
    word: "nhạy cảm",
    part_of_speech: "tính từ",
    meaning:
      "(vấn đề) tế nhị, khó nói ra (vì nói ra thường dễ gây hiểu nhầm hoặc dễ nảy sinh những điều không hay): vấn đề hết sức nhạy cảm",
    example: "vấn đề hết sức nhạy cảm",
  },
  {
    word: "nhạy bén",
    part_of_speech: "tính từ",
    meaning:
      "có khả năng nắm bắt, phát hiện và thích ứng nhanh đối với những yếu tố mới, những yêu cầu mới: đầu óc nhạy bén",
    example: "đầu óc nhạy bén",
  },
  {
    word: "nhảy cao",
    part_of_speech: "danh từ",
    meaning:
      "môn điền kinh dùng sức của chân bật mạnh người lên cao để vượt qua một xà ngang: vận động viên nhảy cao",
    example: "vận động viên nhảy cao",
  },
  {
    word: "nhảy cẫng",
    part_of_speech: "động từ",
    meaning: "nhảy tung người lên vì vui sướng: nhảy cẫng lên sung sướng",
    example: "nhảy cẫng lên sung sướng",
  },
  {
    word: "nhảy cóc",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) (làm việc gì) nhảy từ cái nọ đến cái kia, bỏ qua từng phần, từng đoạn ở giữa: học nhảy cóc, hai năm ba lớp",
    example: "học nhảy cóc, hai năm ba lớp",
  },
  {
    word: "nhảy cầu",
    part_of_speech: "danh từ",
    meaning:
      "môn điền kinh nhảy từ trên cao xuống nước, có kết hợp làm động tác nhào lộn: môn nhảy cầu",
    example: "môn nhảy cầu",
  },
  {
    word: "nháy đúp",
    part_of_speech: "động từ",
    meaning:
      "ấn và thả nhanh hai lần liên tiếp một nút bấm trên con chuột của máy tính để thực hiện một thao tác định trước: nháy đúp chuột vào biểu tượng trên màn hình",
    example: "nháy đúp chuột vào biểu tượng trên màn hình",
  },
  {
    word: "nhảy dù",
    part_of_speech: "động từ",
    meaning: "nhảy bằng dù từ trên máy bay xuống: phi công nhảy dù",
    example: "phi công nhảy dù",
  },
  {
    word: "nhảy dù",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đến từ nơi khác và chiếm lấy (đất đai) làm của mình: dân nhảy dù",
    example: "dân nhảy dù",
  },
  {
    word: "nhảy dựng",
    part_of_speech: "động từ",
    meaning:
      "nhảy bật thẳng người lên do bị một tác động mạnh và đột ngột: ngựa nhảy dựng, hí ran * chưa nghe hết câu đã nhảy dựng lên",
    example: "ngựa nhảy dựng, hí ran * chưa nghe hết câu đã nhảy dựng lên",
  },
  {
    word: "nhảy múa",
    part_of_speech: "động từ",
    meaning:
      "làm những động tác nghệ thuật nhảy và múa (nói khái quát): mọi người nhảy múa quanh đống lửa * những dòng chữ như nhảy múa trước mắt",
    example:
      "mọi người nhảy múa quanh đống lửa * những dòng chữ như nhảy múa trước mắt",
  },
  {
    word: "nháy mắt",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) khoảng thời gian rất ngắn (tựa như chỉ bằng một cái nháy mắt): sự việc xảy ra trong nháy mắt",
    example: "sự việc xảy ra trong nháy mắt",
  },
  {
    word: "nhảy dây",
    part_of_speech: "động từ",
    meaning:
      "nhảy với sợi dây quay, mỗi khi sợi dây chạm đất thì nhảy co chân lên cho dây luồn qua (một trò chơi, thường là của trẻ em): chơi nhảy dây",
    example: "chơi nhảy dây",
  },
  {
    word: "nhảy đầm",
    part_of_speech: "động từ",
    meaning: "(cũ, khẩu ngữ) khiêu vũ: đi nhảy đầm * tập nhảy đầm",
    example: "đi nhảy đầm * tập nhảy đầm",
  },
  {
    word: "nháy nháy",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) trong ngoặc kép (hàm ý mỉa mai): dân chủ nháy nháy * nói là  * , nhưng chỉ là tử tế trong nháy nháy thôi",
    example:
      "dân chủ nháy nháy * nói là  * , nhưng chỉ là tử tế trong nháy nháy thôi",
  },
  {
    word: "nhảy vọt",
    part_of_speech: "động từ",
    meaning:
      "nhảy qua hoặc nhảy đến một nơi nào đó bằng động tác nhanh và dứt khoát: nhảy vọt qua rãnh nước",
    example: "nhảy vọt qua rãnh nước",
  },
  {
    word: "nhảy vọt",
    part_of_speech: "động từ",
    meaning:
      "lên cao đột ngột và rất nhanh: giá cả nhảy vọt * mức tăng trưởng nhảy vọt",
    example: "giá cả nhảy vọt * mức tăng trưởng nhảy vọt",
  },
  {
    word: "nhảy ổ",
    part_of_speech: "động từ",
    meaning: "(gà) nhảy tìm ổ để đẻ trứng: gà nhảy ổ",
    example: "gà nhảy ổ",
  },
  {
    word: "nhảy tót",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nhảy lên chỗ cao bằng động tác nhanh và gọn: nhảy tót lên xe",
    example: "nhảy tót lên xe",
  },
  {
    word: "nhảy nhót",
    part_of_speech: "động từ",
    meaning:
      "nhảy tung tăng một cách vui vẻ, thoải mái: con chim nhảy nhót trên cành",
    example: "con chim nhảy nhót trên cành",
  },
  {
    word: "nhay nháy",
    part_of_speech: "động từ",
    meaning:
      "nháy nhiều và liên tiếp: nhay nháy con mắt * chớp đông nhay nháy, gà gáy thì mưa (tng)",
    example: "nhay nháy con mắt * chớp đông nhay nháy, gà gáy thì mưa (tng)",
  },
  {
    word: "nhảy xa",
    part_of_speech: "danh từ",
    meaning:
      "môn điền kinh nhảy bằng cách chạy lấy đà rồi bật mạnh để đưa người đi xa: đoạt huy chương vàng môn nhảy xa",
    example: "đoạt huy chương vàng môn nhảy xa",
  },
  {
    word: "nhảy xổ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nhảy thẳng tới, lao tới một cách bất ngờ: từ ngoài mé hang nhảy xổ vào * nhảy xổ vào mà giật",
    example: "từ ngoài mé hang nhảy xổ vào * nhảy xổ vào mà giật",
  },
  {
    word: "nhắc nhỏm",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) nhắc đến luôn: nhắc nhỏm đến người đi xa",
    example: "nhắc nhỏm đến người đi xa",
  },
  {
    word: "nhắc nhủ",
    part_of_speech: "động từ",
    meaning: "nhắc nhở và khuyên nhủ: động viên, nhắc nhủ kịp thời",
    example: "động viên, nhắc nhủ kịp thời",
  },
  {
    word: "nhắc nhở",
    part_of_speech: "động từ",
    meaning:
      "nhắc để cho chú ý (nói khái quát): thường xuyên nhắc nhở con cái * nhắc nhở nhau học tập",
    example: "thường xuyên nhắc nhở con cái * nhắc nhở nhau học tập",
  },
  {
    word: "nhắc nhở",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) phê bình nhẹ bằng cách nhắc điều người khác đã quên nên đã phạm khuyết điểm: bị nhắc nhở vì đi làm muộn",
    example: "bị nhắc nhở vì đi làm muộn",
  },
  {
    word: "nhắc chừng",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) thỉnh thoảng lại nhắc cho khỏi quên: nhắc chừng con trông em cẩn thận",
    example: "nhắc chừng con trông em cẩn thận",
  },
  {
    word: "nhắm",
    part_of_speech: "động từ",
    meaning:
      "(mắt) khép kín hai mi, như khi ngủ: mắt nhắm lại cho đỡ mỏi * sợ quá mắt nhắm tít",
    example: "mắt nhắm lại cho đỡ mỏi * sợ quá mắt nhắm tít",
  },
  {
    word: "nhắm",
    part_of_speech: "động từ",
    meaning:
      "tìm chọn đối tượng nào đó cho một công việc sắp tới: sản phẩm nhắm vào giới trẻ",
    example: "sản phẩm nhắm vào giới trẻ",
  },
  {
    word: "nhắm",
    part_of_speech: "động từ",
    meaning: "ăn thức ăn kèm khi uống rượu: nhắm rượu * đồ nhắm",
    example: "nhắm rượu * đồ nhắm",
  },
  {
    word: "nhắc",
    part_of_speech: "động từ",
    meaning: "nói ra cho người khác nhớ: nhắc bài cho bạn * nhắc tới chuyện cũ",
    example: "nhắc bài cho bạn * nhắc tới chuyện cũ",
  },
  {
    word: "nhắc",
    part_of_speech: "động từ",
    meaning:
      "nói lại để người khác nhớ mà thực hiện, mà làm đúng: nhắc mấy lần rồi mà vẫn không trả * nhắc con đi ngủ",
    example: "nhắc mấy lần rồi mà vẫn không trả * nhắc con đi ngủ",
  },
  {
    word: "nhắc",
    part_of_speech: "động từ",
    meaning: "nói đến vì quan tâm, mong nhớ: mẹ tôi thường nhắc đến anh luôn",
    example: "mẹ tôi thường nhắc đến anh luôn",
  },
  {
    word: "nhằm",
    part_of_speech: "động từ",
    meaning:
      "hướng vào một cái đích nào đó: giương súng nhằm bắn * nhằm hướng đông mà đi * phê bình chung chung, không nhằm riêng ai",
    example:
      "giương súng nhằm bắn * nhằm hướng đông mà đi * phê bình chung chung, không nhằm riêng ai",
  },
  {
    word: "nhằm",
    part_of_speech: "động từ",
    meaning:
      "hướng sự lựa chọn vào người nào đó: nhằm người thật thà để lừa đảo * cứ nhằm vào anh ta mà đả kích",
    example: "nhằm người thật thà để lừa đảo * cứ nhằm vào anh ta mà đả kích",
  },
  {
    word: "nhằm",
    part_of_speech: "động từ",
    meaning:
      "chọn đúng cơ hội, thời cơ: nhằm lúc sơ hở mà đánh * nhằm đúng thời cơ",
    example: "nhằm lúc sơ hở mà đánh * nhằm đúng thời cơ",
  },
  {
    word: "nhằm",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là cái đích hướng vào của việc làm vừa nói đến: làm thế nhằm trấn an dư luận * thực hiện nhiều biện pháp nhằm đẩy mạnh sản xuất",
    example:
      "làm thế nhằm trấn an dư luận * thực hiện nhiều biện pháp nhằm đẩy mạnh sản xuất",
  },
  {
    word: "nhặm lẹ",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) mau lẹ: đi đứng nhặm lẹ",
    example: "đi đứng nhặm lẹ",
  },
  {
    word: "nhặm",
    part_of_speech: "tính từ",
    meaning:
      "có cảm giác ngứa, xót, khó chịu do bị những vật vụn nhỏ nhưng sắc cạnh bám vào da thịt: nghịch rơm nên bị nhặm * mắt nhặm vì bụi",
    example: "nghịch rơm nên bị nhặm * mắt nhặm vì bụi",
  },
  {
    word: "nhắm mắt đưa chân",
    part_of_speech: "",
    meaning:
      'đành nhắm mắt mà làm, phó mặc cho số phận, cho may rủi: "Cũng liều nhắm mắt đưa chân, Mà xem con Tạo xoay vần đến đâu!" (TKiều)',
    example:
      'Cũng liều nhắm mắt đưa chân, Mà xem con Tạo xoay vần đến đâu!" (TKiều)',
  },
  {
    word: "nhắm nghiền",
    part_of_speech: "động từ",
    meaning: "(mắt) nhắm thật chặt: mệt mỏi, hai mắt nhắm nghiền",
    example: "mệt mỏi, hai mắt nhắm nghiền",
  },
  {
    word: "nhắm mắt",
    part_of_speech: "động từ",
    meaning: "bắt đầu ngủ: vừa mới nhắm mắt thì trời đã sáng",
    example: "vừa mới nhắm mắt thì trời đã sáng",
  },
  {
    word: "nhắm mắt",
    part_of_speech: "động từ",
    meaning: "(trang trọng) chết: lời dặn dò trước lúc nhắm mắt",
    example: "lời dặn dò trước lúc nhắm mắt",
  },
  {
    word: "nhắm mắt",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) yên lòng mà chết, không có điều gì ân hận: chết không nhắm mắt",
    example: "chết không nhắm mắt",
  },
  {
    word: "nhắm mắt",
    part_of_speech: "động từ",
    meaning: "làm như không biết gì cả về một sự thật nào đó: nhắm mắt làm ngơ",
    example: "nhắm mắt làm ngơ",
  },
  {
    word: "nhắm nhe",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ, hiếm) chú ý đến, nhắm sẵn: có mấy đám nhắm nhe",
    example: "có mấy đám nhắm nhe",
  },
  {
    word: "nhằn",
    part_of_speech: "động từ",
    meaning:
      "cắn từng tí một và dùng lưỡi lừa, đẩy ra những phần không ăn được: nhằn hạt dưa * ăn cá nhằn xương * nhằn sạn",
    example: "nhằn hạt dưa * ăn cá nhằn xương * nhằn sạn",
  },
  {
    word: "nhằn",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) làm để mong thu được chút ít kết quả: việc ấy khó nhằn lắm",
    example: "việc ấy khó nhằn lắm",
  },
  {
    word: "nhắn",
    part_of_speech: "động từ",
    meaning:
      'báo tin bằng cách nhờ người khác nói lại hoặc qua phương tiện trung gian: nhắn người đến đón * "Khi về nhắn liễu Chương Đài, Cành xuân đã bẻ cho ai một cành." (ca dao)',
    example:
      'nhắn người đến đón * "Khi về nhắn liễu Chương Đài, Cành xuân đã bẻ cho ai một cành." (ca dao)',
  },
  {
    word: "nhằm nhè",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ, khẩu ngữ) như ăn thua (ng2): bị thương như vầy đã nhằm nhè gì!",
    example: "bị thương như vầy đã nhằm nhè gì!",
  },
  {
    word: "nhằm nhò",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ, khẩu ngữ) như ăn thua (ng2): nhằm nhò gì ba cái đồng bạc!",
    example: "nhằm nhò gì ba cái đồng bạc!",
  },
  {
    word: "nhẵn",
    part_of_speech: "tính từ",
    meaning:
      "có bề mặt rất trơn, không thô ráp, không gồ ghề: mặt đá mòn nhẵn * bào nhẵn từng thanh gỗ * đầu cạo nhẵn",
    example: "mặt đá mòn nhẵn * bào nhẵn từng thanh gỗ * đầu cạo nhẵn",
  },
  {
    word: "nhẵn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) hoàn toàn chẳng còn gì: ăn nhẵn nồi mà vẫn đói * nhẵn như chùi",
    example: "ăn nhẵn nồi mà vẫn đói * nhẵn như chùi",
  },
  {
    word: "nhẵn",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) quá quen vì đã qua lại hoặc gặp nhiều lần rồi: nhẵn mặt nhau",
    example: "nhẵn mặt nhau",
  },
  {
    word: "nhăn",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nhe răng, để lộ răng ra: nhăn răng ra cười * đói nhăn ra",
    example: "nhăn răng ra cười * đói nhăn ra",
  },
  {
    word: "nhăn",
    part_of_speech: "tính từ",
    meaning: "có nếp nhỏ như gấp lại, không phẳng: nếp nhăn * ống quần bị nhăn",
    example: "nếp nhăn * ống quần bị nhăn",
  },
  {
    word: "nhăn",
    part_of_speech: "động từ",
    meaning:
      "co các cơ, làm cho da mặt gấp thành những nếp nhăn nhỏ (thường do suy nghĩ, đau đớn hoặc xúc động): nhăn trán suy nghĩ * nhăn mặt khó chịu",
    example: "nhăn trán suy nghĩ * nhăn mặt khó chịu",
  },
  {
    word: "nhẵn mặt",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) quá quen mặt vì đã gặp nhiều lần (thường hàm ý coi thường): một tên trộm nhẵn mặt ở khu chợ",
    example: "một tên trộm nhẵn mặt ở khu chợ",
  },
  {
    word: "nhắn gửi",
    part_of_speech: "động từ",
    meaning: "gửi lời nhắn cho người khác: nhắn gửi lời thăm hỏi",
    example: "nhắn gửi lời thăm hỏi",
  },
  {
    word: "nhăn nheo",
    part_of_speech: "tính từ",
    meaning: "có nhiều nếp nhăn: quần áo nhăn nheo * bàn tay nhăn nheo",
    example: "quần áo nhăn nheo * bàn tay nhăn nheo",
  },
  {
    word: "nhăn nhó",
    part_of_speech: "",
    meaning:
      "(mặt) nhăn lại, tỏ vẻ đau khổ hoặc không vừa lòng: mặt mũi lúc nào cũng nhăn nhó * ôm bụng nhăn nhó",
    example: "mặt mũi lúc nào cũng nhăn nhó * ôm bụng nhăn nhó",
  },
  {
    word: "nhẵn lì",
    part_of_speech: "tính từ",
    meaning:
      "nhẵn đến mức như không hề có một chút gợn: viên sỏi nhẵn lì * mặt đường nhẵn lì",
    example: "viên sỏi nhẵn lì * mặt đường nhẵn lì",
  },
  {
    word: "nhắn nhe",
    part_of_speech: "động từ",
    meaning:
      '(khẩu ngữ) nhắn (nói khái quát): "Hai ta cách trở đôi phương, Nhắn nhe cùng bạn, giận hờn chi không?" (ca dao)',
    example:
      'Hai ta cách trở đôi phương, Nhắn nhe cùng bạn, giận hờn chi không?" (ca dao)',
  },
  {
    word: "nhăn nhở",
    part_of_speech: "",
    meaning: "nhe răng cười không đúng lúc, vô duyên, trơ trẽn: cười nhăn nhở",
    example: "cười nhăn nhở",
  },
  {
    word: "nhắn nhủ",
    part_of_speech: "động từ",
    meaning: "gửi lời dặn dò, khuyên nhủ: nhắn nhủ đôi điều",
    example: "nhắn nhủ đôi điều",
  },
  {
    word: "nhăn nhúm",
    part_of_speech: "tính từ",
    meaning:
      "nhăn nheo và co rúm lại, trông méo mó: chiếc áo nhăn nhúm * da mặt nhăn nhúm",
    example: "chiếc áo nhăn nhúm * da mặt nhăn nhúm",
  },
  {
    word: "nhẵn nhụi",
    part_of_speech: "tính từ",
    meaning:
      "được sửa, dọn cho thật sạch, thật nhẵn, không còn lởm chởm, rậm rạp: gỗ bào nhẵn nhụi * râu ria cạo nhẵn nhụi",
    example: "gỗ bào nhẵn nhụi * râu ria cạo nhẵn nhụi",
  },
  {
    word: "nhắn tìm",
    part_of_speech: "động từ",
    meaning:
      "tìm, hỏi tin tức bằng cách nhắn tin trên các phương tiện thông tin đại chúng: nhắn tìm người thân bị lạc * mục  *  trên đài truyền hình",
    example: "nhắn tìm người thân bị lạc * mục  *  trên đài truyền hình",
  },
  {
    word: "nhắn tin",
    part_of_speech: "động từ",
    meaning:
      "gửi tin cần báo đến người nào đó qua một người khác hoặc qua phương tiện trung gian: máy nhắn tin * dịch vụ nhắn tin",
    example: "máy nhắn tin * dịch vụ nhắn tin",
  },
  {
    word: "nhẵn thín",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) nhẵn đến mức như trơn bóng, không có chút gợn nào: hòn sỏi nhẵn thín * đầu cạo nhẵn thín",
    example: "hòn sỏi nhẵn thín * đầu cạo nhẵn thín",
  },
  {
    word: "nhăn răng",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) tổ hợp gợi tả dáng vẻ chết hay đói trông thấy rõ, không thể cứu được (thường dùng trong lời rủa, mắng): đói nhăn răng",
    example: "đói nhăn răng",
  },
  {
    word: "nhặng",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) rối rít, ồn ào quá mức cần thiết, gây cảm giác khó chịu đến phát ghét: đàn chó sủa nhặng * kêu nhặng lên * động một tí là nhặng lên!",
    example: "đàn chó sủa nhặng * kêu nhặng lên * động một tí là nhặng lên!",
  },
  {
    word: "nhẵn túi",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) hết sạch tiền: thua bạc nhẵn túi",
    example: "thua bạc nhẵn túi",
  },
  {
    word: "nhắng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) rối rít, ồn ào với vẻ bận rộn, quan trọng, gây cho người khác cảm giác sốt ruột, khó chịu: giục nhắng lên * mấy con chó sủa nhắng lên",
    example: "giục nhắng lên * mấy con chó sủa nhắng lên",
  },
  {
    word: "nhắng",
    part_of_speech: "tính từ",
    meaning:
      "có vẻ nhộn hơi thái quá, dễ gây buồn cười: thằng bé rất nhắng * kiểu tóc trông nhắng lắm!",
    example: "thằng bé rất nhắng * kiểu tóc trông nhắng lắm!",
  },
  {
    word: "nhăng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) lung tung, không đâu vào đâu, không ích lợi gì: vẽ nhăng vào vở * chạy nhăng",
    example: "vẽ nhăng vào vở * chạy nhăng",
  },
  {
    word: "nhằng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đan xen vào nhau, giằng chéo vào nhau, rất khó gỡ, khó dứt ra: các sợi nhằng vào nhau * việc nọ nhằng sang việc kia",
    example: "các sợi nhằng vào nhau * việc nọ nhằng sang việc kia",
  },
  {
    word: "nhằng nhằng",
    part_of_speech: "động từ",
    meaning: "như nhằng (nhưng ý nhấn mạnh hơn): lửa chớp nhằng nhằng",
    example: "lửa chớp nhằng nhằng",
  },
  {
    word: "nhằng nhằng",
    part_of_speech: "động từ",
    meaning:
      "dai dẳng, rất khó dứt, gây cảm giác khó chịu: đứa bé bám nhằng nhằng lấy mẹ",
    example: "đứa bé bám nhằng nhằng lấy mẹ",
  },
  {
    word: "nhăng cuội",
    part_of_speech: "tính từ",
    meaning:
      "nhảm nhí, vu vơ, không đâu vào đâu: vẽ nhăng cuội * nói nhăng nói cuội",
    example: "vẽ nhăng cuội * nói nhăng nói cuội",
  },
  {
    word: "nhắng nhít",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) nhắng, làm ra bộ quan trọng (nói khái quát): chưa chi đã nhắng nhít lên",
    example: "chưa chi đã nhắng nhít lên",
  },
  {
    word: "nhằng nhẵng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (theo, bám) không một lúc nào chịu rời, chịu dứt ra: bám nhằng nhẵng * nhằng nhẵng theo sau",
    example: "bám nhằng nhẵng * nhằng nhẵng theo sau",
  },
  {
    word: "nhăng nhẳng",
    part_of_speech: "tính từ",
    meaning: "dai dẳng, không chịu thôi: đòi nhăng nhẳng * chó cắn nhăng nhẳng",
    example: "đòi nhăng nhẳng * chó cắn nhăng nhẳng",
  },
  {
    word: "nhằng nhịt",
    part_of_speech: "tính từ",
    meaning:
      "thành nhiều đường đan xen, chồng chéo lên nhau theo nhiều chiều một cách không có thứ tự: mạng nhện giăng nhằng nhịt * rễ tre đan vào nhau nhằng nhịt",
    example: "mạng nhện giăng nhằng nhịt * rễ tre đan vào nhau nhằng nhịt",
  },
  {
    word: "nhặng xị",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) rộ lên làm ầm ĩ, gây khó chịu: quát tháo nhặng xị * cáu gắt nhặng xị",
    example: "quát tháo nhặng xị * cáu gắt nhặng xị",
  },
  {
    word: "nhặt",
    part_of_speech: "động từ",
    meaning:
      "(Nam thường nói lượm) cầm vật bị đánh rơi lên: ra sân nhặt bóng * nhặt được của rơi, trả người đánh mất",
    example: "ra sân nhặt bóng * nhặt được của rơi, trả người đánh mất",
  },
  {
    word: "nhặt",
    part_of_speech: "động từ",
    meaning:
      "(Nam thường lặt) cầm cái đã được chọn lựa lên và để riêng ra: nhặt rau * nhặt cỏ ngoài vườn * nhặt thóc lẫn trong gạo",
    example: "nhặt rau * nhặt cỏ ngoài vườn * nhặt thóc lẫn trong gạo",
  },
  {
    word: "nhặt",
    part_of_speech: "tính từ",
    meaning:
      "(giữa các phần cách đều nhau và nối tiếp nhau) có khoảng cách ngắn hơn nhiều so với mức bình thường: mía nhặt đốt * khâu nhặt mũi * nhặt che mưa, thưa che nắng (tng)",
    example: "mía nhặt đốt * khâu nhặt mũi * nhặt che mưa, thưa che nắng (tng)",
  },
  {
    word: "nhặt",
    part_of_speech: "tính từ",
    meaning: "có nhịp độ âm thanh dày và dồn dập: tiếng đàn lúc nhặt lúc khoan",
    example: "tiếng đàn lúc nhặt lúc khoan",
  },
  {
    word: "nhăng nhít",
    part_of_speech: "tính từ",
    meaning:
      "nhăng (nói khái quát): vẽ nhăng nhít lên tường * nói nhăng nhít mấy câu * chạy nhăng nhít",
    example:
      "vẽ nhăng nhít lên tường * nói nhăng nhít mấy câu * chạy nhăng nhít",
  },
  {
    word: "nhăng nhít",
    part_of_speech: "tính từ",
    meaning:
      "không đứng đắn (trong quan hệ nam nữ): yêu đương nhăng nhít * giở trò trăng hoa nhăng nhít",
    example: "yêu đương nhăng nhít * giở trò trăng hoa nhăng nhít",
  },
  {
    word: "nhầm",
    part_of_speech: "động từ",
    meaning:
      'như lầm (thường nói về cái cụ thể hoặc không quan trọng): nhớ nhầm * đoán nhầm * "Lòng tôi yêu vụng nhớ thầm, Trách ông Nguyệt Lão xe nhầm duyên ai!" (ca dao)',
    example:
      'nhớ nhầm * đoán nhầm * "Lòng tôi yêu vụng nhớ thầm, Trách ông Nguyệt Lão xe nhầm duyên ai!" (ca dao)',
  },
  {
    word: "nhặt nhạnh",
    part_of_speech: "động từ",
    meaning:
      "nhặt từng ít một, từng cái rất nhỏ để gom, góp lại: nhặt nhạnh đồ nghề vào một chỗ * nhặt nhạnh từng mẩu sắt vụn",
    example: "nhặt nhạnh đồ nghề vào một chỗ * nhặt nhạnh từng mẩu sắt vụn",
  },
  {
    word: "nhẩm",
    part_of_speech: "động từ",
    meaning:
      "nói, đọc khẽ trong miệng hoặc nghĩ thầm trong óc, thường để cho thuộc, cho nhớ: đọc nhẩm * cộng nhẩm * nhẩm đi nhẩm lại cho thuộc",
    example: "đọc nhẩm * cộng nhẩm * nhẩm đi nhẩm lại cho thuộc",
  },
  {
    word: "nhấm",
    part_of_speech: "động từ",
    meaning:
      "cắn nhẹ từng tí một: ớt nhấm không thấy cay * nhấm đầu bút chì * quần áo bị gián nhấm",
    example: "ớt nhấm không thấy cay * nhấm đầu bút chì * quần áo bị gián nhấm",
  },
  {
    word: "nhấc",
    part_of_speech: "động từ",
    meaning:
      "nâng lên, đưa lên cao hơn một chút: nhấc li rượu lên * nhấc lên đặt xuống * mệt quá, chân tay không nhấc lên nổi",
    example:
      "nhấc li rượu lên * nhấc lên đặt xuống * mệt quá, chân tay không nhấc lên nổi",
  },
  {
    word: "nhấc",
    part_of_speech: "động từ",
    meaning:
      "nâng để chuyển khỏi vị trí cũ: nhấc từng bước mệt mỏi * nhấc nồi ra khỏi bếp * bị nhấc mất chiếc xe đạp",
    example:
      "nhấc từng bước mệt mỏi * nhấc nồi ra khỏi bếp * bị nhấc mất chiếc xe đạp",
  },
  {
    word: "nhấc",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đưa lên một chức vị cao hơn: được nhấc lên chức trưởng phòng",
    example: "được nhấc lên chức trưởng phòng",
  },
  {
    word: "nhậm chức",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) chính thức nhận chức vụ: lễ nhậm chức * nhậm chức thủ tướng",
    example: "lễ nhậm chức * nhậm chức thủ tướng",
  },
  {
    word: "nhầm lẫn",
    part_of_speech: "động từ",
    meaning:
      "nhầm cái nọ với cái kia (nói khái quát): đánh dấu cho khỏi nhầm lẫn",
    example: "đánh dấu cho khỏi nhầm lẫn",
  },
  {
    word: "nhấm nháp",
    part_of_speech: "động từ",
    meaning:
      "ăn hay uống từ từ từng ít một, chủ yếu là để thưởng thức: nhấm nháp li rượu * nhấm nháp chút ít cho vui miệng",
    example: "nhấm nháp li rượu * nhấm nháp chút ít cho vui miệng",
  },
  {
    word: "nhâm nhẩm",
    part_of_speech: "động từ",
    meaning: "như lẩm nhẩm: miệng nhâm nhẩm hát",
    example: "miệng nhâm nhẩm hát",
  },
  {
    word: "nhận",
    part_of_speech: "động từ",
    meaning:
      "dìm cho ngập vào nước, vào bùn: thuyền bị sóng nhận chìm * nhận cỏ xuống bùn",
    example: "thuyền bị sóng nhận chìm * nhận cỏ xuống bùn",
  },
  {
    word: "nhận",
    part_of_speech: "động từ",
    meaning:
      "lấy, lĩnh, thu về cái được gửi, được trao cho mình: nhận quà * nhận được thư nhà * nhận nhiệm vụ",
    example: "nhận quà * nhận được thư nhà * nhận nhiệm vụ",
  },
  {
    word: "nhận",
    part_of_speech: "động từ",
    meaning:
      "đồng ý, bằng lòng làm theo yêu cầu: nhận giúp đỡ bạn * nhận chở hàng thuê",
    example: "nhận giúp đỡ bạn * nhận chở hàng thuê",
  },
  {
    word: "nhận",
    part_of_speech: "động từ",
    meaning:
      "thấy rõ, biết rõ, nhờ phân biệt ra được: nhận ra người quen * nhận thấy có điều bất thường * nhận rõ trắng đen",
    example:
      "nhận ra người quen * nhận thấy có điều bất thường * nhận rõ trắng đen",
  },
  {
    word: "nhận",
    part_of_speech: "động từ",
    meaning:
      "chịu là đúng, là có: nhận lỗi * xin nhận khuyết điểm * tự nhận là mình sai",
    example: "nhận lỗi * xin nhận khuyết điểm * tự nhận là mình sai",
  },
  {
    word: "nhân",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận ở bên trong một số loại hạt: nhân quả trám * nhân hạt sen * lạc nhân",
    example: "nhân quả trám * nhân hạt sen * lạc nhân",
  },
  {
    word: "nhân",
    part_of_speech: "danh từ",
    meaning:
      "phần ở giữa bánh, thường là phần ngon nhất, làm bằng các chất khác với phần ngoài: mua thịt làm nhân nem * bánh bao không nhân",
    example: "mua thịt làm nhân nem * bánh bao không nhân",
  },
  {
    word: "nhân",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận ở giữa tế bào, thường hình cầu, có chức năng quan trọng trong hoạt động sống, sinh sản và di truyền: nhân tế bào",
    example: "nhân tế bào",
  },
  {
    word: "nhân",
    part_of_speech: "danh từ",
    meaning: "lòng thương người: làm điều nhân * sống rất có nhân có nghĩa",
    example: "làm điều nhân * sống rất có nhân có nghĩa",
  },
  {
    word: "nhân",
    part_of_speech: "danh từ",
    meaning: "nguyên nhân (nói tắt): nhân nào quả ấy * mối quan hệ nhân - quả",
    example: "nhân nào quả ấy * mối quan hệ nhân - quả",
  },
  {
    word: "nhân",
    part_of_speech: "động từ",
    meaning:
      "làm phép toán về số mà ở trường hợp đơn giản nhất là cộng tắt một số (gọi là số bị nhân) với chính nó một số lần nào đó (số lần đó gọi là số nhân): hai nhân bốn là tám (2 x 4 = 8) * làm phép tính nhân",
    example: "hai nhân bốn là tám (2 x 4 = 8) * làm phép tính nhân",
  },
  {
    word: "nhân",
    part_of_speech: "động từ",
    meaning:
      "làm tăng thêm gấp nhiều lần từ cái hiện có: nhân bèo hoa dâu * nhân giống",
    example: "nhân bèo hoa dâu * nhân giống",
  },
  {
    word: "nhân",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là dịp, là hoàn cảnh thuận tiện trong đó diễn ra sự việc nói đến: chúc mừng nhân ngày sinh nhật * nhân đi qua thì ghé vào",
    example: "chúc mừng nhân ngày sinh nhật * nhân đi qua thì ghé vào",
  },
  {
    word: "nhấm nhẳn",
    part_of_speech: "tính từ",
    meaning:
      "(nói) buông từng tiếng một, tỏ vẻ bực mình, khó chịu: ăn nói dấm dẳn",
    example: "ăn nói dấm dẳn",
  },
  {
    word: "nhâm nhi",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) như nhấm nháp: nhâm nhi li cà phê",
    example: "nhâm nhi li cà phê",
  },
  {
    word: "nhấn",
    part_of_speech: "động từ",
    meaning: "ấn nhẹ xuống: nhấn chuông * nhấn còi",
    example: "nhấn chuông * nhấn còi",
  },
  {
    word: "nhấn",
    part_of_speech: "động từ",
    meaning: "(hiếm) như nhận: áo trắng nhấn bùn",
    example: "áo trắng nhấn bùn",
  },
  {
    word: "nhấn",
    part_of_speech: "động từ",
    meaning:
      "dùng lời lẽ hay giọng điệu khác thường ở điều được coi là quan trọng, đáng quan tâm, làm cho người khác chú ý đến: nói nhấn giọng * nhấn vào nhiệm vụ chính",
    example: "nói nhấn giọng * nhấn vào nhiệm vụ chính",
  },
  {
    word: "nhân ảnh",
    part_of_speech: "danh từ",
    meaning:
      '(văn chương) hình bóng của con người: "Cái quay búng sẵn trên trời, Mờ mờ nhân ảnh như người đi đêm." (CO)',
    example:
      'Cái quay búng sẵn trên trời, Mờ mờ nhân ảnh như người đi đêm." (CO)',
  },
  {
    word: "nhẫn",
    part_of_speech: "danh từ",
    meaning:
      "vòng nhỏ, thường bằng vàng, bạc, đeo vào ngón tay làm đồ trang sức: nhẫn vàng * đeo nhẫn",
    example: "nhẫn vàng * đeo nhẫn",
  },
  {
    word: "nhẫn",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) nhịn, dằn lòng xuống: tôi mà không nhẫn thì đã sinh chuyện",
    example: "tôi mà không nhẫn thì đã sinh chuyện",
  },
  {
    word: "nhân ái",
    part_of_speech: "tính từ",
    meaning:
      "có lòng yêu thương con người, sẵn sàng giúp đỡ khi cần thiết: tấm lòng nhân ái * sống nhân ái với mọi người",
    example: "tấm lòng nhân ái * sống nhân ái với mọi người",
  },
  {
    word: "nhân bản",
    part_of_speech: "động từ",
    meaning: "tạo ra thành nhiều bản giống hệt nhau: nhân bản một tài liệu",
    example: "nhân bản một tài liệu",
  },
  {
    word: "nhân bản",
    part_of_speech: "động từ",
    meaning: "nhân bản vô tính (nói tắt): nhân bản phôi người",
    example: "nhân bản phôi người",
  },
  {
    word: "nhân bản",
    part_of_speech: "tính từ",
    meaning:
      "(cũ) như nhân văn (ng2): giá trị nhân bản * câu chuyện mang tính nhân bản sâu sắc",
    example: "giá trị nhân bản * câu chuyện mang tính nhân bản sâu sắc",
  },
  {
    word: "nhân cách hoá",
    part_of_speech: "",
    meaning:
      "biện pháp tu từ trong văn học, gán cho loài vật hoặc vật vô tri hình dáng, tính cách hoặc ngôn ngữ của con người: thủ pháp nhân cách hoá thường được dùng trong truyện ngụ ngôn",
    example: "thủ pháp nhân cách hoá thường được dùng trong truyện ngụ ngôn",
  },
  {
    word: "nhấn chìm",
    part_of_speech: "động từ",
    meaning: "làm cho bị chìm ngập: con tàu bị nhấn chìm dưới đáy biển",
    example: "con tàu bị nhấn chìm dưới đáy biển",
  },
  {
    word: "nhân cách",
    part_of_speech: "danh từ",
    meaning:
      "tư cách và phẩm chất con người: người có nhân cách * mất nhân cách",
    example: "người có nhân cách * mất nhân cách",
  },
  {
    word: "nhận chân",
    part_of_speech: "động từ",
    meaning: "nhận thức rõ một sự thật, một chân lí: nhận chân ra sự thật",
    example: "nhận chân ra sự thật",
  },
  {
    word: "nhận biết",
    part_of_speech: "động từ",
    meaning:
      "nhận ra mà biết, mà hiểu được: nhận biết ra lẽ phải * nhận biết bằng cảm giác",
    example: "nhận biết ra lẽ phải * nhận biết bằng cảm giác",
  },
  {
    word: "nhận dạng",
    part_of_speech: "động từ",
    meaning:
      "nhìn hình dáng, đặc điểm bên ngoài để nhận ra một đối tượng nào đó: nhận dạng chữ kí * nhận dạng tử thi",
    example: "nhận dạng chữ kí * nhận dạng tử thi",
  },
  {
    word: "nhẫn cưới",
    part_of_speech: "danh từ",
    meaning: "nhẫn nam nữ trao cho nhau khi làm lễ cưới: mua một đôi nhẫn cưới",
    example: "mua một đôi nhẫn cưới",
  },
  {
    word: "nhân dạng",
    part_of_speech: "danh từ",
    meaning:
      "những đặc điểm bề ngoài, như dáng người, màu da, vẻ mặt, v.v., để nhận biết một người, phân biệt với những người khác (nói tổng quát): đặc điểm nhân dạng",
    example: "đặc điểm nhân dạng",
  },
  {
    word: "nhân công",
    part_of_speech: "danh từ",
    meaning:
      "sức lao động của con người được sử dụng vào một công việc nào đó: thuê nhân công * đội ngũ nhân công lành nghề * giá nhân công rẻ mạt",
    example:
      "thuê nhân công * đội ngũ nhân công lành nghề * giá nhân công rẻ mạt",
  },
  {
    word: "nhân chứng",
    part_of_speech: "danh từ",
    meaning: "người làm chứng: làm nhân chứng ở phiên toà * nhân chứng lịch sử",
    example: "làm nhân chứng ở phiên toà * nhân chứng lịch sử",
  },
  {
    word: "nhân dân",
    part_of_speech: "danh từ",
    meaning:
      "đông đảo những người dân, thuộc mọi tầng lớp, đang sống trong một khu vực nào đó (nói tổng quát): nhân dân Việt Nam * quần chúng nhân dân * nhân dân lao động * ý kiến của nhân dân",
    example:
      "nhân dân Việt Nam * quần chúng nhân dân * nhân dân lao động * ý kiến của nhân dân",
  },
  {
    word: "nhân dân",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về đông đảo những người dân, nhằm phục vụ cho lợi ích của đông đảo người dân: quân đội nhân dân * toà án nhân dân",
    example: "quân đội nhân dân * toà án nhân dân",
  },
  {
    word: "nhân danh",
    part_of_speech: "danh từ",
    meaning: "tên người: từ điển nhân danh",
    example: "từ điển nhân danh",
  },
  {
    word: "nhân danh",
    part_of_speech: "động từ",
    meaning:
      "lấy danh nghĩa để làm một việc gì đó: nhân danh giám đốc tuyên bố mức kỉ luật",
    example: "nhân danh giám đốc tuyên bố mức kỉ luật",
  },
  {
    word: "nhân dịp",
    part_of_speech: "kết từ",
    meaning:
      "nhân có được dịp thuận tiện, thích hợp để làm việc nào đó: chúc mừng nhân dịp sinh nhật",
    example: "chúc mừng nhân dịp sinh nhật",
  },
  {
    word: "nhân duyên",
    part_of_speech: "danh từ",
    meaning:
      'nguyên nhân có từ kiếp trước tạo ra kết quả ở kiếp sau, theo quan niệm của đạo Phật: "Âu đành quả kiếp nhân duyên, Cũng người một hội, một thuyền đâu xa!" (TKiều)',
    example:
      'Âu đành quả kiếp nhân duyên, Cũng người một hội, một thuyền đâu xa!" (TKiều)',
  },
  {
    word: "nhân duyên",
    part_of_speech: "danh từ",
    meaning: "(cũ) duyên vợ chồng: đường nhân duyên * nhân duyên trắc trở",
    example: "đường nhân duyên * nhân duyên trắc trở",
  },
  {
    word: "nhận diện",
    part_of_speech: "động từ",
    meaning:
      "nhìn để nhận ra, chỉ ra đối tượng đang che giấu tung tích hay đối tượng đang cần tìm: nhận diện hung thủ * nhận diện người trong ảnh",
    example: "nhận diện hung thủ * nhận diện người trong ảnh",
  },
  {
    word: "nhân đạo",
    part_of_speech: "danh từ",
    meaning:
      "đạo đức thể hiện ở sự thương yêu, quý trọng và bảo vệ con người: một hành vi trái với nhân đạo",
    example: "một hành vi trái với nhân đạo",
  },
  {
    word: "nhân đạo",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất thương yêu, quý trọng và vì con người: hiến máu nhân đạo * có lòng nhân đạo * chính sách nhân đạo với tù binh",
    example:
      "hiến máu nhân đạo * có lòng nhân đạo * chính sách nhân đạo với tù binh",
  },
  {
    word: "nhân điện",
    part_of_speech: "danh từ",
    meaning:
      "năng lượng của cơ thể con người, thường nói về mặt có thể dùng để chữa bệnh: chữa bệnh bằng nhân điện",
    example: "chữa bệnh bằng nhân điện",
  },
  {
    word: "nhân gian",
    part_of_speech: "danh từ",
    meaning:
      '(văn chương) cõi đời, nơi loài người đang ở: cõi nhân gian * "Nước trôi hoa rụng đã yên, Hay đâu địa ngục ở miền nhân gian!" (TKiều)',
    example:
      'cõi nhân gian * "Nước trôi hoa rụng đã yên, Hay đâu địa ngục ở miền nhân gian!" (TKiều)',
  },
  {
    word: "nhân đức",
    part_of_speech: "tính từ",
    meaning: "có lòng thương người, ăn ở tốt: con người nhân đức",
    example: "con người nhân đức",
  },
  {
    word: "nhận định",
    part_of_speech: "",
    meaning:
      "đưa ra ý kiến nhận xét, đánh giá, dự đoán về một vấn đề nào đó: nhận định tình hình * một nhận định thiếu cơ sở",
    example: "nhận định tình hình * một nhận định thiếu cơ sở",
  },
  {
    word: "nhân hậu",
    part_of_speech: "tính từ",
    meaning:
      "hiền và giàu lòng thương người, chỉ muốn đem lại những điều tốt lành cho người khác: tấm lòng nhân hậu * sống rất nhân hậu",
    example: "tấm lòng nhân hậu * sống rất nhân hậu",
  },
  {
    word: "nhân khẩu",
    part_of_speech: "danh từ",
    meaning:
      "người trong một gia đình, một địa phương, về mặt số lượng: nhà có 5 nhân khẩu * chia ruộng theo nhân khẩu",
    example: "nhà có 5 nhân khẩu * chia ruộng theo nhân khẩu",
  },
  {
    word: "nhân loại",
    part_of_speech: "danh từ",
    meaning:
      "như loài người: nền văn minh của nhân loại * hạnh phúc của nhân loại",
    example: "nền văn minh của nhân loại * hạnh phúc của nhân loại",
  },
  {
    word: "nhân kiệt",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người tài giỏi, kiệt xuất: địa linh sinh nhân kiệt (đất thiêng sinh người tài giỏi)",
    example: "địa linh sinh nhân kiệt (đất thiêng sinh người tài giỏi)",
  },
  {
    word: "nhận lời",
    part_of_speech: "động từ",
    meaning:
      "đồng ý theo lời yêu cầu hay đề nghị: nhận lời thách đấu * chưa nhận lời yêu ai",
    example: "nhận lời thách đấu * chưa nhận lời yêu ai",
  },
  {
    word: "nhân mãn",
    part_of_speech: "danh từ",
    meaning:
      "tình trạng dân số quá đông tại một khu vực nào đó, so với điều kiện thiên nhiên: nạn nhân mãn",
    example: "nạn nhân mãn",
  },
  {
    word: "nhân lực",
    part_of_speech: "danh từ",
    meaning:
      "sức người, về mặt sử dụng trong lao động sản xuất: nguồn nhân lực * đào tạo nhân lực * tập trung toàn bộ nhân lực cho công việc",
    example:
      "nguồn nhân lực * đào tạo nhân lực * tập trung toàn bộ nhân lực cho công việc",
  },
  {
    word: "nhấn mạnh",
    part_of_speech: "động từ",
    meaning:
      "nêu bật lên, làm nổi hẳn cái được coi là quan trọng để làm cho người khác quan tâm, chú ý hơn: nhấn mạnh tầm quan trọng của vấn đề * những điểm cần nhấn mạnh",
    example: "nhấn mạnh tầm quan trọng của vấn đề * những điểm cần nhấn mạnh",
  },
  {
    word: "nhân mạng",
    part_of_speech: "danh từ",
    meaning:
      "tính mạng con người: tổn thất về nhân mạng * chiến tranh đã cướp đi rất nhiều nhân mạng",
    example:
      "tổn thất về nhân mạng * chiến tranh đã cướp đi rất nhiều nhân mạng",
  },
  {
    word: "nhận mặt",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) như nhận diện: nhận mặt tên gián điệp",
    example: "nhận mặt tên gián điệp",
  },
  {
    word: "nhẫn nại",
    part_of_speech: "tính từ",
    meaning:
      "chịu đựng kiên trì, bền bỉ để làm việc gì: nhẫn nại chờ đợi * biết nhẫn nại, chịu đựng",
    example: "nhẫn nại chờ đợi * biết nhẫn nại, chịu đựng",
  },
  {
    word: "nhẩn nha",
    part_of_speech: "tính từ",
    meaning:
      "(làm việc gì) ung dung, thong thả, tỏ ra không có gì phải vội, không quan tâm về mặt thời gian: đàn bò nhẩn nha gặm cỏ * đạp xe nhẩn nha",
    example: "đàn bò nhẩn nha gặm cỏ * đạp xe nhẩn nha",
  },
  {
    word: "nhân nhẩn",
    part_of_speech: "tính từ",
    meaning: "như nhần nhận (nhưng ít dùng hơn): nhân nhẩn đắng",
    example: "nhân nhẩn đắng",
  },
  {
    word: "nhân nghĩa",
    part_of_speech: "danh từ",
    meaning:
      "lòng thương người và tôn trọng lẽ phải, điều phải: trọng nhân nghĩa",
    example: "trọng nhân nghĩa",
  },
  {
    word: "nhân nghĩa",
    part_of_speech: "tính từ",
    meaning: "có lòng thương người: sống rất nhân nghĩa * việc nhân nghĩa",
    example: "sống rất nhân nghĩa * việc nhân nghĩa",
  },
  {
    word: "nhân ngãi",
    part_of_speech: "danh từ",
    meaning: "(cũ, hoặc ph)",
    example: "già nhân ngãi, non vợ chồng (tng)",
  },
  {
    word: "nhấn nhá",
    part_of_speech: "động từ",
    meaning:
      "(giọng nói, tiếng đàn) phát ra lúc to, lúc nhỏ, lúc dài, lúc ngắn, thường nhằm gây ấn tượng hoặc sự chú ý: giọng nhấn nhá * nhấn nhá tiếng đàn",
    example: "giọng nhấn nhá * nhấn nhá tiếng đàn",
  },
  {
    word: "nhẫn nhịn",
    part_of_speech: "động từ",
    meaning:
      "chịu nhịn, chịu dằn lòng xuống để tránh xung đột: nhẫn nhịn cho gia đình được êm thấm",
    example: "nhẫn nhịn cho gia đình được êm thấm",
  },
  {
    word: "nhân nhượng",
    part_of_speech: "động từ",
    meaning:
      "chịu giảm bớt yêu cầu của mình hoặc chấp nhận thêm đòi hỏi của đối phương nhằm đạt tới một sự thoả thuận: đấu tranh không nhân nhượng",
    example: "đấu tranh không nhân nhượng",
  },
  {
    word: "nhần nhận",
    part_of_speech: "tính từ",
    meaning: "có vị hơi đắng: ngồng cải luộc ăn hơi nhần nhận",
    example: "ngồng cải luộc ăn hơi nhần nhận",
  },
  {
    word: "nhẫn nhục",
    part_of_speech: "động từ",
    meaning:
      "dằn lòng chịu đựng những điều cực nhục để đạt được một mục đích nào đó: nhẫn nhục chịu đựng",
    example: "nhẫn nhục chịu đựng",
  },
  {
    word: "nhân quyền",
    part_of_speech: "danh từ",
    meaning:
      "quyền căn bản của con người, như quyền tự do ngôn luận, tự do tín ngưỡng, tự do đi lại, v.v. (nói khái quát): vi phạm nhân quyền * tôn trọng nhân quyền",
    example: "vi phạm nhân quyền * tôn trọng nhân quyền",
  },
  {
    word: "nhân sinh quan",
    part_of_speech: "danh từ",
    meaning:
      "quan niệm thành hệ thống về cuộc đời, về ý nghĩa và mục đích sống của con người: nhân sinh quan Phật giáo",
    example: "nhân sinh quan Phật giáo",
  },
  {
    word: "nhân sĩ",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người trí thức có danh vọng, có tư tưởng tiến bộ: một nhân sĩ yêu nước",
    example: "một nhân sĩ yêu nước",
  },
  {
    word: "nhân phẩm",
    part_of_speech: "danh từ",
    meaning:
      "phẩm chất và giá trị con người: phục hồi nhân phẩm * mất nhân phẩm",
    example: "phục hồi nhân phẩm * mất nhân phẩm",
  },
  {
    word: "nhân sâm",
    part_of_speech: "danh từ",
    meaning: "cây nhỏ, rễ củ có hình người, dùng làm thuốc bổ: củ nhân sâm",
    example: "củ nhân sâm",
  },
  {
    word: "nhân quả",
    part_of_speech: "danh từ",
    meaning: "nguyên nhân và kết quả (nói khái quát): mối quan hệ nhân quả",
    example: "mối quan hệ nhân quả",
  },
  {
    word: "nhân quả",
    part_of_speech: "danh từ",
    meaning:
      "nguyên nhân có từ kiếp trước tạo ra kết quả ở kiếp sau, và ngược lại kết quả ở kiếp sau là do nguyên nhân từ kiếp trước, theo quan niệm của đạo Phật: thuyết nhân quả",
    example: "thuyết nhân quả",
  },
  {
    word: "nhân tạo",
    part_of_speech: "tính từ",
    meaning:
      "do con người tạo ra, phỏng theo cái có sẵn trong tự nhiên: tơ nhân tạo * hô hấp nhân tạo * thụ tinh nhân tạo",
    example: "tơ nhân tạo * hô hấp nhân tạo * thụ tinh nhân tạo",
  },
  {
    word: "nhân sự",
    part_of_speech: "danh từ",
    meaning:
      "việc thuộc về sự tuyển dụng, bố trí, điều động, quản lí con người trong tổ chức (nói khái quát): quản lí nhân sự * bố trí nhân sự hợp lí",
    example: "quản lí nhân sự * bố trí nhân sự hợp lí",
  },
  {
    word: "nhân sư",
    part_of_speech: "danh từ",
    meaning:
      "quái vật trong thần thoại cổ Hi Lạp, thường được hình dung trong nghệ thuật là có đầu người, mình sư tử (được tạc thành pho tượng đá lớn ở Ai Cập, gần Kim Tự Tháp): tượng nhân sư",
    example: "tượng nhân sư",
  },
  {
    word: "nhân tài",
    part_of_speech: "danh từ",
    meaning:
      "người có tài năng và trí tuệ hơn hẳn mọi người: phát hiện nhân tài * bồi dưỡng nhân tài",
    example: "phát hiện nhân tài * bồi dưỡng nhân tài",
  },
  {
    word: "nhân tâm",
    part_of_speech: "danh từ",
    meaning:
      "lòng người, tình cảm của số đông người đối với những sự việc, những vấn đề chung nào đó: thu phục nhân tâm",
    example: "thu phục nhân tâm",
  },
  {
    word: "nhẫn tâm",
    part_of_speech: "",
    meaning:
      "bằng lòng làm những điều trái với đạo lí, nhân nghĩa mà không chút do dự: nhẫn tâm từ bỏ con cái * con người nhẫn tâm",
    example: "nhẫn tâm từ bỏ con cái * con người nhẫn tâm",
  },
  {
    word: "nhận thức",
    part_of_speech: "danh từ",
    meaning:
      "kết quả của quá trình phản ánh và tái hiện hiện thực vào trong tư duy; kết quả con người nhận biết, hiểu biết thế giới khách quan: nâng cao nhận thức * có nhận thức đúng đắn",
    example: "nâng cao nhận thức * có nhận thức đúng đắn",
  },
  {
    word: "nhận thức",
    part_of_speech: "động từ",
    meaning:
      "nhận ra và biết được, hiểu được: nhận thức được việc mình làm * nhận thức đúng tình hình",
    example: "nhận thức được việc mình làm * nhận thức đúng tình hình",
  },
  {
    word: "nhân thế",
    part_of_speech: "danh từ",
    meaning: "nhân tình thế thái (nói tắt): nỗi sầu nhân thế",
    example: "nỗi sầu nhân thế",
  },
  {
    word: "nhận thực",
    part_of_speech: "động từ",
    meaning:
      "xác nhận chính thức là đúng, là thật để có giá trị pháp lí: nhận thực bản sao bằng tốt nghiệp",
    example: "nhận thực bản sao bằng tốt nghiệp",
  },
  {
    word: "nhân thể",
    part_of_speech: "phụ từ",
    meaning: "(khẩu ngữ) như một thể: chờ tôi một chút rồi cùng về nhân thể",
    example: "chờ tôi một chút rồi cùng về nhân thể",
  },
  {
    word: "nhân thể",
    part_of_speech: "kết từ",
    meaning:
      "như nhân tiện: nhân thể gặp xe thì về luôn * đi chơi, nhân thể gặp cái gì hay thì mua",
    example:
      "nhân thể gặp xe thì về luôn * đi chơi, nhân thể gặp cái gì hay thì mua",
  },
  {
    word: "nhân thân",
    part_of_speech: "danh từ",
    meaning:
      "tổng hợp các đặc điểm về thân thế, cuộc sống và tính cách của một con người, về mặt thi hành pháp luật: tìm hiểu nhân thân người bị hại * nhân thân không rõ ràng",
    example: "tìm hiểu nhân thân người bị hại * nhân thân không rõ ràng",
  },
  {
    word: "nhận thầu",
    part_of_speech: "động từ",
    meaning:
      "nhận thực hiện công việc cho người khác, căn cứ vào các điều kiện đã được thoả thuận trong hợp đồng kí kết giữa hai bên: nhận thầu công trình",
    example: "nhận thầu công trình",
  },
  {
    word: "nhân tiện",
    part_of_speech: "kết từ",
    meaning:
      "(khẩu ngữ) từ biểu thị quan hệ đồng thời giữa hai sự việc, nhân làm hay nhân có việc này thì tiện thể làm luôn việc kia: nhân tiện ra bưu điện, chị bỏ hộ tôi cái thư",
    example: "nhân tiện ra bưu điện, chị bỏ hộ tôi cái thư",
  },
  {
    word: "nhân tình",
    part_of_speech: "danh từ",
    meaning:
      "người có quan hệ yêu đương không chính đáng với người khác, trong quan hệ với người ấy: có nhân tình * bỏ nhà theo nhân tình",
    example: "có nhân tình * bỏ nhà theo nhân tình",
  },
  {
    word: "nhân tình",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) người yêu: "Cô nhân tình bé của tôi ơi!, Tôi muốn môi cô chỉ mỉm cười." (NgBính; 6)',
    example:
      'Cô nhân tình bé của tôi ơi!, Tôi muốn môi cô chỉ mỉm cười." (NgBính; 6)',
  },
  {
    word: "nhân tình",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) tình cảm giữa con người với nhau; tình người (nói khái quát): "Trước đèn xem truyện Tây minh, Gẫm cười hai chữ nhân tình éo le." (LVT)',
    example:
      'Trước đèn xem truyện Tây minh, Gẫm cười hai chữ nhân tình éo le." (LVT)',
  },
  {
    word: "nhân thọ",
    part_of_speech: "danh từ",
    meaning: "tuổi thọ của con người: vấn đề nhân thọ * bảo hiểm nhân thọ",
    example: "vấn đề nhân thọ * bảo hiểm nhân thọ",
  },
  {
    word: "nhân tính",
    part_of_speech: "danh từ",
    meaning:
      "bản tính tốt đẹp của con người: hành vi vô nhân tính * một kẻ mất hết nhân tính",
    example: "hành vi vô nhân tính * một kẻ mất hết nhân tính",
  },
  {
    word: "nhân từ",
    part_of_speech: "tính từ",
    meaning:
      "hiền lành, có lòng thương người: người mẹ nhân từ * vẻ mặt nhân từ",
    example: "người mẹ nhân từ * vẻ mặt nhân từ",
  },
  {
    word: "nhân văn",
    part_of_speech: "tính từ",
    meaning: "thuộc về văn hoá, thuộc về con người: khoa học nhân văn",
    example: "khoa học nhân văn",
  },
  {
    word: "nhân văn",
    part_of_speech: "tính từ",
    meaning:
      "nhân văn chủ nghĩa (nói tắt): tác phẩm mang tính nhân văn sâu sắc * tư tưởng nhân văn",
    example: "tác phẩm mang tính nhân văn sâu sắc * tư tưởng nhân văn",
  },
  {
    word: "nhân tố",
    part_of_speech: "danh từ",
    meaning:
      "yếu tố chủ yếu gây ra, tạo ra cái gì đó: nhân tố văn hoá * nhân tố con người",
    example: "nhân tố văn hoá * nhân tố con người",
  },
  {
    word: "nhân vật",
    part_of_speech: "danh từ",
    meaning:
      "đối tượng (thường là con người) được miêu tả, thể hiện trong tác phẩm văn học, nghệ thuật: nhân vật chính của vở kịch * xây dựng tính cách nhân vật",
    example: "nhân vật chính của vở kịch * xây dựng tính cách nhân vật",
  },
  {
    word: "nhân vật",
    part_of_speech: "danh từ",
    meaning:
      "người có tiếng tăm, có một vai trò nhất định trong xã hội: một nhân vật quan trọng",
    example: "một nhân vật quan trọng",
  },
  {
    word: "nhân viên",
    part_of_speech: "danh từ",
    meaning:
      "người làm việc trong một cơ quan, tổ chức, trong quan hệ với thủ trưởng, lãnh đạo của cơ quan, tổ chức đó: nhân viên kế toán * quan hệ giữa giám đốc và nhân viên",
    example: "nhân viên kế toán * quan hệ giữa giám đốc và nhân viên",
  },
  {
    word: "nhân viên",
    part_of_speech: "danh từ",
    meaning: "ngạch cán bộ cấp thấp nhất: nhân viên đánh máy bậc 2",
    example: "nhân viên đánh máy bậc 2",
  },
  {
    word: "nhận xét",
    part_of_speech: "động từ",
    meaning:
      "đưa ra ý kiến xét đoán, đánh giá về một đối tượng nào đó: nhận xét về tình hình * lời nhận xét",
    example: "nhận xét về tình hình * lời nhận xét",
  },
  {
    word: "nhận xét",
    part_of_speech: "danh từ",
    meaning:
      "lời, điều nhận xét: nêu một vài nhận xét * ghi nhận xét vào học bạ",
    example: "nêu một vài nhận xét * ghi nhận xét vào học bạ",
  },
  {
    word: "nhập cảng",
    part_of_speech: "động từ",
    meaning: "(cũ) như nhập khẩu: hàng nhập cảng",
    example: "hàng nhập cảng",
  },
  {
    word: "nhập cảng",
    part_of_speech: "động từ",
    meaning:
      "(cũ) đưa từ nước ngoài vào cái vốn không có hoặc chưa phát triển ở nước mình; phân biệt với xuất cảng: lối sống nhập cảng * văn hoá nhập cảng",
    example: "lối sống nhập cảng * văn hoá nhập cảng",
  },
  {
    word: "nhâng nháo",
    part_of_speech: "tính từ",
    meaning: "ngông nghênh, vô lễ, không coi ai ra gì: mặt mũi nhâng nháo",
    example: "mặt mũi nhâng nháo",
  },
  {
    word: "nhận vơ",
    part_of_speech: "động từ",
    meaning:
      '(khẩu ngữ) nhận về mình cái biết rõ là không phải của mình: chỉ được cái nhận vơ! * "Dơ sao chả để hết dơ, Thấy người lịch sự nhận vơ làm chồng." (ca dao)',
    example:
      'chỉ được cái nhận vơ! * "Dơ sao chả để hết dơ, Thấy người lịch sự nhận vơ làm chồng." (ca dao)',
  },
  {
    word: "nhấp",
    part_of_speech: "động từ",
    meaning:
      "uống một chút hoặc uống từng chút một bằng cách chỉ hớp ở đầu môi: nhấp thử ngụm rượu",
    example: "nhấp thử ngụm rượu",
  },
  {
    word: "nhấp",
    part_of_speech: "động từ",
    meaning: "như nháy (ng4): nhấp chuột vào biểu tượng * nhấp phím phải chuột",
    example: "nhấp chuột vào biểu tượng * nhấp phím phải chuột",
  },
  {
    word: "nhân vô thập toàn",
    part_of_speech: "",
    meaning:
      "con người ta không ai là hoàn hảo, là hoàn toàn không có khiếm khuyết cả: nhân vô thập toàn, ai mà chẳng có khiếm khuyết!",
    example: "nhân vô thập toàn, ai mà chẳng có khiếm khuyết!",
  },
  {
    word: "nhập",
    part_of_speech: "động từ",
    meaning:
      "đưa vào, nhận vào một nơi để quản lí; phân biệt với xuất: nhập hàng vào kho * nhập tiền vào quỹ * nhập dữ liệu vào máy",
    example: "nhập hàng vào kho * nhập tiền vào quỹ * nhập dữ liệu vào máy",
  },
  {
    word: "nhập",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nhập khẩu (nói tắt): hàng nhập * nhập linh kiện nước ngoài",
    example: "hàng nhập * nhập linh kiện nước ngoài",
  },
  {
    word: "nhập",
    part_of_speech: "động từ",
    meaning:
      "vào, tham gia vào một nhóm, một tổ chức, một cộng đồng với tư cách là một thành viên: nhập hội * nhập vào một băng cướp * nhập hộ khẩu",
    example: "nhập hội * nhập vào một băng cướp * nhập hộ khẩu",
  },
  {
    word: "nhập",
    part_of_speech: "động từ",
    meaning:
      "gộp lại, hợp nhất lại thành một khối, một chỉnh thể: nhập hai khoản làm một * nhập các công ti lại thành tập đoàn",
    example: "nhập hai khoản làm một * nhập các công ti lại thành tập đoàn",
  },
  {
    word: "nhập",
    part_of_speech: "động từ",
    meaning:
      "(linh hồn người chết hay ma quỷ) hiện vào trong một con người hay một vật nào đó, mượn con người hay vật ấy để hiển hiện ra với người đời, theo mê tín: lơ ngơ như bị ma nhập * đầu lắc lư như người nhập đồng",
    example: "lơ ngơ như bị ma nhập * đầu lắc lư như người nhập đồng",
  },
  {
    word: "nhập cư",
    part_of_speech: "động từ",
    meaning:
      "đến ở hẳn một nước khác để sinh sống, nói trong quan hệ với nước khác đó: người Việt nhập cư tại Pháp * nhập cư trái phép",
    example: "người Việt nhập cư tại Pháp * nhập cư trái phép",
  },
  {
    word: "nhập cảnh",
    part_of_speech: "động từ",
    meaning:
      "đi vào lãnh thổ của một nước khác; phân biệt với xuất cảnh: giấy phép nhập cảnh",
    example: "giấy phép nhập cảnh",
  },
  {
    word: "nhập cuộc",
    part_of_speech: "động từ",
    meaning:
      "tham gia vào một hoạt động hay một công việc nào đó: đứng ở ngoài nhìn, chứ không nhập cuộc",
    example: "đứng ở ngoài nhìn, chứ không nhập cuộc",
  },
  {
    word: "nhập cục",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) gộp vào làm một, bất chấp những đặc điểm khác nhau: nhập cục các vấn đề vào một",
    example: "nhập cục các vấn đề vào một",
  },
  {
    word: "nhập đề",
    part_of_speech: "động từ",
    meaning:
      "mở đầu trước khi đi vào phần chính của một vấn đề, một bài viết hay một tác phẩm: câu thơ nhập đề",
    example: "câu thơ nhập đề",
  },
  {
    word: "nhập định",
    part_of_speech: "động từ",
    meaning:
      "ngồi hoàn toàn yên lặng, nhắm mắt, gạt bỏ mọi điều suy nghĩ (một phép tu của người theo đạo Phật): nhà sư ngồi nhập định * tâm thần nhập định",
    example: "nhà sư ngồi nhập định * tâm thần nhập định",
  },
  {
    word: "nhấp giọng",
    part_of_speech: "động từ",
    meaning: "uống một ít nước cho khỏi khô cổ: uống một hớp nước nhấp giọng",
    example: "uống một hớp nước nhấp giọng",
  },
  {
    word: "nhập học",
    part_of_speech: "động từ",
    meaning: "bắt đầu vào học ở trường: ngày nhập học * buổi lễ nhập học",
    example: "ngày nhập học * buổi lễ nhập học",
  },
  {
    word: "nhập ngoại",
    part_of_speech: "động từ",
    meaning:
      "nhập từ nước ngoài vào (thường nói về hàng hoá): thuốc lá nhập ngoại * linh kiện nhập ngoại * công nghệ nhập ngoại",
    example:
      "thuốc lá nhập ngoại * linh kiện nhập ngoại * công nghệ nhập ngoại",
  },
  {
    word: "nhập khẩu",
    part_of_speech: "động từ",
    meaning:
      "đưa hàng hoá hay tư bản của nước ngoài vào nước mình; phân việt với xuất khẩu: hàng nhập khẩu * thuế nhập khẩu",
    example: "hàng nhập khẩu * thuế nhập khẩu",
  },
  {
    word: "nhập môn",
    part_of_speech: "động từ",
    meaning:
      "(cũ) bắt đầu trở thành học trò (của thầy hoặc của trường nào đó): lễ nhập môn",
    example: "lễ nhập môn",
  },
  {
    word: "nhập môn",
    part_of_speech: "động từ",
    meaning: "mở đầu vào một môn học: phần nhập môn * nhập môn ngôn ngữ học",
    example: "phần nhập môn * nhập môn ngôn ngữ học",
  },
  {
    word: "nhập ngũ",
    part_of_speech: "động từ",
    meaning: "vào quân đội: lên đường nhập ngũ",
    example: "lên đường nhập ngũ",
  },
  {
    word: "nhấp nhem",
    part_of_speech: "tính từ",
    meaning:
      "khi sáng khi tối, lúc tỏ lúc mờ, không sáng rõ: ánh đuốc nhấp nhem",
    example: "ánh đuốc nhấp nhem",
  },
  {
    word: "nhập nhằng",
    part_of_speech: "động từ",
    meaning:
      "cố ý làm cho thành không rành mạch, rõ ràng giữa cái nọ với cái kia để dễ bề gian lận: nhập nhằng giữa công với tư * tiền nong phải sòng phẳng, không nên nhập nhằng",
    example:
      "nhập nhằng giữa công với tư * tiền nong phải sòng phẳng, không nên nhập nhằng",
  },
  {
    word: "nhập nhằng",
    part_of_speech: "tính từ",
    meaning:
      "ở tình trạng đang còn chưa rõ là thế này hay thế kia: ranh giới nhập nhằng * mối quan hệ nhập nhằng",
    example: "ranh giới nhập nhằng * mối quan hệ nhập nhằng",
  },
  {
    word: "nhấp nháng",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như nhấp nhoáng: ánh đèn nhấp nháng",
    example: "ánh đèn nhấp nháng",
  },
  {
    word: "nhấp nháy",
    part_of_speech: "động từ",
    meaning:
      "(mắt) mở ra, nhắm lại liên tiếp: bà cụ nhấp nháy hai con mắt nhìn đứa cháu",
    example: "bà cụ nhấp nháy hai con mắt nhìn đứa cháu",
  },
  {
    word: "nhấp nháy",
    part_of_speech: "động từ",
    meaning:
      "loé sáng rồi tắt ngay, một cách liên tiếp: đốm sáng nhấp nháy * ánh đèn pin nhấp nháy",
    example: "đốm sáng nhấp nháy * ánh đèn pin nhấp nháy",
  },
  {
    word: "nhập nhèm",
    part_of_speech: "tính từ",
    meaning:
      "không sáng, nửa tỏ nửa mờ, khó nhìn thấy rõ: ánh sáng nhập nhèm * mắt nhập nhèm",
    example: "ánh sáng nhập nhèm * mắt nhập nhèm",
  },
  {
    word: "nhập nhèm",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) như nhập nhằng: làm ăn nhập nhèm * nhập nhèm giữa công với tư",
    example: "làm ăn nhập nhèm * nhập nhèm giữa công với tư",
  },
  {
    word: "nhập nhoà",
    part_of_speech: "tính từ",
    meaning:
      "lúc nhìn thấy rõ, lúc mờ mờ: trời nhập nhoà, tranh tối tranh sáng * ánh sáng nhập nhoà",
    example: "trời nhập nhoà, tranh tối tranh sáng * ánh sáng nhập nhoà",
  },
  {
    word: "nhấp nhứ",
    part_of_speech: "động từ",
    meaning: "(hiếm) như dấm dứ: nhấp nhứ mấy lần định nói nhưng lại thôi",
    example: "nhấp nhứ mấy lần định nói nhưng lại thôi",
  },
  {
    word: "nhập nhoạng",
    part_of_speech: "tính từ",
    meaning: "chưa tối hẳn, vẫn còn sáng nhờ nhờ: trời nhập nhoạng tối",
    example: "trời nhập nhoạng tối",
  },
  {
    word: "nhấp nhô",
    part_of_speech: "",
    meaning:
      "nhô lên thụt xuống một cách liên tiếp: đồi núi nhấp nhô * con thuyền nhấp nhô trên sóng",
    example: "đồi núi nhấp nhô * con thuyền nhấp nhô trên sóng",
  },
  {
    word: "nhấp nhổm",
    part_of_speech: "tính từ",
    meaning:
      "không yên lòng, tỏ ra sốt ruột, hết đứng lên lại ngồi xuống, chỉ muốn đi: nhấp nhổm đứng dậy * nhấp nhổm muốn đi",
    example: "nhấp nhổm đứng dậy * nhấp nhổm muốn đi",
  },
  {
    word: "nhập nội",
    part_of_speech: "động từ",
    meaning:
      "đưa từ nước ngoài vào (thường là sinh vật): giống lúa nhập nội * gà nhập nội",
    example: "giống lúa nhập nội * gà nhập nội",
  },
  {
    word: "nhập siêu",
    part_of_speech: "danh từ",
    meaning:
      "tình trạng kim ngạch nhập khẩu lớn hơn kim ngạch xuất khẩu trong cán cân thương mại của một nước; phân biệt với xuất siêu: tỉ lệ nhập siêu cao * hạn chế nhập siêu",
    example: "tỉ lệ nhập siêu cao * hạn chế nhập siêu",
  },
  {
    word: "nhập quan",
    part_of_speech: "động từ",
    meaning:
      "đặt xác người chết vào quan tài theo nghi thức: giờ nhập quan * làm lễ nhập quan",
    example: "giờ nhập quan * làm lễ nhập quan",
  },
  {
    word: "nhập tịch",
    part_of_speech: "động từ",
    meaning:
      "nhập vào làm dân một nơi khác: làm thủ tục nhập tịch * đến nhập tịch làm dân xứ này",
    example: "làm thủ tục nhập tịch * đến nhập tịch làm dân xứ này",
  },
  {
    word: "nhập tâm",
    part_of_speech: "động từ",
    meaning: "nhớ rất rõ, rất kĩ, như khắc sâu trong lòng: thuộc nhập tâm",
    example: "thuộc nhập tâm",
  },
  {
    word: "nhập thế",
    part_of_speech: "động từ",
    meaning:
      "tham dự vào để gánh vác việc đời (thường là ra làm quan), không xa lánh cõi đời, không đi ở ẩn, theo quan niệm của nho giáo: một nhà nho nhập thế * tư tưởng nhập thế",
    example: "một nhà nho nhập thế * tư tưởng nhập thế",
  },
  {
    word: "nhập tràng",
    part_of_speech: "động từ",
    meaning:
      "(ma quỷ) nhập vào thây người chết làm cho cái thây đó biết đi lại, nói năng như người sống, theo mê tín: quỷ nhập tràng",
    example: "quỷ nhập tràng",
  },
  {
    word: "nhập viện",
    part_of_speech: "động từ",
    meaning:
      "vào ở tại bệnh viện để chữa bệnh; phân biệt với xuất viện: ốm nên phải nhập viện * thủ tục nhập viện",
    example: "ốm nên phải nhập viện * thủ tục nhập viện",
  },
  {
    word: "nhập trường",
    part_of_speech: "động từ",
    meaning:
      "vào trường, tập trung ở trường để bắt đầu một khoá học: giấy báo nhập trường",
    example: "giấy báo nhập trường",
  },
  {
    word: "nhập vai",
    part_of_speech: "",
    meaning:
      "(diễn viên) tự đặt mình vào hoàn cảnh của nhân vật và diễn xuất hết sức tự nhiên, như không còn ranh giới giữa người diễn và vai diễn: diễn rất nhập vai",
    example: "diễn rất nhập vai",
  },
  {
    word: "nhất",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) một: quần áo chỉ có nhất bộ * con gái chỉ có nhất thì",
    example: "quần áo chỉ có nhất bộ * con gái chỉ có nhất thì",
  },
  {
    word: "nhất",
    part_of_speech: "tính từ",
    meaning:
      "ở vị trí cao nhất trong thứ tự xếp hạng: xếp thứ nhất * đoạt giải nhất * về nhất trong cuộc thi chạy",
    example: "xếp thứ nhất * đoạt giải nhất * về nhất trong cuộc thi chạy",
  },
  {
    word: "nhất",
    part_of_speech: "phụ từ",
    meaning:
      "đến mức hơn tất cả trong phạm vi được so sánh hay được nói đến: đẹp nhất vùng * phương pháp tối ưu nhất * cần nhất là sức khoẻ",
    example: "đẹp nhất vùng * phương pháp tối ưu nhất * cần nhất là sức khoẻ",
  },
  {
    word: "nhất cử nhất động",
    part_of_speech: "",
    meaning:
      "mỗi một cử chỉ, hành động dù là nhỏ nhất: nhất cử nhất động đều bị theo dõi",
    example: "nhất cử nhất động đều bị theo dõi",
  },
  {
    word: "nhất định",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị ý khẳng định chắc chắn, không thể nào khác được: nhất định anh ấy sẽ về * nhất định chúng ta sẽ thắng",
    example: "nhất định anh ấy sẽ về * nhất định chúng ta sẽ thắng",
  },
  {
    word: "nhất định",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị ý dứt khoát, không thay đổi ý định: nhất định không chịu nhận * nói thế nào cũng nhất định không nghe",
    example:
      "nhất định không chịu nhận * nói thế nào cũng nhất định không nghe",
  },
  {
    word: "nhất định",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất xác định, trong một tương quan nào đó: hẹn gặp ở một điểm nhất định * tuân thủ theo những nội quy nhất định",
    example:
      "hẹn gặp ở một điểm nhất định * tuân thủ theo những nội quy nhất định",
  },
  {
    word: "nhất định",
    part_of_speech: "tính từ",
    meaning:
      "ở một mức tuy không cao, nhưng cũng tương đối, vừa phải, theo sự đánh giá của người nói: có một số kinh nghiệm nhất định",
    example: "có một số kinh nghiệm nhất định",
  },
  {
    word: "nhật báo",
    part_of_speech: "danh từ",
    meaning: "báo ra hằng ngày (chỉ nói báo viết): tờ nhật báo",
    example: "tờ nhật báo",
  },
  {
    word: "nhất hạng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) thuộc về hạng nhất: chè nhất hạng * loại ruộng nhất hạng",
    example: "chè nhất hạng * loại ruộng nhất hạng",
  },
  {
    word: "nhất hô bá ứng",
    part_of_speech: "",
    meaning: "(cũ) có uy quyền: quyền cao chức trọng, nhất hô bá ứng",
    example: "quyền cao chức trọng, nhất hô bá ứng",
  },
  {
    word: "nhất hô bá ứng",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) trên dưới một lòng, đoàn kết nhất trí: nhất hô bá ứng, người người đều hưởng ứng làm theo",
    example: "nhất hô bá ứng, người người đều hưởng ứng làm theo",
  },
  {
    word: "nhất loạt",
    part_of_speech: "phụ từ",
    meaning:
      "tất cả đều như vậy, không có sự khác biệt: dùng nhất loạt một loại nguyên liệu",
    example: "dùng nhất loạt một loại nguyên liệu",
  },
  {
    word: "nhất loạt",
    part_of_speech: "phụ từ",
    meaning:
      "cùng một lúc (bắt đầu làm việc gì đó): cả lớp nhất loạt đứng dậy * các mặt hàng đều nhất loạt tăng giá",
    example: "cả lớp nhất loạt đứng dậy * các mặt hàng đều nhất loạt tăng giá",
  },
  {
    word: "nhật ký",
    part_of_speech: "danh từ",
    meaning:
      "những điều ghi chép hằng ngày (nói tổng quát): nhật kí công tác * nhật kí hành trình chuyến thám hiểm * quyển nhật kí",
    example:
      "nhật kí công tác * nhật kí hành trình chuyến thám hiểm * quyển nhật kí",
  },
  {
    word: "nhật ký",
    part_of_speech: "danh từ",
    meaning:
      "thể văn ghi theo thứ tự thời gian những sự kiện xảy ra và những cảm nghĩ hằng ngày của người ghi: viết nhật kí * nhật kí bằng thơ",
    example: "viết nhật kí * nhật kí bằng thơ",
  },
  {
    word: "nhật kí",
    part_of_speech: "danh từ",
    meaning:
      "những điều ghi chép hằng ngày (nói tổng quát): nhật kí công tác * nhật kí hành trình chuyến thám hiểm * quyển nhật kí",
    example:
      "nhật kí công tác * nhật kí hành trình chuyến thám hiểm * quyển nhật kí",
  },
  {
    word: "nhật kí",
    part_of_speech: "danh từ",
    meaning:
      "thể văn ghi theo thứ tự thời gian những sự kiện xảy ra và những cảm nghĩ hằng ngày của người ghi: viết nhật kí * nhật kí bằng thơ",
    example: "viết nhật kí * nhật kí bằng thơ",
  },
  {
    word: "nhất là",
    part_of_speech: "",
    meaning:
      "tổ hợp biểu thị ý nhấn mạnh cái được coi là ở hàng đầu hoặc quan trọng nhất so với tất cả những cái khác trong phạm vi được nói đến: bài viết rất hay, nhất là ở đoạn cuối",
    example: "bài viết rất hay, nhất là ở đoạn cuối",
  },
  {
    word: "nhật nguyệt",
    part_of_speech: "danh từ",
    meaning: "(cũ, văn chương) mặt trời và mặt trăng: đôi vầng nhật nguyệt",
    example: "đôi vầng nhật nguyệt",
  },
  {
    word: "nhất mực",
    part_of_speech: "phụ từ",
    meaning: "(khẩu ngữ) như một mực: mời thế nào cũng nhất mực từ chối",
    example: "mời thế nào cũng nhất mực từ chối",
  },
  {
    word: "nhất mực",
    part_of_speech: "phụ từ",
    meaning: "như rất mực: nhất mực yêu thương con cái",
    example: "nhất mực yêu thương con cái",
  },
  {
    word: "nhất phẩm",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) phẩm trật cao nhất trong thang cấp bậc quan lại: quan nhất phẩm * nhất phẩm phu nhân",
    example: "quan nhất phẩm * nhất phẩm phu nhân",
  },
  {
    word: "nhất nhất",
    part_of_speech: "phụ từ",
    meaning:
      "tất cả đều như nhau, không có sự khác biệt, không có ngoại lệ: mọi người nhất nhất phải tuân theo pháp luật",
    example: "mọi người nhất nhất phải tuân theo pháp luật",
  },
  {
    word: "nhất nhất",
    part_of_speech: "phụ từ",
    meaning: "(hiếm) như nhất mực (ng1): nhất nhất tin là mình sẽ thắng",
    example: "nhất nhất tin là mình sẽ thắng",
  },
  {
    word: "nhất quyết",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) quyết định dứt khoát: việc đó tôi đã nhất quyết rồi * nhất quyết là mai sẽ xong",
    example: "việc đó tôi đã nhất quyết rồi * nhất quyết là mai sẽ xong",
  },
  {
    word: "nhất quyết",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) như nhất định (ng2; nhưng nghĩa mạnh hơn): nói thế nào cũng nhất quyết không nghe",
    example: "nói thế nào cũng nhất quyết không nghe",
  },
  {
    word: "nhất tề",
    part_of_speech: "phụ từ",
    meaning:
      "(nhiều người) đồng loạt bắt đầu làm việc gì đó cùng một lúc, có sự phối hợp ăn ý: mọi người nhất tề hưởng ứng * nơi nơi nhất tề nổi dậy",
    example: "mọi người nhất tề hưởng ứng * nơi nơi nhất tề nổi dậy",
  },
  {
    word: "nhất thành bất biến",
    part_of_speech: "",
    meaning:
      "đã hình thành rồi thì giữ nguyên, không thay đổi, không đổi mới: văn hoá không phải là nhất thành bất biến mà luôn luôn phát triển",
    example:
      "văn hoá không phải là nhất thành bất biến mà luôn luôn phát triển",
  },
  {
    word: "nhất thể hoá",
    part_of_speech: "động từ",
    meaning:
      "làm cho trở thành một thể thống nhất: nhất thể hoá các nền kinh tế * tiến trình nhất thể hoá khu vực",
    example: "nhất thể hoá các nền kinh tế * tiến trình nhất thể hoá khu vực",
  },
  {
    word: "nhất quán",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất thống nhất từ đầu đến cuối, trước sau không trái ngược, không mâu thuẫn nhau: giải quyết nhất quán các trường hợp * tư tưởng thiếu nhất quán",
    example: "giải quyết nhất quán các trường hợp * tư tưởng thiếu nhất quán",
  },
  {
    word: "nhất thiết",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị ý dứt khoát phải như thế, không thể khác được: ngày mai nhất thiết phải xong * kẻ nào làm trái, nhất thiết xử theo quân pháp",
    example:
      "ngày mai nhất thiết phải xong * kẻ nào làm trái, nhất thiết xử theo quân pháp",
  },
  {
    word: "nhất thiết",
    part_of_speech: "phụ từ",
    meaning: "(hiếm) như nhất định (ng2): nhất thiết từ chối",
    example: "nhất thiết từ chối",
  },
  {
    word: "nhật thực",
    part_of_speech: "danh từ",
    meaning:
      "hiện tượng mắt ta thấy vầng Mặt Trời bị tối đi một phần hoặc hoàn toàn trong một lúc vì bị Mặt Trăng che khuất: hiện tượng nhật thực",
    example: "hiện tượng nhật thực",
  },
  {
    word: "nhâu",
    part_of_speech: "động từ",
    meaning:
      "châu vào, xúm vào (hàm ý chê hoặc khinh): đàn chó nhâu ra sủa * thấy người sang là nhâu vào nịnh hót",
    example: "đàn chó nhâu ra sủa * thấy người sang là nhâu vào nịnh hót",
  },
  {
    word: "nhất trí",
    part_of_speech: "",
    meaning:
      "cùng thống nhất về ý kiến, quan điểm, không mâu thuẫn nhau: đồng tâm nhất trí * mọi người đều nhất trí tán thành",
    example: "đồng tâm nhất trí * mọi người đều nhất trí tán thành",
  },
  {
    word: "nhật tụng",
    part_of_speech: "tính từ",
    meaning: "(kinh) đọc hằng ngày: kinh nhật tụng",
    example: "kinh nhật tụng",
  },
  {
    word: "nhậu",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ, khẩu ngữ) uống rượu, bia với các thức nhắm đi kèm: đi nhậu * nhậu lai rai",
    example: "đi nhậu * nhậu lai rai",
  },
  {
    word: "nhất thời",
    part_of_speech: "tính từ",
    meaning:
      "chỉ có trong khoảng thời gian ngắn nào đó, không lâu dài: giải pháp nhất thời",
    example: "giải pháp nhất thời",
  },
  {
    word: "nhầy",
    part_of_speech: "tính từ",
    meaning:
      "nhờn và hơi dính, gây cảm giác ghê, bẩn: chất nhầy * tay nhầy những mỡ * mũi dãi nhầy nhầy",
    example: "chất nhầy * tay nhầy những mỡ * mũi dãi nhầy nhầy",
  },
  {
    word: "nhây",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ, khẩu ngữ) (làm việc gì) kéo dài lâu, không chịu dứt: có tật nói nhây",
    example: "có tật nói nhây",
  },
  {
    word: "nhầu nhĩ",
    part_of_speech: "tính từ",
    meaning: "(mặt) có nhiều nếp nhăn: gương mặt nhầu nhĩ",
    example: "gương mặt nhầu nhĩ",
  },
  {
    word: "nhậu nhẹt",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ, khẩu ngữ) nhậu (nói khái quát; hàm ý chê): nhậu nhẹt say sưa",
    example: "nhậu nhẹt say sưa",
  },
  {
    word: "nhẩy",
    part_of_speech: "trợ từ",
    meaning: "(phương ngữ, khẩu ngữ) nhỉ: thằng này cũng gớm nhẩy!",
    example: "thằng này cũng gớm nhẩy!",
  },
  {
    word: "nhẫy",
    part_of_speech: "tính từ",
    meaning:
      "bóng láng như có dầu, mỡ bôi lên trên: trán nhẫy mồ hôi * đầu chải bóng nhẫy",
    example: "trán nhẫy mồ hôi * đầu chải bóng nhẫy",
  },
  {
    word: "nhậy",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) nhạy: bật lửa rất nhậy",
    example: "bật lửa rất nhậy",
  },
  {
    word: "nhây nhớt",
    part_of_speech: "tính từ",
    meaning:
      "nhớt nhát và bẩn thỉu: đờm dãi nhây nhớt * chân nhây nhớt bùn đất",
    example: "đờm dãi nhây nhớt * chân nhây nhớt bùn đất",
  },
  {
    word: "nhầy nhụa",
    part_of_speech: "tính từ",
    meaning:
      "dính ướt và bẩn thỉu, gây cảm giác ghê tởm: mũi dãi nhầy nhụa * tay nhầy nhụa máu",
    example: "mũi dãi nhầy nhụa * tay nhầy nhụa máu",
  },
  {
    word: "nhé",
    part_of_speech: "trợ từ",
    meaning:
      "(khẩu ngữ) từ biểu thị ý nhấn mạnh một cách thân mật để người đối thoại chú ý đến lời nói của mình: chào nhé! * đến đó, tha hồ chơi nhé! * hôm qua, vui lắm nhé!",
    example: "chào nhé! * đến đó, tha hồ chơi nhé! * hôm qua, vui lắm nhé!",
  },
  {
    word: "nhé",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý nhấn mạnh vào lời đề nghị, dặn dò, bảo ban, giao hẹn, một cách thân mật: uống trà nhé! * để tôi giúp chị một tay nhé! * cẩn thận nhé!",
    example: "uống trà nhé! * để tôi giúp chị một tay nhé! * cẩn thận nhé!",
  },
  {
    word: "nhé",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý nhấn mạnh vào lời đe nẹt hoặc mỉa mai một cách nhẹ nhàng: đừng hòng nhé! * liệu hồn đấy nhé!",
    example: "đừng hòng nhé! * liệu hồn đấy nhé!",
  },
  {
    word: "nhe",
    part_of_speech: "động từ",
    meaning:
      "chành môi để lộ răng hoặc lợi ra: nhe răng ra cười * cười nhe cả lợi",
    example: "nhe răng ra cười * cười nhe cả lợi",
  },
  {
    word: "nhẹ",
    part_of_speech: "tính từ",
    meaning:
      'có trọng lượng nhỏ hơn mức bình thường hoặc so với trọng lượng của vật khác: người nhẹ cân * "Nhẹ như bấc, nặng như chì, Gỡ cho ra nữa còn gì là duyên!" (TKiều)',
    example:
      'người nhẹ cân * "Nhẹ như bấc, nặng như chì, Gỡ cho ra nữa còn gì là duyên!" (TKiều)',
  },
  {
    word: "nhẹ",
    part_of_speech: "tính từ",
    meaning:
      "có tỉ trọng nhỏ: kim loại nhẹ * xăng là chất lỏng nhẹ * mỡ nhẹ hơn nước",
    example: "kim loại nhẹ * xăng là chất lỏng nhẹ * mỡ nhẹ hơn nước",
  },
  {
    word: "nhẹ",
    part_of_speech: "tính từ",
    meaning:
      "có sức tác động yếu, cường độ hoạt động thấp: gió nhẹ * mưa nhẹ hạt * trận động đất nhẹ * hơi thở rất nhẹ",
    example: "gió nhẹ * mưa nhẹ hạt * trận động đất nhẹ * hơi thở rất nhẹ",
  },
  {
    word: "nhẹ",
    part_of_speech: "tính từ",
    meaning:
      "không gây cảm giác nặng nề, khó chịu cho cơ thể hoặc tinh thần: ăn thức ăn nhẹ * rượu nhẹ * người yếu nên làm việc nhẹ",
    example: "ăn thức ăn nhẹ * rượu nhẹ * người yếu nên làm việc nhẹ",
  },
  {
    word: "nhẹ",
    part_of_speech: "tính từ",
    meaning:
      "ở mức độ thấp, không nghiêm trọng, không gây hậu quả tai hại: ốm nhẹ * bị thương nhẹ * máy bị hỏng nhẹ",
    example: "ốm nhẹ * bị thương nhẹ * máy bị hỏng nhẹ",
  },
  {
    word: "nhẹ",
    part_of_speech: "tính từ",
    meaning:
      "gồm những thành phần giản tiện, không phức tạp, không cồng kềnh: bữa liên hoan nhẹ * trang bị vũ khí nhẹ * hành trang gọn nhẹ",
    example: "bữa liên hoan nhẹ * trang bị vũ khí nhẹ * hành trang gọn nhẹ",
  },
  {
    word: "nhẹ",
    part_of_speech: "tính từ",
    meaning: "(đất) có pha cát, tơi xốp, cày cuốc dễ: cày ruộng nhẹ",
    example: "cày ruộng nhẹ",
  },
  {
    word: "nhẹ",
    part_of_speech: "tính từ",
    meaning:
      "có tác động êm dịu, gây cảm giác dễ chịu: mùi thơm nhẹ * màu vàng nhẹ * giọng nói nhẹ và êm",
    example: "mùi thơm nhẹ * màu vàng nhẹ * giọng nói nhẹ và êm",
  },
  {
    word: "nhẹ",
    part_of_speech: "tính từ",
    meaning:
      "có cảm giác thanh thoát, thoải mái như vừa trút được gánh nặng: trả xong nợ, nhẹ cả người * nói ra được, lòng nhẹ lâng lâng",
    example: "trả xong nợ, nhẹ cả người * nói ra được, lòng nhẹ lâng lâng",
  },
  {
    word: "nhẹ",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra ít chú ý, không coi trọng (trong khi coi trọng cái khác, phần khác hơn): nặng về hình thức, nhẹ về nội dung * xem nhẹ hiểm nguy",
    example: "nặng về hình thức, nhẹ về nội dung * xem nhẹ hiểm nguy",
  },
  {
    word: "nhè",
    part_of_speech: "động từ",
    meaning: "đẩy ra khỏi miệng bằng lưỡi: nhè cơm ra khỏi miệng",
    example: "nhè cơm ra khỏi miệng",
  },
  {
    word: "nhè",
    part_of_speech: "động từ",
    meaning:
      "hờn khóc hoặc nói kéo dài giọng một cách khó chịu: khóc nhè * nhè mồm ra khóc",
    example: "khóc nhè * nhè mồm ra khóc",
  },
  {
    word: "nhè",
    part_of_speech: "động từ",
    meaning: "nhằm vào (chỗ yếu, chỗ bất lợi của người khác): nhè bụng mà đánh",
    example: "nhè bụng mà đánh",
  },
  {
    word: "nhẹ bỗng",
    part_of_speech: "tính từ",
    meaning:
      "nhẹ đến mức gây cảm giác như không có trọng lượng, dễ dàng nhấc lên cao: cái túi nhẹ bỗng * trả được nợ, thấy nhẹ bỗng cả người",
    example: "cái túi nhẹ bỗng * trả được nợ, thấy nhẹ bỗng cả người",
  },
  {
    word: "nhẹ hẫng",
    part_of_speech: "tính từ",
    meaning:
      "nhẹ đến mức gây cảm giác như bị hẫng đi vì không còn trọng lượng như trước: chiếc va li nhẹ hẫng",
    example: "chiếc va li nhẹ hẫng",
  },
  {
    word: "nhẹ dạ",
    part_of_speech: "tính từ",
    meaning:
      "dễ tin người, thiếu chín chắn nên thường dễ bị mắc lừa: nhẹ dạ cả tin * nhẹ dạ nên dễ bị lừa",
    example: "nhẹ dạ cả tin * nhẹ dạ nên dễ bị lừa",
  },
  {
    word: "nhẹ gánh",
    part_of_speech: "tính từ",
    meaning:
      "nhẹ bớt đi, giảm được đi phần nào trách nhiệm, công việc nặng nề, khó khăn: trả xong được nợ là nhẹ gánh",
    example: "trả xong được nợ là nhẹ gánh",
  },
  {
    word: "nhè nhẹ",
    part_of_speech: "tính từ",
    meaning: "hơi nhẹ: gió thổi nhè nhẹ",
    example: "gió thổi nhè nhẹ",
  },
  {
    word: "nhẹ kí",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có sức mạnh không đáng kể, không đáng phải lưu ý: đối thủ nhẹ kí",
    example: "đối thủ nhẹ kí",
  },
  {
    word: "nhẹ lời",
    part_of_speech: "tính từ",
    meaning:
      "có cách nói năng nhẹ nhàng khi trách cứ hay khuyên bảo: nhẹ lời khuyên bảo",
    example: "nhẹ lời khuyên bảo",
  },
  {
    word: "nhẹ nhõm",
    part_of_speech: "tính từ",
    meaning:
      "có hình dáng, đường nét thanh thoát, tạo cảm giác ưa nhìn: mặt mũi nhẹ nhõm",
    example: "mặt mũi nhẹ nhõm",
  },
  {
    word: "nhẹ nhõm",
    part_of_speech: "tính từ",
    meaning:
      "có cảm giác thanh thản, khoan khoái, không còn bị vướng bận, bị đè nặng: thở phào nhẹ nhõm * trong lòng nhẹ nhõm",
    example: "thở phào nhẹ nhõm * trong lòng nhẹ nhõm",
  },
  {
    word: "nhẹ nhàng",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất nhẹ, không gây cảm giác gì nặng nề hoặc khó chịu: công việc nhẹ nhàng * hương thơm nhẹ nhàng * nhẹ nhàng đứng dậy",
    example: "công việc nhẹ nhàng * hương thơm nhẹ nhàng * nhẹ nhàng đứng dậy",
  },
  {
    word: "nhẹ nhàng",
    part_of_speech: "tính từ",
    meaning:
      "có cảm giác khoan khoái, dễ chịu vì không vướng bận gì: tâm hồn nhẹ nhàng, khoan khoái",
    example: "tâm hồn nhẹ nhàng, khoan khoái",
  },
  {
    word: "nhẹ nợ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có được cảm giác nhẹ nhàng, thoải mái trong lòng như vừa trút bỏ được một món nợ, một gánh nặng: bỏ quách đi cho nhẹ nợ!",
    example: "bỏ quách đi cho nhẹ nợ!",
  },
  {
    word: "nhẹ tênh",
    part_of_speech: "tính từ",
    meaning: "nhẹ đến mức cảm thấy như không có gì: lòng nhẹ tênh",
    example: "lòng nhẹ tênh",
  },
  {
    word: "nhẹm",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) rất kín, không để lộ ra: giấu nhẹm lá thư đi, không để ai biết",
    example: "giấu nhẹm lá thư đi, không để ai biết",
  },
  {
    word: "nhèm",
    part_of_speech: "tính từ",
    meaning: "ướt dinh dính và bẩn: quần áo ướt nhèm * mặt mũi đen nhèm",
    example: "quần áo ướt nhèm * mặt mũi đen nhèm",
  },
  {
    word: "nhẹ tay",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) nhẹ nhàng, cẩn thận khi cầm, giữ, đụng chạm đến vật nào đó, để khỏi vỡ, khỏi hỏng: nhẹ tay kẻo vỡ",
    example: "nhẹ tay kẻo vỡ",
  },
  {
    word: "nhẹ tay",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) có sự nương nhẹ trong đối xử, trong sự trừng phạt: tội này phải xử nặng, không thể nhẹ tay được",
    example: "tội này phải xử nặng, không thể nhẹ tay được",
  },
  {
    word: "nhem nhuốc",
    part_of_speech: "tính từ",
    meaning:
      "(người, quần áo) bị dây bẩn nhiều chỗ: quần áo nhem nhuốc dầu mỡ * mặt mày nhem nhuốc",
    example: "quần áo nhem nhuốc dầu mỡ * mặt mày nhem nhuốc",
  },
  {
    word: "nhem nhép",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng như tiếng bước chân giẫm vào chất ướt và nhão: tiếng chân lội nhem nhép trên con đường lầy",
    example: "tiếng chân lội nhem nhép trên con đường lầy",
  },
  {
    word: "nhem thèm",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) làm cho thèm bằng cách đưa ra cho trông thấy thức ăn nhưng không cho ăn: con bé đưa miếng bánh ra nhem thèm em",
    example: "con bé đưa miếng bánh ra nhem thèm em",
  },
  {
    word: "nhen nhúm",
    part_of_speech: "động từ",
    meaning: "nhen (nói khái quát): nhen nhóm tia hi vọng",
    example: "nhen nhóm tia hi vọng",
  },
  {
    word: "nheo",
    part_of_speech: "động từ",
    meaning: "(mắt) hơi nhíu lại: mắt nheo lại vì chói * nheo mắt cười tít",
    example: "mắt nheo lại vì chói * nheo mắt cười tít",
  },
  {
    word: "nhéo",
    part_of_speech: "động từ",
    meaning: "(Phương ngữ) véo: nhéo một cái rõ đau",
    example: "nhéo một cái rõ đau",
  },
  {
    word: "nhen nhóm",
    part_of_speech: "động từ",
    meaning: "nhen (nói khái quát): nhen nhóm tia hi vọng",
    example: "nhen nhóm tia hi vọng",
  },
  {
    word: "nhen",
    part_of_speech: "động từ",
    meaning:
      "như nhóm (nhưng thường dùng với nghĩa bóng): nhen bếp nấu cơm * trong lòng nhen lên niềm hi vọng",
    example: "nhen bếp nấu cơm * trong lòng nhen lên niềm hi vọng",
  },
  {
    word: "nhèo nhẹo",
    part_of_speech: "",
    meaning:
      "(trẻ con) quấy khóc dai dẳng, gây khó chịu: khóc nhèo nhẹo cả ngày",
    example: "khóc nhèo nhẹo cả ngày",
  },
  {
    word: "nhẽo",
    part_of_speech: "tính từ",
    meaning:
      "(bắp thịt, da thịt) mềm nhão cả ra, mất hết sức co dãn: bắp thịt nhẽo",
    example: "bắp thịt nhẽo",
  },
  {
    word: "nheo nhéo",
    part_of_speech: "động từ",
    meaning:
      "từ gợi tả tiếng gọi, hỏi liên tiếp, gây cảm giác khó chịu: gọi nheo nhéo * nheo nhéo như mõ réo quan viên (tng)",
    example: "gọi nheo nhéo * nheo nhéo như mõ réo quan viên (tng)",
  },
  {
    word: "nhẽo nhèo",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như nhẽo (nhưng nghĩa mạnh hơn): da thịt nhẽo nhèo",
    example: "da thịt nhẽo nhèo",
  },
  {
    word: "nhèo nhẽo",
    part_of_speech: "tính từ",
    meaning: "(bắp thịt, da thịt) hơi nhẽo: bắp thịt mềm nhèo nhẽo",
    example: "bắp thịt mềm nhèo nhẽo",
  },
  {
    word: "nheo nhóc",
    part_of_speech: "tính từ",
    meaning:
      "(trẻ em) ở tình trạng sống thiếu thốn, không được chăm sóc nên trông nhếch nhác, gầy còm, khổ sở: vợ con nheo nhóc",
    example: "vợ con nheo nhóc",
  },
  {
    word: "nhể",
    part_of_speech: "động từ",
    meaning: "khêu nhẹ bằng mũi nhọn nhỏ để lấy ra: nhể ốc * dùng kim nhể gai",
    example: "nhể ốc * dùng kim nhể gai",
  },
  {
    word: "nhét",
    part_of_speech: "động từ",
    meaning:
      "cố lèn mạnh cho vào một nơi nào đó, bất kể thế nào: nhét vội tiền vào túi * nhét giẻ vào mồm",
    example: "nhét vội tiền vào túi * nhét giẻ vào mồm",
  },
  {
    word: "nhép",
    part_of_speech: "danh từ",
    meaning: "con bài tú lơ khơ có in hình ( màu đen: con át nhép",
    example: "con át nhép",
  },
  {
    word: "nhép",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) quá nhỏ và không có giá trị, không có tác dụng gì đáng kể (hàm ý coi khinh): dăm ba tên học trò nhép * mấy con gà nhép",
    example: "dăm ba tên học trò nhép * mấy con gà nhép",
  },
  {
    word: "nhếch nhác",
    part_of_speech: "tính từ",
    meaning:
      "lôi thôi, bừa bãi và bẩn thỉu: mặt mũi nhếch nhác * quần áo nhếch nhác",
    example: "mặt mũi nhếch nhác * quần áo nhếch nhác",
  },
  {
    word: "nhễ nhại",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái ướt đẫm, chảy thành dòng (thường nói về mồ hôi): mồ hôi mồ kê nhễ nhại",
    example: "mồ hôi mồ kê nhễ nhại",
  },
  {
    word: "nhễ nhại",
    part_of_speech: "tính từ",
    meaning:
      "thuần một màu (thường là trắng hoặc đen) ở mức độ cao, trông như bóng lên: da trắng nhễ nhại * tường quét hắc ín đen bóng nhễ nhại",
    example: "da trắng nhễ nhại * tường quét hắc ín đen bóng nhễ nhại",
  },
  {
    word: "nhệch",
    part_of_speech: "động từ",
    meaning:
      "đưa lệch môi sang một bên và trễ xuống, trông xấu: nhệch một bên mép, cười khẩy",
    example: "nhệch một bên mép, cười khẩy",
  },
  {
    word: "nhếch",
    part_of_speech: "động từ",
    meaning:
      "khẽ đưa chếch môi, mép sang một bên: cười nhếch mép * khẽ nhếch môi cười",
    example: "cười nhếch mép * khẽ nhếch môi cười",
  },
  {
    word: "nhếu nháo",
    part_of_speech: "tính từ",
    meaning: "(ăn) vội vàng, qua loa, nhai không kĩ: ăn nhếu nháo cho xong bữa",
    example: "ăn nhếu nháo cho xong bữa",
  },
  {
    word: "nhi",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) nhi khoa (nói tắt): bệnh viện nhi * khoa nhi * bác sĩ nhi",
    example: "bệnh viện nhi * khoa nhi * bác sĩ nhi",
  },
  {
    word: "nhị",
    part_of_speech: "danh từ",
    meaning: "(cũng nhuỵ) bộ phận sinh sản của hoa: nhị hoa",
    example: "nhị hoa",
  },
  {
    word: "nhị",
    part_of_speech: "danh từ",
    meaning:
      "(cũng nhị đực) bộ phận sinh sản đực của hoa, thường nằm ngoài nhuỵ và trong cánh hoa, mang bao phấn chứa hạt phấn",
    example: "đàn nhị * kéo nhị",
  },
  {
    word: "nhí",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) bé, nhỏ tuổi: ca sĩ nhí * diễn viên nhí",
    example: "ca sĩ nhí * diễn viên nhí",
  },
  {
    word: "nhểu",
    part_of_speech: "động từ",
    meaning:
      "nhỏ xuống từng giọt dài: nhựa cây nhểu ròng ròng * nước dãi nhểu xuống cằm",
    example: "nhựa cây nhểu ròng ròng * nước dãi nhểu xuống cằm",
  },
  {
    word: "nhỉ",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) nhỏ chậm chạp từng giọt một: nhỉ vài giọt nước mắt * nước mắm nhỉ",
    example: "nhỉ vài giọt nước mắt * nước mắm nhỉ",
  },
  {
    word: "nhỉ",
    part_of_speech: "trợ từ",
    meaning:
      "(khẩu ngữ) từ biểu thị ý khẳng định nhẹ nhàng về điều vừa mới nhận thức ra, và nêu ra để tỏ sự đồng ý với người đối thoại hoặc để tranh thủ sự đồng ý: đẹp nhỉ! * thằng bé thông minh nhỉ! * chúng ta đi thôi, chị nhỉ?",
    example: "đẹp nhỉ! * thằng bé thông minh nhỉ! * chúng ta đi thôi, chị nhỉ?",
  },
  {
    word: "nhỉ",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý mỉa mai, nêu ra dưới dạng như hỏi mà không cần được trả lời: nói dễ nghe nhỉ? * đẹp mặt nhỉ? * à, ra mày cũng bướng gớm nhỉ?",
    example: "nói dễ nghe nhỉ? * đẹp mặt nhỉ? * à, ra mày cũng bướng gớm nhỉ?",
  },
  {
    word: "nhỉ",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý thân mật: ai thế nhỉ? * tên bạn là gì nhỉ? * mấy giờ rồi nhỉ?",
    example: "ai thế nhỉ? * tên bạn là gì nhỉ? * mấy giờ rồi nhỉ?",
  },
  {
    word: "nhị cái",
    part_of_speech: "danh từ",
    meaning: "(cũng nhị) bộ phận sinh sản của hoa: nhuỵ hoa",
    example: "nhuỵ hoa",
  },
  {
    word: "nhì",
    part_of_speech: "tính từ",
    meaning:
      "ở vị trí thứ hai, sau nhất: đoạt giải nhì * thứ nhất cày nỏ, thứ nhì bỏ phân (tng)",
    example: "đoạt giải nhì * thứ nhất cày nỏ, thứ nhì bỏ phân (tng)",
  },
  {
    word: "nhi đồng",
    part_of_speech: "danh từ",
    meaning:
      "trẻ em ở độ từ bốn, năm đến tám, chín tuổi: tuổi nhi đồng * các cháu nhi đồng",
    example: "tuổi nhi đồng * các cháu nhi đồng",
  },
  {
    word: "nhị đực",
    part_of_speech: "danh từ",
    meaning: "(cũng nhuỵ) bộ phận sinh sản của hoa: nhị hoa",
    example: "nhị hoa",
  },
  {
    word: "nhị đực",
    part_of_speech: "danh từ",
    meaning:
      "(cũng nhị đực) bộ phận sinh sản đực của hoa, thường nằm ngoài nhuỵ và trong cánh hoa, mang bao phấn chứa hạt phấn",
    example: "đàn nhị * kéo nhị",
  },
  {
    word: "nhi khoa",
    part_of_speech: "danh từ",
    meaning:
      "bộ môn y học nghiên cứu phòng và chữa bệnh cho trẻ em: bác sĩ nhi khoa",
    example: "bác sĩ nhi khoa",
  },
  {
    word: "nhí nhách",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả kiểu nhai luôn mồm và phát ra những tiếng nhỏ: nhai cơm nhí nhách",
    example: "nhai cơm nhí nhách",
  },
  {
    word: "nhí nhảnh",
    part_of_speech: "tính từ",
    meaning:
      "hay cười nói, thích tung tăng nhảy nhót, tỏ ra hồn nhiên, yêu đời (thường nói về con gái): điệu bộ nhí nhảnh * cười nói nhí nhảnh",
    example: "điệu bộ nhí nhảnh * cười nói nhí nhảnh",
  },
  {
    word: "nhì nhằng",
    part_of_speech: "tính từ",
    meaning: "(tia sáng) ngoằn ngoèo và đan chéo vào nhau: ánh chớp nhì nhằng",
    example: "ánh chớp nhì nhằng",
  },
  {
    word: "nhì nhằng",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra không rạch ròi, có sự nhập nhằng: sổ sách nhì nhằng * làm ăn quá nhì nhằng! * công tư nhì nhằng",
    example: "sổ sách nhì nhằng * làm ăn quá nhì nhằng! * công tư nhì nhằng",
  },
  {
    word: "nhì nhằng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) thường thường, không lớn cũng không nhỏ, không tốt cũng không xấu: buôn bán nhì nhằng",
    example: "buôn bán nhì nhằng",
  },
  {
    word: "nhị hỉ",
    part_of_speech: "danh từ",
    meaning: "(cũ) lễ lại mặt sau ngày cưới: ngày nhị hỉ",
    example: "ngày nhị hỉ",
  },
  {
    word: "nhì nhèo",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nói lải nhải liên tục, nghe bực mình, khó chịu: nhì nhèo xin cho bằng được * suốt ngày nhì nhèo bên tai",
    example: "nhì nhèo xin cho bằng được * suốt ngày nhì nhèo bên tai",
  },
  {
    word: "nhi nhí",
    part_of_speech: "tính từ",
    meaning:
      "(nói) nhỏ trong miệng, nghe không rõ: nói nhi nhí trong miệng, không sao nghe được",
    example: "nói nhi nhí trong miệng, không sao nghe được",
  },
  {
    word: "nhí nhố",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) lăng nhăng, không đứng đắn: ăn nói nhí nhố * bày trò nhí nhố * đừng có nhí nhố!",
    example: "ăn nói nhí nhố * bày trò nhí nhố * đừng có nhí nhố!",
  },
  {
    word: "nhí nhố",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả vẻ đứng ngồi lộn xộn của một đám đông: bọn trẻ kéo đến, ngồi nhí nhố đầy nhà",
    example: "bọn trẻ kéo đến, ngồi nhí nhố đầy nhà",
  },
  {
    word: "nhích",
    part_of_speech: "động từ",
    meaning:
      "khẽ chuyển dịch đi một chút: nhích dần từng bước * giá cả có nhích lên chút ít",
    example: "nhích dần từng bước * giá cả có nhích lên chút ít",
  },
  {
    word: "nhích",
    part_of_speech: "tính từ",
    meaning: "như nhỉnh: học lực nhích hơn bạn chút xíu",
    example: "học lực nhích hơn bạn chút xíu",
  },
  {
    word: "nhi nữ",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) đàn bà, con gái (nói khái quát): "Qua chơi nghe tiếng nàng Kiều, Tấm lòng nhi nữ cũng xiêu anh hùng." (TKiều)',
    example:
      'Qua chơi nghe tiếng nàng Kiều, Tấm lòng nhi nữ cũng xiêu anh hùng." (TKiều)',
  },
  {
    word: "nhị phẩm",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) phẩm trật thứ hai trong thang cấp bậc quan lại: quan nhị phẩm",
    example: "quan nhị phẩm",
  },
  {
    word: "nhiếc",
    part_of_speech: "động từ",
    meaning:
      "moi móc cái xấu và nói lên bằng lời lẽ sâu cay, độc địa làm cho phải khổ tâm: bị nhiếc là đồ bạc bẽo * nói nhiếc",
    example: "bị nhiếc là đồ bạc bẽo * nói nhiếc",
  },
  {
    word: "nhiễm bệnh",
    part_of_speech: "động từ",
    meaning: "bị yếu tố gây bệnh xâm nhập vào cơ thể: cơ thể bị nhiễm bệnh",
    example: "cơ thể bị nhiễm bệnh",
  },
  {
    word: "nhị phân",
    part_of_speech: "động từ",
    meaning:
      "lấy cách chia cho 2 làm cơ sở: hệ đếm nhị phân * số nhị phân * máy tính mã hoá dữ liệu dưới dạng nhị phân",
    example:
      "hệ đếm nhị phân * số nhị phân * máy tính mã hoá dữ liệu dưới dạng nhị phân",
  },
  {
    word: "nhiếc móc",
    part_of_speech: "động từ",
    meaning:
      "nhiếc (nói khái quát): nặng lời nhiếc móc * bực bội nên thường nhiếc móc con cái",
    example: "nặng lời nhiếc móc * bực bội nên thường nhiếc móc con cái",
  },
  {
    word: "nhiễm",
    part_of_speech: "động từ",
    meaning:
      "bị yếu tố bên ngoài (thường là độc hại) xâm nhập vào, thường gây ra những hậu quả xấu: nhiễm virus * cơ thể bị nhiễm lạnh * nhiễm phải thói hư tật xấu",
    example: "nhiễm virus * cơ thể bị nhiễm lạnh * nhiễm phải thói hư tật xấu",
  },
  {
    word: "nhiễm độc",
    part_of_speech: "động từ",
    meaning:
      "bị chất độc xâm nhập: nguồn nước bị nhiễm độc * nhiễm độc thực phẩm",
    example: "nguồn nước bị nhiễm độc * nhiễm độc thực phẩm",
  },
  {
    word: "nhiệm kì",
    part_of_speech: "danh từ",
    meaning:
      "thời hạn làm nhiệm vụ theo quy định: nhiệm kì công tác * chuyển giao nhiệm kì * nhiệm kì tổng thống",
    example: "nhiệm kì công tác * chuyển giao nhiệm kì * nhiệm kì tổng thống",
  },
  {
    word: "nhiễm điện",
    part_of_speech: "động từ",
    meaning: "trở thành có mang điện tích: thanh sắt đã nhiễm điện",
    example: "thanh sắt đã nhiễm điện",
  },
  {
    word: "nhiễm khuẩn",
    part_of_speech: "động từ",
    meaning:
      "bị vi khuẩn gây bệnh xâm nhập vào cơ thể: vết thương bị nhiễm khuẩn * thức ăn bị nhiễm khuẩn",
    example: "vết thương bị nhiễm khuẩn * thức ăn bị nhiễm khuẩn",
  },
  {
    word: "nhiệm kỳ",
    part_of_speech: "danh từ",
    meaning:
      "thời hạn làm nhiệm vụ theo quy định: nhiệm kì công tác * chuyển giao nhiệm kì * nhiệm kì tổng thống",
    example: "nhiệm kì công tác * chuyển giao nhiệm kì * nhiệm kì tổng thống",
  },
  {
    word: "nhiễm sắc thể",
    part_of_speech: "danh từ",
    meaning:
      "phần của nhân tế bào, mang gen, có vai trò chủ đạo về mặt di truyền: nhiễm sắc thể X * ở người có 23 cặp nhiễm sắc thể",
    example: "nhiễm sắc thể X * ở người có 23 cặp nhiễm sắc thể",
  },
  {
    word: "nhiệm sở",
    part_of_speech: "danh từ",
    meaning: "(hiếm) nơi, trụ sở làm việc: rời nhiệm sở",
    example: "rời nhiệm sở",
  },
  {
    word: "nhiệm mầu",
    part_of_speech: "tính từ",
    meaning: "như mầu nhiệm: phép nhiệm mầu",
    example: "phép nhiệm mầu",
  },
  {
    word: "nhiễm trùng",
    part_of_speech: "động từ",
    meaning:
      "bị vi trùng xâm nhập vào cơ thể: vết thương bị nhiễm trùng * nhiễm trùng máu",
    example: "vết thương bị nhiễm trùng * nhiễm trùng máu",
  },
  {
    word: "nhiệm vụ",
    part_of_speech: "danh từ",
    meaning:
      "công việc do cơ quan, đơn vị hoặc tổ chức giao cho phải làm vì một mục đích và trong một thời gian nhất định: làm nhiệm vụ trinh sát * nhận nhiệm vụ mới * hoàn thành nhiệm vụ được giao",
    example:
      "làm nhiệm vụ trinh sát * nhận nhiệm vụ mới * hoàn thành nhiệm vụ được giao",
  },
  {
    word: "nhiễm từ",
    part_of_speech: "động từ",
    meaning: "trở thành có từ tính: thanh kim loại bị nhiễm từ",
    example: "thanh kim loại bị nhiễm từ",
  },
  {
    word: "nhiếp ảnh",
    part_of_speech: "động từ",
    meaning: "chụp ảnh: nghệ sĩ nhiếp ảnh * làm nghề nhiếp ảnh",
    example: "nghệ sĩ nhiếp ảnh * làm nghề nhiếp ảnh",
  },
  {
    word: "nhiên liệu",
    part_of_speech: "danh từ",
    meaning: "chất đốt: cung cấp nhiên liệu cho nhà máy * thiếu nhiên liệu",
    example: "cung cấp nhiên liệu cho nhà máy * thiếu nhiên liệu",
  },
  {
    word: "nhiễm xạ",
    part_of_speech: "động từ",
    meaning: "bị nhiễm tia phóng xạ: chất thải nhiễm xạ * cơ thể bị nhiễm xạ",
    example: "chất thải nhiễm xạ * cơ thể bị nhiễm xạ",
  },
  {
    word: "nhiễn",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) nhuyễn: thịt xay nhiễn",
    example: "thịt xay nhiễn",
  },
  {
    word: "nhiệt dung",
    part_of_speech: "danh từ",
    meaning:
      "đại lượng vật lí cho biết nhiệt lượng cần phải cung cấp cho một vật để nhiệt độ của nó tăng một độ: nhiệt dung của nước",
    example: "nhiệt dung của nước",
  },
  {
    word: "nhiệt",
    part_of_speech: "danh từ",
    meaning:
      "hiện tượng vật lí có thể truyền đi được, sự tăng lên của nó thể hiện bằng sự tăng nhiệt độ, sự dãn nở và những sự chuyển hoá như nóng chảy, bay hơi.",
    example: "toả nhiệt * cần mặc ấm để giữ nhiệt cho cơ thể",
  },
  {
    word: "nhiệt",
    part_of_speech: "tính từ",
    meaning:
      "(cơ thể) ở tạng nóng, có những biểu hiện như miệng khô, khát nước, mạch nhanh, v.v. (theo cách nói của đông y): cơ thể bị nhiệt",
    example: "cơ thể bị nhiệt",
  },
  {
    word: "nhiệt điện",
    part_of_speech: "danh từ",
    meaning: "điện do nhiệt năng sinh ra: nhà máy nhiệt điện",
    example: "nhà máy nhiệt điện",
  },
  {
    word: "nhiệt điện",
    part_of_speech: "danh từ",
    meaning:
      "hiện tượng xuất hiện dòng điện trong một mạch kín tạo thành bởi hai vật kim loại khác nhau và hai chỗ nối các vật đó có nhiệt độ khác nhau: pin nhiệt điện",
    example: "pin nhiệt điện",
  },
  {
    word: "nhiệt độ",
    part_of_speech: "danh từ",
    meaning:
      "đại lượng chỉ độ nóng lạnh của một vật: nước sôi ở nhiệt độ 100OC",
    example: "nước sôi ở nhiệt độ 100OC",
  },
  {
    word: "nhiệt độ",
    part_of_speech: "danh từ",
    meaning:
      "nhiệt độ không khí (nói tắt): nhiệt độ ngoài trời * máy điều hoà nhiệt độ",
    example: "nhiệt độ ngoài trời * máy điều hoà nhiệt độ",
  },
  {
    word: "nhiệt hạch",
    part_of_speech: "danh từ",
    meaning:
      "hiện tượng tổng hợp hạt nhân nhẹ thành các hạt nhân nặng hơn, nhờ tác dụng của nhiệt độ rất cao: phản ứng nhiệt hạch * nhà máy điện nhiệt hạch",
    example: "phản ứng nhiệt hạch * nhà máy điện nhiệt hạch",
  },
  {
    word: "nhiệt độ tới hạn",
    part_of_speech: "danh từ",
    meaning:
      "nhiệt độ mà trên đó trạng thái khí không thể chuyển thành trạng thái lỏng, dù có tăng áp suất: nhiệt độ tới hạn của nước là 374OC",
    example: "nhiệt độ tới hạn của nước là 374OC",
  },
  {
    word: "nhiệt đới",
    part_of_speech: "danh từ",
    meaning:
      "đới nằm giữa xích đới và cận nhiệt đới, có khí hậu nóng: miền nhiệt đới * rừng nhiệt đới * khí hậu nhiệt đới",
    example: "miền nhiệt đới * rừng nhiệt đới * khí hậu nhiệt đới",
  },
  {
    word: "nhiệt luyện",
    part_of_speech: "động từ",
    meaning:
      "nung nóng kim loại hay hợp kim đến nhiệt độ xác định, rồi làm nguội với tốc độ thích hợp nhằm làm biến đổi tính chất của chúng: phương pháp nhiệt luyện",
    example: "phương pháp nhiệt luyện",
  },
  {
    word: "nhiệt liệt",
    part_of_speech: "",
    meaning:
      "với tất cả lòng hăng hái, nhiệt tình, biểu lộ trong thái độ hoan nghênh: nhiệt liệt chào mừng * nhiệt liệt hưởng ứng * khán giả vỗ tay nhiệt liệt",
    example:
      "nhiệt liệt chào mừng * nhiệt liệt hưởng ứng * khán giả vỗ tay nhiệt liệt",
  },
  {
    word: "nhiệt huyết",
    part_of_speech: "danh từ",
    meaning:
      'lòng sốt sắng, hăng hái đối với sự nghiệp chung: nhiệt huyết cách mạng * "Một bầu nhiệt huyết chan chan, Thân này với nợ giang san còn nhiều." (ca dao)',
    example:
      'nhiệt huyết cách mạng * "Một bầu nhiệt huyết chan chan, Thân này với nợ giang san còn nhiều." (ca dao)',
  },
  {
    word: "nhiệt tâm",
    part_of_speech: "danh từ",
    meaning:
      "lòng nhiệt tình, sốt sắng đối với công việc chung, sự nghiệp chung: nhiệt tâm nghề nghiệp * có nhiệt tâm với sự nghiệp giáo dục",
    example: "nhiệt tâm nghề nghiệp * có nhiệt tâm với sự nghiệp giáo dục",
  },
  {
    word: "nhiều",
    part_of_speech: "tính từ",
    meaning:
      "có số lượng lớn hoặc ở mức cao: lắm tiền nhiều của * được đi nhiều nơi * nhiều năm đã trôi qua * có tật nói nhiều",
    example:
      "lắm tiền nhiều của * được đi nhiều nơi * nhiều năm đã trôi qua * có tật nói nhiều",
  },
  {
    word: "nhiệt tình",
    part_of_speech: "danh từ",
    meaning:
      "tình cảm sốt sắng, hăng hái: thiếu nhiệt tình trong công việc * đem hết tài năng và nhiệt tình phục vụ đất nước",
    example:
      "thiếu nhiệt tình trong công việc * đem hết tài năng và nhiệt tình phục vụ đất nước",
  },
  {
    word: "nhiệt tình",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có nhiệt tình: cổ vũ nhiệt tình * nhiệt tình ủng hộ * giúp đỡ rất nhiệt tình",
    example: "cổ vũ nhiệt tình * nhiệt tình ủng hộ * giúp đỡ rất nhiệt tình",
  },
  {
    word: "nhiêu",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) chức vị ở làng xã thời phong kiến, thường phải bỏ tiền ra mua để được quyền miễn tạp dịch: mua nhiêu, mua xã",
    example: "mua nhiêu, mua xã",
  },
  {
    word: "nhiều chuyện",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ, hiếm) như lắm chuyện: chỉ được cái nhiều chuyện!",
    example: "chỉ được cái nhiều chuyện!",
  },
  {
    word: "nhiệt thành",
    part_of_speech: "tính từ",
    meaning:
      "nhiệt tình, sốt sắng với tình cảm chân thành: lòng nhiệt thành cách mạng * nhiệt thành giúp đỡ bạn bè",
    example: "lòng nhiệt thành cách mạng * nhiệt thành giúp đỡ bạn bè",
  },
  {
    word: "nhiều nhặn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) nhiều (nói khái quát): có hơn chục nghìn đồng chứ nhiều nhặn gì!",
    example: "có hơn chục nghìn đồng chứ nhiều nhặn gì!",
  },
  {
    word: "nhiêu khê",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) lôi thôi, phức tạp một cách không cần thiết: thủ tục nhiêu khê",
    example: "thủ tục nhiêu khê",
  },
  {
    word: "nhiễu loạn",
    part_of_speech: "",
    meaning:
      "nhiễu, làm biến đổi, sai lệch, méo mó (nói khái quát): đường thông tin bị nhiễu loạn",
    example: "đường thông tin bị nhiễu loạn",
  },
  {
    word: "nhiễu nhương",
    part_of_speech: "tính từ",
    meaning:
      "(tình trạng) rối ren, loạn lạc, không yên ổn: thời buổi nhiễu nhương",
    example: "thời buổi nhiễu nhương",
  },
  {
    word: "nhiễu",
    part_of_speech: "danh từ",
    meaning:
      "hàng dệt bằng tơ, sợi ngang xe rất săn, làm cho mặt nổi cát: khăn nhiễu",
    example: "khăn nhiễu",
  },
  {
    word: "nhiễu",
    part_of_speech: "động từ",
    meaning:
      "hạch sách, đòi hỏi hết chuyện này đến chuyện khác để làm cho không yên: quan lại nhiễu dân",
    example: "quan lại nhiễu dân",
  },
  {
    word: "nhiễu",
    part_of_speech: "động từ",
    meaning:
      "hoặc d làm méo thông tin truyền đi: thời tiết xấu nên đài bắt nhiễu * ti vi có nhiều nhiễu * làm nhiễu sóng radar",
    example:
      "thời tiết xấu nên đài bắt nhiễu * ti vi có nhiều nhiễu * làm nhiễu sóng radar",
  },
  {
    word: "nhiễu",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) nhiễu sự (nói tắt): thôi đi, đừng có nhiễu!",
    example: "thôi đi, đừng có nhiễu!",
  },
  {
    word: "nhìn",
    part_of_speech: "động từ",
    meaning:
      "đưa mắt về một hướng nào đó để thấy: ngẩng mặt nhìn trời * xa quá, nhìn không rõ",
    example: "ngẩng mặt nhìn trời * xa quá, nhìn không rõ",
  },
  {
    word: "nhìn",
    part_of_speech: "động từ",
    meaning:
      "để mắt tới, quan tâm, chú ý tới: mải chơi, không nhìn đến sách vở * nhà cửa bỏ mặc, không ai thèm nhìn đến",
    example:
      "mải chơi, không nhìn đến sách vở * nhà cửa bỏ mặc, không ai thèm nhìn đến",
  },
  {
    word: "nhìn",
    part_of_speech: "động từ",
    meaning:
      "xem xét để thấy và biết được: nhìn rõ trắng đen * nhìn ra sai lầm của mình * nhìn vấn đề một cách khách quan",
    example:
      "nhìn rõ trắng đen * nhìn ra sai lầm của mình * nhìn vấn đề một cách khách quan",
  },
  {
    word: "nhìn",
    part_of_speech: "động từ",
    meaning:
      "(vật xây dựng hay được bố trí, sắp xếp) có mặt chính quay về, hướng về (phía hoặc hướng nào đó): khách sạn nhìn ra biển * ngôi nhà nhìn về hướng đông",
    example: "khách sạn nhìn ra biển * ngôi nhà nhìn về hướng đông",
  },
  {
    word: "nhìn nhận",
    part_of_speech: "động từ",
    meaning:
      "xem xét, đánh giá về một vấn đề, một sự vật, sự việc nào đó: nhìn nhận vấn đề * nhìn nhận lại cách cư xử của mình",
    example: "nhìn nhận vấn đề * nhìn nhận lại cách cư xử của mình",
  },
  {
    word: "nhìn nhận",
    part_of_speech: "động từ",
    meaning:
      "thừa nhận một thực tế, một sự việc nào đó: thẳng thắn nhìn nhận những sai lầm của bản thân",
    example: "thẳng thắn nhìn nhận những sai lầm của bản thân",
  },
  {
    word: "nhìn chung",
    part_of_speech: "",
    meaning:
      "tổ hợp dùng để mở đầu một lời nhận xét bao quát, chỉ nhìn trên những cái chính, cái cơ bản: nhìn chung mọi việc vẫn bình thường",
    example: "nhìn chung mọi việc vẫn bình thường",
  },
  {
    word: "nhiễu sự",
    part_of_speech: "động từ",
    meaning: "bày ra nhiều việc rắc rối vô ích: tính hay nhiễu sự",
    example: "tính hay nhiễu sự",
  },
  {
    word: "nhín",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) bớt lại, để dành lại chút ít: nhín lại thức ăn để bữa sau",
    example: "nhín lại thức ăn để bữa sau",
  },
  {
    word: "nhín",
    part_of_speech: "động từ",
    meaning: "tằn tiện, dè sẻn: ăn nhín cho lâu hết * tiêu nhín",
    example: "ăn nhín cho lâu hết * tiêu nhín",
  },
  {
    word: "nhịn đói",
    part_of_speech: "động từ",
    meaning: "phải chịu đói, vì không có gì để ăn: hết tiền nên phải nhịn đói",
    example: "hết tiền nên phải nhịn đói",
  },
  {
    word: "nhịn",
    part_of_speech: "động từ",
    meaning:
      "chịu đựng, không tự cho mình thoả mãn nhu cầu nào đó của bản thân: nhịn ăn * nhịn mặc * phải nhịn đói từ sáng tới giờ",
    example: "nhịn ăn * nhịn mặc * phải nhịn đói từ sáng tới giờ",
  },
  {
    word: "nhịn",
    part_of_speech: "động từ",
    meaning:
      "dằn xuống, ghìm lại, không để biểu hiện sự phản ứng ra ngoài: cố nhịn cười * người tốt nhịn * một điều nhịn chín điều lành (tng)",
    example:
      "cố nhịn cười * người tốt nhịn * một điều nhịn chín điều lành (tng)",
  },
  {
    word: "nhịn nhục",
    part_of_speech: "động từ",
    meaning:
      "dằn lòng chịu đựng, không có biểu hiện phản ứng lại: sống nhịn nhục",
    example: "sống nhịn nhục",
  },
  {
    word: "nhìn xa trông rộng",
    part_of_speech: "",
    meaning:
      "sáng suốt, có khả năng lường trước, thấy được trước những vấn đề mà người khác chưa thấy: một người biết nhìn xa trông rộng",
    example: "một người biết nhìn xa trông rộng",
  },
  {
    word: "nhinh nhỉnh",
    part_of_speech: "tính từ",
    meaning: "hơi nhỉnh hơn một chút: hai đứa chỉ nhinh nhỉnh hơn nhau chút ít",
    example: "hai đứa chỉ nhinh nhỉnh hơn nhau chút ít",
  },
  {
    word: "nhỉnh",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) lớn hơn, trội hơn một chút về mặt nào đó: học lực nhỉnh hơn bạn một chút * giá cả có nhỉnh hơn trước",
    example: "học lực nhỉnh hơn bạn một chút * giá cả có nhỉnh hơn trước",
  },
  {
    word: "nhịp",
    part_of_speech: "danh từ",
    meaning:
      'khoảng cách giữa hai trụ hoặc hai mố cầu liền nhau: "Qua cầu ghé nón trông cầu, Cầu bao nhiêu nhịp dạ sầu bấy nhiêu." (ca dao)',
    example:
      'Qua cầu ghé nón trông cầu, Cầu bao nhiêu nhịp dạ sầu bấy nhiêu." (ca dao)',
  },
  {
    word: "nhịp",
    part_of_speech: "danh từ",
    meaning:
      "sự nối tiếp và lặp lại một cách đều đặn, tuần hoàn các độ dài thời gian bằng nhau làm nền cho nhạc: hát sai nhịp * nhịp phách",
    example: "hát sai nhịp * nhịp phách",
  },
  {
    word: "nhịp",
    part_of_speech: "danh từ",
    meaning:
      "sự nối tiếp và lặp lại một cách đều đặn một hoạt động hay một quá trình nào đó: nhịp chày * nhịp thở đều đều * hoà vào nhịp phát triển chung của xã hội",
    example:
      "nhịp chày * nhịp thở đều đều * hoà vào nhịp phát triển chung của xã hội",
  },
  {
    word: "nhíp",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng gồm hai thanh kim loại nhỏ, mỏng và cứng, có khả năng kẹp và giữ chặt, dùng để nhổ râu, nhổ lông: dùng nhíp nhổ râu",
    example: "dùng nhíp nhổ râu",
  },
  {
    word: "nhíp",
    part_of_speech: "danh từ",
    meaning:
      "thanh thép cong, có sức chịu lực và đàn hồi tốt, dùng để giảm xóc trong xe ô tô: nhíp ô tô * xe bị gãy nhíp",
    example: "nhíp ô tô * xe bị gãy nhíp",
  },
  {
    word: "nhịp điệu",
    part_of_speech: "danh từ",
    meaning:
      "sự lặp lại một cách tuần hoàn các âm mạnh và nhẹ theo những trật tự, cách thức nhất định: bài thơ có nhịp điệu hào hùng",
    example: "bài thơ có nhịp điệu hào hùng",
  },
  {
    word: "nhịp điệu",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) như nhịp độ (ng2): nhịp điệu sản xuất * nhịp điệu làm việc hối hả",
    example: "nhịp điệu sản xuất * nhịp điệu làm việc hối hả",
  },
  {
    word: "nhíu",
    part_of_speech: "động từ",
    meaning:
      "cử động khẽ tạo thành những nếp nhăn ở vùng mắt gần trán khi đang có điều khó chịu hoặc đang suy nghĩ: nhíu trán suy nghĩ * nhíu mày tỏ vẻ khó chịu",
    example: "nhíu trán suy nghĩ * nhíu mày tỏ vẻ khó chịu",
  },
  {
    word: "nhịp nhàng",
    part_of_speech: "tính từ",
    meaning:
      "có nhịp điệu đều đặn và ăn khớp với nhau: chân bước nhịp nhàng * có sự phối hợp nhịp nhàng",
    example: "chân bước nhịp nhàng * có sự phối hợp nhịp nhàng",
  },
  {
    word: "nhọ",
    part_of_speech: "tính từ",
    meaning: "có vết bẩn màu đen: mặt nhọ * tay bị nhọ",
    example: "mặt nhọ * tay bị nhọ",
  },
  {
    word: "nhọ",
    part_of_speech: "tính từ",
    meaning:
      '(khẩu ngữ) có màu đen như màu của nhọ nồi: "Có người mặt nhọ như niêu, Cái răng khấp khểnh chồng yêu lạ lùng." (ca dao)',
    example:
      'Có người mặt nhọ như niêu, Cái răng khấp khểnh chồng yêu lạ lùng." (ca dao)',
  },
  {
    word: "nhọ",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) vết bẩn màu đen: tay dính nhọ",
    example: "tay dính nhọ",
  },
  {
    word: "nhỏ",
    part_of_speech: "động từ",
    meaning:
      "rơi hoặc làm cho rơi xuống thành từng giọt: tiếng nước nhỏ tí tách * nhỏ thuốc đau mắt",
    example: "tiếng nước nhỏ tí tách * nhỏ thuốc đau mắt",
  },
  {
    word: "nhỏ",
    part_of_speech: "tính từ",
    meaning:
      "có kích thước, số lượng, phạm vi hoặc giá trị, ý nghĩa không đáng kể, hay kém hơn so với phần lớn những cái khác cùng loại: ngõ nhỏ * chú chó nhỏ * mưa nhỏ hạt * đó chỉ là chuyện nhỏ",
    example: "ngõ nhỏ * chú chó nhỏ * mưa nhỏ hạt * đó chỉ là chuyện nhỏ",
  },
  {
    word: "nhỏ",
    part_of_speech: "tính từ",
    meaning:
      "còn ít tuổi, chưa trưởng thành: thuở nhỏ * nhà có con nhỏ * nó còn nhỏ quá, chưa hiểu gì",
    example: "thuở nhỏ * nhà có con nhỏ * nó còn nhỏ quá, chưa hiểu gì",
  },
  {
    word: "nhỏ",
    part_of_speech: "tính từ",
    meaning:
      "(âm thanh) có cường độ yếu, nghe không rõ so với bình thường: nói nhỏ quá, nghe không rõ * vặn nhỏ đài * nhỏ mồm thôi!",
    example: "nói nhỏ quá, nghe không rõ * vặn nhỏ đài * nhỏ mồm thôi!",
  },
  {
    word: "nhỏ",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ, khẩu ngữ) trẻ, trẻ nhỏ (với ý thân mật, âu yếm): tụi nhỏ đang chơi ngoài sân * con nhỏ trông thật đáng yêu!",
    example: "tụi nhỏ đang chơi ngoài sân * con nhỏ trông thật đáng yêu!",
  },
  {
    word: "nhịp độ",
    part_of_speech: "danh từ",
    meaning:
      "độ nhanh, chậm của bản nhạc, bài hát: tiết tấu và nhịp độ của ca khúc",
    example: "tiết tấu và nhịp độ của ca khúc",
  },
  {
    word: "nhịp độ",
    part_of_speech: "danh từ",
    meaning:
      "mức độ tiến triển của sự việc: nhịp độ sản xuất * nhịp độ tăng trưởng kinh tế",
    example: "nhịp độ sản xuất * nhịp độ tăng trưởng kinh tế",
  },
  {
    word: "nhỏ con",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) (người) có vóc dáng bé nhỏ: người nhỏ con",
    example: "người nhỏ con",
  },
  {
    word: "nhỏ dại",
    part_of_speech: "tính từ",
    meaning: "bé nhỏ và thơ dại: con cái còn nhỏ dại",
    example: "con cái còn nhỏ dại",
  },
  {
    word: "nho",
    part_of_speech: "danh từ",
    meaning:
      "cây thân leo, quả tròn mọc thành chùm, khi chín có màu nâu đỏ, thịt mọng nước, vị ngọt, dùng để ăn hay để chế rượu vang: chùm nho * rượu nho (rượu chế từ nho)",
    example: "chùm nho * rượu nho (rượu chế từ nho)",
  },
  {
    word: "nho",
    part_of_speech: "danh từ",
    meaning:
      "chữ Hán (theo cách gọi thông thường của người Việt Nam thời trước): chữ nho * sách nho * ông đồ nho",
    example: "chữ nho * sách nho * ông đồ nho",
  },
  {
    word: "nho gia",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) nhà nho có tên tuổi: "Một trai con thứ rốt lòng, Vương Quan là chữ, nối dòng nho gia." (TKiều)',
    example:
      'Một trai con thứ rốt lòng, Vương Quan là chữ, nối dòng nho gia." (TKiều)',
  },
  {
    word: "nhỏ giọt",
    part_of_speech: "động từ",
    meaning:
      "nhỏ từng giọt một; ví cách cung cấp nay một ít, mai một ít và quá chậm: đầu tư nhỏ giọt * kinh phí cấp theo kiểu nhỏ giọt",
    example: "đầu tư nhỏ giọt * kinh phí cấp theo kiểu nhỏ giọt",
  },
  {
    word: "nhỏ bé",
    part_of_speech: "tính từ",
    meaning:
      "như bé nhỏ (nhưng thường dùng với nghĩa trừu tượng): căn phòng nhỏ bé * những mơ ước nhỏ bé",
    example: "căn phòng nhỏ bé * những mơ ước nhỏ bé",
  },
  {
    word: "nho giáo",
    part_of_speech: "danh từ",
    meaning:
      "hệ thống các nguyên tắc đạo đức, chính trị do Khổng Tử sáng lập, nhằm duy trì trật tự của xã hội phong kiến: hệ tư tưởng nho giáo",
    example: "hệ tư tưởng nho giáo",
  },
  {
    word: "nho học",
    part_of_speech: "danh từ",
    meaning: "nền học vấn theo nho giáo: xuất thân nho học",
    example: "xuất thân nho học",
  },
  {
    word: "nhọ mặt người",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) chập choạng tối, không còn trông rõ mặt người: đi từ trưa, đến nhọ mặt người mới về",
    example: "đi từ trưa, đến nhọ mặt người mới về",
  },
  {
    word: "nhỏ lẻ",
    part_of_speech: "tính từ",
    meaning:
      "ở tình trạng chia nhỏ, thiếu tập trung, thiếu liên kết: hoạt động nhỏ lẻ * buôn bán nhỏ lẻ",
    example: "hoạt động nhỏ lẻ * buôn bán nhỏ lẻ",
  },
  {
    word: "nhọ mặt",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) nhọ mặt người (nói tắt): đi từ sớm đến nhọ mặt mới về",
    example: "đi từ sớm đến nhọ mặt mới về",
  },
  {
    word: "nhỏ mọn",
    part_of_speech: "tính từ",
    meaning:
      "nhỏ bé, không có giá trị, không đáng kể: món quà nhỏ mọn * chuyện nhỏ mọn nên không chấp",
    example: "món quà nhỏ mọn * chuyện nhỏ mọn nên không chấp",
  },
  {
    word: "nhỏ mọn",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như nhỏ nhen: tính nhỏ mọn * hay chấp nhặt nhỏ mọn",
    example: "tính nhỏ mọn * hay chấp nhặt nhỏ mọn",
  },
  {
    word: "nhỏ nhặt",
    part_of_speech: "tính từ",
    meaning:
      "nhỏ bé, vụn vặt, không đáng để tâm, chú ý: chú ý từng chi tiết nhỏ nhặt * chuyện nhỏ nhặt",
    example: "chú ý từng chi tiết nhỏ nhặt * chuyện nhỏ nhặt",
  },
  {
    word: "nhỏ nhắn",
    part_of_speech: "tính từ",
    meaning:
      "nhỏ và trông cân đối, dễ thương: bàn tay nhỏ nhắn * thân hình nhỏ nhắn",
    example: "bàn tay nhỏ nhắn * thân hình nhỏ nhắn",
  },
  {
    word: "nhỏ nhẹ",
    part_of_speech: "tính từ",
    meaning:
      "(nói năng) nhỏ giọng và nhẹ nhàng, dễ nghe: ăn nói nhỏ nhẹ * giọng nhỏ nhẹ, thân mật",
    example: "ăn nói nhỏ nhẹ * giọng nhỏ nhẹ, thân mật",
  },
  {
    word: "nhỏ nhen",
    part_of_speech: "tính từ",
    meaning:
      'tỏ ra hẹp hòi, hay chú ý đến những việc nhỏ nhặt về quyền lợi trong quan hệ đối xử: lòng dạ nhỏ nhen * "Tha ra thì cũng may đời, Làm ra thì cũng ra người nhỏ nhen." (TKiều)',
    example:
      'lòng dạ nhỏ nhen * "Tha ra thì cũng may đời, Làm ra thì cũng ra người nhỏ nhen." (TKiều)',
  },
  {
    word: "nho nhã",
    part_of_speech: "tính từ",
    meaning:
      "có dáng vẻ tao nhã của người có học thức: ăn mặc nho nhã * vẻ phong lưu nho nhã",
    example: "ăn mặc nho nhã * vẻ phong lưu nho nhã",
  },
  {
    word: "nhọ nhem",
    part_of_speech: "tính từ",
    meaning: "có nhiều vết nhọ, trông lem luốc: mặt mũi lọ lem",
    example: "mặt mũi lọ lem",
  },
  {
    word: "nhỏ nhít",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) rất nhỏ bé: lớn tướng rồi chớ nhỏ nhít gì!",
    example: "lớn tướng rồi chớ nhỏ nhít gì!",
  },
  {
    word: "nho nhỏ",
    part_of_speech: "tính từ",
    meaning:
      "hơi nhỏ, trông xinh xắn, đáng yêu: quả cau nho nhỏ * niềm vui nho nhỏ",
    example: "quả cau nho nhỏ * niềm vui nho nhỏ",
  },
  {
    word: "nhỏ nhẻ",
    part_of_speech: "tính từ",
    meaning:
      "(nói năng, ăn uống) nhẹ nhàng, chậm rãi với vẻ giữ gìn, từ tốn: nói năng nhỏ nhẻ như con gái",
    example: "nói năng nhỏ nhẻ như con gái",
  },
  {
    word: "nhỏ thó",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) nhỏ con và trông gầy gò: dáng người nhỏ thó",
    example: "dáng người nhỏ thó",
  },
  {
    word: "nho nhoe",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) lăm le định làm việc gì đó không nên làm và cũng quá sức mình (hàm ý coi khinh): có dăm ba chữ cũng nho nhoe học đòi",
    example: "có dăm ba chữ cũng nho nhoe học đòi",
  },
  {
    word: "nhỏ to",
    part_of_speech: "động từ",
    meaning:
      '(khẩu ngữ) như to nhỏ: "Vội vàng, kẻ giữ người coi, Nhỏ to, nàng lại tìm lời khuyên can." (TKiều)',
    example:
      'Vội vàng, kẻ giữ người coi, Nhỏ to, nàng lại tìm lời khuyên can." (TKiều)',
  },
  {
    word: "nho sĩ",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người theo nho giáo, thuộc tầng lớp trí thức trong xã hội phong kiến: giới nho sĩ * một nho sĩ yêu nước",
    example: "giới nho sĩ * một nho sĩ yêu nước",
  },
  {
    word: "nhọ nồi",
    part_of_speech: "danh từ",
    meaning:
      "bụi đen bám ở phía ngoài nồi, chảo, v.v. do đun nấu: mặt bị dính nhọ nồi",
    example: "mặt bị dính nhọ nồi",
  },
  {
    word: "nhoai",
    part_of_speech: "động từ",
    meaning:
      "đẩy mạnh thân mình cố di chuyển về phía trước một cách vất vả: nhoai người trườn đi * nhoai mãi mới vào được bờ",
    example: "nhoai người trườn đi * nhoai mãi mới vào được bờ",
  },
  {
    word: "nhỏ nhoi",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) nhỏ bé, ít ỏi, gây ấn tượng yếu ớt, mỏng manh: món quà nhỏ nhoi * vốn liếng nhỏ nhoi",
    example: "món quà nhỏ nhoi * vốn liếng nhỏ nhoi",
  },
  {
    word: "nhỏ tuổi",
    part_of_speech: "tính từ",
    meaning:
      "ít tuổi (thường nói về tuổi thiếu niên): khán giả nhỏ tuổi * tuy còn nhỏ tuổi nhưng rất thông minh",
    example: "khán giả nhỏ tuổi * tuy còn nhỏ tuổi nhưng rất thông minh",
  },
  {
    word: "nhỏ yếu",
    part_of_speech: "tính từ",
    meaning: "nhỏ và yếu, thiếu sức mạnh: lực lượng quân sự nhỏ yếu",
    example: "lực lượng quân sự nhỏ yếu",
  },
  {
    word: "nhỏ xíu",
    part_of_speech: "tính từ",
    meaning:
      "rất nhỏ, như không còn nhỏ hơn được nữa: những vì sao nhỏ xíu * chơi với nhau từ hồi còn nhỏ xíu",
    example: "những vì sao nhỏ xíu * chơi với nhau từ hồi còn nhỏ xíu",
  },
  {
    word: "nhoà",
    part_of_speech: "",
    meaning:
      "trở thành mờ, không còn hiện lên rõ nét hoặc không còn nhìn thấu qua được một cách rõ nét nữa: hàng cây nhoà vào bóng tối * kính nhoà hơi sương * dòng chữ nhoà đi vì nước mắt",
    example:
      "hàng cây nhoà vào bóng tối * kính nhoà hơi sương * dòng chữ nhoà đi vì nước mắt",
  },
  {
    word: "nhoài",
    part_of_speech: "động từ",
    meaning:
      "vươn hẳn thân mình ra phía trước: nhoài người qua cửa xe * ngã nhoài ra đất",
    example: "nhoài người qua cửa xe * ngã nhoài ra đất",
  },
  {
    word: "nhoáy",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) rất nhanh, gọn và nhẹ nhàng: viết nhoáy một lúc là xong",
    example: "viết nhoáy một lúc là xong",
  },
  {
    word: "nhoáng nhoàng",
    part_of_speech: "tính từ",
    meaning:
      "rất nhanh và vội, chỉ trong chốc lát: ăn nhoáng nhoàng cho xong bữa * chạy nhoáng nhoàng",
    example: "ăn nhoáng nhoàng cho xong bữa * chạy nhoáng nhoàng",
  },
  {
    word: "nhoay nhoáy",
    part_of_speech: "tính từ",
    meaning:
      "như nhoáy (nhưng ý liên tiếp và mức độ nhiều hơn): tay đan nhoay nhoáy",
    example: "tay đan nhoay nhoáy",
  },
  {
    word: "nhoáng",
    part_of_speech: "động từ",
    meaning: "loé lên rồi tắt ngay: bầu trời nhoáng lên ánh chớp",
    example: "bầu trời nhoáng lên ánh chớp",
  },
  {
    word: "nhoang nhoáng",
    part_of_speech: "",
    meaning:
      "chiếu sáng hoặc được chiếu sáng lướt nhanh trên bề mặt một cách liên tiếp, tạo thành những vệt sáng không đều: ánh đèn pin quét loang loáng",
    example: "ánh đèn pin quét loang loáng",
  },
  {
    word: "nhoàng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (sự việc xảy ra) rất nhanh, như chỉ trong giây lát: làm nhoàng cái là xong",
    example: "làm nhoàng cái là xong",
  },
  {
    word: "nhóc",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) trẻ con (hàm ý thân mật, vui đùa): bọn nhóc * chú nhóc",
    example: "bọn nhóc * chú nhóc",
  },
  {
    word: "nhọc",
    part_of_speech: "",
    meaning:
      "cảm thấy mệt, khó chịu trong người vì đã phải bỏ nhiều sức lực, phải vất vả: cả ngày chỉ giặt giũ, cơm nước cũng đủ nhọc * nghĩ làm gì cho thêm nhọc",
    example:
      "cả ngày chỉ giặt giũ, cơm nước cũng đủ nhọc * nghĩ làm gì cho thêm nhọc",
  },
  {
    word: "nhóc con",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) như nhóc (hàm ý coi thường): thằng nhóc con! * nhóc con mà dám lên mặt!",
    example: "thằng nhóc con! * nhóc con mà dám lên mặt!",
  },
  {
    word: "nhọc lòng",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái phải lo lắng, suy nghĩ nhiều về việc gì: nhọc lòng lo nghĩ",
    example: "nhọc lòng lo nghĩ",
  },
  {
    word: "nhọc nhằn",
    part_of_speech: "tính từ",
    meaning:
      'khó nhọc, vất vả: "Dã tràng xe cát biển Đông, Nhọc nhằn mà chẳng nên công cán gì." (ca dao)',
    example:
      'Dã tràng xe cát biển Đông, Nhọc nhằn mà chẳng nên công cán gì." (ca dao)',
  },
  {
    word: "nhoè nhoẹt",
    part_of_speech: "tính từ",
    meaning:
      "nhoè bẩn ra ở nhiều chỗ: tờ giấy bị ngấm nước, chữ nhoè nhoẹt, rất khó đọc",
    example: "tờ giấy bị ngấm nước, chữ nhoè nhoẹt, rất khó đọc",
  },
  {
    word: "nhóc nhách",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) từ mô phỏng tiếng nhai nhỏ, thong thả và lâu (thường khi nhai vật dai): nhai trầu nhóc nhách",
    example: "nhai trầu nhóc nhách",
  },
  {
    word: "nhoe nhoét",
    part_of_speech: "tính từ",
    meaning:
      "dây loang ra, trông bẩn mắt: chân nhoe nhoét bùn đất * mực dây nhoe nhoét ra sách vở",
    example: "chân nhoe nhoét bùn đất * mực dây nhoe nhoét ra sách vở",
  },
  {
    word: "nhoẻn",
    part_of_speech: "động từ",
    meaning:
      "(miệng) mở ra cười một cách tự nhiên, thoải mái: nhoẻn miệng cười",
    example: "nhoẻn miệng cười",
  },
  {
    word: "nhoè",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) (ăn uống hoặc tiêu dùng) một cách thoả thích: ngần ấy thì ăn nhoè * tiêu nhoè cũng không hết",
    example: "ngần ấy thì ăn nhoè * tiêu nhoè cũng không hết",
  },
  {
    word: "nhoèn",
    part_of_speech: "tính từ",
    meaning: "(mắt) ướt, dính nhiều dử: mắt nhoèn dử * toét nhoèn",
    example: "mắt nhoèn dử * toét nhoèn",
  },
  {
    word: "nhoét",
    part_of_speech: "tính từ",
    meaning:
      "nhão hay ướt quá mức, gây cảm giác nhớp nháp, khó chịu: mưa nhiều, đường đất nhoét ra * người ướt nhoét mồ hôi",
    example: "mưa nhiều, đường đất nhoét ra * người ướt nhoét mồ hôi",
  },
  {
    word: "nhoen nhoẻn",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) từ gợi tả điệu nói, cười luôn miệng một cách quá tự nhiên, đến mức trở thành vô duyên: mồm miệng nhoen nhoẻn cả ngày",
    example: "mồm miệng nhoen nhoẻn cả ngày",
  },
  {
    word: "nhoẹt",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như nhoét (nhưng nghĩa mạnh hơn): quần áo ướt nhoẹt",
    example: "quần áo ướt nhoẹt",
  },
  {
    word: "nhoi nhói",
    part_of_speech: "tính từ",
    meaning: "hơi nhói: chỗ đau thỉnh thoảng lại nhoi nhói",
    example: "chỗ đau thỉnh thoảng lại nhoi nhói",
  },
  {
    word: "nhỏm",
    part_of_speech: "động từ",
    meaning:
      "cử động người để ngồi dậy hoặc đứng lên: ngồi nhổm dậy * đang nằm cũng nhổm lên nhìn",
    example: "ngồi nhổm dậy * đang nằm cũng nhổm lên nhìn",
  },
  {
    word: "nhóm",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp gồm một số cá thể được hình thành theo những nguyên tắc nhất định: chia đoàn thành các nhóm * nhóm trinh sát * hai người cùng nhóm máu O",
    example:
      "chia đoàn thành các nhóm * nhóm trinh sát * hai người cùng nhóm máu O",
  },
  {
    word: "nhóm",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tụ tập nhau lại để cùng làm một việc gì: chợ nhóm vào buổi sáng * nhóm lại thành giàu, chia nhau thành khó (tng)",
    example:
      "chợ nhóm vào buổi sáng * nhóm lại thành giàu, chia nhau thành khó (tng)",
  },
  {
    word: "nhóm",
    part_of_speech: "động từ",
    meaning:
      "làm cho lửa bắt vào để cháy lên: nhóm bếp nấu cơm * củi ướt nên khó nhóm",
    example: "nhóm bếp nấu cơm * củi ướt nên khó nhóm",
  },
  {
    word: "nhóm",
    part_of_speech: "động từ",
    meaning:
      "bắt đầu có được cơ sở để từ đó có thể phát triển lên: phong trào mới nhóm lên",
    example: "phong trào mới nhóm lên",
  },
  {
    word: "nhoi",
    part_of_speech: "động từ",
    meaning:
      "(cũng nhoi) nhô lên một cách khó khăn từ trong nước hay trong bùn, đất: ngoi mình lên trên mặt nước",
    example: "ngoi mình lên trên mặt nước",
  },
  {
    word: "nhoi",
    part_of_speech: "động từ",
    meaning:
      "cố sức vươn lên vị trí cao hơn một cách khó nhọc (thường hàm ý khinh): ngoi mãi mới lên tới chức trưởng phòng",
    example: "ngoi mãi mới lên tới chức trưởng phòng",
  },
  {
    word: "nhòm ngó",
    part_of_speech: "động từ",
    meaning:
      "để ý quan sát theo dõi nhằm thực hiện ý đồ không tốt: bị kẻ trộm dòm ngó",
    example: "bị kẻ trộm dòm ngó",
  },
  {
    word: "nhòm ngó",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) để ý, quan tâm đến người khác giới (thường nói về người con trai đối với người con gái): xinh đẹp nên được nhiều anh dòm ngó",
    example: "xinh đẹp nên được nhiều anh dòm ngó",
  },
  {
    word: "nhói",
    part_of_speech: "tính từ",
    meaning:
      "bị đau nhức đột ngột, tựa như có vật nhọn xoáy sâu vào: vết thương thỉnh thoảng lại nhói lên",
    example: "vết thương thỉnh thoảng lại nhói lên",
  },
  {
    word: "nhóm họp",
    part_of_speech: "động từ",
    meaning: "họp nhau lại để bàn công việc chung: nhóm họp để bàn bạc",
    example: "nhóm họp để bàn bạc",
  },
  {
    word: "nhòm",
    part_of_speech: "động từ",
    meaning:
      "nhìn và quan sát kĩ để dò xét hoặc để tìm kiếm cái gì: dòm qua khe cửa * ghé mắt dòm vào",
    example: "dòm qua khe cửa * ghé mắt dòm vào",
  },
  {
    word: "nhòm",
    part_of_speech: "động từ",
    meaning: "(Phương ngữ) nhìn, trông: dòm trước dòm sau mới đi",
    example: "dòm trước dòm sau mới đi",
  },
  {
    word: "nhom nhem",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ, hiếm) như hom hem: nhom nhem như ông lão tám mươi",
    example: "nhom nhem như ông lão tám mươi",
  },
  {
    word: "nhon nhón",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả dáng đi, chạy nhanh và nhẹ bằng các đầu ngón chân với những bước ngắn: bé nhon nhón chạy ra cửa đón mẹ",
    example: "bé nhon nhón chạy ra cửa đón mẹ",
  },
  {
    word: "nhọn hoắt",
    part_of_speech: "tính từ",
    meaning: "rất nhọn, đến mức gây cảm giác ghê sợ: ngọn chông nhọn hoắt",
    example: "ngọn chông nhọn hoắt",
  },
  {
    word: "nhọn",
    part_of_speech: "tính từ",
    meaning:
      "(vật) có phần đầu nhỏ dần lại, dễ đâm thủng vật khác: cái gai nhọn * vót chông cho nhọn * vỏ quýt dày có móng tay nhọn (tng)",
    example:
      "cái gai nhọn * vót chông cho nhọn * vỏ quýt dày có móng tay nhọn (tng)",
  },
  {
    word: "nhọn",
    part_of_speech: "tính từ",
    meaning: "(góc hình học) nhỏ hơn một góc vuông: góc nhọn",
    example: "góc nhọn",
  },
  {
    word: "nhón",
    part_of_speech: "động từ",
    meaning:
      "lấy vật rời, vụn một cách nhẹ nhàng bằng mấy đầu ngón tay chụm lại: nhón mấy hạt muối * nhón tay làm phúc (b)",
    example: "nhón mấy hạt muối * nhón tay làm phúc (b)",
  },
  {
    word: "nhón",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) lấy đi món tiền hay vật nhỏ một cách nhanh gọn: bị kẻ gian nhón mất chiếc ví",
    example: "bị kẻ gian nhón mất chiếc ví",
  },
  {
    word: "nhón",
    part_of_speech: "động từ",
    meaning:
      "nhấc cao hẳn gót chân lên, chỉ để các đầu ngón chân tiếp xúc với mặt nền: nhón gót với lấy quyển sách * nhón chân đi nhẹ nhàng",
    example: "nhón gót với lấy quyển sách * nhón chân đi nhẹ nhàng",
  },
  {
    word: "nhòn nhọn",
    part_of_speech: "tính từ",
    meaning: "hơi nhọn: cái cằm nhòn nhọn",
    example: "cái cằm nhòn nhọn",
  },
  {
    word: "nhõng nha nhõng nhẽo",
    part_of_speech: "",
    meaning:
      "rất nhõng nhẽo, gây cảm giác khó chịu: lớn rồi mà vẫn còn nhõng nha nhõng nhẽo",
    example: "lớn rồi mà vẫn còn nhõng nha nhõng nhẽo",
  },
  {
    word: "nhỏng nhảnh",
    part_of_speech: "tính từ",
    meaning:
      '(phương ngữ, hiếm) như đỏng đảnh: "Nhông nhông như chiếc sào chong, Lại còn nhỏng nhảnh kén chồng trai tơ." (ca dao)',
    example:
      'Nhông nhông như chiếc sào chong, Lại còn nhỏng nhảnh kén chồng trai tơ." (ca dao)',
  },
  {
    word: "nhóng",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) rướn cao lên: nhóng cổ lên nhìn",
    example: "nhóng cổ lên nhìn",
  },
  {
    word: "nhót",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) bỏ đi nơi khác một cách lặng lẽ, nhanh chóng trong lúc mọi người không chú ý đến: sểnh ra một cái là nhót đi chơi mất",
    example: "sểnh ra một cái là nhót đi chơi mất",
  },
  {
    word: "nhót",
    part_of_speech: "động từ",
    meaning: "(Khẩu ngữ) như nhón (ng2): nhót lấy một củ khoai",
    example: "nhót lấy một củ khoai",
  },
  {
    word: "nhong nhong",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng nhạc ngựa đều đều, nhịp nhàng theo từng bước ngựa chạy: cưỡi ngựa nhong nhong",
    example: "cưỡi ngựa nhong nhong",
  },
  {
    word: "nhong nhong",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) đi, chạy như kiểu ngựa chạy chậm: chó chạy nhong nhong * đi nhong nhong ngoài đường",
    example: "chó chạy nhong nhong * đi nhong nhong ngoài đường",
  },
  {
    word: "nhõng nhẽo",
    part_of_speech: "",
    meaning:
      "làm ra vẻ không bằng lòng để đòi hỏi người khác phải chiều theo ý mình (thường nói về trẻ con hoặc phụ nữ): tính hay nhõng nhẽo",
    example: "tính hay nhõng nhẽo",
  },
  {
    word: "nhong nhóng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ở tình trạng nhàn rỗi chỉ ngồi chờ ăn hoặc đi lông bông, không làm việc gì: chỉ nhong nhóng suốt ngày!",
    example: "chỉ nhong nhóng suốt ngày!",
  },
  {
    word: "nhọt",
    part_of_speech: "danh từ",
    meaning:
      "nốt viêm sinh mủ nổi trên cơ thể, tương đối to, khi chín thường có ngòi, gây đau nhức: nóng quá, người nổi nhọt",
    example: "nóng quá, người nổi nhọt",
  },
  {
    word: "nhô",
    part_of_speech: "động từ",
    meaning:
      "đưa phần đầu cho vượt hẳn lên phía trên hoặc ra phía trước, so với những cái xung quanh: nhô đầu lên miệng hầm * vách núi nhô ra biển",
    example: "nhô đầu lên miệng hầm * vách núi nhô ra biển",
  },
  {
    word: "nhóp nhép",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như tóp tép: miệng nhai nhóp nhép",
    example: "miệng nhai nhóp nhép",
  },
  {
    word: "nhổ",
    part_of_speech: "động từ",
    meaning: "làm cho vật đang ngậm trong miệng vọt ra ngoài: nhổ nước bọt",
    example: "nhổ nước bọt",
  },
  {
    word: "nhổ",
    part_of_speech: "động từ",
    meaning:
      "làm cho một vật rời ra và lìa khỏi chỗ nó được cắm vào bằng cách lay, kéo, giật mạnh: nhổ cỏ * nhổ râu * nhổ mấy cái cọc lên * nhổ được cái gai trong mắt (b)",
    example:
      "nhổ cỏ * nhổ râu * nhổ mấy cái cọc lên * nhổ được cái gai trong mắt (b)",
  },
  {
    word: "nhổ neo",
    part_of_speech: "động từ",
    meaning:
      "(tàu thuyền) kéo neo lên để rời bến đi nơi khác: thuyền đã nhổ neo",
    example: "thuyền đã nhổ neo",
  },
  {
    word: "nhồi",
    part_of_speech: "động từ",
    meaning:
      "nhét vào, ấn vào cho đầy, cho căng: nhồi thuốc vào tẩu * thú nhồi bông * nhồi hàng chục người vào thùng xe",
    example:
      "nhồi thuốc vào tẩu * thú nhồi bông * nhồi hàng chục người vào thùng xe",
  },
  {
    word: "nhồi",
    part_of_speech: "động từ",
    meaning: "===== (phương ngữ): nhồi bột làm bánh * nhồi đất nặn tượng",
    example: "nhồi bột làm bánh * nhồi đất nặn tượng",
  },
  {
    word: "nhố nhăng",
    part_of_speech: "tính từ",
    meaning:
      "lố lắm, đến mức làm chướng tai gai mắt: ăn mặc lố lăng * toàn làm những trò lố lăng",
    example: "ăn mặc lố lăng * toàn làm những trò lố lăng",
  },
  {
    word: "nhôm",
    part_of_speech: "danh từ",
    meaning:
      "kim loại nhẹ, màu trắng, khó gỉ, dễ dát mỏng, dẫn nhiệt và dẫn điện tốt, dùng để chế hợp kim dùng trong công nghiệp hoặc làm đồ dùng hằng ngày: mâm nhôm * chậu nhôm",
    example: "mâm nhôm * chậu nhôm",
  },
  {
    word: "nhồi lắc",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) dồi và lắc (nói khái quát): sóng lớn làm con tàu bị nhồi lắc mạnh",
    example: "sóng lớn làm con tàu bị nhồi lắc mạnh",
  },
  {
    word: "nhồi nhét",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nhét vào, dồn vào một số lượng quá nhiều so với vật chứa: cố nhồi nhét cho được nhiều * nhồi nhét hàng chục người vào xe",
    example: "cố nhồi nhét cho được nhiều * nhồi nhét hàng chục người vào xe",
  },
  {
    word: "nhồi nhét",
    part_of_speech: "động từ",
    meaning:
      "bắt đầu óc phải tiếp nhận thật nhiều kiến thức, tư tưởng một cách không thật cần thiết, thậm chí còn có hại: nhồi nhét kiến thức * bị nhồi nhét đủ thứ vào đầu",
    example: "nhồi nhét kiến thức * bị nhồi nhét đủ thứ vào đầu",
  },
  {
    word: "nhồi sọ",
    part_of_speech: "động từ",
    meaning:
      "nhồi nhét lượng kiến thức chỉ cốt cho nhiều, quá sức tiếp thu hoặc không thật cần thiết: lối học nhồi sọ, cốt cho được nhiều",
    example: "lối học nhồi sọ, cốt cho được nhiều",
  },
  {
    word: "nhồi sọ",
    part_of_speech: "động từ",
    meaning:
      "làm cho thấm dần, ăn sâu vào đầu óc rồi mù quáng tin theo: bị nhồi sọ tư tưởng phản động",
    example: "bị nhồi sọ tư tưởng phản động",
  },
  {
    word: "nhôm nhoam",
    part_of_speech: "tính từ",
    meaning: "nham nhở, bẩn thỉu: mặt mũi nhôm nhoam",
    example: "mặt mũi nhôm nhoam",
  },
  {
    word: "nhồm nhoàm",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) từ gợi tả động tác ăn uống thô tục, nhai đầy mồm: ăn uống nhồm nhoàm * nhai nhồm nhoàm",
    example: "ăn uống nhồm nhoàm * nhai nhồm nhoàm",
  },
  {
    word: "nhốn nháo",
    part_of_speech: "động từ",
    meaning:
      "diễn ra cảnh hỗn loạn khác thường do hoạt động của một số đông bị hoảng sợ: đám đông nhốn nháo, xô đẩy nhau",
    example: "đám đông nhốn nháo, xô đẩy nhau",
  },
  {
    word: "nhổm",
    part_of_speech: "động từ",
    meaning:
      "cử động người để ngồi dậy hoặc đứng lên: ngồi nhổm dậy * đang nằm cũng nhổm lên nhìn",
    example: "ngồi nhổm dậy * đang nằm cũng nhổm lên nhìn",
  },
  {
    word: "nhộn nhạo",
    part_of_speech: "",
    meaning:
      "ở tình trạng lộn xộn, ồn ào, không ổn định, không yên: đám đông nhộn nhạo * tình hình đang nhộn nhạo",
    example: "đám đông nhộn nhạo * tình hình đang nhộn nhạo",
  },
  {
    word: "nhộn",
    part_of_speech: "tính từ",
    meaning:
      "có cái vẻ ồn ào, sôi nổi do đông người tạo ra: không khí ngày mùa rất nhộn * mỗi người một câu làm nhộn hẳn lên",
    example: "không khí ngày mùa rất nhộn * mỗi người một câu làm nhộn hẳn lên",
  },
  {
    word: "nhộn",
    part_of_speech: "tính từ",
    meaning: "có tác dụng tạo không khí vui hơi ồn ào: tính rất nhộn",
    example: "tính rất nhộn",
  },
  {
    word: "nhộn nhịp",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả không khí đông vui, tấp nập, do có nhiều người qua lại hoặc cùng tham gia hoạt động: không khí nhộn nhịp ngày khai trường",
    example: "không khí nhộn nhịp ngày khai trường",
  },
  {
    word: "nhồn nhột",
    part_of_speech: "tính từ",
    meaning: "hơi nhột: thấy nhồn nhột nơi sống lưng",
    example: "thấy nhồn nhột nơi sống lưng",
  },
  {
    word: "nhông",
    part_of_speech: "danh từ",
    meaning:
      "bánh răng nhỏ liền trục để truyền chuyển động từ động cơ đến các bộ phận kéo tải khác: thay nhông xe",
    example: "thay nhông xe",
  },
  {
    word: "nhông",
    part_of_speech: "phụ từ",
    meaning:
      "(đi, chạy) khắp mọi nơi, mọi chỗ không nhằm mục đích gì cả: lũ trẻ chạy nhông khắp xóm * đi nhông ngoài đường",
    example: "lũ trẻ chạy nhông khắp xóm * đi nhông ngoài đường",
  },
  {
    word: "nhồng",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) ngồng: nhồng cải",
    example: "nhồng cải",
  },
  {
    word: "nhơ",
    part_of_speech: "tính từ",
    meaning:
      'xấu xa về phẩm chất: "Ví bằng theo thói người ta, Uốn lưng co gối cũng nhơ một đời." (NĐM)',
    example:
      'Ví bằng theo thói người ta, Uốn lưng co gối cũng nhơ một đời." (NĐM)',
  },
  {
    word: "nhột",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) buồn (do bị kích thích trên da): bị nhột, không nhịn được cười",
    example: "bị nhột, không nhịn được cười",
  },
  {
    word: "nhột",
    part_of_speech: "tính từ",
    meaning: "chột dạ: thấy có người nhìn mình, hắn đã hơi nhột",
    example: "thấy có người nhìn mình, hắn đã hơi nhột",
  },
  {
    word: "nhộng",
    part_of_speech: "danh từ",
    meaning:
      "hình thái của một số sâu bọ trước khi thành bướm: nhộng tằm * trần như nhộng",
    example: "nhộng tằm * trần như nhộng",
  },
  {
    word: "nhột nhạt",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) bứt rứt, khó chịu: thấy trong người nhột nhạt",
    example: "thấy trong người nhột nhạt",
  },
  {
    word: "nhốt",
    part_of_speech: "động từ",
    meaning:
      "giữ ở trong chuồng, cũi, hay nơi được chắn kín, không cho tự do đi lại, hoạt động: nhốt gà vào chuồng * bị nhốt trong nhà lao",
    example: "nhốt gà vào chuồng * bị nhốt trong nhà lao",
  },
  {
    word: "nhớ",
    part_of_speech: "động từ",
    meaning:
      "giữ lại trong trí điều đã cảm biết, nhận biết để rồi sau đó có thể tái hiện được: nhớ lời mẹ dặn * nhiều việc quá, nhớ không xuể * uống nước nhớ nguồn (tng)",
    example:
      "nhớ lời mẹ dặn * nhiều việc quá, nhớ không xuể * uống nước nhớ nguồn (tng)",
  },
  {
    word: "nhớ",
    part_of_speech: "động từ",
    meaning:
      "tái hiện ra trong trí điều trước đó đã từng được cảm biết, nhận biết: nhớ lại chuyện cũ * nhớ lõm bõm được mấy câu thơ * nhắc lại cho nhớ",
    example:
      "nhớ lại chuyện cũ * nhớ lõm bõm được mấy câu thơ * nhắc lại cho nhớ",
  },
  {
    word: "nhớ",
    part_of_speech: "động từ",
    meaning:
      "nghĩ đến (người hay cảnh thân thiết nào đó hiện đang ở cách xa) với tình cảm tha thiết muốn được gặp, được thấy: nhớ quê hương * nhớ nhà * nỗi nhớ khôn nguôi",
    example: "nhớ quê hương * nhớ nhà * nỗi nhớ khôn nguôi",
  },
  {
    word: "nhớ",
    part_of_speech: "động từ",
    meaning:
      "giữ một con số để cộng nhẩm nó ở cột sau với số trên trong một phép tính cộng, số dưới trong một phép tính trừ hoặc tích trong một phép tính nhân: 5 nhân 2 là 10, viết 0 nhớ 1",
    example: "5 nhân 2 là 10, viết 0 nhớ 1",
  },
  {
    word: "nhớ",
    part_of_speech: "trợ từ",
    meaning:
      "(khẩu ngữ) như nhé (hàm ý thân mật, âu yếm): thế thôi nhớ! * con đi, mẹ nhớ! * để tôi giúp anh nhớ!",
    example: "thế thôi nhớ! * con đi, mẹ nhớ! * để tôi giúp anh nhớ!",
  },
  {
    word: "nhờ",
    part_of_speech: "động từ",
    meaning:
      'yêu cầu người khác làm giúp cho việc gì: nhờ người làm giúp * "Nhạn ơi trăm sự nhờ mày, Ngậm thư mang tới tận tay cho chàng." (ca dao)',
    example:
      'nhờ người làm giúp * "Nhạn ơi trăm sự nhờ mày, Ngậm thư mang tới tận tay cho chàng." (ca dao)',
  },
  {
    word: "nhờ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) hưởng sự giúp đỡ: một người làm quan cả họ được nhờ (tng)",
    example: "một người làm quan cả họ được nhờ (tng)",
  },
  {
    word: "nhờ",
    part_of_speech: "động từ",
    meaning:
      "từ biểu thị hoạt động vừa nói đến được thực hiện dựa vào sự giúp đỡ về phương tiện hoặc điều kiện của người khác: đi nhờ xe * ở nhờ nhà bạn * sống nhờ vào người khác",
    example: "đi nhờ xe * ở nhờ nhà bạn * sống nhờ vào người khác",
  },
  {
    word: "nhờ",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nói ra là nguyên nhân dẫn đến kết quả tốt đẹp, khả quan được nói đến: nhờ giời, tôi vẫn mạnh khoẻ * nhờ có anh mà nó mới được như ngày nay",
    example:
      "nhờ giời, tôi vẫn mạnh khoẻ * nhờ có anh mà nó mới được như ngày nay",
  },
  {
    word: "nhờ",
    part_of_speech: "tính từ",
    meaning:
      "có màu mờ đục, không được sáng và trong: màu trắng nhờ * đám mây đen nhờ",
    example: "màu trắng nhờ * đám mây đen nhờ",
  },
  {
    word: "nhợ",
    part_of_speech: "danh từ",
    meaning: "===== (phương ngữ): buộc nhợ vào cần câu",
    example: "buộc nhợ vào cần câu",
  },
  {
    word: "nhơ bẩn",
    part_of_speech: "tính từ",
    meaning: "bẩn thỉu, xấu xa đến mức đáng ghê tởm: bộ mặt xấu xa, nhơ bẩn",
    example: "bộ mặt xấu xa, nhơ bẩn",
  },
  {
    word: "nhờ cậy",
    part_of_speech: "động từ",
    meaning:
      "dựa vào, trông vào sự giúp đỡ của người khác (nói khái quát): nhờ cậy bạn bè khi khó khăn",
    example: "nhờ cậy bạn bè khi khó khăn",
  },
  {
    word: "nhờ nhờ",
    part_of_speech: "tính từ",
    meaning:
      "hơi có màu trắng đục, không được sáng và trong: trắng nhờ nhờ * lớp sương nhờ nhờ như khói",
    example: "trắng nhờ nhờ * lớp sương nhờ nhờ như khói",
  },
  {
    word: "nhớ đời",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nhớ mãi suốt đời (thường nói về những gì không hay đã tác động mạnh mẽ đến mình): bài học nhớ đời * miếng ngon nhớ lâu, đòn đau nhớ đời (tng)",
    example: "bài học nhớ đời * miếng ngon nhớ lâu, đòn đau nhớ đời (tng)",
  },
  {
    word: "nhỡ nhàng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) như lỡ làng (nhưng thường nói về những sự việc không quan trọng lắm): duyên phận nhỡ nhàng",
    example: "duyên phận nhỡ nhàng",
  },
  {
    word: "nhờ nhỡ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (kích cỡ) vừa phải, không lớn lắm nhưng cũng không bé lắm: chọn loại nồi nhờ nhỡ * mua một con lợn nhờ nhỡ",
    example: "chọn loại nồi nhờ nhỡ * mua một con lợn nhờ nhỡ",
  },
  {
    word: "nhơ nhớ",
    part_of_speech: "động từ",
    meaning: "cảm thấy hơi nhớ: đi xa cũng thấy nhơ nhớ",
    example: "đi xa cũng thấy nhơ nhớ",
  },
  {
    word: "nhơ nhớp",
    part_of_speech: "tính từ",
    meaning:
      "nhơ bẩn đến mức thậm tệ: nhà cửa để nhơ nhớp * đồng tiền nhơ nhớp",
    example: "nhà cửa để nhơ nhớp * đồng tiền nhơ nhớp",
  },
  {
    word: "nhớ mong",
    part_of_speech: "động từ",
    meaning:
      'như mong nhớ: "Chẳng may chim nhạn lạc đàn, Chim trời bay mất, để chàng nhớ mong." (ca dao)',
    example:
      'Chẳng may chim nhạn lạc đàn, Chim trời bay mất, để chàng nhớ mong." (ca dao)',
  },
  {
    word: "nhớ nhung",
    part_of_speech: "động từ",
    meaning: "nhớ đến, nghĩ đến một cách da diết khôn nguôi: nhớ nhung da diết",
    example: "nhớ nhung da diết",
  },
  {
    word: "nhơ nhuốc",
    part_of_speech: "tính từ",
    meaning: "xấu xa, nhục nhã: bộ mặt xấu xa, nhơ nhuốc * tấm thân nhơ nhuốc",
    example: "bộ mặt xấu xa, nhơ nhuốc * tấm thân nhơ nhuốc",
  },
  {
    word: "nhớ tiếc",
    part_of_speech: "động từ",
    meaning:
      "nhớ đến với lòng luyến tiếc (người nào hay những gì đó đáng quý mà đã vĩnh viễn mất đi, qua đi): nhớ tiếc tuổi xuân * bùi ngùi nhớ tiếc",
    example: "nhớ tiếc tuổi xuân * bùi ngùi nhớ tiếc",
  },
  {
    word: "nhỡ ra",
    part_of_speech: "kết từ",
    meaning:
      "(khẩu ngữ) như nhỡ (nhưng nhấn mạnh ý giả thiết hơn): không biết thì đừng nói, nhỡ ra vạ miệng thì khốn",
    example: "không biết thì đừng nói, nhỡ ra vạ miệng thì khốn",
  },
  {
    word: "nhớ thương",
    part_of_speech: "động từ",
    meaning: "như thương nhớ: nhớ thương con",
    example: "nhớ thương con",
  },
  {
    word: "nhơi",
    part_of_speech: "động từ",
    meaning: "(trâu, bò, v.v.) nhai lại lần thứ hai: bò nằm nhơi cỏ",
    example: "bò nằm nhơi cỏ",
  },
  {
    word: "nhờ vả",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) làm phiền đến người khác, dựa vào sự giúp đỡ của người khác (nói khái quát): khó khăn phải nhờ vả bạn bè * không muốn nhờ vả người khác",
    example: "khó khăn phải nhờ vả bạn bè * không muốn nhờ vả người khác",
  },
  {
    word: "nhớm",
    part_of_speech: "động từ",
    meaning: "nhấc cao lên một chút: nhớm gót nhìn vào",
    example: "nhớm gót nhìn vào",
  },
  {
    word: "nhởi",
    part_of_speech: "động từ",
    meaning: "chơi: đi nhởi",
    example: "đi nhởi",
  },
  {
    word: "nhớn",
    part_of_speech: "",
    meaning:
      "(phương ngữ, khẩu ngữ) lớn (thường nói về người): đứa con nhớn * mọi việc nhớn bé trong nhà đều một tay nó làm",
    example: "đứa con nhớn * mọi việc nhớn bé trong nhà đều một tay nó làm",
  },
  {
    word: "nhờn",
    part_of_speech: "động từ",
    meaning:
      "không giữ được thái độ đúng mực, lễ phép như ban đầu, do coi thường sau nhiều lần tiếp xúc dễ dãi: dễ quá để bọn trẻ nó nhờn * coi nhờn phép nước",
    example: "dễ quá để bọn trẻ nó nhờn * coi nhờn phép nước",
  },
  {
    word: "nhờn",
    part_of_speech: "động từ",
    meaning:
      "trơ ra, không còn chịu tác động nữa do đã quá quen, quá nhàm: cơ thể đã nhờn kháng sinh",
    example: "cơ thể đã nhờn kháng sinh",
  },
  {
    word: "nhờn",
    part_of_speech: "tính từ",
    meaning:
      "trơn và láng vì có chất dầu, mỡ: cái chảo nhờn mỡ * dầu mỡ nhờn tay * được một bữa nhờn môi (kng)",
    example: "cái chảo nhờn mỡ * dầu mỡ nhờn tay * được một bữa nhờn môi (kng)",
  },
  {
    word: "nhơm nhớp",
    part_of_speech: "tính từ",
    meaning: "hơi nhớp: mồ hôi nhơm nhớp",
    example: "mồ hôi nhơm nhớp",
  },
  {
    word: "nhởn nha",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như nhởn nhơ: đàn bò nhởn nha gặm cỏ",
    example: "đàn bò nhởn nha gặm cỏ",
  },
  {
    word: "nhởn nhơ",
    part_of_speech: "tính từ",
    meaning:
      "có vẻ thong thả, ung dung, tựa như không có điều gì phải quan tâm, phải lo nghĩ: nhởn nhơ dạo chơi * sống nhởn nhơ ngoài vòng pháp luật",
    example: "nhởn nhơ dạo chơi * sống nhởn nhơ ngoài vòng pháp luật",
  },
  {
    word: "nhớn nhao",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ, khẩu ngữ) lớn (nói khái quát; thường chỉ nói về người): thằng bé mới có tí tuổi chứ đã nhớn nhao gì!",
    example: "thằng bé mới có tí tuổi chứ đã nhớn nhao gì!",
  },
  {
    word: "nhơn nhơn",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra trơ lì, không có chút gì kiêng sợ hoặc xấu hổ: nhơn nhơn cái mặt * nhơn nhơn tự đắc",
    example: "nhơn nhơn cái mặt * nhơn nhơn tự đắc",
  },
  {
    word: "nhờn nhợt",
    part_of_speech: "tính từ",
    meaning:
      'hơi nhợt: "Thoắt trông nhờn nhợt màu da, Ăn chi cao lớn đẫy đà làm sao?" (TKiều)',
    example:
      'Thoắt trông nhờn nhợt màu da, Ăn chi cao lớn đẫy đà làm sao?" (TKiều)',
  },
  {
    word: "nhớn nhác",
    part_of_speech: "tính từ",
    meaning:
      "có vẻ sợ hãi, luống cuống, quay nhìn chỗ này chỗ khác để tìm lối thoát: mắt nhớn nhác nhìn quanh * nhớn nhác như gà con lạc mẹ",
    example: "mắt nhớn nhác nhìn quanh * nhớn nhác như gà con lạc mẹ",
  },
  {
    word: "nhớp",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) bẩn: tay nhớp * quần áo bị nhớp hết cả",
    example: "tay nhớp * quần áo bị nhớp hết cả",
  },
  {
    word: "nhớp nháp",
    part_of_speech: "tính từ",
    meaning:
      "bẩn thỉu và ướt át, gây cảm giác khó chịu: đường sá nhớp nháp bùn đất",
    example: "đường sá nhớp nháp bùn đất",
  },
  {
    word: "nhớp nhơ",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như nhơ nhớp: lạc thú nhớp nhơ * tấm thân nhớp nhơ",
    example: "lạc thú nhớp nhơ * tấm thân nhớp nhơ",
  },
  {
    word: "nhớt nhát",
    part_of_speech: "tính từ",
    meaning:
      "có chất nhờn dinh dính và bẩn (nói khái quát): người nhớt nhát mồ hôi",
    example: "người nhớt nhát mồ hôi",
  },
  {
    word: "nhớp nhúa",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) bẩn thỉu và ướt át: toàn thân nhớp nhúa mồ hôi",
    example: "toàn thân nhớp nhúa mồ hôi",
  },
  {
    word: "nhợt",
    part_of_speech: "tính từ",
    meaning:
      "(màu sắc) phai đi, giảm độ sáng đi, không tươi: trắng nhợt * nước da xanh nhợt * bóng tối đã nhợt dần",
    example: "trắng nhợt * nước da xanh nhợt * bóng tối đã nhợt dần",
  },
  {
    word: "nhợt nhạt",
    part_of_speech: "tính từ",
    meaning: "nhợt (nói khái quát): đôi môi nhợt nhạt * nước da nhợt nhạt",
    example: "đôi môi nhợt nhạt * nước da nhợt nhạt",
  },
  {
    word: "nhợt nhạt",
    part_of_speech: "tính từ",
    meaning: "nhạt và yếu, không tươi: ánh sáng nhợt nhạt * màu sắc nhợt nhạt",
    example: "ánh sáng nhợt nhạt * màu sắc nhợt nhạt",
  },
  {
    word: "nhú",
    part_of_speech: "động từ",
    meaning:
      "mới nhô lên, bắt đầu hiện ra một phần: mầm cây nhú lên khỏi mặt đất * cây nhú chồi non * răng mới nhú",
    example: "mầm cây nhú lên khỏi mặt đất * cây nhú chồi non * răng mới nhú",
  },
  {
    word: "nhớt",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất dễ dính và khó chảy: nhớt như canh mồng tơi * độ nhớt của dầu",
    example: "nhớt như canh mồng tơi * độ nhớt của dầu",
  },
  {
    word: "nhớt",
    part_of_speech: "danh từ",
    meaning:
      "chất nhầy ở ngoài da một số động vật: da lươn có nhớt * nhớt cá trê",
    example: "da lươn có nhớt * nhớt cá trê",
  },
  {
    word: "nhớt",
    part_of_speech: "danh từ",
    meaning: "(Nam) dầu nhớt (nói tắt): xăng pha nhớt * thay nhớt",
    example: "xăng pha nhớt * thay nhớt",
  },
  {
    word: "nhu",
    part_of_speech: "tính từ",
    meaning:
      "mềm mỏng, mềm dẻo trong ứng xử: ứng xử phải có lúc nhu lúc cương * lấy nhu thắng cương",
    example: "ứng xử phải có lúc nhu lúc cương * lấy nhu thắng cương",
  },
  {
    word: "nhũ",
    part_of_speech: "danh từ",
    meaning: "kim nhũ (nói tắt): chữ ngoài bìa mạ nhũ óng ánh",
    example: "chữ ngoài bìa mạ nhũ óng ánh",
  },
  {
    word: "nhu động",
    part_of_speech: "động từ",
    meaning:
      "cử động co bóp của ống tiêu hoá nhịp nhàng theo lối lượn sóng để nhào trộn thức ăn: nhu động ruột",
    example: "nhu động ruột",
  },
  {
    word: "nhu nhú",
    part_of_speech: "động từ",
    meaning: "hơi nhú lên chút ít: răng mọc nhu nhú",
    example: "răng mọc nhu nhú",
  },
  {
    word: "nhủ",
    part_of_speech: "động từ",
    meaning:
      "tự bảo, tự khuyên mình: tự nhủ phải bình tĩnh * thầm nhủ với lòng",
    example: "tự nhủ phải bình tĩnh * thầm nhủ với lòng",
  },
  {
    word: "nhủ",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) bảo: nhớ lời mẹ nhủ",
    example: "nhớ lời mẹ nhủ",
  },
  {
    word: "nhu cầu",
    part_of_speech: "danh từ",
    meaning:
      "điều đòi hỏi của đời sống, tự nhiên và xã hội: nhu cầu về ăn mặc * thoả mãn nhu cầu * không đáp ứng được nhu cầu của thị trường",
    example:
      "nhu cầu về ăn mặc * thoả mãn nhu cầu * không đáp ứng được nhu cầu của thị trường",
  },
  {
    word: "nhu mì",
    part_of_speech: "tính từ",
    meaning: "dịu hiền, mềm mỏng trong quan hệ đối xử: ăn nói nhu mì",
    example: "ăn nói nhu mì",
  },
  {
    word: "nhu nhược",
    part_of_speech: "tính từ",
    meaning:
      "yếu đuối, thiếu cương quyết, không dám có những phản ứng khi cần thiết: thái độ nhu nhược * con người nhu nhược",
    example: "thái độ nhu nhược * con người nhu nhược",
  },
  {
    word: "nhũ tương",
    part_of_speech: "danh từ",
    meaning:
      "hệ những hạt nhỏ chất lỏng lơ lửng trong một chất lỏng khác: sữa là một nhũ tương",
    example: "sữa là một nhũ tương",
  },
  {
    word: "nhuần",
    part_of_speech: "tính từ",
    meaning:
      '(cũ, văn chương) (mưa) tưới thấm sâu, đều khắp: "Lạy thôi nàng giở sầu xưa, Một lời một lúc hạt mưa tưới nhuần." (PT)',
    example:
      'Lạy thôi nàng giở sầu xưa, Một lời một lúc hạt mưa tưới nhuần." (PT)',
  },
  {
    word: "nhu yếu phẩm",
    part_of_speech: "danh từ",
    meaning:
      "vật phẩm cần thiết cho đời sống hằng ngày nói chung: gạo, vải, giấy, v.v. là những nhu yếu phẩm",
    example: "gạo, vải, giấy, v.v. là những nhu yếu phẩm",
  },
  {
    word: "nhuận bút",
    part_of_speech: "danh từ",
    meaning:
      "tiền trả cho tác giả có công trình văn hoá, nghệ thuật, khoa học được xuất bản hoặc được sử dụng: lĩnh nhuận bút * trả nhuận bút",
    example: "lĩnh nhuận bút * trả nhuận bút",
  },
  {
    word: "nhu quyền",
    part_of_speech: "danh từ",
    meaning:
      "quyền thuật có các động tác mềm mại, nhẹ nhàng: luyện tập nhu quyền",
    example: "luyện tập nhu quyền",
  },
  {
    word: "nhuận",
    part_of_speech: "tính từ",
    meaning:
      "(năm, tháng trong lịch) được thêm một ngày (vào tháng 2, theo dương lịch) hoặc một tháng (theo âm lịch) để bù lại khoảng thời gian hụt đi do cách tính lịch không phù hợp với chuyển động của Trái Đất xung quanh Mặt Trời: nhuận hai tháng 3 * năm 2003 là năm nhuận, tháng 2 có 29 ngày",
    example: "nhuận hai tháng 3 * năm 2003 là năm nhuận, tháng 2 có 29 ngày",
  },
  {
    word: "nhuần nhuyễn",
    part_of_speech: "tính từ",
    meaning:
      "đạt đến mức thành thạo, vận dụng một cách rất tự nhiên: luyện tập cho thật nhuần nhuyễn * kết hợp nhuần nhuyễn giữa lí thuyết và thực hành",
    example:
      "luyện tập cho thật nhuần nhuyễn * kết hợp nhuần nhuyễn giữa lí thuyết và thực hành",
  },
  {
    word: "nhuần nhị",
    part_of_speech: "tính từ",
    meaning:
      "có được sự kết hợp rất hài hoà, tự nhiên giữa các yếu tố: có sự kết hợp thật nhuần nhị giữa các yếu tố",
    example: "có sự kết hợp thật nhuần nhị giữa các yếu tố",
  },
  {
    word: "nhục",
    part_of_speech: "tính từ",
    meaning:
      "xấu hổ đến mức khó chịu đựng nổi, vì cảm thấy mình bị khinh bỉ hoặc đáng khinh bỉ, danh dự bị xúc phạm nặng nề: chịu nhục * chết vinh còn hơn sống nhục (tng)",
    example: "chịu nhục * chết vinh còn hơn sống nhục (tng)",
  },
  {
    word: "nhục",
    part_of_speech: "danh từ",
    meaning: "điều làm cho nhục: cái nhục mất nước * rửa nhục",
    example: "cái nhục mất nước * rửa nhục",
  },
  {
    word: "nhuận tràng",
    part_of_speech: "tính từ",
    meaning:
      "có tác dụng làm cho phân được thải ra dễ dàng, không bị táo bón: rau lang có tác dụng nhuận tràng * thuốc nhuận tràng",
    example: "rau lang có tác dụng nhuận tràng * thuốc nhuận tràng",
  },
  {
    word: "nhục cảm",
    part_of_speech: "",
    meaning:
      "khả năng khêu gợi đòi hỏi về xác thịt ở người khác giới (thường nói về nữ giới): một vẻ đẹp đầy nhục cảm",
    example: "một vẻ đẹp đầy nhục cảm",
  },
  {
    word: "nhục dục",
    part_of_speech: "danh từ",
    meaning:
      "lòng ham muốn về quan hệ xác thịt: thú vui nhục dục * thoả mãn nhục dục",
    example: "thú vui nhục dục * thoả mãn nhục dục",
  },
  {
    word: "nhục hình",
    part_of_speech: "danh từ",
    meaning:
      "hình phạt làm cho đau đớn về thể xác: dùng nhục hình tra tấn * chịu nhục hình",
    example: "dùng nhục hình tra tấn * chịu nhục hình",
  },
  {
    word: "nhục mạ",
    part_of_speech: "động từ",
    meaning:
      "làm nhục bằng cách chửi mắng, xúc phạm nặng nề đến danh dự: buông lời nhục mạ * bị nhục mạ trước đám đông",
    example: "buông lời nhục mạ * bị nhục mạ trước đám đông",
  },
  {
    word: "nhục nhã",
    part_of_speech: "tính từ",
    meaning:
      "nhục, đáng khinh bỉ, đáng xấu hổ (nói khái quát): thất bại nhục nhã",
    example: "thất bại nhục nhã",
  },
  {
    word: "nhục nhằn",
    part_of_speech: "tính từ",
    meaning: "như cực nhục: kiếp sống nhục nhằn * chịu bao nỗi nhục nhằn",
    example: "kiếp sống nhục nhằn * chịu bao nỗi nhục nhằn",
  },
  {
    word: "nhục thể",
    part_of_speech: "danh từ",
    meaning:
      "thể xác con người; phân biệt với tinh thần: chịu đau đớn về nhục thể",
    example: "chịu đau đớn về nhục thể",
  },
  {
    word: "nhúc nhắc",
    part_of_speech: "động từ",
    meaning:
      "bước từng bước một cách khó khăn, chậm chạp: chân đi nhúc nhắc * bị đau nhưng cũng cố nhúc nhắc đi",
    example: "chân đi nhúc nhắc * bị đau nhưng cũng cố nhúc nhắc đi",
  },
  {
    word: "nhúc nhắc",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) như nhúc nhích: ngồi im không nhúc nhắc",
    example: "ngồi im không nhúc nhắc",
  },
  {
    word: "nhuếnh nhoáng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) qua loa, đại khái cho có về hình thức: họp nhuếnh nhoáng một lúc đã nghỉ * ăn nhuếnh nhoáng cho xong bữa",
    example:
      "họp nhuếnh nhoáng một lúc đã nghỉ * ăn nhuếnh nhoáng cho xong bữa",
  },
  {
    word: "nhúc nhích",
    part_of_speech: "động từ",
    meaning:
      "cử động nhẹ, chuyển động một ít: nhúc nhích từng bước * mọi việc cứ ì ra, không nhúc nhích (b)",
    example: "nhúc nhích từng bước * mọi việc cứ ì ra, không nhúc nhích (b)",
  },
  {
    word: "nhuệ khí",
    part_of_speech: "danh từ",
    meaning: "khí thế hăng hái: nhuệ khí chiến đấu * làm nhụt nhuệ khí",
    example: "nhuệ khí chiến đấu * làm nhụt nhuệ khí",
  },
  {
    word: "nhúm",
    part_of_speech: "động từ",
    meaning:
      "lấy một ít vật rời, vụn bằng cách chụm năm đầu ngón tay lại: nhúm chút muối * nhúm chè cho vào ấm",
    example: "nhúm chút muối * nhúm chè cho vào ấm",
  },
  {
    word: "nhúm",
    part_of_speech: "danh từ",
    meaning:
      "lượng nhỏ trong một lần nhúm lấy: nhúm tóc * nhúm muối * bốc một nhúm gạo",
    example: "nhúm tóc * nhúm muối * bốc một nhúm gạo",
  },
  {
    word: "nhúm",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) số lượng nhỏ, ít, không đáng kể: mới có nhúm tuổi đầu, đã biết làm ăn gì!",
    example: "mới có nhúm tuổi đầu, đã biết làm ăn gì!",
  },
  {
    word: "nhủi",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ giủi) đồ đan bằng tre để xúc bắt tôm, cá: mang nhủi ra ao xúc cá",
    example: "mang nhủi ra ao xúc cá",
  },
  {
    word: "nhủi",
    part_of_speech: "động từ",
    meaning: "(phương ngữ giủi) xúc bắt tôm, cá bằng cái nhủi: đi nhủi tôm",
    example: "đi nhủi tôm",
  },
  {
    word: "nhủi",
    part_of_speech: "động từ",
    meaning:
      "đưa đầu đẩy tới phía trước, cố khắc phục vật chướng ngại để di chuyển: con dế đùn đất nhủi lên",
    example: "con dế đùn đất nhủi lên",
  },
  {
    word: "nhủi",
    part_of_speech: "động từ",
    meaning: "(Nam) chui vào chỗ kín: con chuột nhủi mất * cua nhủi vô hang",
    example: "con chuột nhủi mất * cua nhủi vô hang",
  },
  {
    word: "nhủi",
    part_of_speech: "động từ",
    meaning: "(Nam) chúi xuống, chúc xuống: té nhủi",
    example: "té nhủi",
  },
  {
    word: "nhún mình",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) tự hạ mình xuống để tỏ ra khiêm tốn: nhún mình với bạn bè",
    example: "nhún mình với bạn bè",
  },
  {
    word: "nhũn",
    part_of_speech: "tính từ",
    meaning:
      "mềm quá, gần như nát nhão ra: chuối chín nhũn * rau luộc nát nhũn",
    example: "chuối chín nhũn * rau luộc nát nhũn",
  },
  {
    word: "nhũn",
    part_of_speech: "tính từ",
    meaning:
      "chịu nhịn, tỏ ra mềm mỏng trong cách đối xử: nhũn như con chi chi * yếu thế nên phải chịu nhũn",
    example: "nhũn như con chi chi * yếu thế nên phải chịu nhũn",
  },
  {
    word: "nhủn",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) rủn: sợ nhủn cả người",
    example: "sợ nhủn cả người",
  },
  {
    word: "nhún",
    part_of_speech: "động từ",
    meaning:
      "hơi chùng chân cho người hạ thấp xuống để lấy đà bật lên: nhún chân nhảy qua mương * nhún người trên đu",
    example: "nhún chân nhảy qua mương * nhún người trên đu",
  },
  {
    word: "nhún",
    part_of_speech: "động từ",
    meaning:
      "tự hạ mình xuống, nhường nhịn hoặc chịu lép vế trong một hoàn cảnh nào đó nhằm đạt mục đích nhất định: yếu thế nên đành chịu nhún",
    example: "yếu thế nên đành chịu nhún",
  },
  {
    word: "nhún nhảy",
    part_of_speech: "động từ",
    meaning:
      "nhún xuống nhảy lên liên tiếp, nhịp nhàng: vừa đi vừa nhún nhảy đôi chân",
    example: "vừa đi vừa nhún nhảy đôi chân",
  },
  {
    word: "nhun nhũn",
    part_of_speech: "tính từ",
    meaning: "hơi nhũn: quả cam đã hơi nhun nhũn",
    example: "quả cam đã hơi nhun nhũn",
  },
  {
    word: "nhũn nhẽo",
    part_of_speech: "tính từ",
    meaning:
      "rất nhẽo, đến mức như chảy xệ ra (thường nói về da thịt): mới ốm dậy, da mặt nhũn nhẽo",
    example: "mới ốm dậy, da mặt nhũn nhẽo",
  },
  {
    word: "nhún nhẩy",
    part_of_speech: "động từ",
    meaning:
      "nhún xuống nhảy lên liên tiếp, nhịp nhàng: vừa đi vừa nhún nhảy đôi chân",
    example: "vừa đi vừa nhún nhảy đôi chân",
  },
  {
    word: "nhũn nhặn",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra khiêm tốn và nhã nhặn trong quan hệ tiếp xúc với người khác: trả lời nhũn nhặn * thái độ nhũn nhặn",
    example: "trả lời nhũn nhặn * thái độ nhũn nhặn",
  },
  {
    word: "nhung lụa",
    part_of_speech: "danh từ",
    meaning:
      "nhung và lụa; thường dùng để chỉ cuộc sống giàu sang: cuộc sống nhung lụa * lớn lên trong nhung lụa",
    example: "cuộc sống nhung lụa * lớn lên trong nhung lụa",
  },
  {
    word: "nhung",
    part_of_speech: "danh từ",
    meaning: "sừng non của hươu, nai dùng làm thuốc bổ: cặp nhung hươu",
    example: "cặp nhung hươu",
  },
  {
    word: "nhung",
    part_of_speech: "danh từ",
    meaning:
      "hàng dệt bằng tơ hay bằng sợi bông, có tuyết mượt phủ kín sợi dọc và sợi ngang: khăn nhung * quần nhung * bàn tay trắng muốt và mịn như nhung",
    example: "khăn nhung * quần nhung * bàn tay trắng muốt và mịn như nhung",
  },
  {
    word: "nhung",
    part_of_speech: "tính từ",
    meaning:
      "(văn chương) (bộ phận cơ thể) có bề mặt mượt mà, êm dịu tựa như nhung, gây cảm giác dễ chịu: đôi mắt nhung * mái tóc nhung huyền",
    example: "đôi mắt nhung * mái tóc nhung huyền",
  },
  {
    word: "nhún nhường",
    part_of_speech: "tính từ",
    meaning:
      "chịu hạ mình một chút, tỏ ra khiêm nhường, mềm mỏng trong quan hệ giao tiếp: cử chỉ nhún nhường * ăn nói nhún nhường",
    example: "cử chỉ nhún nhường * ăn nói nhún nhường",
  },
  {
    word: "nhung kẻ",
    part_of_speech: "danh từ",
    meaning: "nhung sợi dọc làm thành từng luống nhỏ đều nhau: vải nhung kẻ",
    example: "vải nhung kẻ",
  },
  {
    word: "nhún vai",
    part_of_speech: "động từ",
    meaning:
      "co hai vai lên rồi rụt xuống (thường để tỏ ý ngạc nhiên, ngờ vực hay mỉa mai): nhún vai tỏ ý ngạc nhiên",
    example: "nhún vai tỏ ý ngạc nhiên",
  },
  {
    word: "nhúng",
    part_of_speech: "động từ",
    meaning:
      'cho vào trong chất lỏng, rồi lấy ra ngay: nhúng ướt khăn mặt * "Trót vì tay đã nhúng chàm, Dại rồi còn biết khôn làm sao đây?" (TKiều)',
    example:
      'nhúng ướt khăn mặt * "Trót vì tay đã nhúng chàm, Dại rồi còn biết khôn làm sao đây?" (TKiều)',
  },
  {
    word: "nhúng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) dự vào việc gì đó: việc của người khác thì đừng có nhúng vào",
    example: "việc của người khác thì đừng có nhúng vào",
  },
  {
    word: "nhung nhăng",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) (đi, chạy) một cách lộn xộn không theo một hướng nhất định nào: đàn lợn con đuổi nhau nhung nhăng",
    example: "đàn lợn con đuổi nhau nhung nhăng",
  },
  {
    word: "nhùng nhằng",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái vướng vào nhau chằng chịt, khó gỡ ra: dây dợ nhùng nhằng",
    example: "dây dợ nhùng nhằng",
  },
  {
    word: "nhùng nhằng",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như nhì nhằng (ng3): buôn bán nhùng nhằng cũng đủ sống",
    example: "buôn bán nhùng nhằng cũng đủ sống",
  },
  {
    word: "nhùng nhằng",
    part_of_speech: "động từ",
    meaning:
      "có thái độ dằng dai, không dứt khoát: nhùng nhằng mãi không chịu trả nợ",
    example: "nhùng nhằng mãi không chịu trả nợ",
  },
  {
    word: "nhũng nhiễu",
    part_of_speech: "động từ",
    meaning:
      "hạch sách, quấy rầy, đòi hỏi cái này cái khác (nói khái quát): quan lại nhũng nhiễu dân",
    example: "quan lại nhũng nhiễu dân",
  },
  {
    word: "nhũng nhẵng",
    part_of_speech: "tính từ",
    meaning: "lôi thôi, làm vướng víu: đôi quang gánh nhũng nhẵng trên vai",
    example: "đôi quang gánh nhũng nhẵng trên vai",
  },
  {
    word: "nhũng nhẵng",
    part_of_speech: "tính từ",
    meaning:
      "dằng dai, lằng nhằng, không dứt khoát: con chó nhũng nhẵng bám theo chủ",
    example: "con chó nhũng nhẵng bám theo chủ",
  },
  {
    word: "nhũng nhẵng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) hờn dỗi, làm nũng: nhũng nhẵng với chồng * nhũng nhẵng như trẻ con",
    example: "nhũng nhẵng với chồng * nhũng nhẵng như trẻ con",
  },
  {
    word: "nhung nhúc",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả cảnh có rất nhiều động vật nhỏ đang chuyển động chen chúc nhau dày đặc: dòi bọ nhung nhúc",
    example: "dòi bọ nhung nhúc",
  },
  {
    word: "nhủng nhẳng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) không thuận, không đồng ý, nhưng cũng không dứt khoát từ chối: nhủng nhẳng không chịu làm * thái độ nhủng nhẳng",
    example: "nhủng nhẳng không chịu làm * thái độ nhủng nhẳng",
  },
  {
    word: "nhủng nhẳng",
    part_of_speech: "tính từ",
    meaning:
      "(nói năng) buông từng lời ngắn cụt, tỏ ý miễn cưỡng, không hài lòng: trả lời nhủng nhẳng * ăn nói nhủng nhẳng",
    example: "trả lời nhủng nhẳng * ăn nói nhủng nhẳng",
  },
  {
    word: "nhuốc nhơ",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như nhơ nhuốc: tấm thân nhuốc nhơ",
    example: "tấm thân nhuốc nhơ",
  },
  {
    word: "nhuộm",
    part_of_speech: "động từ",
    meaning:
      "làm cho chuyển thành màu nào đó bằng cách nhúng vào hoặc ủ với chất có màu: vải trắng nhuộm nâu * thuốc nhuộm tóc * nhuộm răng",
    example: "vải trắng nhuộm nâu * thuốc nhuộm tóc * nhuộm răng",
  },
  {
    word: "nhuốm",
    part_of_speech: "động từ",
    meaning:
      "mới hơi bắt màu: vải đã nhuốm màu * bàn tay nhuốm máu * tóc nhuốm hoa râm",
    example: "vải đã nhuốm màu * bàn tay nhuốm máu * tóc nhuốm hoa râm",
  },
  {
    word: "nhuốm",
    part_of_speech: "động từ",
    meaning:
      "phủ lên hoặc bị phủ lên, bao trùm lên: sóng biển nhuốm nắng * phong cảnh nhuốm một vẻ huyền ảo",
    example: "sóng biển nhuốm nắng * phong cảnh nhuốm một vẻ huyền ảo",
  },
  {
    word: "nhụt",
    part_of_speech: "",
    meaning:
      "bị giảm sút đi (về ý chí, tinh thần): làm nhụt tinh thần chiến đấu",
    example: "làm nhụt tinh thần chiến đấu",
  },
  {
    word: "nhuốm bệnh",
    part_of_speech: "động từ",
    meaning: "bắt đầu mắc bệnh: cơ thể bị nhuốm bệnh",
    example: "cơ thể bị nhuốm bệnh",
  },
  {
    word: "nhúng tay",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) trực tiếp tham gia vào (thường là những việc không hay): nhúng tay vào tội ác",
    example: "nhúng tay vào tội ác",
  },
  {
    word: "nhút nhát",
    part_of_speech: "tính từ",
    meaning:
      "nhát, hay rụt rè, sợ sệt: cô bé nhút nhát * tính nhút nhát nên không dám hỏi",
    example: "cô bé nhút nhát * tính nhút nhát nên không dám hỏi",
  },
  {
    word: "nhứ",
    part_of_speech: "động từ",
    meaning:
      "đưa ra cho nhìn thấy cái ham thích để dụ, để nhử: dứ miếng thịt trước mũi con chó",
    example: "dứ miếng thịt trước mũi con chó",
  },
  {
    word: "nhứ",
    part_of_speech: "động từ",
    meaning:
      "giơ ra cho nhìn thấy vật dùng để đánh, đâm, v.v. và làm động tác như chực đánh, chực đâm, để hăm doạ: dứ nắm đấm để doạ",
    example: "dứ nắm đấm để doạ",
  },
  {
    word: "nhừ",
    part_of_speech: "tính từ",
    meaning:
      "(món ăn) được đun nấu đến mức chín kĩ, mềm tơi ra: ninh thịt cho nhừ * cà bung nhừ * đi nắng, mặt mũi chín nhừ (b)",
    example: "ninh thịt cho nhừ * cà bung nhừ * đi nắng, mặt mũi chín nhừ (b)",
  },
  {
    word: "nhừ",
    part_of_speech: "tính từ",
    meaning:
      "nát đến mức dễ tơi vụn ra: cỏ bị xéo nát nhừ * bị một trận nhừ xương (b)",
    example: "cỏ bị xéo nát nhừ * bị một trận nhừ xương (b)",
  },
  {
    word: "nhừ",
    part_of_speech: "tính từ",
    meaning:
      "(cơ thể) rã rời, không còn muốn cử động nữa: đi nhiều, mỏi nhừ cả hai chân * mệt nhừ người * toàn thân đau nhừ",
    example:
      "đi nhiều, mỏi nhừ cả hai chân * mệt nhừ người * toàn thân đau nhừ",
  },
  {
    word: "như chơi",
    part_of_speech: "",
    meaning:
      '(khẩu ngữ) (có thể thực hiện, có thể xảy ra) một cách rất dễ dàng: sơ hở một cái là mất như chơi * "Lạ cho cái sóng khuynh thành, Làm cho đổ quán xiêu đình, như chơi!" (TKiều)',
    example:
      'sơ hở một cái là mất như chơi * "Lạ cho cái sóng khuynh thành, Làm cho đổ quán xiêu đình, như chơi!" (TKiều)',
  },
  {
    word: "nhử",
    part_of_speech: "động từ",
    meaning:
      "dùng mồi để dụ bắt: làm mồi nhử cá * vãi thóc nhử gà * nhử chó vào cũi",
    example: "làm mồi nhử cá * vãi thóc nhử gà * nhử chó vào cũi",
  },
  {
    word: "nhử",
    part_of_speech: "động từ",
    meaning:
      "dùng kế để đưa vào tròng: nhử giặc ra khỏi đồn * dùng tiền để nhử",
    example: "nhử giặc ra khỏi đồn * dùng tiền để nhử",
  },
  {
    word: "nhuỵ",
    part_of_speech: "danh từ",
    meaning: "(cũng nhị) bộ phận sinh sản của hoa: nhuỵ hoa",
    example: "nhuỵ hoa",
  },
  {
    word: "nhuyễn",
    part_of_speech: "tính từ",
    meaning:
      "nát mềm ra thành những hạt nhỏ, mịn, quyện vào nhau: nhào bột cho thật nhuyễn * thịt giã nhuyễn",
    example: "nhào bột cho thật nhuyễn * thịt giã nhuyễn",
  },
  {
    word: "nhuyễn",
    part_of_speech: "động từ",
    meaning:
      "kết hợp vào với nhau một cách chặt chẽ hài hoà, tự nhiên: nội dung và hình thức nhuyễn vào nhau như một",
    example: "nội dung và hình thức nhuyễn vào nhau như một",
  },
  {
    word: "như diều gặp gió",
    part_of_speech: "",
    meaning:
      "ví trường hợp đang đà phát triển rất nhanh do gặp thời cơ: gặp thời, lão phất lên như diều gặp gió",
    example: "gặp thời, lão phất lên như diều gặp gió",
  },
  {
    word: "như",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị quan hệ ngang bằng hoặc tương đồng trong sự so sánh về một mặt nào đó giữa các sự vật, hiện tượng hoặc trạng thái, tính chất: cảnh vật vẫn như xưa * coi nhau như người nhà * làm như không biết",
    example:
      "cảnh vật vẫn như xưa * coi nhau như người nhà * làm như không biết",
  },
  {
    word: "như",
    part_of_speech: "kết từ",
    meaning:
      "từ dùng trong những tổ hợp so sánh để biểu thị mức độ rất cao, có thể sánh với cái tiêu biểu được nêu ra: trắng như tuyết * êm như ru * nói dối như Cuội",
    example: "trắng như tuyết * êm như ru * nói dối như Cuội",
  },
  {
    word: "như",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị những cái sắp nêu ra là thí dụ cụ thể minh hoạ cho cái vừa nói đến: mang theo một số hành lí như quần áo, chăn màn, sách vở",
    example: "mang theo một số hành lí như quần áo, chăn màn, sách vở",
  },
  {
    word: "như",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là căn cứ cho thấy điều nói đến là không có gì mới lạ hoặc không có gì phải bàn cãi: như trên đã nói, công việc đang tiến triển tốt đẹp",
    example: "như trên đã nói, công việc đang tiến triển tốt đẹp",
  },
  {
    word: "như ai",
    part_of_speech: "",
    meaning: "chẳng thua kém gì ai: trang điểm lên, trông cũng đẹp như ai",
    example: "trang điểm lên, trông cũng đẹp như ai",
  },
  {
    word: "như điên",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) (làm việc gì hoặc có biểu hiện) với mức độ cao khác thường: phóng xe như điên * cười như điên",
    example: "phóng xe như điên * cười như điên",
  },
  {
    word: "như hình với bóng",
    part_of_speech: "",
    meaning:
      'ví cảnh luôn luôn ở bên nhau, gắn bó với nhau không lúc nào rời: "Hai người như hình với bóng, như chập làm một, chia sẻ hết mọi niềm vui, nỗi uẩn khúc cho nhau." (MVKháng; 5)',
    example:
      'Hai người như hình với bóng, như chập làm một, chia sẻ hết mọi niềm vui, nỗi uẩn khúc cho nhau." (MVKháng; 5)',
  },
  {
    word: "như thường",
    part_of_speech: "",
    meaning:
      "như bình thường, như chẳng có điều gì khác thường xảy ra cả: vẫn vui vẻ như thường * thức cả đêm mà hôm sau vẫn tỉnh táo như thường",
    example:
      "vẫn vui vẻ như thường * thức cả đêm mà hôm sau vẫn tỉnh táo như thường",
  },
  {
    word: "như thể",
    part_of_speech: "kết từ",
    meaning:
      "như là, tựa như: sáng như thể ban ngày * thương người như thể thương thân (tng)",
    example: "sáng như thể ban ngày * thương người như thể thương thân (tng)",
  },
  {
    word: "như tuồng",
    part_of_speech: "kết từ",
    meaning: "(khẩu ngữ) như, ra vẻ như: làm như tuồng không biết",
    example: "làm như tuồng không biết",
  },
  {
    word: "như vầy",
    part_of_speech: "",
    meaning:
      "(phương ngữ, khẩu ngữ) như thế này: trời, đẹp như vầy sao? * ăn ở như vầy thì ai dám khinh khi?",
    example: "trời, đẹp như vầy sao? * ăn ở như vầy thì ai dám khinh khi?",
  },
  {
    word: "như nhứ",
    part_of_speech: "động từ",
    meaning: "dứ liên tiếp để nhử hoặc hăm doạ: dư dứ nắm đấm để doạ",
    example: "dư dứ nắm đấm để doạ",
  },
  {
    word: "nhừ tử",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) bị đánh nhiều và rất đau (đến mức tưởng như nát nhừ cả người, có thể chết được): nện cho một trận nhừ tử * đánh cho nhừ tử",
    example: "nện cho một trận nhừ tử * đánh cho nhừ tử",
  },
  {
    word: "như không",
    part_of_speech: "",
    meaning:
      '(khẩu ngữ) (tỏ ra) như chẳng có điều gì khác thường xảy ra cả: mặt thản nhiên như không * "Công tôi đi đợi về chờ, Sao người ăn nói lững lờ như không!" (ca dao)',
    example:
      'mặt thản nhiên như không * "Công tôi đi đợi về chờ, Sao người ăn nói lững lờ như không!" (ca dao)',
  },
  {
    word: "như không",
    part_of_speech: "",
    meaning: "như như chơi: cả một tạ thóc mà nó gánh cứ như không",
    example: "cả một tạ thóc mà nó gánh cứ như không",
  },
  {
    word: "nhừ đòn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) bị đánh đòn nhiều và đau (đến mức như đau nhừ cả người): bị một trận nhừ đòn",
    example: "bị một trận nhừ đòn",
  },
  {
    word: "như ý",
    part_of_speech: "tính từ",
    meaning:
      "đúng như ý muốn của mình: vạn sự như ý * kết quả không được như ý",
    example: "vạn sự như ý * kết quả không được như ý",
  },
  {
    word: "như ý",
    part_of_speech: "tính từ",
    meaning:
      "đúng như ý muốn của mình: vạn sự như ý * kết quả không được như ý",
    example: "vạn sự như ý * kết quả không được như ý",
  },
  {
    word: "nhựa",
    part_of_speech: "danh từ",
    meaning: "dịch lỏng lưu thông trong thân cây để nuôi cây.",
    example: "nhựa thông * nhựa mít",
  },
  {
    word: "nhựa",
    part_of_speech: "danh từ",
    meaning: "chất dính do một số loại cây tiết ra: nhựa thông * nhựa mít",
    example: "cái ca nhựa * bộ bàn ghế nhựa * vải nhựa",
  },
  {
    word: "nhựa hoá",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) làm cho đường sá được trải nhựa: nhựa hoá đường giao thông liên tỉnh",
    example: "nhựa hoá đường giao thông liên tỉnh",
  },
  {
    word: "nhừa nhựa",
    part_of_speech: "tính từ",
    meaning:
      "(giọng) lè nhè, kéo dài, các âm như dính vào nhau: giọng nhừa nhựa hơi men",
    example: "giọng nhừa nhựa hơi men",
  },
  {
    word: "những",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ một số lượng nhiều, không xác định: những vì sao đêm * những ngày thơ ấu * nhớ lại những kỉ niệm xưa",
    example: "những vì sao đêm * những ngày thơ ấu * nhớ lại những kỉ niệm xưa",
  },
  {
    word: "những",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý nhấn mạnh số lượng quá nhiều: ăn những năm bát cơm * anh ta hơn tôi những mười tuổi",
    example: "ăn những năm bát cơm * anh ta hơn tôi những mười tuổi",
  },
  {
    word: "những",
    part_of_speech: "trợ từ",
    meaning:
      "(Khẩu ngữ) từ biểu thị ý nhấn mạnh số lượng nhiều như không kể xiết: trong vườn trồng toàn những hoa là hoa * trên bàn đầy những giấy lộn",
    example:
      "trong vườn trồng toàn những hoa là hoa * trên bàn đầy những giấy lộn",
  },
  {
    word: "những",
    part_of_speech: "trợ từ",
    meaning:
      'từ biểu thị ý nhấn mạnh tính chất ngập tràn của một trạng thái tâm lí, tình cảm: những mong cho con khôn lớn * "Buồng riêng, riêng những sụt sùi, Nghĩ thân mà lại ngậm ngùi cho thân." (TKiều)',
    example:
      'những mong cho con khôn lớn * "Buồng riêng, riêng những sụt sùi, Nghĩ thân mà lại ngậm ngùi cho thân." (TKiều)',
  },
  {
    word: "nhức nhối",
    part_of_speech: "tính từ",
    meaning:
      "nhức, đau như dội lên, khó chịu: vết thương nhức nhối * đau nhức nhối toàn thân",
    example: "vết thương nhức nhối * đau nhức nhối toàn thân",
  },
  {
    word: "nhức nhối",
    part_of_speech: "tính từ",
    meaning:
      "(vấn đề, sự việc) gây cảm giác khó chịu dai dẳng, khiến luôn phải nghĩ đến: vấn đề nhức nhối của xã hội",
    example: "vấn đề nhức nhối của xã hội",
  },
  {
    word: "nhựa sống",
    part_of_speech: "danh từ",
    meaning:
      "nhựa nuôi cây; dùng để biểu trưng cho nguồn sinh lực, cho sức sống của con người: nguồn nhựa sống * cơ thể tràn trề nhựa sống",
    example: "nguồn nhựa sống * cơ thể tràn trề nhựa sống",
  },
  {
    word: "nhưng",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra ngược lại với ý do điều vừa nói đến có thể gợi ra: việc nhỏ nhưng ý nghĩa lớn * nói nhỏ nhưng vẫn nghe thấy * hứa nhưng không thực hiện",
    example:
      "việc nhỏ nhưng ý nghĩa lớn * nói nhỏ nhưng vẫn nghe thấy * hứa nhưng không thực hiện",
  },
  {
    word: "nhức",
    part_of_speech: "tính từ",
    meaning:
      "đau nhói lên ở một điểm, như khi có nhọt đang sưng tấy: nhức đầu * vết thương thỉnh thoảng lại nhức lên * nhìn lâu nhức mắt",
    example:
      "nhức đầu * vết thương thỉnh thoảng lại nhức lên * nhìn lâu nhức mắt",
  },
  {
    word: "những ai",
    part_of_speech: "đại từ",
    meaning:
      "tất cả những người nào: trong nhà có những ai * những ai đồng ý thì giơ tay",
    example: "trong nhà có những ai * những ai đồng ý thì giơ tay",
  },
  {
    word: "nhược",
    part_of_speech: "tính từ",
    meaning:
      "(điểm, chỗ) yếu, hiểm, nếu bị xâm phạm đến thì ảnh hưởng nghiêm trọng tới toàn bộ: nắm được điểm nhược của đối phương * đánh trúng chỗ nhược",
    example: "nắm được điểm nhược của đối phương * đánh trúng chỗ nhược",
  },
  {
    word: "nhưng nhức",
    part_of_speech: "tính từ",
    meaning: "hơi nhức: đầu hơi nhưng nhức",
    example: "đầu hơi nhưng nhức",
  },
  {
    word: "nhưng nhức",
    part_of_speech: "phụ từ",
    meaning:
      'toàn một màu và ánh bóng lên, trông đẹp (thường nói về màu đen): "Nhìn em đôi má ửng hồng, Răng đen nhưng nhức mà lòng anh say." (ca dao)',
    example:
      'Nhìn em đôi má ửng hồng, Răng đen nhưng nhức mà lòng anh say." (ca dao)',
  },
  {
    word: "nhưng mà",
    part_of_speech: "kết từ",
    meaning:
      "như nhưng (nghĩa mạnh hơn; thường dùng để tỏ ý phân vân hoặc phân trần): đắt nhưng mà đẹp * tuy mệt nhưng mà vui * bỏ qua cũng được nhưng mà tức lắm!",
    example:
      "đắt nhưng mà đẹp * tuy mệt nhưng mà vui * bỏ qua cũng được nhưng mà tức lắm!",
  },
  {
    word: "nhược điểm",
    part_of_speech: "danh từ",
    meaning:
      "chỗ kém, chỗ yếu: nhược điểm của hắn là nhu nhược * khắc phục nhược điểm",
    example: "nhược điểm của hắn là nhu nhược * khắc phục nhược điểm",
  },
  {
    word: "nhượng",
    part_of_speech: "động từ",
    meaning:
      "bán lại (thường là cái đang dùng): nhượng lại bộ bàn ghế cho người khác * nhượng quyền sử dụng đất",
    example: "nhượng lại bộ bàn ghế cho người khác * nhượng quyền sử dụng đất",
  },
  {
    word: "nhường",
    part_of_speech: "động từ",
    meaning:
      "để cho người khác được hưởng những quyền lợi mà mình đang hưởng hoặc lẽ ra mình được hưởng: nhường đường * kính trên nhường dưới (tng)",
    example: "nhường đường * kính trên nhường dưới (tng)",
  },
  {
    word: "những tưởng",
    part_of_speech: "động từ",
    meaning:
      "cứ tưởng đâu là: những tưởng cầm chắc phần thắng trong tay, ai ngờ!",
    example: "những tưởng cầm chắc phần thắng trong tay, ai ngờ!",
  },
  {
    word: "nhướng",
    part_of_speech: "động từ",
    meaning:
      "(mắt) mở to hết cỡ, lông mày cong lên, cố nhìn cho thật rõ: nhướng mắt lên nhìn * đôi lông mày nhướng lên giữa trán",
    example: "nhướng mắt lên nhìn * đôi lông mày nhướng lên giữa trán",
  },
  {
    word: "nhượng bộ",
    part_of_speech: "động từ",
    meaning:
      "chịu từ bỏ một phần hoặc toàn bộ ý kiến hay quyền lợi của mình trong sự tranh chấp: nhất định không chịu nhượng bộ",
    example: "nhất định không chịu nhượng bộ",
  },
  {
    word: "nhượng bộ",
    part_of_speech: "động từ",
    meaning:
      "(vế câu) nêu lí do đáng lẽ ngăn cản, không để cho điều nói đến xảy ra (nhưng điều ấy vẫn xảy ra): trong câu  * ,  *  là vế câu có nghĩa nhượng bộ",
    example: "trong câu  * ,  *  là vế câu có nghĩa nhượng bộ",
  },
  {
    word: "nhường bước",
    part_of_speech: "động từ",
    meaning:
      "nhường cho đối tượng khác đi trước, vượt lên trước mình: tránh sang bên nhường bước",
    example: "tránh sang bên nhường bước",
  },
  {
    word: "nhường nhịn",
    part_of_speech: "động từ",
    meaning:
      "chịu nhận phần kém, phần thiệt về mình, để cho người khác được hưởng phần hơn trong quan hệ đối xử (nói khái quát): nhường nhịn bạn bè * ăn uống nhường nhịn",
    example: "nhường nhịn bạn bè * ăn uống nhường nhịn",
  },
  {
    word: "ni",
    part_of_speech: "đại từ",
    meaning: "(Phương ngữ) nay: chờ đợi ba bốn năm ni",
    example: "chờ đợi ba bốn năm ni",
  },
  {
    word: "ni",
    part_of_speech: "đại từ",
    meaning: "này: bên ni, bên tê",
    example: "bên ni, bên tê",
  },
  {
    word: "nhường lời",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) để cho người khác nói, phát biểu ý kiến trước: xin nhường lời cho độc giả",
    example: "xin nhường lời cho độc giả",
  },
  {
    word: "nhường cơm sẻ áo",
    part_of_speech: "",
    meaning:
      "giúp đỡ, san sẻ cho nhau những thứ tối cần thiết cho đời sống khi thiếu thốn, khó khăn: sẵn sàng nhường cơm sẻ áo cho đồng bào vùng bị lũ",
    example: "sẵn sàng nhường cơm sẻ áo cho đồng bào vùng bị lũ",
  },
  {
    word: "nỉ",
    part_of_speech: "danh từ",
    meaning:
      "hàng dệt bằng sợi len chải xơ lên, che lấp sợi dọc và sợi ngang: áo nỉ * mũ nỉ",
    example: "áo nỉ * mũ nỉ",
  },
  {
    word: "nỉ non",
    part_of_speech: "động từ",
    meaning: "tỉ tê chuyện tâm tình: con gái nỉ non với mẹ",
    example: "con gái nỉ non với mẹ",
  },
  {
    word: "nỉ non",
    part_of_speech: "tính từ",
    meaning:
      '(âm thanh) nhẹ nhàng, êm ái, gợi cảm giác buồn thương: khóc nỉ non * "Lĩnh lời, nàng mới lựa dây, Nỉ non, thánh thót, dễ say lòng người!" (TKiều)',
    example:
      'khóc nỉ non * "Lĩnh lời, nàng mới lựa dây, Nỉ non, thánh thót, dễ say lòng người!" (TKiều)',
  },
  {
    word: "nĩa",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng thường bằng kim loại, có dạng như cái thìa nhưng đầu có răng nhọn, cán dẹt, dùng để lấy thức ăn.",
    example: "dùng nĩa xúc vôi",
  },
  {
    word: "ních",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) nhồi, nhét cho thật căng, thật đầy: ních hàng vào bao * ních tiền chặt túi * trong nhà đầy ních những người",
    example:
      "ních hàng vào bao * ních tiền chặt túi * trong nhà đầy ních những người",
  },
  {
    word: "ni-lông",
    part_of_speech: "danh từ",
    meaning:
      "chất dẻo dễ kéo sợi, dùng để dệt vải, dệt lưới, làm chỉ khâu vết thương, v.v.: túi nylon * vải pha nylon",
    example: "túi nylon * vải pha nylon",
  },
  {
    word: "nia",
    part_of_speech: "danh từ",
    meaning:
      "đồ đan khít bằng tre, hình tròn, nông lòng, to hơn cái mẹt, dùng để phơi, đựng: lọt sàng xuống nia (tng)",
    example: "lọt sàng xuống nia (tng)",
  },
  {
    word: "niềm",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) lòng tưởng nhớ, nghĩ đến: một niềm vì nước vì dân * "Chạnh niềm, nhớ cảnh gia hương, Nhớ quê, chàng lại tìm đường thăm quê." (TKiều)',
    example:
      'một niềm vì nước vì dân * "Chạnh niềm, nhớ cảnh gia hương, Nhớ quê, chàng lại tìm đường thăm quê." (TKiều)',
  },
  {
    word: "niềm",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng tâm trạng, trạng thái tình cảm cụ thể (thường là tích cực) mà con người trải qua: niềm vui, nỗi buồn * niềm tự hào * niềm hi vọng",
    example: "niềm vui, nỗi buồn * niềm tự hào * niềm hi vọng",
  },
  {
    word: "niệm",
    part_of_speech: "động từ",
    meaning:
      "đọc lẩm nhẩm trong mồm, để cầu khẩn hoặc làm phép: tụng kinh niệm Phật * niệm thần chú",
    example: "tụng kinh niệm Phật * niệm thần chú",
  },
  {
    word: "niềm nở",
    part_of_speech: "tính từ",
    meaning:
      "(tiếp đãi) vui vẻ, tỏ ra nhiệt tình, mến khách: chào hỏi niềm nở * tiếp đãi niềm nở",
    example: "chào hỏi niềm nở * tiếp đãi niềm nở",
  },
  {
    word: "niêm phong",
    part_of_speech: "động từ",
    meaning:
      "đóng kín và ghi dấu hiệu để không cho phép tự tiện mở, đảm bảo mọi thứ bên trong được giữ nguyên, đầy đủ, bí mật: niêm phong đề thi * tài sản bị niêm phong * dán giấy niêm phong",
    example: "niêm phong đề thi * tài sản bị niêm phong * dán giấy niêm phong",
  },
  {
    word: "niềm tây",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) tâm tư, nỗi lòng riêng: "Khóc than kể hết niềm tây, Chàng ôi, biết nỗi nước này cho chưa?" (TKiều)',
    example:
      'Khóc than kể hết niềm tây, Chàng ôi, biết nỗi nước này cho chưa?" (TKiều)',
  },
  {
    word: "niềm riêng",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, vch, hiếm) như niềm tây: "Niềm riêng chất để muôn vàn, Nói cười ngoài miệng, tân toan trong lòng." (HTr)',
    example:
      'Niềm riêng chất để muôn vàn, Nói cười ngoài miệng, tân toan trong lòng." (HTr)',
  },
  {
    word: "niên giám",
    part_of_speech: "danh từ",
    meaning:
      "sách ghi những thông tin, sự kiện quan trọng trong từng năm của một ngành nào đó: niên giám thống kê * niên giám điện thoại",
    example: "niên giám thống kê * niên giám điện thoại",
  },
  {
    word: "niêm luật",
    part_of_speech: "danh từ",
    meaning:
      "quy tắc tương ứng về luật bằng trắc và các quy tắc khác trong thơ, phú cổ theo Đường luật (nói khái quát): bài thơ làm không đúng niêm luật * thơ tự do không cần niêm luật",
    example: "bài thơ làm không đúng niêm luật * thơ tự do không cần niêm luật",
  },
  {
    word: "niệm tình",
    part_of_speech: "động từ",
    meaning:
      "thông cảm với tình cảnh mà chấp nhận hay đồng ý làm việc gì đó: xin được niệm tình lượng thứ",
    example: "xin được niệm tình lượng thứ",
  },
  {
    word: "niêm yết",
    part_of_speech: "động từ",
    meaning:
      "dán giấy công bố ở nơi công cộng cho mọi người biết: niêm yết danh sách cử tri * niêm yết tên những người thi đỗ",
    example: "niêm yết danh sách cử tri * niêm yết tên những người thi đỗ",
  },
  {
    word: "niên đại",
    part_of_speech: "danh từ",
    meaning:
      "năm tháng, thời đại liên quan đến một sự kiện lịch sử: xác định niên đại của trống đồng * niên đại Hùng Vương",
    example: "xác định niên đại của trống đồng * niên đại Hùng Vương",
  },
  {
    word: "niên biểu",
    part_of_speech: "danh từ",
    meaning:
      "bảng ghi các năm xảy ra những sự kiện lịch sử đáng chú ý: niên biểu lịch sử Việt Nam",
    example: "niên biểu lịch sử Việt Nam",
  },
  {
    word: "niên hiệu",
    part_of_speech: "danh từ",
    meaning:
      "tên hiệu của vua đặt ra để tính năm trong thời gian mình trị vì: Nguyễn Huệ lấy niên hiệu là Quang Trung",
    example: "Nguyễn Huệ lấy niên hiệu là Quang Trung",
  },
  {
    word: "niên hạn",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) thời hạn quy định tính bằng số năm cho một công việc, một quyền hạn hay nghĩa vụ nào đó: niên hạn công tác * lương tính theo niên hạn",
    example: "niên hạn công tác * lương tính theo niên hạn",
  },
  {
    word: "niên hạn",
    part_of_speech: "danh từ",
    meaning: "tuổi thọ (của một công trình): ngôi nhà đã hết niên hạn sử dụng",
    example: "ngôi nhà đã hết niên hạn sử dụng",
  },
  {
    word: "niễng",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) nghển, kiễng: niễng chân lên nhìn",
    example: "niễng chân lên nhìn",
  },
  {
    word: "niên học",
    part_of_speech: "danh từ",
    meaning: "(hiếm) năm học: kết thúc niên học * chuẩn bị cho niên học mới",
    example: "kết thúc niên học * chuẩn bị cho niên học mới",
  },
  {
    word: "niên khoá",
    part_of_speech: "danh từ",
    meaning:
      "khoá học, được tính từ năm bắt đầu cho đến năm kết thúc: sinh viên niên khoá 2006 - 2010",
    example: "sinh viên niên khoá 2006 - 2010",
  },
  {
    word: "niên vụ",
    part_of_speech: "danh từ",
    meaning:
      "vụ sản xuất nông nghiệp, thường kéo dài từ năm trước sang đầu năm sau: xuất khẩu gạo dự đoán sẽ tăng so với niên vụ trước",
    example: "xuất khẩu gạo dự đoán sẽ tăng so với niên vụ trước",
  },
  {
    word: "nín bặt",
    part_of_speech: "động từ",
    meaning: "im hẳn, nín hẳn, một cách đột ngột: đang khóc bỗng nín bặt",
    example: "đang khóc bỗng nín bặt",
  },
  {
    word: "niết bàn",
    part_of_speech: "danh từ",
    meaning:
      "thế giới tưởng tượng, nơi con người thoát khỏi vòng luân hồi và mọi sự đau khổ (cái đích của sự tu hành theo đạo Phật): cõi niết bàn",
    example: "cõi niết bàn",
  },
  {
    word: "nín khe",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) nín lặng hoàn toàn, không dám nói hoặc cười, khóc một tiếng nào: ngồi nín khe, không dám nói nữa",
    example: "ngồi nín khe, không dám nói nữa",
  },
  {
    word: "niên thiếu",
    part_of_speech: "tính từ",
    meaning:
      "ít tuổi, chưa tới tuổi trưởng thành: thời niên thiếu * tuổi niên thiếu",
    example: "thời niên thiếu * tuổi niên thiếu",
  },
  {
    word: "niệt",
    part_of_speech: "danh từ",
    meaning: "dây buộc ở cổ trâu, bò: dây niệt * tròng niệt vào cổ trâu",
    example: "dây niệt * tròng niệt vào cổ trâu",
  },
  {
    word: "niệt",
    part_of_speech: "động từ",
    meaning: "buộc vào cổ trâu, bò bằng cái niệt: niệt trâu vào chuồng",
    example: "niệt trâu vào chuồng",
  },
  {
    word: "nín",
    part_of_speech: "động từ",
    meaning:
      "ngừng lại, nén lại (một hoạt động nào đó của cơ thể ): nín thở * nín cười * nín hơi lặn xuống nước",
    example: "nín thở * nín cười * nín hơi lặn xuống nước",
  },
  {
    word: "nín",
    part_of_speech: "động từ",
    meaning:
      '(phương ngữ) như nhịn (ng2): "Nói ra mang tiếng phũ phàng, Nín đi thì não can tràng xiết bao!" (ca dao)',
    example:
      'Nói ra mang tiếng phũ phàng, Nín đi thì não can tràng xiết bao!" (ca dao)',
  },
  {
    word: "niêu",
    part_of_speech: "danh từ",
    meaning:
      "nồi đất nhỏ, thường dùng nấu cơm, kho cá: niêu đất * cơm niêu nước lọ (tng)",
    example: "niêu đất * cơm niêu nước lọ (tng)",
  },
  {
    word: "nín lặng",
    part_of_speech: "động từ",
    meaning:
      "im hẳn, không nói, không có một tiếng động nào: nín lặng một lúc mới cất tiếng trả lời",
    example: "nín lặng một lúc mới cất tiếng trả lời",
  },
  {
    word: "nín nhịn",
    part_of_speech: "động từ",
    meaning:
      "nén lòng chịu nhịn, không phản ứng, không chống lại (nói khái quát): cố nín nhịn cho xong chuyện * tức quá, không sao nín nhịn được",
    example: "cố nín nhịn cho xong chuyện * tức quá, không sao nín nhịn được",
  },
  {
    word: "ninh",
    part_of_speech: "động từ",
    meaning:
      "nấu nhừ thức ăn bằng cách đun nhỏ lửa và lâu: ninh khoai cho nhừ * ninh chân giò",
    example: "ninh khoai cho nhừ * ninh chân giò",
  },
  {
    word: "nín thít",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) im bặt, hoàn toàn không nói một lời nào: sợ quá, ngồi nín thít",
    example: "sợ quá, ngồi nín thít",
  },
  {
    word: "nín thinh",
    part_of_speech: "động từ",
    meaning:
      "im không nói gì, không lên tiếng: ngồi nín thinh, không nói năng gì",
    example: "ngồi nín thinh, không nói năng gì",
  },
  {
    word: "nịnh hót",
    part_of_speech: "động từ",
    meaning: "nịnh nọt và ton hót: nịnh hót cấp trên",
    example: "nịnh hót cấp trên",
  },
  {
    word: "nịnh",
    part_of_speech: "động từ",
    meaning:
      "khen không đúng hoặc khen quá lời, chỉ cốt để làm đẹp lòng (thường nhằm mục đích cầu lợi): trẻ con ưa nịnh * khéo nịnh * nịnh trên nạt dưới",
    example: "trẻ con ưa nịnh * khéo nịnh * nịnh trên nạt dưới",
  },
  {
    word: "nịnh bợ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nịnh một cách hèn hạ để cầu lợi (nói khái quát): nịnh bợ kẻ có quyền thế",
    example: "nịnh bợ kẻ có quyền thế",
  },
  {
    word: "nịnh đầm",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) nịnh phụ nữ để lấy lòng: chỉ giỏi nịnh đầm!",
    example: "chỉ giỏi nịnh đầm!",
  },
  {
    word: "nình nịch",
    part_of_speech: "tính từ",
    meaning:
      "rất chắc, đến mức như được dồn nén chặt lại: cánh tay chắc nình nịch",
    example: "cánh tay chắc nình nịch",
  },
  {
    word: "nịt",
    part_of_speech: "động từ",
    meaning:
      "thít chặt làm cho bó sát: nịt bụng * áo nịt ngực * nịt chặt ống quần",
    example: "nịt bụng * áo nịt ngực * nịt chặt ống quần",
  },
  {
    word: "nịt",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ) (dây) thắt lưng: chiếc nịt da",
    example: "chiếc nịt da",
  },
  {
    word: "ninh ních",
    part_of_speech: "tính từ",
    meaning:
      'nhiều và đầy như không thể lèn thêm được nữa: ăn no, bụng căng ninh ních * "Hề đồng theo bốn năm thằng, Thơ ninh ních túi, rượu lưng lửng bầu." (NĐM)',
    example:
      'ăn no, bụng căng ninh ních * "Hề đồng theo bốn năm thằng, Thơ ninh ních túi, rượu lưng lửng bầu." (NĐM)',
  },
  {
    word: "nịnh nọt",
    part_of_speech: "động từ",
    meaning: "nịnh (nói khái quát): giọng nịnh nọt * nịnh nọt cấp trên",
    example: "giọng nịnh nọt * nịnh nọt cấp trên",
  },
  {
    word: "níu",
    part_of_speech: "động từ",
    meaning:
      "nắm lấy và kéo lại, kéo xuống: đứa bé níu áo mẹ * níu lại, không cho đi",
    example: "đứa bé níu áo mẹ * níu lại, không cho đi",
  },
  {
    word: "níu áo",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) ví việc kìm giữ nhau lại không muốn cho tiến bộ hoặc vượt lên hơn mình: tư tưởng níu áo nhau",
    example: "tư tưởng níu áo nhau",
  },
  {
    word: "nõ",
    part_of_speech: "danh từ",
    meaning:
      "cọc đóng vào giữa một vật, thường để làm trụ hay để cho chắc: tra nõ vào chổi * nõ cối xay",
    example: "tra nõ vào chổi * nõ cối xay",
  },
  {
    word: "nõ",
    part_of_speech: "danh từ",
    meaning: "phần cuống ăn sâu vào trong quả: nõ na * mít chín bị tụt nõ",
    example: "nõ na * mít chín bị tụt nõ",
  },
  {
    word: "nõ",
    part_of_speech: "danh từ",
    meaning:
      "ống nhỏ trong điếu hút thuốc lào, để cho thuốc vào đó mà hút: nõ tẩu * bỏ thuốc vào nõ điếu",
    example: "nõ tẩu * bỏ thuốc vào nõ điếu",
  },
  {
    word: "no",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái nhu cầu sinh lí về ăn uống được thoả mãn đầy đủ: ăn cho no bụng * bữa no bữa đói",
    example: "ăn cho no bụng * bữa no bữa đói",
  },
  {
    word: "no",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái nhu cầu nào đó đã được thoả mãn hoàn toàn đầy đủ, không thể nhận thêm được nữa: đất ngấm no nước * xe no xăng * cánh diều no gió",
    example: "đất ngấm no nước * xe no xăng * cánh diều no gió",
  },
  {
    word: "no",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) hết mức, có muốn hơn nữa cũng không được: cười no bụng * bị một trận no đòn * ngủ no mắt",
    example: "cười no bụng * bị một trận no đòn * ngủ no mắt",
  },
  {
    word: "no",
    part_of_speech: "tính từ",
    meaning: "(dung dịch) không thể hoà tan thêm nữa.",
    example: "methan là một carbur no",
  },
  {
    word: "nỏ",
    part_of_speech: "danh từ",
    meaning:
      "khí giới hình cái cung, có cán làm tay cầm và có lẫy, căng bật dây để bắn tên: giương nỏ bắn chim",
    example: "giương nỏ bắn chim",
  },
  {
    word: "nỏ",
    part_of_speech: "tính từ",
    meaning:
      "khô đến mức như không còn một chút chất nước nào cả: củi nỏ dễ cháy",
    example: "củi nỏ dễ cháy",
  },
  {
    word: "nỏ",
    part_of_speech: "phụ từ",
    meaning:
      '(phương ngữ) không, chẳng: nỏ có chi * "Thương em nỏ biết mần răng, Mười đêm ra đứng trông trăng cả mười." (ca dao)',
    example:
      'nỏ có chi * "Thương em nỏ biết mần răng, Mười đêm ra đứng trông trăng cả mười." (ca dao)',
  },
  {
    word: "nó",
    part_of_speech: "đại từ",
    meaning:
      "từ dùng để chỉ người hay vật ở ngôi thứ ba: việc của nó, cứ để nó làm * nó lú nhưng chú nó khôn (tng)",
    example: "việc của nó, cứ để nó làm * nó lú nhưng chú nó khôn (tng)",
  },
  {
    word: "nó",
    part_of_speech: "đại từ",
    meaning:
      '(khẩu ngữ) từ dùng để chỉ người, vật hay sự việc vừa nêu ngay trước đó, có tính chất nhấn mạnh hoặc để cho lời nói tự nhiên hơn: hát cho nó vui * tính tôi nó thế * "Hạt tiêu nó bé nó cay, Đồng tiền nó bé, nó hay cửa quyền." (ca dao)',
    example:
      'hát cho nó vui * tính tôi nó thế * "Hạt tiêu nó bé nó cay, Đồng tiền nó bé, nó hay cửa quyền." (ca dao)',
  },
  {
    word: "nò",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) lờ: đặt nò",
    example: "đặt nò",
  },
  {
    word: "nọ",
    part_of_speech: "đại từ",
    meaning:
      "từ dùng để chỉ cái không xác định cụ thể ở cách xa hay ở trong quá khứ: hôm nọ * ở một làng nọ * kẻ này, người nọ * chuyện nọ xọ chuyện kia",
    example:
      "hôm nọ * ở một làng nọ * kẻ này, người nọ * chuyện nọ xọ chuyện kia",
  },
  {
    word: "no ấm",
    part_of_speech: "tính từ",
    meaning: "như ấm no: cuộc sống no ấm",
    example: "cuộc sống no ấm",
  },
  {
    word: "níu kéo",
    part_of_speech: "động từ",
    meaning: "níu giữ lại: níu kéo khách hàng * tìm cách níu kéo cuộc hôn nhân",
    example: "níu kéo khách hàng * tìm cách níu kéo cuộc hôn nhân",
  },
  {
    word: "nỏ miệng",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như nỏ mồm: nỏ miệng nó vừa vừa thôi!",
    example: "nỏ miệng nó vừa vừa thôi!",
  },
  {
    word: "no đủ",
    part_of_speech: "tính từ",
    meaning: "đầy đủ về đời sống vật chất: cuộc sống no đủ",
    example: "cuộc sống no đủ",
  },
  {
    word: "nỏ mồm",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) lắm lời và lớn tiếng, gây cảm giác khó chịu: nỏ mồm cãi * đừng có nỏ mồm!",
    example: "nỏ mồm cãi * đừng có nỏ mồm!",
  },
  {
    word: "no tròn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có dáng hình căng tròn, đầy đặn: cái bụng no tròn * thân hình no tròn",
    example: "cái bụng no tròn * thân hình no tròn",
  },
  {
    word: "no nê",
    part_of_speech: "tính từ",
    meaning:
      "no tới mức hoàn toàn thoả mãn: ăn uống no nê * chén no nê * đánh một giấc no nê (kng; ngủ đẫy giấc)",
    example:
      "ăn uống no nê * chén no nê * đánh một giấc no nê (kng; ngủ đẫy giấc)",
  },
  {
    word: "nọc",
    part_of_speech: "danh từ",
    meaning: "chất độc do tuyến đặc biệt tiết ra ở một số động vật: nọc rắn",
    example: "nọc rắn",
  },
  {
    word: "nọc",
    part_of_speech: "danh từ",
    meaning:
      "cọc đóng xuống đất để buộc người cho căng ra mà đánh (khi thi hành một hình phạt thời phong kiến).",
    example: "nọc trầu",
  },
  {
    word: "nọc",
    part_of_speech: "động từ",
    meaning: "căng người ra để đánh đòn: nọc xác ra * nọc cổ đánh cho một trận",
    example: "nọc xác ra * nọc cổ đánh cho một trận",
  },
  {
    word: "nọc",
    part_of_speech: "danh từ",
    meaning:
      "phần bài còn lại sau khi chia, để cho mọi người rút, trong trò chơi tổ tôm hoặc tài bàn: bốc nọc",
    example: "bốc nọc",
  },
  {
    word: "nóc",
    part_of_speech: "danh từ",
    meaning:
      "chỗ cao nhất của mái nhà, nơi tiếp giáp giữa các mặt mái: dột từ nóc dột xuống (tng)",
    example: "dột từ nóc dột xuống (tng)",
  },
  {
    word: "nóc",
    part_of_speech: "danh từ",
    meaning:
      "phần trên cùng của một số vật: nóc chạn * để trên nóc tủ * ngồi trên nóc xe",
    example: "nóc chạn * để trên nóc tủ * ngồi trên nóc xe",
  },
  {
    word: "nọc nạng",
    part_of_speech: "danh từ",
    meaning:
      "cọc có hai hoặc ba nhánh (hình giống cái chạc) được cắm xuống đất để chống, đỡ: cắm nọc nạng để đỡ giàn trầu",
    example: "cắm nọc nạng để đỡ giàn trầu",
  },
  {
    word: "nói",
    part_of_speech: "động từ",
    meaning:
      "phát ra thành tiếng, thành lời để diễn đạt một nội dung nhất định trong giao tiếp: trẻ đang tập nói * lặng im không nói",
    example: "trẻ đang tập nói * lặng im không nói",
  },
  {
    word: "nói",
    part_of_speech: "động từ",
    meaning:
      "phát ra thành tiếng, thành lời với một tính chất nào đó: nói giọng Huế * tiếng nói sang sảng * nói một cách từ tốn",
    example: "nói giọng Huế * tiếng nói sang sảng * nói một cách từ tốn",
  },
  {
    word: "nói",
    part_of_speech: "động từ",
    meaning:
      "sử dụng một thứ tiếng nào đó, phát âm để giao tiếp: nói tiếng Việt * nói tiếng Anh với người nước ngoài",
    example: "nói tiếng Việt * nói tiếng Anh với người nước ngoài",
  },
  {
    word: "nói",
    part_of_speech: "động từ",
    meaning:
      "có ý kiến chỉ trích, chê bai: chuyện ấy bị nhiều người nói * làm thế người ta nói cho!",
    example: "chuyện ấy bị nhiều người nói * làm thế người ta nói cho!",
  },
  {
    word: "nói",
    part_of_speech: "động từ",
    meaning:
      "thể hiện, diễn đạt một nội dung nào đó: bài thơ nói về quê hương đất nước * điều đó đã nói lên sự thật",
    example: "bài thơ nói về quê hương đất nước * điều đó đã nói lên sự thật",
  },
  {
    word: "nọc độc",
    part_of_speech: "danh từ",
    meaning:
      "chất độc ở một số loài vật; thường dùng để ví cái rất nguy hại về văn hoá, tinh thần: bị tiêm nhiễm nọc độc từ những văn hoá phẩm đồi truỵ",
    example: "bị tiêm nhiễm nọc độc từ những văn hoá phẩm đồi truỵ",
  },
  {
    word: "noi",
    part_of_speech: "động từ",
    meaning:
      "đi lần theo một lối, một hướng nào đó: noi lối cũ vào rừng * noi theo bờ suối mà đi",
    example: "noi lối cũ vào rừng * noi theo bờ suối mà đi",
  },
  {
    word: "noi",
    part_of_speech: "động từ",
    meaning:
      "học tập và làm theo điều hay, điều tốt: noi gương người tốt * noi theo tập quán cổ truyền",
    example: "noi gương người tốt * noi theo tập quán cổ truyền",
  },
  {
    word: "nòi",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị phân loại sinh học, chỉ nhóm động vật thuộc cùng một loài, có những đặc tính di truyền chung: nòi gà chọi * nòi chó săn",
    example: "nòi gà chọi * nòi chó săn",
  },
  {
    word: "nòi",
    part_of_speech: "danh từ",
    meaning: "giống nòi (nói tắt): nòi nào giống ấy * yêu nước thương nòi",
    example: "nòi nào giống ấy * yêu nước thương nòi",
  },
  {
    word: "nòi",
    part_of_speech: "danh từ",
    meaning:
      "giống tốt, có nhiều đặc tính di truyền ưu việt: chó săn nòi * cờ bạc nòi * con nhà nòi",
    example: "chó săn nòi * cờ bạc nòi * con nhà nòi",
  },
  {
    word: "nói bóng gió",
    part_of_speech: "",
    meaning:
      "không nói thẳng, trực tiếp, mà nói xa xôi hoặc mượn chuyện khác để nói cho người ta tự suy ngẫm mà hiểu ý: chỉ bóng gió xa xôi, chứ không nói thẳng",
    example: "chỉ bóng gió xa xôi, chứ không nói thẳng",
  },
  {
    word: "nói cạnh",
    part_of_speech: "động từ",
    meaning: "nói gần nói xa để châm chọc, khích bác: nói cạnh nhau",
    example: "nói cạnh nhau",
  },
  {
    word: "nói chung",
    part_of_speech: "",
    meaning:
      "tổ hợp dùng phối hợp với nói chung để nêu nhấn mạnh một điều ở một bộ phận nào đó, tuy rằng điều ấy là chung cho cả toàn thể: phát triển văn học nói chung và thơ ca nói riêng",
    example: "phát triển văn học nói chung và thơ ca nói riêng",
  },
  {
    word: "nói cho phải",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) nói cho đúng ra thì... (cho nên thật ra không đến nỗi tồi tệ như đã nói): nói cho phải thì hắn cũng biết tí chút",
    example: "nói cho phải thì hắn cũng biết tí chút",
  },
  {
    word: "nói chơi",
    part_of_speech: "động từ",
    meaning:
      'nói cho vui, không nhằm mục đích gì: chuyện quan trọng, không thể nói chơi * "Tưởng là thiên hạ nói chơi, Hay đâu nói thiệt, rụng rời tay chân." (Cdao)',
    example:
      'chuyện quan trọng, không thể nói chơi * "Tưởng là thiên hạ nói chơi, Hay đâu nói thiệt, rụng rời tay chân." (Cdao)',
  },
  {
    word: "nói chữ",
    part_of_speech: "động từ",
    meaning:
      "sính dùng từ ngữ kiểu cách, khó hiểu (thường là từ ngữ gốc Hán): đã dốt lại còn hay nói chữ",
    example: "đã dốt lại còn hay nói chữ",
  },
  {
    word: "nói chuyện",
    part_of_speech: "động từ",
    meaning:
      "nói với nhau một cách tự nhiên, về những chuyện bình thường trong giao tiếp: vừa đi vừa nói chuyện * không nói chuyện trong giờ học",
    example: "vừa đi vừa nói chuyện * không nói chuyện trong giờ học",
  },
  {
    word: "nói chuyện",
    part_of_speech: "động từ",
    meaning:
      "trình bày vấn đề gì một cách có hệ thống trước đông người: nói chuyện thời sự",
    example: "nói chuyện thời sự",
  },
  {
    word: "nói chuyện",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nói cho biết rõ ý kiến, thái độ: để lát nữa tôi sẽ nói chuyện với anh",
    example: "để lát nữa tôi sẽ nói chuyện với anh",
  },
  {
    word: "nói chặn",
    part_of_speech: "động từ",
    meaning:
      "nói trước để ngăn ngừa điều cho là người ta sắp nói, sắp làm: đoán được ý nên phải nói chặn trước",
    example: "đoán được ý nên phải nói chặn trước",
  },
  {
    word: "nói dối",
    part_of_speech: "động từ",
    meaning:
      "nói sai sự thật một cách cố ý, nhằm che giấu điều gì: nói dối quen mồm * ăn mặn nói ngay còn hơn ăn chay nói dối (tng)",
    example: "nói dối quen mồm * ăn mặn nói ngay còn hơn ăn chay nói dối (tng)",
  },
  {
    word: "nói cứng",
    part_of_speech: "động từ",
    meaning:
      "nói để tỏ ra vẫn vững vàng, kiên quyết, không phân vân, không lo sợ: miệng vẫn nói cứng nhưng trong bụng đã run lắm rồi",
    example: "miệng vẫn nói cứng nhưng trong bụng đã run lắm rồi",
  },
  {
    word: "nói của đáng tội",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị sự chuyển ý để nhằm thanh minh hoặc làm rõ thêm cho điều ít nhiều không hay vừa nói đến: của đáng tội, cả hai bên đều có cái sai",
    example: "của đáng tội, cả hai bên đều có cái sai",
  },
  {
    word: "nói dóc",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nói khoác lác và bịa đặt cốt để cho vui hay để ra vẻ ta đây: đừng tin, hắn nói dóc đó!",
    example: "đừng tin, hắn nói dóc đó!",
  },
  {
    word: "nói gần nói xa",
    part_of_speech: "",
    meaning:
      "nói một cách gián tiếp, xa xôi, chứ không nói thẳng: nói gần nói xa chẳng qua nói thật",
    example: "nói gần nói xa chẳng qua nói thật",
  },
  {
    word: "nói đúng ra",
    part_of_speech: "",
    meaning:
      "đúng lí ra (thì thế này, chứ không phải như người ta nghĩ): nói đúng ra, anh nên đi mới phải",
    example: "nói đúng ra, anh nên đi mới phải",
  },
  {
    word: "nói điêu",
    part_of_speech: "động từ",
    meaning:
      "nói những điều không có thật hoặc quá sự thật, để lừa dối hoặc để đổ vấy cho người khác: quen thói nói điêu",
    example: "quen thói nói điêu",
  },
  {
    word: "nói gì thì nói",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) dù như thế nào thì sự thật cũng là (và phải thừa nhận là như vậy): nói gì thì nói, cách tính toán của ông ấy vẫn là đúng",
    example: "nói gì thì nói, cách tính toán của ông ấy vẫn là đúng",
  },
  {
    word: "nói đớt",
    part_of_speech: "động từ",
    meaning:
      "nói không được bình thường, không phát âm rõ được một số âm, do có tật ở lưỡi: có tật nói đớt",
    example: "có tật nói đớt",
  },
  {
    word: "nói gở",
    part_of_speech: "động từ",
    meaning:
      "nói ra những lời cho là có thể báo trước hoặc đưa đến điều chẳng lành, theo quan niệm dân gian: chỉ được cái nói gở!",
    example: "chỉ được cái nói gở!",
  },
  {
    word: "nói gì",
    part_of_speech: "",
    meaning:
      "như huống gì (nhưng thường dùng trong câu có ý phủ định): đồng lương ăn còn chẳng đủ, nói gì may sắm",
    example: "đồng lương ăn còn chẳng đủ, nói gì may sắm",
  },
  {
    word: "nòi giống",
    part_of_speech: "danh từ",
    meaning: "như giống nòi: duy trì nòi giống",
    example: "duy trì nòi giống",
  },
  {
    word: "nói gì đến",
    part_of_speech: "",
    meaning:
      "như nói gì (nhưng nghĩa mạnh hơn): ngồi không mà ăn thì núi cũng phải lở, nói gì đến số tiền cỏn con",
    example:
      "ngồi không mà ăn thì núi cũng phải lở, nói gì đến số tiền cỏn con",
  },
  {
    word: "nói hươu nói vượn",
    part_of_speech: "",
    meaning:
      "nói rất nhiều và toàn là những chuyện khoác lác, không thật, không thực tế: chỉ toàn nói hươu nói vượn!",
    example: "chỉ toàn nói hươu nói vượn!",
  },
  {
    word: "nói kháy",
    part_of_speech: "động từ",
    meaning: "nói cạnh khoé, xa xôi để khích bác, trêu tức: nói kháy nhau",
    example: "nói kháy nhau",
  },
  {
    word: "nói khéo",
    part_of_speech: "động từ",
    meaning:
      "nói bằng lời lẽ mềm mỏng, thích hợp để làm vừa lòng người nghe (nhằm đạt mục đích nhất định): nói khéo để nó nghe ra",
    example: "nói khéo để nó nghe ra",
  },
  {
    word: "nói khan nói vã",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) nói hết lời, đủ cách, để cố thuyết phục, nài xin: phải nói khan nói vã mãi người ta mới cho vay",
    example: "phải nói khan nói vã mãi người ta mới cho vay",
  },
  {
    word: "nói lảng",
    part_of_speech: "động từ",
    meaning:
      "nói sang chuyện khác, cốt để tránh chuyện đang nói: không muốn trả lời nên nói lảng ra chuyện khác",
    example: "không muốn trả lời nên nói lảng ra chuyện khác",
  },
  {
    word: "nói khó",
    part_of_speech: "động từ",
    meaning:
      "nói rõ hết tình cảnh khó khăn để nài xin, thuyết phục: nói khó mãi người ta mới cho vay",
    example: "nói khó mãi người ta mới cho vay",
  },
  {
    word: "nói lái",
    part_of_speech: "động từ",
    meaning:
      "nói khác đi một tổ hợp hai, ba âm tiết bằng cách chuyển đổi riêng phần vần hay phần phụ âm đầu hoặc thanh điệu, có thể đổi cả trật tự các âm tiết, để bông đùa hoặc chơi chữ, châm biếm: nói  *  thành  *  là một cách nói lái",
    example: "nói  *  thành  *  là một cách nói lái",
  },
  {
    word: "nói láo",
    part_of_speech: "động từ",
    meaning:
      "nói hỗn hoặc nói những chuyện nhảm nhí, không đứng đắn: đừng có nói láo!",
    example: "đừng có nói láo!",
  },
  {
    word: "nói láo",
    part_of_speech: "động từ",
    meaning:
      '(phương ngữ) nói dối: "Nhà anh lợp những mo nang, Nói láo với nàng nhà ngói năm căn." (ca dao)',
    example:
      'Nhà anh lợp những mo nang, Nói láo với nàng nhà ngói năm căn." (ca dao)',
  },
  {
    word: "nói khoác",
    part_of_speech: "động từ",
    meaning:
      "nói những điều quá xa sự thật hoặc không thể có trong thực tế để khoe khoang hoặc để đùa vui: tính hay nói khoác",
    example: "tính hay nói khoác",
  },
  {
    word: "nói leo",
    part_of_speech: "động từ",
    meaning:
      "nói chen vào chuyện của người khác (thường là người trên) khi không được hỏi đến: trẻ con không được nói leo",
    example: "trẻ con không được nói leo",
  },
  {
    word: "nói lửng",
    part_of_speech: "động từ",
    meaning:
      "nói nửa chừng, không hết ý, để cho người nghe tự hiểu: buông câu nói lửng",
    example: "buông câu nói lửng",
  },
  {
    word: "nói lắp",
    part_of_speech: "động từ",
    meaning:
      "nói không trơn tru, trôi chảy, hay nhắc đi nhắc lại nhiều lần một tiếng, do có tật: bị tật nói lắp",
    example: "bị tật nói lắp",
  },
  {
    word: "nói mê",
    part_of_speech: "động từ",
    meaning: "nói trong lúc nằm mơ: nói mê lảm nhảm",
    example: "nói mê lảm nhảm",
  },
  {
    word: "nói mát",
    part_of_speech: "động từ",
    meaning:
      "nói dịu nhẹ có vẻ như khen, nhưng thật ra là chê trách hoặc mỉa mai: nói mát một câu",
    example: "nói mát một câu",
  },
  {
    word: "nói mép",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nói nhiều và khéo, nhưng chỉ là ngoài miệng, không đúng với suy nghĩ hoặc không đúng với việc làm thực tế: nó chỉ giỏi nói mép thôi, chứ làm được gì",
    example: "nó chỉ giỏi nói mép thôi, chứ làm được gì",
  },
  {
    word: "nói mò",
    part_of_speech: "động từ",
    meaning:
      "nói một cách hú hoạ, không có căn cứ: ăn ốc nói mò (tng) * chỉ được cái nói mò!",
    example: "ăn ốc nói mò (tng) * chỉ được cái nói mò!",
  },
  {
    word: "nói móc",
    part_of_speech: "động từ",
    meaning:
      "nói những lời châm chọc, soi mói điều không hay của người khác một cách cố ý: nói móc để khiêu khích",
    example: "nói móc để khiêu khích",
  },
  {
    word: "nói năng",
    part_of_speech: "động từ",
    meaning:
      "nói để giao tiếp (nói khái quát): nói năng lưu loát * ngồi im, không nói năng gì",
    example: "nói năng lưu loát * ngồi im, không nói năng gì",
  },
  {
    word: "nói nhăng nói cuội",
    part_of_speech: "",
    meaning: "nói linh tinh, nhảm nhí, vớ vẩn: toàn nói nhăng nói cuội!",
    example: "toàn nói nhăng nói cuội!",
  },
  {
    word: "nói ngoa",
    part_of_speech: "động từ",
    meaning:
      "nói một cách phóng đại, quá xa sự thật: không phải nói ngoa, nhà ấy giàu nhất nước",
    example: "không phải nói ngoa, nhà ấy giàu nhất nước",
  },
  {
    word: "nói phách",
    part_of_speech: "động từ",
    meaning: "nói khoác lác, vẻ kiêu căng, hợm hĩnh: chỉ giỏi nói phách!",
    example: "chỉ giỏi nói phách!",
  },
  {
    word: "nói nhịu",
    part_of_speech: "động từ",
    meaning:
      "nói tiếng nọ lẫn ra tiếng kia, do có tật: có tật nói nhịu * bị nói nhịu",
    example: "có tật nói nhịu * bị nói nhịu",
  },
  {
    word: "nói ngọt",
    part_of_speech: "động từ",
    meaning:
      "nói dịu dàng, khéo léo, dễ nghe để dỗ dành, thuyết phục: nói ngọt lọt đến xương (tng)",
    example: "nói ngọt lọt đến xương (tng)",
  },
  {
    word: "nói nhỏ",
    part_of_speech: "động từ",
    meaning:
      "nói riêng với nhau, chỉ đủ nghe, không để người khác nghe biết: nói nhỏ vào tai bạn",
    example: "nói nhỏ vào tai bạn",
  },
  {
    word: "nói phét",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nói quá xa sự thật những điều cho như là mình có thể làm được: chỉ giỏi nói phét!",
    example: "chỉ giỏi nói phét!",
  },
  {
    word: "nói quanh",
    part_of_speech: "động từ",
    meaning:
      "nói vòng vo, không đi thẳng vào vấn đề, để tránh nói sự thật: bị hỏi vặn nên cứ nói quanh mãi",
    example: "bị hỏi vặn nên cứ nói quanh mãi",
  },
  {
    word: "nói ngang",
    part_of_speech: "động từ",
    meaning:
      'nói trái với lẽ phải, thiếu thiện ý trong sự bàn bạc, làm cản trở công việc: "Bởi chưng thầy mẹ nói ngang, Để cho đũa ngọc mâm vàng cách xa." (ca dao)',
    example:
      'Bởi chưng thầy mẹ nói ngang, Để cho đũa ngọc mâm vàng cách xa." (ca dao)',
  },
  {
    word: "nói ngon nói ngọt",
    part_of_speech: "",
    meaning:
      "như nói ngọt (nhưng nghĩa mạnh hơn): nói ngon nói ngọt để dỗ dành",
    example: "nói ngon nói ngọt để dỗ dành",
  },
  {
    word: "nói sảng",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) nói trong cơn mê sảng: người bệnh nói sảng * sốt cao nên nói sảng",
    example: "người bệnh nói sảng * sốt cao nên nói sảng",
  },
  {
    word: "nói riêng",
    part_of_speech: "",
    meaning:
      "tổ hợp dùng phối hợp với nói chung để nêu nhấn mạnh một điều ở một bộ phận nào đó, tuy rằng điều ấy là chung cho cả toàn thể: phát triển văn học nói chung và thơ ca nói riêng",
    example: "phát triển văn học nói chung và thơ ca nói riêng",
  },
  {
    word: "nói thách",
    part_of_speech: "động từ",
    meaning:
      "nói giá cao hơn so với giá định bán: nói đúng giá bán, không nói thách",
    example: "nói đúng giá bán, không nói thách",
  },
  {
    word: "nói sõi",
    part_of_speech: "động từ",
    meaning:
      "nói rõ ràng và ở mức thông thạo (thường nói về trẻ em): đứa bé đã nói sõi * chưa nói sõi tiếng Anh",
    example: "đứa bé đã nói sõi * chưa nói sõi tiếng Anh",
  },
  {
    word: "nói suông",
    part_of_speech: "động từ",
    meaning: "nói mà không làm: chỉ được bộ nói suông",
    example: "chỉ được bộ nói suông",
  },
  {
    word: "nói thánh nói tướng",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) nói huênh hoang, tự cho mình là tài, là giỏi: cứ ngồi đấy mà nói thánh nói tướng!",
    example: "cứ ngồi đấy mà nói thánh nói tướng!",
  },
  {
    word: "nói thẳng",
    part_of_speech: "động từ",
    meaning:
      "nói trực tiếp với người mình muốn nói, không qua trung gian: có gì thắc mắc cứ nói thẳng với giám đốc",
    example: "có gì thắc mắc cứ nói thẳng với giám đốc",
  },
  {
    word: "nói thẳng",
    part_of_speech: "động từ",
    meaning:
      "nói thật, nói hết những điều thấy cần nói, muốn nói, không giấu giếm: có gì thì cứ nói thẳng ra",
    example: "có gì thì cứ nói thẳng ra",
  },
  {
    word: "nói toạc",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nói thẳng ra một cách rõ ràng, không che đậy, úp mở (thường là điều khó nói): có gì cứ nói toạc ra, cần gì phải úp mở",
    example: "có gì cứ nói toạc ra, cần gì phải úp mở",
  },
  {
    word: "nói thầm",
    part_of_speech: "động từ",
    meaning:
      'nói thật khẽ chỉ đủ cho một người nghe: ghé tai nói thầm * "Quạt này là quạt tri âm, Để dành che miệng, nói thầm cùng nhau." (ca dao)',
    example:
      'ghé tai nói thầm * "Quạt này là quạt tri âm, Để dành che miệng, nói thầm cùng nhau." (ca dao)',
  },
  {
    word: "nói toẹt",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) nói thẳng ra, không cần che giấu hoặc giữ gìn gì: nói toẹt ra, chẳng cần ý tứ gì hết!",
    example: "nói toẹt ra, chẳng cần ý tứ gì hết!",
  },
  {
    word: "nói trạng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nói khoác lác, làm ra vẻ tài giỏi: đừng có nói trạng, thử làm xem sao!",
    example: "đừng có nói trạng, thử làm xem sao!",
  },
  {
    word: "nói trạng",
    part_of_speech: "động từ",
    meaning:
      "nói những chuyện bông đùa, khoác lác cho vui: ngồi nói trạng với nhau cho vui",
    example: "ngồi nói trạng với nhau cho vui",
  },
  {
    word: "nói tóm lại",
    part_of_speech: "",
    meaning:
      "nói vắn tắt để kết luận: nói tóm lại sự việc chỉ có thế! * nói tóm lại, anh có đồng ý không?",
    example:
      "nói tóm lại sự việc chỉ có thế! * nói tóm lại, anh có đồng ý không?",
  },
  {
    word: "nói trắng ra",
    part_of_speech: "",
    meaning:
      "nói rõ sự thật không cần che đậy, giấu giếm: cứ nói trắng ra, không cần phải bóng gió",
    example: "cứ nói trắng ra, không cần phải bóng gió",
  },
  {
    word: "nói trống",
    part_of_speech: "động từ",
    meaning: "như nói trống không (ng1): người ta nói trống mà cũng động lòng",
    example: "người ta nói trống mà cũng động lòng",
  },
  {
    word: "nói trộm vía",
    part_of_speech: "",
    meaning:
      "lời mở đầu khi nói lời khen sức khoẻ trẻ nhỏ để tránh cho lời khen khỏi chạm vía và thành điềm gở, theo quan niệm dân gian: nói trộm vía, cháu bé bụ bẫm lắm!",
    example: "nói trộm vía, cháu bé bụ bẫm lắm!",
  },
  {
    word: "nói trống không",
    part_of_speech: "động từ",
    meaning:
      "nói mà không nêu rõ đối tượng muốn nói đến: nói trống không, chẳng nói với ai hết",
    example: "nói trống không, chẳng nói với ai hết",
  },
  {
    word: "nói tướng",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) nói thật to lên: tức quá, nói tướng lên",
    example: "tức quá, nói tướng lên",
  },
  {
    word: "nói tướng",
    part_of_speech: "động từ",
    meaning:
      "nói huênh hoang, khoác lác để ra vẻ ta đây: đi đâu cũng nói tướng lên là bằng này bằng nọ",
    example: "đi đâu cũng nói tướng lên là bằng này bằng nọ",
  },
  {
    word: "nói vụng",
    part_of_speech: "động từ",
    meaning:
      "nói lén lút với nhau sau lưng về những điều không hay, không tốt của người khác: nói vụng sau lưng",
    example: "nói vụng sau lưng",
  },
  {
    word: "nói vợ",
    part_of_speech: "động từ",
    meaning: "(phương ngữ, khẩu ngữ) hỏi vợ: đi nói vợ cho con",
    example: "đi nói vợ cho con",
  },
  {
    word: "nói trổng",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) nói trống không: má nó đánh vì cái tội hay nói trổng",
    example: "má nó đánh vì cái tội hay nói trổng",
  },
  {
    word: "nói vã bọt mép",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) nói rất nhiều, nhằm nài xin, khuyên bảo hay thuyết phục: phải nói vã bọt mép mới được đấy",
    example: "phải nói vã bọt mép mới được đấy",
  },
  {
    word: "nói tục",
    part_of_speech: "động từ",
    meaning: "nói những lời thô tục: hay nói tục * quen mồm nói tục",
    example: "hay nói tục * quen mồm nói tục",
  },
  {
    word: "nói xàm",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) nói tầm bậy: chỉ được cái nói xàm!",
    example: "chỉ được cái nói xàm!",
  },
  {
    word: "nòm",
    part_of_speech: "danh từ",
    meaning: "vật dễ cháy, dùng để nhóm lửa: lấy giấy làm nòm",
    example: "lấy giấy làm nòm",
  },
  {
    word: "nói xấu",
    part_of_speech: "động từ",
    meaning:
      "nói sau lưng những điều không hay, không tốt của người khác, nhằm bôi nhọ, làm giảm uy tín: đặt điều nói xấu * nói xấu sau lưng",
    example: "đặt điều nói xấu * nói xấu sau lưng",
  },
  {
    word: "nói xỏ",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) nói xa xôi, bóng gió, nhằm châm chọc một cách ác ý: nghe ngứa tai nên nói xỏ một câu",
    example: "nghe ngứa tai nên nói xỏ một câu",
  },
  {
    word: "non",
    part_of_speech: "danh từ",
    meaning:
      '(văn chương) núi: non xanh nước biếc * "Một cây làm chẳng nên non, Ba cây chụm lại nên hòn núi cao." (Cdao)',
    example:
      'non xanh nước biếc * "Một cây làm chẳng nên non, Ba cây chụm lại nên hòn núi cao." (Cdao)',
  },
  {
    word: "non",
    part_of_speech: "tính từ",
    meaning:
      "ở vào giai đoạn đầu tiên của quá trình sống tự nhiên (mới mọc, mới sinh ra), cơ thể còn yếu ớt, chưa phát triển đầy đủ: chồi non * quả còn non * con chim non",
    example: "chồi non * quả còn non * con chim non",
  },
  {
    word: "non",
    part_of_speech: "tính từ",
    meaning:
      "(làm hoặc xảy ra việc gì) sớm hơn bình thường, khi chưa đủ điều kiện hoặc quá trình trước đó diễn ra chưa trọn vẹn: đẻ non * về hưu non * bán lúa non * đánh bạc ăn non",
    example: "đẻ non * về hưu non * bán lúa non * đánh bạc ăn non",
  },
  {
    word: "non",
    part_of_speech: "tính từ",
    meaning:
      "có số lượng, mức độ dưới mức chuẩn, dưới mức yêu cầu phải đạt được: đậu rán non * cơm non lửa * gạch non",
    example: "đậu rán non * cơm non lửa * gạch non",
  },
  {
    word: "non",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) gần đến, còn thiếu chút ít nữa mới đạt đến một mức cụ thể nào đó: còn non nửa bát nước * cao non một thước * từ đây đến đó mất non một tiếng",
    example:
      "còn non nửa bát nước * cao non một thước * từ đây đến đó mất non một tiếng",
  },
  {
    word: "non",
    part_of_speech: "tính từ",
    meaning:
      "(cái cân) thiếu chính xác, cho số ghi khối lượng của vật được cân ít hơn khối lượng thật một chút: cái cân hơi bị non",
    example: "cái cân hơi bị non",
  },
  {
    word: "non",
    part_of_speech: "tính từ",
    meaning:
      "ở trình độ thấp, do thiếu kinh nghiệm hoặc chưa được học tập, rèn luyện đầy đủ: non tay nghề * tay lái non * nét vẽ còn non * trình độ lí luận còn non",
    example:
      "non tay nghề * tay lái non * nét vẽ còn non * trình độ lí luận còn non",
  },
  {
    word: "non",
    part_of_speech: "tính từ",
    meaning: "yếu về bản lĩnh, tinh thần: chẳng phải tay non * non gan",
    example: "chẳng phải tay non * non gan",
  },
  {
    word: "nõn",
    part_of_speech: "danh từ",
    meaning:
      "lá non ở một số cây, còn cuộn hoặc bọc kín, chưa mở hết ra: lá nõn * nõn cỏ * tre ra nõn * màu xanh nõn chuối",
    example: "lá nõn * nõn cỏ * tre ra nõn * màu xanh nõn chuối",
  },
  {
    word: "nõn",
    part_of_speech: "tính từ",
    meaning: "mịn và mượt: nước da trắng nõn * gạo nõn * tôm bóc nõn",
    example: "nước da trắng nõn * gạo nõn * tôm bóc nõn",
  },
  {
    word: "nón",
    part_of_speech: "danh từ",
    meaning:
      "(Nam thường nón lá) đồ dùng để đội đầu, che mưa nắng, thường bằng lá và có hình một vòng tròn nhỏ dần lên đỉnh: quai nón * nghiêng nghiêng vành nón",
    example: "quai nón * nghiêng nghiêng vành nón",
  },
  {
    word: "nón",
    part_of_speech: "danh từ",
    meaning: "(Nam) mũ (đội đầu): nón vải * đội nón",
    example: "nón vải *",
  },
  {
    word: "nom dòm",
    part_of_speech: "động từ",
    meaning: "để ý nhìn để nhòm ngó, dò xét: nom dòm nhà người khác",
    example: "nom dòm nhà người khác",
  },
  {
    word: "nom dòm",
    part_of_speech: "động từ",
    meaning: "như trông chừng: nom dòm nhà cửa",
    example: "nom dòm nhà cửa",
  },
  {
    word: "nón ba tầm",
    part_of_speech: "danh từ",
    meaning:
      'nón dùng cho phụ nữ thời xưa, mặt bằng, vành rộng, thành cao, quai có rủ tua: "Ai làm cái nón quai thao, Để cho anh thấy cô nào cũng xinh." (ca dao)',
    example:
      'Ai làm cái nón quai thao, Để cho anh thấy cô nào cũng xinh." (ca dao)',
  },
  {
    word: "nom",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) như trông (ng1): ở xa quá, nom không rõ * ngôi nhà nom rất đẹp",
    example: "ở xa quá, nom không rõ * ngôi nhà nom rất đẹp",
  },
  {
    word: "nom",
    part_of_speech: "động từ",
    meaning: "để ý nhìn ngó đến: nhờ người nom hộ nhà cửa",
    example: "nhờ người nom hộ nhà cửa",
  },
  {
    word: "non bộ",
    part_of_speech: "danh từ",
    meaning: "núi giả để làm cảnh: hòn non bộ",
    example: "hòn non bộ",
  },
  {
    word: "non gan",
    part_of_speech: "tính từ",
    meaning: "thiếu can đảm, hay sợ: đồ non gan!",
    example: "đồ non gan!",
  },
  {
    word: "non kém",
    part_of_speech: "tính từ",
    meaning: "non về năng lực, trình độ: trình độ chuyên môn còn non kém",
    example: "trình độ chuyên môn còn non kém",
  },
  {
    word: "non choẹt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (vẻ mặt, giọng nói) quá non trẻ, chưa từng trải (hàm ý coi thường): mặt non choẹt",
    example: "mặt non choẹt",
  },
  {
    word: "non dại",
    part_of_speech: "tính từ",
    meaning: "(hiếm) non nớt, thơ dại: con cái còn non dại",
    example: "con cái còn non dại",
  },
  {
    word: "nõn nà",
    part_of_speech: "tính từ",
    meaning: "có vẻ đẹp mịn màng và mượt mà (như nõn cây): làn da nõn nà",
    example: "làn da nõn nà",
  },
  {
    word: "non nớt",
    part_of_speech: "tính từ",
    meaning:
      "quá non, quá yếu (nói khái quát): tuổi còn non nớt * trình độ lí luận còn non nớt",
    example: "tuổi còn non nớt * trình độ lí luận còn non nớt",
  },
  {
    word: "non nước",
    part_of_speech: "danh từ",
    meaning:
      '(văn chương) như nước non: non nước hữu tình * "Tóc thề đã chấm ngang vai, Nào lời non nước, nào lời sắt son?" (TKiều)',
    example:
      'non nước hữu tình * "Tóc thề đã chấm ngang vai, Nào lời non nước, nào lời sắt son?" (TKiều)',
  },
  {
    word: "non tay",
    part_of_speech: "tính từ",
    meaning:
      'yếu kém về tay nghề, về bản lĩnh: nét vẽ còn non tay * "Nước to sóng cả khôn chừng, Đã vào gian hiểm khuyên đừng non tay." (ca dao)',
    example:
      'nét vẽ còn non tay * "Nước to sóng cả khôn chừng, Đã vào gian hiểm khuyên đừng non tay." (ca dao)',
  },
  {
    word: "nón quai thao",
    part_of_speech: "danh từ",
    meaning:
      'nón dùng cho phụ nữ thời xưa, mặt bằng, vành rộng, thành cao, quai có rủ tua: "Ai làm cái nón quai thao, Để cho anh thấy cô nào cũng xinh." (ca dao)',
    example:
      'Ai làm cái nón quai thao, Để cho anh thấy cô nào cũng xinh." (ca dao)',
  },
  {
    word: "non trẻ",
    part_of_speech: "tính từ",
    meaning:
      "còn rất trẻ, vừa mới lớn, chưa đủ già dặn: khuôn mặt non trẻ * bộ óc non trẻ * tuổi đời còn quá non trẻ",
    example: "khuôn mặt non trẻ * bộ óc non trẻ * tuổi đời còn quá non trẻ",
  },
  {
    word: "non trẻ",
    part_of_speech: "tính từ",
    meaning:
      "ở giai đoạn mới xây dựng, chưa phát triển đầy đủ: nền công nghiệp non trẻ * một nhà máy non trẻ",
    example: "nền công nghiệp non trẻ * một nhà máy non trẻ",
  },
  {
    word: "nón thúng quai thao",
    part_of_speech: "danh từ",
    meaning:
      'nón dùng cho phụ nữ thời xưa, mặt bằng, vành rộng, thành cao, quai có rủ tua: "Ai làm cái nón quai thao, Để cho anh thấy cô nào cũng xinh." (ca dao)',
    example:
      'Ai làm cái nón quai thao, Để cho anh thấy cô nào cũng xinh." (ca dao)',
  },
  {
    word: "non sông",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương) núi và sông (nói khái quát); dùng để chỉ đất nước: non sông một dải",
    example: "non sông một dải",
  },
  {
    word: "nong",
    part_of_speech: "danh từ",
    meaning:
      "đồ đan khít bằng tre, to hơn nia, lòng rộng và nông, dùng để phơi, đựng: nong tằm * phơi chè trên nong",
    example: "nong tằm * phơi chè trên nong",
  },
  {
    word: "nong",
    part_of_speech: "động từ",
    meaning:
      "cho một vật vào trong một vật rỗng để dùng lực ép từ bên trong làm cho vật đó rộng ra: nong ống * nong khung xe đạp * nong động mạch vành",
    example: "nong ống * nong khung xe đạp * nong động mạch vành",
  },
  {
    word: "nong",
    part_of_speech: "động từ",
    meaning: "(Khẩu ngữ) luồn cho vào hẳn bên trong: nong chân vào giầy",
    example: "nong chân vào giầy",
  },
  {
    word: "nõn nường",
    part_of_speech: "tính từ",
    meaning: "(cũ) như nõn nà (nhưng thường dùng với ý mỉa mai): đẹp nõn nường",
    example: "đẹp nõn nường",
  },
  {
    word: "non yếu",
    part_of_speech: "tính từ",
    meaning: "non trẻ và yếu ớt: nền công nghiệp non yếu * đối thủ non yếu",
    example: "nền công nghiệp non yếu * đối thủ non yếu",
  },
  {
    word: "nóng",
    part_of_speech: "tính từ",
    meaning:
      "có nhiệt độ cao hơn so với nhiệt độ cơ thể người, hoặc cao hơn mức được coi là trung bình: nước nóng * xấu hổ, mặt nóng bừng * trời nóng kéo dài",
    example: "nước nóng * xấu hổ, mặt nóng bừng * trời nóng kéo dài",
  },
  {
    word: "nóng",
    part_of_speech: "tính từ",
    meaning:
      "dễ nổi cơn tức giận, khó kìm giữ được những phản ứng thiếu suy nghĩ: tính nóng như lửa * người dễ nổi nóng",
    example: "tính nóng như lửa * người dễ nổi nóng",
  },
  {
    word: "nóng",
    part_of_speech: "tính từ",
    meaning:
      "muốn có ngay, biết ngay về điều gì: nóng trở lại quê nhà * nóng biết tình hình",
    example: "nóng trở lại quê nhà * nóng biết tình hình",
  },
  {
    word: "nóng",
    part_of_speech: "tính từ",
    meaning:
      "(đường dây điện thoại) trực tiếp, có thể liên lạc (để phản ánh, yêu cầu, cần tư vấn, v.v.) vào bất cứ lúc nào: đường dây nóng * gọi theo số điện thoại nóng",
    example: "đường dây nóng * gọi theo số điện thoại nóng",
  },
  {
    word: "nóng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (vay mượn) gấp, cần có ngay và chỉ tạm trong một thời gian ngắn: vay nóng vài hôm * giật nóng ít tiền",
    example: "vay nóng vài hôm * giật nóng ít tiền",
  },
  {
    word: "nóng",
    part_of_speech: "tính từ",
    meaning:
      "(màu) thiên về đỏ hoặc vàng, gợi cảm giác nóng bức: tông màu nóng",
    example: "tông màu nóng",
  },
  {
    word: "nòng",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận của súng, hình ống, nơi viên đạn được phóng ra: nòng pháo * súng hai nòng * đạn đã lên nòng",
    example: "nòng pháo * súng hai nòng * đạn đã lên nòng",
  },
  {
    word: "nóng bỏng",
    part_of_speech: "tính từ",
    meaning:
      "nóng đến mức tưởng như có thể làm bỏng, làm rộp da: bãi cát nóng bỏng giữa trưa hè * giọt nước mắt nóng bỏng (b)",
    example: "bãi cát nóng bỏng giữa trưa hè * giọt nước mắt nóng bỏng (b)",
  },
  {
    word: "nóng bỏng",
    part_of_speech: "tính từ",
    meaning: "có tính chất thời sự và cấp thiết: vấn đề nóng bỏng của xã hội",
    example: "vấn đề nóng bỏng của xã hội",
  },
  {
    word: "nóng ăn",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nóng vội, muốn được hưởng kết quả ngay: nóng ăn nên dễ hỏng việc",
    example: "nóng ăn nên dễ hỏng việc",
  },
  {
    word: "nóng bức",
    part_of_speech: "tính từ",
    meaning:
      "nóng ngột ngạt, gây khó chịu: trưa hè nóng bức * trời nóng bức, ngột ngạt",
    example: "trưa hè nóng bức * trời nóng bức, ngột ngạt",
  },
  {
    word: "nòng cột",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như nòng cốt: giữ vai trò nòng cột",
    example: "giữ vai trò nòng cột",
  },
  {
    word: "nóng giận",
    part_of_speech: "",
    meaning: "nổi nóng vì tức giận: nguôi cơn nóng giận",
    example: "nguôi cơn nóng giận",
  },
  {
    word: "nóng chảy",
    part_of_speech: "động từ",
    meaning:
      "(vật chất) chuyển từ trạng thái rắn sang trạng thái lỏng do nhận nhiệt: kim loại nóng chảy * nhiệt độ nóng chảy",
    example: "kim loại nóng chảy * nhiệt độ nóng chảy",
  },
  {
    word: "nóng hổi",
    part_of_speech: "tính từ",
    meaning: "còn nóng nguyên: cơm canh nóng hổi * giọt nước mắt nóng hổi",
    example: "cơm canh nóng hổi * giọt nước mắt nóng hổi",
  },
  {
    word: "nóng hổi",
    part_of_speech: "tính từ",
    meaning:
      "còn nguyên tính chất thời sự mới mẻ: tin nóng hổi * vấn đề thời sự nóng hổi",
    example: "tin nóng hổi * vấn đề thời sự nóng hổi",
  },
  {
    word: "nóng lòng",
    part_of_speech: "tính từ",
    meaning:
      "có tâm trạng thôi thúc muốn được làm ngay việc gì vì không thể chờ đợi lâu hơn được nữa: nóng lòng chờ đợi",
    example: "nóng lòng chờ đợi",
  },
  {
    word: "nóng gáy",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) nổi nóng trước sự việc chướng tai gai mắt hoặc vì bị đụng chạm tới quyền lợi, danh dự bản thân: chưa nghe hết câu đã nóng gáy lên",
    example: "chưa nghe hết câu đã nóng gáy lên",
  },
  {
    word: "nòng cốt",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận chủ yếu, làm trụ cột, làm chỗ dựa cho những bộ phận khác xung quanh nó: lực lượng nòng cốt * vai trò nòng cốt * nòng cốt câu",
    example: "lực lượng nòng cốt * vai trò nòng cốt * nòng cốt câu",
  },
  {
    word: "nóng mặt",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) nổi nóng vì bị đụng chạm đến danh dự cá nhân: nghe câu nói xấc xược mà nóng mặt",
    example: "nghe câu nói xấc xược mà nóng mặt",
  },
  {
    word: "nóng hôi hổi",
    part_of_speech: "tính từ",
    meaning: "như nóng hổi (nhưng ý mức độ cao hơn): củ khoai còn nóng hôi hổi",
    example: "củ khoai còn nóng hôi hổi",
  },
  {
    word: "nóng như trương phi",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) rất nóng tính, dễ dàng nổi nóng với những biểu hiện ghê gớm (như nhân vật Trương Phi trong Tam Quốc diễn nghĩa của Trung Quốc): tính nóng như Trương Phi",
    example: "tính nóng như Trương Phi",
  },
  {
    word: "nóng mắt",
    part_of_speech: "",
    meaning: "(khẩu ngữ) nổi nóng vì thấy chướng mắt: trông mà nóng mắt",
    example: "trông mà nóng mắt",
  },
  {
    word: "nóng nảy",
    part_of_speech: "tính từ",
    meaning:
      "khó kiềm chế, dễ nổi nóng, dễ có phản ứng mạnh mẽ, thiếu bình tĩnh trong quan hệ đối xử: tính khí nóng nảy * nóng nảy nên dễ hỏng việc",
    example: "tính khí nóng nảy * nóng nảy nên dễ hỏng việc",
  },
  {
    word: "nóng ruột",
    part_of_speech: "tính từ",
    meaning: "nóng lòng, sốt ruột: đợi lâu nên có vẻ nóng ruột",
    example: "đợi lâu nên có vẻ nóng ruột",
  },
  {
    word: "nóng sốt",
    part_of_speech: "tính từ",
    meaning: "nóng do mới được đun nấu: cơm canh còn nóng sốt",
    example: "cơm canh còn nóng sốt",
  },
  {
    word: "nóng nực",
    part_of_speech: "tính từ",
    meaning: "như nóng bức: ngày hè nóng nực * thời tiết nóng nực",
    example: "ngày hè nóng nực * thời tiết nóng nực",
  },
  {
    word: "nóng tiết",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tức giận cao độ, dẫn đến có thái độ phản ứng gay gắt, thiếu suy nghĩ: nóng tiết, chửi vung lên",
    example: "nóng tiết, chửi vung lên",
  },
  {
    word: "nong nóng",
    part_of_speech: "tính từ",
    meaning: "hơi nóng: trán hơi nong nóng",
    example: "trán hơi nong nóng",
  },
  {
    word: "nóng vội",
    part_of_speech: "tính từ",
    meaning:
      "(tiêu cực) muốn cho xong ngay, được ngay, thiếu kiên nhẫn, không chịu được sự chờ đợi: tư tưởng nóng vội * cứ bình tĩnh, không việc gì phải nóng vội",
    example: "tư tưởng nóng vội * cứ bình tĩnh, không việc gì phải nóng vội",
  },
  {
    word: "nóng rực",
    part_of_speech: "tính từ",
    meaning:
      "rất nóng, có nhiều hơi nóng bừng lên và toả mạnh ra xung quanh: lò than nóng rực * người nóng rực",
    example: "lò than nóng rực * người nóng rực",
  },
  {
    word: "nổ",
    part_of_speech: "động từ",
    meaning:
      "bật vỡ tung ra đột ngột và mạnh, nghe thành tiếng động lớn và ngắn: pháo nổ đùng đoàng * xe bị nổ lốp * lựu đạn câm, không nổ",
    example: "pháo nổ đùng đoàng * xe bị nổ lốp * lựu đạn câm, không nổ",
  },
  {
    word: "nổ",
    part_of_speech: "động từ",
    meaning:
      "làm cho nổ hoặc cho phát ra tiếng nổ: nổ liền hai phát súng * nổ máy cho xe chạy",
    example: "nổ liền hai phát súng * nổ máy cho xe chạy",
  },
  {
    word: "nổ",
    part_of_speech: "động từ",
    meaning:
      "phát sinh đột ngột với mức độ mạnh: nổ ra cuộc cãi vã * chiến tranh sắp nổ ra * các cuộc khởi nghĩa nổ ra khắp nơi",
    example:
      "nổ ra cuộc cãi vã * chiến tranh sắp nổ ra * các cuộc khởi nghĩa nổ ra khắp nơi",
  },
  {
    word: "nô",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) chơi đùa: bọn trẻ đang nô ở ngoài sân",
    example: "bọn trẻ đang nô ở ngoài sân",
  },
  {
    word: "nô bộc",
    part_of_speech: "danh từ",
    meaning: "(cũ) đầy tớ trong xã hội thời xưa: thân phận nô bộc",
    example: "thân phận nô bộc",
  },
  {
    word: "nổ cướp",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) nổ sớm khi chưa định cho nổ: quả mìn nổ cướp",
    example: "quả mìn nổ cướp",
  },
  {
    word: "nô dịch",
    part_of_speech: "động từ",
    meaning:
      "làm cho mất hết quyền tự do, trở thành hoàn toàn phụ thuộc vào mình: một dân tộc bị nô dịch * chính sách nô dịch của thực dân",
    example: "một dân tộc bị nô dịch * chính sách nô dịch của thực dân",
  },
  {
    word: "nô dịch",
    part_of_speech: "tính từ",
    meaning:
      "mang tính chất nô lệ, phụ thuộc vào nước ngoài: nền văn hoá nô dịch",
    example: "nền văn hoá nô dịch",
  },
  {
    word: "nộ khí",
    part_of_speech: "danh từ",
    meaning: "khí sắc giận dữ: mặt đầy nộ khí",
    example: "mặt đầy nộ khí",
  },
  {
    word: "nô đùa",
    part_of_speech: "động từ",
    meaning: "chơi đùa một cách ồn ào, vui vẻ: bọn trẻ nô đùa ngoài sân",
    example: "bọn trẻ nô đùa ngoài sân",
  },
  {
    word: "nộ khí xung thiên",
    part_of_speech: "",
    meaning:
      "nổi cơn giận ghê gớm (tựa như khí giận bốc lên tận trời; thường nói về đàn ông): chưa nghe hết chuyện đã nộ khí xung thiên",
    example: "chưa nghe hết chuyện đã nộ khí xung thiên",
  },
  {
    word: "nỗ lực",
    part_of_speech: "động từ",
    meaning:
      "đem hết công sức ra để làm việc gì: nỗ lực học hành * nỗ lực thi đua sản xuất",
    example: "nỗ lực học hành * nỗ lực thi đua sản xuất",
  },
  {
    word: "nỗ lực",
    part_of_speech: "danh từ",
    meaning:
      "sự nỗ lực: một nỗ lực phi thường * làm việc bằng tất cả nỗ lực của mình",
    example: "một nỗ lực phi thường * làm việc bằng tất cả nỗ lực của mình",
  },
  {
    word: "nổ mìn",
    part_of_speech: "động từ",
    meaning:
      "làm nổ khối thuốc nổ đã được nạp vào những khoảng trống, để công phá: nổ mìn phá đá",
    example: "nổ mìn phá đá",
  },
  {
    word: "nô lệ",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người lao động hoàn toàn không có tư liệu sản xuất, bị tước hết quyền làm người, biến thành vật sở hữu của chủ nô (trong chế độ chiếm hữu nô lệ): mua bán nô lệ",
    example: "mua bán nô lệ",
  },
  {
    word: "nô lệ",
    part_of_speech: "danh từ",
    meaning:
      "người bị tước đoạt hết mọi quyền tự do, sống dưới một ách áp bức: không chịu cúi đầu làm nô lệ cho thực dân",
    example: "không chịu cúi đầu làm nô lệ cho thực dân",
  },
  {
    word: "nô lệ",
    part_of_speech: "danh từ",
    meaning:
      "người bị phụ thuộc hoàn toàn vào một thế lực nào đó: trở thành nô lệ của đồng tiền",
    example: "trở thành nô lệ của đồng tiền",
  },
  {
    word: "nô lệ",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) phụ thuộc hoàn toàn vào: sống nô lệ vào đồng tiền",
    example: "sống nô lệ vào đồng tiền",
  },
  {
    word: "nổ súng",
    part_of_speech: "động từ",
    meaning:
      "bắn (thường nói về sự bắt đầu, mở đầu cuộc chiến): được lệnh nổ súng * giờ nổ súng đã đến",
    example: "được lệnh nổ súng * giờ nổ súng đã đến",
  },
  {
    word: "nốc",
    part_of_speech: "động từ",
    meaning:
      "(Thông tục) uống nhiều và hết ngay trong thời gian ngắn, một cách thô tục: nốc một hơi hết nửa chai bia",
    example: "nốc một hơi hết nửa chai bia",
  },
  {
    word: "nô nức",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra hăm hở, phấn khởi cùng đua nhau làm một việc gì: nô nức đi xem hội * học sinh nô nức đến trường",
    example: "nô nức đi xem hội * học sinh nô nức đến trường",
  },
  {
    word: "nôi",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng để cho trẻ nhỏ nằm, thường được đan bằng mây, có thể đưa qua đưa lại được: đưa nôi",
    example: "đưa nôi",
  },
  {
    word: "nôi",
    part_of_speech: "danh từ",
    meaning:
      "nơi phát sinh ra (cái có ý nghĩa trọng đại trong lịch sử dân tộc, lịch sử loài người): cái nôi của nền văn minh lúa nước * Việt Bắc là cái nôi của cách mạng nước ta",
    example:
      "cái nôi của nền văn minh lúa nước * Việt Bắc là cái nôi của cách mạng nước ta",
  },
  {
    word: "nốc ao",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) đo ván: hạ nốc ao",
    example: "hạ nốc ao",
  },
  {
    word: "nỗi",
    part_of_speech: "danh từ",
    meaning:
      "sự tình, sự thể xảy ra, thường là không hay và có tác động đến tình cảm con người: cứ làm như vậy thì đâu đến nỗi! * sung sướng nỗi gì!",
    example: "cứ làm như vậy thì đâu đến nỗi! * sung sướng nỗi gì!",
  },
  {
    word: "nỗi",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng tâm trạng, trạng thái tình cảm cụ thể (thường vào loại không được như ý muốn) mà con người trải qua: nỗi nhớ * niềm vui nỗi buồn * chịu nhiều nỗi xót xa",
    example: "nỗi nhớ * niềm vui nỗi buồn * chịu nhiều nỗi xót xa",
  },
  {
    word: "nồi",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng bằng đất nung hay kim loại, lòng sâu, để đun nấu thức ăn: nồi đất * nấu một nồi chè * ăn trông nồi ngồi trông hướng (tng)",
    example: "nồi đất * nấu một nồi chè * ăn trông nồi ngồi trông hướng (tng)",
  },
  {
    word: "nồi",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận giống hình cái nồi, để chứa bi trong ổ trục: lắp nồi vào ổ trục xe đạp",
    example: "lắp nồi vào ổ trục xe đạp",
  },
  {
    word: "nồi",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị dân gian, thường dùng thời trước để đong chất hạt rời, thường bằng khoảng 20 đấu, tức 20 lít: vay mấy nồi thóc",
    example: "vay mấy nồi thóc",
  },
  {
    word: "nối",
    part_of_speech: "động từ",
    meaning:
      "làm cho (cái bị đứt đoạn hoặc những phần đang tách rời nhau) liền lại với nhau: nối dây điện bị đứt * nối lại tình xưa",
    example: "nối dây điện bị đứt * nối lại tình xưa",
  },
  {
    word: "nối",
    part_of_speech: "động từ",
    meaning:
      "làm cho tiếp liền vào nhau, tạo ra một sự liên tục: nối lời bạn * viết nối thêm một đoạn * nối bước cha ông",
    example: "nối lời bạn * viết nối thêm một đoạn * nối bước cha ông",
  },
  {
    word: "nội bộ",
    part_of_speech: "danh từ",
    meaning:
      "tình hình bên trong của tổ chức: chia rẽ nội bộ * tài liệu lưu hành nội bộ",
    example: "chia rẽ nội bộ * tài liệu lưu hành nội bộ",
  },
  {
    word: "nội",
    part_of_speech: "tính từ",
    meaning:
      "thuộc trong nước, do trong nước sản xuất; phân biệt với ngoại: hàng nội * săm lốp nội * hàng ngoại giá nội (hàng tốt mà giá rẻ)",
    example: "hàng nội * săm lốp nội * hàng ngoại giá nội (hàng tốt mà giá rẻ)",
  },
  {
    word: "nội",
    part_of_speech: "tính từ",
    meaning:
      "hoặc d thuộc gia đình, họ hàng của cha hoặc của chồng; phân biệt với ngoại: họ nội * anh em đằng nội * bà nội * quê nội",
    example: "họ nội * anh em đằng nội * bà nội * quê nội",
  },
  {
    word: "nội",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ, khẩu ngữ) ông nội hay bà nội (gọi tắt một cách thân mật): con đi nghe nội!",
    example: "con đi nghe nội!",
  },
  {
    word: "nội",
    part_of_speech: "danh từ",
    meaning: "cung vua: vào chầu trong nội",
    example: "vào chầu trong nội",
  },
  {
    word: "nội",
    part_of_speech: "danh từ",
    meaning:
      "phạm vi về thời gian, không gian, được hạn định nào đó: nội đêm nay phải đi * nội ngày nay là xong việc * tìm nội trong nhà này",
    example:
      "nội đêm nay phải đi * nội ngày nay là xong việc * tìm nội trong nhà này",
  },
  {
    word: "nội",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) khoa nội (nói tắt): phòng khám nội * bác sĩ nội",
    example: "phòng khám nội * bác sĩ nội",
  },
  {
    word: "nổi",
    part_of_speech: "động từ",
    meaning:
      "ở trên bề mặt của một chất lỏng: bè nứa nổi lềnh bềnh * tảng băng nửa chìm nửa nổi * đàn cá ăn nổi",
    example:
      "bè nứa nổi lềnh bềnh * tảng băng nửa chìm nửa nổi * đàn cá ăn nổi",
  },
  {
    word: "nổi",
    part_of_speech: "động từ",
    meaning:
      "chuyển từ phía dưới lên phía bề mặt của một chất lỏng: tàu ngầm từ từ nổi lên * rùa nổi ở Hồ Gươm",
    example: "tàu ngầm từ từ nổi lên * rùa nổi ở Hồ Gươm",
  },
  {
    word: "nổi",
    part_of_speech: "động từ",
    meaning:
      "nhô lên, hiện lên trên bề mặt, dễ nhận thấy: sợ nổi gai ốc * rễ cây nổi lên trên mặt đất * mặt nổi mụn",
    example: "sợ nổi gai ốc * rễ cây nổi lên trên mặt đất * mặt nổi mụn",
  },
  {
    word: "nổi",
    part_of_speech: "động từ",
    meaning:
      "(nước) dâng lên cao do mưa lũ: mùa nước nổi * ruộng nổi nước trắng xoá",
    example: "mùa nước nổi * ruộng nổi nước trắng xoá",
  },
  {
    word: "nổi",
    part_of_speech: "động từ",
    meaning:
      "phát ra hoặc làm cho phát ra (âm thanh, ánh sáng) ít nhiều mạnh mẽ: tiếng trống nổi lên rộn rã * trọng tài nổi còi cho bắt đầu trận đấu * nổi lửa nấu cơm",
    example:
      "tiếng trống nổi lên rộn rã * trọng tài nổi còi cho bắt đầu trận đấu * nổi lửa nấu cơm",
  },
  {
    word: "nổi",
    part_of_speech: "động từ",
    meaning:
      "phát sinh, nảy sinh đột ngột, thường thành đợt, thành cơn và có tác dụng đáng kể: trời nổi cơn dông * mặt biển nổi sóng * nổi cáu * nổi cơn ghen",
    example: "trời nổi cơn dông * mặt biển nổi sóng * nổi cáu * nổi cơn ghen",
  },
  {
    word: "nổi",
    part_of_speech: "động từ",
    meaning:
      "vùng lên thành lực lượng đông đảo, gây ra biến động: các cuộc khởi nghĩa nổi lên khắp nơi",
    example: "các cuộc khởi nghĩa nổi lên khắp nơi",
  },
  {
    word: "nổi",
    part_of_speech: "động từ",
    meaning:
      "hiện ra rõ rệt, khiến rất dễ nhận thấy giữa những cái khác: ca sĩ mới nổi * chiếc áo màu đỏ trông rất nổi * từ kết quả này thấy nổi lên một số vấn đề",
    example:
      "ca sĩ mới nổi * chiếc áo màu đỏ trông rất nổi * từ kết quả này thấy nổi lên một số vấn đề",
  },
  {
    word: "nổi",
    part_of_speech: "động từ",
    meaning:
      "(âm thanh, hình ảnh) sống động, tự nhiên, giống như thực: âm thanh nổi * phim nổi",
    example: "âm thanh nổi * phim nổi",
  },
  {
    word: "nổi",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị khả năng thực hiện của một việc khó khăn, nặng nề: nặng quá không vác nổi * không thể tưởng tượng nổi * không nén nổi xúc động",
    example:
      "nặng quá không vác nổi * không thể tưởng tượng nổi * không nén nổi xúc động",
  },
  {
    word: "nổi bật",
    part_of_speech: "tính từ",
    meaning:
      "nổi lên rất rõ giữa những cái khác, khiến dễ dàng nhận thấy ngay: thành tích nổi bật * vấn đề nổi bật trong tuần",
    example: "thành tích nổi bật * vấn đề nổi bật trong tuần",
  },
  {
    word: "nội các",
    part_of_speech: "danh từ",
    meaning:
      "hội đồng chính phủ, theo cách gọi ở một số nước: nội các chính phủ * cải tổ nội các",
    example: "nội các chính phủ * cải tổ nội các",
  },
  {
    word: "nội chiến",
    part_of_speech: "danh từ",
    meaning:
      "sự xung đột vũ trang giữa các miền hoặc các lực lượng xã hội bên trong một nước: cuộc nội chiến",
    example: "cuộc nội chiến",
  },
  {
    word: "nội biến",
    part_of_speech: "danh từ",
    meaning:
      "tình hình có biến bên trong một nước, một tổ chức: trong nước có nội biến * dẹp yên nội biến",
    example: "trong nước có nội biến * dẹp yên nội biến",
  },
  {
    word: "nội chính",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) việc chính trị trong một nước (nói khái quát): nội chính chưa an * việc nội chính của một nước",
    example: "nội chính chưa an * việc nội chính của một nước",
  },
  {
    word: "nội chính",
    part_of_speech: "danh từ",
    meaning:
      "lĩnh vực hoạt động của nhà nước, bao gồm việc quản lí trật tự trị an, quân sự, kinh tế, văn hoá: cơ quan nội chính",
    example: "cơ quan nội chính",
  },
  {
    word: "nổi cáu",
    part_of_speech: "động từ",
    meaning: "phát cáu lên vì tức giận: vô cớ nổi cáu",
    example: "vô cớ nổi cáu",
  },
  {
    word: "nội công",
    part_of_speech: "danh từ",
    meaning:
      "thuật rèn luyện khả năng chịu đựng của các cơ quan bên trong thân thể; phân biệt với ngoại công: nội công thâm hậu * vận nội công",
    example: "nội công thâm hậu * vận nội công",
  },
  {
    word: "nồi chõ",
    part_of_speech: "danh từ",
    meaning:
      "nồi dùng để đồ xôi, gồm hai tầng, tầng dưới đựng nước, tầng trên đựng gạo có lỗ nhỏ ở đáy để hơi nước bốc lên làm chín gạo: bắc chõ thổi xôi",
    example: "bắc chõ thổi xôi",
  },
  {
    word: "nồi chõ",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) hướng thẳng hoặc tập trung âm thanh về phía nào đó: chõ loa vào trong xóm * ngồi trong buồng nói chõ ra",
    example: "chõ loa vào trong xóm * ngồi trong buồng nói chõ ra",
  },
  {
    word: "nồi chõ",
    part_of_speech: "động từ",
    meaning:
      "(Thông tục) nói xen vào việc không dính líu đến mình: nghe ngứa tai, nói chõ vào một câu",
    example: "nghe ngứa tai, nói chõ vào một câu",
  },
  {
    word: "nổi cộm",
    part_of_speech: "",
    meaning:
      "nổi lên rõ rệt và gây khó khăn hoặc có ảnh hướng xấu: vấn đề xã hội nổi cộm * giải quyết những vụ tiêu cực nổi cộm",
    example: "vấn đề xã hội nổi cộm * giải quyết những vụ tiêu cực nổi cộm",
  },
  {
    word: "nội công ngoại kích",
    part_of_speech: "",
    meaning:
      "có sự phối hợp đồng bộ, trong đánh ra, ngoài đánh vào: dùng kế nội công ngoại kích",
    example: "dùng kế nội công ngoại kích",
  },
  {
    word: "nổi danh",
    part_of_speech: "tính từ",
    meaning:
      'có danh tiếng, được rất nhiều người biết đến: ca sĩ nổi danh * "Nổi danh tài sắc một thì, Xôn xao ngoài cửa hiếm gì yến anh." (TKiều)',
    example:
      'ca sĩ nổi danh * "Nổi danh tài sắc một thì, Xôn xao ngoài cửa hiếm gì yến anh." (TKiều)',
  },
  {
    word: "nội dung",
    part_of_speech: "danh từ",
    meaning:
      "mặt bên trong của sự vật, cái được hình thức chứa đựng hoặc biểu hiện: nội dung tác phẩm * có sự hài hoà giữa nội dung và hình thức",
    example: "nội dung tác phẩm * có sự hài hoà giữa nội dung và hình thức",
  },
  {
    word: "nổi dậy",
    part_of_speech: "động từ",
    meaning:
      "nổi lên thành lực lượng đông đảo chống lại trật tự xã hội: cuộc nổi dậy của nông dân",
    example: "cuộc nổi dậy của nông dân",
  },
  {
    word: "nối dõi",
    part_of_speech: "động từ",
    meaning:
      "tiếp tục dòng dõi của ông cha: nối dõi tông đường * có con trai nối dõi",
    example: "nối dõi tông đường * có con trai nối dõi",
  },
  {
    word: "nổi doá",
    part_of_speech: "động từ",
    meaning: "(phương ngữ, khẩu ngữ) như nổi đoá: động một tí là nổi doá lên",
    example: "động một tí là nổi doá lên",
  },
  {
    word: "nội địa",
    part_of_speech: "danh từ",
    meaning: "phần đất trong lục địa ở xa biển: tiến sâu vào nội địa",
    example: "tiến sâu vào nội địa",
  },
  {
    word: "nội địa",
    part_of_speech: "tính từ",
    meaning:
      "ở trong nước, được làm ra để tiêu thụ trong nước, không phải hàng nhập khẩu và cũng không phải để xuất khẩu: ti vi nội địa * nước hoa nội địa * hàng nội địa",
    example: "ti vi nội địa * nước hoa nội địa * hàng nội địa",
  },
  {
    word: "nội đồng",
    part_of_speech: "danh từ",
    meaning: "khu vực bên trong cánh đồng: hệ thống kênh mương nội đồng",
    example: "hệ thống kênh mương nội đồng",
  },
  {
    word: "nổi đình nổi đám",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) làm cho nổi trội hẳn lên, và được nhiều người chú ý: đám cưới ấy cũng nổi đình nổi đám lắm",
    example: "đám cưới ấy cũng nổi đình nổi đám lắm",
  },
  {
    word: "nội động",
    part_of_speech: "tính từ",
    meaning:
      "(động từ) không đòi hỏi phải có bổ ngữ đối tượng trực tiếp để cho nghĩa được đầy đủ; phân biệt với ngoại động: ,  * ,  *  là những động từ nội động",
    example: ",  * ,  *  là những động từ nội động",
  },
  {
    word: "nội đô",
    part_of_speech: "danh từ",
    meaning:
      "nội thành (của thủ đô hoặc thành phố lớn): sống ở vùng nội đô * mở rộng giao thông vùng nội đô",
    example: "sống ở vùng nội đô * mở rộng giao thông vùng nội đô",
  },
  {
    word: "nối đuôi",
    part_of_speech: "động từ",
    meaning:
      "tiếp liền nhau, cái nọ theo sau cái kia: xe cộ nối đuôi nhau qua cầu * dòng người nối đuôi nhau vào lăng viếng Bác",
    example:
      "xe cộ nối đuôi nhau qua cầu * dòng người nối đuôi nhau vào lăng viếng Bác",
  },
  {
    word: "nối ghép",
    part_of_speech: "động từ",
    meaning: "như ghép nối: nối ghép mạng điện * thiết bị nối ghép",
    example: "nối ghép mạng điện * thiết bị nối ghép",
  },
  {
    word: "nổi đoá",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ, khẩu ngữ) nổi cáu, nổi giận lên một cách bất ngờ: chưa nghe hết câu đã nổi đoá lên",
    example: "chưa nghe hết câu đã nổi đoá lên",
  },
  {
    word: "nổi giận",
    part_of_speech: "động từ",
    meaning:
      'cảm thấy rất giận và có những phản ứng mạnh mẽ, không kìm lại được: "Tiểu thư nổi giận đùng đùng, Gớm thay thêu dệt, ra lòng trêu ngươi!" (TKiều)',
    example:
      'Tiểu thư nổi giận đùng đùng, Gớm thay thêu dệt, ra lòng trêu ngươi!" (TKiều)',
  },
  {
    word: "nội gián",
    part_of_speech: "danh từ",
    meaning:
      "người ở trong một tổ chức làm gián điệp cho đối phương, hoặc kẻ địch được cài vào trong nội bộ để hoạt động phá hoại: trong tổ chức có nội gián * cài người làm nội gián",
    example: "trong tổ chức có nội gián * cài người làm nội gián",
  },
  {
    word: "nội hạt",
    part_of_speech: "danh từ",
    meaning:
      "khu vực bên trong một tỉnh hoặc một nước: mạng viễn thông nội hạt * cước cuộc gọi nội hạt * di dân nội hạt",
    example: "mạng viễn thông nội hạt * cước cuộc gọi nội hạt * di dân nội hạt",
  },
  {
    word: "nối gót",
    part_of_speech: "động từ",
    meaning: "đi tiếp liền sau người đi trước: từng đoàn người nối gót nhau đi",
    example: "từng đoàn người nối gót nhau đi",
  },
  {
    word: "nối gót",
    part_of_speech: "động từ",
    meaning:
      "(văn chương) tiếp liền theo sau để tiếp tục sự nghiệp của lớp người trước: nối gót cha anh",
    example: "nối gót cha anh",
  },
  {
    word: "nội hoá",
    part_of_speech: "động từ",
    meaning: "nội địa hoá (nói tắt): nội hoá các chi tiết xe máy",
    example: "nội hoá các chi tiết xe máy",
  },
  {
    word: "nội hàm",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp tất cả các thuộc tính chung của các đối tượng được phản ánh trong một khái niệm; phân biệt với ngoại diện: nội hàm khái niệm",
    example: "nội hàm khái niệm",
  },
  {
    word: "nối kết",
    part_of_speech: "động từ",
    meaning:
      "nối liền lại, làm cho liên kết, gắn bó với nhau: nối kết các bộ phận lại với nhau * đứa con là sợi dây nối kết giữa hai người",
    example:
      "nối kết các bộ phận lại với nhau * đứa con là sợi dây nối kết giữa hai người",
  },
  {
    word: "nội khoá",
    part_of_speech: "danh từ",
    meaning:
      "môn học hoặc hoạt động giáo dục trong chương trình chính thức; phân biệt với ngoại khoá: giờ nội khoá",
    example: "giờ nội khoá",
  },
  {
    word: "nỗi lòng",
    part_of_speech: "danh từ",
    meaning:
      'tâm tư, tình cảm sâu kín trong lòng: bày tỏ nỗi lòng * "Sinh thì gan héo, ruột đầy, Nỗi lòng, càng nghĩ càng cay đắng lòng." (TKiều)',
    example:
      'bày tỏ nỗi lòng * "Sinh thì gan héo, ruột đầy, Nỗi lòng, càng nghĩ càng cay đắng lòng." (TKiều)',
  },
  {
    word: "nổi loạn",
    part_of_speech: "động từ",
    meaning:
      "nổi lên làm loạn: kiêu binh nổi loạn * đập tan âm mưu nổi loạn * cuộc nổi loạn",
    example: "kiêu binh nổi loạn * đập tan âm mưu nổi loạn * cuộc nổi loạn",
  },
  {
    word: "nối liền",
    part_of_speech: "động từ",
    meaning:
      "nối cho liền lại, cho liên tục, không còn cách biệt: Nam Bắc nối liền một dải",
    example: "Nam Bắc nối liền một dải",
  },
  {
    word: "nối nghiệp",
    part_of_speech: "động từ",
    meaning:
      "tiếp tục nghề nghiệp hoặc sự nghiệp của người trước: nối nghiệp ông cha * có con nối nghiệp",
    example: "nối nghiệp ông cha * có con nối nghiệp",
  },
  {
    word: "nối mạng",
    part_of_speech: "động từ",
    meaning:
      "nối kết máy tính với hệ thống mạng máy tính, hoặc nối kết các máy tính với nhau thành một hệ thống mạng, để có thể trao đổi và khai thác các chương trình dữ liệu: các máy tính trong phòng được nối mạng với nhau * nối mạng Internet",
    example:
      "các máy tính trong phòng được nối mạng với nhau * nối mạng Internet",
  },
  {
    word: "nội nhật",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) nội trong thời gian một ngày: nội nhật hôm nay phải xong việc",
    example: "nội nhật hôm nay phải xong việc",
  },
  {
    word: "nỗi niềm",
    part_of_speech: "danh từ",
    meaning:
      'tâm tư tình cảm riêng: bày tỏ nỗi niềm riêng * "Chung quanh lặng ngắt như tờ, Nỗi niềm tâm sự bây giờ hỏi ai?" (TKiều)',
    example:
      'bày tỏ nỗi niềm riêng * "Chung quanh lặng ngắt như tờ, Nỗi niềm tâm sự bây giờ hỏi ai?" (TKiều)',
  },
  {
    word: "nội lực",
    part_of_speech: "danh từ",
    meaning:
      "lực sinh ra trong nội bộ đối tượng được xét; phân biệt với ngoại lực: phát huy nội lực * một con người có nội lực phi thường",
    example: "phát huy nội lực * một con người có nội lực phi thường",
  },
  {
    word: "nồi niêu",
    part_of_speech: "danh từ",
    meaning:
      "nồi dùng để nấu ăn (nói khái quát): nồi niêu, bát đũa vứt bừa trong bếp",
    example: "nồi niêu, bát đũa vứt bừa trong bếp",
  },
  {
    word: "nội san",
    part_of_speech: "danh từ",
    meaning: "tập san chỉ để lưu hành trong nội bộ: tờ nội san kinh tế",
    example: "tờ nội san kinh tế",
  },
  {
    word: "nội quy",
    part_of_speech: "danh từ",
    meaning:
      "những điều quy định để bảo đảm trật tự và kỉ luật trong một tập thể, một cơ quan (nói tổng quát): chấp hành nội quy của nhà trường * vi phạm nội quy",
    example: "chấp hành nội quy của nhà trường * vi phạm nội quy",
  },
  {
    word: "nội qui",
    part_of_speech: "danh từ",
    meaning:
      "những điều quy định để bảo đảm trật tự và kỉ luật trong một tập thể, một cơ quan (nói tổng quát): chấp hành nội quy của nhà trường * vi phạm nội quy",
    example: "chấp hành nội quy của nhà trường * vi phạm nội quy",
  },
  {
    word: "nội sinh",
    part_of_speech: "tính từ",
    meaning:
      "được sinh ra từ bên trong bản thân sự vật, đối tượng được nói đến; phân biệt với ngoại sinh: năng lực nội sinh * yếu tố nội sinh",
    example: "năng lực nội sinh * yếu tố nội sinh",
  },
  {
    word: "nội ô",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) nội thành; phân biệt với ngoại ô: xe chạy theo hướng từ nội ô ra ngoại thành",
    example: "xe chạy theo hướng từ nội ô ra ngoại thành",
  },
  {
    word: "nổi nóng",
    part_of_speech: "động từ",
    meaning:
      "tức giận không kìm nén được, có thái độ phản ứng gay gắt, thiếu suy nghĩ: hơi một tí là nổi nóng",
    example: "hơi một tí là nổi nóng",
  },
  {
    word: "nội soi",
    part_of_speech: "danh từ",
    meaning:
      "phương pháp đưa một ống nhỏ vào bên trong cơ thể, qua đó có thể quan sát hay chụp ảnh cơ quan bệnh lí bằng một máy ảnh đặt ở đầu ống phía ngoài, cũng có thể cắt một mảnh nhỏ để chẩn đoán tế bào hay thực hiện phẫu thuật qua ống này: mổ nội soi * chẩn đoán bằng phương pháp nội soi",
    example: "mổ nội soi * chẩn đoán bằng phương pháp nội soi",
  },
  {
    word: "nội tại",
    part_of_speech: "tính từ",
    meaning:
      "có ở ngay bên trong bản thân sự vật: nguyên nhân nội tại * mâu thuẫn nội tại",
    example: "nguyên nhân nội tại * mâu thuẫn nội tại",
  },
  {
    word: "nổi tam bành",
    part_of_speech: "",
    meaning:
      '(khẩu ngữ) nổi cơn giận ghê gớm (thường nói về đàn bà): "Mụ nghe nàng nói hay tình, Bấy giờ mới nổi tam bành mụ lên." (TKiều)',
    example:
      'Mụ nghe nàng nói hay tình, Bấy giờ mới nổi tam bành mụ lên." (TKiều)',
  },
  {
    word: "nội tâm",
    part_of_speech: "danh từ",
    meaning:
      "tâm tư, tình cảm riêng của mỗi người (nói tổng quát): nội tâm của nhân vật * vẻ đẹp nội tâm",
    example: "nội tâm của nhân vật * vẻ đẹp nội tâm",
  },
  {
    word: "nội thành",
    part_of_speech: "danh từ",
    meaning:
      "khu vực bên trong thành phố; phân biệt với ngoại thành: các quận nội thành * sống trong nội thành",
    example: "các quận nội thành * sống trong nội thành",
  },
  {
    word: "nội tệ",
    part_of_speech: "danh từ",
    meaning:
      "tiền của một nước, trong quan hệ với người nước ấy; phân biệt với ngoại tệ: đồng nội tệ * thanh toán bằng nội tệ",
    example: "đồng nội tệ * thanh toán bằng nội tệ",
  },
  {
    word: "nội thất",
    part_of_speech: "danh từ",
    meaning:
      "đồ đạc, các loại tiện nghi và cách bài trí, làm thành phía bên trong của một ngôi nhà (nói tổng quát); phân biệt với ngoại thất: mua sắm nội thất * trang trí nội thất",
    example: "mua sắm nội thất * trang trí nội thất",
  },
  {
    word: "nội tạng",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) các cơ quan nằm bên trong cơ thể như tim, phổi, gan, thận, v.v.: tổn thương nội tạng",
    example: "tổn thương nội tạng",
  },
  {
    word: "nội thị",
    part_of_speech: "danh từ",
    meaning:
      "khu vực bên trong thị xã; phân biệt với ngoại thị: giao thông nội thị",
    example: "giao thông nội thị",
  },
  {
    word: "nội thị",
    part_of_speech: "danh từ",
    meaning: "(cũ) hoạn quan hầu trong cung vua: quan nội thị",
    example: "quan nội thị",
  },
  {
    word: "nổi tiếng",
    part_of_speech: "tính từ",
    meaning:
      'có tiếng đồn xa, được rất nhiều người biết đến: một ca sĩ nổi tiếng * "Bạc tình nổi tiếng lầu xanh, Một tay chôn biết mấy cành phù dung!" (TKiều)',
    example:
      'một ca sĩ nổi tiếng * "Bạc tình nổi tiếng lầu xanh, Một tay chôn biết mấy cành phù dung!" (TKiều)',
  },
  {
    word: "nội tiếp",
    part_of_speech: "tính từ",
    meaning:
      "(hình tròn, hình cầu) nằm trong một đa giác hoặc đa diện và tiếp xúc với mọi cạnh hoặc mọi mặt của đa giác hoặc đa diện đó: hình tròn nội tiếp",
    example: "hình tròn nội tiếp",
  },
  {
    word: "nội tiếp",
    part_of_speech: "tính từ",
    meaning:
      "(đa giác, đa diện) có tất cả các đỉnh nằm trên một đường tròn hoặc một mặt cầu: đa giác nội tiếp trong hình cầu",
    example: "đa giác nội tiếp trong hình cầu",
  },
  {
    word: "nối tiếp",
    part_of_speech: "động từ",
    meaning:
      "tiếp theo nhau, không để ngắt quãng: chuyện nọ nối tiếp chuyện kia * nối tiếp sự nghiệp cha ông",
    example: "chuyện nọ nối tiếp chuyện kia * nối tiếp sự nghiệp cha ông",
  },
  {
    word: "nội thuộc",
    part_of_speech: "động từ",
    meaning:
      "lệ thuộc vào một nước lớn (tự coi mình là trung tâm): chiến thắng Bạch Đằng năm 938 đã chấm dứt hơn nghìn năm nội thuộc phương Bắc",
    example:
      "chiến thắng Bạch Đằng năm 938 đã chấm dứt hơn nghìn năm nội thuộc phương Bắc",
  },
  {
    word: "nội thương",
    part_of_speech: "danh từ",
    meaning:
      "việc buôn bán bên trong một nước (nói khái quát); phân biệt với ngoại thương: buôn bán nội thương",
    example: "buôn bán nội thương",
  },
  {
    word: "nội tiết",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) nội tiết tố (nói tắt): rối loạn nội tiết",
    example: "rối loạn nội tiết",
  },
  {
    word: "nội tỉnh",
    part_of_speech: "danh từ",
    meaning:
      "khu vực bên trong tỉnh; phân biệt với ngoại tỉnh: bến xe nội tỉnh * cước điện thoại nội tỉnh",
    example: "bến xe nội tỉnh * cước điện thoại nội tỉnh",
  },
  {
    word: "nội tình",
    part_of_speech: "danh từ",
    meaning:
      "tình hình, tình trạng bên trong (của một nước, một tổ chức, v.v.): nội tình sự việc",
    example: "nội tình sự việc",
  },
  {
    word: "nội tộc",
    part_of_speech: "danh từ",
    meaning:
      "họ nội; phân biệt với ngoại tộc: họ hàng nội tộc * bà con nội tộc",
    example: "họ hàng nội tộc * bà con nội tộc",
  },
  {
    word: "nổi trội",
    part_of_speech: "",
    meaning: "nổi bật, hơn hẳn những cái khác: thành tích nổi trội",
    example: "thành tích nổi trội",
  },
  {
    word: "nội trợ",
    part_of_speech: "động từ",
    meaning:
      "lo liệu mọi việc hằng ngày trong sinh hoạt gia đình như cơm nước, giặt giũ, chăm sóc con cái, v.v. (nói khát quát): lo việc nội trợ trong gia đình * người nội trợ giỏi",
    example: "lo việc nội trợ trong gia đình * người nội trợ giỏi",
  },
  {
    word: "nội trú",
    part_of_speech: "động từ",
    meaning:
      "(học sinh, người bệnh) ăn ở ngay trong trường, trong bệnh viện; phân biệt với ngoại trú: sinh viên nội trú * bệnh nhân nội trú",
    example: "sinh viên nội trú * bệnh nhân nội trú",
  },
  {
    word: "nội ứng",
    part_of_speech: "danh từ",
    meaning:
      "người từ trong hàng ngũ đối phương hoạt động phối hợp với lực lượng bên ngoài để đánh phá: cơ sở nội ứng * làm nội ứng",
    example: "cơ sở nội ứng * làm nội ứng",
  },
  {
    word: "nội vụ",
    part_of_speech: "danh từ",
    meaning:
      "công việc thuộc lĩnh vực chính trị trong một nước: bộ nội vụ * nhân viên nội vụ",
    example: "bộ nội vụ * nhân viên nội vụ",
  },
  {
    word: "nội vụ",
    part_of_speech: "danh từ",
    meaning:
      "cách sắp xếp nơi ăn ở, cách ăn mặc, sắp xếp thì giờ sinh hoạt, v.v. của quân nhân trong doanh trại (nói tổng quát): nội vụ gọn gàng * kiểm tra nội vụ",
    example: "nội vụ gọn gàng * kiểm tra nội vụ",
  },
  {
    word: "nội vụ",
    part_of_speech: "danh từ",
    meaning: "diễn biến bên trong của vụ việc: điều tra để làm rõ nội vụ",
    example: "điều tra để làm rõ nội vụ",
  },
  {
    word: "nôm",
    part_of_speech: "danh từ",
    meaning:
      "tiếng Việt, viết bằng chữ gọi là chữ Nôm; phân biệt với tiếng Hán, viết bằng chữ Nho: truyện nôm khuyết danh * thơ nôm",
    example: "truyện nôm khuyết danh * thơ nôm",
  },
  {
    word: "nội tướng",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, hoặc kng) người vợ (hàm ý là người nắm quyền quản lí trong gia đình): bà nội tướng",
    example: "bà nội tướng",
  },
  {
    word: "nồm",
    part_of_speech: "danh từ",
    meaning:
      'gió nồm (nói tắt): "Mai mưa, trưa nắng, chiều nồm, Trời còn luân chuyển, huống mồm thế gian." (ca dao)',
    example:
      'Mai mưa, trưa nắng, chiều nồm, Trời còn luân chuyển, huống mồm thế gian." (ca dao)',
  },
  {
    word: "nồm",
    part_of_speech: "danh từ",
    meaning:
      "trạng thái thời tiết ấm và ẩm ướt ở miền Bắc Việt Nam vào cuối mùa đông sang đầu mùa xuân: trời nồm",
    example: "trời nồm",
  },
  {
    word: "nội xâm",
    part_of_speech: "danh từ",
    meaning:
      "lực lượng phản động, tiêu cực trong nước đang phá hoại, làm suy yếu đất nước, được coi là nguy hiểm như một thứ giặc: nạn nội xâm * ngăn ngừa hoạ nội xâm",
    example: "nạn nội xâm * ngăn ngừa hoạ nội xâm",
  },
  {
    word: "nôn",
    part_of_speech: "động từ",
    meaning:
      "tống (những gì chứa trong dạ dày) ra ngoài qua đường miệng, do không cầm giữ được: ăn được bao nhiêu nôn ra hết * nôn thốc tháo * bắt nó phải nôn hết tiền ra! (thgt)",
    example:
      "ăn được bao nhiêu nôn ra hết * nôn thốc tháo * bắt nó phải nôn hết tiền ra! (thgt)",
  },
  {
    word: "nôn",
    part_of_speech: "tính từ",
    meaning:
      "(Phương ngữ) khó nhịn được cười khi bị kích thích trên da thịt: nôn quá, không nhịn được cười",
    example: "nôn quá, không nhịn được cười",
  },
  {
    word: "nôn",
    part_of_speech: "tính từ",
    meaning: "(Phương ngữ) nóng lòng, nóng vội: nôn về nhà cho sớm",
    example: "nôn về nhà cho sớm",
  },
  {
    word: "nôm na",
    part_of_speech: "tính từ",
    meaning:
      "(cách nói, cách diễn đạt) mộc mạc, theo cách nói của người dân thường không biết chữ nho: lời lẽ rất nôm na * hiểu một cách nôm na",
    example: "lời lẽ rất nôm na * hiểu một cách nôm na",
  },
  {
    word: "nôn mửa",
    part_of_speech: "động từ",
    meaning: "nôn (nói khái quát): nôn mửa thốc tháo vì say xe",
    example: "nôn mửa thốc tháo vì say xe",
  },
  {
    word: "nộm",
    part_of_speech: "danh từ",
    meaning: "hình nộm (nói tắt): con nộm rơm",
    example: "con nộm rơm",
  },
  {
    word: "nộm",
    part_of_speech: "danh từ",
    meaning:
      "món ăn làm bằng rau hoặc củ, quả thái nhỏ, trộn với dấm, đường, vừng, lạc và các gia vị khác: nộm hoa chuối * nộm ngó sen",
    example: "nộm hoa chuối * nộm ngó sen",
  },
  {
    word: "nôn nao",
    part_of_speech: "động từ",
    meaning:
      "có cảm giác khó chịu trong người, như bị chao đảo, chóng mặt, buồn nôn: nôn nao như người say sóng",
    example: "nôn nao như người say sóng",
  },
  {
    word: "nôn nao",
    part_of_speech: "động từ",
    meaning:
      'ở trạng thái xao động trong tình cảm khi đang mong mỏi hoặc gợi nhớ đến điều gì: lòng nôn nao buồn * "Biết là em quá xa rồi, Cớ chi dạ cứ bồi hồi nôn nao." (TrĐKhoa; 10)',
    example:
      'lòng nôn nao buồn * "Biết là em quá xa rồi, Cớ chi dạ cứ bồi hồi nôn nao." (TrĐKhoa; 10)',
  },
  {
    word: "nồng",
    part_of_speech: "tính từ",
    meaning:
      '(trạng thái thời tiết) nóng ẩm, lặng gió và nhiều mây, gây cảm giác oi bức, ngột ngạt: "Cơn lạnh còn có cơn nồng, Cơn đắp áo ngắn, cơn chung áo dài." (Cdao)',
    example:
      'Cơn lạnh còn có cơn nồng, Cơn đắp áo ngắn, cơn chung áo dài." (Cdao)',
  },
  {
    word: "nồng",
    part_of_speech: "tính từ",
    meaning:
      'có mùi hơi khó ngửi như mùi của vôi tôi (thường do nung nấu, ủ kín quá kĩ): cơm khê nồng * "Tưởng rằng đá nát thì thôi, Ai ngờ đá nát nung vôi lại nồng." (Cdao)',
    example:
      'cơm khê nồng * "Tưởng rằng đá nát thì thôi, Ai ngờ đá nát nung vôi lại nồng." (Cdao)',
  },
  {
    word: "nồng",
    part_of_speech: "tính từ",
    meaning: "có độ nóng, độ đậm đặc ở mức cao: miếng trầu nồng * rượu nồng",
    example: "miếng trầu nồng * rượu nồng",
  },
  {
    word: "nồng",
    part_of_speech: "tính từ",
    meaning:
      '(Văn chương) có tình cảm thắm thiết, sâu đậm: "Lửa tâm càng dập, càng nồng, Trách người đen bạc, ra lòng trăng hoa." (TKiều)',
    example:
      'Lửa tâm càng dập, càng nồng, Trách người đen bạc, ra lòng trăng hoa." (TKiều)',
  },
  {
    word: "nôn nóng",
    part_of_speech: "tính từ",
    meaning:
      "nóng lòng muốn được làm ngay việc chưa thể làm, muốn có ngay cái chưa thể có: thái độ nôn nóng * nôn nóng muốn về",
    example: "thái độ nôn nóng * nôn nóng muốn về",
  },
  {
    word: "nông",
    part_of_speech: "danh từ",
    meaning: "nghề làm ruộng: nghề nông * phát triển nông, lâm nghiệp",
    example: "nghề nông * phát triển nông, lâm nghiệp",
  },
  {
    word: "nông",
    part_of_speech: "danh từ",
    meaning: "người làm ruộng: công nông liên minh * con nhà nông",
    example: "công nông liên minh * con nhà nông",
  },
  {
    word: "nông",
    part_of_speech: "tính từ",
    meaning:
      "có khoảng cách từ miệng hoặc bề mặt xuống đáy ngắn hơn so với mức bình thường: ao nông * chậu nông lòng * đường cày nông * rễ mạ ăn nông",
    example: "ao nông * chậu nông lòng * đường cày nông * rễ mạ ăn nông",
  },
  {
    word: "nông",
    part_of_speech: "tính từ",
    meaning: "nông cạn (nói tắt): suy nghĩ còn nông",
    example: "suy nghĩ còn nông",
  },
  {
    word: "nổng",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) gò: nổng cát * nổng đất",
    example: "nổng cát * nổng đất",
  },
  {
    word: "nồng ấm",
    part_of_speech: "tính từ",
    meaning: "nồng nàn và ấm áp: giọt nước mắt nồng ấm * tình cảm nồng ấm",
    example: "giọt nước mắt nồng ấm * tình cảm nồng ấm",
  },
  {
    word: "nống",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) nong: nống tằm",
    example: "nống tằm",
  },
  {
    word: "nống",
    part_of_speech: "động từ",
    meaning: "làm cho cao hơn lên bằng cách chống, bẩy từ dưới: nống cột nhà",
    example: "nống cột nhà",
  },
  {
    word: "nống",
    part_of_speech: "động từ",
    meaning:
      "nới rộng, mở rộng ra bằng cách lấn từ bên trong lấn ra: nống vành rổ * địch đánh nống ra vùng tự do",
    example: "nống vành rổ * địch đánh nống ra vùng tự do",
  },
  {
    word: "nồng cháy",
    part_of_speech: "tính từ",
    meaning:
      "có những biểu hiện mãnh liệt của một tình cảm sâu đậm, thiết tha: tình yêu nồng cháy * ước mơ nồng cháy * khát vọng nồng cháy",
    example: "tình yêu nồng cháy * ước mơ nồng cháy * khát vọng nồng cháy",
  },
  {
    word: "nông cạn",
    part_of_speech: "tính từ",
    meaning:
      "(nhận thức) không đi vào chiều sâu, vào bản chất, chỉ lướt qua bên ngoài: suy nghĩ nông cạn * tư tưởng nông cạn",
    example: "suy nghĩ nông cạn * tư tưởng nông cạn",
  },
  {
    word: "nông choèn",
    part_of_speech: "tính từ",
    meaning: "rất nông, đến mức coi như không đáng kể: cái hố nông choèn",
    example: "cái hố nông choèn",
  },
  {
    word: "nông cụ",
    part_of_speech: "danh từ",
    meaning: "công cụ dùng trong sản xuất nông nghiệp: cải tiến nông cụ",
    example: "cải tiến nông cụ",
  },
  {
    word: "nông choèn choẹt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) như nông choèn (nhưng ý nhấn mạnh hơn): vũng nước nông choèn choẹt",
    example: "vũng nước nông choèn choẹt",
  },
  {
    word: "nông gia",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) nhà nông: "Cấy cày vốn nghiệp nông gia, Ta đây trâu đấy, ai mà quản công!" (ca dao)',
    example:
      'Cấy cày vốn nghiệp nông gia, Ta đây trâu đấy, ai mà quản công!" (ca dao)',
  },
  {
    word: "nồng đượm",
    part_of_speech: "tính từ",
    meaning: "nồng nàn và sâu đậm: hương thơm nồng đượm * mối tình nồng đượm",
    example: "hương thơm nồng đượm * mối tình nồng đượm",
  },
  {
    word: "nông dược",
    part_of_speech: "danh từ",
    meaning:
      "thuốc dùng trong sản xuất nông nghiệp, như thuốc trừ sâu, thuốc diệt cỏ, v.v.: cửa hàng nông dược * sản xuất thuốc nông dược",
    example: "cửa hàng nông dược * sản xuất thuốc nông dược",
  },
  {
    word: "nông giang",
    part_of_speech: "danh từ",
    meaning:
      "sông đào phục vụ cho sản xuất nông nghiệp: cải tạo hệ thống nông giang",
    example: "cải tạo hệ thống nông giang",
  },
  {
    word: "nồng độ",
    part_of_speech: "danh từ",
    meaning:
      "độ đậm đặc thể hiện bằng lượng chất tan trong đơn vị thể tích hoặc đơn vị khối lượng của dung dịch: nồng độ cồn",
    example: "nồng độ cồn",
  },
  {
    word: "nông dân",
    part_of_speech: "danh từ",
    meaning:
      "người lao động sản xuất nông nghiệp: bà con nông dân * cuộc nổi dậy của nông dân",
    example: "bà con nông dân * cuộc nổi dậy của nông dân",
  },
  {
    word: "nồng hậu",
    part_of_speech: "tính từ",
    meaning: "nồng nhiệt và thắm thiết: tình cảm nồng hậu * thết đãi nồng hậu",
    example: "tình cảm nồng hậu * thết đãi nồng hậu",
  },
  {
    word: "nông hội",
    part_of_speech: "danh từ",
    meaning: "(cũ) tổ chức quần chúng của nông dân: uỷ viên nông hội",
    example: "uỷ viên nông hội",
  },
  {
    word: "nông hộ",
    part_of_speech: "danh từ",
    meaning: "hộ nông dân: đa số nông hộ đã gia nhập hợp tác xã",
    example: "đa số nông hộ đã gia nhập hợp tác xã",
  },
  {
    word: "nồng nàn",
    part_of_speech: "tính từ",
    meaning:
      "đậm mùi một cách dễ chịu: mùi hoa sữa nồng nàn * hương thơm nồng nàn",
    example: "mùi hoa sữa nồng nàn * hương thơm nồng nàn",
  },
  {
    word: "nồng nàn",
    part_of_speech: "tính từ",
    meaning: "tha thiết và sâu đậm: lòng yêu nước nồng nàn * tình cảm nồng nàn",
    example: "lòng yêu nước nồng nàn * tình cảm nồng nàn",
  },
  {
    word: "nồng nã",
    part_of_speech: "tính từ",
    meaning:
      '(khẩu ngữ) rất nồng, rất đậm: hơi rượu nồng nã * "Đòi phen cợt phấn cười hồng, Ngọc lung lay động, hương nồng nã rơi." (HT)',
    example:
      'hơi rượu nồng nã * "Đòi phen cợt phấn cười hồng, Ngọc lung lay động, hương nồng nã rơi." (HT)',
  },
  {
    word: "nồng nặc",
    part_of_speech: "tính từ",
    meaning:
      "có mùi khó ngửi bốc lên mạnh với nồng độ cao: khai nồng nặc * người nồng nặc hơi rượu",
    example: "khai nồng nặc * người nồng nặc hơi rượu",
  },
  {
    word: "nông lâm",
    part_of_speech: "danh từ",
    meaning:
      "nông nghiệp và lâm nghiệp (nói gộp): sở nông lâm * đại học nông lâm",
    example: "sở nông lâm * đại học nông lâm",
  },
  {
    word: "nông ngư",
    part_of_speech: "danh từ",
    meaning:
      "nông nghiệp và ngư nghiệp (nói gộp): sản xuất theo mô hình nông ngư kết hợp",
    example: "sản xuất theo mô hình nông ngư kết hợp",
  },
  {
    word: "nông nghiệp",
    part_of_speech: "danh từ",
    meaning:
      "ngành sản xuất vật chất cơ bản của xã hội, cung cấp sản phẩm trồng trọt và sản phẩm chăn nuôi: ngành nông nghiệp * sản xuất nông nghiệp * hợp tác xã nông nghiệp",
    example:
      "ngành nông nghiệp * sản xuất nông nghiệp * hợp tác xã nông nghiệp",
  },
  {
    word: "nông nhàn",
    part_of_speech: "tính từ",
    meaning:
      "rỗi việc đồng áng: làm nghề phụ trong những lúc nông nhàn * buổi nông nhàn",
    example: "làm nghề phụ trong những lúc nông nhàn * buổi nông nhàn",
  },
  {
    word: "nông nổi",
    part_of_speech: "tính từ",
    meaning:
      'nông cạn, bồng bột, thiếu cân nhắc suy nghĩ trước khi hành động: hành động nông nổi * "Đàn ông nông nổi giếng khơi, Đàn bà sâu sắc như cơi đựng trầu." (ca dao)',
    example:
      'hành động nông nổi * "Đàn ông nông nổi giếng khơi, Đàn bà sâu sắc như cơi đựng trầu." (ca dao)',
  },
  {
    word: "nông phu",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người đàn ông làm ruộng; cũng dùng để chỉ người nông dân nói chung: đám nông phu * người nông phu",
    example: "đám nông phu * người nông phu",
  },
  {
    word: "nông nô",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người nông dân bị phụ thuộc vào ruộng đất của địa chủ, bị bóc lột bằng địa tô và lao dịch, có thể bị bán theo ruộng đất, dưới chế độ phong kiến: giải phóng nông nô * mâu thuẫn giữa nông nô và địa chủ",
    example: "giải phóng nông nô * mâu thuẫn giữa nông nô và địa chủ",
  },
  {
    word: "nông nỗi",
    part_of_speech: "danh từ",
    meaning:
      "tình cảnh, sự thể không được như ý muốn: ai biết cơ sự lại ra nông nỗi này!",
    example: "ai biết cơ sự lại ra nông nỗi này!",
  },
  {
    word: "nồng nực",
    part_of_speech: "tính từ",
    meaning: "nóng bức và ngột ngạt: trời oi ả, nồng nực",
    example: "trời oi ả, nồng nực",
  },
  {
    word: "nồng nhiệt",
    part_of_speech: "tính từ",
    meaning:
      "đầy nhiệt tình và rất thắm thiết: đón chào nồng nhiệt * cổ vũ nồng nhiệt * tình cảm nồng nhiệt",
    example: "đón chào nồng nhiệt * cổ vũ nồng nhiệt * tình cảm nồng nhiệt",
  },
  {
    word: "nông phẩm",
    part_of_speech: "danh từ",
    meaning:
      "sản phẩm nông nghiệp, như gạo, thịt, trứng, rau, hoa quả, v.v. (nói khái quát): thu mua nông sản * nhà máy chế biến nông sản",
    example: "thu mua nông sản * nhà máy chế biến nông sản",
  },
  {
    word: "nông tang",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) nghề làm ruộng và nghề trồng dâu nuôi tằm: "Chư quân đâu đấy đều nghe, Muôn dân vạn họ theo nghề nông tang." (TS)',
    example:
      'Chư quân đâu đấy đều nghe, Muôn dân vạn họ theo nghề nông tang." (TS)',
  },
  {
    word: "nồng nỗng",
    part_of_speech: "tính từ",
    meaning:
      "trần truồng đến mức quá lộ liễu, quá tự nhiên, không biết xấu hổ là gì: để truồng nồng nỗng",
    example: "để truồng nồng nỗng",
  },
  {
    word: "nông sản",
    part_of_speech: "danh từ",
    meaning:
      "sản phẩm nông nghiệp, như gạo, thịt, trứng, rau, hoa quả, v.v. (nói khái quát): thu mua nông sản * nhà máy chế biến nông sản",
    example: "thu mua nông sản * nhà máy chế biến nông sản",
  },
  {
    word: "nồng thắm",
    part_of_speech: "tính từ",
    meaning: "nồng nàn và thắm thiết: mối tình nồng thắm * nụ hôn nồng thắm",
    example: "mối tình nồng thắm * nụ hôn nồng thắm",
  },
  {
    word: "nông trang",
    part_of_speech: "danh từ",
    meaning:
      "nông trang tập thể (nói tắt): nông trang trồng nho * chủ tịch nông trang",
    example: "nông trang trồng nho * chủ tịch nông trang",
  },
  {
    word: "nông thôn",
    part_of_speech: "danh từ",
    meaning:
      "khu vực dân cư tập trung chủ yếu làm nghề nông; phân biệt với thành thị: sống ở nông thôn * người nông thôn * từ nông thôn ra thành thị",
    example: "sống ở nông thôn * người nông thôn * từ nông thôn ra thành thị",
  },
  {
    word: "nông trại",
    part_of_speech: "danh từ",
    meaning: "trại sản xuất nông nghiệp: nông trại nuôi bò",
    example: "nông trại nuôi bò",
  },
  {
    word: "nông trường",
    part_of_speech: "danh từ",
    meaning:
      "nông trường quốc doanh (nói tắt): nông trường cà phê * công nhân nông trường",
    example: "nông trường cà phê * công nhân nông trường",
  },
  {
    word: "nộp",
    part_of_speech: "động từ",
    meaning:
      "đưa cho người có trách nhiệm thu giữ: nộp đơn * nộp học phí * nộp thuế * đem thân đến nộp mạng (b)",
    example: "nộp đơn * nộp học phí * nộp thuế * đem thân đến nộp mạng (b)",
  },
  {
    word: "nốt",
    part_of_speech: "danh từ",
    meaning:
      "chấm nhỏ nổi lên trên mặt da: nốt trứng cá * nốt muỗi cắn * chân tay có nhiều nốt đỏ",
    example: "nốt trứng cá * nốt muỗi cắn * chân tay có nhiều nốt đỏ",
  },
  {
    word: "nốt",
    part_of_speech: "danh từ",
    meaning: "nốt nhạc (nói tắt): nốt fa",
    example: "nốt fa",
  },
  {
    word: "nốt",
    part_of_speech: "phụ từ",
    meaning:
      "(làm việc gì) cho hết phần còn lại, không để bỏ dở: ăn nốt bát cơm * trả nốt số tiền còn nợ * để tôi nói nốt đã!",
    example: "ăn nốt bát cơm * trả nốt số tiền còn nợ * để tôi nói nốt đã!",
  },
  {
    word: "nốt",
    part_of_speech: "phụ từ",
    meaning:
      "(Khẩu ngữ) (cũng) như vậy, giống hệt như sự việc, hành động vừa nêu trước đó, tựa như là có một sự kéo theo nào vậy: mình quên, nó cũng quên nốt",
    example: "mình quên, nó cũng quên nốt",
  },
  {
    word: "nột",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) bí, cùng đường: đuổi nột đến sau lưng * nột quá, phải liều mạng",
    example: "đuổi nột đến sau lưng * nột quá, phải liều mạng",
  },
  {
    word: "nớ",
    part_of_speech: "đại từ",
    meaning:
      '(Phương ngữ) ấy: "Hẹn hò đã mấy sớm trưa, Kẻ trông bên nớ, người chờ bên kia." (Cdao)',
    example:
      'Hẹn hò đã mấy sớm trưa, Kẻ trông bên nớ, người chờ bên kia." (Cdao)',
  },
  {
    word: "nợ",
    part_of_speech: "danh từ",
    meaning:
      "cái vay mà chưa trả: mang nợ * đòi nợ * làm thuê trừ nợ * nhất tội nhì nợ (tng)",
    example: "mang nợ * đòi nợ * làm thuê trừ nợ * nhất tội nhì nợ (tng)",
  },
  {
    word: "nợ",
    part_of_speech: "danh từ",
    meaning:
      "phía bên phải của bản tổng kết tài sản, cho biết nguồn hình thành vốn bằng tiền (vốn đầu tư dài hạn, các khoản nợ ngắn hạn); đối lập với có.",
    example: "nợ văn chương * đền nợ nước",
  },
  {
    word: "nợ",
    part_of_speech: "danh từ",
    meaning:
      "(trang trọng) điều mang ơn, phải đền đáp mà chưa đền đáp được: nợ văn chương * đền nợ nước",
    example:
      "vứt quách đi cho rảnh nợ! * vương vào rồi lại thành ra một cái nợ!",
  },
  {
    word: "nợ",
    part_of_speech: "động từ",
    meaning: "đang mắc nợ ai: nợ tiền ngân hàng * chưa trả được thì cho nợ",
    example: "nợ tiền ngân hàng * chưa trả được thì cho nợ",
  },
  {
    word: "nợ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đã hứa với ai việc gì đó mà chưa có dịp thực hiện: tôi còn nợ anh buổi xem phim",
    example: "tôi còn nợ anh buổi xem phim",
  },
  {
    word: "nơ",
    part_of_speech: "danh từ",
    meaning:
      "vật trang điểm thường tết bằng vải, lụa, để cài vào tóc, vào áo, v.v.: tết nơ * tóc cài nơ",
    example: "tết nơ * tóc cài nơ",
  },
  {
    word: "nợ đìa",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nợ rất nhiều và nhiều khoản, nhiều người: ăn tiêu hoang toàng nên mới nợ đìa ra như thế!",
    example: "ăn tiêu hoang toàng nên mới nợ đìa ra như thế!",
  },
  {
    word: "nỡ",
    part_of_speech: "động từ",
    meaning:
      "bằng lòng làm cái việc mà biết rằng người có tình cảm không thể làm: không nỡ từ chối * ép dầu ép mỡ, ai nỡ ép duyên (tng)",
    example: "không nỡ từ chối * ép dầu ép mỡ, ai nỡ ép duyên (tng)",
  },
  {
    word: "nở",
    part_of_speech: "động từ",
    meaning:
      "(nụ hoa) xoè mở một cách tự nhiên: nụ hoa hé nở * trăm hoa đua nở * môi nở một nụ cười (b)",
    example: "nụ hoa hé nở * trăm hoa đua nở * môi nở một nụ cười (b)",
  },
  {
    word: "nở",
    part_of_speech: "động từ",
    meaning:
      "(động vật con được ấp đủ ngày trong trứng) phá vỏ trứng thoát ra ngoài: gà con mới nở",
    example: "gà con mới nở",
  },
  {
    word: "nở",
    part_of_speech: "động từ",
    meaning: "(phương ngữ, khẩu ngữ) đẻ, sinh: nở con trai đầu lòng",
    example: "nở con trai đầu lòng",
  },
  {
    word: "nở",
    part_of_speech: "động từ",
    meaning:
      "tăng thể tích mà không tăng khối lượng: gạo nở * bột nở * ngô nở bung",
    example: "gạo nở * bột nở * ngô nở bung",
  },
  {
    word: "nợ đọng",
    part_of_speech: "danh từ",
    meaning: "nợ lưu lại từ trước chưa trả: nợ đọng thuế * nợ đọng tiền hàng",
    example: "nợ đọng thuế * nợ đọng tiền hàng",
  },
  {
    word: "nỡ nào",
    part_of_speech: "",
    meaning:
      'nỡ lòng nào, chẳng nỡ: người ta đã nói thế, nỡ nào lại từ chối * "Công em trăm đợi nghìn chờ, Nỡ nào dứt chỉ lìa tơ sao đành." (ca dao)',
    example:
      'người ta đã nói thế, nỡ nào lại từ chối * "Công em trăm đợi nghìn chờ, Nỡ nào dứt chỉ lìa tơ sao đành." (ca dao)',
  },
  {
    word: "nợ đời",
    part_of_speech: "danh từ",
    meaning: "nghĩa vụ đối với đời còn chưa làm được: trả nợ đời",
    example: "trả nợ đời",
  },
  {
    word: "nợ đời",
    part_of_speech: "danh từ",
    meaning:
      'cái coi là nỗi khổ đeo đẳng, chỉ muốn dứt bỏ mà không dứt bỏ được: "Chồng gì anh, vợ gì tôi, Chẳng qua là cái nợ đời chi đây!" (ca dao)',
    example:
      'Chồng gì anh, vợ gì tôi, Chẳng qua là cái nợ đời chi đây!" (ca dao)',
  },
  {
    word: "nở hậu",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) (nhà, đất) có bề ngang phía sau rộng hơn phía trước: ngôi nhà nở hậu",
    example: "ngôi nhà nở hậu",
  },
  {
    word: "nở mặt nở mày",
    part_of_speech: "",
    meaning:
      'vui mừng, mãn nguyện thể hiện ra trên nét mặt: "Nghe tin nở mặt nở mày, Mừng nào lại quá mừng này nữa chăng?" (TKiều)',
    example:
      'Nghe tin nở mặt nở mày, Mừng nào lại quá mừng này nữa chăng?" (TKiều)',
  },
  {
    word: "nở nang",
    part_of_speech: "tính từ",
    meaning:
      "(thân thể hoặc bộ phận thân thể) được phát triển một cách đầy đặn: bộ ngực nở nang * bắp thịt nở nang",
    example: "bộ ngực nở nang * bắp thịt nở nang",
  },
  {
    word: "nợ nần",
    part_of_speech: "",
    meaning: "nợ (nói khái quát): nợ nần chồng chất * không nợ nần gì ai",
    example: "nợ nần chồng chất * không nợ nần gì ai",
  },
  {
    word: "nở rộ",
    part_of_speech: "động từ",
    meaning: "(hoa) nở đều khắp cả loạt: hoa đào nở rộ vào dịp tết",
    example: "hoa đào nở rộ vào dịp tết",
  },
  {
    word: "nở ruột nở gan",
    part_of_speech: "",
    meaning: "sung sướng, thoả mãn trong lòng: sướng nở ruột nở gan",
    example: "sướng nở ruột nở gan",
  },
  {
    word: "nới tay",
    part_of_speech: "động từ",
    meaning:
      "bớt khắt khe, nghiệt ngã trong hành động, trong đối xử: đối xử có phần nới tay hơn * đây là lần đầu, mong ông nới tay cho!",
    example:
      "đối xử có phần nới tay hơn * đây là lần đầu, mong ông nới tay cho!",
  },
  {
    word: "nơi",
    part_of_speech: "danh từ",
    meaning:
      "phần không gian mà người hay vật nào đó chiếm, hoặc ở đấy sự việc gì đó xảy ra: nơi kinh kì * tìm nơi trú ẩn * bỏ làng đi nơi khác * loại hàng này có ở khắp nơi",
    example:
      "nơi kinh kì * tìm nơi trú ẩn * bỏ làng đi nơi khác * loại hàng này có ở khắp nơi",
  },
  {
    word: "nơi",
    part_of_speech: "danh từ",
    meaning:
      '(khẩu ngữ) từ dùng để chỉ (mà không nói rõ ra) người đặt quan hệ yêu đương để lấy làm vợ hoặc chồng: tham nơi phú quý * "Sông sâu ngựa lội ngập kiều, Dầu anh có phụ cũng nhiều nơi thương." (ca dao)',
    example:
      'tham nơi phú quý * "Sông sâu ngựa lội ngập kiều, Dầu anh có phụ cũng nhiều nơi thương." (ca dao)',
  },
  {
    word: "nơi",
    part_of_speech: "kết từ",
    meaning:
      "(khẩu ngữ) từ biểu thị điều sắp nêu ra là đối tượng mà sự vật, hoạt động vừa nói đến hướng vào đó: trông cậy nơi bạn * việc đó tuỳ ở nơi anh",
    example: "trông cậy nơi bạn * việc đó tuỳ ở nơi anh",
  },
  {
    word: "nới",
    part_of_speech: "động từ",
    meaning:
      "làm cho lỏng, cho rộng ra chút ít để bớt căng, bớt chật: quần chật, phải nới ra * nới rộng phạm vi hoạt động * có mới nới cũ (tng)",
    example:
      "quần chật, phải nới ra * nới rộng phạm vi hoạt động * có mới nới cũ (tng)",
  },
  {
    word: "nới",
    part_of_speech: "động từ",
    meaning:
      "làm cho thoáng hơn, bớt chặt chẽ, nghiêm ngặt: nới kỉ luật * điều lệ có phần nới hơn",
    example: "nới kỉ luật * điều lệ có phần nới hơn",
  },
  {
    word: "nới",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) hạ bớt giá xuống chút ít, so với bình thường: giá cả có phần nới hơn trước",
    example: "giá cả có phần nới hơn trước",
  },
  {
    word: "nơm",
    part_of_speech: "danh từ",
    meaning:
      'đồ đan thưa bằng tre, hình cái chuông, dùng để chụp bắt cá: "Trách ai đặng cá quên nơm, Đặng chim bẻ ná, quên ơn sinh thành." (ca dao)',
    example:
      'Trách ai đặng cá quên nơm, Đặng chim bẻ ná, quên ơn sinh thành." (ca dao)',
  },
  {
    word: "nơm",
    part_of_speech: "động từ",
    meaning: "bắt cá bằng nơm: xách nơm đi nơm cá",
    example: "xách nơm đi nơm cá",
  },
  {
    word: "nơi nơi",
    part_of_speech: "danh từ",
    meaning: "khắp mọi nơi (nói khái quát): nơi nơi đều nhất tề nổi dậy",
    example: "nơi nơi đều nhất tề nổi dậy",
  },
  {
    word: "nơi nới",
    part_of_speech: "động từ",
    meaning:
      "nới lỏng thêm ra một ít: nơi nới thắt lưng cho dễ thở * xử nơi nới tay một chút",
    example: "nơi nới thắt lưng cho dễ thở * xử nơi nới tay một chút",
  },
  {
    word: "nỡm",
    part_of_speech: "danh từ",
    meaning:
      "(thông tục) tiếng trách mắng thân mật khi không vừa ý: rõ nỡm! * thôi đi, nỡm ạ!",
    example: "rõ nỡm! * thôi đi, nỡm ạ!",
  },
  {
    word: "nơm nớp",
    part_of_speech: "động từ",
    meaning:
      "ở trạng thái luôn luôn phấp phỏng lo sợ về một tai hoạ có thể xảy ra bất kì lúc nào: nơm nớp lo sợ",
    example: "nơm nớp lo sợ",
  },
  {
    word: "nụ",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận ở cành cây, hình búp hoặc hình viên tròn, sắp nở thành hoa: nụ hồng * nụ tầm xuân * cành đào có nhiều nụ",
    example: "nụ hồng * nụ tầm xuân * cành đào có nhiều nụ",
  },
  {
    word: "nụ",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng cái hôn hoặc cái cười không thành tiếng: nụ hôn * môi nở một nụ cười",
    example: "nụ hôn * môi nở một nụ cười",
  },
  {
    word: "nục",
    part_of_speech: "danh từ",
    meaning: "(Khẩu ngữ) cá nục (nói tắt): mắm nục * con nục, con thu",
    example: "mắm nục * con nục, con thu",
  },
  {
    word: "nục",
    part_of_speech: "tính từ",
    meaning: "chín kĩ, đến mức nhừ nát: mít chín nục * cá kho thật nục",
    example: "mít chín nục * cá kho thật nục",
  },
  {
    word: "nục nạc",
    part_of_speech: "tính từ",
    meaning: "(thịt) toàn nạc, không có xương hoặc mỡ: miếng thịt nục nạc",
    example: "miếng thịt nục nạc",
  },
  {
    word: "núc ních",
    part_of_speech: "tính từ",
    meaning:
      "béo đến mức căng tròn, vẻ rắn chắc: con lợn béo núc ních * người núc ních những thịt",
    example: "con lợn béo núc ních * người núc ních những thịt",
  },
  {
    word: "núi",
    part_of_speech: "danh từ",
    meaning:
      "địa hình lồi, sườn dốc, nổi cao lên trên mặt đất, thường cao trên 200 mét: núi đá * đỉnh núi * nhà ở chân núi * chất cao như núi",
    example: "núi đá * đỉnh núi * nhà ở chân núi * chất cao như núi",
  },
  {
    word: "nùi",
    part_of_speech: "danh từ",
    meaning:
      "mớ rơm rác hay vải, giấy được vò chặt lại: nùi rơm * nùi giẻ rách",
    example: "nùi rơm * nùi giẻ rách",
  },
  {
    word: "núi lửa",
    part_of_speech: "danh từ",
    meaning:
      "núi hình chóp nón, có miệng ở đỉnh phun ra những chất nóng chảy từ lòng đất sâu (gọi là nham thạch) một cách thường xuyên hoặc theo từng thời kì: núi lửa đang hoạt động",
    example: "núi lửa đang hoạt động",
  },
  {
    word: "núi non",
    part_of_speech: "danh từ",
    meaning: "núi (nói khái quát): núi non hùng vĩ * núi non hiểm trở",
    example: "núi non hùng vĩ * núi non hiểm trở",
  },
  {
    word: "núm",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận hình tròn, nhỏ, nhô lên ở đầu hay trên bề mặt một số vật: núm cau * núm vú * vặn núm điều chỉnh ti vi",
    example: "núm cau * núm vú * vặn núm điều chỉnh ti vi",
  },
  {
    word: "núm",
    part_of_speech: "danh từ",
    meaning: "(Khẩu ngữ) nắm: núm gạo * một núm đất",
    example: "núm gạo * một núm đất",
  },
  {
    word: "núm",
    part_of_speech: "động từ",
    meaning: "(Phương ngữ) túm: núm tóc * tay núm chặt sợi dây",
    example: "núm tóc * tay núm chặt sợi dây",
  },
  {
    word: "núi rừng",
    part_of_speech: "danh từ",
    meaning:
      "núi và rừng (nói khái quát): cảnh núi rừng * sống giữa núi rừng * núi rừng Tây Bắc",
    example: "cảnh núi rừng * sống giữa núi rừng * núi rừng Tây Bắc",
  },
  {
    word: "nùn",
    part_of_speech: "danh từ",
    meaning:
      "cuộn rơm bện chặt, dùng để đốt hay để làm vật kê, đậy: bện nùn rơm",
    example: "bện nùn rơm",
  },
  {
    word: "nung",
    part_of_speech: "động từ",
    meaning:
      "đốt nóng ở nhiệt độ cao: nung vôi * nồi bằng đất nung * nóng như nung",
    example: "nung vôi * nồi bằng đất nung * nóng như nung",
  },
  {
    word: "nung",
    part_of_speech: "động từ",
    meaning:
      "(hiện tượng bệnh) ở thời kì còn đang phát triển ngấm ngầm, chưa có triệu chứng biểu hiện ra ngoài: giai đoạn nung sởi * nhọt đang nung mủ",
    example: "giai đoạn nung sởi * nhọt đang nung mủ",
  },
  {
    word: "núng",
    part_of_speech: "tính từ",
    meaning:
      "không còn vững chắc nữa, mà như đang chực đổ, chực sụt xuống: đoạn đê bị núng * bức tường núng, sắp đổ",
    example: "đoạn đê bị núng * bức tường núng, sắp đổ",
  },
  {
    word: "núng",
    part_of_speech: "tính từ",
    meaning:
      "(trước tác động bên ngoài) không còn giữ được sự vững vàng, không còn đủ sức chịu đựng, chống đỡ nữa: núng chí trước khó khăn * nao lòng núng dạ",
    example: "núng chí trước khó khăn * nao lòng núng dạ",
  },
  {
    word: "núng",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) lúm: cười núng cả má",
    example: "cười núng cả má",
  },
  {
    word: "nung bệnh",
    part_of_speech: "động từ",
    meaning: "(hiếm) như ủ bệnh: thời kì nung bệnh",
    example: "thời kì nung bệnh",
  },
  {
    word: "nũng",
    part_of_speech: "động từ",
    meaning: "(Khẩu ngữ) làm nũng (nói tắt): đứa bé nũng mẹ * tính hay nũng",
    example: "đứa bé nũng mẹ * tính hay nũng",
  },
  {
    word: "nung nấu",
    part_of_speech: "động từ",
    meaning:
      "làm cho bị nóng nhiều và lâu, tựa như nung trong lò: cái nắng nung nấu",
    example: "cái nắng nung nấu",
  },
  {
    word: "nung nấu",
    part_of_speech: "động từ",
    meaning:
      "làm cho (một mong muốn, một tình cảm nào đó) bị thôi thúc, dồn nén ngày càng nhiều: nung nấu ý chí phục thù * nỗi buồn nung nấu tâm can",
    example: "nung nấu ý chí phục thù * nỗi buồn nung nấu tâm can",
  },
  {
    word: "nung mủ",
    part_of_speech: "động từ",
    meaning: "(mụn, nhọt) đang làm mủ: nhọt đang nung mủ",
    example: "nhọt đang nung mủ",
  },
  {
    word: "núng nính",
    part_of_speech: "tính từ",
    meaning:
      "(cơ thể) béo tròn, thịt thành khối, nhiều đến mức rung rinh khi cử động: người béo núng nính",
    example: "người béo núng nính",
  },
  {
    word: "nung đúc",
    part_of_speech: "động từ",
    meaning: "(văn chương) như hun đúc: được nung đúc trong chiến tranh",
    example: "được nung đúc trong chiến tranh",
  },
  {
    word: "nũng nịu",
    part_of_speech: "",
    meaning:
      "tỏ vẻ nhõng nhẽo để được chiều chuộng: bé nũng nịu đòi mẹ bế * giọng nũng nịu",
    example: "bé nũng nịu đòi mẹ bế * giọng nũng nịu",
  },
  {
    word: "nùng nục",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như nung núc: khuôn mặt nùng nục, toàn những thịt",
    example: "khuôn mặt nùng nục, toàn những thịt",
  },
  {
    word: "nuộc",
    part_of_speech: "danh từ",
    meaning:
      'vòng dây buộc vào một vật: "Ngó lên nuộc lạt mái nhà, Bao nhiêu nuộc lạt thương bà bấy nhiêu." (ca dao)',
    example:
      'Ngó lên nuộc lạt mái nhà, Bao nhiêu nuộc lạt thương bà bấy nhiêu." (ca dao)',
  },
  {
    word: "nuộc",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) buộc thành nuộc cho chắc: nuộc chiếc gàu cho chắc * nuộc bánh chưng",
    example: "nuộc chiếc gàu cho chắc * nuộc bánh chưng",
  },
  {
    word: "nung núng",
    part_of_speech: "tính từ",
    meaning:
      "hơi núng, không còn vững chắc, vững vàng như trước nữa: thế giặc đã nung núng",
    example: "thế giặc đã nung núng",
  },
  {
    word: "nung núc",
    part_of_speech: "tính từ",
    meaning: "như béo núc (nhưng mức độ nhiều hơn): người nung núc những thịt",
    example: "người nung núc những thịt",
  },
  {
    word: "nuối",
    part_of_speech: "động từ",
    meaning: "lưu luyến không muốn rời xa: chia tay còn nuối theo",
    example: "chia tay còn nuối theo",
  },
  {
    word: "nuôi",
    part_of_speech: "động từ",
    meaning:
      'cho ăn uống, chăm sóc để duy trì và phát triển sự sống: nuôi tằm * nuôi con khôn lớn * "Công anh xúc tép nuôi cò, Cò ăn cò lớn cò dò lên cây." (ca dao)',
    example:
      'nuôi tằm * nuôi con khôn lớn * "Công anh xúc tép nuôi cò, Cò ăn cò lớn cò dò lên cây." (ca dao)',
  },
  {
    word: "nuôi",
    part_of_speech: "động từ",
    meaning:
      "giữ gìn, chăm sóc để cho tồn tại, cho phát triển: nuôi tóc * nuôi móng tay * nuôi hi vọng * nuôi ảo mộng",
    example: "nuôi tóc * nuôi móng tay * nuôi hi vọng * nuôi ảo mộng",
  },
  {
    word: "nuôi",
    part_of_speech: "tính từ",
    meaning:
      "được coi như ruột thịt, tuy không có quan hệ dòng máu trực tiếp: nhận cháu làm con nuôi * cha mẹ nuôi",
    example: "nhận cháu làm con nuôi * cha mẹ nuôi",
  },
  {
    word: "nuôi bộ",
    part_of_speech: "động từ",
    meaning:
      "nuôi (trẻ sơ sinh) hoàn toàn không phải bằng sữa mẹ: mẹ không có sữa nên phải nuôi bộ",
    example: "mẹ không có sữa nên phải nuôi bộ",
  },
  {
    word: "nuôi cấy",
    part_of_speech: "động từ",
    meaning:
      "nuôi (tế bào, vi sinh vật, v.v.) trong môi trường thích hợp, thường để nghiên cứu: nuôi cấy tế bào * nuôi cấy da * nuôi cấy mô",
    example: "nuôi cấy tế bào * nuôi cấy da * nuôi cấy mô",
  },
  {
    word: "nuôi dưỡng",
    part_of_speech: "động từ",
    meaning:
      "nuôi nấng và chăm chút cho tốt (nói khái quát): nuôi dưỡng mẹ già",
    example: "nuôi dưỡng mẹ già",
  },
  {
    word: "nuôi béo",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) làm lợi cho kẻ khác không công: làm thế chỉ nuôi béo bọn lậu thuế",
    example: "làm thế chỉ nuôi béo bọn lậu thuế",
  },
  {
    word: "nuôi nấng",
    part_of_speech: "động từ",
    meaning: "nuôi dưỡng với sự chăm sóc ân cần, chu đáo: nuôi nấng con cái",
    example: "nuôi nấng con cái",
  },
  {
    word: "nuối tiếc",
    part_of_speech: "động từ",
    meaning:
      "tiếc và ngậm ngùi trước những cái tốt đẹp đã qua đi: nuối tiếc tuổi thanh xuân * không có gì phải nuối tiếc",
    example: "nuối tiếc tuổi thanh xuân * không có gì phải nuối tiếc",
  },
  {
    word: "nuốm",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) núm: nuốm cau",
    example: "nuốm cau",
  },
  {
    word: "nuôi thả",
    part_of_speech: "động từ",
    meaning:
      "nuôi (súc vật) bằng cách thả cho được tự do chứ không giữ ở một chỗ: gà nuôi thả * nuôi thả gia súc",
    example: "gà nuôi thả * nuôi thả gia súc",
  },
  {
    word: "nuông",
    part_of_speech: "động từ",
    meaning:
      "chiều người dưới, thường là con cái, một cách quá mức, để cho làm hay làm theo cả những điều vô lí, sai trái: nuông lắm sinh hư * mẹ nuông con",
    example: "nuông lắm sinh hư * mẹ nuông con",
  },
  {
    word: "nuôi trồng",
    part_of_speech: "động từ",
    meaning: "nuôi và trồng (nói khái quát): nuôi trồng thuỷ sản",
    example: "nuôi trồng thuỷ sản",
  },
  {
    word: "nuốt chửng",
    part_of_speech: "động từ",
    meaning: "nuốt gọn cả miếng, không nhai: con trăn nuốt chửng con mồi",
    example: "con trăn nuốt chửng con mồi",
  },
  {
    word: "nuốt chửng",
    part_of_speech: "động từ",
    meaning:
      "che phủ hoặc nhấn chìm vào trong một cách hoàn toàn và nhanh gọn: con thuyền bị sóng nuốt chửng",
    example: "con thuyền bị sóng nuốt chửng",
  },
  {
    word: "nuốt",
    part_of_speech: "động từ",
    meaning:
      "làm cho đồ ăn uống từ miệng trôi qua thực quản, xuống dạ dày: nuốt nước bọt * nhai kĩ rồi mới nuốt * nghe như nuốt từng lời (b)",
    example:
      "nuốt nước bọt * nhai kĩ rồi mới nuốt * nghe như nuốt từng lời (b)",
  },
  {
    word: "nuốt",
    part_of_speech: "động từ",
    meaning:
      "cố dằn xuống, nén xuống, như làm cho chìm sâu vào trong lòng, không để lộ ra: nuốt giận * ôm sầu nuốt tủi * nuốt nước mắt vào trong",
    example: "nuốt giận * ôm sầu nuốt tủi * nuốt nước mắt vào trong",
  },
  {
    word: "nuốt",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) chiếm đoạt gọn bằng quyền thế hay mánh khoé: nuốt không mấy sào ruộng * nuốt không trôi nên mới phải nhả ra",
    example: "nuốt không mấy sào ruộng * nuốt không trôi nên mới phải nhả ra",
  },
  {
    word: "nuốt",
    part_of_speech: "động từ",
    meaning:
      "làm át hẳn đi bằng một sức tác động mạnh hơn: tiếng gọi bị nuốt trong tiếng sóng * cặp kính nuốt cả khuôn mặt",
    example: "tiếng gọi bị nuốt trong tiếng sóng * cặp kính nuốt cả khuôn mặt",
  },
  {
    word: "nuốt lời",
    part_of_speech: "động từ",
    meaning:
      "cố tình không làm đúng theo lời đã hứa, đã cam kết: nuốt lời hứa * đã nói thì đừng có nuốt lời đấy nhé!",
    example: "nuốt lời hứa * đã nói thì đừng có nuốt lời đấy nhé!",
  },
  {
    word: "nuột",
    part_of_speech: "tính từ",
    meaning:
      "có bề mặt bóng, mượt, trông đẹp mắt: sợi tơ óng nuột * mặt gỗ bóng nuột * chuốt nan cho thật nuột",
    example: "sợi tơ óng nuột * mặt gỗ bóng nuột * chuốt nan cho thật nuột",
  },
  {
    word: "nuông chiều",
    part_of_speech: "động từ",
    meaning: "nuông (nói khái quát): là con út nên được cả nhà nuông chiều",
    example: "là con út nên được cả nhà nuông chiều",
  },
  {
    word: "nuốt trộng",
    part_of_speech: "động từ",
    meaning: "(Phương ngữ) nuốt chửng: thằng bé nuốt trộng cả miếng bánh",
    example: "thằng bé nuốt trộng cả miếng bánh",
  },
  {
    word: "núp bóng",
    part_of_speech: "động từ",
    meaning:
      "dựa vào uy thế hay vào sự che chở của ai hay cái gì đó: núp bóng từ bi * núp bóng quan lớn",
    example: "núp bóng từ bi * núp bóng quan lớn",
  },
  {
    word: "nút",
    part_of_speech: "danh từ",
    meaning:
      "vật tròn, nhỏ, để đóng vào miệng chai lọ cho kín: chai bị mất nút * bật nút sâm banh * dùng lá chuối khô làm nút",
    example: "chai bị mất nút * bật nút sâm banh * dùng lá chuối khô làm nút",
  },
  {
    word: "nút",
    part_of_speech: "danh từ",
    meaning:
      "chỗ hai đầu dây buộc vào nhau: gỡ nút thừng * cởi nút dây * buộc thắt nút",
    example: "gỡ nút thừng * cởi nút dây * buộc thắt nút",
  },
  {
    word: "nút",
    part_of_speech: "danh từ",
    meaning:
      "chỗ giao nhau của nhiều đoạn đường đi từ các hướng lại: nút giao thông",
    example: "nút giao thông",
  },
  {
    word: "nút",
    part_of_speech: "danh từ",
    meaning:
      "điểm trọng yếu: nắm được cái nút của vấn đề * điểm nút của câu chuyện",
    example: "nắm được cái nút của vấn đề * điểm nút của câu chuyện",
  },
  {
    word: "nút",
    part_of_speech: "danh từ",
    meaning:
      "điểm cao trào trong vở kịch, khi các nhân vật chính đụng độ với nhau làm bùng nổ xung đột: vở kịch đang đến đoạn nút * thắt nút câu chuyện",
    example: "vở kịch đang đến đoạn nút * thắt nút câu chuyện",
  },
  {
    word: "nút",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ) khuy: nút áo",
    example: "nút áo",
  },
  {
    word: "nút",
    part_of_speech: "danh từ",
    meaning:
      "núm nhỏ, có tác dụng đóng mở để điều khiển ở một số loại máy, động cơ hay hệ thống điện: ấn nút điện * bấm nút điều khiển",
    example: "ấn nút điện * bấm nút điều khiển",
  },
  {
    word: "nút",
    part_of_speech: "danh từ",
    meaning:
      "(Thông tục) tập hợp nhiều người, hoặc đôi khi là động vật, cùng loại (hàm ý coi thường hoặc thân mật): tí nữa thì chết cả nút!",
    example: "tí nữa thì chết cả nút!",
  },
  {
    word: "nút",
    part_of_speech: "động từ",
    meaning:
      "đóng kín miệng chai lọ bằng nút: nút miệng chai bằng lá chuối * nút không chặt nên rượu bị hả",
    example: "nút miệng chai bằng lá chuối * nút không chặt nên rượu bị hả",
  },
  {
    word: "nút",
    part_of_speech: "động từ",
    meaning: "(Nam) mút: bé nút sữa * ong nút mật hoa",
    example: "bé nút sữa * ong nút mật hoa",
  },
  {
    word: "nuốt sống",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) chiếm được, thắng được một cách dễ dàng, chóng vánh (thường hàm ý mỉa mai): tưởng nuốt sống được ngay, không ngờ lại chịu thất bại",
    example: "tưởng nuốt sống được ngay, không ngờ lại chịu thất bại",
  },
  {
    word: "nuột nà",
    part_of_speech: "tính từ",
    meaning: "nuột (nói khái quát): mái tóc nuột nà, óng ả",
    example: "mái tóc nuột nà, óng ả",
  },
  {
    word: "nư",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) cơn giận: mắng cho đã nư",
    example: "mắng cho đã nư",
  },
  {
    word: "núp",
    part_of_speech: "động từ",
    meaning:
      "giấu mình vào nơi có vật che khuất để trốn, để được che chở: nấp sau lưng mẹ * nấp dưới hầm",
    example: "nấp sau lưng mẹ * nấp dưới hầm",
  },
  {
    word: "nuy",
    part_of_speech: "tính từ",
    meaning: "khoả thân: ảnh nuy * tranh thiếu nữ nuy",
    example: "ảnh nuy * tranh thiếu nữ nuy",
  },
  {
    word: "nữ chúa",
    part_of_speech: "danh từ",
    meaning:
      "người phụ nữ làm chúa, có quyền lực cao nhất trong một vùng: nữ chúa rừng xanh",
    example: "nữ chúa rừng xanh",
  },
  {
    word: "nữ",
    part_of_speech: "danh từ",
    meaning:
      "người thuộc nữ giới (nói khái quát); phân biệt với nam: bên nữ bên nam * nam nữ bình quyền * tư tưởng trọng nam khinh nữ",
    example: "bên nữ bên nam * nam nữ bình quyền * tư tưởng trọng nam khinh nữ",
  },
  {
    word: "nữ",
    part_of_speech: "tính từ",
    meaning:
      "(đồ dùng hoặc môn chơi) chuyên dành cho nữ giới: xe đạp nữ * bóng đá nữ",
    example: "xe đạp nữ * bóng đá nữ",
  },
  {
    word: "nữ hoàng",
    part_of_speech: "danh từ",
    meaning: "người phụ nữ làm vua: nữ hoàng Ai Cập * nữ hoàng Anh",
    example: "nữ hoàng Ai Cập * nữ hoàng Anh",
  },
  {
    word: "nữ công",
    part_of_speech: "danh từ",
    meaning:
      "công việc nội trợ của phụ nữ, như may vá, thêu thùa, nấu nướng, v.v. (nói khái quát): việc nữ công * giỏi nữ công * nữ công gia chánh",
    example: "việc nữ công * giỏi nữ công * nữ công gia chánh",
  },
  {
    word: "nữ công",
    part_of_speech: "danh từ",
    meaning: "công tác phụ nữ trong cơ quan, đoàn thể: phụ trách nữ công",
    example: "phụ trách nữ công",
  },
  {
    word: "nữ nhi",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) đàn bà, con gái, thường nói về mặt có tính cách yếu đuối, theo quan niệm cũ (nói khái quát); phân biệt với nam nhi: phận nữ nhi * "Buồn vì con gái nữ nhi, Mẹ cha thách cưới làm chi lỡ làng." (ca dao)',
    example:
      'phận nữ nhi * "Buồn vì con gái nữ nhi, Mẹ cha thách cưới làm chi lỡ làng." (ca dao)',
  },
  {
    word: "nữ giới",
    part_of_speech: "danh từ",
    meaning:
      "những người thuộc về giới có thể đẻ con (nói tổng quát); phân biệt với nam giới: môn thể thao dành riêng cho nữ giới",
    example: "môn thể thao dành riêng cho nữ giới",
  },
  {
    word: "nữ quyền",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) quyền lợi về chính trị và xã hội của phụ nữ (nói khái quát): bênh vực nữ quyền * tranh đấu cho nữ quyền",
    example: "bênh vực nữ quyền * tranh đấu cho nữ quyền",
  },
  {
    word: "nữ thần",
    part_of_speech: "danh từ",
    meaning: "vị thần nữ: nữ thần mặt trời * tượng nữ thần Tự Do",
    example: "nữ thần mặt trời * tượng nữ thần Tự Do",
  },
  {
    word: "nữ nhi thường tình",
    part_of_speech: "",
    meaning:
      '(cũ, văn chương) như nhi nữ thường tình: "Từ rằng: Tâm phúc tương tri, Sao chưa thoát khỏi nữ nhi thường tình?" (TKiều)',
    example:
      'Từ rằng: Tâm phúc tương tri, Sao chưa thoát khỏi nữ nhi thường tình?" (TKiều)',
  },
  {
    word: "nữ trang",
    part_of_speech: "danh từ",
    meaning:
      "đồ trang sức của phụ nữ (nói khái quát): đồ nữ trang * mua sắm nữ trang",
    example: "đồ nữ trang * mua sắm nữ trang",
  },
  {
    word: "nữ sĩ",
    part_of_speech: "danh từ",
    meaning: "(cũ) nhà văn, nhà thơ nữ: nữ sĩ Hồ Xuân Hương",
    example: "nữ sĩ Hồ Xuân Hương",
  },
  {
    word: "nữ sinh",
    part_of_speech: "danh từ",
    meaning:
      "học sinh nữ; phân biệt với nam sinh: trường nữ sinh * nữ sinh trung học",
    example: "trường nữ sinh * nữ sinh trung học",
  },
  {
    word: "nữ tính",
    part_of_speech: "danh từ",
    meaning:
      "giới tính nữ; phân biệt với nam tính: một cô gái tốt bụng, giàu nữ tính",
    example: "một cô gái tốt bụng, giàu nữ tính",
  },
  {
    word: "nữ tính",
    part_of_speech: "tính từ",
    meaning:
      "có những đặc điểm, tính chất của giới tính nữ (như dịu dàng, mềm mại, v.v.); phân biệt với nam tính: kiểu tóc trông rất nữ tính",
    example: "kiểu tóc trông rất nữ tính",
  },
  {
    word: "nữ tướng",
    part_of_speech: "danh từ",
    meaning:
      "người phụ nữ làm tướng: Bùi Thị Xuân là một nữ tướng của nghĩa quân Tây Sơn",
    example: "Bùi Thị Xuân là một nữ tướng của nghĩa quân Tây Sơn",
  },
  {
    word: "nửa",
    part_of_speech: "danh từ",
    meaning:
      'một trong hai phần bằng nhau của một cái gì: nửa quả cam * không nói nửa lời * "Vầng trăng ai xẻ làm đôi?, Nửa in gối chiếc, nửa soi dặm trường." (TKiều)',
    example:
      'nửa quả cam * không nói nửa lời * "Vầng trăng ai xẻ làm đôi?, Nửa in gối chiếc, nửa soi dặm trường." (TKiều)',
  },
  {
    word: "nửa",
    part_of_speech: "tính từ",
    meaning:
      "không hoàn toàn, vừa như thế, vừa khác thế: những nước thuộc địa và nửa thuộc địa * thực vật nửa kí sinh",
    example: "những nước thuộc địa và nửa thuộc địa * thực vật nửa kí sinh",
  },
  {
    word: "nữa",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị sự tiếp tục, tiếp diễn của hành động, trạng thái: thôi, đừng nói nữa! * cứ đi nữa đi! * không ăn nữa",
    example: "thôi, đừng nói nữa! * cứ đi nữa đi! * không ăn nữa",
  },
  {
    word: "nữa",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị sự lặp lại của hành động, trạng thái: trời lại đổ một trận mưa nữa * hôm trước đã say, hôm nay lại say nữa",
    example:
      "trời lại đổ một trận mưa nữa * hôm trước đã say, hôm nay lại say nữa",
  },
  {
    word: "nữa",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị sự gia tăng về mức độ, cường độ của hoạt động, trạng thái, tính chất: nhanh nữa lên! * nói khẽ chút nữa * nói thế, chứ nói nữa cũng vẫn vậy",
    example:
      "nhanh nữa lên! * nói khẽ chút nữa * nói thế, chứ nói nữa cũng vẫn vậy",
  },
  {
    word: "nữa",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị ý bổ sung về số lượng, phải tăng thêm một phần nào đó: cho thêm chút muối nữa * đi một đoạn nữa thì đến",
    example: "cho thêm chút muối nữa * đi một đoạn nữa thì đến",
  },
  {
    word: "nữa",
    part_of_speech: "trợ từ",
    meaning:
      "từ dùng để nhấn mạnh ý tăng cường, tiếp thêm: ngôi nhà rộng, lại cao ráo nữa * cô ấy đã đẹp lại còn thông minh nữa * tôi, anh và cả nó nữa cùng đi",
    example:
      "ngôi nhà rộng, lại cao ráo nữa * cô ấy đã đẹp lại còn thông minh nữa * tôi, anh và cả nó nữa cùng đi",
  },
  {
    word: "nữa",
    part_of_speech: "kết từ",
    meaning:
      '(hiếm) như nữa là: "Phải duyên phải kiếp thì theo, Cám còn ăn được, nữa bèo hử anh." (ca dao)',
    example:
      'Phải duyên phải kiếp thì theo, Cám còn ăn được, nữa bèo hử anh." (ca dao)',
  },
  {
    word: "nửa buổi",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian vào giữa buổi sáng, khoảng từ 9 đến 10 giờ, hoặc vào giữa buổi chiều, khoảng từ 3 đến 4 giờ: ngủ đến nửa buổi mới đi làm * từ đây đến đó mất non nửa buổi",
    example: "ngủ đến nửa buổi mới đi làm * từ đây đến đó mất non nửa buổi",
  },
  {
    word: "nửa đêm",
    part_of_speech: "danh từ",
    meaning: "khoảng thời gian vào giữa đêm: đi đến nửa đêm mới về",
    example: "đi đến nửa đêm mới về",
  },
  {
    word: "nửa chừng",
    part_of_speech: "danh từ",
    meaning:
      'khoảng giữa chừng, chưa xong, chưa trọn vẹn: làm nửa chừng rồi bỏ * "Thà rằng chẳng biết cho đừng, Biết ra dan díu nửa chừng lại thôi." (ca dao)',
    example:
      'làm nửa chừng rồi bỏ * "Thà rằng chẳng biết cho đừng, Biết ra dan díu nửa chừng lại thôi." (ca dao)',
  },
  {
    word: "nửa chừng xuân",
    part_of_speech: "",
    meaning:
      '(văn chương) khoảng giữa chừng tuổi trẻ: "Kiếp hồng nhan có mong manh, Nửa chừng xuân, thoắt gãy cành thiên hương!" (TKiều)',
    example:
      'Kiếp hồng nhan có mong manh, Nửa chừng xuân, thoắt gãy cành thiên hương!" (TKiều)',
  },
  {
    word: "nửa đời",
    part_of_speech: "danh từ",
    meaning:
      'khoảng thời gian coi như đã sống được một nửa cuộc đời con người, ở độ khoảng từ ba đến bốn mươi tuổi: "Nàng rằng: Chút phận hoa rơi, Nửa đời nếm trải mọi mùi đắng cay." (TKiều)',
    example:
      'Nàng rằng: Chút phận hoa rơi, Nửa đời nếm trải mọi mùi đắng cay." (TKiều)',
  },
  {
    word: "nữa là",
    part_of_speech: "",
    meaning:
      'huống chi là: "Chuông khánh còn chẳng ăn ai, Nữa là mảnh chĩnh bỏ ngoài bờ tre." (ca dao)',
    example:
      'Chuông khánh còn chẳng ăn ai, Nữa là mảnh chĩnh bỏ ngoài bờ tre." (ca dao)',
  },
  {
    word: "nửa mùa",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) kém cỏi, không lành nghề, không chuyên nghiệp (hàm ý giễu cợt): ca sĩ nửa mùa",
    example: "ca sĩ nửa mùa",
  },
  {
    word: "nửa nạc nửa mỡ",
    part_of_speech: "",
    meaning:
      "(lối nói) ỡm ờ, không rõ ràng, không dứt khoát: lối nói nửa nạc nửa mỡ",
    example: "lối nói nửa nạc nửa mỡ",
  },
  {
    word: "nửa úp nửa mở",
    part_of_speech: "",
    meaning:
      "(lối nói) không rõ ràng, không hết ý, vừa muốn che giấu lại vừa muốn để lộ ra: không nói thẳng, cứ nửa úp nửa mở, ai mà hiểu được",
    example: "không nói thẳng, cứ nửa úp nửa mở, ai mà hiểu được",
  },
  {
    word: "nực cười",
    part_of_speech: "tính từ",
    meaning:
      'buồn cười, khó nhịn được cười vì kì quặc, lố bịch hay vì quá vô lí: chuyện nực cười * "Sự đời nghĩ cũng nực cười, Một con cá lội mấy người buông câu!" (ca dao)',
    example:
      'chuyện nực cười * "Sự đời nghĩ cũng nực cười, Một con cá lội mấy người buông câu!" (ca dao)',
  },
  {
    word: "nực",
    part_of_speech: "tính từ",
    meaning: "nóng bức: trời nực",
    example: "trời nực",
  },
  {
    word: "nửa vời",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất nửa chừng, không dứt khoát, không triệt để: ăn nói nửa vời * thái độ nửa vời",
    example: "ăn nói nửa vời * thái độ nửa vời",
  },
  {
    word: "nực nội",
    part_of_speech: "tính từ",
    meaning: "nóng bức đến khó chịu: ngày hè nực nội",
    example: "ngày hè nực nội",
  },
  {
    word: "nức danh",
    part_of_speech: "tính từ",
    meaning:
      '(cũ, hiếm) như nức tiếng: "Đào non sớm nghĩ thơ lành, Vui vầy một hội nức danh muôn đời." (HT)',
    example:
      'Đào non sớm nghĩ thơ lành, Vui vầy một hội nức danh muôn đời." (HT)',
  },
  {
    word: "nức",
    part_of_speech: "động từ",
    meaning: "cạp miệng, vành của đồ đan bằng tre, nứa: nức lại cái thúng",
    example: "nức lại cái thúng",
  },
  {
    word: "nức lòng",
    part_of_speech: "tính từ",
    meaning:
      "phấn chấn và hào hứng hẳn lên, do một tác động tích cực từ bên ngoài: tin thắng trận làm nức lòng dân",
    example: "tin thắng trận làm nức lòng dân",
  },
  {
    word: "nức tiếng",
    part_of_speech: "tính từ",
    meaning:
      "có tiếng tăm vang xa, ai cũng biết: nức tiếng tài giỏi * đẹp nức tiếng một thời",
    example: "nức tiếng tài giỏi * đẹp nức tiếng một thời",
  },
  {
    word: "nức nở",
    part_of_speech: "động từ",
    meaning:
      'khóc nấc lên từng cơn, không thể kìm nén được (thường do quá xúc động): khóc nức nở * "Hỏi sao ra sự lạ lùng, Kiều càng nức nở nói không ra lời." (TKiều)',
    example:
      'khóc nức nở * "Hỏi sao ra sự lạ lùng, Kiều càng nức nở nói không ra lời." (TKiều)',
  },
  {
    word: "nức nở",
    part_of_speech: "phụ từ",
    meaning:
      '(Khẩu ngữ) (khen) không ngớt lời: "Xem thơ nức nở khen thầm, Giá đành tú khẩu, cẩm tâm khác thường!" (TKiều)',
    example:
      'Xem thơ nức nở khen thầm, Giá đành tú khẩu, cẩm tâm khác thường!" (TKiều)',
  },
  {
    word: "nựng",
    part_of_speech: "động từ",
    meaning:
      "tỏ rõ sự âu yếm trẻ con bằng lời nói, cử chỉ: nựng trẻ con * nói nựng",
    example: "nựng trẻ con * nói nựng",
  },
  {
    word: "nựng nịu",
    part_of_speech: "động từ",
    meaning:
      "nựng (nói khái quát): người mẹ nựng nịu con * phải nựng nịu, vỗ về mãi đứa bé mới ngủ",
    example: "người mẹ nựng nịu con * phải nựng nịu, vỗ về mãi đứa bé mới ngủ",
  },
  {
    word: "nước ăn",
    part_of_speech: "danh từ",
    meaning: "nước dùng cho việc ăn uống hằng ngày: bể nước ăn",
    example: "bể nước ăn",
  },
  {
    word: "nước",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ, cũ nác) chất lỏng không màu, không mùi và tồn tại trong tự nhiên ở ao hồ, sông biển, v.v.: nước giếng * nước mưa",
    example: "nước giếng * nước mưa",
  },
  {
    word: "nước",
    part_of_speech: "danh từ",
    meaning:
      "chất lỏng, nói chung: nước mắt * chanh mọng nước * vắt cam lấy nước * thuốc nước",
    example: "nước mắt * chanh mọng nước * vắt cam lấy nước * thuốc nước",
  },
  {
    word: "nước",
    part_of_speech: "danh từ",
    meaning:
      "lần, lượt sử dụng nước, cho một tác dụng nhất định nào đó: chè mới pha nước thứ nhất * thuốc sắc ba nước * giũ ba nước mới hết xà phòng",
    example:
      "chè mới pha nước thứ nhất * thuốc sắc ba nước * giũ ba nước mới hết xà phòng",
  },
  {
    word: "nước",
    part_of_speech: "danh từ",
    meaning:
      "lớp quét, phủ bên ngoài cho bền, đẹp: quét hai nước vôi * vải nhuộm một nước * tốt gỗ hơn tốt nước sơn (tng)",
    example:
      "quét hai nước vôi * vải nhuộm một nước * tốt gỗ hơn tốt nước sơn (tng)",
  },
  {
    word: "nước",
    part_of_speech: "danh từ",
    meaning:
      "vẻ ánh, bóng tự nhiên của một số vật, tựa như có một lớp mỏng chất phản chiếu ánh sáng nào đó phủ bên ngoài: gỗ lên nước bóng loáng * nước thép sáng ngời",
    example: "gỗ lên nước bóng loáng * nước thép sáng ngời",
  },
  {
    word: "nước",
    part_of_speech: "danh từ",
    meaning:
      "vùng đất trong đó những người thuộc một hay nhiều dân tộc cùng sống chung dưới một chế độ chính trị - xã hội và cùng thuộc về một nhà nước nhất định: các nước Đông Dương * tách ra thành lập một nước mới * sang thăm nước bạn",
    example:
      "các nước Đông Dương * tách ra thành lập một nước mới * sang thăm nước bạn",
  },
  {
    word: "nước",
    part_of_speech: "danh từ",
    meaning:
      "bước đi, về mặt nhanh chậm (của ngựa): chỉ xem qua nước chạy đã biết đó là con ngựa hay",
    example: "chỉ xem qua nước chạy đã biết đó là con ngựa hay",
  },
  {
    word: "nước",
    part_of_speech: "danh từ",
    meaning:
      "bước đi của quân cờ, về mặt ảnh hưởng đến thế cờ: đi một nước cờ cao * cờ đang bí nước",
    example: "đi một nước cờ cao * cờ đang bí nước",
  },
  {
    word: "nước",
    part_of_speech: "danh từ",
    meaning:
      "cách hành động, hoạt động để tác động đến tình hình, thoát khỏi thế bí hoặc tạo ra thế thuận lợi: xấu hổ chỉ còn nước chui xuống đất!",
    example: "xấu hổ chỉ còn nước chui xuống đất!",
  },
  {
    word: "nước",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) thế hơn kém: được nước làm già * xuống nước làm lành * nó chỉ có cái nước ăn hại!",
    example:
      "được nước làm già * xuống nước làm lành * nó chỉ có cái nước ăn hại!",
  },
  {
    word: "nước",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) mức độ khó có thể chịu đựng hơn: sao lại độc ác đến nước ấy! * đến nước này thì không thể nhịn được nữa",
    example:
      "sao lại độc ác đến nước ấy! * đến nước này thì không thể nhịn được nữa",
  },
  {
    word: "nưng niu",
    part_of_speech: "động từ",
    meaning:
      "cầm, giữ trên tay với tình cảm trân trọng, yêu quý: tay nâng niu bông hoa",
    example: "tay nâng niu bông hoa",
  },
  {
    word: "nưng niu",
    part_of_speech: "động từ",
    meaning:
      "chăm chút, giữ gìn cẩn thận với tình cảm yêu quý đặc biệt: nâng niu từng kỉ vật * được nâng niu từ tấm bé",
    example: "nâng niu từng kỉ vật * được nâng niu từ tấm bé",
  },
  {
    word: "nước bọt",
    part_of_speech: "danh từ",
    meaning:
      "dịch do tuyến ở miệng tiết ra, có tác dụng chính là tẩm ướt thức ăn cho dễ nuốt: thèm nuốt nước bọt * nhổ một bãi nước bọt",
    example: "thèm nuốt nước bọt * nhổ một bãi nước bọt",
  },
  {
    word: "nước chảy bèo trôi",
    part_of_speech: "",
    meaning:
      'ví thái độ tiêu cực, buông trôi, phó mặc cho sự diễn biến, phát triển tự nhiên của sự việc: "Cầm bằng nước chảy bèo trôi, Trời mưa nước úng, bèo ngồi đầu sen." (ca dao)',
    example:
      'Cầm bằng nước chảy bèo trôi, Trời mưa nước úng, bèo ngồi đầu sen." (ca dao)',
  },
  {
    word: "nước chạt",
    part_of_speech: "danh từ",
    meaning:
      "nước biển lọc qua cát, phơi để lấy muối theo lối sản xuất muối thủ công: phơi chạt",
    example: "phơi chạt",
  },
  {
    word: "nước chạt",
    part_of_speech: "danh từ",
    meaning: "khoảng đất đắp để chứa và phơi nước chạt: đắp lại bờ chạt",
    example: "đắp lại bờ chạt",
  },
  {
    word: "nước chạt",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) tạt mạnh: đất đá văng chạt sang hai bên",
    example: "đất đá văng chạt sang hai bên",
  },
  {
    word: "nước chấm",
    part_of_speech: "danh từ",
    meaning:
      "dung dịch mặn, chế biến bằng cách hoà các nguyên liệu có nhiều chất đạm, có thêm gia vị, dùng để chấm thức ăn: pha nước chấm",
    example: "pha nước chấm",
  },
  {
    word: "nước cốt",
    part_of_speech: "danh từ",
    meaning:
      "phần nước đậm đặc, tinh tuý nhất do vắt, ép hoặc ngâm, nấu lần đầu mà có: nước cốt dừa * nước cốt chanh",
    example: "nước cốt dừa * nước cốt chanh",
  },
  {
    word: "nước chín",
    part_of_speech: "danh từ",
    meaning: "như nước lọc (ng2): uống nước chín",
    example: "uống nước chín",
  },
  {
    word: "nước dùng",
    part_of_speech: "danh từ",
    meaning:
      "nước nấu từ thịt, xương, tôm để chan vào các món ăn như phở, bún, v.v.: nồi nước dùng * phở chan nước dùng",
    example: "nồi nước dùng * phở chan nước dùng",
  },
  {
    word: "nước độc",
    part_of_speech: "danh từ",
    meaning:
      "chỉ khí hậu, môi trường xấu, dễ sinh ốm đau: vùng ma thiêng nước độc",
    example: "vùng ma thiêng nước độc",
  },
  {
    word: "nước da",
    part_of_speech: "danh từ",
    meaning: "màu sắc của da người: nước da trắng hồng",
    example: "nước da trắng hồng",
  },
  {
    word: "nước đá",
    part_of_speech: "danh từ",
    meaning: "nước đông cứng do được làm lạnh: lạnh như nước đá",
    example: "lạnh như nước đá",
  },
  {
    word: "nước dãi",
    part_of_speech: "danh từ",
    meaning: "nước bọt chảy ra ngoài mép: thèm nhỏ nước dãi",
    example: "thèm nhỏ nước dãi",
  },
  {
    word: "nước đại",
    part_of_speech: "danh từ",
    meaning:
      "bước chạy nhanh, phi nhanh của ngựa; phân biệt với nước kiệu: ngựa phi nước đại * phóng nước đại",
    example: "ngựa phi nước đại * phóng nước đại",
  },
  {
    word: "nước đổ lá khoai",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) ví trường hợp những lời dạy bảo, khuyên can đều chỉ là hoài công, không có tác dụng gì (tựa như nước đổ vào lá khoai không đọng lại được giọt nào, không thấm ướt lá mà chảy ngay đi hết): nói với nó cũng chỉ như nước đổ lá khoai",
    example: "nói với nó cũng chỉ như nước đổ lá khoai",
  },
  {
    word: "nước đôi",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất lập lờ không dứt khoát, khiến cho hiểu thế này hay thế khác đều được: câu nói nước đôi * trả lời nước đôi",
    example: "câu nói nước đôi * trả lời nước đôi",
  },
  {
    word: "nước gội đầu",
    part_of_speech: "danh từ",
    meaning:
      "nước dùng để gội đầu, thường được nấu từ bồ kết hoặc từ lá của một số loài cây có hương thơm: đun một nồi nước gội đầu",
    example: "đun một nồi nước gội đầu",
  },
  {
    word: "nước gội đầu",
    part_of_speech: "danh từ",
    meaning: "(hiếm) dầu gội: chai nước gội đầu",
    example: "chai nước gội đầu",
  },
  {
    word: "nước hàng",
    part_of_speech: "danh từ",
    meaning:
      "đường được đun cháy rồi cho thêm một ít nước vào, có màu nâu sẫm, dùng để cho vào đồ kho nấu cho thơm và có màu: thắng nước hàng",
    example: "thắng nước hàng",
  },
  {
    word: "nước gạo",
    part_of_speech: "danh từ",
    meaning:
      "nước vo gạo, màu trắng đục, thường được chứa cùng với cơm thừa, canh cặn, v.v., dùng để nuôi lợn: đi xin nước gạo * thùng nước gạo",
    example: "đi xin nước gạo * thùng nước gạo",
  },
  {
    word: "nước hoa",
    part_of_speech: "danh từ",
    meaning:
      "nước thơm chế từ tinh dầu của hoa hay bằng chất hoá học, dùng để bôi, xức cho thơm: xức nước hoa * mùi nước hoa sực nức",
    example: "xức nước hoa * mùi nước hoa sực nức",
  },
  {
    word: "nước lã",
    part_of_speech: "danh từ",
    meaning:
      "nước ngọt tự nhiên, chưa qua đun nấu, xử lí: không uống nước lã * nước lã mà vã nên hồ (tng)",
    example: "không uống nước lã * nước lã mà vã nên hồ (tng)",
  },
  {
    word: "nước lạnh",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) nước lã: đau bụng vì uống nước lạnh",
    example: "đau bụng vì uống nước lạnh",
  },
  {
    word: "nước khoáng",
    part_of_speech: "danh từ",
    meaning:
      "nước ở dưới đất, có chứa nhiều chất khí và ion của các nguyên tố hoá học và hợp chất của chúng: suối nước khoáng * nước khoáng đóng chai",
    example: "suối nước khoáng * nước khoáng đóng chai",
  },
  {
    word: "nước lọc",
    part_of_speech: "danh từ",
    meaning:
      "nước lã đã qua khâu lắng lọc và khử trùng để dùng trong sinh hoạt: nấu ăn bằng nước lọc * bể nước lọc",
    example: "nấu ăn bằng nước lọc * bể nước lọc",
  },
  {
    word: "nước lọc",
    part_of_speech: "danh từ",
    meaning:
      "nước đã được đun sôi, thường để nguội, dùng để uống: uống một cốc nước lọc",
    example: "uống một cốc nước lọc",
  },
  {
    word: "nước lèo",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) nước dùng: nồi nước lèo",
    example: "nồi nước lèo",
  },
  {
    word: "nước lợ",
    part_of_speech: "danh từ",
    meaning:
      "nước pha trộn lẫn nước ngọt và nước mặn, thường có ở vùng cửa sông và một số vùng ven biển; phân biệt với nước ngọt, nước mặn: nghề nuôi cá nước lợ",
    example: "nghề nuôi cá nước lợ",
  },
  {
    word: "nước mặn",
    part_of_speech: "danh từ",
    meaning:
      "nước biển, có vị mặn tự nhiên vì chứa nhiều muối; phân biệt với nước ngọt, nước lợ: cá nước mặn * cánh đồng bị nước mặn xâm nhập",
    example: "cá nước mặn * cánh đồng bị nước mặn xâm nhập",
  },
  {
    word: "nước mẹ",
    part_of_speech: "danh từ",
    meaning: "(thông tục) như nước non: chẳng được cái nước mẹ gì!",
    example: "chẳng được cái nước mẹ gì!",
  },
  {
    word: "nước mắt",
    part_of_speech: "danh từ",
    meaning:
      "nước do tuyến ở mắt tiết ra khi khóc hay khi mắt bị kích thích mạnh: cay chảy cả nước mắt * “Một mình âm ỉ đêm chầy, Đĩa dầu vơi, nước mắt đầy, năm canh.” (TKiều)",
    example:
      "cay chảy cả nước mắt * “Một mình âm ỉ đêm chầy, Đĩa dầu vơi, nước mắt đầy, năm canh.” (TKiều)",
  },
  {
    word: "nước mặn đồng chua",
    part_of_speech: "",
    meaning:
      'như đồng chua nước mặn: "Quê hương anh nước mặn đồng chua, Làng tôi nghèo đất cày lên sỏi đá." (ChHữu; 1)',
    example:
      'Quê hương anh nước mặn đồng chua, Làng tôi nghèo đất cày lên sỏi đá." (ChHữu; 1)',
  },
  {
    word: "nước miếng",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) nước bọt: thèm chảy nước miếng",
    example: "thèm chảy nước miếng",
  },
  {
    word: "nước ngoài",
    part_of_speech: "danh từ",
    meaning:
      "nước không phải là nước của mình, trong quan hệ với nước mình: người nước ngoài * tiếng nước ngoài * ra nước ngoài công tác",
    example: "người nước ngoài * tiếng nước ngoài * ra nước ngoài công tác",
  },
  {
    word: "nước ngầm",
    part_of_speech: "danh từ",
    meaning:
      "nước ở các mạch ngầm sâu trong lòng đất: mạch nước ngầm * khai thác nước ngầm",
    example: "mạch nước ngầm * khai thác nước ngầm",
  },
  {
    word: "nước non",
    part_of_speech: "danh từ",
    meaning:
      '(văn chương) sông nước và núi non; thường dùng để chỉ đất nước, tổ quốc: nước non tươi đẹp * "Chung quanh những nước non người, Đau lòng lưu lạc, nên vài bốn câu." (TKiều)',
    example:
      'nước non tươi đẹp * "Chung quanh những nước non người, Đau lòng lưu lạc, nên vài bốn câu." (TKiều)',
  },
  {
    word: "nước non",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) cái đạt được, cái có nghĩa lí: tốn kém nhiều mà chẳng nước non gì!",
    example: "tốn kém nhiều mà chẳng nước non gì!",
  },
  {
    word: "nước nhà",
    part_of_speech: "danh từ",
    meaning:
      "nước của mình (gọi một cách thân thiết): nước nhà được độc lập * xây dựng nước nhà ngày càng giàu mạnh",
    example: "nước nhà được độc lập * xây dựng nước nhà ngày càng giàu mạnh",
  },
  {
    word: "nước nôi",
    part_of_speech: "danh từ",
    meaning:
      "nước dùng trong sinh hoạt và sản xuất (nói khái quát): nước nôi thiếu thốn * đến rồi đi ngay, chưa kịp nước nôi gì!",
    example: "nước nôi thiếu thốn * đến rồi đi ngay, chưa kịp nước nôi gì!",
  },
  {
    word: "nước ngọt",
    part_of_speech: "danh từ",
    meaning:
      "nước tự nhiên, không có vị mặn, thường ở sông hồ; phân biệt với nước mặn, nước lợ: cá nước ngọt",
    example: "cá nước ngọt",
  },
  {
    word: "nước ngọt",
    part_of_speech: "danh từ",
    meaning:
      "nước giải khát có vị ngọt, nói chung: mua mấy lon nước ngọt * nhà máy sản xuất bia và nước ngọt",
    example: "mua mấy lon nước ngọt * nhà máy sản xuất bia và nước ngọt",
  },
  {
    word: "nước thải",
    part_of_speech: "danh từ",
    meaning:
      "nước đã qua sử dụng, đã loại bỏ sau khi sử dụng: nước thải công nghiệp * hệ thống xử lí nước thải",
    example: "nước thải công nghiệp * hệ thống xử lí nước thải",
  },
  {
    word: "nước rửa bát",
    part_of_speech: "danh từ",
    meaning:
      "xà phòng ở dạng lỏng, được dùng để rửa bát đĩa, cốc chén, v.v.: nước rửa bát hương chanh",
    example: "nước rửa bát hương chanh",
  },
  {
    word: "nước sạch",
    part_of_speech: "danh từ",
    meaning:
      "nước không bị nhiễm bẩn và các chất độc hại, dùng cho đời sống sinh hoạt của con người: nguồn nước sạch * chương trình nước sạch ở nông thôn",
    example: "nguồn nước sạch * chương trình nước sạch ở nông thôn",
  },
  {
    word: "nước rút",
    part_of_speech: "danh từ",
    meaning:
      "sự dồn sức để tăng tốc độ lên mức cao nhất khi gần về đích trong cuộc đua: chạy nước rút * giai đoạn nước rút",
    example: "chạy nước rút * giai đoạn nước rút",
  },
  {
    word: "nước sôi lửa bỏng",
    part_of_speech: "",
    meaning:
      "ví tình thế nguy kịch, cấp bách trước tai hoạ lớn đang trực tiếp đe doạ: tình hình đang nước sôi lửa bỏng",
    example: "tình hình đang nước sôi lửa bỏng",
  },
  {
    word: "nước trắng",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) nước đun sôi để uống; phân biệt với nước trà, nước chè: uống thuốc với nước trắng",
    example: "uống thuốc với nước trắng",
  },
  {
    word: "nước xáo",
    part_of_speech: "danh từ",
    meaning: "như nước xuýt: trăm voi không được bát nước xáo (tng)",
    example: "trăm voi không được bát nước xáo (tng)",
  },
  {
    word: "nước xốt",
    part_of_speech: "danh từ",
    meaning:
      "nước chấm có dạng sền sệt, dùng để chấm hoặc rưới lên trên một số món ăn: nước xốt cà chua * bánh mì rưới nước xốt",
    example: "nước xốt cà chua * bánh mì rưới nước xốt",
  },
  {
    word: "nương",
    part_of_speech: "danh từ",
    meaning: "đất trồng trọt trên vùng đồi núi: phát nương * lúa nương",
    example: "phát nương * lúa nương",
  },
  {
    word: "nương",
    part_of_speech: "danh từ",
    meaning: "bãi cao ven sông: nương dâu",
    example: "nương dâu",
  },
  {
    word: "nương",
    part_of_speech: "động từ",
    meaning:
      "dựa vào để có được sự che chở, giúp đỡ: nương vào nhau mà sống * nương vào thanh thế của cha ông * nương cửa Phật",
    example:
      "nương vào nhau mà sống * nương vào thanh thế của cha ông * nương cửa Phật",
  },
  {
    word: "nương",
    part_of_speech: "động từ",
    meaning:
      "giữ gìn động tác cho nhẹ nhàng, cẩn thận khi cầm nắm, sử dụng, không làm mạnh tay để tránh làm vỡ, gãy, hỏng: nương sức mà làm * nương nhẹ tay",
    example: "nương sức mà làm * nương nhẹ tay",
  },
  {
    word: "nước xuýt",
    part_of_speech: "danh từ",
    meaning: "nước luộc thịt, luộc lòng: nước xuýt gà * nồi nước xuýt",
    example: "nước xuýt gà * nồi nước xuýt",
  },
  {
    word: "nương náu",
    part_of_speech: "động từ",
    meaning:
      "nương nhờ ở nơi nào đó để lánh thân một thời gian: nương náu cửa chùa * tìm nơi nương náu",
    example: "nương náu cửa chùa * tìm nơi nương náu",
  },
  {
    word: "nườm nượp",
    part_of_speech: "tính từ",
    meaning:
      "(di chuyển) đông, nhiều và liên tục, hết lớp này tiếp đến lớp khác: người đi lại nườm nượp * khách đông nườm nượp",
    example: "người đi lại nườm nượp * khách đông nườm nượp",
  },
  {
    word: "nướng",
    part_of_speech: "động từ",
    meaning:
      "làm cho chín bằng cách đặt trực tiếp trên than hồng hoặc lửa: nướng chả * nướng bánh * khoai nướng * lò nướng",
    example: "nướng chả * nướng bánh * khoai nướng * lò nướng",
  },
  {
    word: "nướng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tiêu phí số lượng lớn một cách nhanh chóng, vô ích: đem tiền nướng vào cờ bạc * có bao nhiêu nướng sạch bấy nhiêu",
    example: "đem tiền nướng vào cờ bạc * có bao nhiêu nướng sạch bấy nhiêu",
  },
  {
    word: "nương nhờ",
    part_of_speech: "động từ",
    meaning:
      "dựa vào sự giúp đỡ của người khác (nói khái quát): già yếu, phải nương nhờ vào con cái",
    example: "già yếu, phải nương nhờ vào con cái",
  },
  {
    word: "nương long",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) ngực của người phụ nữ: "Lược trúc chải cài trên mái tóc, Yếm đào trễ xuống dưới nương long." (HXHương; 35)',
    example:
      'Lược trúc chải cài trên mái tóc, Yếm đào trễ xuống dưới nương long." (HXHương; 35)',
  },
  {
    word: "nương nhẹ",
    part_of_speech: "động từ",
    meaning:
      "cầm, giữ nhẹ nhàng để khỏi vỡ, khỏi gãy, khỏi hỏng: chuối chín, nương nhẹ kẻo rụng * cầm lược, nương nhẹ từng nhát chải",
    example:
      "chuối chín, nương nhẹ kẻo rụng * cầm lược, nương nhẹ từng nhát chải",
  },
  {
    word: "nương nhẹ",
    part_of_speech: "động từ",
    meaning:
      "phê bình, nhận xét hoặc xử phạt ở mức nhẹ hơn mức cần phải có, để tránh làm phật ý, tránh sự phản ứng: phê bình nương nhẹ * xử lí nương nhẹ",
    example: "phê bình nương nhẹ * xử lí nương nhẹ",
  },
  {
    word: "nương nương",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) từ dùng để gọi người phụ nữ quyền quý thời phong kiến: hoàng hậu nương nương",
    example: "hoàng hậu nương nương",
  },
  {
    word: "nương rẫy",
    part_of_speech: "danh từ",
    meaning:
      "đất trồng trọt ở miền rừng núi (nói khái quát): phát rừng làm nương rẫy",
    example: "phát rừng làm nương rẫy",
  },
  {
    word: "nương tựa",
    part_of_speech: "động từ",
    meaning:
      "cậy nhờ vào để sống, để tồn tại (nói khái quát): mồ côi, không nơi nương tựa * nương tựa vào nhau mà sống",
    example: "mồ côi, không nơi nương tựa * nương tựa vào nhau mà sống",
  },
  {
    word: "nướu",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) lợi (phần bao quanh chân răng): rụng răng còn nướu",
    example: "rụng răng còn nướu",
  },
  {
    word: "nương tay",
    part_of_speech: "động từ",
    meaning: "như nhẹ tay: cầm nương tay kẻo vỡ * đánh không chút nương tay",
    example: "cầm nương tay kẻo vỡ * đánh không chút nương tay",
  },
  {
    word: "nứt nẻ",
    part_of_speech: "động từ",
    meaning:
      "nứt thành nhiều đường ngang dọc chằng chịt (nói khái quát): mặt ruộng nứt nẻ vì nắng hạn * gót chân nứt nẻ",
    example: "mặt ruộng nứt nẻ vì nắng hạn * gót chân nứt nẻ",
  },
  {
    word: "nứt nanh",
    part_of_speech: "động từ",
    meaning: "(hạt thóc giống) có mầm bắt đầu lộ ra ngoài vỏ: thóc đã nứt nanh",
    example: "thóc đã nứt nanh",
  },
  {
    word: "nứt",
    part_of_speech: "động từ",
    meaning:
      "bị tách thành vệt, thành khe, nhưng chưa rời hẳn ra: mặt gỗ bị nứt * gót chân có nhiều vết nứt",
    example: "mặt gỗ bị nứt * gót chân có nhiều vết nứt",
  },
  {
    word: "nứt",
    part_of_speech: "động từ",
    meaning: "bị tách lớp vỏ bọc ra do mầm rễ trồi lên: hạt cây đã nứt mầm",
    example: "hạt cây đã nứt mầm",
  },
  {
    word: "nứt mắt",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) mới mở mắt, vừa mới sinh ra; thường dùng để nói người còn quá trẻ (hàm ý khinh thường): ranh con, mới nứt mắt mà đã láo!",
    example: "ranh con, mới nứt mắt mà đã láo!",
  },
  {
    word: "nương thân",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) ở nhờ để tìm sự che chở, giúp đỡ: bơ vơ, không chốn nương thân",
    example: "bơ vơ, không chốn nương thân",
  },
  {
    word: "nứt toác",
    part_of_speech: "động từ",
    meaning:
      "nứt thành đường rộng, thành mảng lớn: cây sáo trúc bị nứt toác * mặt bàn nứt toác",
    example: "cây sáo trúc bị nứt toác * mặt bàn nứt toác",
  },
  {
    word: "o bế",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) chăm chút hoặc nâng niu, chiều chuộng quá mức: được cấp trên o bế",
    example: "được cấp trên o bế",
  },
  {
    word: "ó",
    part_of_speech: "động từ",
    meaning: "(Phương ngữ) kêu, la lên một cách ầm ĩ: kêu ó * ó lên như giặc!",
    example: "kêu ó * ó lên như giặc!",
  },
  {
    word: "ọ ẹ",
    part_of_speech: "động từ",
    meaning:
      "từ mô phỏng tiếng trẻ sơ sinh phát ra khi cựa mình thức giấc: đứa trẻ ọ ẹ mấy tiếng rồi lại ngủ",
    example: "đứa trẻ ọ ẹ mấy tiếng rồi lại ngủ",
  },
  {
    word: "o ép",
    part_of_speech: "động từ",
    meaning:
      "bức bách, dồn ép vào thế bí, làm cho buộc phải theo, phải chấp nhận: bị o ép phải ra đi * đừng có o ép người quá đáng!",
    example: "bị o ép phải ra đi * đừng có o ép người quá đáng!",
  },
  {
    word: "o o",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng gà gáy hay tiếng người ngáy, phát ra đều và liên tiếp: ngáy o o",
    example: "ngáy o o",
  },
  {
    word: "nylon",
    part_of_speech: "danh từ",
    meaning:
      "chất dẻo dễ kéo sợi, dùng để dệt vải, dệt lưới, làm chỉ khâu vết thương, v.v.: túi nylon * vải pha nylon",
    example: "túi nylon * vải pha nylon",
  },
  {
    word: "o,o",
    part_of_speech: "danh từ",
    meaning:
      '(phương ngữ) cô: ông chú bà o * "Cách sông nên phải luỵ đò, Tối trời nên phải luỵ o bán dầu." (ca dao)',
    example:
      'ông chú bà o * "Cách sông nên phải luỵ đò, Tối trời nên phải luỵ o bán dầu." (ca dao)',
  },
  {
    word: "o,o",
    part_of_speech: "động từ",
    meaning: "(phương ngữ, khẩu ngữ) tán tỉnh (phụ nữ): o mèo * o gái",
    example: "o mèo * o gái",
  },
  {
    word: "oa trữ",
    part_of_speech: "động từ",
    meaning:
      "(cũ) chứa chấp, cất giấu những thứ bị coi là phi pháp: oa trữ đồ ăn cắp",
    example: "oa trữ đồ ăn cắp",
  },
  {
    word: "oách",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có dáng vẻ bề ngoài trông rất oai và sang trọng: diện thật oách * đi đâu mà oách thế?",
    example: "diện thật oách * đi đâu mà oách thế?",
  },
  {
    word: "oải",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ở trạng thái đã bị duỗi thẳng ra hay trễ xuống, không còn giữ được hình dạng uốn cong như trước: lưỡi câu đã oải",
    example: "lưỡi câu đã oải",
  },
  {
    word: "oải",
    part_of_speech: "tính từ",
    meaning: "mệt rã rời: bắp thịt oải ra * làm oải cả người",
    example: "bắp thịt oải ra * làm oải cả người",
  },
  {
    word: "oa oa",
    part_of_speech: "động từ",
    meaning: "như oe oe: đứa bé oa oa khóc",
    example: "đứa bé oa oa khóc",
  },
  {
    word: "oà",
    part_of_speech: "động từ",
    meaning:
      "đột nhiên bật lên thành tiếng thật to: oà khóc nức nở * cả bọn cười oà lên",
    example: "oà khóc nức nở * cả bọn cười oà lên",
  },
  {
    word: "oà",
    part_of_speech: "động từ",
    meaning: "(hiếm) như ùa: bọn trẻ oà ra sân chơi",
    example: "bọn trẻ oà ra sân chơi",
  },
  {
    word: "oạch",
    part_of_speech: "tính từ",
    meaning: "từ mô phỏng tiếng người ngã mạnh xuống đất: ngã oạch một cái",
    example: "ngã oạch một cái",
  },
  {
    word: "oái",
    part_of_speech: "cảm từ",
    meaning:
      "tiếng thốt to lên khi bị đau bất ngờ hay sợ đột ngột: kêu oái một tiếng",
    example: "kêu oái một tiếng",
  },
  {
    word: "oai hùng",
    part_of_speech: "tính từ",
    meaning:
      "hào hùng, mạnh mẽ, đầy khí thế: những trang sử oai hùng * chiến thắng oai hùng",
    example: "những trang sử oai hùng * chiến thắng oai hùng",
  },
  {
    word: "oai phong",
    part_of_speech: "tính từ",
    meaning:
      "có dáng vẻ thể hiện một uy lực mạnh mẽ, khiến cho người khác phải kính nể: dáng vẻ oai phong * oai phong lẫm liệt",
    example: "dáng vẻ oai phong * oai phong lẫm liệt",
  },
  {
    word: "oai nghiêm",
    part_of_speech: "tính từ",
    meaning: "như uy nghiêm: tướng mạo oai nghiêm",
    example: "tướng mạo oai nghiêm",
  },
  {
    word: "oai nghi",
    part_of_speech: "tính từ",
    meaning:
      "có dáng vẻ chững chạc, bề thế, gợi sự tôn kính: ngôi đền uy nghi * diện mạo uy nghi",
    example: "ngôi đền uy nghi * diện mạo uy nghi",
  },
  {
    word: "oái oăm",
    part_of_speech: "tính từ",
    meaning:
      "trái với bình thường một cách kì quặc: căn bệnh oái oăm * cảnh ngộ oái oăm",
    example: "căn bệnh oái oăm * cảnh ngộ oái oăm",
  },
  {
    word: "oai",
    part_of_speech: "",
    meaning:
      "có dáng vẻ của người có quyền lực khiến cho người ta phải nể sợ: oai trời * diện quân phục trông rất oai * nói vài câu cho oai",
    example: "oai trời * diện quân phục trông rất oai * nói vài câu cho oai",
  },
  {
    word: "oai oái",
    part_of_speech: "cảm từ",
    meaning: "như oái (nhưng ý liên tiếp): kêu oai oái",
    example: "kêu oai oái",
  },
  {
    word: "oai vệ",
    part_of_speech: "tính từ",
    meaning: "có vẻ trang nghiêm, đường bệ: dáng đi rất oai vệ",
    example: "dáng đi rất oai vệ",
  },
  {
    word: "oàm oạp",
    part_of_speech: "tính từ",
    meaning: "như ì oạp: sóng vỗ bờ oàm oạp",
    example: "sóng vỗ bờ oàm oạp",
  },
  {
    word: "oán",
    part_of_speech: "",
    meaning:
      "giận nung nấu trong lòng kẻ đã hại mình: oán đến tận xương tuỷ * làm ơn nên oán (tng)",
    example: "oán đến tận xương tuỷ * làm ơn nên oán (tng)",
  },
  {
    word: "oán cừu",
    part_of_speech: "",
    meaning: "(cũ, hiếm) như oán thù: oán cừu xưa chưa trả",
    example: "oán cừu xưa chưa trả",
  },
  {
    word: "oản",
    part_of_speech: "danh từ",
    meaning:
      "xôi hoặc bột bánh khảo được nén chặt vào khuôn, đóng thành khối nhỏ hình nón cụt để cúng: đóng oản * khư khư như từ giữ oản (tng)",
    example: "đóng oản * khư khư như từ giữ oản (tng)",
  },
  {
    word: "oan",
    part_of_speech: "tính từ",
    meaning:
      "bị quy cho tội mà bản thân không gây nên, phải chịu sự trừng phạt mà bản thân không đáng phải chịu: nghi oan * bị mắng oan * viết đơn kêu oan",
    example: "nghi oan * bị mắng oan * viết đơn kêu oan",
  },
  {
    word: "oán giận",
    part_of_speech: "động từ",
    meaning:
      "căm giận và uất ức: oán giận cảnh ngộ * oán giận kẻ khủng bố bạo tàn",
    example: "oán giận cảnh ngộ * oán giận kẻ khủng bố bạo tàn",
  },
  {
    word: "oán ghét",
    part_of_speech: "động từ",
    meaning: "oán giận và căm ghét: oán ghét bọn giặc đến tận xương tuỷ",
    example: "oán ghét bọn giặc đến tận xương tuỷ",
  },
  {
    word: "oán hận",
    part_of_speech: "động từ",
    meaning:
      "căm giận sâu sắc, chất chứa trong lòng: lòng dân oán hận * không oán hận điều gì",
    example: "lòng dân oán hận * không oán hận điều gì",
  },
  {
    word: "oan khiên",
    part_of_speech: "tính từ",
    meaning: "(cũ) như oan ức: nỗi oan khiên",
    example: "nỗi oan khiên",
  },
  {
    word: "oán hờn",
    part_of_speech: "động từ",
    meaning:
      "uất ức và oán giận sâu sắc, nung nấu trong lòng: oán hờn kẻ bán nước * ánh mắt oán hờn",
    example: "oán hờn kẻ bán nước * ánh mắt oán hờn",
  },
  {
    word: "oan khổ",
    part_of_speech: "",
    meaning:
      'đau khổ vì bị oan ức: chịu biết bao oan khổ * "Những là oan khổ lưu ly, Chờ cho hết kiếp, còn gì là thân?" (TKiều)',
    example:
      'chịu biết bao oan khổ * "Những là oan khổ lưu ly, Chờ cho hết kiếp, còn gì là thân?" (TKiều)',
  },
  {
    word: "oan gia",
    part_of_speech: "danh từ",
    meaning:
      "tai vạ ở đâu bỗng dưng phải gánh chịu một cách oan uổng: chơi với nó có ngày oan gia",
    example: "chơi với nó có ngày oan gia",
  },
  {
    word: "oan nghiệt",
    part_of_speech: "danh từ",
    meaning: "như oan trái: chịu bao oan nghiệt",
    example: "chịu bao oan nghiệt",
  },
  {
    word: "oan khốc",
    part_of_speech: "tính từ",
    meaning:
      '(cũ) như oan khổ: "Búa rìu bao quản thân tàn, Nỡ đày đoạ trẻ, càng oan khốc già." (TKiều)',
    example:
      'Búa rìu bao quản thân tàn, Nỡ đày đoạ trẻ, càng oan khốc già." (TKiều)',
  },
  {
    word: "oán thù",
    part_of_speech: "",
    meaning:
      '(hiếm) như thù oán: gây oán thù * "Gẫm mình chưa mấy xuân thu, Sầu vương đã chịu, oán thù đã mang." (ca dao)',
    example:
      'gây oán thù * "Gẫm mình chưa mấy xuân thu, Sầu vương đã chịu, oán thù đã mang." (ca dao)',
  },
  {
    word: "oan khuất",
    part_of_speech: "tính từ",
    meaning: "oan mà không thể giãi bày ra được: nỗi oan khuất * bị oan khuất",
    example: "nỗi oan khuất * bị oan khuất",
  },
  {
    word: "oàng",
    part_of_speech: "danh từ",
    meaning:
      "từ mô phỏng tiếng nổ to và âm vang như tiếng súng đại bác: nổ đánh oàng một cái",
    example: "nổ đánh oàng một cái",
  },
  {
    word: "oán thán",
    part_of_speech: "động từ",
    meaning:
      "oán giận, biểu hiện ra bằng những lời ta thán vì không thể kìm nén được trong lòng: lời oán thán * dù cực khổ cũng không oán thán",
    example: "lời oán thán * dù cực khổ cũng không oán thán",
  },
  {
    word: "oan uổng",
    part_of_speech: "tính từ",
    meaning:
      "như oan (nhưng nghĩa mạnh hơn; nói khái quát): chết oan uổng * phạt như vậy thì oan uổng quá!",
    example: "chết oan uổng * phạt như vậy thì oan uổng quá!",
  },
  {
    word: "oán trách",
    part_of_speech: "động từ",
    meaning:
      "tức giận, biểu hiện ra bằng những lời trách móc: giọng oán trách * oán trách tạo vật",
    example: "giọng oán trách * oán trách tạo vật",
  },
  {
    word: "oan ức",
    part_of_speech: "tính từ",
    meaning:
      "oan đến mức cảm thấy uất ức mà không làm gì được: nỗi oan ức * bị kết tội một cách oan ức",
    example: "nỗi oan ức * bị kết tội một cách oan ức",
  },
  {
    word: "oan trái",
    part_of_speech: "tính từ",
    meaning:
      "(văn chương) ngang trái khiến cho phải đau khổ, bất hạnh: mối tình oan trái * lâm vào cảnh ngộ oan trái",
    example: "mối tình oan trái * lâm vào cảnh ngộ oan trái",
  },
  {
    word: "oanh",
    part_of_speech: "danh từ",
    meaning:
      '(văn chương) chim vàng anh, về mặt có tiếng hót hay: "Lơ thơ tơ liễu buông mành, Con oanh học nói trên cành mỉa mai." (TKiều)',
    example:
      'Lơ thơ tơ liễu buông mành, Con oanh học nói trên cành mỉa mai." (TKiều)',
  },
  {
    word: "oang oác",
    part_of_speech: "",
    meaning:
      "từ mô phỏng tiếng gà kêu to khi gặp nguy hiểm: tiếng gà kêu oang oác",
    example: "tiếng gà kêu oang oác",
  },
  {
    word: "oang oác",
    part_of_speech: "",
    meaning: "(khẩu ngữ) như oang oang (nhưng nghĩa mạnh hơn): giọng oang oác",
    example: "giọng oang oác",
  },
  {
    word: "oang oang",
    part_of_speech: "",
    meaning:
      "từ gợi tả âm thanh phát ra to và vang xa một cách liên tiếp: cười nói oang oang",
    example: "cười nói oang oang",
  },
  {
    word: "oành oạch",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng ngã mạnh và liên tiếp xuống nền đất: đường trơn nên trượt ngã oành oạch",
    example: "đường trơn nên trượt ngã oành oạch",
  },
  {
    word: "oanh tạc",
    part_of_speech: "động từ",
    meaning:
      "dùng hoả lực mạnh như ném bom, bắn pháo lớn để đánh phá: trận oanh tạc * bệnh viện bị máy bay oanh tạc",
    example: "trận oanh tạc * bệnh viện bị máy bay oanh tạc",
  },
  {
    word: "oanh liệt",
    part_of_speech: "tính từ",
    meaning:
      "có tiếng tăm lừng lẫy, vang dội khắp nơi: chiến công oanh liệt * thời oanh liệt",
    example: "chiến công oanh liệt * thời oanh liệt",
  },
  {
    word: "oằn oại",
    part_of_speech: "động từ",
    meaning:
      "vặn mình qua lại, cong người lên rồi lại gập mình xuống vì quá đau đớn: đau bụng oằn oại",
    example: "đau bụng oằn oại",
  },
  {
    word: "oằn",
    part_of_speech: "",
    meaning:
      "bị cong hẳn đi, thường do phải chịu một lực quá lớn: cành bưởi bị oằn vì sai quả * gánh nặng oằn cả vai * oằn người đi vì đau đớn",
    example:
      "cành bưởi bị oằn vì sai quả * gánh nặng oằn cả vai * oằn người đi vì đau đớn",
  },
  {
    word: "oằn èo",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) như ngoằn ngoèo: một vệt pháo sáng oằn èo trên nền trời đêm",
    example: "một vệt pháo sáng oằn èo trên nền trời đêm",
  },
  {
    word: "oắt con",
    part_of_speech: "",
    meaning:
      "bé, bé con (hàm ý bông đùa hoặc coi thường): thằng oắt con * ê, oắt con, lại đây tao bảo!",
    example: "thằng oắt con * ê, oắt con, lại đây tao bảo!",
  },
  {
    word: "oắt",
    part_of_speech: "",
    meaning: "như oắt con: này oắt, mày là con cái nhà ai?",
    example: "này oắt, mày là con cái nhà ai?",
  },
  {
    word: "oặt",
    part_of_speech: "",
    meaning:
      "bị cong gập xuống vì phải chịu một lực quá lớn: cành cậy oặt gần mặt nước * gánh nặng oặt cả đòn gánh",
    example: "cành cậy oặt gần mặt nước * gánh nặng oặt cả đòn gánh",
  },
  {
    word: "oặt ẹo",
    part_of_speech: "tính từ",
    meaning:
      "mềm yếu, yếu ớt đến mức như không thể nào tự giữ thẳng được: thân cây oặt ẹo",
    example: "thân cây oặt ẹo",
  },
  {
    word: "óc",
    part_of_speech: "danh từ",
    meaning:
      "khối mềm màu trắng đục ở trong hộp sọ, là cơ sở của hoạt động thần kinh trung ương: mổ lấy máu bầm trong óc * tổn thương óc",
    example: "mổ lấy máu bầm trong óc * tổn thương óc",
  },
  {
    word: "óc",
    part_of_speech: "danh từ",
    meaning:
      "óc của con người, được coi là biểu tượng của khả năng suy nghĩ, nhận thức (nói khái quát): giàu óc sáng tạo * có óc thẩm mĩ",
    example: "giàu óc sáng tạo * có óc thẩm mĩ",
  },
  {
    word: "óc",
    part_of_speech: "danh từ",
    meaning:
      "ý thức, tư tưởng của mỗi người (nói khái quát): óc cổ hủ * óc tư hữu",
    example: "óc cổ hủ * óc tư hữu",
  },
  {
    word: "óc ách",
    part_of_speech: "tính từ",
    meaning:
      "(bụng) ở trạng thái đầy ứ vì chứa nhiều nước, gây cảm giác khó chịu: bụng óc ách khó chịu",
    example: "bụng óc ách khó chịu",
  },
  {
    word: "óc ách",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng như tiếng nước chuyển động trong vật chứa khi bị nhồi lắc: tiếng suối chảy óc ách",
    example: "tiếng suối chảy óc ách",
  },
  {
    word: "ọc",
    part_of_speech: "động từ",
    meaning: "như ộc: nôn ọc ra",
    example: "nôn ọc ra",
  },
  {
    word: "ọc ạch",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (xe cộ, máy móc) ở tình trạng sắp hư hỏng do các bộ phận bị lỏng ra, không còn khớp chặt với nhau, khi chạy phát ra tiếng kêu không êm, không đều: chiếc xe bò ọc ạch leo dốc",
    example: "chiếc xe bò ọc ạch leo dốc",
  },
  {
    word: "oẹ",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) nôn, mửa: bé vừa ăn xong lại oẹ ra",
    example: "bé vừa ăn xong lại oẹ ra",
  },
  {
    word: "oe",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) từ mô phỏng tiếng khóc to của trẻ sơ sinh: chốc chốc, đứa bé lại oe lên một tiếng",
    example: "chốc chốc, đứa bé lại oe lên một tiếng",
  },
  {
    word: "oda",
    part_of_speech: "danh từ",
    meaning:
      "(A: Official Development Assistance, viết tắt) viện trợ phát triển chính thức: quản lí nguồn vốn ODA",
    example: "quản lí nguồn vốn ODA",
  },
  {
    word: "oẻ hoẹ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ, hiếm) chê bai, bắt bẻ hết cái này đến cái khác: oẻ hoẹ hết cái này đến cái khác",
    example: "oẻ hoẹ hết cái này đến cái khác",
  },
  {
    word: "oẻ",
    part_of_speech: "",
    meaning:
      "cong trĩu xuống, thường do bị đè nặng: cành cây sai trái, ẻo xuống",
    example: "cành cây sai trái, ẻo xuống",
  },
  {
    word: "óc bã đậu",
    part_of_speech: "danh từ",
    meaning:
      "(thông tục) đầu óc ngu đần, chẳng được tích sự gì (ví như bã đậu là thứ còn lại sau khi chế biến đậu phụ, chỉ dùng làm thức ăn cho lợn; thường dùng làm tiếng chửi rủa): đồ óc bã đậu!",
    example: "đồ óc bã đậu!",
  },
  {
    word: "oe oe",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng khóc to và liên tiếp của trẻ sơ sinh: tiếng trẻ con khóc oe oe",
    example: "tiếng trẻ con khóc oe oe",
  },
  {
    word: "oe oé",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng trẻ con kêu hoặc khóc to và liên tiếp, nghe chói tai: kêu oe oé",
    example: "kêu oe oé",
  },
  {
    word: "oi",
    part_of_speech: "tính từ",
    meaning:
      "(thời tiết) rất nóng và ẩm, lặng gió, khiến cơ thể khó toả nhiệt, gây cảm giác bức bối khó chịu: trời oi quá, chắc lại sắp mưa",
    example: "trời oi quá, chắc lại sắp mưa",
  },
  {
    word: "oi ả",
    part_of_speech: "tính từ",
    meaning: "oi (nói khái quát): trưa hè oi ả * tiết trời oi ả",
    example: "trưa hè oi ả * tiết trời oi ả",
  },
  {
    word: "oi khói",
    part_of_speech: "tính từ",
    meaning:
      "có mùi hơi hôi như mùi của khói, do bị khói ùa vào nồi khi đun nấu: cơm bị oi khói",
    example: "cơm bị oi khói",
  },
  {
    word: "ói",
    part_of_speech: "động từ",
    meaning: "(Phương ngữ) nôn, mửa: bị ói vì say xe",
    example: "bị ói vì say xe",
  },
  {
    word: "oi bức",
    part_of_speech: "tính từ",
    meaning:
      "oi một cách ngột ngạt (nói khái quát): trời oi bức, không có lấy một ngọn gió",
    example: "trời oi bức, không có lấy một ngọn gió",
  },
  {
    word: "ok",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tiếng dùng để trả lời, tỏ sự đồng tình, đồng ý: ô kê, tốt lắm! * tưởng gì chứ việc đó thì ô kê ngay!",
    example: "ô kê, tốt lắm! * tưởng gì chứ việc đó thì ô kê ngay!",
  },
  {
    word: "olympic",
    part_of_speech: "danh từ",
    meaning:
      "đại hội thể dục thể thao quốc tế, dành riêng cho các vận động viên nghiệp dư, thường tổ chức bốn năm một lần: vô địch olympic",
    example: "vô địch olympic",
  },
  {
    word: "òi ọp",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) yếu ớt, hay đau ốm luôn (thường nói về trẻ con): đứa trẻ òi ọp quanh năm",
    example: "đứa trẻ òi ọp quanh năm",
  },
  {
    word: "ỏm",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như om: la hét ỏm cả lên",
    example: "la hét ỏm cả lên",
  },
  {
    word: "ỏm tỏi",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ầm ĩ đến náo loạn, gây cảm giác khó chịu: cãi nhau ỏm tỏi",
    example: "cãi nhau ỏm tỏi",
  },
  {
    word: "om sòm",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) ầm ĩ, gây náo động: quát tháo om sòm * cãi cọ om sòm",
    example: "quát tháo om sòm * cãi cọ om sòm",
  },
  {
    word: "ỏn a ỏn ẻn",
    part_of_speech: "tính từ",
    meaning: "rất ỏn ẻn, gây cảm giác khó chịu: giọng ỏn a ỏn ẻn như con gái",
    example: "giọng ỏn a ỏn ẻn như con gái",
  },
  {
    word: "óng",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) sợi dây vòng dưới cổ trâu bò để giữ ách: tháo óng cho trâu",
    example: "tháo óng cho trâu",
  },
  {
    word: "óng",
    part_of_speech: "tính từ",
    meaning: "bóng, mượt và đẹp: cuộn tơ vàng óng * tóc đen óng",
    example: "cuộn tơ vàng óng * tóc đen óng",
  },
  {
    word: "ỏn ẻn",
    part_of_speech: "tính từ",
    meaning:
      "(cách nói, giọng nói) nhỏ nhẻ và uốn éo, có vẻ điệu đà: giọng nói ỏn ẻn",
    example: "giọng nói ỏn ẻn",
  },
  {
    word: "ong",
    part_of_speech: "danh từ",
    meaning:
      "côn trùng cánh màng, có ngòi đốt ở đuôi, thường sống thành đàn, một số loài hút mật hoa để làm mật: ong hút mật * nuôi ong tay áo (tng)",
    example: "ong hút mật * nuôi ong tay áo (tng)",
  },
  {
    word: "ỏn thót",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nói nhỏ nhẹ, khéo léo để nịnh nọt hoặc để gièm pha: tính hay ỏn thót * ỏn thót với cấp trên",
    example: "tính hay ỏn thót * ỏn thót với cấp trên",
  },
  {
    word: "ỏng",
    part_of_speech: "tính từ",
    meaning:
      "(bụng) phình to không bình thường, do có bệnh: bụng ỏng đít beo (tng)",
    example: "bụng ỏng đít beo (tng)",
  },
  {
    word: "óng ả",
    part_of_speech: "tính từ",
    meaning: "bóng mượt và mềm mại: mái tóc dài óng ả",
    example: "mái tóc dài óng ả",
  },
  {
    word: "óng ả",
    part_of_speech: "tính từ",
    meaning:
      '(hiếm) mềm mại, tha thướt: tấm thân óng ả * "Cô kia óng ả làm chi, Để cho anh nọ tin đi mối về." (ca dao)',
    example:
      'tấm thân óng ả * "Cô kia óng ả làm chi, Để cho anh nọ tin đi mối về." (ca dao)',
  },
  {
    word: "óng ánh",
    part_of_speech: "",
    meaning:
      'phản chiếu ánh sáng lấp lánh, trông đẹp mắt: sợi kim tuyến óng ánh * "(...) những lá đề tròn mà dài cuống nhuộm ánh trăng lấp lánh, óng ánh trên nền trời trong." (THoài; 34)',
    example:
      'sợi kim tuyến óng ánh * "(...) những lá đề tròn mà dài cuống nhuộm ánh trăng lấp lánh, óng ánh trên nền trời trong." (THoài; 34)',
  },
  {
    word: "óng chuốt",
    part_of_speech: "tính từ",
    meaning: "sáng bóng lên như được mài, chuốt kĩ: sợi tơ óng chuốt",
    example: "sợi tơ óng chuốt",
  },
  {
    word: "õng ẹo",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) từ gợi tả dáng điệu, cách nói năng uốn éo để làm nũng hoặc làm duyên (hàm ý chê): điệu bộ õng ẹo * bước đi õng ẹo",
    example: "điệu bộ õng ẹo * bước đi õng ẹo",
  },
  {
    word: "ong bướm",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) ong và bướm; dùng để chỉ kẻ chơi bời, ve vãn phụ nữ: đưa lời ong bướm * "Êm đềm trướng rủ màn che, Tường đông ong bướm đi về mặc ai." (TKiều)',
    example:
      'đưa lời ong bướm * "Êm đềm trướng rủ màn che, Tường đông ong bướm đi về mặc ai." (TKiều)',
  },
  {
    word: "óng mượt",
    part_of_speech: "tính từ",
    meaning: "sáng bóng lên một cách mượt mà, mềm mại: mái tóc dài óng mượt",
    example: "mái tóc dài óng mượt",
  },
  {
    word: "ong óng",
    part_of_speech: "tính từ",
    meaning: "hơi bóng mượt, trông thích mắt: tơ vàng ong óng",
    example: "tơ vàng ong óng",
  },
  {
    word: "òng ọc",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng nước bị khuấy động mạnh ở chỗ bị dồn, ứ lại: bụng sôi òng ọc * tiếng súc miệng òng ọc",
    example: "bụng sôi òng ọc * tiếng súc miệng òng ọc",
  },
  {
    word: "online",
    part_of_speech: "tính từ",
    meaning:
      "(máy tính) ở trong trạng thái được kết nối và thâm nhập trực tiếp vào một mạng máy tính; phân biệt với ngoại tuyến: đường truyền trực tuyến * truy cập trực tuyến * tra từ điển trực tuyến",
    example:
      "đường truyền trực tuyến * truy cập trực tuyến * tra từ điển trực tuyến",
  },
  {
    word: "online",
    part_of_speech: "tính từ",
    meaning:
      "(tin tức, âm thanh, hình ảnh, v.v.) được cung cấp trực tiếp trên mạng Internet đồng thời hoặc ngay sau khi xảy ra một sự kiện nào đó: trả lời trực tuyến về công tác tuyển sinh",
    example: "trả lời trực tuyến về công tác tuyển sinh",
  },
  {
    word: "óp",
    part_of_speech: "tính từ",
    meaning: "lép, teo hoặc không chắc thịt, không mẩy: cua óp * lạc óp",
    example: "cua óp * lạc óp",
  },
  {
    word: "ọp ẹp",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái đã hư hỏng nhiều, đến mức các bộ phận trở nên lỏng lẻo, không còn gắn chặt với nhau, dễ sụp đổ: bộ bàn ghế ọp ẹp * chiếc thuyền nan ọp ẹp",
    example: "bộ bàn ghế ọp ẹp * chiếc thuyền nan ọp ẹp",
  },
  {
    word: "ọp à ọp ẹp",
    part_of_speech: "tính từ",
    meaning: "rất ọp ẹp: cái chõng tre ọp à ọp ẹp",
    example: "cái chõng tre ọp à ọp ẹp",
  },
  {
    word: "organ",
    part_of_speech: "danh từ",
    meaning: "đàn phím điện tử: chơi organ",
    example: "chơi organ",
  },
  {
    word: "ót",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ) gáy: tóc búi sau ót",
    example: "tóc búi sau ót",
  },
  {
    word: "ổ",
    part_of_speech: "danh từ",
    meaning:
      "chỗ có lót và quây rơm rác để nằm hay để đẻ, thường là của một số loài vật: ổ rơm * gà nhảy ổ",
    example: "ổ rơm * gà nhảy ổ",
  },
  {
    word: "ổ",
    part_of_speech: "danh từ",
    meaning:
      "đàn động vật con mới sinh trong cùng một ổ: ổ chó có ba con * mua cả ổ lợn",
    example: "ổ chó có ba con * mua cả ổ lợn",
  },
  {
    word: "ổ",
    part_of_speech: "danh từ",
    meaning:
      "nơi tụ tập, ẩn náu của những kẻ chuyên làm việc phi pháp; cũng dùng để chỉ nhóm người làm việc phi pháp có tổ chức: ổ cướp * ổ cờ bạc * một ổ lưu manh",
    example: "ổ cướp * ổ cờ bạc * một ổ lưu manh",
  },
  {
    word: "ổ",
    part_of_speech: "danh từ",
    meaning:
      "nơi tập trung chứa đựng nguồn gốc bệnh tật: ổ dịch bệnh * ổ vi trùng",
    example: "ổ dịch bệnh * ổ vi trùng",
  },
  {
    word: "ổ",
    part_of_speech: "danh từ",
    meaning:
      "nơi được bố trí tập trung lực lượng chiến đấu đánh địch: rơi vào ổ phục kích",
    example: "rơi vào ổ phục kích",
  },
  {
    word: "ổ",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ) chiếc (bánh mì): ổ bánh mì",
    example: "ổ bánh mì",
  },
  {
    word: "ố",
    part_of_speech: "tính từ",
    meaning:
      "có vết loang lổ và xỉn màu, khó tẩy rửa (thường nói về giấy, vải): tấm ảnh đã bị ố vàng * chiếc áo có nhiều vết ố",
    example: "tấm ảnh đã bị ố vàng * chiếc áo có nhiều vết ố",
  },
  {
    word: "ồ ạt",
    part_of_speech: "tính từ",
    meaning:
      "mạnh, nhanh, dồn dập, và không có trật tự: đê vỡ, nước ồ ạt tràn vào * làn sóng di cư ồ ạt",
    example: "đê vỡ, nước ồ ạt tràn vào * làn sóng di cư ồ ạt",
  },
  {
    word: "ồ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) như ùa: nước ồ vào thuyền * bọn trẻ chạy ồ ra khỏi lớp",
    example: "nước ồ vào thuyền * bọn trẻ chạy ồ ra khỏi lớp",
  },
  {
    word: "ồ",
    part_of_speech: "cảm từ",
    meaning:
      "tiếng thốt ra biểu lộ cảm xúc ngạc nhiên, bất ngờ hoặc khi sực nhớ ra điều gì: ồ, đẹp quá! * mọi người cùng ồ lên kinh ngạc",
    example: "ồ, đẹp quá! * mọi người cùng ồ lên kinh ngạc",
  },
  {
    word: "ổ bụng",
    part_of_speech: "danh từ",
    meaning:
      "khoang bụng nằm dưới cơ hoành, nơi chứa dạ dày, ruột và các cơ quan tiêu hoá khác: siêu âm ổ bụng",
    example: "siêu âm ổ bụng",
  },
  {
    word: "ô",
    part_of_speech: "danh từ",
    meaning: "(Từ cũ, Văn chương) kim ô (nói tắt): vừng ô",
    example: "vừng ô",
  },
  {
    word: "ô",
    part_of_speech: "danh từ",
    meaning:
      "(Nam dù) đồ dùng để che mưa nắng, có cán cầm gắn với khung lợp vải có thể giương ra cụp vào: giương ô * mang theo ô kẻo nắng",
    example: "giương ô * mang theo ô kẻo nắng",
  },
  {
    word: "ô",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) kẻ cấp trên có thế lực, có thể che chở, làm chỗ dựa cho kẻ cấp dưới, nói trong quan hệ với kẻ cấp dưới đó: cậy mình có ô to",
    example: "cậy mình có ô to",
  },
  {
    word: "ô",
    part_of_speech: "danh từ",
    meaning:
      "khoảng nhỏ vuông vắn được phân chia ngăn cách ra trên bề mặt của vật: ô cửa sổ * giấy kẻ ô * áo sơ mi kẻ ô",
    example: "ô cửa sổ * giấy kẻ ô * áo sơ mi kẻ ô",
  },
  {
    word: "ô",
    part_of_speech: "danh từ",
    meaning:
      "khu vực bên ngoài thành Thăng Long thời xưa: năm cửa ô * ô Cầu Dền",
    example: "năm cửa ô * ô Cầu Dền",
  },
  {
    word: "ô",
    part_of_speech: "cảm từ",
    meaning: "như ơ: ô, sao lại thế?",
    example: "ô, sao lại thế?",
  },
  {
    word: "ổ chuột",
    part_of_speech: "",
    meaning:
      "nhà ở chui rúc, chật hẹp và bẩn thỉu (tựa như hang ổ của chuột): khu nhà ổ chuột",
    example: "khu nhà ổ chuột",
  },
  {
    word: "ổ cứng",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) ổ đĩa cứng (nói tắt): máy bị hỏng ổ cứng",
    example: "máy bị hỏng ổ cứng",
  },
  {
    word: "ô danh",
    part_of_speech: "tính từ",
    meaning:
      '(cũ) xấu xa với người đời; phải chịu mang tiếng xấu: làm ô danh dòng họ * "Tuồng chi là giống hôi tanh, Thân nghìn vàng để ô danh má hồng." (TKiều)',
    example:
      'làm ô danh dòng họ * "Tuồng chi là giống hôi tanh, Thân nghìn vàng để ô danh má hồng." (TKiều)',
  },
  {
    word: "ô dù",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) kẻ cấp trên che chở cho kẻ cấp dưới làm càn, trong quan hệ với kẻ cấp dưới đó (nói khái quát): cậy có ô dù nên không coi ai ra gì",
    example: "cậy có ô dù nên không coi ai ra gì",
  },
  {
    word: "ổ đề kháng",
    part_of_speech: "danh từ",
    meaning:
      "điểm chốt vững chắc để chống lại khi đối phương thọc sâu vào khu vực phòng ngự: tiêu diệt ổ đề kháng của địch",
    example: "tiêu diệt ổ đề kháng của địch",
  },
  {
    word: "ổ đọc",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) ổ để đọc băng, đĩa, nói chung: ổ đọc đĩa CD * ổ đọc băng từ",
    example: "ổ đọc đĩa CD * ổ đọc băng từ",
  },
  {
    word: "ổ cắm",
    part_of_speech: "danh từ",
    meaning: "bộ phận để cắm phích điện: kiểm tra ổ cắm",
    example: "kiểm tra ổ cắm",
  },
  {
    word: "ồ ề",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả giọng nói trầm, nặng, không rõ, không gọn và rề rà: giọng nói ồ ề",
    example: "giọng nói ồ ề",
  },
  {
    word: "ổ gà",
    part_of_speech: "danh từ",
    meaning: "chỗ mặt đường bị lở, lõm sâu xuống giống như ổ của gà: lấp ổ gà",
    example: "lấp ổ gà",
  },
  {
    word: "ô hợp",
    part_of_speech: "tính từ",
    meaning:
      "(tập hợp người) táp nham, không có tổ chức, không có kỉ luật gì (ví như một bầy quạ): hạng người ô hợp",
    example: "hạng người ô hợp",
  },
  {
    word: "ộ ệ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) từ gợi tả dáng nặng nề, đi lại rất khó nhọc của người có chửa: bụng chửa ộ ệ",
    example: "bụng chửa ộ ệ",
  },
  {
    word: "ô hay",
    part_of_speech: "cảm từ",
    meaning:
      "tiếng thốt ra biểu lộ sự ngạc nhiên, tỏ ý không hài lòng: ô hay, sao lại làm như thế?",
    example: "ô hay, sao lại làm như thế?",
  },
  {
    word: "ổ khoá",
    part_of_speech: "danh từ",
    meaning: "khoá dùng để lắp chìm vào cửa, tủ: ổ khoá bị hóc",
    example: "ổ khoá bị hóc",
  },
  {
    word: "ô lại",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) nha lại tham nhũng thời phong kiến, thực dân: tham quan ô lại",
    example: "tham quan ô lại",
  },
  {
    word: "ô kìa",
    part_of_speech: "cảm từ",
    meaning:
      "tiếng thốt ra biểu lộ sự ngạc nhiên cao độ: ô kìa cái anh này, làm gì thế hả?",
    example: "ô kìa cái anh này, làm gì thế hả?",
  },
  {
    word: "ô mai",
    part_of_speech: "danh từ",
    meaning:
      "quả mơ ướp đường hoặc muối rồi phơi khô, để ăn hoặc làm thuốc; cũng dùng để chỉ một số loại quả được chế biến theo cách đó: ô mai mơ * làm ô mai sấu",
    example: "ô mai mơ * làm ô mai sấu",
  },
  {
    word: "ô kê",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tiếng dùng để trả lời, tỏ sự đồng tình, đồng ý: ô kê, tốt lắm! * tưởng gì chứ việc đó thì ô kê ngay!",
    example: "ô kê, tốt lắm! * tưởng gì chứ việc đó thì ô kê ngay!",
  },
  {
    word: "ổ nhóm",
    part_of_speech: "danh từ",
    meaning:
      "nhóm hoạt động phi pháp ở những địa bàn nhất định (nói khái quát): triệt phá những ổ nhóm buôn lậu ma tuý",
    example: "triệt phá những ổ nhóm buôn lậu ma tuý",
  },
  {
    word: "ô liu",
    part_of_speech: "danh từ",
    meaning:
      "cây to hoặc nhỡ mọc ở miền ôn đới, thân có nhiều mấu, lá hình ngọn giáo, mặt trên lục nhạt, mặt dưới trắng nhạt, quả ăn được hoặc để ép lấy dầu: dầu ô liu",
    example: "dầu ô liu",
  },
  {
    word: "ô nhiễm",
    part_of_speech: "động từ",
    meaning:
      "nhiễm bẩn tới mức có thể gây độc hại: ô nhiễm môi trường * mạch nước bị ô nhiễm nặng",
    example: "ô nhiễm môi trường * mạch nước bị ô nhiễm nặng",
  },
  {
    word: "ổ mềm",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) ổ đĩa mềm (nói tắt): khởi động máy từ ổ mềm",
    example: "khởi động máy từ ổ mềm",
  },
  {
    word: "ồ ồ",
    part_of_speech: "tính từ",
    meaning: "từ mô phỏng tiếng nước chảy nhiều và mạnh: nước chảy ồ ồ",
    example: "nước chảy ồ ồ",
  },
  {
    word: "ồ ồ",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả giọng nói, âm thanh to và trầm: tự nhiên lại ồ ồ lên khóc * giọng nói ồ ồ",
    example: "tự nhiên lại ồ ồ lên khóc * giọng nói ồ ồ",
  },
  {
    word: "ô nhục",
    part_of_speech: "tính từ",
    meaning: "xấu xa, nhục nhã: nỗi ô nhục * thân thể bị ô nhục",
    example: "nỗi ô nhục * thân thể bị ô nhục",
  },
  {
    word: "ổ trâu",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) chỗ lõm sâu trên mặt đường, lớn hơn ổ gà, khiến đi lại khó khăn: mặt đường toàn ổ gà, ổ trâu",
    example: "mặt đường toàn ổ gà, ổ trâu",
  },
  {
    word: "ô uế",
    part_of_speech: "tính từ",
    meaning: "bẩn thỉu, nhơ nhớp: tấm thân ô uế * làm ô uế thanh danh",
    example: "tấm thân ô uế * làm ô uế thanh danh",
  },
  {
    word: "ô trọc",
    part_of_speech: "tính từ",
    meaning:
      '(văn chương) xấu xa, nhơ bẩn: miệng đời ô trọc * "Đêm đêm lại hỏi trời già, Thân này ô trọc hay là thanh cao?" (TTK)',
    example:
      'miệng đời ô trọc * "Đêm đêm lại hỏi trời già, Thân này ô trọc hay là thanh cao?" (TTK)',
  },
  {
    word: "bó giò",
    part_of_speech: "động từ",
    meaning: "(hiếm) như bó gối: bó giò suy nghĩ",
    example: "bó giò suy nghĩ",
  },
  {
    word: "bó gối",
    part_of_speech: "động từ",
    meaning:
      "(tư thế ngồi) co gập hai chân, hai tay vòng ra ôm lấy đầu gối (thường trong khi phải suy nghĩ): ngồi bó gối",
    example: "ngồi bó gối",
  },
  {
    word: "bọ gậy",
    part_of_speech: "danh từ",
    meaning: "ấu trùng muỗi, sống ở dưới nước: diệt bọ gậy",
    example: "diệt bọ gậy",
  },
  {
    word: "bỏ hoang",
    part_of_speech: "động từ",
    meaning:
      "(ruộng đất, nhà cửa) bỏ không trồng trọt, không sử dụng đến trong một thời gian dài: đất bỏ hoang * ngôi nhà bỏ hoang * vườn bỏ hoang cho cỏ mọc",
    example: "đất bỏ hoang * ngôi nhà bỏ hoang * vườn bỏ hoang cho cỏ mọc",
  },
  {
    word: "bó hẹp",
    part_of_speech: "động từ",
    meaning:
      "thu hẹp, hạn chế phạm vi: bài thi bó hẹp trong phạm vi sách giáo khoa",
    example: "bài thi bó hẹp trong phạm vi sách giáo khoa",
  },
  {
    word: "bò lê bò càng",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) bò, lết mà di chuyển, không đứng dậy nổi, thường vì đau quá hoặc say quá: bị đánh đến bò lê bò càng",
    example: "bị đánh đến bò lê bò càng",
  },
  {
    word: "bỏ lửng",
    part_of_speech: "động từ",
    meaning: "buông lửng xuống nửa chừng: tóc bỏ lửng ra sau",
    example: "tóc bỏ lửng ra sau",
  },
  {
    word: "bỏ lửng",
    part_of_speech: "động từ",
    meaning:
      "để dở dang, không bỏ hẳn nhưng cũng không tiếp tục nữa: bỏ lửng câu nói * công trình bị bỏ lửng giữa chừng",
    example: "bỏ lửng câu nói * công trình bị bỏ lửng giữa chừng",
  },
  {
    word: "bỏ mạng",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) mất mạng, chết (hàm ý khinh): bỏ mạng ngoài chiến trường",
    example: "bỏ mạng ngoài chiến trường",
  },
  {
    word: "bỏ mẹ",
    part_of_speech: "",
    meaning:
      "(thông tục) tổ hợp biểu thị ý chửi rủa, hăm doạ, có nghĩa như cho chết: đánh bỏ mẹ nó đi!",
    example: "đánh bỏ mẹ nó đi!",
  },
  {
    word: "bỏ mẹ",
    part_of_speech: "",
    meaning:
      "tổ hợp biểu thị ý lo ngại về một hậu quả không hay: làm ăn thế này thì bỏ mẹ! * bỏ mẹ, trời lại mưa rồi!",
    example: "làm ăn thế này thì bỏ mẹ! * bỏ mẹ, trời lại mưa rồi!",
  },
  {
    word: "bỏ mẹ",
    part_of_speech: "",
    meaning:
      "tổ hợp biểu thị mức độ quá lớn, quá nhiều: chán bỏ mẹ! * thích bỏ mẹ lại còn làm bộ! * thằng ấy hâm bỏ mẹ!",
    example: "chán bỏ mẹ! * thích bỏ mẹ lại còn làm bộ! * thằng ấy hâm bỏ mẹ!",
  },
  {
    word: "bỏ mình",
    part_of_speech: "động từ",
    meaning: "hi sinh thân mình, chết vì một cái gì cao quý: bỏ mình vì nước",
    example: "bỏ mình vì nước",
  },
  {
    word: "bỏ mối",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) giao hàng cho các điểm bán lẻ để kiếm lời: chạy hàng bỏ mối cho các sạp vải",
    example: "chạy hàng bỏ mối cho các sạp vải",
  },
  {
    word: "bỏ ngỏ",
    part_of_speech: "động từ",
    meaning:
      "để trống, không đóng kín, không có sự phòng thủ: bỏ ngỏ cửa sổ cho mát * giặc chạy trốn, để thành bỏ ngỏ",
    example: "bỏ ngỏ cửa sổ cho mát * giặc chạy trốn, để thành bỏ ngỏ",
  },
  {
    word: "bỏ ngỏ",
    part_of_speech: "động từ",
    meaning:
      "(vấn đề khoa học) để trong tình trạng chưa được giải quyết, còn chờ nghiên cứu thêm: trong lĩnh vực này, nhiều vấn đề còn đang bỏ ngỏ",
    example: "trong lĩnh vực này, nhiều vấn đề còn đang bỏ ngỏ",
  },
  {
    word: "bỏ mứa",
    part_of_speech: "động từ",
    meaning:
      "(ăn) bỏ dở, bỏ thừa do quá chán, quá no: ăn không hết phải bỏ mứa",
    example: "ăn không hết phải bỏ mứa",
  },
  {
    word: "bỏ mứa",
    part_of_speech: "động từ",
    meaning:
      '(khẩu ngữ) (làm việc gì đó) bỏ dở, không làm cho xong: "(...) Nam đọc bỏ mứa thì Nam phải cử người đọc đền." (ĐVũ; 1)',
    example: '(...) Nam đọc bỏ mứa thì Nam phải cử người đọc đền." (ĐVũ; 1)',
  },
  {
    word: "bỏ ngũ",
    part_of_speech: "động từ",
    meaning: "(hiếm) như đào ngũ: lính bỏ ngũ",
    example: "lính bỏ ngũ",
  },
  {
    word: "bỏ ngoài tai",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) coi như không nghe thấy, không thèm để ý đến: bỏ ngoài tai những lời dị nghị",
    example: "bỏ ngoài tai những lời dị nghị",
  },
  {
    word: "bỏ quá",
    part_of_speech: "động từ",
    meaning:
      "bỏ qua, không chấp (dùng trong lời xin lỗi): tôi lỡ lời, mong bác bỏ quá cho!",
    example: "tôi lỡ lời, mong bác bỏ quá cho!",
  },
  {
    word: "bỏ phiếu",
    part_of_speech: "động từ",
    meaning:
      "dùng phiếu để thể hiện sự lựa chọn hay thái độ của mình trong cuộc bầu cử hoặc biểu quyết: bỏ phiếu kín * bỏ phiếu bầu đại biểu quốc hội",
    example: "bỏ phiếu kín * bỏ phiếu bầu đại biểu quốc hội",
  },
  {
    word: "bỏ qua",
    part_of_speech: "động từ",
    meaning:
      "bỏ bớt đi, không thực hiện đầy đủ theo quy trình: phải thực hiện từng bước, không nên bỏ qua khâu nào",
    example: "phải thực hiện từng bước, không nên bỏ qua khâu nào",
  },
  {
    word: "bỏ qua",
    part_of_speech: "động từ",
    meaning:
      "để cho qua mất đi, không biết lợi dụng: bỏ qua dịp may * bỏ qua cơ hội",
    example: "bỏ qua dịp may * bỏ qua cơ hội",
  },
  {
    word: "bỏ qua",
    part_of_speech: "động từ",
    meaning:
      "làm ngơ, coi như không quan trọng, không cần chú ý đến: bỏ qua mọi lời khuyên can * chuyện này không thể bỏ qua!",
    example: "bỏ qua mọi lời khuyên can * chuyện này không thể bỏ qua!",
  },
  {
    word: "bó rọ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bị ép chặt đến mức không thể tự do cử động được, tựa như bị nhốt ở trong rọ: ngồi bó rọ trong xe",
    example: "ngồi bó rọ trong xe",
  },
  {
    word: "bỏ rẻ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tính tối thiểu, ít ra: số thóc đó, bỏ rẻ cũng được triệu bạc",
    example: "số thóc đó, bỏ rẻ cũng được triệu bạc",
  },
  {
    word: "bỏ rơi",
    part_of_speech: "động từ",
    meaning:
      "bỏ lại phía sau rất xa: bỏ rơi các vận động viên khác trên đường đua",
    example: "bỏ rơi các vận động viên khác trên đường đua",
  },
  {
    word: "bỏ rơi",
    part_of_speech: "động từ",
    meaning:
      "bỏ mặc, không quan tâm đến, coi như không còn có quan hệ: bị gia đình bỏ rơi",
    example: "bị gia đình bỏ rơi",
  },
  {
    word: "bó tay",
    part_of_speech: "động từ",
    meaning:
      'chịu bất lực, không thể làm gì được: khó quá, đành chịu bó tay * "Người đâu sâu sắc nước đời, Mà chàng Thúc phải ra người bó tay!" (TKiều)',
    example:
      'khó quá, đành chịu bó tay * "Người đâu sâu sắc nước đời, Mà chàng Thúc phải ra người bó tay!" (TKiều)',
  },
  {
    word: "bỏ thầu",
    part_of_speech: "động từ",
    meaning:
      "đưa ra các điều kiện, đặc biệt là giá cả, trong quá trình dự thầu: giá bỏ thầu",
    example: "giá bỏ thầu",
  },
  {
    word: "bỏ thây",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) như bỏ xác: chết bỏ thây",
    example: "chết bỏ thây",
  },
  {
    word: "bỏ trầu",
    part_of_speech: "động từ",
    meaning:
      "(nhà trai) đưa trầu cau đến nhà gái để dạm hỏi: đi bỏ trầu cho con",
    example: "đi bỏ trầu cho con",
  },
  {
    word: "bỏ vật bỏ vạ",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) bỏ mặc không trông nom, không gìn giữ: máy móc bỏ vật bỏ vạ ngoài trời",
    example: "máy móc bỏ vật bỏ vạ ngoài trời",
  },
  {
    word: "bỏ túi",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) lấy tiền của công làm của riêng (thường nói về những khoản không lớn lắm): bớt xén tiền công để bỏ túi",
    example: "bớt xén tiền công để bỏ túi",
  },
  {
    word: "bỏ túi",
    part_of_speech: "động từ",
    meaning:
      "thuộc cỡ nhỏ, tiện để cho vào túi mang đi: từ điển bỏ túi * máy tính bỏ túi",
    example: "từ điển bỏ túi * máy tính bỏ túi",
  },
  {
    word: "bó tròn",
    part_of_speech: "động từ",
    meaning:
      "thu hẹp, hạn chế trong một phạm vi nhất định: mọi khoản chi tiêu chỉ bó tròn trong từng ấy tiền",
    example: "mọi khoản chi tiêu chỉ bó tròn trong từng ấy tiền",
  },
  {
    word: "bỏ xác",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) chết (thường hàm ý không coi trọng hoặc coi khinh): không khéo thì bỏ xác cả nút",
    example: "không khéo thì bỏ xác cả nút",
  },
  {
    word: "boa",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) bo: tiền boa * được khách boa tiền",
    example: "tiền boa * được khách boa tiền",
  },
  {
    word: "bỏ xừ",
    part_of_speech: "",
    meaning: "(thông tục) như bỏ mẹ: mệt bỏ xừ! * chán bỏ xừ!",
    example: "mệt bỏ xừ! * chán bỏ xừ!",
  },
  {
    word: "bỏ xó",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) vứt vào một góc, một nơi, không nhìn ngó đến: xe hỏng nên đành bỏ xó",
    example: "xe hỏng nên đành bỏ xó",
  },
  {
    word: "bỏ xó",
    part_of_speech: "động từ",
    meaning: "vô dụng, không có giá trị, đáng vứt đi: của bỏ xó * đồ bỏ xó",
    example: "của bỏ xó * đồ bỏ xó",
  },
  {
    word: "bóc",
    part_of_speech: "động từ",
    meaning:
      "gỡ ra, lấy đi vỏ ngoài hoặc phần bọc, dán ở bên ngoài: bóc vỏ cam * bóc bánh * bóc thư",
    example: "bóc vỏ cam * bóc bánh * bóc thư",
  },
  {
    word: "bóc",
    part_of_speech: "động từ",
    meaning: "tháo, dỡ đi hoặc tách ra: bóc một đoạn đường ray",
    example: "bóc một đoạn đường ray",
  },
  {
    word: "bọc lót",
    part_of_speech: "động từ",
    meaning:
      "(các cầu thủ) phối hợp với nhau cùng che chắn và bảo vệ khung thành: một pha bọc lót sơ hở của hậu vệ",
    example: "một pha bọc lót sơ hở của hậu vệ",
  },
  {
    word: "bọc",
    part_of_speech: "động từ",
    meaning: "gói lại, bao kín để che giữ: bọc sách * răng bọc vàng",
    example: "bọc sách * răng bọc vàng",
  },
  {
    word: "bọc",
    part_of_speech: "động từ",
    meaning: "bao quanh: hàng rào bọc quanh nhà",
    example: "hàng rào bọc quanh nhà",
  },
  {
    word: "bọc",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp những vật rời được bọc lại với nhau thành từng đơn vị: một bọc tiền * bọc quần áo",
    example: "một bọc tiền * bọc quần áo",
  },
  {
    word: "bọc",
    part_of_speech: "danh từ",
    meaning:
      "túi chứa thai, trứng, v.v. trong cơ thể người và một số động vật: theo truyền thuyết, mẹ Âu Cơ sinh ra một bọc trăm trứng",
    example: "theo truyền thuyết, mẹ Âu Cơ sinh ra một bọc trăm trứng",
  },
  {
    word: "bọc hậu",
    part_of_speech: "động từ",
    meaning:
      "vòng ra phía sau đối phương để chặn đánh, vây đánh: đánh bọc hậu * cánh quân bọc hậu",
    example: "đánh bọc hậu * cánh quân bọc hậu",
  },
  {
    word: "bóc lột",
    part_of_speech: "động từ",
    meaning:
      "chiếm đoạt thành quả lao động của người khác bằng cách dựa vào quyền tư hữu về tư liệu sản xuất hoặc vào quyền hành, địa vị: giai cấp bóc lột * địa chủ bóc lột nông dân * xoá bỏ chế độ người bóc lột người",
    example:
      "giai cấp bóc lột * địa chủ bóc lột nông dân * xoá bỏ chế độ người bóc lột người",
  },
  {
    word: "bóc lột",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) ăn lãi quá đáng hoặc lợi dụng quá đáng: bóc lột sức lao động của công nhân",
    example: "bóc lột sức lao động của công nhân",
  },
  {
    word: "bóc tem",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) (hàng hoá) lần đầu tiên được đưa ra sử dụng: hàng chưa bóc tem (còn mới nguyên, chưa đem ra sử dụng)",
    example: "hàng chưa bóc tem (còn mới nguyên, chưa đem ra sử dụng)",
  },
  {
    word: "bói đâu ra",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) rất hiếm, không tìm đâu ra: bói đâu ra tiền? * đang mùa đông, bói đâu ra hoa sen?",
    example: "bói đâu ra tiền? * đang mùa đông, bói đâu ra hoa sen?",
  },
  {
    word: "bóc trần",
    part_of_speech: "động từ",
    meaning:
      "làm cho bộc lộ hoàn toàn cái xấu xa vốn được che đậy, giấu giếm: bóc trần bộ mặt xảo trá * âm mưu bị bóc trần",
    example: "bóc trần bộ mặt xảo trá * âm mưu bị bóc trần",
  },
  {
    word: "bóc mẽ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ, hiếm) làm cho bộc lộ hoàn toàn cái xấu xa vốn được che đậy bằng cái vẻ tốt đẹp bề ngoài: ai lại bóc mẽ nhau thế?",
    example: "ai lại bóc mẽ nhau thế?",
  },
  {
    word: "bói",
    part_of_speech: "động từ",
    meaning:
      "đoán việc đã qua hay sắp tới gắn với số mệnh của từng người, theo mê tín: quẻ bói * bói ra ma, quét nhà ra rác (tng)",
    example: "quẻ bói * bói ra ma, quét nhà ra rác (tng)",
  },
  {
    word: "bói",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tìm ra (cái khó mà có được): có bói cũng chẳng ra đồng nào",
    example: "có bói cũng chẳng ra đồng nào",
  },
  {
    word: "bói",
    part_of_speech: "động từ",
    meaning: "(cây) ra quả lần đầu tiên: cây cam mới bói quả",
    example: "cây cam mới bói quả",
  },
  {
    word: "bom",
    part_of_speech: "danh từ",
    meaning:
      "vũ khí thường do máy bay thả xuống, vỏ bằng kim loại, trong có chứa thuốc nổ, có sức sát thương và phá hoại mạnh: quả bom * dội bom * máy bay ném bom",
    example: "quả bom * dội bom * máy bay ném bom",
  },
  {
    word: "bói toán",
    part_of_speech: "động từ",
    meaning: "bói vận số (nói khái quát): thuật bói toán * hành nghề bói toán",
    example: "thuật bói toán * hành nghề bói toán",
  },
  {
    word: "bói không ra",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) như bói đâu ra: nhà sạch đến nỗi bói không ra một cái rác",
    example: "nhà sạch đến nỗi bói không ra một cái rác",
  },
  {
    word: "bỏm bẻm",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả kiểu (người già) nhai lâu, thong thả, miệng không mở to: miệng bỏm bẻm nhai trầu",
    example: "miệng bỏm bẻm nhai trầu",
  },
  {
    word: "bom đạn",
    part_of_speech: "danh từ",
    meaning:
      "bom, đạn, vũ khí giết người hay chiến tranh (nói khái quát): vượt qua bom đạn * nhà cửa bị bom đạn tàn phá",
    example: "vượt qua bom đạn * nhà cửa bị bom đạn tàn phá",
  },
  {
    word: "bón",
    part_of_speech: "động từ",
    meaning:
      "(Nam đút) đút cho ăn từng tí một: bón cơm cho trẻ * bón cháo cho người bệnh",
    example: "bón cơm cho trẻ * bón cháo cho người bệnh",
  },
  {
    word: "bón",
    part_of_speech: "động từ",
    meaning:
      "bỏ thêm chất để làm tăng thành phần dinh dưỡng hoặc để cải tạo đất, giúp cây cối sinh trưởng tốt: bón phân cho lúa * bón vôi khử chua cho đất",
    example: "bón phân cho lúa * bón vôi khử chua cho đất",
  },
  {
    word: "bón",
    part_of_speech: "tính từ",
    meaning: "(Nam, thông tục) táo bón: trẻ bị bón",
    example: "trẻ bị bón",
  },
  {
    word: "bọn",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp gồm một số người có chung một tính chất nào đó, như cùng lứa tuổi, cùng một tổ chức, cùng tham gia một hoạt động, v.v.: bọn trẻ con * bọn cướp * mai bọn mình sẽ đi * ý kiến đó được cả bọn tán thành",
    example:
      "bọn trẻ con * bọn cướp * mai bọn mình sẽ đi * ý kiến đó được cả bọn tán thành",
  },
  {
    word: "bon",
    part_of_speech: "động từ",
    meaning:
      '(xe cộ hoặc ngựa) chạy nhanh và nhẹ nhàng: chiếc xe bon về phía đầu dốc * "Hơi gió lạnh người dầu mặt dạn, Dòng nước sâu ngựa nản chân bon." (CPN)',
    example:
      'chiếc xe bon về phía đầu dốc * "Hơi gió lạnh người dầu mặt dạn, Dòng nước sâu ngựa nản chân bon." (CPN)',
  },
  {
    word: "bon",
    part_of_speech: "tính từ",
    meaning: "(chạy) êm và nhẹ: xe đi rất bon",
    example: "xe đi rất bon",
  },
  {
    word: "bòn",
    part_of_speech: "động từ",
    meaning:
      "tìm kiếm, góp nhặt từng ít một: ốm đau, phải bòn từng đồng để thuốc thang",
    example: "ốm đau, phải bòn từng đồng để thuốc thang",
  },
  {
    word: "bòn",
    part_of_speech: "động từ",
    meaning:
      "lấy dần từng ít một của người khác, bằng mọi cách khôn khéo (hàm ý chê): bòn của",
    example: "bòn của",
  },
  {
    word: "bon bon",
    part_of_speech: "tính từ",
    meaning: "rất bon: xe chạy bon bon",
    example: "xe chạy bon bon",
  },
  {
    word: "bon chen",
    part_of_speech: "động từ",
    meaning:
      "tranh giành để cố cầu danh hoặc mưu lợi: cuộc sống bon chen * bon chen danh lợi",
    example: "cuộc sống bon chen * bon chen danh lợi",
  },
  {
    word: "bòn mót",
    part_of_speech: "động từ",
    meaning:
      "bòn từng li từng tí, không để sót: bòn mót từng hạt thóc rơi vãi * bòn mót từng cành củi về đun",
    example: "bòn mót từng hạt thóc rơi vãi * bòn mót từng cành củi về đun",
  },
  {
    word: "bóng",
    part_of_speech: "danh từ",
    meaning:
      "vùng không được ánh sáng chiếu tới do bị một vật che khuất, hoặc hình của vật ấy trên nền: ngồi nghỉ dưới bóng cây * bóng người in trên vách * như hình với bóng (luôn bên nhau)",
    example:
      "ngồi nghỉ dưới bóng cây * bóng người in trên vách * như hình với bóng (luôn bên nhau)",
  },
  {
    word: "bóng",
    part_of_speech: "danh từ",
    meaning:
      'bóng của người có thế lực, thường dùng để ví sự che chở: núp bóng * "Nghìn tầm nhờ bóng tùng quân, Tuyết sương che chở cho thân cát đằng." (TKiều)',
    example:
      'núp bóng * "Nghìn tầm nhờ bóng tùng quân, Tuyết sương che chở cho thân cát đằng." (TKiều)',
  },
  {
    word: "bóng",
    part_of_speech: "danh từ",
    meaning:
      "mảng sáng tối trên bề mặt của vật do tác dụng của ánh sáng: mảng bóng trên bức tranh * đánh bóng",
    example: "mảng bóng trên bức tranh * đánh bóng",
  },
  {
    word: "bóng",
    part_of_speech: "danh từ",
    meaning:
      'ánh, ánh sáng: bóng nắng chiếu qua ô cửa * "Đêm nay chẳng biết đêm nào, Bóng trăng vằng vặc bóng sao mờ mờ." (LVT)',
    example:
      'bóng nắng chiếu qua ô cửa * "Đêm nay chẳng biết đêm nào, Bóng trăng vằng vặc bóng sao mờ mờ." (LVT)',
  },
  {
    word: "bóng",
    part_of_speech: "danh từ",
    meaning:
      "hình ảnh của vật do phản chiếu mà có: soi bóng mình trong gương * cây in bóng xuống nước * thả mồi bắt bóng (tng)",
    example:
      "soi bóng mình trong gương * cây in bóng xuống nước * thả mồi bắt bóng (tng)",
  },
  {
    word: "bóng",
    part_of_speech: "danh từ",
    meaning:
      "hình dạng nhìn thấy một cách mờ ảo, không rõ nét hoặc thấp thoáng: có bóng người thấp thoáng * bóng chim tăm cá",
    example: "có bóng người thấp thoáng * bóng chim tăm cá",
  },
  {
    word: "bóng",
    part_of_speech: "danh từ",
    meaning:
      "hình ảnh gián tiếp hoặc vu vơ: doạ bóng * nói bóng nói gió * chó cắn bóng (sủa vu vơ trong đêm)",
    example: "doạ bóng * nói bóng nói gió * chó cắn bóng (sủa vu vơ trong đêm)",
  },
  {
    word: "bóng",
    part_of_speech: "danh từ",
    meaning:
      "hồn người chết hiện về nhập vào xác người nào đó, theo mê tín: hồn cô bóng cậu * ngồi hầu bóng",
    example: "hồn cô bóng cậu * ngồi hầu bóng",
  },
  {
    word: "bóng",
    part_of_speech: "danh từ",
    meaning: "(Nam, cũ) ảnh: chụp bóng",
    example: "chụp bóng",
  },
  {
    word: "bóng",
    part_of_speech: "danh từ",
    meaning:
      "bong bóng cá hay bì lợn phơi khô, nướng, sấy hoặc rán phồng, dùng làm thức ăn.",
    example: "quả bóng nhựa * chơi đá bóng * sân bóng",
  },
  {
    word: "bóng",
    part_of_speech: "danh từ",
    meaning:
      "(Nam banh) quả cầu rỗng bằng cao su, da hoặc nhựa, dễ nẩy, dùng làm đồ chơi thể thao: quả bóng nhựa * chơi đá bóng * sân bóng",
    example: "thổi bóng * thả một chùm bóng",
  },
  {
    word: "bóng",
    part_of_speech: "danh từ",
    meaning: "bóng bay (nói tắt): thổi bóng * thả một chùm bóng",
    example: "đèn vỡ bóng * bóng đèn hoa kì",
  },
  {
    word: "bóng",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận bằng thuỷ tinh để che gió trong đèn dầu hoả cho ngọn lửa khỏi tắt hoặc cho đỡ khói: đèn vỡ bóng * bóng đèn hoa kì",
    example: "bóng đã bị cháy * bóng 75 watt * bóng đèn tuýp",
  },
  {
    word: "bóng",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) bóng điện (nói tắt): bóng đã bị cháy * bóng 75 watt * bóng đèn tuýp",
    example: "máy thu thanh bảy bóng",
  },
  {
    word: "bóng",
    part_of_speech: "tính từ",
    meaning:
      "(bề mặt) nhẵn đến mức phản chiếu được ánh sáng gần như mặt gương: chiếc vòng bạc sáng bóng * lau cho thật bóng",
    example: "chiếc vòng bạc sáng bóng * lau cho thật bóng",
  },
  {
    word: "bòn rút",
    part_of_speech: "động từ",
    meaning:
      "bòn lấy của người khác một cách quá đáng: quan lại bòn rút của dân",
    example: "quan lại bòn rút của dân",
  },
  {
    word: "bỏng",
    part_of_speech: "tính từ",
    meaning:
      "bị tổn thương ở da thịt do chịu tác động của lửa, nhiệt hoặc hoá chất, v.v.: bỏng nước sôi * bỏng acid * rát như phải bỏng",
    example: "bỏng nước sôi * bỏng acid * rát như phải bỏng",
  },
  {
    word: "bỏng",
    part_of_speech: "tính từ",
    meaning:
      "nóng hoặc rát đến mức có cảm giác như bị bỏng: cát nóng bỏng chân * nói rát cổ bỏng họng",
    example: "cát nóng bỏng chân * nói rát cổ bỏng họng",
  },
  {
    word: "bỏng",
    part_of_speech: "danh từ",
    meaning:
      "món ăn làm bằng ngô hoặc gạo rang phồng cho nở ra, có khi trộn thêm mật: bỏng ngô * một nắm bỏng gạo",
    example: "bỏng ngô * một nắm bỏng gạo",
  },
  {
    word: "bóng bàn",
    part_of_speech: "danh từ",
    meaning:
      "môn thể thao dùng vợt đánh quả bóng nhựa qua lại trên một cái bàn hình chữ nhật có lưới căng ngang ở giữa: quả bóng bàn * chơi đánh bóng bàn",
    example: "quả bóng bàn * chơi đánh bóng bàn",
  },
  {
    word: "bọng",
    part_of_speech: "danh từ",
    meaning:
      "bọc chứa chất nước trong cơ thể người và một số động vật: bọng nước đái * bọng cà cuống * chưa vỡ bọng cứt đã đòi bay bổng (tng)",
    example:
      "bọng nước đái * bọng cà cuống * chưa vỡ bọng cứt đã đòi bay bổng (tng)",
  },
  {
    word: "bòng",
    part_of_speech: "danh từ",
    meaning: "cây cùng họ với bưởi, quả to, cùi dày, vị chua: quả bòng",
    example: "quả bòng",
  },
  {
    word: "bong",
    part_of_speech: "động từ",
    meaning:
      "(lớp mỏng bên ngoài) không còn dính vào, mà rời ra từng mảng: giấy dán lâu ngày bị bong * vôi bong từng mảng",
    example: "giấy dán lâu ngày bị bong * vôi bong từng mảng",
  },
  {
    word: "bong",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) búng cho quay tít: chơi bong vụ (chơi búng con quay)",
    example: "chơi bong vụ (chơi búng con quay)",
  },
  {
    word: "bóng bay",
    part_of_speech: "danh từ",
    meaning:
      "túi cao su mỏng có màu sắc, được thổi hoặc bơm căng phồng lên (thường bằng khí nhẹ) để có thể thả cho bay cao, dùng làm đồ chơi hoặc vật trang trí: chùm bóng bay * thả bóng bay",
    example: "chùm bóng bay * thả bóng bay",
  },
  {
    word: "bóng bẩy",
    part_of_speech: "tính từ",
    meaning:
      'có vẻ đẹp hào nhoáng bề ngoài: nước sơn bóng bẩy * "Ngông nghênh áo tía quần hồng, Tuy rằng bóng bẩy nhưng không có gì." (ca dao)',
    example:
      'nước sơn bóng bẩy * "Ngông nghênh áo tía quần hồng, Tuy rằng bóng bẩy nhưng không có gì." (ca dao)',
  },
  {
    word: "bóng bẩy",
    part_of_speech: "tính từ",
    meaning: "(lời văn) đẹp đẽ, trau chuốt, có nhiều hình ảnh: lời lẽ bóng bẩy",
    example: "lời lẽ bóng bẩy",
  },
  {
    word: "bong bóng",
    part_of_speech: "danh từ",
    meaning:
      "túi chứa không khí trong bụng một số loài cá làm cho chúng có thể chìm nổi trong nước dễ dàng: bong bóng cá",
    example: "bong bóng cá",
  },
  {
    word: "bong bóng",
    part_of_speech: "danh từ",
    meaning: "túi chứa nước đái trong bụng một số động vật: bong bóng lợn",
    example: "bong bóng lợn",
  },
  {
    word: "bong bóng",
    part_of_speech: "danh từ",
    meaning: "(cũ) bóng bay: quả bong bóng đỏ * thổi bong bóng",
    example: "quả bong bóng đỏ * thổi bong bóng",
  },
  {
    word: "bong bóng",
    part_of_speech: "danh từ",
    meaning:
      'màng nước hình cầu nhỏ do không khí làm phồng lên: bong bóng xà phòng * "Trời mưa bong bóng phập phồng (…)" (ca dao)',
    example:
      'bong bóng xà phòng * "Trời mưa bong bóng phập phồng (…)" (ca dao)',
  },
  {
    word: "bóng câu",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) bóng ngựa câu (ngựa khoẻ, đang sức lớn) chạy nhanh; dùng để ví thời gian trôi nhanh: thời gian như bóng câu qua cửa * "Bóng câu thoáng bên mành mấy nỗi, Những hương sầu phấn tủi bao xong." (CO)',
    example:
      'thời gian như bóng câu qua cửa * "Bóng câu thoáng bên mành mấy nỗi, Những hương sầu phấn tủi bao xong." (CO)',
  },
  {
    word: "bòng bong",
    part_of_speech: "danh từ",
    meaning:
      "dây leo thuộc loại dương xỉ, thường mọc xoắn vào nhau thành từng đám ở bờ bụi: dây bòng bong",
    example: "dây bòng bong",
  },
  {
    word: "bòng bong",
    part_of_speech: "danh từ",
    meaning:
      "xơ tre vót ra bị cuốn rối lại; thường dùng để ví tình trạng rối ren: rối như mớ bòng bong",
    example: "rối như mớ bòng bong",
  },
  {
    word: "bóng chim tăm cá",
    part_of_speech: "",
    meaning:
      '(cũ, văn chương) ví những cái rất xa vời, vô vọng, khó có thể tìm thấy được: "Nghĩ điều trời thẳm vực sâu, Bóng chim tăm cá, biết đâu mà nhìn!" (TKiều)',
    example:
      'Nghĩ điều trời thẳm vực sâu, Bóng chim tăm cá, biết đâu mà nhìn!" (TKiều)',
  },
  {
    word: "bóng dợn",
    part_of_speech: "tính từ",
    meaning:
      "(tóc, lông) bóng, mượt đến mức như nổi vân lên bề mặt: đầu chải dầu thơm bóng dợn",
    example: "đầu chải dầu thơm bóng dợn",
  },
  {
    word: "bóng dáng",
    part_of_speech: "danh từ",
    meaning:
      "hình dáng không rõ nét hoặc thấp thoáng: chẳng thấy bóng dáng một ai * có bóng dáng một người đằng xa",
    example: "chẳng thấy bóng dáng một ai * có bóng dáng một người đằng xa",
  },
  {
    word: "bóng đè",
    part_of_speech: "danh từ",
    meaning:
      "hiện tượng xảy ra trong khi ngủ, có cảm giác như có gì đè nặng lên người, làm cho khó thở và không cựa quậy được: bị bóng đè",
    example: "bị bóng đè",
  },
  {
    word: "bóng đá",
    part_of_speech: "danh từ",
    meaning:
      "môn thể thao chia thành hai đội, cầu thủ dùng chân điều khiển bóng và tìm cách dùng chân hoặc đầu đưa bóng lọt vào khung thành của đối phương: cầu thủ bóng đá * giải bóng đá thế giới",
    example: "cầu thủ bóng đá * giải bóng đá thế giới",
  },
  {
    word: "bóng láng",
    part_of_speech: "tính từ",
    meaning:
      "bóng đến mức bề mặt hoàn toàn trơn nhẵn: đầu chải bóng láng * sàn nhà lên nước bóng láng",
    example: "đầu chải bóng láng * sàn nhà lên nước bóng láng",
  },
  {
    word: "bóng loáng",
    part_of_speech: "tính từ",
    meaning:
      "bóng đến mức ánh lên, có thể phản chiếu được ánh sáng: chiếc ô tô bóng loáng",
    example: "chiếc ô tô bóng loáng",
  },
  {
    word: "bóng gió",
    part_of_speech: "tính từ",
    meaning:
      '(lối nói năng) dùng hình ảnh xa xôi để ngụ ý, chứ không chỉ thẳng ra: chửi bóng gió * "(...) nàng không nghĩ để tìm nghĩa xa xôi những câu bóng gió của dì ghẻ (...)" (KhHưng; 4)',
    example:
      'chửi bóng gió * "(...) nàng không nghĩ để tìm nghĩa xa xôi những câu bóng gió của dì ghẻ (...)" (KhHưng; 4)',
  },
  {
    word: "bóng gió",
    part_of_speech: "tính từ",
    meaning: "vu vơ, thiếu căn cứ: sợ bóng sợ gió * ghen bóng gió",
    example: "sợ bóng sợ gió * ghen bóng gió",
  },
  {
    word: "bong gân",
    part_of_speech: "động từ",
    meaning:
      "rạn hoặc bong dây chằng ra do bị căng quá mạnh khi tổn thương ở khớp xương: bị ngã bong gân * chân bị bong gân",
    example: "bị ngã bong gân * chân bị bong gân",
  },
  {
    word: "bóng lộn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) bóng đến mức như có thể soi vào được: chiếc xe con bóng lộn * đầu tóc bóng lộn",
    example: "chiếc xe con bóng lộn * đầu tóc bóng lộn",
  },
  {
    word: "bóng mát",
    part_of_speech: "danh từ",
    meaning: "chỗ râm mát, không bị nắng chiếu: trồng cây lấy bóng mát",
    example: "trồng cây lấy bóng mát",
  },
  {
    word: "bóng ma",
    part_of_speech: "danh từ",
    meaning:
      "hình ảnh đáng sợ lởn vởn, ám ảnh trong tâm trí người ta: bóng ma chiến tranh vẫn còn ám ảnh con người",
    example: "bóng ma chiến tranh vẫn còn ám ảnh con người",
  },
  {
    word: "bóng râm",
    part_of_speech: "danh từ",
    meaning:
      "chỗ râm mát, do trời có mây hoặc do không bị nắng chiếu: ngồi nghỉ dưới bóng râm",
    example: "ngồi nghỉ dưới bóng râm",
  },
  {
    word: "bọng ong",
    part_of_speech: "danh từ",
    meaning:
      "khúc gỗ hình trụ rỗng, bịt hai đầu, chừa lỗ nhỏ cho ong vào làm tổ: nuôi khoảng chục bọng ong",
    example: "nuôi khoảng chục bọng ong",
  },
  {
    word: "bóng tối",
    part_of_speech: "danh từ",
    meaning:
      "phần không gian không có ánh sáng rọi tới: dò dẫm trong bóng tối * cảnh vật chìm trong bóng tối",
    example: "dò dẫm trong bóng tối * cảnh vật chìm trong bóng tối",
  },
  {
    word: "boóng",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) ké, nhờ vào phần người khác: ăn boóng",
    example: "ăn boóng",
  },
  {
    word: "boong",
    part_of_speech: "danh từ",
    meaning: "sàn ngăn chia tàu thuỷ thành nhiều tầng.",
    example: "lên boong hóng gió",
  },
  {
    word: "boong",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng kêu vang và ngân dài như tiếng chuông: tiếng chuông chùa boong ngân thong thả",
    example: "tiếng chuông chùa boong ngân thong thả",
  },
  {
    word: "bóng rổ",
    part_of_speech: "danh từ",
    meaning:
      "môn thể thao chia thành hai đội, người chơi dùng tay điều khiển bóng, tìm cách ném vào vòng có mắc lưới, gọi là rổ, của đối phương: trận thi đấu bóng rổ * sân bóng rổ",
    example: "trận thi đấu bóng rổ * sân bóng rổ",
  },
  {
    word: "bóng vía",
    part_of_speech: "danh từ",
    meaning:
      "yếu tố vô hình tồn tại trong con người, tạo ra sức mạnh, sức sống tinh thần, theo một quan niệm duy tâm: cứng bóng vía * yếu bóng vía",
    example: "cứng bóng vía * yếu bóng vía",
  },
  {
    word: "bóng vía",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) như bóng dáng: không thấy bóng vía một ai",
    example: "không thấy bóng vía một ai",
  },
  {
    word: "bóp bụng",
    part_of_speech: "động từ",
    meaning: "hết sức tằn tiện, dè sẻn trong việc ăn tiêu: bóp bụng để dành",
    example: "bóp bụng để dành",
  },
  {
    word: "bóp bụng",
    part_of_speech: "động từ",
    meaning: "hết sức nhịn nhục, dằn lòng: bóp bụng mà chịu",
    example: "bóp bụng mà chịu",
  },
  {
    word: "bóp",
    part_of_speech: "danh từ",
    meaning: "(cũ) như bốt: bóp cảnh sát * giặc đóng bóp ở đầu làng",
    example: "bóp cảnh sát * giặc đóng bóp ở đầu làng",
  },
  {
    word: "bóp",
    part_of_speech: "động từ",
    meaning:
      "nắm và siết mạnh trong lòng bàn tay hoặc giữa các ngón tay: bóp nát quả cam * bóp chân cho đỡ mỏi * kẻ vo tròn, người bóp bẹp (tng)",
    example:
      "bóp nát quả cam * bóp chân cho đỡ mỏi * kẻ vo tròn, người bóp bẹp (tng)",
  },
  {
    word: "bóp",
    part_of_speech: "động từ",
    meaning:
      "ấn, kéo làm phát ra tiếng kêu, tiếng nổ: bóp còi inh ỏi * bóp cò súng",
    example: "bóp còi inh ỏi * bóp cò súng",
  },
  {
    word: "bóp",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) trộn, ướp (nói về món ăn): thịt chó bóp riềng * hoa chuối bóp muối",
    example: "thịt chó bóp riềng * hoa chuối bóp muối",
  },
  {
    word: "bóp",
    part_of_speech: "động từ",
    meaning:
      "thắt eo lại, bị nhỏ đi về thể tích: quả bầu bóp ở giữa * trán bóp",
    example: "quả bầu bóp ở giữa * trán bóp",
  },
  {
    word: "bóp chắt",
    part_of_speech: "động từ",
    meaning: "(hiếm) như chắt bóp: bóp chắt tiền bạc * chi tiêu bóp chắt",
    example: "bóp chắt tiền bạc * chi tiêu bóp chắt",
  },
  {
    word: "bóp chẹt",
    part_of_speech: "động từ",
    meaning:
      "kìm hãm, làm cho không phát triển nổi (thường nói về kinh tế): các công ti tìm cách tranh giành thị trường, bóp chẹt lẫn nhau",
    example: "các công ti tìm cách tranh giành thị trường, bóp chẹt lẫn nhau",
  },
  {
    word: "bóp chẹt",
    part_of_speech: "động từ",
    meaning: "như bắt bí: lợi dụng sự độc quyền để bóp chẹt khách hàng",
    example: "lợi dụng sự độc quyền để bóp chẹt khách hàng",
  },
  {
    word: "bóp chết",
    part_of_speech: "động từ",
    meaning:
      "làm cho không thể tồn tại được, thường là bằng bạo lực: đàn áp hòng bóp chết phong trào cách mạng",
    example: "đàn áp hòng bóp chết phong trào cách mạng",
  },
  {
    word: "bóp hầu bóp cổ",
    part_of_speech: "",
    meaning:
      '(khẩu ngữ) như bóp cổ (nhưng nghĩa mạnh hơn): "(...) bọn lý dịch vẫn thường bóp hầu bóp cổ và nhũng lạm, và biển thủ tiền của đám cùng đinh." (VTrPhụng; 15)',
    example:
      '(...) bọn lý dịch vẫn thường bóp hầu bóp cổ và nhũng lạm, và biển thủ tiền của đám cùng đinh." (VTrPhụng; 15)',
  },
  {
    word: "bóp cổ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) hà hiếp, bóc lột một cách quá đáng, thậm tệ: quan lại bóp cổ dân nghèo * bóp cổ khách hàng",
    example: "quan lại bóp cổ dân nghèo * bóp cổ khách hàng",
  },
  {
    word: "boong boong",
    part_of_speech: "tính từ",
    meaning:
      'như boong (nhưng ý liên tiếp): "Kìa đâu chiền sớm, chợ trưa, Chày boong boong nện, khói mờ mờ bay." (SKTT)',
    example:
      'Kìa đâu chiền sớm, chợ trưa, Chày boong boong nện, khói mờ mờ bay." (SKTT)',
  },
  {
    word: "bóp miệng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) hết sức tằn tiện, dè sẻn trong việc ăn uống: bóp miệng để dành",
    example: "bóp miệng để dành",
  },
  {
    word: "bóp mũi",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bắt nạt một cách dễ dàng: nhát thế thì thể nào cũng có ngày bị bóp mũi",
    example: "nhát thế thì thể nào cũng có ngày bị bóp mũi",
  },
  {
    word: "bóp nặn",
    part_of_speech: "động từ",
    meaning:
      "(kẻ có quyền, có chức) bòn rút, vơ vét đến cùng kiệt: đe doạ để bóp nặn, vơ vét",
    example: "đe doạ để bóp nặn, vơ vét",
  },
  {
    word: "bóp méo",
    part_of_speech: "động từ",
    meaning:
      "trình bày hoặc phản ánh cho sai lệch đi, do dụng ý không tốt: bóp méo sự thật * thông tin bị sai lạc, bóp méo",
    example: "bóp méo sự thật * thông tin bị sai lạc, bóp méo",
  },
  {
    word: "bóp nghẹt",
    part_of_speech: "động từ",
    meaning:
      "không để cho phát triển, nhằm dần dần thủ tiêu: bóp nghẹt quyền tự do dân chủ",
    example: "bóp nghẹt quyền tự do dân chủ",
  },
  {
    word: "bọt",
    part_of_speech: "danh từ",
    meaning:
      "đám bong bóng kết lại với nhau trên bề mặt chất lỏng: cốc bia sủi bọt * bọt xà phòng",
    example: "cốc bia sủi bọt * bọt xà phòng",
  },
  {
    word: "bóp trán",
    part_of_speech: "động từ",
    meaning: "cố sức suy tính một cách vất vả: bóp trán suy nghĩ",
    example: "bóp trán suy nghĩ",
  },
  {
    word: "bọt bèo",
    part_of_speech: "danh từ",
    meaning: "như bèo bọt: thân phận bọt bèo",
    example: "thân phận bọt bèo",
  },
  {
    word: "bót",
    part_of_speech: "danh từ",
    meaning:
      "nơi đóng quân nhỏ hoặc trạm canh gác của binh lính, cảnh sát dưới chế độ thực dân: bốt cảnh sát * bốt gác * giặc đóng bốt trong làng",
    example: "bốt cảnh sát * bốt gác * giặc đóng bốt trong làng",
  },
  {
    word: "bót",
    part_of_speech: "danh từ",
    meaning: "giày cổ cao đến gần đầu gối: chân đi đôi bốt trắng",
    example: "chân đi đôi bốt trắng",
  },
  {
    word: "box",
    part_of_speech: "danh từ",
    meaning: "(Khẩu ngữ) quyền Anh: đấu box * đấm box",
    example: "đấu box * đấm box",
  },
  {
    word: "bồ",
    part_of_speech: "danh từ",
    meaning: "(Khẩu ngữ) nhân tình, người yêu: có bồ * cặp bồ",
    example: "có bồ * cặp bồ",
  },
  {
    word: "bồ",
    part_of_speech: "danh từ",
    meaning:
      "(Phương ngữ) từ dùng để gọi người bạn thân một cách thân mật: thỉnh thoảng lại chơi nghe bồ!",
    example: "thỉnh thoảng lại chơi nghe bồ!",
  },
  {
    word: "bồ",
    part_of_speech: "danh từ",
    meaning:
      'đồ đựng đan bằng tre, nứa, có thành cao, miệng tròn và rộng, thường có nắp đậy: "Lúa khô anh đổ vào bồ, Cau già róc vỏ phơi khô để dành." (Cdao)',
    example: 'Lúa khô anh đổ vào bồ, Cau già róc vỏ phơi khô để dành." (Cdao)',
  },
  {
    word: "bồ",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ) cót: bồ lúa",
    example: "bồ lúa",
  },
  {
    word: "bô",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng giống cái chậu nhỏ, thường có nắp đậy và quai cầm, được làm bằng sắt tráng men hoặc nhựa, để đại tiện, tiểu tiện: đổ bô nước giải * bé đã biết ngồi bô",
    example: "đổ bô nước giải * bé đã biết ngồi bô",
  },
  {
    word: "bô",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) thùng bằng sắt rất to, đặt ở nơi công cộng để gom đựng rác thải: bô rác",
    example: "bô rác",
  },
  {
    word: "bô",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ, khẩu ngữ) ống xả: khói từ các ống bô xả ra mù mịt * bị bỏng bô * xe máy thủng bô",
    example: "khói từ các ống bô xả ra mù mịt * bị bỏng bô * xe máy thủng bô",
  },
  {
    word: "bộ",
    part_of_speech: "danh từ",
    meaning:
      "những cái biểu hiện ra bên ngoài của một con người, qua cử chỉ, dáng vẻ, v.v. (nói tổng quát): làm ra bộ không hiểu * nét mặt trầm ngâm, bộ suy nghĩ lung lắm!",
    example: "làm ra bộ không hiểu * nét mặt trầm ngâm, bộ suy nghĩ lung lắm!",
  },
  {
    word: "bộ",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) khả năng, năng lực xét qua cử chỉ, dáng vẻ bề ngoài, nhìn một cách tổng quát (thường hàm ý coi thường): bộ nó thì làm ăn gì!",
    example: "bộ nó thì làm ăn gì!",
  },
  {
    word: "bộ",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp gồm những vật cùng loại hoặc thường được dùng phối hợp cùng với nhau, làm thành một chỉnh thể: bộ quần áo * bộ bàn ghế * sách trọn bộ 5 tập",
    example: "bộ quần áo * bộ bàn ghế * sách trọn bộ 5 tập",
  },
  {
    word: "bộ",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp gồm một số bộ phận của máy móc hay thiết bị có một chức năng, công dụng nhất định nào đó: bộ khuếch đại âm thanh * bộ giảm tốc của ô tô",
    example: "bộ khuếch đại âm thanh * bộ giảm tốc của ô tô",
  },
  {
    word: "bộ",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị phân loại sinh học, dưới lớp, trên họ: bộ rùa thuộc lớp bò sát",
    example: "bộ rùa thuộc lớp bò sát",
  },
  {
    word: "bộ",
    part_of_speech: "danh từ",
    meaning:
      "nhóm phân loại chữ Hán, dựa trên phần giống nhau về hình thể: cách tra từ điển tiếng Hán theo bộ",
    example: "cách tra từ điển tiếng Hán theo bộ",
  },
  {
    word: "bộ",
    part_of_speech: "danh từ",
    meaning:
      "cơ quan trung ương của bộ máy nhà nước, lãnh đạo và quản lí một ngành công tác: bộ công an * bộ giáo dục * bộ và các cơ quan ngang bộ",
    example: "bộ công an * bộ giáo dục * bộ và các cơ quan ngang bộ",
  },
  {
    word: "bộ",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng trong tên gọi của một vài cơ quan chỉ huy, lãnh đạo cấp cao: bộ tổng tham mưu * bộ chỉ huy * bộ chính trị",
    example: "bộ tổng tham mưu * bộ chỉ huy * bộ chính trị",
  },
  {
    word: "bộ",
    part_of_speech: "danh từ",
    meaning:
      "mặt đất, đất liền, phân biệt với đường thuỷ, đường hàng không: bộ binh * giao thông đường bộ",
    example: "bộ binh * giao thông đường bộ",
  },
  {
    word: "bộ",
    part_of_speech: "danh từ",
    meaning:
      "bước chân, coi là phương thức đi lại, phân biệt với việc dùng phương tiện giao thông (nói khái quát): xe hỏng, phải dắt bộ một đoạn * đi bộ",
    example: "xe hỏng, phải dắt bộ một đoạn * đi bộ",
  },
  {
    word: "bộ",
    part_of_speech: "tính từ",
    meaning:
      "(làm việc gì) không dùng công cụ, vũ khí, chỉ bằng tay không, chân không: tra tấn bằng các loại đòn bộ",
    example: "tra tấn bằng các loại đòn bộ",
  },
  {
    word: "bỗ bã",
    part_of_speech: "tính từ",
    meaning: "vụng về, thô lỗ, không có ý tứ: ăn nói bỗ bã",
    example: "ăn nói bỗ bã",
  },
  {
    word: "bỗ bã",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) (bữa ăn, thức ăn) đầy đủ nhưng không được ngon, do cách chế biến sơ sài, cốt lấy nhiều: bữa cơm bỗ bã, cốt lấy no",
    example: "bữa cơm bỗ bã, cốt lấy no",
  },
  {
    word: "bồ bịch",
    part_of_speech: "danh từ",
    meaning:
      "đồ đựng đan bằng tre nứa như bồ, bịch, v.v. (nói khái quát): bồ bịch để ngổn ngang",
    example: "bồ bịch để ngổn ngang",
  },
  {
    word: "bồ bịch",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) người có quan hệ yêu đương, thường là không nghiêm túc hoặc không chính đáng (nói khái quát): mải mê bồ bịch * hai người là vợ chồng hay bồ bịch?",
    example: "mải mê bồ bịch * hai người là vợ chồng hay bồ bịch?",
  },
  {
    word: "bồ bịch",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) cặp bồ: giám đốc bồ bịch với thư kí",
    example: "giám đốc bồ bịch với thư kí",
  },
  {
    word: "bô bô",
    part_of_speech: "tính từ",
    meaning:
      "lớn tiếng nói ra điều không nên nói một cách không có ý tứ: chưa chi đã bô bô cái mồm!",
    example: "chưa chi đã bô bô cái mồm!",
  },
  {
    word: "bố",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) cha (có thể dùng để xưng gọi): bố nào con nấy * bố chồng",
    example: "bố nào con nấy * bố chồng",
  },
  {
    word: "bố",
    part_of_speech: "danh từ",
    meaning:
      "con vật đực thuộc thế hệ trước, trực tiếp sinh ra thế hệ sau: lựa chọn cá bố, cá mẹ",
    example: "lựa chọn cá bố, cá mẹ",
  },
  {
    word: "bố",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) từ dùng để gọi người lớn tuổi, đáng bậc cha (tỏ ý thân mật hoặc vui đùa): mời bố đến nhà con chơi * bố già",
    example: "mời bố đến nhà con chơi * bố già",
  },
  {
    word: "bố",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) từ dùng để gọi người đàn ông bằng lứa hoặc trẻ em trai (hàm ý đùa nghịch hoặc trách cứ): nghịch vừa vừa thôi bố ạ! * thôi đi mấy bố!",
    example: "nghịch vừa vừa thôi bố ạ! * thôi đi mấy bố!",
  },
  {
    word: "bố",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) cỡ lớn, to (thường nói về chai lọ): chai bố",
    example: "chai bố",
  },
  {
    word: "bố",
    part_of_speech: "danh từ",
    meaning:
      "(thông tục) từ dùng trong tiếng rủa, biểu thị ý hơi bực mình: nói thế thì bố ai mà biết được * kệ bố nó!",
    example: "nói thế thì bố ai mà biết được * kệ bố nó!",
  },
  {
    word: "bố",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) cây đay.",
    example: "giày bố * áo may bằng vải bố",
  },
  {
    word: "bố",
    part_of_speech: "động từ",
    meaning: "(phương ngữ, khẩu ngữ) ruồng bố (nói tắt): giặc bố ngoài bờ sông",
    example: "giặc bố ngoài bờ sông",
  },
  {
    word: "bổ bán",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) chia phần để bắt phải đóng góp cho đủ số đã định (nói khái quát): khoản đó nên bổ bán theo đầu người",
    example: "khoản đó nên bổ bán theo đầu người",
  },
  {
    word: "bổ",
    part_of_speech: "động từ",
    meaning:
      '(phương ngữ) ngã: chạy bổ sấp bổ ngửa * "Mặc ai bổ ngả bổ nghiêng, Anh đây đứng vững như kiềng ba chân." (ca dao)',
    example:
      'chạy bổ sấp bổ ngửa * "Mặc ai bổ ngả bổ nghiêng, Anh đây đứng vững như kiềng ba chân." (ca dao)',
  },
  {
    word: "bổ",
    part_of_speech: "động từ",
    meaning:
      "giơ cao và giáng mạnh cho lưỡi sắc cắm sâu xuống làm cho tách ra, vỡ ra: bổ củi * đầu đau như búa bổ",
    example: "bổ củi * đầu đau như búa bổ",
  },
  {
    word: "bổ",
    part_of_speech: "động từ",
    meaning:
      'dùng lưỡi dao cắt để chia quả cây làm nhiều phần theo chiều dọc: bổ cam * "Yêu nhau cau sáu bổ ba, Ghét nhau cau sáu bổ ra làm mười." (ca dao)',
    example:
      'bổ cam * "Yêu nhau cau sáu bổ ba, Ghét nhau cau sáu bổ ra làm mười." (ca dao)',
  },
  {
    word: "bổ",
    part_of_speech: "động từ",
    meaning: "lao mạnh toàn thân: nhảy bổ vào * mọi người bổ đi tìm",
    example: "nhảy bổ vào * mọi người bổ đi tìm",
  },
  {
    word: "bổ",
    part_of_speech: "động từ",
    meaning:
      "(cũ) chia phần để bắt phải đóng góp cho đủ số đã định: bổ theo đầu người",
    example: "bổ theo đầu người",
  },
  {
    word: "bổ",
    part_of_speech: "động từ",
    meaning: "(hiếm) như bủa: bị bổ vây bốn phía",
    example: "bị bổ vây bốn phía",
  },
  {
    word: "bổ",
    part_of_speech: "tính từ",
    meaning:
      "có tác dụng tăng thêm chất dinh dưỡng, tăng thêm sức khoẻ cho cơ thể: thuốc bổ * chất bổ",
    example: "thuốc bổ * chất bổ",
  },
  {
    word: "bộ binh",
    part_of_speech: "danh từ",
    meaning:
      "binh chủng của lục quân, quân sĩ đi bộ tác chiến (khi có chiến tranh): đơn vị bộ binh * súng bộ binh",
    example: "đơn vị bộ binh * súng bộ binh",
  },
  {
    word: "bồ cào",
    part_of_speech: "động từ",
    meaning: "san bằng hoặc làm nhỏ đất, làm cỏ bằng cái cào: cào đất * cào cỏ",
    example: "cào đất * cào cỏ",
  },
  {
    word: "bồ cào",
    part_of_speech: "động từ",
    meaning:
      "ấn các móng nhọn hoặc những vật tương tự vào và kéo mạnh trên bề mặt: quần áo bị gai cào rách * bị mèo cào",
    example: "quần áo bị gai cào rách * bị mèo cào",
  },
  {
    word: "bộ cánh",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) bộ quần áo đẹp để diện: thắng bộ cánh mới",
    example: "thắng bộ cánh mới",
  },
  {
    word: "bố cáo",
    part_of_speech: "động từ",
    meaning:
      "thông báo rộng rãi cho mọi người biết về một sự kiện quan trọng: bố cáo thành lập công ti",
    example: "bố cáo thành lập công ti",
  },
  {
    word: "bố cáo",
    part_of_speech: "danh từ",
    meaning:
      "bản thông báo cho mọi người biết về một sự kiện quan trọng: dán bố cáo truy nã tội phạm",
    example: "dán bố cáo truy nã tội phạm",
  },
  {
    word: "bồ câu",
    part_of_speech: "danh từ",
    meaning:
      "chim nuôi để làm cảnh và ăn thịt, cánh dài, bay giỏi, mắt tròn đẹp và sáng, mỏ yếu; được dùng làm biểu tượng của hoà bình: chim bồ câu",
    example: "chim bồ câu",
  },
  {
    word: "ốc",
    part_of_speech: "danh từ",
    meaning:
      "động vật thân mềm có vỏ cứng và xoắn, có nhiều loài khác nhau, sống ở nước hoặc ở cạn, một số loài thịt ăn được: mò cua bắt ốc",
    example: "mò cua bắt ốc",
  },
  {
    word: "ô-lim-pích",
    part_of_speech: "danh từ",
    meaning:
      "đại hội thể dục thể thao quốc tế, dành riêng cho các vận động viên nghiệp dư, thường tổ chức bốn năm một lần: vô địch olympic",
    example: "vô địch olympic",
  },
  {
    word: "ộc",
    part_of_speech: "động từ",
    meaning:
      "trào mạnh, tuôn mạnh từ trong ra một cách đột ngột: máu ộc ra đằng miệng",
    example: "máu ộc ra đằng miệng",
  },
  {
    word: "ốc nhồi",
    part_of_speech: "danh từ",
    meaning:
      "ốc nước ngọt tròn và to, vỏ bóng, sống ở ao, ruộng: mắt ốc nhồi (mắt to và lồi)",
    example: "mắt ốc nhồi (mắt to và lồi)",
  },
  {
    word: "ôi",
    part_of_speech: "tính từ",
    meaning:
      "(thức ăn) bắt đầu có mùi khó ngửi, không còn tươi ngon nữa: miếng thịt ôi * của rẻ là của ôi (tng)",
    example: "miếng thịt ôi * của rẻ là của ôi (tng)",
  },
  {
    word: "ôi",
    part_of_speech: "cảm từ",
    meaning:
      "tiếng thốt ra biểu lộ sự xúc động mạnh mẽ trước điều bất ngờ: ôi! thật thế à? * ôi! đông quá!",
    example: "ôi! thật thế à? * ôi! đông quá!",
  },
  {
    word: "ôi",
    part_of_speech: "cảm từ",
    meaning:
      'tiếng thốt ra biểu lộ ý than thở hoặc để bày tỏ tình cảm tha thiết: "Thương chàng lắm lắm chàng ôi!, Biết đâu thanh vắng mà ngồi thở than?" (ca dao)',
    example:
      'Thương chàng lắm lắm chàng ôi!, Biết đâu thanh vắng mà ngồi thở than?" (ca dao)',
  },
  {
    word: "ối",
    part_of_speech: "danh từ",
    meaning: "màng ối (nói tắt): vỡ ối * kiểm tra nước ối",
    example: "vỡ ối * kiểm tra nước ối",
  },
  {
    word: "ối",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) nhiều lắm, như không kể xiết: còn ối việc phải làm * ở đời có ối người tử tế",
    example: "còn ối việc phải làm * ở đời có ối người tử tế",
  },
  {
    word: "ối",
    part_of_speech: "cảm từ",
    meaning:
      "tiếng thốt ra khi bị đau, bị tai hoạ bất ngờ: ối! đau quá! * ối làng nước ơi! cứu tôi với!",
    example: "ối! đau quá! * ối làng nước ơi! cứu tôi với!",
  },
  {
    word: "ôi dào",
    part_of_speech: "cảm từ",
    meaning:
      "tiếng thốt ra biểu lộ ý chán nản, thiếu tin tưởng: ôi dào, chuyên nghiệp còn chẳng ăn ai nữa là nghiệp dư",
    example: "ôi dào, chuyên nghiệp còn chẳng ăn ai nữa là nghiệp dư",
  },
  {
    word: "ôi chao",
    part_of_speech: "cảm từ",
    meaning:
      "tiếng thốt ra biểu lộ sự xúc động mạnh đến ngạc nhiên, sửng sốt: ôi chao, đẹp quá! * ôi chao, mới đấy mà đã mấy năm rồi!",
    example: "ôi chao, đẹp quá! * ôi chao, mới đấy mà đã mấy năm rồi!",
  },
  {
    word: "ôi chao",
    part_of_speech: "cảm từ",
    meaning:
      "tiếng thốt ra như tiếng than, biểu thị sự phàn nàn, than thở: ôi chao, còn gì nữa mà mong!",
    example: "ôi chao, còn gì nữa mà mong!",
  },
  {
    word: "ôi thôi",
    part_of_speech: "cảm từ",
    meaning:
      'tiếng thốt ra biểu lộ sự than tiếc, thất vọng trước điều không hay vừa xảy ra: "Ôi thôi con vượn lìa cây, Đoái xem phong cảnh, hội này đã xa." (ca dao)',
    example:
      'Ôi thôi con vượn lìa cây, Đoái xem phong cảnh, hội này đã xa." (ca dao)',
  },
  {
    word: "ốm",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) gầy: con bé trông ốm quá!",
    example: "con bé trông ốm quá!",
  },
  {
    word: "ôm",
    part_of_speech: "động từ",
    meaning:
      "vòng hai tay qua để giữ sát vào lòng, vào người: ôm eo * ôm con vào lòng * bé quàng tay ôm lấy cổ mẹ",
    example: "ôm eo * ôm con vào lòng * bé quàng tay ôm lấy cổ mẹ",
  },
  {
    word: "ôm",
    part_of_speech: "động từ",
    meaning: "giữ mãi, nuôi mãi trong lòng: ôm mộng làm giàu * ôm mối thù",
    example: "ôm mộng làm giàu * ôm mối thù",
  },
  {
    word: "ôm",
    part_of_speech: "danh từ",
    meaning:
      "lượng vừa nằm gọn trong một vòng tay: một ôm quần áo * vay mấy ôm củi",
    example: "một ôm quần áo * vay mấy ôm củi",
  },
  {
    word: "ôm chầm",
    part_of_speech: "động từ",
    meaning:
      "ôm và ghì chặt lấy vào lòng bằng một động tác rất nhanh và đột ngột: bé ôm chầm lấy mẹ",
    example: "bé ôm chầm lấy mẹ",
  },
  {
    word: "ôm ấp",
    part_of_speech: "động từ",
    meaning: "ôm vào lòng với tình cảm tha thiết, âu yếm: ôm ấp con vào lòng",
    example: "ôm ấp con vào lòng",
  },
  {
    word: "ôm ấp",
    part_of_speech: "động từ",
    meaning:
      "nuôi giữ trong lòng một cách trân trọng, tha thiết: ôm ấp mộng văn chương * ôm ấp hi vọng",
    example: "ôm ấp mộng văn chương * ôm ấp hi vọng",
  },
  {
    word: "ốm đau",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) gầy: con bé trông ốm quá!",
    example: "con bé trông ốm quá!",
  },
  {
    word: "ôm chân",
    part_of_speech: "động từ",
    meaning:
      "ví hành động luồn cúi, bợ đỡ một cách đê hèn: diệt trừ kẻ ôm chân giặc",
    example: "diệt trừ kẻ ôm chân giặc",
  },
  {
    word: "ôm đồm",
    part_of_speech: "động từ",
    meaning: "(hiếm) mang theo quá nhiều thứ: mang vác ôm đồm",
    example: "mang vác ôm đồm",
  },
  {
    word: "ôm đồm",
    part_of_speech: "động từ",
    meaning:
      "tự nhận làm quá nhiều việc, kể cả những việc lẽ ra phải để người khác làm, cho nên làm không xuể: ôm đồm nhiều việc * tính hay ôm đồm",
    example: "ôm đồm nhiều việc * tính hay ôm đồm",
  },
  {
    word: "ốm đòn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) bị đòn rất đau (thường dùng với ý doạ dẫm): cứ lười nhác thì ốm đòn!",
    example: "cứ lười nhác thì ốm đòn!",
  },
  {
    word: "ốm nhách",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) gầy: con bé trông ốm quá!",
    example: "con bé trông ốm quá!",
  },
  {
    word: "ốm o",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) gầy: con bé trông ốm quá!",
    example: "con bé trông ốm quá!",
  },
  {
    word: "ồm ồm",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả giọng nói to, trầm và hơi rè, nghe không được rành rọt: tiếng loa ồm ồm * giọng nói ồm ồm",
    example: "tiếng loa ồm ồm * giọng nói ồm ồm",
  },
  {
    word: "ồm ộp",
    part_of_speech: "tính từ",
    meaning: "như ộp oạp (ng1): ếch nhái kêu ồm ộp",
    example: "ếch nhái kêu ồm ộp",
  },
  {
    word: "ốm xác",
    part_of_speech: "tính từ",
    meaning:
      "(thông tục) cực nhọc, làm khổ cái thân mà không được lợi ích gì: chả được cái gì, chỉ ốm xác! * đi làm gì cho ốm xác!",
    example: "chả được cái gì, chỉ ốm xác! * đi làm gì cho ốm xác!",
  },
  {
    word: "ốm nhom",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) gầy: con bé trông ốm quá!",
    example: "con bé trông ốm quá!",
  },
  {
    word: "ôn",
    part_of_speech: "động từ",
    meaning:
      "học lại hoặc nhắc lại để nhớ điều đã học hoặc đã trải qua: ôn bài * ôn lại những kỉ niệm thời thơ ấu * văn ôn võ luyện",
    example: "ôn bài * ôn lại những kỉ niệm thời thơ ấu * văn ôn võ luyện",
  },
  {
    word: "ốm yếu",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) gầy: con bé trông ốm quá!",
    example: "con bé trông ốm quá!",
  },
  {
    word: "ổn",
    part_of_speech: "tính từ",
    meaning:
      "yên, không có gì vướng mắc, không có gì lôi thôi phải giải quyết: công việc đã tạm ổn * nói như vậy là không ổn",
    example: "công việc đã tạm ổn * nói như vậy là không ổn",
  },
  {
    word: "ồn",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều âm thanh, tiếng động lẫn lộn, làm cho khó nghe, khó chịu: đóng cửa cho đỡ ồn * làm ồn * ồn quá, chẳng nghe thấy gì!",
    example: "đóng cửa cho đỡ ồn * làm ồn * ồn quá, chẳng nghe thấy gì!",
  },
  {
    word: "ồn ã",
    part_of_speech: "tính từ",
    meaning: "có nhiều âm thanh hỗn độn làm náo động lên: tiếng cười nói ồn ã",
    example: "tiếng cười nói ồn ã",
  },
  {
    word: "ồn ào",
    part_of_speech: "tính từ",
    meaning: "ồn (nói khái quát): đường phố ồn ào, náo nhiệt",
    example: "đường phố ồn ào, náo nhiệt",
  },
  {
    word: "ồn ào",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) thích làm ồn ào để gây sự chú ý, tạo cảm giác khó chịu: cách sống ồn ào, sôi nổi * lối quảng cáo ồn ào",
    example: "cách sống ồn ào, sôi nổi * lối quảng cáo ồn ào",
  },
  {
    word: "ôn con",
    part_of_speech: "danh từ",
    meaning:
      '(thông tục) tổ hợp dùng làm tiếng rủa, mắng trẻ con hay người ít tuổi: thằng ôn con! * "Quân này, ôn con mà đã gan hơn tướng cướp!" (VTrPhụng; 15)',
    example:
      'thằng ôn con! * "Quân này, ôn con mà đã gan hơn tướng cướp!" (VTrPhụng; 15)',
  },
  {
    word: "ôn dịch",
    part_of_speech: "danh từ",
    meaning:
      "bệnh dịch (nói khái quát); thường dùng làm tiếng chửi rủa: đồ ôn dịch!",
    example: "đồ ôn dịch!",
  },
  {
    word: "ôn tập",
    part_of_speech: "động từ",
    meaning:
      "học và ôn luyện lại những điều đã học để nắm chắc, để nhớ lâu: ôn tập hè * ôn tập một cách có hệ thống",
    example: "ôn tập hè * ôn tập một cách có hệ thống",
  },
  {
    word: "ôn hoà",
    part_of_speech: "tính từ",
    meaning:
      "(khí hậu) ấm áp, dễ chịu, không nóng quá, cũng không lạnh quá: khí hậu ôn hoà, dễ chịu",
    example: "khí hậu ôn hoà, dễ chịu",
  },
  {
    word: "ôn hoà",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra điềm đạm, không gay gắt, không nóng nảy trong quan hệ đối xử: thái độ ôn hoà * ăn nói ôn hoà",
    example: "thái độ ôn hoà * ăn nói ôn hoà",
  },
  {
    word: "ôn hoà",
    part_of_speech: "tính từ",
    meaning:
      "có tư tưởng, quan điểm chính trị không tán thành đấu tranh quyết liệt, hoặc không quá khích: đường lối ôn hoà * phái ôn hoà",
    example: "đường lối ôn hoà * phái ôn hoà",
  },
  {
    word: "ổn định",
    part_of_speech: "",
    meaning:
      "ở trạng thái yên ổn, không còn có những biến động, thay đổi đáng kể: ổn định cuộc sống * giá cả ổn định",
    example: "ổn định cuộc sống * giá cả ổn định",
  },
  {
    word: "ôn đới",
    part_of_speech: "danh từ",
    meaning:
      "đới nằm giữa cận nhiệt đới và hàn đới, có nhiệt độ thay đổi rõ rệt theo mùa: vùng ôn đới * khí hậu ôn đới",
    example: "vùng ôn đới * khí hậu ôn đới",
  },
  {
    word: "ôn luyện",
    part_of_speech: "động từ",
    meaning:
      "ôn lại, tập lại nhiều lần để nắm chắc, để cho thành thạo (nói khái quát): ôn luyện bài vở để thi đại học",
    example: "ôn luyện bài vở để thi đại học",
  },
  {
    word: "ôn tồn",
    part_of_speech: "tính từ",
    meaning:
      "(nói năng) nhẹ nhàng, từ tốn, tỏ ra nhã nhặn khiến dễ tiếp thu: ôn tồn khuyên bảo",
    example: "ôn tồn khuyên bảo",
  },
  {
    word: "ôn vật",
    part_of_speech: "danh từ",
    meaning: "(thông tục) như ôn con (nhưng nghĩa mạnh hơn): đồ ôn vật!",
    example: "đồ ôn vật!",
  },
  {
    word: "ông",
    part_of_speech: "danh từ",
    meaning:
      "người đàn ông sinh ra hoặc thuộc thế hệ sinh ra cha hoặc mẹ (có thể dùng để xưng gọi): ông nội * ông và cháu",
    example: "ông nội * ông và cháu",
  },
  {
    word: "ông",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ hoặc gọi người đàn ông đứng tuổi hoặc được kính trọng: ông giáo * ông bộ trưởng * ông lão hàng xóm",
    example: "ông giáo * ông bộ trưởng * ông lão hàng xóm",
  },
  {
    word: "ông",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) từ người đàn ông dùng để tự xưng khi tức giận, muốn tỏ vẻ trịch thượng hoặc hách dịch: mày sẽ biết tay ông!",
    example: "mày sẽ biết tay ông!",
  },
  {
    word: "ông",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) từ dùng để gọi người đàn ông ngang hàng hoặc hàng dưới một cách thân mật: ông anh vợ * ông bạn nối khố * ông em rể",
    example: "ông anh vợ * ông bạn nối khố * ông em rể",
  },
  {
    word: "ông",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để gọi tôn vật được sùng bái hay kiêng sợ: ông trời * ông công ông táo * ông thiên lôi",
    example: "ông trời * ông công ông táo * ông thiên lôi",
  },
  {
    word: "ổn thoả",
    part_of_speech: "tính từ",
    meaning:
      "yên ổn, đâu vào đấy, không còn khúc mắc gì nữa: mọi việc được thu xếp ổn thoả",
    example: "mọi việc được thu xếp ổn thoả",
  },
  {
    word: "ống",
    part_of_speech: "danh từ",
    meaning: "vật rỗng, hình trụ dài: ống máng * ống thoát nước * ống giang",
    example: "ống máng * ống thoát nước * ống giang",
  },
  {
    word: "ông bà",
    part_of_speech: "danh từ",
    meaning:
      "ông và bà (nói gộp); thường dùng để chỉ chung tổ tiên, trong quan hệ với con cháu: ruộng vườn của ông bà để lại",
    example: "ruộng vườn của ông bà để lại",
  },
  {
    word: "ống bơ",
    part_of_speech: "danh từ",
    meaning: "vỏ đồ hộp nói chung: nhặt ống bơ",
    example: "nhặt ống bơ",
  },
  {
    word: "ông bầu",
    part_of_speech: "danh từ",
    meaning:
      "người đàn ông làm bầu cho một gánh hát, một ca sĩ, một đội thể thao, v.v.: ông bầu ca nhạc * ông bầu của đội bóng",
    example: "ông bầu ca nhạc * ông bầu của đội bóng",
  },
  {
    word: "ống chân",
    part_of_speech: "danh từ",
    meaning:
      "phần của chi dưới từ đầu gối đến cổ chân: hai ống chân gầy như que củi",
    example: "hai ống chân gầy như que củi",
  },
  {
    word: "ống bô",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận bằng kim loại, hình ống dài được nối với buồng đốt của động cơ để đưa khí thải ra ngoài và giảm tiếng ồn: thủng ống xả",
    example: "thủng ống xả",
  },
  {
    word: "ông cha",
    part_of_speech: "danh từ",
    meaning:
      "những người thuộc các thế hệ trước, trong quan hệ với những người thuộc các thế hệ sau (nói tổng quát): tiếp bước ông cha * phát huy truyền thống của ông cha",
    example: "tiếp bước ông cha * phát huy truyền thống của ông cha",
  },
  {
    word: "ông hoàng",
    part_of_speech: "danh từ",
    meaning:
      "hoàng tử, hoàng thân; thường dùng để ví người giàu sang, sung sướng: ông hoàng, bà chúa * sướng như ông hoàng",
    example: "ông hoàng, bà chúa * sướng như ông hoàng",
  },
  {
    word: "ông già",
    part_of_speech: "danh từ",
    meaning:
      "người đàn ông đã cao tuổi; thường dùng để chỉ cha mình hoặc người thuộc bậc cha mình trong cách nói thân mật: ông già tôi hiền lắm!",
    example: "ông già tôi hiền lắm!",
  },
  {
    word: "ống khói",
    part_of_speech: "danh từ",
    meaning: "ống để dẫn cho khói, bụi thoát lên cao: ống khói nhà máy",
    example: "ống khói nhà máy",
  },
  {
    word: "ông mãnh",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) người đàn ông nhiều tuổi chết khi chưa vợ: bà cô, ông mãnh",
    example: "bà cô, ông mãnh",
  },
  {
    word: "ông mãnh",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) người đàn ông hay đứa con trai láu lỉnh, tinh quái (dùng để gọi đùa hoặc làm tiếng rủa mắng): nghịch vừa thôi, ông mãnh!",
    example: "nghịch vừa thôi, ông mãnh!",
  },
  {
    word: "ông địa",
    part_of_speech: "danh từ",
    meaning:
      "nhân vật thấp béo, bụng phệ, mặt tròn, tay cầm quạt, trong đám múa sư tử, múa lân.",
    example: "cúng ông địa",
  },
  {
    word: "ống kính",
    part_of_speech: "danh từ",
    meaning:
      "hệ thống thấu kính được lắp ghép thành hình ống, dùng để thu hình ảnh của vật vào phim hoặc để chiếu phim lên màn ảnh: ống kính máy quay phim",
    example: "ống kính máy quay phim",
  },
  {
    word: "ống nghe",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận biến đổi dao động điện thành dao động âm để phát thành âm thanh nghe được: ống nghe máy điện thoại",
    example: "ống nghe máy điện thoại",
  },
  {
    word: "ông phệnh",
    part_of_speech: "danh từ",
    meaning:
      "đồ chơi trẻ con có hình một người béo phệ ngồi để hở bụng to phình, thường làm bằng sành, sứ hoặc gỗ: ngồi như ông phệnh",
    example: "ngồi như ông phệnh",
  },
  {
    word: "ống nói",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận chuyển dao động âm thành dao động điện: ống nói điện thoại * nhấc ống nói",
    example: "ống nói điện thoại * nhấc ống nói",
  },
  {
    word: "ống nhòm",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ quang học dùng để quan sát những vật ở xa: quan sát bằng ống nhòm",
    example: "quan sát bằng ống nhòm",
  },
  {
    word: "ông ổng",
    part_of_speech: "tính từ",
    meaning:
      "(thông tục) từ gợi tả tiếng chó sủa hay tiếng nói tuôn ra thành chuỗi to, trầm, nghe khó chịu: chó sủa ông ổng * hát ông ổng",
    example: "chó sủa ông ổng * hát ông ổng",
  },
  {
    word: "ồng ộc",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng chất lỏng tuôn mạnh, chảy dồn mạnh: nôn ra ồng ộc * nước xối ồng ộc từ trên máng xuống đất",
    example: "nôn ra ồng ộc * nước xối ồng ộc từ trên máng xuống đất",
  },
  {
    word: "ông táo",
    part_of_speech: "danh từ",
    meaning: "(hiếm) đầu rau.",
    example: "cúng ông táo",
  },
  {
    word: "ông tơ",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) Nguyệt Lão, về mặt chuyên dùng dây tơ hồng xe duyên cho người đời: "Ai xinh thì mặc ai xinh, Ông Tơ chỉ quyết xe mình với ta." (ca dao)',
    example:
      'Ai xinh thì mặc ai xinh, Ông Tơ chỉ quyết xe mình với ta." (ca dao)',
  },
  {
    word: "ông từ",
    part_of_speech: "danh từ",
    meaning: "người trông coi đền, miếu: lừ đừ như ông từ vào đền (tng)",
    example: "lừ đừ như ông từ vào đền (tng)",
  },
  {
    word: "ông tổ",
    part_of_speech: "danh từ",
    meaning: "người sinh ra, lập ra một dòng họ: ông tổ họ Nguyễn",
    example: "ông tổ họ Nguyễn",
  },
  {
    word: "ông tổ",
    part_of_speech: "danh từ",
    meaning: "người đã sáng lập ra, gây dựng ra một nghề gì: ông tổ nghề dệt",
    example: "ông tổ nghề dệt",
  },
  {
    word: "ống tay áo",
    part_of_speech: "danh từ",
    meaning: "phần của áo che cánh tay: nuôi ong tay áo (tng)",
    example: "nuôi ong tay áo (tng)",
  },
  {
    word: "ông tơ hồng",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, hiếm) như ông tơ: "Đôi ta như vợ với chồng, Chỉ hiềm một nỗi ông Tơ Hồng chưa xe." (ca dao)',
    example:
      'Đôi ta như vợ với chồng, Chỉ hiềm một nỗi ông Tơ Hồng chưa xe." (ca dao)',
  },
  {
    word: "ông vải",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) ông bà, tổ tiên: bàn thờ ông vải",
    example: "bàn thờ ông vải",
  },
  {
    word: "ông xã",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) từ dùng để gọi người chồng một cách thân mật, đùa vui: ông xã nhà tôi * ông xã đã về đó hả?",
    example: "ông xã nhà tôi * ông xã đã về đó hả?",
  },
  {
    word: "ộp oạp",
    part_of_speech: "tính từ",
    meaning: "từ mô phỏng tiếng ếch nhái kêu: ếch nhái kêu ộp oạp",
    example: "ếch nhái kêu ộp oạp",
  },
  {
    word: "ộp oạp",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng bước chân lội dưới bùn nước hoặc tiếng nước vỗ nhẹ vào bờ: tiếng chân lội ộp oạp dưới ruộng * sóng vỗ ộp oạp vào bờ",
    example: "tiếng chân lội ộp oạp dưới ruộng * sóng vỗ ộp oạp vào bờ",
  },
  {
    word: "ốp",
    part_of_speech: "động từ",
    meaning:
      "làm cho áp sát và gắn chặt vào bề mặt một vật khác, làm thành thêm một lớp bên ngoài: tường ốp đá",
    example: "tường ốp đá",
  },
  {
    word: "ốp",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) kèm sát bên cạnh để đốc thúc: bị ốp về đồn",
    example: "bị ốp về đồn",
  },
  {
    word: "ốp lết",
    part_of_speech: "danh từ",
    meaning:
      "món ăn làm bằng trứng để nguyên lòng trắng, lòng đỏ, rán chín tới: bánh mì ốp lết (bánh mì ăn với trứng ốp lết)",
    example: "bánh mì ốp lết (bánh mì ăn với trứng ốp lết)",
  },
  {
    word: "ống xả",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận bằng kim loại, hình ống dài được nối với buồng đốt của động cơ để đưa khí thải ra ngoài và giảm tiếng ồn: thủng ống xả",
    example: "thủng ống xả",
  },
  {
    word: "ôsin",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) tên nhân vật chính trong bộ phim cùng tên của Nhật Bản; dùng để chỉ người phụ nữ giúp việc trong gia đình: thuê ôsin * làm ôsin",
    example: "thuê ôsin * làm ôsin",
  },
  {
    word: "ông xanh",
    part_of_speech: "danh từ",
    meaning:
      '(văn chương) trời, ông trời: "Sống lâu nghe lắm chuyện kì, Trách mình thôi chứ trách gì ông xanh." (ca dao)',
    example:
      'Sống lâu nghe lắm chuyện kì, Trách mình thôi chứ trách gì ông xanh." (ca dao)',
  },
  {
    word: "ốp lát",
    part_of_speech: "động từ",
    meaning:
      "lát vật liệu xây dựng như gạch, đá, gỗ, v.v. trên bề mặt: kĩ thuật ốp lát nền",
    example: "kĩ thuật ốp lát nền",
  },
  {
    word: "ôxy già",
    part_of_speech: "danh từ",
    meaning:
      "chất hoá học có khả năng ôxy hoá, thường được dùng để sát trùng, tẩy vết bẩn: dùng nước ôxy già để rửa vết thương",
    example: "dùng nước ôxy già để rửa vết thương",
  },
  {
    word: "ôxy hoá",
    part_of_speech: "động từ",
    meaning:
      "(quá trình một chất) hoá hợp với oxygen, biến đổi thành oxide: tấm sắt đã bị ôxy hoá",
    example: "tấm sắt đã bị ôxy hoá",
  },
  {
    word: "ờ",
    part_of_speech: "cảm từ",
    meaning:
      "(Khẩu ngữ) tiếng thốt ra, biểu lộ sự đồng tình hoặc sực nhớ ra điều gì: ờ, cứ để đấy cho tôi! * ờ, con bé dạo này xinh thật!",
    example: "ờ, cứ để đấy cho tôi! * ờ, con bé dạo này xinh thật!",
  },
  {
    word: "ơ",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) nồi đất nhỏ dùng để kho nấu thức ăn: một ơ cá kho",
    example: "một ơ cá kho",
  },
  {
    word: "ơ",
    part_of_speech: "cảm từ",
    meaning:
      "tiếng thốt ra biểu lộ sự ngạc nhiên: ơ, sao lại thế? * ơ... thằng này láo nhỉ!",
    example: "ơ, sao lại thế? * ơ... thằng này láo nhỉ!",
  },
  {
    word: "ớ",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) như ngớ: hỏi đến mới ớ người ra * ớ ra, chẳng hiểu gì",
    example: "hỏi đến mới ớ người ra * ớ ra, chẳng hiểu gì",
  },
  {
    word: "ớ",
    part_of_speech: "cảm từ",
    meaning:
      '(khẩu ngữ) tiếng gọi dùng để gọi người ở xa, thường là không quen: "Nửa đêm trăng tắt sao loè, Ngoài ngõ lắm đá, coi què, ớ anh!" (ca dao)',
    example:
      'Nửa đêm trăng tắt sao loè, Ngoài ngõ lắm đá, coi què, ớ anh!" (ca dao)',
  },
  {
    word: "ở",
    part_of_speech: "động từ",
    meaning:
      "sống đời sống riêng thường ngày tại một nơi, một chỗ nào đó: ở nhà số 4 * hai người ở cùng phố * bố mẹ đều ở quê",
    example: "ở nhà số 4 * hai người ở cùng phố * bố mẹ đều ở quê",
  },
  {
    word: "ở",
    part_of_speech: "động từ",
    meaning:
      "có mặt trong một thời gian hoặc một thời điểm nhất định, tại một nơi, một chỗ nào đó: bây giờ tôi đang ở cơ quan * ở có mấy hôm rồi lại đi",
    example: "bây giờ tôi đang ở cơ quan * ở có mấy hôm rồi lại đi",
  },
  {
    word: "ở",
    part_of_speech: "động từ",
    meaning:
      "tiếp tục có mặt tại một nơi nào đó, không rời đi đâu: ở lại chơi thêm vài ngày * kẻ ở, người đi",
    example: "ở lại chơi thêm vài ngày * kẻ ở, người đi",
  },
  {
    word: "ở",
    part_of_speech: "động từ",
    meaning:
      "sinh hoạt thường ngày trong những điều kiện nào đó: ở bẩn * ở sạch",
    example: "ở bẩn * ở sạch",
  },
  {
    word: "ở",
    part_of_speech: "động từ",
    meaning: "đối xử trong đời sống hằng ngày: ở bạc * ở hiền gặp lành (tng)",
    example: "ở bạc * ở hiền gặp lành (tng)",
  },
  {
    word: "ở",
    part_of_speech: "động từ",
    meaning:
      "làm thuê dưới hình thức ăn ở luôn trong nhà chủ, làm các công việc phục dịch thường ngày: đi ở * thằng ở * thân phận đứa ở",
    example: "đi ở * thằng ở * thân phận đứa ở",
  },
  {
    word: "ở",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là nơi, chỗ, khoảng thời gian sự vật hay sự việc được nói đến tồn tại hay diễn ra: đi dự hội nghị ở trên tỉnh * xem phim ở rạp * đau ở vùng thắt lưng",
    example:
      "đi dự hội nghị ở trên tỉnh * xem phim ở rạp * đau ở vùng thắt lưng",
  },
  {
    word: "ở",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là cái hướng vào đó của điều vừa nói đến (thường là một hoạt động tâm lí, tình cảm): tin tưởng ở tương lai * hi vọng ở thế hệ trẻ",
    example: "tin tưởng ở tương lai * hi vọng ở thế hệ trẻ",
  },
  {
    word: "ở ẩn",
    part_of_speech: "động từ",
    meaning:
      "(cũ) ở nơi ít người biết, để lánh đời (nói về nhà nho thời trước): cáo quan về ở ẩn",
    example: "cáo quan về ở ẩn",
  },
  {
    word: "ợ",
    part_of_speech: "động từ",
    meaning:
      "tống khí hoặc những chất gì đó từ dạ dày lên miệng: ợ chua * bò ợ cỏ lên nhai lại",
    example: "ợ chua * bò ợ cỏ lên nhai lại",
  },
  {
    word: "ở đợ",
    part_of_speech: "động từ",
    meaning: "đi ở có thời hạn và lấy công trước: đi ở đợ",
    example: "đi ở đợ",
  },
  {
    word: "ở đậu",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) ở nhờ nhà người khác, có tính chất tạm thời: ăn nhờ ở đậu * ở đậu nhà người quen",
    example: "ăn nhờ ở đậu * ở đậu nhà người quen",
  },
  {
    word: "ở goá",
    part_of_speech: "động từ",
    meaning:
      "không lấy chồng (hoặc vợ) khác, sau khi vợ (hoặc chồng) chết, tuy tuổi đang còn trẻ, và sống như vậy cho đến cuối đời: ở goá nuôi con",
    example: "ở goá nuôi con",
  },
  {
    word: "ơ hay",
    part_of_speech: "cảm từ",
    meaning: "như ô hay: ơ hay cái con bé này, ai bảo mày làm thế?",
    example: "ơ hay cái con bé này, ai bảo mày làm thế?",
  },
  {
    word: "ơ kìa",
    part_of_speech: "cảm từ",
    meaning: "như ô kìa: ơ kìa, đi đâu đấy!",
    example: "ơ kìa, đi đâu đấy!",
  },
  {
    word: "ở không",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) không làm việc gì cả vì không có việc để làm hoặc vì không muốn làm: thất nghiệp, ở không mấy tháng",
    example: "thất nghiệp, ở không mấy tháng",
  },
  {
    word: "ở mướn",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) ở đợ: ở mướn cho một nhà giàu",
    example: "ở mướn cho một nhà giàu",
  },
  {
    word: "ở vậy",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) cứ sống như vậy, độc thân hoặc không lấy vợ khác, chồng khác: ở vậy nuôi con",
    example: "ở vậy nuôi con",
  },
  {
    word: "ở riêng",
    part_of_speech: "động từ",
    meaning:
      "lập gia đình riêng, không còn ở chung với cha mẹ nữa: con cái đều đã ở riêng",
    example: "con cái đều đã ở riêng",
  },
  {
    word: "ơi ới",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả tiếng nhiều người gọi nhau to và liên tiếp từ nơi khác vọng lại: có tiếng gọi ơi ới ngoài ngõ * tiếng rao hàng ơi ới",
    example: "có tiếng gọi ơi ới ngoài ngõ * tiếng rao hàng ơi ới",
  },
  {
    word: "ới",
    part_of_speech: "cảm từ",
    meaning:
      '(văn chương) tiếng dùng để kêu hoặc gọi với ý than vãn, nhắn nhủ: Ới người đội nón chung quai, Chung thầy chung mẹ ghé vai chung tình." (ca dao)',
    example:
      'Ới người đội nón chung quai, Chung thầy chung mẹ ghé vai chung tình." (ca dao)',
  },
  {
    word: "ới",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) gọi, báo cho biết: ới nhau đi * có gì thì ới tôi một tiếng",
    example: "ới nhau đi * có gì thì ới tôi một tiếng",
  },
  {
    word: "ời ời",
    part_of_speech: "tính từ",
    meaning:
      '(khẩu ngữ) từ gợi tả tiếng gọi to và liên tiếp, kéo dài, nghe khó chịu: "Thằng Cuội ngồi gốc cây đa, Để trâu ăn lúa gọi cha ời ời." (ca dao)',
    example:
      'Thằng Cuội ngồi gốc cây đa, Để trâu ăn lúa gọi cha ời ời." (ca dao)',
  },
  {
    word: "ớm",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) cớm: lúa bị ớm nắng",
    example: "lúa bị ớm nắng",
  },
  {
    word: "ơi là",
    part_of_speech: "",
    meaning:
      '(khẩu ngữ) tổ hợp biểu thị một cảm xúc mạnh mẽ của người nói, do chịu tác động trực tiếp của một tính chất nào đó ở mức độ đặc biệt cao: xinh ơi là xinh! * "Ăn trầu thì bỏ quên vôi, Ăn cau bỏ hạt nàng ơi là nàng!" (ca dao)',
    example:
      'xinh ơi là xinh! * "Ăn trầu thì bỏ quên vôi, Ăn cau bỏ hạt nàng ơi là nàng!" (ca dao)',
  },
  {
    word: "ơi",
    part_of_speech: "cảm từ",
    meaning:
      'tiếng gọi dùng để gọi một cách thân mật, thân thiết: mẹ ơi! * "Thuyền ơi có nhớ bến chăng, Bến thì một dạ khăng khăng đợi thuyền." (Cdao)',
    example:
      'mẹ ơi! * "Thuyền ơi có nhớ bến chăng, Bến thì một dạ khăng khăng đợi thuyền." (Cdao)',
  },
  {
    word: "ơi",
    part_of_speech: "cảm từ",
    meaning:
      "(Khẩu ngữ) tiếng đáp dùng để đáp lại tiếng gọi của người ngang hàng hoặc người dưới: (- chị ơi!) - ơi! đợi chị một tí!",
    example: "(- chị ơi!) - ơi! đợi chị một tí!",
  },
  {
    word: "ơi",
    part_of_speech: "cảm từ",
    meaning:
      'tiếng gọi dùng để kêu với ý than vãn: "Trời ơi có thấu tình chăng! Bước sang mười sáu ông trăng gần già." (Cdao)',
    example:
      'Trời ơi có thấu tình chăng! Bước sang mười sáu ông trăng gần già." (Cdao)',
  },
  {
    word: "ỡm ờ",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) ra vẻ ngơ ngẩn như không biết gì cả: biết rồi còn cứ ỡm ờ!",
    example: "biết rồi còn cứ ỡm ờ!",
  },
  {
    word: "ỡm ờ",
    part_of_speech: "tính từ",
    meaning:
      "nửa đùa nửa thật, có ý trêu cợt (thường nói về cách nói năng): trả lời ỡm ờ * ăn nói ỡm ờ",
    example: "trả lời ỡm ờ * ăn nói ỡm ờ",
  },
  {
    word: "ời ợi",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) từ gợi tả tiếng ru hoặc tiếng rao kéo dài giọng và liên tiếp: tiếng rao hàng ời ợi * ru con ời ợi",
    example: "tiếng rao hàng ời ợi * ru con ời ợi",
  },
  {
    word: "ơn",
    part_of_speech: "danh từ",
    meaning:
      'điều làm cho người nào đó, mang lại lợi ích, sự tốt đẹp, được bản thân người ấy nhận thức như là cần phải đền đáp: nhớ ơn * ghi ơn * "Làm ơn ắt hẳn nên ơn, Trời nào phụ kẻ có nhơn bao giờ." (ca dao)',
    example:
      'nhớ ơn * ghi ơn * "Làm ơn ắt hẳn nên ơn, Trời nào phụ kẻ có nhơn bao giờ." (ca dao)',
  },
  {
    word: "ớn",
    part_of_speech: "động từ",
    meaning:
      "có cảm giác lạnh từ trong người lạnh ra và ghê ghê người: người ớn lạnh * lưỡi đao sáng loáng, trông mà ớn xương sống",
    example: "người ớn lạnh * lưỡi đao sáng loáng, trông mà ớn xương sống",
  },
  {
    word: "ớn",
    part_of_speech: "động từ",
    meaning: "chán đến phát ngấy: ăn mãi món đó, ớn quá!",
    example: "ăn mãi món đó, ớn quá!",
  },
  {
    word: "ớn",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) sợ: ớn đòn * ai cũng phải ớn thằng cha đó!",
    example: "ớn đòn * ai cũng phải ớn thằng cha đó!",
  },
  {
    word: "patanh",
    part_of_speech: "danh từ",
    meaning:
      "môn thể thao chơi trượt trên mặt sân cứng bằng một loại giày riêng, đế giày gắn bánh xe có thể xoay theo các hướng: sân trượt patanh * giày patanh",
    example: "sân trượt patanh * giày patanh",
  },
  {
    word: "parabol",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp tất cả các điểm trong mặt phẳng cách đều một điểm cho trước (gọi là tiêu điểm) và một đường thẳng cố định (gọi là đường chuẩn): đường cong parabol",
    example: "đường cong parabol",
  },
  {
    word: "patê",
    part_of_speech: "danh từ",
    meaning:
      "món ăn làm bằng thịt hoặc gan ướp với đường, rượu rồi nghiền nhỏ, bao mỡ lá và hấp chín: bánh mì patê",
    example: "bánh mì patê",
  },
  {
    word: "patinê",
    part_of_speech: "động từ",
    meaning:
      "(hiện tượng xe cơ giới) quay bánh tại chỗ làm cho xe không di chuyển được, do bị sa lầy hoặc bị trượt bánh: xe bị patinê",
    example: "xe bị patinê",
  },
  {
    word: "penalty",
    part_of_speech: "danh từ",
    meaning: "quả phạt đền: được hưởng penalty * đá penalty",
    example: "được hưởng penalty * đá penalty",
  },
  {
    word: "pen-cát-xi-lát",
    part_of_speech: "danh từ",
    meaning:
      "hôm qua (nói tắt): sáng qua * nó vừa đi chiều qua * từ qua tới nay, mọi chuyện cứ rối tinh cả lên",
    example:
      "sáng qua * nó vừa đi chiều qua * từ qua tới nay, mọi chuyện cứ rối tinh cả lên",
  },
  {
    word: "pêđan",
    part_of_speech: "danh từ",
    meaning: "bàn đạp của xe đạp, một số loại xe máy, v.v.: xe đạp hỏng pêđan",
    example: "xe đạp hỏng pêđan",
  },
  {
    word: "pê-nan-ti",
    part_of_speech: "danh từ",
    meaning: "quả phạt đền: được hưởng penalty * đá penalty",
    example: "được hưởng penalty * đá penalty",
  },
  {
    word: "pha",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) đèn pha (nói tắt): xe bị hỏng pha",
    example: "xe bị hỏng pha",
  },
  {
    word: "pha",
    part_of_speech: "danh từ",
    meaning:
      "đại lượng đo bằng đơn vị góc, xác định trạng thái của quá trình dao động tại mỗi thời điểm: dao động cùng pha",
    example: "dao động cùng pha",
  },
  {
    word: "pha",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp các phần của một hệ nhiệt động có cùng các tính chất vật lí và hoá học: hệ ba pha",
    example: "hệ ba pha",
  },
  {
    word: "pha",
    part_of_speech: "danh từ",
    meaning:
      "cảnh diễn ra trong chốc lát, cảnh này nối tiếp cảnh kia trong toàn bộ một sự kiện: pha biểu diễn đẹp mắt * một pha gay cấn",
    example: "pha biểu diễn đẹp mắt * một pha gay cấn",
  },
  {
    word: "pha",
    part_of_speech: "động từ",
    meaning:
      "cho nước sôi vào cho ngấm để tạo thành thức uống: pha cà phê * chè pha hơi đặc",
    example: "pha cà phê * chè pha hơi đặc",
  },
  {
    word: "pha",
    part_of_speech: "động từ",
    meaning:
      "trộn lẫn vào nhau theo tỉ lệ nhất định để tạo thành một hỗn hợp nào đó: pha màu * pha nước chấm * pha nước chanh",
    example: "pha màu * pha nước chấm * pha nước chanh",
  },
  {
    word: "pha",
    part_of_speech: "động từ",
    meaning:
      "có lẫn một ít cái khác vào: đồng pha gang * vải pha nylon * câu nói đùa pha chút trách móc",
    example: "đồng pha gang * vải pha nylon * câu nói đùa pha chút trách móc",
  },
  {
    word: "pha",
    part_of_speech: "động từ",
    meaning:
      'cắt, xẻ một khối nguyên ra thành từng phần để tiện sử dụng vào một mục đích nào đó: pha thịt lợn * "Tre già anh để pha nan, Lớn đan nong né, bé đan giần sàng." (ca dao)',
    example:
      'pha thịt lợn * "Tre già anh để pha nan, Lớn đan nong né, bé đan giần sàng." (ca dao)',
  },
  {
    word: "phá",
    part_of_speech: "danh từ",
    meaning:
      "vùng nước mặn rộng lớn có dải đất, cát chặn ở trước, ngăn cách với biển, thông ra biển bởi một dòng nước hẹp và chảy xiết: phá Tam Giang",
    example: "phá Tam Giang",
  },
  {
    word: "phá",
    part_of_speech: "động từ",
    meaning:
      "làm cho tan vỡ, hư hỏng, cho không còn tồn tại như cũ nữa: mìn phá đá * phá ngôi nhà cũ đi xây lại",
    example: "mìn phá đá * phá ngôi nhà cũ đi xây lại",
  },
  {
    word: "phá",
    part_of_speech: "động từ",
    meaning:
      "làm cho cái cũ không còn giá trị bằng cách tạo ra cái mới, cái có giá trị cao hơn: phá chỉ tiêu cũ * phá kỉ lục thế giới",
    example: "phá chỉ tiêu cũ * phá kỉ lục thế giới",
  },
  {
    word: "phá",
    part_of_speech: "động từ",
    meaning: "(vết thương) lở bung ra: vết thương phá miệng",
    example: "vết thương phá miệng",
  },
  {
    word: "phá",
    part_of_speech: "động từ",
    meaning:
      "phát ra, bật ra một cách mạnh mẽ, khó ngăn giữ được: cười phá lên * chạy phá ra chỗ khác",
    example: "cười phá lên * chạy phá ra chỗ khác",
  },
  {
    word: "phả",
    part_of_speech: "động từ",
    meaning: "như phà (nhưng nghĩa mạnh hơn).",
    example: "đất phả hơi sương * một luồng gió lạnh phả vào mặt",
  },
  {
    word: "phà",
    part_of_speech: "danh từ",
    meaning:
      "phương tiện vận chuyển lớn, có hình chữ nhật, lòng phẳng, dùng để chở xe cộ và người qua sông: xe qua phà * bến phà",
    example: "xe qua phà * bến phà",
  },
  {
    word: "phà",
    part_of_speech: "động từ",
    meaning:
      "thở mạnh ra qua đường miệng: miệng phà ra hơi rượu * phà khói thuốc",
    example: "miệng phà ra hơi rượu * phà khói thuốc",
  },
  {
    word: "phá án",
    part_of_speech: "động từ",
    meaning:
      "(toà án cấp trên) huỷ một bản án do toà án cấp dưới đã xử chung thẩm và yêu cầu toà án đó xét lại.",
    example: "30 ngày phá án",
  },
  {
    word: "phá bỏ",
    part_of_speech: "động từ",
    meaning:
      "bỏ đi một cách cương quyết, làm cho không còn tồn tại để tiếp tục hoạt động được nữa: phá bỏ hàng rào thuế quan * phá bỏ một hủ tục",
    example: "phá bỏ hàng rào thuế quan * phá bỏ một hủ tục",
  },
  {
    word: "phá bĩnh",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) gây rối, phá phách nhằm làm hỏng công việc hoặc cuộc vui của những người khác: chơi chán rồi quay ra phá bĩnh",
    example: "chơi chán rồi quay ra phá bĩnh",
  },
  {
    word: "phá cách",
    part_of_speech: "động từ",
    meaning:
      "không theo đúng luật hay những quy định cũ (thường nói về thơ văn): bài thơ có lối gieo vần phá cách",
    example: "bài thơ có lối gieo vần phá cách",
  },
  {
    word: "phá giá",
    part_of_speech: "động từ",
    meaning:
      "(nhà nước) hạ thấp tỉ giá chính thức của đồng tiền nước mình so với đồng tiền nước ngoài, hay hạ thấp lượng vàng bảo đảm chính thức của đồng tiền: đồng euro bị phá giá",
    example: "đồng euro bị phá giá",
  },
  {
    word: "phá giá",
    part_of_speech: "động từ",
    meaning: "bán phá giá (nói tắt): phá giá để cạnh tranh",
    example: "phá giá để cạnh tranh",
  },
  {
    word: "phá đề",
    part_of_speech: "động từ",
    meaning: "(cũ) mở đầu một bài văn, bài thơ: câu phá đề rất ấn tượng",
    example: "câu phá đề rất ấn tượng",
  },
  {
    word: "phá đám",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) quấy rối để làm hỏng công việc hoặc cuộc vui của những người khác: kẻ phá đám * không được chơi thì quay ra phá đám",
    example: "kẻ phá đám * không được chơi thì quay ra phá đám",
  },
  {
    word: "phá gia chi tử",
    part_of_speech: "",
    meaning:
      "đứa con làm tan nát tài sản của gia đình; cũng dùng để chỉ kẻ ăn chơi hoang toàng: đồ phá gia chi tử!",
    example: "đồ phá gia chi tử!",
  },
  {
    word: "pha chế",
    part_of_speech: "động từ",
    meaning:
      "chế ra một hỗn hợp bằng cách pha trộn theo những tỉ lệ hoặc công thức nhất định: pha chế thuốc * công thức pha chế rượu vang",
    example: "pha chế thuốc * công thức pha chế rượu vang",
  },
  {
    word: "phá hoại",
    part_of_speech: "động từ",
    meaning:
      "cố ý làm cho hỏng, cho bị thiệt hại nặng: phá hoại của công * bom đạn phá hoại đê điều",
    example: "phá hoại của công * bom đạn phá hoại đê điều",
  },
  {
    word: "phá hại",
    part_of_speech: "động từ",
    meaning:
      "làm cho hư hỏng, thiệt hại (thường là hoa màu): sâu bọ phá hại mùa màng",
    example: "sâu bọ phá hại mùa màng",
  },
  {
    word: "phá huỷ",
    part_of_speech: "động từ",
    meaning:
      "làm cho không còn tồn tại hoặc bị hư hỏng nặng, không dùng được nữa: hệ thống đê kè đã bị phá huỷ sau trận lũ",
    example: "hệ thống đê kè đã bị phá huỷ sau trận lũ",
  },
  {
    word: "phá hoang",
    part_of_speech: "động từ",
    meaning: "vỡ đất hoang để trồng trọt: đất phá hoang",
    example: "đất phá hoang",
  },
  {
    word: "pha lê",
    part_of_speech: "danh từ",
    meaning:
      "thuỷ tinh trong suốt, đẹp và nặng hơn thuỷ tinh thường: chiếc lọ pha lê * trong như pha lê",
    example: "chiếc lọ pha lê * trong như pha lê",
  },
  {
    word: "phá ngang",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bỏ dở giữa chừng, không làm tiếp cho trọn (thường nói về việc học hành): đang học năm thứ ba thì phá ngang đi buôn",
    example: "đang học năm thứ ba thì phá ngang đi buôn",
  },
  {
    word: "phá ngang",
    part_of_speech: "động từ",
    meaning:
      "cố ý làm ảnh hưởng, làm hỏng công việc đang làm của người khác: giở giọng phá ngang * bàn gì, chỉ giỏi phá ngang!",
    example: "giở giọng phá ngang * bàn gì, chỉ giỏi phá ngang!",
  },
  {
    word: "phá lưới",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đá bóng vào lưới của đối phương, tạo bàn thắng: vua phá lưới (người ghi nhiều bàn thắng nhất trong một giải đấu lớn)",
    example:
      "vua phá lưới (người ghi nhiều bàn thắng nhất trong một giải đấu lớn)",
  },
  {
    word: "phá phách",
    part_of_speech: "động từ",
    meaning:
      "phá lung tung, bừa bãi, làm hư hỏng nhiều thứ (nói khái quát): giặc vào làng cướp bóc, phá phách",
    example: "giặc vào làng cướp bóc, phá phách",
  },
  {
    word: "phá quấy",
    part_of_speech: "động từ",
    meaning:
      "làm rối ren để gây trở ngại, kìm hãm: cái thằng, chỉ giỏi phá quấy!",
    example: "cái thằng, chỉ giỏi phá quấy!",
  },
  {
    word: "phá sản",
    part_of_speech: "động từ",
    meaning:
      "lâm vào tình trạng tài sản không còn gì, thường là do kinh doanh bị thua lỗ, thất bại: nhiều công ti bị phá sản * tuyên bố phá sản",
    example: "nhiều công ti bị phá sản * tuyên bố phá sản",
  },
  {
    word: "phá sản",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) thất bại hoàn toàn: kế hoạch tấn công của địch hoàn toàn bị phá sản",
    example: "kế hoạch tấn công của địch hoàn toàn bị phá sản",
  },
  {
    word: "phá rối",
    part_of_speech: "động từ",
    meaning:
      "làm cho bị rối loạn, mất ổn định: phá rối an ninh quốc phòng * bắt giữ những kẻ phá rối",
    example: "phá rối an ninh quốc phòng * bắt giữ những kẻ phá rối",
  },
  {
    word: "pha tạp",
    part_of_speech: "tính từ",
    meaning:
      "bị trộn lẫn, pha lẫn nhiều thứ, nhiều loại khác nhau, không có được bản sắc riêng: lối kiến trúc pha tạp",
    example: "lối kiến trúc pha tạp",
  },
  {
    word: "phá rào",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) làm trái với những quy định hiện hành về chế độ, chính sách (thường trong lĩnh vực kinh tế), vì cho rằng những quy định này không còn phù hợp với tình hình nhưng chưa được sửa đổi: ngân hàng đã phá rào trong việc cho vay vốn",
    example: "ngân hàng đã phá rào trong việc cho vay vốn",
  },
  {
    word: "pha trò",
    part_of_speech: "động từ",
    meaning:
      "chêm vào câu chuyện những lời nói, cử chỉ nhằm gây cười cho vui: nói vài câu pha trò * pha trò nhạt",
    example: "nói vài câu pha trò * pha trò nhạt",
  },
  {
    word: "pha trộn",
    part_of_speech: "động từ",
    meaning:
      "trộn lẫn, hoà lẫn với nhau: pha trộn màu * pha trộn sơn * trong lòng pha trộn cả vui lẫn buồn",
    example:
      "pha trộn màu * pha trộn sơn * trong lòng pha trộn cả vui lẫn buồn",
  },
  {
    word: "pha trộn",
    part_of_speech: "động từ",
    meaning:
      "có pha lẫn những thứ khác vào, không còn thuần chất nữa: một ngôn ngữ pha trộn",
    example: "một ngôn ngữ pha trộn",
  },
  {
    word: "phác",
    part_of_speech: "động từ",
    meaning:
      "vạch ra những nét chính để có thể hình dung ra toàn bộ: nói phác những nét chính * vẽ phác * tính phác qua",
    example: "nói phác những nét chính * vẽ phác * tính phác qua",
  },
  {
    word: "phác",
    part_of_speech: "động từ",
    meaning:
      "có cử chỉ, cử động đơn giản để biểu thị một thái độ nào đó: trên môi phác một nụ cười * tay phác một cử chỉ phản đối",
    example: "trên môi phác một nụ cười * tay phác một cử chỉ phản đối",
  },
  {
    word: "phá thai",
    part_of_speech: "động từ",
    meaning:
      "bỏ cái thai còn ít tháng, thường bằng các biện pháp chuyên môn: uống thuốc phá thai",
    example: "uống thuốc phá thai",
  },
  {
    word: "phác hoạ",
    part_of_speech: "động từ",
    meaning:
      "vẽ phác để thể hiện những đường nét cơ bản nhất, quan trọng nhất trước khi vẽ tiếp cho hoàn chỉnh bức tranh: phác hoạ chân dung * vẽ phác hoạ",
    example: "phác hoạ chân dung * vẽ phác hoạ",
  },
  {
    word: "phác hoạ",
    part_of_speech: "động từ",
    meaning:
      "vạch ra những nét chính, nét cơ bản: phác hoạ kế hoạch công tác trong quý",
    example: "phác hoạ kế hoạch công tác trong quý",
  },
  {
    word: "phác hoạ",
    part_of_speech: "danh từ",
    meaning:
      'bản vẽ được phác ra: "Sinh rằng: Phác hoạ vừa rồi, Phẩm đề xin một vài lời thêm hoa." (TKiều)',
    example:
      'Sinh rằng: Phác hoạ vừa rồi, Phẩm đề xin một vài lời thêm hoa." (TKiều)',
  },
  {
    word: "phác đồ",
    part_of_speech: "danh từ",
    meaning:
      "trình tự và thao tác vạch sẵn để xử lí và điều trị bệnh: xây dựng phác đồ điều trị",
    example: "xây dựng phác đồ điều trị",
  },
  {
    word: "phách",
    part_of_speech: "danh từ",
    meaning:
      "nhạc khí dân tộc làm bằng đoạn tre cứng, thường dùng đệm trong hát ca trù: gõ phách",
    example: "gõ phách",
  },
  {
    word: "phách",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị thời gian cơ bản của nhịp: trong nhịp 2/4 có hai phách * gõ sai phách * mỗi người nói một phách",
    example:
      "trong nhịp 2/4 có hai phách * gõ sai phách * mỗi người nói một phách",
  },
  {
    word: "phạch",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng như tiếng của vật nhẹ và rộng bản đập vào một vật cứng khác: vỗ đánh phạch cái chiếu xuống đất",
    example: "vỗ đánh phạch cái chiếu xuống đất",
  },
  {
    word: "phác thảo",
    part_of_speech: "động từ",
    meaning:
      "viết một bản thảo sơ lược hoặc tạo dựng một bản mẫu bằng những đường nét cơ bản, nhằm thể hiện một ý đồ sáng tác về văn học, nghệ thuật: phác thảo chân dung * bản phác thảo đề án xây dựng",
    example: "phác thảo chân dung * bản phác thảo đề án xây dựng",
  },
  {
    word: "phác thảo",
    part_of_speech: "danh từ",
    meaning:
      "phần ghi họ tên và số báo danh của thí sinh ở đầu mỗi bài thi, được rọc riêng ra trước khi đưa đi chấm thi (nhằm đảm bảo sự công bằng): ghi số phách * rọc phách",
    example: "ghi số phách * rọc phách",
  },
  {
    word: "phác thảo",
    part_of_speech: "danh từ",
    meaning:
      '(văn chương) vía, tinh thần mạnh mẽ của con người, theo quan niệm của người xưa: "Vậy nên nấn ná đòi khi, Hình tuy còn ở phách thì đã theo." (ATV)',
    example: 'Vậy nên nấn ná đòi khi, Hình tuy còn ở phách thì đã theo." (ATV)',
  },
  {
    word: "phác thảo",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) lên mặt, ra vẻ ta đây: làm phách",
    example: "làm phách",
  },
  {
    word: "phách lác",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) như khoác lác: tính hay phách lác",
    example: "tính hay phách lác",
  },
  {
    word: "phách lối",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) lên mặt ra oai để cho người ta phải nể sợ: bộ tịch phách lối * con nhỏ phách lối lắm!",
    example: "bộ tịch phách lối * con nhỏ phách lối lắm!",
  },
  {
    word: "phải biết",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị ý nhấn mạnh một sự thật và một mức độ cao mà dường như người đối thoại khó có thể hình dung được: ngon phải biết * nó mà mặc áo này thì đẹp phải biết!",
    example: "ngon phải biết * nó mà mặc áo này thì đẹp phải biết!",
  },
  {
    word: "phải cái",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị điều sắp nêu ra là một điều hạn chế đáng tiếc, đáng phàn nàn: thông minh nhưng phải cái hơi ẩu",
    example: "thông minh nhưng phải cái hơi ẩu",
  },
  {
    word: "phái",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp người đứng về một phía nào đó, trong quan hệ đối lập với những người phía khác: chia bè chia phái * phái đối lập * phái yếu",
    example: "chia bè chia phái * phái đối lập * phái yếu",
  },
  {
    word: "phái",
    part_of_speech: "động từ",
    meaning:
      "cử đi làm việc gì với những yêu cầu nhất định, trong một thời gian nhất định: phái đi công tác * phái người đi điều tra",
    example: "phái đi công tác * phái người đi điều tra",
  },
  {
    word: "phải",
    part_of_speech: "động từ",
    meaning:
      'ở trong điều kiện bắt buộc, không thể không làm, không thể khác: ốm thì phải uống thuốc * phải làm cho xong * "Cách sông nên phải luỵ đò, Tối trời nên phải luỵ o bán dầu." (Cdao)',
    example:
      'ốm thì phải uống thuốc * phải làm cho xong * "Cách sông nên phải luỵ đò, Tối trời nên phải luỵ o bán dầu." (Cdao)',
  },
  {
    word: "phải",
    part_of_speech: "động từ",
    meaning:
      "chịu tác động không hay, không có lợi: phải vạ lây * phải gió độc * làm gì mà như đỉa phải vôi thế!",
    example: "phải vạ lây * phải gió độc * làm gì mà như đỉa phải vôi thế!",
  },
  {
    word: "phải",
    part_of_speech: "động từ",
    meaning:
      "(do một hoạt động nào đó mà) gặp, chịu tác động của cái không hay: đạp phải mìn * mua phải hàng giả * chết đuối với phải bọt (tng)",
    example: "đạp phải mìn * mua phải hàng giả * chết đuối với phải bọt (tng)",
  },
  {
    word: "phải",
    part_of_speech: "động từ",
    meaning:
      "gặp lúc hoặc hoàn cảnh nào đó: phải hôm mưa gió, không đi đâu được * phải lúc khác thì mày chết với tao!",
    example:
      "phải hôm mưa gió, không đi đâu được * phải lúc khác thì mày chết với tao!",
  },
  {
    word: "phải",
    part_of_speech: "tính từ",
    meaning:
      "ở cùng một phía với tay thường dùng để cầm bút, cầm dụng cụ lao động; đối lập với trái: rẽ sang phải * không được vượt bên phải * thuận tay phải",
    example: "rẽ sang phải * không được vượt bên phải * thuận tay phải",
  },
  {
    word: "phải",
    part_of_speech: "tính từ",
    meaning:
      "(mặt) được coi là chính, thường được bày ra ngoài (thường nói về hàng dệt); đối lập với trái: mặt phải của tấm vải",
    example: "mặt phải của tấm vải",
  },
  {
    word: "phải",
    part_of_speech: "tính từ",
    meaning:
      "đúng với, phù hợp với: thương không phải lối * bán phải giá, không đắt không rẻ",
    example: "thương không phải lối * bán phải giá, không đắt không rẻ",
  },
  {
    word: "phải",
    part_of_speech: "tính từ",
    meaning:
      "đúng, phù hợp với đạo lí, với những điều nên làm: lẽ phải * nói chí phải * nói phải củ cải cũng nghe (tng)",
    example: "lẽ phải * nói chí phải * nói phải củ cải cũng nghe (tng)",
  },
  {
    word: "phải",
    part_of_speech: "tính từ",
    meaning:
      'đúng, hợp với sự thật: nói như vậy là không phải * "Thực vàng chẳng phải thau đâu, Đừng đem thử lửa mà đau lòng vàng." (Cdao)',
    example:
      'nói như vậy là không phải * "Thực vàng chẳng phải thau đâu, Đừng đem thử lửa mà đau lòng vàng." (Cdao)',
  },
  {
    word: "phải",
    part_of_speech: "kết từ",
    meaning:
      "(Khẩu ngữ) từ dùng để nêu lên một giả thiết, xem với giả thiết ấy thì cái gì xảy ra (nhằm so sánh đánh giá về điều trái lại đã xảy ra trong thực tế): phải nó chịu nghe mình thì đâu đến nỗi",
    example: "phải nó chịu nghe mình thì đâu đến nỗi",
  },
  {
    word: "phai",
    part_of_speech: "danh từ",
    meaning:
      "công trình nhỏ đắp bằng đất hoặc gồm các tấm gỗ xếp chồng lên nhau để ngăn dòng nước: mương phai",
    example: "mương phai",
  },
  {
    word: "phai",
    part_of_speech: "động từ",
    meaning:
      'không còn giữ được nguyên độ đậm của màu sắc, hương vị như ban đầu: hoa phai sắc * chè đã phai hương * "Áo đen không lẽ đen hoài, Mưa lâu cũng nhạt, nắng hoài cũng phai." (ca dao)',
    example:
      'hoa phai sắc * chè đã phai hương * "Áo đen không lẽ đen hoài, Mưa lâu cũng nhạt, nắng hoài cũng phai." (ca dao)',
  },
  {
    word: "phai",
    part_of_speech: "động từ",
    meaning:
      "không còn giữ được nguyên độ đằm thắm, sâu sắc như lúc ban đầu: những kỉ niệm không bao giờ phai",
    example: "những kỉ niệm không bao giờ phai",
  },
  {
    word: "phách lạc hồn xiêu",
    part_of_speech: "",
    meaning:
      '(hiếm) như hồn xiêu phách lạc: "Sinh đà phách lạc hồn xiêu, Thương ôi! Chẳng phải nàng Kiều ở đây?" (TKiều)',
    example:
      'Sinh đà phách lạc hồn xiêu, Thương ôi! Chẳng phải nàng Kiều ở đây?" (TKiều)',
  },
  {
    word: "phải cái tội",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) như chỉ mỗi tội: cô ta đẹp nhưng phải cái tội hơi lười",
    example: "cô ta đẹp nhưng phải cái tội hơi lười",
  },
  {
    word: "phải chi",
    part_of_speech: "kết từ",
    meaning: "(phương ngữ) như giá như: phải chi ảnh nghe tôi thì đâu đến nỗi",
    example: "phải chi ảnh nghe tôi thì đâu đến nỗi",
  },
  {
    word: "phải chăng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) vừa phải, có thể chấp nhận được: giá cả phải chăng * ăn nói phải chăng",
    example: "giá cả phải chăng * ăn nói phải chăng",
  },
  {
    word: "phải chăng",
    part_of_speech: "tính từ",
    meaning:
      "tổ hợp biểu thị ý nhận định có phần dè dặt, chưa chắc chắn của người nói, được nêu ra dưới dạng như muốn hỏi người đối thoại: phải chăng buồn quá mà thành bệnh? * phải chăng nó đã đi rồi, nên không đến",
    example:
      "phải chăng buồn quá mà thành bệnh? * phải chăng nó đã đi rồi, nên không đến",
  },
  {
    word: "phải chăng",
    part_of_speech: "tính từ",
    meaning:
      "tổ hợp biểu thị ý hỏi mỉa mai về một điều nào đó mà biết là người đối thoại cũng phải thấy là vô lí và khó trả lời: phải chăng anh không biết gì cả?",
    example: "phải chăng anh không biết gì cả?",
  },
  {
    word: "phái đoàn",
    part_of_speech: "danh từ",
    meaning:
      "đoàn người được chính thức cử đi làm một nhiệm vụ nhất định trong thời gian nhất định: phái đoàn ngoại giao * chuẩn bị đón tiếp phái đoàn",
    example: "phái đoàn ngoại giao * chuẩn bị đón tiếp phái đoàn",
  },
  {
    word: "phai mờ",
    part_of_speech: "động từ",
    meaning:
      "(hình ảnh, ấn tượng) mờ nhạt đi, không còn rõ ràng, nguyên vẹn trong tâm trí: kỉ niệm không phai mờ",
    example: "kỉ niệm không phai mờ",
  },
  {
    word: "phải lòng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) cảm thấy yêu một cách khó cưỡng lại nổi (nói về tình yêu nam nữ): hai người phải lòng nhau",
    example: "hai người phải lòng nhau",
  },
  {
    word: "phải gió",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) bị trúng gió: người run lên như phải gió!",
    example: "người run lên như phải gió!",
  },
  {
    word: "phải gió",
    part_of_speech: "tính từ",
    meaning:
      "(thông tục) tiếng dùng để rủa một cách nhẹ nhàng: đồ phải gió! * phải gió cái nhà anh này, cứ đùa mãi thế!",
    example: "đồ phải gió! * phải gió cái nhà anh này, cứ đùa mãi thế!",
  },
  {
    word: "phai nhạt",
    part_of_speech: "động từ",
    meaning:
      "(tình cảm, ấn tượng) mờ dần đi, không còn đậm đà, không còn rõ nét: tình cảm phai nhạt dần",
    example: "tình cảm phai nhạt dần",
  },
  {
    word: "phải tội",
    part_of_speech: "động từ",
    meaning:
      "mắc tội với thần linh, với tổ tiên hay với ai đó, và sẽ phải chịu trừng phạt về sau này, theo quan niệm cũ: nói thế phải tội chết!",
    example: "nói thế phải tội chết!",
  },
  {
    word: "phải tội",
    part_of_speech: "động từ",
    meaning:
      ".  (khẩu ngữ) như chỉ mỗi tội: con bé nhanh nhẹn, phải tội hơi lắm lời",
    example: "con bé nhanh nhẹn, phải tội hơi lắm lời",
  },
  {
    word: "phải tội mà",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị việc sắp nêu ra là không nên làm, vì cho rằng có làm thì cũng chỉ mang lấy sự vất vả chứ chẳng có lợi gì: mưa gió thế này, ai phải tội mà đi",
    example: "mưa gió thế này, ai phải tội mà đi",
  },
  {
    word: "phái sinh",
    part_of_speech: "tính từ",
    meaning:
      "(từ hoặc nghĩa từ) được tạo ra từ một yếu tố gốc bằng cách thêm, bớt hay biến đổi một vài thành tố nào đó: nghĩa phái sinh * 'đỏ thắm', 'đỏ tươi' là những từ phái sinh của 'đỏ'.",
    example:
      "nghĩa phái sinh * 'đỏ thắm', 'đỏ tươi' là những từ phái sinh của 'đỏ'.",
  },
  {
    word: "phải quấy",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) phải trái, đúng sai: nói phải quấy cho nó nghe ra * chưa rõ phải quấy ra làm sao!",
    example: "nói phải quấy cho nó nghe ra * chưa rõ phải quấy ra làm sao!",
  },
  {
    word: "phái viên",
    part_of_speech: "danh từ",
    meaning:
      "(trang trọng) người được phái đi làm một nhiệm vụ nào đó, thường là đặc biệt: phái viên của chính phủ",
    example: "phái viên của chính phủ",
  },
  {
    word: "phải trái",
    part_of_speech: "tính từ",
    meaning:
      "phải hay trái, đúng hay sai, về mặt cần phân biệt rạch ròi: phân biệt phải trái * chưa rõ phải trái thế nào",
    example: "phân biệt phải trái * chưa rõ phải trái thế nào",
  },
  {
    word: "phạm",
    part_of_speech: "động từ",
    meaning: "(cắt, rạch, v.v.) lấn vào chỗ cần tránh: cắt phạm vào tay",
    example: "cắt phạm vào tay",
  },
  {
    word: "phạm",
    part_of_speech: "động từ",
    meaning:
      "động chạm đến, làm tổn hại đến những cái, những điều cần tôn trọng, giữ gìn: phạm nội quy * phạm đến danh dự cá nhân",
    example: "phạm nội quy * phạm đến danh dự cá nhân",
  },
  {
    word: "phạm",
    part_of_speech: "động từ",
    meaning:
      "mắc phải điều cần tránh, nên tránh: phạm sai lầm * phạm phải những lỗi lầm nghiêm trọng",
    example: "phạm sai lầm * phạm phải những lỗi lầm nghiêm trọng",
  },
  {
    word: "phạm",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) phạm nhân (nói tắt): xe chở phạm",
    example: "xe chở phạm",
  },
  {
    word: "phàm ăn",
    part_of_speech: "động từ",
    meaning:
      "ăn nhiều và ăn được nhiều thứ, nhiều loại thức ăn: giống lợn phàm ăn",
    example: "giống lợn phàm ăn",
  },
  {
    word: "phàm",
    part_of_speech: "tính từ",
    meaning:
      "hoặc d (cũ) thuộc cõi đời trên mặt đất, phân biệt với thuộc cõi tiên: người phàm * cõi phàm * tiên giáng phàm",
    example: "người phàm * cõi phàm * tiên giáng phàm",
  },
  {
    word: "phàm",
    part_of_speech: "tính từ",
    meaning: "(hiếm) (ăn, nói) thô tục, không thanh lịch: nói phàm * ăn phàm",
    example: "nói phàm * ăn phàm",
  },
  {
    word: "phàm",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý nhấn mạnh về tính khái quát của một nhận định đúng ở đời cho tất cả mọi trường hợp sắp nêu ra: phàm là con người, ai chẳng có ham muốn",
    example: "phàm là con người, ai chẳng có ham muốn",
  },
  {
    word: "phạm luật",
    part_of_speech: "động từ",
    meaning:
      "làm trái với luật lệ, trái với quy định: một cầu thủ bị phạm luật",
    example: "một cầu thủ bị phạm luật",
  },
  {
    word: "phạm pháp",
    part_of_speech: "động từ",
    meaning: "làm những điều pháp luật cấm: có hành vi phạm pháp",
    example: "có hành vi phạm pháp",
  },
  {
    word: "phạm huý",
    part_of_speech: "động từ",
    meaning:
      "(cũ) phạm tội nhắc đến tên huý của một ai đó, thường là người bề trên, một trong những điều phải kiêng tránh theo tục lệ thời phong kiến: bài thi bị đánh hỏng vì phạm huý",
    example: "bài thi bị đánh hỏng vì phạm huý",
  },
  {
    word: "phạm quy",
    part_of_speech: "động từ",
    meaning:
      "phạm phải những lỗi mà quy định của cuộc thi đã đề ra: có 15 thí sinh phạm quy * phạm quy nên bị trừ một nửa số điểm",
    example: "có 15 thí sinh phạm quy * phạm quy nên bị trừ một nửa số điểm",
  },
  {
    word: "phạm thượng",
    part_of_speech: "động từ",
    meaning:
      "(cũ) xúc phạm tới người bề trên, thường là với vua chúa (một tội nặng theo quy định thời phong kiến): mắc tội khi quân, phạm thượng",
    example: "mắc tội khi quân, phạm thượng",
  },
  {
    word: "phạm tội",
    part_of_speech: "động từ",
    meaning:
      "có hành vi trái với pháp luật hoặc trái với đạo đức: phạm tội giết người",
    example: "phạm tội giết người",
  },
  {
    word: "phàm phu",
    part_of_speech: "",
    meaning: "(cũ) (người đàn ông) thô lỗ tục tằn: kẻ phàm phu",
    example: "kẻ phàm phu",
  },
  {
    word: "phàm trần",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) cõi trần tục, cõi đời thực: "Đằng vân giá vũ một thôi, Phút đâu đã đến gần nơi phàm trần." (MPXH)',
    example:
      'Đằng vân giá vũ một thôi, Phút đâu đã đến gần nơi phàm trần." (MPXH)',
  },
  {
    word: "phàm tục",
    part_of_speech: "tính từ",
    meaning:
      "tầm thường, thuộc cõi đời thực, không có gì là cao siêu: kẻ phàm tục * cõi phàm tục",
    example: "kẻ phàm tục * cõi phàm tục",
  },
  {
    word: "phạn",
    part_of_speech: "danh từ",
    meaning: "liễn dùng để đựng cơm: một phạn cơm",
    example: "một phạn cơm",
  },
  {
    word: "phạm vi",
    part_of_speech: "danh từ",
    meaning:
      "khoảng được giới hạn của một hoạt động, một vấn đề hay một cái gì: phạm vi chuyên môn * mở rộng phạm vi hoạt động",
    example: "phạm vi chuyên môn * mở rộng phạm vi hoạt động",
  },
  {
    word: "phạm trù",
    part_of_speech: "danh từ",
    meaning:
      "khái niệm khoa học phản ánh những thuộc tính và mối quan hệ chung, cơ bản nhất của các hiện tượng: vật chất, tinh thần là hai phạm trù cơ bản của triết học",
    example: "vật chất, tinh thần là hai phạm trù cơ bản của triết học",
  },
  {
    word: "phạm trù",
    part_of_speech: "danh từ",
    meaning:
      "khái niệm khoa học biểu thị loại sự vật, hiện tượng hay những đặc trưng chung nhất của chúng: các phạm trù ngữ pháp * phạm trù số của danh từ",
    example: "các phạm trù ngữ pháp * phạm trù số của danh từ",
  },
  {
    word: "phản bác",
    part_of_speech: "động từ",
    meaning:
      "bác bỏ, phủ nhận ý kiến, quan điểm của người khác bằng lí lẽ: ý kiến xác đáng, không thể phản bác",
    example: "ý kiến xác đáng, không thể phản bác",
  },
  {
    word: "phản ảnh",
    part_of_speech: "động từ",
    meaning:
      "trình bày với người, với cấp có trách nhiệm những vấn đề hiện thực đáng quan tâm nào đó: phản ảnh đến cơ quan chức năng",
    example: "phản ảnh đến cơ quan chức năng",
  },
  {
    word: "phán",
    part_of_speech: "danh từ",
    meaning: "(cũ) thông phán (gọi tắt): ông phán * mợ phán",
    example: "ông phán * mợ phán",
  },
  {
    word: "phán",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) (vua chúa, thần thánh) truyền bảo, ra lệnh: đức vua phán hỏi * nói như thánh phán",
    example: "đức vua phán hỏi * nói như thánh phán",
  },
  {
    word: "phán",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nhận xét, phát biểu với giọng kẻ cả, trịch thượng: làm thì không làm, cứ ngồi đấy mà phán!",
    example: "làm thì không làm, cứ ngồi đấy mà phán!",
  },
  {
    word: "phản biện",
    part_of_speech: "động từ",
    meaning:
      "đánh giá chất lượng một công trình khoa học khi công trình được đưa ra bảo vệ trước hội đồng thẩm định: được mời phản biện cho một đề tài cấp nhà nước",
    example: "được mời phản biện cho một đề tài cấp nhà nước",
  },
  {
    word: "phản biện",
    part_of_speech: "động từ",
    meaning:
      "đánh giá chất lượng một công trình khoa học khi công trình được đưa ra bảo vệ để lấy học vị trước hội đồng chấm thi: phản biện luận án tiến sĩ * trả lời câu hỏi của thầy phản biện",
    example: "phản biện luận án tiến sĩ * trả lời câu hỏi của thầy phản biện",
  },
  {
    word: "phản",
    part_of_speech: "động từ",
    meaning:
      "thay đổi hẳn thái độ, có hành động chống lại, làm hại người vốn có quan hệ gắn bó với mình: lừa thầy phản bạn * phường phản dân hại nước * mưu phản",
    example: "lừa thầy phản bạn * phường phản dân hại nước * mưu phản",
  },
  {
    word: "phản",
    part_of_speech: "động từ",
    meaning:
      "(cái của chính mình) làm hại mình một cách không ngờ: chính điều anh ta nói ra đã phản lại anh ta",
    example: "chính điều anh ta nói ra đã phản lại anh ta",
  },
  {
    word: "phản bội",
    part_of_speech: "động từ",
    meaning:
      "chống lại người hay cái mà nghĩa vụ bắt buộc mình phải trung thành, phải tôn trọng, bảo vệ: kẻ phản bội * phản bội tổ quốc",
    example: "kẻ phản bội * phản bội tổ quốc",
  },
  {
    word: "phản ánh",
    part_of_speech: "động từ",
    meaning:
      "tái hiện những đặc trưng, thuộc tính, quan hệ của một đối tượng nào đó: nghệ thuật phản ánh chân thực cuộc sống * phản ánh tư duy khách quan",
    example:
      "nghệ thuật phản ánh chân thực cuộc sống * phản ánh tư duy khách quan",
  },
  {
    word: "phản ánh",
    part_of_speech: "động từ",
    meaning: "(hiếm) như phản ảnh: phản ánh vụ việc lên cấp trên",
    example: "phản ánh vụ việc lên cấp trên",
  },
  {
    word: "phản cung",
    part_of_speech: "động từ",
    meaning:
      "phủ nhận hoặc khai ngược lại với nội dung đã cung khai: bị can phản cung",
    example: "bị can phản cung",
  },
  {
    word: "phản cách mạng",
    part_of_speech: "tính từ",
    meaning:
      "có hành động hoặc tính chất chống lại cách mạng: tư tưởng phản cách mạng",
    example: "tư tưởng phản cách mạng",
  },
  {
    word: "phản cảm",
    part_of_speech: "",
    meaning:
      "gây ra phản ứng tiêu cực, làm cho cảm thấy bực mình, khó chịu (thường nói về người thưởng thức nghệ thuật): bức tranh thiếu tính thẩm mĩ nên gây phản cảm cho người xem",
    example: "bức tranh thiếu tính thẩm mĩ nên gây phản cảm cho người xem",
  },
  {
    word: "phản công",
    part_of_speech: "động từ",
    meaning:
      "tiến công trở lại khi bị đối phương tiến công, hoặc chuyển sang tiến công sau một thời kì phòng ngự, cầm cự: chuẩn bị kế hoạch phản công",
    example: "chuẩn bị kế hoạch phản công",
  },
  {
    word: "phản chiếu",
    part_of_speech: "động từ",
    meaning: "chiếu hắt ánh sáng trở lại: mặt hồ phản chiếu ánh trăng",
    example: "mặt hồ phản chiếu ánh trăng",
  },
  {
    word: "phản chiếu",
    part_of_speech: "động từ",
    meaning:
      "(cũ) như phản ánh: tác phẩm phản chiếu chân thực cuộc sống xã hội đương thời",
    example: "tác phẩm phản chiếu chân thực cuộc sống xã hội đương thời",
  },
  {
    word: "phản diện",
    part_of_speech: "danh từ",
    meaning:
      "mặt trái, có nhiều yếu tố tiêu cực, nêu lên để phê phán, đả kích trong tác phẩm văn học - nghệ thuật: nhân vật phản diện",
    example: "nhân vật phản diện",
  },
  {
    word: "phản đối",
    part_of_speech: "động từ",
    meaning:
      "chống lại bằng lời nói hoặc hành động: tỏ ý phản đối * ngấm ngầm phản đối",
    example: "tỏ ý phản đối * ngấm ngầm phản đối",
  },
  {
    word: "phán đoán",
    part_of_speech: "động từ",
    meaning:
      "dựa vào những điều đã biết để suy luận và rút ra nhận định về điều chưa biết, chưa xảy ra: phán đoán đúng ý đồ của đối phương * phán đoán tình hình",
    example: "phán đoán đúng ý đồ của đối phương * phán đoán tình hình",
  },
  {
    word: "phán đoán",
    part_of_speech: "danh từ",
    meaning:
      "hình thức tư duy trong đó các khái niệm kết hợp với nhau, khái niệm này (vị ngữ) vạch rõ nội dung, thuộc tính của khái niệm kia (chủ ngữ): phán đoán khẳng định * phán đoán phủ định",
    example: "phán đoán khẳng định * phán đoán phủ định",
  },
  {
    word: "phản đế",
    part_of_speech: "động từ",
    meaning: "chống đế quốc: mặt trận dân tộc phản đế * phất cờ phản đế",
    example: "mặt trận dân tộc phản đế * phất cờ phản đế",
  },
  {
    word: "phản giáo dục",
    part_of_speech: "tính từ",
    meaning:
      "không có tính giáo dục, ngược lại với nguyên tắc giáo dục: một phương pháp phản giáo dục * các loại đồ chơi phản giáo dục",
    example: "một phương pháp phản giáo dục * các loại đồ chơi phản giáo dục",
  },
  {
    word: "phản động",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất chống lại chính quyền, chống lại sự tiến bộ (khác với phản quốc - chống lại đất nước, nhân dân): tư tưởng phản động * các thế lực phản động đang âm mưu lật đổ sự cầm quyền của Đảng cộng sản",
    example:
      "tư tưởng phản động * các thế lực phản động đang âm mưu lật đổ sự cầm quyền của Đảng cộng sản",
  },
  {
    word: "phản kháng",
    part_of_speech: "động từ",
    meaning:
      "chống lại, phản ứng lại một cách quyết liệt: hành động phản kháng",
    example: "hành động phản kháng",
  },
  {
    word: "phản gián",
    part_of_speech: "động từ",
    meaning: "(cũ) dùng mưu kế gây chia rẽ nội bộ đối phương: kế phản gián",
    example: "kế phản gián",
  },
  {
    word: "phản gián",
    part_of_speech: "động từ",
    meaning: "chống gián điệp: hoạt động phản gián * cục phản gián",
    example: "hoạt động phản gián * cục phản gián",
  },
  {
    word: "phản hồi",
    part_of_speech: "động từ",
    meaning: "(cũ) trở về, quay trở lại: dẫn binh phản hồi * phản hồi cố hương",
    example: "dẫn binh phản hồi * phản hồi cố hương",
  },
  {
    word: "phản hồi",
    part_of_speech: "động từ",
    meaning: "tác dụng trở lại: tín hiệu phản hồi",
    example: "tín hiệu phản hồi",
  },
  {
    word: "phản hồi",
    part_of_speech: "động từ",
    meaning:
      "đáp lại, trả lời lại một cách chính thức: không có ý kiến phản hồi * các thông tin phản hồi đều mang dấu hiệu tích cực",
    example:
      "không có ý kiến phản hồi * các thông tin phản hồi đều mang dấu hiệu tích cực",
  },
  {
    word: "phản kích",
    part_of_speech: "động từ",
    meaning:
      "hành động tiến công nhằm tiêu diệt quân đối phương đột nhập trận địa phòng ngự, khôi phục lại hoàn toàn hoặc một phần trận địa đã mất: mở cuộc phản kích * đánh bật các cuộc phản kích của địch",
    example: "mở cuộc phản kích * đánh bật các cuộc phản kích của địch",
  },
  {
    word: "phản khoa học",
    part_of_speech: "động từ",
    meaning:
      "không có tính khoa học, trái với nguyên tắc khoa học: một kết luận phản khoa học",
    example: "một kết luận phản khoa học",
  },
  {
    word: "phản nghĩa",
    part_of_speech: "tính từ",
    meaning: "có nghĩa đối lập: từ phản nghĩa *  phản nghĩa với",
    example: "từ phản nghĩa *  phản nghĩa với",
  },
  {
    word: "phản nghịch",
    part_of_speech: "động từ",
    meaning: "(cũ) làm phản, chống lại: quân phản nghịch",
    example: "quân phản nghịch",
  },
  {
    word: "phàn nàn",
    part_of_speech: "động từ",
    meaning:
      "nói ra nỗi buồn bực, không vừa ý để mong có sự đồng cảm, đồng tình: phàn nàn về cách ăn ở không khéo của nàng dâu * tính hay kêu ca, phàn nàn",
    example:
      "phàn nàn về cách ăn ở không khéo của nàng dâu * tính hay kêu ca, phàn nàn",
  },
  {
    word: "phản quang",
    part_of_speech: "tính từ",
    meaning:
      "có khả năng phản xạ ánh sáng tốt: sơn phản quang * kính phản quang",
    example: "sơn phản quang * kính phản quang",
  },
  {
    word: "phản lực",
    part_of_speech: "danh từ",
    meaning:
      "lực xuất hiện khi một vật tác dụng trở lại vào vật đang tác dụng lên nó: phản lực bao giờ cũng bằng và ngược chiều với lực tác động",
    example: "phản lực bao giờ cũng bằng và ngược chiều với lực tác động",
  },
  {
    word: "phản pháo",
    part_of_speech: "động từ",
    meaning:
      "dùng pháo binh để đánh trả lại pháo binh của đối phương: cuộc phản pháo",
    example: "cuộc phản pháo",
  },
  {
    word: "phản loạn",
    part_of_speech: "động từ",
    meaning: "gây rối loạn để chống lại: diệt trừ kẻ phản loạn",
    example: "diệt trừ kẻ phản loạn",
  },
  {
    word: "phản phong",
    part_of_speech: "động từ",
    meaning:
      "chống phong kiến: phong trào phản đế, phản phong lan rộng khắp các tỉnh thành",
    example: "phong trào phản đế, phản phong lan rộng khắp các tỉnh thành",
  },
  {
    word: "phản phúc",
    part_of_speech: "tính từ",
    meaning:
      "tráo trở, phản lại người đã tin cậy mình hoặc có ân nghĩa với mình: kẻ phản phúc * lòng dạ phản phúc",
    example: "kẻ phản phúc * lòng dạ phản phúc",
  },
  {
    word: "phản quốc",
    part_of_speech: "động từ",
    meaning: "phản bội, chống lại tổ quốc của chính mình: tội phản quốc",
    example: "tội phản quốc",
  },
  {
    word: "phản tác dụng",
    part_of_speech: "",
    meaning:
      "tác dụng thực tế ngược lại với tác dụng mong muốn: dùng thuốc quá liều sẽ phản tác dụng",
    example: "dùng thuốc quá liều sẽ phản tác dụng",
  },
  {
    word: "phán quyết",
    part_of_speech: "động từ",
    meaning:
      "(toà án) ra một quyết định có giá trị pháp lí, ai cũng phải tuân theo: lời phán quyết cuối cùng",
    example: "lời phán quyết cuối cùng",
  },
  {
    word: "phản xạ",
    part_of_speech: "danh từ",
    meaning:
      "phản ứng theo quy luật của cơ thể động vật đối với các kích thích bên ngoài và bên trong: vung tay theo phản xạ",
    example: "vung tay theo phản xạ",
  },
  {
    word: "phản thùng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) phản lại người vốn cùng phe cánh và thường là thân thiết với mình: bị bọn đàn em phản thùng",
    example: "bị bọn đàn em phản thùng",
  },
  {
    word: "phản ứng dây chuyền",
    part_of_speech: "danh từ",
    meaning:
      "chuỗi các phản ứng xảy ra nối tiếp nhau nhờ một phản ứng đầu để tạo thành các sản phẩm một cách liên tục, cho đến khi toàn bộ chất phản ứng đã được sử dụng hết hoặc cho đến khi xảy ra sự ngắt mạch.",
    example:
      "hàng loạt công nhân đình công đã tạo thành phản ứng dây chuyền trong các khu công nghiệp",
  },
  {
    word: "phản ứng",
    part_of_speech: "danh từ",
    meaning:
      "hoạt động, trạng thái, quá trình nảy sinh ra để đáp lại một tác động nào đó: thăm dò phản ứng của đối phương",
    example: "thăm dò phản ứng của đối phương",
  },
  {
    word: "phản ứng",
    part_of_speech: "danh từ",
    meaning:
      "sự đáp lại của cơ thể sinh vật trước những kích thích bên ngoài hay bên trong nào đó: phản ứng tự vệ của cơ thể * tiêm dưới da để thử phản ứng",
    example: "phản ứng tự vệ của cơ thể * tiêm dưới da để thử phản ứng",
  },
  {
    word: "phản ứng",
    part_of_speech: "danh từ",
    meaning: "phản ứng hoá học (nói tắt):  phản ứng oxy hoá khử",
    example: "phản ứng oxy hoá khử",
  },
  {
    word: "phản ứng",
    part_of_speech: "động từ",
    meaning:
      "có phản ứng trước một tác động, một sự việc nào đó: phản ứng mạnh mẽ trước lời cáo buộc vô căn cứ * ngồi im, không phản ứng gì",
    example:
      "phản ứng mạnh mẽ trước lời cáo buộc vô căn cứ * ngồi im, không phản ứng gì",
  },
  {
    word: "phản ứng",
    part_of_speech: "động từ",
    meaning:
      "có phản ứng trước những kích thích nào đó đối với cơ thể: bệnh nhân bị sốc do phản ứng thuốc",
    example: "bệnh nhân bị sốc do phản ứng thuốc",
  },
  {
    word: "phản ứng",
    part_of_speech: "động từ",
    meaning:
      "tham gia vào một phản ứng hoá học: acid phản ứng với base sinh ra muối và nước",
    example: "acid phản ứng với base sinh ra muối và nước",
  },
  {
    word: "phản vệ",
    part_of_speech: "động từ",
    meaning:
      "phản ứng đặc biệt của cơ thể chống lại sự xâm nhập của tác nhân gây hại từ bên ngoài: sốc phản vệ do thuốc kháng sinh",
    example: "sốc phản vệ do thuốc kháng sinh",
  },
  {
    word: "phản trắc",
    part_of_speech: "tính từ",
    meaning:
      "tráo trở, dễ rắp tâm làm phản, không thể tin được: tâm địa phản trắc * kẻ phản trắc",
    example: "tâm địa phản trắc * kẻ phản trắc",
  },
  {
    word: "phán xét",
    part_of_speech: "động từ",
    meaning:
      "xem xét và đánh giá, có tính chất quyết định: phán xét công bằng * không có quyền phán xét",
    example: "phán xét công bằng * không có quyền phán xét",
  },
  {
    word: "phảng phất",
    part_of_speech: "động từ",
    meaning:
      "thoảng nhẹ qua, có lúc tựa như biến mất, khiến khó nhận ra ngay được: mùi hương phảng phất * nét mặt phảng phất vẻ u buồn",
    example: "mùi hương phảng phất * nét mặt phảng phất vẻ u buồn",
  },
  {
    word: "phanh",
    part_of_speech: "danh từ",
    meaning:
      "(Nam thắng) bộ phận dùng để làm ngừng hoặc làm chậm sự chuyển động của xe cộ, máy móc: thay phanh",
    example: "thay phanh",
  },
  {
    word: "phanh",
    part_of_speech: "động từ",
    meaning:
      "(Nam thắng) làm ngừng hoặc làm chậm sự chuyển động lại bằng cái phanh: phanh xe đột ngột",
    example: "phanh xe đột ngột",
  },
  {
    word: "phanh",
    part_of_speech: "động từ",
    meaning: "mở rộng, làm lộ ra phần bên trong: phanh ngực * mở phanh cửa",
    example: "phanh ngực * mở phanh cửa",
  },
  {
    word: "phanh",
    part_of_speech: "động từ",
    meaning: "mổ rồi banh rộng ra: phanh con gà ra",
    example: "phanh con gà ra",
  },
  {
    word: "phạng",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) như phang: phạng cho một gậy",
    example: "phạng cho một gậy",
  },
  {
    word: "phang",
    part_of_speech: "động từ",
    meaning:
      "vung vật rắn chắc cao lên rồi lấy sức đập thật mạnh: phang gậy vào lưng nhau",
    example: "phang gậy vào lưng nhau",
  },
  {
    word: "phanh phách",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng phát ra nghe hơi đanh, như tiếng của vật mỏng rộng bản đập liên tiếp trong không khí hay vào một vật khác: đàn chim cánh vỗ phanh phách",
    example: "đàn chim cánh vỗ phanh phách",
  },
  {
    word: "phành phạch",
    part_of_speech: "tính từ",
    meaning: "như phạch (nhưng với ý liên tiếp): quạt phành phạch cả đêm",
    example: "quạt phành phạch cả đêm",
  },
  {
    word: "phanh phui",
    part_of_speech: "động từ",
    meaning:
      "làm cho lộ hết ra trước mắt mọi người sự thật xấu xa vốn được che đậy, giấu giếm: phanh phui một vụ tham nhũng",
    example: "phanh phui một vụ tham nhũng",
  },
  {
    word: "phao",
    part_of_speech: "danh từ",
    meaning:
      "vật thả nổi trên mặt nước để làm mục tiêu hoặc để đỡ cho vật khác cùng nổi: phao bơi * phao cứu hộ",
    example: "phao bơi * phao cứu hộ",
  },
  {
    word: "phao",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) tài liệu sử dụng trái phép khi làm bài thi, coi như vật cứu giúp: chép phao * cấm mang phao vào phòng thi",
    example: "chép phao * cấm mang phao vào phòng thi",
  },
  {
    word: "phao",
    part_of_speech: "danh từ",
    meaning: "bầu đựng dầu trong đèn dầu hoả: dầu rót đầy phao",
    example: "dầu rót đầy phao",
  },
  {
    word: "phao",
    part_of_speech: "động từ",
    meaning:
      "nói một cách không chính thức để làm lan truyền ra, thường là với dụng ý xấu: phao tin nhảm",
    example: "phao tin nhảm",
  },
  {
    word: "pháo cao xạ",
    part_of_speech: "danh từ",
    meaning:
      "pháo có nòng dài, chủ yếu dùng để bắn các mục tiêu trên không: trận địa pháo cao xạ",
    example: "trận địa pháo cao xạ",
  },
  {
    word: "phào",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) (hơi) thoảng qua, tạo thành tiếng nhẹ và ngắn: giọng nói phào phào",
    example: "giọng nói phào phào",
  },
  {
    word: "pháo",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi chung các loại súng lớn, nặng, có nòng dày đường kính từ 20 millimet trở lên, thường bắn đạn có chứa thuốc nổ trong đầu đạn: trận địa pháo * pháo cao xạ",
    example: "trận địa pháo * pháo cao xạ",
  },
  {
    word: "pháo",
    part_of_speech: "danh từ",
    meaning:
      "vật cuộn bằng giấy, bên trong nhồi thuốc nổ, có ngòi, để đốt cho nổ thành tiếng kêu: đốt pháo * tiếng pháo giao thừa",
    example: "đốt pháo * tiếng pháo giao thừa",
  },
  {
    word: "phao đồn",
    part_of_speech: "động từ",
    meaning:
      "phao tin để cho lan rộng ra: thiên hạ phao đồn rằng ông ta trúng số độc đắc",
    example: "thiên hạ phao đồn rằng ông ta trúng số độc đắc",
  },
  {
    word: "pháo đài",
    part_of_speech: "danh từ",
    meaning:
      "công trình xây dựng vững chắc để đặt pháo lớn ở trong khu vực phòng thủ lâu dài: một pháo đài kiên cố",
    example: "một pháo đài kiên cố",
  },
  {
    word: "pháo hoa",
    part_of_speech: "danh từ",
    meaning:
      "pháo khi bắn lên thì nổ trên không tạo thành những chùm tia sáng màu sắc rực rỡ, thường được bắn trong những đêm hội: bắn pháo hoa",
    example: "bắn pháo hoa",
  },
  {
    word: "pháo kích",
    part_of_speech: "động từ",
    meaning: "đánh bằng hoả lực pháo: pháo kích vào sân bay",
    example: "pháo kích vào sân bay",
  },
  {
    word: "pháo phòng không",
    part_of_speech: "danh từ",
    meaning:
      "pháo có nòng dài, chủ yếu dùng để bắn các mục tiêu trên không: trận địa pháo cao xạ",
    example: "trận địa pháo cao xạ",
  },
  {
    word: "phao tiêu",
    part_of_speech: "danh từ",
    meaning:
      "phao dùng làm mục tiêu trên các tuyến đường sông, đường biển, để hướng dẫn tàu thuyền đi lại được an toàn: kiểm tra hệ thống phao tiêu",
    example: "kiểm tra hệ thống phao tiêu",
  },
  {
    word: "pháo thủ",
    part_of_speech: "danh từ",
    meaning: "chiến sĩ trong biên chế của khẩu đội pháo: phân đội pháo thủ",
    example: "phân đội pháo thủ",
  },
  {
    word: "pháp chế",
    part_of_speech: "danh từ",
    meaning:
      "chế độ trong đó đời sống và hoạt động xã hội được bảo đảm bằng pháp luật: tăng cường pháp chế",
    example: "tăng cường pháp chế",
  },
  {
    word: "pháp chế",
    part_of_speech: "danh từ",
    meaning:
      "hệ thống luật lệ của nhà nước nói chung, hoặc hệ thống luật lệ áp dụng trong một ngành nhất định: nền pháp chế Việt Nam",
    example: "nền pháp chế Việt Nam",
  },
  {
    word: "pháp bảo",
    part_of_speech: "danh từ",
    meaning: "đạo lí của nhà Phật để dạy tín đồ, được coi là phép quý.",
    example:
      'Bản sư rồi cũng đến sau, Dạy đưa pháp bảo sang hầu sư huynh." (TKiều)',
  },
  {
    word: "pháp danh",
    part_of_speech: "danh từ",
    meaning:
      "tên hiệu đặt cho người xuất gia làm tăng ni hoặc đạo sĩ: pháp danh của nhà sư",
    example: "pháp danh của nhà sư",
  },
  {
    word: "pháp định",
    part_of_speech: "tính từ",
    meaning: "do pháp luật quy định: vốn pháp định",
    example: "vốn pháp định",
  },
  {
    word: "pháp lí",
    part_of_speech: "danh từ",
    meaning:
      "lí luận, nguyên lí về pháp luật: không có cơ sở pháp lí * hoàn chỉnh các thủ tục pháp lí * hành lang pháp lí",
    example:
      "không có cơ sở pháp lí * hoàn chỉnh các thủ tục pháp lí * hành lang pháp lí",
  },
  {
    word: "pháp lệnh",
    part_of_speech: "danh từ",
    meaning:
      "văn bản do cơ quan đứng đầu nhà nước ban hành, có hiệu lực gần như luật: pháp lệnh bảo vệ đê điều * pháp lệnh chống tham nhũng",
    example: "pháp lệnh bảo vệ đê điều * pháp lệnh chống tham nhũng",
  },
  {
    word: "pháp lệnh",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất bắt buộc phải thực hiện, được coi tựa như pháp lệnh: chỉ tiêu pháp lệnh do nhà nước giao",
    example: "chỉ tiêu pháp lệnh do nhà nước giao",
  },
  {
    word: "pháp luật",
    part_of_speech: "danh từ",
    meaning:
      "những quy phạm hành vi do nhà nước ban hành mà mọi người dân buộc phải tuân theo, nhằm điều chỉnh các quan hệ xã hội và bảo vệ trật tự xã hội (nói tổng quát): tuân thủ pháp luật * vi phạm pháp luật",
    example: "tuân thủ pháp luật * vi phạm pháp luật",
  },
  {
    word: "pháp nhân",
    part_of_speech: "danh từ",
    meaning:
      "chủ thể pháp luật độc lập không phải là con người (như đơn vị, tổ chức, v.v.); phân biệt với thể nhân: tư cách pháp nhân",
    example: "tư cách pháp nhân",
  },
  {
    word: "pháp lý",
    part_of_speech: "danh từ",
    meaning:
      "lí luận, nguyên lí về pháp luật: không có cơ sở pháp lí * hoàn chỉnh các thủ tục pháp lí * hành lang pháp lí",
    example:
      "không có cơ sở pháp lí * hoàn chỉnh các thủ tục pháp lí * hành lang pháp lí",
  },
  {
    word: "pháp quyền",
    part_of_speech: "danh từ",
    meaning:
      "hệ thống pháp luật tiêu biểu cho quyền lực của một nhà nước, cho bản chất của một chế độ: hệ thống pháp quyền * nhà nước pháp quyền xã hội chủ nghĩa",
    example: "hệ thống pháp quyền * nhà nước pháp quyền xã hội chủ nghĩa",
  },
  {
    word: "pháp quy",
    part_of_speech: "danh từ",
    meaning:
      "những quy định có tính chất pháp luật (nói tổng quát): văn bản pháp quy",
    example: "văn bản pháp quy",
  },
  {
    word: "phát",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị động tác hay sự việc diễn ra rất nhanh, thường là động tác bắn: đập cho một phát vào lưng * bắn từng phát một",
    example: "đập cho một phát vào lưng * bắn từng phát một",
  },
  {
    word: "phát",
    part_of_speech: "động từ",
    meaning:
      "đập vào thân mình người khác bằng bàn tay mở: phát đen đét vào lưng",
    example: "phát đen đét vào lưng",
  },
  {
    word: "phát",
    part_of_speech: "động từ",
    meaning:
      "làm đứt ngang ra cả loạt bằng cách dùng lưỡi dao dài lia mạnh: phát cỏ * phát quang bờ rào * phát bờ",
    example: "phát cỏ * phát quang bờ rào * phát bờ",
  },
  {
    word: "phát",
    part_of_speech: "động từ",
    meaning:
      "đưa cho, cấp cho từng người, thường theo một chế độ chung nhất định: phát lương vào cuối tháng * phát phần thưởng * phát tờ rơi",
    example: "phát lương vào cuối tháng * phát phần thưởng * phát tờ rơi",
  },
  {
    word: "phát",
    part_of_speech: "động từ",
    meaning:
      "truyền đi và làm toả ra tiếng nói, âm thanh, hình ảnh (thường trên làn sóng điện): phát bản tin đặc biệt * máy phát",
    example: "phát bản tin đặc biệt * máy phát",
  },
  {
    word: "phát",
    part_of_speech: "động từ",
    meaning:
      "trực tiếp sinh ra và làm toả ra ánh sáng, mùi vị, v.v.: phát ra mùi thơm * phát ra ánh sáng",
    example: "phát ra mùi thơm * phát ra ánh sáng",
  },
  {
    word: "phát",
    part_of_speech: "động từ",
    meaning:
      "(bệnh) bắt đầu biểu hiện ra bằng những triệu chứng rõ rệt: bệnh đang ủ, chưa phát",
    example: "bệnh đang ủ, chưa phát",
  },
  {
    word: "phát",
    part_of_speech: "động từ",
    meaning:
      "từ biểu thị sự nảy sinh một trạng thái tâm sinh lí nào đó, do tác động mạnh mẽ của một nhận thức, một cảm xúc: trông phát khiếp * lo đến phát ốm * tức đến phát khóc",
    example: "trông phát khiếp * lo đến phát ốm * tức đến phát khóc",
  },
  {
    word: "phát",
    part_of_speech: "động từ",
    meaning:
      "gặp nhiều may mắn nhờ mồ mả của ông cha chôn được ở chỗ đất tốt, theo thuật phong thuỷ: nghe nói mả nhà ấy phát nên tiền vào như nước",
    example: "nghe nói mả nhà ấy phát nên tiền vào như nước",
  },
  {
    word: "phát âm",
    part_of_speech: "động từ",
    meaning:
      "phát ra các âm thanh của một ngôn ngữ bằng các động tác của môi, lưỡi, v.v.: luyện phát âm * phát âm không chuẩn",
    example: "luyện phát âm * phát âm không chuẩn",
  },
  {
    word: "pháp y",
    part_of_speech: "danh từ",
    meaning:
      "một ngành của y học chuyên điều tra và nghiên cứu các nguyên nhân gây thương tích và tử vong, đặc biệt trong trường hợp nghi ngờ có hành vi phạm tội: đợi kết luận của cơ quan pháp y * giám định pháp y",
    example: "đợi kết luận của cơ quan pháp y * giám định pháp y",
  },
  {
    word: "phát ban",
    part_of_speech: "động từ",
    meaning:
      "nổi những nốt đỏ bất thường thành từng mảng trên da (triệu chứng của một số bệnh): sốt phát ban",
    example: "sốt phát ban",
  },
  {
    word: "phạt",
    part_of_speech: "động từ",
    meaning:
      "chém mạnh một nhát cho đứt ngang ra: phạt cành cây * phạt cỏ * phạt ngang thân cây chuối",
    example: "phạt cành cây * phạt cỏ * phạt ngang thân cây chuối",
  },
  {
    word: "phạt",
    part_of_speech: "động từ",
    meaning:
      "bắt phải chịu một hình thức xử lí nào đó vì đã phạm lỗi: xử phạt hành chính * thưởng phạt công minh",
    example: "xử phạt hành chính * thưởng phạt công minh",
  },
  {
    word: "phát bóng",
    part_of_speech: "động từ",
    meaning:
      "đánh quả bóng đầu tiên mở đầu một trận, một hiệp trong một số môn thể thao như bóng chuyền, bóng bàn, v.v.: giành quyền phát bóng * bị dẫn điểm do phát bóng hỏng",
    example: "giành quyền phát bóng * bị dẫn điểm do phát bóng hỏng",
  },
  {
    word: "phát biểu",
    part_of_speech: "động từ",
    meaning:
      "nói ra ý kiến của mình về vấn đề nào đó cho người khác biết: phát biểu ý kiến * phát biểu cảm nghĩ * giơ tay phát biểu",
    example: "phát biểu ý kiến * phát biểu cảm nghĩ * giơ tay phát biểu",
  },
  {
    word: "phát chẩn",
    part_of_speech: "động từ",
    meaning:
      "(cũ) phân phát tiền, gạo, v.v. để cứu giúp người nghèo đói, gặp khó khăn hoạn nạn: phát chẩn gạo cho dân nghèo",
    example: "phát chẩn gạo cho dân nghèo",
  },
  {
    word: "phát điện",
    part_of_speech: "động từ",
    meaning: "sản xuất ra điện: máy phát điện",
    example: "máy phát điện",
  },
  {
    word: "phát dục",
    part_of_speech: "động từ",
    meaning:
      "(quá trình) thay đổi không ngừng của cơ thể sinh vật, chủ yếu về chất lượng, từ lúc bắt đầu cho tới lúc kết thúc sự sống: quá trình phát dục của bướm gồm bốn giai đoạn: trứng, ấu trùng, nhộng, bướm",
    example:
      "quá trình phát dục của bướm gồm bốn giai đoạn: trứng, ấu trùng, nhộng, bướm",
  },
  {
    word: "phát dục",
    part_of_speech: "động từ",
    meaning:
      "bắt đầu có khả năng sinh dục: thời kì phát dục ở nữ thường sớm hơn nam",
    example: "thời kì phát dục ở nữ thường sớm hơn nam",
  },
  {
    word: "phát giác",
    part_of_speech: "động từ",
    meaning: "phát hiện và tố giác việc làm phi pháp: vụ tham ô bị phát giác",
    example: "vụ tham ô bị phát giác",
  },
  {
    word: "phát đơn",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) như đâm đơn: phát đơn kiện",
    example: "phát đơn kiện",
  },
  {
    word: "phát đạt",
    part_of_speech: "động từ",
    meaning:
      "(làm ăn, buôn bán) phát triển thuận lợi, giàu có nhanh, mở mang nhanh: làm ăn phát đạt * năm nay phát đạt hơn năm trước",
    example: "làm ăn phát đạt * năm nay phát đạt hơn năm trước",
  },
  {
    word: "phạt đền",
    part_of_speech: "động từ",
    meaning:
      "bắt phạt cầu thủ bóng đá phạm lỗi nặng trong khu vực cấm địa của đội mình bằng cách cho đối phương đá quả bóng đặt tại một điểm cố định cách khung thành 11m (gọi là chấm phạt đền), chỉ có thủ môn được bắt hoặc chặn bóng: sút hỏng quả phạt đền",
    example: "sút hỏng quả phạt đền",
  },
  {
    word: "phát động",
    part_of_speech: "động từ",
    meaning: "(hiếm) như khởi động: máy đã phát động",
    example: "máy đã phát động",
  },
  {
    word: "phát động",
    part_of_speech: "động từ",
    meaning:
      "tuyên truyền, làm cho hiểu rõ ý nghĩa, mục đích của một việc làm để rồi cùng nhau bắt đầu tham gia một cách tự giác, hăng hái: phát động quần chúng đấu tranh tố giác tội phạm * phát động phong trào thi đua",
    example:
      "phát động quần chúng đấu tranh tố giác tội phạm * phát động phong trào thi đua",
  },
  {
    word: "phát hành",
    part_of_speech: "động từ",
    meaning:
      "đem bán hoặc phân phối sách, báo, tài liệu: mỗi tuần phát hành hai số báo * công tác phát hành",
    example: "mỗi tuần phát hành hai số báo * công tác phát hành",
  },
  {
    word: "phát hành",
    part_of_speech: "động từ",
    meaning:
      "đưa tiền tệ ra lưu thông: phát hành đồng tiền mới * phát hành công trái",
    example: "phát hành đồng tiền mới * phát hành công trái",
  },
  {
    word: "phát hiện",
    part_of_speech: "",
    meaning:
      "tìm thấy, tìm ra cái chưa ai biết: phát hiện nhân tài * phát hiện bệnh sớm nên kịp thời chữa trị",
    example: "phát hiện nhân tài * phát hiện bệnh sớm nên kịp thời chữa trị",
  },
  {
    word: "phát lộ",
    part_of_speech: "động từ",
    meaning:
      "bộc lộ ra, để lộ ra một cách rõ ràng: sự ghen tức ngấm ngầm giờ đã phát lộ",
    example: "sự ghen tức ngấm ngầm giờ đã phát lộ",
  },
  {
    word: "phát mại",
    part_of_speech: "động từ",
    meaning: "(cũ) đem bán: phát mại chiếc bình cổ",
    example: "phát mại chiếc bình cổ",
  },
  {
    word: "phát mại",
    part_of_speech: "động từ",
    meaning:
      "đem bán công khai tài sản đã tịch thu theo pháp luật: phát mại tài sản thế chấp để thu nợ * phát mại hàng nhập lậu mới tịch thu",
    example:
      "phát mại tài sản thế chấp để thu nợ * phát mại hàng nhập lậu mới tịch thu",
  },
  {
    word: "phát hoả",
    part_of_speech: "động từ",
    meaning: "bắt đầu bốc cháy: căn nhà phát hoả",
    example: "căn nhà phát hoả",
  },
  {
    word: "phát hoả",
    part_of_speech: "động từ",
    meaning: "nổ súng, bắt đầu nổ súng: chưa tới giờ phát hoả",
    example: "chưa tới giờ phát hoả",
  },
  {
    word: "phát huy",
    part_of_speech: "động từ",
    meaning:
      "làm cho cái hay, cái tốt lan rộng tác dụng và tiếp tục phát triển thêm: phát huy quyền làm chủ * phát huy ưu điểm, khắc phục nhược điểm",
    example: "phát huy quyền làm chủ * phát huy ưu điểm, khắc phục nhược điểm",
  },
  {
    word: "phát ngôn",
    part_of_speech: "động từ",
    meaning:
      "phát biểu ý kiến một cách chính thức, thay mặt cho một nhân vật hay một tổ chức: người phát ngôn của bộ ngoại giao",
    example: "người phát ngôn của bộ ngoại giao",
  },
  {
    word: "phát ngôn",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) nói ra, phát biểu ra thành lời: phát ngôn bừa bãi",
    example: "phát ngôn bừa bãi",
  },
  {
    word: "phát ngôn",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị cơ bản của giao tiếp bằng ngôn ngữ, do một lời nói ra tạo nên trong một hoàn cảnh cụ thể và mang một nội dung tương đối trọn vẹn.",
    example: "thằng phát vãng * đồ phát vãng",
  },
  {
    word: "phát minh",
    part_of_speech: "",
    meaning:
      "tìm ra cái có ý nghĩa, có giá trị lớn cho khoa học và loài người: Newton là người phát minh ra định luật  * một phát minh vĩ đại",
    example: "Newton là người phát minh ra định luật  * một phát minh vĩ đại",
  },
  {
    word: "phát nổ",
    part_of_speech: "động từ",
    meaning: "bắt đầu nổ: máy bay bị phát nổ",
    example: "máy bay bị phát nổ",
  },
  {
    word: "phát quang",
    part_of_speech: "động từ",
    meaning:
      "phát sạch cây cối để làm cho sáng sủa, gọn gàng, cho tầm mắt không còn bị che chắn: phát quang bụi rậm",
    example: "phát quang bụi rậm",
  },
  {
    word: "phát ngôn viên",
    part_of_speech: "danh từ",
    meaning: "người phát ngôn: phát ngôn viên của bộ ngoại giao",
    example: "phát ngôn viên của bộ ngoại giao",
  },
  {
    word: "phát kiến",
    part_of_speech: "",
    meaning: "(hiếm) điều phát hiện có ý nghĩa khoa học: phát kiến về địa lí",
    example: "phát kiến về địa lí",
  },
  {
    word: "phát sóng",
    part_of_speech: "động từ",
    meaning:
      "phát trên sóng vô tuyến: tăng thời lượng phát sóng * phát sóng lại bộ phim theo yêu cầu của khán giả",
    example:
      "tăng thời lượng phát sóng * phát sóng lại bộ phim theo yêu cầu của khán giả",
  },
  {
    word: "phát sinh",
    part_of_speech: "động từ",
    meaning:
      "bắt đầu sinh ra, nảy sinh ra (thường là cái không hay): có nhiều vấn đề mới phát sinh * phát sinh tiêu cực",
    example: "có nhiều vấn đề mới phát sinh * phát sinh tiêu cực",
  },
  {
    word: "phát sốt phát rét",
    part_of_speech: "",
    meaning: "(khẩu ngữ) lo lắng đến mức phát ốm: lo đến phát sốt phát rét",
    example: "lo đến phát sốt phát rét",
  },
  {
    word: "phát thanh",
    part_of_speech: "động từ",
    meaning:
      "phát và truyền âm thanh bằng sóng vô tuyến điện: đài phát thanh * buổi phát thanh ca nhạc",
    example: "đài phát thanh * buổi phát thanh ca nhạc",
  },
  {
    word: "phát tác",
    part_of_speech: "động từ",
    meaning:
      "gây tác hại: bệnh sắp phát tác * chất độc đã phát tác trong cơ thể",
    example: "bệnh sắp phát tác * chất độc đã phát tác trong cơ thể",
  },
  {
    word: "phát tài",
    part_of_speech: "động từ",
    meaning:
      "(làm ăn, buôn bán) gặp nhiều may mắn, kiếm được nhiều tiền, trở thành giàu có: làm ăn phát tài",
    example: "làm ăn phát tài",
  },
  {
    word: "phát tán",
    part_of_speech: "động từ",
    meaning:
      "(hiện tượng) rải rộng các sinh vật hoặc bộ phận sinh sản của sinh vật ra xung quanh: phấn hoa phát tán theo gió",
    example: "phấn hoa phát tán theo gió",
  },
  {
    word: "phát tán",
    part_of_speech: "động từ",
    meaning:
      "phát ra, truyền ra rộng rãi, gây ảnh hưởng (thường là không tốt) đến nhiều nơi, nhiều người: phát tán truyền đơn * đoạn phim bị phát tán trên Internet",
    example: "phát tán truyền đơn * đoạn phim bị phát tán trên Internet",
  },
  {
    word: "phát tán",
    part_of_speech: "động từ",
    meaning:
      "có tác dụng làm cho ra mồ hôi để giải độc (một phương pháp chữa bệnh trong đông y): vị thuốc phát tán",
    example: "vị thuốc phát tán",
  },
  {
    word: "phát tích",
    part_of_speech: "động từ",
    meaning:
      "bắt đầu làm nên sự nghiệp lớn từ nơi nào đó: Lam Sơn chính là nơi phát tích của Lê Lợi",
    example: "Lam Sơn chính là nơi phát tích của Lê Lợi",
  },
  {
    word: "phát tang",
    part_of_speech: "động từ",
    meaning:
      "(thân nhân của người chết) bắt đầu mặc quần áo tang và chính thức báo cho bà con, bạn bè biết về việc gia đình mình có người qua đời: đến giờ phát tang",
    example: "đến giờ phát tang",
  },
  {
    word: "phát triển",
    part_of_speech: "động từ",
    meaning:
      "biến đổi hoặc làm cho biến đổi theo chiều hướng tăng, từ ít đến nhiều, hẹp đến rộng, thấp đến cao, đơn giản đến phức tạp: kinh tế phát triển * đất nước càng ngày càng phát triển",
    example: "kinh tế phát triển * đất nước càng ngày càng phát triển",
  },
  {
    word: "phát tiết",
    part_of_speech: "động từ",
    meaning:
      'biểu lộ rõ ra bên ngoài: "Anh hoa phát tiết ra ngoài, Nghìn thu bạc mệnh một đời tài hoa." (TKiều)',
    example:
      'Anh hoa phát tiết ra ngoài, Nghìn thu bạc mệnh một đời tài hoa." (TKiều)',
  },
  {
    word: "phát thanh viên",
    part_of_speech: "danh từ",
    meaning:
      "người đọc tin, bài trên đài phát thanh, đài truyền hình: phát thanh viên đài tiếng nói Việt Nam",
    example: "phát thanh viên đài tiếng nói Việt Nam",
  },
  {
    word: "phát tướng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) (vẻ mặt, dáng người) trở nên rạng rỡ, béo tốt, như báo hiệu sự may mắn, thành đạt: người đã bắt đầu phát tướng",
    example: "người đã bắt đầu phát tướng",
  },
  {
    word: "phạt vạ",
    part_of_speech: "động từ",
    meaning:
      "bắt phạt vì đã làm điều trái với tục lệ hay quy ước của làng xã thời trước: chửa hoang nên bị làng phạt vạ",
    example: "chửa hoang nên bị làng phạt vạ",
  },
  {
    word: "phát xuất",
    part_of_speech: "động từ",
    meaning: "(hiếm) như xuất phát (ng2): mọi chuyện phát xuất từ lòng tham",
    example: "mọi chuyện phát xuất từ lòng tham",
  },
  {
    word: "phát xạ",
    part_of_speech: "động từ",
    meaning: "phát sóng điện từ: tốc độ phát xạ",
    example: "tốc độ phát xạ",
  },
  {
    word: "phát xít",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về chủ nghĩa phát xít, có tính chất của chủ nghĩa phát xít: chế độ phát xít * chính sách độc tài phát xít",
    example: "chế độ phát xít * chính sách độc tài phát xít",
  },
  {
    word: "phát xít",
    part_of_speech: "danh từ",
    meaning: "kẻ theo chủ nghĩa phát xít: diệt phát xít",
    example: "diệt phát xít",
  },
  {
    word: "phăm phăm",
    part_of_speech: "phụ từ",
    meaning:
      "từ gợi tả dáng vẻ chuyển động hoặc làm một động tác nào đó nhanh, mạnh theo một hướng nhất định, bất chấp mọi cản trở: chạy phăm phăm * phăm phăm đi trước dẫn đường",
    example: "chạy phăm phăm * phăm phăm đi trước dẫn đường",
  },
  {
    word: "phắc",
    part_of_speech: "tính từ",
    meaning:
      'hoàn toàn không có một tiếng động: ngồi im phắc * "(...) bữa cơm lặng phắc, nghe được tiếng ruồi bay qua." (HCận; 10)',
    example:
      'ngồi im phắc * "(...) bữa cơm lặng phắc, nghe được tiếng ruồi bay qua." (HCận; 10)',
  },
  {
    word: "phay",
    part_of_speech: "động từ",
    meaning:
      "làm cho đất nhỏ ra, tơi ra hoặc nhuyễn ra bằng phay: phay đất để chuẩn bị cấy",
    example: "phay đất để chuẩn bị cấy",
  },
  {
    word: "phay",
    part_of_speech: "động từ",
    meaning:
      "tạo một mặt phẳng hay một rãnh trên chi tiết máy bằng loại dao quay tròn có nhiều lưỡi cắt: máy phay",
    example: "máy phay",
  },
  {
    word: "phay",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) (thịt lợn, gà luộc) được thái lát mỏng hoặc xé nhỏ ra: đĩa thịt phay * món gà xé phay",
    example: "đĩa thịt phay * món gà xé phay",
  },
  {
    word: "phăm phắp",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) đúng đến tận các chi tiết hay các bộ phận, không hề sai chệch: xe chạy đúng giờ phăm phắp * động tác đều phăm phắp",
    example: "xe chạy đúng giờ phăm phắp * động tác đều phăm phắp",
  },
  {
    word: "phăng",
    part_of_speech: "phụ từ",
    meaning:
      "ngay lập tức, một cách rất nhanh, mạnh và gọn: chối phăng * chiếc cầu tre bị lũ cuốn phăng",
    example: "chối phăng * chiếc cầu tre bị lũ cuốn phăng",
  },
  {
    word: "phẳng",
    part_of_speech: "tính từ",
    meaning:
      "có bề mặt bằng, đều, không lồi lõm, nhăn nheo: san đất cho phẳng * mặt nước phẳng như gương",
    example: "san đất cho phẳng * mặt nước phẳng như gương",
  },
  {
    word: "phẳng",
    part_of_speech: "tính từ",
    meaning: "nằm trong một mặt phẳng: hình học phẳng",
    example: "hình học phẳng",
  },
  {
    word: "phắn",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) rời khỏi, biến đi thật nhanh: tụi nó phắn hết rồi * tìm đường mà phắn",
    example: "tụi nó phắn hết rồi * tìm đường mà phắn",
  },
  {
    word: "phẳng lặng",
    part_of_speech: "tính từ",
    meaning:
      "êm ả, không một chút xáo động: mặt hồ phẳng lặng * cuộc sống phẳng lặng",
    example: "mặt hồ phẳng lặng * cuộc sống phẳng lặng",
  },
  {
    word: "phăng phắc",
    part_of_speech: "tính từ",
    meaning:
      "im lặng đến mức không có một tiếng động nhỏ nào: cả lớp ngồi im phăng phắc",
    example: "cả lớp ngồi im phăng phắc",
  },
  {
    word: "phẳng phiu",
    part_of_speech: "tính từ",
    meaning:
      "phẳng đều và ngay ngắn, trông thích mắt: quần áo là phẳng phiu * con đường phẳng phiu, thẳng tắp",
    example: "quần áo là phẳng phiu * con đường phẳng phiu, thẳng tắp",
  },
  {
    word: "phẩm",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi chung các chất dùng để nhuộm màu: phẩm màu * quần áo dính đầy phẩm",
    example: "phẩm màu * quần áo dính đầy phẩm",
  },
  {
    word: "phẩm",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị chiếc oản dùng để cúng: cúng một phẩm oản",
    example: "cúng một phẩm oản",
  },
  {
    word: "phăng teo",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) bỏ đi, cắt bỏ đi một cách dứt khoát, không thương tiếc: bạn bè gì nó, cho phăng teo đi là xong",
    example: "bạn bè gì nó, cho phăng teo đi là xong",
  },
  {
    word: "phăng teo",
    part_of_speech: "động từ",
    meaning: "hỏng hoặc chết hết cả: lộ ra thì phăng teo cả lũ",
    example: "lộ ra thì phăng teo cả lũ",
  },
  {
    word: "phắt",
    part_of_speech: "phụ từ",
    meaning:
      "một cách nhanh, gọn, ngay lập tức, với thái độ dứt khoát: đứng phắt dậy * gạt phắt đi * chối phắt",
    example: "đứng phắt dậy * gạt phắt đi * chối phắt",
  },
  {
    word: "phăng phăng",
    part_of_speech: "phụ từ",
    meaning:
      "(di chuyển) ngay lập tức một cách rất nhanh, mạnh và liền một mạch: chạy phăng phăng * cây gỗ trôi phăng phăng theo dòng nước",
    example: "chạy phăng phăng * cây gỗ trôi phăng phăng theo dòng nước",
  },
  {
    word: "phẳng lì",
    part_of_speech: "tính từ",
    meaning: "phẳng và nhẵn lì: bờ cát phẳng lì",
    example: "bờ cát phẳng lì",
  },
  {
    word: "phẩm cấp",
    part_of_speech: "danh từ",
    meaning: "(cũ) phẩm trật: phẩm cấp quan lại",
    example: "phẩm cấp quan lại",
  },
  {
    word: "phẩm cấp",
    part_of_speech: "danh từ",
    meaning:
      "thứ bậc về phẩm chất của hàng hoá, sản phẩm: xuất khẩu loại gạo có phẩm cấp cao",
    example: "xuất khẩu loại gạo có phẩm cấp cao",
  },
  {
    word: "phẩm cách",
    part_of_speech: "danh từ",
    meaning:
      "phẩm chất, tư cách của một con người: phẩm cách thanh cao * một con người có phẩm cách",
    example: "phẩm cách thanh cao * một con người có phẩm cách",
  },
  {
    word: "phẩm giá",
    part_of_speech: "danh từ",
    meaning:
      "giá trị riêng của con người: giữ gìn phẩm giá * bị bôi nhọ phẩm giá",
    example: "giữ gìn phẩm giá * bị bôi nhọ phẩm giá",
  },
  {
    word: "phẩm chất",
    part_of_speech: "danh từ",
    meaning:
      "cái làm nên giá trị của một người hay một vật: phẩm chất người lính * hàng kém phẩm chất",
    example: "phẩm chất người lính * hàng kém phẩm chất",
  },
  {
    word: "phầm phập",
    part_of_speech: "tính từ",
    meaning:
      "như phập (nhưng ý liên tiếp): những mảnh đạn phầm phập găm vào thân cây",
    example: "những mảnh đạn phầm phập găm vào thân cây",
  },
  {
    word: "phẩm vật",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, hiếm) như vật phẩm (thường nói về những thứ quý giá): phẩm vật quý của địa phương",
    example: "phẩm vật quý của địa phương",
  },
  {
    word: "phân",
    part_of_speech: "danh từ",
    meaning:
      "chất cặn bã do người hoặc động vật bài tiết ra theo đường ruột, qua hậu môn.",
    example: "bón phân cho lúa * nhất nước, nhì phân, tam cần, tứ giống (tng)",
  },
  {
    word: "phân",
    part_of_speech: "danh từ",
    meaning: "đơn vị cũ đo độ dài, bằng một phần trăm của thước.",
    example: "bé đã cao 80 phân * ống quần rộng 20 phân",
  },
  {
    word: "phân",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi khác trong dân gian của centimet: bé đã cao 80 phân * ống quần rộng 20 phân",
    example: "một lạng vàng bị hao mất hai phân",
  },
  {
    word: "phân",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị cũ đo khối lượng, bằng một phần trăm của lạng, tức khoảng 0,378 gram: một lạng vàng bị hao mất hai phân",
    example: "vay lãi năm phân (năm phần trăm mỗi tháng)",
  },
  {
    word: "phân",
    part_of_speech: "động từ",
    meaning:
      "tách ra thành các phần riêng biệt, từ một chỉnh thể: phân làm ba phần * phân ranh giới",
    example: "phân làm ba phần * phân ranh giới",
  },
  {
    word: "phân",
    part_of_speech: "động từ",
    meaning: "chia, cấp cho để sử dụng: được cơ quan phân nhà",
    example: "được cơ quan phân nhà",
  },
  {
    word: "phân",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) phân công (nói tắt): phân về phòng kinh doanh * phân trực nhật * phân người trực đêm",
    example: "phân về phòng kinh doanh * phân trực nhật * phân người trực đêm",
  },
  {
    word: "phân",
    part_of_speech: "động từ",
    meaning: "phân biệt (nói tắt): chưa phân thắng bại",
    example: "chưa phân thắng bại",
  },
  {
    word: "phần",
    part_of_speech: "danh từ",
    meaning:
      "cái được phân chia ra từ một tổng thể, trong quan hệ với tổng thể đó: một bài văn gồm có ba phần: mở bài, thân bài, kết luận * bị thương ở phần mềm",
    example:
      "một bài văn gồm có ba phần: mở bài, thân bài, kết luận * bị thương ở phần mềm",
  },
  {
    word: "phần",
    part_of_speech: "danh từ",
    meaning:
      "cái thuộc về hay được phân cho từng người, từng đơn vị, trong quan hệ với những cái thuộc về hay được phân cho những người khác, đơn vị khác: chịu một phần trách nhiệm * hoàn thành phần việc của mình",
    example: "chịu một phần trách nhiệm * hoàn thành phần việc của mình",
  },
  {
    word: "phần",
    part_of_speech: "danh từ",
    meaning:
      "mức độ nào đó, không xác định: nói thế thì cũng có phần đúng * chỉ bớt đau phần nào thôi",
    example: "nói thế thì cũng có phần đúng * chỉ bớt đau phần nào thôi",
  },
  {
    word: "phần",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) để phần (nói tắt): phần cơm canh cho người ăn sau",
    example: "phần cơm canh cho người ăn sau",
  },
  {
    word: "phẩm hàm",
    part_of_speech: "danh từ",
    meaning: "(cũ) cấp bậc cùng với hàm của quan lại: được thăng phẩm hàm",
    example: "được thăng phẩm hàm",
  },
  {
    word: "phẩm hạnh",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) tính nết, đạo đức tốt, biểu hiện phẩm giá con người (thường nói về phụ nữ): phẩm hạnh đoan chính",
    example: "phẩm hạnh đoan chính",
  },
  {
    word: "phấn",
    part_of_speech: "danh từ",
    meaning:
      "hạt nhỏ, thường có màu vàng, do nhị hoa sản sinh ra, chứa mầm mống của tế bào sinh dục đực của cây.",
    example: "bị ngứa vì phấn bướm * vỏ quả bí đao phủ một lớp phấn trắng",
  },
  {
    word: "phấn",
    part_of_speech: "danh từ",
    meaning:
      "chất hạt nhỏ như bột ở cánh một số loài sâu bọ hay ở lá, quả của một số loài cây: bị ngứa vì phấn bướm * vỏ quả bí đao phủ một lớp phấn trắng",
    example: "đánh phấn * phấn rôm",
  },
  {
    word: "phấn",
    part_of_speech: "danh từ",
    meaning:
      "bột trộn lẫn với hoá chất hoặc chất thơm, dùng để trang điểm hoặc bảo vệ da: đánh phấn * phấn rôm",
    example: "viên phấn * tay dính đầy bụi phấn",
  },
  {
    word: "phận",
    part_of_speech: "danh từ",
    meaning:
      'thân phận (nói tắt): phận hèn * "Đau đớn thay, phận đàn bà!, Lời rằng bạc mệnh cũng là lời chung." (TKiều)',
    example:
      'phận hèn * "Đau đớn thay, phận đàn bà!, Lời rằng bạc mệnh cũng là lời chung." (TKiều)',
  },
  {
    word: "phận",
    part_of_speech: "danh từ",
    meaning:
      "địa vị và gắn với nó là bổn phận của người bề dưới đối với người bề trên: phận làm dâu * phận tôi tớ",
    example: "phận làm dâu * phận tôi tớ",
  },
  {
    word: "phân bón",
    part_of_speech: "danh từ",
    meaning:
      "phân dùng để bón cho cây nói chung: sản xuất phân bón * nhà máy phân bón",
    example: "sản xuất phân bón * nhà máy phân bón",
  },
  {
    word: "phân biệt",
    part_of_speech: "động từ",
    meaning:
      "nhận biết được sự khác nhau, căn cứ vào đặc điểm, tính chất: hai chiếc mũ giống nhau nên khó phân biệt * không phân biệt được phải trái, đúng sai",
    example:
      "hai chiếc mũ giống nhau nên khó phân biệt * không phân biệt được phải trái, đúng sai",
  },
  {
    word: "phân biệt",
    part_of_speech: "động từ",
    meaning:
      "coi là khác nhau để có sự đối xử không như nhau: phân biệt chủng tộc * không phân biệt sang hèn",
    example: "phân biệt chủng tộc * không phân biệt sang hèn",
  },
  {
    word: "phân bố",
    part_of_speech: "động từ",
    meaning:
      "chia ra, rải ra nhiều nơi, thường theo nguyên tắc nào đó: dân cư phân bố không đều * phân bố tài nguyên",
    example: "dân cư phân bố không đều * phân bố tài nguyên",
  },
  {
    word: "phân bổ",
    part_of_speech: "động từ",
    meaning:
      "chia hết cái phải đóng góp hoặc cái được hưởng ra cho mỗi cá nhân, mỗi đơn vị nhận một phần: phân bổ ngân sách cho các tỉnh * lãi được phân bổ đều cho các bên",
    example:
      "phân bổ ngân sách cho các tỉnh * lãi được phân bổ đều cho các bên",
  },
  {
    word: "phân bì",
    part_of_speech: "động từ",
    meaning:
      "so sánh hơn thiệt, cho rằng người nào đó được phần hơn mình và tỏ ý không bằng lòng: phân bì hơn thiệt",
    example: "phân bì hơn thiệt",
  },
  {
    word: "phân cách",
    part_of_speech: "động từ",
    meaning: "phân cho tách nhau riêng biệt ra: dải phân cách đường",
    example: "dải phân cách đường",
  },
  {
    word: "phân cấp",
    part_of_speech: "động từ",
    meaning:
      "phân thành nhiều cấp, nhiều hạng: phân cấp quản lí * phân cấp các cơ sở khám chữa bệnh",
    example: "phân cấp quản lí * phân cấp các cơ sở khám chữa bệnh",
  },
  {
    word: "phân bua",
    part_of_speech: "động từ",
    meaning:
      "nói, trình bày cho rõ để cho người ta đừng có nghĩ sai, nghĩ xấu cho mình: phân bua về sự đường đột của mình * còn lạ gì nhau nữa mà phải phân bua",
    example:
      "phân bua về sự đường đột của mình * còn lạ gì nhau nữa mà phải phân bua",
  },
  {
    word: "phân chia",
    part_of_speech: "động từ",
    meaning:
      "chia thành nhiều phần, giao cho từng cá nhân, từng đơn vị: phân chia công việc cụ thể cho từng cán bộ * phân chia tài sản",
    example: "phân chia công việc cụ thể cho từng cán bộ * phân chia tài sản",
  },
  {
    word: "phân chia",
    part_of_speech: "động từ",
    meaning:
      "chia ra thành nhiều bộ phận hoặc nhiều giai đoạn: quá trình phát triển được phân chia thành ba giai đoạn",
    example: "quá trình phát triển được phân chia thành ba giai đoạn",
  },
  {
    word: "phẫn chí",
    part_of_speech: "động từ",
    meaning:
      "uất hận vì chí không được thoả, đến mức thấy bế tắc, trở nên bi quan, tiêu cực: thi trượt sinh phẫn chí * phẫn chí bỏ nhà ra đi",
    example: "thi trượt sinh phẫn chí * phẫn chí bỏ nhà ra đi",
  },
  {
    word: "phân công",
    part_of_speech: "động từ",
    meaning:
      "giao cho làm một phần việc nhất định nào đó: phân công công tác * được nhà trường phân công làm chủ nhiệm lớp",
    example: "phân công công tác * được nhà trường phân công làm chủ nhiệm lớp",
  },
  {
    word: "phân chuồng",
    part_of_speech: "danh từ",
    meaning:
      "phân gia súc có lẫn nước giải và rác độn được lấy từ chuồng của vật nuôi ra, ủ làm phân bón, dùng để bón cây: bón phân chuồng * ủ phân chuồng",
    example: "bón phân chuồng * ủ phân chuồng",
  },
  {
    word: "phấn chấn",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái hăng hái, hứng khởi do tác động của một sự việc hoặc ý nghĩ tích cực, hợp nguyện vọng: tinh thần phấn chấn",
    example: "tinh thần phấn chấn",
  },
  {
    word: "phần cứng",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi chung phần những chi tiết, linh kiện có thể tháo lắp được của một máy tính; phân biệt với phần mềm: hỏng phần cứng * ổ đĩa là một thiết bị phần cứng của máy vi tính",
    example: "hỏng phần cứng * ổ đĩa là một thiết bị phần cứng của máy vi tính",
  },
  {
    word: "phấn đấu",
    part_of_speech: "động từ",
    meaning:
      "cố gắng, bền bỉ thực hiện nhằm đạt tới mục đích cao đẹp đã đề ra: phấn đấu trở thành học sinh xuất sắc",
    example: "phấn đấu trở thành học sinh xuất sắc",
  },
  {
    word: "phận đẹp duyên ưa",
    part_of_speech: "",
    meaning:
      '(văn chương) như duyên ưa phận đẹp: "Người sao phận đẹp duyên ưa, Người sao chểnh mảng mà chưa vuông tròn." (ca dao)',
    example:
      'Người sao phận đẹp duyên ưa, Người sao chểnh mảng mà chưa vuông tròn." (ca dao)',
  },
  {
    word: "phân định",
    part_of_speech: "động từ",
    meaning:
      "phân chia và xác định một cách rõ ràng, cụ thể: đường biên giới được phân định rõ ràng",
    example: "đường biên giới được phân định rõ ràng",
  },
  {
    word: "phân đoạn",
    part_of_speech: "danh từ",
    meaning:
      "phần, đoạn được chia ra: đã hoàn thành những phân đoạn đầu tiên của công trình",
    example: "đã hoàn thành những phân đoạn đầu tiên của công trình",
  },
  {
    word: "phân đội",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi chung các đơn vị tổ chức của lực lượng vũ trang, từ tiểu đội đến tiểu đoàn: phân đội trinh sát",
    example: "phân đội trinh sát",
  },
  {
    word: "phân giải",
    part_of_speech: "động từ",
    meaning:
      "giải thích, phân tích để cho thấy rõ phải trái, đúng sai: lựa lời phân giải * phân giải sự xích mích giữa hai bên",
    example: "lựa lời phân giải * phân giải sự xích mích giữa hai bên",
  },
  {
    word: "phân giải",
    part_of_speech: "động từ",
    meaning:
      "(quá trình một chất) biến đổi, phân ra thành những chất khác, đơn giản hơn: chất hữu cơ phân giải thành chất vô cơ",
    example: "chất hữu cơ phân giải thành chất vô cơ",
  },
  {
    word: "phân chất",
    part_of_speech: "động từ",
    meaning:
      "phân tích để xác định thành phần, tính chất của một chất: phân chất một mẫu quặng",
    example: "phân chất một mẫu quặng",
  },
  {
    word: "phần đông",
    part_of_speech: "danh từ",
    meaning:
      "số lượng không xác định, nhưng là chiếm số đông trong một tập hợp người: phần đông mọi người đều tán thành * dân làng phần đông làm nghề chài lưới",
    example:
      "phần đông mọi người đều tán thành * dân làng phần đông làm nghề chài lưới",
  },
  {
    word: "phân giới",
    part_of_speech: "động từ",
    meaning: "phân chia ranh giới: đường phân giới giữa hai tỉnh",
    example: "đường phân giới giữa hai tỉnh",
  },
  {
    word: "phân độ",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị đo được phân chia trong một thang độ của một dụng cụ đo lường: trên đòn cân có chia phân độ",
    example: "trên đòn cân có chia phân độ",
  },
  {
    word: "phân hạch",
    part_of_speech: "động từ",
    meaning:
      "(hiện tượng hạt nhân nguyên tử) vỡ ra, thường thành hai mảnh lớn, giải phóng neutron và toả ra nhiều năng lượng: năng lượng phân hạch",
    example: "năng lượng phân hạch",
  },
  {
    word: "phân hạng",
    part_of_speech: "động từ",
    meaning:
      "chia ra thành nhiều hạng, nhiều loại: phân hạng theo thứ tự từ thấp đến cao",
    example: "phân hạng theo thứ tự từ thấp đến cao",
  },
  {
    word: "phân hoá",
    part_of_speech: "động từ",
    meaning:
      "chia thành nhiều bộ phận có những đặc điểm khác hẳn nhau: phân hoá giai cấp * sự phân hoá giàu nghèo ngày càng rõ rệt",
    example: "phân hoá giai cấp * sự phân hoá giàu nghèo ngày càng rõ rệt",
  },
  {
    word: "phân hoá",
    part_of_speech: "động từ",
    meaning:
      "biến đổi dần thành chất khác ở những điều kiện nhất định: đá basalt bị phân hoá thành đất đỏ",
    example: "đá basalt bị phân hoá thành đất đỏ",
  },
  {
    word: "phân hội",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị tổ chức dưới hội, trực thuộc hội: hội khuyến học có nhiều phân hội ở các tỉnh",
    example: "hội khuyến học có nhiều phân hội ở các tỉnh",
  },
  {
    word: "phân hiệu",
    part_of_speech: "danh từ",
    meaning:
      "chi nhánh của một trường học: phân hiệu của trường đại học Y tại Huế",
    example: "phân hiệu của trường đại học Y tại Huế",
  },
  {
    word: "phẫn khích",
    part_of_speech: "động từ",
    meaning:
      "uất hận cao độ khiến cho tinh thần bị kích động mạnh mẽ: cơn phẫn khích",
    example: "cơn phẫn khích",
  },
  {
    word: "phân kì",
    part_of_speech: "động từ",
    meaning:
      "phân chia thành những giai đoạn khác nhau, căn cứ vào nội dung và đặc điểm phát triển chủ yếu của từng giai đoạn: sự phân kì trong lịch sử văn học",
    example: "sự phân kì trong lịch sử văn học",
  },
  {
    word: "phân kì",
    part_of_speech: "động từ",
    meaning:
      '(cũ, văn chương) chia tay, mỗi người đi một ngả: "Đoạn trường thay lúc phân kì, Mẹ thì bãi bắc, con thì non tây." (PT)',
    example:
      'Đoạn trường thay lúc phân kì, Mẹ thì bãi bắc, con thì non tây." (PT)',
  },
  {
    word: "phân kì",
    part_of_speech: "động từ",
    meaning:
      "(tia sáng) càng đi càng tách xa nhau: tia sáng phân kì * thấu kính phân kì",
    example: "tia sáng phân kì * thấu kính phân kì",
  },
  {
    word: "phân khoáng",
    part_of_speech: "danh từ",
    meaning: "phân bón được lấy từ khoáng sản: xí nghiệp phân khoáng",
    example: "xí nghiệp phân khoáng",
  },
  {
    word: "phấn khích",
    part_of_speech: "",
    meaning:
      "phấn khởi do tinh thần được kích động, cổ vũ: được động viên kịp thời, mọi người đều phấn khích",
    example: "được động viên kịp thời, mọi người đều phấn khích",
  },
  {
    word: "phân khối",
    part_of_speech: "danh từ",
    meaning: "centimet khối.",
    example: "xe máy 110 phân khối * xe phân khối lớn",
  },
  {
    word: "phân huỷ",
    part_of_speech: "động từ",
    meaning:
      "(hiện tượng một chất) phân chia thành nhiều chất khác, không mang tính chất của chất ban đầu: nước phân huỷ thành hydrogen và oxygen * các chất hữu cơ bắt đầu phân huỷ",
    example:
      "nước phân huỷ thành hydrogen và oxygen * các chất hữu cơ bắt đầu phân huỷ",
  },
  {
    word: "phấn khởi",
    part_of_speech: "",
    meaning:
      "cảm thấy vui sướng trong lòng vì được cổ vũ, khích lệ: tinh thần phấn khởi * phấn khởi vì được tin con thi đỗ",
    example: "tinh thần phấn khởi * phấn khởi vì được tin con thi đỗ",
  },
  {
    word: "phân li",
    part_of_speech: "động từ",
    meaning:
      '(văn chương) như chia li: buổi phân li * "Ai làm nên bước phân li, Cám công mưa nắng kẻ đi, người về." (ca dao)',
    example:
      'buổi phân li * "Ai làm nên bước phân li, Cám công mưa nắng kẻ đi, người về." (ca dao)',
  },
  {
    word: "phân li",
    part_of_speech: "động từ",
    meaning:
      "phân chia một chất hoá học thành nhiều phần, mà những phần này có thể tái kết hợp để lại tạo thành chất ấy: quá trình phân li phân tử thành các ion",
    example: "quá trình phân li phân tử thành các ion",
  },
  {
    word: "phân li",
    part_of_speech: "động từ",
    meaning:
      "xuất hiện nhiều dạng khác nhau từ một dạng ban đầu trong quá trình tiến hoá: phân li tính trạng",
    example: "phân li tính trạng",
  },
  {
    word: "phân kỳ",
    part_of_speech: "động từ",
    meaning:
      "phân chia thành những giai đoạn khác nhau, căn cứ vào nội dung và đặc điểm phát triển chủ yếu của từng giai đoạn: sự phân kì trong lịch sử văn học",
    example: "sự phân kì trong lịch sử văn học",
  },
  {
    word: "phân kỳ",
    part_of_speech: "động từ",
    meaning:
      '(cũ, văn chương) chia tay, mỗi người đi một ngả: "Đoạn trường thay lúc phân kì, Mẹ thì bãi bắc, con thì non tây." (PT)',
    example:
      'Đoạn trường thay lúc phân kì, Mẹ thì bãi bắc, con thì non tây." (PT)',
  },
  {
    word: "phân kỳ",
    part_of_speech: "động từ",
    meaning:
      "(tia sáng) càng đi càng tách xa nhau: tia sáng phân kì * thấu kính phân kì",
    example: "tia sáng phân kì * thấu kính phân kì",
  },
  {
    word: "phân lập",
    part_of_speech: "động từ",
    meaning:
      "chia tách cho thành biệt lập với nhau, không phụ thuộc vào nhau: thuyết tam quyền phân lập",
    example: "thuyết tam quyền phân lập",
  },
  {
    word: "phân loại",
    part_of_speech: "động từ",
    meaning:
      "chia ra thành nhiều loại khác nhau: phân loại con giống * phân loại các mặt hàng",
    example: "phân loại con giống * phân loại các mặt hàng",
  },
  {
    word: "phân liệt",
    part_of_speech: "động từ",
    meaning:
      "chia rẽ thành những phần tách biệt và đối lập nhau, không còn là một tổ chức thống nhất nữa: thần kinh phân liệt * tránh sự phân liệt trong nội bộ",
    example: "thần kinh phân liệt * tránh sự phân liệt trong nội bộ",
  },
  {
    word: "phần lớn",
    part_of_speech: "danh từ",
    meaning:
      "số lượng không xác định, nhưng là một số lớn trong tổng số: dành phần lớn thời gian cho gia đình * phần lớn học sinh đều đạt hạnh kiểm tốt",
    example:
      "dành phần lớn thời gian cho gia đình * phần lớn học sinh đều đạt hạnh kiểm tốt",
  },
  {
    word: "phân minh",
    part_of_speech: "tính từ",
    meaning:
      "rõ ràng, rành mạch: tiền bạc phải phân minh * thưởng phạt phân minh",
    example: "tiền bạc phải phân minh * thưởng phạt phân minh",
  },
  {
    word: "phân luồng",
    part_of_speech: "động từ",
    meaning:
      "phân thành luồng đường để các phương tiện giao thông đi lại theo tuyến nhất định, nhằm đảm bảo giao thông thông suốt, có trật tự: phân luồng xe qua cầu trong giờ cao điểm",
    example: "phân luồng xe qua cầu trong giờ cao điểm",
  },
  {
    word: "phần mềm",
    part_of_speech: "danh từ",
    meaning:
      "phần của cơ thể mà không phải là xương: bị thương ở phần mềm * sây sát phần mềm",
    example: "bị thương ở phần mềm * sây sát phần mềm",
  },
  {
    word: "phần mềm",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi chung các chương trình được sử dụng trên máy tính điện tử; phân biệt với phần cứng: viết phần mềm cho máy tính * ngành công nghiệp phần mềm",
    example: "viết phần mềm cho máy tính * ngành công nghiệp phần mềm",
  },
  {
    word: "phận mỏng cánh chuồn",
    part_of_speech: "",
    meaning:
      '(cũ, văn chương) ví thân phận mỏng manh, hẩm hiu: "Nghĩ mình phận mỏng cánh chuồn, Khuôn xanh biết có vuông tròn mà hay." (TKiều)',
    example:
      'Nghĩ mình phận mỏng cánh chuồn, Khuôn xanh biết có vuông tròn mà hay." (TKiều)',
  },
  {
    word: "phân lượng",
    part_of_speech: "danh từ",
    meaning:
      "lượng nhiều ít nhất định: phân lượng nước trong cơ thể người thường chiếm đến 90%",
    example: "phân lượng nước trong cơ thể người thường chiếm đến 90%",
  },
  {
    word: "phân ly",
    part_of_speech: "động từ",
    meaning:
      '(văn chương) như chia li: buổi phân li * "Ai làm nên bước phân li, Cám công mưa nắng kẻ đi, người về." (ca dao)',
    example:
      'buổi phân li * "Ai làm nên bước phân li, Cám công mưa nắng kẻ đi, người về." (ca dao)',
  },
  {
    word: "phân ly",
    part_of_speech: "động từ",
    meaning:
      "phân chia một chất hoá học thành nhiều phần, mà những phần này có thể tái kết hợp để lại tạo thành chất ấy: quá trình phân li phân tử thành các ion",
    example: "quá trình phân li phân tử thành các ion",
  },
  {
    word: "phân ly",
    part_of_speech: "động từ",
    meaning:
      "xuất hiện nhiều dạng khác nhau từ một dạng ban đầu trong quá trình tiến hoá: phân li tính trạng",
    example: "phân li tính trạng",
  },
  {
    word: "phần nào",
    part_of_speech: "danh từ",
    meaning:
      "một mức nào đó, thường là thấp, ít: giúp đỡ một phần nào * đoán biết được phần nào câu chuyện",
    example: "giúp đỡ một phần nào * đoán biết được phần nào câu chuyện",
  },
  {
    word: "phân nhiệm",
    part_of_speech: "động từ",
    meaning:
      "phân công và xác định nhiệm vụ, trách nhiệm rõ ràng trong công tác: cần phân công, phân nhiệm rõ ràng cho từng người trong tổ",
    example: "cần phân công, phân nhiệm rõ ràng cho từng người trong tổ",
  },
  {
    word: "phẫn nộ",
    part_of_speech: "",
    meaning:
      "uất hận đến mức bộc lộ những phản ứng mạnh mẽ, không kìm giữ được: tiếng thét phẫn nộ * cơn phẫn nộ",
    example: "tiếng thét phẫn nộ * cơn phẫn nộ",
  },
  {
    word: "phân phát",
    part_of_speech: "động từ",
    meaning:
      "chia ra từng phần rồi phát cho lần lượt từng cá nhân hay đơn vị (nói khái quát): phân phát công văn * bọn trẻ được phân phát quà trung thu",
    example: "phân phát công văn * bọn trẻ được phân phát quà trung thu",
  },
  {
    word: "phân phất",
    part_of_speech: "tính từ",
    meaning:
      '(văn chương) (gió, mưa) rất nhẹ nhàng và diễn ra liên tục: "Mành Tương phân phất gió đàn, Hương gây mùi nhớ, trà khan giọng tình." (TKiều)',
    example:
      'Mành Tương phân phất gió đàn, Hương gây mùi nhớ, trà khan giọng tình." (TKiều)',
  },
  {
    word: "phân phối",
    part_of_speech: "động từ",
    meaning:
      "phân chia cho nhiều cá nhân, nhiều đơn vị, thường theo những nguyên tắc, quy định chung nào đó: phân phối tiền cứu trợ cho các nạn nhân * lượng mưa phân phối không đều giữa các vùng",
    example:
      "phân phối tiền cứu trợ cho các nạn nhân * lượng mưa phân phối không đều giữa các vùng",
  },
  {
    word: "phân phối",
    part_of_speech: "động từ",
    meaning:
      "phân chia sản phẩm xã hội thành những phần khác nhau, theo những mục đích khác nhau (một khâu của quá trình tái sản xuất xã hội): phân phối thu nhập quốc dân cho tích luỹ và tiêu dùng",
    example: "phân phối thu nhập quốc dân cho tích luỹ và tiêu dùng",
  },
  {
    word: "phân phối",
    part_of_speech: "động từ",
    meaning:
      "hay t (tính chất của phép nhân) cho phép có thể nhân một số lần lượt với từng số hạng của tổng rồi cộng các kết quả lại: phép nhân có tính phân phối đối với phép cộng",
    example: "phép nhân có tính phân phối đối với phép cộng",
  },
  {
    word: "phần phụ",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận sinh dục trong của người phụ nữ, gồm hai buồng trứng, hai ống dẫn trứng: viêm phần phụ",
    example: "viêm phần phụ",
  },
  {
    word: "phần phật",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng như tiếng của mảnh vải bay quật vào không khí trước làn gió mạnh: cờ bay phần phật trong gió",
    example: "cờ bay phần phật trong gió",
  },
  {
    word: "phân quyền",
    part_of_speech: "động từ",
    meaning:
      "phân chia quyền hành; phân biệt với tập quyền: chế độ phong kiến phân quyền",
    example: "chế độ phong kiến phân quyền",
  },
  {
    word: "phân nửa",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) một nửa: chai rượu chỉ còn phân nửa",
    example: "chai rượu chỉ còn phân nửa",
  },
  {
    word: "phấn son",
    part_of_speech: "danh từ",
    meaning:
      "đồ trang điểm của phụ nữ, như phấn xoa mặt, son bôi môi (nói khái quát): phấn son loè loẹt",
    example: "phấn son loè loẹt",
  },
  {
    word: "phấn rôm",
    part_of_speech: "danh từ",
    meaning:
      "bột tan màu trắng, thơm, có trộn chất sát trùng, dùng xoa ngoài da để bảo vệ da, chống rôm sảy: xoa phấn rôm cho bé để chống hăm",
    example: "xoa phấn rôm cho bé để chống hăm",
  },
  {
    word: "phấn sáp",
    part_of_speech: "danh từ",
    meaning: "(cũ) phấn son: mặt trát đầy phấn sáp",
    example: "mặt trát đầy phấn sáp",
  },
  {
    word: "phận sự",
    part_of_speech: "danh từ",
    meaning:
      "phần việc phải làm, thuộc trách nhiệm của một người: làm đúng phận sự của mình * không phận sự miễn vào",
    example: "làm đúng phận sự của mình * không phận sự miễn vào",
  },
  {
    word: "phân tán",
    part_of_speech: "động từ",
    meaning:
      "chia nhỏ và phân ra nhiều hướng, nhiều nơi khác nhau: phân tán lực lượng * phân tán tài sản",
    example: "phân tán lực lượng * phân tán tài sản",
  },
  {
    word: "phân tán",
    part_of_speech: "động từ",
    meaning:
      "hướng vào nhiều mục tiêu, nhiều vấn đề khác nhau trong cùng một lúc, không tập trung vào chủ đích: phân tán tư tưởng * sức lực bị phân tán * việc học tập bị phân tán",
    example:
      "phân tán tư tưởng * sức lực bị phân tán * việc học tập bị phân tán",
  },
  {
    word: "phần trăm",
    part_of_speech: "danh từ",
    meaning:
      "phần bằng một đơn vị chia đều cho một trăm (biểu thị bằng kí hiệu %): tính tỉ lệ phần trăm * đúng một trăm phần trăm (đúng hoàn toàn)",
    example: "tính tỉ lệ phần trăm * đúng một trăm phần trăm (đúng hoàn toàn)",
  },
  {
    word: "phân tâm học",
    part_of_speech: "danh từ",
    meaning:
      "khoa học nghiên cứu, phân tích về các hiện tượng tâm lí và cách chữa các chứng bệnh về rối loạn tâm lí: chữa bệnh bằng phân tâm học * Freud được coi là ông tổ của ngành phân tâm học",
    example:
      "chữa bệnh bằng phân tâm học * Freud được coi là ông tổ của ngành phân tâm học",
  },
  {
    word: "phần thưởng",
    part_of_speech: "danh từ",
    meaning:
      "vật tặng để thưởng cho cá nhân hay tổ chức có công lao, thành tích: được nhận phần thưởng * phát phần thưởng cho học sinh giỏi",
    example: "được nhận phần thưởng * phát phần thưởng cho học sinh giỏi",
  },
  {
    word: "phân tách",
    part_of_speech: "động từ",
    meaning:
      "phân ra, tách nhau ra thành những đơn vị riêng rẽ (nói khái quát): quá trình phân tách tế bào",
    example: "quá trình phân tách tế bào",
  },
  {
    word: "phân tích",
    part_of_speech: "động từ",
    meaning:
      "phân chia, thật sự hay bằng tưởng tượng, một đối tượng nhận thức ra thành các yếu tố: phân tích tình hình * phân tích nguyên nhân và kết quả * phân tích một mẫu nước",
    example:
      "phân tích tình hình * phân tích nguyên nhân và kết quả * phân tích một mẫu nước",
  },
  {
    word: "phân thân",
    part_of_speech: "động từ",
    meaning:
      "tự biến ra nhiều thân hình, để có thể đồng thời xuất hiện ở nhiều nơi, theo phép thuật trong truyện cổ: dùng phép phân thân",
    example: "dùng phép phân thân",
  },
  {
    word: "phân thân",
    part_of_speech: "động từ",
    meaning:
      "tách khỏi bản thân, đặt mình vào vị trí của người nào đó hay của nhân vật nghệ thuật để hoà đồng, thông cảm với người ấy hoặc với nhân vật: người diễn viên đang phân thân vào nhân vật của mình",
    example: "người diễn viên đang phân thân vào nhân vật của mình",
  },
  {
    word: "phần tử",
    part_of_speech: "danh từ",
    meaning:
      "vật, đối tượng riêng lẻ, với tư cách là bộ phận hợp thành, cấu thành của một tổng thể nào đó: những phần tử của một tập hợp",
    example: "những phần tử của một tập hợp",
  },
  {
    word: "phần tử",
    part_of_speech: "danh từ",
    meaning:
      "cá nhân, với tư cách là thành viên của một tổ chức, một tập thể, nói về mặt có tính chất nào đó (thường là xấu): phần tử lạc hậu * các phần tử chống đối cách mạng",
    example: "phần tử lạc hậu * các phần tử chống đối cách mạng",
  },
  {
    word: "phẫn uất",
    part_of_speech: "động từ",
    meaning: "căm giận và uất ức đến cao độ: bị chèn ép đến phẫn uất",
    example: "bị chèn ép đến phẫn uất",
  },
  {
    word: "phân ưu",
    part_of_speech: "động từ",
    meaning:
      "(Trang trọng) chia buồn với gia đình có tang: gửi lời phân ưu cùng tang quyến",
    example: "gửi lời phân ưu cùng tang quyến",
  },
  {
    word: "phân trần",
    part_of_speech: "động từ",
    meaning:
      "bày tỏ cặn kẽ để mong người khác hiểu và thông cảm với mình mà không nghĩ xấu về mình trong sự việc nào đó: phân trần về hành vi sơ ý của mình * giọng nói như phân trần",
    example: "phân trần về hành vi sơ ý của mình * giọng nói như phân trần",
  },
  {
    word: "phân vân",
    part_of_speech: "động từ",
    meaning:
      "ở trong trạng thái đang phải nghĩ ngợi, chưa biết nên quyết định như thế nào cho phải: phân vân không biết nên đi hay ở * phân vân lo nghĩ",
    example: "phân vân không biết nên đi hay ở * phân vân lo nghĩ",
  },
  {
    word: "phân viện",
    part_of_speech: "danh từ",
    meaning:
      "chi nhánh của một viện nghiên cứu khoa học: phân viện Chính trị Quốc gia Hồ Chí Minh",
    example: "phân viện Chính trị Quốc gia Hồ Chí Minh",
  },
  {
    word: "phân vi sinh",
    part_of_speech: "danh từ",
    meaning:
      "phân bón có thành phần cơ bản là vi sinh vật: sản xuất phân vi sinh",
    example: "sản xuất phân vi sinh",
  },
  {
    word: "phân xét",
    part_of_speech: "động từ",
    meaning:
      "phân rõ mọi việc để xét xử cho hợp lí: mọi việc sẽ được phân xét tại toà án",
    example: "mọi việc sẽ được phân xét tại toà án",
  },
  {
    word: "phân xã",
    part_of_speech: "danh từ",
    meaning: "chi nhánh của một hãng thông tấn: phân xã Việt Nam tại Nga",
    example: "phân xã Việt Nam tại Nga",
  },
  {
    word: "phân xử",
    part_of_speech: "động từ",
    meaning:
      "phân rõ phải trái, đúng sai để giải quyết một vụ xích mích hay tranh chấp: phân xử đúng sai * đứng ra phân xử",
    example: "phân xử đúng sai * đứng ra phân xử",
  },
  {
    word: "phân xưởng",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị tổ chức của xí nghiệp, nhà máy, thực hiện một phần việc hoàn chỉnh nào đó của quá trình sản xuất: phân xưởng cơ khí * phân xưởng may",
    example: "phân xưởng cơ khí * phân xưởng may",
  },
  {
    word: "phập",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng vật sắc hoặc nhọn cắm mạnh và sâu vào vật mềm: lưỡi dao cắm phập vào thân cây",
    example: "lưỡi dao cắm phập vào thân cây",
  },
  {
    word: "phập phều",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) phồng lên rồi lại xẹp xuống tuỳ theo một tác động bên ngoài nào đó: củi rác phập phều trên mặt nước",
    example: "củi rác phập phều trên mặt nước",
  },
  {
    word: "phập phồng",
    part_of_speech: "động từ",
    meaning:
      'phồng lên, xẹp xuống một cách liên tiếp: hai cánh mũi phập phồng * "Trời mưa bong bóng phập phồng, Mẹ đi lấy chồng con ở với ai." (Cdao)',
    example:
      'hai cánh mũi phập phồng * "Trời mưa bong bóng phập phồng, Mẹ đi lấy chồng con ở với ai." (Cdao)',
  },
  {
    word: "phập phù",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ở tình trạng khi có khi không, không thường xuyên, không ổn định: điện đóm phập phù * lương lậu phập phù",
    example: "điện đóm phập phù * lương lậu phập phù",
  },
  {
    word: "phấp phỏng",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái không yên lòng vì đang có điều phải lo lắng, chờ đợi: phấp phỏng chờ kết quả thi * phấp phỏng mừng thầm",
    example: "phấp phỏng chờ kết quả thi * phấp phỏng mừng thầm",
  },
  {
    word: "phấp phới",
    part_of_speech: "động từ",
    meaning:
      "(vật hình tấm mỏng) bay lật qua lật lại trước gió một cách nhẹ nhàng: cờ bay phấp phới * tà áo dài phấp phới",
    example: "cờ bay phấp phới * tà áo dài phấp phới",
  },
  {
    word: "phất",
    part_of_speech: "động từ",
    meaning:
      "đưa cao lên và làm cho chuyển động qua lại: phất cờ làm hiệu * cờ đến tay ai người ấy phất (tng)",
    example: "phất cờ làm hiệu * cờ đến tay ai người ấy phất (tng)",
  },
  {
    word: "phất",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) phát tài nhanh chóng (thường với hàm ý không coi trọng): phất lên nhờ giá đất tăng vọt",
    example: "phất lên nhờ giá đất tăng vọt",
  },
  {
    word: "phật đản",
    part_of_speech: "danh từ",
    meaning:
      "ngày sinh của Phật Thích Ca Mâu Ni (8 tháng tư âm lịch): lễ Phật Đản",
    example: "lễ Phật Đản",
  },
  {
    word: "phật lòng",
    part_of_speech: "động từ",
    meaning:
      "bực mình, không vừa lòng: câu nói vô tình làm hắn phật lòng * cố gắng để không làm phật lòng khách",
    example:
      "câu nói vô tình làm hắn phật lòng * cố gắng để không làm phật lòng khách",
  },
  {
    word: "phất phơ",
    part_of_speech: "động từ",
    meaning:
      '(vật mỏng, nhẹ) chuyển động qua lại nhẹ nhàng theo làn gió: mái tóc phất phơ * "Thân em như tấm lụa đào, Phất phơ giữa chợ biết vào tay ai?" (ca dao)',
    example:
      'mái tóc phất phơ * "Thân em như tấm lụa đào, Phất phơ giữa chợ biết vào tay ai?" (ca dao)',
  },
  {
    word: "phất phơ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (lang thang) hết chỗ này đến chỗ khác, không rõ mục đích: đi phất phơ ngoài đường",
    example: "đi phất phơ ngoài đường",
  },
  {
    word: "phất phơ",
    part_of_speech: "tính từ",
    meaning: "hời hợt, không nghiêm túc: làm ăn phất phơ",
    example: "làm ăn phất phơ",
  },
  {
    word: "phất phới",
    part_of_speech: "động từ",
    meaning: "(hiếm) như phấp phới: cờ bay phất phới",
    example: "cờ bay phất phới",
  },
  {
    word: "phật ý",
    part_of_speech: "động từ",
    meaning:
      "không vui vì không được vừa ý: phật ý vì thái độ lạnh lùng của bạn * lời nhận xét làm ông ta hơi phật ý",
    example:
      "phật ý vì thái độ lạnh lùng của bạn * lời nhận xét làm ông ta hơi phật ý",
  },
  {
    word: "phây",
    part_of_speech: "tính từ",
    meaning: "(người) béo tốt, hồng hào: người cứ phây ra",
    example: "người cứ phây ra",
  },
  {
    word: "phẩy",
    part_of_speech: "danh từ",
    meaning:
      "dấu ',' dùng để làm dấu câu, chỉ một quãng ngắt tương đối ngắn, phân ranh giới giữa một số thành phần trong nội bộ câu: khi đọc, phải ngắt đoạn ở dấu phẩy",
    example: "khi đọc, phải ngắt đoạn ở dấu phẩy",
  },
  {
    word: "phẩy",
    part_of_speech: "danh từ",
    meaning:
      "dấu ',' dùng làm dấu đặt trước số lẻ trong số thập phân: một phẩy năm (1,5)",
    example: "một phẩy năm (1,5)",
  },
  {
    word: "phẩy",
    part_of_speech: "danh từ",
    meaning:
      "dấu ( Â ) đặt ở trên và bên phải một chữ dùng làm kí hiệu toán học để phân biệt nó với kí hiệu không có dấu: vẽ một đường thẳng đi qua A và A'",
    example: "vẽ một đường thẳng đi qua A và A'",
  },
  {
    word: "phẩy",
    part_of_speech: "động từ",
    meaning:
      "tạo ra dấu phẩy khi viết: sau mỗi tên người được liệt kê phải phẩy",
    example: "sau mỗi tên người được liệt kê phải phẩy",
  },
  {
    word: "phẩy",
    part_of_speech: "động từ",
    meaning:
      "cầm một vật mỏng, nhẹ đưa qua đưa lại để tạo ra gió hoặc để làm bay bụi trên bề mặt: cầm quạt phẩy nhè nhẹ * phẩy bụi trên giường",
    example: "cầm quạt phẩy nhè nhẹ * phẩy bụi trên giường",
  },
  {
    word: "phẫu",
    part_of_speech: "",
    meaning: "(khẩu ngữ) phẫu thuật (nói tắt): trạm phẫu tiền phương",
    example: "trạm phẫu tiền phương",
  },
  {
    word: "phây phây",
    part_of_speech: "tính từ",
    meaning:
      "như phây (nhưng ý mức độ nhiều hơn; thường nói về người phụ nữ đã đứng tuổi): béo tốt phây phây",
    example: "béo tốt phây phây",
  },
  {
    word: "phẫu thuật",
    part_of_speech: "động từ",
    meaning: "mổ để chữa bệnh: phẫu thuật tim * ca phẫu thuật",
    example: "phẫu thuật tim * ca phẫu thuật",
  },
  {
    word: "phè",
    part_of_speech: "phụ từ",
    meaning:
      "(Khẩu ngữ) quá mức, gây cảm giác khó chịu: đầy phè * chán phè * nói ngang phè phè",
    example: "đầy phè * chán phè * nói ngang phè phè",
  },
  {
    word: "phẩy tay",
    part_of_speech: "động từ",
    meaning:
      "đưa nhẹ bàn tay trong không khí để biểu lộ một ý muốn, một thái độ nào đó: phẩy tay ra hiệu * phẩy tay từ chối",
    example: "phẩy tay ra hiệu * phẩy tay từ chối",
  },
  {
    word: "phây phẩy",
    part_of_speech: "động từ",
    meaning: "(gió) thổi qua nhè nhẹ, gây cảm giác dễ chịu: gió nồm phây phẩy",
    example: "gió nồm phây phẩy",
  },
  {
    word: "phe cánh",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp người hoặc tổ chức câu kết với nhau vì những quyền lợi không chính đáng (nói khái quát): các phe cánh đấu đá nhau",
    example: "các phe cánh đấu đá nhau",
  },
  {
    word: "phe phái",
    part_of_speech: "danh từ",
    meaning:
      "phe (nói khái quát): các phe phái đối lập * trong tổ chức đã hình thành phe phái",
    example: "các phe phái đối lập * trong tổ chức đã hình thành phe phái",
  },
  {
    word: "phe",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp người hoặc tổ chức cùng đứng về một phía với nhau, hoạt động đối lập với những người hoặc tổ chức đứng về một phía khác: phe bảo thủ * chia làm hai phe",
    example: "phe bảo thủ * chia làm hai phe",
  },
  {
    word: "phe",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) làm việc mua đi bán lại bất cứ hàng hoá gì để kiếm lãi (hàm ý coi thường): đi phe * dân phe vé",
    example: "đi phe * dân phe vé",
  },
  {
    word: "phè phỡn",
    part_of_speech: "tính từ",
    meaning:
      "(lối sống ăn uống, chơi bời) thoả thuê một cách phung phí, phóng túng, chỉ để hưởng lạc: ăn uống phè phỡn * rủ nhau đi phè phỡn",
    example: "ăn uống phè phỡn * rủ nhau đi phè phỡn",
  },
  {
    word: "phe phẩy",
    part_of_speech: "động từ",
    meaning:
      "đưa qua đưa lại vật mỏng, nhẹ một cách nhẹ nhàng (nói khái quát): cầm chiếc quạt phe phẩy * con ngựa phe phẩy đuôi",
    example: "cầm chiếc quạt phe phẩy * con ngựa phe phẩy đuôi",
  },
  {
    word: "phe phẩy",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) như phe (nói khái quát; hàm ý coi thường): dân phe phẩy",
    example: "dân phe phẩy",
  },
  {
    word: "phè phè",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng phát ra nghe như bị chặn lại, do luồng hơi bật phun mạnh từ miệng hoặc khe hẹp ra ngoài: thở phè phè * miệng phun nước phè phè",
    example: "thở phè phè * miệng phun nước phè phè",
  },
  {
    word: "phèn",
    part_of_speech: "danh từ",
    meaning: "tên gọi chung các loại muối kép gồm hai muối sulfat.",
    example: "nước đã đánh phèn",
  },
  {
    word: "phèo",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) ruột non: phèo lợn * đâm cho lòi phèo",
    example: "phèo lợn * đâm cho lòi phèo",
  },
  {
    word: "phèo",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ, hiếm) như sùi: phèo bọt mép",
    example: "phèo bọt mép",
  },
  {
    word: "phen",
    part_of_speech: "danh từ",
    meaning:
      '(khẩu ngữ) lần xảy ra sự việc (thường là quan trọng, đáng chú ý): bị một phen hú vía * "Vợ chàng quỷ quái, tinh ma, Phen này kẻ cắp, bà già gặp nhau!" (TKiều)',
    example:
      'bị một phen hú vía * "Vợ chàng quỷ quái, tinh ma, Phen này kẻ cắp, bà già gặp nhau!" (TKiều)',
  },
  {
    word: "phéng",
    part_of_speech: "phụ từ",
    meaning: "(thông tục) như béng: quên phéng đi mất",
    example: "quên phéng đi mất",
  },
  {
    word: "phép",
    part_of_speech: "danh từ",
    meaning:
      "những quy định chính thức có tính chất bắt buộc phải tuân theo để bảo đảm trật tự, kỉ cương trong xã hội, trong gia đình: giữ nghiêm phép nước * phép vua thua lệ làng (tng)",
    example: "giữ nghiêm phép nước * phép vua thua lệ làng (tng)",
  },
  {
    word: "phép",
    part_of_speech: "danh từ",
    meaning:
      "những cách thức đối xử được coi là phải, là phù hợp với đạo lí: trả lời cho phải phép * giữ phép lịch sự",
    example: "trả lời cho phải phép * giữ phép lịch sự",
  },
  {
    word: "phép",
    part_of_speech: "danh từ",
    meaning:
      "những nguyên tắc và phương pháp cần theo trong một lĩnh vực hoạt động nào đó: phép dùng binh",
    example: "phép dùng binh",
  },
  {
    word: "phép",
    part_of_speech: "danh từ",
    meaning:
      "sự đồng ý cho làm việc gì đó của cấp trên, người trên: được phép * viết giấy xin phép nghỉ học * cấp phép xây nhà",
    example: "được phép * viết giấy xin phép nghỉ học * cấp phép xây nhà",
  },
  {
    word: "phép",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) nghỉ phép (nói tắt): một năm được mười ngày phép * đi phép",
    example: "một năm được mười ngày phép * đi phép",
  },
  {
    word: "phép",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) phép toán (nói tắt): phép chia * phép tịnh tiến",
    example: "phép chia * phép tịnh tiến",
  },
  {
    word: "phép",
    part_of_speech: "danh từ",
    meaning:
      "khả năng huyền bí tạo nên những điều kì lạ: hoá phép * có phép lạ",
    example: "hoá phép * có phép lạ",
  },
  {
    word: "phèn phẹt",
    part_of_speech: "tính từ",
    meaning:
      "(mặt) to bè ra, trông xấu: mặt to phèn phẹt * phèn phẹt như mẹt bánh đúc",
    example: "mặt to phèn phẹt * phèn phẹt như mẹt bánh đúc",
  },
  {
    word: "phép tắc",
    part_of_speech: "danh từ",
    meaning:
      "quy tắc, lề lối phải tuân theo (nói khái quát): làm trái phép tắc * giữ đúng phép tắc, lễ nghĩa",
    example: "làm trái phép tắc * giữ đúng phép tắc, lễ nghĩa",
  },
  {
    word: "phép tính",
    part_of_speech: "danh từ",
    meaning:
      "quá trình toán học đi từ một hay nhiều số hoặc biểu thức chữ thay cho số suy ra những số khác, theo một quy tắc nào đó: các phép tính cộng, trừ, nhân, chia * thực hiện một phép tính",
    example: "các phép tính cộng, trừ, nhân, chia * thực hiện một phép tính",
  },
  {
    word: "phép tính",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi chung một số bộ môn toán học lí thuyết: phép tính vi phân",
    example: "phép tính vi phân",
  },
  {
    word: "phê",
    part_of_speech: "động từ",
    meaning:
      "ghi ý kiến nhận xét, đánh giá: phê vào sổ liên lạc * lời phê của cô giáo",
    example: "phê vào sổ liên lạc * lời phê của cô giáo",
  },
  {
    word: "phê",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) phê bình (nói tắt): phải có tinh thần phê và tự phê",
    example: "phải có tinh thần phê và tự phê",
  },
  {
    word: "phê",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) say rượu, say ma tuý: con nghiện đang phê thuốc",
    example: "con nghiện đang phê thuốc",
  },
  {
    word: "phê",
    part_of_speech: "tính từ",
    meaning: "(thông tục) rất khoái, rất sướng: giọng ca nghe rất phê",
    example: "giọng ca nghe rất phê",
  },
  {
    word: "phét",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) phóng đại hoặc bịa đặt để đùa vui hoặc khoe khoang: chỉ phét là tài! * thôi, đừng có phét nữa cha nội!",
    example: "chỉ phét là tài! * thôi, đừng có phét nữa cha nội!",
  },
  {
    word: "phép thuật",
    part_of_speech: "danh từ",
    meaning:
      "phép có thể sai khiến được những lực lượng siêu nhiên, quỷ thần, theo mê tín (nói khái quát): không tin vào yêu ma, phép thuật * có phép thuật",
    example: "không tin vào yêu ma, phép thuật * có phép thuật",
  },
  {
    word: "phế",
    part_of_speech: "danh từ",
    meaning: "phổi, theo cách gọi trong đông y: thuốc bổ phế",
    example: "thuốc bổ phế",
  },
  {
    word: "phế",
    part_of_speech: "động từ",
    meaning:
      "bỏ, không dùng đến nữa: thương binh tàn nhưng không phế * trù tính việc phế vua",
    example: "thương binh tàn nhưng không phế * trù tính việc phế vua",
  },
  {
    word: "phệ",
    part_of_speech: "tính từ",
    meaning: "béo đến mức bụng chảy xệ xuống: béo phệ * bụng phệ",
    example: "béo phệ * bụng phệ",
  },
  {
    word: "phê bình",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) xem xét, phân tích, đánh giá ưu điểm và khuyết điểm: phê bình và tự phê bình để rút kinh nghiệm",
    example: "phê bình và tự phê bình để rút kinh nghiệm",
  },
  {
    word: "phê bình",
    part_of_speech: "động từ",
    meaning:
      "chỉ ra một cách cụ thể những khuyết điểm, thiếu sót của ai đó để góp ý kiến, để chê trách: phê bình thẳng thắn * tiếp thu ý kiến phê bình",
    example: "phê bình thẳng thắn * tiếp thu ý kiến phê bình",
  },
  {
    word: "phê bình",
    part_of_speech: "động từ",
    meaning:
      "phân tích, nhận xét và đánh giá một tác phẩm văn học nghệ thuật: một cây bút phê bình sắc sảo * nhà phê bình",
    example: "một cây bút phê bình sắc sảo * nhà phê bình",
  },
  {
    word: "phế bỏ",
    part_of_speech: "động từ",
    meaning: "phế đi, bỏ đi (nói khái quát): phế bỏ chế độ quân chủ",
    example: "phế bỏ chế độ quân chủ",
  },
  {
    word: "phê duyệt",
    part_of_speech: "động từ",
    meaning:
      "(người, cấp có thẩm quyền) xem xét và đồng ý thông qua những văn bản, dự thảo, v.v. do cấp dưới trình lên: dự án đã được Bộ Kế hoạch và Đầu tư phê duyệt",
    example: "dự án đã được Bộ Kế hoạch và Đầu tư phê duyệt",
  },
  {
    word: "phế liệu",
    part_of_speech: "danh từ",
    meaning:
      "vật bỏ đi từ những nguyên liệu đã qua chế biến: thu gom phế liệu * kinh doanh mặt hàng phế liệu",
    example: "thu gom phế liệu * kinh doanh mặt hàng phế liệu",
  },
  {
    word: "phê chuẩn",
    part_of_speech: "động từ",
    meaning:
      "(người, cấp có thẩm quyền) xét duyệt và đồng ý cho thi hành: chủ tịch nước đã kí quyết định phê chuẩn dự thảo luật sửa đổi",
    example: "chủ tịch nước đã kí quyết định phê chuẩn dự thảo luật sửa đổi",
  },
  {
    word: "phế đế",
    part_of_speech: "danh từ",
    meaning: "(cũ) vua đã bị truất ngôi: phế đế Bảo Đại",
    example: "phế đế Bảo Đại",
  },
  {
    word: "phét lác",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) nói phét (nói khái quát): chỉ giỏi phét lác! * anh này cũng phét lác gớm nhỉ!",
    example: "chỉ giỏi phét lác! * anh này cũng phét lác gớm nhỉ!",
  },
  {
    word: "phế nhân",
    part_of_speech: "danh từ",
    meaning: "(cũ) người tàn tật, không còn khả năng lao động: kẻ phế nhân",
    example: "kẻ phế nhân",
  },
  {
    word: "phế phẩm",
    part_of_speech: "danh từ",
    meaning:
      "sản phẩm hỏng, thường bị loại bỏ vì không đúng quy cách, phẩm chất đã quy định: loại bỏ phế phẩm * hàng phế phẩm",
    example: "loại bỏ phế phẩm * hàng phế phẩm",
  },
  {
    word: "phề phệ",
    part_of_speech: "tính từ",
    meaning: "hơi phệ: cái bụng có vẻ hơi phề phệ",
    example: "cái bụng có vẻ hơi phề phệ",
  },
  {
    word: "phế quản",
    part_of_speech: "danh từ",
    meaning:
      "cơ quan có dạng hình ống (cuống phổi), dẫn không khí từ khí quản vào phổi: viêm phế quản",
    example: "viêm phế quản",
  },
  {
    word: "phê phán",
    part_of_speech: "động từ",
    meaning:
      "vạch ra, chỉ ra cái sai trái để tỏ thái độ không đồng tình hoặc lên án: giọng thơ phê phán, đả kích * phê phán thái độ bàng quan, vô trách nhiệm",
    example:
      "giọng thơ phê phán, đả kích * phê phán thái độ bàng quan, vô trách nhiệm",
  },
  {
    word: "phế tích",
    part_of_speech: "danh từ",
    meaning:
      "di tích bị bỏ hoang, đã đổ nát, hư hỏng do không được bảo quản, chăm sóc: ngôi chùa cổ giờ chỉ còn là một phế tích",
    example: "ngôi chùa cổ giờ chỉ còn là một phế tích",
  },
  {
    word: "phếch",
    part_of_speech: "phụ từ",
    meaning:
      "đến mức độ như chẳng còn màu sắc gì rõ ràng nữa cả do bị phai hẳn đi, ngả sang màu trắng đục không đều: cái áo màu nhạt phếch * mặt bạc phếch",
    example: "cái áo màu nhạt phếch * mặt bạc phếch",
  },
  {
    word: "phế truất",
    part_of_speech: "động từ",
    meaning:
      "truất bỏ, không tiếp tục cho giữ chức vụ, địa vị nào đó: vị vua bị phế truất",
    example: "vị vua bị phế truất",
  },
  {
    word: "phế thải",
    part_of_speech: "",
    meaning:
      "(vật qua quá trình sản xuất, sinh hoạt, v.v.) bị loại bỏ do kém phẩm chất, hoặc do không còn cần dùng đến nữa: thu gom đồ phế thải * xử lí các chất phế thải",
    example: "thu gom đồ phế thải * xử lí các chất phế thải",
  },
  {
    word: "phên",
    part_of_speech: "danh từ",
    meaning:
      "tấm đan bằng tre nứa, dùng để ngăn, chắn hoặc che đậy: tấm phên nứa * đan phên",
    example: "tấm phên nứa * đan phên",
  },
  {
    word: "phễu",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng có một miệng loe rộng, dùng để rót chất lỏng vào vật đựng có miệng nhỏ: phễu nhựa * phễu rót dầu",
    example: "phễu nhựa * phễu rót dầu",
  },
  {
    word: "phệnh",
    part_of_speech: "danh từ",
    meaning: "ông phệnh (nói tắt): ngồi như phệnh",
    example: "ngồi như phệnh",
  },
  {
    word: "phềnh",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái phình to, trương to lên: nổi phềnh trên mặt nước * bụng ăn căng phềnh",
    example: "nổi phềnh trên mặt nước * bụng ăn căng phềnh",
  },
  {
    word: "phều",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ, hiếm) như sùi: nói phều cả bọt mép",
    example: "nói phều cả bọt mép",
  },
  {
    word: "phết",
    part_of_speech: "động từ",
    meaning: "bôi thành lớp trên khắp bề mặt: phết hồ * bánh mì phết bơ",
    example: "phết hồ * bánh mì phết bơ",
  },
  {
    word: "phết",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đánh bằng roi hay bằng một vật nào đó rộng bản: phết cho mấy roi",
    example: "phết cho mấy roi",
  },
  {
    word: "phều phào",
    part_of_speech: "tính từ",
    meaning:
      "(giọng nói) yếu ớt, đứt đoạn và bị lẫn trong hơi thở, nghe không rõ: giọng nói phều phào * móm phều phào",
    example: "giọng nói phều phào * móm phều phào",
  },
  {
    word: "phí",
    part_of_speech: "động từ",
    meaning:
      "để mất đi một cách vô ích do đã dùng không có hiệu quả, dùng quá mức cần thiết hoặc đã bỏ không dùng đến: phí tiền mà mua cái của ấy * nói với nó chỉ phí lời * phí thì giờ vào những việc vô ích",
    example:
      "phí tiền mà mua cái của ấy * nói với nó chỉ phí lời * phí thì giờ vào những việc vô ích",
  },
  {
    word: "phí",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) khoản tiền phải trả cho một công việc phục vụ, dịch vụ công cộng nào đó: thanh toán viện phí * thu phí cầu đường",
    example: "thanh toán viện phí * thu phí cầu đường",
  },
  {
    word: "phi",
    part_of_speech: "danh từ",
    meaning: "tên một con chữ (f, j, viết hoa F) của chữ cái Hi Lạp.",
    example: "thép phi 10",
  },
  {
    word: "phi",
    part_of_speech: "động từ",
    meaning:
      "(ngựa) chạy rất nhanh, bốn vó tung lên khỏi mặt đất: phi nước đại * ngựa phi như bay",
    example: "phi nước đại * ngựa phi như bay",
  },
  {
    word: "phi",
    part_of_speech: "động từ",
    meaning:
      "dùng tay phóng rất mạnh binh khí có mũi nhọn vào một mục tiêu nào đó: phi ngọn lao * phi con dao vào thân cây",
    example: "phi ngọn lao * phi con dao vào thân cây",
  },
  {
    word: "phi",
    part_of_speech: "động từ",
    meaning: "rán hành, tỏi cho dậy mùi thơm: phi hành * phi tỏi cho thơm",
    example: "phi hành * phi tỏi cho thơm",
  },
  {
    word: "phi",
    part_of_speech: "động từ",
    meaning: "rang cho tan thành bột: phi phèn chua",
    example: "phi phèn chua",
  },
  {
    word: "phi",
    part_of_speech: "kết từ",
    meaning:
      "(Ít dùng) từ dùng để nêu một giả thiết phủ định, rồi nói rõ cái gì sẽ xảy ra với giả thiết ấy, nhằm nhấn mạnh một điều gì đó; nếu không phải là: việc này, phi ông ấy thì không xong",
    example: "việc này, phi ông ấy thì không xong",
  },
  {
    word: "phì",
    part_of_speech: "động từ",
    meaning:
      'bật mạnh hơi từ trong ra: nồi áp suất phì hơi * "Nỗi khinh bỉ của anh phì cả ra ngoài, theo cái bĩu môi dài thườn thượt." (NCao; 8)',
    example:
      'nồi áp suất phì hơi * "Nỗi khinh bỉ của anh phì cả ra ngoài, theo cái bĩu môi dài thườn thượt." (NCao; 8)',
  },
  {
    word: "phì",
    part_of_speech: "tính từ",
    meaning:
      "béo một cách không bình thường, không phải là biểu hiện của sự khoẻ mạnh: phát phì * béo phì",
    example: "phát phì * béo phì",
  },
  {
    word: "phi chính phủ",
    part_of_speech: "tính từ",
    meaning:
      "không phải, không thuộc chính phủ, nhà nước: tổ chức phi chính phủ",
    example: "tổ chức phi chính phủ",
  },
  {
    word: "phị",
    part_of_speech: "tính từ",
    meaning: "béo đến mức chảy xệ xuống: người béo phị * hai má phị ra",
    example: "người béo phị * hai má phị ra",
  },
  {
    word: "phỉ",
    part_of_speech: "danh từ",
    meaning:
      "giặc cướp thường hoạt động ở miền rừng núi: toán phỉ * tiễu phỉ trừ gian",
    example: "toán phỉ * tiễu phỉ trừ gian",
  },
  {
    word: "phỉ",
    part_of_speech: "động từ",
    meaning:
      '(cũ, văn chương) được thoả mãn nhu cầu thuộc về tinh thần: phỉ chí tang bồng * "Trai anh hùng, gái thuyền quyên, Phỉ nguyền sánh phượng, đẹp duyên cưỡi rồng." (TKiều)',
    example:
      'phỉ chí tang bồng * "Trai anh hùng, gái thuyền quyên, Phỉ nguyền sánh phượng, đẹp duyên cưỡi rồng." (TKiều)',
  },
  {
    word: "phỉ báng",
    part_of_speech: "động từ",
    meaning:
      "chê bai, nói xấu, tỏ ý coi khinh cái hoặc người nào đó thường phải được coi trọng: giọng phỉ báng",
    example: "giọng phỉ báng",
  },
  {
    word: "phì cười",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bật ra tiếng cười vì không nén nhịn được: đang tức mà nghe hắn nói cũng phải phì cười",
    example: "đang tức mà nghe hắn nói cũng phải phì cười",
  },
  {
    word: "phi dê",
    part_of_speech: "động từ",
    meaning: "(cũ) uốn tóc cho quăn: đầu phi dê",
    example: "đầu phi dê",
  },
  {
    word: "phi hành",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) đi trên máy bay hoặc tàu vũ trụ với tư cách là thành viên trong phi đoàn, tham gia lái, điều khiển: nhân viên phi hành * tổ phi hành",
    example: "nhân viên phi hành * tổ phi hành",
  },
  {
    word: "phi hành",
    part_of_speech: "động từ",
    meaning:
      "(cũ) đi nhanh như bay (thường có trong các truyện kiếm hiệp): thuật phi hành",
    example: "thuật phi hành",
  },
  {
    word: "phi đao",
    part_of_speech: "danh từ",
    meaning:
      "dao nhọn và sắc, dùng để ném, phóng (một loại khí giới thời xưa): ngọn phi đao",
    example: "ngọn phi đao",
  },
  {
    word: "phi lê",
    part_of_speech: "",
    meaning:
      "(miếng thịt hoặc cá) đã được lọc bỏ xương và cắt thành miếng hoàn chỉnh: cá phi lê * phi lê thịt",
    example: "cá phi lê * phi lê thịt",
  },
  {
    word: "phí hoài",
    part_of_speech: "động từ",
    meaning:
      "để mất đi, qua đi một cách đáng tiếc: phí hoài tuổi xuân * phí hoài công sức",
    example: "phí hoài tuổi xuân * phí hoài công sức",
  },
  {
    word: "phi lý",
    part_of_speech: "tính từ",
    meaning:
      "trái với, không hợp với lẽ phải thông thường: đưa ra những quyết định phi lí * làm những việc phi lí",
    example: "đưa ra những quyết định phi lí * làm những việc phi lí",
  },
  {
    word: "phi đội",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị chiến thuật cơ bản của không quân, gồm một số biên đội: một phi đội bắt đầu xuất kích",
    example: "một phi đội bắt đầu xuất kích",
  },
  {
    word: "phi lí",
    part_of_speech: "tính từ",
    meaning:
      "trái với, không hợp với lẽ phải thông thường: đưa ra những quyết định phi lí * làm những việc phi lí",
    example: "đưa ra những quyết định phi lí * làm những việc phi lí",
  },
  {
    word: "phì nhiêu",
    part_of_speech: "tính từ",
    meaning:
      "(đất đai) màu mỡ, thuận lợi cho việc trồng trọt: đất đai phì nhiêu",
    example: "đất đai phì nhiêu",
  },
  {
    word: "phi mã",
    part_of_speech: "",
    meaning:
      "tốc độ tăng nhanh đến mức không kiểm soát nổi, ví như ngựa phóng nước đại: giá cả tăng phi mã * tốc độ phát triển cấp phi mã",
    example: "giá cả tăng phi mã * tốc độ phát triển cấp phi mã",
  },
  {
    word: "phi ngựa",
    part_of_speech: "động từ",
    meaning: "cưỡi ngựa và cho ngựa phi thật nhanh: phi ngựa vội vã",
    example: "phi ngựa vội vã",
  },
  {
    word: "phỉ nhổ",
    part_of_speech: "động từ",
    meaning:
      "tỏ thái độ cực kì khinh bỉ (tựa như muốn nhổ vào mặt): bị người đời phỉ nhổ",
    example: "bị người đời phỉ nhổ",
  },
  {
    word: "phi nghĩa",
    part_of_speech: "tính từ",
    meaning:
      "trái với đạo nghĩa, đạo lí: cuộc chiến tranh phi nghĩa * đồng tiền phi nghĩa",
    example: "cuộc chiến tranh phi nghĩa * đồng tiền phi nghĩa",
  },
  {
    word: "phì nộn",
    part_of_speech: "tính từ",
    meaning:
      "béo phì đến mức nhìn thấy phát sợ, gây cảm giác như là biểu hiện của người được ăn uống quá đầy đủ mà ngồi không chẳng làm gì: khuôn mặt phì nộn * béo phì nộn",
    example: "khuôn mặt phì nộn * béo phì nộn",
  },
  {
    word: "phi phàm",
    part_of_speech: "tính từ",
    meaning:
      "không phải bình thường mà vượt hẳn lên, hơn hẳn: có sức khoẻ phi phàm",
    example: "có sức khoẻ phi phàm",
  },
  {
    word: "phì phị",
    part_of_speech: "tính từ",
    meaning: "hơi phị (thường nói về mặt): mặt béo phì phị",
    example: "mặt béo phì phị",
  },
  {
    word: "phi pháp",
    part_of_speech: "tính từ",
    meaning: "(làm điều) trái với pháp luật: làm ăn phi pháp",
    example: "làm ăn phi pháp",
  },
  {
    word: "phì phạch",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng phát ra như tiếng của quạt giấy khi quạt mạnh: quạt phì phạch",
    example: "quạt phì phạch",
  },
  {
    word: "phì phò",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng như tiếng hơi thở mạnh bật ra mệt nhọc, nặng nề, thành từng đợt liên tiếp ra cả đằng miệng: vừa bê vừa thở phì phò",
    example: "vừa bê vừa thở phì phò",
  },
  {
    word: "phì phèo",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) từ gợi tả dáng vẻ hút thuốc lá, hít vào phà ra một cách khoái trá: hút thuốc phì phèo",
    example: "hút thuốc phì phèo",
  },
  {
    word: "phí phạm",
    part_of_speech: "động từ",
    meaning:
      "làm hao tốn quá mức cần thiết, gây lãng phí: phí phạm thời gian và tiền của",
    example: "phí phạm thời gian và tiền của",
  },
  {
    word: "phỉ phui",
    part_of_speech: "cảm từ",
    meaning:
      "(khẩu ngữ) tiếng thốt ra nhằm xoá đi lời coi là nói gở ngay trước đó: phỉ phui, ăn nói đến là nhảm!",
    example: "phỉ phui, ăn nói đến là nhảm!",
  },
  {
    word: "phỉ phong",
    part_of_speech: "tính từ",
    meaning:
      '(cũ, văn chương) thanh bạch, chẳng có gì đáng kể: "Ngần ngừ nàng mới thưa rằng, Thói nhà băng tuyết, chất hằng phỉ phong." (TKiều)',
    example:
      'Ngần ngừ nàng mới thưa rằng, Thói nhà băng tuyết, chất hằng phỉ phong." (TKiều)',
  },
  {
    word: "phi tang",
    part_of_speech: "động từ",
    meaning: "làm cho mất tang chứng: ăn trộm rồi đốt kho để phi tang",
    example: "ăn trộm rồi đốt kho để phi tang",
  },
  {
    word: "phi tiêu",
    part_of_speech: "danh từ",
    meaning:
      "vật hơi dài, có đầu sắc nhọn hình như mũi tên, dùng để ném, phóng (một loại khí giới thời xưa): phóng phi tiêu",
    example: "phóng phi tiêu",
  },
  {
    word: "phi thường",
    part_of_speech: "tính từ",
    meaning:
      "đặc biệt khác thường, vượt xa mức bình thường tới độ đáng khâm phục: một nghị lực phi thường * sức mạnh phi thường",
    example: "một nghị lực phi thường * sức mạnh phi thường",
  },
  {
    word: "phi trường",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) sân bay: máy bay đáp xuống phi trường * phi trường Tân Sơn Nhất",
    example: "máy bay đáp xuống phi trường * phi trường Tân Sơn Nhất",
  },
  {
    word: "phi thuyền",
    part_of_speech: "danh từ",
    meaning: "(hiếm) tàu vũ trụ: phi thuyền con thoi",
    example: "phi thuyền con thoi",
  },
  {
    word: "phí tổn",
    part_of_speech: "danh từ",
    meaning:
      "các khoản chi tiêu cụ thể, cần cho công việc gì (nói khái quát): phí tổn vận chuyển * chịu mọi phí tổn",
    example: "phí tổn vận chuyển * chịu mọi phí tổn",
  },
  {
    word: "phịa",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) bịa: phịa chuyện * chỉ giỏi phịa!",
    example: "phịa chuyện * chỉ giỏi phịa!",
  },
  {
    word: "phiếm",
    part_of_speech: "tính từ",
    meaning:
      "(trò chuyện, chơi đùa) chung chung, không thiết thực, không đâu vào đâu: ngồi chuyện phiếm với nhau * nói phiếm",
    example: "ngồi chuyện phiếm với nhau * nói phiếm",
  },
  {
    word: "phía",
    part_of_speech: "danh từ",
    meaning:
      "khoảng không gian mà khi đứng ở một vị trí nhất định có thể nhìn bao quát được trong một lúc, đối lập với những khoảng không gian không thể nhìn thấy trong lúc đó: phía trước mặt * bị đánh từ phía sau * nhìn về phía chân trời",
    example: "phía trước mặt * bị đánh từ phía sau * nhìn về phía chân trời",
  },
  {
    word: "phía",
    part_of_speech: "danh từ",
    meaning:
      "những người mà đứng trên một quan điểm nhất định có thể gộp chung vào với nhau, dựa trên một số điểm chung nào đó, đối lập với những người khác (nói tổng quát): phía nhà trai * ông ta đứng về phía bảo thủ",
    example: "phía nhà trai * ông ta đứng về phía bảo thủ",
  },
  {
    word: "phi vụ",
    part_of_speech: "danh từ",
    meaning: "(cũ) chuyến bay của máy bay chiến đấu.",
    example: "phi vụ làm ăn * thắng quả đậm trong phi vụ vừa rồi",
  },
  {
    word: "phịch",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng trầm và nặng như tiếng của vật nặng rơi xuống đất: ngồi phịch xuống ghế * vứt phịch cái ba lô xuống đất",
    example: "ngồi phịch xuống ghế * vứt phịch cái ba lô xuống đất",
  },
  {
    word: "phích",
    part_of_speech: "danh từ",
    meaning:
      "bình bằng kim loại hoặc thuỷ tinh tráng thuỷ ngân, có hai lớp vỏ, giữa là khoảng chân không cách nhiệt, dùng để giữ nguyên nhiệt độ của vật chứa đựng trong đó trong nhiều giờ (Nam thường bình thuỷ nếu chứa nước nóng): rót nước sôi vào phích * phích đá",
    example: "rót nước sôi vào phích * phích đá",
  },
  {
    word: "phích",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ để cắm vào ổ cắm nối dòng điện với đồ dùng điện: hỏng mất cái phích cắm",
    example: "hỏng mất cái phích cắm",
  },
  {
    word: "phiếm chỉ",
    part_of_speech: "động từ",
    meaning:
      "chỉ chung, không chỉ cụ thể người nào, sự vật nào: ,  *  là các đại từ phiếm chỉ",
    example: ",  *  là các đại từ phiếm chỉ",
  },
  {
    word: "phiếm luận",
    part_of_speech: "động từ",
    meaning: "(hiếm) bàn luận chung chung, không thiết thực: cuộc phiếm luận",
    example: "cuộc phiếm luận",
  },
  {
    word: "phiên âm",
    part_of_speech: "động từ",
    meaning:
      "ghi lại cách phát âm các từ ngữ của một ngôn ngữ bằng hệ thống kí hiệu riêng hoặc bằng hệ thống chữ cái của một ngôn ngữ khác: bảng phiên âm quốc tế * phiên âm ra tiếng Việt",
    example: "bảng phiên âm quốc tế * phiên âm ra tiếng Việt",
  },
  {
    word: "phiến",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị những vật có bề mặt rộng, bằng phẳng, vuông vắn: một phiến đá lớn * phiến gỗ lim",
    example: "một phiến đá lớn * phiến gỗ lim",
  },
  {
    word: "phiền",
    part_of_speech: "tính từ",
    meaning:
      'có tâm trạng buồn, khó chịu vì phải lo nghĩ nhiều: phiền vì nỗi con hư * "Dỗ dành khuyên giải trăm chiều, Lửa phiền càng dập, càng khêu mối phiền." (TKiều)',
    example:
      'phiền vì nỗi con hư * "Dỗ dành khuyên giải trăm chiều, Lửa phiền càng dập, càng khêu mối phiền." (TKiều)',
  },
  {
    word: "phiền",
    part_of_speech: "tính từ",
    meaning:
      "rầy rà, rắc rối, sinh nhiều chuyện phải bận lòng: đánh mất của người ta thì phiền lắm * phiền quá, lại lỡ hẹn rồi",
    example: "đánh mất của người ta thì phiền lắm * phiền quá, lại lỡ hẹn rồi",
  },
  {
    word: "phiền",
    part_of_speech: "động từ",
    meaning:
      'quấy rầy do nhờ vả điều gì đó (lời yêu cầu lịch sự người khác làm việc gì): phiền anh cho tôi hỏi * "Ước gì quan đắp đường liền, Để ta đi lại khỏi phiền đò giang." (ca dao)',
    example:
      'phiền anh cho tôi hỏi * "Ước gì quan đắp đường liền, Để ta đi lại khỏi phiền đò giang." (ca dao)',
  },
  {
    word: "phiên",
    part_of_speech: "danh từ",
    meaning:
      "lần mà mỗi người, theo thứ tự, làm cùng một loại việc như người trước và sau mình để bảo đảm sự liên tục: phiên trực * phiên gác * thay phiên nhau trực nhật",
    example: "phiên trực * phiên gác * thay phiên nhau trực nhật",
  },
  {
    word: "phiên",
    part_of_speech: "danh từ",
    meaning:
      "lần họp, lần làm việc theo quy định: phiên chợ vùng cao * quốc hội họp phiên bế mạc",
    example: "phiên chợ vùng cao * quốc hội họp phiên bế mạc",
  },
  {
    word: "phiên",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) phiên âm (nói tắt): phiên sang chữ quốc ngữ",
    example: "phiên sang chữ quốc ngữ",
  },
  {
    word: "phiên chuyển",
    part_of_speech: "động từ",
    meaning:
      "phiên âm và chuyển tự (nói gộp): thống nhất cách phiên chuyển từ ngữ tiếng nước ngoài trên báo chí",
    example:
      "thống nhất cách phiên chuyển từ ngữ tiếng nước ngoài trên báo chí",
  },
  {
    word: "phiên bản",
    part_of_speech: "danh từ",
    meaning:
      "bản sao lại từ một bản gốc, thường là của tác phẩm nghệ thuật hoặc tài liệu quý, hiếm: Truyện Kiều có nhiều phiên bản * phiên bản của bức tranh",
    example: "Truyện Kiều có nhiều phiên bản * phiên bản của bức tranh",
  },
  {
    word: "phiên dịch",
    part_of_speech: "động từ",
    meaning:
      "dịch một văn bản hay một lời phát biểu từ một ngôn ngữ hoặc một hệ thống kí hiệu này sang một ngôn ngữ hoặc một hệ thống kí hiệu khác: làm công tác phiên dịch",
    example: "làm công tác phiên dịch",
  },
  {
    word: "phiên dịch",
    part_of_speech: "danh từ",
    meaning:
      "người làm công việc phiên dịch: đào tạo phiên dịch * làm phiên dịch",
    example: "đào tạo phiên dịch * làm phiên dịch",
  },
  {
    word: "phiến diện",
    part_of_speech: "tính từ",
    meaning:
      "chỉ thiên về một mặt, một phía, không thấy đầy đủ các mặt, các khía cạnh khác của vấn đề: phát biểu một cách phiến diện * cái nhìn phiến diện",
    example: "phát biểu một cách phiến diện * cái nhìn phiến diện",
  },
  {
    word: "phiên hiệu",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi kí hiệu bằng con số của các đơn vị lực lượng vũ trang: sư đoàn mang phiên hiệu 304",
    example: "sư đoàn mang phiên hiệu 304",
  },
  {
    word: "phiền hà",
    part_of_speech: "động từ",
    meaning:
      "làm rầy rà, rắc rối, gây khó dễ cho người khác: thủ tục phiền hà * không muốn phiền hà người khác",
    example: "thủ tục phiền hà * không muốn phiền hà người khác",
  },
  {
    word: "phiền hà",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) lấy làm phiền, bực mình, khó chịu: chuyện đó tôi không có phiền hà chi hết!",
    example: "chuyện đó tôi không có phiền hà chi hết!",
  },
  {
    word: "phiền lòng",
    part_of_speech: "",
    meaning:
      "buồn, phải bận tâm, lo nghĩ nhiều về một việc nào đó: con hư làm phiền lòng cha mẹ",
    example: "con hư làm phiền lòng cha mẹ",
  },
  {
    word: "phiến loạn",
    part_of_speech: "động từ",
    meaning:
      "nổi dậy, tiến hành bạo động vũ trang làm rối loạn trật tự xã hội: dẹp tan quân phiến loạn",
    example: "dẹp tan quân phiến loạn",
  },
  {
    word: "phiền não",
    part_of_speech: "",
    meaning: "(cũ) rầu não ruột: trong lòng phiền não * quên hết mọi phiền não",
    example: "trong lòng phiền não * quên hết mọi phiền não",
  },
  {
    word: "phiền luỵ",
    part_of_speech: "động từ",
    meaning:
      "phải gặp rầy rà, khó khăn vì người khác: làm phiền luỵ đến gia đình",
    example: "làm phiền luỵ đến gia đình",
  },
  {
    word: "phiền phức",
    part_of_speech: "tính từ",
    meaning:
      "phức tạp và rắc rối, gây khó khăn: thủ tục phiền phức * gặp chuyện phiền phức",
    example: "thủ tục phiền phức * gặp chuyện phiền phức",
  },
  {
    word: "phiền nhiễu",
    part_of_speech: "động từ",
    meaning:
      "quấy rầy, hết cái này đến cái khác, làm cho rất khó chịu: cố tình gây phiền nhiễu",
    example: "cố tình gây phiền nhiễu",
  },
  {
    word: "phiền muộn",
    part_of_speech: "tính từ",
    meaning:
      "(văn chương) buồn và cảm thấy đau khổ, phải suy nghĩ nhiều: tâm trạng phiền muộn * không có gì phải lo âu, phiền muộn",
    example: "tâm trạng phiền muộn * không có gì phải lo âu, phiền muộn",
  },
  {
    word: "phiên phiến",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (làm việc gì) không yêu cầu đầy đủ như bình thường, chỉ cần đạt đến mức nào đó cũng coi là xong, là được: làm phiên phiến * phiên phiến thôi cũng được",
    example: "làm phiên phiến * phiên phiến thôi cũng được",
  },
  {
    word: "phiên toà",
    part_of_speech: "danh từ",
    meaning: "lần họp để xét xử của toà án: mở phiên toà * phiên toà sơ thẩm",
    example: "mở phiên toà * phiên toà sơ thẩm",
  },
  {
    word: "phiền toái",
    part_of_speech: "tính từ",
    meaning:
      "rắc rối, gây cảm giác khó chịu vì vướng vào những cái lẽ ra không cần thiết: những nghi lễ phiền toái",
    example: "những nghi lễ phiền toái",
  },
  {
    word: "phiêu dạt",
    part_of_speech: "động từ",
    meaning: "như phiêu bạt: phiêu dạt giang hồ",
    example: "phiêu dạt giang hồ",
  },
  {
    word: "phiếu",
    part_of_speech: "danh từ",
    meaning:
      "tờ giấy rời có cỡ nhất định, chuyên dùng để ghi chép những nội dung cụ thể nào đó: phiếu điều tra * phiếu thư viện * phiếu góp ý",
    example: "phiếu điều tra * phiếu thư viện * phiếu góp ý",
  },
  {
    word: "phiếu",
    part_of_speech: "danh từ",
    meaning:
      "tờ giấy ghi nhận một quyền lợi nào đó cho người sử dụng: phiếu nhận tiền * phiếu khám sức khoẻ * phiếu thanh toán tiền tàu xe",
    example:
      "phiếu nhận tiền * phiếu khám sức khoẻ * phiếu thanh toán tiền tàu xe",
  },
  {
    word: "phiếu",
    part_of_speech: "danh từ",
    meaning:
      "tờ giấy biểu thị ý kiến trong cuộc bầu cử hoặc biểu quyết, do từng cá nhân trực tiếp bỏ vào hòm (gọi là hòm phiếu): bỏ phiếu bầu cử * kiểm phiếu * phiếu thuận",
    example: "bỏ phiếu bầu cử * kiểm phiếu * phiếu thuận",
  },
  {
    word: "phiếu",
    part_of_speech: "động từ",
    meaning:
      "làm cho vải, lụa trắng ra bằng cách ngâm vào hoá chất và giặt nhiều lần: phiếu lụa tơ tằm",
    example: "phiếu lụa tơ tằm",
  },
  {
    word: "phiếu trắng",
    part_of_speech: "danh từ",
    meaning:
      "phiếu không tán thành mà cũng không phản đối, hoặc không bầu cho ai cả: bỏ phiếu trắng",
    example: "bỏ phiếu trắng",
  },
  {
    word: "phiêu diêu",
    part_of_speech: "động từ",
    meaning:
      "(văn chương) di chuyển đây đó, thường là ở trên cao, một cách nhẹ nhàng: sương mù bay phiêu diêu * phiêu diêu trong giấc mộng",
    example: "sương mù bay phiêu diêu * phiêu diêu trong giấc mộng",
  },
  {
    word: "phiêu bạt",
    part_of_speech: "động từ",
    meaning: "(hiếm) bị sóng gió làm cho trôi dạt đi.",
    example: "lang thang phiêu bạt khắp nơi * cuộc đời phiêu bạt",
  },
  {
    word: "phiêu lưu",
    part_of_speech: "động từ",
    meaning: "(hiếm) như phiêu bạt (ng2): phiêu lưu nơi đất khách",
    example: "phiêu lưu nơi đất khách",
  },
  {
    word: "phiêu lưu",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất liều lĩnh, vội vàng, không tính toán kĩ trước khi làm, không lường hết hậu quả nghiêm trọng có thể có: hành động phiêu lưu",
    example: "hành động phiêu lưu",
  },
  {
    word: "phiêu linh",
    part_of_speech: "tính từ",
    meaning:
      "(cũ, vch, hiếm) trôi nổi lênh đênh nay đây mai đó: cuộc đời phiêu linh",
    example: "cuộc đời phiêu linh",
  },
  {
    word: "phiêu lãng",
    part_of_speech: "động từ",
    meaning:
      "sống nay đây mai đó một cách tự do, phóng túng, không có gì ràng buộc: bước đường phiêu lãng",
    example: "bước đường phiêu lãng",
  },
  {
    word: "phiêu du",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) đi chơi xa, đi đến những nơi xa lạ: cuộc phiêu du đầy kì thú",
    example: "cuộc phiêu du đầy kì thú",
  },
  {
    word: "phim",
    part_of_speech: "danh từ",
    meaning:
      "vật liệu dùng để chụp ảnh, làm bằng chất trong suốt được cán mỏng, trên bề mặt có tráng lớp thuốc nhạy ánh sáng: chụp phim * quay phim * tráng phim",
    example: "chụp phim * quay phim * tráng phim",
  },
  {
    word: "phim",
    part_of_speech: "danh từ",
    meaning:
      "mảnh giấy nhựa đã thu được ảnh thật sau khi chụp, có thể in rửa thành ảnh trên giấy: chờ lấy phim X quang",
    example: "chờ lấy phim X quang",
  },
  {
    word: "phim",
    part_of_speech: "danh từ",
    meaning:
      "tác phẩm điện ảnh ghi trên những cuộn phim để chiếu lên màn ảnh: đóng phim * chiếu phim * phim truyền hình",
    example: "đóng phim * chiếu phim * phim truyền hình",
  },
  {
    word: "phim ảnh",
    part_of_speech: "danh từ",
    meaning: "phim chiếu trên màn ảnh (nói khái quát): thích ca nhạc, phim ảnh",
    example: "thích ca nhạc, phim ảnh",
  },
  {
    word: "phím",
    part_of_speech: "danh từ",
    meaning:
      "miếng nhỏ bằng gỗ, nhựa hay kim loại chắn dây trên một số loại đàn dây, dùng để định cung trên cần đàn.",
    example: "ấn phím Enter để xuống dòng",
  },
  {
    word: "phim hoạt hình",
    part_of_speech: "danh từ",
    meaning:
      "phim quay từng hình vẽ, hình cắt giấy, động tác của búp bê, con rối, v.v. và khi chiếu với tốc độ 24 hình/giây sẽ tạo được cảm giác các nhân vật đang hoạt động: trẻ em rất thích xem phim hoạt hình",
    example: "trẻ em rất thích xem phim hoạt hình",
  },
  {
    word: "phim truyền hình",
    part_of_speech: "danh từ",
    meaning:
      "phim được quay bằng các phương tiện kĩ thuật truyền hình và được phát trên đài truyền hình: phim truyền hình nhiều tập",
    example: "phim truyền hình nhiều tập",
  },
  {
    word: "phính",
    part_of_speech: "tính từ",
    meaning:
      "tròn và căng lên (thường nói về má): má căng phính * bụng no phính",
    example: "má căng phính * bụng no phính",
  },
  {
    word: "phĩnh",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) (bộ phận cơ thể, thường là bụng) to ra một cách quá đáng, trông rất khó coi: chửa phĩnh ra * ăn no phĩnh bụng",
    example: "chửa phĩnh ra * ăn no phĩnh bụng",
  },
  {
    word: "phỉnh nịnh",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nịnh khéo để lợi dụng (nói khái quát): nghe lời cấp dưới phỉnh nịnh",
    example: "nghe lời cấp dưới phỉnh nịnh",
  },
  {
    word: "phỉnh",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nói khéo, nói nịnh để làm cho người ta tưởng thật, thích và nghe theo, làm theo: trẻ con ưa phỉnh * phỉnh cho mấy câu là nghe ngay",
    example: "trẻ con ưa phỉnh * phỉnh cho mấy câu là nghe ngay",
  },
  {
    word: "phỉnh mũi",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) như phổng mũi: phỉnh mũi vì được cô giáo khen",
    example: "phỉnh mũi vì được cô giáo khen",
  },
  {
    word: "phỉnh phờ",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) phỉnh (nói khái quát): nghe lời phỉnh phờ",
    example: "nghe lời phỉnh phờ",
  },
  {
    word: "phình",
    part_of_speech: "động từ",
    meaning:
      "to ra do chứa quá nhiều ở bên trong: túi căng phình * bụng ăn no phình * khúc sông phình ra ở quãng giữa",
    example:
      "túi căng phình * bụng ăn no phình * khúc sông phình ra ở quãng giữa",
  },
  {
    word: "phình",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) phát triển rộng ra, lớn ra quá đáng, gây mất cân đối: bộ máy quản lí ngày càng phình ra",
    example: "bộ máy quản lí ngày càng phình ra",
  },
  {
    word: "phinh phính",
    part_of_speech: "tính từ",
    meaning:
      "(má) hơi tròn và căng đầy đặn, trông thích mắt, đáng yêu: má phinh phính",
    example: "má phinh phính",
  },
  {
    word: "phó",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) người trực tiếp giúp việc và khi cần thiết có thể thay mặt cho cấp trưởng: cấp phó * ông chánh, ông phó",
    example: "cấp phó * ông chánh, ông phó",
  },
  {
    word: "phó",
    part_of_speech: "danh từ",
    meaning: "(cũ) người thợ làm nghề thủ công: phó cả * phó nề * bác phó mộc",
    example: "phó cả * phó nề * bác phó mộc",
  },
  {
    word: "phó",
    part_of_speech: "động từ",
    meaning:
      '(khẩu ngữ) giao cho, để cho chịu trách nhiệm hoàn toàn: mọi việc trong nhà đều phó cho vợ * "Thiếp nay là phận nữ nhân, Một thân đã phó lang quân cầm quyền." (NTT)',
    example:
      'mọi việc trong nhà đều phó cho vợ * "Thiếp nay là phận nữ nhân, Một thân đã phó lang quân cầm quyền." (NTT)',
  },
  {
    word: "phịu",
    part_of_speech: "động từ",
    meaning:
      "(mặt, môi) hơi xệ xuống, trông khó coi, biểu hiện sự hờn dỗi, không vừa lòng: bị mẹ mắng, mặt phịu ra",
    example: "bị mẹ mắng, mặt phịu ra",
  },
  {
    word: "phò",
    part_of_speech: "động từ",
    meaning:
      '(cũ) theo giúp vua, chúa hoặc người mà mình tôn sùng: phò vua giúp nước * "Nhờ có chúng tôi phò, chúa mới được lên ngôi. Nay chúa lại coi chúng tôi là kẻ thù." (HLNTC)',
    example:
      'phò vua giúp nước * "Nhờ có chúng tôi phò, chúa mới được lên ngôi. Nay chúa lại coi chúng tôi là kẻ thù." (HLNTC)',
  },
  {
    word: "pho",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị bộ sách hay bức tượng lớn và quý: pho tiểu thuyết * ngồi im như pho tượng",
    example: "pho tiểu thuyết * ngồi im như pho tượng",
  },
  {
    word: "phó mặc",
    part_of_speech: "động từ",
    meaning:
      "giao cho và để mặc muốn làm gì thì làm, muốn ra sao thì ra: mọi việc trong nhà đều phó mặc cho vợ * phó mặc cho số phận",
    example: "mọi việc trong nhà đều phó mặc cho vợ * phó mặc cho số phận",
  },
  {
    word: "phò mã",
    part_of_speech: "danh từ",
    meaning: "(cũ) con rể của vua: khen phò mã tốt áo (tng)",
    example: "khen phò mã tốt áo (tng)",
  },
  {
    word: "phó phòng",
    part_of_speech: "danh từ",
    meaning:
      "phó trưởng phòng (nói tắt): phó phòng kinh doanh * lên chức phó phòng",
    example: "phó phòng kinh doanh * lên chức phó phòng",
  },
  {
    word: "phó nhòm",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) người chụp ảnh (hàm ý hài hước hoặc coi thường): tay phó nháy",
    example: "tay phó nháy",
  },
  {
    word: "phó nháy",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) người chụp ảnh (hàm ý hài hước hoặc coi thường): tay phó nháy",
    example: "tay phó nháy",
  },
  {
    word: "phò tá",
    part_of_speech: "động từ",
    meaning:
      "(cũ) theo bên cạnh để giúp việc: người phò tá đắc lực * một lòng phò tá nhà vua",
    example: "người phò tá đắc lực * một lòng phò tá nhà vua",
  },
  {
    word: "phó thác",
    part_of_speech: "động từ",
    meaning:
      "giao phó hoàn toàn cho người nhận: mọi việc đều phó thác cho trợ lí * phó thác việc nhà",
    example: "mọi việc đều phó thác cho trợ lí * phó thác việc nhà",
  },
  {
    word: "phó từ",
    part_of_speech: "danh từ",
    meaning:
      "(ngữ pháp) từ chuyên bổ túc nghĩa cho một động từ, tính từ hoặc một phụ từ khác: 'sẽ', 'đã', 'đang', 'rất', 'lắm' là một số phụ từ trong tiếng Việt.",
    example:
      "'sẽ', 'đã', 'đang', 'rất', 'lắm' là một số phụ từ trong tiếng Việt.",
  },
  {
    word: "phó tổng",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) phó tổng biên tập, hoặc phó tổng giám đốc (nói tắt): ngồi ghế phó tổng của một tờ tạp chí",
    example: "ngồi ghế phó tổng của một tờ tạp chí",
  },
  {
    word: "phóc",
    part_of_speech: "",
    meaning:
      "từ gợi tả dáng vẻ nhanh gọn của động tác nhảy đột ngột: nhảy phóc qua mương * phóc lên lưng ngựa",
    example: "nhảy phóc qua mương * phóc lên lưng ngựa",
  },
  {
    word: "phòi",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) (cái bị nén, ép bên trong) lòi một phần ra ngoài qua một lỗ nhỏ: bóp phòi ruột con cá * nặn cho phòi trứng cá",
    example: "bóp phòi ruột con cá * nặn cho phòi trứng cá",
  },
  {
    word: "phoi",
    part_of_speech: "danh từ",
    meaning:
      "vật liệu được thải ra khi tạo hình bằng cách gọt, bào, tiện: phoi thép * phoi tiện * phoi bào",
    example: "phoi thép * phoi tiện * phoi bào",
  },
  {
    word: "phom",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) vóc dáng, hình dáng bên ngoài: phom người chuẩn * chọn áo theo phom người",
    example: "phom người chuẩn * chọn áo theo phom người",
  },
  {
    word: "phong ba",
    part_of_speech: "danh từ",
    meaning:
      'gió to và sóng lớn; thường dùng để ví những khó khăn, trở ngại lớn gặp phải trong cuộc sống: vượt qua phong ba bão táp * "Đôi ta chỉ quyết đôi ta, Đá vàng cũng quyết, phong ba cũng liều." (ca dao)',
    example:
      'vượt qua phong ba bão táp * "Đôi ta chỉ quyết đôi ta, Đá vàng cũng quyết, phong ba cũng liều." (ca dao)',
  },
  {
    word: "phòng",
    part_of_speech: "danh từ",
    meaning:
      "phần không gian của nhà được ngăn riêng bằng tường, vách, thường với mục đích sử dụng cụ thể nào đó: nhà chỉ có hai phòng * phòng họp * phòng tiếp khách",
    example: "nhà chỉ có hai phòng * phòng họp * phòng tiếp khách",
  },
  {
    word: "phòng",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị hành chính, sự nghiệp hoặc làm công tác chuyên môn trong một cơ quan hoặc một quận, huyện: phòng kế toán * cán bộ phòng tổ chức",
    example: "phòng kế toán * cán bộ phòng tổ chức",
  },
  {
    word: "phòng",
    part_of_speech: "động từ",
    meaning:
      'lo liệu để có biện pháp tránh, ngăn ngừa hoặc chuẩn bị đối phó với điều không hay có thể xảy ra: phòng khi bất trắc * "Ra đi anh có dặn phòng, Chanh chua chớ phụ, ngọt bòng chớ ham." (Cdao)',
    example:
      'phòng khi bất trắc * "Ra đi anh có dặn phòng, Chanh chua chớ phụ, ngọt bòng chớ ham." (Cdao)',
  },
  {
    word: "phong",
    part_of_speech: "danh từ",
    meaning:
      "vật được gói, bọc vuông vắn, thường bằng giấy gấp lại và dán kín: phong thư * mua vài phong bánh khảo * đốt mấy phong pháo",
    example: "phong thư * mua vài phong bánh khảo * đốt mấy phong pháo",
  },
  {
    word: "phong",
    part_of_speech: "động từ",
    meaning:
      "(cũ) (nhà vua) ban, cấp chức tước, đất đai cho quan lại, người có công trạng: phong ấp * phong tước hầu",
    example: "phong ấp * phong tước hầu",
  },
  {
    word: "phong",
    part_of_speech: "động từ",
    meaning:
      "(nhà nước) tặng chức vị, danh hiệu cho cá nhân hay tập thể có công trạng: phong danh hiệu Bà mẹ Việt Nam anh hùng * phong học hàm giáo sư",
    example: "phong danh hiệu Bà mẹ Việt Nam anh hùng * phong học hàm giáo sư",
  },
  {
    word: "phỏng",
    part_of_speech: "động từ",
    meaning:
      "dựa theo cái đã có mà làm giống hoặc gần giống như thế: bài hát phỏng thơ Nguyễn Bính * phỏng theo một điệu dân ca",
    example: "bài hát phỏng thơ Nguyễn Bính * phỏng theo một điệu dân ca",
  },
  {
    word: "phỏng",
    part_of_speech: "động từ",
    meaning:
      "ước đoán trên đại thể, không cần chính xác, cụ thể lắm: tính phỏng xem còn bao nhiêu * đoán phỏng",
    example: "tính phỏng xem còn bao nhiêu * đoán phỏng",
  },
  {
    word: "phỏng",
    part_of_speech: "động từ",
    meaning:
      "từ biểu thị ý lấy làm ngờ, nêu ra như để hỏi, nhưng với hàm ý phủ định: nói thế phỏng có ích gì? * nếu tôi nghèo đói, phỏng nó có nhận là anh em không?",
    example:
      "nói thế phỏng có ích gì? * nếu tôi nghèo đói, phỏng nó có nhận là anh em không?",
  },
  {
    word: "phỏng",
    part_of_speech: "kết từ",
    meaning:
      "(hiếm) từ dùng để nêu một giả thiết, với hàm ý khẳng định rất dè dặt: phỏng chị ta đã biết hết mọi chuyện rồi thì sao?",
    example: "phỏng chị ta đã biết hết mọi chuyện rồi thì sao?",
  },
  {
    word: "phỏng",
    part_of_speech: "trợ từ",
    meaning:
      "(khẩu ngữ) từ biểu thị ý như muốn hỏi, nhưng thật ra chỉ là để xác nhận điều mình đã khẳng định, có nghĩa như ‘phải không’: chị mệt lắm phỏng? * anh muốn gây sự đấy phỏng?",
    example: "chị mệt lắm phỏng? * anh muốn gây sự đấy phỏng?",
  },
  {
    word: "phỏng",
    part_of_speech: "tính từ",
    meaning:
      "(da) phồng rộp lên, do bị bỏng hoặc bị cọ xát mạnh: phỏng rộp hai tay * gánh nặng phỏng cả vai",
    example: "phỏng rộp hai tay * gánh nặng phỏng cả vai",
  },
  {
    word: "phỏng",
    part_of_speech: "tính từ",
    meaning: "(Nam) bỏng: bị phỏng nước sôi",
    example: "bị phỏng nước sôi",
  },
  {
    word: "phóng",
    part_of_speech: "động từ",
    meaning:
      "vẽ ra, in ra thành bản khác to hơn: phóng ảnh * dưới kính hiển vi, mẫu tế bào được phóng lên gấp trăm lần",
    example:
      "phóng ảnh * dưới kính hiển vi, mẫu tế bào được phóng lên gấp trăm lần",
  },
  {
    word: "phóng",
    part_of_speech: "động từ",
    meaning:
      "làm cho rời ra khỏi mình và di chuyển thẳng theo một hướng nào đó với tốc độ lớn: phóng lao * bệ phóng tên lửa * phóng tầm mắt ra xa",
    example: "phóng lao * bệ phóng tên lửa * phóng tầm mắt ra xa",
  },
  {
    word: "phóng",
    part_of_speech: "động từ",
    meaning:
      "di chuyển theo một hướng nào đó với tốc độ lớn: phóng xe máy * phóng như bay trên đường",
    example: "phóng xe máy * phóng như bay trên đường",
  },
  {
    word: "phòng ban",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) phòng và ban trong một cơ quan (nói khái quát): đại diện các phòng ban trong xí nghiệp",
    example: "đại diện các phòng ban trong xí nghiệp",
  },
  {
    word: "phong bao",
    part_of_speech: "danh từ",
    meaning:
      "phong bì đựng tiền hay gói tiền nhỏ dùng để mừng tuổi hay để trả công, trả ơn một cách lịch sự: phong bao lì xì",
    example: "phong bao lì xì",
  },
  {
    word: "phong bao",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) cho tiền để mừng tuổi hay để trả công, trả ơn một cách lịch sự: phong bao cho các cháu nhân dịp năm mới",
    example: "phong bao cho các cháu nhân dịp năm mới",
  },
  {
    word: "phong cách",
    part_of_speech: "danh từ",
    meaning:
      "cung cách sinh hoạt, làm việc, hoạt động, xử sự tạo nên cái riêng của một người hay một lớp người nào đó (nói tổng quát): có phong cách sống giản dị * phong cách nghệ sĩ",
    example: "có phong cách sống giản dị * phong cách nghệ sĩ",
  },
  {
    word: "phong cách",
    part_of_speech: "danh từ",
    meaning:
      "những đặc điểm có tính chất hệ thống về tư tưởng và nghệ thuật, biểu hiện trong sáng tác của một nghệ sĩ hay trong các sáng tác thuộc cùng một thể loại nói chung: phong cách của Nguyễn Du * phong cách thơ mới",
    example: "phong cách của Nguyễn Du * phong cách thơ mới",
  },
  {
    word: "phong cách",
    part_of_speech: "danh từ",
    meaning:
      "dạng của ngôn ngữ được sử dụng trong những yêu cầu chức năng điển hình nào đó, khác với những dạng khác về đặc điểm từ vựng, ngữ pháp, ngữ âm: phong cách khẩu ngữ * phong cách ngôn ngữ nghệ thuật",
    example: "phong cách khẩu ngữ * phong cách ngôn ngữ nghệ thuật",
  },
  {
    word: "phòng bệnh",
    part_of_speech: "động từ",
    meaning:
      "ngăn ngừa bệnh tật để giữ gìn và tăng cường sức khoẻ: phòng bệnh hơn chữa bệnh",
    example: "phòng bệnh hơn chữa bệnh",
  },
  {
    word: "phong bế",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) bao vây chặt, làm cắt đứt mọi sự liên hệ, tiếp xúc với bên ngoài: phong bế các cửa khẩu",
    example: "phong bế các cửa khẩu",
  },
  {
    word: "phòng bị",
    part_of_speech: "động từ",
    meaning: "đề phòng sẵn để ngăn ngừa, đối phó: phòng bị cẩn thận",
    example: "phòng bị cẩn thận",
  },
  {
    word: "phong bì",
    part_of_speech: "danh từ",
    meaning:
      "bao bằng giấy gấp lại chuyên dùng để đựng thư, thiếp, v.v.: bỏ lá thư vào phong bì",
    example: "bỏ lá thư vào phong bì",
  },
  {
    word: "phong bì",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) tiền biếu tặng hoặc trả thù lao, đưa một cách lịch sự (thường cho vào phong bì): nhận phong bì ăn trưa * đưa phong bì cho cô dâu",
    example: "nhận phong bì ăn trưa * đưa phong bì cho cô dâu",
  },
  {
    word: "phong cảnh",
    part_of_speech: "danh từ",
    meaning:
      "những cảnh thiên nhiên, thường là đẹp, bày ra trước mắt, như sông, núi, làng mạc, phố xá, v.v. (nói tổng quát): phong cảnh làng quê ngày mùa * ngắm phong cảnh",
    example: "phong cảnh làng quê ngày mùa * ngắm phong cảnh",
  },
  {
    word: "phòng chống",
    part_of_speech: "động từ",
    meaning: "phòng bị trước và sẵn sàng chống lại: phòng chống bão lụt",
    example: "phòng chống bão lụt",
  },
  {
    word: "phỏng chừng",
    part_of_speech: "động từ",
    meaning:
      "ước lượng hoặc đoán đại khái, không thật chính xác: tính phỏng chừng * việc đó phỏng chừng cũng sắp xong",
    example: "tính phỏng chừng * việc đó phỏng chừng cũng sắp xong",
  },
  {
    word: "phong dao",
    part_of_speech: "danh từ",
    meaning: "ca dao cổ: câu phong dao",
    example: "câu phong dao",
  },
  {
    word: "phóng đãng",
    part_of_speech: "tính từ",
    meaning:
      "có lối sống tự do, buông thả, không chút tự kiềm chế mình trong các mặt sinh hoạt: ăn chơi phóng đãng * sống phóng đãng",
    example: "ăn chơi phóng đãng * sống phóng đãng",
  },
  {
    word: "phóng đại",
    part_of_speech: "động từ",
    meaning:
      "tạo một ảnh giống hệt vật hay ảnh đã có nào đó, nhưng có kích thước lớn gấp nhiều lần: phóng đại tấm ảnh * hình ảnh được phóng đại qua kính hiển vi",
    example: "phóng đại tấm ảnh * hình ảnh được phóng đại qua kính hiển vi",
  },
  {
    word: "phóng đại",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nói quá lên so với sự thật: lối nói khoa trương, phóng đại * phóng đại sự thật",
    example: "lối nói khoa trương, phóng đại * phóng đại sự thật",
  },
  {
    word: "phong độ",
    part_of_speech: "",
    meaning:
      "những biểu hiện bên ngoài (như vẻ mặt, cử chỉ, cách nói năng, v.v.) tạo nên tính cách riêng (thường là tốt đẹp) của mỗi người: phong độ ung dung * lấy lại phong độ",
    example: "phong độ ung dung * lấy lại phong độ",
  },
  {
    word: "phỏng đoán",
    part_of_speech: "động từ",
    meaning:
      "đoán phỏng chừng, không có cơ sở chắc chắn: phỏng đoán sai * sự việc diễn ra đúng như phỏng đoán",
    example: "phỏng đoán sai * sự việc diễn ra đúng như phỏng đoán",
  },
  {
    word: "phòng gian",
    part_of_speech: "động từ",
    meaning:
      "đề phòng, ngăn chặn kẻ gian hoạt động: chú ý công tác phòng gian, bảo mật",
    example: "chú ý công tác phòng gian, bảo mật",
  },
  {
    word: "phong hàn",
    part_of_speech: "danh từ",
    meaning: "bệnh cảm nhiễm do gió và khí lạnh: mắc chứng phong hàn",
    example: "mắc chứng phong hàn",
  },
  {
    word: "phỏng độ",
    part_of_speech: "",
    meaning: "(hiếm) độ chừng, khoảng chừng: cô ấy phỏng độ hai mươi tuổi",
    example: "cô ấy phỏng độ hai mươi tuổi",
  },
  {
    word: "phóng điện",
    part_of_speech: "động từ",
    meaning: "cho dòng điện chạy ra: acquy phóng điện",
    example: "acquy phóng điện",
  },
  {
    word: "phóng điện",
    part_of_speech: "động từ",
    meaning:
      "phát ra một dòng điện mạnh chạy qua một môi trường: hiện tượng phóng điện ở các đám mây trong cơn dông",
    example: "hiện tượng phóng điện ở các đám mây trong cơn dông",
  },
  {
    word: "phong hoá",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) phong tục, tập quán và nếp sống của một xã hội (nói tổng quát): phong hoá suy đồi",
    example: "phong hoá suy đồi",
  },
  {
    word: "phong hoá",
    part_of_speech: "động từ",
    meaning:
      "(hiện tượng) huỷ hoại các loại đá do tác dụng của khí quyển, nước và sinh vật: đá vôi bị phong hoá",
    example: "đá vôi bị phong hoá",
  },
  {
    word: "phóng hoả",
    part_of_speech: "động từ",
    meaning: "gây ra đám cháy để thiêu huỷ: phóng hoả để phi tang",
    example: "phóng hoả để phi tang",
  },
  {
    word: "phòng không",
    part_of_speech: "động từ",
    meaning:
      "phòng chống và đánh trả các cuộc tiến công bằng đường không của đối phương: tên lửa phòng không * binh chủng phòng không",
    example: "tên lửa phòng không * binh chủng phòng không",
  },
  {
    word: "phòng hộ",
    part_of_speech: "động từ",
    meaning: "che chắn để bảo vệ: đắp kè để phòng hộ đê * trồng rừng phòng hộ",
    example: "đắp kè để phòng hộ đê * trồng rừng phòng hộ",
  },
  {
    word: "phòng hộ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) như bảo hộ lao động: trang bị phòng hộ * có biện pháp phòng hộ",
    example: "trang bị phòng hộ * có biện pháp phòng hộ",
  },
  {
    word: "phòng khám",
    part_of_speech: "danh từ",
    meaning:
      "nơi khám và chữa bệnh ngoại trú (= người bệnh không ở lại để theo dõi): mở phòng khám tư * phòng khám đa khoa",
    example: "mở phòng khám tư * phòng khám đa khoa",
  },
  {
    word: "phóng khoáng",
    part_of_speech: "tính từ",
    meaning:
      "không bị gò bó, trói buộc bởi những điều vụn vặt: sống phóng khoáng * tính tình phóng khoáng",
    example: "sống phóng khoáng * tính tình phóng khoáng",
  },
  {
    word: "phòng hoả",
    part_of_speech: "động từ",
    meaning: "đề phòng hoả hoạn: công tác phòng hoả",
    example: "công tác phòng hoả",
  },
  {
    word: "phòng mạch",
    part_of_speech: "danh từ",
    meaning:
      "phòng xem mạch, chữa bệnh của thầy thuốc đông y: phòng mạch châm cứu",
    example: "phòng mạch châm cứu",
  },
  {
    word: "phòng mạch",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) phòng khám tư nhân: mở phòng mạch tư",
    example: "mở phòng mạch tư",
  },
  {
    word: "phong kiến",
    part_of_speech: "danh từ",
    meaning:
      "những người thuộc giai cấp thống trị trong chế độ phong kiến (nói tổng quát): bọn địa chủ, phong kiến * thế lực phong kiến",
    example: "bọn địa chủ, phong kiến * thế lực phong kiến",
  },
  {
    word: "phong kiến",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về chế độ hoặc giai cấp phong kiến, có tính chất phong kiến: một con người cổ hủ, phong kiến * tư tưởng phong kiến",
    example: "một con người cổ hủ, phong kiến * tư tưởng phong kiến",
  },
  {
    word: "phong nguyệt",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) gió và trăng (nói khái quát); dùng để nói thú vui du ngoạn đây đó hoặc chuyện yêu đương của trai gái: "Sánh vai về chốn thư hiên, Ngâm lời phong nguyệt, nặng nguyền non sông." (TKiều)',
    example:
      'Sánh vai về chốn thư hiên, Ngâm lời phong nguyệt, nặng nguyền non sông." (TKiều)',
  },
  {
    word: "phòng ngừa",
    part_of_speech: "động từ",
    meaning:
      "phòng trước, không để cho cái xấu, cái không hay có thể xảy ra: phòng ngừa dịch bệnh * thực hiện các biện pháp phòng ngừa lũ lụt",
    example: "phòng ngừa dịch bệnh * thực hiện các biện pháp phòng ngừa lũ lụt",
  },
  {
    word: "phong lưu",
    part_of_speech: "tính từ",
    meaning:
      "có dáng vẻ, cử chỉ, tác phong lịch sự, trang nhã: con người phong lưu * cốt cách phong lưu",
    example: "con người phong lưu * cốt cách phong lưu",
  },
  {
    word: "phong lưu",
    part_of_speech: "tính từ",
    meaning:
      '(cũ) có đời sống vật chất khá giả, dễ chịu: sống rất phong lưu * "Rủ nhau đi cấy đi cày, Bây giờ khó nhọc, có ngày phong lưu." (ca dao)',
    example:
      'sống rất phong lưu * "Rủ nhau đi cấy đi cày, Bây giờ khó nhọc, có ngày phong lưu." (ca dao)',
  },
  {
    word: "phòng ngự",
    part_of_speech: "động từ",
    meaning:
      "phòng chống và đánh trả nhằm đẩy lùi các cuộc tiến công của đối phương: chuyển từ tấn công sang phòng ngự",
    example: "chuyển từ tấn công sang phòng ngự",
  },
  {
    word: "phòng ốc",
    part_of_speech: "danh từ",
    meaning:
      "phòng, buồng, nhà cửa (nói khái quát): sửa sang, mở rộng phòng ốc",
    example: "sửa sang, mở rộng phòng ốc",
  },
  {
    word: "phong phanh",
    part_of_speech: "tính từ",
    meaning: "(quần áo mặc) ít và mỏng manh, không đủ ấm: ăn mặc phong phanh",
    example: "ăn mặc phong phanh",
  },
  {
    word: "phong nhã",
    part_of_speech: "tính từ",
    meaning: "lịch sự, tao nhã, dễ được yêu mến: con người hào hoa phong nhã",
    example: "con người hào hoa phong nhã",
  },
  {
    word: "phong phú",
    part_of_speech: "tính từ",
    meaning:
      "nhiều và đa dạng: trí tưởng tượng hết sức phong phú * nguồn tài nguyên phong phú",
    example: "trí tưởng tượng hết sức phong phú * nguồn tài nguyên phong phú",
  },
  {
    word: "phóng sinh",
    part_of_speech: "động từ",
    meaning:
      "thả chim, cá bắt được hay mua về vì kiêng sát sinh, theo giáo lí đạo Phật.",
    example: "nhà cửa bỏ phóng sinh mà đi chơi",
  },
  {
    word: "phong quang",
    part_of_speech: "tính từ",
    meaning:
      "sáng sủa, quang đãng: nhà cửa phong quang * đường phố phong quang, sạch đẹp",
    example: "nhà cửa phong quang * đường phố phong quang, sạch đẹp",
  },
  {
    word: "phóng tay",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) (làm việc gì) thả hết sức, không hề tự kiềm chế, tự hạn chế: phóng tay mua sắm * phóng tay kí một loạt hợp đồng",
    example: "phóng tay mua sắm * phóng tay kí một loạt hợp đồng",
  },
  {
    word: "phóng sự",
    part_of_speech: "danh từ",
    meaning:
      "thể văn chuyên miêu tả những việc có thật mang tính thời sự xã hội: phóng sự điều tra * thiên phóng sự",
    example: "phóng sự điều tra * thiên phóng sự",
  },
  {
    word: "phong sương",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) gió và sương (nói khái quát); thường dùng để ví những nỗi gian nan, vất vả trong cuộc sống: giũ áo phong sương * dầu dãi phong sương",
    example: "giũ áo phong sương * dầu dãi phong sương",
  },
  {
    word: "phong thái",
    part_of_speech: "danh từ",
    meaning:
      "những nét đặc trưng (thường là tốt đẹp) biểu hiện qua dáng đi, cử chỉ, điệu bộ của một người: phong thái ung dung * có phong thái một nghệ sĩ",
    example: "phong thái ung dung * có phong thái một nghệ sĩ",
  },
  {
    word: "phóng thanh",
    part_of_speech: "động từ",
    meaning:
      "có tác dụng làm cho âm thanh, tiếng nói to ra để mọi người cùng nghe thấy: loa phóng thanh * nói trước máy phóng thanh",
    example: "loa phóng thanh * nói trước máy phóng thanh",
  },
  {
    word: "phong tặng",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) (nhà nước) trao tặng danh hiệu cao quý: được phong tặng danh hiệu Anh hùng lao động",
    example: "được phong tặng danh hiệu Anh hùng lao động",
  },
  {
    word: "phong thổ",
    part_of_speech: "danh từ",
    meaning:
      "những điều kiện về khí hậu của một vùng đối với đời sống của con người (nói tổng quát): không quen phong thổ",
    example: "không quen phong thổ",
  },
  {
    word: "phong thanh",
    part_of_speech: "tính từ",
    meaning:
      "(tin tức) thoáng nghe được, thoáng biết được, chưa thật rõ ràng, chưa chắc chắn: chỉ nghe phong thanh chứ chưa biết chắc",
    example: "chỉ nghe phong thanh chứ chưa biết chắc",
  },
  {
    word: "phòng thân",
    part_of_speech: "động từ",
    meaning:
      "đề phòng những điều không hay có thể xảy ra, gây hại cho bản thân: mang theo tiền để phòng thân",
    example: "mang theo tiền để phòng thân",
  },
  {
    word: "phòng thí nghiệm",
    part_of_speech: "danh từ",
    meaning:
      "phòng, cơ sở có những thiết bị cần thiết để tiến hành thí nghiệm khoa học, nghiên cứu khoa học: cán bộ phòng thí nghiệm",
    example: "cán bộ phòng thí nghiệm",
  },
  {
    word: "phòng the",
    part_of_speech: "danh từ",
    meaning: "(cũ, văn chương)",
    example: "chuyện phòng the",
  },
  {
    word: "phóng thích",
    part_of_speech: "động từ",
    meaning:
      "(cơ quan có thẩm quyền) thả tù nhân, thả người đang bị giam: phóng thích tù binh",
    example: "phóng thích tù binh",
  },
  {
    word: "phóng thích",
    part_of_speech: "động từ",
    meaning: "như giải phóng (ng4): năng lượng được phóng thích",
    example: "năng lượng được phóng thích",
  },
  {
    word: "phong thuỷ",
    part_of_speech: "danh từ",
    meaning:
      "thuật xem đất, hướng gió, mạch nước để chọn nơi dựng nhà cửa hay đặt mồ mả: thầy phong thuỷ",
    example: "thầy phong thuỷ",
  },
  {
    word: "phòng thường trực",
    part_of_speech: "danh từ",
    meaning:
      "nơi có nhiệm vụ xem xét giấy tờ, theo dõi việc ra vào một cơ quan, một xí nghiệp, v.v.: khách đến làm việc với cơ quan phải qua phòng thường trực",
    example: "khách đến làm việc với cơ quan phải qua phòng thường trực",
  },
  {
    word: "phòng thủ",
    part_of_speech: "động từ",
    meaning:
      "tự bảo vệ, chống trả lại sự tiến công của đối phương để giữ vững vị trí, trận địa của mình: tuyến phòng thủ * tăng cường phòng thủ",
    example: "tuyến phòng thủ * tăng cường phòng thủ",
  },
  {
    word: "phòng tiêu",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, văn chương): “Phòng tiêu lạnh ngắt như đồng, Gương loan bẻ nửa, dải đồng xé đôi.” (CO)",
    example:
      "“Phòng tiêu lạnh ngắt như đồng, Gương loan bẻ nửa, dải đồng xé đôi.” (CO)",
  },
  {
    word: "phong tình",
    part_of_speech: "tính từ",
    meaning:
      'có vẻ lẳng lơ, tình tứ: ánh mắt phong tình * "Chẳng ngờ, gã Mã giám sinh, Vẫn là một đứa phong tình đã quen." (TKiều)',
    example:
      'ánh mắt phong tình * "Chẳng ngờ, gã Mã giám sinh, Vẫn là một đứa phong tình đã quen." (TKiều)',
  },
  {
    word: "phong toả",
    part_of_speech: "động từ",
    meaning:
      "bao vây để cô lập, cắt đứt mọi liên hệ, liên lạc với bên ngoài: phong toả các trục đường giao thông * nền kinh tế bị phong toả",
    example: "phong toả các trục đường giao thông * nền kinh tế bị phong toả",
  },
  {
    word: "phỏng tính",
    part_of_speech: "động từ",
    meaning:
      "ước tính, tính đại khái: phỏng tính chi hết năm triệu * theo phỏng tính thì ba ngày là xong",
    example:
      "phỏng tính chi hết năm triệu * theo phỏng tính thì ba ngày là xong",
  },
  {
    word: "phòng tránh",
    part_of_speech: "động từ",
    meaning:
      "phòng bị trước nhằm chủ động tránh điều bất lợi không hay xảy ra đối với mình (nói khái quát): phòng tránh thiên tai, dịch bệnh * các biện pháp phòng tránh HIV",
    example: "phòng tránh thiên tai, dịch bệnh * các biện pháp phòng tránh HIV",
  },
  {
    word: "phòng trừ",
    part_of_speech: "động từ",
    meaning:
      "ngăn ngừa và diệt trừ: phòng trừ sâu bệnh * phòng trừ mối, bảo vệ đê điều",
    example: "phòng trừ sâu bệnh * phòng trừ mối, bảo vệ đê điều",
  },
  {
    word: "phong trần",
    part_of_speech: "danh từ",
    meaning:
      'gió và bụi (nói khái quát); thường dùng để ví những gian nan, vất vả phải trải qua trong cuộc sống: chịu cảnh phong trần * "Bắt phong trần, phải phong trần, Cho thanh cao, mới được phần thanh cao." (TKiều)',
    example:
      'chịu cảnh phong trần * "Bắt phong trần, phải phong trần, Cho thanh cao, mới được phần thanh cao." (TKiều)',
  },
  {
    word: "phong trào",
    part_of_speech: "danh từ",
    meaning:
      "hoạt động chính trị, văn hoá, xã hội lôi cuốn được đông đảo quần chúng tham gia: phong trào văn nghệ * phát động phong trào thi đua",
    example: "phong trào văn nghệ * phát động phong trào thi đua",
  },
  {
    word: "phóng túng",
    part_of_speech: "tính từ",
    meaning:
      "tự do tuỳ tiện, không chịu khép mình vào khuôn phép: ăn chơi phóng túng * sống một cuộc đời phóng túng",
    example: "ăn chơi phóng túng * sống một cuộc đời phóng túng",
  },
  {
    word: "phong tư",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) dáng người đẹp: "Phong tư tài mạo tót vời, Vào trong thanh nhã, ra ngoài hào hoa." (TKiều)',
    example:
      'Phong tư tài mạo tót vời, Vào trong thanh nhã, ra ngoài hào hoa." (TKiều)',
  },
  {
    word: "phong tục",
    part_of_speech: "danh từ",
    meaning:
      "thói quen đã có từ lâu đời, đã ăn sâu vào đời sống xã hội, được mọi người công nhận và làm theo: phong tục mỗi vùng mỗi khác * phong tục, tập quán",
    example: "phong tục mỗi vùng mỗi khác * phong tục, tập quán",
  },
  {
    word: "phóng uế",
    part_of_speech: "động từ",
    meaning:
      "đi tiểu tiện, đại tiện bừa bãi, không đúng nơi, đúng chỗ: cấm phóng uế bừa bãi",
    example: "cấm phóng uế bừa bãi",
  },
  {
    word: "phong vận",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, văn chương) cốt cách lịch sự, phong lưu: phong vận con nhà quyền quý",
    example: "phong vận con nhà quyền quý",
  },
  {
    word: "phong vận",
    part_of_speech: "tính từ",
    meaning:
      '(cũ, văn chương) phong lưu, tao nhã: "Thoắt đâu thấy một tiểu kiều, Có chiều phong vận, có chiều thanh tân." (TKiều)',
    example:
      'Thoắt đâu thấy một tiểu kiều, Có chiều phong vận, có chiều thanh tân." (TKiều)',
  },
  {
    word: "phòng tuyến",
    part_of_speech: "danh từ",
    meaning:
      "hệ thống bố trí lực lượng phòng thủ: chọc thủng phòng tuyến của địch",
    example: "chọc thủng phòng tuyến của địch",
  },
  {
    word: "phong vị",
    part_of_speech: "danh từ",
    meaning:
      "đặc tính gây hứng thú đặc sắc: phong vị ca dao * phong vị ngày Tết",
    example: "phong vị ca dao * phong vị ngày Tết",
  },
  {
    word: "phong vân",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) gió và mây (nói khái quát); thường dùng để ví dịp tốt, dịp may để lập công danh, sự nghiệp: "Làm trai có chí lập thân, Rồi ra gặp hội phong vân có ngày." (ca dao)',
    example:
      'Làm trai có chí lập thân, Rồi ra gặp hội phong vân có ngày." (ca dao)',
  },
  {
    word: "phòng vệ",
    part_of_speech: "động từ",
    meaning:
      "phòng giữ và bảo vệ, chống lại sự xâm phạm, đánh chiếm: phòng vệ nghiêm ngặt * lực lượng phòng vệ",
    example: "phòng vệ nghiêm ngặt * lực lượng phòng vệ",
  },
  {
    word: "phỏng vấn",
    part_of_speech: "động từ",
    meaning:
      "hỏi ý kiến một nhân vật nào đó để công bố trước dư luận: phóng viên phỏng vấn thủ tướng * trả lời phỏng vấn trực tiếp trên truyền hình",
    example:
      "phóng viên phỏng vấn thủ tướng * trả lời phỏng vấn trực tiếp trên truyền hình",
  },
  {
    word: "phóng viên thường trú",
    part_of_speech: "danh từ",
    meaning:
      "phóng viên được cử đến ở thường xuyên một nơi xa để hoạt động ở đó trong một thời gian dài: phóng viên thường trú tại Nga",
    example: "phóng viên thường trú tại Nga",
  },
  {
    word: "phóng xạ",
    part_of_speech: "động từ",
    meaning:
      "(hiện tượng) phóng ra các tia alpha, beta, gamma do sự phân rã của hạt nhân: chất phóng xạ",
    example: "chất phóng xạ",
  },
  {
    word: "phọt",
    part_of_speech: "động từ",
    meaning:
      "bật mạnh ra ngoài, thường thành tia, thành dòng: phọt nước * vết thương phọt máu",
    example: "phọt nước * vết thương phọt máu",
  },
  {
    word: "phòng xa",
    part_of_speech: "động từ",
    meaning:
      'có biện pháp để phòng trước điều không hay: dặn phòng xa * "Đến con kiến cũng biết tha lâu đầy tổ, phòng xa những cảnh cơ hàn (...)" (VTrPhụng; 14)',
    example:
      'dặn phòng xa * "Đến con kiến cũng biết tha lâu đầy tổ, phòng xa những cảnh cơ hàn (...)" (VTrPhụng; 14)',
  },
  {
    word: "phọt phẹt",
    part_of_speech: "tính từ",
    meaning:
      "(thông tục) kém cỏi, không ra gì, không đâu vào đâu: làm ăn phọt phẹt * biết phọt phẹt vài câu tiếng Anh",
    example: "làm ăn phọt phẹt * biết phọt phẹt vài câu tiếng Anh",
  },
  {
    word: "photocopy",
    part_of_speech: "động từ",
    meaning: "chụp sao lại: photocopy tập tài liệu",
    example: "photocopy tập tài liệu",
  },
  {
    word: "phổ biến",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất chung, có thể áp dụng cho cả một tập hợp các sự vật, hiện tượng: quy luật phổ biến của tự nhiên * nguyên lí phổ biến",
    example: "quy luật phổ biến của tự nhiên * nguyên lí phổ biến",
  },
  {
    word: "phổ biến",
    part_of_speech: "tính từ",
    meaning:
      "thường thấy, thường gặp ở nhiều nơi, nhiều người: một hiện tượng phổ biến",
    example: "một hiện tượng phổ biến",
  },
  {
    word: "phổ biến",
    part_of_speech: "động từ",
    meaning:
      "làm cho đông đảo người biết bằng cách truyền đạt trực tiếp hay thông qua hình thức nào đó: sách phổ biến kiến thức * phổ biến kinh nghiệm",
    example: "sách phổ biến kiến thức * phổ biến kinh nghiệm",
  },
  {
    word: "phô",
    part_of_speech: "động từ",
    meaning:
      "để lộ ra, bày ra: hoa phô nhuỵ * miệng cười phô hàm răng trắng muốt",
    example: "hoa phô nhuỵ * miệng cười phô hàm răng trắng muốt",
  },
  {
    word: "phô",
    part_of_speech: "động từ",
    meaning: "chưng ra, nói ra để khoe: tốt đẹp phô ra, xấu xa đậy lại (tng)",
    example: "tốt đẹp phô ra, xấu xa đậy lại (tng)",
  },
  {
    word: "phô",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) lộ liễu, thiếu tế nhị, thiếu kín đáo: khen kiểu đấy thì phô quá * lối thể hiện hơi phô",
    example: "khen kiểu đấy thì phô quá * lối thể hiện hơi phô",
  },
  {
    word: "phố",
    part_of_speech: "danh từ",
    meaning:
      "đường ở thành phố, thị trấn, dọc hai bên có nhà cửa của dân cư sinh sống: phố Hàng Đường * phố giăng như mắc cửi",
    example: "phố Hàng Đường * phố giăng như mắc cửi",
  },
  {
    word: "phố",
    part_of_speech: "danh từ",
    meaning:
      "(Phương ngữ, Từ cũ) nhà (ở thành thị, thường liền nhau thành từng dãy): mua một căn phố * mướn phố để ở tạm",
    example: "mua một căn phố * mướn phố để ở tạm",
  },
  {
    word: "phổ",
    part_of_speech: "động từ",
    meaning:
      "soạn thêm phần nhạc hoặc đặt thêm phần lời để từ một bài thơ hoặc một bản nhạc đã có sẵn làm thành một bài hát: phổ nhạc cho bài thơ",
    example: "phổ nhạc cho bài thơ",
  },
  {
    word: "phô diễn",
    part_of_speech: "động từ",
    meaning:
      "thể hiện, diễn đạt bằng một phương tiện, cách thức nào đó: phô diễn tài năng",
    example: "phô diễn tài năng",
  },
  {
    word: "phổ cập",
    part_of_speech: "động từ",
    meaning:
      "làm cho trở thành rộng khắp, cho đến được với đông đảo quần chúng: phổ cập giáo dục tiểu học * phổ cập tin học trong nhà trường",
    example: "phổ cập giáo dục tiểu học * phổ cập tin học trong nhà trường",
  },
  {
    word: "phô bày",
    part_of_speech: "động từ",
    meaning:
      "để lộ rõ ra cho nhiều người cùng thấy (nói khái quát): phô bày vẻ đẹp * phô bày của cải",
    example: "phô bày vẻ đẹp * phô bày của cải",
  },
  {
    word: "phổ dụng",
    part_of_speech: "tính từ",
    meaning:
      "được sử dụng phổ biến: phần mềm phổ dụng * tính chất phổ dụng của chương trình",
    example: "phần mềm phổ dụng * tính chất phổ dụng của chương trình",
  },
  {
    word: "phổ độ",
    part_of_speech: "động từ",
    meaning:
      "cứu giúp hết thảy mọi người, theo quan niệm của đạo Phật: Phật phổ độ",
    example: "Phật phổ độ",
  },
  {
    word: "phô phang",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) phô ra để khoe (nói khái quát; hàm ý chê): phô phang tài trí",
    example: "phô phang tài trí",
  },
  {
    word: "phố phường",
    part_of_speech: "danh từ",
    meaning:
      "phố và phường (nói khái quát); thường dùng để chỉ nơi thành thị: Hà Nội ba mươi sáu phố phường * phố phường đông đúc",
    example: "Hà Nội ba mươi sáu phố phường * phố phường đông đúc",
  },
  {
    word: "phổ quát",
    part_of_speech: "tính từ",
    meaning:
      "phổ biến một cách rộng khắp, bao trùm tất cả: hiện tượng phổ quát * các phạm trù phổ quát của ngôn ngữ",
    example: "hiện tượng phổ quát * các phạm trù phổ quát của ngôn ngữ",
  },
  {
    word: "phổ thông",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất thông thường, hợp với số đông, không có gì đặc biệt, không thuộc những vấn đề có tính chuyên sâu: kiến thức phổ thông * chương trình phổ thông * công cụ lao động phổ thông",
    example:
      "kiến thức phổ thông * chương trình phổ thông * công cụ lao động phổ thông",
  },
  {
    word: "phổ thông",
    part_of_speech: "động từ",
    meaning:
      '(cũ) như phổ biến: "(...) mấy tờ cáo thị nếu làm bằng chữ quốc ngữ thì ít người đọc được. Phải dịch chữ nho một bên để phổ thông khắp dân gian." (HBChánh; 4)',
    example:
      '(...) mấy tờ cáo thị nếu làm bằng chữ quốc ngữ thì ít người đọc được. Phải dịch chữ nho một bên để phổ thông khắp dân gian." (HBChánh; 4)',
  },
  {
    word: "phổ thông",
    part_of_speech: "danh từ",
    meaning:
      "bậc học gồm tiểu học, trung học cơ sở và trung học phổ thông (từ lớp một đến hết lớp mười hai): học sinh phổ thông",
    example: "học sinh phổ thông",
  },
  {
    word: "phố thị",
    part_of_speech: "danh từ",
    meaning: "(cũ) thành phố, thành thị (nói khái quát): cuộc sống nơi phố thị",
    example: "cuộc sống nơi phố thị",
  },
  {
    word: "phố xá",
    part_of_speech: "danh từ",
    meaning:
      "phố, đường phố (nói khái quát): phố xá đã lên đèn * phố xá nhộn nhịp người qua lại",
    example: "phố xá đã lên đèn * phố xá nhộn nhịp người qua lại",
  },
  {
    word: "phô trương",
    part_of_speech: "động từ",
    meaning:
      "chưng ra, bày ra cho người ta thấy, để lấy tiếng, lấy oai (thường hàm ý chê): phô trương lực lượng * phô trương thanh thế",
    example: "phô trương lực lượng * phô trương thanh thế",
  },
  {
    word: "phổ thông cơ sở",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) cấp học đầu tiên từ lớp một đến lớp chín trong bậc phổ thông mười hai năm: trường phổ thông cơ sở * thi tốt nghiệp phổ thông cơ sở",
    example: "trường phổ thông cơ sở * thi tốt nghiệp phổ thông cơ sở",
  },
  {
    word: "phôi",
    part_of_speech: "danh từ",
    meaning:
      "bán thành phẩm dùng để gia công tiếp và chế tạo thành thành phẩm hoàn chỉnh: phôi in * cấp phôi bằng",
    example: "phôi in * cấp phôi bằng",
  },
  {
    word: "phô-tô-cô-pi",
    part_of_speech: "động từ",
    meaning: "chụp sao lại: photocopy tập tài liệu",
    example: "photocopy tập tài liệu",
  },
  {
    word: "phối cảnh",
    part_of_speech: "danh từ",
    meaning:
      "phương pháp hội hoạ cho phép thể hiện được không gian của đối tượng trên mặt tranh: vẽ phối cảnh * dựng phối cảnh cho các công trình kiến trúc",
    example: "vẽ phối cảnh * dựng phối cảnh cho các công trình kiến trúc",
  },
  {
    word: "phốc",
    part_of_speech: "phụ từ",
    meaning:
      "từ gợi tả dáng vẻ nhanh, gọn và mạnh của một động tác (thường là của chân): đá phốc một cái * nhảy phốc lên xe, phóng mất",
    example: "đá phốc một cái * nhảy phốc lên xe, phóng mất",
  },
  {
    word: "phổi bò",
    part_of_speech: "tính từ",
    meaning:
      '(khẩu ngữ) có tính có gì thì nói ngay hoặc làm liền, không suy nghĩ, đắn đo, không để bụng: tính phổi bò * "Vợ Hoạnh bụng dạ phổi bò lắm. Nói đấy, lại quên ngay đấy." (THoài; 12)',
    example:
      'tính phổi bò * "Vợ Hoạnh bụng dạ phổi bò lắm. Nói đấy, lại quên ngay đấy." (THoài; 12)',
  },
  {
    word: "phổi",
    part_of_speech: "danh từ",
    meaning:
      "cơ quan hô hấp hình túi trong cơ thể của người và động vật bậc cao: lá phổi * bị viêm phổi",
    example: "lá phổi * bị viêm phổi",
  },
  {
    word: "phối",
    part_of_speech: "động từ",
    meaning: "kết hợp tế bào sinh sản đực với tế bào sinh sản cái: phối giống",
    example: "phối giống",
  },
  {
    word: "phối kết hợp",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) phối hợp và kết hợp (nói gộp): cần có sự quan tâm và phối kết hợp giữa các ban ngành",
    example: "cần có sự quan tâm và phối kết hợp giữa các ban ngành",
  },
  {
    word: "phôi pha",
    part_of_speech: "động từ",
    meaning:
      '(văn chương) phai nhạt, mất dần vẻ tươi tắn: "Phũ phàng chi bấy Hoá công!, Ngày xanh mòn mỏi, má hồng phôi pha." (TKiều)',
    example:
      'Phũ phàng chi bấy Hoá công!, Ngày xanh mòn mỏi, má hồng phôi pha." (TKiều)',
  },
  {
    word: "phôi pha",
    part_of_speech: "động từ",
    meaning:
      'phai nhạt đi, không còn thắm thiết, mặn nồng như trước: "Lời chưa dứt, bóng đêm đà vụt biến!, Tình chưa nồng, đã sắp phải phôi pha!" (ChLViên; 2)',
    example:
      'Lời chưa dứt, bóng đêm đà vụt biến!, Tình chưa nồng, đã sắp phải phôi pha!" (ChLViên; 2)',
  },
  {
    word: "phối khí",
    part_of_speech: "động từ",
    meaning: "phối hợp các nhạc cụ khi diễn tấu: nhạc sĩ phối khí",
    example: "nhạc sĩ phối khí",
  },
  {
    word: "phối màu",
    part_of_speech: "động từ",
    meaning:
      "pha trộn các màu khác nhau để tạo ra một màu mới: phương pháp phối màu * cách phối màu khá hài hoà",
    example: "phương pháp phối màu * cách phối màu khá hài hoà",
  },
  {
    word: "phối liệu",
    part_of_speech: "danh từ",
    meaning:
      "nguyên vật liệu dùng để pha trộn vào chất khác theo một tỉ lệ nhất định để sản xuất một sản phẩm nào đó: tỉ lệ phối liệu hợp lí",
    example: "tỉ lệ phối liệu hợp lí",
  },
  {
    word: "phôi thai",
    part_of_speech: "động từ",
    meaning:
      "mới hình thành, mới nảy sinh, còn rất non yếu: đang ở thời kì phôi thai",
    example: "đang ở thời kì phôi thai",
  },
  {
    word: "phối trộn",
    part_of_speech: "động từ",
    meaning:
      "trộn lẫn và kết hợp với nhau theo một tỉ lệ nhất định: phối trộn vật liệu để sản xuất xi măng",
    example: "phối trộn vật liệu để sản xuất xi măng",
  },
  {
    word: "phối thuộc",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) giao hẳn hoặc được giao hẳn cho đơn vị khác trực tiếp chỉ huy và sử dụng trong một thời gian nhất định: đơn vị phối thuộc * dân quân phối thuộc chiến đấu với bộ đội",
    example: "đơn vị phối thuộc * dân quân phối thuộc chiến đấu với bộ đội",
  },
  {
    word: "phối hợp",
    part_of_speech: "động từ",
    meaning:
      "cùng hành động hoặc hoạt động hỗ trợ lẫn nhau: phối hợp hết sức ăn ý * thuỷ binh phối hợp với bộ binh",
    example: "phối hợp hết sức ăn ý * thuỷ binh phối hợp với bộ binh",
  },
  {
    word: "phôm phốp",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) từ gợi tả vẻ béo trắng lồ lộ: trắng phôm phốp * béo phôm phốp",
    example: "trắng phôm phốp * béo phôm phốp",
  },
  {
    word: "phồn thịnh",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái đang phát triển tốt đẹp, ngày một mở mang, sung túc: thời kì phồn thịnh * xây dựng nông thôn phồn thịnh",
    example: "thời kì phồn thịnh * xây dựng nông thôn phồn thịnh",
  },
  {
    word: "phổng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) lớn phổng (nói tắt): mới có mấy tháng mà trông nó đã phổng lên",
    example: "mới có mấy tháng mà trông nó đã phổng lên",
  },
  {
    word: "phổng",
    part_of_speech: "động từ",
    meaning:
      "(mũi) phồng to ra, lộ vẻ sung sướng, hài lòng: được khen, mũi phổng lên",
    example: "được khen, mũi phổng lên",
  },
  {
    word: "phồn hoa",
    part_of_speech: "tính từ",
    meaning:
      '(văn chương) (nơi) có cuộc sống náo nhiệt và giàu có, xa hoa: nơi phồn hoa đô hội * "Người mà đến thế thì thôi, Đời phồn hoa cũng là đời bỏ đi!" (TKiều)',
    example:
      'nơi phồn hoa đô hội * "Người mà đến thế thì thôi, Đời phồn hoa cũng là đời bỏ đi!" (TKiều)',
  },
  {
    word: "phỗng",
    part_of_speech: "danh từ",
    meaning:
      "tượng người bằng đất, đá đặt ở đền chùa, miếu mạo, được coi là người đứng hầu ở nơi thờ cúng: ông phỗng đá * đứng ngây như phỗng",
    example: "ông phỗng đá * đứng ngây như phỗng",
  },
  {
    word: "phỗng",
    part_of_speech: "động từ",
    meaning:
      "ăn con bài đánh hoặc bốc ra ở bất cứ cửa nào khi trong tay mình có được một đôi như thế, trong bài tổ tôm, tài bàn.",
    example: "bị kẻ gian phỗng mất cái ví * phỗng tay trên",
  },
  {
    word: "phồn vinh",
    part_of_speech: "tính từ",
    meaning:
      "giàu có, thịnh vượng, cho thấy rõ là đang phát triển tốt đẹp: xã hội phồn vinh * xây dựng đất nước phồn vinh",
    example: "xã hội phồn vinh * xây dựng đất nước phồn vinh",
  },
  {
    word: "phồn thực",
    part_of_speech: "động từ",
    meaning: "sinh sản để duy trì và phát triển giống nòi: bản năng phồn thực",
    example: "bản năng phồn thực",
  },
  {
    word: "phông",
    part_of_speech: "danh từ",
    meaning: "như nền (ng4): ảnh chân dung chụp trên phông sáng màu",
    example: "ảnh chân dung chụp trên phông sáng màu",
  },
  {
    word: "phông",
    part_of_speech: "danh từ",
    meaning:
      "khung cảnh ở cuối sân khấu, đối diện với người xem, làm nền cho diễn viên biểu diễn.",
    example: "chọn phông",
  },
  {
    word: "phôn",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) telephone (nói tắt); điện thoại: có gì thì phôn ngay nhé! * xin số phôn",
    example: "có gì thì phôn ngay nhé! * xin số phôn",
  },
  {
    word: "phông nền",
    part_of_speech: "danh từ",
    meaning:
      "phần làm nền, có tác dụng làm nổi bật những gì ở trên hoặc trước nó: bức tranh được vẽ trên phông nền màu xanh nhạt",
    example: "bức tranh được vẽ trên phông nền màu xanh nhạt",
  },
  {
    word: "phông chữ",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp hoàn chỉnh các chữ cái, dấu câu, con số và các kí tự đồ hoạ theo một kiểu dáng, kích cỡ phù hợp: phông chữ Unicode * thay đổi phông chữ",
    example: "phông chữ Unicode * thay đổi phông chữ",
  },
  {
    word: "phổng mũi",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tỏ vẻ đắc ý, sung sướng (khiến mũi phồng to ra), khi được khen ngợi: lời khen làm thằng bé phổng mũi",
    example: "lời khen làm thằng bé phổng mũi",
  },
  {
    word: "phồng",
    part_of_speech: "động từ",
    meaning:
      "làm cho hoặc trở nên căng đầy ra và to lên: phồng má thổi quả bóng * hai túi căng phồng",
    example: "phồng má thổi quả bóng * hai túi căng phồng",
  },
  {
    word: "phồng",
    part_of_speech: "động từ",
    meaning:
      "hoặc t (da) rộp lên và thường có nước bên trong, do bị cọ xát nhiều: cuốc đất phồng cả tay",
    example: "cuốc đất phồng cả tay",
  },
  {
    word: "phồng tôm",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) bánh phồng tôm (nói tắt): rán phồng tôm * mua mấy gói phồng tôm",
    example: "rán phồng tôm * mua mấy gói phồng tôm",
  },
  {
    word: "phốp pháp",
    part_of_speech: "tính từ",
    meaning: "to béo, vạm vỡ: dáng người phốp pháp * tay chân phốp pháp",
    example: "dáng người phốp pháp * tay chân phốp pháp",
  },
  {
    word: "phở",
    part_of_speech: "danh từ",
    meaning:
      "món ăn gồm bánh phở thái nhỏ và thịt thái mỏng, chan nước dùng hoặc xào khô: bát phở bốc khói nghi ngút * phở xào",
    example: "bát phở bốc khói nghi ngút * phở xào",
  },
  {
    word: "phơ",
    part_of_speech: "tính từ",
    meaning: "(râu, tóc bạc) trắng một màu: mái tóc bạc phơ",
    example: "mái tóc bạc phơ",
  },
  {
    word: "phốt",
    part_of_speech: "danh từ",
    meaning:
      "(Từ cũ, hoặc kng) sai lầm đã mắc phải: bị phốt * chưa có phốt gì trong lí lịch",
    example: "bị phốt * chưa có phốt gì trong lí lịch",
  },
  {
    word: "phổng phao",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái đang lớn phổng, nở nang, vẻ khoẻ mạnh và đầy sức sống: con bé ngày một phổng phao",
    example: "con bé ngày một phổng phao",
  },
  {
    word: "phờ",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái mệt mỏi, đờ đẫn cả người: mệt phờ * thức đêm phờ cả người * ngồi phờ ra",
    example: "mệt phờ * thức đêm phờ cả người * ngồi phờ ra",
  },
  {
    word: "phơi áo",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bị thua nặng nề một cách quá dễ dàng (thường nói trong thi đấu thể thao): đội chủ nhà bị phơi áo với tỉ số đậm",
    example: "đội chủ nhà bị phơi áo với tỉ số đậm",
  },
  {
    word: "phơi bày",
    part_of_speech: "động từ",
    meaning:
      "để lộ rõ những cái xấu xa ra trước mắt mọi người: bản chất xấu xa đã bị phơi bày",
    example: "bản chất xấu xa đã bị phơi bày",
  },
  {
    word: "phơ phất",
    part_of_speech: "động từ",
    meaning: "(hiếm) như phất phơ: những ngọn lau phơ phất trong gió",
    example: "những ngọn lau phơ phất trong gió",
  },
  {
    word: "phờ phạc",
    part_of_speech: "tính từ",
    meaning:
      "có vẻ ngoài xơ xác, biểu lộ trạng thái hết sức mệt mỏi, cả về thể chất và tinh thần: người phờ phạc vì thiếu ngủ * phờ phạc cả người",
    example: "người phờ phạc vì thiếu ngủ * phờ phạc cả người",
  },
  {
    word: "phới",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) bỏ đi khỏi một cách nhanh chóng: gã Sở Khanh đã phới mất",
    example: "gã Sở Khanh đã phới mất",
  },
  {
    word: "phờ râu",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như phờ (nhưng nghĩa mạnh hơn): mệt phờ râu",
    example: "mệt phờ râu",
  },
  {
    word: "phơi",
    part_of_speech: "động từ",
    meaning:
      "làm cho khô bằng cách trải hoặc giăng ra chỗ nắng, chỗ thoáng: đem quần áo ra phơi * phơi thóc",
    example: "đem quần áo ra phơi * phơi thóc",
  },
  {
    word: "phơi",
    part_of_speech: "động từ",
    meaning:
      "làm cho lộ rõ ra ngoài cho tất cả mọi người cùng thấy: ruột gan có gì cũng phơi ra hết * vụ việc đã bị phơi trần",
    example: "ruột gan có gì cũng phơi ra hết * vụ việc đã bị phơi trần",
  },
  {
    word: "phơi màu",
    part_of_speech: "tính từ",
    meaning:
      "(lúa, ngô) ở giai đoạn mới trỗ, các bao phấn nhị đực mở ra: lúa đã phơi màu",
    example: "lúa đã phơi màu",
  },
  {
    word: "phơi phóng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) phơi cho khô (nói khái quát): rơm rạ phơi phóng đầy sân * phơi phóng quần áo",
    example: "rơm rạ phơi phóng đầy sân * phơi phóng quần áo",
  },
  {
    word: "phơi phới",
    part_of_speech: "tính từ",
    meaning: "ở trạng thái mở rộng, tung bay trước gió: cờ bay phơi phới",
    example: "cờ bay phơi phới",
  },
  {
    word: "phơi phới",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả vẻ vui tươi đầy sức sống của cái gì đang phát triển, đang dâng lên mạnh mẽ: tuổi xuân phơi phới * tâm hồn vui phơi phới",
    example: "tuổi xuân phơi phới * tâm hồn vui phơi phới",
  },
  {
    word: "phớn phở",
    part_of_speech: "tính từ",
    meaning:
      "có vẻ ngoài rạng rỡ, biểu lộ sự vui sướng, hả hê trong lòng: vẻ mặt phớn phở",
    example: "vẻ mặt phớn phở",
  },
  {
    word: "phởn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ở trạng thái vui sướng, hả hê quá mức, thường không kìm nén được và biểu lộ ra bằng những hành động, lời nói ngộ nghĩnh: phởn chí",
    example: "phởn chí",
  },
  {
    word: "phớt đời",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) phớt tất cả, không cần để ý gì đến xung quanh, tỏ vẻ bất cần đời: làm ra vẻ phớt đời",
    example: "làm ra vẻ phớt đời",
  },
  {
    word: "phớt",
    part_of_speech: "động từ",
    meaning:
      "chỉ lướt qua rất nhẹ trên bề mặt: đánh phớt một lớp phấn * hôn phớt lên má",
    example: "đánh phớt một lớp phấn * hôn phớt lên má",
  },
  {
    word: "phớt",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tỏ vẻ lạnh nhạt như không hề để ý, không biết đến: phớt đi như không hề quen biết * ai nói gì cũng phớt",
    example: "phớt đi như không hề quen biết * ai nói gì cũng phớt",
  },
  {
    word: "phớt",
    part_of_speech: "tính từ",
    meaning:
      "(màu) rất nhạt, tựa như chỉ có một lớp màu rất mỏng trên bề mặt: tím phớt * chiếc áo màu phớt hồng",
    example: "tím phớt * chiếc áo màu phớt hồng",
  },
  {
    word: "phơn phớt",
    part_of_speech: "tính từ",
    meaning:
      "(màu) rất nhạt, như chỉ phớt một lớp rất mỏng bên trên: má phơn phớt hồng",
    example: "má phơn phớt hồng",
  },
  {
    word: "phơn phớt",
    part_of_speech: "tính từ",
    meaning: "(Ít dùng) như lớt phớt (ng2): làm phơn phớt rồi bỏ",
    example: "làm phơn phớt rồi bỏ",
  },
  {
    word: "phởn phơ",
    part_of_speech: "tính từ",
    meaning:
      "có vẻ ngoài tươi tỉnh, thoải mái, biểu lộ sự khoan khoái trong lòng: mặt mũi phởn phơ * chè chén phởn phơ",
    example: "mặt mũi phởn phơ * chè chén phởn phơ",
  },
  {
    word: "phơi thây",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) chết nơi chiến trường do bị thua trận, không được chôn cất (hàm ý khinh): phơi thây ngoài chiến trường",
    example: "phơi thây ngoài chiến trường",
  },
  {
    word: "phớt lờ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) phớt hẳn, lờ hẳn đi, không thèm để ý đến: phớt lờ như không nhìn thấy * ai nói gì cũng phớt lờ",
    example: "phớt lờ như không nhìn thấy * ai nói gì cũng phớt lờ",
  },
  {
    word: "phớt lạnh",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) phớt hẳn, với vẻ rất lạnh lùng: bộ mặt phớt lạnh",
    example: "bộ mặt phớt lạnh",
  },
  {
    word: "phớt tỉnh",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) phớt hoàn toàn, mặt thản nhiên như không có gì xảy ra: phớt tỉnh như không hề liên quan",
    example: "phớt tỉnh như không hề liên quan",
  },
  {
    word: "phụ",
    part_of_speech: "động từ",
    meaning:
      'làm trái với điều mình đã hẹn ước, đã thề nguyền, hoặc phản lại công ơn, sự tin cậy của người khác: phụ lời hẹn ước * phụ lòng cha mẹ * "Trách ai tham phú phụ bần, Tham xa mà bỏ nghĩa gần thuở xưa." (ca dao)',
    example:
      'phụ lời hẹn ước * phụ lòng cha mẹ * "Trách ai tham phú phụ bần, Tham xa mà bỏ nghĩa gần thuở xưa." (ca dao)',
  },
  {
    word: "phụ",
    part_of_speech: "tính từ",
    meaning:
      "không quan trọng so với cái chính: đóng vai trò phụ * mặt hàng phụ * diễn viên đóng vai phụ",
    example: "đóng vai trò phụ * mặt hàng phụ * diễn viên đóng vai phụ",
  },
  {
    word: "phụ",
    part_of_speech: "tính từ",
    meaning:
      "có tác dụng giúp thêm, góp phần thêm cho cái chính: làm thêm nghề phụ * diện tích phụ",
    example: "làm thêm nghề phụ * diện tích phụ",
  },
  {
    word: "phụ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) giúp thêm vào một công việc nào đó: phụ thêm một tay cho nhanh",
    example: "phụ thêm một tay cho nhanh",
  },
  {
    word: "phụ",
    part_of_speech: "động từ",
    meaning:
      "(góc hay cung) cộng với một góc hay một cung khác thì thành 90O: hai góc phụ nhau",
    example: "hai góc phụ nhau",
  },
  {
    word: "phu",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người lao động bị bắt đi làm lao dịch thời phong kiến, thực dân: phu làm đường * đi phu",
    example: "phu làm đường * đi phu",
  },
  {
    word: "phu",
    part_of_speech: "danh từ",
    meaning:
      "người lao động chuyên làm những việc nặng nhọc như khuân vác, kéo xe, v.v. để sinh sống dưới thời thực dân (hàm ý coi khinh): phu mỏ * đi phu ở đồn điền cao su * người phu xe",
    example: "phu mỏ * đi phu ở đồn điền cao su * người phu xe",
  },
  {
    word: "phú",
    part_of_speech: "động từ",
    meaning:
      "(tạo hoá) cho sẵn có một tính chất, một khả năng đặc biệt nào đó: sắc đẹp trời phú",
    example: "sắc đẹp trời phú",
  },
  {
    word: "phú",
    part_of_speech: "tính từ",
    meaning:
      '(cũ, hiếm) giàu: "Xưa nay tạo hoá xoay vần, Hết bần lại phú, chẳng cần gì đâu." (ca dao)',
    example:
      'Xưa nay tạo hoá xoay vần, Hết bần lại phú, chẳng cần gì đâu." (ca dao)',
  },
  {
    word: "phù",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng thổi mạnh ở miệng ra: thổi phù ngọn nến * phồng mồm, thở phù một cái",
    example: "thổi phù ngọn nến * phồng mồm, thở phù một cái",
  },
  {
    word: "phủ",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) đơn vị hành chính thời phong kiến, cấp cao hơn huyện, tuy đều trực tiếp dưới tỉnh: quan phủ",
    example: "quan phủ",
  },
  {
    word: "phủ",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) nơi làm việc hoặc nơi ở của quan lại, quý tộc thời phong kiến: phủ chúa * phủ thống sứ",
    example: "phủ chúa * phủ thống sứ",
  },
  {
    word: "phủ",
    part_of_speech: "danh từ",
    meaning:
      "nơi hoặc bộ máy làm việc của một vài cơ quan cao nhất của nhà nước: phủ chủ tịch * phủ tổng thống",
    example: "phủ chủ tịch * phủ tổng thống",
  },
  {
    word: "phủ",
    part_of_speech: "động từ",
    meaning:
      'làm cho kín hoàn toàn bề mặt bằng cách trải một vật có bề rộng lên trên: bị tuyết phủ * "Nhiễu điều phủ lấy giá gương, Người trong một nước thì thương nhau cùng." (ca dao)',
    example:
      'bị tuyết phủ * "Nhiễu điều phủ lấy giá gương, Người trong một nước thì thương nhau cùng." (ca dao)',
  },
  {
    word: "phũ",
    part_of_speech: "tính từ",
    meaning:
      "(lời nói, hành động) lạnh lùng, thô bạo đến mức tàn nhẫn: đánh phũ tay * phũ mồm",
    example: "đánh phũ tay * phũ mồm",
  },
  {
    word: "phụ âm",
    part_of_speech: "danh từ",
    meaning:
      "âm mà khi phát âm luồng hơi từ phổi đi lên qua thanh hầu, gặp phải cản trở đáng kể trước khi thoát ra ngoài; phân biệt với nguyên âm: b, c, d,... là những phụ âm",
    example: "b, c, d,... là những phụ âm",
  },
  {
    word: "phụ bạc",
    part_of_speech: "động từ",
    meaning:
      'đối xử tệ bạc, không kể gì đến tình nghĩa (thường nói về tình nghĩa yêu đương, vợ chồng): sinh lòng phụ bạc * "Vợ anh như thể đĩa xôi, Anh còn phụ bạc nữa tôi cơm đùm." (ca dao)',
    example:
      'sinh lòng phụ bạc * "Vợ anh như thể đĩa xôi, Anh còn phụ bạc nữa tôi cơm đùm." (ca dao)',
  },
  {
    word: "phụ cấp",
    part_of_speech: "động từ",
    meaning:
      "cấp thêm ngoài khoản cấp chính (thường bằng tiền): tiền phụ cấp trách nhiệm",
    example: "tiền phụ cấp trách nhiệm",
  },
  {
    word: "phụ cấp",
    part_of_speech: "danh từ",
    meaning: "khoản tiền cấp thêm ngoài khoản chính: lĩnh phụ cấp",
    example: "lĩnh phụ cấp",
  },
  {
    word: "phù chú",
    part_of_speech: "danh từ",
    meaning:
      "(Từ cũ) lá bùa và câu thần chú, dùng để trừ ma quỷ hoặc làm phép thuật (nói khái quát): dùng phù chú ếm ma quỷ",
    example: "dùng phù chú ếm ma quỷ",
  },
  {
    word: "phụ bản",
    part_of_speech: "danh từ",
    meaning:
      "tài liệu in kèm thêm của một tờ báo hoặc tạp chí: số báo này có kèm phụ bản",
    example: "số báo này có kèm phụ bản",
  },
  {
    word: "phụ cận",
    part_of_speech: "tính từ",
    meaning: "(khu vực) gần sát xung quanh: vùng phụ cận * khu vực phụ cận",
    example: "vùng phụ cận * khu vực phụ cận",
  },
  {
    word: "phụ chú",
    part_of_speech: "danh từ",
    meaning: "(hiếm) lời chú giải thêm: cuối trang sách có mấy dòng phụ chú",
    example: "cuối trang sách có mấy dòng phụ chú",
  },
  {
    word: "phù dung",
    part_of_speech: "danh từ",
    meaning:
      'cây trồng làm cảnh, cùng họ với cây bông, lá hình chân vịt, hoa đẹp nhưng rất chóng tàn, có màu sắc thay đổi theo thời gian (buổi sáng nở thì màu trắng, buổi trưa màu hồng, buổi chiều sắp tàn thì màu đỏ); văn học cổ thường dùng để ví người con gái đẹp: "Bạc tình nổi tiếng lầu xanh, Một tay chôn biết mấy cành phù dung!" (TKiều)',
    example:
      'Bạc tình nổi tiếng lầu xanh, Một tay chôn biết mấy cành phù dung!" (TKiều)',
  },
  {
    word: "phủ doãn",
    part_of_speech: "danh từ",
    meaning: "(cũ) chức quan đứng đầu tỉnh, nơi có đặt kinh đô: quan phủ doãn",
    example: "quan phủ doãn",
  },
  {
    word: "phụ đề",
    part_of_speech: "danh từ",
    meaning:
      "dòng chữ đề phía dưới màn ảnh dùng để ghi lời thoại đang phát trong phim, hoặc dùng để dịch lời thoại sang ngôn ngữ khác: phim có phụ đề tiếng Việt",
    example: "phim có phụ đề tiếng Việt",
  },
  {
    word: "phủ đầu",
    part_of_speech: "động từ",
    meaning:
      "áp đảo tinh thần ngay từ đầu để giành thế chủ động, khi đối phương còn chưa kịp chuẩn bị: đòn phủ đầu * đánh một trận phủ đầu",
    example: "đòn phủ đầu * đánh một trận phủ đầu",
  },
  {
    word: "phủ định",
    part_of_speech: "",
    meaning:
      "bác bỏ sự tồn tại, sự cần thiết của cái gì: câu phủ định * cái mới phủ định cái cũ",
    example: "câu phủ định * cái mới phủ định cái cũ",
  },
  {
    word: "phụ đạo",
    part_of_speech: "động từ",
    meaning:
      "giảng thêm ngoài giờ lên lớp, giúp cho học sinh hiểu thêm bài: đi học phụ đạo * tìm giáo viên dạy phụ đạo cho con",
    example: "đi học phụ đạo * tìm giáo viên dạy phụ đạo cho con",
  },
  {
    word: "phụ gia",
    part_of_speech: "động từ",
    meaning: "thêm vào, với tư cách một thành phần phụ: chất phụ gia",
    example: "chất phụ gia",
  },
  {
    word: "phụ gia",
    part_of_speech: "danh từ",
    meaning: "chất được dùng để thêm vào: sản xuất phụ gia",
    example: "sản xuất phụ gia",
  },
  {
    word: "phù hiệu",
    part_of_speech: "danh từ",
    meaning:
      "dấu hiệu quy định để chỉ tổ chức, đơn vị, v.v.: phù hiệu của quân chủng hải quân có hình chiếc mỏ neo",
    example: "phù hiệu của quân chủng hải quân có hình chiếc mỏ neo",
  },
  {
    word: "phù hoa",
    part_of_speech: "tính từ",
    meaning:
      "(văn chương, hiếm) có cái vẻ đẹp phô trương bề ngoài: ánh sáng phù hoa * phù hoa giả, phong lưu mượn (tng)",
    example: "ánh sáng phù hoa * phù hoa giả, phong lưu mượn (tng)",
  },
  {
    word: "phụ giảng",
    part_of_speech: "động từ",
    meaning:
      "giảng dạy giúp thêm cho giảng viên chính ở trường đại học: đi phụ giảng ở trường đại học",
    example: "đi phụ giảng ở trường đại học",
  },
  {
    word: "phụ giảng",
    part_of_speech: "danh từ",
    meaning:
      "giảng viên phụ giúp việc giảng dạy thêm ở các trường đại học: một phụ giảng giỏi",
    example: "một phụ giảng giỏi",
  },
  {
    word: "phụ giúp",
    part_of_speech: "động từ",
    meaning: "giúp thêm vào: đi làm thêm để phụ giúp gia đình",
    example: "đi làm thêm để phụ giúp gia đình",
  },
  {
    word: "phụ hoạ",
    part_of_speech: "động từ",
    meaning:
      "hùa theo, hưởng ứng theo một cách dễ dãi, thường không có suy nghĩ: chưa hiểu gì mà cũng phụ hoạ",
    example: "chưa hiểu gì mà cũng phụ hoạ",
  },
  {
    word: "phụ hoạ",
    part_of_speech: "động từ",
    meaning: "phụ thêm vào để làm cho rõ hơn, nổi bật hơn: màn múa phụ hoạ",
    example: "màn múa phụ hoạ",
  },
  {
    word: "phụ huynh",
    part_of_speech: "danh từ",
    meaning:
      "cha mẹ hoặc người thay mặt, đại diện cho gia đình học sinh trong quan hệ với nhà trường: trưởng ban phụ huynh * họp phụ huynh học sinh",
    example: "trưởng ban phụ huynh * họp phụ huynh học sinh",
  },
  {
    word: "phù hợp",
    part_of_speech: "động từ",
    meaning:
      "hợp với nhau, ăn khớp với nhau: nội dung và hình thức phù hợp nhau * chọn được người chồng phù hợp",
    example:
      "nội dung và hình thức phù hợp nhau * chọn được người chồng phù hợp",
  },
  {
    word: "phụ lão",
    part_of_speech: "danh từ",
    meaning: "người cao tuổi, người già, nói chung: các cụ phụ lão",
    example: "các cụ phụ lão",
  },
  {
    word: "phú hộ",
    part_of_speech: "danh từ",
    meaning: "(cũ) nhà giàu: lão phú hộ",
    example: "lão phú hộ",
  },
  {
    word: "phụ kiện",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận hoặc chi tiết phụ nhưng cần thiết để đảm bảo cho máy móc, thiết bị hoạt động bình thường: thay thế các phụ kiện",
    example: "thay thế các phụ kiện",
  },
  {
    word: "phụ liệu",
    part_of_speech: "danh từ",
    meaning:
      "vật liệu phụ để làm nên sản phẩm: sản xuất bị đình trệ vì thiếu phụ liệu",
    example: "sản xuất bị đình trệ vì thiếu phụ liệu",
  },
  {
    word: "phù hộ",
    part_of_speech: "động từ",
    meaning: "(lực lượng siêu nhiên) che chở, giúp đỡ: nhờ trời phù hộ",
    example: "nhờ trời phù hộ",
  },
  {
    word: "phụ lục",
    part_of_speech: "danh từ",
    meaning:
      "phần tài liệu kèm thêm để bổ sung cho nội dung của tài liệu chính: quyển sách có nhiều phụ lục rất bổ ích",
    example: "quyển sách có nhiều phụ lục rất bổ ích",
  },
  {
    word: "phù nề",
    part_of_speech: "",
    meaning: "phù (nói khái quát): toàn thân bị phù nề",
    example: "toàn thân bị phù nề",
  },
  {
    word: "phu nhân",
    part_of_speech: "danh từ",
    meaning:
      "(trang trọng) từ dùng để gọi vợ của người có địa vị cao trong xã hội: phu nhân tổng thống",
    example: "phu nhân tổng thống",
  },
  {
    word: "phú ông",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người đàn ông giàu có ở nông thôn thời trước: trở nên bậc phú ông",
    example: "trở nên bậc phú ông",
  },
  {
    word: "phụ mẫu",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, trang trọng) cha mẹ: "Viết thư thăm hết nội nhà, Trước thăm phụ mẫu sau là thăm em." (ca dao)',
    example:
      'Viết thư thăm hết nội nhà, Trước thăm phụ mẫu sau là thăm em." (ca dao)',
  },
  {
    word: "phụ nữ",
    part_of_speech: "danh từ",
    meaning: "người lớn thuộc nữ giới: ngày quốc tế phụ nữ",
    example: "ngày quốc tế phụ nữ",
  },
  {
    word: "phũ phàng",
    part_of_speech: "tính từ",
    meaning:
      'tàn nhẫn, gây đau khổ mà không hề có một chút thương cảm: bị đánh đập phũ phàng * "Phũ phàng chi bấy Hoá công!, Ngày xanh mòn mỏi, má hồng phôi pha." (TKiều)',
    example:
      'bị đánh đập phũ phàng * "Phũ phàng chi bấy Hoá công!, Ngày xanh mòn mỏi, má hồng phôi pha." (TKiều)',
  },
  {
    word: "phù phép",
    part_of_speech: "",
    meaning:
      "dùng phép thuật sai khiến quỷ thần, hoặc làm những điều kì lạ: phù phép trừ tà * không tin vào phù phép",
    example: "phù phép trừ tà * không tin vào phù phép",
  },
  {
    word: "phủ nhận",
    part_of_speech: "động từ",
    meaning:
      "không thừa nhận là đúng, là có thật: phủ nhận sạch trơn * một sự thật không thể phủ nhận",
    example: "phủ nhận sạch trơn * một sự thật không thể phủ nhận",
  },
  {
    word: "phụ phí",
    part_of_speech: "danh từ",
    meaning: "chi phí phải trả thêm ngoài chi phí chính: phụ phí vận chuyển",
    example: "phụ phí vận chuyển",
  },
  {
    word: "phụ phẩm",
    part_of_speech: "danh từ",
    meaning: "sản phẩm phụ: phụ phẩm nông nghiệp",
    example: "phụ phẩm nông nghiệp",
  },
  {
    word: "phủ phê",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) đầy đủ, thoả thuê, đến mức như thừa thãi: cuộc sống sung túc phủ phê",
    example: "cuộc sống sung túc phủ phê",
  },
  {
    word: "phù phiếm",
    part_of_speech: "tính từ",
    meaning:
      "viển vông, không thiết thực, không thực tế: lối văn chương phù phiếm * chuyện phù phiếm",
    example: "lối văn chương phù phiếm * chuyện phù phiếm",
  },
  {
    word: "phu phụ",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) vợ chồng: "Mình về tôi cũng về theo, Sum vầy phu phụ, giàu nghèo có nhau." (ca dao)',
    example:
      'Mình về tôi cũng về theo, Sum vầy phu phụ, giàu nghèo có nhau." (ca dao)',
  },
  {
    word: "phu phen",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) phu, người làm lao dịch (nói khái quát): phu phen thợ thuyền",
    example: "phu phen thợ thuyền",
  },
  {
    word: "phú quý",
    part_of_speech: "tính từ",
    meaning: "giàu có và sang trọng: phú quý sinh lễ nghĩa * giàu sang phú quý",
    example: "phú quý sinh lễ nghĩa * giàu sang phú quý",
  },
  {
    word: "phu quý phụ vinh",
    part_of_speech: "",
    meaning:
      'chồng được phú quý, sang trọng thì vợ cũng được vinh hiển, danh giá: "Ngỡ là phu quý phụ vinh, Ai ngờ một phút tan tành thịt xương!" (TKiều)',
    example: "Ngỡ là phu quý phụ vinh, Ai ngờ một phút tan tành thịt xương!",
  },
  {
    word: "phủ phục",
    part_of_speech: "động từ",
    meaning:
      "quỳ và cúi đầu xuống sát đất: con voi nằm phủ phục * phủ phục trước bàn thờ",
    example: "con voi nằm phủ phục * phủ phục trước bàn thờ",
  },
  {
    word: "phủ quyết",
    part_of_speech: "động từ",
    meaning:
      "dùng quyền đặc biệt để bác bỏ quyết nghị của đa số: hạ nghị viện đã phủ quyết ứng cử viên thủ tướng",
    example: "hạ nghị viện đã phủ quyết ứng cử viên thủ tướng",
  },
  {
    word: "phụ sản",
    part_of_speech: "danh từ",
    meaning:
      "phụ khoa và sản khoa (nói gộp): bệnh viện phụ sản * bác sĩ phụ sản * chuyên khoa phụ sản",
    example: "bệnh viện phụ sản * bác sĩ phụ sản * chuyên khoa phụ sản",
  },
  {
    word: "phù sa",
    part_of_speech: "danh từ",
    meaning:
      "đất, cát mịn và có nhiều chất màu được cuốn trôi theo dòng nước hoặc lắng đọng lại ở bờ sông, bãi bồi: dòng sông đục ngầu phù sa * được phù sa bồi đắp",
    example: "dòng sông đục ngầu phù sa * được phù sa bồi đắp",
  },
  {
    word: "phủ sóng",
    part_of_speech: "động từ",
    meaning:
      "phát sóng điện từ bao phủ trong một phạm vi nào đó để các thiết bị thu trong vùng có thể thu được: thuê bao đang ngoài vùng phủ sóng",
    example: "thuê bao đang ngoài vùng phủ sóng",
  },
  {
    word: "phụ san",
    part_of_speech: "danh từ",
    meaning:
      "ấn phẩm phụ của một tờ báo, thường được xuất bản khi số báo không đăng tải hết nội dung: tờ phụ san",
    example: "tờ phụ san",
  },
  {
    word: "phụ tá",
    part_of_speech: "danh từ",
    meaning: "như trợ lí: phụ tá của tổng thống",
    example: "phụ tá của tổng thống",
  },
  {
    word: "phu thê",
    part_of_speech: "danh từ",
    meaning: "(cũ) vợ chồng: đạo phu thê",
    example: "đạo phu thê",
  },
  {
    word: "phù sinh",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) đời người coi là vô định và ngắn ngủi không có nghĩa lí gì, theo quan niệm bi quan: kiếp phù sinh * "Phù sinh thôi thế thì thôi, Dẫu thân chuộc lại cũng đời bỏ đi." (TTK)',
    example:
      'kiếp phù sinh * "Phù sinh thôi thế thì thôi, Dẫu thân chuộc lại cũng đời bỏ đi." (TTK)',
  },
  {
    word: "phù thế",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) như phù sinh: "Nghĩ thân phù thế mà đau, Bọt trong bể khổ, bèo đầu bến mê." (CO)',
    example:
      'Nghĩ thân phù thế mà đau, Bọt trong bể khổ, bèo đầu bến mê." (CO)',
  },
  {
    word: "phụ thu",
    part_of_speech: "",
    meaning: "thu thêm vào ngoài phần thu chính: thuế phụ thu * khoản phụ thu",
    example: "thuế phụ thu * khoản phụ thu",
  },
  {
    word: "phụ thuộc",
    part_of_speech: "động từ",
    meaning:
      "chịu sự ràng buộc, chi phối của cái khác, không thể tồn tại, phát triển nếu thiếu tác động nhất định của cái khác: sống phụ thuộc vào gia đình * cây cỏ phụ thuộc vào thời tiết * nước phụ thuộc",
    example:
      "sống phụ thuộc vào gia đình * cây cỏ phụ thuộc vào thời tiết * nước phụ thuộc",
  },
  {
    word: "phù thuỷ",
    part_of_speech: "danh từ",
    meaning:
      "người có phép thuật, sai khiến được quỷ thần, thường dùng bùa chú để trừ tà, chữa bệnh hoặc làm các việc kì lạ khác, theo mê tín: thầy phù thuỷ",
    example: "thầy phù thuỷ",
  },
  {
    word: "phù thuỷ",
    part_of_speech: "danh từ",
    meaning:
      "nhân vật tưởng tượng trong truyện cổ tích, có nhiều phép lạ, thường rất độc ác và hay làm hại người: mụ phù thuỷ độc ác",
    example: "mụ phù thuỷ độc ác",
  },
  {
    word: "phụ trách",
    part_of_speech: "động từ",
    meaning:
      "đảm nhận và chịu trách nhiệm về những công việc cụ thể nào đó: phụ trách bộ phận kinh doanh * phụ trách sản xuất",
    example: "phụ trách bộ phận kinh doanh * phụ trách sản xuất",
  },
  {
    word: "phụ trách",
    part_of_speech: "động từ",
    meaning:
      "đảm nhận và chịu trách nhiệm về công tác thiếu niên, nhi đồng: cán bộ phụ trách Đội * chị phụ trách",
    example: "cán bộ phụ trách Đội * chị phụ trách",
  },
  {
    word: "phù trì",
    part_of_speech: "động từ",
    meaning: "(cũ) giúp đỡ, che chở: được trời Phật phù trì",
    example: "được trời Phật phù trì",
  },
  {
    word: "phụ tố",
    part_of_speech: "danh từ",
    meaning:
      "(ngữ pháp) bộ phận của từ, mang ý nghĩa ngữ pháp, được ghép vào căn tố để cấu tạo từ mới hoặc cấu tạo dạng thức của từ: 'hoá' trong 'hiện đại hoá' là một phụ tố trong tiếng Việt.",
    example: "hoá' trong 'hiện đại hoá' là một phụ tố trong tiếng Việt.",
  },
  {
    word: "phụ tình",
    part_of_speech: "động từ",
    meaning: "(hiếm) như phụ bạc: kẻ phụ tình",
    example: "kẻ phụ tình",
  },
  {
    word: "phụ trội",
    part_of_speech: "động từ",
    meaning: "tăng thêm một lượng ngoài mức quy định: cước điện thoại phụ trội",
    example: "cước điện thoại phụ trội",
  },
  {
    word: "phù trợ",
    part_of_speech: "động từ",
    meaning: "(hiếm) như phù hộ: số có quý nhân phù trợ",
    example: "số có quý nhân phù trợ",
  },
  {
    word: "phù trợ",
    part_of_speech: "động từ",
    meaning: "như phụ trợ: tác dụng phù trợ",
    example: "tác dụng phù trợ",
  },
  {
    word: "phụ trợ",
    part_of_speech: "động từ",
    meaning: "giúp thêm, phụ thêm vào cái chính: môn học phụ trợ",
    example: "môn học phụ trợ",
  },
  {
    word: "phụ trương",
    part_of_speech: "danh từ",
    meaning:
      "phần in riêng phụ thêm ngoài số trang thường lệ của báo hoặc tạp chí: phụ trương của số báo Tết",
    example: "phụ trương của số báo Tết",
  },
  {
    word: "phụ từ",
    part_of_speech: "danh từ",
    meaning:
      "(ngữ pháp) từ chuyên bổ túc nghĩa cho một động từ, tính từ hoặc một phụ từ khác: 'sẽ', 'đã', 'đang', 'rất', 'lắm' là một số phụ từ trong tiếng Việt.",
    example:
      "'sẽ', 'đã', 'đang', 'rất', 'lắm' là một số phụ từ trong tiếng Việt.",
  },
  {
    word: "phụ tùng",
    part_of_speech: "danh từ",
    meaning: "chi tiết máy có thể thay thế được khi hỏng: thay phụ tùng xe đạp",
    example: "thay phụ tùng xe đạp",
  },
  {
    word: "phù vân",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) đám mây thoáng nổi lên rồi tan ngay, thường dùng để ví cái không lâu bền, có được rồi lại mất ngay: của phù vân * "Cuộc đời như áng phù vân, Lại nhiều nghiệp chướng, trầm luân mê đồi." (PTNH)',
    example:
      'của phù vân * "Cuộc đời như áng phù vân, Lại nhiều nghiệp chướng, trầm luân mê đồi." (PTNH)',
  },
  {
    word: "phụ tử",
    part_of_speech: "danh từ",
    meaning: "(cũ, văn chương) cha con: tình phụ tử",
    example: "tình phụ tử",
  },
  {
    word: "phù voi",
    part_of_speech: "danh từ",
    meaning:
      "bệnh do một loại giun chỉ gây ra, thường làm da thịt phù lên rất to và nứt ra, gây đau đớn: chân bị phù voi",
    example: "chân bị phù voi",
  },
  {
    word: "phụ vương",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, trang trọng) từ con vua dùng để gọi cha, tỏ ý tôn kính: muôn tâu phụ vương",
    example: "muôn tâu phụ vương",
  },
  {
    word: "phục chế",
    part_of_speech: "động từ",
    meaning:
      "làm lại cho đúng hình dáng ban đầu của hiện vật: phục chế cổ vật * phục chế ảnh",
    example: "phục chế cổ vật * phục chế ảnh",
  },
  {
    word: "phục",
    part_of_speech: "động từ",
    meaning:
      'cúi gập người xuống sát đất: phục xuống lạy * "Đạo nhân phục trước tĩnh đàn, Xuất thần giây phút chưa tàn nén hương." (TKiều)',
    example:
      'phục xuống lạy * "Đạo nhân phục trước tĩnh đàn, Xuất thần giây phút chưa tàn nén hương." (TKiều)',
  },
  {
    word: "phục",
    part_of_speech: "động từ",
    meaning:
      "ẩn nấp sẵn để chờ thời cơ hành động: phục binh * phục sẵn để đón bắt",
    example: "phục binh * phục sẵn để đón bắt",
  },
  {
    word: "phục",
    part_of_speech: "động từ",
    meaning:
      "cho là tài, giỏi, là đáng tôn trọng: phục tài * phục sát đất * tâm phục khẩu phục",
    example: "phục tài * phục sát đất * tâm phục khẩu phục",
  },
  {
    word: "phúc âm",
    part_of_speech: "",
    meaning: "(cũ, trang trọng) như hồi âm: gửi thư nhưng chưa thấy phúc âm",
    example: "gửi thư nhưng chưa thấy phúc âm",
  },
  {
    word: "phúc",
    part_of_speech: "danh từ",
    meaning:
      "điều may lớn, điều mang lại những sự tốt lành lớn: nhà có phúc * phúc bảy mươi đời nhà nó! (kng; phúc rất lớn)",
    example: "nhà có phúc * phúc bảy mươi đời nhà nó! (kng; phúc rất lớn)",
  },
  {
    word: "phúc",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) may mắn: thật phúc quá! * được như vậy là phúc lắm rồi!",
    example: "thật phúc quá! * được như vậy là phúc lắm rồi!",
  },
  {
    word: "phúc ấm",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) phúc đức của tổ tiên để lại cho con cháu: phúc ấm của tổ tiên",
    example: "phúc ấm của tổ tiên",
  },
  {
    word: "phục dịch",
    part_of_speech: "động từ",
    meaning:
      "làm công việc chân tay vất vả để phục vụ người khác (thường là chủ hoặc người bề trên): phục dịch thuốc thang cho người ốm * người phục dịch",
    example: "phục dịch thuốc thang cho người ốm * người phục dịch",
  },
  {
    word: "phục cổ",
    part_of_speech: "động từ",
    meaning: "khôi phục lại cái cũ, cái đã lỗi thời: khuynh hướng phục cổ",
    example: "khuynh hướng phục cổ",
  },
  {
    word: "phục dựng",
    part_of_speech: "động từ",
    meaning:
      "khôi phục và dàn dựng lại cho giống như thật (nói khái quát): phục dựng lễ tế Nam Giao",
    example: "phục dựng lễ tế Nam Giao",
  },
  {
    word: "phúc đức",
    part_of_speech: "danh từ",
    meaning:
      "điều tốt lành để lại cho con cháu do ăn ở tốt, theo quan niệm truyền thống: nhờ phúc đức tổ tiên để lại mà tai qua nạn khỏi",
    example: "nhờ phúc đức tổ tiên để lại mà tai qua nạn khỏi",
  },
  {
    word: "phúc đức",
    part_of_speech: "tính từ",
    meaning:
      "hay làm những điều tốt lành cho người khác (thường với hi vọng để cái phúc lại cho con cháu): một bà lão nhân hậu, phúc đức * ăn ở có phúc đức",
    example: "một bà lão nhân hậu, phúc đức * ăn ở có phúc đức",
  },
  {
    word: "phúc đức",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) may mắn, tốt lành lắm: thật là phúc đức quá!",
    example: "thật là phúc đức quá!",
  },
  {
    word: "phục hưng",
    part_of_speech: "động từ",
    meaning:
      "làm cho cái đã bị suy tàn hưng thịnh trở lại: phục hưng nền văn hoá cổ * thời kì phục hưng",
    example: "phục hưng nền văn hoá cổ * thời kì phục hưng",
  },
  {
    word: "phục hoá",
    part_of_speech: "động từ",
    meaning:
      "canh tác, trồng trọt trở lại ở những ruộng đất trước đây bỏ hoang: công cuộc khai hoang phục hoá",
    example: "công cuộc khai hoang phục hoá",
  },
  {
    word: "phục hồi",
    part_of_speech: "động từ",
    meaning:
      "khôi phục cái đã mất đi hoặc đã giảm sút đi: phục hồi chức năng * sức khoẻ chưa phục hồi",
    example: "phục hồi chức năng * sức khoẻ chưa phục hồi",
  },
  {
    word: "phúc hậu",
    part_of_speech: "tính từ",
    meaning:
      "có tấm lòng nhân hậu (thường được biểu hiện rõ trên khuôn mặt): ăn ở phúc hậu * khuôn mặt phúc hậu",
    example: "ăn ở phúc hậu * khuôn mặt phúc hậu",
  },
  {
    word: "phúc đáp",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) trả lời bằng thư từ, công văn: gửi công văn phúc đáp * thư phúc đáp",
    example: "gửi công văn phúc đáp * thư phúc đáp",
  },
  {
    word: "phúc khảo",
    part_of_speech: "động từ",
    meaning:
      "(cũ) chấm lại sau khi đã sơ khảo trong các khoa thi thời phong kiến.",
    example: "gửi đơn xin phúc khảo lại bài thi",
  },
  {
    word: "phục kích",
    part_of_speech: "động từ",
    meaning:
      "bí mật bố trí sẵn lực lượng tại một địa điểm, đợi khi đối phương đi qua để đánh úp: rơi vào ổ phục kích * bị phục kích ngang đường",
    example: "rơi vào ổ phục kích * bị phục kích ngang đường",
  },
  {
    word: "phúc lợi",
    part_of_speech: "danh từ",
    meaning:
      "lợi ích mà mọi người có thể được hưởng không phải trả tiền hoặc chỉ phải trả một phần: xây dựng quỹ phúc lợi * các công trình phúc lợi",
    example: "xây dựng quỹ phúc lợi * các công trình phúc lợi",
  },
  {
    word: "phúc kiểm",
    part_of_speech: "động từ",
    meaning:
      "(cơ quan chức năng) kiểm tra lại: phúc kiểm toàn bộ chất lượng lô hàng cá đông lạnh * hạt phúc kiểm lâm sản",
    example:
      "phúc kiểm toàn bộ chất lượng lô hàng cá đông lạnh * hạt phúc kiểm lâm sản",
  },
  {
    word: "phục lăn",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) rất phục, phục hết mức: tài nghệ của ông ta khiến mọi người phải phục lăn",
    example: "tài nghệ của ông ta khiến mọi người phải phục lăn",
  },
  {
    word: "phúc mạc",
    part_of_speech: "danh từ",
    meaning: "màng bụng: viêm phúc mạc",
    example: "viêm phúc mạc",
  },
  {
    word: "phục sức",
    part_of_speech: "động từ",
    meaning: "ăn mặc và trang sức theo lối riêng nào đó: phục sức cho cô dâu",
    example: "phục sức cho cô dâu",
  },
  {
    word: "phúc thẩm",
    part_of_speech: "động từ",
    meaning:
      "(toà án cấp trên) xét xử lại một vụ án do cấp dưới đã xử sơ thẩm mà có chống án: toà phúc thẩm y án",
    example: "toà phúc thẩm y án",
  },
  {
    word: "phục phịch",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả dáng vẻ béo quá, đến mức trông nặng nề, vận động khó khăn: béo phục phịch",
    example: "béo phục phịch",
  },
  {
    word: "phúc phận",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) điều tốt lành được hưởng, theo quan niệm cũ: được như vậy cũng là nhờ vào phúc phận",
    example: "được như vậy cũng là nhờ vào phúc phận",
  },
  {
    word: "phục sinh",
    part_of_speech: "động từ",
    meaning: "(hiếm) sống lại: lễ phục sinh * Đức Chúa phục sinh",
    example: "lễ phục sinh * Đức Chúa phục sinh",
  },
  {
    word: "phục quốc",
    part_of_speech: "động từ",
    meaning:
      "(cũ) khôi phục nền độc lập của đất nước, giành lại độc lập: báo thù phục quốc",
    example: "báo thù phục quốc",
  },
  {
    word: "phục thiện",
    part_of_speech: "động từ",
    meaning:
      "chịu nghe theo lẽ phải (thường sau khi mắc sai lầm): tư tưởng phục thiện",
    example: "tư tưởng phục thiện",
  },
  {
    word: "phục nguyên",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) khôi phục lại trạng thái vốn có của một sự vật đã mất đi, dựa trên những dấu vết còn để lại: phục nguyên pho tượng cổ",
    example: "phục nguyên pho tượng cổ",
  },
  {
    word: "phục thù",
    part_of_speech: "động từ",
    meaning: "trả mối thù lớn, mối thù sâu nặng: nuôi ý chí phục thù",
    example: "nuôi ý chí phục thù",
  },
  {
    word: "phúc trình",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) trình bày để cấp trên biết: phúc trình lên thủ tướng",
    example: "phúc trình lên thủ tướng",
  },
  {
    word: "phục tùng",
    part_of_speech: "động từ",
    meaning: "tuân theo, không làm trái lại: phục tùng mệnh lệnh",
    example: "phục tùng mệnh lệnh",
  },
  {
    word: "phúc tra",
    part_of_speech: "động từ",
    meaning:
      "xem xét, kiểm tra lại, thường bằng phương pháp khác và do người khác tiến hành: làm đơn xin phúc tra lại điểm thi đại học",
    example: "làm đơn xin phúc tra lại điểm thi đại học",
  },
  {
    word: "phục trang",
    part_of_speech: "danh từ",
    meaning:
      "quần áo và đồ trang sức của diễn viên khi đóng vai (nói khái quát): thay đổi phục trang",
    example: "thay đổi phục trang",
  },
  {
    word: "phục vụ",
    part_of_speech: "động từ",
    meaning:
      "làm phần việc thuộc trách nhiệm của mình, vì lợi ích chung (nói khái quát): hết lòng phục vụ nhân dân",
    example: "hết lòng phục vụ nhân dân",
  },
  {
    word: "phục vụ",
    part_of_speech: "động từ",
    meaning:
      "làm việc nhằm giúp ích trực tiếp cho cái gì (nói khái quát): phục vụ sản xuất",
    example: "phục vụ sản xuất",
  },
  {
    word: "phục vụ",
    part_of_speech: "động từ",
    meaning:
      "làm công việc giúp ích trực tiếp cho sinh hoạt vật chất hoặc văn hoá của người khác: phục vụ bệnh nhân * thư viện mở cửa phục vụ bạn đọc",
    example: "phục vụ bệnh nhân * thư viện mở cửa phục vụ bạn đọc",
  },
  {
    word: "phục viên",
    part_of_speech: "động từ",
    meaning:
      "(quân nhân) trở về địa phương sau khi đã hết hạn phục vụ trong quân đội: bộ đội phục viên",
    example: "bộ đội phục viên",
  },
  {
    word: "phủi",
    part_of_speech: "động từ",
    meaning:
      "gạt nhẹ cho rơi hết bụi bẩn: phủi đất trên quần * phủi bụi trên bàn",
    example: "phủi đất trên quần * phủi bụi trên bàn",
  },
  {
    word: "phủi",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) gạt bỏ, không nhận trách nhiệm: phủi trách nhiệm * phủi hết mọi tội lỗi",
    example: "phủi trách nhiệm * phủi hết mọi tội lỗi",
  },
  {
    word: "phun",
    part_of_speech: "động từ",
    meaning:
      "làm cho chất lỏng hoặc chất hơi bị đẩy mạnh ra ngoài thành tia qua lỗ hẹp: phun thuốc trừ sâu * máu phun ra từ vết thương * ngậm máu phun người (tng)",
    example:
      "phun thuốc trừ sâu * máu phun ra từ vết thương * ngậm máu phun người (tng)",
  },
  {
    word: "phun",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nói ra (thường hàm ý khinh): chưa hỏi đến đã phun ra hết",
    example: "chưa hỏi đến đã phun ra hết",
  },
  {
    word: "phủi tay",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) coi như mình không có một chút trách nhiệm nào cả (trước việc không hay do chính mình gây ra): đã làm rồi, giờ định phủi tay sao?",
    example: "đã làm rồi, giờ định phủi tay sao?",
  },
  {
    word: "phun châu nhả ngọc",
    part_of_speech: "",
    meaning:
      '(cũ, văn chương) như nhả ngọc phun châu: "Phun châu nhả ngọc đua tài, Giải nguyên tên đã dự bài bốn ngay." (PT)',
    example:
      'Phun châu nhả ngọc đua tài, Giải nguyên tên đã dự bài bốn ngay." (PT)',
  },
  {
    word: "phụng",
    part_of_speech: "danh từ",
    meaning: "(Nam cũng phụng) phượng hoàng (nói tắt): nem công chả phượng",
    example: "nem công chả phượng",
  },
  {
    word: "phụng",
    part_of_speech: "danh từ",
    meaning:
      "cây thuộc họ đậu, có nhiều loại, lá kép lông chim, hoa mọc thành chùm, màu đỏ hoặc vàng, thường nở vào mùa hè, được trồng để lấy bóng mát hoặc làm cảnh: hoa phượng đỏ",
    example: "hoa phượng đỏ",
  },
  {
    word: "phùn phụt",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả âm thanh vang liên tiếp, thường do nước, hơi phụt ra thành từng luồng mạnh: dòng nước bắn ra phùn phụt * lửa phùn phụt bốc lên",
    example: "dòng nước bắn ra phùn phụt * lửa phùn phụt bốc lên",
  },
  {
    word: "phúng",
    part_of_speech: "động từ",
    meaning: "đem lễ đến viếng người chết: tiền phúng đám ma * đi phúng",
    example: "tiền phúng đám ma * đi phúng",
  },
  {
    word: "phụng chỉ",
    part_of_speech: "động từ",
    meaning:
      "(cũ, trang trọng) vâng lệnh vua: phụng chỉ vua đem quân đi dẹp giặc",
    example: "phụng chỉ vua đem quân đi dẹp giặc",
  },
  {
    word: "phụng mệnh",
    part_of_speech: "động từ",
    meaning: "(cũ, trang trọng) tuân lệnh: phụng mệnh triều đình",
    example: "phụng mệnh triều đình",
  },
  {
    word: "phụng dưỡng",
    part_of_speech: "động từ",
    meaning: "chăm sóc và nuôi dưỡng với lòng thành kính: phụng dưỡng cha mẹ",
    example: "phụng dưỡng cha mẹ",
  },
  {
    word: "phúng điếu",
    part_of_speech: "động từ",
    meaning: "như phúng viếng: mua vòng hoa tới phúng điếu",
    example: "mua vòng hoa tới phúng điếu",
  },
  {
    word: "phúng dụ",
    part_of_speech: "danh từ",
    meaning:
      "sự diễn đạt tư tưởng, khái niệm trừu tượng bằng ngụ ý thông qua những hình ảnh cụ thể (một phương thức tu từ): thơ ngụ ngôn thường sử dụng phúng dụ",
    example: "thơ ngụ ngôn thường sử dụng phúng dụ",
  },
  {
    word: "phung phá",
    part_of_speech: "động từ",
    meaning: "như phung phí: ăn tiêu phung phá",
    example: "ăn tiêu phung phá",
  },
  {
    word: "phụng phịu",
    part_of_speech: "động từ",
    meaning:
      "từ gợi tả vẻ mặt xị xuống tỏ ý hờn dỗi, không bằng lòng (thường nói về trẻ con): mặt phụng phịu sắp khóc",
    example: "mặt phụng phịu sắp khóc",
  },
  {
    word: "phung phí",
    part_of_speech: "động từ",
    meaning:
      "sử dụng quá nhiều một cách lãng phí, vô ích: phung phí tiền bạc * ăn chơi phung phí",
    example: "phung phí tiền bạc * ăn chơi phung phí",
  },
  {
    word: "phùng phìu",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) phồng lên từng chỗ, từng đám không đều: chăn bông phùng phìu",
    example: "chăn bông phùng phìu",
  },
  {
    word: "phúng phính",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả vẻ béo căng tròn của mặt, má: em bé có đôi má phúng phính * mặt tròn phúng phính",
    example: "em bé có đôi má phúng phính * mặt tròn phúng phính",
  },
  {
    word: "phụng sự",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) phục vụ hết lòng: phụng sự tổ quốc * phụng sự nghệ thuật",
    example: "phụng sự tổ quốc * phụng sự nghệ thuật",
  },
  {
    word: "phụt",
    part_of_speech: "động từ",
    meaning:
      "bật mạnh từ bên trong ra thành tia, thành luồng: nước từ trong ống phụt ra * xe phụt khói",
    example: "nước từ trong ống phụt ra * xe phụt khói",
  },
  {
    word: "phụt",
    part_of_speech: "phụ từ",
    meaning:
      "(tắt) nhanh và đột ngột như bị thổi mạnh: đèn phụt tắt * thổi phụt",
    example: "đèn phụt tắt * thổi phụt",
  },
  {
    word: "phụng thờ",
    part_of_speech: "động từ",
    meaning: "như thờ cúng: phụng thờ tổ tiên * khói hương phụng thờ",
    example: "phụng thờ tổ tiên * khói hương phụng thờ",
  },
  {
    word: "phụng thờ",
    part_of_speech: "động từ",
    meaning:
      'tôn thờ và phụng sự: "Sao anh như dại như khờ, Cứ đòi đi lính, phụng thờ Tây bang." (ca dao)',
    example:
      'Sao anh như dại như khờ, Cứ đòi đi lính, phụng thờ Tây bang." (ca dao)',
  },
  {
    word: "phút chốc",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian rất ngắn, như chỉ trong ít phút (nói khái quát): sự việc chỉ xảy ra trong phút chốc * phút chốc, trời đất tối sầm lại",
    example:
      "sự việc chỉ xảy ra trong phút chốc * phút chốc, trời đất tối sầm lại",
  },
  {
    word: "phút giây",
    part_of_speech: "danh từ",
    meaning: "như giây phút: những phút giây hạnh phúc",
    example: "những phút giây hạnh phúc",
  },
  {
    word: "phút",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị đo thời gian, bằng 60 giây: tàu đến chậm năm phút * thời gian làm bài là 180 phút",
    example: "tàu đến chậm năm phút * thời gian làm bài là 180 phút",
  },
  {
    word: "phút",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian hết sức ngắn, được coi là ngắn nhất: chỉ một phút là xong * chờ đến phút chót",
    example: "chỉ một phút là xong * chờ đến phút chót",
  },
  {
    word: "phứa",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như bừa: cãi phứa * làm phứa",
    example: "cãi phứa * làm phứa",
  },
  {
    word: "phức",
    part_of_speech: "tính từ",
    meaning:
      "có cấu tạo gồm nhiều thành phần; phân biệt với đơn: thành tố phức * câu phức",
    example: "thành tố phức * câu phức",
  },
  {
    word: "phức hợp",
    part_of_speech: "tính từ",
    meaning:
      "gồm hai hay nhiều thành phần hợp thành: cấu tạo phức hợp * từ phức hợp",
    example: "cấu tạo phức hợp * từ phức hợp",
  },
  {
    word: "phức hệ",
    part_of_speech: "danh từ",
    meaning: "hệ thống phức tạp, gồm nhiều hệ thống nhỏ: phức hệ sinh thái",
    example: "phức hệ sinh thái",
  },
  {
    word: "phừng",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) như bừng (ng1): mặt đỏ phừng * lửa cháy phừng lên",
    example: "mặt đỏ phừng * lửa cháy phừng lên",
  },
  {
    word: "phường",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) khối dân cư gồm những người làm cùng một nghề, và là đơn vị hành chính thấp nhất ở kinh đô Thăng Long và một số thị trấn thời phong kiến: kinh thành Thăng Long chia làm 36 phường",
    example: "kinh thành Thăng Long chia làm 36 phường",
  },
  {
    word: "phường",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị hành chính cơ sở ở nội thành, nội thị, tổ chức theo khu vực dân cư ở đường phố, dưới quận: uỷ ban nhân dân phường",
    example: "uỷ ban nhân dân phường",
  },
  {
    word: "phường",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) tổ chức gồm những người cùng làm một nghề, một công việc đơn giản thời phong kiến: phường vải * phường hát * phường thợ đấu",
    example: "phường vải * phường hát * phường thợ đấu",
  },
  {
    word: "phường",
    part_of_speech: "danh từ",
    meaning:
      'bọn, nhóm người cùng có một đặc điểm chung nào đó, thường đáng khinh: "Con này chẳng phải thiện nhân, Chẳng phường trốn chúa, thì quân lộn chồng." (TKiều)',
    example:
      'Con này chẳng phải thiện nhân, Chẳng phường trốn chúa, thì quân lộn chồng." (TKiều)',
  },
  {
    word: "phức tạp",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều thành phần hoặc nhiều mặt kết hợp, đan xen với nhau, khó mà tách bạch ra được: máy móc tinh vi, phức tạp",
    example: "máy móc tinh vi, phức tạp",
  },
  {
    word: "phức tạp",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều sự rắc rối khó hiểu, khó nắm bắt, khó giải quyết: những vấn đề phức tạp, khó giải quyết * tư tưởng phức tạp",
    example: "những vấn đề phức tạp, khó giải quyết * tư tưởng phức tạp",
  },
  {
    word: "phưỡn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (bụng) to phình và đưa ra phía trước một cách khó coi: ăn no phưỡn bụng",
    example: "ăn no phưỡn bụng",
  },
  {
    word: "phưỡn",
    part_of_speech: "động từ",
    meaning: "(hiếm) như ưỡn: phưỡn ngực",
    example: "phưỡn ngực",
  },
  {
    word: "phương án",
    part_of_speech: "danh từ",
    meaning:
      "dự kiến về cách thức, trình tự tiến hành công việc trong điều kiện, hoàn cảnh nhất định nào đó: đề ra nhiều phương án * lên phương án đối phó",
    example: "đề ra nhiều phương án * lên phương án đối phó",
  },
  {
    word: "phương cách",
    part_of_speech: "danh từ",
    meaning:
      "cách, cách thức: hết phương cách * thay đổi phương cách hoạt động * tìm phương cách mới",
    example:
      "hết phương cách * thay đổi phương cách hoạt động * tìm phương cách mới",
  },
  {
    word: "phướn",
    part_of_speech: "danh từ",
    meaning:
      "cờ của nhà chùa, hình dải hẹp, phần cuối xẻ như đuôi cá: cột phướn",
    example: "cột phướn",
  },
  {
    word: "phượng",
    part_of_speech: "danh từ",
    meaning: "(Nam cũng phụng) phượng hoàng (nói tắt): nem công chả phượng",
    example: "nem công chả phượng",
  },
  {
    word: "phượng",
    part_of_speech: "danh từ",
    meaning:
      "cây thuộc họ đậu, có nhiều loại, lá kép lông chim, hoa mọc thành chùm, màu đỏ hoặc vàng, thường nở vào mùa hè, được trồng để lấy bóng mát hoặc làm cảnh: hoa phượng đỏ",
    example: "hoa phượng đỏ",
  },
  {
    word: "phương",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng để đong chất hạt rời, có dung tích khoảng 30 lít: một phương thóc",
    example: "một phương thóc",
  },
  {
    word: "phương",
    part_of_speech: "danh từ",
    meaning:
      "một trong bốn hướng chính nhìn về chân trời (đông, tây, nam, bắc), làm cơ sở xác định những hướng khác: phương Đông * đi khắp bốn phương trời",
    example: "phương Đông * đi khắp bốn phương trời",
  },
  {
    word: "phương",
    part_of_speech: "danh từ",
    meaning:
      "nơi xa, ở về một hướng nào đó: anh em mỗi người một phương * đi học ở phương xa",
    example: "anh em mỗi người một phương * đi học ở phương xa",
  },
  {
    word: "phương",
    part_of_speech: "danh từ",
    meaning:
      "thuộc tính về vị trí mà mỗi đường thẳng có chung với tất cả các đường thẳng song song với nó: phương nằm ngang * phương thẳng đứng",
    example: "phương nằm ngang * phương thẳng đứng",
  },
  {
    word: "phương",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) phương thuốc (nói tắt): thuốc nam có nhiều phương hay * bốc vài phương để uống thử",
    example: "thuốc nam có nhiều phương hay * bốc vài phương để uống thử",
  },
  {
    word: "phương",
    part_of_speech: "danh từ",
    meaning:
      "cách để giải quyết một khó khăn nào đó trong cuộc sống: vô phương cứu chữa * trăm phương ngàn kế",
    example: "vô phương cứu chữa * trăm phương ngàn kế",
  },
  {
    word: "phượng chạ loan chung",
    part_of_speech: "",
    meaning:
      '(cũ, văn chương) ví việc trai gái ân ái, chung chạ với nhau: "Nào người phượng chạ loan chung, Nào người tiếc lục tham hồng là ai?" (TKiều)',
    example:
      'Nào người phượng chạ loan chung, Nào người tiếc lục tham hồng là ai?" (TKiều)',
  },
  {
    word: "phương diện",
    part_of_speech: "danh từ",
    meaning:
      "một mặt nào đó xét riêng ra của vấn đề, sự việc: hơn về mọi phương diện * có giá trị về phương diện tinh thần",
    example: "hơn về mọi phương diện * có giá trị về phương diện tinh thần",
  },
  {
    word: "phương châm",
    part_of_speech: "danh từ",
    meaning:
      "tư tưởng chỉ đạo hành động, thường được diễn đạt bằng những câu ngắn gọn: phương châm là đánh nhanh, thắng nhanh",
    example: "phương châm là đánh nhanh, thắng nhanh",
  },
  {
    word: "phương hại",
    part_of_speech: "động từ",
    meaning:
      "làm tổn hại, gây ảnh hưởng xấu đến cái gì đó: không làm phương hại người khác",
    example: "không làm phương hại người khác",
  },
  {
    word: "phương chi",
    part_of_speech: "kết từ",
    meaning:
      "(cũ) như huống chi: người ngoài còn giúp được, phương chi người nhà",
    example: "người ngoài còn giúp được, phương chi người nhà",
  },
  {
    word: "phương hướng",
    part_of_speech: "danh từ",
    meaning:
      "hướng được xác định (nói khái quát): đi sai phương hướng * dùng la bàn để xác định phương hướng",
    example: "đi sai phương hướng * dùng la bàn để xác định phương hướng",
  },
  {
    word: "phương hướng",
    part_of_speech: "danh từ",
    meaning:
      "những điều được xác định để nhằm theo đó mà hành động (nói tổng quát): xác định phương hướng sản xuất * phát triển đúng phương hướng",
    example: "xác định phương hướng sản xuất * phát triển đúng phương hướng",
  },
  {
    word: "phường chèo",
    part_of_speech: "danh từ",
    meaning:
      "gánh hát chèo; dùng để chỉ những việc làm gây trò cười (thường hàm ý chê): chuyện cứ như phường chèo!",
    example: "chuyện cứ như phường chèo!",
  },
  {
    word: "phương ngôn",
    part_of_speech: "danh từ",
    meaning:
      '(hiếm) như tục ngữ: phương ngôn có câu "nước xa không cứu được lửa gần',
    example: 'phương ngôn có câu "nước xa không cứu được lửa gần',
  },
  {
    word: "phương ngôn",
    part_of_speech: "danh từ",
    meaning: "(cũ) phương ngữ: phương ngôn Bình Trị Thiên",
    example: "phương ngôn Bình Trị Thiên",
  },
  {
    word: "phương kế",
    part_of_speech: "danh từ",
    meaning:
      "cách để giải quyết một vấn đề khó khăn nào đó trong đời sống: tìm phương kế sinh nhai",
    example: "tìm phương kế sinh nhai",
  },
  {
    word: "phương sách",
    part_of_speech: "danh từ",
    meaning:
      "cách thức và những biện pháp để giải quyết một vấn đề xã hội, chính trị (nói tổng quát): tìm phương sách đối phó",
    example: "tìm phương sách đối phó",
  },
  {
    word: "phương ngữ",
    part_of_speech: "danh từ",
    meaning:
      "biến thể của một ngôn ngữ được sử dụng theo địa phương hoặc theo tầng lớp xã hội: phương ngữ Trung Bộ * từ phương ngữ",
    example: "phương ngữ Trung Bộ * từ phương ngữ",
  },
  {
    word: "phương phi",
    part_of_speech: "tính từ",
    meaning:
      "béo tốt, hồng hào, trông khoẻ và đẹp (thường nói về người đàn ông đã đứng tuổi): mặt mũi phương phi * thân hình phương phi",
    example: "mặt mũi phương phi * thân hình phương phi",
  },
  {
    word: "phương pháp",
    part_of_speech: "danh từ",
    meaning:
      "cách thức nghiên cứu, nhìn nhận các hiện tượng của tự nhiên và đời sống xã hội: phương pháp biện chứng * phương pháp so sánh thực nghiệm",
    example: "phương pháp biện chứng * phương pháp so sánh thực nghiệm",
  },
  {
    word: "phương pháp",
    part_of_speech: "danh từ",
    meaning:
      "hệ thống các cách sử dụng để tiến hành một hoạt động nào đó: phương pháp học tập * làm việc có phương pháp",
    example: "phương pháp học tập * làm việc có phương pháp",
  },
  {
    word: "phương thuốc",
    part_of_speech: "danh từ",
    meaning: "bài thuốc chữa bệnh của đông y: phương thuốc hữu hiệu",
    example: "phương thuốc hữu hiệu",
  },
  {
    word: "phương thức",
    part_of_speech: "danh từ",
    meaning:
      "cách thức và phương pháp tiến hành (nói tổng quát): phương thức canh tác lạc hậu",
    example: "phương thức canh tác lạc hậu",
  },
  {
    word: "phương tiện",
    part_of_speech: "danh từ",
    meaning:
      "cái dùng để làm một việc gì, để đạt một mục đích nào đó: phương tiện giao thông * các phương tiện thông tin đại chúng",
    example: "phương tiện giao thông * các phương tiện thông tin đại chúng",
  },
  {
    word: "phương trưởng",
    part_of_speech: "tính từ",
    meaning: "(cũ) khôn lớn và trưởng thành: con cái đều đã phương trưởng",
    example: "con cái đều đã phương trưởng",
  },
  {
    word: "phứt",
    part_of_speech: "phụ từ",
    meaning:
      "một cách nhanh, gọn, ngay lập tức, với thái độ dứt khoát: đứng phắt dậy * gạt phắt đi * chối phắt",
    example: "đứng phắt dậy * gạt phắt đi * chối phắt",
  },
  {
    word: "píc-ních",
    part_of_speech: "danh từ",
    meaning:
      "buổi đi chơi dã ngoại có mang theo thức ăn để tổ chức bữa ăn ngoài trời: tổ chức đi picnic cuối tuần",
    example: "tổ chức đi picnic cuối tuần",
  },
  {
    word: "pích",
    part_of_speech: "danh từ",
    meaning: "con bài tú lơ khơ có in hình ‘(’ màu đen: con át pích",
    example: "con át pích",
  },
  {
    word: "picnic",
    part_of_speech: "danh từ",
    meaning:
      "buổi đi chơi dã ngoại có mang theo thức ăn để tổ chức bữa ăn ngoài trời: tổ chức đi picnic cuối tuần",
    example: "tổ chức đi picnic cuối tuần",
  },
  {
    word: "pin",
    part_of_speech: "danh từ",
    meaning:
      "nguồn điện một chiều trong đó hoá năng biến đổi thành điện năng: đèn pin * pin con thỏ (mang nhãn hiệu con thỏ)",
    example: "đèn pin * pin con thỏ (mang nhãn hiệu con thỏ)",
  },
  {
    word: "plastic",
    part_of_speech: "danh từ",
    meaning: "chất dẻo tổng hợp: ép plastic * vật liệu plastic",
    example: "ép plastic * vật liệu plastic",
  },
  {
    word: "plas-tích",
    part_of_speech: "danh từ",
    meaning: "chất dẻo tổng hợp: ép plastic * vật liệu plastic",
    example: "ép plastic * vật liệu plastic",
  },
  {
    word: "pô",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) lần lên phim và bấm máy để chụp ảnh: chụp vài pô ảnh",
    example: "chụp vài pô ảnh",
  },
  {
    word: "puốcboa",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tiền của khách thưởng riêng cho người trực tiếp phục vụ ở cửa hàng ăn uống, khách sạn, các cơ sở dịch vụ, v.v.: khoản puốcboa * puốcboa cho bồi bàn",
    example: "khoản puốcboa * puốcboa cho bồi bàn",
  },
  {
    word: "qua",
    part_of_speech: "đại từ",
    meaning:
      '(Phương ngữ, Khẩu ngữ) từ người đàn ông lớn tuổi dùng để tự xưng một cách thân mật khi nói với người vai em, vai dưới: "Chim kêu ríu rít trên nhành, Qua không bỏ bậu, sao bậu đành bỏ qua?" (Cdao)',
    example:
      'Chim kêu ríu rít trên nhành, Qua không bỏ bậu, sao bậu đành bỏ qua?" (Cdao)',
  },
  {
    word: "qua",
    part_of_speech: "động từ",
    meaning:
      'di chuyển từ phía bên này sang phía bên kia của một sự vật: dắt cụ già qua đường * qua sông * "Yêu nhau cởi áo cho nhau, Về nhà mẹ hỏi qua cầu gió bay." (Cdao)',
    example:
      'dắt cụ già qua đường * qua sông * "Yêu nhau cởi áo cho nhau, Về nhà mẹ hỏi qua cầu gió bay." (Cdao)',
  },
  {
    word: "qua",
    part_of_speech: "động từ",
    meaning:
      "đi đến một nơi nào đó, sau khi vượt một khoảng không gian nhất định: qua nhà hàng xóm chơi * qua Nhật dự hội nghị",
    example: "qua nhà hàng xóm chơi * qua Nhật dự hội nghị",
  },
  {
    word: "qua",
    part_of_speech: "động từ",
    meaning:
      "từ biểu thị hoạt động theo hướng từ phía bên này sang phía bên kia của sự vật, hoặc chuyển sang một đối tượng khác, một hướng khác: nhảy qua mương * nhìn qua cửa sổ * nói qua chuyện khác",
    example: "nhảy qua mương * nhìn qua cửa sổ * nói qua chuyện khác",
  },
  {
    word: "qua",
    part_of_speech: "động từ",
    meaning:
      "sống hết một quãng thời gian nào đó: qua mấy cái Tết xa nhà * qua thời khó khăn",
    example: "qua mấy cái Tết xa nhà * qua thời khó khăn",
  },
  {
    word: "qua",
    part_of_speech: "động từ",
    meaning:
      "trôi đi hoặc trở thành thuộc về quá khứ: một năm đã qua * mấy tiếng đồng hồ trôi qua * nhắc lại những chuyện đã qua",
    example:
      "một năm đã qua * mấy tiếng đồng hồ trôi qua * nhắc lại những chuyện đã qua",
  },
  {
    word: "qua",
    part_of_speech: "động từ",
    meaning:
      "bước vào, tiếp đến một thời gian nào đó sau khi đã hết một khoảng thời gian nhất định: qua năm mới * đời này qua đời khác * sắp qua mùa xuân",
    example: "qua năm mới * đời này qua đời khác * sắp qua mùa xuân",
  },
  {
    word: "qua",
    part_of_speech: "động từ",
    meaning:
      "chịu tác động trực tiếp của cả một quá trình nào đó: qua một lớp tập huấn * qua khâu kiểm tra",
    example: "qua một lớp tập huấn * qua khâu kiểm tra",
  },
  {
    word: "qua",
    part_of_speech: "động từ",
    meaning:
      "tránh được sự chú ý: cố tìm cách để qua mắt địch * mọi việc không qua được mắt anh ta",
    example: "cố tìm cách để qua mắt địch * mọi việc không qua được mắt anh ta",
  },
  {
    word: "qua",
    part_of_speech: "phụ từ",
    meaning:
      "(làm việc gì) một cách nhanh, thường là không kĩ, không chi tiết: đọc qua bức thư * chỉ nghe qua cũng đủ hiểu * là qua cái áo",
    example: "đọc qua bức thư * chỉ nghe qua cũng đủ hiểu * là qua cái áo",
  },
  {
    word: "qua",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị sự vật, sự việc sắp nêu ra là trung gian, là phương tiện của hoạt động được nói đến: chuyển tiền qua bưu điện * quen biết qua một người bạn * kiểm nghiệm qua thực tế",
    example:
      "chuyển tiền qua bưu điện * quen biết qua một người bạn * kiểm nghiệm qua thực tế",
  },
  {
    word: "qua",
    part_of_speech: "trợ từ",
    meaning:
      "(Khẩu ngữ) từ biểu thị ý nhấn mạnh sự phủ định: hết sạch tiền, không còn qua một đồng * không nói qua một câu",
    example: "hết sạch tiền, không còn qua một đồng * không nói qua một câu",
  },
  {
    word: "quà",
    part_of_speech: "danh từ",
    meaning:
      "thức mua để ăn thêm ngoài bữa chính: mua quà sáng * ăn quà như mỏ khoét",
    example: "mua quà sáng * ăn quà như mỏ khoét",
  },
  {
    word: "quà",
    part_of_speech: "danh từ",
    meaning:
      "vật để hoặc được tặng, biếu để tỏ lòng quan tâm, quý mến: quà sinh nhật * quà mừng tân gia * tặng quà kỉ niệm",
    example: "quà sinh nhật * quà mừng tân gia * tặng quà kỉ niệm",
  },
  {
    word: "quá",
    part_of_speech: "động từ",
    meaning:
      "vượt qua một giới hạn quy định hoặc một điểm lấy làm mốc: quá tuổi đi học * đã quá mười giờ rồi * quá lứa nhỡ thì",
    example: "quá tuổi đi học * đã quá mười giờ rồi * quá lứa nhỡ thì",
  },
  {
    word: "quá",
    part_of_speech: "phụ từ",
    meaning:
      "đến mức độ vượt ra ngoài giới hạn cho phép: làm việc quá sức * còn ít quá, không đủ * dài quá nên phải cắt bớt đi",
    example:
      "làm việc quá sức * còn ít quá, không đủ * dài quá nên phải cắt bớt đi",
  },
  {
    word: "quá",
    part_of_speech: "phụ từ",
    meaning:
      "đến mức độ cao hơn hẳn mức bình thường: buồn quá * cô bé trông xinh quá * phố xá ngày Tết đông quá",
    example: "buồn quá * cô bé trông xinh quá * phố xá ngày Tết đông quá",
  },
  {
    word: "quả",
    part_of_speech: "danh từ",
    meaning:
      "(Nam thường trái) bộ phận của cây do bầu nhuỵ hoa phát triển thành, bên trong thường chứa hạt: đơm hoa kết quả * ăn quả nhớ kẻ trồng cây (tng) * quả táo",
    example: "đơm hoa kết quả * ăn quả nhớ kẻ trồng cây (tng) * quả táo",
  },
  {
    word: "quả",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị những vật có hình giống như quả cây: quả cầu * quả trứng vịt * cho mấy quả đấm",
    example: "quả cầu * quả trứng vịt * cho mấy quả đấm",
  },
  {
    word: "quả",
    part_of_speech: "danh từ",
    meaning:
      "đồ để đựng, thường bằng gỗ, hình hộp tròn, bên trong chia thành nhiều ngăn, có nắp đậy: quả trầu * thuê quả để đựng đồ lễ",
    example: "quả trầu * thuê quả để đựng đồ lễ",
  },
  {
    word: "quả",
    part_of_speech: "danh từ",
    meaning: "kết quả (nói tắt): quan hệ nhân quả",
    example: "quan hệ nhân quả",
  },
  {
    word: "quả",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) món lợi thu được trong làm ăn, buôn bán: thắng quả đậm * trúng quả",
    example: "thắng quả đậm * trúng quả",
  },
  {
    word: "quả",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý xác nhận dứt khoát, đúng là như vậy: nói quả không sai * quả có thế thật * bài ấy quả là khó",
    example: "nói quả không sai * quả có thế thật * bài ấy quả là khó",
  },
  {
    word: "quả báo",
    part_of_speech: "",
    meaning:
      "sự đáp lại điều ác hay điều thiện đã làm ở kiếp trước bằng điều ác hay điều thiện trong kiếp sau, theo đạo Phật: gặp quả báo",
    example: "gặp quả báo",
  },
  {
    word: "quá bán",
    part_of_speech: "",
    meaning:
      "quá một nửa (trong tổng số người tham gia): số người ủng hộ chưa được quá bán * thông qua với số phiếu quá bán",
    example:
      "số người ủng hộ chưa được quá bán * thông qua với số phiếu quá bán",
  },
  {
    word: "quả cảm",
    part_of_speech: "tính từ",
    meaning:
      "có quyết tâm và dũng khí, dám đương đầu với nguy hiểm để làm những việc thấy cần phải làm: tinh thần quả cảm * một người thông minh và quả cảm",
    example: "tinh thần quả cảm * một người thông minh và quả cảm",
  },
  {
    word: "quá bữa",
    part_of_speech: "tính từ",
    meaning:
      "(ăn uống) muộn hơn nhiều so với bữa ăn thường ngày: quá bữa nên ăn mất ngon",
    example: "quá bữa nên ăn mất ngon",
  },
  {
    word: "quá bộ",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) ghé bước, ghé đến (nói một cách lịch sự, nhún nhường, thường dùng trong lời mời người khác đến chơi nhà mình): mời bác quá bộ lại chơi",
    example: "mời bác quá bộ lại chơi",
  },
  {
    word: "quà bánh",
    part_of_speech: "danh từ",
    meaning:
      "bánh trái để ăn thêm, ngoài bữa chính: mua quà bánh về cho con * hàng quà bánh",
    example: "mua quà bánh về cho con * hàng quà bánh",
  },
  {
    word: "quà cáp",
    part_of_speech: "danh từ",
    meaning:
      "quà để biếu tặng (nói khái quát): chuẩn bị quà cáp đi biếu * biếu xén quà cáp",
    example: "chuẩn bị quà cáp đi biếu * biếu xén quà cáp",
  },
  {
    word: "quá cảnh",
    part_of_speech: "động từ",
    meaning:
      "(vận chuyển hàng hoá, hành khách) đi qua lãnh thổ của một hay nhiều nước để tới một nước khác, trên cơ sở hiệp định đã kí giữa các nước có liên quan: vận chuyển quá cảnh",
    example: "vận chuyển quá cảnh",
  },
  {
    word: "quá chén",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) uống rượu nhiều quá, đến mức bị say: hơi quá chén nên thiếu tỉnh táo",
    example: "hơi quá chén nên thiếu tỉnh táo",
  },
  {
    word: "quá chừng",
    part_of_speech: "phụ từ",
    meaning:
      '(khẩu ngữ) hơn hẳn mức bình thường: vui quá chừng! * đẹp quá chừng! * "(...) Trong lòng hiểm độc sâu cay quá chừng!" (BCB)',
    example:
      'vui quá chừng! * đẹp quá chừng! * "(...) Trong lòng hiểm độc sâu cay quá chừng!" (BCB)',
  },
  {
    word: "quá cố",
    part_of_speech: "động từ",
    meaning: "(trang trọng) đã chết: tưởng nhớ đến người quá cố",
    example: "tưởng nhớ đến người quá cố",
  },
  {
    word: "quá cỡ",
    part_of_speech: "phụ từ",
    meaning:
      "quá mức thường: to quá cỡ * sợ quá cỡ * bị mẹ rầy một trận quá cỡ",
    example: "to quá cỡ * sợ quá cỡ * bị mẹ rầy một trận quá cỡ",
  },
  {
    word: "quả đấm",
    part_of_speech: "danh từ",
    meaning:
      "bàn tay nắm lại để đánh: ăn mấy quả đấm * giơ quả đấm lên doạ bạn",
    example: "ăn mấy quả đấm * giơ quả đấm lên doạ bạn",
  },
  {
    word: "quả đấm",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận của một loại khoá cửa, hình tròn hoặc hình quả trứng, dùng để cầm vặn khi mở, đóng cửa: vặn quả đấm cửa ra vào",
    example: "vặn quả đấm cửa ra vào",
  },
  {
    word: "quá đà",
    part_of_speech: "tính từ",
    meaning:
      "lỡ đà, quá mức giới hạn cho phép: xe chạy quá đà * vui quá đà * tự do quá đà",
    example: "xe chạy quá đà * vui quá đà * tự do quá đà",
  },
  {
    word: "quá đáng",
    part_of_speech: "tính từ",
    meaning:
      "quá mức độ cần thiết hoặc quá mức độ có thể chấp nhận, khiến người ta thấy khó chịu: thái độ nghiêm khắc quá đáng * nói quá đáng",
    example: "thái độ nghiêm khắc quá đáng * nói quá đáng",
  },
  {
    word: "quá độ",
    part_of_speech: "động từ",
    meaning:
      "chuyển tiếp từ trạng thái này sang trạng thái khác, trong quá trình vận động và phát triển: giai đoạn quá độ * thời kì quá độ",
    example: "giai đoạn quá độ * thời kì quá độ",
  },
  {
    word: "quá độ",
    part_of_speech: "phụ từ",
    meaning: "quá mức độ bình thường: ăn chơi quá độ * làm việc quá độ",
    example: "ăn chơi quá độ * làm việc quá độ",
  },
  {
    word: "quá đi chứ",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị ý khẳng định dứt khoát, bác bỏ sự hoài nghi hay ý kiến trái lại của người đối thoại: được quá đi chứ! * vụ làm ăn này lời quá đi chứ!",
    example: "được quá đi chứ! * vụ làm ăn này lời quá đi chứ!",
  },
  {
    word: "quá giang",
    part_of_speech: "động từ",
    meaning: "(hiếm) đi đò ngang qua sông: khách quá giang ngồi chờ đò",
    example: "khách quá giang ngồi chờ đò",
  },
  {
    word: "quá giang",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) đi nhờ một phương tiện vận tải nào đó: vẫy xe xin quá giang",
    example: "vẫy xe xin quá giang",
  },
  {
    word: "quá đỗi",
    part_of_speech: "phụ từ",
    meaning:
      'quá mức bình thường: vui mừng quá đỗi * ngạc nhiên quá đỗi * "Thương em quá đỗi nên say (...)" (ca dao)',
    example:
      'vui mừng quá đỗi * ngạc nhiên quá đỗi * "Thương em quá đỗi nên say (...)" (ca dao)',
  },
  {
    word: "quá khích",
    part_of_speech: "tính từ",
    meaning:
      "mạnh mẽ và quyết liệt quá mức trong đấu tranh (hàm ý chê): hành động quá khích * phần tử quá khích",
    example: "hành động quá khích * phần tử quá khích",
  },
  {
    word: "quá giấc",
    part_of_speech: "tính từ",
    meaning:
      "(đi ngủ) muộn hơn nhiều so với thường ngày: quá giấc nên không ngủ được",
    example: "quá giấc nên không ngủ được",
  },
  {
    word: "quá khổ",
    part_of_speech: "tính từ",
    meaning:
      "có kích thước quá mức bình thường hoặc quá mức cho phép: to quá khổ * chiếc áo rộng quá khổ",
    example: "to quá khổ * chiếc áo rộng quá khổ",
  },
  {
    word: "quá khứ",
    part_of_speech: "danh từ",
    meaning: "thời gian đã qua: thời quá khứ * chuyện đó đã thuộc về quá khứ",
    example: "thời quá khứ * chuyện đó đã thuộc về quá khứ",
  },
  {
    word: "qua đời",
    part_of_speech: "động từ",
    meaning: "(trang trọng) chết, chết rồi: ông cụ qua đời ở tuổi 80",
    example: "ông cụ qua đời ở tuổi 80",
  },
  {
    word: "qua lại",
    part_of_speech: "động từ",
    meaning:
      "đi qua đi lại liên tục (nói khái quát): đường phố về đêm rất ít người qua lại * dòng người qua lại tấp nập",
    example:
      "đường phố về đêm rất ít người qua lại * dòng người qua lại tấp nập",
  },
  {
    word: "qua lại",
    part_of_speech: "động từ",
    meaning:
      "(quan hệ tác động) có tính chất hai chiều, trở đi trở lại: tác động qua lại * có ảnh hưởng qua lại * mối quan hệ qua lại",
    example: "tác động qua lại * có ảnh hưởng qua lại * mối quan hệ qua lại",
  },
  {
    word: "quá lắm",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) quá mức, làm cho khó có thể chịu nổi: một vừa hai phải thôi, quá lắm thì không ai chịu được",
    example: "một vừa hai phải thôi, quá lắm thì không ai chịu được",
  },
  {
    word: "qua loa",
    part_of_speech: "tính từ",
    meaning: "chỉ sơ qua, gọi là có: hỏi thăm qua loa * làm qua loa",
    example: "hỏi thăm qua loa * làm qua loa",
  },
  {
    word: "quá lắm cũng chỉ",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị ý đánh giá chỉ đến thế là cùng, không thể hơn được: nhìn chị ấy quá lắm cũng chỉ ba mươi tuổi * việc đó quá lắm cũng chỉ hai tháng là xong",
    example:
      "nhìn chị ấy quá lắm cũng chỉ ba mươi tuổi * việc đó quá lắm cũng chỉ hai tháng là xong",
  },
  {
    word: "quá lời",
    part_of_speech: "",
    meaning:
      "nói những lời quá đáng, làm cho người nghe cảm thấy bối rối hoặc thấy bị xúc phạm: khen quá lời * cảm thấy ân hận vì đã quá lời",
    example: "khen quá lời * cảm thấy ân hận vì đã quá lời",
  },
  {
    word: "quả lừa",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) vố lừa bịp: cho ăn quả lừa * bị một quả lừa",
    example: "cho ăn quả lừa * bị một quả lừa",
  },
  {
    word: "quá lửa",
    part_of_speech: "tính từ",
    meaning:
      "chịu tác động sức nóng của lửa quá mức cần thiết: cơm hơi khê vì quá lửa",
    example: "cơm hơi khê vì quá lửa",
  },
  {
    word: "quả lắc",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) con lắc đồng hồ: đồng hồ quả lắc",
    example: "đồng hồ quả lắc",
  },
  {
    word: "quạ mượn lông công",
    part_of_speech: "",
    meaning:
      'ví kẻ giả dối, mượn cái đẹp đẽ của người khác để che đậy bản chất xấu xa của mình: "Khác nào quạ mượn lông công, Ngoài hình xinh đẹp trong lòng xấu xa." (ca dao)',
    example:
      'Khác nào quạ mượn lông công, Ngoài hình xinh đẹp trong lòng xấu xa." (ca dao)',
  },
  {
    word: "qua mặt",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) lờ đi, không thèm hỏi ý kiến hoặc không cho biết, tỏ ra coi thường: dám qua mặt lãnh đạo",
    example: "dám qua mặt lãnh đạo",
  },
  {
    word: "quả phụ",
    part_of_speech: "danh từ",
    meaning: "(trang trọng) người đàn bà goá: cô nhi quả phụ",
    example: "cô nhi quả phụ",
  },
  {
    word: "quá quắt",
    part_of_speech: "tính từ",
    meaning:
      "quá cái mức mà người ta có thể chấp nhận, có thể chịu nổi: tính nết càng ngày càng quá quắt * ăn nói quá quắt",
    example: "tính nết càng ngày càng quá quắt * ăn nói quá quắt",
  },
  {
    word: "quả nhiên",
    part_of_speech: "tính từ",
    meaning:
      "đúng như vậy, đúng như đã đoán biết trước: quả nhiên mọi chuyện xảy ra đúng như vậy",
    example: "quả nhiên mọi chuyện xảy ra đúng như vậy",
  },
  {
    word: "quả quyết",
    part_of_speech: "động từ",
    meaning:
      "khẳng định một cách chắc chắn, không chút do dự: quả quyết rằng sẽ làm xong sớm * tôi quả quyết là như vậy",
    example: "quả quyết rằng sẽ làm xong sớm * tôi quả quyết là như vậy",
  },
  {
    word: "quả quyết",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra có đủ quyết tâm, không hề do dự: thái độ quả quyết * hành động quả quyết",
    example: "thái độ quả quyết * hành động quả quyết",
  },
  {
    word: "qua quít",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) một cách sơ sài, gọi là cho có, cho xong: trả lời qua quýt * làm qua quýt",
    example: "trả lời qua quýt * làm qua quýt",
  },
  {
    word: "qua quýt",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) một cách sơ sài, gọi là cho có, cho xong: trả lời qua quýt * làm qua quýt",
    example: "trả lời qua quýt * làm qua quýt",
  },
  {
    word: "qua ngày",
    part_of_speech: "",
    meaning:
      "hết được ngày này qua đến được ngày khác, thường chỉ cảnh sống lần hồi, tạm bợ: muối dưa đắp đổi qua ngày * sống qua ngày",
    example: "muối dưa đắp đổi qua ngày * sống qua ngày",
  },
  {
    word: "quá tải",
    part_of_speech: "tính từ",
    meaning:
      "quá sức chuyên chở, sức chịu đựng cho phép: xe chở quá tải * mạch điện bị ngắt vì quá tải",
    example: "xe chở quá tải * mạch điện bị ngắt vì quá tải",
  },
  {
    word: "quá tam ba bận",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) (làm việc gì) đã đến lần thứ ba mà vẫn hỏng, vẫn không được thì thôi, coi như không bao giờ đạt được: thi quá tam ba bận rồi mà vẫn trượt",
    example: "thi quá tam ba bận rồi mà vẫn trượt",
  },
  {
    word: "quá sức",
    part_of_speech: "tính từ",
    meaning:
      "vượt quá sức lực, quá khả năng chịu đựng: làm việc quá sức * quá sức chịu đựng",
    example: "làm việc quá sức * quá sức chịu đựng",
  },
  {
    word: "quá sức",
    part_of_speech: "tính từ",
    meaning:
      "ở mức độ rất cao, vượt xa mức bình thường: mừng quá sức * đám cưới được ấn định quá sức vội vàng",
    example: "mừng quá sức * đám cưới được ấn định quá sức vội vàng",
  },
  {
    word: "quá tay",
    part_of_speech: "",
    meaning:
      "hành động quá mức cần thiết, thường vì lỡ tay: trận đòn quá tay * tra muối quá tay nên mặn",
    example: "trận đòn quá tay * tra muối quá tay nên mặn",
  },
  {
    word: "quả tang",
    part_of_speech: "phụ từ",
    meaning:
      "(bị bắt gặp, bị phát hiện) ngay trong khi đang làm việc gì vụng trộm, phạm pháp: tên trộm bị bắt quả tang",
    example: "tên trộm bị bắt quả tang",
  },
  {
    word: "quả thật",
    part_of_speech: "phụ từ",
    meaning:
      "quả đúng như vậy, không còn gì phải nghi ngờ cả (dùng để biểu thị ý khẳng định hay phân trần): việc đó quả thật tôi cũng không biết",
    example: "việc đó quả thật tôi cũng không biết",
  },
  {
    word: "quá thể",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) quá mức bình thường có thể có: ghét quá thể * thấy chướng mắt quá thể!",
    example: "ghét quá thể * thấy chướng mắt quá thể!",
  },
  {
    word: "quả tình",
    part_of_speech: "phụ từ",
    meaning:
      "quả đúng sự thật là như vậy (dùng để biểu thị ý phân trần, thanh minh): quả tình lúc đó tôi không nhận ra anh",
    example: "quả tình lúc đó tôi không nhận ra anh",
  },
  {
    word: "quá trình",
    part_of_speech: "danh từ",
    meaning:
      "trình tự phát triển, diễn biến của một sự việc, hiện tượng nào đó: quá trình phát triển của cây * theo dõi quá trình công tác",
    example: "quá trình phát triển của cây * theo dõi quá trình công tác",
  },
  {
    word: "quá trời",
    part_of_speech: "phụ từ",
    meaning:
      "(Phương ngữ, Khẩu ngữ) quá mức, một cách đáng ngạc nhiên: vui quá trời! * thằng bé khóc quá trời!",
    example: "vui quá trời! * thằng bé khóc quá trời!",
  },
  {
    word: "quá ư",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) quá sức tưởng tượng, khó có thể nghĩ là đến như vậy: quá ư cẩu thả * hành động quá ư tàn nhẫn",
    example: "quá ư cẩu thả * hành động quá ư tàn nhẫn",
  },
  {
    word: "quá xá",
    part_of_speech: "phụ từ",
    meaning:
      '(phương ngữ, khẩu ngữ) như quá trời: vui quá xá! * "Còn giả đò hoài cha nội! Số mầy hên quá xá đó." (ChLai; 1)',
    example:
      'vui quá xá! * "Còn giả đò hoài cha nội! Số mầy hên quá xá đó." (ChLai; 1)',
  },
  {
    word: "quá trớn",
    part_of_speech: "tính từ",
    meaning: "quá mức, quá giới hạn cho phép: đùa quá trớn * ăn nói quá trớn",
    example: "đùa quá trớn * ăn nói quá trớn",
  },
  {
    word: "quá tội",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) như cũng quá tội: ăn uống hà tiện rồi lại ốm ra thì quá tội!",
    example: "ăn uống hà tiện rồi lại ốm ra thì quá tội!",
  },
  {
    word: "quá vãng",
    part_of_speech: "động từ",
    meaning: "(cũ, trang trọng) như quá cố: tưởng nhớ đến người quá vãng",
    example: "tưởng nhớ đến người quá vãng",
  },
  {
    word: "quá vãng",
    part_of_speech: "động từ",
    meaning:
      "(văn chương, hiếm) thuộc về quá khứ: chuyện đó chỉ còn là quá vãng * thời quá vãng",
    example: "chuyện đó chỉ còn là quá vãng * thời quá vãng",
  },
  {
    word: "quạc",
    part_of_speech: "động từ",
    meaning: "từ mô phỏng tiếng kêu của vịt, ngỗng.",
    example: "quạc mồm ra cãi",
  },
  {
    word: "quả vậy",
    part_of_speech: "phụ từ",
    meaning: "quả đúng như vậy: quả vậy, hắn chẳng ưng gì ông ta",
    example: "quả vậy, hắn chẳng ưng gì ông ta",
  },
  {
    word: "quách",
    part_of_speech: "danh từ",
    meaning: "hòm bọc ngoài quan tài: trong quan ngoài quách",
    example: "trong quan ngoài quách",
  },
  {
    word: "quách",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) (làm việc gì) ngay đi cho xong, cho khỏi vướng bận: chờ với chả đợi, làm quách cho xong * vứt quách đi!",
    example: "chờ với chả đợi, làm quách cho xong * vứt quách đi!",
  },
  {
    word: "quai",
    part_of_speech: "danh từ",
    meaning:
      'bộ phận gắn vào vật, dùng để xách, mang hay đeo vào người: quai túi * dép đứt quai * "Tròng trành như nón không quai, Như thuyền không lái như ai không chồng." (Cdao)',
    example:
      'quai túi * dép đứt quai * "Tròng trành như nón không quai, Như thuyền không lái như ai không chồng." (Cdao)',
  },
  {
    word: "quai",
    part_of_speech: "động từ",
    meaning: "đắp cho bao quanh một khu vực: quai đê lấn biển",
    example: "quai đê lấn biển",
  },
  {
    word: "quai",
    part_of_speech: "động từ",
    meaning: "vung theo hình vòng cung rồi giáng mạnh xuống: quai búa",
    example: "quai búa",
  },
  {
    word: "quài",
    part_of_speech: "động từ",
    meaning:
      "vươn tay hoặc vòng tay về đằng sau để với tới: quài tay ra sau lưng để gãi",
    example: "quài tay ra sau lưng để gãi",
  },
  {
    word: "quải",
    part_of_speech: "động từ",
    meaning: "(Phương ngữ) vãi, rải: quải thóc cho gà ăn",
    example: "quải thóc cho gà ăn",
  },
  {
    word: "quải",
    part_of_speech: "động từ",
    meaning: "(Phương ngữ, Từ cũ) cúng: quải cơm",
    example: "quải cơm",
  },
  {
    word: "quái ác",
    part_of_speech: "tính từ",
    meaning: "quái lạ và độc ác: trận lụt quái ác * chơi trò quái ác",
    example: "trận lụt quái ác * chơi trò quái ác",
  },
  {
    word: "quái dị",
    part_of_speech: "tính từ",
    meaning:
      "rất khác với những gì thường thấy, gây cảm giác khó coi: hình thù quái dị * chuyện quái dị",
    example: "hình thù quái dị * chuyện quái dị",
  },
  {
    word: "quại",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) đánh rất mạnh bằng nắm đấm: quại cho một quả vào mặt",
    example: "quại cho một quả vào mặt",
  },
  {
    word: "quái",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) lạ, rất đáng ngạc nhiên, khó có thể hiểu nổi: quái, giờ này mà vẫn chưa thèm đến?",
    example: "quái, giờ này mà vẫn chưa thèm đến?",
  },
  {
    word: "quái",
    part_of_speech: "trợ từ",
    meaning:
      "(khẩu ngữ) từ biểu thị ý nhấn mạnh sắc thái phủ định: ra cái quái gì * chẳng hiểu quái gì * ốm đau quái gì, giả vờ đấy!",
    example:
      "ra cái quái gì * chẳng hiểu quái gì * ốm đau quái gì, giả vờ đấy!",
  },
  {
    word: "quái đản",
    part_of_speech: "tính từ",
    meaning: "kì quái, không có thật: câu chuyện quái đản * hình thù quái đản",
    example: "câu chuyện quái đản * hình thù quái đản",
  },
  {
    word: "quái kiệt",
    part_of_speech: "",
    meaning:
      "người có tài nghệ đặc biệt khác thường, đến mức khó hiểu nổi: một quái kiệt trong làng điện ảnh",
    example: "một quái kiệt trong làng điện ảnh",
  },
  {
    word: "quái gở",
    part_of_speech: "tính từ",
    meaning:
      "rất kì quái, gây ấn tượng không tốt, có thể gây hại: làm những việc quái gở * những sở thích quái gở",
    example: "làm những việc quái gở * những sở thích quái gở",
  },
  {
    word: "quải đơm",
    part_of_speech: "động từ",
    meaning:
      '(cũ) cúng (nói khái quát): "Lâm râm khấn vái quải đơm, Có linh xin hưởng, chớ hờn cơm xa." (TKCT)',
    example:
      'Lâm râm khấn vái quải đơm, Có linh xin hưởng, chớ hờn cơm xa." (TKCT)',
  },
  {
    word: "quái lạ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) lạ lùng khó hiểu, rất đáng ngạc nhiên: toàn chuyện quái lạ * quái lại, chính tay mình để đây cơ mà!",
    example: "toàn chuyện quái lạ * quái lại, chính tay mình để đây cơ mà!",
  },
  {
    word: "quái vật",
    part_of_speech: "danh từ",
    meaning:
      "con vật tưởng tượng, có hình thù quái dị trông đáng sợ và độc ác, hay hại người: con quái vật",
    example: "con quái vật",
  },
  {
    word: "quai hàm",
    part_of_speech: "danh từ",
    meaning:
      "phần xương hàm dưới, ở bên và phía dưới mặt: ngáp sái cả quai hàm",
    example: "ngáp sái cả quai hàm",
  },
  {
    word: "quái quỷ",
    part_of_speech: "tính từ",
    meaning: "như quỷ quái: làm cái quái quỷ gì thế?",
    example: "làm cái quái quỷ gì thế?",
  },
  {
    word: "quan",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) (đôi khi tiêu cực) viên chức có quyền hành trong bộ máy nhà nước phong kiến, thực dân: quan văn * cửa quan * miệng nhà quan có gang có thép (tng)",
    example: "quan văn * cửa quan * miệng nhà quan có gang có thép (tng)",
  },
  {
    word: "quan ải",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) cửa ải: "Xảy nghe tin giặc Ô Qua, Phủ vây quan ải, quân ba bốn ngàn." (LVT)',
    example:
      'Xảy nghe tin giặc Ô Qua, Phủ vây quan ải, quân ba bốn ngàn." (LVT)',
  },
  {
    word: "quản",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) trông coi, điều khiển: lũ trẻ nghịch quá, không ai quản được",
    example: "lũ trẻ nghịch quá, không ai quản được",
  },
  {
    word: "quản",
    part_of_speech: "động từ",
    meaning:
      'tính đến và ngại: không quản nắng mưa * "Phải duyên em nhất định theo, Nào ai có quản khó nghèo chi đâu." (ca dao)',
    example:
      'không quản nắng mưa * "Phải duyên em nhất định theo, Nào ai có quản khó nghèo chi đâu." (ca dao)',
  },
  {
    word: "quán",
    part_of_speech: "danh từ",
    meaning:
      'nhà nhỏ dựng ở giữa đồng để trú mưa, trú nắng: "Có quán tình phụ bóng đa, Ba năm quán đổ cây đa vẫn còn." (ca dao)',
    example:
      'Có quán tình phụ bóng đa, Ba năm quán đổ cây đa vẫn còn." (ca dao)',
  },
  {
    word: "quán",
    part_of_speech: "danh từ",
    meaning:
      "nhà nhỏ dùng làm nơi bán hàng: quán nước ven đường * quán cơm bình dân * dọn quán bán hàng",
    example: "quán nước ven đường * quán cơm bình dân * dọn quán bán hàng",
  },
  {
    word: "quản ca",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) người điều khiển và huấn luyện một nhóm hát: quản ca bắt nhịp cho cả lớp hát",
    example: "quản ca bắt nhịp cho cả lớp hát",
  },
  {
    word: "quàn",
    part_of_speech: "động từ",
    meaning:
      "đặt tạm linh cữu ở một nơi để làm lễ trước khi mai táng: linh cữu được quàn tại nhà tang lễ",
    example: "linh cữu được quàn tại nhà tang lễ",
  },
  {
    word: "quản chế",
    part_of_speech: "động từ",
    meaning: "(Từ cũ) như quản thúc: bị quản chế tại nhà",
    example: "bị quản chế tại nhà",
  },
  {
    word: "quan cách",
    part_of_speech: "tính từ",
    meaning:
      "có cái kiểu cách là kẻ bề trên, ra vẻ có quyền hành giống như quan lại đối với người dân thường: thói quan cách * ra vẻ quan cách",
    example: "thói quan cách * ra vẻ quan cách",
  },
  {
    word: "quan điểm",
    part_of_speech: "danh từ",
    meaning:
      "điểm xuất phát quy định hướng suy nghĩ, cách xem xét, đánh giá về một sự vật, sự việc nào đó: quan điểm giai cấp * có quan điểm sống đúng đắn",
    example: "quan điểm giai cấp * có quan điểm sống đúng đắn",
  },
  {
    word: "quan điểm",
    part_of_speech: "danh từ",
    meaning:
      "cách nhìn, cách suy nghĩ: trình bày rõ quan điểm của mình * bất đồng quan điểm",
    example: "trình bày rõ quan điểm của mình * bất đồng quan điểm",
  },
  {
    word: "quan dạng",
    part_of_speech: "tính từ",
    meaning:
      "có dáng điệu như của những người có quyền hành, cố làm cho ra vẻ oai vệ: có vẻ quan dạng * làm ra lối quan dạng",
    example: "có vẻ quan dạng * làm ra lối quan dạng",
  },
  {
    word: "quan chức",
    part_of_speech: "danh từ",
    meaning: "người có chức vụ cao trong bộ máy nhà nước: quan chức địa phương",
    example: "quan chức địa phương",
  },
  {
    word: "quan gia",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) từ dùng để gọi vua: quan gia vạn tuế! * tâu quan gia, hạ thần tuân chỉ!",
    example: "quan gia vạn tuế! * tâu quan gia, hạ thần tuân chỉ!",
  },
  {
    word: "quản đốc",
    part_of_speech: "danh từ",
    meaning:
      "người đứng đầu quản lí một phân xưởng hay một xưởng trong nhà máy, xí nghiệp: quản đốc phân xưởng cơ điện",
    example: "quản đốc phân xưởng cơ điện",
  },
  {
    word: "quán cóc",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) quán (bán hàng) nhỏ, có tính tạm bợ: quán cóc ven đường",
    example: "quán cóc ven đường",
  },
  {
    word: "quản gia",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người làm thuê, trông coi việc nhà cho một gia đình giàu có: người quản gia trung thành",
    example: "người quản gia trung thành",
  },
  {
    word: "quản giáo",
    part_of_speech: "danh từ",
    meaning: "(cũ) người trực tiếp quản lí, dạy dỗ.",
    example: "làm quản giáo ở trại giam",
  },
  {
    word: "quan hà",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) cửa ải và sông; thường dùng để chỉ sự xa xôi cách trở: "Chiếc thân tựa gối quan hà, Nỗi niềm tâm sự trăng già thấu chăng?" (TTK)',
    example:
      'Chiếc thân tựa gối quan hà, Nỗi niềm tâm sự trăng già thấu chăng?" (TTK)',
  },
  {
    word: "quan họ",
    part_of_speech: "danh từ",
    meaning:
      "dân ca trữ tình vùng Bắc Ninh, có làn điệu phong phú, thường biểu diễn dưới hình thức hát đối: làn quan họ * hát quan họ",
    example: "làn quan họ * hát quan họ",
  },
  {
    word: "quan khách",
    part_of_speech: "danh từ",
    meaning:
      "(trang trọng) khách mời đến dự lễ (nói khái quát): quan khách đã đến đông đủ",
    example: "quan khách đã đến đông đủ",
  },
  {
    word: "quan hệ",
    part_of_speech: "danh từ",
    meaning:
      "trạng thái tác động lẫn nhau, ảnh hưởng lẫn nhau giữa các sự vật: quan hệ hai chiều * quan hệ ngoại giao * quan hệ hàng xóm láng giềng",
    example:
      "quan hệ hai chiều * quan hệ ngoại giao * quan hệ hàng xóm láng giềng",
  },
  {
    word: "quan hệ",
    part_of_speech: "tính từ",
    meaning: "(Từ cũ) quan trọng, hệ trọng: việc này rất quan hệ!",
    example: "việc này rất quan hệ!",
  },
  {
    word: "quản lí",
    part_of_speech: "động từ",
    meaning:
      "trông coi và giữ gìn theo những yêu cầu nhất định: quản lí sổ sách * quản lí hồ sơ, tài liệu",
    example: "quản lí sổ sách * quản lí hồ sơ, tài liệu",
  },
  {
    word: "quản lí",
    part_of_speech: "động từ",
    meaning:
      "tổ chức và điều khiển các hoạt động theo những yêu cầu nhất định: quản lí nhân sự * ban quản lí dự án",
    example: "quản lí nhân sự * ban quản lí dự án",
  },
  {
    word: "quản lí",
    part_of_speech: "danh từ",
    meaning: "sự quản lí: cải tiến quản lí * đầu tư cho quản lí",
    example: "cải tiến quản lí * đầu tư cho quản lí",
  },
  {
    word: "quan lại",
    part_of_speech: "danh từ",
    meaning: "(cũ) quan (nói khái quát): hàng ngũ quan lại",
    example: "hàng ngũ quan lại",
  },
  {
    word: "quan nha",
    part_of_speech: "danh từ",
    meaning: "(cũ) nơi làm việc của quan lại (nói khái quát).",
    example: "bị quan nha ức hiếp",
  },
  {
    word: "quản ngại",
    part_of_speech: "động từ",
    meaning: "ngại ngần, e ngại: khó khăn cũng không quản ngại",
    example: "khó khăn cũng không quản ngại",
  },
  {
    word: "quan ngại",
    part_of_speech: "động từ",
    meaning:
      "quan tâm và lo ngại: sự việc khiến nhiều người quan ngại * tình hình rất đáng quan ngại",
    example:
      "sự việc khiến nhiều người quan ngại * tình hình rất đáng quan ngại",
  },
  {
    word: "quán ngữ",
    part_of_speech: "danh từ",
    meaning:
      "tổ hợp từ cố định đã dùng lâu, dùng nhiều thành quen, nghĩa có thể suy ra từ nghĩa của các yếu tố hợp thành: ,  * ,  *  là những quán ngữ trong tiếng Việt",
    example: ",  * ,  *  là những quán ngữ trong tiếng Việt",
  },
  {
    word: "quan san",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) cửa ải và núi non; thường dùng để chỉ đường sá xa xôi, cách trở: quan san nghìn dặm * "Người lên ngựa, kẻ chia bào, Rừng phong, thu đã nhuốm màu quan san." (TKiều)',
    example:
      'quan san nghìn dặm * "Người lên ngựa, kẻ chia bào, Rừng phong, thu đã nhuốm màu quan san." (TKiều)',
  },
  {
    word: "quan liêu",
    part_of_speech: "danh từ",
    meaning: "(cũ) như quan lại: bộ máy quan liêu phong kiến",
    example: "bộ máy quan liêu phong kiến",
  },
  {
    word: "quan liêu",
    part_of_speech: "tính từ",
    meaning:
      "(cách lãnh đạo, chỉ đạo) thiên về dùng mệnh lệnh, giấy tờ, xa rời thực tế, xa rời quần chúng: lối làm việc quan liêu",
    example: "lối làm việc quan liêu",
  },
  {
    word: "quản lý",
    part_of_speech: "động từ",
    meaning:
      "trông coi và giữ gìn theo những yêu cầu nhất định: quản lí sổ sách * quản lí hồ sơ, tài liệu",
    example: "quản lí sổ sách * quản lí hồ sơ, tài liệu",
  },
  {
    word: "quản lý",
    part_of_speech: "động từ",
    meaning:
      "tổ chức và điều khiển các hoạt động theo những yêu cầu nhất định: quản lí nhân sự * ban quản lí dự án",
    example: "quản lí nhân sự * ban quản lí dự án",
  },
  {
    word: "quản lý",
    part_of_speech: "danh từ",
    meaning: "sự quản lí: cải tiến quản lí * đầu tư cho quản lí",
    example: "cải tiến quản lí * đầu tư cho quản lí",
  },
  {
    word: "quán quân",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, hoặc kng) danh hiệu dành cho người chiếm giải nhất trong một số môn thi đấu thể thao: quán quân quần vợt * đoạt quán quân giải võ cổ truyền toàn quốc",
    example: "quán quân quần vợt * đoạt quán quân giải võ cổ truyền toàn quốc",
  },
  {
    word: "quan niệm",
    part_of_speech: "động từ",
    meaning:
      "hiểu, nhận thức như thế nào đó về một vấn đề: anh ấy quan niệm khác với mọi người",
    example: "anh ấy quan niệm khác với mọi người",
  },
  {
    word: "quan niệm",
    part_of_speech: "danh từ",
    meaning:
      "cách nhận thức, đánh giá về một vấn đề, một sự kiện: những quan niệm sai lầm * một quan niệm mới về tình yêu và hôn nhân",
    example:
      "những quan niệm sai lầm * một quan niệm mới về tình yêu và hôn nhân",
  },
  {
    word: "quan sát",
    part_of_speech: "động từ",
    meaning:
      "nhìn, xem xét để thấy, để biết rõ sự vật, hiện tượng nào đó: đài quan sát * quan sát cẩn thận trước khi sang đường",
    example: "đài quan sát * quan sát cẩn thận trước khi sang đường",
  },
  {
    word: "quan tái",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) nơi miền biên ải xa xôi: nơi quan tái * "Chạnh niềm nhớ cảnh giang hồ, Một màu quan tái, mấy mùa gió trăng." (TKiều)',
    example:
      'nơi quan tái * "Chạnh niềm nhớ cảnh giang hồ, Một màu quan tái, mấy mùa gió trăng." (TKiều)',
  },
  {
    word: "quan thầy",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) kẻ có thế lực, dùng kẻ khác làm tay sai để làm những việc phi nghĩa, trong quan hệ với tay sai của mình: xu nịnh quan thầy",
    example: "xu nịnh quan thầy",
  },
  {
    word: "quản thúc",
    part_of_speech: "động từ",
    meaning:
      "bắt kẻ phạm tội phải chịu sự quản lí của chính quyền địa phương về việc đi lại, làm ăn, cư trú (không được tự do như các công dân khác; hình phạt không giam giữ): bị chính quyền quản thúc * được tự do, không ai quản thúc (kng)",
    example: "bị chính quyền quản thúc * được tự do, không ai quản thúc (kng)",
  },
  {
    word: "quan thuế",
    part_of_speech: "danh từ",
    meaning: "(cũ) như thuế quan: hàng rào quan thuế",
    example: "hàng rào quan thuế",
  },
  {
    word: "quan tâm",
    part_of_speech: "động từ",
    meaning:
      "để tâm, chú ý đến một cách thường xuyên: quan tâm chăm sóc con cái * chuyện đó tôi không quan tâm",
    example: "quan tâm chăm sóc con cái * chuyện đó tôi không quan tâm",
  },
  {
    word: "quán tính",
    part_of_speech: "danh từ",
    meaning:
      "tính chất không tự thay đổi trạng thái chuyển động hoặc đứng yên của vật: quán tính của con lắc",
    example: "quán tính của con lắc",
  },
  {
    word: "quán tính",
    part_of_speech: "danh từ",
    meaning:
      "phản ứng đã trở thành tự nhiên, theo thói quen của cơ thể: chớp mắt theo quán tính",
    example: "chớp mắt theo quán tính",
  },
  {
    word: "quan tiền",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) (đôi khi tiêu cực) viên chức có quyền hành trong bộ máy nhà nước phong kiến, thực dân: quan văn * cửa quan * miệng nhà quan có gang có thép (tng)",
    example: "quan văn * cửa quan * miệng nhà quan có gang có thép (tng)",
  },
  {
    word: "quản trang",
    part_of_speech: "động từ",
    meaning:
      "trông coi, quản lí nghĩa trang: công việc quản trang * tổ quản trang",
    example: "công việc quản trang * tổ quản trang",
  },
  {
    word: "quán trọ",
    part_of_speech: "danh từ",
    meaning: "nhà trọ nhỏ: nghỉ đêm ở một quán trọ ven đường",
    example: "nghỉ đêm ở một quán trọ ven đường",
  },
  {
    word: "quản trị",
    part_of_speech: "động từ",
    meaning:
      "quản lí và điều hành công việc thường ngày (thường về sản xuất, kinh doanh): bầu ban quản trị * phòng quản trị * họp hội đồng quản trị",
    example: "bầu ban quản trị * phòng quản trị * họp hội đồng quản trị",
  },
  {
    word: "quan trọng",
    part_of_speech: "tính từ",
    meaning:
      "có ý nghĩa, tác dụng hoặc có ảnh hưởng lớn, đáng được coi trọng: vai trò quan trọng * nhiệm vụ quan trọng",
    example: "vai trò quan trọng * nhiệm vụ quan trọng",
  },
  {
    word: "quan trắc",
    part_of_speech: "động từ",
    meaning:
      "quan sát, đo đạc các hiện tượng tự nhiên như thiên văn, địa lí, khí tượng, v.v.: dụng cụ quan trắc",
    example: "dụng cụ quan trắc",
  },
  {
    word: "quan trường",
    part_of_speech: "danh từ",
    meaning: "(cũ) giới quan lại: bon chen trong chốn quan trường",
    example: "bon chen trong chốn quan trường",
  },
  {
    word: "quan viên",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) (hiếm) người làm quan, phân biệt với những người dân thường (nói khái quát).",
    example: "các quan viên trong làng",
  },
  {
    word: "quan viên",
    part_of_speech: "danh từ",
    meaning:
      "người có địa vị ở làng xã, được miễn phu phen, tạp dịch dưới thời phong kiến, thực dân (phân biệt với dân đen; nói khái quát): các quan viên trong làng",
    example: "kính mời quan viên hai họ",
  },
  {
    word: "quán triệt",
    part_of_speech: "động từ",
    meaning:
      "hiểu thấu đáo và thể hiện đầy đủ trong hoạt động, hành động: quán triệt đường lối * quán triệt tinh thần * quán triệt nghị quyết",
    example:
      "quán triệt đường lối * quán triệt tinh thần * quán triệt nghị quyết",
  },
  {
    word: "quan trọng hoá",
    part_of_speech: "động từ",
    meaning:
      "làm cho có vẻ quan trọng trong khi thật ra không có gì quan trọng cả: tính hay quan trọng hoá vấn đề",
    example: "tính hay quan trọng hoá vấn đề",
  },
  {
    word: "quán xá",
    part_of_speech: "danh từ",
    meaning:
      "quán nhỏ, nhà hàng nhỏ, nói chung: tìm quán xá để nghỉ chân * la cà quán xá",
    example: "tìm quán xá để nghỉ chân * la cà quán xá",
  },
  {
    word: "quán xuyến",
    part_of_speech: "động từ",
    meaning:
      "bao quát, đảm đương được tất cả: có khả năng quán xuyến * quán xuyến mọi việc trong gia đình",
    example: "có khả năng quán xuyến * quán xuyến mọi việc trong gia đình",
  },
  {
    word: "quán xuyến",
    part_of_speech: "động từ",
    meaning:
      "(quan điểm, tư tưởng) bao trùm và chi phối toàn bộ: tư tưởng nhân đạo quán xuyến toàn bộ tác phẩm",
    example: "tư tưởng nhân đạo quán xuyến toàn bộ tác phẩm",
  },
  {
    word: "quang",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng tết bằng những sợi dây bền để đặt vật gánh đi hoặc treo lên: đôi quang mây",
    example: "đôi quang mây",
  },
  {
    word: "quang",
    part_of_speech: "danh từ",
    meaning: "ánh sáng: phản quang * chất cản quang",
    example: "phản quang * chất cản quang",
  },
  {
    word: "quang",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) quang học (nói tắt): các thiết bị quang",
    example: "các thiết bị quang",
  },
  {
    word: "quan yếu",
    part_of_speech: "tính từ",
    meaning:
      "như quan trọng: vị trí quan yếu * việc quan yếu trước mắt cần làm",
    example: "vị trí quan yếu * việc quan yếu trước mắt cần làm",
  },
  {
    word: "quảng cáo",
    part_of_speech: "động từ",
    meaning:
      "trình bày, giới thiệu rộng rãi để cho nhiều người (thường là khách hàng) biết đến: sản phẩm được quảng cáo trên truyền hình",
    example: "sản phẩm được quảng cáo trên truyền hình",
  },
  {
    word: "quảng cáo",
    part_of_speech: "danh từ",
    meaning:
      "thông tin, chương trình quảng cáo: thu hút khách hàng bằng quảng cáo * bộ phim bị xen quá nhiều quảng cáo",
    example:
      "thu hút khách hàng bằng quảng cáo * bộ phim bị xen quá nhiều quảng cáo",
  },
  {
    word: "quãng",
    part_of_speech: "danh từ",
    meaning:
      "phần không gian hoặc thời gian tương đối ngắn được xác định giữa hai điểm hoặc hai thời điểm: đi cách nhau một quãng * quãng đường phía trước * đọc ngắt quãng",
    example: "đi cách nhau một quãng * quãng đường phía trước * đọc ngắt quãng",
  },
  {
    word: "quãng",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) phần không gian hoặc thời gian tương đối ngắn được xác định một cách đại khái: quãng đời niên thiếu * đứa bé quãng ba bốn tuổi",
    example: "quãng đời niên thiếu * đứa bé quãng ba bốn tuổi",
  },
  {
    word: "quáng",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái thị giác bị rối loạn, trông không rõ do tác động của sự thay đổi cường độ ánh sáng quá đột ngột: chói quá, quáng cả mắt",
    example: "chói quá, quáng cả mắt",
  },
  {
    word: "quàng",
    part_of_speech: "động từ",
    meaning:
      "vòng cánh tay ôm qua người hay qua vai, qua cổ người khác: quàng lấy cổ bạn * quàng tay nhau * ôm quàng lấy mẹ",
    example: "quàng lấy cổ bạn * quàng tay nhau * ôm quàng lấy mẹ",
  },
  {
    word: "quàng",
    part_of_speech: "động từ",
    meaning:
      "mang vào thân mình bằng cách quấn hoặc vòng qua người, qua đầu: quàng tấm khăn * quàng áo mưa * quàng súng trên vai",
    example: "quàng tấm khăn * quàng áo mưa * quàng súng trên vai",
  },
  {
    word: "quàng",
    part_of_speech: "động từ",
    meaning:
      '(hiếm) vướng phải, mắc phải khi đang đi: "Đi đâu mà vội mà vàng, Mà vấp phải đá mà quàng phải dây." (ca dao)',
    example:
      'Đi đâu mà vội mà vàng, Mà vấp phải đá mà quàng phải dây." (ca dao)',
  },
  {
    word: "quàng",
    part_of_speech: "phụ từ",
    meaning:
      "hoặc t (khẩu ngữ) (làm việc gì) một cách nhanh, vội, cốt cho chóng xong để còn làm việc khác: ăn quàng lên rồi đi * chạy quàng ra chợ",
    example: "ăn quàng lên rồi đi * chạy quàng ra chợ",
  },
  {
    word: "quàng",
    part_of_speech: "phụ từ",
    meaning:
      "không kể gì đúng sai: vơ quàng * nhận quàng * thấy người sang bắt quàng làm họ (tng)",
    example: "vơ quàng * nhận quàng * thấy người sang bắt quàng làm họ (tng)",
  },
  {
    word: "quang âm",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) ánh sáng và bóng tối; dùng để chỉ thời gian, ngày giờ: "Nghĩ nhan sắc đương chừng hoa nở, Tiếc quang âm lần lữa gieo qua." (CPN)',
    example:
      'Nghĩ nhan sắc đương chừng hoa nở, Tiếc quang âm lần lữa gieo qua." (CPN)',
  },
  {
    word: "quảng bá",
    part_of_speech: "động từ",
    meaning:
      "phổ biến rộng rãi bằng các phương tiện thông tin: thông tin được quảng bá rộng rãi trên các phương tiện * quảng bá sản phẩm",
    example:
      "thông tin được quảng bá rộng rãi trên các phương tiện * quảng bá sản phẩm",
  },
  {
    word: "quang cảnh",
    part_of_speech: "danh từ",
    meaning:
      "cảnh bày ra rõ ràng trước mắt: quang cảnh ngày mùa * một quang cảnh hãi hùng",
    example: "quang cảnh ngày mùa * một quang cảnh hãi hùng",
  },
  {
    word: "quảng canh",
    part_of_speech: "động từ",
    meaning:
      "(phương thức canh tác) dựa chủ yếu vào việc mở rộng diện tích để tăng sản lượng; phân biệt với thâm canh: canh tác theo phương thức quảng canh * nuôi tôm quảng canh",
    example: "canh tác theo phương thức quảng canh * nuôi tôm quảng canh",
  },
  {
    word: "quang dầu",
    part_of_speech: "động từ",
    meaning:
      "quét lên một lớp quang dầu để làm tăng độ bền và vẻ đẹp: quang dầu chiếc nón",
    example: "quang dầu chiếc nón",
  },
  {
    word: "quáng gà",
    part_of_speech: "tính từ",
    meaning:
      "(mắt) ở tình trạng nhìn không rõ lúc tranh tối tranh sáng: mắt quáng gà",
    example: "mắt quáng gà",
  },
  {
    word: "quang gánh",
    part_of_speech: "danh từ",
    meaning: "quang và đòn gánh (nói khái quát): chuẩn bị quang gánh",
    example: "chuẩn bị quang gánh",
  },
  {
    word: "quang đãng",
    part_of_speech: "tính từ",
    meaning:
      "sáng sủa và rộng rãi (nói khái quát): bầu trời quang đãng * không gian quang đãng, sáng sủa",
    example: "bầu trời quang đãng * không gian quang đãng, sáng sủa",
  },
  {
    word: "quảng đại",
    part_of_speech: "tính từ",
    meaning: "đông đảo, rộng khắp: đáp ứng nhu cầu của quảng đại quần chúng",
    example: "đáp ứng nhu cầu của quảng đại quần chúng",
  },
  {
    word: "quảng đại",
    part_of_speech: "tính từ",
    meaning:
      "(cũ) rộng rãi, độ lượng: một con người quảng đại * có lòng quảng đại",
    example: "một con người quảng đại * có lòng quảng đại",
  },
  {
    word: "quảng giao",
    part_of_speech: "động từ",
    meaning: "(cũ, hiếm) giao thiệp rộng: một con người quảng giao",
    example: "một con người quảng giao",
  },
  {
    word: "quang điện",
    part_of_speech: "danh từ",
    meaning:
      "điện tích (điện tử, ion dương) xuất hiện dưới tác dụng của ánh sáng và do đó vật trở nên dẫn điện: sản phẩm quang điện",
    example: "sản phẩm quang điện",
  },
  {
    word: "quang minh",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) rõ ràng, sáng tỏ: hành động quang minh * người quang minh chính trực",
    example: "hành động quang minh * người quang minh chính trực",
  },
  {
    word: "quang năng",
    part_of_speech: "danh từ",
    meaning: "năng lượng của ánh sáng: chuyển hoá quang năng thành nhiệt năng",
    example: "chuyển hoá quang năng thành nhiệt năng",
  },
  {
    word: "quang quác",
    part_of_speech: "động từ",
    meaning:
      "từ mô phỏng tiếng kêu to, liên tiếp của gà, ngỗng và một số loại chim lớn: tiếng gà kêu quang quác",
    example: "tiếng gà kêu quang quác",
  },
  {
    word: "quang quác",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nói, la rất to, gây cảm giác khó chịu (hàm ý mỉa mai, coi thường): suốt ngày quang quác, điếc cả tai * quang quác cái mồm",
    example: "suốt ngày quang quác, điếc cả tai * quang quác cái mồm",
  },
  {
    word: "quáng quàng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) hết sức vội vàng, hấp tấp: chạy quáng quàng * ăn quáng quàng cho xong bữa",
    example: "chạy quáng quàng * ăn quáng quàng cho xong bữa",
  },
  {
    word: "quàng quạc",
    part_of_speech: "động từ",
    meaning:
      "từ mô phỏng tiếng kêu to và liên tiếp của vịt, ngan, ngỗng: vịt kêu quàng quạc",
    example: "vịt kêu quàng quạc",
  },
  {
    word: "quang quẻ",
    part_of_speech: "tính từ",
    meaning: "quang và có vẻ thoáng đãng (nói khái quát): bầu trời quang quẻ",
    example: "bầu trời quang quẻ",
  },
  {
    word: "quang minh chính đại",
    part_of_speech: "",
    meaning:
      "ngay thẳng, rõ ràng, không chút mờ ám: một con người quang minh chính đại",
    example: "một con người quang minh chính đại",
  },
  {
    word: "quang vinh",
    part_of_speech: "tính từ",
    meaning:
      "có giá trị tinh thần cao, đem lại niềm tự hào chính đáng: sự nghiệp vinh quang * lao động là vinh quang",
    example: "sự nghiệp vinh quang * lao động là vinh quang",
  },
  {
    word: "quảng trường",
    part_of_speech: "danh từ",
    meaning:
      "khu đất trống, rộng trong thành phố, xung quanh thường có những kiến trúc thích hợp phục vụ cho các hoạt động hội họp, mít tinh, v.v. của quần chúng: quảng trường Ba Đình * mít tinh ở quảng trường",
    example: "quảng trường Ba Đình * mít tinh ở quảng trường",
  },
  {
    word: "quánh",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái đặc sệt như dính lại với nhau thành khối: bùn quánh * bát bột đặc quánh",
    example: "bùn quánh * bát bột đặc quánh",
  },
  {
    word: "quanh",
    part_of_speech: "danh từ",
    meaning:
      "phần bao phía ngoài của một vị trí, một khu vực nào đó: rào dây thép gai quanh tường * ngồi vây quanh đống lửa",
    example: "rào dây thép gai quanh tường * ngồi vây quanh đống lửa",
  },
  {
    word: "quanh",
    part_of_speech: "danh từ",
    meaning:
      "những nơi ở gần, làm thành như một vòng bao phía ngoài (nói tổng quát): tìm quanh * chạy quanh * dạo quanh thành phố",
    example: "tìm quanh * chạy quanh * dạo quanh thành phố",
  },
  {
    word: "quanh",
    part_of_speech: "động từ",
    meaning: "di chuyển theo đường vòng: đạp xe quanh lại",
    example: "đạp xe quanh lại",
  },
  {
    word: "quanh",
    part_of_speech: "tính từ",
    meaning:
      "(đường sá, sông ngòi) vòng lượn, uốn khúc: khúc quanh của con sông * dòng nước uốn quanh",
    example: "khúc quanh của con sông * dòng nước uốn quanh",
  },
  {
    word: "quanh",
    part_of_speech: "tính từ",
    meaning:
      '(nói) vòng vèo, tránh không nói sự thật hoặc không đi thẳng vào vấn đề: chối quanh * nói dối quanh * "Lại còn bưng bít giấu quanh, Làm chi những thói trẻ ranh nực cười!" (TKiều)',
    example:
      'chối quanh * nói dối quanh * "Lại còn bưng bít giấu quanh, Làm chi những thói trẻ ranh nực cười!" (TKiều)',
  },
  {
    word: "quàng xiên",
    part_of_speech: "tính từ",
    meaning:
      'bậy bạ, không đúng: ăn nói quàng xiên * "Chẳng qua đồng cốt quàng xiên, Người đâu mà lại thấy trên cõi trần?" (TKiều)',
    example:
      'ăn nói quàng xiên * "Chẳng qua đồng cốt quàng xiên, Người đâu mà lại thấy trên cõi trần?" (TKiều)',
  },
  {
    word: "quạnh hiu",
    part_of_speech: "tính từ",
    meaning:
      'như hiu quạnh: "Một vùng non nước quạnh hiu, Phất phơ gió trúc, dập dìu mưa hoa." (BC)',
    example:
      'Một vùng non nước quạnh hiu, Phất phơ gió trúc, dập dìu mưa hoa." (BC)',
  },
  {
    word: "quanh đi quẩn lại",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) trở đi trở lại mãi (cũng chỉ có thế): quanh đi quẩn lại vẫn một chuyện",
    example: "quanh đi quẩn lại vẫn một chuyện",
  },
  {
    word: "quạnh",
    part_of_speech: "tính từ",
    meaning:
      "vắng vẻ và yên lặng, gây cảm giác trống trải, buồn bã: vắng đàn ông quạnh nhà, vắng đàn bà quạnh bếp (tng)",
    example: "vắng đàn ông quạnh nhà, vắng đàn bà quạnh bếp (tng)",
  },
  {
    word: "quanh quẩn",
    part_of_speech: "",
    meaning:
      "loanh quanh ở một chỗ, không rời đi đâu xa: suốt ngày quanh quẩn trong nhà * chơi quanh quẩn trong sân",
    example: "suốt ngày quanh quẩn trong nhà * chơi quanh quẩn trong sân",
  },
  {
    word: "quanh quẩn",
    part_of_speech: "",
    meaning:
      "(suy nghĩ) trở đi trở lại như cũ, không dứt, không thoát ra được: ý nghĩ ấy cứ quanh quẩn trong đầu",
    example: "ý nghĩ ấy cứ quanh quẩn trong đầu",
  },
  {
    word: "quanh quẩn",
    part_of_speech: "",
    meaning:
      "trở đi trở lại (cũng chỉ có thế): quanh quẩn vẫn ngần ấy việc * quanh quẩn cũng có mấy người",
    example: "quanh quẩn vẫn ngần ấy việc * quanh quẩn cũng có mấy người",
  },
  {
    word: "quanh quánh",
    part_of_speech: "tính từ",
    meaning: "hơi quánh: bùn đất quanh quánh",
    example: "bùn đất quanh quánh",
  },
  {
    word: "quạnh quẽ",
    part_of_speech: "tính từ",
    meaning:
      'quạnh (nói khái quát): nhà quạnh quẽ, một mình một bóng * "Non Kì quạnh quẽ trăng treo, Bến Phì gió thổi đìu hiu mấy gò." (CPN)',
    example:
      'nhà quạnh quẽ, một mình một bóng * "Non Kì quạnh quẽ trăng treo, Bến Phì gió thổi đìu hiu mấy gò." (CPN)',
  },
  {
    word: "quành",
    part_of_speech: "động từ",
    meaning:
      "không theo hướng thẳng mà vòng ngược lại hoặc quanh sang một bên: quành tay ra đằng sau * đi đến chỗ quành",
    example: "quành tay ra đằng sau * đi đến chỗ quành",
  },
  {
    word: "quanh co",
    part_of_speech: "",
    meaning:
      "(đường sá, sông ngòi) có nhiều vòng lượn, uốn khúc, không thẳng: đường đi lối lại quanh co * dòng suối uốn lượn quanh co",
    example: "đường đi lối lại quanh co * dòng suối uốn lượn quanh co",
  },
  {
    word: "quanh co",
    part_of_speech: "",
    meaning: "loanh quanh mãi, có ý giấu giếm: nói quanh co * rào đón quanh co",
    example: "nói quanh co * rào đón quanh co",
  },
  {
    word: "quánh quạnh",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) quánh đến mức như dính bết lại thành tảng, thành khối: bùn đặc quánh quạnh",
    example: "bùn đặc quánh quạnh",
  },
  {
    word: "quanh quất",
    part_of_speech: "danh từ",
    meaning:
      "ở quanh nơi nào đó, không xa: nhìn quanh quất không một bóng người",
    example: "nhìn quanh quất không một bóng người",
  },
  {
    word: "quanh quất",
    part_of_speech: "tính từ",
    meaning:
      '(hiếm) quanh co, không thẳng: "Đường đi quanh quất ruột dê, Chim kêu, vượn hú dựa kề bên non." (ca dao)',
    example:
      'Đường đi quanh quất ruột dê, Chim kêu, vượn hú dựa kề bên non." (ca dao)',
  },
  {
    word: "quanh năm",
    part_of_speech: "danh từ",
    meaning:
      "suốt từ đầu năm đến cuối năm: cây ra hoa quanh năm * quanh năm đầu tắt mặt tối",
    example: "cây ra hoa quanh năm * quanh năm đầu tắt mặt tối",
  },
  {
    word: "quát",
    part_of_speech: "động từ",
    meaning:
      "lớn tiếng mắng mỏ hoặc ra lệnh: quát cho một trận * nói như quát vào tai",
    example: "quát cho một trận * nói như quát vào tai",
  },
  {
    word: "quanh quéo",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ, hiếm) như quanh co: đường đi quanh quéo * nói năng quanh quéo",
    example: "đường đi quanh quéo * nói năng quanh quéo",
  },
  {
    word: "quạnh vắng",
    part_of_speech: "tính từ",
    meaning:
      "rất vắng vẻ, gây cảm giác trống trải, cô đơn: khúc sông quạnh vắng",
    example: "khúc sông quạnh vắng",
  },
  {
    word: "quạt",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng để làm cho không khí chuyển động tạo thành gió: quạt giấy * quạt điện * quạt nan",
    example: "quạt giấy * quạt điện * quạt nan",
  },
  {
    word: "quạt",
    part_of_speech: "động từ",
    meaning:
      "làm cho không khí chuyển động tạo thành gió bằng cái quạt: quạt cho mát * quạt thóc cho sạch",
    example: "quạt cho mát * quạt thóc cho sạch",
  },
  {
    word: "quạt",
    part_of_speech: "động từ",
    meaning:
      "khoát mạnh vào nước bằng mái chèo, cánh tay, v.v. để đẩy thuyền, người lên phía trước: quạt mạnh mái chèo",
    example: "quạt mạnh mái chèo",
  },
  {
    word: "quạt",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bắn liền một loạt đạn một cách dữ dội: quạt một băng tiểu liên",
    example: "quạt một băng tiểu liên",
  },
  {
    word: "quạt",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) phê bình, khiển trách một cách gay gắt: quạt cho một trận nên thân",
    example: "quạt cho một trận nên thân",
  },
  {
    word: "quào",
    part_of_speech: "động từ",
    meaning: "cào bằng các móng nhọn, làm cho rách, xước: bị mèo quào xước tay",
    example: "bị mèo quào xước tay",
  },
  {
    word: "quạt gió",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) quạt lớn, tạo ra luồng gió mạnh, thường dùng trong sản xuất: dùng quạt gió để làm khô thóc",
    example: "dùng quạt gió để làm khô thóc",
  },
  {
    word: "quạt gió",
    part_of_speech: "danh từ",
    meaning: "động cơ chạy bằng sức gió: hệ thống quạt gió",
    example: "hệ thống quạt gió",
  },
  {
    word: "quát mắng",
    part_of_speech: "động từ",
    meaning: "lớn tiếng mắng mỏ: quát mắng ầm ầm",
    example: "quát mắng ầm ầm",
  },
  {
    word: "quát lác",
    part_of_speech: "động từ",
    meaning:
      "quát, với vẻ hách dịch (nói khái quát): suốt ngày quát lác con cái",
    example: "suốt ngày quát lác con cái",
  },
  {
    word: "quát tháo",
    part_of_speech: "động từ",
    meaning:
      "quát mắng với vẻ giận dữ hay hách dịch: quát tháo ầm ĩ * luôn miệng quát tháo",
    example: "quát tháo ầm ĩ * luôn miệng quát tháo",
  },
  {
    word: "quạu",
    part_of_speech: "động từ",
    meaning: "(Phương ngữ) cáu: nổi quạu",
    example: "nổi quạu",
  },
  {
    word: "quạu quọ",
    part_of_speech: "",
    meaning: "(phương ngữ) cau có: mặt quạu quọ",
    example: "mặt quạu quọ",
  },
  {
    word: "quay",
    part_of_speech: "động từ",
    meaning:
      "chuyển động hoặc làm cho chuyển động quanh một trục hay một điểm ở trung tâm một cách đều đặn, liên tục: cánh chong chóng quay tít * quay tơ * Trái Đất quay quanh Mặt Trời",
    example:
      "cánh chong chóng quay tít * quay tơ * Trái Đất quay quanh Mặt Trời",
  },
  {
    word: "quay",
    part_of_speech: "động từ",
    meaning:
      "chuyển động hoặc làm cho chuyển động để đổi hướng, để hướng về phía nào đó: quay mặt đi, không nhìn * đứng quay lưng lại * đi được một đoạn lại quay về",
    example:
      "quay mặt đi, không nhìn * đứng quay lưng lại * đi được một đoạn lại quay về",
  },
  {
    word: "quay",
    part_of_speech: "động từ",
    meaning:
      "chuyển tiếp sang hoạt động khác, việc khác: hết việc này lại quay sang việc khác",
    example: "hết việc này lại quay sang việc khác",
  },
  {
    word: "quay",
    part_of_speech: "động từ",
    meaning:
      "làm chín vàng cả khối thịt bằng cách xoay đều trên lửa hoặc rán trong chảo mỡ đậy kín: quay con gà * thịt quay",
    example: "quay con gà * thịt quay",
  },
  {
    word: "quay",
    part_of_speech: "động từ",
    meaning: "quay phim (nói tắt): bộ phim mới quay * khởi quay",
    example: "bộ phim mới quay * khởi quay",
  },
  {
    word: "quay",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) hỏi vặn vẹo cặn kẽ (thường nói về việc hỏi bài, thi cử): bị thầy giáo quay * quay cho một lúc, không biết đường nào mà trả lời",
    example:
      "bị thầy giáo quay * quay cho một lúc, không biết đường nào mà trả lời",
  },
  {
    word: "quay",
    part_of_speech: "danh từ",
    meaning:
      'đồ chơi của trẻ em, bằng gỗ, khi chơi thì đánh cho quay tít: đẽo quay * "Cái quay búng sẵn trên trời, Mờ mờ nhân ảnh như người đi đêm." (CO)',
    example:
      'đẽo quay * "Cái quay búng sẵn trên trời, Mờ mờ nhân ảnh như người đi đêm." (CO)',
  },
  {
    word: "quàu quạu",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) như càu cạu: mặt mũi lúc nào cũng quàu quạu",
    example: "mặt mũi lúc nào cũng quàu quạu",
  },
  {
    word: "quay cuồng",
    part_of_speech: "động từ",
    meaning:
      "quay tròn rất nhanh, như bị cuốn vào, làm cho không còn biết gì nữa: múa may quay cuồng * đầu óc quay cuồng",
    example: "múa may quay cuồng * đầu óc quay cuồng",
  },
  {
    word: "quày",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) buồng (quả cây): quày dừa",
    example: "quày dừa",
  },
  {
    word: "quày",
    part_of_speech: "động từ",
    meaning:
      '(phương ngữ) quay lại: "Thuyền không bánh lái thuyền quày, Con không cha mẹ, ai bày con nên?" (ca dao)',
    example:
      'Thuyền không bánh lái thuyền quày, Con không cha mẹ, ai bày con nên?" (ca dao)',
  },
  {
    word: "quay lơ",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) lăn ra, lăn quay ra: ngã quay lơ * nằm quay lơ giữa nhà",
    example: "ngã quay lơ * nằm quay lơ giữa nhà",
  },
  {
    word: "quay cóp",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) sao chép lại bài làm của người khác hoặc tài liệu giấu mang theo, khi làm bài kiểm tra hoặc thi cử (nói khái quát): quay cóp bài của bạn",
    example: "quay cóp bài của bạn",
  },
  {
    word: "quay quắt",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) xảo trá, tráo trở, hay lừa lọc: con người quay quắt * lòng dạ quay quắt",
    example: "con người quay quắt * lòng dạ quay quắt",
  },
  {
    word: "quay quắt",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) ở mức độ đứng ngồi không yên: nhớ quay quắt",
    example: "nhớ quay quắt",
  },
  {
    word: "quay đĩa",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) máy quay đĩa (nói tắt): chiếc quay đĩa đời cũ",
    example: "chiếc quay đĩa đời cũ",
  },
  {
    word: "quày quả",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có dáng điệu vội vã như đang quá bận, quá nhiều việc phải lo: nói xong vội quày quả đi ngay",
    example: "nói xong vội quày quả đi ngay",
  },
  {
    word: "quay tít",
    part_of_speech: "động từ",
    meaning:
      "quay rất nhanh, đến mức không còn nhìn rõ hình dạng của vật quay: bánh xe quay tít * cánh quạt quay tít",
    example: "bánh xe quay tít * cánh quạt quay tít",
  },
  {
    word: "quặm",
    part_of_speech: "tính từ",
    meaning: "cong xuống và quặp ngược lại: mũi quặm * mỏ quặm như mỏ diều hâu",
    example: "mũi quặm * mỏ quặm như mỏ diều hâu",
  },
  {
    word: "quặm",
    part_of_speech: "danh từ",
    meaning: "lông quặm (nói tắt): mắt có quặm",
    example: "mắt có quặm",
  },
  {
    word: "quắc",
    part_of_speech: "động từ",
    meaning:
      "giương to mắt nhìn với ánh mắt khác thường, biểu thị thái độ giận dữ, bất bình hay đe doạ: quắc mắt lên nhìn * mắt quắc lên giận giữ",
    example: "quắc mắt lên nhìn * mắt quắc lên giận giữ",
  },
  {
    word: "quay vòng",
    part_of_speech: "động từ",
    meaning:
      "lặp lại nhiều lần một quá trình trong sản xuất: lối sản xuất quay vòng",
    example: "lối sản xuất quay vòng",
  },
  {
    word: "quay vòng",
    part_of_speech: "động từ",
    meaning:
      "sử dụng luân chuyển tiền bạc, phương tiện sản xuất một cách liên tục, hết vào việc này tiếp luôn vào việc khác: thu hồi vốn nhanh để quay vòng",
    example: "thu hồi vốn nhanh để quay vòng",
  },
  {
    word: "quặc",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) móc vào, ngoắc vào: quặc chiếc áo lên móc * bị gai quặc rách cả một mảng áo",
    example: "quặc chiếc áo lên móc * bị gai quặc rách cả một mảng áo",
  },
  {
    word: "quặc",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) cãi lại, tỏ thái độ phản ứng: nghe ngứa tai nên quặc lại",
    example: "nghe ngứa tai nên quặc lại",
  },
  {
    word: "quắc thước",
    part_of_speech: "tính từ",
    meaning:
      "(người đàn ông tuổi đã cao) có vẻ mạnh khoẻ, nhanh nhẹn và rắn rỏi: cụ già quắc thước",
    example: "cụ già quắc thước",
  },
  {
    word: "quăm quắm",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả vẻ nhìn gườm gườm, không chớp mắt, trông dễ sợ: nhìn quăm quắm * mắt quăm quắm",
    example: "nhìn quăm quắm * mắt quăm quắm",
  },
  {
    word: "quăn",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái bị cong hay bị cuộn lại, không thẳng: vở bị quăn góc * tóc uốn quăn",
    example: "vở bị quăn góc * tóc uốn quăn",
  },
  {
    word: "quắn",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) rất quăn, có vẻ như xoắn lại: tóc quắn tít",
    example: "tóc quắn tít",
  },
  {
    word: "quắn",
    part_of_speech: "tính từ",
    meaning:
      "(thông tục) ở trạng thái co rúm lại: chè pha đặc quắn lưỡi * phết cho quắn đít",
    example: "chè pha đặc quắn lưỡi * phết cho quắn đít",
  },
  {
    word: "quằm quặm",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả vẻ mặt, cái nhìn lạnh lùng, thâm hiểm đáng gờm: mặt quằm quặm * mắt nhìn quằm quặm",
    example: "mặt quằm quặm * mắt nhìn quằm quặm",
  },
  {
    word: "quằn quại",
    part_of_speech: "động từ",
    meaning: "vặn mình, vật vã vì quá đau đớn: đau bụng quằn quại",
    example: "đau bụng quằn quại",
  },
  {
    word: "quằn quặn",
    part_of_speech: "tính từ",
    meaning:
      'hơi quặn: "Đêm năm canh nguyệt lặn sao dời, Ngày sáu khắc ruột đau quằn quặn." (MPXH)',
    example:
      'Đêm năm canh nguyệt lặn sao dời, Ngày sáu khắc ruột đau quằn quặn." (MPXH)',
  },
  {
    word: "quặng",
    part_of_speech: "danh từ",
    meaning:
      "chất lấy từ dưới đất lên, chứa nguyên tố có ích mà hàm lượng đủ lớn để có thể khai thác được: quặng sắt * mỏ quặng",
    example: "quặng sắt * mỏ quặng",
  },
  {
    word: "quăn queo",
    part_of_speech: "tính từ",
    meaning:
      "quăn nhiều và có vẻ rối (nói khái quát): tập giấy quăn queo * thanh sắt quăn queo",
    example: "tập giấy quăn queo * thanh sắt quăn queo",
  },
  {
    word: "quặn",
    part_of_speech: "",
    meaning: "có cảm giác như ruột bị thắt, bị xoắn lại: lòng quặn đau",
    example: "lòng quặn đau",
  },
  {
    word: "quằn",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái không còn sắc, nhọn, do đâm, chém mạnh phải vật cứng hơn: dao bị quằn lưỡi * quằn mũi khoan",
    example: "dao bị quằn lưỡi * quằn mũi khoan",
  },
  {
    word: "quằn",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái bị cong xuống do bị đè quá nặng: gánh nặng quằn cả đòn gánh * quằn người vì đau đớn * con giun xéo lắm cũng quằn (tng)",
    example:
      "gánh nặng quằn cả đòn gánh * quằn người vì đau đớn * con giun xéo lắm cũng quằn (tng)",
  },
  {
    word: "quặn thắt",
    part_of_speech: "tính từ",
    meaning:
      "quặn đau, có cảm giác như ruột co thắt lại: ruột quặn thắt từng hồi",
    example: "ruột quặn thắt từng hồi",
  },
  {
    word: "quăng quật",
    part_of_speech: "động từ",
    meaning:
      "để lung tung, không chú ý giữ gìn: sách vở quăng quật mỗi nơi mỗi quyển",
    example: "sách vở quăng quật mỗi nơi mỗi quyển",
  },
  {
    word: "quăng quật",
    part_of_speech: "động từ",
    meaning:
      "lăn lộn một cách vất vả, khó nhọc để kiếm sống: suốt ngày quăng quật với cơm áo",
    example: "suốt ngày quăng quật với cơm áo",
  },
  {
    word: "quẳng",
    part_of_speech: "động từ",
    meaning:
      "thẳng tay quăng đi, ném đi: quẳng ba lô xuống đất * quẳng xuống ao",
    example: "quẳng ba lô xuống đất * quẳng xuống ao",
  },
  {
    word: "quẳng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) vứt đi, bỏ đi một cách không thương tiếc: quẳng tiền vào cờ bạc * tờ giấy ấy chỉ đáng quẳng vào sọt rác",
    example: "quẳng tiền vào cờ bạc * tờ giấy ấy chỉ đáng quẳng vào sọt rác",
  },
  {
    word: "quắp",
    part_of_speech: "động từ",
    meaning: "co, gập cong vào phía trong: chó quắp đuôi chạy mất * râu quắp",
    example: "chó quắp đuôi chạy mất * râu quắp",
  },
  {
    word: "quắp",
    part_of_speech: "động từ",
    meaning:
      "co, gập vào để ôm, giữ cho chặt: quắp chặt miếng mồi * nằm quắp lấy nhau cho ấm",
    example: "quắp chặt miếng mồi * nằm quắp lấy nhau cho ấm",
  },
  {
    word: "quắp",
    part_of_speech: "động từ",
    meaning:
      "bắt, lấy đi bằng cách co gập vào để ôm, giữ cho chặt: diều hâu quắp gà con",
    example: "diều hâu quắp gà con",
  },
  {
    word: "quắt",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái bị teo lại, sắt lại do khô héo hoặc gầy mòn: bông hoa héo quắt * ốm lâu ngày, tay chân quắt lại",
    example: "bông hoa héo quắt * ốm lâu ngày, tay chân quắt lại",
  },
  {
    word: "quắt queo",
    part_of_speech: "tính từ",
    meaning:
      "quắt (nói khái quát): sau trận ốm, người quắt queo lại * gầy quắt queo",
    example: "sau trận ốm, người quắt queo lại * gầy quắt queo",
  },
  {
    word: "quăng",
    part_of_speech: "động từ",
    meaning:
      'vung tay ném ngang và mạnh ra xa: quăng lựu đạn * "Một mình thong thả làm ăn, Khoẻ quơ chài lưới mệt quăng câu dầm." (LVT)',
    example:
      'quăng lựu đạn * "Một mình thong thả làm ăn, Khoẻ quơ chài lưới mệt quăng câu dầm." (LVT)',
  },
  {
    word: "quăng",
    part_of_speech: "động từ",
    meaning: "(Phương ngữ) vứt bỏ đi: quăng vũ khí bỏ chạy",
    example: "quăng vũ khí bỏ chạy",
  },
  {
    word: "quặt",
    part_of_speech: "động từ",
    meaning:
      "bẻ gập theo hướng ngược với bình thường: trói quặt tay ra đằng sau",
    example: "trói quặt tay ra đằng sau",
  },
  {
    word: "quặt",
    part_of_speech: "động từ",
    meaning:
      "rẽ sang hướng khác: quặt sang bên tay phải * đang đi tự nhiên rẽ quặt lại",
    example: "quặt sang bên tay phải * đang đi tự nhiên rẽ quặt lại",
  },
  {
    word: "quặt quẹo",
    part_of_speech: "tính từ",
    meaning:
      "hay đau yếu (thường nói về trẻ con): thằng bé quặt quẹo lắm * đau ốm quặt quẹo",
    example: "thằng bé quặt quẹo lắm * đau ốm quặt quẹo",
  },
  {
    word: "quặp",
    part_of_speech: "động từ",
    meaning: "quắp hẳn lại: bẻ quặp vào * chim mỏ quặp",
    example: "bẻ quặp vào * chim mỏ quặp",
  },
  {
    word: "quẫn",
    part_of_speech: "tính từ",
    meaning:
      "ở vào tình trạng khó khăn bế tắc, đến mức như không có lối thoát (thường là về đời sống vật chất): quẫn quá hoá liều * cảnh nhà đang lúc quẫn",
    example: "quẫn quá hoá liều * cảnh nhà đang lúc quẫn",
  },
  {
    word: "quẫn",
    part_of_speech: "tính từ",
    meaning:
      "ở vào trạng thái rối trí đến mức thiếu sáng suốt để tìm ra cách giải quyết: nhiều việc quá mà đâm quẫn",
    example: "nhiều việc quá mà đâm quẫn",
  },
  {
    word: "quân",
    part_of_speech: "danh từ",
    meaning: "quân đội (nói tắt): rút quân về nước * tình đoàn kết quân dân",
    example: "rút quân về nước * tình đoàn kết quân dân",
  },
  {
    word: "quân",
    part_of_speech: "danh từ",
    meaning: "quân sự (nói tắt): bàn việc quân",
    example: "bàn việc quân",
  },
  {
    word: "quân",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) người trực tiếp chịu sự chỉ huy (của người khác): bắt được cả quân lẫn tướng * đem quân đi dẹp giặc",
    example: "bắt được cả quân lẫn tướng * đem quân đi dẹp giặc",
  },
  {
    word: "quân",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) hạng người đáng khinh (thường dùng để mắng nhiếc, nguyền rủa): quân giết người * quân lừa đảo * quân bán nước",
    example: "quân giết người * quân lừa đảo * quân bán nước",
  },
  {
    word: "quân",
    part_of_speech: "danh từ",
    meaning: "con bài, con cờ: quân xe * ăn quân pháo * đi quân tốt",
    example: "quân xe * ăn quân pháo * đi quân tốt",
  },
  {
    word: "quẩn",
    part_of_speech: "động từ",
    meaning:
      "di chuyển quanh một điểm, một phạm vi hẹp, không rời xa ra được: khói quẩn trong phòng * gà què ăn quẩn cối xay (tng)",
    example: "khói quẩn trong phòng * gà què ăn quẩn cối xay (tng)",
  },
  {
    word: "quẩn",
    part_of_speech: "động từ",
    meaning:
      "bị vướng víu hoặc bị cản trở trong sự vận động, di chuyển: làm quẩn chân người khác",
    example: "làm quẩn chân người khác",
  },
  {
    word: "quẩn",
    part_of_speech: "tính từ",
    meaning:
      "thiếu sáng suốt, không còn có khả năng suy nghĩ để tìm ra lối thoát tích cực: tính quẩn * hay nghĩ quẩn",
    example: "tính quẩn * hay nghĩ quẩn",
  },
  {
    word: "quấn",
    part_of_speech: "động từ",
    meaning:
      "cuộn những vật có hình sợi hay dải mỏng thành nhiều vòng bao quanh vật gì: quấn chỉ vào lõi * quấn thêm chăn cho ấm * quấn chặt bằng một cuộn dây thừng",
    example:
      "quấn chỉ vào lõi * quấn thêm chăn cho ấm * quấn chặt bằng một cuộn dây thừng",
  },
  {
    word: "quấn",
    part_of_speech: "động từ",
    meaning:
      "lúc nào cũng ở bên cạnh người nào đó, không chịu rời, vì yêu mến, quyến luyến: trẻ quấn hơi mẹ * hai chị em lúc nào cũng quấn lấy nhau",
    example: "trẻ quấn hơi mẹ * hai chị em lúc nào cũng quấn lấy nhau",
  },
  {
    word: "quần",
    part_of_speech: "động từ",
    meaning:
      "hành động, hoạt động liên tục tác động mạnh mẽ đến một đối tượng nào đó, làm cho phải mệt mỏi, thần kinh luôn luôn căng thẳng: quần nhau với giặc * máy bay địch quần suốt ngày đêm",
    example: "quần nhau với giặc * máy bay địch quần suốt ngày đêm",
  },
  {
    word: "quần âu",
    part_of_speech: "danh từ",
    meaning:
      "quần kiểu Âu, có cạp, ống may đứng, rộng vừa phải, trông gọn: mặc sơ mi với quần âu",
    example: "mặc sơ mi với quần âu",
  },
  {
    word: "quần áo",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng để mặc, như quần, áo, v.v. (nói khái quát): cửa hàng quần áo may sẵn * quần áo chỉnh tề",
    example: "cửa hàng quần áo may sẵn * quần áo chỉnh tề",
  },
  {
    word: "quận",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) khu vực hành chính dưới thời phong kiến Trung Quốc đô hộ: quận Giao Chỉ",
    example: "quận Giao Chỉ",
  },
  {
    word: "quận",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị hành chính ở nội thành, gồm nhiều phường, ngang với huyện ở nông thôn: uỷ ban nhân dân quận * quận Tây Hồ",
    example: "uỷ ban nhân dân quận * quận Tây Hồ",
  },
  {
    word: "quẫn bách",
    part_of_speech: "tính từ",
    meaning:
      "ở vào tình trạng khốn đốn ngặt nghèo đến mức không biết làm thế nào, không có cách nào để tháo gỡ: cảnh nhà quẫn bách * lâm vào cảnh quẫn bách",
    example: "cảnh nhà quẫn bách * lâm vào cảnh quẫn bách",
  },
  {
    word: "quân báo",
    part_of_speech: "danh từ",
    meaning: "tình báo của quân đội: chiến sĩ quân báo * hoạt động quân báo",
    example: "chiến sĩ quân báo * hoạt động quân báo",
  },
  {
    word: "quân bưu",
    part_of_speech: "danh từ",
    meaning:
      "công tác bưu chính trong nội bộ tổ chức quân đội: chiến sĩ quân bưu",
    example: "chiến sĩ quân bưu",
  },
  {
    word: "quân chủ",
    part_of_speech: "tính từ",
    meaning: "(chế độ) có vua đứng đầu nhà nước: nước quân chủ * nền quân chủ",
    example: "nước quân chủ * nền quân chủ",
  },
  {
    word: "quân cảng",
    part_of_speech: "danh từ",
    meaning: "cảng dùng cho hải quân: quân cảng Cam Ranh",
    example: "quân cảng Cam Ranh",
  },
  {
    word: "quân chính",
    part_of_speech: "danh từ",
    meaning:
      "quân sự và chính trị (nói gộp): hội nghị quân chính * học trường quân chính",
    example: "hội nghị quân chính * học trường quân chính",
  },
  {
    word: "quân bình",
    part_of_speech: "tính từ",
    meaning:
      "cân bằng, ngang bằng nhau: lực lượng hai bên ở thế quân bình * tính quân bình",
    example: "lực lượng hai bên ở thế quân bình * tính quân bình",
  },
  {
    word: "quần chúng",
    part_of_speech: "danh từ",
    meaning:
      "những người dân bình thường trong xã hội (trong quan hệ với lực lượng lãnh đạo, nói tổng quát): sự nghiệp của quần chúng * xa rời quần chúng",
    example: "sự nghiệp của quần chúng * xa rời quần chúng",
  },
  {
    word: "quần chúng",
    part_of_speech: "danh từ",
    meaning:
      "số đông người ngoài đảng và là đối tượng lãnh đạo trực tiếp của một tổ chức đảng (nói trong quan hệ với tổ chức đảng ấy): cán bộ Đảng viên phải đi sâu, đi sát quần chúng",
    example: "cán bộ Đảng viên phải đi sâu, đi sát quần chúng",
  },
  {
    word: "quần chúng",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) người ngoài đảng (nói trong quan hệ với đảng lãnh đạo): một quần chúng tích cực",
    example: "một quần chúng tích cực",
  },
  {
    word: "quân công",
    part_of_speech: "danh từ",
    meaning:
      "công trạng lập được trong quân đội (huân chương cao nhất của lực lượng vũ trang nhân dân Việt Nam): được tặng thưởng quân công hạng nhất",
    example: "được tặng thưởng quân công hạng nhất",
  },
  {
    word: "quân cơ",
    part_of_speech: "danh từ",
    meaning: "(cũ) việc quân sự cơ mật: tiết lộ quân cơ * nắm giữ quân cơ",
    example: "tiết lộ quân cơ * nắm giữ quân cơ",
  },
  {
    word: "quân chủng",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận phân loại cơ bản của quân đội, gồm có lục quân, hải quân, không quân, mỗi bộ phận được rèn luyện chiến đấu ở một môi trường địa lí nhất định (trên bộ, trên biển hoặc trên không): quân chủng không quân * quân chủng hải quân",
    example: "quân chủng không quân * quân chủng hải quân",
  },
  {
    word: "quân dân",
    part_of_speech: "danh từ",
    meaning:
      "quân đội và nhân dân (nói gộp): tình quân dân * quân dân cả nước đều đồng lòng nhất trí",
    example: "tình quân dân * quân dân cả nước đều đồng lòng nhất trí",
  },
  {
    word: "quần cư",
    part_of_speech: "động từ",
    meaning:
      "tụ họp ở một nơi để cùng sinh sống: người chạy loạn đến quần cư nơi này",
    example: "người chạy loạn đến quần cư nơi này",
  },
  {
    word: "quân dụng",
    part_of_speech: "tính từ",
    meaning: "dùng cho quân đội: hàng quân dụng * kho quân dụng",
    example: "hàng quân dụng * kho quân dụng",
  },
  {
    word: "quân dụng",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng để phục vụ cho quân đội (thường là được cấp, phát): chuẩn bị đầy đủ quân trang, quân dụng",
    example: "chuẩn bị đầy đủ quân trang, quân dụng",
  },
  {
    word: "quân dịch",
    part_of_speech: "danh từ",
    meaning:
      "nghĩa vụ công dân tham gia phục vụ quân đội khi có chiến sự (thường nói về quân đội của các nước tư bản): trốn quân dịch * bị gọi đi quân dịch",
    example: "trốn quân dịch * bị gọi đi quân dịch",
  },
  {
    word: "quân giới",
    part_of_speech: "danh từ",
    meaning:
      "các thứ vũ khí, đạn dược của quân đội: xưởng quân giới * ngành quân giới",
    example: "xưởng quân giới * ngành quân giới",
  },
  {
    word: "quần đảo",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp nhiều đảo ở gần nhau trong một khu vực địa lí nhất định: quần đảo Trường Sa",
    example: "quần đảo Trường Sa",
  },
  {
    word: "quân hàm",
    part_of_speech: "danh từ",
    meaning: "cấp bậc trong quân đội: quân hàm trung tá",
    example: "quân hàm trung tá",
  },
  {
    word: "quân hàm",
    part_of_speech: "danh từ",
    meaning: "phù hiệu quân hàm: đeo quân hàm đại uý",
    example: "đeo quân hàm đại uý",
  },
  {
    word: "quân đội",
    part_of_speech: "danh từ",
    meaning:
      "lực lượng vũ trang tập trung của một nước, phục vụ cho mục đích chính trị: thành lập quân đội * phục vụ trong quân đội",
    example: "thành lập quân đội * phục vụ trong quân đội",
  },
  {
    word: "quân hành",
    part_of_speech: "động từ",
    meaning: "(cũ) hành quân: hát khúc quân hành * bước quân hành",
    example: "hát khúc quân hành * bước quân hành",
  },
  {
    word: "quân khu",
    part_of_speech: "danh từ",
    meaning:
      "khu quân sự được phân ra theo yêu cầu chiến lược, đứng đầu là một bộ tư lệnh và trực tiếp dưới quyền bộ tổng tư lệnh: quân khu III * bộ tư lệnh quân khu",
    example: "quân khu III * bộ tư lệnh quân khu",
  },
  {
    word: "quân kì",
    part_of_speech: "danh từ",
    meaning: "cờ chính thức của quân đội: tuyên thệ trước quân kì",
    example: "tuyên thệ trước quân kì",
  },
  {
    word: "quân khí",
    part_of_speech: "danh từ",
    meaning:
      "vũ khí, khí tài, đạn dược và các thứ phụ kiện của quân đội (nói khái quát): kho quân khí",
    example: "kho quân khí",
  },
  {
    word: "quân khí",
    part_of_speech: "danh từ",
    meaning:
      "ngành công tác của quân đội, chuyên làm nhiệm vụ bảo quản, cấp phát và sửa chữa quân khí: xưởng quân khí",
    example: "xưởng quân khí",
  },
  {
    word: "quân kỳ",
    part_of_speech: "danh từ",
    meaning: "cờ chính thức của quân đội: tuyên thệ trước quân kì",
    example: "tuyên thệ trước quân kì",
  },
  {
    word: "quân lệnh",
    part_of_speech: "danh từ",
    meaning: "mệnh lệnh quân sự: chấp hành quân lệnh * quân lệnh như sơn",
    example: "chấp hành quân lệnh * quân lệnh như sơn",
  },
  {
    word: "quần là áo lượt",
    part_of_speech: "",
    meaning:
      'quần bằng là, áo bằng lượt; tả cảnh sống giàu sang: "Người giầu má đỏ, mày xanh, Quần là áo lượt đua tranh lên đường." (TS)',
    example:
      'Người giầu má đỏ, mày xanh, Quần là áo lượt đua tranh lên đường." (TS)',
  },
  {
    word: "quân lính",
    part_of_speech: "danh từ",
    meaning: "lính, nói chung: ra lệnh cho quân lính",
    example: "ra lệnh cho quân lính",
  },
  {
    word: "quân ngũ",
    part_of_speech: "danh từ",
    meaning: "hàng ngũ quân đội: trở lại quân ngũ * rời quân ngũ",
    example: "trở lại quân ngũ * rời quân ngũ",
  },
  {
    word: "quân luật",
    part_of_speech: "danh từ",
    meaning: "kỉ luật trong quân đội: xử theo quân luật * thiết quân luật",
    example: "xử theo quân luật * thiết quân luật",
  },
  {
    word: "quân lương",
    part_of_speech: "danh từ",
    meaning: "lương thực của quân đội: chuẩn bị đầy đủ quân lương",
    example: "chuẩn bị đầy đủ quân lương",
  },
  {
    word: "quân nhạc",
    part_of_speech: "danh từ",
    meaning: "nhạc của quân đội: cử quân nhạc",
    example: "cử quân nhạc",
  },
  {
    word: "quân nhạc",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) đội quân nhạc (nói tắt): quân nhạc bắt đầu vào vị trí",
    example: "quân nhạc bắt đầu vào vị trí",
  },
  {
    word: "quân nhân",
    part_of_speech: "danh từ",
    meaning:
      "người thuộc quân đội: trách nhiệm người quân nhân * danh dự quân nhân * quân nhân tại ngũ",
    example:
      "trách nhiệm người quân nhân * danh dự quân nhân * quân nhân tại ngũ",
  },
  {
    word: "quần ngựa",
    part_of_speech: "danh từ",
    meaning: "trường đua ngựa: sân quần ngựa",
    example: "sân quần ngựa",
  },
  {
    word: "quân lực",
    part_of_speech: "danh từ",
    meaning: "lực lượng quân đội: quân lực dồi dào",
    example: "quân lực dồi dào",
  },
  {
    word: "quân nhu",
    part_of_speech: "danh từ",
    meaning:
      "những thứ cần thiết cho đời sống vật chất của quân đội (nói khái quát): kho quân nhu * phát quân nhu",
    example: "kho quân nhu * phát quân nhu",
  },
  {
    word: "quần quật",
    part_of_speech: "tính từ",
    meaning:
      "(lao động) nặng nhọc, vất vả liên tục và kéo dài, tựa như không có lúc nghỉ: làm quần quật * quần quật suốt ngày mà vẫn không đủ ăn",
    example: "làm quần quật * quần quật suốt ngày mà vẫn không đủ ăn",
  },
  {
    word: "quấn quýt",
    part_of_speech: "động từ",
    meaning: "(Ít dùng) quấn vào nhau nhiều vòng: dây dợ quấn quýt",
    example: "dây dợ quấn quýt",
  },
  {
    word: "quấn quýt",
    part_of_speech: "động từ",
    meaning:
      "luôn luôn ở bên nhau như không thể rời ra, vì yêu mến, quyến luyến: hai đứa lúc nào cũng quấn quýt bên nhau",
    example: "hai đứa lúc nào cũng quấn quýt bên nhau",
  },
  {
    word: "quân pháp",
    part_of_speech: "danh từ",
    meaning: "luật pháp trong quân đội: chiểu theo quân pháp",
    example: "chiểu theo quân pháp",
  },
  {
    word: "quân phiệt",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất của chủ nghĩa quân phiệt, dựa vào vũ lực để áp chế người khác một cách độc đoán: tư tưởng quân phiệt * hành động quân phiệt",
    example: "tư tưởng quân phiệt * hành động quân phiệt",
  },
  {
    word: "quân quản",
    part_of_speech: "động từ",
    meaning:
      "(chính quyền) được quân đội điều hành trong hoàn cảnh đặc biệt: ban quân quản",
    example: "ban quân quản",
  },
  {
    word: "quân phục",
    part_of_speech: "danh từ",
    meaning:
      "quần áo đồng phục của quân nhân: quân phục chỉnh tề * mặc quân phục",
    example: "quân phục chỉnh tề * mặc quân phục",
  },
  {
    word: "quẩn quanh",
    part_of_speech: "",
    meaning: "như quanh quẩn: quẩn quanh cũng vẫn từng ấy việc",
    example: "quẩn quanh cũng vẫn từng ấy việc",
  },
  {
    word: "quân sư",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người bày mưu tính kế, vạch các kế hoạch quân sự giúp cho người chỉ huy quân đội thời xưa: Nguyễn Trãi là quân sư của Lê Lợi",
    example: "Nguyễn Trãi là quân sư của Lê Lợi",
  },
  {
    word: "quần tam tụ ngũ",
    part_of_speech: "",
    meaning:
      "túm năm tụm ba (thường để làm những việc xấu): suốt ngày chỉ quần tam tụ ngũ để cờ bạc, rượu chè",
    example: "suốt ngày chỉ quần tam tụ ngũ để cờ bạc, rượu chè",
  },
  {
    word: "quân số",
    part_of_speech: "danh từ",
    meaning: "số quân trong quân đội: kiểm tra quân số * giảm quân số",
    example: "kiểm tra quân số * giảm quân số",
  },
  {
    word: "quân sự",
    part_of_speech: "danh từ",
    meaning:
      "việc xây dựng lực lượng vũ trang và đấu tranh vũ trang (nói tổng quát): đường lối quân sự * việc quân sự",
    example: "đường lối quân sự * việc quân sự",
  },
  {
    word: "quân sự",
    part_of_speech: "tính từ",
    meaning: "thuộc về quân đội: cơ quan quân sự * khoa học quân sự",
    example: "cơ quan quân sự * khoa học quân sự",
  },
  {
    word: "quân sự",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) nghiêm túc, khẩn trương, gọn gàng, như trong quân đội: có tác phong quân sự",
    example: "có tác phong quân sự",
  },
  {
    word: "quần thần",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) các quan trong triều, xét trong quan hệ với vua (nói tổng quát): quần thần trong triều",
    example: "quần thần trong triều",
  },
  {
    word: "quần thảo",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) đọ sức nhau, thường là kéo dài và giữa nhiều người, để giành phần thắng: bọn cướp quần thảo nhau",
    example: "bọn cướp quần thảo nhau",
  },
  {
    word: "quần thể",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp các cá thể sinh vật cùng loài, sống cùng một nơi: quần thể san hô * quần thể động vật quý hiếm",
    example: "quần thể san hô * quần thể động vật quý hiếm",
  },
  {
    word: "quần thể",
    part_of_speech: "danh từ",
    meaning:
      "tổ hợp kiến trúc không gian nhất quán, gồm những nhà cửa, công trình, tượng đài bố trí một cách hợp lí, xây dựng với một ý đồ tư tưởng - nghệ thuật nhất định: quần thể kiến trúc",
    example: "quần thể kiến trúc",
  },
  {
    word: "quân thù",
    part_of_speech: "danh từ",
    meaning:
      "những kẻ gây hại lớn cho đất nước, dân tộc mình mà mình căm thù sâu sắc (nói tổng quát): tiêu diệt quân thù",
    example: "tiêu diệt quân thù",
  },
  {
    word: "quân tịch",
    part_of_speech: "danh từ",
    meaning:
      "tư cách pháp lí của quân nhân tại ngũ, có quyền lợi, nghĩa vụ được luật pháp, điều lệnh, điều lệ quân đội và các văn bản pháp quy khác của nhà nước quy định: tước quân tịch",
    example: "tước quân tịch",
  },
  {
    word: "quân tình nguyện",
    part_of_speech: "danh từ",
    meaning:
      "đội quân tổ chức trên cơ sở tự nguyện để giúp một dân tộc khác chiến đấu chống kẻ thù chung: quân tình nguyện Việt Nam tại Campuchia",
    example: "quân tình nguyện Việt Nam tại Campuchia",
  },
  {
    word: "quẫn trí",
    part_of_speech: "tính từ",
    meaning:
      "ở vào trạng thái bị rối trí, mất sáng suốt, đến mức có thể dẫn đến những ý nghĩ và hành động sai lầm: lo nghĩ nhiều đâm quẫn trí * quẫn trí làm liều",
    example: "lo nghĩ nhiều đâm quẫn trí * quẫn trí làm liều",
  },
  {
    word: "quân trang",
    part_of_speech: "danh từ",
    meaning:
      "quân phục và một số đồ dùng cá nhân cần thiết được trang bị cho quân nhân: lĩnh quân trang * chỉnh đốn quân trang",
    example: "lĩnh quân trang * chỉnh đốn quân trang",
  },
  {
    word: "quận uỷ",
    part_of_speech: "danh từ",
    meaning:
      "ban chấp hành đảng bộ quận: văn phòng quận uỷ * phó bí thư quận uỷ",
    example: "văn phòng quận uỷ * phó bí thư quận uỷ",
  },
  {
    word: "quân tử",
    part_of_speech: "danh từ",
    meaning:
      "người có nhân cách cao thượng, theo quan điểm của nho giáo; đối lập với tiểu nhân.",
    example:
      'Hai tay bưng chén rượu đào, Xin mời quân tử uống vào cho say." (ca dao)',
  },
  {
    word: "quân uỷ",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) quân uỷ trung ương (nói tắt): bí thư quân uỷ",
    example: "bí thư quân uỷ",
  },
  {
    word: "quần tụ",
    part_of_speech: "động từ",
    meaning:
      "quây quần, tụ họp nhau lại ở một nơi, một chỗ nào đó: một đám người quần tụ dưới gốc cây",
    example: "một đám người quần tụ dưới gốc cây",
  },
  {
    word: "quân uỷ trung ương",
    part_of_speech: "danh từ",
    meaning:
      "cơ quan lãnh đạo cao nhất của đảng cộng sản cầm quyền trong lực lượng vũ trang ở một số nước: chủ tịch quân uỷ trung ương",
    example: "chủ tịch quân uỷ trung ương",
  },
  {
    word: "quân y",
    part_of_speech: "danh từ",
    meaning: "y tế trong quân đội: trạm quân y * bác sĩ quân y",
    example: "trạm quân y * bác sĩ quân y",
  },
  {
    word: "quần vợt",
    part_of_speech: "danh từ",
    meaning:
      "môn thể thao hai hoặc bốn người chơi, dùng vợt có cán dài, đánh quả bóng nhỏ qua lại trên lưới căng ở giữa sân: chơi quần vợt * sân quần vợt",
    example: "chơi quần vợt * sân quần vợt",
  },
  {
    word: "quân vụ",
    part_of_speech: "danh từ",
    meaning: "(cũ) nhiệm vụ quân sự: tham tán quân vụ",
    example: "tham tán quân vụ",
  },
  {
    word: "quẩng",
    part_of_speech: "tính từ",
    meaning:
      "(thú vật) ở trạng thái bị kích thích hứng thú khiến cho có những động tác chạy nhảy, tung chân cao lên khác thường: con chó thấy chủ chạy quẩng lên, vẫy đuôi mừng",
    example: "con chó thấy chủ chạy quẩng lên, vẫy đuôi mừng",
  },
  {
    word: "quầng",
    part_of_speech: "danh từ",
    meaning:
      "vầng sáng tròn, nhiều màu sắc bao quanh các nguồn sáng, sinh ra do ánh sáng nhiễu xạ trên các hạt nhỏ cùng kích thước: quầng sáng phát ra từ đám mây phóng xạ",
    example: "quầng sáng phát ra từ đám mây phóng xạ",
  },
  {
    word: "quầng",
    part_of_speech: "danh từ",
    meaning:
      "quầng của mặt trời hay mặt trăng, thường xuất hiện khi có đám mây mỏng bay qua, những hạt nước nhỏ của đám mây gây ra nhiễu xạ ánh sáng: trăng quầng thì hạn, trăng tán thì mưa (tng)",
    example: "trăng quầng thì hạn, trăng tán thì mưa (tng)",
  },
  {
    word: "quầng",
    part_of_speech: "danh từ",
    meaning:
      "vùng sáng toả rộng quanh một vật nào đó trong đêm: quầng sáng của ngọn đèn dầu",
    example: "quầng sáng của ngọn đèn dầu",
  },
  {
    word: "quầng",
    part_of_speech: "danh từ",
    meaning:
      "vùng da màu sẫm xung quanh mắt: mắt có quầng vì thức đêm nhiều * mắt thâm quầng",
    example: "mắt có quầng vì thức đêm nhiều * mắt thâm quầng",
  },
  {
    word: "quật cường",
    part_of_speech: "động từ",
    meaning:
      "cứng cỏi, sẵn sàng vùng lên, không chịu khuất phục: tinh thần quật cường * ý chí quật cường",
    example: "tinh thần quật cường * ý chí quật cường",
  },
  {
    word: "quất",
    part_of_speech: "danh từ",
    meaning:
      "cây nhỡ thuộc họ cam quýt, quả tròn và nhỏ hơn quả quýt, vị chua, vỏ khi chín có màu vàng đỏ, thường được trồng làm cảnh và lấy quả: chậu quất cảnh * mứt quất",
    example: "chậu quất cảnh * mứt quất",
  },
  {
    word: "quất",
    part_of_speech: "động từ",
    meaning:
      "vụt mạnh bằng roi hoặc bằng dây cứng: quất cho mấy roi * con ngựa lồng lên vì bị quất mạnh",
    example: "quất cho mấy roi * con ngựa lồng lên vì bị quất mạnh",
  },
  {
    word: "quật",
    part_of_speech: "động từ",
    meaning: "vụt mạnh từ trên xuống bằng gậy: vung gậy quật túi bụi",
    example: "vung gậy quật túi bụi",
  },
  {
    word: "quật",
    part_of_speech: "động từ",
    meaning:
      "dùng sức mạnh làm cho vật đang ở thế đứng vững phải đổ, ngã: cây bị bão quật ngã * bị bệnh tật quật ngã",
    example: "cây bị bão quật ngã * bị bệnh tật quật ngã",
  },
  {
    word: "quật",
    part_of_speech: "động từ",
    meaning: "đào lấy từ dưới sâu lên: quật mả",
    example: "quật mả",
  },
  {
    word: "quây",
    part_of_speech: "động từ",
    meaning:
      "làm thành một lớp bao quanh, ngăn cách với bên ngoài: dùng cót quây buồng tắm",
    example: "dùng cót quây buồng tắm",
  },
  {
    word: "quây",
    part_of_speech: "động từ",
    meaning:
      "(ngồi, đứng) làm thành một vòng xung quanh: ngồi quây quanh bếp lửa * các fan hâm mộ quây kín lấy chàng diễn viên",
    example:
      "ngồi quây quanh bếp lửa * các fan hâm mộ quây kín lấy chàng diễn viên",
  },
  {
    word: "quẩng mỡ",
    part_of_speech: "động từ",
    meaning: "(thông tục) như rửng mỡ: đồ quẩng mỡ!",
    example: "đồ quẩng mỡ!",
  },
  {
    word: "quật khởi",
    part_of_speech: "động từ",
    meaning: "vùng dậy đấu tranh với khí thế mạnh mẽ: tinh thần quật khởi",
    example: "tinh thần quật khởi",
  },
  {
    word: "quậy",
    part_of_speech: "động từ",
    meaning: "(Phương ngữ) như quẫy (ng1): cá quậy đục nước",
    example: "cá quậy đục nước",
  },
  {
    word: "quậy",
    part_of_speech: "động từ",
    meaning: "như quấy (ng1): quậy cho tan đường * dùng thìa quậy mạnh",
    example: "quậy cho tan đường * dùng thìa quậy mạnh",
  },
  {
    word: "quậy",
    part_of_speech: "động từ",
    meaning:
      "(Phương ngữ, Khẩu ngữ) phá rối, không để cho yên: thằng nhỏ quậy quá!",
    example: "thằng nhỏ quậy quá!",
  },
  {
    word: "quấy",
    part_of_speech: "động từ",
    meaning:
      'dùng dụng cụ như đũa, thìa, v.v. đảo qua đảo lại cho tan đều trong chất lỏng: quấy cho tan muối * "Chọc trời, quấy nước, mặc dầu, Dọc ngang nào biết trên đầu có ai?" (TKiều)',
    example:
      'quấy cho tan muối * "Chọc trời, quấy nước, mặc dầu, Dọc ngang nào biết trên đầu có ai?" (TKiều)',
  },
  {
    word: "quấy",
    part_of_speech: "động từ",
    meaning:
      "nấu chín bằng cách vừa đun vừa quấy liên tục: quấy bột * quấy bánh đúc",
    example: "quấy bột * quấy bánh đúc",
  },
  {
    word: "quấy",
    part_of_speech: "động từ",
    meaning:
      "(trẻ em) hay khóc, không chịu chơi, làm phiền người lớn: bé quấy suốt đêm * đứa bé không khoẻ nên hay quấy",
    example: "bé quấy suốt đêm * đứa bé không khoẻ nên hay quấy",
  },
  {
    word: "quấy",
    part_of_speech: "động từ",
    meaning:
      "gây điều rầy rà, cản trở, không để cho yên ổn: chưa sáng đã mò đến quấy",
    example: "chưa sáng đã mò đến quấy",
  },
  {
    word: "quấy",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) nghịch ngợm một cách vui nhộn: tiết mục ấy quấy quá * tính thằng bé rất quấy",
    example: "tiết mục ấy quấy quá * tính thằng bé rất quấy",
  },
  {
    word: "quấy",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) sai, trái với lẽ phải: nói rõ phải quấy",
    example: "nói rõ phải quấy",
  },
  {
    word: "quầy",
    part_of_speech: "danh từ",
    meaning:
      "tủ thấp ở các cửa hàng, cửa hiệu, v.v. mặt trên dùng như mặt bàn, đặt trước người bán hàng hoặc người thu tiền: quầy rượu * quầy bán vé * ra quầy tính tiền",
    example: "quầy rượu * quầy bán vé * ra quầy tính tiền",
  },
  {
    word: "quầy",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận của cửa hàng, cửa hiệu, chuyên bán một loại hàng nhất định: quầy bán hàng lưu niệm * quầy thực phẩm * quầy bán báo",
    example: "quầy bán hàng lưu niệm * quầy thực phẩm * quầy bán báo",
  },
  {
    word: "quấy quá",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) qua loa gọi là có, cốt cho xong: trả lời quấy quá * ăn quấy quá bát cơm nguội",
    example: "trả lời quấy quá * ăn quấy quá bát cơm nguội",
  },
  {
    word: "quấy đảo",
    part_of_speech: "động từ",
    meaning: "quấy rối, không để cho yên: quấy đảo cuộc sống bình yên",
    example: "quấy đảo cuộc sống bình yên",
  },
  {
    word: "quẩy",
    part_of_speech: "động từ",
    meaning:
      "mang đi bằng quang gánh: quẩy gánh hàng rong * quẩy đôi thùng đi gánh nước",
    example: "quẩy gánh hàng rong * quẩy đôi thùng đi gánh nước",
  },
  {
    word: "quẩy",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) mang đi bằng cách móc vào một đầu đòn đặt trên vai: quẩy khăn gói ra đi",
    example: "quẩy khăn gói ra đi",
  },
  {
    word: "quấy phá",
    part_of_speech: "động từ",
    meaning:
      "phá phách và quấy rối, làm cho không yên: giấc ngủ bị quấy phá * quấy phá hạnh phúc gia đình người khác",
    example: "giấc ngủ bị quấy phá * quấy phá hạnh phúc gia đình người khác",
  },
  {
    word: "quấy nhiễu",
    part_of_speech: "động từ",
    meaning:
      "hoạt động gây hại thường xuyên, không để cho sống yên ổn: bọn cướp quấy nhiễu dân lành * bị người khác đến quấy nhiễu",
    example: "bọn cướp quấy nhiễu dân lành * bị người khác đến quấy nhiễu",
  },
  {
    word: "quẫy đạp",
    part_of_speech: "động từ",
    meaning: "đạp và vùng vẫy mạnh: thai nhi quẫy đạp trong bụng mẹ",
    example: "thai nhi quẫy đạp trong bụng mẹ",
  },
  {
    word: "quẫy",
    part_of_speech: "động từ",
    meaning:
      "vận động mạnh cơ thể hoặc bộ phận cơ thể ở trong nước theo nhiều hướng khác nhau: tiếng cá quẫy mạnh dưới ao * quẫy người trong nước",
    example: "tiếng cá quẫy mạnh dưới ao * quẫy người trong nước",
  },
  {
    word: "quẫy",
    part_of_speech: "động từ",
    meaning:
      "cố sức cử động mạnh theo nhiều hướng khác nhau nhằm thoát khỏi một tình trạng nào đó: đứa bé quẫy khỏi tay người lạ",
    example: "đứa bé quẫy khỏi tay người lạ",
  },
  {
    word: "quây quần",
    part_of_speech: "động từ",
    meaning:
      "tụ tập lại trong một không khí thân mật, đầm ấm: cả nhà quây quần đông đủ * ngồi quây quần bên bếp lửa",
    example: "cả nhà quây quần đông đủ * ngồi quây quần bên bếp lửa",
  },
  {
    word: "quấy rầy",
    part_of_speech: "động từ",
    meaning:
      "làm ảnh hưởng đến công việc hoặc sự nghỉ ngơi của người khác, khiến người ta phải bực mình: quấy rầy giấc ngủ * không muốn bị ai quấy rầy",
    example: "quấy rầy giấc ngủ * không muốn bị ai quấy rầy",
  },
  {
    word: "quấy rối",
    part_of_speech: "động từ",
    meaning:
      "gây rối, không để cho yên: bọn cướp quấy rối dân lành * quấy rối tình dục",
    example: "bọn cướp quấy rối dân lành * quấy rối tình dục",
  },
  {
    word: "quầy quậy",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) như nguây nguẩy (nhưng nghĩa mạnh hơn): lắc đầu quầy quậy * đuổi quầy quậy",
    example: "lắc đầu quầy quậy * đuổi quầy quậy",
  },
  {
    word: "que",
    part_of_speech: "danh từ",
    meaning:
      "vật cứng, dài và nhỏ, có thể cầm được dễ dàng để dùng vào việc gì: que diêm * que hàn * gầy như que củi",
    example: "que diêm * que hàn * gầy như que củi",
  },
  {
    word: "quấy quả",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) quấy, làm phiền, làm cho thấy bực mình (nói khái quát): không dám quấy quả * quấy quả không cho làm ăn",
    example: "không dám quấy quả * quấy quả không cho làm ăn",
  },
  {
    word: "quẻ âm dương",
    part_of_speech: "danh từ",
    meaning:
      "quẻ gieo hai đồng tiền xuống đĩa, nếu một sấp một ngửa thì là quẻ tốt, theo thuật bói toán: xin một quẻ âm dương",
    example: "xin một quẻ âm dương",
  },
  {
    word: "quẻ",
    part_of_speech: "danh từ",
    meaning:
      "dấu hiệu trong bói toán, cầu khấn, từ đó có thể đoán ra điều lành dữ, may rủi, theo thuật bói toán: gieo quẻ * xin một quẻ",
    example: "gieo quẻ * xin một quẻ",
  },
  {
    word: "què",
    part_of_speech: "tính từ",
    meaning:
      "mất khả năng cử động bình thường của tay chân, do bị thương tật: bị què chân * què tay",
    example: "bị què chân * què tay",
  },
  {
    word: "que đan",
    part_of_speech: "danh từ",
    meaning:
      "(Nam, cũ kim đơn) thuốc tiên, được luyện rất lâu và công phu, uống vào sẽ được trường sinh bất tử, theo trí tưởng tượng của người xưa: luyện kim đan",
    example: "luyện kim đan",
  },
  {
    word: "què quặt",
    part_of_speech: "tính từ",
    meaning: "(hiếm) què (nói khái quát): chân tay què quặt",
    example: "chân tay què quặt",
  },
  {
    word: "què quặt",
    part_of_speech: "tính từ",
    meaning:
      "thiếu hẳn một hoặc một số bộ phận quan trọng, làm cho mất cân đối: nền kinh tế què quặt * tâm hồn què quặt",
    example: "nền kinh tế què quặt * tâm hồn què quặt",
  },
  {
    word: "quen biết",
    part_of_speech: "động từ",
    meaning:
      "biết nhau và có quan hệ, có giao thiệp với nhau: chỗ quen biết * không hề quen biết",
    example: "chỗ quen biết * không hề quen biết",
  },
  {
    word: "quen",
    part_of_speech: "",
    meaning:
      'do có tiếp xúc hoặc có quan hệ mà đã hiểu biết, thông thuộc: nhận ra người quen * trước lạ sau quen * "Chim quyên ăn trái nhãn lồng, Thia thia quen chậu, vợ chồng quen hơi." (ca dao)',
    example:
      'nhận ra người quen * trước lạ sau quen * "Chim quyên ăn trái nhãn lồng, Thia thia quen chậu, vợ chồng quen hơi." (ca dao)',
  },
  {
    word: "quen",
    part_of_speech: "",
    meaning:
      "đã làm nhiều lần đến mức thành nếp, hoặc đã tiếp xúc nhiều lần trong đời sống đến mức hoàn toàn thích nghi: quen dậy sớm * nói bậy quen mồm * chưa quen với cuộc sống thành thị",
    example:
      "quen dậy sớm * nói bậy quen mồm * chưa quen với cuộc sống thành thị",
  },
  {
    word: "quen mặt",
    part_of_speech: "",
    meaning:
      'có nét mặt trông quen, nhận ra được ngay là đã có lần gặp (nhưng không nhất thiết là đã biết rõ tên tuổi): khách hàng quen mặt * "Chàng Vương quen mặt ra chào, Hai kiều e lệ nép vào dưới hoa." (TKiều)',
    example:
      'khách hàng quen mặt * "Chàng Vương quen mặt ra chào, Hai kiều e lệ nép vào dưới hoa." (TKiều)',
  },
  {
    word: "quen hơi bén tiếng",
    part_of_speech: "",
    meaning:
      'bắt đầu quen và gắn bó với nhau trong quan hệ tình cảm (thường dùng để nói về tình cảm nam nữ): "Biết nhau thêm dở dang nhau, Quen hơi bén tiếng bao lâu mà rằng!" (NĐM)',
    example:
      'Biết nhau thêm dở dang nhau, Quen hơi bén tiếng bao lâu mà rằng!" (NĐM)',
  },
  {
    word: "quen mui",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đã làm, đã hưởng một đôi lần, thấy dễ dàng và có lợi nên lại muốn làm nữa, hưởng nữa (hàm ý chê): ăn cắp quen mui * quen mui thấy mùi ăn mãi (kng)",
    example: "ăn cắp quen mui * quen mui thấy mùi ăn mãi (kng)",
  },
  {
    word: "quèn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) thuộc hạng tầm thường, không có giá trị gì: anh lính quèn * nhân viên quèn",
    example: "anh lính quèn * nhân viên quèn",
  },
  {
    word: "quèn quẹt",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng âm thanh như tiếng dép hay tiếng chổi tre quệt liên tiếp xuống mặt nền: lê dép quèn quẹt",
    example: "lê dép quèn quẹt",
  },
  {
    word: "quen thân",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) như quen thói (nhưng thường dùng ở cuối câu làm tiếng mắng): hỗn láo quen thân!",
    example: "hỗn láo quen thân!",
  },
  {
    word: "quen thân",
    part_of_speech: "tính từ",
    meaning: "như thân quen: bạn bè quen thân",
    example: "bạn bè quen thân",
  },
  {
    word: "quen thuộc",
    part_of_speech: "tính từ",
    meaning:
      "quen đến mức biết rất rõ, vì thường gặp, thường thấy đã từ lâu: giọng nói quen thuộc * cảnh vật quen thuộc",
    example: "giọng nói quen thuộc * cảnh vật quen thuộc",
  },
  {
    word: "quen thói",
    part_of_speech: "động từ",
    meaning:
      '(khẩu ngữ) đã thành thói xấu lâu ngày, khó sửa được: "Lạ gì bỉ sắc tư phong, Trời xanh quen thói má hồng đánh ghen." (TKiều)',
    example:
      'Lạ gì bỉ sắc tư phong, Trời xanh quen thói má hồng đánh ghen." (TKiều)',
  },
  {
    word: "quẹo",
    part_of_speech: "tính từ",
    meaning:
      "bị cong hẳn về một bên, trông gần như gập lại: bẻ quẹo * ngã quẹo chân",
    example: "bẻ quẹo * ngã quẹo chân",
  },
  {
    word: "quẹo",
    part_of_speech: "động từ",
    meaning:
      "(Phương ngữ) ngoặt, rẽ sang một hướng khác: đi một đoạn nữa thì quẹo tay mặt * quẹo vào một con hẻm nhỏ",
    example: "đi một đoạn nữa thì quẹo tay mặt * quẹo vào một con hẻm nhỏ",
  },
  {
    word: "quèo",
    part_of_speech: "động từ",
    meaning: "như khoèo: đá mèo, quèo chó (tng)",
    example: "đá mèo, quèo chó (tng)",
  },
  {
    word: "quèo",
    part_of_speech: "tính từ",
    meaning: "cong, không thẳng (thường nói về dáng nằm): chân quèo * nằm quèo",
    example: "chân quèo * nằm quèo",
  },
  {
    word: "quét dọn",
    part_of_speech: "động từ",
    meaning:
      "quét và dọn cho sạch, cho gọn (nói khái quát): quét dọn nhà cửa * thuê người quét dọn",
    example: "quét dọn nhà cửa * thuê người quét dọn",
  },
  {
    word: "quẹt",
    part_of_speech: "động từ",
    meaning:
      "chạm vào và đưa sát trên bề mặt theo một vệt dài: hai chiếc xe quệt nhẹ vào nhau * gấu quần quệt đất",
    example: "hai chiếc xe quệt nhẹ vào nhau * gấu quần quệt đất",
  },
  {
    word: "quẹt",
    part_of_speech: "động từ",
    meaning:
      "làm động tác quệt để lấy riêng ra hoặc để bôi, phết hay chùi sạch đi một ít chất dính: quệt hồ lên phong bì * hai tay quệt nước mắt",
    example: "quệt hồ lên phong bì * hai tay quệt nước mắt",
  },
  {
    word: "quẹt",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như vệt: một quệt mực giữa trang giấy * quệt đèn pha",
    example: "một quệt mực giữa trang giấy * quệt đèn pha",
  },
  {
    word: "queo",
    part_of_speech: "tính từ",
    meaning:
      "cong, vênh một cách không đều đặn, làm biến dạng: thanh củi khô queo * sự việc bị bẻ queo (b)",
    example: "thanh củi khô queo * sự việc bị bẻ queo (b)",
  },
  {
    word: "quét",
    part_of_speech: "động từ",
    meaning:
      "làm cho sạch rác, bụi bằng cách đưa từng nhát chổi lần lượt trên bề mặt: quét sân * bói ra ma quét nhà ra rác (tng)",
    example: "quét sân * bói ra ma quét nhà ra rác (tng)",
  },
  {
    word: "quét",
    part_of_speech: "động từ",
    meaning:
      "dùng chổi phết đều sơn, vôi, v.v. lên bề mặt để tạo một lớp phủ ngoài: quét vôi * quét sơn chống thấm",
    example: "quét vôi * quét sơn chống thấm",
  },
  {
    word: "quét",
    part_of_speech: "động từ",
    meaning:
      "bắn, lia trên một phạm vi rộng: đạn quét xối xả * ánh đèn pha quét trên mặt đất",
    example: "đạn quét xối xả * ánh đèn pha quét trên mặt đất",
  },
  {
    word: "quét",
    part_of_speech: "động từ",
    meaning: "tiêu diệt trên một phạm vi rộng: quét sạch bọn thổ phỉ",
    example: "quét sạch bọn thổ phỉ",
  },
  {
    word: "quét tước",
    part_of_speech: "động từ",
    meaning:
      "quét cho sạch rác, bụi (nói khái quát): quét tước nhà cửa * cả ngày chỉ dọn dẹp, quét tước",
    example: "quét tước nhà cửa * cả ngày chỉ dọn dẹp, quét tước",
  },
  {
    word: "quét quáy",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) quét (nói khái quát): quét quáy nhà cửa sạch sẽ",
    example: "quét quáy nhà cửa sạch sẽ",
  },
  {
    word: "quê",
    part_of_speech: "danh từ",
    meaning:
      "nơi gia đình, dòng họ mình đã qua nhiều đời làm ăn sinh sống, thường có sự gắn bó tự nhiên về tình cảm với mình: về thăm quê * quê ở miền Nam * bạn cùng quê",
    example: "về thăm quê * quê ở miền Nam * bạn cùng quê",
  },
  {
    word: "quê",
    part_of_speech: "danh từ",
    meaning:
      "nông thôn, nơi có đồng ruộng làng mạc: ở quê ra * dân quê * đi chợ quê",
    example: "ở quê ra * dân quê * đi chợ quê",
  },
  {
    word: "quê",
    part_of_speech: "tính từ",
    meaning: "mộc mạc, có vẻ kém thanh lịch: ăn nói rất quê * trông quê quê",
    example: "ăn nói rất quê * trông quê quê",
  },
  {
    word: "quê hương",
    part_of_speech: "danh từ",
    meaning:
      'quê của mình, về mặt là nơi có sự gắn bó tự nhiên về tình cảm: nỗi nhớ quê hương * "Thuở còn thơ ngày hai buổi đến trường, Yêu quê hương qua từng trang sách nhỏ." (GNam; 2)',
    example:
      'nỗi nhớ quê hương * "Thuở còn thơ ngày hai buổi đến trường, Yêu quê hương qua từng trang sách nhỏ." (GNam; 2)',
  },
  {
    word: "quê hương",
    part_of_speech: "danh từ",
    meaning:
      "nơi đầu tiên sản sinh ra cái gì để từ đó phổ biến rộng ra những nơi khác: nước Anh là quê hương của môn bóng đá",
    example: "nước Anh là quê hương của môn bóng đá",
  },
  {
    word: "quên",
    part_of_speech: "động từ",
    meaning:
      "không còn nhớ, không còn lưu giữ trong trí nhớ: quên số điện thoại của bạn * quên địa chỉ * những kỉ niệm không bao giờ quên",
    example:
      "quên số điện thoại của bạn * quên địa chỉ * những kỉ niệm không bao giờ quên",
  },
  {
    word: "quên",
    part_of_speech: "động từ",
    meaning:
      "không nghĩ đến, không để tâm đến (điều thường hoặc lẽ ra không thể như vậy): mải chơi quên cả ăn * làm việc quên giờ giấc",
    example: "mải chơi quên cả ăn * làm việc quên giờ giấc",
  },
  {
    word: "quên",
    part_of_speech: "động từ",
    meaning:
      "không làm, không mang theo do không nhớ, không nghĩ đến: quên cặp sách * quên chìa khoá ở nhà",
    example: "quên cặp sách * quên chìa khoá ở nhà",
  },
  {
    word: "quế hoè",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) cây quế và cây hoè, dùng để chỉ cảnh con cháu làm nên, hiển đạt: "Quế hoè nối dấu công khanh, Trỗi sinh Lưu tướng đáng danh nữ tài." (LNT)',
    example:
      'Quế hoè nối dấu công khanh, Trỗi sinh Lưu tướng đáng danh nữ tài." (LNT)',
  },
  {
    word: "quê kệch",
    part_of_speech: "tính từ",
    meaning: "có vẻ mộc mạc quá, đến mức thô thiển: nói năng quê kệch",
    example: "nói năng quê kệch",
  },
  {
    word: "quệch quạc",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như nguệch ngoạc: viết quệch quạc mấy chữ",
    example: "viết quệch quạc mấy chữ",
  },
  {
    word: "quê kiểng",
    part_of_speech: "",
    meaning: "(phương ngữ, hiếm) có vẻ dân dã, mộc mạc: món đặc sản quê kiểng",
    example: "món đặc sản quê kiểng",
  },
  {
    word: "quê quán",
    part_of_speech: "danh từ",
    meaning:
      "quê, về mặt là nơi gốc rễ của gia đình, dòng họ: không rõ quê quán * bỏ quê quán đi làm ăn xa",
    example: "không rõ quê quán * bỏ quê quán đi làm ăn xa",
  },
  {
    word: "quê mùa",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất, dáng vẻ như của người dân quê chất phác và ít hiểu biết: con người quê mùa * ăn mặc quê mùa",
    example: "con người quê mùa * ăn mặc quê mùa",
  },
  {
    word: "quê một cục",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) rất quê mùa, gây cảm giác khó chịu: ăn mặc quê một cục",
    example: "ăn mặc quê một cục",
  },
  {
    word: "quên bẵng",
    part_of_speech: "động từ",
    meaning:
      "quên hẳn đi, hoàn toàn không nhớ đến trong một thời gian khá dài: quên bẵng lời hứa * tự dưng lại quên bẵng đi mất!",
    example: "quên bẵng lời hứa * tự dưng lại quên bẵng đi mất!",
  },
  {
    word: "quên béng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) quên hẳn đi một cách rất nhanh điều mà lẽ ra phải nghĩ đến, phải nhớ làm: vừa nói xong đã quên béng",
    example: "vừa nói xong đã quên béng",
  },
  {
    word: "quên khuấy",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) quên hẳn đi, không nghĩ đến vì quá bận hay vì mải chú ý đến những cái khác: quên khuấy mất buổi họp ban sáng",
    example: "quên khuấy mất buổi họp ban sáng",
  },
  {
    word: "quên mình",
    part_of_speech: "động từ",
    meaning:
      "không nghĩ đến bản thân, kể cả trong trường hợp có thể mất mát, hi sinh: lao động quên mình * quên mình vì việc nghĩa",
    example: "lao động quên mình * quên mình vì việc nghĩa",
  },
  {
    word: "quên lãng",
    part_of_speech: "động từ",
    meaning: "như lãng quên: câu chuyện đã rơi vào quên lãng",
    example: "câu chuyện đã rơi vào quên lãng",
  },
  {
    word: "quện",
    part_of_speech: "động từ",
    meaning:
      "cùng với nhau làm thành một khối không thể tách rời, tựa như xoắn chặt, bện chặt vào nhau: hương cốm quyện với mùi lá sen * tiếng đàn và tiếng hát quyện vào nhau",
    example:
      "hương cốm quyện với mùi lá sen * tiếng đàn và tiếng hát quyện vào nhau",
  },
  {
    word: "quềnh quàng",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả vẻ tay chân cử động một cách lóng ngóng, không hoàn toàn tự điều khiển được: đứa bé bò quềnh quàng trên nền nhà",
    example: "đứa bé bò quềnh quàng trên nền nhà",
  },
  {
    word: "quên lửng",
    part_of_speech: "động từ",
    meaning:
      "quên ngay, nhưng không quên hoàn toàn, khi được gợi đến là lại nhớ lại: quên lửng nồi thịt kho trên bếp",
    example: "quên lửng nồi thịt kho trên bếp",
  },
  {
    word: "quệt",
    part_of_speech: "động từ",
    meaning:
      "chạm vào và đưa sát trên bề mặt theo một vệt dài: hai chiếc xe quệt nhẹ vào nhau * gấu quần quệt đất",
    example: "hai chiếc xe quệt nhẹ vào nhau * gấu quần quệt đất",
  },
  {
    word: "quệt",
    part_of_speech: "động từ",
    meaning:
      "làm động tác quệt để lấy riêng ra hoặc để bôi, phết hay chùi sạch đi một ít chất dính: quệt hồ lên phong bì * hai tay quệt nước mắt",
    example: "quệt hồ lên phong bì * hai tay quệt nước mắt",
  },
  {
    word: "quệt",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như vệt: một quệt mực giữa trang giấy * quệt đèn pha",
    example: "một quệt mực giữa trang giấy * quệt đèn pha",
  },
  {
    word: "quết trầu",
    part_of_speech: "danh từ",
    meaning: "nước màu đỏ ứa ra khi ăn trầu: nhổ quết trầu",
    example: "nhổ quết trầu",
  },
  {
    word: "quều quào",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả vẻ chân tay cử động một cách khó khăn, thiếu tự nhiên, do quá ốm yếu hoặc ngượng ngập, vụng về: chân tay quều quào",
    example: "chân tay quều quào",
  },
  {
    word: "quết",
    part_of_speech: "động từ",
    meaning:
      "giã cho nhuyễn, cho dính quyện vào với nhau: quết giò * quết bột làm bánh",
    example: "quết giò * quết bột làm bánh",
  },
  {
    word: "quết",
    part_of_speech: "động từ",
    meaning:
      "làm cho chất dính bám thành một lớp trên bề mặt: quết sơn lên vải * quết hồ",
    example: "quết sơn lên vải * quết hồ",
  },
  {
    word: "quì",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ, hoặc cũ) hướng dương: hoa quỳ",
    example: "hoa quỳ",
  },
  {
    word: "quì",
    part_of_speech: "danh từ",
    meaning:
      "vàng, bạc dát mỏng, thường dùng để thếp câu đối, hoành phi, v.v.: vàng quỳ",
    example: "vàng quỳ",
  },
  {
    word: "quì",
    part_of_speech: "động từ",
    meaning:
      "ở tư thế đầu gối gập xuống và đặt sát mặt nền để đỡ toàn thân: ngắm bắn ở tư thế quỳ * quỳ trước bàn thờ * tủ chân quỳ",
    example: "ngắm bắn ở tư thế quỳ * quỳ trước bàn thờ * tủ chân quỳ",
  },
  {
    word: "quỉ",
    part_of_speech: "danh từ",
    meaning:
      "con vật tưởng tượng ở dưới âm phủ, hình thù kì dị và dữ tợn, hay hiện lên quấy nhiễu và làm hại người, theo truyền thuyết: con quỷ",
    example: "con quỷ",
  },
  {
    word: "quỉ",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) kẻ tinh nghịch, quái ác hay quấy phá (thường dùng làm tiếng mắng): thằng quỷ, nghịch vừa chứ!",
    example: "thằng quỷ, nghịch vừa chứ!",
  },
  {
    word: "quị",
    part_of_speech: "động từ",
    meaning:
      "gập hẳn hai gối lại trên mặt nền ở tư thế quỳ, không gượng lại nổi: quỵ gối * bước được vài bước thì quỵ xuống",
    example: "quỵ gối * bước được vài bước thì quỵ xuống",
  },
  {
    word: "quị",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) mất hết sức lực, không còn có thể gắng gượng gì được nữa: làm quên ăn quên ngủ như thế không khéo quỵ mất!",
    example: "làm quên ăn quên ngủ như thế không khéo quỵ mất!",
  },
  {
    word: "qui",
    part_of_speech: "động từ",
    meaning:
      "đưa về, gom lại trong nhận thức thành một cái gì đơn giản hơn dựa trên những đặc điểm chung cơ bản nào đó: quy về một mối * quy thành mấy kiểu chính",
    example: "quy về một mối * quy thành mấy kiểu chính",
  },
  {
    word: "qui",
    part_of_speech: "động từ",
    meaning:
      "chuyển thành một loại nào đó tương đương về giá trị để tiện cho việc tính toán: quy thành tiền * cứ quy ra thóc mà nộp thuế",
    example: "quy thành tiền * cứ quy ra thóc mà nộp thuế",
  },
  {
    word: "qui",
    part_of_speech: "động từ",
    meaning:
      "cho đó là phần trách nhiệm, công lao, tội lỗi thuộc về người nào đó: quy trách nhiệm rõ ràng * quy sai tội cho người khác",
    example: "quy trách nhiệm rõ ràng * quy sai tội cho người khác",
  },
  {
    word: "quí",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian bằng ba tháng, tính từ tháng một trở đi: lên kế hoạch làm việc của cả quý * nộp báo cáo quý",
    example: "lên kế hoạch làm việc của cả quý * nộp báo cáo quý",
  },
  {
    word: "quí",
    part_of_speech: "tính từ",
    meaning: "có giá trị cao: của quý * con người là vốn quý * quý như vàng",
    example: "của quý * con người là vốn quý * quý như vàng",
  },
  {
    word: "quí",
    part_of_speech: "tính từ",
    meaning:
      "(Kiểu cách) từ dùng trước một danh từ trong những tổ hợp dùng để gọi một cách lịch sự một số người hay một tổ chức nào đó nói chung, khi nói với những người hay tổ chức ấy: quý ông * quý vị đại biểu * theo yêu cầu của quý cơ quan",
    example: "quý ông * quý vị đại biểu * theo yêu cầu của quý cơ quan",
  },
  {
    word: "quí",
    part_of_speech: "động từ",
    meaning:
      "coi là quý: quý con quý cháu * không biết quý sức khoẻ * quý thời gian",
    example: "quý con quý cháu * không biết quý sức khoẻ * quý thời gian",
  },
  {
    word: "qui bản",
    part_of_speech: "danh từ",
    meaning: "yếm rùa, dùng để nấu cao: cao quy bản",
    example: "cao quy bản",
  },
  {
    word: "quĩ",
    part_of_speech: "danh từ",
    meaning:
      "số tiền dành riêng cho những khoản chi tiêu nhất định: quỹ tiền lương * quỹ phúc lợi * nộp quỹ lớp",
    example: "quỹ tiền lương * quỹ phúc lợi * nộp quỹ lớp",
  },
  {
    word: "quĩ",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức làm nơi nhận gửi và chi trả tiền: quỹ tiết kiệm * quỹ tín dụng",
    example: "quỹ tiết kiệm * quỹ tín dụng",
  },
  {
    word: "quí báu",
    part_of_speech: "tính từ",
    meaning:
      "có giá trị, đáng được coi trọng: thì giờ quý báu * yêu nước thương nòi là truyền thống quý báu của dân tộc ta",
    example:
      "thì giờ quý báu * yêu nước thương nòi là truyền thống quý báu của dân tộc ta",
  },
  {
    word: "qui củ",
    part_of_speech: "danh từ",
    meaning:
      "toàn thể nói chung những quy định nhằm làm cho một việc làm nào đó thành có trật tự, có tổ chức: công việc có quy củ",
    example: "công việc có quy củ",
  },
  {
    word: "qui củ",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) có trật tự, có tổ chức: làm ăn rất quy củ * gia đình quy củ * không khí làm việc khẩn trương và quy củ",
    example:
      "làm ăn rất quy củ * gia đình quy củ * không khí làm việc khẩn trương và quy củ",
  },
  {
    word: "qui cách",
    part_of_speech: "danh từ",
    meaning:
      "những yêu cầu về mặt kĩ thuật đối với một sản phẩm (nói tổng quát): làm sai quy cách * cứ theo quy cách mà làm",
    example: "làm sai quy cách * cứ theo quy cách mà làm",
  },
  {
    word: "qui chế",
    part_of_speech: "danh từ",
    meaning:
      "những điều đã được quy định thành chế độ để mọi người theo đó mà thực hiện trong những hoạt động nhất định nào đó: công bố quy chế tuyển sinh * được thưởng theo đúng quy chế",
    example: "công bố quy chế tuyển sinh * được thưởng theo đúng quy chế",
  },
  {
    word: "quĩ đạo",
    part_of_speech: "danh từ",
    meaning:
      "đường cong do một vật thể chuyển động trong không gian vạch ra: quỹ đạo của Trái Đất quanh Mặt Trời",
    example: "quỹ đạo của Trái Đất quanh Mặt Trời",
  },
  {
    word: "quĩ đạo",
    part_of_speech: "danh từ",
    meaning:
      "vòng ảnh hưởng, phạm vi tác động của cái gì: quỹ đạo phát triển kinh tế của khu vực",
    example: "quỹ đạo phát triển kinh tế của khu vực",
  },
  {
    word: "qui chuẩn",
    part_of_speech: "danh từ",
    meaning:
      "quy cách, tiêu chuẩn đã được quy định (nói khái quát): áp dụng quy chuẩn xây dựng * sản phẩm chưa đạt quy chuẩn",
    example: "áp dụng quy chuẩn xây dựng * sản phẩm chưa đạt quy chuẩn",
  },
  {
    word: "quĩ đen",
    part_of_speech: "danh từ",
    meaning:
      "quỹ dành riêng cho những khoản chi được giữ bí mật, thường là bất hợp pháp: phát hiện quỹ đen của công ti * lập quỹ đen",
    example: "phát hiện quỹ đen của công ti * lập quỹ đen",
  },
  {
    word: "qui định",
    part_of_speech: "",
    meaning:
      "định ra để phải theo, phải thực hiện trong công việc, trong hoạt động cụ thể: quy định thời gian làm việc * làm đủ các thủ tục theo quy định",
    example: "quy định thời gian làm việc * làm đủ các thủ tục theo quy định",
  },
  {
    word: "quí giá",
    part_of_speech: "tính từ",
    meaning:
      "có giá trị lớn: đồ nữ trang quý giá * không có tài sản gì quý giá",
    example: "đồ nữ trang quý giá * không có tài sản gì quý giá",
  },
  {
    word: "qui đổi",
    part_of_speech: "động từ",
    meaning:
      "chuyển đổi sang một hệ đơn vị khác: tính hệ số quy đổi * quy đổi thời gian công tác * quy đổi từ đồng yen Nhật sang đồng Việt Nam",
    example:
      "tính hệ số quy đổi * quy đổi thời gian công tác * quy đổi từ đồng yen Nhật sang đồng Việt Nam",
  },
  {
    word: "quí hiếm",
    part_of_speech: "tính từ",
    meaning: "quý giá và hiếm có: động vật quý hiếm",
    example: "động vật quý hiếm",
  },
  {
    word: "quí hoá",
    part_of_speech: "tính từ",
    meaning:
      "đáng quý, đáng coi trọng (thường nói về mặt tinh thần): tình cảm quý hoá * cô con dâu quý hoá * được như thế thì còn gì quý hoá bằng!",
    example:
      "tình cảm quý hoá * cô con dâu quý hoá * được như thế thì còn gì quý hoá bằng!",
  },
  {
    word: "quí hoá",
    part_of_speech: "động từ",
    meaning: "(hiếm) coi là quý: bà cụ quý hoá anh như con",
    example: "bà cụ quý hoá anh như con",
  },
  {
    word: "qui hoạch",
    part_of_speech: "",
    meaning:
      "bố trí, sắp xếp toàn bộ theo một trình tự hợp lí trong từng thời gian, làm cơ sở cho việc lập kế hoạch dài hạn: quy hoạch các khu kinh tế * khu vực sắp quy hoạch",
    example: "quy hoạch các khu kinh tế * khu vực sắp quy hoạch",
  },
  {
    word: "quí hồ",
    part_of_speech: "kết từ",
    meaning:
      'miễn sao, chỉ cần (một điều kiện) là (chứ không đòi hỏi gì hơn): "Quý hồ anh có lòng thương, Em có lòng đợi như rương khoá rồi." (ca dao)',
    example:
      'Quý hồ anh có lòng thương, Em có lòng đợi như rương khoá rồi." (ca dao)',
  },
  {
    word: "quỉ kế",
    part_of_speech: "danh từ",
    meaning: "mưu kế quỷ quyệt: bày quỷ kế * dùng quỷ kế để hại người",
    example: "bày quỷ kế * dùng quỷ kế để hại người",
  },
  {
    word: "quỉ khốc thần kinh",
    part_of_speech: "",
    meaning:
      'quỷ thần cũng phải khiếp sợ (trước cảnh tượng hãi hùng, khủng khiếp hoặc điều kì lạ, phi thường): "Hoa thêu gấm dệt lời chau chuốt, Quỷ khốc thần kinh bút vẫy vùng." (LTKN)',
    example:
      'Hoa thêu gấm dệt lời chau chuốt, Quỷ khốc thần kinh bút vẫy vùng." (LTKN)',
  },
  {
    word: "qui kết",
    part_of_speech: "động từ",
    meaning:
      "đưa ra nhận định về người nào đó một cách chủ quan, thiếu căn cứ (và thường là đánh giá nặng nề): không nên quy kết vội vàng * bị quy kết là kẻ có tội",
    example: "không nên quy kết vội vàng * bị quy kết là kẻ có tội",
  },
  {
    word: "quị luỵ",
    part_of_speech: "động từ",
    meaning:
      "tự hạ mình chịu nhục trước người khác để cầu xin, nhờ vả điều gì: hạ mình quỵ luỵ để nhờ vả * không chịu quỵ luỵ ai",
    example: "hạ mình quỵ luỵ để nhờ vả * không chịu quỵ luỵ ai",
  },
  {
    word: "quí mến",
    part_of_speech: "động từ",
    meaning:
      "quý và yêu mến: đem lòng quý mến * thông minh, tốt tính nên ai cũng quý mến",
    example: "đem lòng quý mến * thông minh, tốt tính nên ai cũng quý mến",
  },
  {
    word: "qui nạp",
    part_of_speech: "động từ",
    meaning:
      "(suy lí, suy luận) đi từ những hiện tượng, sự kiện riêng đến những kết luận chung; phân biệt với diễn dịch: trình bày theo lối quy nạp * phương pháp quy nạp",
    example: "trình bày theo lối quy nạp * phương pháp quy nạp",
  },
  {
    word: "quí nhân",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, hiếm) người ở bậc cao sang và được kính trọng: có cốt cách của một bậc quý nhân",
    example: "có cốt cách của một bậc quý nhân",
  },
  {
    word: "quí nhân",
    part_of_speech: "danh từ",
    meaning:
      "người luôn che chở, giúp đỡ cho khi gặp khó khăn, hoạn nạn, như đã định trong số mệnh, theo mê tín: số có có quý nhân phù trợ",
    example: "số có có quý nhân phù trợ",
  },
  {
    word: "qui mô",
    part_of_speech: "danh từ",
    meaning:
      "độ rộng lớn về mặt tổ chức: mở rộng quy mô của xí nghiệp * công trình có quy mô hiện đại",
    example: "mở rộng quy mô của xí nghiệp * công trình có quy mô hiện đại",
  },
  {
    word: "qui mô",
    part_of_speech: "tính từ",
    meaning:
      "có độ rộng lớn về khuôn khổ hay về mặt tổ chức: công trình xây dựng khá quy mô",
    example: "công trình xây dựng khá quy mô",
  },
  {
    word: "qui luật",
    part_of_speech: "danh từ",
    meaning:
      "mối liên hệ bản chất ổn định, được lặp đi lặp lại giữa các hiện tượng trong tự nhiên và xã hội: quy luật phát triển xã hội * quy luật di truyền",
    example: "quy luật phát triển xã hội * quy luật di truyền",
  },
  {
    word: "qui phạm",
    part_of_speech: "danh từ",
    meaning:
      "điều quy định chặt chẽ, đòi hỏi phải tuân theo: quy phạm đạo đức * văn bản quy phạm pháp luật",
    example: "quy phạm đạo đức * văn bản quy phạm pháp luật",
  },
  {
    word: "quí phái",
    part_of_speech: "tính từ",
    meaning:
      "thuộc dòng dõi quý tộc hoặc có dáng vẻ sang như con nhà quý tộc: con nhà quý phái * dáng điệu thanh cao quý phái",
    example: "con nhà quý phái * dáng điệu thanh cao quý phái",
  },
  {
    word: "quỉ quyệt",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều mánh khoé hiểm độc, gian giảo, khó lường trước được: mưu mô quỷ quyệt * con người quỷ quyệt",
    example: "mưu mô quỷ quyệt * con người quỷ quyệt",
  },
  {
    word: "qui phạm pháp luật",
    part_of_speech: "danh từ",
    meaning:
      "quy tắc ứng xử có tính chất khuôn mẫu do nhà nước ban hành hoặc thừa nhận, bắt buộc mọi chủ thể phải tuân theo: thi hành văn bản quy phạm pháp luật",
    example: "thi hành văn bản quy phạm pháp luật",
  },
  {
    word: "qui phục",
    part_of_speech: "động từ",
    meaning: "như hàng phục: cúi đầu quy phục * thuận lòng quy phục",
    example: "cúi đầu quy phục * thuận lòng quy phục",
  },
  {
    word: "quỉ sứ",
    part_of_speech: "danh từ",
    meaning:
      "quỷ dưới âm phủ, chuyên hành hạ linh hồn những người có tội, theo mê tín.",
    example: "đồ quỷ sứ!",
  },
  {
    word: "quỉ quái",
    part_of_speech: "tính từ",
    meaning:
      'hết sức tai ác và ranh mãnh: "Vợ chàng quỷ quái, tinh ma, Phen này kẻ cắp, bà già gặp nhau!" (TKiều)',
    example:
      'Vợ chàng quỷ quái, tinh ma, Phen này kẻ cắp, bà già gặp nhau!" (TKiều)',
  },
  {
    word: "quỉ quái",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) như quái: quỷ quái thật, vừa mới để đây mà bây giờ không thấy đâu",
    example: "quỷ quái thật, vừa mới để đây mà bây giờ không thấy đâu",
  },
  {
    word: "qui tắc",
    part_of_speech: "danh từ",
    meaning:
      "những điều quy định đòi hỏi phải tuân theo trong một hoạt động chung nào đó (nói tổng quát): tôn trọng quy tắc thi đấu * quy tắc bảo đảm vệ sinh an toàn thực phẩm",
    example:
      "tôn trọng quy tắc thi đấu * quy tắc bảo đảm vệ sinh an toàn thực phẩm",
  },
  {
    word: "qui tắc",
    part_of_speech: "danh từ",
    meaning:
      "công thức, hình thức ngắn gọn nêu lên những điều cần phải làm theo trong những trường hợp nhất định: quy tắc viết hoa * quy tắc quy đồng mẫu số",
    example: "quy tắc viết hoa * quy tắc quy đồng mẫu số",
  },
  {
    word: "quỉ thần",
    part_of_speech: "danh từ",
    meaning: "các vị thần linh (nói khái quát): nói có quỷ thần chứng giám",
    example: "nói có quỷ thần chứng giám",
  },
  {
    word: "qui thuận",
    part_of_speech: "động từ",
    meaning:
      "chịu theo đối phương, không hoạt động chống đối lại nữa: quy thuận triều đình",
    example: "quy thuận triều đình",
  },
  {
    word: "quĩ tiết kiệm",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức nhận gửi tiền tiết kiệm, có trả lãi: nhân viên quỹ tiết kiệm",
    example: "nhân viên quỹ tiết kiệm",
  },
  {
    word: "qui tụ",
    part_of_speech: "động từ",
    meaning:
      "(từ nhiều nơi, nhiều hướng) quy về, tụ về một chỗ, một điểm: quy tụ nhân tài * học trò các nơi quy tụ về kinh dự thi",
    example: "quy tụ nhân tài * học trò các nơi quy tụ về kinh dự thi",
  },
  {
    word: "quí tử",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) đứa con trai có những phẩm chất dự báo sau này sẽ làm nên sự nghiệp, theo quan niệm xưa: sinh được quý tử",
    example: "sinh được quý tử",
  },
  {
    word: "quí tử",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) người con trai được gia đình nuông chiều (thường dùng với hàm ý coi thường hay châm biếm): ông con quý tử",
    example: "ông con quý tử",
  },
  {
    word: "quí tộc",
    part_of_speech: "danh từ",
    meaning:
      "người thuộc tầng lớp trên, có đặc quyền, đặc lợi trong xã hội chiếm hữu nô lệ, xã hội phong kiến hay các quốc gia quân chủ: có dòng dõi quý tộc * tầng lớp quý tộc phong kiến",
    example: "có dòng dõi quý tộc * tầng lớp quý tộc phong kiến",
  },
  {
    word: "quí tộc",
    part_of_speech: "tính từ",
    meaning:
      "có vẻ sang trọng, có kiểu cách của người thuộc tầng lớp trên trong xã hội: dáng vẻ quý tộc * lối sống quý tộc",
    example: "dáng vẻ quý tộc * lối sống quý tộc",
  },
  {
    word: "quí trọng",
    part_of_speech: "động từ",
    meaning: "quý và coi trọng (nói khái quát): quý trọng thầy cô giáo",
    example: "quý trọng thầy cô giáo",
  },
  {
    word: "qui trình",
    part_of_speech: "danh từ",
    meaning:
      "trình tự phải tuân theo để tiến hành một công việc nào đó: quy trình sản xuất * quy trình thiết kế",
    example: "quy trình sản xuất * quy trình thiết kế",
  },
  {
    word: "qui ước",
    part_of_speech: "danh từ",
    meaning:
      "những điều quy định thoả thuận với nhau về một vấn đề nào đó, cần phải làm theo: thực hiện đúng quy ước * vi phạm các quy ước quốc tế",
    example: "thực hiện đúng quy ước * vi phạm các quy ước quốc tế",
  },
  {
    word: "qui ước",
    part_of_speech: "động từ",
    meaning:
      "thoả thuận với nhau mà quy định: kí hiệu quy ước * hẹn gặp tại địa điểm đã quy ước",
    example: "kí hiệu quy ước * hẹn gặp tại địa điểm đã quy ước",
  },
  {
    word: "quí tướng",
    part_of_speech: "danh từ",
    meaning:
      "tướng mạo của người tỏ ra là sẽ làm nên, theo mê tín: người có quý tướng",
    example: "người có quý tướng",
  },
  {
    word: "quota",
    part_of_speech: "danh từ",
    meaning:
      "số lượng hoặc tỉ lệ tối đa cho phép, như về hàng hoá xuất khẩu, nhập khẩu trong một thời gian nhất định, v.v.; giấy phép cấp trong trường hợp nói trên: phân bổ quota không đều * xin được một quota xuất khẩu gạo",
    example: "phân bổ quota không đều * xin được một quota xuất khẩu gạo",
  },
  {
    word: "quốc âm",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) tiếng nước nhà; dùng để chỉ tiếng Việt ghi bằng chữ Nôm, đối lập với tiếng Hán ghi bằng chữ Hán: dịch ra quốc âm * thơ quốc âm của Nguyễn Trãi",
    example: "dịch ra quốc âm * thơ quốc âm của Nguyễn Trãi",
  },
  {
    word: "qui y",
    part_of_speech: "động từ",
    meaning:
      "thụ lễ theo đạo Phật, để chính thức trở thành Phật tử: quy y cửa Phật * cắt tóc quy y",
    example: "quy y cửa Phật * cắt tóc quy y",
  },
  {
    word: "quịt",
    part_of_speech: "động từ",
    meaning:
      "cố tình không chịu trả, không chịu thanh toán cái mình đang nợ của ai đó: vay xong rồi quỵt * quỵt nợ",
    example: "vay xong rồi quỵt * quỵt nợ",
  },
  {
    word: "quốc cấm",
    part_of_speech: "tính từ",
    meaning: "bị pháp luật cấm: hàng quốc cấm * chứa đồ quốc cấm",
    example: "hàng quốc cấm * chứa đồ quốc cấm",
  },
  {
    word: "quốc ca",
    part_of_speech: "danh từ",
    meaning:
      "bài hát chính thức của một quốc gia, dùng khi có lễ nghi trọng thể: hát quốc ca trong lễ chào cờ",
    example: "hát quốc ca trong lễ chào cờ",
  },
  {
    word: "quốc dân",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) nhân dân trong nước: gửi quốc dân đồng bào * nền kinh tế quốc dân",
    example: "gửi quốc dân đồng bào * nền kinh tế quốc dân",
  },
  {
    word: "quốc đảo",
    part_of_speech: "danh từ",
    meaning: "như đảo quốc: Singapore là một quốc đảo",
    example: "Singapore là một quốc đảo",
  },
  {
    word: "quốc doanh",
    part_of_speech: "tính từ",
    meaning:
      "do nhà nước tổ chức kinh doanh: thành phần kinh tế ngoài quốc doanh * xí nghiệp quốc doanh",
    example: "thành phần kinh tế ngoài quốc doanh * xí nghiệp quốc doanh",
  },
  {
    word: "quốc giáo",
    part_of_speech: "danh từ",
    meaning:
      "tôn giáo chính thức của một nước: ở triều Lý, Trần, Phật giáo là quốc giáo của nước ta",
    example: "ở triều Lý, Trần, Phật giáo là quốc giáo của nước ta",
  },
  {
    word: "quốc gia",
    part_of_speech: "danh từ",
    meaning:
      "nước, nhà nước: giải vô địch quốc gia * điện lưới quốc gia * nguyên thủ quốc gia",
    example: "giải vô địch quốc gia * điện lưới quốc gia * nguyên thủ quốc gia",
  },
  {
    word: "quốc gia",
    part_of_speech: "danh từ",
    meaning: "(cũ) đất nước, tổ quốc của mình: lo việc quốc gia",
    example: "lo việc quốc gia",
  },
  {
    word: "quốc gia",
    part_of_speech: "tính từ",
    meaning: "theo chủ nghĩa quốc gia: tư tưởng quốc gia hẹp hòi",
    example: "tư tưởng quốc gia hẹp hòi",
  },
  {
    word: "quốc hiệu",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi chính thức của một nước: Hùng Vương đặt quốc hiệu là Văn Lang",
    example: "Hùng Vương đặt quốc hiệu là Văn Lang",
  },
  {
    word: "quốc lập",
    part_of_speech: "tính từ",
    meaning: "như công lập: trường quốc lập",
    example: "trường quốc lập",
  },
  {
    word: "quốc hồn",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) tinh thần đặc biệt của dân tộc, do lịch sử lâu đời kết tinh lại mà thành, tạo nên sức sống của một quốc gia: giữ gìn quốc hồn, quốc tuý",
    example: "giữ gìn quốc hồn, quốc tuý",
  },
  {
    word: "quốc hữu hoá",
    part_of_speech: "động từ",
    meaning:
      "(tư liệu sản xuất, xí nghiệp, đất đai, v.v. thuộc tư nhân) chuyển thành của nhà nước, do nhà nước quản lí: quốc hữu hoá toàn bộ hệ thống ngân hàng của chế độ cũ",
    example: "quốc hữu hoá toàn bộ hệ thống ngân hàng của chế độ cũ",
  },
  {
    word: "quốc khánh",
    part_of_speech: "danh từ",
    meaning:
      "lễ chính thức lớn nhất của một nước, thường là kỉ niệm ngày thành lập nước: mít tinh mừng quốc khánh",
    example: "mít tinh mừng quốc khánh",
  },
  {
    word: "quốc ngữ",
    part_of_speech: "danh từ",
    meaning: "(hiếm) tiếng nói chung của cả nước: bảo tồn quốc ngữ",
    example: "bảo tồn quốc ngữ",
  },
  {
    word: "quốc ngữ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) chữ quốc ngữ (nói tắt): sách quốc ngữ * viết bằng quốc ngữ",
    example: "sách quốc ngữ * viết bằng quốc ngữ",
  },
  {
    word: "quốc pháp",
    part_of_speech: "danh từ",
    meaning: "(cũ) pháp luật của một nước: coi trọng quốc pháp",
    example: "coi trọng quốc pháp",
  },
  {
    word: "quốc sắc",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) sắc đẹp nổi tiếng trong cả nước: "Người quốc sắc, kẻ thiên tài, Tình trong như đã, mặt ngoài còn e." (TKiều)',
    example:
      'Người quốc sắc, kẻ thiên tài, Tình trong như đã, mặt ngoài còn e." (TKiều)',
  },
  {
    word: "quốc nạn",
    part_of_speech: "danh từ",
    meaning:
      "nạn lớn, gây ảnh hưởng, thiệt hại nghiêm trọng cho đất nước: tham nhũng là một quốc nạn",
    example: "tham nhũng là một quốc nạn",
  },
  {
    word: "quốc sách",
    part_of_speech: "danh từ",
    meaning: "chính sách lớn, quan trọng của nhà nước: tiết kiệm là quốc sách",
    example: "tiết kiệm là quốc sách",
  },
  {
    word: "quốc lủi",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) rượu gạo nấu bằng phương pháp thủ công, có màu trong suốt, nồng độ cao (thời Pháp thuộc thường phải nấu lậu): mua một chai quốc lủi",
    example: "mua một chai quốc lủi",
  },
  {
    word: "quốc phòng",
    part_of_speech: "danh từ",
    meaning:
      "việc giữ gìn chủ quyền và an ninh của đất nước (nói khái quát): an ninh quốc phòng * bộ quốc phòng * ngân sách quốc phòng",
    example: "an ninh quốc phòng * bộ quốc phòng * ngân sách quốc phòng",
  },
  {
    word: "quốc nội",
    part_of_speech: "tính từ",
    meaning:
      "ở trong nước, thuộc phạm vi trong nước: thu nhập quốc nội * tổng sản phẩm quốc nội",
    example: "thu nhập quốc nội * tổng sản phẩm quốc nội",
  },
  {
    word: "quốc sự",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) việc lớn của đất nước; việc nước: lo việc quốc sự * bàn quốc sự",
    example: "lo việc quốc sự * bàn quốc sự",
  },
  {
    word: "quốc tế hoá",
    part_of_speech: "động từ",
    meaning:
      "làm cho có tính chất quốc tế: có xu thế quốc tế hoá * quốc tế hoá các thuật ngữ khoa học",
    example: "có xu thế quốc tế hoá * quốc tế hoá các thuật ngữ khoa học",
  },
  {
    word: "quốc sắc thiên hương",
    part_of_speech: "",
    meaning:
      '(cũ, văn chương) sắc nước hương trời: "Đã nên quốc sắc thiên hương, Một cười này, hẳn nghìn vàng chẳng ngoa." (TKiều)',
    example:
      'Đã nên quốc sắc thiên hương, Một cười này, hẳn nghìn vàng chẳng ngoa." (TKiều)',
  },
  {
    word: "quốc táng",
    part_of_speech: "danh từ",
    meaning: "việc chôn cất theo nghi lễ trọng thể của nhà nước: lễ quốc táng",
    example: "lễ quốc táng",
  },
  {
    word: "quốc tang",
    part_of_speech: "danh từ",
    meaning: "tang chung của cả nước: tổ chức quốc tang",
    example: "tổ chức quốc tang",
  },
  {
    word: "quốc tế",
    part_of_speech: "danh từ",
    meaning:
      "các nước trên thế giới trong quan hệ với nhau (nói tổng quát): tin quốc tế * phong trào công nhân quốc tế * quan hệ quốc tế",
    example: "tin quốc tế * phong trào công nhân quốc tế * quan hệ quốc tế",
  },
  {
    word: "quốc tế",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về quan hệ giữa các nước trên thế giới: sân bay quốc tế * hội nghị quốc tế * công ước quốc tế",
    example: "sân bay quốc tế * hội nghị quốc tế * công ước quốc tế",
  },
  {
    word: "quốc tế",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về chủ nghĩa quốc tế, theo chủ nghĩa quốc tế: tư tưởng quốc tế",
    example: "tư tưởng quốc tế",
  },
  {
    word: "quốc thể",
    part_of_speech: "danh từ",
    meaning: "danh dự của một quốc gia: coi trọng quốc thể * giữ gìn quốc thể",
    example: "coi trọng quốc thể * giữ gìn quốc thể",
  },
  {
    word: "quốc thiều",
    part_of_speech: "danh từ",
    meaning: "nhạc của bài quốc ca: cử quốc thiều",
    example: "cử quốc thiều",
  },
  {
    word: "quốc tịch",
    part_of_speech: "danh từ",
    meaning:
      "tư cách là công dân của một nước nhất định, được pháp luật nước đó thừa nhận: một người Việt có quốc tịch Pháp",
    example: "một người Việt có quốc tịch Pháp",
  },
  {
    word: "quốc tế ngữ",
    part_of_speech: "danh từ",
    meaning:
      "ngôn ngữ đặt ra nhằm mục đích dùng chung cho các nước trên thế giới: Esperanto là một quốc tế ngữ",
    example: "Esperanto là một quốc tế ngữ",
  },
  {
    word: "quốc thích",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) họ hàng thân thích bên ngoại của nhà vua: hoàng thân, quốc thích",
    example: "hoàng thân, quốc thích",
  },
  {
    word: "quốc thư",
    part_of_speech: "danh từ",
    meaning:
      "công hàm của người đứng đầu một nước này gửi cho người đứng đầu một nước khác để giới thiệu đại sứ hay công sứ đặc mệnh toàn quyền: đại sứ trình quốc thư",
    example: "đại sứ trình quốc thư",
  },
  {
    word: "quơ",
    part_of_speech: "động từ",
    meaning:
      "đưa qua đưa lại trong khoảng không, hướng không xác định: quơ chân tìm dép * quơ đuốc cho lửa bốc cao",
    example: "quơ chân tìm dép * quơ đuốc cho lửa bốc cao",
  },
  {
    word: "quơ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tóm lấy một cách vội vàng, chỉ cốt cho nhanh: quơ nắm lá về xông * quơ vội cái áo mặc vào",
    example: "quơ nắm lá về xông * quơ vội cái áo mặc vào",
  },
  {
    word: "quờ",
    part_of_speech: "động từ",
    meaning:
      "quơ đi quơ lại tay, chân theo nhiều hướng, thường để tìm khi không thể nhìn thấy: quờ tay lần tìm trong bóng tối",
    example: "quờ tay lần tìm trong bóng tối",
  },
  {
    word: "quờ",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) quơ vội, chỉ cốt lấy được cho nhanh: quờ đống lá khô về nhóm bếp",
    example: "quờ đống lá khô về nhóm bếp",
  },
  {
    word: "quốc trưởng",
    part_of_speech: "danh từ",
    meaning:
      "người đứng đầu một nước, theo cách gọi của một số nước: quốc trưởng Campuchia",
    example: "quốc trưởng Campuchia",
  },
  {
    word: "quốc văn",
    part_of_speech: "danh từ",
    meaning:
      "(sách báo) tiếng nước nhà; phân biệt với ngoại văn: hiệu sách quốc văn",
    example: "hiệu sách quốc văn",
  },
  {
    word: "quốc văn",
    part_of_speech: "danh từ",
    meaning: "(cũ) ngôn ngữ và văn học nước nhà: môn quốc văn",
    example: "môn quốc văn",
  },
  {
    word: "quốc tuý",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) cái tinh hoa trong nền văn hoá của một dân tộc, một quốc gia: bảo tồn quốc tuý",
    example: "bảo tồn quốc tuý",
  },
  {
    word: "quở",
    part_of_speech: "động từ",
    meaning:
      "(cũ) nhận xét trực tiếp một cách nghiêm khắc lỗi của người bề dưới: quở cho một trận * bị mẹ quở",
    example: "quở cho một trận * bị mẹ quở",
  },
  {
    word: "quở",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nhận xét có ý chê bai về người nào đó, nhằm làm cho người đó phải chú ý: bị mọi người quở là gầy quá",
    example: "bị mọi người quở là gầy quá",
  },
  {
    word: "quở",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nhận xét có ý khen, thường là về tình trạng sức khoẻ của trẻ con, điều mà người xưa cho rằng có thể đưa đến sự chẳng lành (lối nói kiêng tránh): đứa trẻ mũm mĩm nên hay bị quở",
    example: "đứa trẻ mũm mĩm nên hay bị quở",
  },
  {
    word: "quở mắng",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) quở trách bằng những lời nói nặng: làm sai nên bị mẹ quở mắng",
    example: "làm sai nên bị mẹ quở mắng",
  },
  {
    word: "quở phạt",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) trách mắng và phạt lỗi (nói khái quát): bị thầy giáo quở phạt",
    example: "bị thầy giáo quở phạt",
  },
  {
    word: "quờ quạng",
    part_of_speech: "động từ",
    meaning:
      "quờ hết chỗ này đến chỗ khác theo đủ các hướng, thường để tìm kiếm vật gì: đi quờ quạng trong bóng tối * quờ quạng sờ tìm bao diêm",
    example: "đi quờ quạng trong bóng tối * quờ quạng sờ tìm bao diêm",
  },
  {
    word: "quở trách",
    part_of_speech: "động từ",
    meaning:
      "phê bình một cách nghiêm khắc lỗi của người bề dưới: quở trách học trò * cái nhìn quở trách",
    example: "quở trách học trò * cái nhìn quở trách",
  },
  {
    word: "quở quang",
    part_of_speech: "động từ",
    meaning: "(hiếm) như quở (ng3; nói khái quát): quở quang thằng bé",
    example: "quở quang thằng bé",
  },
  {
    word: "quy",
    part_of_speech: "động từ",
    meaning:
      "đưa về, gom lại trong nhận thức thành một cái gì đơn giản hơn dựa trên những đặc điểm chung cơ bản nào đó: quy về một mối * quy thành mấy kiểu chính",
    example: "quy về một mối * quy thành mấy kiểu chính",
  },
  {
    word: "quy",
    part_of_speech: "động từ",
    meaning:
      "chuyển thành một loại nào đó tương đương về giá trị để tiện cho việc tính toán: quy thành tiền * cứ quy ra thóc mà nộp thuế",
    example: "quy thành tiền * cứ quy ra thóc mà nộp thuế",
  },
  {
    word: "quy",
    part_of_speech: "động từ",
    meaning:
      "cho đó là phần trách nhiệm, công lao, tội lỗi thuộc về người nào đó: quy trách nhiệm rõ ràng * quy sai tội cho người khác",
    example: "quy trách nhiệm rõ ràng * quy sai tội cho người khác",
  },
  {
    word: "quý",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian bằng ba tháng, tính từ tháng một trở đi: lên kế hoạch làm việc của cả quý * nộp báo cáo quý",
    example: "lên kế hoạch làm việc của cả quý * nộp báo cáo quý",
  },
  {
    word: "quý",
    part_of_speech: "tính từ",
    meaning: "có giá trị cao: của quý * con người là vốn quý * quý như vàng",
    example: "của quý * con người là vốn quý * quý như vàng",
  },
  {
    word: "quý",
    part_of_speech: "tính từ",
    meaning:
      "(Kiểu cách) từ dùng trước một danh từ trong những tổ hợp dùng để gọi một cách lịch sự một số người hay một tổ chức nào đó nói chung, khi nói với những người hay tổ chức ấy: quý ông * quý vị đại biểu * theo yêu cầu của quý cơ quan",
    example: "quý ông * quý vị đại biểu * theo yêu cầu của quý cơ quan",
  },
  {
    word: "quý",
    part_of_speech: "động từ",
    meaning:
      "coi là quý: quý con quý cháu * không biết quý sức khoẻ * quý thời gian",
    example: "quý con quý cháu * không biết quý sức khoẻ * quý thời gian",
  },
  {
    word: "quỹ",
    part_of_speech: "danh từ",
    meaning:
      "số tiền dành riêng cho những khoản chi tiêu nhất định: quỹ tiền lương * quỹ phúc lợi * nộp quỹ lớp",
    example: "quỹ tiền lương * quỹ phúc lợi * nộp quỹ lớp",
  },
  {
    word: "quỹ",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức làm nơi nhận gửi và chi trả tiền: quỹ tiết kiệm * quỹ tín dụng",
    example: "quỹ tiết kiệm * quỹ tín dụng",
  },
  {
    word: "quỳ",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ, hoặc cũ) hướng dương: hoa quỳ",
    example: "hoa quỳ",
  },
  {
    word: "quỳ",
    part_of_speech: "danh từ",
    meaning:
      "vàng, bạc dát mỏng, thường dùng để thếp câu đối, hoành phi, v.v.: vàng quỳ",
    example: "vàng quỳ",
  },
  {
    word: "quỳ",
    part_of_speech: "động từ",
    meaning:
      "ở tư thế đầu gối gập xuống và đặt sát mặt nền để đỡ toàn thân: ngắm bắn ở tư thế quỳ * quỳ trước bàn thờ * tủ chân quỳ",
    example: "ngắm bắn ở tư thế quỳ * quỳ trước bàn thờ * tủ chân quỳ",
  },
  {
    word: "quỷ",
    part_of_speech: "danh từ",
    meaning:
      "con vật tưởng tượng ở dưới âm phủ, hình thù kì dị và dữ tợn, hay hiện lên quấy nhiễu và làm hại người, theo truyền thuyết: con quỷ",
    example: "con quỷ",
  },
  {
    word: "quỷ",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) kẻ tinh nghịch, quái ác hay quấy phá (thường dùng làm tiếng mắng): thằng quỷ, nghịch vừa chứ!",
    example: "thằng quỷ, nghịch vừa chứ!",
  },
  {
    word: "quy bản",
    part_of_speech: "danh từ",
    meaning: "yếm rùa, dùng để nấu cao: cao quy bản",
    example: "cao quy bản",
  },
  {
    word: "quỵ",
    part_of_speech: "động từ",
    meaning:
      "gập hẳn hai gối lại trên mặt nền ở tư thế quỳ, không gượng lại nổi: quỵ gối * bước được vài bước thì quỵ xuống",
    example: "quỵ gối * bước được vài bước thì quỵ xuống",
  },
  {
    word: "quỵ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) mất hết sức lực, không còn có thể gắng gượng gì được nữa: làm quên ăn quên ngủ như thế không khéo quỵ mất!",
    example: "làm quên ăn quên ngủ như thế không khéo quỵ mất!",
  },
  {
    word: "quy chế",
    part_of_speech: "danh từ",
    meaning:
      "những điều đã được quy định thành chế độ để mọi người theo đó mà thực hiện trong những hoạt động nhất định nào đó: công bố quy chế tuyển sinh * được thưởng theo đúng quy chế",
    example: "công bố quy chế tuyển sinh * được thưởng theo đúng quy chế",
  },
  {
    word: "quỹ đạo",
    part_of_speech: "danh từ",
    meaning:
      "đường cong do một vật thể chuyển động trong không gian vạch ra: quỹ đạo của Trái Đất quanh Mặt Trời",
    example: "quỹ đạo của Trái Đất quanh Mặt Trời",
  },
  {
    word: "quỹ đạo",
    part_of_speech: "danh từ",
    meaning:
      "vòng ảnh hưởng, phạm vi tác động của cái gì: quỹ đạo phát triển kinh tế của khu vực",
    example: "quỹ đạo phát triển kinh tế của khu vực",
  },
  {
    word: "quy cách",
    part_of_speech: "danh từ",
    meaning:
      "những yêu cầu về mặt kĩ thuật đối với một sản phẩm (nói tổng quát): làm sai quy cách * cứ theo quy cách mà làm",
    example: "làm sai quy cách * cứ theo quy cách mà làm",
  },
  {
    word: "quy chụp",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) quy lỗi cho người khác theo kiểu chụp mũ: bị cấp trên quy chụp",
    example: "bị cấp trên quy chụp",
  },
  {
    word: "quy định",
    part_of_speech: "",
    meaning:
      "định ra để phải theo, phải thực hiện trong công việc, trong hoạt động cụ thể: quy định thời gian làm việc * làm đủ các thủ tục theo quy định",
    example: "quy định thời gian làm việc * làm đủ các thủ tục theo quy định",
  },
  {
    word: "quỹ đen",
    part_of_speech: "danh từ",
    meaning:
      "quỹ dành riêng cho những khoản chi được giữ bí mật, thường là bất hợp pháp: phát hiện quỹ đen của công ti * lập quỹ đen",
    example: "phát hiện quỹ đen của công ti * lập quỹ đen",
  },
  {
    word: "quy chuẩn",
    part_of_speech: "danh từ",
    meaning:
      "quy cách, tiêu chuẩn đã được quy định (nói khái quát): áp dụng quy chuẩn xây dựng * sản phẩm chưa đạt quy chuẩn",
    example: "áp dụng quy chuẩn xây dựng * sản phẩm chưa đạt quy chuẩn",
  },
  {
    word: "quý danh",
    part_of_speech: "danh từ",
    meaning:
      "(trang trọng) từ dùng để gọi tôn tên của người mà mình cần hỏi, khi nói với người ấy: xin anh cho biết quý danh",
    example: "xin anh cho biết quý danh",
  },
  {
    word: "quý giá",
    part_of_speech: "tính từ",
    meaning:
      "có giá trị lớn: đồ nữ trang quý giá * không có tài sản gì quý giá",
    example: "đồ nữ trang quý giá * không có tài sản gì quý giá",
  },
  {
    word: "quý hiếm",
    part_of_speech: "tính từ",
    meaning: "quý giá và hiếm có: động vật quý hiếm",
    example: "động vật quý hiếm",
  },
  {
    word: "quy đổi",
    part_of_speech: "động từ",
    meaning:
      "chuyển đổi sang một hệ đơn vị khác: tính hệ số quy đổi * quy đổi thời gian công tác * quy đổi từ đồng yen Nhật sang đồng Việt Nam",
    example:
      "tính hệ số quy đổi * quy đổi thời gian công tác * quy đổi từ đồng yen Nhật sang đồng Việt Nam",
  },
  {
    word: "quy củ",
    part_of_speech: "danh từ",
    meaning:
      "toàn thể nói chung những quy định nhằm làm cho một việc làm nào đó thành có trật tự, có tổ chức: công việc có quy củ",
    example: "công việc có quy củ",
  },
  {
    word: "quy củ",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) có trật tự, có tổ chức: làm ăn rất quy củ * gia đình quy củ * không khí làm việc khẩn trương và quy củ",
    example:
      "làm ăn rất quy củ * gia đình quy củ * không khí làm việc khẩn trương và quy củ",
  },
  {
    word: "quý báu",
    part_of_speech: "tính từ",
    meaning:
      "có giá trị, đáng được coi trọng: thì giờ quý báu * yêu nước thương nòi là truyền thống quý báu của dân tộc ta",
    example:
      "thì giờ quý báu * yêu nước thương nòi là truyền thống quý báu của dân tộc ta",
  },
  {
    word: "quy hàng",
    part_of_speech: "động từ",
    meaning:
      "(cũ) chịu thua và chịu theo đối phương, không chống lại nữa: tướng giặc phải cởi giáp quy hàng",
    example: "tướng giặc phải cởi giáp quy hàng",
  },
  {
    word: "quý hoá",
    part_of_speech: "tính từ",
    meaning:
      "đáng quý, đáng coi trọng (thường nói về mặt tinh thần): tình cảm quý hoá * cô con dâu quý hoá * được như thế thì còn gì quý hoá bằng!",
    example:
      "tình cảm quý hoá * cô con dâu quý hoá * được như thế thì còn gì quý hoá bằng!",
  },
  {
    word: "quý hoá",
    part_of_speech: "động từ",
    meaning: "(hiếm) coi là quý: bà cụ quý hoá anh như con",
    example: "bà cụ quý hoá anh như con",
  },
  {
    word: "quy hoạch",
    part_of_speech: "",
    meaning:
      "bố trí, sắp xếp toàn bộ theo một trình tự hợp lí trong từng thời gian, làm cơ sở cho việc lập kế hoạch dài hạn: quy hoạch các khu kinh tế * khu vực sắp quy hoạch",
    example: "quy hoạch các khu kinh tế * khu vực sắp quy hoạch",
  },
  {
    word: "quý hồ",
    part_of_speech: "kết từ",
    meaning:
      'miễn sao, chỉ cần (một điều kiện) là (chứ không đòi hỏi gì hơn): "Quý hồ anh có lòng thương, Em có lòng đợi như rương khoá rồi." (ca dao)',
    example:
      'Quý hồ anh có lòng thương, Em có lòng đợi như rương khoá rồi." (ca dao)',
  },
  {
    word: "quý khách",
    part_of_speech: "danh từ",
    meaning:
      "(trang trọng) từ dùng để gọi chung hành khách, khách hàng, khách trọ, v.v. một cách lịch sự: kính mời quý khách lên tàu",
    example: "kính mời quý khách lên tàu",
  },
  {
    word: "quy kết",
    part_of_speech: "động từ",
    meaning:
      "đưa ra nhận định về người nào đó một cách chủ quan, thiếu căn cứ (và thường là đánh giá nặng nề): không nên quy kết vội vàng * bị quy kết là kẻ có tội",
    example: "không nên quy kết vội vàng * bị quy kết là kẻ có tội",
  },
  {
    word: "quỷ kế",
    part_of_speech: "danh từ",
    meaning: "mưu kế quỷ quyệt: bày quỷ kế * dùng quỷ kế để hại người",
    example: "bày quỷ kế * dùng quỷ kế để hại người",
  },
  {
    word: "quy luật",
    part_of_speech: "danh từ",
    meaning:
      "mối liên hệ bản chất ổn định, được lặp đi lặp lại giữa các hiện tượng trong tự nhiên và xã hội: quy luật phát triển xã hội * quy luật di truyền",
    example: "quy luật phát triển xã hội * quy luật di truyền",
  },
  {
    word: "quỷ khốc thần kinh",
    part_of_speech: "",
    meaning:
      'quỷ thần cũng phải khiếp sợ (trước cảnh tượng hãi hùng, khủng khiếp hoặc điều kì lạ, phi thường): "Hoa thêu gấm dệt lời chau chuốt, Quỷ khốc thần kinh bút vẫy vùng." (LTKN)',
    example:
      'Hoa thêu gấm dệt lời chau chuốt, Quỷ khốc thần kinh bút vẫy vùng." (LTKN)',
  },
  {
    word: "quý nhân",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, hiếm) người ở bậc cao sang và được kính trọng: có cốt cách của một bậc quý nhân",
    example: "có cốt cách của một bậc quý nhân",
  },
  {
    word: "quý nhân",
    part_of_speech: "danh từ",
    meaning:
      "người luôn che chở, giúp đỡ cho khi gặp khó khăn, hoạn nạn, như đã định trong số mệnh, theo mê tín: số có có quý nhân phù trợ",
    example: "số có có quý nhân phù trợ",
  },
  {
    word: "quý phái",
    part_of_speech: "tính từ",
    meaning:
      "thuộc dòng dõi quý tộc hoặc có dáng vẻ sang như con nhà quý tộc: con nhà quý phái * dáng điệu thanh cao quý phái",
    example: "con nhà quý phái * dáng điệu thanh cao quý phái",
  },
  {
    word: "quỵ luỵ",
    part_of_speech: "động từ",
    meaning:
      "tự hạ mình chịu nhục trước người khác để cầu xin, nhờ vả điều gì: hạ mình quỵ luỵ để nhờ vả * không chịu quỵ luỵ ai",
    example: "hạ mình quỵ luỵ để nhờ vả * không chịu quỵ luỵ ai",
  },
  {
    word: "quý mến",
    part_of_speech: "động từ",
    meaning:
      "quý và yêu mến: đem lòng quý mến * thông minh, tốt tính nên ai cũng quý mến",
    example: "đem lòng quý mến * thông minh, tốt tính nên ai cũng quý mến",
  },
  {
    word: "quy phạm",
    part_of_speech: "danh từ",
    meaning:
      "điều quy định chặt chẽ, đòi hỏi phải tuân theo: quy phạm đạo đức * văn bản quy phạm pháp luật",
    example: "quy phạm đạo đức * văn bản quy phạm pháp luật",
  },
  {
    word: "quy phạm pháp luật",
    part_of_speech: "danh từ",
    meaning:
      "quy tắc ứng xử có tính chất khuôn mẫu do nhà nước ban hành hoặc thừa nhận, bắt buộc mọi chủ thể phải tuân theo: thi hành văn bản quy phạm pháp luật",
    example: "thi hành văn bản quy phạm pháp luật",
  },
  {
    word: "quy phục",
    part_of_speech: "động từ",
    meaning: "như hàng phục: cúi đầu quy phục * thuận lòng quy phục",
    example: "cúi đầu quy phục * thuận lòng quy phục",
  },
  {
    word: "quy nạp",
    part_of_speech: "động từ",
    meaning:
      "(suy lí, suy luận) đi từ những hiện tượng, sự kiện riêng đến những kết luận chung; phân biệt với diễn dịch: trình bày theo lối quy nạp * phương pháp quy nạp",
    example: "trình bày theo lối quy nạp * phương pháp quy nạp",
  },
  {
    word: "quỷ quái",
    part_of_speech: "tính từ",
    meaning:
      'hết sức tai ác và ranh mãnh: "Vợ chàng quỷ quái, tinh ma, Phen này kẻ cắp, bà già gặp nhau!" (TKiều)',
    example:
      'Vợ chàng quỷ quái, tinh ma, Phen này kẻ cắp, bà già gặp nhau!" (TKiều)',
  },
  {
    word: "quỷ quái",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) như quái: quỷ quái thật, vừa mới để đây mà bây giờ không thấy đâu",
    example: "quỷ quái thật, vừa mới để đây mà bây giờ không thấy đâu",
  },
  {
    word: "quy mô",
    part_of_speech: "danh từ",
    meaning:
      "độ rộng lớn về mặt tổ chức: mở rộng quy mô của xí nghiệp * công trình có quy mô hiện đại",
    example: "mở rộng quy mô của xí nghiệp * công trình có quy mô hiện đại",
  },
  {
    word: "quy mô",
    part_of_speech: "tính từ",
    meaning:
      "có độ rộng lớn về khuôn khổ hay về mặt tổ chức: công trình xây dựng khá quy mô",
    example: "công trình xây dựng khá quy mô",
  },
  {
    word: "quỷ quyệt",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều mánh khoé hiểm độc, gian giảo, khó lường trước được: mưu mô quỷ quyệt * con người quỷ quyệt",
    example: "mưu mô quỷ quyệt * con người quỷ quyệt",
  },
  {
    word: "quỷ sứ",
    part_of_speech: "danh từ",
    meaning:
      "quỷ dưới âm phủ, chuyên hành hạ linh hồn những người có tội, theo mê tín.",
    example: "đồ quỷ sứ!",
  },
  {
    word: "quy tập",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) tập trung về một chỗ (thường nói về mồ mả, hài cốt): tiến hành công tác quy tập mộ liệt sĩ",
    example: "tiến hành công tác quy tập mộ liệt sĩ",
  },
  {
    word: "quỷ tha ma bắt",
    part_of_speech: "",
    meaning:
      "(thông tục) lời chửi rủa đối với những kẻ mình cho là có hành động hết sức tồi tệ, không thể chấp nhận được: đồ quỷ tha ma bắt!",
    example: "đồ quỷ tha ma bắt!",
  },
  {
    word: "quy thuận",
    part_of_speech: "động từ",
    meaning:
      "chịu theo đối phương, không hoạt động chống đối lại nữa: quy thuận triều đình",
    example: "quy thuận triều đình",
  },
  {
    word: "quỹ tiết kiệm",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức nhận gửi tiền tiết kiệm, có trả lãi: nhân viên quỹ tiết kiệm",
    example: "nhân viên quỹ tiết kiệm",
  },
  {
    word: "quỷ thần",
    part_of_speech: "danh từ",
    meaning: "các vị thần linh (nói khái quát): nói có quỷ thần chứng giám",
    example: "nói có quỷ thần chứng giám",
  },
  {
    word: "quy tiên",
    part_of_speech: "động từ",
    meaning:
      "(cũ, trang trọng) chết, coi như về cõi tiên (nói về người già): hai cụ đều đã quy tiên",
    example: "hai cụ đều đã quy tiên",
  },
  {
    word: "quy tắc",
    part_of_speech: "danh từ",
    meaning:
      "những điều quy định đòi hỏi phải tuân theo trong một hoạt động chung nào đó (nói tổng quát): tôn trọng quy tắc thi đấu * quy tắc bảo đảm vệ sinh an toàn thực phẩm",
    example:
      "tôn trọng quy tắc thi đấu * quy tắc bảo đảm vệ sinh an toàn thực phẩm",
  },
  {
    word: "quy tắc",
    part_of_speech: "danh từ",
    meaning:
      "công thức, hình thức ngắn gọn nêu lên những điều cần phải làm theo trong những trường hợp nhất định: quy tắc viết hoa * quy tắc quy đồng mẫu số",
    example: "quy tắc viết hoa * quy tắc quy đồng mẫu số",
  },
  {
    word: "quý tộc",
    part_of_speech: "danh từ",
    meaning:
      "người thuộc tầng lớp trên, có đặc quyền, đặc lợi trong xã hội chiếm hữu nô lệ, xã hội phong kiến hay các quốc gia quân chủ: có dòng dõi quý tộc * tầng lớp quý tộc phong kiến",
    example: "có dòng dõi quý tộc * tầng lớp quý tộc phong kiến",
  },
  {
    word: "quý tộc",
    part_of_speech: "tính từ",
    meaning:
      "có vẻ sang trọng, có kiểu cách của người thuộc tầng lớp trên trong xã hội: dáng vẻ quý tộc * lối sống quý tộc",
    example: "dáng vẻ quý tộc * lối sống quý tộc",
  },
  {
    word: "quý tướng",
    part_of_speech: "danh từ",
    meaning:
      "tướng mạo của người tỏ ra là sẽ làm nên, theo mê tín: người có quý tướng",
    example: "người có quý tướng",
  },
  {
    word: "quy tụ",
    part_of_speech: "động từ",
    meaning:
      "(từ nhiều nơi, nhiều hướng) quy về, tụ về một chỗ, một điểm: quy tụ nhân tài * học trò các nơi quy tụ về kinh dự thi",
    example: "quy tụ nhân tài * học trò các nơi quy tụ về kinh dự thi",
  },
  {
    word: "quy ước",
    part_of_speech: "danh từ",
    meaning:
      "những điều quy định thoả thuận với nhau về một vấn đề nào đó, cần phải làm theo: thực hiện đúng quy ước * vi phạm các quy ước quốc tế",
    example: "thực hiện đúng quy ước * vi phạm các quy ước quốc tế",
  },
  {
    word: "quy ước",
    part_of_speech: "động từ",
    meaning:
      "thoả thuận với nhau mà quy định: kí hiệu quy ước * hẹn gặp tại địa điểm đã quy ước",
    example: "kí hiệu quy ước * hẹn gặp tại địa điểm đã quy ước",
  },
  {
    word: "quy trình",
    part_of_speech: "danh từ",
    meaning:
      "trình tự phải tuân theo để tiến hành một công việc nào đó: quy trình sản xuất * quy trình thiết kế",
    example: "quy trình sản xuất * quy trình thiết kế",
  },
  {
    word: "quy y",
    part_of_speech: "động từ",
    meaning:
      "thụ lễ theo đạo Phật, để chính thức trở thành Phật tử: quy y cửa Phật * cắt tóc quy y",
    example: "quy y cửa Phật * cắt tóc quy y",
  },
  {
    word: "quý trọng",
    part_of_speech: "động từ",
    meaning: "quý và coi trọng (nói khái quát): quý trọng thầy cô giáo",
    example: "quý trọng thầy cô giáo",
  },
  {
    word: "quyến",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) rủ rê, dụ dỗ đến với mình, đi theo cùng với mình: quyến gió rủ mây",
    example: "quyến gió rủ mây",
  },
  {
    word: "quyến",
    part_of_speech: "động từ",
    meaning:
      'có sự gắn bó về tình cảm, không muốn rời xa: "Gió vào ve vuốt má đào, Má đào quyến gió, lối nào gió ra?" (ca dao)',
    example:
      'Gió vào ve vuốt má đào, Má đào quyến gió, lối nào gió ra?" (ca dao)',
  },
  {
    word: "quý vị",
    part_of_speech: "danh từ",
    meaning:
      "(trang trọng) tiếng gọi tôn một hay nhiều người một cách lịch sự: kính thưa các quý vị * quý vị đại biểu",
    example: "kính thưa các quý vị * quý vị đại biểu",
  },
  {
    word: "quý tử",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) đứa con trai có những phẩm chất dự báo sau này sẽ làm nên sự nghiệp, theo quan niệm xưa: sinh được quý tử",
    example: "sinh được quý tử",
  },
  {
    word: "quý tử",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) người con trai được gia đình nuông chiều (thường dùng với hàm ý coi thường hay châm biếm): ông con quý tử",
    example: "ông con quý tử",
  },
  {
    word: "quyến anh rủ yến",
    part_of_speech: "",
    meaning:
      '(cũ, văn chương) ví việc dụ dỗ, lừa gạt phụ nữ: "Nàng rằng: Trời nhẽ có hay!, Quyến anh, rủ yến, sự này tại ai?" (TKiều)',
    example:
      'Nàng rằng: Trời nhẽ có hay!, Quyến anh, rủ yến, sự này tại ai?" (TKiều)',
  },
  {
    word: "quyển",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị sách, vở được đóng riêng thành tập: quyển vở * quyển sách * quyển sổ",
    example: "quyển vở * quyển sách * quyển sổ",
  },
  {
    word: "quyền",
    part_of_speech: "danh từ",
    meaning:
      "môn võ đánh bằng tay không, không dùng khí giới: biểu diễn một bài quyền",
    example: "biểu diễn một bài quyền",
  },
  {
    word: "quyền",
    part_of_speech: "danh từ",
    meaning:
      "điều mà pháp luật hoặc xã hội công nhận cho được hưởng, được làm, được đòi hỏi: quyền công dân * quyền được tự do và mưu cầu hạnh phúc * quyền bình đẳng",
    example:
      "quyền công dân * quyền được tự do và mưu cầu hạnh phúc * quyền bình đẳng",
  },
  {
    word: "quyền",
    part_of_speech: "danh từ",
    meaning:
      "những điều do địa vị hay chức vụ mà được làm (nói tổng quát): có chức có quyền * quyền cao chức trọng * có quyền quyết định mọi việc trong nhà",
    example:
      "có chức có quyền * quyền cao chức trọng * có quyền quyết định mọi việc trong nhà",
  },
  {
    word: "quyền",
    part_of_speech: "động từ",
    meaning:
      "tạm giữ một chức vụ lãnh đạo nào đó trong khi người phụ trách chính thức vắng mặt hoặc chưa được chỉ định: quyền giám đốc * quyền trưởng phòng",
    example: "quyền giám đốc * quyền trưởng phòng",
  },
  {
    word: "quyện",
    part_of_speech: "động từ",
    meaning:
      "cùng với nhau làm thành một khối không thể tách rời, tựa như xoắn chặt, bện chặt vào nhau: hương cốm quyện với mùi lá sen * tiếng đàn và tiếng hát quyện vào nhau",
    example:
      "hương cốm quyện với mùi lá sen * tiếng đàn và tiếng hát quyện vào nhau",
  },
  {
    word: "quyền bính",
    part_of_speech: "danh từ",
    meaning: "(cũ) như quyền hành: nắm quyền bính trong tay",
    example: "nắm quyền bính trong tay",
  },
  {
    word: "quyền anh",
    part_of_speech: "danh từ",
    meaning:
      "môn thể thao đấu võ, có nguồn gốc từ nước Anh, dùng nắm tay có đeo găng đấm nhau: thi đấu quyền Anh",
    example: "thi đấu quyền Anh",
  },
  {
    word: "quyền biến",
    part_of_speech: "động từ",
    meaning:
      "ứng phó linh hoạt khi có biến, khi có việc bất thường: có tài quyền biến * biết quyền biến lúc lâm nguy",
    example: "có tài quyền biến * biết quyền biến lúc lâm nguy",
  },
  {
    word: "quyên",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) (chim) đỗ quyên (nói tắt): "Dưới trăng quyên đã gọi hè, Đầu tường lửa lựu lập loè đâm bông." (TKiều)',
    example:
      'Dưới trăng quyên đã gọi hè, Đầu tường lửa lựu lập loè đâm bông." (TKiều)',
  },
  {
    word: "quyên",
    part_of_speech: "động từ",
    meaning:
      "đóng góp hoặc vận động mọi người đóng góp tiền của để làm việc nghĩa, việc có ích chung: quyên tiền ủng hộ đồng bào bị bão lụt",
    example: "quyên tiền ủng hộ đồng bào bị bão lụt",
  },
  {
    word: "quyên giáo",
    part_of_speech: "động từ",
    meaning:
      "quyên góp tiền của để làm những công việc về đạo Phật: khuyên giáo để đúc tượng",
    example: "khuyên giáo để đúc tượng",
  },
  {
    word: "quyền hạn",
    part_of_speech: "danh từ",
    meaning:
      "quyền được xác định trong phạm vi cho phép: lợi dụng quyền hạn * vượt quá quyền hạn cho phép",
    example: "lợi dụng quyền hạn * vượt quá quyền hạn cho phép",
  },
  {
    word: "quyên góp",
    part_of_speech: "động từ",
    meaning:
      "quyên hoặc góp tiền của để làm việc nghĩa (nói khái quát): quyên góp tiền để ủng hộ nạn nhân chất độc màu da cam",
    example: "quyên góp tiền để ủng hộ nạn nhân chất độc màu da cam",
  },
  {
    word: "quyến gió rủ mây",
    part_of_speech: "",
    meaning:
      '(văn chương) ví việc dụ dỗ chuyện phong tình, trai gái: "Phao cho quyến gió rủ mây, Hãy xem có biết mặt này là ai?" (TKiều)',
    example:
      'Phao cho quyến gió rủ mây, Hãy xem có biết mặt này là ai?" (TKiều)',
  },
  {
    word: "quyền hành",
    part_of_speech: "danh từ",
    meaning:
      "quyền định đoạt và điều hành công việc: thâu tóm quyền hành * lợi dụng quyền hành",
    example: "thâu tóm quyền hành * lợi dụng quyền hành",
  },
  {
    word: "quyền lợi",
    part_of_speech: "danh từ",
    meaning:
      "quyền được hưởng những lợi ích nào đó về vật chất, tinh thần: bảo vệ quyền lợi của trẻ em * mâu thuẫn về quyền lợi",
    example: "bảo vệ quyền lợi của trẻ em * mâu thuẫn về quyền lợi",
  },
  {
    word: "quyến luyến",
    part_of_speech: "động từ",
    meaning:
      "biểu thị tình cảm gắn bó, không muốn rời xa: quyến luyến vợ con * chia tay quyến luyến",
    example: "quyến luyến vợ con * chia tay quyến luyến",
  },
  {
    word: "quyền năng",
    part_of_speech: "danh từ",
    meaning:
      "khả năng định đoạt, chi phối những cái khác: Thiên Chúa đầy quyền năng * quyền năng của con người",
    example: "Thiên Chúa đầy quyền năng * quyền năng của con người",
  },
  {
    word: "quyền môn",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) chỗ, nhà có quyền thế: "Miễn là được chốn quyền môn, Gặp dâu phú quý cho con nương nhờ." (PCCH)',
    example:
      'Miễn là được chốn quyền môn, Gặp dâu phú quý cho con nương nhờ." (PCCH)',
  },
  {
    word: "quyền quý",
    part_of_speech: "tính từ",
    meaning:
      "có quyền thế và sang trọng: con nhà quyền quý * ham nơi quyền quý",
    example: "con nhà quyền quý * ham nơi quyền quý",
  },
  {
    word: "quyền lực",
    part_of_speech: "danh từ",
    meaning:
      "quyền định đoạt mọi công việc quan trọng về mặt chính trị và sức mạnh để bảo đảm việc thực hiện quyền ấy (nói khái quát): có quyền lực tối cao * thâu tóm quyền lực",
    example: "có quyền lực tối cao * thâu tóm quyền lực",
  },
  {
    word: "quyền tác giả",
    part_of_speech: "danh từ",
    meaning:
      "quyền của tổ chức, cá nhân đối với tác phẩm do mình sáng tạo ra hoặc sở hữu: vi phạm quyền tác giả",
    example: "vi phạm quyền tác giả",
  },
  {
    word: "quyến rũ",
    part_of_speech: "động từ",
    meaning:
      "làm cho người ta mê mẩn mà theo: bị sắc đẹp quyến rũ * giọng hát quyến rũ người nghe",
    example: "bị sắc đẹp quyến rũ * giọng hát quyến rũ người nghe",
  },
  {
    word: "quyền sở hữu",
    part_of_speech: "danh từ",
    meaning:
      "quyền chiếm hữu và sử dụng tài sản theo quy định của pháp luật: bảo vệ quyền sở hữu của công dân",
    example: "bảo vệ quyền sở hữu của công dân",
  },
  {
    word: "quyên sinh",
    part_of_speech: "động từ",
    meaning:
      '(cũ, văn chương) từ bỏ, liều bỏ mạng sống của mình: "Giận duyên, tủi phận, bời bời, Cầm dao, nàng đã toan bài quyên sinh." (TKiều)',
    example:
      'Giận duyên, tủi phận, bời bời, Cầm dao, nàng đã toan bài quyên sinh." (TKiều)',
  },
  {
    word: "quyền thế",
    part_of_speech: "danh từ",
    meaning:
      "quyền hành và thế lực (nói khái quát): xu phụ kẻ quyền thế * cậy có quyền thế",
    example: "xu phụ kẻ quyền thế * cậy có quyền thế",
  },
  {
    word: "quyền uy",
    part_of_speech: "",
    meaning: "như uy quyền: ham quyền uy * một con người giàu có, quyền uy",
    example: "ham quyền uy * một con người giàu có, quyền uy",
  },
  {
    word: "quyết định",
    part_of_speech: "động từ",
    meaning:
      "có ý kiến dứt khoát về việc làm cụ thể nào đó, chọn một trong các khả năng, sau khi đã có sự cân nhắc: quyết định xin chuyển công tác về gần nhà * tự quyết định mọi việc trong nhà",
    example:
      "quyết định xin chuyển công tác về gần nhà * tự quyết định mọi việc trong nhà",
  },
  {
    word: "quyết định",
    part_of_speech: "động từ",
    meaning:
      "là nguyên nhân trực tiếp của những diễn biến ở sự vật, hiện tượng nào đó: thời tiết là một trong những yếu tố quyết định năng suất cây trồng",
    example:
      "thời tiết là một trong những yếu tố quyết định năng suất cây trồng",
  },
  {
    word: "quyết định",
    part_of_speech: "tính từ",
    meaning:
      "quan trọng nhất, có ý nghĩa quyết định đối với tất cả những gì sẽ xảy ra sau đó: giờ phút quyết định * một lựa chọn có ý nghĩa quyết định",
    example: "giờ phút quyết định * một lựa chọn có ý nghĩa quyết định",
  },
  {
    word: "quyết định",
    part_of_speech: "danh từ",
    meaning: "điều đã được quyết định: một quyết định sai lầm",
    example: "một quyết định sai lầm",
  },
  {
    word: "quyết định",
    part_of_speech: "danh từ",
    meaning:
      "văn bản hành chính về quyết định của một cấp có thẩm quyền: kí quyết định đình chỉ công tác * ra quyết định thu hồi đất",
    example: "kí quyết định đình chỉ công tác * ra quyết định thu hồi đất",
  },
  {
    word: "quyết chí",
    part_of_speech: "động từ",
    meaning:
      'có ý chí và quyết làm bằng được: quyết chí học hành * "Làm trai quyết chí lập thân, Rồi ra gặp hội phong vân kịp người." (ca dao)',
    example:
      'quyết chí học hành * "Làm trai quyết chí lập thân, Rồi ra gặp hội phong vân kịp người." (ca dao)',
  },
  {
    word: "quyết đấu",
    part_of_speech: "động từ",
    meaning: "giao đấu quyết giành phần thắng: trận quyết đấu",
    example: "trận quyết đấu",
  },
  {
    word: "quyết",
    part_of_speech: "động từ",
    meaning:
      'định dứt khoát làm việc gì, sau khi đã cân nhắc: còn phân vân nên chưa dám quyết * "Đã gần chi có điều xa, Đá vàng đã quyết, phong ba cũng liều." (TKiều)',
    example:
      'còn phân vân nên chưa dám quyết * "Đã gần chi có điều xa, Đá vàng đã quyết, phong ba cũng liều." (TKiều)',
  },
  {
    word: "quyết",
    part_of_speech: "động từ",
    meaning:
      "nhất định thực hiện bằng được điều đã định, bất kể khó khăn, trở lực: quyết không lùi bước * quyết làm cho bằng được",
    example: "quyết không lùi bước * quyết làm cho bằng được",
  },
  {
    word: "quyết",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) khẳng định dứt khoát (về việc gì): tôi quyết với anh là chúng ta sẽ thắng",
    example: "tôi quyết với anh là chúng ta sẽ thắng",
  },
  {
    word: "quyết",
    part_of_speech: "trợ từ",
    meaning:
      "(khẩu ngữ) từ dùng để nhấn mạnh thêm ý phủ định dứt khoát: việc này quyết không để xảy ra sai sót",
    example: "việc này quyết không để xảy ra sai sót",
  },
  {
    word: "quyết chiến",
    part_of_speech: "động từ",
    meaning:
      "kiên quyết chiến đấu đến cùng: tinh thần quyết chiến, quyết thắng",
    example: "tinh thần quyết chiến, quyết thắng",
  },
  {
    word: "quyết chiến",
    part_of_speech: "động từ",
    meaning:
      "tác chiến nhằm giành thắng lợi có ý nghĩa quyết định: trận quyết chiến giữa ta và địch * địa bàn quyết chiến",
    example: "trận quyết chiến giữa ta và địch * địa bàn quyết chiến",
  },
  {
    word: "quyết đoán",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) phán đoán một cách quả quyết: quyết đoán rằng mọi việc sẽ tốt đẹp",
    example: "quyết đoán rằng mọi việc sẽ tốt đẹp",
  },
  {
    word: "quyết đoán",
    part_of_speech: "tính từ",
    meaning:
      "có những quyết định nhanh chóng và dứt khoát, không do dự, e dè: tính quyết đoán * quyết đoán mọi vấn đề",
    example: "tính quyết đoán * quyết đoán mọi vấn đề",
  },
  {
    word: "quyến thuộc",
    part_of_speech: "danh từ",
    meaning: "(cũ) họ hàng thân thuộc: anh em quyến thuộc",
    example: "anh em quyến thuộc",
  },
  {
    word: "quyết liệt",
    part_of_speech: "tính từ",
    meaning:
      "hết sức mạnh mẽ, tỏ ra kiên quyết, không khoan nhượng trong đấu tranh: chống trả một cách quyết liệt * phản công quyết liệt",
    example: "chống trả một cách quyết liệt * phản công quyết liệt",
  },
  {
    word: "quyết sách",
    part_of_speech: "danh từ",
    meaning:
      "chính sách, biện pháp mang tính chất quyết định: kịp thời đưa ra những quyết sách đúng đắn * chọn quyết sách phù hợp",
    example:
      "kịp thời đưa ra những quyết sách đúng đắn * chọn quyết sách phù hợp",
  },
  {
    word: "quyết tâm",
    part_of_speech: "",
    meaning:
      "quyết và cố gắng thực hiện bằng được điều đã định, tuy biết là có nhiều khó khăn, trở ngại: quyết tâm học thật giỏi * quyết tâm chờ đợi * có quyết tâm",
    example: "quyết tâm học thật giỏi * quyết tâm chờ đợi * có quyết tâm",
  },
  {
    word: "quỳnh",
    part_of_speech: "danh từ",
    meaning:
      "cây thuộc họ xương rồng, thân hình phiến dẹt trông giống như lá, hoa to, màu trắng, nở về đêm, thường trồng làm cảnh: hoa quỳnh",
    example: "hoa quỳnh",
  },
  {
    word: "quyết tử",
    part_of_speech: "động từ",
    meaning:
      "sẵn sàng hi sinh tính mạng của mình vì sự nghiệp cao cả: quyết tử cho tổ quốc quyết sinh",
    example: "quyết tử cho tổ quốc quyết sinh",
  },
  {
    word: "quyết nghị",
    part_of_speech: "động từ",
    meaning:
      "(tập thể) quyết định sau khi đã bàn bạc, thảo luận (một vấn đề thường là quan trọng): nhất trí quyết nghị * bàn bạc kĩ mới đi đến quyết nghị",
    example: "nhất trí quyết nghị * bàn bạc kĩ mới đi đến quyết nghị",
  },
  {
    word: "quyết nghị",
    part_of_speech: "danh từ",
    meaning: "(Ít dùng) như nghị quyết: ra quyết nghị",
    example: "ra quyết nghị",
  },
  {
    word: "quyết thắng",
    part_of_speech: "động từ",
    meaning:
      "quyết giành thắng lợi trong chiến đấu: tinh thần quyết chiến, quyết thắng * lá cờ quyết thắng",
    example: "tinh thần quyết chiến, quyết thắng * lá cờ quyết thắng",
  },
  {
    word: "quyết sinh",
    part_of_speech: "động từ",
    meaning:
      "nhất định phải sống, phải tồn tại: quyết tử cho Tổ quốc quyết sinh",
    example: "quyết tử cho Tổ quốc quyết sinh",
  },
  {
    word: "quyết toán",
    part_of_speech: "động từ",
    meaning:
      "tổng kết trên cơ sở tổng hợp các khoản thu chi để làm rõ tình hình sử dụng vốn của một công ti, một cơ quan, xí nghiệp hay cho một công trình, dự án nào đó: làm quyết toán cuối năm",
    example: "làm quyết toán cuối năm",
  },
  {
    word: "quýnh",
    part_of_speech: "động từ",
    meaning:
      "có những động tác, cử chỉ vội vàng và lúng túng, do có sự tác động mạnh và đột ngột: quýnh quá, không mở được cửa * hồi hộp quá đâm quýnh",
    example: "quýnh quá, không mở được cửa * hồi hộp quá đâm quýnh",
  },
  {
    word: "quýnh",
    part_of_speech: "tính từ",
    meaning:
      "rối lên, tỏ ra không tự chủ được, do có sự tác động của một tình cảm mạnh và đột ngột: mừng quýnh * sợ quýnh",
    example: "mừng quýnh * sợ quýnh",
  },
  {
    word: "quỷnh",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) ngốc, ngốc nghếch: đồ quỷnh!",
    example: "đồ quỷnh!",
  },
  {
    word: "quỳnh tương",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) rượu ngon: "Dây tơ hồng chưa xe đã mắc, Rượu quỳnh tương chưa nhắp đã say." (ca dao)',
    example:
      'Dây tơ hồng chưa xe đã mắc, Rượu quỳnh tương chưa nhắp đã say." (ca dao)',
  },
  {
    word: "quýnh quáng",
    part_of_speech: "tính từ",
    meaning:
      "rối hết cả lên, lúng túng, không còn làm chủ được động tác, cử chỉ của mình: sợ quá, chạy quýnh quáng đâm cả vào cột nhà",
    example: "sợ quá, chạy quýnh quáng đâm cả vào cột nhà",
  },
  {
    word: "ra",
    part_of_speech: "động từ",
    meaning:
      "di chuyển đến một nơi, một vị trí ở phía ngoài: ra khơi * ra trận * từ trong nhà ra sân * cả đời không ra khỏi luỹ tre làng",
    example:
      "ra khơi * ra trận * từ trong nhà ra sân * cả đời không ra khỏi luỹ tre làng",
  },
  {
    word: "ra",
    part_of_speech: "động từ",
    meaning:
      "tách khỏi, không còn sinh hoạt, hoạt động, v.v. ở trong một môi trường, tổ chức nào đó nữa: ra viện * làm đơn xin ra khỏi hợp tác xã",
    example: "ra viện * làm đơn xin ra khỏi hợp tác xã",
  },
  {
    word: "ra",
    part_of_speech: "động từ",
    meaning: "(cây cối) nảy sinh bộ phận nào đó: cây ra lộc * mùa bưởi ra hoa",
    example: "cây ra lộc * mùa bưởi ra hoa",
  },
  {
    word: "ra",
    part_of_speech: "động từ",
    meaning:
      "nói cho người khác biết, thường là với yêu cầu phải chấp hành, phải thực hiện: ra đề bài * ra lệnh * ra điều kiện cho đối phương",
    example: "ra đề bài * ra lệnh * ra điều kiện cho đối phương",
  },
  {
    word: "ra",
    part_of_speech: "động từ",
    meaning:
      "thành, trở nên, hoá thành: nấu ăn chẳng ra gì * dây cà ra dây muống (tng)",
    example: "nấu ăn chẳng ra gì * dây cà ra dây muống (tng)",
  },
  {
    word: "ra",
    part_of_speech: "động từ",
    meaning:
      "biểu hiện cho thấy thật đúng với tính chất, ý nghĩa: sống cho ra sống * chơi ra chơi, học ra học",
    example: "sống cho ra sống * chơi ra chơi, học ra học",
  },
  {
    word: "ra",
    part_of_speech: "động từ",
    meaning:
      "qua khỏi một thời gian nào đó, bước sang một đơn vị thời gian mới: ra giêng * ra Tết",
    example: "ra giêng * ra Tết",
  },
  {
    word: "ra",
    part_of_speech: "động từ",
    meaning:
      "từ biểu thị hướng của hoạt động từ trong đến ngoài, từ hẹp đến rộng, từ không đến có, chỗ hạn chế đến chỗ thuận lợi: bước ra sân * nói ra sự thật * đứng ra chịu trách nhiệm * như thế cho nó sáng mắt ra!",
    example:
      "bước ra sân * nói ra sự thật * đứng ra chịu trách nhiệm * như thế cho nó sáng mắt ra!",
  },
  {
    word: "ra",
    part_of_speech: "động từ",
    meaning:
      "từ biểu thị quá trình hoạt động đạt được kết quả như mong muốn: tìm ra kết quả * nhận ra lỗi của mình * có vẻ đã hiểu ra",
    example: "tìm ra kết quả * nhận ra lỗi của mình * có vẻ đã hiểu ra",
  },
  {
    word: "ra",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị xu hướng phát triển tăng thêm của một tính chất, trạng thái: thấy trong người khoẻ ra * càng ngày càng đẹp ra * giặt xong, cái áo trắng hẳn ra",
    example:
      "thấy trong người khoẻ ra * càng ngày càng đẹp ra * giặt xong, cái áo trắng hẳn ra",
  },
  {
    word: "ra",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị một điều kiện giả thiết hay một sự đánh giá mà nội dung do từ (thường là tính từ) đứng ngay trước nó biểu đạt: bét ra cũng phải được 7 điểm * đúng ra thì con bé chưa đủ tuổi vào lớp 1",
    example:
      "bét ra cũng phải được 7 điểm * đúng ra thì con bé chưa đủ tuổi vào lớp 1",
  },
  {
    word: "ra",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị sự đột nhiên nhận thấy, đột nhiên nhận thức điều trước đó không ngờ tới: ra vậy! * hoá ra là thế! * ra tôi với anh cũng có họ hàng",
    example: "ra vậy! * hoá ra là thế! * ra tôi với anh cũng có họ hàng",
  },
  {
    word: "quỵt",
    part_of_speech: "động từ",
    meaning:
      "cố tình không chịu trả, không chịu thanh toán cái mình đang nợ của ai đó: vay xong rồi quỵt * quỵt nợ",
    example: "vay xong rồi quỵt * quỵt nợ",
  },
  {
    word: "rà",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) di chuyển theo sát, thường với mục đích thăm dò, tìm kiếm: chiếc trực thăng rà khắp vùng rừng",
    example: "chiếc trực thăng rà khắp vùng rừng",
  },
  {
    word: "rà",
    part_of_speech: "động từ",
    meaning:
      "(tay, mắt, v.v.) đưa từ từ theo khắp bề mặt cái gì, thường để tìm kiếm: rà tên trong danh sách * xe rà mìn",
    example: "rà tên trong danh sách * xe rà mìn",
  },
  {
    word: "rà",
    part_of_speech: "động từ",
    meaning:
      "xem lại từng chi tiết xem có gì sai sót không: rà sổ sách * rà lại các khoản thu chi * rà lại từ đầu xem sai ở đâu",
    example:
      "rà sổ sách * rà lại các khoản thu chi * rà lại từ đầu xem sai ở đâu",
  },
  {
    word: "quỵp",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) cụp: chó quỵp đuôi chạy mất",
    example: "chó quỵp đuôi chạy mất",
  },
  {
    word: "ra bộ",
    part_of_speech: "",
    meaning: "(khẩu ngữ) làm ra vẻ như là: ra bộ người lớn * làm ra bộ hớn hở",
    example: "ra bộ người lớn * làm ra bộ hớn hở",
  },
  {
    word: "rạ",
    part_of_speech: "danh từ",
    meaning:
      'phần còn lại của cây lúa sau khi gặt: gốc rạ * "Em về cắt rạ đánh tranh, Chặt tre chẻ lạt cho anh lợp nhà." (ca dao)',
    example:
      'gốc rạ * "Em về cắt rạ đánh tranh, Chặt tre chẻ lạt cho anh lợp nhà." (ca dao)',
  },
  {
    word: "rạ",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) thuỷ đậu: em bé bị lên rạ",
    example: "em bé bị lên rạ",
  },
  {
    word: "rã",
    part_of_speech: "động từ",
    meaning:
      "rời nhau ra, không còn kết dính với nhau thành khối như ban đầu: hoa rã cánh * mệt rã cả người (b)",
    example: "hoa rã cánh * mệt rã cả người (b)",
  },
  {
    word: "rã",
    part_of_speech: "động từ",
    meaning:
      "phân tán ra, không còn tổ chức, không còn có quan hệ với nhau nữa: rã hội * du kích đã phá rã lính giặc",
    example: "rã hội * du kích đã phá rã lính giặc",
  },
  {
    word: "bộ chỉ huy",
    part_of_speech: "danh từ",
    meaning:
      "cơ quan chỉ huy quân sự cấp binh đoàn hoặc tương đương: bộ chỉ huy quân sự * bộ chỉ huy mặt trận",
    example: "bộ chỉ huy quân sự * bộ chỉ huy mặt trận",
  },
  {
    word: "bộ chính trị",
    part_of_speech: "danh từ",
    meaning:
      "cơ quan lãnh đạo cao nhất của một số chính đảng, do ban chấp hành trung ương cử ra: uỷ viên bộ chính trị",
    example: "uỷ viên bộ chính trị",
  },
  {
    word: "bố cục",
    part_of_speech: "động từ",
    meaning:
      "tổ chức, sắp xếp các phần để tạo thành một tác phẩm hoàn chỉnh: cách bố cục câu chuyện rất hợp lí",
    example: "cách bố cục câu chuyện rất hợp lí",
  },
  {
    word: "bố cục",
    part_of_speech: "danh từ",
    meaning:
      "sự sắp xếp, bố trí các yếu tố, các thành phần trong một chỉnh thể: thay đổi bố cục của cuốn sách",
    example: "thay đổi bố cục của cuốn sách",
  },
  {
    word: "bố cu mẹ đĩ",
    part_of_speech: "",
    meaning:
      '(cũ, khẩu ngữ) tổ hợp từ dùng ở nông thôn thời trước để chỉ những người thường dân không có chức sắc, danh vọng gì: hạng bố cu mẹ đĩ * "Nó chỉ là con nhà bố cu mẹ đĩ thôi mà cũng không đến nỗi khốn nạn đến thế bao giờ." (VTrPhụng; 3)',
    example:
      'hạng bố cu mẹ đĩ * "Nó chỉ là con nhà bố cu mẹ đĩ thôi mà cũng không đến nỗi khốn nạn đến thế bao giờ." (VTrPhụng; 3)',
  },
  {
    word: "bổ chửng",
    part_of_speech: "động từ",
    meaning:
      "(ngã) ngửa người ra vì bất ngờ bị trượt: ngã bổ chửng * trượt chân bổ chửng giữa nhà",
    example: "ngã bổ chửng * trượt chân bổ chửng giữa nhà",
  },
  {
    word: "bộ duyệt",
    part_of_speech: "danh từ",
    meaning:
      "chương trình máy tính cho phép xem được các thông tin, hình ảnh, v.v. trình bày trên trang web: trình duyệt web",
    example: "trình duyệt web",
  },
  {
    word: "bộ duyệt",
    part_of_speech: "động từ",
    meaning:
      "trình lên cho cấp có thẩm quyền xem xét để phê duyệt: trình duyệt dự án đầu tư",
    example: "trình duyệt dự án đầu tư",
  },
  {
    word: "bộ dàn",
    part_of_speech: "danh từ",
    meaning:
      "các thiết bị âm thanh điện tử như đầu phát audio hoặc video, ampli, loa, v.v., được kết hợp với nhau thành một hệ thống, tạo ra sự tiện dụng và làm tăng chất lượng âm thanh: bộ dàn karaoke",
    example: "bộ dàn karaoke",
  },
  {
    word: "bổ dụng",
    part_of_speech: "động từ",
    meaning:
      "(cũ) cử giữ một chức vụ (thường không vào loại quan trọng) trong bộ máy nhà nước: mới tốt nghiệp còn chờ bổ dụng * được bổ dụng làm thông ngôn",
    example: "mới tốt nghiệp còn chờ bổ dụng * được bổ dụng làm thông ngôn",
  },
  {
    word: "bộ dạng",
    part_of_speech: "danh từ",
    meaning:
      "dáng vẻ, cử chỉ thể hiện ra bên ngoài (nói tổng quát): bộ dạng tiều tuỵ * bộ dạng xun xoe, bợ đỡ",
    example: "bộ dạng tiều tuỵ * bộ dạng xun xoe, bợ đỡ",
  },
  {
    word: "bổ dưỡng",
    part_of_speech: "động từ",
    meaning:
      "giữ gìn, phục hồi hoặc làm tăng sức khoẻ bằng thuốc men: bổ dưỡng bằng sâm nhung",
    example: "bổ dưỡng bằng sâm nhung",
  },
  {
    word: "bồ đào",
    part_of_speech: "danh từ",
    meaning: "(cũ) (cây, quả) nho: trái bồ đào * rượu bồ đào",
    example: "trái bồ đào * rượu bồ đào",
  },
  {
    word: "bô đê",
    part_of_speech: "động từ",
    meaning:
      "làm cho mép vải trở thành có những đường cong đều có tính chất trang trí: bô đê cổ áo * gấu quần xa tanh có viền bô đê",
    example: "bô đê cổ áo * gấu quần xa tanh có viền bô đê",
  },
  {
    word: "bộ đồ",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ, hoặc kng) bộ quần áo: mặc bộ đồ mới * bộ đồ bà ba",
    example: "mặc bộ đồ mới * bộ đồ bà ba",
  },
  {
    word: "bộ điệu",
    part_of_speech: "danh từ",
    meaning:
      'dáng, vẻ lộ ra qua cử chỉ, nét mặt, cách đi đứng (nhìn một cách tổng quát): bộ điệu tự nhiên * "Nàng thờ ơ đáp lại bằng bộ điệu bình thản, không vồn vã, không vui thích." (ĐĐThu; 2)',
    example:
      'bộ điệu tự nhiên * "Nàng thờ ơ đáp lại bằng bộ điệu bình thản, không vồn vã, không vui thích." (ĐĐThu; 2)',
  },
  {
    word: "bộ đội",
    part_of_speech: "danh từ",
    meaning: "người trong quân đội (Việt Nam): đi bộ đội * vào bộ đội",
    example: "đi bộ đội * vào bộ đội",
  },
  {
    word: "bộ đội",
    part_of_speech: "danh từ",
    meaning:
      "từ gọi chung bộ phận, thành phần của quân đội: bộ đội lục quân * bộ đội địa phương",
    example: "bộ đội lục quân * bộ đội địa phương",
  },
  {
    word: "bộ gõ",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp các nhạc cụ phát ra âm thanh nhờ động tác gõ, đánh lên bề mặt: trống là nhạc cụ chính trong bộ gõ",
    example: "trống là nhạc cụ chính trong bộ gõ",
  },
  {
    word: "bộ hành",
    part_of_speech: "động từ",
    meaning:
      '(cũ) đi bộ: "Gần xa nô nức yến anh, Chị em sắm sửa bộ hành chơi xuân." (TKiều)',
    example:
      'Gần xa nô nức yến anh, Chị em sắm sửa bộ hành chơi xuân." (TKiều)',
  },
  {
    word: "bộ hành",
    part_of_speech: "danh từ",
    meaning:
      'người đi bộ, người đi bằng đường bộ: "Cây đa cũ bến đò xưa, Bộ hành có nghĩa, nắng mưa cũng chờ." (ca dao)',
    example:
      'Cây đa cũ bến đò xưa, Bộ hành có nghĩa, nắng mưa cũng chờ." (ca dao)',
  },
  {
    word: "bộ hạ",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người trực tiếp dưới quyền, giúp việc cho một người có thế lực: bộ hạ thân tín * dung túng cho bọn bộ hạ làm càn",
    example: "bộ hạ thân tín * dung túng cho bọn bộ hạ làm càn",
  },
  {
    word: "bồ hóng",
    part_of_speech: "danh từ",
    meaning:
      "bụi mịn đen do khói đóng lại lâu ngày thành mảng, thành lớp trên nóc bếp, vách bếp: tường bếp bám đầy bồ hóng",
    example: "tường bếp bám đầy bồ hóng",
  },
  {
    word: "bổ khuyết",
    part_of_speech: "động từ",
    meaning: "thêm vào cho nội dung được đầy đủ: góp ý kiến bổ khuyết",
    example: "góp ý kiến bổ khuyết",
  },
  {
    word: "bổ ích",
    part_of_speech: "tính từ",
    meaning:
      "có ích, có tác dụng tốt: rút ra bài học bổ ích * câu chuyện bổ ích",
    example: "rút ra bài học bổ ích * câu chuyện bổ ích",
  },
  {
    word: "bồ kết",
    part_of_speech: "danh từ",
    meaning:
      "cây to, thân và cành có gai dài, quả dẹp, thường dùng để nấu nước gội đầu hoặc làm thuốc chữa bệnh: gội đầu bằng nước bồ kết",
    example: "gội đầu bằng nước bồ kết",
  },
  {
    word: "bộ khuếch đại",
    part_of_speech: "danh từ",
    meaning:
      "khí cụ làm tăng trị số của một đại lượng nào đó nhờ năng lượng của nguồn ngoài: bộ khuếch đại âm thanh",
    example: "bộ khuếch đại âm thanh",
  },
  {
    word: "bộ lạc",
    part_of_speech: "danh từ",
    meaning:
      "hình thái tộc người ở thời đại nguyên thuỷ, bao gồm một số thị tộc thân thuộc có chung một tên gọi, có chung tài sản và ngôn ngữ, sống cạnh nhau trên một vùng đất đai thuận lợi: các bộ lạc da đỏ",
    example: "các bộ lạc da đỏ",
  },
  {
    word: "bô lão",
    part_of_speech: "danh từ",
    meaning:
      "người già cả, người cao tuổi (nói khái quát; hàm ý coi trọng): các bô lão trong làng",
    example: "các bô lão trong làng",
  },
  {
    word: "bố láo",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) vô lễ, hỗn xược: thái độ bố láo * đừng có bố láo! * ăn nói bố láo",
    example: "thái độ bố láo * đừng có bố láo! * ăn nói bố láo",
  },
  {
    word: "bố láo",
    part_of_speech: "tính từ",
    meaning: "bậy bạ, không đứng đắn: toàn chuyện bố láo * làm ăn bố láo",
    example: "toàn chuyện bố láo * làm ăn bố láo",
  },
  {
    word: "bồ liễu",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) loài cây rụng lá sớm nhất về mùa đông, dễ mọc, nhưng dễ tàn; dùng trong văn học cổ để ví người phụ nữ có thể chất yếu đuối: "Thương nàng mười tám xuân xanh, Tấm thân bồ liễu một cành bơ vơ." (ca dao)',
    example:
      'Thương nàng mười tám xuân xanh, Tấm thân bồ liễu một cành bơ vơ." (ca dao)',
  },
  {
    word: "bộ máy",
    part_of_speech: "danh từ",
    meaning:
      "hệ thống các cơ quan hoặc bộ phận bảo đảm thực hiện những nhiệm vụ chung của một tổ chức: bộ máy hành chính * bộ máy quản lí kinh tế",
    example: "bộ máy hành chính * bộ máy quản lí kinh tế",
  },
  {
    word: "bộ máy",
    part_of_speech: "danh từ",
    meaning:
      "hệ thống các cơ quan hoặc bộ phận bảo đảm thực hiện một chức năng chung trong cơ thể: bộ máy tiêu hoá * bộ máy hô hấp",
    example: "bộ máy tiêu hoá * bộ máy hô hấp",
  },
  {
    word: "bô lô ba la",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) hay nói và nói nhiều một cách vô ý thức: thằng bé cứ bô lô ba la cả ngày",
    example: "thằng bé cứ bô lô ba la cả ngày",
  },
  {
    word: "bộ luật",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp các luật định theo một hệ thống, thống nhất trong một văn bản pháp luật của một ngành luật và được cơ quan quyền lực nhà nước cao nhất thông qua: ban hành bộ luật mới * bộ luật dân sự * bộ luật hình sự",
    example: "ban hành bộ luật mới * bộ luật dân sự * bộ luật hình sự",
  },
  {
    word: "bộ mặt",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ nói chung những vẻ, những nét nhìn thấy trên mặt: bộ mặt tươi tỉnh * bóc trần bộ mặt giả dối",
    example: "bộ mặt tươi tỉnh * bóc trần bộ mặt giả dối",
  },
  {
    word: "bộ mặt",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ nói chung những cái bộc lộ ra bên ngoài, qua đó ít nhiều phản ánh được thực chất bên trong: bộ mặt nông thôn có nhiều đổi mới",
    example: "bộ mặt nông thôn có nhiều đổi mới",
  },
  {
    word: "bộ môn",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận hợp thành của một ngành, một lĩnh vực khoa học, kĩ thuật, nghệ thuật: các bộ môn nghệ thuật * bộ môn toán * giảng viên bộ môn",
    example: "các bộ môn nghệ thuật * bộ môn toán * giảng viên bộ môn",
  },
  {
    word: "bổ ngữ",
    part_of_speech: "danh từ",
    meaning:
      "thành phần cú pháp bổ nghĩa cho động từ, tính từ:  trong  *  là bổ ngữ",
    example: "trong  *  là bổ ngữ",
  },
  {
    word: "bổ nháo bổ nhào",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) như bổ nháo (nhưng nghĩa mạnh hơn): bổ nháo bổ nhào đi tìm * chạy bổ nháo bổ nhào",
    example: "bổ nháo bổ nhào đi tìm * chạy bổ nháo bổ nhào",
  },
  {
    word: "bổ nháo",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) lao mình chạy vội theo hướng này, hướng khác: mọi người hốt hoảng, bổ nháo đi tìm",
    example: "mọi người hốt hoảng, bổ nháo đi tìm",
  },
  {
    word: "bồ nhí",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) nhân tình còn rất trẻ tuổi (của một người đã đứng tuổi; hàm ý châm biếm): bồ nhí của giám đốc",
    example: "bồ nhí của giám đốc",
  },
  {
    word: "bổ nhào",
    part_of_speech: "động từ",
    meaning: "lao đầu nhào xuống: máy bay bổ nhào",
    example: "máy bay bổ nhào",
  },
  {
    word: "bổ nhào",
    part_of_speech: "động từ",
    meaning: "lao mình chạy vội đi: cả nhà bổ nhào đi tìm",
    example: "cả nhà bổ nhào đi tìm",
  },
  {
    word: "bổ nhiệm",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) (người, đơn vị có thẩm quyền) cử ai đó giữ một chức vụ trong bộ máy lãnh đạo hoặc quản lí: được bổ nhiệm làm giám đốc",
    example: "được bổ nhiệm làm giám đốc",
  },
  {
    word: "bộ nhớ",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận lưu trữ dữ liệu trong máy tính, để cung cấp khi cần sử dụng, xử lí: lưu dữ liệu vào bộ nhớ * máy tính hết bộ nhớ",
    example: "lưu dữ liệu vào bộ nhớ * máy tính hết bộ nhớ",
  },
  {
    word: "bộ óc",
    part_of_speech: "danh từ",
    meaning:
      "óc của con người, coi là biểu tượng của những khả năng trí tuệ, của sự thông minh: bộ óc nhạy bén",
    example: "bộ óc nhạy bén",
  },
  {
    word: "bồ ruột",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) người bạn hoặc người tình gắn bó nhất, thân thiết nhất: nhỏ bạn là bồ ruột của em từ hồi vỡ lòng",
    example: "nhỏ bạn là bồ ruột của em từ hồi vỡ lòng",
  },
  {
    word: "bộ phận",
    part_of_speech: "danh từ",
    meaning:
      "phần làm nên một chỉnh thể: các bộ phận của cơ thể * tháo rời từng bộ phận của máy * các bộ phận cấu thành của nền kinh tế",
    example:
      "các bộ phận của cơ thể * tháo rời từng bộ phận của máy * các bộ phận cấu thành của nền kinh tế",
  },
  {
    word: "bố phòng",
    part_of_speech: "động từ",
    meaning: "bố trí binh lực để phòng thủ: bố phòng cẩn mật",
    example: "bố phòng cẩn mật",
  },
  {
    word: "bổ sung",
    part_of_speech: "động từ",
    meaning: "thêm vào cho đủ: bổ sung nguồn vốn * sửa đổi, bổ sung điều lệ",
    example: "bổ sung nguồn vốn * sửa đổi, bổ sung điều lệ",
  },
  {
    word: "bồ sứt cạp",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) ví thân người to lớn sồ sề quá mức (thường nói về phụ nữ): to như bồ sứt cạp",
    example: "to như bồ sứt cạp",
  },
  {
    word: "bổ sấp bổ ngửa",
    part_of_speech: "",
    meaning: "(khẩu ngữ) như bổ nháo bổ nhào: chạy bổ sấp bổ ngửa",
    example: "chạy bổ sấp bổ ngửa",
  },
  {
    word: "bộ sậu",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) toàn bộ những người, những bộ phận làm thành một bộ máy tổ chức nào đó: bộ sậu lãnh đạo của công ti",
    example: "bộ sậu lãnh đạo của công ti",
  },
  {
    word: "bồ tạt",
    part_of_speech: "danh từ",
    meaning:
      "bột trắng có tính kiềm, dễ tan trong nước, dùng để tẩy giặt, chế xà phòng.",
    example: "phân bồ tạt",
  },
  {
    word: "bố thắng",
    part_of_speech: "danh từ",
    meaning:
      "vật có thể điều khiển cho áp sát vào một bộ phận của vật đang chuyển động để làm ngừng hoặc làm chậm lại: má phanh xe đạp * má phanh đã bị mòn",
    example: "má phanh xe đạp * má phanh đã bị mòn",
  },
  {
    word: "bố thí",
    part_of_speech: "động từ",
    meaning:
      'cho để làm ơn, làm phúc: của bố thí * "Vợ thì gánh nước liền tay, Để đem bố thí người nay lỡ đường." (TS)',
    example:
      'của bố thí * "Vợ thì gánh nước liền tay, Để đem bố thí người nay lỡ đường." (TS)',
  },
  {
    word: "bộ tịch",
    part_of_speech: "danh từ",
    meaning: "bộ điệu (thường hàm ý chê): bộ tịch phách lối",
    example: "bộ tịch phách lối",
  },
  {
    word: "bộ tộc",
    part_of_speech: "danh từ",
    meaning:
      "hình thái cộng đồng tộc người hình thành trong giai đoạn cuối của chế độ bộ lạc nguyên thuỷ, được phát triển trong thời chiếm hữu nô lệ và phong kiến sơ kì, có vùng cư trú, trạng thái kinh tế, văn hoá và tên gọi riêng: bộ tộc da đỏ ở châu Mĩ",
    example: "bộ tộc da đỏ ở châu Mĩ",
  },
  {
    word: "bố trí",
    part_of_speech: "động từ",
    meaning:
      "sắp xếp theo một trật tự và đáp ứng một nhu cầu nhất định: bố trí công việc * sắp xếp, bố trí chỗ ăn ở cho khách",
    example: "bố trí công việc * sắp xếp, bố trí chỗ ăn ở cho khách",
  },
  {
    word: "bổ trụ",
    part_of_speech: "động từ",
    meaning:
      "xây trụ nhô ra khỏi mặt tường để giữ cho tường vững chắc hơn: tường nhà xây có bổ trụ",
    example: "tường nhà xây có bổ trụ",
  },
  {
    word: "bổ trợ",
    part_of_speech: "động từ",
    meaning:
      "giúp thêm, phụ thêm vào cho đủ, cho tốt hơn: ăn thêm nhiều chất bổ trợ * sách tham khảo bổ trợ cho sách giáo khoa",
    example:
      "ăn thêm nhiều chất bổ trợ * sách tham khảo bổ trợ cho sách giáo khoa",
  },
  {
    word: "bộ trưởng",
    part_of_speech: "danh từ",
    meaning:
      "người đứng đầu lãnh đạo một bộ trong chính phủ: bộ trưởng bộ ngoại giao * ngài bộ trưởng",
    example: "bộ trưởng bộ ngoại giao * ngài bộ trưởng",
  },
  {
    word: "bộ tư lệnh",
    part_of_speech: "danh từ",
    meaning:
      "cơ quan chỉ huy quân sự cấp liên binh đoàn và tương đương: bộ tư lệnh liên khu * bộ tư lệnh phòng không",
    example: "bộ tư lệnh liên khu * bộ tư lệnh phòng không",
  },
  {
    word: "bổ túc",
    part_of_speech: "động từ",
    meaning:
      "bồi bổ thêm cho được đầy đủ, cho đáp ứng được yêu cầu: bổ túc về nghiệp vụ",
    example: "bổ túc về nghiệp vụ",
  },
  {
    word: "bổ túc",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bổ túc văn hoá (nói tắt): học bổ túc * lớp bổ túc ban đêm",
    example: "học bổ túc * lớp bổ túc ban đêm",
  },
  {
    word: "bộ tướng",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) tướng mạo: bộ tướng dữ tợn",
    example: "bộ tướng dữ tợn",
  },
  {
    word: "bốc đồng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đột nhiên hăng lên một cách quá mức trong chốc lát (tựa như người lên đồng): tính bốc đồng * ăn nói bốc đồng",
    example: "tính bốc đồng * ăn nói bốc đồng",
  },
  {
    word: "bộ vị",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) vị trí của một bộ phận (thường là của cơ thể): bộ vị cấu âm",
    example: "bộ vị cấu âm",
  },
  {
    word: "bốc",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) cốc đựng bia, khoảng 1/4 lít: uống mấy bốc bia",
    example: "uống mấy bốc bia",
  },
  {
    word: "bốc",
    part_of_speech: "danh từ",
    meaning:
      "kiểu tóc nam giới cắt ngắn, chỉ để dài một mái trước: đầu húi bốc * cắt đầu bốc",
    example: "đầu húi bốc * cắt đầu bốc",
  },
  {
    word: "bốc",
    part_of_speech: "động từ",
    meaning:
      "lấy bằng cả lòng bàn tay, những vật rời vụn hay vật nhão: bốc một nắm gạo * ăn bốc",
    example: "bốc một nắm gạo * ăn bốc",
  },
  {
    word: "bốc",
    part_of_speech: "động từ",
    meaning:
      "lấy các vị thuốc đông y theo đơn để làm thành thang thuốc: kê đơn, bốc thuốc * bốc mấy thang thuốc bổ",
    example: "kê đơn, bốc thuốc * bốc mấy thang thuốc bổ",
  },
  {
    word: "bốc",
    part_of_speech: "động từ",
    meaning:
      "lấy ra và chuyển đi nơi khác: bốc hài cốt * bốc một quân bài * bốc mộ",
    example: "bốc hài cốt * bốc một quân bài * bốc mộ",
  },
  {
    word: "bốc",
    part_of_speech: "động từ",
    meaning: "lấy các vật chuyên chở để chuyển đi: bốc hàng lên xe",
    example: "bốc hàng lên xe",
  },
  {
    word: "bốc",
    part_of_speech: "động từ",
    meaning:
      "lấy ra khỏi một nơi nào đó và chuyển toàn khối đi nơi khác: mái tranh bị gió bão bốc từng mảng * bốc cả gia đình đi nơi khác",
    example: "mái tranh bị gió bão bốc từng mảng * bốc cả gia đình đi nơi khác",
  },
  {
    word: "bốc",
    part_of_speech: "động từ",
    meaning:
      "(lửa, khói, hơi, v.v.) vụt lên cao mạnh mẽ và toả ra: ngọn lửa bốc cao * nước sôi bốc hơi nghi ngút",
    example: "ngọn lửa bốc cao * nước sôi bốc hơi nghi ngút",
  },
  {
    word: "bốc",
    part_of_speech: "động từ",
    meaning:
      "(hiện tượng tâm lí) nổi lên, dâng lên mạnh mẽ trong người: cơn giận bốc lên",
    example: "cơn giận bốc lên",
  },
  {
    word: "bốc bải",
    part_of_speech: "động từ",
    meaning:
      'bốc để ăn một cách tự nhiên: ăn bốc bải * "Yêu nhau bốc bải giần sàng, Ghét nhau đũa ngọc mâm vàng chớ thây." (ca dao)',
    example:
      'ăn bốc bải * "Yêu nhau bốc bải giần sàng, Ghét nhau đũa ngọc mâm vàng chớ thây." (ca dao)',
  },
  {
    word: "bộc bạch",
    part_of_speech: "động từ",
    meaning:
      "nói ra rõ ràng và thành thật (nỗi lòng của mình): bộc bạch nỗi niềm",
    example: "bộc bạch nỗi niềm",
  },
  {
    word: "bốc dỡ",
    part_of_speech: "động từ",
    meaning:
      "bốc và dỡ (hàng hoá) để chuyển ra khỏi một nơi nào đó (nói khái quát): bốc dỡ hàng",
    example: "bốc dỡ hàng",
  },
  {
    word: "bốc giời",
    part_of_speech: "động từ",
    meaning:
      '(cũ) tiêu tiền của hết sức hoang phí: có tính bốc rời * "Thúc Sinh quen thói bốc rời, Trăm nghìn đổ một trận cười như không!" (TKiều)',
    example:
      'có tính bốc rời * "Thúc Sinh quen thói bốc rời, Trăm nghìn đổ một trận cười như không!" (TKiều)',
  },
  {
    word: "bốc hơi",
    part_of_speech: "động từ",
    meaning:
      "(chất lỏng) chuyển thành hơi; chuyển sang trạng thái khí: nước bốc hơi",
    example: "nước bốc hơi",
  },
  {
    word: "bốc hoả",
    part_of_speech: "động từ",
    meaning: "bốc khí nóng lên mặt, lên đầu, theo quan niệm đông y.",
    example: "tính hay bốc hoả",
  },
  {
    word: "bộc lộ",
    part_of_speech: "động từ",
    meaning:
      "để lộ rõ ra: bộc lộ một số nhược điểm * càng nói càng bộc lộ lòng dạ hẹp hòi",
    example: "bộc lộ một số nhược điểm * càng nói càng bộc lộ lòng dạ hẹp hòi",
  },
  {
    word: "bộc lộ",
    part_of_speech: "động từ",
    meaning: "nói ra điều sâu kín riêng: bộc lộ tâm sự * bộc lộ tình cảm",
    example: "bộc lộ tâm sự * bộc lộ tình cảm",
  },
  {
    word: "bộc phát",
    part_of_speech: "động từ",
    meaning: "(hiếm) như bột phát: cơn giận dữ bộc phát",
    example: "cơn giận dữ bộc phát",
  },
  {
    word: "bốc phét",
    part_of_speech: "động từ",
    meaning: "(thông tục) nói phét: tính hay bốc phét",
    example: "tính hay bốc phét",
  },
  {
    word: "bốc rời",
    part_of_speech: "động từ",
    meaning:
      '(cũ) tiêu tiền của hết sức hoang phí: có tính bốc rời * "Thúc Sinh quen thói bốc rời, Trăm nghìn đổ một trận cười như không!" (TKiều)',
    example:
      'có tính bốc rời * "Thúc Sinh quen thói bốc rời, Trăm nghìn đổ một trận cười như không!" (TKiều)',
  },
  {
    word: "bộc phá",
    part_of_speech: "động từ",
    meaning: "phá huỷ bằng chất nổ: bộc phá hàng rào * bộc phá công sự ngầm",
    example: "bộc phá hàng rào * bộc phá công sự ngầm",
  },
  {
    word: "bộc phá",
    part_of_speech: "danh từ",
    meaning: "khối thuốc nổ để phá các vật rắn chắc: đánh bằng bộc phá",
    example: "đánh bằng bộc phá",
  },
  {
    word: "bốc lửa",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có khả năng lôi cuốn, kích động tinh thần, tình cảm của người khác một cách sôi sục, mạnh mẽ (ví như có ngọn lửa bốc lên từ bên trong; thường nói về ngoại hình hay về phong cách biểu diễn, thể hiện): giọng ca bốc lửa * cô ca sĩ có thân hình bốc lửa",
    example: "giọng ca bốc lửa * cô ca sĩ có thân hình bốc lửa",
  },
  {
    word: "bốc thăm",
    part_of_speech: "động từ",
    meaning: "như bắt thăm: tổ chức bốc thăm chọn đề thi",
    example: "tổ chức bốc thăm chọn đề thi",
  },
  {
    word: "bốc trời",
    part_of_speech: "động từ",
    meaning:
      '(cũ) tiêu tiền của hết sức hoang phí: có tính bốc rời * "Thúc Sinh quen thói bốc rời, Trăm nghìn đổ một trận cười như không!" (TKiều)',
    example:
      'có tính bốc rời * "Thúc Sinh quen thói bốc rời, Trăm nghìn đổ một trận cười như không!" (TKiều)',
  },
  {
    word: "bộc trực",
    part_of_speech: "tính từ",
    meaning:
      "có tính nghĩ sao nói vậy một cách thẳng thắn: ăn nói bộc trực * tính khí bộc trực, thẳng thắn",
    example: "ăn nói bộc trực * tính khí bộc trực, thẳng thắn",
  },
  {
    word: "bộc tuệch",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) thật thà một cách vụng về, không giữ gìn tế nhị: tính bộc tuệch * ăn nói bộc tuệch",
    example: "tính bộc tuệch * ăn nói bộc tuệch",
  },
  {
    word: "bốc xếp",
    part_of_speech: "động từ",
    meaning: "bốc dỡ và chất, xếp (hàng hoá): bốc xếp sách vào kho",
    example: "bốc xếp sách vào kho",
  },
  {
    word: "bổi",
    part_of_speech: "danh từ",
    meaning:
      "mớ cành lá, cỏ rác lẫn lộn, thường dùng để đun: đống bổi * hết củi phải đun bằng bổi",
    example: "đống bổi * hết củi phải đun bằng bổi",
  },
  {
    word: "bổi",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) vụn rơm, thóc lép: trộn đất lẫn bổi để trát tường",
    example: "trộn đất lẫn bổi để trát tường",
  },
  {
    word: "bôi",
    part_of_speech: "động từ",
    meaning:
      "làm cho một chất nào đó dính thành lớp mỏng trên bề mặt: môi bôi son * quần áo bị bôi bẩn",
    example: "môi bôi son * quần áo bị bôi bẩn",
  },
  {
    word: "bôi",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) làm không đến nơi đến chốn, thiếu trách nhiệm: công việc bôi ra",
    example: "công việc bôi ra",
  },
  {
    word: "bôi",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) bày vẽ cái không cần thiết: đừng bôi việc ra nữa",
    example: "đừng bôi việc ra nữa",
  },
  {
    word: "bôi bác",
    part_of_speech: "động từ",
    meaning: "làm dối, làm qua loa cho gọi là có: làm ăn bôi bác",
    example: "làm ăn bôi bác",
  },
  {
    word: "bôi bác",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nêu cái xấu của người khác ra cho mọi người thấy, nhằm hạ thấp: bôi bác nhau",
    example: "bôi bác nhau",
  },
  {
    word: "bội",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) làm trái ngược với cái đã theo hay đã hứa; phản lại: bội ơn * bội lời giao ước * bội nghĩa vong ân",
    example: "bội ơn * bội lời giao ước * bội nghĩa vong ân",
  },
  {
    word: "bội",
    part_of_speech: "tính từ",
    meaning:
      "được nhân lên nhiều lần, hơn nhiều so với một mức nhất định: thu bội lên đến hơn chục triệu * người đông gấp bội",
    example: "thu bội lên đến hơn chục triệu * người đông gấp bội",
  },
  {
    word: "bội",
    part_of_speech: "danh từ",
    meaning: "tích của một đại lượng với một số nguyên: bội chung nhỏ nhất",
    example: "bội chung nhỏ nhất",
  },
  {
    word: "bốc vác",
    part_of_speech: "động từ",
    meaning:
      "bốc xếp và mang vác để vận chuyển: bốc vác thóc xuống thuyền * công nhân bốc vác",
    example: "bốc vác thóc xuống thuyền * công nhân bốc vác",
  },
  {
    word: "bồi",
    part_of_speech: "danh từ",
    meaning:
      "người đàn ông làm thuê chuyên phục vụ trong khách sạn, nhà hàng hoặc nhà riêng: làm bồi làm bếp * bồi bàn",
    example: "làm bồi làm bếp * bồi bàn",
  },
  {
    word: "bồi",
    part_of_speech: "động từ",
    meaning:
      "làm cho có thêm nhiều lớp để được dày hơn, bền chắc hơn: bồi giấy * bồi bức tranh",
    example: "bồi giấy * bồi bức tranh",
  },
  {
    word: "bồi",
    part_of_speech: "động từ",
    meaning:
      '(bùn cát) tích tụ lại và làm nâng cao thêm lòng sông, lòng hồ hoặc làm rộng thêm bờ sông, bờ hồ: "Con sông kia bên lở bên bồi, Bên lở thì đục, bên bồi thì trong." (Cdao)',
    example:
      'Con sông kia bên lở bên bồi, Bên lở thì đục, bên bồi thì trong." (Cdao)',
  },
  {
    word: "bồi",
    part_of_speech: "động từ",
    meaning:
      "tiếp thêm các hành động làm cho phải chịu đựng nặng nề hơn: bắn bồi thêm mấy phát * bồi thêm một câu",
    example: "bắn bồi thêm mấy phát * bồi thêm một câu",
  },
  {
    word: "bội bạc",
    part_of_speech: "tính từ",
    meaning:
      "không nhớ ơn nghĩa, làm những việc sai trái, không xứng với công ơn, tình nghĩa: con người bội bạc * ăn ở bội bạc",
    example: "con người bội bạc * ăn ở bội bạc",
  },
  {
    word: "bồi bàn",
    part_of_speech: "danh từ",
    meaning:
      "người làm thuê chuyên phục vụ ở bàn ăn: gọi bồi bàn tính tiền * làm bồi bàn cho khách sạn",
    example: "gọi bồi bàn tính tiền * làm bồi bàn cho khách sạn",
  },
  {
    word: "bối cảnh",
    part_of_speech: "",
    meaning: "(phương ngữ)",
    example:
      "trong bối cảnh hội nhập với quốc tế * được sống trong bối cảnh hoà bình",
  },
  {
    word: "bồi bổ",
    part_of_speech: "động từ",
    meaning:
      "làm cho tăng thêm hoặc mạnh thêm: bồi bổ sức khoẻ * bồi bổ kiến thức",
    example: "bồi bổ sức khoẻ * bồi bổ kiến thức",
  },
  {
    word: "bồi dưỡng",
    part_of_speech: "động từ",
    meaning: "làm cho tăng thêm sức của cơ thể bằng chất bổ.",
    example: "mở khoá bồi dưỡng viết văn * bồi dưỡng nâng cao trình độ",
  },
  {
    word: "bồi bút",
    part_of_speech: "danh từ",
    meaning:
      "kẻ làm tay sai bằng nghề viết sách báo: bọn bồi bút của lũ thực dân",
    example: "bọn bồi bút của lũ thực dân",
  },
  {
    word: "bồi đắp",
    part_of_speech: "động từ",
    meaning: "đắp thêm cho dày hơn, vững hơn: bồi đắp chân đê * phù sa bồi đắp",
    example: "bồi đắp chân đê * phù sa bồi đắp",
  },
  {
    word: "bội chi",
    part_of_speech: "động từ",
    meaning:
      "chi vượt quá mức thu hoặc quá mức dự trù: bội chi công quỹ * bội chi ngân sách",
    example: "bội chi công quỹ * bội chi ngân sách",
  },
  {
    word: "bội chung",
    part_of_speech: "danh từ",
    meaning: "bội đồng thời của nhiều đại lượng: bội chung nhỏ nhất",
    example: "bội chung nhỏ nhất",
  },
  {
    word: "bồi hoàn",
    part_of_speech: "động từ",
    meaning:
      "trả lại (cho đối tượng) những thiệt hại do mình gây ra: bồi hoàn tiền tham ô công quỹ",
    example: "bồi hoàn tiền tham ô công quỹ",
  },
  {
    word: "bôi đen",
    part_of_speech: "động từ",
    meaning:
      "mô tả hoặc trình bày một cách méo mó cho xấu xí đi nhằm hạ thấp giá trị: bôi đen sự thật * tung tin xấu để bôi đen chế độ",
    example: "bôi đen sự thật * tung tin xấu để bôi đen chế độ",
  },
  {
    word: "bôi đen",
    part_of_speech: "động từ",
    meaning:
      "làm cho kí tự hoặc đoạn văn bản trên máy tính có màu đen, nhằm đánh dấu sự lựa chọn, để thực hiện các thao tác như cắt, dán, v.v.: bôi đen một đoạn văn bản",
    example: "bôi đen một đoạn văn bản",
  },
  {
    word: "bồi hồi",
    part_of_speech: "",
    meaning:
      'ở trong trạng thái có những cảm xúc, ý nghĩ trở đi trở lại, làm xao xuyến không yên (thường là khi nghĩ đến việc đã qua): trong dạ bồi hồi * "Lòng chàng nghĩ lại bồi hồi, Trước tuy còn giận sau rồi lại thương." (QÂTK)',
    example:
      'trong dạ bồi hồi * "Lòng chàng nghĩ lại bồi hồi, Trước tuy còn giận sau rồi lại thương." (QÂTK)',
  },
  {
    word: "bổi hổi bồi hồi",
    part_of_speech: "",
    meaning:
      'như bồi hồi (nhưng nghĩa mạnh hơn): "Nhớ ai bổi hổi bồi hồi, Như đứng đống lửa, như ngồi đống than." (ca dao)',
    example:
      'Nhớ ai bổi hổi bồi hồi, Như đứng đống lửa, như ngồi đống than." (ca dao)',
  },
  {
    word: "bổi hổi",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) như bồi hồi (nhưng nghĩa mạnh hơn): thương nhớ bổi hổi * ruột gan bổi hổi",
    example: "thương nhớ bổi hổi * ruột gan bổi hổi",
  },
  {
    word: "bồi lắng",
    part_of_speech: "động từ",
    meaning:
      "(bùn cát, rác thải) bồi dần do lắng đọng (nói khái quát): luồng lạch bị bồi lắng",
    example: "luồng lạch bị bồi lắng",
  },
  {
    word: "bội nhiễm",
    part_of_speech: "động từ",
    meaning:
      "bị nhiễm khuẩn khi đang mắc một bệnh hoặc nhiễm khuẩn lần thứ hai khi cơ thể đang bị nhiễm khuẩn mãn tính: điều trị dứt điểm để tránh bội nhiễm",
    example: "điều trị dứt điểm để tránh bội nhiễm",
  },
  {
    word: "bội ơn",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) không những không biết ơn mà còn đối xử tệ bạc với người mình mang ơn: kẻ bội ơn",
    example: "kẻ bội ơn",
  },
  {
    word: "bội phản",
    part_of_speech: "động từ",
    meaning: "(hiếm) như phản bội: trị tội kẻ bội phản",
    example: "trị tội kẻ bội phản",
  },
  {
    word: "bội nghĩa",
    part_of_speech: "động từ",
    meaning: "phụ ơn nghĩa: kẻ bội nghĩa",
    example: "kẻ bội nghĩa",
  },
  {
    word: "bồi lấp",
    part_of_speech: "động từ",
    meaning:
      "(phù sa, bùn, cát, v.v.) lắng đọng lại và dần lấp đi: cửa sông bị bồi lấp * khai thông những đoạn kênh bị bồi lấp",
    example: "cửa sông bị bồi lấp * khai thông những đoạn kênh bị bồi lấp",
  },
  {
    word: "bôi nhọ",
    part_of_speech: "động từ",
    meaning: "làm cho xấu xa, nhơ nhuốc: bôi nhọ uy tín * bôi nhọ lịch sử",
    example: "bôi nhọ uy tín * bôi nhọ lịch sử",
  },
  {
    word: "bội số",
    part_of_speech: "danh từ",
    meaning: "tích của một số với một số nguyên: 9 là bội số của 3",
    example: "9 là bội số của 3",
  },
  {
    word: "bối rối",
    part_of_speech: "tính từ",
    meaning:
      'lúng túng, mất bình tĩnh, không biết nên xử trí thế nào: vẻ mặt bối rối * "Lòng ngán ngẫm buồn tênh mọi nỗi, Khúc sầu tràng bối rối dường tơ." (CO)',
    example:
      'vẻ mặt bối rối * "Lòng ngán ngẫm buồn tênh mọi nỗi, Khúc sầu tràng bối rối dường tơ." (CO)',
  },
  {
    word: "bội phần",
    part_of_speech: "phụ từ",
    meaning:
      'hơn rất nhiều, so với một mức nào đó: sung sướng bội phần * "Mày ai trăng mới in ngần, Phấn thừa hương cũ bội phần xót xa!" (TKiều)',
    example:
      'sung sướng bội phần * "Mày ai trăng mới in ngần, Phấn thừa hương cũ bội phần xót xa!" (TKiều)',
  },
  {
    word: "bội số chung",
    part_of_speech: "danh từ",
    meaning:
      "bội số đồng thời của hai hay nhiều đại lượng: 12 là bội số chung của 2, 3, 4 và 6 * tìm bội số chung nhỏ nhất của 4 và 6",
    example:
      "12 là bội số chung của 2, 3, 4 và 6 * tìm bội số chung nhỏ nhất của 4 và 6",
  },
  {
    word: "bội thực",
    part_of_speech: "động từ",
    meaning:
      "ăn quá no, không tiêu hoá kịp, gây cảm giác hết sức khó chịu trong bụng: ăn no bội thực * bội thực thông tin (b)",
    example: "ăn no bội thực * bội thực thông tin (b)",
  },
  {
    word: "bồi thường",
    part_of_speech: "động từ",
    meaning:
      "trả lại cho người khác cái có giá trị (thường bằng tiền) tương xứng với những thiệt hại mà mình đã gây ra: làm hỏng phải bồi thường * bồi thường cho gia đình nạn nhân * bồi thường danh dự",
    example:
      "làm hỏng phải bồi thường * bồi thường cho gia đình nạn nhân * bồi thường danh dự",
  },
  {
    word: "bội tín",
    part_of_speech: "động từ",
    meaning:
      "phụ lòng tin cậy (lường gạt hoặc chiếm đoạt trái phép của người khác): kẻ bội tín * việc làm bội tín",
    example: "kẻ bội tín * việc làm bội tín",
  },
  {
    word: "bội thu",
    part_of_speech: "động từ",
    meaning:
      "(mùa màng) thu hoạch được nhiều hơn bình thường: một vụ mùa bội thu * bội thu cà phê",
    example: "một vụ mùa bội thu * bội thu cà phê",
  },
  {
    word: "bội thu",
    part_of_speech: "động từ",
    meaning:
      "thu nhiều hơn chi hoặc nhiều hơn mức dự kiến: cán cân thanh toán đang bội thu",
    example: "cán cân thanh toán đang bội thu",
  },
  {
    word: "bội tình",
    part_of_speech: "động từ",
    meaning: "(hiếm) phụ bạc tình yêu: kẻ bội tình",
    example: "kẻ bội tình",
  },
  {
    word: "bồi tụ",
    part_of_speech: "động từ",
    meaning:
      "tích tụ và bồi đắp phù sa: đất ngoài đê được phù sa bồi tụ * quá trình bồi tụ châu thổ sông Hồng",
    example:
      "đất ngoài đê được phù sa bồi tụ * quá trình bồi tụ châu thổ sông Hồng",
  },
  {
    word: "bội ước",
    part_of_speech: "động từ",
    meaning: "làm trái với điều đã cam kết: bội ước với người yêu",
    example: "bội ước với người yêu",
  },
  {
    word: "bôm bốp",
    part_of_speech: "tính từ",
    meaning:
      'từ mô phỏng âm thanh đều và to, phát ra liên tiếp do hơi bị nén bật ra: vỗ tay bôm bốp * "Người ta vỗ tay hoặc cười lăn cười lộn. Nút chai lại bôm bốp phụt lên trần nhà." (VTrPhụng; 4)',
    example:
      'vỗ tay bôm bốp * "Người ta vỗ tay hoặc cười lăn cười lộn. Nút chai lại bôm bốp phụt lên trần nhà." (VTrPhụng; 4)',
  },
  {
    word: "bôi tro trát trấu",
    part_of_speech: "",
    meaning:
      'ví hành vi làm nhục, làm mất thể diện (của người thân) bằng việc làm xấu xa của mình: "(…) mày rước đứa con gái ở cái làng ăn cướp ấy về làm dâu tao, thì phỏng mày định bôi tro trát trấu vào mặt bố mẹ mày ư?" (NgGiao; 1)',
    example:
      '(…) mày rước đứa con gái ở cái làng ăn cướp ấy về làm dâu tao, thì phỏng mày định bôi tro trát trấu vào mặt bố mẹ mày ư?" (NgGiao; 1)',
  },
  {
    word: "bôi trơn",
    part_of_speech: "động từ",
    meaning:
      "cho chất trơn, nhờn vào giữa hai mặt cọ xát với nhau trong máy để máy chạy dễ dàng hơn và giảm bớt các hiện tượng ăn mòn, mất năng lượng, v.v.: tra dầu để bôi trơn máy",
    example: "tra dầu để bôi trơn máy",
  },
  {
    word: "bốn",
    part_of_speech: "danh từ",
    meaning:
      "số (ghi bằng 4) liền sau số ba trong dãy số tự nhiên: học lớp bốn * bốn ba (kng; bốn mươi ba) * một năm có bốn mùa",
    example: "học lớp bốn * bốn ba (kng; bốn mươi ba) * một năm có bốn mùa",
  },
  {
    word: "bộn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) nhiều và ngổn ngang: công việc bộn lên * thóc lúa bộn nhà",
    example: "công việc bộn lên * thóc lúa bộn nhà",
  },
  {
    word: "bộn",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) nhiều, khá nhiều: anh ta đã bộn tuổi * kiếm được bộn tiền",
    example: "anh ta đã bộn tuổi * kiếm được bộn tiền",
  },
  {
    word: "bồn",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng chứa nước để tắm rửa hoặc trồng cây cảnh, v.v., thường đặt ở những vị trí nhất định: bồn tắm * bồn rửa bát",
    example: "bồn tắm * bồn rửa bát",
  },
  {
    word: "bồn",
    part_of_speech: "danh từ",
    meaning:
      "khoảng đất đánh thành vồng và thường có xây bờ bao thấp xung quanh để trồng cây, trồng hoa: bồn hoa",
    example: "bồn hoa",
  },
  {
    word: "bồn",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) (trâu, bò, ngựa) lồng lên chạy: con trâu cong đuôi bồn thẳng ra đồng",
    example: "con trâu cong đuôi bồn thẳng ra đồng",
  },
  {
    word: "bồm bộp",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng âm thanh đều và trầm đục, liên tiếp phát ra do vật cứng đập vào vật mềm rỗng hoặc không đặc ruột: vỗ bồm bộp vào vai",
    example: "vỗ bồm bộp vào vai",
  },
  {
    word: "bốn biển",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương) tất cả mọi nơi trên thế giới, toàn thế giới: đi khắp bốn biển * anh em bốn biển một nhà",
    example: "đi khắp bốn biển * anh em bốn biển một nhà",
  },
  {
    word: "bộn bề",
    part_of_speech: "tính từ",
    meaning: "như bề bộn: nhà cửa bộn bề * công việc bộn bề",
    example: "nhà cửa bộn bề * công việc bộn bề",
  },
  {
    word: "bôn ba",
    part_of_speech: "động từ",
    meaning:
      "đi đây đi đó, chịu nhiều gian lao, vất vả (để lo liệu công việc): bôn ba nơi xứ người * cuộc sống bôn ba",
    example: "bôn ba nơi xứ người * cuộc sống bôn ba",
  },
  {
    word: "bổn phận",
    part_of_speech: "danh từ",
    meaning:
      "trách nhiệm và phần việc phải gánh vác, lo liệu, theo đạo lí thông thường: bổn phận làm con * làm tròn bổn phận",
    example: "bổn phận làm con * làm tròn bổn phận",
  },
  {
    word: "bốn phương",
    part_of_speech: "danh từ",
    meaning:
      'tất cả các phương trời, tất cả các nơi: đi khắp bốn phương * "Bốn phương mây trắng một màu, Trông vời cố quốc biết đâu là nhà?" (TKiều)',
    example:
      'đi khắp bốn phương * "Bốn phương mây trắng một màu, Trông vời cố quốc biết đâu là nhà?" (TKiều)',
  },
  {
    word: "bông",
    part_of_speech: "danh từ",
    meaning:
      "cây thân cỏ hay cây nhỡ, lá hình chân vịt, hoa màu vàng, quả già chứa xơ trắng, dùng để kéo thành sợi vải: cây bông * cánh đồng trồng bông",
    example: "cây bông * cánh đồng trồng bông",
  },
  {
    word: "bông",
    part_of_speech: "danh từ",
    meaning:
      "chất sợi lấy từ quả của bông hoặc của một số cây khác: dùng bông thấm máu * chăn bông * gối bằng bông gạo",
    example: "dùng bông thấm máu * chăn bông * gối bằng bông gạo",
  },
  {
    word: "bông",
    part_of_speech: "tính từ",
    meaning:
      "tơi xốp, mềm mại như bông: ruốc bông * tóc bông * đánh trứng cho thật bông",
    example: "ruốc bông * tóc bông * đánh trứng cho thật bông",
  },
  {
    word: "bông",
    part_of_speech: "danh từ",
    meaning:
      'tập hợp gồm nhiều hoa không cuống mọc dọc trên một cán hoa chung hoặc tập hợp gồm nhiều quả (mà thông thường gọi là hạt) phát triển từ một cụm hoa như thế: lúa trĩu bông * "Đìu hiu quạnh quẽ hơi thu, Bông lau phơi trắng, lá ngô rạng vàng." (Cdao)',
    example:
      'lúa trĩu bông * "Đìu hiu quạnh quẽ hơi thu, Bông lau phơi trắng, lá ngô rạng vàng." (Cdao)',
  },
  {
    word: "bông",
    part_of_speech: "danh từ",
    meaning: "từ dùng để chỉ từng cái hoa: bông hồng * ngắt mấy bông hoa",
    example: "bông hồng * ngắt mấy bông hoa",
  },
  {
    word: "bông",
    part_of_speech: "danh từ",
    meaning:
      '(Phương ngữ) hoa: đốt pháo bông * "Dưới trăng quyên đã gọi hè, Đầu tường lửa lựu lập loè đâm bông." (TKiều)',
    example:
      'đốt pháo bông * "Dưới trăng quyên đã gọi hè, Đầu tường lửa lựu lập loè đâm bông." (TKiều)',
  },
  {
    word: "bông",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ, Khẩu ngữ) bông tai (nói tắt): tai đeo bông",
    example: "tai đeo bông",
  },
  {
    word: "bông",
    part_of_speech: "danh từ",
    meaning: "(Từ cũ) phiếu cấp phát để mua hàng: bông mua vải",
    example: "bông mua vải",
  },
  {
    word: "bông",
    part_of_speech: "động từ",
    meaning: "(Khẩu ngữ) đùa vui bằng lời nói: nói bông",
    example: "nói bông",
  },
  {
    word: "bồn chồn",
    part_of_speech: "",
    meaning:
      "ở trong trạng thái thấp thỏm, mong ngóng, chờ đợi một việc gì chưa đến, chưa biết sẽ ra sao: trong dạ bồn chồn * bồn chồn chờ kết quả thi",
    example: "trong dạ bồn chồn * bồn chồn chờ kết quả thi",
  },
  {
    word: "bồn địa",
    part_of_speech: "danh từ",
    meaning:
      "vùng đất trũng thấp, rộng lớn, thường có núi bao quanh: Tây Nguyên có bồn địa rộng và rất đẹp",
    example: "Tây Nguyên có bồn địa rộng và rất đẹp",
  },
  {
    word: "bôn sê vích",
    part_of_speech: "tính từ",
    meaning:
      "theo chủ nghĩa bôn sê vích, theo chủ nghĩa Marx-Lenin: một đảng bôn sê vích * tinh thần bôn sê vích",
    example: "một đảng bôn sê vích * tinh thần bôn sê vích",
  },
  {
    word: "bồng",
    part_of_speech: "động từ",
    meaning: "(Phương ngữ) bế, ẵm: bồng em đi chơi * mẹ bồng con",
    example: "bồng em đi chơi * mẹ bồng con",
  },
  {
    word: "bồng",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái nổi cao lên, phồng cao lên: nước sôi bồng lên * mái tóc bồng lên * áo vai bồng",
    example: "nước sôi bồng lên * mái tóc bồng lên * áo vai bồng",
  },
  {
    word: "bỗng",
    part_of_speech: "danh từ",
    meaning:
      "bã rượu hoặc rau cỏ ủ chua làm thức ăn cho lợn: bỗng rượu * ủ bỗng chua cho lợn",
    example: "bỗng rượu * ủ bỗng chua cho lợn",
  },
  {
    word: "bỗng",
    part_of_speech: "phụ từ",
    meaning:
      "(hành động, quá trình xảy ra) một cách rất nhanh và bất ngờ, không lường trước được: trời đang nắng bỗng đổ mưa * thằng bé bỗng tu lên khóc",
    example: "trời đang nắng bỗng đổ mưa * thằng bé bỗng tu lên khóc",
  },
  {
    word: "bộng",
    part_of_speech: "danh từ",
    meaning: "chỗ rỗng trong lòng gỗ: gỗ bị mọt, có nhiều bộng",
    example: "gỗ bị mọt, có nhiều bộng",
  },
  {
    word: "bộng",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) nồi đất cỡ to, miệng rộng: luộc một bộng khoai",
    example: "luộc một bộng khoai",
  },
  {
    word: "bổng",
    part_of_speech: "tính từ",
    meaning:
      "(giọng, tiếng) cao và trong: tiếng sáo khi trầm khi bổng * lên bổng xuống trầm",
    example: "tiếng sáo khi trầm khi bổng * lên bổng xuống trầm",
  },
  {
    word: "bổng",
    part_of_speech: "tính từ",
    meaning:
      'ở vị trí lên được rất cao trong khoảng không: nhấc bổng lên * "Lão chỉ đá phốc cho một cái thì bổng cả thúng lẫn người lên nóc nhà!" (THoài; 32)',
    example:
      'nhấc bổng lên * "Lão chỉ đá phốc cho một cái thì bổng cả thúng lẫn người lên nóc nhà!" (THoài; 32)',
  },
  {
    word: "bồng bồng",
    part_of_speech: "danh từ",
    meaning: "cây nhỡ, lá có gân song song, hoa dùng làm rau ăn: hoa bồng bồng",
    example: "hoa bồng bồng",
  },
  {
    word: "bồng bế",
    part_of_speech: "động từ",
    meaning:
      "bế trẻ em (nói khái quát): bồng bế con cái * cùng quẫn, phải bồng bế nhau đi ăn mày",
    example: "bồng bế con cái * cùng quẫn, phải bồng bế nhau đi ăn mày",
  },
  {
    word: "bồng bột",
    part_of_speech: "tính từ",
    meaning:
      "sôi nổi, hăng hái, nhưng thiếu chín chắn, không lâu bền: suy nghĩ bồng bột * tuổi trẻ bồng bột",
    example: "suy nghĩ bồng bột * tuổi trẻ bồng bột",
  },
  {
    word: "bỗng chốc",
    part_of_speech: "phụ từ",
    meaning:
      "bỗng nhiên, trong chốc lát: trời bỗng chốc tối sầm * đám đông đang ồn ào, bỗng chốc lặng thinh * mọi sự không thể bỗng chốc mà thành",
    example:
      "trời bỗng chốc tối sầm * đám đông đang ồn ào, bỗng chốc lặng thinh * mọi sự không thể bỗng chốc mà thành",
  },
  {
    word: "bỗng dưng",
    part_of_speech: "phụ từ",
    meaning:
      'bỗng nhiên, không rõ vì sao: "Cuộc đời chưa đến bể dâu, Bỗng dưng mua não chuốc sầu mà chơi." (HT)',
    example:
      'Cuộc đời chưa đến bể dâu, Bỗng dưng mua não chuốc sầu mà chơi." (HT)',
  },
  {
    word: "bông bụt",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) râm bụt: hàng rào bông bụt",
    example: "hàng rào bông bụt",
  },
  {
    word: "bồng bềnh",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả dáng chuyển động lên xuống nhẹ nhàng theo làn sóng, làn gió: thuyền bồng bềnh trên mặt nước * mây trôi bồng bềnh",
    example: "thuyền bồng bềnh trên mặt nước * mây trôi bồng bềnh",
  },
  {
    word: "ra đầu ra đũa",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) (cách ăn nói) rành mạch, cặn kẽ mọi tình tiết, có đầu có đuôi: chuyện kể không ra đầu ra đũa gì",
    example: "chuyện kể không ra đầu ra đũa gì",
  },
  {
    word: "rã họng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) (nói hoặc đói đến mức) rã rời, không chịu nổi nữa: đói rã họng * nói đến rã họng mà nó vẫn không nghe",
    example: "đói rã họng * nói đến rã họng mà nó vẫn không nghe",
  },
  {
    word: "ra cái điều",
    part_of_speech: "",
    meaning: "(khẩu ngữ) như ra điều: ra cái điều ta đây học giỏi!",
    example: "ra cái điều ta đây học giỏi!",
  },
  {
    word: "ra cái vẻ",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) làm ra vẻ một cách giả tạo: ra cái vẻ phong lưu * cứ làm ra cái vẻ ngoan ngoãn lắm!",
    example: "ra cái vẻ phong lưu * cứ làm ra cái vẻ ngoan ngoãn lắm!",
  },
  {
    word: "ra đời",
    part_of_speech: "động từ",
    meaning: "được sinh ra trên đời: một bé trai sắp ra đời",
    example: "một bé trai sắp ra đời",
  },
  {
    word: "ra đời",
    part_of_speech: "động từ",
    meaning:
      "bắt đầu được xuất hiện và tồn tại: một tổ chức mới ra đời * cho ra đời một tác phẩm mới",
    example: "một tổ chức mới ra đời * cho ra đời một tác phẩm mới",
  },
  {
    word: "ra gì",
    part_of_speech: "",
    meaning:
      "có được một chút giá trị nhất định nào đó: không coi ai ra gì * hạng người không ra gì",
    example: "không coi ai ra gì * hạng người không ra gì",
  },
  {
    word: "rã đám",
    part_of_speech: "động từ",
    meaning: "(hiếm)",
    example: "có tư tưởng rã đám * chưa chi đã rã đám",
  },
  {
    word: "ra chiều",
    part_of_speech: "",
    meaning:
      "ra vẻ, tỏ vẻ: nét mặt ra chiều vui vẻ * cư xử với nhau ra chiều thân mật lắm",
    example: "nét mặt ra chiều vui vẻ * cư xử với nhau ra chiều thân mật lắm",
  },
  {
    word: "ra công",
    part_of_speech: "động từ",
    meaning:
      "đem hết công sức ra làm việc gì: ra công học tập * ngày đêm ra công luyện tập",
    example: "ra công học tập * ngày đêm ra công luyện tập",
  },
  {
    word: "ra dáng",
    part_of_speech: "",
    meaning:
      "có dáng vẻ giống như (trong khi có thể chưa phải đã hoàn toàn như thế): trông cũng ra dáng thiếu nữ * nét mặt trầm ngâm ra dáng nghĩ ngợi",
    example:
      "trông cũng ra dáng thiếu nữ * nét mặt trầm ngâm ra dáng nghĩ ngợi",
  },
  {
    word: "ra hồn",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) có đủ những giá trị cần có để có thể gọi được là như vậy: không làm được việc gì ra hồn",
    example: "không làm được việc gì ra hồn",
  },
  {
    word: "ra điều",
    part_of_speech: "",
    meaning:
      '(khẩu ngữ) làm ra vẻ là: ra điều không chấp * "Em là con gái nhà nghèo, Cha mẹ thách cưới ra điều xênh xang." (ca dao)',
    example:
      'ra điều không chấp * "Em là con gái nhà nghèo, Cha mẹ thách cưới ra điều xênh xang." (ca dao)',
  },
  {
    word: "ra hiệu",
    part_of_speech: "động từ",
    meaning:
      "làm dấu hiệu, thường bằng cử chỉ, để báo cho biết: vẫy tay ra hiệu * nháy mắt ra hiệu bảo thôi",
    example: "vẫy tay ra hiệu * nháy mắt ra hiệu bảo thôi",
  },
  {
    word: "ra mắt",
    part_of_speech: "động từ",
    meaning:
      "xuất hiện lần đầu tiên trước ai, thường là số đông, có tính chất để cho người ta biết mình: số báo đầu tiên đã ra mắt bạn đọc * ra mắt công chúng",
    example: "số báo đầu tiên đã ra mắt bạn đọc * ra mắt công chúng",
  },
  {
    word: "ra lò",
    part_of_speech: "động từ",
    meaning:
      "vừa mới được sản xuất ra: gạch ra lò * kiểm tra lô sản phẩm mới ra lò * bánh mì vừa mới ra lò",
    example:
      "gạch ra lò * kiểm tra lô sản phẩm mới ra lò * bánh mì vừa mới ra lò",
  },
  {
    word: "ra mặt",
    part_of_speech: "động từ",
    meaning:
      "tỏ rõ ra, không cần phải che đậy giấu giếm gì: ghét ra mặt * mừng ra mặt * ra mặt chống đối",
    example: "ghét ra mặt * mừng ra mặt * ra mặt chống đối",
  },
  {
    word: "ra môn ra khoai",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) ví làm việc gì có kết quả rõ ràng, đâu ra đấy: phải làm cho ra môn ra khoai",
    example: "phải làm cho ra môn ra khoai",
  },
  {
    word: "ra lệnh",
    part_of_speech: "động từ",
    meaning: "đưa ra mệnh lệnh: ra lệnh xuất quân * nói như ra lệnh",
    example: "ra lệnh xuất quân * nói như ra lệnh",
  },
  {
    word: "ra oai",
    part_of_speech: "động từ",
    meaning:
      "cố ý tỏ ra là có quyền thế, có sức mạnh để cho người khác phải nể sợ: hơi một tí là ra oai * lên giọng để ra oai",
    example: "hơi một tí là ra oai * lên giọng để ra oai",
  },
  {
    word: "ra phết",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) ở mức tương đối cao: xinh ra phết * thắng bộ vào, trông cũng oai ra phết",
    example: "xinh ra phết * thắng bộ vào, trông cũng oai ra phết",
  },
  {
    word: "ra quân",
    part_of_speech: "động từ",
    meaning: "đưa quân ra trận để chiến đấu: trước giờ ra quân",
    example: "trước giờ ra quân",
  },
  {
    word: "ra quân",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) triển khai, tăng cường lực lượng để đẩy mạnh một công việc gì: trận ra quân đầu tiên của đội nhà",
    example: "trận ra quân đầu tiên của đội nhà",
  },
  {
    word: "ra ràng",
    part_of_speech: "động từ",
    meaning:
      "(chim non) mới mọc đủ lông, đủ cánh, bắt đầu có thể bay ra khỏi tổ: con chim đã ra ràng",
    example: "con chim đã ra ràng",
  },
  {
    word: "ra rả",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả những âm thanh to, vang lặp đi lặp lại, kéo dài mãi, gây cảm giác khó chịu: tiếng ve kêu ra rả * nói ra rả cả ngày",
    example: "tiếng ve kêu ra rả * nói ra rả cả ngày",
  },
  {
    word: "rà rẫm",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) làm việc gì đó một cách hết sức chậm chạp: làm cái gì cũng rà rẫm",
    example: "làm cái gì cũng rà rẫm",
  },
  {
    word: "rã rời",
    part_of_speech: "động từ",
    meaning:
      'rã ra, rời ra thành từng phần, từng mảng, không còn có quan hệ gì với nhau: đội ngũ rã rời * "Mần chi cho bỉ mặt nhau, Miếng trầu khô héo, miếng cau rã rời." (ca dao)',
    example:
      'đội ngũ rã rời * "Mần chi cho bỉ mặt nhau, Miếng trầu khô héo, miếng cau rã rời." (ca dao)',
  },
  {
    word: "rã rời",
    part_of_speech: "động từ",
    meaning:
      "ở trạng thái hết sức mỏi mệt, có cảm giác như các bộ phận của cơ thể muốn rời nhau ra, không còn sức vận động: người mệt mỏi rã rời",
    example: "người mệt mỏi rã rời",
  },
  {
    word: "rã rượi",
    part_of_speech: "tính từ",
    meaning:
      "có vẻ rũ xuống, rã ra do quá mệt mỏi hoặc buồn bã: chân tay rã rượi * đầu tóc rã rượi",
    example: "chân tay rã rượi * đầu tóc rã rượi",
  },
  {
    word: "ra rìa",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bị gạt ra một bên, không còn được ai để ý đến nữa: cho ra rìa",
    example: "cho ra rìa",
  },
  {
    word: "ra sức",
    part_of_speech: "động từ",
    meaning: "đem hết sức ra để làm việc gì: ra sức học tập",
    example: "ra sức học tập",
  },
  {
    word: "rả rích",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả những âm thanh không to, không cao, lặp đi lặp lại đều đều và kéo dài như không dứt: côn trùng kêu rả rích * mưa rả rích suốt đêm",
    example: "côn trùng kêu rả rích * mưa rả rích suốt đêm",
  },
  {
    word: "ra tay",
    part_of_speech: "động từ",
    meaning:
      '(khẩu ngữ) bắt đầu hành động để tỏ rõ khả năng, tài trí của mình: "Thuyền quyên ví biết anh hùng, Ra tay tháo cũi sổ lồng như chơi!" (TKiều)',
    example:
      'Thuyền quyên ví biết anh hùng, Ra tay tháo cũi sổ lồng như chơi!" (TKiều)',
  },
  {
    word: "rà soát",
    part_of_speech: "động từ",
    meaning:
      "xem xét lại toàn bộ một cách kĩ lưỡng: rà soát sổ sách * rà soát lại từng câu từng chữ",
    example: "rà soát sổ sách * rà soát lại từng câu từng chữ",
  },
  {
    word: "ra trò",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) ở mức độ thật đáng kể: đánh chén một bữa ra trò * đứa bé kháu ra trò",
    example: "đánh chén một bữa ra trò * đứa bé kháu ra trò",
  },
  {
    word: "ra vẻ",
    part_of_speech: "",
    meaning:
      "có vẻ như là: ra vẻ hào hứng * làm ra vẻ tự nhiên * gật gù ra vẻ bằng lòng",
    example: "ra vẻ hào hứng * làm ra vẻ tự nhiên * gật gù ra vẻ bằng lòng",
  },
  {
    word: "ra vẻ",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) có được cái vẻ, cái hình thức bên ngoài: ăn mặc cho ra vẻ",
    example: "ăn mặc cho ra vẻ",
  },
  {
    word: "ra tấm ra món",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) thành một khoản, một món đáng kể, không lắt nhắt, vụn vặt (thường nói về tiền): lấy lương một cục cho ra tấm ra món",
    example: "lấy lương một cục cho ra tấm ra món",
  },
  {
    word: "ra tuồng",
    part_of_speech: "",
    meaning:
      '(khẩu ngữ, hiếm) ra vẻ, có cái vẻ như: "Cau không buồng ra tuồng cau đực, Anh kia không vợ cực lắm anh ơi!" (ca dao)',
    example:
      'Cau không buồng ra tuồng cau đực, Anh kia không vợ cực lắm anh ơi!" (ca dao)',
  },
  {
    word: "ra tuồng",
    part_of_speech: "",
    meaning: "như ra trò: chẳng đứa nào làm cho ra tuồng",
    example: "chẳng đứa nào làm cho ra tuồng",
  },
  {
    word: "ra-đi-ô",
    part_of_speech: "danh từ",
    meaning:
      "(cũng vô tuyến điện) phương thức truyền tín hiệu đi xa bằng sự bức xạ sóng điện từ",
    example: "nghe radio",
  },
  {
    word: "rạc",
    part_of_speech: "tính từ",
    meaning: "gầy đi trông thấy, đến mức xơ xác: người gầy rạc",
    example: "người gầy rạc",
  },
  {
    word: "rạc",
    part_of_speech: "tính từ",
    meaning:
      "cảm thấy như rã rời, vì quá mệt mỏi: đi rạc cẳng mà vẫn chưa đến nơi * nói rạc cổ * viết rạc cả tay",
    example: "đi rạc cẳng mà vẫn chưa đến nơi * nói rạc cổ * viết rạc cả tay",
  },
  {
    word: "rạc",
    part_of_speech: "tính từ",
    meaning:
      "(cây cối) ở trạng thái tàn lụi, trông xác xơ: bèo rạc * mùa đông cây cối rạc lá",
    example: "bèo rạc * mùa đông cây cối rạc lá",
  },
  {
    word: "rác rưởi",
    part_of_speech: "danh từ",
    meaning:
      "rác (nói khái quát): rác rưởi nổi lềnh bềnh trên mặt sông * đồ rác rưởi!",
    example: "rác rưởi nổi lềnh bềnh trên mặt sông * đồ rác rưởi!",
  },
  {
    word: "rác rến",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) rác rưởi: rác rến đầy đường",
    example: "rác rến đầy đường",
  },
  {
    word: "rạc rài",
    part_of_speech: "tính từ",
    meaning:
      "gầy rạc, xác xơ (nói khái quát): thân thể rạc rài * đói khát rạc rài",
    example: "thân thể rạc rài * đói khát rạc rài",
  },
  {
    word: "rác",
    part_of_speech: "danh từ",
    meaning:
      "những thứ vụn vặt không dùng đến hoặc đã qua sử dụng bị vứt bỏ (nói tổng quát): gom rác lại một chỗ * đổ rác * bói ra ma, quét nhà ra rác (tng)",
    example: "gom rác lại một chỗ * đổ rác * bói ra ma, quét nhà ra rác (tng)",
  },
  {
    word: "rác",
    part_of_speech: "tính từ",
    meaning: "bẩn vì có nhiều rác: nhặt mấy thứ đó về chỉ tổ làm rác nhà",
    example: "nhặt mấy thứ đó về chỉ tổ làm rác nhà",
  },
  {
    word: "rác thải",
    part_of_speech: "danh từ",
    meaning: "như chất thải: thu gom rác thải",
    example: "thu gom rác thải",
  },
  {
    word: "rác tai",
    part_of_speech: "tính từ",
    meaning:
      '(khẩu ngữ) nghe khó chịu vì toàn là những chuyện không có nghĩa lí gì: "Nói chi những tiếng mỉa mai, Mếch lòng thiếu nữ, rác tai anh hùng." (ca dao)',
    example:
      'Nói chi những tiếng mỉa mai, Mếch lòng thiếu nữ, rác tai anh hùng." (ca dao)',
  },
  {
    word: "ra-đa",
    part_of_speech: "danh từ",
    meaning:
      "máy xác định vị trí và khoảng cách của vật cần phát hiện bằng sự phản xạ của sóng radio khi gặp vật đó: trạm radar * điều khiển radar",
    example: "trạm radar * điều khiển radar",
  },
  {
    word: "rách bươm",
    part_of_speech: "tính từ",
    meaning:
      "rách thành nhiều mảnh nhỏ, trông tả tơi: quần áo bị gai cào rách bươm",
    example: "quần áo bị gai cào rách bươm",
  },
  {
    word: "rách",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái không còn nguyên mảnh, có những chỗ bị tách, bị thủng ra: áo rách vai * xé rách quyển sách * đói cho sạch, rách cho thơm (tng)",
    example:
      "áo rách vai * xé rách quyển sách * đói cho sạch, rách cho thơm (tng)",
  },
  {
    word: "rạch",
    part_of_speech: "danh từ",
    meaning:
      "đường dẫn nước từ sông vào đồng ruộng, thuyền bè có thể đi lại được: hệ thống kênh, rạch chằng chịt",
    example: "hệ thống kênh, rạch chằng chịt",
  },
  {
    word: "rạch",
    part_of_speech: "động từ",
    meaning:
      "làm cho đứt thành đường trên bề mặt, bằng vật sắc: bị kẻ gian rạch túi * rạch mặt ăn vạ * chớp rạch ngang dọc bầu trời",
    example:
      "bị kẻ gian rạch túi * rạch mặt ăn vạ * chớp rạch ngang dọc bầu trời",
  },
  {
    word: "rạch",
    part_of_speech: "danh từ",
    meaning:
      "đường rãnh nhỏ, nông, xẻ trên mặt ruộng để gieo hạt, trồng cây: xẻ rạch * đánh rạch * khơi rạch để thoát nước",
    example: "xẻ rạch * đánh rạch * khơi rạch để thoát nước",
  },
  {
    word: "rạch",
    part_of_speech: "động từ",
    meaning:
      "di chuyển ngược dòng nước, cố ngoi lên chỗ cạn (thường nói về cá rô): đi bắt cá rô rạch",
    example: "đi bắt cá rô rạch",
  },
  {
    word: "rách nát",
    part_of_speech: "tính từ",
    meaning:
      "rách nhiều chỗ, đến mức gần như nát ra (nói khái quát): quần áo rách nát * đội cái nón mê đã rách nát",
    example: "quần áo rách nát * đội cái nón mê đã rách nát",
  },
  {
    word: "rách mướp",
    part_of_speech: "tính từ",
    meaning: "rách tơi như xơ mướp: quần áo rách mướp * chiếc chiếu rách mướp",
    example: "quần áo rách mướp * chiếc chiếu rách mướp",
  },
  {
    word: "rạch ròi",
    part_of_speech: "tính từ",
    meaning:
      "rành mạch, có sự phân biệt rõ ràng, đâu ra đấy: kể rạch ròi câu chuyện * phân biệt rạch ròi",
    example: "kể rạch ròi câu chuyện * phân biệt rạch ròi",
  },
  {
    word: "rách như tổ đỉa",
    part_of_speech: "",
    meaning:
      '(khẩu ngữ) (quần áo) rách tả tơi, xơ xác, nham nhở: "Lúc này không ai dám bảo hắn là ăn mày, mặc dầu quần áo hắn rách như tổ đỉa." (NgTuân; 35)',
    example:
      'Lúc này không ai dám bảo hắn là ăn mày, mặc dầu quần áo hắn rách như tổ đỉa." (NgTuân; 35)',
  },
  {
    word: "rách rưới",
    part_of_speech: "tính từ",
    meaning:
      "rách tả tơi và trông tồi tàn, do quá cũ (nói khái quát): ăn mặc rách rưới",
    example: "ăn mặc rách rưới",
  },
  {
    word: "rách việc",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) chẳng được việc gì, mà chỉ gây phiền phức rắc rối: nghe theo nó đâm ra rách việc",
    example: "nghe theo nó đâm ra rách việc",
  },
  {
    word: "radio",
    part_of_speech: "danh từ",
    meaning:
      "(cũng vô tuyến điện) phương thức truyền tín hiệu đi xa bằng sự bức xạ sóng điện từ",
    example: "nghe radio",
  },
  {
    word: "radar",
    part_of_speech: "danh từ",
    meaning:
      "máy xác định vị trí và khoảng cách của vật cần phát hiện bằng sự phản xạ của sóng radio khi gặp vật đó: trạm radar * điều khiển radar",
    example: "trạm radar * điều khiển radar",
  },
  {
    word: "rải",
    part_of_speech: "động từ",
    meaning:
      "làm cho phân tán tương đối đều khắp trên một phạm vi nhất định (thường là rộng): rải truyền đơn * rải phân xanh * mặt đường đang rải nhựa",
    example: "rải truyền đơn * rải phân xanh * mặt đường đang rải nhựa",
  },
  {
    word: "rải rác",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái phân tán ra nhiều nơi, không tập trung: dân cư sống rải rác",
    example: "dân cư sống rải rác",
  },
  {
    word: "ram",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp 500 tờ giấy hay 20 thếp giấy, làm thành đơn vị để tính số lượng giấy: in hết hai ram giấy",
    example: "in hết hai ram giấy",
  },
  {
    word: "ram",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ) nem rán: quấn ram",
    example: "quấn ram",
  },
  {
    word: "rám",
    part_of_speech: "động từ",
    meaning:
      "(da hoặc vỏ quả cây) chuyển thành màu sẫm hơn do chịu tác động của ánh nắng hay của lửa: nước da rám nắng * nắng tháng tám, rám trái bưởi (tng)",
    example: "nước da rám nắng * nắng tháng tám, rám trái bưởi (tng)",
  },
  {
    word: "rán",
    part_of_speech: "động từ",
    meaning:
      "làm cho chín thức ăn trong dầu, mỡ đun sôi: rán khoai tây * đậu rán * cá rô rán giòn",
    example: "rán khoai tây * đậu rán * cá rô rán giòn",
  },
  {
    word: "ran",
    part_of_speech: "động từ",
    meaning:
      '(âm thanh) vang lên liên tiếp và kéo dài: pháo nổ ran * cười ran * "Bốn bề sương tuyết mịt mờ, Trăng nghiêng chênh chếch, gà đà gáy ran." (ca dao)',
    example:
      'pháo nổ ran * cười ran * "Bốn bề sương tuyết mịt mờ, Trăng nghiêng chênh chếch, gà đà gáy ran." (ca dao)',
  },
  {
    word: "ran",
    part_of_speech: "động từ",
    meaning:
      "cảm thấy có một cảm giác cụ thể nào đó đang từ một vùng của cơ thể lan truyền dần dần ra khắp cả một khu vực hoặc khắp cả người: nóng ran * ngứa ran khắp người",
    example: "nóng ran * ngứa ran khắp người",
  },
  {
    word: "ram ráp",
    part_of_speech: "tính từ",
    meaning:
      "hơi ráp, không được mịn: cằm ram ráp những râu * đôi bàn tay ram ráp",
    example: "cằm ram ráp những râu * đôi bàn tay ram ráp",
  },
  {
    word: "rạn nứt",
    part_of_speech: "động từ",
    meaning: "có vết rạn (nói khái quát): tường nhà bị rạn nứt",
    example: "tường nhà bị rạn nứt",
  },
  {
    word: "rạn nứt",
    part_of_speech: "động từ",
    meaning:
      "không còn được nguyên vẹn, mà có dấu hiệu bắt đầu đã có những sự tổn thương (thường nói về quan hệ tình cảm): tình cảm hai người đã bắt đầu rạn nứt",
    example: "tình cảm hai người đã bắt đầu rạn nứt",
  },
  {
    word: "ràn",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) chuồng: ràn trâu",
    example: "ràn trâu",
  },
  {
    word: "ràn rạt",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả tiếng như tiếng khua động mạnh đều và liên tiếp trong không khí, trong nước: gió thổi ràn rạt qua các lùm cây * đàn chim đi ăn đêm ràn rạt bay qua",
    example:
      "gió thổi ràn rạt qua các lùm cây * đàn chim đi ăn đêm ràn rạt bay qua",
  },
  {
    word: "ráng",
    part_of_speech: "danh từ",
    meaning:
      'hiện tượng ánh sáng mặt trời lúc mọc hay lặn phản chiếu vào các đám mây, làm cho một khoảng trời sáng rực, nhuộm màu vàng đỏ hay hồng sẫm: ráng mỡ gà, ai có nhà thì chống (tng) * "Áo chàng đỏ tựa ráng pha, Ngựa chàng sắc trắng như là tuyết in." (CPN)',
    example:
      'ráng mỡ gà, ai có nhà thì chống (tng) * "Áo chàng đỏ tựa ráng pha, Ngựa chàng sắc trắng như là tuyết in." (CPN)',
  },
  {
    word: "ráng",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) như cố: ráng chịu đau * ráng học cho thành tài",
    example: "ráng chịu đau * ráng học cho thành tài",
  },
  {
    word: "rạn",
    part_of_speech: "danh từ",
    meaning:
      "đá ngầm ở biển, không nhô lên khỏi mặt nước: rạn san hô * thuyền va phải rạn đá",
    example: "rạn san hô * thuyền va phải rạn đá",
  },
  {
    word: "rạn",
    part_of_speech: "danh từ",
    meaning:
      "ở tình trạng không còn hoàn toàn lành lặn, mà có những chỗ hơi nứt ra thành những đường nhỏ hoặc hơi rách ra: cái cốc rạn * mặt vải đã bị rạn",
    example: "cái cốc rạn * mặt vải đã bị rạn",
  },
  {
    word: "rạn vỡ",
    part_of_speech: "động từ",
    meaning:
      "không còn nguyên vẹn, mà đã có những dấu hiệu của sự tan vỡ: hạnh phúc gia đình bị rạn vỡ",
    example: "hạnh phúc gia đình bị rạn vỡ",
  },
  {
    word: "rang",
    part_of_speech: "động từ",
    meaning:
      "làm cho chín bằng cách đảo đi đảo lại trong chảo nóng và khô: rang lạc * rang hạt tiêu * chuyện nở như ngô rang",
    example: "rang lạc * rang hạt tiêu * chuyện nở như ngô rang",
  },
  {
    word: "ran rát",
    part_of_speech: "tính từ",
    meaning: "hơi rát: ran rát ở đầu lưỡi",
    example: "ran rát ở đầu lưỡi",
  },
  {
    word: "ràng",
    part_of_speech: "động từ",
    meaning: "buộc chặt bằng nhiều vòng: ràng chặt gói hàng sau yên xe",
    example: "ràng chặt gói hàng sau yên xe",
  },
  {
    word: "rạng",
    part_of_speech: "",
    meaning:
      "(trời) chuyển dần từ tối sang sáng: rạng sáng * đêm mồng năm rạng ngày mồng sáu",
    example: "rạng sáng * đêm mồng năm rạng ngày mồng sáu",
  },
  {
    word: "rạng",
    part_of_speech: "",
    meaning:
      "ở trạng thái sáng hẳn lên: cười rạng cả khuôn mặt * đèn nhà ai, nhà ấy rạng (tng)",
    example: "cười rạng cả khuôn mặt * đèn nhà ai, nhà ấy rạng (tng)",
  },
  {
    word: "ràng buộc",
    part_of_speech: "",
    meaning:
      "đặt trong tình thế có những điều bắt buộc phải làm, trong quan hệ với người khác, khiến cho hành động mất tự do: bị lễ giáo ràng buộc * con cái là sợi dây ràng buộc giữa hai người",
    example:
      "bị lễ giáo ràng buộc * con cái là sợi dây ràng buộc giữa hai người",
  },
  {
    word: "rạng đông",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian trước lúc mặt trời mọc, lúc bầu trời ở phía đông bắt đầu hửng sáng: trời sắp rạng đông",
    example: "trời sắp rạng đông",
  },
  {
    word: "ràng rạng",
    part_of_speech: "tính từ",
    meaning: "bắt đầu hơi rạng lên: bầu trời đã ràng rạng",
    example: "bầu trời đã ràng rạng",
  },
  {
    word: "rạng rỡ",
    part_of_speech: "tính từ",
    meaning: "sáng rực rỡ: nắng ban mai rạng rỡ * nụ cười rạng rỡ",
    example: "nắng ban mai rạng rỡ * nụ cười rạng rỡ",
  },
  {
    word: "rạng rỡ",
    part_of_speech: "tính từ",
    meaning:
      "vẻ vang, được nhiều người biết đến: chiến công rạng rỡ * được rạng rỡ thân danh",
    example: "chiến công rạng rỡ * được rạng rỡ thân danh",
  },
  {
    word: "rạng rỡ",
    part_of_speech: "tính từ",
    meaning:
      "nhỏ, bé, không có tác dụng gì: mấy con gà ranh * mới ba tuổi ranh đã học đòi!",
    example: "mấy con gà ranh * mới ba tuổi ranh đã học đòi!",
  },
  {
    word: "rạng rỡ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) khôn một cách tinh quái: bé nhưng ranh lắm * nghịch ranh",
    example: "bé nhưng ranh lắm * nghịch ranh",
  },
  {
    word: "ràng rịt",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) buộc nhiều vòng chằng chéo nhau: bao gạo được ràng rịt trên yên xe",
    example: "bao gạo được ràng rịt trên yên xe",
  },
  {
    word: "rành",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) biết rõ, thạo, sành: không rành nấu ăn * chỉ biết qua loa chứ không rành * việc đó anh có rành không?",
    example:
      "không rành nấu ăn * chỉ biết qua loa chứ không rành * việc đó anh có rành không?",
  },
  {
    word: "rành",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ, hiếm) như rõ: kể rành mọi chuyện * hỏi cho rành",
    example: "kể rành mọi chuyện * hỏi cho rành",
  },
  {
    word: "rành",
    part_of_speech: "phụ từ",
    meaning:
      "chỉ thuần một loại, không có loại nào khác: bán rành hàng cao cấp * cả vườn chỉ trồng rành một loài hoa",
    example: "bán rành hàng cao cấp * cả vườn chỉ trồng rành một loài hoa",
  },
  {
    word: "rảnh",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái không có công việc gì thúc bách phải làm ngay, không bận bịu: rảnh việc * khi nào rảnh, mời bác qua nhà tôi chơi",
    example: "rảnh việc * khi nào rảnh, mời bác qua nhà tôi chơi",
  },
  {
    word: "rảnh",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) khỏi vướng víu, bận bịu: vứt luôn đi cho rảnh",
    example: "vứt luôn đi cho rảnh",
  },
  {
    word: "rãnh",
    part_of_speech: "danh từ",
    meaning:
      "đường thoát nước, dẫn nước, nhỏ hẹp và lộ thiên: khơi rãnh * đào rãnh",
    example: "khơi rãnh * đào rãnh",
  },
  {
    word: "rãnh",
    part_of_speech: "danh từ",
    meaning:
      "đường hẹp và lõm xuống trên bề mặt một số vật: mặt bàn có nhiều rãnh nhỏ",
    example: "mặt bàn có nhiều rãnh nhỏ",
  },
  {
    word: "ranh con",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) đứa trẻ tinh quái, khôn lỏi (thường dùng làm tiếng chửi, mắng): thằng ranh con!",
    example: "thằng ranh con!",
  },
  {
    word: "ranh giới",
    part_of_speech: "danh từ",
    meaning:
      "đường phân giới giữa hai bên: bức tường làm ranh giới giữa hai nhà * ranh giới giữa sự sống và cái chết",
    example:
      "bức tường làm ranh giới giữa hai nhà * ranh giới giữa sự sống và cái chết",
  },
  {
    word: "ranh ma",
    part_of_speech: "tính từ",
    meaning: "như tinh quái: bé mà đã ranh ma * toàn nghịch những trò ranh ma",
    example: "bé mà đã ranh ma * toàn nghịch những trò ranh ma",
  },
  {
    word: "rành mạch",
    part_of_speech: "tính từ",
    meaning:
      "rõ ràng từng điều, từng khoản: trả lời rành mạch * tính toán rành mạch, đâu ra đấy",
    example: "trả lời rành mạch * tính toán rành mạch, đâu ra đấy",
  },
  {
    word: "rảnh rang",
    part_of_speech: "tính từ",
    meaning:
      "rảnh, đỡ bận bịu: việc nhiều, không lúc nào được rảnh rang * đầu óc rảnh rang",
    example: "việc nhiều, không lúc nào được rảnh rang * đầu óc rảnh rang",
  },
  {
    word: "rành rành",
    part_of_speech: "tính từ",
    meaning:
      'hết sức rõ ràng, ai cũng thấy: chứng cớ rành rành * "Rủ nhau chơi khắp Long Thành, Ba mươi sáu phố rành rành chẳng sai." (ca dao)',
    example:
      'chứng cớ rành rành * "Rủ nhau chơi khắp Long Thành, Ba mươi sáu phố rành rành chẳng sai." (ca dao)',
  },
  {
    word: "ranh mãnh",
    part_of_speech: "tính từ",
    meaning: "tinh khôn và nghịch ngợm: nụ cười ranh mãnh * cặp mắt ranh mãnh",
    example: "nụ cười ranh mãnh * cặp mắt ranh mãnh",
  },
  {
    word: "rảnh rỗi",
    part_of_speech: "tính từ",
    meaning:
      "rảnh (nói khái quát): thì giờ rảnh rỗi * đọc báo những lúc rảnh rỗi",
    example: "thì giờ rảnh rỗi * đọc báo những lúc rảnh rỗi",
  },
  {
    word: "rành rẽ",
    part_of_speech: "tính từ",
    meaning: "như rành rọt: trả lời rành rẽ",
    example: "trả lời rành rẽ",
  },
  {
    word: "rành rọt",
    part_of_speech: "tính từ",
    meaning:
      "rõ ràng đến từng chi tiết một, không có chỗ nào không rõ: nói rành rọt từng câu * biết rành rọt",
    example: "nói rành rọt từng câu * biết rành rọt",
  },
  {
    word: "rào",
    part_of_speech: "danh từ",
    meaning:
      "vật dùng để ngăn lối đi, thường là để bao quanh và bảo vệ một khu vực: vượt qua rào bảo vệ * hàng rào thép gai",
    example: "vượt qua rào bảo vệ * hàng rào thép gai",
  },
  {
    word: "rào",
    part_of_speech: "động từ",
    meaning:
      "ngăn hẳn lối đi, thường là để bảo vệ một khu vực, không cho ra vào tự do: rào lối đi * ăn cây nào rào cây ấy (tng)",
    example: "rào lối đi * ăn cây nào rào cây ấy (tng)",
  },
  {
    word: "rảo",
    part_of_speech: "động từ",
    meaning:
      "đi bằng những bước nhanh, gấp và liền một mạch: rảo bước * nói xong liền rảo gót quay đi",
    example: "rảo bước * nói xong liền rảo gót quay đi",
  },
  {
    word: "rao",
    part_of_speech: "động từ",
    meaning:
      'nói to lên ở nơi công cộng hoặc đăng trên báo để cho ai cũng có thể biết: có tiếng rao hàng ngoài ngõ * "Trách người quân tử bạc tình, Chơi hoa mà nỡ bẻ cành bán rao." (Cdao)',
    example:
      'có tiếng rao hàng ngoài ngõ * "Trách người quân tử bạc tình, Chơi hoa mà nỡ bẻ cành bán rao." (Cdao)',
  },
  {
    word: "rão",
    part_of_speech: "tính từ",
    meaning:
      "bị dãn ra, lỏng ra, không còn chặt, còn chắc nữa do đã dùng quá nhiều, quá lâu: xích xe bị rão * dây chun rão",
    example: "xích xe bị rão * dây chun rão",
  },
  {
    word: "rão",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái mệt mỏi, gân cốt như lỏng ra: mệt rão người * xương cốt rão ra",
    example: "mệt rão người * xương cốt rão ra",
  },
  {
    word: "rào chắn",
    part_of_speech: "danh từ",
    meaning:
      "rào để ngăn, không cho vượt qua; dùng để ví sự trở ngại lớn khiến ngăn cách, cản trở trong việc giao lưu, thông thương: chiếc xe húc đổ rào chắn lao xuống sông * phá bỏ những rào chắn trong quan hệ thương mại giữa hai nước",
    example:
      "chiếc xe húc đổ rào chắn lao xuống sông * phá bỏ những rào chắn trong quan hệ thương mại giữa hai nước",
  },
  {
    word: "ráo",
    part_of_speech: "tính từ",
    meaning:
      'đã khô, đã hết nước: nét chữ chưa ráo mực * quạt cho ráo mồ hôi * "Vì ai nước mắt sụt sùi, Khăn lau không ráo, áo chùi không khô." (ca dao)',
    example:
      'nét chữ chưa ráo mực * quạt cho ráo mồ hôi * "Vì ai nước mắt sụt sùi, Khăn lau không ráo, áo chùi không khô." (ca dao)',
  },
  {
    word: "ráo",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) hết tất cả, không chừa một ai, một cái gì: đồ đạc, hành lí bị mất ráo * chẳng biết gì ráo",
    example: "đồ đạc, hành lí bị mất ráo * chẳng biết gì ráo",
  },
  {
    word: "rào đón",
    part_of_speech: "động từ",
    meaning:
      "nói có tính chất thăm dò để ngừa trước những sự hiểu lầm hay phản ứng không tốt về điều mình sắp nói: tính hay nói thẳng, không quen rào đón",
    example: "tính hay nói thẳng, không quen rào đón",
  },
  {
    word: "rào giậu",
    part_of_speech: "",
    meaning:
      "rào ngăn vườn, ngăn sân (nói khái quát): ngôi vườn được rào giậu cẩn thận",
    example: "ngôi vườn được rào giậu cẩn thận",
  },
  {
    word: "rào giậu ngăn sân",
    part_of_speech: "",
    meaning:
      'chỉ sự chia rẽ, ngăn cấm, không cho gặp gỡ, tiếp xúc: "Dù ai rào giậu ngăn sân, Lòng ta vẫn giữ là dân Cụ Hồ!" (THữu; 30)',
    example:
      'Dù ai rào giậu ngăn sân, Lòng ta vẫn giữ là dân Cụ Hồ!" (THữu; 30)',
  },
  {
    word: "rao giảng",
    part_of_speech: "động từ",
    meaning:
      "giảng giải, tuyên truyền ở nơi công cộng hoặc trên các phương tiện thông tin, cho mọi người đều biết (thường là những vấn đề về tôn giáo): buổi rao giảng ở nhà thờ",
    example: "buổi rao giảng ở nhà thờ",
  },
  {
    word: "ráo hoảnh",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) ráo, khô đến mức không còn, không có lấy một chút nước nào: ấm nước ráo hoảnh * miệng kêu khóc mà mắt thì ráo hoảnh",
    example: "ấm nước ráo hoảnh * miệng kêu khóc mà mắt thì ráo hoảnh",
  },
  {
    word: "ráo hoảnh",
    part_of_speech: "tính từ",
    meaning:
      "(giọng nói) tỏ ra không có lấy một chút cảm xúc, tình cảm nào, như chẳng có gì liên quan tới mình: trả lời ráo hoảnh * giọng điệu ráo hoảnh",
    example: "trả lời ráo hoảnh * giọng điệu ráo hoảnh",
  },
  {
    word: "rào rào",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng những tiếng động xen lẫn vào nhau đều đều, liên tiếp: đất đá rơi rào rào * tiếng nói chuyện nổi lên rào rào",
    example: "đất đá rơi rào rào * tiếng nói chuyện nổi lên rào rào",
  },
  {
    word: "ráo riết",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) khắt khe, không chút nhân nhượng, vì nể trong quan hệ đối xử: ăn ở ráo riết",
    example: "ăn ở ráo riết",
  },
  {
    word: "ráo riết",
    part_of_speech: "tính từ",
    meaning:
      "(làm việc gì) hết sức khẩn trương, căng thẳng một cách liên tục: truy đuổi ráo riết * chuẩn bị một cách ráo riết",
    example: "truy đuổi ráo riết * chuẩn bị một cách ráo riết",
  },
  {
    word: "rạo rực",
    part_of_speech: "động từ",
    meaning:
      "(cũ, hiếm) có cảm giác nôn nao, khó chịu trong người: rạo rực buồn nôn",
    example: "rạo rực buồn nôn",
  },
  {
    word: "rạo rực",
    part_of_speech: "động từ",
    meaning:
      "ở trạng thái có những cảm xúc, tình cảm làm xao xuyến, làm rộn lên trong lòng, như có cái gì thôi thúc, không yên: trong lòng rạo rực một niềm vui",
    example: "trong lòng rạo rực một niềm vui",
  },
  {
    word: "rào rạo",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng những vật nhỏ khô và giòn nghiến vào nhau: nhai rào rạo * bánh xe nghiến trên đường sỏi rào rạo",
    example: "nhai rào rạo * bánh xe nghiến trên đường sỏi rào rạo",
  },
  {
    word: "ráo trọi",
    part_of_speech: "trợ từ",
    meaning:
      "(phương ngữ, khẩu ngữ) hết sạch, không còn tí gì: gặp mưa, quần áo ướt ráo trọi * hành lí bị mất ráo trọi",
    example: "gặp mưa, quần áo ướt ráo trọi * hành lí bị mất ráo trọi",
  },
  {
    word: "rạp",
    part_of_speech: "danh từ",
    meaning:
      "mái, nhà dựng tạm để che mưa nắng khi có hội hè, đình đám: dựng rạp đám cưới",
    example: "dựng rạp đám cưới",
  },
  {
    word: "rạp",
    part_of_speech: "danh từ",
    meaning:
      "công trình xây dựng để làm nơi trình chiếu, biểu diễn nghệ thuật trước công chúng: rạp hát * rạp xiếc * rạp chiếu phim",
    example: "rạp hát * rạp xiếc * rạp chiếu phim",
  },
  {
    word: "rạp",
    part_of_speech: "động từ",
    meaning:
      "áp sát, gần như nằm xuống trên một bề mặt nào đó: cúi rạp * nằm rạp * bò rạp sát đất * cây cối bị đè rạp",
    example: "cúi rạp * nằm rạp * bò rạp sát đất * cây cối bị đè rạp",
  },
  {
    word: "ráp",
    part_of_speech: "động từ",
    meaning:
      "lắp, ghép lại cho khớp vào với nhau: ráp các linh kiện của máy * ráp thông tin * cố ráp các mảnh vỡ lại với nhau",
    example:
      "ráp các linh kiện của máy * ráp thông tin * cố ráp các mảnh vỡ lại với nhau",
  },
  {
    word: "ráp",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ, khẩu ngữ) tụ tập nhau lại để cùng làm một việc gì: ráp lại hỏi chuyện",
    example: "ráp lại hỏi chuyện",
  },
  {
    word: "ráp",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều nốt hoặc vết nhỏ lồi lên trên bề mặt, sờ vào thấy không mịn: mặt gỗ bào còn ráp * sờ lên mặt vải thấy ráp * bàn tay thô ráp",
    example: "mặt gỗ bào còn ráp * sờ lên mặt vải thấy ráp * bàn tay thô ráp",
  },
  {
    word: "rap",
    part_of_speech: "danh từ",
    meaning:
      "lối hát dân gian có nguồn gốc từ châu Mĩ và châu Phi, có nhạc cụ đệm, tiết tấu nhanh và hấp dẫn: nhạc rap",
    example: "nhạc rap",
  },
  {
    word: "rạp hát",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như nhà hát (ng1): đi xem ca nhạc ở rạp hát",
    example: "đi xem ca nhạc ở rạp hát",
  },
  {
    word: "rát rạt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) rất rát, rất dữ dội và dồn dập: tấn công rát rạt * nước mưa táp vào mặt đau rát rạt",
    example: "tấn công rát rạt * nước mưa táp vào mặt đau rát rạt",
  },
  {
    word: "ráp nối",
    part_of_speech: "động từ",
    meaning:
      "nối các bộ phận bằng cách đặt cho khớp vào nhau: ráp nối các linh kiện máy tính * ráp nối các tình tiết của vụ án (b)",
    example:
      "ráp nối các linh kiện máy tính * ráp nối các tình tiết của vụ án (b)",
  },
  {
    word: "rát cổ bỏng họng",
    part_of_speech: "",
    meaning:
      "nói nhiều, hò hét nhiều đến mức như cổ họng bị bỏng rát: nói rát cổ bỏng họng mà nó vẫn không nghe",
    example: "nói rát cổ bỏng họng mà nó vẫn không nghe",
  },
  {
    word: "rát",
    part_of_speech: "tính từ",
    meaning:
      "có cảm giác khó chịu ở da, như khi bị bỏng: rát như phải bỏng * rát lưỡi * gần lửa rát mặt (tng)",
    example: "rát như phải bỏng * rát lưỡi * gần lửa rát mặt (tng)",
  },
  {
    word: "rát",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) có tác động gây ra cảm giác nóng, bỏng ở da: nắng rát * mặt đường bỏng rát",
    example: "nắng rát * mặt đường bỏng rát",
  },
  {
    word: "rát",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (hoạt động nào đó) diễn ra dữ dội và dồn dập: đuổi rát phía sau * pháo địch bắn rất rát",
    example: "đuổi rát phía sau * pháo địch bắn rất rát",
  },
  {
    word: "rát mặt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ngượng mặt, xấu hổ khi điều xấu xa của mình bị vạch ra: bị mắng rát mặt * nhờ vả mãi cũng rát mặt",
    example: "bị mắng rát mặt * nhờ vả mãi cũng rát mặt",
  },
  {
    word: "rau",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi chung các thứ cây, thường thuộc loại thân cỏ, có thể dùng làm thức ăn cho người: luống rau * cuốc đất trồng rau * đói ăn rau, đau uống thuốc (tng)",
    example:
      "luống rau * cuốc đất trồng rau * đói ăn rau, đau uống thuốc (tng)",
  },
  {
    word: "rau cháo",
    part_of_speech: "danh từ",
    meaning:
      "thức ăn thường ngày của những người nghèo khổ (nói khái quát): rau cháo nuôi nhau",
    example: "rau cháo nuôi nhau",
  },
  {
    word: "rau cỏ",
    part_of_speech: "danh từ",
    meaning: "các thứ rau ăn (nói khái quát): ở vùng này, rau cỏ rất hiếm",
    example: "ở vùng này, rau cỏ rất hiếm",
  },
  {
    word: "rau dưa",
    part_of_speech: "danh từ",
    meaning:
      "thức ăn chỉ có rau và dưa; dùng để nói về cảnh ăn uống rất đạm bạc: bữa cơm rau dưa",
    example: "bữa cơm rau dưa",
  },
  {
    word: "rau đay",
    part_of_speech: "danh từ",
    meaning:
      "cây thân cỏ, lá hình trứng dài và nhọn, mép lá có răng cưa, hơi nhớt, trồng lấy ngọn để ăn: canh rau đay mồng tơi",
    example: "canh rau đay mồng tơi",
  },
  {
    word: "rau màu",
    part_of_speech: "danh từ",
    meaning:
      "rau và hoa màu, dùng làm lương thực phụ (nói khái quát): tăng diện tích rau màu * thu hoạch rau màu",
    example: "tăng diện tích rau màu * thu hoạch rau màu",
  },
  {
    word: "rau sạch",
    part_of_speech: "danh từ",
    meaning:
      "rau không chứa các yếu tố có thể gây ra tác động có hại đến sức khoẻ, do được tưới, bón, chăm sóc theo đúng tiêu chuẩn quy định: cửa hàng rau sạch * vùng chuyên trồng rau sạch",
    example: "cửa hàng rau sạch * vùng chuyên trồng rau sạch",
  },
  {
    word: "rau ráu",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng nhai vật giòn một cách ngon lành: miệng nhai rau ráu",
    example: "miệng nhai rau ráu",
  },
  {
    word: "ráy",
    part_of_speech: "danh từ",
    meaning: "chất nhờn màu vàng do ống tai ngoài tiết ra: lấy ráy tai",
    example: "lấy ráy tai",
  },
  {
    word: "ray",
    part_of_speech: "danh từ",
    meaning:
      "thanh thép hoặc sắt ghép nối lại với nhau thành hai đường thẳng song song, làm thành đường (gọi là đường ray) cho tàu hoả, xe goòng chạy: đặt ray * bánh xe chệch đường ray",
    example: "đặt ray * bánh xe chệch đường ray",
  },
  {
    word: "rắc",
    part_of_speech: "động từ",
    meaning:
      "làm cho vật có dạng hạt nhỏ rơi xuống đều khắp trên một bề mặt: rắc hạt giống * rắc phân bón cây * rắc thóc cho gà",
    example: "rắc hạt giống * rắc phân bón cây * rắc thóc cho gà",
  },
  {
    word: "rắc",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng phát ra nghe giòn và gọn như tiếng cành cây khô bị gãy: cái cột gãy đánh rắc",
    example: "cái cột gãy đánh rắc",
  },
  {
    word: "rày",
    part_of_speech: "đại từ",
    meaning:
      '(cũ, hoặc ph) nay: từ rày về sau * "Thiếp như con én lạc đàn, Phải cung, rày đã sợ làn cây cong!" (TKiều)',
    example:
      'từ rày về sau * "Thiếp như con én lạc đàn, Phải cung, rày đã sợ làn cây cong!" (TKiều)',
  },
  {
    word: "rặc",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) (nước thuỷ triều) rút xuống: con nước rặc",
    example: "con nước rặc",
  },
  {
    word: "rảy",
    part_of_speech: "động từ",
    meaning:
      "vẩy nhẹ, làm cho nước toé ra đều khắp: rẩy nước quét cho đỡ bụi * rẩy nước vào bó hoa",
    example: "rẩy nước quét cho đỡ bụi * rẩy nước vào bó hoa",
  },
  {
    word: "rày ước mai ao",
    part_of_speech: "",
    meaning:
      '(văn chương) ngày ngày ao ước, khát khao: "Những là rày ước mai ao, Mười lăm năm ấy, biết bao nhiêu tình!" (TKiều)',
    example:
      'Những là rày ước mai ao, Mười lăm năm ấy, biết bao nhiêu tình!" (TKiều)',
  },
  {
    word: "rắc rối",
    part_of_speech: "tính từ",
    meaning:
      "có mối quan hệ phức tạp giữa nhiều yếu tố, khiến cho trở nên khó hiểu, khó giải quyết: gặp chuyện rắc rối * gây rắc rối cho người khác * bài toán rắc rối quá!",
    example:
      "gặp chuyện rắc rối * gây rắc rối cho người khác * bài toán rắc rối quá!",
  },
  {
    word: "rắm",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) hơi trong ruột thoát ra qua hậu môn: đánh rắm",
    example: "đánh rắm",
  },
  {
    word: "rắn",
    part_of_speech: "danh từ",
    meaning:
      "động vật thuộc lớp bò sát, thân dài, có vảy, không chân, di chuyển bằng cách uốn thân: rắn độc * cõng rắn cắn gà nhà (tng)",
    example: "rắn độc * cõng rắn cắn gà nhà (tng)",
  },
  {
    word: "rắn",
    part_of_speech: "tính từ",
    meaning:
      "có khả năng chịu đựng được tác dụng của lực cơ học mà không bị biến dạng: rắn như đá * mềm nắn rắn buông (tng)",
    example: "rắn như đá * mềm nắn rắn buông (tng)",
  },
  {
    word: "rắn",
    part_of_speech: "tính từ",
    meaning:
      "có khả năng chịu đựng được những tác động bất lợi về tâm lí mà tinh thần, tình cảm không bị ảnh hưởng: mặt rắn đanh * tay đó rắn lắm, khó mà thuyết phục được",
    example: "mặt rắn đanh * tay đó rắn lắm, khó mà thuyết phục được",
  },
  {
    word: "rắn",
    part_of_speech: "tính từ",
    meaning:
      "(vật chất) ở trạng thái luôn luôn có hình dạng và thể tích nhất định, không tuỳ thuộc vào vật chứa: chất rắn * ở thể rắn",
    example: "chất rắn * ở thể rắn",
  },
  {
    word: "rằm",
    part_of_speech: "danh từ",
    meaning:
      "ngày thứ mười lăm trong tháng âm lịch: trăng rằm * rằm tháng giêng",
    example: "trăng rằm * rằm tháng giêng",
  },
  {
    word: "rặm",
    part_of_speech: "tính từ",
    meaning:
      "có cảm giác ngứa, xót, khó chịu do bị những vật vụn nhỏ nhưng sắc cạnh bám vào da thịt: nghịch rơm nên bị nhặm * mắt nhặm vì bụi",
    example: "nghịch rơm nên bị nhặm * mắt nhặm vì bụi",
  },
  {
    word: "rặn",
    part_of_speech: "động từ",
    meaning:
      "nín hơi, cố sức để đẩy từ trong cơ thể ra ngoài qua đường hậu môn hoặc cơ quan sinh dục: rặn đẻ",
    example: "rặn đẻ",
  },
  {
    word: "rặn",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) cố hết sức để có thể nói ra, tạo ra được, một cách gượng gạo: rặn mãi mới được một câu * rặn ra mà cười",
    example: "rặn mãi mới được một câu * rặn ra mà cười",
  },
  {
    word: "răn",
    part_of_speech: "động từ",
    meaning:
      'chỉ cho những điều sai trái và tác hại của nó để biết mà tránh làm việc xấu: tự răn mình * "Thưa rằng: bác mẹ em răn, Làm thân con gái chớ ăn trầu người." (ca dao)',
    example:
      'tự răn mình * "Thưa rằng: bác mẹ em răn, Làm thân con gái chớ ăn trầu người." (ca dao)',
  },
  {
    word: "rằn",
    part_of_speech: "tính từ",
    meaning: "có nhiều sọc khác màu: khăn rằn * tôm rằn",
    example: "khăn rằn * tôm rằn",
  },
  {
    word: "rắn cấc",
    part_of_speech: "tính từ",
    meaning: "rắn đến mức như khô cứng lại: viên kẹo rắn cấc",
    example: "viên kẹo rắn cấc",
  },
  {
    word: "răm rắp",
    part_of_speech: "tính từ",
    meaning:
      "đều một loạt như nhau: những cánh tay giơ lên đều răm rắp * quân lính đều răm rắp tuân lệnh",
    example:
      "những cánh tay giơ lên đều răm rắp * quân lính đều răm rắp tuân lệnh",
  },
  {
    word: "răn bảo",
    part_of_speech: "động từ",
    meaning: "(hiếm) như răn dạy: nghe lời răn bảo",
    example: "nghe lời răn bảo",
  },
  {
    word: "răn dạy",
    part_of_speech: "động từ",
    meaning:
      "răn và dạy bảo một cách nghiêm khắc cho biết điều hơn lẽ phải: răn dạy con cái",
    example: "răn dạy con cái",
  },
  {
    word: "rắn chắc",
    part_of_speech: "tính từ",
    meaning:
      "có khả năng chịu đựng được những tác động bất lợi từ bên ngoài mà vẫn giữ nguyên được trạng thái, tính chất (nói khái quát): đôi tay rắn chắc * thân hình rắn chắc",
    example: "đôi tay rắn chắc * thân hình rắn chắc",
  },
  {
    word: "rắn đầu rắn mặt",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ, hiếm) như rắn mặt (nhưng nghĩa mạnh hơn): cái thằng đến là rắn đầu rắn mặt!",
    example: "cái thằng đến là rắn đầu rắn mặt!",
  },
  {
    word: "rắn độc",
    part_of_speech: "danh từ",
    meaning:
      "rắn có tuyến nọc độc; cũng dùng để ví người hiểm độc: bị rắn độc cắn * đồ rắn độc! (tiếng chửi)",
    example: "bị rắn độc cắn * đồ rắn độc! (tiếng chửi)",
  },
  {
    word: "rắn mặt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (trẻ con) khó láy chuyển, bất chấp cả lời răn đe: đồ rắn mặt! * thằng bé rất rắn mặt",
    example: "đồ rắn mặt! * thằng bé rất rắn mặt",
  },
  {
    word: "rắn mày rắn mặt",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) như rắn mặt (nhưng nghĩa mạnh hơn): thằng này rắn mày rắn mặt lắm!",
    example: "thằng này rắn mày rắn mặt lắm!",
  },
  {
    word: "răn đe",
    part_of_speech: "động từ",
    meaning:
      "nói cho biết rõ điều tai hại với mục đích ngăn cấm, kèm theo ý đe doạ: trừng trị một người để răn đe những người khác",
    example: "trừng trị một người để răn đe những người khác",
  },
  {
    word: "rắn mối",
    part_of_speech: "danh từ",
    meaning:
      "(Bắc) (Nam rắn mối) động vật thuộc nhóm bò sát, thân và đuôi dài phủ vảy bóng màu nâu sẫm, bốn chi khoẻ, sống ở bờ bụi, ăn sâu bọ",
    example: "hai con thằn lằn con",
  },
  {
    word: "rằn ri",
    part_of_speech: "tính từ",
    meaning:
      "có những vệt màu khác nhau xen lẫn một cách lộn xộn, trông rối mắt: cái mũ rằn ri * bộ quần áo rằn ri",
    example: "cái mũ rằn ri * bộ quần áo rằn ri",
  },
  {
    word: "răn rắn",
    part_of_speech: "tính từ",
    meaning: "hơi rắn: chạm phải một vật răn rắn",
    example: "chạm phải một vật răn rắn",
  },
  {
    word: "rằng",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là nội dung thuyết minh điều vừa nói đến: tin rằng mọi việc sẽ tốt đẹp * tưởng rằng được yên, ai ngờ * có ý kiến rằng",
    example:
      "tin rằng mọi việc sẽ tốt đẹp * tưởng rằng được yên, ai ngờ * có ý kiến rằng",
  },
  {
    word: "rặng",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp nhiều vật cùng loại (thường là cây hoặc núi) đứng tiếp liền nhau thành dãy dài: rặng tre * mặt trời dần dần khuất sau rặng núi",
    example: "rặng tre * mặt trời dần dần khuất sau rặng núi",
  },
  {
    word: "rắn rỏi",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra có khả năng chịu đựng những tác động bất lợi từ bên ngoài mà không thay đổi thái độ: vẻ mặt rắn rỏi * một con người rắn rỏi",
    example: "vẻ mặt rắn rỏi * một con người rắn rỏi",
  },
  {
    word: "răng",
    part_of_speech: "danh từ",
    meaning:
      "phần xương cứng, màu trắng, mọc trên hàm, dùng để cắn và nhai thức ăn: răng khểnh * bé đang mọc răng * bị sâu răng",
    example: "răng khểnh * bé đang mọc răng * bị sâu răng",
  },
  {
    word: "răng",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận chìa ra, đầu thường nhọn, sắp đều nhau thành hàng trong một số đồ dùng, dụng cụ: răng lược * răng bừa",
    example: "răng lược * răng bừa",
  },
  {
    word: "răng",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ) sao: mần răng? * răng mà như rứa?",
    example: "mần răng? * răng mà như rứa?",
  },
  {
    word: "răng cưa",
    part_of_speech: "danh từ",
    meaning:
      "những phần nhọn nhô ra một cách đều đặn ở rìa một vật nào đó, trông tựa như răng của lưỡi cưa: lá răng cưa * cắt răng cưa",
    example: "lá răng cưa * cắt răng cưa",
  },
  {
    word: "rặt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) chỉ toàn một thứ, một loại, không có những thứ khác lẫn vào: mấy ngày liền chỉ ăn rặt một món * người chỉ còn rặt những xương",
    example: "mấy ngày liền chỉ ăn rặt một món * người chỉ còn rặt những xương",
  },
  {
    word: "rắp ranh",
    part_of_speech: "động từ",
    meaning:
      'định sẵn, chuẩn bị sẵn để thực hiện việc gì, thường là không tốt: rắp ranh làm phản * "Vậy nên ngảnh mặt làm thinh, Mưu cao vốn đã rắp ranh những ngày." (TKiều)',
    example:
      'rắp ranh làm phản * "Vậy nên ngảnh mặt làm thinh, Mưu cao vốn đã rắp ranh những ngày." (TKiều)',
  },
  {
    word: "rầm",
    part_of_speech: "danh từ",
    meaning:
      "thanh vật liệu cứng chắc, đặt ngang trên một số điểm tựa để đỡ các bộ phận bên trên của công trình xây dựng: rầm nhà * thay rầm cầu",
    example: "rầm nhà * thay rầm cầu",
  },
  {
    word: "rầm",
    part_of_speech: "danh từ",
    meaning:
      "từ mô phỏng tiếng động to, rền, làm rung chuyển cả xung quanh: đổ đánh rầm * đại bác nổ rầm trời",
    example: "đổ đánh rầm * đại bác nổ rầm trời",
  },
  {
    word: "rầm",
    part_of_speech: "danh từ",
    meaning: "ồn ào náo động cả xung quanh: đồn rầm lên * quát tháo rầm nhà",
    example: "đồn rầm lên * quát tháo rầm nhà",
  },
  {
    word: "rắp",
    part_of_speech: "động từ",
    meaning:
      '(hiếm) toan (làm việc gì): "Giương cung rắp bắn phượng hoàng, Chẳng may lại gặp một đàn chim ri." (ca dao)',
    example:
      'Giương cung rắp bắn phượng hoàng, Chẳng may lại gặp một đàn chim ri." (ca dao)',
  },
  {
    word: "rấm",
    part_of_speech: "động từ",
    meaning:
      "ủ cho chóng chín hay chóng mọc mầm: rấm thóc giống * rấm chuối * rấm bằng đất đèn",
    example: "rấm thóc giống * rấm chuối * rấm bằng đất đèn",
  },
  {
    word: "rấm",
    part_of_speech: "động từ",
    meaning: "ủ bếp để giữ lửa: rấm lò",
    example: "rấm lò",
  },
  {
    word: "rấm",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) chuẩn bị trước, nhắm trước một cách kín đáo cho một việc gì đó: rấm sẵn cho cậu con trai một đám",
    example: "rấm sẵn cho cậu con trai một đám",
  },
  {
    word: "rắp tâm",
    part_of_speech: "động từ",
    meaning:
      "nuôi ý định và quyết làm bằng được việc nào đó (thường là việc xấu): rắp tâm phá hoại * rắp tâm hại người",
    example: "rắp tâm phá hoại * rắp tâm hại người",
  },
  {
    word: "râm",
    part_of_speech: "tính từ",
    meaning:
      "không có ánh nắng, do có mây hoặc có vật nào đó che ánh mặt trời: bóng râm * chơi ở chỗ râm",
    example: "bóng râm * chơi ở chỗ râm",
  },
  {
    word: "răng rắc",
    part_of_speech: "tính từ",
    meaning: "như rắc (nhưng với ý liên tiếp): cành cây gãy răng rắc",
    example: "cành cây gãy răng rắc",
  },
  {
    word: "rắp định",
    part_of_speech: "động từ",
    meaning:
      '(cũ) định sẵn, rắp tâm sẵn: "Trăng lên phỏng độ nhường bao, Đào non rắp định nơi nao bây giờ?" (ca dao)',
    example:
      'Trăng lên phỏng độ nhường bao, Đào non rắp định nơi nao bây giờ?" (ca dao)',
  },
  {
    word: "rậm",
    part_of_speech: "tính từ",
    meaning:
      "(cây cối, sợi, lông, v.v.) có rất nhiều, đan chen và phủ kín một vùng, một mảng: rừng rậm * bụi rậm * tóc để rậm",
    example: "rừng rậm * bụi rậm * tóc để rậm",
  },
  {
    word: "rậm rạp",
    part_of_speech: "tính từ",
    meaning: "rậm (nói khái quát): cây cối rậm rạp",
    example: "cây cối rậm rạp",
  },
  {
    word: "rầm rập",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng như tiếng chân bước nhanh, mạnh, dồn dập của cả một đoàn người: quân đi rầm rập * xe cộ chạy rầm rập suốt đêm",
    example: "quân đi rầm rập * xe cộ chạy rầm rập suốt đêm",
  },
  {
    word: "rầm rầm rộ rộ",
    part_of_speech: "tính từ",
    meaning:
      "rất rầm rộ, với khí thế hừng hực của số đông người: đoàn người rầm rầm rộ rộ kéo nhau đi",
    example: "đoàn người rầm rầm rộ rộ kéo nhau đi",
  },
  {
    word: "râm bụt",
    part_of_speech: "danh từ",
    meaning:
      'cây nhỡ, mép lá có răng cưa, hoa to, màu đỏ hoặc vàng, nhị hoa dính liền nhau thành một ống dài ở giữa, thường trồng làm cảnh hay làm hàng rào: hàng rào râm bụt * "Có đỏ mà chẳng có thơm, Như hoa râm bụt nên cơm cháo gì!" (ca dao)',
    example:
      'hàng rào râm bụt * "Có đỏ mà chẳng có thơm, Như hoa râm bụt nên cơm cháo gì!" (ca dao)',
  },
  {
    word: "rầm rầm",
    part_of_speech: "tính từ",
    meaning: "như rầm (nhưng ý liên tiếp): cười nói rầm rầm",
    example: "cười nói rầm rầm",
  },
  {
    word: "rầm rầm",
    part_of_speech: "phụ từ",
    meaning:
      '(diễn ra) với tốc độ cao và liên tục, như không thể dừng, không thể ngăn nổi: "Vai mang túi bạc kè kè, Nói quấy nói quá người nghe rầm rầm." (ca dao)',
    example:
      'Vai mang túi bạc kè kè, Nói quấy nói quá người nghe rầm rầm." (ca dao)',
  },
  {
    word: "râm ran",
    part_of_speech: "tính từ",
    meaning:
      "(nhiều tiếng cười nói hay tiếng kêu) hoà vào nhau rộn rã: cười nói râm ran * ve kêu râm ran",
    example: "cười nói râm ran * ve kêu râm ran",
  },
  {
    word: "râm ran",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái cảm thấy có một cảm giác nào đó như đang dần dần lan truyền rộng ra khắp cơ thể hoặc bộ phận cơ thể: ngứa râm ran khắp người",
    example: "ngứa râm ran khắp người",
  },
  {
    word: "rậm rật",
    part_of_speech: "động từ",
    meaning:
      "cảm thấy có nhu cầu phải hoạt động do một đòi hỏi thôi thúc từ bên trong của cơ thể: chân tay rậm rật muốn chạy nhảy * thấy rậm rật trong người",
    example: "chân tay rậm rật muốn chạy nhảy * thấy rậm rật trong người",
  },
  {
    word: "rầm rì",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như rì rầm: tiếng nói chuyện rầm rì",
    example: "tiếng nói chuyện rầm rì",
  },
  {
    word: "rầm rĩ",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như ầm ĩ: kêu khóc rầm rĩ * chưa chi đã làm rầm rĩ lên",
    example: "kêu khóc rầm rĩ * chưa chi đã làm rầm rĩ lên",
  },
  {
    word: "rậm rì",
    part_of_speech: "tính từ",
    meaning:
      "rậm đến mức như chỉ còn thấy một khối dày đặc: bụi cây gai rậm rì * râu ria rậm rì",
    example: "bụi cây gai rậm rì * râu ria rậm rì",
  },
  {
    word: "rậm rịt",
    part_of_speech: "tính từ",
    meaning: "rậm và nhằng nhịt vào nhau: lau sậy mọc rậm rịt hai bên bờ sông",
    example: "lau sậy mọc rậm rịt hai bên bờ sông",
  },
  {
    word: "rấm rứt",
    part_of_speech: "tính từ",
    meaning: "(khóc) nhỏ, khẽ, nhưng kéo dài, mãi không thôi: khóc rấm rứt",
    example: "khóc rấm rứt",
  },
  {
    word: "rầm rộ",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả vẻ hoạt động mạnh mẽ, có khí thế của một số đông lôi cuốn nhau: từng đoàn người rầm rộ kéo tới * tấn công rầm rộ",
    example: "từng đoàn người rầm rộ kéo tới * tấn công rầm rộ",
  },
  {
    word: "rậm rịch",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả những tiếng động trầm, nặng, liên tục, nhưng không đều, do hoạt động khẩn trương, nhưng không ồn ào của nhiều người: rậm rịch giã gạo * tiếng chân bước rậm rịch ngoài ngõ",
    example: "rậm rịch giã gạo * tiếng chân bước rậm rịch ngoài ngõ",
  },
  {
    word: "rậm rịch",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) như rục rịch (ng1): rậm rịch làm nhà * rậm rịch cưới vợ",
    example: "rậm rịch làm nhà * rậm rịch cưới vợ",
  },
  {
    word: "rân",
    part_of_speech: "động từ",
    meaning: "như ran: cười rân * mặt đỏ rân",
    example: "cười rân * mặt đỏ rân",
  },
  {
    word: "rân rấn",
    part_of_speech: "động từ",
    meaning: "(nước mắt) ứa ra một ít trong tròng mắt: rân rấn nước mắt",
    example: "rân rấn nước mắt",
  },
  {
    word: "rần rần",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) rầm rầm: súng nổ rần rần",
    example: "súng nổ rần rần",
  },
  {
    word: "rần rật",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) từ gợi tả những tiếng động to nối tiếp nhau với một nhịp nhanh, mạnh, gấp: gió rần rật * tiếng chân rần rật suốt đêm",
    example: "gió rần rật * tiếng chân rần rật suốt đêm",
  },
  {
    word: "rần rật",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái đang bừng bừng và lan toả ra mạnh mẽ: lửa cháy rần rật * khắp người rần rật niềm vui sướng",
    example: "lửa cháy rần rật * khắp người rần rật niềm vui sướng",
  },
  {
    word: "rấp",
    part_of_speech: "động từ",
    meaning:
      '(khẩu ngữ) ngăn lối đi một cách tạm bợ bằng cành rào, cành gai: rấp cổng * "Đất bằng bỗng rấp chông gai, Ai đem nhân ảnh nhuốm mùi tà dương." (CO)',
    example:
      'rấp cổng * "Đất bằng bỗng rấp chông gai, Ai đem nhân ảnh nhuốm mùi tà dương." (CO)',
  },
  {
    word: "rấp",
    part_of_speech: "động từ",
    meaning:
      'gặp phải liên tiếp (điều không hay): "Anh hùng rấp phải khúc lươn, Khi quấn thì ngắn khi vươn thì dài." (ca dao)',
    example:
      'Anh hùng rấp phải khúc lươn, Khi quấn thì ngắn khi vươn thì dài." (ca dao)',
  },
  {
    word: "rấp",
    part_of_speech: "động từ",
    meaning: "(hiếm) rủi, không may: mới đầu năm đã rấp * gặp rấp",
    example: "mới đầu năm đã rấp * gặp rấp",
  },
  {
    word: "rất chi là",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) như rất (nhưng nghĩa mạnh hơn): rất chi là may mắn * sống rất chi là sòng phẳng",
    example: "rất chi là may mắn * sống rất chi là sòng phẳng",
  },
  {
    word: "rập khuôn",
    part_of_speech: "động từ",
    meaning:
      "làm theo một kiểu có sẵn nào đó một cách máy móc mà không suy nghĩ, sáng tạo để vận dụng sao cho thích hợp: suy nghĩ rập khuôn * bắt chước một cách rập khuôn",
    example: "suy nghĩ rập khuôn * bắt chước một cách rập khuôn",
  },
  {
    word: "rập rờn",
    part_of_speech: "",
    meaning:
      "chuyển động lúc lên lúc xuống, lúc ẩn lúc hiện, lúc gần lúc xa nối tiếp nhau liên tiếp và nhịp nhàng: ánh lửa dập dờn trong đêm",
    example: "ánh lửa dập dờn trong đêm",
  },
  {
    word: "rập rình",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) muốn làm nhưng còn lưỡng lự, chờ cơ hội: rập rình mãi rồi lại không làm",
    example: "rập rình mãi rồi lại không làm",
  },
  {
    word: "rập rình",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả tiếng nhạc nhịp nhàng, khi trầm khi bổng: tiếng nhạc rập rình",
    example: "tiếng nhạc rập rình",
  },
  {
    word: "rập rình",
    part_of_speech: "tính từ",
    meaning: "t hoặc đg như dập dềnh: bè nứa rập rình trên mặt sông",
    example: "bè nứa rập rình trên mặt sông",
  },
  {
    word: "rất",
    part_of_speech: "phụ từ",
    meaning:
      "ở mức độ cao, trên hẳn mức bình thường: cô bé học rất giỏi * cười rất có duyên * tính rất thẳng * rất ghét người hay nói dối",
    example:
      "cô bé học rất giỏi * cười rất có duyên * tính rất thẳng * rất ghét người hay nói dối",
  },
  {
    word: "rập ràng",
    part_of_speech: "tính từ",
    meaning:
      '(phương ngữ) nhịp nhàng: "Hai bên đứng lại hai hàng, Người mũi, kẻ lái rập ràng cho mau." (ca dao)',
    example:
      'Hai bên đứng lại hai hàng, Người mũi, kẻ lái rập ràng cho mau." (ca dao)',
  },
  {
    word: "rập",
    part_of_speech: "động từ",
    meaning:
      "phỏng theo, làm hoàn toàn giống với một cái mẫu có sẵn: rập cùng một khuôn * rập theo mẫu của nước ngoài",
    example: "rập cùng một khuôn * rập theo mẫu của nước ngoài",
  },
  {
    word: "rập",
    part_of_speech: "động từ",
    meaning:
      "(nhiều người) làm việc gì cùng một lúc và cùng một kiểu, hoàn toàn giống nhau, khớp với nhau: cùng hô rập một tiếng",
    example: "cùng hô rập một tiếng",
  },
  {
    word: "rất đỗi",
    part_of_speech: "phụ từ",
    meaning:
      "đến mức được đánh giá là hết sức, không thể hơn: rất đỗi ngạc nhiên * một gương mặt rất đỗi quen thuộc",
    example: "rất đỗi ngạc nhiên * một gương mặt rất đỗi quen thuộc",
  },
  {
    word: "rất mực",
    part_of_speech: "phụ từ",
    meaning:
      "đến mức dường như không thể hơn được nữa: một người mẹ rất mực thương con * rất mực khiêm tốn",
    example: "một người mẹ rất mực thương con * rất mực khiêm tốn",
  },
  {
    word: "rầu",
    part_of_speech: "tính từ",
    meaning:
      'buồn bã đến mức héo hon: nghĩ mà rầu cả ruột * "Cây rầu thì lá cũng rầu, Anh về anh để mối sầu cho ai?" (ca dao)',
    example:
      'nghĩ mà rầu cả ruột * "Cây rầu thì lá cũng rầu, Anh về anh để mối sầu cho ai?" (ca dao)',
  },
  {
    word: "râu",
    part_of_speech: "danh từ",
    meaning:
      "lông cứng mọc ở cằm và phía trên môi trên, thường ở đàn ông hoặc ở một số loài động vật: cạo râu * vuốt râu hùm (tng)",
    example: "cạo râu * vuốt râu hùm (tng)",
  },
  {
    word: "râu",
    part_of_speech: "danh từ",
    meaning:
      "cơ quan xúc giác, hình râu, mọc ở đầu một số sâu bọ, tôm, cá: râu tôm * râu cá chép",
    example: "râu tôm * râu cá chép",
  },
  {
    word: "râu",
    part_of_speech: "danh từ",
    meaning: "bộ phận của hoa ở một số cây: râu ngô",
    example: "râu ngô",
  },
  {
    word: "rầu rầu",
    part_of_speech: "tính từ",
    meaning:
      '(nét mặt, giọng nói, v.v.) lộ rõ vẻ buồn bã, rầu rĩ: giọng rầu rầu * "Thương ai nét mặt rầu rầu, Lược ngà không chải, gương tàu không soi." (ca dao)',
    example:
      'giọng rầu rầu * "Thương ai nét mặt rầu rầu, Lược ngà không chải, gương tàu không soi." (ca dao)',
  },
  {
    word: "rầu rĩ",
    part_of_speech: "tính từ",
    meaning:
      'có vẻ bên ngoài biểu lộ tâm trạng buồn bã, đau khổ: vẻ mặt rầu rĩ * giọng rầu rĩ * "Vì sương cho núi bạc đầu, Vì đâu mưa nắng cho rầu rĩ hoa." (ca dao)',
    example:
      'vẻ mặt rầu rĩ * giọng rầu rĩ * "Vì sương cho núi bạc đầu, Vì đâu mưa nắng cho rầu rĩ hoa." (ca dao)',
  },
  {
    word: "rẫy",
    part_of_speech: "danh từ",
    meaning:
      "đất trồng trọt ở vùng rừng núi, có được bằng cách phá rừng, đốt cây rồi trồng tỉa: phát rẫy * đi lên rẫy * làm rẫy",
    example: "phát rẫy * đi lên rẫy * làm rẫy",
  },
  {
    word: "rẫy",
    part_of_speech: "động từ",
    meaning:
      'ruồng bỏ một cách không thương tiếc, coi như không hề có quan hệ và trách nhiệm gì với nhau nữa (thường nói về quan hệ vợ chồng): "Mèo lành ai nỡ cắt tai, Gái kia chồng rẫy khoe tài gì em?" (Cdao)',
    example:
      'Mèo lành ai nỡ cắt tai, Gái kia chồng rẫy khoe tài gì em?" (Cdao)',
  },
  {
    word: "râu ria",
    part_of_speech: "danh từ",
    meaning: "râu của người (nói khái quát): râu ria lởm chởm",
    example: "râu ria lởm chởm",
  },
  {
    word: "râu ria",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) những cái phụ, cái thứ yếu, không quan trọng (nói tổng quát): chuyện râu ria",
    example: "chuyện râu ria",
  },
  {
    word: "rây",
    part_of_speech: "động từ",
    meaning:
      "cho chất đã tán vụn vào rây rồi lắc đều, làm cho chất lỏng hay những hạt nhỏ nhất rơi xuống để lấy riêng ra: rây bột",
    example: "rây bột",
  },
  {
    word: "rẩy",
    part_of_speech: "động từ",
    meaning:
      "vẩy nhẹ, làm cho nước toé ra đều khắp: rẩy nước quét cho đỡ bụi * rẩy nước vào bó hoa",
    example: "rẩy nước quét cho đỡ bụi * rẩy nước vào bó hoa",
  },
  {
    word: "rầy",
    part_of_speech: "danh từ",
    meaning: "bọ rầy (nói tắt): phun thuốc trừ rầy hại lúa",
    example: "phun thuốc trừ rầy hại lúa",
  },
  {
    word: "rầy",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có nhiều yếu tố khiến cho sinh nhiều chuyện phải bận lòng: làm vậy thì rầy cho anh quá! * bây giờ mà ốm thì rầy to!",
    example: "làm vậy thì rầy cho anh quá! * bây giờ mà ốm thì rầy to!",
  },
  {
    word: "rẫy chết",
    part_of_speech: "động từ",
    meaning:
      "giãy giụa mạnh trước khi chết: con cá giãy chết * chủ nghĩa đế quốc đang hồi giãy chết (b)",
    example: "con cá giãy chết * chủ nghĩa đế quốc đang hồi giãy chết (b)",
  },
  {
    word: "rầy rà",
    part_of_speech: "tính từ",
    meaning:
      "rầy, gây khó khăn, rắc rối (nói khái quát): gặp chuyện rầy rà * chuyện mà vỡ lở thì rầy rà lắm!",
    example: "gặp chuyện rầy rà * chuyện mà vỡ lở thì rầy rà lắm!",
  },
  {
    word: "rầy la",
    part_of_speech: "động từ",
    meaning: "trách mắng, tỏ ý không bằng lòng: bị rầy la suốt ngày",
    example: "bị rầy la suốt ngày",
  },
  {
    word: "rẽ",
    part_of_speech: "động từ",
    meaning:
      "tách ra, gạt sang hai bên, tạo thành một khoảng trống ở giữa: rẽ ngôi lệch * tàu rẽ sóng ra khơi * rẽ vạt cỏ",
    example: "rẽ ngôi lệch * tàu rẽ sóng ra khơi * rẽ vạt cỏ",
  },
  {
    word: "rẽ",
    part_of_speech: "động từ",
    meaning: "đi ngoặt sang đường khác: rẽ tay trái * đã đến chỗ rẽ",
    example: "rẽ tay trái * đã đến chỗ rẽ",
  },
  {
    word: "rẽ",
    part_of_speech: "động từ",
    meaning:
      "tách ra một phần sản phẩm, một phần lợi thu được để nộp cho người chủ của tư liệu sản xuất (một hình thức bị bóc lột thời trước): làm rẽ * nuôi rẽ bò * cấy rẽ",
    example: "làm rẽ * nuôi rẽ bò * cấy rẽ",
  },
  {
    word: "ré",
    part_of_speech: "danh từ",
    meaning: "thứ lúa mùa hạt nhỏ, nấu ngon cơm: cơm gạo ré",
    example: "cơm gạo ré",
  },
  {
    word: "ré",
    part_of_speech: "động từ",
    meaning: "(voi) kêu: tiếng voi ré",
    example: "tiếng voi ré",
  },
  {
    word: "ré",
    part_of_speech: "động từ",
    meaning:
      "phát ra tiếng kêu to, rít lên đột ngột, nghe chói tai: từng hồi còi ré lên * ré lên cười * đứa bé giật mình, khóc ré lên",
    example:
      "từng hồi còi ré lên * ré lên cười * đứa bé giật mình, khóc ré lên",
  },
  {
    word: "rè",
    part_of_speech: "tính từ",
    meaning:
      "có tiếng rung của những âm pha tạp lẫn vào, nghe không trong: loa rè * chuông rè",
    example: "loa rè * chuông rè",
  },
  {
    word: "rẻ mạt",
    part_of_speech: "tính từ",
    meaning:
      "rẻ quá mức, gần như không có giá trị gì: tiền công rẻ mạt * bán với giá rất rẻ mạt",
    example: "tiền công rẻ mạt * bán với giá rất rẻ mạt",
  },
  {
    word: "rẻ",
    part_of_speech: "danh từ",
    meaning:
      "vật có hình giống như một nan trong tập hợp các nan quạt được xoè rộng ra (làm thành hình gọi là hình rẻ quạt): rẻ sườn",
    example: "rẻ sườn",
  },
  {
    word: "rẻ",
    part_of_speech: "tính từ",
    meaning:
      "có giá thấp hơn mức bình thường: mua với giá rẻ * rẻ như bèo * ham của rẻ",
    example: "mua với giá rẻ * rẻ như bèo * ham của rẻ",
  },
  {
    word: "rẻ",
    part_of_speech: "tính từ",
    meaning:
      "có giá trị thấp hơn nhiều so với giá trị thực: xem rẻ đồng tiền * coi rẻ nhau",
    example: "xem rẻ đồng tiền * coi rẻ nhau",
  },
  {
    word: "rẽ ràng",
    part_of_speech: "tính từ",
    meaning:
      "(làm việc gì, thường là nói năng) nhẹ nhàng, khoan thai và rõ ràng: nói rẽ ràng * trình bày lại một cách rẽ ràng",
    example: "nói rẽ ràng * trình bày lại một cách rẽ ràng",
  },
  {
    word: "rẽ rọt",
    part_of_speech: "tính từ",
    meaning: "(hiếm) (nói) rõ từng tiếng và vừa đủ nghe: giọng nói rẽ rọt",
    example: "giọng nói rẽ rọt",
  },
  {
    word: "rẻ rề",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ, khẩu ngữ) rất rẻ: cà chua giữa vụ rẻ rề",
    example: "cà chua giữa vụ rẻ rề",
  },
  {
    word: "rẻ quạt",
    part_of_speech: "danh từ",
    meaning:
      "hình các nan quạt xoè rộng ra: hình rẻ quạt * ánh nắng xuyên qua kẽ lá như rẻ quạt",
    example: "hình rẻ quạt * ánh nắng xuyên qua kẽ lá như rẻ quạt",
  },
  {
    word: "rẻ rúng",
    part_of_speech: "động từ",
    meaning:
      'coi rẻ, xem thường, đối xử như đối với một vật vô giá trị: bị bạn bè rẻ rúng * "Trong khi chắp cánh liền cành, Mà lòng rẻ rúng đã dành một bên!" (TKiều)',
    example:
      'bị bạn bè rẻ rúng * "Trong khi chắp cánh liền cành, Mà lòng rẻ rúng đã dành một bên!" (TKiều)',
  },
  {
    word: "rén",
    part_of_speech: "phụ từ",
    meaning:
      "một cách rất nhẹ, rất khẽ, cố giữ để không gây ra tiếng động: rén bước vào nhà",
    example: "rén bước vào nhà",
  },
  {
    word: "rẻ thối",
    part_of_speech: "tính từ",
    meaning:
      "(thông tục) rất rẻ, hoàn toàn không đáng kể: rau giữa vụ nên rẻ thối * giá cả rẻ thối",
    example: "rau giữa vụ nên rẻ thối * giá cả rẻ thối",
  },
  {
    word: "ren",
    part_of_speech: "danh từ",
    meaning:
      "đồ mĩ nghệ đan, móc hay dệt bằng chỉ, sợi, tạo thành những hình trang trí đẹp mắt: gấu áo có đường ren * hàng ren * đặt tấm ren xuống dưới kính",
    example: "gấu áo có đường ren * hàng ren * đặt tấm ren xuống dưới kính",
  },
  {
    word: "ren",
    part_of_speech: "danh từ",
    meaning:
      "rãnh xoắn ốc sít liền nhau trên các vật hoặc chi tiết máy hình trụ tròn hoặc hình nón: đinh ốc bị chờn ren",
    example: "đinh ốc bị chờn ren",
  },
  {
    word: "ren",
    part_of_speech: "động từ",
    meaning: "tạo thành ren, làm cho có ren: ren ống nước",
    example: "ren ống nước",
  },
  {
    word: "rẻ tiền",
    part_of_speech: "tính từ",
    meaning:
      "rẻ, không đáng bao nhiêu tiền: đồ chơi rẻ tiền * lần vải lót là loại vải rẻ tiền",
    example: "đồ chơi rẻ tiền * lần vải lót là loại vải rẻ tiền",
  },
  {
    word: "rẻ tiền",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) không có giá trị, không đáng được coi trọng: những lí luận rẻ tiền * không đọc loại tiểu thuyết yêu đương rẻ tiền",
    example:
      "những lí luận rẻ tiền * không đọc loại tiểu thuyết yêu đương rẻ tiền",
  },
  {
    word: "rèn",
    part_of_speech: "động từ",
    meaning:
      "đập khối kim loại đã nung mềm để làm thành đồ dùng: rèn con dao * thợ rèn",
    example: "rèn con dao * thợ rèn",
  },
  {
    word: "rèn",
    part_of_speech: "động từ",
    meaning:
      "luyện cho có được và ở mức thuần thục những thói quen, đức tính tốt: rèn tay nghề * rèn tính nhẫn nại",
    example: "rèn tay nghề * rèn tính nhẫn nại",
  },
  {
    word: "rèm",
    part_of_speech: "danh từ",
    meaning:
      'vật hình tấm, bằng vải hoặc đan bằng tre, trúc, dùng để che và trang trí ở cửa: rèm cửa * buông rèm * "Đêm qua nằm trọ nhà hàng, Rèm thưa gió lọt lòng càng nhớ thương." (ca dao)',
    example:
      'rèm cửa * buông rèm * "Đêm qua nằm trọ nhà hàng, Rèm thưa gió lọt lòng càng nhớ thương." (ca dao)',
  },
  {
    word: "rẽ thuý chia uyên",
    part_of_speech: "",
    meaning:
      '(cũ, văn chương) chia rẽ lứa đôi, làm cho phải lìa nhau: "Chước đâu rẽ thuý, chia uyên, Đã ra đường nấy, ai nhìn được ai!" (TKiều)',
    example:
      'Chước đâu rẽ thuý, chia uyên, Đã ra đường nấy, ai nhìn được ai!" (TKiều)',
  },
  {
    word: "rèn cặp",
    part_of_speech: "động từ",
    meaning:
      "chỉ bảo, uốn nắn một cách sát sao để tiến bộ hơn: rèn cặp con cái * rèn cặp cho thành tài",
    example: "rèn cặp con cái * rèn cặp cho thành tài",
  },
  {
    word: "rèn luyện",
    part_of_speech: "động từ",
    meaning:
      "luyện tập một cách thường xuyên để đạt tới những phẩm chất hay trình độ ở một mức nào đó: rèn luyện thân thể * rèn luyện đạo đức * có ý thức rèn luyện",
    example: "rèn luyện thân thể * rèn luyện đạo đức * có ý thức rèn luyện",
  },
  {
    word: "rèn giũa",
    part_of_speech: "động từ",
    meaning:
      "rèn luyện, dạy dỗ rất cẩn thận, nghiêm khắc: được rèn giũa trong quân đội * rèn giũa con cái",
    example: "được rèn giũa trong quân đội * rèn giũa con cái",
  },
  {
    word: "reng reng",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng âm thanh như tiếng chuông rung liên tục thành hồi dài và nhanh: chuông xe đạp kêu reng reng",
    example: "chuông xe đạp kêu reng reng",
  },
  {
    word: "ren rén",
    part_of_speech: "phụ từ",
    meaning:
      'như rén (nhưng ý mức độ nhiều hơn): "Mai sinh ren rén bước vào, Nửa mừng nửa sợ biết bao là tình." (NĐM)',
    example:
      'Mai sinh ren rén bước vào, Nửa mừng nửa sợ biết bao là tình." (NĐM)',
  },
  {
    word: "réo",
    part_of_speech: "động từ",
    meaning:
      "kêu, gọi từ xa bằng những tiếng cao giọng, gay gắt, kéo dài: lũ trẻ réo ầm nhà * réo cả tên tục của người ta ra mà chửi",
    example: "lũ trẻ réo ầm nhà * réo cả tên tục của người ta ra mà chửi",
  },
  {
    word: "réo",
    part_of_speech: "động từ",
    meaning:
      "phát ra tiếng nghe như tiếng réo: còi tàu réo vang * chuông điện thoại réo",
    example: "còi tàu réo vang * chuông điện thoại réo",
  },
  {
    word: "rẻo",
    part_of_speech: "danh từ",
    meaning:
      "miếng nhỏ, thường dài và hẹp, được cắt xén ra từ một mảnh vải, giấy, v.v.: chỉ còn thừa một rẻo vải nhỏ * xin những rẻo giấy thừa về nhóm bếp",
    example:
      "chỉ còn thừa một rẻo vải nhỏ * xin những rẻo giấy thừa về nhóm bếp",
  },
  {
    word: "rẻo",
    part_of_speech: "danh từ",
    meaning: "miếng đất dài, hẹp: rẻo đất cạnh bờ sông",
    example: "rẻo đất cạnh bờ sông",
  },
  {
    word: "rẻo",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) men theo, đi dọc theo một lượt: rẻo một vòng quanh xóm * rẻo bước ra vườn hóng gió",
    example: "rẻo một vòng quanh xóm * rẻo bước ra vườn hóng gió",
  },
  {
    word: "reo",
    part_of_speech: "động từ",
    meaning: "kêu lên tỏ sự vui mừng, phấn khởi: đám trẻ được quà, reo ầm ĩ",
    example: "đám trẻ được quà, reo ầm ĩ",
  },
  {
    word: "reo",
    part_of_speech: "động từ",
    meaning:
      "phát ra chuỗi âm thanh liên tục, đều đều: thông reo trong gió * chuông điện thoại reo * ấm nước mới reo, chưa sôi",
    example:
      "thông reo trong gió * chuông điện thoại reo * ấm nước mới reo, chưa sôi",
  },
  {
    word: "reo hò",
    part_of_speech: "động từ",
    meaning: "như hò reo: tiếng reo hò ầm ĩ",
    example: "tiếng reo hò ầm ĩ",
  },
  {
    word: "réo rắt",
    part_of_speech: "tính từ",
    meaning:
      '(âm thanh, thường là tiếng nhạc) cao và thanh, lúc to lúc nhỏ, lúc nhanh lúc chậm: tiếng đàn réo rắt * "Con chim khôn chết mệt về mồi, Nó kêu réo rắt ghẹo người tình chung." (Cdao)',
    example:
      'tiếng đàn réo rắt * "Con chim khôn chết mệt về mồi, Nó kêu réo rắt ghẹo người tình chung." (Cdao)',
  },
  {
    word: "rẻo cao",
    part_of_speech: "danh từ",
    meaning:
      "vùng trên núi cao có những rẻo đất trồng trọt: mùa xuân về trên rẻo cao",
    example: "mùa xuân về trên rẻo cao",
  },
  {
    word: "rét buốt",
    part_of_speech: "tính từ",
    meaning: "rét đến mức như thấm sâu vào tận xương tuỷ: đêm đông rét buốt",
    example: "đêm đông rét buốt",
  },
  {
    word: "rét",
    part_of_speech: "tính từ",
    meaning:
      "(thời tiết) có nhiệt độ thấp đến mức cơ thể cảm thấy khó chịu: trời trở rét * mùa đông năm nay rét hơn năm ngoái",
    example: "trời trở rét * mùa đông năm nay rét hơn năm ngoái",
  },
  {
    word: "rét",
    part_of_speech: "tính từ",
    meaning:
      "có cảm giác lạnh trong người, thường khiến cho phải run lên: rét run người * mặc bao nhiêu áo rồi mà vẫn thấy rét",
    example: "rét run người * mặc bao nhiêu áo rồi mà vẫn thấy rét",
  },
  {
    word: "rét mướt",
    part_of_speech: "tính từ",
    meaning:
      "rét và có mưa kéo dài (nói khái quát): mưa gió rét mướt * trời rét mướt",
    example: "mưa gió rét mướt * trời rét mướt",
  },
  {
    word: "rễ",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận của cây, thường đâm sâu xuống đất, giữ cho cây đứng thẳng và hút chất dinh dưỡng nuôi cây: lúa đã bén rễ * cây đâm rễ",
    example: "lúa đã bén rễ * cây đâm rễ",
  },
  {
    word: "rê",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) bánh (thuốc lào, thuốc lá sợi): mua mấy rê thuốc để hút dần",
    example: "mua mấy rê thuốc để hút dần",
  },
  {
    word: "rê",
    part_of_speech: "động từ",
    meaning:
      "kéo lê hoặc trượt dài trên mặt nền: mỏ neo bị kéo rê trên nền cát * xe rê bánh trên mặt đường lầy lội",
    example:
      "mỏ neo bị kéo rê trên nền cát * xe rê bánh trên mặt đường lầy lội",
  },
  {
    word: "rê",
    part_of_speech: "động từ",
    meaning:
      "di chuyển đều đều, liên tục trên bề mặt hay theo phương nằm ngang: rê bóng rất khéo * thao tác rê chuột trên màn hình",
    example: "rê bóng rất khéo * thao tác rê chuột trên màn hình",
  },
  {
    word: "rê",
    part_of_speech: "động từ",
    meaning:
      "làm sạch thóc bằng cách đổ cho thóc rơi chậm và đều từ trên cao xuống trước gió, cho những hạt lép, trấu, bụi bay đi: rê thóc",
    example: "rê thóc",
  },
  {
    word: "rể",
    part_of_speech: "danh từ",
    meaning:
      "người đàn ông đã lấy vợ, trong quan hệ với cha mẹ vợ và gia đình nhà vợ: làm rể * cháu rể * cô dâu, chú rể * ở rể",
    example: "làm rể * cháu rể * cô dâu, chú rể * ở rể",
  },
  {
    word: "rệ",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) rìa, vệ: rệ đường",
    example: "rệ đường",
  },
  {
    word: "rệ",
    part_of_speech: "động từ",
    meaning:
      "(hiện tượng xe cơ giới) có một bên bánh bị trượt ngang sang một bên lề đường: xe bị rệ bánh",
    example: "xe bị rệ bánh",
  },
  {
    word: "rếch rác",
    part_of_speech: "tính từ",
    meaning: "rếch (nói khái quát): nhà cửa rếch rác",
    example: "nhà cửa rếch rác",
  },
  {
    word: "rên",
    part_of_speech: "động từ",
    meaning:
      "phát ra những tiếng kêu khẽ và kéo dài, biểu lộ sự đau đớn của cơ thể: rên ư ử * cất tiếng rên khe khẽ",
    example: "rên ư ử * cất tiếng rên khe khẽ",
  },
  {
    word: "rên",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) kêu ca, than phiền (hàm ý coi thường): suốt ngày rên là không có tiền",
    example: "suốt ngày rên là không có tiền",
  },
  {
    word: "rêm",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) ê ẩm, đau nhức: đau rêm cả người",
    example: "đau rêm cả người",
  },
  {
    word: "rên la",
    part_of_speech: "động từ",
    meaning:
      "vừa rên vừa kêu la to vì quá đau đớn (nói khái quát): rên la rầm rĩ",
    example: "rên la rầm rĩ",
  },
  {
    word: "rề rề",
    part_of_speech: "tính từ",
    meaning:
      "chậm đến mức làm mất quá nhiều thời gian, không biết lúc nào mới kết thúc: chậm rề rề * của đi rề rề, của về nghễu nghện (tng)",
    example: "chậm rề rề * của đi rề rề, của về nghễu nghện (tng)",
  },
  {
    word: "rề rề",
    part_of_speech: "tính từ",
    meaning:
      "(Phương ngữ) ở trong tình trạng đau ốm kéo dài, không trầm trọng, nhưng mãi không khỏi: ốm rề rề",
    example: "ốm rề rề",
  },
  {
    word: "rền",
    part_of_speech: "tính từ",
    meaning:
      "(âm thanh) trầm và vang vọng từng hồi, liên tục: sấm rền * tiếng đại bác nổ rền",
    example: "sấm rền * tiếng đại bác nổ rền",
  },
  {
    word: "rền",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) liên tục, quá lâu hoặc quá nhiều so với bình thường: mưa rền cả tháng * đi chơi rền mấy ngày liền",
    example: "mưa rền cả tháng * đi chơi rền mấy ngày liền",
  },
  {
    word: "rền",
    part_of_speech: "tính từ",
    meaning:
      "(xôi, bánh) rất dẻo và ngon, do được luộc, nấu kĩ: xôi rền * bánh chưng luộc rất rền",
    example: "xôi rền * bánh chưng luộc rất rền",
  },
  {
    word: "rề rà",
    part_of_speech: "tính từ",
    meaning:
      "chậm chạp, dềnh dàng, làm mất nhiều thời gian, gây cảm giác khó chịu: đi đứng rề rà * giọng nói rề rà",
    example: "đi đứng rề rà * giọng nói rề rà",
  },
  {
    word: "rền rĩ",
    part_of_speech: "tính từ",
    meaning:
      "(kêu la, than khóc) dai dẳng và sầu thảm: khóc than rền rĩ * kêu la rền rĩ",
    example: "khóc than rền rĩ * kêu la rền rĩ",
  },
  {
    word: "rền rĩ",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) vang rền và kéo dài từng hồi: tiếng ve rền rĩ * từng hồi tù và rúc lên rền rĩ",
    example: "tiếng ve rền rĩ * từng hồi tù và rúc lên rền rĩ",
  },
  {
    word: "rên rẩm",
    part_of_speech: "động từ",
    meaning:
      "rên kéo dài, vẻ đau đớn (nói khái quát): chân đau, rên rẩm cả đêm * hơi khổ một tí là rên rẩm",
    example: "chân đau, rên rẩm cả đêm * hơi khổ một tí là rên rẩm",
  },
  {
    word: "rên rỉ",
    part_of_speech: "động từ",
    meaning:
      "rên nhỏ và kéo dài, vẻ thiểu não, khổ sở (nói khái quát): giọng rên rỉ * lúc nào cũng rên rỉ",
    example: "giọng rên rỉ * lúc nào cũng rên rỉ",
  },
  {
    word: "rên xiết",
    part_of_speech: "động từ",
    meaning:
      "than thở một cách ai oán vì bị đè nén, áp bức, cực khổ, không chịu đựng nổi: rên xiết dưới ách nô lệ",
    example: "rên xiết dưới ách nô lệ",
  },
  {
    word: "rệu",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ở trạng thái các bộ phận, các thành phần không còn kết hợp chặt với nhau, mà như muốn rời ra, rã ra: ngôi nhà tranh đã rệu * quả na chín rệu",
    example: "ngôi nhà tranh đã rệu * quả na chín rệu",
  },
  {
    word: "rết",
    part_of_speech: "danh từ",
    meaning:
      "động vật có thân dài gồm nhiều đốt, mỗi đốt có một đôi chân, có nọc độc: bị rết cắn",
    example: "bị rết cắn",
  },
  {
    word: "rệp",
    part_of_speech: "danh từ",
    meaning:
      "bọ hút máu người, thân dẹp, tiết chất hôi, chuyên sống ở chăn chiếu, khe giường, phản.",
    example: "phun thuốc trừ rệp cho cây trồng",
  },
  {
    word: "rều",
    part_of_speech: "danh từ",
    meaning:
      "vật nhỏ vụn như cỏ, rác, củi, v.v. trôi nổi thành từng đám trên mặt sông, mặt nước khi có lũ lụt (nói khái quát): vớt củi rều",
    example: "vớt củi rều",
  },
  {
    word: "rêu phong",
    part_of_speech: "danh từ",
    meaning:
      "rêu phủ dày, kín, gợi vẻ cổ xưa: mái ngói rêu phong * tường đá rêu phong",
    example: "mái ngói rêu phong * tường đá rêu phong",
  },
  {
    word: "ri",
    part_of_speech: "đại từ",
    meaning:
      '(phương ngữ) thế này: "Cứ lời anh dặn em ri, Giàu sang mặc họ, khó khăn chi cũng vợ chồng." (ca dao)',
    example:
      'Cứ lời anh dặn em ri, Giàu sang mặc họ, khó khăn chi cũng vợ chồng." (ca dao)',
  },
  {
    word: "rệu rạo",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) quá rệu: xương cốt rệu rạo",
    example: "xương cốt rệu rạo",
  },
  {
    word: "rệu rã",
    part_of_speech: "tính từ",
    meaning:
      "rệu đến mức như sắp rời ra từng mảnh, sắp tan rã (thường dùng với nghĩa bóng): chiếc xe đạp lâu ngày, giờ đã rệu rã * tinh thần rệu rã",
    example: "chiếc xe đạp lâu ngày, giờ đã rệu rã * tinh thần rệu rã",
  },
  {
    word: "rêu rao",
    part_of_speech: "động từ",
    meaning:
      "nói to cho nhiều người biết, nhằm mục đích xấu: đi rêu rao khắp làng * tìm chuyện xấu của người ta để rêu rao",
    example: "đi rêu rao khắp làng * tìm chuyện xấu của người ta để rêu rao",
  },
  {
    word: "rỉ",
    part_of_speech: "danh từ",
    meaning: "chất do kim loại tác dụng với không khí ẩm tạo thành: gỉ sắt",
    example: "gỉ sắt",
  },
  {
    word: "rỉ",
    part_of_speech: "động từ",
    meaning: "bị biến thành gỉ: thép không gỉ * con dao gỉ",
    example: "thép không gỉ * con dao gỉ",
  },
  {
    word: "rị",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) ghì lại, kéo ngược lại: nắm tay rị lại, không để cho đi",
    example: "nắm tay rị lại, không để cho đi",
  },
  {
    word: "rì rà rì rầm",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng rì rầm phát ra liên tiếp: hai người rì rà rì rầm suốt đêm",
    example: "hai người rì rà rì rầm suốt đêm",
  },
  {
    word: "rỉ răng",
    part_of_speech: "động từ",
    meaning:
      '(khẩu ngữ) như hé răng: "Tình riêng chưa dám rỉ răng, Tiểu thư trước đã liệu chừng nhủ qua." (TKiều)',
    example:
      'Tình riêng chưa dám rỉ răng, Tiểu thư trước đã liệu chừng nhủ qua." (TKiều)',
  },
  {
    word: "rì rào",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng những âm thanh nhỏ, êm nhẹ, phát ra đều đều liên tiếp như tiếng sóng vỗ, tiếng gió thổi: sóng biển rì rào * gió thổi rì rào qua kẽ lá",
    example: "sóng biển rì rào * gió thổi rì rào qua kẽ lá",
  },
  {
    word: "rỉ rả",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả những âm thanh không to, không cao, lặp đi lặp lại cách quãng, đều đều và kéo dài như không dứt: tiếng côn trùng kêu rỉ rả",
    example: "tiếng côn trùng kêu rỉ rả",
  },
  {
    word: "rỉ rả",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) mỗi lúc một ít, nhưng đều đều và kéo dài như không dứt: ăn rỉ rả suốt ngày * mưa rỉ rả",
    example: "ăn rỉ rả suốt ngày * mưa rỉ rả",
  },
  {
    word: "ri rí",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) (âm thanh) nhỏ, khẽ, như bị kìm giữ lại: cười ri rí",
    example: "cười ri rí",
  },
  {
    word: "rì rầm",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả tiếng động hay tiếng nói chuyện nho nhỏ, nghe không thật rõ, cứ đều đều không dứt: sóng biển rì rầm * nói chuyện rì rầm",
    example: "sóng biển rì rầm * nói chuyện rì rầm",
  },
  {
    word: "rỉ tai",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nói rất khẽ chỉ để cho nhau biết: rỉ tai một chuyện bí mật * rỉ tai nhau nói thầm",
    example: "rỉ tai một chuyện bí mật * rỉ tai nhau nói thầm",
  },
  {
    word: "ri rỉ",
    part_of_speech: "động từ",
    meaning:
      "chảy ra từng ít một, chậm nhưng liên tục: nước ri rỉ qua thành thùng bị nứt * máu ri rỉ",
    example: "nước ri rỉ qua thành thùng bị nứt * máu ri rỉ",
  },
  {
    word: "ri rỉ",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng kêu, khóc nhỏ, đều đều và dai dẳng: khóc ri rỉ * tiếng côn trùng kêu ri rỉ",
    example: "khóc ri rỉ * tiếng côn trùng kêu ri rỉ",
  },
  {
    word: "rì rì",
    part_of_speech: "tính từ",
    meaning:
      "từ biểu thị vẻ chậm chạp, gây cảm giác sốt ruột: xe chạy rì rì * hàng họ chậm rì rì",
    example: "xe chạy rì rì * hàng họ chậm rì rì",
  },
  {
    word: "rịa",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) rạn: bát rịa",
    example: "bát rịa",
  },
  {
    word: "rìa",
    part_of_speech: "danh từ",
    meaning:
      "phần ở ngoài cùng của một vật, sát với cạnh: ngồi ghé ở rìa phản * đi men theo rìa núi * một ngôi nhà nhỏ ở rìa xóm",
    example:
      "ngồi ghé ở rìa phản * đi men theo rìa núi * một ngôi nhà nhỏ ở rìa xóm",
  },
  {
    word: "ria",
    part_of_speech: "danh từ",
    meaning: "râu mọc ở mép: để ria * bộ ria mép",
    example: "để ria * bộ ria mép",
  },
  {
    word: "rỉa rói",
    part_of_speech: "động từ",
    meaning:
      "nhiếc móc một cách dai dẳng, làm cho phải đau khổ, day dứt: mẹ chồng rỉa rói con dâu",
    example: "mẹ chồng rỉa rói con dâu",
  },
  {
    word: "rích",
    part_of_speech: "phụ từ",
    meaning: "(khẩu ngữ) quá lắm (hàm ý chê): cũ rích * nhà cửa hôi rích",
    example: "cũ rích * nhà cửa hôi rích",
  },
  {
    word: "rỉa",
    part_of_speech: "động từ",
    meaning:
      "dùng miệng hoặc mỏ để mổ và rứt dần ra từng miếng nhỏ: cá rỉa mồi * kền kền rỉa xác chết",
    example: "cá rỉa mồi * kền kền rỉa xác chết",
  },
  {
    word: "rỉa",
    part_of_speech: "động từ",
    meaning: "dùng mỏ để mổ và vuốt cho sạch, cho mượt lông: chim rỉa lông",
    example: "chim rỉa lông",
  },
  {
    word: "riêng lẻ",
    part_of_speech: "tính từ",
    meaning:
      "từng cái một, tách riêng khỏi những cái khác cùng loại: chú ý đến từng trường hợp riêng lẻ",
    example: "chú ý đến từng trường hợp riêng lẻ",
  },
  {
    word: "riêng lẻ",
    part_of_speech: "tính từ",
    meaning: "có tính chất cá thể, không phải tập thể: làm ăn riêng lẻ",
    example: "làm ăn riêng lẻ",
  },
  {
    word: "riềng",
    part_of_speech: "danh từ",
    meaning:
      "cây cùng họ với gừng, thân ngầm hình củ, màu đỏ nâu, chia thành nhiều đốt, vị cay và thơm, dùng làm gia vị: cá kho riềng",
    example: "cá kho riềng",
  },
  {
    word: "riềng",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) trách mắng gay gắt, nặng lời: riềng cho một trận",
    example: "riềng cho một trận",
  },
  {
    word: "riêng biệt",
    part_of_speech: "tính từ",
    meaning:
      "riêng của một sự vật, làm cho nó khác với những sự vật khác: đặc điểm riêng biệt * vẻ đẹp riêng biệt",
    example: "đặc điểm riêng biệt * vẻ đẹp riêng biệt",
  },
  {
    word: "riêng biệt",
    part_of_speech: "tính từ",
    meaning:
      "riêng một mình, không có quan hệ với những cái khác cùng loại: tính riêng biệt từng khoản * mỗi người một phòng riêng biệt",
    example: "tính riêng biệt từng khoản * mỗi người một phòng riêng biệt",
  },
  {
    word: "riêng tây",
    part_of_speech: "tính từ",
    meaning:
      '(cũ, hiếm) riêng tư: "Đồ tế nhuyễn, của riêng tây, Sạch sành sanh vét cho đầy túi tham." (TKiều)',
    example:
      'Đồ tế nhuyễn, của riêng tây, Sạch sành sanh vét cho đầy túi tham." (TKiều)',
  },
  {
    word: "riêng",
    part_of_speech: "tính từ",
    meaning:
      "chỉ thuộc về một cá nhân hay một sự vật, bộ phận nào đó; phân biệt với chung: nhà riêng * con chung, con riêng * đặc điểm riêng * có cửa hàng riêng",
    example:
      "nhà riêng * con chung, con riêng * đặc điểm riêng * có cửa hàng riêng",
  },
  {
    word: "riêng",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất tách biệt, tách khỏi cái chung: trình bày riêng từng vấn đề * để riêng ra một chỗ",
    example: "trình bày riêng từng vấn đề * để riêng ra một chỗ",
  },
  {
    word: "riêng",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý nhấn mạnh về tính tách biệt, đơn nhất của sự vật, sự việc được nói đến: riêng tiền ăn hỏi cũng đã mất chục triệu * riêng nó thì được ưu tiên",
    example:
      "riêng tiền ăn hỏi cũng đã mất chục triệu * riêng nó thì được ưu tiên",
  },
  {
    word: "riết",
    part_of_speech: "động từ",
    meaning:
      "làm cho vòng thắt thu nhỏ lại để buộc, ôm thật chặt: riết mối lạt * riết chặt sợi dây thừng",
    example: "riết mối lạt * riết chặt sợi dây thừng",
  },
  {
    word: "riết",
    part_of_speech: "phụ từ",
    meaning:
      "(làm việc gì) với sự chú ý tập trung tối đa, quyết không rời công việc, không rời đối tượng, cho kì đạt kết quả: bám riết * canh phòng rất riết * đuổi riết sau lưng",
    example: "bám riết * canh phòng rất riết * đuổi riết sau lưng",
  },
  {
    word: "riệt",
    part_of_speech: "phụ từ",
    meaning: "(phương ngữ) rịt: xấu hổ nên ở riệt trong nhà",
    example: "xấu hổ nên ở riệt trong nhà",
  },
  {
    word: "riết róng",
    part_of_speech: "tính từ",
    meaning:
      "quá chặt chẽ, khắt khe trong quan hệ đối xử: thái độ riết róng * canh chừng riết róng",
    example: "thái độ riết róng * canh chừng riết róng",
  },
  {
    word: "riêng rẽ",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất tách rời với nhau hoặc tách rời với cái chung: hoạt động riêng rẽ * làm ăn riêng rẽ",
    example: "hoạt động riêng rẽ * làm ăn riêng rẽ",
  },
  {
    word: "riêng tư",
    part_of_speech: "tính từ",
    meaning: "riêng của cá nhân: chuyện riêng tư",
    example: "chuyện riêng tư",
  },
  {
    word: "rịn",
    part_of_speech: "động từ",
    meaning:
      "thấm ướt ra ngoài từng ít một: trán rịn mồ hôi * vết thương rịn nước vàng",
    example: "trán rịn mồ hôi * vết thương rịn nước vàng",
  },
  {
    word: "rinh",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ, khẩu ngữ) mang, chuyển đi nơi khác: rinh lu nước ra chỗ khác",
    example: "rinh lu nước ra chỗ khác",
  },
  {
    word: "rinh",
    part_of_speech: "phụ từ",
    meaning: "(khẩu ngữ) ầm lên, inh lên: khóc rinh lên * cười nói rinh nhà",
    example: "khóc rinh lên * cười nói rinh nhà",
  },
  {
    word: "riêu",
    part_of_speech: "danh từ",
    meaning:
      "món canh nấu bằng cua hoặc cá với chất chua và gia vị: cá nấu riêu * riêu cua * thích ăn bún riêu",
    example: "cá nấu riêu * riêu cua * thích ăn bún riêu",
  },
  {
    word: "rin rít",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái có bụi bẩn bám dính vào da, gây cảm giác khó chịu: người rin rít mồ hôi",
    example: "người rin rít mồ hôi",
  },
  {
    word: "rin rít",
    part_of_speech: "tính từ",
    meaning:
      'từ mô phỏng tiếng phát ra khi hai vật cứng cọ xát hay nghiến vào nhau, nghe chói tai: tiếng cửa sắt nghiến rin rít * "Chị Khà nổi ba máu sáu cơn, giọng chị rin rít qua kẽ răng (...)" (NgKiên; 15)',
    example:
      'tiếng cửa sắt nghiến rin rít * "Chị Khà nổi ba máu sáu cơn, giọng chị rin rít qua kẽ răng (...)" (NgKiên; 15)',
  },
  {
    word: "rim",
    part_of_speech: "động từ",
    meaning:
      "đun nhỏ lửa cho thức ăn ngấm mắm muối hoặc đường và khô lại: đậu rim * thịt rim * rim mứt",
    example: "đậu rim * thịt rim * rim mứt",
  },
  {
    word: "rình mò",
    part_of_speech: "động từ",
    meaning: "rình với mục đích xấu (nói khái quát): có kẻ trộm rình mò",
    example: "có kẻ trộm rình mò",
  },
  {
    word: "rinh rích",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả tiếng cười hay tiếng kêu nhỏ và liên tiếp: tiếng chuột rinh rích * cười rinh rích",
    example: "tiếng chuột rinh rích * cười rinh rích",
  },
  {
    word: "rinh rích",
    part_of_speech: "tính từ",
    meaning: "như rả rích: mưa rinh rích cả tuần lễ",
    example: "mưa rinh rích cả tuần lễ",
  },
  {
    word: "rình rang",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) có vẻ rùm beng, phô trương ồn ào: tổ chức tiệc tùng rình rang * quảng cáo rình rang",
    example: "tổ chức tiệc tùng rình rang * quảng cáo rình rang",
  },
  {
    word: "rình",
    part_of_speech: "động từ",
    meaning:
      "kín đáo quan sát để theo dõi hoặc để chờ cơ hội thuận tiện mà hành động: mèo rình chuột * rình trộm * rình lúc không ai để ý là chuồn mất",
    example: "mèo rình chuột * rình trộm * rình lúc không ai để ý là chuồn mất",
  },
  {
    word: "rình",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ, hiếm) như chực: ngọn đèn dầu leo lét chỉ rình tắt",
    example: "ngọn đèn dầu leo lét chỉ rình tắt",
  },
  {
    word: "rình rập",
    part_of_speech: "động từ",
    meaning: "rình (nói khái quát): kẻ gian rình rập",
    example: "kẻ gian rình rập",
  },
  {
    word: "ríu",
    part_of_speech: "động từ",
    meaning:
      "rối và thắt chặt vào nhau thành những nút khó tháo gỡ: chỉ ríu vào nhau thành búi",
    example: "chỉ ríu vào nhau thành búi",
  },
  {
    word: "ríu",
    part_of_speech: "động từ",
    meaning:
      "(bộ phận cơ thể) chạm, chập vào nhau gây vướng, làm cho không cử động được bình thường, tự nhiên, thường do vội vàng, luống cuống: hai chân ríu vào nhau * mắt ríu lại vì buồn ngủ * sợ ríu cả lưỡi",
    example: "hai chân ríu vào nhau * mắt ríu lại vì buồn ngủ * sợ ríu cả lưỡi",
  },
  {
    word: "rịt",
    part_of_speech: "động từ",
    meaning:
      "đắp (thuốc, bông, v.v.) vào chỗ đau: rịt chặt bông để cầm máu * hái lá rịt vào vết thương",
    example: "rịt chặt bông để cầm máu * hái lá rịt vào vết thương",
  },
  {
    word: "rịt",
    part_of_speech: "phụ từ",
    meaning:
      "nhất quyết không chịu buông, không chịu rời ra: bám rịt lấy mẹ * giữ rịt lấy không chịu trả",
    example: "bám rịt lấy mẹ * giữ rịt lấy không chịu trả",
  },
  {
    word: "rít",
    part_of_speech: "động từ",
    meaning:
      "(âm thanh) phát ra cao, thành hồi dài, nghe chói tai: rít giọng * tiếng gió rít từng hồi",
    example: "rít giọng * tiếng gió rít từng hồi",
  },
  {
    word: "rít",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) hít mạnh một hơi thuốc dài: rít một hơi thuốc",
    example: "rít một hơi thuốc",
  },
  {
    word: "rít",
    part_of_speech: "động từ",
    meaning:
      "ở trạng thái khó chuyển động vì không trơn, không êm do có nhiều gỉ, bụi bẩn, v.v. bám vào ở khe hở giữa các bộ phận: không mở được cửa vì khoá rít * bánh xe bị rít",
    example: "không mở được cửa vì khoá rít * bánh xe bị rít",
  },
  {
    word: "riu ríu",
    part_of_speech: "phụ từ",
    meaning:
      "từ gợi tả vẻ sợ sệt chịu tuân theo mà làm việc gì đó một cách ngoan ngoãn, không hề có biểu hiện muốn chống lại: chân riu ríu bước theo",
    example: "chân riu ríu bước theo",
  },
  {
    word: "riu",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ đan bằng tre, dùng đẩy dưới nước để bắt tôm, tép: đẩy riu bắt tép",
    example: "đẩy riu bắt tép",
  },
  {
    word: "riu",
    part_of_speech: "động từ",
    meaning: "bắt tép bằng cái riu: riu tép",
    example: "riu tép",
  },
  {
    word: "rìu",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ dùng để đẽo, chặt, có cán cầm và một lưỡi sắc hình thang tra thẳng góc vào cán: dùng rìu bổ củi * múa rìu qua mắt thợ (tng)",
    example: "dùng rìu bổ củi * múa rìu qua mắt thợ (tng)",
  },
  {
    word: "ríu rít",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng những tiếng cao, trong và tiếp liền nhau, nghe không rõ từng tiếng, giống như tiếng chim: chim hót ríu rít",
    example: "chim hót ríu rít",
  },
  {
    word: "ríu rít",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả cảnh đám trẻ sàn sàn bằng nhau, tụ lại với nhau cười nói rộn ràng như một bầy chim: bọn trẻ ríu rít đi vào lớp",
    example: "bọn trẻ ríu rít đi vào lớp",
  },
  {
    word: "ríu ra ríu rít",
    part_of_speech: "tính từ",
    meaning:
      'từ mô phỏng tiếng ríu rít phát ra nhiều và liên tiếp, nghe vui tai: "Trường em mấy tổ trong thôn, Ríu ra ríu rít chim non đầu mùa." (THữu; 42)',
    example:
      'Trường em mấy tổ trong thôn, Ríu ra ríu rít chim non đầu mùa." (THữu; 42)',
  },
  {
    word: "ríu ran",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng những âm thanh rộn rã, rang khắp: chuyện trò ríu ran * tiếng chim ríu ran trên cành lá",
    example: "chuyện trò ríu ran * tiếng chim ríu ran trên cành lá",
  },
  {
    word: "riu riu",
    part_of_speech: "tính từ",
    meaning:
      "(lửa cháy hay nước sôi) nhỏ, nhẹ và đều đều: bếp lửa cháy riu riu * ấm thuốc bắc sôi riu riu",
    example: "bếp lửa cháy riu riu * ấm thuốc bắc sôi riu riu",
  },
  {
    word: "ró",
    part_of_speech: "danh từ",
    meaning:
      "đồ đựng đan bằng cói, lác, giống cái bị, nhưng có vỉ buồm để đậy và không có quai: ró gạo",
    example: "ró gạo",
  },
  {
    word: "rõ",
    part_of_speech: "động từ",
    meaning:
      'hiểu, biết tường tận, cụ thể: không rõ nguyên do * "Bây giờ rõ mặt đôi ta, Biết đâu rồi nữa chẳng là chiêm bao?" (TKiều)',
    example:
      'không rõ nguyên do * "Bây giờ rõ mặt đôi ta, Biết đâu rồi nữa chẳng là chiêm bao?" (TKiều)',
  },
  {
    word: "rõ",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái tách bạch hẳn ra, khiến có thể phân biệt được hoàn toàn với những cái khác: trông thấy rõ mồn một * phân biệt rõ trắng đen * giảng cho rõ nghĩa",
    example:
      "trông thấy rõ mồn một * phân biệt rõ trắng đen * giảng cho rõ nghĩa",
  },
  {
    word: "rõ",
    part_of_speech: "trợ từ",
    meaning:
      "(Khẩu ngữ) từ biểu thị ý khẳng định về một mức độ mà mình cho là hơn hẳn bình thường và có thể thấy rất rõ: rõ chán * rõ dơ * nói rõ to",
    example: "rõ chán * rõ dơ * nói rõ to",
  },
  {
    word: "rò",
    part_of_speech: "động từ",
    meaning:
      "(vật đựng chất lỏng) có kẽ nứt hoặc lỗ thủng rất nhỏ, làm chất lỏng rỉ ra, thấm ra ngoài: chân đê có chỗ rò * bịt lỗ rò",
    example: "chân đê có chỗ rò * bịt lỗ rò",
  },
  {
    word: "rọ rạy",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) động đậy, cựa quậy liên tục: chân tay lúc nào cũng rọ rạy",
    example: "chân tay lúc nào cũng rọ rạy",
  },
  {
    word: "rõ khéo",
    part_of_speech: "",
    meaning:
      '(khẩu ngữ) tổ hợp biểu thị ý mỉa mai hay trách móc một cách nhẹ nhàng: rõ khéo bày vẽ * "Anh này rõ khéo làm ăn, Đi cày chẳng biết, chít khăn mượn người." (ca dao)',
    example:
      'rõ khéo bày vẽ * "Anh này rõ khéo làm ăn, Đi cày chẳng biết, chít khăn mượn người." (ca dao)',
  },
  {
    word: "rõ rành",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như rành rõ: nói năng rõ rành",
    example: "nói năng rõ rành",
  },
  {
    word: "rõ ràng",
    part_of_speech: "tính từ",
    meaning:
      "rõ đến mức ai cũng có thể thấy, có thể nhận biết được một cách dễ dàng: bằng chứng rõ ràng * trả lời một cách rõ ràng",
    example: "bằng chứng rõ ràng * trả lời một cách rõ ràng",
  },
  {
    word: "rõ rệt",
    part_of_speech: "tính từ",
    meaning:
      'rõ đến mức có những biểu hiện cụ thể, nhận thấy được một cách dễ dàng: tiến bộ rõ rệt * "Cái lạnh man mác của chiều thu gần tàn Bính cảm thấy rõ rệt lắm." (NgHồng; 1)',
    example:
      'tiến bộ rõ rệt * "Cái lạnh man mác của chiều thu gần tàn Bính cảm thấy rõ rệt lắm." (NgHồng; 1)',
  },
  {
    word: "rọ",
    part_of_speech: "danh từ",
    meaning:
      "đồ đan bằng tre nứa, hình thuôn dài, dùng để nhốt súc vật khi vận chuyển: rọ lợn * trói voi bỏ rọ (tng)",
    example: "rọ lợn * trói voi bỏ rọ (tng)",
  },
  {
    word: "rò rỉ",
    part_of_speech: "động từ",
    meaning:
      "(chất lỏng, chất khí) thấm, thoát ra ngoài từng ít một theo những khe lỗ rất nhỏ, khó thấy: đường ống dầu bị rò rỉ * rò rỉ khí gas",
    example: "đường ống dầu bị rò rỉ * rò rỉ khí gas",
  },
  {
    word: "rò rỉ",
    part_of_speech: "động từ",
    meaning:
      "mất đi dần từng ít một, khó phát hiện: rò rỉ thông tin * ngân sách bị rò rỉ",
    example: "rò rỉ thông tin * ngân sách bị rò rỉ",
  },
  {
    word: "ro ro",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng những tiếng động nhỏ, đều đều, tròn tiếng và kéo dài: máy quay ro ro",
    example: "máy quay ro ro",
  },
  {
    word: "ro ró",
    part_of_speech: "động từ",
    meaning: "(hiếm) như ru rú: cả ngày chỉ ro ró ở xó bếp",
    example: "cả ngày chỉ ro ró ở xó bếp",
  },
  {
    word: "róc",
    part_of_speech: "động từ",
    meaning:
      'tách bỏ bằng lưỡi sắc phần bên ngoài của vật cứng, thường là cả phần vỏ: róc mía * "Lúa khô anh đổ vào bồ, Cau già róc vỏ phơi khô để dành." (ca dao)',
    example:
      'róc mía * "Lúa khô anh đổ vào bồ, Cau già róc vỏ phơi khô để dành." (ca dao)',
  },
  {
    word: "róc",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) hết sạch (thường nói về nước): vớt rau ra rổ cho róc nước",
    example: "vớt rau ra rổ cho róc nước",
  },
  {
    word: "róc",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) rất khôn trong quan hệ đối xử, không bao giờ chịu để cho mình thua thiệt: hắn ta róc lắm * khôn róc đời!",
    example: "hắn ta róc lắm * khôn róc đời!",
  },
  {
    word: "robot",
    part_of_speech: "danh từ",
    meaning:
      "máy thường có hình dạng giống người, có thể làm thay cho con người một số việc, thực hiện một số thao tác kĩ thuật phức tạp: chế tạo robot",
    example: "chế tạo robot",
  },
  {
    word: "robotic",
    part_of_speech: "danh từ",
    meaning:
      "môn khoa học và kĩ thuật chuyên về thiết kế và chế tạo robot: kĩ sư robotic",
    example: "kĩ sư robotic",
  },
  {
    word: "róc rách",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng nước chảy nhẹ qua kẽ đá: nước suối chảy róc rách",
    example: "nước suối chảy róc rách",
  },
  {
    word: "roi",
    part_of_speech: "danh từ",
    meaning:
      "(Bắc, cũng gioi) (Nam mận) cây cùng họ với ổi, lá to, hoa trắng, quả mọng hình quả lê, thịt xốp, ăn được",
    example:
      "quật cho vài roi * ăn roi (= bị đánh bằng roi) * Thương cho roi cho vọt",
  },
  {
    word: "rọc",
    part_of_speech: "động từ",
    meaning:
      "đưa lưỡi sắc dọc theo đường gấp để làm cho đứt rời ra: rọc giấy * rọc phách * dùng mũi kéo rọc vải",
    example: "rọc giấy * rọc phách * dùng mũi kéo rọc vải",
  },
  {
    word: "rói",
    part_of_speech: "tính từ",
    meaning: "có vẻ tươi mới lộ rõ ra ngoài: hoa gạo đỏ rói",
    example: "hoa gạo đỏ rói",
  },
  {
    word: "rọi",
    part_of_speech: "động từ",
    meaning:
      "hướng luồng ánh sáng chiếu thẳng vào: rọi đèn * nắng rọi qua cửa sổ * mặt trời rọi qua kẽ lá",
    example: "rọi đèn * nắng rọi qua cửa sổ * mặt trời rọi qua kẽ lá",
  },
  {
    word: "rock",
    part_of_speech: "danh từ",
    meaning:
      "thể nhạc dân gian hiện đại, có nguồn gốc từ phương Tây, chuyên sử dụng dàn trống và guitar điện, có tiết tấu mạnh mẽ: ca sĩ nhạc rock",
    example: "ca sĩ nhạc rock",
  },
  {
    word: "roi rói",
    part_of_speech: "tính từ",
    meaning:
      "rất tươi mới, lộ rõ ra ngoài, trông sáng và đẹp: mặt tươi roi rói",
    example: "mặt tươi roi rói",
  },
  {
    word: "rón rén",
    part_of_speech: "phụ từ",
    meaning:
      "từ gợi tả dáng điệu của động tác cố làm cho thật nhẹ nhàng, thong thả vì sợ gây tiếng động hoặc điều thất thố: rón rén thưa bày * ăn rón rén từng tí một",
    example: "rón rén thưa bày * ăn rón rén từng tí một",
  },
  {
    word: "roi vọt",
    part_of_speech: "danh từ",
    meaning:
      "roi để đánh (nói khái quát); thường dùng để chỉ sự đánh đập: không nên dạy con bằng roi vọt",
    example: "không nên dạy con bằng roi vọt",
  },
  {
    word: "roneo",
    part_of_speech: "danh từ",
    meaning:
      "máy gồm có một trục tẩm mực để in những bản đánh máy trên giấy sáp: in roneo",
    example: "in roneo",
  },
  {
    word: "ròng",
    part_of_speech: "động từ",
    meaning: "(nước thuỷ triều) rút xuống: nước ròng",
    example: "nước ròng",
  },
  {
    word: "ròng",
    part_of_speech: "động từ",
    meaning:
      "chảy thành dòng, thành vệt (thường là trên cơ thể): nước mắt chảy ròng * mồ hôi tuôn ròng trên trán",
    example: "nước mắt chảy ròng * mồ hôi tuôn ròng trên trán",
  },
  {
    word: "ròng",
    part_of_speech: "tính từ",
    meaning: "nguyên chất (thường nói về kim loại): vàng ròng * thép ròng",
    example: "vàng ròng * thép ròng",
  },
  {
    word: "ròng",
    part_of_speech: "tính từ",
    meaning: "thuần tuý: lãi ròng * thu nhập ròng * sản lượng ròng",
    example: "lãi ròng * thu nhập ròng * sản lượng ròng",
  },
  {
    word: "ròng",
    part_of_speech: "tính từ",
    meaning:
      "liên tục trong suốt cả một khoảng thời gian nào đó: đi bộ mấy ngày ròng * thức mấy đêm ròng",
    example: "đi bộ mấy ngày ròng * thức mấy đêm ròng",
  },
  {
    word: "roi cặc bò",
    part_of_speech: "danh từ",
    meaning:
      'roi tết bằng những sợi gân bò, đánh rất đau: "Nghe đồn ở mỏ thảnh thơi, Khi ra chỉ những ăn roi cặc bò." (ca dao)',
    example:
      'Nghe đồn ở mỏ thảnh thơi, Khi ra chỉ những ăn roi cặc bò." (ca dao)',
  },
  {
    word: "rong",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi chung những thực vật bậc cao sống ở nước, thường có thân mảnh, hình dải dài mọc sát vào nhau: rong biển",
    example: "rong biển",
  },
  {
    word: "rong",
    part_of_speech: "động từ",
    meaning:
      "đi lang thang đây đó, hết chỗ này đến chỗ khác, không dừng lại lâu ở đâu cả: bán hàng rong * gánh hát rong * suốt ngày rong chơi",
    example: "bán hàng rong * gánh hát rong * suốt ngày rong chơi",
  },
  {
    word: "rong rêu",
    part_of_speech: "danh từ",
    meaning: "rong và rêu (nói khái quát): vớt rong rêu",
    example: "vớt rong rêu",
  },
  {
    word: "rong róc",
    part_of_speech: "tính từ",
    meaning: "như róc (nhưng ý nhấn mạnh hơn): khô rong róc",
    example: "khô rong róc",
  },
  {
    word: "rong ruổi",
    part_of_speech: "động từ",
    meaning:
      "đi liên tục trên chặng đường dài, nhằm mục đích nhất định: đạp xe rong ruổi khắp phố phường",
    example: "đạp xe rong ruổi khắp phố phường",
  },
  {
    word: "ròng rã",
    part_of_speech: "tính từ",
    meaning:
      "liên tục trong suốt một thời gian được coi là quá dài: đi ròng rã mấy tháng trời",
    example: "đi ròng rã mấy tháng trời",
  },
  {
    word: "rót",
    part_of_speech: "động từ",
    meaning:
      "làm cho chất lỏng chảy thành dòng qua vòi của một vật chứa vào vật chứa khác: rót nước sôi vào phích * rót nước mời khách * dỗ ngon dỗ ngọt như rót mật vào tai",
    example:
      "rót nước sôi vào phích * rót nước mời khách * dỗ ngon dỗ ngọt như rót mật vào tai",
  },
  {
    word: "rót",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) (pháo) bắn tập trung, tựa như trút đạn, vào một điểm nào đó: đại bác rót đạn như mưa",
    example: "đại bác rót đạn như mưa",
  },
  {
    word: "rót",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) cấp kinh phí, vật tư, v.v.: rót tiền vào các dự án * rót thêm kinh phí",
    example: "rót tiền vào các dự án * rót thêm kinh phí",
  },
  {
    word: "rỗ",
    part_of_speech: "tính từ",
    meaning: "có nhiều sẹo nhỏ lỗ chỗ trên da, thường do bệnh đậu mùa: mặt rỗ",
    example: "mặt rỗ",
  },
  {
    word: "rỗ",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều lỗ nhỏ lỗ chỗ trên bề mặt: mặt bê tông bị rỗ * mưa rỗ nền cát",
    example: "mặt bê tông bị rỗ * mưa rỗ nền cát",
  },
  {
    word: "ròng ròng",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái chảy nhiều và thành dòng, không dứt (thường là trên cơ thể): mồ hôi chảy ròng ròng * nước mắt ròng ròng",
    example: "mồ hôi chảy ròng ròng * nước mắt ròng ròng",
  },
  {
    word: "rọt rẹt",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng những âm thanh rè, không vang, không đều, lúc có lúc không: tiếng máy rọt rẹt",
    example: "tiếng máy rọt rẹt",
  },
  {
    word: "rồ",
    part_of_speech: "động từ",
    meaning:
      "(xe cộ, máy móc) phát ra tiếng động to, nghe inh tai, khi động cơ khởi động hoặc khi tăng tốc độ đột ngột: rồ máy * rồ ga vượt lên",
    example: "rồ máy * rồ ga vượt lên",
  },
  {
    word: "rồ",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái không kiềm chế được hành vi, thường có những biểu hiện, hành động quá khích: tức quá hoá rồ * rồ cả người * nói năng như thằng rồ",
    example: "tức quá hoá rồ * rồ cả người * nói năng như thằng rồ",
  },
  {
    word: "rộ",
    part_of_speech: "",
    meaning:
      "(xảy ra) rất nhiều một cách mạnh mẽ và đều khắp: hoa nở rộ * vải chín rộ * mọi người cười rộ lên",
    example: "hoa nở rộ * vải chín rộ * mọi người cười rộ lên",
  },
  {
    word: "rô",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) cá rô (nói tắt): tham con diếc, tiếc con rô (tng)",
    example: "tham con diếc, tiếc con rô (tng)",
  },
  {
    word: "rô",
    part_of_speech: "danh từ",
    meaning: "con bài tú lơ khơ có in hình _ màu đỏ: con mười rô",
    example: "con mười rô",
  },
  {
    word: "rổ",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng để đựng, thường đan bằng tre hay làm bằng nhựa, tròn và sâu lòng, có nhiều lỗ nhỏ và thưa: rổ rau * chẻ tre đan rổ",
    example: "rổ rau * chẻ tre đan rổ",
  },
  {
    word: "rổ",
    part_of_speech: "danh từ",
    meaning:
      "vòng sắt tròn có mắc lưới, gắn vào mặt bảng, dùng làm đích để ném bóng vào, trong môn bóng rổ: ném bóng vào rổ * bóng rơi ra ngoài rổ",
    example: "ném bóng vào rổ * bóng rơi ra ngoài rổ",
  },
  {
    word: "rỗ hoa",
    part_of_speech: "tính từ",
    meaning:
      '(mặt) có những nốt rỗ thưa và nông: "Những người lấm tấm rỗ hoa, Rỗ năm ba nốt, thật là rỗ xinh." (ca dao)',
    example:
      'Những người lấm tấm rỗ hoa, Rỗ năm ba nốt, thật là rỗ xinh." (ca dao)',
  },
  {
    word: "rô ti",
    part_of_speech: "động từ",
    meaning: "quay (thịt): chim rô ti",
    example: "chim rô ti",
  },
  {
    word: "rồ dại",
    part_of_speech: "tính từ",
    meaning: "tỏ ra mất trí khôn: làm những việc rồ dại",
    example: "làm những việc rồ dại",
  },
  {
    word: "rô to",
    part_of_speech: "danh từ",
    meaning:
      "phần quay trong các máy điện và động cơ điện: rô to của quạt điện",
    example: "rô to của quạt điện",
  },
  {
    word: "rô-bốt",
    part_of_speech: "danh từ",
    meaning:
      "máy thường có hình dạng giống người, có thể làm thay cho con người một số việc, thực hiện một số thao tác kĩ thuật phức tạp: chế tạo robot",
    example: "chế tạo robot",
  },
  {
    word: "rô-bô-tích",
    part_of_speech: "danh từ",
    meaning:
      "môn khoa học và kĩ thuật chuyên về thiết kế và chế tạo robot: kĩ sư robotic",
    example: "kĩ sư robotic",
  },
  {
    word: "rộc rạc",
    part_of_speech: "tính từ",
    meaning: "gầy rộc, hốc hác: rộc rạc cả người vì lo nghĩ",
    example: "rộc rạc cả người vì lo nghĩ",
  },
  {
    word: "rộc",
    part_of_speech: "danh từ",
    meaning: "ngòi nước nhỏ, hẹp: lội qua rộc",
    example: "lội qua rộc",
  },
  {
    word: "rộc",
    part_of_speech: "danh từ",
    meaning:
      "đất trũng ven các cánh đồng, hoặc giữa hai sườn đồi núi: ruộng rộc",
    example: "ruộng rộc",
  },
  {
    word: "rộc",
    part_of_speech: "tính từ",
    meaning:
      "gầy sút người đi một cách trông thấy: gầy rộc * lo nghĩ đến rộc người",
    example: "gầy rộc * lo nghĩ đến rộc người",
  },
  {
    word: "rốc",
    part_of_speech: "danh từ",
    meaning:
      "thể nhạc dân gian hiện đại, có nguồn gốc từ phương Tây, chuyên sử dụng dàn trống và guitar điện, có tiết tấu mạnh mẽ: ca sĩ nhạc rock",
    example: "ca sĩ nhạc rock",
  },
  {
    word: "rô-nê-ô",
    part_of_speech: "danh từ",
    meaning:
      "máy gồm có một trục tẩm mực để in những bản đánh máy trên giấy sáp: in roneo",
    example: "in roneo",
  },
  {
    word: "rỗi",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái ít hoặc không có việc phải làm: đang rỗi việc * không có thời gian rỗi",
    example: "đang rỗi việc * không có thời gian rỗi",
  },
  {
    word: "rỗi",
    part_of_speech: "tính từ",
    meaning:
      "(linh hồn) được cứu vớt khỏi mọi sự ràng buộc tội lỗi, được giải thoát, theo quan niệm của một số tôn giáo: cứu rỗi linh hồn",
    example: "cứu rỗi linh hồn",
  },
  {
    word: "rối",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) múa rối (nói tắt): tiết mục rối",
    example: "tiết mục rối",
  },
  {
    word: "rối",
    part_of_speech: "danh từ",
    meaning: "con rối (nói tắt): kĩ thuật điều khiển rối",
    example: "kĩ thuật điều khiển rối",
  },
  {
    word: "rối",
    part_of_speech: "danh từ",
    meaning:
      "ở tình trạng bị mắc, bị vướng nhằng nhịt vào nhau, khó gỡ: tóc rối * tơ rối",
    example: "tóc rối * tơ rối",
  },
  {
    word: "rối",
    part_of_speech: "danh từ",
    meaning:
      'ở tình trạng bị xáo trộn, không yên, không bình thường: gây rối nơi công cộng * phá rối * "Tai nghe ruột rối bời bời, Ngập ngừng nàng mới giải lời trước sau." (TKiều)',
    example:
      'gây rối nơi công cộng * phá rối * "Tai nghe ruột rối bời bời, Ngập ngừng nàng mới giải lời trước sau." (TKiều)',
  },
  {
    word: "rồi",
    part_of_speech: "động từ",
    meaning:
      '(cũ, hoặc ph) xong: "Thôi thì một thác cho rồi, Tấm lòng phó mặc trên trời, dưới sông!" (TKiều)',
    example:
      'Thôi thì một thác cho rồi, Tấm lòng phó mặc trên trời, dưới sông!" (TKiều)',
  },
  {
    word: "rồi",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị điều vừa nói đến là đã được thực hiện, là thuộc về thời gian đã qua: anh ấy đi công tác rồi * cô ta đã có gia đình rồi * lâu rồi không đến thăm",
    example:
      "anh ấy đi công tác rồi * cô ta đã có gia đình rồi * lâu rồi không đến thăm",
  },
  {
    word: "rồi",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị điều vừa nói đến sẽ được thực hiện xong, sẽ kết thúc ngay trước mắt: xong đến nơi rồi * sắp đến giờ rồi",
    example: "xong đến nơi rồi * sắp đến giờ rồi",
  },
  {
    word: "rồi",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị điều sắp nêu có nhiều khả năng sẽ xảy ra trong một tương lai gần: cứ để đó rồi sẽ liệu * trước sau rồi người ta cũng biết",
    example: "cứ để đó rồi sẽ liệu * trước sau rồi người ta cũng biết",
  },
  {
    word: "rồi",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) vừa rồi (nói tắt): hôm rồi tôi có gặp anh ấy * tuần rồi có chút việc bận",
    example: "hôm rồi tôi có gặp anh ấy * tuần rồi có chút việc bận",
  },
  {
    word: "rồi",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị quan hệ nối tiếp về thời gian, điều sắp nêu xảy ra liền ngay sau điều vừa nói đến: học xong rồi đi chơi * định nói nhưng rồi lại thôi",
    example: "học xong rồi đi chơi * định nói nhưng rồi lại thôi",
  },
  {
    word: "rồi",
    part_of_speech: "kết từ",
    meaning:
      'từ biểu thị một loại quan hệ kéo theo, điều vừa nói đến có thể sẽ dẫn tới điều sắp nêu ra: ngoan đi rồi mẹ yêu * "Nói lời thì giữ lấy lời, Đừng như con bướm đậu rồi lại bay." (ca dao)',
    example:
      'ngoan đi rồi mẹ yêu * "Nói lời thì giữ lấy lời, Đừng như con bướm đậu rồi lại bay." (ca dao)',
  },
  {
    word: "rồi",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý nhấn mạnh về điều coi như đã có thể khẳng định dứt khoát: đẹp lắm rồi * tất nhiên rồi * đúng rồi * hỏng mất rồi!",
    example: "đẹp lắm rồi * tất nhiên rồi * đúng rồi * hỏng mất rồi!",
  },
  {
    word: "rồi",
    part_of_speech: "tính từ",
    meaning:
      "(cũ) ở trạng thái không có việc gì để làm cả: ăn không ngồi rồi (tng)",
    example: "ăn không ngồi rồi (tng)",
  },
  {
    word: "rối beng",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) rối lên, không biết giải quyết thế nào: mọi việc cứ rối beng lên hết",
    example: "mọi việc cứ rối beng lên hết",
  },
  {
    word: "rối bét",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) rối đến mức tồi tệ, khó mà tháo gỡ nổi: mọi việc đều rối bét",
    example: "mọi việc đều rối bét",
  },
  {
    word: "rối bời",
    part_of_speech: "",
    meaning:
      "rối và bề bộn ngổn ngang, không biết đường nào mà tháo gỡ hay sắp xếp, giải quyết: đầu tóc rối bời * ruột gan rối bời",
    example: "đầu tóc rối bời * ruột gan rối bời",
  },
  {
    word: "rối bòng bong",
    part_of_speech: "",
    meaning:
      "ở tình trạng rất rối ren, lộn xộn, khó giải quyết: mọi chuyện cứ rối bòng bong cả lên",
    example: "mọi chuyện cứ rối bòng bong cả lên",
  },
  {
    word: "rồi đây",
    part_of_speech: "",
    meaning:
      '(khẩu ngữ) trong thời gian sắp tới đây: "Rồi đây bèo hợp mây tan, Biết đâu hạc nội, mây ngàn là đâu?" (TKiều)',
    example:
      'Rồi đây bèo hợp mây tan, Biết đâu hạc nội, mây ngàn là đâu?" (TKiều)',
  },
  {
    word: "rỗi hơi",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có thời gian và sức lực để làm việc coi là vô ích, là không có quan hệ gì đến mình: ai rỗi hơi mà quan tâm đến chuyện đó",
    example: "ai rỗi hơi mà quan tâm đến chuyện đó",
  },
  {
    word: "rối mù",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) rối tung lên, đến mức không còn nhận biết ra cái gì nữa: đầu óc rối mù lên vì công việc",
    example: "đầu óc rối mù lên vì công việc",
  },
  {
    word: "rối bù",
    part_of_speech: "",
    meaning:
      "(đầu tóc) rối và có nhiều sợi dài dựng lên, quấn vào nhau nhằng nhịt, lộn xộn: đầu tóc rối bù",
    example: "đầu tóc rối bù",
  },
  {
    word: "rồi đời",
    part_of_speech: "động từ",
    meaning: "(phương ngữ, khẩu ngữ) như hết đời: đòm cho một phát là rồi đời!",
    example: "đòm cho một phát là rồi đời!",
  },
  {
    word: "rối loạn",
    part_of_speech: "",
    meaning:
      "ở tình trạng lộn xộn, không còn có trật tự nào cả: rối loạn đội hình * một xã hội rối loạn * tâm trí rối loạn",
    example: "rối loạn đội hình * một xã hội rối loạn * tâm trí rối loạn",
  },
  {
    word: "rối như tơ vò",
    part_of_speech: "",
    meaning:
      "(tâm trạng) rối bời, bứt rứt không yên vì gặp phải việc khó giải quyết, khó tháo gỡ: ruột rối như tơ vò, chẳng biết phải làm sao",
    example: "ruột rối như tơ vò, chẳng biết phải làm sao",
  },
  {
    word: "rối nước",
    part_of_speech: "danh từ",
    meaning:
      "loại hình múa rối cổ truyền của Việt Nam, biểu diễn trên sân khấu - mặt nước: biểu diễn rối nước * đi xem múa rối nước",
    example: "biểu diễn rối nước * đi xem múa rối nước",
  },
  {
    word: "rồi ra",
    part_of_speech: "",
    meaning:
      'rồi sau này (thường dùng trong lời dự đoán): "Làm trai có chí lập thân, Rồi ra gặp hội phong vân có ngày." (ca dao)',
    example:
      'Làm trai có chí lập thân, Rồi ra gặp hội phong vân có ngày." (ca dao)',
  },
  {
    word: "rối ra rối rít",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) như rối rít (nhưng ý mức độ nhiều): tiếng chào hỏi rối ra rối rít",
    example: "tiếng chào hỏi rối ra rối rít",
  },
  {
    word: "rối ruột",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ở tình trạng hết sức lo lắng, đến mức mất bình tĩnh: rối ruột vì chuyện nhà cửa",
    example: "rối ruột vì chuyện nhà cửa",
  },
  {
    word: "rối rắm",
    part_of_speech: "tính từ",
    meaning:
      "rối lằng nhằng, không rõ ràng, rành mạch: trình bày rối rắm * đầu óc rối rắm với bao ý nghĩ",
    example: "trình bày rối rắm * đầu óc rối rắm với bao ý nghĩ",
  },
  {
    word: "rối ren",
    part_of_speech: "",
    meaning:
      "ở tình trạng lộn xộn, rắc rối, phức tạp, khó giải quyết: chính sự rối ren * tình hình xã hội rối ren",
    example: "chính sự rối ren * tình hình xã hội rối ren",
  },
  {
    word: "rỗi rãi",
    part_of_speech: "tính từ",
    meaning:
      "rỗi (nói khái quát): không có lúc nào rỗi rãi * lúc nào rỗi rãi, anh qua tôi chơi",
    example: "không có lúc nào rỗi rãi * lúc nào rỗi rãi, anh qua tôi chơi",
  },
  {
    word: "rối tinh rối mù",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) như rối tinh (nhưng nghĩa mạnh hơn): sổ sách rối tinh rối mù",
    example: "sổ sách rối tinh rối mù",
  },
  {
    word: "rối rít tít mù",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) như rối rít (nhưng nghĩa mạnh hơn): làm cái gì mà cứ rối rít tít mù lên thế!",
    example: "làm cái gì mà cứ rối rít tít mù lên thế!",
  },
  {
    word: "rối rít",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả vẻ vội vã, tỏ ra mất bình tĩnh: gọi rối rít * cảm ơn rối rít",
    example: "gọi rối rít * cảm ơn rối rít",
  },
  {
    word: "rối tung",
    part_of_speech: "",
    meaning:
      "rối nhằng nhịt vào nhau, khó tháo gỡ, khó giải quyết: mái tóc rối tung * mọi chuyện cứ rối tung cả lên",
    example: "mái tóc rối tung * mọi chuyện cứ rối tung cả lên",
  },
  {
    word: "rối tinh",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) rối tung, mọi cái nhằng nhịt vào nhau làm cho không còn biết đằng nào mà lần: đầu óc rối tinh * mọi việc cứ rối tinh cả lên",
    example: "đầu óc rối tinh * mọi việc cứ rối tinh cả lên",
  },
  {
    word: "rôm",
    part_of_speech: "danh từ",
    meaning:
      "mụn nhỏ lấm tấm mọc thành từng đám ở ngoài da người, do nóng nực, gây ngứa ngáy khó chịu: nổi rôm đầy người * bị rôm cắn",
    example: "nổi rôm đầy người * bị rôm cắn",
  },
  {
    word: "rôm",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) rôm rả (nói tắt): trò chuyện rất rôm",
    example: "trò chuyện rất rôm",
  },
  {
    word: "rôm rả",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) phong phú về nội dung và tạo được không khí sôi nổi, vui vẻ: chuyện trò rôm rả * nối lời cho câu chuyện thêm phần rôm rả",
    example: "chuyện trò rôm rả * nối lời cho câu chuyện thêm phần rôm rả",
  },
  {
    word: "rốn",
    part_of_speech: "danh từ",
    meaning:
      "(Nam rún) ống dẫn máu từ nhau vào bào thai: cuống rốn * nơi chôn nhau cắt rốn",
    example: "cuống rốn * nơi chôn nhau cắt rốn",
  },
  {
    word: "rốn",
    part_of_speech: "danh từ",
    meaning:
      "sẹo tròn và nhỏ ở giữa bụng, vết tích còn lại của rốn đã cắt: rốn lồi",
    example: "rốn lồi",
  },
  {
    word: "rốn",
    part_of_speech: "danh từ",
    meaning:
      "chỗ lõm sâu ở giữa hoặc đáy một số vật: rốn biển * rốn của quả bầu",
    example: "rốn biển * rốn của quả bầu",
  },
  {
    word: "rốn",
    part_of_speech: "động từ",
    meaning:
      "cố kéo dài thời gian ở lại nơi nào đó hoặc làm việc gì đó, khi đáng lẽ phải rời đi hoặc phải thôi: làm rốn cho xong * ngủ rốn",
    example: "làm rốn cho xong * ngủ rốn",
  },
  {
    word: "rôm sảy",
    part_of_speech: "danh từ",
    meaning: "rôm (nói khái quát): rôm sảy nổi đầy người",
    example: "rôm sảy nổi đầy người",
  },
  {
    word: "rổn rảng",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả tiếng va chạm mạnh, vang và khô của những vật cứng và giòn: soong nồi khua rổn rảng",
    example: "soong nồi khua rổn rảng",
  },
  {
    word: "rộn",
    part_of_speech: "động từ",
    meaning:
      "(âm thanh, thường là tiếng người) nổi lên liên tiếp, sôi nổi: gà gáy rộn trong thôn * trong nhà rộn lên tiếng nói cười",
    example: "gà gáy rộn trong thôn * trong nhà rộn lên tiếng nói cười",
  },
  {
    word: "rộn",
    part_of_speech: "động từ",
    meaning:
      "ở trạng thái có những cảm xúc tốt đẹp dâng lên mạnh mẽ: trong lòng rộn niềm vui * rộn lên bao cảm xúc",
    example: "trong lòng rộn niềm vui * rộn lên bao cảm xúc",
  },
  {
    word: "rộn ràng",
    part_of_speech: "tính từ",
    meaning:
      "có cái vui dậy lên từ nhiều phía, nhiều hướng do có tác động cùng một lúc của nhiều loại âm thanh, màu sắc: tiếng trống rộn ràng * người xe đi lại rộn ràng",
    example: "tiếng trống rộn ràng * người xe đi lại rộn ràng",
  },
  {
    word: "rộn ràng",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều cảm xúc vui mừng dậy lên trong lòng: lòng rộn ràng niềm vui",
    example: "lòng rộn ràng niềm vui",
  },
  {
    word: "rộn rã",
    part_of_speech: "tính từ",
    meaning:
      'có nhiều âm thanh sôi nổi, vui vẻ và liên tiếp: tiếng dép guốc rộn rã trên nền gạch * "Ta thấy xuân nồng thắm khắp nơi, Trên đường rộn rã tiếng đua cười." (ThLữ; 3)',
    example:
      'tiếng dép guốc rộn rã trên nền gạch * "Ta thấy xuân nồng thắm khắp nơi, Trên đường rộn rã tiếng đua cười." (ThLữ; 3)',
  },
  {
    word: "rộn rã",
    part_of_speech: "tính từ",
    meaning: "có nhiều cảm xúc phấn khởi, sôi nổi: rộn rã niềm vui",
    example: "rộn rã niềm vui",
  },
  {
    word: "rộn rạo",
    part_of_speech: "động từ",
    meaning:
      "ở trạng thái có những xao động trong tình cảm, khiến trong lòng nao nao không yên: lòng rộn rạo những nỗi lo âu",
    example: "lòng rộn rạo những nỗi lo âu",
  },
  {
    word: "rộn rịch",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả không khí hoạt động sôi nổi, có nhiều tiếng động, tấp nập, khẩn trương: làng quê rộn rịch vào mùa",
    example: "làng quê rộn rịch vào mùa",
  },
  {
    word: "rộn rực",
    part_of_speech: "động từ",
    meaning: "(hiếm) như rạo rực: rộn rực một niềm vui khó tả",
    example: "rộn rực một niềm vui khó tả",
  },
  {
    word: "rông",
    part_of_speech: "động từ",
    meaning: "(nước thuỷ triều) dâng lên: con nước rông",
    example: "con nước rông",
  },
  {
    word: "rông",
    part_of_speech: "tính từ",
    meaning:
      "ở tình trạng buông thả, không bị ràng buộc, có thể đi lung tung khắp nơi: chó chạy rông khắp xóm * gà thả rông",
    example: "chó chạy rông khắp xóm * gà thả rông",
  },
  {
    word: "rỗng",
    part_of_speech: "tính từ",
    meaning:
      "không có phần lõi, phần ruột ở bên trong, mà chỉ có lớp vỏ ngoài: tre rỗng ruột * khoét rỗng",
    example: "tre rỗng ruột * khoét rỗng",
  },
  {
    word: "rỗng",
    part_of_speech: "tính từ",
    meaning:
      "không chứa đựng gì ở bên trong: bụng rỗng * thùng rỗng kêu to (tng)",
    example: "bụng rỗng * thùng rỗng kêu to (tng)",
  },
  {
    word: "rống",
    part_of_speech: "động từ",
    meaning: "(một số loài thú) kêu to: sư tử rống * kêu như bò rống",
    example: "sư tử rống * kêu như bò rống",
  },
  {
    word: "rống",
    part_of_speech: "động từ",
    meaning:
      "kêu lên những tiếng to, vang và kéo dài, thường nghe thảm thiết: khóc rống lên",
    example: "khóc rống lên",
  },
  {
    word: "rộng",
    part_of_speech: "tính từ",
    meaning:
      "có khoảng cách bao nhiêu đó từ đầu này đến cuối đầu kia, theo chiều đối lập với chiều dài (gọi là chiều rộng) của vật: vải khổ rộng 90 phân * lòng nhà rộng 4 mét",
    example: "vải khổ rộng 90 phân * lòng nhà rộng 4 mét",
  },
  {
    word: "rộng",
    part_of_speech: "tính từ",
    meaning:
      "có diện tích là bao nhiêu đó: cánh đồng rộng hàng trăm hecta * căn phòng rộng chừng 20m2",
    example: "cánh đồng rộng hàng trăm hecta * căn phòng rộng chừng 20m2",
  },
  {
    word: "rộng",
    part_of_speech: "tính từ",
    meaning:
      "có chiều rộng hoặc diện tích lớn hơn mức bình thường, hoặc lớn hơn so với yêu cầu: biển rộng * đường rộng thênh thang",
    example: "biển rộng * đường rộng thênh thang",
  },
  {
    word: "rộng",
    part_of_speech: "tính từ",
    meaning:
      "có kích thước lớn hơn so với vật cần bọc hoặc cần chứa bên trong: giày rộng, không đi được * áo may hơi rộng",
    example: "giày rộng, không đi được * áo may hơi rộng",
  },
  {
    word: "rộng",
    part_of_speech: "tính từ",
    meaning:
      "có phạm vi lớn hơn mức bình thường: kiến thức rất rộng * phong trào phát triển rộng * nhìn xa trông rộng",
    example:
      "kiến thức rất rộng * phong trào phát triển rộng * nhìn xa trông rộng",
  },
  {
    word: "rộng",
    part_of_speech: "tính từ",
    meaning:
      'có lòng bao dung, có độ lượng, hào phóng trong quan hệ đối xử: ăn ở rộng * rộng lòng tha thứ * "Rộng thương cỏ nội, hoa hèn, Chút thân bèo bọt dám phiền mai sau!" (TKiều)',
    example:
      'ăn ở rộng * rộng lòng tha thứ * "Rộng thương cỏ nội, hoa hèn, Chút thân bèo bọt dám phiền mai sau!" (TKiều)',
  },
  {
    word: "rộng cẳng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) không bận bịu, vướng víu gì, muốn đi đâu tuỳ ý: chưa chồng con gì, còn rộng cẳng mà bay nhảy",
    example: "chưa chồng con gì, còn rộng cẳng mà bay nhảy",
  },
  {
    word: "rỗng không",
    part_of_speech: "tính từ",
    meaning: "rỗng hoàn toàn, không có chút gì: túi rỗng không",
    example: "túi rỗng không",
  },
  {
    word: "rộng lớn",
    part_of_speech: "tính từ",
    meaning:
      "có diện tích hoặc phạm vi rất lớn (nói khái quát): một vùng đất đai rộng lớn * có ảnh hưởng rộng lớn * thị trường rộng lớn",
    example:
      "một vùng đất đai rộng lớn * có ảnh hưởng rộng lớn * thị trường rộng lớn",
  },
  {
    word: "rộng mở",
    part_of_speech: "tính từ",
    meaning: "rộng rãi và cởi mở: tấm lòng rộng mở",
    example: "tấm lòng rộng mở",
  },
  {
    word: "rộng rãi",
    part_of_speech: "tính từ",
    meaning:
      "rộng, tạo cảm giác thoải mái: nhà cửa rộng rãi * tính tình rộng rãi * chi tiêu rộng rãi",
    example: "nhà cửa rộng rãi * tính tình rộng rãi * chi tiêu rộng rãi",
  },
  {
    word: "rộng huếch",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) rộng và mở to ra quá cỡ: miệng cười rộng huếch",
    example: "miệng cười rộng huếch",
  },
  {
    word: "rồng rắn",
    part_of_speech: "danh từ",
    meaning:
      "tổ hợp gợi tả cảnh đám đông nối đuôi nhau thành hàng dài, uốn khúc: xếp hàng rồng rắn * trẻ con rồng rắn kéo nhau đi chơi",
    example: "xếp hàng rồng rắn * trẻ con rồng rắn kéo nhau đi chơi",
  },
  {
    word: "rộng lượng",
    part_of_speech: "tính từ",
    meaning:
      "dễ cảm thông, dễ tha thứ với người có sai sót, lầm lỡ: ăn ở rộng lượng * sống rất rộng lượng",
    example: "ăn ở rộng lượng * sống rất rộng lượng",
  },
  {
    word: "rộng rinh",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ, khẩu ngữ) rộng thênh thang: ngôi nhà rộng rinh",
    example: "ngôi nhà rộng rinh",
  },
  {
    word: "rồng rồng",
    part_of_speech: "danh từ",
    meaning:
      "cá quả, cá sộp con mới nở sống thành đàn: đàn rồng rồng bơi đen mặt nước",
    example: "đàn rồng rồng bơi đen mặt nước",
  },
  {
    word: "rỗng tuếch",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) hoàn toàn trống rỗng (hàm ý chê): nhà cửa rỗng tuếch * đầu óc rỗng tuếch",
    example: "nhà cửa rỗng tuếch * đầu óc rỗng tuếch",
  },
  {
    word: "rốt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ở vị trí cuối cùng trong một trật tự sắp xếp, sau đó không còn ai nữa cả: đứa con rốt * đi sau rốt",
    example: "đứa con rốt * đi sau rốt",
  },
  {
    word: "rỗng tuếch rỗng toác",
    part_of_speech: "tính từ",
    meaning:
      "trống rỗng hoàn toàn, như không có một chút gì bên trong: đầu óc rỗng tuếch rỗng toác",
    example: "đầu óc rỗng tuếch rỗng toác",
  },
  {
    word: "rốt cuộc",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị ý kết quả cuối cùng rồi cũng dẫn đến của sự việc: tính toán mãi, rốt cuộc vẫn chẳng được gì",
    example: "tính toán mãi, rốt cuộc vẫn chẳng được gì",
  },
  {
    word: "rộp",
    part_of_speech: "động từ",
    meaning:
      "(lớp da hoặc lớp vỏ mỏng bên ngoài) phồng lên, thường vì nóng quá: bàn tay rộp lên * lớp sơn đã rộp",
    example: "bàn tay rộp lên * lớp sơn đã rộp",
  },
  {
    word: "rớ",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) vó bắt tôm, cá: cất rớ",
    example: "cất rớ",
  },
  {
    word: "rớ",
    part_of_speech: "động từ",
    meaning: "(phương ngữ, khẩu ngữ) bắt tôm, cá bằng vó: đi rớ cá",
    example: "đi rớ cá",
  },
  {
    word: "rớ",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) sờ đến, động đến: rớ đến cái gì là hỏng cái đấy",
    example: "rớ đến cái gì là hỏng cái đấy",
  },
  {
    word: "rớ",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) gặp được, có được một cách ngẫu nhiên: rớ được cuốn sách hay",
    example: "rớ được cuốn sách hay",
  },
  {
    word: "rơ",
    part_of_speech: "tính từ",
    meaning:
      "(bộ phận trong máy móc) không còn khớp chặt với chi tiết khác nữa (thường do bị mòn nhiều): trục xe bị rơ * bánh xe rơ",
    example: "trục xe bị rơ * bánh xe rơ",
  },
  {
    word: "rỡ",
    part_of_speech: "tính từ",
    meaning:
      '(cũ) sáng ngời một cách đẹp đẽ: nắng vàng rỡ * "Một trận khói tan, Nghìn năm tiết rỡ." (VTNSCG)',
    example: 'nắng vàng rỡ * "Một trận khói tan, Nghìn năm tiết rỡ." (VTNSCG)',
  },
  {
    word: "rợ",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi chung các bộ tộc, dân tộc có đời sống và văn hoá lạc hậu (hàm ý khinh miệt, theo quan điểm kì thị dân tộc thời phong kiến): rợ Hung Nô",
    example: "rợ Hung Nô",
  },
  {
    word: "rợ",
    part_of_speech: "tính từ",
    meaning:
      "(màu sắc) quá sặc sỡ, quá loè loẹt, trông không nhã, không hợp với thị hiếu thông thường: cái áo trông hơi rợ * chiếc áo màu đỏ rợ",
    example: "cái áo trông hơi rợ * chiếc áo màu đỏ rợ",
  },
  {
    word: "rơ le",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ đặt xen trong một mạch điện để tự động ngắt mạch điện theo một điều kiện định trước: rơ le điện từ",
    example: "rơ le điện từ",
  },
  {
    word: "rời",
    part_of_speech: "động từ",
    meaning:
      "di chuyển khỏi chỗ: tàu rời ga * thuyền rời bến * mắt không rời mục tiêu",
    example: "tàu rời ga * thuyền rời bến * mắt không rời mục tiêu",
  },
  {
    word: "rời",
    part_of_speech: "động từ",
    meaning: "tách lìa khỏi: lá rời cành * đứa trẻ không chịu rời mẹ một bước",
    example: "lá rời cành * đứa trẻ không chịu rời mẹ một bước",
  },
  {
    word: "rời",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái từng bộ phận, từng đơn vị được tách riêng ra, độc lập với nhau: đóng những tờ giấy rời thành quyển * tháo rời các chi tiết máy * mỏi rời cả chân tay",
    example:
      "đóng những tờ giấy rời thành quyển * tháo rời các chi tiết máy * mỏi rời cả chân tay",
  },
  {
    word: "rơi",
    part_of_speech: "động từ",
    meaning:
      "di chuyển xuống mặt đất một cách tự nhiên khi không có gì giữ lại ở vị trí trên cao: tuột tay đánh rơi cái cốc * buồn rơi nước mắt",
    example: "tuột tay đánh rơi cái cốc * buồn rơi nước mắt",
  },
  {
    word: "rơi",
    part_of_speech: "động từ",
    meaning:
      "ở vào tình trạng, hoàn cảnh không may: rơi vào tay kẻ cướp * rơi vào thế bị động",
    example: "rơi vào tay kẻ cướp * rơi vào thế bị động",
  },
  {
    word: "rơ moóc",
    part_of_speech: "danh từ",
    meaning:
      "thùng xe rời, thường được kéo theo phía sau một số loại xe ô tô tải, dùng để tăng thêm sức chở hàng hoá của xe, hoặc để chở các kiện hàng đặc biệt: xe có rơ moóc",
    example: "xe có rơ moóc",
  },
  {
    word: "rờ rẫm",
    part_of_speech: "động từ",
    meaning:
      "sờ chỗ này chỗ khác, để nhận biết hoặc tìm kiếm khi mắt không thể nhìn thấy: rờ rẫm trong bóng tối",
    example: "rờ rẫm trong bóng tối",
  },
  {
    word: "rỡ ràng",
    part_of_speech: "tính từ",
    meaning:
      "sáng một cách rực rỡ, đẹp đẽ: y phục rỡ ràng * mặt mày tươi tỉnh, rỡ ràng",
    example: "y phục rỡ ràng * mặt mày tươi tỉnh, rỡ ràng",
  },
  {
    word: "rỡ ràng",
    part_of_speech: "tính từ",
    meaning:
      '(cũ) vẻ vang, rạng rỡ: "Cũng ngôi mệnh phụ đường đường, Nở nang mày mặt, rỡ ràng mẹ cha." (TKiều)',
    example:
      'Cũng ngôi mệnh phụ đường đường, Nở nang mày mặt, rỡ ràng mẹ cha." (TKiều)',
  },
  {
    word: "rời rã",
    part_of_speech: "động từ",
    meaning: "(hiếm) như rã rời: chân tay rời rã",
    example: "chân tay rời rã",
  },
  {
    word: "rơi rớt",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) rơi (nói khái quát): để rơi rớt mấy đồng bạc",
    example: "để rơi rớt mấy đồng bạc",
  },
  {
    word: "rơi rớt",
    part_of_speech: "động từ",
    meaning:
      "còn rớt lại, sót lại (nói khái quát): những thói tục xấu còn rơi rớt lại",
    example: "những thói tục xấu còn rơi rớt lại",
  },
  {
    word: "rời rạc",
    part_of_speech: "tính từ",
    meaning:
      "rời ra thành từng phần, từng bộ phận riêng rẽ, không còn liên tục, không gắn kết với nhau: tiếng mõ rời rạc * câu chuyện rời rạc",
    example: "tiếng mõ rời rạc * câu chuyện rời rạc",
  },
  {
    word: "rơi rụng",
    part_of_speech: "động từ",
    meaning:
      "bị mất dần đi từng ít một, không còn giữ được nguyên vẹn (nói khái quát): cánh hoa rơi rụng lả tả * lâu ngày không sử dụng, vốn tiếng Anh rơi rụng dần",
    example:
      "cánh hoa rơi rụng lả tả * lâu ngày không sử dụng, vốn tiếng Anh rơi rụng dần",
  },
  {
    word: "rớm",
    part_of_speech: "động từ",
    meaning:
      "(máu, nước mắt) ứa ra một ít, chưa thành giọt, thành dòng: mắt rớm lệ * vết thương còn rớm máu",
    example: "mắt rớm lệ * vết thương còn rớm máu",
  },
  {
    word: "rởm",
    part_of_speech: "tính từ",
    meaning:
      "làm ra vẻ sang trọng một cách không phải lối, khiến cho trở thành lố bịch, trớ trêu: rởm đời * đạo đức rởm * đài các rởm!",
    example: "rởm đời * đạo đức rởm * đài các rởm!",
  },
  {
    word: "rởm",
    part_of_speech: "tính từ",
    meaning: "(hàng) giả, kém chất lượng: hàng rởm * mua phải đồ rởm",
    example: "hàng rởm * mua phải đồ rởm",
  },
  {
    word: "rơm rạ",
    part_of_speech: "danh từ",
    meaning: "rơm và rạ (nói khái quát): rơm rạ phơi đầy sân",
    example: "rơm rạ phơi đầy sân",
  },
  {
    word: "rơm",
    part_of_speech: "danh từ",
    meaning:
      "phần trên của thân cây lúa đã gặt và đập hết hạt: bện chổi rơm * bùi nhùi rơm",
    example: "bện chổi rơm * bùi nhùi rơm",
  },
  {
    word: "rơi vãi",
    part_of_speech: "động từ",
    meaning:
      "bị mất dần đi mỗi nơi, mỗi lúc một ít (nói khái quát): thức ăn rơi vãi * thóc bị rơi vãi dọc đường",
    example: "thức ăn rơi vãi * thóc bị rơi vãi dọc đường",
  },
  {
    word: "rơm rác",
    part_of_speech: "danh từ",
    meaning:
      "rơm và rác (nói khái quát); dùng để ví cái không có giá trị, đáng bỏ đi: sân sướng đầy rơm rác * coi người như rơm rác",
    example: "sân sướng đầy rơm rác * coi người như rơm rác",
  },
  {
    word: "rơm rớm",
    part_of_speech: "động từ",
    meaning: "rớm ra chút ít trên bề mặt: tay rơm rớm máu * rơm rớm nước mắt",
    example: "tay rơm rớm máu * rơm rớm nước mắt",
  },
  {
    word: "rớp",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) việc không may gặp phải, vận rủi: "Dớp nhà gặp bước truân chuyên, Tuy nghèo có một nhưng hiền không hai." (PCCH)',
    example:
      'Dớp nhà gặp bước truân chuyên, Tuy nghèo có một nhưng hiền không hai." (PCCH)',
  },
  {
    word: "rớp",
    part_of_speech: "danh từ",
    meaning:
      "việc không may (thường là tai nạn) lặp lại, có thể nhiều lần, giống như đã từng xảy ra: đoạn đường này có dớp, rất hay xảy ra tai nạn",
    example: "đoạn đường này có dớp, rất hay xảy ra tai nạn",
  },
  {
    word: "rờn rợn",
    part_of_speech: "",
    meaning: "có cảm giác hơi rợn: đi đêm cũng thấy rờn rợn",
    example: "đi đêm cũng thấy rờn rợn",
  },
  {
    word: "rợn",
    part_of_speech: "",
    meaning:
      "có cảm giác lạnh người, hơi rùng mình, thường do quá sợ: tiếng hú nghe rợn cả người * sợ đến rợn tóc gáy",
    example: "tiếng hú nghe rợn cả người * sợ đến rợn tóc gáy",
  },
  {
    word: "rớt",
    part_of_speech: "động từ",
    meaning:
      "rơi ra một vài giọt: làm rớt nước mắm ra mâm * thương rớt nước mắt",
    example: "làm rớt nước mắm ra mâm * thương rớt nước mắt",
  },
  {
    word: "rớt",
    part_of_speech: "động từ",
    meaning:
      "còn sót lại của một cái gì đã qua đi, đã không còn nữa: những tàn tích cũ còn rớt lại",
    example: "những tàn tích cũ còn rớt lại",
  },
  {
    word: "rớt",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) như rơi (ng1): làm rớt cái bút * rớt quyển sách xuống dưới gầm bàn",
    example: "làm rớt cái bút * rớt quyển sách xuống dưới gầm bàn",
  },
  {
    word: "rớt",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) trượt (trong thi cử): thi rớt * bị rớt môn toán",
    example: "thi rớt * bị rớt môn toán",
  },
  {
    word: "rớt giá",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) giảm giá, mất giá nhiều so với bình thường: cà phê rớt giá * lúa rớt giá liên tục",
    example: "cà phê rớt giá * lúa rớt giá liên tục",
  },
  {
    word: "rợp",
    part_of_speech: "tính từ",
    meaning: "có nhiều bóng mát, do được che chắn: đường làng rợp bóng tre",
    example: "đường làng rợp bóng tre",
  },
  {
    word: "rợp",
    part_of_speech: "tính từ",
    meaning:
      'nhiều, đến mức dày đặc, như phủ kín cả: cờ, hoa, biểu ngữ rợp trời * "Bao giờ mười vạn tinh binh, Tiếng chiêng dậy đất, bóng tinh rợp đường." (TKiều)',
    example:
      'cờ, hoa, biểu ngữ rợp trời * "Bao giờ mười vạn tinh binh, Tiếng chiêng dậy đất, bóng tinh rợp đường." (TKiều)',
  },
  {
    word: "rũ",
    part_of_speech: "động từ",
    meaning:
      '(Văn chương) trút sạch khỏi mình những gì coi là vướng víu: "Xót thay chiếc lá bơ vơ!, Kiếp trần, biết rũ bao giờ cho xong?" (TKiều)',
    example:
      'Xót thay chiếc lá bơ vơ!, Kiếp trần, biết rũ bao giờ cho xong?" (TKiều)',
  },
  {
    word: "rủ",
    part_of_speech: "động từ",
    meaning:
      'bảo cho người khác nghe theo để cùng làm với mình: rủ bạn về quê chơi * "Rủ nhau đi cấy đi cày, Bây giờ khó nhọc, có ngày phong lưu." (Cdao)',
    example:
      'rủ bạn về quê chơi * "Rủ nhau đi cấy đi cày, Bây giờ khó nhọc, có ngày phong lưu." (Cdao)',
  },
  {
    word: "rủ",
    part_of_speech: "động từ",
    meaning:
      'buông thõng từ trên cao xuống một cách tự nhiên: liễu rủ xuống mặt hồ * những sợi tóc rủ xuống trán * "Êm đềm trướng rủ màn che, Tường đông ong bướm đi về mặc ai." (TKiều)',
    example:
      'liễu rủ xuống mặt hồ * những sợi tóc rủ xuống trán * "Êm đềm trướng rủ màn che, Tường đông ong bướm đi về mặc ai." (TKiều)',
  },
  {
    word: "rú",
    part_of_speech: "danh từ",
    meaning:
      '(phương ngữ) núi có nhiều cây cối rậm rạp: "Chim bay về rú, về non, Cá kia về vực, anh còn đợi em." (ca dao)',
    example: 'Chim bay về rú, về non, Cá kia về vực, anh còn đợi em." (ca dao)',
  },
  {
    word: "rú",
    part_of_speech: "động từ",
    meaning:
      "bật lên tiếng kêu to và dài, thường do bị tác động quá bất ngờ: mừng rú lên * sợ quá, rú lên một tiếng",
    example: "mừng rú lên * sợ quá, rú lên một tiếng",
  },
  {
    word: "rú",
    part_of_speech: "động từ",
    meaning:
      "phát ra những tiếng to và dài: còi báo động rú lên * xe máy rú ga",
    example: "còi báo động rú lên * xe máy rú ga",
  },
  {
    word: "ru",
    part_of_speech: "động từ",
    meaning:
      'hát nhẹ và êm, thường kèm với động tác vỗ vễ nhằm tác động cho trẻ dễ ngủ: lời ru * êm như ru * "Gió mùa thu mẹ ru con ngủ, Năm canh chầy, thức đủ năm canh." (Cdao)',
    example:
      'lời ru * êm như ru * "Gió mùa thu mẹ ru con ngủ, Năm canh chầy, thức đủ năm canh." (Cdao)',
  },
  {
    word: "rủ áo chắp tay",
    part_of_speech: "",
    meaning: "như chắp tay rủ áo.",
    example: "hơi may se sắt * gió thu se sắt",
  },
  {
    word: "ru hời",
    part_of_speech: "động từ",
    meaning: "ru (nói khái quát): à ơi tiếng mẹ ru hời",
    example: "à ơi tiếng mẹ ru hời",
  },
  {
    word: "rù",
    part_of_speech: "tính từ",
    meaning:
      "(gà) mắc bệnh dịch ỉa chảy, phân trắng, diều căng (thường đứng xù lông, ủ rũ): đàn gà bị rù, chết gần hết",
    example: "đàn gà bị rù, chết gần hết",
  },
  {
    word: "rù",
    part_of_speech: "tính từ",
    meaning: "có dáng điệu co ro, ủ rũ, thiếu linh lợi: ngồi rù ở góc nhà",
    example: "ngồi rù ở góc nhà",
  },
  {
    word: "rủ lòng",
    part_of_speech: "động từ",
    meaning:
      "nghĩ đến mà ban cho một điều nào đó, coi như ân huệ: xin ngài rủ lòng thương",
    example: "xin ngài rủ lòng thương",
  },
  {
    word: "ru lô",
    part_of_speech: "danh từ",
    meaning:
      "vật hình trụ dùng để lăn, cuốn, v.v.: dùng ru lô lăn mực * quấn tóc vào ru lô",
    example: "dùng ru lô lăn mực * quấn tóc vào ru lô",
  },
  {
    word: "ru ngủ",
    part_of_speech: "động từ",
    meaning:
      "làm mê muội tinh thần và tê liệt ý chí đấu tranh: những bài hát ru ngủ thanh niên * luận điệu ru ngủ",
    example: "những bài hát ru ngủ thanh niên * luận điệu ru ngủ",
  },
  {
    word: "rù rì",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) chậm chạp, có vẻ nặng nhọc, không nhanh nhẹn: con tàu rù rì như sên bò",
    example: "con tàu rù rì như sên bò",
  },
  {
    word: "rù rì",
    part_of_speech: "động từ",
    meaning: "(hiếm) như rủ rỉ (nhưng nghe nhẹ hơn): rù rì nói chuyện",
    example: "rù rì nói chuyện",
  },
  {
    word: "rủ rê",
    part_of_speech: "động từ",
    meaning:
      "rủ, lôi kéo làm việc xấu (nói khái quát): bị đám bạn xấu rủ rê * nghe theo lời rủ rê mà làm bậy",
    example: "bị đám bạn xấu rủ rê * nghe theo lời rủ rê mà làm bậy",
  },
  {
    word: "rủ rỉ",
    part_of_speech: "động từ",
    meaning:
      'nói nhỏ nhẹ, chậm rãi, vừa đủ để cho nhau nghe, vẻ thân mật: giọng rủ rỉ * rủ rỉ tâm sự * "Bẻ bai, rủ rỉ tiếng tơ, Trầm bay nhạt khói, gió đưa lay rèm." (TKiều)',
    example:
      'giọng rủ rỉ * rủ rỉ tâm sự * "Bẻ bai, rủ rỉ tiếng tơ, Trầm bay nhạt khói, gió đưa lay rèm." (TKiều)',
  },
  {
    word: "ru rú",
    part_of_speech: "động từ",
    meaning:
      "(sống) quanh quẩn ở một nơi chật hẹp nào đó, không dám đi ra ngoài, không đi đâu xa: suốt ngày ru rú trong nhà",
    example: "suốt ngày ru rú trong nhà",
  },
  {
    word: "rũ rượi",
    part_of_speech: "tính từ",
    meaning: "(tóc) rối bù và xoã xuống: đầu tóc rũ rượi",
    example: "đầu tóc rũ rượi",
  },
  {
    word: "rũ rượi",
    part_of_speech: "tính từ",
    meaning:
      "có vẻ ngoài mệt mỏi, bơ phờ, người như rũ xuống: mệt rũ rượi * ho rũ rượi",
    example: "mệt rũ rượi * ho rũ rượi",
  },
  {
    word: "rũ rượi",
    part_of_speech: "tính từ",
    meaning:
      "(cười) nhiều đến nghiêng ngả, rũ người xuống, do không kìm nén được: cười rũ rượi",
    example: "cười rũ rượi",
  },
  {
    word: "rũ tù",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bị giam, có thể cho đến chết rũ ở trong tù: phen này thì cứ gọi là rũ tù!",
    example: "phen này thì cứ gọi là rũ tù!",
  },
  {
    word: "rù rờ",
    part_of_speech: "tính từ",
    meaning: "có vẻ chậm chạp, thiếu linh hoạt: dáng vẻ rù rờ",
    example: "dáng vẻ rù rờ",
  },
  {
    word: "rủ rỉ rù rì",
    part_of_speech: "động từ",
    meaning:
      'như rủ rỉ (nhưng ý nhấn mạnh hơn): "Đêm qua rủ rỉ rù rì, Tiếng nặng bằng bấc tiếng chì bằng bông." (ca dao)',
    example:
      'Đêm qua rủ rỉ rù rì, Tiếng nặng bằng bấc tiếng chì bằng bông." (ca dao)',
  },
  {
    word: "ru-bi",
    part_of_speech: "danh từ",
    meaning:
      "đá quý màu hồng, trong suốt, thường dùng làm đồ trang sức, làm chân kính đồng hồ: đá hồng ngọc * mặt dây chuyền làm bằng hồng ngọc",
    example: "đá hồng ngọc * mặt dây chuyền làm bằng hồng ngọc",
  },
  {
    word: "rùa",
    part_of_speech: "danh từ",
    meaning:
      "động vật thuộc lớp bò sát, có mai bảo vệ cơ thể, di chuyển chậm chạp: chậm như rùa",
    example: "chậm như rùa",
  },
  {
    word: "rủa",
    part_of_speech: "động từ",
    meaning:
      "dùng những lời độc địa cầu cho người mình căm ghét sẽ gặp những điều không lành: rủa thầm * đừng có rủa!",
    example: "rủa thầm * đừng có rủa!",
  },
  {
    word: "rua",
    part_of_speech: "động từ",
    meaning:
      "tạo ra các hình trang trí trên đồ vải bằng cách rút bớt sợi vải ra và buộc các sợi còn lại, hoặc luồn thêm các sợi màu vào: rua áo gối * rua khăn * rua rèm cửa",
    example: "rua áo gối * rua khăn * rua rèm cửa",
  },
  {
    word: "rúc",
    part_of_speech: "động từ",
    meaning:
      "chui vào chỗ hẹp hoặc kín: con chó rúc vào bụi cây * bé rúc đầu vào lòng mẹ",
    example: "con chó rúc vào bụi cây * bé rúc đầu vào lòng mẹ",
  },
  {
    word: "rúc",
    part_of_speech: "động từ",
    meaning:
      "dùng mỏ hoặc mõm để mò, rỉa thức ăn: vịt rúc xuống bùn * lợn rúc mõm",
    example: "vịt rúc xuống bùn * lợn rúc mõm",
  },
  {
    word: "rúc",
    part_of_speech: "động từ",
    meaning: "kêu to và thành hồi dài: tiếng còi tàu rúc lên",
    example: "tiếng còi tàu rúc lên",
  },
  {
    word: "rúc rích",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng cùng cười với nhau nhỏ nhưng đầy vẻ thích thú: cười rúc rích",
    example: "cười rúc rích",
  },
  {
    word: "ruby",
    part_of_speech: "danh từ",
    meaning:
      "đá quý màu hồng, trong suốt, thường dùng làm đồ trang sức, làm chân kính đồng hồ: đá hồng ngọc * mặt dây chuyền làm bằng hồng ngọc",
    example: "đá hồng ngọc * mặt dây chuyền làm bằng hồng ngọc",
  },
  {
    word: "rủa sả",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) rủa nhiều và bằng những lời độc ác, cay nghiệt (nói khái quát): vừa xỉa xói, vừa rủa sả",
    example: "vừa xỉa xói, vừa rủa sả",
  },
  {
    word: "rục rịch",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) có những hoạt động chuẩn bị để sắp sửa làm việc gì: rục rịch chuyển nhà * rục rịch lấy vợ",
    example: "rục rịch chuyển nhà * rục rịch lấy vợ",
  },
  {
    word: "rục rịch",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) như cựa quậy: ngồi im không rục rịch * cứ rục rịch, day trở người luôn",
    example: "ngồi im không rục rịch * cứ rục rịch, day trở người luôn",
  },
  {
    word: "rục",
    part_of_speech: "tính từ",
    meaning: "chín tơi ra, nhừ ra: chuối chín rục",
    example: "chuối chín rục",
  },
  {
    word: "rục",
    part_of_speech: "tính từ",
    meaning: "như rũ (ng2): tù rục xương * chết rục",
    example: "tù rục xương * chết rục",
  },
  {
    word: "rủi",
    part_of_speech: "danh từ",
    meaning:
      "điều không lành, không tốt xảy đến một cách bất ngờ: gặp rủi * may nhờ, rủi chịu",
    example: "gặp rủi * may nhờ, rủi chịu",
  },
  {
    word: "rủi",
    part_of_speech: "tính từ",
    meaning:
      "ở trong tình hình gặp điều không may: rủi quá, bị kẻ gian móc túi mất hết * rủi có bề gì thì sao?",
    example: "rủi quá, bị kẻ gian móc túi mất hết * rủi có bề gì thì sao?",
  },
  {
    word: "rùm",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) như rầm (ng2): tức quá, la rùm lên",
    example: "tức quá, la rùm lên",
  },
  {
    word: "rủi ro",
    part_of_speech: "",
    meaning:
      'rủi (nói khái quát): điều rủi ro * gặp rủi ro * "Phận mình sao khéo rủi ro, Đã đi tới giếng, quảy vò về không." (ca dao)',
    example:
      'điều rủi ro * gặp rủi ro * "Phận mình sao khéo rủi ro, Đã đi tới giếng, quảy vò về không." (ca dao)',
  },
  {
    word: "rúm",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái bị thu nhỏ và méo mó, biến dạng đi: chân tay co rúm * rúm người lại vì sợ",
    example: "chân tay co rúm * rúm người lại vì sợ",
  },
  {
    word: "rụm",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) như rụi (ng2): cháy rụm * ngã rụm",
    example: "cháy rụm * ngã rụm",
  },
  {
    word: "rum",
    part_of_speech: "danh từ",
    meaning: "rượu mạnh, cất bằng mật mía: mua một chai rum",
    example: "mua một chai rum",
  },
  {
    word: "rúm ró",
    part_of_speech: "tính từ",
    meaning:
      "rúm lại, trông xấu xí (nói khái quát): chiếc bị cói rúm ró * quần áo khâu rúm ró",
    example: "chiếc bị cói rúm ró * quần áo khâu rúm ró",
  },
  {
    word: "rùm beng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ầm ĩ lên, làm cho to chuyện (thường để phô trương thanh thế): quảng cáo rùm beng * làm rùm beng lên",
    example: "quảng cáo rùm beng * làm rùm beng lên",
  },
  {
    word: "rum-ba",
    part_of_speech: "danh từ",
    meaning: "điệu nhạc múa có nguồn gốc từ Cuba: nhảy theo điệu rumba",
    example: "nhảy theo điệu rumba",
  },
  {
    word: "rụi",
    part_of_speech: "động từ",
    meaning:
      "ngã gục xuống, đổ sập xuống: cháy rụi * căn nhà bị đổ rụi * rụi xuống vì kiệt sức",
    example: "cháy rụi * căn nhà bị đổ rụi * rụi xuống vì kiệt sức",
  },
  {
    word: "rumba",
    part_of_speech: "danh từ",
    meaning: "điệu nhạc múa có nguồn gốc từ Cuba: nhảy theo điệu rumba",
    example: "nhảy theo điệu rumba",
  },
  {
    word: "rún",
    part_of_speech: "danh từ",
    meaning:
      "(Nam rún) ống dẫn máu từ nhau vào bào thai: cuống rốn * nơi chôn nhau cắt rốn",
    example: "cuống rốn * nơi chôn nhau cắt rốn",
  },
  {
    word: "rún",
    part_of_speech: "danh từ",
    meaning:
      "sẹo tròn và nhỏ ở giữa bụng, vết tích còn lại của rốn đã cắt: rốn lồi",
    example: "rốn lồi",
  },
  {
    word: "rún",
    part_of_speech: "danh từ",
    meaning:
      "chỗ lõm sâu ở giữa hoặc đáy một số vật: rốn biển * rốn của quả bầu",
    example: "rốn biển * rốn của quả bầu",
  },
  {
    word: "rún",
    part_of_speech: "động từ",
    meaning:
      "cố kéo dài thời gian ở lại nơi nào đó hoặc làm việc gì đó, khi đáng lẽ phải rời đi hoặc phải thôi: làm rốn cho xong * ngủ rốn",
    example: "làm rốn cho xong * ngủ rốn",
  },
  {
    word: "run rủi",
    part_of_speech: "động từ",
    meaning:
      'xui khiến nên, do một nguyên nhân thần bí nào đó: số phận run rủi cho hai người gặp nhau * "Đường tác hợp trời kia run rủi, Trốn làm sao cho khỏi nhân tình." (CO)',
    example:
      'số phận run rủi cho hai người gặp nhau * "Đường tác hợp trời kia run rủi, Trốn làm sao cho khỏi nhân tình." (CO)',
  },
  {
    word: "rùn",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) co rụt làm cho thấp xuống: rùn cổ lại * rùn chân ngồi xuống",
    example: "rùn cổ lại * rùn chân ngồi xuống",
  },
  {
    word: "run",
    part_of_speech: "động từ",
    meaning:
      "bị rung động nhẹ chân tay hoặc cơ thể do sự co giật khẽ của các cơ, gây ra bởi do một nguyên nhân về sinh lí hay tâm lí nào đó: rét run * run bần bật",
    example: "rét run * run bần bật",
  },
  {
    word: "run",
    part_of_speech: "động từ",
    meaning:
      "(giọng nói, nét chữ) có trạng thái không bình thường do khi nói, khi viết bị run: nét chữ hơi run * giọng run lên vì giận dữ",
    example: "nét chữ hơi run * giọng run lên vì giận dữ",
  },
  {
    word: "run rẩy",
    part_of_speech: "động từ",
    meaning:
      "run mạnh và liên tiếp, vẻ yếu ớt: sợ quá, chân tay run rẩy * đôi môi run rẩy, không nói thành lời",
    example: "sợ quá, chân tay run rẩy * đôi môi run rẩy, không nói thành lời",
  },
  {
    word: "rung",
    part_of_speech: "động từ",
    meaning:
      'làm chuyển động qua lại nhanh và liên tiếp, không theo một hướng nhất định: rung chuông * "Đố ai quét sạch lá rừng, Để ta khuyên gió, gió đừng rung cây." (Cdao)',
    example:
      'rung chuông * "Đố ai quét sạch lá rừng, Để ta khuyên gió, gió đừng rung cây." (Cdao)',
  },
  {
    word: "rủn",
    part_of_speech: "động từ",
    meaning:
      "ở trạng thái rã rời, không tự điều khiển được nữa vì mệt mỏi hay sợ hãi quá mức: sợ rủn người * lạnh rủn cả chân tay",
    example: "sợ rủn người * lạnh rủn cả chân tay",
  },
  {
    word: "run sợ",
    part_of_speech: "động từ",
    meaning:
      "run lên vì sợ, tỏ ra rất sợ (nói khái quát): tiếng thét làm đứa trẻ run sợ * không run sợ trước họng súng của kẻ thù",
    example:
      "tiếng thét làm đứa trẻ run sợ * không run sợ trước họng súng của kẻ thù",
  },
  {
    word: "rùng",
    part_of_speech: "danh từ",
    meaning:
      "lưới hình chữ nhật dài dùng để đánh cá biển: đánh rùng * kéo rùng",
    example: "đánh rùng * kéo rùng",
  },
  {
    word: "rùng",
    part_of_speech: "động từ",
    meaning:
      "bất ngờ rung lên một cái, do bị chấn động hay bị một tác động mạnh đột ngột: mặt đất rùng lên * rùng người vì lạnh",
    example: "mặt đất rùng lên * rùng người vì lạnh",
  },
  {
    word: "rùng",
    part_of_speech: "động từ",
    meaning:
      "lắc nhẹ để làm cho vật rời chứa đựng ở trong dồn vào giữa: rùng sàng * rùng rây bột",
    example: "rùng sàng * rùng rây bột",
  },
  {
    word: "rung động",
    part_of_speech: "động từ",
    meaning:
      "chuyển động qua lại liên tiếp không theo một hướng xác định, do một tác động từ bên ngoài: cành cây rung động vì gió * cánh cửa rung động",
    example: "cành cây rung động vì gió * cánh cửa rung động",
  },
  {
    word: "rung động",
    part_of_speech: "động từ",
    meaning:
      "tác động đến tình cảm, làm nảy sinh cảm xúc: cảnh đẹp làm rung động lòng người * con tim rung động",
    example: "cảnh đẹp làm rung động lòng người * con tim rung động",
  },
  {
    word: "rụng",
    part_of_speech: "động từ",
    meaning:
      "rời ra, lìa ra và rơi xuống: lá rụng * khế chín rụng đầy gốc * thuốc chống rụng tóc",
    example: "lá rụng * khế chín rụng đầy gốc * thuốc chống rụng tóc",
  },
  {
    word: "rùng mình",
    part_of_speech: "động từ",
    meaning:
      "rùng mạnh toàn thân một cách bất ngờ, do sợ hãi hoặc bị lạnh đột ngột: rùng mình vì lạnh * cảnh tượng ấy, ai nhìn thấy cũng phải rùng mình",
    example:
      "rùng mình vì lạnh * cảnh tượng ấy, ai nhìn thấy cũng phải rùng mình",
  },
  {
    word: "rủng rẻng",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng va chạm của những vật nhỏ bằng kim loại: tiền xu rủng rẻng trong túi * sợi xích sắt khua rủng rẻng",
    example: "tiền xu rủng rẻng trong túi * sợi xích sắt khua rủng rẻng",
  },
  {
    word: "rúng động",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) rung chuyển, rung động: bom nổ làm rúng động cả toà nhà",
    example: "bom nổ làm rúng động cả toà nhà",
  },
  {
    word: "rung rinh",
    part_of_speech: "động từ",
    meaning:
      'rung động nhẹ và liên tiếp: cánh hoa rung rinh trước gió * "Seo Mẩy đi trước. (...) Cái váy hoa rung rinh, xập xoè theo bước đi (...)" (MVKháng; 13)',
    example:
      'cánh hoa rung rinh trước gió * "Seo Mẩy đi trước. (...) Cái váy hoa rung rinh, xập xoè theo bước đi (...)" (MVKháng; 13)',
  },
  {
    word: "rung rinh",
    part_of_speech: "động từ",
    meaning: "(hiếm) như rung chuyển: xe chạy làm rung rinh mặt đường",
    example: "xe chạy làm rung rinh mặt đường",
  },
  {
    word: "rung chuyển",
    part_of_speech: "động từ",
    meaning:
      "rung động mạnh, đến mức có thể làm lay chuyển cái vốn có nền tảng vững chắc: mặt đất rung chuyển",
    example: "mặt đất rung chuyển",
  },
  {
    word: "rủng rỉnh",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như rủng rẻng (nhưng thường nói về tiền).",
    example: "tiền bạc rủng rỉnh * đến mùa, thóc lúa rủng rỉnh",
  },
  {
    word: "rung cảm",
    part_of_speech: "động từ",
    meaning:
      "cảm thấy hoặc làm cho rung động trong lòng: bài thơ làm rung cảm lòng người",
    example: "bài thơ làm rung cảm lòng người",
  },
  {
    word: "ruốc",
    part_of_speech: "danh từ",
    meaning:
      "tép nhỏ ở biển, mình tròn và trắng, thường dùng làm mắm: con ruốc",
    example: "con ruốc",
  },
  {
    word: "ruốc",
    part_of_speech: "danh từ",
    meaning: "loại mắm làm từ con ruốc để ngấu: mắm ruốc",
    example: "mắm ruốc",
  },
  {
    word: "ruốc",
    part_of_speech: "danh từ",
    meaning:
      "(Nam chà bông) món ăn làm bằng thịt nạc, cá hoặc tôm luộc, rim với nước mắm rồi giã nhỏ và rang khô: ruốc thịt * giã ruốc",
    example: "ruốc thịt * giã ruốc",
  },
  {
    word: "ruồi xanh",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) rối rít, ồn ào quá mức cần thiết, gây cảm giác khó chịu đến phát ghét: đàn chó sủa nhặng * kêu nhặng lên * động một tí là nhặng lên!",
    example: "đàn chó sủa nhặng * kêu nhặng lên * động một tí là nhặng lên!",
  },
  {
    word: "ruồi nhặng",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) rối rít, ồn ào quá mức cần thiết, gây cảm giác khó chịu đến phát ghét: đàn chó sủa nhặng * kêu nhặng lên * động một tí là nhặng lên!",
    example: "đàn chó sủa nhặng * kêu nhặng lên * động một tí là nhặng lên!",
  },
  {
    word: "ruộng",
    part_of_speech: "danh từ",
    meaning:
      "đất trồng trọt ở ngoài đồng, xung quanh thường có bờ: ruộng khoai * cày ruộng * tát nước vào ruộng",
    example: "ruộng khoai * cày ruộng * tát nước vào ruộng",
  },
  {
    word: "ruồng",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) càn: giặc đi ruồng",
    example: "giặc đi ruồng",
  },
  {
    word: "ruộng cả ao liền",
    part_of_speech: "",
    meaning:
      'tả cơ ngơi giàu có ở nông thôn thời trước (có ruộng rộng bát ngát, nhiều ao cá liền bờ): "Chẳng tham ruộng cả ao liền, Tham vì cái bút cái nghiên anh đồ." (ca dao)',
    example:
      'Chẳng tham ruộng cả ao liền, Tham vì cái bút cái nghiên anh đồ." (ca dao)',
  },
  {
    word: "ruồng bỏ",
    part_of_speech: "động từ",
    meaning:
      "ghét bỏ, không ngó ngàng gì đến nữa: ruồng bỏ con cái * bị chồng ruồng bỏ",
    example: "ruồng bỏ con cái * bị chồng ruồng bỏ",
  },
  {
    word: "ruỗng",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái đã bị một quá trình huỷ hoại từ bên trong, làm cho thực tế chỉ còn có lớp bên ngoài: mặt bàn bị mọt ăn ruỗng",
    example: "mặt bàn bị mọt ăn ruỗng",
  },
  {
    word: "ruồng bố",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) càn quét: địch ruồng bố liên miên",
    example: "địch ruồng bố liên miên",
  },
  {
    word: "ruộng đất",
    part_of_speech: "danh từ",
    meaning:
      "đất trồng trọt, về mặt là tư liệu sản xuất (nói khái quát): cải cách ruộng đất * hợp tác xã họp để chia lại ruộng đất",
    example: "cải cách ruộng đất * hợp tác xã họp để chia lại ruộng đất",
  },
  {
    word: "rụng rời",
    part_of_speech: "động từ",
    meaning:
      'cảm thấy chân tay rã rời, thường do quá khiếp sợ: rụng rời chân tay * "Điều đâu sét đánh lưng trời, Thoắt nghe, chàng thoắt rụng rời xiết bao!" (TKiều)',
    example:
      'rụng rời chân tay * "Điều đâu sét đánh lưng trời, Thoắt nghe, chàng thoắt rụng rời xiết bao!" (TKiều)',
  },
  {
    word: "ruộng nương",
    part_of_speech: "danh từ",
    meaning:
      "ruộng đất trồng trọt (nói khái quát): ruộng nương bị bỏ hoang  * nhà cửa, ruộng nương phải bán sạch vì cờ bạc",
    example:
      "ruộng nương bị bỏ hoang  * nhà cửa, ruộng nương phải bán sạch vì cờ bạc",
  },
  {
    word: "rùng rợn",
    part_of_speech: "tính từ",
    meaning:
      "có tác dụng gây cảm giác sợ hãi đến rợn người: chuyện li kì, rùng rợn * tiếng hú nghe rùng rợn",
    example: "chuyện li kì, rùng rợn * tiếng hú nghe rùng rợn",
  },
  {
    word: "rùng rùng",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả sự chuyển động mạnh mẽ cùng một lúc của số đông: con tàu rùng rùng chuyển bánh",
    example: "con tàu rùng rùng chuyển bánh",
  },
  {
    word: "ruồng rẫy",
    part_of_speech: "động từ",
    meaning:
      'hắt hủi, tỏ ra muốn ruồng bỏ: ruồng rẫy vợ con * "Bây giờ đã ra lòng ruồng rẫy, Để thân này nước chảy hoa trôi." (CO)',
    example:
      'ruồng rẫy vợ con * "Bây giờ đã ra lòng ruồng rẫy, Để thân này nước chảy hoa trôi." (CO)',
  },
  {
    word: "ruộng vườn",
    part_of_speech: "danh từ",
    meaning:
      "ruộng và vườn (nói khái quát): ruộng vườn nhà cửa * chăm lo ruộng vườn",
    example: "ruộng vườn nhà cửa * chăm lo ruộng vườn",
  },
  {
    word: "ruộng rẫy",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như ruộng nương: chăm lo ruộng rẫy",
    example: "chăm lo ruộng rẫy",
  },
  {
    word: "ruột",
    part_of_speech: "danh từ",
    meaning: "phần của ống tiêu hoá từ cuối dạ dày đến hậu môn.",
    example: "ruột phích * ruột bút chì * ruột bánh mì",
  },
  {
    word: "ruột",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận bên trong của một số vật: ruột phích * ruột bút chì * ruột bánh mì",
    example:
      'thương con đứt ruột * "Cánh buồm bao quản gió xiêu, Nhớ em ruột thắt chín chiều quặn đau." (ca dao)',
  },
  {
    word: "ruột",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về mối quan hệ giữa cha mẹ và con cái, giữa những người cùng cha mẹ hoặc giữa những người có cùng cha mẹ với con cái của họ: anh em ruột * đi thăm ông bác ruột * cháu ruột",
    example: "anh em ruột * đi thăm ông bác ruột * cháu ruột",
  },
  {
    word: "ruột",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ, khẩu ngữ) gần gũi, thân thiết như ruột thịt: bồ ruột (bạn thân nhất) * chiến hữu ruột * khách hàng ruột",
    example: "bồ ruột (bạn thân nhất) * chiến hữu ruột * khách hàng ruột",
  },
  {
    word: "ruột để ngoài da",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tả tính người thật thà, bộp chộp, không giấu giếm ai điều gì, cũng không giận ai lâu: ruột để ngoài da, nói xong lại thôi",
    example: "ruột để ngoài da, nói xong lại thôi",
  },
  {
    word: "ruột gà",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) lò xo có hình dây xoắn thành nhiều vòng bằng nhau: thay ruột gà của chiếc bật lửa",
    example: "thay ruột gà của chiếc bật lửa",
  },
  {
    word: "ruột gan",
    part_of_speech: "danh từ",
    meaning:
      'ruột và gan của con người, được coi là biểu tượng của sự chịu đựng hay sự quan tâm của con người, nhưng được giữ kín, không bộc lộ ra, nói chung: ruột gan như lửa đốt * "Ruột gan chẳng đánh mà đau, Nhân duyên chia rẽ nên sầu thảm thương." (ca dao)',
    example:
      'ruột gan như lửa đốt * "Ruột gan chẳng đánh mà đau, Nhân duyên chia rẽ nên sầu thảm thương." (ca dao)',
  },
  {
    word: "ruột tượng",
    part_of_speech: "danh từ",
    meaning:
      "bao vải dài dùng để đựng tiền hay gạo, đeo quanh bụng hoặc ngang lưng: lần ruột tượng lấy tiền",
    example: "lần ruột tượng lấy tiền",
  },
  {
    word: "ruột thừa",
    part_of_speech: "danh từ",
    meaning:
      "mẩu ruột nhỏ hình giống đầu con giun chìa ra ở đầu trên ruột già, không có tác dụng gì trong việc tiêu hoá: đau ruột thừa * mổ ruột thừa",
    example: "đau ruột thừa * mổ ruột thừa",
  },
  {
    word: "ruột rà",
    part_of_speech: "tính từ",
    meaning:
      'như ruột thịt (nhưng ý không nhấn mạnh bằng): anh em ruột rà * "Đắng cay cũng thể ruột rà, Ngọt ngào cho lắm cũng là người dưng." (ca dao)',
    example:
      'anh em ruột rà * "Đắng cay cũng thể ruột rà, Ngọt ngào cho lắm cũng là người dưng." (ca dao)',
  },
  {
    word: "ruột thịt",
    part_of_speech: "tính từ",
    meaning:
      "có quan hệ cùng máu mủ hoặc thân thiết, gắn bó như những người cùng máu mủ: anh em ruột thịt * tình máu mủ ruột thịt",
    example: "anh em ruột thịt * tình máu mủ ruột thịt",
  },
  {
    word: "rụp",
    part_of_speech: "",
    meaning:
      "(phương ngữ, khẩu ngữ) ngay lập tức, rất nhanh, rất gọn: điện mất cái rụp * đưa tay chào cái rụp * đồng ý cái rụp",
    example: "điện mất cái rụp * đưa tay chào cái rụp * đồng ý cái rụp",
  },
  {
    word: "rút gọn",
    part_of_speech: "động từ",
    meaning:
      "làm cho có hình thức ngắn gọn, đơn giản hơn: rút gọn câu * rút gọn bản báo cáo * rút gọn phân số",
    example: "rút gọn câu * rút gọn bản báo cáo * rút gọn phân số",
  },
  {
    word: "rụt",
    part_of_speech: "động từ",
    meaning:
      "co lại, thụt lại: rụt vội tay lại * nóng rụt lưỡi * so vai rụt cổ",
    example: "rụt vội tay lại * nóng rụt lưỡi * so vai rụt cổ",
  },
  {
    word: "rút",
    part_of_speech: "động từ",
    meaning:
      "lấy ra, tách ra khỏi một vật chứa hoặc một tập hợp nào đó: rút gươm * rút thẻ * xin rút khỏi danh sách đề cử",
    example: "rút gươm * rút thẻ * xin rút khỏi danh sách đề cử",
  },
  {
    word: "rút",
    part_of_speech: "động từ",
    meaning:
      "lấy trở về, thu trở lại cái đã đưa ra: rút tiền tiết kiệm * xin rút ý kiến * rút đơn tố cáo",
    example: "rút tiền tiết kiệm * xin rút ý kiến * rút đơn tố cáo",
  },
  {
    word: "rút",
    part_of_speech: "động từ",
    meaning:
      "lấy ra cái nội dung mình cần, qua một quá trình so sánh, phân tích, suy luận: rút kinh nghiệm * rút ra nhiều bài học bổ ích * rút ra kết luận",
    example: "rút kinh nghiệm * rút ra nhiều bài học bổ ích * rút ra kết luận",
  },
  {
    word: "rút",
    part_of_speech: "động từ",
    meaning:
      "nắm một đầu (thường là dây) kéo cho di chuyển trượt qua một điểm, một vật cố định nào đó: rút thòng lọng * rút quần áo đã phơi khô * rút ngắn dây lại",
    example: "rút thòng lọng * rút quần áo đã phơi khô * rút ngắn dây lại",
  },
  {
    word: "rút",
    part_of_speech: "động từ",
    meaning:
      "chuyển về một vị trí ở phía sau, phía trong, kín đáo hơn: rút quân * rút vào hoạt động bí mật * rút về tuyến sau",
    example: "rút quân * rút vào hoạt động bí mật * rút về tuyến sau",
  },
  {
    word: "rút",
    part_of_speech: "động từ",
    meaning: "làm giảm bớt: rút chỉ tiêu * rút thời hạn * rút số người",
    example: "rút chỉ tiêu * rút thời hạn * rút số người",
  },
  {
    word: "rút lui",
    part_of_speech: "động từ",
    meaning: "rời bỏ vị trí, trở về phía sau: được lệnh rút lui",
    example: "được lệnh rút lui",
  },
  {
    word: "rút lui",
    part_of_speech: "động từ",
    meaning:
      "rút về, thôi không đưa ra nữa, không tham gia nữa: xin rút lui, không tham gia ứng cử nữa * tuyên bố rút lui khỏi đội tuyển * rút lui ý kiến",
    example:
      "xin rút lui, không tham gia ứng cử nữa * tuyên bố rút lui khỏi đội tuyển * rút lui ý kiến",
  },
  {
    word: "rụt rè",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra e dè không mạnh dạn làm việc gì đó: ăn nói rụt rè * tiếng chân bước rụt rè * muốn xin nhưng còn rụt rè, chưa dám nói",
    example:
      "ăn nói rụt rè * tiếng chân bước rụt rè * muốn xin nhưng còn rụt rè, chưa dám nói",
  },
  {
    word: "rút tiền",
    part_of_speech: "động từ",
    meaning:
      "lấy ra một phần hay toàn bộ số tiền đã gửi ở một quỹ nào đó: rút tiền ở ngân hàng * rút tiền tiết kiệm",
    example: "rút tiền ở ngân hàng * rút tiền tiết kiệm",
  },
  {
    word: "ruy băng",
    part_of_speech: "danh từ",
    meaning:
      "dải dài và hẹp làm bằng vải hoặc nylon, v.v., dùng để trang sức: dây ruy băng * hai bím tóc được buộc bằng hai dải ruy băng hồng",
    example: "dây ruy băng * hai bím tóc được buộc bằng hai dải ruy băng hồng",
  },
  {
    word: "rứa",
    part_of_speech: "",
    meaning:
      '(Phương ngữ) thế: "Đôi ta như chỉ xe tư, Xe răng thì rứa y như một lời." (Cdao)',
    example: 'Đôi ta như chỉ xe tư, Xe răng thì rứa y như một lời." (Cdao)',
  },
  {
    word: "rữa",
    part_of_speech: "tính từ",
    meaning:
      'nát nhủn ra đến mức dễ rời, dễ rã ra khi đụng đến, thường do quá chín hoặc để quá lâu: chuối chín rữa * thối rữa * "Ngồi buồn vén lá trông hoa, Hoa tàn nhị rữa, buồn da diết buồn." (ca dao)',
    example:
      'chuối chín rữa * thối rữa * "Ngồi buồn vén lá trông hoa, Hoa tàn nhị rữa, buồn da diết buồn." (ca dao)',
  },
  {
    word: "rửa",
    part_of_speech: "động từ",
    meaning:
      "dùng nước hoặc các chất lỏng khác làm cho sạch: rửa mặt * rửa rau * rửa vết thương bằng cồn",
    example: "rửa mặt * rửa rau * rửa vết thương bằng cồn",
  },
  {
    word: "rửa",
    part_of_speech: "động từ",
    meaning:
      "làm cho tiêu tan nỗi sỉ nhục, oan ức, v.v. bằng hành động trừng trị đích đáng kẻ đã gây ra: rửa hờn * rửa mối nhục",
    example: "rửa hờn * rửa mối nhục",
  },
  {
    word: "rửa tiền",
    part_of_speech: "động từ",
    meaning: "hợp pháp hoá những khoản tiền bất chính: hành vi rửa tiền",
    example: "hành vi rửa tiền",
  },
  {
    word: "rút ruột",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) lấy hết phần có giá trị bên trong.",
    example: "rút ruột công trình xây dựng * rút ruột công ti",
  },
  {
    word: "rửa ráy",
    part_of_speech: "động từ",
    meaning: "rửa (nói khái quát): rửa ráy chân tay mặt mũi",
    example: "rửa ráy chân tay mặt mũi",
  },
  {
    word: "rưa rứa",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ, khẩu ngữ) hơi giống, gần gần như thế: cũng rưa rứa như nhau",
    example: "cũng rưa rứa như nhau",
  },
  {
    word: "rực rỡ",
    part_of_speech: "tính từ",
    meaning:
      "có màu sắc tươi sáng đẹp đẽ và nổi bật hẳn lên, làm cho ai cũng phải chú ý: nắng vàng rực rỡ * đẹp rực rỡ * một tương lai rực rỡ",
    example: "nắng vàng rực rỡ * đẹp rực rỡ * một tương lai rực rỡ",
  },
  {
    word: "rực",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái đang bừng lên, toả mạnh hơi nóng hoặc ánh sáng ra xung quanh: nóng rực * đôi mắt sáng rực * bếp than cháy rực lên",
    example: "nóng rực * đôi mắt sáng rực * bếp than cháy rực lên",
  },
  {
    word: "rực",
    part_of_speech: "tính từ",
    meaning:
      "có màu (đỏ, vàng) tươi đậm và chói: vườn quýt đỏ rực * đồng lúa vàng rực",
    example: "vườn quýt đỏ rực * đồng lúa vàng rực",
  },
  {
    word: "rừng",
    part_of_speech: "danh từ",
    meaning:
      "vùng đất rộng có nhiều cây cối mọc lâu năm: rừng cao su bạt ngàn * rừng già * lạc trong rừng",
    example: "rừng cao su bạt ngàn * rừng già * lạc trong rừng",
  },
  {
    word: "rừng",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp rất nhiều vật san sát nhau, dày đặc: một rừng cờ hoa * rừng người",
    example: "một rừng cờ hoa * rừng người",
  },
  {
    word: "rừng",
    part_of_speech: "tính từ",
    meaning:
      "(thú vật, cây cối) có tính chất hoang dại, thường là sống hoặc mọc hoang trong rừng: lợn rừng * gà rừng * hái măng rừng",
    example: "lợn rừng * gà rừng * hái măng rừng",
  },
  {
    word: "rựng",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) như lựng (ng2): đỏ rựng * chín rựng",
    example: "đỏ rựng * chín rựng",
  },
  {
    word: "rựng",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như rạng (ng1): trời đã rựng sáng",
    example: "trời đã rựng sáng",
  },
  {
    word: "rửng mỡ",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) có cử chỉ đùa bỡn quá trớn, tựa như là thừa dư sức lực mà không biết làm gì (thường dùng để mắng, chửi): ăn lắm rồi rửng mỡ",
    example: "ăn lắm rồi rửng mỡ",
  },
  {
    word: "rừng núi",
    part_of_speech: "danh từ",
    meaning: "như núi rừng: rừng núi âm u",
    example: "rừng núi âm u",
  },
  {
    word: "rưng rức",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả tiếng khóc không to, nhưng kéo dài không dứt: khóc rưng rức",
    example: "khóc rưng rức",
  },
  {
    word: "rừng phòng hộ",
    part_of_speech: "danh từ",
    meaning:
      "rừng được dùng để phòng chống các diễn biến có hại của tự nhiên, bảo vệ nguồn nước, bảo vệ môi trường sinh thái, v.v.: rừng phòng hộ đầu nguồn",
    example: "rừng phòng hộ đầu nguồn",
  },
  {
    word: "rừng rú",
    part_of_speech: "danh từ",
    meaning: "rừng tự nhiên (nói khái quát): sống ở nơi rừng rú",
    example: "sống ở nơi rừng rú",
  },
  {
    word: "rưng rưng",
    part_of_speech: "tính từ",
    meaning:
      "(nước mắt) ứa ra đọng đầy tròng nhưng chưa chảy xuống thành giọt: nước mắt rưng rưng",
    example: "nước mắt rưng rưng",
  },
  {
    word: "rừng rực",
    part_of_speech: "tính từ",
    meaning:
      "rực lên mỗi lúc một mạnh mẽ: lửa cháy rừng rực * hòn than đỏ rừng rực",
    example: "lửa cháy rừng rực * hòn than đỏ rừng rực",
  },
  {
    word: "rừng thiêng nước độc",
    part_of_speech: "",
    meaning:
      'tả nơi rừng núi âm u, xa xôi, hẻo lánh, khí hậu khắc nghiệt, dễ sinh các bệnh nguy hiểm: "Anh đi ba bữa anh về, Rừng thiêng nước độc chớ hề ở lâu." (ca dao)',
    example:
      'Anh đi ba bữa anh về, Rừng thiêng nước độc chớ hề ở lâu." (ca dao)',
  },
  {
    word: "rước",
    part_of_speech: "động từ",
    meaning:
      "đi thành đoàn có cờ trống, đèn đuốc, v.v. để làm lễ đón về hoặc để biểu thị sự vui mừng, phấn khởi trong ngày hội: rước đuốc * rước đèn trung thu * rước kiệu * lễ rước thần",
    example: "rước đuốc * rước đèn trung thu * rước kiệu * lễ rước thần",
  },
  {
    word: "rước",
    part_of_speech: "động từ",
    meaning:
      "đón về một cách trân trọng: đoàn rước dâu * rước thầy về dạy cho con",
    example: "đoàn rước dâu * rước thầy về dạy cho con",
  },
  {
    word: "rước",
    part_of_speech: "động từ",
    meaning:
      "(Nam) đón (= đi đến một nơi có ai và mang người đó về): về quê rước ông bà lên chơi * xe đưa rước công nhân",
    example: "về quê rước ông bà lên chơi * xe đưa rước công nhân",
  },
  {
    word: "rước xách",
    part_of_speech: "động từ",
    meaning:
      "đón rước với đầy đủ các nghi thức (nói khái quát, thường hàm ý than phiền): hội làng năm nay không có tế lễ, rước xách gì",
    example: "hội làng năm nay không có tế lễ, rước xách gì",
  },
  {
    word: "rưởi",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) như rưỡi (nhưng thường chỉ dùng sau số đơn vị từ hàng trăm trở lên): trăm rưởi * triệu rưởi",
    example: "trăm rưởi * triệu rưởi",
  },
  {
    word: "rưới",
    part_of_speech: "động từ",
    meaning:
      "đổ cho thấm đều từng ít một lên khắp bề mặt: rưới xăng đốt * cơm rưới nước mắm",
    example: "rưới xăng đốt * cơm rưới nước mắm",
  },
  {
    word: "rưỡi",
    part_of_speech: "danh từ",
    meaning:
      "một nửa của đơn vị: một nghìn rưỡi * làm trong một tuần rưỡi * giá điện tăng gần gấp rưỡi",
    example:
      "một nghìn rưỡi * làm trong một tuần rưỡi * giá điện tăng gần gấp rưỡi",
  },
  {
    word: "rươi",
    part_of_speech: "danh từ",
    meaning:
      "giun đốt, thân có nhiều tơ nhỏ, sinh theo mùa, ở vùng nước lợ, có thể dùng làm thức ăn: mùa rươi * trộm cắp như rươi",
    example: "mùa rươi * trộm cắp như rươi",
  },
  {
    word: "rượi",
    part_of_speech: "tính từ",
    meaning:
      "có tác dụng gây cảm giác dịu mát, dễ chịu: mát rượi * một vùng cỏ tranh vàng rượi",
    example: "mát rượi * một vùng cỏ tranh vàng rượi",
  },
  {
    word: "rườm rà",
    part_of_speech: "tính từ",
    meaning:
      "(cây) có nhiều cành lá xoè toả ra xung quanh (nói khái quát): cây cối rườm rà",
    example: "cây cối rườm rà",
  },
  {
    word: "rườm rà",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều phần, nhiều chi tiết thừa, vô ích: thủ tục rườm rà * lời văn rườm rà, không súc tích",
    example: "thủ tục rườm rà * lời văn rườm rà, không súc tích",
  },
  {
    word: "rười rượi",
    part_of_speech: "tính từ",
    meaning: "như rượi (nhưng ý nhấn mạnh hơn): mát rười rượi",
    example: "mát rười rượi",
  },
  {
    word: "rười rượi",
    part_of_speech: "tính từ",
    meaning: "(dáng vẻ) buồn ủ rũ: mặt buồn rười rượi",
    example: "mặt buồn rười rượi",
  },
  {
    word: "rướn",
    part_of_speech: "động từ",
    meaning:
      "cố vươn thẳng ra phía trước hay vươn cao lên: chú gà rướn cổ cất tiếng gáy * thằng bé rướn người lên ôm lấy cổ mẹ",
    example:
      "chú gà rướn cổ cất tiếng gáy * thằng bé rướn người lên ôm lấy cổ mẹ",
  },
  {
    word: "rương",
    part_of_speech: "danh từ",
    meaning: "hòm gỗ để đựng đồ dùng: rương đựng sách",
    example: "rương đựng sách",
  },
  {
    word: "rườm",
    part_of_speech: "tính từ",
    meaning:
      "dài dòng, lôi thôi, nhiều chỗ thừa và không rõ ý: rườm tai * thôi, không phải rườm lời!",
    example: "rườm tai * thôi, không phải rườm lời!",
  },
  {
    word: "rường cột",
    part_of_speech: "danh từ",
    meaning:
      "rường và cột (nói khái quát); dùng để chỉ chỗ dựa vững chắc nhất của một cơ cấu tổ chức: rường cột của triều đình",
    example: "rường cột của triều đình",
  },
  {
    word: "rượt",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) đuổi theo: rượt theo tên cướp",
    example: "rượt theo tên cướp",
  },
  {
    word: "rượu chè",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) uống rượu nhiều đến mức nghiện ngập, sinh ra bê tha: máu mê rượu chè * suốt ngày chỉ rượu chè, cờ bạc",
    example: "máu mê rượu chè * suốt ngày chỉ rượu chè, cờ bạc",
  },
  {
    word: "rượu",
    part_of_speech: "danh từ",
    meaning:
      "chất lỏng, vị cay nồng, thường cất từ chất bột hoặc trái cây đã ủ men: say rượu * không biết uống rượu * cất rượu * men rượu",
    example: "say rượu * không biết uống rượu * cất rượu * men rượu",
  },
  {
    word: "rượu bia",
    part_of_speech: "danh từ",
    meaning: "rượu và bia (nói khái quát): cửa hàng chuyên doanh rượu bia",
    example: "cửa hàng chuyên doanh rượu bia",
  },
  {
    word: "rượu nho",
    part_of_speech: "danh từ",
    meaning:
      "(cũng rượu nho) rượu chế bằng nước của quả nho ép và để cho lên men: rượu vang đỏ * rượu vang trắng",
    example: "rượu vang đỏ * rượu vang trắng",
  },
  {
    word: "rượu nếp",
    part_of_speech: "danh từ",
    meaning: "rượu làm bằng cơm nếp ủ với men, ăn cả cái lẫn nước.",
    example: "chai rượu nếp",
  },
  {
    word: "rượu sớm cờ trưa",
    part_of_speech: "",
    meaning:
      'tả cảnh sống ung dung, nhàn tản, không phải lo nghĩ gì của người đàn ông thời xưa: "Mảng vui rượu sớm cờ trưa, Đào đà phai thắm, sen vừa nảy xanh." (TKiều)',
    example:
      'Mảng vui rượu sớm cờ trưa, Đào đà phai thắm, sen vừa nảy xanh." (TKiều)',
  },
  {
    word: "rượu sớm trà trưa",
    part_of_speech: "",
    meaning:
      'như rượu sớm cờ trưa: "Người ta rượu sớm trà trưa, Em nay đi vắng về mưa đã nhiều." (ca dao)',
    example:
      'Người ta rượu sớm trà trưa, Em nay đi vắng về mưa đã nhiều." (ca dao)',
  },
  {
    word: "rượu vang",
    part_of_speech: "danh từ",
    meaning:
      "(cũng rượu nho) rượu chế bằng nước của quả nho ép và để cho lên men: rượu vang đỏ * rượu vang trắng",
    example: "rượu vang đỏ * rượu vang trắng",
  },
  {
    word: "s",
    part_of_speech: "",
    meaning:
      "(A: second, viết tắt) kí hiệu của giây trong một số đơn vị đo: tốc độ của ánh sáng là 300.000 km/s",
    example: "tốc độ của ánh sáng là 300.000 km/s",
  },
  {
    word: "rứt ruột",
    part_of_speech: "",
    meaning:
      "ví nỗi đau xót cực độ, đến mức ruột gan tựa như bị đứt ra từng đoạn: buồn rứt ruột * con rứt ruột đẻ ra",
    example: "buồn rứt ruột * con rứt ruột đẻ ra",
  },
  {
    word: "rứt",
    part_of_speech: "động từ",
    meaning:
      'giật mạnh cho rời ra, đứt ra: rứt chỉ * rứt một sợi tóc * "Lòng anh còn đợi còn chờ, Sao em rứt nghĩa bao giờ không hay." (ca dao)',
    example:
      'rứt chỉ * rứt một sợi tóc * "Lòng anh còn đợi còn chờ, Sao em rứt nghĩa bao giờ không hay." (ca dao)',
  },
  {
    word: "sá",
    part_of_speech: "danh từ",
    meaning:
      "phần đất tạo thành một đường dài, đã được cày lật lên hoặc bừa cho nhỏ, nhuyễn: sá cày * bừa thẳng sá",
    example: "sá cày * bừa thẳng sá",
  },
  {
    word: "sá",
    part_of_speech: "động từ",
    meaning:
      '(cũ, văn chương) kể đến:  "Sá chi thân phận tôi đòi, Dẫu rằng xương trắng quê người, quản đâu!" (TKiều)',
    example:
      'Sá chi thân phận tôi đòi, Dẫu rằng xương trắng quê người, quản đâu!" (TKiều)',
  },
  {
    word: "sá",
    part_of_speech: "phụ từ",
    meaning:
      '(cũ, văn chương) từ biểu thị ý phủ định dứt khoát: "Hạt mưa sá nghĩ phận hèn, Liều đem tấc cỏ, quyết đền ba xuân." (TKiều)',
    example:
      'Hạt mưa sá nghĩ phận hèn, Liều đem tấc cỏ, quyết đền ba xuân." (TKiều)',
  },
  {
    word: "sà",
    part_of_speech: "động từ",
    meaning:
      "bay thấp hẳn, hướng đến một vị trí nào đó phía dưới: đàn chim sà xuống cánh đồng * chiếc máy bay sà xuống thấp",
    example: "đàn chim sà xuống cánh đồng * chiếc máy bay sà xuống thấp",
  },
  {
    word: "sà",
    part_of_speech: "động từ",
    meaning:
      "di chuyển thân mình bằng động tác nhanh và gọn, thẳng đến chỗ nào đó một cách thích thú: sà vào lòng mẹ * thấy có ăn là sà vào",
    example: "sà vào lòng mẹ * thấy có ăn là sà vào",
  },
  {
    word: "sả",
    part_of_speech: "danh từ",
    meaning:
      "cây cùng họ với lúa, mọc thành bụi, lá dài, hẹp và thơm, dùng làm gia vị hoặc chiết lấy dầu: dầu sả",
    example: "dầu sả",
  },
  {
    word: "sa",
    part_of_speech: "danh từ",
    meaning: "hàng dệt bằng tơ, rất mỏng và thoáng: áo sa * khăn sa",
    example: "áo sa * khăn sa",
  },
  {
    word: "sa",
    part_of_speech: "động từ",
    meaning:
      '(Từ cũ, Văn chương) từ từ rơi thẳng xuống: sương sa * "Đàn bà như hạt mưa sa, Hạt vào gác tía, hạt ra luống cày." (Cdao)',
    example:
      'sương sa * "Đàn bà như hạt mưa sa, Hạt vào gác tía, hạt ra luống cày." (Cdao)',
  },
  {
    word: "sa",
    part_of_speech: "động từ",
    meaning:
      "hạ xuống vị trí quá thấp so với bình thường (thường nói về một số bộ phận bên trong cơ thể): sa dạ dày * bị sa dạ con",
    example: "sa dạ dày * bị sa dạ con",
  },
  {
    word: "sa",
    part_of_speech: "động từ",
    meaning:
      "ở vào, mắc vào một tình trạng không hay nào đó: sa vào con đường nghiện ngập * sa lưới pháp luật * sa vào cảnh ngộ éo le",
    example:
      "sa vào con đường nghiện ngập * sa lưới pháp luật * sa vào cảnh ngộ éo le",
  },
  {
    word: "sã",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) buông rũ xuống, không còn giữ được ở tư thế bình thường: chim sã cánh * mỏi sã tay",
    example: "chim sã cánh * mỏi sã tay",
  },
  {
    word: "sa cơ",
    part_of_speech: "động từ",
    meaning:
      'rơi vào tình thế rủi ro, không may: "(...) Hùm thiêng khi đã sa cơ cũng hèn!" (TKiều)',
    example: '(...) Hùm thiêng khi đã sa cơ cũng hèn!" (TKiều)',
  },
  {
    word: "sa bàn",
    part_of_speech: "danh từ",
    meaning:
      "hình mẫu một khu vực, giống như địa hình thật, đắp theo tỉ lệ thu nhỏ để phục vụ việc trình bày, nghiên cứu: đắp sa bàn * sa bàn quân sự",
    example: "đắp sa bàn * sa bàn quân sự",
  },
  {
    word: "sạ",
    part_of_speech: "động từ",
    meaning:
      "gieo thẳng cho cây lúa mọc tự nhiên, không cấy: sạ lúa * ruộng sạ",
    example: "sạ lúa * ruộng sạ",
  },
  {
    word: "sa bồi",
    part_of_speech: "danh từ",
    meaning:
      "đất do phù sa lắng đọng, bồi đắp dần mà thành: đất sa bồi * trồng ngô ở bãi sa bồi",
    example: "đất sa bồi * trồng ngô ở bãi sa bồi",
  },
  {
    word: "sa chân",
    part_of_speech: "động từ",
    meaning:
      "bước lỡ chân vào chỗ thấp, bị hẫng và ngã; thường dùng để ví trường hợp bị rơi vào cảnh ngộ không hay: sa chân vào con đường nghiện ngập",
    example: "sa chân vào con đường nghiện ngập",
  },
  {
    word: "sa đà",
    part_of_speech: "động từ",
    meaning:
      "bị cuốn hút vào việc nào đó đến mức mê mải, không tự kiềm chế được: sà đà vào cờ bạc * ăn chơi sa đà",
    example: "sà đà vào cờ bạc * ăn chơi sa đà",
  },
  {
    word: "sa đoạ",
    part_of_speech: "tính từ",
    meaning:
      "tồi tệ về lối sống, về tinh thần: ăn chơi sa đoạ * lối sống sa đoạ",
    example: "ăn chơi sa đoạ * lối sống sa đoạ",
  },
  {
    word: "sa lát",
    part_of_speech: "danh từ",
    meaning:
      "món ăn làm bằng các loại rau củ, thường để sống, trộn lẫn với một số gia vị: trộn sa lát * món sa lát Nga",
    example: "trộn sa lát * món sa lát Nga",
  },
  {
    word: "sa ngã",
    part_of_speech: "động từ",
    meaning:
      "trở nên hư hỏng do không giữ được mình trước những sự cám dỗ vật chất: sa ngã trước sự cám dỗ của đồng tiền * lối sống sa ngã",
    example: "sa ngã trước sự cám dỗ của đồng tiền * lối sống sa ngã",
  },
  {
    word: "sa khoáng",
    part_of_speech: "danh từ",
    meaning:
      "quặng giàu khoáng vật quý, được hình thành trong quá trình trầm tích biển hoặc phong hoá, nóng chảy, chuyển dòng mà lắng đọng thành: mỏ sa khoáng * vàng sa khoáng",
    example: "mỏ sa khoáng * vàng sa khoáng",
  },
  {
    word: "sa lầy",
    part_of_speech: "động từ",
    meaning:
      "sa vào chỗ lầy; dùng để ví cảnh rơi vào tình thế khó khăn, khó tháo gỡ, khó thoát ra được: xe bị sa lầy * sa lầy trong cuộc chiến tranh",
    example: "xe bị sa lầy * sa lầy trong cuộc chiến tranh",
  },
  {
    word: "sa mạc",
    part_of_speech: "danh từ",
    meaning:
      "vùng rộng lớn có khí hậu rất khô, không có nước, hầu như không có cây cối và động vật sinh sống, trừ ở một số ốc đảo: chỉ là hạt cát trên sa mạc",
    example: "chỉ là hạt cát trên sa mạc",
  },
  {
    word: "sa sả",
    part_of_speech: "phụ từ",
    meaning:
      "(nói năng, mắng chửi) không ngớt lời với một giọng to tiếng, làm người nghe rất khó chịu: mắng sa sả * nói sa sả cả ngày",
    example: "mắng sa sả * nói sa sả cả ngày",
  },
  {
    word: "sa sẩy",
    part_of_speech: "động từ",
    meaning: "mất mát, rơi rụng đi: thóc bị sa sẩy trong khi vận chuyển",
    example: "thóc bị sa sẩy trong khi vận chuyển",
  },
  {
    word: "sà sã",
    part_of_speech: "phụ từ",
    meaning:
      "(nói năng, hoạt động) liên tục, không ngớt trong một thời gian dài: quạt sà sã cả đêm * nói sà sã cả ngày",
    example: "quạt sà sã cả đêm * nói sà sã cả ngày",
  },
  {
    word: "sa thải",
    part_of_speech: "động từ",
    meaning:
      "thải người làm việc, không thuê, không sử dụng nữa: hàng loạt công nhân bị sa thải * giám đốc đã kí quyết định sa thải",
    example:
      "hàng loạt công nhân bị sa thải * giám đốc đã kí quyết định sa thải",
  },
  {
    word: "sa sút",
    part_of_speech: "động từ",
    meaning: "trở nên sút kém dần: học hành sa sút * sức khoẻ ngày một sa sút",
    example: "học hành sa sút * sức khoẻ ngày một sa sút",
  },
  {
    word: "sa sầm",
    part_of_speech: "động từ",
    meaning:
      "(bầu trời, vẻ mặt) thoắt chuyển thành u ám, nặng nề: bầu trời sa sầm * sa sầm nét mặt",
    example: "bầu trời sa sầm * sa sầm nét mặt",
  },
  {
    word: "sách",
    part_of_speech: "danh từ",
    meaning: "dạ lá sách (nói tắt): sách bò xào khế",
    example: "sách bò xào khế",
  },
  {
    word: "sách",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp một số lượng nhất định những tờ giấy có chữ in, đóng gộp lại thành quyển: sách tham khảo * đọc sách tới khuya * hiệu sách",
    example: "sách tham khảo * đọc sách tới khuya * hiệu sách",
  },
  {
    word: "sách",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) mưu, kế: giở hết sách mà vẫn thua * thượng sách",
    example: "giở hết sách mà vẫn thua * thượng sách",
  },
  {
    word: "sạc",
    part_of_speech: "động từ",
    meaning:
      "nạp điện vào khí cụ trữ điện năng để sử dụng dần: sạc điện cho bình ắc quy * sạc pin điện thoại",
    example: "sạc điện cho bình ắc quy * sạc pin điện thoại",
  },
  {
    word: "sa trường",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) chiến trường: bỏ thân ngoài sa trường * "Ngại ngùng thay, lúc phân kỳ, Người về cố quốc, kẻ đi sa trường." (NĐM)',
    example:
      'bỏ thân ngoài sa trường * "Ngại ngùng thay, lúc phân kỳ, Người về cố quốc, kẻ đi sa trường." (NĐM)',
  },
  {
    word: "sạch",
    part_of_speech: "tính từ",
    meaning:
      "không có bụi bặm, rác rưởi, cáu ghét, hoặc không bị hoen ố: cái áo giặt chưa sạch * nhà sạch thì mát, bát sạch ngon cơm (tng)",
    example:
      "cái áo giặt chưa sạch * nhà sạch thì mát, bát sạch ngon cơm (tng)",
  },
  {
    word: "sạch",
    part_of_speech: "tính từ",
    meaning:
      "không chứa chất bẩn hoặc yếu tố gây hại, do được xử lí theo đúng tiêu chuẩn vệ sinh: sử dụng nước sạch * cửa hàng rau sạch",
    example: "sử dụng nước sạch * cửa hàng rau sạch",
  },
  {
    word: "sạch",
    part_of_speech: "phụ từ",
    meaning:
      "hết đi tất cả, không còn sót lại chút nào: mất sạch đồ đạc * quên sạch * hết sạch cả tiền",
    example: "mất sạch đồ đạc * quên sạch * hết sạch cả tiền",
  },
  {
    word: "sạch bách",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) hết sạch, không còn lại một chút gì: thùng gạo đã sạch bách * bán sạch bách đồ đạc trong nhà",
    example: "thùng gạo đã sạch bách * bán sạch bách đồ đạc trong nhà",
  },
  {
    word: "sách báo",
    part_of_speech: "danh từ",
    meaning:
      "sách và báo (nói khái quát): sách báo ngoại văn * theo dõi tin tức qua sách báo",
    example: "sách báo ngoại văn * theo dõi tin tức qua sách báo",
  },
  {
    word: "sạch bóng",
    part_of_speech: "tính từ",
    meaning: "như sạch bong: nền nhà lau sạch bóng",
    example: "nền nhà lau sạch bóng",
  },
  {
    word: "sạch bong",
    part_of_speech: "tính từ",
    meaning:
      "sạch đến mức không có một chút bụi bặm, rác bẩn nào: bàn ghế sạch bong",
    example: "bàn ghế sạch bong",
  },
  {
    word: "sách công cụ",
    part_of_speech: "danh từ",
    meaning: "sách chuyên dùng để tra cứu: từ điển là sách công cụ",
    example: "từ điển là sách công cụ",
  },
  {
    word: "sách đỏ",
    part_of_speech: "danh từ",
    meaning:
      "sách ghi tên động vật, thực vật, hoặc những giá trị vật chất hoặc tinh thần quý hiếm, với yêu cầu phải bảo vệ, ngăn ngừa nguy cơ tuyệt diệt: sao la có tên trong sách đỏ Việt Nam",
    example: "sao la có tên trong sách đỏ Việt Nam",
  },
  {
    word: "sách lược",
    part_of_speech: "danh từ",
    meaning:
      "những đường lối, hình thức tổ chức và đấu tranh để giành thắng lợi trong một hoạt động thường có ảnh hưởng lớn và rộng nào đó (nói tổng quát): sách lược mềm dẻo * đưa ra những sách lược mới",
    example: "sách lược mềm dẻo * đưa ra những sách lược mới",
  },
  {
    word: "sạch mắt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) sạch sẽ và sáng sủa, dễ coi: nhà cửa trông cũng sạch mắt",
    example: "nhà cửa trông cũng sạch mắt",
  },
  {
    word: "sạch sành sanh",
    part_of_speech: "tính từ",
    meaning:
      '(mất, hết) sạch hoàn toàn, không còn sót lại tí gì (cái mà trước đó vốn rất nhiều): mất sạch sành sanh * "Đồ tế nhuyễn, của riêng tây, Sạch sành sanh vét cho đầy túi tham." (TKiều)',
    example:
      'mất sạch sành sanh * "Đồ tế nhuyễn, của riêng tây, Sạch sành sanh vét cho đầy túi tham." (TKiều)',
  },
  {
    word: "sách nhiễu",
    part_of_speech: "động từ",
    meaning: "gây chuyện lôi thôi để đòi hối lộ: quan lại sách nhiễu dân chúng",
    example: "quan lại sách nhiễu dân chúng",
  },
  {
    word: "sạch nước cản",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) có trình độ chỉ mới gọi là tạm được (ví như người chơi cờ tướng bắt đầu thuộc các nước đi để cản các quân cờ của đối phương, nhưng chưa có được những nước cờ cao): chưa sạch nước cản",
    example: "chưa sạch nước cản",
  },
  {
    word: "sạch sẽ",
    part_of_speech: "tính từ",
    meaning: "sạch (nói khái quát): nhà cửa gọn gàng, sạch sẽ * ăn mặc sạch sẽ",
    example: "nhà cửa gọn gàng, sạch sẽ * ăn mặc sạch sẽ",
  },
  {
    word: "sách vở",
    part_of_speech: "danh từ",
    meaning:
      "sách và vở; tài liệu học tập, nghiên cứu (nói khái quát): soạn sách vở đến trường * suốt ngày vùi đầu vào sách vở",
    example: "soạn sách vở đến trường * suốt ngày vùi đầu vào sách vở",
  },
  {
    word: "sách vở",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất bị lệ thuộc vào sách vở, không sát với thực tế: lối suy nghĩ sách vở * một con người sách vở",
    example: "lối suy nghĩ sách vở * một con người sách vở",
  },
  {
    word: "sạch trơn",
    part_of_speech: "tính từ",
    meaning:
      '(phương ngữ, khẩu ngữ) hết sạch, hết nhẵn, không còn tí nào: thùng gạo đã sạch trơn * "Lênh đênh một chiếc thuyền hà, Nay sửa, mai sửa, cửa nhà sạch trơn." (ca dao)',
    example:
      'thùng gạo đã sạch trơn * "Lênh đênh một chiếc thuyền hà, Nay sửa, mai sửa, cửa nhà sạch trơn." (ca dao)',
  },
  {
    word: "sai",
    part_of_speech: "động từ",
    meaning:
      "bảo người dưới làm việc gì đó cho mình: sai người làm * sai con đi chợ",
    example: "sai người làm * sai con đi chợ",
  },
  {
    word: "sai",
    part_of_speech: "tính từ",
    meaning:
      "(cây cối) có hoa quả hoặc củ nhiều và sít vào nhau: cây bưởi sai hoa * mít sai quả * sai trĩu trịt",
    example: "cây bưởi sai hoa * mít sai quả * sai trĩu trịt",
  },
  {
    word: "sai",
    part_of_speech: "tính từ",
    meaning:
      "không giống, không phù hợp với cái hoặc điều có thật: phản ánh sai sự thật * nói như thế là sai",
    example: "phản ánh sai sự thật * nói như thế là sai",
  },
  {
    word: "sai",
    part_of_speech: "tính từ",
    meaning: "chệch đi so với nhau, không khớp với nhau: xương bị sai khớp",
    example: "xương bị sai khớp",
  },
  {
    word: "sai",
    part_of_speech: "tính từ",
    meaning:
      "không phù hợp với yêu cầu khách quan, lẽ ra phải khác: định hướng sai * đi sai đường * tính sai một bước",
    example: "định hướng sai * đi sai đường * tính sai một bước",
  },
  {
    word: "sai",
    part_of_speech: "tính từ",
    meaning:
      "không phù hợp với phép tắc, với những điều quy định: làm sai nội quy * viết sai chính tả",
    example: "làm sai nội quy * viết sai chính tả",
  },
  {
    word: "sãi",
    part_of_speech: "danh từ",
    meaning:
      'người đàn ông giữ chùa: "Con vua thì lại làm vua, Con sãi ở chùa thì quét lá đa." (Cdao)',
    example: 'Con vua thì lại làm vua, Con sãi ở chùa thì quét lá đa." (Cdao)',
  },
  {
    word: "sái",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (bộ phận cơ thể) bị sai, trệch khớp: ngã sái tay * ngáp sái quai hàm * Chuyện tào lao mà nó tin sái cổ (= tin lắm).",
    example:
      "ngã sái tay * ngáp sái quai hàm * Chuyện tào lao mà nó tin sái cổ",
  },
  {
    word: "sài",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi chung các bệnh nội khoa lâu khỏi ở trẻ em: trẻ bị sài, lâu lớn",
    example: "trẻ bị sài, lâu lớn",
  },
  {
    word: "sài",
    part_of_speech: "danh từ",
    meaning: "(hiếm) bệnh chốc lở trên đầu trẻ em: em bé bị lên sài",
    example: "em bé bị lên sài",
  },
  {
    word: "sai bảo",
    part_of_speech: "động từ",
    meaning: "sai (nói khái quát): sai bảo con cái * có quyền sai bảo",
    example: "sai bảo con cái * có quyền sai bảo",
  },
  {
    word: "sai dịch",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) việc lao động có tính chất bắt buộc, phục dịch ở cửa công thời phong kiến: được miễn sai dịch",
    example: "được miễn sai dịch",
  },
  {
    word: "sai dịch",
    part_of_speech: "danh từ",
    meaning:
      "người làm việc phục dịch ở cửa công thời phong kiến: bọn sai nha, sai dịch",
    example: "bọn sai nha, sai dịch",
  },
  {
    word: "sải",
    part_of_speech: "danh từ",
    meaning:
      '(cũng xải) đồ đan bằng tre nứa, hình tròn, lòng sâu, trát sơn ở mặt ngoài, thường dùng để đựng chất lỏng: "Rủ nhau đi gánh nước thuyền, Đứt quang vỡ sải nước liền ra sông." (ca dao)',
    example:
      'Rủ nhau đi gánh nước thuyền, Đứt quang vỡ sải nước liền ra sông." (ca dao)',
  },
  {
    word: "sải",
    part_of_speech: "danh từ",
    meaning:
      "độ dài bằng khoảng cách từ đầu bàn tay này đến đầu bàn tay kia khi dang thẳng cánh tay: chiếc gậy dài một sải tay",
    example: "chiếc gậy dài một sải tay",
  },
  {
    word: "sải",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) dang, duỗi thật hết cỡ: sải bước * chim sải cánh bay",
    example: "sải bước * chim sải cánh bay",
  },
  {
    word: "sài giật",
    part_of_speech: "danh từ",
    meaning: "như sài kinh: lên cơn sài giật",
    example: "lên cơn sài giật",
  },
  {
    word: "sai khiến",
    part_of_speech: "động từ",
    meaning:
      "bắt phải làm theo, tuân theo lệnh (nói khái quát): sai khiến thuộc hạ",
    example: "sai khiến thuộc hạ",
  },
  {
    word: "sai lạc",
    part_of_speech: "tính từ",
    meaning:
      "không đúng, không phù hợp với thực tế khách quan hoặc với lẽ phải (nói khái quát): quan điểm sai lạc * thông tin sai lạc",
    example: "quan điểm sai lạc * thông tin sai lạc",
  },
  {
    word: "sài lang",
    part_of_speech: "danh từ",
    meaning:
      "chó sói hung dữ; thường dùng để ví hạng người độc ác, tàn bạo: bọn đế quốc sài lang",
    example: "bọn đế quốc sài lang",
  },
  {
    word: "sai lầm",
    part_of_speech: "tính từ",
    meaning:
      "trái với yêu cầu khách quan hoặc với lẽ phải, dẫn đến những hậu quả không hay: một quyết định sai lầm * việc làm sai lầm",
    example: "một quyết định sai lầm * việc làm sai lầm",
  },
  {
    word: "sai lầm",
    part_of_speech: "danh từ",
    meaning:
      "điều trái với yêu cầu khách quan, dẫn đến hậu quả không hay: sửa chữa sai lầm * phạm nhiều sai lầm",
    example: "sửa chữa sai lầm * phạm nhiều sai lầm",
  },
  {
    word: "sai lệch",
    part_of_speech: "tính từ",
    meaning:
      "chệch đi so với cái được coi là chuẩn: sự sai lệch của âm phương ngữ so với âm chuẩn",
    example: "sự sai lệch của âm phương ngữ so với âm chuẩn",
  },
  {
    word: "sai lệch",
    part_of_speech: "tính từ",
    meaning:
      "sai, không đúng: thông tin sai lệch * nhiều tình tiết của vụ án đã bị làm sai lệch",
    example:
      "thông tin sai lệch * nhiều tình tiết của vụ án đã bị làm sai lệch",
  },
  {
    word: "sai ngoa",
    part_of_speech: "tính từ",
    meaning: "(cũ, hiếm) không thật, dối trá: ăn nói sai ngoa",
    example: "ăn nói sai ngoa",
  },
  {
    word: "sai sót",
    part_of_speech: "danh từ",
    meaning:
      "khuyết điểm không lớn, thường do sơ suất: khắc phục những sai sót trong quản lí * không tránh khỏi sai sót",
    example: "khắc phục những sai sót trong quản lí * không tránh khỏi sai sót",
  },
  {
    word: "sai phái",
    part_of_speech: "động từ",
    meaning:
      "sai đi, phái đi làm việc này việc nọ (nói khái quát): sai phái quân lính đi điều tra",
    example: "sai phái quân lính đi điều tra",
  },
  {
    word: "sai phạm",
    part_of_speech: "động từ",
    meaning: "vi phạm các quy định: sai phạm quân luật * hành vi sai phạm",
    example: "sai phạm quân luật * hành vi sai phạm",
  },
  {
    word: "sai phạm",
    part_of_speech: "danh từ",
    meaning:
      "điều vi phạm, làm sai các quy định: cố tình che đậy sai phạm * xử lí cán bộ có sai phạm",
    example: "cố tình che đậy sai phạm * xử lí cán bộ có sai phạm",
  },
  {
    word: "sai số",
    part_of_speech: "danh từ",
    meaning:
      "hiệu số giữa trị số đúng và trị số gần đúng đã được xác định: sai số không đáng kể * sai số cho phép",
    example: "sai số không đáng kể * sai số cho phép",
  },
  {
    word: "sạm",
    part_of_speech: "tính từ",
    meaning:
      "(nước da) sẫm lại và xấu đi, thường do tác động của nắng gió: mặt sạm đen * nước da sạm nắng",
    example: "mặt sạm đen * nước da sạm nắng",
  },
  {
    word: "sai trái",
    part_of_speech: "tính từ",
    meaning:
      "không đúng, không phù hợp với lẽ phải: việc làm sai trái * hành động sai trái",
    example: "việc làm sai trái * hành động sai trái",
  },
  {
    word: "sám hối",
    part_of_speech: "động từ",
    meaning:
      "ăn năn, hối hận về tội lỗi của mình và mong được sửa chữa: sám hối tội lỗi * lời sám hối * một lời nói dối, sám hối bảy ngày (tng)",
    example:
      "sám hối tội lỗi * lời sám hối * một lời nói dối, sám hối bảy ngày (tng)",
  },
  {
    word: "sam",
    part_of_speech: "danh từ",
    meaning:
      "động vật chân đốt ở biển, thân lớn, có vỏ giáp cứng, đuôi dài và nhọn, sống thành đôi, con đực và con cái không bao giờ rời nhau: quấn quýt bên nhau như đôi sam",
    example: "quấn quýt bên nhau như đôi sam",
  },
  {
    word: "sam",
    part_of_speech: "danh từ",
    meaning: "rau sam (nói tắt): hoa sam * canh sam",
    example: "hoa sam * canh sam",
  },
  {
    word: "sàm sỡ",
    part_of_speech: "tính từ",
    meaning:
      "có thái độ thiếu đứng đắn trong quan hệ giao tiếp giữa nam và nữ: ăn nói sàm sỡ * cử chỉ sàm sỡ",
    example: "ăn nói sàm sỡ * cử chỉ sàm sỡ",
  },
  {
    word: "sản",
    part_of_speech: "động từ",
    meaning: "(Khẩu ngữ) đỡ đẻ: khoa sản * bác sĩ sản",
    example: "khoa sản * bác sĩ sản",
  },
  {
    word: "sản",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) phần thuế nông nghiệp bằng sản phẩm từng hộ nông dân phải nộp cho nhà nước: thu sản * nộp sản",
    example: "thu sản * nộp sản",
  },
  {
    word: "sàm ngôn",
    part_of_speech: "danh từ",
    meaning: "(cũ) lời gièm pha, nói xấu: lời sàm ngôn",
    example: "lời sàm ngôn",
  },
  {
    word: "sàn",
    part_of_speech: "danh từ",
    meaning:
      "mặt nền của một tầng nhà, tầng tàu, xe, v.v. được láng xi măng hoặc lát gạch, gỗ, v.v.: cọ sàn nhà * sàn lát bằng gỗ * sàn tàu",
    example: "cọ sàn nhà * sàn lát bằng gỗ * sàn tàu",
  },
  {
    word: "sạn",
    part_of_speech: "danh từ",
    meaning:
      "mảnh sỏi, đá rất nhỏ lẫn vào cơm, gạo hay thức ăn: nhai phải hạt sạn * gạo có nhiều sạn",
    example: "nhai phải hạt sạn * gạo có nhiều sạn",
  },
  {
    word: "sạn",
    part_of_speech: "danh từ",
    meaning:
      "hạt cát, bụi bám trên đồ đạc: giường chiếu đầy sạn * nền nhà có nhiều sạn",
    example: "giường chiếu đầy sạn * nền nhà có nhiều sạn",
  },
  {
    word: "sán",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đến sát ngay bên cạnh do thấy thích, do bị cuốn hút: sán lại nghe chuyện * thấy ăn là sán đến * sán đến làm quen",
    example: "sán lại nghe chuyện * thấy ăn là sán đến * sán đến làm quen",
  },
  {
    word: "sàm tấu",
    part_of_speech: "động từ",
    meaning:
      "(cũ) tâu lên những lời gièm pha, dối trá để hại người: tin lời sàm tấu",
    example: "tin lời sàm tấu",
  },
  {
    word: "san định",
    part_of_speech: "động từ",
    meaning:
      "sửa sang lại một văn bản cổ bằng cách bỏ đi những chỗ cho là không hợp, xác định những chỗ còn có nghi ngờ và sắp xếp lại: san định bộ sử Việt Nam",
    example: "san định bộ sử Việt Nam",
  },
  {
    word: "san",
    part_of_speech: "động từ",
    meaning:
      "làm cho bằng phẳng bằng cách gạt đất cát từ chỗ cao xuống chỗ trũng: san nền nhà * san bằng mọi trở lực (b)",
    example: "san nền nhà * san bằng mọi trở lực (b)",
  },
  {
    word: "san",
    part_of_speech: "động từ",
    meaning:
      "chuyển bớt từ chỗ có nhiều sang chỗ chưa có hoặc có ít: san ra hai túi cho dễ xách * san bớt việc cho người khác",
    example: "san ra hai túi cho dễ xách * san bớt việc cho người khác",
  },
  {
    word: "sàn diễn",
    part_of_speech: "danh từ",
    meaning:
      "nơi để trình diễn nghệ thuật; thường dùng để chỉ lĩnh vực nghệ thuật sân khấu: bước lên sàn diễn * vắng bóng trên sàn diễn",
    example: "bước lên sàn diễn * vắng bóng trên sàn diễn",
  },
  {
    word: "sản khoa",
    part_of_speech: "danh từ",
    meaning:
      "bộ môn y học chuyên việc đỡ đẻ và chăm sóc sức khoẻ cho phụ nữ trong thời kì chửa đẻ: bác sĩ sản khoa",
    example: "bác sĩ sản khoa",
  },
  {
    word: "san lấp",
    part_of_speech: "động từ",
    meaning:
      "lấp chỗ trũng và san cho phẳng (nói khái quát): san lấp các hố bom",
    example: "san lấp các hố bom",
  },
  {
    word: "sản phụ",
    part_of_speech: "danh từ",
    meaning:
      "người phụ nữ đang trong thời kì chửa đẻ, trong quan hệ với thầy thuốc, bệnh viện: theo dõi sức khoẻ của sản phụ",
    example: "theo dõi sức khoẻ của sản phụ",
  },
  {
    word: "sàn nhảy",
    part_of_speech: "danh từ",
    meaning: "nơi dành riêng để khiêu vũ: ánh đèn sàn nhảy",
    example: "ánh đèn sàn nhảy",
  },
  {
    word: "sản lượng",
    part_of_speech: "danh từ",
    meaning:
      "số lượng sản phẩm sản xuất ra trong một thời gian nhất định: sản lượng lúa cao hơn năm ngoái",
    example: "sản lượng lúa cao hơn năm ngoái",
  },
  {
    word: "san sát",
    part_of_speech: "tính từ",
    meaning:
      "nhiều và liền sát vào nhau, như không còn có khe hở: nhà cửa san sát * dưới sông thuyền đậu san sát",
    example: "nhà cửa san sát * dưới sông thuyền đậu san sát",
  },
  {
    word: "san sát",
    part_of_speech: "tính từ",
    meaning:
      'từ gợi tả tiếng nói phát ra to, nối tiếp nhau như không có lúc nào ngơi, nghe khó chịu: giọng san sát * "Vi lô san sát hơi may, Một trời thu để riêng ai một người." (TKiều)',
    example:
      'giọng san sát * "Vi lô san sát hơi may, Một trời thu để riêng ai một người." (TKiều)',
  },
  {
    word: "sàn sàn",
    part_of_speech: "tính từ",
    meaning: "gần ngang bằng nhau, suýt soát nhau: trình độ sàn sàn nhau",
    example: "trình độ sàn sàn nhau",
  },
  {
    word: "sản nghiệp",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, hiếm) tổng thể nói chung những tài sản để sinh sống hoặc kinh doanh: bán sạch sản nghiệp vì cờ bạc",
    example: "bán sạch sản nghiệp vì cờ bạc",
  },
  {
    word: "sản vật",
    part_of_speech: "danh từ",
    meaning:
      "vật được làm ra hoặc được khai thác, thu nhặt từ trong thiên nhiên: sản vật thiên nhiên",
    example: "sản vật thiên nhiên",
  },
  {
    word: "sản phẩm",
    part_of_speech: "danh từ",
    meaning:
      "cái do lao động của con người tạo ra: sản phẩm mĩ nghệ * giới thiệu sản phẩm mới * trả lương theo sản phẩm",
    example:
      "sản phẩm mĩ nghệ * giới thiệu sản phẩm mới * trả lương theo sản phẩm",
  },
  {
    word: "sản phẩm",
    part_of_speech: "danh từ",
    meaning:
      "cái được tạo ra, như là một kết quả tự nhiên: đứa con là sản phẩm của tình yêu",
    example: "đứa con là sản phẩm của tình yêu",
  },
  {
    word: "san sẻ",
    part_of_speech: "động từ",
    meaning:
      "chia bớt cho nhau để cùng hưởng, cùng chịu (nói khái quát): san sẻ từng bát cơm, manh áo * san sẻ tình cảm",
    example: "san sẻ từng bát cơm, manh áo * san sẻ tình cảm",
  },
  {
    word: "sản sinh",
    part_of_speech: "động từ",
    meaning:
      "sinh ra, tạo ra: sản sinh năng lượng * vùng đất đã sản sinh ra nhiều vị anh hùng",
    example: "sản sinh năng lượng * vùng đất đã sản sinh ra nhiều vị anh hùng",
  },
  {
    word: "san ủi",
    part_of_speech: "động từ",
    meaning: "san và ủi bề mặt cho bằng phẳng: san ủi mặt bằng",
    example: "san ủi mặt bằng",
  },
  {
    word: "sáng bạch",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) (trời) sáng rõ: ngủ đến sáng bạch mà vẫn chưa dậy",
    example: "ngủ đến sáng bạch mà vẫn chưa dậy",
  },
  {
    word: "sảng",
    part_of_speech: "động từ",
    meaning: "mê man, hoảng loạn: mê sảng * nói sảng",
    example: "mê sảng * nói sảng",
  },
  {
    word: "sản xuất",
    part_of_speech: "động từ",
    meaning:
      "tạo ra của cải vật chất nói chung: sản xuất lương thực * sản xuất đồ gia dụng",
    example: "sản xuất lương thực * sản xuất đồ gia dụng",
  },
  {
    word: "sản xuất",
    part_of_speech: "danh từ",
    meaning:
      "hoạt động tạo ra vật phẩm cho xã hội bằng cách dùng tư liệu lao động tác động vào đối tượng lao động: sản xuất nông nghiệp * sản xuất công nghiệp",
    example: "sản xuất nông nghiệp * sản xuất công nghiệp",
  },
  {
    word: "sàng",
    part_of_speech: "động từ",
    meaning:
      "dùng sàng hoặc máy sàng làm cho gạo sạch thóc và trấu, hay phân loại các hạt ngũ cốc hoặc hạt, cục vật liệu rời theo kích thước: sàng gạo * sàng cát",
    example: "sàng gạo * sàng cát",
  },
  {
    word: "sáng bảnh",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) sáng bảnh mắt (nói tắt): đi từ sáng bảnh",
    example: "đi từ sáng bảnh",
  },
  {
    word: "sáng bảnh mắt",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) (trời) đã sáng hẳn: sáng bảnh mắt ra rồi mà vẫn chưa dậy",
    example: "sáng bảnh mắt ra rồi mà vẫn chưa dậy",
  },
  {
    word: "sang",
    part_of_speech: "động từ",
    meaning:
      "di chuyển đến một nơi khác với nơi mình đang ở và thường là ở bên cạnh (có ranh giới trực tiếp và rõ ràng): sang nhà bạn chơi * sang làng bên * sang sông",
    example: "sang nhà bạn chơi * sang làng bên * sang sông",
  },
  {
    word: "sang",
    part_of_speech: "động từ",
    meaning:
      'chuyển qua một giai đoạn, một trạng thái khác nào đó trong quá trình vận động, phát triển: sang năm mới * "Sen tàn, cúc lại nở hoa, Sầu dài, ngày ngắn, đông đà sang xuân." (TKiều)',
    example:
      'sang năm mới * "Sen tàn, cúc lại nở hoa, Sầu dài, ngày ngắn, đông đà sang xuân." (TKiều)',
  },
  {
    word: "sang",
    part_of_speech: "động từ",
    meaning:
      "chuyển cho người khác quyền sở hữu: sang nhà * sang đất cho một người bạn",
    example: "sang nhà * sang đất cho một người bạn",
  },
  {
    word: "sang",
    part_of_speech: "động từ",
    meaning:
      "sao chép nội dung từ băng đĩa gốc sang một băng đĩa mới: sang đĩa * sang băng video",
    example: "sang đĩa * sang băng video",
  },
  {
    word: "sang",
    part_of_speech: "động từ",
    meaning:
      "hướng hoạt động nhằm đến một đối tượng khác, một hướng khác: học hết toán lại sang văn * chuyển sang vấn đề khác",
    example: "học hết toán lại sang văn * chuyển sang vấn đề khác",
  },
  {
    word: "sang",
    part_of_speech: "động từ",
    meaning:
      "đến khoảng thời gian tiếp liền theo sau thời gian hiện tại hoặc đang nói đến: sang tháng mới có tiền * sang tuần phải đi công tác",
    example: "sang tháng mới có tiền * sang tuần phải đi công tác",
  },
  {
    word: "sang",
    part_of_speech: "tính từ",
    meaning:
      "(cũ) có tiền tài và danh vọng, được nhiều người trong xã hội kính trọng: thấy người sang bắt quàng làm họ (tng)",
    example: "thấy người sang bắt quàng làm họ (tng)",
  },
  {
    word: "sang",
    part_of_speech: "tính từ",
    meaning:
      "có giá trị cao và đắt tiền, trông lịch sự: diện rất sang * nhà hàng vào loại sang * thích chơi sang",
    example: "diện rất sang * nhà hàng vào loại sang * thích chơi sang",
  },
  {
    word: "sáng",
    part_of_speech: "tính từ",
    meaning:
      "có ánh sáng toả ra khiến cho có thể nhìn thấy mọi vật: bật đèn lên cho sáng * sáng trăng * trời đã sáng",
    example: "bật đèn lên cho sáng * sáng trăng * trời đã sáng",
  },
  {
    word: "sáng",
    part_of_speech: "tính từ",
    meaning:
      "có khả năng phản chiếu ánh sáng, do có bề mặt nhẵn và bóng: cô gái có đôi mắt sáng * sáng như gương",
    example: "cô gái có đôi mắt sáng * sáng như gương",
  },
  {
    word: "sáng",
    part_of_speech: "tính từ",
    meaning:
      "(màu) tươi nhạt, không sẫm, không tối: thích mặc đồ sáng màu * chọn những gam sáng",
    example: "thích mặc đồ sáng màu * chọn những gam sáng",
  },
  {
    word: "sáng",
    part_of_speech: "tính từ",
    meaning: "rõ ràng, dễ hiểu: diễn đạt không được sáng",
    example: "diễn đạt không được sáng",
  },
  {
    word: "sáng",
    part_of_speech: "tính từ",
    meaning:
      "có khả năng cảm biết, nhận thức nhanh, rõ: nghe giảng giải mới thấy sáng ra * việc người thì sáng, việc mình thì quáng (tng)",
    example:
      "nghe giảng giải mới thấy sáng ra * việc người thì sáng, việc mình thì quáng (tng)",
  },
  {
    word: "sáng",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian từ lúc mặt trời mọc cho đến gần trưa: buổi sáng * từ sáng đến chiều * học thâu đêm suốt sáng",
    example: "buổi sáng * từ sáng đến chiều * học thâu đêm suốt sáng",
  },
  {
    word: "sáng",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian từ lúc coi như bắt đầu một ngày cho đến gần trưa (từ sau 12 giờ đêm cho đến trước 11 giờ trưa): dậy từ 2 giờ sáng * tàu chạy lúc 4 giờ sáng",
    example: "dậy từ 2 giờ sáng * tàu chạy lúc 4 giờ sáng",
  },
  {
    word: "sáng chế",
    part_of_speech: "động từ",
    meaning:
      "chế tạo ra cái trước đó chưa có: sáng chế ra loại máy mới * bằng sáng chế",
    example: "sáng chế ra loại máy mới * bằng sáng chế",
  },
  {
    word: "sáng chế",
    part_of_speech: "danh từ",
    meaning:
      "cái được chế tạo ra dưới dạng sản phẩm hoặc quy trình nhằm giải quyết một vấn đề, được xác định bằng việc ứng dụng các quy luật tự nhiên: độc quyền sử dụng sáng chế * một sáng chế mới",
    example: "độc quyền sử dụng sáng chế * một sáng chế mới",
  },
  {
    word: "sang chấn",
    part_of_speech: "",
    meaning:
      "(tình trạng) thương tổn ở bộ phận cơ thể hoặc tinh thần do bị va chạm, bị tác động mạnh: sưng tấy do sang chấn * sang chấn tâm lí",
    example: "sưng tấy do sang chấn * sang chấn tâm lí",
  },
  {
    word: "sáng dạ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) thông minh, hiểu nhanh, nhớ nhanh (thường dùng với người còn trẻ tuổi): sáng dạ nên học rất nhanh * thằng bé rất sáng dạ",
    example: "sáng dạ nên học rất nhanh * thằng bé rất sáng dạ",
  },
  {
    word: "sáng giá",
    part_of_speech: "tính từ",
    meaning:
      "nổi tiếng, được hâm mộ và đánh giá cao: người mẫu sáng giá * ứng cử viên sáng giá của chức vô địch",
    example: "người mẫu sáng giá * ứng cử viên sáng giá của chức vô địch",
  },
  {
    word: "sáng choang",
    part_of_speech: "tính từ",
    meaning:
      "rất sáng, đến mức làm cho mọi vật như ánh lên: nhà cửa sáng choang * đèn điện thắp sáng choang",
    example: "nhà cửa sáng choang * đèn điện thắp sáng choang",
  },
  {
    word: "sang giàu",
    part_of_speech: "tính từ",
    meaning: "như giàu sang: mơ ước một cuộc sống sang giàu",
    example: "mơ ước một cuộc sống sang giàu",
  },
  {
    word: "sảng khoái",
    part_of_speech: "tính từ",
    meaning:
      "có cảm giác dễ chịu, thoả mãn về tinh thần, làm cho đầu óc thấy tỉnh táo, sáng suốt: cười sảng khoái * tinh thần sảng khoái",
    example: "cười sảng khoái * tinh thần sảng khoái",
  },
  {
    word: "sáng kiến",
    part_of_speech: "danh từ",
    meaning:
      "ý kiến mới, giúp cho công việc tiến hành tốt hơn, thuận lợi hơn: nảy ra sáng kiến mới * sáng kiến cải tiến kĩ thuật",
    example: "nảy ra sáng kiến mới * sáng kiến cải tiến kĩ thuật",
  },
  {
    word: "sáng lập",
    part_of_speech: "động từ",
    meaning:
      "xây dựng nên, lập nên cái trước đó chưa hề có: người sáng lập công ti * thành viên sáng lập",
    example: "người sáng lập công ti * thành viên sáng lập",
  },
  {
    word: "sang năm",
    part_of_speech: "danh từ",
    meaning:
      'năm tới: "Ăn chơi cho hết năm nay, Sang năm kiếm chốn cho tày người ta." (ca dao)',
    example:
      'Ăn chơi cho hết năm nay, Sang năm kiếm chốn cho tày người ta." (ca dao)',
  },
  {
    word: "sáng láng",
    part_of_speech: "tính từ",
    meaning:
      "có khả năng nhận thức rõ ràng: đầu óc sáng láng * cô bé rất thông minh, sáng láng",
    example: "đầu óc sáng láng * cô bé rất thông minh, sáng láng",
  },
  {
    word: "sàng lọc",
    part_of_speech: "động từ",
    meaning:
      "lựa chọn kĩ lưỡng để loại bỏ những cái xấu, những cái không đạt tiêu chuẩn hoặc không phù hợp (nói khái quát): xét nghiệm sàng lọc HIV * sàng lọc đối tượng",
    example: "xét nghiệm sàng lọc HIV * sàng lọc đối tượng",
  },
  {
    word: "sáng ngời",
    part_of_speech: "tính từ",
    meaning:
      "sáng trong và ánh lên vẻ đẹp: đôi mắt sáng ngời * viên ngọc sáng ngời",
    example: "đôi mắt sáng ngời * viên ngọc sáng ngời",
  },
  {
    word: "sáng ngời",
    part_of_speech: "tính từ",
    meaning:
      "đẹp rực rỡ, tựa như có cái gì toả sáng ra: tấm gương trung dũng sáng ngời * tương lai sáng ngời",
    example: "tấm gương trung dũng sáng ngời * tương lai sáng ngời",
  },
  {
    word: "sáng mai",
    part_of_speech: "danh từ",
    meaning: "buổi sáng ngày hôm sau: khuya rồi, để sáng mai làm tiếp",
    example: "khuya rồi, để sáng mai làm tiếp",
  },
  {
    word: "sáng loáng",
    part_of_speech: "tính từ",
    meaning:
      "sáng lấp lánh trên khắp bề mặt: lưỡi lê sáng loáng * đồng tiền xu sáng loáng",
    example: "lưỡi lê sáng loáng * đồng tiền xu sáng loáng",
  },
  {
    word: "sáng mắt",
    part_of_speech: "tính từ",
    meaning: "(mắt) còn tinh, nhìn thấy rõ: già rồi nhưng còn sáng mắt",
    example: "già rồi nhưng còn sáng mắt",
  },
  {
    word: "sáng mắt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) thấy ra, nhận ra những điều mà trước đó vì mê muội không nhận thấy: có thế mới sáng mắt ra!",
    example: "có thế mới sáng mắt ra!",
  },
  {
    word: "sang ngang",
    part_of_speech: "động từ",
    meaning:
      "qua sông, từ bến bên này vượt ngang qua sông để sang bến bên kia: đò sang ngang",
    example: "đò sang ngang",
  },
  {
    word: "sang ngang",
    part_of_speech: "động từ",
    meaning:
      'đi lấy chồng (thường với hàm ý không bằng lòng, không như mong muốn): "Chuyến này chị bước sang ngang, Là tan vỡ giấc mộng vàng từ nay." (NgBính; 11)',
    example:
      'Chuyến này chị bước sang ngang, Là tan vỡ giấc mộng vàng từ nay." (NgBính; 11)',
  },
  {
    word: "sáng quắc",
    part_of_speech: "tính từ",
    meaning:
      "có ánh sáng chiếu ra mạnh đến mức làm chói mắt: mắt sáng quắc * lưỡi lê sáng quắc",
    example: "mắt sáng quắc * lưỡi lê sáng quắc",
  },
  {
    word: "sang sảng",
    part_of_speech: "tính từ",
    meaning:
      "(giọng nói) to khoẻ và vang: giọng nói sang sảng * sang sảng tiếng đồng",
    example: "giọng nói sang sảng * sang sảng tiếng đồng",
  },
  {
    word: "sáng rực",
    part_of_speech: "tính từ",
    meaning:
      "có ánh sáng bừng lên, toả mạnh ra xung quanh: lửa cháy sáng rực * ánh mắt sáng rực lên vì vui sướng",
    example: "lửa cháy sáng rực * ánh mắt sáng rực lên vì vui sướng",
  },
  {
    word: "sang nhượng",
    part_of_speech: "động từ",
    meaning:
      "bán và sang tên cho người khác, thường là bất động sản: sang nhượng nhà * sang nhượng cửa hàng",
    example: "sang nhượng nhà * sang nhượng cửa hàng",
  },
  {
    word: "sang sáng",
    part_of_speech: "tính từ",
    meaning: "hơi sáng: trời đã sang sáng",
    example: "trời đã sang sáng",
  },
  {
    word: "sáng sáng",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) sáng này sang sáng khác, sáng nào cũng như vậy: sáng sáng dậy tập thể dục",
    example: "sáng sáng dậy tập thể dục",
  },
  {
    word: "sàng sảy",
    part_of_speech: "động từ",
    meaning:
      "sàng và sảy để làm sạch chất hạt rời (nói khái quát): gạo mới xát, chưa sàng sảy",
    example: "gạo mới xát, chưa sàng sảy",
  },
  {
    word: "sáng sủa",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều ánh sáng chiếu vào, gây cảm giác thoải mái, dễ chịu: bầu trời sáng sủa * ngôi nhà cao ráo, sáng sủa",
    example: "bầu trời sáng sủa * ngôi nhà cao ráo, sáng sủa",
  },
  {
    word: "sáng sủa",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có nhiều nét lộ vẻ thông minh (thường nói về người còn ít tuổi): mặt mũi sáng sủa * đầu óc không được sáng sủa",
    example: "mặt mũi sáng sủa * đầu óc không được sáng sủa",
  },
  {
    word: "sáng sủa",
    part_of_speech: "tính từ",
    meaning:
      "(cách diễn đạt, trình bày) rõ ràng, rành mạch, dễ hiểu: lối viết sáng sủa, mạch lạc * trình bày sáng sủa",
    example: "lối viết sáng sủa, mạch lạc * trình bày sáng sủa",
  },
  {
    word: "sáng sủa",
    part_of_speech: "tính từ",
    meaning:
      "tốt đẹp và cho thấy có nhiều triển vọng: một tương lai sáng sủa đang mở ra trước mắt",
    example: "một tương lai sáng sủa đang mở ra trước mắt",
  },
  {
    word: "sáng suốt",
    part_of_speech: "tính từ",
    meaning:
      "có khả năng nhận thức đúng đắn, giúp giải quyết vấn đề một cách tỉnh táo, không sai lầm: đầu óc sáng suốt * một quyết định thiếu sáng suốt * sự lựa chọn sáng suốt",
    example:
      "đầu óc sáng suốt * một quyết định thiếu sáng suốt * sự lựa chọn sáng suốt",
  },
  {
    word: "sang sửa",
    part_of_speech: "động từ",
    meaning: "(hiếm) như sửa sang: sang sửa nhà cửa",
    example: "sang sửa nhà cửa",
  },
  {
    word: "sảng sốt",
    part_of_speech: "tính từ",
    meaning:
      'hoảng hốt xen lẫn vẻ ngơ ngác do bị chấn động mạnh về tinh thần một cách bất ngờ: tiếng kêu thảng thốt * "Phò ngẩng lên, thảng thốt như vừa mới giật mình tỉnh dậy." (TrBôn; 1)',
    example:
      'tiếng kêu thảng thốt * "Phò ngẩng lên, thảng thốt như vừa mới giật mình tỉnh dậy.',
  },
  {
    word: "sáng tác",
    part_of_speech: "danh từ",
    meaning: "tác phẩm văn học, nghệ thuật: một sáng tác có giá trị",
    example: "một sáng tác có giá trị",
  },
  {
    word: "sáng tạo",
    part_of_speech: "động từ",
    meaning:
      "tạo ra những giá trị mới về vật chất hoặc tinh thần: sáng tạo ra chữ viết * sáng tạo nghệ thuật",
    example: "sáng tạo ra chữ viết * sáng tạo nghệ thuật",
  },
  {
    word: "sáng tạo",
    part_of_speech: "tính từ",
    meaning:
      "có cách giải quyết mới, không bị gò bó, phụ thuộc vào cái đã có: có óc sáng tạo * vận dụng một cách sáng tạo",
    example: "có óc sáng tạo * vận dụng một cách sáng tạo",
  },
  {
    word: "sang trọng",
    part_of_speech: "tính từ",
    meaning:
      "sang, làm cho người ta phải coi trọng (nói khái quát): nhà cửa sang trọng * ăn mặc sang trọng",
    example: "nhà cửa sang trọng * ăn mặc sang trọng",
  },
  {
    word: "sáng trưng",
    part_of_speech: "tính từ",
    meaning:
      "sáng đến mức có thể thấy rõ mồn một mọi vật: đèn điện thắp sáng trưng",
    example: "đèn điện thắp sáng trưng",
  },
  {
    word: "sang tên",
    part_of_speech: "động từ",
    meaning:
      "làm các thủ tục giấy tờ chuyển quyền sở hữu tài sản cho người khác: sang tên ngôi nhà cho con",
    example: "sang tên ngôi nhà cho con",
  },
  {
    word: "sáng tỏ",
    part_of_speech: "tính từ",
    meaning: "(hiếm) sáng, trông thấy rõ: bóng trăng sáng tỏ * trời đã sáng tỏ",
    example: "bóng trăng sáng tỏ * trời đã sáng tỏ",
  },
  {
    word: "sáng tỏ",
    part_of_speech: "tính từ",
    meaning: "rõ ràng, không còn nghi vấn gì nữa: làm sáng tỏ vụ việc",
    example: "làm sáng tỏ vụ việc",
  },
  {
    word: "sáng ý",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có khả năng hiểu nhanh, nắm bắt nhanh (thường dùng với người còn trẻ tuổi): cậu bé rất sáng ý * sáng ý nên học rất nhanh",
    example: "cậu bé rất sáng ý * sáng ý nên học rất nhanh",
  },
  {
    word: "sàng tuyển",
    part_of_speech: "danh từ",
    meaning:
      "sàng, tuyển lựa và phân loại than thành từng loại riêng: sàng tuyển than bằng nước hoặc dung dịch",
    example: "sàng tuyển than bằng nước hoặc dung dịch",
  },
  {
    word: "sành",
    part_of_speech: "danh từ",
    meaning:
      'gốm rất rắn, chế từ đất sét thô, có tráng men, nung ở nhiệt độ khoảng 1000OC: bát sành * "Rượu ngon chẳng quản be sành, áo rách khéo vá hơn lành vụng may." (Cdao)',
    example:
      'bát sành * "Rượu ngon chẳng quản be sành, áo rách khéo vá hơn lành vụng may." (Cdao)',
  },
  {
    word: "sành",
    part_of_speech: "động từ",
    meaning:
      "am hiểu, thông thạo và có nhiều kinh nghiệm: sành đồ cổ * sành ăn",
    example: "sành đồ cổ * sành ăn",
  },
  {
    word: "sánh duyên",
    part_of_speech: "động từ",
    meaning:
      "(văn chương) kết duyên với nhau: mơ ước được sánh duyên cùng người đẹp",
    example: "mơ ước được sánh duyên cùng người đẹp",
  },
  {
    word: "sánh",
    part_of_speech: "động từ",
    meaning: "(hiếm) như so (ng1): sánh với các bạn thì còn thua xa",
    example: "sánh với các bạn thì còn thua xa",
  },
  {
    word: "sánh",
    part_of_speech: "động từ",
    meaning:
      'đạt mức độ bằng khi so với cái làm chuẩn: giỏi ít ai sánh kịp * "Thuyền quyên sánh với anh hùng, Những người thục nữ sánh cùng văn nhân." (ca dao)',
    example:
      'giỏi ít ai sánh kịp * "Thuyền quyên sánh với anh hùng, Những người thục nữ sánh cùng văn nhân." (ca dao)',
  },
  {
    word: "sánh",
    part_of_speech: "động từ",
    meaning:
      "(chất lỏng) tràn ra ngoài vật chứa vì bị chao động: thùng nước đầy, sánh cả ra ngoài",
    example: "thùng nước đầy, sánh cả ra ngoài",
  },
  {
    word: "sánh",
    part_of_speech: "tính từ",
    meaning: "ở trạng thái gần như đặc quánh lại: cháo sánh * mật nấu đã sánh",
    example: "cháo sánh * mật nấu đã sánh",
  },
  {
    word: "sảnh",
    part_of_speech: "danh từ",
    meaning:
      "phòng lớn dùng làm nơi tiếp khách: bày tiệc tiếp đãi ở ngoài sảnh",
    example: "bày tiệc tiếp đãi ở ngoài sảnh",
  },
  {
    word: "sánh bước",
    part_of_speech: "động từ",
    meaning:
      "đi kề nhau, giữ đều bước cho ngang hàng với nhau: sánh bước nhau đi dạo",
    example: "sánh bước nhau đi dạo",
  },
  {
    word: "sành điệu",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) tỏ ra rất sành (thường trong việc thưởng thức, đánh giá): lái xe sành điệu * tỏ ra là người sành điệu",
    example: "lái xe sành điệu * tỏ ra là người sành điệu",
  },
  {
    word: "sánh đôi",
    part_of_speech: "động từ",
    meaning:
      '(cũ) như sánh duyên: "Ước gì lòng được như lòng, Như chim loan phượng ngô đồng sánh đôi." (ca dao)',
    example:
      'Ước gì lòng được như lòng, Như chim loan phượng ngô đồng sánh đôi." (ca dao)',
  },
  {
    word: "sành sứ",
    part_of_speech: "danh từ",
    meaning: "đồ dùng bằng sành, sứ (nói khái quát): cửa hàng bán đồ sành sứ",
    example: "cửa hàng bán đồ sành sứ",
  },
  {
    word: "sành sỏi",
    part_of_speech: "tính từ",
    meaning:
      "thành thạo, đến mức biết rõ các ngóc ngách, mánh khoé cần thiết (thường hàm ý chê): bà nội trợ sành sỏi * một tay sành sỏi trên thương trường",
    example: "bà nội trợ sành sỏi * một tay sành sỏi trên thương trường",
  },
  {
    word: "sanh sánh",
    part_of_speech: "tính từ",
    meaning: "hơi sánh: bát cháo sanh sánh",
    example: "bát cháo sanh sánh",
  },
  {
    word: "sao",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi chung các thiên thể nhìn thấy như những điểm sáng lấp lánh trên bầu trời ban đêm: trời đầy sao * đông sao thì nắng, vắng sao thì mưa (tng)",
    example: "trời đầy sao * đông sao thì nắng, vắng sao thì mưa (tng)",
  },
  {
    word: "sao",
    part_of_speech: "danh từ",
    meaning:
      "thiên thể toả nhiệt và tự phát ra ánh sáng: sao Bắc Cực * hành tinh quay quanh một ngôi sao",
    example: "sao Bắc Cực * hành tinh quay quanh một ngôi sao",
  },
  {
    word: "sao",
    part_of_speech: "danh từ",
    meaning:
      "hình tượng trưng cho ngôi sao, thường có nhiều cánh nhọn toả ra từ một điểm trung tâm: ngôi sao năm cánh * đèn ông sao * đánh dấu sao vào những ý quan trọng",
    example:
      "ngôi sao năm cánh * đèn ông sao * đánh dấu sao vào những ý quan trọng",
  },
  {
    word: "sao",
    part_of_speech: "danh từ",
    meaning:
      "váng dầu, mỡ có hình tròn, nhỏ, lóng lánh nổi trên mặt chất lỏng: bát canh nổi đầy sao",
    example: "bát canh nổi đầy sao",
  },
  {
    word: "sao",
    part_of_speech: "danh từ",
    meaning: "chấm trắng nổi lên trên bộ lông một số động vật: hươu sao",
    example: "hươu sao",
  },
  {
    word: "sao",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng sau các số từ từ một đến năm, biểu thị sự xếp hạng của khách sạn: khách sạn 5 sao",
    example: "khách sạn 5 sao",
  },
  {
    word: "sao",
    part_of_speech: "động từ",
    meaning: "đảo trong chảo đun nóng để làm cho thật khô: sao chè * sao thuốc",
    example: "sao chè * sao thuốc",
  },
  {
    word: "sao",
    part_of_speech: "động từ",
    meaning:
      "chép lại hoặc tạo ra bản khác theo đúng bản gốc (thường nói về giấy tờ hành chính): sao nguyên văn hồ sơ * bản sao * sao thành ba bản",
    example: "sao nguyên văn hồ sơ * bản sao * sao thành ba bản",
  },
  {
    word: "sao",
    part_of_speech: "đại từ",
    meaning:
      "từ dùng để chỉ cái không biết cụ thể như thế nào (thường dùng để hỏi): có sao không? * bị sao thế? * muốn nghĩ sao cũng được",
    example: "có sao không? * bị sao thế? * muốn nghĩ sao cũng được",
  },
  {
    word: "sao",
    part_of_speech: "đại từ",
    meaning:
      "từ dùng để chỉ nguyên nhân không biết rõ của điều đã xảy ra (thường dùng để hỏi): sao lại không đi nữa? * sao lâu thế?",
    example: "sao lại không đi nữa? * sao lâu thế?",
  },
  {
    word: "sao",
    part_of_speech: "đại từ",
    meaning:
      "từ dùng để chỉ một phương thức, cách thức nào đấy được xác định đại khái: muốn làm sao thì làm, miễn là xong việc * nghĩ sao nói vậy",
    example: "muốn làm sao thì làm, miễn là xong việc * nghĩ sao nói vậy",
  },
  {
    word: "sao",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý ngạc nhiên trước một mức độ cảm thấy không bình thường, và như tự hỏi nguyên nhân: giọng hát sao nghe buồn thế! * cuộc đời sao mà ngắn ngủi!",
    example: "giọng hát sao nghe buồn thế! * cuộc đời sao mà ngắn ngủi!",
  },
  {
    word: "sao",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý nhấn mạnh mức độ làm ngạc nhiên, thán phục: cảnh vật mới đẹp sao! * cậu bé đáng yêu làm sao!",
    example: "cảnh vật mới đẹp sao! * cậu bé đáng yêu làm sao!",
  },
  {
    word: "sáo",
    part_of_speech: "danh từ",
    meaning:
      'chim nhỏ, lông đen có điểm trắng ở cánh, thường sống thành đàn: "Ai đem con sáo sang sông, Để cho con sáo sổ lồng nó bay." (Cdao)',
    example: 'Ai đem con sáo sang sông, Để cho con sáo sổ lồng nó bay." (Cdao)',
  },
  {
    word: "sáo",
    part_of_speech: "tính từ",
    meaning:
      "(cách nói, cách viết) theo một khuôn mẫu có sẵn, nghe rất kêu nhưng nhàm và không chân thật: văn viết sáo * những lời nói sáo",
    example: "văn viết sáo * những lời nói sáo",
  },
  {
    word: "sáo",
    part_of_speech: "danh từ",
    meaning: "mành tre: bức sáo",
    example: "bức sáo",
  },
  {
    word: "sao chép",
    part_of_speech: "động từ",
    meaning: "tạo ra một hoặc nhiều bản giống như bản gốc: sao chép tài liệu",
    example: "sao chép tài liệu",
  },
  {
    word: "sánh vai",
    part_of_speech: "động từ",
    meaning:
      "kề vai đi ngang nhau: sánh vai nhau dạo bước * dân tộc Việt Nam sánh vai cùng các cường quốc năm châu",
    example:
      "sánh vai nhau dạo bước * dân tộc Việt Nam sánh vai cùng các cường quốc năm châu",
  },
  {
    word: "sào",
    part_of_speech: "danh từ",
    meaning:
      "cây dài, thẳng bằng tre, nứa, v.v. thường dùng để chống thuyền, để phơi quần áo v.v.: lấy sào chọc cho rụng * chuột chạy cùng sào (tng)",
    example: "lấy sào chọc cho rụng * chuột chạy cùng sào (tng)",
  },
  {
    word: "sào",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị cũ đo diện tích ruộng đất, bằng một phần mười mẫu, tức bằng 360 mét vuông (sào Bắc Bộ) hay 497 mét vuông (sào Trung Bộ): cấy hai sào lúa * sản lượng đạt 3 tạ một sào",
    example: "cấy hai sào lúa * sản lượng đạt 3 tạ một sào",
  },
  {
    word: "sao chụp",
    part_of_speech: "động từ",
    meaning: "chụp sao lại: photocopy tập tài liệu",
    example: "photocopy tập tài liệu",
  },
  {
    word: "sáo cũ",
    part_of_speech: "tính từ",
    meaning:
      "(cách nói, cách viết) sáo và đã được nhiều người dùng lâu và lặp đi lặp lại quá nhiều, nghe nhàm: nói những câu sáo cũ * lời văn sáo cũ",
    example: "nói những câu sáo cũ * lời văn sáo cũ",
  },
  {
    word: "sào huyệt",
    part_of_speech: "danh từ",
    meaning:
      "nơi tụ tập, ẩn náu của bọn trộm cướp, bọn người nguy hiểm: tấn công vào sào huyệt của bọn tội phạm",
    example: "tấn công vào sào huyệt của bọn tội phạm",
  },
  {
    word: "sáo mòn",
    part_of_speech: "tính từ",
    meaning:
      "(hình thức diễn đạt) nhàm và đơn điệu, vì đã được nhiều người dùng lặp đi lặp lại quá nhiều: lời lẽ sáo mòn * lối viết sáo mòn",
    example: "lời lẽ sáo mòn * lối viết sáo mòn",
  },
  {
    word: "sao nhãng",
    part_of_speech: "động từ",
    meaning:
      "không để tâm, không dồn công sức vào công việc chính phải làm, do bị lôi cuốn vào những cái khác: sao nhãng việc học hành * không được sao nhãng nhiệm vụ",
    example: "sao nhãng việc học hành * không được sao nhãng nhiệm vụ",
  },
  {
    word: "sáo ngữ",
    part_of_speech: "danh từ",
    meaning:
      "từ ngữ, câu văn được dùng đi dùng lại quá nhiều, nghe mãi thành nhàm: bài viết dùng nhiều sáo ngữ",
    example: "bài viết dùng nhiều sáo ngữ",
  },
  {
    word: "sáo mép",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ba hoa những lời bóng bẩy nhưng rỗng tuếch, không có giá trị: nói những câu sáo mép",
    example: "nói những câu sáo mép",
  },
  {
    word: "sáo rỗng",
    part_of_speech: "tính từ",
    meaning:
      "(lời văn) sáo, không có nội dung gì: viết những lời sáo rỗng * văn chương sáo rỗng",
    example: "viết những lời sáo rỗng * văn chương sáo rỗng",
  },
  {
    word: "sát",
    part_of_speech: "động từ",
    meaning:
      "(có tướng số) làm vợ, hay chồng chết sớm, theo quan niệm duy tâm: tướng sát chồng",
    example: "tướng sát chồng",
  },
  {
    word: "sát",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) có khả năng, tựa như trời phú, hay đánh bắt được nhiều chim, thú, cá, v.v.: một tay sát cá",
    example: "một tay sát cá",
  },
  {
    word: "sát",
    part_of_speech: "tính từ",
    meaning:
      "gần đến mức như tiếp giáp, không còn khoảng cách ở giữa: kê bàn sát tường * bé nằm sát mẹ * nhà sát chợ * những ngày sát Tết",
    example:
      "kê bàn sát tường * bé nằm sát mẹ * nhà sát chợ * những ngày sát Tết",
  },
  {
    word: "sát",
    part_of_speech: "tính từ",
    meaning:
      "có sự tiếp xúc, theo dõi thường xuyên, nên có những hiểu biết kĩ càng, cặn kẽ về những người nào đó, việc gì đó: chỉ đạo sát * theo sát phong trào * theo dõi rất sát",
    example: "chỉ đạo sát * theo sát phong trào * theo dõi rất sát",
  },
  {
    word: "sát",
    part_of_speech: "tính từ",
    meaning:
      "bị dính chặt một cách tự nhiên, khó bóc ra: trứng sát vỏ * sản phụ bị sát nhau",
    example: "trứng sát vỏ * sản phụ bị sát nhau",
  },
  {
    word: "sát",
    part_of_speech: "tính từ",
    meaning:
      "(làm việc gì) theo đúng những yêu cầu của một thực tế khách quan nào đó, không có sự sai lệch: tính không sát * dịch sát bản gốc",
    example: "tính không sát * dịch sát bản gốc",
  },
  {
    word: "sát",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) (nước) rất cạn, khi thuỷ triều xuống: đợi lúc nước sát mới đi bắt cá",
    example: "đợi lúc nước sát mới đi bắt cá",
  },
  {
    word: "sạt",
    part_of_speech: "động từ",
    meaning: "lở, sụt mất từng mảng lớn: kè lại đoạn đê bị sạt * núi sạt",
    example: "kè lại đoạn đê bị sạt * núi sạt",
  },
  {
    word: "sạt",
    part_of_speech: "động từ",
    meaning: "vụt qua thật sát, gần như chạm vào: đạn sạt qua vai",
    example: "đạn sạt qua vai",
  },
  {
    word: "sạt",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng phát ra như tiếng động chạm mạnh vào lá cây: có tiếng sạt trong bụi cây",
    example: "có tiếng sạt trong bụi cây",
  },
  {
    word: "sáp",
    part_of_speech: "danh từ",
    meaning:
      "chất mềm không thấm nước do một số sâu bọ tiết ra để xây tổ hoặc làm vỏ bảo vệ bên ngoài: sáp ong",
    example: "sáp ong",
  },
  {
    word: "sáp",
    part_of_speech: "danh từ",
    meaning:
      "chất mềm không thấm nước, trông giống như sáp ong, thường màu trắng ngà, có nhiều công dụng khác nhau: sáp nến * sáp nẻ",
    example: "sáp nến * sáp nẻ",
  },
  {
    word: "sáp",
    part_of_speech: "danh từ",
    meaning:
      "chất mềm và dẻo, màu hồng hay đỏ, dùng để trang điểm: sáp bôi môi * soi gương đánh sáp",
    example: "sáp bôi môi * soi gương đánh sáp",
  },
  {
    word: "sáp nhập",
    part_of_speech: "động từ",
    meaning:
      "nhập vào với nhau làm một (thường nói về các tổ chức, đơn vị hành chính): ba xã sáp nhập làm một * sáp nhập hai tỉnh",
    example: "ba xã sáp nhập làm một * sáp nhập hai tỉnh",
  },
  {
    word: "sạp",
    part_of_speech: "danh từ",
    meaning: "sàn trong khoang thuyền: đầy một sạp cá",
    example: "đầy một sạp cá",
  },
  {
    word: "sạp",
    part_of_speech: "danh từ",
    meaning:
      "sàn ghép bằng tre, nứa, gỗ để nằm hay để bày hàng hoá: sạp hàng * sạp vải",
    example: "sạp hàng * sạp vải",
  },
  {
    word: "sát cánh",
    part_of_speech: "động từ",
    meaning:
      "cùng hợp sức chặt chẽ trong một công việc chung: kề vai sát cánh * luôn sát cánh bên nhau",
    example: "kề vai sát cánh * luôn sát cánh bên nhau",
  },
  {
    word: "sát hại",
    part_of_speech: "động từ",
    meaning: "như giết hại: bị giặc sát hại",
    example: "bị giặc sát hại",
  },
  {
    word: "sát hạch",
    part_of_speech: "động từ",
    meaning:
      "kiểm tra xem kiến thức hay khả năng có đáp ứng yêu cầu hay không: kiểm tra sát hạch * trượt trong kì sát hạch",
    example: "kiểm tra sát hạch * trượt trong kì sát hạch",
  },
  {
    word: "sát khuẩn",
    part_of_speech: "động từ",
    meaning: "diệt vi khuẩn: chất sát khuẩn",
    example: "chất sát khuẩn",
  },
  {
    word: "sát nhân",
    part_of_speech: "động từ",
    meaning: "giết người một cách cố ý: kẻ sát nhân",
    example: "kẻ sát nhân",
  },
  {
    word: "sát hợp",
    part_of_speech: "tính từ",
    meaning:
      "sát và phù hợp với tình hình thực tế: định ra một chính sách thuế sát hợp",
    example: "định ra một chính sách thuế sát hợp",
  },
  {
    word: "sạt lở",
    part_of_speech: "động từ",
    meaning:
      "(đất, đá) nứt vỡ và sụt xuống từng mảng lớn: quãng đê bị sạt lở * trái mìn làm sạt lở cả một mảng sườn núi",
    example: "quãng đê bị sạt lở * trái mìn làm sạt lở cả một mảng sườn núi",
  },
  {
    word: "sát nách",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) sát ngay bên cạnh: hai nhà sát nách nhau * kẻ thù ở ngay sát nách",
    example: "hai nhà sát nách nhau * kẻ thù ở ngay sát nách",
  },
  {
    word: "sạt nghiệp",
    part_of_speech: "động từ",
    meaning:
      "tiêu tan hết cả cơ nghiệp: sạt nghiệp vì cờ bạc * làm ăn như thế rồi có ngày sạt nghiệp",
    example: "sạt nghiệp vì cờ bạc * làm ăn như thế rồi có ngày sạt nghiệp",
  },
  {
    word: "sát nút",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) sát nhau, chỉ còn cách nhau một khoảng không đáng kể: đuổi sát nút * thắng với tỉ số sát nút",
    example: "đuổi sát nút * thắng với tỉ số sát nút",
  },
  {
    word: "sát khí",
    part_of_speech: "danh từ",
    meaning: "vẻ dữ tợn như muốn đánh, giết người ngay: mặt đằng đằng sát khí",
    example: "mặt đằng đằng sát khí",
  },
  {
    word: "sát sàn sạt",
    part_of_speech: "tính từ",
    meaning:
      '(khẩu ngữ) sát đến mức như chạm vào nhau hoặc trùng khít vào nhau, không chệch tí nào: tính sát sàn sạt * "Chiếc phản lực trinh sát (...) là sát sàn sạt mái ngói những ngôi nhà (...)" (BNinh; 5)',
    example:
      'tính sát sàn sạt * "Chiếc phản lực trinh sát (...) là sát sàn sạt mái ngói những ngôi nhà (...)" (BNinh; 5)',
  },
  {
    word: "sát phạt",
    part_of_speech: "động từ",
    meaning: "(cũ) đánh giết.",
    example: "các con bạc sát phạt nhau cả đêm",
  },
  {
    word: "sát sao",
    part_of_speech: "tính từ",
    meaning: "sát (nói khái quát): kiểm tra sát sao * tính toán sát sao",
    example: "kiểm tra sát sao * tính toán sát sao",
  },
  {
    word: "sát sinh",
    part_of_speech: "động từ",
    meaning:
      "giết sinh vật (nói khái quát): kiêng sát sinh * đạo Phật cấm sát sinh",
    example: "kiêng sát sinh * đạo Phật cấm sát sinh",
  },
  {
    word: "sát sinh",
    part_of_speech: "động từ",
    meaning:
      "giết súc vật để làm thịt (nói khái quát): lò sát sinh * thuế sát sinh",
    example: "lò sát sinh * thuế sát sinh",
  },
  {
    word: "sát trùng",
    part_of_speech: "động từ",
    meaning: "diệt vi trùng: thuốc sát trùng * sát trùng vết thương cẩn thận",
    example: "thuốc sát trùng * sát trùng vết thương cẩn thận",
  },
  {
    word: "sát sườn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có quan hệ trực tiếp đến lợi ích của bản thân: quyền lợi sát sườn",
    example: "quyền lợi sát sườn",
  },
  {
    word: "sát sạt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) rất sát, như liền với nhau: đứng sát sạt vào nhau * nhà sát sạt đường",
    example: "đứng sát sạt vào nhau * nhà sát sạt đường",
  },
  {
    word: "sát sạt",
    part_of_speech: "tính từ",
    meaning:
      "rất sát, không sai một chút nào: dự trù sát sạt, không thừa cũng không thiếu",
    example: "dự trù sát sạt, không thừa cũng không thiếu",
  },
  {
    word: "sau",
    part_of_speech: "danh từ",
    meaning:
      "ở phía đối lập với phía trước mặt, khi mắt nhìn thẳng không thể thấy được: đứng đằng sau * sau lưng * đi tụt lại phía sau",
    example: "đứng đằng sau * sau lưng * đi tụt lại phía sau",
  },
  {
    word: "sau",
    part_of_speech: "danh từ",
    meaning:
      "phía những vị trí bị che khuất, hoặc phía những vị trí không ở mặt chính của sự vật, không thường bày ra cho người ta nhìn thấy: mặt trời khuất sau núi * treo quần áo sau cánh cửa * viết mấy dòng lưu niệm sau tấm ảnh",
    example:
      "mặt trời khuất sau núi * treo quần áo sau cánh cửa * viết mấy dòng lưu niệm sau tấm ảnh",
  },
  {
    word: "sau",
    part_of_speech: "danh từ",
    meaning:
      "phía xa hơn so với vị trí, giới hạn nào đó: ngồi ở hàng ghế sau nên hơi khó nhìn",
    example: "ngồi ở hàng ghế sau nên hơi khó nhìn",
  },
  {
    word: "sau",
    part_of_speech: "danh từ",
    meaning:
      "khoảng của những thời điểm kể từ thời điểm lấy làm mốc nào đó trở đi: kế hoạch của năm sau * từ nay về sau * người đến sau",
    example: "kế hoạch của năm sau * từ nay về sau * người đến sau",
  },
  {
    word: "sát thực",
    part_of_speech: "tính từ",
    meaning:
      "có nội dung sát với thực tế: ý kiến sát thực * đánh giá tình hình không sát thực",
    example: "ý kiến sát thực * đánh giá tình hình không sát thực",
  },
  {
    word: "sau cùng",
    part_of_speech: "danh từ",
    meaning:
      "sau tất cả những người khác, việc khác: người về đích sau cùng * những lời nói sau cùng",
    example: "người về đích sau cùng * những lời nói sau cùng",
  },
  {
    word: "sau này",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian sau thời điểm nói hoặc thời điểm được nói đến nào đó: lo cho cuộc sống sau này * mong sau này gặp lại",
    example: "lo cho cuộc sống sau này * mong sau này gặp lại",
  },
  {
    word: "sát thủ",
    part_of_speech: "danh từ",
    meaning: "kẻ giết người: truy tìm sát thủ",
    example: "truy tìm sát thủ",
  },
  {
    word: "sát thương",
    part_of_speech: "động từ",
    meaning:
      "giết chết hoặc làm bị thương: mìn sát thương * hạn chế gây sát thương",
    example: "mìn sát thương * hạn chế gây sát thương",
  },
  {
    word: "sáu",
    part_of_speech: "danh từ",
    meaning:
      "số (ghi bằng 6) liền sau số năm trong dãy số tự nhiên: mười sáu * một trăm linh sáu * toà nhà có sáu tầng",
    example: "mười sáu * một trăm linh sáu * toà nhà có sáu tầng",
  },
  {
    word: "sau rốt",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) sau cùng, sau tất cả: đi sau rốt",
    example: "đi sau rốt",
  },
  {
    word: "say đắm",
    part_of_speech: "động từ",
    meaning:
      "say mê đến mức như chìm sâu vào, không còn biết gì đến cái khác, đến xung quanh nữa: yêu say đắm * cái nhìn say đắm",
    example: "yêu say đắm * cái nhìn say đắm",
  },
  {
    word: "say mê",
    part_of_speech: "động từ",
    meaning:
      'ham thích đặc biệt và bị cuốn hút liên tục vào công việc nào đó, đến mức như không còn thiết gì khác nữa: say mê tửu sắc * "Tuồng gì cua ốc ngoài đồng, Đẹp gì người ấy mà lòng say mê!" (ca dao)',
    example:
      'say mê tửu sắc * "Tuồng gì cua ốc ngoài đồng, Đẹp gì người ấy mà lòng say mê!" (ca dao)',
  },
  {
    word: "sảy",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) rôm: nổi sảy đầy người * cái sảy nảy cái ung (tng)",
    example: "nổi sảy đầy người * cái sảy nảy cái ung (tng)",
  },
  {
    word: "say hoa đắm nguyệt",
    part_of_speech: "",
    meaning:
      '(văn chương) say đắm sắc đẹp: "Mang bầu tới quán rượu dâu, Say hoa đắm nguyệt quên câu ân tình." (ca dao)',
    example:
      'Mang bầu tới quán rượu dâu, Say hoa đắm nguyệt quên câu ân tình." (ca dao)',
  },
  {
    word: "say mèm",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) say rượu đến mức như bủn rủn cả chân tay, không gắng gượng được nữa: uống một trận say mèm",
    example: "uống một trận say mèm",
  },
  {
    word: "say khướt",
    part_of_speech: "tính từ",
    meaning: "say rượu đến mức không còn biết gì nữa cả: uống rượu say khướt",
    example: "uống rượu say khướt",
  },
  {
    word: "say xỉn",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) say rượu, bia đến mức chẳng còn biết gì: suốt ngày nhậu nhẹt say xỉn",
    example: "suốt ngày nhậu nhẹt say xỉn",
  },
  {
    word: "say máu",
    part_of_speech: "động từ",
    meaning:
      "hăng đánh giết đến mức như điên cuồng, không còn biết gì nữa: con ác thú say máu, càng trở nên dữ tợn",
    example: "con ác thú say máu, càng trở nên dữ tợn",
  },
  {
    word: "say",
    part_of_speech: "động từ",
    meaning:
      'ở trạng thái bị ngây ngất, choáng váng, nôn nao do tác động của rượu, thuốc hay các yếu tố có tác dụng kích thích: say sóng * say nắng * "Rượu lạt uống lắm cũng say, Người khôn nói lắm dẫu hay cũng nhàm." (Cdao)',
    example:
      'say sóng * say nắng * "Rượu lạt uống lắm cũng say, Người khôn nói lắm dẫu hay cũng nhàm." (Cdao)',
  },
  {
    word: "say",
    part_of_speech: "động từ",
    meaning:
      'ở trạng thái bị cuốn hút hoàn toàn, đến mức như không biết gì đến xung quanh: tiếng hát làm say lòng người * "Thoắt thôi tay lại cầm tay, Càng yêu vì nết, càng say vì tình." (TKiều)',
    example:
      'tiếng hát làm say lòng người * "Thoắt thôi tay lại cầm tay, Càng yêu vì nết, càng say vì tình." (TKiều)',
  },
  {
    word: "say",
    part_of_speech: "tính từ",
    meaning: "(ngủ) rất sâu, không còn hay biết gì cả: ngủ say như chết",
    example: "ngủ say như chết",
  },
  {
    word: "say sưa",
    part_of_speech: "động từ",
    meaning:
      'say rượu (nói khái quát): "Giàu đâu những kẻ ngủ trưa, Sang đâu những kẻ say sưa tối ngày." (ca dao)',
    example:
      'Giàu đâu những kẻ ngủ trưa, Sang đâu những kẻ say sưa tối ngày." (ca dao)',
  },
  {
    word: "say sưa",
    part_of_speech: "động từ",
    meaning:
      "ở trạng thái bị tập trung, cuốn hút hoàn toàn vào một công việc hứng thú nào đó: say sưa làm việc * đọc say sưa * nhìn đắm đuối, say sưa",
    example: "say sưa làm việc * đọc say sưa * nhìn đắm đuối, say sưa",
  },
  {
    word: "sắc",
    part_of_speech: "danh từ",
    meaning: "(cũ) lệnh bằng văn bản của vua: đọc sắc vua ban",
    example: "đọc sắc vua ban",
  },
  {
    word: "sắc",
    part_of_speech: "danh từ",
    meaning: "màu, màu sắc.",
    example: "sắc mặt không vui * thất sắc",
  },
  {
    word: "sắc",
    part_of_speech: "danh từ",
    meaning:
      "nước da và những biểu hiện trên mặt con người, phản ánh tình trạng sức khoẻ hay trạng thái tâm lí, tình cảm nhất định (nói tổng quát): sắc mặt không vui * thất sắc",
    example:
      'vừa có sắc, vừa có tài * "Một hai nghiêng nước nghiêng thành, Sắc đành đòi một, tài đành hoạ hai." (TKiều)',
  },
  {
    word: "sắc",
    part_of_speech: "động từ",
    meaning:
      "đun thuốc nam, thuốc bắc với nước cho sôi lâu để cho ra hết chất: sắc thuốc bắc",
    example: "sắc thuốc bắc",
  },
  {
    word: "sắc",
    part_of_speech: "tính từ",
    meaning:
      "có cạnh rất mỏng, dễ làm đứt các vật được chặt, cắt: dao sắc * lưỡi gươm rất sắc",
    example: "dao sắc * lưỡi gươm rất sắc",
  },
  {
    word: "sắc",
    part_of_speech: "tính từ",
    meaning: "tỏ ra rất tinh và nhanh: cô gái có đôi mắt rất sắc * sắc nước cờ",
    example: "cô gái có đôi mắt rất sắc * sắc nước cờ",
  },
  {
    word: "sắc",
    part_of_speech: "tính từ",
    meaning: "(âm thanh) quá cao, nghe không êm tai: một tiếng quát gọn và sắc",
    example: "một tiếng quát gọn và sắc",
  },
  {
    word: "sắc cạnh",
    part_of_speech: "tính từ",
    meaning: "sắc sảo và sành sỏi: một con người sắc cạnh * lời nói sắc cạnh",
    example: "một con người sắc cạnh * lời nói sắc cạnh",
  },
  {
    word: "sắc bén",
    part_of_speech: "tính từ",
    meaning:
      "rất tinh, rất nhanh nhạy (nói khái quát): cái nhìn sắc bén * sự chỉ đạo sắc bén * miệng lưỡi sắc bén",
    example: "cái nhìn sắc bén * sự chỉ đạo sắc bén * miệng lưỡi sắc bén",
  },
  {
    word: "sắc bén",
    part_of_speech: "tính từ",
    meaning: "có hiệu lực, có tác dụng tư tưởng mạnh mẽ: lập luận sắc bén",
    example: "lập luận sắc bén",
  },
  {
    word: "sặc",
    part_of_speech: "động từ",
    meaning:
      "bị ho mạnh hoặc hắt hơi liên tục do có vật gì lọt vào làm cho tắc nghẽn khí quản một cách đột ngột: sặc nước * sặc khói * đang ăn thì bị sặc",
    example: "sặc nước * sặc khói * đang ăn thì bị sặc",
  },
  {
    word: "sặc",
    part_of_speech: "động từ",
    meaning:
      "(hơi, mùi) bốc lên, toả ra với mức độ đậm đặc, thường gây khó chịu: miệng sặc hơi bia * sặc mùi nước hoa",
    example: "miệng sặc hơi bia * sặc mùi nước hoa",
  },
  {
    word: "sắc diện",
    part_of_speech: "danh từ",
    meaning: "(hiếm) sắc mặt: không thay đổi sắc diện",
    example: "không thay đổi sắc diện",
  },
  {
    word: "sắc đẹp",
    part_of_speech: "danh từ",
    meaning: "vẻ đẹp của người phụ nữ: có sắc đẹp lộng lẫy * chăm sóc sắc đẹp",
    example: "có sắc đẹp lộng lẫy * chăm sóc sắc đẹp",
  },
  {
    word: "sắc dục",
    part_of_speech: "danh từ",
    meaning: "lòng ham muốn quá đáng về tình dục với phụ nữ: đam mê sắc dục",
    example: "đam mê sắc dục",
  },
  {
    word: "sặc gạch",
    part_of_speech: "động từ",
    meaning: "(thông tục) như sặc máu: tức sặc gạch",
    example: "tức sặc gạch",
  },
  {
    word: "sắc độ",
    part_of_speech: "danh từ",
    meaning:
      'độ đậm nhạt của màu sắc: "(...) trời tối mờ mờ, bàng bạc, cùng một sắc độ như nhau giữa trời và nước." (LVThảo; 15)',
    example:
      '(...) trời tối mờ mờ, bàng bạc, cùng một sắc độ như nhau giữa trời và nước." (LVThảo; 15)',
  },
  {
    word: "sắc lệnh",
    part_of_speech: "danh từ",
    meaning:
      "văn bản do người đứng đầu nhà nước ban hành, quy định những điều quan trọng, có giá trị như một văn bản pháp luật: chính phủ ban bố sắc lệnh chống rửa tiền",
    example: "chính phủ ban bố sắc lệnh chống rửa tiền",
  },
  {
    word: "sắc lạnh",
    part_of_speech: "tính từ",
    meaning:
      "rất sắc, đến mức gây cảm giác ớn lạnh khi chạm vào: lưỡi dao sắc lạnh",
    example: "lưỡi dao sắc lạnh",
  },
  {
    word: "sắc lạnh",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra rất sắc sảo, với thái độ lạnh lùng đến mức đáng sợ: cái nhìn sắc lạnh * bộ mặt sắc lạnh",
    example: "cái nhìn sắc lạnh * bộ mặt sắc lạnh",
  },
  {
    word: "sặc mùi",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) thuần một kiểu, một tính chất (thường là xấu) rất rõ rệt: giọng sặc mùi tiền * sặc mùi tiểu tư sản",
    example: "giọng sặc mùi tiền * sặc mùi tiểu tư sản",
  },
  {
    word: "sặc máu",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) hộc máu mồm, máu mũi, do phải chịu một tác động dữ dội nào đó quá sức chịu đựng: tức sặc máu * làm sặc máu vẫn không đủ ăn (làm rất vất vả, nặng nhọc)",
    example:
      "tức sặc máu * làm sặc máu vẫn không đủ ăn (làm rất vất vả, nặng nhọc)",
  },
  {
    word: "sắc lẹm",
    part_of_speech: "tính từ",
    meaning:
      "sắc đến mức như đụng vào là đứt ngay: lưỡi gươm sắc lẹm * ánh mắt sắc lẹm",
    example: "lưỡi gươm sắc lẹm * ánh mắt sắc lẹm",
  },
  {
    word: "sắc phong",
    part_of_speech: "động từ",
    meaning:
      "(cũ) (nhà vua) ra sắc chỉ phong phẩm tước: được sắc phong là quận chúa",
    example: "được sắc phong là quận chúa",
  },
  {
    word: "sắc màu",
    part_of_speech: "danh từ",
    meaning:
      "sự biểu hiện vẻ đẹp của màu sắc: quần áo rực rỡ sắc màu * sắc màu của đồng quê",
    example: "quần áo rực rỡ sắc màu * sắc màu của đồng quê",
  },
  {
    word: "sắc nước hương trời",
    part_of_speech: "",
    meaning:
      '(văn chương) ví sắc đẹp tuyệt trần, hiếm có trên đời: "Thực âu sắc nước hương trời, Chẳng dòng thần nữ cũng vời tiên cung." (MĐMK)',
    example:
      'Thực âu sắc nước hương trời, Chẳng dòng thần nữ cũng vời tiên cung." (MĐMK)',
  },
  {
    word: "sắc sảo",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra có khả năng nhận xét, ứng phó nhanh, tinh tường và thông minh: một cây bút sắc sảo * đôi mắt sắc sảo",
    example: "một cây bút sắc sảo * đôi mắt sắc sảo",
  },
  {
    word: "sắc phục",
    part_of_speech: "danh từ",
    meaning: "quần áo, trang phục nói chung: sắc phục cảnh sát",
    example: "sắc phục cảnh sát",
  },
  {
    word: "sắc phục",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) quần áo có màu sắc khác nhau để phân biệt cấp bậc của quan lại thời phong kiến: bộ sắc phục võ tướng * sắc phục của quan văn",
    example: "bộ sắc phục võ tướng * sắc phục của quan văn",
  },
  {
    word: "sặc sụa",
    part_of_speech: "động từ",
    meaning: "sặc liên hồi thành cơn dài: ho sặc sụa * cười sặc sụa",
    example: "ho sặc sụa * cười sặc sụa",
  },
  {
    word: "sặc sụa",
    part_of_speech: "động từ",
    meaning:
      "xông lên mạnh và khắp trong phạm vi nào đó một mùi rất khó chịu: hơi rượu sặc sụa * không gian sặc sụa mùi khói",
    example: "hơi rượu sặc sụa * không gian sặc sụa mùi khói",
  },
  {
    word: "sắc thái",
    part_of_speech: "danh từ",
    meaning:
      "nét phân biệt tinh tế giữa những sự vật về cơ bản giống nhau: các từ đồng nghĩa thường khác nhau về sắc thái",
    example: "các từ đồng nghĩa thường khác nhau về sắc thái",
  },
  {
    word: "sắc thái",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) thần thái của một con người thể hiện qua nét mặt: sắc thái vui vẻ",
    example: "sắc thái vui vẻ",
  },
  {
    word: "sặc sỡ",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều màu sắc sáng, chói xen lẫn nhau: quần áo sặc sỡ * màu sắc sặc sỡ",
    example: "quần áo sặc sỡ * màu sắc sặc sỡ",
  },
  {
    word: "sắc thuế",
    part_of_speech: "danh từ",
    meaning: "loại thuế: sắc thuế doanh thu * sắc thuế xuất nhập khẩu",
    example: "sắc thuế doanh thu * sắc thuế xuất nhập khẩu",
  },
  {
    word: "sắc tố",
    part_of_speech: "danh từ",
    meaning:
      "chất có màu, thấm vào các thể hữu cơ hay các chất lỏng trong cơ thể: sắc tố da",
    example: "sắc tố da",
  },
  {
    word: "sắc tộc",
    part_of_speech: "danh từ",
    meaning: "như tộc người: xung đột sắc tộc * một dân tộc đa sắc tộc",
    example: "xung đột sắc tộc * một dân tộc đa sắc tộc",
  },
  {
    word: "sặc tiết",
    part_of_speech: "động từ",
    meaning: "(thông tục) như sặc máu: uất sặc tiết mà đành phải nhịn",
    example: "uất sặc tiết mà đành phải nhịn",
  },
  {
    word: "sắm nắm",
    part_of_speech: "tính từ",
    meaning: "rối rít, tíu tít khi làm một việc thích thú: xắm nắm đi xem hội",
    example: "xắm nắm đi xem hội",
  },
  {
    word: "săm",
    part_of_speech: "danh từ",
    meaning:
      "ống cao su tròn khép kín, dùng để chứa khí nén, đặt trong lốp bánh xe ô tô, mô tô, xe đạp: vá săm xe đạp * xe bị thủng săm",
    example: "vá săm xe đạp * xe bị thủng săm",
  },
  {
    word: "săm",
    part_of_speech: "danh từ",
    meaning: "(cũ, hiếm) nhà săm (nói tắt): chủ săm",
    example: "chủ săm",
  },
  {
    word: "sắm sanh",
    part_of_speech: "động từ",
    meaning:
      '(khẩu ngữ) mua sắm các thứ (nói khái quát): sắm sanh quần áo * "Bõ công bác mẹ sắm sanh, Sắm nghiên sắm bút cho anh học hành." (ca dao)',
    example:
      'sắm sanh quần áo * "Bõ công bác mẹ sắm sanh, Sắm nghiên sắm bút cho anh học hành." (ca dao)',
  },
  {
    word: "sắm",
    part_of_speech: "động từ",
    meaning: "mua để có sẵn mà dùng: đi sắm Tết * sắm một lúc mấy bộ quần áo",
    example: "đi sắm Tết * sắm một lúc mấy bộ quần áo",
  },
  {
    word: "săm sắn",
    part_of_speech: "tính từ",
    meaning:
      "nhanh nhảu (trong công việc): xăm xắn thu dọn nhà cửa * xăm xắn đi trước dẫn đường",
    example: "xăm xắn thu dọn nhà cửa * xăm xắn đi trước dẫn đường",
  },
  {
    word: "sẵn",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái có thể sử dụng được ngay hoặc hành động được ngay, do đã được chuẩn bị: đợi sẵn ở cổng * quần áo may sẵn * cửa hàng bán đồ ăn sẵn",
    example: "đợi sẵn ở cổng * quần áo may sẵn * cửa hàng bán đồ ăn sẵn",
  },
  {
    word: "sẵn",
    part_of_speech: "tính từ",
    meaning:
      'có nhiều đến mức đáp ứng đầy đủ nhu cầu: hàng hoá rất sẵn * "Trong tay đã sẵn đồng tiền, Dầu lòng đổi trắng thay đen khó gì!" (TKiều)',
    example:
      'hàng hoá rất sẵn * "Trong tay đã sẵn đồng tiền, Dầu lòng đổi trắng thay đen khó gì!" (TKiều)',
  },
  {
    word: "sẵn",
    part_of_speech: "kết từ",
    meaning:
      '(khẩu ngữ) nhân tiện có: sẵn có đông đủ mọi người, ta bàn việc luôn thể * "Sẵn cây roi trong tay, ông Cai lệ quất luôn cho nó mấy cái (...)" (NgTTố; 5)',
    example:
      'sẵn có đông đủ mọi người, ta bàn việc luôn thể * "Sẵn cây roi trong tay, ông Cai lệ quất luôn cho nó mấy cái (...)" (NgTTố; 5)',
  },
  {
    word: "săn bắn",
    part_of_speech: "động từ",
    meaning:
      "săn muông thú (nói khái quát): nghề săn bắn * cấm săn bắn động vật hoang dã",
    example: "nghề săn bắn * cấm săn bắn động vật hoang dã",
  },
  {
    word: "sắm sửa",
    part_of_speech: "động từ",
    meaning:
      'mua sắm để cho có đủ các thứ cần thiết đối với một việc nào đó: sắm sửa sách vở cho năm học mới * "Lấy anh, anh sắm sửa cho, Sắm ăn, sắm mặc, sắm cho chơi bời." (ca dao)',
    example:
      'sắm sửa sách vở cho năm học mới * "Lấy anh, anh sắm sửa cho, Sắm ăn, sắm mặc, sắm cho chơi bời." (ca dao)',
  },
  {
    word: "sắm sửa",
    part_of_speech: "động từ",
    meaning:
      'sửa soạn, chuẩn bị: sắm sửa hành trang * "Gần xa nô nức yến anh, Chị em sắm sửa bộ hành chơi xuân." (TKiều)',
    example:
      'sắm sửa hành trang * "Gần xa nô nức yến anh, Chị em sắm sửa bộ hành chơi xuân." (TKiều)',
  },
  {
    word: "sắn",
    part_of_speech: "danh từ",
    meaning:
      "cây cùng họ với thầu dầu, thân thẳng mang nhiều sẹo lá, lá có cuống dài, phiến xẻ hình chân vịt, rễ củ chứa nhiều tinh bột, dùng để ăn: củ sắn * hom sắn",
    example: "củ sắn * hom sắn",
  },
  {
    word: "săm soi",
    part_of_speech: "động từ",
    meaning:
      "ngắm đi ngắm lại một cách thích thú: săm soi mình trong gương * săm soi chiếc đồng hồ mới",
    example: "săm soi mình trong gương * săm soi chiếc đồng hồ mới",
  },
  {
    word: "săm soi",
    part_of_speech: "động từ",
    meaning:
      "nhìn với vẻ hết sức chú ý, như để phát hiện đến từng chi tiết nhỏ: tính hay săm soi, để ý",
    example: "tính hay săm soi, để ý",
  },
  {
    word: "sắm vai",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) đóng vai: sắm vai bà mối",
    example: "sắm vai bà mối",
  },
  {
    word: "săn bắt",
    part_of_speech: "động từ",
    meaning:
      "tìm bắt, đuổi bắt muông thú để ăn thịt, sinh sống (một hình thái kinh tế nguyên thuỷ): người nguyên thuỷ sống bằng săn bắt và hái lượm",
    example: "người nguyên thuỷ sống bằng săn bắt và hái lượm",
  },
  {
    word: "săn bắt",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) lùng bắt: săn bắt thủ phạm * đội săn bắt cướp",
    example: "săn bắt thủ phạm * đội săn bắt cướp",
  },
  {
    word: "săn",
    part_of_speech: "động từ",
    meaning: "đuổi bắt hoặc tìm giết muông thú: đi săn * vào rừng săn thú",
    example: "đi săn * vào rừng săn thú",
  },
  {
    word: "săn",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) lùng bắt, lùng kiếm: săn đồ cổ * phóng viên săn tin",
    example: "săn đồ cổ * phóng viên săn tin",
  },
  {
    word: "săn",
    part_of_speech: "tính từ",
    meaning:
      '(sợi xe) được xoắn rất chặt vào nhau: thừng bện săn * "Thường thường phải đạo thì thôi, Đừng săn mà đứt, đừng lơi mà chùng." (ca dao)',
    example:
      'thừng bện săn * "Thường thường phải đạo thì thôi, Đừng săn mà đứt, đừng lơi mà chùng." (ca dao)',
  },
  {
    word: "săn",
    part_of_speech: "tính từ",
    meaning: "(bộ phận cơ thể) rắn chắc: cánh tay rất săn * bắp thịt săn chắc",
    example: "cánh tay rất săn * bắp thịt săn chắc",
  },
  {
    word: "săn",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) (mưa rơi, nước chảy) mau, mạnh: mưa săn hạt * nước chảy săn",
    example: "mưa săn hạt * nước chảy săn",
  },
  {
    word: "sắn dây",
    part_of_speech: "danh từ",
    meaning:
      "cây leo cùng họ với đậu, đỗ, lá có ba lá chét rộng, rễ củ dài giống như củ sắn, chứa nhiều bột, dùng để ăn hay làm thuốc: khóm sắn dây * bột sắn dây",
    example: "khóm sắn dây * bột sắn dây",
  },
  {
    word: "săn đón",
    part_of_speech: "động từ",
    meaning:
      "tỏ thái độ niềm nở, vồ vập khi gặp mặt, thường nhằm để lấy lòng: săn đón khách hàng * săn đón hỏi han",
    example: "săn đón khách hàng * săn đón hỏi han",
  },
  {
    word: "sẵn sàng",
    part_of_speech: "tính từ",
    meaning:
      'ở trạng thái có thể sử dụng hoặc hành động được ngay do đã được chuẩn bị đầy đủ: sẵn sàng chiến đấu * "Thấy nhàn luống tưởng thư phong, Nghe hơi sương sắm áo bông sẵn sàng." (CPN)',
    example:
      'sẵn sàng chiến đấu * "Thấy nhàn luống tưởng thư phong, Nghe hơi sương sắm áo bông sẵn sàng." (CPN)',
  },
  {
    word: "săn sắt",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) cá săn sắt (nói tắt): thả con săn sắt, bắt con cá rô (tng)",
    example: "thả con săn sắt, bắt con cá rô (tng)",
  },
  {
    word: "sẵn lòng",
    part_of_speech: "động từ",
    meaning:
      "sẵn sàng làm việc gì đó vì người khác một cách vui vẻ: sẵn lòng tha thứ * sẵn lòng giúp đỡ",
    example: "sẵn lòng tha thứ * sẵn lòng giúp đỡ",
  },
  {
    word: "săn lùng",
    part_of_speech: "động từ",
    meaning:
      "lùng sục khắp nơi để tìm kiếm: săn lùng tội phạm * bị chủ nợ săn lùng * săn lùng cổ vật",
    example: "săn lùng tội phạm * bị chủ nợ săn lùng * săn lùng cổ vật",
  },
  {
    word: "săn tìm",
    part_of_speech: "động từ",
    meaning:
      "tìm kiếm một cách kĩ càng, ráo riết để có được: săn tìm đồ cổ * săn tìm tài liệu",
    example: "săn tìm đồ cổ * săn tìm tài liệu",
  },
  {
    word: "săn đuổi",
    part_of_speech: "động từ",
    meaning:
      "theo đuổi một cách ráo riết để có được: con thú bị săn đuổi đến đường cùng",
    example: "con thú bị săn đuổi đến đường cùng",
  },
  {
    word: "săng",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) cỏ tranh: nhà lợp săng",
    example: "nhà lợp săng",
  },
  {
    word: "săng",
    part_of_speech: "danh từ",
    meaning: "(cũ) quan tài: hàng săng chết bó chiếu (tng)",
    example: "hàng săng chết bó chiếu (tng)",
  },
  {
    word: "săn sóc",
    part_of_speech: "động từ",
    meaning:
      "chăm nom chu đáo, tận tình: săn sóc cha mẹ * tận tình săn sóc người ốm",
    example: "săn sóc cha mẹ * tận tình săn sóc người ốm",
  },
  {
    word: "sắp đặt",
    part_of_speech: "động từ",
    meaning:
      "đặt, xếp cho có thứ tự (nói khái quát): sắp đặt công việc đâu ra đấy",
    example: "sắp đặt công việc đâu ra đấy",
  },
  {
    word: "sắp đặt",
    part_of_speech: "động từ",
    meaning:
      "đặt, xếp theo ý định, theo sự tính toán trước: làm theo sự sắp đặt của người khác",
    example: "làm theo sự sắp đặt của người khác",
  },
  {
    word: "sắp",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) bọn (thường nói về trẻ con): sắp trẻ nhà tôi * ghé vô nhà thăm sắp nhỏ",
    example: "sắp trẻ nhà tôi * ghé vô nhà thăm sắp nhỏ",
  },
  {
    word: "sắp",
    part_of_speech: "danh từ",
    meaning:
      "làn điệu trong hát chèo, có tính chất vui vẻ, phấn khởi, dùng để đối đáp hay để hát tập thể: điệu sắp",
    example: "điệu sắp",
  },
  {
    word: "sắp",
    part_of_speech: "động từ",
    meaning: "đặt, xếp vào đúng chỗ, theo hàng lối, thứ tự: sắp hàng * sắp chữ",
    example: "sắp hàng * sắp chữ",
  },
  {
    word: "sắp",
    part_of_speech: "động từ",
    meaning:
      "bày ra theo một trật tự nhất định, chuẩn bị sẵn để làm việc gì: sắp thức ăn ra mâm * sắp sẵn hành lí để đi",
    example: "sắp thức ăn ra mâm * sắp sẵn hành lí để đi",
  },
  {
    word: "sắp",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị rằng sự việc, hiện tượng xảy ra vào thời gian tới, rất gần: sắp đến ngày thi * bệnh sắp khỏi * trời sắp mưa",
    example: "sắp đến ngày thi * bệnh sắp khỏi * trời sắp mưa",
  },
  {
    word: "sắp xếp",
    part_of_speech: "động từ",
    meaning:
      "xếp theo một trật tự coi là hợp lí nhất: sắp xếp thời gian * sắp xếp công việc gia đình",
    example: "sắp xếp thời gian * sắp xếp công việc gia đình",
  },
  {
    word: "sắt đá",
    part_of_speech: "tính từ",
    meaning:
      "cứng cỏi, kiên quyết đến mức không gì lay chuyển được: lòng tin sắt đá * ý chí sắt đá",
    example: "lòng tin sắt đá * ý chí sắt đá",
  },
  {
    word: "sắp sửa",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) chuẩn bị, sửa soạn sẵn (nói khái quát): sắp sửa hành trang lên đường",
    example: "sắp sửa hành trang lên đường",
  },
  {
    word: "sắp sửa",
    part_of_speech: "phụ từ",
    meaning:
      'từ biểu thị sự việc sắp xảy ra, ngay trước mắt: thuyền sắp sửa rời bến * "Tám Bính hồi hộp nghĩ đến tình cảnh sắp sửa dấn thân vào." (NgHồng; 1)',
    example:
      'thuyền sắp sửa rời bến * "Tám Bính hồi hộp nghĩ đến tình cảnh sắp sửa dấn thân vào." (NgHồng; 1)',
  },
  {
    word: "sặt",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) cá sặt (nói tắt): mắm sặt * khô sặt",
    example: "mắm sặt * khô sặt",
  },
  {
    word: "sặt",
    part_of_speech: "danh từ",
    meaning:
      "cây thuộc loại tre, thân nhỏ rất thẳng, dùng làm sào, gậy hoặc để đan lát: rừng sặt",
    example: "rừng sặt",
  },
  {
    word: "sắt",
    part_of_speech: "danh từ",
    meaning:
      "kim loại màu xám xanh, dễ dát mỏng và kéo sợi, dễ bị gỉ trong không khí ẩm, là thành phần chính của gang và thép: có công mài sắt, có ngày nên kim (tng)",
    example: "có công mài sắt, có ngày nên kim (tng)",
  },
  {
    word: "sắt",
    part_of_speech: "tính từ",
    meaning:
      "cứng rắn trong ý chí, tình cảm: kỉ luật sắt * gan vàng dạ sắt (tng)",
    example: "kỉ luật sắt * gan vàng dạ sắt (tng)",
  },
  {
    word: "sắt",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái trở nên khô cứng và rắn chắc: rang cho thịt sắt lại * người sắt lại",
    example: "rang cho thịt sắt lại * người sắt lại",
  },
  {
    word: "sắt",
    part_of_speech: "tính từ",
    meaning: "trở nên có vẻ cứng rắn và tựa như đanh lại: giọng sắt lại",
    example: "giọng sắt lại",
  },
  {
    word: "sắt tây",
    part_of_speech: "danh từ",
    meaning: "thép lá, mềm, có tráng mạ thiếc: thùng sắt tây",
    example: "thùng sắt tây",
  },
  {
    word: "sấm",
    part_of_speech: "danh từ",
    meaning:
      "tiếng nổ rền vang do hiện tượng phóng điện giữa hai đám mây gây ra khi trời có dông: sấm rền * sấm vang chớp giật",
    example: "sấm rền * sấm vang chớp giật",
  },
  {
    word: "sấm",
    part_of_speech: "danh từ",
    meaning:
      "lời dự đoán có tính chất bí ẩn về sự kiện lớn trong tương lai có quan hệ đến đời sống của một xã hội, một dân tộc, theo thuật lí số: lời sấm * sấm Trạng Trình",
    example: "lời sấm * sấm Trạng Trình",
  },
  {
    word: "sẩm",
    part_of_speech: "tính từ",
    meaning:
      "(khoảng thời gian) bắt đầu tối, không còn trông rõ mọi vật nữa: đi từ lúc sẩm tối",
    example: "đi từ lúc sẩm tối",
  },
  {
    word: "sẫm",
    part_of_speech: "tính từ",
    meaning: "(màu sắc) đậm và hơi tối: vải sẫm màu * xanh sẫm * tím sẫm",
    example: "vải sẫm màu * xanh sẫm * tím sẫm",
  },
  {
    word: "sầm",
    part_of_speech: "tính từ",
    meaning: "(bầu trời) tối lại một cách đột ngột: bầu trời tối sầm",
    example: "bầu trời tối sầm",
  },
  {
    word: "sầm",
    part_of_speech: "tính từ",
    meaning:
      "(vẻ mặt) bỗng nhiên mất tươi, có vẻ như tối lại và trở nên nặng nề: sầm ngay mặt lại",
    example: "sầm ngay mặt lại",
  },
  {
    word: "sầm",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng rất to và đột ngột, như tiếng va đập rất mạnh của những vật lớn, nặng: đóng sầm cánh cửa lại * cái xe đổ đánh sầm",
    example: "đóng sầm cánh cửa lại * cái xe đổ đánh sầm",
  },
  {
    word: "sâm banh",
    part_of_speech: "danh từ",
    meaning:
      "rượu vang trắng, có nhiều bọt, thường dùng để chúc tụng trong các dịp vui mừng: uống sâm banh * khai vị bằng sâm banh",
    example: "uống sâm banh * khai vị bằng sâm banh",
  },
  {
    word: "sậm",
    part_of_speech: "tính từ",
    meaning: "như sẫm (nhưng nghĩa mạnh hơn): sậm màu * tím sậm",
    example: "sậm màu * tím sậm",
  },
  {
    word: "sấm kí",
    part_of_speech: "danh từ",
    meaning:
      "những lời sấm được ghi chép lại: lời sấm kí của Nguyễn Bỉnh Khiêm",
    example: "lời sấm kí của Nguyễn Bỉnh Khiêm",
  },
  {
    word: "sấm ký",
    part_of_speech: "danh từ",
    meaning:
      "những lời sấm được ghi chép lại: lời sấm kí của Nguyễn Bỉnh Khiêm",
    example: "lời sấm kí của Nguyễn Bỉnh Khiêm",
  },
  {
    word: "sấm sét",
    part_of_speech: "danh từ",
    meaning:
      "sấm và sét (nói khái quát); thường dùng để ví những tác động mạnh khủng khiếp: giáng những đòn sấm sét",
    example: "giáng những đòn sấm sét",
  },
  {
    word: "sầm sập",
    part_of_speech: "tính từ",
    meaning:
      'từ mô phỏng tiếng như tiếng mưa to đổ xuống dồn dập: mưa sầm sập * "Tiếng khoan như gió thoảng ngoài, Tiếng mau sầm sập như trời đổ mưa." (TKiều)',
    example:
      'mưa sầm sập * "Tiếng khoan như gió thoảng ngoài, Tiếng mau sầm sập như trời đổ mưa." (TKiều)',
  },
  {
    word: "sầm sập",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả vẻ nhanh, mạnh và dồn dập: máy bay sầm sập lao tới * đám người sầm sập tiến vào",
    example: "máy bay sầm sập lao tới * đám người sầm sập tiến vào",
  },
  {
    word: "sầm sì",
    part_of_speech: "tính từ",
    meaning: "(trời) u ám, nặng nề như sắp mưa: trời sầm sì muốn mưa",
    example: "trời sầm sì muốn mưa",
  },
  {
    word: "sâm sẩm",
    part_of_speech: "tính từ",
    meaning: "(trời) vừa mới bắt đầu tối: trời vừa sâm sẩm * sâm sẩm tối",
    example: "trời vừa sâm sẩm * sâm sẩm tối",
  },
  {
    word: "sân",
    part_of_speech: "danh từ",
    meaning:
      "khoảng đất trống, bằng phẳng thường ở ngay trước cửa nhà: bọn trẻ chơi ngoài sân * sân đình * phơi thóc ở sân kho",
    example: "bọn trẻ chơi ngoài sân * sân đình * phơi thóc ở sân kho",
  },
  {
    word: "sân",
    part_of_speech: "danh từ",
    meaning:
      "khoảng đất phẳng có kích thước và những thiết bị nhất định, dùng để chơi một số môn thể thao: sân bóng * sân tennis * cầu thủ phạm lỗi bị đuổi ra khỏi sân",
    example: "sân bóng * sân tennis * cầu thủ phạm lỗi bị đuổi ra khỏi sân",
  },
  {
    word: "sầm uất",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều nhà cửa, đông đúc và nhộn nhịp, biểu thị sự giàu có, đang phát triển tốt đẹp: thị trấn sầm uất * phố nhỏ nhưng sầm uất",
    example: "thị trấn sầm uất * phố nhỏ nhưng sầm uất",
  },
  {
    word: "sần",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều nốt nổi xù xì trên bề mặt, không trơn, không nhẵn: da sần * hai bàn tay chai sần * mặt vải sần",
    example: "da sần * hai bàn tay chai sần * mặt vải sần",
  },
  {
    word: "sần",
    part_of_speech: "tính từ",
    meaning: "(quả cây) bị khô, không có nước: quả cam sần",
    example: "quả cam sần",
  },
  {
    word: "sân chơi",
    part_of_speech: "danh từ",
    meaning:
      "hoạt động hoặc nơi diễn ra các hoạt động được coi như một trò chơi, có tác dụng giải trí: sân chơi âm nhạc * các sân chơi trên truyền hình",
    example: "sân chơi âm nhạc * các sân chơi trên truyền hình",
  },
  {
    word: "sân chơi",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) môi trường diễn ra một hoạt động kinh tế, xã hội nào đó thường có tính cạnh tranh: tạo sân chơi bình đẳng giữa các thành phần kinh tế",
    example: "tạo sân chơi bình đẳng giữa các thành phần kinh tế",
  },
  {
    word: "sân rồng",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) sân chầu trước cung vua: "Chàng vào bái tạ cửu trùng, Tạ từ vâng trước sân rồng bước ra." (CC)',
    example:
      'Chàng vào bái tạ cửu trùng, Tạ từ vâng trước sân rồng bước ra." (CC)',
  },
  {
    word: "sân siu",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tính toán, thêm bớt một cách không chi li để cho đủ, cho cân đối: sân siu mỗi người một ít * tính sân siu",
    example: "sân siu mỗi người một ít * tính sân siu",
  },
  {
    word: "sấn",
    part_of_speech: "danh từ",
    meaning:
      "phần thịt có nạc nằm trên mỡ phần ở lưng, mông và vai lợn: thịt sấn * mông sấn",
    example: "thịt sấn * mông sấn",
  },
  {
    word: "sấn",
    part_of_speech: "động từ",
    meaning:
      "xông thẳng tới, không kể gì xung quanh: sấn ngay đến bên cạnh * sấn vào đánh bạn",
    example: "sấn ngay đến bên cạnh * sấn vào đánh bạn",
  },
  {
    word: "sấn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (hành động) bừa đi, bất chấp tất cả: bảo nhau làm sấn tới",
    example: "bảo nhau làm sấn tới",
  },
  {
    word: "sân khách",
    part_of_speech: "danh từ",
    meaning:
      "sân bóng của đội đối phương, khi đội mình đến đó để thi đấu; phân biệt với sân nhà: đá trên sân khách",
    example: "đá trên sân khách",
  },
  {
    word: "sân cỏ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) sân có trồng cỏ; thường dùng để chỉ môn bóng đá: ngôi sao sân cỏ * câu chuyện bên lề sân cỏ",
    example: "ngôi sao sân cỏ * câu chuyện bên lề sân cỏ",
  },
  {
    word: "sân khấu",
    part_of_speech: "danh từ",
    meaning:
      "sàn dùng cho diễn viên biểu diễn: bước ra sân khấu * đứng sau cánh gà trên sân khấu",
    example: "bước ra sân khấu * đứng sau cánh gà trên sân khấu",
  },
  {
    word: "sân khấu",
    part_of_speech: "danh từ",
    meaning:
      "nghệ thuật biểu diễn trên sân khấu; nghệ thuật sân khấu (nói tắt): sân khấu cải lương * hội diễn sân khấu",
    example: "sân khấu cải lương * hội diễn sân khấu",
  },
  {
    word: "sân nhà",
    part_of_speech: "danh từ",
    meaning:
      "sân bóng của đội mình, khi thi đấu; phân biệt với sân khách: lợi thế sân nhà * để thua ngay trên sân nhà",
    example: "lợi thế sân nhà * để thua ngay trên sân nhà",
  },
  {
    word: "sần sật",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng như tiếng nhai vật giòn và hơi dai, như cùi dừa, sụn, v.v.: nhai cùi dừa sần sật",
    example: "nhai cùi dừa sần sật",
  },
  {
    word: "sấn sổ",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả dáng bộ hung hăng, lấn tới một cách trắng trợn: sấn sổ bước đến * hành động sấn sổ",
    example: "sấn sổ bước đến * hành động sấn sổ",
  },
  {
    word: "sần sùi",
    part_of_speech: "tính từ",
    meaning:
      "có những nốt to nhỏ không đều nổi lên khắp bề mặt, trông không đẹp: vỏ cam sần sùi * da mặt sần sùi",
    example: "vỏ cam sần sùi * da mặt sần sùi",
  },
  {
    word: "sân thượng",
    part_of_speech: "danh từ",
    meaning:
      "khoảng rộng trên mái bằng của nhà: lên sân thượng ngắm trăng * phơi quần áo trên sân thượng",
    example: "lên sân thượng ngắm trăng * phơi quần áo trên sân thượng",
  },
  {
    word: "sân sướng",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) sân của nhà ở (nói khái quát): quét dọn sân sướng",
    example: "quét dọn sân sướng",
  },
  {
    word: "sấp",
    part_of_speech: "tính từ",
    meaning:
      "ở tư thế gáy và lưng ở bên trên, mặt và phần trước cơ thể ở bên dưới: nằm sấp * ngã sấp mặt xuống đất * chạy sấp chạy ngửa (tng)",
    example: "nằm sấp * ngã sấp mặt xuống đất * chạy sấp chạy ngửa (tng)",
  },
  {
    word: "sấp",
    part_of_speech: "tính từ",
    meaning:
      "ở vị trí phía mặt hay phía lòng trũng được đặt bên dưới: đặt sấp quân bài * thuyền bị lật sấp",
    example: "đặt sấp quân bài * thuyền bị lật sấp",
  },
  {
    word: "sấp mặt",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) có thái độ trở mặt, bội bạc với người đã làm điều tốt cho mình: đồ sấp mặt! (tiếng chửi mắng)",
    example: "đồ sấp mặt! (tiếng chửi mắng)",
  },
  {
    word: "sập sùi",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả cảnh trời lúc mưa nhỏ lúc tạnh, kéo dài không ngớt: mưa gió sập sùi",
    example: "mưa gió sập sùi",
  },
  {
    word: "sập",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng để nằm, bằng gỗ, mặt liền với chân, xung quanh có diềm: sập gụ * ngồi chễm chệ trên sập",
    example: "sập gụ * ngồi chễm chệ trên sập",
  },
  {
    word: "sập",
    part_of_speech: "động từ",
    meaning:
      "đổ ập xuống một cách đột ngột, thường trên một phạm vi rộng: nhà bị sập * cầu bị bom đánh sập * mưa sập xuống",
    example: "nhà bị sập * cầu bị bom đánh sập * mưa sập xuống",
  },
  {
    word: "sập",
    part_of_speech: "động từ",
    meaning:
      "đóng mạnh và nhanh cho thật khớp vào: đóng sập cửa * chuột sập bẫy",
    example: "đóng sập cửa * chuột sập bẫy",
  },
  {
    word: "sấp ngửa",
    part_of_speech: "danh từ",
    meaning:
      "lối đánh bạc thời trước, đoán đồng tiền gieo úp trong bát là sấp hay ngửa mà ăn tiền: chơi sấp ngửa",
    example: "chơi sấp ngửa",
  },
  {
    word: "sấp ngửa",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (dáng vẻ) vội vàng, tất tả: nghe tin dữ, sấp ngửa chạy về",
    example: "nghe tin dữ, sấp ngửa chạy về",
  },
  {
    word: "sấp bóng",
    part_of_speech: "động từ",
    meaning:
      "quay lưng về phía có ánh sáng, làm cho phía trước mặt bị che tối: ngồi sấp bóng * bàn học kê ở chỗ bị sấp bóng",
    example: "ngồi sấp bóng * bàn học kê ở chỗ bị sấp bóng",
  },
  {
    word: "sập tiệm",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) phá sản, phải đóng cửa: cửa hàng bị sập tiệm * làm ăn kiểu đó có ngày sập tiệm",
    example: "cửa hàng bị sập tiệm * làm ăn kiểu đó có ngày sập tiệm",
  },
  {
    word: "sầu",
    part_of_speech: "động từ",
    meaning:
      '(Từ cũ, Văn chương) buồn sâu trong lòng (thường vì nhớ thương, xa cách): ôm mối sầu * "Ông tơ ghét bỏ chi nhau, Chưa vui sum họp đã sầu chia phôi!" (TKiều)',
    example:
      'ôm mối sầu * "Ông tơ ghét bỏ chi nhau, Chưa vui sum họp đã sầu chia phôi!" (TKiều)',
  },
  {
    word: "sất",
    part_of_speech: "trợ từ",
    meaning:
      "(Khẩu ngữ) từ biểu thị ý nhấn mạnh sự phủ định hoàn toàn: không còn gì sất! * chẳng có chuyện gì xảy ra sất!",
    example: "không còn gì sất! * chẳng có chuyện gì xảy ra sất!",
  },
  {
    word: "sâu",
    part_of_speech: "danh từ",
    meaning:
      "dạng ấu trùng của sâu bọ, thường ăn hại cây cối: sâu cắn lúa * con sâu làm rầu nồi canh (tng)",
    example: "sâu cắn lúa * con sâu làm rầu nồi canh (tng)",
  },
  {
    word: "sâu",
    part_of_speech: "tính từ",
    meaning:
      "bị sâu ăn, hay bị hư hỏng tựa như sâu ăn: mía sâu * nhổ răng sâu * đầu có nhiều tóc sâu",
    example: "mía sâu * nhổ răng sâu * đầu có nhiều tóc sâu",
  },
  {
    word: "sâu",
    part_of_speech: "tính từ",
    meaning:
      "có khoảng cách bao nhiêu đó tính từ miệng hoặc bề mặt đến đáy: khoan sâu hơn chục mét * đo độ sâu của biển",
    example: "khoan sâu hơn chục mét * đo độ sâu của biển",
  },
  {
    word: "sâu",
    part_of_speech: "tính từ",
    meaning:
      "có độ sâu lớn hơn mức thường hoặc lớn hơn so với những vật tương tự: sông sâu * viên đạn nằm sâu nơi bả vai * ghi sâu trong lòng",
    example: "sông sâu * viên đạn nằm sâu nơi bả vai * ghi sâu trong lòng",
  },
  {
    word: "sâu",
    part_of_speech: "tính từ",
    meaning:
      "có chỗ tận cùng bên trong cách xa miệng hoặc xa mặt ngoài: hang sâu * trốn trong rừng sâu",
    example: "hang sâu * trốn trong rừng sâu",
  },
  {
    word: "sâu",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất đi vào phía bên trong của sự vật, phía thuộc về nội dung cơ bản, về bản chất: hiểu biết sâu * phát triển theo chiều sâu",
    example: "hiểu biết sâu * phát triển theo chiều sâu",
  },
  {
    word: "sâu",
    part_of_speech: "tính từ",
    meaning:
      "đạt đến độ cao nhất của một trạng thái nào đó: giấc ngủ sâu * hôn mê sâu",
    example: "giấc ngủ sâu * hôn mê sâu",
  },
  {
    word: "sâu đậm",
    part_of_speech: "tính từ",
    meaning: "sâu sắc và đậm đà: ân tình sâu đậm * để lại dấu ấn sâu đậm",
    example: "ân tình sâu đậm * để lại dấu ấn sâu đậm",
  },
  {
    word: "sâu cay",
    part_of_speech: "tính từ",
    meaning: "đau đớn hoặc làm cho đau đớn thấm thía: lời châm biếm sâu cay",
    example: "lời châm biếm sâu cay",
  },
  {
    word: "sâu bọ",
    part_of_speech: "danh từ",
    meaning:
      "động vật chân đốt, cơ thể chia thành ba phần, có một đôi râu, ba đôi chân, phần lớn có cánh: tiếng côn trùng kêu rả rích",
    example: "tiếng côn trùng kêu rả rích",
  },
  {
    word: "sầu bi",
    part_of_speech: "tính từ",
    meaning:
      '(hiếm) buồn thương: "Nhớ chàng luống những sầu bi, Trong mình mang gánh tương tư nặng nề." (PCCH)',
    example:
      'Nhớ chàng luống những sầu bi, Trong mình mang gánh tương tư nặng nề." (PCCH)',
  },
  {
    word: "sâu bệnh",
    part_of_speech: "danh từ",
    meaning:
      "sâu và bệnh làm hại cây trồng (nói khái quát): phun thuốc phòng trừ sâu bệnh",
    example: "phun thuốc phòng trừ sâu bệnh",
  },
  {
    word: "sâu độc",
    part_of_speech: "tính từ",
    meaning: "nham hiểm và độc ác: mưu mô sâu độc * những lời mỉa mai sâu độc",
    example: "mưu mô sâu độc * những lời mỉa mai sâu độc",
  },
  {
    word: "sâu hoắm",
    part_of_speech: "tính từ",
    meaning:
      "sâu hõm vào, tựa như không thấy đáy, trông có cảm giác sợ: vết thương sâu hoắm * hố bom sâu hoắm",
    example: "vết thương sâu hoắm * hố bom sâu hoắm",
  },
  {
    word: "sầu muộn",
    part_of_speech: "tính từ",
    meaning:
      '(hiếm) buồn rầu trong lòng (thường vì nhớ tiếc): nét mặt sầu muộn * "Làm thơ nước mắt nhỏ lem, Tương tư sầu muộn vì em có chồng." (ca dao)',
    example:
      'nét mặt sầu muộn * "Làm thơ nước mắt nhỏ lem, Tương tư sầu muộn vì em có chồng." (ca dao)',
  },
  {
    word: "sầu hận",
    part_of_speech: "tính từ",
    meaning: "buồn sâu kín xen lẫn oán hận: ôm lòng sầu hận",
    example: "ôm lòng sầu hận",
  },
  {
    word: "sâu lắng",
    part_of_speech: "tính từ",
    meaning:
      "sâu sắc và lắng đọng trong lòng: giọng thơ sâu lắng, thiết tha * nơi sâu lắng trong tâm hồn",
    example: "giọng thơ sâu lắng, thiết tha * nơi sâu lắng trong tâm hồn",
  },
  {
    word: "sâu kín",
    part_of_speech: "tính từ",
    meaning:
      'sâu và kín đáo, khó bộc lộ ra: tình cảm sâu kín * "Anh trở vào phòng, cầm lấy bút, những nốt nhạc bay lên từ nơi sâu kín của trái tim anh." (TrHương; 1)',
    example:
      'tình cảm sâu kín * "Anh trở vào phòng, cầm lấy bút, những nốt nhạc bay lên từ nơi sâu kín của trái tim anh." (TrHương; 1)',
  },
  {
    word: "sâu mọt",
    part_of_speech: "danh từ",
    meaning:
      "sâu và mọt (nói khái quát); dùng để chỉ những kẻ chuyên đục khoét của dân: quan lại sâu mọt * bọn sâu mọt",
    example: "quan lại sâu mọt * bọn sâu mọt",
  },
  {
    word: "sầu não",
    part_of_speech: "tính từ",
    meaning: "buồn rầu, đau khổ: vẻ mặt sầu não",
    example: "vẻ mặt sầu não",
  },
  {
    word: "sâu nặng",
    part_of_speech: "tính từ",
    meaning:
      "(tình cảm) sâu sắc, không thể quên: gắn bó sâu nặng * tình cảm sâu nặng",
    example: "gắn bó sâu nặng * tình cảm sâu nặng",
  },
  {
    word: "sầu tư",
    part_of_speech: "tính từ",
    meaning:
      '(văn chương, hiếm) buồn rầu vì thương nhớ (thường là trong tình yêu nam nữ): "Sầu tư đêm cũng như ngày, Má hồng đào phai thắm, mái tóc dày hoá thưa." (ca dao)',
    example:
      'Sầu tư đêm cũng như ngày, Má hồng đào phai thắm, mái tóc dày hoá thưa." (ca dao)',
  },
  {
    word: "sầu tư",
    part_of_speech: "danh từ",
    meaning:
      "cây to cùng họ với xoài, lá kép lông chim, quả có vị chua, ăn được: ô mai sấu",
    example: "ô mai sấu",
  },
  {
    word: "sâu sát",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có tác phong làm việc đi vào chiều sâu, gần gũi và sát với thực tế để nắm rõ tình hình: sâu sát phong trào",
    example: "sâu sát phong trào",
  },
  {
    word: "sâu rộng",
    part_of_speech: "tính từ",
    meaning:
      "vừa rộng vừa có chiều sâu (nói khái quát): phong trào phát triển sâu rộng * có kiến thức sâu rộng",
    example: "phong trào phát triển sâu rộng * có kiến thức sâu rộng",
  },
  {
    word: "sâu sắc",
    part_of_speech: "tính từ",
    meaning:
      'có tính chất đi vào chiều sâu, vào những vấn đề thuộc bản chất, có ý nghĩa nhất: một triết lí sâu sắc * "Người đâu sâu sắc nước đời, Mà chàng Thúc phải ra người bó tay!" (TKiều)',
    example:
      'một triết lí sâu sắc * "Người đâu sâu sắc nước đời, Mà chàng Thúc phải ra người bó tay!" (TKiều)',
  },
  {
    word: "sâu sắc",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất cơ bản, có ý nghĩa quan trọng và lâu dài: chịu ảnh hưởng sâu sắc * mâu thuẫn sâu sắc * sự kiện có ý nghĩa sâu sắc",
    example:
      "chịu ảnh hưởng sâu sắc * mâu thuẫn sâu sắc * sự kiện có ý nghĩa sâu sắc",
  },
  {
    word: "sâu sắc",
    part_of_speech: "tính từ",
    meaning:
      "(tình cảm) rất sâu trong lòng, không thể nào phai nhạt: những kỉ niệm sâu sắc * tình yêu sâu sắc * bày tỏ lòng biết ơn sâu sắc",
    example:
      "những kỉ niệm sâu sắc * tình yêu sâu sắc * bày tỏ lòng biết ơn sâu sắc",
  },
  {
    word: "sầu thảm",
    part_of_speech: "tính từ",
    meaning:
      'buồn rầu thảm thương: tiếng khóc than sầu thảm * "Nỗi nàng sầu thảm khôn nguôi, Nỗi chàng lửa rập sóng vùi khôn an." (PCCH)',
    example:
      'tiếng khóc than sầu thảm * "Nỗi nàng sầu thảm khôn nguôi, Nỗi chàng lửa rập sóng vùi khôn an." (PCCH)',
  },
  {
    word: "sâu xa",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất cơ bản, quan trọng, nhưng không trực tiếp nhận thức được mà phải qua phân tích mới thấy: nguồn gốc sâu xa * triết lí sâu xa",
    example: "nguồn gốc sâu xa * triết lí sâu xa",
  },
  {
    word: "sây",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) (cây) sai (hoa, quả): cây sây trái",
    example: "cây sây trái",
  },
  {
    word: "sầy",
    part_of_speech: "",
    meaning: "bị mất đi một ít da hoặc vỏ mỏng, do cọ xát: ngã bị sầy da",
    example: "ngã bị sầy da",
  },
  {
    word: "sấy",
    part_of_speech: "động từ",
    meaning: "làm cho khô bằng khí nóng: sấy tóc * lò sấy * sấy quần áo",
    example: "sấy tóc * lò sấy * sấy quần áo",
  },
  {
    word: "sẩy",
    part_of_speech: "động từ",
    meaning:
      "sơ ý, làm một động tác (tay, chân, miệng, v.v.) biết ngay là thiếu cẩn thận nhưng không kịp giữ lại được, để xảy ra điều đáng tiếc: sẩy miệng * sẩy chân nên ngã",
    example: "sẩy miệng * sẩy chân nên ngã",
  },
  {
    word: "sẩy",
    part_of_speech: "động từ",
    meaning: "để sổng mất đi, do sơ ý: sẩy mất con mồi",
    example: "sẩy mất con mồi",
  },
  {
    word: "sẩy",
    part_of_speech: "động từ",
    meaning: "(hiếm) mất đi người thân: sẩy cha còn chú, sẩy mẹ bú dì (tng)",
    example: "sẩy cha còn chú, sẩy mẹ bú dì (tng)",
  },
  {
    word: "sẩy",
    part_of_speech: "động từ",
    meaning:
      "(thai) tự ra ngoài tử cung khi đang còn ít tháng: cái thai được ba tháng thì sẩy",
    example: "cái thai được ba tháng thì sẩy",
  },
  {
    word: "sây sát",
    part_of_speech: "tính từ",
    meaning:
      "bị sầy, xước nhiều chỗ: mình mẩy sây sát * mặt bàn có nhiều vết sây sát",
    example: "mình mẩy sây sát * mặt bàn có nhiều vết sây sát",
  },
  {
    word: "sấy tóc",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ điện có tác dụng làm cho tóc khô và giữ nếp bằng khí nóng: máy sấy tóc * hỏng mất cái sấy tóc",
    example: "máy sấy tóc * hỏng mất cái sấy tóc",
  },
  {
    word: "se",
    part_of_speech: "",
    meaning:
      "hơi khô đi, không còn thấm nhiều nước nữa: quần áo đã hơi se * mặt ruộng se lại * vết thương bắt đầu se miệng",
    example:
      "quần áo đã hơi se * mặt ruộng se lại * vết thương bắt đầu se miệng",
  },
  {
    word: "se",
    part_of_speech: "",
    meaning: "(khí trời) khô và hơi lạnh: trời se lạnh",
    example: "trời se lạnh",
  },
  {
    word: "se",
    part_of_speech: "",
    meaning: "cảm thấy đau xót, xúc động: se lòng trước tình cảnh của bạn",
    example: "se lòng trước tình cảnh của bạn",
  },
  {
    word: "sẻ",
    part_of_speech: "danh từ",
    meaning: "(Khẩu ngữ) chim sẻ (nói tắt): bầy sẻ nhỏ",
    example: "bầy sẻ nhỏ",
  },
  {
    word: "sẻ",
    part_of_speech: "động từ",
    meaning:
      'chia bớt ra, lấy ra một phần (thường để cùng hưởng): sẻ bát nước làm hai * "Thương nhau, chia củ sắn lùi, Bát cơm sẻ nửa, chăn sui đắp cùng." (THữu; 39)',
    example:
      'sẻ bát nước làm hai * "Thương nhau, chia củ sắn lùi, Bát cơm sẻ nửa, chăn sui đắp cùng." (THữu; 39)',
  },
  {
    word: "sè",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) mở ra, ngửa ra: chim sè cánh * sè tay nhận tiền của người khác",
    example: "chim sè cánh * sè tay nhận tiền của người khác",
  },
  {
    word: "se mình",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) không được khoẻ trong người, muốn ốm (lối nói kiêng tránh): bà cụ se mình",
    example: "bà cụ se mình",
  },
  {
    word: "sẽ",
    part_of_speech: "tính từ",
    meaning:
      'như khẽ: đi sẽ * gọi rất sẽ * "Tiếng sen sẽ động giấc hoè, Bóng trăng đã xế hoa lê lại gần." (TKiều)',
    example:
      'đi sẽ * gọi rất sẽ * "Tiếng sen sẽ động giấc hoè, Bóng trăng đã xế hoa lê lại gần." (TKiều)',
  },
  {
    word: "sẽ",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị sự việc, hiện tượng nói đến xảy ra trong tương lai, sau thời điểm nói, hoặc xảy ra trong thời gian sau thời điểm nào đó trong quá khứ được lấy làm mốc: mai sẽ làm * tuần sau, anh ấy sẽ về * điều đó chắc chắn sẽ xảy ra",
    example:
      "mai sẽ làm * tuần sau, anh ấy sẽ về * điều đó chắc chắn sẽ xảy ra",
  },
  {
    word: "se sắt",
    part_of_speech: "tính từ",
    meaning:
      "đau buồn đến héo hắt, tái tê: lòng se sắt một nỗi cô đơn * buồn se sắt",
    example: "lòng se sắt một nỗi cô đơn * buồn se sắt",
  },
  {
    word: "sẽ sàng",
    part_of_speech: "tính từ",
    meaning: "như khẽ khàng: nói năng sẽ sàng",
    example: "nói năng sẽ sàng",
  },
  {
    word: "sè sè",
    part_of_speech: "tính từ",
    meaning:
      '(vật có hình khối nổi lên) rất thấp, không đáng kể so với mặt bằng xung quanh: "Sè sè nắm đất bên đường, Dầu dầu ngọn cỏ nửa vàng nửa xanh." (TKiều)',
    example:
      'Sè sè nắm đất bên đường, Dầu dầu ngọn cỏ nửa vàng nửa xanh." (TKiều)',
  },
  {
    word: "se sẽ",
    part_of_speech: "tính từ",
    meaning: "như khe khẽ: cất tiếng hát se sẽ",
    example: "cất tiếng hát se sẽ",
  },
  {
    word: "se se",
    part_of_speech: "",
    meaning:
      'hơi se lại: "Bây giờ chống chếnh mái tranh, Se se ngọn gió, mỏng manh ánh đèn." (NgBVợi; 3)',
    example:
      'Bây giờ chống chếnh mái tranh, Se se ngọn gió, mỏng manh ánh đèn." (NgBVợi; 3)',
  },
  {
    word: "se sua",
    part_of_speech: "động từ",
    meaning:
      "(Phương ngữ, Khẩu ngữ) chưng diện, làm đỏm với ý khoe khoang: tánh không ưa se sua",
    example: "tánh không ưa se sua",
  },
  {
    word: "se thắt",
    part_of_speech: "động từ",
    meaning:
      "đau đớn, quặn thắt trong lòng: lòng se thắt trước cảnh tượng thương tâm",
    example: "lòng se thắt trước cảnh tượng thương tâm",
  },
  {
    word: "séc",
    part_of_speech: "danh từ",
    meaning:
      "lệnh viết của chủ tài khoản để ngân hàng trích tài khoản trả cho người nào đó: thanh toán bằng séc * kí séc",
    example: "thanh toán bằng séc * kí séc",
  },
  {
    word: "sém",
    part_of_speech: "động từ",
    meaning:
      "bị cháy một ít ở cạnh hay ở mặt ngoài: lửa làm sém tóc * thân cây bị cháy sém",
    example: "lửa làm sém tóc * thân cây bị cháy sém",
  },
  {
    word: "seminar",
    part_of_speech: "danh từ",
    meaning:
      "buổi sinh hoạt học tập để thảo luận những vấn đề chuyên môn ở đại học hoặc trên đại học: tổ chức một seminar về văn học cận đại",
    example: "tổ chức một seminar về văn học cận đại",
  },
  {
    word: "sẻn so",
    part_of_speech: "tính từ",
    meaning: "sẻn (nói khái quát): ăn tiêu sẻn so",
    example: "ăn tiêu sẻn so",
  },
  {
    word: "sen",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) đầy tớ gái trong các gia đình ở thành thị thời trước: con sen đứa ở",
    example: "con sen đứa ở",
  },
  {
    word: "sen",
    part_of_speech: "danh từ",
    meaning:
      'cây mọc ở nước, lá to tròn, hoa màu hồng hay trắng, nhị vàng, hương thơm nhẹ, hạt dùng để ăn hoặc làm thuốc: mứt sen * "Trong đầm gì đẹp bằng sen, Lá xanh bông trắng lại chen nhị vàng." (ca dao)',
    example:
      'mứt sen * "Trong đầm gì đẹp bằng sen, Lá xanh bông trắng lại chen nhị vàng." (ca dao)',
  },
  {
    word: "sen ngó đào tơ",
    part_of_speech: "",
    meaning:
      '(cũ, văn chương) ví người con gái còn rất trẻ, đang ở tuổi thanh xuân: "Những từ sen ngó đào tơ, Mười lăm năm mới bây giờ là đây!" (TKiều)',
    example:
      'Những từ sen ngó đào tơ, Mười lăm năm mới bây giờ là đây!" (TKiều)',
  },
  {
    word: "sẹo",
    part_of_speech: "danh từ",
    meaning:
      "(Nam cũng dùng thẹo) dấu tích vết thương hay mụn nhọt để lại trên da, sau khi khỏi: vết thương đã thành sẹo * mặt đầy sẹo",
    example: "vết thương đã thành sẹo * mặt đầy sẹo",
  },
  {
    word: "sẹo",
    part_of_speech: "danh từ",
    meaning: "mấu: tấm ván có sẹo * thân sắn mang nhiều sẹo lá",
    example: "tấm ván có sẹo * thân sắn mang nhiều sẹo lá",
  },
  {
    word: "sẹo",
    part_of_speech: "danh từ",
    meaning:
      "lỗ thủng xoi ở vách mũi trâu bò để xỏ dây vào mà điều khiển: trâu đứt sẹo",
    example: "trâu đứt sẹo",
  },
  {
    word: "sét",
    part_of_speech: "danh từ",
    meaning:
      "hiện tượng phóng điện giữa đám mây và mặt đất, gây tiếng nổ to và đanh, có thể làm chết người, đổ cây, cháy nhà: sét đánh trúng cột điện * tin sét đánh (tin dữ)",
    example: "sét đánh trúng cột điện * tin sét đánh (tin dữ)",
  },
  {
    word: "sét",
    part_of_speech: "danh từ",
    meaning: "đất sét (nói tắt): đất nhiều sét",
    example: "đất nhiều sét",
  },
  {
    word: "sét",
    part_of_speech: "danh từ",
    meaning:
      "lượng vừa đến sát miệng của vật đựng: ăn sét bát cơm * nấu hai sét bò gạo",
    example: "ăn sét bát cơm * nấu hai sét bò gạo",
  },
  {
    word: "sét",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) gỉ sắt: cạo sét * bị sét ăn mòn",
    example: "cạo sét * bị sét ăn mòn",
  },
  {
    word: "sệ",
    part_of_speech: "động từ",
    meaning:
      "sa và lệch xuống vì quá nặng: người béo xệ * má chảy xệ * bụng xệ",
    example: "người béo xệ * má chảy xệ * bụng xệ",
  },
  {
    word: "sex",
    part_of_speech: "danh từ",
    meaning:
      "sự khêu gợi ham muốn tình dục một cách lộ liễu (thường bằng phim ảnh): phim sex",
    example: "phim sex",
  },
  {
    word: "sề",
    part_of_speech: "danh từ",
    meaning:
      "đồ đan mắt thưa, nan thô, rộng, to hơn rổ, dùng đựng bèo, khoai, v.v.: rổ sề",
    example: "rổ sề",
  },
  {
    word: "sề",
    part_of_speech: "tính từ",
    meaning: "(lợn cái) đã đẻ nhiều lứa: nái sề * lợn sề",
    example: "nái sề * lợn sề",
  },
  {
    word: "sề",
    part_of_speech: "tính từ",
    meaning:
      "(Thông tục) (đàn bà) đã sinh đẻ nhiều lần, thân thể không còn gọn gàng: gái sề",
    example: "gái sề",
  },
  {
    word: "sến",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ, khẩu ngữ) (nhạc, giọng ca) bộc lộ tình cảm yếu đuối đến mức uỷ mị, sướt mướt một cách rẻ tiền: nhạc sến * giọng ca rất sến",
    example: "nhạc sến * giọng ca rất sến",
  },
  {
    word: "sexy",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có tính chất gợi tình, gợi dục một cách lộ liễu: ăn mặc sexy",
    example: "ăn mặc sexy",
  },
  {
    word: "sên",
    part_of_speech: "danh từ",
    meaning: "ốc sên (nói tắt): chậm như sên",
    example: "chậm như sên",
  },
  {
    word: "sên",
    part_of_speech: "danh từ",
    meaning:
      "động vật thân mềm ở cạn, có dạng giun, không có vỏ, tiết nhiều chất nhờn để tự bảo vệ, ăn thực vật và các chất mùn bã.",
    example: "con sên rừng",
  },
  {
    word: "sề sệ",
    part_of_speech: "động từ",
    meaning: "hơi bị sa xuống, xệ xuống một chút: khẩu súng lục xề xệ bên hông",
    example: "khẩu súng lục xề xệ bên hông",
  },
  {
    word: "sền sệt",
    part_of_speech: "tính từ",
    meaning: "hơi quánh lại: bột quấy đặc sền sệt",
    example: "bột quấy đặc sền sệt",
  },
  {
    word: "sền sệt",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng như tiếng của vật bị kéo lê đi trên mặt đất: lê dép sền sệt",
    example: "lê dép sền sệt",
  },
  {
    word: "sền sệt",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả dáng chuyển động gần như luôn luôn kéo lết trên mặt nền: kéo tải thóc sền sệt trên mặt đường",
    example: "kéo tải thóc sền sệt trên mặt đường",
  },
  {
    word: "sếp",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) người chỉ huy, người cai quản: sếp bốt * bị sếp xạc cho một trận",
    example: "sếp bốt * bị sếp xạc cho một trận",
  },
  {
    word: "sểnh",
    part_of_speech: "động từ",
    meaning:
      "để thoát khỏi, để mất đi cái mình đã nắm được hoặc coi như đã nắm được: sểnh mất con mồi * để sểnh mất tên cướp",
    example: "sểnh mất con mồi * để sểnh mất tên cướp",
  },
  {
    word: "sểnh",
    part_of_speech: "động từ",
    meaning:
      "lơi ra, không chú ý, không trông nom đến: sểnh ra là nó lại trốn đi chơi * cứ sểnh ra một cái là mất",
    example: "sểnh ra là nó lại trốn đi chơi * cứ sểnh ra một cái là mất",
  },
  {
    word: "sệt",
    part_of_speech: "tính từ",
    meaning:
      "ở vị trí chạm sát mặt nền khi chuyển động: đá sệt * kéo sệt trên mặt đường",
    example: "đá sệt * kéo sệt trên mặt đường",
  },
  {
    word: "sếu",
    part_of_speech: "danh từ",
    meaning:
      "chim lớn, cổ và mỏ dài, chân cao, kêu rất to, sống ở phương Bắc, trú đông ở phương Nam: gió bấc hiu hiu, sếu kêu thì rét (tng)",
    example: "gió bấc hiu hiu, sếu kêu thì rét (tng)",
  },
  {
    word: "sêu tết",
    part_of_speech: "động từ",
    meaning: "sêu (nói khái quát): đã có người sêu tết",
    example: "đã có người sêu tết",
  },
  {
    word: "sêu",
    part_of_speech: "động từ",
    meaning:
      '(nhà trai) đưa lễ vật đến biếu nhà gái trong những dịp tết, khi chưa cưới, theo tục lệ cũ: đi sêu * "Mình nói dối ta mình chửa có chồng, Để ta mua cốm mua hồng sang sêu." (ca dao)',
    example:
      'đi sêu * "Mình nói dối ta mình chửa có chồng, Để ta mua cốm mua hồng sang sêu." (ca dao)',
  },
  {
    word: "shop",
    part_of_speech: "danh từ",
    meaning: "cửa hàng, thường vào loại cao cấp: shop thời trang",
    example: "shop thời trang",
  },
  {
    word: "si",
    part_of_speech: "tính từ",
    meaning: "mê mẩn, ngây dại, thường vì say đắm: si vì tình",
    example: "si vì tình",
  },
  {
    word: "sĩ",
    part_of_speech: "danh từ",
    meaning:
      "(Từ cũ) người trí thức thời phong kiến (nói khái quát): kẻ sĩ * các tầng lớp sĩ, nông, công, thương",
    example: "kẻ sĩ * các tầng lớp sĩ, nông, công, thương",
  },
  {
    word: "sĩ",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi quân cờ hay quân bài đứng hàng thứ hai, sau tướng, trong cờ tướng hay bài tam cúc, bài tứ sắc: ghểnh sĩ * bộ ba tướng, sĩ, tượng",
    example: "ghểnh sĩ * bộ ba tướng, sĩ, tượng",
  },
  {
    word: "sĩ",
    part_of_speech: "động từ",
    meaning: "(Khẩu ngữ) sĩ diện (nói tắt): tính rất sĩ * nói sĩ",
    example: "tính rất sĩ * nói sĩ",
  },
  {
    word: "sì",
    part_of_speech: "phụ từ",
    meaning:
      "ở mức độ cao, thường trông xấu hoặc gây cảm giác khó chịu: đen sì * mặt gỗ nhám sì * môi thâm sì",
    example: "đen sì * mặt gỗ nhám sì * môi thâm sì",
  },
  {
    word: "sĩ khí",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) lòng khí khái của kẻ sĩ, của nhà nho: dùng lễ nghĩa để vun trồng sĩ khí",
    example: "dùng lễ nghĩa để vun trồng sĩ khí",
  },
  {
    word: "sĩ khí",
    part_of_speech: "danh từ",
    meaning:
      'tinh thần, khí thế của quân đội: "Sĩ khí đã hăng, Quân thanh càng mạnh." (BNĐC)',
    example: 'Sĩ khí đã hăng, Quân thanh càng mạnh." (BNĐC)',
  },
  {
    word: "sĩ diện",
    part_of_speech: "danh từ",
    meaning: "thể diện cá nhân: mất hết sĩ diện * giữ sĩ diện",
    example: "mất hết sĩ diện * giữ sĩ diện",
  },
  {
    word: "sĩ diện",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) muốn làm ra vẻ không thua kém ai để cho người ta coi trọng, hoặc muốn che giấu sự thua kém của mình cho người ta khỏi coi thường: nổi máu sĩ diện * chỉ được cái sĩ diện hão!",
    example: "nổi máu sĩ diện * chỉ được cái sĩ diện hão!",
  },
  {
    word: "sĩ phu",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người trí thức có danh tiếng trong xã hội phong kiến: một sĩ phu yêu nước",
    example: "một sĩ phu yêu nước",
  },
  {
    word: "si ngốc",
    part_of_speech: "tính từ",
    meaning: "ngu si và ngốc ngếch: đầu óc si ngốc * vẻ si ngốc",
    example: "đầu óc si ngốc * vẻ si ngốc",
  },
  {
    word: "sỉ",
    part_of_speech: "tính từ",
    meaning:
      "(mua hay bán) cả số lượng lớn trong một lần (để người mua sau đó bán lẻ cho người tiêu dùng): vừa bán sỉ vừa bán lẻ * buôn sỉ",
    example: "vừa bán sỉ vừa bán lẻ * buôn sỉ",
  },
  {
    word: "si mê",
    part_of_speech: "tính từ",
    meaning:
      "mê mẩn, say đắm đến mức không còn biết gì nữa: yêu đến si mê * cái nhìn si mê",
    example: "yêu đến si mê * cái nhìn si mê",
  },
  {
    word: "sĩ quan",
    part_of_speech: "danh từ",
    meaning:
      "quân nhân có quân hàm từ cấp uý trở lên: trường đào tạo sĩ quan * sĩ quan cao cấp",
    example: "trường đào tạo sĩ quan * sĩ quan cao cấp",
  },
  {
    word: "sỉ nhục",
    part_of_speech: "tính từ",
    meaning: "xấu xa, nhục nhã, đáng hổ thẹn: làm điều sỉ nhục",
    example: "làm điều sỉ nhục",
  },
  {
    word: "sỉ nhục",
    part_of_speech: "động từ",
    meaning:
      "làm cho phải thấy nhục nhã, phải thấy hổ thẹn: bị sỉ nhục trước đám đông",
    example: "bị sỉ nhục trước đám đông",
  },
  {
    word: "si tình",
    part_of_speech: "tính từ",
    meaning:
      "mê mẩn, ngây dại vì tình yêu đắm đuối: cặp mắt si tình * kẻ si tình",
    example: "cặp mắt si tình * kẻ si tình",
  },
  {
    word: "sì sụp",
    part_of_speech: "động từ",
    meaning:
      "từ gợi tả động tác cúi xuống ngẩng lên liên tiếp khi vái lạy: sì sụp khấn vái",
    example: "sì sụp khấn vái",
  },
  {
    word: "sì sụp",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng húp liên tiếp thức ăn có chất lỏng: húp cháo sì sụp",
    example: "húp cháo sì sụp",
  },
  {
    word: "sĩ tử",
    part_of_speech: "danh từ",
    meaning: "(cũ) người đi thi thời phong kiến: các sĩ tử lều chõng đi thi",
    example: "các sĩ tử lều chõng đi thi",
  },
  {
    word: "si-li-côn",
    part_of_speech: "danh từ",
    meaning:
      "hợp chất hữu cơ của silicium, gồm nhiều loại khác nhau, được dùng để chế tạo sơn, cao su nhân tạo, vecni, v.v.: thẩm mĩ nâng ngực bằng túi silicone",
    example: "thẩm mĩ nâng ngực bằng túi silicone",
  },
  {
    word: "sịch",
    part_of_speech: "tính từ",
    meaning:
      "(cũng sịch) từ mô phỏng tiếng động mạnh và đột ngột như tiếng ô tô dừng đột ngột: ô tô đỗ xịch trước cửa * cánh cửa xịch mở",
    example: "ô tô đỗ xịch trước cửa * cánh cửa xịch mở",
  },
  {
    word: "sịch",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) xích, dịch ra chút ít: ngồi xịch ra",
    example: "ngồi xịch ra",
  },
  {
    word: "sỉa",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) thụt xuống hố hay chỗ bùn nước khi đang đi: sỉa chân xuống hố",
    example: "sỉa chân xuống hố",
  },
  {
    word: "siêu âm",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) khám, chữa bệnh bằng thiết bị ứng dụng sóng siêu âm: siêu âm ổ bụng",
    example: "siêu âm ổ bụng",
  },
  {
    word: "siêu âm",
    part_of_speech: "tính từ",
    meaning: "có tốc độ lớn hơn tốc độ âm thanh: máy bay phản lực siêu âm",
    example: "máy bay phản lực siêu âm",
  },
  {
    word: "siêng năng",
    part_of_speech: "tính từ",
    meaning: "siêng (nói khái quát): siêng năng làm việc * học hành siêng năng",
    example: "siêng năng làm việc * học hành siêng năng",
  },
  {
    word: "siêng",
    part_of_speech: "tính từ",
    meaning:
      "có sự chú ý thường xuyên để làm việc gì đó một cách đều đặn: siêng học siêng làm * việc nhà thì nhác, việc chú bác thì siêng (tng)",
    example:
      "siêng học siêng làm * việc nhà thì nhác, việc chú bác thì siêng (tng)",
  },
  {
    word: "siểm nịnh",
    part_of_speech: "động từ",
    meaning:
      "ton hót, nịnh nọt người có quyền thế để làm hại người khác, mưu lợi cho mình: quân siểm nịnh * nghe lời siểm nịnh",
    example: "quân siểm nịnh * nghe lời siểm nịnh",
  },
  {
    word: "siêu",
    part_of_speech: "danh từ",
    meaning:
      "ấm dùng để đun nước hoặc sắc thuốc: siêu sắc thuốc * đun siêu nước",
    example: "siêu sắc thuốc * đun siêu nước",
  },
  {
    word: "siêu",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) rất tài giỏi: học rất siêu * trình độ vào loại siêu",
    example: "học rất siêu * trình độ vào loại siêu",
  },
  {
    word: "siết",
    part_of_speech: "động từ",
    meaning:
      "nắm lại hoặc ôm lấy cho thật chặt: ôm siết con vào lòng * cái siết tay thật chặt",
    example: "ôm siết con vào lòng * cái siết tay thật chặt",
  },
  {
    word: "siết",
    part_of_speech: "động từ",
    meaning:
      "làm cho ôm giữ lấy thật chặt: siết dây thòng lọng * siết chặt đinh ốc",
    example: "siết dây thòng lọng * siết chặt đinh ốc",
  },
  {
    word: "siêu dẫn",
    part_of_speech: "động từ",
    meaning:
      "truyền điện qua dây dẫn có điện trở bằng không: chất siêu dẫn * vật liệu siêu dẫn",
    example: "chất siêu dẫn * vật liệu siêu dẫn",
  },
  {
    word: "siêu đẳng",
    part_of_speech: "tính từ",
    meaning:
      "thuộc vào loại đặc biệt, vượt xa những thứ cùng loại được xếp hạng: nghệ thuật siêu đẳng * tài nghệ siêu đẳng",
    example: "nghệ thuật siêu đẳng * tài nghệ siêu đẳng",
  },
  {
    word: "siêu độ",
    part_of_speech: "động từ",
    meaning:
      "cầu cho linh hồn người chết được lên cõi cực lạc, theo đạo Phật: làm lễ siêu độ cho người chết",
    example: "làm lễ siêu độ cho người chết",
  },
  {
    word: "siêu hạng",
    part_of_speech: "",
    meaning:
      "hạng đặc biệt, vượt hẳn lên về khả năng, tài nghệ: trình độ siêu hạng * một ảo thuật gia siêu hạng",
    example: "trình độ siêu hạng * một ảo thuật gia siêu hạng",
  },
  {
    word: "siêu hình",
    part_of_speech: "tính từ",
    meaning:
      "không có hình thể, vượt ra ngoài thế giới vật chất: những thế lực siêu hình * sức mạnh siêu hình",
    example: "những thế lực siêu hình * sức mạnh siêu hình",
  },
  {
    word: "siêu hình",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về phép siêu hình, dựa trên phép siêu hình: quan điểm siêu hình * cách lập luận siêu hình",
    example: "quan điểm siêu hình * cách lập luận siêu hình",
  },
  {
    word: "siêu ngạch",
    part_of_speech: "tính từ",
    meaning: "vượt xa trên mức bình quân: lợi nhuận siêu ngạch",
    example: "lợi nhuận siêu ngạch",
  },
  {
    word: "siêu mẫu",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) siêu người mẫu (nói tắt): siêu mẫu thời trang",
    example: "siêu mẫu thời trang",
  },
  {
    word: "siêu người mẫu",
    part_of_speech: "danh từ",
    meaning: "người mẫu siêu hạng: một siêu người mẫu nổi tiếng thế giới",
    example: "một siêu người mẫu nổi tiếng thế giới",
  },
  {
    word: "siêu phàm",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất, khả năng vượt lên trên người thường hoặc những điều thường thấy: bộ óc siêu phàm * năng lực siêu phàm",
    example: "bộ óc siêu phàm * năng lực siêu phàm",
  },
  {
    word: "siêu nhiên",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất, khả năng vượt ra khỏi phạm vi tự nhiên, không thể giải thích bằng các quy luật tự nhiên: thế lực siêu nhiên",
    example: "thế lực siêu nhiên",
  },
  {
    word: "siêu quần",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) có khả năng, trình độ vượt lên trên mọi người: tài năng siêu quần",
    example: "tài năng siêu quần",
  },
  {
    word: "siêu sao",
    part_of_speech: "danh từ",
    meaning:
      "người đạt thành tích đặc biệt xuất sắc, vượt trội hẳn lên trong lĩnh vực biểu diễn nghệ thuật, hoạt động thể thao: siêu sao ca nhạc * siêu sao điện ảnh",
    example: "siêu sao ca nhạc * siêu sao điện ảnh",
  },
  {
    word: "siêu tần",
    part_of_speech: "tính từ",
    meaning:
      "có tần số cao vượt mức giới hạn thông thường đối với các sóng vô tuyến ứng với dạng sóng cực ngắn, tần số lớn hơn 300 MHz hoặc âm thanh thường ứng với tần số lớn hơn 20 KHz, tai người không nghe được: bị ảnh hưởng của sóng siêu tần * dải siêu tần",
    example: "bị ảnh hưởng của sóng siêu tần * dải siêu tần",
  },
  {
    word: "siêu thị",
    part_of_speech: "danh từ",
    meaning: "cửa hàng tự phục vụ lớn, bán thực phẩm và hàng bách hoá đủ loại.",
    example: "siêu thị sách * siêu thị điện tử - điện lạnh",
  },
  {
    word: "siêu thanh",
    part_of_speech: "tính từ",
    meaning: "như siêu âm: máy bay phản lực siêu thanh * sóng siêu thanh",
    example: "máy bay phản lực siêu thanh * sóng siêu thanh",
  },
  {
    word: "siêu thăng",
    part_of_speech: "động từ",
    meaning: "như siêu thoát (ng1): được siêu thăng lên cõi Niết Bàn",
    example: "được siêu thăng lên cõi Niết Bàn",
  },
  {
    word: "siêu thịt",
    part_of_speech: "tính từ",
    meaning:
      "(vật nuôi) có lượng thịt cao hơn bình thường: nuôi lợn siêu thịt * giống vịt siêu thịt",
    example: "nuôi lợn siêu thịt * giống vịt siêu thịt",
  },
  {
    word: "siêu thoát",
    part_of_speech: "động từ",
    meaning:
      "(linh hồn người chết) được lên cõi cực lạc, theo quan niệm của đạo Phật: linh hồn được siêu thoát",
    example: "linh hồn được siêu thoát",
  },
  {
    word: "siêu tốc",
    part_of_speech: "tính từ",
    meaning:
      "có tốc độ rất cao, vượt xa tốc độ bình thường: tàu siêu tốc * bộ vi xử lí siêu tốc",
    example: "tàu siêu tốc * bộ vi xử lí siêu tốc",
  },
  {
    word: "siêu thực",
    part_of_speech: "tính từ",
    meaning:
      "thuộc chủ nghĩa siêu thực: trường phái siêu thực * tranh siêu thực",
    example: "trường phái siêu thực * tranh siêu thực",
  },
  {
    word: "siêu trường",
    part_of_speech: "tính từ",
    meaning:
      "(thiết bị, phương tiện) có độ dài rất lớn, hơn hẳn mức thường: xe siêu trường",
    example: "xe siêu trường",
  },
  {
    word: "siêu trứng",
    part_of_speech: "tính từ",
    meaning: "(vật nuôi) cho lượng trứng lớn: vịt siêu trứng",
    example: "vịt siêu trứng",
  },
  {
    word: "siêu vi",
    part_of_speech: "danh từ",
    meaning: "siêu vi khuẩn, siêu vi trùng (nói tắt): viêm gan siêu vi B",
    example: "viêm gan siêu vi B",
  },
  {
    word: "siêu vi",
    part_of_speech: "tính từ",
    meaning: "hết sức nhỏ, cực nhỏ: các vật thể siêu vi",
    example: "các vật thể siêu vi",
  },
  {
    word: "siêu tự nhiên",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất, khả năng vượt ra khỏi phạm vi tự nhiên, không thể giải thích bằng các quy luật tự nhiên: thế lực siêu nhiên",
    example: "thế lực siêu nhiên",
  },
  {
    word: "siêu trọng",
    part_of_speech: "tính từ",
    meaning:
      "(vật nuôi hoặc phương tiện vận tải) có trọng lượng hoặc trọng tải rất lớn, hơn hẳn mức thường: lợn siêu trọng * đoạn đường cấm các xe siêu trọng",
    example: "lợn siêu trọng * đoạn đường cấm các xe siêu trọng",
  },
  {
    word: "siêu việt",
    part_of_speech: "tính từ",
    meaning:
      "ở mức vượt lên trên hẳn những cái thông thường: tài năng siêu việt",
    example: "tài năng siêu việt",
  },
  {
    word: "sim",
    part_of_speech: "danh từ",
    meaning:
      "cây bụi nhỏ cùng họ với ổi, quả chín màu tím đen, chứa nhiều hạt, ăn được: màu tím hoa sim",
    example: "màu tím hoa sim",
  },
  {
    word: "silicone",
    part_of_speech: "danh từ",
    meaning:
      "hợp chất hữu cơ của silicium, gồm nhiều loại khác nhau, được dùng để chế tạo sơn, cao su nhân tạo, vecni, v.v.: thẩm mĩ nâng ngực bằng túi silicone",
    example: "thẩm mĩ nâng ngực bằng túi silicone",
  },
  {
    word: "sin sít",
    part_of_speech: "tính từ",
    meaning: "rất sít: hàm răng sin sít",
    example: "hàm răng sin sít",
  },
  {
    word: "sin sít",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả tiếng nói cười nghe như rít qua kẽ răng: giọng sin sít qua kẽ răng",
    example: "giọng sin sít qua kẽ răng",
  },
  {
    word: "sinh",
    part_of_speech: "động từ",
    meaning:
      "đẻ ra (thường chỉ nói về người): sinh con đầu lòng * bà cụ sinh được ba người con",
    example: "sinh con đầu lòng * bà cụ sinh được ba người con",
  },
  {
    word: "sinh",
    part_of_speech: "động từ",
    meaning: "tạo ra, làm nảy nở: sinh hoa kết trái * sinh lời * sinh bệnh",
    example: "sinh hoa kết trái * sinh lời * sinh bệnh",
  },
  {
    word: "sinh",
    part_of_speech: "động từ",
    meaning:
      "chuyển thành có một trạng thái khác trước và không hay: được nuông chiều quá sinh hư * thấy lạ sinh nghi",
    example: "được nuông chiều quá sinh hư * thấy lạ sinh nghi",
  },
  {
    word: "sình",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ) lầy: lội qua bãi sình",
    example: "lội qua bãi sình",
  },
  {
    word: "sình",
    part_of_speech: "động từ",
    meaning: "(Phương ngữ) trương: xác chết sình lên",
    example: "xác chết sình lên",
  },
  {
    word: "sính",
    part_of_speech: "động từ",
    meaning:
      "thích, chuộng đến mức thái quá, thường để tỏ ra hơn người: sính nói chữ * sính hàng ngoại",
    example: "sính nói chữ * sính hàng ngoại",
  },
  {
    word: "sinh bệnh",
    part_of_speech: "động từ",
    meaning: "sinh ra thành bệnh tật: buồn rầu quá mà sinh bệnh",
    example: "buồn rầu quá mà sinh bệnh",
  },
  {
    word: "sinh chuyện",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) làm sinh ra chuyện lôi thôi, rắc rối: nói làm gì cho sinh chuyện * cứ gặp nhau là sinh chuyện",
    example: "nói làm gì cho sinh chuyện * cứ gặp nhau là sinh chuyện",
  },
  {
    word: "sinh chuyện",
    part_of_speech: "động từ",
    meaning:
      "kiếm chuyện gây rắc rối cho người khác: kiếm cớ để sinh chuyện * sinh chuyện với nhau",
    example: "kiếm cớ để sinh chuyện * sinh chuyện với nhau",
  },
  {
    word: "sinh dục",
    part_of_speech: "động từ",
    meaning: "thực hiện chức năng sinh sản: cơ quan sinh dục",
    example: "cơ quan sinh dục",
  },
  {
    word: "sinh đẻ",
    part_of_speech: "động từ",
    meaning: "sinh con (nói khái quát): sinh đẻ có kế hoạch * độ tuổi sinh đẻ",
    example: "sinh đẻ có kế hoạch * độ tuổi sinh đẻ",
  },
  {
    word: "sinh dưỡng",
    part_of_speech: "động từ",
    meaning: "sinh đẻ và nuôi dưỡng: công ơn sinh dưỡng của cha mẹ",
    example: "công ơn sinh dưỡng của cha mẹ",
  },
  {
    word: "sinh đôi",
    part_of_speech: "",
    meaning:
      "sinh ra trong cùng một lần, thành một đôi (chỉ nói về người): chị em sinh đôi * đẻ sinh đôi",
    example: "chị em sinh đôi * đẻ sinh đôi",
  },
  {
    word: "sinh động",
    part_of_speech: "tính từ",
    meaning:
      "đầy sự sống, với nhiều dạng, nhiều vẻ khác nhau: cảnh vật sinh động * cuộc sống sinh động",
    example: "cảnh vật sinh động * cuộc sống sinh động",
  },
  {
    word: "sinh động",
    part_of_speech: "tính từ",
    meaning:
      "có khả năng gợi ra những hình ảnh hợp với hiện thực của đời sống: cách kể chuyện sinh động * bài văn tả cảnh khá sinh động",
    example: "cách kể chuyện sinh động * bài văn tả cảnh khá sinh động",
  },
  {
    word: "sinh hoá",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về, có tính chất những phản ứng hoá học xảy ra trong cơ thể sinh vật: quá trình hoá sinh trong cơ thể thực vật",
    example: "quá trình hoá sinh trong cơ thể thực vật",
  },
  {
    word: "sinh hạ",
    part_of_speech: "động từ",
    meaning:
      "(cũ, trang trọng) sinh ra, đẻ ra: bà cụ sinh hạ được hai người con",
    example: "bà cụ sinh hạ được hai người con",
  },
  {
    word: "sinh hoạt",
    part_of_speech: "danh từ",
    meaning:
      "những hoạt động thuộc về đời sống hằng ngày của một người hay một cộng đồng người (nói tổng quát): sinh hoạt tinh thần * sinh hoạt gia đình",
    example: "sinh hoạt tinh thần * sinh hoạt gia đình",
  },
  {
    word: "sinh hoạt",
    part_of_speech: "danh từ",
    meaning:
      "những hoạt động tập thể của một tổ chức (nói tổng quát): sinh hoạt chi đoàn * tổ chức những sinh hoạt văn hoá văn nghệ",
    example: "sinh hoạt chi đoàn * tổ chức những sinh hoạt văn hoá văn nghệ",
  },
  {
    word: "sinh hoạt",
    part_of_speech: "động từ",
    meaning:
      "sống cuộc sống riêng hằng ngày (nói khái quát): sinh hoạt giản dị",
    example: "sinh hoạt giản dị",
  },
  {
    word: "sinh hoạt",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) họp để tiến hành những hoạt động tập thể: giờ sinh hoạt lớp",
    example: "giờ sinh hoạt lớp",
  },
  {
    word: "sinh hoạt phí",
    part_of_speech: "danh từ",
    meaning:
      "tiền chi tiêu vào đời sống hằng ngày theo chế độ cung cấp trong thời kì chiến tranh: lĩnh sinh hoạt phí",
    example: "lĩnh sinh hoạt phí",
  },
  {
    word: "sinh kế",
    part_of_speech: "danh từ",
    meaning: "việc làm để kiếm ăn, để mưu sống: bị mất sinh kế * tìm sinh kế",
    example: "bị mất sinh kế * tìm sinh kế",
  },
  {
    word: "sinh học",
    part_of_speech: "tính từ",
    meaning: "thuộc về sinh học, có tính chất của sinh học: đặc điểm sinh học",
    example: "đặc điểm sinh học",
  },
  {
    word: "sinh khí",
    part_of_speech: "danh từ",
    meaning: "sức sống: cơ thể tràn đầy sinh khí * luồng sinh khí",
    example: "cơ thể tràn đầy sinh khí * luồng sinh khí",
  },
  {
    word: "sinh khoáng",
    part_of_speech: "danh từ",
    meaning:
      "khả năng hình thành khoáng sản khác nhau của đối tượng địa chất như đá macma, đá hoa cương, đá vôi, v.v.: đới sinh khoáng * cấu trúc địa tầng sinh khoáng của vỏ Trái Đất",
    example: "đới sinh khoáng * cấu trúc địa tầng sinh khoáng của vỏ Trái Đất",
  },
  {
    word: "sình lầy",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) bùn lầy: lội qua sình lầy",
    example: "lội qua sình lầy",
  },
  {
    word: "sinh lí",
    part_of_speech: "",
    meaning:
      "hoạt động và tính chất của các cơ quan, các bộ phận của cơ thể sinh vật (nói tổng quát): chức năng sinh lí * đòi hỏi sinh lí * đặc điểm sinh lí",
    example: "chức năng sinh lí * đòi hỏi sinh lí * đặc điểm sinh lí",
  },
  {
    word: "sính lễ",
    part_of_speech: "danh từ",
    meaning:
      "lễ vật của nhà trai đem đến nhà gái để xin cưới: đồ sính lễ * sắp sửa sính lễ",
    example: "đồ sính lễ * sắp sửa sính lễ",
  },
  {
    word: "sinh linh",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, văn chương) con người sống trong xã hội nói chung: một sinh linh bé bỏng * nạn đói đã cướp đi hàng triệu sinh linh",
    example: "một sinh linh bé bỏng * nạn đói đã cướp đi hàng triệu sinh linh",
  },
  {
    word: "sinh lợi",
    part_of_speech: "động từ",
    meaning: "làm cho có lãi: làm ăn sinh lợi * đầu tư sinh lợi",
    example: "làm ăn sinh lợi * đầu tư sinh lợi",
  },
  {
    word: "sinh lực",
    part_of_speech: "danh từ",
    meaning: "sức sống: tràn trề sinh lực * nguồn sinh lực",
    example: "tràn trề sinh lực * nguồn sinh lực",
  },
  {
    word: "sinh lực",
    part_of_speech: "danh từ",
    meaning:
      "lực lượng trực tiếp chiến đấu và phục vụ chiến đấu: tiêu hao sinh lực địch",
    example: "tiêu hao sinh lực địch",
  },
  {
    word: "sính nghi",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, hiếm) như sính lễ: "Rằng: Mua ngọc đến Lam Kiều, Sính nghi xin dạy bao nhiêu cho tường." (TKiều)',
    example:
      'Rằng: Mua ngọc đến Lam Kiều, Sính nghi xin dạy bao nhiêu cho tường." (TKiều)',
  },
  {
    word: "sinh mệnh",
    part_of_speech: "danh từ",
    meaning: "sự sống của con người: nguy hiểm đến sinh mạng",
    example: "nguy hiểm đến sinh mạng",
  },
  {
    word: "sinh lý",
    part_of_speech: "",
    meaning:
      "hoạt động và tính chất của các cơ quan, các bộ phận của cơ thể sinh vật (nói tổng quát): chức năng sinh lí * đòi hỏi sinh lí * đặc điểm sinh lí",
    example: "chức năng sinh lí * đòi hỏi sinh lí * đặc điểm sinh lí",
  },
  {
    word: "sinh mạng",
    part_of_speech: "danh từ",
    meaning: "sự sống của con người: nguy hiểm đến sinh mạng",
    example: "nguy hiểm đến sinh mạng",
  },
  {
    word: "sinh nhật",
    part_of_speech: "danh từ",
    meaning:
      "ngày sinh, ngày ra đời (về mặt là ngày kỉ niệm đáng nhớ): tổ chức lễ sinh nhật * ngày sinh nhật Bác",
    example: "tổ chức lễ sinh nhật * ngày sinh nhật Bác",
  },
  {
    word: "sinh nhai",
    part_of_speech: "động từ",
    meaning:
      "làm ăn sinh sống, kiếm sống (hàm ý khó khăn, chật vật): kiếm kế sinh nhai",
    example: "kiếm kế sinh nhai",
  },
  {
    word: "sinh nở",
    part_of_speech: "động từ",
    meaning: "như sinh đẻ (nói về người): chưa sinh nở lần nào",
    example: "chưa sinh nở lần nào",
  },
  {
    word: "sinh nở",
    part_of_speech: "động từ",
    meaning:
      "sinh ra và phát triển (nói khái quát): mùa xuân, sâu bọ sinh nở rất nhanh",
    example: "mùa xuân, sâu bọ sinh nở rất nhanh",
  },
  {
    word: "sinh sản",
    part_of_speech: "động từ",
    meaning:
      "đẻ, về mặt chức năng duy trì và phát triển nòi giống của sinh vật (nói khái quát): về mùa xuân, sâu bọ sinh sản rất nhanh * chức năng sinh sản",
    example: "về mùa xuân, sâu bọ sinh sản rất nhanh * chức năng sinh sản",
  },
  {
    word: "sinh quyển",
    part_of_speech: "danh từ",
    meaning:
      "khoảng không gian và tầng khí quyển làm thành môi trường bảo đảm sự sống cho sinh vật: khu dự trữ sinh quyển vùng ngập mặn",
    example: "khu dự trữ sinh quyển vùng ngập mặn",
  },
  {
    word: "sinh sắc",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương) vẻ sinh động, sống động: sinh sắc của thiên nhiên * hai má đỏ hồng lên, đầy sinh sắc",
    example: "sinh sắc của thiên nhiên * hai má đỏ hồng lên, đầy sinh sắc",
  },
  {
    word: "sinh sát",
    part_of_speech: "động từ",
    meaning:
      "(quyền) tự ý quyết định sự sống chết của những người khác: nắm quyền sinh sát trong tay",
    example: "nắm quyền sinh sát trong tay",
  },
  {
    word: "sinh sôi",
    part_of_speech: "động từ",
    meaning:
      "sinh nở và phát triển ngày một nhiều: thời tiết nóng ẩm, sâu bọ sinh sôi rất nhanh * của cải sinh sôi nẩy nở",
    example:
      "thời tiết nóng ẩm, sâu bọ sinh sôi rất nhanh * của cải sinh sôi nẩy nở",
  },
  {
    word: "sinh sống",
    part_of_speech: "động từ",
    meaning:
      "sống, về mặt tồn tại trên đời (nói khái quát): chuyển vào Nam sinh sống * làm ăn sinh sống",
    example: "chuyển vào Nam sinh sống * làm ăn sinh sống",
  },
  {
    word: "sinh sự",
    part_of_speech: "động từ",
    meaning:
      "gây ra chuyện lôi thôi, rắc rối: sinh sự cãi nhau * sinh sự sự sinh (tng)",
    example: "sinh sự cãi nhau * sinh sự sự sinh (tng)",
  },
  {
    word: "sinh thành",
    part_of_speech: "động từ",
    meaning:
      '(cũ) sinh ra và nuôi nấng, dạy dỗ cho thành người: công sinh thành * "Đội ơn chín chữ cù lao, Sinh thành kể mấy non cao cho bằng." (ca dao)',
    example:
      'công sinh thành * "Đội ơn chín chữ cù lao, Sinh thành kể mấy non cao cho bằng." (ca dao)',
  },
  {
    word: "sinh thành",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) được tạo ra và dần dần hình thành: những bí mật về sự sinh thành của trái đất",
    example: "những bí mật về sự sinh thành của trái đất",
  },
  {
    word: "sinh thái",
    part_of_speech: "danh từ",
    meaning:
      "quan hệ giữa sinh vật và môi trường (nói tổng quát): sinh thái biển * du lịch sinh thái * cân bằng sinh thái",
    example: "sinh thái biển * du lịch sinh thái * cân bằng sinh thái",
  },
  {
    word: "sinh thể",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) thể sống (thường nói về con người): một sinh thể độc lập * tình yêu đến từ hai sinh thể khác giới",
    example: "một sinh thể độc lập * tình yêu đến từ hai sinh thể khác giới",
  },
  {
    word: "sinh thời",
    part_of_speech: "danh từ",
    meaning:
      "(trang trọng) thời còn sống của người nào đó đã qua đời: lúc sinh thời, ông cụ quý cây mai này lắm",
    example: "lúc sinh thời, ông cụ quý cây mai này lắm",
  },
  {
    word: "sinh thiết",
    part_of_speech: "động từ",
    meaning:
      "lấy một phần nhỏ của bộ phận nghi ngờ mắc bệnh trên cơ thể sống để làm tiêu bản tế bào nhằm chẩn đoán bệnh: chờ kết quả sinh thiết * đưa bệnh nhân đi sinh thiết",
    example: "chờ kết quả sinh thiết * đưa bệnh nhân đi sinh thiết",
  },
  {
    word: "sinh trưởng",
    part_of_speech: "động từ",
    meaning:
      "(cơ thể) lớn lên, tăng thêm dần về thể tích và khối lượng: quá trình sinh trưởng của cây lúa",
    example: "quá trình sinh trưởng của cây lúa",
  },
  {
    word: "sinh trưởng",
    part_of_speech: "động từ",
    meaning: "ra đời và lớn lên: sinh trưởng trong một gia đình gia giáo",
    example: "sinh trưởng trong một gia đình gia giáo",
  },
  {
    word: "sinh thực khí",
    part_of_speech: "danh từ",
    meaning:
      "khí quan phồn thực của sinh vật (thường nói về của người): tín ngưỡng thờ sinh thực khí",
    example: "tín ngưỡng thờ sinh thực khí",
  },
  {
    word: "sinh tố",
    part_of_speech: "danh từ",
    meaning: "(Ít dùng) vitamin: loại trái cây chứa nhiều sinh tố A",
    example: "loại trái cây chứa nhiều sinh tố A",
  },
  {
    word: "sinh tố",
    part_of_speech: "danh từ",
    meaning:
      "chất chứa nhiều vitamin: nước sinh tố * sinh tố xoài * máy xay sinh tố",
    example: "nước sinh tố * sinh tố xoài * máy xay sinh tố",
  },
  {
    word: "sinh thú",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) thú vui trong cuộc sống: lao động là một sinh thú * không còn sinh thú gì",
    example: "lao động là một sinh thú * không còn sinh thú gì",
  },
  {
    word: "sinh tồn",
    part_of_speech: "động từ",
    meaning:
      "sống còn, không để bị diệt vong: đấu tranh sinh tồn * vì mục đích sinh tồn * bản năng sinh tồn",
    example: "đấu tranh sinh tồn * vì mục đích sinh tồn * bản năng sinh tồn",
  },
  {
    word: "sinh tử",
    part_of_speech: "động từ",
    meaning:
      "sống và chết, về mặt là lẽ tự nhiên ở đời: sinh tử có nhau * vòng sinh tử",
    example: "sinh tử có nhau * vòng sinh tử",
  },
  {
    word: "sinh tử",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) cực kì quan trọng, có ý nghĩa quyết định đối với sự sống còn: vấn đề sinh tử * cuộc chiến đấu sinh tử",
    example: "vấn đề sinh tử * cuộc chiến đấu sinh tử",
  },
  {
    word: "sinh vật cảnh",
    part_of_speech: "danh từ",
    meaning:
      "động, thực vật được nuôi, trồng làm cảnh: nuôi trồng sinh vật cảnh * cửa hàng sinh vật cảnh",
    example: "nuôi trồng sinh vật cảnh * cửa hàng sinh vật cảnh",
  },
  {
    word: "sịp",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) quần lót của nam giới, mặc sát vào mông và háng, không có ống: quần sịp",
    example: "quần sịp",
  },
  {
    word: "sít sìn sịt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) sít đến mức như liền vào nhau, không còn kẽ hở: hàng rào ken sít sìn sịt",
    example: "hàng rào ken sít sìn sịt",
  },
  {
    word: "sinh viên",
    part_of_speech: "danh từ",
    meaning:
      "người học ở bậc đại học: sinh viên năm thứ nhất * sinh viên trường Y",
    example: "sinh viên năm thứ nhất * sinh viên trường Y",
  },
  {
    word: "sinh vật học",
    part_of_speech: "tính từ",
    meaning: "thuộc về sinh học, có tính chất của sinh học: đặc điểm sinh học",
    example: "đặc điểm sinh học",
  },
  {
    word: "sít",
    part_of_speech: "tính từ",
    meaning:
      "thật sát vào nhau, như không hề có khe hở ở giữa: chữ viết hơi sít * bố trí công việc rất sít * ngồi sít vào nhau",
    example: "chữ viết hơi sít * bố trí công việc rất sít * ngồi sít vào nhau",
  },
  {
    word: "sít sao",
    part_of_speech: "tính từ",
    meaning: "(hiếm) sát sao, chặt chẽ: sự chỉ đạo sít sao * kiểm tra sít sao",
    example: "sự chỉ đạo sít sao * kiểm tra sít sao",
  },
  {
    word: "sít sao",
    part_of_speech: "tính từ",
    meaning:
      "khẩn trương, liên tục, không có khoảng thời gian trống: chương trình làm việc rất sít sao * thời gian sít sao",
    example: "chương trình làm việc rất sít sao * thời gian sít sao",
  },
  {
    word: "sít sịt",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) rất sít: bàn kê sít sịt vào nhau",
    example: "bàn kê sít sịt vào nhau",
  },
  {
    word: "so",
    part_of_speech: "động từ",
    meaning:
      "đặt kề nhau, song song với nhau để xem hơn kém nhau bao nhiêu: so đũa * so xem ai cao hơn * so bài làm với đáp án",
    example: "so đũa * so xem ai cao hơn * so bài làm với đáp án",
  },
  {
    word: "so",
    part_of_speech: "động từ",
    meaning:
      "so sánh điều chỉnh cho có được sự phù hợp nhất định: so mái chèo * đàn đã so dây",
    example: "so mái chèo * đàn đã so dây",
  },
  {
    word: "so",
    part_of_speech: "động từ",
    meaning:
      "làm cho (đôi vai) nhô cao lên, tựa như so với nhau: so vai rụt cổ",
    example: "so vai rụt cổ",
  },
  {
    word: "so",
    part_of_speech: "tính từ",
    meaning:
      "được thai nghén hoặc được đẻ ra lần đầu tiên: chửa con so * trứng gà so",
    example: "chửa con so * trứng gà so",
  },
  {
    word: "sọ",
    part_of_speech: "danh từ",
    meaning: "hộp xương đựng bộ não: hộp sọ",
    example: "hộp sọ",
  },
  {
    word: "sọ",
    part_of_speech: "danh từ",
    meaning: "tập hợp các xương đầu: sọ người * bị đánh vỡ sọ",
    example: "sọ người * bị đánh vỡ sọ",
  },
  {
    word: "sỏ",
    part_of_speech: "danh từ",
    meaning: "(Khẩu ngữ) thủ: thịt sỏ * cái sỏ lợn",
    example: "thịt sỏ * cái sỏ lợn",
  },
  {
    word: "so bì",
    part_of_speech: "động từ",
    meaning:
      "so tính hơn thiệt để không muốn mình bị thua thiệt: tính hay so bì * so bì gia thế",
    example: "tính hay so bì * so bì gia thế",
  },
  {
    word: "so đo",
    part_of_speech: "động từ",
    meaning:
      "so sánh để tính toán chi li hơn thiệt: tính hay so đo * so đo hơn thiệt",
    example: "tính hay so đo * so đo hơn thiệt",
  },
  {
    word: "sọ dừa",
    part_of_speech: "danh từ",
    meaning:
      "vỏ cứng bên trong quả dừa đựng cùi và nước dừa: gáo làm bằng sọ dừa",
    example: "gáo làm bằng sọ dừa",
  },
  {
    word: "so đũa",
    part_of_speech: "danh từ",
    meaning:
      "cây gỗ, lá kép lông chim, hoa to, màu trắng hay hồng, hình bướm, xếp thành chùm thõng, thường trồng làm cảnh: hàng so đũa",
    example: "hàng so đũa",
  },
  {
    word: "so găng",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) đấu quyền Anh: cuộc so găng giữa hai võ sĩ",
    example: "cuộc so găng giữa hai võ sĩ",
  },
  {
    word: "so kè",
    part_of_speech: "động từ",
    meaning:
      'tính toán hơn thiệt từng li từng tí (thường nói về mặt chi tiêu): so kè tính toán * "(...) ông phải là một người cơ chỉ, so kè từ một đồng xu trở đi." (NgTTố; 5)',
    example:
      'so kè tính toán * "(...) ông phải là một người cơ chỉ, so kè từ một đồng xu trở đi." (NgTTố; 5)',
  },
  {
    word: "so le",
    part_of_speech: "tính từ",
    meaning:
      "cao thấp, dài ngắn không đều khi đặt cạnh nhau, hoặc không thẳng hàng với nhau: đứng so le nhau * cây trồng so le",
    example: "đứng so le nhau * cây trồng so le",
  },
  {
    word: "so sánh",
    part_of_speech: "động từ",
    meaning:
      "nhìn vào cái này mà xem xét cái kia để thấy sự giống nhau, khác nhau hoặc sự hơn kém: so sánh hai phân số có cùng tử số * so sánh lực lượng giữa hai bên",
    example:
      "so sánh hai phân số có cùng tử số * so sánh lực lượng giữa hai bên",
  },
  {
    word: "soạn giả",
    part_of_speech: "danh từ",
    meaning: "(trang trọng) người biên soạn: một soạn giả nổi tiếng",
    example: "một soạn giả nổi tiếng",
  },
  {
    word: "soạn",
    part_of_speech: "động từ",
    meaning:
      "đem ra, chọn lấy những thứ cần thiết và sắp xếp cho việc gì đó: soạn sách vở * soạn quần áo, tư trang để đi công tác",
    example: "soạn sách vở * soạn quần áo, tư trang để đi công tác",
  },
  {
    word: "soạn",
    part_of_speech: "động từ",
    meaning:
      "chọn tài liệu và sắp xếp để viết thành bài, sách, bản nhạc, vở kịch: soạn bài * soạn một vở kịch * soạn giáo án",
    example: "soạn bài * soạn một vở kịch * soạn giáo án",
  },
  {
    word: "soàn soạt",
    part_of_speech: "tính từ",
    meaning:
      "như soạt (nhưng ý liên tiếp và mức độ nhiều hơn): tiếng cắt lúa soàn soạt",
    example: "tiếng cắt lúa soàn soạt",
  },
  {
    word: "sinh ngữ",
    part_of_speech: "danh từ",
    meaning: "ngôn ngữ đang được dùng hiện nay; phân biệt với tử ngữ.",
    example: "giờ học sinh ngữ * giỏi sinh ngữ",
  },
  {
    word: "soạn thảo",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) thảo ra văn kiện quan trọng, có tính chất chính thức: soạn thảo hiến pháp",
    example: "soạn thảo hiến pháp",
  },
  {
    word: "soạn thảo",
    part_of_speech: "động từ",
    meaning: "dùng máy tính để tạo lập văn bản: soạn thảo văn bản",
    example: "soạn thảo văn bản",
  },
  {
    word: "soát",
    part_of_speech: "động từ",
    meaning:
      "xem kĩ để phát hiện có gì không đúng hoặc bất thường thì sửa hoặc xử lí: soát vé * soát lại danh sách * đọc soát lại một lượt trước khi nộp bài",
    example:
      "soát vé * soát lại danh sách * đọc soát lại một lượt trước khi nộp bài",
  },
  {
    word: "sọc",
    part_of_speech: "danh từ",
    meaning:
      "vệt màu chạy dọc hoặc ngang trên mặt vải hay trên mặt một số vật: vải kẻ sọc * nền xanh sọc đỏ",
    example: "vải kẻ sọc * nền xanh sọc đỏ",
  },
  {
    word: "sóc",
    part_of_speech: "danh từ",
    meaning:
      "thú gặm nhấm lớn hơn chuột, sống trên cây, mõm tròn, đuôi xù, chuyền cành rất nhanh, ăn quả, hạt và búp cây: nhanh như sóc",
    example: "nhanh như sóc",
  },
  {
    word: "soạt",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng như tiếng của một vật cứng chuyển động mạnh và đột ngột, cọ xát với vật khác: tiếng giở giấy đánh soạt * rút soạt thanh kiếm ra khỏi bao",
    example: "tiếng giở giấy đánh soạt * rút soạt thanh kiếm ra khỏi bao",
  },
  {
    word: "soát xét",
    part_of_speech: "động từ",
    meaning:
      "soát lại, xem xét lại một cách kĩ càng, tỉ mỉ: soát xét lại toàn bộ kế hoạch",
    example: "soát xét lại toàn bộ kế hoạch",
  },
  {
    word: "soi",
    part_of_speech: "danh từ",
    meaning:
      "dải phù sa nổi giữa sông: soi cát * soi dâu * trồng hoa màu ở bãi soi",
    example: "soi cát * soi dâu * trồng hoa màu ở bãi soi",
  },
  {
    word: "soi",
    part_of_speech: "động từ",
    meaning:
      'chiếu ánh sáng vào làm cho thấy rõ: soi đèn * soi đường chỉ lối * "Vầng trăng ai xẻ làm đôi?, Nửa in gối chiếc, nửa soi dặm trường." (TKiều)',
    example:
      'soi đèn * soi đường chỉ lối * "Vầng trăng ai xẻ làm đôi?, Nửa in gối chiếc, nửa soi dặm trường." (TKiều)',
  },
  {
    word: "soi",
    part_of_speech: "động từ",
    meaning:
      "nhìn vào mặt gương hoặc vật tựa như gương để thấy ảnh của mình: soi gương chải đầu * đứng soi mình xuống nước * hàng cây soi bóng xuống mặt hồ",
    example:
      "soi gương chải đầu * đứng soi mình xuống nước * hàng cây soi bóng xuống mặt hồ",
  },
  {
    word: "soi",
    part_of_speech: "động từ",
    meaning:
      "nhìn cho rõ hơn bằng cách giơ lên phía có ánh sáng để nhìn khi có ánh sáng chiếu xuyên qua: soi trứng * soi xem tiền thật hay giả",
    example: "soi trứng * soi xem tiền thật hay giả",
  },
  {
    word: "soi",
    part_of_speech: "động từ",
    meaning:
      "nhìn cho rõ hơn bằng dụng cụ quang học cho thấy ảnh phóng to nhiều lần: soi kính hiển vi",
    example: "soi kính hiển vi",
  },
  {
    word: "sói",
    part_of_speech: "danh từ",
    meaning: "chó sói (nói tắt): lũ sói rừng * sống giữa bầy sói",
    example: "lũ sói rừng * sống giữa bầy sói",
  },
  {
    word: "sói",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) hói: sói trán",
    example: "sói trán",
  },
  {
    word: "sỏi",
    part_of_speech: "danh từ",
    meaning: "đá vụn nhỏ, tròn và nhẵn, thường ở lòng sông, lòng suối.",
    example: "sỏi mật * sỏi thận",
  },
  {
    word: "sõi",
    part_of_speech: "tính từ",
    meaning:
      "(trẻ nhỏ phát âm) rõ, đúng, rành rọt từng tiếng, từng lời: cháu bé nói chưa sõi",
    example: "cháu bé nói chưa sõi",
  },
  {
    word: "sõi",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (nói) đúng, thành thạo một ngôn ngữ nào đó khác với ngôn ngữ của dân tộc mình: nói sõi tiếng Anh",
    example: "nói sõi tiếng Anh",
  },
  {
    word: "sọm",
    part_of_speech: "tính từ",
    meaning:
      "gầy tóp: ốm một trận, người gầy sọm đi * già sọm * sọm người vì lo nghĩ",
    example: "ốm một trận, người gầy sọm đi * già sọm * sọm người vì lo nghĩ",
  },
  {
    word: "soi rọi",
    part_of_speech: "động từ",
    meaning: "soi rõ (nói khái quát): ánh lửa soi rọi khuôn mặt từng người",
    example: "ánh lửa soi rọi khuôn mặt từng người",
  },
  {
    word: "sói lang",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như lang sói: bầy sói lang",
    example: "bầy sói lang",
  },
  {
    word: "soi xét",
    part_of_speech: "động từ",
    meaning:
      '(trang trọng, hiếm) xem xét kĩ để thấy rõ: đèn trời soi xét * "Bẩm quan lớn, xin quan lớn soi xét cho, sự thực mà như thế thì ức cho gia đình con lắm." (VTrPhụng; 4)',
    example:
      'đèn trời soi xét * "Bẩm quan lớn, xin quan lớn soi xét cho, sự thực mà như thế thì ức cho gia đình con lắm." (VTrPhụng; 4)',
  },
  {
    word: "soi mói",
    part_of_speech: "động từ",
    meaning:
      "để ý, moi móc những sai sót, những chuyện riêng tư của người khác, với dụng ý xấu: cái nhìn soi mói * soi mói chuyện của người khác",
    example: "cái nhìn soi mói * soi mói chuyện của người khác",
  },
  {
    word: "són",
    part_of_speech: "động từ",
    meaning:
      "đái hay ỉa một ít ra quần, do không tự chủ được: đái són * són ra quần",
    example: "đái són * són ra quần",
  },
  {
    word: "són",
    part_of_speech: "động từ",
    meaning:
      "(Thông tục) đưa ra, bỏ ra quá ít so với yêu cầu một cách khó khăn (hàm ý chê): có xin thì cũng chỉ són cho vài đồng",
    example: "có xin thì cũng chỉ són cho vài đồng",
  },
  {
    word: "son phấn",
    part_of_speech: "danh từ",
    meaning:
      "đồ trang điểm của phụ nữ, như phấn xoa mặt, son bôi môi (nói khái quát): phấn son loè loẹt",
    example: "phấn son loè loẹt",
  },
  {
    word: "son",
    part_of_speech: "danh từ",
    meaning:
      "đá đỏ, mài ra làm mực viết, vẽ (bằng bút lông): mài son * khuyên mấy nét son",
    example: "mài son * khuyên mấy nét son",
  },
  {
    word: "son",
    part_of_speech: "danh từ",
    meaning:
      "sáp thường màu đỏ, phụ nữ dùng để tô môi: bôi son * tô son điểm phấn (tng)",
    example: "bôi son * tô son điểm phấn (tng)",
  },
  {
    word: "son",
    part_of_speech: "tính từ",
    meaning: "có màu đỏ như son: lầu son * đũa mốc chòi mâm son (tng)",
    example: "lầu son * đũa mốc chòi mâm son (tng)",
  },
  {
    word: "son",
    part_of_speech: "tính từ",
    meaning:
      '(Từ cũ, Văn chương) (lòng) ngay thẳng, trung trinh, trước sau không phai nhạt, đổi thay: tấm lòng son * "Bên trời góc biển bơ vơ, Tấm son gột rửa bao giờ cho phai." (TKiều)',
    example:
      'tấm lòng son * "Bên trời góc biển bơ vơ, Tấm son gột rửa bao giờ cho phai." (TKiều)',
  },
  {
    word: "son",
    part_of_speech: "tính từ",
    meaning: "còn trẻ và chưa có con cái, tuy đã có vợ, có chồng: vợ chồng son",
    example: "vợ chồng son",
  },
  {
    word: "son",
    part_of_speech: "tính từ",
    meaning:
      '(Ít dùng) còn trẻ, chưa có vợ, có chồng: "Anh còn son, em cũng còn son, Ước gì ta được làm con một nhà." (Cdao)',
    example:
      'Anh còn son, em cũng còn son, Ước gì ta được làm con một nhà." (Cdao)',
  },
  {
    word: "sonata",
    part_of_speech: "danh từ",
    meaning:
      "bản nhạc gồm ba hoặc bốn chương khác nhau về nhịp điệu và tính chất, nối tiếp với nhau: bản sonata của Beethoven",
    example: "bản sonata của Beethoven",
  },
  {
    word: "sòn sòn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (người phụ nữ) đẻ nhiều và dày (hàm ý chê): đẻ sòn sòn * sòn sòn năm một",
    example: "đẻ sòn sòn * sòn sòn năm một",
  },
  {
    word: "son rỗi",
    part_of_speech: "tính từ",
    meaning:
      "rỗi rãi vì chưa có con, không phải bận bịu vì con cái (thường nói về phụ nữ): tranh thủ học khi còn son rỗi",
    example: "tranh thủ học khi còn son rỗi",
  },
  {
    word: "son sắt",
    part_of_speech: "tính từ",
    meaning:
      "thuỷ chung, không bao giờ đổi thay, không bao giờ phai nhạt (tựa như lúc nào cũng đỏ như son, rắn như sắt): lời thề son sắt * son sắt đợi chờ",
    example: "lời thề son sắt * son sắt đợi chờ",
  },
  {
    word: "son trẻ",
    part_of_speech: "tính từ",
    meaning:
      "còn trẻ và không phải bận bịu việc gia đình, con cái: thời son trẻ * cặp vợ chồng son trẻ",
    example: "thời son trẻ * cặp vợ chồng son trẻ",
  },
  {
    word: "sóng",
    part_of_speech: "danh từ",
    meaning:
      "hiện tượng mặt nước dao động, dâng lên hạ xuống trông như đang di chuyển, chủ yếu do gió gây nên: mặt hồ gợn sóng * con sóng vỗ bờ",
    example: "mặt hồ gợn sóng * con sóng vỗ bờ",
  },
  {
    word: "sóng",
    part_of_speech: "danh từ",
    meaning:
      "hiện tượng cả một khối lớn vận động, di chuyển trên một phạm vi rộng theo kiểu làn sóng: sóng lúa nhấp nhô * làn sóng đấu tranh",
    example: "sóng lúa nhấp nhô * làn sóng đấu tranh",
  },
  {
    word: "sóng",
    part_of_speech: "danh từ",
    meaning:
      "dao động truyền đi trong một môi trường: sóng âm * sóng vô tuyến điện",
    example: "sóng âm * sóng vô tuyến điện",
  },
  {
    word: "sóng",
    part_of_speech: "động từ",
    meaning: "(Ít dùng) sánh ra: nước sóng ra bàn",
    example: "nước sóng ra bàn",
  },
  {
    word: "sòng",
    part_of_speech: "danh từ",
    meaning: "nơi gá bạc: sòng bạc",
    example: "sòng bạc",
  },
  {
    word: "song biên",
    part_of_speech: "tính từ",
    meaning:
      "(quan hệ về kinh tế, chính trị) giữa hai nước: quan hệ thương mại song biên",
    example: "quan hệ thương mại song biên",
  },
  {
    word: "song",
    part_of_speech: "danh từ",
    meaning:
      "cây thân leo dài, cùng họ với mây, lá kép lông chim, có bẹ, thân dùng làm bàn ghế, gậy chống, v.v.: gậy song * roi song",
    example: "gậy song * roi song",
  },
  {
    word: "song",
    part_of_speech: "danh từ",
    meaning:
      '(Từ cũ, Văn chương) cửa sổ: "Mỗi lần nắng mới hắt bên song, Xao xác, gà trưa gáy não nùng." (LTrLư; 6)',
    example:
      'Mỗi lần nắng mới hắt bên song, Xao xác, gà trưa gáy não nùng." (LTrLư; 6)',
  },
  {
    word: "song",
    part_of_speech: "danh từ",
    meaning: "chấn song (nói tắt): song cửa sổ * nhìn qua song sắt",
    example: "song cửa sổ * nhìn qua song sắt",
  },
  {
    word: "song",
    part_of_speech: "kết từ",
    meaning:
      "(Văn chương) như nhưng (nhưng nghĩa mạnh hơn): người đã lớn song trí còn non nớt",
    example: "người đã lớn song trí còn non nớt",
  },
  {
    word: "sóng đôi",
    part_of_speech: "động từ",
    meaning: "song song thành một đôi với nhau: đi sóng đôi",
    example: "đi sóng đôi",
  },
  {
    word: "song ca",
    part_of_speech: "động từ",
    meaning:
      "hát hai người (một hình thức biểu diễn nghệ thuật): tiết mục song ca * song ca nam nữ",
    example: "tiết mục song ca * song ca nam nữ",
  },
  {
    word: "sóng gió",
    part_of_speech: "danh từ",
    meaning:
      'sóng và gió (nói khái quát); thường dùng để ví những khó khăn lớn và bất ngờ phải vượt qua trong công việc, trong cuộc đời: cuộc đời nhiều sóng gió * "Sự đâu sóng gió bất kỳ, Hiếu tình, khôn lẽ hai bề vẹn hai?" (TKiều)',
    example:
      'cuộc đời nhiều sóng gió * "Sự đâu sóng gió bất kỳ, Hiếu tình, khôn lẽ hai bề vẹn hai?" (TKiều)',
  },
  {
    word: "song đường",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) xuân đường và huyên đường; cha mẹ: "Thương song đường lòng này như cắt, Nói ra càng chua xót đắng cay!" (PTNH)',
    example:
      'Thương song đường lòng này như cắt, Nói ra càng chua xót đắng cay!" (PTNH)',
  },
  {
    word: "song hồ",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) cửa sổ phất giấy; cũng dùng để chỉ nơi đọc sách của học trò nghèo thời xưa: "Song hồ ngày tháng lân la, Một hai hoàng quyển năm ba tiểu đồng." (TTK)',
    example:
      'Song hồ ngày tháng lân la, Một hai hoàng quyển năm ba tiểu đồng." (TTK)',
  },
  {
    word: "song le",
    part_of_speech: "kết từ",
    meaning:
      '(cũ, văn chương) nhưng mà: "Trong nhà đã có hoàng cầm, Song le còn muốn nhân sâm nước người." (ca dao)',
    example:
      'Trong nhà đã có hoàng cầm, Song le còn muốn nhân sâm nước người." (ca dao)',
  },
  {
    word: "song loan",
    part_of_speech: "danh từ",
    meaning:
      "mõ nhỏ làm bằng gỗ cứng có đính cần gỗ, thường dùng để điểm nhịp trong các dàn nhạc tài tử: nhịp song loan",
    example: "nhịp song loan",
  },
  {
    word: "song hành",
    part_of_speech: "động từ",
    meaning: "cùng sóng đôi với nhau, song song với nhau: bạn song hành",
    example: "bạn song hành",
  },
  {
    word: "song kiếm",
    part_of_speech: "danh từ",
    meaning:
      "đôi kiếm giống nhau làm thành một bộ, sử dụng cùng một lúc: song kiếm thư hùng",
    example: "song kiếm thư hùng",
  },
  {
    word: "sóng lừng",
    part_of_speech: "danh từ",
    meaning:
      "sóng rất lớn, đầu tròn, sườn thoai thoải, thường gặp ở ngoài khơi khi có gió mạnh: đợt sóng lừng",
    example: "đợt sóng lừng",
  },
  {
    word: "song hỷ",
    part_of_speech: "danh từ",
    meaning:
      "hai chữ hỉ của tiếng Hán đứng liền nhau (I), tượng trưng cho hôn nhân hạnh phúc, thường dùng để trang trí trên thiếp mời, trong lễ cưới: cắt chữ song hỉ",
    example: "cắt chữ song hỉ",
  },
  {
    word: "song hỉ",
    part_of_speech: "danh từ",
    meaning:
      "hai chữ hỉ của tiếng Hán đứng liền nhau (I), tượng trưng cho hôn nhân hạnh phúc, thường dùng để trang trí trên thiếp mời, trong lễ cưới: cắt chữ song hỉ",
    example: "cắt chữ song hỉ",
  },
  {
    word: "song ngữ",
    part_of_speech: "tính từ",
    meaning:
      "(hiện tượng hai ngôn ngữ) được sử dụng ngang nhau trong giao tiếp: hiện tượng song ngữ ở một số dân tộc",
    example: "hiện tượng song ngữ ở một số dân tộc",
  },
  {
    word: "song ngữ",
    part_of_speech: "tính từ",
    meaning: "được viết bằng hai ngôn ngữ: từ điển song ngữ * sách song ngữ",
    example: "từ điển song ngữ * sách song ngữ",
  },
  {
    word: "sòng phẳng",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra phân minh, rõ ràng và thẳng thắn: mua bán sòng phẳng * tiền nong sòng phẳng, không nhập nhèm",
    example: "mua bán sòng phẳng * tiền nong sòng phẳng, không nhập nhèm",
  },
  {
    word: "song phương",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất của cả hai bên, có sự thoả thuận hoặc sự tham gia của cả hai bên; phân biệt với đơn phương: kí kết hiệp định song phương * đàm phán song phương * quan hệ song phương",
    example:
      "kí kết hiệp định song phương * đàm phán song phương * quan hệ song phương",
  },
  {
    word: "sóng sánh",
    part_of_speech: "động từ",
    meaning:
      "(chất lỏng trong đồ đựng) chao qua chao lại như sắp tràn ra vì bị lắc động mạnh: thùng nước sóng sánh * rượu sóng sánh trong li",
    example: "thùng nước sóng sánh * rượu sóng sánh trong li",
  },
  {
    word: "song phi",
    part_of_speech: "động từ",
    meaning:
      "nhảy lên đá một chân này rồi tiếp liền theo đá chân kia: đá song phi * tung một cú song phi",
    example: "đá song phi * tung một cú song phi",
  },
  {
    word: "sõng soài",
    part_of_speech: "tính từ",
    meaning: "như sóng sượt: ngã sõng soài",
    example: "ngã sõng soài",
  },
  {
    word: "song sinh",
    part_of_speech: "tính từ",
    meaning: "sinh đôi: chị em song sinh * ca đẻ song sinh",
    example: "chị em song sinh * ca đẻ song sinh",
  },
  {
    word: "song song",
    part_of_speech: "tính từ",
    meaning:
      "sóng đôi với nhau: hai người đi song song nhau * kê hai hàng ghế song song",
    example: "hai người đi song song nhau * kê hai hàng ghế song song",
  },
  {
    word: "song song",
    part_of_speech: "tính từ",
    meaning:
      "không cắt nhau (nói về hai đường thẳng trên cùng một mặt phẳng) hoặc không có một điểm nào chung (nói về một đường thẳng và một mặt phẳng, hay nói về hai mặt phẳng): hai đường thẳng song song",
    example: "hai đường thẳng song song",
  },
  {
    word: "song song",
    part_of_speech: "phụ từ",
    meaning:
      "(xảy ra, tiến hành) cùng trong một thời gian: thực hiện song song hai nhiệm vụ * cái xấu và cái tốt song song tồn tại",
    example:
      "thực hiện song song hai nhiệm vụ * cái xấu và cái tốt song song tồn tại",
  },
  {
    word: "sòng sọc",
    part_of_speech: "tính từ",
    meaning:
      "(mắt) ở trạng thái mở to, không chớp và đưa đi đưa lại rất nhanh: mắt long lên sòng sọc",
    example: "mắt long lên sòng sọc",
  },
  {
    word: "sòng sọc",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng như tiếng nước kêu giòn, vang ở trong vật đựng kín khi bị khuấy động: rít thuốc lào sòng sọc",
    example: "rít thuốc lào sòng sọc",
  },
  {
    word: "song thai",
    part_of_speech: "danh từ",
    meaning:
      "(hiện tượng) hai bào thai cùng phát triển trong bụng mẹ: mang song thai",
    example: "mang song thai",
  },
  {
    word: "sóng sượt",
    part_of_speech: "tính từ",
    meaning:
      "ở tư thế nằm thẳng dài người ra, không động đậy: nằm sóng sượt * ngã sóng sượt",
    example: "nằm sóng sượt * ngã sóng sượt",
  },
  {
    word: "song tiết",
    part_of_speech: "tính từ",
    meaning: "gồm hai âm tiết: từ song tiết * tổ hợp song tiết",
    example: "từ song tiết * tổ hợp song tiết",
  },
  {
    word: "song toàn",
    part_of_speech: "tính từ",
    meaning:
      "(cũ) (trang trọng) (cha mẹ hoặc vợ chồng) còn sống đủ cả hai: phụ mẫu vẫn song toàn",
    example: "phụ mẫu vẫn song toàn",
  },
  {
    word: "song toàn",
    part_of_speech: "tính từ",
    meaning: "vẹn toàn cả hai: văn võ song toàn * tài mạo song toàn",
    example: "văn võ song toàn * tài mạo song toàn",
  },
  {
    word: "song thân",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) phụ thân và mẫu thân; cha mẹ: "Dẫu vàng dẫu đá với người, Nặng tình đâu dám nhẹ lời song thân." (HT)',
    example:
      'Dẫu vàng dẫu đá với người, Nặng tình đâu dám nhẹ lời song thân." (HT)',
  },
  {
    word: "song thất lục bát",
    part_of_speech: "danh từ",
    meaning:
      "thể văn vần, mỗi đoạn gồm hai câu bảy âm tiết rồi đến một câu sáu và một câu tám âm tiết:  được viết theo thể song thất lục bát",
    example: "được viết theo thể song thất lục bát",
  },
  {
    word: "soóc",
    part_of_speech: "danh từ",
    meaning: "quần soóc (nói tắt): mặc soóc",
    example: "mặc soóc",
  },
  {
    word: "sóng thần",
    part_of_speech: "danh từ",
    meaning:
      "sóng biển rất to, cao đến hàng chục mét, do động đất ngầm dưới biển gây ra, có sức tàn phá rất lớn: hiểm hoạ sóng thần",
    example: "hiểm hoạ sóng thần",
  },
  {
    word: "sổ",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp những tờ giấy đóng thành quyển, có bìa, dùng để ghi chép: sổ ghi chép * sổ nhật kí",
    example: "sổ ghi chép * sổ nhật kí",
  },
  {
    word: "sổ",
    part_of_speech: "động từ",
    meaning:
      "tạo nên nét gạch thẳng từ trên xuống dưới, trong lối viết chữ Hán, chữ Nôm: ngang bằng, sổ thẳng",
    example: "ngang bằng, sổ thẳng",
  },
  {
    word: "sổ",
    part_of_speech: "động từ",
    meaning:
      "(Từ cũ) gạch thẳng ở lề, biểu thị ý chê là dở, trong cách chấm bài chữ Hán thời trước: bài văn bị sổ một đoạn",
    example: "bài văn bị sổ một đoạn",
  },
  {
    word: "sổ",
    part_of_speech: "động từ",
    meaning: "(Từ cũ) gạch bỏ, xoá bỏ: bị sổ tên trong danh sách",
    example: "bị sổ tên trong danh sách",
  },
  {
    word: "sổ",
    part_of_speech: "động từ",
    meaning:
      "tuột ra (nói về cái gì đã được khâu, buộc, tết, v.v.): gấu quần bị sổ * sổ đường chỉ * sổ tóc ra chải",
    example: "gấu quần bị sổ * sổ đường chỉ * sổ tóc ra chải",
  },
  {
    word: "sổ",
    part_of_speech: "động từ",
    meaning: "thoát ra khỏi nơi giam giữ: chim sổ lồng * tù sổ ngục",
    example: "chim sổ lồng * tù sổ ngục",
  },
  {
    word: "sổ",
    part_of_speech: "động từ",
    meaning: "(Khẩu ngữ) sổ lòng (nói tắt): chị ấy mới sổ đêm qua",
    example: "chị ấy mới sổ đêm qua",
  },
  {
    word: "sổ",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) to béo ra một cách nhanh chóng và thiếu cân đối: càng ngày càng sổ ra",
    example: "càng ngày càng sổ ra",
  },
  {
    word: "sọt",
    part_of_speech: "danh từ",
    meaning:
      "đồ đựng đan thưa, sâu lòng: một sọt khoai đầy * quẩy đôi sọt ra đồng * sọt đựng rác",
    example: "một sọt khoai đầy * quẩy đôi sọt ra đồng * sọt đựng rác",
  },
  {
    word: "số",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để đếm (gọi là những số tự nhiên): bé đã biết đếm từ số một đến số mười * tính đến số một trăm",
    example: "bé đã biết đếm từ số một đến số mười * tính đến số một trăm",
  },
  {
    word: "số",
    part_of_speech: "danh từ",
    meaning: "chữ số (nói tắt): số 5 * tính sai một con số * số hàng đơn vị",
    example: "số 5 * tính sai một con số * số hàng đơn vị",
  },
  {
    word: "số",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp những vật cùng loại, về mặt đếm được nhiều hay ít: mất một số tiền lớn * số hộ nghèo đã giảm * kiểm lại số hàng trong kho",
    example:
      "mất một số tiền lớn * số hộ nghèo đã giảm * kiểm lại số hàng trong kho",
  },
  {
    word: "số",
    part_of_speech: "danh từ",
    meaning:
      "số gán cho một vật làm kí hiệu phân biệt nó với những vật cùng loại, hoặc phân biệt tiểu loại của nó với những tiểu loại khác trong toàn bộ hệ thống phân loại: nhà số 26 * ngồi ở toa C, số ghế 12 * đánh số trang",
    example: "nhà số 26 * ngồi ở toa C, số ghế 12 * đánh số trang",
  },
  {
    word: "số",
    part_of_speech: "danh từ",
    meaning:
      "con số dùng trong hộp tốc độ, ứng với tỉ số vòng quay giữa trục đầu và trục cuối: lên dốc thì phải về số * cài số lùi * hộp số của quạt trần",
    example: "lên dốc thì phải về số * cài số lùi * hộp số của quạt trần",
  },
  {
    word: "số",
    part_of_speech: "danh từ",
    meaning:
      "số khác nhau ghi trên vé trong một trò chơi may rủi, vé nào trúng giải thì được thưởng: quay số * trúng số độc đắc",
    example: "quay số * trúng số độc đắc",
  },
  {
    word: "số",
    part_of_speech: "danh từ",
    meaning:
      "bản báo hoặc tạp chí ra vào một ngày, một kì nào đó, được ghi rõ bằng một con số thứ tự nhất định: một tuần ra hai số * có bài đăng ở số Tết * số báo đặc biệt",
    example: "một tuần ra hai số * có bài đăng ở số Tết * số báo đặc biệt",
  },
  {
    word: "số",
    part_of_speech: "danh từ",
    meaning:
      "phạm trù ngữ pháp của danh từ, tính từ, động từ, đại từ trong một số ngôn ngữ, thông qua phương tiện hình thái học để biểu thị ý có một (gọi là số ít) hoặc có trên một (gọi là số nhiều): chia động từ ở ngôi thứ ba, số ít",
    example: "chia động từ ở ngôi thứ ba, số ít",
  },
  {
    word: "số",
    part_of_speech: "danh từ",
    meaning:
      "những sự may rủi gặp phải trong cuộc đời của mỗi người, đã được định sẵn từ trước một cách thần bí, theo quan niệm duy tâm: số vất vả từ bé * tốt số * lập lá số tử vi",
    example: "số vất vả từ bé * tốt số * lập lá số tử vi",
  },
  {
    word: "sót",
    part_of_speech: "động từ",
    meaning:
      "không hết tất cả, mà còn lại hoặc thiếu đi một số, một phần nào đó, do sơ ý hoặc quên: còn sót mấy khoản chưa tính * chẳng để sót một ai * đọc không sót một câu nào",
    example:
      "còn sót mấy khoản chưa tính * chẳng để sót một ai * đọc không sót một câu nào",
  },
  {
    word: "sô",
    part_of_speech: "danh từ",
    meaning:
      "buổi, màn trình diễn nghệ thuật: sô quảng cáo * sô trình diễn thời trang * sô diễn * chạy sô (= biểu diễn ở nhiều nơi, liên tiếp nhau)",
    example:
      "sô quảng cáo * sô trình diễn thời trang * sô diễn * chạy sô (= biểu diễn ở nhiều nơi, liên tiếp nhau)",
  },
  {
    word: "sô",
    part_of_speech: "danh từ",
    meaning:
      "vải thô, dệt thưa, thường dùng để may màn hoặc làm khăn, áo tang: màn sô * khăn sô",
    example: "màn sô * khăn sô",
  },
  {
    word: "sỗ",
    part_of_speech: "tính từ",
    meaning:
      "(nói năng, cử chỉ) tự nhiên đến mức không có ý tứ, thậm chí thô lỗ: đùa sỗ * ăn nói rất sỗ",
    example: "đùa sỗ * ăn nói rất sỗ",
  },
  {
    word: "sos",
    part_of_speech: "danh từ",
    meaning:
      "tín hiệu quốc tế dùng đánh radio kêu cứu khi mắc nạn: tín hiệu SOS được phát đi từ con tàu bị nạn",
    example: "tín hiệu SOS được phát đi từ con tàu bị nạn",
  },
  {
    word: "số âm",
    part_of_speech: "danh từ",
    meaning: "số bé hơn số không; đối lập với số dương: -6, -11 là những số âm",
    example: "-6, -11 là những số âm",
  },
  {
    word: "số bị chia",
    part_of_speech: "danh từ",
    meaning:
      "số đem chia cho một số khác; phân biệt với số chia: trong phép tính 49 : 7 = 7, thì 49 là số bị chia",
    example: "trong phép tính 49 : 7 = 7, thì 49 là số bị chia",
  },
  {
    word: "số bị nhân",
    part_of_speech: "danh từ",
    meaning:
      "số được đem nhân với một số khác; phân biệt với số nhân: trong phép tính 13 x 5 = 65, thì 13 là số bị nhân",
    example: "trong phép tính 13 x 5 = 65, thì 13 là số bị nhân",
  },
  {
    word: "số chẵn",
    part_of_speech: "danh từ",
    meaning:
      "số nguyên chia hết cho 2; đối lập với số lẻ: các số 6, 8, 14, 120 là những số chẵn",
    example: "các số 6, 8, 14, 120 là những số chẵn",
  },
  {
    word: "số bị trừ",
    part_of_speech: "danh từ",
    meaning:
      "số được đem trừ đi một số khác; phân biệt với số trừ: trong phép tính 25 - 7 = 18, thì 25 là số bị trừ",
    example: "trong phép tính 25 - 7 = 18, thì 25 là số bị trừ",
  },
  {
    word: "số chia",
    part_of_speech: "danh từ",
    meaning:
      "số mà nhân với thương thì được số bị chia: trong phép tính 42 : 6 = 7, thì 6 là số chia",
    example: "trong phép tính 42 : 6 = 7, thì 6 là số chia",
  },
  {
    word: "số dư",
    part_of_speech: "danh từ",
    meaning:
      "số còn lại sau khi lấy số bị chia trừ đi tích của số chia với thương: 50 chia cho 7 được 7, số dư là 1",
    example: "50 chia cho 7 được 7, số dư là 1",
  },
  {
    word: "số dư",
    part_of_speech: "danh từ",
    meaning:
      "số còn lại sau khi đã đối chiếu số tăng và số giảm, hoặc số tiền gửi vào và số tiền lấy ra: kiểm tra số dư trong tài khoản",
    example: "kiểm tra số dư trong tài khoản",
  },
  {
    word: "số chính phương",
    part_of_speech: "danh từ",
    meaning:
      "số tự nhiên là bình phương của một số tự nhiên: 4, 9, 16... là những số chính phương",
    example: "4, 9, 16... là những số chính phương",
  },
  {
    word: "số dách",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ, khẩu ngữ) số một, trên tất cả những cái khác cùng loại: chè ngon số dách * thằng cha nói láo số dách!",
    example: "chè ngon số dách * thằng cha nói láo số dách!",
  },
  {
    word: "số đề",
    part_of_speech: "danh từ",
    meaning:
      "lối chơi đề, dựa vào việc đoán trước những con số nào đó: chơi số đề * ghi số đề",
    example: "chơi số đề * ghi số đề",
  },
  {
    word: "sổ đen",
    part_of_speech: "danh từ",
    meaning:
      "sổ bí mật ghi chép về những người bị tình nghi để theo dõi: có tên trong sổ đen",
    example: "có tên trong sổ đen",
  },
  {
    word: "sổ đỏ",
    part_of_speech: "danh từ",
    meaning:
      "giấy chứng nhận quyền sử dụng đất, do cơ quan có thẩm quyền cấp: cấp sổ đỏ",
    example: "cấp sổ đỏ",
  },
  {
    word: "số đối",
    part_of_speech: "danh từ",
    meaning:
      "số có giá trị tuyệt đối bằng giá trị của một số khác nhưng có dấu trái với dấu của số đó: -6 là số đối của +6 * +7 và -7 là một cặp số đối",
    example: "-6 là số đối của +6 * +7 và -7 là một cặp số đối",
  },
  {
    word: "số đo",
    part_of_speech: "danh từ",
    meaning:
      "số chỉ kết quả của phép đo một đại lượng nhất định bằng hệ đơn vị xác định nào đó: số đo vận tốc chuyển động * số đo của bước sóng ánh sáng",
    example: "số đo vận tốc chuyển động * số đo của bước sóng ánh sáng",
  },
  {
    word: "số đo",
    part_of_speech: "danh từ",
    meaning:
      "số ghi độ dài, chiều cao, vòng ngực, vòng bụng, v.v. (nói tổng quát): một cô gái có số đo lí tưởng * thợ may lấy số đo",
    example: "một cô gái có số đo lí tưởng * thợ may lấy số đo",
  },
  {
    word: "số hiệu",
    part_of_speech: "danh từ",
    meaning: "kí hiệu phân loại bằng chữ số: số hiệu đơn vị",
    example: "số hiệu đơn vị",
  },
  {
    word: "số hữu tỉ",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi chung các số nguyên và các phân số (dương, âm hoặc bằng không): các số 1, -5, L, 0 là những số hữu tỉ",
    example: "các số 1, -5, L, 0 là những số hữu tỉ",
  },
  {
    word: "số hữu tỷ",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi chung các số nguyên và các phân số (dương, âm hoặc bằng không): các số 1, -5, L, 0 là những số hữu tỉ",
    example: "các số 1, -5, L, 0 là những số hữu tỉ",
  },
  {
    word: "số liệu",
    part_of_speech: "danh từ",
    meaning:
      "tài liệu biểu hiện bằng những con số: theo dõi các số liệu * số liệu thống kê",
    example: "theo dõi các số liệu * số liệu thống kê",
  },
  {
    word: "số ít",
    part_of_speech: "danh từ",
    meaning: "số lượng nhỏ: những người như vậy chỉ chiếm số ít",
    example: "những người như vậy chỉ chiếm số ít",
  },
  {
    word: "số ít",
    part_of_speech: "danh từ",
    meaning:
      "phạm trù ngữ pháp số trong một số ngôn ngữ, biểu thị ý có một; đối lập với số nhiều: chia động từ ở ngôi thứ ba số ít",
    example: "chia động từ ở ngôi thứ ba số ít",
  },
  {
    word: "số kiếp",
    part_of_speech: "danh từ",
    meaning:
      "số phận một đời người: số kiếp long đong * sướng khổ âu cũng do số kiếp",
    example: "số kiếp long đong * sướng khổ âu cũng do số kiếp",
  },
  {
    word: "số lẻ",
    part_of_speech: "danh từ",
    meaning:
      "số nguyên không chia hết cho 2; đối lập với số chẵn: các số 3, 15, 217 là những số lẻ",
    example: "các số 3, 15, 217 là những số lẻ",
  },
  {
    word: "số nguyên tố",
    part_of_speech: "danh từ",
    meaning:
      "số tự nhiên chỉ có hai ước số, chỉ có thể chia hết cho 1 và cho chính nó; phân biệt với hợp số: 2, 3, 5, 7, 11, 13, 17, 19 là những số nguyên tố",
    example: "2, 3, 5, 7, 11, 13, 17, 19 là những số nguyên tố",
  },
  {
    word: "số một",
    part_of_speech: "danh từ",
    meaning:
      "vị trí đứng trên hết, được coi là quan trọng hơn hết trong thứ tự xếp loại: nhiệm vụ số một * vai trò số một",
    example: "nhiệm vụ số một * vai trò số một",
  },
  {
    word: "số lượng",
    part_of_speech: "danh từ",
    meaning:
      "con số biểu thị sự có nhiều hay có ít: số lượng học sinh * tăng cả về số lượng lẫn chất lượng",
    example: "số lượng học sinh * tăng cả về số lượng lẫn chất lượng",
  },
  {
    word: "số là",
    part_of_speech: "kết từ",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị điều sắp nêu ra là nguyên do của tình hình không hay được nói đến (thường để nhằm mục đích thanh minh hoặc phân bua): số là hôm qua tôi bận, nên đã không đến được",
    example: "số là hôm qua tôi bận, nên đã không đến được",
  },
  {
    word: "sổ lòng",
    part_of_speech: "động từ",
    meaning: "vừa ra khỏi bụng mẹ hoặc vừa đẻ ra: đứa trẻ mới sổ lòng",
    example: "đứa trẻ mới sổ lòng",
  },
  {
    word: "số mệnh",
    part_of_speech: "danh từ",
    meaning:
      "những điều may rủi, hoạ phúc đã được tạo hoá định sẵn cho cuộc đời của mỗi người, theo quan niệm duy tâm (nói tổng quát): tin vào số mệnh * không chịu phục tùng số mệnh",
    example: "tin vào số mệnh * không chịu phục tùng số mệnh",
  },
  {
    word: "sỗ sàng",
    part_of_speech: "tính từ",
    meaning:
      'tỏ ra thiếu lịch sự một cách trắng trợn trong giao tiếp: thái độ sỗ sàng * "Ghế trên ngồi tót sỗ sàng, Buồng trong mối đã giục nàng kíp ra." (TKiều)',
    example:
      'thái độ sỗ sàng * "Ghế trên ngồi tót sỗ sàng, Buồng trong mối đã giục nàng kíp ra." (TKiều)',
  },
  {
    word: "số nhân",
    part_of_speech: "danh từ",
    meaning:
      "số được đem nhân với số bị nhân trong một phép nhân: trong phép tính 13 x 5 = 65, thì 5 là số nhân",
    example: "trong phép tính 13 x 5 = 65, thì 5 là số nhân",
  },
  {
    word: "số phức",
    part_of_speech: "danh từ",
    meaning: "tổng của một số thực với một số ảo: 3 + T là một số phức",
    example: "3 + T là một số phức",
  },
  {
    word: "số nhiều",
    part_of_speech: "danh từ",
    meaning:
      "phạm trù ngữ pháp số trong một số ngôn ngữ, biểu thị ý có trên một; đối lập với số ít: danh từ số nhiều trong tiếng Anh",
    example: "danh từ số nhiều trong tiếng Anh",
  },
  {
    word: "sổ tay",
    part_of_speech: "danh từ",
    meaning:
      "sổ nhỏ, thường mang theo người, dùng để ghi chép những điều cần thiết: ghi sổ tay * tặng bạn cuốn sổ tay",
    example: "ghi sổ tay * tặng bạn cuốn sổ tay",
  },
  {
    word: "sổ tay",
    part_of_speech: "danh từ",
    meaning:
      "sách cỡ nhỏ, dễ sử dụng, dùng để tra cứu những điều chỉ dẫn cần thiết về một chuyên ngành nào đó: sổ tay toán học * sổ tay chính tả",
    example: "sổ tay toán học * sổ tay chính tả",
  },
  {
    word: "số phận",
    part_of_speech: "danh từ",
    meaning:
      "phần hoạ phúc, sướng khổ (thường là hoạ nhiều hơn phúc) dành riêng cho cuộc đời của mỗi người đã được tạo hoá định sẵn từ trước, theo quan niệm duy tâm (nói khái quát): số phận hẩm hiu * oán trách số phận * vượt lên trên số phận",
    example: "số phận hẩm hiu * oán trách số phận * vượt lên trên số phận",
  },
  {
    word: "số phận",
    part_of_speech: "danh từ",
    meaning:
      "sự sống, sự tồn tại dành cho mỗi người, mỗi vật: kết liễu số phận tên tướng cướp * số phận ngắn ngủi của những bộ phim",
    example:
      "kết liễu số phận tên tướng cướp * số phận ngắn ngủi của những bộ phim",
  },
  {
    word: "số siêu việt",
    part_of_speech: "danh từ",
    meaning:
      "số không thể là nghiệm của bất kì đa thức nào với các hệ số nguyên; trái với số đại số: ( là một số siêu việt",
    example: "( là một số siêu việt",
  },
  {
    word: "sổ sách",
    part_of_speech: "danh từ",
    meaning:
      "sổ theo dõi các thông tin, số liệu (nói khái quát): sổ sách kế toán * kiểm tra sổ sách",
    example: "sổ sách kế toán * kiểm tra sổ sách",
  },
  {
    word: "sồ sề",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) từ gợi tả dáng vóc to béo một cách mất cân đối, không gọn gàng (thường nói về phụ nữ): thân hình to béo, sồ sề",
    example: "thân hình to béo, sồ sề",
  },
  {
    word: "số trừ",
    part_of_speech: "danh từ",
    meaning:
      "số được đem trừ vào số bị trừ trong một phép trừ: trong phép tính 25 - 7 = 18, thì 7 là số trừ",
    example: "trong phép tính 25 - 7 = 18, thì 7 là số trừ",
  },
  {
    word: "số thập phân",
    part_of_speech: "danh từ",
    meaning:
      "phân số thập phân viết dưới hình thức không có mẫu số và vạch ngang phân số, mà dùng một dấu phẩy đặt ở vị trí thích hợp trong tử số: 1,22 (= R) là một số thập phân",
    example: "1,22 (= R) là một số thập phân",
  },
  {
    word: "sổ toẹt",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) xoá bỏ hết, coi là không có chút giá trị gì: bài văn bị sổ toẹt * ý kiến đưa ra bị sổ toẹt",
    example: "bài văn bị sổ toẹt * ý kiến đưa ra bị sổ toẹt",
  },
  {
    word: "sổ thiên tào",
    part_of_speech: "danh từ",
    meaning:
      "sổ ghi số phận mỗi người do trời định, theo mê tín: bị gạch tên trong sổ thiên tào",
    example: "bị gạch tên trong sổ thiên tào",
  },
  {
    word: "sổ vàng",
    part_of_speech: "danh từ",
    meaning:
      "sổ dùng để ghi trang trọng tên những người có công lao hoặc những ý kiến, cảm tưởng của những người rất được coi trọng đối với một tổ chức, một cơ quan: có tên trong sổ vàng của nhà trường * ghi cảm tưởng vào sổ vàng",
    example: "có tên trong sổ vàng của nhà trường * ghi cảm tưởng vào sổ vàng",
  },
  {
    word: "số từ",
    part_of_speech: "danh từ",
    meaning:
      "từ chuyên biểu thị số lượng hoặc thứ tự (trong tiếng Việt là danh từ số lượng): ,  * ,  * ,  *  đều là số từ",
    example: ",  * ,  * ,  *  đều là số từ",
  },
  {
    word: "số vô tỷ",
    part_of_speech: "danh từ",
    meaning:
      "số được viết dưới dạng phân số thập phân vô hạn không tuần hoàn; phân biệt với số hữu tỉ: số pi (( = 3,1415926535...) là một số vô tỉ",
    example: "số pi (( = 3,1415926535...) là một số vô tỉ",
  },
  {
    word: "số vô tỉ",
    part_of_speech: "danh từ",
    meaning:
      "số được viết dưới dạng phân số thập phân vô hạn không tuần hoàn; phân biệt với số hữu tỉ: số pi (( = 3,1415926535...) là một số vô tỉ",
    example: "số pi (( = 3,1415926535...) là một số vô tỉ",
  },
  {
    word: "sốc",
    part_of_speech: "danh từ",
    meaning:
      "(cũng choáng) tình trạng toàn thân suy sụp đột ngột do rối loạn các chức năng sinh lí quan trọng, có thể dẫn tới tử vong: chấn thương nặng gây sốc * tử vong do sốc thuốc",
    example: "chấn thương nặng gây sốc * tử vong do sốc thuốc",
  },
  {
    word: "sốc",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) tình trạng tinh thần suy sụp đột ngột do tác động mạnh của những điều bất lợi đối với bản thân: cú sốc * bị sốc vì nghe tin dữ",
    example: "cú sốc * bị sốc vì nghe tin dữ",
  },
  {
    word: "sô vanh",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về chủ nghĩa sô vanh, có tính chất của chủ nghĩa sô vanh: tư tưởng sô vanh nước lớn",
    example: "tư tưởng sô vanh nước lớn",
  },
  {
    word: "sôi động",
    part_of_speech: "động từ",
    meaning:
      "ở trạng thái có nhiều biến động không ngừng: tình hình mỗi lúc một sôi động * nhịp sống sôi động",
    example: "tình hình mỗi lúc một sôi động * nhịp sống sôi động",
  },
  {
    word: "sôi gan",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) tức giận đến cao độ: tức sôi gan",
    example: "tức sôi gan",
  },
  {
    word: "sồi",
    part_of_speech: "danh từ",
    meaning:
      "hàng dệt bằng tơ ươm không đều, sợi có đoạn to đoạn nhỏ nên mặt xù xì: áo sồi",
    example: "áo sồi",
  },
  {
    word: "sôi",
    part_of_speech: "động từ",
    meaning:
      'chuyển nhanh từ trạng thái lỏng sang trạng thái khí ở một nhiệt độ nhất định, dưới một áp suất nhất định, biểu hiện bằng hiện tượng có bọt sủi và hơi bốc lên mạnh: nước sôi ở 100oC * "Chồng giận thì vợ bớt lời, Cơm sôi nhỏ lửa một đời không khê." (ca dao)',
    example:
      'nước sôi ở 100oC * "Chồng giận thì vợ bớt lời, Cơm sôi nhỏ lửa một đời không khê." (ca dao)',
  },
  {
    word: "sôi",
    part_of_speech: "động từ",
    meaning:
      "(bụng) có hiện tượng chất hơi chuyển động bên trong nghe thành tiếng, do đói hoặc do bị rối loạn tiêu hoá: bị sôi bụng",
    example: "bị sôi bụng",
  },
  {
    word: "sôi",
    part_of_speech: "động từ",
    meaning:
      "chuyển trạng thái đột ngột, trở thành có những biểu hiện rõ rệt, mạnh mẽ, tựa như có cái gì đang bừng lên, đang nổi lên: không khí cuộc họp sôi lên * giận sôi lên",
    example: "không khí cuộc họp sôi lên * giận sôi lên",
  },
  {
    word: "sổi",
    part_of_speech: "tính từ",
    meaning: "(súc vật cái) không có khả năng chửa đẻ: trâu sổi",
    example: "trâu sổi",
  },
  {
    word: "sôi máu",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) như sôi gan: chỉ nhìn thấy mặt nó đã đủ sôi máu lên rồi",
    example: "chỉ nhìn thấy mặt nó đã đủ sôi máu lên rồi",
  },
  {
    word: "sôi nổi",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra có khí thế mạnh mẽ, hào hứng: phát biểu rất sôi nổi * sôi nổi bàn tán",
    example: "phát biểu rất sôi nổi * sôi nổi bàn tán",
  },
  {
    word: "sôi nổi",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra hăng hái, đầy nhiệt tình trong các hoạt động (thường nói về tuổi trẻ): thời thanh niên sôi nổi * tính tình sôi nổi",
    example: "thời thanh niên sôi nổi * tính tình sôi nổi",
  },
  {
    word: "sôi sục",
    part_of_speech: "",
    meaning:
      "có biến động dâng lên mạnh mẽ: sôi sục căm thù * phong trào đấu tranh sôi sục",
    example: "sôi sục căm thù * phong trào đấu tranh sôi sục",
  },
  {
    word: "sồn sồn",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) (nói năng, hoạt động) ồn ào, vội vã, có vẻ nóng nảy: giục sồn sồn * hơi một tí là sồn sồn lên!",
    example: "giục sồn sồn * hơi một tí là sồn sồn lên!",
  },
  {
    word: "sồn sồn",
    part_of_speech: "tính từ",
    meaning:
      "(Phương ngữ) đã nhiều tuổi, nhưng chưa phải già: người đàn bà sồn sồn",
    example: "người đàn bà sồn sồn",
  },
  {
    word: "sôn sốt",
    part_of_speech: "động từ",
    meaning: "(cơ thể) hơi sốt: người hơi sôn sốt",
    example: "người hơi sôn sốt",
  },
  {
    word: "sổng",
    part_of_speech: "động từ",
    meaning:
      "thoát ra khỏi nơi bị nhốt, bị giam cầm, bị giữ lại: lợn sổng ra khỏi chuồng * để sổng mất con mồi",
    example: "lợn sổng ra khỏi chuồng * để sổng mất con mồi",
  },
  {
    word: "sống",
    part_of_speech: "danh từ",
    meaning:
      "cạnh dày của vật, ở phía đối lập với lưỡi, răng: sống dao * đập bằng sống cuốc",
    example: "sống dao * đập bằng sống cuốc",
  },
  {
    word: "sống",
    part_of_speech: "danh từ",
    meaning:
      "phần nổi gồ lên theo chiều dọc ở giữa một số vật: sống lá * sống lưng * sống mũi",
    example: "sống lá * sống lưng * sống mũi",
  },
  {
    word: "sống",
    part_of_speech: "động từ",
    meaning:
      "tồn tại ở hình thái có trao đổi chất với môi trường bên ngoài, có sinh đẻ, lớn lên và chết: cây cổ thụ đã sống gần hai trăm năm * cơ thể sống * chết đi sống lại",
    example:
      "cây cổ thụ đã sống gần hai trăm năm * cơ thể sống * chết đi sống lại",
  },
  {
    word: "sống",
    part_of_speech: "động từ",
    meaning:
      "ở thường xuyên tại nơi nào đó, trong môi trường nào đó, trải qua ở đấy cả cuộc đời hoặc một phần cuộc đời của mình: sống ở miền Nam * động vật sống dưới nước",
    example: "sống ở miền Nam * động vật sống dưới nước",
  },
  {
    word: "sống",
    part_of_speech: "động từ",
    meaning:
      "duy trì sự sống của mình bằng những phương tiện vật chất nào đó: kiếm sống * sống bằng nghề chài lưới",
    example: "kiếm sống * sống bằng nghề chài lưới",
  },
  {
    word: "sống",
    part_of_speech: "động từ",
    meaning:
      "sống kiểu nào đó hoặc sống trong hoàn cảnh, tình trạng nào đó: sống độc thân * sống một cuộc đời thanh bạch",
    example: "sống độc thân * sống một cuộc đời thanh bạch",
  },
  {
    word: "sống",
    part_of_speech: "động từ",
    meaning:
      "cư xử, ăn ở ở đời: biết cách sống * sống rất chu đáo với mọi người",
    example: "biết cách sống * sống rất chu đáo với mọi người",
  },
  {
    word: "sống",
    part_of_speech: "động từ",
    meaning:
      "tồn tại với con người, không mất đi: Bác Hồ sống mãi với non sông, đất nước",
    example: "Bác Hồ sống mãi với non sông, đất nước",
  },
  {
    word: "sống",
    part_of_speech: "tính từ",
    meaning: "ở trạng thái còn sống, chưa chết: bắt sống đem về * tế sống",
    example: "bắt sống đem về * tế sống",
  },
  {
    word: "sống",
    part_of_speech: "tính từ",
    meaning:
      "chưa được nấu chín: cơm sống * luộc rau vẫn còn sống * xà lách để ăn sống",
    example: "cơm sống * luộc rau vẫn còn sống * xà lách để ăn sống",
  },
  {
    word: "sống",
    part_of_speech: "tính từ",
    meaning:
      "(nguyên liệu) còn nguyên, chưa được chế biến: vôi sống * cao su sống",
    example: "vôi sống * cao su sống",
  },
  {
    word: "sống",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) chưa thuần thục, chưa đủ độ chín: câu văn còn rất sống",
    example: "câu văn còn rất sống",
  },
  {
    word: "sống",
    part_of_speech: "tính từ",
    meaning: "chưa tróc hết vỏ hoặc chưa vỡ hết hạt khi xay: gạo xay sống",
    example: "gạo xay sống",
  },
  {
    word: "sống",
    part_of_speech: "tính từ",
    meaning: "(Khẩu ngữ) (chiếm đoạt) một cách trắng trợn: cướp sống",
    example: "cướp sống",
  },
  {
    word: "sồn sột",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng khô, giòn, liên tiếp phát ra như khi gặm vào vật tươi, cứng: gãi sồn sột",
    example: "gãi sồn sột",
  },
  {
    word: "sồng",
    part_of_speech: "danh từ",
    meaning: "cây có lá dùng nhuộm vải màu nâu sẫm: áo nâu sồng * khăn sồng",
    example: "áo nâu sồng * khăn sồng",
  },
  {
    word: "sống chết",
    part_of_speech: "động từ",
    meaning:
      "sống hay chết, trong bất cứ hoàn cảnh nào, dù thế nào chăng nữa: thề sống chết có nhau * sống chết cũng phải làm cho xong",
    example: "thề sống chết có nhau * sống chết cũng phải làm cho xong",
  },
  {
    word: "sống chết",
    part_of_speech: "động từ",
    meaning:
      "có thái độ quyết liệt, một mất một còn: quyết sống chết với kẻ thù",
    example: "quyết sống chết với kẻ thù",
  },
  {
    word: "sống chết mặc bay",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) nói thái độ bỏ mặc một cách hoàn toàn vô trách nhiệm: sống chết mặc bay, mạnh ai người ấy lo",
    example: "sống chết mặc bay, mạnh ai người ấy lo",
  },
  {
    word: "sông cạn đá mòn",
    part_of_speech: "",
    meaning:
      '(văn chương) thiên nhiên thay đổi nhiều (thường dùng trong lời thề, để đối lập với ý lòng người vẫn không đổi thay): "Dù cho sông cạn đá mòn, Còn non, còn nước, hãy còn thề xưa." (TĐà; 7)',
    example:
      'Dù cho sông cạn đá mòn, Còn non, còn nước, hãy còn thề xưa." (TĐà; 7)',
  },
  {
    word: "sông",
    part_of_speech: "danh từ",
    meaning:
      "dòng nước tự nhiên tương đối lớn, chảy thường xuyên trên mặt đất, thuyền bè thường đi lại được: dòng sông * sông có khúc người có lúc (tng)",
    example: "dòng sông * sông có khúc người có lúc (tng)",
  },
  {
    word: "sống còn",
    part_of_speech: "động từ",
    meaning: "sống và tồn tại trên đời: vì sự sống còn của đất nước",
    example: "vì sự sống còn của đất nước",
  },
  {
    word: "sống còn",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất quan trọng quyết định đối với sự sống, sự tồn tại: quyền lợi sống còn * nhiệm vụ sống còn",
    example: "quyền lợi sống còn * nhiệm vụ sống còn",
  },
  {
    word: "sống động",
    part_of_speech: "tính từ",
    meaning:
      "sinh động, có những biểu hiện mạnh mẽ của sự sống: tranh vẽ rất sống động * hình ảnh sống động * âm thanh sống động",
    example: "tranh vẽ rất sống động * hình ảnh sống động * âm thanh sống động",
  },
  {
    word: "sống mái",
    part_of_speech: "động từ",
    meaning:
      "đấu tranh một mất một còn: quyết một trận sống mái * sống mái với kẻ thù",
    example: "quyết một trận sống mái * sống mái với kẻ thù",
  },
  {
    word: "sống mũi",
    part_of_speech: "danh từ",
    meaning:
      "phần nổi cao ở giữa mũi, chạy từ giữa hai mắt tới đầu mũi: sống mũi cao và thẳng",
    example: "sống mũi cao và thẳng",
  },
  {
    word: "sông ngô bể sở",
    part_of_speech: "",
    meaning:
      '(cũ, văn chương) như bể Sở sông Ngô: "Chồng chài, vợ lưới, con câu, Sông Ngô bể Sở biết đâu là nhà." (ca dao)',
    example:
      'Chồng chài, vợ lưới, con câu, Sông Ngô bể Sở biết đâu là nhà." (ca dao)',
  },
  {
    word: "sống lưng",
    part_of_speech: "danh từ",
    meaning:
      "đường nổi gồ ở giữa lưng theo dọc xương sống: sợ lạnh cả sống lưng * đánh gió dọc theo sống lưng",
    example: "sợ lạnh cả sống lưng * đánh gió dọc theo sống lưng",
  },
  {
    word: "sông ngòi",
    part_of_speech: "danh từ",
    meaning:
      "sông, về mặt là đường giao thông, vận chuyển (nói khái quát): sông ngòi chằng chịt",
    example: "sông ngòi chằng chịt",
  },
  {
    word: "sông nước",
    part_of_speech: "danh từ",
    meaning:
      "sông, về mặt là cảnh vật thiên nhiên, hoặc điều kiện sinh sống của con người (nói khái quát): ngắm cảnh sông nước * thạo nghề sông nước * dân sông nước",
    example: "ngắm cảnh sông nước * thạo nghề sông nước * dân sông nước",
  },
  {
    word: "sống nhăn",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) còn sống sờ sờ, chưa chết (hàm ý mỉa mai, hài hước): tên giết người vẫn còn sống nhăn",
    example: "tên giết người vẫn còn sống nhăn",
  },
  {
    word: "sống nhăn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) còn sống nguyên, chưa chín chút nào cả (hàm ý chê): cơm sống nhăn",
    example: "cơm sống nhăn",
  },
  {
    word: "sống sót",
    part_of_speech: "động từ",
    meaning:
      "còn sống sau một biến cố, một tai nạn lớn, trong khi những người cùng hoàn cảnh hầu như đã chết cả: may mắn sống sót sau vụ động đất * tàu đắm, không còn một ai sống sót",
    example:
      "may mắn sống sót sau vụ động đất * tàu đắm, không còn một ai sống sót",
  },
  {
    word: "sống sít",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (thức ăn, hoa quả) chưa chín (nói khái quát; hàm ý chê): cơm sống sít * ăn sống ăn sít",
    example: "cơm sống sít * ăn sống ăn sít",
  },
  {
    word: "sông núi",
    part_of_speech: "danh từ",
    meaning:
      'như núi sông: "Sông núi nước Nam vua Nam ở, Rành rành định phận ở sách trời." (NQSH)',
    example:
      'Sông núi nước Nam vua Nam ở, Rành rành định phận ở sách trời." (NQSH)',
  },
  {
    word: "sổng sểnh",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái cài buộc lỏng lẻo, không kĩ, không cẩn thận: cửa ngõ sổng sểnh * chuồng trại để sổng sểnh",
    example: "cửa ngõ sổng sểnh * chuồng trại để sổng sểnh",
  },
  {
    word: "sổng sểnh",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái không bị gò bó, kiềm chế, cấm đoán, mà được tự do, không phải giữ gìn: ăn nói sổng sểnh, không chút giữ gìn",
    example: "ăn nói sổng sểnh, không chút giữ gìn",
  },
  {
    word: "sộp",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) sang, tỏ ra nhiều tiền và hào phóng: vớ được món sộp * khách sộp",
    example: "vớ được món sộp * khách sộp",
  },
  {
    word: "sốt dẻo",
    part_of_speech: "tính từ",
    meaning:
      "(thức ăn) đang nóng, rất ngon do vừa mới được nấu xong: cơm canh sốt dẻo",
    example: "cơm canh sốt dẻo",
  },
  {
    word: "sốt dẻo",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) (tin tức) rất mới, vừa mới nhận được: tin sốt dẻo",
    example: "tin sốt dẻo",
  },
  {
    word: "sốt rét",
    part_of_speech: "danh từ",
    meaning:
      "bệnh lây do một loại kí sinh trùng truyền qua muỗi anophel gây nên những cơn rét, nóng có chu kì, gây đau đầu, đau xương sống, làm huỷ hoại nhiều hồng cầu: lên cơn sốt rét",
    example: "lên cơn sốt rét",
  },
  {
    word: "sống sượng",
    part_of_speech: "tính từ",
    meaning:
      "thiếu sự nhuần nhuyễn, không tự nhiên: câu văn sống sượng * hành động và lời thoại của nhân vật còn sống sượng",
    example:
      "câu văn sống sượng * hành động và lời thoại của nhân vật còn sống sượng",
  },
  {
    word: "sống sượng",
    part_of_speech: "tính từ",
    meaning:
      "(cử chỉ, nói năng) thiếu sự tế nhị, sự nhã nhặn tối thiểu: ăn nói sống sượng",
    example: "ăn nói sống sượng",
  },
  {
    word: "sống trâu",
    part_of_speech: "danh từ",
    meaning:
      "chỗ gồ cao lên theo chiều dọc của đường đất, hình như sống lưng con trâu: đường sống trâu",
    example: "đường sống trâu",
  },
  {
    word: "sốt lạnh",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (hàng hoá) giảm giá nhanh do tình trạng cung lớn hơn cầu: hàng nhập ồ ạt dẫn đến tình trạng sốt lạnh",
    example: "hàng nhập ồ ạt dẫn đến tình trạng sốt lạnh",
  },
  {
    word: "sốt ruột",
    part_of_speech: "động từ",
    meaning:
      "ở tâm trạng, trạng thái nôn nóng, không yên lòng: đợi lâu nên sốt ruột * nóng lòng sốt ruột",
    example: "đợi lâu nên sốt ruột * nóng lòng sốt ruột",
  },
  {
    word: "sốt",
    part_of_speech: "động từ",
    meaning:
      "tăng nhiệt độ cơ thể lên quá mức bình thường, do bị bệnh: cháu bé bị sốt * thuốc hạ sốt",
    example: "cháu bé bị sốt * thuốc hạ sốt",
  },
  {
    word: "sốt",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) tăng mạnh một cách đột ngột, nhất thời về nhu cầu hay giá cả: sốt vật liệu xây dựng * sốt đất",
    example: "sốt vật liệu xây dựng * sốt đất",
  },
  {
    word: "sốt",
    part_of_speech: "tính từ",
    meaning:
      "(Ít dùng) (cơm, canh) còn đang nóng, vừa mới bắc ở bếp xuống: cơm nóng canh sốt",
    example: "cơm nóng canh sốt",
  },
  {
    word: "sốt",
    part_of_speech: "trợ từ",
    meaning: "(Khẩu ngữ, Ít dùng) như sất: chẳng làm gì sốt!",
    example: "chẳng làm gì sốt!",
  },
  {
    word: "sốt sắng",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra quan tâm và tích cực muốn được làm ngay, thực hiện ngay một công việc nào đó: sốt sắng với công việc chung * sốt sắng nhận lời",
    example: "sốt sắng với công việc chung * sốt sắng nhận lời",
  },
  {
    word: "sốt xuất huyết",
    part_of_speech: "danh từ",
    meaning:
      "bệnh dịch do một loại virus gây nên, triệu chứng là sốt và chảy máu: bị sốt xuất huyết",
    example: "bị sốt xuất huyết",
  },
  {
    word: "sớ",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) thớ1: chẻ theo sớ gỗ",
    example: "chẻ theo sớ gỗ",
  },
  {
    word: "sớ",
    part_of_speech: "danh từ",
    meaning: "(cũ) tờ trình dâng lên vua, thường để báo cáo, đề nghị việc gì",
    example: "đốt sớ * viết lá sớ",
  },
  {
    word: "sột soạt",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng khua động nhẹ của những vật khô, mỏng, cứng khi chạm nhau: tiếng lá khô rơi sột soạt",
    example: "tiếng lá khô rơi sột soạt",
  },
  {
    word: "sốt sột",
    part_of_speech: "phụ từ",
    meaning: "(khẩu ngữ) ngay lập tức: làm sốt sột * đưa tin sốt sột",
    example: "làm sốt sột * đưa tin sốt sột",
  },
  {
    word: "sơ",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) dùng đũa khuấy qua cho đều nồi cơm đang sôi: sơ cơm",
    example: "sơ cơm",
  },
  {
    word: "sơ",
    part_of_speech: "tính từ",
    meaning:
      "(làm việc gì) lướt qua một lượt, không kĩ càng, đầy đủ: nắm sơ qua tình hình * chỉ biết sơ sơ",
    example: "nắm sơ qua tình hình * chỉ biết sơ sơ",
  },
  {
    word: "sơ",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) không có quan hệ gần gũi, thường là mới quen biết: kẻ thân người sơ * không phân biệt thân sơ",
    example: "kẻ thân người sơ * không phân biệt thân sơ",
  },
  {
    word: "sơ",
    part_of_speech: "tính từ",
    meaning: "(cũ) ở vào giai đoạn đầu, mới hình thành: thời Lê sơ",
    example: "thời Lê sơ",
  },
  {
    word: "sốt vó",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ở trạng thái cuống lên: lo đến sốt vó * giá cổ phiếu giảm mạnh làm nhiều nhà đầu tư sốt vó",
    example:
      "lo đến sốt vó * giá cổ phiếu giảm mạnh làm nhiều nhà đầu tư sốt vó",
  },
  {
    word: "sợ",
    part_of_speech: "động từ",
    meaning:
      "ở trong trạng thái không yên lòng vì cho rằng có cái gì đó trực tiếp gây nguy hiểm hoặc gây hại cho mình, mà tự thấy không thể chống lại hoặc không thể tránh khỏi: sợ ma * không dám làm vì sợ khó * điếc không sợ súng (tng)",
    example: "sợ ma * không dám làm vì sợ khó * điếc không sợ súng (tng)",
  },
  {
    word: "sợ",
    part_of_speech: "động từ",
    meaning:
      "không yên lòng do lường trước khả năng không hay nào đó: sợ tắc đường nên phải đi sớm * không dám làm cố vì sợ ốm",
    example: "sợ tắc đường nên phải đi sớm * không dám làm cố vì sợ ốm",
  },
  {
    word: "sợ",
    part_of_speech: "động từ",
    meaning:
      "từ dùng trong đối thoại để biểu thị ý khẳng định có phần dè dặt về điều ít nhiều không hay: tôi cứ sợ chị không về kịp * ít quá, sợ không đủ",
    example: "tôi cứ sợ chị không về kịp * ít quá, sợ không đủ",
  },
  {
    word: "sờ",
    part_of_speech: "động từ",
    meaning:
      "đặt và di động nhẹ bàn tay trên bề mặt của vật để nhận biết bằng xúc giác: sờ lên má * sờ tay lên vách",
    example: "sờ lên má * sờ tay lên vách",
  },
  {
    word: "sờ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) động đến, bắt tay làm: không bao giờ sờ đến việc nhà * sờ vào cái gì là hỏng cái ấy",
    example: "không bao giờ sờ đến việc nhà * sờ vào cái gì là hỏng cái ấy",
  },
  {
    word: "sở",
    part_of_speech: "danh từ",
    meaning:
      "cơ quan quản lí một ngành chuyên môn của nhà nước ở cấp tỉnh và thành phố: sở giáo dục * giám đốc sở",
    example: "sở giáo dục * giám đốc sở",
  },
  {
    word: "sở",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) tổ chức kinh doanh của nhà nước hay tư nhân thời trước: sở xe lửa",
    example: "sở xe lửa",
  },
  {
    word: "sở",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) công sở hoặc sở tư (nói tắt), trong quan hệ với nhân viên làm việc: bị thải hồi khỏi sở * đi bộ từ nhà đến sở",
    example: "bị thải hồi khỏi sở * đi bộ từ nhà đến sở",
  },
  {
    word: "sơ bộ",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất bước đầu, chuẩn bị cho bước tiếp theo đầy đủ hơn: tính sơ bộ * thảo luận sơ bộ",
    example: "tính sơ bộ * thảo luận sơ bộ",
  },
  {
    word: "sơ cấp",
    part_of_speech: "tính từ",
    meaning: "thuộc cấp thấp nhất, dưới trung cấp: trường sơ cấp dược",
    example: "trường sơ cấp dược",
  },
  {
    word: "sở cầu",
    part_of_speech: "danh từ",
    meaning: "(cũ) điều hằng mong muốn cho mình: được đúng như sở cầu",
    example: "được đúng như sở cầu",
  },
  {
    word: "sơ chế",
    part_of_speech: "động từ",
    meaning:
      "chế biến qua cho nguyên liệu trở thành bán thành phẩm: qua khâu sơ chế * thực phẩm đã sơ chế",
    example: "qua khâu sơ chế * thực phẩm đã sơ chế",
  },
  {
    word: "sở dĩ",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là nguyên nhân, lí do giải thích tại sao cho điều đã xảy ra: sở dĩ thi hỏng là vì lười học",
    example: "sở dĩ thi hỏng là vì lười học",
  },
  {
    word: "sở đoản",
    part_of_speech: "danh từ",
    meaning:
      "chỗ kém, chỗ yếu vốn có; phân biệt với sở trường: phát huy sở trường, khắc phục sở đoản",
    example: "phát huy sở trường, khắc phục sở đoản",
  },
  {
    word: "sơ đẳng",
    part_of_speech: "tính từ",
    meaning: "(cũ) thuộc bậc học thấp nhất: trường sơ đẳng",
    example: "trường sơ đẳng",
  },
  {
    word: "sơ đẳng",
    part_of_speech: "tính từ",
    meaning: "ở mức thấp nhất: kiến thức sơ đẳng * nguyên tắc pháp lí sơ đẳng",
    example: "kiến thức sơ đẳng * nguyên tắc pháp lí sơ đẳng",
  },
  {
    word: "sơ cứu",
    part_of_speech: "động từ",
    meaning: "cấp cứu sơ bộ: sơ cứu người bị bỏng * sơ cứu kịp thời",
    example: "sơ cứu người bị bỏng * sơ cứu kịp thời",
  },
  {
    word: "sở giao dịch",
    part_of_speech: "danh từ",
    meaning:
      "trung tâm buôn bán chứng khoán, hàng hoá lớn và sức lao động: sở giao dịch chứng khoán",
    example: "sở giao dịch chứng khoán",
  },
  {
    word: "sơ giản",
    part_of_speech: "tính từ",
    meaning: "(hiếm) sơ lược và đơn giản: một định nghĩa sơ giản",
    example: "một định nghĩa sơ giản",
  },
  {
    word: "sơ đồ",
    part_of_speech: "danh từ",
    meaning:
      "hình vẽ quy ước, có tính chất sơ lược, nhằm mô tả một đặc trưng nào đó của sự vật hay một quá trình nào đó: vẽ sơ đồ * sơ đồ phòng thủ",
    example: "vẽ sơ đồ * sơ đồ phòng thủ",
  },
  {
    word: "sơ học",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) cấp học thấp nhất trong hệ thống giáo dục thời Pháp thuộc: trường sơ học",
    example: "trường sơ học",
  },
  {
    word: "sợ hãi",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra rất sợ: tái mặt sợ hãi * tiếng quát làm đứa trẻ sợ hãi, khóc thét lên",
    example: "tái mặt sợ hãi * tiếng quát làm đứa trẻ sợ hãi, khóc thét lên",
  },
  {
    word: "sơ hở",
    part_of_speech: "",
    meaning:
      "sơ ý, không đề phòng cẩn thận: sơ hở một chút là hỏng việc * lợi dụng sơ hở trong quản lí để ăn cắp của công",
    example:
      "sơ hở một chút là hỏng việc * lợi dụng sơ hở trong quản lí để ăn cắp của công",
  },
  {
    word: "sở hữu",
    part_of_speech: "động từ",
    meaning:
      "chiếm hữu, sử dụng và hưởng thụ của cải vật chất trong xã hội: sở hữu tư liệu sản xuất * giấy chứng nhận quyền sở hữu đất",
    example: "sở hữu tư liệu sản xuất * giấy chứng nhận quyền sở hữu đất",
  },
  {
    word: "sở hữu",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ, hiếm) quyền sở hữu, sự sở hữu (nói tắt): căn hộ này thuộc sở hữu của anh ấy",
    example: "căn hộ này thuộc sở hữu của anh ấy",
  },
  {
    word: "sơ khai",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất của buổi đầu mới hình thành, mới được lập ra: thời kì sơ khai của xã hội * giai đoạn sơ khai",
    example: "thời kì sơ khai của xã hội * giai đoạn sơ khai",
  },
  {
    word: "sơ kết",
    part_of_speech: "động từ",
    meaning:
      "nhìn lại một cách tổng quát phần việc đã làm sau một thời kì nào đó để có sự đánh giá, rút ra những kết luận bước đầu: sơ kết học kì I * báo cáo sơ kết công tác sáu tháng đầu năm",
    example: "sơ kết học kì I * báo cáo sơ kết công tác sáu tháng đầu năm",
  },
  {
    word: "sở khanh",
    part_of_speech: "danh từ",
    meaning:
      'nhân vật trong Truyện Kiều của Nguyễn Du; dùng để chỉ người đàn ông chuyên gạ gẫm, lừa gạt phụ nữ: đồ sở khanh! * "Anh đây thật đấng trai lành, Chẳng thèm theo thói Sở Khanh phụ nàng." (ca dao)',
    example:
      'đồ sở khanh! * "Anh đây thật đấng trai lành, Chẳng thèm theo thói Sở Khanh phụ nàng." (ca dao)',
  },
  {
    word: "sơ khởi",
    part_of_speech: "tính từ",
    meaning: "(hiếm) thuộc bước đầu: giai đoạn sơ khởi * bước sơ khởi",
    example: "giai đoạn sơ khởi * bước sơ khởi",
  },
  {
    word: "sơ lược",
    part_of_speech: "tính từ",
    meaning:
      "chỉ trên những nét lớn, nét chính, bỏ qua các chi tiết nhỏ, không quan trọng: giới thiệu sơ lược * trình bày sơ lược * tóm tắt sơ lược",
    example: "giới thiệu sơ lược * trình bày sơ lược * tóm tắt sơ lược",
  },
  {
    word: "sơ lược",
    part_of_speech: "tính từ",
    meaning:
      "rất chung chung, không đi sâu vào từng điểm nhỏ nhất: thông tin mang tính sơ lược * hiểu một cách sơ lược",
    example: "thông tin mang tính sơ lược * hiểu một cách sơ lược",
  },
  {
    word: "sơ khảo",
    part_of_speech: "động từ",
    meaning: "(cũ) chấm lần thứ nhất trong khoa thi thời phong kiến.",
    example: "bị loại ngay từ vòng sơ khảo",
  },
  {
    word: "sờ lên gáy",
    part_of_speech: "",
    meaning:
      'tự nhìn lại chính mình (cũng sẽ thấy cái xấu mà mình tưởng chỉ người khác mới có): "Nói người chẳng nghĩ đến thân, Thử sờ lên gáy xem gần hay xa." (ca dao)',
    example:
      'Nói người chẳng nghĩ đến thân, Thử sờ lên gáy xem gần hay xa." (ca dao)',
  },
  {
    word: "sơ kỳ",
    part_of_speech: "danh từ",
    meaning:
      "giai đoạn đầu của một thời kì lịch sử hay của một chế độ xã hội: sơ kì đồ đồng * xã hội phong kiến sơ kì",
    example: "sơ kì đồ đồng * xã hội phong kiến sơ kì",
  },
  {
    word: "sơ kì",
    part_of_speech: "danh từ",
    meaning:
      "giai đoạn đầu của một thời kì lịch sử hay của một chế độ xã hội: sơ kì đồ đồng * xã hội phong kiến sơ kì",
    example: "sơ kì đồ đồng * xã hội phong kiến sơ kì",
  },
  {
    word: "sơ mi",
    part_of_speech: "danh từ",
    meaning: "áo kiểu Âu, cổ đứng hoặc cổ bẻ, có tay: mặc sơ mi",
    example: "mặc sơ mi",
  },
  {
    word: "sơ mi",
    part_of_speech: "danh từ",
    meaning:
      "chi tiết máy có dạng ống mỏng, có tác dụng bảo vệ: sơ mi xi lanh của động cơ đốt trong",
    example: "sơ mi xi lanh của động cơ đốt trong",
  },
  {
    word: "sở nguyện",
    part_of_speech: "danh từ",
    meaning: "(trang trọng) điều hằng mong muốn: đạt được sở nguyện",
    example: "đạt được sở nguyện",
  },
  {
    word: "sơ nhiễm",
    part_of_speech: "động từ",
    meaning:
      "bị tổn thương ban đầu ở một bộ phận cơ thể do vi khuẩn gây bệnh thâm nhập: sơ nhiễm lao * viêm phổi sơ nhiễm",
    example: "sơ nhiễm lao * viêm phổi sơ nhiễm",
  },
  {
    word: "sơ sẩy",
    part_of_speech: "động từ",
    meaning:
      "sơ ý để xảy ra điều đáng tiếc: đồ đạc sơ sẩy là bị mất * chỉ sơ sẩy một chút là hỏng việc",
    example: "đồ đạc sơ sẩy là bị mất * chỉ sơ sẩy một chút là hỏng việc",
  },
  {
    word: "sờ mó",
    part_of_speech: "động từ",
    meaning: "sờ vào (nói khái quát): cả ngày không sờ mó đến sách vở",
    example: "cả ngày không sờ mó đến sách vở",
  },
  {
    word: "sợ sệt",
    part_of_speech: "động từ",
    meaning:
      "sợ tới mức trở nên yếu hèn, bất lực: dáng điệu sợ sệt * ánh mắt sợ sệt",
    example: "dáng điệu sợ sệt * ánh mắt sợ sệt",
  },
  {
    word: "sơ sài",
    part_of_speech: "tính từ",
    meaning: "đơn sơ và ít ỏi: căn phòng bài trí sơ sài * vốn kiến thức sơ sài",
    example: "căn phòng bài trí sơ sài * vốn kiến thức sơ sài",
  },
  {
    word: "sơ sài",
    part_of_speech: "tính từ",
    meaning: "không đầy đủ so với yêu cầu, chỉ sơ qua cho có: bài làm sơ sài",
    example: "bài làm sơ sài",
  },
  {
    word: "sờ sẫm",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) rờ rẫm: ông lão mù sờ sẫm tìm gậy",
    example: "ông lão mù sờ sẫm tìm gậy",
  },
  {
    word: "sơ sinh",
    part_of_speech: "tính từ",
    meaning: "mới đẻ ra: trẻ sơ sinh * áo sơ sinh",
    example: "trẻ sơ sinh * áo sơ sinh",
  },
  {
    word: "sờ soạng",
    part_of_speech: "động từ",
    meaning:
      "sờ chỗ này chỗ khác để tìm, do mắt không nhìn thấy (nói khái quát): sờ soạng trong bóng tối * sờ soạng tìm diêm thắp đèn",
    example: "sờ soạng trong bóng tối * sờ soạng tìm diêm thắp đèn",
  },
  {
    word: "sơ sơ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) chỉ một phần nào, một chút ít thôi, không đáng kể: quen sơ sơ * biết sơ sơ * tính sơ sơ cũng hết triệu bạc",
    example: "quen sơ sơ * biết sơ sơ * tính sơ sơ cũng hết triệu bạc",
  },
  {
    word: "sơ sót",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như sai sót: kiểm tra xem có sơ sót gì không",
    example: "kiểm tra xem có sơ sót gì không",
  },
  {
    word: "sơ thảo",
    part_of_speech: "",
    meaning:
      "thảo ra lần đầu, còn phải được thêm bớt, sửa chữa cho hoàn chỉnh: bản sơ thảo * viết sơ thảo",
    example: "bản sơ thảo * viết sơ thảo",
  },
  {
    word: "sơ tán",
    part_of_speech: "động từ",
    meaning:
      "di chuyển người và của tạm thời ra khỏi khu vực không an toàn để tránh tai nạn, thường là tai nạn chiến tranh: sơ tán dân để tránh lũ * đi sơ tán",
    example: "sơ tán dân để tránh lũ * đi sơ tán",
  },
  {
    word: "sờ sợ",
    part_of_speech: "động từ",
    meaning: "có cảm giác hơi sợ: đi đêm một mình cũng thấy sờ sợ",
    example: "đi đêm một mình cũng thấy sờ sợ",
  },
  {
    word: "sờ sờ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) quá rõ ràng, như bày ra trước mắt: sờ sờ trước mắt mà không thấy * sự thật đã sờ sờ ra đấy",
    example: "sờ sờ trước mắt mà không thấy * sự thật đã sờ sờ ra đấy",
  },
  {
    word: "sở tại",
    part_of_speech: "tính từ",
    meaning:
      "thuộc nơi đang ở hoặc thuộc nơi xảy ra sự việc đang nói tới: chính quyền sở tại * nước sở tại",
    example: "chính quyền sở tại * nước sở tại",
  },
  {
    word: "sơ suất",
    part_of_speech: "",
    meaning:
      "không cẩn thận, không chú ý đúng mức để có sai sót: sơ suất trong khâu chế bản * sơ suất một chút là hỏng việc * có gì sơ suất, mong bác bỏ quá cho!",
    example:
      "sơ suất trong khâu chế bản * sơ suất một chút là hỏng việc * có gì sơ suất, mong bác bỏ quá cho!",
  },
  {
    word: "sơ thẩm",
    part_of_speech: "động từ",
    meaning: "xét xử lần đầu một vụ án ở cấp xử thấp nhất: phiên toà sơ thẩm",
    example: "phiên toà sơ thẩm",
  },
  {
    word: "sở thuộc",
    part_of_speech: "tính từ",
    meaning:
      "phạm trù ngữ pháp biểu thị mối quan hệ giữa chủ thể và cái thuộc về chủ thể đó: quan hệ sở thuộc * định ngữ sở thuộc",
    example: "quan hệ sở thuộc * định ngữ sở thuộc",
  },
  {
    word: "sở trường",
    part_of_speech: "danh từ",
    meaning:
      "chỗ mạnh, chỗ thành thạo, nổi trội vốn có; phân biệt với sở đoản: miếng võ sở trường * phát huy sở trường, khắc phục sở đoản",
    example: "miếng võ sở trường * phát huy sở trường, khắc phục sở đoản",
  },
  {
    word: "sở thích",
    part_of_speech: "danh từ",
    meaning:
      "ý thích riêng của mỗi người: tôn trọng sở thích cá nhân * làm theo sở thích",
    example: "tôn trọng sở thích cá nhân * làm theo sở thích",
  },
  {
    word: "sơ tuyển",
    part_of_speech: "động từ",
    meaning:
      "tuyển chọn vòng đầu theo những yêu cầu tối thiểu: bị loại ngay ở vòng sơ tuyển * các trường nghệ thuật tổ chức sơ tuyển",
    example:
      "bị loại ngay ở vòng sơ tuyển * các trường nghệ thuật tổ chức sơ tuyển",
  },
  {
    word: "sới",
    part_of_speech: "danh từ",
    meaning:
      "khoảng đất được bố trí làm nơi đấu vật hoặc chọi gà, chọi chim để tranh giải trong ngày hội: sới vật * hai đô vật bắt đầu ra sới * lên sới",
    example: "sới vật * hai đô vật bắt đầu ra sới * lên sới",
  },
  {
    word: "sơ yếu",
    part_of_speech: "danh từ",
    meaning: "bản tóm tắt những điểm chính: sơ yếu lí lịch",
    example: "sơ yếu lí lịch",
  },
  {
    word: "sởi",
    part_of_speech: "danh từ",
    meaning: "bệnh lây do virus, gây sốt phát ban: lên sởi",
    example: "lên sởi",
  },
  {
    word: "sơ ý",
    part_of_speech: "động từ",
    meaning:
      "không quan tâm, chú ý đến trong chốc lát nên để xảy ra điều đáng tiếc: sơ ý, làm vỡ phích nước * sơ ý nói lỡ lời",
    example: "sơ ý, làm vỡ phích nước * sơ ý nói lỡ lời",
  },
  {
    word: "sớm chiều",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian từ sáng sớm đến chiều tối; cả ngày, lúc nào cũng vậy: sớm chiều vất vả",
    example: "sớm chiều vất vả",
  },
  {
    word: "sớm hôm",
    part_of_speech: "danh từ",
    meaning: "như hôm sớm: tần tảo sớm hôm",
    example: "tần tảo sớm hôm",
  },
  {
    word: "sợi",
    part_of_speech: "danh từ",
    meaning:
      "nguyên liệu dài và mảnh, dùng để dệt, thêu, v.v., làm từ bông, lông thú, v.v.: sợi bông * sợi nylon * nhà máy sợi",
    example: "sợi bông * sợi nylon * nhà máy sợi",
  },
  {
    word: "sợi",
    part_of_speech: "danh từ",
    meaning:
      "từ chỉ chung những vật dài, nhỏ và mảnh: sợi chỉ * sợi tóc * kéo thành dạng sợi",
    example: "sợi chỉ * sợi tóc * kéo thành dạng sợi",
  },
  {
    word: "sợi chỉ đỏ",
    part_of_speech: "",
    meaning:
      "ví cái quán triệt từ đầu đến cuối và nổi bật (thường nói về tư tưởng, và với nghĩa tốt): chủ nghĩa nhân đạo là sợi chỉ đỏ xuyên suốt tác phẩm",
    example: "chủ nghĩa nhân đạo là sợi chỉ đỏ xuyên suốt tác phẩm",
  },
  {
    word: "sớm",
    part_of_speech: "danh từ",
    meaning: "khoảng thời gian lúc mặt trời mới mọc: đi từ sớm",
    example: "đi từ sớm",
  },
  {
    word: "sớm",
    part_of_speech: "tính từ",
    meaning:
      "(xảy ra) trước thời điểm quy định hay trước thời điểm thường lệ tương đối lâu: đi sớm về muộn * dậy sớm học bài * mùa mưa đến sớm",
    example: "đi sớm về muộn * dậy sớm học bài * mùa mưa đến sớm",
  },
  {
    word: "sớm mận tối đào",
    part_of_speech: "",
    meaning:
      '(cũ, văn chương) ví việc yêu đương không đứng đắn, nay với người này, mai với người khác: "Cho hay thục nữ chí cao, Phải người sớm mận, tối đào như ai?" (TKiều)',
    example:
      'Cho hay thục nữ chí cao, Phải người sớm mận, tối đào như ai?" (TKiều)',
  },
  {
    word: "sớm khuya",
    part_of_speech: "danh từ",
    meaning:
      'khoảng thời gian từ sáng sớm đến đêm khuya; suốt ngày: sớm khuya vất vả * "Sớm khuya gác gấm buồng thêu, Ngọc vàng mình phải nâng niu lấy mình." (HT)',
    example:
      'sớm khuya vất vả * "Sớm khuya gác gấm buồng thêu, Ngọc vàng mình phải nâng niu lấy mình." (HT)',
  },
  {
    word: "sớm mai",
    part_of_speech: "danh từ",
    meaning:
      '(phương ngữ) lúc sáng sớm: đi từ sớm mai * "Một năm được mấy mùa xuân, Một ngày được mấy giờ dần sớm mai." (ca dao)',
    example:
      'đi từ sớm mai * "Một năm được mấy mùa xuân, Một ngày được mấy giờ dần sớm mai." (ca dao)',
  },
  {
    word: "sớm muộn",
    part_of_speech: "tính từ",
    meaning:
      "không sớm thì muộn, thế nào cũng sẽ xảy ra: chuyện này, sớm muộn rồi mọi người cũng biết * sớm muộn gì hôm nay cũng phải xong",
    example:
      "chuyện này, sớm muộn rồi mọi người cũng biết * sớm muộn gì hôm nay cũng phải xong",
  },
  {
    word: "sơm sớm",
    part_of_speech: "tính từ",
    meaning:
      "hơi sớm hơn một chút (thường dùng trong lời yêu cầu, đề nghị): việc này nên làm sơm sớm đi",
    example: "việc này nên làm sơm sớm đi",
  },
  {
    word: "sờn",
    part_of_speech: "động từ",
    meaning:
      "bị xơ ra một ít trên bề mặt, có dấu hiệu sắp rách: áo sờn vai * sách sờn gáy",
    example: "áo sờn vai * sách sờn gáy",
  },
  {
    word: "sờn",
    part_of_speech: "động từ",
    meaning:
      "ở trạng thái tinh thần, ý chí bị lung lay, dao động trước khó khăn, thử thách: khó khăn chẳng sờn * dù nguy hiểm mấy cũng không sờn",
    example: "khó khăn chẳng sờn * dù nguy hiểm mấy cũng không sờn",
  },
  {
    word: "sớm sủa",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) sớm (nói khái quát): đi đi cho sớm sủa * hơn mười giờ rồi chứ sớm sủa gì!",
    example: "đi đi cho sớm sủa * hơn mười giờ rồi chứ sớm sủa gì!",
  },
  {
    word: "sớm tối",
    part_of_speech: "danh từ",
    meaning:
      'sớm cũng như tối; suốt ngày: sớm tối có nhau * "Tình khuê các gần xa lắm nỗi, Người quan sơn sớm tối một mình." (TTK)',
    example:
      'sớm tối có nhau * "Tình khuê các gần xa lắm nỗi, Người quan sơn sớm tối một mình." (TTK)',
  },
  {
    word: "sơn",
    part_of_speech: "danh từ",
    meaning:
      "cây cùng họ với xoài, lá kép lông chim, thân có nhựa dùng để chế một chất cũng gọi là sơn.",
    example: "sơn bóng * quét sơn * tốt gỗ hơn tốt nước sơn (tng)",
  },
  {
    word: "sơn",
    part_of_speech: "động từ",
    meaning:
      "quét sơn lên bề ngoài của đồ vật: sơn tường * sơn cửa * sơn lại chỗ xe bị xước",
    example: "sơn tường * sơn cửa * sơn lại chỗ xe bị xước",
  },
  {
    word: "sởn",
    part_of_speech: "động từ",
    meaning:
      "có cảm giác gai ốc nổi lên hay tóc gáy dựng đứng lên do bị lạnh hoặc do quá sợ hãi: lạnh sởn gai ốc",
    example: "lạnh sởn gai ốc",
  },
  {
    word: "sớm trưa",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) như sớm tối: "ớ người dãi gió dầm mưa!, Màn trời chiếu đất, sớm trưa nhọc nhằn." (ca dao)',
    example:
      'ớ người dãi gió dầm mưa!, Màn trời chiếu đất, sớm trưa nhọc nhằn." (ca dao)',
  },
  {
    word: "sơn cốc",
    part_of_speech: "danh từ",
    meaning: "(cũ) chỗ đất bằng ăn sâu vào núi: nơi sơn cốc",
    example: "nơi sơn cốc",
  },
  {
    word: "sơn cước",
    part_of_speech: "danh từ",
    meaning: "chân núi: vùng sơn cước",
    example: "vùng sơn cước",
  },
  {
    word: "sơn cước",
    part_of_speech: "danh từ",
    meaning: "miền núi, nói chung: dân sơn cước",
    example: "dân sơn cước",
  },
  {
    word: "sơn ca",
    part_of_speech: "danh từ",
    meaning:
      "chim chiền chiện; cũng dùng để ví giọng hát hay: chim sơn ca * giọng sơn ca",
    example: "chim sơn ca * giọng sơn ca",
  },
  {
    word: "sơn dã",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) nơi rừng núi hoặc đồng ruộng, trong quan hệ đối lập với nơi thành thị: chốn sơn dã",
    example: "chốn sơn dã",
  },
  {
    word: "sơn hà",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) núi sông; thường dùng để chỉ đất đai thuộc chủ quyền của một nước: "Ghé vai gánh đỡ sơn hà, Sao cho tỏ mặt mới là trượng phu." (ca dao)',
    example:
      'Ghé vai gánh đỡ sơn hà, Sao cho tỏ mặt mới là trượng phu." (ca dao)',
  },
  {
    word: "sơn hà xã tắc",
    part_of_speech: "",
    meaning:
      "(cũ, văn chương) sơn hà và xã tắc (nói gộp); dùng để chỉ đất nước, những gì thuộc về chủ quyền của một nước: sơn hà xã tắc lâm nguy",
    example: "sơn hà xã tắc lâm nguy",
  },
  {
    word: "sơn dầu",
    part_of_speech: "danh từ",
    meaning:
      "chất liệu hội hoạ, nhão, hơi quánh, không hoà tan trong nước, chế từ màu bột và dầu ép, thường dùng vẽ tranh: vẽ bằng sơn dầu",
    example: "vẽ bằng sơn dầu",
  },
  {
    word: "sơn dầu",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) tranh sơn dầu (nói tắt): bức sơn dầu",
    example: "bức sơn dầu",
  },
  {
    word: "sơn khê",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) núi và khe (nói khái quát); chỉ miền núi non hiểm trở: chốn sơn khê * "Liêu dương cách trở sơn khê, Xuân đường kíp gọi Sinh về hộ tang." (TKiều)',
    example:
      'chốn sơn khê * "Liêu dương cách trở sơn khê, Xuân đường kíp gọi Sinh về hộ tang." (TKiều)',
  },
  {
    word: "sởn gáy",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) sợ đến mức có cảm giác như tóc gáy dựng lên: nhìn mà sởn gáy",
    example: "nhìn mà sởn gáy",
  },
  {
    word: "sơn lam chướng khí",
    part_of_speech: "",
    meaning: "chướng khí (nói khái quát): vùng đất đầy sơn lam chướng khí",
    example: "vùng đất đầy sơn lam chướng khí",
  },
  {
    word: "sơn lâm",
    part_of_speech: "danh từ",
    meaning: "(cũ) núi rừng: chốn sơn lâm",
    example: "chốn sơn lâm",
  },
  {
    word: "sơn hào hải vị",
    part_of_speech: "",
    meaning:
      "thức ăn ngon và lạ, như sơn hào, hải vị, v.v. (nói khái quát): thưởng thức sơn hào hải vị",
    example: "thưởng thức sơn hào hải vị",
  },
  {
    word: "sờn lòng",
    part_of_speech: "động từ",
    meaning:
      "lung lay, dao động trước khó khăn, thử thách: nản chí sờn lòng * gian khổ không sờn lòng",
    example: "nản chí sờn lòng * gian khổ không sờn lòng",
  },
  {
    word: "sơn mài",
    part_of_speech: "danh từ",
    meaning:
      "chất liệu hội hoạ, trong và bóng, chế từ nhựa sơn, thường dùng vẽ tranh: vẽ sơn mài",
    example: "vẽ sơn mài",
  },
  {
    word: "sơn mài",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) tranh sơn mài (nói tắt): bức sơn mài",
    example: "bức sơn mài",
  },
  {
    word: "sơn son thếp vàng",
    part_of_speech: "",
    meaning:
      "(đồ vật) được phủ sơn màu đỏ và được thếp vàng trên hoa văn, chữ viết, v.v.: đôi câu đối sơn son thếp vàng",
    example: "đôi câu đối sơn son thếp vàng",
  },
  {
    word: "sơn phòng",
    part_of_speech: "động từ",
    meaning: "phòng thủ miền rừng núi: đồn sơn phòng",
    example: "đồn sơn phòng",
  },
  {
    word: "sơn nữ",
    part_of_speech: "danh từ",
    meaning: "(văn chương) người con gái miền núi: người sơn nữ",
    example: "người sơn nữ",
  },
  {
    word: "sơn son thiếp vàng",
    part_of_speech: "",
    meaning:
      "(đồ vật) được phủ sơn màu đỏ và được thếp vàng trên hoa văn, chữ viết, v.v.: đôi câu đối sơn son thếp vàng",
    example: "đôi câu đối sơn son thếp vàng",
  },
  {
    word: "sởn sơ",
    part_of_speech: "tính từ",
    meaning: "rất tươi tắn: mặt mũi sởn sơ",
    example: "mặt mũi sởn sơ",
  },
  {
    word: "sơn thần",
    part_of_speech: "danh từ",
    meaning: "thần núi: miếu thờ sơn thần",
    example: "miếu thờ sơn thần",
  },
  {
    word: "sơn thuỷ",
    part_of_speech: "danh từ",
    meaning:
      "núi và nước (nói khái quát); chỉ cảnh đẹp thiên nhiên: bức tranh sơn thuỷ * ngao du sơn thuỷ",
    example: "bức tranh sơn thuỷ * ngao du sơn thuỷ",
  },
  {
    word: "sơn thuỷ hữu tình",
    part_of_speech: "",
    meaning:
      'cảnh sông núi tươi đẹp, hài hoà, dễ làm rung động lòng người: "Ở đây sơn thuỷ hữu tình, Có thuyền, có bến, có mình, có ta." (ca dao)',
    example:
      'Ở đây sơn thuỷ hữu tình, Có thuyền, có bến, có mình, có ta." (ca dao)',
  },
  {
    word: "stator",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận cố định (không quay) trong máy phát điện: stator của turbin thuỷ lực",
    example: "stator của turbin thuỷ lực",
  },
  {
    word: "sớt",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) sẻ: sớt bát nước làm hai",
    example: "sớt bát nước làm hai",
  },
  {
    word: "sớt",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) rơi ra một vài giọt: nước sớt ra bàn",
    example: "nước sớt ra bàn",
  },
  {
    word: "sơn tràng",
    part_of_speech: "danh từ",
    meaning: "nghề khai thác rừng theo lối thủ công: thợ sơn tràng",
    example: "thợ sơn tràng",
  },
  {
    word: "stereo",
    part_of_speech: "danh từ",
    meaning:
      "kĩ thuật thu và phát lại âm thanh qua hai kênh, khi phát tạo ra cảm giác phân biệt được các nguồn âm khác nhau trong không gian; phân biệt với mono: thu stereo * âm thanh stereo",
    example: "thu stereo * âm thanh stereo",
  },
  {
    word: "stop",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) dừng lại: stop! mai làm tiếp!",
    example: "stop! mai làm tiếp!",
  },
  {
    word: "sú",
    part_of_speech: "danh từ",
    meaning:
      "cây bụi, lá dày, quả hình lưỡi liềm, hạt mọc rễ khi quả còn ở trên cành, thường mọc ở vùng bùn lầy nước lợ ven biển: bãi sú",
    example: "bãi sú",
  },
  {
    word: "sú",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) trộn với nước rồi khuấy đều hoặc nhào kĩ: sú bột làm bánh * sú cám heo",
    example: "sú bột làm bánh * sú cám heo",
  },
  {
    word: "stress",
    part_of_speech: "danh từ",
    meaning:
      "tổng thể nói chung những sự rối loạn tâm sinh lí xảy ra đột ngột do nhiều nguyên nhân khác nhau (sốc, xúc động mạnh, lao lực quá sức, v.v.): bị stress vì công việc quá căng thẳng * giải toả stress",
    example: "bị stress vì công việc quá căng thẳng * giải toả stress",
  },
  {
    word: "sụ",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) to, lớn quá cỡ: xách một va li to sụ * nhà giàu sụ",
    example: "xách một va li to sụ * nhà giàu sụ",
  },
  {
    word: "sủa",
    part_of_speech: "động từ",
    meaning:
      "(chó) kêu to, thường khi đánh hơi thấy có người hay vật lạ: chó sủa gâu gâu",
    example: "chó sủa gâu gâu",
  },
  {
    word: "suất",
    part_of_speech: "danh từ",
    meaning:
      "phần chia cho từng người theo mức đã định: mua một suất cơm * suất học bổng",
    example: "mua một suất cơm * suất học bổng",
  },
  {
    word: "sù sụ",
    part_of_speech: "tính từ",
    meaning: "từ mô phỏng tiếng ho trầm, thành cơn dài: ho sù sụ cả đêm",
    example: "ho sù sụ cả đêm",
  },
  {
    word: "sục",
    part_of_speech: "động từ",
    meaning:
      "thọc sâu vào nơi nào đó, làm khuấy lộn lên: mũi khoan sục sâu vào lòng đất * con lợn sục mõm vào chậu cám",
    example: "mũi khoan sục sâu vào lòng đất * con lợn sục mõm vào chậu cám",
  },
  {
    word: "sục",
    part_of_speech: "động từ",
    meaning:
      "xông vào bất cứ đâu, kể cả những chỗ kín đáo, bất cứ chỗ nào cảm thấy khả nghi để tìm kiếm: sục khắp nơi mà không thấy * sục vào tận nhà để tìm",
    example: "sục khắp nơi mà không thấy * sục vào tận nhà để tìm",
  },
  {
    word: "súc",
    part_of_speech: "danh từ",
    meaning:
      "khối to còn nguyên, chưa xẻ hoặc pha ra: súc gỗ * một súc thịt lợn",
    example: "súc gỗ * một súc thịt lợn",
  },
  {
    word: "súc",
    part_of_speech: "danh từ",
    meaning: "khối gồm nhiều tấm vải hay nhiều buộc sợi: súc sợi * súc vải",
    example: "súc sợi * súc vải",
  },
  {
    word: "súc",
    part_of_speech: "động từ",
    meaning:
      "làm cho sạch bằng cách cho nước vào và làm cho nước chuyển động mạnh theo đủ các hướng: súc miệng bằng nước muối * súc chai cho sạch",
    example: "súc miệng bằng nước muối * súc chai cho sạch",
  },
  {
    word: "súc sinh",
    part_of_speech: "danh từ",
    meaning:
      "súc vật; thường dùng làm tiếng chửi hoặc chỉ kẻ hèn hạ, không còn nhân cách: đồ súc sinh!",
    example: "đồ súc sinh!",
  },
  {
    word: "súc sắc",
    part_of_speech: "danh từ",
    meaning:
      "khối vuông nhỏ có sáu mặt, chấm số từ một đến sáu, dùng trong một số loại trò chơi, cờ bạc: quân súc sắc * gieo súc sắc",
    example: "quân súc sắc * gieo súc sắc",
  },
  {
    word: "súc sản",
    part_of_speech: "danh từ",
    meaning: "sản phẩm thịt gia súc: hàng súc sản * công ti xuất khẩu súc sản",
    example: "hàng súc sản * công ti xuất khẩu súc sản",
  },
  {
    word: "sục sạo",
    part_of_speech: "động từ",
    meaning:
      "sục hết chỗ này đến chỗ khác để tìm kiếm: con chó sục sạo trong các bụi rậm * sục sạo tìm kiếm",
    example: "con chó sục sạo trong các bụi rậm * sục sạo tìm kiếm",
  },
  {
    word: "sục bùn",
    part_of_speech: "động từ",
    meaning:
      "làm cho bùn bị khuấy lên để đất được thoáng, nhằm giúp lúa đẻ nhánh nhanh, sinh trưởng tốt: làm cỏ sục bùn",
    example: "làm cỏ sục bùn",
  },
  {
    word: "súc tích",
    part_of_speech: "tính từ",
    meaning:
      "có chứa nhiều ý trong một hình thức diễn đạt ngắn gọn: văn viết cô đọng, súc tích",
    example: "văn viết cô đọng, súc tích",
  },
  {
    word: "sùi",
    part_of_speech: "động từ",
    meaning:
      "nổi bọt lên thành từng đám: cốc bia sùi bọt ra ngoài * nói sùi bọt mép",
    example: "cốc bia sùi bọt ra ngoài * nói sùi bọt mép",
  },
  {
    word: "sùi",
    part_of_speech: "động từ",
    meaning: "nổi lên thành những nốt nhỏ trên bề mặt: mặt sùi trứng cá",
    example: "mặt sùi trứng cá",
  },
  {
    word: "súc vật",
    part_of_speech: "danh từ",
    meaning:
      "thú vật nuôi trong nhà; cũng thường dùng làm tiếng chửi: tiêm phòng cho súc vật * quân súc vật! (tiếng chửi)",
    example: "tiêm phòng cho súc vật * quân súc vật! (tiếng chửi)",
  },
  {
    word: "sủi",
    part_of_speech: "động từ",
    meaning:
      "nổi tăm hoặc nổi bọt trên bề mặt: sủi bọt * ấm nước trên bếp đã sủi tăm",
    example: "sủi bọt * ấm nước trên bếp đã sủi tăm",
  },
  {
    word: "sui",
    part_of_speech: "danh từ",
    meaning:
      "cây to ở rừng, thân tròn thẳng, có nhựa độc, gỗ nhẹ, vỏ cây có thể dùng làm chăn đắp: chăn sui",
    example: "chăn sui",
  },
  {
    word: "sui",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) sui gia (nói tắt): làm sui với nhau * bà sui",
    example: "làm sui với nhau * bà sui",
  },
  {
    word: "sui gia",
    part_of_speech: "danh từ",
    meaning:
      '(phương ngữ) thông gia: "Sui gia đã xứng sui gia, Rày mừng hai họ một nhà thành thân." (LVT)',
    example:
      'Sui gia đã xứng sui gia, Rày mừng hai họ một nhà thành thân." (LVT)',
  },
  {
    word: "sùi sụt",
    part_of_speech: "động từ",
    meaning: "như sụt sùi: mưa dầm sùi sụt",
    example: "mưa dầm sùi sụt",
  },
  {
    word: "sum sê",
    part_of_speech: "tính từ",
    meaning:
      "(cây cối) có nhiều cành lá rậm rạp, tươi tốt: cây trái sum sê * cây đa cổ thụ, cành lá sum sê",
    example: "cây trái sum sê * cây đa cổ thụ, cành lá sum sê",
  },
  {
    word: "sum họp",
    part_of_speech: "động từ",
    meaning:
      'tụ họp tại một chỗ một cách vui vẻ, sau một thời gian phải sống xa nhau: gia đình sum họp * "Ông tơ ghét bỏ chi nhau, Chưa vui sum họp đã sầu chia phôi!" (TKiều)',
    example:
      'gia đình sum họp * "Ông tơ ghét bỏ chi nhau, Chưa vui sum họp đã sầu chia phôi!" (TKiều)',
  },
  {
    word: "sụm",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) sụp xuống: người đổ sụm xuống vì kiệt sức",
    example: "người đổ sụm xuống vì kiệt sức",
  },
  {
    word: "sùm sụp",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái hạ xuống hoặc cụp xuống quá thấp, khó coi: đội mũ sùm sụp * mi mắt sùm sụp",
    example: "đội mũ sùm sụp * mi mắt sùm sụp",
  },
  {
    word: "sum vầy",
    part_of_speech: "động từ",
    meaning:
      '(văn chương) như sum họp: trúc mai sum vầy * "Những mong cá nước sum vầy, Bao ngờ đôi ngả nước mây cách vời." (CPN)',
    example:
      'trúc mai sum vầy * "Những mong cá nước sum vầy, Bao ngờ đôi ngả nước mây cách vời." (CPN)',
  },
  {
    word: "sụn",
    part_of_speech: "danh từ",
    meaning: "xương non và mềm, thường ở đầu các khớp xương: xương sụn",
    example: "xương sụn",
  },
  {
    word: "sụn",
    part_of_speech: "động từ",
    meaning:
      "(xương) đau mỏi đến mức như muốn sụp xuống, không gượng nổi: đau sụn lưng * hai đầu gối nhủn ra, chỉ muốn sụn xuống",
    example: "đau sụn lưng * hai đầu gối nhủn ra, chỉ muốn sụn xuống",
  },
  {
    word: "sún",
    part_of_speech: "động từ",
    meaning:
      '(Phương ngữ) mớm: "Nhớ hồi mẹ đẻ thiếp ra, Nhai cơm sún nước, lớn mà chừng ni." (Cdao)',
    example:
      'Nhớ hồi mẹ đẻ thiếp ra, Nhai cơm sún nước, lớn mà chừng ni." (Cdao)',
  },
  {
    word: "sún",
    part_of_speech: "tính từ",
    meaning:
      "(răng ở trẻ em) bị gãy, rụng mà chưa mọc răng mới, vẫn trống một chỗ: em bé bị sún hai cái răng cửa * nhe hàm răng sún ra cười",
    example: "em bé bị sún hai cái răng cửa * nhe hàm răng sún ra cười",
  },
  {
    word: "sung",
    part_of_speech: "danh từ",
    meaning:
      "cây to cùng họ với đa, không có rễ phụ, quả mọc từng chùm trên thân và các cành to, khi chín màu đỏ, ăn được: lòng vả cũng như lòng sung (tng)",
    example: "lòng vả cũng như lòng sung (tng)",
  },
  {
    word: "sung",
    part_of_speech: "động từ",
    meaning:
      "nhận một chức vụ hoặc cương vị nào đó như một thành viên của tổ chức: sung vào đội bóng đá * sung chức",
    example: "sung vào đội bóng đá * sung chức",
  },
  {
    word: "sung",
    part_of_speech: "động từ",
    meaning: "nhập vào làm của công: tiền thừa sung quỹ",
    example: "tiền thừa sung quỹ",
  },
  {
    word: "sùng",
    part_of_speech: "danh từ",
    meaning: "sâu sống ở dưới đất, thường phá hoại hoa màu: khoai lang bị sùng",
    example: "khoai lang bị sùng",
  },
  {
    word: "sùng",
    part_of_speech: "động từ",
    meaning:
      "kính trọng hay ưa chuộng và tin theo: một người sùng đạo * sùng hàng ngoại",
    example: "một người sùng đạo * sùng hàng ngoại",
  },
  {
    word: "sủng ái",
    part_of_speech: "động từ",
    meaning:
      "(cũ) yêu và nuông chiều hết sức (thường nói về quan hệ của vua chúa đối với cung phi): được nhà vua sủng ái",
    example: "được nhà vua sủng ái",
  },
  {
    word: "sũng",
    part_of_speech: "tính từ",
    meaning:
      "ướt đầy nước đến mức nước chảy cả ra ngoài vì không thấm vào được nữa: quần áo ướt sũng * đôi giày sũng nước",
    example: "quần áo ướt sũng * đôi giày sũng nước",
  },
  {
    word: "súng",
    part_of_speech: "danh từ",
    meaning:
      "cây mọc dưới nước, lá nổi trên mặt nước, hoa to, màu tím, trắng hoặc hồng, củ có thể ăn được: hoa súng * đen như củ súng",
    example: "hoa súng * đen như củ súng",
  },
  {
    word: "súng",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi chung các vũ khí có nòng hình ống: bắn một phát súng * khoác súng lên vai",
    example: "bắn một phát súng * khoác súng lên vai",
  },
  {
    word: "sùng bái",
    part_of_speech: "động từ",
    meaning:
      "kính phục đến mức như tôn thờ: sùng bái đạo Phật * tâm lí sùng bái hàng ngoại",
    example: "sùng bái đạo Phật * tâm lí sùng bái hàng ngoại",
  },
  {
    word: "sung công",
    part_of_speech: "động từ",
    meaning:
      "nhập vào làm của công do quyết định của cơ quan có thẩm quyền: sung công toàn bộ tài sản bất chính",
    example: "sung công toàn bộ tài sản bất chính",
  },
  {
    word: "sùng cổ",
    part_of_speech: "động từ",
    meaning: "coi trọng, yêu thích những gì thuộc về thời xưa: người sùng cổ",
    example: "người sùng cổ",
  },
  {
    word: "súng hơi",
    part_of_speech: "danh từ",
    meaning:
      "súng bắn đạn chì bằng lực đẩy của không khí bị nén trong xi lanh ở thân súng: xách súng hơi đi săn",
    example: "xách súng hơi đi săn",
  },
  {
    word: "sùng đạo",
    part_of_speech: "động từ",
    meaning:
      "có lòng tin tuyệt đối đối với tôn giáo mà mình theo: một tín đồ sùng đạo",
    example: "một tín đồ sùng đạo",
  },
  {
    word: "sung huyết",
    part_of_speech: "động từ",
    meaning:
      "ứ máu một cách bất thường do mạch máu bị dãn ở một vùng nào đó của cơ thể: sung huyết não",
    example: "sung huyết não",
  },
  {
    word: "sùng kính",
    part_of_speech: "động từ",
    meaning: "(văn chương) hết sức tôn kính: sùng kính nhà vua",
    example: "sùng kính nhà vua",
  },
  {
    word: "sùng ngoại",
    part_of_speech: "động từ",
    meaning:
      "ham chuộng quá mức những thứ của nước ngoài: tư tưởng sùng ngoại * tâm lí sùng ngoại",
    example: "tư tưởng sùng ngoại * tâm lí sùng ngoại",
  },
  {
    word: "sung mãn",
    part_of_speech: "tính từ",
    meaning:
      "(văn chương) ở trạng thái phát triển đầy đủ nhất: vẻ mặt đầy sung mãn * đang ở giai đoạn sung mãn",
    example: "vẻ mặt đầy sung mãn * đang ở giai đoạn sung mãn",
  },
  {
    word: "súng ống",
    part_of_speech: "danh từ",
    meaning:
      "súng các loại (nói khái quát): trang bị đầy đủ súng ống * kiểm tra lại súng ống, đạn dược",
    example: "trang bị đầy đủ súng ống * kiểm tra lại súng ống, đạn dược",
  },
  {
    word: "sùng sục",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả tiếng như tiếng nước đang sôi mạnh: nồi bánh chưng sôi sùng sục * nước sôi sùng sục",
    example: "nồi bánh chưng sôi sùng sục * nước sôi sùng sục",
  },
  {
    word: "sùng sục",
    part_of_speech: "tính từ",
    meaning:
      'từ gợi tả khí thế mạnh mẽ của một hoạt động như không có gì ngăn cản được: khí thế sùng sục của ngày ra quân * "Thị thấy lòng sôi lên sùng sục, thị giậm chân bành bạch kêu trời." (NCao; 11)',
    example:
      'khí thế sùng sục của ngày ra quân * "Thị thấy lòng sôi lên sùng sục, thị giậm chân bành bạch kêu trời." (NCao; 11)',
  },
  {
    word: "sung sức",
    part_of_speech: "tính từ",
    meaning: "có sức lực dồi dào: đang độ sung sức * một cây bút sung sức",
    example: "đang độ sung sức * một cây bút sung sức",
  },
  {
    word: "sùng tín",
    part_of_speech: "động từ",
    meaning: "tin theo hoàn toàn một tôn giáo nào đó: sùng tín đạo Phật",
    example: "sùng tín đạo Phật",
  },
  {
    word: "sung sướng",
    part_of_speech: "tính từ",
    meaning:
      "ở trong trạng thái vui vẻ, thích thú, cảm thấy được thoả mãn về vật chất hoặc tinh thần: sống sung sướng * nở nụ cười sung sướng",
    example: "sống sung sướng * nở nụ cười sung sướng",
  },
  {
    word: "sung túc",
    part_of_speech: "tính từ",
    meaning: "đầy đủ về vật chất: đời sống ngày càng sung túc",
    example: "đời sống ngày càng sung túc",
  },
  {
    word: "suối",
    part_of_speech: "danh từ",
    meaning:
      "dòng nước tự nhiên ở miền đồi núi, chảy thường xuyên hoặc theo mùa, do nước mưa hoặc nước ngầm chảy ra ngoài mặt đất tạo nên: trèo đèo lội suối",
    example: "trèo đèo lội suối",
  },
  {
    word: "suối vàng",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) âm phủ: "Suối vàng hồn mẹ có linh, Chứng cho con trẻ lòng thành ngày nay." (LVT)',
    example:
      'Suối vàng hồn mẹ có linh, Chứng cho con trẻ lòng thành ngày nay." (LVT)',
  },
  {
    word: "suôn",
    part_of_speech: "tính từ",
    meaning:
      'thẳng liền một đường dài và trơn tru: mái tóc suôn dài * "Chim rừng ai dạy mà khôn, Cây suôn ai uốn, trái tròn ai vo." (ca dao)',
    example:
      'mái tóc suôn dài * "Chim rừng ai dạy mà khôn, Cây suôn ai uốn, trái tròn ai vo." (ca dao)',
  },
  {
    word: "suông",
    part_of_speech: "tính từ",
    meaning:
      "(làm việc gì) thiếu hẳn đi cái thật ra là nội dung quan trọng, nên gây cảm giác nhạt nhẽo, vô vị: uống rượu suông * canh cần nấu suông",
    example: "uống rượu suông * canh cần nấu suông",
  },
  {
    word: "suông",
    part_of_speech: "tính từ",
    meaning:
      "(ánh trăng) sáng mà không tỏ, không trông thấy mặt trăng, gây cảm giác lạnh lẽo, buồn tẻ: sáng trăng suông",
    example: "sáng trăng suông",
  },
  {
    word: "suông",
    part_of_speech: "tính từ",
    meaning:
      "chỉ nói mà không làm: toàn hứa suông * lí thuyết suông * hô khẩu hiệu suông",
    example: "toàn hứa suông * lí thuyết suông * hô khẩu hiệu suông",
  },
  {
    word: "suôn sẻ",
    part_of_speech: "tính từ",
    meaning:
      "trôi chảy, không có khó khăn, vấp váp: mọi việc đều suôn sẻ * vượt qua kì thi khá suôn sẻ",
    example: "mọi việc đều suôn sẻ * vượt qua kì thi khá suôn sẻ",
  },
  {
    word: "suồng sã",
    part_of_speech: "tính từ",
    meaning:
      "có thái độ tỏ ra thân mật, gần gũi một cách quá trớn, thiếu đứng đắn, lễ độ: cử chỉ suồng sã * thái độ suồng sã",
    example: "cử chỉ suồng sã * thái độ suồng sã",
  },
  {
    word: "suốt",
    part_of_speech: "danh từ",
    meaning:
      "ống nhỏ bằng tre, gỗ, giấy, hoặc kim loại, dùng quấn sợi để cho vào thoi dệt hoặc quấn chỉ cho vào máy khâu: đánh thêm mấy suốt chỉ * ống suốt",
    example: "đánh thêm mấy suốt chỉ * ống suốt",
  },
  {
    word: "suốt",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) tuốt: suốt lúa",
    example: "suốt lúa",
  },
  {
    word: "suốt",
    part_of_speech: "tính từ",
    meaning:
      "liền một mạch trong không gian, nối tiếp từ đầu này đến đầu kia, từ nơi này đến nơi khác: nước trong nhìn suốt đến tận đáy * suốt dọc đường đi",
    example: "nước trong nhìn suốt đến tận đáy * suốt dọc đường đi",
  },
  {
    word: "suốt",
    part_of_speech: "tính từ",
    meaning:
      "liên tục trong thời gian, từ lúc bắt đầu đến lúc kết thúc: làm việc suốt từ sáng đến tối * nói suốt ngày * suốt một đời người",
    example:
      "làm việc suốt từ sáng đến tối * nói suốt ngày * suốt một đời người",
  },
  {
    word: "sụt",
    part_of_speech: "động từ",
    meaning:
      "(khối đất đá) nứt vỡ và rơi thẳng xuống từng mảng, từng phần: trần nhà bị sụt một mảng * lũ lên to gây sụt, lở đất",
    example: "trần nhà bị sụt một mảng * lũ lên to gây sụt, lở đất",
  },
  {
    word: "sụt",
    part_of_speech: "động từ",
    meaning: "sa xuống chỗ sâu: sụt hầm chông * xe sụt xuống hố",
    example: "sụt hầm chông * xe sụt xuống hố",
  },
  {
    word: "sụt",
    part_of_speech: "động từ",
    meaning:
      "giảm xuống đến mức thấp hẳn: giá xi măng sụt xuống đột ngột * giờ cao điểm, điện thế sụt hẳn",
    example: "giá xi măng sụt xuống đột ngột * giờ cao điểm, điện thế sụt hẳn",
  },
  {
    word: "sút",
    part_of_speech: "động từ",
    meaning:
      "đá mạnh quả bóng vào khung thành: sút bóng vào gôn * sút quả phạt đền",
    example: "sút bóng vào gôn * sút quả phạt đền",
  },
  {
    word: "sút",
    part_of_speech: "động từ",
    meaning:
      "giảm đi, kém hơn so với trước: sức học ngày càng sút * sức khoẻ sút đi nhiều * sau trận ốm, người sút đi mấy cân",
    example:
      "sức học ngày càng sút * sức khoẻ sút đi nhiều * sau trận ốm, người sút đi mấy cân",
  },
  {
    word: "sút",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) long ra, rời ra: dao sút cán * áo bị sút chỉ",
    example: "dao sút cán * áo bị sút chỉ",
  },
  {
    word: "sụt sịt",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả tiếng hít, thở, tiếng khóc khi mũi có nước: sụt sịt muốn ốm * khóc sụt sịt",
    example: "sụt sịt muốn ốm * khóc sụt sịt",
  },
  {
    word: "sụt giảm",
    part_of_speech: "động từ",
    meaning:
      "giảm hẳn đi rất nhanh và nhiều: đồng dollar sụt giảm mạnh * kim ngạch xuất khẩu bị sụt giảm",
    example: "đồng dollar sụt giảm mạnh * kim ngạch xuất khẩu bị sụt giảm",
  },
  {
    word: "sụp",
    part_of_speech: "động từ",
    meaning:
      "tự hạ thấp thân mình xuống một cách đột ngột: quỳ sụp xuống lạy * sụp xuống khóc",
    example: "quỳ sụp xuống lạy * sụp xuống khóc",
  },
  {
    word: "sụp",
    part_of_speech: "động từ",
    meaning: "bước hụt và sa chân xuống: sụp xuống hố * sụp ổ gà",
    example: "sụp xuống hố * sụp ổ gà",
  },
  {
    word: "sụp",
    part_of_speech: "động từ",
    meaning:
      "(đội mũ) hạ thấp xuống: mũ sụp xuống tận mắt * kéo mũ sụp xuống để che mưa",
    example: "mũ sụp xuống tận mắt * kéo mũ sụp xuống để che mưa",
  },
  {
    word: "sụp",
    part_of_speech: "động từ",
    meaning: "(mi mắt) cụp hẳn xuống: buồn ngủ quá, mắt sụp xuống",
    example: "buồn ngủ quá, mắt sụp xuống",
  },
  {
    word: "sụt giá",
    part_of_speech: "danh từ",
    meaning:
      "tình trạng giảm sút giá trị hoặc giá cả: vàng đang sụt giá * sụt giá chứng khoán",
    example: "vàng đang sụt giá * sụt giá chứng khoán",
  },
  {
    word: "sụp đổ",
    part_of_speech: "động từ",
    meaning:
      "đổ sập xuống, đổ hẳn xuống: chế độ độc tài sụp đổ * bao nhiêu hi vọng đều bị sụp đổ",
    example: "chế độ độc tài sụp đổ * bao nhiêu hi vọng đều bị sụp đổ",
  },
  {
    word: "sút giảm",
    part_of_speech: "động từ",
    meaning: "(hiếm) như giảm sút: sức khoẻ bị sút giảm",
    example: "sức khoẻ bị sút giảm",
  },
  {
    word: "sút kém",
    part_of_speech: "động từ",
    meaning:
      "bị sút đi, trở nên thấp và kém trước (nói khái quát): học lực sút kém * cảnh nhà ngày một sút kém",
    example: "học lực sút kém * cảnh nhà ngày một sút kém",
  },
  {
    word: "suy dinh dưỡng",
    part_of_speech: "danh từ",
    meaning:
      "trạng thái sự dinh dưỡng không thoả mãn yêu cầu phát triển của cơ thể, thường do ăn uống không đầy đủ: em bé bị suy dinh dưỡng",
    example: "em bé bị suy dinh dưỡng",
  },
  {
    word: "suy diễn",
    part_of_speech: "động từ",
    meaning:
      "đi từ những nguyên lí chung đến những kết luận riêng; trái với quy nạp: phương pháp suy diễn",
    example: "phương pháp suy diễn",
  },
  {
    word: "suy diễn",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) suy ra điều này điều nọ một cách chủ quan: suy diễn ra đủ chuyện",
    example: "suy diễn ra đủ chuyện",
  },
  {
    word: "suy",
    part_of_speech: "động từ",
    meaning:
      'như nghĩ (ng1): vụng suy * "Làm người mà chẳng biết suy, Đến khi nghĩ lại còn gì là thân." (ca dao)',
    example:
      'vụng suy * "Làm người mà chẳng biết suy, Đến khi nghĩ lại còn gì là thân." (ca dao)',
  },
  {
    word: "suy",
    part_of_speech: "động từ",
    meaning:
      "vận dụng trí tuệ để từ cái đã biết đi đến cái chưa biết hoặc đoán cái chưa xảy ra: suy đến cùng * suy bụng ta ra bụng người (tng)",
    example: "suy đến cùng * suy bụng ta ra bụng người (tng)",
  },
  {
    word: "suy",
    part_of_speech: "động từ",
    meaning: "ở trạng thái đang ngày một sút kém đi: vận đã đến lúc suy",
    example: "vận đã đến lúc suy",
  },
  {
    word: "suy",
    part_of_speech: "động từ",
    meaning:
      "(cơ thể hay bộ phận cơ thể) ở trạng thái đang ngày một yếu đi, thực hiện chức năng ngày một kém: suy tim * thận đã suy * suy dinh dưỡng",
    example: "suy tim * thận đã suy * suy dinh dưỡng",
  },
  {
    word: "suy bì",
    part_of_speech: "động từ",
    meaning:
      "so sánh hơn thiệt từng tí một với người mình cho là được hưởng có phần nhiều hơn mình: tính hay suy bì thiệt hơn",
    example: "tính hay suy bì thiệt hơn",
  },
  {
    word: "sụt sùi",
    part_of_speech: "tính từ",
    meaning:
      'từ gợi tả tiếng khóc nhỏ kéo dài, vẻ ngậm ngùi như cố giấu, cố nén nỗi đau lòng: sụt sùi khóc * "Buồng riêng, riêng những sụt sùi, Nghĩ thân mà lại ngậm ngùi cho thân." (TKiều)',
    example:
      'sụt sùi khóc * "Buồng riêng, riêng những sụt sùi, Nghĩ thân mà lại ngậm ngùi cho thân." (TKiều)',
  },
  {
    word: "sụt sùi",
    part_of_speech: "tính từ",
    meaning: "từ gợi tả cảnh trời mưa nhỏ, rả rích, kéo dài: mưa gió sụt sùi",
    example: "mưa gió sụt sùi",
  },
  {
    word: "suy đoán",
    part_of_speech: "động từ",
    meaning:
      "đoán ra điều chưa biết, căn cứ vào những điều đã biết: suy đoán tình hình * chữ viết bị nhoè, phải suy đoán mới hiểu được",
    example:
      "suy đoán tình hình * chữ viết bị nhoè, phải suy đoán mới hiểu được",
  },
  {
    word: "suy đồi",
    part_of_speech: "",
    meaning:
      "ở tình trạng suy tàn và đồi bại: văn hoá suy đồi * chế độ phong kiến suy đồi",
    example: "văn hoá suy đồi * chế độ phong kiến suy đồi",
  },
  {
    word: "suy đốn",
    part_of_speech: "tính từ",
    meaning: "ở tình trạng bị sa sút đến mức khốn đốn: vận nhà suy đốn",
    example: "vận nhà suy đốn",
  },
  {
    word: "suy lí",
    part_of_speech: "",
    meaning:
      "rút ra một phán đoán mới (gọi là kết luận) từ một hay nhiều phán đoán sẵn có (gọi là tiền đề): các quy tắc suy lí",
    example: "các quy tắc suy lí",
  },
  {
    word: "suy gẫm",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) như suy ngẫm: điều đáng phải suy gẫm",
    example: "điều đáng phải suy gẫm",
  },
  {
    word: "suy kiệt",
    part_of_speech: "động từ",
    meaning:
      "ở tình trạng suy yếu, giảm sút đến mức trầm trọng: cơ thể suy kiệt",
    example: "cơ thể suy kiệt",
  },
  {
    word: "suy giảm",
    part_of_speech: "động từ",
    meaning:
      "bị giảm sút, kém dần đi: già nên trí nhớ suy giảm * sức khoẻ suy giảm",
    example: "già nên trí nhớ suy giảm * sức khoẻ suy giảm",
  },
  {
    word: "suy luận",
    part_of_speech: "",
    meaning:
      "liên hệ các phán đoán với nhau để rút ra một hay nhiều phán đoán mới về một chủ đề nào đó: suy luận thiếu logic * cách suy luận chặt chẽ",
    example: "suy luận thiếu logic * cách suy luận chặt chẽ",
  },
  {
    word: "suy luận",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) suy ra điều này điều nọ một cách không có căn cứ, không thực tế, không logic: hay suy luận lung tung",
    example: "hay suy luận lung tung",
  },
  {
    word: "suy lý",
    part_of_speech: "",
    meaning:
      "rút ra một phán đoán mới (gọi là kết luận) từ một hay nhiều phán đoán sẵn có (gọi là tiền đề): các quy tắc suy lí",
    example: "các quy tắc suy lí",
  },
  {
    word: "suy nghĩ",
    part_of_speech: "động từ",
    meaning:
      "vận dụng sự hoạt động của trí óc để tìm hiểu và giải quyết vấn đề, từ một số phán đoán và ý nghĩ này đi đến những phán đoán và ý nghĩ khác có chứa tri thức mới: vẻ mặt đăm chiêu suy nghĩ * lười suy nghĩ * suy nghĩ kĩ trước khi hành động",
    example:
      "vẻ mặt đăm chiêu suy nghĩ * lười suy nghĩ * suy nghĩ kĩ trước khi hành động",
  },
  {
    word: "suy ngẫm",
    part_of_speech: "động từ",
    meaning:
      "ngẫm nghĩ để đánh giá, kết luận: suy ngẫm sự đời * phải suy ngẫm mãi mới hiểu",
    example: "suy ngẫm sự đời * phải suy ngẫm mãi mới hiểu",
  },
  {
    word: "suy sụp",
    part_of_speech: "động từ",
    meaning:
      "ở tình trạng suy yếu trầm trọng, khó gượng nổi: suy sụp tinh thần * sức khoẻ bị suy sụp",
    example: "suy sụp tinh thần * sức khoẻ bị suy sụp",
  },
  {
    word: "suy nhược",
    part_of_speech: "tính từ",
    meaning:
      "ở tình trạng sức lực, tinh thần bị suy yếu nhiều: suy nhược cơ thể",
    example: "suy nhược cơ thể",
  },
  {
    word: "suy thoái",
    part_of_speech: "động từ",
    meaning:
      "ở tình trạng suy yếu và sút kém dần, có tính chất kéo dài: nền kinh tế suy thoái",
    example: "nền kinh tế suy thoái",
  },
  {
    word: "suy tàn",
    part_of_speech: "động từ",
    meaning:
      "ở trạng thái suy yếu và tàn lụi, không còn sức sống: chế độ phong kiến suy tàn",
    example: "chế độ phong kiến suy tàn",
  },
  {
    word: "suy suyển",
    part_of_speech: "động từ",
    meaning:
      "bị mất mát hay có đổi khác đi theo hướng xấu: đồ đạc bị suy suyển * niềm tin không hề suy suyển",
    example: "đồ đạc bị suy suyển * niềm tin không hề suy suyển",
  },
  {
    word: "suy tị",
    part_of_speech: "động từ",
    meaning: "suy bì, tị nạnh: tính hay suy tị * suy tị nhau từng tí một",
    example: "tính hay suy tị * suy tị nhau từng tí một",
  },
  {
    word: "suy tính",
    part_of_speech: "động từ",
    meaning:
      "suy nghĩ, tính toán để cân nhắc lợi hại, thiệt hơn: suy tính kĩ càng * một người biết suy tính",
    example: "suy tính kĩ càng * một người biết suy tính",
  },
  {
    word: "suy tôn",
    part_of_speech: "động từ",
    meaning: "đưa lên địa vị cao quý: được suy tôn là bậc thầy",
    example: "được suy tôn là bậc thầy",
  },
  {
    word: "suy tưởng",
    part_of_speech: "",
    meaning:
      "suy nghĩ sâu lắng về những vấn đề chung, vấn đề có ý nghĩa lớn: suy tưởng về cuộc đời * dòng suy tưởng * đắm chìm trong suy tưởng",
    example:
      "suy tưởng về cuộc đời * dòng suy tưởng * đắm chìm trong suy tưởng",
  },
  {
    word: "suy xét",
    part_of_speech: "động từ",
    meaning:
      "suy nghĩ và xem xét kĩ càng: bình tĩnh suy xét * nhận định thiếu suy xét",
    example: "bình tĩnh suy xét * nhận định thiếu suy xét",
  },
  {
    word: "suy vong",
    part_of_speech: "động từ",
    meaning: "ở tình trạng suy yếu và đi đến diệt vong: thời nhà Lê suy vong",
    example: "thời nhà Lê suy vong",
  },
  {
    word: "suy tổn",
    part_of_speech: "động từ",
    meaning: "hao mòn, sút kém hẳn đi: nền kinh tế bị suy tổn nặng nề",
    example: "nền kinh tế bị suy tổn nặng nề",
  },
  {
    word: "suy tư",
    part_of_speech: "",
    meaning: "suy nghĩ sâu lắng: vẻ mặt suy tư * giấu kín những suy tư",
    example: "vẻ mặt suy tư * giấu kín những suy tư",
  },
  {
    word: "suy yếu",
    part_of_speech: "tính từ",
    meaning: "yếu dần đi: cơ thể ngày một suy yếu * làm suy yếu lực lượng địch",
    example: "cơ thể ngày một suy yếu * làm suy yếu lực lượng địch",
  },
  {
    word: "suy vi",
    part_of_speech: "động từ",
    meaning:
      "ở tình trạng đi xuống, sút kém dần: vận nhà suy vi * đất nước gặp buổi suy vi",
    example: "vận nhà suy vi * đất nước gặp buổi suy vi",
  },
  {
    word: "suýt",
    part_of_speech: "phụ từ",
    meaning:
      "chỉ còn thiếu chút nữa là đã xảy ra (thường là điều không hay): trượt chân suýt ngã * ốm một trận suýt chết",
    example: "trượt chân suýt ngã * ốm một trận suýt chết",
  },
  {
    word: "suyễn",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) hen: lên cơn suyễn",
    example: "lên cơn suyễn",
  },
  {
    word: "sứ",
    part_of_speech: "danh từ",
    meaning:
      "(Từ cũ) chức quan được vua phái đi giao thiệp với nước ngoài: đi sứ",
    example: "đi sứ",
  },
  {
    word: "sứ",
    part_of_speech: "danh từ",
    meaning: "công sứ ở tỉnh thời Pháp thuộc (nói tắt): quan sứ * toà sứ",
    example: "quan sứ * toà sứ",
  },
  {
    word: "sứ",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ) đại: cây sứ * bông sứ",
    example: "cây sứ * bông sứ",
  },
  {
    word: "suýt soát",
    part_of_speech: "tính từ",
    meaning:
      "gần bằng, chỉ hơn kém một ít: tuổi suýt soát bốn mươi * hai người cao suýt soát nhau",
    example: "tuổi suýt soát bốn mươi * hai người cao suýt soát nhau",
  },
  {
    word: "sư",
    part_of_speech: "danh từ",
    meaning: "người tu hành theo đạo Phật ở chùa: ông sư bà sãi",
    example: "ông sư bà sãi",
  },
  {
    word: "sư",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) sư đoàn (nói tắt): chỉ huy một sư",
    example: "chỉ huy một sư",
  },
  {
    word: "sự",
    part_of_speech: "danh từ",
    meaning: "việc, chuyện (nói khái quát): gây sự * muốn quên đi mọi sự",
    example: "gây sự * muốn quên đi mọi sự",
  },
  {
    word: "sự",
    part_of_speech: "danh từ",
    meaning:
      "từ có tác dụng danh từ hoá (sự vật hoá) một hoạt động, một tính chất: sự sống * sự đau đớn * sự thông cảm * sự cố gắng",
    example: "sự sống * sự đau đớn * sự thông cảm * sự cố gắng",
  },
  {
    word: "suỵt",
    part_of_speech: "động từ",
    meaning: "phát ra tiếng gió ở miệng để xua và khiến chó: suỵt chó ra đuổi",
    example: "suỵt chó ra đuổi",
  },
  {
    word: "suỵt",
    part_of_speech: "cảm từ",
    meaning:
      "tiếng gió thốt ra khe khẽ để nhắc người khác giữ im lặng: suỵt! bé cái mồm chứ",
    example: "suỵt! bé cái mồm chứ",
  },
  {
    word: "sử",
    part_of_speech: "danh từ",
    meaning: "lịch sử (nói tắt): sử Việt Nam",
    example: "sử Việt Nam",
  },
  {
    word: "sử",
    part_of_speech: "danh từ",
    meaning: "sử học (nói tắt): môn sử * nhà viết sử",
    example: "môn sử * nhà viết sử",
  },
  {
    word: "suýt nữa",
    part_of_speech: "phụ từ",
    meaning: "như suýt: suýt nữa thì muộn học * chỉ suýt nữa là xảy ra tai nạn",
    example: "suýt nữa thì muộn học * chỉ suýt nữa là xảy ra tai nạn",
  },
  {
    word: "sự biến",
    part_of_speech: "danh từ",
    meaning:
      "sự việc không hay bất ngờ xảy ra, có tác động tiêu cực đến đời sống xã hội hoặc cá nhân: phòng khi có sự biến",
    example: "phòng khi có sự biến",
  },
  {
    word: "sự cố",
    part_of_speech: "danh từ",
    meaning:
      "hiện tượng bất thường và không hay xảy ra trong một quá trình hoạt động nào đó: mất điện do sự cố * khắc phục sự cố tràn dầu trên biển",
    example: "mất điện do sự cố * khắc phục sự cố tràn dầu trên biển",
  },
  {
    word: "sư đệ",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng giữa tăng ni để gọi thân mật người có tuổi đạo thấp hơn mình.",
    example: "tình sư đệ",
  },
  {
    word: "sự đời",
    part_of_speech: "danh từ",
    meaning:
      'sự việc xảy ra ở đời, về mặt là không phải bao giờ cũng như ý muốn (nói khái quát): "Sự đời nghĩ cũng nực cười, Một con cá lội mấy người buông câu!" (ca dao)',
    example:
      'Sự đời nghĩ cũng nực cười, Một con cá lội mấy người buông câu!" (ca dao)',
  },
  {
    word: "sư đoàn",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị tổ chức của lực lượng vũ trang gồm hai trung đoàn trở lên: sư đoàn bộ binh",
    example: "sư đoàn bộ binh",
  },
  {
    word: "sử dụng",
    part_of_speech: "động từ",
    meaning:
      "lấy làm phương tiện để phục vụ nhu cầu, mục đích nào đó: hết hạn sử dụng * quyền sử dụng đất * sử dụng tiếng Anh để giao tiếp",
    example:
      "hết hạn sử dụng * quyền sử dụng đất * sử dụng tiếng Anh để giao tiếp",
  },
  {
    word: "sứ giả",
    part_of_speech: "danh từ",
    meaning: "(cũ) người được vua phái đi giao thiệp với nước ngoài.",
    example: "sứ giả của hoà bình",
  },
  {
    word: "sử kí",
    part_of_speech: "danh từ",
    meaning: "(cũ) lịch sử: cuốn sử kí của Tư Mã Thiên",
    example: "cuốn sử kí của Tư Mã Thiên",
  },
  {
    word: "sứ mạng",
    part_of_speech: "danh từ",
    meaning:
      "(trang trọng) nhiệm vụ quan trọng, thiêng liêng: sứ mệnh lịch sử * hoàn thành sứ mệnh được giao",
    example: "sứ mệnh lịch sử * hoàn thành sứ mệnh được giao",
  },
  {
    word: "sự kiện",
    part_of_speech: "danh từ",
    meaning:
      "sự việc có ý nghĩa ít nhiều quan trọng đã xảy ra: những sự kiện lịch sử * sự kiện đáng ghi nhớ",
    example: "những sự kiện lịch sử * sự kiện đáng ghi nhớ",
  },
  {
    word: "sứ mệnh",
    part_of_speech: "danh từ",
    meaning:
      "(trang trọng) nhiệm vụ quan trọng, thiêng liêng: sứ mệnh lịch sử * hoàn thành sứ mệnh được giao",
    example: "sứ mệnh lịch sử * hoàn thành sứ mệnh được giao",
  },
  {
    word: "sự nghiệp",
    part_of_speech: "danh từ",
    meaning:
      "những công việc to lớn, có ích lợi chung và lâu dài cho bản thân và xã hội (nói tổng quát): sự nghiệp đấu tranh giải phóng dân tộc * thân thế và sự nghiệp của Nguyễn Trãi",
    example:
      "sự nghiệp đấu tranh giải phóng dân tộc * thân thế và sự nghiệp của Nguyễn Trãi",
  },
  {
    word: "sự nghiệp",
    part_of_speech: "danh từ",
    meaning:
      "các hoạt động có tính chất nghiệp vụ riêng biệt, phục vụ cho sản xuất kinh doanh và cho đời sống văn hoá (nói tổng quát): cơ quan hành chính sự nghiệp",
    example: "cơ quan hành chính sự nghiệp",
  },
  {
    word: "sư phạm",
    part_of_speech: "danh từ",
    meaning:
      "khoa học về giảng dạy và giáo dục trong nhà trường: kĩ năng sư phạm * đại học sư phạm",
    example: "kĩ năng sư phạm * đại học sư phạm",
  },
  {
    word: "sử sách",
    part_of_speech: "danh từ",
    meaning: "sách ghi chép về lịch sử (nói khái quát): lưu danh sử sách",
    example: "lưu danh sử sách",
  },
  {
    word: "sự thật",
    part_of_speech: "danh từ",
    meaning:
      "cái có thật, cái có trong thực tế: ước mơ đã trở thành sự thật * phản ánh đúng sự thật",
    example: "ước mơ đã trở thành sự thật * phản ánh đúng sự thật",
  },
  {
    word: "sự thật",
    part_of_speech: "danh từ",
    meaning:
      "điều phản ánh đúng hiện thực khách quan: tìm ra sự thật * sự thật đã rành rành, không thể chối cãi",
    example: "tìm ra sự thật * sự thật đã rành rành, không thể chối cãi",
  },
  {
    word: "sự thật",
    part_of_speech: "phụ từ",
    meaning:
      "đúng là như vậy, sự thật là như vậy: sự thật là tôi không biết gì cả!",
    example: "sự thật là tôi không biết gì cả!",
  },
  {
    word: "sứ quân",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) tướng lĩnh hay quý tộc có thế lực nổi dậy chiếm cứ một địa phương trong thời kì loạn lạc cuối đời nhà Ngô ở Việt Nam: Đinh Bộ Lĩnh dẹp loạn mười hai sứ quân",
    example: "Đinh Bộ Lĩnh dẹp loạn mười hai sứ quân",
  },
  {
    word: "sự thế",
    part_of_speech: "danh từ",
    meaning: "(hiếm) tình hình và xu thế của sự việc: sự thế đã khác trước",
    example: "sự thế đã khác trước",
  },
  {
    word: "sự thế",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) như thế sự: "Dửng dưng sự thế, biếng đua tranh, Dầu mặc chê khen, mặc dữ lành." (QÂTT)',
    example:
      'Dửng dưng sự thế, biếng đua tranh, Dầu mặc chê khen, mặc dữ lành." (QÂTT)',
  },
  {
    word: "sự thể",
    part_of_speech: "danh từ",
    meaning:
      "tình hình cụ thể của sự việc đã xảy ra: chưa biết sự thể ra sao * sự thể nghiêm trọng hơn tôi tưởng",
    example: "chưa biết sự thể ra sao * sự thể nghiêm trọng hơn tôi tưởng",
  },
  {
    word: "sự tích",
    part_of_speech: "danh từ",
    meaning:
      "câu chuyện về nguồn gốc của một cái gì từ thời xa xưa còn được truyền lại, kể lại: sự tích trầu cau * sự tích cây vú sữa",
    example: "sự tích trầu cau * sự tích cây vú sữa",
  },
  {
    word: "sự tình",
    part_of_speech: "danh từ",
    meaning:
      'tình hình của sự việc đã xảy ra và những diễn biến chi tiết bên trong của nó: kể lại sự tình * "Sự tình đã đến nước này thì tôi cũng mặc, tới đâu hay đó." (ĐGiỏi; 4)',
    example:
      'kể lại sự tình * "Sự tình đã đến nước này thì tôi cũng mặc, tới đâu hay đó." (ĐGiỏi; 4)',
  },
  {
    word: "sự vật",
    part_of_speech: "danh từ",
    meaning:
      "cái tồn tại được nhận thức có ranh giới rõ ràng, phân biệt với những cái tồn tại khác: khám phá các sự vật * sự vật biến đổi không ngừng",
    example: "khám phá các sự vật * sự vật biến đổi không ngừng",
  },
  {
    word: "sử xanh",
    part_of_speech: "danh từ",
    meaning:
      '(văn chương) sách lịch sử (nói khái quát): "Tiếng tăm lừng lẫy đó đây, Sử xanh ghi mãi những ngày vẻ vang." (ca dao)',
    example:
      'Tiếng tăm lừng lẫy đó đây, Sử xanh ghi mãi những ngày vẻ vang." (ca dao)',
  },
  {
    word: "sự vụ",
    part_of_speech: "tính từ",
    meaning:
      "(công tác) có tính chất lặt vặt và cụ thể thường ngày, giữa các việc thường không có liên quan với nhau, không có tính chất chuyên môn: làm công tác sự vụ ở phòng hành chính * công việc sự vụ",
    example: "làm công tác sự vụ ở phòng hành chính * công việc sự vụ",
  },
  {
    word: "sự vụ",
    part_of_speech: "tính từ",
    meaning:
      "(tác phong công tác) chỉ lo giải quyết những công việc sự vụ, không nắm được những vấn đề chính, không có sự suy nghĩ, nghiên cứu: lối làm việc rất sự vụ",
    example: "lối làm việc rất sự vụ",
  },
  {
    word: "sự vụ",
    part_of_speech: "danh từ",
    meaning:
      "sự việc không hay, về mặt đang được xem xét để giải quyết: nguyên nhân sự vụ * sự vụ đang được điều tra, làm rõ",
    example: "nguyên nhân sự vụ * sự vụ đang được điều tra, làm rõ",
  },
  {
    word: "sự việc",
    part_of_speech: "danh từ",
    meaning:
      "cái xảy ra được nhận thức có ranh giới rõ ràng, phân biệt với những cái xảy ra khác: tìm hiểu đầu đuôi sự việc * sự việc trở nên nghiêm trọng",
    example: "tìm hiểu đầu đuôi sự việc * sự việc trở nên nghiêm trọng",
  },
  {
    word: "sửa",
    part_of_speech: "động từ",
    meaning:
      "làm cho không còn những chỗ hư hỏng, sai sót hoặc không thích hợp, để trở thành bình thường hoặc tốt hơn: sửa vô tuyến * sửa từng chữ * sửa chiếc xe hỏng",
    example: "sửa vô tuyến * sửa từng chữ * sửa chiếc xe hỏng",
  },
  {
    word: "sửa",
    part_of_speech: "động từ",
    meaning:
      "thay đổi, thêm bớt để phù hợp với yêu cầu: sửa áo dài thành áo cánh",
    example: "sửa áo dài thành áo cánh",
  },
  {
    word: "sửa",
    part_of_speech: "động từ",
    meaning: "(Khẩu ngữ) trị để làm cho sợ: sửa cho một trận",
    example: "sửa cho một trận",
  },
  {
    word: "sưa",
    part_of_speech: "tính từ",
    meaning:
      '(phương ngữ) thưa: "Thương ai ra đứng đầu cầu, Lược sưa biếng chải, gương tàu biếng soi." (ca dao)',
    example:
      'Thương ai ra đứng đầu cầu, Lược sưa biếng chải, gương tàu biếng soi." (ca dao)',
  },
  {
    word: "sữa",
    part_of_speech: "danh từ",
    meaning:
      "chất lỏng màu trắng đục do tuyến vú của phụ nữ hoặc động vật có vú giống cái tiết ra để nuôi con: vắt sữa bò * bú sữa mẹ",
    example: "vắt sữa bò * bú sữa mẹ",
  },
  {
    word: "sữa",
    part_of_speech: "danh từ",
    meaning:
      "chất đặc có màu trắng đục trong hạt ngũ cốc non: lúa đang kì ngậm sữa",
    example: "lúa đang kì ngậm sữa",
  },
  {
    word: "sửa chữa",
    part_of_speech: "động từ",
    meaning:
      "sửa những chỗ hư hỏng, sai sót (nói khái quát): sửa chữa nhà cửa * sửa chữa sai lầm",
    example: "sửa chữa nhà cửa * sửa chữa sai lầm",
  },
  {
    word: "sửa đổi",
    part_of_speech: "động từ",
    meaning:
      "thay đổi, thêm bớt cho phù hợp với yêu cầu đã khác trước: sửa đổi hiến pháp * sửa đổi tính nết",
    example: "sửa đổi hiến pháp * sửa đổi tính nết",
  },
  {
    word: "sửa soạn",
    part_of_speech: "động từ",
    meaning:
      "lo liệu và sắp đặt các thứ để làm việc gì đó: sửa soạn hành trang * sửa soạn nấu cơm",
    example: "sửa soạn hành trang * sửa soạn nấu cơm",
  },
  {
    word: "sức",
    part_of_speech: "danh từ",
    meaning:
      "khả năng mang lại kết quả của gân cốt, có thể tạo ra tác động làm biến đổi vị trí, sự chuyển động hoặc hình dạng của các vật: đọ sức * sức yếu nên không nâng nổi quả tạ * dồn sức cho công việc",
    example:
      "đọ sức * sức yếu nên không nâng nổi quả tạ * dồn sức cho công việc",
  },
  {
    word: "sức",
    part_of_speech: "danh từ",
    meaning:
      "khả năng hoạt động, làm việc, tác động hoặc chịu tác động đến đâu: sức chịu đựng * sức học trung bình * sức gió giật trên cấp 12",
    example: "sức chịu đựng * sức học trung bình * sức gió giật trên cấp 12",
  },
  {
    word: "sửa sai",
    part_of_speech: "động từ",
    meaning:
      "sửa chữa sai lầm (thường nói về sai lầm về chính sách): công tác sửa sai",
    example: "công tác sửa sai",
  },
  {
    word: "sửa sang",
    part_of_speech: "động từ",
    meaning:
      'sửa lại ít nhiều cho tốt hơn, đẹp hơn (nói khái quát): sửa sang nhà cửa để đón Tết * "Sửa sang áo tía quần hồng, Nhìn xem ngỡ khách non bồng tiên phi." (HTr)',
    example:
      'sửa sang nhà cửa để đón Tết * "Sửa sang áo tía quần hồng, Nhìn xem ngỡ khách non bồng tiên phi." (HTr)',
  },
  {
    word: "sực",
    part_of_speech: "động từ",
    meaning:
      "(mùi) xông mạnh và lan toả ra, rất dễ nhận biết: thơm sực * mùi nước hoa rẻ tiền sực lên hăng hắc",
    example: "thơm sực * mùi nước hoa rẻ tiền sực lên hăng hắc",
  },
  {
    word: "sực",
    part_of_speech: "phụ từ",
    meaning:
      'bỗng nhiên, chợt (thức giấc, nghĩ ra, nhớ ra): sực tỉnh * "Hôm qua dệt cửi thoi vàng, Sực nhớ đến chàng, cửi lại dừng thoi." (ca dao)',
    example:
      'sực tỉnh * "Hôm qua dệt cửi thoi vàng, Sực nhớ đến chàng, cửi lại dừng thoi." (ca dao)',
  },
  {
    word: "sức bật",
    part_of_speech: "danh từ",
    meaning:
      "sức nẩy lên mạnh mẽ; thường dùng để ví khả năng phản ứng nhanh và mạnh trong một thời gian ngắn để vươn lên mạnh mẽ, có tính chất nhảy vọt: một vận động viên có sức bật tốt * tạo một sức bật mới cho sự phát triển",
    example:
      "một vận động viên có sức bật tốt * tạo một sức bật mới cho sự phát triển",
  },
  {
    word: "sức bền",
    part_of_speech: "danh từ",
    meaning:
      "sức chịu đựng của vật liệu đối với tác dụng cơ học: sức bền vật liệu",
    example: "sức bền vật liệu",
  },
  {
    word: "sức ép",
    part_of_speech: "danh từ",
    meaning:
      "sức dồn ép rất mạnh; thường dùng để ví sự cưỡng ép bằng sức mạnh: sức ép của bom * sức ép tâm lí * gây sức ép",
    example: "sức ép của bom * sức ép tâm lí * gây sức ép",
  },
  {
    word: "sức lực",
    part_of_speech: "danh từ",
    meaning:
      "sức của con người (nói khái quát): tuổi cao, sức lực giảm sút * tập trung toàn bộ sức lực",
    example: "tuổi cao, sức lực giảm sút * tập trung toàn bộ sức lực",
  },
  {
    word: "sức mua",
    part_of_speech: "danh từ",
    meaning:
      "khả năng mua sắm hàng hoá: tìm hiểu sức mua của thị trường * sức mua tăng cao vào dịp Tết",
    example: "tìm hiểu sức mua của thị trường * sức mua tăng cao vào dịp Tết",
  },
  {
    word: "sức mua",
    part_of_speech: "danh từ",
    meaning:
      "khả năng mua hàng của một đơn vị tiền tệ: giữ vững sức mua của đồng tiền",
    example: "giữ vững sức mua của đồng tiền",
  },
  {
    word: "sức khoẻ",
    part_of_speech: "danh từ",
    meaning:
      "trạng thái không có bệnh tật, cảm thấy thoải mái về thể chất, thư thái về tinh thần: hút thuốc lá có hại cho sức khoẻ * hỏi thăm sức khoẻ",
    example: "hút thuốc lá có hại cho sức khoẻ * hỏi thăm sức khoẻ",
  },
  {
    word: "sức mấy",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) có được bao nhiêu hơi sức mà làm việc gì đó (hàm ý coi thường): sức mấy mà địch lại với nó? * thằng ấy thì sức mấy?",
    example: "sức mấy mà địch lại với nó? * thằng ấy thì sức mấy?",
  },
  {
    word: "sức mấy",
    part_of_speech: "",
    meaning:
      "tổ hợp biểu thị ý phủ định về việc cho là không có khả năng xảy ra: sức mấy mà nó nghe theo",
    example: "sức mấy mà nó nghe theo",
  },
  {
    word: "sực nức",
    part_of_speech: "động từ",
    meaning:
      "(mùi thơm) xông lên mạnh mẽ và lan toả khắp nơi: sực nức mùi hương hoa nhài * mùi thơm sực nức",
    example: "sực nức mùi hương hoa nhài * mùi thơm sực nức",
  },
  {
    word: "sức lao động",
    part_of_speech: "danh từ",
    meaning:
      "năng lực lao động của con người, bao gồm thể lực và trí lực: giải phóng sức lao động * lãng phí sức lao động",
    example: "giải phóng sức lao động * lãng phí sức lao động",
  },
  {
    word: "sức kéo",
    part_of_speech: "danh từ",
    meaning:
      "sức của súc vật, máy kéo dùng để kéo cày bừa, kéo xe, v.v. nói chung: nuôi trâu bò để lấy sức kéo",
    example: "nuôi trâu bò để lấy sức kéo",
  },
  {
    word: "sức mạnh",
    part_of_speech: "danh từ",
    meaning:
      "khả năng tác động mạnh mẽ đến những người khác, đến sự vật, gây tác dụng ở mức cao: đoàn kết là sức mạnh * sức mạnh tinh thần * sức mạnh vô hình",
    example: "đoàn kết là sức mạnh * sức mạnh tinh thần * sức mạnh vô hình",
  },
  {
    word: "sức vóc",
    part_of_speech: "danh từ",
    meaning: "sức lực biểu hiện ra ở dáng vóc: sức vóc vạm vỡ",
    example: "sức vóc vạm vỡ",
  },
  {
    word: "sức sống",
    part_of_speech: "danh từ",
    meaning:
      "khả năng tồn tại và phát triển được biểu hiện ra một cách mạnh mẽ: tuổi trẻ tràn đầy sức sống * sức sống mãnh liệt",
    example: "tuổi trẻ tràn đầy sức sống * sức sống mãnh liệt",
  },
  {
    word: "sừng",
    part_of_speech: "danh từ",
    meaning:
      "phần cứng mọc nhô ra ở đầu một số loài thú có guốc: sừng hươu * tê giác một sừng * lược sừng (lược làm bằng sừng)",
    example: "sừng hươu * tê giác một sừng * lược sừng (lược làm bằng sừng)",
  },
  {
    word: "sững",
    part_of_speech: "động từ",
    meaning:
      "dừng lại một cách đột ngột do một tác động bất ngờ: đang đi bỗng sững lại",
    example: "đang đi bỗng sững lại",
  },
  {
    word: "sững",
    part_of_speech: "tính từ",
    meaning:
      "ở vào trạng thái bất động, đờ người ra trong giây lát, do chịu một tác động tinh thần mạnh đột ngột: đứng sững * nhìn sững vào bóng tối * sững người trước vẻ đẹp kì ảo của thiên nhiên",
    example:
      "đứng sững * nhìn sững vào bóng tối * sững người trước vẻ đẹp kì ảo của thiên nhiên",
  },
  {
    word: "sưng",
    part_of_speech: "động từ",
    meaning:
      "(bộ phận cơ thể) phồng to lên do máu dồn đến chỗ bị chấn thương hay viêm: khóc sưng mắt * hai bàn chân sưng tướng lên",
    example: "khóc sưng mắt * hai bàn chân sưng tướng lên",
  },
  {
    word: "sửng cồ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) phản ứng mạnh, hung hăng khi gặp điều trái ý: tính hay sửng cồ * thấy trái ý là sửng cồ lên ngay",
    example: "tính hay sửng cồ * thấy trái ý là sửng cồ lên ngay",
  },
  {
    word: "sưng sỉa",
    part_of_speech: "tính từ",
    meaning:
      "(mặt) nặng ra, và như sưng lên, lộ rõ vẻ không bằng lòng: mặt mày sưng sỉa * hơi động đến là mặt sưng sỉa lên!",
    example: "mặt mày sưng sỉa * hơi động đến là mặt sưng sỉa lên!",
  },
  {
    word: "sưng húp",
    part_of_speech: "động từ",
    meaning:
      "sưng to và mọng lên một cách không bình thường, gây cảm giác nặng nề, khó chịu: mặt mũi sưng húp",
    example: "mặt mũi sưng húp",
  },
  {
    word: "sừng sộ",
    part_of_speech: "động từ",
    meaning:
      "có vẻ mặt, điệu bộ, lời nói hung hăng, dữ tợn, đầy vẻ đe doạ: sừng sộ sấn vào * sừng sộ toan đánh người",
    example: "sừng sộ sấn vào * sừng sộ toan đánh người",
  },
  {
    word: "sửng sốt",
    part_of_speech: "động từ",
    meaning:
      "ngạc nhiên tới mức ngẩn người ra: giật mình sửng sốt  * nghe tin dữ, ai cũng sửng sốt",
    example: "giật mình sửng sốt  * nghe tin dữ, ai cũng sửng sốt",
  },
  {
    word: "sưng vếu",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như sưng vù: mồm miệng sưng vếu",
    example: "mồm miệng sưng vếu",
  },
  {
    word: "sừng sỏ",
    part_of_speech: "tính từ",
    meaning:
      "hung hăng, ngang bướng, không hề chịu thua ai: tên tướng cướp sừng sỏ",
    example: "tên tướng cướp sừng sỏ",
  },
  {
    word: "sừng sững",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả dáng của một vật to lớn, chắn ngang tầm nhìn: toà tháp cao sừng sững * đứng sừng sững trước mặt",
    example: "toà tháp cao sừng sững * đứng sừng sững trước mặt",
  },
  {
    word: "sững sờ",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái lặng người đi vì ngạc nhiên hay xúc động: sững sờ nhìn nhau * sững sờ trước sự thay đổi của bạn",
    example: "sững sờ nhìn nhau * sững sờ trước sự thay đổi của bạn",
  },
  {
    word: "sưởi",
    part_of_speech: "động từ",
    meaning:
      "tiếp xúc với hơi nóng cho ấm: sưởi nắng * lò sưởi * đốt lửa để sưởi ấm",
    example: "sưởi nắng * lò sưởi * đốt lửa để sưởi ấm",
  },
  {
    word: "sưng vều",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như sưng vù: mặt sưng vều",
    example: "mặt sưng vều",
  },
  {
    word: "sườn",
    part_of_speech: "danh từ",
    meaning:
      "các xương bao quanh lồng ngực từ cột sống đến vùng ức (nói tổng quát): xương sườn * món sườn xào chua ngọt",
    example: "xương sườn * món sườn xào chua ngọt",
  },
  {
    word: "sườn",
    part_of_speech: "danh từ",
    meaning:
      "phần thân ứng với xương sườn: hích vào sườn bạn * thấy đau một bên sườn",
    example: "hích vào sườn bạn * thấy đau một bên sườn",
  },
  {
    word: "sườn",
    part_of_speech: "danh từ",
    meaning:
      "bề cạnh của một số vật có hình khối và chiều cao: sườn núi * sườn tàu",
    example: "sườn núi * sườn tàu",
  },
  {
    word: "sườn",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận chính làm nòng cốt, làm chỗ dựa để tạo nên hình dáng của vật: sườn nhà * viết sườn của luận án",
    example: "sườn nhà * viết sườn của luận án",
  },
  {
    word: "sưng vù",
    part_of_speech: "tính từ",
    meaning: "sưng lên rất to: ngã sưng vù đầu gối * mặt bị ong đốt sưng vù",
    example: "ngã sưng vù đầu gối * mặt bị ong đốt sưng vù",
  },
  {
    word: "sườn sượt",
    part_of_speech: "tính từ",
    meaning: "như sượt (nhưng ý nhấn mạnh hơn): thở dài sườn sượt",
    example: "thở dài sườn sượt",
  },
  {
    word: "sượng",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái nấu chưa được thật chín, hoặc do bị kém phẩm chất, không thể nào nấu cho chín mềm được: bánh luộc còn sượng * khoai sượng * đỗ bị sượng",
    example: "bánh luộc còn sượng * khoai sượng * đỗ bị sượng",
  },
  {
    word: "sượng",
    part_of_speech: "tính từ",
    meaning:
      "thiếu sự nhuần nhuyễn, sự mềm mại: câu văn còn hơi sượng * diễn rất sượng",
    example: "câu văn còn hơi sượng * diễn rất sượng",
  },
  {
    word: "sượng",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như ngượng: sượng cả mặt",
    example: "sượng cả mặt",
  },
  {
    word: "sướng",
    part_of_speech: "tính từ",
    meaning:
      "được đầy đủ, thoả mãn như ý muốn, thường là về mặt vật chất: sống sướng * sướng như tiên",
    example: "sống sướng * sướng như tiên",
  },
  {
    word: "sướng",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) có cảm giác thích thú, thoả mãn đến cao độ: nói cho sướng mồm * nghe cũng thấy sướng tai",
    example: "nói cho sướng mồm * nghe cũng thấy sướng tai",
  },
  {
    word: "sương giá",
    part_of_speech: "danh từ",
    meaning:
      "sương rất giá lạnh nhưng chưa đông thành những hạt băng: trời đầy sương giá",
    example: "trời đầy sương giá",
  },
  {
    word: "sương",
    part_of_speech: "danh từ",
    meaning:
      "hơi nước ngưng tụ lại thành hạt màu trắng rất nhỏ bay lơ lửng trong lớp không khí gần mặt đất: dãi nắng dầm sương * trời đầy sương",
    example: "dãi nắng dầm sương * trời đầy sương",
  },
  {
    word: "sương",
    part_of_speech: "danh từ",
    meaning:
      "(cũng sương móc) hơi nước ngưng tụ đọng lại thành hạt trên cành cây ngọn cỏ: những giọt sương long lanh đọng trên lá",
    example: "những giọt sương long lanh đọng trên lá",
  },
  {
    word: "sương",
    part_of_speech: "danh từ",
    meaning:
      '(văn chương) (tóc) màu trắng như sương: mái tóc đã điểm sương * "Chốc đà mười mấy năm trời, Còn ra khi đã da mồi tóc sương." (TKiều)',
    example:
      'mái tóc đã điểm sương * "Chốc đà mười mấy năm trời, Còn ra khi đã da mồi tóc sương." (TKiều)',
  },
  {
    word: "sương gió",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương) sương và gió (nói khái quát); thường dùng để ví cảnh gian truân vất vả trong cuộc đời: dãi dầu sương gió * cuộc đời đầy sương gió",
    example: "dãi dầu sương gió * cuộc đời đầy sương gió",
  },
  {
    word: "sượng mặt",
    part_of_speech: "",
    meaning:
      "xấu hổ, ngại ngùng lộ rõ trên vẻ mặt (đến mức cảm thấy mặt mình như trơ ra trước người khác): bị mắng cho sượng mặt",
    example: "bị mắng cho sượng mặt",
  },
  {
    word: "sương khói",
    part_of_speech: "danh từ",
    meaning:
      "sương và khói (nói khái quát); thường dùng để ví những cái gì hư ảo, mong manh, khó nắm bắt: trời mịt mù sương khói * mọi hi vọng chỉ còn là sương khói",
    example: "trời mịt mù sương khói * mọi hi vọng chỉ còn là sương khói",
  },
  {
    word: "sượng sùng",
    part_of_speech: "tính từ",
    meaning:
      "ngượng ngùng, lúng túng: vẻ mặt sượng sùng * sượng sùng như cô dâu mới",
    example: "vẻ mặt sượng sùng * sượng sùng như cô dâu mới",
  },
  {
    word: "sương móc",
    part_of_speech: "danh từ",
    meaning:
      "hơi nước ngưng tụ lại thành hạt màu trắng rất nhỏ bay lơ lửng trong lớp không khí gần mặt đất: dãi nắng dầm sương * trời đầy sương",
    example: "dãi nắng dầm sương * trời đầy sương",
  },
  {
    word: "sương móc",
    part_of_speech: "danh từ",
    meaning:
      "(cũng sương móc) hơi nước ngưng tụ đọng lại thành hạt trên cành cây ngọn cỏ: những giọt sương long lanh đọng trên lá",
    example: "những giọt sương long lanh đọng trên lá",
  },
  {
    word: "sương móc",
    part_of_speech: "danh từ",
    meaning:
      '(văn chương) (tóc) màu trắng như sương: mái tóc đã điểm sương * "Chốc đà mười mấy năm trời, Còn ra khi đã da mồi tóc sương." (TKiều)',
    example:
      'mái tóc đã điểm sương * "Chốc đà mười mấy năm trời, Còn ra khi đã da mồi tóc sương." (TKiều)',
  },
  {
    word: "sương mù",
    part_of_speech: "danh từ",
    meaning: "(ng1): sương mù dày đặc",
    example: "sương mù dày đặc",
  },
  {
    word: "sướt",
    part_of_speech: "động từ",
    meaning: "bay sát qua, gần như đã chạm vào: viên đạn sướt qua vai",
    example: "viên đạn sướt qua vai",
  },
  {
    word: "sướt",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ tướt bơ) có vệt xước: má bị sướt * tay bị gai cào sướt",
    example: "má bị sướt * tay bị gai cào sướt",
  },
  {
    word: "sương muối",
    part_of_speech: "danh từ",
    meaning:
      "sương đông thành những hạt băng trắng xoá phủ trên mặt đất và cây cỏ, trông như muối: đầu năm sương muối, cuối năm gió nồm (tng)",
    example: "đầu năm sương muối, cuối năm gió nồm (tng)",
  },
  {
    word: "sướng rơn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) cảm thấy sung sướng đến mức như rộn lên trong lòng: thằng nhỏ sướng rơn vì thấy má về sớm",
    example: "thằng nhỏ sướng rơn vì thấy má về sớm",
  },
  {
    word: "sứt",
    part_of_speech: "",
    meaning:
      "(vật rắn) bị mất đi một bộ phận nhỏ hay một mảnh tương đối lớn ở cạnh, ở rìa: sứt răng * bát sứt",
    example: "sứt răng * bát sứt",
  },
  {
    word: "sứt",
    part_of_speech: "",
    meaning: "bị tuột, bị đứt ra một đoạn: áo sứt chỉ",
    example: "áo sứt chỉ",
  },
  {
    word: "sượt",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả dáng nằm dài ra, tựa như bất động: mệt quá, nằm sượt ra",
    example: "mệt quá, nằm sượt ra",
  },
  {
    word: "sượt",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả tiếng thở dài buông ra, biểu lộ tâm trạng chán chường: thở dài đánh sượt",
    example: "thở dài đánh sượt",
  },
  {
    word: "sứt đầu mẻ trán",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) bị thương tích, thương tổn nặng (do đánh nhau): đánh nhau sứt đầu mẻ trán",
    example: "đánh nhau sứt đầu mẻ trán",
  },
  {
    word: "sướt mướt",
    part_of_speech: "tính từ",
    meaning: "(khóc) nhiều và lâu không dứt, nước mắt đầm đìa: khóc sướt mướt",
    example: "khóc sướt mướt",
  },
  {
    word: "sướt mướt",
    part_of_speech: "tính từ",
    meaning:
      "có tác dụng gây tâm trạng buồn bã, yếu đuối và dai dẳng không dứt: giọng ca sướt mướt * phim tình cảm sướt mướt",
    example: "giọng ca sướt mướt * phim tình cảm sướt mướt",
  },
  {
    word: "sửu",
    part_of_speech: "danh từ",
    meaning:
      "(thường viết hoa) kí hiệu thứ hai trong địa chi (lấy trâu làm tượng trưng; sau tí trước dần), dùng trong phép đếm thời gian cổ truyền của Trung Quốc và một số nước châu á, trong đó có Việt Nam: giờ Sửu (từ 1 đến 3 giờ sáng) * năm Kỉ Sửu",
    example: "giờ Sửu (từ 1 đến 3 giờ sáng) * năm Kỉ Sửu",
  },
  {
    word: "sứt sát",
    part_of_speech: "tính từ",
    meaning:
      "bị sứt mẻ và có nhiều vết xước, không còn lành nguyên nữa: báng súng bị sứt sát vì mảnh đạn * ngã nhưng không hề bị sứt sát",
    example: "báng súng bị sứt sát vì mảnh đạn * ngã nhưng không hề bị sứt sát",
  },
  {
    word: "sứt mẻ",
    part_of_speech: "tính từ",
    meaning:
      "bị mất đi một phần đáng kể, không còn nguyên vẹn (nói khái quát): cái bát bị sứt mẻ nhiều chỗ * tình cảm bị sứt mẻ",
    example: "cái bát bị sứt mẻ nhiều chỗ * tình cảm bị sứt mẻ",
  },
  {
    word: "sứt sẹo",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều vết sứt, vết sẹo, không còn được nguyên vẹn (nói khái quát): bàn tay sứt sẹo",
    example: "bàn tay sứt sẹo",
  },
  {
    word: "sưu dịch",
    part_of_speech: "danh từ",
    meaning: "(cũ) việc sưu (nói khái quát): sưu dịch nặng nề",
    example: "sưu dịch nặng nề",
  },
  {
    word: "sưu",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) công việc lao động nặng nhọc mà người đàn ông dân thường từ mười tám đến sáu mươi tuổi phải làm cho nhà nước phong kiến: đi sưu",
    example: "đi sưu",
  },
  {
    word: "sưu",
    part_of_speech: "danh từ",
    meaning:
      "khoản tiền mà người đàn ông dân thường từ mười tám đến sáu mươi tuổi buộc phải nộp hằng năm cho nhà nước phong kiến, thực dân (một loại thuế thân): nộp sưu",
    example: "nộp sưu",
  },
  {
    word: "sưu thuế",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) tiền sưu và các khoản tiền thuế dưới thời phong kiến, thực dân (nói khái quát): sưu thuế nặng nề",
    example: "sưu thuế nặng nề",
  },
  {
    word: "sưu tầm",
    part_of_speech: "động từ",
    meaning:
      "tìm kiếm, thu thập một cách có hệ thống: sưu tầm tài liệu * sưu tầm tem * có thú sưu tầm đồ cổ",
    example: "sưu tầm tài liệu * sưu tầm tem * có thú sưu tầm đồ cổ",
  },
  {
    word: "tá",
    part_of_speech: "danh từ",
    meaning:
      "cấp quân hàm của sĩ quan trên cấp uý, dưới cấp tướng: về hưu với quân hàm cấp tá",
    example: "về hưu với quân hàm cấp tá",
  },
  {
    word: "tá",
    part_of_speech: "danh từ",
    meaning:
      "số gộp chung mười hai đơn vị làm một; cũng dùng để chỉ số lượng nhiều: một tá bút chì * mua hàng tá khăn mặt",
    example: "một tá bút chì * mua hàng tá khăn mặt",
  },
  {
    word: "tá",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) kiếm chuyện để lấy cớ vin vào: tá chuyện để đòi tiền hối lộ",
    example: "tá chuyện để đòi tiền hối lộ",
  },
  {
    word: "tá",
    part_of_speech: "trợ từ",
    meaning:
      '(cũ, văn chương) từ biểu thị ý thương cảm khi hỏi (vừa có nghĩa nghi vấn, vừa có nghĩa cảm thán, nay ít dùng): "Trông tin nhạn biết là đâu tá?, Tâm tình này ai tả cho nên." (TDLH)',
    example:
      'Trông tin nhạn biết là đâu tá?, Tâm tình này ai tả cho nên." (TDLH)',
  },
  {
    word: "sưu tập",
    part_of_speech: "động từ",
    meaning: "tìm kiếm và tập hợp lại: sưu tập thơ * sưu tập tranh dân gian",
    example: "sưu tập thơ * sưu tập tranh dân gian",
  },
  {
    word: "sưu tập",
    part_of_speech: "danh từ",
    meaning: "tập hợp những cái đã sưu tập được: bộ sưu tập tem",
    example: "bộ sưu tập tem",
  },
  {
    word: "tả",
    part_of_speech: "danh từ",
    meaning: "(Khẩu ngữ) dịch tả (nói tắt): tiêm phòng tả",
    example: "tiêm phòng tả",
  },
  {
    word: "tả",
    part_of_speech: "danh từ",
    meaning:
      "bên trái, trong mối quan hệ đối lập với hữu là bên phải: phía bên tả * tả xung hữu đột (tng)",
    example: "phía bên tả * tả xung hữu đột (tng)",
  },
  {
    word: "tả",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận thiên về tiến bộ, về cách mạng trong nghị viện hoặc trong các tổ chức chính trị ở một số nước tư bản, trong mối quan hệ đối lập với hữu là bộ phận thiên về bảo thủ, thoả hiệp hay phản cách mạng: phái tả lên cầm quyền * đảng cánh tả",
    example: "phái tả lên cầm quyền * đảng cánh tả",
  },
  {
    word: "tả",
    part_of_speech: "tính từ",
    meaning:
      "có chủ trương, hành động quá mạnh, quá sớm, không thích hợp với điều kiện thực tế: hành động quá tả",
    example: "hành động quá tả",
  },
  {
    word: "tả",
    part_of_speech: "động từ",
    meaning:
      "diễn đạt bằng ngôn ngữ cho người khác có thể hình dung ra được một cách rõ ràng: văn tả cảnh * niềm vui khó tả * đẹp không bút nào tả nổi",
    example: "văn tả cảnh * niềm vui khó tả * đẹp không bút nào tả nổi",
  },
  {
    word: "tả",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái rời ra, nát ra thành những mảnh vụn nhỏ: giấy ướt tả ra * chiếc áo đã quá tả",
    example: "giấy ướt tả ra * chiếc áo đã quá tả",
  },
  {
    word: "tã",
    part_of_speech: "danh từ",
    meaning:
      "mảnh vải hoặc giấy dùng để quấn, lót cho trẻ mới sinh, còn ít tháng: thay tã cho con * băng tã * chứng hăm tã",
    example: "thay tã cho con * băng tã * chứng hăm tã",
  },
  {
    word: "tã",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) quá cũ, đã rách nát hoặc hư hỏng nhiều: đôi giày đã tã * chiếc xe đã quá tã",
    example: "đôi giày đã tã * chiếc xe đã quá tã",
  },
  {
    word: "ta",
    part_of_speech: "đại từ",
    meaning:
      "(Từ cũ) từ dùng để tự xưng khi nói với người ở bậc dưới: để ta nói cho các ngươi biết",
    example: "để ta nói cho các ngươi biết",
  },
  {
    word: "ta",
    part_of_speech: "đại từ",
    meaning:
      '(Văn chương) từ dùng để tự xưng khi nói với người ngang hàng với ý thân thiết hoặc khi tự nói với mình: "Mình về mình có nhớ ta, Ta về ta nhớ những hoa cùng người." (THữu; 39)',
    example:
      'Mình về mình có nhớ ta, Ta về ta nhớ những hoa cùng người." (THữu; 39)',
  },
  {
    word: "ta",
    part_of_speech: "đại từ",
    meaning:
      "từ dùng để chỉ gộp chung mình và người đối thoại với ý thân mật, gần gũi (hàm ý coi nhau như chỉ là một): đôi ta * dân tộc ta",
    example: "đôi ta * dân tộc ta",
  },
  {
    word: "ta",
    part_of_speech: "đại từ",
    meaning:
      "(Khẩu ngữ) từ dùng trong đối thoại để chỉ người đã được nói đến trước đó với ý không coi trọng: cô ta là ai? * hắn ta * lão ta",
    example: "cô ta là ai? * hắn ta * lão ta",
  },
  {
    word: "ta",
    part_of_speech: "tính từ",
    meaning:
      "từ người Việt Nam dùng để chỉ những thứ có nguồn gốc là của dân tộc, của đất nước mình; phân biệt với tây, tàu: Tết ta (tết âm lịch) * táo ta * thuốc ta (thuốc Nam) * thịt gà ta ngon hơn thịt gà lai",
    example:
      "Tết ta (tết âm lịch) * táo ta * thuốc ta (thuốc Nam) * thịt gà ta ngon hơn thịt gà lai",
  },
  {
    word: "ta",
    part_of_speech: "trợ từ",
    meaning:
      "(Phương ngữ, Khẩu ngữ) từ dùng để nhấn mạnh với vẻ hơi ngạc nhiên hoặc có ý hỏi, để biểu thị ý thân mật: ông già quê ở đâu ta? * sao kì quá vậy ta? * giỏi quá ta!",
    example: "ông già quê ở đâu ta? * sao kì quá vậy ta? * giỏi quá ta!",
  },
  {
    word: "tạ",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ thể thao, gồm hai khối kim loại lắp ở hai đầu đòn, dùng để tập nâng, nhấc: cử tạ * nâng tạ ở mức 150kg",
    example: "cử tạ * nâng tạ ở mức 150kg",
  },
  {
    word: "tạ",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ thể thao hình cầu bằng kim loại, có khối lượng quy định, dùng để tập đẩy đi xa: thi môn đẩy tạ",
    example: "thi môn đẩy tạ",
  },
  {
    word: "tạ",
    part_of_speech: "danh từ",
    meaning: "đơn vị đo khối lượng, bằng 100 kilogram: một tạ thóc",
    example: "một tạ thóc",
  },
  {
    word: "tạ",
    part_of_speech: "động từ",
    meaning:
      'bày tỏ lòng biết ơn hay xin lỗi một cách trân trọng: tạ lỗi * "Vắng nhà được buổi hôm nay, Lấy lòng gọi chút ra đây tạ lòng!" (TKiều)',
    example:
      'tạ lỗi * "Vắng nhà được buổi hôm nay, Lấy lòng gọi chút ra đây tạ lòng!" (TKiều)',
  },
  {
    word: "tà dương",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) mặt trời lúc sắp lặn: "Làn mây bạc long lanh đáy nước, Bóng tà dương đã gác non đoài." (ca dao)',
    example:
      'Làn mây bạc long lanh đáy nước, Bóng tà dương đã gác non đoài." (ca dao)',
  },
  {
    word: "tả chân",
    part_of_speech: "động từ",
    meaning: "như tả thực: lối văn tả chân",
    example: "lối văn tả chân",
  },
  {
    word: "tà dâm",
    part_of_speech: "tính từ",
    meaning:
      'dâm dục: "Xét trong tội nghiệp Thuý Kiều, Mắc điều tình ái, khỏi điều tà dâm." (TKiều)',
    example:
      'Xét trong tội nghiệp Thuý Kiều, Mắc điều tình ái, khỏi điều tà dâm." (TKiều)',
  },
  {
    word: "tà dâm",
    part_of_speech: "động từ",
    meaning: "như gian dâm: tội tà dâm",
    example: "tội tà dâm",
  },
  {
    word: "ta đây",
    part_of_speech: "",
    meaning:
      "(Khẩu ngữ) tổ hợp biểu thị ý phê phán thái độ hợm mình, cho là chỉ có ta mới được thế, mới đáng thế: tỏ vẻ ta đây * lên mặt ta đây",
    example: "tỏ vẻ ta đây * lên mặt ta đây",
  },
  {
    word: "tá dược",
    part_of_speech: "danh từ",
    meaning:
      "những chất phụ gia được dùng để chế dược phẩm, không có tác dụng chữa bệnh, như than, bột, sáp ong, v.v.: thành phần tá dược vừa đủ",
    example: "thành phần tá dược vừa đủ",
  },
  {
    word: "tà",
    part_of_speech: "danh từ",
    meaning:
      'đường nẹp nhỏ ở dọc hai bên vạt của một số loại áo như áo bà ba, áo dài: "Áo anh sứt chỉ đường tà, Vợ anh chưa có mẹ già chưa khâu." (ca dao)',
    example:
      'Áo anh sứt chỉ đường tà, Vợ anh chưa có mẹ già chưa khâu." (ca dao)',
  },
  {
    word: "tà",
    part_of_speech: "danh từ",
    meaning: "phần dưới của thân áo dài: tà áo bay bay trong gió",
    example: "tà áo bay bay trong gió",
  },
  {
    word: "tà",
    part_of_speech: "danh từ",
    meaning:
      "ma quỷ làm hại người, theo mê tín: đuổi như đuổi tà * bắt quyết để trừ tà",
    example: "đuổi như đuổi tà * bắt quyết để trừ tà",
  },
  {
    word: "tà",
    part_of_speech: "tính từ",
    meaning:
      "mờ ám, không ngay thẳng hoặc không đúng đắn về mặt đạo đức: cải tà quy chính * không phân biệt chính với tà",
    example: "cải tà quy chính * không phân biệt chính với tà",
  },
  {
    word: "tà",
    part_of_speech: "tính từ",
    meaning:
      '(ánh mặt trời, mặt trăng) chếch hẳn về một phía khi ngày hoặc đêm đã quá muộn, đã sắp hết: ánh chiều tà * thỏ lặn ác tà * "Đêm khuya giục bóng trăng tà, Sao Mai đã mọc, tiếng gà gọi con." (ca dao)',
    example:
      'ánh chiều tà * thỏ lặn ác tà * "Đêm khuya giục bóng trăng tà, Sao Mai đã mọc, tiếng gà gọi con." (ca dao)',
  },
  {
    word: "tà đạo",
    part_of_speech: "danh từ",
    meaning:
      "đạo xằng bậy (từ một số người sùng tín một đạo nào đó, đặc biệt là đạo chính thống, dùng để gọi những đạo khác): dùng tà đạo để mê hoặc lòng người",
    example: "dùng tà đạo để mê hoặc lòng người",
  },
  {
    word: "bỗng không",
    part_of_speech: "phụ từ",
    meaning:
      'bỗng nhiên, không duyên cớ: "Suy di đâu biết cơ trời, Bỗng không mà hoá ra người vị vong." (CO)',
    example:
      'Suy di đâu biết cơ trời, Bỗng không mà hoá ra người vị vong." (CO)',
  },
  {
    word: "bông đùa",
    part_of_speech: "động từ",
    meaning:
      "đùa, thường bằng lời nói (nói khái quát): nói bằng giọng bông đùa * tính hay bông đùa",
    example: "nói bằng giọng bông đùa * tính hay bông đùa",
  },
  {
    word: "bỗng đâu",
    part_of_speech: "phụ từ",
    meaning:
      'bỗng nhiên, không rõ từ đâu: nước mắt bỗng đâu cứ ứa ra * "Lần thâu gió mát trăng thanh, Bỗng đâu có khách biên đình sang chơi." (TKiều)',
    example:
      'nước mắt bỗng đâu cứ ứa ra * "Lần thâu gió mát trăng thanh, Bỗng đâu có khách biên đình sang chơi." (TKiều)',
  },
  {
    word: "bồng lai tiên cảnh",
    part_of_speech: "",
    meaning:
      "(cũ, văn chương) nơi tiên ở, có cảnh đẹp và cuộc sống hạnh phúc (như con người mơ ước): chốn bồng lai tiên cảnh",
    example: "chốn bồng lai tiên cảnh",
  },
  {
    word: "bồng lai",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương, thường viết hoa) tên ngọn núi Bồng Lai nơi tiên ở (theo thần thoại của Trung Quốc); dùng để nói cảnh đẹp và cuộc sống hạnh phúc mà con người mơ ước: "Người hay lại gặp cảnh hay, Khác nào tiên tử chơi rày Bồng Lai." (LVT)',
    example:
      'Người hay lại gặp cảnh hay, Khác nào tiên tử chơi rày Bồng Lai." (LVT)',
  },
  {
    word: "bông lơn",
    part_of_speech: "động từ",
    meaning: "nói đùa, thường là không đứng đắn: nói bông lơn",
    example: "nói bông lơn",
  },
  {
    word: "bổng lộc",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) lương và các khoản hưởng phụ khác của quan lại (nói tổng quát): được hưởng bổng lộc của triều đình",
    example: "được hưởng bổng lộc của triều đình",
  },
  {
    word: "bổng lộc",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) các khoản lợi có được do chức vụ, địa vị mang lại (nói tổng quát; thường hàm ý chê): tha hồ mà hưởng bổng lộc * lương ít nhưng bổng lộc nhiều",
    example: "tha hồ mà hưởng bổng lộc * lương ít nhưng bổng lộc nhiều",
  },
  {
    word: "bông lông",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như lông bông: đi chơi bông lông",
    example: "đi chơi bông lông",
  },
  {
    word: "bông tai",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) hoa tai: đôi bông tai bằng vàng",
    example: "đôi bông tai bằng vàng",
  },
  {
    word: "bông phèng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bông đùa một cách dễ dãi, tuỳ tiện, chỉ để cho vui: tính hay bông phèng",
    example: "tính hay bông phèng",
  },
  {
    word: "bỗng nhiên",
    part_of_speech: "phụ từ",
    meaning:
      "(hành động, quá trình xảy ra) một cách tự nhiên và bất ngờ, không lường trước được: đang nắng, bỗng nhiên trời đổ mưa * những kỉ niệm cũ bỗng nhiên sống dậy",
    example:
      "đang nắng, bỗng nhiên trời đổ mưa * những kỉ niệm cũ bỗng nhiên sống dậy",
  },
  {
    word: "bồng súng",
    part_of_speech: "động từ",
    meaning:
      "cầm súng nâng lên một cách nghiêm trang theo thể thức quy định: bồng súng chào",
    example: "bồng súng chào",
  },
  {
    word: "bộp",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng âm thanh trầm và gọn như tiếng vật nặng rơi mạnh xuống mặt đất: quả mít rơi bộp xuống đất * vỗ tay cái bộp",
    example: "quả mít rơi bộp xuống đất * vỗ tay cái bộp",
  },
  {
    word: "bốp chát",
    part_of_speech: "động từ",
    meaning:
      "nói năng, đối đáp gay gắt một cách thô bạo, không kiêng nể: ăn nói bốp chát * hơi một tí là bốp chát luôn",
    example: "ăn nói bốp chát * hơi một tí là bốp chát luôn",
  },
  {
    word: "bốp",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) nói thẳng vào mặt, không kiêng nể: nổi cáu, bốp luôn mấy câu * nói bốp vào mặt",
    example: "nổi cáu, bốp luôn mấy câu * nói bốp vào mặt",
  },
  {
    word: "bốp",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng kêu vang to và đanh như tiếng tát, vỗ mạnh: tát bốp vào mặt",
    example: "tát bốp vào mặt",
  },
  {
    word: "bốp",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ, hiếm) (quần áo, cách ăn mặc) đẹp một cách chải chuốt: diện thật bốp",
    example: "diện thật bốp",
  },
  {
    word: "bốt",
    part_of_speech: "danh từ",
    meaning:
      "nơi đóng quân nhỏ hoặc trạm canh gác của binh lính, cảnh sát dưới chế độ thực dân: bốt cảnh sát * bốt gác * giặc đóng bốt trong làng",
    example: "bốt cảnh sát * bốt gác * giặc đóng bốt trong làng",
  },
  {
    word: "bốt",
    part_of_speech: "danh từ",
    meaning: "giày cổ cao đến gần đầu gối: chân đi đôi bốt trắng",
    example: "chân đi đôi bốt trắng",
  },
  {
    word: "bột",
    part_of_speech: "danh từ",
    meaning: "cá bột (nói tắt): cá mè bột",
    example: "cá mè bột",
  },
  {
    word: "bột",
    part_of_speech: "danh từ",
    meaning:
      "chất chứa nhiều trong hạt ngũ cốc hoặc các loại củ, dễ xay giã thành những hạt nhỏ mịn: xay bột làm bánh * bột mì * có bột mới gột nên hồ (tng)",
    example: "xay bột làm bánh * bột mì * có bột mới gột nên hồ (tng)",
  },
  {
    word: "bột",
    part_of_speech: "danh từ",
    meaning: "món ăn của trẻ em nấu từ bột gạo: quấy bột * cho bé ăn bột",
    example: "quấy bột * cho bé ăn bột",
  },
  {
    word: "bột",
    part_of_speech: "danh từ",
    meaning:
      "dạng hạt nhỏ mịn như bột: nghiền thành bột * vôi bột * đất bột * bột màu",
    example: "nghiền thành bột * vôi bột * đất bột * bột màu",
  },
  {
    word: "bột",
    part_of_speech: "danh từ",
    meaning:
      "calcium sulfat ngậm nước, có dạng bột, dùng để bó chỗ xương gãy: bị gãy chân phải bó bột * tháo bột",
    example: "bị gãy chân phải bó bột * tháo bột",
  },
  {
    word: "bộp chộp",
    part_of_speech: "tính từ",
    meaning:
      "(tính người) chưa suy nghĩ kĩ đã vội nói, vội làm: ăn nói bộp chộp * tính nông nổi và bộp chộp",
    example: "ăn nói bộp chộp * tính nông nổi và bộp chộp",
  },
  {
    word: "bơ",
    part_of_speech: "danh từ",
    meaning: "chất béo màu vàng nhạt tách ra từ sữa tươi: ăn bánh mì với bơ",
    example: "ăn bánh mì với bơ",
  },
  {
    word: "bơ",
    part_of_speech: "danh từ",
    meaning:
      "cây ăn quả, lá to dài hình xoan hoặc thuôn, hay bầu dục, quả có vỏ và thịt màu xanh lục, khi chín thịt chuyển thành màu vàng nhạt, ăn có vị béo (như bơ)",
    example: "vay vài bơ gạo",
  },
  {
    word: "bơ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) cố tình làm ra vẻ như không mảy may để ý đến (trước điều lẽ ra phải được chú ý): hỏi gì nó cũng bơ đi, như không thèm để ý",
    example: "hỏi gì nó cũng bơ đi, như không thèm để ý",
  },
  {
    word: "bột nở",
    part_of_speech: "danh từ",
    meaning:
      "bột mịn dễ tan trong nước, thường dùng trong chế biến thực phẩm để làm tăng thêm độ nở, độ tơi xốp: cho bột nở vào làm bánh mì",
    example: "cho bột nở vào làm bánh mì",
  },
  {
    word: "bớ",
    part_of_speech: "cảm từ",
    meaning:
      "(Từ cũ, hoặc ph) tiếng gọi người (thường là người ngang hàng hoặc người dưới) ở đằng xa: bớ ba quân tướng sĩ! * bớ bà con, cướp, cướp!",
    example: "bớ ba quân tướng sĩ! * bớ bà con, cướp, cướp!",
  },
  {
    word: "bợ",
    part_of_speech: "động từ",
    meaning:
      "(Phương ngữ) đỡ phía dưới mà nâng lên bằng bàn tay đặt ngửa: bợ thúng thóc lên",
    example: "bợ thúng thóc lên",
  },
  {
    word: "bột phát",
    part_of_speech: "động từ",
    meaning:
      "phát sinh đột ngột: cơn đau tim bột phát * tình cảm bột phát * hành động của anh ta chỉ là bột phát",
    example:
      "cơn đau tim bột phát * tình cảm bột phát * hành động của anh ta chỉ là bột phát",
  },
  {
    word: "bờ",
    part_of_speech: "danh từ",
    meaning:
      "dải đất làm giới hạn cho một vùng nước hoặc để ngăn giữ nước: bờ ao  * tức nước vỡ bờ (tng)",
    example: "bờ ao  * tức nước vỡ bờ (tng)",
  },
  {
    word: "bờ",
    part_of_speech: "danh từ",
    meaning:
      'hàng cây cối rậm rạp hoặc tường xây dùng làm giới hạn cho một khoảng đất nhất định: bờ rào râm bụt * bờ tường * "Chuông khánh còn chẳng ăn ai, Nữa là mảnh chĩnh bỏ ngoài bờ tre." (ca dao)',
    example:
      'bờ rào râm bụt * bờ tường * "Chuông khánh còn chẳng ăn ai, Nữa là mảnh chĩnh bỏ ngoài bờ tre." (ca dao)',
  },
  {
    word: "bờ",
    part_of_speech: "danh từ",
    meaning:
      "phần nhô lên và bao quanh một khoảng lõm trên cơ thể: vết loét đã nổi bờ * bờ môi tím tái * tóc xoã bờ vai",
    example: "vết loét đã nổi bờ * bờ môi tím tái * tóc xoã bờ vai",
  },
  {
    word: "bờ bụi",
    part_of_speech: "danh từ",
    meaning:
      "bờ và bụi (nói khái quát): tìm khắp các bờ bụi * con chó chui rúc bờ bụi",
    example: "tìm khắp các bờ bụi * con chó chui rúc bờ bụi",
  },
  {
    word: "bở",
    part_of_speech: "tính từ",
    meaning:
      "dễ tơi ra, vụn ra khi chịu tác động của lực cơ học: khoai bở tung * đất bở như vôi",
    example: "khoai bở tung * đất bở như vôi",
  },
  {
    word: "bở",
    part_of_speech: "tính từ",
    meaning:
      "không bền, dễ bục, dễ đứt ra khi chịu tác động của lực cơ học: sợi dây rất bở * chiếc áo mặc lâu ngày đã bở sợi",
    example: "sợi dây rất bở * chiếc áo mặc lâu ngày đã bở sợi",
  },
  {
    word: "bở",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) dễ mang lại lợi, mang lại hiệu quả mà không phải tốn nhiều sức: vớ được món bở",
    example: "vớ được món bở",
  },
  {
    word: "bở",
    part_of_speech: "tính từ",
    meaning: "(Khẩu ngữ) (mệt) rã rời: mệt bở cả người",
    example: "mệt bở cả người",
  },
  {
    word: "bờ bến",
    part_of_speech: "danh từ",
    meaning:
      "bờ và bến, nơi giới hạn, tiếp giáp giữa nơi sông nước với đất liền (nói khái quát): biển cả mênh mông, không thấy đâu là bờ bến * tình yêu không bờ bến",
    example:
      "biển cả mênh mông, không thấy đâu là bờ bến * tình yêu không bờ bến",
  },
  {
    word: "bờ cõi",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, hiếm) ranh giới giữa nước này với nước khác: quân giặc đã tiến sát bờ cõi",
    example: "quân giặc đã tiến sát bờ cõi",
  },
  {
    word: "bờ cõi",
    part_of_speech: "danh từ",
    meaning: "phần lãnh thổ của một quốc gia: mở mang bờ cõi * xâm phạm bờ cõi",
    example: "mở mang bờ cõi * xâm phạm bờ cõi",
  },
  {
    word: "bợ đít",
    part_of_speech: "động từ",
    meaning: "(thông tục) nịnh hót, luồn cúi một cách đê hèn: bợ đít quan thầy",
    example: "bợ đít quan thầy",
  },
  {
    word: "bở hơi tai",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) mệt đến mức như hơi ra cả ở tai: mệt bở hơi tai * làm bở hơi tai vẫn không xong",
    example: "mệt bở hơi tai * làm bở hơi tai vẫn không xong",
  },
  {
    word: "bợ đỡ",
    part_of_speech: "động từ",
    meaning: "nịnh hót để mưu lợi: xun xoe bợ đỡ * bợ đỡ kẻ quyền thế",
    example: "xun xoe bợ đỡ * bợ đỡ kẻ quyền thế",
  },
  {
    word: "bỡ ngỡ",
    part_of_speech: "",
    meaning:
      "có cảm giác ngỡ ngàng, lúng túng vì còn mới lạ, chưa quen: bỡ ngỡ với công việc * mới đến, còn bỡ ngỡ",
    example: "bỡ ngỡ với công việc * mới đến, còn bỡ ngỡ",
  },
  {
    word: "bờ rào",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) hàng rào bao quanh sân, vườn: con chó chui qua bờ rào",
    example: "con chó chui qua bờ rào",
  },
  {
    word: "bơ phờ",
    part_of_speech: "tính từ",
    meaning:
      'có vẻ ngoài lộ rõ trạng thái rất mệt mỏi, trông như mất hết cả sinh khí, sức lực: vẻ mặt bơ phờ * "Trời hôm tựa bóng ngẩn ngơ, Trăng khuya sương gối bơ phờ tóc mai." (CPN)',
    example:
      'vẻ mặt bơ phờ * "Trời hôm tựa bóng ngẩn ngơ, Trăng khuya sương gối bơ phờ tóc mai." (CPN)',
  },
  {
    word: "bở vía",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) không còn hồn vía; mất hết tinh thần vì quá sợ hãi: sợ bở vía * bị một phen bở vía",
    example: "sợ bở vía * bị một phen bở vía",
  },
  {
    word: "bờ quai",
    part_of_speech: "danh từ",
    meaning:
      "bờ phụ để ngăn nước ở phía cao, nối liền quanh một bờ lớn: đắp bờ quai giữ nước",
    example: "đắp bờ quai giữ nước",
  },
  {
    word: "bơ thờ",
    part_of_speech: "tính từ",
    meaning:
      '(hiếm) thẫn thờ và ngơ ngẩn vì không ổn định trong lòng: "Anh như con nhạn bơ thờ, Sớm ăn tối đậu cành tơ một mình." (ca dao)',
    example:
      'Anh như con nhạn bơ thờ, Sớm ăn tối đậu cành tơ một mình." (ca dao)',
  },
  {
    word: "bơ vơ",
    part_of_speech: "tính từ",
    meaning:
      'lẻ loi một mình, không nơi nương tựa: bơ vơ, không nơi nương tựa * "Trời đông vừa rạng ngàn dâu, Bơ vơ nào đã biết đâu là nhà." (TKiều)',
    example:
      'bơ vơ, không nơi nương tựa * "Trời đông vừa rạng ngàn dâu, Bơ vơ nào đã biết đâu là nhà." (TKiều)',
  },
  {
    word: "bới",
    part_of_speech: "động từ",
    meaning:
      "(Nam cũng bươi) xới lên và gạt đi những gì phủ bên trên để tìm lấy cái vùi lấp bên dưới: gà bới rác tìm mồi * đi bới khoai",
    example: "gà bới rác tìm mồi * đi bới khoai",
  },
  {
    word: "bới",
    part_of_speech: "động từ",
    meaning:
      'moi móc để tìm cho ra, cho thành ra có: bới xấu nhau * bới việc ra cho làm * "Hắn bới ra từng tội một, và nhất định sẽ bới ra đến hết." (NCao; 9)',
    example:
      'bới xấu nhau * bới việc ra cho làm * "Hắn bới ra từng tội một, và nhất định sẽ bới ra đến hết." (NCao; 9)',
  },
  {
    word: "bới",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) réo tên cha mẹ tổ tiên người ta ra mà chửi: bới cha mẹ người ta ra mà chửi!",
    example: "bới cha mẹ người ta ra mà chửi!",
  },
  {
    word: "bới",
    part_of_speech: "động từ",
    meaning: "(Nam) xới (cơm): bới một bát cơm đầy",
    example: "bới một bát cơm đầy",
  },
  {
    word: "bới",
    part_of_speech: "động từ",
    meaning: "mang cái ăn theo khi đi xa nhà: cơm đùm gạo bới",
    example: "cơm đùm gạo bới",
  },
  {
    word: "bới",
    part_of_speech: "động từ",
    meaning: "(Nam) búi: tóc bới cao",
    example: "tóc bới cao",
  },
  {
    word: "bơi",
    part_of_speech: "động từ",
    meaning:
      "di chuyển trong nước hoặc trên mặt nước bằng cử động của thân thể: đàn cá bơi tung tăng * không biết bơi",
    example: "đàn cá bơi tung tăng * không biết bơi",
  },
  {
    word: "bơi",
    part_of_speech: "động từ",
    meaning:
      "gạt nước bằng mái dầm, mái chèo để làm cho thuyền bè di chuyển: bơi xuồng đi câu",
    example: "bơi xuồng đi câu",
  },
  {
    word: "bơi",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) làm việc rất vất vả, lúng túng do việc quá nhiều hoặc vượt quá khả năng: bơi trong đống giấy tờ, tài liệu",
    example: "bơi trong đống giấy tờ, tài liệu",
  },
  {
    word: "bởi",
    part_of_speech: "kết từ",
    meaning:
      'từ biểu thị điều sắp nêu ra là lí do hoặc nguyên nhân của việc được nói đến: mắt thâm quầng bởi thức khuya nhiều * "Trắng da vì bởi phấn dồi, Đen da vì bởi em ngồi chợ trưa." (ca dao)',
    example:
      'mắt thâm quầng bởi thức khuya nhiều * "Trắng da vì bởi phấn dồi, Đen da vì bởi em ngồi chợ trưa." (ca dao)',
  },
  {
    word: "bởi",
    part_of_speech: "kết từ",
    meaning:
      'từ biểu thị điều sắp nêu ra là người hoặc vật gây ra trạng thái đã nói đến: "Trăng lu vì bởi áng mây, Đôi ta cách trở vì dây tơ hồng." (ca dao)',
    example:
      'Trăng lu vì bởi áng mây, Đôi ta cách trở vì dây tơ hồng." (ca dao)',
  },
  {
    word: "bởi chưng",
    part_of_speech: "kết từ",
    meaning:
      '(cũ) như bởi vì: "Bởi chưng thầy mẹ nói ngang, Để cho đũa ngọc mâm vàng cách xa." (ca dao)',
    example:
      'Bởi chưng thầy mẹ nói ngang, Để cho đũa ngọc mâm vàng cách xa." (ca dao)',
  },
  {
    word: "bời bời",
    part_of_speech: "tính từ",
    meaning:
      'nhiều và ngổn ngang, lộn xộn: việc nhà việc nước bời bời * "Bao nhiêu ý nghĩ đen tối, ghê rợn, nối tiếp bời bời trong đầu óc ông lão." (KLân; 5)',
    example:
      'việc nhà việc nước bời bời * "Bao nhiêu ý nghĩ đen tối, ghê rợn, nối tiếp bời bời trong đầu óc ông lão." (KLân; 5)',
  },
  {
    word: "bời bời",
    part_of_speech: "tính từ",
    meaning: "(cây cối) đầy sức sống: cỏ lác bời bời * lúa tốt bời bời",
    example: "cỏ lác bời bời * lúa tốt bời bời",
  },
  {
    word: "bơi lội",
    part_of_speech: "động từ",
    meaning:
      "bơi (nói khái quát): đàn cá bơi lội tung tăng * trổ hết tài bơi lội",
    example: "đàn cá bơi lội tung tăng * trổ hết tài bơi lội",
  },
  {
    word: "bởi thế",
    part_of_speech: "kết từ",
    meaning:
      'như vì thế: "(...) cái gì mình ác cảm nó lại buộc chặt vào mình, bởi thế, thành một cái ách." (THoài; 28)',
    example:
      '(...) cái gì mình ác cảm nó lại buộc chặt vào mình, bởi thế, thành một cái ách." (THoài; 28)',
  },
  {
    word: "bởi vì",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là lí do hoặc nguyên nhân giải thích việc được nói đến: bởi vì trời mưa nên không đi được * làm sai bởi vì không biết",
    example: "bởi vì trời mưa nên không đi được * làm sai bởi vì không biết",
  },
  {
    word: "bới móc",
    part_of_speech: "động từ",
    meaning:
      "moi móc điều xấu của người khác ra để nói, nhằm hạ thấp giá trị: bới móc chuyện riêng của người khác * bới móc nhau",
    example: "bới móc chuyện riêng của người khác * bới móc nhau",
  },
  {
    word: "bởi vậy",
    part_of_speech: "kết từ",
    meaning: "như vì vậy: mình đã xin lỗi, bởi vậy người ta mới bỏ qua",
    example: "mình đã xin lỗi, bởi vậy người ta mới bỏ qua",
  },
  {
    word: "bơi trải",
    part_of_speech: "động từ",
    meaning:
      "đua thuyền theo kiểu truyền thống (một trò chơi dân gian cổ truyền): mở hội thi bơi trải",
    example: "mở hội thi bơi trải",
  },
  {
    word: "bờm",
    part_of_speech: "danh từ",
    meaning:
      "đám lông dài mọc trên cổ, trên gáy một vài giống thú: sư tử đực có bờm * bờm ngựa",
    example: "sư tử đực có bờm * bờm ngựa",
  },
  {
    word: "bờm",
    part_of_speech: "danh từ",
    meaning: "mớ tóc dài và rậm mọc nhô cao lên: tóc để bờm",
    example: "tóc để bờm",
  },
  {
    word: "bơm",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ dùng để đưa chất lỏng, chất khí từ một nơi đến nơi khác, hoặc để nén khí, hút khí: bơm xe đạp * bơm chữa cháy",
    example: "bơm xe đạp * bơm chữa cháy",
  },
  {
    word: "bơm",
    part_of_speech: "động từ",
    meaning:
      "đưa chất lỏng hoặc chất khí từ một nơi đến nơi khác bằng bơm: bơm nước vào ruộng * bơm thuốc trừ sâu * bơm mực vào bút * bơm lốp xe cho căng",
    example:
      "bơm nước vào ruộng * bơm thuốc trừ sâu * bơm mực vào bút * bơm lốp xe cho căng",
  },
  {
    word: "bơm",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nói quá mức về mặt nào đó (hàm ý chê): bơm phồng khó khăn * bơm to chuyện",
    example: "bơm phồng khó khăn * bơm to chuyện",
  },
  {
    word: "bợm",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) kẻ sành sỏi về những trò ăn chơi: bợm rượu (uống được nhiều rượu) * bợm bạc (chuyên sống bằng cờ bạc)",
    example:
      "bợm rượu (uống được nhiều rượu) * bợm bạc (chuyên sống bằng cờ bạc)",
  },
  {
    word: "bợm",
    part_of_speech: "danh từ",
    meaning: "kẻ chuyên lừa bịp, trộm cắp: tin bợm mất bò (tng)",
    example: "tin bợm mất bò (tng)",
  },
  {
    word: "bợm",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) sành sỏi và khôn khéo, có nhiều mánh khoé táo tợn: xoay xở rất bợm!",
    example: "xoay xở rất bợm!",
  },
  {
    word: "bợm già",
    part_of_speech: "danh từ",
    meaning:
      '(khẩu ngữ) kẻ lão luyện trong nghề lừa bịp, có nhiều mánh khoé: "Nào ngờ cũng tổ bợm già, Bạc bà học với Tú bà đồng môn!" (TKiều)',
    example: 'Nào ngờ cũng tổ bợm già, Bạc bà học với Tú bà đồng môn!" (TKiều)',
  },
  {
    word: "bợm bãi",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều mánh khoé lừa bịp (nói khái quát): có tính bợm bãi * tay bợm bãi",
    example: "có tính bợm bãi * tay bợm bãi",
  },
  {
    word: "bợn",
    part_of_speech: "danh từ",
    meaning:
      "cái ít nhiều lẫn vào hoặc còn sót lại, làm cho bẩn đi, cho vẩn đục: nước trong, không chút bợn",
    example: "nước trong, không chút bợn",
  },
  {
    word: "bợn",
    part_of_speech: "tính từ",
    meaning:
      "có chút gì làm cho bẩn đi: nhà sạch đến nỗi không bợn một chút rác",
    example: "nhà sạch đến nỗi không bợn một chút rác",
  },
  {
    word: "bợn",
    part_of_speech: "tính từ",
    meaning:
      '(tâm trí) có chút gì làm cho vướng víu, bận bịu: không bợn tư tình * "Êm ái chiều xuân tới khán đài, Lâng lâng chẳng bợn chút trần ai!" (HXHương; 5)',
    example:
      'không bợn tư tình * "Êm ái chiều xuân tới khán đài, Lâng lâng chẳng bợn chút trần ai!" (HXHương; 5)',
  },
  {
    word: "bỡn",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) đùa chơi cho vui, không nghiêm chỉnh: nói nửa thật nửa bỡn * dễ như bỡn!",
    example: "nói nửa thật nửa bỡn * dễ như bỡn!",
  },
  {
    word: "bỡn",
    part_of_speech: "động từ",
    meaning:
      "xem như chuyện đùa, không nghiêm chỉnh, không coi trọng: làm bỡn ăn thật",
    example: "làm bỡn ăn thật",
  },
  {
    word: "bờm xơm",
    part_of_speech: "động từ",
    meaning:
      "cợt nhả, trêu ghẹo một cách không đứng đắn đối với phụ nữ: tính hay bờm xơm",
    example: "tính hay bờm xơm",
  },
  {
    word: "bỡn cợt",
    part_of_speech: "động từ",
    meaning: "bỡn (nói khái quát): giọng bỡn cợt * tính hay bỡn cợt",
    example: "giọng bỡn cợt * tính hay bỡn cợt",
  },
  {
    word: "bờm xờm",
    part_of_speech: "tính từ",
    meaning: "(lông, tóc) dài ngắn không đều và rối bù: tóc tai bờm xờm",
    example: "tóc tai bờm xờm",
  },
  {
    word: "bớp",
    part_of_speech: "động từ",
    meaning: "như bợp: bớp nhẹ cho một cái",
    example: "bớp nhẹ cho một cái",
  },
  {
    word: "bợt",
    part_of_speech: "tính từ",
    meaning: "sờn, mòn, chớm rách: áo đã bợt vai * giấy bị ngấm nước, bợt mủn",
    example: "áo đã bợt vai * giấy bị ngấm nước, bợt mủn",
  },
  {
    word: "bợt",
    part_of_speech: "tính từ",
    meaning: "đã phai màu: vải đã bợt màu",
    example: "vải đã bợt màu",
  },
  {
    word: "bợt",
    part_of_speech: "tính từ",
    meaning: "(da) nhợt nhạt, vẻ ốm yếu: nước da bợt * mặt trắng bợt",
    example: "nước da bợt * mặt trắng bợt",
  },
  {
    word: "bợt bạt",
    part_of_speech: "tính từ",
    meaning: "bợt (nói khái quát): mặt mày bợt bạt",
    example: "mặt mày bợt bạt",
  },
  {
    word: "bợp",
    part_of_speech: "động từ",
    meaning:
      "đánh sướt qua bằng lòng bàn tay vào mặt hoặc vào đầu: bợp cho mấy phát",
    example: "bợp cho mấy phát",
  },
  {
    word: "bợp",
    part_of_speech: "danh từ",
    meaning:
      "cái đánh vào mặt hoặc vào đầu bằng lòng bàn tay sướt qua: bị ăn mấy cái bợp tai",
    example: "bị ăn mấy cái bợp tai",
  },
  {
    word: "bớt",
    part_of_speech: "danh từ",
    meaning:
      "vết màu hung xám, xanh xám hay đỏ trên mặt da (thường do bẩm sinh): có cái bớt trên má",
    example: "có cái bớt trên má",
  },
  {
    word: "bớt",
    part_of_speech: "động từ",
    meaning:
      'làm cho hoặc trở nên ít đi một phần về số lượng, mức độ: bớt ăn bớt tiêu * thêm bạn bớt thù * bớt giận * "Cò kè bớt một thêm hai, Giờ lâu ngã giá vàng ngoài bốn trăm." (TKiều)',
    example:
      'bớt ăn bớt tiêu * thêm bạn bớt thù * bớt giận * "Cò kè bớt một thêm hai, Giờ lâu ngã giá vàng ngoài bốn trăm." (TKiều)',
  },
  {
    word: "bớt",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) lấy ra một phần để dùng vào việc khác: bớt cơm để phần * bớt chút thì giờ",
    example: "bớt cơm để phần * bớt chút thì giờ",
  },
  {
    word: "bớt",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) nhượng lại một phần: bớt cho ít gạch để xây giếng",
    example: "bớt cho ít gạch để xây giếng",
  },
  {
    word: "bớt miệng",
    part_of_speech: "",
    meaning: "(khẩu ngữ) ăn uống dè sẻn bớt đi: bớt miệng để dành",
    example: "bớt miệng để dành",
  },
  {
    word: "bớt miệng",
    part_of_speech: "",
    meaning: "nói ít đi, không lắm điều: nói bớt miệng thôi!",
    example: "nói bớt miệng thôi!",
  },
  {
    word: "bớt xén",
    part_of_speech: "động từ",
    meaning:
      "lấy bớt đi để hưởng riêng một phần cái đáng lẽ phải đem dùng hết, phải chi hết: bớt xén tiền công của thợ",
    example: "bớt xén tiền công của thợ",
  },
  {
    word: "bớt xớ",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ, hiếm) như bớt xén: bớt xớ vật liệu",
    example: "bớt xớ vật liệu",
  },
  {
    word: "bớt xớ",
    part_of_speech: "động từ",
    meaning:
      "kèo nài để trả ít hơn giá đã định: lần nào mua cũng kì kèo, bớt xớ",
    example: "lần nào mua cũng kì kèo, bớt xớ",
  },
  {
    word: "bú",
    part_of_speech: "động từ",
    meaning: "mút núm vú để hút sữa: con có khóc mẹ mới cho bú (tng)",
    example: "con có khóc mẹ mới cho bú (tng)",
  },
  {
    word: "bủ",
    part_of_speech: "danh từ",
    meaning:
      "(Phương ngữ) từ dùng để gọi người già cả với ý kính trọng, thân mật, có nghĩa như lão, cụ: ông bủ",
    example: "ông bủ",
  },
  {
    word: "bù",
    part_of_speech: "động từ",
    meaning:
      "thêm vào để cho đủ, để lấp khoản thiếu hụt: học bù giờ * ngủ bù * lấy thu bù chi",
    example: "học bù giờ * ngủ bù * lấy thu bù chi",
  },
  {
    word: "bù",
    part_of_speech: "động từ",
    meaning:
      "(góc hoặc cung) cộng với một góc (hoặc một cung) được nói đến nào đó thì thành 180O: góc 60O bù với góc 120O",
    example: "góc 60O bù với góc 120O",
  },
  {
    word: "bù",
    part_of_speech: "tính từ",
    meaning:
      "(đầu tóc) dựng lên và quấn vào nhau một cách lộn xộn: đầu bù tóc rối",
    example: "đầu bù tóc rối",
  },
  {
    word: "bu",
    part_of_speech: "danh từ",
    meaning: "===== (Phương ngữ): con chào bu * thầy bu",
    example: "con chào bu * thầy bu",
  },
  {
    word: "bụ bẫm",
    part_of_speech: "tính từ",
    meaning: "bụ (nói khái quát): chồi cây bụ bẫm * chân tay bụ bẫm",
    example: "chồi cây bụ bẫm * chân tay bụ bẫm",
  },
  {
    word: "bụ",
    part_of_speech: "tính từ",
    meaning:
      "béo tròn, trông khoẻ mạnh (nói về cơ thể còn non): đứa bé trông rất bụ * mầm cây bụ",
    example: "đứa bé trông rất bụ * mầm cây bụ",
  },
  {
    word: "bù đắp",
    part_of_speech: "động từ",
    meaning:
      "bù vào để làm giảm bớt đi phần nào những mất mát, thiếu thốn (thường là về mặt tinh thần, tình cảm): bù đắp những mất mát * đau thương không gì bù đắp nổi",
    example: "bù đắp những mất mát * đau thương không gì bù đắp nổi",
  },
  {
    word: "bù đắp",
    part_of_speech: "động từ",
    meaning: "chăm lo giúp đỡ, gây dựng về vật chất: bù đắp cho con cái",
    example: "bù đắp cho con cái",
  },
  {
    word: "bù đắp",
    part_of_speech: "động từ",
    meaning: "(hiếm) như đền đáp: công ơn ấy không gì bù đắp nổi",
    example: "công ơn ấy không gì bù đắp nổi",
  },
  {
    word: "bú dù",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) khỉ (thường dùng làm tiếng mắng chửi): trông như con bú dù * đồ bú dù!",
    example: "trông như con bú dù * đồ bú dù!",
  },
  {
    word: "bù đầu",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ở tình trạng bận việc túi bụi đến mức tựa như đầu để bù không kịp chải: bận bù đầu",
    example: "bận bù đầu",
  },
  {
    word: "bù giá",
    part_of_speech: "động từ",
    meaning:
      "(nhà nước) phụ cấp bằng tiền để bù lại việc nâng giá một mặt hàng trước đây được cung cấp theo định lượng với giá thấp: bù giá điện vào lương",
    example: "bù giá điện vào lương",
  },
  {
    word: "bù lu bù loa",
    part_of_speech: "động từ",
    meaning:
      "làm ầm ĩ bằng cách kêu la hoặc khóc lóc cho ra vẻ to chuyện hoặc để gây sự chú ý: hơi một tí là bù lu bù loa lên * khóc bù lu bù loa",
    example: "hơi một tí là bù lu bù loa lên * khóc bù lu bù loa",
  },
  {
    word: "bụ sữa",
    part_of_speech: "tính từ",
    meaning:
      "bụ, mập tròn, nhờ được nuôi bằng sữa tốt: đứa bé bụ sữa trông rất kháu * đàn lợn con bụ sữa",
    example: "đứa bé bụ sữa trông rất kháu * đàn lợn con bụ sữa",
  },
  {
    word: "bù lỗ",
    part_of_speech: "động từ",
    meaning:
      "cấp một khoản tiền tương ứng để bù vào khoản bị lỗ: một số doanh nghiệp được nhà nước bù lỗ * mặt hàng được bù lỗ nên giá rẻ",
    example:
      "một số doanh nghiệp được nhà nước bù lỗ * mặt hàng được bù lỗ nên giá rẻ",
  },
  {
    word: "bù khú",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) chuyện trò tâm sự hoặc cười nói đùa vui với nhau một cách tâm đắc, thích thú và thường kéo dài: trò chuyện bù khú với nhau",
    example: "trò chuyện bù khú với nhau",
  },
  {
    word: "bu lông",
    part_of_speech: "danh từ",
    meaning:
      "đinh bằng kim loại, một đầu có mũ, đầu kia có ren khớp với ren đai ốc, dùng để cố định các phần tử của máy, của kết cấu: vặn đinh ốc",
    example: "vặn đinh ốc",
  },
  {
    word: "bù nhìn",
    part_of_speech: "danh từ",
    meaning:
      "vật giả hình người, thường bện bằng rơm, dùng để doạ chim, thú hoặc dùng diễn tập trong luyện tập quân sự: bù nhìn giữ dưa (tng)",
    example: "bù nhìn giữ dưa (tng)",
  },
  {
    word: "bù nhìn",
    part_of_speech: "danh từ",
    meaning:
      "kẻ có chức vị mà không có quyền hành, chỉ làm theo lệnh người khác: chính quyền bù nhìn",
    example: "chính quyền bù nhìn",
  },
  {
    word: "bú mớm",
    part_of_speech: "động từ",
    meaning:
      'cho bú và mớm cho ăn; nuôi nấng từ khi còn nhỏ: "Nâng niu bú mớm đêm ngày, Công cha nghĩa mẹ coi tày biển non." (ca dao)',
    example:
      'Nâng niu bú mớm đêm ngày, Công cha nghĩa mẹ coi tày biển non." (ca dao)',
  },
  {
    word: "bù trì",
    part_of_speech: "động từ",
    meaning:
      "(cũ) chăm lo, nuôi nấng chu đáo hoặc giúp đỡ một cách ân cần: mẹ cha bù trì * nuôi nấng, bù trì",
    example: "mẹ cha bù trì * nuôi nấng, bù trì",
  },
  {
    word: "bù xù",
    part_of_speech: "tính từ",
    meaning:
      "(lông, tóc, v.v.) có nhiều sợi bị mắc và xoắn vào nhau thành một mớ lộn xộn, không gọn: đầu tóc bù xù",
    example: "đầu tóc bù xù",
  },
  {
    word: "bù trừ",
    part_of_speech: "động từ",
    meaning:
      "lấy chỗ thừa bù vào chỗ thiếu, chỗ hơn bù chỗ kém, v.v.: chỗ hơn chỗ kém bù trừ cho nhau là vừa đủ * luật bù trừ",
    example: "chỗ hơn chỗ kém bù trừ cho nhau là vừa đủ * luật bù trừ",
  },
  {
    word: "búa",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ để đập, đóng, nện, gồm một khối nặng thường bằng sắt, tra thẳng góc vào cán: nện một búa * trên đe dưới búa (tng)",
    example: "nện một búa * trên đe dưới búa (tng)",
  },
  {
    word: "búa",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ thường để bổ củi, gồm một khối sắt thép có lưỡi sắc tra thẳng góc vào cán: lưỡi búa sáng loáng * đầu đau như búa bổ",
    example: "lưỡi búa sáng loáng * đầu đau như búa bổ",
  },
  {
    word: "bùa",
    part_of_speech: "danh từ",
    meaning:
      "vật thường bằng giấy hoặc vải, có những dấu hiệu đặc biệt, được cho là có phép thiêng trừ ma quỷ, tránh được tai nạn, mê hoặc được người khác, v.v., theo mê tín: lá bùa * yểm bùa",
    example: "lá bùa * yểm bùa",
  },
  {
    word: "bủa",
    part_of_speech: "động từ",
    meaning:
      "toả ra bao lấy các phía trên một phạm vi rộng: bủa lưới đánh cá * bủa đi tìm * sương mù bủa đầy trời",
    example: "bủa lưới đánh cá * bủa đi tìm * sương mù bủa đầy trời",
  },
  {
    word: "búa rìu",
    part_of_speech: "danh từ",
    meaning:
      'búa và rìu; dùng để ví sự phê phán, dè bỉu nặng nề, nghiêm khắc: búa rìu dư luận * "Rằng: Con biết tội đã nhiều, Dẫu rằng sấm sét, búa rìu cũng cam." (TKiều)',
    example:
      'búa rìu dư luận * "Rằng: Con biết tội đã nhiều, Dẫu rằng sấm sét, búa rìu cũng cam." (TKiều)',
  },
  {
    word: "bùa yêu",
    part_of_speech: "danh từ",
    meaning:
      'bùa có thể làm cho người khác phải thương yêu, theo mê tín: "Chỉ ngũ sắc xanh đỏ trắng vàng, Bùa yêu ăn phải dạ càng tương tư." (ca dao)',
    example:
      'Chỉ ngũ sắc xanh đỏ trắng vàng, Bùa yêu ăn phải dạ càng tương tư." (ca dao)',
  },
  {
    word: "bủa vây",
    part_of_speech: "động từ",
    meaning:
      "toả ra khắp mọi phía để bao vây, không cho thoát: bủa vây khu rừng * bọn cướp đã bị bủa vây khắp xung quanh",
    example: "bủa vây khu rừng * bọn cướp đã bị bủa vây khắp xung quanh",
  },
  {
    word: "búa xua",
    part_of_speech: "tính từ",
    meaning:
      "(Phương ngữ, Khẩu ngữ) bát nháo và loạn xạ, không theo một trật tự nào cả: ăn nói búa xua * chạy búa xua",
    example: "ăn nói búa xua * chạy búa xua",
  },
  {
    word: "bục",
    part_of_speech: "danh từ",
    meaning:
      "vật đóng bằng gỗ hoặc chỗ nền được xây cao lên, làm chỗ đứng: đứng trên bục giảng * bước lên bục vinh quang (b)",
    example: "đứng trên bục giảng * bước lên bục vinh quang (b)",
  },
  {
    word: "bục",
    part_of_speech: "động từ",
    meaning:
      'đứt ra, rời ra từng mảnh do bị căng tức quá hoặc do không còn đủ sức bền chắc: áo bục chỉ * con đê bị bục một quãng * "Đem chuông đi đấm nước người, Đấm cho nó bục mà lôi nó về." (Cdao)',
    example:
      'áo bục chỉ * con đê bị bục một quãng * "Đem chuông đi đấm nước người, Đấm cho nó bục mà lôi nó về." (Cdao)',
  },
  {
    word: "búi",
    part_of_speech: "danh từ",
    meaning:
      "mớ vật dài xoắn vào nhau, quấn chặt vào nhau: một búi tóc rối * búi cỏ khô",
    example: "một búi tóc rối * búi cỏ khô",
  },
  {
    word: "búi",
    part_of_speech: "động từ",
    meaning:
      "quấn tóc thành búi tròn, thường ở phía sau đầu: tóc búi thành hai búi",
    example: "tóc búi thành hai búi",
  },
  {
    word: "búi",
    part_of_speech: "tính từ",
    meaning:
      '(phương ngữ) rối: "(...) Tóc không xe tóc búi, ruột không dần ruột đau." (ca dao)',
    example: '(...) Tóc không xe tóc búi, ruột không dần ruột đau." (ca dao)',
  },
  {
    word: "búi",
    part_of_speech: "tính từ",
    meaning:
      '(khẩu ngữ) bận và rối mù: công việc búi lên * "Trọn ngày nay chắc tôi búi lắm không về được." (AĐức; 16)',
    example:
      'công việc búi lên * "Trọn ngày nay chắc tôi búi lắm không về được." (AĐức; 16)',
  },
  {
    word: "bụi bặm",
    part_of_speech: "danh từ",
    meaning:
      "bụi bẩn bám trên bề mặt các vật (nói khát quát): bụi bặm bám đầy quần áo",
    example: "bụi bặm bám đầy quần áo",
  },
  {
    word: "bụi",
    part_of_speech: "danh từ",
    meaning:
      "đám cây cỏ mọc chen sát nhau, cành lá chằng chịt với nhau: bụi tre * bụi chuối * bụi dứa gai * lạy ông tôi ở bụi này (tng)",
    example: "bụi tre * bụi chuối * bụi dứa gai * lạy ông tôi ở bụi này (tng)",
  },
  {
    word: "bụi",
    part_of_speech: "danh từ",
    meaning: "đám gồm những cây thân gỗ nhỏ: bụi sim * bụi mua",
    example: "bụi sim * bụi mua",
  },
  {
    word: "bụi",
    part_of_speech: "danh từ",
    meaning:
      "vụn nhỏ li ti của chất rắn có thể lơ lửng trong không khí hoặc bám trên bề mặt các vật: hạt bụi * bụi phấn * mặt bàn bám đầy bụi * bụi đường bốc lên mù mịt",
    example:
      "hạt bụi * bụi phấn * mặt bàn bám đầy bụi * bụi đường bốc lên mù mịt",
  },
  {
    word: "bụi",
    part_of_speech: "danh từ",
    meaning:
      'dạng hạt nhỏ như hạt bụi (thường nói về nước): bụi nước tung trắng xoá * "Mưa đổ bụi êm êm trên bến vắng, Đò biếng lười nằm mặc nước sông trôi." (AThơ; 2)',
    example:
      'bụi nước tung trắng xoá * "Mưa đổ bụi êm êm trên bến vắng, Đò biếng lười nằm mặc nước sông trôi." (AThơ; 2)',
  },
  {
    word: "bụi",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) tang: nhà có bụi",
    example: "nhà có bụi",
  },
  {
    word: "bụi",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) bụi đời (nói tắt): bỏ nhà đi bụi * dân bụi",
    example: "bỏ nhà đi bụi * dân bụi",
  },
  {
    word: "bụi",
    part_of_speech: "tính từ",
    meaning:
      "có dáng vẻ tự do buông thả, không theo khuôn mẫu thông thường: tóc cắt trông bụi lắm * đeo chiếc túi rất bụi",
    example: "tóc cắt trông bụi lắm * đeo chiếc túi rất bụi",
  },
  {
    word: "bùi",
    part_of_speech: "tính từ",
    meaning:
      "có vị ngon hơi beo béo như vị của lạc, của hạt dẻ: hạt dẻ ăn rất bùi",
    example: "hạt dẻ ăn rất bùi",
  },
  {
    word: "bùi nhùi",
    part_of_speech: "danh từ",
    meaning: "mớ rơm rạ hoặc xơ tre nứa để rối: tóc rối như bùi nhùi",
    example: "tóc rối như bùi nhùi",
  },
  {
    word: "bùi nhùi",
    part_of_speech: "danh từ",
    meaning: "mồi lửa lèn bằng chất nhạy lửa: bùi nhùi rơm",
    example: "bùi nhùi rơm",
  },
  {
    word: "bùi tai",
    part_of_speech: "tính từ",
    meaning:
      "(lời nói) dễ làm cho người ta vui lòng nghe theo, thuận theo: nghe bùi tai nên đồng ý",
    example: "nghe bùi tai nên đồng ý",
  },
  {
    word: "bụi hồng",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) bụi bặm; dùng để chỉ xã hội phồn hoa, hoặc chỉ cõi đời: "Sự đời đã tắt lửa lòng, Còn chen vào chốn bụi hồng làm chi!" (TKiều)',
    example:
      'Sự đời đã tắt lửa lòng, Còn chen vào chốn bụi hồng làm chi!" (TKiều)',
  },
  {
    word: "bùi ngùi",
    part_of_speech: "tính từ",
    meaning:
      'buồn vì thương cảm, xen lẫn luyến tiếc: bùi ngùi cảm động * "Ra về chân lại đá lui, Bâng khuâng nhớ bạn, bùi ngùi nhớ em." (ca dao)',
    example:
      'bùi ngùi cảm động * "Ra về chân lại đá lui, Bâng khuâng nhớ bạn, bùi ngùi nhớ em." (ca dao)',
  },
  {
    word: "búi rễ",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ hệ rễ của một số cây, trông giống như một búi tóc: một búi rễ tre",
    example: "một búi rễ tre",
  },
  {
    word: "bụi đời",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ, hiếm) cảnh sống lang thang, vất vưởng, không nhà cửa, không nghề nghiệp: đám bụi đời * bỏ nhà đi bụi đời",
    example: "đám bụi đời * bỏ nhà đi bụi đời",
  },
  {
    word: "bụm",
    part_of_speech: "động từ",
    meaning:
      "lấy vật rời hay chất lỏng lên bằng hai bàn tay khum để ngửa và các ngón chụm khít: bụm gạo * bụm nước lên rửa mặt",
    example: "bụm gạo * bụm nước lên rửa mặt",
  },
  {
    word: "bụm",
    part_of_speech: "động từ",
    meaning:
      "chụm bàn tay lại để che, bịt: bụm miệng cười * hai tay bụm mặt khóc",
    example: "bụm miệng cười * hai tay bụm mặt khóc",
  },
  {
    word: "bụm",
    part_of_speech: "động từ",
    meaning: "chúm miệng, môi: bụm miệng nín cười",
    example: "bụm miệng nín cười",
  },
  {
    word: "bụm",
    part_of_speech: "danh từ",
    meaning:
      "lượng lấy được trong hai bàn tay bụm: một bụm gạo * bụm mấy bụm nước để rửa mặt",
    example: "một bụm gạo * bụm mấy bụm nước để rửa mặt",
  },
  {
    word: "bụm",
    part_of_speech: "danh từ",
    meaning: "khối nhỏ và đặc kết chặt với nhau: bụm khói * nhổ ra một bụm máu",
    example: "bụm khói * nhổ ra một bụm máu",
  },
  {
    word: "bụm",
    part_of_speech: "danh từ",
    meaning: "lùm, bụi (cây cỏ): bụm cỏ",
    example: "bụm cỏ",
  },
  {
    word: "bùm tum",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như um tùm: cây cối bùm tum",
    example: "cây cối bùm tum",
  },
  {
    word: "bún",
    part_of_speech: "danh từ",
    meaning:
      "món ăn làm bằng bột gạo tẻ luộc chín, có hình sợi tròn, mềm, vị hơi chua: mềm như bún * sợi bún",
    example: "mềm như bún * sợi bún",
  },
  {
    word: "bùn",
    part_of_speech: "danh từ",
    meaning:
      "đất nhão hoà lẫn trong nước: chân nhoe nhoét những bùn * đánh bùn sang ao (tng)",
    example: "chân nhoe nhoét những bùn * đánh bùn sang ao (tng)",
  },
  {
    word: "bụi trần",
    part_of_speech: "danh từ",
    meaning:
      'bụi bặm; dùng để chỉ cõi đời, thường để phân biệt với cõi tu hành: "Gương trong chẳng chút bụi trần, Một lời quyết hẳn muôn phần kính thêm!" (TKiều)',
    example:
      'Gương trong chẳng chút bụi trần, Một lời quyết hẳn muôn phần kính thêm!" (TKiều)',
  },
  {
    word: "bủn",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ bủn) dễ bị nát vụn ra khi đụng đến, do tác động của thời gian, của mưa nắng: cái chiếu nát mủn * tờ giấy ngấm nước đã mủn ra",
    example: "cái chiếu nát mủn * tờ giấy ngấm nước đã mủn ra",
  },
  {
    word: "bủn",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như mùn: mủn rơm",
    example: "mủn rơm",
  },
  {
    word: "bùn lầy",
    part_of_speech: "danh từ",
    meaning: "bùn nhiều và trên diện tích rộng: lội bì bõm dưới bùn lầy",
    example: "lội bì bõm dưới bùn lầy",
  },
  {
    word: "bủn nhủn",
    part_of_speech: "tính từ",
    meaning:
      "rã rời gân cốt, như không còn cử động nổi nữa: sợ quá, chân tay bủn rủn * nghe tin dữ, bủn rủn cả người",
    example: "sợ quá, chân tay bủn rủn * nghe tin dữ, bủn rủn cả người",
  },
  {
    word: "bủn rủn",
    part_of_speech: "tính từ",
    meaning:
      "rã rời gân cốt, như không còn cử động nổi nữa: sợ quá, chân tay bủn rủn * nghe tin dữ, bủn rủn cả người",
    example: "sợ quá, chân tay bủn rủn * nghe tin dữ, bủn rủn cả người",
  },
  {
    word: "bùn nhơ",
    part_of_speech: "danh từ",
    meaning:
      "bùn bẩn; thường dùng trong văn chương để ví cái xấu xa thối nát mà con người gây nên trong cuộc sống: quét sạch bùn nhơ của xã hội",
    example: "quét sạch bùn nhơ của xã hội",
  },
  {
    word: "bung",
    part_of_speech: "động từ",
    meaning: "bật tung ra: nón đã bung vành * đạp bung cánh cửa",
    example: "nón đã bung vành * đạp bung cánh cửa",
  },
  {
    word: "bung",
    part_of_speech: "động từ",
    meaning: "nấu với nhiều nước cho chín nhừ: cà bung * bung ngô",
    example: "cà bung * bung ngô",
  },
  {
    word: "búng",
    part_of_speech: "động từ",
    meaning:
      "co một đầu ngón tay ép chặt vào đầu ngón tay cái, rồi bật mạnh ra: búng vào má * búng tai * búng đầu ngón tay vào quả bóng",
    example: "búng vào má * búng tai * búng đầu ngón tay vào quả bóng",
  },
  {
    word: "búng",
    part_of_speech: "động từ",
    meaning:
      'bật bằng đầu ngón tay để làm cho vật nhỏ quay tít: búng đồng tiền * "Cái quay búng sẵn trên trời, Mờ mờ nhân ảnh như người đi đêm." (CO)',
    example:
      'búng đồng tiền * "Cái quay búng sẵn trên trời, Mờ mờ nhân ảnh như người đi đêm." (CO)',
  },
  {
    word: "búng",
    part_of_speech: "động từ",
    meaning:
      "dùng sức mười đầu ngón tay chuyền quả bóng đi khi bóng cao hơn ngực: động tác búng bóng",
    example: "động tác búng bóng",
  },
  {
    word: "búng",
    part_of_speech: "động từ",
    meaning:
      "(tôm) co và nẩy mình lên để di chuyển: tôm còn sống, đang búng tanh tách",
    example: "tôm còn sống, đang búng tanh tách",
  },
  {
    word: "búng",
    part_of_speech: "động từ",
    meaning: "phồng má ngậm đầy trong miệng: búng một miệng cơm đầy",
    example: "búng một miệng cơm đầy",
  },
  {
    word: "búng",
    part_of_speech: "danh từ",
    meaning: "lượng chứa đầy trong miệng phồng má: ngậm một búng cơm",
    example: "ngậm một búng cơm",
  },
  {
    word: "bùng",
    part_of_speech: "động từ",
    meaning:
      "bốc lên nhanh, mạnh mẽ: ngọn lửa đang âm ỉ, bỗng bùng cháy * cuộc đấu tranh chống phát xít bùng lên trên toàn thế giới",
    example:
      "ngọn lửa đang âm ỉ, bỗng bùng cháy * cuộc đấu tranh chống phát xít bùng lên trên toàn thế giới",
  },
  {
    word: "bùng",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) trốn hoặc bỏ đi nơi khác một cách đột ngột: lựa thời cơ bùng mất",
    example: "lựa thời cơ bùng mất",
  },
  {
    word: "bủn xỉn",
    part_of_speech: "tính từ",
    meaning:
      "hà tiện quá đáng, đến mức không dám chi tiêu về cả những khoản hết sức nhỏ nhặt: con người bủn xỉn * tính bủn xỉn",
    example: "con người bủn xỉn * tính bủn xỉn",
  },
  {
    word: "bụng",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận cơ thể người hoặc động vật, chứa ruột, dạ dày, v.v.: cá đầy một bụng trứng * chưa có hột cơm nào vào bụng",
    example: "cá đầy một bụng trứng * chưa có hột cơm nào vào bụng",
  },
  {
    word: "bụng",
    part_of_speech: "danh từ",
    meaning:
      "bụng con người, coi là biểu tượng của ý nghĩ, tình cảm sâu kín đối với người, với việc: có bụng thương người * tính không hay để bụng * suy bụng ta ra bụng người (tng)",
    example:
      "có bụng thương người * tính không hay để bụng * suy bụng ta ra bụng người (tng)",
  },
  {
    word: "bụng",
    part_of_speech: "danh từ",
    meaning:
      "phần phình to ở giữa của một số vật: bụng lò * bụng chiếc trực thăng",
    example: "bụng lò * bụng chiếc trực thăng",
  },
  {
    word: "bủng",
    part_of_speech: "tính từ",
    meaning:
      '(nước da) nhợt nhạt và như mọng nước, do ốm yếu: da xanh bủng * "Bà chủ quán cũng ốm rề rề, quanh năm bủng vàng như nghệ." (THoài; 28)',
    example:
      'da xanh bủng * "Bà chủ quán cũng ốm rề rề, quanh năm bủng vàng như nghệ." (THoài; 28)',
  },
  {
    word: "bủng beo",
    part_of_speech: "tính từ",
    meaning:
      'bủng và gầy tóp, xanh xao: mặt bủng beo * "Cao su đi dễ khó về, Khi đi trai tráng, khi về bủng beo." (ca dao)',
    example:
      'mặt bủng beo * "Cao su đi dễ khó về, Khi đi trai tráng, khi về bủng beo." (ca dao)',
  },
  {
    word: "bùng bục",
    part_of_speech: "tính từ",
    meaning: "dễ bục ra: vải bở bùng bục",
    example: "vải bở bùng bục",
  },
  {
    word: "búng báng",
    part_of_speech: "danh từ",
    meaning:
      "cây mọc hoang trong rừng ẩm nhiệt đới, cùng họ với dừa, mặt dưới lá hơi trắng, thân cho thứ bột ăn được: bột báng",
    example: "bột báng",
  },
  {
    word: "búng báng",
    part_of_speech: "danh từ",
    meaning:
      "chứng bụng to do nước ứ trong ổ bụng hay do sưng lá lách: bụng báng",
    example: "bụng báng",
  },
  {
    word: "búng báng",
    part_of_speech: "danh từ",
    meaning:
      "ống mai, ống bương để đựng nước (phổ biến ở miền núi): vác báng ra suối lấy nước",
    example: "vác báng ra suối lấy nước",
  },
  {
    word: "búng báng",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận ở cuối khẩu súng cầm tay, thường bằng gỗ, dùng để tì hoặc giữ súng khi bắn: báng súng trường * khẩu tiểu liên báng gập * tì báng súng vào vai",
    example:
      "báng súng trường * khẩu tiểu liên báng gập * tì báng súng vào vai",
  },
  {
    word: "búng báng",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) húc (nói về súc vật có sừng): hai con trâu báng nhau",
    example: "hai con trâu báng nhau",
  },
  {
    word: "bụng dạ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) bộ máy tiêu hoá, gồm có dạ dày, ruột, v.v. (nói khái quát): đói, bụng dạ cồn cào",
    example: "đói, bụng dạ cồn cào",
  },
  {
    word: "bụng dạ",
    part_of_speech: "danh từ",
    meaning:
      "bụng và dạ của con người, coi là biểu tượng của ý nghĩ sâu kín, không bộc lộ ra, đối với người, với việc, nói chung: bụng dạ tử tế * hiểu rõ bụng dạ nhau * không còn bụng dạ nào mà nghĩ đến chuyện đó",
    example:
      "bụng dạ tử tế * hiểu rõ bụng dạ nhau * không còn bụng dạ nào mà nghĩ đến chuyện đó",
  },
  {
    word: "bùng binh",
    part_of_speech: "danh từ",
    meaning:
      "vòng tròn được vây cao (thường có hoa, cây cảnh bên trong) nằm ở giữa các ngả đường giao nhau để làm mốc cho xe cộ lưu thông: xe vòng qua bùng binh để rẽ trái",
    example: "xe vòng qua bùng binh để rẽ trái",
  },
  {
    word: "bùng bùng",
    part_of_speech: "tính từ",
    meaning: "(lửa cháy) to và ngày càng mạnh: ngọn lửa bùng bùng bốc lên",
    example: "ngọn lửa bùng bùng bốc lên",
  },
  {
    word: "bung búng",
    part_of_speech: "tính từ",
    meaning:
      "(miệng) hơi phồng to lên do đang ngậm nhai cái gì đó, không mở ra được: miệng bung búng những cơm",
    example: "miệng bung búng những cơm",
  },
  {
    word: "bùng nhùng",
    part_of_speech: "tính từ",
    meaning:
      "có bề mặt mềm nhũn, dễ lún xuống hoặc phồng lên, nhưng lại khó nén chặt: đất lùng nhùng * nhọt bọc lùng nhùng",
    example: "đất lùng nhùng * nhọt bọc lùng nhùng",
  },
  {
    word: "bùng nhùng",
    part_of_speech: "tính từ",
    meaning:
      "rối và vướng vào với nhau, khó dồn nén, khó tháo gỡ: bộ quần áo dài lùng nhùng",
    example: "bộ quần áo dài lùng nhùng",
  },
  {
    word: "bùng nổ",
    part_of_speech: "động từ",
    meaning:
      "phát sinh mạnh mẽ và đột ngột: chiến tranh bùng nổ * thời đại bùng nổ công nghệ thông tin",
    example: "chiến tranh bùng nổ * thời đại bùng nổ công nghệ thông tin",
  },
  {
    word: "bụng nhụng",
    part_of_speech: "tính từ",
    meaning: "mềm và nhão (thường nói về thịt): miếng thịt bụng nhụng",
    example: "miếng thịt bụng nhụng",
  },
  {
    word: "búng ra sữa",
    part_of_speech: "",
    meaning: "(khẩu ngữ) như bấm ra sữa: mặt búng ra sữa",
    example: "mặt búng ra sữa",
  },
  {
    word: "bùng phát",
    part_of_speech: "động từ",
    meaning:
      "phát sinh, phát triển lên một cách mạnh mẽ: tệ cờ bạc lại được dịp bùng phát * bệnh dịch bùng phát",
    example: "tệ cờ bạc lại được dịp bùng phát * bệnh dịch bùng phát",
  },
  {
    word: "bùng nổ dân số",
    part_of_speech: "danh từ",
    meaning:
      "hiện tượng tăng dân số quá nhanh, không hạn chế được: hạn chế nguy cơ bùng nổ dân số",
    example: "hạn chế nguy cơ bùng nổ dân số",
  },
  {
    word: "tá hoả",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) hoảng hồn, sửng sốt khi biết điều không hay xảy ra mà trước đó không hề ngờ đến: tá hoả vì những tin đồn nhảm",
    example: "tá hoả vì những tin đồn nhảm",
  },
  {
    word: "tà khí",
    part_of_speech: "danh từ",
    meaning:
      "khí độc, nhân tố gây bệnh tật cho con người, theo quan niệm của đông y: yểm tà khí * món ăn này có thể giải được tà khí",
    example: "yểm tà khí * món ăn này có thể giải được tà khí",
  },
  {
    word: "tả khuynh",
    part_of_speech: "tính từ",
    meaning:
      "có khuynh hướng chính trị thiên về tiến bộ, triệt để cách mạng; đối lập với hữu khuynh: tư tưởng tả khuynh",
    example: "tư tưởng tả khuynh",
  },
  {
    word: "tà giáo",
    part_of_speech: "danh từ",
    meaning:
      "đạo xằng bậy (từ một số người sùng tín một đạo nào đó, đặc biệt là đạo chính thống, dùng để gọi những đạo khác): dùng tà đạo để mê hoặc lòng người",
    example: "dùng tà đạo để mê hoặc lòng người",
  },
  {
    word: "tả hữu",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) bên trái và bên phải; thường dùng để chỉ chung những người thân cận giúp việc vua quan thời trước: các quan tả hữu",
    example: "các quan tả hữu",
  },
  {
    word: "tà ma",
    part_of_speech: "danh từ",
    meaning: "ma quỷ làm hại người: yểm bùa trừ tà ma",
    example: "yểm bùa trừ tà ma",
  },
  {
    word: "tã lót",
    part_of_speech: "danh từ",
    meaning:
      "tã và lót dùng cho trẻ sơ sinh (nói khái quát): quấn lại tã lót cho con",
    example: "quấn lại tã lót cho con",
  },
  {
    word: "tả ngạn",
    part_of_speech: "danh từ",
    meaning:
      "bờ bên trái của sông, nhìn theo hướng nước chảy từ nguồn xuống; đối lập với hữu ngạn: tả ngạn sông Hương",
    example: "tả ngạn sông Hương",
  },
  {
    word: "tà tâm",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) lòng không ngay thẳng, thường có ác ý hoặc ý đồ xấu: có tà tâm",
    example: "có tà tâm",
  },
  {
    word: "tà tà",
    part_of_speech: "tính từ",
    meaning:
      '(bóng mặt trời, mặt trăng) hơi chếch về phía tây, khi ngày hoặc đêm sắp hết: "Tà tà bóng ngả về tây, Chị em thơ thẩn dan tay ra về." (TKiều)',
    example: 'Tà tà bóng ngả về tây, Chị em thơ thẩn dan tay ra về." (TKiều)',
  },
  {
    word: "tà tà",
    part_of_speech: "tính từ",
    meaning:
      'như là là: "Lá sây cây đỏ hoa vàng, Tà tà sát đất thiếp đố chàng cây chi?" (ca dao)',
    example:
      'Lá sây cây đỏ hoa vàng, Tà tà sát đất thiếp đố chàng cây chi?" (ca dao)',
  },
  {
    word: "tà tà",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) (làm việc gì) một cách từ từ, tỏ ra không có gì phải vội: cứ tà tà mà làm",
    example: "cứ tà tà mà làm",
  },
  {
    word: "tà thuật",
    part_of_speech: "danh từ",
    meaning:
      "thủ đoạn, mánh khoé lợi dụng sự mê tín để lừa bịp: tà thuật của thầy phù thuỷ",
    example: "tà thuật của thầy phù thuỷ",
  },
  {
    word: "ta thán",
    part_of_speech: "động từ",
    meaning:
      "than thở và oán trách: trăm họ ta thán * người dân ta thán về nạn tham nhũng",
    example: "trăm họ ta thán * người dân ta thán về nạn tham nhũng",
  },
  {
    word: "tạ thế",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) từ giã cõi đời; chết: ông cụ đã tạ thế lúc sáng sớm",
    example: "ông cụ đã tạ thế lúc sáng sớm",
  },
  {
    word: "tả thực",
    part_of_speech: "động từ",
    meaning: "tả đúng như sự thật: văn tả thực",
    example: "văn tả thực",
  },
  {
    word: "tá túc",
    part_of_speech: "động từ",
    meaning:
      "ngủ nhờ hoặc ở nhờ: xin tá túc một đêm * tá túc ở nhà một người bạn",
    example: "xin tá túc một đêm * tá túc ở nhà một người bạn",
  },
  {
    word: "tà vẹt",
    part_of_speech: "danh từ",
    meaning:
      "thanh gỗ, sắt hoặc bê tông dùng kê ngang dưới đường ray để đỡ và cố định các thanh ray nằm trên nó: thay tà vẹt * tà vẹt đường sắt",
    example: "thay tà vẹt * tà vẹt đường sắt",
  },
  {
    word: "tá tràng",
    part_of_speech: "danh từ",
    meaning: "đoạn đầu của ruột non, phần tiếp giáp với dạ dày: viêm tá tràng",
    example: "viêm tá tràng",
  },
  {
    word: "tạ từ",
    part_of_speech: "động từ",
    meaning: "(cũ, trang trọng) chào từ biệt: giây phút tạ từ * đứng dậy tạ từ",
    example: "giây phút tạ từ * đứng dậy tạ từ",
  },
  {
    word: "tả tơi",
    part_of_speech: "tính từ",
    meaning:
      "ở tình trạng bị rách nát, bị rời ra thành nhiều mảnh nhỏ, trông lôi thôi, thảm hại: quần áo rách tả tơi * bị một trận đòn tả tơi (bị đòn rất đau)",
    example: "quần áo rách tả tơi * bị một trận đòn tả tơi (bị đòn rất đau)",
  },
  {
    word: "tả xung hữu đột",
    part_of_speech: "",
    meaning:
      "đánh bên trái, đánh bên phải, mạnh mẽ chống đỡ tứ phía: một mình tả xung hữu đột giữa vòng vây",
    example: "một mình tả xung hữu đột giữa vòng vây",
  },
  {
    word: "tác dụng",
    part_of_speech: "danh từ",
    meaning:
      "kết quả của tác động: tác dụng của quảng cáo * thuốc đã phát huy tác dụng * tác dụng phụ",
    example:
      "tác dụng của quảng cáo * thuốc đã phát huy tác dụng * tác dụng phụ",
  },
  {
    word: "tác dụng",
    part_of_speech: "động từ",
    meaning:
      "tác động đến và làm cho ít nhiều biến đổi: base tác dụng với acid sinh ra muối và nước",
    example: "base tác dụng với acid sinh ra muối và nước",
  },
  {
    word: "tà ý",
    part_of_speech: "danh từ",
    meaning: "(cũ, hiếm) ý đồ thâm hiểm, không ngay thẳng: lộ rõ tà ý",
    example: "lộ rõ tà ý",
  },
  {
    word: "tác chiến",
    part_of_speech: "động từ",
    meaning:
      "(lực lượng vũ trang) đánh trận với chiến thuật cụ thể: các binh chủng hợp đồng tác chiến * kế hoạch tác chiến",
    example: "các binh chủng hợp đồng tác chiến * kế hoạch tác chiến",
  },
  {
    word: "tác",
    part_of_speech: "động từ",
    meaning: "(hươu, nai) kêu: tiếng nai tác",
    example: "tiếng nai tác",
  },
  {
    word: "tạc",
    part_of_speech: "động từ",
    meaning:
      "đẽo, gọt hay chạm trổ vào gỗ, đá, v.v. để tạo nên những hình khối có giá trị nghệ thuật: tạc tượng * hai chị em giống nhau như tạc",
    example: "tạc tượng * hai chị em giống nhau như tạc",
  },
  {
    word: "tạc",
    part_of_speech: "động từ",
    meaning:
      '(văn chương) ghi sâu vào trong tâm khảm, không bao giờ quên: ghi lòng tạc dạ * "Trăm năm tạc một chữ đồng, Dầu ai thêu phụng vẽ rồng mặc ai." (ca dao)',
    example:
      'ghi lòng tạc dạ * "Trăm năm tạc một chữ đồng, Dầu ai thêu phụng vẽ rồng mặc ai." (ca dao)',
  },
  {
    word: "tác giả",
    part_of_speech: "danh từ",
    meaning:
      "người trực tiếp sáng tạo ra toàn bộ hoặc một phần tác phẩm văn học, nghệ thuật, khoa học nào đó: tác giả của Truyện Kiều là Nguyễn Du * quyền tác giả",
    example: "tác giả của Truyện Kiều là Nguyễn Du * quyền tác giả",
  },
  {
    word: "tác động",
    part_of_speech: "động từ",
    meaning:
      "làm cho một đối tượng nào đó có những biến đổi nhất định: xu hướng toàn cầu hoá tác động mạnh đến kinh tế * chịu tác động của hoàn cảnh",
    example:
      "xu hướng toàn cầu hoá tác động mạnh đến kinh tế * chịu tác động của hoàn cảnh",
  },
  {
    word: "tác động",
    part_of_speech: "danh từ",
    meaning: "cái, điều tác động: tác động của một lực",
    example: "tác động của một lực",
  },
  {
    word: "tác gia",
    part_of_speech: "danh từ",
    meaning:
      "tác giả lớn, có tác phẩm gây ảnh hưởng sâu rộng tới đời sống xã hội: các tác gia kinh điển",
    example: "các tác gia kinh điển",
  },
  {
    word: "tác oai tác quái",
    part_of_speech: "",
    meaning:
      "làm những điều ngang ngược một cách tuỳ tiện, trái với lẽ phải: bọn côn đồ tác oai tác quái",
    example: "bọn côn đồ tác oai tác quái",
  },
  {
    word: "tác hợp",
    part_of_speech: "động từ",
    meaning:
      '(cũ) tác động làm cho kết đôi với nhau thành vợ chồng: tác hợp cho đôi trẻ * "Than rằng: Duyên lứa đôi ta, Trời xanh tác hợp, giăng già xe duyên." (PCCH)',
    example:
      'tác hợp cho đôi trẻ * "Than rằng: Duyên lứa đôi ta, Trời xanh tác hợp, giăng già xe duyên." (PCCH)',
  },
  {
    word: "tác hại",
    part_of_speech: "động từ",
    meaning:
      "gây ra điều hại đáng kể đối với ai hay cái gì: sâu bọ tác hại mùa màng",
    example: "sâu bọ tác hại mùa màng",
  },
  {
    word: "tác hại",
    part_of_speech: "danh từ",
    meaning: "điều hại đáng kể gây ra: tác hại của thuốc lá",
    example: "tác hại của thuốc lá",
  },
  {
    word: "tác phẩm",
    part_of_speech: "danh từ",
    meaning:
      "sản phẩm trí tuệ do nhà văn hoá, nghệ thuật, khoa học trực tiếp sáng tạo ra dưới một hình thức nhất định: tác phẩm văn học * tác phẩm hội hoạ đương đại",
    example: "tác phẩm văn học * tác phẩm hội hoạ đương đại",
  },
  {
    word: "tác nghiệp",
    part_of_speech: "động từ",
    meaning:
      "tiến hành công việc có tính chất nghiệp vụ, kĩ thuật: người phóng viên đang tác nghiệp * quy trình tác nghiệp",
    example: "người phóng viên đang tác nghiệp * quy trình tác nghiệp",
  },
  {
    word: "tác nhân",
    part_of_speech: "danh từ",
    meaning:
      "nhân tố gây ra một tác động nào đó (thường là có hại): các tác nhân gây bệnh * dốt nát là tác nhân kìm hãm sự tiến bộ xã hội",
    example:
      "các tác nhân gây bệnh * dốt nát là tác nhân kìm hãm sự tiến bộ xã hội",
  },
  {
    word: "tác phong",
    part_of_speech: "danh từ",
    meaning:
      "lề lối làm việc hoặc sinh hoạt hằng ngày của mỗi người: tác phong nhanh nhẹn * tác phong của người quân nhân",
    example: "tác phong nhanh nhẹn * tác phong của người quân nhân",
  },
  {
    word: "tác quái",
    part_of_speech: "động từ",
    meaning: "tác oai tác quái (nói tắt): bọn tham quan tác quái",
    example: "bọn tham quan tác quái",
  },
  {
    word: "tách bạch",
    part_of_speech: "",
    meaning:
      "tách riêng hẳn ra thành từng cái một cách rõ ràng: tính tách bạch ra từng khoản * phân chia tách bạch",
    example: "tính tách bạch ra từng khoản * phân chia tách bạch",
  },
  {
    word: "tách",
    part_of_speech: "danh từ",
    meaning:
      "(Nam thường li) đồ dùng để uống nước, lớn hơn chén, thường làm bằng sứ, miệng rộng, có quai cầm: uống một tách trà * lấy tách pha cà phê",
    example: "uống một tách trà * lấy tách pha cà phê",
  },
  {
    word: "tách",
    part_of_speech: "động từ",
    meaning:
      "làm cho rời hẳn ra, không còn gần hoặc gắn liền với nhau thành một khối nữa: tách quả cam thành từng múi * tách riêng ra từng phần",
    example: "tách quả cam thành từng múi * tách riêng ra từng phần",
  },
  {
    word: "tách",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng nổ nhỏ, nghe giòn và đanh: hạt muối trong chảo nổ đánh tách",
    example: "hạt muối trong chảo nổ đánh tách",
  },
  {
    word: "tác quyền",
    part_of_speech: "danh từ",
    meaning: "(hiếm) quyền tác giả: bảo vệ tác quyền * vi phạm tác quyền",
    example: "bảo vệ tác quyền * vi phạm tác quyền",
  },
  {
    word: "tạch",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng nổ hoặc tiếng bật nhỏ nhưng giòn và đanh: pháo nổ đánh tạch một cái",
    example: "pháo nổ đánh tạch một cái",
  },
  {
    word: "tách biệt",
    part_of_speech: "",
    meaning:
      "tách rời hẳn ra, làm cho không còn có quan hệ hoặc dính dáng gì với nhau nữa: sống tách biệt với mọi người * tách biệt ưu điểm với khuyết điểm",
    example: "sống tách biệt với mọi người * tách biệt ưu điểm với khuyết điểm",
  },
  {
    word: "tài",
    part_of_speech: "danh từ",
    meaning:
      "khả năng đặc biệt làm được một việc nào đó: một nhà văn có tài * tài ngoại giao * gắng sức học thành tài",
    example: "một nhà văn có tài * tài ngoại giao * gắng sức học thành tài",
  },
  {
    word: "tài",
    part_of_speech: "tính từ",
    meaning:
      "có tài: trọng dụng người tài * bắn súng rất tài * trai tài, gái sắc",
    example: "trọng dụng người tài * bắn súng rất tài * trai tài, gái sắc",
  },
  {
    word: "tác thành",
    part_of_speech: "động từ",
    meaning: "(cũ, hiếm) gây dựng nên cho thành đạt: ơn tác thành",
    example: "ơn tác thành",
  },
  {
    word: "tác thành",
    part_of_speech: "động từ",
    meaning: "như tác hợp: tác thành cho hai người thành vợ thành chồng",
    example: "tác thành cho hai người thành vợ thành chồng",
  },
  {
    word: "tai",
    part_of_speech: "danh từ",
    meaning:
      "cơ quan ở hai bên đầu người hoặc động vật, dùng để nghe: con chó vểnh tai * tai nghe mắt thấy",
    example: "con chó vểnh tai * tai nghe mắt thấy",
  },
  {
    word: "tai",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận ở một số vật, có hình dáng chìa ra giống như cái tai: ấm bị sứt tai * tai cối xay * tai nấm",
    example: "ấm bị sứt tai * tai cối xay * tai nấm",
  },
  {
    word: "tai",
    part_of_speech: "động từ",
    meaning: "(Khẩu ngữ) bạt tai (nói tắt): tai cho nó mấy cái",
    example: "tai cho nó mấy cái",
  },
  {
    word: "tai",
    part_of_speech: "danh từ",
    meaning:
      '(Từ cũ) điều không may bất ngờ xảy tới, gây tổn thất lớn: "Tiểu thơ con gái nhà ai, Đi đâu nên nỗi mang tai bất kỳ?" (LVT)',
    example: 'Tiểu thơ con gái nhà ai, Đi đâu nên nỗi mang tai bất kỳ?" (LVT)',
  },
  {
    word: "taekwondo",
    part_of_speech: "danh từ",
    meaning:
      "môn võ dùng để tự vệ, có nguồn gốc từ Hàn Quốc, kết hợp đá chân cao và đấm: võ sĩ taekwondo",
    example: "võ sĩ taekwondo",
  },
  {
    word: "tại",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là nơi xác định của sự việc, sự vật được nói đến diễn ra hoặc tồn tại: sinh ra và lớn lên tại Hà Nội * hội nghị diễn ra tại Huế",
    example: "sinh ra và lớn lên tại Hà Nội * hội nghị diễn ra tại Huế",
  },
  {
    word: "tại",
    part_of_speech: "kết từ",
    meaning:
      'từ biểu thị điều sắp nêu ra là nguyên nhân của việc không hay được nói đến: tại xe hỏng nên đến muộn * "Ngẫm hay muôn sự tại trời, Trời kia đã bắt làm người có thân." (TKiều)',
    example:
      'tại xe hỏng nên đến muộn * "Ngẫm hay muôn sự tại trời, Trời kia đã bắt làm người có thân." (TKiều)',
  },
  {
    word: "tài ba",
    part_of_speech: "",
    meaning: "(Khẩu ngữ) tài (nói khái quát): người thuỷ thủ tài ba",
    example: "người thuỷ thủ tài ba",
  },
  {
    word: "tải",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) bao tải (nói tắt): một tải gạo",
    example: "một tải gạo",
  },
  {
    word: "tải",
    part_of_speech: "động từ",
    meaning:
      "mang chuyển đi nơi khác bằng sức người hoặc bằng phương tiện thô sơ: đi tải đạn * tải lương thực ra tiền tuyến",
    example: "đi tải đạn * tải lương thực ra tiền tuyến",
  },
  {
    word: "tải",
    part_of_speech: "danh từ",
    meaning: "trọng tải (nói tắt): xe chở quá tải",
    example: "xe chở quá tải",
  },
  {
    word: "tái",
    part_of_speech: "tính từ",
    meaning:
      "(thức ăn, thường là thịt, cá) được chế biến chưa chín hẳn, nhưng cũng không phải còn sống: phở bò tái * thịt dê xào tái",
    example: "phở bò tái * thịt dê xào tái",
  },
  {
    word: "tái",
    part_of_speech: "tính từ",
    meaning:
      "(một số loại quả, củ) chưa được làm cho khô hẳn, nhưng cũng không phải còn tươi: cau phơi tái * cải bẹ phơi tái để muối dưa",
    example: "cau phơi tái * cải bẹ phơi tái để muối dưa",
  },
  {
    word: "tái",
    part_of_speech: "tính từ",
    meaning:
      "(nước da) đã mất sắc, trở nên xám hoặc xanh: nước da xanh tái * sợ tái mặt",
    example: "nước da xanh tái * sợ tái mặt",
  },
  {
    word: "tãi",
    part_of_speech: "động từ",
    meaning:
      'rải mỏng và dàn đều ra trên bề mặt rộng: tãi thóc ra phơi * "Bóng trăng tãi lên nền sân in bóng mấy ngọn cau khẽ lay động." (NgKhải; 29)',
    example:
      'tãi thóc ra phơi * "Bóng trăng tãi lên nền sân in bóng mấy ngọn cau khẽ lay động." (NgKhải; 29)',
  },
  {
    word: "tai ách",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) tai hoạ nặng nề bỗng nhiên phải gánh chịu: hứng chịu đủ thứ tai ách",
    example: "hứng chịu đủ thứ tai ách",
  },
  {
    word: "tai ác",
    part_of_speech: "tính từ",
    meaning:
      "rất tai hại, đáng nguyền rủa: căn bệnh tai ác * bị đòn oan vì trò đùa tai ác",
    example: "căn bệnh tai ác * bị đòn oan vì trò đùa tai ác",
  },
  {
    word: "tái bản",
    part_of_speech: "động từ",
    meaning:
      "(xuất bản phẩm) được in lại lần nữa theo bản cũ: tập thơ vừa được tái bản lần thứ hai * tái bản có sửa chữa và bổ sung",
    example:
      "tập thơ vừa được tái bản lần thứ hai * tái bản có sửa chữa và bổ sung",
  },
  {
    word: "tài cán",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tài, năng lực có được để có thể làm tốt việc gì (nói khái quát): chẳng có tài cán gì",
    example: "chẳng có tài cán gì",
  },
  {
    word: "tái bút",
    part_of_speech: "động từ",
    meaning:
      "viết thêm vào cuối bức thư, sau chữ kí (thường viết tắt là TB): đoạn tái bút",
    example: "đoạn tái bút",
  },
  {
    word: "tái chế",
    part_of_speech: "động từ",
    meaning:
      "chế tạo lại từ những sản phẩm cũ, hỏng, hoặc từ đồ phế thải: cao su tái chế * tái chế chất thải",
    example: "cao su tái chế * tái chế chất thải",
  },
  {
    word: "tai biến",
    part_of_speech: "danh từ",
    meaning:
      "biến cố bất ngờ, gây ra tai hoạ lớn: cơn tai biến * bị tai biến mạch máu não",
    example: "cơn tai biến * bị tai biến mạch máu não",
  },
  {
    word: "tái chiếm",
    part_of_speech: "động từ",
    meaning: "chiếm lấy một lần nữa: tái chiếm đồn địch",
    example: "tái chiếm đồn địch",
  },
  {
    word: "tài chủ",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người có nhiều tiền của để cho vay lấy lãi: vay tiền của các tài chủ trong làng",
    example: "vay tiền của các tài chủ trong làng",
  },
  {
    word: "tài chánh",
    part_of_speech: "danh từ",
    meaning:
      "sự quản lí việc thu chi tiền bạc theo những mục đích nhất định: công tác tài chính của cơ quan * phòng tài chính",
    example: "công tác tài chính của cơ quan * phòng tài chính",
  },
  {
    word: "tài chánh",
    part_of_speech: "danh từ",
    meaning:
      "tiền nong và việc thu chi (nói khái quát): nguồn tài chính * hỗ trợ tài chính * khả năng tài chính hạn hẹp",
    example: "nguồn tài chính * hỗ trợ tài chính * khả năng tài chính hạn hẹp",
  },
  {
    word: "tại chỗ",
    part_of_speech: "tính từ",
    meaning:
      "ở ngay tại nơi sự việc diễn ra (nơi đang được nói đến): xử lí tại chỗ * phục vụ ăn uống tại chỗ",
    example: "xử lí tại chỗ * phục vụ ăn uống tại chỗ",
  },
  {
    word: "tại chức",
    part_of_speech: "tính từ",
    meaning: "(hiếm) còn đang làm việc, đang giữ chức vụ: cán bộ tại chức",
    example: "cán bộ tại chức",
  },
  {
    word: "tại chức",
    part_of_speech: "tính từ",
    meaning:
      "(hình thức học) không tập trung, mà vừa công tác hoặc lao động sản xuất vừa tham gia học tập: đại học tại chức",
    example: "đại học tại chức",
  },
  {
    word: "tài chính",
    part_of_speech: "danh từ",
    meaning:
      "sự quản lí việc thu chi tiền bạc theo những mục đích nhất định: công tác tài chính của cơ quan * phòng tài chính",
    example: "công tác tài chính của cơ quan * phòng tài chính",
  },
  {
    word: "tài chính",
    part_of_speech: "danh từ",
    meaning:
      "tiền nong và việc thu chi (nói khái quát): nguồn tài chính * hỗ trợ tài chính * khả năng tài chính hạn hẹp",
    example: "nguồn tài chính * hỗ trợ tài chính * khả năng tài chính hạn hẹp",
  },
  {
    word: "tái diễn",
    part_of_speech: "động từ",
    meaning:
      "lặp lại lần nữa (thường nói về việc không hay): lạm phát lại tái diễn * tái diễn khuyết điểm lần trước",
    example: "lạm phát lại tái diễn * tái diễn khuyết điểm lần trước",
  },
  {
    word: "tài danh",
    part_of_speech: "",
    meaning:
      '(cũ) người có tài năng và tiếng tăm: một hoạ sĩ tài danh * "Người dung hạnh, bậc tài danh, Nghìn thu để một mối tình làm gương." (HT)',
    example:
      'một hoạ sĩ tài danh * "Người dung hạnh, bậc tài danh, Nghìn thu để một mối tình làm gương." (HT)',
  },
  {
    word: "tái cử",
    part_of_speech: "động từ",
    meaning: "bầu lại lần nữa vào chức vụ vừa giữ: tái cử chức tổng thống",
    example: "tái cử chức tổng thống",
  },
  {
    word: "tái dại",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (nước da) tái đến mức như tê dại đi, không còn thần sắc gì nữa, do quá sợ hãi hoặc xúc động mạnh: sợ quá, mặt mày tái dại",
    example: "sợ quá, mặt mày tái dại",
  },
  {
    word: "tài đức",
    part_of_speech: "danh từ",
    meaning: "tài năng và đức độ (nói khái quát): tài đức song toàn",
    example: "tài đức song toàn",
  },
  {
    word: "tai hại",
    part_of_speech: "tính từ",
    meaning:
      "có tác dụng gây ra thiệt hại lớn: sai lầm tai hại * hậu quả tai hại của việc làm ẩu * thật là tai hại!",
    example:
      "sai lầm tai hại * hậu quả tai hại của việc làm ẩu * thật là tai hại!",
  },
  {
    word: "tai hại",
    part_of_speech: "danh từ",
    meaning:
      "cái, điều gây tai hại: gây tai hại cho người khác * tai hại của cờ bạc",
    example: "gây tai hại cho người khác * tai hại của cờ bạc",
  },
  {
    word: "tải điện",
    part_of_speech: "động từ",
    meaning: "truyền điện năng đi bằng đường dây: đường dây tải điện",
    example: "đường dây tải điện",
  },
  {
    word: "tái giá",
    part_of_speech: "động từ",
    meaning: "(đàn bà goá) lấy chồng lần nữa: ở vậy nuôi con chứ không tái giá",
    example: "ở vậy nuôi con chứ không tái giá",
  },
  {
    word: "tái giá",
    part_of_speech: "động từ",
    meaning: "(lúa) cấy lại sau khi lúa cấy lần trước bị hỏng: cấy tái giá",
    example: "cấy tái giá",
  },
  {
    word: "tại gia",
    part_of_speech: "tính từ",
    meaning: "ở ngay nhà mình (thường nói về tu hành): tu tại gia",
    example: "tu tại gia",
  },
  {
    word: "tài giỏi",
    part_of_speech: "tính từ",
    meaning: "có tài và giỏi giang (nói khái quát): vị tướng tài giỏi",
    example: "vị tướng tài giỏi",
  },
  {
    word: "tái hiện",
    part_of_speech: "động từ",
    meaning:
      "xuất hiện trở lại hoặc hiện lên lại trong trí nhớ: dĩ vãng tái hiện * giấc mơ đêm trước lại tái hiện",
    example: "dĩ vãng tái hiện * giấc mơ đêm trước lại tái hiện",
  },
  {
    word: "tái hiện",
    part_of_speech: "động từ",
    meaning:
      "thể hiện lại hiện thực một cách chân thật, bằng sáng tạo nghệ thuật: tác phẩm đã tái hiện lại một thời kì lịch sử",
    example: "tác phẩm đã tái hiện lại một thời kì lịch sử",
  },
  {
    word: "tái hợp",
    part_of_speech: "động từ",
    meaning:
      "(văn chương) sum họp, đoàn tụ trở lại sau một thời gian xa cách, chia lìa: đợi ngày tái hợp * vợ chồng tái hợp",
    example: "đợi ngày tái hợp * vợ chồng tái hợp",
  },
  {
    word: "tái hồi",
    part_of_speech: "động từ",
    meaning:
      '(cũ, văn chương) trở về lại nơi cũ, về lại với người cũ hoặc với trạng thái cũ: tái hồi quê hương * "Bảy mươi chống gậy ra ngồi, Xuân ơi, xuân có tái hồi được chăng?" (ca dao)',
    example:
      'tái hồi quê hương * "Bảy mươi chống gậy ra ngồi, Xuân ơi, xuân có tái hồi được chăng?" (ca dao)',
  },
  {
    word: "tài hoa",
    part_of_speech: "tính từ",
    meaning:
      "có tài về nghệ thuật, văn chương: người nhạc sĩ tài hoa * nét vẽ tài hoa",
    example: "người nhạc sĩ tài hoa * nét vẽ tài hoa",
  },
  {
    word: "tai hoạ",
    part_of_speech: "danh từ",
    meaning:
      "điều không may gây nên những đau khổ, tổn thất lớn: gieo tai hoạ cho người khác * gặp tai hoạ",
    example: "gieo tai hoạ cho người khác * gặp tai hoạ",
  },
  {
    word: "tai hồng",
    part_of_speech: "danh từ",
    meaning: "đai ốc có hai cánh để vặn: tai hồng xe đạp",
    example: "tai hồng xe đạp",
  },
  {
    word: "tái kiểm",
    part_of_speech: "động từ",
    meaning:
      "(cơ quan chức năng) kiểm định lại: tái kiểm gia cầm từ các tỉnh đưa về",
    example: "tái kiểm gia cầm từ các tỉnh đưa về",
  },
  {
    word: "tài lộc",
    part_of_speech: "danh từ",
    meaning:
      "của cải và lợi lộc do được trời hoặc đấng thiêng liêng ban cho, theo quan niệm dân gian: tài lộc dồi dào",
    example: "tài lộc dồi dào",
  },
  {
    word: "tài khoá",
    part_of_speech: "danh từ",
    meaning:
      "thời gian quy định có hiệu lực cho một dự án ngân sách: tài khoá năm 2006-2007",
    example: "tài khoá năm 2006-2007",
  },
  {
    word: "tái lập",
    part_of_speech: "động từ",
    meaning:
      "lập lại, xây dựng lại (sau một thời gian bị ngưng hoặc đình trệ): hai nước tái lập quan hệ ngoại giao * tái lập nền hoà bình",
    example: "hai nước tái lập quan hệ ngoại giao * tái lập nền hoà bình",
  },
  {
    word: "tài khoản",
    part_of_speech: "danh từ",
    meaning:
      "số kế toán dùng để phản ánh tình hình biến động của các loại vốn và nguồn vốn: hạch toán vào các tài khoản",
    example: "hạch toán vào các tài khoản",
  },
  {
    word: "tài khoản",
    part_of_speech: "danh từ",
    meaning:
      "dấu hiệu ghi nhận sự thoả thuận của cá nhân hay cơ quan với ngân hàng để gửi tiền ở đó và rút tiền ra khi cần thiết: mở tài khoản ở ngân hàng * kiểm tra tài khoản",
    example: "mở tài khoản ở ngân hàng * kiểm tra tài khoản",
  },
  {
    word: "tài khoản",
    part_of_speech: "danh từ",
    meaning:
      "dấu hiệu quy định quyền được sử dụng một dịch vụ nào đó sau khi đã đăng kí với nơi cung cấp dịch vụ: tài khoản kết nối Internet * tài khoản truy cập",
    example: "tài khoản kết nối Internet * tài khoản truy cập",
  },
  {
    word: "tai nạn",
    part_of_speech: "danh từ",
    meaning:
      "việc rủi ro bất ngờ xảy ra, gây thiệt hại lớn cho con người: tai nạn giao thông * tai nạn sập lò * gặp tai nạn",
    example: "tai nạn giao thông * tai nạn sập lò * gặp tai nạn",
  },
  {
    word: "tài liệu",
    part_of_speech: "danh từ",
    meaning:
      "dữ liệu, tin tức giúp cho việc tìm hiểu một vấn đề gì: tài liệu lịch sử * tham khảo tài liệu * thu thập tài liệu",
    example: "tài liệu lịch sử * tham khảo tài liệu * thu thập tài liệu",
  },
  {
    word: "tai mắt",
    part_of_speech: "danh từ",
    meaning:
      "tai và mắt (nói khái quát); thường dùng để ví người chuyên đi nghe ngóng, dò la, tìm hiểu tin tức hoặc tình hình để cung cấp cho người khác: bị tai mắt của địch theo dõi * có tai mắt ở khắp nơi",
    example: "bị tai mắt của địch theo dõi * có tai mắt ở khắp nơi",
  },
  {
    word: "tai mắt",
    part_of_speech: "danh từ",
    meaning: "(cũ) người có quyền thế, danh vọng: bậc tai mắt trong thành phố",
    example: "bậc tai mắt trong thành phố",
  },
  {
    word: "tài nào mà chẳng",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) không thể nào không, thể nào rồi cũng sẽ phải như thế: để một mình nó làm tài nào mà chẳng hỏng việc",
    example: "để một mình nó làm tài nào mà chẳng hỏng việc",
  },
  {
    word: "tái mét",
    part_of_speech: "tính từ",
    meaning:
      "tái đến mức nhợt nhạt như không còn chút máu (thường nói về sắc mặt): mặt tái mét",
    example: "mặt tái mét",
  },
  {
    word: "tài lực",
    part_of_speech: "danh từ",
    meaning:
      "khả năng về tài chính dùng cho một mục đích nhất định: huy động mọi nguồn tài lực * động viên nhân lực, vật lực và tài lực",
    example:
      "huy động mọi nguồn tài lực * động viên nhân lực, vật lực và tài lực",
  },
  {
    word: "tài lực",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) tài năng và sức lực: một vị tướng có tài lực * đem hết tài lực ra để đối phó",
    example: "một vị tướng có tài lực * đem hết tài lực ra để đối phó",
  },
  {
    word: "tái ngắt",
    part_of_speech: "tính từ",
    meaning:
      "rất tái, đến mức trông như không còn chút sắc hồng nào: lạnh quá, người cháu bé tái ngắt",
    example: "lạnh quá, người cháu bé tái ngắt",
  },
  {
    word: "tại ngoại",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (bị can) không bị giam trong giai đoạn chờ điều tra và xét xử (nhưng thường bị quản chế trong một phạm vi cư trú nhất định): bị can được tại ngoại",
    example: "bị can được tại ngoại",
  },
  {
    word: "tài năng",
    part_of_speech: "danh từ",
    meaning:
      "năng lực xuất sắc, khả năng làm giỏi và có sáng tạo trong công việc: một kĩ sư trẻ có tài năng * trổ hết tài năng",
    example: "một kĩ sư trẻ có tài năng * trổ hết tài năng",
  },
  {
    word: "tài năng",
    part_of_speech: "danh từ",
    meaning:
      "người có tài năng: phát hiện và bồi dưỡng những tài năng trẻ * một tài năng âm nhạc của đất nước",
    example:
      "phát hiện và bồi dưỡng những tài năng trẻ * một tài năng âm nhạc của đất nước",
  },
  {
    word: "tài nghệ",
    part_of_speech: "danh từ",
    meaning:
      "tài năng đạt đến độ điêu luyện trong nghề nghiệp: trổ hết tài nghệ ra thi đấu",
    example: "trổ hết tài nghệ ra thi đấu",
  },
  {
    word: "tai nghe",
    part_of_speech: "danh từ",
    meaning:
      "loa được cấu tạo để đặt hoặc áp vào tai khi nghe radio, điện thoại, v.v., mà không để người khác nghe thấy: bộ tai nghe * tai nghe không dây",
    example: "bộ tai nghe * tai nghe không dây",
  },
  {
    word: "tại ngũ",
    part_of_speech: "tính từ",
    meaning: "còn đang phục vụ trong quân đội: lính tại ngũ",
    example: "lính tại ngũ",
  },
  {
    word: "tái ngũ",
    part_of_speech: "động từ",
    meaning:
      "(quân nhân đã xuất ngũ) trở lại phục vụ trong quân đội: lên đường tái ngũ",
    example: "lên đường tái ngũ",
  },
  {
    word: "tài nguyên",
    part_of_speech: "danh từ",
    meaning:
      "nguồn của cải có sẵn trong tự nhiên chưa khai thác hoặc đang được tiến hành khai thác: nguồn tài nguyên * thăm dò tài nguyên * khai thác tài nguyên khoáng sản",
    example:
      "nguồn tài nguyên * thăm dò tài nguyên * khai thác tài nguyên khoáng sản",
  },
  {
    word: "tái ngộ",
    part_of_speech: "động từ",
    meaning: "(cũ) gặp lại nhau, sau một thời gian xa cách: hẹn ngày tái ngộ",
    example: "hẹn ngày tái ngộ",
  },
  {
    word: "tai ngược",
    part_of_speech: "tính từ",
    meaning:
      "ngang ngược một cách quá mức, khó có thể chấp nhận được: ăn nói tai ngược * tính nết tai ngược",
    example: "ăn nói tai ngược * tính nết tai ngược",
  },
  {
    word: "tái phạm",
    part_of_speech: "động từ",
    meaning: "phạm lại tội cũ hoặc sai lầm cũ: tái phạm khuyết điểm",
    example: "tái phạm khuyết điểm",
  },
  {
    word: "tài phán",
    part_of_speech: "động từ",
    meaning:
      "phân định phải trái và xử lí theo luật của một nước hoặc theo thông lệ quốc tế: cơ quan tài phán * lãnh sự tài phán",
    example: "cơ quan tài phán * lãnh sự tài phán",
  },
  {
    word: "tái nhợt",
    part_of_speech: "tính từ",
    meaning: "tái và nhợt nhạt hẳn đi: gương mặt tái nhợt * đôi môi tái nhợt",
    example: "gương mặt tái nhợt * đôi môi tái nhợt",
  },
  {
    word: "tái phát",
    part_of_speech: "động từ",
    meaning:
      "(bệnh, vết thương cũ) phát lại sau một thời gian đã bớt, đã khỏi: bệnh cũ tái phát",
    example: "bệnh cũ tái phát",
  },
  {
    word: "tài phiệt",
    part_of_speech: "danh từ",
    meaning:
      "tư bản tài chính có thế lực, nắm quyền chi phối kinh tế - chính trị ở các nước tư bản: giới tài phiệt * nhà tài phiệt",
    example: "giới tài phiệt * nhà tài phiệt",
  },
  {
    word: "tai quái",
    part_of_speech: "tính từ",
    meaning:
      "tinh ranh, quỷ quái đến mức làm cho người khác phải khốn khổ: trò đùa tai quái * con bé tai quái lắm!",
    example: "trò đùa tai quái * con bé tai quái lắm!",
  },
  {
    word: "tài sản",
    part_of_speech: "danh từ",
    meaning:
      "mọi giá trị hữu hình (vật chất) hoặc vô hình (tinh thần) đem lại lợi ích thiết thực đối với chủ sở hữu: tịch thu tài sản * ngôn ngữ là thứ tài sản quý giá của con người",
    example: "tịch thu tài sản * ngôn ngữ là thứ tài sản quý giá của con người",
  },
  {
    word: "tái sản xuất",
    part_of_speech: "động từ",
    meaning:
      "sản xuất lặp lại và tiếp diễn không ngừng với mức độ như cũ hoặc với mức độ lớn hơn: đầu tư thêm vốn để tái sản xuất * tái sản xuất sức lao động",
    example: "đầu tư thêm vốn để tái sản xuất * tái sản xuất sức lao động",
  },
  {
    word: "tai phôn",
    part_of_speech: "danh từ",
    meaning:
      "loa được cấu tạo để đặt hoặc áp vào tai khi nghe radio, điện thoại, v.v., mà không để người khác nghe thấy: bộ tai nghe * tai nghe không dây",
    example: "bộ tai nghe * tai nghe không dây",
  },
  {
    word: "tại sao",
    part_of_speech: "",
    meaning:
      "tổ hợp dùng để chỉ nguyên nhân hoặc lí do chưa biết rõ của điều đã xảy ra: tại sao anh lại làm như thế? * chẳng biết tại sao máy lại hỏng!",
    example: "tại sao anh lại làm như thế? * chẳng biết tại sao máy lại hỏng!",
  },
  {
    word: "tài sắc",
    part_of_speech: "danh từ",
    meaning:
      'tài năng và nhan sắc (chỉ nói về nữ giới): tài sắc vẹn toàn * "Kiều càng sắc sảo mặn mà, So bề tài sắc, lại là phần hơn." (TKiều)',
    example:
      'tài sắc vẹn toàn * "Kiều càng sắc sảo mặn mà, So bề tài sắc, lại là phần hơn." (TKiều)',
  },
  {
    word: "tái sinh",
    part_of_speech: "động từ",
    meaning:
      "sinh lại một lần nữa ở kiếp khác, theo thuyết luân hồi của đạo Phật.",
    example: "rừng tái sinh",
  },
  {
    word: "tái sinh",
    part_of_speech: "động từ",
    meaning:
      "sống lại hoặc được làm cho sống lại, sinh sôi nảy nở lại: rừng tái sinh",
    example: "nhựa tái sinh * sản phẩm cao su tái sinh",
  },
  {
    word: "tái tạo",
    part_of_speech: "động từ",
    meaning:
      "tạo ra lại, làm ra lại: tái tạo rừng * tái tạo men răng * ơn tái tạo",
    example: "tái tạo rừng * tái tạo men răng * ơn tái tạo",
  },
  {
    word: "tái tạo",
    part_of_speech: "động từ",
    meaning:
      "phản ánh hiện thực có hư cấu, tưởng tượng, nhưng chân thật và sinh động đến mức như làm sống lại hiện thực: bộ phim đã tái tạo lại một thời kì lịch sử",
    example: "bộ phim đã tái tạo lại một thời kì lịch sử",
  },
  {
    word: "tai tái",
    part_of_speech: "tính từ",
    meaning: "hơi tái: nước da tai tái * giá chần tai tái",
    example: "nước da tai tái * giá chần tai tái",
  },
  {
    word: "tái thẩm",
    part_of_speech: "động từ",
    meaning:
      "xét lại một bản án đã xử (khi phát hiện những tình tiết mới có thể làm thay đổi bản chất của vụ án): hội đồng tái thẩm * phiên tái thẩm",
    example: "hội đồng tái thẩm * phiên tái thẩm",
  },
  {
    word: "tái thiết",
    part_of_speech: "động từ",
    meaning:
      "kiến thiết lại, thiết lập lại: tái thiết đất nước sau chiến tranh * tái thiết hoà bình",
    example: "tái thiết đất nước sau chiến tranh * tái thiết hoà bình",
  },
  {
    word: "tái tê",
    part_of_speech: "tính từ",
    meaning:
      'như tê tái: trong lòng tái tê * "Đêm qua trăng gác đầu non, Vạc kêu sương lạnh em buồn tái tê." (ca dao)',
    example:
      'trong lòng tái tê * "Đêm qua trăng gác đầu non, Vạc kêu sương lạnh em buồn tái tê." (ca dao)',
  },
  {
    word: "tài tình",
    part_of_speech: "tính từ",
    meaning:
      '(cũ, văn chương) tài hoa và tình cảm: "Nghĩ đời mà ngán cho đời, Tài tình chi lắm cho trời đất ghen." (TKiều)',
    example:
      'Nghĩ đời mà ngán cho đời, Tài tình chi lắm cho trời đất ghen." (TKiều)',
  },
  {
    word: "tài tình",
    part_of_speech: "tính từ",
    meaning:
      'tỏ ra có tài nghệ đến mức đáng khâm phục: biến hoá tài tình * "Anh Hoàng là một nhà văn, nhưng đồng thời cũng là một tay chợ đen rất tài tình." (NCao; 8)',
    example:
      'biến hoá tài tình * "Anh Hoàng là một nhà văn, nhưng đồng thời cũng là một tay chợ đen rất tài tình." (NCao; 8)',
  },
  {
    word: "tải thương",
    part_of_speech: "động từ",
    meaning:
      "chuyên chở người bị thương (ở ngoài mặt trận): nhiệm vụ tải thương * lính tải thương",
    example: "nhiệm vụ tải thương * lính tải thương",
  },
  {
    word: "tai tiếng",
    part_of_speech: "danh từ",
    meaning: "tiếng xấu, dư luận xấu: sợ tai tiếng * vụ việc tai tiếng",
    example: "sợ tai tiếng * vụ việc tai tiếng",
  },
  {
    word: "tai to mặt lớn",
    part_of_speech: "",
    meaning:
      "chỉ người có quyền thế, địa vị trong xã hội (hàm ý không coi trọng): những kẻ tai to mặt lớn * thuộc hạng tai to mặt lớn trong tỉnh",
    example: "những kẻ tai to mặt lớn * thuộc hạng tai to mặt lớn trong tỉnh",
  },
  {
    word: "tại trận",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ở ngay nơi và ngay giữa lúc sự việc đang diễn ra: bị bắt tại trận",
    example: "bị bắt tại trận",
  },
  {
    word: "tài trợ",
    part_of_speech: "động từ",
    meaning:
      "giúp đỡ về mặt tài chính: tìm nguồn tài trợ * đơn vị tài trợ chính của chương trình",
    example: "tìm nguồn tài trợ * đơn vị tài trợ chính của chương trình",
  },
  {
    word: "tai ương",
    part_of_speech: "danh từ",
    meaning: "như tai ách: mắc phải tai ương * gieo rắc tai ương",
    example: "mắc phải tai ương * gieo rắc tai ương",
  },
  {
    word: "tải trọng",
    part_of_speech: "danh từ",
    meaning:
      "sức chịu đựng (xét về mặt cơ học) của một vật khi có lực (hoặc ngẫu lực) từ bên ngoài tác động vào: kim loại có khả năng chịu được tải trọng lớn * tải trọng của cây cầu",
    example:
      "kim loại có khả năng chịu được tải trọng lớn * tải trọng của cây cầu",
  },
  {
    word: "tải trọng",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như trọng tải: tải trọng của xe là 15 tấn",
    example: "tải trọng của xe là 15 tấn",
  },
  {
    word: "tài tử",
    part_of_speech: "danh từ",
    meaning: "(Từ cũ, Văn chương) người đàn ông tài hoa: tài tử giai nhân",
    example: "tài tử giai nhân",
  },
  {
    word: "tài tử",
    part_of_speech: "danh từ",
    meaning:
      "diễn viên sân khấu, xiếc hay điện ảnh có tài: tài tử điện ảnh * tài tử cải lương",
    example: "tài tử điện ảnh * tài tử cải lương",
  },
  {
    word: "tài tử",
    part_of_speech: "tính từ",
    meaning:
      "không phải chuyên nghiệp, chỉ do thích thú mà chơi hoặc theo đuổi một cách nghiệp dư một môn thể thao, văn nghệ nào đó: đờn ca tài tử * một giọng ca tài tử",
    example: "đờn ca tài tử * một giọng ca tài tử",
  },
  {
    word: "tài tử",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) (phong cách, lối làm việc) tuỳ hứng, không có sự chuyên tâm: lối học tài tử",
    example: "lối học tài tử",
  },
  {
    word: "tài trí",
    part_of_speech: "danh từ",
    meaning: "tài năng và trí tuệ (nói khái quát): có tài trí hơn người",
    example: "có tài trí hơn người",
  },
  {
    word: "tài trí",
    part_of_speech: "tính từ",
    meaning:
      'có tài và thông minh: một người lính gan dạ và tài trí * "Dầu cho tài trí bực nào, Gặp cơn nguy hiểm biết sao mà nhờ." (LVT)',
    example:
      'một người lính gan dạ và tài trí * "Dầu cho tài trí bực nào, Gặp cơn nguy hiểm biết sao mà nhờ." (LVT)',
  },
  {
    word: "tai vạ",
    part_of_speech: "danh từ",
    meaning:
      "điều không may lớn phải gánh chịu một cách oan uổng: gây ra tai vạ cho người khác * hứng chịu tai vạ",
    example: "gây ra tai vạ cho người khác * hứng chịu tai vạ",
  },
  {
    word: "tài vụ",
    part_of_speech: "danh từ",
    meaning:
      "công việc thu chi tiền và sử dụng vốn để thực hiện nhiệm vụ ở một cơ quan, một tổ chức: phòng tài vụ * phụ trách tài vụ",
    example: "phòng tài vụ * phụ trách tài vụ",
  },
  {
    word: "tái vũ trang",
    part_of_speech: "động từ",
    meaning:
      "(nước hoặc lực lượng đã bị giải giáp) tự vũ trang trở lại: lực lượng tái vũ trang",
    example: "lực lượng tái vũ trang",
  },
  {
    word: "tái xanh",
    part_of_speech: "tính từ",
    meaning:
      "(da người) tái đến mức như ngả sang màu xanh: da tái xanh * sợ quá, mặt tái xanh lại",
    example: "da tái xanh * sợ quá, mặt tái xanh lại",
  },
  {
    word: "tài xế",
    part_of_speech: "danh từ",
    meaning: "người làm nghề lái ô tô hoặc tàu hoả: tài xế ô tô",
    example: "tài xế ô tô",
  },
  {
    word: "tái xuất",
    part_of_speech: "động từ",
    meaning:
      "xuất khẩu trở lại những hàng hoá đã nhập khẩu mà không qua gia công chế biến gì ở trong nước, hoặc những hàng hoá nhập lậu từ nước ngoài tịch thu được; phân biệt với tái nhập: tái xuất những lô hàng nhập lậu",
    example: "tái xuất những lô hàng nhập lậu",
  },
  {
    word: "tam",
    part_of_speech: "danh từ",
    meaning: "ba: nhất nước, nhì phân, tam cần, tứ giống (tng)",
    example: "nhất nước, nhì phân, tam cần, tứ giống (tng)",
  },
  {
    word: "taiga",
    part_of_speech: "danh từ",
    meaning:
      "rừng cây thuộc họ thông, mọc thành miền rộng lớn ở xứ lạnh như Bắc á, Bắc Âu, Bắc Mĩ: những dãy rừng taiga ở vùng Siberia",
    example: "những dãy rừng taiga ở vùng Siberia",
  },
  {
    word: "tám",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi chung một số giống lúa tẻ, gạo hạt nhỏ và dài, cơm có mùi thơm, ngon: gạo tám * cơm tám",
    example: "gạo tám * cơm tám",
  },
  {
    word: "tám",
    part_of_speech: "danh từ",
    meaning:
      "số (ghi bằng 8) tiếp theo số bảy trong dãy số tự nhiên: ngày làm việc tám tiếng * cao một mét tám",
    example: "ngày làm việc tám tiếng * cao một mét tám",
  },
  {
    word: "tai-ga",
    part_of_speech: "danh từ",
    meaning:
      "rừng cây thuộc họ thông, mọc thành miền rộng lớn ở xứ lạnh như Bắc á, Bắc Âu, Bắc Mĩ: những dãy rừng taiga ở vùng Siberia",
    example: "những dãy rừng taiga ở vùng Siberia",
  },
  {
    word: "tạm",
    part_of_speech: "tính từ",
    meaning:
      "(làm việc gì) chỉ trong một thời gian nào đó, khi có điều kiện thì sẽ có thay đổi: chuyến đi tạm hoãn * tạm lánh đi nơi khác",
    example: "chuyến đi tạm hoãn * tạm lánh đi nơi khác",
  },
  {
    word: "tạm",
    part_of_speech: "tính từ",
    meaning:
      "chưa thật đạt yêu cầu như mong muốn, nhưng có thể chấp nhận và coi là được: công việc đã tạm ổn * ăn tạm cái bánh cho đỡ đói",
    example: "công việc đã tạm ổn * ăn tạm cái bánh cho đỡ đói",
  },
  {
    word: "tam bành",
    part_of_speech: "danh từ",
    meaning:
      '(hiếm) ba vị hung thần có ở trong con người, là Bành Cư, Bành Kiêu, Bành Chất, chuyên xui khiến con người ta làm điều bậy bạ; dùng để chỉ cơn giận ghê gớm (thường của người đàn bà): nổi cơn tam bành * "Thuận lòng bao quản sang hèn, Tam bành bà đã nổi lên một hồi." (NĐM)',
    example:
      'nổi cơn tam bành * "Thuận lòng bao quản sang hèn, Tam bành bà đã nổi lên một hồi." (NĐM)',
  },
  {
    word: "tam bản",
    part_of_speech: "danh từ",
    meaning:
      "thuyền hoặc ghe nhỏ không mui, có một chèo, thường làm bằng ba tấm gỗ ghép lại: ghe tam bản",
    example: "ghe tam bản",
  },
  {
    word: "tạm biệt",
    part_of_speech: "động từ",
    meaning:
      "chia tay nhau với hi vọng sẽ sớm được gặp lại; cũng dùng làm lời chào khi chia tay: xin tạm biệt! * vẫy tay chào tạm biệt",
    example: "xin tạm biệt! * vẫy tay chào tạm biệt",
  },
  {
    word: "tạm bợ",
    part_of_speech: "tính từ",
    meaning:
      "chỉ có tính chất nhất thời, chứ không nhằm tới một cái gì ổn định, lâu dài: sống tạm bợ * dựng căn lều tạm bợ",
    example: "sống tạm bợ * dựng căn lều tạm bợ",
  },
  {
    word: "tam đại",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) đã xưa lắm, cũ lắm, từ đời thuở nào rồi: chuyện từ đời tam đại nào rồi mà vẫn còn nhắc",
    example: "chuyện từ đời tam đại nào rồi mà vẫn còn nhắc",
  },
  {
    word: "tam cúc",
    part_of_speech: "danh từ",
    meaning:
      "bài lá gồm ba mươi hai quân giống như quân cờ tướng: chơi tam cúc * cỗ bài tam cúc",
    example: "chơi tam cúc * cỗ bài tam cúc",
  },
  {
    word: "tạm cư",
    part_of_speech: "động từ",
    meaning: "cư trú tạm thời, không ở cố định hoặc cư trú lâu dài: hộ tạm cư",
    example: "hộ tạm cư",
  },
  {
    word: "tam đảo",
    part_of_speech: "danh từ",
    meaning:
      'ba hòn đảo nơi tiên ở: Bồng Lai, Phương Trượng, Doanh Châu; thường dùng để chỉ cõi tiên: "Trên tam đảo dưới cửu tuyền, Tìm đâu thì cũng biết tin rõ ràng." (TKiều)',
    example:
      'Trên tam đảo dưới cửu tuyền, Tìm đâu thì cũng biết tin rõ ràng." (TKiều)',
  },
  {
    word: "tám đời",
    part_of_speech: "danh từ",
    meaning:
      '(khẩu ngữ) đã lâu lắm, như từ cách đây nhiều đời: hết từ tám đời rồi * "Chị em cùng khúc ruột rà, Kẻ giàu người khó, họ xa tám đời." (ca dao)',
    example:
      'hết từ tám đời rồi * "Chị em cùng khúc ruột rà, Kẻ giàu người khó, họ xa tám đời." (ca dao)',
  },
  {
    word: "tám hoánh",
    part_of_speech: "danh từ",
    meaning:
      '(khẩu ngữ) thời gian đã lâu lắm rồi: chuyện từ đời tám hoánh, nhắc làm gì * "Khách về từ tám hoánh mới đem nước ra để làm gì bây giờ?" (LKhai; 1)',
    example:
      'chuyện từ đời tám hoánh, nhắc làm gì * "Khách về từ tám hoánh mới đem nước ra để làm gì bây giờ?" (LKhai; 1)',
  },
  {
    word: "tam quan",
    part_of_speech: "danh từ",
    meaning: "cổng xây có ba lối ra vào ở trước chùa: sửa chữa lại tam quan",
    example: "sửa chữa lại tam quan",
  },
  {
    word: "tam giới",
    part_of_speech: "danh từ",
    meaning:
      "ba cõi, là dục giới, sắc giới và vô sắc giới, trong trời đất, theo quan niệm của đạo Phật; cũng dùng để chỉ chung thế giới: luân hồi trong tam giới * đứng trong tam giới",
    example: "luân hồi trong tam giới * đứng trong tam giới",
  },
  {
    word: "tam nguyên",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người đỗ đầu cả ba kì thi thời phong kiến, là thi hương, thi hội và thi đình: đỗ tam nguyên * tam nguyên Yên Đổ (NgKhuyến)",
    example: "đỗ tam nguyên * tam nguyên Yên Đổ (NgKhuyến)",
  },
  {
    word: "tam phẩm",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) phẩm trật thứ ba trong thang cấp bậc quan lại: chức phủ doãn được xếp vào hàng tam phẩm",
    example: "chức phủ doãn được xếp vào hàng tam phẩm",
  },
  {
    word: "tàm tạm",
    part_of_speech: "tính từ",
    meaning:
      "hơi tạm được, mặc dù chưa thật đạt yêu cầu: cô ta trông cũng tàm tạm * công việc đã tàm tạm ổn",
    example: "cô ta trông cũng tàm tạm * công việc đã tàm tạm ổn",
  },
  {
    word: "tam tài",
    part_of_speech: "danh từ",
    meaning:
      "ba màu: xanh, trắng và đỏ: chiếc áo tam tài * cờ tam tài (cờ nước Pháp; theo cách gọi trước đây)",
    example:
      "chiếc áo tam tài * cờ tam tài (cờ nước Pháp; theo cách gọi trước đây)",
  },
  {
    word: "tam tạng",
    part_of_speech: "danh từ",
    meaning:
      "sách kinh của Phật giáo (chia làm ba bộ: Kinh, Luật, Luận), nói chung: kinh Tam Tạng",
    example: "kinh Tam Tạng",
  },
  {
    word: "tam tấu",
    part_of_speech: "động từ",
    meaning: "hoà nhạc ba người: nhóm tam tấu",
    example: "nhóm tam tấu",
  },
  {
    word: "tam thể",
    part_of_speech: "danh từ",
    meaning: "ba màu: mèo tam thể",
    example: "mèo tam thể",
  },
  {
    word: "tạm thời",
    part_of_speech: "tính từ",
    meaning:
      "không có tính chất lâu dài, chỉ có tính chất trong một thời gian ngắn trước mắt: chỗ ở tạm thời * tạm thời ngừng hoạt động",
    example: "chỗ ở tạm thời * tạm thời ngừng hoạt động",
  },
  {
    word: "tam thất",
    part_of_speech: "danh từ",
    meaning:
      "cây nhỏ mọc ở vùng núi cao, rễ củ màu đen dùng làm thuốc: đen như củ tam thất",
    example: "đen như củ tam thất",
  },
  {
    word: "tam toạng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) vớ vẩn, không kể gì đúng sai, không có căn cứ và chủ đích gì: ăn nói tam toạng",
    example: "ăn nói tam toạng",
  },
  {
    word: "tạm trú",
    part_of_speech: "động từ",
    meaning:
      "ở tạm một thời gian, không ở thường xuyên một cách chính thức: xin được tạm trú ít hôm * đăng kí hộ khẩu tạm trú",
    example: "xin được tạm trú ít hôm * đăng kí hộ khẩu tạm trú",
  },
  {
    word: "tam tòng",
    part_of_speech: "danh từ",
    meaning:
      "nguyên tắc bắt buộc của lễ giáo phong kiến đối với người đàn bà xưa, là khi ở nhà phải theo cha, khi lấy chồng phải theo chồng, khi chồng chết phải theo con (nói tổng quát): giữ đạo tam tòng",
    example: "giữ đạo tam tòng",
  },
  {
    word: "tạm ước",
    part_of_speech: "danh từ",
    meaning:
      "điều ước tạm thời do hai hay nhiều nước kí kết với nhau để hoà hoãn xung đột, tạo điều kiện đi đến kí kết điều ước chính thức nhằm giải quyết toàn bộ sự tranh chấp: kí tạm ước",
    example: "kí tạm ước",
  },
  {
    word: "tạm trữ",
    part_of_speech: "động từ",
    meaning:
      "dự trữ trong một thời gian ngắn để giải quyết khó khăn trước mắt: tạm trữ lúa gạo cho mùa bão * mua cà phê tạm trữ để chờ giá lên",
    example: "tạm trữ lúa gạo cho mùa bão * mua cà phê tạm trữ để chờ giá lên",
  },
  {
    word: "tạm ứng",
    part_of_speech: "động từ",
    meaning:
      "ứng trước, thường là một khoản tiền, rồi sẽ thanh toán sau: tạm ứng tiền lương",
    example: "tạm ứng tiền lương",
  },
  {
    word: "tạm tuyển",
    part_of_speech: "động từ",
    meaning:
      "tạm nhận vào làm việc trong cơ quan, xí nghiệp, v.v., không phải trong biên chế chính thức: nhân viên tạm tuyển",
    example: "nhân viên tạm tuyển",
  },
  {
    word: "tạm vắng",
    part_of_speech: "động từ",
    meaning: "tạm thời vắng mặt ở nơi đăng kí thường trú: khai báo tạm trú",
    example: "khai báo tạm trú",
  },
  {
    word: "tản",
    part_of_speech: "động từ",
    meaning:
      "di chuyển ra nhiều phía, làm cho ở trên một diện tích rộng hơn: làn khói tản rộng ra xung quanh * đoàn người tản dần về các ngõ xóm",
    example:
      "làn khói tản rộng ra xung quanh * đoàn người tản dần về các ngõ xóm",
  },
  {
    word: "tan",
    part_of_speech: "động từ",
    meaning:
      "(chất rắn) hoà lẫn hoàn toàn vào trong một chất lỏng: muối tan trong nước * quấy cho tan đường",
    example: "muối tan trong nước * quấy cho tan đường",
  },
  {
    word: "tan",
    part_of_speech: "động từ",
    meaning:
      "chuyển từ trạng thái rắn sang trạng thái lỏng: tuyết tan * băng bắt đầu tan",
    example: "tuyết tan * băng bắt đầu tan",
  },
  {
    word: "tan",
    part_of_speech: "động từ",
    meaning:
      "vỡ vụn ra thành nhiều mảnh nhỏ, không còn nguyên vẹn như trước: chiếc cốc rơi xuống đất, vỡ tan * đập tan âm mưu phá hoại của địch",
    example:
      "chiếc cốc rơi xuống đất, vỡ tan * đập tan âm mưu phá hoại của địch",
  },
  {
    word: "tan",
    part_of_speech: "động từ",
    meaning:
      "tản dần ra xung quanh, không còn tập trung và như biến mất dần đi: cơn bão đã tan * trời tan mây * sương tan",
    example: "cơn bão đã tan * trời tan mây * sương tan",
  },
  {
    word: "tan",
    part_of_speech: "động từ",
    meaning:
      "(đám đông người) kết thúc hoạt động và tản ra các ngả: tan học * tan cuộc họp * chợ đã tan",
    example: "tan học * tan cuộc họp * chợ đã tan",
  },
  {
    word: "tàn bạo",
    part_of_speech: "tính từ",
    meaning: "độc ác và hung bạo: cách đối xử tàn bạo * thủ đoạn tàn bạo",
    example: "cách đối xử tàn bạo * thủ đoạn tàn bạo",
  },
  {
    word: "tán",
    part_of_speech: "danh từ",
    meaning: "tàn lớn: tán che kiệu",
    example: "tán che kiệu",
  },
  {
    word: "tán",
    part_of_speech: "danh từ",
    meaning: "vật có hình dáng như cái tán: tán đèn",
    example: "tán đèn",
  },
  {
    word: "tán",
    part_of_speech: "danh từ",
    meaning:
      "vòng sáng mờ nhạt nhiều màu sắc bao quanh mặt trời hay mặt trăng do sự khúc xạ và phản chiếu ánh sáng qua màn mây: trăng quầng thì hạn, trăng tán thì mưa (tng)",
    example: "trăng quầng thì hạn, trăng tán thì mưa (tng)",
  },
  {
    word: "tán",
    part_of_speech: "danh từ",
    meaning:
      "bộ lá của cây, tạo thành vòm lớn, có hình giống như cái tán: dưới tán cây rừng * cây bàng xoè tán rộng",
    example: "dưới tán cây rừng * cây bàng xoè tán rộng",
  },
  {
    word: "tán",
    part_of_speech: "danh từ",
    meaning:
      "kiểu cụm hoa có các nhánh cùng xuất phát từ một điểm chung trên trục chính, trông như cái tán: cây mùi thuộc họ hoa tán",
    example: "cây mùi thuộc họ hoa tán",
  },
  {
    word: "tán",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) nói với nhau những chuyện linh tinh, không đâu vào đâu, cốt để cho vui: tranh thủ ngồi tán vui một lúc * tán chuyện",
    example: "tranh thủ ngồi tán vui một lúc * tán chuyện",
  },
  {
    word: "tán",
    part_of_speech: "động từ",
    meaning: "nói thêm thắt vào, thường là nói quá lên: có một tán thành ba",
    example: "có một tán thành ba",
  },
  {
    word: "tán",
    part_of_speech: "động từ",
    meaning:
      'nói khéo, nói hay cho người ta thích, chứ không thật lòng, cốt để tranh thủ, lợi dụng: tán gái * "Canh suông khéo nấu thì ngon, Mẹ già khéo tán thì con đắt chồng." (Cdao)',
    example:
      'tán gái * "Canh suông khéo nấu thì ngon, Mẹ già khéo tán thì con đắt chồng." (Cdao)',
  },
  {
    word: "tán",
    part_of_speech: "động từ",
    meaning: "đập bẹt đầu đinh ra để cho bám giữ chặt: tán đinh",
    example: "tán đinh",
  },
  {
    word: "tán",
    part_of_speech: "động từ",
    meaning: "nghiền cho nhỏ vụn ra: tán thuốc * tán bột",
    example: "tán thuốc * tán bột",
  },
  {
    word: "tàn",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng có cán dài cắm vào một cái khung tròn bọc nhiễu hoặc vóc, xung quanh rủ dài xuống, để che cho vua chúa thời trước, hoặc để che kiệu trong các đám rước: mặt ngay cán tàn",
    example: "mặt ngay cán tàn",
  },
  {
    word: "tàn",
    part_of_speech: "danh từ",
    meaning:
      "cành lá của cây xoè ra trên cao, trông như hình cái tàn (nói tổng quát): ngồi dưới tàn cây",
    example: "ngồi dưới tàn cây",
  },
  {
    word: "tàn",
    part_of_speech: "động từ",
    meaning:
      '(hoa) ở trạng thái cuối của sự tồn tại, héo khô dần: sen tàn * "Còn nhiều ân ái chan chan, Hay gì vầy cánh hoa tàn mà chơi?" (TKiều)',
    example:
      'sen tàn * "Còn nhiều ân ái chan chan, Hay gì vầy cánh hoa tàn mà chơi?" (TKiều)',
  },
  {
    word: "tàn",
    part_of_speech: "động từ",
    meaning:
      "(lửa) ở trạng thái yếu dần, biểu hiện sự sắp tắt: đống tro tàn (tro của lửa đã tàn) * chưa tàn nén hương",
    example: "đống tro tàn (tro của lửa đã tàn) * chưa tàn nén hương",
  },
  {
    word: "tàn",
    part_of_speech: "động từ",
    meaning:
      "ở vào giai đoạn cuối cùng của sự tồn tại, có những dấu hiệu của sự suy dần, yếu dần: sức tàn lực kiệt * cuộc vui sắp tàn",
    example: "sức tàn lực kiệt * cuộc vui sắp tàn",
  },
  {
    word: "tàn",
    part_of_speech: "danh từ",
    meaning:
      "phần còn lại của vật sau khi cháy hết: tàn thuốc lá * theo đóm ăn tàn (tng)",
    example: "tàn thuốc lá * theo đóm ăn tàn (tng)",
  },
  {
    word: "tàn binh",
    part_of_speech: "danh từ",
    meaning: "như tàn quân: truy lùng bọn tàn binh",
    example: "truy lùng bọn tàn binh",
  },
  {
    word: "tàn canh",
    part_of_speech: "động từ",
    meaning:
      'hết đêm, kết thúc một đêm: thức đến tàn canh * "Cớ chi ngồi nhẫn tàn canh, Nỗi riêng còn mắc mối tình chi đây?" (TKiều)',
    example:
      'thức đến tàn canh * "Cớ chi ngồi nhẫn tàn canh, Nỗi riêng còn mắc mối tình chi đây?" (TKiều)',
  },
  {
    word: "tàn ác",
    part_of_speech: "tính từ",
    meaning:
      "độc ác và tàn nhẫn (đối với cả một số đông): hành vi tàn ác * thủ đoạn bóc lột tàn ác",
    example: "hành vi tàn ác * thủ đoạn bóc lột tàn ác",
  },
  {
    word: "tan cửa nát nhà",
    part_of_speech: "",
    meaning:
      'tả cảnh gia đình bị tan nát, chia lìa: "Chơi hoa tan cửa nát nhà, Lìa con, bỏ vợ, chơi hoa làm gì!" (ca dao)',
    example:
      'Chơi hoa tan cửa nát nhà, Lìa con, bỏ vợ, chơi hoa làm gì!" (ca dao)',
  },
  {
    word: "tản bộ",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) đi bộ một cách nhàn tản để dạo chơi: đi tản bộ vòng quanh hồ",
    example: "đi tản bộ vòng quanh hồ",
  },
  {
    word: "tản cư",
    part_of_speech: "động từ",
    meaning:
      "tạm rời nơi đang ở để đến ở nơi xa chiến sự hơn nhằm tránh tai nạn chiến tranh: đi tản cư để tránh địch * đồng bào tản cư",
    example: "đi tản cư để tránh địch * đồng bào tản cư",
  },
  {
    word: "tán dóc",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) nói khoác lác và bịa đặt những chuyện linh tinh, cốt để cho vui: ngồi tán dóc với nhau",
    example: "ngồi tán dóc với nhau",
  },
  {
    word: "tán đồng",
    part_of_speech: "động từ",
    meaning:
      "tán thành và ủng hộ: gật đầu tỏ ý tán đồng * kế hoạch mới được đa số tán đồng",
    example: "gật đầu tỏ ý tán đồng * kế hoạch mới được đa số tán đồng",
  },
  {
    word: "tán gẫu",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nói toàn những chuyện không đâu, cốt chỉ để cho vui hoặc cho qua thời gian rảnh rỗi: ngồi tán gẫu với nhau * chuyện trò tán gẫu",
    example: "ngồi tán gẫu với nhau * chuyện trò tán gẫu",
  },
  {
    word: "tan hoang",
    part_of_speech: "tính từ",
    meaning:
      "tan nát, sụp đổ hoàn toàn, không còn gì: tan hoang cửa nhà * làng xóm tan hoang sau trận bão",
    example: "tan hoang cửa nhà * làng xóm tan hoang sau trận bão",
  },
  {
    word: "tán dương",
    part_of_speech: "động từ",
    meaning:
      "khen quá lên để đề cao: tán dương công đức của cấp trên * lời tán dương",
    example: "tán dương công đức của cấp trên * lời tán dương",
  },
  {
    word: "tàn dư",
    part_of_speech: "danh từ",
    meaning:
      "cái cũ đã lỗi thời còn sót lại (nói khái quát): tàn dư của chế độ phong kiến",
    example: "tàn dư của chế độ phong kiến",
  },
  {
    word: "tan hợp",
    part_of_speech: "động từ",
    meaning:
      '(cũ, văn chương) như hợp tan: "Lời tan hợp, nỗi hàn huyên, Chữ tình càng mặn, chữ duyên càng nồng." (TKiều)',
    example:
      'Lời tan hợp, nỗi hàn huyên, Chữ tình càng mặn, chữ duyên càng nồng." (TKiều)',
  },
  {
    word: "tán hươu tán vượn",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tán chuyện linh tinh, toàn những chuyện viển vông, không đâu vào đâu (hàm ý chê): chỉ giỏi tán hươu tán vượn",
    example: "chỉ giỏi tán hươu tán vượn",
  },
  {
    word: "tàn hương",
    part_of_speech: "danh từ",
    meaning:
      "nốt nhỏ màu nâu (trông như vết tàn của hương) vô hại, thường nổi trên da mặt người: mặt đầy tàn hương",
    example: "mặt đầy tàn hương",
  },
  {
    word: "tàn khốc",
    part_of_speech: "tính từ",
    meaning:
      "tàn bạo và khốc liệt (nói khái quát): cuộc chiến tranh tàn khốc * chế độ nhà tù tàn khốc",
    example: "cuộc chiến tranh tàn khốc * chế độ nhà tù tàn khốc",
  },
  {
    word: "tán loạn",
    part_of_speech: "động từ",
    meaning:
      "(số đông) phân tán rất nhanh ra mọi phía một cách hỗn loạn (thường do hoảng hốt): bỏ chạy tán loạn",
    example: "bỏ chạy tán loạn",
  },
  {
    word: "tản mác",
    part_of_speech: "",
    meaning:
      "rải rác mỗi nơi một ít, không tập trung: làn khói bay tản mát * anh em tản mát mỗi người một phương",
    example: "làn khói bay tản mát * anh em tản mát mỗi người một phương",
  },
  {
    word: "tản mạn",
    part_of_speech: "tính từ",
    meaning:
      "dàn trải và không có sự liên hệ với nhau, không tập trung vào một vấn đề: suy nghĩ tản mạn * cách trình bày còn tản mạn, thiếu tập trung",
    example: "suy nghĩ tản mạn * cách trình bày còn tản mạn, thiếu tập trung",
  },
  {
    word: "tản mạn",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như tản mát: tài liệu tản mạn nhiều nơi",
    example: "tài liệu tản mạn nhiều nơi",
  },
  {
    word: "tàn lụi",
    part_of_speech: "động từ",
    meaning:
      "ở trạng thái tàn dần, lụi dần (nói khái quát): cỏ cây tàn lụi vì hạn hán * ngọn đèn hết dầu, cứ tàn lụi dần",
    example: "cỏ cây tàn lụi vì hạn hán * ngọn đèn hết dầu, cứ tàn lụi dần",
  },
  {
    word: "tan nát",
    part_of_speech: "tính từ",
    meaning:
      'ở trạng thái bị phá huỷ hoàn toàn, đến mức như chỉ còn là những mảnh vỡ vụn: gia đình tan nát * "Bốn giây như khóc như than, Khiến người trên tiệc cũng tan nát lòng!" (TKiều)',
    example:
      'gia đình tan nát * "Bốn giây như khóc như than, Khiến người trên tiệc cũng tan nát lòng!" (TKiều)',
  },
  {
    word: "tản mát",
    part_of_speech: "",
    meaning:
      "rải rác mỗi nơi một ít, không tập trung: làn khói bay tản mát * anh em tản mát mỗi người một phương",
    example: "làn khói bay tản mát * anh em tản mát mỗi người một phương",
  },
  {
    word: "tàn phá",
    part_of_speech: "động từ",
    meaning:
      "phá hoại nặng nề trên một phạm vi rộng: bão lụt tàn phá làng mạc * con đường bị bom đạn tàn phá",
    example: "bão lụt tàn phá làng mạc * con đường bị bom đạn tàn phá",
  },
  {
    word: "tàn quân",
    part_of_speech: "danh từ",
    meaning:
      "quân lính sống sót sau khi thua trận: thu nhặt tàn quân * đám tàn quân",
    example: "thu nhặt tàn quân * đám tàn quân",
  },
  {
    word: "tàn nhẫn",
    part_of_speech: "tính từ",
    meaning:
      "độc ác đến mức thậm tệ, không chút xót thương: đối xử tàn nhẫn * đánh đập tàn nhẫn",
    example: "đối xử tàn nhẫn * đánh đập tàn nhẫn",
  },
  {
    word: "tán sắc",
    part_of_speech: "động từ",
    meaning:
      "(hiện tượng chùm ánh sáng đa sắc) tách thành nhiều chùm đơn sắc: hiện tượng tán sắc của ánh sáng mặt trời khi đi qua một lăng kính",
    example:
      "hiện tượng tán sắc của ánh sáng mặt trời khi đi qua một lăng kính",
  },
  {
    word: "tàn phế",
    part_of_speech: "tính từ",
    meaning:
      "bị thương tật nặng đến mức mất hết khả năng lao động bình thường: bị tàn phế vì một tai nạn giao thông",
    example: "bị tàn phế vì một tai nạn giao thông",
  },
  {
    word: "tàn sát",
    part_of_speech: "động từ",
    meaning: "giết hại hàng loạt một cách dã man: giặc tàn sát dân thường",
    example: "giặc tàn sát dân thường",
  },
  {
    word: "tan rã",
    part_of_speech: "động từ",
    meaning:
      "rời ra thành từng mảng, không còn gắn kết với nhau thành một khối có tổ chức nữa: hàng ngũ tan rã * tổng công ti tan rã",
    example: "hàng ngũ tan rã * tổng công ti tan rã",
  },
  {
    word: "tàn tạ",
    part_of_speech: "",
    meaning:
      'ở giai đoạn cuối của quá trình suy tàn: nhan sắc tàn tạ * "Chẳng phải vì anh, chẳng tại em, Hoa thu tàn tạ rụng bên thềm." (ThCan; 1)',
    example:
      'nhan sắc tàn tạ * "Chẳng phải vì anh, chẳng tại em, Hoa thu tàn tạ rụng bên thềm." (ThCan; 1)',
  },
  {
    word: "tan tành",
    part_of_speech: "tính từ",
    meaning:
      "tan nát hoàn toàn, không còn mảnh nào nguyên vẹn: miếng kính vỡ tan tành * nhà cửa tan tành sau trận bão",
    example: "miếng kính vỡ tan tành * nhà cửa tan tành sau trận bão",
  },
  {
    word: "tàn tệ",
    part_of_speech: "tính từ",
    meaning:
      "(đối xử) hết sức tệ bạc, không có chút lòng thương: mắng chửi tàn tệ * bị bóc lột tàn tệ",
    example: "mắng chửi tàn tệ * bị bóc lột tàn tệ",
  },
  {
    word: "tan tác",
    part_of_speech: "tính từ",
    meaning:
      "rời rã, tả tơi mỗi nơi một mảnh, mỗi nơi một ít: hoa rụng tan tác * thua trận, quân lính chạy tan tác",
    example: "hoa rụng tan tác * thua trận, quân lính chạy tan tác",
  },
  {
    word: "tàn tật",
    part_of_speech: "tính từ",
    meaning:
      "bị tật nặng khiến cho mất khả năng lao động, hoạt động bình thường: giúp đỡ người tàn tật",
    example: "giúp đỡ người tàn tật",
  },
  {
    word: "tan thành mây khói",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tan biến hoàn toàn, không còn lại chút gì: cả cơ nghiệp đã tan thành mây khói",
    example: "cả cơ nghiệp đã tan thành mây khói",
  },
  {
    word: "tan tầm",
    part_of_speech: "động từ",
    meaning:
      "hết giờ làm việc ở các xí nghiệp, cơ quan: còi tan tầm của nhà máy * giờ tan tầm",
    example: "còi tan tầm của nhà máy * giờ tan tầm",
  },
  {
    word: "tàn tích",
    part_of_speech: "danh từ",
    meaning:
      "dấu vết, vết tích của cái cũ còn sót lại: những tàn tích của chiến tranh * xoá bỏ tàn tích phong kiến",
    example: "những tàn tích của chiến tranh * xoá bỏ tàn tích phong kiến",
  },
  {
    word: "tán thành",
    part_of_speech: "động từ",
    meaning:
      "đồng ý chủ trương hoặc hành vi (của người khác): gật đầu tán thành * mọi người đều tán thành",
    example: "gật đầu tán thành * mọi người đều tán thành",
  },
  {
    word: "tán thưởng",
    part_of_speech: "động từ",
    meaning:
      "tỏ thái độ đồng tình, khen ngợi: vỗ tay tán thưởng * lời tán thưởng",
    example: "vỗ tay tán thưởng * lời tán thưởng",
  },
  {
    word: "tán tỉnh",
    part_of_speech: "động từ",
    meaning:
      "dùng lời lẽ ngon ngọt tìm cách làm cho người khác xiêu lòng nghe theo mình để đạt mục đích riêng (thường nói về chuyện yêu đương): tán tỉnh phụ nữ * buông lời tán tỉnh",
    example: "tán tỉnh phụ nữ * buông lời tán tỉnh",
  },
  {
    word: "tán tụng",
    part_of_speech: "động từ",
    meaning:
      "ca ngợi, ca tụng một cách quá mức: tán tụng cấp trên * hết lời tán tụng",
    example: "tán tụng cấp trên * hết lời tán tụng",
  },
  {
    word: "tán xạ",
    part_of_speech: "động từ",
    meaning:
      "(hiện tượng chùm ánh sáng hoặc chùm hạt) bị hắt ra mọi phía khi gặp một vật khác hoặc khi truyền qua một chất trong suốt: ánh sáng tán xạ",
    example: "ánh sáng tán xạ",
  },
  {
    word: "tan vỡ",
    part_of_speech: "động từ",
    meaning:
      "đổ vỡ, tan nát hoàn toàn, chẳng còn gì (thường nói về cái trừu tượng): làm tan vỡ trái tim * hạnh phúc tan vỡ",
    example: "làm tan vỡ trái tim * hạnh phúc tan vỡ",
  },
  {
    word: "táng",
    part_of_speech: "động từ",
    meaning: "(Khẩu ngữ) đánh, nện mạnh: táng cho mấy gậy vào người",
    example: "táng cho mấy gậy vào người",
  },
  {
    word: "tạng",
    part_of_speech: "danh từ",
    meaning: "tính chất cơ thể của mỗi người: tạng gầy * tạng người yếu đuối",
    example: "tạng gầy * tạng người yếu đuối",
  },
  {
    word: "tang",
    part_of_speech: "danh từ",
    meaning:
      "thân hoặc thành bầu cộng hưởng của trống: tang trống * trống thủng còn tang (tng)",
    example: "tang trống * trống thủng còn tang (tng)",
  },
  {
    word: "tang",
    part_of_speech: "danh từ",
    meaning: "sự đau buồn vì có người thân mới chết: nhà đang có tang",
    example: "nhà đang có tang",
  },
  {
    word: "tang",
    part_of_speech: "danh từ",
    meaning: "lễ chôn cất người chết: đưa tang * dự đám tang",
    example: "đưa tang * dự đám tang",
  },
  {
    word: "tang",
    part_of_speech: "danh từ",
    meaning:
      "dấu hiệu (thường ở áo, mũ, đầu, theo phong tục) để tỏ lòng thương tiếc người mới chết: áo tang * khăn tang",
    example: "áo tang * khăn tang",
  },
  {
    word: "tang",
    part_of_speech: "danh từ",
    meaning:
      "thời gian mà người thân trong gia đình luôn mang một dấu hiệu nào đó để tỏ lòng thương tiếc người chết, theo phong tục: mãn tang",
    example: "mãn tang",
  },
  {
    word: "tang",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ, Ít dùng) loại, hạng người hoặc vật (hàm ý không coi trọng): tang thuốc này hút hơi xóc * cái tang ấy thì làm nên trò trống gì!",
    example:
      "tang thuốc này hút hơi xóc * cái tang ấy thì làm nên trò trống gì!",
  },
  {
    word: "tảng",
    part_of_speech: "danh từ",
    meaning:
      "khối chất rắn tương đối lớn: tảng đá * tảng băng trôi * cả một tảng thịt lớn",
    example: "tảng đá * tảng băng trôi * cả một tảng thịt lớn",
  },
  {
    word: "tảng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) giả tảng (nói tắt): hỏi gì nó cũng cứ tảng như không biết",
    example: "hỏi gì nó cũng cứ tảng như không biết",
  },
  {
    word: "tàng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (đồ dùng) quá cũ nát, trông tồi tàn không ra gì, vì dùng đã lâu ngày: chiếc xe tàng * bộ quần áo đã tàng tàng",
    example: "chiếc xe tàng * bộ quần áo đã tàng tàng",
  },
  {
    word: "tàng ẩn",
    part_of_speech: "động từ",
    meaning: "ẩn chứa sâu trong đó: nét đẹp tàng ẩn trên khuôn mặt",
    example: "nét đẹp tàng ẩn trên khuôn mặt",
  },
  {
    word: "tang bồng",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) tang bồng hồ thỉ (nói tắt): "Làm trai quyết chí tang bồng, Sao cho tỏ mặt anh hùng mới cam." (ca dao)',
    example:
      'Làm trai quyết chí tang bồng, Sao cho tỏ mặt anh hùng mới cam." (ca dao)',
  },
  {
    word: "tang chế",
    part_of_speech: "danh từ",
    meaning:
      "(Ít dùng, Khẩu ngữ) việc lo tang và để tang (nói khái quát): lo việc tang chế * hết tang chế",
    example: "lo việc tang chế * hết tang chế",
  },
  {
    word: "tang chủ",
    part_of_speech: "danh từ",
    meaning: "người chủ gia đình có tang: chia buồn cùng tang chủ",
    example: "chia buồn cùng tang chủ",
  },
  {
    word: "tang hải",
    part_of_speech: "danh từ",
    meaning: "(cũ, văn chương) bể dâu: cuộc đời tang hải",
    example: "cuộc đời tang hải",
  },
  {
    word: "tàng hình",
    part_of_speech: "động từ",
    meaning:
      "làm cho mình như tự biến mất đi bằng phép lạ, không ai có thể nhìn thấy được: phép tàng hình",
    example: "phép tàng hình",
  },
  {
    word: "tang lễ",
    part_of_speech: "danh từ",
    meaning:
      "(trang trọng) các nghi lễ chôn cất người chết (nói tổng quát): nhà tang lễ * tang lễ được cử hành trọng thể",
    example: "nhà tang lễ * tang lễ được cử hành trọng thể",
  },
  {
    word: "tang chứng",
    part_of_speech: "danh từ",
    meaning:
      "vật làm chứng cho hành động phạm pháp (nói khái quát): có đủ tang chứng để luận tội * tang chứng rành rành, không thể chối cãi",
    example:
      "có đủ tang chứng để luận tội * tang chứng rành rành, không thể chối cãi",
  },
  {
    word: "tang gia",
    part_of_speech: "danh từ",
    meaning: "(hiếm) nhà có tang: chia buồn cùng tang gia",
    example: "chia buồn cùng tang gia",
  },
  {
    word: "tang phục",
    part_of_speech: "danh từ",
    meaning: "quần áo tang: mặc tang phục",
    example: "mặc tang phục",
  },
  {
    word: "tảng lờ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) lờ đi, làm như không hay, không biết gì: nghe thấy, nhưng tảng lờ như không biết",
    example: "nghe thấy, nhưng tảng lờ như không biết",
  },
  {
    word: "tảng sáng",
    part_of_speech: "tính từ",
    meaning: "vừa mới bắt đầu sáng: đi từ lúc tảng sáng * trời tảng sáng",
    example: "đi từ lúc tảng sáng * trời tảng sáng",
  },
  {
    word: "tang quyến",
    part_of_speech: "danh từ",
    meaning:
      "(trang trọng) những người thân thích trong gia đình có tang: xin có lời chia buồn cùng tang quyến",
    example: "xin có lời chia buồn cùng tang quyến",
  },
  {
    word: "tang tảng sáng",
    part_of_speech: "tính từ",
    meaning: "(trời) vừa mới mờ mờ sáng: trời đã tang tảng sáng",
    example: "trời đã tang tảng sáng",
  },
  {
    word: "tàng tàng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) như tàng (nhưng ý giảm nhẹ hơn): chiếc xe đạp tàng tàng",
    example: "chiếc xe đạp tàng tàng",
  },
  {
    word: "tang sự",
    part_of_speech: "danh từ",
    meaning: "(cũ, hiếm) việc tang: lo tang sự chu đáo",
    example: "lo tang sự chu đáo",
  },
  {
    word: "tang tích",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) dấu vết còn để lại của hành động phạm pháp: thu thập tang tích của vụ án",
    example: "thu thập tang tích của vụ án",
  },
  {
    word: "tang tóc",
    part_of_speech: "tính từ",
    meaning:
      "đau đớn và buồn thảm vì có người thân chết: cảnh tang tóc * không khí tang tóc",
    example: "cảnh tang tóc * không khí tang tóc",
  },
  {
    word: "tang thương",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) bể dâu: "Chửa đầy một cuộc tang thương, Non đồng đã lở, núi vàng cũng nghiêng." (BC)',
    example:
      'Chửa đầy một cuộc tang thương, Non đồng đã lở, núi vàng cũng nghiêng." (BC)',
  },
  {
    word: "tang thương",
    part_of_speech: "tính từ",
    meaning:
      "tiều tuỵ, khốn khổ đến mức gợi sự đau xót, thương tâm: trông thật tang thương",
    example: "trông thật tang thương",
  },
  {
    word: "tango",
    part_of_speech: "danh từ",
    meaning: "điệu vũ chậm, nhịp 2/4 hoặc 4/4: nhảy điệu tango",
    example: "nhảy điệu tango",
  },
  {
    word: "tàng trữ",
    part_of_speech: "động từ",
    meaning:
      "cất giữ cẩn thận những thứ có giá trị (thường với khối lượng lớn): thư viện tàng trữ nhiều loại sách báo quý",
    example: "thư viện tàng trữ nhiều loại sách báo quý",
  },
  {
    word: "tàng trữ",
    part_of_speech: "động từ",
    meaning:
      "cất giấu những thứ bị cấm: tàng trữ vũ khí trái phép * bị truy tố vì tội tàng trữ ma tuý",
    example: "tàng trữ vũ khí trái phép * bị truy tố vì tội tàng trữ ma tuý",
  },
  {
    word: "tanh",
    part_of_speech: "danh từ",
    meaning:
      "vòng dây thép chịu lực nằm trong mép lốp xe: lốp xe đạp bị đứt tanh",
    example: "lốp xe đạp bị đứt tanh",
  },
  {
    word: "tanh",
    part_of_speech: "tính từ",
    meaning:
      "có mùi hoặc vị khó chịu, dễ gây lợm giọng, như mùi cá sống: tanh như cá mè * tanh mùi bùn",
    example: "tanh như cá mè * tanh mùi bùn",
  },
  {
    word: "tanh",
    part_of_speech: "phụ từ",
    meaning:
      "đến mức độ cao, như không thể hơn được nữa, thường gây cảm giác không vừa lòng: cơm canh để nguội tanh * nhà cửa vắng tanh * lạnh tanh * mỏng tanh",
    example:
      "cơm canh để nguội tanh * nhà cửa vắng tanh * lạnh tanh * mỏng tanh",
  },
  {
    word: "tạnh",
    part_of_speech: "động từ",
    meaning: "(mưa, gió) ngừng hoặc dứt hẳn: mưa đã tạnh * trời quang mây tạnh",
    example: "mưa đã tạnh * trời quang mây tạnh",
  },
  {
    word: "tạnh ráo",
    part_of_speech: "tính từ",
    meaning: "khô ráo vì đã hết mưa: trời tạnh ráo, sáng sủa",
    example: "trời tạnh ráo, sáng sủa",
  },
  {
    word: "tanh bành",
    part_of_speech: "tính từ",
    meaning:
      "ở tình trạng các thứ bị đảo lộn, xáo tung cả ra, trông ngổn ngang, bừa bãi: nhà cửa bị phá tanh bành",
    example: "nhà cửa bị phá tanh bành",
  },
  {
    word: "tanh tách",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng vật cứng và mảnh bật vào nhau liên tiếp nghe giòn và thanh: gảy móng tay tanh tách * tôm nhảy tanh tách",
    example: "gảy móng tay tanh tách * tôm nhảy tanh tách",
  },
  {
    word: "tanh tao",
    part_of_speech: "tính từ",
    meaning:
      '(hiếm) tanh (nói khái quát): mùi cá tanh tao * "Lánh cho khỏi tanh tao là quý, Giữ được điều liêm sỉ là hay." (TTK)',
    example:
      'mùi cá tanh tao * "Lánh cho khỏi tanh tao là quý, Giữ được điều liêm sỉ là hay." (TTK)',
  },
  {
    word: "tanh tưởi",
    part_of_speech: "tính từ",
    meaning:
      "rất tanh và gây cảm giác tởm, lợm (nói khái quát): cá mú tanh tưởi * mùi tanh tưởi, khó chịu",
    example: "cá mú tanh tưởi * mùi tanh tưởi, khó chịu",
  },
  {
    word: "táo",
    part_of_speech: "danh từ",
    meaning: "(Khẩu ngữ) táo quân (nói tắt): ông táo về trời",
    example: "ông táo về trời",
  },
  {
    word: "tành tạch",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng nổ nhỏ, giòn, đanh và liên tiếp: pháo tép nổ tành tạch",
    example: "pháo tép nổ tành tạch",
  },
  {
    word: "tao",
    part_of_speech: "danh từ",
    meaning:
      "sợi dây bằng đay, cói hoặc mây dùng để thắt quang, treo võng, treo nôi: quang đứt tao * nắm lấy tao võng",
    example: "quang đứt tao * nắm lấy tao võng",
  },
  {
    word: "tao",
    part_of_speech: "danh từ",
    meaning:
      "phen, đợt hoặc lần xảy ra việc nào đó, thường là việc không may: gặp tao loạn lạc * mấy tao điêu đứng vì cờ bạc",
    example: "gặp tao loạn lạc * mấy tao điêu đứng vì cờ bạc",
  },
  {
    word: "tao",
    part_of_speech: "đại từ",
    meaning:
      'từ dùng để tự xưng khi nói với người ngang hàng hoặc hàng dưới, tỏ ý thân mật hoặc coi thường, coi khinh: tao đi nhé! * lại đây tao bảo! * "Con kia đã bán cho ta, Nhập gia, cứ phải phép nhà tao đây!" (TKiều)',
    example:
      'tao đi nhé! * lại đây tao bảo! * "Con kia đã bán cho ta, Nhập gia, cứ phải phép nhà tao đây!" (TKiều)',
  },
  {
    word: "tao đàn",
    part_of_speech: "danh từ",
    meaning: "(cũ) nhóm nhà văn, nhà thơ: hội tao đàn",
    example: "hội tao đàn",
  },
  {
    word: "tạo",
    part_of_speech: "động từ",
    meaning:
      "làm ra, từ chỗ không có trở thành có và tồn tại: tạo điều kiện * tạo ra giống lúa mới * tạo môi trường cạnh tranh lành mạnh",
    example:
      "tạo điều kiện * tạo ra giống lúa mới * tạo môi trường cạnh tranh lành mạnh",
  },
  {
    word: "tạo hoá",
    part_of_speech: "danh từ",
    meaning:
      'đấng tạo ra muôn vật với mọi sự biến hoá, đổi thay, theo quan niệm duy tâm: tạo hoá đã an bài * "Xưa nay tạo hoá xoay vần, Hết bần lại phú, chẳng cần gì đâu." (ca dao)',
    example:
      'tạo hoá đã an bài * "Xưa nay tạo hoá xoay vần, Hết bần lại phú, chẳng cần gì đâu." (ca dao)',
  },
  {
    word: "tạo hình",
    part_of_speech: "động từ",
    meaning:
      "tạo ra các hình thể bằng đường nét, màu sắc, hình khối: nghệ thuật tạo hình",
    example: "nghệ thuật tạo hình",
  },
  {
    word: "táo bạo",
    part_of_speech: "tính từ",
    meaning:
      "không e ngại khi làm những việc mà người khác thường không dám làm, bất chấp mọi nguy hiểm: hành động táo bạo * một quyết định táo bạo",
    example: "hành động táo bạo * một quyết định táo bạo",
  },
  {
    word: "tạo dựng",
    part_of_speech: "động từ",
    meaning:
      "tạo nên, dựng nên (nói khái quát): tạo dựng cơ nghiệp * tạo dựng ý thức tự lập cho con cái",
    example: "tạo dựng cơ nghiệp * tạo dựng ý thức tự lập cho con cái",
  },
  {
    word: "tào khang",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) người vợ lấy từ lúc còn nghèo khó: "Tin nhà ngày một vắng tin, Mặn tình cát luỹ, lạt tình tao khang." (TKiều)',
    example:
      'Tin nhà ngày một vắng tin, Mặn tình cát luỹ, lạt tình tao khang." (TKiều)',
  },
  {
    word: "tào khang",
    part_of_speech: "danh từ",
    meaning:
      "tình nghĩa vợ chồng gắn bó từ thuở còn nghèo khó: phụ nghĩa tao khang",
    example: "phụ nghĩa tao khang",
  },
  {
    word: "tạo mẫu",
    part_of_speech: "động từ",
    meaning:
      "thiết kế, tạo ra những kiểu mẫu mới: tạo mẫu tóc * nhà tạo mẫu thời trang",
    example: "tạo mẫu tóc * nhà tạo mẫu thời trang",
  },
  {
    word: "tạo lập",
    part_of_speech: "động từ",
    meaning: "tạo nên, lập nên (nói khái quát): tạo lập cơ nghiệp",
    example: "tạo lập cơ nghiệp",
  },
  {
    word: "tào lao",
    part_of_speech: "tính từ",
    meaning:
      "(lời nói, câu chuyện) không có nội dung gì thiết thực, chỉ nói ra cho vui: hứa tào lao * chuyện trò tào lao",
    example: "hứa tào lao * chuyện trò tào lao",
  },
  {
    word: "tao khang",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) người vợ lấy từ lúc còn nghèo khó: "Tin nhà ngày một vắng tin, Mặn tình cát luỹ, lạt tình tao khang." (TKiều)',
    example:
      'Tin nhà ngày một vắng tin, Mặn tình cát luỹ, lạt tình tao khang." (TKiều)',
  },
  {
    word: "tao khang",
    part_of_speech: "danh từ",
    meaning:
      "tình nghĩa vợ chồng gắn bó từ thuở còn nghèo khó: phụ nghĩa tao khang",
    example: "phụ nghĩa tao khang",
  },
  {
    word: "tao nhã",
    part_of_speech: "tính từ",
    meaning:
      "thanh cao và nhã nhặn, dễ được cảm tình, yêu mến: phong thái tao nhã * thú chơi tao nhã",
    example: "phong thái tao nhã * thú chơi tao nhã",
  },
  {
    word: "tảo mộ",
    part_of_speech: "động từ",
    meaning:
      "thăm viếng và sửa sang mồ mả hằng năm, theo phong tục cổ truyền: đầu xuân đi tảo mộ",
    example: "đầu xuân đi tảo mộ",
  },
  {
    word: "tao ngộ",
    part_of_speech: "động từ",
    meaning: "(cũ, văn chương) gặp gỡ tình cờ: duyên tao ngộ",
    example: "duyên tao ngộ",
  },
  {
    word: "tao loạn",
    part_of_speech: "động từ",
    meaning: "(cũ) như loạn lạc: gặp buổi tao loạn",
    example: "gặp buổi tao loạn",
  },
  {
    word: "tao nhân",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người sành về sáng tác cũng như thưởng thức văn chương: bậc tao nhân",
    example: "bậc tao nhân",
  },
  {
    word: "táo tác",
    part_of_speech: "tính từ",
    meaning: "nhớn nhác và hỗn loạn: gà vịt chạy táo tác",
    example: "gà vịt chạy táo tác",
  },
  {
    word: "tao tác",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như xao xác: tiếng gà tao tác gáy trưa",
    example: "tiếng gà tao tác gáy trưa",
  },
  {
    word: "tao phùng",
    part_of_speech: "động từ",
    meaning: "(cũ, văn chương) như tao ngộ: duyên tao phùng",
    example: "duyên tao phùng",
  },
  {
    word: "tảo tần",
    part_of_speech: "động từ",
    meaning: "như tần tảo: tảo tần hôm sớm",
    example: "tảo tần hôm sớm",
  },
  {
    word: "táo tợn",
    part_of_speech: "tính từ",
    meaning:
      'táo bạo đến mức không biết sợ, không kiêng nể gì, lộ rõ vẻ thách thức: ăn nói táo tợn * "(...) y vừa thật thà, nhũn nhặn lại vừa táo tợn và liều lĩnh." (NgKiên; 3)',
    example:
      'ăn nói táo tợn * "(...) y vừa thật thà, nhũn nhặn lại vừa táo tợn và liều lĩnh." (NgKiên; 3)',
  },
  {
    word: "tạp âm",
    part_of_speech: "danh từ",
    meaning:
      "âm thanh khác lạ có chất lượng kém xen lẫn vào, gây khó khăn cho việc nghe nhận âm thanh chính: lọc bớt tạp âm",
    example: "lọc bớt tạp âm",
  },
  {
    word: "tạo vật",
    part_of_speech: "danh từ",
    meaning: "(hiếm) (cũ) như tạo hoá: oán trách tạo vật * tạo vật đã an bài",
    example: "oán trách tạo vật * tạo vật đã an bài",
  },
  {
    word: "tạo vật",
    part_of_speech: "danh từ",
    meaning:
      "mọi vật tồn tại trong thiên nhiên, coi là do tạo hoá tạo ra: tạo vật quanh ta * ngắm nhìn cây cỏ, tạo vật",
    example: "tạo vật quanh ta * ngắm nhìn cây cỏ, tạo vật",
  },
  {
    word: "tạo vật",
    part_of_speech: "động từ",
    meaning: "đớp, ngoạm nhanh và mạnh bằng cách há rộng miệng: bị chó táp",
    example: "bị chó táp",
  },
  {
    word: "tạo vật",
    part_of_speech: "động từ",
    meaning:
      "hắt mạnh vào, tạt mạnh vào: mưa táp vào mặt * gió táp mưa sa (tng)",
    example: "mưa táp vào mặt * gió táp mưa sa (tng)",
  },
  {
    word: "tạo vật",
    part_of_speech: "động từ",
    meaning:
      "ốp thêm, đắp thêm vào bên ngoài cho vững chắc hơn: táp vữa lên tường * lưng áo táp một miếng vá",
    example: "táp vữa lên tường * lưng áo táp một miếng vá",
  },
  {
    word: "tạo vật",
    part_of_speech: "động từ",
    meaning:
      "(lá cây) héo úa do điều kiện sinh trưởng bất lợi: trời rét, mạ bị táp hết",
    example: "trời rét, mạ bị táp hết",
  },
  {
    word: "tạp chất",
    part_of_speech: "danh từ",
    meaning:
      "chất thường không có ích hoặc có hại lẫn vào trong chất chính: loại bỏ tạp chất trong quặng",
    example: "loại bỏ tạp chất trong quặng",
  },
  {
    word: "tạp",
    part_of_speech: "tính từ",
    meaning:
      "nhiều thứ, nhiều loại lẫn lộn vào nhau và thường chất lượng không tốt: mớ cá tạp * ăn tạp",
    example: "mớ cá tạp * ăn tạp",
  },
  {
    word: "tạp",
    part_of_speech: "tính từ",
    meaning: "(hiếm) không tốt, không chất lượng: gỗ tạp",
    example: "gỗ tạp",
  },
  {
    word: "tạp ăn",
    part_of_speech: "động từ",
    meaning:
      "ăn nhiều và ngon lành bất cứ loại thức ăn gì, không kén chọn: đàn lợn tạp ăn nên chóng lớn",
    example: "đàn lợn tạp ăn nên chóng lớn",
  },
  {
    word: "tạp chủng",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) giống đã được lai tạo; phân biệt với thuần chủng: giống lúa tạp chủng",
    example: "giống lúa tạp chủng",
  },
  {
    word: "tạp dề",
    part_of_speech: "danh từ",
    meaning:
      "tấm vải có dây buộc dùng đeo phía trước người để giữ cho quần áo khỏi bẩn khi làm một số công việc: đeo tạp dề khi làm bếp",
    example: "đeo tạp dề khi làm bếp",
  },
  {
    word: "tạp dịch",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) việc lao động mà người dân phải làm không công dưới thời thực dân, phong kiến (nói khái quát): phu phen tạp dịch * "Quan sở tại đòi riêng làng nhà phải có ít ra là năm chục phu đi tạp dịch." (VTrPhụng; 15)',
    example:
      'phu phen tạp dịch * "Quan sở tại đòi riêng làng nhà phải có ít ra là năm chục phu đi tạp dịch." (VTrPhụng; 15)',
  },
  {
    word: "tạp dịch",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như tạp vụ: nhân viên tạp dịch",
    example: "nhân viên tạp dịch",
  },
  {
    word: "tạp giao",
    part_of_speech: "động từ",
    meaning:
      "giao phối hoặc thụ tinh giữa những nòi khác nhau về mặt di truyền học: giống lúa tạp giao",
    example: "giống lúa tạp giao",
  },
  {
    word: "tạp kĩ",
    part_of_speech: "danh từ",
    meaning:
      "loại hình sân khấu gồm nhiều thể loại nghệ thuật như hát, múa, ảo thuật, xiếc, v.v. biểu diễn đan xen nhau (nói tổng quát): sân khấu tạp kĩ * buổi biểu diễn ca nhạc tạp kĩ",
    example: "sân khấu tạp kĩ * buổi biểu diễn ca nhạc tạp kĩ",
  },
  {
    word: "tạp hoá",
    part_of_speech: "danh từ",
    meaning:
      "hàng hoá lặt vặt, thường dùng hằng ngày: cửa hàng tạp hoá * bán tạp hoá",
    example: "cửa hàng tạp hoá * bán tạp hoá",
  },
  {
    word: "tạp kỹ",
    part_of_speech: "danh từ",
    meaning:
      "loại hình sân khấu gồm nhiều thể loại nghệ thuật như hát, múa, ảo thuật, xiếc, v.v. biểu diễn đan xen nhau (nói tổng quát): sân khấu tạp kĩ * buổi biểu diễn ca nhạc tạp kĩ",
    example: "sân khấu tạp kĩ * buổi biểu diễn ca nhạc tạp kĩ",
  },
  {
    word: "tạp nhạp",
    part_of_speech: "tính từ",
    meaning:
      "nhiều thứ lặt vặt lẫn lộn, ít có giá trị: bán đủ thứ tạp nhạp * toàn những việc tạp nhạp",
    example: "bán đủ thứ tạp nhạp * toàn những việc tạp nhạp",
  },
  {
    word: "tạp văn",
    part_of_speech: "danh từ",
    meaning:
      "một loại tản văn có nội dung rộng, hình thức không gò bó, như bài bình luận ngắn, tiểu phẩm, tuỳ bút, v. v.: viết tạp văn",
    example: "viết tạp văn",
  },
  {
    word: "táp nham",
    part_of_speech: "tính từ",
    meaning:
      "linh tinh nhiều loại, nhiều thứ lặt vặt, kém chất lượng: đồ đạc táp nham * mảnh vườn trồng táp nham đủ loại cây",
    example: "đồ đạc táp nham * mảnh vườn trồng táp nham đủ loại cây",
  },
  {
    word: "tạp phẩm",
    part_of_speech: "danh từ",
    meaning:
      "hàng hoá lặt vặt, gồm những đồ dùng cho sinh hoạt cá nhân hằng ngày: quầy tạp phẩm",
    example: "quầy tạp phẩm",
  },
  {
    word: "tạp phí lù",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) hổ lốn, chẳng có thứ gì đáng có giá trị: nấu một nồi tạp phí lù * văn chương tạp phí lù",
    example: "nấu một nồi tạp phí lù * văn chương tạp phí lù",
  },
  {
    word: "tát",
    part_of_speech: "động từ",
    meaning:
      "đánh mạnh vào mặt bằng bàn tay đang mở: tát cho mấy cái vào mặt * tát thẳng tay",
    example: "tát cho mấy cái vào mặt * tát thẳng tay",
  },
  {
    word: "tát",
    part_of_speech: "danh từ",
    meaning: "cái đánh vào mặt bằng bàn tay đang mở: cho nó mấy cái tát",
    example: "cho nó mấy cái tát",
  },
  {
    word: "tát",
    part_of_speech: "động từ",
    meaning:
      'dùng gàu hoặc xô, chậu, v.v. để chuyển nước từ nơi này sang nơi khác, thường bằng động tác hất mạnh: tát ao bắt cá * "Hỡi cô tát nước bên đàng, Sao cô múc ánh trăng vàng đổ đi." (ca dao)',
    example:
      'tát ao bắt cá * "Hỡi cô tát nước bên đàng, Sao cô múc ánh trăng vàng đổ đi." (ca dao)',
  },
  {
    word: "tạt",
    part_of_speech: "động từ",
    meaning:
      "chuyển động mạnh hoặc làm cho chuyển động lệch hẳn sang một hướng khác: mưa tạt qua song cửa * cầu thủ tạt bóng cho đồng đội",
    example: "mưa tạt qua song cửa * cầu thủ tạt bóng cho đồng đội",
  },
  {
    word: "tạt",
    part_of_speech: "động từ",
    meaning:
      "ghé vào, rẽ vào một thời gian ngắn, khi đang trên đường đi: trên đường về, tạt vào thăm bạn * tạt xe vào lề đường",
    example: "trên đường về, tạt vào thăm bạn * tạt xe vào lề đường",
  },
  {
    word: "tạp vụ",
    part_of_speech: "danh từ",
    meaning:
      "công việc lao động lặt vặt ở các cơ quan, công sở, như quét tước, dọn dẹp: nhân viên tạp vụ * công việc tạp vụ",
    example: "nhân viên tạp vụ * công việc tạp vụ",
  },
  {
    word: "tát tai",
    part_of_speech: "",
    meaning: "(khẩu ngữ) như bạt tai: cho mấy cái tát tai",
    example: "cho mấy cái tát tai",
  },
  {
    word: "tàu bay",
    part_of_speech: "danh từ",
    meaning:
      "cây thân cỏ mọc hoang, lá có mùi thơm, quả có lông trắng dễ bay đi theo gió, có thể dùng làm rau ăn: rau tàu bay",
    example: "rau tàu bay",
  },
  {
    word: "tàu",
    part_of_speech: "danh từ",
    meaning:
      "lá to, có cuống dài của một số loài cây: tàu chuối * tàu dừa * xanh như tàu lá",
    example: "tàu chuối * tàu dừa * xanh như tàu lá",
  },
  {
    word: "tàu",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi chung các phương tiện vận tải lớn và hoạt động bằng máy móc phức tạp: tàu thuỷ * tàu bay * bến tàu * tàu đã cập cảng",
    example: "tàu thuỷ * tàu bay * bến tàu * tàu đã cập cảng",
  },
  {
    word: "tàu",
    part_of_speech: "danh từ",
    meaning: "tàu hoả (nói tắt): con tàu từ từ chuyển bánh * tàu đã vào ga",
    example: "con tàu từ từ chuyển bánh * tàu đã vào ga",
  },
  {
    word: "tàu",
    part_of_speech: "danh từ",
    meaning:
      "máng đựng thức ăn trong chuồng ngựa; cũng dùng để chỉ chuồng ngựa: một con ngựa đau, cả tàu không ăn cỏ (tng)",
    example: "một con ngựa đau, cả tàu không ăn cỏ (tng)",
  },
  {
    word: "tàu",
    part_of_speech: "tính từ",
    meaning:
      "tên gọi chung những thứ vốn có nguồn gốc từ Trung Quốc hoặc theo kiểu Trung Quốc: chè tàu * mực tàu, giấy bản",
    example: "chè tàu * mực tàu, giấy bản",
  },
  {
    word: "tàu bè",
    part_of_speech: "danh từ",
    meaning:
      "phương tiện vận tải đường thuỷ như tàu, thuyền, v.v. (nói khái quát): tàu bè tấp nập trên sông",
    example: "tàu bè tấp nập trên sông",
  },
  {
    word: "tàu hũ",
    part_of_speech: "danh từ",
    meaning: "đậu phụ: món tàu hũ nhồi thịt",
    example: "món tàu hũ nhồi thịt",
  },
  {
    word: "tàu hũ",
    part_of_speech: "danh từ",
    meaning: "tào phở: tàu hũ nước gừng",
    example: "tàu hũ nước gừng",
  },
  {
    word: "tàu suốt",
    part_of_speech: "danh từ",
    meaning:
      "tàu hoả chạy đường dài, không đỗ lại ở các ga xép dọc đường: đi tàu suốt cho nhanh",
    example: "đi tàu suốt cho nhanh",
  },
  {
    word: "tàu vét",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) chuyến tàu hoả cuối cùng trong ngày, thường dừng lại ở tất cả các ga để đón khách: đi chuyến tàu vét",
    example: "đi chuyến tàu vét",
  },
  {
    word: "tay",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận của cơ thể người, từ vai đến các ngón, dùng để cầm, nắm: giơ tay vẫy * dừng tay * tay làm hàm nhai (tng)",
    example: "giơ tay vẫy * dừng tay * tay làm hàm nhai (tng)",
  },
  {
    word: "tay",
    part_of_speech: "danh từ",
    meaning:
      "chi trước hay xúc tu của một số động vật, thường có khả năng cầm, nắm đơn giản: tay vượn * tay gấu * bạch tuộc thò tay bắt mồi",
    example: "tay vượn * tay gấu * bạch tuộc thò tay bắt mồi",
  },
  {
    word: "tay",
    part_of_speech: "danh từ",
    meaning:
      "biểu tượng cho sự lao động cụ thể của con người: tay cày, tay cuốc * mỗi người giúp một tay",
    example: "tay cày, tay cuốc * mỗi người giúp một tay",
  },
  {
    word: "tay",
    part_of_speech: "danh từ",
    meaning:
      "biểu tượng của khả năng, trình độ nghề nghiệp, hay khả năng hành động nào đó của con người: chắc tay lái * nét vẽ già tay",
    example: "chắc tay lái * nét vẽ già tay",
  },
  {
    word: "tay",
    part_of_speech: "danh từ",
    meaning:
      "biểu tượng cho quyền sử dụng hay định đoạt của con người: chính quyền về tay nhân dân * sa vào tay giặc * có đủ quyền hành trong tay",
    example:
      "chính quyền về tay nhân dân * sa vào tay giặc * có đủ quyền hành trong tay",
  },
  {
    word: "tay",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) người có khả năng về mặt hoạt động nào đó (thường hàm ý chê hoặc không coi trọng): một tay anh chị nổi tiếng * tay nhà báo",
    example: "một tay anh chị nổi tiếng * tay nhà báo",
  },
  {
    word: "tay",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) người giỏi về một môn, một nghề nào đó: tay trống cự phách * tay thợ lành nghề",
    example: "tay trống cự phách * tay thợ lành nghề",
  },
  {
    word: "tay",
    part_of_speech: "danh từ",
    meaning:
      "bên tham gia vào một việc nào đó có liên quan giữa các bên với nhau: cuộc đàm phán tay ba * hội nghị tay tư",
    example: "cuộc đàm phán tay ba * hội nghị tay tư",
  },
  {
    word: "tay",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận của vật tương ứng với tay hoặc có chức năng, hình dáng như cái tay: tay ghế * tay đòn bị gãy",
    example: "tay ghế * tay đòn bị gãy",
  },
  {
    word: "tay ba",
    part_of_speech: "danh từ",
    meaning: "ba bên với nhau: mối tình tay ba * hiệp ước tay ba",
    example: "mối tình tay ba * hiệp ước tay ba",
  },
  {
    word: "tày",
    part_of_speech: "tính từ",
    meaning: "(hiếm) bằng đầu, không nhọn: gậy đầu tầy, đầu nhọn",
    example: "gậy đầu tầy, đầu nhọn",
  },
  {
    word: "tay áo",
    part_of_speech: "danh từ",
    meaning: "phần của áo che cánh tay: nuôi ong tay áo (tng)",
    example: "nuôi ong tay áo (tng)",
  },
  {
    word: "tay ấn",
    part_of_speech: "danh từ",
    meaning: "như ấn quyết: phù thuỷ cao tay ấn",
    example: "phù thuỷ cao tay ấn",
  },
  {
    word: "tay bắt mặt mừng",
    part_of_speech: "",
    meaning:
      "tả cảnh gặp gỡ vui vẻ, mừng rỡ (thường do lâu ngày mới được gặp nhau): gặp nhau tay bắt mặt mừng",
    example: "gặp nhau tay bắt mặt mừng",
  },
  {
    word: "tay bo",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ, khẩu ngữ) (làm việc gì) chỉ bằng tay không (không có phương tiện gì): đánh nhau tay bo",
    example: "đánh nhau tay bo",
  },
  {
    word: "tay chơi",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) người chơi bời sành sỏi (hàm ý chê): một tay chơi thứ thiệt",
    example: "một tay chơi thứ thiệt",
  },
  {
    word: "tay đã nhúng chàm",
    part_of_speech: "",
    meaning:
      'đã nhúng tay làm điều sai trái, dại dột (thì có ăn năn, hối hận cũng đã muộn, khó có thể gột rửa vết nhơ được): "Trót vì tay đã nhúng chàm, Dại rồi còn biết khôn làm sao đây?" (TKiều)',
    example:
      'Trót vì tay đã nhúng chàm, Dại rồi còn biết khôn làm sao đây?" (TKiều)',
  },
  {
    word: "tày đình",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (chuyện, việc) lớn lắm, có thể có hậu quả rất nghiêm trọng: chuyện tày đình * tội to tày đình",
    example: "chuyện tày đình * tội to tày đình",
  },
  {
    word: "tay đua",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) vận động viên đua xe: một tay đua ngoại hạng",
    example: "một tay đua ngoại hạng",
  },
  {
    word: "tay hòm chìa khoá",
    part_of_speech: "",
    meaning:
      "quyền quản lí mọi việc chi tiêu trong gia đình: trao tay hòm chìa khoá cho con dâu",
    example: "trao tay hòm chìa khoá cho con dâu",
  },
  {
    word: "tay lái",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận dùng để cầm điều khiển hướng đi của tàu, xe: vững tay lái * cầm chắc tay lái",
    example: "vững tay lái * cầm chắc tay lái",
  },
  {
    word: "tay lái",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) người lái xe: một tay lái có hạng",
    example: "một tay lái có hạng",
  },
  {
    word: "tay chân",
    part_of_speech: "danh từ",
    meaning:
      "kẻ giúp việc đắc lực, tin cẩn (hàm ý không coi trọng): tay chân thân tín * bọn tay chân",
    example: "tay chân thân tín * bọn tay chân",
  },
  {
    word: "tay không",
    part_of_speech: "",
    meaning:
      'chỉ với hai bàn tay, không có gì thêm cả: "Nước lã mà vã nên hồ, Tay không mà nổi cơ đồ mới ngoan." (ca dao)',
    example:
      'Nước lã mà vã nên hồ, Tay không mà nổi cơ đồ mới ngoan." (ca dao)',
  },
  {
    word: "tay đôi",
    part_of_speech: "danh từ",
    meaning: "hai bên với nhau: cãi nhau tay đôi * kí hiệp ước tay đôi",
    example: "cãi nhau tay đôi * kí hiệp ước tay đôi",
  },
  {
    word: "táy máy",
    part_of_speech: "động từ",
    meaning:
      "sờ mó để thử, để xem (vì tò mò hay nghịch ngợm): chân tay táy máy * táy máy làm hỏng chiếc đồng hồ",
    example: "chân tay táy máy * táy máy làm hỏng chiếc đồng hồ",
  },
  {
    word: "táy máy",
    part_of_speech: "động từ",
    meaning: "như tắt mắt: có tính táy máy",
    example: "có tính táy máy",
  },
  {
    word: "tay nải",
    part_of_speech: "danh từ",
    meaning:
      "túi vải may theo lối xưa, có dạng như một cái bọc, có quai đeo, dùng đựng đồ mang đi đường: buộc tay nải * quàng tay nải lên vai",
    example: "buộc tay nải * quàng tay nải lên vai",
  },
  {
    word: "tay nghề",
    part_of_speech: "danh từ",
    meaning:
      "trình độ, khả năng về nghề nghiệp: tay nghề còn non * nâng cao tay nghề",
    example: "tay nghề còn non * nâng cao tay nghề",
  },
  {
    word: "tay mặt",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) tay phải: nhà ở phía tay mặt",
    example: "nhà ở phía tay mặt",
  },
  {
    word: "tay phải",
    part_of_speech: "danh từ",
    meaning:
      "tay thường dùng để cầm bút, cầm dụng cụ lao động; đối lập với tay trái: thuận tay phải",
    example: "thuận tay phải",
  },
  {
    word: "tay phải",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) phía bên phải; đối lập với tay trái: đứng bên tay phải * rẽ về phía tay phải",
    example: "đứng bên tay phải * rẽ về phía tay phải",
  },
  {
    word: "tày liếp",
    part_of_speech: "tính từ",
    meaning:
      '(hiếm) (gương về thất bại, sai lầm) rất lớn, ở ngay trước mắt: "Những người thâm độc hiểm sâu, Gương treo tày liếp trên đầu chẳng soi." (ca dao)',
    example:
      'Những người thâm độc hiểm sâu, Gương treo tày liếp trên đầu chẳng soi." (ca dao)',
  },
  {
    word: "tay quay",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ quay bằng tay để vận hành các công cụ hoặc máy móc như mũi khoan, chìa vít, máy nổ, v.v.: tay quay máy nổ",
    example: "tay quay máy nổ",
  },
  {
    word: "tay sai",
    part_of_speech: "danh từ",
    meaning:
      "kẻ chịu để cho kẻ khác sai khiến làm những việc phi nghĩa: làm tay sai cho giặc * bọn tay sai",
    example: "làm tay sai cho giặc * bọn tay sai",
  },
  {
    word: "tay trái",
    part_of_speech: "danh từ",
    meaning:
      "tay ở cùng một bên với quả tim; đối lập với tay phải: thuận tay trái",
    example: "thuận tay trái",
  },
  {
    word: "tay trái",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) phía bên trái; đối lập với tay phải: rẽ tay trái",
    example: "rẽ tay trái",
  },
  {
    word: "tay trái",
    part_of_speech: "tính từ",
    meaning: "phụ, không phải chính: sống chủ yếu bằng nghề tay trái",
    example: "sống chủ yếu bằng nghề tay trái",
  },
  {
    word: "tay ngang",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) người làm một nghề nào đó vốn không thành thạo, không chuyên: thợ nề tay ngang",
    example: "thợ nề tay ngang",
  },
  {
    word: "tay ngang",
    part_of_speech: "tính từ",
    meaning:
      "không thành thạo, không chuyên (về một nghề nào đó): thợ tay ngang nên làm hơi chậm",
    example: "thợ tay ngang nên làm hơi chậm",
  },
  {
    word: "tay trong",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) người trong một tổ chức nào đó giúp đỡ ngầm cho người hoặc tổ chức khác (thường là đối đầu): có tay trong lo lót * cài người làm tay trong",
    example: "có tay trong lo lót * cài người làm tay trong",
  },
  {
    word: "tay trên",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) (lấy đi) trước người khác, cái mà đáng lẽ người đó được hưởng: hớt tay trên * nẫng tay trên",
    example: "hớt tay trên * nẫng tay trên",
  },
  {
    word: "tày trời",
    part_of_speech: "tính từ",
    meaning:
      "(chuyện, việc) hết sức lớn và có những hậu quả không sao lường hết được: tội ác tày trời * làm những chuyện tày trời đồng tày đình",
    example: "tội ác tày trời * làm những chuyện tày trời",
  },
  {
    word: "tay trắng",
    part_of_speech: "danh từ",
    meaning:
      'tình trạng không có chút vốn liếng, của cải gì trong tay: tay trắng lập nghiệp * "Số giàu tay trắng cũng giàu, Số nghèo chín đụn mười trâu cũng nghèo." (ca dao)',
    example:
      'tay trắng lập nghiệp * "Số giàu tay trắng cũng giàu, Số nghèo chín đụn mười trâu cũng nghèo." (ca dao)',
  },
  {
    word: "tắc",
    part_of_speech: "động từ",
    meaning:
      "ở tình trạng có cái gì đó mắc lại, làm cho không lưu thông được: cống bị tắc * tắc đường",
    example: "cống bị tắc * tắc đường",
  },
  {
    word: "tắc",
    part_of_speech: "động từ",
    meaning:
      "ở tình trạng không thể tiếp tục được nữa, không có cách giải quyết: công việc điều tra bị tắc lại * hỏi đến câu nào cũng tắc, không trả lời được",
    example:
      "công việc điều tra bị tắc lại * hỏi đến câu nào cũng tắc, không trả lời được",
  },
  {
    word: "tắc kè",
    part_of_speech: "danh từ",
    meaning:
      "bò sát giống thằn lằn, sống trên cây to, thường kêu tắc kè, thường dùng làm thuốc: rượu tắc kè (rượu ngâm tắc kè)",
    example: "rượu tắc kè (rượu ngâm tắc kè)",
  },
  {
    word: "tắc họng",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) im bặt, không nói được điều gì nữa, như thể bị tắc lại trong họng: chứng cớ rành rành, tắc họng không cãi được nữa",
    example: "chứng cớ rành rành, tắc họng không cãi được nữa",
  },
  {
    word: "tặc lưỡi",
    part_of_speech: "động từ",
    meaning:
      "bật lưỡi kêu thành tiếng, biểu lộ ý không bằng lòng nhưng đành bỏ qua cho xong chuyện: tặc lưỡi cho qua",
    example: "tặc lưỡi cho qua",
  },
  {
    word: "tay vợt",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) vận động viên thi đấu các môn thể thao có dùng vợt, như bóng bàn, cầu lông, tennis: tay vợt nhà nghề",
    example: "tay vợt nhà nghề",
  },
  {
    word: "tay vịn",
    part_of_speech: "danh từ",
    meaning:
      'bộ phận để vịn tay vào khi lên xuống: tay vịn cầu thang * "Thương em không quản xa gần, Cầu không tay vịn cũng lần tới nơi." (ca dao)',
    example:
      'tay vịn cầu thang * "Thương em không quản xa gần, Cầu không tay vịn cũng lần tới nơi." (ca dao)',
  },
  {
    word: "tắc lưỡi",
    part_of_speech: "động từ",
    meaning: "bật lưỡi thành những tiếng kêu: tắc lưỡi làm ám hiệu",
    example: "tắc lưỡi làm ám hiệu",
  },
  {
    word: "tắc nghẽn",
    part_of_speech: "động từ",
    meaning:
      "tắc và nghẽn (nói khái quát): giao thông bị tắc nghẽn * tắc nghẽn động mạch",
    example: "giao thông bị tắc nghẽn * tắc nghẽn động mạch",
  },
  {
    word: "tắc tị",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tắc hoàn toàn, không thông, không thoát ra được: máy nước tắc tị, không chảy một giọt nào * đọc được vài câu là tắc tị",
    example:
      "máy nước tắc tị, không chảy một giọt nào * đọc được vài câu là tắc tị",
  },
  {
    word: "tăm",
    part_of_speech: "danh từ",
    meaning:
      "que nhỏ và ngắn, thường bằng tre hay gỗ, dùng để xỉa răng: vót tăm * dùng tăm xỉa răng",
    example: "vót tăm * dùng tăm xỉa răng",
  },
  {
    word: "tăm",
    part_of_speech: "danh từ",
    meaning:
      "que nhỏ và dài, thường bằng tre, gỗ, dùng để đan mành, làm que hương, v.v.: chẻ tăm đan mành * tăm hương",
    example: "chẻ tăm đan mành * tăm hương",
  },
  {
    word: "tăm",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) nan hoa: tăm xe đạp",
    example: "tăm xe đạp",
  },
  {
    word: "tăm",
    part_of_speech: "danh từ",
    meaning:
      "bọt nhỏ từ trong nước nổi lên: nước đun đã sủi tăm * bóng chim tăm cá (tng)",
    example: "nước đun đã sủi tăm * bóng chim tăm cá (tng)",
  },
  {
    word: "tăm",
    part_of_speech: "danh từ",
    meaning:
      "dấu hiệu có thể nhìn thấy hoặc nghe thấy được, để qua đó có thể giúp cho biết được về sự có mặt hay tin tức của một người nào hoặc một cái gì: trốn biệt tăm * đi mất tăm",
    example: "trốn biệt tăm * đi mất tăm",
  },
  {
    word: "tăm",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) tìm, săn tìm: tăm đồ cổ",
    example: "tăm đồ cổ",
  },
  {
    word: "tằm",
    part_of_speech: "danh từ",
    meaning:
      "ấu trùng của một loài bướm, ăn lá dâu hoặc lá sắn, nuôi để lấy tơ: nghề trồng dâu nuôi tằm * ăn như tằm ăn rỗi (ăn khoẻ và nhanh)",
    example: "nghề trồng dâu nuôi tằm * ăn như tằm ăn rỗi (ăn khoẻ và nhanh)",
  },
  {
    word: "tăm dạng",
    part_of_speech: "danh từ",
    meaning:
      'dấu vết, hình dạng nào đó của người hoặc cái đang tìm kiếm, đang mong đợi: "(…) những ngày dài chờ đợi vẫn trôi đi, ông lý vẫn biệt tăm dạng." (BHiển; 14)',
    example:
      '(…) những ngày dài chờ đợi vẫn trôi đi, ông lý vẫn biệt tăm dạng." (BHiển; 14)',
  },
  {
    word: "tắm",
    part_of_speech: "động từ",
    meaning:
      "giội nước lên người hoặc ngâm mình trong nước cho sạch sẽ, mát mẻ: tắm biển * ăn no tắm mát * cảnh vật như tắm mình trong ánh trăng đêm",
    example:
      "tắm biển * ăn no tắm mát * cảnh vật như tắm mình trong ánh trăng đêm",
  },
  {
    word: "tắm",
    part_of_speech: "động từ",
    meaning: "ngâm mình trong một chất nào đó để chữa bệnh: tắm bùn * tắm hơi",
    example: "tắm bùn * tắm hơi",
  },
  {
    word: "tắm",
    part_of_speech: "động từ",
    meaning:
      "phơi mình dưới ánh nắng hoặc làm cho toàn thân chịu tác động của một loại tia sáng (theo phương pháp vật lí) để chữa bệnh: tắm nắng * tắm điện",
    example: "tắm nắng * tắm điện",
  },
  {
    word: "tắm",
    part_of_speech: "động từ",
    meaning:
      "nhúng đồ vàng bạc vào trong một loại nước chua để làm sáng bóng trở lại: tắm vàng",
    example: "tắm vàng",
  },
  {
    word: "tăm hơi",
    part_of_speech: "danh từ",
    meaning:
      "dấu hiệu, tin tức nhờ đó có thể biết về sự có mặt của một người nào hoặc một cái gì đó đang tìm kiếm, mong đợi (nói khái quát): đi bặt tăm hơi * chẳng thấy tăm hơi đâu cả",
    example: "đi bặt tăm hơi * chẳng thấy tăm hơi đâu cả",
  },
  {
    word: "tắm giặt",
    part_of_speech: "động từ",
    meaning: "tắm rửa và giặt giũ (nói khái quát): tắm giặt cho con",
    example: "tắm giặt cho con",
  },
  {
    word: "tằm tang",
    part_of_speech: "danh từ",
    meaning: "việc trồng dâu nuôi tằm (nói khái quát): chăm việc tằm tang",
    example: "chăm việc tằm tang",
  },
  {
    word: "tăm tia",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) lân la, tìm hiểu để tìm cách tán tỉnh: tăm tia cô hàng xóm",
    example: "tăm tia cô hàng xóm",
  },
  {
    word: "tắc trách",
    part_of_speech: "tính từ",
    meaning:
      "(làm việc) qua loa đại khái, chỉ cốt cho xong, không chú ý đến kết quả, do thiếu tinh thần trách nhiệm: lối làm ăn tắc trách * thái độ tắc trách",
    example: "lối làm ăn tắc trách * thái độ tắc trách",
  },
  {
    word: "tắm rửa",
    part_of_speech: "động từ",
    meaning: "tắm và rửa, làm cho sạch (nói khái quát): tắm rửa sạch sẽ",
    example: "tắm rửa sạch sẽ",
  },
  {
    word: "tăm tắp",
    part_of_speech: "phụ từ",
    meaning:
      "như tắp (nhưng ý mức độ cao hơn): hàm răng đều tăm tắp * xếp hàng thẳng tăm tắp",
    example: "hàm răng đều tăm tắp * xếp hàng thẳng tăm tắp",
  },
  {
    word: "tằn tiện",
    part_of_speech: "",
    meaning:
      "hết sức hạn chế việc chi dùng, ngay cả những món nhỏ nhặt: chi tiêu tằn tiện * sống rất tằn tiện",
    example: "chi tiêu tằn tiện * sống rất tằn tiện",
  },
  {
    word: "tăm tối",
    part_of_speech: "tính từ",
    meaning: "như tối tăm (nhưng thường dùng theo nghĩa bóng): đầu óc tăm tối",
    example: "đầu óc tăm tối",
  },
  {
    word: "tăm tích",
    part_of_speech: "danh từ",
    meaning: "tin tức hay dấu vết nào đó để lại: đi biệt tăm tích",
    example: "đi biệt tăm tích",
  },
  {
    word: "tặng",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) cho, trao cho nhằm khen ngợi, khuyến khích hoặc để tỏ lòng quý mến: quà tặng * tặng hoa cho người yêu * tặng bằng khen",
    example: "quà tặng * tặng hoa cho người yêu * tặng bằng khen",
  },
  {
    word: "tăng",
    part_of_speech: "danh từ",
    meaning: "người đàn ông tu hành theo đạo Phật và ở chùa: vị tăng cao niên",
    example: "vị tăng cao niên",
  },
  {
    word: "tăng",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) xe tăng (nói tắt): súng chống tăng",
    example: "súng chống tăng",
  },
  {
    word: "tăng",
    part_of_speech: "danh từ",
    meaning:
      "tấm vải bạt hoặc nylon dùng để căng làm mái che mưa nắng: tấm tăng * căng tăng làm lều",
    example: "tấm tăng * căng tăng làm lều",
  },
  {
    word: "tăng",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) lần, đợt hiện tượng hoặc sự việc diễn ra một cách liên tiếp: nói một tăng hết chuyện nọ đến chuyện kia",
    example: "nói một tăng hết chuyện nọ đến chuyện kia",
  },
  {
    word: "tăng",
    part_of_speech: "động từ",
    meaning:
      "làm cho nhiều hơn lên, hoặc trở nên nhiều hơn về mặt số lượng hoặc mức độ: tăng lương cho cán bộ * điện áp tăng * giá cả hàng hoá tăng cao",
    example: "tăng lương cho cán bộ * điện áp tăng * giá cả hàng hoá tăng cao",
  },
  {
    word: "tăng âm",
    part_of_speech: "động từ",
    meaning: "(máy) làm cho cường độ âm thanh trở nên lớn hơn: máy tăng âm",
    example: "máy tăng âm",
  },
  {
    word: "tăng bo",
    part_of_speech: "động từ",
    meaning:
      "chuyển sang phương tiện khác để đi tiếp hoặc vận chuyển tiếp khi đường giao thông bị gián đoạn: tàu bị trật bánh, phải tăng bo",
    example: "tàu bị trật bánh, phải tăng bo",
  },
  {
    word: "tăng giá",
    part_of_speech: "động từ",
    meaning:
      "nâng giá hàng lên cao hơn so với trước; trái với giảm giá: tăng giá xăng dầu * tất cả các mặt hàng đều đồng loạt tăng giá",
    example: "tăng giá xăng dầu * tất cả các mặt hàng đều đồng loạt tăng giá",
  },
  {
    word: "tăng cường",
    part_of_speech: "động từ",
    meaning:
      "làm cho mạnh thêm, nhiều thêm: tăng cường lực lượng * tập thể dục để tăng cường sức khoẻ",
    example: "tăng cường lực lượng * tập thể dục để tăng cường sức khoẻ",
  },
  {
    word: "tăng gia",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) tăng gia sản xuất (nói tắt): tích cực tăng gia",
    example: "tích cực tăng gia",
  },
  {
    word: "tặng thưởng",
    part_of_speech: "động từ",
    meaning: "tặng để khen thưởng: tặng thưởng huân chương",
    example: "tặng thưởng huân chương",
  },
  {
    word: "tăng lữ",
    part_of_speech: "danh từ",
    meaning:
      "những người tu hành theo một tôn giáo nào đó (nói tổng quát): giới tăng lữ",
    example: "giới tăng lữ",
  },
  {
    word: "tăng tiến",
    part_of_speech: "động từ",
    meaning:
      "tiến hơn, vượt hơn so với trước một cách rõ rệt: sức học ngày một tăng tiến * nền kinh tế bắt đầu tăng tiến",
    example: "sức học ngày một tăng tiến * nền kinh tế bắt đầu tăng tiến",
  },
  {
    word: "tặng phẩm",
    part_of_speech: "danh từ",
    meaning: "vật phẩm dùng để tặng: tặng phẩm mừng sinh nhật * trao tặng phẩm",
    example: "tặng phẩm mừng sinh nhật * trao tặng phẩm",
  },
  {
    word: "tăng sản",
    part_of_speech: "động từ",
    meaning:
      "nâng sản lượng hơn hẳn mức bình thường bằng các biện pháp kĩ thuật: vườn ngô tăng sản * lợn tăng sản",
    example: "vườn ngô tăng sản * lợn tăng sản",
  },
  {
    word: "tăng tả",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) như tong tả: đi tăng tả ngoài đường",
    example: "đi tăng tả ngoài đường",
  },
  {
    word: "tăng trọng",
    part_of_speech: "động từ",
    meaning:
      "(vật nuôi) tăng trọng lượng: lợn tăng trọng nhanh * cám tăng trọng",
    example: "lợn tăng trọng nhanh * cám tăng trọng",
  },
  {
    word: "tăng-gô",
    part_of_speech: "danh từ",
    meaning: "điệu vũ chậm, nhịp 2/4 hoặc 4/4: nhảy điệu tango",
    example: "nhảy điệu tango",
  },
  {
    word: "tắp lự",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) liền ngay tức khắc, một cách rất nhanh: đi tắp lự * làm tắp lự",
    example: "đi tắp lự * làm tắp lự",
  },
  {
    word: "tăng trưởng",
    part_of_speech: "động từ",
    meaning:
      "(vật nuôi, cây trồng) phát triển, tăng lên về trọng lượng, kích thước: đàn lợn tăng trưởng nhanh * quá trình tăng trưởng của cây trồng",
    example: "đàn lợn tăng trưởng nhanh * quá trình tăng trưởng của cây trồng",
  },
  {
    word: "tăng trưởng",
    part_of_speech: "động từ",
    meaning:
      "phát triển lớn mạnh lên: nền kinh tế tăng trưởng nhanh * xuất khẩu đạt mức tăng trưởng cao",
    example:
      "nền kinh tế tăng trưởng nhanh * xuất khẩu đạt mức tăng trưởng cao",
  },
  {
    word: "tặng vật",
    part_of_speech: "danh từ",
    meaning: "như tặng phẩm: một tặng vật có giá trị",
    example: "một tặng vật có giá trị",
  },
  {
    word: "tăng viện",
    part_of_speech: "động từ",
    meaning:
      "đưa thêm người, thêm của để giúp sức cho bộ phận khác đang gặp khó khăn (thường là trong chiến đấu): quân tăng viện * cử người đi tăng viện",
    example: "quân tăng viện * cử người đi tăng viện",
  },
  {
    word: "tắp",
    part_of_speech: "phụ từ",
    meaning:
      "thành một đường, một vệt rất rõ: thẳng tắp * đường chỉ may đều tắp",
    example: "thẳng tắp * đường chỉ may đều tắp",
  },
  {
    word: "tăng tốc",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) tăng tốc độ (nói tắt): tăng tốc cho xe vượt lên trước",
    example: "tăng tốc cho xe vượt lên trước",
  },
  {
    word: "tắt mắt",
    part_of_speech: "động từ",
    meaning: "ăn cắp vặt: tính hay tắt mắt",
    example: "tính hay tắt mắt",
  },
  {
    word: "tắt",
    part_of_speech: "động từ",
    meaning:
      "thôi hoặc làm cho thôi không còn cháy, không còn sáng nữa: lửa đã tắt * nắng tắt * trời tắt gió",
    example: "lửa đã tắt * nắng tắt * trời tắt gió",
  },
  {
    word: "tắt",
    part_of_speech: "động từ",
    meaning:
      "làm cho máy móc ngừng hoạt động hoặc ngừng chạy: tắt đài * tắt ti vi * tắt quạt điện",
    example: "tắt đài * tắt ti vi * tắt quạt điện",
  },
  {
    word: "tắt",
    part_of_speech: "động từ",
    meaning:
      "không còn tồn tại nữa (tạm thời hay vĩnh viễn): nụ cười trên môi vụt tắt * hi vọng đã tắt",
    example: "nụ cười trên môi vụt tắt * hi vọng đã tắt",
  },
  {
    word: "tắt",
    part_of_speech: "tính từ",
    meaning:
      "(đi lại) không theo đường chính hoặc lối đi thông thường, mà theo một lối ngắn hơn cho nhanh hơn: con đường tắt * đi tắt đường đồng",
    example: "con đường tắt * đi tắt đường đồng",
  },
  {
    word: "tắt",
    part_of_speech: "tính từ",
    meaning:
      "(nói, viết) không đầy đủ các âm, các chữ như bình thường, mà bỏ bớt đi một số cho nhanh hơn, gọn hơn: cách nói tắt * gọi tắt * chữ viết tắt",
    example: "cách nói tắt * gọi tắt * chữ viết tắt",
  },
  {
    word: "tắt ngấm",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tắt hẳn, tắt hoàn toàn: bếp lửa đã tắt ngấm * tia hi vọng cuối cùng cũng tắt ngấm",
    example: "bếp lửa đã tắt ngấm * tia hi vọng cuối cùng cũng tắt ngấm",
  },
  {
    word: "tắt nghỉ",
    part_of_speech: "động từ",
    meaning: "(cũ, trang trọng) như tắt thở: ông cụ đã tắt nghỉ",
    example: "ông cụ đã tắt nghỉ",
  },
  {
    word: "tắt ngóm",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) tắt hẳn đi một cách đột ngột: điện bỗng dưng tắt ngóm",
    example: "điện bỗng dưng tắt ngóm",
  },
  {
    word: "tấc gang",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như gang tấc: gần gũi tấc gang",
    example: "gần gũi tấc gang",
  },
  {
    word: "tấc riêng",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) tấm lòng riêng, nỗi lòng riêng: "Hiên tà gác bóng chênh chênh, Nỗi riêng, riêng chạnh tấc riêng một mình." (TKiều)',
    example:
      'Hiên tà gác bóng chênh chênh, Nỗi riêng, riêng chạnh tấc riêng một mình." (TKiều)',
  },
  {
    word: "tấc lòng",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) lòng, tấm lòng: tấc lòng trung hiếu * "Bấy lâu nam bắc tây đông, Bước chân xa cách, tấc lòng quặn đau." (NĐM)',
    example:
      'tấc lòng trung hiếu * "Bấy lâu nam bắc tây đông, Bước chân xa cách, tấc lòng quặn đau." (NĐM)',
  },
  {
    word: "tấc",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị cũ đo độ dài, bằng một phần mười thước mộc (0,0425 mét) hoặc bằng một phần mười thước đo vải (0,0645 mét).",
    example: "tấc đất, tấc vàng",
  },
  {
    word: "tấc",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị cũ đo diện tích ruộng đất, bằng một phần mười thước, tức bằng 2,4 mét vuông (tấc Bắc Bộ), hoặc 3,3 mét vuông (tấc Trung Bộ): tấc đất, tấc vàng",
    example:
      'Hạt mưa sá nghĩ phận hèn, Liều đem tấc cỏ, quyết đền ba xuân." (TKiều)',
  },
  {
    word: "tấc son",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) tấm lòng son: "Còn trời, còn nước, còn non, Công phu đền báo tấc son có ngày." (TS)',
    example:
      'Còn trời, còn nước, còn non, Công phu đền báo tấc son có ngày." (TS)',
  },
  {
    word: "tắt thở",
    part_of_speech: "động từ",
    meaning:
      "ngừng thở hoàn toàn, không còn biểu hiện của sự sống: người bệnh đã tắt thở",
    example: "người bệnh đã tắt thở",
  },
  {
    word: "tấc vàng",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) tấm lòng vàng; tấc lòng: "Lời con dặn lại một hai, Dẫu mòn bia đá, dám sai tấc vàng?" (TKiều)',
    example:
      'Lời con dặn lại một hai, Dẫu mòn bia đá, dám sai tấc vàng?" (TKiều)',
  },
  {
    word: "tấc thành",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) lòng chân thành, tấm lòng thành: "Tưng bừng sắm sửa áo xiêm, Biện dâng một lễ, xa đem tấc thành." (TKiều)',
    example:
      'Tưng bừng sắm sửa áo xiêm, Biện dâng một lễ, xa đem tấc thành." (TKiều)',
  },
  {
    word: "tầm",
    part_of_speech: "danh từ",
    meaning:
      "khoảng cách, phạm vi có thể đạt được: tên lửa tầm xa * tuột khỏi tầm tay",
    example: "tên lửa tầm xa * tuột khỏi tầm tay",
  },
  {
    word: "tầm",
    part_of_speech: "danh từ",
    meaning:
      "khoảng chừng, độ chừng: chỗ đó ước tầm ba chục mét vuông * tầm này năm ngoái",
    example: "chỗ đó ước tầm ba chục mét vuông * tầm này năm ngoái",
  },
  {
    word: "tầm",
    part_of_speech: "danh từ",
    meaning:
      "độ, cỡ, thường được coi là ở mức chuẩn hoặc mức tương đối cao: tầm quan trọng của vấn đề * đứng ngang tầm với các nước phát triển",
    example:
      "tầm quan trọng của vấn đề * đứng ngang tầm với các nước phát triển",
  },
  {
    word: "tầm",
    part_of_speech: "danh từ",
    meaning:
      "thời gian làm việc hằng ngày theo quy định, ở công sở, nhà máy: còi tầm * giờ tan tầm",
    example: "còi tầm * giờ tan tầm",
  },
  {
    word: "tầm",
    part_of_speech: "động từ",
    meaning: "(cũ)",
    example: "tầm sư học đạo",
  },
  {
    word: "tâm",
    part_of_speech: "danh từ",
    meaning:
      "điểm chính giữa, cách đều tất cả các điểm trên một đường tròn hoặc trên một mặt cầu: tâm vòng tròn * tâm mặt cầu * tâm Trái Đất",
    example: "tâm vòng tròn * tâm mặt cầu * tâm Trái Đất",
  },
  {
    word: "tâm",
    part_of_speech: "danh từ",
    meaning: "tâm đối xứng (nói tắt): tâm hình chữ nhật",
    example: "tâm hình chữ nhật",
  },
  {
    word: "tâm",
    part_of_speech: "danh từ",
    meaning:
      'mặt tình cảm, ý chí của con người: không nỡ tâm lừa bạn * "Lửa tâm càng dập, càng nồng, Trách người đen bạc, ra lòng trăng hoa." (TKiều)',
    example:
      'không nỡ tâm lừa bạn * "Lửa tâm càng dập, càng nồng, Trách người đen bạc, ra lòng trăng hoa." (TKiều)',
  },
  {
    word: "tâm",
    part_of_speech: "danh từ",
    meaning: "tấm lòng nhân ái: sống có tâm",
    example: "sống có tâm",
  },
  {
    word: "tấm",
    part_of_speech: "danh từ",
    meaning: "mảnh vỡ nhỏ của hạt gạo do xay, giã: cơm tấm",
    example: "cơm tấm",
  },
  {
    word: "tấm",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị một số vật có mặt phẳng mỏng và dài: tấm ảnh * tấm ván mỏng * tấm vải hoa",
    example: "tấm ảnh * tấm ván mỏng * tấm vải hoa",
  },
  {
    word: "tấm",
    part_of_speech: "danh từ",
    meaning:
      '(văn chương) từ dùng để chỉ từng đơn vị một số vật bé nhỏ hoặc không đáng giá bao nhiêu, nhưng đáng được trân trọng: đồng quà tấm bánh * "Mẹ già ở tấm lều tranh, Sớm thăm tối viếng, mới đành dạ con." (ca dao)',
    example:
      'đồng quà tấm bánh * "Mẹ già ở tấm lều tranh, Sớm thăm tối viếng, mới đành dạ con." (ca dao)',
  },
  {
    word: "tấm",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương) từ dùng để chỉ từng cá nhân hay từng mối tình cảm đáng trân trọng: tấm thân ngọc ngà * tấm lòng cao cả",
    example: "tấm thân ngọc ngà * tấm lòng cao cả",
  },
  {
    word: "tấm bé",
    part_of_speech: "danh từ",
    meaning: "lúc còn đang nhỏ, đang thơ dại: vất vả từ tấm bé",
    example: "vất vả từ tấm bé",
  },
  {
    word: "tẩm",
    part_of_speech: "động từ",
    meaning: "làm cho một chất lỏng ngấm vào: mũi tên tẩm thuốc độc",
    example: "mũi tên tẩm thuốc độc",
  },
  {
    word: "tẩm",
    part_of_speech: "động từ",
    meaning:
      "làm cho chất bột hay đường dính phủ lên mặt ngoài của thức ăn: đùi ếch tẩm bột",
    example: "đùi ếch tẩm bột",
  },
  {
    word: "tẩm",
    part_of_speech: "tính từ",
    meaning:
      "(thông tục) quê kệch hoặc ngờ nghệch, kém khôn ngoan, kém hiểu biết: đúng là đồ tẩm!",
    example: "đúng là đồ tẩm!",
  },
  {
    word: "tẩm bổ",
    part_of_speech: "động từ",
    meaning:
      "làm tăng thêm sức khoẻ cho cơ thể bằng các thức ăn có nhiều chất dinh dưỡng hoặc thuốc bổ: ăn uống tẩm bổ",
    example: "ăn uống tẩm bổ",
  },
  {
    word: "tầm bậy tầm bạ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) như tầm bậy (nhưng nghĩa nhấn mạnh hơn): viết tầm bậy tầm bạ * ăn tầm bậy tầm bạ nên mới đau bụng",
    example: "viết tầm bậy tầm bạ * ăn tầm bậy tầm bạ nên mới đau bụng",
  },
  {
    word: "tâm bệnh",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) bệnh tinh thần, do phải lo nghĩ, buồn phiền mà sinh ra: mang tâm bệnh",
    example: "mang tâm bệnh",
  },
  {
    word: "tầm bậy",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) bậy bạ, vớ vẩn: nói tầm bậy * toàn nghĩ tầm bậy!",
    example: "nói tầm bậy * toàn nghĩ tầm bậy!",
  },
  {
    word: "tấc vuông",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) tấc lòng: "Tuy rằng lễ vật tầm thường, Xin cho soi xét tấc vuông lòng thành." (BCB)',
    example:
      'Tuy rằng lễ vật tầm thường, Xin cho soi xét tấc vuông lòng thành." (BCB)',
  },
  {
    word: "tâm cảnh",
    part_of_speech: "danh từ",
    meaning: "(cũ) như tâm trạng: tâm cảnh bâng khuâng",
    example: "tâm cảnh bâng khuâng",
  },
  {
    word: "tâm can",
    part_of_speech: "danh từ",
    meaning:
      "tim và gan, được coi là biểu tượng của những tình cảm sâu kín tận đáy lòng của con người, nói chung: thấu hiểu tâm can * bày tỏ tâm can",
    example: "thấu hiểu tâm can * bày tỏ tâm can",
  },
  {
    word: "tâm đắc",
    part_of_speech: "động từ",
    meaning: "hiểu được sâu sắc: điều tâm đắc * cuốn sách tâm đắc",
    example: "điều tâm đắc * cuốn sách tâm đắc",
  },
  {
    word: "tâm đắc",
    part_of_speech: "động từ",
    meaning:
      "hiểu lòng nhau, thích thú và thấy rất hợp: bạn tâm đắc * chuyện trò rất tâm đắc",
    example: "bạn tâm đắc * chuyện trò rất tâm đắc",
  },
  {
    word: "tâm địa",
    part_of_speech: "danh từ",
    meaning:
      "lòng dạ (thường là xấu xa, hiểm độc) của con người: tâm địa độc ác * không có tâm địa gì",
    example: "tâm địa độc ác * không có tâm địa gì",
  },
  {
    word: "tâm điểm",
    part_of_speech: "danh từ",
    meaning: "như tâm (ng1): tâm điểm của đường tròn",
    example: "tâm điểm của đường tròn",
  },
  {
    word: "tâm điểm",
    part_of_speech: "danh từ",
    meaning:
      "điểm chính, điểm trọng tâm: tâm điểm của sự chú ý * trở thành tâm điểm về kinh tế của khu vực",
    example:
      "tâm điểm của sự chú ý * trở thành tâm điểm về kinh tế của khu vực",
  },
  {
    word: "tâm giao",
    part_of_speech: "tính từ",
    meaning:
      "(mối quan hệ bạn bè) rất thân thiết và thấu hiểu lòng nhau: bạn tâm giao",
    example: "bạn tâm giao",
  },
  {
    word: "tầm cỡ",
    part_of_speech: "danh từ",
    meaning:
      "cỡ, mức độ hoặc quy mô, thường là lớn (nói khái quát): công trình mang tầm cỡ quốc tế * một chính khách có tầm cỡ",
    example: "công trình mang tầm cỡ quốc tế * một chính khách có tầm cỡ",
  },
  {
    word: "tầm cỡ",
    part_of_speech: "danh từ",
    meaning: "(hiếm) cỡ chừng, khoảng chừng: quãng đường tầm cỡ 20 cây số",
    example: "quãng đường tầm cỡ 20 cây số",
  },
  {
    word: "tâm hương",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) nén hương thắp lên, dâng lên với cả tấm lòng thành kính: đốt nén tâm hương",
    example: "đốt nén tâm hương",
  },
  {
    word: "tâm lí",
    part_of_speech: "danh từ",
    meaning:
      "tổng thể nói chung các hiện tượng từ cảm giác, nhận thức đến tình cảm, hành vi, ý chí, v.v. của mỗi người: tâm lí tuổi dậy thì * tâm lí căng thẳng trước giờ thi đấu",
    example: "tâm lí tuổi dậy thì * tâm lí căng thẳng trước giờ thi đấu",
  },
  {
    word: "tâm lí",
    part_of_speech: "danh từ",
    meaning:
      "ý thích, nguyện vọng, thị hiếu, v.v. riêng của mỗi người hoặc một lớp người, trong một hoàn cảnh cụ thể nào đó: nắm được tâm lí khách hàng * hiểu tâm lí học sinh",
    example: "nắm được tâm lí khách hàng * hiểu tâm lí học sinh",
  },
  {
    word: "tâm lí",
    part_of_speech: "tính từ",
    meaning: "thuộc về tâm lí: hiện tượng tâm lí",
    example: "hiện tượng tâm lí",
  },
  {
    word: "tâm lí",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có thể hiểu được ý thích, nguyện vọng, thị hiếu, v.v. của người khác để có sự ứng xử phù hợp: một cô giáo rất tâm lí với học sinh",
    example: "một cô giáo rất tâm lí với học sinh",
  },
  {
    word: "tâm hồn",
    part_of_speech: "danh từ",
    meaning:
      'tâm tư và tình cảm, làm thành đời sống nội tâm của mỗi con người (nói tổng quát): tâm hồn trong sáng * có tâm hồn nghệ sĩ * "Nhớ ai mê mẩn tâm hồn, Thương ai mong đợi mỏi mòn tháng năm." (ca dao)',
    example:
      'tâm hồn trong sáng * có tâm hồn nghệ sĩ * "Nhớ ai mê mẩn tâm hồn, Thương ai mong đợi mỏi mòn tháng năm." (ca dao)',
  },
  {
    word: "tâm linh",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) khả năng tự biết trước một biến cố nào đó sẽ xảy ra, theo quan niệm duy tâm: tâm linh báo trước có điều chẳng lành",
    example: "tâm linh báo trước có điều chẳng lành",
  },
  {
    word: "tâm linh",
    part_of_speech: "danh từ",
    meaning:
      "tâm hồn, tinh thần (thường có tính chất thiêng liêng): đời sống tâm linh * hiểu thấu tâm linh",
    example: "đời sống tâm linh * hiểu thấu tâm linh",
  },
  {
    word: "tâm huyết",
    part_of_speech: "danh từ",
    meaning:
      "lòng sốt sắng, thiết tha đối với sự nghiệp chung xuất phát từ tình cảm và ý chí: đem hết tâm huyết ra giúp đời * có tâm huyết",
    example: "đem hết tâm huyết ra giúp đời * có tâm huyết",
  },
  {
    word: "tâm huyết",
    part_of_speech: "tính từ",
    meaning:
      "rất nhiệt tình và chân thành, xuất phát từ tình cảm và nguyện vọng thiết tha: lời tâm huyết * một bác sĩ rất tâm huyết với nghề",
    example: "lời tâm huyết * một bác sĩ rất tâm huyết với nghề",
  },
  {
    word: "tâm khảm",
    part_of_speech: "danh từ",
    meaning:
      "nơi chứa đựng những tình cảm thầm kín nhất: giấu kín trong tâm khảm * hình ảnh đã ghi sâu vào tâm khảm",
    example: "giấu kín trong tâm khảm * hình ảnh đã ghi sâu vào tâm khảm",
  },
  {
    word: "tâm lực",
    part_of_speech: "danh từ",
    meaning:
      "sức mạnh của ý chí, tinh thần con người: dồn hết tâm lực vào công việc",
    example: "dồn hết tâm lực vào công việc",
  },
  {
    word: "tâm lý",
    part_of_speech: "danh từ",
    meaning:
      "tổng thể nói chung các hiện tượng từ cảm giác, nhận thức đến tình cảm, hành vi, ý chí, v.v. của mỗi người: tâm lí tuổi dậy thì * tâm lí căng thẳng trước giờ thi đấu",
    example: "tâm lí tuổi dậy thì * tâm lí căng thẳng trước giờ thi đấu",
  },
  {
    word: "tâm lý",
    part_of_speech: "danh từ",
    meaning:
      "ý thích, nguyện vọng, thị hiếu, v.v. riêng của mỗi người hoặc một lớp người, trong một hoàn cảnh cụ thể nào đó: nắm được tâm lí khách hàng * hiểu tâm lí học sinh",
    example: "nắm được tâm lí khách hàng * hiểu tâm lí học sinh",
  },
  {
    word: "tâm lý",
    part_of_speech: "tính từ",
    meaning: "thuộc về tâm lí: hiện tượng tâm lí",
    example: "hiện tượng tâm lí",
  },
  {
    word: "tâm lý",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có thể hiểu được ý thích, nguyện vọng, thị hiếu, v.v. của người khác để có sự ứng xử phù hợp: một cô giáo rất tâm lí với học sinh",
    example: "một cô giáo rất tâm lí với học sinh",
  },
  {
    word: "tấm lợp",
    part_of_speech: "danh từ",
    meaning: "vật liệu có dạng hình tấm, dùng để lợp mái: tấm lợp bằng nhựa",
    example: "tấm lợp bằng nhựa",
  },
  {
    word: "tâm não",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như tâm trí: in đậm trong tâm não",
    example: "in đậm trong tâm não",
  },
  {
    word: "tâm ngẩm",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) lầm lì, để bụng (không chịu để lộ ý nghĩ của mình): trông tâm ngẩm thế mà ghê lắm",
    example: "trông tâm ngẩm thế mà ghê lắm",
  },
  {
    word: "tầm mắt",
    part_of_speech: "danh từ",
    meaning:
      "tầm nhìn xa của mắt; thường dùng để chỉ khả năng nhìn xa trông rộng: phóng tầm mắt ra xa * đi đây đó cho mở mang tầm mắt",
    example: "phóng tầm mắt ra xa * đi đây đó cho mở mang tầm mắt",
  },
  {
    word: "tầm nhìn xa",
    part_of_speech: "danh từ",
    meaning:
      "khoảng không gian có thể nhìn thấy được vật ở xa trên mặt đất hoặc mặt biển, tuỳ thuộc vào độ trong suốt của khí quyển: tầm nhìn xa trên mười kilomet",
    example: "tầm nhìn xa trên mười kilomet",
  },
  {
    word: "tâm nguyện",
    part_of_speech: "danh từ",
    meaning:
      "mong muốn, ước nguyện xuất phát từ trong tâm khảm: bày tỏ tâm nguyện * thực hiện tâm nguyện của người đã khuất",
    example: "bày tỏ tâm nguyện * thực hiện tâm nguyện của người đã khuất",
  },
  {
    word: "tâm niệm",
    part_of_speech: "động từ",
    meaning:
      "nghĩ tới thường xuyên và tự nhắc mình để ghi nhớ và làm theo: điều tâm niệm * luôn tâm niệm lời dặn dò của cha mẹ",
    example: "điều tâm niệm * luôn tâm niệm lời dặn dò của cha mẹ",
  },
  {
    word: "tâm phục khẩu phục",
    part_of_speech: "",
    meaning:
      "phục tự đáy lòng, chứ không phải chỉ nói ngoài miệng: sự xét xử công minh của tòa án khiến các bị cáo tâm phục khẩu phục",
    example:
      "sự xét xử công minh của tòa án khiến các bị cáo tâm phục khẩu phục",
  },
  {
    word: "tầm phào",
    part_of_speech: "tính từ",
    meaning:
      "vu vơ, không đâu vào đâu, không nhằm mục đích gì cả: nói mấy câu tầm phào * chuyện tầm phào",
    example: "nói mấy câu tầm phào * chuyện tầm phào",
  },
  {
    word: "tâm phục",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) phục tự đáy lòng: tài năng và đức độ của ông khiến mọi người tâm phục",
    example: "tài năng và đức độ của ông khiến mọi người tâm phục",
  },
  {
    word: "tâm phúc",
    part_of_speech: "tính từ",
    meaning:
      'gần gũi, thân thiết và tin cẩn: người tâm phúc * "Mấy lời tâm phúc ruột rà, Tương tri dường ấy mới là tương tri!" (TKiều)',
    example:
      'người tâm phúc * "Mấy lời tâm phúc ruột rà, Tương tri dường ấy mới là tương tri!" (TKiều)',
  },
  {
    word: "tầm sét",
    part_of_speech: "danh từ",
    meaning:
      "lưỡi búa của thiên lôi dùng giáng xuống gây ra sét đánh, theo tưởng tượng của dân gian: lưỡi tầm sét",
    example: "lưỡi tầm sét",
  },
  {
    word: "tâm sinh lí",
    part_of_speech: "danh từ",
    meaning:
      "tâm lí và sinh lí (nói tắt): tìm hiểu đặc điểm tâm sinh lí của trẻ",
    example: "tìm hiểu đặc điểm tâm sinh lí của trẻ",
  },
  {
    word: "tâm sinh lý",
    part_of_speech: "danh từ",
    meaning:
      "tâm lí và sinh lí (nói tắt): tìm hiểu đặc điểm tâm sinh lí của trẻ",
    example: "tìm hiểu đặc điểm tâm sinh lí của trẻ",
  },
  {
    word: "tầm súng",
    part_of_speech: "danh từ",
    meaning:
      "khoảng không gian súng bắn có hiệu quả: mục tiêu đã lọt vào tầm súng",
    example: "mục tiêu đã lọt vào tầm súng",
  },
  {
    word: "tấm tắc",
    part_of_speech: "động từ",
    meaning:
      "luôn miệng buột ra những tiếng tỏ ý khen ngợi, thán phục: tấm tắc khen ngon",
    example: "tấm tắc khen ngon",
  },
  {
    word: "tâm sự",
    part_of_speech: "danh từ",
    meaning:
      'chuyện riêng tư sâu kín trong lòng (nói khái quát): bày tỏ tâm sự * dốc bầu tâm sự * "Chung quanh lặng ngắt như tờ, Nỗi niềm tâm sự bây giờ hỏi ai?" (TKiều)',
    example:
      'bày tỏ tâm sự * dốc bầu tâm sự * "Chung quanh lặng ngắt như tờ, Nỗi niềm tâm sự bây giờ hỏi ai?" (TKiều)',
  },
  {
    word: "tâm sự",
    part_of_speech: "động từ",
    meaning: "thổ lộ chuyện riêng tư với nhau: tâm sự với bạn",
    example: "tâm sự với bạn",
  },
  {
    word: "tâm sức",
    part_of_speech: "danh từ",
    meaning: "như tâm lực: dồn hết tâm sức chăm lo cho con cái",
    example: "dồn hết tâm sức chăm lo cho con cái",
  },
  {
    word: "tầm tầm",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (đồ dùng) đã cũ, nhưng vẫn còn dùng được: mặc một chiếc áo tầm tầm",
    example: "mặc một chiếc áo tầm tầm",
  },
  {
    word: "tầm tầm",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) ở mức vừa phải, mức trung bình (không cao, không thấp, không lớn, không nhỏ): giá cũng tầm tầm chứ không cao * khả năng chỉ vào loại tầm tầm",
    example: "giá cũng tầm tầm chứ không cao * khả năng chỉ vào loại tầm tầm",
  },
  {
    word: "tâm thần học",
    part_of_speech: "danh từ",
    meaning:
      "ngành học nghiên cứu các bệnh tâm lí hay về hoạt động tâm lí trên cơ sở tác động của hệ thần kinh: chuyên khoa tâm thần học",
    example: "chuyên khoa tâm thần học",
  },
  {
    word: "tầm tã",
    part_of_speech: "tính từ",
    meaning:
      '(trời mưa hay nước mắt tuôn rơi) nhiều và kéo dài mãi không dứt: trời mưa tầm tã * "Sụt sùi giở nỗi đoạn tràng, Giọt châu tầm tã đẫm tràng áo xanh." (TKiều)',
    example:
      'trời mưa tầm tã * "Sụt sùi giở nỗi đoạn tràng, Giọt châu tầm tã đẫm tràng áo xanh." (TKiều)',
  },
  {
    word: "tâm thần",
    part_of_speech: "danh từ",
    meaning:
      "tâm trí, tinh thần: tâm thần bất định * thích đến mê mẩn tâm thần",
    example: "tâm thần bất định * thích đến mê mẩn tâm thần",
  },
  {
    word: "tâm thần",
    part_of_speech: "danh từ",
    meaning: "bệnh tâm thần (nói tắt): bệnh viện tâm thần * mắc chứng tâm thần",
    example: "bệnh viện tâm thần * mắc chứng tâm thần",
  },
  {
    word: "tâm thế",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) tâm trạng và tư thế thể hiện ra trước một việc gì (nói khái quát): tâm thế của một người chiến thắng * có tâm thế dự phòng",
    example: "tâm thế của một người chiến thắng * có tâm thế dự phòng",
  },
  {
    word: "tầm thường",
    part_of_speech: "tính từ",
    meaning:
      "rất thường, không có gì đặc sắc, đặc biệt (hàm ý chê): thị hiếu tầm thường * hạng người tầm thường",
    example: "thị hiếu tầm thường * hạng người tầm thường",
  },
  {
    word: "tầm thước",
    part_of_speech: "tính từ",
    meaning:
      "(vóc người) vừa phải, không cao lắm nhưng cũng không thấp: vóc người tầm thước",
    example: "vóc người tầm thước",
  },
  {
    word: "tâm tình",
    part_of_speech: "danh từ",
    meaning:
      'tình cảm riêng tư, thầm kín của mỗi người: thổ lộ tâm tình * "Dừng chèo muốn tỏ tâm tình, Sông bao nhiêu nước thương mình bấy nhiêu." (ca dao)',
    example:
      'thổ lộ tâm tình * "Dừng chèo muốn tỏ tâm tình, Sông bao nhiêu nước thương mình bấy nhiêu." (ca dao)',
  },
  {
    word: "tâm tình",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) thổ lộ tâm tư, tình cảm thầm kín với nhau: viết thư để tâm tình * chuyện trò tâm tình",
    example: "viết thư để tâm tình * chuyện trò tâm tình",
  },
  {
    word: "tâm tình",
    part_of_speech: "tính từ",
    meaning:
      "thân thiết đến mức có thể thổ lộ cho nhau biết những tâm tư, tình cảm thầm kín: bạn tâm tình",
    example: "bạn tâm tình",
  },
  {
    word: "tâm thức",
    part_of_speech: "danh từ",
    meaning:
      "tình cảm và nhận thức đã ăn sâu và bền vững: hình ảnh cây đa, bến nước, sân đình đã ăn sâu trong tâm thức người Việt",
    example:
      "hình ảnh cây đa, bến nước, sân đình đã ăn sâu trong tâm thức người Việt",
  },
  {
    word: "tâm thư",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, hiếm) thư bày tỏ tâm sự hoặc những lời tâm huyết: bức tâm thư",
    example: "bức tâm thư",
  },
  {
    word: "tậm tịt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (tình trạng, máy móc) không hoạt động được đều, lúc được lúc không, hay bị tắc, bị hỏng: điện đóm tậm tịt * chiếc xe tậm tịt, chốc chốc lại chết máy",
    example: "điện đóm tậm tịt * chiếc xe tậm tịt, chốc chốc lại chết máy",
  },
  {
    word: "tâm trạng",
    part_of_speech: "danh từ",
    meaning:
      "trạng thái tâm lí cụ thể trong một thời điểm nào đó: tâm trạng u buồn * sống trong tâm trạng phấp phỏng lo sợ",
    example: "tâm trạng u buồn * sống trong tâm trạng phấp phỏng lo sợ",
  },
  {
    word: "tâm trí",
    part_of_speech: "danh từ",
    meaning:
      "tình cảm và suy nghĩ của con người trong một hoàn cảnh cụ thể nào đó (nói tổng quát): dồn hết tâm trí vào công việc * tâm trí đâu mà nghĩ đến chuyện đó!",
    example:
      "dồn hết tâm trí vào công việc * tâm trí đâu mà nghĩ đến chuyện đó!",
  },
  {
    word: "tâm tính",
    part_of_speech: "danh từ",
    meaning:
      "tính nết riêng của mỗi người: tâm tính thay đổi * tâm tính cục cằn",
    example: "tâm tính thay đổi * tâm tính cục cằn",
  },
  {
    word: "tâm trường",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) tim và ruột; lòng dạ: "Nghe nhời con nói tỏ tường, Tướng công khi ấy tâm trường xót xa!" (CC)',
    example:
      'Nghe nhời con nói tỏ tường, Tướng công khi ấy tâm trường xót xa!" (CC)',
  },
  {
    word: "tâm tưởng",
    part_of_speech: "danh từ",
    meaning:
      "suy nghĩ và tình cảm riêng của mỗi người: một thời quá khứ như sống dậy trong tâm tưởng",
    example: "một thời quá khứ như sống dậy trong tâm tưởng",
  },
  {
    word: "tấm tức",
    part_of_speech: "động từ",
    meaning:
      "bị oan ức hoặc bực tức mà phải nén trong lòng, không nói ra được: tấm tức trong lòng * bị mắng oan nên tấm tức mãi",
    example: "tấm tức trong lòng * bị mắng oan nên tấm tức mãi",
  },
  {
    word: "tấm tức",
    part_of_speech: "tính từ",
    meaning:
      "(tiếng khóc) nhỏ, khẽ và kéo dài bật ra do có điều bực tức hoặc oan ức cố kìm nén trong lòng mà không thể kìm nén nổi: khóc tấm tức",
    example: "khóc tấm tức",
  },
  {
    word: "tâm tư",
    part_of_speech: "danh từ",
    meaning:
      "những điều đang suy nghĩ trong lòng (nói tổng quát): hiểu thấu tâm tư, nguyện vọng",
    example: "hiểu thấu tâm tư, nguyện vọng",
  },
  {
    word: "tầm xuân",
    part_of_speech: "danh từ",
    meaning:
      "cây mọc hoang, cùng loại với hoa hồng, hoa thường có màu trắng: nụ tầm xuân",
    example: "nụ tầm xuân",
  },
  {
    word: "tầm vóc",
    part_of_speech: "danh từ",
    meaning: "dáng vóc, cỡ người: tầm vóc cao lớn",
    example: "tầm vóc cao lớn",
  },
  {
    word: "tầm vóc",
    part_of_speech: "danh từ",
    meaning: "như tầm cỡ (ng1): một công trình mang tầm vóc quốc gia",
    example: "một công trình mang tầm vóc quốc gia",
  },
  {
    word: "tân binh",
    part_of_speech: "danh từ",
    meaning: "lính mới nhập ngũ: huấn luyện tân binh",
    example: "huấn luyện tân binh",
  },
  {
    word: "tấn",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị đo khối lượng bằng 1.000 kilogram, trong hệ đơn vị đo lường quốc tế: hai tấn thóc * xe có trọng tải 10 tấn",
    example: "hai tấn thóc * xe có trọng tải 10 tấn",
  },
  {
    word: "tấn",
    part_of_speech: "danh từ",
    meaning:
      "lớp diễn có tính chất cao trào của vở tuồng, vở kịch: tấn tuồng cổ",
    example: "tấn tuồng cổ",
  },
  {
    word: "tấn",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương) cảnh ngộ có nhiều kịch tính ở đời: tấn trò đời * tấn bi kịch của gia đình",
    example: "tấn trò đời * tấn bi kịch của gia đình",
  },
  {
    word: "tấn",
    part_of_speech: "danh từ",
    meaning:
      "thế võ đứng chùng thấp xuống và dồn lực vào hai chân cho vững chắc: xuống tấn * đứng tấn",
    example: "xuống tấn * đứng tấn",
  },
  {
    word: "tấn",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) chặn hoặc chèn lên cho chặt: tấn chiếc bàn vào cánh cửa * tấn màn cho con ngủ",
    example: "tấn chiếc bàn vào cánh cửa * tấn màn cho con ngủ",
  },
  {
    word: "tân",
    part_of_speech: "tính từ",
    meaning:
      "(Từ cũ, Ít dùng) mới, trong quan hệ đối lập với cựu (Từ cũ, có trước): kẻ cựu người tân",
    example: "kẻ cựu người tân",
  },
  {
    word: "tân",
    part_of_speech: "tính từ",
    meaning:
      "(người đã ở tuổi trưởng thành) chưa hề có quan hệ tình dục: trai tân * mất tân",
    example: "trai tân * mất tân",
  },
  {
    word: "tần",
    part_of_speech: "động từ",
    meaning:
      "làm cho thức ăn chín nhừ bằng cách hấp cách thuỷ: chim câu tần * gà tần thuốc bắc",
    example: "chim câu tần * gà tần thuốc bắc",
  },
  {
    word: "tận",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) (chỗ hoặc lúc) đến đấy là hết, là giới hạn cuối cùng: nơi sơn cùng thuỷ tận * năm cùng tháng tận",
    example: "nơi sơn cùng thuỷ tận * năm cùng tháng tận",
  },
  {
    word: "tận",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là vị trí, giới hạn cuối cùng mà hành động vừa nói đến đạt tới: đưa tận tay * đi đến tận khuya mới về * bóc lột tận xương tuỷ",
    example: "đưa tận tay * đi đến tận khuya mới về * bóc lột tận xương tuỷ",
  },
  {
    word: "tấn công",
    part_of_speech: "động từ",
    meaning:
      "tiến đánh một cách dữ dội, mãnh mẽ và thường trên diện rộng: tấn công vào căn cứ địch * tấn công vào nghèo nàn và bệnh tật",
    example: "tấn công vào căn cứ địch * tấn công vào nghèo nàn và bệnh tật",
  },
  {
    word: "tấn công",
    part_of_speech: "động từ",
    meaning:
      "dùng sức mạnh hoặc lợi thế để lấn át đối phương một cách mạnh mẽ nhằm giành thắng lợi hoặc để chiếm ưu thế trong một cuộc đua tranh có tính được thua nào đó: đội nhà ào lên tấn công",
    example: "đội nhà ào lên tấn công",
  },
  {
    word: "tận cùng",
    part_of_speech: "tính từ",
    meaning:
      "ở chỗ cuối cùng, đến đấy là hết giới hạn, là kết thúc: ở vị trí tận cùng * tìm những âm tiết tận cùng là 't'",
    example: "ở vị trí tận cùng * tìm những âm tiết tận cùng là 't'",
  },
  {
    word: "tận cùng",
    part_of_speech: "danh từ",
    meaning:
      "chỗ đến đấy là hết, không còn gì nữa: đại dương mênh mông, không biết đâu là tận cùng",
    example: "đại dương mênh mông, không biết đâu là tận cùng",
  },
  {
    word: "tận diệt",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) diệt sạch, diệt cho bằng hết: chất độc màu da cam đã tận diệt cả cỏ cây",
    example: "chất độc màu da cam đã tận diệt cả cỏ cây",
  },
  {
    word: "tận dụng",
    part_of_speech: "động từ",
    meaning:
      "sử dụng cho hết mọi khả năng có được, không bỏ phí: tận dụng phế liệu * tận dụng triệt để mọi cơ hội",
    example: "tận dụng phế liệu * tận dụng triệt để mọi cơ hội",
  },
  {
    word: "tẩn",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) đánh: tẩn cho nó một trận",
    example: "tẩn cho nó một trận",
  },
  {
    word: "tân hôn",
    part_of_speech: "danh từ",
    meaning: "(trang trọng) lúc vừa mới làm lễ cưới: đêm tân hôn",
    example: "đêm tân hôn",
  },
  {
    word: "tân dược",
    part_of_speech: "danh từ",
    meaning:
      "thuốc tây y: kinh doanh mặt hàng tân dược * xưởng điều chế tân dược",
    example: "kinh doanh mặt hàng tân dược * xưởng điều chế tân dược",
  },
  {
    word: "tận hưởng",
    part_of_speech: "động từ",
    meaning:
      "hưởng cho trọn vẹn cái được hưởng (thường nói về cảm giác sung sướng): tận hưởng hạnh phúc * tận hưởng bầu không khí trong lành",
    example: "tận hưởng hạnh phúc * tận hưởng bầu không khí trong lành",
  },
  {
    word: "tân gia",
    part_of_speech: "danh từ",
    meaning:
      "nhà mới (dùng trong dịp khánh thành): chúc mừng tân gia * quà mừng tân gia",
    example: "chúc mừng tân gia * quà mừng tân gia",
  },
  {
    word: "tân khoa",
    part_of_speech: "danh từ",
    meaning: "(cũ) người mới thi đỗ: chúc mừng tân khoa * quan tân khoa",
    example: "chúc mừng tân khoa * quan tân khoa",
  },
  {
    word: "tân kì",
    part_of_speech: "tính từ",
    meaning: "(cũ) mới lạ: ăn mặc theo lối tân kì",
    example: "ăn mặc theo lối tân kì",
  },
  {
    word: "tân lang",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, văn chương) chàng rể mới (dùng để gọi trong ngày cưới): chàng tân lang",
    example: "chàng tân lang",
  },
  {
    word: "tân khổ",
    part_of_speech: "tính từ",
    meaning:
      '(cũ, văn chương) đắng cay, khổ sở: "Xa xôi ai có tỏ chừng?, Gian nan tân khổ, ta đừng quên nhau." (ca dao)',
    example:
      'Xa xôi ai có tỏ chừng?, Gian nan tân khổ, ta đừng quên nhau." (ca dao)',
  },
  {
    word: "tận lực",
    part_of_speech: "tính từ",
    meaning:
      "(làm việc gì) hết sức mình, bằng tất cả sức lực: tận lực giúp đỡ mọi người",
    example: "tận lực giúp đỡ mọi người",
  },
  {
    word: "tận mắt",
    part_of_speech: "tính từ",
    meaning: "(nhìn, thấy) trực tiếp bằng chính mắt mình: nhìn tận mắt",
    example: "nhìn tận mắt",
  },
  {
    word: "tần mần",
    part_of_speech: "động từ",
    meaning:
      "mân mê những thứ không phải của mình một cách lặng lẽ và chăm chú: ông khách đứng tần mần xem chiếc độc bình cổ",
    example: "ông khách đứng tần mần xem chiếc độc bình cổ",
  },
  {
    word: "tần mần",
    part_of_speech: "tính từ",
    meaning:
      "(làm việc gì) thong thả, kiên nhẫn như không còn để ý gì đến thời gian: ngồi tần mần đan lát",
    example: "ngồi tần mần đan lát",
  },
  {
    word: "tẩn mẩn tần mần",
    part_of_speech: "động từ",
    meaning:
      '(hiếm) như tần mần (nhưng ý nhấn mạnh hơn): "Ban ngày quan lớn như thần, Ban đêm tẩn mẩn tần mần như ma." (ca dao)',
    example:
      'Ban ngày quan lớn như thần, Ban đêm tẩn mẩn tần mần như ma." (ca dao)',
  },
  {
    word: "tần ngần",
    part_of_speech: "động từ",
    meaning:
      "tỏ ra còn đang nghĩ ngợi chưa biết nên như thế nào: đứng tần ngần một lúc mới dám vào * vẻ mặt tần ngần",
    example: "đứng tần ngần một lúc mới dám vào * vẻ mặt tần ngần",
  },
  {
    word: "tẩn mẩn",
    part_of_speech: "tính từ",
    meaning:
      "(làm việc gì) quá tỉ mỉ, vụn vặt, mất thì giờ: tẩn mẩn nặn tò he * tính toán tẩn mẩn",
    example: "tẩn mẩn nặn tò he * tính toán tẩn mẩn",
  },
  {
    word: "tần phiền",
    part_of_speech: "động từ",
    meaning:
      "(cũ, hiếm) gây phiền nhiễu, quấy rầy: không muốn tần phiền đến ai",
    example: "không muốn tần phiền đến ai",
  },
  {
    word: "tân nương",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, văn chương) nàng dâu mới (dùng để gọi trong ngày cưới): chúc tân lang tân nương trăm năm hạnh phúc",
    example: "chúc tân lang tân nương trăm năm hạnh phúc",
  },
  {
    word: "tấn phong",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) phong lên chức vụ hay tước vị cao nhất: lễ tấn phong hoàng hậu",
    example: "lễ tấn phong hoàng hậu",
  },
  {
    word: "tần suất",
    part_of_speech: "danh từ",
    meaning:
      "số lần xuất hiện của một hiện tượng trong một phạm vi, một đơn vị thời gian nhất định: nâng tần suất chạy tàu lên 5 chuyến một ngày",
    example: "nâng tần suất chạy tàu lên 5 chuyến một ngày",
  },
  {
    word: "tận số",
    part_of_speech: "",
    meaning: "chấm dứt, kết thúc số phận, coi như hết đời: đến ngày tận số",
    example: "đến ngày tận số",
  },
  {
    word: "tận tay",
    part_of_speech: "tính từ",
    meaning:
      'trực tiếp đến tay, không qua trung gian: trao tận tay * "Nhạn ơi, trăm sự nhờ mày, Gửi thư đem đến tận tay cho chàng." (ca dao)',
    example:
      'trao tận tay * "Nhạn ơi, trăm sự nhờ mày, Gửi thư đem đến tận tay cho chàng." (ca dao)',
  },
  {
    word: "tần số",
    part_of_speech: "danh từ",
    meaning:
      "số chu kì của một hiện tượng dao động trong một đơn vị thời gian (một giây): tần số dao động của con lắc * xác định tần số của sóng radio",
    example: "tần số dao động của con lắc * xác định tần số của sóng radio",
  },
  {
    word: "tần số",
    part_of_speech: "danh từ",
    meaning: "như tần suất: xác định tần số của từ  *  trong tác phẩm Tắt đèn",
    example: "xác định tần số của từ  *  trong tác phẩm Tắt đèn",
  },
  {
    word: "tận tâm",
    part_of_speech: "tính từ",
    meaning:
      "với tất cả tấm lòng: tận tâm với công việc * được các bác sĩ tận tâm chăm sóc",
    example: "tận tâm với công việc * được các bác sĩ tận tâm chăm sóc",
  },
  {
    word: "tần tảo",
    part_of_speech: "động từ",
    meaning:
      "(người phụ nữ) làm lụng vất vả, lo toan việc nhà trong cảnh sống khó khăn: sớm khuya tần tảo * một mình tần tảo nuôi con",
    example: "sớm khuya tần tảo * một mình tần tảo nuôi con",
  },
  {
    word: "tân tiến",
    part_of_speech: "tính từ",
    meaning:
      "(cũ) mới và tiến bộ (thường nói về tư tưởng, lối sống): tư tưởng tân tiến * con người tân tiến",
    example: "tư tưởng tân tiến * con người tân tiến",
  },
  {
    word: "tân thời",
    part_of_speech: "tính từ",
    meaning:
      '(cách ăn mặc, quần áo) theo kiểu mới, mốt mới, đang được nhiều người ưa chuộng: ăn mặc tân thời * "Bẩm, trông bà chỉ có vẻ lương thiện đứng đắn thôi chứ không tân thời mấy ạ." (VTrPhụng; 13)',
    example:
      'ăn mặc tân thời * "Bẩm, trông bà chỉ có vẻ lương thiện đứng đắn thôi chứ không tân thời mấy ạ." (VTrPhụng; 13)',
  },
  {
    word: "tận tuỵ",
    part_of_speech: "tính từ",
    meaning:
      "hết lòng hết sức với công việc, không ngại gian khổ, khó khăn: tận tuỵ với công việc * cúc cung tận tuỵ",
    example: "tận tuỵ với công việc * cúc cung tận tuỵ",
  },
  {
    word: "tấn tới",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) (học hành, làm ăn) ngày một tiến bộ, ngày càng tốt hơn: học hành tấn tới * công việc làm ăn ngày một tấn tới",
    example: "học hành tấn tới * công việc làm ăn ngày một tấn tới",
  },
  {
    word: "tân toan",
    part_of_speech: "tính từ",
    meaning:
      '(cũ, văn chương) đắng cay, khổ nhục: "Niềm riêng chất để muôn vàn, Nói cười ngoài miệng, tân toan trong lòng." (HTr)',
    example:
      'Niềm riêng chất để muôn vàn, Nói cười ngoài miệng, tân toan trong lòng." (HTr)',
  },
  {
    word: "tận tình",
    part_of_speech: "tính từ",
    meaning:
      "với tất cả nhiệt tình: giúp đỡ tận tình * tận tình chăm sóc người bệnh",
    example: "giúp đỡ tận tình * tận tình chăm sóc người bệnh",
  },
  {
    word: "tầng",
    part_of_speech: "danh từ",
    meaning:
      "mặt phẳng ngang hoặc lớp ngăn chia không gian thành những phần trên dưới khác nhau về độ cao: nhà cao tầng * tầng hầm * tầng khí quyển * chịu mấy tầng áp bức",
    example: "nhà cao tầng * tầng hầm * tầng khí quyển * chịu mấy tầng áp bức",
  },
  {
    word: "tầng",
    part_of_speech: "danh từ",
    meaning:
      "lớp, bậc tạo thành do quá trình bóc đất đá và khai thác khoáng sản của mỏ lộ thiên: tầng trên của khu mỏ",
    example: "tầng trên của khu mỏ",
  },
  {
    word: "tận thu",
    part_of_speech: "động từ",
    meaning:
      "thu cho kì hết, không bỏ sót hoặc để lãng phí: tận thu ngân sách * tận thu phế thải để tái chế",
    example: "tận thu ngân sách * tận thu phế thải để tái chế",
  },
  {
    word: "tân xuân",
    part_of_speech: "danh từ",
    meaning: "mùa xuân mới, năm mới: li rượu mừng tân xuân",
    example: "li rượu mừng tân xuân",
  },
  {
    word: "tân trang",
    part_of_speech: "động từ",
    meaning:
      "sửa sang, làm lại cho có vẻ như mới: tân trang nhà cửa * chiếc xe cũ mới được tân trang",
    example: "tân trang nhà cửa * chiếc xe cũ mới được tân trang",
  },
  {
    word: "tâng",
    part_of_speech: "động từ",
    meaning:
      "làm cho bật hoặc tung cao lên một cách nhẹ nhàng, mau lẹ: tâng bóng qua đầu thủ môn * nhảy tâng người lên cao",
    example: "tâng bóng qua đầu thủ môn * nhảy tâng người lên cao",
  },
  {
    word: "tâng",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) đề cao người nào đó (thường là ngay trước mặt người ấy) một cách quá mức: nói tâng nhau lên",
    example: "nói tâng nhau lên",
  },
  {
    word: "tân văn",
    part_of_speech: "danh từ",
    meaning: "(cũ) báo chí.",
    example: "ảnh tân văn và ảnh nghệ thuật",
  },
  {
    word: "tâng bốc",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nói hay, nói tốt hoặc đề cao người nào đó một cách quá đáng để lấy lòng: tâng bốc nhau * tính ưa được tâng bốc",
    example: "tâng bốc nhau * tính ưa được tâng bốc",
  },
  {
    word: "tâng công",
    part_of_speech: "động từ",
    meaning:
      "tự đề cao công lao của mình để trục lợi: báo cáo láo để tâng công",
    example: "báo cáo láo để tâng công",
  },
  {
    word: "tầng bậc",
    part_of_speech: "danh từ",
    meaning:
      "tầng và bậc theo trình tự nhất định (nói khái quát): các tầng bậc ngữ nghĩa của câu * cấu trúc tầng bậc",
    example: "các tầng bậc ngữ nghĩa của câu * cấu trúc tầng bậc",
  },
  {
    word: "tâng tâng",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả dáng vẻ bật lên rơi xuống một cách nhẹ nhàng, liên tiếp: quả bóng nảy tâng tâng",
    example: "quả bóng nảy tâng tâng",
  },
  {
    word: "tâng hẩng",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) chưng hửng: nghe ổng nói, mọi người đều tâng hẩng",
    example: "nghe ổng nói, mọi người đều tâng hẩng",
  },
  {
    word: "tầng lớp",
    part_of_speech: "danh từ",
    meaning:
      "lớp người sống cùng thời có địa vị và những lợi ích như nhau (nói khái quát): tầng lớp lao động nghèo * tầng lớp trí thức",
    example: "tầng lớp lao động nghèo * tầng lớp trí thức",
  },
  {
    word: "tầng nấc",
    part_of_speech: "danh từ",
    meaning:
      "các bước, các giai đoạn khác nhau trong một tiến trình công việc (nói khái quát): tầng nấc trung gian * việc đàm phán phải qua nhiều tầng nấc",
    example: "tầng nấc trung gian * việc đàm phán phải qua nhiều tầng nấc",
  },
  {
    word: "tầng ozone",
    part_of_speech: "danh từ",
    meaning:
      "lớp oxygen ở dạng phân tử O3 bọc quanh trái đất, có tác dụng bảo vệ sinh vật trên trái đất khỏi sự bức xạ của tia tử ngoại Mặt Trời: bảo vệ tầng ozone",
    example: "bảo vệ tầng ozone",
  },
  {
    word: "tấp",
    part_of_speech: "động từ",
    meaning:
      "trôi dạt vào, dồn lại thành đám nhiều và lộn xộn: rác rưởi tấp vào bờ",
    example: "rác rưởi tấp vào bờ",
  },
  {
    word: "tấp",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ, khẩu ngữ) tạt nhanh vào, ghé nhanh vào: xe tấp vô lề đường",
    example: "xe tấp vô lề đường",
  },
  {
    word: "tấp",
    part_of_speech: "động từ",
    meaning:
      "phủ kín thành nhiều tầng, nhiều lớp bằng cỏ rác hay rơm rạ: tấp rơm lên gốc để giữ ấm cho cây * cỏ khô tấp thành đống ở góc vườn",
    example:
      "tấp rơm lên gốc để giữ ấm cho cây * cỏ khô tấp thành đống ở góc vườn",
  },
  {
    word: "tập",
    part_of_speech: "danh từ",
    meaning:
      "chồng nhỏ giấy tờ, sổ sách, v.v. cùng loại: tập bản thảo * tập ảnh * báo xếp thành từng tập",
    example: "tập bản thảo * tập ảnh * báo xếp thành từng tập",
  },
  {
    word: "tập",
    part_of_speech: "danh từ",
    meaning:
      "phần làm thành từng cuốn riêng của một tác phẩm, có nội dung tương đối trọn vẹn: tập một của bộ tiểu thuyết * phim truyền hình nhiều tập",
    example: "tập một của bộ tiểu thuyết * phim truyền hình nhiều tập",
  },
  {
    word: "tập",
    part_of_speech: "danh từ",
    meaning:
      "cuốn sách gồm nhiều tác phẩm riêng biệt: mới in một tập thơ * tập truyện ngắn",
    example: "mới in một tập thơ * tập truyện ngắn",
  },
  {
    word: "tập",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ) vở: cuốn tập * tập học sinh",
    example: "cuốn tập * tập học sinh",
  },
  {
    word: "tập",
    part_of_speech: "động từ",
    meaning:
      "làm đi làm lại nhiều lần một việc gì đó để cho quen, cho thạo: tập võ * bé đang bập bẹ tập nói",
    example: "tập võ * bé đang bập bẹ tập nói",
  },
  {
    word: "tập ấm",
    part_of_speech: "động từ",
    meaning:
      "(cũ) được cấp hàm ấm sinh do cha ông là quan lại cao cấp: cha làm quan, con được tập ấm",
    example: "cha làm quan, con được tập ấm",
  },
  {
    word: "tập đoàn",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp những người có chung những quyền lợi kinh tế và địa vị xã hội, đối lập với những tập hợp người khác: tập đoàn thống trị",
    example: "tập đoàn thống trị",
  },
  {
    word: "tập đoàn",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp những người có cùng một nghề làm ăn chung với nhau, thường có quy mô không lớn lắm: tập đoàn đánh cá * tập đoàn sản xuất",
    example: "tập đoàn đánh cá * tập đoàn sản xuất",
  },
  {
    word: "tập đoàn",
    part_of_speech: "danh từ",
    meaning:
      "mô hình sản xuất, kinh doanh với quy mô lớn, có một hệ thống các công ti thành viên sản xuất nhiều sản phẩm khác nhau, nhằm mục đích đa dạng hoá các hoạt động kinh doanh và các nguồn lợi tức: các tập đoàn kinh tế * tập đoàn truyền thông đa quốc gia",
    example: "các tập đoàn kinh tế * tập đoàn truyền thông đa quốc gia",
  },
  {
    word: "tập đoàn",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp nhiều sinh vật cùng loại sống quây quần bên nhau: tập đoàn san hô * tập đoàn châu chấu",
    example: "tập đoàn san hô * tập đoàn châu chấu",
  },
  {
    word: "tập đại thành",
    part_of_speech: "danh từ",
    meaning:
      "kết quả của việc tập hợp những cái hay, cái đẹp tự cổ chí kim rồi đúc kết lại một cách có hệ thống: pho sách xứng đáng là một tập đại thành về văn hoá Việt Nam",
    example: "pho sách xứng đáng là một tập đại thành về văn hoá Việt Nam",
  },
  {
    word: "tập dượt",
    part_of_speech: "động từ",
    meaning:
      "tập đi tập lại các động tác hoặc bài bản cho thành thạo (nói khái quát): đội văn nghệ đang tích cực tập dượt",
    example: "đội văn nghệ đang tích cực tập dượt",
  },
  {
    word: "tập hậu",
    part_of_speech: "động từ",
    meaning:
      "đánh bất ngờ vào phía sau quân đối phương: đề phòng quân địch đánh tập hậu",
    example: "đề phòng quân địch đánh tập hậu",
  },
  {
    word: "tập kết",
    part_of_speech: "động từ",
    meaning:
      "(cán bộ, chiến sĩ hoạt động ở phía Nam vĩ tuyến 17, sau hiệp định Genève 1954) chuyển ra miền Bắc sống và tiếp tục hoạt động: cán bộ tập kết * đi tập kết",
    example: "cán bộ tập kết * đi tập kết",
  },
  {
    word: "tập kết",
    part_of_speech: "động từ",
    meaning:
      "tập hợp lại tại một khu vực: nơi tập kết hàng * các cánh quân đã ở vị trí tập kết",
    example: "nơi tập kết hàng * các cánh quân đã ở vị trí tập kết",
  },
  {
    word: "tập hợp",
    part_of_speech: "động từ",
    meaning:
      "(số đông người) tập trung, dồn từ nhiều chỗ, nhiều nơi khác nhau lại để cùng làm một việc gì: tập hợp lực lượng * người dân tập hợp ở quảng trường dự mít tinh",
    example: "tập hợp lực lượng * người dân tập hợp ở quảng trường dự mít tinh",
  },
  {
    word: "tập hợp",
    part_of_speech: "động từ",
    meaning:
      "lấy từ nhiều chỗ, nhiều nguồn khác nhau rồi gộp chung lại để làm việc gì: tập hợp ý kiến để xem xét * bài viết được tập hợp từ nhiều nguồn tư liệu",
    example:
      "tập hợp ý kiến để xem xét * bài viết được tập hợp từ nhiều nguồn tư liệu",
  },
  {
    word: "tập hợp",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ những cá thể có chung đặc trưng nào đó: tập hợp công nhân của nhà máy * tập hợp các số tự nhiên",
    example: "tập hợp công nhân của nhà máy * tập hợp các số tự nhiên",
  },
  {
    word: "tập họp",
    part_of_speech: "động từ",
    meaning: "họp lại, tụ tập lại: mọi người tập họp đông đủ",
    example: "mọi người tập họp đông đủ",
  },
  {
    word: "tập huấn",
    part_of_speech: "động từ",
    meaning:
      "huấn luyện, hướng dẫn nhằm nâng cao kĩ năng, nghiệp vụ: tập huấn cho cán bộ phụ trách Đoàn * lớp tập huấn ngắn hạn",
    example: "tập huấn cho cán bộ phụ trách Đoàn * lớp tập huấn ngắn hạn",
  },
  {
    word: "tập luyện",
    part_of_speech: "động từ",
    meaning: "như luyện tập: tập luyện thể thao để nâng cao sức khoẻ",
    example: "tập luyện thể thao để nâng cao sức khoẻ",
  },
  {
    word: "tấp nập",
    part_of_speech: "tính từ",
    meaning:
      "có rất nhiều người cùng qua lại, hoạt động không ngớt: đường phố tấp nập người qua lại",
    example: "đường phố tấp nập người qua lại",
  },
  {
    word: "tập kích",
    part_of_speech: "động từ",
    meaning:
      "đánh bất ngờ và bí mật, nhân lúc đối phương sơ hở: bộ đội đặc công tập kích sân bay địch * trận tập kích",
    example: "bộ đội đặc công tập kích sân bay địch * trận tập kích",
  },
  {
    word: "tập quán",
    part_of_speech: "danh từ",
    meaning:
      "thói quen hình thành từ lâu và đã trở thành nếp trong đời sống xã hội của một cộng đồng dân cư, được mọi người công nhận và làm theo: phong tục tập quán * tập quán văn hoá của người Việt Nam",
    example: "phong tục tập quán * tập quán văn hoá của người Việt Nam",
  },
  {
    word: "tập san",
    part_of_speech: "danh từ",
    meaning:
      "tạp chí nghiệp vụ của một ngành chuyên môn: tập san khoa học xã hội",
    example: "tập san khoa học xã hội",
  },
  {
    word: "tập nhiễm",
    part_of_speech: "động từ",
    meaning:
      "(cũ, hiếm) thấm vào, nhiễm vào (thường là cái không hay), rồi dần dần trở thành thói quen: tập nhiễm lối sống ăn chơi sa đoạ",
    example: "tập nhiễm lối sống ăn chơi sa đoạ",
  },
  {
    word: "tập quyền",
    part_of_speech: "động từ",
    meaning:
      "tập trung quyền hành (thường nói về thể chế chính trị); phân biệt với phân quyền: chế độ phong kiến tập quyền * nhà nước tập quyền",
    example: "chế độ phong kiến tập quyền * nhà nước tập quyền",
  },
  {
    word: "tập tễnh",
    part_of_speech: "tính từ",
    meaning:
      "(dáng đi) không cân, không đều, bên cao bên thấp, vẻ ngả nghiêng, dễ ngã: chân đau, bước đi tập tễnh",
    example: "chân đau, bước đi tập tễnh",
  },
  {
    word: "tập tễnh",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) bắt đầu tập làm việc gì đó, thường là không phù hợp với trình độ, khả năng, lối sống, v.v. (hàm ý châm biếm): tập tễnh làm thơ * mới tập tễnh vào nghề",
    example: "tập tễnh làm thơ * mới tập tễnh vào nghề",
  },
  {
    word: "tập tành",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tập đi tập lại nhiều lần cho thành thạo (nói khái quát): tập tành văn nghệ * tập tành công việc đồng áng",
    example: "tập tành văn nghệ * tập tành công việc đồng áng",
  },
  {
    word: "tập sự",
    part_of_speech: "động từ",
    meaning: "làm với tính chất học nghề: tập sự làm thầy thuốc * thợ tập sự",
    example: "tập sự làm thầy thuốc * thợ tập sự",
  },
  {
    word: "tập sự",
    part_of_speech: "động từ",
    meaning:
      "tập làm một thời gian cho quen việc trước khi được chính thức tuyển dụng: nhân viên tập sự",
    example: "nhân viên tập sự",
  },
  {
    word: "tập thể hoá",
    part_of_speech: "động từ",
    meaning:
      "chuyển đổi hình thức sản xuất từ cá thể trở thành tập thể: tập thể hoá tư liệu sản xuất",
    example: "tập thể hoá tư liệu sản xuất",
  },
  {
    word: "tấp tểnh",
    part_of_speech: "động từ",
    meaning:
      "có cử chỉ, điệu bộ lộ rõ ý muốn làm ngay việc gì đó khi thật ra chưa đủ điều kiện, chưa đến lúc (hàm ý chê bai): việc chưa xong đã tấp tểnh đi chơi",
    example: "việc chưa xong đã tấp tểnh đi chơi",
  },
  {
    word: "tấp tểnh",
    part_of_speech: "động từ",
    meaning: "như khấp khởi: tấp tểnh mừng thầm",
    example: "tấp tểnh mừng thầm",
  },
  {
    word: "tập thể dục",
    part_of_speech: "động từ",
    meaning: "thực hiện những động tác thể dục hằng ngày: tập thể dục đều đặn",
    example: "tập thể dục đều đặn",
  },
  {
    word: "tập tin",
    part_of_speech: "danh từ",
    meaning:
      "(vi tính) một tài liệu hoặc một tập hợp các thông tin có cùng cấu trúc được lưu giữ tại một địa chỉ trong bộ nhớ ngoài của máy tính (đĩa từ, băng từ) dưới một tên gọi duy nhất: tập tin hệ thống * chống sao chép tập tin",
    example: "tập tin hệ thống * chống sao chép tập tin",
  },
  {
    word: "tập tàng",
    part_of_speech: "tính từ",
    meaning:
      "(rau) lẫn lộn nhiều loại, thường là những loại mọc dại, dễ kiếm: rau tập tàng",
    example: "rau tập tàng",
  },
  {
    word: "tập thể",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp những người có mối quan hệ gắn bó như cùng sinh hoạt hoặc cùng làm việc chung với nhau: tập thể y bác sĩ * ý kiến của tập thể * lợi ích cá nhân gắn liền với lợi ích của tập thể",
    example:
      "tập thể y bác sĩ * ý kiến của tập thể * lợi ích cá nhân gắn liền với lợi ích của tập thể",
  },
  {
    word: "tập thể",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về tập thể, có tính chất tập thể: nhà ăn tập thể * tinh thần tập thể * môi trường làm việc tập thể",
    example: "nhà ăn tập thể * tinh thần tập thể * môi trường làm việc tập thể",
  },
  {
    word: "tập trận",
    part_of_speech: "động từ",
    meaning:
      "diễn tập quân sự, thường trên quy mô lớn: cuộc tập trận trên biển",
    example: "cuộc tập trận trên biển",
  },
  {
    word: "tập tính",
    part_of_speech: "danh từ",
    meaning:
      "đặc tính hoặc thói quen hoạt động có tính chất tự nhiên hay bản năng (nói tổng quát): tập tính thích ngược dòng nước của loài cá * tập tính tự vệ",
    example: "tập tính thích ngược dòng nước của loài cá * tập tính tự vệ",
  },
  {
    word: "tập tõng",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ, hiếm) như tập tọng: tập tõng làm thơ",
    example: "tập tõng làm thơ",
  },
  {
    word: "tập trung",
    part_of_speech: "động từ",
    meaning:
      "dồn vào một chỗ hoặc một điểm: tập trung đồ đạc vào một chỗ * mọi người đã tập trung đông đủ",
    example: "tập trung đồ đạc vào một chỗ * mọi người đã tập trung đông đủ",
  },
  {
    word: "tập trung",
    part_of_speech: "động từ",
    meaning:
      "dồn sức hoạt động, hướng các hoạt động vào một việc gì: tập trung tư tưởng * tập trung giải quyết đơn từ tồn đọng",
    example: "tập trung tư tưởng * tập trung giải quyết đơn từ tồn đọng",
  },
  {
    word: "tập tọng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) vụng về, lúng túng vì còn chưa thành thạo do mới học, mới biết qua ít nhiều: tập tọng đánh vần * mới tập tọng học nghề",
    example: "tập tọng đánh vần * mới tập tọng học nghề",
  },
  {
    word: "tật",
    part_of_speech: "danh từ",
    meaning:
      "trạng thái không bình thường ở bộ phận cơ thể (thường không chữa được), do bẩm sinh hoặc do tai nạn hay bệnh gây ra: tật nói lắp * bị đánh đến thành tật",
    example: "tật nói lắp * bị đánh đến thành tật",
  },
  {
    word: "tật",
    part_of_speech: "danh từ",
    meaning: "(cũ) bệnh: thuốc đắng dã tật (tng)",
    example: "thuốc đắng dã tật (tng)",
  },
  {
    word: "tật",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) trạng thái không được bình thường ở vật liệu, dụng cụ, máy móc, ít nhiều gây khó khăn nhất định cho người sử dụng: chiếc xe có tật hay chết máy giữa chừng",
    example: "chiếc xe có tật hay chết máy giữa chừng",
  },
  {
    word: "tật",
    part_of_speech: "danh từ",
    meaning:
      "thói quen, thường là xấu và khó sửa: thói hư tật xấu * sinh tật cờ bạc * lắm tài nhiều tật",
    example: "thói hư tật xấu * sinh tật cờ bạc * lắm tài nhiều tật",
  },
  {
    word: "tập tục",
    part_of_speech: "danh từ",
    meaning:
      "phong tục và tập quán (nói khái quát): những tập tục về cưới xin * nghi lễ được tiến hành theo tập tục cổ truyền",
    example:
      "những tập tục về cưới xin * nghi lễ được tiến hành theo tập tục cổ truyền",
  },
  {
    word: "tất bật",
    part_of_speech: "tính từ",
    meaning:
      "vội vàng và luôn tay luôn chân vì quá bận bịu, vất vả: dáng đi tất bật * tất bật ngược xuôi để lo công việc",
    example: "dáng đi tất bật * tất bật ngược xuôi để lo công việc",
  },
  {
    word: "tất cả",
    part_of_speech: "đại từ",
    meaning:
      "từ dùng để chỉ số lượng toàn bộ, không trừ một ai, cái gì hay điều gì: thưa tất cả bà con! * tất cả đều tán thành * làm tất cả mọi việc",
    example: "thưa tất cả bà con! * tất cả đều tán thành * làm tất cả mọi việc",
  },
  {
    word: "tập vở",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) vở (để viết; nói khái quát): sắm sửa tập vở để đến trường",
    example: "sắm sửa tập vở để đến trường",
  },
  {
    word: "tất",
    part_of_speech: "danh từ",
    meaning: "(Khẩu ngữ) bít tất (nói tắt): chân đi tất",
    example: "chân đi tất",
  },
  {
    word: "tất",
    part_of_speech: "đại từ",
    meaning:
      "(Khẩu ngữ) tất cả (nói tắt): còn bao nhiêu cho tất * tự làm tất mọi việc",
    example: "còn bao nhiêu cho tất * tự làm tất mọi việc",
  },
  {
    word: "tất",
    part_of_speech: "phụ từ",
    meaning: "như ắt: đã hứa tất sẽ làm * nóng vội tất sẽ hỏng việc",
    example: "đã hứa tất sẽ làm * nóng vội tất sẽ hỏng việc",
  },
  {
    word: "tật bệnh",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như bệnh tật: người khoẻ mạnh, không có tật bệnh gì",
    example: "người khoẻ mạnh, không có tật bệnh gì",
  },
  {
    word: "tất nhiên",
    part_of_speech: "tính từ",
    meaning:
      "đương nhiên phải như vậy, không thể khác được: lẽ tất nhiên * muốn tiến bộ, tất nhiên phải cố gắng",
    example: "lẽ tất nhiên * muốn tiến bộ, tất nhiên phải cố gắng",
  },
  {
    word: "tất tả",
    part_of_speech: "tính từ",
    meaning:
      "(dáng đi) vội vàng, lật đật, trông có vẻ vất vả: tất tả ngược xuôi * mọi người tất tả đi tìm",
    example: "tất tả ngược xuôi * mọi người tất tả đi tìm",
  },
  {
    word: "tất tần tật",
    part_of_speech: "đại từ",
    meaning:
      "(khẩu ngữ) như tất tật (nhưng ý nhấn mạnh hơn): cộng tất tần tật các khoản",
    example: "cộng tất tần tật các khoản",
  },
  {
    word: "tật nguyền",
    part_of_speech: "danh từ",
    meaning:
      "tật tương đối lớn, nghiêm trọng và ảnh hưởng đến đời sống (nói khái quát): vượt lên tật nguyền",
    example: "vượt lên tật nguyền",
  },
  {
    word: "tật nguyền",
    part_of_speech: "tính từ",
    meaning: "như tàn tật: đứa con tật nguyền",
    example: "đứa con tật nguyền",
  },
  {
    word: "tất niên",
    part_of_speech: "danh từ",
    meaning:
      "lúc sắp hết năm cũ, chuẩn bị đón năm mới: bữa cơm tất niên * cúng tất niên",
    example: "bữa cơm tất niên * cúng tất niên",
  },
  {
    word: "tất tật",
    part_of_speech: "đại từ",
    meaning:
      "(khẩu ngữ) tất cả, không trừ lại ai, cái gì: làm tất tật mọi việc trong nhà * đồ đạc trong nhà đã ra đi tất tật",
    example:
      "làm tất tật mọi việc trong nhà * đồ đạc trong nhà đã ra đi tất tật",
  },
  {
    word: "tất thảy",
    part_of_speech: "đại từ",
    meaning:
      "(hiếm) như tất cả (nhưng thường chỉ nói về người): tất thảy mọi người đều đi * ông cụ có tất thảy 6 người con",
    example: "tất thảy mọi người đều đi * ông cụ có tất thảy 6 người con",
  },
  {
    word: "tất thắng",
    part_of_speech: "động từ",
    meaning:
      "nhất định sẽ chiến thắng, không thể khác được: niềm tin tất thắng",
    example: "niềm tin tất thắng",
  },
  {
    word: "tất yếu",
    part_of_speech: "tính từ",
    meaning:
      "hiển nhiên phải như thế, không thể khác được (thường nói về những cái diễn ra có tính quy luật): xã hội hoá giáo dục là một xu thế tất yếu * kết cục tất yếu",
    example: "xã hội hoá giáo dục là một xu thế tất yếu * kết cục tất yếu",
  },
  {
    word: "tất yếu",
    part_of_speech: "tính từ",
    meaning:
      "không thể thiếu, nhất thiết phải có thì mới có được một kết quả, một tác dụng nào đó: điều kiện tất yếu * vốn là một yêu cầu tất yếu để sản xuất",
    example: "điều kiện tất yếu * vốn là một yêu cầu tất yếu để sản xuất",
  },
  {
    word: "tâu",
    part_of_speech: "động từ",
    meaning: "(cũ) trình với vua chúa hoặc hoàng hậu: tâu lên vua",
    example: "tâu lên vua",
  },
  {
    word: "tâu",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) mách với người trên để tâng công (hàm ý chê): tâu với cấp trên",
    example: "tâu với cấp trên",
  },
  {
    word: "tậu",
    part_of_speech: "động từ",
    meaning:
      "mua vật gì có giá trị tương đối lớn để dùng lâu dài: tậu nhà * tậu mấy sào ruộng * vừa tậu được con xe mới",
    example: "tậu nhà * tậu mấy sào ruộng * vừa tậu được con xe mới",
  },
  {
    word: "tấu",
    part_of_speech: "động từ",
    meaning: "(cũ, văn chương) tâu với vua: tiền trảm hậu tấu (tng)",
    example: "tiền trảm hậu tấu (tng)",
  },
  {
    word: "tấu",
    part_of_speech: "danh từ",
    meaning: "tờ trình dâng lên vua: dâng tấu",
    example: "dâng tấu",
  },
  {
    word: "tấu",
    part_of_speech: "động từ",
    meaning: "biểu diễn một bản nhạc trước công chúng: tấu đàn bầu",
    example: "tấu đàn bầu",
  },
  {
    word: "tấu",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) biểu diễn một bài độc tấu: tiết mục tấu",
    example: "tiết mục tấu",
  },
  {
    word: "tất tưởi",
    part_of_speech: "tính từ",
    meaning: "như tất tả: nghe tin dữ, tất tưởi chạy về * dáng đi tất tưởi",
    example: "nghe tin dữ, tất tưởi chạy về * dáng đi tất tưởi",
  },
  {
    word: "tẩu",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng để hút thuốc phiện, thuốc lá sợi, có hình một ống nhỏ và dài, đầu gắn thông với bộ phận giống như cái phễu nhỏ để bỏ thuốc vào: miệng ngậm tẩu",
    example: "miệng ngậm tẩu",
  },
  {
    word: "tẩu",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ, hiếm) chạy trốn: bị phát hiện, tên trộm tìm đường tẩu",
    example: "bị phát hiện, tên trộm tìm đường tẩu",
  },
  {
    word: "tẩu",
    part_of_speech: "động từ",
    meaning:
      "đem giấu nhanh đi nơi khác: thấy động, bọn chúng đã tẩu số hàng lậu",
    example: "thấy động, bọn chúng đã tẩu số hàng lậu",
  },
  {
    word: "tầy",
    part_of_speech: "tính từ",
    meaning: "(hiếm) bằng đầu, không nhọn: gậy đầu tầy, đầu nhọn",
    example: "gậy đầu tầy, đầu nhọn",
  },
  {
    word: "tẩu tán",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) chạy tản nhanh ra nhiều nơi để trốn: bị thua trận, đám tàn quân tẩu tán vào rừng",
    example: "bị thua trận, đám tàn quân tẩu tán vào rừng",
  },
  {
    word: "tẩu tán",
    part_of_speech: "động từ",
    meaning:
      "phân tán nhanh đi nhiều nơi để cất giấu: tẩu tán tài sản * tẩu tán tang vật",
    example: "tẩu tán tài sản * tẩu tán tang vật",
  },
  {
    word: "tẩu thoát",
    part_of_speech: "động từ",
    meaning: "chạy trốn thoát, không để bị bắt giữ: tìm đường tẩu thoát",
    example: "tìm đường tẩu thoát",
  },
  {
    word: "tẩy",
    part_of_speech: "danh từ",
    meaning:
      "quân bài được úp sấp để giấu kín dưới đáy đĩa, cho biết sau cùng, quyết định thắng thua trong ván bài ích xì; thường dùng (trong khẩu ngữ) để chỉ mưu đồ xấu xa được che giấu kĩ: đoán trúng tẩy * lật tẩy * lộ tẩy",
    example: "đoán trúng tẩy * lật tẩy * lộ tẩy",
  },
  {
    word: "tẩy",
    part_of_speech: "động từ",
    meaning:
      "làm cho mất đi các chất bám sâu, ăn sâu vào, thường bằng tác dụng hoá học của một chất nhất định, để cho sạch, cho trắng ra hoặc cho mất đi mùi vị: tẩy vết mực bám trên giấy * chất tẩy màu * tẩy trắng chiếc áo",
    example: "tẩy vết mực bám trên giấy * chất tẩy màu * tẩy trắng chiếc áo",
  },
  {
    word: "tẩy",
    part_of_speech: "động từ",
    meaning:
      "dùng thuốc tống thứ có hại ra khỏi ruột: thuốc tẩy giun * tẩy ruột",
    example: "thuốc tẩy giun * tẩy ruột",
  },
  {
    word: "tẩy",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng làm bằng cao su dùng để tẩy vết mực, vết bẩn trên giấy: cục tẩy * bút chì có tẩy",
    example: "cục tẩy * bút chì có tẩy",
  },
  {
    word: "tây",
    part_of_speech: "danh từ",
    meaning:
      "một trong bốn phương chính, ở về phía mặt trời lặn, đối diện với phương đông: gió tây * mặt trời lặn đằng tây",
    example: "gió tây * mặt trời lặn đằng tây",
  },
  {
    word: "tây",
    part_of_speech: "danh từ",
    meaning:
      "(thường viết hoa) phần đất của thế giới, nằm về phía tây châu Âu; thường dùng (trong khẩu ngữ) để chỉ các nước ở phương Tây nói chung: nền văn minh phương Tây * đi Tây * sống bên Tây",
    example: "nền văn minh phương Tây * đi Tây * sống bên Tây",
  },
  {
    word: "tây",
    part_of_speech: "tính từ",
    meaning:
      "theo kiểu phương Tây, hoặc có nguồn gốc từ phương Tây; đối lập với ta: quần tây * thuốc tây * táo tây * tết tây",
    example: "quần tây * thuốc tây * táo tây * tết tây",
  },
  {
    word: "tây",
    part_of_speech: "tính từ",
    meaning:
      '(cũ, vch, hiếm) riêng tư: niềm tây * "Nồi ai thời nấy muốn đầy, Của chung thời lấy, của tây thời dành." (TNNL)',
    example:
      'niềm tây * "Nồi ai thời nấy muốn đầy, Của chung thời lấy, của tây thời dành." (TNNL)',
  },
  {
    word: "tẩy chay",
    part_of_speech: "động từ",
    meaning:
      "không hưởng ứng, không tham gia, không có quan hệ nữa, để tỏ thái độ phản đối: chơi xấu, bị bạn bè tẩy chay",
    example: "chơi xấu, bị bạn bè tẩy chay",
  },
  {
    word: "tây cung",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, hiếm) nơi phi tần ở, về phía tây trong cung vua; cũng dùng để chỉ phi tần: say đắm tây cung",
    example: "say đắm tây cung",
  },
  {
    word: "tẩy rửa",
    part_of_speech: "động từ",
    meaning:
      "làm cho thật sạch bằng dung dịch hoá chất và nước (nói khái quát): chất tẩy rửa * khu phòng mổ được tẩy rửa sạch sẽ",
    example: "chất tẩy rửa * khu phòng mổ được tẩy rửa sạch sẽ",
  },
  {
    word: "tẩy rửa",
    part_of_speech: "động từ",
    meaning: "như gột rửa: tẩy rửa bụi trần",
    example: "tẩy rửa bụi trần",
  },
  {
    word: "tầy đình",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (chuyện, việc) lớn lắm, có thể có hậu quả rất nghiêm trọng: chuyện tày đình * tội to tày đình",
    example: "chuyện tày đình * tội to tày đình",
  },
  {
    word: "tấy",
    part_of_speech: "động từ",
    meaning:
      "(mụn nhọt, vết thương) đang cương to, làm cho đau nhức nhối: vết thương bị tấy lên",
    example: "vết thương bị tấy lên",
  },
  {
    word: "tây học",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm, thường viết hoa) nền học vấn, học thuật phương Tây, trong quan hệ đối lập với nho học, thời trước: theo tây học",
    example: "theo tây học",
  },
  {
    word: "tây thiên",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) phía trời về phương tây: "Hàn gia ở mé tây thiên, Dưới dòng nước chảy, bên trên có cầu." (TKiều)',
    example:
      'Hàn gia ở mé tây thiên, Dưới dòng nước chảy, bên trên có cầu." (TKiều)',
  },
  {
    word: "tẩy trần",
    part_of_speech: "động từ",
    meaning:
      '(cũ, văn chương) rửa sạch bụi bặm; dùng để nói việc thết tiệc mừng người đi xa mới đến hay mới về: "Tẩy trần vui chén thong dong, Nỗi lòng, ai ở trong lòng mà ra?" (TKiều)',
    example:
      'Tẩy trần vui chén thong dong, Nỗi lòng, ai ở trong lòng mà ra?" (TKiều)',
  },
  {
    word: "tẩy rửa tiền",
    part_of_speech: "động từ",
    meaning:
      "rửa tiền (nói khái quát): thủ đoạn tẩy rửa tiền của bọn tội phạm quốc tế",
    example: "thủ đoạn tẩy rửa tiền của bọn tội phạm quốc tế",
  },
  {
    word: "tẩy trang",
    part_of_speech: "động từ",
    meaning: "làm sạch các chất đã hoá trang: kem tẩy trang",
    example: "kem tẩy trang",
  },
  {
    word: "tẩy trừ",
    part_of_speech: "động từ",
    meaning:
      "xoá bỏ, làm cho mất sạch đi cái xấu, cái có hại nào đó: tẩy trừ nạn tham ô * tẩy trừ văn hoá đồi truỵ",
    example: "tẩy trừ nạn tham ô * tẩy trừ văn hoá đồi truỵ",
  },
  {
    word: "tầy trời",
    part_of_speech: "tính từ",
    meaning:
      "(chuyện, việc) hết sức lớn và có những hậu quả không sao lường hết được: tội ác tày trời * làm những chuyện tày trời đồng tày đình",
    example: "tội ác tày trời * làm những chuyện tày trời",
  },
  {
    word: "tây vị",
    part_of_speech: "động từ",
    meaning: "(cũ, hiếm) như thiên vị: đối xử công bằng, không tây vị ai hết",
    example: "đối xử công bằng, không tây vị ai hết",
  },
  {
    word: "tẩy uế",
    part_of_speech: "động từ",
    meaning:
      "làm cho sạch mọi nhơ bẩn hoặc mầm mống gây bệnh: tẩy uế chuồng trại",
    example: "tẩy uế chuồng trại",
  },
  {
    word: "tẩy xoá",
    part_of_speech: "động từ",
    meaning:
      "xoá và tẩy sạch đi (nói khái quát): bài viết có nhiều vết tẩy xoá * tránh tẩy xoá trong bài thi",
    example: "bài viết có nhiều vết tẩy xoá * tránh tẩy xoá trong bài thi",
  },
  {
    word: "tây y",
    part_of_speech: "danh từ",
    meaning:
      "y học các nước phương Tây; phân biệt với đông y: đông tây y kết hợp",
    example: "đông tây y kết hợp",
  },
  {
    word: "tè",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) đái (thường nói về trẻ em): bé tè dầm",
    example: "bé tè dầm",
  },
  {
    word: "tè",
    part_of_speech: "tính từ",
    meaning:
      "thấp, lùn quá mức, trông mất cân đối: người lùn tè * căn nhà thấp tè",
    example: "người lùn tè * căn nhà thấp tè",
  },
  {
    word: "tẽ",
    part_of_speech: "động từ",
    meaning: "làm cho rời ra, tách ra: tẽ ngô * tẽ đôi ống nứa",
    example: "tẽ ngô * tẽ đôi ống nứa",
  },
  {
    word: "tẽ",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) rẽ (theo đường khác, hướng khác): đến ngã ba thì tẽ phải",
    example: "đến ngã ba thì tẽ phải",
  },
  {
    word: "té",
    part_of_speech: "động từ",
    meaning:
      "dùng lòng bàn tay hắt nước từng ít một lên chỗ nào đó: té nước tưới hoa * té nước theo mưa (tng)",
    example: "té nước tưới hoa * té nước theo mưa (tng)",
  },
  {
    word: "té",
    part_of_speech: "động từ",
    meaning:
      "(Phương ngữ) đổ vãi ra một ít: nước té ra ngoài thùng * đổ không cẩn thận, gạo té hết ra sân",
    example: "nước té ra ngoài thùng * đổ không cẩn thận, gạo té hết ra sân",
  },
  {
    word: "té",
    part_of_speech: "động từ",
    meaning:
      '(Nam) ngã (chỉ dùng cho người): té u đầu * "Mặc dầu cha đánh mẹ treo, Đứt dây té xuống cũng theo chung tình." (ca dao)',
    example:
      'té u đầu * "Mặc dầu cha đánh mẹ treo, Đứt dây té xuống cũng theo chung tình." (ca dao)',
  },
  {
    word: "tẻ",
    part_of_speech: "danh từ",
    meaning:
      "giống lúa cho thứ gạo hạt nhỏ và dài, khi nấu có ít nhựa, thường dùng để thổi cơm ăn hằng ngày: thóc tẻ * cơm tẻ",
    example: "thóc tẻ * cơm tẻ",
  },
  {
    word: "tẻ",
    part_of_speech: "tính từ",
    meaning:
      "(một số loại ngũ cốc, quả cây hoặc thực phẩm) hơi cứng, hơi khô hoặc không được ngon như bình thường; phân biệt với nếp: ngô tẻ * dừa tẻ * gan tẻ",
    example: "ngô tẻ * dừa tẻ * gan tẻ",
  },
  {
    word: "tẻ",
    part_of_speech: "tính từ",
    meaning:
      'buồn, chán do vắng vẻ: có người nói chuyện cho đỡ tẻ * "Tẻ, vui cũng một kiếp người, Hồng nhan phải giống ở đời mãi ru!" (TKiều)',
    example:
      'có người nói chuyện cho đỡ tẻ * "Tẻ, vui cũng một kiếp người, Hồng nhan phải giống ở đời mãi ru!" (TKiều)',
  },
  {
    word: "tẻ",
    part_of_speech: "tính từ",
    meaning:
      "không có sức hấp dẫn, chẳng có gì lôi cuốn do đơn điệu, thiếu sinh khí: buổi liên hoan hơi tẻ * vở kịch diễn tẻ quá",
    example: "buổi liên hoan hơi tẻ * vở kịch diễn tẻ quá",
  },
  {
    word: "te",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ đan bằng tre, giống như cái nhủi, dùng để xúc bắt tôm cá: đi đánh te",
    example: "đi đánh te",
  },
  {
    word: "te",
    part_of_speech: "động từ",
    meaning:
      'xúc bắt tôm cá bằng cái te: te cá trên sông * "Mặc ai lưới, mặc ai te, Ta cứ thủng thỉnh kéo bè nghênh ngang." (Cdao)',
    example:
      'te cá trên sông * "Mặc ai lưới, mặc ai te, Ta cứ thủng thỉnh kéo bè nghênh ngang." (Cdao)',
  },
  {
    word: "tẻ lạnh",
    part_of_speech: "tính từ",
    meaning:
      "buồn tẻ tới mức gây cảm giác lạnh lẽo: đón tiếp tẻ lạnh * bầu không khí tẻ lạnh",
    example: "đón tiếp tẻ lạnh * bầu không khí tẻ lạnh",
  },
  {
    word: "tẻ nhạt",
    part_of_speech: "tính từ",
    meaning:
      "tẻ và nhạt nhẽo (nói khái quát): công việc tẻ nhạt * sống một cuộc đời tẻ nhạt",
    example: "công việc tẻ nhạt * sống một cuộc đời tẻ nhạt",
  },
  {
    word: "tẻ ngắt",
    part_of_speech: "tính từ",
    meaning:
      "hoàn toàn không có lấy một chút sinh khí, sức lôi cuốn nào, khiến hết sức buồn chán: câu chuyện tẻ ngắt * trời mưa, phố sá tẻ ngắt",
    example: "câu chuyện tẻ ngắt * trời mưa, phố sá tẻ ngắt",
  },
  {
    word: "té ngửa",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) ngã ngửa: nghe nói lại mới té ngửa ra",
    example: "nghe nói lại mới té ngửa ra",
  },
  {
    word: "tè he",
    part_of_speech: "tính từ",
    meaning:
      "(cách ngồi) gập đầu gối lại, hai chân xếp quặt ra đằng sau: ngồi xếp tè he",
    example: "ngồi xếp tè he",
  },
  {
    word: "té ra",
    part_of_speech: "",
    meaning: "(khẩu ngữ) như hoá ra: té ra anh đã biết chuyện rồi?",
    example: "té ra anh đã biết chuyện rồi?",
  },
  {
    word: "te te",
    part_of_speech: "động từ",
    meaning:
      "từ mô phỏng tiếng gà gáy với âm vang cao và liên hồi: gà gáy te te",
    example: "gà gáy te te",
  },
  {
    word: "te te",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (dáng đi, chạy) liền một mạch với vẻ nhanh nhẹn, sốt sắng: chạy te te",
    example: "chạy te te",
  },
  {
    word: "té tát",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (mắng, chửi) dồn dập, tới tấp, ví như tát nước vào mặt: mắng té tát * chửi té tát vào mặt",
    example: "mắng té tát * chửi té tát vào mặt",
  },
  {
    word: "téc",
    part_of_speech: "danh từ",
    meaning:
      "thùng lớn, có nắp kín để chứa chất lỏng như dầu, nước: téc nước * xe chở téc",
    example: "téc nước * xe chở téc",
  },
  {
    word: "te tái",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có dáng vẻ nhanh nhảu, vội vã: te tái bước đi * te tái chạy trước dẫn đường",
    example: "te tái bước đi * te tái chạy trước dẫn đường",
  },
  {
    word: "te tua",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) ở trạng thái rách tua ra thành nhiều mảnh, nhiều miếng nhỏ dài: ống quần te tua",
    example: "ống quần te tua",
  },
  {
    word: "te tét",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) rách đến mức không còn hình thù gì nữa: quần áo bị gai cào, rách te tét",
    example: "quần áo bị gai cào, rách te tét",
  },
  {
    word: "tém",
    part_of_speech: "động từ",
    meaning:
      "thu, dồn lại một chỗ cho gọn: tóc chải tém ra phía sau * tém gọn đống thóc vào một chỗ",
    example: "tóc chải tém ra phía sau * tém gọn đống thóc vào một chỗ",
  },
  {
    word: "tém",
    part_of_speech: "động từ",
    meaning:
      "nhét các mép chăn, màn xuống để cho phủ kín hoặc gọn gàng hơn: tém màn cho kĩ kẻo muỗi vào * tém gọn góc chăn cho bé",
    example: "tém màn cho kĩ kẻo muỗi vào * tém gọn góc chăn cho bé",
  },
  {
    word: "tem",
    part_of_speech: "danh từ",
    meaning:
      "(cũng tem thư) mảnh giấy nhỏ do bưu điện phát hành, thường hình chữ nhật, có in tranh ảnh và giá tiền, dùng để dán lên các bưu phẩm để làm chứng từ cước phí: con tem * sưu tập tem",
    example: "con tem * sưu tập tem",
  },
  {
    word: "tem",
    part_of_speech: "danh từ",
    meaning:
      "mảnh giấy nhỏ hình chữ nhật trông giống như tem thư, do nhà nước phát hành, dùng để dán vào một số giấy tờ chính thức hoặc hàng hoá để chứng nhận đã nộp thuế hoặc lệ phí: tem nhập khẩu * sách có dán tem chống giả",
    example: "tem nhập khẩu * sách có dán tem chống giả",
  },
  {
    word: "tem",
    part_of_speech: "danh từ",
    meaning:
      "nhãn hiệu dán trên các mặt hàng để chứng nhận phẩm chất: hàng chưa bóc tem (còn mới nguyên, chưa sử dụng)",
    example: "hàng chưa bóc tem (còn mới nguyên, chưa sử dụng)",
  },
  {
    word: "tem",
    part_of_speech: "danh từ",
    meaning:
      "mảnh giấy nhỏ giống như tem thư, do nhà nước phát hành, có giá trị để mua hàng hoá cung cấp theo định lượng (trong thời bao cấp trước đây): tem lương thực * thời kì tem phiếu",
    example: "tem lương thực * thời kì tem phiếu",
  },
  {
    word: "tem thư",
    part_of_speech: "danh từ",
    meaning:
      "(cũng tem thư) mảnh giấy nhỏ do bưu điện phát hành, thường hình chữ nhật, có in tranh ảnh và giá tiền, dùng để dán lên các bưu phẩm để làm chứng từ cước phí: con tem * sưu tập tem",
    example: "con tem * sưu tập tem",
  },
  {
    word: "tem thư",
    part_of_speech: "danh từ",
    meaning:
      "mảnh giấy nhỏ hình chữ nhật trông giống như tem thư, do nhà nước phát hành, dùng để dán vào một số giấy tờ chính thức hoặc hàng hoá để chứng nhận đã nộp thuế hoặc lệ phí: tem nhập khẩu * sách có dán tem chống giả",
    example: "tem nhập khẩu * sách có dán tem chống giả",
  },
  {
    word: "tem thư",
    part_of_speech: "danh từ",
    meaning:
      "nhãn hiệu dán trên các mặt hàng để chứng nhận phẩm chất: hàng chưa bóc tem (còn mới nguyên, chưa sử dụng)",
    example: "hàng chưa bóc tem (còn mới nguyên, chưa sử dụng)",
  },
  {
    word: "tem thư",
    part_of_speech: "danh từ",
    meaning:
      "mảnh giấy nhỏ giống như tem thư, do nhà nước phát hành, có giá trị để mua hàng hoá cung cấp theo định lượng (trong thời bao cấp trước đây): tem lương thực * thời kì tem phiếu",
    example: "tem lương thực * thời kì tem phiếu",
  },
  {
    word: "tèm lem",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) lem luốc: mặt mũi tèm lem",
    example: "mặt mũi tèm lem",
  },
  {
    word: "tèm nhèm",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như tẹp nhẹp: chuyện tèm nhèm, không thèm chấp",
    example: "chuyện tèm nhèm, không thèm chấp",
  },
  {
    word: "teng beng",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ, khẩu ngữ) (rách) tả tơi, tanh bành, không còn ra hình thù gì nữa: cái nón rách teng beng * xé teng beng áo quần",
    example: "cái nón rách teng beng * xé teng beng áo quần",
  },
  {
    word: "tẽn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ngượng, xấu hổ trước mọi người vì bị hớ hay bị nhầm một cách bất ngờ: tẽn mặt * bị tẽn vì nhầm người nọ ra người kia",
    example: "tẽn mặt * bị tẽn vì nhầm người nọ ra người kia",
  },
  {
    word: "ten-nít",
    part_of_speech: "danh từ",
    meaning:
      "môn thể thao hai hoặc bốn người chơi, dùng vợt có cán dài, đánh quả bóng nhỏ qua lại trên lưới căng ở giữa sân: chơi quần vợt * sân quần vợt",
    example: "chơi quần vợt * sân quần vợt",
  },
  {
    word: "tẽn tò",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) tẽn (nói khái quát): tẽn tò vì pha trò mà chẳng ai cười",
    example: "tẽn tò vì pha trò mà chẳng ai cười",
  },
  {
    word: "ten",
    part_of_speech: "",
    meaning: "(phương ngữ) (đồng, thau) gỉ: ten đồng * mâm đồng nổi ten",
    example: "ten đồng * mâm đồng nổi ten",
  },
  {
    word: "tennis",
    part_of_speech: "danh từ",
    meaning:
      "môn thể thao hai hoặc bốn người chơi, dùng vợt có cán dài, đánh quả bóng nhỏ qua lại trên lưới căng ở giữa sân: chơi quần vợt * sân quần vợt",
    example: "chơi quần vợt * sân quần vợt",
  },
  {
    word: "teo",
    part_of_speech: "động từ",
    meaning:
      "thu nhỏ lại, bé dần lại, thường do tác động bất lợi nào đó: teo cơ * ống chân teo nhỏ",
    example: "teo cơ * ống chân teo nhỏ",
  },
  {
    word: "tẹo",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) lượng hết sức nhỏ, quá ít ỏi, coi như không đáng kể: xin một tẹo muối * tẹo nữa thì đi",
    example: "xin một tẹo muối * tẹo nữa thì đi",
  },
  {
    word: "tẹo",
    part_of_speech: "tính từ",
    meaning: "quá nhỏ, quá ít: người bé tẹo",
    example: "người bé tẹo",
  },
  {
    word: "teo tóp",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ở trạng thái bị teo nhỏ lại và trở nên nhăn nheo, xấu xí: chân tay teo tóp * người hắn teo tóp lại vì đói",
    example: "chân tay teo tóp * người hắn teo tóp lại vì đói",
  },
  {
    word: "tẻo teo",
    part_of_speech: "tính từ",
    meaning:
      '(hiếm) quá nhỏ bé đến mức như không đáng kể: hạt cát tẻo teo * "Ao thu lạnh lẽo nước trong veo, Một chiếc thuyền câu bé tẻo teo." (NgKhuyến; 3)',
    example:
      'hạt cát tẻo teo * "Ao thu lạnh lẽo nước trong veo, Một chiếc thuyền câu bé tẻo teo." (NgKhuyến; 3)',
  },
  {
    word: "tẹp nhẹp",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) nhỏ nhen, vụn vặt đến mức đáng coi thường: làm ăn tẹp nhẹp * toàn những việc tẹp nhẹp",
    example: "làm ăn tẹp nhẹp * toàn những việc tẹp nhẹp",
  },
  {
    word: "tép riu",
    part_of_speech: "danh từ",
    meaning: "tép loại nhỏ, chuyên sống bám trong rong rêu: mớ tép riu",
    example: "mớ tép riu",
  },
  {
    word: "tép riu",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) loại, hạng người hèn kém, nhỏ bé, coi như không đáng kể: hạng tép riu * chấp gì cái bọn tép riu ấy",
    example: "hạng tép riu * chấp gì cái bọn tép riu ấy",
  },
  {
    word: "tetanos",
    part_of_speech: "danh từ",
    meaning: "uốn ván: tiêm phòng tetanos",
    example: "tiêm phòng tetanos",
  },
  {
    word: "tẹt",
    part_of_speech: "tính từ",
    meaning:
      "không nhô cao như thường thấy, mà như bị ép sát xuống: thấp tẹt * mũi tẹt",
    example: "thấp tẹt * mũi tẹt",
  },
  {
    word: "tẹt",
    part_of_speech: "động từ",
    meaning: "(Ít dùng) như xẹp (ng1): nhọt đã tẹt",
    example: "nhọt đã tẹt",
  },
  {
    word: "tép",
    part_of_speech: "danh từ",
    meaning:
      "động vật thân giáp, nhỏ hơn tôm và không có càng: tép kho dưa * mắm tép",
    example: "tép kho dưa * mắm tép",
  },
  {
    word: "tép",
    part_of_speech: "danh từ",
    meaning:
      '(phương ngữ, khẩu ngữ) tôm, cá nhỏ nói chung: "Công anh xúc tép nuôi cò, Cò ăn cò lớn cò dò lên cây." (ca dao)',
    example: 'Công anh xúc tép nuôi cò, Cò ăn cò lớn cò dò lên cây." (ca dao)',
  },
  {
    word: "tép",
    part_of_speech: "tính từ",
    meaning: "thuộc loại nhỏ: pháo tép * nứa tép",
    example: "pháo tép * nứa tép",
  },
  {
    word: "tép",
    part_of_speech: "danh từ",
    meaning: "sợi nhỏ mọng nước trong múi của một số quả: tép bưởi * tép chanh",
    example: "tép bưởi * tép chanh",
  },
  {
    word: "tép",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) nhánh nhỏ: bóc mấy tép tỏi",
    example: "bóc mấy tép tỏi",
  },
  {
    word: "tép",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) gói nhỏ chứa một lượng heroin nhất định, thường cho một lần sử dụng: tép heroin",
    example: "tép heroin",
  },
  {
    word: "tét",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) cắt bánh bằng sợi dây vòng qua rồi kéo thẳng ra: tét bánh chưng",
    example: "tét bánh chưng",
  },
  {
    word: "tét",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) rách hoặc đứt dọc ra thành đường dài: đánh nhau tét đầu chảy máu",
    example: "đánh nhau tét đầu chảy máu",
  },
  {
    word: "tê dại",
    part_of_speech: "tính từ",
    meaning:
      "tê đến mức hầu như mất hết cảm giác và khả năng hoạt động bình thường: chân tay tê dại",
    example: "chân tay tê dại",
  },
  {
    word: "tề tựu",
    part_of_speech: "động từ",
    meaning:
      "đến từ nhiều nơi và tập trung đông đủ: con cháu đã tề tựu đông đủ",
    example: "con cháu đã tề tựu đông đủ",
  },
  {
    word: "tề",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) chính quyền ở làng xã vùng bị chiếm đóng trong thời kì Việt Nam kháng chiến chống Pháp, chống Mĩ: xây bốt lập tề * phá tề",
    example: "xây bốt lập tề * phá tề",
  },
  {
    word: "tề",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) vùng bị chiếm đóng, có lập tề: làng tề",
    example: "làng tề",
  },
  {
    word: "tề",
    part_of_speech: "động từ",
    meaning:
      "chặt, cắt bớt phần so le để cho bằng, cho đều nhau: tề tranh cho thẳng để lợp nhà * tề ngọn chổi tre",
    example: "tề tranh cho thẳng để lợp nhà * tề ngọn chổi tre",
  },
  {
    word: "tề",
    part_of_speech: "đại từ",
    meaning:
      '(phương ngữ) kìa: hắn đó tề! * "Trăng lên đến đó rồi tề, Nói răng thì nói anh về kẻo khuya." (ca dao)',
    example:
      'hắn đó tề! * "Trăng lên đến đó rồi tề, Nói răng thì nói anh về kẻo khuya." (ca dao)',
  },
  {
    word: "tệ hại",
    part_of_speech: "danh từ",
    meaning:
      "cái có tác dụng gây hại lớn cho con người, cho xã hội: gây rất nhiều tệ hại",
    example: "gây rất nhiều tệ hại",
  },
  {
    word: "tệ hại",
    part_of_speech: "tính từ",
    meaning:
      "quá tệ và có tác dụng gây những tổn thất lớn: một hành động tệ hại * tình hình ngày càng tệ hại",
    example: "một hành động tệ hại * tình hình ngày càng tệ hại",
  },
  {
    word: "tệ hại",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ, hiếm) quá đáng lắm, không thể hình dung nổi: xấu tệ hại * đường sá bẩn tệ hại",
    example: "xấu tệ hại * đường sá bẩn tệ hại",
  },
  {
    word: "tề gia",
    part_of_speech: "động từ",
    meaning: "(cũ) trông nom và chăm sóc việc gia đình: việc tề gia",
    example: "việc tề gia",
  },
  {
    word: "tễ",
    part_of_speech: "danh từ",
    meaning: "thuốc đông y được bào chế thành những viên tròn, nhỏ: thuốc tễ",
    example: "thuốc tễ",
  },
  {
    word: "tệ nạn",
    part_of_speech: "danh từ",
    meaning:
      "thói quen xấu tương đối phổ biến trong xã hội, có tác hại rất lớn: tệ nạn xã hội * ngăn chặn tệ nạn mại dâm",
    example: "tệ nạn xã hội * ngăn chặn tệ nạn mại dâm",
  },
  {
    word: "tế bần",
    part_of_speech: "động từ",
    meaning:
      "(cũ) cứu giúp người nghèo khổ (một việc làm từ thiện thời trước): hội tế bần * lớn lên ở trại tế bần",
    example: "hội tế bần * lớn lên ở trại tế bần",
  },
  {
    word: "tê",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái mất hết cảm giác ở một bộ phận nào đó của cơ thể: thuốc gây tê * ngồi lâu, hai chân tê cứng",
    example: "thuốc gây tê * ngồi lâu, hai chân tê cứng",
  },
  {
    word: "tê",
    part_of_speech: "đại từ",
    meaning: "(Phương ngữ) kia: bên ni bên tê",
    example: "bên ni bên tê",
  },
  {
    word: "tệ tục",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) tục lệ xấu, cổ hủ, không còn phù hợp với xã hội đương thời: tệ tục ăn uống ở chốn đình trung",
    example: "tệ tục ăn uống ở chốn đình trung",
  },
  {
    word: "tệ bạc",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra không còn nhớ gì đến ơn nghĩa, không giữ trọn tình nghĩa trước sau (nói khái quát): đối xử tệ bạc * con người tệ bạc",
    example: "đối xử tệ bạc * con người tệ bạc",
  },
  {
    word: "tê liệt",
    part_of_speech: "tính từ",
    meaning:
      "(bộ phận cơ thể) ở trạng thái mất hết mọi cảm giác và khả năng hoạt động: tê liệt toàn thân",
    example: "tê liệt toàn thân",
  },
  {
    word: "tê liệt",
    part_of_speech: "tính từ",
    meaning:
      "ở tình trạng mất hoàn toàn khả năng hoạt động: hệ thống điện đài bị tê liệt * lũ lụt làm giao thông đường sắt bị tê liệt hoàn toàn",
    example:
      "hệ thống điện đài bị tê liệt * lũ lụt làm giao thông đường sắt bị tê liệt hoàn toàn",
  },
  {
    word: "tetracycline",
    part_of_speech: "danh từ",
    meaning:
      "tên một loại thuốc kháng sinh: uống tetracycline để chống nhiễm trùng",
    example: "uống tetracycline để chống nhiễm trùng",
  },
  {
    word: "tê tái",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái bị tác động quá mạnh của một cảm giác, cảm xúc đau đớn, khó chịu nào đó, đến mức làm cho như không còn có khả năng cảm giác, cảm xúc gì khác nữa: rét tê tái * buồn tê tái",
    example: "rét tê tái * buồn tê tái",
  },
  {
    word: "tế độ",
    part_of_speech: "động từ",
    meaning:
      'cứu vớt chúng sinh ra khỏi bể khổ, theo đạo Phật: "Đánh liều nhắn một hai lời, Nhờ tay tế độ vớt người trầm luân." (TKiều)',
    example:
      'Đánh liều nhắn một hai lời, Nhờ tay tế độ vớt người trầm luân." (TKiều)',
  },
  {
    word: "tế",
    part_of_speech: "động từ",
    meaning:
      "cúng dâng lễ vật theo nghi thức trọng thể, thường có đọc bài văn và có chiêng trống: lễ tế trời * lạy như tế sao",
    example: "lễ tế trời * lạy như tế sao",
  },
  {
    word: "tế",
    part_of_speech: "động từ",
    meaning:
      "(ngựa hoặc trâu bò) phi nước đại hoặc chạy lồng lên: tế ngựa như bay * trâu tế",
    example: "tế ngựa như bay * trâu tế",
  },
  {
    word: "tế",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) mắng chửi ầm ĩ: làm thế để nó tế cho à? * bị tế cho một trận",
    example: "làm thế để nó tế cho à? * bị tế cho một trận",
  },
  {
    word: "tệ",
    part_of_speech: "danh từ",
    meaning:
      "thói quen xấu và có hại, hình thành tương đối phổ biến trong xã hội: xoá bỏ tệ cờ bạc, rượu chè * tệ quan liêu",
    example: "xoá bỏ tệ cờ bạc, rượu chè * tệ quan liêu",
  },
  {
    word: "tệ",
    part_of_speech: "tính từ",
    meaning:
      "không tốt, không có tình nghĩa trong quan hệ đối xử: xử tệ với nhau * thằng cha tệ lắm!",
    example: "xử tệ với nhau * thằng cha tệ lắm!",
  },
  {
    word: "tệ",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) kém, tồi: làm ăn ngày càng tệ",
    example: "làm ăn ngày càng tệ",
  },
  {
    word: "tệ",
    part_of_speech: "phụ từ",
    meaning: "(khẩu ngữ) quá, lắm: ngoan tệ! * càng ngày càng xấu tệ!",
    example: "ngoan tệ! * càng ngày càng xấu tệ!",
  },
  {
    word: "tệ",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) nhân dân tệ (nói tắt): tiêu hết mấy nghìn tệ",
    example: "tiêu hết mấy nghìn tệ",
  },
  {
    word: "tê mê",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái tạm thời mất hết cảm giác và ý thức do chịu một tác động nào đó: sướng đến tê mê * có cảm giác tê mê",
    example: "sướng đến tê mê * có cảm giác tê mê",
  },
  {
    word: "tế nhị",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra khéo léo, nhã nhặn trong cách ứng xử, biết chú ý đến cả những điểm rất nhỏ thường dễ bị bỏ qua: từ chối một cách tế nhị * lời nói thiếu tế nhị * tế nhị không nhắc lại chuyện cũ",
    example:
      "từ chối một cách tế nhị * lời nói thiếu tế nhị * tế nhị không nhắc lại chuyện cũ",
  },
  {
    word: "tế nhị",
    part_of_speech: "tính từ",
    meaning:
      "có những tình tiết tinh tế, sâu kín thường khó nói ra hoặc không tiện nói ra được: một cái nhìn hết sức tế nhị * vấn đề tế nhị * lí do tế nhị",
    example: "một cái nhìn hết sức tế nhị * vấn đề tế nhị * lí do tế nhị",
  },
  {
    word: "tế bào",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị cơ sở của sự sống, cấu tạo nên cơ thể sinh vật, có khả năng trao đổi, sinh trưởng và phân hoá: tế bào não * cấy ghép tế bào * gia đình là tế bào của xã hội",
    example: "tế bào não * cấy ghép tế bào * gia đình là tế bào của xã hội",
  },
  {
    word: "tê tê",
    part_of_speech: "danh từ",
    meaning:
      "thú cỡ trung bình, mõm nhọn, không có răng, chân thấp, thân có lớp vảy sừng phủ kín, hay đào hang trong đất để ăn kiến, mối, khi gặp nguy hiểm thường cuộn tròn mình lại rất chặt: vảy tê tê",
    example: "vảy tê tê",
  },
  {
    word: "tế lễ",
    part_of_speech: "động từ",
    meaning: "làm lễ tế (nói khái quát): đồ tế lễ",
    example: "đồ tế lễ",
  },
  {
    word: "tê giác",
    part_of_speech: "danh từ",
    meaning:
      "thú có guốc, chân có ba ngón, da dày, có một hoặc hai sừng mọc trên mũi, sống ở rừng: sừng tê giác là một loại dược liệu quý",
    example: "sừng tê giác là một loại dược liệu quý",
  },
  {
    word: "tế tự",
    part_of_speech: "động từ",
    meaning: "(cũ) thờ cúng, tế lễ nói chung: tế tự tổ tiên",
    example: "tế tự tổ tiên",
  },
  {
    word: "tên",
    part_of_speech: "danh từ",
    meaning:
      "đoạn tre hoặc gỗ dài, mảnh, một đầu nhọn, có thể có ngạnh, được phóng đi bằng cung, nỏ để sát thương: bị trúng tên",
    example: "bị trúng tên",
  },
  {
    word: "tên",
    part_of_speech: "danh từ",
    meaning:
      "từ hoặc nhóm từ dùng để chỉ một cá nhân, cá thể nhằm phân biệt với những cá nhân, cá thể khác: tên phố * tên làng * đặt tên cho con",
    example: "tên phố * tên làng * đặt tên cho con",
  },
  {
    word: "tên",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng cá nhân thuộc hạng bị coi thường, coi khinh: tên cướp * tên lưu manh",
    example: "tên cướp * tên lưu manh",
  },
  {
    word: "tếch",
    part_of_speech: "động từ",
    meaning: "(thông tục) bỏ đi, chuồn đi: thằng sở khanh đã tếch mất",
    example: "thằng sở khanh đã tếch mất",
  },
  {
    word: "tê-tơ-ra-xi-lin",
    part_of_speech: "danh từ",
    meaning:
      "tên một loại thuốc kháng sinh: uống tetracycline để chống nhiễm trùng",
    example: "uống tetracycline để chống nhiễm trùng",
  },
  {
    word: "tê-ta-nốt",
    part_of_speech: "danh từ",
    meaning: "uốn ván: tiêm phòng tetanos",
    example: "tiêm phòng tetanos",
  },
  {
    word: "tên cúng cơm",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) tên thật (của người đã chết), dùng để khấn khi cúng giỗ: réo cả tên cúng cơm của người ta ra mà chửi",
    example: "réo cả tên cúng cơm của người ta ra mà chửi",
  },
  {
    word: "têm",
    part_of_speech: "động từ",
    meaning:
      "làm thành miếng trầu để ăn, bằng cách quệt vôi lên lá trầu rồi gấp cuốn lại (theo hình thù nhất định) và gài chặt bằng cọng lá: trầu têm cánh phượng",
    example: "trầu têm cánh phượng",
  },
  {
    word: "tên hiệu",
    part_of_speech: "danh từ",
    meaning:
      "tên tồn tại bên cạnh tên vốn có, do người trí thức thời phong kiến tự đặt thêm cho mình (thường là một từ ngữ Hán-Việt có ý nghĩa): Ức Trai là tên hiệu của Nguyễn Trãi",
    example: "Ức Trai là tên hiệu của Nguyễn Trãi",
  },
  {
    word: "tên lửa",
    part_of_speech: "danh từ",
    meaning:
      "vật chứa chất cháy gây ra một phản lực cực lớn, dùng để đẩy đi rất xa một viên đạn hoặc một vật chở nào đó (tàu vũ trụ, máy thám không, v.v.): bệ phóng tên lửa * tên lửa vượt đại châu",
    example: "bệ phóng tên lửa * tên lửa vượt đại châu",
  },
  {
    word: "tên miền",
    part_of_speech: "danh từ",
    meaning:
      "tên được sử dụng để định danh các địa chỉ Internet, thường bắt đầu bằng www, tiếp theo là tên đăng kí (của cá nhân, cơ quan), sau nữa là tên viết tắt tượng trưng cho các loại hoạt động (com: thương mại; edu: giáo dục; gov: cơ quan chính phủ; org: các tổ chức, v.v.) hoặc tên nước (vn: Việt Nam; uk: Anh; us: Mĩ; fr: Pháp, v.v.): đăng kí tên miền",
    example: "đăng kí tên miền",
  },
  {
    word: "tên riêng",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi của từng cá nhân, cá thể riêng rẽ, phân biệt với những cá nhân, cá thể khác cùng loại: viết hoa các tên riêng",
    example: "viết hoa các tên riêng",
  },
  {
    word: "tên tục",
    part_of_speech: "danh từ",
    meaning:
      "tên do cha mẹ đặt cho lúc mới sinh, thường xấu xí, chỉ dùng để gọi khi còn nhỏ nhằm tránh sự chú ý, quấy phá của ma quỷ, theo quan niệm cũ: lôi cả tên tục ra mà chửi",
    example: "lôi cả tên tục ra mà chửi",
  },
  {
    word: "tênh tênh",
    part_of_speech: "tính từ",
    meaning:
      "rất nhẹ, đến mức có cảm giác như không có một chút sức nặng nào: chiếc va li nhẹ tênh tênh",
    example: "chiếc va li nhẹ tênh tênh",
  },
  {
    word: "tênh",
    part_of_speech: "phụ từ",
    meaning: "đến mức như cảm thấy hoàn toàn trống không: nhẹ tênh * buồn tênh",
    example: "nhẹ tênh * buồn tênh",
  },
  {
    word: "tềnh toàng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) đơn sơ, trống trải, vẻ tạm bợ: nhà cửa tuềnh toàng, chẳng có gì đáng giá",
    example: "nhà cửa tuềnh toàng, chẳng có gì đáng giá",
  },
  {
    word: "tềnh toàng",
    part_of_speech: "tính từ",
    meaning:
      "(tính người) đơn giản và dễ dãi đến mức thiếu cẩn thận, thiếu chu đáo: tính nết tuềnh toàng * ăn mặc đơn giản đến mức tuềnh toàng",
    example: "tính nết tuềnh toàng * ăn mặc đơn giản đến mức tuềnh toàng",
  },
  {
    word: "tên tự",
    part_of_speech: "danh từ",
    meaning:
      "tên đặt bằng từ Hán-Việt và thường dựa theo nghĩa của tên vốn có, thường phổ biến trong giới trí thức thời trước: Thân Nhân Trung tên tự là Hậu Phủ",
    example: "Thân Nhân Trung tên tự là Hậu Phủ",
  },
  {
    word: "tênh hênh",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái phơi bày ra một cách hớ hênh, lộ liễu, thiếu kín đáo, thiếu ý tứ: nhà cửa để tênh hênh, không khoá * nằm tênh hênh giữa nhà",
    example: "nhà cửa để tênh hênh, không khoá * nằm tênh hênh giữa nhà",
  },
  {
    word: "tết",
    part_of_speech: "danh từ",
    meaning:
      "ngày lễ lớn hằng năm, thường có cúng lễ, vui chơi, hội hè, theo truyền thống dân tộc: tết Hàn Thực * tết Trung Thu",
    example: "tết Hàn Thực * tết Trung Thu",
  },
  {
    word: "tết",
    part_of_speech: "danh từ",
    meaning:
      "(thường viết hoa) Tết Nguyên Đán (nói tắt): gói bánh chưng ngày Tết * đi chúc Tết * báo Tết",
    example: "gói bánh chưng ngày Tết * đi chúc Tết * báo Tết",
  },
  {
    word: "tết",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) biếu quà nhân dịp tết: đi tết bố mẹ vợ * tết thầy một cành hoa đào",
    example: "đi tết bố mẹ vợ * tết thầy một cành hoa đào",
  },
  {
    word: "tết",
    part_of_speech: "động từ",
    meaning:
      "đan, bện bằng cách thắt nhiều sợi lại với nhau thành dây dài hoặc thành hình vật gì: tết tóc đuôi sam * con cào cào tết bằng lá dừa",
    example: "tết tóc đuôi sam * con cào cào tết bằng lá dừa",
  },
  {
    word: "tệp",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) xấp: tệp tiền * một tệp giấy",
    example: "tệp tiền * một tệp giấy",
  },
  {
    word: "tệp",
    part_of_speech: "danh từ",
    meaning: "tập tin: đổi tên tệp",
    example: "đổi tên tệp",
  },
  {
    word: "tên tuổi",
    part_of_speech: "danh từ",
    meaning: "tên và tuổi (nói khái quát): ghi rõ tên tuổi, quê quán",
    example: "ghi rõ tên tuổi, quê quán",
  },
  {
    word: "tên tuổi",
    part_of_speech: "danh từ",
    meaning:
      "tên của một người được nhiều người biết đến và kính trọng: một nhà văn có tên tuổi * ca sĩ không tên tuổi",
    example: "một nhà văn có tên tuổi * ca sĩ không tên tuổi",
  },
  {
    word: "tệp tin",
    part_of_speech: "danh từ",
    meaning:
      "(vi tính) một tài liệu hoặc một tập hợp các thông tin có cùng cấu trúc được lưu giữ tại một địa chỉ trong bộ nhớ ngoài của máy tính (đĩa từ, băng từ) dưới một tên gọi duy nhất: tập tin hệ thống * chống sao chép tập tin",
    example: "tập tin hệ thống * chống sao chép tập tin",
  },
  {
    word: "tết nhất",
    part_of_speech: "danh từ",
    meaning:
      "ngày tết, về mặt là dịp nghỉ ngơi, vui chơi, sum họp trong một năm (nói khái quát): tết nhất đến nơi mà chưa sắm sửa được gì",
    example: "tết nhất đến nơi mà chưa sắm sửa được gì",
  },
  {
    word: "tếu táo",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) tỏ ra quá tếu, không được nghiêm túc: ăn nói tếu táo * tếu táo một lúc cho vui",
    example: "ăn nói tếu táo * tếu táo một lúc cho vui",
  },
  {
    word: "tha",
    part_of_speech: "động từ",
    meaning:
      "(con vật) mang đi bằng cách ngậm chặt ở miệng hoặc mỏ: chó tha khúc xương * kiến tha lâu cũng đầy tổ (tng)",
    example: "chó tha khúc xương * kiến tha lâu cũng đầy tổ (tng)",
  },
  {
    word: "tha",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) mang theo, lôi theo bên mình một cách lôi thôi, nhếch nhác: tha cái của nợ ấy về làm gì * đi đâu cũng tha con theo",
    example: "tha cái của nợ ấy về làm gì * đi đâu cũng tha con theo",
  },
  {
    word: "tha",
    part_of_speech: "động từ",
    meaning:
      "thả người bị bắt giữ, cho được tự do: tha cho những tù nhân cải tạo tốt * tù mới được tha",
    example: "tha cho những tù nhân cải tạo tốt * tù mới được tha",
  },
  {
    word: "tha",
    part_of_speech: "động từ",
    meaning:
      "bỏ qua cho hoặc miễn cho, không trách cứ hoặc trừng phạt nữa: tha cho tội chết * trẻ không tha, già không thương (tng)",
    example: "tha cho tội chết * trẻ không tha, già không thương (tng)",
  },
  {
    word: "tếu",
    part_of_speech: "tính từ",
    meaning:
      "có cử chỉ, lời nói vui nhộn, cố tình gây cười một cách nghịch ngợm, nhiều khi thiếu nghiêm chỉnh: kể chuyện tếu * đùa tếu * tính anh chàng rất tếu",
    example: "kể chuyện tếu * đùa tếu * tính anh chàng rất tếu",
  },
  {
    word: "thá",
    part_of_speech: "danh từ",
    meaning:
      "(thông tục) thứ, loại (thường nói với ý khinh miệt): mày chẳng là cái thá gì hết!",
    example: "mày chẳng là cái thá gì hết!",
  },
  {
    word: "thà",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra dù biết rõ là không hay nhưng vẫn sẵn sàng chấp nhận cốt để tránh một điều không muốn khác (để nhấn mạnh tính chất hoàn toàn không thể chấp nhận được của điều khác đó): biết thế này, thà ở nhà cho xong * thà chết chứ không chịu làm nô lệ",
    example:
      "biết thế này, thà ở nhà cho xong * thà chết chứ không chịu làm nô lệ",
  },
  {
    word: "thả",
    part_of_speech: "động từ",
    meaning:
      "không giữ lại một chỗ nữa mà để cho được tự do hoạt động: thả gà ra vườn * thả thuyền trôi theo dòng nước * không có chứng cứ nên được thả tự do",
    example:
      "thả gà ra vườn * thả thuyền trôi theo dòng nước * không có chứng cứ nên được thả tự do",
  },
  {
    word: "thả",
    part_of_speech: "động từ",
    meaning:
      "cho vào môi trường thích hợp để có thể tự do hoạt động hoặc phát triển: thả diều * đào ao thả cá",
    example: "thả diều * đào ao thả cá",
  },
  {
    word: "thả",
    part_of_speech: "động từ",
    meaning:
      "để cho tự bay lên hoặc rơi thẳng xuống, nhằm mục đích nhất định: thả bom * thả bóng bay * thả hai ống quần xuống",
    example: "thả bom * thả bóng bay * thả hai ống quần xuống",
  },
  {
    word: "thả cửa",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (làm việc gì) hết sức tự do, thoải mái, không tự kiềm chế và cũng không bị ai hay cái gì kìm hãm hay ngăn cản: ăn chơi thả cửa * tiêu xài thả cửa",
    example: "ăn chơi thả cửa * tiêu xài thả cửa",
  },
  {
    word: "thả bộ",
    part_of_speech: "động từ",
    meaning: "đi bộ một cách thong thả và thoải mái: thả bộ trên vỉa hè",
    example: "thả bộ trên vỉa hè",
  },
  {
    word: "thả giàn",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ, khẩu ngữ) như thả cửa: rượu uống thả giàn",
    example: "rượu uống thả giàn",
  },
  {
    word: "tha bổng",
    part_of_speech: "động từ",
    meaning:
      "tha hẳn, không truy cứu hay kết án gì cả sau khi đã xét xử: được tha bổng ngay sau phiên toà",
    example: "được tha bổng ngay sau phiên toà",
  },
  {
    word: "tha hồ",
    part_of_speech: "phụ từ",
    meaning:
      "(làm việc gì) một cách hoàn toàn thoải mái theo ý muốn, không hề bị hạn chế, ngăn trở: nghỉ hè, tha hồ đi chơi * mai rỗi thì tha hồ mà ngủ",
    example: "nghỉ hè, tha hồ đi chơi * mai rỗi thì tha hồ mà ngủ",
  },
  {
    word: "tha hồ",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) rất, hết mức: đến đấy thì tha hồ vui! * chiếc áo ấy thì tha hồ mà ấm",
    example: "đến đấy thì tha hồ vui! * chiếc áo ấy thì tha hồ mà ấm",
  },
  {
    word: "tha hoá",
    part_of_speech: "động từ",
    meaning:
      "(con người) đánh mất dần phẩm chất đạo đức, trở nên xấu xa, tồi tệ: một cán bộ tha hoá * bị đồng tiền làm cho tha hoá",
    example: "một cán bộ tha hoá * bị đồng tiền làm cho tha hoá",
  },
  {
    word: "tha hoá",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) biến chất và trở nên xấu hẳn đi, hoặc trở thành một cái khác đối nghịch lại: ruộng đất để tha hoá",
    example: "ruộng đất để tha hoá",
  },
  {
    word: "tha hương",
    part_of_speech: "danh từ",
    meaning:
      'nơi xa lạ không phải quê hương mình, nhưng buộc phải sinh sống ở đó: "Tấc lòng cố quốc tha hương, Đường kia, nỗi nọ, ngổn ngang bời bời." (TKiều)',
    example:
      'Tấc lòng cố quốc tha hương, Đường kia, nỗi nọ, ngổn ngang bời bời." (TKiều)',
  },
  {
    word: "tha hương",
    part_of_speech: "động từ",
    meaning:
      "phải rời bỏ quê hương, đi đến nơi xa lạ để sinh sống: tha hương nơi đất khách quê người",
    example: "tha hương nơi đất khách quê người",
  },
  {
    word: "thà là",
    part_of_speech: "kết từ",
    meaning: "(khẩu ngữ) như thà: thà là chịu khổ chứ không quỵ luỵ ai",
    example: "thà là chịu khổ chứ không quỵ luỵ ai",
  },
  {
    word: "thả lỏng",
    part_of_speech: "động từ",
    meaning:
      "để cho các cơ bắp được hoàn toàn tự nhiên, thoải mái, không có một biểu hiện dùng sức hay căng cứng nào cả, dù rất nhỏ: thả lỏng toàn thân",
    example: "thả lỏng toàn thân",
  },
  {
    word: "thả lỏng",
    part_of_speech: "động từ",
    meaning:
      "để cho được tự do làm gì thì làm, hoàn toàn không có sự bó buộc hay ngăn cản: thả lỏng cho bộ hạ làm bậy",
    example: "thả lỏng cho bộ hạ làm bậy",
  },
  {
    word: "thả lỏng",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) không giam giữ, quản lí nữa, để cho được tự do, nhưng vẫn ngầm chịu một sự giám sát nhất định: thả lỏng một chính trị phạm",
    example: "thả lỏng một chính trị phạm",
  },
  {
    word: "tha ma",
    part_of_speech: "danh từ",
    meaning:
      "bãi đất hoang rộng dành để chôn người chết: bãi tha ma * khu vườn hẻo lánh tựa tha ma",
    example: "bãi tha ma * khu vườn hẻo lánh tựa tha ma",
  },
  {
    word: "tha phương cầu thực",
    part_of_speech: "",
    meaning:
      "bỏ quê hương để đi tìm kế sinh nhai ở nơi xa lạ: bỏ làng đi tha phương cầu thực",
    example: "bỏ làng đi tha phương cầu thực",
  },
  {
    word: "thả phanh",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ, khẩu ngữ) như thả cửa: ăn chơi thả phanh * cười thả phanh",
    example: "ăn chơi thả phanh * cười thả phanh",
  },
  {
    word: "thả nổi",
    part_of_speech: "động từ",
    meaning:
      "để mặc cho tự do hoạt động, phát triển một cách tự nhiên theo mọi diễn biến bất thường tuỳ theo tình hình (thường nói về hiện tượng kinh tế): thả nổi giá cả * thả nổi tỉ giá giữa đồng nội tệ với đồng dollar",
    example: "thả nổi giá cả * thả nổi tỉ giá giữa đồng nội tệ với đồng dollar",
  },
  {
    word: "tha phương",
    part_of_speech: "",
    meaning:
      'như tha hương: sống tha phương * "Cô hồn nhờ gửi tha phương, Gió trăng hiu hắt lửa hương lạnh lùng." (CH)',
    example:
      'sống tha phương * "Cô hồn nhờ gửi tha phương, Gió trăng hiu hắt lửa hương lạnh lùng." (CH)',
  },
  {
    word: "thà rằng",
    part_of_speech: "kết từ",
    meaning:
      '(khẩu ngữ) như thà: "Thà rằng chẳng biết thì thôi, Biết ra thêm một khúc nhôi bộn bề." (ca dao)',
    example:
      'Thà rằng chẳng biết thì thôi, Biết ra thêm một khúc nhôi bộn bề." (ca dao)',
  },
  {
    word: "thả sức",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như thả cửa: thả sức ăn uống",
    example: "thả sức ăn uống",
  },
  {
    word: "tha thiết",
    part_of_speech: "tính từ",
    meaning:
      "(tình cảm) thắm thiết làm cho gắn bó hết lòng, luôn luôn nghĩ đến, quan tâm đến: yêu tha thiết * lời lẽ tha thiết",
    example: "yêu tha thiết * lời lẽ tha thiết",
  },
  {
    word: "tha thiết",
    part_of_speech: "tính từ",
    meaning:
      "rất cấp thiết đối với mình và hết sức mong mỏi được đáp ứng: nguyện vọng tha thiết * lời cầu xin tha thiết",
    example: "nguyện vọng tha thiết * lời cầu xin tha thiết",
  },
  {
    word: "tha thẩn",
    part_of_speech: "tính từ",
    meaning:
      "(đi) thong thả và lặng lẽ từ chỗ này đến chỗ nọ, có vẻ như không chú ý gì đến việc mình đang ở đâu và đang đi đâu: bé chơi tha thẩn ở ngoài sân * đi tha thẩn trong làng",
    example: "bé chơi tha thẩn ở ngoài sân * đi tha thẩn trong làng",
  },
  {
    word: "tha thứ",
    part_of_speech: "động từ",
    meaning:
      "tha cho, bỏ qua cho, không trách cứ hoặc trừng phạt nữa: tha thứ cho đứa con bất hiếu * cầu xin tha thứ",
    example: "tha thứ cho đứa con bất hiếu * cầu xin tha thứ",
  },
  {
    word: "thác loạn",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái hỗn loạn và quay cuồng, không còn theo nền nếp, trật tự bình thường: lối sống thác loạn * ăn chơi thác loạn",
    example: "lối sống thác loạn * ăn chơi thác loạn",
  },
  {
    word: "tha thướt",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như thướt tha: tà áo dài tha thướt",
    example: "tà áo dài tha thướt",
  },
  {
    word: "thác",
    part_of_speech: "danh từ",
    meaning:
      "chỗ dòng sông, dòng suối chảy vượt qua một vách đá cao nằm chắn ngang rồi đổ mạnh xuống: vượt thác * lên thác xuống ghềnh",
    example: "vượt thác * lên thác xuống ghềnh",
  },
  {
    word: "thác",
    part_of_speech: "động từ",
    meaning:
      "bịa ra lí do, viện cớ để né tránh hoặc từ chối việc gì: thác ốm để nghỉ * nói thác",
    example: "thác ốm để nghỉ * nói thác",
  },
  {
    word: "thác",
    part_of_speech: "động từ",
    meaning:
      '(cũ, văn chương) chết: "Sống làm vợ khắp người ta, Khéo thay thác xuống làm ma không chồng!" (TKiều)',
    example:
      'Sống làm vợ khắp người ta, Khéo thay thác xuống làm ma không chồng!" (TKiều)',
  },
  {
    word: "thạch bàn",
    part_of_speech: "danh từ",
    meaning: "(cũ) tảng đá có mặt phẳng: ngồi trên thạch bàn",
    example: "ngồi trên thạch bàn",
  },
  {
    word: "thách",
    part_of_speech: "động từ",
    meaning:
      "nói kích nhằm làm cho người khác dám làm một việc gì đó có tính chất khó khăn, hoặc dám đối đầu hay thi tài với mình: thách đấu kiếm * có thách cũng chả dám",
    example: "thách đấu kiếm * có thách cũng chả dám",
  },
  {
    word: "thách",
    part_of_speech: "động từ",
    meaning:
      "đưa ra mức giá hoặc yêu cầu cao hơn hẳn so với bình thường: nói giá bán, không nói thách * thách cưới",
    example: "nói giá bán, không nói thách * thách cưới",
  },
  {
    word: "thách",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) bật mạnh thân mình lên cao một cách đột ngột: nhảy thách lên mà chửi",
    example: "nhảy thách lên mà chửi",
  },
  {
    word: "thách đố",
    part_of_speech: "động từ",
    meaning:
      "đố làm được điều gì đó, thường với vẻ thách thức vì cho là khó có thể làm nổi (nói khái quát): nói như thế, quá bằng thách đố nhau!",
    example: "nói như thế, quá bằng thách đố nhau!",
  },
  {
    word: "thách thức",
    part_of_speech: "",
    meaning:
      "thách làm điều gì (nói khái quát): thách thức thi đấu * đưa ra những thách thức",
    example: "thách thức thi đấu * đưa ra những thách thức",
  },
  {
    word: "thạch lựu",
    part_of_speech: "danh từ",
    meaning:
      "cây nhỏ, lá mọc đối, hoa màu đỏ, quả chứa nhiều hạt mọng nước, ăn được, vỏ rễ dùng làm thuốc: quả lựu",
    example: "quả lựu",
  },
  {
    word: "thạch lựu",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ, khẩu ngữ) lựu đạn (nói tắt): ném lựu",
    example: "ném lựu",
  },
  {
    word: "thải",
    part_of_speech: "động từ",
    meaning:
      "bỏ đi cái không cần thiết, cái không có giá trị hay không còn tác dụng nữa: một số chất được thải ra ngoài cơ thể qua mồ hôi * nhà máy thải bớt thợ",
    example:
      "một số chất được thải ra ngoài cơ thể qua mồ hôi * nhà máy thải bớt thợ",
  },
  {
    word: "thai",
    part_of_speech: "danh từ",
    meaning:
      "cơ thể sống đang hình thành và lớn lên trong bụng mẹ: có thai * phòng khám thai * xác định tuổi thai",
    example: "có thai * phòng khám thai * xác định tuổi thai",
  },
  {
    word: "thái",
    part_of_speech: "động từ",
    meaning:
      "cắt (vật mềm) thành miếng mỏng hoặc nhỏ bằng dao: thái thịt * sắn thái lát",
    example: "thái thịt * sắn thái lát",
  },
  {
    word: "thái cực",
    part_of_speech: "danh từ",
    meaning:
      "trạng thái trời đất khi chưa phân chia, khi vũ trụ còn hỗn mang, theo quan niệm triết học xưa của phương Đông.",
    example: "hai thái cực của một vấn đề * hai người ở hai thái cực khác nhau",
  },
  {
    word: "thái bình",
    part_of_speech: "tính từ",
    meaning:
      "(đất nước, đời sống) yên ổn, không có loạn lạc, chiến tranh: thiên hạ thái bình",
    example: "thiên hạ thái bình",
  },
  {
    word: "thái cổ",
    part_of_speech: "tính từ",
    meaning: "thuộc thời kì xa xưa nhất trong lịch sử loài người: thời thái cổ",
    example: "thời thái cổ",
  },
  {
    word: "thái dương",
    part_of_speech: "danh từ",
    meaning: "(cũ, văn chương) mặt trời: vầng thái dương * ánh thái dương",
    example: "vầng thái dương * ánh thái dương",
  },
  {
    word: "thái dương",
    part_of_speech: "danh từ",
    meaning:
      "phần của mặt ở khoảng giữa đuôi mắt và vành tai phía trên: đau hai bên thái dương",
    example: "đau hai bên thái dương",
  },
  {
    word: "thái độ",
    part_of_speech: "danh từ",
    meaning:
      "tổng thể nói chung những biểu hiện của ý nghĩ, tình cảm được thể hiện ra bên ngoài qua nét mặt, cử chỉ, lời nói, hành động trước một đối tượng, một sự việc nào đó: thái độ khiêm tốn * tỏ thái độ lạnh nhạt",
    example: "thái độ khiêm tốn * tỏ thái độ lạnh nhạt",
  },
  {
    word: "thái độ",
    part_of_speech: "danh từ",
    meaning:
      "cách nghĩ, cách nhìn và cách hành động theo một hướng nào đó trước một vấn đề hay một tình hình cụ thể: có thái độ bất hợp tác * với việc này, nó không có thái độ rõ rệt",
    example:
      "có thái độ bất hợp tác * với việc này, nó không có thái độ rõ rệt",
  },
  {
    word: "thải hồi",
    part_of_speech: "động từ",
    meaning:
      "(cũ) (cơ quan nhà nước) cho nghỉ việc, buộc thôi việc: tay nghề thấp nên bị thải hồi",
    example: "tay nghề thấp nên bị thải hồi",
  },
  {
    word: "thai nghén",
    part_of_speech: "động từ",
    meaning: "mang thai (nói khái quát): thời kì thai nghén",
    example: "thời kì thai nghén",
  },
  {
    word: "thai nghén",
    part_of_speech: "động từ",
    meaning:
      "(văn chương) nuôi dưỡng và ấp ủ trong lòng để chuẩn bị cho sự ra đời: tác phẩm đã được thai nghén từ rất lâu",
    example: "tác phẩm đã được thai nghén từ rất lâu",
  },
  {
    word: "thải loại",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) loại ra những cái không còn cần thiết hoặc không đáp ứng đủ yêu cầu: quá trình thải loại các chất cặn bã của cơ thể",
    example: "quá trình thải loại các chất cặn bã của cơ thể",
  },
  {
    word: "thai nhi",
    part_of_speech: "danh từ",
    meaning: "đứa con còn trong bụng mẹ: kiểm tra sức khoẻ của thai nhi",
    example: "kiểm tra sức khoẻ của thai nhi",
  },
  {
    word: "thai sản",
    part_of_speech: "động từ",
    meaning:
      "thai nghén và sinh đẻ (nói khái quát): chế độ trợ cấp thai sản * nghỉ thai sản",
    example: "chế độ trợ cấp thai sản * nghỉ thai sản",
  },
  {
    word: "thái quá",
    part_of_speech: "phụ từ",
    meaning:
      "quá mức, quá chừng mực (thường hàm ý chê): tự tin thái quá * bối rối trước sự vồn vập thái quá",
    example: "tự tin thái quá * bối rối trước sự vồn vập thái quá",
  },
  {
    word: "thái uý",
    part_of_speech: "danh từ",
    meaning: "(cũ) chức quan võ cao nhất thời Lý, Trần: thái uý Lý Thường Kiệt",
    example: "thái uý Lý Thường Kiệt",
  },
  {
    word: "thái tử",
    part_of_speech: "danh từ",
    meaning: "hoàng tử được chọn để sau này nối ngôi vua: lập thái tử",
    example: "lập thái tử",
  },
  {
    word: "tham bác",
    part_of_speech: "động từ",
    meaning:
      "(cũ) tham khảo nhiều nơi, nhiều nguồn cho biết được rộng: tham bác binh thư",
    example: "tham bác binh thư",
  },
  {
    word: "tham",
    part_of_speech: "động từ",
    meaning:
      "ham muốn một cách thái quá, không biết chán, không biết giới hạn: tham ăn * tham giàu * tham sống sợ chết (tng)",
    example: "tham ăn * tham giàu * tham sống sợ chết (tng)",
  },
  {
    word: "tham",
    part_of_speech: "động từ",
    meaning:
      "(làm việc gì) cố cho được nhiều mà không biết tự kiềm chế, thường dẫn đến điều không hay: đò đắm vì chở tham khách * bài viết tham quá, thành ra hơi rườm",
    example: "đò đắm vì chở tham khách * bài viết tham quá, thành ra hơi rườm",
  },
  {
    word: "thải trừ",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) loại bỏ đi cái không còn tác dụng (nói khái quát): thải trừ chất cặn bã ra khỏi cơ thể",
    example: "thải trừ chất cặn bã ra khỏi cơ thể",
  },
  {
    word: "thảm bại",
    part_of_speech: "động từ",
    meaning:
      "thất bại một cách nặng nề, thảm hại: quân địch thảm bại trên chiến trường",
    example: "quân địch thảm bại trên chiến trường",
  },
  {
    word: "thảm bại",
    part_of_speech: "danh từ",
    meaning: "sự thất bại một cách nặng nề: chuốc lấy thảm bại",
    example: "chuốc lấy thảm bại",
  },
  {
    word: "thảm",
    part_of_speech: "danh từ",
    meaning:
      "tấm dệt bằng sợi to, thường có hình trang trí, dùng trải trên lối đi hoặc trên sàn nhà: sàn nhà trải thảm * thảm chùi chân",
    example: "sàn nhà trải thảm * thảm chùi chân",
  },
  {
    word: "thảm",
    part_of_speech: "danh từ",
    meaning: "lớp cây, lá dày phủ trên mặt đất: thảm cỏ * thảm lá",
    example: "thảm cỏ * thảm lá",
  },
  {
    word: "thảm",
    part_of_speech: "tính từ",
    meaning:
      'đau thương hoặc khổ sở đến mức khiến cho ai cũng phải động lòng thương cảm: chết thảm * "Một cung gió thảm mưa sầu, Bốn dây giỏ máu năm đầu ngón tay." (TKiều)',
    example:
      'chết thảm * "Một cung gió thảm mưa sầu, Bốn dây giỏ máu năm đầu ngón tay." (TKiều)',
  },
  {
    word: "tham công tiếc việc",
    part_of_speech: "",
    meaning:
      "chăm chỉ, ham làm việc, hết việc này lại làm đến việc khác, không chịu ngồi rỗi: tính hay tham công tiếc việc",
    example: "tính hay tham công tiếc việc",
  },
  {
    word: "tham chính",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) tham gia vào chính quyền ở một cương vị nào đó: một thương gia tham chính",
    example: "một thương gia tham chính",
  },
  {
    word: "thảm đạm",
    part_of_speech: "tính từ",
    meaning:
      "buồn thảm và gợi lên sự lạnh lẽo, hoang vắng: nét mặt thảm đạm * buổi chiều tà thảm đạm",
    example: "nét mặt thảm đạm * buổi chiều tà thảm đạm",
  },
  {
    word: "tham chiếu",
    part_of_speech: "động từ",
    meaning: "căn cứ, dựa vào để tham khảo và đối chiếu: tài liệu tham chiếu",
    example: "tài liệu tham chiếu",
  },
  {
    word: "tham chiến",
    part_of_speech: "động từ",
    meaning:
      "tham gia vào cuộc chiến tranh, chiến đấu: các nước tham chiến * lực lượng tham chiến",
    example: "các nước tham chiến * lực lượng tham chiến",
  },
  {
    word: "tham dự",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) dự vào một hoạt động cụ thể nào đó: tham dự hội nghị * tham dự phiên toà",
    example: "tham dự hội nghị * tham dự phiên toà",
  },
  {
    word: "thảm cảnh",
    part_of_speech: "danh từ",
    meaning: "cảnh tượng thê thảm, đáng thương: thảm cảnh chiến tranh",
    example: "thảm cảnh chiến tranh",
  },
  {
    word: "tham đó bỏ đăng",
    part_of_speech: "",
    meaning:
      'ví kẻ thay lòng đổi dạ, không chung thuỷ trong tình yêu, tình vợ chồng: "Xin đừng tham đó bỏ đăng, Chơi lê quên lựu chơi trăng quên đèn." (LVT)',
    example:
      'Xin đừng tham đó bỏ đăng, Chơi lê quên lựu chơi trăng quên đèn." (LVT)',
  },
  {
    word: "thảm đỏ",
    part_of_speech: "danh từ",
    meaning:
      "thảm dài màu đỏ, trải trên lối đi cho khách quý; dùng để biểu thị tinh thần hoan nghênh, trọng thị: trải thảm đỏ đón tiếp nhà đầu tư",
    example: "trải thảm đỏ đón tiếp nhà đầu tư",
  },
  {
    word: "tham gia",
    part_of_speech: "động từ",
    meaning:
      "góp phần hoạt động của mình vào một hoạt động chung nào đó: tham gia cách mạng * tham gia thi tuyển * việc này tôi không tham gia",
    example:
      "tham gia cách mạng * tham gia thi tuyển * việc này tôi không tham gia",
  },
  {
    word: "tham khảo",
    part_of_speech: "động từ",
    meaning:
      "tìm đọc thêm tài liệu, xem xét, nghe ngóng thêm ý kiến có liên quan để biết rõ hơn về vấn đề đang quan tâm: sách tham khảo * tham khảo ý kiến của các chuyên gia",
    example: "sách tham khảo * tham khảo ý kiến của các chuyên gia",
  },
  {
    word: "thám hiểm",
    part_of_speech: "động từ",
    meaning:
      "đi vào vùng xa lạ hoặc hiểm trở ít ai đặt chân tới, để khám phá, khảo sát: thám hiểm đại dương * chuyến bay thám hiểm vũ trụ",
    example: "thám hiểm đại dương * chuyến bay thám hiểm vũ trụ",
  },
  {
    word: "thảm hại",
    part_of_speech: "tính từ",
    meaning:
      "có vẻ khổ sở, thê thảm đến đáng thương: bộ dạng thảm hại * chiếc xe trông thật thảm hại",
    example: "bộ dạng thảm hại * chiếc xe trông thật thảm hại",
  },
  {
    word: "thảm hại",
    part_of_speech: "tính từ",
    meaning: "nặng nề và nhục nhã: thất bại thảm hại",
    example: "thất bại thảm hại",
  },
  {
    word: "thảm hoạ",
    part_of_speech: "danh từ",
    meaning:
      "tai hoạ lớn, gây nhiều cảnh đau thương, tang tóc: thảm hoạ chiến tranh * thảm họa sóng thần",
    example: "thảm hoạ chiến tranh * thảm họa sóng thần",
  },
  {
    word: "tham kiến",
    part_of_speech: "động từ",
    meaning:
      "(cũ, trang trọng) tham dự cuộc gặp với người có cương vị cao: tham kiến hoàng thượng",
    example: "tham kiến hoàng thượng",
  },
  {
    word: "thám không",
    part_of_speech: "động từ",
    meaning:
      "khảo sát và nghiên cứu khí tượng trên không trung: bóng thám không",
    example: "bóng thám không",
  },
  {
    word: "thảm kịch",
    part_of_speech: "danh từ",
    meaning: "việc, cảnh hết sức đau thương, bi thảm: thảm kịch chiến tranh",
    example: "thảm kịch chiến tranh",
  },
  {
    word: "thảm khốc",
    part_of_speech: "tính từ",
    meaning:
      "quá tàn khốc, gây ra những cảnh hết sức thảm thương: một tai nạn thảm khốc * cuộc tàn sát thảm khốc",
    example: "một tai nạn thảm khốc * cuộc tàn sát thảm khốc",
  },
  {
    word: "tham lam",
    part_of_speech: "tính từ",
    meaning:
      "Đặc tính muốn lấy hết, vơ hết về cho mình: tính tham lam * có bụng tham lam",
    example: "tính tham lam * có bụng tham lam",
  },
  {
    word: "tham luận",
    part_of_speech: "động từ",
    meaning:
      "phát biểu ý kiến (đã chuẩn bị trước) về một vấn đề nào đó được đặt ra trong hội nghị: ý kiến tham luận của các đại biểu",
    example: "ý kiến tham luận của các đại biểu",
  },
  {
    word: "tham luận",
    part_of_speech: "danh từ",
    meaning: "bài tham luận: đọc tham luận",
    example: "đọc tham luận",
  },
  {
    word: "tham mưu",
    part_of_speech: "động từ",
    meaning:
      "giúp người chỉ huy trong việc xếp đặt và tổ chức thực hiện các kế hoạch quân sự: ban tham mưu * sĩ quan tham mưu",
    example: "ban tham mưu * sĩ quan tham mưu",
  },
  {
    word: "tham mưu",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) góp ý kiến có tính chất chỉ đạo giúp cho cấp lãnh đạo: tham mưu cho cấp trên",
    example: "tham mưu cho cấp trên",
  },
  {
    word: "tham mưu",
    part_of_speech: "danh từ",
    meaning: "người làm công tác tham mưu: bàn bạc với các tham mưu",
    example: "bàn bạc với các tham mưu",
  },
  {
    word: "tham nghị",
    part_of_speech: "động từ",
    meaning:
      "(cũ) dự bàn những công việc chung có tính chất quan trọng: tham nghị việc triều chính",
    example: "tham nghị việc triều chính",
  },
  {
    word: "tham quan",
    part_of_speech: "danh từ",
    meaning: "(Ít dùng) quan lại tham nhũng: trừng trị bọn tham quan lộng hành",
    example: "trừng trị bọn tham quan lộng hành",
  },
  {
    word: "tham quan",
    part_of_speech: "động từ",
    meaning:
      "đi xem tận nơi, tận mắt để mở rộng hiểu biết hoặc để học tập kinh nghiệm: tham quan viện bảo tàng * đi tham quan",
    example: "tham quan viện bảo tàng * đi tham quan",
  },
  {
    word: "tham nhũng",
    part_of_speech: "động từ",
    meaning:
      "lợi dụng quyền hành để tham ô và nhũng nhiễu dân: bài trừ tệ nạn tham nhũng",
    example: "bài trừ tệ nạn tham nhũng",
  },
  {
    word: "tham quan ô lại",
    part_of_speech: "",
    meaning:
      "(cũ) quan lại tham lam, bòn rút, vơ vét của dân: một lũ tham quan ô lại",
    example: "một lũ tham quan ô lại",
  },
  {
    word: "tham ô",
    part_of_speech: "động từ",
    meaning:
      "lợi dụng quyền hạn hoặc chức trách để ăn cắp của công: mắc tội tham ô * tham ô công quỹ",
    example: "mắc tội tham ô * tham ô công quỹ",
  },
  {
    word: "thảm sát",
    part_of_speech: "động từ",
    meaning: "giết hại hàng loạt người một cách dã man: vụ thảm sát đẫm máu",
    example: "vụ thảm sát đẫm máu",
  },
  {
    word: "thám sát",
    part_of_speech: "động từ",
    meaning:
      "quan sát, thăm dò để phát hiện (vật hay tình hình chưa biết, chưa rõ): thám sát thị trường * đi thám sát tình hình",
    example: "thám sát thị trường * đi thám sát tình hình",
  },
  {
    word: "thảm sầu",
    part_of_speech: "tính từ",
    meaning:
      '(văn chương) như sầu thảm: "Có chồng như cá ở ao, Kẻ nam người bắc, biết bao thảm sầu." (ca dao)',
    example:
      'Có chồng như cá ở ao, Kẻ nam người bắc, biết bao thảm sầu." (ca dao)',
  },
  {
    word: "tham số",
    part_of_speech: "danh từ",
    meaning:
      "hằng số tuỳ ý, có giá trị xác định cho từng phần tử của một hệ thống đang xét, nhưng có thể thay đổi từ phần tử nọ sang phần tử kia: tham số của một phương trình",
    example: "tham số của một phương trình",
  },
  {
    word: "tham tàn",
    part_of_speech: "tính từ",
    meaning: "(hiếm) tham lam và tàn ác: bọn đế quốc tham tàn",
    example: "bọn đế quốc tham tàn",
  },
  {
    word: "tham tán",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) chức quan văn giúp trông coi việc quân dưới quyền một viên tướng, thời phong kiến.",
    example: "tham tán thương mại * tham tán văn hoá",
  },
  {
    word: "thám thính",
    part_of_speech: "động từ",
    meaning:
      "dò xét, nghe ngóng để thu thập tình hình: cho người đi thám thính",
    example: "cho người đi thám thính",
  },
  {
    word: "tham thanh chuộng lạ",
    part_of_speech: "",
    meaning:
      '(hiếm) như ham thanh chuộng lạ: "Trâu ta ăn cỏ đồng ta, Tham thanh chuộng lạ dắt qua đồng người." (ca dao)',
    example:
      'Trâu ta ăn cỏ đồng ta, Tham thanh chuộng lạ dắt qua đồng người." (ca dao)',
  },
  {
    word: "thảm thực vật",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp thực vật mọc ở một vùng, thường là rộng lớn: phân loại thảm thực vật rừng Việt Nam",
    example: "phân loại thảm thực vật rừng Việt Nam",
  },
  {
    word: "thảm thiết",
    part_of_speech: "tính từ",
    meaning:
      "thê thảm, thống thiết: khóc lóc thảm thiết * tiếng kêu gào thảm thiết",
    example: "khóc lóc thảm thiết * tiếng kêu gào thảm thiết",
  },
  {
    word: "thảm trạng",
    part_of_speech: "danh từ",
    meaning: "tình trạng bi thảm: thảm trạng về môi trường",
    example: "thảm trạng về môi trường",
  },
  {
    word: "thám tử",
    part_of_speech: "danh từ",
    meaning: "người làm việc do thám: thuê thám tử điều tra * thám tử tư",
    example: "thuê thám tử điều tra * thám tử tư",
  },
  {
    word: "tham vàng bỏ ngãi",
    part_of_speech: "",
    meaning:
      'tham tiền của mà sinh lòng phụ bạc: "Tham vàng bỏ ngãi, anh ơi!, Vàng thì ăn hết, ngãi tôi hãy còn." (ca dao)',
    example:
      'Tham vàng bỏ ngãi, anh ơi!, Vàng thì ăn hết, ngãi tôi hãy còn." (ca dao)',
  },
  {
    word: "thảm thương",
    part_of_speech: "tính từ",
    meaning:
      'rất thảm, làm đau lòng (nói khái quát): tình cảnh thảm thương * "Ruột gan chẳng đánh mà đau, Nhân duyên chia rẽ nên sầu thảm thương." (ca dao)',
    example:
      'tình cảnh thảm thương * "Ruột gan chẳng đánh mà đau, Nhân duyên chia rẽ nên sầu thảm thương." (ca dao)',
  },
  {
    word: "tham vọng",
    part_of_speech: "danh từ",
    meaning:
      "lòng ham muốn, mong ước quá lớn, thường vượt xa khả năng thực tế, khó có thể đạt được: tham vọng làm bá chủ thế giới * nuôi tham vọng",
    example: "tham vọng làm bá chủ thế giới * nuôi tham vọng",
  },
  {
    word: "tham vấn",
    part_of_speech: "động từ",
    meaning:
      "hỏi hoặc đưa ra ý kiến để tham khảo (thường về vấn đề có tính chất chuyên môn): cơ quan tham vấn cho chính phủ",
    example: "cơ quan tham vấn cho chính phủ",
  },
  {
    word: "than",
    part_of_speech: "danh từ",
    meaning:
      "chất rắn, thường màu đen, dùng làm chất đốt, do gỗ hoặc xương cháy không hoàn toàn tạo nên, hoặc do cây cối bị chôn vùi ở dưới đất qua nhiều thế kỉ phân huỷ dần mà thành: than củi * than đá * bếp than hồng",
    example: "than củi * than đá * bếp than hồng",
  },
  {
    word: "than",
    part_of_speech: "động từ",
    meaning:
      'thốt ra những lời cảm động, thương xót cho nỗi đau khổ, bất hạnh của mình: than thân trách phận * "Bốn dây như khóc, như than, Khiến người trên tiệc cũng tan nát lòng." (TKiều)',
    example:
      'than thân trách phận * "Bốn dây như khóc, như than, Khiến người trên tiệc cũng tan nát lòng." (TKiều)',
  },
  {
    word: "than đá",
    part_of_speech: "danh từ",
    meaning: "tên gọi chung một số loại than mỏ: thăm dò trữ lượng than đá",
    example: "thăm dò trữ lượng than đá",
  },
  {
    word: "than cốc",
    part_of_speech: "danh từ",
    meaning:
      "than đá đã được chưng, xốp và cứng, chuyên dùng làm chất đốt trong các lò cao: lò luyện than cốc",
    example: "lò luyện than cốc",
  },
  {
    word: "than khóc",
    part_of_speech: "động từ",
    meaning:
      'như khóc than: "Kiều công thức dậy bước ra, Nghe con than khóc xót xa lòng vàng." (LVT)',
    example:
      'Kiều công thức dậy bước ra, Nghe con than khóc xót xa lòng vàng." (LVT)',
  },
  {
    word: "than thở",
    part_of_speech: "động từ",
    meaning:
      'kêu than, thổ lộ nỗi buồn rầu, đau khổ của mình: "Chia tay gan thắt ruột bào, Đêm ngày than thở dầu hao canh tàn." (ca dao)',
    example:
      'Chia tay gan thắt ruột bào, Đêm ngày than thở dầu hao canh tàn." (ca dao)',
  },
  {
    word: "thản nhiên",
    part_of_speech: "tính từ",
    meaning:
      "có dáng vẻ tự nhiên như thường, coi như không có gì xảy ra: nét mặt thản nhiên * thản nhiên trước hiểm nguy",
    example: "nét mặt thản nhiên * thản nhiên trước hiểm nguy",
  },
  {
    word: "thán phục",
    part_of_speech: "động từ",
    meaning: "cảm phục và khen ngợi: trầm trồ thán phục",
    example: "trầm trồ thán phục",
  },
  {
    word: "than phiền",
    part_of_speech: "động từ",
    meaning:
      "phàn nàn, kêu ca về điều phiền muộn nào đó: than phiền về số phận",
    example: "than phiền về số phận",
  },
  {
    word: "than vãn",
    part_of_speech: "động từ",
    meaning:
      "than thở và kể lể, mong có sự đồng cảm, xót thương: than vãn chuyện chồng con * không một lời than vãn",
    example: "than vãn chuyện chồng con * không một lời than vãn",
  },
  {
    word: "thang âm",
    part_of_speech: "danh từ",
    meaning:
      "chuỗi âm thanh lên hoặc xuống theo từng cung bậc khác nhau: những thang âm trầm bổng của tiếng đàn bầu",
    example: "những thang âm trầm bổng của tiếng đàn bầu",
  },
  {
    word: "tháng",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian bằng một phần mười hai năm dương lịch, thường gồm ba mươi hoặc ba mươi mốt ngày (tháng dương lịch): ba tháng hè * ngày quốc khánh mồng 2 tháng 9",
    example: "ba tháng hè * ngày quốc khánh mồng 2 tháng 9",
  },
  {
    word: "tháng",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian gần đúng với độ dài một tuần trăng, có hai mươi chín hoặc ba mươi ngày (tháng âm lịch): năm nay nhuận hai tháng bảy * tháng chạp",
    example: "năm nay nhuận hai tháng bảy * tháng chạp",
  },
  {
    word: "tháng",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian bất kì bằng ba mươi ngày hoặc đại khái gần ba mươi ngày: công việc kéo dài trong ba tháng * mang thai chín tháng mười ngày",
    example:
      "công việc kéo dài trong ba tháng * mang thai chín tháng mười ngày",
  },
  {
    word: "tháng",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian từ ngày đầu tháng đến ngày cuối tháng: khoảng cuối tháng mới về * giữa tháng sau sẽ lên đường",
    example: "khoảng cuối tháng mới về * giữa tháng sau sẽ lên đường",
  },
  {
    word: "thang",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ dùng để leo, thường làm bằng tre, gỗ, gồm có hai thanh dài song song nối liền với nhau bằng nhiều thanh ngang ngắn, cách đều nhau thành bậc: bắc thang * những nấc thang của cuộc đời (b)",
    example: "bắc thang * những nấc thang của cuộc đời (b)",
  },
  {
    word: "thang",
    part_of_speech: "danh từ",
    meaning:
      "thanh ngang ở khung giường, chõng hay ở thuyền nan: gãy thang giường",
    example: "gãy thang giường",
  },
  {
    word: "thang",
    part_of_speech: "danh từ",
    meaning:
      "hệ thống gồm những cấp, độ phân từ thấp lên cao, dùng để xác định giá trị, mức độ: thang nhiệt độ * thang lương",
    example: "thang nhiệt độ * thang lương",
  },
  {
    word: "thang",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp những vị thuốc đông y theo đơn của thầy thuốc, dùng để sắc chung với nhau trong một lần thành một liều thuốc uống: cắt mấy thang thuốc Bắc",
    example: "cắt mấy thang thuốc Bắc",
  },
  {
    word: "thang",
    part_of_speech: "danh từ",
    meaning:
      "vị thuốc đông y dùng phụ cho những vị thuốc khác: chén thuốc này lấy kinh giới làm thang",
    example: "chén thuốc này lấy kinh giới làm thang",
  },
  {
    word: "thang gác",
    part_of_speech: "danh từ",
    meaning: "(cũ) như cầu thang: bước lên thang gác",
    example: "bước lên thang gác",
  },
  {
    word: "tháng đợi năm chờ",
    part_of_speech: "",
    meaning:
      'chờ đợi lâu ngày, hết tháng này đến tháng khác, hết năm này qua năm khác: "Quản bao tháng đợi, năm chờ, Nghĩ người ăn gió nằm mưa xót thầm." (TKiều)',
    example:
      'Quản bao tháng đợi, năm chờ, Nghĩ người ăn gió nằm mưa xót thầm." (TKiều)',
  },
  {
    word: "thảng hoặc",
    part_of_speech: "phụ từ",
    meaning:
      "chỉ thỉnh thoảng, hoạ hoằn lắm (mới có, mới xảy ra): thảng hoặc hai người mới gặp nhau * thảng hoặc mới phải đi xa",
    example: "thảng hoặc hai người mới gặp nhau * thảng hoặc mới phải đi xa",
  },
  {
    word: "thảng hoặc",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là một giả thiết rất hiếm khi xảy ra: mang theo mấy viên thuốc cảm, thảng hoặc khi trái gió trở trời",
    example: "mang theo mấy viên thuốc cảm, thảng hoặc khi trái gió trở trời",
  },
  {
    word: "tháng ngày",
    part_of_speech: "danh từ",
    meaning:
      'như ngày tháng: "Non cao những ngóng cùng trông, Suối khô dòng lệ chờ mong tháng ngày." (TĐà; 7)',
    example:
      'Non cao những ngóng cùng trông, Suối khô dòng lệ chờ mong tháng ngày." (TĐà; 7)',
  },
  {
    word: "thánh",
    part_of_speech: "danh từ",
    meaning:
      "(Từ cũ) danh hiệu người đời gọi tôn người có vốn hiểu biết rộng, có phẩm chất đạo đức cao, vượt lên hẳn người cùng thời: nho giáo tôn Khổng Tử là bậc thánh",
    example: "nho giáo tôn Khổng Tử là bậc thánh",
  },
  {
    word: "thánh",
    part_of_speech: "danh từ",
    meaning:
      "(Từ cũ) thần linh hoặc nhân vật truyền thuyết, nhân vật lịch sử có công lao to lớn, được tôn thờ ở đền, chùa: đức Thánh Trần * đền thờ thánh Tản",
    example: "đức Thánh Trần * đền thờ thánh Tản",
  },
  {
    word: "thánh",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) người có tài, có khả năng hơn hẳn người thường trong một nghề hoặc một việc gì: thánh thơ * thánh cờ * có tài thánh cũng không đoán được",
    example: "thánh thơ * thánh cờ * có tài thánh cũng không đoán được",
  },
  {
    word: "thánh",
    part_of_speech: "danh từ",
    meaning:
      "đấng tạo ra trời, đất, chúa tể của muôn loài, theo một số tôn giáo: đạo Hồi thờ thánh Allah",
    example: "đạo Hồi thờ thánh Allah",
  },
  {
    word: "thánh",
    part_of_speech: "danh từ",
    meaning:
      "từ Kitô giáo dùng để gọi Chúa Jesus và những cái thuộc về Chúa: ngày lễ thánh * kinh thánh",
    example: "ngày lễ thánh * kinh thánh",
  },
  {
    word: "thánh",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) tài, giỏi khác thường, được tôn vào loại bậc nhất: thánh thật, đoán đâu trúng đấy",
    example: "thánh thật, đoán đâu trúng đấy",
  },
  {
    word: "thảng thốt",
    part_of_speech: "tính từ",
    meaning:
      'hoảng hốt xen lẫn vẻ ngơ ngác do bị chấn động mạnh về tinh thần một cách bất ngờ: tiếng kêu thảng thốt * "Phò ngẩng lên, thảng thốt như vừa mới giật mình tỉnh dậy." (TrBôn; 1)',
    example:
      'tiếng kêu thảng thốt * "Phò ngẩng lên, thảng thốt như vừa mới giật mình tỉnh dậy.',
  },
  {
    word: "thanh âm",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như âm thanh: thanh âm réo rắt",
    example: "thanh âm réo rắt",
  },
  {
    word: "thanh",
    part_of_speech: "danh từ",
    meaning:
      "vật cứng dài, có dạng mỏng hoặc tròn, nhỏ bản: thanh gươm báu * thanh sắt * thanh tre",
    example: "thanh gươm báu * thanh sắt * thanh tre",
  },
  {
    word: "thanh",
    part_of_speech: "danh từ",
    meaning: "thanh điệu (nói tắt): thanh huyền",
    example: "thanh huyền",
  },
  {
    word: "thanh",
    part_of_speech: "tính từ",
    meaning:
      'rất trong, không lẫn một chút gì làm cho đục, cho mờ đi cái bản sắc riêng, gây cảm giác thích thú, dễ chịu: đêm thanh * "Một mình niệm Phật niệm kinh, Gió thanh là quạt, trăng thanh là đèn." (BCB)',
    example:
      'đêm thanh * "Một mình niệm Phật niệm kinh, Gió thanh là quạt, trăng thanh là đèn." (BCB)',
  },
  {
    word: "thanh",
    part_of_speech: "tính từ",
    meaning:
      "(âm thanh) rất trong, không rè, không có tạp âm, dễ nghe: giọng nói rất thanh",
    example: "giọng nói rất thanh",
  },
  {
    word: "thanh",
    part_of_speech: "tính từ",
    meaning:
      "có hình dáng, đường nét mảnh mai, trông dễ coi: dáng người thanh thanh * nét rất thanh",
    example: "dáng người thanh thanh * nét rất thanh",
  },
  {
    word: "thanh",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) lịch sự, không thô tục: trai thanh gái lịch * nam thanh nữ tú",
    example: "trai thanh gái lịch * nam thanh nữ tú",
  },
  {
    word: "thanh bạch",
    part_of_speech: "tính từ",
    meaning:
      "trong sạch, giản dị trong lối sống, luôn giữ phẩm chất của mình, không để cho sự giàu sang cám dỗ: một nhà nho thanh bạch * sống thanh bạch",
    example: "một nhà nho thanh bạch * sống thanh bạch",
  },
  {
    word: "thanh bình",
    part_of_speech: "tính từ",
    meaning:
      "(đời sống chung) yên vui trong cảnh hoà bình: cuộc sống thanh bình * đất nước thanh bình",
    example: "cuộc sống thanh bình * đất nước thanh bình",
  },
  {
    word: "thành",
    part_of_speech: "danh từ",
    meaning:
      "công trình xây đắp kiên cố bao quanh một khu vực dân cư hoặc nhà cửa trọng yếu để phòng thủ: thành Cổ Loa * cháy thành vạ lây (tng)",
    example: "thành Cổ Loa * cháy thành vạ lây (tng)",
  },
  {
    word: "thành",
    part_of_speech: "danh từ",
    meaning: "thành phố (nói tắt): đi khắp các tỉnh, thành trong cả nước",
    example: "đi khắp các tỉnh, thành trong cả nước",
  },
  {
    word: "thành",
    part_of_speech: "danh từ",
    meaning:
      "phần dựng đứng, bao kín các mặt bên của một vật chứa, đồ đựng, hoặc nói chung của một vật rỗng ở giữa: thành giếng * ngồi dựa vào thành giường * đập thình thình vào thành xe",
    example:
      "thành giếng * ngồi dựa vào thành giường * đập thình thình vào thành xe",
  },
  {
    word: "thành",
    part_of_speech: "động từ",
    meaning:
      "chuyển sang trạng thái, hình thức khác mà trước đó chưa có hoặc chưa phải: đẽo đá thành tượng * chuyển bại thành thắng * hai người đã thành vợ thành chồng",
    example:
      "đẽo đá thành tượng * chuyển bại thành thắng * hai người đã thành vợ thành chồng",
  },
  {
    word: "thành",
    part_of_speech: "động từ",
    meaning: "(công việc) đạt được kết quả như dự định: việc không thành",
    example: "việc không thành",
  },
  {
    word: "thành",
    part_of_speech: "tính từ",
    meaning: "(tình cảm) chân thật, xuất phát tự đáy lòng: lễ bạc lòng thành",
    example: "lễ bạc lòng thành",
  },
  {
    word: "thành bại",
    part_of_speech: "động từ",
    meaning:
      "thành công hay thất bại (nói khái quát): việc thành bại thế nào hiện còn chưa rõ",
    example: "việc thành bại thế nào hiện còn chưa rõ",
  },
  {
    word: "thanh cao",
    part_of_speech: "tính từ",
    meaning:
      'trong sạch và cao thượng: tâm hồn thanh cao * "Đêm đêm lại hỏi trời già, Thân này ô trọc hay là thanh cao?" (TTK)',
    example:
      'tâm hồn thanh cao * "Đêm đêm lại hỏi trời già, Thân này ô trọc hay là thanh cao?" (TTK)',
  },
  {
    word: "thanh cảnh",
    part_of_speech: "tính từ",
    meaning:
      "(ăn uống) nhỏ nhẹ, không chuộng nhiều, không thô tục: ăn uống thanh cảnh",
    example: "ăn uống thanh cảnh",
  },
  {
    word: "thánh chỉ",
    part_of_speech: "danh từ",
    meaning: "(cũ) lệnh của vua, theo cách gọi với ý tôn kính: tiếp thánh chỉ",
    example: "tiếp thánh chỉ",
  },
  {
    word: "thành công",
    part_of_speech: "",
    meaning:
      "đạt được kết quả, mục đích như dự định: bảo vệ thành công luận án tiến sĩ * đại hội thành công tốt đẹp",
    example: "bảo vệ thành công luận án tiến sĩ * đại hội thành công tốt đẹp",
  },
  {
    word: "thành chung",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) (tốt nghiệp) cao đẳng tiểu học, thời thuộc Pháp: tốt nghiệp thành chung",
    example: "tốt nghiệp thành chung",
  },
  {
    word: "thanh đạm",
    part_of_speech: "tính từ",
    meaning:
      '(ăn uống) đơn giản, không có những món cầu kì hoặc đắt tiền: bữa cơm thanh đạm * "Miếng cao lương phong lưu nhưng lợm, Mùi hoắc lê thanh đạm mà ngon." (CO)',
    example:
      'bữa cơm thanh đạm * "Miếng cao lương phong lưu nhưng lợm, Mùi hoắc lê thanh đạm mà ngon." (CO)',
  },
  {
    word: "thanh đạm",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) (cuộc sống, lối sống) giản dị và trong sạch: nếp sống thanh đạm",
    example: "nếp sống thanh đạm",
  },
  {
    word: "thành danh",
    part_of_speech: "động từ",
    meaning: "thành đạt, làm nên danh tiếng: một cây bút chưa thành danh",
    example: "một cây bút chưa thành danh",
  },
  {
    word: "thành đạt",
    part_of_speech: "động từ",
    meaning:
      "đạt được kết quả, đạt được mục đích về sự nghiệp: thành đạt trong cuộc sống * kinh doanh ngày càng thành đạt",
    example: "thành đạt trong cuộc sống * kinh doanh ngày càng thành đạt",
  },
  {
    word: "thanh điệu",
    part_of_speech: "danh từ",
    meaning:
      "sự nâng cao hoặc hạ thấp giọng nói trong một âm tiết, có tác dụng khu biệt vỏ âm thanh của từ hoặc hình vị ở một số ngôn ngữ: tiếng Việt có sáu thanh điệu",
    example: "tiếng Việt có sáu thanh điệu",
  },
  {
    word: "thanh danh",
    part_of_speech: "danh từ",
    meaning: "tiếng tăm tốt: thanh danh của gia đình * bị mất thanh danh",
    example: "thanh danh của gia đình * bị mất thanh danh",
  },
  {
    word: "thành đoàn",
    part_of_speech: "danh từ",
    meaning: "cấp bộ thành phố của tổ chức đoàn thanh niên: bí thư thành đoàn",
    example: "bí thư thành đoàn",
  },
  {
    word: "thành đồng",
    part_of_speech: "danh từ",
    meaning:
      "bức thành bằng đồng; dùng để tượng trưng cho lực lượng bảo vệ vững chắc: vững như thành đồng * thành đồng tổ quốc",
    example: "vững như thành đồng * thành đồng tổ quốc",
  },
  {
    word: "thánh địa",
    part_of_speech: "danh từ",
    meaning:
      "(thường viết hoa) nơi được coi là hết sức thiêng liêng của một tôn giáo; thường là nơi có di hài, di vật của giáo chủ.",
    example: "bảo vệ vùng đất thánh",
  },
  {
    word: "thành đô",
    part_of_speech: "danh từ",
    meaning: "(cũ) như đô thành: chốn thành đô",
    example: "chốn thành đô",
  },
  {
    word: "thanh đới",
    part_of_speech: "danh từ",
    meaning: "(cũ) dây thanh: viêm thanh đới",
    example: "viêm thanh đới",
  },
  {
    word: "thánh giá",
    part_of_speech: "danh từ",
    meaning: "(cũ, trtr, hiếm) xe vua đi thời phong kiến: nghênh đón thánh giá",
    example: "nghênh đón thánh giá",
  },
  {
    word: "thánh giá",
    part_of_speech: "danh từ",
    meaning:
      "giá hình chữ thập, tượng trưng cho sự hi sinh vì đạo của Chúa Jesus: cây thánh giá * cổ đeo thánh giá",
    example: "cây thánh giá * cổ đeo thánh giá",
  },
  {
    word: "thánh đường",
    part_of_speech: "danh từ",
    meaning:
      "(trang trọng) nhà thờ của một số tôn giáo như Kitô giáo, Hồi giáo: thánh đường Hồi giáo * xưng tội trước thánh đường",
    example: "thánh đường Hồi giáo * xưng tội trước thánh đường",
  },
  {
    word: "thánh hiền",
    part_of_speech: "danh từ",
    meaning:
      "người được các đời sau trong xã hội phong kiến tôn sùng, coi là bậc có tài đức, trí tuệ hơn hẳn người đời, theo quan điểm và truyền thống của nho giáo (nói khái quát): đạo thánh hiền * đọc sách thánh hiền",
    example: "đạo thánh hiền * đọc sách thánh hiền",
  },
  {
    word: "thành hình",
    part_of_speech: "động từ",
    meaning:
      "được tạo thành ở mức chỉ mới có những nét chính chứ chưa hoàn chỉnh: bào thai đã thành hình * bức vẽ chưa thành hình",
    example: "bào thai đã thành hình * bức vẽ chưa thành hình",
  },
  {
    word: "thành hôn",
    part_of_speech: "động từ",
    meaning: "(Trang trọng) chính thức thành vợ chồng: lễ thành hôn",
    example: "lễ thành hôn",
  },
  {
    word: "thành hội",
    part_of_speech: "danh từ",
    meaning: "cấp bộ thành phố của một hội: thành hội phụ nữ",
    example: "thành hội phụ nữ",
  },
  {
    word: "thành khẩn",
    part_of_speech: "tính từ",
    meaning:
      "hết sức thành thật trong khi khai báo, nhận lỗi hay tự phê bình và tiếp thu phê bình: thái độ thành khẩn * thành khẩn khai báo",
    example: "thái độ thành khẩn * thành khẩn khai báo",
  },
  {
    word: "thành hoàng",
    part_of_speech: "danh từ",
    meaning: "vị thần được thờ ở một làng: miếu thờ thành hoàng",
    example: "miếu thờ thành hoàng",
  },
  {
    word: "thành kiến",
    part_of_speech: "danh từ",
    meaning:
      "ý kiến nhận xét không hay (về ai, vấn đề nào đó) đã ăn rất sâu, khó thay đổi: thành kiến hẹp hòi * hai người có thành kiến với nhau",
    example: "thành kiến hẹp hòi * hai người có thành kiến với nhau",
  },
  {
    word: "thành kiến",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) cứ giữ nguyên ý kiến nhận xét không tốt (về ai hay vấn đề nào đó), không chịu thay đổi: nó đã tiến bộ rồi, không nên thành kiến mãi",
    example: "nó đã tiến bộ rồi, không nên thành kiến mãi",
  },
  {
    word: "thành khí",
    part_of_speech: "tính từ",
    meaning:
      "(gỗ xẻ) đã được gia công thêm theo những quy cách nhất định để sử dụng vào những công việc cụ thể (như làm nhà cửa, đóng đồ đạc, v.v.): gỗ thành khí",
    example: "gỗ thành khí",
  },
  {
    word: "thanh khiết",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) trong sạch, thuần khiết: hương sen thanh khiết * giữ cho mình được thanh khiết",
    example: "hương sen thanh khiết * giữ cho mình được thanh khiết",
  },
  {
    word: "thành kính",
    part_of_speech: "tính từ",
    meaning: "thành tâm và kính cẩn: tấm lòng thành kính * thành kính kêu cầu",
    example: "tấm lòng thành kính * thành kính kêu cầu",
  },
  {
    word: "thanh lí",
    part_of_speech: "động từ",
    meaning:
      "bán hoặc huỷ bỏ công khai tài sản cố định không dùng nữa: thanh lí một số máy móc cũ * hàng thanh lí",
    example: "thanh lí một số máy móc cũ * hàng thanh lí",
  },
  {
    word: "thanh lí",
    part_of_speech: "động từ",
    meaning:
      "hoàn tất việc thực hiện một hợp đồng giữa các bên liên quan: thanh lí hợp đồng",
    example: "thanh lí hợp đồng",
  },
  {
    word: "thanh lâu",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) lầu xanh: "Hết hạn nọ, đến nạn kia, Thanh lâu hai lượt, thanh y hai lần." (TKiều)',
    example:
      'Hết hạn nọ, đến nạn kia, Thanh lâu hai lượt, thanh y hai lần." (TKiều)',
  },
  {
    word: "thanh lịch",
    part_of_speech: "tính từ",
    meaning:
      "thanh nhã và lịch sự: cốt cách thanh lịch * cuộc thi nữ sinh thanh lịch",
    example: "cốt cách thanh lịch * cuộc thi nữ sinh thanh lịch",
  },
  {
    word: "thanh lọc",
    part_of_speech: "động từ",
    meaning:
      "loại bỏ ra những phần tử xấu để làm cho tổ chức được trong sạch: thanh lọc cán bộ",
    example: "thanh lọc cán bộ",
  },
  {
    word: "thanh liêm",
    part_of_speech: "tính từ",
    meaning: "trong sạch, liêm khiết: vị quan thanh liêm",
    example: "vị quan thanh liêm",
  },
  {
    word: "thành lập",
    part_of_speech: "động từ",
    meaning:
      "chính thức lập nên, dựng nên (thường nói về một tổ chức quan trọng): thành lập công ti * ngày thành lập nước",
    example: "thành lập công ti * ngày thành lập nước",
  },
  {
    word: "thanh mai",
    part_of_speech: "danh từ",
    meaning: "(Ít dùng) dâu rượu: rượu thanh mai",
    example: "rượu thanh mai",
  },
  {
    word: "thành luỹ",
    part_of_speech: "danh từ",
    meaning:
      "công trình xây đắp kiên cố để phòng thủ một vị trí quan trọng, như thành, luỹ, v.v. (nói khái quát): sửa sang thành luỹ",
    example: "sửa sang thành luỹ",
  },
  {
    word: "thanh lý",
    part_of_speech: "động từ",
    meaning:
      "bán hoặc huỷ bỏ công khai tài sản cố định không dùng nữa: thanh lí một số máy móc cũ * hàng thanh lí",
    example: "thanh lí một số máy móc cũ * hàng thanh lí",
  },
  {
    word: "thanh lý",
    part_of_speech: "động từ",
    meaning:
      "hoàn tất việc thực hiện một hợp đồng giữa các bên liên quan: thanh lí hợp đồng",
    example: "thanh lí hợp đồng",
  },
  {
    word: "thanh mảnh",
    part_of_speech: "tính từ",
    meaning:
      "(hình dáng) mảnh mai, trông có vẻ hơi yếu, nhưng nhìn có cảm giác ưa thích: làn lông mày thanh mảnh * dáng người thanh mảnh",
    example: "làn lông mày thanh mảnh * dáng người thanh mảnh",
  },
  {
    word: "thanh nhã",
    part_of_speech: "tính từ",
    meaning:
      "lịch sự, nhã nhặn, dễ được cảm tình, yêu mến: màu sắc thanh nhã * cách bài trí thanh nhã",
    example: "màu sắc thanh nhã * cách bài trí thanh nhã",
  },
  {
    word: "thanh minh",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi một trong hai mươi bốn ngày tiết trong năm theo lịch cổ truyền của Trung Quốc, ứng với ngày 4, 5 hoặc 6 tháng tư dương lịch (thường vào khoảng tháng hai, tháng ba âm lịch), đây là dịp tiết trời trong sáng nên có tục đi thăm viếng, sửa sang mồ mả: tết thanh minh",
    example: "tết thanh minh",
  },
  {
    word: "thanh minh",
    part_of_speech: "động từ",
    meaning:
      "phân trần, giải thích cho người khác hiểu để không còn quy lỗi hoặc nghĩ xấu cho mình hay cho ai đó nữa, trong sự việc nào đó: thanh minh cho hành động của mình * bị hiểu lầm nhưng không thanh minh",
    example:
      "thanh minh cho hành động của mình * bị hiểu lầm nhưng không thanh minh",
  },
  {
    word: "thánh mẫu",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi tôn một số nữ thần, theo tín ngưỡng dân gian: đền thờ thánh mẫu Liễu Hạnh",
    example: "đền thờ thánh mẫu Liễu Hạnh",
  },
  {
    word: "thánh mẫu",
    part_of_speech: "danh từ",
    meaning:
      "(thường viết hoa) tên những người theo Công giáo gọi đức bà Maria: tạ ơn Thánh Mẫu",
    example: "tạ ơn Thánh Mẫu",
  },
  {
    word: "thành ngữ",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp từ cố định đã quen dùng mà nghĩa của nó thường không thể giải thích được một cách đơn giản bằng nghĩa của các từ tạo nên: ,  *  là những thành ngữ",
    example: ",  *  là những thành ngữ",
  },
  {
    word: "thanh nhàn",
    part_of_speech: "tính từ",
    meaning:
      'nhàn nhã, thảnh thơi, không vướng bận việc gì: cuộc sống thanh nhàn * "Cầm đường ngày tháng thanh nhàn, Sớm khuya tiếng hạc, tiếng đàn tiêu dao." (TKiều)',
    example:
      'cuộc sống thanh nhàn * "Cầm đường ngày tháng thanh nhàn, Sớm khuya tiếng hạc, tiếng đàn tiêu dao." (TKiều)',
  },
  {
    word: "thanh niên",
    part_of_speech: "danh từ",
    meaning: "người còn trẻ, đang ở độ tuổi trưởng thành: thế hệ thanh niên",
    example: "thế hệ thanh niên",
  },
  {
    word: "thanh niên",
    part_of_speech: "tính từ",
    meaning:
      "(đặc điểm, tính cách) trẻ trung, sôi nổi và đầy sức sống: phong cách rất thanh niên",
    example: "phong cách rất thanh niên",
  },
  {
    word: "thánh nhân",
    part_of_speech: "danh từ",
    meaning: "người được tôn bậc thánh: bậc thánh nhân",
    example: "bậc thánh nhân",
  },
  {
    word: "thành nội",
    part_of_speech: "danh từ",
    meaning:
      "khu vực cung điện của vua có thành xây chung quanh để bảo vệ, nằm bên trong một vòng thành khác: đột nhập vào thành nội",
    example: "đột nhập vào thành nội",
  },
  {
    word: "thanh nhạc",
    part_of_speech: "danh từ",
    meaning:
      "âm nhạc biểu hiện bằng giọng hát; phân biệt với khí nhạc: trường thanh nhạc * hát đúng thanh nhạc",
    example: "trường thanh nhạc * hát đúng thanh nhạc",
  },
  {
    word: "thành phẩm",
    part_of_speech: "danh từ",
    meaning:
      "sản phẩm đã được chế tạo, chế biến xong hoàn toàn, không còn phải qua khâu gia công nào nữa; phân biệt với bán thành phẩm: xuất khẩu gạo thành phẩm * kiểm tra chất lượng thành phẩm",
    example: "xuất khẩu gạo thành phẩm * kiểm tra chất lượng thành phẩm",
  },
  {
    word: "thành niên",
    part_of_speech: "tính từ",
    meaning:
      "đã đến tuổi trưởng thành và được pháp luật công nhận là công dân với đầy đủ các quyền lợi và nghĩa vụ: tuổi thành niên",
    example: "tuổi thành niên",
  },
  {
    word: "thành phần",
    part_of_speech: "danh từ",
    meaning:
      "yếu tố, bộ phận kết hợp với những yếu tố, bộ phận khác để tạo nên một chỉnh thể: thành phần hoá học của nước * nền kinh tế nhiều thành phần",
    example: "thành phần hoá học của nước * nền kinh tế nhiều thành phần",
  },
  {
    word: "thành phần",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp người có cùng tiêu chí nào đó trong một tập hợp người lớn hơn: thành phần nữ chiếm đa số trong ban chấp hành",
    example: "thành phần nữ chiếm đa số trong ban chấp hành",
  },
  {
    word: "thành phần",
    part_of_speech: "danh từ",
    meaning:
      "thành phần giai cấp (nói tắt): thành phần tiểu tư sản * thành phần trung nông",
    example: "thành phần tiểu tư sản * thành phần trung nông",
  },
  {
    word: "thành quách",
    part_of_speech: "danh từ",
    meaning:
      "thành xây có nhiều lớp bao bọc để bảo vệ (nói khái quát): xây dựng lâu đài, thành quách",
    example: "xây dựng lâu đài, thành quách",
  },
  {
    word: "thành quả",
    part_of_speech: "danh từ",
    meaning:
      "kết quả quý giá đạt được sau một quá trình hoạt động, đấu tranh mất nhiều công sức: thành quả lao động * hưởng thành quả",
    example: "thành quả lao động * hưởng thành quả",
  },
  {
    word: "thanh quang",
    part_of_speech: "tính từ",
    meaning: "(cũ) như phong quang: địa thế thanh quang",
    example: "địa thế thanh quang",
  },
  {
    word: "thánh quân",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) từ gọi tôn vị vua sáng suốt, có tài đức: tôi hiền gặp được thánh quân",
    example: "tôi hiền gặp được thánh quân",
  },
  {
    word: "thành ra",
    part_of_speech: "kết từ",
    meaning:
      "(khẩu ngữ) như thành thử: cái gì cũng muốn, thành ra xôi hỏng bỏng không",
    example: "cái gì cũng muốn, thành ra xôi hỏng bỏng không",
  },
  {
    word: "thanh sạch",
    part_of_speech: "tính từ",
    meaning: "(cũ) trong sạch, không một vết nhơ: phẩm hạnh thanh sạch",
    example: "phẩm hạnh thanh sạch",
  },
  {
    word: "thánh sống",
    part_of_speech: "danh từ",
    meaning:
      "người tài giỏi khác thường, được người cùng thời khâm phục, tôn sùng như bậc thánh: lúc sinh thời, danh y Lê Hữu Trác được người đời coi như một vị thánh sống * nói như thánh sống (kng)",
    example:
      "lúc sinh thời, danh y Lê Hữu Trác được người đời coi như một vị thánh sống * nói như thánh sống (kng)",
  },
  {
    word: "thanh quản",
    part_of_speech: "danh từ",
    meaning:
      "phần trên của khí quản, chứa dây thanh, có thể phát ra tiếng khi không khí đi qua từ phổi: viêm thanh quản",
    example: "viêm thanh quản",
  },
  {
    word: "thành tài",
    part_of_speech: "động từ",
    meaning:
      "trở nên tài giỏi, trở thành người có khả năng làm nên sự nghiệp (sau một quá trình học tập, rèn luyện): cố gắng học cho thành tài",
    example: "cố gắng học cho thành tài",
  },
  {
    word: "thanh sắc",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) giọng nói và sắc đẹp; dùng để chỉ giọng hát hay và sắc đẹp của người phụ nữ (nói khái quát): thanh sắc hơn người * ham mê thanh sắc",
    example: "thanh sắc hơn người * ham mê thanh sắc",
  },
  {
    word: "thanh sát",
    part_of_speech: "động từ",
    meaning: "thanh tra và giám sát: tiến hành thanh sát vũ khí hạt nhân",
    example: "tiến hành thanh sát vũ khí hạt nhân",
  },
  {
    word: "thanh tao",
    part_of_speech: "tính từ",
    meaning:
      "(dáng điệu, đường nét) tao nhã, toát lên vẻ mềm mại, gây cảm giác nhẹ nhàng, dễ ưa: nét vẽ thanh tao * diện mạo thanh tao",
    example: "nét vẽ thanh tao * diện mạo thanh tao",
  },
  {
    word: "thánh tăng",
    part_of_speech: "danh từ",
    meaning:
      "vị cao tăng được người đời tôn sùng như bậc thánh: Không Lộ thiền sư là một bậc thánh tăng",
    example: "Không Lộ thiền sư là một bậc thánh tăng",
  },
  {
    word: "thành tâm",
    part_of_speech: "tính từ",
    meaning:
      "có tình cảm chân thật, không có gì giả dối: thành tâm lễ bái * thành tâm giúp đỡ bạn",
    example: "thành tâm lễ bái * thành tâm giúp đỡ bạn",
  },
  {
    word: "thanh thản",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái nhẹ nhàng, thoải mái, vì trong lòng không còn có điều gì phải bận tâm lo nghĩ hay áy náy nữa: đầu óc thanh thản * nói ra cho lòng được thanh thản",
    example: "đầu óc thanh thản * nói ra cho lòng được thanh thản",
  },
  {
    word: "thanh tân",
    part_of_speech: "tính từ",
    meaning:
      "(cũ) tươi trẻ: vẻ yểu điệu thanh tân * “Thoắt đâu thấy một tiểu kiều, Có chiều phong vận, có chiều thanh tân.” (TKiều)",
    example:
      "vẻ yểu điệu thanh tân * “Thoắt đâu thấy một tiểu kiều, Có chiều phong vận, có chiều thanh tân.” (TKiều)",
  },
  {
    word: "thanh tân",
    part_of_speech: "tính từ",
    meaning: "trong trắng, còn tân: gái thanh tân",
    example: "gái thanh tân",
  },
  {
    word: "thanh thanh",
    part_of_speech: "tính từ",
    meaning: "hơi thanh, dễ ưa: dáng người thanh thanh * giọng hát thanh thanh",
    example: "dáng người thanh thanh * giọng hát thanh thanh",
  },
  {
    word: "thánh thần",
    part_of_speech: "danh từ",
    meaning:
      "(cũng thánh thần) thần và thánh, chỉ những lực lượng siêu tự nhiên, linh thiêng (nói khái quát): không tin vào thần thánh, ma quỷ",
    example: "không tin vào thần thánh, ma quỷ",
  },
  {
    word: "thánh thần",
    part_of_speech: "tính từ",
    meaning: "có tính chất thiêng liêng và vĩ đại: cuộc kháng chiến thần thánh",
    example: "cuộc kháng chiến thần thánh",
  },
  {
    word: "thành thân",
    part_of_speech: "động từ",
    meaning:
      "(cũ, văn chương) lấy nhau, thành vợ thành chồng: hai người đã thành thân",
    example: "hai người đã thành thân",
  },
  {
    word: "thành thạo",
    part_of_speech: "tính từ",
    meaning:
      "(làm việc gì) rất thạo, do đã quen làm và đã có kinh nghiệm: nói thành thạo hai thứ tiếng * sử dụng máy tính thành thạo",
    example: "nói thành thạo hai thứ tiếng * sử dụng máy tính thành thạo",
  },
  {
    word: "thánh thiện",
    part_of_speech: "tính từ",
    meaning:
      "trong sáng và nhân từ, cao thượng: tấm lòng thánh thiện * vẻ đẹp thánh thiện",
    example: "tấm lòng thánh thiện * vẻ đẹp thánh thiện",
  },
  {
    word: "thanh thế",
    part_of_speech: "danh từ",
    meaning:
      "uy tín, thế lực và tiếng tăm (được nhiều người biết đến): phô trương thanh thế * một dòng họ có thanh thế nhất vùng",
    example: "phô trương thanh thế * một dòng họ có thanh thế nhất vùng",
  },
  {
    word: "thành thật",
    part_of_speech: "tính từ",
    meaning:
      "có lời nói, hành vi đúng như những suy nghĩ, tình cảm của mình, không có gì giả dối: trả lời thành thật * thành thật xin lỗi",
    example: "trả lời thành thật * thành thật xin lỗi",
  },
  {
    word: "thanh thiên",
    part_of_speech: "danh từ",
    meaning: "(cũ) trời xanh: thề có thanh thiên chứng giám",
    example: "thề có thanh thiên chứng giám",
  },
  {
    word: "thanh thiên",
    part_of_speech: "tính từ",
    meaning: "thiên thanh: áo màu thanh thiên",
    example: "áo màu thanh thiên",
  },
  {
    word: "thành thị",
    part_of_speech: "danh từ",
    meaning:
      "thành phố, thị xã nói chung, về mặt là nơi dân cư đông đúc, công nghiệp và thương nghiệp phát triển, sinh hoạt văn hoá phong phú; phân biệt với nông thôn: dân nghèo thành thị * thu hẹp khoảng cách giữa nông thôn và thành thị",
    example:
      "dân nghèo thành thị * thu hẹp khoảng cách giữa nông thôn và thành thị",
  },
  {
    word: "thanh thoát",
    part_of_speech: "tính từ",
    meaning:
      "(dáng điệu, đường nét) mềm mại, không gò bó, gợi cảm giác nhẹ nhàng, dễ ưa: khuôn mặt thanh thoát * vóc dáng thanh thoát",
    example: "khuôn mặt thanh thoát * vóc dáng thanh thoát",
  },
  {
    word: "thanh thoát",
    part_of_speech: "tính từ",
    meaning:
      "(lời văn) lưu loát, nhẹ nhàng, không gò bó, không khúc mắc: giọng văn thanh thoát",
    example: "giọng văn thanh thoát",
  },
  {
    word: "thanh thoát",
    part_of_speech: "tính từ",
    meaning:
      "(tâm trạng) thanh thản, cảm thấy nhẹ nhõm trong lòng: tâm trạng thanh thoát * sống thanh thoát, hồn nhiên",
    example: "tâm trạng thanh thoát * sống thanh thoát, hồn nhiên",
  },
  {
    word: "thánh thất",
    part_of_speech: "danh từ",
    meaning:
      "nhà thờ của đạo Cao Đài: thánh thất Tây Ninh * làm lễ tại thánh thất",
    example: "thánh thất Tây Ninh * làm lễ tại thánh thất",
  },
  {
    word: "thánh thót",
    part_of_speech: "tính từ",
    meaning:
      'từ mô phỏng tiếng nước nhỏ từng giọt thong thả: mồ hôi thánh thót * "Cây quỳnh thánh thót sương rơi, Đào rầu rầu ủ liễu hơi hơi gầy." (HT)',
    example:
      'mồ hôi thánh thót * "Cây quỳnh thánh thót sương rơi, Đào rầu rầu ủ liễu hơi hơi gầy." (HT)',
  },
  {
    word: "thánh thót",
    part_of_speech: "tính từ",
    meaning:
      '(âm thanh) cao, ngân vang và trong trẻo, lúc to lúc nhỏ, nghe êm ái: giọng hát thánh thót * "Lĩnh lời, nàng mới lựa dây, Nỉ non, thánh thót, dễ say lòng người!" (TKiều)',
    example:
      'giọng hát thánh thót * "Lĩnh lời, nàng mới lựa dây, Nỉ non, thánh thót, dễ say lòng người!" (TKiều)',
  },
  {
    word: "thành thử",
    part_of_speech: "kết từ",
    meaning:
      "(khẩu ngữ) từ biểu thị điều sắp nêu ra là kết quả tự nhiên dẫn đến của điều vừa nói: bị tắc đường, thành thử đến muộn",
    example: "bị tắc đường, thành thử đến muộn",
  },
  {
    word: "thánh thượng",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) từ dùng để gọi vua, theo cách gọi tôn kính thời phong kiến: muôn tâu thánh thượng",
    example: "muôn tâu thánh thượng",
  },
  {
    word: "thành tích",
    part_of_speech: "danh từ",
    meaning:
      "kết quả tốt đẹp do nỗ lực mà đạt được: đạt thành tích cao trong học tập * chạy theo thành tích",
    example: "đạt thành tích cao trong học tập * chạy theo thành tích",
  },
  {
    word: "thảnh thơi",
    part_of_speech: "tính từ",
    meaning:
      'ở trạng thái thoải mái, hoàn toàn không phải vướng bận hay lo nghĩ gì: đầu óc thảnh thơi * "Buồng đào khuya sớm thảnh thơi, Ra vào một mực nói cười như không." (TKiều)',
    example:
      'đầu óc thảnh thơi * "Buồng đào khuya sớm thảnh thơi, Ra vào một mực nói cười như không." (TKiều)',
  },
  {
    word: "thành thục",
    part_of_speech: "tính từ",
    meaning:
      "hết sức thành thạo và nhuần nhuyễn về động tác, kĩ năng, kĩ thuật (do đã qua một quá trình trau dồi, luyện tập lâu dài và kĩ càng): thực hiện các động tác hết sức thành thục",
    example: "thực hiện các động tác hết sức thành thục",
  },
  {
    word: "thành thục",
    part_of_speech: "tính từ",
    meaning:
      "(cơ thể sinh vật) đã đạt đến giai đoạn có thể sinh sản được: cơ thể chưa phát triển thành thục",
    example: "cơ thể chưa phát triển thành thục",
  },
  {
    word: "thanh tịnh",
    part_of_speech: "tính từ",
    meaning: "trong sạch và yên tĩnh: chốn thanh tịnh",
    example: "chốn thanh tịnh",
  },
  {
    word: "thanh tĩnh",
    part_of_speech: "tính từ",
    meaning: "hoàn toàn yên tĩnh: cảnh chùa thanh tĩnh",
    example: "cảnh chùa thanh tĩnh",
  },
  {
    word: "thanh toán",
    part_of_speech: "động từ",
    meaning:
      "chi trả bằng tiền giữa các bên trong những quan hệ kinh tế nhất định: hoá đơn thanh toán * thanh toán bằng tiền mặt",
    example: "hoá đơn thanh toán * thanh toán bằng tiền mặt",
  },
  {
    word: "thanh toán",
    part_of_speech: "động từ",
    meaning:
      "giải quyết cho xong, cho dứt điểm cái còn tồn tại, gây vướng mắc, trở ngại: thanh toán nạn mù chữ",
    example: "thanh toán nạn mù chữ",
  },
  {
    word: "thanh toán",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tiêu diệt, trừ khử đi: các băng đảng tội phạm thanh toán lẫn nhau",
    example: "các băng đảng tội phạm thanh toán lẫn nhau",
  },
  {
    word: "thanh tra",
    part_of_speech: "động từ",
    meaning:
      "(cơ quan, cá nhân có thẩm quyền) xem xét tại chỗ việc làm của địa phương, tổ chức để phát hiện và ngăn chặn những gì trái với quy định: thanh tra đất đai * cử người xuống cơ sở thanh tra",
    example: "thanh tra đất đai * cử người xuống cơ sở thanh tra",
  },
  {
    word: "thanh trừng",
    part_of_speech: "động từ",
    meaning:
      "gạt bỏ ra khỏi hàng ngũ (thường vì mục đích chính trị): cuộc thanh trừng giữa các phe cánh",
    example: "cuộc thanh trừng giữa các phe cánh",
  },
  {
    word: "thành tố",
    part_of_speech: "danh từ",
    meaning:
      "yếu tố trực tiếp tạo nên một chỉnh thể: phương pháp phân tích thành tố * thành tố của ngữ là từ",
    example: "phương pháp phân tích thành tố * thành tố của ngữ là từ",
  },
  {
    word: "thành trì",
    part_of_speech: "danh từ",
    meaning:
      "thành có hào sâu bao quanh để phòng thủ một vị trí quan trọng: xây dựng thành trì * thành trì kiên cố",
    example: "xây dựng thành trì * thành trì kiên cố",
  },
  {
    word: "thành trì",
    part_of_speech: "danh từ",
    meaning:
      "cái nền tảng, cơ sở vững chắc (cho cái khác tồn tại và phát triển): thành trì cách mạng",
    example: "thành trì cách mạng",
  },
  {
    word: "thanh trùng",
    part_of_speech: "động từ",
    meaning:
      "loại trừ vi trùng, vi khuẩn để có đồ ăn hay thức uống sạch, an toàn (một khâu trong quá trình chế biến thực phẩm): sữa tươi đã qua thanh trùng * thanh trùng thực phẩm trước khi đóng hộp",
    example:
      "sữa tươi đã qua thanh trùng * thanh trùng thực phẩm trước khi đóng hộp",
  },
  {
    word: "thành tựu",
    part_of_speech: "danh từ",
    meaning:
      "kết quả đạt được hết sức có ý nghĩa, sau một quá trình hoạt động thành công: ứng dụng những thành tựu của khoa học vào đời sống",
    example: "ứng dụng những thành tựu của khoa học vào đời sống",
  },
  {
    word: "thanh trừ",
    part_of_speech: "động từ",
    meaning: "loại bỏ ra khỏi tổ chức: thanh trừ những phần tử cơ hội",
    example: "thanh trừ những phần tử cơ hội",
  },
  {
    word: "thành văn",
    part_of_speech: "tính từ",
    meaning:
      "được ghi lại bằng chữ viết, thành văn bản: nền văn học thành văn * luật bất thành văn (không được quy định thành văn bản)",
    example:
      "nền văn học thành văn * luật bất thành văn (không được quy định thành văn bản)",
  },
  {
    word: "thanh tú",
    part_of_speech: "tính từ",
    meaning:
      "(hình dáng, đường nét) có vẻ đẹp mảnh mai, thanh thoát, dễ gây cảm tình: dáng người thanh tú * khuôn mặt thanh tú",
    example: "dáng người thanh tú * khuôn mặt thanh tú",
  },
  {
    word: "thánh tướng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) tài giỏi, có khả năng hơn người (hàm ý mỉa mai): nó chỉ nói thánh tướng thế thôi chứ chả làm được cái gì",
    example: "nó chỉ nói thánh tướng thế thôi chứ chả làm được cái gì",
  },
  {
    word: "thanh vắng",
    part_of_speech: "tính từ",
    meaning:
      'yên tĩnh và vắng vẻ: đêm khuya thanh vắng * "Bên sông thanh vắng một mình, Có ông ngư phủ biết tình mà thôi." (ca dao)',
    example:
      'đêm khuya thanh vắng * "Bên sông thanh vắng một mình, Có ông ngư phủ biết tình mà thôi." (ca dao)',
  },
  {
    word: "thành ý",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) ý nghĩ, ý định thành thực: tỏ thành ý * ghi nhận thành ý của bạn bè",
    example: "tỏ thành ý * ghi nhận thành ý của bạn bè",
  },
  {
    word: "thành ý",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) có ý định tốt và chân thành: thành tâm, thành ý giúp đỡ bạn",
    example: "thành tâm, thành ý giúp đỡ bạn",
  },
  {
    word: "thanh u",
    part_of_speech: "tính từ",
    meaning:
      '(hiếm) như u tịch: "Đến đây thực cảnh thanh u, Tắm sông chơi với ngày thu lo gì." (PCCH)',
    example:
      'Đến đây thực cảnh thanh u, Tắm sông chơi với ngày thu lo gì." (PCCH)',
  },
  {
    word: "thanh vân",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) mây xanh; chỉ bước đường công danh: "Mấy phen lần bước dặm thanh vân, Đeo lợi làm chi luống nhục thân." (QÂTT)',
    example:
      'Mấy phen lần bước dặm thanh vân, Đeo lợi làm chi luống nhục thân." (QÂTT)',
  },
  {
    word: "thanh xuân",
    part_of_speech: "tính từ",
    meaning: "(văn chương) tươi trẻ, tràn đầy sức sống: tuổi thanh xuân",
    example: "tuổi thanh xuân",
  },
  {
    word: "thạo",
    part_of_speech: "tính từ",
    meaning:
      "biết tới mức có thể làm, sử dụng một cách dễ dàng, nhanh nhẹn, không có gì lúng túng: đọc thông viết thạo * không thạo đường nên bị lạc",
    example: "đọc thông viết thạo * không thạo đường nên bị lạc",
  },
  {
    word: "thao",
    part_of_speech: "danh từ",
    meaning: "tơ sợi thô và to, chưa sạch gút: sợi thao",
    example: "sợi thao",
  },
  {
    word: "thao",
    part_of_speech: "danh từ",
    meaning: "hàng dệt bằng thao: khăn thao",
    example: "khăn thao",
  },
  {
    word: "thao",
    part_of_speech: "danh từ",
    meaning: "tua kết bằng tơ, chỉ: nón quai thao",
    example: "nón quai thao",
  },
  {
    word: "tháo",
    part_of_speech: "động từ",
    meaning:
      "làm cho các chi tiết, bộ phận được lắp ghép rời ra khỏi chỉnh thể: cỗ máy bị tháo tung * đan lỗi, phải tháo mất một đoạn",
    example: "cỗ máy bị tháo tung * đan lỗi, phải tháo mất một đoạn",
  },
  {
    word: "tháo",
    part_of_speech: "động từ",
    meaning:
      "cởi ra, bỏ ra cái đang mang trên mình: tháo băng * tháo ách cho trâu",
    example: "tháo băng * tháo ách cho trâu",
  },
  {
    word: "tháo",
    part_of_speech: "động từ",
    meaning:
      "làm cho thoát ra khỏi tình trạng bị ngăn giữ, ứ đọng: tháo van xả khí * nước chảy như tháo cống",
    example: "tháo van xả khí * nước chảy như tháo cống",
  },
  {
    word: "tháo",
    part_of_speech: "động từ",
    meaning:
      "(chất bài tiết) thoát ra ngoài cơ thể nhiều và mạnh: nôn tháo ra * chạy tháo mồ hôi hột",
    example: "nôn tháo ra * chạy tháo mồ hôi hột",
  },
  {
    word: "thành viên",
    part_of_speech: "danh từ",
    meaning:
      "người hoặc đơn vị với tư cách là thành phần của một tổ chức, một tập thể: các nước thành viên Liên Hợp Quốc * thành viên ban chấp hành",
    example: "các nước thành viên Liên Hợp Quốc * thành viên ban chấp hành",
  },
  {
    word: "thanh y",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) áo xanh; chỉ người đầy tớ gái nhà quyền quý (đầy tớ gái nhà giàu thời xưa ở Trung Quốc thường mặc áo màu xanh): "Ra vào theo lũ thanh y, Dãi dầu tóc rối, da chì quản bao." (TKiều)',
    example:
      'Ra vào theo lũ thanh y, Dãi dầu tóc rối, da chì quản bao." (TKiều)',
  },
  {
    word: "tháo chạy",
    part_of_speech: "động từ",
    meaning:
      "chạy thật nhanh để tìm cách thoát ra khỏi tình trạng bị bao vây hoặc nguy hiểm: quân địch tháo chạy tán loạn",
    example: "quân địch tháo chạy tán loạn",
  },
  {
    word: "thảo",
    part_of_speech: "danh từ",
    meaning: "(hiếm) cây thân cỏ: lúa là cây thuộc họ thảo",
    example: "lúa là cây thuộc họ thảo",
  },
  {
    word: "thảo",
    part_of_speech: "động từ",
    meaning:
      "viết phác ra lần đầu cho thành bài, thành bản với một nội dung nhất định để sau đó còn xem xét, sửa chữa và hoàn chỉnh lại: thảo công văn * thảo bức thư trả lời",
    example: "thảo công văn * thảo bức thư trả lời",
  },
  {
    word: "thảo",
    part_of_speech: "động từ",
    meaning:
      "viết tháu chữ Hán, chữ Nôm, nét nọ liền nét kia và thường có bỏ bớt đi một số nét: câu đối viết bằng chữ thảo",
    example: "câu đối viết bằng chữ thảo",
  },
  {
    word: "thảo",
    part_of_speech: "tính từ",
    meaning:
      "rộng rãi, có lòng tốt, hay chia sẻ, nhường nhịn cho người khác: thảo ăn * tính con bé rất thảo",
    example: "thảo ăn * tính con bé rất thảo",
  },
  {
    word: "thảo",
    part_of_speech: "tính từ",
    meaning:
      "biết ăn ở phải đạo, quan tâm chăm sóc cha mẹ và những người bề trên trong gia đình: dâu hiền, rể thảo",
    example: "dâu hiền, rể thảo",
  },
  {
    word: "tháo dỡ",
    part_of_speech: "động từ",
    meaning:
      "tháo rời và lấy ra lần lượt từng cái, từng bộ phận hoặc từng thứ một (nói khái quát): tháo dỡ nhà cửa * tháo dỡ hàng hoá",
    example: "tháo dỡ nhà cửa * tháo dỡ hàng hoá",
  },
  {
    word: "thao diễn",
    part_of_speech: "động từ",
    meaning:
      "trình diễn các thao tác kĩ thuật với số đông người để tập dượt, trao đổi kinh nghiệm: thao diễn kĩ thuật bay cứu nạn trên biển * thao diễn vũ thuật",
    example: "thao diễn kĩ thuật bay cứu nạn trên biển * thao diễn vũ thuật",
  },
  {
    word: "thảo khấu",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) kẻ cướp ở nơi rừng núi hẻo lánh, thời xưa: diệt trừ thảo khấu * phường lục lâm thảo khấu",
    example: "diệt trừ thảo khấu * phường lục lâm thảo khấu",
  },
  {
    word: "thảo hèn",
    part_of_speech: "kết từ",
    meaning: "(phương ngữ) thảo nào: hổm rày nó ốm, thảo hèn không thấy đi học",
    example: "hổm rày nó ốm, thảo hèn không thấy đi học",
  },
  {
    word: "thảo dược",
    part_of_speech: "danh từ",
    meaning: "cây dùng làm thuốc chữa bệnh: trồng được loại thảo dược quý",
    example: "trồng được loại thảo dược quý",
  },
  {
    word: "thạo đời",
    part_of_speech: "tính từ",
    meaning:
      "sành sỏi việc đời và biết cách đối phó, ứng xử khéo léo trong mọi việc (thường hàm ý chê): ra vẻ thạo đời * một tay thạo đời",
    example: "ra vẻ thạo đời * một tay thạo đời",
  },
  {
    word: "tháo gỡ",
    part_of_speech: "động từ",
    meaning: "tháo bỏ, phá bỏ đi cái ngăn cản, gây nguy hiểm: tháo gỡ mìn",
    example: "tháo gỡ mìn",
  },
  {
    word: "tháo gỡ",
    part_of_speech: "động từ",
    meaning:
      "giải quyết từng bước, làm cho không còn khó khăn, vướng mắc nữa: khó khăn đã được tháo gỡ",
    example: "khó khăn đã được tháo gỡ",
  },
  {
    word: "thảo dã",
    part_of_speech: "tính từ",
    meaning:
      "(cũ) thuộc nơi thôn quê hẻo lánh hoặc có tính chất quê mùa, thôn dã: nơi thảo dã * món ăn miền thảo dã",
    example: "nơi thảo dã * món ăn miền thảo dã",
  },
  {
    word: "tháo cũi sổ lồng",
    part_of_speech: "",
    meaning:
      'ví việc giải phóng, làm cho thoát cảnh bị giam hãm, tù túng và được tự do: "Thuyền quyên ví biết anh hùng, Ra tay tháo cũi sổ lồng như chơi!" (TKiều)',
    example:
      'Thuyền quyên ví biết anh hùng, Ra tay tháo cũi sổ lồng như chơi!" (TKiều)',
  },
  {
    word: "tháo khoán",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) để cho được tự do làm điều mà trước đây vốn bị hạn chế, ngăn giữ, kiểm soát: chủ thầu tháo khoán, cho thợ nghỉ một buổi",
    example: "chủ thầu tháo khoán, cho thợ nghỉ một buổi",
  },
  {
    word: "thao láo",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) (mắt) mở to, nhìn lâu không chớp: mắt mở thao láo",
    example: "mắt mở thao láo",
  },
  {
    word: "thảo luận",
    part_of_speech: "động từ",
    meaning:
      "trao đổi ý kiến, có phân tích lí lẽ, để làm sáng tỏ một vấn đề mà nhiều người đang cùng quan tâm đến: thảo luận về bản dự thảo hiến pháp * đưa vấn đề ra thảo luận",
    example: "thảo luận về bản dự thảo hiến pháp * đưa vấn đề ra thảo luận",
  },
  {
    word: "thảo lảo",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) rất thảo, hay chia sẻ, hay nhường nhịn (nói khái quát): con bé tính nết thảo lảo",
    example: "con bé tính nết thảo lảo",
  },
  {
    word: "tháo lui",
    part_of_speech: "động từ",
    meaning:
      "rút chạy để bảo toàn tính mạng, lực lượng: bị truy đuổi, toán phỉ tháo lui vào rừng sâu",
    example: "bị truy đuổi, toán phỉ tháo lui vào rừng sâu",
  },
  {
    word: "tháo lui",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) rút lui để trốn tránh: tháo lui vì sợ khó khăn",
    example: "tháo lui vì sợ khó khăn",
  },
  {
    word: "thao luyện",
    part_of_speech: "động từ",
    meaning:
      "luyện tập cho thành thục để nâng cao kĩ năng, kĩ thuật (thường nói về số đông người): thao luyện binh mã",
    example: "thao luyện binh mã",
  },
  {
    word: "thảo nào",
    part_of_speech: "kết từ",
    meaning:
      "tổ hợp biểu thị điều vừa nói đến là lí do để giải thích, làm cho điều sắp nêu ra không còn có gì phải ngạc nhiên nữa: bài toán khó thế, thảo nào nó không làm được",
    example: "bài toán khó thế, thảo nào nó không làm được",
  },
  {
    word: "thao lược",
    part_of_speech: "danh từ",
    meaning: "(cũ) phép dùng binh: tài thao lược",
    example: "tài thao lược",
  },
  {
    word: "thao lược",
    part_of_speech: "tính từ",
    meaning:
      "rất tài giỏi, biết cách ứng biến trong phép dùng binh, hoặc trong công việc: viên tướng nổi tiếng là người thao lược",
    example: "viên tướng nổi tiếng là người thao lược",
  },
  {
    word: "thảo mộc",
    part_of_speech: "danh từ",
    meaning: "cây cỏ, cây cối nói chung: dầu thảo mộc * các loài thảo mộc",
    example: "dầu thảo mộc * các loài thảo mộc",
  },
  {
    word: "thao tác",
    part_of_speech: "",
    meaning:
      "thực hiện những động tác kĩ thuật để hoàn thành một công việc gì đó: thao tác tháo lắp súng * thao tác vận hành máy",
    example: "thao tác tháo lắp súng * thao tác vận hành máy",
  },
  {
    word: "thào thào",
    part_of_speech: "tính từ",
    meaning:
      "(giọng nói) nhỏ và yếu, tựa như hơi gió thoảng qua (thường do mệt hoặc do quá yếu): nói thào thào * giọng thào thào, nghe không rõ",
    example: "nói thào thào * giọng thào thào, nghe không rõ",
  },
  {
    word: "thao thức",
    part_of_speech: "động từ",
    meaning:
      "trằn trọc, trăn trở không sao ngủ được vì có điều phải suy nghĩ, không yên: trở mình thao thức * thao thức suốt canh khuya",
    example: "trở mình thao thức * thao thức suốt canh khuya",
  },
  {
    word: "thao thao",
    part_of_speech: "tính từ",
    meaning:
      "(cách nói năng) sôi nổi, liên hồi: nói thao thao * mồm mép cứ thao thao",
    example: "nói thao thao * mồm mép cứ thao thao",
  },
  {
    word: "thao thao bất tuyệt",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) (nói hoặc viết) liên hồi, hết cái này sang cái kia, tưởng như không bao giờ dứt: nói thao thao bất tuyệt",
    example: "nói thao thao bất tuyệt",
  },
  {
    word: "tháo thân",
    part_of_speech: "động từ",
    meaning:
      "trốn chạy thục mạng để mong được thoát thân: tìm cách tháo thân * chạy tháo thân",
    example: "tìm cách tháo thân * chạy tháo thân",
  },
  {
    word: "thao trường",
    part_of_speech: "danh từ",
    meaning:
      "bãi rộng dùng làm nơi luyện tập quân sự: diễn tập trên thao trường",
    example: "diễn tập trên thao trường",
  },
  {
    word: "thao túng",
    part_of_speech: "động từ",
    meaning:
      "nắm giữ và chi phối, bắt phải hành động theo ý của mình: các tổ chức độc quyền mặc sức thao túng thị trường",
    example: "các tổ chức độc quyền mặc sức thao túng thị trường",
  },
  {
    word: "tháp",
    part_of_speech: "danh từ",
    meaning:
      "công trình xây dựng có chiều cao lớn hơn nhiều so với chiều ngang (thường có nhiều tầng và phần trên đỉnh có hình chóp): toà tháp đôi * tháp chuông nhà thờ * tháp vô tuyến truyền hình",
    example: "toà tháp đôi * tháp chuông nhà thờ * tháp vô tuyến truyền hình",
  },
  {
    word: "tháp",
    part_of_speech: "danh từ",
    meaning: "bộ phận có hình thon tròn dần lên của một số vật: tháp bút",
    example: "tháp bút",
  },
  {
    word: "tháp",
    part_of_speech: "động từ",
    meaning: "(phương ngữ)",
    example: "kĩ thuật tháp cành nhân giống",
  },
  {
    word: "tháo vát",
    part_of_speech: "tính từ",
    meaning:
      "giỏi giang, nhanh nhẹn, biết xoay xở tìm cách này cách khác để giải quyết tốt mọi công việc trong những lúc khó khăn: một cô gái tháo vát * làm ăn tháo vát",
    example: "một cô gái tháo vát * làm ăn tháo vát",
  },
  {
    word: "thạp",
    part_of_speech: "danh từ",
    meaning:
      "đồ đựng thường làm bằng sành hoặc đồng, cỡ tương đối lớn, miệng tròn và rộng, bụng phình, đáy hơi thót lại: thạp gạo",
    example: "thạp gạo",
  },
  {
    word: "tháp canh",
    part_of_speech: "danh từ",
    meaning: "chòi cao để quan sát, canh gác, chiến đấu: dựng tháp canh",
    example: "dựng tháp canh",
  },
  {
    word: "thau",
    part_of_speech: "danh từ",
    meaning:
      "hợp kim đồng với kẽm, màu vàng, dễ dát mỏng, thường dùng để làm một số vật dụng như mâm, chậu rửa mặt: vàng thau lẫn lộn",
    example: "vàng thau lẫn lộn",
  },
  {
    word: "thau",
    part_of_speech: "danh từ",
    meaning:
      "(Nam) chậu (đựng nước); chậu thau: thau rửa mặt * múc một thau nước",
    example: "thau rửa mặt * múc một thau nước",
  },
  {
    word: "thau",
    part_of_speech: "động từ",
    meaning:
      "cọ rửa sạch và xả hết nước cũ trong đồ chứa đựng như chum, vại, bể, v.v. để chứa đựng nước mới: thau bể để hứng nước mưa",
    example: "thau bể để hứng nước mưa",
  },
  {
    word: "thau",
    part_of_speech: "động từ",
    meaning:
      "(Ít dùng) tan ra dễ dàng (thường nói về thức ăn cho vào miệng): viên kẹo thau dần trong miệng",
    example: "viên kẹo thau dần trong miệng",
  },
  {
    word: "tháp tùng",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) đi cùng để giúp việc cho một nhân vật lãnh đạo cao cấp: tháp tùng thủ tướng trong chuyến công du * nhân viên tháp tùng",
    example: "tháp tùng thủ tướng trong chuyến công du * nhân viên tháp tùng",
  },
  {
    word: "tháu",
    part_of_speech: "tính từ",
    meaning:
      "(lối viết chữ) nhanh, không đầy đủ và rõ ràng từng nét: chữ viết tháu nên rất khó đọc",
    example: "chữ viết tháu nên rất khó đọc",
  },
  {
    word: "tháp ngà",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương) tháp làm bằng ngà; ví cái thế giới cao siêu, xa vời của những tri thức sách vở và ý nghĩ chủ quan, nơi mà trong đó người trí thức, văn nghệ sĩ náu mình, thoát li thực tế đời sống: giấu mình trong tháp ngà",
    example: "giấu mình trong tháp ngà",
  },
  {
    word: "thay",
    part_of_speech: "động từ",
    meaning:
      "bỏ ra, đưa ra khỏi vị trí và thế vào đó một cái khác, người khác có cùng một chức năng (nhưng thường là tốt hơn, thích hợp hơn): thay băng * cây đang thay lá * thay thầy đổi chủ (tng)",
    example: "thay băng * cây đang thay lá * thay thầy đổi chủ (tng)",
  },
  {
    word: "thay",
    part_of_speech: "động từ",
    meaning:
      "đảm nhiệm chức năng vốn trước đây là của người khác, cái khác: thay cha dạy dỗ đàn em nhỏ * của đi thay người (tng)",
    example: "thay cha dạy dỗ đàn em nhỏ * của đi thay người (tng)",
  },
  {
    word: "thay",
    part_of_speech: "động từ",
    meaning:
      "làm phần việc mà đáng ra người khác phải làm: nhờ người kí thay * đi họp thay",
    example: "nhờ người kí thay * đi họp thay",
  },
  {
    word: "thay",
    part_of_speech: "cảm từ",
    meaning:
      "(Văn chương) từ biểu thị một cảm xúc hết sức mạnh mẽ trước tác động của một điều hay sự việc gì đó: tiếc thay! * buồn thay! * lạ lắm thay!",
    example: "tiếc thay! * buồn thay! * lạ lắm thay!",
  },
  {
    word: "thau tháu",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) nhanh và nhẹ nhàng, với vẻ dễ dàng: viết thau tháu * làm thau tháu",
    example: "viết thau tháu * làm thau tháu",
  },
  {
    word: "thay bậc đổi ngôi",
    part_of_speech: "",
    meaning:
      '(cũ) thay đổi thứ bậc, địa vị, làm đảo lộn tình thế, trật tự: "Giờ ra thay bậc đổi ngôi, Dám xin gửi lại một lời cho minh." (TKiều)',
    example:
      'Giờ ra thay bậc đổi ngôi, Dám xin gửi lại một lời cho minh." (TKiều)',
  },
  {
    word: "thay da đổi thịt",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) ví sự biến đổi khác trước một cách rõ rệt và trở nên tốt đẹp hơn: vùng quê đang bắt đầu thay da đổi thịt",
    example: "vùng quê đang bắt đầu thay da đổi thịt",
  },
  {
    word: "thày lay",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) xen vào việc của người khác, không dính dáng đến mình: tính con nhỏ hay thày lay hớt lẻo * miệng thế thày lay",
    example: "tính con nhỏ hay thày lay hớt lẻo * miệng thế thày lay",
  },
  {
    word: "thảy",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) quăng, ném đi: thảy trái lựu đạn",
    example: "thảy trái lựu đạn",
  },
  {
    word: "thảy",
    part_of_speech: "đại từ",
    meaning:
      "(cũ) tất cả, không trừ một ai, một cái gì: cha mẹ thảy đều già cả",
    example: "cha mẹ thảy đều già cả",
  },
  {
    word: "thay lòng đổi dạ",
    part_of_speech: "",
    meaning:
      "trở nên phụ bạc, không giữ được lòng chung thuỷ hay trung thành như trước nữa: dẫu chết cũng không thay lòng đổi dạ",
    example: "dẫu chết cũng không thay lòng đổi dạ",
  },
  {
    word: "thay đổi",
    part_of_speech: "động từ",
    meaning:
      "thay cái này bằng cái khác (nói khái quát): thay đổi trang phục * thay đổi ý định",
    example: "thay đổi trang phục * thay đổi ý định",
  },
  {
    word: "thay đổi",
    part_of_speech: "động từ",
    meaning:
      "đổi khác, trở nên khác trước (nói khái quát): cảnh vật thay đổi * thay đổi thời tiết * thay đổi sắc mặt",
    example: "cảnh vật thay đổi * thay đổi thời tiết * thay đổi sắc mặt",
  },
  {
    word: "thay mặt",
    part_of_speech: "động từ",
    meaning:
      "lấy tư cách của người hay tổ chức nào đó để đứng ra làm việc gì: thay mặt gia đình xin cảm ơn mọi người",
    example: "thay mặt gia đình xin cảm ơn mọi người",
  },
  {
    word: "thay thế",
    part_of_speech: "động từ",
    meaning:
      "thay vào chỗ của cái bị mất hoặc không còn thích hợp nữa: phụ tùng thay thế * tìm người thay thế",
    example: "phụ tùng thay thế * tìm người thay thế",
  },
  {
    word: "thay vì",
    part_of_speech: "",
    meaning:
      "tổ hợp biểu thị điều sắp nêu là điều lẽ ra phải như vậy nhưng thực tế lại diễn ra khác: thay vì học bài, nó lại đi ngủ sớm",
    example: "thay vì học bài, nó lại đi ngủ sớm",
  },
  {
    word: "thắc mắc",
    part_of_speech: "",
    meaning:
      "cảm thấy còn có điều chưa hiểu, chưa thông nên muốn được giải đáp: không hiểu nên còn thắc mắc * giải quyết những thắc mắc cá nhân",
    example: "không hiểu nên còn thắc mắc * giải quyết những thắc mắc cá nhân",
  },
  {
    word: "thắc thỏm",
    part_of_speech: "động từ",
    meaning: "(hiếm) như thấp thỏm: lòng thắc thỏm, lo âu",
    example: "lòng thắc thỏm, lo âu",
  },
  {
    word: "thăm hỏi",
    part_of_speech: "động từ",
    meaning:
      "thăm và hỏi han tình hình nhằm tỏ sự quan tâm (nói khái quát): thăm hỏi sức khoẻ * viết thư thăm hỏi",
    example: "thăm hỏi sức khoẻ * viết thư thăm hỏi",
  },
  {
    word: "thắm",
    part_of_speech: "tính từ",
    meaning:
      '(màu sắc) đậm và tươi (thường nói về màu đỏ): chỉ thắm * màu lá xanh thắm * "Thế gian lắm kẻ mơ màng, Thấy hòn son thắm ngỡ vàng nhặt đeo." (ca dao)',
    example:
      'chỉ thắm * màu lá xanh thắm * "Thế gian lắm kẻ mơ màng, Thấy hòn son thắm ngỡ vàng nhặt đeo." (ca dao)',
  },
  {
    word: "thắm",
    part_of_speech: "tính từ",
    meaning: "(tình cảm) đậm đà, nồng ấm: thắm tình quê hương",
    example: "thắm tình quê hương",
  },
  {
    word: "thẳm",
    part_of_speech: "tính từ",
    meaning:
      'rất sâu hay rất xa, nhìn đến hút tầm mắt, đến như không còn nhận thấy ra đâu là cùng, là tận: vực thẳm * "Nghĩ điều trời thẳm vực sâu, Bóng chim tăm cá, biết đâu mà nhìn!" (TKiều)',
    example:
      'vực thẳm * "Nghĩ điều trời thẳm vực sâu, Bóng chim tăm cá, biết đâu mà nhìn!" (TKiều)',
  },
  {
    word: "thăm",
    part_of_speech: "danh từ",
    meaning:
      "vật quy ước ứng với phần mà mỗi người sẽ được nhận (trong một sự phân phối, phân chia dựa vào may rủi): bốc được lá thăm may mắn * rút thăm chia phần",
    example: "bốc được lá thăm may mắn * rút thăm chia phần",
  },
  {
    word: "thăm",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) phiếu bầu cử: đi bỏ thăm",
    example: "đi bỏ thăm",
  },
  {
    word: "thăm",
    part_of_speech: "động từ",
    meaning:
      "(đến với ai hoặc nơi nào đó) hỏi han cho biết tình hình, nhằm tỏ sự quan tâm: đi thăm người ốm * về thăm quê",
    example: "đi thăm người ốm * về thăm quê",
  },
  {
    word: "thăm",
    part_of_speech: "động từ",
    meaning:
      "đến nơi nào đó để xem xét, tìm hiểu cho biết qua tình hình: đi thăm lúa",
    example: "đi thăm lúa",
  },
  {
    word: "thăm",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) khám (bệnh): thăm bệnh",
    example: "thăm bệnh",
  },
  {
    word: "thăm dò",
    part_of_speech: "động từ",
    meaning:
      "tìm hiểu bằng cách dò hỏi, dò xét một cách kín đáo để biết ý kiến, thái độ hoặc sự phản ứng của người khác: thăm dò ý kiến * thăm dò thái độ",
    example: "thăm dò ý kiến * thăm dò thái độ",
  },
  {
    word: "thăm dò",
    part_of_speech: "động từ",
    meaning:
      "khảo sát, tìm hiểu để đánh giá trữ lượng và chất lượng của tài nguyên thiên nhiên: thăm dò địa chất",
    example: "thăm dò địa chất",
  },
  {
    word: "thăm khám",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) thăm bệnh, khám bệnh (nói khái quát): bác sĩ thăm khám cho người bệnh",
    example: "bác sĩ thăm khám cho người bệnh",
  },
  {
    word: "thăm nuôi",
    part_of_speech: "động từ",
    meaning: "thăm và tiếp tế cho người tù: không có người thăm nuôi",
    example: "không có người thăm nuôi",
  },
  {
    word: "thăm thẳm",
    part_of_speech: "tính từ",
    meaning:
      "như thẳm (nhưng ý mức độ nhiều hơn): vực sâu thăm thẳm * đôi mắt buồn thăm thẳm",
    example: "vực sâu thăm thẳm * đôi mắt buồn thăm thẳm",
  },
  {
    word: "thắm thiết",
    part_of_speech: "tính từ",
    meaning:
      '(tình cảm) rất đậm đà, sâu sắc: tình bạn thắm thiết * "Từ khi đá biết tuổi vàng, Lòng càng thắm thiết, dạ càng ngẩn ngơ." (ca dao)',
    example:
      'tình bạn thắm thiết * "Từ khi đá biết tuổi vàng, Lòng càng thắm thiết, dạ càng ngẩn ngơ." (ca dao)',
  },
  {
    word: "thăm nom",
    part_of_speech: "động từ",
    meaning: "thăm và trông nom, săn sóc (nói khái quát): thăm nom người ốm",
    example: "thăm nom người ốm",
  },
  {
    word: "thăm thú",
    part_of_speech: "động từ",
    meaning:
      "thăm chỗ này chỗ khác để xem xét, để biết (nói khái quát): thăm thú tình hình * được đi thăm thú nhiều nơi",
    example: "thăm thú tình hình * được đi thăm thú nhiều nơi",
  },
  {
    word: "thăm ván bán thuyền",
    part_of_speech: "",
    meaning:
      'ví người ăn ở không chung thuỷ, vừa có cái mới đã phụ bạc, rẻ rúng cái cũ: "Làm cho trông thấy nhãn tiền, Cho người thăm ván bán thuyền biết tay." (TKiều)',
    example:
      'Làm cho trông thấy nhãn tiền, Cho người thăm ván bán thuyền biết tay." (TKiều)',
  },
  {
    word: "thăm viếng",
    part_of_speech: "động từ",
    meaning: "đi thăm (nói khái quát): thăm viếng họ hàng",
    example: "thăm viếng họ hàng",
  },
  {
    word: "thăn",
    part_of_speech: "danh từ",
    meaning:
      "phần thịt toàn nạc được lọc ra ở phần lưng của súc vật khi mổ thịt: miếng thăn lợn * thịt thăn",
    example: "miếng thăn lợn * thịt thăn",
  },
  {
    word: "thằn lằn",
    part_of_speech: "danh từ",
    meaning:
      "(Bắc) (Nam rắn mối) động vật thuộc nhóm bò sát, thân và đuôi dài phủ vảy bóng màu nâu sẫm, bốn chi khoẻ, sống ở bờ bụi, ăn sâu bọ",
    example: "hai con thằn lằn con",
  },
  {
    word: "thằng",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng cá nhân người đàn ông, con trai thuộc hàng dưới hoặc ngang hàng, với ý thân mật hoặc không tôn trọng: thằng bé * thằng lưu manh * dở ông dở thằng (tng)",
    example: "thằng bé * thằng lưu manh * dở ông dở thằng (tng)",
  },
  {
    word: "thắng",
    part_of_speech: "động từ",
    meaning: "đun nóng cho đường chảy tan ra: thắng nước hàng",
    example: "thắng nước hàng",
  },
  {
    word: "thắng",
    part_of_speech: "động từ",
    meaning: "(Phương ngữ) rán (mỡ): thắng mỡ heo",
    example: "thắng mỡ heo",
  },
  {
    word: "thắng",
    part_of_speech: "động từ",
    meaning:
      'đóng yên cương vào ngựa hoặc buộc ngựa vào xe: thắng xe * "Ngựa ô anh thắng kiệu vàng, Anh tra khớp bạc đưa nàng về dinh." (Cdao)',
    example:
      'thắng xe * "Ngựa ô anh thắng kiệu vàng, Anh tra khớp bạc đưa nàng về dinh." (Cdao)',
  },
  {
    word: "thắng",
    part_of_speech: "động từ",
    meaning: "(Khẩu ngữ) mặc, diện quần áo đẹp: thắng bộ quần áo mới",
    example: "thắng bộ quần áo mới",
  },
  {
    word: "thắng",
    part_of_speech: "động từ",
    meaning:
      "giành được phần hơn trong một cuộc đọ sức, thi tài: giành phần thắng * thắng không kiêu, bại không nản",
    example: "giành phần thắng * thắng không kiêu, bại không nản",
  },
  {
    word: "thắng",
    part_of_speech: "động từ",
    meaning:
      "khắc phục được, chế ngự được, vượt qua được khó khăn thử thách: thắng được đói nghèo, bệnh tật",
    example: "thắng được đói nghèo, bệnh tật",
  },
  {
    word: "thắng",
    part_of_speech: "động từ",
    meaning: "(Nam) phanh: Bộ phận này dùng để thắng xe lại.",
    example: "Bộ phận này dùng để thắng xe lại.",
  },
  {
    word: "thắng",
    part_of_speech: "danh từ",
    meaning: "(Nam) phanh: Thắng xe bị mòn, phải thay.",
    example: "Thắng xe bị mòn, phải thay.",
  },
  {
    word: "thăng bằng",
    part_of_speech: "danh từ",
    meaning:
      "thế của một vị trí tự giữ được không bị chao đảo, ngả nghiêng: diễn viên xiếc giữ thăng bằng trên dây * mất thăng bằng nên bị ngã",
    example:
      "diễn viên xiếc giữ thăng bằng trên dây * mất thăng bằng nên bị ngã",
  },
  {
    word: "thăng bằng",
    part_of_speech: "danh từ",
    meaning:
      "trạng thái tâm lí ổn định, không có sự dao động, ngả nghiêng: lấy lại thăng bằng * tâm trạng mất thăng bằng",
    example: "lấy lại thăng bằng * tâm trạng mất thăng bằng",
  },
  {
    word: "thăng bằng",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) làm cho trở thành ngang bằng, cho các mặt đối lập tương đương nhau, có tác dụng bù trừ lẫn nhau: thăng bằng thu chi",
    example: "thăng bằng thu chi",
  },
  {
    word: "thăng",
    part_of_speech: "động từ",
    meaning:
      "(cũ, hoặc kng) nâng lên một chức vụ, cấp bậc cao hơn: thăng quân hàm vượt cấp * thăng chức",
    example: "thăng quân hàm vượt cấp * thăng chức",
  },
  {
    word: "thăng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ, hiếm) thăng thiên (nói tắt): thánh phán mấy câu rồi thăng",
    example: "thánh phán mấy câu rồi thăng",
  },
  {
    word: "thăng",
    part_of_speech: "danh từ",
    meaning:
      "dấu có hình (e) đặt trước nốt nhạc để biểu thị nốt nhạc được nâng cao lên nửa cung: dấu thăng * fa thăng",
    example: "dấu thăng * fa thăng",
  },
  {
    word: "thẳng băng",
    part_of_speech: "tính từ",
    meaning:
      "rất thẳng, thành một đường, một mạch, không cong vẹo, không có sự cản trở nào: đường thẳng băng * công việc được tiến hành thẳng băng",
    example: "đường thẳng băng * công việc được tiến hành thẳng băng",
  },
  {
    word: "thẳng băng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) rất thẳng thắn, ngay thật, không quanh co, không vì nể gì: trả lời thẳng băng",
    example: "trả lời thẳng băng",
  },
  {
    word: "thắng bại",
    part_of_speech: "động từ",
    meaning:
      "được hay thua, thắng hay bại (nói khái quát): cuộc chiến đấu bất phân thắng bại",
    example: "cuộc chiến đấu bất phân thắng bại",
  },
  {
    word: "thẳng",
    part_of_speech: "tính từ",
    meaning:
      "theo một hướng nhất định, không một chỗ, một lúc nào chệch, không cong, không gãy gập: sống mũi cao và thẳng * mắt nhìn thẳng về phía trước * thẳng hướng nam mà đi",
    example:
      "sống mũi cao và thẳng * mắt nhìn thẳng về phía trước * thẳng hướng nam mà đi",
  },
  {
    word: "thẳng",
    part_of_speech: "tính từ",
    meaning:
      "không kiêng nể, không che giấu, không úp mở, dám nói lên sự thật hoặc nói đúng những điều mình nghĩ: nói thẳng * tính rất thẳng, có gì không vừa ý là nói ngay",
    example: "nói thẳng * tính rất thẳng, có gì không vừa ý là nói ngay",
  },
  {
    word: "thẳng",
    part_of_speech: "tính từ",
    meaning:
      "(làm việc gì) liên tục, liền một mạch từ đầu đến cuối, không một lúc nào ngừng nghỉ, gián đoạn hay bị cản trở: xe đâm thẳng xuống vực sâu * xông thẳng vào nhà",
    example: "xe đâm thẳng xuống vực sâu * xông thẳng vào nhà",
  },
  {
    word: "thẳng",
    part_of_speech: "tính từ",
    meaning:
      "(làm việc gì) trực tiếp, không qua một khâu trung gian nào cả: nói thẳng vào mặt * trình bày thẳng với giám đốc",
    example: "nói thẳng vào mặt * trình bày thẳng với giám đốc",
  },
  {
    word: "thẳng",
    part_of_speech: "tính từ",
    meaning:
      "(hành động) ngay và dứt khoát, không chần chừ: quay đầu đi thẳng * ăn xong thì chuồn thẳng",
    example: "quay đầu đi thẳng * ăn xong thì chuồn thẳng",
  },
  {
    word: "thắng cảnh",
    part_of_speech: "danh từ",
    meaning: "cảnh đẹp nổi tiếng: thắng cảnh Hương Sơn",
    example: "thắng cảnh Hương Sơn",
  },
  {
    word: "thẳng cẳng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (nằm) ngay đơ ra, không động đậy: nằm thẳng cẳng ở giữa nhà",
    example: "nằm thẳng cẳng ở giữa nhà",
  },
  {
    word: "thẳng cánh",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) không một chút nương nhẹ, không dè dặt: đuổi thẳng cánh * trừng trị thẳng cánh",
    example: "đuổi thẳng cánh * trừng trị thẳng cánh",
  },
  {
    word: "thằng chả",
    part_of_speech: "đại từ",
    meaning: "(phương ngữ, khẩu ngữ) thằng cha ấy: thằng chả nói dóc đó",
    example: "thằng chả nói dóc đó",
  },
  {
    word: "thằng cha",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) tổ hợp dùng để chỉ người đàn ông nào đó với ý thân mật hoặc coi thường: thằng cha ấy thế mà giỏi! * thằng cha lang băm",
    example: "thằng cha ấy thế mà giỏi! * thằng cha lang băm",
  },
  {
    word: "thặng dư",
    part_of_speech: "tính từ",
    meaning:
      "(phần) ở trên mức cần thiết: mức thặng dư mậu dịch * giá trị thặng dư",
    example: "mức thặng dư mậu dịch * giá trị thặng dư",
  },
  {
    word: "thẳng đuồn đuột",
    part_of_speech: "tính từ",
    meaning: "thẳng đuột một đường, trông cứng và thô: lưng thẳng đuồn đuột",
    example: "lưng thẳng đuồn đuột",
  },
  {
    word: "thăng hạng",
    part_of_speech: "động từ",
    meaning: "lên hạng (trong thể thao): đội bóng mới thăng hạng",
    example: "đội bóng mới thăng hạng",
  },
  {
    word: "thăng đường",
    part_of_speech: "động từ",
    meaning: "(cũ) (quan lại) lên công đường làm việc: thăng đường xử án",
    example: "thăng đường xử án",
  },
  {
    word: "thẳng đứng",
    part_of_speech: "tính từ",
    meaning:
      "thẳng theo chiều dựng đứng, vuông góc với mặt đất: vách núi thẳng đứng * đo theo chiều thẳng đứng",
    example: "vách núi thẳng đứng * đo theo chiều thẳng đứng",
  },
  {
    word: "thăng giáng",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) thăng chức và giáng chức (nói khái quát): xét công để thăng giáng",
    example: "xét công để thăng giáng",
  },
  {
    word: "thẳng đuột",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) thẳng một đường, không có chỗ nào cong queo: thân cau thẳng đuột * người thẳng đuột như khúc gỗ",
    example: "thân cau thẳng đuột * người thẳng đuột như khúc gỗ",
  },
  {
    word: "thẳng đuột",
    part_of_speech: "tính từ",
    meaning:
      "(tính tình, cách nói năng) quá thẳng thắn, bộc trực đến mức thái quá: nói thẳng đuột, chẳng nể nang ai",
    example: "nói thẳng đuột, chẳng nể nang ai",
  },
  {
    word: "thẳng đuỗn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) thẳng và cứng đờ ra, trông không tự nhiên, không mềm mại: lưng thẳng đuỗn * mặt thẳng đuỗn",
    example: "lưng thẳng đuỗn * mặt thẳng đuỗn",
  },
  {
    word: "thắng lợi",
    part_of_speech: "động từ",
    meaning:
      "giành được phần thắng trong đấu tranh, hoặc đạt được kết quả tốt đẹp trong một hoạt động đòi hỏi nhiều nỗ lực: kháng chiến thắng lợi * kì họp kết thúc thắng lợi",
    example: "kháng chiến thắng lợi * kì họp kết thúc thắng lợi",
  },
  {
    word: "thắng lợi",
    part_of_speech: "danh từ",
    meaning:
      "kết quả giành được, đạt được trong tranh đấu hay trong hoạt động đòi hỏi nhiều nỗ lực: giành được nhiều thắng lợi",
    example: "giành được nhiều thắng lợi",
  },
  {
    word: "thăng hà",
    part_of_speech: "động từ",
    meaning:
      '(cũ, trang trọng) (vua chúa) chết: "Trạng chết chúa cũng thăng hà, Dưa gang đỏ đít thì cà đỏ trôn." (ca dao)',
    example:
      'Trạng chết chúa cũng thăng hà, Dưa gang đỏ đít thì cà đỏ trôn." (ca dao)',
  },
  {
    word: "thẳng rẵng",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ, khẩu ngữ) (tư thế nằm) thẳng đườn người ra: nằm thẳng rẵng trên sập",
    example: "nằm thẳng rẵng trên sập",
  },
  {
    word: "thăng hoa",
    part_of_speech: "động từ",
    meaning:
      "(chất) chuyển trực tiếp từ trạng thái rắn sang trạng thái khí, không qua trạng thái lỏng: hiện tượng thăng hoa của băng phiến",
    example: "hiện tượng thăng hoa của băng phiến",
  },
  {
    word: "thăng hoa",
    part_of_speech: "động từ",
    meaning:
      "đưa những cái tinh tuý nhất vượt cao lên cho thành tốt đẹp hơn: nghệ thuật là sự thăng hoa của cuộc sống",
    example: "nghệ thuật là sự thăng hoa của cuộc sống",
  },
  {
    word: "thẳng thắn",
    part_of_speech: "tính từ",
    meaning:
      "rất thẳng, không xiên lệch, cong vẹo: cây mọc theo hàng lối thẳng thắn * vuốt tờ giấy cho thẳng thắn",
    example: "cây mọc theo hàng lối thẳng thắn * vuốt tờ giấy cho thẳng thắn",
  },
  {
    word: "thẳng thắn",
    part_of_speech: "tính từ",
    meaning:
      "rất thẳng, không quanh co, không e ngại: trao đổi thẳng thắn * tính tình thẳng thắn, cương trực",
    example: "trao đổi thẳng thắn * tính tình thẳng thắn, cương trực",
  },
  {
    word: "thẳng tắp",
    part_of_speech: "tính từ",
    meaning:
      "thẳng thành một đường dài, đều đặn: hàng cây thẳng tắp * con đường nhựa thẳng tắp",
    example: "hàng cây thẳng tắp * con đường nhựa thẳng tắp",
  },
  {
    word: "thẳng tay",
    part_of_speech: "tính từ",
    meaning:
      "mạnh mẽ, dứt khoát, không chút nương nhẹ hoặc thương hại: trừng trị thẳng tay",
    example: "trừng trị thẳng tay",
  },
  {
    word: "thăng thiên",
    part_of_speech: "động từ",
    meaning:
      "(thần, thánh) lên trời, bay về trời, theo tín ngưỡng dân gian: 23 tháng chạp là ngày ông táo thăng thiên",
    example: "23 tháng chạp là ngày ông táo thăng thiên",
  },
  {
    word: "thẳng ruột ngựa",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tả tính người có sao nói vậy, không chút kiêng nể gì: tính thẳng ruột ngựa",
    example: "tính thẳng ruột ngựa",
  },
  {
    word: "thắng thế",
    part_of_speech: "động từ",
    meaning:
      "giành được thế trội, lấn át hơn đối phương: thắng thế, càng làm già",
    example: "thắng thế, càng làm già",
  },
  {
    word: "thẳng thớm",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) thẳng thắn: xếp hàng thẳng thớm * phê bình thẳng thớm",
    example: "xếp hàng thẳng thớm * phê bình thẳng thớm",
  },
  {
    word: "thăng trầm",
    part_of_speech: "",
    meaning:
      "(việc đời) có nhiều biến đổi lớn, lúc thịnh lúc suy, lúc thành lúc bại, không có được sự bình ổn, yên vui: lịch sử thăng trầm * trải qua bao thăng trầm trong cuộc sống",
    example: "lịch sử thăng trầm * trải qua bao thăng trầm trong cuộc sống",
  },
  {
    word: "thẳng thừng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) dứt khoát, rõ ràng, tỏ ra không chút e dè, vì nể: từ chối thẳng thừng * thẳng thừng tuyên bố",
    example: "từ chối thẳng thừng * thẳng thừng tuyên bố",
  },
  {
    word: "thắp",
    part_of_speech: "động từ",
    meaning:
      'châm lửa làm cho cháy lên (thường nói về những vật có kích thước nhỏ như đèn, nến, hương, v.v.): thắp mấy nén hương * "Đêm khuya thắp đĩa dầu đầy, Học hành thì ít sầu tây thì nhiều." (ca dao)',
    example:
      'thắp mấy nén hương * "Đêm khuya thắp đĩa dầu đầy, Học hành thì ít sầu tây thì nhiều." (ca dao)',
  },
  {
    word: "thẳng tuột",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) thẳng một đường, hoàn toàn không có chỗ nào quanh co: đi thẳng tuột một đường",
    example: "đi thẳng tuột một đường",
  },
  {
    word: "thẳng tuột",
    part_of_speech: "tính từ",
    meaning:
      "(lối nói năng) rất thẳng thắn, không e dè, không quanh co, úp mở: trình bày thẳng tuột * nói thẳng tuột, không cần úp mở",
    example: "trình bày thẳng tuột * nói thẳng tuột, không cần úp mở",
  },
  {
    word: "thắt cổ",
    part_of_speech: "động từ",
    meaning:
      "thít chặt cổ bằng sợi dây thòng lọng cho chết nghẹt: thắt cổ tự tử",
    example: "thắt cổ tự tử",
  },
  {
    word: "thắt cổ bồng",
    part_of_speech: "tính từ",
    meaning:
      "có hình eo lại, thắt lại ở giữa thân như hình cái trống bồng: áo may theo lối thắt cổ bồng",
    example: "áo may theo lối thắt cổ bồng",
  },
  {
    word: "thắt",
    part_of_speech: "động từ",
    meaning:
      "vòng hai đầu mối dây hay dải vải mềm qua nhau và kết chặt lại thành nút: thắt nơ * thắt dây võng * buộc thắt nút",
    example: "thắt nơ * thắt dây võng * buộc thắt nút",
  },
  {
    word: "thắt",
    part_of_speech: "động từ",
    meaning:
      "rút, thít các đầu mối dây đã buộc lại cho chặt hoặc cho vòng buộc thu hẹp lại: thắt miệng túi * thắt chặt vòng vây * ruột đau như thắt (b)",
    example: "thắt miệng túi * thắt chặt vòng vây * ruột đau như thắt (b)",
  },
  {
    word: "thắt",
    part_of_speech: "động từ",
    meaning:
      "eo lại, thót lại ở một chỗ nào đó: quả bầu thắt lại ở giữa * thắt đáy lưng ong",
    example: "quả bầu thắt lại ở giữa * thắt đáy lưng ong",
  },
  {
    word: "thắt",
    part_of_speech: "động từ",
    meaning: "tết lại thành vật gì: thắt quang",
    example: "thắt quang",
  },
  {
    word: "thăng tiến",
    part_of_speech: "động từ",
    meaning:
      "tiến bộ về chuyên môn, về cấp bậc, địa vị,… trong nghề nghiệp, nói chung: có cơ hội thăng tiến * đường công danh đang thăng tiến",
    example: "có cơ hội thăng tiến * đường công danh đang thăng tiến",
  },
  {
    word: "thẳng tính",
    part_of_speech: "tính từ",
    meaning: "có tính thẳng thắn, hay nói thẳng: một người rất thẳng tính",
    example: "một người rất thẳng tính",
  },
  {
    word: "thắt lưng",
    part_of_speech: "danh từ",
    meaning: "vùng giữa lưng và mông của cơ thể người: bị đau ở thắt lưng",
    example: "bị đau ở thắt lưng",
  },
  {
    word: "thắt lưng",
    part_of_speech: "danh từ",
    meaning:
      "dải vải, da hay nhựa dùng thắt ngang lưng để giữ quần áo: thắt lưng da",
    example: "thắt lưng da",
  },
  {
    word: "thẫm",
    part_of_speech: "tính từ",
    meaning: "như sẫm: đỏ thẫm * tím thẫm",
    example: "đỏ thẫm * tím thẫm",
  },
  {
    word: "thâm",
    part_of_speech: "động từ",
    meaning: "(tiêu) lạm vào một khoản tiền khác: tiêu thâm cả vào vốn",
    example: "tiêu thâm cả vào vốn",
  },
  {
    word: "thâm",
    part_of_speech: "tính từ",
    meaning:
      "(vật có chất liệu mềm) có màu sẫm đen hoặc ngả về màu sẫm đen: vải thâm * mắt có quầng thâm * môi thâm",
    example: "vải thâm * mắt có quầng thâm * môi thâm",
  },
  {
    word: "thâm",
    part_of_speech: "tính từ",
    meaning:
      '(Văn chương) sâu (chỉ dùng với nghĩa bóng): "Sông sâu nước chảy đá mòn, Tình thâm mong trả, nghĩa tròn đấy đây." (Cdao)',
    example:
      'Sông sâu nước chảy đá mòn, Tình thâm mong trả, nghĩa tròn đấy đây." (Cdao)',
  },
  {
    word: "thâm",
    part_of_speech: "tính từ",
    meaning: "sâu độc và kín đáo: mưu thâm * ông ta thâm lắm!",
    example: "mưu thâm * ông ta thâm lắm!",
  },
  {
    word: "thắt đáy lưng ong",
    part_of_speech: "",
    meaning:
      '(thân hình phụ nữ) thon đẹp, eo nhỏ và thắt lại trông như lưng con ong: "Những người thắt đáy lưng ong, Vừa khéo chiều chồng, lại khéo nuôi con." (ca dao)',
    example:
      'Những người thắt đáy lưng ong, Vừa khéo chiều chồng, lại khéo nuôi con." (ca dao)',
  },
  {
    word: "thắt ngặt",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) khó khăn, ngặt nghèo: hoàn cảnh thắt ngặt",
    example: "hoàn cảnh thắt ngặt",
  },
  {
    word: "thắt nút",
    part_of_speech: "động từ",
    meaning:
      "bắt đầu hoặc làm cho bắt đầu hình thành sự xung đột có kịch tính: đoạn thắt nút của vở kịch",
    example: "đoạn thắt nút của vở kịch",
  },
  {
    word: "thầm",
    part_of_speech: "tính từ",
    meaning:
      "(tiếng nói phát ra) rất khẽ, như không để cho người ngoài nghe thấy: ghé tai nói thầm * hát thầm",
    example: "ghé tai nói thầm * hát thầm",
  },
  {
    word: "thầm",
    part_of_speech: "tính từ",
    meaning:
      "kín đáo, không biểu lộ ra ngoài, không muốn để cho người ngoài biết: mừng thầm * thầm yêu trộm nhớ * nghĩ thầm trong bụng",
    example: "mừng thầm * thầm yêu trộm nhớ * nghĩ thầm trong bụng",
  },
  {
    word: "thầm",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (làm việc gì) ở trong tình trạng không nhìn thấy gì cả, vì xung quanh là bóng tối, không có ánh sáng: xe tắt đèn, chạy thầm trong đêm",
    example: "xe tắt đèn, chạy thầm trong đêm",
  },
  {
    word: "thắt lưng buộc bụng",
    part_of_speech: "",
    meaning:
      "hết sức hạn chế, tiết kiệm trong tiêu dùng để trang trải, dành dụm trong hoàn cảnh khó khăn: thắt lưng buộc bụng để lo trả nợ",
    example: "thắt lưng buộc bụng để lo trả nợ",
  },
  {
    word: "thấm",
    part_of_speech: "động từ",
    meaning:
      "(chất lỏng) bị hút vào trong một môi trường xốp hoặc qua một màng mỏng: mưa thấm đất * mồ hôi thấm áo",
    example: "mưa thấm đất * mồ hôi thấm áo",
  },
  {
    word: "thấm",
    part_of_speech: "động từ",
    meaning:
      "làm cho chất lỏng thấm vào và bị hút khô đi: lấy bông thấm máu * vải nhiều nylon, không thấm mồ hôi",
    example: "lấy bông thấm máu * vải nhiều nylon, không thấm mồ hôi",
  },
  {
    word: "thấm",
    part_of_speech: "động từ",
    meaning:
      "cảm giác hoặc ý thức được một cách đầy đủ, sâu sắc, sau một quá trình chịu tác dụng hoặc tác động dần dần: thấm đòn * người đã thấm mệt * lời nói như thấm vào lòng",
    example: "thấm đòn * người đã thấm mệt * lời nói như thấm vào lòng",
  },
  {
    word: "thấm",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) có tác dụng, có ảnh hưởng đáng kể: tưởng nhiều chứ chừng ấy thì thấm gì!",
    example: "tưởng nhiều chứ chừng ấy thì thấm gì!",
  },
  {
    word: "thậm",
    part_of_speech: "phụ từ",
    meaning:
      "(cũ, hoặc kng) rất, hết sức: thậm ghét cái tính tắt mắt * ông cụ thậm hiền lành",
    example: "thậm ghét cái tính tắt mắt * ông cụ thậm hiền lành",
  },
  {
    word: "thẩm",
    part_of_speech: "động từ",
    meaning:
      "(toà án) xét kĩ các vấn đề liên quan đến một vụ án: thẩm lại vụ án",
    example: "thẩm lại vụ án",
  },
  {
    word: "thẩm",
    part_of_speech: "động từ",
    meaning: "(hiếm)",
    example: "nước thẩm qua đáy bể",
  },
  {
    word: "thẩm âm",
    part_of_speech: "động từ",
    meaning: "(hiếm) (khả năng) cảm thụ âm thanh: thẩm âm tốt * khiếu thẩm âm",
    example: "thẩm âm tốt * khiếu thẩm âm",
  },
  {
    word: "thậm chí",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị mức bao gồm cả những trường hợp không bình thường, nêu ra để nhấn mạnh làm nổi bật một điều nào đó: đã không giúp được gì, thậm chí còn phá",
    example: "đã không giúp được gì, thậm chí còn phá",
  },
  {
    word: "thâm canh",
    part_of_speech: "động từ",
    meaning:
      "(phương thức canh tác) tập trung chủ yếu vào việc áp dụng khoa học kĩ thuật, đầu tư thêm tư liệu sản xuất và lao động trên một đơn vị diện tích không mở rộng, nhằm đạt năng suất cao hơn để tăng sản lượng nông nghiệp; phân biệt với quảng canh: thâm canh lúa nước",
    example: "thâm canh lúa nước",
  },
  {
    word: "thẩm định",
    part_of_speech: "động từ",
    meaning:
      "xem xét nhằm đánh giá để xác định, quyết định: thẩm định văn chương * hội đồng thẩm định tính khả thi của dự án",
    example: "thẩm định văn chương * hội đồng thẩm định tính khả thi của dự án",
  },
  {
    word: "thẩm cung",
    part_of_speech: "động từ",
    meaning: "hỏi cung một cách kĩ càng: thẩm cung một bị can",
    example: "thẩm cung một bị can",
  },
  {
    word: "thâm cung",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) cung của vua chúa, là nơi kín đáo, thâm nghiêm ít người được lui tới: chốn thâm cung",
    example: "chốn thâm cung",
  },
  {
    word: "thấm đẫm",
    part_of_speech: "động từ",
    meaning: "thấm nhiều và đều khắp: chiếc khăn thấm đẫm nước mắt",
    example: "chiếc khăn thấm đẫm nước mắt",
  },
  {
    word: "thâm căn cố đế",
    part_of_speech: "",
    meaning:
      "đã ăn rất sâu, ảnh hưởng rất nặng nên khó có thể thay đổi: một thói tật đã thâm căn cố đế",
    example: "một thói tật đã thâm căn cố đế",
  },
  {
    word: "thâm độc",
    part_of_speech: "tính từ",
    meaning:
      "độc ác một cách thâm hiểm: thủ đoạn thâm độc * bà dì ghẻ thâm độc",
    example: "thủ đoạn thâm độc * bà dì ghẻ thâm độc",
  },
  {
    word: "thấm đượm",
    part_of_speech: "động từ",
    meaning:
      "(văn chương) thấm rất sâu và như lan toả ra đều khắp, gợi nên những cảm giác, ấn tượng hết sức sâu sắc (thường dùng với nghĩa bóng): câu hát thấm đượm tình quê hương",
    example: "câu hát thấm đượm tình quê hương",
  },
  {
    word: "thấm đậm",
    part_of_speech: "động từ",
    meaning:
      "mang đậm tính chất nào đó: không gian thấm đậm hương hoa sữa * cử chỉ thấm đậm nghĩa tình",
    example: "không gian thấm đậm hương hoa sữa * cử chỉ thấm đậm nghĩa tình",
  },
  {
    word: "thâm hụt",
    part_of_speech: "động từ",
    meaning: "bị hụt đi do chi tiêu quá mức: thâm hụt ngân sách",
    example: "thâm hụt ngân sách",
  },
  {
    word: "thầm kín",
    part_of_speech: "tính từ",
    meaning:
      "sâu kín ở trong lòng, không bộc lộ ra ngoài: nỗi buồn thầm kín * mơ ước thầm kín",
    example: "nỗi buồn thầm kín * mơ ước thầm kín",
  },
  {
    word: "thâm hiểm",
    part_of_speech: "tính từ",
    meaning:
      "(lòng dạ) hiểm ác, sâu độc một cách khó lường: mưu mô thâm hiểm * con người thâm hiểm",
    example: "mưu mô thâm hiểm * con người thâm hiểm",
  },
  {
    word: "thẩm lậu",
    part_of_speech: "động từ",
    meaning:
      "(cũ) (hiện tượng chất lỏng) ngấm qua và rỉ ra, chảy đi nơi khác: đoạn đê bị thẩm lậu",
    example: "đoạn đê bị thẩm lậu",
  },
  {
    word: "thẩm lậu",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) lọt qua trái phép từng ít một, rất khó kiểm soát: rượu ngoại thẩm lậu vào thị trường trong nước",
    example: "rượu ngoại thẩm lậu vào thị trường trong nước",
  },
  {
    word: "thầm lặng",
    part_of_speech: "tính từ",
    meaning:
      "âm thầm và lặng lẽ, ít ai biết đến: sự hi sinh thầm lặng * giúp đỡ một cách thầm lặng",
    example: "sự hi sinh thầm lặng * giúp đỡ một cách thầm lặng",
  },
  {
    word: "thầm lén",
    part_of_speech: "tính từ",
    meaning:
      "âm thầm và lén lút, không muốn cho người khác biết: thầm lén rủ nhau đi * yêu thầm lén",
    example: "thầm lén rủ nhau đi * yêu thầm lén",
  },
  {
    word: "thẩm mĩ",
    part_of_speech: "động từ",
    meaning:
      "cảm thụ và hiểu biết về cái đẹp: óc thẩm mĩ * chức năng thẩm mĩ của văn học",
    example: "óc thẩm mĩ * chức năng thẩm mĩ của văn học",
  },
  {
    word: "thẩm mĩ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) chăm sóc, sửa sang làm cho cơ thể trở nên đẹp hơn bằng các biện pháp kĩ thuật đặc biệt: phẫu thuật thẩm mĩ * dịch vụ thẩm mĩ",
    example: "phẫu thuật thẩm mĩ * dịch vụ thẩm mĩ",
  },
  {
    word: "thẩm mĩ",
    part_of_speech: "danh từ",
    meaning:
      "cái đẹp, khả năng cảm thụ cái đẹp: quan niệm về thẩm mĩ * một công trình kiến trúc thiếu thẩm mĩ",
    example: "quan niệm về thẩm mĩ * một công trình kiến trúc thiếu thẩm mĩ",
  },
  {
    word: "thâm nghiêm",
    part_of_speech: "tính từ",
    meaning:
      'sâu kín và gợi vẻ uy nghiêm: "Thâm nghiêm kín cổng cao tường, Cạn dòng lá thắm, dứt đường chim xanh." (TKiều)',
    example:
      'Thâm nghiêm kín cổng cao tường, Cạn dòng lá thắm, dứt đường chim xanh." (TKiều)',
  },
  {
    word: "thẩm mỹ viện",
    part_of_speech: "danh từ",
    meaning: "như mĩ viện: đến thẩm mĩ viện để sửa sang sắc đẹp",
    example: "đến thẩm mĩ viện để sửa sang sắc đẹp",
  },
  {
    word: "thẩm mỹ",
    part_of_speech: "động từ",
    meaning:
      "cảm thụ và hiểu biết về cái đẹp: óc thẩm mĩ * chức năng thẩm mĩ của văn học",
    example: "óc thẩm mĩ * chức năng thẩm mĩ của văn học",
  },
  {
    word: "thẩm mỹ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) chăm sóc, sửa sang làm cho cơ thể trở nên đẹp hơn bằng các biện pháp kĩ thuật đặc biệt: phẫu thuật thẩm mĩ * dịch vụ thẩm mĩ",
    example: "phẫu thuật thẩm mĩ * dịch vụ thẩm mĩ",
  },
  {
    word: "thẩm mỹ",
    part_of_speech: "danh từ",
    meaning:
      "cái đẹp, khả năng cảm thụ cái đẹp: quan niệm về thẩm mĩ * một công trình kiến trúc thiếu thẩm mĩ",
    example: "quan niệm về thẩm mĩ * một công trình kiến trúc thiếu thẩm mĩ",
  },
  {
    word: "thâm nhiễm",
    part_of_speech: "động từ",
    meaning: "bị nhiễm sâu, ăn sâu vào: thâm nhiễm thói xấu",
    example: "thâm nhiễm thói xấu",
  },
  {
    word: "thâm nhiễm",
    part_of_speech: "động từ",
    meaning:
      "bị vi khuẩn hoặc tác nhân gây bệnh xâm nhập: bệnh thuộc thể thâm nhiễm",
    example: "bệnh thuộc thể thâm nhiễm",
  },
  {
    word: "thâm nhập",
    part_of_speech: "động từ",
    meaning:
      "đi sâu vào và cùng hoà mình trong một môi trường hoạt động nào đó: nhà văn đi thâm nhập thực tế * thâm nhập thị trường",
    example: "nhà văn đi thâm nhập thực tế * thâm nhập thị trường",
  },
  {
    word: "thâm nhập",
    part_of_speech: "động từ",
    meaning:
      "(yếu tố từ bên ngoài) ăn sâu vào và trở thành nhân tố tác động bên trong: vi trùng thâm nhập vào cơ thể qua đường hô hấp",
    example: "vi trùng thâm nhập vào cơ thể qua đường hô hấp",
  },
  {
    word: "thâm nhập",
    part_of_speech: "động từ",
    meaning: "như truy cập: thâm nhập vào ổ đĩa để lấy dữ liệu",
    example: "thâm nhập vào ổ đĩa để lấy dữ liệu",
  },
  {
    word: "thâm niên",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian (tính bằng đơn vị năm) làm việc liên tục trong một cơ quan nhà nước trong một ngành, một nghề nào đó: có thâm niên hơn 40 năm trong nghề * hưởng tiền phụ cấp thâm niên",
    example:
      "có thâm niên hơn 40 năm trong nghề * hưởng tiền phụ cấp thâm niên",
  },
  {
    word: "thâm niên",
    part_of_speech: "tính từ",
    meaning: "(cũ) lâu năm: lính thâm niên",
    example: "lính thâm niên",
  },
  {
    word: "thẩm mĩ viện",
    part_of_speech: "danh từ",
    meaning: "như mĩ viện: đến thẩm mĩ viện để sửa sang sắc đẹp",
    example: "đến thẩm mĩ viện để sửa sang sắc đẹp",
  },
  {
    word: "thâm nho",
    part_of_speech: "danh từ",
    meaning: "(cũ) nhà nho có tri thức sâu sắc: một vị thâm nho",
    example: "một vị thâm nho",
  },
  {
    word: "thâm nho",
    part_of_speech: "tính từ",
    meaning:
      "có kiến thức nho học sâu sắc, uyên thâm: ông cụ rất thâm nho, mẫn tuệ * viên quan thâm nho",
    example: "ông cụ rất thâm nho, mẫn tuệ * viên quan thâm nho",
  },
  {
    word: "thâm nho",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) như thâm (ng2): ý tứ rất thâm nho * lão ta thâm nho lắm!",
    example: "ý tứ rất thâm nho * lão ta thâm nho lắm!",
  },
  {
    word: "thấm nhuần",
    part_of_speech: "động từ",
    meaning:
      '(cũ, văn chương) thấm đẫm và đều khắp: "Cảnh vật như thấm nhuần một nguồn sống mới mẻ. Mấy cây đa hai bên hồi đền vừa đổi lá." (KLân; 3)',
    example:
      'Cảnh vật như thấm nhuần một nguồn sống mới mẻ. Mấy cây đa hai bên hồi đền vừa đổi lá." (KLân; 3)',
  },
  {
    word: "thấm nhuần",
    part_of_speech: "động từ",
    meaning:
      "thấu hiểu điều gì một cách sâu sắc đến mức như có thể biến điều đó thành suy nghĩ, tư tưởng, hành động của mình một cách nhuần nhuyễn: thấm nhuần tư tưởng tiến bộ",
    example: "thấm nhuần tư tưởng tiến bộ",
  },
  {
    word: "thẩm quyền",
    part_of_speech: "danh từ",
    meaning:
      "quyền xem xét để kết luận và định đoạt một vấn đề theo pháp luật: dự án đã trình lên cơ quan có thẩm quyền",
    example: "dự án đã trình lên cơ quan có thẩm quyền",
  },
  {
    word: "thẩm quyền",
    part_of_speech: "danh từ",
    meaning:
      "tư cách, quyền hạn về mặt chuyên môn được thừa nhận để có ý kiến có tính chất quyết định về một vấn đề nào đó: vấn đề này không thuộc thẩm quyền của cơ quan",
    example: "vấn đề này không thuộc thẩm quyền của cơ quan",
  },
  {
    word: "thâm quầng",
    part_of_speech: "tính từ",
    meaning:
      "(mắt) thâm lại thành quầng ở xung quanh, thường do thiếu ngủ: thức đêm nhiều nên hai mắt thâm quầng",
    example: "thức đêm nhiều nên hai mắt thâm quầng",
  },
  {
    word: "thậm tệ",
    part_of_speech: "tính từ",
    meaning:
      "tệ tới mức không còn có thể hơn được nữa: bị bóc lột thậm tệ * mắng nhiếc một cách thậm tệ",
    example: "bị bóc lột thậm tệ * mắng nhiếc một cách thậm tệ",
  },
  {
    word: "thâm tâm",
    part_of_speech: "danh từ",
    meaning:
      "nơi tâm tư sâu kín trong lòng (không bộc lộ ra ngoài): điều ấp ủ trong thâm tâm * thâm tâm hắn không có ý hại người",
    example: "điều ấp ủ trong thâm tâm * thâm tâm hắn không có ý hại người",
  },
  {
    word: "thậm thà thậm thụt",
    part_of_speech: "động từ",
    meaning:
      "thậm thụt nhiều lần: bọn chúng thậm thà thậm thụt đi lại với nhau",
    example: "bọn chúng thậm thà thậm thụt đi lại với nhau",
  },
  {
    word: "thấm tháp",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) có một tác dụng nào đó ở mức phải chăng, coi như chưa đủ đáp ứng nhu cầu: chừng ấy thì thấm tháp gì * nói đến thế mà vẫn không thấm tháp vào đâu",
    example:
      "chừng ấy thì thấm tháp gì * nói đến thế mà vẫn không thấm tháp vào đâu",
  },
  {
    word: "thầm thì",
    part_of_speech: "",
    meaning: "như thì thầm: thầm thì to nhỏ",
    example: "thầm thì to nhỏ",
  },
  {
    word: "thấm thía",
    part_of_speech: "động từ",
    meaning:
      "có tác dụng thấm sâu vào tư tưởng, tình cảm: lời khuyên thấm thía * buồn thấm thía * càng nghĩ càng thấm thía",
    example: "lời khuyên thấm thía * buồn thấm thía * càng nghĩ càng thấm thía",
  },
  {
    word: "thấm thía",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ, hiếm) như thấm tháp: ngần này thì thấm thía gì!",
    example: "ngần này thì thấm thía gì!",
  },
  {
    word: "thẩm thấu",
    part_of_speech: "động từ",
    meaning:
      "(hiện tượng một chất, thường là dung môi) khuếch tán qua một màng mỏng ngăn cách dung môi nguyên chất với dung dịch hoặc ngăn cách hai dung dịch có nồng độ khác nhau, màng mỏng này chỉ cho dung môi thấm qua mà thôi: tính thẩm thấu của nước",
    example: "tính thẩm thấu của nước",
  },
  {
    word: "thẩm thấu",
    part_of_speech: "động từ",
    meaning:
      "như thẩm lậu (ng2): hàng kém chất lượng thẩm thấu vào thị trường trong nước",
    example: "hàng kém chất lượng thẩm thấu vào thị trường trong nước",
  },
  {
    word: "thầm thĩ",
    part_of_speech: "",
    meaning: "(hiếm) như thầm thì: những lời thầm thĩ yêu thương",
    example: "những lời thầm thĩ yêu thương",
  },
  {
    word: "thậm thịch",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng phát ra trầm, đều, liên tục, như tiếng bước chân nhiều người nện trên mặt đất: tiếng chày nện thậm thịch * tiếng chân bước thậm thịch trên nền đất",
    example:
      "tiếng chày nện thậm thịch * tiếng chân bước thậm thịch trên nền đất",
  },
  {
    word: "thâm thấp",
    part_of_speech: "tính từ",
    meaning: "hơi thấp: dáng người thâm thấp",
    example: "dáng người thâm thấp",
  },
  {
    word: "thấm thoắt",
    part_of_speech: "tính từ",
    meaning:
      "(thời gian) qua đi một cách nhanh chóng đến mức không ngờ (bây giờ nhìn lại mới nhận ra): thời gian thấm thoắt trôi đi * từ đó đến nay, thấm thoắt đã ba năm",
    example:
      "thời gian thấm thoắt trôi đi * từ đó đến nay, thấm thoắt đã ba năm",
  },
  {
    word: "thậm thọt",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) như thậm thụt: ra vào thậm thọt",
    example: "ra vào thậm thọt",
  },
  {
    word: "thâm thù",
    part_of_speech: "",
    meaning: "căm thù sâu sắc: mối thâm thù * không có thâm thù gì với ai",
    example: "mối thâm thù * không có thâm thù gì với ai",
  },
  {
    word: "thâm thủng",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) như thâm hụt: thâm thủng ngân sách",
    example: "thâm thủng ngân sách",
  },
  {
    word: "thâm thuý",
    part_of_speech: "tính từ",
    meaning:
      "rất sâu sắc về tư tưởng, ý tứ: lời dạy thâm thuý * ý nghĩa thâm thuý của kinh truyện",
    example: "lời dạy thâm thuý * ý nghĩa thâm thuý của kinh truyện",
  },
  {
    word: "thậm thụt",
    part_of_speech: "động từ",
    meaning:
      "đi lại, ra vào nhiều lần một cách lén lút (thường để làm việc bất chính): thậm thụt đi lại với nhau * thậm thụt đi đêm về hôm",
    example: "thậm thụt đi lại với nhau * thậm thụt đi đêm về hôm",
  },
  {
    word: "thâm trầm",
    part_of_speech: "tính từ",
    meaning:
      "sâu sắc và kín đáo, không dễ dàng để tâm tư, tình cảm cũng như ý nghĩ bộc lộ ra bên ngoài: vẻ mặt thâm trầm * tính khí thâm trầm",
    example: "vẻ mặt thâm trầm * tính khí thâm trầm",
  },
  {
    word: "thâm u",
    part_of_speech: "tính từ",
    meaning: "(khung cảnh) sâu tối và quạnh vắng: rừng đêm tịch mịch thâm u",
    example: "rừng đêm tịch mịch thâm u",
  },
  {
    word: "thẩm tra",
    part_of_speech: "động từ",
    meaning:
      "điều tra, xem xét lại xem có đúng, có chính xác như đã biết không: thẩm tra lí lịch * thẩm tra tờ khai",
    example: "thẩm tra lí lịch * thẩm tra tờ khai",
  },
  {
    word: "thâm tình",
    part_of_speech: "danh từ",
    meaning: "tình cảm rất sâu đậm: mối thâm tình * cha con là chỗ thâm tình",
    example: "mối thâm tình * cha con là chỗ thâm tình",
  },
  {
    word: "thầm vụng",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) lén lút, vụng trộm: thương yêu thầm vụng * hai người đi lại thầm vụng với nhau",
    example: "thương yêu thầm vụng * hai người đi lại thầm vụng với nhau",
  },
  {
    word: "thẩm vấn",
    part_of_speech: "động từ",
    meaning: "xét hỏi trong vụ án: hội đồng xét xử tiến hành thẩm vấn bị can",
    example: "hội đồng xét xử tiến hành thẩm vấn bị can",
  },
  {
    word: "thâm xịt",
    part_of_speech: "tính từ",
    meaning:
      "thâm đến mức xỉn lại thành màu đục, tối, trông xấu: đôi môi thâm xịt *  quả cà thâm xịt * nước da thâm xịt",
    example: "đôi môi thâm xịt *  quả cà thâm xịt * nước da thâm xịt",
  },
  {
    word: "thẩm xét",
    part_of_speech: "động từ",
    meaning:
      "xem xét lại một cách kĩ càng trước khi đưa ra quyết định: thẩm xét danh sách khen thưởng * thẩm xét lại vụ án",
    example: "thẩm xét danh sách khen thưởng * thẩm xét lại vụ án",
  },
  {
    word: "thân",
    part_of_speech: "danh từ",
    meaning:
      "phần chính, nơi chứa đựng các cơ quan bên trong của cơ thể động vật, hoặc mang hoa lá của cơ thể thực vật: thân cây * thân người * sâu đục thân",
    example: "thân cây * thân người * sâu đục thân",
  },
  {
    word: "thân",
    part_of_speech: "danh từ",
    meaning:
      "cơ thể con người, về mặt là thể xác, thể lực, nói chung: đau toàn thân * tấm thân to lớn",
    example: "đau toàn thân * tấm thân to lớn",
  },
  {
    word: "thân",
    part_of_speech: "danh từ",
    meaning:
      "phần giữa và lớn hơn cả, thường là nơi để chứa đựng, hoặc mang nội dung chính: thân tàu làm bằng thép * phần thân bài * thân đê",
    example: "thân tàu làm bằng thép * phần thân bài * thân đê",
  },
  {
    word: "thân",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận chính của áo, quần, được thiết kế theo kích thước nhất định: thân quần * thân áo",
    example: "thân quần * thân áo",
  },
  {
    word: "thân",
    part_of_speech: "danh từ",
    meaning:
      "cái cá nhân, cái riêng tư của mỗi người: chỉ biết lo cho thân mình * được sướng thân",
    example: "chỉ biết lo cho thân mình * được sướng thân",
  },
  {
    word: "thân",
    part_of_speech: "danh từ",
    meaning:
      "(thường viết hoa) kí hiệu thứ chín trong địa chi (lấy khỉ làm tượng trưng; sau mùi, trước dậu), dùng trong phép đếm thời gian cổ truyền của Trung Quốc và một số nước châu á, trong đó có Việt Nam: tuổi Thân (sinh vào một năm Thân)",
    example: "tuổi Thân (sinh vào một năm Thân)",
  },
  {
    word: "thân",
    part_of_speech: "tính từ",
    meaning:
      "có quan hệ rất gần gũi và gắn bó mật thiết với nhau: hai người rất thân nhau * đôi bạn thân",
    example: "hai người rất thân nhau * đôi bạn thân",
  },
  {
    word: "thầm yêu trộm nhớ",
    part_of_speech: "",
    meaning:
      "yêu thầm kín trong lòng, không dám thổ lộ ra: được nhiều chàng trai thầm yêu trộm nhớ",
    example: "được nhiều chàng trai thầm yêu trộm nhớ",
  },
  {
    word: "thậm xưng",
    part_of_speech: "động từ",
    meaning:
      "(cũ) nói ngoa, thường nhằm mục đích hài hước: lối thậm xưng trong ca dao",
    example: "lối thậm xưng trong ca dao",
  },
  {
    word: "thận",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận cơ thể động vật, hình hạt đậu, màu nâu đỏ, nằm ở hai bên cột sống, có chức năng lọc nước tiểu: bị sỏi thận",
    example: "bị sỏi thận",
  },
  {
    word: "thần",
    part_of_speech: "danh từ",
    meaning:
      "lực lượng siêu tự nhiên được tôn thờ (như thần tiên, thần thánh), coi là linh thiêng, có sức mạnh và phép lạ phi thường, có thể gây hoạ hoặc làm phúc cho người đời, theo quan niệm mê tín hoặc theo quan niệm của tôn giáo: lễ tế thần * thần thổ địa * thần cây đa, ma cây đề (tng)",
    example: "lễ tế thần * thần thổ địa * thần cây đa, ma cây đề (tng)",
  },
  {
    word: "thần",
    part_of_speech: "tính từ",
    meaning:
      "(vật) có phép lạ của thần: vị thuốc thần * chiếc đũa thần trong truyện cổ tích",
    example: "vị thuốc thần * chiếc đũa thần trong truyện cổ tích",
  },
  {
    word: "thần",
    part_of_speech: "danh từ",
    meaning:
      "cái yếu tố vô hình nhưng có vai trò chủ đạo, mang lại sức sống, tạo nên sức sống: bức tranh có thần * diễn viên đã thể hiện được cái thần của nhân vật",
    example:
      "bức tranh có thần * diễn viên đã thể hiện được cái thần của nhân vật",
  },
  {
    word: "thần",
    part_of_speech: "tính từ",
    meaning:
      "đờ đẫn hẳn ra đến mức như không biết gì đến xung quanh nữa: mặt thần ra nghĩ ngợi",
    example: "mặt thần ra nghĩ ngợi",
  },
  {
    word: "thân ái",
    part_of_speech: "tính từ",
    meaning:
      "có tình cảm yêu mến và gần gũi: gửi lời chào thân ái * sống thân ái với mọi người",
    example: "gửi lời chào thân ái * sống thân ái với mọi người",
  },
  {
    word: "thân cận",
    part_of_speech: "tính từ",
    meaning: "gần gũi và thân thiết: chỗ thân cận * bạn bè thân cận",
    example: "chỗ thân cận * bạn bè thân cận",
  },
  {
    word: "thần bí hoá",
    part_of_speech: "động từ",
    meaning: "làm cho trở nên thần bí: xu hướng thần bí hoá thơ ca",
    example: "xu hướng thần bí hoá thơ ca",
  },
  {
    word: "thâm ý",
    part_of_speech: "danh từ",
    meaning: "ý kín đáo, sâu xa, không nói ra: hiểu được thâm ý của người nói",
    example: "hiểu được thâm ý của người nói",
  },
  {
    word: "thần chết",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương) vị thần chuyên đi bắt người hết thời hạn sống trở về cõi âm, theo thần thoại (thường được tưởng tượng là bộ xương cầm lưỡi hái): thoát khỏi bàn tay của thần chết",
    example: "thoát khỏi bàn tay của thần chết",
  },
  {
    word: "thần bí",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về thần linh, có chứa đựng những điều không thể hiểu được, theo quan niệm duy tâm: thế giới thần bí * chuyện thần bí",
    example: "thế giới thần bí * chuyện thần bí",
  },
  {
    word: "thân chinh",
    part_of_speech: "động từ",
    meaning:
      "(cũ) (vua) tự mình cầm quân ra mặt trận: nhà vua thân chinh đi đánh giặc",
    example: "nhà vua thân chinh đi đánh giặc",
  },
  {
    word: "thân chinh",
    part_of_speech: "tính từ",
    meaning:
      "(trang trọng) (tự mình) trực tiếp đi làm một việc nào đó mà đáng lẽ có thể giao cho người dưới làm: bộ trưởng thân chinh đi kiểm tra",
    example: "bộ trưởng thân chinh đi kiểm tra",
  },
  {
    word: "thần chú",
    part_of_speech: "danh từ",
    meaning:
      "lời bí ẩn đọc lên để sai khiến quỷ thần, theo mê tín: niệm thần chú * đọc câu thần chú",
    example: "niệm thần chú * đọc câu thần chú",
  },
  {
    word: "thân chủ",
    part_of_speech: "danh từ",
    meaning:
      "khách hàng của những người làm nghề tự do, thường là của luật sư: luật sư bào chữa cho thân chủ",
    example: "luật sư bào chữa cho thân chủ",
  },
  {
    word: "thần dược",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) thuốc thần, thuốc tiên: bệnh ấy chỉ có thần dược mới chữa được",
    example: "bệnh ấy chỉ có thần dược mới chữa được",
  },
  {
    word: "thần đồng",
    part_of_speech: "danh từ",
    meaning:
      "đứa trẻ thông minh khác thường, có năng khiếu hết sức đặc biệt: thần đồng đất Việt * đứa trẻ thần đồng",
    example: "thần đồng đất Việt * đứa trẻ thần đồng",
  },
  {
    word: "thần diệu",
    part_of_speech: "tính từ",
    meaning:
      "có khả năng đưa lại hiệu quả tốt đẹp đến mức đáng kinh ngạc, giống như có phép thần: kế sách thần diệu * phương thuốc thần diệu",
    example: "kế sách thần diệu * phương thuốc thần diệu",
  },
  {
    word: "thân hành",
    part_of_speech: "tính từ",
    meaning:
      "(tự mình) trực tiếp làm việc gì chứ không để hoặc không sai người dưới làm: được thủ tướng thân hành ra đón",
    example: "được thủ tướng thân hành ra đón",
  },
  {
    word: "thân hào",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người có địa vị và thế lực trong xã hội cũ: các vị thân hào trong phủ",
    example: "các vị thân hào trong phủ",
  },
  {
    word: "thần hiệu",
    part_of_speech: "tính từ",
    meaning:
      "hiệu nghiệm một cách đặc biệt, giống như có phép thần: phương thuốc thần hiệu",
    example: "phương thuốc thần hiệu",
  },
  {
    word: "thân hình",
    part_of_speech: "danh từ",
    meaning: "hình dáng, thân thể con người (nói khái quát): thân hình vạm vỡ",
    example: "thân hình vạm vỡ",
  },
  {
    word: "thần kì",
    part_of_speech: "tính từ",
    meaning:
      "tài tình một cách kì lạ, tới mức như không thể tưởng tượng nổi: sức mạnh thần kì * câu chuyện thần kì",
    example: "sức mạnh thần kì * câu chuyện thần kì",
  },
  {
    word: "thần hôn",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) sớm tối; chỉ việc con cái chuyên cần thăm hỏi, chăm sóc cha mẹ: "Rừng thu từng biếc xen hồng, Nghe chim như nhắc tấm lòng thần hôn." (TKiều)',
    example:
      'Rừng thu từng biếc xen hồng, Nghe chim như nhắc tấm lòng thần hôn." (TKiều)',
  },
  {
    word: "thần kinh",
    part_of_speech: "danh từ",
    meaning:
      "bộ máy của cơ thể động vật, có khả năng dẫn truyền kích thích và điều khiển các phản ứng đối với những kích thích đó, giúp động vật sống và hoạt động bình thường trong môi trường xung quanh: suy nhược thần kinh * thần kinh căng thẳng",
    example: "suy nhược thần kinh * thần kinh căng thẳng",
  },
  {
    word: "thần kinh",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) như tâm thần (ng2): mắc chứng thần kinh",
    example: "mắc chứng thần kinh",
  },
  {
    word: "thần kỳ",
    part_of_speech: "tính từ",
    meaning:
      "tài tình một cách kì lạ, tới mức như không thể tưởng tượng nổi: sức mạnh thần kì * câu chuyện thần kì",
    example: "sức mạnh thần kì * câu chuyện thần kì",
  },
  {
    word: "thần hồn",
    part_of_speech: "danh từ",
    meaning:
      "phần hồn, phần tinh thần (thường nói ở trạng thái không bình thường): làm hỏng thì cứ liệu cái thần hồn! * thần hồn nát thần tính (tng)",
    example:
      "làm hỏng thì cứ liệu cái thần hồn! * thần hồn nát thần tính (tng)",
  },
  {
    word: "thân hữu",
    part_of_speech: "danh từ",
    meaning: "(cũ) thân bằng cố hữu (nói tắt): tình thân hữu * bạn bè thân hữu",
    example: "tình thân hữu * bạn bè thân hữu",
  },
  {
    word: "thần linh",
    part_of_speech: "danh từ",
    meaning:
      "thần, lực lượng siêu tự nhiên (nói khái quát): cầu xin thần linh phù hộ",
    example: "cầu xin thần linh phù hộ",
  },
  {
    word: "thân mật",
    part_of_speech: "tính từ",
    meaning:
      "có những biểu hiện tình cảm chân thành và thân thiết với nhau: chuyện trò thân mật * bữa cơm thân mật",
    example: "chuyện trò thân mật * bữa cơm thân mật",
  },
  {
    word: "thần lực",
    part_of_speech: "danh từ",
    meaning: "(hiếm) sức mạnh thần kì: một tráng sĩ có thần lực",
    example: "một tráng sĩ có thần lực",
  },
  {
    word: "thân nghênh",
    part_of_speech: "động từ",
    meaning:
      '(cũ) đích thân ra nghênh đón: "Kéo cờ luỹ, phát súng thành, Từ công lên ngựa thân nghênh cửa ngoài." (TKiều)',
    example:
      'Kéo cờ luỹ, phát súng thành, Từ công lên ngựa thân nghênh cửa ngoài." (TKiều)',
  },
  {
    word: "thân nhân",
    part_of_speech: "danh từ",
    meaning:
      "người thân, người nhà, thường là của người chết, người bệnh hoặc người bị tai nạn (nói khái quát): chia buồn với thân nhân của người đã khuất",
    example: "chia buồn với thân nhân của người đã khuất",
  },
  {
    word: "thân nhiệt",
    part_of_speech: "danh từ",
    meaning: "nhiệt độ cơ thể của người và động vật: thân nhiệt cao",
    example: "thân nhiệt cao",
  },
  {
    word: "thân mến",
    part_of_speech: "tính từ",
    meaning:
      "có quan hệ tình cảm gần gũi và quý mến: tình thân mến * bạn bè thân mến",
    example: "tình thân mến * bạn bè thân mến",
  },
  {
    word: "thân phận",
    part_of_speech: "danh từ",
    meaning:
      "địa vị xã hội thấp hèn hoặc cảnh ngộ không may mà con người không sao thoát khỏi được, do số phận định đoạt (theo quan niệm duy tâm): thân phận nữ nhi * thương cho thân phận mình",
    example: "thân phận nữ nhi * thương cho thân phận mình",
  },
  {
    word: "thân pháp",
    part_of_speech: "danh từ",
    meaning:
      "cách vận động, di chuyển thân thể (trong các môn võ nghệ): thân pháp nhanh nhẹn, biến hoá",
    example: "thân pháp nhanh nhẹn, biến hoá",
  },
  {
    word: "thân quen",
    part_of_speech: "",
    meaning: "quen thuộc và thân thiết: bạn bè thân quen",
    example: "bạn bè thân quen",
  },
  {
    word: "thần phục",
    part_of_speech: "động từ",
    meaning:
      "(cũ) chịu phục tùng và tự nhận làm bề tôi của vua hoặc chư hầu của nước lớn: tướng giặc đã chịu thần phục",
    example: "tướng giặc đã chịu thần phục",
  },
  {
    word: "thân sĩ",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người có học thức thuộc tầng lớp trên trong xã hội cũ: thân sĩ yêu nước",
    example: "thân sĩ yêu nước",
  },
  {
    word: "thân sinh",
    part_of_speech: "",
    meaning:
      "(trang trọng) (người) sinh ra ai đó: ông thân sinh * thân sinh của anh là một nhà nho",
    example: "ông thân sinh * thân sinh của anh là một nhà nho",
  },
  {
    word: "thân quyến",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) bà con họ hàng thân thiết, nói chung: thân quyến người bị nạn * bà con thân quyến",
    example: "thân quyến người bị nạn * bà con thân quyến",
  },
  {
    word: "thần sắc",
    part_of_speech: "danh từ",
    meaning:
      "sắc mặt, biểu hiện trạng thái sức khoẻ hoặc tinh thần của con người: thần sắc nhợt nhạt * sợ mất cả thần sắc",
    example: "thần sắc nhợt nhạt * sợ mất cả thần sắc",
  },
  {
    word: "thần tài",
    part_of_speech: "danh từ",
    meaning:
      "thần phù hộ cho việc làm ăn buôn bán thuận lợi, phát tài, theo quan niệm dân gian: thờ thần tài",
    example: "thờ thần tài",
  },
  {
    word: "thân sơ",
    part_of_speech: "tính từ",
    meaning: "thân và sơ (nói khái quát): bạn bè thân sơ",
    example: "bạn bè thân sơ",
  },
  {
    word: "thần thái",
    part_of_speech: "danh từ",
    meaning:
      "những biểu hiện bên ngoài như vẻ mặt, dáng đi, điệu bộ, cử chỉ của con người (nói tổng quát): thần thái mệt mỏi",
    example: "thần thái mệt mỏi",
  },
  {
    word: "thần thánh",
    part_of_speech: "danh từ",
    meaning:
      "(cũng thánh thần) thần và thánh, chỉ những lực lượng siêu tự nhiên, linh thiêng (nói khái quát): không tin vào thần thánh, ma quỷ",
    example: "không tin vào thần thánh, ma quỷ",
  },
  {
    word: "thần thánh",
    part_of_speech: "tính từ",
    meaning: "có tính chất thiêng liêng và vĩ đại: cuộc kháng chiến thần thánh",
    example: "cuộc kháng chiến thần thánh",
  },
  {
    word: "thân thế",
    part_of_speech: "danh từ",
    meaning:
      "cuộc đời của một người (thường là người có danh tiếng): thân thế và sự nghiệp của nhà văn",
    example: "thân thế và sự nghiệp của nhà văn",
  },
  {
    word: "thần thế",
    part_of_speech: "danh từ, tính từ",
    meaning:
      "chỗ dựa mạnh, có quyền uy và thế lực: cậy thần thế mà kiêu ngạo * một gia đình giàu có và thần thế",
    example: "cậy thần thế mà kiêu ngạo * một gia đình giàu có và thần thế",
  },
  {
    word: "thần thánh hoá",
    part_of_speech: "động từ",
    meaning:
      "làm cho trở nên có tính chất thần thánh: thần thánh hoá vị tướng chỉ huy",
    example: "thần thánh hoá vị tướng chỉ huy",
  },
  {
    word: "thần thoại",
    part_of_speech: "danh từ",
    meaning:
      "truyện kể dân gian về các vị thần hoặc các nhân vật anh hùng đã được thần thánh hoá, phản ánh những quan niệm ngây thơ của con người thời xa xưa về các hiện tượng tự nhiên và khát vọng trong đấu tranh chinh phục thiên nhiên: truyện thần thoại Hi Lạp",
    example: "truyện thần thoại Hi Lạp",
  },
  {
    word: "thân thiện",
    part_of_speech: "tính từ",
    meaning:
      "có biểu hiện tỏ ra tử tế và có thiện cảm với nhau: nụ cười thân thiện * quan hệ thân thiện giữa hai nước",
    example: "nụ cười thân thiện * quan hệ thân thiện giữa hai nước",
  },
  {
    word: "thân thuộc",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) bà con họ hàng (nói khái quát): giúp đỡ thân thuộc * họ hàng thân thuộc",
    example: "giúp đỡ thân thuộc * họ hàng thân thuộc",
  },
  {
    word: "thân thuộc",
    part_of_speech: "tính từ",
    meaning:
      "có quan hệ gần gũi, thân thiết: giọng nói thân thuộc * mùi vị thân thuộc của đồng quê",
    example: "giọng nói thân thuộc * mùi vị thân thuộc của đồng quê",
  },
  {
    word: "thân thích",
    part_of_speech: "danh từ",
    meaning:
      "người có quan hệ họ hàng gần gũi (nói khái quát): bà con thân thích * thân thích của nhà vua",
    example: "bà con thân thích * thân thích của nhà vua",
  },
  {
    word: "thân thể",
    part_of_speech: "danh từ",
    meaning: "cơ thể của người: rèn luyện thân thể",
    example: "rèn luyện thân thể",
  },
  {
    word: "thân thiết",
    part_of_speech: "tính từ",
    meaning:
      "có quan hệ tình cảm gần gũi và gắn bó mật thiết với nhau: bạn bè thân thiết * không còn ai thân thiết",
    example: "bạn bè thân thiết * không còn ai thân thiết",
  },
  {
    word: "thẩn thơ",
    part_of_speech: "tính từ",
    meaning: "như thơ thẩn: suy nghĩ thẩn thơ",
    example: "suy nghĩ thẩn thơ",
  },
  {
    word: "thẫn thờ",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái như ngẩn ngơ, mất hết vẻ linh hoạt, nhanh nhẹn: vẻ mặt thẫn thờ * ánh mắt thẫn thờ",
    example: "vẻ mặt thẫn thờ * ánh mắt thẫn thờ",
  },
  {
    word: "thân tình",
    part_of_speech: "danh từ",
    meaning:
      "tình cảm thân mật, chân thành: lấy thân tình mà đối đãi * chỗ thân tình với nhau, anh không phải khách sáo",
    example:
      "lấy thân tình mà đối đãi * chỗ thân tình với nhau, anh không phải khách sáo",
  },
  {
    word: "thần thông",
    part_of_speech: "tính từ",
    meaning:
      "rất phi thường, có khả năng hiểu thấu mọi sự và biến hoá khó lường: có phép thần thông",
    example: "có phép thần thông",
  },
  {
    word: "thân thương",
    part_of_speech: "tính từ",
    meaning:
      "gần gũi, thấm đượm tình cảm yêu thương thân thiết: những tình cảm thân thương * sống trong tình thân thương của mọi người",
    example:
      "những tình cảm thân thương * sống trong tình thân thương của mọi người",
  },
  {
    word: "thần tiên",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về thế giới của thần và tiên; thường dùng để ví sự tốt đẹp đạt đến mức không gì sánh nổi: xứ sở thần tiên * chốn thần tiên * thuốc thần tiên",
    example: "xứ sở thần tiên * chốn thần tiên * thuốc thần tiên",
  },
  {
    word: "thần tình",
    part_of_speech: "tính từ",
    meaning:
      "rất tài tình, tới mức không thể giải thích nổi: nét vẽ thần tình * cú sút thật là thần tình",
    example: "nét vẽ thần tình * cú sút thật là thần tình",
  },
  {
    word: "thân tín",
    part_of_speech: "tính từ",
    meaning: "gần gũi và tin cậy: tay chân thân tín",
    example: "tay chân thân tín",
  },
  {
    word: "thân tộc",
    part_of_speech: "danh từ",
    meaning:
      "bà con, anh em trong cùng một dòng họ (nói tổng quát): quan hệ thân tộc * thân tộc của nhà vua",
    example: "quan hệ thân tộc * thân tộc của nhà vua",
  },
  {
    word: "thần tốc",
    part_of_speech: "tính từ",
    meaning:
      "nhanh chóng một cách phi thường, thường nói trong phép dùng binh: cuộc hành quân thần tốc",
    example: "cuộc hành quân thần tốc",
  },
  {
    word: "thần trí",
    part_of_speech: "danh từ",
    meaning: "(hiếm) tinh thần và tâm trí, nói chung: thần trí sáng suốt",
    example: "thần trí sáng suốt",
  },
  {
    word: "thần tượng",
    part_of_speech: "danh từ",
    meaning:
      "tượng thần; dùng để ví cái được tôn sùng, chiêm ngưỡng: thần tượng bóng đá",
    example: "thần tượng bóng đá",
  },
  {
    word: "thần xác",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) phần thể xác của con người (thường hàm ý chê bai, coi thường): thần xác mệt mỏi * đi từ sáng, giờ mới dẫn thần xác về",
    example: "thần xác mệt mỏi * đi từ sáng, giờ mới dẫn thần xác về",
  },
  {
    word: "thân xác",
    part_of_speech: "danh từ",
    meaning:
      "thân thể, phần xác của con người, về mặt tách khỏi tinh thần, tình cảm: thân xác to lớn * linh hồn thoát ra khỏi thân xác",
    example: "thân xác to lớn * linh hồn thoát ra khỏi thân xác",
  },
  {
    word: "thân yêu",
    part_of_speech: "tính từ",
    meaning:
      "yêu quý và thân thiết: những người bạn thân yêu * miền quê thân yêu",
    example: "những người bạn thân yêu * miền quê thân yêu",
  },
  {
    word: "thận trọng",
    part_of_speech: "tính từ",
    meaning:
      "hết sức cẩn thận, luôn có sự đắn đo, suy tính kĩ lưỡng trong hành động để tránh sai sót: nói năng thiếu thận trọng * thận trọng trong công việc",
    example: "nói năng thiếu thận trọng * thận trọng trong công việc",
  },
  {
    word: "thấp",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) thấp khớp (nói tắt): mắc bệnh thấp",
    example: "mắc bệnh thấp",
  },
  {
    word: "thấp",
    part_of_speech: "tính từ",
    meaning:
      "có chiều cao dưới mức bình thường hoặc kém hơn so với những vật khác, hoặc có khoảng cách gần hơn đối với mặt đất so với những cái khác: từ trên cao nhìn xuống thấp * ngọn cỏ thấp là là mặt đất * chuồn chuồn bay thấp thì mưa (tng)",
    example:
      "từ trên cao nhìn xuống thấp * ngọn cỏ thấp là là mặt đất * chuồn chuồn bay thấp thì mưa (tng)",
  },
  {
    word: "thấp",
    part_of_speech: "tính từ",
    meaning:
      "dưới mức trung bình về mặt số lượng, chất lượng, trình độ, giá cả, v.v.: nhiệt độ xuống thấp * mức lương quá thấp * tay nghề còn thấp",
    example: "nhiệt độ xuống thấp * mức lương quá thấp * tay nghề còn thấp",
  },
  {
    word: "thấp",
    part_of_speech: "tính từ",
    meaning:
      "(âm thanh) có tần số rung động nhỏ: giọng hát hơi thấp * hạ thấp giọng",
    example: "giọng hát hơi thấp * hạ thấp giọng",
  },
  {
    word: "thập ác",
    part_of_speech: "danh từ",
    meaning:
      "mười tội nặng nhất, theo quan niệm của đạo Phật hoặc theo pháp luật phong kiến (nói tổng quát): sát sinh là tội lớn nhất trong thập ác",
    example: "sát sinh là tội lớn nhất trong thập ác",
  },
  {
    word: "thấp hèn",
    part_of_speech: "tính từ",
    meaning:
      "quá hèn kém, tầm thường, đáng khinh: những thị hiếu thấp hèn * thân phận thấp hèn",
    example: "những thị hiếu thấp hèn * thân phận thấp hèn",
  },
  {
    word: "thấp kém",
    part_of_speech: "tính từ",
    meaning:
      "kém hơn hẳn so với mức bình thường (nói khái quát): trình độ thấp kém * hạng người thấp kém nhất trong xã hội",
    example: "trình độ thấp kém * hạng người thấp kém nhất trong xã hội",
  },
  {
    word: "thập cẩm",
    part_of_speech: "tính từ",
    meaning:
      "(mứt, nhân bánh, món ăn, v.v.) gồm nhiều thứ khác nhau như chất thơm, chất béo, hoa quả, v.v., trộn lẫn với nhau: chè thập cẩm * cơm rang thập cẩm",
    example: "chè thập cẩm * cơm rang thập cẩm",
  },
  {
    word: "thập cẩm",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) gồm nhiều thứ rất khác loại gộp chung vào với nhau: vườn trồng thập cẩm đủ các thứ * bán đủ thứ hàng thập cẩm",
    example: "vườn trồng thập cẩm đủ các thứ * bán đủ thứ hàng thập cẩm",
  },
  {
    word: "thấp điểm",
    part_of_speech: "danh từ",
    meaning:
      "thời điểm có lượng hoạt động diễn ra thấp nhất, ít căng thẳng nhất trong ngày: giảm giá điện vào giờ thấp điểm",
    example: "giảm giá điện vào giờ thấp điểm",
  },
  {
    word: "thập kỉ",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian từng mười năm một của một thế kỉ, tính từ năm đầu của thế kỉ trở đi: thập kỉ 80 của thế kỉ XX (từ năm 1980 đến năm 1989)",
    example: "thập kỉ 80 của thế kỉ XX (từ năm 1980 đến năm 1989)",
  },
  {
    word: "thập thò",
    part_of_speech: "động từ",
    meaning:
      "từ gợi tả dáng vẻ ló ra rồi lại thụt vào hoặc khuất đi, nhiều lần như vậy, có ý như e sợ, rụt rè: thập thò mãi không dám vào",
    example: "thập thò mãi không dám vào",
  },
  {
    word: "thấp tầng",
    part_of_speech: "tính từ",
    meaning:
      "(nhà) có ít tầng (nói về những toà nhà lớn, thường có nhiều tầng); phân biệt với cao tầng: nhà chung cư thấp tầng",
    example: "nhà chung cư thấp tầng",
  },
  {
    word: "thập kỷ",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian từng mười năm một của một thế kỉ, tính từ năm đầu của thế kỉ trở đi: thập kỉ 80 của thế kỉ XX (từ năm 1980 đến năm 1989)",
    example: "thập kỉ 80 của thế kỉ XX (từ năm 1980 đến năm 1989)",
  },
  {
    word: "thập phương",
    part_of_speech: "danh từ",
    meaning:
      "mười phương, theo quan niệm của đạo Phật (đông, tây, nam, bắc, đông nam, tây nam, đông bắc, tây bắc, trên, dưới); khắp mọi nơi: khách thập phương đến lễ chùa",
    example: "khách thập phương đến lễ chùa",
  },
  {
    word: "thập lục",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) đàn thập lục (nói tắt): cây thập lục",
    example: "cây thập lục",
  },
  {
    word: "thập niên",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian mười năm, thường được tính từ thời điểm nói: thập niên đầu thế kỉ * những năm cuối của thập niên 90",
    example: "thập niên đầu thế kỉ * những năm cuối của thập niên 90",
  },
  {
    word: "thấp thoáng",
    part_of_speech: "động từ",
    meaning:
      'thoáng hiện rồi lại thoáng mất, lúc rõ lúc không: có bóng người thấp thoáng * "Buồn trông cửa bể chiều hôm, Thuyền ai thấp thoáng cánh buồm xa xa?" (TKiều)',
    example:
      'có bóng người thấp thoáng * "Buồn trông cửa bể chiều hôm, Thuyền ai thấp thoáng cánh buồm xa xa?" (TKiều)',
  },
  {
    word: "thấp thỏm",
    part_of_speech: "động từ",
    meaning:
      "(trạng thái tâm lí) luôn phấp phỏng, lo âu, không yên lòng trước một việc mà mình chưa biết rõ nó sẽ xảy ra như thế nào hoặc vào lúc nào: tâm trạng thấp thỏm * thấp thỏm lo sợ",
    example: "tâm trạng thấp thỏm * thấp thỏm lo sợ",
  },
  {
    word: "thập phân",
    part_of_speech: "động từ",
    meaning: "lấy cách chia cho 10 làm cơ sở: hệ đếm thập phân",
    example: "hệ đếm thập phân",
  },
  {
    word: "thập toàn",
    part_of_speech: "tính từ",
    meaning: "(cũ, hiếm) đầy đủ, trọn vẹn hết mọi bề: nhân vô thập toàn (tng)",
    example: "nhân vô thập toàn (tng)",
  },
  {
    word: "thất bảo",
    part_of_speech: "danh từ",
    meaning:
      '(hiếm) bảy thứ quý theo quan niệm của người xưa (như: vàng bạc, san hô, hổ phách, xà cừ, v.v.), dùng làm đồ trang sức hoặc để khảm các đồ dùng (nói khái quát): "Buồng riêng, sửa chốn thanh nhàn, Đặt giường thất bảo, vây màn bát tiên." (TKiều)',
    example:
      'Buồng riêng, sửa chốn thanh nhàn, Đặt giường thất bảo, vây màn bát tiên." (TKiều)',
  },
  {
    word: "thập tử nhất sinh",
    part_of_speech: "",
    meaning:
      "mười phần chết, một phần sống; ý nói rất nguy kịch: ốm thập tử nhất sinh",
    example: "ốm thập tử nhất sinh",
  },
  {
    word: "thất cách",
    part_of_speech: "tính từ",
    meaning:
      "(làm việc gì) trái với quy cách, hoặc không đúng với cách thức thông thường, không hợp lí, nên gây ra những sự bất tiện, kết quả không như ý muốn: nhà làm thất cách, không thoáng gió",
    example: "nhà làm thất cách, không thoáng gió",
  },
  {
    word: "thật",
    part_of_speech: "tính từ",
    meaning:
      "hoàn toàn đúng với nội dung, bản chất hoặc tên gọi: nhà văn Anh Đức tên thật là Bùi Đức ái * hàng thật hàng giả lẫn lộn",
    example:
      "nhà văn Anh Đức tên thật là Bùi Đức ái * hàng thật hàng giả lẫn lộn",
  },
  {
    word: "thật",
    part_of_speech: "tính từ",
    meaning:
      "đúng y như đã có, đã xảy ra trong thực tế, chứ không thêm bớt, không bịa đặt ra: nói thật * chuyện thật mà như bịa * nói đùa mà cứ tưởng thật",
    example: "nói thật * chuyện thật mà như bịa * nói đùa mà cứ tưởng thật",
  },
  {
    word: "thật",
    part_of_speech: "tính từ",
    meaning:
      "ngay thẳng, có thế nào thì bộc lộ thế ấy, không dối trá, không giả tạo: yêu thật lòng * thật bụng giúp đỡ",
    example: "yêu thật lòng * thật bụng giúp đỡ",
  },
  {
    word: "thật",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị mức độ hoàn toàn đầy đủ để có thể thấy rất rõ, không có gì còn phải nghi ngờ: gọi thật to * quét dọn thật sạch sẽ",
    example: "gọi thật to * quét dọn thật sạch sẽ",
  },
  {
    word: "thật",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý khẳng định về một mức độ cao của tính chất hay trạng thái mà người nói nhận thấy rất rõ và như muốn trao đổi, thông báo cho người đối thoại: chiếc áo đẹp thật * chết thật, tôi quên bẵng đi mất",
    example: "chiếc áo đẹp thật * chết thật, tôi quên bẵng đi mất",
  },
  {
    word: "thật",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý khẳng định về một việc qua thực tế thấy đúng như vậy, phải thừa nhận, không có gì còn phải nghi ngờ: tưởng nó chỉ nói doạ thế thôi, ai ngờ nó làm thật * quả có thế thật * đúng thật",
    example:
      "tưởng nó chỉ nói doạ thế thôi, ai ngờ nó làm thật * quả có thế thật * đúng thật",
  },
  {
    word: "thất bát",
    part_of_speech: "động từ",
    meaning:
      "(mùa màng) mất mát, thu hoạch kém hơn nhiều so với mức bình thường (nói khái quát): mùa màng thất bát",
    example: "mùa màng thất bát",
  },
  {
    word: "thất bại",
    part_of_speech: "",
    meaning:
      "không đạt được kết quả, mục đích như dự định: âm mưu đảo chính bị thất bại * gặp thất bại trên thương trường",
    example: "âm mưu đảo chính bị thất bại * gặp thất bại trên thương trường",
  },
  {
    word: "thất bại",
    part_of_speech: "",
    meaning:
      "không giành được phần thắng, phải chịu thua đối phương: cuộc chiến tranh phi nghĩa đã thất bại",
    example: "cuộc chiến tranh phi nghĩa đã thất bại",
  },
  {
    word: "thất cơ",
    part_of_speech: "động từ",
    meaning:
      "(cũ) sai lầm về mưu kế (nên phải thua đối phương): thất cơ nên bị thua trận",
    example: "thất cơ nên bị thua trận",
  },
  {
    word: "thất đảm",
    part_of_speech: "động từ",
    meaning:
      "(cũ) sợ hãi đến mức hoảng hốt, mất hết tinh thần: sợ thất đảm * bị một phen thất đảm",
    example: "sợ thất đảm * bị một phen thất đảm",
  },
  {
    word: "thất cử",
    part_of_speech: "động từ",
    meaning: "không trúng cử: thất cử tổng thống",
    example: "thất cử tổng thống",
  },
  {
    word: "thất đức",
    part_of_speech: "",
    meaning:
      "làm tổn hại đến cái đức của tổ tiên, ông bà để lại cho mình và do đó cũng không để lại được cái đức cho con cháu mình mai sau: ăn ở thất đức * làm điều thất đức",
    example: "ăn ở thất đức * làm điều thất đức",
  },
  {
    word: "thất hiếu",
    part_of_speech: "động từ",
    meaning:
      "(con cái) lỗi đạo, không giữ tròn chữ hiếu đối với cha mẹ: thất hiếu với mẹ cha",
    example: "thất hiếu với mẹ cha",
  },
  {
    word: "thất gia",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) như gia thất: "Tới đây thời ở lại đây, Cùng con gái lão sum vầy thất gia." (LVT)',
    example:
      'Tới đây thời ở lại đây, Cùng con gái lão sum vầy thất gia." (LVT)',
  },
  {
    word: "thất học",
    part_of_speech: "",
    meaning:
      "không được học hành (thường do một điều kiện, hoàn cảnh) nên phải chịu cảnh dốt nát: kẻ thất học",
    example: "kẻ thất học",
  },
  {
    word: "thất kinh",
    part_of_speech: "động từ",
    meaning:
      'sợ đến mức mất hết cả tinh thần, hồn vía: sợ thất kinh * "Thúc ông nhà cũng gần quanh, Chợt trông ngọn lửa, thất kinh rụng rời." (TKiều)',
    example:
      'sợ thất kinh * "Thúc ông nhà cũng gần quanh, Chợt trông ngọn lửa, thất kinh rụng rời." (TKiều)',
  },
  {
    word: "thật lực",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) (làm việc gì) bằng tất cả sức lực, khả năng của mình, không còn có thể hơn nữa: làm thật lực * chạy thật lực mà vẫn không kịp",
    example: "làm thật lực * chạy thật lực mà vẫn không kịp",
  },
  {
    word: "thật lực",
    part_of_speech: "phụ từ",
    meaning:
      "(hiếm) hết sức, đến mức độ không còn có thể nào hơn được nữa: vui thật lực * nó lăn ra, ngủ thật lực một giấc đến tận sáng",
    example: "vui thật lực * nó lăn ra, ngủ thật lực một giấc đến tận sáng",
  },
  {
    word: "thất lạc",
    part_of_speech: "động từ",
    meaning:
      "lạc mất, không tìm thấy: tài liệu bị thất lạc * tìm được đứa con thất lạc",
    example: "tài liệu bị thất lạc * tìm được đứa con thất lạc",
  },
  {
    word: "thất hứa",
    part_of_speech: "động từ",
    meaning:
      "không giữ đúng, làm đúng như lời đã hứa: không muốn thất hứa với bạn bè",
    example: "không muốn thất hứa với bạn bè",
  },
  {
    word: "thất lễ",
    part_of_speech: "",
    meaning:
      "không giữ đúng được phép tắc cư xử, thường là đối với người trên hoặc người lớn tuổi hơn: thất lễ với thầy giáo",
    example: "thất lễ với thầy giáo",
  },
  {
    word: "thất nghiệp",
    part_of_speech: "động từ",
    meaning:
      "không có việc làm để sinh sống: hạn chế nạn thất nghiệp * thất nghiệp phải ngồi không",
    example: "hạn chế nạn thất nghiệp * thất nghiệp phải ngồi không",
  },
  {
    word: "thất luật",
    part_of_speech: "tính từ",
    meaning: "(thơ) không đúng niêm luật: bài thơ thất luật",
    example: "bài thơ thất luật",
  },
  {
    word: "thất phu",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) người đàn ông là dân thường, dốt nát, hèn kém (hàm ý coi khinh, theo quan niệm cũ): kẻ thất phu * "E khi mắc đảng hành hung, Uổng trang thục nữ sánh cùng thất phu." (LVT)',
    example:
      'kẻ thất phu * "E khi mắc đảng hành hung, Uổng trang thục nữ sánh cùng thất phu." (LVT)',
  },
  {
    word: "thật ra",
    part_of_speech: "",
    meaning:
      "tổ hợp biểu thị điều sắp nêu ra mới là sự thật và nó có phần trái với điều vừa nói đến hoặc với điều người ta vẫn thường nghĩ: thật ra anh ta cũng là một người tốt",
    example: "thật ra anh ta cũng là một người tốt",
  },
  {
    word: "thất sắc",
    part_of_speech: "động từ",
    meaning:
      "thay đổi thần sắc một cách đột ngột, từ bình thường trở thành tái đi, do sợ hãi hoặc quá mệt mỏi: mặt mày thất sắc",
    example: "mặt mày thất sắc",
  },
  {
    word: "thất sách",
    part_of_speech: "tính từ",
    meaning:
      "sai lầm trong việc mưu tính, trong cách giải quyết công việc, nên hỏng việc: làm như vậy là thất sách",
    example: "làm như vậy là thất sách",
  },
  {
    word: "thật sự",
    part_of_speech: "tính từ",
    meaning:
      "thật, có thật, với đầy đủ mức độ hoặc ý nghĩa: người chủ thật sự * giỏi thật sự * thật sự ngạc nhiên",
    example: "người chủ thật sự * giỏi thật sự * thật sự ngạc nhiên",
  },
  {
    word: "thất tán",
    part_of_speech: "động từ",
    meaning:
      "tan tác, thất lạc đi nhiều nơi, nhiều hướng: chiến tranh loạn lạc, gia đình thất tán mỗi người một nơi * tài sản bị thất tán",
    example:
      "chiến tranh loạn lạc, gia đình thất tán mỗi người một nơi * tài sản bị thất tán",
  },
  {
    word: "thất sủng",
    part_of_speech: "động từ",
    meaning:
      "(Từ cũ) không còn được người bề trên yêu mến, tin dùng nữa: hoàng hậu bị thất sủng",
    example: "hoàng hậu bị thất sủng",
  },
  {
    word: "thất thế",
    part_of_speech: "động từ",
    meaning:
      "không có được hoặc bị mất đi vị trí, chỗ tựa thuận lợi, làm cho thiếu sự vững vàng, không có sức chống đỡ: đứng thất thế nên dễ bị ngã",
    example: "đứng thất thế nên dễ bị ngã",
  },
  {
    word: "thất thế",
    part_of_speech: "động từ",
    meaning:
      'mất đi cái địa vị, thế lực vốn có: "Bao giờ dân nổi can qua, Con vua thất thế, lại ra ở chùa." (ca dao)',
    example:
      'Bao giờ dân nổi can qua, Con vua thất thế, lại ra ở chùa." (ca dao)',
  },
  {
    word: "thất thần",
    part_of_speech: "động từ",
    meaning:
      "mất hết cả khí sắc, tinh thần, thường do quá sợ hãi hoặc do có sự chấn động mạnh về mặt tâm lí: sợ thất thần",
    example: "sợ thất thần",
  },
  {
    word: "thất thanh",
    part_of_speech: "tính từ",
    meaning:
      "(kêu, hét) to đến lạc giọng, không thành tiếng vì quá sợ hãi: kêu thất thanh * sợ quá, la thất thanh",
    example: "kêu thất thanh * sợ quá, la thất thanh",
  },
  {
    word: "thật thà",
    part_of_speech: "tính từ",
    meaning:
      "(tính người) tự bộc lộ mình một cách tự nhiên như vốn có, không giả dối, không giả tạo: tính thật thà, có sao nói vậy",
    example: "tính thật thà, có sao nói vậy",
  },
  {
    word: "thật thà",
    part_of_speech: "tính từ",
    meaning:
      "(tính người) đàng hoàng, không tham của người khác: con người thật thà * sống thật thà, không gian lận",
    example: "con người thật thà * sống thật thà, không gian lận",
  },
  {
    word: "thất thểu",
    part_of_speech: "",
    meaning:
      "từ gợi tả dáng đi chậm chạp không đều, không vững, lộ vẻ mệt mỏi, chán nản: mệt quá, bước đi thất thểu",
    example: "mệt quá, bước đi thất thểu",
  },
  {
    word: "thất thiệt",
    part_of_speech: "động từ",
    meaning: "(hiếm) mất mát, thiệt hại: mùa màng thất thiệt sau cơn bão",
    example: "mùa màng thất thiệt sau cơn bão",
  },
  {
    word: "thất thiệt",
    part_of_speech: "tính từ",
    meaning:
      "(tin tức) không đúng sự thật, không đáng tin, thường được đưa ra với dụng ý xấu: tin thất thiệt",
    example: "tin thất thiệt",
  },
  {
    word: "thất thoát",
    part_of_speech: "động từ",
    meaning:
      "mất đi với số lượng lớn, gây thiệt hại đáng kể (nói khái quát): thất thoát điện năng * hàng hoá bị thất thoát",
    example: "thất thoát điện năng * hàng hoá bị thất thoát",
  },
  {
    word: "thất thủ",
    part_of_speech: "động từ",
    meaning:
      "(cũ) (vị trí phòng thủ quan trọng) bị mất về tay đối phương: kinh thành thất thủ",
    example: "kinh thành thất thủ",
  },
  {
    word: "thất tín",
    part_of_speech: "động từ",
    meaning:
      "làm phụ lòng tin vì không giữ lời hứa: thất tín với khách hàng * con người thất tín",
    example: "thất tín với khách hàng * con người thất tín",
  },
  {
    word: "thất thố",
    part_of_speech: "tính từ",
    meaning:
      "sơ suất, sai phạm, thiếu giữ gìn ý tứ trong cách cư xử, nói năng (thường là đối với người trên): có điều gì thất thố, mong cụ lượng thứ cho!",
    example: "có điều gì thất thố, mong cụ lượng thứ cho!",
  },
  {
    word: "thất tình",
    part_of_speech: "",
    meaning:
      "(tâm trạng) buồn chán, đau khổ vì thất vọng trong tình yêu: bị thất tình",
    example: "bị thất tình",
  },
  {
    word: "thất thường",
    part_of_speech: "tính từ",
    meaning:
      "ở tình trạng hay thay đổi, khi thế này, khi thế khác, không theo một quy luật nào cả: thời tiết thất thường * ăn ngủ thất thường * tính khí thất thường",
    example:
      "thời tiết thất thường * ăn ngủ thất thường * tính khí thất thường",
  },
  {
    word: "thất thu",
    part_of_speech: "động từ",
    meaning:
      "thu không đạt mức, ở dưới mức được coi là bình thường trong sản xuất, kinh doanh: chống thất thu thuế * mùa màng thất thu do hạn hán kéo dài",
    example: "chống thất thu thuế * mùa màng thất thu do hạn hán kéo dài",
  },
  {
    word: "thất trận",
    part_of_speech: "động từ",
    meaning: "thua trận: đội quân thất trận",
    example: "đội quân thất trận",
  },
  {
    word: "thật tình",
    part_of_speech: "tính từ",
    meaning:
      "thành thật, đúng với thực tế của tình cảm, ý nghĩ, không giả dối: mời rất thực tình * nói thực tình",
    example: "mời rất thực tình * nói thực tình",
  },
  {
    word: "thật tình",
    part_of_speech: "tính từ",
    meaning:
      "hay p đúng như vậy, sự thật là như vậy: thực tình, tôi cũng không muốn chuyện này xảy ra",
    example: "thực tình, tôi cũng không muốn chuyện này xảy ra",
  },
  {
    word: "thất truyền",
    part_of_speech: "động từ",
    meaning:
      "bị mất đi, không còn được truyền lại cho đời sau nữa: phương thuốc bị thất truyền",
    example: "phương thuốc bị thất truyền",
  },
  {
    word: "thấu",
    part_of_speech: "tính từ",
    meaning:
      "liền suốt một mạch từ đầu này cho tới đầu kia: nước trong, nhìn thấu đáy * lạnh thấu xương",
    example: "nước trong, nhìn thấu đáy * lạnh thấu xương",
  },
  {
    word: "thấu",
    part_of_speech: "tính từ",
    meaning: "rõ đến mức tường tận: hiểu thấu lòng nhau * biết thấu sự tình",
    example: "hiểu thấu lòng nhau * biết thấu sự tình",
  },
  {
    word: "thấu",
    part_of_speech: "tính từ",
    meaning: "hay p (phương ngữ) như nổi: nặng quá, chịu không thấu",
    example: "nặng quá, chịu không thấu",
  },
  {
    word: "thâu",
    part_of_speech: "tính từ",
    meaning:
      'suốt từ đầu đến cuối trong một khoảng thời gian nào đó, thường là ban đêm: thức thâu đêm * "Chim quyên lăng líu cành dâu, Đêm nằm thăm thẳm canh thâu nhớ chàng." (ca dao)',
    example:
      'thức thâu đêm * "Chim quyên lăng líu cành dâu, Đêm nằm thăm thẳm canh thâu nhớ chàng." (ca dao)',
  },
  {
    word: "thẩu",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) lọ thuỷ tinh hoặc nhựa, miệng rộng, cổ ngắn và thường có nắp đậy: thẩu mứt * thẩu mắm",
    example: "thẩu mứt * thẩu mắm",
  },
  {
    word: "thấu đáo",
    part_of_speech: "tính từ",
    meaning:
      "(hiểu biết, suy nghĩ) tường tận, kĩ càng, đến nơi đến chốn: hiểu thấu đáo * suy nghĩ một cách thấu đáo",
    example: "hiểu thấu đáo * suy nghĩ một cách thấu đáo",
  },
  {
    word: "thầu",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) nhận thầu (nói tắt): thầu ao nuôi cá",
    example: "thầu ao nuôi cá",
  },
  {
    word: "thất vọng",
    part_of_speech: "",
    meaning:
      "mất hết hi vọng, không còn trông mong gì được nữa: lắc đầu thất vọng * thất vọng tràn trề",
    example: "lắc đầu thất vọng * thất vọng tràn trề",
  },
  {
    word: "thấu cảm",
    part_of_speech: "động từ",
    meaning: "cảm nhận và thấu hiểu một cách sâu sắc: thấu cảm lòng nhau",
    example: "thấu cảm lòng nhau",
  },
  {
    word: "thấu hiểu",
    part_of_speech: "động từ",
    meaning:
      "hiểu một cách sâu sắc, tường tận: thấu hiểu lòng nhau * thấu hiểu tình cảnh của bạn",
    example: "thấu hiểu lòng nhau * thấu hiểu tình cảnh của bạn",
  },
  {
    word: "thấu tình đạt lý",
    part_of_speech: "",
    meaning:
      "thoả đáng cả về lí lẽ lẫn tình cảm (hợp với lẽ phải, thuận với lòng người): một cách giải quyết thật thấu tình đạt lí",
    example: "một cách giải quyết thật thấu tình đạt lí",
  },
  {
    word: "thấu suốt",
    part_of_speech: "động từ",
    meaning: "hiểu kĩ và thông suốt: thấu suốt chủ trương của Đảng",
    example: "thấu suốt chủ trương của Đảng",
  },
  {
    word: "thấu thị",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) (nhìn) thấu qua vật cản, bất kể khoảng cách trong không gian hay thời gian: cái nhìn thấu thị của một người từng trải",
    example: "cái nhìn thấu thị của một người từng trải",
  },
  {
    word: "thấy",
    part_of_speech: "động từ",
    meaning:
      "nhận biết được bằng mắt nhìn: thoáng thấy có bóng người * tối quá, không thấy gì hết",
    example: "thoáng thấy có bóng người * tối quá, không thấy gì hết",
  },
  {
    word: "thấy",
    part_of_speech: "động từ",
    meaning:
      "nhận biết được bằng giác quan nói chung: bị nặng tai, không nghe thấy gì * ngửi thấy mùi khét",
    example: "bị nặng tai, không nghe thấy gì * ngửi thấy mùi khét",
  },
  {
    word: "thấy",
    part_of_speech: "động từ",
    meaning:
      "nhận ra được, biết được qua nhận thức: thấy được cái sai của mình",
    example: "thấy được cái sai của mình",
  },
  {
    word: "thấy",
    part_of_speech: "động từ",
    meaning: "có cảm giác: thấy vui trong dạ * thấy xấu hổ với bạn bè",
    example: "thấy vui trong dạ * thấy xấu hổ với bạn bè",
  },
  {
    word: "thây",
    part_of_speech: "danh từ",
    meaning: "xác người: phanh thây * chết không toàn thây",
    example: "phanh thây * chết không toàn thây",
  },
  {
    word: "thây",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) mặc, muốn ra sao thì ra, không quan tâm để ý đến: ai nói gì cũng thây * nó muốn làm gì cứ thây nó!",
    example: "ai nói gì cũng thây * nó muốn làm gì cứ thây nó!",
  },
  {
    word: "thấu tình đạt lí",
    part_of_speech: "",
    meaning:
      "thoả đáng cả về lí lẽ lẫn tình cảm (hợp với lẽ phải, thuận với lòng người): một cách giải quyết thật thấu tình đạt lí",
    example: "một cách giải quyết thật thấu tình đạt lí",
  },
  {
    word: "thấu triệt",
    part_of_speech: "tính từ",
    meaning:
      "hoàn toàn tường tận, sâu sắc ở mọi khía cạnh: hiểu thấu triệt vấn đề",
    example: "hiểu thấu triệt vấn đề",
  },
  {
    word: "thấu triệt",
    part_of_speech: "động từ",
    meaning:
      "hiểu hoặc thực hiện một cách đầy đủ, triệt để: thấu triệt đường lối",
    example: "thấu triệt đường lối",
  },
  {
    word: "thâu tóm",
    part_of_speech: "động từ",
    meaning: "tập trung lại để nắm giữ, sử dụng: thâu tóm mọi quyền hành",
    example: "thâu tóm mọi quyền hành",
  },
  {
    word: "thâu tóm",
    part_of_speech: "động từ",
    meaning:
      "bao quát và nắm được những cái chính, cái cơ bản: thâu tóm nội dung của tác phẩm",
    example: "thâu tóm nội dung của tác phẩm",
  },
  {
    word: "thầy bà",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) thầy giáo, hoặc nói chung những người vẫn thường được xã hội gọi tôn là thầy (nói khái quát; hàm ý coi thường): thầy bà gì cái loại nó",
    example: "thầy bà gì cái loại nó",
  },
  {
    word: "thấy bà",
    part_of_speech: "",
    meaning:
      "(phương ngữ, khẩu ngữ) tổ hợp biểu thị mức độ quá cao, cao hơn hẳn mức bình thường: chán thấy bà * mệt thấy bà",
    example: "chán thấy bà * mệt thấy bà",
  },
  {
    word: "thầy bói",
    part_of_speech: "danh từ",
    meaning: "người chuyên làm nghề bói toán: thầy bói nói dựa",
    example: "thầy bói nói dựa",
  },
  {
    word: "thầy",
    part_of_speech: "danh từ",
    meaning:
      'người đàn ông làm nghề dạy học hoặc nói chung người dạy học, trong quan hệ với học sinh (có thể dùng để xưng gọi): tình thầy trò * "Muốn sang thì bắc cầu kiều, Muốn con hay chữ, thì yêu lấy thầy." (ca dao)',
    example:
      'tình thầy trò * "Muốn sang thì bắc cầu kiều, Muốn con hay chữ, thì yêu lấy thầy." (ca dao)',
  },
  {
    word: "thầy",
    part_of_speech: "danh từ",
    meaning:
      "người có khả năng, trình độ trong một lĩnh vực nào đó, được xem như có thể hướng dẫn, dạy bảo được cho người khác (hàm ý coi trọng): nhà văn Nguyễn Tuân là bậc thầy về thể loại tuỳ bút",
    example: "nhà văn Nguyễn Tuân là bậc thầy về thể loại tuỳ bút",
  },
  {
    word: "thầy",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để gọi tôn người làm một số nghề đòi hỏi có học, hoặc dùng để gọi những viên chức cấp thấp thời phong kiến, thực dân: thầy lang * thầy thuốc * thầy thông",
    example: "thầy lang * thầy thuốc * thầy thông",
  },
  {
    word: "thầy",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) chủ, trong quan hệ với tớ trong xã hội cũ: thay thầy đổi chủ (tng)",
    example: "thay thầy đổi chủ (tng)",
  },
  {
    word: "thầy",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) cha (thường dùng để xưng gọi trong những gia đình nhà nho hoặc gia đình trung lưu, thượng lưu thời trước): thầy u * "Em về xin mẹ xin thầy, Cho anh kiếm đĩa trầu đầy lên chơi." (ca dao)',
    example:
      'thầy u * "Em về xin mẹ xin thầy, Cho anh kiếm đĩa trầu đầy lên chơi." (ca dao)',
  },
  {
    word: "thầy dùi",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) người chuyên kiếm chuyện để xúi giục người này người khác gây xích mích, mâu thuẫn với nhau, để mình ở giữa kiếm lợi: không nên nghe theo bọn thầy dùi",
    example: "không nên nghe theo bọn thầy dùi",
  },
  {
    word: "thầy địa lí",
    part_of_speech: "danh từ",
    meaning:
      'người chuyên làm nghề xem thế đất để tìm chỗ đặt mồ mả, dựng nhà cửa cho được may mắn, theo thuật phong thuỷ: "Hòn đất mà biết nói năng, Thì thầy địa lí hàm răng chẳng còn." (ca dao)',
    example:
      'Hòn đất mà biết nói năng, Thì thầy địa lí hàm răng chẳng còn." (ca dao)',
  },
  {
    word: "thầy địa lý",
    part_of_speech: "danh từ",
    meaning:
      'người chuyên làm nghề xem thế đất để tìm chỗ đặt mồ mả, dựng nhà cửa cho được may mắn, theo thuật phong thuỷ: "Hòn đất mà biết nói năng, Thì thầy địa lí hàm răng chẳng còn." (ca dao)',
    example:
      'Hòn đất mà biết nói năng, Thì thầy địa lí hàm răng chẳng còn." (ca dao)',
  },
  {
    word: "thây kệ",
    part_of_speech: "động từ",
    meaning: "(thông tục) như mặc kệ: thây kệ nó, muốn làm gì thì làm",
    example: "thây kệ nó, muốn làm gì thì làm",
  },
  {
    word: "thây lẩy",
    part_of_speech: "tính từ",
    meaning: "ở trạng thái chìa ra, nhô hẳn ra: cái bướu thây lẩy ở cổ",
    example: "cái bướu thây lẩy ở cổ",
  },
  {
    word: "thấy mồ",
    part_of_speech: "",
    meaning: "(phương ngữ, khẩu ngữ) như thấy bà: mắc cỡ thấy mồ!",
    example: "mắc cỡ thấy mồ!",
  },
  {
    word: "thây ma",
    part_of_speech: "danh từ",
    meaning:
      "xác người chết (hàm ý coi khinh): nằm còng queo như một cái thây ma",
    example: "nằm còng queo như một cái thây ma",
  },
  {
    word: "thầy thợ",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) người chuyên chạy lo việc thuê cho người khác, thường là việc giấy tờ ở cửa công trong xã hội cũ (nói khái quát): "Chiến, hoà sắp sẵn hai bài, Cậy tay thầy thợ, mượn người dò la." (TKiều)',
    example:
      'Chiến, hoà sắp sẵn hai bài, Cậy tay thầy thợ, mượn người dò la." (TKiều)',
  },
  {
    word: "thé",
    part_of_speech: "tính từ",
    meaning:
      "(tiếng người) cao và thường rít lên đột ngột, nghe chối tai: giọng bà ấy hơi thé * thằng bé gào thé lên",
    example: "giọng bà ấy hơi thé * thằng bé gào thé lên",
  },
  {
    word: "the",
    part_of_speech: "danh từ",
    meaning:
      'hàng dệt bằng tơ nhỏ sợi, mặt thưa, mỏng, không bóng, thời trước thường dùng để may áo dài hoặc khăn, màn: khăn the * rèm the * "Ra đường quần lĩnh áo the, Về nhà không có con me mà cày." (Cdao)',
    example:
      'khăn the * rèm the * "Ra đường quần lĩnh áo the, Về nhà không có con me mà cày." (Cdao)',
  },
  {
    word: "the",
    part_of_speech: "tính từ",
    meaning:
      "có vị hơi cay cay, tê tê, như vị của vỏ cam, bưởi: bưởi non ăn hơi the",
    example: "bưởi non ăn hơi the",
  },
  {
    word: "thè lè",
    part_of_speech: "",
    meaning: "đưa lưỡi chìa thật dài ra ngoài miệng: lưỡi thè lè",
    example: "lưỡi thè lè",
  },
  {
    word: "thè lè",
    part_of_speech: "",
    meaning:
      "ở trạng thái chìa hẳn ra ngoài so với những cái khác cùng hàng, trông khó coi: quán bán nước nằm thè lè bên đường",
    example: "quán bán nước nằm thè lè bên đường",
  },
  {
    word: "thẻ bài",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) thẻ bằng gỗ sơn, trước đây thường dùng để viết trát của quan, hoặc để ghi nhận một điều gì: thẻ bài của quan huyện đòi lí trưởng lên hầu",
    example: "thẻ bài của quan huyện đòi lí trưởng lên hầu",
  },
  {
    word: "thè",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) lè: thè lưỡi liếm",
    example: "thè lưỡi liếm",
  },
  {
    word: "thẻ",
    part_of_speech: "danh từ",
    meaning:
      "mảnh tre, gỗ, giấy, v.v. dẹp và mỏng, dùng để ghi hay đánh dấu điều gì: trọng tài phạt thẻ đỏ * đầu năm đi rút thẻ",
    example: "trọng tài phạt thẻ đỏ * đầu năm đi rút thẻ",
  },
  {
    word: "thẻ",
    part_of_speech: "danh từ",
    meaning:
      "giấy chứng nhận một tư cách nào đó, thường có dạng nhỏ, gọn: thẻ nhà báo * thẻ cử tri",
    example: "thẻ nhà báo * thẻ cử tri",
  },
  {
    word: "thẻ",
    part_of_speech: "danh từ",
    meaning:
      "vật nhỏ có hình dẹp và mỏng (trông giống như cái thẻ tre): thẻ mạ * mua mấy thẻ hương * gãy mất hai thẻ xương sườn",
    example: "thẻ mạ * mua mấy thẻ hương * gãy mất hai thẻ xương sườn",
  },
  {
    word: "thẻ",
    part_of_speech: "danh từ",
    meaning:
      "miếng plastic có kích thước tiêu chuẩn, trên mặt có dải băng từ ghi thông tin về thẻ và chủ của thẻ, thường do ngân hàng phát hành để phục vụ trong các giao dịch thanh toán tự động: thẻ ATM * thanh toán bằng thẻ",
    example: "thẻ ATM * thanh toán bằng thẻ",
  },
  {
    word: "the thé",
    part_of_speech: "tính từ",
    meaning: "như thé (nhưng ý mức độ cao hơn): giọng the thé như xé vải",
    example: "giọng the thé như xé vải",
  },
  {
    word: "thẽ thọt",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả lối nói nhỏ nhẹ, thong thả, như cố tranh thủ cảm tình của người nghe: nói bằng giọng thẽ thọt",
    example: "nói bằng giọng thẽ thọt",
  },
  {
    word: "thèm khát",
    part_of_speech: "động từ",
    meaning:
      "thèm đến mức thiết tha, thôi thúc vì đang cảm thấy rất thiếu (thường nói về nhu cầu tình cảm, tinh thần): ánh mắt thèm khát * thèm khát vòng tay yêu thương của mẹ",
    example: "ánh mắt thèm khát * thèm khát vòng tay yêu thương của mẹ",
  },
  {
    word: "thèm",
    part_of_speech: "động từ",
    meaning:
      "có cảm giác muốn được hưởng cái gì đó trong sinh hoạt, do nhu cầu thôi thúc của cơ thể: thèm thuốc lào * thèm được ngủ một giấc * ăn cho đã thèm",
    example: "thèm thuốc lào * thèm được ngủ một giấc * ăn cho đã thèm",
  },
  {
    word: "thèm",
    part_of_speech: "động từ",
    meaning:
      "tha thiết mong muốn được hưởng, được có, hay được làm một cái gì đó: thèm một đứa cháu nội",
    example: "thèm một đứa cháu nội",
  },
  {
    word: "thèm",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) muốn, cần do có nhu cầu: thèm đi chơi * chán chẳng thèm nhìn * không thèm chấp",
    example: "thèm đi chơi * chán chẳng thèm nhìn * không thèm chấp",
  },
  {
    word: "thèm muốn",
    part_of_speech: "",
    meaning:
      "muốn được thoả mãn nhu cầu nào đó của bản thân (thường là những cái bị coi là tầm thường): thèm muốn cuộc sống giàu sang * cái nhìn thèm muốn",
    example: "thèm muốn cuộc sống giàu sang * cái nhìn thèm muốn",
  },
  {
    word: "thèm thuồng",
    part_of_speech: "động từ",
    meaning: "thèm đến mức để lộ rõ ra ở cử chỉ, thái độ: ánh mắt thèm thuồng",
    example: "ánh mắt thèm thuồng",
  },
  {
    word: "thèm nhạt",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ, hiếm) thèm (nói khái quát): không thèm nhạt gì",
    example: "không thèm nhạt gì",
  },
  {
    word: "then",
    part_of_speech: "danh từ",
    meaning:
      "thanh gỗ hay sắt nhỏ và dài, dùng để cài giữ cánh cửa khi đóng: cửa đóng then cài * then cửa",
    example: "cửa đóng then cài * then cửa",
  },
  {
    word: "then",
    part_of_speech: "danh từ",
    meaning:
      "thanh gỗ hay sắt, được đóng bắc ngang ở một số vật để giữ cho chắc: then ghế",
    example: "then ghế",
  },
  {
    word: "then",
    part_of_speech: "danh từ",
    meaning:
      "chi tiết máy đặt trong rãnh dọc giữa trục và lỗ của vật lắp trên trục để không cho chúng xoay được với nhau.",
    example: "then thuyền",
  },
  {
    word: "then",
    part_of_speech: "danh từ",
    meaning:
      "lực lượng siêu nhiên sáng tạo ra thế giới, theo quan niệm của một số dân tộc thiểu số miền Bắc Việt Nam.",
    example: "bà then",
  },
  {
    word: "then",
    part_of_speech: "danh từ",
    meaning:
      "người làm nghề cúng bái (thường là nữ) ở các vùng dân tộc thiểu số miền Bắc Việt Nam: bà then",
    example: "hát then * điệu múa then",
  },
  {
    word: "then",
    part_of_speech: "tính từ",
    meaning: "có màu đen và bóng: cái tráp sơn then",
    example: "cái tráp sơn then",
  },
  {
    word: "thẹn thò",
    part_of_speech: "",
    meaning: "tỏ ra mất tự nhiên, rụt rè, e lệ vì thẹn: dáng điệu thẹn thò",
    example: "dáng điệu thẹn thò",
  },
  {
    word: "thèm vào",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) không thèm (hàm ý dằn dỗi hoặc coi khinh): thèm vào cái của ấy!",
    example: "thèm vào cái của ấy!",
  },
  {
    word: "thẹn",
    part_of_speech: "động từ",
    meaning:
      "hoặc t tự cảm thấy bối rối, ngại ngùng, mất tự nhiên khi tiếp xúc với đám đông hay người khác giới cùng lứa tuổi (thường nói về người trẻ tuổi): tính hay thẹn khi tiếp xúc với người lạ * thẹn đỏ cả mặt",
    example: "tính hay thẹn khi tiếp xúc với người lạ * thẹn đỏ cả mặt",
  },
  {
    word: "thẹn",
    part_of_speech: "động từ",
    meaning:
      'tự cảm thấy mình có điều gì đó không nên, không phải hoặc không xứng đáng: không thẹn với lòng mình * "Trông trăng mà thẹn với trời, Soi gương mà thẹn với người trong gương." (ca dao)',
    example:
      'không thẹn với lòng mình * "Trông trăng mà thẹn với trời, Soi gương mà thẹn với người trong gương." (ca dao)',
  },
  {
    word: "then chốt",
    part_of_speech: "danh từ",
    meaning:
      "cái quan trọng nhất, có vai trò và tác dụng quyết định đối với toàn bộ: vị trí then chốt * điểm then chốt của vấn đề",
    example: "vị trí then chốt * điểm then chốt của vấn đề",
  },
  {
    word: "theo đòi",
    part_of_speech: "động từ",
    meaning:
      '(cũ) chuyên chú, miệt mài với một công việc có tính chất lâu dài nào đó: theo đòi kinh sử * "Sinh rằng: Chút phận bọt bèo, Theo đòi vả cũng ít nhiều bút nghiên." (TKiều)',
    example:
      'theo đòi kinh sử * "Sinh rằng: Chút phận bọt bèo, Theo đòi vả cũng ít nhiều bút nghiên." (TKiều)',
  },
  {
    word: "theo đòi",
    part_of_speech: "động từ",
    meaning:
      "bắt chước, làm theo (việc thường là không hay): theo đòi chúng bạn",
    example: "theo đòi chúng bạn",
  },
  {
    word: "thẹo",
    part_of_speech: "danh từ",
    meaning:
      "(Nam cũng dùng thẹo) dấu tích vết thương hay mụn nhọt để lại trên da, sau khi khỏi: vết thương đã thành sẹo * mặt đầy sẹo",
    example: "vết thương đã thành sẹo * mặt đầy sẹo",
  },
  {
    word: "thẹo",
    part_of_speech: "danh từ",
    meaning: "mấu: tấm ván có sẹo * thân sắn mang nhiều sẹo lá",
    example: "tấm ván có sẹo * thân sắn mang nhiều sẹo lá",
  },
  {
    word: "thẹo",
    part_of_speech: "danh từ",
    meaning:
      "lỗ thủng xoi ở vách mũi trâu bò để xỏ dây vào mà điều khiển: trâu đứt sẹo",
    example: "trâu đứt sẹo",
  },
  {
    word: "theo",
    part_of_speech: "động từ",
    meaning:
      "đi liền ở phía sau, không rời ra: đuổi theo tên cướp * lẽo đẽo theo sau * theo dòng lịch sử (b)",
    example: "đuổi theo tên cướp * lẽo đẽo theo sau * theo dòng lịch sử (b)",
  },
  {
    word: "theo",
    part_of_speech: "động từ",
    meaning:
      "đi cùng với, thường là đi kèm với: hành lí mang theo người * theo cha mẹ sang định cư ở Pháp",
    example: "hành lí mang theo người * theo cha mẹ sang định cư ở Pháp",
  },
  {
    word: "theo",
    part_of_speech: "động từ",
    meaning:
      "bỏ nhà đi chung sống với người khác như vợ chồng mà không có cưới hỏi chính thức (hàm ý chê): theo gái * bỏ chồng theo trai",
    example: "theo gái * bỏ chồng theo trai",
  },
  {
    word: "theo",
    part_of_speech: "động từ",
    meaning:
      "tin vào và hướng suy nghĩ, hành động của mình cho phù hợp với mục đích, yêu cầu của cá nhân, tổ chức hay tôn giáo, v.v. nào đó: theo đạo Phật * cam lòng theo giặc",
    example: "theo đạo Phật * cam lòng theo giặc",
  },
  {
    word: "theo",
    part_of_speech: "động từ",
    meaning:
      "hoạt động liên tục trong một công việc nào đó một cách kiên trì nhằm đạt một mục đích nhất định: theo học chữ nho * theo nghề canh cửi * theo kiện mấy năm trời",
    example: "theo học chữ nho * theo nghề canh cửi * theo kiện mấy năm trời",
  },
  {
    word: "theo",
    part_of_speech: "động từ",
    meaning:
      "từ biểu thị lối, hướng di chuyển hoặc hoạt động: trôi theo dòng nước * nhìn với theo",
    example: "trôi theo dòng nước * nhìn với theo",
  },
  {
    word: "theo",
    part_of_speech: "động từ",
    meaning:
      "làm giống như người khác đã làm, do chịu một sự tác động hay ảnh hưởng nhất định từ việc làm của người đó đưa lại: cất giọng hát theo * đứa bé thấy chị khóc, cũng khóc theo",
    example: "cất giọng hát theo * đứa bé thấy chị khóc, cũng khóc theo",
  },
  {
    word: "theo",
    part_of_speech: "động từ",
    meaning: "dựa vào, căn cứ vào: uống thuốc theo đơn * xây theo bản thiết kế",
    example: "uống thuốc theo đơn * xây theo bản thiết kế",
  },
  {
    word: "thẻo",
    part_of_speech: "danh từ",
    meaning:
      "miếng nhỏ và dài, như được xẻo ra ở rìa, cạnh: thẻo vải * thẻo đất",
    example: "thẻo vải * thẻo đất",
  },
  {
    word: "theo dõi",
    part_of_speech: "động từ",
    meaning:
      "chú ý quan sát (thường là kín đáo, bí mật) từng hoạt động, từng diễn biến để biết rõ hoặc để có sự ứng phó, xử lí kịp thời: theo dõi tin tức trên báo * theo dõi bệnh tình * bị theo dõi",
    example: "theo dõi tin tức trên báo * theo dõi bệnh tình * bị theo dõi",
  },
  {
    word: "thẹn thùng",
    part_of_speech: "",
    meaning:
      "tỏ ra thẹn, thường để lộ qua dáng vẻ bề ngoài (nói khái quát): vẻ mặt thẹn thùng * dáng điệu khép nép, thẹn thùng",
    example: "vẻ mặt thẹn thùng * dáng điệu khép nép, thẹn thùng",
  },
  {
    word: "thèo đảnh",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ở vị trí chênh vênh gây cảm giác dễ đổ, dễ ngã do không có chỗ bám hoặc chỗ dựa: đứng thèo đảnh trên mép bàn",
    example: "đứng thèo đảnh trên mép bàn",
  },
  {
    word: "theo đuôi",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) làm hùa theo một cách thụ động, thiếu suy nghĩ riêng: theo đuôi đám bạn xấu * không chịu suy nghĩ, chỉ phát biểu theo đuôi",
    example:
      "theo đuôi đám bạn xấu * không chịu suy nghĩ, chỉ phát biểu theo đuôi",
  },
  {
    word: "thét lác",
    part_of_speech: "động từ",
    meaning: "như hét lác: thét lác con cái",
    example: "thét lác con cái",
  },
  {
    word: "thép",
    part_of_speech: "danh từ",
    meaning:
      "hợp kim của sắt với một lượng nhỏ carbon, bền, cứng và dẻo: lò luyện thép * bê tông cốt thép",
    example: "lò luyện thép * bê tông cốt thép",
  },
  {
    word: "theo đuổi",
    part_of_speech: "động từ",
    meaning:
      "làm việc gì đó một cách kiên trì, bền bỉ nhằm mong đạt cho bằng được mục đích (thường là những việc làm tốt đẹp): theo đuổi công danh * mỗi người theo đuổi một ý nghĩ riêng",
    example: "theo đuổi công danh * mỗi người theo đuổi một ý nghĩ riêng",
  },
  {
    word: "thét",
    part_of_speech: "động từ",
    meaning:
      "quát, mắng, kêu, v.v., bằng giọng rất to và cao đến thé giọng, thường để biểu thị sự tức tối, căm giận hay hăm doạ: sợ quá khóc thét lên * tiếng thét căm hờn",
    example: "sợ quá khóc thét lên * tiếng thét căm hờn",
  },
  {
    word: "thét",
    part_of_speech: "phụ từ",
    meaning: "(phương ngữ) mãi: mần thét rồi cũng quen",
    example: "mần thét rồi cũng quen",
  },
  {
    word: "theo gót",
    part_of_speech: "động từ",
    meaning:
      "làm theo, noi theo người đi trước: theo gót cha anh * theo gót kẻ xấu",
    example: "theo gót cha anh * theo gót kẻ xấu",
  },
  {
    word: "thế",
    part_of_speech: "danh từ",
    meaning: "(văn chương) đời, thế gian: miệng thế cười chê",
    example: "miệng thế cười chê",
  },
  {
    word: "thế",
    part_of_speech: "danh từ",
    meaning:
      "chỗ, vị trí tạo thành điều kiện chung có lợi hay không có lợi cho một hoạt động nào đó của con người: thế núi hiểm trở, tiện cho phòng thủ * lựa thế để đặt đòn bẩy * thế võ hiểm",
    example:
      "thế núi hiểm trở, tiện cho phòng thủ * lựa thế để đặt đòn bẩy * thế võ hiểm",
  },
  {
    word: "thế",
    part_of_speech: "danh từ",
    meaning:
      "tổng thể nói chung các mặt tạo nên sức mạnh hay điều kiện thuận lợi cho một hoạt động nào đó của con người: thế yếu nên địch không lại * lật ngược thế cờ * cậy thế làm càn * thừa thế xông lên",
    example:
      "thế yếu nên địch không lại * lật ngược thế cờ * cậy thế làm càn * thừa thế xông lên",
  },
  {
    word: "thế",
    part_of_speech: "động từ",
    meaning:
      "đưa cái khác có cùng chức năng vào chỗ của cái hiện đang thiếu hoặc đang muốn loại bỏ đi để có thể coi như không còn thiếu nữa: mẹ bận nên chị phải đi thế",
    example: "mẹ bận nên chị phải đi thế",
  },
  {
    word: "thế",
    part_of_speech: "động từ",
    meaning: "giao cho làm tin để vay tiền: thế ruộng * thế vợ đợ con",
    example: "thế ruộng * thế vợ đợ con",
  },
  {
    word: "thế",
    part_of_speech: "đại từ",
    meaning:
      "từ dùng để chỉ điều đã biết hoặc coi như đã biết (vì vừa được nói đến), hay đang là thực tế ở ngay trước mắt: nói thế cũng phải * cứ thế mà làm",
    example: "nói thế cũng phải * cứ thế mà làm",
  },
  {
    word: "thế",
    part_of_speech: "trợ từ",
    meaning:
      "từ dùng để nhấn mạnh tính chất cụ thể gắn liền với hiện thực đã biết hoặc đang liên quan trực tiếp của điều muốn nói, muốn hỏi: cái quái gì thế? * thế tôi đi nhé! * đi đâu mà về khuya thế?",
    example: "cái quái gì thế? * thế tôi đi nhé! * đi đâu mà về khuya thế?",
  },
  {
    word: "thế",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý ngạc nhiên khi nhận ra mức độ cao của một thuộc tính trực tiếp tác động đến mình hoặc của một trạng thái tình cảm của chính mình: trời, sao lại nóng thế! * con cái nhà ai mà hư thế không biết!",
    example: "trời, sao lại nóng thế! * con cái nhà ai mà hư thế không biết!",
  },
  {
    word: "thể",
    part_of_speech: "danh từ",
    meaning:
      "trạng thái tồn tại của vật chất, được phân biệt theo hình dạng và thể tích tuỳ thuộc hay không tuỳ thuộc vào vật chứa: thể rắn * nước ở thể lỏng * thể khí",
    example: "thể rắn * nước ở thể lỏng * thể khí",
  },
  {
    word: "thể",
    part_of_speech: "danh từ",
    meaning:
      "hình thức sáng tác văn, thơ theo những quy cách nhất định: thể thơ lục bát * bài báo được viết theo thể phóng sự điều tra",
    example: "thể thơ lục bát * bài báo được viết theo thể phóng sự điều tra",
  },
  {
    word: "thể",
    part_of_speech: "danh từ",
    meaning:
      "hình thức biểu hiện của sự vật, hiện tượng, nhìn một cách tổng quát: con người là một thể thống nhất * bị chấn thương não ở thể nhẹ",
    example: "con người là một thể thống nhất * bị chấn thương não ở thể nhẹ",
  },
  {
    word: "thể",
    part_of_speech: "động từ",
    meaning:
      '(cũ, hiếm) là, vẫn là: "Chẳng thơm cũng thể hoa nhài, Dẫu không thanh lịch cũng người Tràng An." (ca dao)',
    example:
      'Chẳng thơm cũng thể hoa nhài, Dẫu không thanh lịch cũng người Tràng An." (ca dao)',
  },
  {
    word: "thể",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như thế (ng2): cái thể không đừng được",
    example: "cái thể không đừng được",
  },
  {
    word: "thể",
    part_of_speech: "động từ",
    meaning: "(hiếm, văn chương) thể theo (nói tắt): thể lòng dân",
    example: "thể lòng dân",
  },
  {
    word: "thề",
    part_of_speech: "động từ",
    meaning:
      "nói hoặc hứa một cách chắc chắn bằng cách lấy cái thiêng liêng, quý báu như danh dự, tính mạng, quỷ thần, v.v., để làm chứng, làm điều đảm bảo cho lời nói ấy: thề sẽ nói đúng sự thật * lời thề quyết tử cho tổ quốc quyết sinh",
    example:
      "thề sẽ nói đúng sự thật * lời thề quyết tử cho tổ quốc quyết sinh",
  },
  {
    word: "thể chất",
    part_of_speech: "danh từ",
    meaning:
      "cơ thể con người, nói về mặt sức khoẻ: thể chất yếu đuối * rèn luyện cả về thể chất lẫn tinh thần",
    example: "thể chất yếu đuối * rèn luyện cả về thể chất lẫn tinh thần",
  },
  {
    word: "thể chế",
    part_of_speech: "danh từ",
    meaning:
      "những quy định, luật lệ của một chế độ xã hội, buộc mọi người phải tuân theo (nói tổng quát): thể chế chính trị * cải cách thể chế quản lí",
    example: "thể chế chính trị * cải cách thể chế quản lí",
  },
  {
    word: "thế chân",
    part_of_speech: "động từ",
    meaning:
      "đưa vào để thế chỗ của người khác, cái khác: tìm người thế chân * trưởng phòng thế chân giám đốc",
    example: "tìm người thế chân * trưởng phòng thế chân giám đốc",
  },
  {
    word: "thế chiến",
    part_of_speech: "danh từ",
    meaning: "chiến tranh thế giới: thế chiến thứ hai",
    example: "thế chiến thứ hai",
  },
  {
    word: "thề bồi",
    part_of_speech: "động từ",
    meaning:
      '(cũ) thề (nói khái quát): "Biết bao duyên nợ thề bồi, Kiếp này thôi thế thì thôi, còn gì!" (TKiều)',
    example:
      'Biết bao duyên nợ thề bồi, Kiếp này thôi thế thì thôi, còn gì!" (TKiều)',
  },
  {
    word: "thế chấp",
    part_of_speech: "động từ",
    meaning:
      "(tài sản) dùng làm vật bảo đảm, thay thế cho số tiền vay nếu không có khả năng trả đúng kì hạn: tài sản thế chấp * thế chấp nhà để vay tiền",
    example: "tài sản thế chấp * thế chấp nhà để vay tiền",
  },
  {
    word: "thế cuộc",
    part_of_speech: "danh từ",
    meaning: "(văn chương) cuộc đời: thế cuộc đổi dời",
    example: "thế cuộc đổi dời",
  },
  {
    word: "thể dục",
    part_of_speech: "danh từ",
    meaning:
      "hệ thống các động tác tập luyện thân thể, thường được sắp xếp thành những bài nhất định, nhằm rèn luyện và tăng cường sức khoẻ: tập thể dục buổi sáng",
    example: "tập thể dục buổi sáng",
  },
  {
    word: "thể diện",
    part_of_speech: "danh từ",
    meaning:
      "tư cách và danh dự, cái làm cho người khác coi trọng mình khi tiếp xúc (nói tổng quát): giữ thể diện cho gia đình * mất thể diện",
    example: "giữ thể diện cho gia đình * mất thể diện",
  },
  {
    word: "thế gia",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) nhà thuộc dòng dõi danh giá, quyền thế thời phong kiến: thế gia vọng tộc * con nhà thế gia",
    example: "thế gia vọng tộc * con nhà thế gia",
  },
  {
    word: "thế gian",
    part_of_speech: "danh từ",
    meaning: "cõi đời, nơi người đời ở: đi khắp thế gian",
    example: "đi khắp thế gian",
  },
  {
    word: "thế gian",
    part_of_speech: "danh từ",
    meaning:
      'người ta ở đời nói chung: "Anh ngồi anh thở anh than, Vợ anh thua kém thế gian mười phần." (ca dao)',
    example:
      'Anh ngồi anh thở anh than, Vợ anh thua kém thế gian mười phần." (ca dao)',
  },
  {
    word: "thế giới quan",
    part_of_speech: "danh từ",
    meaning:
      "tổng thể quan niệm thành hệ thống về thế giới, về các hiện tượng tự nhiên và xã hội: thế giới quan Phật giáo",
    example: "thế giới quan Phật giáo",
  },
  {
    word: "thế giới",
    part_of_speech: "danh từ",
    meaning:
      "tổng thể nói chung những gì (thường chỉ tổng quát những sự vật vật chất và hiện tượng) tồn tại bên ngoài và độc lập với ý thức, trong mối quan hệ với nhận thức của con người: thế giới vật chất * nhận thức và cải tạo thế giới",
    example: "thế giới vật chất * nhận thức và cải tạo thế giới",
  },
  {
    word: "thế giới",
    part_of_speech: "danh từ",
    meaning:
      "Trái Đất, về mặt là nơi toàn thể loài người đang sinh sống: bản đồ thế giới * các nước trên thế giới * đi khắp thế giới",
    example: "bản đồ thế giới * các nước trên thế giới * đi khắp thế giới",
  },
  {
    word: "thế giới",
    part_of_speech: "danh từ",
    meaning:
      "xã hội, cộng đồng người có những đặc trưng chung nào đó, phân biệt với những xã hội và cộng đồng người khác: thế giới tư bản",
    example: "thế giới tư bản",
  },
  {
    word: "thế giới",
    part_of_speech: "danh từ",
    meaning:
      "phạm vi, lĩnh vực của đời sống, của các sự vật, hiện tượng có những đặc trưng chung nào đó, phân biệt với các phạm vi, lĩnh vực khác: thế giới nội tâm của nhân vật",
    example: "thế giới nội tâm của nhân vật",
  },
  {
    word: "thệ hải minh sơn",
    part_of_speech: "",
    meaning:
      '(cũ, văn chương) thề non hẹn biển: "Để lời thệ hải minh sơn, Làm con, trước phải đền ơn sinh thành." (TKiều)',
    example:
      'Để lời thệ hải minh sơn, Làm con, trước phải đền ơn sinh thành." (TKiều)',
  },
  {
    word: "thể hiện",
    part_of_speech: "động từ",
    meaning:
      "biểu lộ, trình bày hoặc miêu tả ra cho mọi người có thể hiểu, cảm nhận hoặc thấy rõ được, bằng một hình thức nào đó: sự buồn rầu thể hiện trên nét mặt * bài hát do một ca sĩ nổi tiếng thể hiện",
    example:
      "sự buồn rầu thể hiện trên nét mặt * bài hát do một ca sĩ nổi tiếng thể hiện",
  },
  {
    word: "thế giới vĩ mô",
    part_of_speech: "danh từ",
    meaning:
      "thế giới lớn, vũ trụ, hoặc là một thực thể lớn, phức tạp; phân biệt với thế giới vi mô: nghiên cứu về thế giới vĩ mô",
    example: "nghiên cứu về thế giới vĩ mô",
  },
  {
    word: "thế hệ",
    part_of_speech: "danh từ",
    meaning:
      "lớp người hoặc sinh vật đại khái cùng một lứa tuổi, phân biệt với lớp trước đã sinh ra mình và với lớp sau do mình (sẽ) sinh ra: tiếp bước các thế hệ cha anh * lợn lai thế hệ thứ nhất",
    example: "tiếp bước các thế hệ cha anh * lợn lai thế hệ thứ nhất",
  },
  {
    word: "thế hệ",
    part_of_speech: "danh từ",
    meaning:
      "kiểu, loại máy móc được sản xuất trong một giai đoạn, đánh dấu một tiến bộ kĩ thuật nhất định nào đó, phân biệt với các kiểu loại sản xuất trước và sau đó: máy tính thế hệ mới có rất nhiều tính năng ưu việt",
    example: "máy tính thế hệ mới có rất nhiều tính năng ưu việt",
  },
  {
    word: "thể hình",
    part_of_speech: "danh từ",
    meaning:
      "hình dáng bên ngoài của cơ thể, nói về mặt tỉ lệ giữa các bộ phận: thể hình cân đối * một cầu thủ có thể hình cao lớn",
    example: "thể hình cân đối * một cầu thủ có thể hình cao lớn",
  },
  {
    word: "thể hình",
    part_of_speech: "danh từ",
    meaning: "thể dục thể hình (nói tắt): vận động viên thể hình",
    example: "vận động viên thể hình",
  },
  {
    word: "thế kỉ",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian một trăm năm: cuộc chiến tranh kéo dài gần một thế kỉ",
    example: "cuộc chiến tranh kéo dài gần một thế kỉ",
  },
  {
    word: "thế kỉ",
    part_of_speech: "danh từ",
    meaning:
      "từng khoảng thời gian một trăm năm, tính từ năm 1 sau công nguyên trở đi (hoặc từ năm 1 trước công nguyên trở về trước): thế kỉ 21 (từ năm 2000 đến năm 2099) * những năm đầu thế kỉ",
    example: "thế kỉ 21 (từ năm 2000 đến năm 2099) * những năm đầu thế kỉ",
  },
  {
    word: "thế kỷ",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian một trăm năm: cuộc chiến tranh kéo dài gần một thế kỉ",
    example: "cuộc chiến tranh kéo dài gần một thế kỉ",
  },
  {
    word: "thế kỷ",
    part_of_speech: "danh từ",
    meaning:
      "từng khoảng thời gian một trăm năm, tính từ năm 1 sau công nguyên trở đi (hoặc từ năm 1 trước công nguyên trở về trước): thế kỉ 21 (từ năm 2000 đến năm 2099) * những năm đầu thế kỉ",
    example: "thế kỉ 21 (từ năm 2000 đến năm 2099) * những năm đầu thế kỉ",
  },
  {
    word: "thê lương",
    part_of_speech: "tính từ",
    meaning:
      "(văn chương) buồn thảm, lạnh lẽo và gợi nên vẻ hắt hiu, quạnh vắng: cảnh thê lương * giọng hát thê lương",
    example: "cảnh thê lương * giọng hát thê lương",
  },
  {
    word: "thể lệ",
    part_of_speech: "danh từ",
    meaning:
      "những điều quy định chung về cách thức tiến hành và thực hiện một việc nào đó, thường là những việc mang tính tập thể (nói tổng quát): nắm vững thể lệ của cuộc thi * thể lệ bầu cử",
    example: "nắm vững thể lệ của cuộc thi * thể lệ bầu cử",
  },
  {
    word: "thế là",
    part_of_speech: "kết từ",
    meaning:
      "tổ hợp biểu thị điều sắp nêu ra là kết quả của tình hình, sự việc vừa nói đến: thế là xong * thế là hết!",
    example: "thế là xong * thế là hết!",
  },
  {
    word: "thế lực",
    part_of_speech: "danh từ",
    meaning:
      "sức mạnh, ảnh hưởng dựa vào địa vị xã hội hay cương vị cá nhân mà có: thế lực của đồng tiền * có thế lực lớn trong vùng",
    example: "thế lực của đồng tiền * có thế lực lớn trong vùng",
  },
  {
    word: "thế lực",
    part_of_speech: "danh từ",
    meaning: "lực lượng xã hội ít nhiều mạnh mẽ: thế lực phong kiến đã sụp đổ",
    example: "thế lực phong kiến đã sụp đổ",
  },
  {
    word: "thế mà",
    part_of_speech: "",
    meaning:
      "tổ hợp biểu thị điều sắp nêu ra là có cái gì đó bất thường, trái với điều đáng lẽ xảy ra: làm cả ngày chủ nhật, thế mà vẫn không xong",
    example: "làm cả ngày chủ nhật, thế mà vẫn không xong",
  },
  {
    word: "thể loại",
    part_of_speech: "danh từ",
    meaning:
      "hình thức sáng tác văn học, nghệ thuật, được phân chia theo phương thức phản ánh hiện thực, sự vận dụng ngôn ngữ, phong cách thể hiện, v.v: thể loại tự sự",
    example: "thể loại tự sự",
  },
  {
    word: "thể lực",
    part_of_speech: "danh từ",
    meaning:
      "sức lực của cơ thể con người: tăng cường thể lực cho các vận động viên * thể lực sung mãn",
    example: "tăng cường thể lực cho các vận động viên * thể lực sung mãn",
  },
  {
    word: "thề nguyền",
    part_of_speech: "động từ",
    meaning:
      "thề để tỏ những điều nguyện ước với nhau (nói khái quát): lời thề nguyền * thề nguyền chung thuỷ",
    example: "lời thề nguyền * thề nguyền chung thuỷ",
  },
  {
    word: "thể nghiệm",
    part_of_speech: "",
    meaning:
      "qua kinh nghiệm, qua thực tiễn mà xét thấy điều gì đó là đúng hay không đúng: giống lúa mới đã qua thể nghiệm * quá trình thể nghiệm của những cây bút trẻ",
    example:
      "giống lúa mới đã qua thể nghiệm * quá trình thể nghiệm của những cây bút trẻ",
  },
  {
    word: "thế nào",
    part_of_speech: "",
    meaning:
      "tổ hợp biểu thị có một điều muốn hỏi (chỉ dùng nói với người ngang hàng hoặc người dưới): thế nào, lại không đi à? * thế nào, có đồng ý không thì bảo?",
    example: "thế nào, lại không đi à? * thế nào, có đồng ý không thì bảo?",
  },
  {
    word: "thế nào",
    part_of_speech: "",
    meaning:
      "tổ hợp thường dùng để hỏi cho rõ hơn về một tình trạng, trạng thái, tính chất, cách thức nào đó đã biết nhưng không được biết cụ thể: sức khoẻ dạo này thế nào? * vụ việc ấy thế nào rồi?",
    example: "sức khoẻ dạo này thế nào? * vụ việc ấy thế nào rồi?",
  },
  {
    word: "thế nào",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp dùng để chỉ một tình trạng, tính chất có gì đó không hay, không bình thường, nhưng khó nói cho rõ ra được: ừ thì ừ nhưng vẫn thấy ngài ngại thế nào ấy!",
    example: "ừ thì ừ nhưng vẫn thấy ngài ngại thế nào ấy!",
  },
  {
    word: "thế nào",
    part_of_speech: "",
    meaning:
      "tổ hợp dùng để chỉ bất cứ một tình trạng, trạng thái, tính chất, cách thức, mức độ nào: thế nào cũng được * hôm đó thế nào tôi cũng đến dự",
    example: "thế nào cũng được * hôm đó thế nào tôi cũng đến dự",
  },
  {
    word: "thể nào",
    part_of_speech: "",
    meaning:
      '(khẩu ngữ) tổ hợp dùng để biểu thị ý khẳng định rằng điều gì đó chắc chắn sẽ xảy ra, cho dù tình huống bất cứ ra sao: thể nào tôi cũng đến * "Giá đừng có dậu mùng tơi, Thể nào tôi cũng sang chơi thăm nàng." (NgBính; 12)',
    example:
      'thể nào tôi cũng đến * "Giá đừng có dậu mùng tơi, Thể nào tôi cũng sang chơi thăm nàng." (NgBính; 12)',
  },
  {
    word: "thế mạng",
    part_of_speech: "động từ",
    meaning:
      "chết thay cho người khác: tìm người thế mạng * hình nhân thế mạng",
    example: "tìm người thế mạng * hình nhân thế mạng",
  },
  {
    word: "thê nhi",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) vợ con: "(...) Quan sơn nghìn dặm, thê nhi một đoàn." (TKiều)',
    example: '(...) Quan sơn nghìn dặm, thê nhi một đoàn." (TKiều)',
  },
  {
    word: "thể nhiễm sắc",
    part_of_speech: "danh từ",
    meaning:
      "phần của nhân tế bào, mang gen, có vai trò chủ đạo về mặt di truyền: nhiễm sắc thể X * ở người có 23 cặp nhiễm sắc thể",
    example: "nhiễm sắc thể X * ở người có 23 cặp nhiễm sắc thể",
  },
  {
    word: "thể phách",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, hiếm) thể xác của con người: "Kiều rằng: Những đấng tài hoa, Thác là thể phách, còn là tinh anh." (TKiều)',
    example:
      'Kiều rằng: Những đấng tài hoa, Thác là thể phách, còn là tinh anh." (TKiều)',
  },
  {
    word: "thế phiệt",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) tầng lớp quý tộc, quan lại có thế lực lớn trong xã hội cũ: dòng dõi trâm anh thế phiệt * con nhà thế phiệt",
    example: "dòng dõi trâm anh thế phiệt * con nhà thế phiệt",
  },
  {
    word: "thế sự",
    part_of_speech: "danh từ",
    meaning: "việc đời (nói khái quát): luận bàn thế sự",
    example: "luận bàn thế sự",
  },
  {
    word: "thế ra",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị điều sắp nêu ra là một sự thật bây giờ mới biết, mới vỡ lẽ ra và do đó có phần ngạc nhiên: thế ra hai người đã quen nhau? * thế ra chị cũng biết chuyện đó?",
    example: "thế ra hai người đã quen nhau? * thế ra chị cũng biết chuyện đó?",
  },
  {
    word: "thế phẩm",
    part_of_speech: "danh từ",
    meaning:
      "vật hay chất dùng thay thế vật khác, chất khác (thường là tốt hơn) đang không có hoặc đang khan hiếm: cao su thế phẩm * tơ thế phẩm",
    example: "cao su thế phẩm * tơ thế phẩm",
  },
  {
    word: "thế tập",
    part_of_speech: "động từ",
    meaning:
      "(cũ) có quyền được thừa hưởng tước vị của cha ông truyền lại, dưới chế độ phong kiến: mấy đời thế tập làm quan",
    example: "mấy đời thế tập làm quan",
  },
  {
    word: "thê thảm",
    part_of_speech: "tính từ",
    meaning:
      "rất thảm thương, rất đau lòng: cái chết thê thảm * cảnh tượng thê thảm",
    example: "cái chết thê thảm * cảnh tượng thê thảm",
  },
  {
    word: "thể tất",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) thông cảm mà lượng thứ, bỏ qua cho: có gì sai sót, mong các bạn thể tất cho!",
    example: "có gì sai sót, mong các bạn thể tất cho!",
  },
  {
    word: "thể theo",
    part_of_speech: "động từ",
    meaning:
      "(cấp trên có thẩm quyền) dựa theo yêu cầu, nguyện vọng của ai đó (để đáp ứng hay làm việc gì): thể theo nguyện vọng của nhân dân",
    example: "thể theo nguyện vọng của nhân dân",
  },
  {
    word: "thế tất",
    part_of_speech: "phụ từ",
    meaning:
      "(cũ, hiếm) từ biểu thị ý khẳng định lẽ đương nhiên là phải như vậy: tức nước thế tất phải vỡ bờ",
    example: "tức nước thế tất phải vỡ bờ",
  },
  {
    word: "thể thao",
    part_of_speech: "danh từ",
    meaning:
      "những hoạt động nhằm nâng cao thể lực, sức khoẻ cho con người, thường được tổ chức thành các hình thức trò chơi, luyện tập, thi đấu theo những quy tắc nhất định (nói khái quát): đại hội thể thao * bóng đá là một môn thể thao được nhiều người ưa thích",
    example:
      "đại hội thể thao * bóng đá là một môn thể thao được nhiều người ưa thích",
  },
  {
    word: "thế thì",
    part_of_speech: "kết từ",
    meaning:
      "tổ hợp biểu thị điều sắp nêu ra là điều nên làm, cần làm, hoặc là một kết luận được rút ra từ tình hình, nguyên nhân của sự việc vừa được nói đến trước đó: thế thì cứ quyết định như vậy",
    example: "thế thì cứ quyết định như vậy",
  },
  {
    word: "thế thần",
    part_of_speech: "danh từ, tính từ",
    meaning:
      "chỗ dựa mạnh, có quyền uy và thế lực: cậy thần thế mà kiêu ngạo * một gia đình giàu có và thần thế",
    example: "cậy thần thế mà kiêu ngạo * một gia đình giàu có và thần thế",
  },
  {
    word: "thể thức",
    part_of_speech: "danh từ",
    meaning:
      "cách thức và thể lệ (nói tổng quát): hướng dẫn cử tri nắm vững thể thức bầu cử * thể thức thi đấu",
    example: "hướng dẫn cử tri nắm vững thể thức bầu cử * thể thức thi đấu",
  },
  {
    word: "thể thống",
    part_of_speech: "danh từ",
    meaning:
      "khuôn phép, nền nếp khiến người ta phải coi trọng: giữ gìn thể thống gia phong * chẳng còn ra thể thống gì nữa!",
    example: "giữ gìn thể thống gia phong * chẳng còn ra thể thống gì nữa!",
  },
  {
    word: "thê thiếp",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) vợ cả (thê) và vợ lẽ (thiếp) trong các gia đình giàu sang thời phong kiến: năm thê bảy thiếp (nhiều vợ)",
    example: "năm thê bảy thiếp (nhiều vợ)",
  },
  {
    word: "thê thiếp",
    part_of_speech: "danh từ",
    meaning:
      'vợ (nói khái quát): "Cha mẹ em đoán số cho chàng, Đoán cung thê thiếp rõ ràng tên em." (ca dao)',
    example:
      'Cha mẹ em đoán số cho chàng, Đoán cung thê thiếp rõ ràng tên em." (ca dao)',
  },
  {
    word: "thê thiết",
    part_of_speech: "tính từ",
    meaning:
      "(cũ, văn chương) thê lương và thảm thiết: buồn thê thiết * tiếng kêu thê thiết",
    example: "buồn thê thiết * tiếng kêu thê thiết",
  },
  {
    word: "thề thốt",
    part_of_speech: "động từ",
    meaning: "thề (nói khái quát): thề thốt keo sơn * nặng lời thề thốt",
    example: "thề thốt keo sơn * nặng lời thề thốt",
  },
  {
    word: "thế tình",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) thế thái nhân tình (nói tắt): "Thế tình chuộng lạ tham thanh, Bên khinh bên trọng ra tình xấu chơi." (ca dao)',
    example:
      'Thế tình chuộng lạ tham thanh, Bên khinh bên trọng ra tình xấu chơi." (ca dao)',
  },
  {
    word: "thể trọng",
    part_of_speech: "danh từ",
    meaning:
      "trọng lượng của cơ thể người hoặc súc vật: thể trọng giảm sút * phân phối lượng thức ăn theo thể trọng của vật nuôi",
    example:
      "thể trọng giảm sút * phân phối lượng thức ăn theo thể trọng của vật nuôi",
  },
  {
    word: "thể trạng",
    part_of_speech: "danh từ",
    meaning:
      "trạng thái chung của cơ thể người hoặc súc vật: lứa lợn có thể trạng phát triển tốt * thể trạng gầy còm",
    example: "lứa lợn có thể trạng phát triển tốt * thể trạng gầy còm",
  },
  {
    word: "thể tích",
    part_of_speech: "danh từ",
    meaning:
      "phần không gian mà một vật thể chiếm: tính thể tích của khối đá * bể đựng nước có thể tích 3m3",
    example: "tính thể tích của khối đá * bể đựng nước có thể tích 3m3",
  },
  {
    word: "thế trận",
    part_of_speech: "danh từ",
    meaning:
      "cách bố trí lực lượng theo những mô hình, quy tắc nhất định trong một trận đánh hoặc trong một trận thi đấu: bày thế trận * thế trận đang nghiêng về phía đội bạn",
    example: "bày thế trận * thế trận đang nghiêng về phía đội bạn",
  },
  {
    word: "thể tình",
    part_of_speech: "động từ",
    meaning:
      "thông cảm với tình cảnh mà chiếu cố hoặc lượng thứ cho: vì hoàn cảnh khó khăn quá, mong ông thể tình cho",
    example: "vì hoàn cảnh khó khăn quá, mong ông thể tình cho",
  },
  {
    word: "thế tục",
    part_of_speech: "danh từ",
    meaning: "(cũ, hiếm) tập tục ở đời (nói khái quát): ăn ở theo thế tục",
    example: "ăn ở theo thế tục",
  },
  {
    word: "thế tục",
    part_of_speech: "danh từ",
    meaning:
      "hoặc t đời sống trần tục, đối lập với đời sống tu hành, theo quan niệm tôn giáo: những nỗi vui buồn thế tục * lánh xa thế tục",
    example: "những nỗi vui buồn thế tục * lánh xa thế tục",
  },
  {
    word: "thê tử",
    part_of_speech: "danh từ",
    meaning: "(cũ, trang trọng) vợ con: bầu đoàn thê tử",
    example: "bầu đoàn thê tử",
  },
  {
    word: "thề ước",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) thề nguyền và ước hẹn với nhau: thề ước sẽ trọn đời thủy chung",
    example: "thề ước sẽ trọn đời thủy chung",
  },
  {
    word: "thể xác",
    part_of_speech: "danh từ",
    meaning:
      "phần vật chất, phần xác của con người, phân biệt với phần tinh thần, phần hồn: đau đớn về thể xác * hoà hợp cả về thể xác lẫn tâm hồn",
    example: "đau đớn về thể xác * hoà hợp cả về thể xác lẫn tâm hồn",
  },
  {
    word: "thêm",
    part_of_speech: "động từ",
    meaning:
      "làm cho hoặc trở nên nhiều hơn lên một phần về số lượng hoặc mức độ: mặc thêm áo cho đỡ lạnh * góp thêm ý kiến",
    example: "mặc thêm áo cho đỡ lạnh * góp thêm ý kiến",
  },
  {
    word: "thềm lục địa",
    part_of_speech: "danh từ",
    meaning:
      "phần đất chìm dưới mực nước biển viền quanh lục địa, ở độ sâu khoảng dưới 500 mét: khoan thăm dò dầu mỏ ở thềm lục địa",
    example: "khoan thăm dò dầu mỏ ở thềm lục địa",
  },
  {
    word: "thêm bớt",
    part_of_speech: "động từ",
    meaning: "thêm hoặc bớt (nói khái quát): viết đúng sự thật, không thêm bớt",
    example: "viết đúng sự thật, không thêm bớt",
  },
  {
    word: "thềm",
    part_of_speech: "danh từ",
    meaning:
      "phần nền trước cửa hoặc chung quanh nhà, có mái che nhưng thường không có cột đỡ: bước lên thềm nhà",
    example: "bước lên thềm nhà",
  },
  {
    word: "thêm thắt",
    part_of_speech: "động từ",
    meaning:
      "thêm vào chút ít, thường là những cái nhỏ nhặt, cái phụ (nói khái quát): được một khoản để thêm thắt vào việc chi tiêu * có gì nói đấy, không thêm thắt",
    example:
      "được một khoản để thêm thắt vào việc chi tiêu * có gì nói đấy, không thêm thắt",
  },
  {
    word: "thếch",
    part_of_speech: "phụ từ",
    meaning:
      "đến mức độ như chẳng còn có mùi vị, màu sắc hay trọng lượng gì nữa cả: bát canh nhạt thếch * túi nhẹ thếch",
    example: "bát canh nhạt thếch * túi nhẹ thếch",
  },
  {
    word: "thênh thang",
    part_of_speech: "tính từ",
    meaning:
      "rộng rãi, thoáng đãng, gây cảm giác không có gì làm cho các hoạt động bị vướng: con đường thênh thang * nhà rộng thênh thang",
    example: "con đường thênh thang * nhà rộng thênh thang",
  },
  {
    word: "thênh thênh",
    part_of_speech: "tính từ",
    meaning:
      "rộng rãi hoặc nhẹ nhàng đến mức gây cảm giác ung dung, thanh thản và thoải mái hết mức (thường nói về cái trừu tượng): nhà rộng thênh thênh * đầu nhẹ thênh thênh",
    example: "nhà rộng thênh thênh * đầu nhẹ thênh thênh",
  },
  {
    word: "thết",
    part_of_speech: "động từ",
    meaning:
      "đãi ăn uống một cách đặc biệt để tỏ sự quý trọng, thân thiết: thết khách * thết bạn một chầu bia",
    example: "thết khách * thết bạn một chầu bia",
  },
  {
    word: "thết đãi",
    part_of_speech: "động từ",
    meaning:
      "mời ăn uống thịnh soạn, hậu hĩ để tỏ lòng quý trọng (nói khái quát): mở tiệc thết đãi khách quý",
    example: "mở tiệc thết đãi khách quý",
  },
  {
    word: "thếp",
    part_of_speech: "danh từ",
    meaning:
      "tập hoặc xấp những vật mỏng cùng loại, thường có một số lượng nhất định: thếp trầu độ 20 lá * mua chục thếp giấy",
    example: "thếp trầu độ 20 lá * mua chục thếp giấy",
  },
  {
    word: "thếp",
    part_of_speech: "động từ",
    meaning:
      "làm cho vàng, bạc dát thành lớp rất mỏng bám chặt vào mặt gỗ, đá nhờ một chất kết dính, để trang trí: đôi câu đối sơn son thếp vàng",
    example: "đôi câu đối sơn son thếp vàng",
  },
  {
    word: "thêu dệt",
    part_of_speech: "động từ",
    meaning:
      "thêu và dệt (nói khái quát); dùng để ví hành vi bịa đặt, thêm thắt một cách khéo léo, để làm cho từ chỗ không có gì cũng trở thành có chuyện, thường là với dụng ý không tốt: giỏi thêu dệt * thêu dệt nên bao điều dối trá",
    example: "giỏi thêu dệt * thêu dệt nên bao điều dối trá",
  },
  {
    word: "thêu",
    part_of_speech: "động từ",
    meaning:
      "dùng kim và chỉ màu tạo nên các hình trên mặt vải: lá cờ thêu sáu chữ vàng * bức tranh thêu",
    example: "lá cờ thêu sáu chữ vàng * bức tranh thêu",
  },
  {
    word: "thêu",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ dùng để đào, xắn đất, giống như cái mai nhưng nhỏ và nhẹ hơn: vác thêu đi đào",
    example: "vác thêu đi đào",
  },
  {
    word: "thì",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là kết quả có thể hoặc tất yếu sẽ xảy ra của giả thiết hay điều kiện của điều vừa được nói đến: trời mưa thì tôi không đi * có làm thì mới có ăn",
    example: "trời mưa thì tôi không đi * có làm thì mới có ăn",
  },
  {
    word: "thì",
    part_of_speech: "kết từ",
    meaning:
      "từ dùng phối hợp với nếu ở vế trước của câu để biểu thị mối quan hệ tương ứng giữa hai sự việc có thật, có việc này mặt khác cũng có việc kia: nếu nó dại thì em nó lại rất khôn",
    example: "nếu nó dại thì em nó lại rất khôn",
  },
  {
    word: "thì",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị mối quan hệ tiếp nối giữa hai sự việc, sự việc này xảy ra xong là tiếp ngay đến sự việc kia: vừa về đến nhà thì trời đổ mưa",
    example: "vừa về đến nhà thì trời đổ mưa",
  },
  {
    word: "thì",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nói có tính chất thuyết minh cho điều vừa nêu ra trước đó: học hành thì chểnh mảng * người thì đẹp nhưng nết lại xấu",
    example: "học hành thì chểnh mảng * người thì đẹp nhưng nết lại xấu",
  },
  {
    word: "thì",
    part_of_speech: "kết từ",
    meaning:
      "(Khẩu ngữ) từ biểu thị ý phủ định mỉa mai dưới hình thức tựa như thừa nhận điều sắp nêu ra, nhằm tỏ ý không đồng tình: vâng, tôi xấu, còn các chị thì đẹp! * mày thì giỏi rồi!",
    example: "vâng, tôi xấu, còn các chị thì đẹp! * mày thì giỏi rồi!",
  },
  {
    word: "thì",
    part_of_speech: "trợ từ",
    meaning:
      "(Khẩu ngữ) từ biểu thị ý nhấn mạnh về điều sắp nêu ra: thì ai chẳng biết thế * thì tôi đã bảo trước rồi mà!",
    example: "thì ai chẳng biết thế * thì tôi đã bảo trước rồi mà!",
  },
  {
    word: "thì",
    part_of_speech: "danh từ",
    meaning:
      "thời kì, giai đoạn cơ thể phát triển mạnh và bắt đầu có khả năng sinh sản: lúa đang thì con gái * quá lứa lỡ thì",
    example: "lúa đang thì con gái * quá lứa lỡ thì",
  },
  {
    word: "thì",
    part_of_speech: "danh từ",
    meaning:
      '(Ít dùng) thời điểm tốt nhất, thuận lợi nhất để cho một hoạt động thu được kết quả tốt: lúa cấy đúng thì * "Ơn Trời mưa nắng phải thì, Nơi thì bừa cạn nơi thì cày sâu." (Cdao)',
    example:
      'lúa cấy đúng thì * "Ơn Trời mưa nắng phải thì, Nơi thì bừa cạn nơi thì cày sâu." (Cdao)',
  },
  {
    word: "thì",
    part_of_speech: "danh từ",
    meaning:
      "từng phần của một động tác, một thao tác kĩ thuật hay một chu trình vận động, chiếm một khoảng thời gian nhất định: động cơ xe máy bốn thì * thì hít vào và thì thở ra của động tác thở",
    example:
      "động cơ xe máy bốn thì * thì hít vào và thì thở ra của động tác thở",
  },
  {
    word: "thì",
    part_of_speech: "danh từ",
    meaning: "(Từ cũ)",
    example: "chia động từ ở thì quá khứ",
  },
  {
    word: "thều thào",
    part_of_speech: "",
    meaning:
      "nói rất nhỏ và yếu ớt qua hơi thở, nghe không rõ lời: nói thều thào * giọng thều thào không ra tiếng",
    example: "nói thều thào * giọng thều thào không ra tiếng",
  },
  {
    word: "thị",
    part_of_speech: "danh từ",
    meaning:
      "(thường viết hoa) tiếng lót thường dùng giữa họ và tên của nữ giới, để phân biệt với tên của nam giới: anh hùng liệt sĩ Võ Thị Sáu",
    example: "anh hùng liệt sĩ Võ Thị Sáu",
  },
  {
    word: "thị",
    part_of_speech: "danh từ",
    meaning:
      ". (thường viết hoa) từ dùng đặt trước một tên riêng để chỉ hoặc gọi người phụ nữ ở tầng lớp dưới trong xã hội cũ, thường hàm ý coi thường: Thị Mầu * Thị Nở",
    example: "Thị Mầu * Thị Nở",
  },
  {
    word: "thị",
    part_of_speech: "đại từ",
    meaning:
      "(khẩu ngữ) từ dùng để chỉ người phụ nữ ở ngôi thứ ba với ý coi khinh: thị đã bị lĩnh án bảy năm tù giam",
    example: "thị đã bị lĩnh án bảy năm tù giam",
  },
  {
    word: "thị",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) thị xã (nói tắt): khắp các huyện, thị trong tỉnh",
    example: "khắp các huyện, thị trong tỉnh",
  },
  {
    word: "thêu thùa",
    part_of_speech: "động từ",
    meaning: "thêu (nói khái quát): giỏi việc thêu thùa",
    example: "giỏi việc thêu thùa",
  },
  {
    word: "thi bá",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, hiếm) nhà thơ được tôn là bậc đàn anh trong nghề thơ: văn hào thi bá",
    example: "văn hào thi bá",
  },
  {
    word: "thi",
    part_of_speech: "động từ",
    meaning:
      "tham gia vào cuộc đọ hơn kém về tài năng, sức lực, v.v. để tranh giải: thi chạy * thi toán quốc tế * đoạt giải nhất cuộc thi giọng hát hay toàn quốc",
    example:
      "thi chạy * thi toán quốc tế * đoạt giải nhất cuộc thi giọng hát hay toàn quốc",
  },
  {
    word: "thi",
    part_of_speech: "động từ",
    meaning:
      "dự những hình thức kiểm tra theo quy định về kiến thức, kĩ năng để được xét chính thức công nhận có đầy đủ một tư cách nào đó: thi đỗ tiến sĩ * thi đại học * cuộc thi thợ giỏi cấp thành phố",
    example: "thi đỗ tiến sĩ * thi đại học * cuộc thi thợ giỏi cấp thành phố",
  },
  {
    word: "thi",
    part_of_speech: "động từ",
    meaning:
      '(hiếm) làm như nhau cùng một lúc, không ai chịu kém ai: mấy con gà thi nhau gáy * "Vợ chồng anh thi nhau kể tội người nhà quê đủ thứ." (NCao; 8)',
    example:
      'mấy con gà thi nhau gáy * "Vợ chồng anh thi nhau kể tội người nhà quê đủ thứ." (NCao; 8)',
  },
  {
    word: "thí",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) cho với thái độ khinh bỉ: thí cho mấy đồng",
    example: "thí cho mấy đồng",
  },
  {
    word: "thí",
    part_of_speech: "động từ",
    meaning:
      "cho để làm phúc, không lấy tiền: bát cháo thí * nhà thương thí (ph; bệnh viện chữa bệnh không lấy tiền, dành cho người nghèo thời trước)",
    example:
      "bát cháo thí * nhà thương thí (ph; bệnh viện chữa bệnh không lấy tiền, dành cho người nghèo thời trước)",
  },
  {
    word: "thí",
    part_of_speech: "động từ",
    meaning:
      "chấp nhận mất, chấp nhận bỏ một quân cờ nào đó để cứu gỡ một thế cờ, một nước cờ: thí pháo cứu xe * cờ bí thí tốt",
    example: "thí pháo cứu xe * cờ bí thí tốt",
  },
  {
    word: "thị chính",
    part_of_speech: "danh từ",
    meaning:
      "công việc hành chính của thành phố, thị xã, ở một số nước: toà thị chính (toà nhà làm việc của thành phố)",
    example: "toà thị chính (toà nhà làm việc của thành phố)",
  },
  {
    word: "thi ca",
    part_of_speech: "danh từ",
    meaning:
      "sáng tác văn học theo thể loại văn vần (nói khái quát): tuyển tập thơ ca",
    example: "tuyển tập thơ ca",
  },
  {
    word: "thí bỏ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) chấp nhận bỏ đi cái gì đó một cách không thương tiếc để cứu lấy cho mình cái quý giá hơn, cần thiết hơn: thí bỏ xe để cứu tướng * tình thế nguy ngập, đành thí bỏ một tay chân đắc lực",
    example:
      "thí bỏ xe để cứu tướng * tình thế nguy ngập, đành thí bỏ một tay chân đắc lực",
  },
  {
    word: "thì chớ kể",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị ý khẳng định với người đối thoại là sẽ không sao tránh được điều không hay như vừa nói đến hoặc như điều đã biết rõ trước đó (hàm ý đe doạ, cảnh cáo): làm thế nó mà biết được thì chớ kể",
    example: "làm thế nó mà biết được thì chớ kể",
  },
  {
    word: "thì chớ",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị ý phủ định về điều cho là nếu như vậy thì có thể chẳng nói đến làm gì, nhằm nhấn mạnh điều xảy ra trên thực tế khác hẳn hoặc trái ngược hoàn toàn: đã chẳng được khen thì chớ, lại còn bị mắng",
    example: "đã chẳng được khen thì chớ, lại còn bị mắng",
  },
  {
    word: "thì có",
    part_of_speech: "",
    meaning:
      'tổ hợp biểu thị ý thừa nhận một điều nào đó, nhưng đồng thời cũng để nêu lên một sự hạn chế với ý phủ định: đẹp thì có đẹp, nhưng hơi đắt * "Hoa bụt mọc trước cửa chùa, Đỏ thì có đỏ, tứ mùa không thơm." (ca dao)',
    example:
      'đẹp thì có đẹp, nhưng hơi đắt * "Hoa bụt mọc trước cửa chùa, Đỏ thì có đỏ, tứ mùa không thơm." (ca dao)',
  },
  {
    word: "thì có",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị ý khẳng định một điều ngược lại với nhận định mà người đối thoại vừa nêu trước đó, nhằm để phủ định, phản bác: có mày ngu thì có! * sớm gì, có mà muộn thì có!",
    example: "có mày ngu thì có! * sớm gì, có mà muộn thì có!",
  },
  {
    word: "thí dụ",
    part_of_speech: "danh từ",
    meaning:
      "trường hợp cụ thể nêu ra để minh hoạ hoặc để chứng minh: một thí dụ điển hình * nêu thí dụ",
    example: "một thí dụ điển hình * nêu thí dụ",
  },
  {
    word: "thí dụ",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để báo cho biết là liền sau đó sẽ nêu ra điều nào đó coi như là có thật, lấy đó làm căn cứ: nếu cần gì, thí dụ như tài liệu, thì cứ đến chỗ tôi",
    example: "nếu cần gì, thí dụ như tài liệu, thì cứ đến chỗ tôi",
  },
  {
    word: "thí dụ",
    part_of_speech: "danh từ",
    meaning:
      "như giả sử: thí dụ trời mưa thì làm thế nào? * đó là tôi thí dụ thế",
    example: "thí dụ trời mưa thì làm thế nào? * đó là tôi thí dụ thế",
  },
  {
    word: "thí điểm",
    part_of_speech: "",
    meaning:
      "thử thực hiện trong một phạm vi hẹp để rút kinh nghiệm: chương trình dạy thí điểm * làm thí điểm",
    example: "chương trình dạy thí điểm * làm thí điểm",
  },
  {
    word: "thi công",
    part_of_speech: "động từ",
    meaning:
      "tiến hành xây dựng một công trình theo thiết kế: đảm bảo tiến độ thi công * công trường đang thi công",
    example: "đảm bảo tiến độ thi công * công trường đang thi công",
  },
  {
    word: "thi cử",
    part_of_speech: "động từ",
    meaning:
      "thi vào hoặc ra trường hay để nhận một bằng cấp, học vị nào đó (nói khái quát): sắp đến mùa thi cử * phổ biến thể lệ thi cử cho các thí sinh",
    example: "sắp đến mùa thi cử * phổ biến thể lệ thi cử cho các thí sinh",
  },
  {
    word: "thi đấu",
    part_of_speech: "động từ",
    meaning:
      "đấu để tranh giải về thể thao: trận thi đấu bóng đá * nâng cao thành tích thi đấu",
    example: "trận thi đấu bóng đá * nâng cao thành tích thi đấu",
  },
  {
    word: "thi đàn",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) diễn đàn thi ca, giới thi ca: một tài năng mới xuất hiện trên thi đàn",
    example: "một tài năng mới xuất hiện trên thi đàn",
  },
  {
    word: "thi gan",
    part_of_speech: "động từ",
    meaning:
      "đương đầu quyết chống chọi lại một cách bền bỉ, quyết liệt: thi gan với giặc",
    example: "thi gan với giặc",
  },
  {
    word: "thi đua",
    part_of_speech: "động từ",
    meaning:
      "cùng nhau đem hết tài năng, sức lực ra để đua nhau làm, nhằm thúc đẩy lẫn nhau đạt thành tích tốt nhất trong một lĩnh vực hoạt động nào đó: phát động phong trào thi đua * thầy và trò ra sức thi đua dạy tốt, học tốt",
    example:
      "phát động phong trào thi đua * thầy và trò ra sức thi đua dạy tốt, học tốt",
  },
  {
    word: "thị giác",
    part_of_speech: "danh từ",
    meaning:
      "cảm giác phân biệt được ánh sáng, màu sắc, hình dạng: cơ quan thị giác * mắc chứng rối loạn thị giác",
    example: "cơ quan thị giác * mắc chứng rối loạn thị giác",
  },
  {
    word: "thì giờ",
    part_of_speech: "danh từ",
    meaning:
      "thời gian, về mặt sử dụng có ích cho con người: có đủ thì giờ chuẩn bị * chẳng có thì giờ đâu mà để tâm đến chuyện ấy",
    example:
      "có đủ thì giờ chuẩn bị * chẳng có thì giờ đâu mà để tâm đến chuyện ấy",
  },
  {
    word: "thị giá",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) giá cả hàng hoá được hình thành trên thị trường dưới tác động của cung cầu và cạnh tranh.",
    example: "thị giá cổ phiếu * thị giá chứng khoán tăng mạnh",
  },
  {
    word: "thi hứng",
    part_of_speech: "danh từ",
    meaning: "cảm xúc mạnh mẽ làm nảy sinh hứng thú làm thơ: thi hứng dào dạt",
    example: "thi hứng dào dạt",
  },
  {
    word: "thị hiếu",
    part_of_speech: "danh từ",
    meaning:
      "xu hướng ham thích, ưa chuộng (thường là của một số đông người và trong một thời kì nhất định) về một lối, một kiểu nào đó đối với những thứ sử dụng hoặc thưởng thức hằng ngày: nắm bắt được thị hiếu của khách hàng",
    example: "nắm bắt được thị hiếu của khách hàng",
  },
  {
    word: "thi hành",
    part_of_speech: "động từ",
    meaning:
      "làm cho thành có hiệu lực điều đã được chính thức quyết định: thi hành bản án * cứ theo mệnh lệnh mà thi hành",
    example: "thi hành bản án * cứ theo mệnh lệnh mà thi hành",
  },
  {
    word: "thi hào",
    part_of_speech: "danh từ",
    meaning: "(trang trọng) nhà thơ lớn: thi hào Nguyễn Du",
    example: "thi hào Nguyễn Du",
  },
  {
    word: "thị lực",
    part_of_speech: "danh từ",
    meaning: "độ nhìn rõ của mắt: máy kiểm tra thị lực * thị lực yếu",
    example: "máy kiểm tra thị lực * thị lực yếu",
  },
  {
    word: "thi lễ",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) chào một cách cung kính theo cách thức và phong tục xưa: cúi đầu thi lễ",
    example: "cúi đầu thi lễ",
  },
  {
    word: "thí mạng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) thí bỏ, chấp nhận mất đi những người hoặc lực lượng nào đó để làm cho được việc gì: thí mạng bọn tay chân để giữ uy tín",
    example: "thí mạng bọn tay chân để giữ uy tín",
  },
  {
    word: "thí mạng",
    part_of_speech: "động từ",
    meaning:
      "liều mạng với ai để quyết làm việc gì: thí mạng với giặc * vào hang hùm ấy để thí mạng à?",
    example: "thí mạng với giặc * vào hang hùm ấy để thí mạng à?",
  },
  {
    word: "thí mạng",
    part_of_speech: "động từ",
    meaning:
      "(làm việc gì) bỏ hết sức lực ra, bất chấp hậu quả: làm thí mạng từ sáng đến tối * phóng xe thí mạng",
    example: "làm thí mạng từ sáng đến tối * phóng xe thí mạng",
  },
  {
    word: "thí nghiệm",
    part_of_speech: "",
    meaning:
      "gây ra một hiện tượng, một sự biến đổi nào đó trong điều kiện xác định để tìm hiểu, nghiên cứu, kiểm tra hay chứng minh: thí nghiệm loại vaccin mới trên cơ thể chuột * phòng thí nghiệm",
    example: "thí nghiệm loại vaccin mới trên cơ thể chuột * phòng thí nghiệm",
  },
  {
    word: "thí nghiệm",
    part_of_speech: "",
    meaning: "làm thử để rút kinh nghiệm: trồng thí nghiệm giống lúa mới",
    example: "trồng thí nghiệm giống lúa mới",
  },
  {
    word: "thi nhân",
    part_of_speech: "danh từ",
    meaning: "(cũ, trang trọng) nhà thơ: thi nhân Việt Nam",
    example: "thi nhân Việt Nam",
  },
  {
    word: "thì phải",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị ý khẳng định dè dặt, như còn muốn kiểm tra lại trí nhớ hoặc nhận định của mình, hoặc muốn có được sự xác nhận của người đối thoại đối với điều mình vừa nói: hình như tôi đã gặp anh ở đâu rồi thì phải",
    example: "hình như tôi đã gặp anh ở đâu rồi thì phải",
  },
  {
    word: "thi phú",
    part_of_speech: "danh từ",
    meaning:
      "thơ và phú (nói khái quát); thường dùng để chỉ thơ văn theo niêm luật, nói chung: văn chương thi phú",
    example: "văn chương thi phú",
  },
  {
    word: "thị phạm",
    part_of_speech: "động từ",
    meaning:
      "làm động tác mẫu cho người khác xem mà bắt chước, học tập theo: huấn luyện viên làm một vài động tác thị phạm",
    example: "huấn luyện viên làm một vài động tác thị phạm",
  },
  {
    word: "thị phi",
    part_of_speech: "tính từ",
    meaning:
      '(cũ) phải trái: "Kề tai mấy mỗi nằn nì, Nàng nghe dường cũng thị phi rạch ròi." (TKiều)',
    example:
      'Kề tai mấy mỗi nằn nì, Nàng nghe dường cũng thị phi rạch ròi." (TKiều)',
  },
  {
    word: "thị phi",
    part_of_speech: "động từ",
    meaning:
      "(người đời) gièm pha, bàn tán chê bai: đặt điều thị phi * chịu tiếng thị phi",
    example: "đặt điều thị phi * chịu tiếng thị phi",
  },
  {
    word: "thị phần",
    part_of_speech: "danh từ",
    meaning:
      "phần chiếm lĩnh thị trường về một loại sản phẩm nào đó mà một cơ sở sản xuất chiếm lĩnh được: cắt giảm thị phần * hàng nội chiếm 70% thị phần",
    example: "cắt giảm thị phần * hàng nội chiếm 70% thị phần",
  },
  {
    word: "thì ra",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị điều sắp nêu là sự thật mà mình vừa mới nhận ra, vừa mới biết được nhờ vào một điều khác nào đó: thì ra quyển sách đó là của anh * à, thì ra là thế!",
    example: "thì ra quyển sách đó là của anh * à, thì ra là thế!",
  },
  {
    word: "thị sát",
    part_of_speech: "động từ",
    meaning:
      "(người chỉ huy, chỉ đạo) xem xét tại chỗ để nắm bắt tình hình: giám đốc xuống thị sát công trường * đi thị sát tình hình",
    example: "giám đốc xuống thị sát công trường * đi thị sát tình hình",
  },
  {
    word: "thi sĩ",
    part_of_speech: "danh từ",
    meaning: "(trang trọng) nhà thơ: một thi sĩ nổi tiếng * có tâm hồn thi sĩ",
    example: "một thi sĩ nổi tiếng * có tâm hồn thi sĩ",
  },
  {
    word: "thị thành",
    part_of_speech: "danh từ",
    meaning: "(cũ) như thành thị: đất thị thành",
    example: "đất thị thành",
  },
  {
    word: "thí sinh",
    part_of_speech: "danh từ",
    meaning:
      "người tham dự một kì thi để kiểm tra trình độ: danh sách thí sinh dự thi đại học",
    example: "danh sách thí sinh dự thi đại học",
  },
  {
    word: "thi thể",
    part_of_speech: "danh từ",
    meaning: "xác người chết: nhận dạng thi thể",
    example: "nhận dạng thi thể",
  },
  {
    word: "thì thào",
    part_of_speech: "",
    meaning:
      "từ gợi tả tiếng nói chuyện với nhau rất nhỏ, nghe tựa như hơi gió thoảng qua tai: thì thào vào tai nhau * nghe có tiếng thì thào",
    example: "thì thào vào tai nhau * nghe có tiếng thì thào",
  },
  {
    word: "thì thầm",
    part_of_speech: "",
    meaning:
      "nói thầm với nhau, không để người ngoài nghe thấy: nói chuyện thì thầm",
    example: "nói chuyện thì thầm",
  },
  {
    word: "thi thoảng",
    part_of_speech: "phụ từ",
    meaning:
      "rất ít khi: thi thoảng mới có lúc rỗi rãi * hai người thi thoảng mới gặp nhau",
    example:
      "thi thoảng mới có lúc rỗi rãi * hai người thi thoảng mới gặp nhau",
  },
  {
    word: "thì thôi",
    part_of_speech: "",
    meaning:
      '(khẩu ngữ) tổ hợp biểu thị ý đành chấp nhận cái thực tế vừa nêu ra, coi như không có gì cần phải nói tới nữa: không ăn thì thôi, kệ nó * "Chẳng thà không biết thì thôi, Biết ra mỗi đứa, mỗi nơi thêm buồn." (ca dao)',
    example:
      'không ăn thì thôi, kệ nó * "Chẳng thà không biết thì thôi, Biết ra mỗi đứa, mỗi nơi thêm buồn." (ca dao)',
  },
  {
    word: "thì thòm",
    part_of_speech: "tính từ",
    meaning:
      'từ mô phỏng tiếng trầm, gọn và vang đều đều như tiếng trống vẳng lại từ xa: tiếng tát nước thì thòm trong đêm * "Thì thòm trống điểm tàn canh, Để coi người ngọc, duyên lành trao ai?" (ca dao)',
    example:
      'tiếng tát nước thì thòm trong đêm * "Thì thòm trống điểm tàn canh, Để coi người ngọc, duyên lành trao ai?" (ca dao)',
  },
  {
    word: "thi thố",
    part_of_speech: "động từ",
    meaning:
      "đem hết tài năng, sức lực ra dùng vào một công việc nào đó, để chứng tỏ, khẳng định mình: thi thố tài năng",
    example: "thi thố tài năng",
  },
  {
    word: "thị thực",
    part_of_speech: "động từ",
    meaning:
      "(cơ quan có thẩm quyền) xác nhận, chứng thực nội dung và làm cho tài liệu được công nhận về mặt pháp lí: giấy tờ nhà đất đã có thị thực của chính quyền * thị thực xuất nhập cảnh",
    example:
      "giấy tờ nhà đất đã có thị thực của chính quyền * thị thực xuất nhập cảnh",
  },
  {
    word: "thi thư",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) kinh Thi và kinh Thư, hai bộ sách kinh điển của nho giáo; dùng để chỉ nền nho học và cũng để chỉ việc học hành: luyện tập thi thư * "Con trai rèn tập sớm khuya, Nhà thi thư vẫn giữ nghề thi thư." (QÂTK)',
    example:
      'luyện tập thi thư * "Con trai rèn tập sớm khuya, Nhà thi thư vẫn giữ nghề thi thư." (QÂTK)',
  },
  {
    word: "thì thùng",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng trống đánh nhịp nhàng khoan thai, nghe vẳng lại từ đâu đó: tiếng trống thì thùng",
    example: "tiếng trống thì thùng",
  },
  {
    word: "thì thụt",
    part_of_speech: "động từ",
    meaning:
      "ra vào, lui tới luôn một cách lén lút, vụng trộm, không đàng hoàng: ra vào thì thụt",
    example: "ra vào thì thụt",
  },
  {
    word: "thi trắc nghiệm",
    part_of_speech: "danh từ",
    meaning:
      "hình thức thi bằng phương pháp trắc nghiệm, thường bằng cách người dự thi đưa ra sự lựa chọn một đáp án đúng trong các đáp án đã cho sẵn ở từng câu hỏi: áp dụng hình thức thi trắc nghiệm cho môn ngoại ngữ",
    example: "áp dụng hình thức thi trắc nghiệm cho môn ngoại ngữ",
  },
  {
    word: "thị trường",
    part_of_speech: "danh từ",
    meaning:
      "tổng thể nói chung những hoạt động mua bán, trao đổi và lưu thông hàng hoá: cơ chế thị trường * mở rộng thị trường",
    example: "cơ chế thị trường * mở rộng thị trường",
  },
  {
    word: "thị trường",
    part_of_speech: "danh từ",
    meaning:
      "nơi thường xuyên tiêu thụ hàng hoá: tranh giành thị trường * một thị trường rộng lớn",
    example: "tranh giành thị trường * một thị trường rộng lớn",
  },
  {
    word: "thị tộc",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức cơ sở của xã hội nguyên thuỷ, bao gồm nhiều gia đình lớn có cùng một tổ tiên và có kinh tế chung: thị tộc mẫu quyền",
    example: "thị tộc mẫu quyền",
  },
  {
    word: "thi tuyển",
    part_of_speech: "động từ",
    meaning:
      "thi để tuyển chọn: tổ chức thi tuyển vào đại học * đổi mới hình thức thi tuyển",
    example: "tổ chức thi tuyển vào đại học * đổi mới hình thức thi tuyển",
  },
  {
    word: "thị uy",
    part_of_speech: "động từ",
    meaning:
      "ra uy, phô trương sức mạnh nhằm làm cho đối phương sợ: cuộc biểu tình thị uy",
    example: "cuộc biểu tình thị uy",
  },
  {
    word: "thi tứ",
    part_of_speech: "danh từ",
    meaning: "(cũ) tứ thơ: thi tứ dồi dào",
    example: "thi tứ dồi dào",
  },
  {
    word: "thi vị hoá",
    part_of_speech: "động từ",
    meaning:
      "làm cho trở thành đẹp hơn trong trí tưởng tượng của mình: thi vị hoá cuộc sống",
    example: "thi vị hoá cuộc sống",
  },
  {
    word: "thi vị",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) cái hay, cái đẹp, cái có tính chất gợi cảm và gây hứng thú trong thơ văn: một câu thơ đầy thi vị",
    example: "một câu thơ đầy thi vị",
  },
  {
    word: "thi vị",
    part_of_speech: "danh từ",
    meaning:
      "hoặc t cái hay, cái đẹp, cái nên thơ của một câu chuyện, sự vật hay khung cảnh nào đó: phong cảnh trăng nước thi vị * thi vị của cuộc sống",
    example: "phong cảnh trăng nước thi vị * thi vị của cuộc sống",
  },
  {
    word: "thìa",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ có một đầu để cầm và một đầu lõm, dùng để múc thức ăn; lượng chứa trong một thìa: thìa xúp * thêm hai thìa muối vào canh",
    example: "thìa xúp * thêm hai thìa muối vào canh",
  },
  {
    word: "thia thia",
    part_of_speech: "danh từ",
    meaning:
      '(khẩu ngữ) cá thia thia (nói tắt): "Chim quyên ăn trái nhãn lồng, Thia thia quen chậu vợ chồng quen hơi." (ca dao)',
    example:
      'Chim quyên ăn trái nhãn lồng, Thia thia quen chậu vợ chồng quen hơi." (ca dao)',
  },
  {
    word: "thia lia",
    part_of_speech: "danh từ",
    meaning:
      '(khẩu ngữ) cá thia thia (nói tắt): "Chim quyên ăn trái nhãn lồng, Thia thia quen chậu vợ chồng quen hơi." (ca dao)',
    example:
      'Chim quyên ăn trái nhãn lồng, Thia thia quen chậu vợ chồng quen hơi." (ca dao)',
  },
  {
    word: "thích dụng",
    part_of_speech: "tính từ",
    meaning:
      "thích hợp để dùng vào việc gì: quyển sách thích dụng với học sinh trung học",
    example: "quyển sách thích dụng với học sinh trung học",
  },
  {
    word: "thịch",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng trầm và nặng, như tiếng của vật nặng rơi xuống trên nền mềm: rơi đánh thịch một cái",
    example: "rơi đánh thịch một cái",
  },
  {
    word: "thích",
    part_of_speech: "động từ",
    meaning:
      "dùng vật có mũi nhọn mà châm vào da cho thành dấu hiệu, chữ viết rồi bôi chất mực cho nổi hình lên: thích chữ vào tay",
    example: "thích chữ vào tay",
  },
  {
    word: "thích",
    part_of_speech: "động từ",
    meaning: "thúc vào người: thích nhẹ khuỷu tay vào sườn bạn",
    example: "thích nhẹ khuỷu tay vào sườn bạn",
  },
  {
    word: "thích",
    part_of_speech: "động từ",
    meaning:
      "có cảm giác bằng lòng, dễ chịu mỗi khi tiếp xúc với cái gì hoặc làm việc gì, khiến luôn muốn tiếp xúc với cái đó hoặc làm việc đó mỗi khi có dịp: thích đi du lịch * thích sống tự lập * không thích cuộc sống tù túng",
    example:
      "thích đi du lịch * thích sống tự lập * không thích cuộc sống tù túng",
  },
  {
    word: "thích đáng",
    part_of_speech: "tính từ",
    meaning:
      "thích hợp và thoả đáng: hình phạt thích đáng * cần phải có một sự quan tâm thích đáng",
    example: "hình phạt thích đáng * cần phải có một sự quan tâm thích đáng",
  },
  {
    word: "thích chí",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra bằng lòng, vui thích vì hợp với ý muốn: tỏ vẻ thích chí * thích chí cười khanh khách",
    example: "tỏ vẻ thích chí * thích chí cười khanh khách",
  },
  {
    word: "thích thú",
    part_of_speech: "",
    meaning:
      "có cảm giác bằng lòng, cảm thấy một đòi hỏi nào đó được thoả mãn: lắng nghe một cách thích thú",
    example: "lắng nghe một cách thích thú",
  },
  {
    word: "thích khách",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người mang vũ khí tới gần để ám sát một nhân vật quan trọng trong thời phong kiến: thích khách đột nhập vào cung",
    example: "thích khách đột nhập vào cung",
  },
  {
    word: "thích hợp",
    part_of_speech: "tính từ",
    meaning:
      "hợp với yêu cầu và đáp ứng tốt các đòi hỏi: các điều kiện thích hợp * không thích hợp với cuộc sống xô bồ",
    example: "các điều kiện thích hợp * không thích hợp với cuộc sống xô bồ",
  },
  {
    word: "thích nghi",
    part_of_speech: "động từ",
    meaning:
      "trở nên quen dần hoặc có những biến đổi cho phù hợp với môi trường hoặc hoàn cảnh mới: thích nghi với môi trường * điều kiện thích nghi",
    example: "thích nghi với môi trường * điều kiện thích nghi",
  },
  {
    word: "thiềm",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) từ dùng trong văn học cổ để chỉ mặt trăng: cung thiềm * "Chim về xao xác lá cây, Rừng Đông đã thấy tròn xoay bóng thiềm." (MĐMK)',
    example:
      'cung thiềm * "Chim về xao xác lá cây, Rừng Đông đã thấy tròn xoay bóng thiềm." (MĐMK)',
  },
  {
    word: "thích ứng",
    part_of_speech: "động từ",
    meaning:
      "có những thay đổi cho phù hợp với điều kiện mới, yêu cầu mới: thích ứng với nền kinh tế thị trường",
    example: "thích ứng với nền kinh tế thị trường",
  },
  {
    word: "thích ứng",
    part_of_speech: "động từ",
    meaning: "(hiếm) như thích nghi: không thích ứng với môi trường nóng ẩm",
    example: "không thích ứng với môi trường nóng ẩm",
  },
  {
    word: "thiền",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) từ đạo Phật gọi sự tĩnh tâm, loại bỏ những ý nghĩ không thuần khiết; cũng thường dùng để gọi chung những gì của đạo Phật: cửa thiền * "Mùi thiền đã bén muối dưa, Màu thiền ăn mặc đã ưa nâu sồng." (TKiều)',
    example:
      'cửa thiền * "Mùi thiền đã bén muối dưa, Màu thiền ăn mặc đã ưa nâu sồng." (TKiều)',
  },
  {
    word: "thiêm thiếp",
    part_of_speech: "động từ",
    meaning:
      "ở trạng thái thiếp đi, hầu như không còn hay biết gì, do quá mệt mỏi: nằm thiêm thiếp * thiêm thiếp giấc nồng",
    example: "nằm thiêm thiếp * thiêm thiếp giấc nồng",
  },
  {
    word: "thiến",
    part_of_speech: "động từ",
    meaning:
      "cắt bỏ tinh hoàn hay buồng trứng để súc vật thuần tính và dễ nuôi béo: gà trống thiến",
    example: "gà trống thiến",
  },
  {
    word: "thiến",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) cắt bỏ hẳn một bộ phận hay một phần nào đó: ngọn cây bị đạn pháo thiến cụt * chủ thầu thiến mất một phần tiền công của thợ",
    example:
      "ngọn cây bị đạn pháo thiến cụt * chủ thầu thiến mất một phần tiền công của thợ",
  },
  {
    word: "thiên",
    part_of_speech: "danh từ",
    meaning:
      "từng phần lớn của quyển sách (thường là sách cổ), trong thường gồm có nhiều chương: sách Luận ngữ có cả thảy hai mươi thiên",
    example: "sách Luận ngữ có cả thảy hai mươi thiên",
  },
  {
    word: "thiên",
    part_of_speech: "danh từ",
    meaning:
      "(trang trọng) từ dùng để chỉ từng đơn vị bài viết hoặc tác phẩm có giá trị lớn: thiên phóng sự * một thiên tiểu thuyết nổi tiếng",
    example: "thiên phóng sự * một thiên tiểu thuyết nổi tiếng",
  },
  {
    word: "thiên",
    part_of_speech: "động từ",
    meaning:
      "nghiêng về hoặc chú trọng quá mức về một phía hay một mặt nào đó trong nhận xét, đánh giá, hoạt động: đội bóng có lối đá thiên về tấn công * thiên về hình thức",
    example: "đội bóng có lối đá thiên về tấn công * thiên về hình thức",
  },
  {
    word: "thiên bẩm",
    part_of_speech: "danh từ",
    meaning: "bẩm chất tốt do trời phú: thiên bẩm thông minh",
    example: "thiên bẩm thông minh",
  },
  {
    word: "thiện",
    part_of_speech: "tính từ",
    meaning:
      "(phẩm chất, hành vi của con người) tốt, lành, hợp với đạo đức (nói khái quát): làm điều thiện * nhàn cư vi bất thiện (tng)",
    example: "làm điều thiện * nhàn cư vi bất thiện (tng)",
  },
  {
    word: "thiện cảm",
    part_of_speech: "danh từ",
    meaning:
      "tình cảm tốt, ưa thích đối với ai đó: có thiện cảm * ánh mắt không mấy thiện cảm",
    example: "có thiện cảm * ánh mắt không mấy thiện cảm",
  },
  {
    word: "thiển cận",
    part_of_speech: "tính từ",
    meaning:
      "(cách nghĩ, cách nhìn) nông cạn, hời hợt, chỉ nhìn thấy cái gần, cái trước mắt, không biết nhìn xa trông rộng: đầu óc thiển cận * lối suy nghĩ thiển cận",
    example: "đầu óc thiển cận * lối suy nghĩ thiển cận",
  },
  {
    word: "thiên binh",
    part_of_speech: "danh từ",
    meaning:
      'binh lính nhà trời; cũng dùng để ví binh lính của nhà vua đi dẹp giặc, coi như phụng mệnh trời: "Quân ta đã vào đến trong thành, thiên binh đã tới, chống cự cũng vô ích." (NgHTưởng; 2)',
    example:
      'Quân ta đã vào đến trong thành, thiên binh đã tới, chống cự cũng vô ích." (NgHTưởng; 2)',
  },
  {
    word: "thiên biến vạn hoá",
    part_of_speech: "",
    meaning:
      "biến hoá đủ mọi cách, không biết đâu mà lường trước được: chiến thuật thiên biến vạn hoá",
    example: "chiến thuật thiên biến vạn hoá",
  },
  {
    word: "thiện chí",
    part_of_speech: "danh từ",
    meaning:
      "ý định, suy nghĩ tốt và luôn thực lòng mong muốn đi đến kết quả tốt khi giải quyết việc gì: thái độ thiếu thiện chí * bắt tay để biểu lộ thiện chí",
    example: "thái độ thiếu thiện chí * bắt tay để biểu lộ thiện chí",
  },
  {
    word: "thiên cổ",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương) ngàn đời: lưu danh thiên cổ * đã ra người thiên cổ (đã chết)",
    example: "lưu danh thiên cổ * đã ra người thiên cổ (đã chết)",
  },
  {
    word: "thiên chúa",
    part_of_speech: "danh từ",
    meaning: "(hiếm) Chúa Trời: kỉ niệm ngày Thiên Chúa giáng sinh",
    example: "kỉ niệm ngày Thiên Chúa giáng sinh",
  },
  {
    word: "thiên chức",
    part_of_speech: "danh từ",
    meaning:
      "chức năng, phần việc mang tính tự nhiên và thiêng liêng của con người: thiên chức làm mẹ của người phụ nữ",
    example: "thiên chức làm mẹ của người phụ nữ",
  },
  {
    word: "thiện chiến",
    part_of_speech: "tính từ",
    meaning: "rất giỏi trong chiến đấu: đội quân thiện chiến",
    example: "đội quân thiện chiến",
  },
  {
    word: "thiên cơ",
    part_of_speech: "danh từ",
    meaning:
      "cơ trời; chỉ phép huyền bí, mầu nhiệm của trời, sắp đặt mọi việc trong trời đất, theo quan niệm duy tâm: thiên cơ đã định * không để lộ thiên cơ",
    example: "thiên cơ đã định * không để lộ thiên cơ",
  },
  {
    word: "thiên di",
    part_of_speech: "động từ",
    meaning:
      "di cư cả khối cộng đồng người đến một vùng khác: quá trình thiên di của những bộ tộc từ phương Bắc xuống phương Nam",
    example:
      "quá trình thiên di của những bộ tộc từ phương Bắc xuống phương Nam",
  },
  {
    word: "thiên cung",
    part_of_speech: "danh từ",
    meaning:
      "cung điện tưởng tượng ở trên trời, theo truyền thuyết: chốn thiên cung",
    example: "chốn thiên cung",
  },
  {
    word: "thiên đỉnh",
    part_of_speech: "danh từ",
    meaning:
      "điểm gặp nhau tưởng tượng giữa đường thẳng đứng đi qua vị trí người quan sát và vòm trời: lúc mặt trời đi qua thiên đỉnh",
    example: "lúc mặt trời đi qua thiên đỉnh",
  },
  {
    word: "thiên đường",
    part_of_speech: "danh từ",
    meaning:
      "nơi linh hồn những người được coi là đã rửa sạch tội lỗi được hưởng sự cực lạc vĩnh viễn sau khi chết, theo quan niệm của một số tôn giáo; cũng dùng để chỉ thế giới tưởng tượng đầy hạnh phúc; đối lập với địa ngục: lên thiên đường * thành phố thiên đường",
    example: "lên thiên đường * thành phố thiên đường",
  },
  {
    word: "thiên địa",
    part_of_speech: "danh từ",
    meaning: "(cũ) trời đất: vái thiên địa",
    example: "vái thiên địa",
  },
  {
    word: "thiên kim",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, văn chương) ngàn vàng; dùng để ví cái hết sức quý giá: thiên kim tiểu thư * nhân nghĩa tựa thiên kim",
    example: "thiên kim tiểu thư * nhân nghĩa tựa thiên kim",
  },
  {
    word: "thiên hạ",
    part_of_speech: "danh từ",
    meaning: "mọi nơi nói chung trên trái đất: đi chu du khắp thiên hạ",
    example: "đi chu du khắp thiên hạ",
  },
  {
    word: "thiên hạ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) người đời, trừ mình và những người thân ra (nói khái quát): che mắt thiên hạ * bị thiên hạ chê cười",
    example: "che mắt thiên hạ * bị thiên hạ chê cười",
  },
  {
    word: "thiên kiến",
    part_of_speech: "danh từ",
    meaning:
      "ý kiến, suy nghĩ thiên lệch, có phần áp đặt, thiếu khách quan: giữa mẹ chồng và nàng dâu có nhiều thiên kiến",
    example: "giữa mẹ chồng và nàng dâu có nhiều thiên kiến",
  },
  {
    word: "thiên hướng",
    part_of_speech: "danh từ",
    meaning:
      "khuynh hướng thiên về một cái gì đó, thường là có tính chất tự nhiên: thiên hướng nghệ thuật * có thiên hướng về các môn tự nhiên",
    example: "thiên hướng nghệ thuật * có thiên hướng về các môn tự nhiên",
  },
  {
    word: "thiên kỉ",
    part_of_speech: "danh từ",
    meaning:
      "thiên niên kỉ (nói tắt): sự biến đổi của Trái Đất trong một thiên kỉ",
    example: "sự biến đổi của Trái Đất trong một thiên kỉ",
  },
  {
    word: "thiên la địa võng",
    part_of_speech: "",
    meaning:
      "lưới giăng khắp trên trời dưới đất; ví sự bủa vây khắp mọi nơi, mọi phía không thể nào thoát ra được: thế trận như thiên la địa võng, có chạy cũng không thoát",
    example: "thế trận như thiên la địa võng, có chạy cũng không thoát",
  },
  {
    word: "thiên kỷ",
    part_of_speech: "danh từ",
    meaning:
      "thiên niên kỉ (nói tắt): sự biến đổi của Trái Đất trong một thiên kỉ",
    example: "sự biến đổi của Trái Đất trong một thiên kỉ",
  },
  {
    word: "thiên lí",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) nghìn dặm; thường dùng để tả cảnh đường đi rất xa hoặc một nơi nào đó rất xa: trên đường thiên lí * "Tôi đi thiên lí giang sơn, Nay về mà đặng bình an cũng mừng." (MPXH)',
    example:
      'trên đường thiên lí * "Tôi đi thiên lí giang sơn, Nay về mà đặng bình an cũng mừng." (MPXH)',
  },
  {
    word: "thiên lý",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) nghìn dặm; thường dùng để tả cảnh đường đi rất xa hoặc một nơi nào đó rất xa: trên đường thiên lí * "Tôi đi thiên lí giang sơn, Nay về mà đặng bình an cũng mừng." (MPXH)',
    example:
      'trên đường thiên lí * "Tôi đi thiên lí giang sơn, Nay về mà đặng bình an cũng mừng." (MPXH)',
  },
  {
    word: "thiên lôi",
    part_of_speech: "danh từ",
    meaning:
      "thần làm ra sấm sét, theo tưởng tượng của người xưa: ông thiên lôi",
    example: "ông thiên lôi",
  },
  {
    word: "thiên mệnh",
    part_of_speech: "danh từ",
    meaning: "(cũ) mệnh trời: sống chết là do thiên mệnh",
    example: "sống chết là do thiên mệnh",
  },
  {
    word: "thiên lệch",
    part_of_speech: "tính từ",
    meaning:
      "(cách nhìn, cách đánh giá, v.v.) lệch về một phía, phiến diện, thiếu khách quan: đánh giá có phần thiên lệch",
    example: "đánh giá có phần thiên lệch",
  },
  {
    word: "thiên nhiên",
    part_of_speech: "danh từ",
    meaning:
      "tổng thể nói chung những gì tồn tại xung quanh con người mà không phải do con người tạo ra: sống gần gũi với thiên nhiên cây cỏ * những quy luật của thiên nhiên",
    example:
      "sống gần gũi với thiên nhiên cây cỏ * những quy luật của thiên nhiên",
  },
  {
    word: "thiện nghệ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) rất giỏi, rất thành thạo trong một nghề, một việc nào đó: lái xe thiện nghệ",
    example: "lái xe thiện nghệ",
  },
  {
    word: "thiển nghĩ",
    part_of_speech: "động từ",
    meaning:
      "từ biểu thị điều sắp nêu ra chỉ là một ý kiến riêng phát biểu dè dặt với người đối thoại, hàm ý rất khiêm nhường, có phần kiểu cách, có nghĩa như theo tôi nghĩ (một cách nông cạn) thì có lẽ là: làm thì làm nhưng thiển nghĩ cũng phải cân nhắc kĩ",
    example: "làm thì làm nhưng thiển nghĩ cũng phải cân nhắc kĩ",
  },
  {
    word: "thiên niên kỷ",
    part_of_speech: "danh từ",
    meaning: "khoảng thời gian một nghìn năm.",
    example:
      "nhân loại đã bước sang thiên kỉ thứ ba (từ năm 2000 đến năm 2999)",
  },
  {
    word: "thiên nhan",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) mặt vua (ví như mặt của trời); cũng dùng để gọi tôn vua: "Thiên nhan gần gũi tấc gang, Nến hoa đối mặt, chén vàng trao tay." (NĐM)',
    example:
      'Thiên nhan gần gũi tấc gang, Nến hoa đối mặt, chén vàng trao tay." (NĐM)',
  },
  {
    word: "thiên phú",
    part_of_speech: "tính từ",
    meaning:
      "(tư chất) vốn có ngay từ lúc sinh ra, như được trời phú cho: tài năng thiên phú",
    example: "tài năng thiên phú",
  },
  {
    word: "thiên niên kỉ",
    part_of_speech: "danh từ",
    meaning: "khoảng thời gian một nghìn năm.",
    example:
      "nhân loại đã bước sang thiên kỉ thứ ba (từ năm 2000 đến năm 2999)",
  },
  {
    word: "thiên tài",
    part_of_speech: "",
    meaning:
      "tài năng kiệt xuất, hơn hẳn mọi người, dường như là được trời phú cho: nhà bác học thiên tài * Nguyễn Huệ là một thiên tài quân sự",
    example: "nhà bác học thiên tài * Nguyễn Huệ là một thiên tài quân sự",
  },
  {
    word: "thiền sư",
    part_of_speech: "danh từ",
    meaning:
      "người luyện tập thiền đã đạt đến một mức độ cao, có thể làm được những việc phi thường nào đó.",
    example: "Không Lộ thiền sư",
  },
  {
    word: "thiên tai",
    part_of_speech: "danh từ",
    meaning:
      "những tai hoạ lớn do các hiện tượng thiên nhiên như bão, lụt, hạn hán, giá rét, động đất, v.v. gây nên, làm ảnh hưởng nặng nề đến đời sống và sản xuất: khắc phục thiên tai",
    example: "khắc phục thiên tai",
  },
  {
    word: "thiên tạo",
    part_of_speech: "tính từ",
    meaning:
      "có một cách tự nhiên, do thiên nhiên tạo ra, chứ không phải do con người: hang thiên tạo",
    example: "hang thiên tạo",
  },
  {
    word: "thiện tâm",
    part_of_speech: "danh từ",
    meaning: "(hiếm) tấm lòng lành, tấm lòng từ thiện: người có thiện tâm",
    example: "người có thiện tâm",
  },
  {
    word: "thiên thanh",
    part_of_speech: "tính từ",
    meaning: "có màu xanh da trời nhạt: chiếc áo màu thiên thanh",
    example: "chiếc áo màu thiên thanh",
  },
  {
    word: "thiên thu",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương) nghìn thu, nghìn năm; thường dùng để chỉ thời gian vĩnh viễn: giấc mộng thiên thu",
    example: "giấc mộng thiên thu",
  },
  {
    word: "thiên thẹo",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) xiên xẹo: đường đi thiên thẹo",
    example: "đường đi thiên thẹo",
  },
  {
    word: "thiên thần",
    part_of_speech: "danh từ",
    meaning:
      "thần ở trên trời; thường dùng để chỉ sự đẹp đẽ, kì diệu: khuôn mặt đẹp như thiên thần * giấc mơ thiên thần",
    example: "khuôn mặt đẹp như thiên thần * giấc mơ thiên thần",
  },
  {
    word: "thiên tính",
    part_of_speech: "danh từ",
    meaning: "tính vốn có, do trời phú cho: thiên tính hiền lành",
    example: "thiên tính hiền lành",
  },
  {
    word: "thiên thai",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, văn chương) nơi thần tiên ở, theo thần thoại: chốn thiên thai",
    example: "chốn thiên thai",
  },
  {
    word: "thiên triều",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) triều đình Trung Quốc, trong quan hệ với các nước láng giềng phụ thuộc thời phong kiến (theo quan điểm của tư tưởng nước lớn phong kiến): đi sứ sang thiên triều * binh lính thiên triều",
    example: "đi sứ sang thiên triều * binh lính thiên triều",
  },
  {
    word: "thiên tử",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) từ dùng để gọi tôn vua (coi như con trời) thời phong kiến: lên ngôi thiên tử",
    example: "lên ngôi thiên tử",
  },
  {
    word: "thiên tuế",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) nghìn năm, nghìn tuổi (thường dùng trong lời tung hô, chúc tụng cha mẹ hoặc vợ con của vua): hoàng hậu thiên tuế!",
    example: "hoàng hậu thiên tuế!",
  },
  {
    word: "thiên tư",
    part_of_speech: "danh từ",
    meaning:
      "tư chất, phẩm chất tự nhiên giúp người ta đạt kết quả tốt trong một loại hoạt động nhất định: có thiên tư về hội hoạ * thiên tư lỗi lạc",
    example: "có thiên tư về hội hoạ * thiên tư lỗi lạc",
  },
  {
    word: "thiên tư",
    part_of_speech: "động từ",
    meaning: "(hiếm) như thiên vị: xét xử có ý thiên tư",
    example: "xét xử có ý thiên tư",
  },
  {
    word: "thiền tông",
    part_of_speech: "danh từ",
    meaning:
      "một phái của đạo Phật, chủ trương lấy thanh tịnh làm gốc, lấy việc ngồi yên lặng để ngẫm nghĩ đạo lí (thiền định) làm phép tu: tư tưởng Phật giáo thiền tông",
    example: "tư tưởng Phật giáo thiền tông",
  },
  {
    word: "thiên văn",
    part_of_speech: "danh từ",
    meaning:
      "hiện tượng xảy ra trên bầu trời liên quan đến sự vận động của các thiên thể: đài thiên văn * kính thiên văn * xem thiên văn",
    example: "đài thiên văn * kính thiên văn * xem thiên văn",
  },
  {
    word: "thiên văn",
    part_of_speech: "danh từ",
    meaning: "thiên văn học (nói tắt): nhà thiên văn * khoa thiên văn",
    example: "nhà thiên văn * khoa thiên văn",
  },
  {
    word: "thiên uy",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) uy của trời; thường dùng để chỉ uy của vua: xúc phạm đến thiên uy",
    example: "xúc phạm đến thiên uy",
  },
  {
    word: "thiên văn học",
    part_of_speech: "danh từ",
    meaning: "khoa học nghiên cứu về các thiên thể: ngành thiên văn học",
    example: "ngành thiên văn học",
  },
  {
    word: "thiện xạ",
    part_of_speech: "tính từ",
    meaning: "giỏi bắn: tay thiện xạ",
    example: "tay thiện xạ",
  },
  {
    word: "thiển ý",
    part_of_speech: "danh từ",
    meaning:
      "(trang trọng) ý nghĩ, ý kiến nông cạn (dùng để tự nói về mình với ý khiêm nhường): theo thiển ý của tôi",
    example: "theo thiển ý của tôi",
  },
  {
    word: "thiêng",
    part_of_speech: "tính từ",
    meaning:
      "có phép lạ như của thần linh, làm được những điều khiến người ta phải kính sợ, theo tín ngưỡng dân gian: khí thiêng sông núi * có thờ có thiêng, có kiêng có lành (tng)",
    example: "khí thiêng sông núi * có thờ có thiêng, có kiêng có lành (tng)",
  },
  {
    word: "thiêng",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) (lời dự đoán) rất đúng, rất hiệu nghiệm: lời nói của anh ta thiêng thật",
    example: "lời nói của anh ta thiêng thật",
  },
  {
    word: "thiện ý",
    part_of_speech: "danh từ",
    meaning:
      "ý định tốt lành trong quan hệ với người khác: tỏ rõ thiện ý * có thiện ý giúp đỡ",
    example: "tỏ rõ thiện ý * có thiện ý giúp đỡ",
  },
  {
    word: "thiên vị",
    part_of_speech: "động từ",
    meaning:
      "(cách đối xử) nghiêng về một phía, không công bằng, không vô tư: đối xử công bằng, không thiên vị ai",
    example: "đối xử công bằng, không thiên vị ai",
  },
  {
    word: "thiệp",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) thiếp: tấm thiệp chúc tết",
    example: "tấm thiệp chúc tết",
  },
  {
    word: "thiệp",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) tỏ ra từng trải, lịch sự trong cách giao thiệp: ăn nói thiệp * một tay thiệp đời",
    example: "ăn nói thiệp * một tay thiệp đời",
  },
  {
    word: "thiếp",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) vợ lẽ trong các gia đình giàu sang thời phong kiến: năm thê bảy thiếp * cưới về làm thiếp",
    example: "năm thê bảy thiếp * cưới về làm thiếp",
  },
  {
    word: "thiếp",
    part_of_speech: "danh từ",
    meaning:
      '(văn chương) từ người phụ nữ ngày trước dùng để tự xưng một cách khiêm nhường khi nói với chồng hoặc với người đàn ông nói chung: "Nàng rằng: Phận gái chữ tòng, Chàng đi, thiếp cũng quyết lòng xin đi." (TKiều)',
    example:
      'Nàng rằng: Phận gái chữ tòng, Chàng đi, thiếp cũng quyết lòng xin đi." (TKiều)',
  },
  {
    word: "thiếp",
    part_of_speech: "danh từ",
    meaning:
      "tấm giấy nhỏ dùng để báo tin, chúc mừng, mời khách, v.v., có nội dung ngắn gọn và thường được in sẵn: thiếp mời đám cưới * thiếp chúc Tết",
    example: "thiếp mời đám cưới * thiếp chúc Tết",
  },
  {
    word: "thiếp",
    part_of_speech: "động từ",
    meaning:
      "ở vào tình trạng như ngủ mê đi, không còn biết gì nữa, thường là do quá mệt mỏi: mệt quá, thiếp đi lúc nào không biết",
    example: "mệt quá, thiếp đi lúc nào không biết",
  },
  {
    word: "thiệt",
    part_of_speech: "",
    meaning:
      'bị mất đi vào tay người khác phần mà mình có quyền được hưởng: chịu thiệt * "Vì ta cho luỵ đến người, Cát lầm ngọc trắng, thiệt đời xuân xanh." (TKiều)',
    example:
      'chịu thiệt * "Vì ta cho luỵ đến người, Cát lầm ngọc trắng, thiệt đời xuân xanh." (TKiều)',
  },
  {
    word: "thiêng liêng",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như thiêng (ng1): đấng thiêng liêng",
    example: "đấng thiêng liêng",
  },
  {
    word: "thiêng liêng",
    part_of_speech: "tính từ",
    meaning:
      "rất cao quý, đáng tôn thờ, coi trọng và giữ gìn hơn hết: lời thề thiêng liêng * giây phút thiêng liêng",
    example: "lời thề thiêng liêng * giây phút thiêng liêng",
  },
  {
    word: "thiết",
    part_of_speech: "động từ",
    meaning:
      "có nhu cầu, ham thích hoặc mong muốn điều gì: chẳng thiết ăn uống gì nữa * không thiết sống",
    example: "chẳng thiết ăn uống gì nữa * không thiết sống",
  },
  {
    word: "thiết bì",
    part_of_speech: "tính từ",
    meaning: "(da) thô, dày và đen xỉn, giống như màu sắt: da thiết bì",
    example: "da thiết bì",
  },
  {
    word: "thiết bị",
    part_of_speech: "danh từ",
    meaning:
      "tổng thể nói chung những máy móc, dụng cụ, phụ tùng cần thiết cho một hoạt động nào đó: không có thiết bị thay thế * thiết bị quân sự",
    example: "không có thiết bị thay thế * thiết bị quân sự",
  },
  {
    word: "thiết bị đầu cuối",
    part_of_speech: "danh từ",
    meaning:
      "thiết bị bao gồm màn hình và bàn phím cho phép người dùng làm việc với máy tính ở xa.",
    example:
      "khách hàng lắp đặt điện thoại được tặng thiết bị đầu cuối * dịch vụ đầu cuối",
  },
  {
    word: "thiết bị đầu cuối",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) như đầu đuôi: hỏi rõ đầu cuối câu chuyện * chưa hiểu đầu cuối ra sao",
    example: "hỏi rõ đầu cuối câu chuyện * chưa hiểu đầu cuối ra sao",
  },
  {
    word: "thiết cốt",
    part_of_speech: "tính từ",
    meaning: "(cũ) như chí cốt: một người bạn thiết cốt",
    example: "một người bạn thiết cốt",
  },
  {
    word: "thiết giáp",
    part_of_speech: "danh từ",
    meaning:
      "vỏ bọc bằng thép dày; thường dùng để gọi xe bọc thép: xe thiết giáp",
    example: "xe thiết giáp",
  },
  {
    word: "thiết giáp",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi chung xe tăng và xe bọc thép: binh chủng thiết giáp * lính thiết giáp",
    example: "binh chủng thiết giáp * lính thiết giáp",
  },
  {
    word: "thiết chế",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như thể chế: thiết chế dân chủ",
    example: "thiết chế dân chủ",
  },
  {
    word: "thiết bị ngoại vi",
    part_of_speech: "danh từ",
    meaning:
      "thiết bị được nối với máy tính, do máy tính điều khiển, nhưng là bộ phận tách rời khỏi bộ phận chứa CPU của máy: lắp đặt một số thiết bị ngoại vi như máy in, máy quét",
    example: "lắp đặt một số thiết bị ngoại vi như máy in, máy quét",
  },
  {
    word: "thiết đồ",
    part_of_speech: "danh từ",
    meaning:
      "hình vẽ một vật theo một mặt cắt tưởng tượng nào đó để nhằm làm rõ cấu trúc bên trong của nó: thiết đồ của máy phát điện",
    example: "thiết đồ của máy phát điện",
  },
  {
    word: "thiệt hại",
    part_of_speech: "",
    meaning:
      "bị mất mát hay tổn thất về người, về của cải vật chất hoặc tinh thần: bồi thường thiệt hại * khắc phục những thiệt hại sau cơn bão",
    example: "bồi thường thiệt hại * khắc phục những thiệt hại sau cơn bão",
  },
  {
    word: "thiết kế",
    part_of_speech: "động từ",
    meaning:
      "lập tài liệu kĩ thuật toàn bộ, gồm có bản tính toán, bản vẽ, v.v., để có thể theo đó mà xây dựng công trình, sản xuất thiết bị, sản phẩm, v.v: thiết kế sai quy định * kĩ sư thiết kế",
    example: "thiết kế sai quy định * kĩ sư thiết kế",
  },
  {
    word: "thiệt mạng",
    part_of_speech: "động từ",
    meaning: "chết một cách oan uổng: vụ tai nạn đã làm nhiều người thiệt mạng",
    example: "vụ tai nạn đã làm nhiều người thiệt mạng",
  },
  {
    word: "thiết mộc",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi chung các loại gỗ quý rất cứng (ví như sắt): đinh, lim, sến, táu được xếp vào hàng thiết mộc",
    example: "đinh, lim, sến, táu được xếp vào hàng thiết mộc",
  },
  {
    word: "thiết nghĩ",
    part_of_speech: "động từ",
    meaning:
      "từ biểu thị điều sắp nêu ra chỉ là một ý kiến riêng trao đổi với người đối thoại, có ý như theo tôi nghĩ là (hàm ý khiêm nhường): vấn đề này thiết nghĩ không nên quá vội vàng",
    example: "vấn đề này thiết nghĩ không nên quá vội vàng",
  },
  {
    word: "thiệt hơn",
    part_of_speech: "tính từ",
    meaning:
      "(cân nhắc, tính toán) hơn hay kém, lợi hay thiệt (nói khái quát): tính toán thiệt hơn",
    example: "tính toán thiệt hơn",
  },
  {
    word: "thiết lập",
    part_of_speech: "động từ",
    meaning:
      "lập ra, dựng nên: thiết lập quan hệ ngoại giao * thiết lập lại trật tự",
    example: "thiết lập quan hệ ngoại giao * thiết lập lại trật tự",
  },
  {
    word: "thiết quân luật",
    part_of_speech: "động từ",
    meaning: "(cũ, hoặc kng) giới nghiêm: giờ thiết quân luật",
    example: "giờ thiết quân luật",
  },
  {
    word: "thiết tha",
    part_of_speech: "tính từ",
    meaning:
      "(tình cảm) thắm thiết làm cho gắn bó hết lòng, luôn luôn nghĩ đến, quan tâm đến: yêu tha thiết * lời lẽ tha thiết",
    example: "yêu tha thiết * lời lẽ tha thiết",
  },
  {
    word: "thiết tha",
    part_of_speech: "tính từ",
    meaning:
      "rất cấp thiết đối với mình và hết sức mong mỏi được đáp ứng: nguyện vọng tha thiết * lời cầu xin tha thiết",
    example: "nguyện vọng tha thiết * lời cầu xin tha thiết",
  },
  {
    word: "thiết thân",
    part_of_speech: "tính từ",
    meaning:
      "rất cần thiết hoặc có sự quan hệ mật thiết về mặt lợi ích đối với bản thân: bảo vệ lợi ích thiết thân",
    example: "bảo vệ lợi ích thiết thân",
  },
  {
    word: "thiệt thân",
    part_of_speech: "động từ",
    meaning:
      'thiệt hại đến bản thân mình một cách vô ích: sinh sự làm gì cho thiệt thân * "Thác đi sợ tiếng gièm pha, Thiệt thân mà miệng người ta chê cười." (ca dao)',
    example:
      'sinh sự làm gì cho thiệt thân * "Thác đi sợ tiếng gièm pha, Thiệt thân mà miệng người ta chê cười." (ca dao)',
  },
  {
    word: "thiệt thòi",
    part_of_speech: "",
    meaning:
      "phải chịu điều thiệt, thường là lớn và do hoàn cảnh đưa lại (nói khái quát): chịu thiệt thòi * bù đắp những thiệt thòi cho trẻ mồ côi",
    example: "chịu thiệt thòi * bù đắp những thiệt thòi cho trẻ mồ côi",
  },
  {
    word: "thiết yếu",
    part_of_speech: "tính từ",
    meaning:
      "rất cần thiết và không thể thiếu được: nhu cầu thiết yếu * mặt hàng thiết yếu",
    example: "nhu cầu thiết yếu * mặt hàng thiết yếu",
  },
  {
    word: "thiết thực",
    part_of_speech: "tính từ",
    meaning:
      "sát thực và phù hợp với những yêu cầu, những vấn đề thực tế trước mắt: việc làm thiết thực * tính những chuyện cao xa, ít thiết thực",
    example: "việc làm thiết thực * tính những chuyện cao xa, ít thiết thực",
  },
  {
    word: "thiết thực",
    part_of_speech: "tính từ",
    meaning:
      "có óc thực tế và luôn chú ý đến yêu cầu, đòi hỏi của thực tế khi hành động: một con người thiết thực",
    example: "một con người thiết thực",
  },
  {
    word: "thiếu",
    part_of_speech: "",
    meaning:
      "có hoặc chỉ đạt số lượng hay mức độ dưới mức cần thiết, dưới mức yêu cầu: trẻ sinh thiếu tháng * hành động thiếu ý thức",
    example: "trẻ sinh thiếu tháng * hành động thiếu ý thức",
  },
  {
    word: "thiết tưởng",
    part_of_speech: "động từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là ý kiến riêng mang tính khẳng định một cách tế nhị, có ý như tôi cho rằng, theo tôi thì (hàm ý khiêm nhường): sự việc đã rõ ràng, thiết tưởng không cần phải bàn cãi gì nữa",
    example: "sự việc đã rõ ràng, thiết tưởng không cần phải bàn cãi gì nữa",
  },
  {
    word: "thiêu",
    part_of_speech: "động từ",
    meaning:
      "đốt cháy bằng ngọn lửa mạnh: nhà cửa bị lửa thiêu trụi * kiếm củi ba năm thiêu một giờ (tng)",
    example: "nhà cửa bị lửa thiêu trụi * kiếm củi ba năm thiêu một giờ (tng)",
  },
  {
    word: "thiêu đốt",
    part_of_speech: "động từ",
    meaning: "thiêu cháy, đốt cháy (nói khái quát): nắng như thiêu đốt",
    example: "nắng như thiêu đốt",
  },
  {
    word: "thiếu gì",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị ý khẳng định số lượng rất nhiều, cần bao nhiêu cũng có: ở đời thiếu gì người tử tế * nhà giàu, tiền bạc thiếu gì",
    example: "ở đời thiếu gì người tử tế * nhà giàu, tiền bạc thiếu gì",
  },
  {
    word: "thiếu hụt",
    part_of_speech: "tính từ",
    meaning:
      "bị thiếu mất đi một phần, không còn đủ nữa (nói khái quát): thiếu hụt ngân sách * quân số thiếu hụt",
    example: "thiếu hụt ngân sách * quân số thiếu hụt",
  },
  {
    word: "thiếu điều",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) (làm việc gì) đã hết sức, hết mức rồi, chỉ còn thiếu cái điều (được coi là quá đáng lắm, không thể có được, nêu ra để nhấn mạnh): chạy thiếu điều hụt hơi",
    example: "chạy thiếu điều hụt hơi",
  },
  {
    word: "thiểu não",
    part_of_speech: "tính từ",
    meaning:
      'buồn rầu, đau khổ: "Vắng lời khuất mặt lúc này, Lòng người thiểu não biết ngày nào nguôi." (QÂTK)',
    example:
      'Vắng lời khuất mặt lúc này, Lòng người thiểu não biết ngày nào nguôi." (QÂTK)',
  },
  {
    word: "thiểu não",
    part_of_speech: "tính từ",
    meaning:
      "có dáng vẻ ủ rũ, khổ sở, trông đáng thương: bộ mặt thiểu não * dáng điệu thiểu não",
    example: "bộ mặt thiểu não * dáng điệu thiểu não",
  },
  {
    word: "thiếu nhi",
    part_of_speech: "danh từ",
    meaning:
      "trẻ em thuộc các lứa tuổi thiếu niên, nhi đồng: các em thiếu nhi * ngày mồng 1 tháng 6 là ngày Quốc tế thiếu nhi",
    example: "các em thiếu nhi * ngày mồng 1 tháng 6 là ngày Quốc tế thiếu nhi",
  },
  {
    word: "thiêu huỷ",
    part_of_speech: "động từ",
    meaning:
      "đốt cháy, làm cho không còn tồn tại nữa (nói khái quát): thiêu huỷ tài liệu",
    example: "thiêu huỷ tài liệu",
  },
  {
    word: "thiểu năng",
    part_of_speech: "danh từ",
    meaning:
      "trạng thái một cơ quan nào đó trong cơ thể không thực hiện được đầy đủ chức năng như vốn có: thiểu năng trí tuệ",
    example: "thiểu năng trí tuệ",
  },
  {
    word: "thiếu niên",
    part_of_speech: "danh từ",
    meaning:
      "trẻ em thuộc lứa tuổi từ mười đến khoảng mười bốn, mười lăm: giáo dục thiếu niên, nhi đồng",
    example: "giáo dục thiếu niên, nhi đồng",
  },
  {
    word: "thiếu đói",
    part_of_speech: "động từ",
    meaning:
      "bị đói do thiếu lương thực cho nhu cầu tối thiểu (nói khái quát): lâm vào cảnh thiếu đói",
    example: "lâm vào cảnh thiếu đói",
  },
  {
    word: "thiếu nữ",
    part_of_speech: "danh từ",
    meaning:
      "người con gái còn rất trẻ, đang ở vào tuổi dậy thì: thời thiếu nữ",
    example: "thời thiếu nữ",
  },
  {
    word: "thiếu sinh quân",
    part_of_speech: "danh từ",
    meaning:
      "thiếu niên theo học ở trường của quân đội để được đào tạo thành quân nhân: trường thiếu sinh quân",
    example: "trường thiếu sinh quân",
  },
  {
    word: "thiều quang",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) ánh sáng đẹp; dùng để chỉ ngày mùa xuân: "Ngày xuân con én đưa thoi, Thiều quang chín chục đã ngoài sáu mươi." (TKiều)',
    example:
      'Ngày xuân con én đưa thoi, Thiều quang chín chục đã ngoài sáu mươi." (TKiều)',
  },
  {
    word: "bung xung",
    part_of_speech: "danh từ",
    meaning:
      'vật để đỡ tên đạn khi ra trận ngày xưa; thường dùng để ví người bị lợi dụng hoặc chịu đỡ đòn thay cho người khác: "Thân em đi lấy chồng chung, Khác nào như cái bung xung chịu đòn!" (ca dao)',
    example:
      'Thân em đi lấy chồng chung, Khác nào như cái bung xung chịu đòn!" (ca dao)',
  },
  {
    word: "buộc",
    part_of_speech: "động từ",
    meaning:
      "làm cho bị giữ chặt ở một vị trí bằng sợi dây: buộc tóc * buộc vết thương * trâu buộc ghét trâu ăn (tng)",
    example: "buộc tóc * buộc vết thương * trâu buộc ghét trâu ăn (tng)",
  },
  {
    word: "buộc",
    part_of_speech: "động từ",
    meaning:
      "làm cho hoặc bị lâm vào thế nhất thiết phải chấp nhận hoặc phải làm điều gì đó trái ý muốn, vì không có cách nào khác: bị buộc phải thôi việc * điều đó buộc hắn phải suy nghĩ",
    example: "bị buộc phải thôi việc * điều đó buộc hắn phải suy nghĩ",
  },
  {
    word: "buộc",
    part_of_speech: "động từ",
    meaning:
      "bắt phải nhận, phải chịu (điều không hay): bị buộc vào tội giết người",
    example: "bị buộc vào tội giết người",
  },
  {
    word: "buộc chỉ cổ tay",
    part_of_speech: "",
    meaning:
      'thề không mắc lại cái sai lầm đã qua (thường khi bị người khác xử tệ với mình): "Từ rày buộc chỉ cổ tay, Chim đậu thì bắt, chim bay thì đừng." (ca dao)',
    example:
      'Từ rày buộc chỉ cổ tay, Chim đậu thì bắt, chim bay thì đừng." (ca dao)',
  },
  {
    word: "buộc lòng",
    part_of_speech: "tính từ",
    meaning:
      "ở trong cái thế đành phải làm, phải chấp nhận mặc dù không muốn: buộc lòng ra đi * bị ép nên buộc lòng phải nhận",
    example: "buộc lòng ra đi * bị ép nên buộc lòng phải nhận",
  },
  {
    word: "buổi đực buổi cái",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) (làm việc gì) thất thường, hôm có hôm không, không được liên tục: học hành buổi đực buổi cái",
    example: "học hành buổi đực buổi cái",
  },
  {
    word: "buộc tội",
    part_of_speech: "động từ",
    meaning:
      "buộc vào một tội gì, bắt phải nhận tội, phải chịu tội: chứng cớ không đủ để buộc tội * lời buộc tội đanh thép",
    example: "chứng cớ không đủ để buộc tội * lời buộc tội đanh thép",
  },
  {
    word: "buổi mai",
    part_of_speech: "danh từ",
    meaning:
      'buổi sáng sớm: "Thân em như cây lúa trĩu bông, Ngả nghiêng dưới ngọn nắng hồng buổi mai." (ca dao)',
    example:
      'Thân em như cây lúa trĩu bông, Ngả nghiêng dưới ngọn nắng hồng buổi mai." (ca dao)',
  },
  {
    word: "buổi",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian trong ngày chia theo trình tự tự nhiên, dựa vào tính chất của ánh sáng hoặc theo thì giờ lao động và nghỉ ngơi: buổi sáng * làm được nửa buổi đã về",
    example: "buổi sáng * làm được nửa buổi đã về",
  },
  {
    word: "buổi",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian nhất định mà sự việc nói tới xảy ra: thân nhau từ buổi đầu gặp gỡ * nhớ buổi ra đi * vận nước gặp buổi suy vi",
    example:
      "thân nhau từ buổi đầu gặp gỡ * nhớ buổi ra đi * vận nước gặp buổi suy vi",
  },
  {
    word: "buồn",
    part_of_speech: "tính từ",
    meaning:
      'hay đg có tâm trạng không thích thú của người đang gặp việc đau thương hoặc đang có điều không được như ý: buồn vì thi trượt * lòng buồn rười rượi * "Cảnh nào cảnh chẳng đeo sầu, Người buồn cảnh có vui đâu bao giờ!" (TKiều)',
    example:
      'buồn vì thi trượt * lòng buồn rười rượi * "Cảnh nào cảnh chẳng đeo sầu, Người buồn cảnh có vui đâu bao giờ!" (TKiều)',
  },
  {
    word: "buồn",
    part_of_speech: "tính từ",
    meaning:
      "có tác động làm cho tâm trạng không thích thú: một kỉ niệm buồn * câu chuyện buồn",
    example: "một kỉ niệm buồn * câu chuyện buồn",
  },
  {
    word: "buồn",
    part_of_speech: "tính từ",
    meaning:
      "có cảm giác bứt rứt khó chịu trong cơ thể, muốn có cử chỉ, hành động nào đó: buồn miệng hát nghêu ngao * ngồi không mãi cũng buồn chân buồn tay",
    example:
      "buồn miệng hát nghêu ngao * ngồi không mãi cũng buồn chân buồn tay",
  },
  {
    word: "buồn",
    part_of_speech: "tính từ",
    meaning:
      "có cảm giác khó nhịn được cười khi bị kích thích trên da thịt: bị cù buồn không nhịn được cười",
    example: "bị cù buồn không nhịn được cười",
  },
  {
    word: "buồn",
    part_of_speech: "động từ",
    meaning:
      "cảm thấy cần phải làm việc gì đó, do cơ thể đòi hỏi, khó nén nhịn được: buồn đi tiểu * trời đã khuya, mà vẫn chưa ai buồn ngủ",
    example: "buồn đi tiểu * trời đã khuya, mà vẫn chưa ai buồn ngủ",
  },
  {
    word: "buồn",
    part_of_speech: "động từ",
    meaning: "cảm thấy muốn: chán chẳng buồn nói * mệt chẳng buồn ăn",
    example: "chán chẳng buồn nói * mệt chẳng buồn ăn",
  },
  {
    word: "buôn",
    part_of_speech: "động từ",
    meaning: "mua để bán lấy lãi: đi buôn * buôn có bạn, bán có phường (tng)",
    example: "đi buôn * buôn có bạn, bán có phường (tng)",
  },
  {
    word: "buồn bã",
    part_of_speech: "tính từ",
    meaning:
      "có tâm trạng hoặc có tính chất buồn (nói khái quát): tâm trạng buồn bã * nét mặt trở nên buồn bã, âu sầu",
    example: "tâm trạng buồn bã * nét mặt trở nên buồn bã, âu sầu",
  },
  {
    word: "buôn bán",
    part_of_speech: "động từ",
    meaning: "buôn và bán (nói khái quát): làm ăn buôn bán * buôn bán gian lận",
    example: "làm ăn buôn bán * buôn bán gian lận",
  },
  {
    word: "buồn bực",
    part_of_speech: "tính từ",
    meaning:
      "buồn và khó chịu, bứt rứt trong lòng: buồn bực chuyện gia đình * có cảm giác chán nản, buồn bực",
    example: "buồn bực chuyện gia đình * có cảm giác chán nản, buồn bực",
  },
  {
    word: "buồn cười",
    part_of_speech: "tính từ",
    meaning:
      "khó mà nhịn được cười, làm cho không nhịn được cười: chuyện đó không có gì đáng buồn cười * cái mặt nó trông buồn cười lắm!",
    example:
      "chuyện đó không có gì đáng buồn cười * cái mặt nó trông buồn cười lắm!",
  },
  {
    word: "buôn chuyến",
    part_of_speech: "động từ",
    meaning:
      "buôn từng chuyến hàng (thường có quy mô lớn và đi dài ngày) từ nơi xa về: buôn chuyến đường dài",
    example: "buôn chuyến đường dài",
  },
  {
    word: "buồn đau",
    part_of_speech: "",
    meaning:
      "như đau buồn: kí ức buồn đau * cùng chia sẻ những buồn đau, bất hạnh",
    example: "kí ức buồn đau * cùng chia sẻ những buồn đau, bất hạnh",
  },
  {
    word: "buồn hiu",
    part_of_speech: "tính từ",
    meaning: "buồn với vẻ cô đơn, lặng lẽ: ánh mắt buồn hiu * mặt buồn hiu",
    example: "ánh mắt buồn hiu * mặt buồn hiu",
  },
  {
    word: "buồn ngủ",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái cảm thấy muốn ngủ, cần ngủ ngay: thức khuya nên buồn ngủ * cơn buồn ngủ ập đến",
    example: "thức khuya nên buồn ngủ * cơn buồn ngủ ập đến",
  },
  {
    word: "buồn nôn",
    part_of_speech: "tính từ",
    meaning: "ở trạng thái cảm thấy muốn nôn: chóng mặt, buồn nôn",
    example: "chóng mặt, buồn nôn",
  },
  {
    word: "buôn lậu",
    part_of_speech: "động từ",
    meaning:
      "buôn bán hàng cấm hoặc hàng trốn thuế: buôn lậu thuốc lá qua biên giới * đi buôn lậu",
    example: "buôn lậu thuốc lá qua biên giới * đi buôn lậu",
  },
  {
    word: "buồn phiền",
    part_of_speech: "tính từ",
    meaning:
      "buồn và lo nghĩ, không yên lòng: con hư làm cha mẹ phải buồn phiền * tâm trạng buồn phiền",
    example: "con hư làm cha mẹ phải buồn phiền * tâm trạng buồn phiền",
  },
  {
    word: "buồn rầu",
    part_of_speech: "tính từ",
    meaning:
      'có tâm trạng buồn và để lộ rõ ra bên ngoài qua nét mặt, dáng điệu, v.v.: vẻ mặt buồn rầu, thiểu não * "Buồn rầu nói chẳng nên lời, Hoa đèn kia với bóng người khá thương." (CPN)',
    example:
      'vẻ mặt buồn rầu, thiểu não * "Buồn rầu nói chẳng nên lời, Hoa đèn kia với bóng người khá thương." (CPN)',
  },
  {
    word: "buồn rượi",
    part_of_speech: "tính từ",
    meaning: "buồn và lộ vẻ ủ rũ: nét mặt buồn rượi * tâm trí buồn rượi",
    example: "nét mặt buồn rượi * tâm trí buồn rượi",
  },
  {
    word: "buồn rười rượi",
    part_of_speech: "tính từ",
    meaning: "như buồn rượi (nhưng ý mức độ nhiều hơn): mặt buồn rười rượi",
    example: "mặt buồn rười rượi",
  },
  {
    word: "buồn tênh",
    part_of_speech: "tính từ",
    meaning:
      'buồn vì cảm thấy như hụt hẫng, như thiếu vắng một cái gì không rõ rệt: nhà cửa buồn tênh * "Nàng càng ủ dột thu ba, Đoạn trường lúc ấy nghĩ mà buồn tênh." (TKiều)',
    example:
      'nhà cửa buồn tênh * "Nàng càng ủ dột thu ba, Đoạn trường lúc ấy nghĩ mà buồn tênh." (TKiều)',
  },
  {
    word: "buồn thảm",
    part_of_speech: "tính từ",
    meaning:
      "buồn đến mức thảm đạm: một cuộc đời buồn thảm * bài hát nghe rất buồn thảm",
    example: "một cuộc đời buồn thảm * bài hát nghe rất buồn thảm",
  },
  {
    word: "buồn tẻ",
    part_of_speech: "tính từ",
    meaning:
      "tẻ nhạt, không có gì vui, không có gì gây hứng thú: một công việc buồn tẻ * cuộc đời buồn tẻ",
    example: "một công việc buồn tẻ * cuộc đời buồn tẻ",
  },
  {
    word: "buồn thiu",
    part_of_speech: "tính từ",
    meaning:
      "buồn với vẻ thất vọng, mất hứng thú: nét mặt buồn thiu * ngồi buồn thiu, chẳng nói chẳng rằng",
    example: "nét mặt buồn thiu * ngồi buồn thiu, chẳng nói chẳng rằng",
  },
  {
    word: "buồn teo",
    part_of_speech: "tính từ",
    meaning:
      "buồn vì cảm thấy vắng lặng: cảnh vật buồn teo * làng xóm buồn teo",
    example: "cảnh vật buồn teo * làng xóm buồn teo",
  },
  {
    word: "buồn thỉu",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như buồn thiu: mặt buồn thỉu",
    example: "mặt buồn thỉu",
  },
  {
    word: "buồn tủi",
    part_of_speech: "tính từ",
    meaning:
      "buồn và cảm thấy tủi hổ, thương xót cho mình: giọt lệ buồn tủi * cảm thấy cô đơn, buồn tủi",
    example: "giọt lệ buồn tủi * cảm thấy cô đơn, buồn tủi",
  },
  {
    word: "buồn tình",
    part_of_speech: "tính từ",
    meaning:
      "buồn vì cảm thấy trống rỗng và không có việc gì làm, không biết làm gì: ngồi không buồn tình, lôi mấy tờ báo cũ ra xem",
    example: "ngồi không buồn tình, lôi mấy tờ báo cũ ra xem",
  },
  {
    word: "buồng",
    part_of_speech: "danh từ",
    meaning:
      'tập hợp gồm nhiều nhánh quả trên một cuống chung ở một số cây như cau, chuối, v.v.: buồng chuối * "Ai về tôi gửi buồng cau, Buồng trước kính mẹ, buồng sau kính thầy." (Cdao)',
    example:
      'buồng chuối * "Ai về tôi gửi buồng cau, Buồng trước kính mẹ, buồng sau kính thầy." (Cdao)',
  },
  {
    word: "buồng",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp gồm hai hoặc nhiều cái cùng loại xếp thành chùm trong cơ thể động vật: buồng phổi * buồng gan",
    example: "buồng phổi * buồng gan",
  },
  {
    word: "buồng",
    part_of_speech: "danh từ",
    meaning:
      'phần không gian của nhà ở được ngăn riêng bằng tường, vách, có công dụng riêng và thường kín đáo: "Nhà anh chỉ có một gian, Nửa thì làm bếp, nửa toan làm buồng." (Cdao)',
    example:
      'Nhà anh chỉ có một gian, Nửa thì làm bếp, nửa toan làm buồng." (Cdao)',
  },
  {
    word: "buồng",
    part_of_speech: "danh từ",
    meaning:
      "khoảng không gian kín trong máy hoặc thiết bị, có một công dụng riêng nào đó: buồng đốt của động cơ đốt trong",
    example: "buồng đốt của động cơ đốt trong",
  },
  {
    word: "buồn xo",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) như buồn thiu: mặt buồn xo",
    example: "mặt buồn xo",
  },
  {
    word: "buông",
    part_of_speech: "động từ",
    meaning:
      "để cho rời ra khỏi tay, không cầm giữ nữa: buông đũa đứng dậy * buông súng đầu hàng",
    example: "buông đũa đứng dậy * buông súng đầu hàng",
  },
  {
    word: "buông",
    part_of_speech: "động từ",
    meaning:
      "thả câu, lưới, v.v. xuống nước để đánh bắt cá: buông lưới đánh cá * buông câu",
    example: "buông lưới đánh cá * buông câu",
  },
  {
    word: "buông",
    part_of_speech: "động từ",
    meaning:
      "để cho rơi thẳng xuống một cách tự nhiên: buông màn đi ngủ * tóc buông xoã * màn đêm buông xuống",
    example: "buông màn đi ngủ * tóc buông xoã * màn đêm buông xuống",
  },
  {
    word: "buông",
    part_of_speech: "động từ",
    meaning:
      "để cho âm thanh phát ra từng tiếng một, nghe như những tiếng tự nhiên rơi vào giữa khoảng không: buông một tiếng thở dài * buông lời trêu ghẹo * chiếc đồng hồ buông tám tiếng",
    example:
      "buông một tiếng thở dài * buông lời trêu ghẹo * chiếc đồng hồ buông tám tiếng",
  },
  {
    word: "buồng đào",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) như buồng khuê: "Buồng đào khuya sớm thảnh thơi, Ra vào một mực nói cười như không." (TKiều)',
    example:
      'Buồng đào khuya sớm thảnh thơi, Ra vào một mực nói cười như không." (TKiều)',
  },
  {
    word: "buồng hương",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) như buồng khuê: "Người thương ơi hỡi người thương!, Đi đâu mà để buồng hương lạnh lùng?" (ca dao)',
    example:
      'Người thương ơi hỡi người thương!, Đi đâu mà để buồng hương lạnh lùng?" (ca dao)',
  },
  {
    word: "buồng khuê",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) phòng riêng của phụ nữ con nhà quyền quý thời xưa: "Xót mình cửa các buồng khuê, Vỡ lòng, học lấy những nghề nghiệp hay!" (TKiều)',
    example:
      'Xót mình cửa các buồng khuê, Vỡ lòng, học lấy những nghề nghiệp hay!" (TKiều)',
  },
  {
    word: "buông lỏng",
    part_of_speech: "động từ",
    meaning:
      "không siết chặt, không kiềm giữ, để cho lỏng lẻo, tự do: buông lỏng dây cương * kỉ luật bị buông lỏng",
    example: "buông lỏng dây cương * kỉ luật bị buông lỏng",
  },
  {
    word: "buông lơi",
    part_of_speech: "động từ",
    meaning:
      "thả lỏng, nới lỏng, không nắm giữ được chặt chẽ và thường xuyên: tóc buông lơi * buông lơi mình vào cờ bạc, rượu chè",
    example: "tóc buông lơi * buông lơi mình vào cờ bạc, rượu chè",
  },
  {
    word: "buồng lái",
    part_of_speech: "danh từ",
    meaning:
      "buồng dành cho người lái trong một số phương tiện vận tải, máy móc: buồng lái của máy bay",
    example: "buồng lái của máy bay",
  },
  {
    word: "buồng máy",
    part_of_speech: "danh từ",
    meaning:
      "buồng đặt máy khởi động trong một số phương tiện vận tải, thiết bị: buồng máy tàu thuỷ",
    example: "buồng máy tàu thuỷ",
  },
  {
    word: "buông tha",
    part_of_speech: "động từ",
    meaning:
      "không giữ nữa mà để cho được tự do: con thú không chịu buông tha con mồi",
    example: "con thú không chịu buông tha con mồi",
  },
  {
    word: "buông tha",
    part_of_speech: "động từ",
    meaning:
      "để cho thoát ra khỏi, không còn liên hệ hay tác động đến nữa: sự khốn khó không chịu buông tha hắn",
    example: "sự khốn khó không chịu buông tha hắn",
  },
  {
    word: "buông thả",
    part_of_speech: "động từ",
    meaning:
      "thả lỏng hoàn toàn, để cho tự do, không giữ gìn, hạn chế: lối sống buông thả",
    example: "lối sống buông thả",
  },
  {
    word: "buồng the",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) như buồng khuê: "Buồng the phải buổi thong dong, Thang lan rủ bức trướng hồng tắm hoa." (TKiều)',
    example:
      'Buồng the phải buổi thong dong, Thang lan rủ bức trướng hồng tắm hoa." (TKiều)',
  },
  {
    word: "buồng thêu",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) như buồng khuê: "Nàng thì vội trở buồng thêu, Sinh thì dạo gót sân đào bước ra." (TKiều)',
    example:
      'Nàng thì vội trở buồng thêu, Sinh thì dạo gót sân đào bước ra." (TKiều)',
  },
  {
    word: "buồng tối",
    part_of_speech: "danh từ",
    meaning:
      "buồng kín trong khí cụ quang học, chỉ cho ánh sáng lọt vào khi khí cụ hoạt động: buồng tối của máy ảnh",
    example: "buồng tối của máy ảnh",
  },
  {
    word: "buông thõng",
    part_of_speech: "động từ",
    meaning:
      "để cho thõng xuống: hai tay buông thõng trên đầu gối * tóc buông thõng sau lưng",
    example: "hai tay buông thõng trên đầu gối * tóc buông thõng sau lưng",
  },
  {
    word: "buông thõng",
    part_of_speech: "động từ",
    meaning: "(hiếm) như buông xõng: buông thõng một câu",
    example: "buông thõng một câu",
  },
  {
    word: "buông trôi",
    part_of_speech: "động từ",
    meaning:
      "không tác động đến nữa, để mặc muốn ra sao thì ra: buông trôi công việc * can thiệp không được, bèn buông trôi",
    example: "buông trôi công việc * can thiệp không được, bèn buông trôi",
  },
  {
    word: "buông xõng",
    part_of_speech: "động từ",
    meaning:
      "nói mấy tiếng ngắn cụt, với giọng hơi xẵng: nói buông xõng * chỉ buông xõng một câu",
    example: "nói buông xõng * chỉ buông xõng một câu",
  },
  {
    word: "buông tuồng",
    part_of_speech: "tính từ",
    meaning:
      "tự do bừa bãi, không chút giữ gìn trong cách sống: sống buông tuồng * ăn nói buông tuồng, thiếu ý tứ",
    example: "sống buông tuồng * ăn nói buông tuồng, thiếu ý tứ",
  },
  {
    word: "buông xuôi",
    part_of_speech: "động từ",
    meaning:
      "bỏ mặc không can thiệp đến, để cho sự việc tiếp tục diễn biến theo chiều hướng xấu: chán nản bèn buông xuôi tất cả",
    example: "chán nản bèn buông xuôi tất cả",
  },
  {
    word: "búp",
    part_of_speech: "danh từ",
    meaning: "chồi non của cây: búp ổi * chè đâm búp tua tủa",
    example: "búp ổi * chè đâm búp tua tủa",
  },
  {
    word: "búp",
    part_of_speech: "danh từ",
    meaning:
      '(hiếm) nụ hoa sắp hé nở, hình búp: búp sen * "Gió đưa gió đẩy bông trang, Bông búp về nàng bông nở về anh." (ca dao)',
    example:
      'búp sen * "Gió đưa gió đẩy bông trang, Bông búp về nàng bông nở về anh." (ca dao)',
  },
  {
    word: "búp",
    part_of_speech: "danh từ",
    meaning:
      "vật có hình thon, nhọn đầu, tựa như hình búp: búp len * ngón tay búp măng * những búp tóc loăn xoăn",
    example: "búp len * ngón tay búp măng * những búp tóc loăn xoăn",
  },
  {
    word: "buốt",
    part_of_speech: "tính từ",
    meaning:
      "có cảm giác đau nhức, như thấm sâu đến tận xương (do rét hoặc do vết thương gây nên): buốt như kim châm * trời lạnh buốt",
    example: "buốt như kim châm * trời lạnh buốt",
  },
  {
    word: "buột",
    part_of_speech: "động từ",
    meaning:
      "tuột ra, rời ra một cách tự nhiên, không giữ lại được: xe đạp buột xích * thằng bé buột khỏi tay mẹ",
    example: "xe đạp buột xích * thằng bé buột khỏi tay mẹ",
  },
  {
    word: "buột tay",
    part_of_speech: "động từ",
    meaning:
      "để rơi khỏi tay một cách tự nhiên hoặc do vô ý: buột tay đánh rơi cái chén",
    example: "buột tay đánh rơi cái chén",
  },
  {
    word: "bụt",
    part_of_speech: "danh từ",
    meaning: "Phật, theo cách gọi dân gian: hiền như bụt",
    example: "hiền như bụt",
  },
  {
    word: "bụt",
    part_of_speech: "danh từ",
    meaning:
      'râm bụt (nói tắt): "Hoa bụt mọc trước cửa chùa, Đỏ thì có đỏ, tứ mùa không thơm." (ca dao)',
    example:
      'Hoa bụt mọc trước cửa chùa, Đỏ thì có đỏ, tứ mùa không thơm." (ca dao)',
  },
  {
    word: "búp phê",
    part_of_speech: "danh từ",
    meaning: "tủ để các đồ dùng vào việc ăn uống, v.v.: tủ búp phê",
    example: "tủ búp phê",
  },
  {
    word: "buột miệng",
    part_of_speech: "động từ",
    meaning:
      "thốt ra một cách bột phát, không kịp kìm nén lại: buột miệng kêu đau * muốn giấu nhưng buột miệng nói ra mất",
    example: "buột miệng kêu đau * muốn giấu nhưng buột miệng nói ra mất",
  },
  {
    word: "bút chiến",
    part_of_speech: "động từ",
    meaning:
      "tranh luận trên sách báo, thường là gay gắt (với người có quan điểm đối lập): trận bút chiến",
    example: "trận bút chiến",
  },
  {
    word: "bút chì",
    part_of_speech: "danh từ",
    meaning:
      "bút có ruột là một thỏi than chì hoặc chất màu, vỏ thường bằng gỗ: gọt bút chì * hộp bút chì màu",
    example: "gọt bút chì * hộp bút chì màu",
  },
  {
    word: "bút",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng để viết, kẻ, vẽ thành nét: ngòi bút * đặt bút kí tên * nghề cầm bút (nghề viết văn)",
    example: "ngòi bút * đặt bút kí tên * nghề cầm bút (nghề viết văn)",
  },
  {
    word: "bút đàm",
    part_of_speech: "động từ",
    meaning:
      "trao đổi ý kiến với nhau bằng cách viết chữ: bút đàm với người điếc",
    example: "bút đàm với người điếc",
  },
  {
    word: "bút danh",
    part_of_speech: "danh từ",
    meaning:
      "tên riêng tác giả dùng để kí vào tác phẩm của mình khi viết văn, viết bài: kí tên thật, không dùng bút danh",
    example: "kí tên thật, không dùng bút danh",
  },
  {
    word: "bút hiệu",
    part_of_speech: "danh từ",
    meaning:
      "tên riêng dùng để ghi tên tác giả khi viết, vẽ: Hoàng Ngọc Phách có bút hiệu Song An",
    example: "Hoàng Ngọc Phách có bút hiệu Song An",
  },
  {
    word: "bút lực",
    part_of_speech: "danh từ",
    meaning:
      "sức viết, vẽ; dùng để chỉ khả năng viết văn, vẽ tranh: bút lực tài tình",
    example: "bút lực tài tình",
  },
  {
    word: "bụt mọc",
    part_of_speech: "danh từ",
    meaning:
      "cây hạt trần cỡ lớn, rễ có những nhánh đâm thẳng lên khỏi mặt đất, trông như tượng Phật, trồng để làm cảnh.",
    example: "ngồi như bụt mọc",
  },
  {
    word: "bút pháp",
    part_of_speech: "danh từ",
    meaning:
      "cách dùng các phương tiện biểu hiện (ngôn ngữ hoặc đường nét, màu sắc, hình khối, v.v.) để phản ánh hiện thực, thể hiện tư tưởng trong tác phẩm nghệ thuật: tác giả đã sử dụng bút pháp tả thực",
    example: "tác giả đã sử dụng bút pháp tả thực",
  },
  {
    word: "bút nghiên",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) bút lông và nghiên mực của người viết chữ Hán thời trước; dùng để chỉ chung việc học tập, sự nghiệp văn chương: theo đòi bút nghiên * "Chàng tuổi trẻ vốn dòng hào kiệt, Xếp bút nghiên theo việc đao cung." (CPN)',
    example:
      'theo đòi bút nghiên * "Chàng tuổi trẻ vốn dòng hào kiệt, Xếp bút nghiên theo việc đao cung." (CPN)',
  },
  {
    word: "bút tích",
    part_of_speech: "danh từ",
    meaning:
      "nét chữ viết, bản viết tay của một người nào đó còn để lại, thường là sau khi chết: còn lưu giữ được bút tích của nhà văn",
    example: "còn lưu giữ được bút tích của nhà văn",
  },
  {
    word: "bự",
    part_of_speech: "tính từ",
    meaning:
      "dày thêm một lớp bên ngoài và có vẻ to lên (thường nói về da mặt; hàm ý chê): mặt bự phấn",
    example: "mặt bự phấn",
  },
  {
    word: "bự",
    part_of_speech: "tính từ",
    meaning: "(Phương ngữ) to, lớn: trái xoài bự * một thương gia cỡ bự",
    example: "trái xoài bự * một thương gia cỡ bự",
  },
  {
    word: "bựa",
    part_of_speech: "danh từ",
    meaning:
      "vật nhỏ còn sót lại của cái gì, trở thành lớp chất bẩn bám vào một nơi nào đó (thường nói về lớp chất bẩn bám ở chân răng): răng đầy bựa",
    example: "răng đầy bựa",
  },
  {
    word: "bứ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có cảm giác đầy ứ, chán ngấy, vì ăn uống quá nhiều: ăn nhiều trứng cũng thấy bứ",
    example: "ăn nhiều trứng cũng thấy bứ",
  },
  {
    word: "bứ bừ",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như bứ (nhưng nghĩa nhấn mạnh hơn): say bứ bừ",
    example: "say bứ bừ",
  },
  {
    word: "bửa",
    part_of_speech: "động từ",
    meaning:
      "dùng tay làm cho tách ra thành nhiều phần: bửa chiếc bánh làm đôi * bửa quả na",
    example: "bửa chiếc bánh làm đôi * bửa quả na",
  },
  {
    word: "bửa",
    part_of_speech: "tính từ",
    meaning:
      "(Thông tục) ngang bướng, trái với lí lẽ, với khuôn phép: nói bửa * ăn chằng vay bửa * tính rất bửa!",
    example: "nói bửa * ăn chằng vay bửa * tính rất bửa!",
  },
  {
    word: "bứ bự",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như bứ bừ: ăn no bứ bự",
    example: "ăn no bứ bự",
  },
  {
    word: "bừa bãi",
    part_of_speech: "tính từ",
    meaning: "bừa (nói khái quát): giấy má vứt bừa bãi * nói năng bừa bãi",
    example: "giấy má vứt bừa bãi * nói năng bừa bãi",
  },
  {
    word: "bừa bộn",
    part_of_speech: "tính từ",
    meaning:
      "nhiều và ngổn ngang, không có trật tự: nhà cửa để bừa bộn * giấy má vứt bừa bộn trên bàn",
    example: "nhà cửa để bừa bộn * giấy má vứt bừa bộn trên bàn",
  },
  {
    word: "bừa",
    part_of_speech: "danh từ",
    meaning:
      "nông cụ dùng sức kéo để làm nhỏ, làm nhuyễn đất, san phẳng ruộng hoặc làm sạch cỏ: kéo bừa * vác bừa ra đồng",
    example: "kéo bừa * vác bừa ra đồng",
  },
  {
    word: "bừa",
    part_of_speech: "động từ",
    meaning:
      "làm nhỏ, làm nhuyễn đất, san phẳng ruộng hoặc làm sạch cỏ bằng cái bừa: bừa cho chết cỏ",
    example: "bừa cho chết cỏ",
  },
  {
    word: "bừa",
    part_of_speech: "tính từ",
    meaning:
      "không có trật tự, không kể gì trật tự: giấy má vứt bừa ra nhà * nhà cửa để bừa, không chịu dọn",
    example: "giấy má vứt bừa ra nhà * nhà cửa để bừa, không chịu dọn",
  },
  {
    word: "bừa",
    part_of_speech: "tính từ",
    meaning:
      "liều, không kể gì hậu quả, đúng sai, chỉ cốt làm cho xong: tự ý làm bừa * không biết nhưng cứ nói bừa",
    example: "tự ý làm bừa * không biết nhưng cứ nói bừa",
  },
  {
    word: "bữa",
    part_of_speech: "danh từ",
    meaning:
      "tổng thể nói chung những thức ăn uống cùng một lần vào một lúc nhất định, theo lệ thường: bữa cơm * làm bữa thịt chó",
    example: "bữa cơm * làm bữa thịt chó",
  },
  {
    word: "bữa",
    part_of_speech: "danh từ",
    meaning:
      "lần ăn uống thường lệ trong ngày: ngày ăn ba bữa * ăn uống linh tinh, không ra bữa",
    example: "ngày ăn ba bữa * ăn uống linh tinh, không ra bữa",
  },
  {
    word: "bữa",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) lần, phen phải chịu đựng việc gì: bị một bữa no đòn * phải một bữa đói",
    example: "bị một bữa no đòn * phải một bữa đói",
  },
  {
    word: "bữa",
    part_of_speech: "danh từ",
    meaning: "(Khẩu ngữ) hôm: bữa trước tôi bận * bữa nào rỗi mời anh qua chơi",
    example: "bữa trước tôi bận * bữa nào rỗi mời anh qua chơi",
  },
  {
    word: "bữa đực bữa cái",
    part_of_speech: "",
    meaning: "(khẩu ngữ) như buổi đực buổi cái: đi học bữa đực bữa cái",
    example: "đi học bữa đực bữa cái",
  },
  {
    word: "bữa kia",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ, khẩu ngữ) ngày sắp tới, cách ngày hôm nay hai ngày, sau mai và mốt: bữa nay đi, đến bữa kia sẽ tới",
    example: "bữa nay đi, đến bữa kia sẽ tới",
  },
  {
    word: "bữa kia",
    part_of_speech: "danh từ",
    meaning:
      "ngày nào đó không nói rõ, trong quá khứ, về mặt có những gì đã xảy ra: bữa kia có người lạ mặt đến làng",
    example: "bữa kia có người lạ mặt đến làng",
  },
  {
    word: "bừa phứa",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) bừa bãi, bất chấp, không kể gì hết (nói khái quát): thức ăn bừa phứa trên bàn",
    example: "thức ăn bừa phứa trên bàn",
  },
  {
    word: "bữa mai",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) ngày mai: việc này bữa mai sẽ xong",
    example: "việc này bữa mai sẽ xong",
  },
  {
    word: "bữa nay",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) hôm nay: bữa nay không xong thì để bữa mai",
    example: "bữa nay không xong thì để bữa mai",
  },
  {
    word: "bực",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) bậc: bực thềm * bực tiểu học",
    example: "bực thềm * bực tiểu học",
  },
  {
    word: "bực",
    part_of_speech: "động từ",
    meaning:
      "khó chịu vì không theo ý, không được như ý: đợi lâu phát bực * bực cả mình",
    example: "đợi lâu phát bực * bực cả mình",
  },
  {
    word: "bức bách",
    part_of_speech: "động từ",
    meaning: "dùng áp lực thúc giục: bị bức bách phải làm",
    example: "bị bức bách phải làm",
  },
  {
    word: "bức bách",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) (việc) đòi hỏi phải được giải quyết ngay, không cho phép trì hoãn: công việc bức bách, phải được ưu tiên giải quyết",
    example: "công việc bức bách, phải được ưu tiên giải quyết",
  },
  {
    word: "bức",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị vật hình tấm, trên bề mặt có tranh ảnh, chữ viết: bức thư * đánh một bức điện * bức tranh * vẽ một bức chân dung",
    example: "bức thư * đánh một bức điện * bức tranh * vẽ một bức chân dung",
  },
  {
    word: "bức",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị vật có bề mặt thường là hình chữ nhật, dùng để che chắn: bức tường * bức vách * bức bình phong",
    example: "bức tường * bức vách * bức bình phong",
  },
  {
    word: "bức",
    part_of_speech: "động từ",
    meaning:
      "làm cho bị dồn vào thế bắt buộc phải làm điều hoàn toàn trái với ý muốn: bức địch ra hàng",
    example: "bức địch ra hàng",
  },
  {
    word: "bức",
    part_of_speech: "tính từ",
    meaning: "nóng ngột ngạt, rất khó chịu: trời bức quá!",
    example: "trời bức quá!",
  },
  {
    word: "bức bối",
    part_of_speech: "tính từ",
    meaning: "bức (nói khái quát): thời tiết nóng nực, bức bối",
    example: "thời tiết nóng nực, bức bối",
  },
  {
    word: "bức bối",
    part_of_speech: "tính từ",
    meaning: "khó chịu, bực dọc trong người: bức bối trong lòng",
    example: "bức bối trong lòng",
  },
  {
    word: "bức cung",
    part_of_speech: "động từ",
    meaning:
      "cưỡng bức phải khai như ý muốn của người hỏi cung: phạm tội bức cung",
    example: "phạm tội bức cung",
  },
  {
    word: "bực bõ",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) như bực bội: có điều bực bõ trong lòng",
    example: "có điều bực bõ trong lòng",
  },
  {
    word: "bực dọc",
    part_of_speech: "động từ",
    meaning:
      "bực tức đến mức không chịu được, lộ rõ ở nét mặt, cử chỉ: tỏ vẻ bực dọc * nói ra cho nhẹ nỗi bực dọc trong lòng",
    example: "tỏ vẻ bực dọc * nói ra cho nhẹ nỗi bực dọc trong lòng",
  },
  {
    word: "bực bội",
    part_of_speech: "động từ",
    meaning:
      "bực tức, khó chịu vì không vừa ý mà không làm gì được: người ốm đau, dễ sinh bực bội * mặt thoáng vẻ bực bội",
    example: "người ốm đau, dễ sinh bực bội * mặt thoáng vẻ bực bội",
  },
  {
    word: "bức hiếp",
    part_of_speech: "động từ",
    meaning: "cưỡng bức, uy hiếp: bị địch tra khảo, bức hiếp",
    example: "bị địch tra khảo, bức hiếp",
  },
  {
    word: "bức hôn",
    part_of_speech: "động từ",
    meaning:
      "cưỡng bức phải kết hôn với người nào đó (thường nói về phụ nữ): bị bức hôn",
    example: "bị bức hôn",
  },
  {
    word: "bực tức",
    part_of_speech: "động từ",
    meaning:
      "bực và tức giận: nét mặt hầm hầm như bực tức chuyện gì * không kìm được nỗi bực tức trong lòng",
    example:
      "nét mặt hầm hầm như bực tức chuyện gì * không kìm được nỗi bực tức trong lòng",
  },
  {
    word: "bức thiết",
    part_of_speech: "tính từ",
    meaning:
      "rất cần thiết, đến mức không thể trì hoãn: việc bức thiết * yêu cầu bức thiết",
    example: "việc bức thiết * yêu cầu bức thiết",
  },
  {
    word: "bực mình",
    part_of_speech: "động từ",
    meaning:
      "bực trong lòng, khó chịu trong lòng: gặp chuyện bực mình * nghe nó nói mà bực mình",
    example: "gặp chuyện bực mình * nghe nó nói mà bực mình",
  },
  {
    word: "bức xạ",
    part_of_speech: "danh từ",
    meaning:
      "sóng điện từ phát ra từ một vật: bức xạ của mặt trời * bức xạ nhiệt * bức xạ điện từ",
    example: "bức xạ của mặt trời * bức xạ nhiệt * bức xạ điện từ",
  },
  {
    word: "bức xúc",
    part_of_speech: "tính từ",
    meaning:
      "hết sức cấp bách, đòi hỏi phải sớm được giải quyết: ma tuý là vấn đề bức xúc của toàn xã hội",
    example: "ma tuý là vấn đề bức xúc của toàn xã hội",
  },
  {
    word: "bưng",
    part_of_speech: "danh từ",
    meaning:
      'vùng đồng lầy ngập nước, mọc nhiều cỏ lác (thường có ở miền Nam): "Trắng da vì bởi má cưng, Đen da vì bởi lội bưng vớt bèo." (ca dao)',
    example:
      'Trắng da vì bởi má cưng, Đen da vì bởi lội bưng vớt bèo." (ca dao)',
  },
  {
    word: "bưng",
    part_of_speech: "động từ",
    meaning:
      "cầm đưa ngang tầm ngực hoặc bụng, thường bằng cả hai tay: tay bưng chén nước * cơm bưng nước rót",
    example: "tay bưng chén nước * cơm bưng nước rót",
  },
  {
    word: "bưng",
    part_of_speech: "động từ",
    meaning:
      'che, bịt bằng bàn tay hoặc bằng một lớp mỏng và căng: bưng miệng cười * bưng mặt khóc * "Nghĩ đà bưng kín miệng bình, Nào ai có khảo mà mình lại xưng?" (TKiều)',
    example:
      'bưng miệng cười * bưng mặt khóc * "Nghĩ đà bưng kín miệng bình, Nào ai có khảo mà mình lại xưng?" (TKiều)',
  },
  {
    word: "bửng",
    part_of_speech: "danh từ",
    meaning: "tảng đất lẫn đá kết dính với nhau không chặt lắm: bửng đất",
    example: "bửng đất",
  },
  {
    word: "bửng",
    part_of_speech: "danh từ",
    meaning: "khối đất lớn bọc quanh gốc, rễ một cây: đánh cả bửng",
    example: "đánh cả bửng",
  },
  {
    word: "bựng",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) khối to và đặc kết chặt với nhau: bựng khói * bựng lửa",
    example: "bựng khói * bựng lửa",
  },
  {
    word: "bưng bít",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) che bịt kín, làm cho ngăn cách hẳn với bên ngoài: tường cao bưng bít xung quanh",
    example: "tường cao bưng bít xung quanh",
  },
  {
    word: "bưng bít",
    part_of_speech: "động từ",
    meaning:
      'giấu giếm, giữ kín không để lộ ra: bưng bít thông tin * "Lại còn bưng bít giấu quanh, Làm chi những thói trẻ ranh nực cười!" (TKiều)',
    example:
      'bưng bít thông tin * "Lại còn bưng bít giấu quanh, Làm chi những thói trẻ ranh nực cười!" (TKiều)',
  },
  {
    word: "bừng bừng",
    part_of_speech: "tính từ",
    meaning:
      "rực lên, bốc lên rất mạnh, đến mức có thể thấy được hoặc cảm nhận được rõ ràng: bừng bừng khí thế",
    example: "bừng bừng khí thế",
  },
  {
    word: "bứng",
    part_of_speech: "động từ",
    meaning:
      "đào cây với cả bầu đất xung quanh rễ để chuyển đi trồng ở nơi khác: bứng cây",
    example: "bứng cây",
  },
  {
    word: "bừng",
    part_of_speech: "động từ",
    meaning:
      "chuyển trạng thái đột ngột từ không có biểu hiện gì trở thành có những biểu hiện rõ rệt và mạnh mẽ: mặt đỏ bừng * sáng bừng lên",
    example: "mặt đỏ bừng * sáng bừng lên",
  },
  {
    word: "bừng",
    part_of_speech: "động từ",
    meaning:
      'chuyển trạng thái đột ngột, từ đang ngủ sang tỉnh hẳn dậy: bừng tỉnh giấc * "Giấc Nam Kha khéo bất bình, Bừng con mắt dậy thấy mình tay không." (CO)',
    example:
      'bừng tỉnh giấc * "Giấc Nam Kha khéo bất bình, Bừng con mắt dậy thấy mình tay không." (CO)',
  },
  {
    word: "bưng kín miệng bình",
    part_of_speech: "",
    meaning:
      'ví hành động giấu giếm khuyết điểm của mình, không để hở ra, để lộ ra: "Ai ơi chớ vội khoe mình, Dễ mà bưng kín miệng bình được sao." (ca dao)',
    example:
      'Ai ơi chớ vội khoe mình, Dễ mà bưng kín miệng bình được sao." (ca dao)',
  },
  {
    word: "bước",
    part_of_speech: "động từ",
    meaning:
      "đặt chân tới một chỗ khác để di chuyển thân thể theo: bước vào nhà * bước lên một bước * bước sang phải",
    example: "bước vào nhà * bước lên một bước * bước sang phải",
  },
  {
    word: "bước",
    part_of_speech: "động từ",
    meaning: "chuyển giai đoạn: bước vào năm học mới * bước sang tuổi mười tám",
    example: "bước vào năm học mới * bước sang tuổi mười tám",
  },
  {
    word: "bước",
    part_of_speech: "danh từ",
    meaning: "động tác bước đi: cất bước * thả bước đi dạo * cản bước",
    example: "cất bước * thả bước đi dạo * cản bước",
  },
  {
    word: "bước",
    part_of_speech: "danh từ",
    meaning:
      "khoảng cách giữa hai bàn chân khi bước: đi được mươi bước thì quay lại * bước lên một bước",
    example: "đi được mươi bước thì quay lại * bước lên một bước",
  },
  {
    word: "bước",
    part_of_speech: "danh từ",
    meaning:
      "giai đoạn, phần chia nhỏ của một quá trình: bước khởi đầu * công việc được tiến hành từng bước",
    example: "bước khởi đầu * công việc được tiến hành từng bước",
  },
  {
    word: "bước",
    part_of_speech: "danh từ",
    meaning:
      "hoàn cảnh không hay gặp phải, coi như một giai đoạn nhỏ trong cuộc đời: gặp bước gian truân * lâm vào bước khó khăn",
    example: "gặp bước gian truân * lâm vào bước khó khăn",
  },
  {
    word: "bước đầu",
    part_of_speech: "danh từ",
    meaning:
      "giai đoạn đầu của một quá trình nào đó (còn chưa kết thúc): kết quả bước đầu * thử thách bước đầu * bước đầu tiếp cận vấn đề",
    example: "kết quả bước đầu * thử thách bước đầu * bước đầu tiếp cận vấn đề",
  },
  {
    word: "bước đi",
    part_of_speech: "danh từ",
    meaning:
      "bước tiến triển hoặc cách thức thực hiện qua từng giai đoạn: công ti có nhiều bước đi táo bạo * bước đi vững chắc của phong trào",
    example:
      "công ti có nhiều bước đi táo bạo * bước đi vững chắc của phong trào",
  },
  {
    word: "bước thấp bước cao",
    part_of_speech: "",
    meaning:
      'tả dáng đi không vững, chân bước không đều (do vội vàng hay sợ hãi điều gì): "Một mình khôn biết làm sao, Dặm rừng bước thấp bước cao hãi hùng." (TKiều)',
    example:
      'Một mình khôn biết làm sao, Dặm rừng bước thấp bước cao hãi hùng." (TKiều)',
  },
  {
    word: "bước ngoặt",
    part_of_speech: "danh từ",
    meaning:
      "sự thay đổi quan trọng, căn bản, đánh dấu sự chuyển hẳn từ giai đoạn, tình thế này sang một giai đoạn, tình thế khác: bước ngoặt lịch sử * một quyết định có tính bước ngoặt",
    example: "bước ngoặt lịch sử * một quyết định có tính bước ngoặt",
  },
  {
    word: "bước tiến",
    part_of_speech: "danh từ",
    meaning: "sự tiến lên phía trước: chặn bước tiến của địch",
    example: "chặn bước tiến của địch",
  },
  {
    word: "bước tiến",
    part_of_speech: "danh từ",
    meaning:
      "sự tiến bộ trong từng giai đoạn: thắng lợi đã đánh dấu một bước tiến rõ rệt * không theo kịp bước tiến của thời đại",
    example:
      "thắng lợi đã đánh dấu một bước tiến rõ rệt * không theo kịp bước tiến của thời đại",
  },
  {
    word: "bưng tai giả điếc",
    part_of_speech: "",
    meaning:
      'như giả câm giả điếc: "Lời trung khêu ruột gian thần, Bưng tai giả điếc, nổi gân bất bình." (NĐM)',
    example:
      'Lời trung khêu ruột gian thần, Bưng tai giả điếc, nổi gân bất bình." (NĐM)',
  },
  {
    word: "bước đường",
    part_of_speech: "danh từ",
    meaning:
      "đoạn đường đi, giai đoạn trải qua: bước đường công danh * bị dồn tới bước đường cùng",
    example: "bước đường công danh * bị dồn tới bước đường cùng",
  },
  {
    word: "bươi",
    part_of_speech: "động từ",
    meaning:
      "(Nam cũng bươi) xới lên và gạt đi những gì phủ bên trên để tìm lấy cái vùi lấp bên dưới: gà bới rác tìm mồi * đi bới khoai",
    example: "gà bới rác tìm mồi * đi bới khoai",
  },
  {
    word: "bươi",
    part_of_speech: "động từ",
    meaning:
      'moi móc để tìm cho ra, cho thành ra có: bới xấu nhau * bới việc ra cho làm * "Hắn bới ra từng tội một, và nhất định sẽ bới ra đến hết." (NCao; 9)',
    example:
      'bới xấu nhau * bới việc ra cho làm * "Hắn bới ra từng tội một, và nhất định sẽ bới ra đến hết." (NCao; 9)',
  },
  {
    word: "bươi",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) réo tên cha mẹ tổ tiên người ta ra mà chửi: bới cha mẹ người ta ra mà chửi!",
    example: "bới cha mẹ người ta ra mà chửi!",
  },
  {
    word: "bươi",
    part_of_speech: "động từ",
    meaning: "(Nam) xới (cơm): bới một bát cơm đầy",
    example: "bới một bát cơm đầy",
  },
  {
    word: "bươi",
    part_of_speech: "động từ",
    meaning: "mang cái ăn theo khi đi xa nhà: cơm đùm gạo bới",
    example: "cơm đùm gạo bới",
  },
  {
    word: "bươi",
    part_of_speech: "động từ",
    meaning: "(Nam) búi: tóc bới cao",
    example: "tóc bới cao",
  },
  {
    word: "bướm",
    part_of_speech: "danh từ",
    meaning:
      "côn trùng có bốn cánh mỏng, phủ một lớp vảy nhỏ như phấn, nhiều màu, có vòi để hút mật hoa.",
    example: "bắt bướm trừ sâu",
  },
  {
    word: "bướm ong",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, văn chương) như ong bướm: quen thói bướm ong * buông lời bướm ong",
    example: "quen thói bướm ong * buông lời bướm ong",
  },
  {
    word: "bươm",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (rách) tả tơi thành nhiều mảnh: tờ giấy nát bươm * quần áo bươm như xơ mướp",
    example: "tờ giấy nát bươm * quần áo bươm như xơ mướp",
  },
  {
    word: "bướm chán ong chường",
    part_of_speech: "",
    meaning:
      '(văn chương) ví thân phận người phụ nữ bị ruồng bỏ, bị rẻ rúng, vì nhan sắc đã tàn phai, thân xác không còn trong trắng: "Mặt sao dày gió dạn sương, Thân sao bướm chán ong chường bấy thân?" (TKiều)',
    example:
      'Mặt sao dày gió dạn sương, Thân sao bướm chán ong chường bấy thân?" (TKiều)',
  },
  {
    word: "bươm bướm",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) truyền đơn nhỏ: rải bươm bướm giữa chợ",
    example: "rải bươm bướm giữa chợ",
  },
  {
    word: "bươn",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) đi vội, đi nhanh: xăm xăm bươn tới trước * con trâu giật dây mũi bươn chạy",
    example: "xăm xăm bươn tới trước * con trâu giật dây mũi bươn chạy",
  },
  {
    word: "bươn chải",
    part_of_speech: "động từ",
    meaning:
      "vật lộn một cách khó nhọc, vất vả (thường để kiếm sống): cuộc sống bươn chải",
    example: "cuộc sống bươn chải",
  },
  {
    word: "bươn bả",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) vội vàng, tất tả: bươn bả bước đi * bươn bả chuẩn bị cho kịp giờ",
    example: "bươn bả bước đi * bươn bả chuẩn bị cho kịp giờ",
  },
  {
    word: "bương",
    part_of_speech: "danh từ",
    meaning:
      "cây cùng loại với tre, thân to, thẳng, mỏng mình (có nhiều ở miền núi Bắc Bộ): rừng bương * cột bương",
    example: "rừng bương * cột bương",
  },
  {
    word: "bương",
    part_of_speech: "danh từ",
    meaning:
      "ống đựng làm bằng thân cây bương, thường dùng để đựng nước ở một số vùng núi: xách bương đi lấy nước",
    example: "xách bương đi lấy nước",
  },
  {
    word: "bương",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) hỏng hẳn, mất hẳn: gió lớn làm bương mái nhà",
    example: "gió lớn làm bương mái nhà",
  },
  {
    word: "bướng",
    part_of_speech: "tính từ",
    meaning:
      "khó bảo, không chịu nghe lời, cứ một mực theo ý mình: đã sai lại còn cãi bướng * thằng bé bướng lắm!",
    example: "đã sai lại còn cãi bướng * thằng bé bướng lắm!",
  },
  {
    word: "bưởng",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) tập hợp một nhóm khá đông những người đào vàng và đá quý, có kẻ cầm đầu: nhiều chủ bưởng phất lên nhanh chóng",
    example: "nhiều chủ bưởng phất lên nhanh chóng",
  },
  {
    word: "bướng bỉnh",
    part_of_speech: "tính từ",
    meaning: "bướng (nói khái quát): tính nết bướng bỉnh, ương ngạnh",
    example: "tính nết bướng bỉnh, ương ngạnh",
  },
  {
    word: "bứt",
    part_of_speech: "động từ",
    meaning:
      "giật mạnh làm cho đứt rời ra: bứt nắm lá * bứt quả * vò đầu bứt tóc",
    example: "bứt nắm lá * bứt quả * vò đầu bứt tóc",
  },
  {
    word: "bứt",
    part_of_speech: "động từ",
    meaning:
      '(phương ngữ) cắt cỏ, rạ, v.v.: "Thiếp xa chàng hái dâu quên giỏ, Chàng xa thiếp, bứt cỏ quên liềm." (ca dao)',
    example:
      'Thiếp xa chàng hái dâu quên giỏ, Chàng xa thiếp, bứt cỏ quên liềm." (ca dao)',
  },
  {
    word: "bứt",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tách lìa hẳn để đi nơi khác, làm việc khác: bứt lên dẫn đầu đoàn đua * công việc nhiều quá, không bứt ra được",
    example:
      "bứt lên dẫn đầu đoàn đua * công việc nhiều quá, không bứt ra được",
  },
  {
    word: "bướp",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như bươm: chiếc áo rách bướp",
    example: "chiếc áo rách bướp",
  },
  {
    word: "bứt phá",
    part_of_speech: "",
    meaning:
      "vượt hẳn lên, cách xa so với mức độ, giới hạn, v.v., thông thường: khả năng bứt phá của vận động viên * bộ sưu tập thời trang có nhiều bứt phá trong thiết kế",
    example:
      "khả năng bứt phá của vận động viên * bộ sưu tập thời trang có nhiều bứt phá trong thiết kế",
  },
  {
    word: "bướu",
    part_of_speech: "danh từ",
    meaning: "u nổi trên thân thể: cổ nổi bướu * có bướu ở lưng",
    example: "cổ nổi bướu * có bướu ở lưng",
  },
  {
    word: "bướu",
    part_of_speech: "danh từ",
    meaning:
      "chỗ lồi to lên một cách khác thường trên thân cây gỗ: cây gỗ có nhiều mắt bướu",
    example: "cây gỗ có nhiều mắt bướu",
  },
  {
    word: "bươu",
    part_of_speech: "động từ",
    meaning: "sưng thành cục ở đầu, ở trán: bị ngã bươu đầu * bươu đầu mẻ trán",
    example: "bị ngã bươu đầu * bươu đầu mẻ trán",
  },
  {
    word: "bứt rứt",
    part_of_speech: "tính từ",
    meaning:
      "cảm thấy khó chịu không yên trong người, trong lòng: chân tay bứt rứt khó chịu * lòng bứt rứt không yên",
    example: "chân tay bứt rứt khó chịu * lòng bứt rứt không yên",
  },
  {
    word: "bưu kiện",
    part_of_speech: "danh từ",
    meaning: "kiện hàng gửi qua bưu điện: giấy báo nhận bưu kiện",
    example: "giấy báo nhận bưu kiện",
  },
  {
    word: "bưu điện",
    part_of_speech: "danh từ",
    meaning:
      "phương thức thông tin, liên lạc bằng thư từ, điện báo, điện thoại, v.v. do một cơ quan chuyên môn đảm nhiệm: nghiệp vụ bưu điện",
    example: "nghiệp vụ bưu điện",
  },
  {
    word: "bưu điện",
    part_of_speech: "danh từ",
    meaning:
      "cơ quan đảm nhiệm việc chuyển thư từ, điện báo, điện thoại, v.v.: nhận bưu kiện ở bưu điện * gửi thư qua đường bưu điện",
    example: "nhận bưu kiện ở bưu điện * gửi thư qua đường bưu điện",
  },
  {
    word: "bưu thiếp",
    part_of_speech: "danh từ",
    meaning: "thiếp dùng để gửi qua bưu điện: gửi bưu thiếp chúc mừng năm mới",
    example: "gửi bưu thiếp chúc mừng năm mới",
  },
  {
    word: "c",
    part_of_speech: "",
    meaning: "chữ số La Mã: 100.",
    example: "nước sôi ở 1000oC",
  },
  {
    word: "c",
    part_of_speech: "",
    meaning: "coulomb (viết tắt).",
    example: "hàng loại C",
  },
  {
    word: "thiếu sót",
    part_of_speech: "",
    meaning:
      "điều còn thiếu, còn có sai sót hoặc khiếm khuyết (nói khái quát): khắc phục kịp thời những thiếu sót * số liệu cập nhật còn thiếu sót",
    example:
      "khắc phục kịp thời những thiếu sót * số liệu cập nhật còn thiếu sót",
  },
  {
    word: "thiêu thân",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi chung loài bọ cánh nửa và bọ nhỏ có cánh, ban đêm thường bay vào lửa mà chết cháy: lao vào chỗ chết như con thiêu thân",
    example: "lao vào chỗ chết như con thiêu thân",
  },
  {
    word: "thiểu số",
    part_of_speech: "danh từ",
    meaning:
      "phần nhỏ, số ít trong tổng thể một tập hợp hoặc một số đông; phân biệt với đa số: thiểu số phục tùng đa số * số người phản đối chỉ là thiểu số",
    example: "thiểu số phục tùng đa số * số người phản đối chỉ là thiểu số",
  },
  {
    word: "thiểu số",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) dân tộc thiểu số (nói tắt): chính sách đối với đồng bào thiểu số",
    example: "chính sách đối với đồng bào thiểu số",
  },
  {
    word: "thiếu thời",
    part_of_speech: "danh từ",
    meaning: "thời kì còn bé, còn đang ở độ tuổi thiếu niên: thuở thiếu thời",
    example: "thuở thiếu thời",
  },
  {
    word: "thiếu thốn",
    part_of_speech: "",
    meaning:
      "thiếu nhiều so với nhu cầu (nói khái quát): thiếu thốn tiền bạc * ăn uống thiếu thốn * thiếu thốn tình cảm",
    example: "thiếu thốn tiền bạc * ăn uống thiếu thốn * thiếu thốn tình cảm",
  },
  {
    word: "thím",
    part_of_speech: "danh từ",
    meaning: "vợ của chú (có thể dùng để xưng gọi): chú thím * bà thím",
    example: "chú thím * bà thím",
  },
  {
    word: "thiếu vắng",
    part_of_speech: "tính từ",
    meaning:
      "thiếu đi cái vốn là cần thiết, gần gũi, khiến cho có cảm giác như bị trống vắng: thiếu vắng bàn tay chăm sóc của mẹ",
    example: "thiếu vắng bàn tay chăm sóc của mẹ",
  },
  {
    word: "thin thít",
    part_of_speech: "tính từ",
    meaning:
      "im lặng hoàn toàn, không nói năng hay cử động gì: im thin thít * thin thít như thịt nấu đông (tng)",
    example: "im thin thít * thin thít như thịt nấu đông (tng)",
  },
  {
    word: "thính",
    part_of_speech: "danh từ",
    meaning:
      "bột làm bằng gạo hoặc ngô rang giã nhỏ, có mùi thơm, thường dùng để chế biến thức ăn (làm mắm, trộn nem, v.v.): món tai lợn luộc trộn thính",
    example: "món tai lợn luộc trộn thính",
  },
  {
    word: "thính",
    part_of_speech: "danh từ",
    meaning:
      "cám rang, thường dùng để làm mồi nhử tôm cá hoặc có thể dùng để ăn thay cho cơm gạo trong lúc đói kém: rang thính * thả thính",
    example: "rang thính * thả thính",
  },
  {
    word: "thính",
    part_of_speech: "tính từ",
    meaning:
      "(giác quan) rất nhạy và tinh trong việc nhận biết các âm thanh và mùi: con chó săn có cái mũi rất thính * tai thính * bọn mật thám rất thính với mọi tin tức (b)",
    example:
      "con chó săn có cái mũi rất thính * tai thính * bọn mật thám rất thính với mọi tin tức (b)",
  },
  {
    word: "thỉnh",
    part_of_speech: "động từ",
    meaning: "(trang trọng) đánh (chuông): thỉnh chuông",
    example: "thỉnh chuông",
  },
  {
    word: "thìn",
    part_of_speech: "danh từ",
    meaning:
      "(thường viết hoa) kí hiệu thứ năm trong địa chi (lấy rồng làm tượng trưng; sau mão, trước tị), dùng trong phép đếm thời gian cổ truyền của Trung Quốc và một số nước châu á, trong đó có Việt Nam: giờ thìn (từ 7 đến 9 giờ sáng) * năm Canh Thìn",
    example: "giờ thìn (từ 7 đến 9 giờ sáng) * năm Canh Thìn",
  },
  {
    word: "thỉnh cầu",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) cầu xin điều gì đó với người bề trên có quyền thế: lời thỉnh cầu được chấp thuận",
    example: "lời thỉnh cầu được chấp thuận",
  },
  {
    word: "thính giả",
    part_of_speech: "danh từ",
    meaning:
      "(trang trọng) người nghe biểu diễn các loại hình âm nhạc, hoặc nghe diễn thuyết, v.v: thính giả đến nghe hoà nhạc * thính giả của đài tiếng nói Việt Nam",
    example:
      "thính giả đến nghe hoà nhạc * thính giả của đài tiếng nói Việt Nam",
  },
  {
    word: "thịnh",
    part_of_speech: "",
    meaning:
      "ở trạng thái đang ngày một phát đạt hoặc phát triển tốt đẹp: thế nước đang thịnh * đời nhà Lý, Phật giáo phát triển rất thịnh",
    example: "thế nước đang thịnh * đời nhà Lý, Phật giáo phát triển rất thịnh",
  },
  {
    word: "thình",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng to và rền như tiếng của vật nặng rơi xuống hay tiếng va đập mạnh: khúc gỗ rơi thình xuống đất * đập bàn đánh thình một cái",
    example: "khúc gỗ rơi thình xuống đất * đập bàn đánh thình một cái",
  },
  {
    word: "thính giác",
    part_of_speech: "danh từ",
    meaning:
      "cảm giác nhận biết được các âm thanh, thông qua tai nghe: tai là cơ quan thính giác",
    example: "tai là cơ quan thính giác",
  },
  {
    word: "thỉnh giảng",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) được mời giảng dạy ở một nơi khác, trường khác: giáo viên thỉnh giảng * được mời sang Pháp thỉnh giảng",
    example: "giáo viên thỉnh giảng * được mời sang Pháp thỉnh giảng",
  },
  {
    word: "thỉnh kinh",
    part_of_speech: "động từ",
    meaning:
      "đi xin kinh Phật ở nơi khác (thường là nơi xa) đưa về: thầy trò Đường Tăng sang Tây Trúc thỉnh kinh",
    example: "thầy trò Đường Tăng sang Tây Trúc thỉnh kinh",
  },
  {
    word: "thỉnh giáo",
    part_of_speech: "động từ",
    meaning: "(cũ, trang trọng) xin dạy bảo cho: đến để nhờ cụ thỉnh giáo",
    example: "đến để nhờ cụ thỉnh giáo",
  },
  {
    word: "thinh không",
    part_of_speech: "danh từ",
    meaning:
      "không trung, nơi hoàn toàn vắng lặng: đấm tay vào thinh không * con chim lạc đàn kêu hớt hải giữa thinh không",
    example:
      "đấm tay vào thinh không * con chim lạc đàn kêu hớt hải giữa thinh không",
  },
  {
    word: "thinh không",
    part_of_speech: "phụ từ",
    meaning:
      "(Phương ngữ, Khẩu ngữ) bỗng dưng, khi không: trời đang nắng, thinh không lại đổ mưa",
    example: "trời đang nắng, thinh không lại đổ mưa",
  },
  {
    word: "thính lực",
    part_of_speech: "danh từ",
    meaning: "độ nghe rõ của tai: tuổi càng cao, thính lực càng suy giảm",
    example: "tuổi càng cao, thính lực càng suy giảm",
  },
  {
    word: "thình lình",
    part_of_speech: "phụ từ",
    meaning:
      "(việc gì diễn ra) một cách hết sức bất ngờ, không thể lường trước được: cơn giông thình lình ập tới * chiếc máy bay thình lình bổ nhào",
    example: "cơn giông thình lình ập tới * chiếc máy bay thình lình bổ nhào",
  },
  {
    word: "thịnh suy",
    part_of_speech: "động từ",
    meaning:
      "thịnh vượng hay suy vong (nói khái quát): sự thịnh suy của một triều đại",
    example: "sự thịnh suy của một triều đại",
  },
  {
    word: "thịnh hành",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái đang ngày càng được nhiều người biết đến và ưa chuộng: mốt mới thịnh hành * thể loại nhạc đang thịnh hành trong giới trẻ",
    example:
      "mốt mới thịnh hành * thể loại nhạc đang thịnh hành trong giới trẻ",
  },
  {
    word: "thịnh soạn",
    part_of_speech: "tính từ",
    meaning:
      "(bữa ăn) có nhiều món ngon và được chuẩn bị chu đáo, lịch sự: bữa tiệc thịnh soạn",
    example: "bữa tiệc thịnh soạn",
  },
  {
    word: "thịnh nộ",
    part_of_speech: "động từ",
    meaning: "nổi giận rất dữ dội: nổi cơn thịnh nộ",
    example: "nổi cơn thịnh nộ",
  },
  {
    word: "thỉnh thị",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) xin ý kiến, chỉ thị của cấp trên để giải quyết việc gì: thỉnh thị cấp trên trước khi giải quyết",
    example: "thỉnh thị cấp trên trước khi giải quyết",
  },
  {
    word: "thinh thích",
    part_of_speech: "động từ",
    meaning: "cảm thấy hơi thích: cái đó trông cũng thinh thích",
    example: "cái đó trông cũng thinh thích",
  },
  {
    word: "thình thịch",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng trầm và nặng, phát ra liên tiếp, như tiếng chân giẫm mạnh và đều trên nền đất: tim đập thình thịch * tiếng chân chạy thình thịch trên nền đất",
    example: "tim đập thình thịch * tiếng chân chạy thình thịch trên nền đất",
  },
  {
    word: "thịnh vượng",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái đang phát đạt, giàu có lên: làm ăn thịnh vượng * chúc gia đình an khang, thịnh vượng",
    example: "làm ăn thịnh vượng * chúc gia đình an khang, thịnh vượng",
  },
  {
    word: "thít",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) thắt chặt vào: chiếc áo bó thít vào người * thít sợi dây chằng cho chặt",
    example: "chiếc áo bó thít vào người * thít sợi dây chằng cho chặt",
  },
  {
    word: "thỉnh thoảng",
    part_of_speech: "phụ từ",
    meaning:
      "đôi khi xảy ra, không thường xuyên: hai người thỉnh thoảng mới gặp nhau * cái xe thỉnh thoảng lại hỏng",
    example:
      "hai người thỉnh thoảng mới gặp nhau * cái xe thỉnh thoảng lại hỏng",
  },
  {
    word: "thịnh tình",
    part_of_speech: "danh từ",
    meaning:
      "(trang trọng) tình cảm tốt đẹp trong đối xử, tiếp đón (thường là với khách lạ): cảm ơn tấm thịnh tình",
    example: "cảm ơn tấm thịnh tình",
  },
  {
    word: "thịt thà",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) thịt để ăn (nói khái quát): mâm cơm đạm bạc, không có thịt thà gì",
    example: "mâm cơm đạm bạc, không có thịt thà gì",
  },
  {
    word: "thiu thiu",
    part_of_speech: "tính từ",
    meaning:
      'ở trạng thái mơ màng, đang đi vào giấc ngủ: thiu thiu ngủ * "Sinh vừa tựa án thiu thiu, Giở chiều như tỉnh, giở chiều như mê." (TKiều)',
    example:
      'thiu thiu ngủ * "Sinh vừa tựa án thiu thiu, Giở chiều như tỉnh, giở chiều như mê." (TKiều)',
  },
  {
    word: "thỏ",
    part_of_speech: "danh từ",
    meaning:
      "thú gặm nhấm, tai to và dài, đuôi ngắn, lông dày mượt, nuôi để lấy thịt và lông: nhát như thỏ * mũ lông thỏ",
    example: "nhát như thỏ * mũ lông thỏ",
  },
  {
    word: "thỏ",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) ngọc thỏ (nói tắt): "Hiềm vì ngựa chạy đường xa, Thỏ vừa ló bóng gà đà gáy tan." (LVT)',
    example:
      'Hiềm vì ngựa chạy đường xa, Thỏ vừa ló bóng gà đà gáy tan." (LVT)',
  },
  {
    word: "thiu",
    part_of_speech: "tính từ",
    meaning:
      "(thức ăn uống đã nấu chín) bị biến chất và có mùi khó chịu: cơm thiu * nước chè thiu",
    example: "cơm thiu * nước chè thiu",
  },
  {
    word: "thịt",
    part_of_speech: "danh từ",
    meaning:
      "phần mềm có thớ, bọc quanh xương trong cơ thể người và động vật: thịt lợn * hàng thịt nguýt hàng cá (tng)",
    example: "thịt lợn * hàng thịt nguýt hàng cá (tng)",
  },
  {
    word: "thịt",
    part_of_speech: "danh từ",
    meaning:
      "phần chính ở bên trong lớp vỏ của quả hay vỏ của thân cây: quả xoài cát có thịt thơm và ngọt * vàng tâm là loại gỗ thịt vàng, thớ mịn",
    example:
      "quả xoài cát có thịt thơm và ngọt * vàng tâm là loại gỗ thịt vàng, thớ mịn",
  },
  {
    word: "thịt",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) làm thịt (nói tắt): thịt gà đãi khách",
    example: "thịt gà đãi khách",
  },
  {
    word: "thò",
    part_of_speech: "động từ",
    meaning:
      "đưa một phần hay một bộ phận nào đó ra hẳn phía ngoài vật che chắn, qua một chỗ hở, để cho lộ hẳn ra: thò đầu qua cửa sổ * cây sáo thò ra ngoài miệng túi",
    example: "thò đầu qua cửa sổ * cây sáo thò ra ngoài miệng túi",
  },
  {
    word: "thò",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đưa vào sâu bên trong một vật gì, qua miệng của nó, thường để lấy cái đựng trong đó: thò đũa vào nồi * thò tay vào túi lấy tiền",
    example: "thò đũa vào nồi * thò tay vào túi lấy tiền",
  },
  {
    word: "thọ",
    part_of_speech: "danh từ",
    meaning: "tuổi thọ (nói tắt): mừng thọ * hưởng thọ * chúc thọ ông bà",
    example: "mừng thọ * hưởng thọ * chúc thọ ông bà",
  },
  {
    word: "thỏ bạc",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) mặt trăng: "Lần lần thỏ bạc ác vàng, Xót người trong hội đoạn tràng đòi cơn!" (TKiều)',
    example:
      'Lần lần thỏ bạc ác vàng, Xót người trong hội đoạn tràng đòi cơn!" (TKiều)',
  },
  {
    word: "thó",
    part_of_speech: "động từ",
    meaning: "(thông tục) lấy cắp: bị kẻ cắp thó mất cái ví",
    example: "bị kẻ cắp thó mất cái ví",
  },
  {
    word: "thọ chung",
    part_of_speech: "động từ",
    meaning:
      "(cũ, trang trọng) chết (chỉ nói về người già): ông cụ đã thọ chung",
    example: "ông cụ đã thọ chung",
  },
  {
    word: "thò lò",
    part_of_speech: "động từ",
    meaning: "(nước mũi) chảy ra lòng thòng thành vệt dài: thò lò mũi xanh",
    example: "thò lò mũi xanh",
  },
  {
    word: "thỏ đế",
    part_of_speech: "danh từ",
    meaning:
      "thỏ hoang, tính nhút nhát; thường dùng để ví người rất nhát: nhát như thỏ đế",
    example: "nhát như thỏ đế",
  },
  {
    word: "thỏ lặn ác tà",
    part_of_speech: "",
    meaning:
      '(cũ, văn chương) tả thời gian trôi đi, ngày này qua ngày khác: "Trải bao thỏ lặn, ác tà, ấy mồ vô chủ, ai mà viếng thăm!" (TKiều)',
    example:
      'Trải bao thỏ lặn, ác tà, ấy mồ vô chủ, ai mà viếng thăm!" (TKiều)',
  },
  {
    word: "thoả",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái hoàn toàn hài lòng khi được đúng như đã mong muốn, ước ao: cứ chơi cho thoả * thoả chí bình sinh",
    example: "cứ chơi cho thoả * thoả chí bình sinh",
  },
  {
    word: "thoa",
    part_of_speech: "danh từ",
    meaning:
      '(Từ cũ) trâm cài đầu của phụ nữ thời xưa: "Trên đầu búi tóc vén mai, Hoa cài tả hữu, thoa cài trước sau." (TNNL)',
    example:
      'Trên đầu búi tóc vén mai, Hoa cài tả hữu, thoa cài trước sau." (TNNL)',
  },
  {
    word: "thỏ thẻ",
    part_of_speech: "tính từ",
    meaning:
      "(cách nói năng) nhỏ nhẹ, thong thả và dễ thương (thường chỉ nói về trẻ con hoặc con gái): thỏ thẻ như trẻ lên ba * tiếng oanh thỏ thẻ",
    example: "thỏ thẻ như trẻ lên ba * tiếng oanh thỏ thẻ",
  },
  {
    word: "thoả đáng",
    part_of_speech: "tính từ",
    meaning:
      "đúng đắn và hợp lí: sự việc đã được giải quyết một cách thoả đáng",
    example: "sự việc đã được giải quyết một cách thoả đáng",
  },
  {
    word: "thoả nguyện",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) thoả mãn được điều mong ước: bấy lâu ao ước, giờ đã được thoả nguyện",
    example: "bấy lâu ao ước, giờ đã được thoả nguyện",
  },
  {
    word: "thoả hiệp",
    part_of_speech: "động từ",
    meaning:
      "nhượng bộ trong sự dàn xếp để giải quyết mâu thuẫn, nhằm kết thúc cuộc đấu tranh, cuộc xung đột: không thoả hiệp với kẻ thù",
    example: "không thoả hiệp với kẻ thù",
  },
  {
    word: "thoá mạ",
    part_of_speech: "động từ",
    meaning:
      "thốt ra những lời xúc phạm nặng nề để sỉ nhục: lời thoá mạ * bị người đời thoá mạ",
    example: "lời thoá mạ * bị người đời thoá mạ",
  },
  {
    word: "thoả thích",
    part_of_speech: "tính từ",
    meaning:
      "hoàn toàn được thoả mãn như ý thích, không bị hạn chế: được ăn một bữa thoả thích * vui chơi thoả thích",
    example: "được ăn một bữa thoả thích * vui chơi thoả thích",
  },
  {
    word: "thoả thuận",
    part_of_speech: "động từ",
    meaning:
      "đồng ý với nhau về điều nào đó có quan hệ đến các bên, sau khi đã bàn bạc, trao đổi: thoả thuận phần trăm ăn chia * bán theo giá thoả thuận",
    example: "thoả thuận phần trăm ăn chia * bán theo giá thoả thuận",
  },
  {
    word: "thoả thuận",
    part_of_speech: "danh từ",
    meaning:
      "điều đã đồng ý với nhau, sau khi đã bàn bạc, trao đổi: thực hiện theo thoả thuận * cuộc họp không đi đến một thoả thuận nào",
    example:
      "thực hiện theo thoả thuận * cuộc họp không đi đến một thoả thuận nào",
  },
  {
    word: "thoả thuê",
    part_of_speech: "tính từ",
    meaning:
      "rất thoả, được tha hồ theo như ý muốn (nói khái quát): ăn uống thoả thuê",
    example: "ăn uống thoả thuê",
  },
  {
    word: "thoả thuận khung",
    part_of_speech: "danh từ",
    meaning:
      "thoả thuận của hai hoặc nhiều bên về những điều cơ bản, có tính định hướng chung, từ đó xây dựng những cam kết cụ thể trong từng lĩnh vực, từng giai đoạn: hai nước đã kí một thoả thuận khung về quan hệ hợp tác thương mại",
    example:
      "hai nước đã kí một thoả thuận khung về quan hệ hợp tác thương mại",
  },
  {
    word: "thoái",
    part_of_speech: "động từ",
    meaning:
      "lui trước sự tiến đánh của đối phương hay trước một trở ngại nào đó (nói khái quát): tiến thoái lưỡng nan",
    example: "tiến thoái lưỡng nan",
  },
  {
    word: "thoả mãn",
    part_of_speech: "",
    meaning:
      "cảm thấy hoàn toàn bằng lòng với những cái đạt được, coi là đầy đủ rồi, không còn mong muốn gì hơn: thoả mãn với thành tích của mình",
    example: "thoả mãn với thành tích của mình",
  },
  {
    word: "thoả mãn",
    part_of_speech: "",
    meaning:
      "đáp ứng đầy đủ yêu cầu, điều kiện đặt ra: thoả mãn mọi yêu cầu của khách hàng * thoả mãn đầy đủ các điều kiện",
    example:
      "thoả mãn mọi yêu cầu của khách hàng * thoả mãn đầy đủ các điều kiện",
  },
  {
    word: "thoả ước",
    part_of_speech: "danh từ",
    meaning: "như điều ước: thoả ước hoà bình",
    example: "thoả ước hoà bình",
  },
  {
    word: "thoả ước",
    part_of_speech: "danh từ",
    meaning:
      "văn bản thoả thuận giữa các bên, có ghi rõ trách nhiệm và quyền lợi của từng bên: kí thoả ước lao động tập thể",
    example: "kí thoả ước lao động tập thể",
  },
  {
    word: "thoái chí",
    part_of_speech: "động từ",
    meaning:
      "mất hết ý chí, không còn muốn theo đuổi việc đang làm vì gặp khó khăn, trở ngại: thoái chí trước khó khăn",
    example: "thoái chí trước khó khăn",
  },
  {
    word: "thoại",
    part_of_speech: "",
    meaning:
      "lời nói (trong tác phẩm; nói khái quát): lời thoại của bộ phim * xem lại đoạn thoại của nhân vật",
    example: "lời thoại của bộ phim * xem lại đoạn thoại của nhân vật",
  },
  {
    word: "thoải",
    part_of_speech: "tính từ",
    meaning:
      "hơi dốc và thấp dần xuống trên một khoảng dài: vùng đồi thoải * nền đất đắp thoải",
    example: "vùng đồi thoải * nền đất đắp thoải",
  },
  {
    word: "thoái hoá",
    part_of_speech: "động từ",
    meaning:
      "(bộ phận của cơ thể động vật) biến đổi theo hướng teo đi, do kết quả của một quá trình lâu đời không hoạt động, không có chức năng gì trong cơ thể: ruột thừa ở người là một cơ quan thoái hoá",
    example: "ruột thừa ở người là một cơ quan thoái hoá",
  },
  {
    word: "thoái hoá",
    part_of_speech: "động từ",
    meaning:
      "biến đổi theo hướng mất dần đi những phẩm chất tốt: thoái hoá cột sống * một cán bộ thoái hoá, biến chất",
    example: "thoái hoá cột sống * một cán bộ thoái hoá, biến chất",
  },
  {
    word: "thoái lui",
    part_of_speech: "động từ",
    meaning:
      "lui lại, quay trở lại phía sau do gặp trở ngại hay sự tấn công nào đó ở phía trước: chạy thoái lui * tìm đường thoái lui",
    example: "chạy thoái lui * tìm đường thoái lui",
  },
  {
    word: "thoai thoải",
    part_of_speech: "tính từ",
    meaning: "hơi thoải: đường dốc thoai thoải",
    example: "đường dốc thoai thoải",
  },
  {
    word: "thoái trào",
    part_of_speech: "danh từ",
    meaning:
      "phong trào ở giai đoạn giảm sút, suy yếu: phong trào đấu tranh đã vào hồi thoái trào",
    example: "phong trào đấu tranh đã vào hồi thoái trào",
  },
  {
    word: "thoải mái",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái hoàn toàn dễ chịu, được hoạt động tự nhiên theo ý muốn, không bị gò bó, hạn chế: ở nhà mặc pyjama cho thoải mái * tinh thần vui vẻ thoải mái",
    example: "ở nhà mặc pyjama cho thoải mái * tinh thần vui vẻ thoải mái",
  },
  {
    word: "thoải mái",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) dễ dãi, tự nhiên, trong quan hệ tiếp xúc: tính thoải mái, dễ gần",
    example: "tính thoải mái, dễ gần",
  },
  {
    word: "thoái thác",
    part_of_speech: "động từ",
    meaning:
      "kiếm cớ từ chối: viện cớ thoái thác * thoái thác là ốm để khỏi phải đi",
    example: "viện cớ thoái thác * thoái thác là ốm để khỏi phải đi",
  },
  {
    word: "thoáng",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian rất ngắn trong đó xảy ra một hoạt động hay tồn tại một trạng thái nào đó: làm một thoáng là xong * thoáng cái, đã không thấy chiếc xe đâu cả",
    example:
      "làm một thoáng là xong * thoáng cái, đã không thấy chiếc xe đâu cả",
  },
  {
    word: "thoáng",
    part_of_speech: "động từ",
    meaning:
      "diễn ra và qua đi rất nhanh trong khoảng thời gian rất ngắn: một ý nghĩ thoáng qua trong đầu * thoáng thấy có bóng người",
    example: "một ý nghĩ thoáng qua trong đầu * thoáng thấy có bóng người",
  },
  {
    word: "thoáng",
    part_of_speech: "tính từ",
    meaning:
      "có khoảng trống cho không khí dễ lưu thông: căn phòng rộng và thoáng * vải thô mặc rất thoáng * mở cửa sổ ra cho thoáng",
    example:
      "căn phòng rộng và thoáng * vải thô mặc rất thoáng * mở cửa sổ ra cho thoáng",
  },
  {
    word: "thoáng",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) không có đường nét, chi tiết rườm rà, rắc rối: nét vẽ thoáng * bố cục của bài viết rất thoáng",
    example: "nét vẽ thoáng * bố cục của bài viết rất thoáng",
  },
  {
    word: "thoáng",
    part_of_speech: "tính từ",
    meaning:
      "rộng rãi, không bảo thủ, dễ dàng tiếp nhận cái mới: sống thoáng * tư tưởng khá thoáng",
    example: "sống thoáng * tư tưởng khá thoáng",
  },
  {
    word: "thoái vị",
    part_of_speech: "động từ",
    meaning: "từ bỏ ngôi vua: vua Bảo Đại thoái vị",
    example: "vua Bảo Đại thoái vị",
  },
  {
    word: "thoái hôn",
    part_of_speech: "động từ",
    meaning:
      "huỷ bỏ giao ước sẽ lấy nhau làm vợ chồng: gia đình nhà gái xin thoái hôn",
    example: "gia đình nhà gái xin thoái hôn",
  },
  {
    word: "thoảng",
    part_of_speech: "động từ",
    meaning:
      "thoáng qua một cách nhẹ nhàng trong thời gian rất ngắn, chỉ đủ để cảm nhận được: một cơn gió thoảng qua * mùi hương bưởi thoảng tới",
    example: "một cơn gió thoảng qua * mùi hương bưởi thoảng tới",
  },
  {
    word: "thoát",
    part_of_speech: "động từ",
    meaning:
      "ra khỏi nơi bị vây hãm, nơi nguy hiểm, hoặc khỏi một tình trạng xấu nào đó: thoát khỏi vòng vây * thoát nạn mù chữ * thoát khỏi cảnh đói nghèo",
    example:
      "thoát khỏi vòng vây * thoát nạn mù chữ * thoát khỏi cảnh đói nghèo",
  },
  {
    word: "thoát",
    part_of_speech: "động từ",
    meaning:
      "làm cho ra khỏi tình trạng bị tắc nghẽn, ứ đọng hoặc bị ràng buộc, kìm hãm: mặc áo mỏng cho dễ thoát mồ hôi * hệ thống thoát nước thải của nhà máy",
    example:
      "mặc áo mỏng cho dễ thoát mồ hôi * hệ thống thoát nước thải của nhà máy",
  },
  {
    word: "thoát",
    part_of_speech: "động từ",
    meaning:
      "thể hiện, diễn đạt một cách tự nhiên, không bị gò bó, gượng ép: bài thơ chữ Hán được dịch thoát ý",
    example: "bài thơ chữ Hán được dịch thoát ý",
  },
  {
    word: "thoát",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) kết thúc công việc theo quy trình định sẵn trong một chương trình máy tính: thoát ra khỏi chương trình",
    example: "thoát ra khỏi chương trình",
  },
  {
    word: "thoang thoảng",
    part_of_speech: "động từ",
    meaning:
      'hơi thoảng qua chút ít: mùi nhang trầm thoang thoảng * "Càng thắm thì lại càng phai, Thoang thoảng hoa nhài mà lại thơm lâu." (ca dao)',
    example:
      'mùi nhang trầm thoang thoảng * "Càng thắm thì lại càng phai, Thoang thoảng hoa nhài mà lại thơm lâu." (ca dao)',
  },
  {
    word: "thoáng đạt",
    part_of_speech: "tính từ",
    meaning: "thoáng và rộng rãi, không cản trở tầm nhìn: ngôi nhà thoáng đạt",
    example: "ngôi nhà thoáng đạt",
  },
  {
    word: "thoáng đãng",
    part_of_speech: "tính từ",
    meaning:
      "thoáng, rộng rãi và sáng sủa, gây cảm giác dễ chịu: căn phòng thoáng đãng * không gian thoáng đãng",
    example: "căn phòng thoáng đãng * không gian thoáng đãng",
  },
  {
    word: "thoạt",
    part_of_speech: "phụ từ",
    meaning:
      "vừa mới làm gì đó (thì đã có ngay nhận thức hoặc phản ứng): thoạt nghe đã hiểu * cái áo thoạt nhìn thì cũng đẹp",
    example: "thoạt nghe đã hiểu * cái áo thoạt nhìn thì cũng đẹp",
  },
  {
    word: "thoạt",
    part_of_speech: "phụ từ",
    meaning:
      "(hiếm) từ biểu thị sự nối tiếp nhanh chóng của những hoạt động trái ngược nhau, vừa mới thế này, đã lại thế khác ngay: thoạt đến rồi thoạt đi",
    example: "thoạt đến rồi thoạt đi",
  },
  {
    word: "thoát li",
    part_of_speech: "động từ",
    meaning:
      "xa rời, tách khỏi cái vốn có quan hệ gắn bó mật thiết với mình: thoát li gia đình * thoát li khỏi đồng ruộng",
    example: "thoát li gia đình * thoát li khỏi đồng ruộng",
  },
  {
    word: "thoát li",
    part_of_speech: "động từ",
    meaning:
      "rời khỏi gia đình, địa phương để đi tham gia công tác cách mạng: cán bộ thoát li",
    example: "cán bộ thoát li",
  },
  {
    word: "thoát ly",
    part_of_speech: "động từ",
    meaning:
      "xa rời, tách khỏi cái vốn có quan hệ gắn bó mật thiết với mình: thoát li gia đình * thoát li khỏi đồng ruộng",
    example: "thoát li gia đình * thoát li khỏi đồng ruộng",
  },
  {
    word: "thoát ly",
    part_of_speech: "động từ",
    meaning:
      "rời khỏi gia đình, địa phương để đi tham gia công tác cách mạng: cán bộ thoát li",
    example: "cán bộ thoát li",
  },
  {
    word: "thoáng khí",
    part_of_speech: "tính từ",
    meaning: "thoáng và có nhiều không khí lưu thông: mở cửa cho thoáng khí",
    example: "mở cửa cho thoáng khí",
  },
  {
    word: "thoạt đầu",
    part_of_speech: "danh từ",
    meaning:
      "lúc mới đầu, lúc ban đầu (nhưng sau đó khác đi): giờ thì tạm ổn chứ thoạt đầu cũng rất khó khăn",
    example: "giờ thì tạm ổn chứ thoạt đầu cũng rất khó khăn",
  },
  {
    word: "thoát thai",
    part_of_speech: "động từ",
    meaning:
      "(văn chương) được sinh ra từ một cái cũ nào đó: Truyện Kiều được thoát thai từ 'Kim Vân Kiều'",
    example: "Truyện Kiều được thoát thai từ 'Kim Vân Kiều'",
  },
  {
    word: "thoát vị",
    part_of_speech: "động từ",
    meaning:
      "(bộ phận bên trong cơ thể) ra ngoài khoang chứa nó qua một lỗ (một hiện tượng bệnh lí): thoát vị rốn",
    example: "thoát vị rốn",
  },
  {
    word: "thoát thân",
    part_of_speech: "động từ",
    meaning:
      "thoát khỏi tình trạng nguy hại đến tính mạng hoặc có ảnh hưởng xấu đến bản thân: trốn chạy để mong thoát thân",
    example: "trốn chạy để mong thoát thân",
  },
  {
    word: "thoát xác",
    part_of_speech: "động từ",
    meaning: "(hiếm) như lột xác: rắn thoát xác",
    example: "rắn thoát xác",
  },
  {
    word: "thoạt tiên",
    part_of_speech: "danh từ",
    meaning:
      "như thoạt đầu: thoạt tiên nó không đồng ý, phải thuyết phục mãi mới được",
    example: "thoạt tiên nó không đồng ý, phải thuyết phục mãi mới được",
  },
  {
    word: "thoắt",
    part_of_speech: "tính từ",
    meaning:
      "(cái gì diễn ra) rất nhanh chóng và đột ngột: thoắt cái đã không thấy đâu cả * bóng người thoắt ẩn thoắt hiện",
    example: "thoắt cái đã không thấy đâu cả * bóng người thoắt ẩn thoắt hiện",
  },
  {
    word: "thóc",
    part_of_speech: "danh từ",
    meaning: "hạt lúa còn nguyên cả vỏ trấu: hạt thóc",
    example: "hạt thóc",
  },
  {
    word: "thọc",
    part_of_speech: "động từ",
    meaning:
      "đưa thẳng và mạnh vào sâu bên trong: thọc dao vào bụng * thọc tay vào túi quần * thọc gậy bánh xe (tng)",
    example:
      "thọc dao vào bụng * thọc tay vào túi quần * thọc gậy bánh xe (tng)",
  },
  {
    word: "thọc",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) xen ngang vào, can thiệp vào một cách thô bạo: chuyện gì cũng thọc mũi vào",
    example: "chuyện gì cũng thọc mũi vào",
  },
  {
    word: "thoăn thoắt",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả dáng cử động rất nhanh nhẹn, nhịp nhàng và liên tục của tay chân: chân bước thoăn thoắt * tay đan lưới thoăn thoắt",
    example: "chân bước thoăn thoắt * tay đan lưới thoăn thoắt",
  },
  {
    word: "thọc sâu",
    part_of_speech: "động từ",
    meaning:
      "tiến đánh mạnh và sâu vào bên trong đội hình hoặc trận địa của địch để tấn công tiêu diệt hoặc chia cắt: đánh thọc sâu",
    example: "đánh thọc sâu",
  },
  {
    word: "thóc lúa",
    part_of_speech: "danh từ",
    meaning: "thóc (nói khái quát): thóc lúa đầy bồ",
    example: "thóc lúa đầy bồ",
  },
  {
    word: "thóc gạo",
    part_of_speech: "danh từ",
    meaning:
      "thóc và gạo, về mặt là lương thực chủ yếu (nói khái quát): thóc gạo đầy nhà * tích trữ thóc gạo",
    example: "thóc gạo đầy nhà * tích trữ thóc gạo",
  },
  {
    word: "thọc lét",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) cù vào người cho cười: thọc lét cho cười",
    example: "thọc lét cho cười",
  },
  {
    word: "thòi",
    part_of_speech: "động từ",
    meaning: "như lòi: bị đâm thòi ruột",
    example: "bị đâm thòi ruột",
  },
  {
    word: "thoi",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận của khung cửi hay máy dệt, có dạng ở giữa phình to, hai đầu thon dần và nhọn, trong có lắp suốt để luồn sợi ngang qua các lớp sợi dọc khi dệt: cắm cúi đưa thoi * ngày tháng thoi đưa (qua đi rất nhanh)",
    example: "cắm cúi đưa thoi * ngày tháng thoi đưa (qua đi rất nhanh)",
  },
  {
    word: "thoi",
    part_of_speech: "danh từ",
    meaning: "thỏi nhỏ: thoi bạc * thoi mực",
    example: "thoi bạc * thoi mực",
  },
  {
    word: "thoi",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) đánh mạnh bằng nắm đấm hoặc cùi tay: thoi một quả đấm vào mặt",
    example: "thoi một quả đấm vào mặt",
  },
  {
    word: "thóc mách",
    part_of_speech: "động từ",
    meaning:
      "(tính) hay tò mò chú ý đến chuyện riêng của người này rồi đem đi kể cho người khác: tính hay thóc mách",
    example: "tính hay thóc mách",
  },
  {
    word: "thói đời",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) cách ăn ở, cư xử không tốt, thường thấy ở người đời: thói đời đen bạc",
    example: "thói đời đen bạc",
  },
  {
    word: "thòi lòi",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) lòi ra hoặc chìa ra ngoài một cách lôi thôi: gấu áo bên trong thòi lòi ra",
    example: "gấu áo bên trong thòi lòi ra",
  },
  {
    word: "thoi thóp",
    part_of_speech: "động từ",
    meaning:
      "thở rất yếu, hơi ra đứt quãng lúc có lúc không một cách mệt nhọc, biểu hiện của sự sắp chết: hơi thở người bệnh chỉ còn thoi thóp * sống thoi thóp với đồng lương ít ỏi (b)",
    example:
      "hơi thở người bệnh chỉ còn thoi thóp * sống thoi thóp với đồng lương ít ỏi (b)",
  },
  {
    word: "thỏi",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị những vật hình thanh nhỏ và ngắn, có thể cầm gọn trong bàn tay: thỏi son * thỏi mực",
    example: "thỏi son * thỏi mực",
  },
  {
    word: "thói tật",
    part_of_speech: "danh từ",
    meaning:
      "thói hư và tật xấu (nói khái quát): thói tật nghiện rượu * một con người nhiều tài nhưng cũng lắm thói tật",
    example:
      "thói tật nghiện rượu * một con người nhiều tài nhưng cũng lắm thói tật",
  },
  {
    word: "thói quen",
    part_of_speech: "danh từ",
    meaning:
      "lối sống, cách sống hay hoạt động do lặp đi lặp lại lâu ngày thành quen, khó thay đổi: thói quen nghề nghiệp * làm theo thói quen",
    example: "thói quen nghề nghiệp * làm theo thói quen",
  },
  {
    word: "thoi thót",
    part_of_speech: "tính từ",
    meaning:
      '(cũ) lẻ tẻ, rời rạc, không liền cùng một lúc: "Chim hôm thoi thót về rừng, Giá trà mi đã ngậm gương nửa vành." (TKiều)',
    example:
      'Chim hôm thoi thót về rừng, Giá trà mi đã ngậm gương nửa vành." (TKiều)',
  },
  {
    word: "thói thường",
    part_of_speech: "danh từ",
    meaning:
      "điều thường thấy, thường có ở nhiều người, coi như đó là chuyện thường, không có gì phải ngạc nhiên: trâu buộc ghét trâu ăn, âu cũng là thói thường",
    example: "trâu buộc ghét trâu ăn, âu cũng là thói thường",
  },
  {
    word: "thói thường",
    part_of_speech: "danh từ",
    meaning:
      "thói quen thường ngày (của một người nào đó): thói thường, hễ buồn bực là hắn lại hút thuốc",
    example: "thói thường, hễ buồn bực là hắn lại hút thuốc",
  },
  {
    word: "thói",
    part_of_speech: "danh từ",
    meaning:
      "(Từ cũ) lề lối lâu ngày đã thành nếp: đất có lề, quê có thói (tng)",
    example: "đất có lề, quê có thói (tng)",
  },
  {
    word: "thói",
    part_of_speech: "danh từ",
    meaning:
      "lối sống, cách sống hay hoạt động, thường là xấu, đã nhiễm sâu vào, do ảnh hưởng lâu ngày thành quen: thói hư tật xấu * quen thói gian trá * giở thói du côn",
    example: "thói hư tật xấu * quen thói gian trá * giở thói du côn",
  },
  {
    word: "thói tục",
    part_of_speech: "danh từ",
    meaning:
      "thói quen và tập tục (nói khái quát): bỏ thói tục ma chay linh đình",
    example: "bỏ thói tục ma chay linh đình",
  },
  {
    word: "thon",
    part_of_speech: "tính từ",
    meaning:
      "có hình dài, tròn và nhỏ dần về phía đầu: ngón tay thon hình búp măng * thân thuyền thon dài",
    example: "ngón tay thon hình búp măng * thân thuyền thon dài",
  },
  {
    word: "thon",
    part_of_speech: "tính từ",
    meaning:
      "có hình dáng nhỏ gọn, tròn trặn, ưa nhìn (thường nói về cơ thể người phụ nữ): dáng người thon",
    example: "dáng người thon",
  },
  {
    word: "thòm thèm",
    part_of_speech: "động từ",
    meaning:
      "vẫn còn thèm nữa vì cảm thấy chưa đủ, chưa được thoả mãn lắm: ăn xong vẫn còn thòm thèm",
    example: "ăn xong vẫn còn thòm thèm",
  },
  {
    word: "thỏm",
    part_of_speech: "phụ từ",
    meaning:
      "(lọt) vào sâu và dễ dàng trong lòng một vật khác lớn hơn rất nhiều: hòn đá rơi thỏm xuống hang * đút thỏm miếng bánh vào miệng",
    example: "hòn đá rơi thỏm xuống hang * đút thỏm miếng bánh vào miệng",
  },
  {
    word: "thòm thòm",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như thì thòm: trống đánh thòm thòm",
    example: "trống đánh thòm thòm",
  },
  {
    word: "thon thả",
    part_of_speech: "tính từ",
    meaning:
      "có vẻ thon nhỏ, mềm mại và đẹp (thường nói về hình dáng người phụ nữ): ngón tay dài, thon thả * thân hình thon thả",
    example: "ngón tay dài, thon thả * thân hình thon thả",
  },
  {
    word: "thon thót",
    part_of_speech: "động từ",
    meaning:
      "giật nẩy người lên một cách đột ngột nhiều lần liên tiếp: giật mình thon thót",
    example: "giật mình thon thót",
  },
  {
    word: "thon lỏn",
    part_of_speech: "tính từ",
    meaning: "gọn thon lỏn (nói tắt): trả lời thon lỏn một câu",
    example: "trả lời thon lỏn một câu",
  },
  {
    word: "thòng",
    part_of_speech: "động từ",
    meaning: "thả cho buông từ trên cao xuống: thòng gàu xuống giếng múc nước",
    example: "thòng gàu xuống giếng múc nước",
  },
  {
    word: "thòng",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) thòi ra ngoài và buông xuống: buộc không gọn nên đầu dây thòng ra ngoài",
    example: "buộc không gọn nên đầu dây thòng ra ngoài",
  },
  {
    word: "thom thóp",
    part_of_speech: "động từ",
    meaning: "(hiếm) như nơm nớp: thom thóp lo sợ",
    example: "thom thóp lo sợ",
  },
  {
    word: "thong dong",
    part_of_speech: "tính từ",
    meaning:
      "thảnh thơi, nhàn nhã, không có vẻ gì là vội vàng: đi thong dong vòng quanh hồ * điệu bộ thong dong, nhàn tản",
    example: "đi thong dong vòng quanh hồ * điệu bộ thong dong, nhàn tản",
  },
  {
    word: "thõng",
    part_of_speech: "động từ",
    meaning:
      "để cho buông thẳng xuống một cách tự nhiên: quả mướp thõng xuống giàn * ngồi bỏ thõng chân",
    example: "quả mướp thõng xuống giàn * ngồi bỏ thõng chân",
  },
  {
    word: "thong thả",
    part_of_speech: "tính từ",
    meaning:
      "(làm việc gì) chậm rãi, từ tốn, không tỏ ra vội vàng, gấp gáp: đọc thong thả từng tiếng một * đi thong thả kẻo ngã",
    example: "đọc thong thả từng tiếng một * đi thong thả kẻo ngã",
  },
  {
    word: "thong thả",
    part_of_speech: "tính từ",
    meaning:
      "rảnh rang, không bận bịu gì: khi nào thong thả, mời bác qua tôi chơi",
    example: "khi nào thong thả, mời bác qua tôi chơi",
  },
  {
    word: "thong thả",
    part_of_speech: "tính từ",
    meaning:
      "từ từ, không vội (thường dùng trong lời đề nghị hoặc can ngăn): việc đó cứ thong thả, lúc nào có dịp thì làm",
    example: "việc đó cứ thong thả, lúc nào có dịp thì làm",
  },
  {
    word: "thòng lọng",
    part_of_speech: "danh từ",
    meaning:
      "đoạn dây có một đầu được buộc lỏng thành vòng để có thể mắc vào vật và thít chặt lại khi rút mạnh đầu kia: mang thòng lọng đi bắt lợn * tự chui đầu vào thòng lọng",
    example: "mang thòng lọng đi bắt lợn * tự chui đầu vào thòng lọng",
  },
  {
    word: "thõng thẹo",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái buông thõng xuống và đung đưa một cách yếu ớt: đi đứng thõng thẹo",
    example: "đi đứng thõng thẹo",
  },
  {
    word: "thóp",
    part_of_speech: "danh từ",
    meaning:
      "khe hở ở sọ của động vật còn non, do xương sọ chưa phát triển đầy đủ nên các khớp nối của xương chưa khép kín hoàn toàn: đội mũ để che thóp cho trẻ * chưa kín thóp",
    example: "đội mũ để che thóp cho trẻ * chưa kín thóp",
  },
  {
    word: "thóp",
    part_of_speech: "danh từ",
    meaning:
      "nhược điểm hay chỗ yếu mà người khác có thể lợi dụng được: biết thóp * nắm được thóp là sợ ma nên càng hay doạ",
    example: "biết thóp * nắm được thóp là sợ ma nên càng hay doạ",
  },
  {
    word: "thóp",
    part_of_speech: "động từ",
    meaning: "(hiếm) như thót: bụng thóp lại",
    example: "bụng thóp lại",
  },
  {
    word: "thõng thượt",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả dáng vẻ dài thượt ra và buông thõng xuống: nằm thõng thượt trên giường",
    example: "nằm thõng thượt trên giường",
  },
  {
    word: "thô",
    part_of_speech: "tính từ",
    meaning:
      "(hình dáng, đường nét) không thanh mảnh, thiếu sự mềm mại, trông không đẹp: đôi bàn tay thô * áo may bằng loại vải thô",
    example: "đôi bàn tay thô * áo may bằng loại vải thô",
  },
  {
    word: "thô",
    part_of_speech: "tính từ",
    meaning:
      "thiếu tế nhị, không thanh nhã trong cách cư xử, thể hiện, diễn đạt: câu nói đùa hơi thô",
    example: "câu nói đùa hơi thô",
  },
  {
    word: "thô",
    part_of_speech: "tính từ",
    meaning:
      "(chất hoặc vật liệu) chưa qua tinh chế, chỉ mới được gia công sơ sài hoặc chế biến một cách đơn giản: xuất khẩu dầu thô * sản xuất sợi thô * chế biến thô",
    example: "xuất khẩu dầu thô * sản xuất sợi thô * chế biến thô",
  },
  {
    word: "thót tim",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) thót người lên và tim như bị nghẹt lại một cách đột ngột trong giây lát khi quá căng thẳng hoặc quá sợ hãi: sợ đến thót tim",
    example: "sợ đến thót tim",
  },
  {
    word: "thót",
    part_of_speech: "động từ",
    meaning:
      "thu nhỏ hoặc làm cho thu nhỏ thể tích lại ở một bộ phận nào đó: thót người lại vì lạnh * bụng thót lại",
    example: "thót người lại vì lạnh * bụng thót lại",
  },
  {
    word: "thót",
    part_of_speech: "động từ",
    meaning: "nẩy mạnh người lên một cách đột ngột: giật mình đánh thót",
    example: "giật mình đánh thót",
  },
  {
    word: "thót",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) di chuyển bằng động tác (thường là nhảy) rất nhanh, gọn và đột ngột: thót lên xe đi mất",
    example: "thót lên xe đi mất",
  },
  {
    word: "thố",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ) liễn nhỏ: thố đựng cơm * bộ thố tráng men",
    example: "thố đựng cơm * bộ thố tráng men",
  },
  {
    word: "thọt",
    part_of_speech: "tính từ",
    meaning: "có một chân teo lại và ngắn hơn chân kia do bị tật: thọt chân",
    example: "thọt chân",
  },
  {
    word: "thọt",
    part_of_speech: "phụ từ",
    meaning:
      "(chạy) thẳng một mạch vào bên trong: con chuột chạy thọt vào hang",
    example: "con chuột chạy thọt vào hang",
  },
  {
    word: "thổ cẩm",
    part_of_speech: "danh từ",
    meaning:
      "hàng mĩ nghệ của một số dân tộc thiểu số, dệt bằng sợi nhiều màu sặc sỡ tạo thành những hình hoa văn trang trí đa dạng: túi thổ cẩm",
    example: "túi thổ cẩm",
  },
  {
    word: "thồ",
    part_of_speech: "động từ",
    meaning:
      "chuyên chở hàng hoá trên lưng súc vật hoặc trên xe đạp: ngựa thồ hàng lên miền núi * thồ bằng xe đạp * thồ gạo",
    example: "ngựa thồ hàng lên miền núi * thồ bằng xe đạp * thồ gạo",
  },
  {
    word: "thổ",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) đất để làm vườn, làm nhà hay để trồng trọt (nhưng không phải là ruộng để trồng lúa): được chia hai sào thổ để ở",
    example: "được chia hai sào thổ để ở",
  },
  {
    word: "thổ",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) nôn, mửa: thổ ra máu * ăn gì cũng thổ ra hết",
    example: "thổ ra máu * ăn gì cũng thổ ra hết",
  },
  {
    word: "thô bạo",
    part_of_speech: "tính từ",
    meaning:
      "có những hành vi, cử chỉ xúc phạm đến người khác một cách trắng trợn: đối xử thô bạo * can thiệp thô bạo",
    example: "đối xử thô bạo * can thiệp thô bạo",
  },
  {
    word: "thổ công",
    part_of_speech: "danh từ",
    meaning:
      "vị thần coi giữ một vùng đất đai: đất có thổ công, sông có hà bá (tng)",
    example: "đất có thổ công, sông có hà bá (tng)",
  },
  {
    word: "thổ công",
    part_of_speech: "danh từ",
    meaning:
      "ví người am hiểu tường tận ở một vùng, một khu vực nào đó: ông ta là thổ công ở vùng này",
    example: "ông ta là thổ công ở vùng này",
  },
  {
    word: "thô bỉ",
    part_of_speech: "tính từ",
    meaning: "thô lỗ và bỉ ổi: lời nói thô bỉ * kẻ thô bỉ",
    example: "lời nói thô bỉ * kẻ thô bỉ",
  },
  {
    word: "thổ địa",
    part_of_speech: "danh từ",
    meaning: "(cũ) ruộng đất.",
    example: "bàn thờ thổ địa * thần thổ địa",
  },
  {
    word: "thổ dân",
    part_of_speech: "danh từ",
    meaning:
      "cư dân sinh sống đã lâu đời ở một vùng hay một địa phương nào đó, thường ở tình trạng lạc hậu, trong quan hệ với người dân văn minh hơn từ nơi khác đến: thổ dân da đỏ",
    example: "thổ dân da đỏ",
  },
  {
    word: "thô lố",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) (mắt) to và như lồi ra: mắt mở thô lố",
    example: "mắt mở thô lố",
  },
  {
    word: "thô lố",
    part_of_speech: "tính từ",
    meaning: "to khác thường, trông thô: đôi giày to thô lố",
    example: "đôi giày to thô lố",
  },
  {
    word: "thô kệch",
    part_of_speech: "tính từ",
    meaning:
      "quá thô, không thanh, không nhã: dáng người thô kệch * ăn nói thô kệch",
    example: "dáng người thô kệch * ăn nói thô kệch",
  },
  {
    word: "thổ cư",
    part_of_speech: "danh từ",
    meaning: "đất dùng để dựng nhà ở (nói khái quát): đất thổ cư",
    example: "đất thổ cư",
  },
  {
    word: "thô lậu",
    part_of_speech: "tính từ",
    meaning: "(cũ) vụng về và thô thiển, kém văn minh: con người thô lậu",
    example: "con người thô lậu",
  },
  {
    word: "thổ lộ",
    part_of_speech: "động từ",
    meaning:
      "nói ra với người khác những điều thầm kín của mình: thổ lộ tình yêu * thổ lộ tâm tư",
    example: "thổ lộ tình yêu * thổ lộ tâm tư",
  },
  {
    word: "thô lỗ",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra thô tục, lỗ mãng trong cách giao tiếp, đối xử: ăn nói thô lỗ * người đàn ông thô lỗ",
    example: "ăn nói thô lỗ * người đàn ông thô lỗ",
  },
  {
    word: "thổ nhưỡng học",
    part_of_speech: "danh từ",
    meaning:
      "ngành khoa học chuyên nghiên cứu về thổ nhưỡng: bộ môn thổ nhưỡng học",
    example: "bộ môn thổ nhưỡng học",
  },
  {
    word: "thổ phỉ",
    part_of_speech: "danh từ",
    meaning:
      "giặc phỉ chuyên quấy phá ở ngay địa phương mình: tiễu trừ thổ phỉ",
    example: "tiễu trừ thổ phỉ",
  },
  {
    word: "thổ nghi",
    part_of_speech: "danh từ",
    meaning:
      "tính chất đất đai và khí hậu của một vùng, về mặt có thích hợp hay không với cuộc sống của con người hay của giống cây trồng, vật nuôi: loài cây này rất thích hợp với thổ nghi nơi đây",
    example: "loài cây này rất thích hợp với thổ nghi nơi đây",
  },
  {
    word: "thổ nhưỡng",
    part_of_speech: "danh từ",
    meaning:
      "đất đai, về mặt có sinh vật sinh sống: bản đồ thổ nhưỡng * điều kiện thổ nhưỡng thuận lợi",
    example: "bản đồ thổ nhưỡng * điều kiện thổ nhưỡng thuận lợi",
  },
  {
    word: "thô mộc",
    part_of_speech: "tính từ",
    meaning:
      "thô sơ và mộc mạc, chưa được gia công, trau chuốt: bộ bàn ghế thô mộc * nét vẽ thô mộc",
    example: "bộ bàn ghế thô mộc * nét vẽ thô mộc",
  },
  {
    word: "thô ráp",
    part_of_speech: "tính từ",
    meaning:
      "thô và ráp, không nhẵn, không mềm mại: mặt bàn thô ráp * đôi bàn tay thô ráp",
    example: "mặt bàn thô ráp * đôi bàn tay thô ráp",
  },
  {
    word: "thô sơ",
    part_of_speech: "tính từ",
    meaning:
      "đơn giản, sơ sài, chưa có sự tinh vi về mặt kĩ thuật: vũ khí thô sơ * phần đường dành cho xe thô sơ",
    example: "vũ khí thô sơ * phần đường dành cho xe thô sơ",
  },
  {
    word: "thô thiển",
    part_of_speech: "tính từ",
    meaning:
      "quá đơn giản và nông cạn, kém tinh tế, không sâu sắc: ăn nói thô thiển * hiểu một cách thô thiển",
    example: "ăn nói thô thiển * hiểu một cách thô thiển",
  },
  {
    word: "thổ thần",
    part_of_speech: "danh từ",
    meaning: "thần đất: lễ tế thổ thần",
    example: "lễ tế thổ thần",
  },
  {
    word: "thổ trạch",
    part_of_speech: "danh từ",
    meaning: "nhà cửa và đất ở, nói chung: thuế thổ trạch",
    example: "thuế thổ trạch",
  },
  {
    word: "thô vụng",
    part_of_speech: "tính từ",
    meaning: "thô thiển, vụng về: đôi bàn tay thô vụng",
    example: "đôi bàn tay thô vụng",
  },
  {
    word: "thốc",
    part_of_speech: "động từ",
    meaning:
      "ào tới rất nhanh và mạnh: gió lạnh thốc vào nhà * cơn giông ùn ùn thốc tới",
    example: "gió lạnh thốc vào nhà * cơn giông ùn ùn thốc tới",
  },
  {
    word: "thốc",
    part_of_speech: "phụ từ",
    meaning:
      "một cách nhanh, mạnh và liền một mạch: nhảy thốc vào * bế thốc con lên",
    example: "nhảy thốc vào * bế thốc con lên",
  },
  {
    word: "thô tục",
    part_of_speech: "tính từ",
    meaning:
      "thiếu lịch sự, thiếu tế nhị đến mức tục tằn: cách ăn uống thô tục",
    example: "cách ăn uống thô tục",
  },
  {
    word: "thổ tả",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) dịch tả: mắc bệnh thổ tả",
    example: "mắc bệnh thổ tả",
  },
  {
    word: "thổ tả",
    part_of_speech: "tính từ",
    meaning:
      "(thông tục) quá tồi tệ, đáng ghét: toàn những chuyện thổ tả * chiếc xe đạp thổ tả",
    example: "toàn những chuyện thổ tả * chiếc xe đạp thổ tả",
  },
  {
    word: "thối",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) thoái",
    example: "thối (lại) tiền cho khách * tiền thối",
  },
  {
    word: "thối",
    part_of_speech: "động từ",
    meaning: "(Nam) trả lại tiền thừa: thối (lại) tiền cho khách * tiền thối",
    example: "trứng thối * mạ bị thối rễ",
  },
  {
    word: "thối",
    part_of_speech: "động từ",
    meaning:
      "(Nam thúi) (chất hữu cơ) bị biến chất sinh ra mùi thối, do tác dụng huỷ hoại của vi sinh vật: trứng thối * mạ bị thối rễ",
    example: "đạn thối không nổ",
  },
  {
    word: "thối",
    part_of_speech: "tính từ",
    meaning:
      "(Nam thúi) có mùi khó ngửi như mùi phân tươi hoặc mùi xác chết lâu ngày: mùi thối * thối như cóc chết",
    example: "mùi thối * thối như cóc chết",
  },
  {
    word: "thổi",
    part_of_speech: "động từ",
    meaning:
      "chúm miệng lại và làm cho luồng hơi bật mạnh từ trong miệng ra: thổi tắt ngọn đèn * thổi bụi",
    example: "thổi tắt ngọn đèn * thổi bụi",
  },
  {
    word: "thổi",
    part_of_speech: "động từ",
    meaning:
      "làm cho kèn, sáo, còi, v.v. phát ra tiếng bằng cách thổi: thổi sáo * trọng tài thổi còi",
    example: "thổi sáo * trọng tài thổi còi",
  },
  {
    word: "thổi",
    part_of_speech: "động từ",
    meaning:
      "(không khí) chuyển động thành luồng và gây ra một tác động nhất định: gió thổi ào ào",
    example: "gió thổi ào ào",
  },
  {
    word: "thổi",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) thêm thắt, nói quá lên: chuyện có một chút cũng thổi cho to",
    example: "chuyện có một chút cũng thổi cho to",
  },
  {
    word: "thổi",
    part_of_speech: "động từ",
    meaning: "(Bắc) nấu (cơm, xôi): thổi cơm * thổi xôi",
    example: "thổi cơm * thổi xôi",
  },
  {
    word: "thộc",
    part_of_speech: "phụ từ",
    meaning: "(hiếm) như thốc: chạy thộc vào nhà",
    example: "chạy thộc vào nhà",
  },
  {
    word: "thốc tháo",
    part_of_speech: "phụ từ",
    meaning:
      "một cách rất nhanh, mạnh, như không có sức gì kìm giữ được: nôn thốc tháo ra hết * bán thốc bán tháo (kng)",
    example: "nôn thốc tháo ra hết * bán thốc bán tháo (kng)",
  },
  {
    word: "thôi",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian hoặc không gian tương đối dài và liên tục, trong đó diễn ra một hoạt động nào đó: nói một thôi dài * tát vài thôi nước đã mệt",
    example: "nói một thôi dài * tát vài thôi nước đã mệt",
  },
  {
    word: "thôi",
    part_of_speech: "động từ",
    meaning:
      "ngừng hẳn lại, chấm dứt hẳn, không tiếp tục làm việc gì đó nữa: thôi học * đòi cho kì được mới thôi * trời đã thôi mưa",
    example: "thôi học * đòi cho kì được mới thôi * trời đã thôi mưa",
  },
  {
    word: "thôi",
    part_of_speech: "động từ",
    meaning:
      "cũng đành coi như là không có chuyện gì nữa, không có gì phải nói nữa: được thì tốt mà không cũng thôi * không tin thì thôi",
    example: "được thì tốt mà không cũng thôi * không tin thì thôi",
  },
  {
    word: "thôi",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý nhấn mạnh sự hạn chế về phạm vi, mức độ của điều vừa nói đến: ăn một bát thôi * chỉ lần này nữa thôi * nói thế thôi là đủ hiểu",
    example: "ăn một bát thôi * chỉ lần này nữa thôi * nói thế thôi là đủ hiểu",
  },
  {
    word: "thôi",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý nhấn mạnh sự miễn cưỡng đồng ý hoặc chấp nhận điều được nói đến, vì thấy khó có ý kiến gì khác: đành vậy thôi * thôi được, để tôi tính xem sao",
    example: "đành vậy thôi * thôi được, để tôi tính xem sao",
  },
  {
    word: "thôi",
    part_of_speech: "trợ từ",
    meaning:
      "(Khẩu ngữ) từ biểu thị ý nhấn mạnh sự khẳng định nhằm thuyết phục người đối thoại không nên phải băn khoăn, đắn đo hay lo nghĩ gì nữa: thế nào rồi cũng ổn thôi * nghỉ ngơi vài ngày là khoẻ lại thôi",
    example: "thế nào rồi cũng ổn thôi * nghỉ ngơi vài ngày là khoẻ lại thôi",
  },
  {
    word: "thôi",
    part_of_speech: "cảm từ",
    meaning:
      "từ thốt ra biểu thị ý tiếc trước điều không hay nào đó đã hoặc đang xảy ra: thôi, hỏng mất rồi! * thôi, thế là xong!",
    example: "thôi, hỏng mất rồi! * thôi, thế là xong!",
  },
  {
    word: "thôi",
    part_of_speech: "cảm từ",
    meaning:
      "từ biểu thị ý can ngăn hoặc từ chối vì không muốn để cho một việc nào đó xảy ra hoặc tiếp diễn nữa: thôi, đừng khóc nữa! * nói vừa thôi! * thôi, tôi không nhận đâu",
    example: "thôi, đừng khóc nữa! * nói vừa thôi! * thôi, tôi không nhận đâu",
  },
  {
    word: "thôi",
    part_of_speech: "động từ",
    meaning:
      "nhả bớt chất màu nhuộm ra, làm lan sang vật khác khi bị ướt, bị ẩm: cái áo đỏ bị thôi màu",
    example: "cái áo đỏ bị thôi màu",
  },
  {
    word: "thối hoăng",
    part_of_speech: "tính từ",
    meaning: "rất thối và lan rộng ra: mùi chuột chết thối hoăng",
    example: "mùi chuột chết thối hoăng",
  },
  {
    word: "thổi nấu",
    part_of_speech: "động từ",
    meaning: "như nấu nướng: có một mình nên ngại thổi nấu",
    example: "có một mình nên ngại thổi nấu",
  },
  {
    word: "thối nát",
    part_of_speech: "tính từ",
    meaning:
      "ở tình trạng xấu xa, hư hỏng đến mức tồi tệ, không thể cứu chữa được: chế độ phong kiến thối nát",
    example: "chế độ phong kiến thối nát",
  },
  {
    word: "thổi ngạt",
    part_of_speech: "động từ",
    meaning: "hà hơi cho người đang bị ngạt thở để cấp cứu: hà hơi thổi ngạt",
    example: "hà hơi thổi ngạt",
  },
  {
    word: "thổi phồng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) thêm thắt vào và nói quá lên so với sự thật, nhằm mục đích nào đó: thổi phồng thành tích",
    example: "thổi phồng thành tích",
  },
  {
    word: "thôi miên",
    part_of_speech: "động từ",
    meaning:
      "tác động vào tâm lí của người nào đó, gây ra trạng thái tựa như ngủ, làm cho dễ dàng chịu sự ám thị của mình: thuật thôi miên * nhìn như bị thôi miên",
    example: "thuật thôi miên * nhìn như bị thôi miên",
  },
  {
    word: "thôi miên",
    part_of_speech: "danh từ",
    meaning: "thuật thôi miên: phương pháp chữa bệnh bằng thôi miên",
    example: "phương pháp chữa bệnh bằng thôi miên",
  },
  {
    word: "thôi nôi",
    part_of_speech: "tính từ",
    meaning: "(trẻ em) tròn một tuổi: lễ thôi nôi * bé sắp đến tuổi thôi nôi",
    example: "lễ thôi nôi * bé sắp đến tuổi thôi nôi",
  },
  {
    word: "thối tha",
    part_of_speech: "tính từ",
    meaning: "(hiếm) thối và bẩn (nói khái quát): bãi rác thối tha",
    example: "bãi rác thối tha",
  },
  {
    word: "thối tha",
    part_of_speech: "tính từ",
    meaning:
      "xấu xa, tồi tệ đến mức khó có thể chấp nhận: lối sống sa đọa, thối tha",
    example: "lối sống sa đọa, thối tha",
  },
  {
    word: "thối thây",
    part_of_speech: "tính từ",
    meaning:
      "(thông tục) quá hư đốn hoặc lười biếng (thường dùng trong lời chửi mắng): lười thối thây!",
    example: "lười thối thây!",
  },
  {
    word: "thôi sơn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (quả đấm) rất mạnh, tựa như trời giáng: quả đấm thôi sơn",
    example: "quả đấm thôi sơn",
  },
  {
    word: "thôi thì",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị điều sắp nêu ra là cách giải quyết sự việc mà cuối cùng thấy là đành phải chấp nhận vì không còn cách nào khác (thường dùng để mở đầu một lời kết thúc sự cân nhắc, bàn bạc): thôi thì tuỳ ý các anh * đã đến nước này, thôi thì đành vậy!",
    example: "thôi thì tuỳ ý các anh * đã đến nước này, thôi thì đành vậy!",
  },
  {
    word: "thôi thì",
    part_of_speech: "",
    meaning:
      "tổ hợp dùng khi liệt kê một loạt cái gì đó nhằm biểu thị ý còn có nhiều lắm, không làm sao mà kể ra hết được: dọn dẹp, giặt giũ, nấu nướng..., thôi thì đủ việc",
    example: "dọn dẹp, giặt giũ, nấu nướng..., thôi thì đủ việc",
  },
  {
    word: "thôn bản",
    part_of_speech: "danh từ",
    meaning:
      "thôn và bản, khu vực dân cư ở các vùng nông thôn hẻo lánh và vùng dân tộc thiểu số (nói khái quát): mạng lưới y tế ở thôn bản * mở đường giao thông đến tận các thôn bản",
    example:
      "mạng lưới y tế ở thôn bản * mở đường giao thông đến tận các thôn bản",
  },
  {
    word: "thồn",
    part_of_speech: "động từ",
    meaning:
      '(hiếm) như thuồn (ng1): "Khi thuốc trong ống vố sắp tàn, lão mới lấy thuốc thồn thêm vào." (AĐức; 6)',
    example:
      'Khi thuốc trong ống vố sắp tàn, lão mới lấy thuốc thồn thêm vào." (AĐức; 6)',
  },
  {
    word: "thôi việc",
    part_of_speech: "động từ",
    meaning:
      "nghỉ việc, không làm việc ở cơ quan, xí nghiệp hay cơ sở nào đó nữa: đơn xin thôi việc * năng lực kém nên bị buộc thôi việc",
    example: "đơn xin thôi việc * năng lực kém nên bị buộc thôi việc",
  },
  {
    word: "thôn ấp",
    part_of_speech: "danh từ",
    meaning: "(cũ, hoặc ph) làng xóm: đi chào bà con trong thôn ấp",
    example: "đi chào bà con trong thôn ấp",
  },
  {
    word: "thôi thúc",
    part_of_speech: "động từ",
    meaning:
      "thúc đẩy, giục giã, khiến cảm thấy cần phải làm ngay điều gì, việc gì đó: có sức mạnh thôi thúc * tiếng trống thôi thúc",
    example: "có sức mạnh thôi thúc * tiếng trống thôi thúc",
  },
  {
    word: "thộn",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) ngây ngô, có vẻ như đần độn: mặt cứ thộn ra",
    example: "mặt cứ thộn ra",
  },
  {
    word: "thồm lồm",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) chứng bệnh gây lở loét ở vành tai: thồm lồm ăn tai",
    example: "thồm lồm ăn tai",
  },
  {
    word: "thốn",
    part_of_speech: "động từ",
    meaning: "nhói lên: vết thương đau thốn",
    example: "vết thương đau thốn",
  },
  {
    word: "thôn ổ",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, văn chương) làng xóm, nơi xa thành thị: cuộc sống lam lũ nơi thôn ổ",
    example: "cuộc sống lam lũ nơi thôn ổ",
  },
  {
    word: "thôn nữ",
    part_of_speech: "danh từ",
    meaning: "(văn chương) người con gái thôn quê: cô thôn nữ",
    example: "cô thôn nữ",
  },
  {
    word: "thổn thức",
    part_of_speech: "động từ",
    meaning:
      "khóc thành những tiếng nhỏ và ngắt quãng như cố nén mà không được, do quá đau đớn hoặc quá xúc động: khóc thổn thức",
    example: "khóc thổn thức",
  },
  {
    word: "thổn thức",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) ở trạng thái có những tình cảm làm rạo rực, xao xuyến không yên: con tim đang thổn thức yêu đương",
    example: "con tim đang thổn thức yêu đương",
  },
  {
    word: "thông",
    part_of_speech: "danh từ",
    meaning:
      "cây hạt trần, thân thẳng, có nhựa thơm, lá hình kim, tán lá hình tháp: nhựa thông",
    example: "nhựa thông",
  },
  {
    word: "thông",
    part_of_speech: "động từ",
    meaning:
      "nối liền một mạch với nhau từ nơi nọ đến nơi kia, không bị cản trở, ngăn cách: đường thông hè thoáng * phòng khách thông với phòng ngủ",
    example: "đường thông hè thoáng * phòng khách thông với phòng ngủ",
  },
  {
    word: "thông",
    part_of_speech: "động từ",
    meaning:
      "làm cho được lưu thông từ đầu nọ đến đầu kia, từ chỗ này đến chỗ khác, không bị tắc nghẽn, không bị dồn ứ: thông cống thoát nước * ống thông khói",
    example: "thông cống thoát nước * ống thông khói",
  },
  {
    word: "thông",
    part_of_speech: "động từ",
    meaning:
      "liền suốt một mạch, không gián đoạn, không ngừng nghỉ: máy chạy thông ca * làm việc thông tầm",
    example: "máy chạy thông ca * làm việc thông tầm",
  },
  {
    word: "thông",
    part_of_speech: "động từ",
    meaning:
      "hiểu rõ và đồng ý chấp thuận, không còn gì băn khoăn, thắc mắc nữa: tư tưởng đã thông * giảng mãi mà vẫn không thông",
    example: "tư tưởng đã thông * giảng mãi mà vẫn không thông",
  },
  {
    word: "thông",
    part_of_speech: "động từ",
    meaning:
      "biết và nắm được một cách thành thạo: đọc thông viết thạo * thông kim bác cổ",
    example: "đọc thông viết thạo * thông kim bác cổ",
  },
  {
    word: "thôn dã",
    part_of_speech: "",
    meaning:
      "(cũ, văn chương) chốn nông thôn, về mặt là nơi dân dã, đơn sơ và bình dị: cuộc sống nơi thôn dã * món ăn thôn dã",
    example: "cuộc sống nơi thôn dã * món ăn thôn dã",
  },
  {
    word: "thỗn thện",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (bộ ngực người phụ nữ) quá to và để hở hang, bày ra một cách lộ liễu, trông khó coi: vú vê thỗn thện",
    example: "vú vê thỗn thện",
  },
  {
    word: "thôn trang",
    part_of_speech: "danh từ",
    meaning: "(cũ) làng mạc: nơi thôn trang vắng vẻ",
    example: "nơi thôn trang vắng vẻ",
  },
  {
    word: "thôn quê",
    part_of_speech: "danh từ",
    meaning: "(cũ) nông thôn: từ thành thị đến thôn quê * lui về chốn thôn quê",
    example: "từ thành thị đến thôn quê * lui về chốn thôn quê",
  },
  {
    word: "thông báo",
    part_of_speech: "động từ",
    meaning:
      "báo cho mọi người biết tình hình, tin tức bằng lời nói hoặc văn bản: thông báo giờ tàu chạy * thông báo kết quả tuyển sinh",
    example: "thông báo giờ tàu chạy * thông báo kết quả tuyển sinh",
  },
  {
    word: "thông báo",
    part_of_speech: "danh từ",
    meaning: "bản thông báo hoặc lời thông báo: ban thường vụ ra thông báo",
    example: "ban thường vụ ra thông báo",
  },
  {
    word: "thông cáo",
    part_of_speech: "danh từ",
    meaning:
      "văn bản do các tổ chức hoặc cơ quan Nhà nước ban hành để báo cho mọi người biết tình hình, sự việc có một tầm quan trọng nhất định nào đó: thông cáo báo chí * bộ ngoại giao ra thông cáo",
    example: "thông cáo báo chí * bộ ngoại giao ra thông cáo",
  },
  {
    word: "thông đạt",
    part_of_speech: "",
    meaning: "(cũ) thông báo: thông đạt tin họp cho hội viên * gửi thông đạt",
    example: "thông đạt tin họp cho hội viên * gửi thông đạt",
  },
  {
    word: "thông dụng",
    part_of_speech: "tính từ",
    meaning:
      "thường dùng và được dùng một cách phổ biến: từ ngữ thông dụng * đồ dùng thông dụng",
    example: "từ ngữ thông dụng * đồ dùng thông dụng",
  },
  {
    word: "thông cảm",
    part_of_speech: "động từ",
    meaning:
      "hiểu thấu hoàn cảnh, khó khăn riêng và chia sẻ tâm tư, tình cảm: thông cảm với hoàn cảnh của nhau * mong anh thông cảm",
    example: "thông cảm với hoàn cảnh của nhau * mong anh thông cảm",
  },
  {
    word: "thống đốc",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) viên chức người Pháp đứng đầu bộ máy cai trị ở Nam Kì thời Pháp thuộc.",
    example: "thống đốc ngân hàng nhà nước",
  },
  {
    word: "thông điệp",
    part_of_speech: "danh từ",
    meaning:
      "công văn ngoại giao quan trọng do một nước hay một tổ chức quốc tế lớn gửi cho một hay nhiều nước khác.",
    example: "thông điệp hoà bình * bức ảnh mang nhiều thông điệp",
  },
  {
    word: "thông đồng",
    part_of_speech: "động từ",
    meaning:
      "thoả thuận, câu kết ngầm với nhau để làm việc trái phép: thông đồng với giặc",
    example: "thông đồng với giặc",
  },
  {
    word: "thông hành",
    part_of_speech: "danh từ",
    meaning: "giấy thông hành (nói tắt): kiểm tra thông hành",
    example: "kiểm tra thông hành",
  },
  {
    word: "thông hiểu",
    part_of_speech: "động từ",
    meaning:
      "hiểu một cách thấu đáo, cặn kẽ: thông hiểu sự đời * thông hiểu luật pháp",
    example: "thông hiểu sự đời * thông hiểu luật pháp",
  },
  {
    word: "thông gia",
    part_of_speech: "danh từ",
    meaning:
      "gia đình có con cái kết hôn với nhau, trong quan hệ với nhau: đến thăm ông thông gia * làm thông gia với nhau",
    example: "đến thăm ông thông gia * làm thông gia với nhau",
  },
  {
    word: "thống kê học",
    part_of_speech: "danh từ",
    meaning:
      "ngành toán học nghiên cứu về sự thu thập, tổ chức và giải thích các số liệu: phương pháp thống kê học",
    example: "phương pháp thống kê học",
  },
  {
    word: "thống khổ",
    part_of_speech: "tính từ",
    meaning:
      "đau đớn và khổ sở đến cực độ: nỗi thống khổ của người dân mất nước",
    example: "nỗi thống khổ của người dân mất nước",
  },
  {
    word: "thống kê",
    part_of_speech: "động từ",
    meaning:
      "thu thập số liệu về một hiện tượng, sự việc, tình hình nào đó: số liệu thống kê * thống kê tình hình tài chính",
    example: "số liệu thống kê * thống kê tình hình tài chính",
  },
  {
    word: "thống kê",
    part_of_speech: "danh từ",
    meaning: "thống kê học (nói tắt): bộ môn thống kê",
    example: "bộ môn thống kê",
  },
  {
    word: "thông lệ",
    part_of_speech: "danh từ",
    meaning: "lệ thường: việc ấy đã thành thông lệ",
    example: "việc ấy đã thành thông lệ",
  },
  {
    word: "thống lĩnh",
    part_of_speech: "động từ",
    meaning:
      "quản lí và chỉ huy một bộ phận lớn hoặc toàn bộ lực lượng vũ trang của một nước: thống lĩnh ba quân",
    example: "thống lĩnh ba quân",
  },
  {
    word: "thông lượng",
    part_of_speech: "danh từ",
    meaning:
      "đại lượng chỉ lượng di chuyển qua bề mặt vuông góc với hướng di chuyển trong một đơn vị thời gian: thông lượng của dòng nước * thông lượng bức xạ * thông lượng đường truyền",
    example:
      "thông lượng của dòng nước * thông lượng bức xạ * thông lượng đường truyền",
  },
  {
    word: "thông qua",
    part_of_speech: "động từ",
    meaning:
      "(cơ quan hoặc người có thẩm quyền) đồng ý chấp thuận cho được thực hiện, sau khi đã xem xét, thảo luận: thông qua nghị quyết * bản dự thảo đã được quốc hội thông qua",
    example: "thông qua nghị quyết * bản dự thảo đã được quốc hội thông qua",
  },
  {
    word: "thông qua",
    part_of_speech: "động từ",
    meaning:
      "nhờ vào, dựa vào khâu trung gian để thực hiện một công việc nào đó, khi không thể thực hiện trực tiếp: ủng hộ đồng bào bị lũ lụt thông qua quỹ",
    example: "ủng hộ đồng bào bị lũ lụt thông qua quỹ",
  },
  {
    word: "thông minh",
    part_of_speech: "tính từ",
    meaning:
      "có năng lực trí tuệ tốt, hiểu nhanh, tiếp thu nhanh: thằng bé rất thông minh",
    example: "thằng bé rất thông minh",
  },
  {
    word: "thông minh",
    part_of_speech: "tính từ",
    meaning:
      "nhanh trí và khôn khéo, có khả năng ứng xử và đối phó mau lẹ, tinh tế với những tình huống phức tạp, bất ngờ: câu trả lời thông minh * cách giải quyết rất thông minh",
    example: "câu trả lời thông minh * cách giải quyết rất thông minh",
  },
  {
    word: "thống nhất",
    part_of_speech: "động từ",
    meaning:
      "hợp lại thành một khối với một cơ cấu tổ chức và sự điều hành quản lí chung: thống nhất đất nước * thống nhất các lực lượng vũ trang",
    example: "thống nhất đất nước * thống nhất các lực lượng vũ trang",
  },
  {
    word: "thống nhất",
    part_of_speech: "động từ",
    meaning:
      "làm cho phù hợp với nhau, không mâu thuẫn nhau: thống nhất đồng hồ trước trận đấu * hai người đã thống nhất ngày cưới",
    example:
      "thống nhất đồng hồ trước trận đấu * hai người đã thống nhất ngày cưới",
  },
  {
    word: "thống nhất",
    part_of_speech: "tính từ",
    meaning:
      "có sự phù hợp, nhất trí với nhau, không mâu thuẫn nhau: kế hoạch còn thiếu thống nhất * ý kiến không thống nhất",
    example: "kế hoạch còn thiếu thống nhất * ý kiến không thống nhất",
  },
  {
    word: "thông ngôn",
    part_of_speech: "động từ",
    meaning: "(cũ) phiên dịch miệng: thông ngôn cho giám đốc",
    example: "thông ngôn cho giám đốc",
  },
  {
    word: "thông quan",
    part_of_speech: "động từ",
    meaning:
      "thông qua các thủ tục hải quan và được phép xuất nhập khẩu qua cửa khẩu (thường nói về hàng hoá): thông quan hàng hoá * làm thủ tục thông quan xe",
    example: "thông quan hàng hoá * làm thủ tục thông quan xe",
  },
  {
    word: "thông suốt",
    part_of_speech: "động từ",
    meaning:
      "thông từ đầu đến cuối, không bị gián đoạn, vướng mắc: tuyến đường giao thông đã thông suốt",
    example: "tuyến đường giao thông đã thông suốt",
  },
  {
    word: "thông suốt",
    part_of_speech: "động từ",
    meaning:
      "hiểu rõ và tán thành hoàn toàn, không còn điều gì băn khoăn, thắc mắc nữa: tư tưởng đã thông suốt",
    example: "tư tưởng đã thông suốt",
  },
  {
    word: "thông tầm",
    part_of_speech: "tính từ",
    meaning:
      "(thời gian làm việc) liền một mạch thành một buổi, chứ không chia làm hai buổi: làm thông tầm",
    example: "làm thông tầm",
  },
  {
    word: "thông tấn xã",
    part_of_speech: "danh từ",
    meaning: "cơ quan chuyên làm nhiệm vụ thông tấn: thông tấn xã Việt Nam",
    example: "thông tấn xã Việt Nam",
  },
  {
    word: "thông số",
    part_of_speech: "danh từ",
    meaning: "(hiếm)",
    example: "đảm bảo các thông số kĩ thuật",
  },
  {
    word: "thông tấn",
    part_of_speech: "động từ",
    meaning:
      "thu thập và biên tập tin tức để cung cấp cho các nơi: phóng viên thông tấn * hãng thông tấn",
    example: "phóng viên thông tấn * hãng thông tấn",
  },
  {
    word: "thông thái",
    part_of_speech: "tính từ",
    meaning: "có kiến thức sâu rộng: nhà thông thái",
    example: "nhà thông thái",
  },
  {
    word: "thông thạo",
    part_of_speech: "động từ",
    meaning:
      "hiểu biết và nắm rất rõ, có thể làm hoặc sử dụng một cách thành thạo: nói tiếng Anh thông thạo * thông thạo đường đi lối lại trong làng",
    example:
      "nói tiếng Anh thông thạo * thông thạo đường đi lối lại trong làng",
  },
  {
    word: "thống thiết",
    part_of_speech: "tính từ",
    meaning: "rất đau xót, gợi lòng thương cảm: cầu xin thống thiết",
    example: "cầu xin thống thiết",
  },
  {
    word: "thông thoáng",
    part_of_speech: "tính từ",
    meaning:
      "rộng rãi, thoáng đãng, có nhiều khoảng trống tạo điều kiện cho việc lưu thông một cách dễ dàng: đường sá thông thoáng",
    example: "đường sá thông thoáng",
  },
  {
    word: "thông thoáng",
    part_of_speech: "tính từ",
    meaning:
      "rộng rãi, không bảo thủ, không gò bó, tạo điều kiện thuận lợi cho sự phát triển: chính sách thông thoáng * môi trường kinh doanh thông thoáng",
    example: "chính sách thông thoáng * môi trường kinh doanh thông thoáng",
  },
  {
    word: "thông thốc",
    part_of_speech: "phụ từ",
    meaning:
      "một cách nhanh, mạnh, liên tiếp, như không gì ngăn giữ nổi: nhà trống, gió thổi thông thốc",
    example: "nhà trống, gió thổi thông thốc",
  },
  {
    word: "thông thường",
    part_of_speech: "tính từ",
    meaning:
      "thường có, thường thấy, không có gì lạ hoặc đặc biệt: đồ dùng thông thường * học một khóa giao tiếp tiếng Anh thông thường",
    example:
      "đồ dùng thông thường * học một khóa giao tiếp tiếng Anh thông thường",
  },
  {
    word: "thông thường",
    part_of_speech: "tính từ",
    meaning: "theo như lệ thường: thông thường, cứ 5 giờ là ông đã tỉnh giấc",
    example: "thông thường, cứ 5 giờ là ông đã tỉnh giấc",
  },
  {
    word: "thông thuộc",
    part_of_speech: "động từ",
    meaning:
      "biết tường tận và nhớ rất rõ: thông thuộc mọi ngõ ngách trong làng",
    example: "thông thuộc mọi ngõ ngách trong làng",
  },
  {
    word: "thông thương",
    part_of_speech: "động từ",
    meaning:
      "buôn bán qua lại giữa các vùng hoặc các nước với nhau: thông thương hàng hoá * quan hệ thông thương giữa các nước",
    example: "thông thương hàng hoá * quan hệ thông thương giữa các nước",
  },
  {
    word: "thông thương",
    part_of_speech: "động từ",
    meaning:
      "(cũ) thông suốt từ vùng nọ sang vùng kia, không bị ngăn cách, cản trở: đường đất thông thương * thông thương cửa khẩu",
    example: "đường đất thông thương * thông thương cửa khẩu",
  },
  {
    word: "thông tin",
    part_of_speech: "động từ",
    meaning:
      "truyền tin, báo tin cho người khác biết: thông tin sai sự thật * thông tin cho mọi người cùng biết",
    example: "thông tin sai sự thật * thông tin cho mọi người cùng biết",
  },
  {
    word: "thông tin",
    part_of_speech: "danh từ",
    meaning:
      "điều hoặc tin được truyền đi cho biết (nói khái quát): bài viết có lượng thông tin cao",
    example: "bài viết có lượng thông tin cao",
  },
  {
    word: "thông tin",
    part_of_speech: "danh từ",
    meaning:
      "sự truyền đạt, sự phản ánh tri thức dưới các hình thức khác nhau, cho biết về thế giới xung quanh và những quá trình xảy ra trong nó: xử lí thông tin trên máy tính",
    example: "xử lí thông tin trên máy tính",
  },
  {
    word: "thông thống",
    part_of_speech: "tính từ",
    meaning:
      "trống trải tới mức có thể nhìn thông suốt từ ngoài vào, không có gì ngăn che: cửa ngõ để thông thống",
    example: "cửa ngõ để thông thống",
  },
  {
    word: "thông tỏ",
    part_of_speech: "động từ",
    meaning:
      "biết rất rõ và tường tận (nói khái quát): thông tỏ đầu đuôi câu chuyện * thông tỏ mọi đường ngang ngõ tắt trong làng",
    example:
      "thông tỏ đầu đuôi câu chuyện * thông tỏ mọi đường ngang ngõ tắt trong làng",
  },
  {
    word: "thống trị",
    part_of_speech: "động từ",
    meaning:
      "nắm và sử dụng bộ máy chính quyền để điều khiển, quản lí, chi phối mọi mặt: giai cấp thống trị",
    example: "giai cấp thống trị",
  },
  {
    word: "thống trị",
    part_of_speech: "động từ",
    meaning:
      "giữ vai trò chủ đạo và chi phối tất cả: học thuyết nho giáo thống trị trong nhiều năm",
    example: "học thuyết nho giáo thống trị trong nhiều năm",
  },
  {
    word: "thông tri",
    part_of_speech: "danh từ",
    meaning: "bản thông tri: ra thông tri",
    example: "ra thông tri",
  },
  {
    word: "thông tín viên",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người làm nhiệm vụ cung cấp tin tức hoặc viết bài cho một tờ báo hoặc tạp chí, nhưng không thuộc biên chế toà soạn: thông tín viên tờ nhật báo",
    example: "thông tín viên tờ nhật báo",
  },
  {
    word: "thông tín viên",
    part_of_speech: "danh từ",
    meaning:
      "người chuyên làm công tác tiếp nhận hoặc chuyển phát thông tin, tín hiệu: thông tín viên của trung tâm cứu nạn",
    example: "thông tín viên của trung tâm cứu nạn",
  },
  {
    word: "thông tục",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) phổ biến và đơn giản, phù hợp với trình độ, với cách hiểu của quần chúng đông đảo: lời văn thông tục * theo cách hiểu thông tục",
    example: "lời văn thông tục * theo cách hiểu thông tục",
  },
  {
    word: "thông tục",
    part_of_speech: "tính từ",
    meaning:
      "(từ ngữ) có tính tự nhiên, dễ dãi, thường chỉ quen dùng trong lớp người gọi là kém văn hoá: dùng những từ ngữ thông tục",
    example: "dùng những từ ngữ thông tục",
  },
  {
    word: "thộp",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tóm giữ lấy bằng một động tác nhanh, gọn và đột ngột: thộp được tên kẻ cắp",
    example: "thộp được tên kẻ cắp",
  },
  {
    word: "thông tư",
    part_of_speech: "danh từ",
    meaning:
      "văn bản giải thích, hướng dẫn thực hiện những văn bản của nhà nước ban hành, thường thuộc phạm vi quản lí của một ngành nhất định: ra thông tư * thông tư liên bộ",
    example: "ra thông tư * thông tư liên bộ",
  },
  {
    word: "thốt nhiên",
    part_of_speech: "phụ từ",
    meaning:
      "thình lình và rất nhanh (thường nói về sự xảy ra của một hiện tượng tâm lí): đang đi thốt nhiên dừng lại * thốt nhiên nhớ ra",
    example: "đang đi thốt nhiên dừng lại * thốt nhiên nhớ ra",
  },
  {
    word: "thốt",
    part_of_speech: "động từ",
    meaning:
      '(Từ cũ) nói: "Hoa cười ngọc thốt đoan trang, Mây thua nước tóc, tuyết nhường màu da." (TKiều)',
    example:
      'Hoa cười ngọc thốt đoan trang, Mây thua nước tóc, tuyết nhường màu da." (TKiều)',
  },
  {
    word: "thốt",
    part_of_speech: "động từ",
    meaning:
      "bật ra thành tiếng, thành lời một cách tự nhiên và thình lình: thốt lên kinh ngạc * thốt ra những lời oán trách",
    example: "thốt lên kinh ngạc * thốt ra những lời oán trách",
  },
  {
    word: "thốt",
    part_of_speech: "phụ từ",
    meaning:
      "(hoạt động, trạng thái tâm lí - tình cảm xảy ra) đột ngột và rất nhanh, chỉ trong thời gian rất ngắn: thốt nhớ ra * thốt kêu lên",
    example: "thốt nhớ ra * thốt kêu lên",
  },
  {
    word: "thốt nốt",
    part_of_speech: "danh từ",
    meaning:
      "cây cùng họ với dừa, thân thẳng và cao, lá hình quạt, ở cuống cụm hoa có thể lấy được một chất nước ngọt dùng để chế đường: đường thốt nốt * rừng thốt nốt",
    example: "đường thốt nốt * rừng thốt nốt",
  },
  {
    word: "thợ",
    part_of_speech: "danh từ",
    meaning:
      "người lao động chân tay làm một nghề nào đó để lấy tiền công: thợ mộc * thợ sửa chữa xe máy",
    example: "thợ mộc * thợ sửa chữa xe máy",
  },
  {
    word: "thớ",
    part_of_speech: "danh từ",
    meaning:
      "đường dọc có dạng hình sợi trong cấu tạo của thịt, gỗ, đất đá, v.v: thịt thái ngang thớ * đục theo thớ đá",
    example: "thịt thái ngang thớ * đục theo thớ đá",
  },
  {
    word: "thờ",
    part_of_speech: "động từ",
    meaning:
      "tỏ lòng tôn kính thần thánh, vật thiêng hoặc linh hồn người chết bằng hình thức lễ nghi, cúng bái theo phong tục hoặc tín ngưỡng: bức ảnh thờ (ảnh của người đã chết được dùng để thờ) * đền thờ thánh Tản Viên",
    example:
      "bức ảnh thờ (ảnh của người đã chết được dùng để thờ) * đền thờ thánh Tản Viên",
  },
  {
    word: "thơ ấu",
    part_of_speech: "tính từ",
    meaning:
      "(thời) rất ít tuổi, còn thơ ngây, bé dại: những ngày thơ ấu * thời thơ ấu",
    example: "những ngày thơ ấu * thời thơ ấu",
  },
  {
    word: "thơ",
    part_of_speech: "danh từ",
    meaning:
      "hình thức nghệ thuật dùng ngôn ngữ giàu hình ảnh và có nhịp điệu, vần điệu để thể hiện nội dung một cách hàm súc: làm thơ * ngâm thơ thưởng nguyệt",
    example: "làm thơ * ngâm thơ thưởng nguyệt",
  },
  {
    word: "thơ",
    part_of_speech: "tính từ",
    meaning: "như nên thơ: phong cảnh rất thơ",
    example: "phong cảnh rất thơ",
  },
  {
    word: "thơ",
    part_of_speech: "tính từ",
    meaning: "còn nhỏ tuổi, còn bé dại (nói khái quát): con thơ * thuở còn thơ",
    example: "con thơ * thuở còn thơ",
  },
  {
    word: "thở",
    part_of_speech: "động từ",
    meaning:
      "hít không khí vào lồng ngực, vào cơ thể rồi đưa trở ra qua mũi, miệng (điều kiện và biểu hiện của sự sống): thấy khó thở * ngạt mũi, phải thở bằng miệng",
    example: "thấy khó thở * ngạt mũi, phải thở bằng miệng",
  },
  {
    word: "thở",
    part_of_speech: "động từ",
    meaning:
      "(cơ thể sinh vật) thực hiện chức năng hấp thụ oxygen và thải khí carbonic để đảm bảo sự sống: cây thở chủ yếu bằng lá",
    example: "cây thở chủ yếu bằng lá",
  },
  {
    word: "thở",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) buông ra những điều không hay: thở ra những câu bất lịch sự",
    example: "thở ra những câu bất lịch sự",
  },
  {
    word: "thơ ca",
    part_of_speech: "danh từ",
    meaning:
      "sáng tác văn học theo thể loại văn vần (nói khái quát): tuyển tập thơ ca",
    example: "tuyển tập thơ ca",
  },
  {
    word: "thờ cúng",
    part_of_speech: "động từ",
    meaning: "thờ và cúng (nói khái quát): thờ cúng tổ tiên",
    example: "thờ cúng tổ tiên",
  },
  {
    word: "thở hắt",
    part_of_speech: "động từ",
    meaning:
      "thở mạnh ra bằng luồng hơi ngắn và dứt khoát, thường là trước khi chết: người bệnh đã thở hắt",
    example: "người bệnh đã thở hắt",
  },
  {
    word: "thơ dại",
    part_of_speech: "tính từ",
    meaning:
      "rất ít tuổi, còn non nớt chưa biết gì (nói khái quát): con còn thơ dại",
    example: "con còn thơ dại",
  },
  {
    word: "thở dài",
    part_of_speech: "động từ",
    meaning:
      "thở ra một hơi dài khi có điều phiền muộn, bức bối ở trong lòng: bật ra một tiếng thở dài * thở dài ngao ngán",
    example: "bật ra một tiếng thở dài * thở dài ngao ngán",
  },
  {
    word: "thờ kính",
    part_of_speech: "động từ",
    meaning: "thờ phụng với tấm lòng tôn kính: thờ kính cha mẹ",
    example: "thờ kính cha mẹ",
  },
  {
    word: "thớ lợ",
    part_of_speech: "tính từ",
    meaning:
      "có vẻ giả tạo, thiếu chân thật, chỉ được cái khéo léo bề ngoài: cười thớ lợ * ghét kiểu người thớ lợ",
    example: "cười thớ lợ * ghét kiểu người thớ lợ",
  },
  {
    word: "thơ mộng",
    part_of_speech: "tính từ",
    meaning:
      "rất nên thơ, gợi lên những cảm xúc dịu dàng và đẹp đẽ: dòng sông thơ mộng * mối tình đầu thơ mộng",
    example: "dòng sông thơ mộng * mối tình đầu thơ mộng",
  },
  {
    word: "thơ ngây",
    part_of_speech: "tính từ",
    meaning: "như ngây thơ: gương mặt thơ ngây",
    example: "gương mặt thơ ngây",
  },
  {
    word: "thở phào",
    part_of_speech: "động từ",
    meaning:
      "thở ra một hơi dài vẻ khoan khoái, nhẹ nhõm vì đã trút được điều đè nặng trong lòng: thở phào nhẹ nhõm",
    example: "thở phào nhẹ nhõm",
  },
  {
    word: "thờ phụng",
    part_of_speech: "động từ",
    meaning: "như thờ cúng: thờ phụng tổ tiên",
    example: "thờ phụng tổ tiên",
  },
  {
    word: "thờ phụng",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) chăm sóc, nuôi dưỡng một cách tôn kính: hết lòng thờ phụng mẹ già",
    example: "hết lòng thờ phụng mẹ già",
  },
  {
    word: "thờ phụng",
    part_of_speech: "động từ",
    meaning: "(hiếm) tôn thờ và phụng sự: thờ phụng lí tưởng",
    example: "thờ phụng lí tưởng",
  },
  {
    word: "thờ ơ",
    part_of_speech: "",
    meaning:
      "tỏ ra lạnh nhạt, không hề quan tâm, để ý tới, không hề có chút tình cảm gì: thờ ơ với thời cuộc * đối xử thờ ơ, lạnh nhạt",
    example: "thờ ơ với thời cuộc * đối xử thờ ơ, lạnh nhạt",
  },
  {
    word: "thơ thẩn",
    part_of_speech: "động từ",
    meaning:
      "đi lại một cách chậm rãi và lặng lẽ, như đang suy nghĩ vẩn vơ, lan man về điều gì: thơ thẩn dạo quanh hồ * đi thơ thẩn ngoài đường",
    example: "thơ thẩn dạo quanh hồ * đi thơ thẩn ngoài đường",
  },
  {
    word: "thơ thẩn",
    part_of_speech: "động từ",
    meaning:
      "hoặc t có vẻ như đang vẩn vơ, mơ màng suy nghĩ về một điều gì đó: buồn thơ thẩn * ngồi thơ thẩn một mình",
    example: "buồn thơ thẩn * ngồi thơ thẩn một mình",
  },
  {
    word: "thợ thuyền",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) công nhân (nói khái quát): anh em thợ thuyền * giai cấp thợ thuyền",
    example: "anh em thợ thuyền * giai cấp thợ thuyền",
  },
  {
    word: "thở than",
    part_of_speech: "động từ",
    meaning: "như than thở: khóc lóc thở than",
    example: "khóc lóc thở than",
  },
  {
    word: "thợ trời",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) tạo hoá: "Thợ trời dù hẳn vô tình, Làm chi đem thói khuynh thành trêu ai?" (TKiều)',
    example:
      'Thợ trời dù hẳn vô tình, Làm chi đem thói khuynh thành trêu ai?" (TKiều)',
  },
  {
    word: "thơ văn",
    part_of_speech: "danh từ",
    meaning: "như văn thơ: thơ văn cách mạng * sáng tác thơ văn",
    example: "thơ văn cách mạng * sáng tác thơ văn",
  },
  {
    word: "thơ trẻ",
    part_of_speech: "tính từ",
    meaning: "(hiếm) còn bé nhỏ, thơ dại (nói khái quát): quãng đời thơ trẻ",
    example: "quãng đời thơ trẻ",
  },
  {
    word: "thờ tự",
    part_of_speech: "động từ",
    meaning: "(cũ) như thờ cúng: đứa con thờ tự",
    example: "đứa con thờ tự",
  },
  {
    word: "thời",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian dài được xác định một cách đại khái, về mặt có những đặc điểm, những sự kiện lớn nào đó: thời kháng chiến * thời thanh niên sôi nổi * nổi tiếng một thời",
    example: "thời kháng chiến * thời thanh niên sôi nổi * nổi tiếng một thời",
  },
  {
    word: "thời",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian thuận lợi hoặc thích hợp để làm một việc gì: giải quyết kịp thời * gặp thời, phất lên nhanh chóng",
    example: "giải quyết kịp thời * gặp thời, phất lên nhanh chóng",
  },
  {
    word: "thời",
    part_of_speech: "danh từ",
    meaning:
      "phạm trù ngữ pháp của động từ trong một số ngôn ngữ, biểu thị mối quan hệ giữa hành động, sự việc xảy ra với thời gian lúc đang nói: thời quá khứ * thời hiện tại",
    example: "thời quá khứ * thời hiện tại",
  },
  {
    word: "thời bình",
    part_of_speech: "danh từ",
    meaning:
      "thời kì hoà bình, không có chiến tranh, loạn lạc: sống trong thời bình * trai thời loạn, gái thời bình (tng)",
    example: "sống trong thời bình * trai thời loạn, gái thời bình (tng)",
  },
  {
    word: "thời buổi",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) khoảng thời gian được xác định đại khái về mặt có những điều kiện sinh hoạt chung nào đó (thường là không tốt) trong xã hội: thời buổi khó khăn * thời buổi kinh tế thị trường",
    example: "thời buổi khó khăn * thời buổi kinh tế thị trường",
  },
  {
    word: "thời chiến",
    part_of_speech: "danh từ",
    meaning:
      "thời kì đang có chiến tranh: chuyển từ thời bình sang thời chiến * tác phong thời chiến",
    example: "chuyển từ thời bình sang thời chiến * tác phong thời chiến",
  },
  {
    word: "thời cơ",
    part_of_speech: "danh từ",
    meaning:
      "điều kiện khách quan thuận lợi trong một thời gian tương đối ngắn: thời cơ đã chín muồi * bỏ lỡ thời cơ",
    example: "thời cơ đã chín muồi * bỏ lỡ thời cơ",
  },
  {
    word: "thời cuộc",
    part_of_speech: "danh từ",
    meaning:
      "tình hình xã hội - chính trị chung trong một thời gian cụ thể nào đó: nhạy bén với thời cuộc",
    example: "nhạy bén với thời cuộc",
  },
  {
    word: "thời đại",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian lịch sử dài được phân chia ra theo những sự kiện có đặc trưng giống nhau: thời đại phong kiến * thời đại công nghệ thông tin",
    example: "thời đại phong kiến * thời đại công nghệ thông tin",
  },
  {
    word: "thời đại",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất tiêu biểu cho một thời đại: người anh hùng thời đại * công trình mang tầm vóc thời đại",
    example: "người anh hùng thời đại * công trình mang tầm vóc thời đại",
  },
  {
    word: "thời gian",
    part_of_speech: "danh từ",
    meaning:
      "hình thức tồn tại cơ bản của vật chất (cùng với không gian), trong đó vật chất vận động và phát triển liên tục, không ngừng: thời gian và không gian đều là vô tận",
    example: "thời gian và không gian đều là vô tận",
  },
  {
    word: "thời gian",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian nhất định xét về mặt dài ngắn, nhanh chậm của nó: có đủ thời gian để chuẩn bị * bớt chút thời gian",
    example: "có đủ thời gian để chuẩn bị * bớt chút thời gian",
  },
  {
    word: "thời gian",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian trong đó một sự việc gì diễn ra từ đầu cho đến cuối: lấy nhau sau một thời gian tìm hiểu",
    example: "lấy nhau sau một thời gian tìm hiểu",
  },
  {
    word: "thời đoạn",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian đại khái tương đối dài, về mặt có đặc điểm nào đó: một thời đoạn lịch sử hào hùng",
    example: "một thời đoạn lịch sử hào hùng",
  },
  {
    word: "thời điểm",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian cực ngắn được xác định một cách chính xác, coi như một điểm trên trục thời gian: thời điểm giao thừa * hẹn gặp vào thời điểm 8 giờ 30 phút",
    example: "thời điểm giao thừa * hẹn gặp vào thời điểm 8 giờ 30 phút",
  },
  {
    word: "thời điểm",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian ngắn được hạn định một cách tương đối chính xác về mặt nào đó: thời điểm gay go nhất * ghi bàn đúng vào thời điểm kết thúc trận đấu",
    example:
      "thời điểm gay go nhất * ghi bàn đúng vào thời điểm kết thúc trận đấu",
  },
  {
    word: "thời gian biểu",
    part_of_speech: "danh từ",
    meaning:
      "bản kê thời gian và trình tự làm các công việc khác nhau theo quy định (thường là trong ngày, trong tuần lễ): lập thời gian biểu * thực hiện đúng thời gian biểu",
    example: "lập thời gian biểu * thực hiện đúng thời gian biểu",
  },
  {
    word: "thời giá",
    part_of_speech: "danh từ",
    meaning:
      "giá cả hàng hoá trong một khoảng thời gian nhất định nào đó: tính theo thời giá lúc bấy giờ",
    example: "tính theo thời giá lúc bấy giờ",
  },
  {
    word: "thời hiệu",
    part_of_speech: "danh từ",
    meaning:
      "thời gian có hiệu lực của một văn bản pháp luật, một quyết định hành chính, một bản án, một hợp đồng, v.v: thời hiệu khiếu nại * thời hiệu tố tụng",
    example: "thời hiệu khiếu nại * thời hiệu tố tụng",
  },
  {
    word: "thời khắc",
    part_of_speech: "danh từ",
    meaning:
      "thời gian, về mặt nối tiếp nhau qua đi: thời khắc chậm chạp trôi đi",
    example: "thời khắc chậm chạp trôi đi",
  },
  {
    word: "thời khắc",
    part_of_speech: "danh từ",
    meaning:
      "thời điểm, thường gắn với một sự kiện có ý nghĩa quan trọng nào đó: thời khắc giao mùa",
    example: "thời khắc giao mùa",
  },
  {
    word: "thời khí",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) điều kiện thời tiết trong một khoảng thời gian nào đó trong năm: bị ốm vì thời khí bất thường",
    example: "bị ốm vì thời khí bất thường",
  },
  {
    word: "thời khoá biểu",
    part_of_speech: "danh từ",
    meaning:
      "bản kê thời gian lên lớp các môn học khác nhau của từng ngày trong tuần: chép thời khoá biểu của năm học mới",
    example: "chép thời khoá biểu của năm học mới",
  },
  {
    word: "thời hạn",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian quy định để làm một công việc nào đó: hoàn thành chỉ tiêu trước thời hạn được giao",
    example: "hoàn thành chỉ tiêu trước thời hạn được giao",
  },
  {
    word: "thời kì",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian được phân chia ra theo một sự việc hay sự kiện nào đó: thời kì sinh nở * thời kì kháng chiến",
    example: "thời kì sinh nở * thời kì kháng chiến",
  },
  {
    word: "thời sự",
    part_of_speech: "danh từ",
    meaning:
      "tổng thể nói chung những sự việc ít nhiều quan trọng trong một lĩnh vực nào đó, thường là xã hội - chính trị, xảy ra trong thời gian gần nhất và đang được nhiều người quan tâm: bản tin thời sự * chương trình thời sự quốc tế",
    example: "bản tin thời sự * chương trình thời sự quốc tế",
  },
  {
    word: "thời sự",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có tính chất thời sự, đang được nhiều người quan tâm: đề tài có tính thời sự cao * việc quy hoạch đô thị đang là vấn đề thời sự",
    example:
      "đề tài có tính thời sự cao * việc quy hoạch đô thị đang là vấn đề thời sự",
  },
  {
    word: "thời giờ",
    part_of_speech: "danh từ",
    meaning:
      "thời gian, về mặt sử dụng có ích cho con người: có đủ thì giờ chuẩn bị * chẳng có thì giờ đâu mà để tâm đến chuyện ấy",
    example:
      "có đủ thì giờ chuẩn bị * chẳng có thì giờ đâu mà để tâm đến chuyện ấy",
  },
  {
    word: "thời lượng",
    part_of_speech: "danh từ",
    meaning:
      "lượng thời gian dành cho một hoạt động nào đó: tăng thời lượng phát sóng trên truyền hình",
    example: "tăng thời lượng phát sóng trên truyền hình",
  },
  {
    word: "thời tiết",
    part_of_speech: "danh từ",
    meaning:
      "trạng thái của khí quyển như nhiệt độ, độ ẩm, mưa, gió, v.v., ở một nơi vào một thời điểm nhất định: dự báo thời tiết * thời tiết ấm áp",
    example: "dự báo thời tiết * thời tiết ấm áp",
  },
  {
    word: "thời vận",
    part_of_speech: "danh từ",
    meaning: "===== vận may: thử thời vận * thời vận đen đủi",
    example: "thử thời vận * thời vận đen đủi",
  },
  {
    word: "thời vận",
    part_of_speech: "danh từ",
    meaning:
      "vận may: thời vận chưa đến * gặp thời vận, anh ta phất lên nhanh chóng",
    example: "thời vận chưa đến * gặp thời vận, anh ta phất lên nhanh chóng",
  },
  {
    word: "thời thượng",
    part_of_speech: "",
    meaning:
      "sự ưa chuộng trong một khoảng thời gian nào đó của số đông người trong xã hội đối với một lối sống hay những kiểu sinh hoạt nào đó: mốt thời thượng",
    example: "mốt thời thượng",
  },
  {
    word: "thời kỳ",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian được phân chia ra theo một sự việc hay sự kiện nào đó: thời kì sinh nở * thời kì kháng chiến",
    example: "thời kì sinh nở * thời kì kháng chiến",
  },
  {
    word: "thời thế",
    part_of_speech: "danh từ",
    meaning:
      "tình thế, hoàn cảnh chung của xã hội trong một thời kì: thời thế đổi thay * xoay chuyển thời thế * thời thế tạo anh hùng",
    example: "thời thế đổi thay * xoay chuyển thời thế * thời thế tạo anh hùng",
  },
  {
    word: "thời trang",
    part_of_speech: "",
    meaning:
      "cách ăn mặc, trang điểm được ưa chuộng trong một thời gian nào đó: nhà thiết kế thời trang * ăn mặc rất thời trang",
    example: "nhà thiết kế thời trang * ăn mặc rất thời trang",
  },
  {
    word: "thơm lừng",
    part_of_speech: "tính từ",
    meaning: "có mùi thơm lan toả ra mạnh và rộng khắp: mùi hoa sữa thơm lừng",
    example: "mùi hoa sữa thơm lừng",
  },
  {
    word: "thơm",
    part_of_speech: "danh từ",
    meaning: "(Nam) dứa: trái thơm",
    example: "trái thơm",
  },
  {
    word: "thơm",
    part_of_speech: "động từ",
    meaning: "hôn (thường nói về trẻ em): mẹ thơm lên má bé",
    example: "mẹ thơm lên má bé",
  },
  {
    word: "thơm",
    part_of_speech: "tính từ",
    meaning:
      "có mùi như mùi hương của hoa, dễ chịu, làm cho thích ngửi: hương thơm * cuốn sách còn thơm mùi giấy mới",
    example: "hương thơm * cuốn sách còn thơm mùi giấy mới",
  },
  {
    word: "thơm",
    part_of_speech: "tính từ",
    meaning:
      "(tiếng tăm) tốt, được người đời nhắc đến và ca ngợi: được tiếng thơm * đói cho sạch, rách cho thơm (tng)",
    example: "được tiếng thơm * đói cho sạch, rách cho thơm (tng)",
  },
  {
    word: "thơm lựng",
    part_of_speech: "tính từ",
    meaning:
      "có mùi thơm đậm đà, tác động mạnh đến khứu giác: mít chít thơm lựng",
    example: "mít chít thơm lựng",
  },
  {
    word: "thời vụ",
    part_of_speech: "danh từ",
    meaning:
      "thời gian thích hợp nhất trong năm để tiến hành một hoạt động sản xuất nào đó trong nông, lâm, ngư nghiệp: gieo trồng cho kịp thời vụ * thời vụ đánh bắt cá",
    example: "gieo trồng cho kịp thời vụ * thời vụ đánh bắt cá",
  },
  {
    word: "thơm lây",
    part_of_speech: "tính từ",
    meaning:
      '(khẩu ngữ) được hưởng một phần tiếng tốt và vinh dự của người khác do có quan hệ gần gũi: "Chị dù thịt nát xương mòn, Ngậm cười chín suối, hãy còn thơm lây." (TKiều)',
    example:
      'Chị dù thịt nát xương mòn, Ngậm cười chín suối, hãy còn thơm lây." (TKiều)',
  },
  {
    word: "thơm phức",
    part_of_speech: "tính từ",
    meaning:
      "có mùi thơm bốc lên mạnh và hấp dẫn (thường nói về thức ăn): mùi nước hoa thơm phức",
    example: "mùi nước hoa thơm phức",
  },
  {
    word: "thơm ngát",
    part_of_speech: "tính từ",
    meaning: "có mùi thơm dễ chịu và toả lan ra xa: hương bưởi thơm ngát",
    example: "hương bưởi thơm ngát",
  },
  {
    word: "thơm nức",
    part_of_speech: "tính từ",
    meaning: "có mùi thơm bốc lên mạnh và lan toả rộng: thơm nức mùi hoa sữa",
    example: "thơm nức mùi hoa sữa",
  },
  {
    word: "thơm thảo",
    part_of_speech: "tính từ",
    meaning:
      "tốt bụng, sẵn sàng chia sẻ những cái mình có cho người khác: tấm lòng thơm thảo",
    example: "tấm lòng thơm thảo",
  },
  {
    word: "thơm tho",
    part_of_speech: "tính từ",
    meaning:
      "thơm và gây cảm giác dễ chịu (nói khái quát): quần áo sạch sẽ, thơm tho",
    example: "quần áo sạch sẽ, thơm tho",
  },
  {
    word: "thớt",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng bằng gỗ rắn hoặc bằng nhựa cứng, có mặt phẳng, dùng để kê đồ ăn lên mà thái, chặt, băm: trơ như mặt thớt",
    example: "trơ như mặt thớt",
  },
  {
    word: "thớt",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị những vật có hình tảng hay hình khối với bề mặt phẳng: thớt trên của cối xay lúa",
    example: "thớt trên của cối xay lúa",
  },
  {
    word: "thơn thớt",
    part_of_speech: "tính từ",
    meaning:
      '(nói cười) có vẻ tử tế, ngọt ngào, nhưng chỉ ở ngoài miệng, không thật lòng: "Bề ngoài thơn thớt nói cười, Mà trong nham hiểm giết người không dao." (TKiều)',
    example:
      'Bề ngoài thơn thớt nói cười, Mà trong nham hiểm giết người không dao." (TKiều)',
  },
  {
    word: "thù",
    part_of_speech: "danh từ",
    meaning:
      "lòng căm hận sâu sắc đối với kẻ đã từng gây hại lớn cho mình và luôn nung nấu ý muốn bắt kẻ đó phải chịu sự trừng phạt tương ứng: mối thù * xoá bỏ thù cũ * nợ nước thù nhà",
    example: "mối thù * xoá bỏ thù cũ * nợ nước thù nhà",
  },
  {
    word: "thù",
    part_of_speech: "danh từ",
    meaning:
      "kẻ đã gây thù cho mình: thù trong giặc ngoài * không phân biệt được bạn với thù",
    example: "thù trong giặc ngoài * không phân biệt được bạn với thù",
  },
  {
    word: "thù",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) có thù với kẻ nào đó: thù nhau ra mặt",
    example: "thù nhau ra mặt",
  },
  {
    word: "thủ",
    part_of_speech: "danh từ",
    meaning:
      "đầu của gia súc đã giết thịt (thường nói về đầu lợn): thịt thủ * giò thủ",
    example: "thịt thủ * giò thủ",
  },
  {
    word: "thủ",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) đảm nhiệm một vai trò cụ thể nào đó trong một công việc có nhiều người tham gia: thủ vai chính trong vở chèo",
    example: "thủ vai chính trong vở chèo",
  },
  {
    word: "thủ",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) giấu sẵn trong mình hoặc chuẩn bị sẵn để phòng khi phải đối phó thì dùng đến: thủ sẵn dao trong người * thủ tài liệu vào phòng thi",
    example: "thủ sẵn dao trong người * thủ tài liệu vào phòng thi",
  },
  {
    word: "thủ",
    part_of_speech: "động từ",
    meaning: "(Thông tục) lấy cắp: bị thủ mất cái đồng hồ",
    example: "bị thủ mất cái đồng hồ",
  },
  {
    word: "thủ",
    part_of_speech: "động từ",
    meaning:
      "chống đỡ để tự bảo vệ trước sự tiến công của đối phương: giữ thế thủ * một võ sĩ có khả năng công, thủ toàn diện",
    example: "giữ thế thủ * một võ sĩ có khả năng công, thủ toàn diện",
  },
  {
    word: "thu",
    part_of_speech: "danh từ",
    meaning:
      "mùa chuyển tiếp từ hạ sang đông, thời tiết dịu mát dần: Hà Nội vào thu * gió mùa thu",
    example: "Hà Nội vào thu * gió mùa thu",
  },
  {
    word: "thu",
    part_of_speech: "danh từ",
    meaning:
      '(Từ cũ, Văn chương) năm, dùng để tính thời gian đã trôi qua: "Sầu đong càng lắc càng đầy, Ba thu dồn lại một ngày dài ghê!" (TKiều)',
    example:
      'Sầu đong càng lắc càng đầy, Ba thu dồn lại một ngày dài ghê!" (TKiều)',
  },
  {
    word: "thu",
    part_of_speech: "động từ",
    meaning:
      "nhận lấy, nhận về từ nhiều nguồn, nhiều nơi: thu thuế * tăng thu giảm chi",
    example: "thu thuế * tăng thu giảm chi",
  },
  {
    word: "thu",
    part_of_speech: "động từ",
    meaning:
      "tập trung từ nhiều nơi vào một chỗ: đồ đạc được thu gọn lại một chỗ * non sông thu về một mối (b)",
    example: "đồ đạc được thu gọn lại một chỗ * non sông thu về một mối (b)",
  },
  {
    word: "thu",
    part_of_speech: "động từ",
    meaning:
      "đạt được, có được kết quả nào đó sau một quá trình hoạt động: hội nghị đã thu được những kết quả tốt đẹp",
    example: "hội nghị đã thu được những kết quả tốt đẹp",
  },
  {
    word: "thu",
    part_of_speech: "động từ",
    meaning:
      "ghi lại âm thanh, hình ảnh nào đó bằng những phương tiện máy móc nhất định: thu băng * thu vào ống kính những hình ảnh đẹp",
    example: "thu băng * thu vào ống kính những hình ảnh đẹp",
  },
  {
    word: "thu",
    part_of_speech: "động từ",
    meaning:
      "làm cho nhỏ lại hoặc gọn lại: thu hẹp khoảng cách * thu nhỏ chiếc áo",
    example: "thu hẹp khoảng cách * thu nhỏ chiếc áo",
  },
  {
    word: "thu",
    part_of_speech: "động từ",
    meaning:
      "làm cho thân mình hoặc một bộ phận nào đó của cơ thể gọn lại, choán ít chỗ hơn và thường khó nhận thấy hơn: ngồi thu mình vào một góc * ngồi thu hai chân lên ghế",
    example: "ngồi thu mình vào một góc * ngồi thu hai chân lên ghế",
  },
  {
    word: "thu ba",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) sóng nước mùa thu; thường dùng để ví ánh mắt sáng lóng lánh của người phụ nữ đẹp: "Nàng càng ủ dột thu ba, Đoạn trường lúc ấy nghĩ mà buồn tênh." (TKiều)',
    example:
      'Nàng càng ủ dột thu ba, Đoạn trường lúc ấy nghĩ mà buồn tênh." (TKiều)',
  },
  {
    word: "thú",
    part_of_speech: "danh từ",
    meaning:
      "động vật có xương sống bậc cao, có lông mao và tuyến vú, nuôi con bằng sữa: sao la là một loài thú quý hiếm * mặt người dạ thú (tng)",
    example: "sao la là một loài thú quý hiếm * mặt người dạ thú (tng)",
  },
  {
    word: "thú",
    part_of_speech: "danh từ",
    meaning:
      "điều làm cho người ta cảm thấy vui thích: vui thú điền viên * thú chơi cây cảnh",
    example: "vui thú điền viên * thú chơi cây cảnh",
  },
  {
    word: "thú",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) cảm thấy vui và thích thú khi làm một việc gì đó: bộ phim có nhiều đoạn xem rất thú",
    example: "bộ phim có nhiều đoạn xem rất thú",
  },
  {
    word: "thú",
    part_of_speech: "động từ",
    meaning:
      "tự nhận hoặc nói ra việc đã làm không tốt của mình mà trong thâm tâm muốn che giấu: thú hết mọi tội lỗi * thú chuyện với cha mẹ",
    example: "thú hết mọi tội lỗi * thú chuyện với cha mẹ",
  },
  {
    word: "thủ bút",
    part_of_speech: "danh từ",
    meaning:
      "văn bản, chữ do chính tay người nào đó (thường là của một người có danh tiếng) viết ra: thủ bút của nhà thơ",
    example: "thủ bút của nhà thơ",
  },
  {
    word: "thụ án",
    part_of_speech: "động từ",
    meaning:
      "(người phạm tội sau khi đã bị kết án) chấp hành bản án mà toà đã tuyên: phạm nhân đã hết thời hạn thụ án",
    example: "phạm nhân đã hết thời hạn thụ án",
  },
  {
    word: "thụ cảm",
    part_of_speech: "động từ",
    meaning: "(hiếm) như cảm thụ: khả năng thụ cảm nghệ thuật",
    example: "khả năng thụ cảm nghệ thuật",
  },
  {
    word: "thu binh",
    part_of_speech: "động từ",
    meaning: "như thu quân: phát lệnh thu binh",
    example: "phát lệnh thu binh",
  },
  {
    word: "thu chi",
    part_of_speech: "động từ",
    meaning:
      "thu và chi tiền nong (nói khái quát): lên kế hoạch thu chi * cân đối thu chi",
    example: "lên kế hoạch thu chi * cân đối thu chi",
  },
  {
    word: "thu dọn",
    part_of_speech: "động từ",
    meaning:
      "sắp xếp lại cho gọn gàng, cho khỏi ngổn ngang, bừa bãi: thu dọn nhà cửa * thu dọn đồ nghề",
    example: "thu dọn nhà cửa * thu dọn đồ nghề",
  },
  {
    word: "thủ cựu",
    part_of_speech: "tính từ",
    meaning:
      "rất bảo thủ, chỉ biết khư khư giữ lấy cái cũ, không chịu tiếp thu cái mới: đầu óc thủ cựu",
    example: "đầu óc thủ cựu",
  },
  {
    word: "thủ công",
    part_of_speech: "động từ",
    meaning:
      "lao động sản xuất bằng tay với công cụ giản đơn, thô sơ: hàng thủ công * thợ thủ công",
    example: "hàng thủ công * thợ thủ công",
  },
  {
    word: "thủ công",
    part_of_speech: "danh từ",
    meaning:
      "môn học dạy cho học sinh cách làm những vật đơn giản bằng tay để rèn luyện kĩ năng lao động: tiết thủ công * cắt thủ công",
    example: "tiết thủ công * cắt thủ công",
  },
  {
    word: "thù địch",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) kẻ ở phía đối lập, có mối hận thù một cách sâu sắc (nói khái quát): những phần tử thù địch * hai người là thù địch của nhau",
    example: "những phần tử thù địch * hai người là thù địch của nhau",
  },
  {
    word: "thù địch",
    part_of_speech: "động từ",
    meaning:
      "chống đối lại một cách quyết liệt vì lẽ sống còn: thái độ thù địch",
    example: "thái độ thù địch",
  },
  {
    word: "thú dữ",
    part_of_speech: "danh từ",
    meaning:
      "loài thú lớn, rất dữ, như hổ, báo, v.v., có thể làm hại con người; thường dùng để ví những kẻ hung dữ, độc ác: loài thú dữ",
    example: "loài thú dữ",
  },
  {
    word: "thủ đoạn",
    part_of_speech: "danh từ",
    meaning:
      "cách làm khôn khéo, thường là xảo trá, chỉ cốt sao cho đạt được mục đích: không từ một thủ đoạn nào * giở thủ đoạn bỉ ổi",
    example: "không từ một thủ đoạn nào * giở thủ đoạn bỉ ổi",
  },
  {
    word: "thủ đoạn",
    part_of_speech: "tính từ",
    meaning: "(Khẩu ngữ) có nhiều thủ đoạn: con người thủ đoạn",
    example: "con người thủ đoạn",
  },
  {
    word: "thụ động",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái chỉ chịu sự chi phối, tác động của bên ngoài mà không hề có phản ứng tích cực nào trở lại: tiếp thu kiến thức một cách thụ động",
    example: "tiếp thu kiến thức một cách thụ động",
  },
  {
    word: "thu dụng",
    part_of_speech: "động từ",
    meaning: "tiếp nhận người về và sử dụng: biết thu dụng nhân tài",
    example: "biết thu dụng nhân tài",
  },
  {
    word: "thụ đắc",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) hiểu được, thu nhận được một cách thấu đáo, tường tận: thụ đắc văn hoá nước ngoài * quá trình thụ đắc ngôn ngữ",
    example: "thụ đắc văn hoá nước ngoài * quá trình thụ đắc ngôn ngữ",
  },
  {
    word: "thu dung",
    part_of_speech: "động từ",
    meaning: "đón nhận và cho ở: trạm thu dung thương binh",
    example: "trạm thu dung thương binh",
  },
  {
    word: "thù ghét",
    part_of_speech: "động từ",
    meaning: "căm ghét tới mức coi như kẻ thù: thù ghét quân giặc",
    example: "thù ghét quân giặc",
  },
  {
    word: "thụ giáo",
    part_of_speech: "động từ",
    meaning:
      "(cũ, trang trọng) chịu sự dạy bảo: chúng cháu xin được thụ giáo cụ",
    example: "chúng cháu xin được thụ giáo cụ",
  },
  {
    word: "thu giữ",
    part_of_speech: "động từ",
    meaning:
      "dùng quyền lực giữ lại đồ vật, hàng hoá để chờ xử lí theo pháp luật: thu giữ tang vật của vụ án * thu giữ hàng nhập lậu để chờ xử lí",
    example: "thu giữ tang vật của vụ án * thu giữ hàng nhập lậu để chờ xử lí",
  },
  {
    word: "thu gom",
    part_of_speech: "động từ",
    meaning:
      "lấy từ nhiều nơi, nhiều nguồn để tập trung lại: thu gom nguyên liệu * thu gom rác thải để xử lí",
    example: "thu gom nguyên liệu * thu gom rác thải để xử lí",
  },
  {
    word: "thủ hiến",
    part_of_speech: "danh từ",
    meaning: "(cũ) chức quan đứng đầu một xứ thời Pháp thuộc: thủ hiến Bắc Kì",
    example: "thủ hiến Bắc Kì",
  },
  {
    word: "thủ hiến",
    part_of_speech: "danh từ",
    meaning:
      "người đứng đầu chính quyền của một bang, ở một số nước: thủ hiến bang Victoria của Australia",
    example: "thủ hiến bang Victoria của Australia",
  },
  {
    word: "thù hằn",
    part_of_speech: "",
    meaning: "thù rất sâu sắc: thù hằn lẫn nhau * xóa bỏ thù hằn",
    example: "thù hằn lẫn nhau * xóa bỏ thù hằn",
  },
  {
    word: "thu hẹp",
    part_of_speech: "động từ",
    meaning:
      "làm cho hẹp lại hoặc hạn chế lại trong một phạm vi hẹp hơn: thu hẹp khoảng cách giàu nghèo * rừng ngày càng bị thu hẹp lại",
    example: "thu hẹp khoảng cách giàu nghèo * rừng ngày càng bị thu hẹp lại",
  },
  {
    word: "thu hình",
    part_of_speech: "động từ",
    meaning: "thu nhỏ thân mình lại: ngồi thu hình ở góc nhà",
    example: "ngồi thu hình ở góc nhà",
  },
  {
    word: "thu hình",
    part_of_speech: "động từ",
    meaning:
      "thu lại hình ảnh đang diễn ra ngoài thực tế bằng máy quay phim: thu hình trận bóng đá * máy thu hình",
    example: "thu hình trận bóng đá * máy thu hình",
  },
  {
    word: "thu hoạch",
    part_of_speech: "động từ",
    meaning:
      "gặt hái để thu về những sản phẩm nông nghiệp do kết quả lao động làm ra: thu hoạch cà phê * đến mùa thu hoạch",
    example: "thu hoạch cà phê * đến mùa thu hoạch",
  },
  {
    word: "thu hoạch",
    part_of_speech: "động từ",
    meaning:
      "thu nhận kiến thức, tri thức do kết quả học tập, tìm hiểu mang lại (thường nói về nhận thức xã hội - chính trị): thu hoạch được nhiều kiến thức sau chuyến thực tập",
    example: "thu hoạch được nhiều kiến thức sau chuyến thực tập",
  },
  {
    word: "thu hoạch",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) tổng thể nói chung những sản phẩm thu hoạch được, những gì làm ra được bằng lao động sản xuất nông nghiệp: giống lúa cho thu hoạch cao",
    example: "giống lúa cho thu hoạch cao",
  },
  {
    word: "thu hoạch",
    part_of_speech: "danh từ",
    meaning:
      "kết quả thu được sau quá trình học tập, nghiên cứu, tìm hiểu: viết báo cáo thu hoạch",
    example: "viết báo cáo thu hoạch",
  },
  {
    word: "thù hận",
    part_of_speech: "",
    meaning: "như hận thù: gieo thù hận",
    example: "gieo thù hận",
  },
  {
    word: "thủ hoà",
    part_of_speech: "động từ",
    meaning:
      "cố gắng cầm cự để giữ được ở thế hoà, không để bị thua (trong thi đấu thể thao): cố gắng thủ hoà để giành một điểm",
    example: "cố gắng thủ hoà để giành một điểm",
  },
  {
    word: "thu hồi",
    part_of_speech: "động từ",
    meaning:
      "thu về lại cái trước đó đã đưa ra, đã cấp phát hoặc bị mất vào tay người khác: thu hồi giấy phép kinh doanh * khả năng thu hồi vốn chậm",
    example: "thu hồi giấy phép kinh doanh * khả năng thu hồi vốn chậm",
  },
  {
    word: "thụ hưởng",
    part_of_speech: "động từ",
    meaning:
      "được nhận, được hưởng (thường nói về những gì không phải do bản thân mình làm ra): thụ hưởng thành quả cách mạng",
    example: "thụ hưởng thành quả cách mạng",
  },
  {
    word: "thu hút",
    part_of_speech: "động từ",
    meaning:
      "tạo nên ấn tượng mạnh mẽ để người khác quan tâm và dồn mọi sự chú ý vào: chính sách thu hút nhân tài * vấn đề thu hút được sự chú ý của dư luận",
    example:
      "chính sách thu hút nhân tài * vấn đề thu hút được sự chú ý của dư luận",
  },
  {
    word: "thu không",
    part_of_speech: "động từ",
    meaning:
      '(cũ) (tiếng trống, chuông) báo hiệu đóng cửa thành vào lúc gần tối, khi biết chắc trong thành không có gì khả nghi, thời xưa: "Kiều từ trở gót trướng hoa, Mặt trời gác núi, chiêng đà thu không." (TKiều)',
    example:
      'Kiều từ trở gót trướng hoa, Mặt trời gác núi, chiêng đà thu không." (TKiều)',
  },
  {
    word: "thù lao",
    part_of_speech: "động từ",
    meaning:
      "trả công (thường bằng tiền) để bù đắp lại công sức lao động đã bỏ ra: thù lao cho chuyên gia * tiền thù lao",
    example: "thù lao cho chuyên gia * tiền thù lao",
  },
  {
    word: "thù lao",
    part_of_speech: "danh từ",
    meaning: "khoản tiền trả thù lao: hưởng thù lao xứng đáng",
    example: "hưởng thù lao xứng đáng",
  },
  {
    word: "thụ lí",
    part_of_speech: "động từ",
    meaning:
      "(cơ quan có thẩm quyền) tiếp nhận và giải quyết vụ kiện hoặc vụ án hình sự: thụ lí vụ án * đơn khiếu nại đã được toà án thụ lí để giải quyết",
    example: "thụ lí vụ án * đơn khiếu nại đã được toà án thụ lí để giải quyết",
  },
  {
    word: "thủ lĩnh",
    part_of_speech: "danh từ",
    meaning:
      "người đứng đầu lãnh đạo một tập đoàn người tương đối lớn: thủ lĩnh một bộ lạc * được tôn làm thủ lĩnh",
    example: "thủ lĩnh một bộ lạc * được tôn làm thủ lĩnh",
  },
  {
    word: "thu lôi",
    part_of_speech: "danh từ",
    meaning:
      "thiết bị gồm một thanh kim loại nhọn đặt trên đỉnh cao của các công trình và được nối với đất bằng dây dẫn, dùng để bảo vệ công trình khỏi bị sét đánh: cột thu lôi",
    example: "cột thu lôi",
  },
  {
    word: "thù lù",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) từ gợi tả hình khối có kích thước to lớn như trồi hẳn lên, đập vào mắt và làm vướng mắt: một đống cát thù lù ở giữa đường * ngồi thù lù giữa cửa",
    example: "một đống cát thù lù ở giữa đường * ngồi thù lù giữa cửa",
  },
  {
    word: "thù lù",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) từ gợi tả vẻ rất béo, mập và căng tròn ra: mập thù lù",
    example: "mập thù lù",
  },
  {
    word: "thụ lý",
    part_of_speech: "động từ",
    meaning:
      "(cơ quan có thẩm quyền) tiếp nhận và giải quyết vụ kiện hoặc vụ án hình sự: thụ lí vụ án * đơn khiếu nại đã được toà án thụ lí để giải quyết",
    example: "thụ lí vụ án * đơn khiếu nại đã được toà án thụ lí để giải quyết",
  },
  {
    word: "thu lượm",
    part_of_speech: "động từ",
    meaning:
      "lượm lặt, gom góp lại: thu lượm sắt vụn * thu lượm tin tức để viết bài",
    example: "thu lượm sắt vụn * thu lượm tin tức để viết bài",
  },
  {
    word: "thu ngân",
    part_of_speech: "động từ",
    meaning:
      "thu tiền của khách hàng (tại các cửa hàng kinh doanh, dịch vụ): quầy thu ngân * nhân viên thu ngân",
    example: "quầy thu ngân * nhân viên thu ngân",
  },
  {
    word: "thu mua",
    part_of_speech: "động từ",
    meaning:
      "mua gom với số lượng lớn theo hình thức tập trung của một tổ chức kinh tế nhất định: thu mua phế liệu",
    example: "thu mua phế liệu",
  },
  {
    word: "thu lu",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) từ gợi tả dáng thu tròn lại thật nhỏ, gọn: cây gỗ tròn thu lu * ngồi thu lu trên giường",
    example: "cây gỗ tròn thu lu * ngồi thu lu trên giường",
  },
  {
    word: "thủ mưu",
    part_of_speech: "danh từ",
    meaning:
      "kẻ cầm đầu lập mưu kế (thường nói về hành động xấu xa): thủ mưu của vụ ám sát",
    example: "thủ mưu của vụ ám sát",
  },
  {
    word: "thu nạp",
    part_of_speech: "động từ",
    meaning:
      "thu nhận vào một tổ chức: thu nạp nhân tài * thu nạp hội viên mới",
    example: "thu nạp nhân tài * thu nạp hội viên mới",
  },
  {
    word: "thu nhận",
    part_of_speech: "động từ",
    meaning:
      "nhận vào, lấy vào từ nhiều nguồn, nhiều nơi khác nhau: thu nhận học sinh mới * trạm thu nhận thông tin",
    example: "thu nhận học sinh mới * trạm thu nhận thông tin",
  },
  {
    word: "thu nhận",
    part_of_speech: "động từ",
    meaning: "(hiếm) nhận biết được bằng giác quan: thu nhận được tín hiệu",
    example: "thu nhận được tín hiệu",
  },
  {
    word: "thu nhặt",
    part_of_speech: "động từ",
    meaning: "nhặt nhạnh mà gom góp lại: thu nhặt phế liệu",
    example: "thu nhặt phế liệu",
  },
  {
    word: "thù oán",
    part_of_speech: "",
    meaning:
      "căm thù và oán giận sâu sắc ở trong lòng, không để biểu lộ ra: sinh lòng thù oán * gây nhiều thù oán",
    example: "sinh lòng thù oán * gây nhiều thù oán",
  },
  {
    word: "thú nhận",
    part_of_speech: "động từ",
    meaning:
      "nói ra và tự nhận là có điều không hay nào đó của mình: thú nhận mọi tội lỗi",
    example: "thú nhận mọi tội lỗi",
  },
  {
    word: "thu nhập",
    part_of_speech: "động từ",
    meaning:
      "thu được, kiếm được tiền bạc, của cải vật chất từ một công việc nào đó để chi dùng cho cuộc sống: nguồn thu nhập * khoản thu nhập đáng kể từ vườn nhãn",
    example: "nguồn thu nhập * khoản thu nhập đáng kể từ vườn nhãn",
  },
  {
    word: "thu nhập",
    part_of_speech: "danh từ",
    meaning:
      "tổng thể nói chung các khoản thu nhập được trong một khoảng thời gian nhất định, thường tính theo tháng, năm (nói tổng quát): làm thêm để tăng thu nhập * thu nhập bình quân tăng",
    example: "làm thêm để tăng thu nhập * thu nhập bình quân tăng",
  },
  {
    word: "thủ pháp",
    part_of_speech: "danh từ",
    meaning:
      "cách thức để thực hiện một ý định, một mục đích cụ thể nào đó: thủ pháp nhân hoá trong thơ",
    example: "thủ pháp nhân hoá trong thơ",
  },
  {
    word: "thủ phạm",
    part_of_speech: "danh từ",
    meaning: "kẻ trực tiếp gây ra vụ phạm pháp: truy tìm thủ phạm",
    example: "truy tìm thủ phạm",
  },
  {
    word: "thủ phận",
    part_of_speech: "động từ",
    meaning:
      'cam chịu với cái phận của mình, không đòi hỏi gì hơn: "Anh về thủ phận lo nghèo, Mặt chưa đáng mặt, chơi trèo giỡn trăng." (ca dao)',
    example:
      'Anh về thủ phận lo nghèo, Mặt chưa đáng mặt, chơi trèo giỡn trăng." (ca dao)',
  },
  {
    word: "thu nhập quốc dân",
    part_of_speech: "danh từ",
    meaning:
      "phần giá trị mới sáng tạo ra trong khu vực sản xuất vật chất của một nước, trong một thời gian nhất định (thường là một năm): thu nhập quốc dân năm nay cao hơn năm ngoái",
    example: "thu nhập quốc dân năm nay cao hơn năm ngoái",
  },
  {
    word: "thụ phấn",
    part_of_speech: "động từ",
    meaning: "(hiện tượng đầu nhuỵ hoa) tiếp nhận hạt phấn: hoa đã thụ phấn",
    example: "hoa đã thụ phấn",
  },
  {
    word: "thu phong",
    part_of_speech: "danh từ",
    meaning: "(cũ, văn chương) gió mùa thu: ngọn thu phong",
    example: "ngọn thu phong",
  },
  {
    word: "thu quân",
    part_of_speech: "động từ",
    meaning: "rút quân về: ra lệnh thu quân",
    example: "ra lệnh thu quân",
  },
  {
    word: "thủ phủ",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) thành phố quan trọng nhất của một khu vực, một vùng: thủ phủ của khu tự trị",
    example: "thủ phủ của khu tự trị",
  },
  {
    word: "thu phục",
    part_of_speech: "động từ",
    meaning:
      "làm cho người ta cảm phục, quý mến mà theo về với mình: thu phục nhân tâm",
    example: "thu phục nhân tâm",
  },
  {
    word: "thu phục",
    part_of_speech: "động từ",
    meaning:
      "(cũ) thu về, lấy lại cái có giá trị to lớn (thường là đất đai, lãnh thổ) đã bị chiếm mất: thu phục sơn hà * thu phục lại quyền bính",
    example: "thu phục sơn hà * thu phục lại quyền bính",
  },
  {
    word: "thụ thai",
    part_of_speech: "động từ",
    meaning: "bắt đầu có thai: khả năng thụ thai kém",
    example: "khả năng thụ thai kém",
  },
  {
    word: "thu thanh",
    part_of_speech: "động từ",
    meaning:
      "thu âm thanh vào một thiết bị nào đó như băng, đĩa từ để khi cần thì có thể phát ra: phòng thu thanh * bài hát mới được thu thanh",
    example: "phòng thu thanh * bài hát mới được thu thanh",
  },
  {
    word: "thủ thân",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) giữ mình nhằm tránh những nguy hiểm, những bất lợi có thể xảy ra: liệu kế thủ thân",
    example: "liệu kế thủ thân",
  },
  {
    word: "thu thập",
    part_of_speech: "động từ",
    meaning:
      "tìm kiếm, góp nhặt và tập hợp lại: thu thập tài liệu * thu thập ý kiến của đông đảo cử tri",
    example: "thu thập tài liệu * thu thập ý kiến của đông đảo cử tri",
  },
  {
    word: "thú thật",
    part_of_speech: "động từ",
    meaning:
      "tự nói ra với người nào đó những khuyết điểm hay tội lỗi của mình một cách thành thật, không chút giấu giếm: thú thật hết tội lỗi với cha mẹ * đầu tiên thì chối, sau mới chịu thú thật",
    example:
      "thú thật hết tội lỗi với cha mẹ * đầu tiên thì chối, sau mới chịu thú thật",
  },
  {
    word: "thú thật",
    part_of_speech: "động từ",
    meaning:
      "tổ hợp biểu thị điều sắp nêu ra là ý nghĩ, tình cảm có gì đó không hay, khó nói, và muốn người đối thoại tin rằng đó là sự thật: thú thật lúc đó mình cũng hơi sợ",
    example: "thú thật lúc đó mình cũng hơi sợ",
  },
  {
    word: "thủ thỉ",
    part_of_speech: "động từ",
    meaning:
      "nói nhỏ nhẹ, thong thả, vừa đủ để cho nhau nghe, thường là để thổ lộ tình cảm, tâm tình: giọng thủ thỉ * thủ thỉ tâm sự",
    example: "giọng thủ thỉ * thủ thỉ tâm sự",
  },
  {
    word: "thủ thế",
    part_of_speech: "động từ",
    meaning: "giữ thế thủ trước sự tấn công của đối phương: đứng thủ thế",
    example: "đứng thủ thế",
  },
  {
    word: "thủ thuật",
    part_of_speech: "danh từ",
    meaning:
      "cách thức tiến hành động tác khéo léo và có kĩ thuật hoặc kinh nghiệm để thực hiện một công việc nào đó có hiệu quả: thủ thuật nhà nghề * thủ thuật xử lí ảnh trên máy tính",
    example: "thủ thuật nhà nghề * thủ thuật xử lí ảnh trên máy tính",
  },
  {
    word: "thủ thuật",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) thủ thuật mổ xẻ để chữa bệnh: phòng thủ thuật * xử lí bằng thủ thuật",
    example: "phòng thủ thuật * xử lí bằng thủ thuật",
  },
  {
    word: "thủ tiêu",
    part_of_speech: "động từ",
    meaning:
      "làm cho mất hẳn đi, cho không còn tồn tại, thường nhằm che giấu điều gì đó: thủ tiêu mọi chứng cớ phạm tội * thủ tiêu tang vật",
    example: "thủ tiêu mọi chứng cớ phạm tội * thủ tiêu tang vật",
  },
  {
    word: "thủ tiêu",
    part_of_speech: "động từ",
    meaning: "giết chết một cách lén lút: thủ tiêu nhân chứng để bịt đầu mối",
    example: "thủ tiêu nhân chứng để bịt đầu mối",
  },
  {
    word: "thủ tiêu",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) từ bỏ, lẩn tránh hoàn toàn những hoạt động nào đó: thủ tiêu đấu tranh",
    example: "thủ tiêu đấu tranh",
  },
  {
    word: "thủ tiết",
    part_of_speech: "động từ",
    meaning:
      "(cũ) (người đàn bà goá) giữ tiết hạnh với người chồng đã chết, không tái giá, theo quan niệm đạo đức phong kiến: thủ tiết thờ chồng, nuôi con",
    example: "thủ tiết thờ chồng, nuôi con",
  },
  {
    word: "thú tính",
    part_of_speech: "danh từ",
    meaning:
      "tính của thú vật; thường dùng để chỉ một cách khái quát những ham muốn xác thịt thuần tuý buông thả, hoặc những hành động cực kì man rợ, mất hết tính người: hành động giết người đầy thú tính",
    example: "hành động giết người đầy thú tính",
  },
  {
    word: "thú tội",
    part_of_speech: "động từ",
    meaning:
      "tự khai nhận tội lỗi đã gây ra: thủ phạm đã thú tội * thú tội trước cơ quan pháp luật",
    example: "thủ phạm đã thú tội * thú tội trước cơ quan pháp luật",
  },
  {
    word: "thụ trai",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) (nhà chùa) ăn cơm chay (thường vào những buổi nhất định): sư cụ đang thụ trai",
    example: "sư cụ đang thụ trai",
  },
  {
    word: "thủ trưởng",
    part_of_speech: "danh từ",
    meaning:
      "người đứng đầu lãnh đạo một cơ quan hay một đơn vị công tác: xin ý kiến thủ trưởng",
    example: "xin ý kiến thủ trưởng",
  },
  {
    word: "thủ tục",
    part_of_speech: "danh từ",
    meaning:
      "những việc cụ thể phải làm theo một trật tự quy định, để tiến hành một công việc có tính chất chính thức (nói tổng quát): thủ tục đăng kí kết hôn * làm thủ tục xuất nhập cảnh",
    example: "thủ tục đăng kí kết hôn * làm thủ tục xuất nhập cảnh",
  },
  {
    word: "thủ túc",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) tay và chân; dùng để ví tình cảm quan hệ khăng khít giữa anh em huynh đệ: tình thủ túc * anh em như thủ túc",
    example: "tình thủ túc * anh em như thủ túc",
  },
  {
    word: "thủ túc",
    part_of_speech: "danh từ",
    meaning: "kẻ tay chân đắc lực: bọn thủ túc",
    example: "bọn thủ túc",
  },
  {
    word: "thú vị",
    part_of_speech: "",
    meaning:
      "có tác dụng tạo nên sự hứng thú, vui thích: sự bất ngờ thú vị * không thú vị gì với chuyện đó",
    example: "sự bất ngờ thú vị * không thú vị gì với chuyện đó",
  },
  {
    word: "thu vén",
    part_of_speech: "động từ",
    meaning:
      "dọn dẹp, sắp xếp mọi thứ lại cho gọn gàng: thu vén quần áo * thu vén đồ đạc",
    example: "thu vén quần áo * thu vén đồ đạc",
  },
  {
    word: "thu vén",
    part_of_speech: "động từ",
    meaning:
      "gom góp, cóp nhặt từng ít một để gây dựng: thu vén cho gia đình * thu vén cho con cái",
    example: "thu vén cho gia đình * thu vén cho con cái",
  },
  {
    word: "thú y",
    part_of_speech: "danh từ",
    meaning:
      "ngành chuyên lo các việc về phòng, trị bệnh cũng như lai tạo giống, v.v. cho gia súc, gia cầm hoặc các loài động vật nói chung, và kiểm nghiệm các sản phẩm chăn nuôi: bác sĩ thú y",
    example: "bác sĩ thú y",
  },
  {
    word: "thu xếp",
    part_of_speech: "động từ",
    meaning: "xếp đặt cho ổn: thu xếp đồ đạc * thu xếp công việc",
    example: "thu xếp đồ đạc * thu xếp công việc",
  },
  {
    word: "thú vui",
    part_of_speech: "danh từ",
    meaning:
      "điều làm cho cảm thấy được hứng thú, vui thích: có thú vui sưu tập tem * tìm thú vui trong công việc",
    example: "có thú vui sưu tập tem * tìm thú vui trong công việc",
  },
  {
    word: "thua",
    part_of_speech: "động từ",
    meaning:
      "chịu để cho đối phương giành phần hơn, phần thắng trong cuộc tranh chấp hoặc đọ sức giữa hai bên: thua cuộc * thua keo này bày keo khác (tng)",
    example: "thua cuộc * thua keo này bày keo khác (tng)",
  },
  {
    word: "thua",
    part_of_speech: "động từ",
    meaning:
      "ở mức thấp hơn, kém hơn cái đưa ra để so sánh: sức học thua xa chúng bạn * thua chị kém em (tng)",
    example: "sức học thua xa chúng bạn * thua chị kém em (tng)",
  },
  {
    word: "thùa",
    part_of_speech: "động từ",
    meaning:
      "khâu móc từng mũi chỉ để viền kín các mép của lỗ khuyết: thùa khuyết",
    example: "thùa khuyết",
  },
  {
    word: "thua lỗ",
    part_of_speech: "động từ",
    meaning: "(kinh doanh, buôn bán) bị lỗ vốn (nói khái quát): làm ăn thua lỗ",
    example: "làm ăn thua lỗ",
  },
  {
    word: "thua kém",
    part_of_speech: "động từ",
    meaning:
      'không bằng, kém hơn (nói khái quát): thua kém bạn bè * "Anh ngồi anh thở anh than, Vợ anh thua kém thế gian mười phần." (ca dao)',
    example:
      'thua kém bạn bè * "Anh ngồi anh thở anh than, Vợ anh thua kém thế gian mười phần." (ca dao)',
  },
  {
    word: "thua sút",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) thua kém do bị giảm sút: học hành thua sút bạn bè * thua sút về thể lực",
    example: "học hành thua sút bạn bè * thua sút về thể lực",
  },
  {
    word: "thua thiệt",
    part_of_speech: "động từ",
    meaning:
      "bị thiệt thòi, thua kém hay mất mát nhiều (nói khái quát): bị thua thiệt đủ đường * yếu thế nên phải chịu thua thiệt",
    example: "bị thua thiệt đủ đường * yếu thế nên phải chịu thua thiệt",
  },
  {
    word: "thuẫn",
    part_of_speech: "danh từ",
    meaning:
      "vật dùng để cầm che đỡ cho gươm, giáo khỏi đâm trúng người khi đánh trận thời xưa, hình thon dần về một đầu, như nửa hình cái thoi: tấm thuẫn",
    example: "tấm thuẫn",
  },
  {
    word: "thuần",
    part_of_speech: "tính từ",
    meaning:
      "dễ bảo, chịu sự điều khiển vì đã được dạy bảo, tập luyện: tính đã thuần hơn trước * con ngựa chưa thuần",
    example: "tính đã thuần hơn trước * con ngựa chưa thuần",
  },
  {
    word: "thuần",
    part_of_speech: "tính từ",
    meaning:
      "quen, thạo một loại công việc nào đó vì đã làm, đã luyện tập nhiều: tập nhiều cho thuần tay",
    example: "tập nhiều cho thuần tay",
  },
  {
    word: "thuần",
    part_of_speech: "tính từ",
    meaning:
      "chỉ toàn một thứ, một loại, không xen lẫn thứ khác, loại khác vào: làm thuần bằng máy * trồng thuần một loại rau",
    example: "làm thuần bằng máy * trồng thuần một loại rau",
  },
  {
    word: "thuận",
    part_of_speech: "tính từ",
    meaning:
      "theo đúng chiều chuyển động, vận động bình thường của sự vật: thuận theo chiều kim đồng hồ * thuyền thuận gió lao đi vun vút * mưa thuận gió hoà (tng)",
    example:
      "thuận theo chiều kim đồng hồ * thuyền thuận gió lao đi vun vút * mưa thuận gió hoà (tng)",
  },
  {
    word: "thuận",
    part_of_speech: "tính từ",
    meaning:
      "hợp với hoặc tiện cho một hoạt động hay sự cảm nhận tự nhiên nào đó: thuận tay trái * nghe không thuận tai",
    example: "thuận tay trái * nghe không thuận tai",
  },
  {
    word: "thuận",
    part_of_speech: "tính từ",
    meaning:
      "hoặc đg bằng lòng, đồng tình: bỏ phiếu thuận * hai người đã thuận lấy nhau",
    example: "bỏ phiếu thuận * hai người đã thuận lấy nhau",
  },
  {
    word: "thuần chất",
    part_of_speech: "tính từ",
    meaning:
      "chỉ nguyên mỗi một chất, không có chất khác lẫn vào: nước mắm thuần chất",
    example: "nước mắm thuần chất",
  },
  {
    word: "thuần chất",
    part_of_speech: "tính từ",
    meaning:
      "vẫn giữ được bản chất vốn có, không bị pha tạp: nền văn hoá bản địa thuần chất",
    example: "nền văn hoá bản địa thuần chất",
  },
  {
    word: "thuần chủng",
    part_of_speech: "tính từ",
    meaning:
      "(giống sinh vật) còn giữ nguyên vẹn bản chất của dòng giống, không bị lai tạp: đàn lợn thuần chủng * giống lúa thuần chủng",
    example: "đàn lợn thuần chủng * giống lúa thuần chủng",
  },
  {
    word: "thuần dưỡng",
    part_of_speech: "động từ",
    meaning:
      "nuôi dưỡng và luyện tập cho thú hoang dã dần trở nên thuần để nuôi: thuần dưỡng voi rừng",
    example: "thuần dưỡng voi rừng",
  },
  {
    word: "thuần hoá",
    part_of_speech: "động từ",
    meaning:
      "làm cho giống cây trồng vừa được đem từ nơi khác đến trở nên thích nghi với điều kiện khí hậu và đất đai ở nơi trồng mới: thuần hoá một số giống cây trồng mới",
    example: "thuần hoá một số giống cây trồng mới",
  },
  {
    word: "thuần hoá",
    part_of_speech: "động từ",
    meaning:
      "như thuần dưỡng: thuần hoá voi rừng * con ngựa chưa được thuần hoá",
    example: "thuần hoá voi rừng * con ngựa chưa được thuần hoá",
  },
  {
    word: "thuần hậu",
    part_of_speech: "tính từ",
    meaning: "chất phác, hiền hậu: bản chất thuần hậu",
    example: "bản chất thuần hậu",
  },
  {
    word: "thuận hoà",
    part_of_speech: "tính từ",
    meaning:
      "(thời tiết, khí hậu) bình thường, diễn biến đúng quy luật, thuận lợi cho việc trồng trọt, làm ăn: mưa gió thuận hoà",
    example: "mưa gió thuận hoà",
  },
  {
    word: "thuận lợi",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều yếu tố hoặc điều kiện dễ dàng (để thực hiện việc gì): làm ăn khá thuận lợi * hoàn cảnh thuận lợi",
    example: "làm ăn khá thuận lợi * hoàn cảnh thuận lợi",
  },
  {
    word: "thuận lợi",
    part_of_speech: "danh từ",
    meaning:
      "yếu tố hoặc điều kiện dễ dàng, không gây khó khăn khi thực hiện việc gì: gặp nhiều thuận lợi trong công việc",
    example: "gặp nhiều thuận lợi trong công việc",
  },
  {
    word: "thuần khiết",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như thuần chất (ng1).",
    example: "một vẻ đẹp thuần khiết",
  },
  {
    word: "thuần phong mĩ tục",
    part_of_speech: "",
    meaning:
      "phong tục tốt đẹp, lành mạnh (nói khái quát): giữ gìn thuần phong mĩ tục",
    example: "giữ gìn thuần phong mĩ tục",
  },
  {
    word: "thuần phác",
    part_of_speech: "tính từ",
    meaning:
      "hiền lành, chất phác: gương mặt thuần phác * người nông dân thuần phác",
    example: "gương mặt thuần phác * người nông dân thuần phác",
  },
  {
    word: "thuần thục",
    part_of_speech: "tính từ",
    meaning:
      "(làm việc gì đó) rất thành thạo và nhuần nhuyễn vì đã làm nhiều hoặc đã được tập luyện nhiều: thực hiện các động tác rất thuần thục",
    example: "thực hiện các động tác rất thuần thục",
  },
  {
    word: "thuần thục",
    part_of_speech: "tính từ",
    meaning:
      "(người phụ nữ) hiền dịu, đảm đang và biết ăn ở: tính nết thuần thục * người phụ nữ thuần thục",
    example: "tính nết thuần thục * người phụ nữ thuần thục",
  },
  {
    word: "thuần nhất",
    part_of_speech: "tính từ",
    meaning:
      "chỉ toàn một loại, không pha tạp: khu vườn chỉ trồng thuần nhất một loại cây * một môi trường giáo dục thuần nhất",
    example:
      "khu vườn chỉ trồng thuần nhất một loại cây * một môi trường giáo dục thuần nhất",
  },
  {
    word: "thuần phục",
    part_of_speech: "động từ",
    meaning:
      "chịu hoặc bắt phải chịu nghe theo, tuân theo sự điều khiển, sai khiến: con ngựa bất kham đã chịu thuần phục",
    example: "con ngựa bất kham đã chịu thuần phục",
  },
  {
    word: "thuận tiện",
    part_of_speech: "tính từ",
    meaning:
      "tiện lợi và dễ dàng, không có khó khăn, trở ngại: cơ hội thuận tiện * giao thông thuận tiện",
    example: "cơ hội thuận tiện * giao thông thuận tiện",
  },
  {
    word: "thuần phong mỹ tục",
    part_of_speech: "",
    meaning:
      "phong tục tốt đẹp, lành mạnh (nói khái quát): giữ gìn thuần phong mĩ tục",
    example: "giữ gìn thuần phong mĩ tục",
  },
  {
    word: "thuận tình",
    part_of_speech: "động từ",
    meaning: "đồng ý, bằng lòng thuận theo: hai người đã thuận tình lấy nhau",
    example: "hai người đã thuận tình lấy nhau",
  },
  {
    word: "thuần tính",
    part_of_speech: "tính từ",
    meaning:
      "hiền lành, dễ bảo, không hay ương bướng hoặc nổi nóng: đứa bé không thuần tính * giống trâu này cũng khá thuần tính",
    example: "đứa bé không thuần tính * giống trâu này cũng khá thuần tính",
  },
  {
    word: "thuần tuý",
    part_of_speech: "tính từ",
    meaning:
      "ở tình trạng còn giữ nguyên bản sắc riêng như vốn có, không bị lai tạp, pha trộn: chất nông dân thuần tuý * nghệ thuật dân gian thuần tuý",
    example: "chất nông dân thuần tuý * nghệ thuật dân gian thuần tuý",
  },
  {
    word: "thuần tuý",
    part_of_speech: "tính từ",
    meaning:
      "hoàn toàn chỉ có một thứ, một mặt: cách xử lí thuần tuý về mặt kĩ thuật",
    example: "cách xử lí thuần tuý về mặt kĩ thuật",
  },
  {
    word: "thuật",
    part_of_speech: "danh từ",
    meaning:
      "phương pháp, cách thức khéo léo cần phải theo để đạt kết quả trong một lĩnh vực hoạt động nào đó: thuật đánh võ * thuật thôi miên  * thuật dùng người",
    example: "thuật đánh võ * thuật thôi miên  * thuật dùng người",
  },
  {
    word: "thuật",
    part_of_speech: "động từ",
    meaning:
      "nói lại, trình bày lại một cách rõ ràng, chi tiết và theo đúng trình tự những gì đã nghe thấy, trông thấy: thuật lại trận đấu bóng đá * thuật lại câu chuyện cho mọi người nghe",
    example:
      "thuật lại trận đấu bóng đá * thuật lại câu chuyện cho mọi người nghe",
  },
  {
    word: "thuận vợ thuận chồng",
    part_of_speech: "",
    meaning:
      "vợ chồng hoà thuận, hợp ý nhau: thuận vợ thuận chồng, tát biển Đông cũng cạn (tng)",
    example: "thuận vợ thuận chồng, tát biển Đông cũng cạn (tng)",
  },
  {
    word: "thuật ngữ",
    part_of_speech: "danh từ",
    meaning:
      "từ, ngữ biểu đạt các khái niệm chuyên môn khoa học, kĩ thuật: âm vị, hình vị là những thuật ngữ ngôn ngữ học.",
    example: "âm vị, hình vị là những thuật ngữ ngôn ngữ học.",
  },
  {
    word: "thúc bá",
    part_of_speech: "danh từ",
    meaning: "(cũ, hiếm) anh em thúc bá (nói tắt): quan hệ thúc bá",
    example: "quan hệ thúc bá",
  },
  {
    word: "thục",
    part_of_speech: "tính từ",
    meaning:
      "(đất) đã được khai phá, cày bừa, cải tạo qua nhiều năm nên đã thành ruộng, thành đất trồng trọt: ruộng thục",
    example: "ruộng thục",
  },
  {
    word: "thúc đẩy",
    part_of_speech: "động từ",
    meaning:
      "kích thích, tạo điều kiện, động lực cho hoạt động, phát triển mạnh hơn theo một hướng nhất định nào đó, thường là hướng tốt: tăng cường các biện pháp thúc đẩy nền kinh tế",
    example: "tăng cường các biện pháp thúc đẩy nền kinh tế",
  },
  {
    word: "thúc bách",
    part_of_speech: "",
    meaning:
      "thúc giục gắt gao, ráo riết: yêu cầu rất thúc bách * công việc thúc bách",
    example: "yêu cầu rất thúc bách * công việc thúc bách",
  },
  {
    word: "thúc",
    part_of_speech: "động từ",
    meaning:
      "dùng tay, chân, v.v. hoặc đầu một vật không nhọn đưa ngang cho chạm mạnh vào: thúc nhẹ khuỷu tay vào sườn bạn * thúc ngựa phi nhanh",
    example: "thúc nhẹ khuỷu tay vào sườn bạn * thúc ngựa phi nhanh",
  },
  {
    word: "thúc",
    part_of_speech: "động từ",
    meaning:
      "giục liên tiếp, không cho để chậm trễ: thúc nợ * chưa xong thì cho người đến thúc",
    example: "thúc nợ * chưa xong thì cho người đến thúc",
  },
  {
    word: "thúc",
    part_of_speech: "động từ",
    meaning:
      "làm cho quá trình phát triển, sinh trưởng của cây trồng, vật nuôi diễn ra nhanh hơn: bón thúc * thúc cho đôi lợn chóng béo",
    example: "bón thúc * thúc cho đôi lợn chóng béo",
  },
  {
    word: "thúc ép",
    part_of_speech: "động từ",
    meaning:
      "thúc giục, bắt ép phải làm ngay hoặc phải chấp nhận: bị thúc ép phải làm * do hoàn cảnh thúc ép",
    example: "bị thúc ép phải làm * do hoàn cảnh thúc ép",
  },
  {
    word: "thúc giục",
    part_of_speech: "động từ",
    meaning:
      "giục liên tục, bắt phải làm nhanh, làm gấp: tiếng trống vang lên thúc giục * luôn miệng thúc giục",
    example: "tiếng trống vang lên thúc giục * luôn miệng thúc giục",
  },
  {
    word: "thúc thủ",
    part_of_speech: "động từ",
    meaning: "(cũ) bó tay, đành bất lực, không làm gì được: đành chịu thúc thủ",
    example: "đành chịu thúc thủ",
  },
  {
    word: "thục mạng",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) (chạy) nhanh và không kể gì hết, miễn sao cho thoát khỏi nguy hiểm: cắm đầu chạy thục mạng",
    example: "cắm đầu chạy thục mạng",
  },
  {
    word: "thục mạng",
    part_of_speech: "phụ từ",
    meaning:
      "(làm việc gì) liều lĩnh và mạnh bạo đến mức không kể gì nguy hiểm: đánh nhau thục mạng",
    example: "đánh nhau thục mạng",
  },
  {
    word: "thuê",
    part_of_speech: "động từ",
    meaning:
      "dùng người hay vật nào đó trong một thời gian, với điều kiện trả một khoản tiền nhất định cho thời gian sử dụng đó: thuê nhà * cho thuê bàn ghế",
    example: "thuê nhà * cho thuê bàn ghế",
  },
  {
    word: "thuê",
    part_of_speech: "động từ",
    meaning:
      "làm việc gì đó cho người khác để lấy tiền công: cày thuê cuốc mướn",
    example: "cày thuê cuốc mướn",
  },
  {
    word: "thuế",
    part_of_speech: "danh từ",
    meaning:
      "khoản tiền hay hiện vật mà người dân hoặc các tổ chức kinh doanh có nghĩa vụ phải nộp cho nhà nước theo mức quy định, dựa trên mức giá trị tài sản, mức thu nhập, loại hình nghề nghiệp, v.v: nộp thuế * thuộc diện được miễn thuế nông nghiệp",
    example: "nộp thuế * thuộc diện được miễn thuế nông nghiệp",
  },
  {
    word: "thục nữ",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) người con gái hiền dịu, nết na: "Thuyền quyên sánh với anh hùng, Những người thục nữ sánh cùng văn nhân." (ca dao)',
    example:
      'Thuyền quyên sánh với anh hùng, Những người thục nữ sánh cùng văn nhân." (ca dao)',
  },
  {
    word: "thuê bao",
    part_of_speech: "động từ",
    meaning:
      "thuê để dùng, chỉ tính thời gian, chứ không tính số lần sử dụng (nhưng thường có hạn chế trong một mức quy định): giảm cước thuê bao điện thoại * phí thuê bao hằng tháng",
    example: "giảm cước thuê bao điện thoại * phí thuê bao hằng tháng",
  },
  {
    word: "thuê bao",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) người hoặc đơn vị đăng kí thuê bao: miễn phí hoà mạng cho các thuê bao mới",
    example: "miễn phí hoà mạng cho các thuê bao mới",
  },
  {
    word: "thuế má",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) như thuế khoá (nhưng thường hàm ý kêu ca, phê phán): thuế má tăng cao",
    example: "thuế má tăng cao",
  },
  {
    word: "thuê mướn",
    part_of_speech: "động từ",
    meaning: "thuê người làm (nói khái quát): thuê mướn nhân công",
    example: "thuê mướn nhân công",
  },
  {
    word: "thuê mua",
    part_of_speech: "động từ",
    meaning:
      "(hình thức) thuê tài sản để sử dụng trong một thời gian dài, cho đến khi thanh toán hết và được quyền sở hữu: áp dụng hình thức thuê mua nhà chung cư cho người có thu nhập thấp",
    example:
      "áp dụng hình thức thuê mua nhà chung cư cho người có thu nhập thấp",
  },
  {
    word: "thuế gián thu",
    part_of_speech: "danh từ",
    meaning:
      "khoản tiền thuế mà người sản xuất và kinh doanh phải nộp, nhưng lại được tính vào giá hàng bán ra để thật ra là người mua phải trả; phân biệt với thuế trực thu: thuế giá trị gia tăng là một loại thuế gián thu",
    example: "thuế giá trị gia tăng là một loại thuế gián thu",
  },
  {
    word: "thuế suất",
    part_of_speech: "danh từ",
    meaning:
      "tỉ lệ phần trăm dùng để tính số thuế phải nộp vào ngân sách, căn cứ vào giá trị sản lượng hàng hoá tiêu thụ: mức thuế suất là 5%",
    example: "mức thuế suất là 5%",
  },
  {
    word: "thuế khoá",
    part_of_speech: "danh từ",
    meaning: "các thứ thuế (nói khái quát): thuế khoá phải công bằng, hợp lí",
    example: "thuế khoá phải công bằng, hợp lí",
  },
  {
    word: "thúi",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) thoái",
    example: "thối (lại) tiền cho khách * tiền thối",
  },
  {
    word: "thúi",
    part_of_speech: "động từ",
    meaning: "(Nam) trả lại tiền thừa: thối (lại) tiền cho khách * tiền thối",
    example: "trứng thối * mạ bị thối rễ",
  },
  {
    word: "thúi",
    part_of_speech: "động từ",
    meaning:
      "(Nam thúi) (chất hữu cơ) bị biến chất sinh ra mùi thối, do tác dụng huỷ hoại của vi sinh vật: trứng thối * mạ bị thối rễ",
    example: "đạn thối không nổ",
  },
  {
    word: "thúi",
    part_of_speech: "tính từ",
    meaning:
      "(Nam thúi) có mùi khó ngửi như mùi phân tươi hoặc mùi xác chết lâu ngày: mùi thối * thối như cóc chết",
    example: "mùi thối * thối như cóc chết",
  },
  {
    word: "thuế vụ",
    part_of_speech: "danh từ",
    meaning: "công việc thu thuế: cơ quan thuế vụ * nhân viên thuế vụ",
    example: "cơ quan thuế vụ * nhân viên thuế vụ",
  },
  {
    word: "thụi",
    part_of_speech: "động từ",
    meaning: "(Khẩu ngữ) đấm: thụi cho mấy quả",
    example: "thụi cho mấy quả",
  },
  {
    word: "thui",
    part_of_speech: "động từ",
    meaning:
      "đốt cho cháy hết lông và cho chín ngoài da súc vật đã giết thịt: món bê thui * chết thui",
    example: "món bê thui * chết thui",
  },
  {
    word: "thui",
    part_of_speech: "động từ",
    meaning:
      "(mầm, nụ hoa, quả non) lụi đi, không phát triển được nữa: mướp bị thui * quả bầu thui",
    example: "mướp bị thui * quả bầu thui",
  },
  {
    word: "thui thủi",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả vẻ cô đơn, lặng lẽ một mình, không có ai bầu bạn: sống thui thủi một mình",
    example: "sống thui thủi một mình",
  },
  {
    word: "thui chột",
    part_of_speech: "tính từ",
    meaning:
      "không thể phát triển bình thường hoặc tàn lụi dần, do bị tác động của điều kiện bên ngoài không thuận lợi (thường nói về cây trồng): lúa má bị thui chột vì giá rét * làm thui chột khả năng sáng tạo (b)",
    example:
      "lúa má bị thui chột vì giá rét * làm thui chột khả năng sáng tạo (b)",
  },
  {
    word: "thum thủm",
    part_of_speech: "tính từ",
    meaning: "hơi thủm: quả trứng loãng lòng, bốc mùi thum thủm",
    example: "quả trứng loãng lòng, bốc mùi thum thủm",
  },
  {
    word: "thùm thụp",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng như tiếng đấm liên tiếp vào vật mềm: đấm lưng nhau thùm thụp",
    example: "đấm lưng nhau thùm thụp",
  },
  {
    word: "thun lủn",
    part_of_speech: "tính từ",
    meaning:
      "quá ngắn, đến mức trông như bị cụt hay thiếu hẳn đi một đoạn, trông chướng mắt, khó coi: ngắn thun lủn * trả lời một câu thun lủn",
    example: "ngắn thun lủn * trả lời một câu thun lủn",
  },
  {
    word: "thun",
    part_of_speech: "danh từ",
    meaning:
      "hàng dệt bằng loại sợi mềm có khả năng co dãn: áo thun * quần may bằng vải thun",
    example: "áo thun * quần may bằng vải thun",
  },
  {
    word: "thun",
    part_of_speech: "danh từ",
    meaning:
      "(Phương ngữ, Khẩu ngữ) dây thun (nói tắt): buộc xấp tiền bằng một sợi thun mỏng",
    example: "buộc xấp tiền bằng một sợi thun mỏng",
  },
  {
    word: "thúng",
    part_of_speech: "danh từ",
    meaning:
      "đồ đan khít bằng tre, hình tròn, lòng sâu, to hơn rổ, dùng để đựng: thúng thóc",
    example: "thúng thóc",
  },
  {
    word: "thúng",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị dân gian đong các chất hạt rời, bằng dung tích của một cái thúng quy định.",
    example: "đi thúng ra bưng * bơi thúng",
  },
  {
    word: "thũng",
    part_of_speech: "danh từ",
    meaning: "(Khẩu ngữ) bệnh phù: người bị thũng",
    example: "người bị thũng",
  },
  {
    word: "thụng",
    part_of_speech: "tính từ",
    meaning:
      "(quần áo) dài và rộng, khi mặc vào có những chỗ dồn lại, không thẳng: quần thụng * áo may thụng",
    example: "quần thụng * áo may thụng",
  },
  {
    word: "thủng",
    part_of_speech: "tính từ",
    meaning:
      "(Nam lủng) có chỗ bị rách hoặc bị chọc thành lỗ xuyên qua vật: cái nồi bị thủng * chọc thủng phòng tuyến",
    example: "cái nồi bị thủng * chọc thủng phòng tuyến",
  },
  {
    word: "thủng",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) đã hiểu được một chuyện hay vấn đề gì một cách thông suốt: nghe mãi vẫn không thủng * hỏi cho thủng câu chuyện",
    example: "nghe mãi vẫn không thủng * hỏi cho thủng câu chuyện",
  },
  {
    word: "thun thút",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả dáng vẻ di chuyển lọt vào rất nhanh và nối tiếp nhau không ngớt, đến mức như không còn kịp nhìn thấy rõ: đạn cắm vào bùn thun thút * bé ăn thun thút",
    example: "đạn cắm vào bùn thun thút * bé ăn thun thút",
  },
  {
    word: "thùng",
    part_of_speech: "danh từ",
    meaning:
      "đồ đựng bằng kim loại hoặc bằng gỗ, có hình trụ hoặc hình hộp: thùng đựng gạo * thùng gánh nước",
    example: "thùng đựng gạo * thùng gánh nước",
  },
  {
    word: "thùng",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị đo lường thời trước, có dung tích bằng khoảng 20 lít: vay mấy thùng thóc",
    example: "vay mấy thùng thóc",
  },
  {
    word: "thung dung",
    part_of_speech: "tính từ",
    meaning:
      '(cũ, hiếm) như thong dong: "Trước sau bày hết sự lòng, Từ tạ thôi mới thung dung lên đàng." (CC)',
    example:
      'Trước sau bày hết sự lòng, Từ tạ thôi mới thung dung lên đàng." (CC)',
  },
  {
    word: "thúng mủng",
    part_of_speech: "danh từ",
    meaning:
      "đồ đựng đan bằng tre, như thúng, mủng, v.v. (nói khái quát): quang gánh, thúng mủng bừa bộn",
    example: "quang gánh, thúng mủng bừa bộn",
  },
  {
    word: "thung lũng",
    part_of_speech: "danh từ",
    meaning:
      "vùng đất trũng thấp giữa hai sườn dốc: bản làng nằm lọt trong thung lũng",
    example: "bản làng nằm lọt trong thung lũng",
  },
  {
    word: "thung huyên",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) như xuân huyên: "Em về thưa với thung huyên, Chốn này ta đã thành duyên nhau rồi." (ca dao)',
    example:
      'Em về thưa với thung huyên, Chốn này ta đã thành duyên nhau rồi." (ca dao)',
  },
  {
    word: "thùng thình",
    part_of_speech: "tính từ",
    meaning: "(quần áo) quá rộng so với khổ người: quần rộng thùng thình",
    example: "quần rộng thùng thình",
  },
  {
    word: "thủng thẳng",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) chậm rãi, từ từ, tỏ ra như không có gì cần phải vội vàng cả: nói thủng thẳng từng tiếng một * việc đó, thủng thẳng rồi hẵng tính",
    example:
      "nói thủng thẳng từng tiếng một * việc đó, thủng thẳng rồi hẵng tính",
  },
  {
    word: "thủng thỉnh",
    part_of_speech: "tính từ",
    meaning: "(cũ) như thủng thẳng: bước thủng thỉnh",
    example: "bước thủng thỉnh",
  },
  {
    word: "thủng nồi trôi rế",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) (ăn) rất khoẻ, rất nhiều, đến mức như mấy cũng hết: ăn thủng nồi trôi rế",
    example: "ăn thủng nồi trôi rế",
  },
  {
    word: "thung thăng",
    part_of_speech: "tính từ",
    meaning:
      'từ gợi tả dáng đi lại thong thả, nhởn nhơ, trông có vẻ nhàn nhã: đi thung thăng * "Cá buồn cá lội thung thăng, Em buồn em biết đãi đằng cùng ai." (ca dao)',
    example:
      'đi thung thăng * "Cá buồn cá lội thung thăng, Em buồn em biết đãi đằng cùng ai." (ca dao)',
  },
  {
    word: "thúng thắng",
    part_of_speech: "phụ từ",
    meaning: "như húng hắng: ho thúng thắng",
    example: "ho thúng thắng",
  },
  {
    word: "thung thổ",
    part_of_speech: "danh từ",
    meaning:
      "đất đai, địa thế của một vùng (nói khái quát): chưa thuộc thung thổ",
    example: "chưa thuộc thung thổ",
  },
  {
    word: "thùng thùng",
    part_of_speech: "tính từ",
    meaning:
      'từ mô phỏng tiếng trống đánh to, vang dội và dồn dập, như thúc giục: "Thùng thùng trống đánh ngũ liên, Bước chân xuống thuyền nước mắt như mưa." (ca dao)',
    example:
      'Thùng thùng trống đánh ngũ liên, Bước chân xuống thuyền nước mắt như mưa." (ca dao)',
  },
  {
    word: "thuốc",
    part_of_speech: "danh từ",
    meaning:
      "chất được chế biến dùng để phòng hoặc chữa bệnh: sắc thuốc * uống thuốc * thuốc đắng dã tật (tng)",
    example: "sắc thuốc * uống thuốc * thuốc đắng dã tật (tng)",
  },
  {
    word: "thuốc",
    part_of_speech: "danh từ",
    meaning:
      "chất được chế biến có dạng như một loại thuốc, có công dụng hoặc tác dụng nhất định: thuốc trừ sâu * thuốc gây tê * thuốc nổ",
    example: "thuốc trừ sâu * thuốc gây tê * thuốc nổ",
  },
  {
    word: "thuốc",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) giết bằng thuốc độc: con chó đã bị thuốc chết",
    example: "con chó đã bị thuốc chết",
  },
  {
    word: "thuốc",
    part_of_speech: "danh từ",
    meaning:
      "lá hay nhựa của một số loại cây đã được chế biến, có tác dụng gây kích thích thần kinh hoặc cảm giác, dùng để hút, hít, v.v.: hút thuốc lá * con nghiện bị say thuốc",
    example: "hút thuốc lá * con nghiện bị say thuốc",
  },
  {
    word: "thuộc cấp",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người dưới quyền, trong mối quan hệ với người lãnh đạo trực tiếp, nói chung: ra lệnh cho thuộc cấp",
    example: "ra lệnh cho thuộc cấp",
  },
  {
    word: "thuốc bắc",
    part_of_speech: "danh từ",
    meaning:
      "thuốc chữa bệnh được chế biến từ các loại thảo mộc có nguồn gốc từ Trung Quốc; phân biệt với thuốc tây và thuốc nam: sắc thuốc bắc",
    example: "sắc thuốc bắc",
  },
  {
    word: "thuộc",
    part_of_speech: "động từ",
    meaning:
      "chế biến da súc vật thành nguyên liệu dai và bền để dùng trong công nghiệp: thuộc da làm trống",
    example: "thuộc da làm trống",
  },
  {
    word: "thuộc",
    part_of_speech: "động từ",
    meaning:
      "nhớ kĩ trong trí óc đến mức có thể nhắc lại hoặc nhận ra một cách dễ dàng và đầy đủ: học thuộc bài * thuộc đường lối",
    example: "học thuộc bài * thuộc đường lối",
  },
  {
    word: "thuộc",
    part_of_speech: "động từ",
    meaning:
      "nằm trong phạm vi sở hữu, điều khiển hoặc chi phối của một đối tượng nào đó: ngôi nhà thuộc về người anh cả",
    example: "ngôi nhà thuộc về người anh cả",
  },
  {
    word: "thuộc",
    part_of_speech: "động từ",
    meaning:
      "là một bộ phận, yếu tố hợp thành của một sự vật, đối tượng, phạm vi nào đó: câu chuyện đã thuộc về dĩ vãng",
    example: "câu chuyện đã thuộc về dĩ vãng",
  },
  {
    word: "thuốc đạn",
    part_of_speech: "danh từ",
    meaning:
      "thuốc ở dạng rắn, có hình giống viên đạn, dễ tan trong cơ thể, thường dùng để đặt vào trong hậu môn: đặt thuốc đạn hạ sốt cho bé",
    example: "đặt thuốc đạn hạ sốt cho bé",
  },
  {
    word: "thuốc đặc hiệu",
    part_of_speech: "danh từ",
    meaning:
      "thuốc có công dụng và hiệu quả đặc biệt trong việc điều trị một loại bệnh nào đó: thuốc đặc hiệu chữa bệnh lao",
    example: "thuốc đặc hiệu chữa bệnh lao",
  },
  {
    word: "thuộc hạ",
    part_of_speech: "danh từ",
    meaning:
      "người cấp dưới, trực tiếp dưới quyền quản lí, sai khiến, trong quan hệ với người cấp trên: khiển trách bọn thuộc hạ",
    example: "khiển trách bọn thuộc hạ",
  },
  {
    word: "thuốc lá",
    part_of_speech: "danh từ",
    meaning:
      "cây thuộc họ cà, hoa màu hồng nhạt, lá to, mềm, có lông và nhựa dính, dùng làm thuốc để hút: trồng thuốc lá * dây chuyền sấy thuốc lá",
    example: "trồng thuốc lá * dây chuyền sấy thuốc lá",
  },
  {
    word: "thuốc lá",
    part_of_speech: "danh từ",
    meaning:
      "thuốc hút được chế biến từ cây thuốc lá, thường được quấn thành điếu: bao thuốc lá * hút thuốc lá có hại cho sức khoẻ",
    example: "bao thuốc lá * hút thuốc lá có hại cho sức khoẻ",
  },
  {
    word: "thuốc lào",
    part_of_speech: "danh từ",
    meaning:
      "cây cùng họ với thuốc lá, lá được dùng đem ủ rồi thái ra để hút bằng điếu hoặc để ăn kèm với trầu: bánh thuốc lào",
    example: "bánh thuốc lào",
  },
  {
    word: "thuộc địa",
    part_of_speech: "danh từ",
    meaning:
      "nước hoặc vùng lãnh thổ bị một nước đế quốc thực dân xâm chiếm và đô hộ: các dân tộc thuộc địa * nước thuộc địa",
    example: "các dân tộc thuộc địa * nước thuộc địa",
  },
  {
    word: "thuốc độc",
    part_of_speech: "danh từ",
    meaning:
      "chất độc dùng để giết người hay các loài vật: uống thuốc độc tự tử * mũi tên tẩm thuốc độc",
    example: "uống thuốc độc tự tử * mũi tên tẩm thuốc độc",
  },
  {
    word: "thuốc độc",
    part_of_speech: "danh từ",
    meaning:
      "thuốc chữa bệnh có chất độc với một hàm lượng nhất định cho phép: thuốc độc bảng A (loại thuốc có chứa độc tố cao nhất trong nhóm phân loại)",
    example:
      "thuốc độc bảng A (loại thuốc có chứa độc tố cao nhất trong nhóm phân loại)",
  },
  {
    word: "thuộc làu",
    part_of_speech: "động từ",
    meaning:
      "thuộc đến mức có thể nói lại hoặc kể ra một cách trôi chảy và hoàn toàn chính xác: nghe nhiều đến thuộc làu * thuộc làu đường đất vùng này",
    example: "nghe nhiều đến thuộc làu * thuộc làu đường đất vùng này",
  },
  {
    word: "thuốc men",
    part_of_speech: "danh từ",
    meaning:
      "thuốc dùng để phòng hoặc chữa bệnh (nói khái quát): chạy chữa thuốc men * không đủ thuốc men để điều trị",
    example: "chạy chữa thuốc men * không đủ thuốc men để điều trị",
  },
  {
    word: "thuộc lòng",
    part_of_speech: "động từ",
    meaning:
      "thuộc đến mức nhớ mãi trong trí óc, bất cứ lúc nào cũng có thể nhắc lại hoặc nhận ra ngay một cách dễ dàng và đầy đủ: học thuộc lòng bài thơ",
    example: "học thuộc lòng bài thơ",
  },
  {
    word: "thuốc mê",
    part_of_speech: "danh từ",
    meaning: "thuốc dùng để gây mê: tiêm thuốc mê trước khi mổ",
    example: "tiêm thuốc mê trước khi mổ",
  },
  {
    word: "thuốc nam",
    part_of_speech: "danh từ",
    meaning:
      "thuốc chữa bệnh được chế biến từ các loại thảo mộc có nguồn gốc ở Việt Nam: chữa bệnh bằng thuốc nam",
    example: "chữa bệnh bằng thuốc nam",
  },
  {
    word: "thuốc mỡ",
    part_of_speech: "danh từ",
    meaning:
      "thuốc ở dạng kem đặc, nhờn, dùng để bôi lên da hay niêm mạc: bôi thuốc mỡ",
    example: "bôi thuốc mỡ",
  },
  {
    word: "thuốc nước",
    part_of_speech: "danh từ",
    meaning:
      "thuốc được điều chế ở dạng chất lỏng, có thể dùng để uống hoặc bôi ngoài da.",
    example: "tranh thuốc nước",
  },
  {
    word: "thuốc phiện",
    part_of_speech: "danh từ",
    meaning:
      "cây trồng ở vùng cao, lá mọc so le, khía răng không đều, hoa nhiều màu sắc, thân và quả cho một thứ nhựa để hút hay dùng để chế morphin, codein: cây thuốc phiện * hút thuốc phiện",
    example: "cây thuốc phiện * hút thuốc phiện",
  },
  {
    word: "thuốc súng",
    part_of_speech: "danh từ",
    meaning:
      "hỗn hợp thuốc nổ ở dạng rắn, mịn, thường dùng trong đạn súng và vào việc nổ mìn phá đá: thùng thuốc súng * mùi thuốc súng khét lẹt",
    example: "thùng thuốc súng * mùi thuốc súng khét lẹt",
  },
  {
    word: "thuốc sâu",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) thuốc trừ sâu (nói tắt): phun thuốc sâu",
    example: "phun thuốc sâu",
  },
  {
    word: "thuốc thang",
    part_of_speech: "danh từ",
    meaning:
      "như thuốc men (nhưng thường nói về thuốc đông y): chăm lo thuốc thang cho người bệnh",
    example: "chăm lo thuốc thang cho người bệnh",
  },
  {
    word: "thuốc thang",
    part_of_speech: "động từ",
    meaning:
      "chữa bệnh bằng các loại thuốc (nói khái quát): chạy vạy để thuốc thang cho chồng",
    example: "chạy vạy để thuốc thang cho chồng",
  },
  {
    word: "thuốn",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng thường làm bằng một ống kim loại, nhọn đầu, dùng xiên vào lòng vật gì để lấy hay thăm dò những thứ ở bên trong: xăm hầm bằng thuốn",
    example: "xăm hầm bằng thuốn",
  },
  {
    word: "thuốn",
    part_of_speech: "động từ",
    meaning:
      "xiên mạnh cho ngập sâu vào bằng cái thuốn hoặc bằng vật tương tự: mũi khoan thuốn sâu vào lòng đất",
    example: "mũi khoan thuốn sâu vào lòng đất",
  },
  {
    word: "thuốc trừ sâu",
    part_of_speech: "danh từ",
    meaning:
      "chất hoá học có tác dụng diệt trừ các loại sâu bọ có hại: phun thuốc trừ sâu cho lúa",
    example: "phun thuốc trừ sâu cho lúa",
  },
  {
    word: "thuộc tính",
    part_of_speech: "danh từ",
    meaning:
      "đặc tính riêng vốn có của một sự vật, nhờ đó sự vật tồn tại và qua đó con người nhận thức được sự vật, phân biệt được sự vật này với sự vật khác: thuộc tính vật lí * các thuộc tính của sự vật",
    example: "thuộc tính vật lí * các thuộc tính của sự vật",
  },
  {
    word: "thuồn",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) như tuồn (ng2): tên trộm thuồn đồ qua hàng rào cho đồng bọn",
    example: "tên trộm thuồn đồ qua hàng rào cho đồng bọn",
  },
  {
    word: "thuỗn",
    part_of_speech: "tính từ",
    meaning: "(vẻ mặt, dáng điệu) ngây ra, đờ ra, bất động: mặt ngây thuỗn",
    example: "mặt ngây thuỗn",
  },
  {
    word: "thuỗn",
    part_of_speech: "tính từ",
    meaning:
      "dài thượt ra, trông không đẹp mắt (thường nói về bộ phận cơ thể): mặt dài thuỗn như lưỡi cày",
    example: "mặt dài thuỗn như lưỡi cày",
  },
  {
    word: "thuôn",
    part_of_speech: "động từ",
    meaning:
      "chế biến món ăn làm từ thịt bằng cách nấu nhiều nước cùng với hành và rau răm: thuôn thịt bò",
    example: "thuôn thịt bò",
  },
  {
    word: "thuồn thuỗn",
    part_of_speech: "tính từ",
    meaning: "như thuỗn (nhưng ý nhấn mạnh hơn): mặt dài thuồn thuỗn",
    example: "mặt dài thuồn thuỗn",
  },
  {
    word: "thụt",
    part_of_speech: "động từ",
    meaning:
      "rụt lại hoặc lùi nhanh vào nơi kín đáo: rùa thụt đầu vào mai * thấy có người lạ, đứa bé lại thụt vào buồng",
    example:
      "rùa thụt đầu vào mai * thấy có người lạ, đứa bé lại thụt vào buồng",
  },
  {
    word: "thụt",
    part_of_speech: "động từ",
    meaning:
      "sa xuống chỗ trũng sâu một cách đột ngột và bất ngờ: đang đi bỗng thụt chân xuống hố",
    example: "đang đi bỗng thụt chân xuống hố",
  },
  {
    word: "thụt",
    part_of_speech: "động từ",
    meaning:
      "nằm lùi sâu vào phía bên trong, không ngang hàng với những cái khác: ngôi nhà nằm thụt sâu trong ngõ",
    example: "ngôi nhà nằm thụt sâu trong ngõ",
  },
  {
    word: "thụt",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) tụt lại phía sau hoặc tụt thấp xuống: khai thụt đi hai tuổi * thụt lại phía sau",
    example: "khai thụt đi hai tuổi * thụt lại phía sau",
  },
  {
    word: "thụt",
    part_of_speech: "động từ",
    meaning:
      "đẩy chất lỏng hoặc chất khí qua một ống dẫn, bằng sức ép: thụt bễ lò rèn",
    example: "thụt bễ lò rèn",
  },
  {
    word: "thụt",
    part_of_speech: "động từ",
    meaning:
      "đẩy nước hoặc thuốc vào cơ thể qua hậu môn hoặc cửa mình bằng một ống dẫn: thụt rửa ruột cho người bị ngộ độc thức ăn",
    example: "thụt rửa ruột cho người bị ngộ độc thức ăn",
  },
  {
    word: "thụt",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bắn (thường nói về loại vũ khí có dạng hình ống): thụt cho mấy quả đạn pháo",
    example: "thụt cho mấy quả đạn pháo",
  },
  {
    word: "thụt",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) lấy cắp của công mà mình có trách nhiệm coi giữ: thụt tiền công quỹ",
    example: "thụt tiền công quỹ",
  },
  {
    word: "thuổng",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ để đào đất, gồm có một lưỡi sắt nặng hơi uốn cong hình lòng máng, được tra thẳng chiều với một cán dài: mai dài hơn thuổng (tng)",
    example: "mai dài hơn thuổng (tng)",
  },
  {
    word: "thuở",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian không xác định đã lùi xa vào quá khứ, hoặc đôi khi thuộc về tương lai xa: thuở xưa * biết thuở nào cho xong * dạy con từ thuở còn thơ",
    example: "thuở xưa * biết thuở nào cho xong * dạy con từ thuở còn thơ",
  },
  {
    word: "thụt lùi",
    part_of_speech: "động từ",
    meaning: "di chuyển lùi dần về phía sau: thụt lùi một bước * đi thụt lùi",
    example: "thụt lùi một bước * đi thụt lùi",
  },
  {
    word: "thụt lùi",
    part_of_speech: "động từ",
    meaning: "sút kém so với trước: sức học ngày càng thụt lùi",
    example: "sức học ngày càng thụt lùi",
  },
  {
    word: "thút",
    part_of_speech: "động từ",
    meaning:
      "xuyên sâu vào trong một cách dễ dàng và nhanh chóng: mảnh đạn cắm thút vào thân chuối",
    example: "mảnh đạn cắm thút vào thân chuối",
  },
  {
    word: "thụp",
    part_of_speech: "động từ",
    meaning:
      "hạ thấp mình xuống một cách nhanh và đột ngột, thường là để tránh hoặc để trốn: ngồi thụp xuống",
    example: "ngồi thụp xuống",
  },
  {
    word: "thụp",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng trầm và nặng như tiếng đấm tay vào vật mềm: đấm thụp vào lưng bạn",
    example: "đấm thụp vào lưng bạn",
  },
  {
    word: "thút thít",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả tiếng khóc nhỏ và ngắt quãng, xen với tiếng xịt mũi: khóc thút thít",
    example: "khóc thút thít",
  },
  {
    word: "thuý",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) chim trả, có lông màu xanh biếc rất đẹp, thời xưa thường dùng làm đồ trang sức cho phụ nữ quý tộc: chia uyên rẽ thuý * "Dầu dãi nắng mưa lần áo thuý, Dầm dề sương tuyết giọt khăn là." (LTKN)',
    example:
      'chia uyên rẽ thuý * "Dầu dãi nắng mưa lần áo thuý, Dầm dề sương tuyết giọt khăn là." (LTKN)',
  },
  {
    word: "thuỳ",
    part_of_speech: "danh từ",
    meaning:
      "phần tròn và lồi ở một số cơ quan của sinh vật: bị tổn thương ở thuỳ não trái * lá xẻ thành năm thuỳ",
    example: "bị tổn thương ở thuỳ não trái * lá xẻ thành năm thuỳ",
  },
  {
    word: "thuỷ",
    part_of_speech: "danh từ",
    meaning: "nước: giao thông đường thuỷ",
    example: "giao thông đường thuỷ",
  },
  {
    word: "thuỷ binh",
    part_of_speech: "danh từ",
    meaning: "(cũ) thuỷ quân: đội thuỷ binh với hàng trăm chiến thuyền",
    example: "đội thuỷ binh với hàng trăm chiến thuyền",
  },
  {
    word: "thuỷ chiến",
    part_of_speech: "động từ",
    meaning: "chiến đấu trên sông, biển: trận thuỷ chiến trên sông Bạch Đằng",
    example: "trận thuỷ chiến trên sông Bạch Đằng",
  },
  {
    word: "thuỷ châm",
    part_of_speech: "động từ",
    meaning:
      "tiêm thuốc trực tiếp vào các huyệt trên cơ thể để chữa bệnh, theo đông y: chữa bệnh bằng phương pháp thuỷ châm",
    example: "chữa bệnh bằng phương pháp thuỷ châm",
  },
  {
    word: "thuỷ chung",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) đầu đuôi, trước sau (của sự việc): "Từ công nghe nói thuỷ chung, Bất bình nổi trận đùng đùng sấm vang." (TKiều)',
    example:
      'Từ công nghe nói thuỷ chung, Bất bình nổi trận đùng đùng sấm vang." (TKiều)',
  },
  {
    word: "thuỷ chung",
    part_of_speech: "tính từ",
    meaning: "như chung thuỷ: ăn ở thuỷ chung",
    example: "ăn ở thuỷ chung",
  },
  {
    word: "thuỷ cung",
    part_of_speech: "danh từ",
    meaning:
      "cung điện tưởng tượng ở dưới nước, theo truyền thuyết: vua thuỷ tề sống ở dưới thuỷ cung",
    example: "vua thuỷ tề sống ở dưới thuỷ cung",
  },
  {
    word: "thuỷ cung",
    part_of_speech: "danh từ",
    meaning:
      "nơi nuôi dưỡng, bảo tồn các loài động vật biển trong những bể kính rất lớn, được bố trí tạo cho người xem có cảm giác như đang ở dưới đáy biển: du khách đến tham quan thuỷ cung",
    example: "du khách đến tham quan thuỷ cung",
  },
  {
    word: "thuỷ công",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) công trình thuỷ lợi nói chung, như đập nước, âu tàu, nhà máy thuỷ điện, v.v.: các công trình thuỷ công * kĩ sư thuỷ công",
    example: "các công trình thuỷ công * kĩ sư thuỷ công",
  },
  {
    word: "thuỷ điện",
    part_of_speech: "danh từ",
    meaning: "điện do năng lượng của nước sinh ra: nhà máy thuỷ điện Hoà Bình",
    example: "nhà máy thuỷ điện Hoà Bình",
  },
  {
    word: "thuỷ động",
    part_of_speech: "danh từ",
    meaning:
      "hang động nằm trong vùng có nước hoặc ở ngầm dưới mặt nước: khu thuỷ động Phong Nha",
    example: "khu thuỷ động Phong Nha",
  },
  {
    word: "thuỷ động",
    part_of_speech: "tính từ",
    meaning: "thuộc về sự chuyển động của các chất lỏng: lực thuỷ động",
    example: "lực thuỷ động",
  },
  {
    word: "thuỷ lực",
    part_of_speech: "danh từ",
    meaning:
      "lực do sức chuyển động của nước tạo ra: máy ép thuỷ lực * hệ thống nâng thuỷ lực",
    example: "máy ép thuỷ lực * hệ thống nâng thuỷ lực",
  },
  {
    word: "thuỷ lực",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) thuỷ lực học (nói tắt): bộ môn thuỷ lực",
    example: "bộ môn thuỷ lực",
  },
  {
    word: "thuỷ lợi",
    part_of_speech: "danh từ",
    meaning:
      "việc lợi dụng tác dụng của nước và chống các tác hại của nó: công trình thuỷ lợi",
    example: "công trình thuỷ lợi",
  },
  {
    word: "thuỷ lợi",
    part_of_speech: "danh từ",
    meaning: "ngành khoa học nghiên cứu về thuỷ lợi: học viện thuỷ lợi",
    example: "học viện thuỷ lợi",
  },
  {
    word: "thuỷ luyện",
    part_of_speech: "động từ",
    meaning:
      "luyện kim trong môi trường có nước, thường được tiến hành ở nhiệt độ thấp: công nghệ thuỷ luyện",
    example: "công nghệ thuỷ luyện",
  },
  {
    word: "thuỳ mị",
    part_of_speech: "tính từ",
    meaning:
      "dịu dàng, hiền hậu và nết na, biểu hiện ở nét mặt, cử chỉ và cách nói năng (thường nói về người con gái): tính tình thuỳ mị * người con gái thuỳ mị",
    example: "tính tình thuỳ mị * người con gái thuỳ mị",
  },
  {
    word: "thuỷ lôi",
    part_of_speech: "danh từ",
    meaning:
      "mìn chuyên thả dưới nước, có sức công phá lớn: tàu va phải thuỷ lôi",
    example: "tàu va phải thuỷ lôi",
  },
  {
    word: "thuỷ mạc",
    part_of_speech: "danh từ",
    meaning: "lối vẽ chỉ dùng mực tàu: tranh thuỷ mạc",
    example: "tranh thuỷ mạc",
  },
  {
    word: "thuỷ mặc",
    part_of_speech: "danh từ",
    meaning: "lối vẽ chỉ dùng mực tàu: tranh thuỷ mạc",
    example: "tranh thuỷ mạc",
  },
  {
    word: "thuỷ nông",
    part_of_speech: "danh từ",
    meaning: "thuỷ lợi phục vụ nông nghiệp: công trình thuỷ nông",
    example: "công trình thuỷ nông",
  },
  {
    word: "thuỷ sản",
    part_of_speech: "danh từ",
    meaning:
      "sản vật ở dưới nước, có giá trị kinh tế như cá, tôm, hải sâm, rau câu, v.v. (nói khái quát): khai thác và đánh bắt thuỷ sản",
    example: "khai thác và đánh bắt thuỷ sản",
  },
  {
    word: "thuỷ phân",
    part_of_speech: "động từ",
    meaning:
      "(hiện tượng một hợp chất) phân huỷ do tác dụng của nước: quá trình thuỷ phân của các chất hữu cơ",
    example: "quá trình thuỷ phân của các chất hữu cơ",
  },
  {
    word: "thuỷ sinh",
    part_of_speech: "động từ",
    meaning:
      "sống ở dưới nước, mọc trong nước: động vật thuỷ sinh * loài cây thuỷ sinh",
    example: "động vật thuỷ sinh * loài cây thuỷ sinh",
  },
  {
    word: "thuỷ thần",
    part_of_speech: "danh từ",
    meaning:
      "thần cai quản ở dưới nước, theo tưởng tượng của người xưa: miếu thờ thuỷ thần",
    example: "miếu thờ thuỷ thần",
  },
  {
    word: "thuỷ táng",
    part_of_speech: "động từ",
    meaning:
      "thả thi hài xuống sông, biển, theo nghi thức tang lễ: lễ thuỷ táng",
    example: "lễ thuỷ táng",
  },
  {
    word: "thuỷ thổ",
    part_of_speech: "danh từ",
    meaning:
      "điều kiện đất đai, sông nước, khí hậu của một vùng (nói khái quát): thông thạo thuỷ thổ",
    example: "thông thạo thuỷ thổ",
  },
  {
    word: "thuỷ thủ",
    part_of_speech: "danh từ",
    meaning: "nhân viên làm việc trên tàu thuỷ: thuỷ thủ viễn dương",
    example: "thuỷ thủ viễn dương",
  },
  {
    word: "thuỷ tạ",
    part_of_speech: "danh từ",
    meaning:
      "nhà xây trên mặt nước, dùng làm nơi vui chơi, giải trí: làm nhà thuỷ tạ trên hồ sen",
    example: "làm nhà thuỷ tạ trên hồ sen",
  },
  {
    word: "thuỷ tinh",
    part_of_speech: "danh từ",
    meaning:
      "chất rắn, giòn và trong suốt, được chế từ cát, dùng làm kính, chai lọ, v.v.: cốc thuỷ tinh",
    example: "cốc thuỷ tinh",
  },
  {
    word: "thuỷ tinh thể",
    part_of_speech: "danh từ",
    meaning:
      "khối chất keo trong suốt có vỏ bọc hình thấu kính hội tụ, nằm trong cầu mắt, có chức năng phồng lên hay dẹt xuống để điều tiết cho mắt có thể nhìn gần hoặc xa được rõ: bị đục thuỷ tinh thể",
    example: "bị đục thuỷ tinh thể",
  },
  {
    word: "thuỷ triều",
    part_of_speech: "danh từ",
    meaning:
      "hiện tượng nước biển dâng lên rút xuống một hai lần trong ngày, chủ yếu do sức hút của Mặt Trăng và Mặt Trời: thuỷ triều lên",
    example: "thuỷ triều lên",
  },
  {
    word: "thuỷ tổ",
    part_of_speech: "danh từ",
    meaning:
      "ông tổ đầu tiên; thường dùng để gọi người sáng lập ra cái gì trong lịch sử: Khổng Tử là thuỷ tổ của đạo nho",
    example: "Khổng Tử là thuỷ tổ của đạo nho",
  },
  {
    word: "thuỷ văn",
    part_of_speech: "danh từ",
    meaning:
      "các hiện tượng biến hoá và vận động của nước trong tự nhiên (nói tổng quát): cơ quan nghiên cứu thuỷ văn",
    example: "cơ quan nghiên cứu thuỷ văn",
  },
  {
    word: "thuyền buồm",
    part_of_speech: "danh từ",
    meaning: "thuyền có gắn buồm, chạy bằng sức gió.",
    example: "câu lạc bộ thuyền buồm",
  },
  {
    word: "thuyền bè",
    part_of_speech: "danh từ",
    meaning:
      "thuyền và các phương tiện giao thông nhỏ trên mặt nước (nói khái quát): thuyền bè tấp nập trên sông",
    example: "thuyền bè tấp nập trên sông",
  },
  {
    word: "thuỷ văn học",
    part_of_speech: "danh từ",
    meaning:
      "khoa học nghiên cứu về nước trong tự nhiên: tốt nghiệp chuyên ngành thuỷ văn học",
    example: "tốt nghiệp chuyên ngành thuỷ văn học",
  },
  {
    word: "thuyền",
    part_of_speech: "danh từ",
    meaning:
      'phương tiện giao thông trên mặt nước, thường nhỏ và thô sơ, hoạt động bằng sức người, sức gió: "Thuyền ơi có nhớ bến chăng, Bến thì một dạ khăng khăng đợi thuyền." (ca dao)',
    example:
      'Thuyền ơi có nhớ bến chăng, Bến thì một dạ khăng khăng đợi thuyền." (ca dao)',
  },
  {
    word: "thuyền chài",
    part_of_speech: "danh từ",
    meaning: "thuyền nhỏ dùng để đánh cá bằng chài lưới.",
    example: "vợ chồng thuyền chài",
  },
  {
    word: "thuyên chuyển",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) đổi nơi ở, di chuyển tới một nơi khác: cơ quan đã thuyên chuyển đi nơi khác",
    example: "cơ quan đã thuyên chuyển đi nơi khác",
  },
  {
    word: "thuyên chuyển",
    part_of_speech: "động từ",
    meaning:
      "chuyển đổi đi làm công tác khác, ở một nơi khác: thuyên chuyển công tác",
    example: "thuyên chuyển công tác",
  },
  {
    word: "thuyền lan",
    part_of_speech: "danh từ",
    meaning:
      'thuyền đẹp, thường làm bằng gỗ mộc lan, thời xưa dùng để đi chơi: "Gió cuốn buồm dong lá phất phơ, Thuyền lan lãng đãng giữa doành tơ." (LTKN)',
    example:
      'Gió cuốn buồm dong lá phất phơ, Thuyền lan lãng đãng giữa doành tơ." (LTKN)',
  },
  {
    word: "thuyên giảm",
    part_of_speech: "động từ",
    meaning: "(bệnh) có phần giảm nhẹ: bệnh đã thuyên giảm",
    example: "bệnh đã thuyên giảm",
  },
  {
    word: "thuyền quyên",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) người con gái đẹp: gái thuyền quyên * "Thuyền quyên sánh với anh hùng, Những người thục nữ sánh cùng văn nhân." (ca dao)',
    example:
      'gái thuyền quyên * "Thuyền quyên sánh với anh hùng, Những người thục nữ sánh cùng văn nhân." (ca dao)',
  },
  {
    word: "thuyết",
    part_of_speech: "danh từ",
    meaning:
      "hệ thống những tư tưởng, kiến giải về mặt lí luận trong một lĩnh vực khoa học: thuyết tương đối của Albert Einstein",
    example: "thuyết tương đối của Albert Einstein",
  },
  {
    word: "thuyết",
    part_of_speech: "động từ",
    meaning:
      "(cũ, hiếm) giảng giải, dùng lí lẽ để phân tích nhằm làm người ta nghe theo: thuyết giặc ra hàng",
    example: "thuyết giặc ra hàng",
  },
  {
    word: "thuyết",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) giảng giải toàn những lí lẽ suông, dài dòng: thuyết một hồi về đạo đức",
    example: "thuyết một hồi về đạo đức",
  },
  {
    word: "thuyết giảng",
    part_of_speech: "động từ",
    meaning:
      "trình bày, giảng giải về một vấn đề: nhà sư đang thuyết giảng đạo pháp",
    example: "nhà sư đang thuyết giảng đạo pháp",
  },
  {
    word: "thuyết giáo",
    part_of_speech: "động từ",
    meaning: "trình bày, giảng giải về giáo lí, về đạo lí: nhà sư thuyết giáo",
    example: "nhà sư thuyết giáo",
  },
  {
    word: "thuyết giáo",
    part_of_speech: "động từ",
    meaning:
      "giảng giải với những lí luận dài dòng, xa thực tế (thường là về đạo đức), nhằm làm cho người ta nghe theo: thuyết giáo về lối sống mới",
    example: "thuyết giáo về lối sống mới",
  },
  {
    word: "thuyết minh",
    part_of_speech: "",
    meaning:
      "nói hoặc chú thích cho người ta hiểu rõ hơn về những sự vật, sự việc hoặc hình ảnh đã đưa ra: phim nước ngoài được thuyết minh bằng tiếng Việt * bản vẽ thiết kế có kèm thuyết minh",
    example:
      "phim nước ngoài được thuyết minh bằng tiếng Việt * bản vẽ thiết kế có kèm thuyết minh",
  },
  {
    word: "thuyết khách",
    part_of_speech: "động từ",
    meaning:
      "(cũ) dùng tài ăn nói để thuyết phục người khác nghe theo (thường nói về một loại hoạt động ngoại giao thời phong kiến): được nhà vua cử đi thuyết khách",
    example: "được nhà vua cử đi thuyết khách",
  },
  {
    word: "thuyết lí",
    part_of_speech: "động từ",
    meaning:
      "dùng lí luận thuần tuý để trình bày, giảng giải về một vấn đề gì: thuyết lí dài dòng",
    example: "thuyết lí dài dòng",
  },
  {
    word: "thuyết lý",
    part_of_speech: "động từ",
    meaning:
      "dùng lí luận thuần tuý để trình bày, giảng giải về một vấn đề gì: thuyết lí dài dòng",
    example: "thuyết lí dài dòng",
  },
  {
    word: "thuyết pháp",
    part_of_speech: "động từ",
    meaning:
      "giảng đạo pháp cho tín đồ trong những dịp nào đó (từ thường dùng trong đạo Phật): nhà sư thuyết pháp",
    example: "nhà sư thuyết pháp",
  },
  {
    word: "thuyết phục",
    part_of_speech: "",
    meaning:
      "làm cho người ta thấy đúng, thấy hay mà tin theo, làm theo: thuyết phục mãi nó mới đồng ý * lập luận chặt chẽ đầy sức thuyết phục",
    example:
      "thuyết phục mãi nó mới đồng ý * lập luận chặt chẽ đầy sức thuyết phục",
  },
  {
    word: "thuyết trình",
    part_of_speech: "động từ",
    meaning:
      "trình bày rõ ràng một vấn đề trước nhiều người: thuyết trình đề tài khoa học * bản thuyết trình dự án xây dựng khu đô thị mới",
    example:
      "thuyết trình đề tài khoa học * bản thuyết trình dự án xây dựng khu đô thị mới",
  },
  {
    word: "thừ",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái đờ ra, như không còn buồn cử động, không còn có khả năng cảm giác nữa, thường do mệt mỏi hoặc đang mải nghĩ về một chuyện gì: mệt thừ cả người * ngồi thừ ra nghĩ ngợi",
    example: "mệt thừ cả người * ngồi thừ ra nghĩ ngợi",
  },
  {
    word: "thứ",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp những sự vật giống nhau về một hay những mặt nhất định nào đó, phân biệt với những tập hợp khác trong cùng loại: thứ chè hảo hạng * chọn thứ vải mỏng cho mát * đầu hai thứ tóc",
    example: "thứ chè hảo hạng * chọn thứ vải mỏng cho mát * đầu hai thứ tóc",
  },
  {
    word: "thứ",
    part_of_speech: "danh từ",
    meaning:
      "sự vật hoặc điều cụ thể nào đó (nói khái quát): chuẩn bị mọi thứ * đồ đạc trong nhà không thiếu thứ gì",
    example: "chuẩn bị mọi thứ * đồ đạc trong nhà không thiếu thứ gì",
  },
  {
    word: "thứ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) loại người được coi là thấp kém hoặc đáng khinh, đáng ghét: ai thèm cái thứ ấy! * thứ người gì mà ngang như cua!",
    example: "ai thèm cái thứ ấy! * thứ người gì mà ngang như cua!",
  },
  {
    word: "thứ",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng trước danh từ số lượng để chỉ thứ tự trong sắp xếp: vua Hùng Vương đời thứ mười tám * đang học đại học năm thứ ba",
    example: "vua Hùng Vương đời thứ mười tám * đang học đại học năm thứ ba",
  },
  {
    word: "thứ",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng trước danh từ số lượng để chỉ ngày trong tuần: thứ hai là ngày đầu tuần * nghỉ học ngày thứ bảy",
    example: "thứ hai là ngày đầu tuần * nghỉ học ngày thứ bảy",
  },
  {
    word: "thứ",
    part_of_speech: "tính từ",
    meaning:
      "(vợ, con) ở bậc dưới, hàng thứ hai, sau người cả: vợ thứ * con thứ",
    example: "vợ thứ * con thứ",
  },
  {
    word: "thử",
    part_of_speech: "động từ",
    meaning:
      "làm như thật , hoặc chỉ dùng một ít hay trong thời gian ngắn, để qua đó xác định tính chất, chất lượng, đối chiếu với yêu cầu: thử quần áo * tổ chức cho học sinh thi thử * ăn thử xem có ngon không",
    example:
      "thử quần áo * tổ chức cho học sinh thi thử * ăn thử xem có ngon không",
  },
  {
    word: "thử",
    part_of_speech: "động từ",
    meaning:
      "dùng những biện pháp kĩ thuật hay tâm lí để phân tích, xem xét đặc tính, thực chất của sự vật hoặc con người cần tìm hiểu: thử máu * thử lòng nhau",
    example: "thử máu * thử lòng nhau",
  },
  {
    word: "thử",
    part_of_speech: "động từ",
    meaning:
      "làm để xem kết quả ra sao, may ra có thể được (thường dùng trong lời khuyên nhẹ nhàng): thử nhớ lại xem * lấy kìm vặn thử xem, biết đâu lại được",
    example: "thử nhớ lại xem * lấy kìm vặn thử xem, biết đâu lại được",
  },
  {
    word: "thứ bậc",
    part_of_speech: "danh từ",
    meaning:
      "trật tự sắp xếp cao thấp, trên dưới, theo một mối quan hệ tôn ti nào đó: xếp theo thứ bậc trên dưới * theo thứ bậc trong họ thì tôi là anh nó",
    example:
      "xếp theo thứ bậc trên dưới * theo thứ bậc trong họ thì tôi là anh nó",
  },
  {
    word: "thư",
    part_of_speech: "danh từ",
    meaning:
      "giấy viết gửi cho người nào đó, mang nội dung về những điều mình muốn nói với người ấy: viết thư * gửi thư qua đường bưu điện",
    example: "viết thư * gửi thư qua đường bưu điện",
  },
  {
    word: "thư",
    part_of_speech: "động từ",
    meaning: "(Khẩu ngữ) viết thư (cho ai đó): thư cho người yêu",
    example: "thư cho người yêu",
  },
  {
    word: "thư",
    part_of_speech: "động từ",
    meaning:
      "để cho hoãn lại, chậm lại một thời gian, không bức bách phải làm ngay việc gì (thường dùng trong lời cầu xin): cho thư món nợ * xin ông thư cho đến mai",
    example: "cho thư món nợ * xin ông thư cho đến mai",
  },
  {
    word: "thư",
    part_of_speech: "tính từ",
    meaning: "ở trạng thái công việc đã bớt thúc bách hơn: công việc đã thư",
    example: "công việc đã thư",
  },
  {
    word: "thư dãn",
    part_of_speech: "động từ",
    meaning:
      "làm cho cơ bắp, đầu óc được thả lỏng hoặc thảnh thơi hoàn toàn, tạo nên cảm giác thư thái và thoải mái cho cơ thể: nghỉ ngơi cho thư dãn đầu óc",
    example: "nghỉ ngơi cho thư dãn đầu óc",
  },
  {
    word: "thứ dân",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) hạng dân thường không có chức vị gì trong xã hội phong kiến (nói tổng quát): phường thứ dân",
    example: "phường thứ dân",
  },
  {
    word: "thử hỏi",
    part_of_speech: "",
    meaning:
      "tổ hợp biểu thị ý nêu ra như muốn hỏi, nhằm để cho người đối thoại tự trả lời bằng phủ định, qua đó tự rút ra kết luận (như ý của người nói muốn nói): làm ăn như thế, thử hỏi ai không tức?",
    example: "làm ăn như thế, thử hỏi ai không tức?",
  },
  {
    word: "thư kí",
    part_of_speech: "danh từ",
    meaning:
      "người giúp việc, làm các công việc về giấy tờ (quản lí, sơ thảo các văn bản, hồ sơ, v.v.): thư kí văn phòng * thư kí giám đốc",
    example: "thư kí văn phòng * thư kí giám đốc",
  },
  {
    word: "thư kí",
    part_of_speech: "danh từ",
    meaning:
      "chức vụ của người điều hành các công việc hằng ngày, soạn thảo những giấy tờ, văn bản quan trọng (của một số tổ chức, cơ quan, đoàn thể): thư kí công đoàn",
    example: "thư kí công đoàn",
  },
  {
    word: "thư kí",
    part_of_speech: "danh từ",
    meaning:
      "người có nhiệm vụ ghi biên bản, soạn thảo quyết định (của một hội nghị, một phiên toà): thư kí toà án * thư kí của hội nghị * thư kí hội đồng khoa học",
    example: "thư kí toà án * thư kí của hội nghị * thư kí hội đồng khoa học",
  },
  {
    word: "thứ hạng",
    part_of_speech: "danh từ",
    meaning:
      "trật tự sắp xếp cao thấp, trên dưới, theo trình độ: thi đấu để phân thứ hạng",
    example: "thi đấu để phân thứ hạng",
  },
  {
    word: "thư hoạ",
    part_of_speech: "danh từ",
    meaning:
      "hình thức nghệ thuật vẽ kết hợp với phép viết chữ Hán của Trung Quốc: triển lãm thư hoạ",
    example: "triển lãm thư hoạ",
  },
  {
    word: "thư ký",
    part_of_speech: "danh từ",
    meaning:
      "người giúp việc, làm các công việc về giấy tờ (quản lí, sơ thảo các văn bản, hồ sơ, v.v.): thư kí văn phòng * thư kí giám đốc",
    example: "thư kí văn phòng * thư kí giám đốc",
  },
  {
    word: "thư ký",
    part_of_speech: "danh từ",
    meaning:
      "chức vụ của người điều hành các công việc hằng ngày, soạn thảo những giấy tờ, văn bản quan trọng (của một số tổ chức, cơ quan, đoàn thể): thư kí công đoàn",
    example: "thư kí công đoàn",
  },
  {
    word: "thư ký",
    part_of_speech: "danh từ",
    meaning:
      "người có nhiệm vụ ghi biên bản, soạn thảo quyết định (của một hội nghị, một phiên toà): thư kí toà án * thư kí của hội nghị * thư kí hội đồng khoa học",
    example: "thư kí toà án * thư kí của hội nghị * thư kí hội đồng khoa học",
  },
  {
    word: "thư kí riêng",
    part_of_speech: "danh từ",
    meaning:
      "người giúp việc cho một nhân vật cao cấp trong các công việc về giấy tờ, giao thiệp, sắp xếp và chuẩn bị nội dung công việc hằng ngày: thư kí riêng của thủ tướng",
    example: "thư kí riêng của thủ tướng",
  },
  {
    word: "thư hương",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) nhà dòng dõi có truyền thống học tập: "Khách du bỗng có một người, Kỳ Tâm họ Thúc, cũng nòi thư hương." (TKiều)',
    example:
      'Khách du bỗng có một người, Kỳ Tâm họ Thúc, cũng nòi thư hương." (TKiều)',
  },
  {
    word: "thư hùng",
    part_of_speech: "",
    meaning: "(cũ, văn chương) sống mái: trận thư hùng",
    example: "trận thư hùng",
  },
  {
    word: "thứ lỗi",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) tha lỗi, bỏ qua cho (chỉ dùng trong lời xin lỗi): tôi đã sai, xin ông thứ lỗi",
    example: "tôi đã sai, xin ông thứ lỗi",
  },
  {
    word: "thứ liệu",
    part_of_speech: "danh từ",
    meaning:
      "vật liệu có chất lượng kém hoặc đã bị bỏ đi của một công đoạn trong sản xuất hay chế biến trước đó: tái chế thứ liệu",
    example: "tái chế thứ liệu",
  },
  {
    word: "thư lưu",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) thư lưu kí (nói tắt): hòm thư lưu",
    example: "hòm thư lưu",
  },
  {
    word: "thử lửa",
    part_of_speech: "động từ",
    meaning:
      "đưa vào lửa để xem xét phẩm chất của vàng; thường dùng để ví sự thử thách khắc nghiệt qua khó khăn, nguy hiểm: qua thử lửa, người chiến sĩ đã trở nên vững vàng",
    example: "qua thử lửa, người chiến sĩ đã trở nên vững vàng",
  },
  {
    word: "thư ký riêng",
    part_of_speech: "danh từ",
    meaning:
      "người giúp việc cho một nhân vật cao cấp trong các công việc về giấy tờ, giao thiệp, sắp xếp và chuẩn bị nội dung công việc hằng ngày: thư kí riêng của thủ tướng",
    example: "thư kí riêng của thủ tướng",
  },
  {
    word: "thư mục",
    part_of_speech: "danh từ",
    meaning:
      "danh mục các sách báo, tài liệu viết về một vấn đề nào đó, thường được sắp xếp theo trật tự nhất định: cuối sách có thư mục tài liệu tham khảo",
    example: "cuối sách có thư mục tài liệu tham khảo",
  },
  {
    word: "thư mục",
    part_of_speech: "danh từ",
    meaning:
      "tài liệu giới thiệu vắn tắt những đặc điểm và nội dung cơ bản của các sách báo để giúp bạn đọc dễ tra tìm và sử dụng: thư mục của tủ sách trong thư viện * biên soạn thư mục chuyên đề",
    example: "thư mục của tủ sách trong thư viện * biên soạn thư mục chuyên đề",
  },
  {
    word: "thư mục",
    part_of_speech: "danh từ",
    meaning:
      "nơi chứa các tập tin hoặc chứa các thư mục con khác tại một địa chỉ trên đĩa máy tính dưới một tên gọi duy nhất: tạo thư mục mới * đặt tên cho thư mục",
    example: "tạo thư mục mới * đặt tên cho thư mục",
  },
  {
    word: "thử nghiệm",
    part_of_speech: "",
    meaning:
      "làm thử, coi như đó là một thí nghiệm để xem kết quả sẽ ra sao.: trồng thử nghiệm giống lúa mới * thử nghiệm này đã thành công",
    example: "trồng thử nghiệm giống lúa mới * thử nghiệm này đã thành công",
  },
  {
    word: "thư nhàn",
    part_of_speech: "tính từ",
    meaning: "thư thả và nhàn rỗi: lúc thư nhàn",
    example: "lúc thư nhàn",
  },
  {
    word: "thư ngỏ",
    part_of_speech: "danh từ",
    meaning:
      "bài viết dưới hình thức một bức thư công khai, thường có tính chất luận chiến hoặc yêu sách: thư ngỏ gửi ngài tổng thống",
    example: "thư ngỏ gửi ngài tổng thống",
  },
  {
    word: "thứ phát",
    part_of_speech: "động từ",
    meaning:
      "(hiện tượng bệnh lí) phát sinh ra sau giai đoạn thứ nhất; phân biệt với nguyên phát: nhiễm trùng thứ phát * vô sinh thứ phát",
    example: "nhiễm trùng thứ phát * vô sinh thứ phát",
  },
  {
    word: "thư phong",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) bức thư để trong phong bì: "Cho theo một đứa tiểu đồng, Thư phong một bức dặn cùng Vân Tiên." (LVT)',
    example:
      'Cho theo một đứa tiểu đồng, Thư phong một bức dặn cùng Vân Tiên." (LVT)',
  },
  {
    word: "thứ phẩm",
    part_of_speech: "danh từ",
    meaning:
      "sản phẩm không đáp ứng đầy đủ những yêu cầu về mặt quy cách hoặc chất lượng; phân biệt với chính phẩm: bán thanh lí một số mặt hàng thứ phẩm",
    example: "bán thanh lí một số mặt hàng thứ phẩm",
  },
  {
    word: "thứ sinh",
    part_of_speech: "tính từ",
    meaning: "được sinh ra từ một cái đã có trước: nguồn lây bệnh thứ sinh",
    example: "nguồn lây bệnh thứ sinh",
  },
  {
    word: "thứ sinh",
    part_of_speech: "tính từ",
    meaning:
      "(rừng) tự mọc lại, sau khi đã khai thác; phân biệt với nguyên sinh: rừng thứ sinh",
    example: "rừng thứ sinh",
  },
  {
    word: "thứ thiệt",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ, khẩu ngữ) thuộc loại thật, có giá trị đúng với bản chất của nó, không phải là giả: hàng thứ thiệt * dân chơi thứ thiệt",
    example: "hàng thứ thiệt * dân chơi thứ thiệt",
  },
  {
    word: "thư tay",
    part_of_speech: "danh từ",
    meaning: "thư nhờ người mang đến, không gửi qua bưu điện: gửi thư tay",
    example: "gửi thư tay",
  },
  {
    word: "thử thách",
    part_of_speech: "",
    meaning:
      "đặt vào tình huống khó khăn, nguy hiểm để qua đó thấy rõ tinh thần, khả năng của con người: thử thách lòng dũng cảm * vượt qua thử thách",
    example: "thử thách lòng dũng cảm * vượt qua thử thách",
  },
  {
    word: "thứ sử",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) chức quan của chính quyền phong kiến Trung Quốc thời xưa, trông coi một hay một số quận hoặc đứng đầu bộ máy cai trị ở một nước phụ thuộc: thứ sử Giao Châu",
    example: "thứ sử Giao Châu",
  },
  {
    word: "thư sinh",
    part_of_speech: "danh từ",
    meaning: "(cũ) người học trò còn trẻ tuổi: chàng thư sinh",
    example: "chàng thư sinh",
  },
  {
    word: "thư sinh",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (người con trai) có dáng vẻ mảnh khảnh, yếu ớt và hiền lành của người ít lao động chân tay, như một học trò thời trước: có dáng thư sinh",
    example: "có dáng thư sinh",
  },
  {
    word: "thư thái",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái cảm thấy nhẹ nhàng, dễ chịu trong lòng, không có điều gì phải suy nghĩ căng thẳng: đầu óc thư thái * nghỉ ngơi cho tinh thần thư thái",
    example: "đầu óc thư thái * nghỉ ngơi cho tinh thần thư thái",
  },
  {
    word: "thư thoại",
    part_of_speech: "danh từ",
    meaning:
      "lời nhắn trực tiếp qua hệ thống điện thoại, thư điện tử mà người khác có thể nghe lại sau đó: đăng kí dịch vụ thư thoại * hộp thư thoại",
    example: "đăng kí dịch vụ thư thoại * hộp thư thoại",
  },
  {
    word: "thư tịch",
    part_of_speech: "danh từ",
    meaning:
      "sách và các tài liệu thành văn, thường nói về loại sách và tài liệu cũ, có từ lâu đời (nói khái quát): thư tịch Hán Nôm * sưu tầm và bảo tồn các thư tịch cổ",
    example: "thư tịch Hán Nôm * sưu tầm và bảo tồn các thư tịch cổ",
  },
  {
    word: "thư tín",
    part_of_speech: "danh từ",
    meaning: "thư từ gửi qua bưu điện (nói khái quát): trao đổi thư tín",
    example: "trao đổi thư tín",
  },
  {
    word: "thư tín điện tử",
    part_of_speech: "danh từ",
    meaning:
      "dịch vụ máy tính cho phép trao đổi thư từ bằng thư điện tử: dịch vụ thư tín điện tử",
    example: "dịch vụ thư tín điện tử",
  },
  {
    word: "thư tín dụng",
    part_of_speech: "danh từ",
    meaning:
      "văn bản pháp lí do một ngân hàng phát hành theo yêu cầu của người mua hàng, trong đó ngân hàng đứng cam kết trả tiền cho người bán hàng với những điều kiện nhất định (trong hoạt động xuất nhập khẩu): thanh toán bằng thư tín dụng * mở thư tín dụng",
    example: "thanh toán bằng thư tín dụng * mở thư tín dụng",
  },
  {
    word: "thư viện",
    part_of_speech: "danh từ",
    meaning:
      "nơi lưu giữ sách báo, tài liệu với số lượng lớn và tổ chức cho bạn đọc sử dụng: đọc sách ở thư viện",
    example: "đọc sách ở thư viện",
  },
  {
    word: "thứ tự",
    part_of_speech: "danh từ",
    meaning:
      "sự sắp xếp lần lượt trên dưới, trước sau, một cách hợp lí, theo một nguyên tắc nhất định: các mục từ được xếp theo thứ tự a, b, c * tính theo thứ tự từ trái sang phải",
    example:
      "các mục từ được xếp theo thứ tự a, b, c * tính theo thứ tự từ trái sang phải",
  },
  {
    word: "thứ yếu",
    part_of_speech: "tính từ",
    meaning:
      "không quan trọng lắm, nói trong sự so sánh với cái quan trọng hơn; phân biệt với chính yếu, chủ yếu: vấn đề thứ yếu * vai trò thứ yếu * những nhân vật thứ yếu",
    example: "vấn đề thứ yếu * vai trò thứ yếu * những nhân vật thứ yếu",
  },
  {
    word: "thứ trưởng",
    part_of_speech: "danh từ",
    meaning:
      "người giúp việc và có thể thay bộ trưởng lãnh đạo một bộ khi cần thiết: thứ trưởng ngoại giao",
    example: "thứ trưởng ngoại giao",
  },
  {
    word: "thư từ",
    part_of_speech: "danh từ",
    meaning: "thư gửi cho nhau (nói khái quát): gửi thư từ cho nhau",
    example: "gửi thư từ cho nhau",
  },
  {
    word: "thư từ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) gửi thư cho nhau (nói khái quát): hai đứa vẫn thư từ thường xuyên * đi biệt, chẳng thư từ về cho gia đình",
    example:
      "hai đứa vẫn thư từ thường xuyên * đi biệt, chẳng thư từ về cho gia đình",
  },
  {
    word: "thửa",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị mảnh ruộng, đất có diện tích đáng kể và được giới hạn rõ ràng: thửa ruộng * thửa vườn",
    example: "thửa ruộng * thửa vườn",
  },
  {
    word: "thửa",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đặt làm một vật gì theo những yêu cầu riêng: thửa một con dao thật tốt để đi rừng * giày thửa",
    example: "thửa một con dao thật tốt để đi rừng * giày thửa",
  },
  {
    word: "thừa",
    part_of_speech: "động từ",
    meaning:
      "theo, tuân theo (người có chức vụ hoặc thẩm quyền nào đó): thừa lệnh của thủ tướng",
    example: "thừa lệnh của thủ tướng",
  },
  {
    word: "thừa",
    part_of_speech: "động từ",
    meaning:
      "lợi dụng dịp, cơ hội hoặc điều kiện thuận lợi nào đó để làm việc gì: thừa lúc mọi người không để ý, lẻn đi",
    example: "thừa lúc mọi người không để ý, lẻn đi",
  },
  {
    word: "thừa",
    part_of_speech: "tính từ",
    meaning:
      "có hoặc đạt số lượng trên mức cần thiết: còn thừa thời gian * thừa tiền mà mua cái ngữ ấy!",
    example: "còn thừa thời gian * thừa tiền mà mua cái ngữ ấy!",
  },
  {
    word: "thừa",
    part_of_speech: "tính từ",
    meaning:
      "còn lại, sau khi đã dùng đủ rồi: cơm thừa canh cặn * phấn thừa hương cũ",
    example: "cơm thừa canh cặn * phấn thừa hương cũ",
  },
  {
    word: "thừa",
    part_of_speech: "tính từ",
    meaning:
      "có thêm một cách vô ích, không cần thiết: động tác thừa * câu hỏi thừa",
    example: "động tác thừa * câu hỏi thừa",
  },
  {
    word: "thừa",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ở mức quá đầy đủ, khiến trở thành như là hiển nhiên, không có gì phải nói nữa: thừa biết * nó thừa khôn ngoan để hiểu chuyện ấy",
    example: "thừa biết * nó thừa khôn ngoan để hiểu chuyện ấy",
  },
  {
    word: "thưa",
    part_of_speech: "động từ",
    meaning: "lên tiếng để đáp lại lời gọi: gọi nhưng không có ai thưa",
    example: "gọi nhưng không có ai thưa",
  },
  {
    word: "thưa",
    part_of_speech: "động từ",
    meaning:
      "trình bày hoặc bẩm báo với người trên một cách lễ phép, trân trọng: thưa chuyện * thưa với thầy giáo",
    example: "thưa chuyện * thưa với thầy giáo",
  },
  {
    word: "thưa",
    part_of_speech: "động từ",
    meaning:
      "từ dùng trước một từ hoặc tổ hợp từ xưng gọi để mở đầu khi nói với người trên hoặc trước đám đông, tỏ thái độ trân trọng, lễ phép: thưa chú, cháu nhớ rồi ạ! * thưa quý vị!",
    example: "thưa chú, cháu nhớ rồi ạ! * thưa quý vị!",
  },
  {
    word: "thưa",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều khoảng trống, khoảng hở hơn so với bình thường, do số lượng yếu tố, đơn vị tương đối ít và cách xa nhau tạo thành: rừng thưa * đất rộng người thưa * cấy thưa",
    example: "rừng thưa * đất rộng người thưa * cấy thưa",
  },
  {
    word: "thưa",
    part_of_speech: "tính từ",
    meaning:
      "(xảy ra) không nhiều và mỗi lần lại cách nhau một khoảng thời gian tương đối dài: đẻ thưa * tiếng súng thưa dần, rồi tắt hẳn",
    example: "đẻ thưa * tiếng súng thưa dần, rồi tắt hẳn",
  },
  {
    word: "thừa kế",
    part_of_speech: "động từ",
    meaning:
      "được hưởng cái của người đã chết để lại cho (thường nói về tài sản, của cải): quyền thừa kế * thừa kế gia sản",
    example: "quyền thừa kế * thừa kế gia sản",
  },
  {
    word: "thừa cơ",
    part_of_speech: "động từ",
    meaning:
      "lợi dụng ngay lấy cơ hội hay dịp tốt nào đó để làm việc gì: thừa cơ không ai để ý, lẩn mất",
    example: "thừa cơ không ai để ý, lẩn mất",
  },
  {
    word: "thừa hưởng",
    part_of_speech: "động từ",
    meaning:
      "được hưởng cái của người khác (thường là của người trước) để lại: thừa hưởng gia tài",
    example: "thừa hưởng gia tài",
  },
  {
    word: "thừa hành",
    part_of_speech: "động từ",
    meaning:
      "làm theo chức trách, theo mệnh lệnh của cấp trên hoặc theo pháp luật: thừa hành lệnh của cấp trên * thừa hành công vụ",
    example: "thừa hành lệnh của cấp trên * thừa hành công vụ",
  },
  {
    word: "thừa mứa",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) thừa do nhiều đến mức không thể nào dùng hết được, gây cảm giác lãng phí: thức ăn thừa mứa",
    example: "thức ăn thừa mứa",
  },
  {
    word: "thưa gửi",
    part_of_speech: "động từ",
    meaning:
      "xưng gọi, nói năng với người trên một cách có lễ độ, phép tắc (nói khái quát): ăn nói xách mé, không thưa gửi gì hết",
    example: "ăn nói xách mé, không thưa gửi gì hết",
  },
  {
    word: "thừa lương",
    part_of_speech: "động từ",
    meaning:
      '(cũ, văn chương) hóng mát: "Có hôm nghiêm phụ thừa lương, Hướng vui dạo mát tìm đường thăm con." (PTNH)',
    example:
      'Có hôm nghiêm phụ thừa lương, Hướng vui dạo mát tìm đường thăm con." (PTNH)',
  },
  {
    word: "thừa nhận",
    part_of_speech: "động từ",
    meaning:
      "chịu nhận (khuyết điểm, sai lầm nào đó của mình) là có thật: thừa nhận khuyết điểm của mình * biết là sai nhưng không dám thừa nhận",
    example:
      "thừa nhận khuyết điểm của mình * biết là sai nhưng không dám thừa nhận",
  },
  {
    word: "thừa nhận",
    part_of_speech: "động từ",
    meaning:
      "đồng ý nhận là đúng với sự thật, là hợp lẽ phải, hợp pháp, không hoặc không còn phủ nhận hay nghi ngờ: phải thừa nhận là nó khoẻ",
    example: "phải thừa nhận là nó khoẻ",
  },
  {
    word: "thừa thãi",
    part_of_speech: "tính từ",
    meaning:
      "thừa nhiều, có thể sử dụng một cách thoải mái mà không sợ hết, sợ thiếu (nói khái quát): quần áo thừa thãi, mặc không hết",
    example: "quần áo thừa thãi, mặc không hết",
  },
  {
    word: "thừa số",
    part_of_speech: "danh từ",
    meaning:
      "một trong các thành phần của một tích: a và b là hai thừa số của tích ab",
    example: "a và b là hai thừa số của tích ab",
  },
  {
    word: "thừa sống thiếu chết",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) chỉ còn một chút nữa là chết; suýt chết: đánh cho một trận thừa sống thiếu chết",
    example: "đánh cho một trận thừa sống thiếu chết",
  },
  {
    word: "thừa thế",
    part_of_speech: "động từ",
    meaning: "thừa lúc đang có lợi thế: thừa thế làm càn",
    example: "thừa thế làm càn",
  },
  {
    word: "thừa thắng",
    part_of_speech: "động từ",
    meaning: "thừa lúc đang ở vào thế thắng: thừa thắng xông lên",
    example: "thừa thắng xông lên",
  },
  {
    word: "thưa thốt",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) bày tỏ, nói ra ý kiến của mình (nói khái quát): biết thì thưa thốt, không biết thì dựa cột mà nghe (tng)",
    example: "biết thì thưa thốt, không biết thì dựa cột mà nghe (tng)",
  },
  {
    word: "thừa tự",
    part_of_speech: "động từ",
    meaning:
      "thừa hưởng tài sản của ông cha để lại và chăm lo việc thờ cúng, theo tục lệ cũ: đứa con thừa tự",
    example: "đứa con thừa tự",
  },
  {
    word: "thưa thớt",
    part_of_speech: "tính từ",
    meaning:
      "rất thưa và phân bố không đều nhau, chỗ nhiều chỗ ít, lúc có lúc không, gây cảm giác rời rạc: dân cư thưa thớt",
    example: "dân cư thưa thớt",
  },
  {
    word: "thức ăn",
    part_of_speech: "danh từ",
    meaning:
      "thứ có chứa chất dinh dưỡng và có thể tiêu hoá được, dùng để nuôi sống con người và động vật, nói chung: chế biến thức ăn * cỏ là nguồn thức ăn chính của trâu bò",
    example: "chế biến thức ăn * cỏ là nguồn thức ăn chính của trâu bò",
  },
  {
    word: "thức ăn",
    part_of_speech: "danh từ",
    meaning:
      "các thứ dùng để ăn với cơm, thường là cá, thịt, v.v., nói chung: ăn vã thức ăn",
    example: "ăn vã thức ăn",
  },
  {
    word: "thức",
    part_of_speech: "danh từ",
    meaning:
      "thứ, món, loại, nói chung (thường nói về đồ ăn uống): đồ ăn thức uống * mùa nào thức ấy",
    example: "đồ ăn thức uống * mùa nào thức ấy",
  },
  {
    word: "thức",
    part_of_speech: "động từ",
    meaning:
      "ở trạng thái không ngủ hoặc chưa ngủ, trong thời gian thông thường dùng để ngủ: thức khuya dậy sớm * thức lâu mới biết đêm dài (tng)",
    example: "thức khuya dậy sớm * thức lâu mới biết đêm dài (tng)",
  },
  {
    word: "thức",
    part_of_speech: "động từ",
    meaning:
      "tỉnh dậy hoặc làm cho tỉnh dậy: thức dậy lúc nửa đêm * đang ngủ thì bị đánh thức",
    example: "thức dậy lúc nửa đêm * đang ngủ thì bị đánh thức",
  },
  {
    word: "thực",
    part_of_speech: "tính từ",
    meaning:
      "có thật, có thể nhận biết trực tiếp bằng giác quan: cảnh vật nửa thực nửa hư",
    example: "cảnh vật nửa thực nửa hư",
  },
  {
    word: "thưa vắng",
    part_of_speech: "tính từ",
    meaning: "vắng, ít hẳn đi so với trước: nhà hát thưa vắng khách",
    example: "nhà hát thưa vắng khách",
  },
  {
    word: "thực bụng",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như thực lòng: nói thực bụng",
    example: "nói thực bụng",
  },
  {
    word: "thực chất",
    part_of_speech: "danh từ",
    meaning:
      "cái nội dung thực có bên trong của sự vật, hiện tượng: đi vào thực chất của vấn đề * quán cà phê thực chất là ổ mại dâm trá hình",
    example:
      "đi vào thực chất của vấn đề * quán cà phê thực chất là ổ mại dâm trá hình",
  },
  {
    word: "thực dụng",
    part_of_speech: "tính từ",
    meaning:
      "(cũ, hoặc id) có giá trị thiết thực, mang lại lợi ích thực tế: tính thực dụng của đề tài khoa học",
    example: "tính thực dụng của đề tài khoa học",
  },
  {
    word: "thực dụng",
    part_of_speech: "tính từ",
    meaning:
      "chỉ nhằm vào những gì có thể mang lại lợi ích vật chất thiết thực và trước mắt cho mình, không quan tâm đến những mặt khác: lối sống thực dụng * con người thực dụng",
    example: "lối sống thực dụng * con người thực dụng",
  },
  {
    word: "thực chi",
    part_of_speech: "động từ",
    meaning:
      "đã chi trong thực tế; phân biệt với dự chi: tổng cộng số tiền thực chi",
    example: "tổng cộng số tiền thực chi",
  },
  {
    word: "thực dân",
    part_of_speech: "danh từ",
    meaning: "chủ nghĩa thực dân (nói tắt): chính sách thực dân",
    example: "chính sách thực dân",
  },
  {
    word: "thực dân",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) người ở nước tư bản, thuộc tầng lớp bóc lột, thống trị ở nước thuộc địa, trong quan hệ với nhân dân nước thuộc địa (nói khái quát): một tên thực dân cáo già",
    example: "một tên thực dân cáo già",
  },
  {
    word: "thực địa",
    part_of_speech: "danh từ",
    meaning:
      "địa bàn, đất đai trên thực tế, phân biệt với sự phản ánh trên giấy tờ, bản đồ, v.v.: khảo sát thực địa",
    example: "khảo sát thực địa",
  },
  {
    word: "thực đơn",
    part_of_speech: "danh từ",
    meaning:
      "bản liệt kê các món ăn có trong nhà hàng hoặc trong một bữa tiệc: lên thực đơn cho bữa tiệc",
    example: "lên thực đơn cho bữa tiệc",
  },
  {
    word: "thực hư",
    part_of_speech: "tính từ",
    meaning:
      "(sự việc) có hay không, và nếu có, thì có đến mức nào (nói khái quát): chưa rõ thực hư * tỏ tường thực hư",
    example: "chưa rõ thực hư * tỏ tường thực hư",
  },
  {
    word: "thực hành",
    part_of_speech: "động từ",
    meaning:
      "làm để áp dụng lí thuyết vào thực tế (nói khái quát): lí thuyết phải đi đôi với thực hành",
    example: "lí thuyết phải đi đôi với thực hành",
  },
  {
    word: "thực hành",
    part_of_speech: "động từ",
    meaning: "(hiếm) như thực hiện (ng1): thực hành tiết kiệm",
    example: "thực hành tiết kiệm",
  },
  {
    word: "thực khách",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) quý tộc thất thế ở nhờ (làm khách ăn thường xuyên) một nhà giàu có hào hiệp, thời xưa, trong quan hệ với chủ nhà: nhà có nhiều thực khách",
    example: "nhà có nhiều thực khách",
  },
  {
    word: "thực khách",
    part_of_speech: "danh từ",
    meaning:
      "(trang trọng) khách ăn của một cửa hàng ăn hoặc của một bữa tiệc: là thực khách thường xuyên của nhà hàng",
    example: "là thực khách thường xuyên của nhà hàng",
  },
  {
    word: "thức giấc",
    part_of_speech: "động từ",
    meaning:
      "thức dậy, không còn ở trạng thái ngủ nữa: giật mình thức giấc * tiếng nổ làm mọi người thức giấc",
    example: "giật mình thức giấc * tiếng nổ làm mọi người thức giấc",
  },
  {
    word: "thực hiện",
    part_of_speech: "động từ",
    meaning:
      "làm cho trở thành sự thật bằng những việc làm hoặc hành động cụ thể: thực hiện lời hứa * nói nhưng không thực hiện",
    example: "thực hiện lời hứa * nói nhưng không thực hiện",
  },
  {
    word: "thực hiện",
    part_of_speech: "động từ",
    meaning:
      "làm theo trình tự, phép tắc nhất định: thực hiện phép tính * thực hiện ca phẫu thuật",
    example: "thực hiện phép tính * thực hiện ca phẫu thuật",
  },
  {
    word: "thực lòng",
    part_of_speech: "tính từ",
    meaning: "thành thật, từ đáy lòng, không có gì giả dối: nói rất thực lòng",
    example: "nói rất thực lòng",
  },
  {
    word: "thực lực",
    part_of_speech: "danh từ",
    meaning:
      "sức mạnh có thật chứ không phải trên danh nghĩa hoặc dựa vào kẻ khác: không có thực lực * thực lực quân giặc đã suy yếu",
    example: "không có thực lực * thực lực quân giặc đã suy yếu",
  },
  {
    word: "thực lợi",
    part_of_speech: "danh từ",
    meaning:
      "kinh doanh bằng cách đầu tư tư bản để thu lợi tức mà không trực tiếp quản lí kinh doanh: tư bản thực lợi * tầng lớp thực lợi (chuyên sống bằng lợi tức)",
    example: "tư bản thực lợi * tầng lớp thực lợi (chuyên sống bằng lợi tức)",
  },
  {
    word: "thực sự",
    part_of_speech: "tính từ",
    meaning:
      "thật, có thật, với đầy đủ mức độ hoặc ý nghĩa: người chủ thật sự * giỏi thật sự * thật sự ngạc nhiên",
    example: "người chủ thật sự * giỏi thật sự * thật sự ngạc nhiên",
  },
  {
    word: "thực mục sở thị",
    part_of_speech: "",
    meaning: "(cũ) nhìn thấy tận mắt: phải thực mục sở thị thì mới tin",
    example: "phải thực mục sở thị thì mới tin",
  },
  {
    word: "thực nghiệm",
    part_of_speech: "động từ",
    meaning:
      "tạo ra những biến đổi nào đó ở sự vật để quan sát nhằm nghiên cứu những hiện tượng nhất định, kiểm tra một ý kiến hoặc gợi ra những ý kiến mới (nói khái quát): hoá học là một khoa học thực nghiệm",
    example: "hoá học là một khoa học thực nghiệm",
  },
  {
    word: "thực ra",
    part_of_speech: "",
    meaning:
      "tổ hợp biểu thị điều sắp nêu ra mới là sự thật và nó có phần trái với điều vừa nói đến hoặc với điều người ta vẫn thường nghĩ: thật ra anh ta cũng là một người tốt",
    example: "thật ra anh ta cũng là một người tốt",
  },
  {
    word: "thực quyền",
    part_of_speech: "danh từ",
    meaning:
      "quyền hành có thật chứ không phải trên danh nghĩa: nắm thực quyền * có danh vị nhưng không có thực quyền",
    example: "nắm thực quyền * có danh vị nhưng không có thực quyền",
  },
  {
    word: "thực phẩm",
    part_of_speech: "danh từ",
    meaning:
      "các thứ dùng để chế biến thành món ăn, như thịt, cá, trứng, v.v. (nói khái quát); phân biệt với lương thực: bảo quản thực phẩm * nhà máy chế biến thực phẩm",
    example: "bảo quản thực phẩm * nhà máy chế biến thực phẩm",
  },
  {
    word: "thực tại",
    part_of_speech: "danh từ",
    meaning:
      "tổng thể nói chung những gì hiện đang tồn tại thực tế xung quanh chúng ta: thực tại éo le * mải mơ mộng, quên hết thực tại",
    example: "thực tại éo le * mải mơ mộng, quên hết thực tại",
  },
  {
    word: "thực tài",
    part_of_speech: "danh từ",
    meaning: "tài năng có thật: không có thực tài",
    example: "không có thực tài",
  },
  {
    word: "thực tâm",
    part_of_speech: "tính từ",
    meaning:
      "thật lòng, không giả dối: thực tâm hối cải * thực tâm giúp đỡ bạn bè",
    example: "thực tâm hối cải * thực tâm giúp đỡ bạn bè",
  },
  {
    word: "thực tập",
    part_of_speech: "động từ",
    meaning:
      "tập làm trong thực tế để vận dụng và củng cố kiến thức lí thuyết, trau dồi thêm về nghiệp vụ, chuyên môn: viết báo cáo sau chuyến đi thực tập * sinh viên thực tập",
    example: "viết báo cáo sau chuyến đi thực tập * sinh viên thực tập",
  },
  {
    word: "thực tế",
    part_of_speech: "danh từ",
    meaning:
      "tổng thể nói chung những gì đang tồn tại, đang diễn ra trong tự nhiên và trong xã hội, về mặt có quan hệ đến đời sống con người: tìm hiểu tình hình thực tế * đúng hay sai, thực tế sẽ trả lời",
    example: "tìm hiểu tình hình thực tế * đúng hay sai, thực tế sẽ trả lời",
  },
  {
    word: "thực tế",
    part_of_speech: "danh từ",
    meaning:
      "trên thực tế, trong thực tế (nói tắt): thực tế không ai làm như vậy",
    example: "thực tế không ai làm như vậy",
  },
  {
    word: "thực tế",
    part_of_speech: "tính từ",
    meaning:
      "có giá trị, có ý nghĩa thiết thực: xây nhà tình nghĩa là một việc làm rất thực tế",
    example: "xây nhà tình nghĩa là một việc làm rất thực tế",
  },
  {
    word: "thực tế",
    part_of_speech: "tính từ",
    meaning:
      "có ý thức coi trọng thực tế và tỏ ra thiết thực trong các hoạt động của mình: đầu óc rất thực tế",
    example: "đầu óc rất thực tế",
  },
  {
    word: "thực tập sinh",
    part_of_speech: "danh từ",
    meaning:
      "người được cử đi làm việc ở các cơ quan nghiên cứu, các trường đại học để trau dồi thêm về kiến thức nghiệp vụ chuyên môn: cử thực tập sinh ra nước ngoài",
    example: "cử thực tập sinh ra nước ngoài",
  },
  {
    word: "thực thể",
    part_of_speech: "danh từ",
    meaning: "cái có sự tồn tại độc lập: con người là một thực thể của xã hội",
    example: "con người là một thực thể của xã hội",
  },
  {
    word: "thức thời",
    part_of_speech: "tính từ",
    meaning:
      "hiểu biết thời thế và có những hành động phù hợp, trong lúc xã hội đang có nhiều biến đổi: tư tưởng thức thời * đầu óc cổ hủ, không thức thời",
    example: "tư tưởng thức thời * đầu óc cổ hủ, không thức thời",
  },
  {
    word: "thực thụ",
    part_of_speech: "tính từ",
    meaning:
      "thật sự, với đầy đủ tư cách và bản chất như vốn có chứ không phải chỉ trên danh nghĩa: một nhà văn thực thụ",
    example: "một nhà văn thực thụ",
  },
  {
    word: "thực thi",
    part_of_speech: "động từ",
    meaning:
      "thực hiện điều đã được giao cho, đã được chính thức quyết định: thực thi mệnh lệnh của cấp trên",
    example: "thực thi mệnh lệnh của cấp trên",
  },
  {
    word: "thực tiễn",
    part_of_speech: "danh từ",
    meaning:
      "những hoạt động của con người, trước hết là lao động sản xuất, nhằm tạo ra những điều kiện cần thiết cho sự tồn tại của xã hội (nói tổng quát): thực tiễn cuộc sống * ứng dụng lí thuyết vào thực tiễn",
    example: "thực tiễn cuộc sống * ứng dụng lí thuyết vào thực tiễn",
  },
  {
    word: "thực tiễn",
    part_of_speech: "tính từ",
    meaning:
      "có ý thức coi trọng thực tiễn trong các hoạt động: một con người có đầu óc thực tiễn",
    example: "một con người có đầu óc thực tiễn",
  },
  {
    word: "thực thu",
    part_of_speech: "động từ",
    meaning:
      "đã thu được trong thực tế; phân biệt với dự thu: con số thực thu cao hơn so với dự tính ban đầu",
    example: "con số thực thu cao hơn so với dự tính ban đầu",
  },
  {
    word: "thực tình",
    part_of_speech: "tính từ",
    meaning:
      "thành thật, đúng với thực tế của tình cảm, ý nghĩ, không giả dối: mời rất thực tình * nói thực tình",
    example: "mời rất thực tình * nói thực tình",
  },
  {
    word: "thực tình",
    part_of_speech: "tính từ",
    meaning:
      "hay p đúng như vậy, sự thật là như vậy: thực tình, tôi cũng không muốn chuyện này xảy ra",
    example: "thực tình, tôi cũng không muốn chuyện này xảy ra",
  },
  {
    word: "thực trạng",
    part_of_speech: "danh từ",
    meaning:
      "tình trạng (thường là không tốt) đúng với sự thật, có khác với những gì nhìn thấy bên ngoài: thực trạng suy thoái của nền kinh tế",
    example: "thực trạng suy thoái của nền kinh tế",
  },
  {
    word: "thực tình mà nói",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị ý nhấn mạnh điều sắp nói là điều suy nghĩ thực lòng, nhưng bây giờ mới nói ra: thực tình mà nói thì anh cũng có cái sai",
    example: "thực tình mà nói thì anh cũng có cái sai",
  },
  {
    word: "thức tỉnh",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) bừng tỉnh và nhận thức ra được lẽ phải, giúp cho thoát khỏi được sự mê muội sai lầm nào đó.",
    example: "bài thơ làm thức tỉnh lòng yêu nước * lương tri thức tỉnh",
  },
  {
    word: "thực từ",
    part_of_speech: "danh từ",
    meaning:
      "từ có ý nghĩa từ vựng độc lập và có khả năng làm thành phần câu: danh từ, tính từ, động từ là những thực từ",
    example: "danh từ, tính từ, động từ là những thực từ",
  },
  {
    word: "thực vật bậc thấp",
    part_of_speech: "danh từ",
    meaning:
      "thực vật có cấu tạo đơn giản, cơ thể chưa phân hoá thành thân, lá, rễ một cách rõ ràng: tảo là một loài thực vật bậc thấp",
    example: "tảo là một loài thực vật bậc thấp",
  },
  {
    word: "thực vật",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi chung các loài cây cỏ và những sinh vật bậc thấp khác có tính chất như cây cỏ, trong các tế bào cơ thể thường có màng bằng cellulos: thuốc bảo vệ thực vật * dầu thực vật",
    example: "thuốc bảo vệ thực vật * dầu thực vật",
  },
  {
    word: "thừng",
    part_of_speech: "danh từ",
    meaning:
      "dây to và chắc, thường được bện bằng đay, gai, dùng để buộc: sợi dây thừng",
    example: "sợi dây thừng",
  },
  {
    word: "thực vật học",
    part_of_speech: "danh từ",
    meaning: "môn khoa học nghiên cứu về thực vật: nhà thực vật học",
    example: "nhà thực vật học",
  },
  {
    word: "thước",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị cũ đo độ dài, bằng khoảng 0,425 mét (thước mộc) hoặc 0,645 mét (thước đo vải).",
    example: "nhà chỉ có dăm thước đất",
  },
  {
    word: "thước",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị cũ đo diện tích ruộng đất, bằng 24 mét vuông (thước Bắc Bộ), hoặc 33 mét vuông (thước Trung Bộ): nhà chỉ có dăm thước đất",
    example: "kẻ bằng thước * thước đo độ",
  },
  {
    word: "thước",
    part_of_speech: "danh từ",
    meaning: "tên gọi thông thường của mét.",
    example:
      'Người nách thước, kẻ tay đao, Đầu trâu, mặt ngựa ào ào như sôi." (TKiều)',
  },
  {
    word: "thưng",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ đong lường, có dung tích không xác định, thường khoảng một lít, trong dân gian thường dùng để đong chất hạt rời: một thưng gạo",
    example: "một thưng gạo",
  },
  {
    word: "thưng",
    part_of_speech: "động từ",
    meaning:
      "làm thành vách ngăn để che kín bằng cách ghép tạm những tấm vật liệu đơn giản như phên, cót: ngôi nhà thưng bằng nứa",
    example: "ngôi nhà thưng bằng nứa",
  },
  {
    word: "thước đo",
    part_of_speech: "danh từ",
    meaning:
      "cái được dùng làm chuẩn để xác định giá trị của những cái khác có tính chất trừu tượng: thước đo giá trị * lợi nhuận là thước đo hiệu quả trong kinh doanh",
    example:
      "thước đo giá trị * lợi nhuận là thước đo hiệu quả trong kinh doanh",
  },
  {
    word: "thưỡi",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) trề dài ra, dài thượt ra, trông không đẹp (thường nói về môi, mặt): mặt thưỡi ra * thưỡi môi ra mắng",
    example: "mặt thưỡi ra * thưỡi môi ra mắng",
  },
  {
    word: "thưỡn",
    part_of_speech: "",
    meaning:
      "ngay và cứng đờ, trông như dài ra, vẻ khó coi (thường nói về dáng mặt hoặc người): đứng thưỡn người ra nhìn",
    example: "đứng thưỡn người ra nhìn",
  },
  {
    word: "thườn thượt",
    part_of_speech: "tính từ",
    meaning: "như thượt (nhưng ý nhấn mạnh hơn): nằm thườn thượt trên giường",
    example: "nằm thườn thượt trên giường",
  },
  {
    word: "thương",
    part_of_speech: "danh từ",
    meaning: "binh khí cổ, cán dài, mũi nhọn, giống như ngọn giáo",
    example: "tìm thương của phép chia * Thương của 10/5 là 2.",
  },
  {
    word: "thương",
    part_of_speech: "động từ",
    meaning:
      "có tình cảm gắn bó, và thường tỏ ra quan tâm săn sóc một cách chu đáo: mẹ thương con",
    example: "mẹ thương con",
  },
  {
    word: "thương",
    part_of_speech: "động từ",
    meaning:
      '(Nam) yêu: "Thương em nỏ biết mần răng, Mười đêm ra đứng trông trăng cả mười." (Cdao)',
    example:
      'Thương em nỏ biết mần răng, Mười đêm ra đứng trông trăng cả mười." (Cdao)',
  },
  {
    word: "thương",
    part_of_speech: "động từ",
    meaning:
      'cảm thấy đau đớn, xót xa trong lòng trước một cảnh ngộ không may nào đó: động lòng thương * "Khi tỉnh rượu, lúc tàn canh, Giật mình, mình lại thương mình xót xa." (TKiều)',
    example:
      'động lòng thương * "Khi tỉnh rượu, lúc tàn canh, Giật mình, mình lại thương mình xót xa." (TKiều)',
  },
  {
    word: "thưỡn thẹo",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như ưỡn ẹo: đưa đẩy đôi chân thưỡn thẹo",
    example: "đưa đẩy đôi chân thưỡn thẹo",
  },
  {
    word: "thưởng",
    part_of_speech: "động từ",
    meaning:
      "tặng tiền, hiện vật, v.v. để khen ngợi và khuyến khích vì đã có công lao, thành tích hoặc có việc làm tốt: thưởng cho người có công * có thưởng có phạt",
    example: "thưởng cho người có công * có thưởng có phạt",
  },
  {
    word: "thưởng",
    part_of_speech: "động từ",
    meaning:
      "(cũ) thưởng thức hoặc thưởng ngoạn (nói tắt): thưởng trà * thưởng nguyệt",
    example: "thưởng trà * thưởng nguyệt",
  },
  {
    word: "thường",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) đền: làm mất nên phải thường",
    example: "làm mất nên phải thường",
  },
  {
    word: "thường",
    part_of_speech: "tính từ",
    meaning:
      "không có gì khác lạ, không có gì đặc biệt so với số lớn những cái cùng loại: tài giỏi hơn hẳn người thường * ngày lễ cũng như ngày thường",
    example: "tài giỏi hơn hẳn người thường * ngày lễ cũng như ngày thường",
  },
  {
    word: "thường",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) bình thường, chỉ ở mức trung bình, không có gì nổi bật hoặc đáng chú ý: tài năng của anh ta xem ra cũng thường",
    example: "tài năng của anh ta xem ra cũng thường",
  },
  {
    word: "thường",
    part_of_speech: "phụ từ",
    meaning:
      "không lúc nào thôi, có sự lặp lại nhiều lần, lần này cách lần khác không lâu: đoạn đường thường xảy ra tai nạn * các lỗi thường gặp khi biên dịch",
    example:
      "đoạn đường thường xảy ra tai nạn * các lỗi thường gặp khi biên dịch",
  },
  {
    word: "thường",
    part_of_speech: "phụ từ",
    meaning:
      "theo lẽ thường, như thường thấy: ông cụ thường thức dậy lúc năm giờ sáng",
    example: "ông cụ thường thức dậy lúc năm giờ sáng",
  },
  {
    word: "thượng",
    part_of_speech: "tính từ",
    meaning:
      "ở trên cao hoặc phía trên, phía trước; đối lập với hạ: thượng nguồn * quyển thượng (quyển thứ nhất trong bộ sách gồm có hai hoặc ba quyển)",
    example:
      "thượng nguồn * quyển thượng (quyển thứ nhất trong bộ sách gồm có hai hoặc ba quyển)",
  },
  {
    word: "thượng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đưa lên, đặt lên trên cao cái không đáng đưa lên, gây cảm giác khó coi: cái gì cũng thượng lên bàn",
    example: "cái gì cũng thượng lên bàn",
  },
  {
    word: "thương binh",
    part_of_speech: "danh từ",
    meaning:
      "quân nhân bị thương do chiến đấu hoặc phục vụ cho chiến đấu: băng bó cho thương binh",
    example: "băng bó cho thương binh",
  },
  {
    word: "thương cảng",
    part_of_speech: "danh từ",
    meaning:
      "cảng biển chủ yếu dùng vào việc giao thương: thương cảng Hải Phòng",
    example: "thương cảng Hải Phòng",
  },
  {
    word: "thương chính",
    part_of_speech: "danh từ",
    meaning: "(cũ) hải quan: thuế thương chính",
    example: "thuế thương chính",
  },
  {
    word: "thường dân",
    part_of_speech: "danh từ",
    meaning:
      "người dân thường, phân biệt với quân nhân, tăng lữ hoặc với những tầng lớp đặc biệt khác trong xã hội, nói chung: cảnh sát ăn mặc giả thường dân * giải ngũ về làm thường dân",
    example: "cảnh sát ăn mặc giả thường dân * giải ngũ về làm thường dân",
  },
  {
    word: "thượng cổ",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về thời xa xưa nhất trong lịch sử thế giới: thời thượng cổ * người thượng cổ",
    example: "thời thượng cổ * người thượng cổ",
  },
  {
    word: "thượng du",
    part_of_speech: "danh từ",
    meaning:
      "miền rừng núi ở vùng thượng lưu các con sông; phân biệt với hạ du: các tỉnh thượng du * vùng thượng du",
    example: "các tỉnh thượng du * vùng thượng du",
  },
  {
    word: "thượng cấp",
    part_of_speech: "danh từ",
    meaning: "(cũ) cấp trên: tuân lệnh thượng cấp",
    example: "tuân lệnh thượng cấp",
  },
  {
    word: "thương cảm",
    part_of_speech: "động từ",
    meaning:
      "cảm động và thương xót trước một tình cảnh nào đó: ngậm ngùi thương cảm",
    example: "ngậm ngùi thương cảm",
  },
  {
    word: "thượng đài",
    part_of_speech: "động từ",
    meaning: "thi đấu trên võ đài: bị thương trong một lần thượng đài",
    example: "bị thương trong một lần thượng đài",
  },
  {
    word: "thượng đẳng",
    part_of_speech: "tính từ",
    meaning: "(cũ) thuộc bậc cao, hạng cao: thực vật thượng đẳng",
    example: "thực vật thượng đẳng",
  },
  {
    word: "thương hại",
    part_of_speech: "động từ",
    meaning:
      "rủ lòng thương xót: tỏ vẻ thương hại * thương hại những người nghèo khổ",
    example: "tỏ vẻ thương hại * thương hại những người nghèo khổ",
  },
  {
    word: "thượng đỉnh",
    part_of_speech: "danh từ",
    meaning: "đỉnh cao nhất: hội nghị thượng đỉnh (hội nghị cấp cao nhất)",
    example: "hội nghị thượng đỉnh (hội nghị cấp cao nhất)",
  },
  {
    word: "thương gia",
    part_of_speech: "danh từ",
    meaning:
      "người làm nghề kinh doanh, buôn bán lớn: một thương gia nổi tiếng",
    example: "một thương gia nổi tiếng",
  },
  {
    word: "thượng hảo hạng",
    part_of_speech: "tính từ",
    meaning: "thuộc loại đặc biệt tốt: loại xì gà thượng hảo hạng",
    example: "loại xì gà thượng hảo hạng",
  },
  {
    word: "thượng hạng",
    part_of_speech: "tính từ",
    meaning: "thuộc hạng nhất: vé thượng hạng * loại chè thượng hạng",
    example: "vé thượng hạng * loại chè thượng hạng",
  },
  {
    word: "thương điếm",
    part_of_speech: "danh từ",
    meaning: "(cũ) hiệu buôn: các thương điếm của người Hoa",
    example: "các thương điếm của người Hoa",
  },
  {
    word: "thượng khách",
    part_of_speech: "danh từ",
    meaning:
      "khách quý, được tiếp đãi một cách đặc biệt: đón tiếp thượng khách",
    example: "đón tiếp thượng khách",
  },
  {
    word: "thương hiệu",
    part_of_speech: "danh từ",
    meaning:
      "dấu hiệu đặc biệt (thường là tên) của nhà sản xuất hay nhà cung cấp, thường được gắn liền với sản phẩm hoặc dịch vụ nhằm làm cho chúng được nhận biết dễ dàng và phân biệt với các sản phẩm hoặc dịch vụ cùng loại của các nhà sản xuất hay nhà cung cấp khác: xây dựng và quảng bá thương hiệu * máy tính mang thương hiệu IBM",
    example: "xây dựng và quảng bá thương hiệu * máy tính mang thương hiệu IBM",
  },
  {
    word: "thường khi",
    part_of_speech: "",
    meaning:
      "thường ngày, như vẫn thường thấy: thường khi, ông trở dậy lúc 5 giờ * mặt mũi không tươi vui như thường khi",
    example:
      "thường khi, ông trở dậy lúc 5 giờ * mặt mũi không tươi vui như thường khi",
  },
  {
    word: "thường khi",
    part_of_speech: "",
    meaning:
      "(hiếm) nhiều khi, nhiều lúc: thường khi chưa nhận thức hết vấn đề",
    example: "thường khi chưa nhận thức hết vấn đề",
  },
  {
    word: "thượng khẩn",
    part_of_speech: "tính từ",
    meaning:
      "rất khẩn cấp, không thể để chậm trễ: lệnh thượng khẩn * công văn thượng khẩn",
    example: "lệnh thượng khẩn * công văn thượng khẩn",
  },
  {
    word: "thượng huyền",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian vào khoảng giữa của nửa đầu tháng âm lịch, khi mặt trăng có hình bán nguyệt (thường là các ngày 7, 8, 9 âm lịch); phân biệt với hạ huyền: trăng thượng huyền",
    example: "trăng thượng huyền",
  },
  {
    word: "thường kì",
    part_of_speech: "tính từ",
    meaning:
      "theo kì hạn đã định trước một cách đều đặn: phiên họp thường kì * khám sức khoẻ thường kì",
    example: "phiên họp thường kì * khám sức khoẻ thường kì",
  },
  {
    word: "thưởng lãm",
    part_of_speech: "động từ",
    meaning:
      "(cũ) ngắm nhìn để thưởng thức vẻ đẹp: thưởng lãm một bức tranh cổ",
    example: "thưởng lãm một bức tranh cổ",
  },
  {
    word: "thường lệ",
    part_of_speech: "danh từ",
    meaning:
      "lệ thường, theo thói quen hoặc theo như đã quy định: thói quen thường lệ * dậy sớm hơn thường lệ",
    example: "thói quen thường lệ * dậy sớm hơn thường lệ",
  },
  {
    word: "thường kỳ",
    part_of_speech: "tính từ",
    meaning:
      "theo kì hạn đã định trước một cách đều đặn: phiên họp thường kì * khám sức khoẻ thường kì",
    example: "phiên họp thường kì * khám sức khoẻ thường kì",
  },
  {
    word: "thương lái",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ) lái buôn: bị thương lái ép giá",
    example: "bị thương lái ép giá",
  },
  {
    word: "thương lượng",
    part_of_speech: "động từ",
    meaning:
      "trao đổi, bàn bạc với nhau nhằm đi đến thoả thuận giải quyết một vấn đề nào đó (thường là có liên quan đến quyền lợi giữa các bên): thương lượng về giá cả * kết thúc chiến tranh bằng thương lượng",
    example: "thương lượng về giá cả * kết thúc chiến tranh bằng thương lượng",
  },
  {
    word: "thượng lộ bình an",
    part_of_speech: "",
    meaning:
      "lên đường bình yên (thường dùng trong lời chúc người đi xa): chúc quý khách thượng lộ bình an",
    example: "chúc quý khách thượng lộ bình an",
  },
  {
    word: "thượng lương",
    part_of_speech: "động từ",
    meaning:
      "đặt thanh xà để dựng nóc khi làm nhà mới (thường chọn ngày lành và có làm lễ theo phong tục cổ truyền): chọn ngày để thượng lương",
    example: "chọn ngày để thượng lương",
  },
  {
    word: "thương mại điện tử",
    part_of_speech: "danh từ",
    meaning:
      "hệ thống thương mại hoạt động nhờ các phương tiện máy tính được nối mạng, thường biểu hiện qua dịch vụ thông tin trực tuyến, Internet, hệ thống bản tin hay qua trao đổi dữ liệu điện tử: hoạt động thương mại điện tử",
    example: "hoạt động thương mại điện tử",
  },
  {
    word: "thường ngày",
    part_of_speech: "",
    meaning: "hằng ngày: đồ dùng thường ngày * chuyện thường ngày",
    example: "đồ dùng thường ngày * chuyện thường ngày",
  },
  {
    word: "thương mến",
    part_of_speech: "",
    meaning: "như mến thương: đem lòng thương mến",
    example: "đem lòng thương mến",
  },
  {
    word: "thương mại hoá",
    part_of_speech: "động từ",
    meaning:
      "làm cho trở thành hàng hoá, đem lại lợi nhuận (về cái không phải là hàng hoá): thương mại hoá một ý tưởng",
    example: "thương mại hoá một ý tưởng",
  },
  {
    word: "thượng lưu",
    part_of_speech: "danh từ",
    meaning:
      "đoạn sông ở gần nguồn, thường kể cả vùng phụ cận; phân biệt với trung lưu, hạ lưu: vùng thượng lưu sông Hồng * đi ngược về phía thượng lưu",
    example: "vùng thượng lưu sông Hồng * đi ngược về phía thượng lưu",
  },
  {
    word: "thượng lưu",
    part_of_speech: "danh từ",
    meaning:
      "vùng sông ở phía trên theo hướng dòng chảy, nhìn từ vị trí của cầu hay của một công trình thuỷ lợi.",
    example: "giới thượng lưu",
  },
  {
    word: "thượng nguồn",
    part_of_speech: "danh từ",
    meaning:
      "đoạn đầu nguồn của một con sông hoặc suối; phân biệt với hạ nguồn: nước lũ từ thượng nguồn đổ về",
    example: "nước lũ từ thượng nguồn đổ về",
  },
  {
    word: "thưởng ngoạn",
    part_of_speech: "động từ",
    meaning:
      "(cũ, trang trọng) ngắm xem để thưởng thức (thường nói về vẻ đẹp thiên nhiên): thưởng ngoạn phong cảnh núi non kì thú",
    example: "thưởng ngoạn phong cảnh núi non kì thú",
  },
  {
    word: "thương nhớ",
    part_of_speech: "động từ",
    meaning:
      'nhớ đến, nghĩ đến với tình cảm thương yêu tha thiết, xen lẫn đượm buồn: thương nhớ quê nhà * "Xót thay huyên cỗi, xuân già, Tấm lòng thương nhớ biết là có nguôi?" (TKiều)',
    example:
      'thương nhớ quê nhà * "Xót thay huyên cỗi, xuân già, Tấm lòng thương nhớ biết là có nguôi?" (TKiều)',
  },
  {
    word: "thường nhật",
    part_of_speech: "tính từ",
    meaning: "thường ngày: cuộc sống thường nhật",
    example: "cuộc sống thường nhật",
  },
  {
    word: "thương nhân",
    part_of_speech: "danh từ",
    meaning: "người làm nghề buôn bán: một thương nhân giàu có",
    example: "một thương nhân giàu có",
  },
  {
    word: "thường niên",
    part_of_speech: "tính từ",
    meaning: "hằng năm: liên hoan phim thường niên * hội nghị thường niên",
    example: "liên hoan phim thường niên * hội nghị thường niên",
  },
  {
    word: "thương ôi",
    part_of_speech: "cảm từ",
    meaning:
      '(văn chương) tiếng than biểu lộ sự thương tiếc, xót xa: "Thương ôi! tài sắc mực này, Một dao oan nghiệt, dứt dây phong trần!" (TKiều)',
    example:
      'Thương ôi! tài sắc mực này, Một dao oan nghiệt, dứt dây phong trần!" (TKiều)',
  },
  {
    word: "thường phạm",
    part_of_speech: "danh từ",
    meaning:
      "tù nhân phạm các tội về trật tự an ninh xã hội, như giết người, trộm cướp, buôn lậu, v.v.; phân biệt với chính trị phạm: khu giam giữ thường phạm",
    example: "khu giam giữ thường phạm",
  },
  {
    word: "thưởng phạt",
    part_of_speech: "động từ",
    meaning:
      "khen thưởng người có công và xử phạt người có tội (nói khái quát): thưởng phạt công minh",
    example: "thưởng phạt công minh",
  },
  {
    word: "thương phẩm",
    part_of_speech: "danh từ",
    meaning:
      "sản phẩm hàng hoá được đưa ra mua bán, trao đổi trên thị trường: xuất khẩu hàng trăm tấn gạo thương phẩm",
    example: "xuất khẩu hàng trăm tấn gạo thương phẩm",
  },
  {
    word: "thưởng nóng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) thưởng lập tức ngay sau khi đạt được thành tích, không cần phải đợi bình xét: đội tuyển được thưởng nóng 100 triệu đồng ngay sau trận thắng",
    example: "đội tuyển được thưởng nóng 100 triệu đồng ngay sau trận thắng",
  },
  {
    word: "thượng sách",
    part_of_speech: "danh từ",
    meaning:
      "phương kế coi là hay nhất trong các phương kế; đối lập với hạ sách: trong ba mươi sáu kế, kế chuồn là thượng sách",
    example: "trong ba mươi sáu kế, kế chuồn là thượng sách",
  },
  {
    word: "thượng phong",
    part_of_speech: "tính từ",
    meaning:
      "ở vào thế mạnh hơn, áp đảo đối phương: chiếm thế thượng phong trên sàn đấu",
    example: "chiếm thế thượng phong trên sàn đấu",
  },
  {
    word: "thường phục",
    part_of_speech: "danh từ",
    meaning:
      "quần áo mặc thường ngày, không phải quân phục, lễ phục hay loại y phục đặc biệt nào khác: cảnh sát mặc thường phục",
    example: "cảnh sát mặc thường phục",
  },
  {
    word: "thượng tầng",
    part_of_speech: "danh từ",
    meaning: "tầng trên, lớp trên: thượng tầng khí quyển",
    example: "thượng tầng khí quyển",
  },
  {
    word: "thương tâm",
    part_of_speech: "tính từ",
    meaning:
      'đau lòng, hoặc làm cho đau lòng: cảnh thương tâm * "Lòng đâu sẵn mối thương tâm, Thoắt nghe Kiều đã đầm đầm châu sa." (TKiều)',
    example:
      'cảnh thương tâm * "Lòng đâu sẵn mối thương tâm, Thoắt nghe Kiều đã đầm đầm châu sa." (TKiều)',
  },
  {
    word: "thương thuyết",
    part_of_speech: "động từ",
    meaning: "đàm phán: quá trình thương thuyết diễn ra rất căng thẳng",
    example: "quá trình thương thuyết diễn ra rất căng thẳng",
  },
  {
    word: "thương thảo",
    part_of_speech: "động từ",
    meaning:
      "thảo luận, thương lượng để đi đến thoả thuận: các đối tác thương thảo về hợp đồng xuất khẩu hàng",
    example: "các đối tác thương thảo về hợp đồng xuất khẩu hàng",
  },
  {
    word: "thượng thặng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) được xếp vào loại cao nhất về thứ bậc hoặc về chất lượng: loại rượu thượng thặng * một đầu bếp thượng thặng",
    example: "loại rượu thượng thặng * một đầu bếp thượng thặng",
  },
  {
    word: "thương tật",
    part_of_speech: "danh từ",
    meaning:
      "vết thương đã thành tật trên cơ thể (nói khái quát): bị đánh đến thành thương tật",
    example: "bị đánh đến thành thương tật",
  },
  {
    word: "thương thuyền",
    part_of_speech: "danh từ",
    meaning:
      "tàu thuyền dùng vào việc buôn bán: thương thuyền tấp nập dưới bến cảng",
    example: "thương thuyền tấp nập dưới bến cảng",
  },
  {
    word: "thượng thọ",
    part_of_speech: "danh từ",
    meaning:
      "tuổi thọ cao, khoảng từ bảy mươi đến tám mươi tuổi: làm lễ thượng thọ",
    example: "làm lễ thượng thọ",
  },
  {
    word: "thượng thư",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) chức quan đứng đầu một bộ trong triều đình phong kiến: thượng thư bộ Lại",
    example: "thượng thư bộ Lại",
  },
  {
    word: "thưởng thức",
    part_of_speech: "động từ",
    meaning:
      "nhận biết được và hưởng thụ một cách thích thú: thưởng thức thơ văn * không biết thưởng thức nghệ thuật",
    example: "thưởng thức thơ văn * không biết thưởng thức nghệ thuật",
  },
  {
    word: "thương tích",
    part_of_speech: "danh từ",
    meaning:
      "dấu vết để lại trên thân thể do bị thương: đánh người gây thương tích * thương tích đầy mình",
    example: "đánh người gây thương tích * thương tích đầy mình",
  },
  {
    word: "thương tiếc",
    part_of_speech: "động từ",
    meaning:
      "thương và tiếc (nói khái quát): vô cùng thương tiếc người đã khuất",
    example: "vô cùng thương tiếc người đã khuất",
  },
  {
    word: "thường thức",
    part_of_speech: "danh từ",
    meaning:
      "tri thức phổ thông về một vấn đề, một chuyên ngành nào đó (nói khái quát): khoa học thường thức * tủ sách thường thức về chăn nuôi",
    example: "khoa học thường thức * tủ sách thường thức về chăn nuôi",
  },
  {
    word: "thương tình",
    part_of_speech: "động từ",
    meaning:
      "chạnh lòng thương cảm một cách sâu sắc trước tình cảnh của người nào đó: thấy cảnh côi cút, thương tình nên sẵn lòng giúp đỡ",
    example: "thấy cảnh côi cút, thương tình nên sẵn lòng giúp đỡ",
  },
  {
    word: "thưởng trăng",
    part_of_speech: "động từ",
    meaning:
      "(cũ, văn chương) ngắm trăng để thưởng thức cái đẹp của đêm trăng: thưởng trăng đêm rằm",
    example: "thưởng trăng đêm rằm",
  },
  {
    word: "thường tình",
    part_of_speech: "tính từ",
    meaning:
      'thông thường, bình thường, không có gì là lạ: mẹ bênh con là chuyện thường tình * "Rằng: Tôi chút dạ đàn bà, Ghen tuông thì cũng người ta thường tình." (TKiều)',
    example:
      'mẹ bênh con là chuyện thường tình * "Rằng: Tôi chút dạ đàn bà, Ghen tuông thì cũng người ta thường tình." (TKiều)',
  },
  {
    word: "thường trú",
    part_of_speech: "động từ",
    meaning:
      "cư trú thường xuyên, lâu dài tại một nơi: hộ khẩu thường trú * phóng viên thường trú",
    example: "hộ khẩu thường trú * phóng viên thường trú",
  },
  {
    word: "thượng tuần",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian mười ngày đầu trong tháng; phân biệt với trung tuần, hạ tuần: vụ việc xảy ra vào tuần tháng giêng",
    example: "vụ việc xảy ra vào tuần tháng giêng",
  },
  {
    word: "thương tổn",
    part_of_speech: "",
    meaning: "như tổn thương: gây thương tổn * những thương tổn về tinh thần",
    example: "gây thương tổn * những thương tổn về tinh thần",
  },
  {
    word: "thương trường",
    part_of_speech: "danh từ",
    meaning: "nơi diễn ra hoạt động thương mại: thương trường như chiến trường",
    example: "thương trường như chiến trường",
  },
  {
    word: "thường trực",
    part_of_speech: "động từ",
    meaning:
      "có mặt thường xuyên để kịp thời theo dõi, giải quyết công việc: thường trực suốt đêm bên giường bệnh * uỷ viên thường trực",
    example: "thường trực suốt đêm bên giường bệnh * uỷ viên thường trực",
  },
  {
    word: "thường trực",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) có, tồn tại thường xuyên: nỗi lo thường trực * nụ cười thường trực trên môi",
    example: "nỗi lo thường trực * nụ cười thường trực trên môi",
  },
  {
    word: "thường trực",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) nhân viên phòng thường trực, làm nhiệm vụ xem xét giấy tờ, theo dõi việc ra vào một cơ quan, xí nghiệp: khách đến cơ quan phải liên hệ qua thường trực",
    example: "khách đến cơ quan phải liên hệ qua thường trực",
  },
  {
    word: "thượng vàng hạ cám",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) đủ các thứ, các loại, từ cái quý nhất cho đến cái tầm thường nhất: trong chợ có đủ thượng vàng hạ cám",
    example: "trong chợ có đủ thượng vàng hạ cám",
  },
  {
    word: "thương vụ",
    part_of_speech: "danh từ",
    meaning:
      "công việc liên lạc về kinh tế với nước sở tại: cơ quan thương vụ Việt Nam tại Đức",
    example: "cơ quan thương vụ Việt Nam tại Đức",
  },
  {
    word: "thương vụ",
    part_of_speech: "danh từ",
    meaning:
      "vụ làm ăn buôn bán, thường là lớn: thực hiện thành công nhiều thương vụ",
    example: "thực hiện thành công nhiều thương vụ",
  },
  {
    word: "thượng võ",
    part_of_speech: "động từ",
    meaning: "ham chuộng võ nghệ: một dân tộc thượng võ",
    example: "một dân tộc thượng võ",
  },
  {
    word: "thượng võ",
    part_of_speech: "tính từ",
    meaning: "có khí phách và lòng hào hiệp: tinh thần thượng võ",
    example: "tinh thần thượng võ",
  },
  {
    word: "thượng vị",
    part_of_speech: "danh từ",
    meaning:
      "vùng bụng nằm sát dưới mũi xương ức, tương ứng với phần trên của dạ dày ở phía trong bụng: đau ở vùng thượng vị",
    example: "đau ở vùng thượng vị",
  },
  {
    word: "thường vụ",
    part_of_speech: "danh từ",
    meaning:
      "tập thể những người do ban chấp hành bầu ra để giải quyết công việc hàng ngày của một tổ chức chính trị, xã hội: uỷ ban thường vụ Quốc hội",
    example: "uỷ ban thường vụ Quốc hội",
  },
  {
    word: "thương xót",
    part_of_speech: "động từ",
    meaning:
      "cảm thấy thương, thấy xót xa trước nỗi bất hạnh của người khác: thương xót người bạn mới khuất * bùi ngùi thương xót",
    example: "thương xót người bạn mới khuất * bùi ngùi thương xót",
  },
  {
    word: "thương vong",
    part_of_speech: "",
    meaning:
      "bị thương và bị chết do chiến tranh, tai nạn (nói khái quát): hạn chế thương vong * tiểu đội bị thương vong quá nửa",
    example: "hạn chế thương vong * tiểu đội bị thương vong quá nửa",
  },
  {
    word: "thường xuyên",
    part_of_speech: "tính từ",
    meaning:
      "đều đặn và liên tục, không gián đoạn: gặp nhau thường xuyên * thường xuyên vắng nhà",
    example: "gặp nhau thường xuyên * thường xuyên vắng nhà",
  },
  {
    word: "thướt tha",
    part_of_speech: "tính từ",
    meaning:
      'có dáng cao rủ dài xuống và chuyển động một cách mềm mại, nhẹ nhàng, uyển chuyển: váy áo thướt tha * "Dưới dòng nước chảy trong veo, Bên cầu tơ liễu bóng chiều thướt tha." (TKiều)',
    example:
      'váy áo thướt tha * "Dưới dòng nước chảy trong veo, Bên cầu tơ liễu bóng chiều thướt tha." (TKiều)',
  },
  {
    word: "tì",
    part_of_speech: "danh từ",
    meaning: "lá lách, theo cách gọi trong đông y: thuốc bổ tì",
    example: "thuốc bổ tì",
  },
  {
    word: "tì",
    part_of_speech: "danh từ",
    meaning:
      "vết xước, vết bẩn trên một vật nào đó, làm cho xấu đi: viên ngọc có tì",
    example: "viên ngọc có tì",
  },
  {
    word: "tì",
    part_of_speech: "động từ",
    meaning:
      "đè mạnh xuống hoặc áp mạnh vào một chỗ tựa chắc chắn, để có được một thế vững: tì cằm vào đầu gối * tì tay xuống mặt bàn",
    example: "tì cằm vào đầu gối * tì tay xuống mặt bàn",
  },
  {
    word: "thượt",
    part_of_speech: "tính từ",
    meaning:
      "thẳng ngay ra, tựa như trải dài hết cỡ: mệt quá, nằm thượt ra giường",
    example: "mệt quá, nằm thượt ra giường",
  },
  {
    word: "ti",
    part_of_speech: "danh từ",
    meaning: "(cũ) sở: ti nông nghiệp * ti giáo dục",
    example: "ti nông nghiệp * ti giáo dục",
  },
  {
    word: "ti",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi chung những chi tiết máy hay dụng cụ có dạng thanh, cần, ống, đòn hình trụ: ti ghi đông xe đạp",
    example: "ti ghi đông xe đạp",
  },
  {
    word: "ti",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, văn chương) sợi tơ, thường dùng để làm dây đàn: tiếng ti, tiếng trúc",
    example: "tiếng ti, tiếng trúc",
  },
  {
    word: "ti",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bú (dùng trong cách nói với trẻ em): cho bé ti * ti một hơi rồi ngủ",
    example: "cho bé ti * ti một hơi rồi ngủ",
  },
  {
    word: "ti",
    part_of_speech: "động từ",
    meaning: "như tí: hạt sạn nhỏ ti",
    example: "hạt sạn nhỏ ti",
  },
  {
    word: "tị",
    part_of_speech: "danh từ",
    meaning:
      "(thường viết Tị, Tỵ) kí hiệu thứ sáu trong địa chi (lấy rắn làm tượng trưng; sau thìn trước ngọ), dùng trong phép đếm thời gian cổ truyền của Trung Quốc và một số nước châu á, trong đó có Việt Nam: giờ Tị (từ 9 giờ sáng đến 11 giờ trưa) * năm Tị * tuổi Tị",
    example: "giờ Tị (từ 9 giờ sáng đến 11 giờ trưa) * năm Tị * tuổi Tị",
  },
  {
    word: "tị",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ, hiếm) như tí: tị nữa là xong * còn có một tị cơm",
    example: "tị nữa là xong * còn có một tị cơm",
  },
  {
    word: "tị",
    part_of_speech: "động từ",
    meaning:
      "tỏ ra không bằng lòng trước cái người khác được hưởng, vì so sánh và cho rằng mình bị thiệt: con chị tị con em * chia đều cho bọn trẻ khỏi tị",
    example: "con chị tị con em * chia đều cho bọn trẻ khỏi tị",
  },
  {
    word: "tí",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) vú (dùng khi nói với trẻ con hoặc theo cách nói của trẻ con): bú tí * bé sờ tí mẹ",
    example: "bú tí * bé sờ tí mẹ",
  },
  {
    word: "tí",
    part_of_speech: "danh từ",
    meaning:
      "(thường viết Tí, Tý) kí hiệu thứ nhất trong địa chi (lấy chuột làm tượng trưng; trước sửu), dùng trong phép đếm thời gian cổ truyền của Trung Quốc và một số nước châu á, trong đó có Việt Nam: tuổi Tí * sinh vào giờ Tí (từ 11 giờ đêm đến 1 giờ sáng)",
    example: "tuổi Tí * sinh vào giờ Tí (từ 11 giờ đêm đến 1 giờ sáng)",
  },
  {
    word: "tí",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) lượng, phần rất nhỏ, rất ít, gần như không đáng kể: cho thêm tí muối * đợi một tí * chẳng có tí hi vọng nào * tí tuổi đầu đã học đòi",
    example:
      "cho thêm tí muối * đợi một tí * chẳng có tí hi vọng nào * tí tuổi đầu đã học đòi",
  },
  {
    word: "tí",
    part_of_speech: "tính từ",
    meaning:
      "quá nhỏ, quá bé, đến mức như khó nhìn thấy: một ngôi sao bé tí * đôi mắt nhỏ tí",
    example: "một ngôi sao bé tí * đôi mắt nhỏ tí",
  },
  {
    word: "thương yêu",
    part_of_speech: "động từ",
    meaning: "như yêu thương: đem lòng thương yêu",
    example: "đem lòng thương yêu",
  },
  {
    word: "tỉ",
    part_of_speech: "danh từ",
    meaning:
      "số đếm, bằng một nghìn triệu: một tỉ đồng * phải tiền tỉ mới mua được",
    example: "một tỉ đồng * phải tiền tỉ mới mua được",
  },
  {
    word: "tí chút",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) như chút ít: còn tí chút nữa là xong",
    example: "còn tí chút nữa là xong",
  },
  {
    word: "tỉ dụ",
    part_of_speech: "danh từ",
    meaning:
      "và đg (cũ, hiếm) ví dụ: dẫn một câu làm tỉ dụ * tỉ dụ nó không có nhà thì sao?",
    example: "dẫn một câu làm tỉ dụ * tỉ dụ nó không có nhà thì sao?",
  },
  {
    word: "tỉ dụ",
    part_of_speech: "danh từ",
    meaning:
      "phép so sánh để làm nổi bật một tính chất nào đó: nói  *  là dùng phép tỉ dụ",
    example: "nói  *  là dùng phép tỉ dụ",
  },
  {
    word: "tỉ giá",
    part_of_speech: "danh từ",
    meaning:
      "quan hệ so sánh các mức giá của các loại hàng hoá khác nhau có liên quan trong sản xuất và tiêu dùng: tỉ giá tiền tệ * tăng tỉ giá đồng dollar",
    example: "tỉ giá tiền tệ * tăng tỉ giá đồng dollar",
  },
  {
    word: "tị hiềm",
    part_of_speech: "động từ",
    meaning:
      "nghi ngờ, không tin nhau, nên tránh mọi sự hợp tác, quan hệ với nhau: quên đi mối tị hiềm giữa hai nhà",
    example: "quên đi mối tị hiềm giữa hai nhà",
  },
  {
    word: "tị hiềm",
    part_of_speech: "động từ",
    meaning:
      "(cũ, hiếm) tránh trước đi, không làm việc gì đó vì sợ dễ bị nghi ngờ, hiểu lầm: sợ bị hiểu lầm nên tị hiềm không hỏi",
    example: "sợ bị hiểu lầm nên tị hiềm không hỏi",
  },
  {
    word: "ti hí",
    part_of_speech: "tính từ",
    meaning: "(mắt) quá nhỏ, không mở to ra được: ti hí mắt lươn",
    example: "ti hí mắt lươn",
  },
  {
    word: "ti hí",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (mắt) hơi khép lại, không nhắm hẳn: nhắm hẳn mắt lại, không được ti hí",
    example: "nhắm hẳn mắt lại, không được ti hí",
  },
  {
    word: "tí đỉnh",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ, hiếm) như chút đỉnh: đóng góp tí đỉnh",
    example: "đóng góp tí đỉnh",
  },
  {
    word: "tỉ lệ",
    part_of_speech: "danh từ",
    meaning:
      "tỉ số giữa các phần của một tổng thể, hay giữa một phần nào đó với tổng thể: tỉ lệ thất nghiệp * tỉ lệ nữ chiếm 2/3 trong tổng số công nhân của nhà máy",
    example:
      "tỉ lệ thất nghiệp * tỉ lệ nữ chiếm 2/3 trong tổng số công nhân của nhà máy",
  },
  {
    word: "tỉ lệ",
    part_of_speech: "danh từ",
    meaning:
      "tỉ số giữa các kích thước của vật trên hình vẽ, ảnh chụp, bản đồ với kích thước thật của nó: bản đồ quy hoạch được vẽ với tỉ lệ 1/500",
    example: "bản đồ quy hoạch được vẽ với tỉ lệ 1/500",
  },
  {
    word: "tỉ lệ",
    part_of_speech: "tính từ",
    meaning:
      "tỉ lệ thuận (nói tắt): chu vi hình tròn tỉ lệ với bán kính của nó",
    example: "chu vi hình tròn tỉ lệ với bán kính của nó",
  },
  {
    word: "tỉ lệ bản đồ",
    part_of_speech: "danh từ",
    meaning:
      "tỉ số cho biết mức độ thu nhỏ của mặt đất lên bản đồ, được biểu thị bằng một phân số mà tử số bằng 1: tỉ lệ bản đồ 1/500.000",
    example: "tỉ lệ bản đồ 1/500.000",
  },
  {
    word: "tí hon",
    part_of_speech: "tính từ",
    meaning:
      "có hình dáng, kích thước nhỏ hơn rất nhiều lần so với bình thường: chú bé tí hon",
    example: "chú bé tí hon",
  },
  {
    word: "tỉ lệ thuận",
    part_of_speech: "tính từ",
    meaning:
      "có quan hệ phụ thuộc lẫn nhau giữa hai đại lượng, sao cho khi đại lượng này tăng giảm bao nhiêu lần thì đại lượng kia cũng tăng giảm bấy nhiêu lần: trong chuyển động đều, quãng đường tỉ lệ thuận với thời gian",
    example: "trong chuyển động đều, quãng đường tỉ lệ thuận với thời gian",
  },
  {
    word: "tỉ mẩn",
    part_of_speech: "tính từ",
    meaning:
      "tỉ mỉ, kiên nhẫn, chú ý từng chi tiết nhỏ nhất: tỉ mẩn tô lại từng nét vẽ",
    example: "tỉ mẩn tô lại từng nét vẽ",
  },
  {
    word: "tỉ mỉ",
    part_of_speech: "tính từ",
    meaning:
      "đầy đủ mọi khía cạnh, kĩ đến từng chi tiết nhỏ: dặn dò tỉ mỉ * kế hoạch đã được tính toán tỉ mỉ",
    example: "dặn dò tỉ mỉ * kế hoạch đã được tính toán tỉ mỉ",
  },
  {
    word: "tỉ như",
    part_of_speech: "",
    meaning:
      '(khẩu ngữ) ví như, ví dụ như: "Trai tơ gặp gái đang xuân, Tỉ như trời hạn nửa chừng gặp mưa." (ca dao)',
    example:
      'Trai tơ gặp gái đang xuân, Tỉ như trời hạn nửa chừng gặp mưa." (ca dao)',
  },
  {
    word: "tị nạnh",
    part_of_speech: "động từ",
    meaning:
      "so sánh hơn thiệt giữa mình với người nào đó, không muốn mình bị thiệt (nói khái quát): tị nạnh nhau từng tí một",
    example: "tị nạnh nhau từng tí một",
  },
  {
    word: "tị nạn",
    part_of_speech: "động từ",
    meaning:
      "lánh đi ở nơi khác để khỏi bị những nguy hiểm đe doạ: dân tị nạn * trại tị nạn",
    example: "dân tị nạn * trại tị nạn",
  },
  {
    word: "tí nhau",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) trẻ con còn nhỏ dại (hàm ý vui đùa hay thân mật): anh chị ấy vừa có một tí nhau",
    example: "anh chị ấy vừa có một tí nhau",
  },
  {
    word: "tỉ phú",
    part_of_speech: "danh từ",
    meaning: "người rất giàu, có bạc tỉ: nhà tỉ phú",
    example: "nhà tỉ phú",
  },
  {
    word: "tỉ suất",
    part_of_speech: "danh từ",
    meaning:
      "tỉ lệ phần trăm so sánh một đại lượng với một đại lượng khác có liên quan để thể hiện mức cao thấp của đại lượng đó: tỉ suất khấu hao * tỉ suất lợi nhuận",
    example: "tỉ suất khấu hao * tỉ suất lợi nhuận",
  },
  {
    word: "tỉ số",
    part_of_speech: "danh từ",
    meaning:
      "thương số các số đo của hai đại lượng cùng loại với cùng một đơn vị đo: tỉ số hai đoạn thẳng * tỉ số chung cuộc là 0 - 0 * thắng với tỉ số sát nút",
    example:
      "tỉ số hai đoạn thẳng * tỉ số chung cuộc là 0 - 0 * thắng với tỉ số sát nút",
  },
  {
    word: "tí tách",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng động nhỏ, gọn, liên tiếp, không đều nhau như tiếng nước rơi xuống từng giọt cách quãng: mưa rơi tí tách * tiếng củi khô cháy nổ tí tách",
    example: "mưa rơi tí tách * tiếng củi khô cháy nổ tí tách",
  },
  {
    word: "tỉ tê",
    part_of_speech: "",
    meaning:
      "nói nhỏ nhẹ và đều đều vừa đủ để cho nhau nghe với giọng thân mật, dễ gây được lòng tin và sự đồng cảm ở người nghe: tỉ tê tâm sự * tiếng côn trùng tỉ tê",
    example: "tỉ tê tâm sự * tiếng côn trùng tỉ tê",
  },
  {
    word: "tí tẹo",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) lượng rất nhỏ, rất ít, như chỉ một tí, một tẹo: thừa tí tẹo cơm * chỉ tí tẹo nữa là xong",
    example: "thừa tí tẹo cơm * chỉ tí tẹo nữa là xong",
  },
  {
    word: "tí tẹo",
    part_of_speech: "tính từ",
    meaning: "rất nhỏ, chỉ có một một tí, một tẹo: mầm cây bé tí tẹo",
    example: "mầm cây bé tí tẹo",
  },
  {
    word: "ti tỉ",
    part_of_speech: "tính từ",
    meaning: "như tỉ ti: đứa bé khóc ti tỉ",
    example: "đứa bé khóc ti tỉ",
  },
  {
    word: "ti tỉ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có rất nhiều, đến mức như không thể đếm xuể: trên trời có ti tỉ ngôi sao * cái đó ngoài chợ thì ti tỉ",
    example: "trên trời có ti tỉ ngôi sao * cái đó ngoài chợ thì ti tỉ",
  },
  {
    word: "tì thiếp",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) nàng hầu: "Thuý hoàn riêng được hẳn hoi, Đổi hình tì thiếp thay ngôi phi tần." (NĐM)',
    example:
      'Thuý hoàn riêng được hẳn hoi, Đổi hình tì thiếp thay ngôi phi tần." (NĐM)',
  },
  {
    word: "tỉ thí",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) thi đấu về võ nghệ hay tài trí một cách không khoan nhượng: các thí sinh đang tỉ thí trên võ đài",
    example: "các thí sinh đang tỉ thí trên võ đài",
  },
  {
    word: "tí ti",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) lượng hết sức nhỏ, hết sức ít: thêm một tí ti nữa * chẳng có tí ti kinh nghiệm",
    example: "thêm một tí ti nữa * chẳng có tí ti kinh nghiệm",
  },
  {
    word: "tí ti",
    part_of_speech: "tính từ",
    meaning:
      'hết sức nhỏ bé, không đáng kể gì: "Thương thay lũ kiến tí ti, Kiếm ăn được mấy phải đi tìm mồi." (ca dao)',
    example:
      'Thương thay lũ kiến tí ti, Kiếm ăn được mấy phải đi tìm mồi." (ca dao)',
  },
  {
    word: "tí tị",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) như tí ti: tí tị nữa là xong * hết sạch, chẳng còn tí tị nào",
    example: "tí tị nữa là xong * hết sạch, chẳng còn tí tị nào",
  },
  {
    word: "tỉ ti",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả tiếng khóc nhỏ, kéo dài mãi không dứt, gây cảm giác buồn thương: khóc tỉ ti",
    example: "khóc tỉ ti",
  },
  {
    word: "ti tiện",
    part_of_speech: "tính từ",
    meaning: "nhỏ nhen, hèn hạ: hành động ti tiện * tâm địa ti tiện",
    example: "hành động ti tiện * tâm địa ti tiện",
  },
  {
    word: "ti toe",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) có những cử chỉ, hành động muốn chứng tỏ khả năng của mình với vẻ đáng ghét: ti toe học đòi * chưa chi đã ti toe!",
    example: "ti toe học đòi * chưa chi đã ti toe!",
  },
  {
    word: "tì tì",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) (dáng vẻ ăn, uống, ngủ) liên tục, không chịu thôi, không biết gì đến xung quanh: uống rượu tì tì * thức ăn ngon, ngồi chén tì tì",
    example: "uống rượu tì tì * thức ăn ngon, ngồi chén tì tì",
  },
  {
    word: "tí toét",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) cười nói luôn miệng (thường hàm ý chê): hơi một tí là tí toét cái miệng",
    example: "hơi một tí là tí toét cái miệng",
  },
  {
    word: "tí tởn",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) vui đùa, cợt nhả một cách không đứng đắn (thường nói về đàn bà, con gái): quen thói tí tởn",
    example: "quen thói tí tởn",
  },
  {
    word: "tí tởn",
    part_of_speech: "tính từ",
    meaning: "(hiếm) tỏ vẻ sung sướng, phấn khởi ra mặt: mặt mũi tí tởn",
    example: "mặt mũi tí tởn",
  },
  {
    word: "tỉ trọng",
    part_of_speech: "danh từ",
    meaning:
      "tỉ số giữa trọng lượng của một thể tích chất nào đó với trọng lượng nước có cùng thể tích.",
    example: "tăng tỉ trọng xuất siêu * hàng nhập khẩu chiếm một tỉ trọng lớn",
  },
  {
    word: "tì vết",
    part_of_speech: "danh từ",
    meaning:
      "vết bẩn, vết xấu làm mất đi sự hoàn mĩ của vật một cách đáng tiếc (nói khái quát): cốc pha lê có tì vết",
    example: "cốc pha lê có tì vết",
  },
  {
    word: "ti vi",
    part_of_speech: "danh từ",
    meaning:
      "thiết bị điện có màn hình, trên đó có thể xem các chương trình có âm thanh và hình ảnh chuyển động: cái ti vi màu * loại ti vi 21 inch * chương trình ti vi (= phát trên ti vi)",
    example: "cái ti vi màu * loại ti vi 21 inch *",
  },
  {
    word: "tí toáy",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả dáng vẻ của tay luôn luôn cử động, sờ mó, như không lúc nào để yên: tí toáy nghịch súng * không biết thì đừng tí toáy",
    example: "tí toáy nghịch súng * không biết thì đừng tí toáy",
  },
  {
    word: "tia",
    part_of_speech: "danh từ",
    meaning:
      "dòng, khối chất lỏng có dạng như sợi chỉ, như khi được phun mạnh ra qua một lỗ rất nhỏ: tia nước * máu phun ra thành từng tia",
    example: "tia nước * máu phun ra thành từng tia",
  },
  {
    word: "tia",
    part_of_speech: "danh từ",
    meaning:
      "luồng ánh sáng nhỏ, sóng điện từ truyền theo một hướng nào đó: tia nắng * tia chớp * không còn tia hi vọng nào (b)",
    example: "tia nắng * tia chớp * không còn tia hi vọng nào (b)",
  },
  {
    word: "tia",
    part_of_speech: "động từ",
    meaning:
      "chiếu, rọi tia bức xạ vào cơ thể hoặc bộ phận cơ thể để chữa bệnh.",
    example: "tia được một nhành lan đẹp * tia cô bé hàng xóm",
  },
  {
    word: "tì vị",
    part_of_speech: "danh từ",
    meaning: "lá lách và dạ dày, theo cách gọi trong đông y: tì vị yếu",
    example: "tì vị yếu",
  },
  {
    word: "tí xíu",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ, hiếm) như chút xíu: chờ tí xíu nữa thôi * còn có tí xíu gạo",
    example: "chờ tí xíu nữa thôi * còn có tí xíu gạo",
  },
  {
    word: "tí xíu",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) rất nhỏ bé, trông xinh xắn: viên ngọc tí xíu * nụ hoa bé tí xíu * em bé giơ đôi bàn tay tí xíu",
    example:
      "viên ngọc tí xíu * nụ hoa bé tí xíu * em bé giơ đôi bàn tay tí xíu",
  },
  {
    word: "tía",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ) cha (chỉ dùng để xưng gọi): tía và má",
    example: "tía và má",
  },
  {
    word: "tía",
    part_of_speech: "tính từ",
    meaning:
      'có màu tím đỏ tương tự như màu mận chín: say rượu mặt đỏ tía tai * "Đàn bà như hạt mưa sa, Hạt vào gác tía, hạt ra luống cày." (Cdao)',
    example:
      'say rượu mặt đỏ tía tai * "Đàn bà như hạt mưa sa, Hạt vào gác tía, hạt ra luống cày." (Cdao)',
  },
  {
    word: "tỉa",
    part_of_speech: "động từ",
    meaning:
      "nhổ bớt, cắt bớt đi để cho thưa, cho gọn: tỉa râu * tỉa lông mày * tỉa bớt cành lá",
    example: "tỉa râu * tỉa lông mày * tỉa bớt cành lá",
  },
  {
    word: "tỉa",
    part_of_speech: "động từ",
    meaning:
      "loại đi, bắt hoặc lấy đi từng cá thể trong một số đông: đánh tỉa cá lớn * bắn tỉa từng tên địch",
    example: "đánh tỉa cá lớn * bắn tỉa từng tên địch",
  },
  {
    word: "tỉa",
    part_of_speech: "động từ",
    meaning:
      "sửa chữa lại từng chi tiết chưa đạt trên các hình khối của một tác phẩm mĩ thuật: tỉa lại đường nét của bức tượng",
    example: "tỉa lại đường nét của bức tượng",
  },
  {
    word: "tía lia",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) (nói) lia lịa và không ngớt miệng: cười nói tía lia",
    example: "cười nói tía lia",
  },
  {
    word: "tía lia",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) đỏ tía đều khắp cả: mặt đỏ tía lia",
    example: "mặt đỏ tía lia",
  },
  {
    word: "tia tía",
    part_of_speech: "tính từ",
    meaning:
      'có màu hơi tía: "Trăng mười lăm đã tỏ lại tròn, Củ lang tia tía đã ngon lại bùi." (ca dao)',
    example:
      'Trăng mười lăm đã tỏ lại tròn, Củ lang tia tía đã ngon lại bùi." (ca dao)',
  },
  {
    word: "tỉa tót",
    part_of_speech: "động từ",
    meaning:
      "loại bớt, cắt tỉa và chỉnh sửa từng chi tiết một cách tỉ mỉ, công phu (nói khái quát): cặp lông mày được tỉa tót cẩn thận",
    example: "cặp lông mày được tỉa tót cẩn thận",
  },
  {
    word: "tích",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) ấm tích (nói tắt): hãm một tích chè xanh",
    example: "hãm một tích chè xanh",
  },
  {
    word: "tích",
    part_of_speech: "danh từ",
    meaning: "kết quả của phép nhân: tìm tích của hai số",
    example: "tìm tích của hai số",
  },
  {
    word: "tích",
    part_of_speech: "danh từ",
    meaning:
      "truyện hoặc cốt truyện đời xưa, thường có liên quan tới lịch sử, được dùng làm đề tài cho sáng tác nghệ thuật hoặc dẫn ra trong tác phẩm: tích Lưu Bình Dương Lễ * tích tuồng",
    example: "tích Lưu Bình Dương Lễ * tích tuồng",
  },
  {
    word: "tích",
    part_of_speech: "động từ",
    meaning:
      "dồn, góp từng ít cho thành số lượng đáng kể: công việc tích lại từ mấy tháng nay * tích được một món tiền kha khá",
    example:
      "công việc tích lại từ mấy tháng nay * tích được một món tiền kha khá",
  },
  {
    word: "tích",
    part_of_speech: "động từ",
    meaning:
      "chứa, trữ ở bên trong: vật tích điện * cơ thể tích nước nên phù to",
    example: "vật tích điện * cơ thể tích nước nên phù to",
  },
  {
    word: "tịch dương",
    part_of_speech: "danh từ",
    meaning: "(cũ, văn chương) như tà dương: bóng tịch dương",
    example: "bóng tịch dương",
  },
  {
    word: "tịch",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) chết (nói về bậc tu hành trong đạo Phật): hoà thượng đã tịch",
    example: "hoà thượng đã tịch",
  },
  {
    word: "tịch",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) chết, theo cách dùng thông tục: chuyện mà bại lộ thì tịch cả nút",
    example: "chuyện mà bại lộ thì tịch cả nút",
  },
  {
    word: "tích kê",
    part_of_speech: "danh từ",
    meaning:
      "mảnh bìa hoặc giấy ghi nhận người mang nó được hưởng một quyền lợi nhất định nào đó: phát tích kê cho từng người * lấy tích kê chờ khám bệnh",
    example: "phát tích kê cho từng người * lấy tích kê chờ khám bệnh",
  },
  {
    word: "tịch diệt",
    part_of_speech: "động từ",
    meaning:
      '(hiếm) trừ sạch trần duyên, cắt được mọi ham muốn với đời, theo quan niệm của đạo Phật: "Truyền thày động trống, thỉnh chuông, Niệm kinh tịch diệt, dẫn đường quy y." (TNNL)',
    example:
      'Truyền thày động trống, thỉnh chuông, Niệm kinh tịch diệt, dẫn đường quy y." (TNNL)',
  },
  {
    word: "tịch diệt",
    part_of_speech: "động từ",
    meaning:
      "chết, không còn mối quan hệ gì với đời, theo quan niệm của đạo Phật: Phật Thích Ca đã tịch diệt",
    example: "Phật Thích Ca đã tịch diệt",
  },
  {
    word: "tịch biên",
    part_of_speech: "động từ",
    meaning:
      "(cơ quan nhà nước) lập danh mục và niêm phong tài sản của một người nào đó (thường do phạm tội) để phát mại hoặc tịch thu: bị tịch biên tài sản do tham nhũng",
    example: "bị tịch biên tài sản do tham nhũng",
  },
  {
    word: "tích góp",
    part_of_speech: "động từ",
    meaning:
      "dành dụm, gom góp từng ít một để ngày càng nhiều lên: chịu khó tích góp * tích góp cả đời mới mua được ngôi nhà",
    example: "chịu khó tích góp * tích góp cả đời mới mua được ngôi nhà",
  },
  {
    word: "tích cóp",
    part_of_speech: "động từ",
    meaning:
      "dành dụm, gom góp từng ít một để ngày càng nhiều lên: chịu khó tích góp * tích góp cả đời mới mua được ngôi nhà",
    example: "chịu khó tích góp * tích góp cả đời mới mua được ngôi nhà",
  },
  {
    word: "tích cực",
    part_of_speech: "tính từ",
    meaning:
      "có tác dụng khẳng định, thúc đẩy sự phát triển: nhân tố tích cực * mặt tích cực của vấn đề",
    example: "nhân tố tích cực * mặt tích cực của vấn đề",
  },
  {
    word: "tích cực",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra chủ động, có những hoạt động tạo ra sự biến đổi theo hướng phát triển: phương pháp phòng bệnh tích cực",
    example: "phương pháp phòng bệnh tích cực",
  },
  {
    word: "tích cực",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra nhiệt tình, đem hết khả năng và tâm trí vào công việc: tích cực học tập * làm việc rất tích cực",
    example: "tích cực học tập * làm việc rất tích cực",
  },
  {
    word: "tịch liêu",
    part_of_speech: "tính từ",
    meaning: "(cũ, văn chương) tịch mịch và hoang vắng: cảnh tịch liêu",
    example: "cảnh tịch liêu",
  },
  {
    word: "tích luỹ",
    part_of_speech: "",
    meaning:
      "góp nhặt dần lại cho nhiều lên, phong phú lên: tích luỹ kiến thức * tài sản tích luỹ từ lâu đời",
    example: "tích luỹ kiến thức * tài sản tích luỹ từ lâu đời",
  },
  {
    word: "tích luỹ",
    part_of_speech: "",
    meaning:
      "dành ra một phần sản phẩm xã hội dưới hình thức tiền tệ hoặc hiện vật để thực hiện tái sản xuất mở rộng: tích luỹ tiền tệ * tích luỹ cho đầu tư sản xuất",
    example: "tích luỹ tiền tệ * tích luỹ cho đầu tư sản xuất",
  },
  {
    word: "tịch mịch",
    part_of_speech: "tính từ",
    meaning:
      "vắng lặng, không có một tiếng động nào: đêm khuya tịch mịch * cảnh chùa tịch mịch",
    example: "đêm khuya tịch mịch * cảnh chùa tịch mịch",
  },
  {
    word: "tích sự",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) việc làm có ích, có kết quả: chẳng được cái tích sự gì!",
    example: "chẳng được cái tích sự gì!",
  },
  {
    word: "tích tắc",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng kêu đều đặn của máy đồng hồ: chuông đồng hồ kêu tích tắc",
    example: "chuông đồng hồ kêu tích tắc",
  },
  {
    word: "tích tắc",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) khoảng thời gian rất ngắn, tựa như chỉ trong một giây: suy nghĩ trong tích tắc * chỉ lơ đãng một tích tắc là hỏng việc",
    example: "suy nghĩ trong tích tắc * chỉ lơ đãng một tích tắc là hỏng việc",
  },
  {
    word: "tích truyện",
    part_of_speech: "danh từ",
    meaning: "truyện, tích cũ (nói khái quát): tóm lược tích truyện",
    example: "tóm lược tích truyện",
  },
  {
    word: "tịch thu",
    part_of_speech: "động từ",
    meaning:
      "(cơ quan nhà nước) tước quyền sở hữu tài sản của một người, thường là do phạm tội, sung làm của công: tịch thu hàng lậu * tịch thu lại ruộng đất",
    example: "tịch thu hàng lậu * tịch thu lại ruộng đất",
  },
  {
    word: "tích tụ",
    part_of_speech: "động từ",
    meaning:
      "dồn lại và dần dần tập trung vào một nơi: chất bẩn tích tụ dưới đáy bể",
    example: "chất bẩn tích tụ dưới đáy bể",
  },
  {
    word: "tiếc",
    part_of_speech: "động từ",
    meaning:
      "cảm thấy day dứt, hụt hẫng trong lòng vì đã mất đi cái gì: tiếc của * tiếc công * tiếc ngẩn tiếc ngơ",
    example: "tiếc của * tiếc công * tiếc ngẩn tiếc ngơ",
  },
  {
    word: "tiếc",
    part_of_speech: "động từ",
    meaning:
      'cảm thấy không muốn rời bỏ, không muốn mất đi: tham công tiếc việc * "Đau lòng tử biệt sinh li, Thân còn chẳng tiếc, tiếc gì đến duyên!" (TKiều)',
    example:
      'tham công tiếc việc * "Đau lòng tử biệt sinh li, Thân còn chẳng tiếc, tiếc gì đến duyên!" (TKiều)',
  },
  {
    word: "tiếc",
    part_of_speech: "động từ",
    meaning:
      "cảm thấy không vui và hối hận vì đã trót làm hoặc không làm việc gì đó: một sai lầm đáng tiếc * rất lấy làm tiếc vì không thể giúp gì được",
    example:
      "một sai lầm đáng tiếc * rất lấy làm tiếc vì không thể giúp gì được",
  },
  {
    word: "tiệc",
    part_of_speech: "danh từ",
    meaning:
      "bữa ăn đặc biệt có nhiều món ngon và có đông người dự, nhân một dịp vui mừng: tiệc sinh nhật * mở tiệc mừng nhà mới",
    example: "tiệc sinh nhật * mở tiệc mừng nhà mới",
  },
  {
    word: "tích trữ",
    part_of_speech: "động từ",
    meaning:
      "góp dần và trữ lại với số lượng lớn để nhằm mục đích nào đó: tích trữ hàng hoá để đầu cơ",
    example: "tích trữ hàng hoá để đầu cơ",
  },
  {
    word: "tiếc hùi hụi",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) tiếc lắm: mất cái áo, tiếc hùi hụi",
    example: "mất cái áo, tiếc hùi hụi",
  },
  {
    word: "tiếc rẻ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tiếc vì cảm thấy bỏ hay mất đi như thế là uổng phí: mấy lần định vứt đi nhưng tiếc rẻ lại thôi",
    example: "mấy lần định vứt đi nhưng tiếc rẻ lại thôi",
  },
  {
    word: "tiệc rượu",
    part_of_speech: "danh từ",
    meaning: "tiệc có rượu và các thức nhắm: bày tiệc rượu",
    example: "bày tiệc rượu",
  },
  {
    word: "tiêm",
    part_of_speech: "động từ",
    meaning:
      "đưa thuốc nước vào cơ thể bằng ống bơm qua kim rỗng: tiêm thuốc kháng sinh * đưa trẻ đi tiêm vaccin",
    example: "tiêm thuốc kháng sinh * đưa trẻ đi tiêm vaccin",
  },
  {
    word: "tiệc tùng",
    part_of_speech: "danh từ",
    meaning:
      "việc ăn uống linh đình (nói khái quát; thường hàm ý chê trách): tiệc tùng thâu đêm * suốt ngày ăn uống, tiệc tùng",
    example: "tiệc tùng thâu đêm * suốt ngày ăn uống, tiệc tùng",
  },
  {
    word: "tiếc nuối",
    part_of_speech: "động từ",
    meaning: "như nuối tiếc: tiếc nuối tuổi xuân",
    example: "tiếc nuối tuổi xuân",
  },
  {
    word: "tiệm",
    part_of_speech: "danh từ",
    meaning: "(cũ, hoặc ph) cửa hàng: tiệm may * tiệm kim hoàn * ăn cơm tiệm",
    example: "tiệm may * tiệm kim hoàn * ăn cơm tiệm",
  },
  {
    word: "tiếc thương",
    part_of_speech: "động từ",
    meaning: "như thương tiếc: nỗi tiếc thương * tiếc thương người xấu số",
    example: "nỗi tiếc thương * tiếc thương người xấu số",
  },
  {
    word: "tiệm cận",
    part_of_speech: "động từ",
    meaning: "(hiếm) tiến sát dần đến: nhận thức ngày càng tiệm cận chân lí",
    example: "nhận thức ngày càng tiệm cận chân lí",
  },
  {
    word: "tiềm",
    part_of_speech: "động từ",
    meaning:
      "làm cho thức ăn chín nhừ bằng cách hấp cách thuỷ: chim câu tần * gà tần thuốc bắc",
    example: "chim câu tần * gà tần thuốc bắc",
  },
  {
    word: "tiêm chích",
    part_of_speech: "động từ",
    meaning: "(hiếm) tiêm (nói khái quát): tiêm chích thuốc bổ",
    example: "tiêm chích thuốc bổ",
  },
  {
    word: "tiêm chích",
    part_of_speech: "động từ",
    meaning:
      "tiêm chất ma tuý (nói khái quát): lây nhiễm HIV qua đường tiêm chích",
    example: "lây nhiễm HIV qua đường tiêm chích",
  },
  {
    word: "tiềm ẩn",
    part_of_speech: "tính từ",
    meaning:
      "ngầm ẩn ở bên trong, chưa bộc lộ ra ngoài: khoáng sản tiềm ẩn trong lòng đất * nguy cơ tiềm ẩn",
    example: "khoáng sản tiềm ẩn trong lòng đất * nguy cơ tiềm ẩn",
  },
  {
    word: "tiêm chủng",
    part_of_speech: "động từ",
    meaning:
      "tiêm và chủng để phòng bệnh (nói khái quát): đưa trẻ đi tiêm chủng * tiêm chủng phòng dịch",
    example: "đưa trẻ đi tiêm chủng * tiêm chủng phòng dịch",
  },
  {
    word: "tiềm lực",
    part_of_speech: "danh từ",
    meaning: "sức mạnh tiềm tàng: có tiềm lực kinh tế * tiềm lực tài chính",
    example: "có tiềm lực kinh tế * tiềm lực tài chính",
  },
  {
    word: "tiềm năng",
    part_of_speech: "danh từ",
    meaning:
      "khả năng, năng lực tiềm tàng: có tiềm năng về du lịch * khai thác tiềm năng",
    example: "có tiềm năng về du lịch * khai thác tiềm năng",
  },
  {
    word: "tiêm nhiễm",
    part_of_speech: "động từ",
    meaning: "để cho cái xấu thâm nhập vào và gây tác hại: tiêm nhiễm thói xấu",
    example: "tiêm nhiễm thói xấu",
  },
  {
    word: "tiếm quyền",
    part_of_speech: "động từ",
    meaning:
      "(cũ) (bầy tôi) lấn quyền người bề trên: chúa Trịnh tiếm quyền vua Lê",
    example: "chúa Trịnh tiếm quyền vua Lê",
  },
  {
    word: "tiềm thức",
    part_of_speech: "danh từ",
    meaning:
      "hoạt động tâm lí của con người mà bản thân người ấy không có ý thức: tư tưởng đó đã ăn sâu vào tiềm thức * cảm nhận bằng tiềm thức",
    example: "tư tưởng đó đã ăn sâu vào tiềm thức * cảm nhận bằng tiềm thức",
  },
  {
    word: "tiệm tiến",
    part_of_speech: "động từ",
    meaning:
      "tiến triển dần dần: vận động tiệm tiến từ thấp đến cao * nền kinh tế phát triển một cách tiệm tiến",
    example:
      "vận động tiệm tiến từ thấp đến cao * nền kinh tế phát triển một cách tiệm tiến",
  },
  {
    word: "tiềm tàng",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái ẩn giấu bên trong dưới dạng khả năng, chưa bộc lộ ra, chưa phải là hiện thực: sức mạnh tiềm tàng * phát huy khả năng tiềm tàng",
    example: "sức mạnh tiềm tàng * phát huy khả năng tiềm tàng",
  },
  {
    word: "tiếm vị",
    part_of_speech: "động từ",
    meaning: "(cũ) chiếm đoạt ngôi vua: gian thần tiếm vị",
    example: "gian thần tiếm vị",
  },
  {
    word: "tiên",
    part_of_speech: "danh từ",
    meaning:
      "nhân vật trong truyện thần thoại, đẹp khác thường, có những phép mầu nhiệm và cuộc sống rất yên vui: nàng tiên * sướng như tiên * cõi tiên",
    example: "nàng tiên * sướng như tiên * cõi tiên",
  },
  {
    word: "tiên",
    part_of_speech: "tính từ",
    meaning: "thuộc về tiên, có phép mầu nhiệm: thuốc tiên * quả đào tiên",
    example: "thuốc tiên * quả đào tiên",
  },
  {
    word: "tiền",
    part_of_speech: "danh từ",
    meaning:
      "vật đúc bằng kim loại hay in bằng giấy do ngân hàng nhà nước phát hành, dùng làm đơn vị tiền tệ (nói khái quát): tiền giấy * tiền xu",
    example: "tiền giấy * tiền xu",
  },
  {
    word: "tiền",
    part_of_speech: "danh từ",
    meaning:
      "khoản tiền cụ thể cho một việc gì: lĩnh tiền nhuận bút * trả tiền viện phí * một tiền gà, ba tiền thóc (tng)",
    example:
      "lĩnh tiền nhuận bút * trả tiền viện phí * một tiền gà, ba tiền thóc (tng)",
  },
  {
    word: "tiền",
    part_of_speech: "tính từ",
    meaning: "ở phía trước; đối lập với hậu: nhà có mặt tiền rộng * cửa tiền",
    example: "nhà có mặt tiền rộng * cửa tiền",
  },
  {
    word: "tiện",
    part_of_speech: "động từ",
    meaning:
      'cắt bao quanh cho đứt hoặc tạo thành mặt xoay, mặt trụ, mặt xoắn ốc: tiện tấm mía * tiện gỗ * "Cau non tiện chũm hạt đào, Trầu têm cánh phượng, rọc dao lưu cầu." (ca dao)',
    example:
      'tiện tấm mía * tiện gỗ * "Cau non tiện chũm hạt đào, Trầu têm cánh phượng, rọc dao lưu cầu." (ca dao)',
  },
  {
    word: "tiện",
    part_of_speech: "tính từ",
    meaning:
      "dễ dàng, thuận lợi cho công việc, không hoặc ít gặp phiền phức, khó khăn, trở ngại: đun bếp ga tiện hơn bếp dầu * có điện thoại để tiện liên lạc",
    example: "đun bếp ga tiện hơn bếp dầu * có điện thoại để tiện liên lạc",
  },
  {
    word: "tiện",
    part_of_speech: "tính từ",
    meaning:
      "phải lẽ, hợp lẽ thông thường, dễ được chấp nhận: việc để lâu e không tiện * chuyện tế nhị, không tiện hỏi",
    example: "việc để lâu e không tiện * chuyện tế nhị, không tiện hỏi",
  },
  {
    word: "tiện",
    part_of_speech: "tính từ",
    meaning:
      "có điều kiện, hoàn cảnh thuận lợi để kết hợp làm luôn việc gì đó: tiện tay làm luôn một thể * tiện đường thì vào thăm",
    example: "tiện tay làm luôn một thể * tiện đường thì vào thăm",
  },
  {
    word: "tiễn",
    part_of_speech: "động từ",
    meaning:
      'đưa đi một đoạn để tỏ tình lưu luyến: tiễn khách * ra ga tiễn bạn * "Tiễn mình đến trước cửa đình, Để ta than thở với mình vài câu." (ca dao)',
    example:
      'tiễn khách * ra ga tiễn bạn * "Tiễn mình đến trước cửa đình, Để ta than thở với mình vài câu." (ca dao)',
  },
  {
    word: "tiến",
    part_of_speech: "động từ",
    meaning:
      "di chuyển thẳng về phía trước: tiến thêm vài bước * lúc tiến lúc lui",
    example: "tiến thêm vài bước * lúc tiến lúc lui",
  },
  {
    word: "tiến",
    part_of_speech: "động từ",
    meaning:
      "phát triển theo hướng đi lên, ngày càng cao hơn: miền núi tiếp kịp miền xuôi * một bước tiến vững chắc",
    example: "miền núi tiếp kịp miền xuôi * một bước tiến vững chắc",
  },
  {
    word: "tiến",
    part_of_speech: "động từ",
    meaning:
      "dâng phẩm vật, lễ vật lên vua hoặc thần thánh: sản vật quý đem tiến vua * vào chùa dâng hương tiến Phật",
    example: "sản vật quý đem tiến vua * vào chùa dâng hương tiến Phật",
  },
  {
    word: "tiến",
    part_of_speech: "động từ",
    meaning: "tiến cử (nói tắt): tiến nhân tài",
    example: "tiến nhân tài",
  },
  {
    word: "tiền án",
    part_of_speech: "danh từ",
    meaning:
      "án về một vụ phạm pháp đã được xử trước đó: có tiền án về tội trộm cắp",
    example: "có tiền án về tội trộm cắp",
  },
  {
    word: "tiến bộ",
    part_of_speech: "danh từ",
    meaning: "sự tiến bộ: có nhiều tiến bộ trong học tập",
    example: "có nhiều tiến bộ trong học tập",
  },
  {
    word: "tiễn biệt",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) tiễn để từ biệt người đi xa: tiễn biệt bạn bè * phút giây tiễn biệt",
    example: "tiễn biệt bạn bè * phút giây tiễn biệt",
  },
  {
    word: "tiền bạc",
    part_of_speech: "danh từ",
    meaning: "tiền để sử dụng, chi tiêu (nói khái quát): tiền bạc rủng rỉnh",
    example: "tiền bạc rủng rỉnh",
  },
  {
    word: "tiền bối",
    part_of_speech: "danh từ",
    meaning:
      "người thuộc lớp trước, thế hệ trước, trong quan hệ với những người lớp sau, gọi là hậu bối (hàm ý kính phục): bậc tiền bối * các nhà văn tiền bối",
    example: "bậc tiền bối * các nhà văn tiền bối",
  },
  {
    word: "tiên cảnh",
    part_of_speech: "danh từ",
    meaning:
      "nơi tiên ở, có cảnh đẹp và cuộc sống sung sướng: Bồng Lai tiên cảnh",
    example: "Bồng Lai tiên cảnh",
  },
  {
    word: "tiên cảm",
    part_of_speech: "",
    meaning:
      "cảm nhận thấy trước (điều thường là không hay, không lành): tiên cảm có chuyện không hay * có những tiên cảm mơ hồ",
    example: "tiên cảm có chuyện không hay * có những tiên cảm mơ hồ",
  },
  {
    word: "tiên chỉ",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người đứng đầu ngôi thứ trong làng thời phong kiến, thường được cử làm chủ các cuộc tế lễ, hương ẩm: giữ ngôi tiên chỉ",
    example: "giữ ngôi tiên chỉ",
  },
  {
    word: "tiền căn hậu kiếp",
    part_of_speech: "",
    meaning:
      'nguyên nhân từ kiếp trước, kiếp sau phải gánh chịu: "Trạng nguyên hỏi rõ cho hay, Tiền căn hậu kiếp sự này làm sao?" (PCCH)',
    example:
      'Trạng nguyên hỏi rõ cho hay, Tiền căn hậu kiếp sự này làm sao?" (PCCH)',
  },
  {
    word: "tiền chiến",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về thời kì trước cách mạng tháng Tám ở Việt Nam: thơ tiền chiến * nhà văn tiền chiến * nhạc tiền chiến",
    example: "thơ tiền chiến * nhà văn tiền chiến * nhạc tiền chiến",
  },
  {
    word: "tiền chẵn",
    part_of_speech: "danh từ",
    meaning:
      "tiền có mệnh giá lớn (nói khái quát); phân biệt với tiền lẻ: chỉ có tiền chẵn, không có tiền lẻ * đổi ra tiền chẵn cho gọn",
    example: "chỉ có tiền chẵn, không có tiền lẻ * đổi ra tiền chẵn cho gọn",
  },
  {
    word: "tiền cảnh",
    part_of_speech: "danh từ",
    meaning:
      "cảnh ở phía trước, gần ống kính hoặc gần mắt người xem nhất: tiền cảnh của đoạn phim là một cánh đồng lúa",
    example: "tiền cảnh của đoạn phim là một cánh đồng lúa",
  },
  {
    word: "tiễn chân",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) như tiễn: tiễn chân con lên đường",
    example: "tiễn chân con lên đường",
  },
  {
    word: "tiến công",
    part_of_speech: "động từ",
    meaning:
      "tiến đánh: tiến công đồn địch * mở đợt tiến công * chặn các mũi tiến công",
    example: "tiến công đồn địch * mở đợt tiến công * chặn các mũi tiến công",
  },
  {
    word: "tiến công",
    part_of_speech: "động từ",
    meaning:
      "hoạt động khắc phục khó khăn với khí thế mạnh mẽ, nhằm đạt mục đích nhất định: tiến công vào nghèo nàn, lạc hậu",
    example: "tiến công vào nghèo nàn, lạc hậu",
  },
  {
    word: "tiền của",
    part_of_speech: "danh từ",
    meaning:
      "tiền bạc và của cải: nhà không thiếu tiền của * đóng góp công sức, tiền của",
    example: "nhà không thiếu tiền của * đóng góp công sức, tiền của",
  },
  {
    word: "tiên cung",
    part_of_speech: "danh từ",
    meaning:
      '(văn chương) cung tiên ở, theo thần thoại: chốn tiên cung * "Phất phơ lơi lả yếm đào, Mắt trần ai biết người nào tiên cung!" (PCCH)',
    example:
      'chốn tiên cung * "Phất phơ lơi lả yếm đào, Mắt trần ai biết người nào tiên cung!" (PCCH)',
  },
  {
    word: "tiền duyên",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương) duyên nợ có với nhau từ kiếp trước, theo quan niệm của đạo Phật: làm lễ cắt tiền duyên",
    example: "làm lễ cắt tiền duyên",
  },
  {
    word: "tiền đạo",
    part_of_speech: "danh từ",
    meaning: "(cũ) đạo quân đi trước mở đường: trực tiếp chỉ huy tiền đạo",
    example: "trực tiếp chỉ huy tiền đạo",
  },
  {
    word: "tiền đạo",
    part_of_speech: "danh từ",
    meaning: "tuyến đầu của một đội bóng: hàng tiền đạo * đá ở vị trí tiền đạo",
    example: "hàng tiền đạo * đá ở vị trí tiền đạo",
  },
  {
    word: "tiền đạo",
    part_of_speech: "danh từ",
    meaning:
      "cầu thủ hoạt động ở vị trí tuyến đầu, có nhiệm vụ chủ yếu là tiến công: đội hình có hai tiền đạo",
    example: "đội hình có hai tiền đạo",
  },
  {
    word: "tiện dân",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người dân nghèo, thuộc tầng lớp thấp nhất trong xã hội thời trước (thường hàm ý bị khinh rẻ): đám tiện dân",
    example: "đám tiện dân",
  },
  {
    word: "tiến cử",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) giới thiệu người có tài năng để được sử dụng: tiến cử người hiền * được tiến cử vào ban chấp hành",
    example: "tiến cử người hiền * được tiến cử vào ban chấp hành",
  },
  {
    word: "tiên đề",
    part_of_speech: "danh từ",
    meaning:
      "mệnh đề được thừa nhận mà không chứng minh, xem như là xuất phát điểm để xây dựng một lí thuyết toán học nào đó: tiên đề Euclide",
    example: "tiên đề Euclide",
  },
  {
    word: "tiên đoán",
    part_of_speech: "động từ",
    meaning:
      "đoán trước (điều sẽ xảy ra): lời tiên đoán * sự việc diễn ra đúng như tiên đoán",
    example: "lời tiên đoán * sự việc diễn ra đúng như tiên đoán",
  },
  {
    word: "tiện dụng",
    part_of_speech: "tính từ",
    meaning: "tiện lợi cho việc sử dụng: dụng cụ này vừa nhẹ lại vừa tiện dụng",
    example: "dụng cụ này vừa nhẹ lại vừa tiện dụng",
  },
  {
    word: "tiền đề",
    part_of_speech: "danh từ",
    meaning:
      "mỗi vế trong hai vế đầu của tam đoạn luận, từ đó rút ra kết luận.",
    example: "tiền đề kinh tế * tạo tiền đề thúc đẩy sự phát triển",
  },
  {
    word: "tiền định",
    part_of_speech: "",
    meaning:
      'đã được tạo hoá định sẵn từ trước, theo quan niệm duy tâm: duyên tiền định * "Mới hay tiền định chẳng lầm, Đã tin điều trước, ắt nhằm điều sau." (TKiều)',
    example:
      'duyên tiền định * "Mới hay tiền định chẳng lầm, Đã tin điều trước, ắt nhằm điều sau." (TKiều)',
  },
  {
    word: "tiền đình",
    part_of_speech: "danh từ",
    meaning:
      "khoang nhỏ ở phần trước một khoang lớn nào đó trong cùng một bộ phận của cơ thể: tiền đình miệng",
    example: "tiền đình miệng",
  },
  {
    word: "tiền đình",
    part_of_speech: "danh từ",
    meaning:
      "khoang nhỏ ở tai trong, nơi có cơ quan cảm thụ sự thăng bằng của cơ thể: rối loạn tiền đình",
    example: "rối loạn tiền đình",
  },
  {
    word: "tiến độ",
    part_of_speech: "danh từ",
    meaning:
      "nhịp độ tiến hành công việc: bảo đảm tiến độ thi công * đẩy nhanh tiến độ sản xuất",
    example: "bảo đảm tiến độ thi công * đẩy nhanh tiến độ sản xuất",
  },
  {
    word: "tiền đồ",
    part_of_speech: "danh từ",
    meaning:
      "con đường tương lai, triển vọng: tiền đồ đất nước * tiền đồ rộng mở",
    example: "tiền đồ đất nước * tiền đồ rộng mở",
  },
  {
    word: "tiền đồn",
    part_of_speech: "danh từ",
    meaning:
      "vị trí ở phía trước nhất, gần đối phương nhất, có nhiệm vụ canh giữ và trực tiếp đương đầu với đối phương: vị trí tiền đồn",
    example: "vị trí tiền đồn",
  },
  {
    word: "tiến hành",
    part_of_speech: "động từ",
    meaning:
      "làm, thực hiện (việc đã định trước): buổi lễ được tiến hành trọng thể * tiến hành điều tra vụ án",
    example: "buổi lễ được tiến hành trọng thể * tiến hành điều tra vụ án",
  },
  {
    word: "tiễn đưa",
    part_of_speech: "động từ",
    meaning: "tiễn (nói khái quát): chén rượu tiễn đưa * buổi tiễn đưa",
    example: "chén rượu tiễn đưa * buổi tiễn đưa",
  },
  {
    word: "tiên giới",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như tiên cảnh: nơi tiên giới",
    example: "nơi tiên giới",
  },
  {
    word: "tiến hoá",
    part_of_speech: "động từ",
    meaning:
      "biến đổi dần theo hướng phát triển đi lên: quá trình vượn tiến hoá thành người * xã hội đang trên đường tiến hoá",
    example:
      "quá trình vượn tiến hoá thành người * xã hội đang trên đường tiến hoá",
  },
  {
    word: "tiền hô hậu ủng",
    part_of_speech: "",
    meaning:
      '(Từ cũ) tả cảnh vua quan đi có đoàn người đi trước dẹp đường, theo sau hộ vệ, uy nghi, rầm rập: "Lên xe phụ tử đề huề, Tiền hô hậu ủng thiên uy lạ nhường!" (TS)',
    example: 'Lên xe phụ tử đề huề, Tiền hô hậu ủng thiên uy lạ nhường!" (TS)',
  },
  {
    word: "tiền lẻ",
    part_of_speech: "danh từ",
    meaning:
      "tiền có mệnh giá nhỏ, dùng cho những khoản chi tiêu lặt vặt hoặc để trả khoản lẻ ngoài số tròn (nói khái quát); phân biệt với tiền chẵn: đổi ít tiền lẻ * không có tiền lẻ, chỉ toàn tiền chẵn",
    example: "đổi ít tiền lẻ * không có tiền lẻ, chỉ toàn tiền chẵn",
  },
  {
    word: "tiền hôn nhân",
    part_of_speech: "tính từ",
    meaning: "thuộc thời kì trước khi kết hôn: giai đoạn tiền hôn nhân",
    example: "giai đoạn tiền hôn nhân",
  },
  {
    word: "tiền khả thi",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất tổng quát các luận điểm về khả năng và điều kiện thực tế cho phép thực hiện được (một dự án): dự án tiền khả thi",
    example: "dự án tiền khả thi",
  },
  {
    word: "tiền kiếp",
    part_of_speech: "danh từ",
    meaning:
      "kiếp trước, theo thuyết luân hồi của đạo Phật: duyên tiền kiếp * nợ tiền kiếp",
    example: "duyên tiền kiếp * nợ tiền kiếp",
  },
  {
    word: "tiện ích",
    part_of_speech: "",
    meaning: "ích lợi và sự tiện dụng, nói chung: phần mềm tiện ích",
    example: "phần mềm tiện ích",
  },
  {
    word: "tiền khởi nghĩa",
    part_of_speech: "tính từ",
    meaning:
      "thuộc thời kì trước cuộc Tổng khởi nghĩa tháng Tám 1945 ở Việt Nam: giai đoạn tiền khởi nghĩa",
    example: "giai đoạn tiền khởi nghĩa",
  },
  {
    word: "tiền lệ",
    part_of_speech: "danh từ",
    meaning:
      "việc xảy ra từ trước, tạo thành cái lệ cho những việc về sau: việc đó đã trở thành tiền lệ * xoá bỏ một tiền lệ xấu",
    example: "việc đó đã trở thành tiền lệ * xoá bỏ một tiền lệ xấu",
  },
  {
    word: "tiên liệu",
    part_of_speech: "động từ",
    meaning:
      "tính trước mọi khả năng để liệu cách ứng phó: mọi việc đã được tiên liệu trước",
    example: "mọi việc đã được tiên liệu trước",
  },
  {
    word: "tiện lợi",
    part_of_speech: "tính từ",
    meaning: "tiện (nói khái quát): giao thông tiện lợi",
    example: "giao thông tiện lợi",
  },
  {
    word: "tiền lương thực tế",
    part_of_speech: "danh từ",
    meaning:
      "tiền lương tính theo số lượng tư liệu sinh hoạt, trên thực tế có thể mua được; phân biệt với tiền lương danh nghĩa: giá sinh hoạt tăng làm tiền lương thực tế bị giảm",
    example: "giá sinh hoạt tăng làm tiền lương thực tế bị giảm",
  },
  {
    word: "tiên lượng",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) đoán trước những diễn biến của sự việc: tiên lượng về tình hình kinh tế trong thời gian tới",
    example: "tiên lượng về tình hình kinh tế trong thời gian tới",
  },
  {
    word: "tiên lượng",
    part_of_speech: "danh từ",
    meaning:
      "dự đoán của thầy thuốc về khả năng diễn biến của một bệnh: bệnh diễn biến phức tạp, có tiên lượng xấu",
    example: "bệnh diễn biến phức tạp, có tiên lượng xấu",
  },
  {
    word: "tiền mãi lộ",
    part_of_speech: "danh từ",
    meaning:
      "tiền phải nộp cho bọn cướp đón đường để chúng cho đi qua (coi như là tiền mua đường): chặn đường đòi tiền mãi lộ",
    example: "chặn đường đòi tiền mãi lộ",
  },
  {
    word: "tiền mặt",
    part_of_speech: "danh từ",
    meaning:
      "tiền giấy hoặc tiền kim loại dùng trực tiếp làm phương tiện mua bán, chi trả trong lưu thông: thanh toán bằng tiền mặt",
    example: "thanh toán bằng tiền mặt",
  },
  {
    word: "tiền nào của nấy",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) của có được thường có giá trị tương ứng với số tiền bỏ ra mua (thường dùng như một lời khuyên hoặc an ủi): tiền nào của ấy, đắt nhưng mà đẹp",
    example: "tiền nào của ấy, đắt nhưng mà đẹp",
  },
  {
    word: "tiền lương",
    part_of_speech: "danh từ",
    meaning:
      "tiền công trả định kì, thường là hằng tháng, cho công nhân, viên chức: lĩnh tiền lương * tiền lương eo hẹp",
    example: "lĩnh tiền lương * tiền lương eo hẹp",
  },
  {
    word: "tiên nga",
    part_of_speech: "danh từ",
    meaning: "(văn chương) nàng tiên: đẹp như tiên nga giáng thế",
    example: "đẹp như tiên nga giáng thế",
  },
  {
    word: "tiền nào của ấy",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) của có được thường có giá trị tương ứng với số tiền bỏ ra mua (thường dùng như một lời khuyên hoặc an ủi): tiền nào của ấy, đắt nhưng mà đẹp",
    example: "tiền nào của ấy, đắt nhưng mà đẹp",
  },
  {
    word: "tiền mất tật mang",
    part_of_speech: "",
    meaning:
      "ví trường hợp mất của, mất công nhưng vẫn không khỏi bệnh, không được việc gì mà thậm chí còn mang thêm hại vào thân: ốm đau mà cúng bái thì chỉ tiền mất tật mang",
    example: "ốm đau mà cúng bái thì chỉ tiền mất tật mang",
  },
  {
    word: "tiền nghìn bạc vạn",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tiền bạc nhiều vô kể (thường hàm ý tuy vậy cũng chẳng có nghĩa gì): tình nghĩa ấy, dẫu có tiền nghìn bạc vạn cũng không mua được",
    example: "tình nghĩa ấy, dẫu có tiền nghìn bạc vạn cũng không mua được",
  },
  {
    word: "tiền nhân",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người thuộc các thế hệ đã qua, trong quan hệ với lớp người đang sống (nói khái quát): nối nghiệp tiền nhân * noi theo bước của tiền nhân",
    example: "nối nghiệp tiền nhân * noi theo bước của tiền nhân",
  },
  {
    word: "tiện nghi",
    part_of_speech: "danh từ",
    meaning:
      "những trang bị, đồ dùng cần thiết cho sinh hoạt hằng ngày được thuận tiện, thoải mái (nói tổng quát): mua sắm tiện nghi sinh hoạt * nhà có đầy đủ tiện nghi",
    example: "mua sắm tiện nghi sinh hoạt * nhà có đầy đủ tiện nghi",
  },
  {
    word: "tiện nghi",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) thích hợp và thuận tiện cho sinh hoạt vật chất hằng ngày: đồ đạc rất tiện nghi * ngôi nhà tiện nghi, sang trọng",
    example: "đồ đạc rất tiện nghi * ngôi nhà tiện nghi, sang trọng",
  },
  {
    word: "tiên nhân",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, hiếm) những người thuộc thế hệ trước trong gia tộc (nói khái quát): nối nghiệp tiên nhân",
    example: "nối nghiệp tiên nhân",
  },
  {
    word: "tiên nhân",
    part_of_speech: "danh từ",
    meaning: "(thông tục) như tiên sư (ng2): tiên nhân nhà mày!",
    example: "tiên nhân nhà mày!",
  },
  {
    word: "tiền nhiệm",
    part_of_speech: "tính từ",
    meaning:
      "đã giữ chức vụ quan trọng nào đó trước đây, nói trong quan hệ với người hoặc tổ chức đương nhiệm: thủ tướng tiền nhiệm * nhận nhiệm vụ thay cho người tiền nhiệm về hưu",
    example:
      "thủ tướng tiền nhiệm * nhận nhiệm vụ thay cho người tiền nhiệm về hưu",
  },
  {
    word: "tiên ông",
    part_of_speech: "danh từ",
    meaning: "(văn chương) ông tiên: vị tiên ông",
    example: "vị tiên ông",
  },
  {
    word: "tiền nong",
    part_of_speech: "danh từ",
    meaning:
      "tiền dùng trong việc vay mượn, buôn bán, chi tiêu (nói khái quát): thu xếp tiền nong * tính toán tiền nong cẩn thận",
    example: "thu xếp tiền nong * tính toán tiền nong cẩn thận",
  },
  {
    word: "tiền phong",
    part_of_speech: "tính từ",
    meaning: "(cũ) như tiên phong (ng2): đi tiền phong * quân tiền phong",
    example: "đi tiền phong * quân tiền phong",
  },
  {
    word: "tiên phong",
    part_of_speech: "tính từ",
    meaning:
      "(đạo quân) ở vị trí đi đầu để ra mặt trận: đội quân tiên phong * chặn mũi tiên phong của địch",
    example: "đội quân tiên phong * chặn mũi tiên phong của địch",
  },
  {
    word: "tiên phong",
    part_of_speech: "tính từ",
    meaning:
      "ở vị trí dẫn đầu, hăng hái, tích cực nhất: đi tiên phong trong việc đổi mới",
    example: "đi tiên phong trong việc đổi mới",
  },
  {
    word: "tiên quyết",
    part_of_speech: "tính từ",
    meaning:
      "cần phải có, phải được giải quyết trước nhất thì mới có thể làm được các việc khác: yếu tố tiên quyết * điều kiện tiên quyết",
    example: "yếu tố tiên quyết * điều kiện tiên quyết",
  },
  {
    word: "tiền phương",
    part_of_speech: "danh từ",
    meaning:
      "vùng đang diễn ra những trận chiến đấu trực tiếp với địch; đối lập với hậu phương: nơi tiền phương * trạm y tế tiền phương",
    example: "nơi tiền phương * trạm y tế tiền phương",
  },
  {
    word: "tiến sĩ",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) học vị của người đỗ khoa thi đình: đỗ tiến sĩ khoa thi năm Mậu Tuất",
    example: "đỗ tiến sĩ khoa thi năm Mậu Tuất",
  },
  {
    word: "tiến sĩ",
    part_of_speech: "danh từ",
    meaning:
      "học vị dưới tiến sĩ khoa học và trên thạc sĩ: tiến sĩ luật học * bảo vệ luận án tiến sĩ",
    example: "tiến sĩ luật học * bảo vệ luận án tiến sĩ",
  },
  {
    word: "tiền sảnh",
    part_of_speech: "danh từ",
    meaning:
      "phòng lớn ở lối vào của một toà nhà lớn, nơi phải đi qua để vào các phòng khác trong toà nhà: gian tiền sảnh",
    example: "gian tiền sảnh",
  },
  {
    word: "tiên quân",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) như tiên đế: "Ngùi ngùi nhớ đức tiên quân, Đôi hàng lệ ngọc mười phân lòng vàng." (TNNL)',
    example:
      'Ngùi ngùi nhớ đức tiên quân, Đôi hàng lệ ngọc mười phân lòng vàng." (TNNL)',
  },
  {
    word: "tiến quân",
    part_of_speech: "động từ",
    meaning:
      "đưa quân đội tiến lên phía trước, hướng về đích: Nguyễn Huệ tiến quân ra Bắc",
    example: "Nguyễn Huệ tiến quân ra Bắc",
  },
  {
    word: "tiên sinh",
    part_of_speech: "danh từ",
    meaning: "(cũ) từ học trò dùng để gọi tôn thầy dạy nho học thời trước.",
    example: "Ức Trai tiên sinh * nhờ tiên sinh chỉ giáo cho",
  },
  {
    word: "tiền tài",
    part_of_speech: "danh từ",
    meaning:
      "tiền (nói khái quát): chạy theo tiền tài, danh vọng * coi trọng tiền tài",
    example: "chạy theo tiền tài, danh vọng * coi trọng tiền tài",
  },
  {
    word: "tiên sư",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) người lập ra một trường phái hoặc bày ra và dạy lại một nghề, trong quan hệ với những người theo trường phái hoặc nghề đó ở các đời sau: tiên sư nghề dệt * "Lầu xanh quen lối xưa nay, Nghề này thì lấy ông này tiên sư." (TKiều)',
    example:
      'tiên sư nghề dệt * "Lầu xanh quen lối xưa nay, Nghề này thì lấy ông này tiên sư." (TKiều)',
  },
  {
    word: "tiên sư",
    part_of_speech: "danh từ",
    meaning:
      "(thông tục) từ dùng làm tiếng chửi: tiên sư chúng nó! * tiên sư nhà mày!",
    example: "tiên sư chúng nó! * tiên sư nhà mày!",
  },
  {
    word: "tiên sư cha",
    part_of_speech: "",
    meaning:
      "(thông tục) như tiên sư (ng2; nhưng ý nhấn mạnh hơn): tiên sư cha chúng nó!",
    example: "tiên sư cha chúng nó!",
  },
  {
    word: "tiền sử",
    part_of_speech: "danh từ",
    meaning:
      "thời kì xa xưa trong lịch sử, trước khi có sử chép: người tiền sử * cuộc sống thời tiền sử",
    example: "người tiền sử * cuộc sống thời tiền sử",
  },
  {
    word: "tiền sử",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ nói chung tình hình sức khoẻ và bệnh tật đã qua của một bệnh nhân: bệnh nhân có tiền sử ho lao",
    example: "bệnh nhân có tiền sử ho lao",
  },
  {
    word: "tiền sử học",
    part_of_speech: "danh từ",
    meaning:
      "khoa học nghiên cứu về thời tiền sử, dựa vào các cứ liệu khảo cổ, truyền thuyết: nhà tiền sử học",
    example: "nhà tiền sử học",
  },
  {
    word: "tiền sự",
    part_of_speech: "danh từ",
    meaning:
      "hành vi phạm pháp (nhưng chưa đến mức bị kết án) đã có trước đó: bị cáo đã có một tiền án và hai tiền sự",
    example: "bị cáo đã có một tiền án và hai tiền sự",
  },
  {
    word: "tiền tệ",
    part_of_speech: "danh từ",
    meaning:
      "vật ngang giá chung dùng để đo lường giá trị hàng hoá, làm phương tiện dùng mua hàng, tích luỹ và thanh toán: phát hành tiền tệ * chính sách tiền tệ * thị trường tiền tệ",
    example: "phát hành tiền tệ * chính sách tiền tệ * thị trường tiền tệ",
  },
  {
    word: "tiện tặn",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) như tằn tiện: ăn tiêu tiện tặn",
    example: "ăn tiêu tiện tặn",
  },
  {
    word: "tiện thiếp",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, trang trọng) từ người phụ nữ dùng để tự xưng một cách khiêm tốn khi nói với người đàn ông: "Trước xe quân tử tạm ngồi, Xin cho tiện thiếp lạy rồi sẽ thưa." (TKiều)',
    example:
      'Trước xe quân tử tạm ngồi, Xin cho tiện thiếp lạy rồi sẽ thưa." (TKiều)',
  },
  {
    word: "tiến thân",
    part_of_speech: "động từ",
    meaning:
      "làm cho mình có được địa vị nào đó trong xã hội (thường hàm ý chê): đường tiến thân * tiến thân bằng con đường học vấn",
    example: "đường tiến thân * tiến thân bằng con đường học vấn",
  },
  {
    word: "tiện thể",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) nhân có được dịp thuận tiện (nên kết hợp làm luôn việc gì đó): đi qua tiện thể ghé vào",
    example: "đi qua tiện thể ghé vào",
  },
  {
    word: "tiền thân",
    part_of_speech: "danh từ",
    meaning:
      "bản thân mình ở kiếp trước, trong quan hệ với thể xác kiếp sau (gọi là hậu thân), theo thuyết luân hồi của đạo Phật: kiếp tiền thân",
    example: "kiếp tiền thân",
  },
  {
    word: "tiền thân",
    part_of_speech: "danh từ",
    meaning:
      "hình thức tổ chức ban đầu, trong quan hệ với hình thức tổ chức phát triển về sau (gọi là hậu thân): tổ chức tiền thân",
    example: "tổ chức tiền thân",
  },
  {
    word: "tiên tiến",
    part_of_speech: "tính từ",
    meaning:
      "ở vị trí hàng đầu, vượt hẳn trình độ phát triển chung: công nghệ tiên tiến * nền sản xuất tiên tiến * tư tưởng rất tiên tiến",
    example:
      "công nghệ tiên tiến * nền sản xuất tiên tiến * tư tưởng rất tiên tiến",
  },
  {
    word: "tiên tiến",
    part_of_speech: "tính từ",
    meaning:
      "(người, đơn vị) đạt thành tích cao, có tác dụng lôi cuốn, thúc đẩy: học sinh tiên tiến * hợp tác xã tiên tiến",
    example: "học sinh tiên tiến * hợp tác xã tiên tiến",
  },
  {
    word: "tiến thoái",
    part_of_speech: "động từ",
    meaning: "tiến và lui (nói khái quát): lâm vào thế khó bề tiến thoái",
    example: "lâm vào thế khó bề tiến thoái",
  },
  {
    word: "tiền trạm",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận nhỏ được phái đến trước để chuẩn bị điều kiện sinh hoạt, làm việc cho bộ phận lớn đến sau: đơn vị tiền trạm",
    example: "đơn vị tiền trạm",
  },
  {
    word: "tiền trạm",
    part_of_speech: "động từ",
    meaning:
      "đến trước để tìm hiểu, chuẩn bị điều kiện cho người hoặc đơn vị đến sau: đi tiền trạm * đơn vị được giao nhiệm vụ tiền trạm cho binh đoàn",
    example: "đi tiền trạm * đơn vị được giao nhiệm vụ tiền trạm cho binh đoàn",
  },
  {
    word: "tiến thủ",
    part_of_speech: "động từ",
    meaning:
      "vươn lên không ngừng để ngày một tiến bộ: có chí tiến thủ * con đường tiến thủ",
    example: "có chí tiến thủ * con đường tiến thủ",
  },
  {
    word: "tiền tiêu",
    part_of_speech: "danh từ",
    meaning:
      "nơi canh gác ở phía trước khu vực trú quân, hướng về phía địch: vọng gác tiền tiêu * vị trí tiền tiêu",
    example: "vọng gác tiền tiêu * vị trí tiền tiêu",
  },
  {
    word: "tiền tố",
    part_of_speech: "danh từ",
    meaning:
      "phụ tố đứng trước căn tố, trong một số ngôn ngữ:  trong  *  là một tiền tố trong tiếng Anh",
    example: "trong  *  là một tiền tố trong tiếng Anh",
  },
  {
    word: "tiến trình",
    part_of_speech: "danh từ",
    meaning: "quá trình tiến triển: tiến trình tiến hoá của nhân loại",
    example: "tiến trình tiến hoá của nhân loại",
  },
  {
    word: "tiến trình",
    part_of_speech: "danh từ",
    meaning:
      "quá trình tiến hành: làm chậm tiến trình thi công * tiến trình của hội nghị",
    example: "làm chậm tiến trình thi công * tiến trình của hội nghị",
  },
  {
    word: "tiên tri",
    part_of_speech: "động từ",
    meaning:
      "biết trước được những việc sẽ xảy ra: lời tiên tri * nhà tiên tri",
    example: "lời tiên tri * nhà tiên tri",
  },
  {
    word: "tiên tổ",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như tổ tiên: thờ phụng tiên tổ",
    example: "thờ phụng tiên tổ",
  },
  {
    word: "tiến triển",
    part_of_speech: "động từ",
    meaning:
      "diễn biến và phát triển theo một hướng nào đó, thường là tích cực: bệnh tình có tiến triển * công việc đang tiến triển tốt",
    example: "bệnh tình có tiến triển * công việc đang tiến triển tốt",
  },
  {
    word: "tiền tuyến",
    part_of_speech: "danh từ",
    meaning:
      "tuyến trước, nơi trực tiếp chiến đấu với địch; đối lập với hậu tuyến: ra tiền tuyến * khu vực tiền tuyến",
    example: "ra tiền tuyến * khu vực tiền tuyến",
  },
  {
    word: "tiền túi",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) tiền riêng của cá nhân: móc tiền túi ra trả",
    example: "móc tiền túi ra trả",
  },
  {
    word: "tiền vệ",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) bộ phận đi đầu trong đội hình hành quân, có nhiệm vụ bảo đảm an toàn ở phía trước: đội tiền vệ",
    example: "đội tiền vệ",
  },
  {
    word: "tiền vệ",
    part_of_speech: "danh từ",
    meaning:
      "tuyến giữa của một đội bóng, ngay sau hàng tiền đạo và trước hàng hậu vệ: hàng tiền vệ của đội bạn rất mạnh * chơi ở vị trí tiền vệ",
    example: "hàng tiền vệ của đội bạn rất mạnh * chơi ở vị trí tiền vệ",
  },
  {
    word: "tiền vệ",
    part_of_speech: "danh từ",
    meaning:
      "cầu thủ hoạt động ở vị trí tiền vệ, có nhiệm vụ vừa tiến công vừa phòng thủ: một tiền vệ xuất sắc",
    example: "một tiền vệ xuất sắc",
  },
  {
    word: "tiền vận",
    part_of_speech: "danh từ",
    meaning:
      "số phận con người trong thời kì còn trẻ; phân biệt với hậu vận: tiền vận vất vả",
    example: "tiền vận vất vả",
  },
  {
    word: "tiếng cả nhà không",
    part_of_speech: "",
    meaning:
      'mang tiếng là giàu có, phong lưu, nhưng thật ra là nghèo túng, không có gì: "Ếch rằng: Đồng trắng nước trong, Tôi đây tiếng cả nhà không, có gì." (TC)',
    example:
      'Ếch rằng: Đồng trắng nước trong, Tôi đây tiếng cả nhà không, có gì." (TC)',
  },
  {
    word: "tiếng động",
    part_of_speech: "danh từ",
    meaning:
      "tiếng phát ra do sự va chạm, nói chung: nhà im ắng, không một tiếng động",
    example: "nhà im ắng, không một tiếng động",
  },
  {
    word: "tiếng địa phương",
    part_of_speech: "danh từ",
    meaning:
      "biến thể theo địa phương của một ngôn ngữ: tiếng địa phương miền Nam",
    example: "tiếng địa phương miền Nam",
  },
  {
    word: "tiếng",
    part_of_speech: "danh từ",
    meaning:
      "cái mà tai có thể nghe được: tiếng nước chảy * tiếng chim hót * tiếng cười",
    example: "tiếng nước chảy * tiếng chim hót * tiếng cười",
  },
  {
    word: "tiếng",
    part_of_speech: "danh từ",
    meaning:
      "âm tiết trong tiếng Việt, về mặt là đơn vị thường có nghĩa, dùng trong chuỗi lời nói: câu thơ có 6 tiếng * nói dằn từng tiếng một * sợ quá, nói không thành tiếng",
    example:
      "câu thơ có 6 tiếng * nói dằn từng tiếng một * sợ quá, nói không thành tiếng",
  },
  {
    word: "tiếng",
    part_of_speech: "danh từ",
    meaning: "ngôn ngữ: tiếng Việt * tiếng Hán * thông thạo ba thứ tiếng",
    example: "tiếng Việt * tiếng Hán * thông thạo ba thứ tiếng",
  },
  {
    word: "tiếng",
    part_of_speech: "danh từ",
    meaning:
      "giọng nói riêng của một người hay cách phát âm riêng của một vùng nào đó: bé nhận ra tiếng mẹ * nói tiếng miền Nam * chửi cha không bằng pha tiếng (tng)",
    example:
      "bé nhận ra tiếng mẹ * nói tiếng miền Nam * chửi cha không bằng pha tiếng (tng)",
  },
  {
    word: "tiếng",
    part_of_speech: "danh từ",
    meaning:
      "lời nói của một cá nhân nào đó: im hơi lặng tiếng * nhờ người trên nói giùm cho một tiếng",
    example: "im hơi lặng tiếng * nhờ người trên nói giùm cho một tiếng",
  },
  {
    word: "tiếng",
    part_of_speech: "danh từ",
    meaning:
      "lời bàn tán, khen chê trong xã hội: chịu tiếng thị phi * được tiếng hiếu thảo",
    example: "chịu tiếng thị phi * được tiếng hiếu thảo",
  },
  {
    word: "tiếng",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) khoảng thời gian một giờ đồng hồ: đợi mất hai tiếng * kém 10 phút đầy một tiếng",
    example: "đợi mất hai tiếng * kém 10 phút đầy một tiếng",
  },
  {
    word: "tiếng là",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) gọi là, mang tiếng là... (thì đáng lẽ phải như thế nào đó, nhưng thực tế lại không phải như vậy): tiếng là giỏi nhưng thật ra cũng thường",
    example: "tiếng là giỏi nhưng thật ra cũng thường",
  },
  {
    word: "tiếng tăm",
    part_of_speech: "danh từ",
    meaning:
      "lời nhận định, đánh giá là hay, là tốt, đã được lan truyền rộng trong xã hội: tiếng tăm lừng lẫy * một nhân vật có tiếng tăm",
    example: "tiếng tăm lừng lẫy * một nhân vật có tiếng tăm",
  },
  {
    word: "tiếng lóng",
    part_of_speech: "danh từ",
    meaning:
      "cách nói những từ ngữ riêng trong một tầng lớp hoặc một nhóm người nào đó, nhằm chỉ để cho trong nội bộ hiểu được với nhau mà thôi: nói tiếng lóng với nhau * từ điển tiếng lóng",
    example: "nói tiếng lóng với nhau * từ điển tiếng lóng",
  },
  {
    word: "tiếng thế",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tiếng là như thế (nhưng thực tế lại không hoàn toàn như vậy): ở đây tiếng thế mà làm ăn cũng dễ",
    example: "ở đây tiếng thế mà làm ăn cũng dễ",
  },
  {
    word: "tiếng rằng",
    part_of_speech: "",
    meaning:
      '(khẩu ngữ) như tiếng là: "Thưa hai cụ, tiếng rằng chúng tôi làm quan, nhưng mà nghèo hơn anh Phán nó đấy ạ!" (NgCHoan; 10)',
    example:
      'Thưa hai cụ, tiếng rằng chúng tôi làm quan, nhưng mà nghèo hơn anh Phán nó đấy ạ!" (NgCHoan; 10)',
  },
  {
    word: "tiếng nói",
    part_of_speech: "danh từ",
    meaning:
      "ngôn ngữ, về mặt là công cụ giao tiếp: nghiên cứu tiếng nói và chữ viết * sự khác biệt về màu da và tiếng nói",
    example:
      "nghiên cứu tiếng nói và chữ viết * sự khác biệt về màu da và tiếng nói",
  },
  {
    word: "tiếng nói",
    part_of_speech: "danh từ",
    meaning:
      "ý kiến, quan điểm được phát biểu về một vấn đề cụ thể nào đó (nói tổng quát): biết lắng nghe tiếng nói của người dân",
    example: "biết lắng nghe tiếng nói của người dân",
  },
  {
    word: "tiếng vang",
    part_of_speech: "danh từ",
    meaning:
      "tác động tốt của một việc làm được dư luận rộng rãi chào đón và hoan nghênh: trận Điện Biên Phủ gây được tiếng vang lớn trên thế giới",
    example: "trận Điện Biên Phủ gây được tiếng vang lớn trên thế giới",
  },
  {
    word: "tiếng phổ thông",
    part_of_speech: "danh từ",
    meaning:
      "ngôn ngữ dùng phổ biến trong cả nước, phân biệt với các ngôn ngữ dân tộc thiểu số, ở nước có nhiều dân tộc: học tiếng phổ thông Trung Quốc",
    example: "học tiếng phổ thông Trung Quốc",
  },
  {
    word: "tiêng tiếc",
    part_of_speech: "tính từ",
    meaning: "hơi tiếc: bỏ cơ hội này kể cũng hơi tiêng tiếc",
    example: "bỏ cơ hội này kể cũng hơi tiêng tiếc",
  },
  {
    word: "tiếp cận",
    part_of_speech: "động từ",
    meaning: "tiến sát gần: tiếp cận mục tiêu * tiếp cận sào huyệt địch",
    example: "tiếp cận mục tiêu * tiếp cận sào huyệt địch",
  },
  {
    word: "tiếp cận",
    part_of_speech: "động từ",
    meaning:
      "đến gần để tiếp xúc: tìm cách tiếp cận giám đốc * tiếp cận đối tượng",
    example: "tìm cách tiếp cận giám đốc * tiếp cận đối tượng",
  },
  {
    word: "tiếp cận",
    part_of_speech: "động từ",
    meaning:
      "từng bước, bằng những phương pháp nhất định, tìm hiểu một vấn đề, công việc nào đó: tiếp cận vấn đề * tìm cách tiếp cận với công nghệ mới",
    example: "tiếp cận vấn đề * tìm cách tiếp cận với công nghệ mới",
  },
  {
    word: "tiếp",
    part_of_speech: "động từ",
    meaning:
      "liền theo sau, tạo thành sự liên tục trong thời gian: chuyện nọ tiếp chuyện kia * việc này để mai bàn tiếp * tiếp bước cha anh",
    example:
      "chuyện nọ tiếp chuyện kia * việc này để mai bàn tiếp * tiếp bước cha anh",
  },
  {
    word: "tiếp",
    part_of_speech: "động từ",
    meaning: "(Phương ngữ) ghép: tiếp cành * tiếp cam với bưởi",
    example: "tiếp cành * tiếp cam với bưởi",
  },
  {
    word: "tiếp",
    part_of_speech: "động từ",
    meaning:
      "đưa thêm vào để cho có đủ, bảo đảm hoạt động được liên tục: tiếp nước cho người bệnh * tiếp máu * được tiếp thêm sức mạnh",
    example: "tiếp nước cho người bệnh * tiếp máu * được tiếp thêm sức mạnh",
  },
  {
    word: "tiếp",
    part_of_speech: "động từ",
    meaning:
      "gặp và chuyện trò (với người đến với mình): tiếp khách * phòng tiếp dân",
    example: "tiếp khách * phòng tiếp dân",
  },
  {
    word: "tiếp âm",
    part_of_speech: "động từ",
    meaning:
      "phát chuyển tiếp một chương trình phát thanh đang thu được để truyền đi xa hơn: đài tiếp âm",
    example: "đài tiếp âm",
  },
  {
    word: "tiếng thơm",
    part_of_speech: "danh từ",
    meaning:
      "tiếng tốt được lưu truyền rộng và mãi về sau: tiếng thơm lừng lẫy",
    example: "tiếng thơm lừng lẫy",
  },
  {
    word: "tiếp chuyện",
    part_of_speech: "động từ",
    meaning:
      "nói chuyện để tiếp người nào đó: tiếp chuyện khách * vui vẻ tiếp chuyện",
    example: "tiếp chuyện khách * vui vẻ tiếp chuyện",
  },
  {
    word: "tiếp điểm",
    part_of_speech: "danh từ",
    meaning:
      "điểm tiếp xúc: tiếp điểm của hai hình tròn * tiếp điểm trong công tắc điện bị hở",
    example:
      "tiếp điểm của hai hình tròn * tiếp điểm trong công tắc điện bị hở",
  },
  {
    word: "tiếp đón",
    part_of_speech: "động từ",
    meaning: "(hiếm) như đón tiếp: tiếp đón long trọng",
    example: "tiếp đón long trọng",
  },
  {
    word: "tiếp diễn",
    part_of_speech: "động từ",
    meaning:
      "tiếp tục xảy ra, diễn ra, chưa chấm dứt: công việc tiếp diễn như thường * cuộc chiến còn tiếp diễn",
    example: "công việc tiếp diễn như thường * cuộc chiến còn tiếp diễn",
  },
  {
    word: "tiếp kiến",
    part_of_speech: "động từ",
    meaning: "(trang trọng) gặp mặt và tiếp chuyện: được tiếp kiến thủ tướng",
    example: "được tiếp kiến thủ tướng",
  },
  {
    word: "tiếp giáp",
    part_of_speech: "động từ",
    meaning:
      "sát kề nhau, giáp nhau: vùng tiếp giáp * ngôi nhà tiếp giáp với rừng",
    example: "vùng tiếp giáp * ngôi nhà tiếp giáp với rừng",
  },
  {
    word: "tiếp đãi",
    part_of_speech: "động từ",
    meaning:
      "đón tiếp và mời ăn uống (nói khái quát): tiếp đãi bạn bè * được tiếp đãi rất nồng hậu",
    example: "tiếp đãi bạn bè * được tiếp đãi rất nồng hậu",
  },
  {
    word: "tiếp cứu",
    part_of_speech: "động từ",
    meaning: "cứu nguy: cháy nhà, kêu người tiếp cứu",
    example: "cháy nhà, kêu người tiếp cứu",
  },
  {
    word: "tiếp liệu",
    part_of_speech: "động từ",
    meaning:
      "cung cấp nguyên vật liệu cho nhà máy, xí nghiệp, v.v.: nhân viên tiếp liệu * phòng tiếp liệu",
    example: "nhân viên tiếp liệu * phòng tiếp liệu",
  },
  {
    word: "tiếp quản",
    part_of_speech: "động từ",
    meaning:
      "thu nhận và quản lí cái của đối phương giao lại: tiếp quản nhà máy * tiếp quản thành phố",
    example: "tiếp quản nhà máy * tiếp quản thành phố",
  },
  {
    word: "tiếp nhận",
    part_of_speech: "động từ",
    meaning:
      "đón nhận cái từ người khác, nơi khác chuyển đến: tiếp nhận hồ sơ * tiếp nhận hàng hoá",
    example: "tiếp nhận hồ sơ * tiếp nhận hàng hoá",
  },
  {
    word: "tiếp phẩm",
    part_of_speech: "động từ",
    meaning:
      "cung cấp thực phẩm cho cơ quan, đơn vị, xí nghiệp, v.v.: tiếp phẩm cho trường học",
    example: "tiếp phẩm cho trường học",
  },
  {
    word: "tiếp tay",
    part_of_speech: "động từ",
    meaning:
      "giúp thêm sức vào để công việc, thường là của kẻ xấu, tiến hành thuận lợi hơn: cán bộ hải quan tiếp tay cho bọn buôn lậu",
    example: "cán bộ hải quan tiếp tay cho bọn buôn lậu",
  },
  {
    word: "tiếp nối",
    part_of_speech: "động từ",
    meaning: "(hiếm) như nối tiếp: tiếp nối truyền thống cha ông",
    example: "tiếp nối truyền thống cha ông",
  },
  {
    word: "tiếp theo",
    part_of_speech: "động từ",
    meaning:
      "tiếp liền theo sau: đến lượt người tiếp theo * kế hoạch tiếp theo",
    example: "đến lượt người tiếp theo * kế hoạch tiếp theo",
  },
  {
    word: "tiếp tế",
    part_of_speech: "động từ",
    meaning:
      "chuyển đến để cung cấp lương thực và những thứ cần thiết: tiếp tế lương thực cho vùng bị lũ lụt",
    example: "tiếp tế lương thực cho vùng bị lũ lụt",
  },
  {
    word: "tiếp thị",
    part_of_speech: "động từ",
    meaning: "tiếp cận để chiếm lĩnh thị trường: đẩy mạnh công tác tiếp thị",
    example: "đẩy mạnh công tác tiếp thị",
  },
  {
    word: "tiếp thị",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tìm khách hàng để giới thiệu, quảng cáo, bán hàng: nhân viên tiếp thị * sản phẩm được tiếp thị đến tận nhà",
    example: "nhân viên tiếp thị * sản phẩm được tiếp thị đến tận nhà",
  },
  {
    word: "tiếp tân",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) đón tiếp khách (nói khái quát): ban tiếp tân * nhân viên tiếp tân của khách sạn",
    example: "ban tiếp tân * nhân viên tiếp tân của khách sạn",
  },
  {
    word: "tiếp sức",
    part_of_speech: "động từ",
    meaning: "giúp sức vào làm tăng thêm sức mạnh: đến tiếp sức cho đồng đội",
    example: "đến tiếp sức cho đồng đội",
  },
  {
    word: "tiếp sức",
    part_of_speech: "động từ",
    meaning:
      "làm tiếp vào công việc người khác đang làm: chạy tiếp sức * bơi tiếp sức",
    example: "chạy tiếp sức * bơi tiếp sức",
  },
  {
    word: "tiếp thu",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) nhận về mình cái do người khác để lại, trao lại: tiếp thu chiến lợi phẩm",
    example: "tiếp thu chiến lợi phẩm",
  },
  {
    word: "tiếp thu",
    part_of_speech: "động từ",
    meaning:
      "tiếp nhận và biến thành nhận thức của mình: không tiếp thu ý kiến phê bình * tiếp thu những tư tưởng tiến bộ",
    example: "không tiếp thu ý kiến phê bình * tiếp thu những tư tưởng tiến bộ",
  },
  {
    word: "tiếp ứng",
    part_of_speech: "động từ",
    meaning:
      "tới để giúp thêm sức cho có thể đối phó được với tình hình đang khó khăn (thường là trong chiến đấu): đưa quân đến tiếp ứng",
    example: "đưa quân đến tiếp ứng",
  },
  {
    word: "tiếp vận",
    part_of_speech: "động từ",
    meaning:
      "vận chuyển để tiếp tế phục vụ cho chiến đấu: tiếp vận quân lương * bắn chìm tàu tiếp vận của địch",
    example: "tiếp vận quân lương * bắn chìm tàu tiếp vận của địch",
  },
  {
    word: "tiếp tục",
    part_of_speech: "động từ",
    meaning:
      "giữ sự nối tiếp, sự liên tục trong hoạt động, không ngừng, không thôi: mưa vẫn tiếp tục rơi * trọng tài cho tiếp tục trận đấu",
    example: "mưa vẫn tiếp tục rơi * trọng tài cho tiếp tục trận đấu",
  },
  {
    word: "tiếp xúc",
    part_of_speech: "động từ",
    meaning:
      "chạm vào nhau và gây nên tác dụng: cho hai đầu dây tiếp xúc với nhau",
    example: "cho hai đầu dây tiếp xúc với nhau",
  },
  {
    word: "tiếp xúc",
    part_of_speech: "động từ",
    meaning:
      "thường xuyên có sự đụng chạm hoặc ở gần đến mức có thể trực tiếp chịu tác động không hay nào đó: không được để tay tiếp xúc với hoá chất * bị lây do tiếp xúc với người bệnh",
    example:
      "không được để tay tiếp xúc với hoá chất * bị lây do tiếp xúc với người bệnh",
  },
  {
    word: "tiếp xúc",
    part_of_speech: "động từ",
    meaning:
      "biết và được làm quen với cái gì đó mới mẻ mà trước đó chưa có dịp hoặc chưa từng được biết đến: tiếp xúc với nền văn hoá mới",
    example: "tiếp xúc với nền văn hoá mới",
  },
  {
    word: "tiếp xúc",
    part_of_speech: "động từ",
    meaning: "gặp gỡ để tạo quan hệ: sống khép mình, ít tiếp xúc với mọi người",
    example: "sống khép mình, ít tiếp xúc với mọi người",
  },
  {
    word: "tiếp viện",
    part_of_speech: "động từ",
    meaning:
      "tăng thêm lực lượng để giúp sức cho bộ phận đang chiến đấu: đem quân đến tiếp viện",
    example: "đem quân đến tiếp viện",
  },
  {
    word: "tiếp viên",
    part_of_speech: "danh từ",
    meaning:
      "nhân viên tiếp đón, phục vụ khách trên máy bay hoặc trong các nhà hàng, khách sạn, v.v.: tiếp viên hàng không * làm tiếp viên nhà hàng",
    example: "tiếp viên hàng không * làm tiếp viên nhà hàng",
  },
  {
    word: "tiết",
    part_of_speech: "danh từ",
    meaning:
      "máu của một số loài động vật có xương sống, được dùng làm món ăn: tiết lợn * tiết vịt * cắt tiết gà",
    example: "tiết lợn * tiết vịt * cắt tiết gà",
  },
  {
    word: "tiết",
    part_of_speech: "danh từ",
    meaning:
      "(thông tục) máu của con người, coi là biểu trưng của lòng tức giận sôi sục: điên tiết * nóng tiết",
    example: "điên tiết * nóng tiết",
  },
  {
    word: "tiết",
    part_of_speech: "danh từ",
    meaning:
      "ngày cách nhau nửa tháng trong năm, ứng với một trong hai mươi bốn vị trí của Mặt Trời trên đường hoàng đạo, được đưa vào lịch cổ truyền của Trung Quốc nhằm xác định khí hậu, thời vụ cho phù hợp với điều kiện tự nhiên: tiết xuân phân * tiết thanh minh * tiết đông chí",
    example: "tiết xuân phân * tiết thanh minh * tiết đông chí",
  },
  {
    word: "tiết",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, hiếm) khoảng thời gian giữa hai ngày tiết kề nhau (15-16 ngày), được xem là có đặc điểm khí hậu gần giống nhau.",
    example: "trời đang tiết xuân * tiết trời ấm áp",
  },
  {
    word: "tiết",
    part_of_speech: "danh từ",
    meaning: "phần nhỏ của chương trong tác phẩm: chương đầu có ba tiết",
    example: "chương đầu có ba tiết",
  },
  {
    word: "tiết",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian lên lớp, thường là 45 phút: tiết toán * mỗi buổi có bốn tiết * trống hết tiết",
    example: "tiết toán * mỗi buổi có bốn tiết * trống hết tiết",
  },
  {
    word: "tiết",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) lòng ngay thẳng, trong sạch, giữ trước sau như một: "Phải điều ăn xổi ở thì, Tiết trăm năm, nỡ bỏ đi một ngày!" (TKiều)',
    example:
      'Phải điều ăn xổi ở thì, Tiết trăm năm, nỡ bỏ đi một ngày!" (TKiều)',
  },
  {
    word: "tiết",
    part_of_speech: "động từ",
    meaning:
      "(bộ phận cơ thể) sản sinh chất dịch: tiết nước bọt * tiết mồ hôi * tiết sữa * cây tiết ra nhựa",
    example: "tiết nước bọt * tiết mồ hôi * tiết sữa * cây tiết ra nhựa",
  },
  {
    word: "tiết canh",
    part_of_speech: "danh từ",
    meaning:
      "món ăn làm bằng tiết sống trộn với gan, sụn, v.v. đã được luộc chín băm nhỏ cùng với các loại gia vị, để cho đông lại: tiết canh ngan * đánh tiết canh",
    example: "tiết canh ngan * đánh tiết canh",
  },
  {
    word: "tiết chế",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) hạn chế, kìm giữ, không cho vượt quá mức: tiết chế dục vọng * tiết chế tình cảm",
    example: "tiết chế dục vọng * tiết chế tình cảm",
  },
  {
    word: "tiết diện",
    part_of_speech: "danh từ",
    meaning:
      "hình phẳng có được do cắt một hình khối bằng một mặt phẳng; mặt cắt (thường nói về mặt có một hình hay một độ lớn nào đó): đường ống nước có tiết diện lớn",
    example: "đường ống nước có tiết diện lớn",
  },
  {
    word: "tiệt",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) hết hẳn hoặc làm cho hết hẳn đi: bị tiệt đường sinh đẻ",
    example: "bị tiệt đường sinh đẻ",
  },
  {
    word: "tiệt",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) hoàn toàn, hết tất cả: cấm tiệt * quên tiệt mất",
    example: "cấm tiệt * quên tiệt mất",
  },
  {
    word: "tiết điệu",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như nhịp điệu: bản nhạc có tiết điệu nhịp nhàng",
    example: "bản nhạc có tiết điệu nhịp nhàng",
  },
  {
    word: "tiết kiệm",
    part_of_speech: "động từ",
    meaning:
      "sử dụng đúng mức, không phí phạm sức lực, của cải, thời gian: tiết kiệm điện * tiết kiệm thời gian * thực hành tiết kiệm, chống lãng phí",
    example:
      "tiết kiệm điện * tiết kiệm thời gian * thực hành tiết kiệm, chống lãng phí",
  },
  {
    word: "tiết kiệm",
    part_of_speech: "động từ",
    meaning:
      "dành dụm được do chi tiêu đúng mức: tiền tiết kiệm * tiết kiệm được món tiền kha khá",
    example: "tiền tiết kiệm * tiết kiệm được món tiền kha khá",
  },
  {
    word: "tiết hạnh",
    part_of_speech: "danh từ",
    meaning:
      'lòng chung thuỷ và nết ăn ở của người phụ nữ đối với chồng, theo quan điểm của đạo đức phong kiến: giữ gìn tiết hạnh * "Trai thời trung hiếu làm đầu, Gái thời tiết hạnh là câu trau mình." (LVT)',
    example:
      'giữ gìn tiết hạnh * "Trai thời trung hiếu làm đầu, Gái thời tiết hạnh là câu trau mình." (LVT)',
  },
  {
    word: "tiệt khuẩn",
    part_of_speech: "động từ",
    meaning: "diệt hoàn toàn vi khuẩn gây bệnh: dụng cụ đã được tiệt khuẩn",
    example: "dụng cụ đã được tiệt khuẩn",
  },
  {
    word: "tiết lộ",
    part_of_speech: "động từ",
    meaning:
      "để lộ ra điều đang cần phải giữ bí mật: tiết lộ bí mật * việc quan trọng, không được tiết lộ với ai",
    example: "tiết lộ bí mật * việc quan trọng, không được tiết lộ với ai",
  },
  {
    word: "tiết niệu",
    part_of_speech: "động từ",
    meaning:
      "bài tiết và đào thải nước tiểu ra ngoài: viêm đường tiết niệu * khoa tiết niệu",
    example: "viêm đường tiết niệu * khoa tiết niệu",
  },
  {
    word: "tiết giảm",
    part_of_speech: "động từ",
    meaning:
      "giảm bớt đi một cách có ý thức, có chủ ý: tiết giảm năng lượng * tiết giảm chi phí",
    example: "tiết giảm năng lượng * tiết giảm chi phí",
  },
  {
    word: "tiết liệt",
    part_of_speech: "tính từ",
    meaning:
      "(cũ) kiên trinh, dám chết để giữ trọn lòng trong sạch (thường nói về phụ nữ): người phụ nữ tiết liệt * tấm gương tiết liệt",
    example: "người phụ nữ tiết liệt * tấm gương tiết liệt",
  },
  {
    word: "tiết nghĩa",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) lòng trung thành, thuỷ chung, quyết giữ trọn đạo nghĩa, theo quan niệm đạo đức phong kiến: giữ trọn tiết nghĩa * một người trung hiếu, tiết nghĩa",
    example: "giữ trọn tiết nghĩa * một người trung hiếu, tiết nghĩa",
  },
  {
    word: "tiết tháo",
    part_of_speech: "danh từ",
    meaning:
      "khí tiết vững vàng, không chịu khuất phục: tiết tháo của nhà nho * giữ tiết tháo",
    example: "tiết tháo của nhà nho * giữ tiết tháo",
  },
  {
    word: "tiết tấu",
    part_of_speech: "danh từ",
    meaning: "nhịp điệu của âm nhạc: ca khúc có giai điệu buồn, tiết tấu chậm",
    example: "ca khúc có giai điệu buồn, tiết tấu chậm",
  },
  {
    word: "tiết mục",
    part_of_speech: "danh từ",
    meaning: "từng mục được trình diễn trong một chương trình: tiết mục xiếc",
    example: "tiết mục xiếc",
  },
  {
    word: "tiệt trùng",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) diệt hoàn toàn vi trùng gây bệnh: kim tiêm đã được tiệt trùng",
    example: "kim tiêm đã được tiệt trùng",
  },
  {
    word: "tiệt trừ",
    part_of_speech: "động từ",
    meaning: "trừ sạch tận gốc: tiệt trừ mầm bệnh",
    example: "tiệt trừ mầm bệnh",
  },
  {
    word: "tiễu",
    part_of_speech: "động từ",
    meaning: "(Từ cũ, Ít dùng) dẹp, trừ: tiễu giặc",
    example: "tiễu giặc",
  },
  {
    word: "tiêu",
    part_of_speech: "danh từ",
    meaning: "hồ tiêu (nói tắt): muối tiêu",
    example: "muối tiêu",
  },
  {
    word: "tiêu",
    part_of_speech: "danh từ",
    meaning:
      '(Từ cũ, Văn chương) cây chuối: "Thánh thót tầu tiêu mấy giọt mưa, Bút thần khôn vẽ cảnh tiêu sơ." (HXHương; 3)',
    example:
      'Thánh thót tầu tiêu mấy giọt mưa, Bút thần khôn vẽ cảnh tiêu sơ." (HXHương; 3)',
  },
  {
    word: "tiêu",
    part_of_speech: "danh từ",
    meaning: "vật làm mốc để đánh dấu vị trí, giới hạn: cắm tiêu * cọc tiêu",
    example: "cắm tiêu * cọc tiêu",
  },
  {
    word: "tiêu",
    part_of_speech: "danh từ",
    meaning:
      "nhạc cụ giống như sáo nhưng nhỏ hơn, thổi theo chiều dọc, tiếng trầm: thổi tiêu * ống tiêu",
    example: "thổi tiêu * ống tiêu",
  },
  {
    word: "tiêu",
    part_of_speech: "động từ",
    meaning:
      "dùng tiền vào việc mua sắm: tiền tiêu vặt * số tiền vẫn còn nguyên, chưa tiêu đồng nào",
    example: "tiền tiêu vặt * số tiền vẫn còn nguyên, chưa tiêu đồng nào",
  },
  {
    word: "tiêu",
    part_of_speech: "động từ",
    meaning:
      "(thức ăn) được tiêu hoá trong dạ dày: ăn nhẹ cho dễ tiêu * thức ăn khó tiêu * nghỉ một lúc cho tiêu cơm",
    example:
      "ăn nhẹ cho dễ tiêu * thức ăn khó tiêu * nghỉ một lúc cho tiêu cơm",
  },
  {
    word: "tiêu",
    part_of_speech: "động từ",
    meaning: "thoát nước thừa, nước thải: cống tắc nên nước không tiêu",
    example: "cống tắc nên nước không tiêu",
  },
  {
    word: "tiêu",
    part_of_speech: "động từ",
    meaning:
      "mất hẳn đi hoặc làm cho mất hẳn đi (thường nói về cái có hại): cái nhọt đã tiêu * hát cho tiêu sầu * tí nữa thì tiêu mạng!",
    example: "cái nhọt đã tiêu * hát cho tiêu sầu * tí nữa thì tiêu mạng!",
  },
  {
    word: "tiêu",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) ỉa (lối nói lịch sự): đi tiêu",
    example: "đi tiêu",
  },
  {
    word: "tiêu chảy",
    part_of_speech: "",
    meaning: "(bệnh) đi ngoài ra phân lỏng: bị tiêu chảy * thuốc trị tiêu chảy",
    example: "bị tiêu chảy * thuốc trị tiêu chảy",
  },
  {
    word: "tiểu ban",
    part_of_speech: "danh từ",
    meaning:
      "tập thể gồm một số ít người được cử ra để chuyên nghiên cứu, theo dõi một vấn đề: tiểu ban văn nghệ * thành lập một tiểu ban điều tra",
    example: "tiểu ban văn nghệ * thành lập một tiểu ban điều tra",
  },
  {
    word: "tiêu âm",
    part_of_speech: "động từ",
    meaning: "làm giảm hoặc làm mất tiếng ồn: bộ phận tiêu âm của ô tô",
    example: "bộ phận tiêu âm của ô tô",
  },
  {
    word: "tiêu biểu",
    part_of_speech: "",
    meaning:
      "là hình ảnh cụ thể qua đó có thể thấy được đặc trưng rõ nét nhất của một cái gì có tính chất trừu tượng hơn, bao quát hơn, chung hơn (thường nói về cái tốt đẹp): học sinh tiêu biểu * bài thơ tiêu biểu cho dòng thơ lãng mạn",
    example: "học sinh tiêu biểu * bài thơ tiêu biểu cho dòng thơ lãng mạn",
  },
  {
    word: "tiêu bản",
    part_of_speech: "danh từ",
    meaning:
      "mẫu vật còn bảo tồn nguyên dạng dùng để nghiên cứu: tiêu bản khoáng sản",
    example: "tiêu bản khoáng sản",
  },
  {
    word: "tiểu",
    part_of_speech: "danh từ",
    meaning:
      "người mới xuất gia tu đạo Phật, đang trong giai đoạn thử thách: chú tiểu",
    example: "chú tiểu",
  },
  {
    word: "tiểu",
    part_of_speech: "danh từ",
    meaning:
      "hòm nhỏ bằng sành để đựng xương người chết sau khi bốc mộ: sang tiểu * thay tiểu",
    example: "sang tiểu * thay tiểu",
  },
  {
    word: "tiểu",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) đái (lối nói lịch sự): buồn đi tiểu * thuốc lợi tiểu",
    example: "buồn đi tiểu * thuốc lợi tiểu",
  },
  {
    word: "tiểu",
    part_of_speech: "tính từ",
    meaning: "thuộc loại nhỏ: pin tiểu * cân tiểu * loại gạch tiểu",
    example: "pin tiểu * cân tiểu * loại gạch tiểu",
  },
  {
    word: "tiêu chí",
    part_of_speech: "danh từ",
    meaning:
      "tính chất, dấu hiệu làm căn cứ để nhận biết, xếp loại một sự vật, một khái niệm: tiêu chí đánh giá * tiêu chí phân loại tác phẩm",
    example: "tiêu chí đánh giá * tiêu chí phân loại tác phẩm",
  },
  {
    word: "tiêu chuẩn hoá",
    part_of_speech: "động từ",
    meaning:
      "xây dựng và áp dụng các tiêu chuẩn thống nhất: tiêu chuẩn hoá chất lượng sản phẩm",
    example: "tiêu chuẩn hoá chất lượng sản phẩm",
  },
  {
    word: "tiêu chuẩn",
    part_of_speech: "danh từ",
    meaning:
      "điều quy định làm căn cứ để đánh giá, phân loại: tiêu chuẩn đạo đức * sản phẩm đạt tiêu chuẩn ISO",
    example: "tiêu chuẩn đạo đức * sản phẩm đạt tiêu chuẩn ISO",
  },
  {
    word: "tiêu chuẩn",
    part_of_speech: "danh từ",
    meaning:
      "mức quy định được hưởng, được cung cấp theo chế độ: ăn đủ tiêu chuẩn",
    example: "ăn đủ tiêu chuẩn",
  },
  {
    word: "tiêu chuẩn",
    part_of_speech: "tính từ",
    meaning: "(cũ) chuẩn: cách phát âm tiêu chuẩn",
    example: "cách phát âm tiêu chuẩn",
  },
  {
    word: "tiêu dao",
    part_of_speech: "động từ",
    meaning:
      '(cũ, văn chương) đi chơi đây đó với tâm hồn thảnh thơi, không vướng bận chuyện đời: thú tiêu dao * "Tiêu dao ngày tháng thong dong, Bạn cùng trăng gió, vui cùng nước mây." (TS)',
    example:
      'thú tiêu dao * "Tiêu dao ngày tháng thong dong, Bạn cùng trăng gió, vui cùng nước mây." (TS)',
  },
  {
    word: "tiểu dị",
    part_of_speech: "tính từ",
    meaning: "(hiếm) khác nhau ở chi tiết: đại đồng tiểu dị",
    example: "đại đồng tiểu dị",
  },
  {
    word: "tiêu dùng",
    part_of_speech: "động từ",
    meaning:
      "sử dụng của cải vật chất để thoả mãn các nhu cầu của đời sống sinh hoạt hằng ngày: sản phẩm tiêu dùng * nhu cầu tiêu dùng ngày càng tăng",
    example: "sản phẩm tiêu dùng * nhu cầu tiêu dùng ngày càng tăng",
  },
  {
    word: "tiêu cực",
    part_of_speech: "tính từ",
    meaning:
      "có ý nghĩa, có tác dụng phủ định, làm trở ngại sự phát triển: yếu tố tiêu cực * mặt tiêu cực của vấn đề",
    example: "yếu tố tiêu cực * mặt tiêu cực của vấn đề",
  },
  {
    word: "tiêu cực",
    part_of_speech: "tính từ",
    meaning:
      "chỉ chịu tác động mà không có phản ứng, hoặc phản ứng yếu ớt, không có những hoạt động mang tính chất chủ động: thái độ tiêu cực với thời cuộc * phản ứng tiêu cực",
    example: "thái độ tiêu cực với thời cuộc * phản ứng tiêu cực",
  },
  {
    word: "tiêu cực",
    part_of_speech: "tính từ",
    meaning:
      "không lành mạnh, có tác dụng không tốt đối với quá trình phát triển của xã hội: ngăn ngừa những tệ nạn tiêu cực",
    example: "ngăn ngừa những tệ nạn tiêu cực",
  },
  {
    word: "tiêu cực",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) hiện tượng tiêu cực, không lành mạnh: nảy sinh tiêu cực * đấu tranh chống tiêu cực",
    example: "nảy sinh tiêu cực * đấu tranh chống tiêu cực",
  },
  {
    word: "tiêu diệt",
    part_of_speech: "động từ",
    meaning:
      "làm cho chết hoặc mất hẳn khả năng hoạt động (thường trên phạm vi rộng hoặc với số lượng lớn): tiêu diệt sinh lực địch",
    example: "tiêu diệt sinh lực địch",
  },
  {
    word: "tiêu đề",
    part_of_speech: "danh từ",
    meaning:
      "lời đề ở đầu một tác phẩm, nêu nội dung chủ yếu để gợi sự chú ý: tiêu đề của cuốn sách",
    example: "tiêu đề của cuốn sách",
  },
  {
    word: "tiêu điểm",
    part_of_speech: "danh từ",
    meaning:
      "điểm hội tụ chùm tia hình nón hình thành sau khi khúc xạ hoặc phản xạ các tia song song: tiêu điểm của gương cầu",
    example: "tiêu điểm của gương cầu",
  },
  {
    word: "tiêu điểm",
    part_of_speech: "danh từ",
    meaning:
      "nơi tập trung cao độ các hoạt động khác nhau và từ đó toả ảnh hưởng lớn ra các nơi khác: tiêu điểm của phong trào thi đua",
    example: "tiêu điểm của phong trào thi đua",
  },
  {
    word: "tiêu điều",
    part_of_speech: "tính từ",
    meaning:
      "(quang cảnh) xơ xác, vắng lặng và buồn tẻ, gây cảm giác hoang tàn: nhà cửa tiêu điều * cảnh vật tiêu điều, xơ xác",
    example: "nhà cửa tiêu điều * cảnh vật tiêu điều, xơ xác",
  },
  {
    word: "tiêu điều",
    part_of_speech: "tính từ",
    meaning: "(hiếm) ở tình trạng tàn tạ, suy tàn: nền kinh tế tiêu điều",
    example: "nền kinh tế tiêu điều",
  },
  {
    word: "tiểu đệ",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, trang trọng) từ người đàn ông dùng để tự xưng một cách khiêm nhường, tự coi mình là đàn em, khi nói với người khác: các huynh đi đâu, cho tiểu đệ đi cùng với",
    example: "các huynh đi đâu, cho tiểu đệ đi cùng với",
  },
  {
    word: "tiểu đoàn",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị tổ chức của lực lượng vũ trang, thường gồm ba hoặc bốn đại đội, nằm trong biên chế của trung đoàn hay được tổ chức độc lập: tiểu đoàn 307 * tiểu đoàn pháo binh",
    example: "tiểu đoàn 307 * tiểu đoàn pháo binh",
  },
  {
    word: "tiểu gia súc",
    part_of_speech: "danh từ",
    meaning:
      "súc vật nhỏ nuôi trong nhà như lợn, dê, chó, v.v. (nói tổng quát): chăn nuôi tiểu gia súc",
    example: "chăn nuôi tiểu gia súc",
  },
  {
    word: "tiểu đối",
    part_of_speech: "danh từ",
    meaning:
      "vế đối của một câu thơ, câu văn: câu thơ được chia làm hai vế tiểu đối",
    example: "câu thơ được chia làm hai vế tiểu đối",
  },
  {
    word: "tiểu đường",
    part_of_speech: "danh từ",
    meaning: "đái đường (lối nói kiêng tránh): bị bệnh tiểu đường",
    example: "bị bệnh tiểu đường",
  },
  {
    word: "tiêu hoá",
    part_of_speech: "động từ",
    meaning:
      "(quá trình) biến thức ăn thành chất nuôi dưỡng cơ thể và thải chất bã ra ngoài: tiêu hoá thức ăn * bị rối loạn tiêu hoá * bộ máy tiêu hoá",
    example: "tiêu hoá thức ăn * bị rối loạn tiêu hoá * bộ máy tiêu hoá",
  },
  {
    word: "tiêu hao",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) tin tức: "Nghe tường ngành ngọn tiêu hao, Lòng riêng, chàng luống lao đao thẫn thờ." (TKiều)',
    example:
      'Nghe tường ngành ngọn tiêu hao, Lòng riêng, chàng luống lao đao thẫn thờ." (TKiều)',
  },
  {
    word: "tiêu hao",
    part_of_speech: "động từ",
    meaning:
      "làm cho hao mòn dần, mất dần: tiêu hao năng lượng * làm tiêu hao sinh lực địch",
    example: "tiêu hao năng lượng * làm tiêu hao sinh lực địch",
  },
  {
    word: "tiểu đồng",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) đứa con trai nhỏ theo hầu những người quyền quý thời phong kiến: "Song thân dạy bảo vừa xong, Vân Tiên cùng gã tiểu đồng dời chân." (LVT)',
    example:
      'Song thân dạy bảo vừa xong, Vân Tiên cùng gã tiểu đồng dời chân." (LVT)',
  },
  {
    word: "tiểu hổ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) mèo, về mặt thịt ăn được và ngon: món tiểu hổ * quán tiểu hổ",
    example: "món tiểu hổ * quán tiểu hổ",
  },
  {
    word: "tiêu huỷ",
    part_of_speech: "động từ",
    meaning:
      "huỷ đi cho mất hẳn, cho không còn để lại dấu vết gì: tiêu huỷ chứng cứ * tiêu huỷ tài liệu bí mật * tiêu huỷ gia cầm mắc bệnh",
    example:
      "tiêu huỷ chứng cứ * tiêu huỷ tài liệu bí mật * tiêu huỷ gia cầm mắc bệnh",
  },
  {
    word: "tiểu hùng",
    part_of_speech: "danh từ",
    meaning:
      "chòm sao ở phương Bắc, có hình dáng giống chòm sao Bắc Đẩu nhưng bé và mờ hơn, trong đó có ngôi sao sáng nhất là sao Bắc Cực: chòm sao Tiểu Hùng",
    example: "chòm sao Tiểu Hùng",
  },
  {
    word: "tiểu học",
    part_of_speech: "danh từ",
    meaning:
      "cấp học thấp nhất trong bậc học giáo dục phổ thông, từ lớp một đến lớp năm: phổ cập tiểu học * giáo viên tiểu học",
    example: "phổ cập tiểu học * giáo viên tiểu học",
  },
  {
    word: "tiêu khiển",
    part_of_speech: "động từ",
    meaning:
      "làm cho thoải mái tinh thần bằng những hình thức vui chơi nhẹ nhàng: trò tiêu khiển * thú tiêu khiển",
    example: "trò tiêu khiển * thú tiêu khiển",
  },
  {
    word: "tiếu lâm",
    part_of_speech: "danh từ",
    meaning:
      "chuyện kể dân gian dùng hình thức gây cười để mua vui hoặc để phê phán, đả kích, thường có yếu tố tục: kể chuyện tiếu lâm",
    example: "kể chuyện tiếu lâm",
  },
  {
    word: "tiểu khoa",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) khoa thi nhỏ ở các tỉnh thời phong kiến, người đỗ được nhận bằng tú tài (dưới cử nhân): đỗ tiểu khoa",
    example: "đỗ tiểu khoa",
  },
  {
    word: "tiểu luận",
    part_of_speech: "danh từ",
    meaning:
      "bài nghiên cứu nhỏ bàn về một vấn đề văn học, khoa học, chính trị, xã hội, v.v..",
    example: "hướng dẫn sinh viên viết tiểu luận",
  },
  {
    word: "tiêu ma",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) mất đi một cách vô ích, vô nghĩa, chẳng còn gì nữa: cơ nghiệp bị tiêu ma",
    example: "cơ nghiệp bị tiêu ma",
  },
  {
    word: "tiểu nhân",
    part_of_speech: "danh từ",
    meaning:
      "người có nhân cách tầm thường, theo quan điểm của nho giáo; đối lập với quân tử.",
    example: "bụng dạ tiểu nhân * đồ tiểu nhân!",
  },
  {
    word: "tiêu pha",
    part_of_speech: "động từ",
    meaning:
      "chi tiêu cho các nhu cầu sinh hoạt cá nhân hoặc gia đình (nói khái quát): tiêu pha phung phí",
    example: "tiêu pha phung phí",
  },
  {
    word: "tiểu phẩm",
    part_of_speech: "danh từ",
    meaning: "bài báo ngắn về vấn đề thời sự, có tính chất châm biếm.",
    example: "tiểu phẩm hài",
  },
  {
    word: "tiểu ngạch",
    part_of_speech: "tính từ",
    meaning:
      "(hoạt động xuất nhập khẩu) nhỏ, lẻ, theo con đường buôn bán trực tiếp: hàng hoá nhập khẩu qua đường tiểu ngạch",
    example: "hàng hoá nhập khẩu qua đường tiểu ngạch",
  },
  {
    word: "tiểu nông",
    part_of_speech: "danh từ",
    meaning: "người nông dân làm chủ một ít ruộng đất, tự mình sản xuất lấy.",
    example: "nền kinh tế tiểu nông",
  },
  {
    word: "tiêu phí",
    part_of_speech: "động từ",
    meaning:
      "dùng một cách hoang phí, vô ích: tiêu phí thì giờ * tiêu phí tiền bạc",
    example: "tiêu phí thì giờ * tiêu phí tiền bạc",
  },
  {
    word: "tiễu phỉ",
    part_of_speech: "động từ",
    meaning: "dẹp trừ giặc cướp ở vùng rừng núi: đem quân đi tiễu phỉ",
    example: "đem quân đi tiễu phỉ",
  },
  {
    word: "tiều phu",
    part_of_speech: "danh từ",
    meaning:
      "(Từ cũ) người đàn ông chuyên nghề đốn củi trong rừng: bác tiều phu",
    example: "bác tiều phu",
  },
  {
    word: "tiểu quy mô",
    part_of_speech: "tính từ",
    meaning: "có quy mô nhỏ: công trình tiểu quy mô * dự án tiểu quy mô",
    example: "công trình tiểu quy mô * dự án tiểu quy mô",
  },
  {
    word: "tiêu sơ",
    part_of_speech: "tính từ",
    meaning:
      '(cảnh vật tự nhiên) đơn sơ và tẻ nhạt: "Thánh thót tầu tiêu mấy giọt mưa, Bút thần khôn vẽ cảnh tiêu sơ." (HXHương; 3)',
    example:
      'Thánh thót tầu tiêu mấy giọt mưa, Bút thần khôn vẽ cảnh tiêu sơ." (HXHương; 3)',
  },
  {
    word: "tiểu qui mô",
    part_of_speech: "tính từ",
    meaning: "có quy mô nhỏ: công trình tiểu quy mô * dự án tiểu quy mô",
    example: "công trình tiểu quy mô * dự án tiểu quy mô",
  },
  {
    word: "tiêu phòng",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) cung hoàng hậu nhà Hán ở, vách có trát bột hồ tiêu để cho thơm và ấm áp; sau được dùng để chỉ phòng ngủ của vợ vua chúa thời phong kiến: "Oán chi những khách tiêu phòng, Mà xui phận bạc nằm trong má đào." (CO)',
    example:
      'Oán chi những khách tiêu phòng, Mà xui phận bạc nằm trong má đào." (CO)',
  },
  {
    word: "tiêu tan",
    part_of_speech: "động từ",
    meaning:
      "tan biến đi, mất đi hoàn toàn, không còn tí gì: cơ nghiệp tiêu tan thành mây khói * làm tiêu tan hi vọng",
    example: "cơ nghiệp tiêu tan thành mây khói * làm tiêu tan hi vọng",
  },
  {
    word: "tiểu sử",
    part_of_speech: "danh từ",
    meaning:
      "thân thế và sự nghiệp một người, trình bày một cách tóm tắt: tiểu sử bản thân * bản tóm tắt tiểu sử của các ứng cử viên",
    example: "tiểu sử bản thân * bản tóm tắt tiểu sử của các ứng cử viên",
  },
  {
    word: "tiêu tán",
    part_of_speech: "động từ",
    meaning: "(cũ) như tiêu tan: bao nỗi mệt nhọc đều tiêu tán hết",
    example: "bao nỗi mệt nhọc đều tiêu tán hết",
  },
  {
    word: "tiêu tao",
    part_of_speech: "tính từ",
    meaning:
      '(cũ, văn chương) buồn bã đến não nuột: "Lựa chi những bực tiêu tao?, Dột lòng mình, cũng nao nao lòng người?" (TKiều)',
    example:
      'Lựa chi những bực tiêu tao?, Dột lòng mình, cũng nao nao lòng người?" (TKiều)',
  },
  {
    word: "tiêu thổ",
    part_of_speech: "động từ",
    meaning:
      "phá huỷ nhà cửa, vườn tược, không để cho đối phương có thể sử dụng (một chiến thuật rút lui phòng ngự trong kháng chiến chống xâm lược): chủ trương tiêu thổ kháng chiến",
    example: "chủ trương tiêu thổ kháng chiến",
  },
  {
    word: "tiêu thoát",
    part_of_speech: "động từ",
    meaning:
      "(nước) thoát đi nhanh, không bị ách tắc, ứ đọng: công trình tiêu thoát nước * cống tiêu thoát",
    example: "công trình tiêu thoát nước * cống tiêu thoát",
  },
  {
    word: "tiểu thư",
    part_of_speech: "danh từ",
    meaning: "(Từ cũ) con gái nhà quan, nhà quyền quý thời phong kiến.",
    example: "trông tiểu thư thế kia thì làm ăn gì!",
  },
  {
    word: "tiểu thuyết",
    part_of_speech: "danh từ",
    meaning:
      "truyện dài bằng văn xuôi có dung lượng lớn, với nhiều nhân vật hoạt động trong phạm vi lịch sử, xã hội rộng lớn: tiểu thuyết trinh thám * bộ tiểu thuyết gồm năm tập",
    example: "tiểu thuyết trinh thám * bộ tiểu thuyết gồm năm tập",
  },
  {
    word: "tiểu thương",
    part_of_speech: "danh từ",
    meaning: "người buôn bán nhỏ: tiểu thương tổ chức bãi chợ",
    example: "tiểu thương tổ chức bãi chợ",
  },
  {
    word: "tiêu thức",
    part_of_speech: "danh từ",
    meaning:
      "tiêu chí và cách thức tiến hành một hoạt động nào đó: tiêu thức phân loại sản phẩm * các tiêu thức thống kê",
    example: "tiêu thức phân loại sản phẩm * các tiêu thức thống kê",
  },
  {
    word: "tiêu thụ",
    part_of_speech: "động từ",
    meaning:
      "bán ra được, bán đi được (nói về hàng hoá): tiêu thụ sản phẩm * cấm tiêu thụ tiền giả * hàng kém chất lượng nên tiêu thụ chậm",
    example:
      "tiêu thụ sản phẩm * cấm tiêu thụ tiền giả * hàng kém chất lượng nên tiêu thụ chậm",
  },
  {
    word: "tiêu thụ",
    part_of_speech: "động từ",
    meaning:
      "dùng dần làm hết đi, vào việc gì: tiêu thụ năng lượng * loại máy mới tiêu thụ điện ít",
    example: "tiêu thụ năng lượng * loại máy mới tiêu thụ điện ít",
  },
  {
    word: "tiểu tiện",
    part_of_speech: "động từ",
    meaning: "đái (lối nói lịch sự): đi tiểu tiện * bí tiểu tiện",
    example: "đi tiểu tiện * bí tiểu tiện",
  },
  {
    word: "tiểu tiết",
    part_of_speech: "danh từ",
    meaning:
      "chi tiết nhỏ nhặt, lặt vặt trong nội dung một sự việc lớn, một vấn đề lớn: bàn luận trên tổng thể, không nên sa đà vào tiểu tiết",
    example: "bàn luận trên tổng thể, không nên sa đà vào tiểu tiết",
  },
  {
    word: "tiểu tu",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) sửa chữa nhỏ; phân biệt với trung tu, đại tu: tiểu tu xe máy * ngôi chùa được tiểu tu lại",
    example: "tiểu tu xe máy * ngôi chùa được tiểu tu lại",
  },
  {
    word: "tiểu tinh",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) ngôi sao nhỏ; dùng để chỉ vợ lẽ: "Thà rằng làm tiểu tinh chàng, Còn hơn chính thất những đoàn vũ phu." (ca dao)',
    example:
      'Thà rằng làm tiểu tinh chàng, Còn hơn chính thất những đoàn vũ phu." (ca dao)',
  },
  {
    word: "tiêu tùng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tiêu tan hoàn toàn, không còn tí gì nữa: sự nghiệp tiêu tùng",
    example: "sự nghiệp tiêu tùng",
  },
  {
    word: "tiêu trừ",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) trừ bỏ, làm cho bị tiêu diệt, bị mất hẳn: tiêu trừ nạn mê tín dị đoan * uống thuốc tiêu trừ chất độc",
    example: "tiêu trừ nạn mê tín dị đoan * uống thuốc tiêu trừ chất độc",
  },
  {
    word: "tiều tuỵ",
    part_of_speech: "tính từ",
    meaning:
      "có dáng vẻ tàn tạ, xơ xác đến thảm hại: thân hình tiều tuỵ * quán xá tiều tuỵ, xơ xác",
    example: "thân hình tiều tuỵ * quán xá tiều tuỵ, xơ xác",
  },
  {
    word: "tiễu trừ",
    part_of_speech: "động từ",
    meaning: "(Từ cũ) diệt trừ: tiễu trừ thổ phỉ",
    example: "tiễu trừ thổ phỉ",
  },
  {
    word: "tiểu tư sản",
    part_of_speech: "danh từ",
    meaning:
      "tầng lớp những người sản xuất nhỏ có tư liệu sản xuất riêng và không bóc lột người khác: thành phần tiểu tư sản",
    example: "thành phần tiểu tư sản",
  },
  {
    word: "tiểu tư sản",
    part_of_speech: "tính từ",
    meaning:
      "thuộc tầng lớp tiểu tư sản, có tính chất của tầng lớp tiểu tư sản: tâm lí tiểu tư sản * tư tưởng tiểu tư sản",
    example: "tâm lí tiểu tư sản * tư tưởng tiểu tư sản",
  },
  {
    word: "tiêu vong",
    part_of_speech: "động từ",
    meaning:
      "bị mất đi hẳn sau một quá trình suy tàn dần: chế độ phong kiến tiêu vong",
    example: "chế độ phong kiến tiêu vong",
  },
  {
    word: "tiêu xài",
    part_of_speech: "động từ",
    meaning:
      "như tiêu pha (nhưng thường hàm ý rộng rãi hoặc phung phí quá mức): đủ tiền tiêu xài * tiêu xài phung phí",
    example: "đủ tiền tiêu xài * tiêu xài phung phí",
  },
  {
    word: "tiểu xảo",
    part_of_speech: "",
    meaning:
      "mẹo nhỏ nhưng có tính khéo léo (trong một công việc đòi hỏi phải có tài năng, có sáng tạo): giở ngón tiểu xảo * dùng tiểu xảo",
    example: "giở ngón tiểu xảo * dùng tiểu xảo",
  },
  {
    word: "tiểu vùng",
    part_of_speech: "danh từ",
    meaning:
      "khu vực địa lí nhỏ, có đặc điểm riêng so với các vùng địa lí nhỏ khác: tiểu vùng kinh tế * tiểu vùng khí hậu * tiểu vùng sông Mê Kông",
    example: "tiểu vùng kinh tế * tiểu vùng khí hậu * tiểu vùng sông Mê Kông",
  },
  {
    word: "tím",
    part_of_speech: "tính từ",
    meaning:
      "có màu do xanh và đỏ hợp thành, như màu hoa sim, màu quả cà dái dê, v.v.: áo tím * mực tím * hoa xoan phơn phớt tím",
    example: "áo tím * mực tím * hoa xoan phơn phớt tím",
  },
  {
    word: "tím",
    part_of_speech: "tính từ",
    meaning:
      "(da, thịt) có màu tím thẫm do máu bị dồn ứ đột ngột: ngã tím đầu gối * đôi môi tím ngắt vì lạnh * giận tím mặt",
    example: "ngã tím đầu gối * đôi môi tím ngắt vì lạnh * giận tím mặt",
  },
  {
    word: "tigôn",
    part_of_speech: "danh từ",
    meaning:
      "cây bụi thân leo, cành non có hai ba tua cuốn ở tận cùng, lá hình bầu dục nhọn, hoa thường có màu trắng hoặc hồng nhạt, trồng làm cảnh: giàn hoa tigôn",
    example: "giàn hoa tigôn",
  },
  {
    word: "tìm",
    part_of_speech: "động từ",
    meaning:
      "cố làm sao cho thấy được, cho có được (cái biết là có ở đâu đó): tìm trẻ lạc * tìm việc làm * tìm ra đầu mối * bới lông tìm vết (tng)",
    example:
      "tìm trẻ lạc * tìm việc làm * tìm ra đầu mối * bới lông tìm vết (tng)",
  },
  {
    word: "tìm",
    part_of_speech: "động từ",
    meaning:
      "cố làm sao nghĩ cho ra: tìm nghiệm của phương trình * tìm cách giải quyết",
    example: "tìm nghiệm của phương trình * tìm cách giải quyết",
  },
  {
    word: "tìm hiểu",
    part_of_speech: "động từ",
    meaning:
      "tìm, hỏi, xem xét để biết rõ, hiểu rõ: tìm hiểu tình hình * tìm hiểu nguyên nhân vụ việc",
    example: "tìm hiểu tình hình * tìm hiểu nguyên nhân vụ việc",
  },
  {
    word: "tìm hiểu",
    part_of_speech: "động từ",
    meaning:
      "(nam nữ) trao đổi tâm tình với nhau để hiểu rõ về nhau trước khi yêu nhau và/hoặc kết hôn: hai người đang tìm hiểu nhau",
    example: "hai người đang tìm hiểu nhau",
  },
  {
    word: "tim",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận trung tâm của hệ tuần hoàn, có chức năng điều khiển việc vận chuyển máu trong cơ thể: quả tim * bị đau tim * Hà Nội là trái tim của cả nước (b)",
    example: "quả tim * bị đau tim * Hà Nội là trái tim của cả nước (b)",
  },
  {
    word: "tim",
    part_of_speech: "danh từ",
    meaning:
      "tim của con người, coi là biểu tượng của tình cảm, tình yêu: trái tim nhân hậu * yêu bằng cả trái tim * làm theo tiếng gọi của con tim",
    example:
      "trái tim nhân hậu * yêu bằng cả trái tim * làm theo tiếng gọi của con tim",
  },
  {
    word: "tim",
    part_of_speech: "danh từ",
    meaning: "phần hoặc điểm ở chính giữa của một số vật: đo từ tim đường ra",
    example: "đo từ tim đường ra",
  },
  {
    word: "tim",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ) tâm (sen): tim sen có vị đắng",
    example: "tim sen có vị đắng",
  },
  {
    word: "tim",
    part_of_speech: "danh từ",
    meaning:
      '(Phương ngữ) bấc (đèn): "Ai trồng trúc lộn với tre, Ai đem chỉ gấm mà xe tim đèn." (Cdao)',
    example: 'Ai trồng trúc lộn với tre, Ai đem chỉ gấm mà xe tim đèn." (Cdao)',
  },
  {
    word: "tim đen",
    part_of_speech: "danh từ",
    meaning: "ý nghĩ, ý đồ xấu xa và thầm kín nhất: nói trúng tim đen",
    example: "nói trúng tim đen",
  },
  {
    word: "tím gan",
    part_of_speech: "tính từ",
    meaning:
      '(khẩu ngữ) rất tức giận mà phải nén chịu: giận tím gan * "Tím gan thay khách má đào, Mông mênh bể Sở dễ vào, khó ra." (ca dao)',
    example:
      'giận tím gan * "Tím gan thay khách má đào, Mông mênh bể Sở dễ vào, khó ra." (ca dao)',
  },
  {
    word: "tìm kiếm",
    part_of_speech: "động từ",
    meaning:
      "tìm cho thấy, cho có được (nói khái quát): tìm kiếm tài liệu * tìm kiếm việc làm",
    example: "tìm kiếm tài liệu * tìm kiếm việc làm",
  },
  {
    word: "tím lịm",
    part_of_speech: "tính từ",
    meaning: "tím rất đậm, như sẫm lại: mặt tím lịm như người say rượu",
    example: "mặt tím lịm như người say rượu",
  },
  {
    word: "tim la",
    part_of_speech: "danh từ",
    meaning: "(cũ, khẩu ngữ) giang mai: mắc bệnh tim la",
    example: "mắc bệnh tim la",
  },
  {
    word: "tim mạch",
    part_of_speech: "danh từ",
    meaning:
      "tim và mạch máu, dùng để chỉ chung hệ tuần hoàn: có bệnh về tim mạch",
    example: "có bệnh về tim mạch",
  },
  {
    word: "tìm tòi",
    part_of_speech: "",
    meaning:
      "tìm một cách công phu, kiên nhẫn để thấy ra, nghĩ ra (nói khái quát): chịu khó suy nghĩ, tìm tòi",
    example: "chịu khó suy nghĩ, tìm tòi",
  },
  {
    word: "tím ruột",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như tím gan: giận tím ruột",
    example: "giận tím ruột",
  },
  {
    word: "tím rịm",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) như tím lịm: bông hoa tím rịm",
    example: "bông hoa tím rịm",
  },
  {
    word: "tím than",
    part_of_speech: "tính từ",
    meaning: "có màu tím sẫm pha xanh: quần màu tím than",
    example: "quần màu tím than",
  },
  {
    word: "tím tái",
    part_of_speech: "tính từ",
    meaning:
      "tái đến mức trông như tím đi (thường nói về sắc da): bờ môi tím tái * khóc tím tái mặt mày",
    example: "bờ môi tím tái * khóc tím tái mặt mày",
  },
  {
    word: "tin",
    part_of_speech: "danh từ",
    meaning:
      "điều được truyền đi, báo cho biết về sự việc, tình hình xảy ra: nhận được tin nhà * báo tin cho bạn",
    example: "nhận được tin nhà * báo tin cho bạn",
  },
  {
    word: "tin",
    part_of_speech: "danh từ",
    meaning: "(Khẩu ngữ) thông tin (ng2; nói tắt): quá trình xử lí tin",
    example: "quá trình xử lí tin",
  },
  {
    word: "tin",
    part_of_speech: "động từ",
    meaning: "(Khẩu ngữ) báo tin (nói tắt): tin về gia đình * tin cho bạn bè",
    example: "tin về gia đình * tin cho bạn bè",
  },
  {
    word: "tin",
    part_of_speech: "động từ",
    meaning:
      "có ý nghĩ cho là đúng sự thật, là có thật: thấy tận mắt mới tin * nửa tin nửa ngờ * chuyện này thì có thể tin được",
    example:
      "thấy tận mắt mới tin * nửa tin nửa ngờ * chuyện này thì có thể tin được",
  },
  {
    word: "tin",
    part_of_speech: "động từ",
    meaning: "cho là thành thật: tin ở lời hứa * tin bợm mất bò (tng)",
    example: "tin ở lời hứa * tin bợm mất bò (tng)",
  },
  {
    word: "tin",
    part_of_speech: "động từ",
    meaning:
      "đặt hoàn toàn hi vọng vào người nào hay cái gì đó: tin vào sức mình * tin ở bạn bè * tin ở lớp trẻ",
    example: "tin vào sức mình * tin ở bạn bè * tin ở lớp trẻ",
  },
  {
    word: "tin",
    part_of_speech: "động từ",
    meaning:
      "nghĩ là rất có thể sẽ như vậy: tôi tin rồi tình hình sẽ ổn * tin là mình làm đúng",
    example: "tôi tin rồi tình hình sẽ ổn * tin là mình làm đúng",
  },
  {
    word: "tim tím",
    part_of_speech: "tính từ",
    meaning: "có màu hơi tím: hoa xoan tim tím",
    example: "hoa xoan tim tím",
  },
  {
    word: "tín chỉ",
    part_of_speech: "danh từ",
    meaning: "giấy đặc biệt dùng để viết văn tự, văn khế.",
    example: "có đầy đủ tín chỉ mới được bảo vệ luận án",
  },
  {
    word: "tin buồn",
    part_of_speech: "danh từ",
    meaning: "tin về việc có người thân chết: nhà có tin buồn * báo tin buồn",
    example: "nhà có tin buồn * báo tin buồn",
  },
  {
    word: "tĩn",
    part_of_speech: "danh từ",
    meaning:
      "hũ có bụng phình to, thường dùng để đựng chất lỏng: tĩn rượu * một tĩn nước mắm",
    example: "tĩn rượu * một tĩn nước mắm",
  },
  {
    word: "tin cẩn",
    part_of_speech: "động từ",
    meaning:
      "tin tới mức có thể cho biết hoặc giao cho những việc quan trọng: tay chân tin cẩn",
    example: "tay chân tin cẩn",
  },
  {
    word: "tín",
    part_of_speech: "danh từ",
    meaning:
      "đức tin của con người biết trọng lời hứa và biết tin nhau: buôn bán phải giữ chữ tín",
    example: "buôn bán phải giữ chữ tín",
  },
  {
    word: "tin cậy",
    part_of_speech: "động từ",
    meaning:
      "tin tưởng tới mức hoàn toàn trông cậy vào: nguồn tin đáng tin cậy * một chỗ dựa tin cậy",
    example: "nguồn tin đáng tin cậy * một chỗ dựa tin cậy",
  },
  {
    word: "tín chấp",
    part_of_speech: "động từ",
    meaning:
      "(hình thức vay tiền ngân hàng) đảm bảo bằng sự tín nhiệm mà không có tài sản thế chấp: vay tín chấp * nhờ người đứng ra tín chấp để vay tiền",
    example: "vay tín chấp * nhờ người đứng ra tín chấp để vay tiền",
  },
  {
    word: "tín dụng",
    part_of_speech: "danh từ",
    meaning:
      "sự vay mượn tiền mặt và vật tư, hàng hoá: cấp tín dụng * vay tín dụng * tổ chức tín dụng",
    example: "cấp tín dụng * vay tín dụng * tổ chức tín dụng",
  },
  {
    word: "tin dùng",
    part_of_speech: "động từ",
    meaning: "tin cậy và giao cho công việc quan trọng: được cấp trên tin dùng",
    example: "được cấp trên tin dùng",
  },
  {
    word: "tin dùng",
    part_of_speech: "động từ",
    meaning:
      "tin tưởng và sử dụng (sản phẩm nào đó): sản phẩm được khách hàng tin dùng",
    example: "sản phẩm được khách hàng tin dùng",
  },
  {
    word: "tín điều",
    part_of_speech: "danh từ",
    meaning:
      "điều do tôn giáo đặt ra để tín đồ tuân theo: tín điều tôn giáo * những tín điều của đạo Phật",
    example: "tín điều tôn giáo * những tín điều của đạo Phật",
  },
  {
    word: "tín điều",
    part_of_speech: "danh từ",
    meaning:
      "điều được tin theo một cách tuyệt đối: những tín điều của nho giáo",
    example: "những tín điều của nho giáo",
  },
  {
    word: "tin đồn",
    part_of_speech: "danh từ",
    meaning:
      "tin được truyền miệng cho nhau một cách không chính thức, không rõ nguồn gốc và không có sự đảm bảo về tính chính xác: tin đồn thất thiệt * phao tin đồn",
    example: "tin đồn thất thiệt * phao tin đồn",
  },
  {
    word: "tín hiệu",
    part_of_speech: "danh từ",
    meaning:
      "dấu hiệu (thường là quy ước) để truyền đi một thông báo: bấm đèn làm tín hiệu * tín hiệu SOS * hệ thống tín hiệu giao thông",
    example:
      "bấm đèn làm tín hiệu * tín hiệu SOS * hệ thống tín hiệu giao thông",
  },
  {
    word: "tín đồ",
    part_of_speech: "danh từ",
    meaning: "người tin theo một tôn giáo: tín đồ Thiên Chúa giáo",
    example: "tín đồ Thiên Chúa giáo",
  },
  {
    word: "tin mừng",
    part_of_speech: "danh từ",
    meaning:
      "tin về việc có chuyện vui (thường là trong đời sống gia đình): báo tin mừng",
    example: "báo tin mừng",
  },
  {
    word: "tin hin",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) quá bé: cái lỗ tin hin * cửa rả gì mà bé tin hin",
    example: "cái lỗ tin hin * cửa rả gì mà bé tin hin",
  },
  {
    word: "tín nghĩa",
    part_of_speech: "danh từ",
    meaning:
      "đức tính của người biết trọng lời hứa, trọng đạo nghĩa, trong quan hệ với những người khác: người có tín nghĩa * biết trọng tín nghĩa",
    example: "người có tín nghĩa * biết trọng tín nghĩa",
  },
  {
    word: "tín ngưỡng",
    part_of_speech: "",
    meaning:
      "lòng tin theo một tôn giáo nào đó: tín ngưỡng tôn giáo * quyền tự do tín ngưỡng",
    example: "tín ngưỡng tôn giáo * quyền tự do tín ngưỡng",
  },
  {
    word: "tín nhiệm",
    part_of_speech: "động từ",
    meaning:
      "tin cậy trong một nhiệm vụ cụ thể nào đó: mất tín nhiệm * được bà con tín nhiệm bầu làm chủ tịch xã",
    example: "mất tín nhiệm * được bà con tín nhiệm bầu làm chủ tịch xã",
  },
  {
    word: "tin nhạn",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) tin tức do chim nhạn đưa đến; dùng để chỉ tin tức nói chung: "Tuấn Khanh đương tiệc tưng bừng, Đã nghe tin nhạn bay chừng tới nơi." (NTT)',
    example:
      'Tuấn Khanh đương tiệc tưng bừng, Đã nghe tin nhạn bay chừng tới nơi." (NTT)',
  },
  {
    word: "tín phiếu",
    part_of_speech: "danh từ",
    meaning:
      "giấy nợ ngắn hạn do các cơ quan tín dụng phát ra: tín phiếu ngân hàng * phát hành tín phiếu",
    example: "tín phiếu ngân hàng * phát hành tín phiếu",
  },
  {
    word: "tin tức",
    part_of_speech: "danh từ",
    meaning: "tin (nói khái quát): tin tức thời sự * thăm dò tin tức",
    example: "tin tức thời sự * thăm dò tin tức",
  },
  {
    word: "tin sương",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) như tin nhạn: "Sự lòng ngỏ với băng nhân, Tin sương đồn đại xa gần xôn xao." (TKiều)',
    example:
      'Sự lòng ngỏ với băng nhân, Tin sương đồn đại xa gần xôn xao." (TKiều)',
  },
  {
    word: "tìn tịt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (thấp) tịt hẳn xuống, như không còn thấy có chiều cao: lùn tìn tịt",
    example: "lùn tìn tịt",
  },
  {
    word: "tin tưởng",
    part_of_speech: "động từ",
    meaning:
      "tin ở ai hoặc ở cái gì đó một cách chắc chắn, có cơ sở: tin tưởng bạn bè * tin tưởng ở tương lai",
    example: "tin tưởng bạn bè * tin tưởng ở tương lai",
  },
  {
    word: "tin vịt",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) tin bịa đặt, không có thật: tung tin vịt",
    example: "tung tin vịt",
  },
  {
    word: "tin yêu",
    part_of_speech: "động từ",
    meaning:
      "tin tưởng và yêu mến: được bạn bè tin yêu * không phụ lòng tin yêu của mọi người",
    example: "được bạn bè tin yêu * không phụ lòng tin yêu của mọi người",
  },
  {
    word: "tin vui",
    part_of_speech: "danh từ",
    meaning:
      "tin có tác dụng mang lại niềm vui: có tin vui * báo tin vui với mọi người",
    example: "có tin vui * báo tin vui với mọi người",
  },
  {
    word: "tin vắn",
    part_of_speech: "danh từ",
    meaning:
      "tin tóm tắt hết sức ngắn gọn, đăng trên báo hoặc phát trên truyền thanh, truyền hình: mẩu tin vắn * mục tin vắn quốc tế",
    example: "mẩu tin vắn * mục tin vắn quốc tế",
  },
  {
    word: "tính",
    part_of_speech: "danh từ",
    meaning:
      "đặc trưng tâm lí của mỗi người, nói chung: tính nóng như lửa * người tốt tính * cha mẹ sinh con, trời sinh tính (tng)",
    example:
      "tính nóng như lửa * người tốt tính * cha mẹ sinh con, trời sinh tính (tng)",
  },
  {
    word: "tính",
    part_of_speech: "danh từ",
    meaning:
      "đặc điểm làm nên cái cơ bản của sự vật, khiến cho sự vật này khác với sự vật khác về bản chất: kim loại có tính dẫn điện * tính dân tộc trong tác phẩm",
    example: "kim loại có tính dẫn điện * tính dân tộc trong tác phẩm",
  },
  {
    word: "tính",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng sau một tính từ để tạo thành một tổ hợp biểu thị một thuộc tính bản chất, thường là một tính cố hữu ở con người: người gàn tính * ông ấy rất kĩ tính * khó tính",
    example: "người gàn tính * ông ấy rất kĩ tính * khó tính",
  },
  {
    word: "tính",
    part_of_speech: "động từ",
    meaning:
      "thực hiện các phép cộng, trừ, nhân, chia, v.v. để tìm ra một số cần biết nào đó: tính tổng của hai số * tính lỗ lãi * thu nhập tính theo đầu người",
    example:
      "tính tổng của hai số * tính lỗ lãi * thu nhập tính theo đầu người",
  },
  {
    word: "tính",
    part_of_speech: "động từ",
    meaning:
      "suy nghĩ, cân nhắc để tìm cho ra cách giải quyết: bàn mưu tính kế * tính chuyện làm ăn",
    example: "bàn mưu tính kế * tính chuyện làm ăn",
  },
  {
    word: "tính",
    part_of_speech: "động từ",
    meaning:
      "kể đến, coi là thuộc phạm vi của những gì cần xét tới: chỗ này bỏ riêng ra, không tính * tính hết các khả năng có thể xảy ra",
    example:
      "chỗ này bỏ riêng ra, không tính * tính hết các khả năng có thể xảy ra",
  },
  {
    word: "tính",
    part_of_speech: "động từ",
    meaning:
      '(Khẩu ngữ) có ý định, dự định làm việc gì đó: tính đến thăm anh mà bận quá * "Nắng nôi quá, hai bà cháu tính đi sớm để chiều còn về." (ĐChu; 3)',
    example:
      'tính đến thăm anh mà bận quá * "Nắng nôi quá, hai bà cháu tính đi sớm để chiều còn về." (ĐChu; 3)',
  },
  {
    word: "tính",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) từ dùng với chủ ngữ ở ngôi thứ hai, làm thành tổ hợp có dạng câu, đặt ở đầu câu thường có hình thức như câu nghi vấn, để biểu thị ý như muốn bảo người đối thoại thử nghĩ xem ý kiến mình nêu ra có đúng không, nhằm tranh thủ một sự đồng tình với mình: anh tính, mưa gió thế này ai mà đi được?",
    example: "anh tính, mưa gió thế này ai mà đi được?",
  },
  {
    word: "tình",
    part_of_speech: "danh từ",
    meaning:
      "sự yêu mến, gắn bó giữa người với người: tình bạn * tình đồng chí * tình thầy trò",
    example: "tình bạn * tình đồng chí * tình thầy trò",
  },
  {
    word: "tình",
    part_of_speech: "danh từ",
    meaning:
      "sự yêu đương giữa nam và nữ: câu chuyện tình * bên tình, bên hiếu",
    example: "câu chuyện tình * bên tình, bên hiếu",
  },
  {
    word: "tình",
    part_of_speech: "danh từ",
    meaning: "tình cảm nói chung: sống có tình, có nghĩa * tức cảnh sinh tình",
    example: "sống có tình, có nghĩa * tức cảnh sinh tình",
  },
  {
    word: "tình",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có vẻ duyên dáng, dễ gợi tình cảm yêu thương: ánh mắt rất tình * nụ cười tình * trông cô ta tình lắm!",
    example: "ánh mắt rất tình * nụ cười tình * trông cô ta tình lắm!",
  },
  {
    word: "tình",
    part_of_speech: "danh từ",
    meaning:
      'tình cảnh, hoàn cảnh: thương tình * "Trời ơi, có thấu tình chăng, Một ngày đằng đẵng xem bằng ba thu!" (ca dao)',
    example:
      'thương tình * "Trời ơi, có thấu tình chăng, Một ngày đằng đẵng xem bằng ba thu!" (ca dao)',
  },
  {
    word: "tỉnh",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị hành chính, gồm nhiều huyện và thị xã, thị trấn: người cùng tỉnh * thành phố trực thuộc tỉnh",
    example: "người cùng tỉnh * thành phố trực thuộc tỉnh",
  },
  {
    word: "tỉnh",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) tỉnh lị (nói tắt): lên tỉnh học * nhà quê ra tỉnh * nửa quê nửa tỉnh",
    example: "lên tỉnh học * nhà quê ra tỉnh * nửa quê nửa tỉnh",
  },
  {
    word: "tỉnh",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái không say, không mê, không ngủ, mà cảm biết và nhận thức được hoàn toàn như bình thường: bệnh nhân đã tỉnh lại * nửa tỉnh nửa say * nói mãi mới tỉnh ra",
    example: "bệnh nhân đã tỉnh lại * nửa tỉnh nửa say * nói mãi mới tỉnh ra",
  },
  {
    word: "tỉnh",
    part_of_speech: "tính từ",
    meaning:
      "hay đg ở trạng thái đã thức hẳn dậy, không còn ngủ nữa: tỉnh hẳn ngủ * tỉnh dậy thì trời đã sáng",
    example: "tỉnh hẳn ngủ * tỉnh dậy thì trời đã sáng",
  },
  {
    word: "tinh",
    part_of_speech: "danh từ",
    meaning:
      "con vật sống lâu năm trở thành yêu quái chuyên hại người, theo tưởng tượng; cũng thường dùng để ví kẻ lão luyện, ranh ma, xảo quyệt: con hồ li đã thành tinh",
    example: "con hồ li đã thành tinh",
  },
  {
    word: "tinh",
    part_of_speech: "danh từ",
    meaning: "phần xanh ở ngoài vỏ cây loài tre, nứa: cạo tinh tre",
    example: "cạo tinh tre",
  },
  {
    word: "tinh",
    part_of_speech: "tính từ",
    meaning:
      "có khả năng nhận biết nhanh cả những cái rất nhỏ, phức tạp, tế nhị: tinh mắt, nhìn thấy trước * nhận xét rất tinh * trẻ con giờ tinh lắm, chuyện gì cũng biết!",
    example:
      "tinh mắt, nhìn thấy trước * nhận xét rất tinh * trẻ con giờ tinh lắm, chuyện gì cũng biết!",
  },
  {
    word: "tinh",
    part_of_speech: "tính từ",
    meaning:
      "đạt đến trình độ cao, nắm vững, thành thạo: nét vẽ đã tinh * nhất nghệ tinh, nhất thân vinh (tng)",
    example: "nét vẽ đã tinh * nhất nghệ tinh, nhất thân vinh (tng)",
  },
  {
    word: "tinh",
    part_of_speech: "tính từ",
    meaning:
      "thuần nhất, không bị pha tạp với thứ khác, loại khác: muối tinh * thức ăn tinh",
    example: "muối tinh * thức ăn tinh",
  },
  {
    word: "tinh",
    part_of_speech: "phụ từ",
    meaning:
      "chỉ toàn là: chọn tinh đồ tốt * toán thợ tinh những người khoẻ mạnh",
    example: "chọn tinh đồ tốt * toán thợ tinh những người khoẻ mạnh",
  },
  {
    word: "tĩnh",
    part_of_speech: "danh từ",
    meaning: "bàn thờ thần thánh: lập tĩnh thờ mẫu",
    example: "lập tĩnh thờ mẫu",
  },
  {
    word: "tĩnh",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) bàn đèn thuốc phiện: lôi tĩnh ra hút",
    example: "lôi tĩnh ra hút",
  },
  {
    word: "tĩnh",
    part_of_speech: "tính từ",
    meaning:
      'yên ắng, không ồn ào: không gian rất tĩnh * "Tuy rằng quán khách hẹp hòi, Chốn nằm cũng tĩnh, chốn ngồi cũng thanh." (NĐM)',
    example:
      'không gian rất tĩnh * "Tuy rằng quán khách hẹp hòi, Chốn nằm cũng tĩnh, chốn ngồi cũng thanh." (NĐM)',
  },
  {
    word: "tĩnh",
    part_of_speech: "tính từ",
    meaning:
      "có vị trí, hình dáng, trạng thái hoặc tính chất không thay đổi theo thời gian: trạng thái tĩnh * hình ảnh tĩnh",
    example: "trạng thái tĩnh * hình ảnh tĩnh",
  },
  {
    word: "tình ái",
    part_of_speech: "danh từ",
    meaning: "như ái tình: chuyện tình ái",
    example: "chuyện tình ái",
  },
  {
    word: "tình báo",
    part_of_speech: "động từ",
    meaning:
      "điều tra, thu thập bí mật quân sự và bí mật quốc gia của đối phương: hoạt động tình báo * công tác tình báo",
    example: "hoạt động tình báo * công tác tình báo",
  },
  {
    word: "tình báo",
    part_of_speech: "danh từ",
    meaning: "người hoặc tổ chức làm công tác tình báo: huấn luyện tình báo",
    example: "huấn luyện tình báo",
  },
  {
    word: "tịnh",
    part_of_speech: "động từ",
    meaning:
      "tính tổng số khối lượng của hàng, không kể bao bì: tịnh hàng vào kho * tịnh lương thực đã đóng bao",
    example: "tịnh hàng vào kho * tịnh lương thực đã đóng bao",
  },
  {
    word: "tịnh",
    part_of_speech: "tính từ",
    meaning:
      "chỉ tính khối lượng thật của hàng, không kể bao bì: khối lượng tịnh",
    example: "khối lượng tịnh",
  },
  {
    word: "tịnh",
    part_of_speech: "trợ từ",
    meaning:
      "(khẩu ngữ) từ biểu thị ý nhấn mạnh sự phủ định nêu ra sau đó: tịnh không một bóng người * tịnh không một tiếng động",
    example: "tịnh không một bóng người * tịnh không một tiếng động",
  },
  {
    word: "tịnh",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) tượng (trong cỗ bài tam cúc hoặc cờ tướng): lên tịnh",
    example: "lên tịnh",
  },
  {
    word: "tinh anh",
    part_of_speech: "danh từ",
    meaning:
      'phần thuần khiết, tốt đẹp nhất (thường nói về tinh thần): "Kiều rằng: Những đấng tài hoa, Thác là thể phách, còn là tinh anh." (TKiều)',
    example:
      'Kiều rằng: Những đấng tài hoa, Thác là thể phách, còn là tinh anh." (TKiều)',
  },
  {
    word: "tinh anh",
    part_of_speech: "tính từ",
    meaning: "(mắt) sáng và có vẻ thông minh, lanh lợi: đôi mắt tinh anh",
    example: "đôi mắt tinh anh",
  },
  {
    word: "tỉnh bơ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) tỉnh như không, như hoàn toàn không có gì xảy ra, trước việc lẽ ra phải chú ý, phải có phản ứng: mặt tỉnh bơ * nói bằng giọng tỉnh bơ",
    example: "mặt tỉnh bơ * nói bằng giọng tỉnh bơ",
  },
  {
    word: "tính cách",
    part_of_speech: "danh từ",
    meaning:
      "tổng thể nói chung những đặc điểm tâm lí ổn định trong cách xử sự của một người, biểu hiện thái độ điển hình của người đó trong những hoàn cảnh điển hình: tính cách mạnh mẽ * mỗi người có một tính cách riêng",
    example: "tính cách mạnh mẽ * mỗi người có một tính cách riêng",
  },
  {
    word: "tinh binh",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) quân tinh nhuệ: "Trong tay mười vạn tinh binh, Kéo về đóng chật một thành Lâm Tri." (TKiều)',
    example:
      'Trong tay mười vạn tinh binh, Kéo về đóng chật một thành Lâm Tri." (TKiều)',
  },
  {
    word: "tinh bột",
    part_of_speech: "danh từ",
    meaning:
      "chất bột trắng và mịn có nhiều trong hạt ngũ cốc và trong một số loại củ, quả: gạo, sắn có chứa nhiều tinh bột",
    example: "gạo, sắn có chứa nhiều tinh bột",
  },
  {
    word: "tình ca",
    part_of_speech: "danh từ",
    meaning: "bài hát về tình yêu: bản tình ca",
    example: "bản tình ca",
  },
  {
    word: "tình cảm",
    part_of_speech: "danh từ",
    meaning:
      "phản ứng tâm lí theo hướng tích cực với sự kích thích của hiện thực khách quan: giàu tình cảm * phân biệt giữa lí trí và tình cảm",
    example: "giàu tình cảm * phân biệt giữa lí trí và tình cảm",
  },
  {
    word: "tình cảm",
    part_of_speech: "danh từ",
    meaning:
      "sự yêu mến, gắn bó giữa người với người: tình cảm vợ chồng * nảy sinh tình cảm * sống thiếu thốn tình cảm",
    example: "tình cảm vợ chồng * nảy sinh tình cảm * sống thiếu thốn tình cảm",
  },
  {
    word: "tình cảm",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra giàu tình cảm và dễ thiên về tình cảm: sống tình cảm * thằng bé rất tình cảm với mẹ",
    example: "sống tình cảm * thằng bé rất tình cảm với mẹ",
  },
  {
    word: "tình cảnh",
    part_of_speech: "danh từ",
    meaning:
      "cảnh ngộ và tình trạng đang phải chịu đựng: tình cảnh rất đáng thương * ở vào tình cảnh khó xử",
    example: "tình cảnh rất đáng thương * ở vào tình cảnh khó xử",
  },
  {
    word: "tính chất",
    part_of_speech: "danh từ",
    meaning:
      "đặc điểm riêng của sự vật, hiện tượng, làm phân biệt nó với những sự vật hiện tượng khác loại: tính chất trữ tình trong thơ mới * câu chuyện mang tính chất thần bí",
    example:
      "tính chất trữ tình trong thơ mới * câu chuyện mang tính chất thần bí",
  },
  {
    word: "tinh cầu",
    part_of_speech: "danh từ",
    meaning: "ngôi sao: mơ ước tới những tinh cầu xa xôi",
    example: "mơ ước tới những tinh cầu xa xôi",
  },
  {
    word: "tình chung",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) tình yêu sâu sắc, thuỷ chung: "Hôm nay sum họp trúc mai, Tình chung một khắc, nghĩa dài trăm năm." (ca dao)',
    example:
      'Hôm nay sum họp trúc mai, Tình chung một khắc, nghĩa dài trăm năm." (ca dao)',
  },
  {
    word: "tinh chế",
    part_of_speech: "động từ",
    meaning:
      "làm cho tinh khiết bằng cách loại bỏ những tạp chất: tinh chế dầu thô * đường tinh chế",
    example: "tinh chế dầu thô * đường tinh chế",
  },
  {
    word: "tinh chỉnh",
    part_of_speech: "động từ",
    meaning:
      "chỉnh lại, sửa lại cho phù hợp, chính xác hơn: tinh chỉnh một số tính năng của máy * tinh chỉnh lại đội ngũ cán bộ",
    example:
      "tinh chỉnh một số tính năng của máy * tinh chỉnh lại đội ngũ cán bộ",
  },
  {
    word: "tinh chất",
    part_of_speech: "danh từ",
    meaning:
      "chất đã được làm cho sạch các tạp chất: vàng tinh chất * tinh chất bạc hà",
    example: "vàng tinh chất * tinh chất bạc hà",
  },
  {
    word: "tính chuyện",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) suy tính và dự định sẽ làm một việc gì: tính chuyện làm ăn * tính chuyện chồng con",
    example: "tính chuyện làm ăn * tính chuyện chồng con",
  },
  {
    word: "tinh dầu",
    part_of_speech: "danh từ",
    meaning:
      "chất lỏng có mùi thơm, dễ bay hơi, lấy từ thực vật hay động vật, thường dùng chế nước hoa hoặc làm thuốc: tinh dầu hoa hồi * chưng cất tinh dầu",
    example: "tinh dầu hoa hồi * chưng cất tinh dầu",
  },
  {
    word: "tính danh",
    part_of_speech: "danh từ",
    meaning: "(cũ) họ và tên, lai lịch của một người: khai báo tính danh",
    example: "khai báo tính danh",
  },
  {
    word: "tình cờ",
    part_of_speech: "tính từ",
    meaning:
      'không liệu trước, không dè trước mà xảy ra: việc xảy ra rất tình cờ * "Tình cờ, chẳng hẹn mà nên, Mạt cưa mướp đắng, đôi bên một phường." (TKiều)',
    example:
      'việc xảy ra rất tình cờ * "Tình cờ, chẳng hẹn mà nên, Mạt cưa mướp đắng, đôi bên một phường." (TKiều)',
  },
  {
    word: "tình dục",
    part_of_speech: "danh từ",
    meaning:
      "nhu cầu tự nhiên của con người về quan hệ tính giao: quan hệ tình dục * thoả mãn tình dục * quấy rối tình dục",
    example: "quan hệ tình dục * thoả mãn tình dục * quấy rối tình dục",
  },
  {
    word: "tính dục",
    part_of_speech: "danh từ",
    meaning:
      "sự đòi hỏi sinh lí về quan hệ tính giao: hiểu biết về tính dục * thoả mãn tính dục",
    example: "hiểu biết về tính dục * thoả mãn tính dục",
  },
  {
    word: "tĩnh điện",
    part_of_speech: "danh từ",
    meaning:
      "điện do ma sát gây ra: hệ thống lọc bụi tĩnh điện * sơn tĩnh điện",
    example: "hệ thống lọc bụi tĩnh điện * sơn tĩnh điện",
  },
  {
    word: "tình duyên",
    part_of_speech: "danh từ",
    meaning:
      "quan hệ yêu đương hướng tới hôn nhân: tình duyên trắc trở * lận đận về đường tình duyên",
    example: "tình duyên trắc trở * lận đận về đường tình duyên",
  },
  {
    word: "tĩnh dưỡng",
    part_of_speech: "động từ",
    meaning:
      "ở tại một chỗ để nghỉ ngơi và dưỡng sức: tĩnh dưỡng vài ngày cho khoẻ lại * về quê tĩnh dưỡng",
    example: "tĩnh dưỡng vài ngày cho khoẻ lại * về quê tĩnh dưỡng",
  },
  {
    word: "tình địch",
    part_of_speech: "danh từ",
    meaning:
      "những người vì cùng yêu một người mà có mâu thuẫn với nhau: kẻ tình địch",
    example: "kẻ tình địch",
  },
  {
    word: "tính đảng",
    part_of_speech: "danh từ",
    meaning:
      "khuynh hướng trong công tác, hoạt động, v.v. thấm nhuần hệ tư tưởng của đảng: rèn luyện tính đảng * tính đảng trong văn học",
    example: "rèn luyện tính đảng * tính đảng trong văn học",
  },
  {
    word: "tình đầu",
    part_of_speech: "danh từ",
    meaning: "(cũ) đầu đuôi của sự việc: kể hết tình đầu",
    example: "kể hết tình đầu",
  },
  {
    word: "tỉnh đòn",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tỉnh ngộ ra (sau khi đã vấp phải điều không hay): bị lừa mấy cú mà vẫn chưa tỉnh đòn",
    example: "bị lừa mấy cú mà vẫn chưa tỉnh đòn",
  },
  {
    word: "tịnh độ",
    part_of_speech: "danh từ",
    meaning:
      "cõi cực lạc, theo đạo Phật: Tây phương tịnh độ * siêu sinh tịnh độ",
    example: "Tây phương tịnh độ * siêu sinh tịnh độ",
  },
  {
    word: "tinh đời",
    part_of_speech: "tính từ",
    meaning:
      'rất tinh trong việc nhận xét, đánh giá con người, việc đời: một con người tinh đời * "Khen cho con mắt tinh đời, Anh hùng đoán giữa trần ai mới già!" (TKiều)',
    example:
      'một con người tinh đời * "Khen cho con mắt tinh đời, Anh hùng đoán giữa trần ai mới già!" (TKiều)',
  },
  {
    word: "tinh giảm",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) như tinh giản: tinh giảm biên chế",
    example: "tinh giảm biên chế",
  },
  {
    word: "tinh giản",
    part_of_speech: "động từ",
    meaning:
      "giảm bớt cho tinh gọn: tinh giản bộ máy hành chính * tổ chức quân đội theo hướng tinh giản, gọn nhẹ",
    example:
      "tinh giản bộ máy hành chính * tổ chức quân đội theo hướng tinh giản, gọn nhẹ",
  },
  {
    word: "tỉnh giấc",
    part_of_speech: "động từ",
    meaning:
      "tỉnh dậy khi đang ngủ hoặc đã ngủ đẫy giấc: tỉnh giấc thì trời vừa sáng * bị tỉnh giấc vì tiếng nổ lớn",
    example: "tỉnh giấc thì trời vừa sáng * bị tỉnh giấc vì tiếng nổ lớn",
  },
  {
    word: "tính giao",
    part_of_speech: "danh từ",
    meaning: "sự giao cấu giữa đực và cái, giữa nam và nữ: quan hệ tính giao",
    example: "quan hệ tính giao",
  },
  {
    word: "tình hình",
    part_of_speech: "danh từ",
    meaning:
      "tổng thể nói chung những sự kiện, hiện tượng có quan hệ với nhau, diễn ra trong một không gian, thời gian nào đó, cho thấy một tình trạng hoặc xu thế phát triển của sự vật: tình hình thời sự * theo dõi tình hình thời tiết",
    example: "tình hình thời sự * theo dõi tình hình thời tiết",
  },
  {
    word: "tinh gọn",
    part_of_speech: "tính từ",
    meaning:
      "có số lượng người tham gia ở mức thấp nhất, hợp lí nhất, nhưng vẫn đảm bảo hoạt động tốt: tinh gọn đội ngũ quản lí * bộ máy cần hết sức tinh gọn",
    example: "tinh gọn đội ngũ quản lí * bộ máy cần hết sức tinh gọn",
  },
  {
    word: "tỉnh hội",
    part_of_speech: "danh từ",
    meaning: "cấp bộ tỉnh của một hội: tỉnh hội phụ nữ",
    example: "tỉnh hội phụ nữ",
  },
  {
    word: "tinh hoa",
    part_of_speech: "danh từ",
    meaning:
      "phần tinh tuý, tốt đẹp nhất, quan trọng nhất: tinh hoa văn hoá dân tộc * cổ học tinh hoa",
    example: "tinh hoa văn hoá dân tộc * cổ học tinh hoa",
  },
  {
    word: "tính hạnh",
    part_of_speech: "danh từ",
    meaning: "(cũ) như tính nết: tính hạnh nết na",
    example: "tính hạnh nết na",
  },
  {
    word: "tình huống",
    part_of_speech: "danh từ",
    meaning:
      "sự diễn biến của tình hình, về mặt cần phải đối phó: rơi vào một tình huống khó xử * gặp tình huống khó khăn",
    example: "rơi vào một tình huống khó xử * gặp tình huống khó khăn",
  },
  {
    word: "tính khí",
    part_of_speech: "danh từ",
    meaning:
      "tính tình và khí chất của con người: tính khí ngang tàng * tính khí thất thường",
    example: "tính khí ngang tàng * tính khí thất thường",
  },
  {
    word: "tinh khôi",
    part_of_speech: "tính từ",
    meaning:
      "(văn chương) hoàn toàn tinh khiết, thuần một tính chất nào đó, gây cảm giác tươi đẹp: màu trắng tinh khôi * chiếc áo mới tinh khôi",
    example: "màu trắng tinh khôi * chiếc áo mới tinh khôi",
  },
  {
    word: "tinh khiết",
    part_of_speech: "tính từ",
    meaning:
      "rất sạch, không lẫn một tạp chất nào: nước uống tinh khiết * màu trắng tinh khiết",
    example: "nước uống tinh khiết * màu trắng tinh khiết",
  },
  {
    word: "tỉnh khô",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) tỉnh như không, hoàn toàn không tỏ một thái độ hay tình cảm gì trước điều lẽ ra phải có tác động đến mình: giọng tỉnh khô * mặt tỉnh khô",
    example: "giọng tỉnh khô * mặt tỉnh khô",
  },
  {
    word: "tinh kì",
    part_of_speech: "danh từ",
    meaning: "(cũ) cờ xí: tinh kì phấp phới",
    example: "tinh kì phấp phới",
  },
  {
    word: "tình khúc",
    part_of_speech: "danh từ",
    meaning: "khúc hát về tình yêu: bản tình khúc * tình khúc mùa thu",
    example: "bản tình khúc * tình khúc mùa thu",
  },
  {
    word: "tinh khôn",
    part_of_speech: "tính từ",
    meaning:
      "khôn và lanh lợi (thường nói về trẻ con hoặc loài vật): con vật tinh khôn * thằng bé rất tinh khôn",
    example: "con vật tinh khôn * thằng bé rất tinh khôn",
  },
  {
    word: "tĩnh lặng",
    part_of_speech: "tính từ",
    meaning:
      "hoàn toàn yên ắng, dường như không có một tiếng động hoặc một hoạt động nào diễn ra: không gian tĩnh lặng * bến đò tĩnh lặng, không người qua lại",
    example: "không gian tĩnh lặng * bến đò tĩnh lặng, không người qua lại",
  },
  {
    word: "tỉnh lị",
    part_of_speech: "danh từ",
    meaning:
      "thị xã hoặc thành phố, nơi các cơ quan tỉnh đóng: người dân tỉnh lị",
    example: "người dân tỉnh lị",
  },
  {
    word: "tỉnh lẻ",
    part_of_speech: "danh từ",
    meaning: "tỉnh nhỏ, xa các trung tâm kinh tế, văn hoá: dân tỉnh lẻ",
    example: "dân tỉnh lẻ",
  },
  {
    word: "tinh luyện",
    part_of_speech: "động từ",
    meaning:
      "khử các tạp chất bằng một quy trình công nghệ để có một chất có độ sạch cao: tinh luyện thiếc * đường tinh luyện",
    example: "tinh luyện thiếc * đường tinh luyện",
  },
  {
    word: "tinh luyện",
    part_of_speech: "tính từ",
    meaning:
      "được rèn luyện đạt đến trình độ cao: ngôn ngữ tinh luyện * đội quân tinh luyện",
    example: "ngôn ngữ tinh luyện * đội quân tinh luyện",
  },
  {
    word: "tinh lực",
    part_of_speech: "danh từ",
    meaning:
      "tinh thần và sức lực: hao mòn tinh lực * tập trung toàn bộ tinh lực vào công việc",
    example: "hao mòn tinh lực * tập trung toàn bộ tinh lực vào công việc",
  },
  {
    word: "tinh lọc",
    part_of_speech: "động từ",
    meaning:
      "làm cho trong sạch, tinh khiết bằng cách lọc bỏ những tạp chất hoặc những thứ không cần thiết: tinh lọc không khí * nước đã được tinh lọc",
    example: "tinh lọc không khí * nước đã được tinh lọc",
  },
  {
    word: "tính liệu",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) như lo liệu: mọi việc đã được tính liệu cẩn thận",
    example: "mọi việc đã được tính liệu cẩn thận",
  },
  {
    word: "tỉnh lược",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) lược bỏ bớt cho gọn (thường nói về bộ phận của câu): câu tỉnh lược * phép tỉnh lược",
    example: "câu tỉnh lược * phép tỉnh lược",
  },
  {
    word: "tỉnh lỵ",
    part_of_speech: "danh từ",
    meaning:
      "thị xã hoặc thành phố, nơi các cơ quan tỉnh đóng: người dân tỉnh lị",
    example: "người dân tỉnh lị",
  },
  {
    word: "tinh ma",
    part_of_speech: "tính từ",
    meaning:
      'tinh ranh, ma mãnh: thằng bé rất tinh ma * "Vợ chàng quỷ quái, tinh ma, Phen này kẻ cắp, bà già gặp nhau!" (TKiều)',
    example:
      'thằng bé rất tinh ma * "Vợ chàng quỷ quái, tinh ma, Phen này kẻ cắp, bà già gặp nhau!" (TKiều)',
  },
  {
    word: "tĩnh mịch",
    part_of_speech: "tính từ",
    meaning:
      "yên lặng và vắng vẻ, không có những biểu hiện hoạt động: cảnh chùa tĩnh mịch",
    example: "cảnh chùa tĩnh mịch",
  },
  {
    word: "tính mạng",
    part_of_speech: "danh từ",
    meaning:
      "mạng sống của con người: nguy hiểm đến tính mạng * coi thường tính mạng",
    example: "nguy hiểm đến tính mạng * coi thường tính mạng",
  },
  {
    word: "tỉnh mộng",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) bừng tỉnh, thoát ra khỏi giấc mộng; dùng để chỉ việc tỉnh ra, nhận ra được rằng điều mình mơ tưởng là không thể đạt được: bị một vố đau, giờ mới tỉnh mộng",
    example: "bị một vố đau, giờ mới tỉnh mộng",
  },
  {
    word: "tĩnh mạch",
    part_of_speech: "danh từ",
    meaning:
      "mạch máu dẫn máu từ các cơ quan trong cơ thể về tim: tiêm vào tĩnh mạch",
    example: "tiêm vào tĩnh mạch",
  },
  {
    word: "tính nết",
    part_of_speech: "danh từ",
    meaning:
      "tính và nết (nói khái quát): tính nết dễ thương * thay đổi tính nết",
    example: "tính nết dễ thương * thay đổi tính nết",
  },
  {
    word: "tinh mơ",
    part_of_speech: "",
    meaning: "lúc sáng sớm, trời còn mờ mờ: sớm tinh mơ * dậy từ tinh mơ",
    example: "sớm tinh mơ * dậy từ tinh mơ",
  },
  {
    word: "tính năng",
    part_of_speech: "danh từ",
    meaning:
      "những đặc điểm về khả năng, tác dụng của một vật, một đối tượng (nói tổng quát): tính năng ưu việt của máy tính * phát huy hết tính năng",
    example: "tính năng ưu việt của máy tính * phát huy hết tính năng",
  },
  {
    word: "tinh nghịch",
    part_of_speech: "tính từ",
    meaning:
      "hay đùa nghịch một cách tinh ranh, láu lỉnh: cậu bé tinh nghịch * trò đùa tinh nghịch",
    example: "cậu bé tinh nghịch * trò đùa tinh nghịch",
  },
  {
    word: "tỉnh ngộ",
    part_of_speech: "động từ",
    meaning:
      "bừng tỉnh và hiểu ra, nhận ra được sai lầm của mình: nghe lời giảng giải mà tỉnh ngộ",
    example: "nghe lời giảng giải mà tỉnh ngộ",
  },
  {
    word: "tình nghĩa",
    part_of_speech: "",
    meaning:
      "tình cảm thuỷ chung hợp với lẽ phải, với đạo lí làm người: tình nghĩa vợ chồng * sống có tình nghĩa",
    example: "tình nghĩa vợ chồng * sống có tình nghĩa",
  },
  {
    word: "tình nghi",
    part_of_speech: "động từ",
    meaning:
      "nghi ngờ là có hành động phạm tội: bị tình nghi là gián điệp * đối tượng tình nghi",
    example: "bị tình nghi là gián điệp * đối tượng tình nghi",
  },
  {
    word: "tỉnh ngủ",
    part_of_speech: "tính từ",
    meaning: "tỉnh táo, không còn buồn ngủ nữa: rửa mặt cho tỉnh ngủ",
    example: "rửa mặt cho tỉnh ngủ",
  },
  {
    word: "tỉnh ngủ",
    part_of_speech: "tính từ",
    meaning:
      "dễ dàng tỉnh dậy giữa giấc ngủ khi có những gì bất thường: người già thường tỉnh ngủ",
    example: "người già thường tỉnh ngủ",
  },
  {
    word: "tinh nhanh",
    part_of_speech: "tính từ",
    meaning: "có vẻ thông minh và nhanh nhẹn: cặp mắt tinh nhanh",
    example: "cặp mắt tinh nhanh",
  },
  {
    word: "tình nguyện",
    part_of_speech: "động từ",
    meaning:
      "tự mình nhận lấy trách nhiệm để làm (thường là việc khó khăn, đòi hỏi hi sinh), không phải do bắt buộc: tình nguyện xin nhập ngũ",
    example: "tình nguyện xin nhập ngũ",
  },
  {
    word: "tính ngữ",
    part_of_speech: "danh từ",
    meaning:
      "tổ hợp từ có quan hệ chính phụ do tính từ làm chính tố: ,  *  là những tính ngữ",
    example: ",  *  là những tính ngữ",
  },
  {
    word: "tinh nhạy",
    part_of_speech: "tính từ",
    meaning:
      "rất tinh và nhạy cảm, ngay với cả những điều hết sức tinh tế, nhỏ nhặt: giác quan tinh nhạy * con chó có cái mũi rất tinh nhạy",
    example: "giác quan tinh nhạy * con chó có cái mũi rất tinh nhạy",
  },
  {
    word: "tình nhân",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, hoặc vch) người yêu: "Tình nhân lại gặp tình nhân, Hoa xưa ong cũ, mấy phân chung tình!" (TKiều)',
    example:
      'Tình nhân lại gặp tình nhân, Hoa xưa ong cũ, mấy phân chung tình!" (TKiều)',
  },
  {
    word: "tình nhân",
    part_of_speech: "danh từ",
    meaning: "như nhân tình (ng1): có tình nhân",
    example: "có tình nhân",
  },
  {
    word: "tinh nhuệ",
    part_of_speech: "tính từ",
    meaning:
      "(lực lượng vũ trang) được trang bị đầy đủ và có sức chiến đấu cao: đội quân tinh nhuệ",
    example: "đội quân tinh nhuệ",
  },
  {
    word: "tinh quặng",
    part_of_speech: "danh từ",
    meaning:
      "quặng đã được làm sạch, chứa ít đất đá và tạp chất: chế biến tinh quặng",
    example: "chế biến tinh quặng",
  },
  {
    word: "tỉnh như không",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) thản nhiên, không mảy may biểu hiện cảm xúc hay trạng thái đặc biệt gì, như chưa từng có điều có tác động đáng kể đến mình đã xảy ra: nói dối mà mặt cứ tỉnh như không",
    example: "nói dối mà mặt cứ tỉnh như không",
  },
  {
    word: "tình quân",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) như tình lang: "Trăm nghìn gửi lại tình quân, Tơ duyên ngắn ngủi có ngần ấy thôi." (TKiều)',
    example:
      'Trăm nghìn gửi lại tình quân, Tơ duyên ngắn ngủi có ngần ấy thôi." (TKiều)',
  },
  {
    word: "tinh quái",
    part_of_speech: "tính từ",
    meaning: "tinh ranh, quỷ quái: cái nhìn đầy tinh quái * trò đùa tinh quái",
    example: "cái nhìn đầy tinh quái * trò đùa tinh quái",
  },
  {
    word: "tình phụ",
    part_of_speech: "động từ",
    meaning:
      '(cũ, văn chương) phụ bạc, ruồng bỏ vợ, chồng hoặc người yêu: "Có quán tình phụ cây đa, Ba năm quán đổ cây đa hãy còn." (ca dao)',
    example:
      'Có quán tình phụ cây đa, Ba năm quán đổ cây đa hãy còn." (ca dao)',
  },
  {
    word: "tinh ranh",
    part_of_speech: "tính từ",
    meaning: "tinh khôn và ranh mãnh: một kẻ lọc lõi, tinh ranh",
    example: "một kẻ lọc lõi, tinh ranh",
  },
  {
    word: "tình sử",
    part_of_speech: "danh từ",
    meaning:
      "câu chuyện tình có nhiều tình tiết éo le, phức tạp: một thiên tình sử",
    example: "một thiên tình sử",
  },
  {
    word: "tỉnh rụi",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ, khẩu ngữ) như tỉnh queo: nói bằng giọng tỉnh rụi",
    example: "nói bằng giọng tỉnh rụi",
  },
  {
    word: "tỉnh queo",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ, khẩu ngữ) như tỉnh khô: nghe xong tin ấy mặt nó vẫn tỉnh queo",
    example: "nghe xong tin ấy mặt nó vẫn tỉnh queo",
  },
  {
    word: "tính sổ",
    part_of_speech: "động từ",
    meaning:
      "tính toán và thanh toán các khoản (thường nói về việc làm ăn): tính sổ cuối năm",
    example: "tính sổ cuối năm",
  },
  {
    word: "tính sổ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) trừ khử kẻ thù địch với mình: bọn cướp tính sổ lẫn nhau",
    example: "bọn cướp tính sổ lẫn nhau",
  },
  {
    word: "tình si",
    part_of_speech: "danh từ",
    meaning:
      '(văn chương) tình yêu đắm đuối làm si mê, ngây dại: tấm tình si * "Tôi chỉ là một khách tình si, Ham vẻ đẹp có muôn hình, muôn thể." (ThLữ; 2)',
    example:
      'tấm tình si * "Tôi chỉ là một khách tình si, Ham vẻ đẹp có muôn hình, muôn thể." (ThLữ; 2)',
  },
  {
    word: "tĩnh tại",
    part_of_speech: "tính từ",
    meaning:
      "ở cố định một nơi, một chỗ, không hoặc rất ít đi lại, chuyển dịch: nhà sư ngồi tĩnh tại",
    example: "nhà sư ngồi tĩnh tại",
  },
  {
    word: "tình tang",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) có quan hệ yêu đương (thường là không nghiêm túc, không lâu bền): chuyện tình tang * chẳng tình tang với ai cả",
    example: "chuyện tình tang * chẳng tình tang với ai cả",
  },
  {
    word: "tinh sương",
    part_of_speech: "",
    meaning:
      "khoảng thời gian mới chuyển từ đêm sang ngày (còn nhìn thấy sao và còn mù sương): buổi sớm tinh sương * ra đi từ lúc còn tinh sương",
    example: "buổi sớm tinh sương * ra đi từ lúc còn tinh sương",
  },
  {
    word: "tinh thần",
    part_of_speech: "danh từ",
    meaning:
      "tổng thể nói chung những ý nghĩ, tình cảm, v.v., những hoạt động thuộc về đời sống nội tâm của con người: đời sống tinh thần * giúp đỡ cả về vật chất lẫn tinh thần",
    example: "đời sống tinh thần * giúp đỡ cả về vật chất lẫn tinh thần",
  },
  {
    word: "tinh thần",
    part_of_speech: "danh từ",
    meaning:
      "những thái độ, ý nghĩ định hướng cho hoạt động, quyết định hành động của con người (nói tổng quát): mất tinh thần * giữ vững tinh thần * chuẩn bị tinh thần",
    example: "mất tinh thần * giữ vững tinh thần * chuẩn bị tinh thần",
  },
  {
    word: "tinh thần",
    part_of_speech: "danh từ",
    meaning:
      "sự quan tâm thường xuyên trên cơ sở những nhận thức nhất định: tinh thần làm việc tốt * có tinh thần trách nhiệm cao",
    example: "tinh thần làm việc tốt * có tinh thần trách nhiệm cao",
  },
  {
    word: "tinh thần",
    part_of_speech: "danh từ",
    meaning:
      "cái sâu sắc nhất, cốt yếu nhất của một nội dung nào đó: tinh thần của bài thơ * nắm vững tinh thần của nghị quyết",
    example: "tinh thần của bài thơ * nắm vững tinh thần của nghị quyết",
  },
  {
    word: "tĩnh tâm",
    part_of_speech: "động từ",
    meaning:
      "giữ hoặc làm cho lòng mình thanh thản, không xao xuyến, xúc động: tĩnh tâm suy nghĩ",
    example: "tĩnh tâm suy nghĩ",
  },
  {
    word: "tỉnh táo",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái tỉnh, không buồn ngủ, không say, không mê (nói khái quát): người bệnh đã hoàn toàn tỉnh táo * nước mát làm tỉnh táo hẳn lên",
    example: "người bệnh đã hoàn toàn tỉnh táo * nước mát làm tỉnh táo hẳn lên",
  },
  {
    word: "tỉnh táo",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái vẫn minh mẫn, không để cho tình hình rắc rối, phức tạp tác động đến tư tưởng, tình cảm: đầu óc tỉnh táo * quá nóng giận nên mất tỉnh táo",
    example: "đầu óc tỉnh táo * quá nóng giận nên mất tỉnh táo",
  },
  {
    word: "tỉnh thành",
    part_of_speech: "danh từ",
    meaning:
      "nơi thành thị, trong quan hệ với thôn quê (nói khái quát): sống ở tỉnh thành",
    example: "sống ở tỉnh thành",
  },
  {
    word: "tình thâm",
    part_of_speech: "danh từ",
    meaning: "(cũ, hiếm) tình nghĩa sâu nặng: mẫu tử tình thâm",
    example: "mẫu tử tình thâm",
  },
  {
    word: "tình thế",
    part_of_speech: "danh từ",
    meaning:
      "tình hình và xu thế, về mặt có lợi hay không có lợi cho những hoạt động nào đó của con người: tình thế thuận lợi * lật ngược tình thế * tìm mọi cách hòng cứu vãn tình thế",
    example:
      "tình thế thuận lợi * lật ngược tình thế * tìm mọi cách hòng cứu vãn tình thế",
  },
  {
    word: "tình thế",
    part_of_speech: "tính từ",
    meaning:
      "(cách làm) có tính chất tạm thời, nhằm đối phó với một tình hình cụ thể trước mắt: giải pháp tình thế",
    example: "giải pháp tình thế",
  },
  {
    word: "tinh tế",
    part_of_speech: "tính từ",
    meaning: "tinh và tế nhị: lời nhận xét tinh tế * cảm nhận tinh tế",
    example: "lời nhận xét tinh tế * cảm nhận tinh tế",
  },
  {
    word: "tinh thể",
    part_of_speech: "danh từ",
    meaning:
      "vật rắn có những dạng hình học xác định: tinh thể muối * cấu trúc tinh thể",
    example: "tinh thể muối * cấu trúc tinh thể",
  },
  {
    word: "tĩnh thổ",
    part_of_speech: "danh từ",
    meaning: "(cũ) như tịnh độ: cõi tây thiên tĩnh thổ",
    example: "cõi tây thiên tĩnh thổ",
  },
  {
    word: "tinh thể học",
    part_of_speech: "danh từ",
    meaning:
      "khoa học nghiên cứu các tinh thể và trạng thái kết tinh của vật chất: nhà tinh thể học",
    example: "nhà tinh thể học",
  },
  {
    word: "tinh thể lỏng",
    part_of_speech: "danh từ",
    meaning:
      "chất lỏng có các đặc tính vật lí giống như tinh thể, rất nhạy cảm với điện trường hoặc từ trường: màn hình tinh thể lỏng",
    example: "màn hình tinh thể lỏng",
  },
  {
    word: "tình thực",
    part_of_speech: "tính từ",
    meaning: "hoặc d (hiếm) thật, đúng với sự thật: cứ tình thực mà nói",
    example: "cứ tình thực mà nói",
  },
  {
    word: "tình thực",
    part_of_speech: "tính từ",
    meaning: "hoặc p đúng sự thật là như vậy: tình thực tôi không có ác ý",
    example: "tình thực tôi không có ác ý",
  },
  {
    word: "tịnh tiến",
    part_of_speech: "động từ",
    meaning:
      "dời chỗ sao cho mỗi đường thẳng nối hai điểm bất kì của vật luôn luôn song song với chính nó: chuyển động tịnh tiến",
    example: "chuyển động tịnh tiến",
  },
  {
    word: "tịnh tiến",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tiến dần dần: phát triển theo hướng tịnh tiến * giá cả ngày một tịnh tiến",
    example: "phát triển theo hướng tịnh tiến * giá cả ngày một tịnh tiến",
  },
  {
    word: "tình thương",
    part_of_speech: "danh từ",
    meaning:
      "tình cảm thương yêu, chia sẻ và đùm bọc một cách thắm thiết: mái ấm tình thương * sống trong tình thương của cha mẹ",
    example: "mái ấm tình thương * sống trong tình thương của cha mẹ",
  },
  {
    word: "tình tiết",
    part_of_speech: "danh từ",
    meaning:
      "sự việc nhỏ trong quá trình diễn biến của sự kiện, tâm trạng: những tình tiết của vụ án * câu chuyện có nhiều tình tiết hấp dẫn",
    example:
      "những tình tiết của vụ án * câu chuyện có nhiều tình tiết hấp dẫn",
  },
  {
    word: "tính toán",
    part_of_speech: "động từ",
    meaning:
      "thực hiện các phép tính để biết, để thấy ra (nói khái quát): tính toán sổ sách * tính toán tiền nong * tính toán các khoản thu chi",
    example:
      "tính toán sổ sách * tính toán tiền nong * tính toán các khoản thu chi",
  },
  {
    word: "tính toán",
    part_of_speech: "động từ",
    meaning:
      "suy tính, cân nhắc trước khi làm việc gì: biết tính toán làm ăn * tính toán kĩ trước khi làm",
    example: "biết tính toán làm ăn * tính toán kĩ trước khi làm",
  },
  {
    word: "tính toán",
    part_of_speech: "động từ",
    meaning:
      "suy tính thiệt hơn cho cá nhân mình: tính toán hơn thiệt * con người tính toán",
    example: "tính toán hơn thiệt * con người tính toán",
  },
  {
    word: "tính tình",
    part_of_speech: "danh từ",
    meaning:
      "tổng thể nói chung những đặc điểm tâm lí - tình cảm của mỗi người, thể hiện trong cách đối xử với người, với việc: thay đổi tính tình * tính tình phóng khoáng",
    example: "thay đổi tính tình * tính tình phóng khoáng",
  },
  {
    word: "tinh thông",
    part_of_speech: "động từ",
    meaning:
      "hiểu biết tường tận, thấu đáo và có khả năng vận dụng thành thạo: tinh thông nghiệp vụ * võ nghệ tinh thông",
    example: "tinh thông nghiệp vụ * võ nghệ tinh thông",
  },
  {
    word: "tĩnh trí",
    part_of_speech: "động từ",
    meaning:
      "bình tĩnh và tỉnh táo để suy xét, xử trí: bình tâm tĩnh trí * cần phải tĩnh trí để ứng phó",
    example: "bình tâm tĩnh trí * cần phải tĩnh trí để ứng phó",
  },
  {
    word: "tính từ",
    part_of_speech: "danh từ",
    meaning:
      "(ngữ pháp) từ chuyên mô tả người (như đẹp, chín chắn) hoặc vật, sự vật (như to, nhỏ, khó khăn)",
    example: "đẹp, chín chắn",
  },
  {
    word: "tình trạng",
    part_of_speech: "danh từ",
    meaning:
      "tổng thể nói chung những hiện tượng không hoặc ít thay đổi, tồn tại trong một thời gian tương đối dài, xét về mặt bất lợi đối với đời sống hoặc những hoạt động nào đó của con người: tình trạng lạm phát * người bệnh đang trong tình trạng nguy kịch",
    example: "tình trạng lạm phát * người bệnh đang trong tình trạng nguy kịch",
  },
  {
    word: "tình trường",
    part_of_speech: "danh từ",
    meaning:
      "(Văn chương) cuộc tình ái, chuyện tình ái: phiêu lưu trong tình trường",
    example: "phiêu lưu trong tình trường",
  },
  {
    word: "tinh tú",
    part_of_speech: "danh từ",
    meaning: "sao trên trời (nói khái quát): các vì tinh tú",
    example: "các vì tinh tú",
  },
  {
    word: "tinh tuý",
    part_of_speech: "",
    meaning:
      "phần đã qua sàng lọc, thuần chất, tinh khiết và quý báu nhất: những tinh tuý của nhân loại * chắt lọc cái tinh tuý nhất của cuộc sống",
    example:
      "những tinh tuý của nhân loại * chắt lọc cái tinh tuý nhất của cuộc sống",
  },
  {
    word: "tinh tươm",
    part_of_speech: "tính từ",
    meaning:
      "tươm tất, đâu ra đấy: ăn mặc tinh tươm * cơm canh đã dọn tinh tươm",
    example: "ăn mặc tinh tươm * cơm canh đã dọn tinh tươm",
  },
  {
    word: "tình tự",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) tâm tình, tâm sự: "Bao nhiêu tình tự xưa nay, Tóc tơ giãi một chốn này là thôi!" (NĐM)',
    example:
      'Bao nhiêu tình tự xưa nay, Tóc tơ giãi một chốn này là thôi!" (NĐM)',
  },
  {
    word: "tình tự",
    part_of_speech: "động từ",
    meaning:
      "bày tỏ với nhau tình cảm yêu đương: đôi trai gái ngồi bên nhau tình tự",
    example: "đôi trai gái ngồi bên nhau tình tự",
  },
  {
    word: "tình tự",
    part_of_speech: "động từ",
    meaning: "(hiếm) kể lể, tâm sự riêng với nhau: hai mẹ con tình tự với nhau",
    example: "hai mẹ con tình tự với nhau",
  },
  {
    word: "tĩnh toạ",
    part_of_speech: "động từ",
    meaning:
      "ngồi yên lặng để ngẫm nghĩ về giáo lí của đạo Phật: sư cụ tĩnh toạ",
    example: "sư cụ tĩnh toạ",
  },
  {
    word: "tỉnh uỷ",
    part_of_speech: "danh từ",
    meaning: "ban chấp hành đảng bộ tỉnh: bí thư tỉnh uỷ",
    example: "bí thư tỉnh uỷ",
  },
  {
    word: "tình tứ",
    part_of_speech: "tính từ",
    meaning:
      "có những biểu hiện tình cảm yêu thương một cách tế nhị, đáng yêu (thường nói về tình cảm, quan hệ nam nữ): ánh mắt tình tứ * những lời tình tứ",
    example: "ánh mắt tình tứ * những lời tình tứ",
  },
  {
    word: "tinh tướng",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tỏ vẻ ta đây tinh khôn, tài giỏi hơn người (hàm ý chê bai hoặc vui đùa): đừng có mà tinh tướng!",
    example: "đừng có mà tinh tướng!",
  },
  {
    word: "tĩnh vật",
    part_of_speech: "danh từ",
    meaning:
      "vật không có khả năng tự chuyển dịch hoặc dao động trong không gian, về mặt là đối tượng thể hiện trong tác phẩm hội hoạ: tranh tĩnh vật",
    example: "tranh tĩnh vật",
  },
  {
    word: "tinh tường",
    part_of_speech: "tính từ",
    meaning:
      "tinh, có khả năng nhận biết nhanh nhạy và rõ ràng đến từng chi tiết nhỏ: đôi mắt tinh tường",
    example: "đôi mắt tinh tường",
  },
  {
    word: "tinh tường",
    part_of_speech: "tính từ",
    meaning:
      "rõ ràng, xác đáng đến từng chi tiết nhỏ: nhận xét tinh tường * giảng giải câu thành ngữ cho tinh tường",
    example: "nhận xét tinh tường * giảng giải câu thành ngữ cho tinh tường",
  },
  {
    word: "tinh vi",
    part_of_speech: "tính từ",
    meaning:
      "được cấu tạo bởi những chi tiết nhỏ phức tạp và có độ chính xác cao: nét chạm khắc tinh vi * máy móc tinh vi",
    example: "nét chạm khắc tinh vi * máy móc tinh vi",
  },
  {
    word: "tinh vi",
    part_of_speech: "tính từ",
    meaning:
      "có nội dung hoặc hình thức biểu hiện hết sức phức tạp, kín đáo, khó mà nhận ra: mánh khoé tinh vi * thủ đoạn bóc lột hết sức tinh vi",
    example: "mánh khoé tinh vi * thủ đoạn bóc lột hết sức tinh vi",
  },
  {
    word: "tinh vi",
    part_of_speech: "tính từ",
    meaning:
      "hoặc đg. (Khẩu ngữ) có vẻ hoặc tỏ ra vẻ ta đây, cái gì cũng biết, cái gì cũng giỏi: đừng có mà tinh vi!",
    example: "đừng có mà tinh vi!",
  },
  {
    word: "tinh vân",
    part_of_speech: "danh từ",
    meaning:
      "vệt sáng lờ mờ trên bầu trời ban đêm do những đám khí lẫn bụi phát sáng trong vũ trụ tạo nên hoặc do ánh sáng của những cụm sao dày đặc ở rất xa trong vũ trụ: đám tinh vân * vệt tinh vân",
    example: "đám tinh vân * vệt tinh vân",
  },
  {
    word: "tinh vệ",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) chim nhỏ trong một truyện thần thoại Trung Quốc (vốn là người con gái chết đuối ở biển hoá thành, ngày ngày ngậm đá lấp biển cho hả giận), dùng để tượng trưng cho nỗi uất ức sâu sắc: "Tình thâm, bể thẳm, lạ điều, Nào hồn tinh vệ biết theo chốn nào?" (TKiều)',
    example:
      'Tình thâm, bể thẳm, lạ điều, Nào hồn tinh vệ biết theo chốn nào?" (TKiều)',
  },
  {
    word: "tịnh vô",
    part_of_speech: "trợ từ",
    meaning: "(khẩu ngữ) như tịnh: tịnh vô không một bóng người",
    example: "tịnh vô không một bóng người",
  },
  {
    word: "tinh xảo",
    part_of_speech: "tính từ",
    meaning:
      "rất tinh vi và khéo léo: những hoạ tiết tinh xảo * máy móc tinh xảo",
    example: "những hoạ tiết tinh xảo * máy móc tinh xảo",
  },
  {
    word: "tình ý",
    part_of_speech: "danh từ",
    meaning:
      "tình cảm và ý định ấp ủ trong lòng, người khác chưa biết: dò xem tình ý * hiểu được tình ý của nhau",
    example: "dò xem tình ý * hiểu được tình ý của nhau",
  },
  {
    word: "tình ý",
    part_of_speech: "danh từ",
    meaning:
      "tình cảm yêu đương đang được giữ kín, chưa bộc lộ ra: hai người có tình ý với nhau",
    example: "hai người có tình ý với nhau",
  },
  {
    word: "tình ý",
    part_of_speech: "danh từ",
    meaning: "(hiếm) tư tưởng, tình cảm (trong văn nghệ): tình ý của bài thơ",
    example: "tình ý của bài thơ",
  },
  {
    word: "tinh xác",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) có độ chính xác rất cao, đến tận những chi tiết nhỏ: máy đo rất tinh xác * ngôn ngữ trong thơ ý vị và tinh xác",
    example: "máy đo rất tinh xác * ngôn ngữ trong thơ ý vị và tinh xác",
  },
  {
    word: "tinh ý",
    part_of_speech: "tính từ",
    meaning:
      "có khả năng nhận ra rất nhanh những cái kín đáo, khó nhận thấy: tinh ý phát hiện ra hàng giả * một con người tinh ý",
    example: "tinh ý phát hiện ra hàng giả * một con người tinh ý",
  },
  {
    word: "tình yêu",
    part_of_speech: "danh từ",
    meaning:
      "tình cảm yêu mến làm cho gắn bó mật thiết và có trách nhiệm với người, với vật: tình yêu đất nước * thắp lên tình yêu cuộc sống",
    example: "tình yêu đất nước * thắp lên tình yêu cuộc sống",
  },
  {
    word: "tình yêu",
    part_of_speech: "danh từ",
    meaning:
      "tình cảm yêu đương giữa nam và nữ: chuyện tình yêu * bày tỏ tình yêu",
    example: "chuyện tình yêu * bày tỏ tình yêu",
  },
  {
    word: "tịt",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) mẩn: muỗi đốt, nổi tịt đầy chân",
    example: "muỗi đốt, nổi tịt đầy chân",
  },
  {
    word: "tịt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ở trạng thái bị bịt kín hoàn toàn, không có chỗ hở thông ra với bên ngoài: đóng tịt cửa lại * lấp tịt cửa hang",
    example: "đóng tịt cửa lại * lấp tịt cửa hang",
  },
  {
    word: "tịt",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái bị làm cho hoàn toàn không có phần nào nhô lên, thò ra trên bề mặt cả: đóng tịt cái đinh vào tường * ấn tịt chiếc que xuống mặt đất",
    example: "đóng tịt cái đinh vào tường * ấn tịt chiếc que xuống mặt đất",
  },
  {
    word: "tịt",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái sát hẳn xuống dưới, tưởng như không còn thấy có chiều cao nữa: nhà cửa thấp tịt * người lùn tịt",
    example: "nhà cửa thấp tịt * người lùn tịt",
  },
  {
    word: "tịt",
    part_of_speech: "tính từ",
    meaning:
      "hoặc đg ở trạng thái không có hoặc không còn khả năng nào đó theo như bình thường, tựa như hoạt động hoặc tác dụng bị chặn hẳn lại: máy chạy được một lúc lại tịt * trả lời được mấy câu là tịt",
    example: "máy chạy được một lúc lại tịt * trả lời được mấy câu là tịt",
  },
  {
    word: "tịt",
    part_of_speech: "tính từ",
    meaning:
      "từ biểu thị mức độ triệt để của một hành vi nhằm tự tạo cho mình một trạng thái hoàn toàn tiêu cực: sợ quá, nhắm tịt mắt lại * ở tịt đấy, không về * biết nhưng cứ lờ tịt đi",
    example:
      "sợ quá, nhắm tịt mắt lại * ở tịt đấy, không về * biết nhưng cứ lờ tịt đi",
  },
  {
    word: "tít mắt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (mắt) tít lại vì thích thú, sung sướng; thường dùng để ví trạng thái say mê, thích thú đến mức không còn thấy được gì khác nữa: thích chí cười tít mắt * tít mắt vì tiền",
    example: "thích chí cười tít mắt * tít mắt vì tiền",
  },
  {
    word: "típ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ, hiếm) loại, hạng người có đặc điểm chung nào đó (hàm ý coi thường): ông thuộc típ người bảo thủ",
    example: "ông thuộc típ người bảo thủ",
  },
  {
    word: "tít",
    part_of_speech: "danh từ",
    meaning:
      "đầu đề bài báo, thường in chữ lớn: hàng tít lớn * đọc lướt qua các tít",
    example: "hàng tít lớn * đọc lướt qua các tít",
  },
  {
    word: "tít",
    part_of_speech: "tính từ",
    meaning: "(mắt) ở trạng thái khép gần như kín lại: cười tít mắt",
    example: "cười tít mắt",
  },
  {
    word: "tít",
    part_of_speech: "phụ từ",
    meaning:
      "(ở cách xa) đến mức như mắt không còn nhìn thấy rõ được nữa: bay tít lên trời * ở tít trên đỉnh núi * nhà ở tít mãi cuối xóm",
    example: "bay tít lên trời * ở tít trên đỉnh núi * nhà ở tít mãi cuối xóm",
  },
  {
    word: "tít",
    part_of_speech: "phụ từ",
    meaning:
      "(chuyển động quay nhanh) đến mức không còn nhìn thấy rõ hình thể của vật chuyển động nữa, mà trông nhoà hẳn đi: chiếc nón xoay tít * múa tít cái gậy * con chó ngoáy tít đuôi",
    example: "chiếc nón xoay tít * múa tít cái gậy * con chó ngoáy tít đuôi",
  },
  {
    word: "tít",
    part_of_speech: "phụ từ",
    meaning:
      "(quăn, xoắn) đến mức khó có thể nhận ra hình dáng, đường nét của vật nữa: tóc xoăn tít * chỉ rối tít * đám dây dợ xoắn tít vào nhau",
    example: "tóc xoăn tít * chỉ rối tít * đám dây dợ xoắn tít vào nhau",
  },
  {
    word: "tít",
    part_of_speech: "phụ từ",
    meaning:
      "(Khẩu ngữ) (say, mê) đến mức như không còn biết gì khác nữa: đặt lưng xuống là ngủ tít * mê tít * thích chí cười tít",
    example: "đặt lưng xuống là ngủ tít * mê tít * thích chí cười tít",
  },
  {
    word: "tịt mít",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) tịt, hoàn toàn không biết, không nhận thức được hoặc không nghĩ ra nổi: đầu óc tịt mít * hỏi gì cũng tịt mít, không trả lời được",
    example: "đầu óc tịt mít * hỏi gì cũng tịt mít, không trả lời được",
  },
  {
    word: "tịt ngòi",
    part_of_speech: "tính từ",
    meaning:
      "(thông tục) tịt hẳn, không còn nói gì được nữa: bị đuối lí nên tịt ngòi luôn",
    example: "bị đuối lí nên tịt ngòi luôn",
  },
  {
    word: "tịt mù",
    part_of_speech: "tính từ",
    meaning:
      '(hiếm) như tít mù: "Lầu canh chiêng lặng, điêu chìm, Tịt mù tăm cá bóng chim mấy trùng." (HT)',
    example:
      'Lầu canh chiêng lặng, điêu chìm, Tịt mù tăm cá bóng chim mấy trùng." (HT)',
  },
  {
    word: "tít mù",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) như tít (nhưng nghĩa mạnh hơn): xa tít mù * bay cao tít mù",
    example: "xa tít mù * bay cao tít mù",
  },
  {
    word: "tít mù tắp",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như tít tắp (nhưng nghĩa mạnh hơn): xa tít mù tắp",
    example: "xa tít mù tắp",
  },
  {
    word: "tít tắp",
    part_of_speech: "tính từ",
    meaning:
      "rất xa, rất dài, đến hết tầm nhìn của mắt: xa tít tắp * con đường dài tít tắp",
    example: "xa tít tắp * con đường dài tít tắp",
  },
  {
    word: "tiu nghỉu",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả vẻ xịu xuống do cụt hứng, buồn bã hoặc thất vọng vì điều xảy ra trái với dự tính ban đầu: mặt tiu nghỉu * thua nên đành tiu nghỉu rút lui",
    example: "mặt tiu nghỉu * thua nên đành tiu nghỉu rút lui",
  },
  {
    word: "tiu",
    part_of_speech: "danh từ",
    meaning:
      "nhạc khí gõ bằng đồng, hình cái bát úp (thường đánh cùng với cảnh): tiếng cảnh tiếng tiu",
    example: "tiếng cảnh tiếng tiu",
  },
  {
    word: "tiu",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) vụt (trong bóng bàn, quần vợt): tiu bóng",
    example: "tiu bóng",
  },
  {
    word: "tít thò lò",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) như tít (nhưng nghĩa mạnh hơn): quay tít thò lò * mê tít thò lò",
    example: "quay tít thò lò * mê tít thò lò",
  },
  {
    word: "tíu tít",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả những tiếng cười nói, hỏi han dồn dập không ngớt: chuyện trò tíu tít * lũ trẻ cười nói tíu tít",
    example: "chuyện trò tíu tít * lũ trẻ cười nói tíu tít",
  },
  {
    word: "tíu tít",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả vẻ bận rộn, tất bật, thường của nhiều người: bận tíu tít suốt ngày * tíu tít thu dọn đồ đạc",
    example: "bận tíu tít suốt ngày * tíu tít thu dọn đồ đạc",
  },
  {
    word: "tỏ",
    part_of_speech: "tính từ",
    meaning: "sáng rõ: trăng tỏ * ngọn đèn khi tỏ khi mờ",
    example: "trăng tỏ * ngọn đèn khi tỏ khi mờ",
  },
  {
    word: "tỏ",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) (mắt, tai người già) vẫn còn tinh, còn nhìn, nghe được rõ: già rồi nhưng mắt còn rất tỏ",
    example: "già rồi nhưng mắt còn rất tỏ",
  },
  {
    word: "tỏ",
    part_of_speech: "động từ",
    meaning:
      "hiểu rõ, biết rõ: tỏ lòng nhau * trong nhà chưa tỏ ngoài ngõ đã tường (tng)",
    example: "tỏ lòng nhau * trong nhà chưa tỏ ngoài ngõ đã tường (tng)",
  },
  {
    word: "tỏ",
    part_of_speech: "động từ",
    meaning:
      "bộc lộ, giãi bày cho người khác biết rõ: tỏ nỗi lòng * tỏ rõ nguồn cơn",
    example: "tỏ nỗi lòng * tỏ rõ nguồn cơn",
  },
  {
    word: "tỏ",
    part_of_speech: "động từ",
    meaning:
      "biểu hiện ra bằng cử chỉ, nét mặt, v.v., cho người khác thấy rõ: tỏ lòng biết ơn * tỏ thái độ thân thiện * đứa bé tỏ ra rất thông minh, tháo vát",
    example:
      "tỏ lòng biết ơn * tỏ thái độ thân thiện * đứa bé tỏ ra rất thông minh, tháo vát",
  },
  {
    word: "tó",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) nạng hoặc giá để chống, đỡ tạm thời: cây tó",
    example: "cây tó",
  },
  {
    word: "to",
    part_of_speech: "tính từ",
    meaning:
      "có kích thước, số lượng đáng kể hoặc hơn hẳn so với bình thường hay so với số lớn những cái cùng loại: to như cột đình * mở to mắt * tai to mặt lớn (tng)",
    example: "to như cột đình * mở to mắt * tai to mặt lớn (tng)",
  },
  {
    word: "to",
    part_of_speech: "tính từ",
    meaning:
      "(âm thanh) có cường độ mạnh, nghe rõ hơn bình thường: đọc to lên * hét thật to * càng quát đứa bé càng gào to",
    example: "đọc to lên * hét thật to * càng quát đứa bé càng gào to",
  },
  {
    word: "to",
    part_of_speech: "tính từ",
    meaning:
      "có mức đáng kể về sức mạnh, sức tác động, về phạm vi hay tầm quan trọng: cơn gió to * lập công to * quân địch bị thua to * lầm to",
    example: "cơn gió to * lập công to * quân địch bị thua to * lầm to",
  },
  {
    word: "to",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) (người) có địa vị, quyền hạn cao: làm quan to * giữ chức to",
    example: "làm quan to * giữ chức to",
  },
  {
    word: "to đùng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) rất to, to quá mức bình thường: bọc hàng to đùng * nồi cơm to đùng",
    example: "bọc hàng to đùng * nồi cơm to đùng",
  },
  {
    word: "tỏ bày",
    part_of_speech: "động từ",
    meaning: "(hiếm) như bày tỏ: tỏ bày tình cảm",
    example: "tỏ bày tình cảm",
  },
  {
    word: "to con",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) (người) có vóc dáng to, cao: dáng to con",
    example: "dáng to con",
  },
  {
    word: "to chuyện",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) thành chuyện to ra, gây lôi thôi, phiền phức: cố ý làm cho to chuyện",
    example: "cố ý làm cho to chuyện",
  },
  {
    word: "tò he",
    part_of_speech: "danh từ",
    meaning:
      "đồ chơi của trẻ em, thường có hình các con vật, được nặn bằng bột hấp chín, có nhuộm màu: nặn tò he",
    example: "nặn tò he",
  },
  {
    word: "to gan",
    part_of_speech: "tính từ",
    meaning:
      "có gan làm những việc nguy hiểm mà không hề sợ: a, thằng này to gan! dám cãi lại kia đấy",
    example: "a, thằng này to gan! dám cãi lại kia đấy",
  },
  {
    word: "to đầu",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) (người) đã lớn tuổi (hàm ý coi thường): to đầu mà dại",
    example: "to đầu mà dại",
  },
  {
    word: "to đầu",
    part_of_speech: "tính từ",
    meaning:
      "(người) thuộc loại cầm đầu, cỡ lớn (hàm ý coi khinh hoặc hài hước): tóm những đứa to đầu",
    example: "tóm những đứa to đầu",
  },
  {
    word: "to lớn",
    part_of_speech: "tính từ",
    meaning:
      "to và lớn (nói khái quát): sự kiện có ý nghĩa to lớn * sự hi sinh to lớn",
    example: "sự kiện có ý nghĩa to lớn * sự hi sinh to lớn",
  },
  {
    word: "to mồm",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) lớn tiếng và nhiều lời lấn át, tỏ ra chẳng kiêng nể gì ai: đã sai lại còn to mồm cãi",
    example: "đã sai lại còn to mồm cãi",
  },
  {
    word: "to kềnh",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) to quá mức, trông kềnh càng, không gọn: con kiến to kềnh * chữ viết to kềnh",
    example: "con kiến to kềnh * chữ viết to kềnh",
  },
  {
    word: "to kếch",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) to quá mức, trông xấu, mất cân đối: chiếc cặp da to kếch",
    example: "chiếc cặp da to kếch",
  },
  {
    word: "tò mò",
    part_of_speech: "",
    meaning:
      "thích tìm tòi, dò hỏi để biết bất cứ điều gì nhằm thoả mãn sự hiếu kì hoặc vì lòng ham muốn nào đó, cho dù việc đó có quan hệ hay không quan hệ đến mình: tính hay tò mò * tò mò chuyện riêng của người khác",
    example: "tính hay tò mò * tò mò chuyện riêng của người khác",
  },
  {
    word: "tò te",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) tỏ ra rất ngơ ngác: lính mới tò te * ngồi ngẩn tò te, không hiểu gì",
    example: "lính mới tò te * ngồi ngẩn tò te, không hiểu gì",
  },
  {
    word: "to tát",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) to (thường về cái trừu tượng; nói khái quát): việc to tát * chuyện ấy thì có gì to tát đâu!",
    example: "việc to tát * chuyện ấy thì có gì to tát đâu!",
  },
  {
    word: "to tướng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) rất to, hơn hẳn mức bình thường: nét chữ to tướng * bụng chửa to tướng",
    example: "nét chữ to tướng * bụng chửa to tướng",
  },
  {
    word: "to sụ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) to quá mức, vẻ nặng nề: chiếc ba lô to sụ * thu mình trong cái áo bông to sụ",
    example: "chiếc ba lô to sụ * thu mình trong cái áo bông to sụ",
  },
  {
    word: "to nhỏ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nói nhỏ với nhau chuyện nọ chuyện kia, vẻ bí mật (nói khái quát): rì rầm to nhỏ * con gái to nhỏ với mẹ",
    example: "rì rầm to nhỏ * con gái to nhỏ với mẹ",
  },
  {
    word: "tỏ tường",
    part_of_speech: "tính từ",
    meaning: "rõ ràng, tường tận: nói cho tỏ tường * biết tỏ tường",
    example: "nói cho tỏ tường * biết tỏ tường",
  },
  {
    word: "tỏ vẻ",
    part_of_speech: "động từ",
    meaning:
      "biểu hiện ra bề ngoài một thái độ hay một trạng thái tình cảm nào đó cho người khác thấy rõ: chau mày tỏ vẻ khó chịu * tỏ vẻ ta đây",
    example: "chau mày tỏ vẻ khó chịu * tỏ vẻ ta đây",
  },
  {
    word: "to tiếng",
    part_of_speech: "tính từ",
    meaning: "lớn tiếng cãi cọ nhau: vợ chồng to tiếng với nhau",
    example: "vợ chồng to tiếng với nhau",
  },
  {
    word: "tỏ tình",
    part_of_speech: "động từ",
    meaning:
      "bày tỏ cho người mình yêu biết tình cảm của mình đối với người ấy: lời tỏ tình * làm thơ tỏ tình",
    example: "lời tỏ tình * làm thơ tỏ tình",
  },
  {
    word: "toả",
    part_of_speech: "động từ",
    meaning:
      "(từ một điểm) lan truyền ra khắp xung quanh: hoa toả hương thơm ngát * hơi ấm toả đi khắp cơ thể",
    example: "hoa toả hương thơm ngát * hơi ấm toả đi khắp cơ thể",
  },
  {
    word: "toả",
    part_of_speech: "động từ",
    meaning:
      "(từ một điểm) phân tán ra về các phía, các hướng khác nhau: đoàn biểu tình toả về các phố",
    example: "đoàn biểu tình toả về các phố",
  },
  {
    word: "toả",
    part_of_speech: "động từ",
    meaning:
      "buông trùm xuống trên một diện tích tương đối rộng: cây đa toả bóng mát",
    example: "cây đa toả bóng mát",
  },
  {
    word: "tò vò",
    part_of_speech: "danh từ",
    meaning:
      "loài ong nhỏ có cuống bụng dài, làm tổ bằng đất nhão bám trên vách hay mái nhà, thường bắt nhện và các sâu bọ khác làm thức ăn dự trữ cho con non: tổ tò vò",
    example: "tổ tò vò",
  },
  {
    word: "tò vò",
    part_of_speech: "danh từ",
    meaning: "hình vòng cung, giống như hình tổ tò vò: cổng tò vò * cửa tò vò",
    example: "cổng tò vò * cửa tò vò",
  },
  {
    word: "toa",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận của phương tiện vận tải có đầu máy kéo chạy trên đường ray, dùng để chở người hoặc hàng hoá: toa tàu * mua vé ở toa số 5",
    example: "toa tàu * mua vé ở toa số 5",
  },
  {
    word: "toa",
    part_of_speech: "danh từ",
    meaning: "(cũ, hoặc ph) đơn (thuốc): toa thuốc * uống thuốc theo toa",
    example: "toa thuốc * uống thuốc theo toa",
  },
  {
    word: "to xù",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) to quá cỡ và thô, không đẹp: một nắm giẻ to xù * cái áo lông to xù",
    example: "một nắm giẻ to xù * cái áo lông to xù",
  },
  {
    word: "toà",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị những công trình xây dựng có quy mô lớn: toà nhà cao tầng * toà lâu đài",
    example: "toà nhà cao tầng * toà lâu đài",
  },
  {
    word: "toà",
    part_of_speech: "danh từ",
    meaning: "toà án (nói tắt): toà tối cao * lôi nhau ra toà",
    example: "toà tối cao * lôi nhau ra toà",
  },
  {
    word: "toà",
    part_of_speech: "danh từ",
    meaning:
      "toàn thể nói chung những người ngồi xét xử trong phiên toà: toà tuyên án chung thân * được toà xử trắng án",
    example: "toà tuyên án chung thân * được toà xử trắng án",
  },
  {
    word: "toà",
    part_of_speech: "danh từ",
    meaning: "toà sen (nói tắt).",
    example: "sự thật trần trụi",
  },
  {
    word: "toá",
    part_of_speech: "động từ",
    meaning: "(hiếm) như túa: bọn trẻ chạy toá ra các ngả",
    example: "bọn trẻ chạy toá ra các ngả",
  },
  {
    word: "toạ đàm",
    part_of_speech: "động từ",
    meaning:
      "họp mặt để cùng nhau trao đổi ý kiến về một vấn đề nào đó: buổi toạ đàm về văn học",
    example: "buổi toạ đàm về văn học",
  },
  {
    word: "toạ đăng",
    part_of_speech: "danh từ",
    meaning: "đèn để bàn loại to, thắp bằng dầu hoả: đèn toạ đăng",
    example: "đèn toạ đăng",
  },
  {
    word: "toạ độ",
    part_of_speech: "danh từ",
    meaning:
      "mỗi số trong một hệ thống số dùng để xác định vị trí của một điểm trên một đường, một mặt hay trong không gian: xác định toạ độ chính xác * đánh bom toạ độ",
    example: "xác định toạ độ chính xác * đánh bom toạ độ",
  },
  {
    word: "toà án",
    part_of_speech: "danh từ",
    meaning:
      "cơ quan nhà nước có nhiệm vụ xét xử các vụ phạm pháp, kiện tụng: toà án tối cao * lời kết tội của toà án * toà án lương tâm",
    example: "toà án tối cao * lời kết tội của toà án * toà án lương tâm",
  },
  {
    word: "toà soạn",
    part_of_speech: "danh từ",
    meaning:
      "trụ sở của một cơ quan báo chí: gửi bài về toà soạn * toà soạn báo Lao Động",
    example: "gửi bài về toà soạn * toà soạn báo Lao Động",
  },
  {
    word: "toà soạn",
    part_of_speech: "danh từ",
    meaning:
      "ban phụ trách biên tập của một tờ báo hoặc tạp chí: lời toà soạn * tên bài do toà soạn đặt",
    example: "lời toà soạn * tên bài do toà soạn đặt",
  },
  {
    word: "toạ lạc",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) (nhà cửa, đất đai) ở tại nơi nào đó: ngôi chùa toạ lạc trên một quả đồi",
    example: "ngôi chùa toạ lạc trên một quả đồi",
  },
  {
    word: "toả nhiệt",
    part_of_speech: "động từ",
    meaning:
      "(hiện tượng) toả nhiệt lượng ra môi trường xung quanh: bộ toả nhiệt của động cơ * sự toả nhiệt của cơ thể",
    example: "bộ toả nhiệt của động cơ * sự toả nhiệt của cơ thể",
  },
  {
    word: "toạ thiền",
    part_of_speech: "động từ",
    meaning:
      "ngồi im lặng theo kiểu riêng, giữ cho thân và tâm không động, theo đạo Phật: sự cụ toạ thiền",
    example: "sự cụ toạ thiền",
  },
  {
    word: "toà sen",
    part_of_speech: "danh từ",
    meaning:
      "chỗ ngồi tôn nghiêm của Phật tạc hình hoa sen; cũng dùng để chỉ Phật, theo cách gọi của những người theo đạo Phật: Phật ngự toà sen * vào chầu toà sen",
    example: "Phật ngự toà sen * vào chầu toà sen",
  },
  {
    word: "toà thánh",
    part_of_speech: "danh từ",
    meaning:
      "nơi giáo hoàng ở và làm việc, và cũng là nơi đặt cơ quan cao nhất của Giáo hội Công giáo: toà thánh Vatican",
    example: "toà thánh Vatican",
  },
  {
    word: "toa xe",
    part_of_speech: "danh từ",
    meaning: "toa (nói khái quát): hệ thống toa xe mới của đoàn tàu",
    example: "hệ thống toa xe mới của đoàn tàu",
  },
  {
    word: "toạc",
    part_of_speech: "động từ",
    meaning:
      "rách to, thường theo chiều dài: áo bị toạc vai * nén bạc đâm toạc tờ giấy (tng)",
    example: "áo bị toạc vai * nén bạc đâm toạc tờ giấy (tng)",
  },
  {
    word: "toài",
    part_of_speech: "động từ",
    meaning:
      "nằm sấp áp sát mặt đất, dùng sức hai khuỷu tay và hai mũi bàn chân đẩy người đi: chiến sĩ học lăn, lê, bò, toài",
    example: "chiến sĩ học lăn, lê, bò, toài",
  },
  {
    word: "toài",
    part_of_speech: "động từ",
    meaning: "(hiếm) như nhoài: cầu thủ toài người đỡ bóng",
    example: "cầu thủ toài người đỡ bóng",
  },
  {
    word: "toác",
    part_of_speech: "động từ",
    meaning:
      "nứt, vỡ thành đường, thành mảng lớn: mặt bàn bị nứt toác * vết thương toác miệng",
    example: "mặt bàn bị nứt toác * vết thương toác miệng",
  },
  {
    word: "toác",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) (mồm, miệng) mở ra quá rộng, trông không đẹp mắt: toác miệng ra cười",
    example: "toác miệng ra cười",
  },
  {
    word: "toàn",
    part_of_speech: "danh từ",
    meaning:
      "tất cả, bao gồm mọi thành phần tạo nên chỉnh thể: nhân dân toàn thế giới * nội dung toàn bài",
    example: "nhân dân toàn thế giới * nội dung toàn bài",
  },
  {
    word: "toàn",
    part_of_speech: "tính từ",
    meaning:
      "(cũ) nguyên vẹn, không mảy may suy suyển, mất mát: chết chẳng toàn thây * giữ cho toàn danh tiết",
    example: "chết chẳng toàn thây * giữ cho toàn danh tiết",
  },
  {
    word: "toàn",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị mức độ nhiều và chỉ thuần một thứ, một loại, không xen lẫn thứ khác, loại khác: nói toàn những lời sáo rỗng * cánh đồng toàn một màu xanh",
    example: "nói toàn những lời sáo rỗng * cánh đồng toàn một màu xanh",
  },
  {
    word: "toại",
    part_of_speech: "động từ",
    meaning:
      "được đầy đủ như mong muốn: công thành danh toại (tng) * có đi có lại mới toại lòng nhau (tng)",
    example:
      "công thành danh toại (tng) * có đi có lại mới toại lòng nhau (tng)",
  },
  {
    word: "toán",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp gồm một số người cùng làm một việc gì: toán thợ * một toán trẻ con",
    example: "toán thợ * một toán trẻ con",
  },
  {
    word: "toán",
    part_of_speech: "danh từ",
    meaning: "như phép tính (ng1; nói khái quát): làm toán",
    example: "làm toán",
  },
  {
    word: "toán",
    part_of_speech: "danh từ",
    meaning: "toán học (nói tắt): giỏi toán * khoa toán * giáo viên dạy toán",
    example: "giỏi toán * khoa toán * giáo viên dạy toán",
  },
  {
    word: "toàn bích",
    part_of_speech: "tính từ",
    meaning:
      "(văn chương) hay, đẹp hoàn toàn, không thể chê trách một chỗ nào (tựa hòn ngọc đẹp, nguyên vẹn, không có chút tì vết): bài thơ toàn bích",
    example: "bài thơ toàn bích",
  },
  {
    word: "toại nguyện",
    part_of_speech: "động từ",
    meaning:
      "được thoả mãn nguyện vọng, được như mong muốn: con cái hạnh phúc, thành đạt là cha mẹ được toại nguyện",
    example: "con cái hạnh phúc, thành đạt là cha mẹ được toại nguyện",
  },
  {
    word: "toan",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) acid: chất toan",
    example: "chất toan",
  },
  {
    word: "toan",
    part_of_speech: "động từ",
    meaning:
      "có ý định thực hiện ngay điều gì đó (nhưng đã không làm được): toan làm phản * mấy lần toan nói nhưng lại thôi",
    example: "toan làm phản * mấy lần toan nói nhưng lại thôi",
  },
  {
    word: "toàn bộ",
    part_of_speech: "danh từ",
    meaning:
      "tất cả các phần, các bộ phận của một chỉnh thể: thừa kế toàn bộ gia sản * tập trung toàn bộ nhân lực",
    example: "thừa kế toàn bộ gia sản * tập trung toàn bộ nhân lực",
  },
  {
    word: "toàn cảnh",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ nói chung những sự vật, hiện tượng có thể bao quát nhìn thấy được ở một nơi, một lúc nào đó: ảnh chụp toàn cảnh sân vận động",
    example: "ảnh chụp toàn cảnh sân vận động",
  },
  {
    word: "toàn cầu hoá",
    part_of_speech: "động từ",
    meaning:
      "làm cho trở thành rộng lớn, trên phạm vi toàn cầu: quá trình toàn cầu hoá nền kinh tế thế giới",
    example: "quá trình toàn cầu hoá nền kinh tế thế giới",
  },
  {
    word: "toàn cầu",
    part_of_speech: "danh từ",
    meaning:
      "cả thế giới, trên phạm vi toàn thế giới: chiến lược toàn cầu * vấn đề mang tính toàn cầu * nổi tiếng khắp toàn cầu",
    example:
      "chiến lược toàn cầu * vấn đề mang tính toàn cầu * nổi tiếng khắp toàn cầu",
  },
  {
    word: "toàn cục",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ tình hình chung: xét trên toàn cục * có cái nhìn toàn cục",
    example: "xét trên toàn cục * có cái nhìn toàn cục",
  },
  {
    word: "toán đố",
    part_of_speech: "danh từ",
    meaning:
      "bài toán đòi hỏi phải làm những phép tính để từ những đại lượng đã cho tìm ra đại lượng chưa biết: giải bài toán đố",
    example: "giải bài toán đố",
  },
  {
    word: "toàn mĩ",
    part_of_speech: "tính từ",
    meaning: "(hiếm) hoàn toàn tốt đẹp: kết quả toàn mĩ",
    example: "kết quả toàn mĩ",
  },
  {
    word: "toàn lực",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ sức lực có được: tập trung toàn lực * dốc toàn lực ra làm",
    example: "tập trung toàn lực * dốc toàn lực ra làm",
  },
  {
    word: "toàn mỹ",
    part_of_speech: "tính từ",
    meaning: "(hiếm) hoàn toàn tốt đẹp: kết quả toàn mĩ",
    example: "kết quả toàn mĩ",
  },
  {
    word: "toàn diện",
    part_of_speech: "",
    meaning:
      "đầy đủ các mặt, không thiếu mặt nào: đổi mới toàn diện * cơ thể phát triển toàn diện",
    example: "đổi mới toàn diện * cơ thể phát triển toàn diện",
  },
  {
    word: "toàn phần",
    part_of_speech: "tính từ",
    meaning: "đủ cả các phần: nhật thực toàn phần",
    example: "nhật thực toàn phần",
  },
  {
    word: "toàn năng",
    part_of_speech: "tính từ",
    meaning:
      "có khả năng làm thành thạo mọi việc trong phạm vi một nghề nào đó: thi thợ giỏi toàn năng * đấng toàn năng (Chúa Trời)",
    example: "thi thợ giỏi toàn năng * đấng toàn năng (Chúa Trời)",
  },
  {
    word: "toàn tâm toàn ý",
    part_of_speech: "",
    meaning:
      "hoàn toàn để hết tâm trí, tinh thần và sức lực vào (làm một công việc chung nào đó): toàn tâm toàn ý với sự nghiệp văn chương",
    example: "toàn tâm toàn ý với sự nghiệp văn chương",
  },
  {
    word: "toàn quốc",
    part_of_speech: "danh từ",
    meaning:
      "(trang trọng) cả nước: toàn quốc kháng chiến * phát động thi đua trên toàn quốc",
    example: "toàn quốc kháng chiến * phát động thi đua trên toàn quốc",
  },
  {
    word: "toàn tập",
    part_of_speech: "danh từ",
    meaning:
      "bộ sách in đầy đủ tất cả các tác phẩm của một tác gia: tác phẩm 'Hồ Chí Minh toàn tập'",
    example: "tác phẩm 'Hồ Chí Minh toàn tập'",
  },
  {
    word: "toàn quyền",
    part_of_speech: "danh từ",
    meaning:
      "quyền hành, quyền lực đầy đủ để giải quyết công việc: được toàn quyền quyết định * toàn quyền sở hữu ngôi nhà",
    example: "được toàn quyền quyết định * toàn quyền sở hữu ngôi nhà",
  },
  {
    word: "toàn quyền",
    part_of_speech: "danh từ",
    meaning:
      "người đứng đầu bộ máy cai trị, đại diện cho chính quốc ở một nước thuộc địa hoặc phụ thuộc: toàn quyền Pháp ở Đông Dương",
    example: "toàn quyền Pháp ở Đông Dương",
  },
  {
    word: "toàn thiện toàn mĩ",
    part_of_speech: "",
    meaning:
      "hoàn toàn tốt đẹp; đạt tới đỉnh cao của cái tốt, cái đẹp: nghệ thuật luôn hướng tới cái toàn thiện toàn mĩ",
    example: "nghệ thuật luôn hướng tới cái toàn thiện toàn mĩ",
  },
  {
    word: "toàn thắng",
    part_of_speech: "động từ",
    meaning:
      "thắng hoàn toàn: ngày toàn thắng * chiến dịch Hồ Chí Minh toàn thắng",
    example: "ngày toàn thắng * chiến dịch Hồ Chí Minh toàn thắng",
  },
  {
    word: "toàn thể",
    part_of_speech: "danh từ",
    meaning:
      "tất cả mọi thành viên: toàn thể nhân dân * thay mặt cho toàn thể bà con trong xóm",
    example: "toàn thể nhân dân * thay mặt cho toàn thể bà con trong xóm",
  },
  {
    word: "toàn thể",
    part_of_speech: "danh từ",
    meaning:
      "cái chung, bao gồm tất cả các bộ phận có liên quan chặt chẽ với nhau trong một chỉnh thể: có cái nhìn toàn thể * xét trên toàn thể",
    example: "có cái nhìn toàn thể * xét trên toàn thể",
  },
  {
    word: "toan tính",
    part_of_speech: "động từ",
    meaning:
      "suy nghĩ, tính toán nhằm thực hiện việc gì: toan tính chuyện làm ăn",
    example: "toan tính chuyện làm ăn",
  },
  {
    word: "toàn thân",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ cơ thể con người: bị bỏng toàn thân * sợ quá, toàn thân run lên bần bật",
    example: "bị bỏng toàn thân * sợ quá, toàn thân run lên bần bật",
  },
  {
    word: "toàn thiện toàn mỹ",
    part_of_speech: "",
    meaning:
      "hoàn toàn tốt đẹp; đạt tới đỉnh cao của cái tốt, cái đẹp: nghệ thuật luôn hướng tới cái toàn thiện toàn mĩ",
    example: "nghệ thuật luôn hướng tới cái toàn thiện toàn mĩ",
  },
  {
    word: "toàn tòng",
    part_of_speech: "tính từ",
    meaning:
      "(địa phương) có tất cả các gia đình đều theo Công giáo: xứ đạo toàn tòng",
    example: "xứ đạo toàn tòng",
  },
  {
    word: "toàn văn",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ văn bản, không lược bớt: đọc toàn văn báo cáo * đăng toàn văn bài phát biểu",
    example: "đọc toàn văn báo cáo * đăng toàn văn bài phát biểu",
  },
  {
    word: "toàn vẹn",
    part_of_speech: "tính từ",
    meaning:
      "hoàn toàn đầy đủ các thành phần, không thiếu hụt, không mất mát: toàn vẹn lãnh thổ",
    example: "toàn vẹn lãnh thổ",
  },
  {
    word: "toang hoang",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (cửa ngõ) để mở toang, do thiếu cẩn thận: nhà cửa để toang hoang",
    example: "nhà cửa để toang hoang",
  },
  {
    word: "toang hoang",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như tan hoang: đập phá toang hoang",
    example: "đập phá toang hoang",
  },
  {
    word: "toang",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có độ mở, độ hở rộng hết cỡ, trông như banh cả ra: cửa mở toang * quần áo rách toang",
    example: "cửa mở toang * quần áo rách toang",
  },
  {
    word: "toang",
    part_of_speech: "tính từ",
    meaning:
      "bị tan ra từng mảnh, không còn nguyên vẹn: nổ toang * cái lọ rơi xuống đất, vỡ toang",
    example: "nổ toang * cái lọ rơi xuống đất, vỡ toang",
  },
  {
    word: "toang",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như toáng: la toang lên",
    example: "la toang lên",
  },
  {
    word: "toang hoác",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có độ mở, độ hở quá mức cần thiết, để lộ cả ra ngoài, trông chướng mắt: cửa mở toang hoác * miệng vết thương toang hoác",
    example: "cửa mở toang hoác * miệng vết thương toang hoác",
  },
  {
    word: "toang toác",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng nứt, vỡ mạnh của vật rắn, nghe to và chói tai: gỗ nứt toang toác * tre nứa cháy nổ toang toác",
    example: "gỗ nứt toang toác * tre nứa cháy nổ toang toác",
  },
  {
    word: "toang toác",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) từ gợi tả tiếng nói to, nói nhiều, nghe chói tai, khó chịu: nói toang toác * cứ toang toác cái mồm!",
    example: "nói toang toác * cứ toang toác cái mồm!",
  },
  {
    word: "toát",
    part_of_speech: "động từ",
    meaning:
      "(từ bên trong) thoát ra bên ngoài nhiều trên khắp một diện rộng, qua những lỗ rất nhỏ (thường nói về mồ hôi): hơi ấm toát ra từ cơ thể * mồ hôi toát ra đầm đìa",
    example: "hơi ấm toát ra từ cơ thể * mồ hôi toát ra đầm đìa",
  },
  {
    word: "toát",
    part_of_speech: "động từ",
    meaning:
      "(yếu tố tinh thần) biểu hiện rõ ra bên ngoài: đôi mắt toát lên vẻ thông minh",
    example: "đôi mắt toát lên vẻ thông minh",
  },
  {
    word: "toáng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ầm ĩ lên cho nhiều người biết, không chút giữ gìn, giấu giếm: hét toáng cả nhà * sợ quá khóc toáng lên * chưa chi đã làm toáng cả lên!",
    example:
      "hét toáng cả nhà * sợ quá khóc toáng lên * chưa chi đã làm toáng cả lên!",
  },
  {
    word: "tóc bạc da mồi",
    part_of_speech: "",
    meaning:
      'tả người già cả, da lốm đốm những chấm màu nâu nhạt như mai con đồi mồi, tóc bạc như sương tuyết: "Tủi thay tóc bạc da mồi, Vì ai nên phải đứng ngồi chẳng khuây?" (QÂTK)',
    example:
      'Tủi thay tóc bạc da mồi, Vì ai nên phải đứng ngồi chẳng khuây?" (QÂTK)',
  },
  {
    word: "toang toang",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) từ gợi tả lối nói năng lớn tiếng và không chút giữ gìn, nghe khó chịu: cười nói toang toang",
    example: "cười nói toang toang",
  },
  {
    word: "tóc đuôi gà",
    part_of_speech: "danh từ",
    meaning:
      'dải tóc để trần thòng ra phía sau (tựa như đuôi con gà) ở đầu người phụ nữ có tóc cuộn vào trong khăn và vấn thành một cái vòng quanh đầu (một kiểu vấn tóc của phụ nữ thời trước): "Chị kia bới tóc đuôi gà, Nghiêng tai hỏi nhỏ cửa nhà chị đâu?" (ca dao)',
    example:
      'Chị kia bới tóc đuôi gà, Nghiêng tai hỏi nhỏ cửa nhà chị đâu?" (ca dao)',
  },
  {
    word: "tóc",
    part_of_speech: "danh từ",
    meaning:
      "lông mọc ở phần trên và sau của đầu người từ trán vòng đến gáy: cắt tóc * mái tóc suôn dài",
    example: "cắt tóc * mái tóc suôn dài",
  },
  {
    word: "tóc",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) dây tóc (nói tắt): bóng đèn đứt tóc",
    example: "bóng đèn đứt tóc",
  },
  {
    word: "toáy",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) cuống lên: giục toáy lên * làm gì mà cứ toáy lên thế!",
    example: "giục toáy lên * làm gì mà cứ toáy lên thế!",
  },
  {
    word: "tọc mạch",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) như thóc mách: tính hay tọc mạch",
    example: "tính hay tọc mạch",
  },
  {
    word: "tóc sương",
    part_of_speech: "danh từ",
    meaning:
      '(văn chương) tóc bạc trắng như sương; chỉ người già, tuổi già: "Chốc đà mười mấy năm trời, Còn ra khi đã da mồi tóc sương." (TKiều)',
    example:
      'Chốc đà mười mấy năm trời, Còn ra khi đã da mồi tóc sương." (TKiều)',
  },
  {
    word: "tóc tai",
    part_of_speech: "danh từ",
    meaning: "tóc (nói khái quát; hàm ý chê): tóc tai rũ rượi",
    example: "tóc tai rũ rượi",
  },
  {
    word: "toe",
    part_of_speech: "tính từ",
    meaning: "từ mô phỏng tiếng còi, tiếng kèn thổi: tiếng còi ô tô toe toe",
    example: "tiếng còi ô tô toe toe",
  },
  {
    word: "tóc thề",
    part_of_speech: "danh từ",
    meaning:
      'tóc của thiếu nữ dài chấm ngang vai: "Tóc thề đã chấm ngang vai, Nào lời non nước, nào lời sắt son?" (TKiều)',
    example:
      'Tóc thề đã chấm ngang vai, Nào lời non nước, nào lời sắt son?" (TKiều)',
  },
  {
    word: "toè",
    part_of_speech: "động từ",
    meaning:
      "(đầu nhọn) bị xoè ra, chẽ rộng ra, thường do bị sức đè mạnh, đập mạnh: ngón chân cái toè ra * ngòi bút đã bị toè",
    example: "ngón chân cái toè ra * ngòi bút đã bị toè",
  },
  {
    word: "tóc tơ",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) sợi tóc và sợi tơ (nói khái quát); dùng để ví những phần, những điểm rất nhỏ trong nội dung sự việc hoặc hiện tượng: "Chuyện trò chưa cạn tóc tơ, Gà đà gáy sáng, trời vừa rạng đông." (TKiều)',
    example:
      'Chuyện trò chưa cạn tóc tơ, Gà đà gáy sáng, trời vừa rạng đông." (TKiều)',
  },
  {
    word: "tóc tơ",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) việc kết tóc xe tơ; chỉ tình duyên vợ chồng: "Kiều nhi phận mỏng như tờ, Một lời đã lỗi tóc tơ với chàng!" (TKiều)',
    example:
      'Kiều nhi phận mỏng như tờ, Một lời đã lỗi tóc tơ với chàng!" (TKiều)',
  },
  {
    word: "toẽ",
    part_of_speech: "động từ",
    meaning:
      "tách nhau ra để từ một điểm phân ra thành nhiều hướng: đám người toẽ ra hai ngả",
    example: "đám người toẽ ra hai ngả",
  },
  {
    word: "tóc xanh",
    part_of_speech: "danh từ",
    meaning:
      '(văn chương) tóc còn đen; chỉ người còn trẻ, tuổi trẻ: "Đêm năm canh, ngày cũng năm canh, Thương người tuổi trẻ tóc xanh lỡ chừng." (ca dao)',
    example:
      'Đêm năm canh, ngày cũng năm canh, Thương người tuổi trẻ tóc xanh lỡ chừng." (ca dao)',
  },
  {
    word: "toé",
    part_of_speech: "động từ",
    meaning:
      "bắn vung ra, văng mạnh ra các phía: nước toé lên người * những nhát búa toé lửa * ngón chân toé máu",
    example: "nước toé lên người * những nhát búa toé lửa * ngón chân toé máu",
  },
  {
    word: "toé",
    part_of_speech: "động từ",
    meaning:
      "bật mạnh, tản nhanh ra nhiều phía, thường do hốt hoảng: thấy động, đàn chim bay toé lên",
    example: "thấy động, đàn chim bay toé lên",
  },
  {
    word: "toé phở",
    part_of_speech: "tính từ",
    meaning:
      "(thông tục) khó nhọc, vất vả đến mức như không chịu đựng nổi: đi được đến nơi thì cũng toé phở * làm toé phở mới kịp",
    example: "đi được đến nơi thì cũng toé phở * làm toé phở mới kịp",
  },
  {
    word: "toe toét",
    part_of_speech: "động từ",
    meaning: "(miệng) mở rộng quá cỡ sang hai bên khi cười nói: cười toe toét",
    example: "cười toe toét",
  },
  {
    word: "toe toét",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như nhoe nhoét: bàn tay toe toét những mực",
    example: "bàn tay toe toét những mực",
  },
  {
    word: "toé khói",
    part_of_speech: "phụ từ",
    meaning:
      "(thông tục) đến mức như không chịu đựng nổi: chửi cho một trận toé khói",
    example: "chửi cho một trận toé khói",
  },
  {
    word: "toé loe",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) toé vung ra trên phạm vi rộng: cháo đổ toé loe * vụ việc toé loe ra, ai cũng biết (b)",
    example: "cháo đổ toé loe * vụ việc toé loe ra, ai cũng biết (b)",
  },
  {
    word: "toèn toẹt",
    part_of_speech: "tính từ",
    meaning: "như toẹt (nhưng với ý liên tiếp): nhổ nước bọt toèn toẹt",
    example: "nhổ nước bọt toèn toẹt",
  },
  {
    word: "toẹt",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng nhổ hoặc tiếng hắt nước mạnh: nhổ toẹt bãi nước bọt * hắt toẹt cốc nước ra sân",
    example: "nhổ toẹt bãi nước bọt * hắt toẹt cốc nước ra sân",
  },
  {
    word: "toẹt",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) (làm việc gì) một cách dứt khoát, thẳng thắn, không cần lưỡng lự, giữ gìn: bài văn bị gạch toẹt đi * cứ nói toẹt ra, cần gì phải úp mở",
    example: "bài văn bị gạch toẹt đi * cứ nói toẹt ra, cần gì phải úp mở",
  },
  {
    word: "toét",
    part_of_speech: "động từ",
    meaning: "mở rộng miệng ra cười một cách tự nhiên: toét miệng ra cười",
    example: "toét miệng ra cười",
  },
  {
    word: "toét",
    part_of_speech: "tính từ",
    meaning:
      "(mắt) bị đau, hai bờ mi sưng đỏ, luôn luôn ướt: mắt toét * khói làm toét cả mắt",
    example: "mắt toét * khói làm toét cả mắt",
  },
  {
    word: "toét",
    part_of_speech: "tính từ",
    meaning:
      "bị giập nát đến mức không còn rõ hình thù gì nữa: cọc tre bị đóng toét đầu * cơm nát toét",
    example: "cọc tre bị đóng toét đầu * cơm nát toét",
  },
  {
    word: "toen hoẻn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) nhỏ hẹp đến mức coi như không đáng kể: mảnh sân toen hoẻn * cái hầm nông toen hoẻn",
    example: "mảnh sân toen hoẻn * cái hầm nông toen hoẻn",
  },
  {
    word: "toét nhèm",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) (mắt) toét và dính ướt, khó nhìn: mắt toét nhèm",
    example: "mắt toét nhèm",
  },
  {
    word: "toi",
    part_of_speech: "động từ",
    meaning:
      "(gia súc, gia cầm) chết nhiều một lúc vì bệnh dịch lan nhanh: cả đàn gà toi sạch",
    example: "cả đàn gà toi sạch",
  },
  {
    word: "toi",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) chết (hàm ý coi khinh): toi đời * làm ăn như thế thì toi cả nút",
    example: "toi đời * làm ăn như thế thì toi cả nút",
  },
  {
    word: "toi",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) mất một cách uổng phí: phí tiền toi * mất công toi * thế là đi toi món tiền",
    example: "phí tiền toi * mất công toi * thế là đi toi món tiền",
  },
  {
    word: "toi dịch",
    part_of_speech: "danh từ",
    meaning:
      "hiện tượng có dịch làm chết nhiều gia súc, gia cầm cùng một lúc (nói khái quát): phòng toi dịch cho gia cầm",
    example: "phòng toi dịch cho gia cầm",
  },
  {
    word: "toi cơm",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) phí cả cơm đã nuôi ăn mà không được việc gì: nuôi nó chỉ tổ toi cơm! * một lũ toi cơm! (tiếng chửi mắng)",
    example: "nuôi nó chỉ tổ toi cơm! * một lũ toi cơm! (tiếng chửi mắng)",
  },
  {
    word: "tòi",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) ló ra, hiện ra bên ngoài vật bao bọc: áo rách tòi cả bông ra ngoài * từ dưới nước tòi đầu lên",
    example: "áo rách tòi cả bông ra ngoài * từ dưới nước tòi đầu lên",
  },
  {
    word: "tòi",
    part_of_speech: "động từ",
    meaning:
      "đưa ra, để lộ ra một cách bất đắc dĩ: nói mãi nó mới tòi ra mấy đồng * việc đó trước sau gì rồi cũng tòi ra",
    example:
      "nói mãi nó mới tòi ra mấy đồng * việc đó trước sau gì rồi cũng tòi ra",
  },
  {
    word: "tom",
    part_of_speech: "tính từ",
    meaning: "từ mô phỏng tiếng trống chầu trong hát ả đào: trống điểm tom tom",
    example: "trống điểm tom tom",
  },
  {
    word: "tóm",
    part_of_speech: "động từ",
    meaning:
      "chộp nhanh và nắm chặt lấy trong tay, không để cho tuột đi: tóm tay * tóm áo giữ lại * tóm lấy thời cơ",
    example: "tóm tay * tóm áo giữ lại * tóm lấy thời cơ",
  },
  {
    word: "tóm",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) bắt giữ, bắt lấy: tóm gọn cả toán cướp * tóm được thằng kẻ cắp",
    example: "tóm gọn cả toán cướp * tóm được thằng kẻ cắp",
  },
  {
    word: "tóm",
    part_of_speech: "động từ",
    meaning:
      "rút gọn, thu gọn lại cho dễ nắm điểm chính, ý chính: nói tóm một câu * tóm lại, mọi việc đang tiến triển tốt",
    example: "nói tóm một câu * tóm lại, mọi việc đang tiến triển tốt",
  },
  {
    word: "tõm",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng vật nhỏ và nặng rơi gọn xuống nước: hòn đá rơi tõm xuống ao",
    example: "hòn đá rơi tõm xuống ao",
  },
  {
    word: "tóm tắt",
    part_of_speech: "động từ",
    meaning:
      "rút ngắn, thu gọn, chỉ nêu những điểm chính: trình bày tóm tắt * tóm tắt ý kiến",
    example: "trình bày tóm tắt * tóm tắt ý kiến",
  },
  {
    word: "tóm tắt",
    part_of_speech: "danh từ",
    meaning: "bản tóm tắt, đoạn tóm tắt: nộp tóm tắt của luận án",
    example: "nộp tóm tắt của luận án",
  },
  {
    word: "toi mạng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) chết một cách vô ích (hàm ý coi khinh): chết toi mạng * sơ sẩy một tí là toi mạng!",
    example: "chết toi mạng * sơ sẩy một tí là toi mạng!",
  },
  {
    word: "tòm",
    part_of_speech: "tính từ",
    meaning: "như tùm: rơi tòm xuống ao",
    example: "rơi tòm xuống ao",
  },
  {
    word: "tom góp",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) như gom góp: tom góp tiền bạc",
    example: "tom góp tiền bạc",
  },
  {
    word: "tóm cổ",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) bắt giữ: bọn cướp đã bị tóm cổ",
    example: "bọn cướp đã bị tóm cổ",
  },
  {
    word: "tóm tém",
    part_of_speech: "động từ",
    meaning:
      "từ gợi tả dáng vẻ cử động đôi môi khẽ và liên tiếp như để thu lại, chúm lại: bà lão tóm tém cười * tóm tém nhai trầu",
    example: "bà lão tóm tém cười * tóm tém nhai trầu",
  },
  {
    word: "tóm lược",
    part_of_speech: "động từ",
    meaning:
      "nêu lại những điểm chính, quan trọng nhất, bỏ qua các chi tiết, để có được cái nhìn tổng thể: tóm lược một số ý chính * tóm lược nội dung bản báo cáo",
    example: "tóm lược một số ý chính * tóm lược nội dung bản báo cáo",
  },
  {
    word: "tóm lược",
    part_of_speech: "tính từ",
    meaning:
      "có những nét cơ bản, chủ yếu nhất, do đã được tóm lược: bản báo cáo tóm lược * chỉ cần nêu tóm lược, không cần cụ thể",
    example: "bản báo cáo tóm lược * chỉ cần nêu tóm lược, không cần cụ thể",
  },
  {
    word: "tòm tem",
    part_of_speech: "động từ",
    meaning:
      '(thông tục) gạ gẫm chuyện tình dục (nói về người đàn ông): "Đương khi lửa tắt cơm sôi, Lợn kêu con khóc chồng đòi tòm tem." (ca dao)',
    example:
      'Đương khi lửa tắt cơm sôi, Lợn kêu con khóc chồng đòi tòm tem." (ca dao)',
  },
  {
    word: "ton hót",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) hót với người trên một cách khéo léo nhằm tâng công, lấy lòng người ấy và làm hại người khác: tính hay ton hót * ton hót mọi chuyện với chủ",
    example: "tính hay ton hót * ton hót mọi chuyện với chủ",
  },
  {
    word: "tòm tõm",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng vật nhỏ và nặng rơi liên tiếp xuống nước: sung chín rụng tòm tõm xuống nước",
    example: "sung chín rụng tòm tõm xuống nước",
  },
  {
    word: "ton ton",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả dáng đi, chạy nhanh với vẻ vội vàng: chân bước ton ton * đứa bé ton ton chạy theo mẹ",
    example: "chân bước ton ton * đứa bé ton ton chạy theo mẹ",
  },
  {
    word: "tọng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) cho vào một chỗ nào đó và dồn xuống cho thật đầy, thật chặt: tọng giẻ vào mồm * tọng cát vào bao",
    example: "tọng giẻ vào mồm * tọng cát vào bao",
  },
  {
    word: "tọng",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) ăn một cách thô tục, tham lam, chỉ cốt cho được nhiều: tọng cho đầy dạ dày",
    example: "tọng cho đầy dạ dày",
  },
  {
    word: "tòng chinh",
    part_of_speech: "động từ",
    meaning: "(cũ) vào quân đội, đi chinh chiến: lên đường tòng chinh",
    example: "lên đường tòng chinh",
  },
  {
    word: "tong",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) mất đứt đi, không còn tí gì: mất tong cả buổi * mấy sào lúa đi tong vì mưa bão",
    example: "mất tong cả buổi * mấy sào lúa đi tong vì mưa bão",
  },
  {
    word: "tòng phạm",
    part_of_speech: "danh từ",
    meaning:
      "người cùng tham gia một hành động phạm pháp: bắt cả thủ phạm và tòng phạm * kẻ tòng phạm",
    example: "bắt cả thủ phạm và tòng phạm * kẻ tòng phạm",
  },
  {
    word: "tòng phu",
    part_of_speech: "động từ",
    meaning:
      "(cũ) theo chồng, hoàn toàn phục tùng chồng (một nguyên tắc của lễ giáo phong kiến ràng buộc người phụ nữ): xuất giá tòng phu * đạo tòng phu",
    example: "xuất giá tòng phu * đạo tòng phu",
  },
  {
    word: "tòng quân",
    part_of_speech: "động từ",
    meaning: "vào quân đội: lên đường tòng quân",
    example: "lên đường tòng quân",
  },
  {
    word: "tong tả",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả dáng đi nhanh, vội: đi tong tả * tong tả quẩy gánh đi chợ",
    example: "đi tong tả * tong tả quẩy gánh đi chợ",
  },
  {
    word: "tòng sự",
    part_of_speech: "động từ",
    meaning: "(cũ) làm việc tại một công sở nào đó: tòng sự tại phủ Thống Sứ",
    example: "tòng sự tại phủ Thống Sứ",
  },
  {
    word: "tòng tọc",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (máy móc, xe cộ) cũ, hay hỏng, chạy xộc xệch: chiếc xe đạp tòng tọc",
    example: "chiếc xe đạp tòng tọc",
  },
  {
    word: "tong teo",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) gầy đét: gầy tong teo",
    example: "gầy tong teo",
  },
  {
    word: "tong tong",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả tiếng như tiếng nước nhỏ nhanh, đều đều từ trên cao xuống: nước nhỏ tong tong xuống chậu",
    example: "nước nhỏ tong tong xuống chậu",
  },
  {
    word: "tong tỏng",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả tiếng như tiếng nước nhỏ hoặc chảy thành dòng nhỏ liên tiếp từ trên cao xuống: nhà dột, nước mưa nhỏ xuống tong tỏng",
    example: "nhà dột, nước mưa nhỏ xuống tong tỏng",
  },
  {
    word: "tóp",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái bị bé đi và nhăn nhúm, do khô héo hoặc do gầy: quả cam héo tóp * đói quá, bụng tóp lại",
    example: "quả cam héo tóp * đói quá, bụng tóp lại",
  },
  {
    word: "tóp",
    part_of_speech: "danh từ",
    meaning:
      "phần xác còn lại của vật sau khi đã lấy hết chất, hết nước: tóp mỡ * tóp chanh * nó mà bắt được thì có mà ra tóp (kng)",
    example: "tóp mỡ * tóp chanh * nó mà bắt được thì có mà ra tóp (kng)",
  },
  {
    word: "tóp",
    part_of_speech: "động từ",
    meaning:
      "ép bên ngoài cho lỗ của một vật rỗng nhỏ lại: tóp ống quần * tóp khung xe đạp",
    example: "tóp ống quần * tóp khung xe đạp",
  },
  {
    word: "tọp",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái gầy tóp hẳn đi: ốm lâu nên người tọp hẳn * gầy tọp đi",
    example: "ốm lâu nên người tọp hẳn * gầy tọp đi",
  },
  {
    word: "top",
    part_of_speech: "danh từ",
    meaning:
      "vị trí được bình chọn là cao nhất: bài hát đã lọt vào top 5 ca khúc hay nhất",
    example: "bài hát đã lọt vào top 5 ca khúc hay nhất",
  },
  {
    word: "toòng teng",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả trạng thái lủng lẳng, dễ đu đưa qua lại: cái túi treo toòng teng ở ghi đông",
    example: "cái túi treo toòng teng ở ghi đông",
  },
  {
    word: "toòng teng",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) hoa tai hình dài, dễ đu đưa qua lại: tai đeo toòng teng",
    example: "tai đeo toòng teng",
  },
  {
    word: "top ten",
    part_of_speech: "",
    meaning:
      "mười vị trí được bình chọn là cao nhất: đứng đầu bảng top ten * ca khúc được lọt vào top ten năm 2004",
    example: "đứng đầu bảng top ten * ca khúc được lọt vào top ten năm 2004",
  },
  {
    word: "tóp tép",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng như tiếng nhai thong thả vật mềm: nhai trầu tóp tép",
    example: "nhai trầu tóp tép",
  },
  {
    word: "tóp tòm tọp",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) như tóp tọp (nhưng ý nhấn mạnh hơn): ốm mấy tháng, người tóp tòm tọp",
    example: "ốm mấy tháng, người tóp tòm tọp",
  },
  {
    word: "tóp tọp",
    part_of_speech: "tính từ",
    meaning: "như tọp (nhưng nghĩa mạnh hơn): hai má tóp tọp",
    example: "hai má tóp tọp",
  },
  {
    word: "tót",
    part_of_speech: "động từ",
    meaning:
      "di chuyển tới một nơi khác bằng động tác rất nhanh, gọn và đột ngột: leo tót lên giường * chạy tót đi chơi * vừa ở đây đã tót đi đâu mất",
    example:
      "leo tót lên giường * chạy tót đi chơi * vừa ở đây đã tót đi đâu mất",
  },
  {
    word: "tót vời",
    part_of_speech: "tính từ",
    meaning:
      '(cũ, văn chương) tuyệt vời: "Phong tư tài mạo tót vời, Vào trong thanh nhã, ra ngoài hào hoa." (TKiều)',
    example:
      'Phong tư tài mạo tót vời, Vào trong thanh nhã, ra ngoài hào hoa." (TKiều)',
  },
  {
    word: "tọt",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) di chuyển vào nơi kín đáo bằng động tác rất nhanh, gọn: con chuột tọt vội vào hang * nhanh chân tọt xuống hầm",
    example: "con chuột tọt vội vào hang * nhanh chân tọt xuống hầm",
  },
  {
    word: "tọt",
    part_of_speech: "phụ từ",
    meaning:
      "bằng một động tác nhanh và đột ngột: sợ quá, chạy tọt vào nhà * bỏ tọt miếng bánh vào miệng",
    example: "sợ quá, chạy tọt vào nhà * bỏ tọt miếng bánh vào miệng",
  },
  {
    word: "tố",
    part_of_speech: "danh từ",
    meaning:
      'gió mạnh đổi chiều đột ngột xảy ra trong cơn dông: "Mây gặp rồng, cơn dông cơn tố, Cá gặp nước, cơn ngược cơn xuôi." (Cdao)',
    example:
      'Mây gặp rồng, cơn dông cơn tố, Cá gặp nước, cơn ngược cơn xuôi." (Cdao)',
  },
  {
    word: "tố",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) nói công khai cho mọi người biết việc làm sai trái, phạm pháp của người khác: tố tội ác của cường hào ác bá",
    example: "tố tội ác của cường hào ác bá",
  },
  {
    word: "tổ",
    part_of_speech: "danh từ",
    meaning:
      "chỗ thường được che chắn bằng rơm rác, lá cây, v.v. để làm nơi ở, đẻ, nuôi con của một số loài vật: chim làm tổ * đầu rối như tổ quạ * kiến tha lâu cũng đầy tổ (tng)",
    example:
      "chim làm tổ * đầu rối như tổ quạ * kiến tha lâu cũng đầy tổ (tng)",
  },
  {
    word: "tổ",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp một số người cùng làm một công việc, theo một tổ chức nhất định: tổ kĩ thuật * tổ trinh sát * lớp chia thành bốn tổ",
    example: "tổ kĩ thuật * tổ trinh sát * lớp chia thành bốn tổ",
  },
  {
    word: "tổ",
    part_of_speech: "danh từ",
    meaning: "tổ dân phố (nói tắt): nhà số 15 tổ 4",
    example: "nhà số 15 tổ 4",
  },
  {
    word: "tổ",
    part_of_speech: "danh từ",
    meaning:
      "người được coi như là người đầu tiên, lập ra một dòng họ: ngôi mộ tổ * nhà thờ tổ * giỗ tổ",
    example: "ngôi mộ tổ * nhà thờ tổ * giỗ tổ",
  },
  {
    word: "tổ",
    part_of_speech: "danh từ",
    meaning:
      "người sáng lập, gây dựng ra một nghề, một sự nghiệp hoặc một môn phái: ông tổ nghề đúc đồng",
    example: "ông tổ nghề đúc đồng",
  },
  {
    word: "tổ",
    part_of_speech: "trợ từ",
    meaning:
      "(khẩu ngữ) từ biểu thị ý nhấn mạnh mức độ của một hậu quả tất yếu của hành động, trạng thái vừa nói đến: nói lắm chỉ tổ mỏi mồm!",
    example: "nói lắm chỉ tổ mỏi mồm!",
  },
  {
    word: "tô",
    part_of_speech: "danh từ",
    meaning: "(cũ) địa tô (nói tắt): nộp tô * thực hiện chính sách giảm tô",
    example: "nộp tô * thực hiện chính sách giảm tô",
  },
  {
    word: "tô",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) bát ô tô: một tô phở * tô canh",
    example: "một tô phở * tô canh",
  },
  {
    word: "tô",
    part_of_speech: "động từ",
    meaning:
      "làm cho nổi rõ các đường nét hoặc mảng màu đã có sẵn bằng mực hoặc màu: tô chữ cho đậm * tô màu cho tranh * môi tô son",
    example: "tô chữ cho đậm * tô màu cho tranh * môi tô son",
  },
  {
    word: "tổ ấm",
    part_of_speech: "danh từ",
    meaning:
      "ví cảnh gia đình đầm ấm, hoà thuận, thương yêu gắn bó với nhau: tổ ấm gia đình * xây tổ ấm",
    example: "tổ ấm gia đình * xây tổ ấm",
  },
  {
    word: "tồ",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) tỏ ra vụng về, khờ khạo, thiếu hẳn sự nhanh nhẹn, linh hoạt, không tương xứng với tuổi hay vóc người: thằng bé rất tồ * càng lớn càng tồ",
    example: "thằng bé rất tồ * càng lớn càng tồ",
  },
  {
    word: "tộ",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) tô to bằng sành, sứ, miệng rộng: ăn hết một tộ cháo",
    example: "ăn hết một tộ cháo",
  },
  {
    word: "tổ bố",
    part_of_speech: "tính từ",
    meaning: "(thông tục) to quá mức bình thường: đôi giày to tổ bố",
    example: "đôi giày to tổ bố",
  },
  {
    word: "tố cáo",
    part_of_speech: "động từ",
    meaning:
      "vạch trần hành động xấu xa, phạm pháp hay tội ác trước cơ quan có thẩm quyền hoặc trước dư luận: tố cáo kẻ gian * viết đơn tố cáo",
    example: "tố cáo kẻ gian * viết đơn tố cáo",
  },
  {
    word: "tổ cha",
    part_of_speech: "",
    meaning:
      '(phương ngữ, khẩu ngữ) tiếng chửi; thường dùng làm tiếng chửi yêu trẻ con: "Tổ cha cái nợ phong trần, Không vay mà trả cực thân thế này!" (ca dao)',
    example:
      'Tổ cha cái nợ phong trần, Không vay mà trả cực thân thế này!" (ca dao)',
  },
  {
    word: "tố chất",
    part_of_speech: "danh từ",
    meaning: "yếu tố cơ bản có trong con người: đứa bé có tố chất thông minh",
    example: "đứa bé có tố chất thông minh",
  },
  {
    word: "tổ chảng",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ, khẩu ngữ) to quá mức thường thấy: đĩa xôi to tổ chảng",
    example: "đĩa xôi to tổ chảng",
  },
  {
    word: "tổ đỉa",
    part_of_speech: "danh từ",
    meaning:
      "cây mọc dại ở bờ nước, lá nhỏ, trông xơ xác; thường dùng để ví tình trạng rách rưới, lôi thôi, nham nhở: rách như tổ đỉa",
    example: "rách như tổ đỉa",
  },
  {
    word: "tổ chức",
    part_of_speech: "động từ",
    meaning:
      "sắp xếp, bố trí cho thành một chỉnh thể, có một cấu tạo, một cấu trúc và những chức năng chung nhất định: tổ chức bộ máy hành chính * tổ chức lại đội ngũ cán bộ",
    example: "tổ chức bộ máy hành chính * tổ chức lại đội ngũ cán bộ",
  },
  {
    word: "tổ chức",
    part_of_speech: "động từ",
    meaning:
      "sắp xếp, bố trí cho thành có trật tự, có nền nếp: tổ chức đời sống * tổ chức lại nề nếp sinh hoạt trong gia đình",
    example: "tổ chức đời sống * tổ chức lại nề nếp sinh hoạt trong gia đình",
  },
  {
    word: "tổ chức",
    part_of_speech: "động từ",
    meaning:
      "làm những gì cần thiết để tiến hành một hoạt động nào đó nhằm có được hiệu quả tốt nhất: tổ chức mít tinh * tổ chức sinh nhật",
    example: "tổ chức mít tinh * tổ chức sinh nhật",
  },
  {
    word: "tổ chức",
    part_of_speech: "động từ",
    meaning:
      "làm công tác tổ chức của cơ quan và công tác cán bộ: phòng tổ chức * cán bộ tổ chức của công ti",
    example: "phòng tổ chức * cán bộ tổ chức của công ti",
  },
  {
    word: "tổ chức",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đưa vào, kết nạp vào một tổ chức nào đó: tổ chức người vào Đảng",
    example: "tổ chức người vào Đảng",
  },
  {
    word: "tổ chức",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tổ chức lễ cưới (nói tắt): hai người định cuối năm tổ chức",
    example: "hai người định cuối năm tổ chức",
  },
  {
    word: "tổ chức",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp người được tổ chức lại, hoạt động vì những quyền lợi chung, nhằm một mục đích chung: tổ chức thương mại thế giới * một tổ chức phi chính phủ",
    example: "tổ chức thương mại thế giới * một tổ chức phi chính phủ",
  },
  {
    word: "tổ chức",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức chính trị - xã hội có kỉ luật chặt chẽ, trong quan hệ với các thành viên của nó: có ý thức tổ chức * làm theo sự phân công của tổ chức",
    example: "có ý thức tổ chức * làm theo sự phân công của tổ chức",
  },
  {
    word: "tô điểm",
    part_of_speech: "động từ",
    meaning:
      "làm cho có thêm màu sắc, cho đẹp hơn: tô điểm mặt mày * tiếng hát tô điểm cuộc đời",
    example: "tô điểm mặt mày * tiếng hát tô điểm cuộc đời",
  },
  {
    word: "tô hô",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (cơ thể) ở trạng thái để phơi bày ra một cách lộ liễu những chỗ cần được che kín: cởi truồng tô hô",
    example: "cởi truồng tô hô",
  },
  {
    word: "tô giới",
    part_of_speech: "danh từ",
    meaning:
      "phần đất (thường là trong một thành phố) của một nước nửa thuộc địa buộc phải cắt nhường cho một nước đế quốc: tô giới Pháp * tô giới Anh ở Thượng Hải",
    example: "tô giới Pháp * tô giới Anh ở Thượng Hải",
  },
  {
    word: "tố giác",
    part_of_speech: "động từ",
    meaning:
      "báo cho cơ quan chính quyền biết người hoặc hành động phạm pháp nào đó: đơn tố giác * tố giác kẻ phạm tội",
    example: "đơn tố giác * tố giác kẻ phạm tội",
  },
  {
    word: "tô hồng",
    part_of_speech: "động từ",
    meaning:
      "tô vẽ hoặc trình bày thêm thắt vào, nhằm làm cho tốt đẹp quá sự thật: tô hồng cuộc sống * không tô hồng kết quả",
    example: "tô hồng cuộc sống * không tô hồng kết quả",
  },
  {
    word: "tổ hợp",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận của máy điện thoại, dùng để nghe và nói: áp chặt ống tổ hợp vào tai",
    example: "áp chặt ống tổ hợp vào tai",
  },
  {
    word: "tổ hợp",
    part_of_speech: "danh từ",
    meaning:
      "cái gồm nhiều thành phần kết hợp với nhau theo những quy tắc nhất định: tổ hợp âm thanh * tổ hợp danh từ",
    example: "tổ hợp âm thanh * tổ hợp danh từ",
  },
  {
    word: "tổ hợp",
    part_of_speech: "danh từ",
    meaning:
      "tổ hợp sản xuất (nói tắt): tổ hợp may mặc * tổ hợp sửa chữa, bảo hành xe máy",
    example: "tổ hợp may mặc * tổ hợp sửa chữa, bảo hành xe máy",
  },
  {
    word: "tô lục chuốt hồng",
    part_of_speech: "",
    meaning:
      '(cũ, văn chương) như tô son điểm phấn: "Mụ càng tô lục chuốt hồng, Máu tham hễ thấy hơi đồng thì mê." (TKiều)',
    example:
      'Mụ càng tô lục chuốt hồng, Máu tham hễ thấy hơi đồng thì mê." (TKiều)',
  },
  {
    word: "tổ khúc",
    part_of_speech: "danh từ",
    meaning:
      "hình thức âm nhạc gồm nhiều khúc nhạc nối tiếp nhau: tổ khúc múa * tổ khúc dân ca",
    example: "tổ khúc múa * tổ khúc dân ca",
  },
  {
    word: "tố nga",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) người con gái đẹp: "Đầu lòng hai ả tố nga, Thuý Kiều là chị, em là Thuý Vân." (TKiều)',
    example:
      'Đầu lòng hai ả tố nga, Thuý Kiều là chị, em là Thuý Vân." (TKiều)',
  },
  {
    word: "tố nữ",
    part_of_speech: "danh từ",
    meaning: "(cũ) như tố nga: tranh tố nữ",
    example: "tranh tố nữ",
  },
  {
    word: "tổ phụ",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) ông nội hoặc ông ngoại; cũng thường dùng để chỉ ông bà, tổ tiên, nói chung: phụng thờ tổ phụ * đất của tổ phụ để lại",
    example: "phụng thờ tổ phụ * đất của tổ phụ để lại",
  },
  {
    word: "tô nô",
    part_of_speech: "danh từ",
    meaning:
      "thùng gỗ lớn, hình trụ, bụng phình, hai mặt đáy được đóng kín, dùng để đựng một số mặt hàng khi chuyên chở: một tô nô rượu",
    example: "một tô nô rượu",
  },
  {
    word: "tổ quốc",
    part_of_speech: "danh từ",
    meaning:
      "đất nước, được bao đời trước xây dựng và để lại, trong quan hệ với những người dân có tình cảm gắn bó với nó: bảo vệ tổ quốc * lá cờ tổ quốc",
    example: "bảo vệ tổ quốc * lá cờ tổ quốc",
  },
  {
    word: "tổ tôm",
    part_of_speech: "danh từ",
    meaning:
      "trò chơi bằng bài lá có một trăm hai mươi quân, do năm người chơi: chơi tổ tôm * đánh tổ tôm",
    example: "chơi tổ tôm * đánh tổ tôm",
  },
  {
    word: "tổ sư",
    part_of_speech: "danh từ",
    meaning:
      "ông tổ lập ra một giáo phái hoặc lập ra một nghề (thường được người đời sau tôn thờ): tổ sư phái Trúc Lâm * tổ sư nghề dệt",
    example: "tổ sư phái Trúc Lâm * tổ sư nghề dệt",
  },
  {
    word: "tổ sư",
    part_of_speech: "danh từ",
    meaning: "(thông tục) từ dùng làm tiếng chửi: tổ sư nhà mày!",
    example: "tổ sư nhà mày!",
  },
  {
    word: "tổ tiên",
    part_of_speech: "danh từ",
    meaning:
      "tổng thể nói chung những người coi là thuộc những thế hệ đầu tiên, qua đời đã lâu, của một dòng họ hay một dân tộc, trong quan hệ với các thế hệ sau này: thờ cúng tổ tiên * phần đất của tổ tiên để lại",
    example: "thờ cúng tổ tiên * phần đất của tổ tiên để lại",
  },
  {
    word: "tồ tồ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) từ mô phỏng tiếng nước chảy từ trên cao xuống thành dòng mạnh: nước chảy tồ tồ",
    example: "nước chảy tồ tồ",
  },
  {
    word: "tố tụng",
    part_of_speech: "động từ",
    meaning:
      "tiến hành các hoạt động khởi tố, điều tra, truy tố, xét xử các vụ án hình sự: tiến hành tố tụng * luật tố tụng hình sự",
    example: "tiến hành tố tụng * luật tố tụng hình sự",
  },
  {
    word: "tốc",
    part_of_speech: "động từ",
    meaning:
      "lật tung lên, lật ngược lên cái đang che phủ: nhà bị tốc mái * tốc chăn vùng dậy",
    example: "nhà bị tốc mái * tốc chăn vùng dậy",
  },
  {
    word: "tốc",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) tốc độ (nói tắt): cho xe tăng tốc * hộp giảm tốc",
    example: "cho xe tăng tốc * hộp giảm tốc",
  },
  {
    word: "tô vẽ",
    part_of_speech: "động từ",
    meaning:
      'tô và vẽ; thường dùng để chỉ hành động bịa đặt để thêm thắt vào nhằm làm cho có được cái vẻ hay hơn, tốt đẹp hơn: "Cuộc sống (...) quê Xoá đẹp một vẻ đẹp nguyên chất, không tô vẽ, không cường điệu." (MVKháng; 8)',
    example:
      'Cuộc sống (...) quê Xoá đẹp một vẻ đẹp nguyên chất, không tô vẽ, không cường điệu." (MVKháng; 8)',
  },
  {
    word: "tộc",
    part_of_speech: "danh từ",
    meaning: "(Từ cũ) họ: người trong tộc * tru di tam tộc",
    example: "người trong tộc * tru di tam tộc",
  },
  {
    word: "tổ trưởng",
    part_of_speech: "danh từ",
    meaning:
      "người đứng đầu điều hành công việc của một tổ: tổ trưởng tổ kĩ thuật",
    example: "tổ trưởng tổ kĩ thuật",
  },
  {
    word: "tốc chiến tốc thắng",
    part_of_speech: "",
    meaning:
      "đánh nhanh nhằm thắng nhanh trong chiến tranh: nắm vững thời cơ để tốc chiến tốc thắng",
    example: "nắm vững thời cơ để tốc chiến tốc thắng",
  },
  {
    word: "tốc độ",
    part_of_speech: "danh từ",
    meaning:
      "độ nhanh, nhịp độ của quá trình vận động, phát triển: xe chạy hết tốc độ * tốc độ tăng trưởng kinh tế * tốc độ âm thanh",
    example:
      "xe chạy hết tốc độ * tốc độ tăng trưởng kinh tế * tốc độ âm thanh",
  },
  {
    word: "tốc hành",
    part_of_speech: "tính từ",
    meaning:
      "(phương tiện vận tải) chạy tuyến đường dài với tốc độ nhanh và ít đỗ dọc đường: chuyến xe tốc hành * tàu tốc hành",
    example: "chuyến xe tốc hành * tàu tốc hành",
  },
  {
    word: "tốc ký",
    part_of_speech: "động từ",
    meaning:
      "ghi nhanh theo kịp lời nói bằng hệ thống kí hiệu đơn giản: kĩ năng tốc kí của các phóng viên",
    example: "kĩ năng tốc kí của các phóng viên",
  },
  {
    word: "tốc lực",
    part_of_speech: "danh từ",
    meaning:
      "sức chạy nhanh (của máy móc): xe chạy với tốc lực 60 kilomet một giờ * máy chạy hết tốc lực",
    example: "xe chạy với tốc lực 60 kilomet một giờ * máy chạy hết tốc lực",
  },
  {
    word: "tốc kí",
    part_of_speech: "động từ",
    meaning:
      "ghi nhanh theo kịp lời nói bằng hệ thống kí hiệu đơn giản: kĩ năng tốc kí của các phóng viên",
    example: "kĩ năng tốc kí của các phóng viên",
  },
  {
    word: "tộc người",
    part_of_speech: "danh từ",
    meaning:
      "cộng đồng người có tên gọi, địa vực cư trú, ngôn ngữ, đặc điểm sinh hoạt và văn hoá riêng (có thể là một bộ lạc, một bộ tộc hay một dân tộc): tộc người Chăm",
    example: "tộc người Chăm",
  },
  {
    word: "tôi",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người đi ở hầu hạ cho chủ trong xã hội cũ: làm tôi cho một nhà giàu",
    example: "làm tôi cho một nhà giàu",
  },
  {
    word: "tôi",
    part_of_speech: "danh từ",
    meaning:
      "quan, phục vụ cho vua, trong quan hệ với vua: người tôi trung * quan hệ vua - tôi",
    example: "người tôi trung * quan hệ vua - tôi",
  },
  {
    word: "tôi",
    part_of_speech: "động từ",
    meaning:
      "nung hợp kim đến nhiệt độ nhất định, rồi làm nguội thật nhanh để tăng độ rắn và độ bền: thép đã tôi",
    example: "thép đã tôi",
  },
  {
    word: "tôi",
    part_of_speech: "động từ",
    meaning: "cho vôi sống vào nước để hoà cho tan ra: tôi vôi",
    example: "tôi vôi",
  },
  {
    word: "tôi",
    part_of_speech: "đại từ",
    meaning:
      '(Nam thường nói tui) từ cá nhân dùng để tự xưng với người ngang hàng hoặc khi không cần tỏ thái độ tình cảm gì: Việc của tôi cứ để tôi làm. * quê hương tôi * "Chồng gì anh, vợ gì tôi, Chẳng qua là cái nợ đời chi đây!" (ca dao)',
    example:
      'Việc của tôi cứ để tôi làm. * quê hương tôi * "Chồng gì anh, vợ gì tôi, Chẳng qua là cái nợ đời chi đây!',
  },
  {
    word: "tội",
    part_of_speech: "danh từ",
    meaning:
      "hành vi phạm pháp, đáng bị xử phạt: phạm tội tham ô * lập công chuộc tội",
    example: "phạm tội tham ô * lập công chuộc tội",
  },
  {
    word: "tội",
    part_of_speech: "danh từ",
    meaning:
      "hành vi phạm vào những điều răn cấm của đạo đức, tôn giáo, v.v.: đi xưng tội * mang tội bất hiếu",
    example: "đi xưng tội * mang tội bất hiếu",
  },
  {
    word: "tội",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) khuyết điểm đáng khiển trách: tội nói dối * bị đánh đòn vì tội lười học",
    example: "tội nói dối * bị đánh đòn vì tội lười học",
  },
  {
    word: "tội",
    part_of_speech: "tính từ",
    meaning:
      'có tình cảnh hoặc hoàn cảnh rất đáng thương, khiến cho người khác trông thấy phải xót xa, thương cảm: "Chim xa rừng thương cây nhớ cội, Người xa người tội lắm người ơi!" (Cdao)',
    example:
      'Chim xa rừng thương cây nhớ cội, Người xa người tội lắm người ơi!" (Cdao)',
  },
  {
    word: "tối cao",
    part_of_speech: "tính từ",
    meaning:
      "cao nhất, cao hơn hết về ý nghĩa, tầm quan trọng: toà án tối cao * viện kiểm sát tối cao",
    example: "toà án tối cao * viện kiểm sát tối cao",
  },
  {
    word: "tội ác",
    part_of_speech: "danh từ",
    meaning:
      "tội rất nghiêm trọng, cả về mặt pháp luật và đạo đức: tội ác diệt chủng * giết người là tội ác",
    example: "tội ác diệt chủng * giết người là tội ác",
  },
  {
    word: "tối",
    part_of_speech: "tính từ",
    meaning:
      "không có hoặc có ít ánh sáng chiếu toả ra trong không gian, khiến cho không hoặc khó nhìn thấy sự vật xung quanh: trời tối dần * vào trong hang tối * tối như bưng",
    example: "trời tối dần * vào trong hang tối * tối như bưng",
  },
  {
    word: "tối",
    part_of_speech: "tính từ",
    meaning:
      "(màu) sẫm, không tươi, không sáng: ưa mặc màu tối * bức tranh có nhiều mảng tối",
    example: "ưa mặc màu tối * bức tranh có nhiều mảng tối",
  },
  {
    word: "tồi",
    part_of_speech: "tính từ",
    meaning:
      "kém hơn nhiều so với yêu cầu, về năng lực, chất lượng hoặc kết quả: loại vải tồi * tay thợ tồi * trí nhớ quá tồi!",
    example: "loại vải tồi * tay thợ tồi * trí nhớ quá tồi!",
  },
  {
    word: "tồi",
    part_of_speech: "tính từ",
    meaning:
      "xấu, tệ về tư cách, trong quan hệ đối xử: cư xử tồi * thằng cha rất tồi!",
    example: "cư xử tồi * thằng cha rất tồi!",
  },
  {
    word: "tối đa",
    part_of_speech: "tính từ",
    meaning:
      "nhiều nhất, không thể nhiều hơn được nữa: đạt điểm tối đa * cố gắng tối đa * hạn chế tối đa",
    example: "đạt điểm tối đa * cố gắng tối đa * hạn chế tối đa",
  },
  {
    word: "tôi con",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) bề tôi, đầy tớ, trong quan hệ trung thành với vua chúa, với chủ, theo quan niệm phong kiến (nói khái quát): tôi con trong nhà",
    example: "tôi con trong nhà",
  },
  {
    word: "tôi đòi",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) người đi ở, phải đem thân ra hầu hạ, phục dịch kẻ khác (nói khái quát): "Sá chi thân phận tôi đòi, Dẫu rằng xương trắng quê người, quản đâu!" (TKiều)',
    example:
      'Sá chi thân phận tôi đòi, Dẫu rằng xương trắng quê người, quản đâu!" (TKiều)',
  },
  {
    word: "tối dạ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) chậm hiểu, kém về khả năng tiếp thu kiến thức: tối dạ nên rất chậm hiểu",
    example: "tối dạ nên rất chậm hiểu",
  },
  {
    word: "tội danh",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi hành vi phạm pháp đã được quy định trong bộ luật hình sự: tội danh tham ô * tội danh trốn thuế",
    example: "tội danh tham ô * tội danh trốn thuế",
  },
  {
    word: "tội đồ",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) hình phạt giam nhiều năm tù; cũng dùng để chỉ người bị hình phạt ấy: kẻ tội đồ * bị phạt 15 năm tội đồ",
    example: "kẻ tội đồ * bị phạt 15 năm tội đồ",
  },
  {
    word: "tội gì",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị ý cho rằng không nên làm việc nói đến ngay sau đó, vì nếu làm như vậy là không hay hoặc vì thực tế có thể làm khác, tốt hơn: có xe tội gì phải đi bộ",
    example: "có xe tội gì phải đi bộ",
  },
  {
    word: "tối đất",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (trời) còn rất tối, vào lúc đã gần hết đêm nhưng chưa rạng sáng: ra đi từ lúc tối đất",
    example: "ra đi từ lúc tối đất",
  },
  {
    word: "tối giản",
    part_of_speech: "tính từ",
    meaning: "(phân số) không thể giản ước được nữa: phân số tối giản",
    example: "phân số tối giản",
  },
  {
    word: "tội gì mà",
    part_of_speech: "",
    meaning:
      'như tội gì: "(...) tôi nghĩ, mình có tiền thì nên làm cái nhà đẹp đẽ mà ở, chứ tội gì mà ở bẩn thỉu chui rúc." (ThLam; 3)',
    example:
      '(...) tôi nghĩ, mình có tiền thì nên làm cái nhà đẹp đẽ mà ở, chứ tội gì mà ở bẩn thỉu chui rúc." (ThLam; 3)',
  },
  {
    word: "tối hậu thư",
    part_of_speech: "danh từ",
    meaning:
      "bức thư nêu ra những điều kiện buộc đối phương phải chấp nhận, nếu không sẽ dùng biện pháp quyết liệt: gửi tối hậu thư, buộc phải đầu hàng vô điều kiện",
    example: "gửi tối hậu thư, buộc phải đầu hàng vô điều kiện",
  },
  {
    word: "tối huệ quốc",
    part_of_speech: "danh từ",
    meaning:
      "nước được một nước khác cho được hưởng những ưu đãi nhất định về mặt kinh tế, trong quan hệ với nước khác đó: được hưởng chế độ tối huệ quốc",
    example: "được hưởng chế độ tối huệ quốc",
  },
  {
    word: "tối hù",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ, khẩu ngữ) tối đen, tối như mực: nhà cửa chi mà tối hù vậy!",
    example: "nhà cửa chi mà tối hù vậy!",
  },
  {
    word: "tối hậu",
    part_of_speech: "tính từ",
    meaning:
      "cuối cùng, không còn có thể có gì khác nữa: mục đích tối hậu * quyền tối hậu quyết định",
    example: "mục đích tối hậu * quyền tối hậu quyết định",
  },
  {
    word: "tối khẩn",
    part_of_speech: "tính từ",
    meaning: "hết sức khẩn cấp: thư tối khẩn * nhiệm vụ tối khẩn",
    example: "thư tối khẩn * nhiệm vụ tối khẩn",
  },
  {
    word: "tối kị",
    part_of_speech: "tính từ",
    meaning:
      "kị nhất, cần hết sức tránh: cãi nhau trước mặt con cái là điều tối kị",
    example: "cãi nhau trước mặt con cái là điều tối kị",
  },
  {
    word: "cả",
    part_of_speech: "tính từ",
    meaning:
      "cao nhất, lớn nhất, đứng hàng đầu trong loại (về phạm vi, mức độ tác động, hay chức năng, giá trị tinh thần, v.v.): con cả * nghĩa cả * chớ thấy sóng cả mà ngã tay chèo (tng)",
    example: "con cả * nghĩa cả * chớ thấy sóng cả mà ngã tay chèo (tng)",
  },
  {
    word: "cả",
    part_of_speech: "phụ từ",
    meaning:
      "ở mức cao nhất, vừa nhiều vừa dễ dàng hoặc mạnh mẽ (nói về một số hoạt động của con người, nhất là hoạt động tâm lí): một người cả tin * cả cười * tính cả ghen",
    example: "một người cả tin * cả cười * tính cả ghen",
  },
  {
    word: "cả",
    part_of_speech: "đại từ",
    meaning:
      "toàn thể, hết thảy, không trừ một ai, hay một thành phần nào: cả nước một lòng * cả nhà đều đi vắng",
    example: "cả nước một lòng * cả nhà đều đi vắng",
  },
  {
    word: "cả",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý nhấn mạnh về mức độ cao, phạm vi không hạn chế của sự việc: làm cả ngày chủ nhật * chẳng ai đến cả * ai cũng biết cả!",
    example: "làm cả ngày chủ nhật * chẳng ai đến cả * ai cũng biết cả!",
  },
  {
    word: "cà",
    part_of_speech: "danh từ",
    meaning:
      'cây thân cỏ, có nhiều loài, lá có lông, hoa màu tím hay trắng, quả chứa nhiều hạt, phần lớn ăn được: "Anh đi anh nhớ quê nhà, Nhớ canh rau muống nhớ cà dầm tương." (Cdao)',
    example:
      'Anh đi anh nhớ quê nhà, Nhớ canh rau muống nhớ cà dầm tương." (Cdao)',
  },
  {
    word: "cà",
    part_of_speech: "động từ",
    meaning:
      "áp một bộ phận thân thể vào vật khác và đưa đi đưa lại sát bề mặt: trâu cà lưng vào gốc cây",
    example: "trâu cà lưng vào gốc cây",
  },
  {
    word: "cà",
    part_of_speech: "động từ",
    meaning:
      "cọ xát vào vật rắn khác nhằm làm cho mòn bớt đI: tục cà răng * cà mắt kính cho vừa với gọng",
    example: "tục cà răng * cà mắt kính cho vừa với gọng",
  },
  {
    word: "cà",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) cố tình gây chuyện cãi cọ với người khác: cà nhau một trận ra trò * tụi nó định cà mình đây!",
    example: "cà nhau một trận ra trò * tụi nó định cà mình đây!",
  },
  {
    word: "ca",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng để uống nước, có quai, thành đứng, thường được làm bằng kim loại hoặc nhựa: uống hết một ca nước * cái ca nhôm",
    example: "uống hết một ca nước * cái ca nhôm",
  },
  {
    word: "ca",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ đong lường, có tay cầm, dung tích từ một phần tư lít đến một, hai lít: đong dầu bằng loại ca hai lít",
    example: "đong dầu bằng loại ca hai lít",
  },
  {
    word: "ca",
    part_of_speech: "danh từ",
    meaning:
      "phiên làm việc liên tục được tính là một ngày công ở xí nghiệp hoặc cơ sở phục vụ: chia thành ba ca * làm ca đêm",
    example: "chia thành ba ca * làm ca đêm",
  },
  {
    word: "ca",
    part_of_speech: "danh từ",
    meaning:
      "toàn thể những người cùng làm trong một ca, nói chung: phổ biến kế hoạch sản xuất cho toàn ca",
    example: "phổ biến kế hoạch sản xuất cho toàn ca",
  },
  {
    word: "ca",
    part_of_speech: "danh từ",
    meaning:
      "việc xảy ra hoặc giả định xảy ra với tính chất cụ thể, mỗi lần mỗi khác: ca mổ khá phức tạp * một ca tai nạn giao thông",
    example: "ca mổ khá phức tạp * một ca tai nạn giao thông",
  },
  {
    word: "ca",
    part_of_speech: "động từ",
    meaning: "(Phương ngữ) hát: vừa đàn vừa ca * ca cải lương",
    example: "vừa đàn vừa ca * ca cải lương",
  },
  {
    word: "ca",
    part_of_speech: "danh từ",
    meaning:
      "điệu hát dân tộc cổ truyền ở một số địa phương trung Trung Bộ, Nam Bộ: ca Huế",
    example: "ca Huế",
  },
  {
    word: "cá",
    part_of_speech: "danh từ",
    meaning:
      "miếng gỗ (giống hình con cá) dùng để giữ chặt các mộng gỗ khi lắp ghép.",
    example: "xe bị trượt cá",
  },
  {
    word: "cá",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) cuộc: cá nhau xem ai thắng ai thua",
    example: "cá nhau xem ai thắng ai thua",
  },
  {
    word: "cá biệt",
    part_of_speech: "tính từ",
    meaning:
      "riêng lẻ, ít có, không phổ biến hoặc không điển hình: thành phần cá biệt * một học sinh cá biệt",
    example: "thành phần cá biệt * một học sinh cá biệt",
  },
  {
    word: "ca bin",
    part_of_speech: "danh từ",
    meaning:
      "buồng nhỏ được thiết kế riêng phục vụ cho một công dụng nào đó: ca bin điện thoại * ca bin học ngoại ngữ",
    example: "ca bin điện thoại * ca bin học ngoại ngữ",
  },
  {
    word: "cá bột",
    part_of_speech: "danh từ",
    meaning: "cá mới nở: vớt cá bột * kĩ thuật nuôi cá bột",
    example: "vớt cá bột * kĩ thuật nuôi cá bột",
  },
  {
    word: "ca cẩm",
    part_of_speech: "động từ",
    meaning: "kêu ca, phàn nàn: tính hay ca cẩm",
    example: "tính hay ca cẩm",
  },
  {
    word: "cá cảnh",
    part_of_speech: "danh từ",
    meaning:
      "cá có hình dáng và màu sắc đẹp, nuôi để làm cảnh, nói chung: bể nuôi cá cảnh",
    example: "bể nuôi cá cảnh",
  },
  {
    word: "cá chày",
    part_of_speech: "danh từ",
    meaning:
      "cá nước ngọt cùng họ với cá chép, mình tròn, mắt đỏ: mắt đỏ như mắt cá chày",
    example: "mắt đỏ như mắt cá chày",
  },
  {
    word: "cà chua",
    part_of_speech: "danh từ",
    meaning:
      "cà thân và lá có lông, lá xẻ hình chân vịt, hoa vàng, quả chín màu vàng đỏ, thịt mềm mọng nước, vị hơi chua: nước xốt cà chua",
    example: "nước xốt cà chua",
  },
  {
    word: "cà cuống",
    part_of_speech: "danh từ",
    meaning:
      "bọ cánh nửa, sống ở nước, phần ngực con đực có hai túi chứa tinh dầu mùi thơm, vị cay, dùng làm gia vị.",
    example: "nước mắm cà cuống",
  },
  {
    word: "cà cộ",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như cà khổ: chiếc xe đạp cà cộ",
    example: "chiếc xe đạp cà cộ",
  },
  {
    word: "cá cược",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) đánh cuộc ăn tiền (nói khái quát): chơi cá cược",
    example: "chơi cá cược",
  },
  {
    word: "ca dao",
    part_of_speech: "danh từ",
    meaning:
      "thơ ca dân gian được truyền miệng dưới dạng những câu hát không theo một điệu nhất định, thường phổ biến theo thể thơ lục bát cho dễ nhớ, dễ thuộc: hình ảnh con cò trong ca dao Việt Nam * sưu tầm được nhiều bài ca dao cổ",
    example:
      "hình ảnh con cò trong ca dao Việt Nam * sưu tầm được nhiều bài ca dao cổ",
  },
  {
    word: "cả cục",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) luôn một lần, cùng một lúc, không tách rời, xé lẻ ra: trả cả cục * bán cả cục * học phí phải đóng cả cục",
    example: "trả cả cục * bán cả cục * học phí phải đóng cả cục",
  },
  {
    word: "cả gan",
    part_of_speech: "tính từ",
    meaning:
      "liều lĩnh, táo tợn, dám làm những việc nguy hiểm hoặc bị ngăn cấm: cả gan ăn cắp",
    example: "cả gan ăn cắp",
  },
  {
    word: "cá độ",
    part_of_speech: "động từ",
    meaning:
      "đánh cuộc ăn thua bằng tiền về tỉ số thắng, thua của trận đấu: dân cá độ bóng đá * triệt phá một đường dây chuyên tổ chức cá độ",
    example: "dân cá độ bóng đá * triệt phá một đường dây chuyên tổ chức cá độ",
  },
  {
    word: "cả gói",
    part_of_speech: "",
    meaning:
      "hết thảy, toàn bộ, không trừ một thành phần nào, trong tổng thể những cái, những việc được nói đến: kế hoạch viện trợ cả gói * giao khoán cả gói",
    example: "kế hoạch viện trợ cả gói * giao khoán cả gói",
  },
  {
    word: "cà gỉ",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như cà khổ: chiếc xe cà gỉ",
    example: "chiếc xe cà gỉ",
  },
  {
    word: "ca hát",
    part_of_speech: "động từ",
    meaning: "hát (nói khái quát): vui chơi ca hát",
    example: "vui chơi ca hát",
  },
  {
    word: "cà kê",
    part_of_speech: "",
    meaning:
      "dài dòng, hết chuyện này sang chuyện khác: ngồi cà kê hết cả buổi sáng * nói cà kê hết chuyện nọ tới chuyện kia",
    example:
      "ngồi cà kê hết cả buổi sáng * nói cà kê hết chuyện nọ tới chuyện kia",
  },
  {
    word: "cà kếu",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) sếu: cao như con cà kếu",
    example: "cao như con cà kếu",
  },
  {
    word: "cà khẳng cà khiu",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) rất gầy và khẳng khiu, trông thiếu sức sống: người cà khẳng cà khiu",
    example: "người cà khẳng cà khiu",
  },
  {
    word: "cà kê dê ngỗng",
    part_of_speech: "",
    meaning: "(khẩu ngữ) như cà kê: ngồi cà kê dê ngỗng hết cả buổi",
    example: "ngồi cà kê dê ngỗng hết cả buổi",
  },
  {
    word: "ca huế",
    part_of_speech: "danh từ",
    meaning:
      "lối hát gồm một số ca khúc dựa vào ngữ điệu địa phương Quảng Trị - Thừa Thiên, có nhạc tính rõ nét và phong cách trữ tình: nghe ca Huế trên sông Hương",
    example: "nghe ca Huế trên sông Hương",
  },
  {
    word: "cà khổ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (đồ vật) xấu xí, tồi tàn, không ra gì: chiếc xe đạp cà khổ",
    example: "chiếc xe đạp cà khổ",
  },
  {
    word: "ca khúc",
    part_of_speech: "danh từ",
    meaning: "bài hát ngắn có bố cục và giai điệu hoàn chỉnh: ca khúc nhạc nhẹ",
    example: "ca khúc nhạc nhẹ",
  },
  {
    word: "cà khịa",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) gây sự để cãi nhau, đánh nhau: buông lời cà khịa * say rượu nên cà khịa lung tung * cà khịa đánh nhau",
    example:
      "buông lời cà khịa * say rượu nên cà khịa lung tung * cà khịa đánh nhau",
  },
  {
    word: "ca kịch",
    part_of_speech: "danh từ",
    meaning:
      "kịch hát dùng làn điệu xen kẽ các lối nói, có kèm điệu bộ hoặc động tác múa: đoàn ca kịch trung ương",
    example: "đoàn ca kịch trung ương",
  },
  {
    word: "cà là gỉ",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ, hiếm) như cà gỉ (hàm ý hài hước): chiếc mũ cà là gỉ",
    example: "chiếc mũ cà là gỉ",
  },
  {
    word: "cà lăm",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) nói lắp: nói cà lăm",
    example: "nói cà lăm",
  },
  {
    word: "cà lơ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có những cử chỉ, hành vi không đứng đắn của kẻ du đãng và lêu lổng: cà lơ thất thểu ở ngoài phố",
    example: "cà lơ thất thểu ở ngoài phố",
  },
  {
    word: "cá lóc",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) cá quả: canh chua cá lóc",
    example: "canh chua cá lóc",
  },
  {
    word: "cá mập",
    part_of_speech: "danh từ",
    meaning: "cá nhám cỡ lớn, rất dữ: hàm cá mập",
    example: "hàm cá mập",
  },
  {
    word: "cá mập",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để ví tư bản rất lớn, thôn tính các tư bản nhỏ: cá mập tư bản",
    example: "cá mập tư bản",
  },
  {
    word: "cà mèng",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như cà khổ: chiếc đồng hồ cà mèng",
    example: "chiếc đồng hồ cà mèng",
  },
  {
    word: "cà mèng",
    part_of_speech: "tính từ",
    meaning: "xoàng, kém cỏi: chức quan cà mèng * thuộc loại cà mèng",
    example: "chức quan cà mèng * thuộc loại cà mèng",
  },
  {
    word: "ca múa",
    part_of_speech: "động từ",
    meaning: "hát và múa (nói khái quát): đoàn ca múa",
    example: "đoàn ca múa",
  },
  {
    word: "cá mú",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) cá (nói khái quát): suốt ngày chỉ thịt thà, cá mú",
    example: "suốt ngày chỉ thịt thà, cá mú",
  },
  {
    word: "cả nể",
    part_of_speech: "tính từ",
    meaning:
      'dễ nể nang, không muốn làm phật ý người khác: tính hay cả nể * "Cả nể cho nên hoá dở dang, Nỗi niềm chàng có biết chăng chàng?" (HXHương; 23)',
    example:
      'tính hay cả nể * "Cả nể cho nên hoá dở dang, Nỗi niềm chàng có biết chăng chàng?" (HXHương; 23)',
  },
  {
    word: "ca ngâm",
    part_of_speech: "động từ",
    meaning:
      '(cũ) ca hát và ngâm vịnh: "Thông minh vốn sẵn tính trời, Pha nghề thi hoạ, đủ mùi ca ngâm." (TKiều)',
    example:
      'Thông minh vốn sẵn tính trời, Pha nghề thi hoạ, đủ mùi ca ngâm." (TKiều)',
  },
  {
    word: "cả nghĩ",
    part_of_speech: "tính từ",
    meaning: "hay nghĩ ngợi, cả về những việc không đáng: một người cả nghĩ",
    example: "một người cả nghĩ",
  },
  {
    word: "ca ngợi",
    part_of_speech: "động từ",
    meaning:
      "nêu lên để khen, để tỏ lòng yêu quý, khâm phục: ca ngợi lòng dũng cảm * nêu lên để ca ngợi",
    example: "ca ngợi lòng dũng cảm * nêu lên để ca ngợi",
  },
  {
    word: "cá nhâm",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) cá trích: mùa cá nhâm",
    example: "mùa cá nhâm",
  },
  {
    word: "ca nhạc",
    part_of_speech: "danh từ",
    meaning:
      "nghệ thuật biểu diễn bằng giọng hát và âm thanh của các loại nhạc cụ: chương trình ca nhạc quốc tế * xem biểu diễn ca nhạc",
    example: "chương trình ca nhạc quốc tế * xem biểu diễn ca nhạc",
  },
  {
    word: "cá ngựa",
    part_of_speech: "danh từ",
    meaning:
      "(cũng hải mã) cá biển đầu giống đầu ngựa, thân dài có nhiều đốt, đuôi thon nhỏ và cong, có thể dùng làm thuốc.",
    example: "chơi cá ngựa",
  },
  {
    word: "cá ngựa",
    part_of_speech: "động từ",
    meaning:
      "đánh cuộc ăn tiền trong các cuộc đua ngựa: hai người cá ngựa với nhau",
    example: "hai người cá ngựa với nhau",
  },
  {
    word: "cà nhắc",
    part_of_speech: "động từ",
    meaning:
      "từ gợi tả dáng đi bước cao bước thấp vẻ khó nhọc, do có một chân không cử động được bình thường: chân đau, phải đi cà nhắc",
    example: "chân đau, phải đi cà nhắc",
  },
  {
    word: "cá nhân chủ nghĩa",
    part_of_speech: "tính từ",
    meaning: "như cá nhân: tư tưởng cá nhân chủ nghĩa",
    example: "tư tưởng cá nhân chủ nghĩa",
  },
  {
    word: "cá nhân",
    part_of_speech: "danh từ",
    meaning:
      "người riêng lẻ; phân biệt với tập thể: ý kiến cá nhân * mối quan hệ giữa cá nhân và tập thể",
    example: "ý kiến cá nhân * mối quan hệ giữa cá nhân và tập thể",
  },
  {
    word: "cá nhân",
    part_of_speech: "tính từ",
    meaning:
      "chỉ chú trọng đến lợi ích của riêng mình, không nghĩ đến quyền lợi của người khác hay của tập thể: tính toán cá nhân",
    example: "tính toán cá nhân",
  },
  {
    word: "cá nhân",
    part_of_speech: "tính từ",
    meaning:
      "(đồ dùng) chỉ dành cho cá nhân, cho một người: giường cá nhân * đồ dùng cá nhân",
    example: "giường cá nhân * đồ dùng cá nhân",
  },
  {
    word: "ca nhi",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, hiếm) người phụ nữ trẻ làm nghề ca hát thời phong kiến: "Vương Quan mới dẫn gần xa, Đạm Tiên nàng ấy xưa là ca nhi." (TKiều)',
    example:
      'Vương Quan mới dẫn gần xa, Đạm Tiên nàng ấy xưa là ca nhi." (TKiều)',
  },
  {
    word: "cá nước",
    part_of_speech: "danh từ",
    meaning:
      "cá và nước, thường dùng để ví quan hệ tình cảm khăng khít, không thể thiếu nhau: tình quân dân cá nước",
    example: "tình quân dân cá nước",
  },
  {
    word: "cá nước chim trời",
    part_of_speech: "",
    meaning:
      'như chim trời cá nước: "Lạ lùng ướm hỏi nhau chơi, Một mai cá nước chim trời gặp nhau." (ca dao)',
    example:
      'Lạ lùng ướm hỏi nhau chơi, Một mai cá nước chim trời gặp nhau." (ca dao)',
  },
  {
    word: "cà rá",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) nhẫn: ngón tay đeo cà rá",
    example: "ngón tay đeo cà rá",
  },
  {
    word: "cà phê",
    part_of_speech: "danh từ",
    meaning:
      "cây nhỡ, lá mọc đối, hoa trắng, quả nhỏ, khi chín có màu đỏ, hạt đem rang và xay nhỏ thành bột màu nâu sẫm, dùng để pha nước uống: cây cà phê * nhấm nháp li cà phê",
    example: "cây cà phê * nhấm nháp li cà phê",
  },
  {
    word: "cả quyết",
    part_of_speech: "động từ",
    meaning: "(cũ) như quả quyết: cả quyết là sẽ làm được * nói rất cả quyết",
    example: "cả quyết là sẽ làm được * nói rất cả quyết",
  },
  {
    word: "cà rà",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) loanh quanh, nấn ná bên cạnh, không chịu đi, không chịu rời ra: cà rà bên cạnh để làm quen",
    example: "cà rà bên cạnh để làm quen",
  },
  {
    word: "ca ri",
    part_of_speech: "danh từ",
    meaning:
      "bột gia vị làm bằng nghệ và hạt mùi, có màu vàng và mùi thơm đặc trưng: thịt gà nấu ca ri",
    example: "thịt gà nấu ca ri",
  },
  {
    word: "cà ròn",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) bao nhỏ đan bằng cói: đan cà ròn * một bao cà ròn muối",
    example: "đan cà ròn * một bao cà ròn muối",
  },
  {
    word: "cà ri",
    part_of_speech: "danh từ",
    meaning:
      "bột gia vị làm bằng nghệ và hạt mùi, có màu vàng và mùi thơm đặc trưng: thịt gà nấu ca ri",
    example: "thịt gà nấu ca ri",
  },
  {
    word: "cà riềng",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) nói lai nhai cố ý như để gây sự hay trách móc: ăn nói cà riềng",
    example: "ăn nói cà riềng",
  },
  {
    word: "ca rô",
    part_of_speech: "danh từ",
    meaning:
      "ô nhỏ hình vuông dệt hoặc in nối tiếp nhau trên vải, trên giấy: vải ca rô * giấy kẻ ca rô",
    example: "vải ca rô * giấy kẻ ca rô",
  },
  {
    word: "cà rịch cà tang",
    part_of_speech: "",
    meaning:
      "(làm việc gì) chậm chạp và với một nhịp độ đều đều như không quan tâm gì đến thời gian: làm cà rịch cà tang thế này thì bao giờ mới xong?",
    example: "làm cà rịch cà tang thế này thì bao giờ mới xong?",
  },
  {
    word: "cà sa",
    part_of_speech: "danh từ",
    meaning:
      'áo mặc ngoài của nhà sư (rất dài và rộng): "Áo xanh đổi lấy cà sa, Pháp danh lại đổi tên ra Trạc Tuyền." (TKiều)',
    example:
      'Áo xanh đổi lấy cà sa, Pháp danh lại đổi tên ra Trạc Tuyền." (TKiều)',
  },
  {
    word: "cà rỡn",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) đùa giỡn: nói cà rỡn",
    example: "nói cà rỡn",
  },
  {
    word: "ca sĩ",
    part_of_speech: "danh từ",
    meaning: "nghệ sĩ chuyên về hát: một ca sĩ nổi tiếng",
    example: "một ca sĩ nổi tiếng",
  },
  {
    word: "ca táp",
    part_of_speech: "danh từ",
    meaning:
      "cặp cỡ to có quai xách, thường làm bằng da và có nhiều ngăn: xách ca táp đi họp",
    example: "xách ca táp đi họp",
  },
  {
    word: "ca sỹ",
    part_of_speech: "danh từ",
    meaning: "nghệ sĩ chuyên về hát: một ca sĩ nổi tiếng",
    example: "một ca sĩ nổi tiếng",
  },
  {
    word: "cà tàng",
    part_of_speech: "tính từ",
    meaning: "(Phương ngữ) rất tàng: chiếc xe đạp cà tàng",
    example: "chiếc xe đạp cà tàng",
  },
  {
    word: "ca thán",
    part_of_speech: "động từ",
    meaning: "như ta thán: ca thán đủ điều * nghe những lời ca thán",
    example: "ca thán đủ điều * nghe những lời ca thán",
  },
  {
    word: "cả thảy",
    part_of_speech: "đại từ",
    meaning:
      "(khẩu ngữ) tất cả, được tính hết gộp lại: trong nhà có bốn người cả thảy",
    example: "trong nhà có bốn người cả thảy",
  },
  {
    word: "cả thẹn",
    part_of_speech: "tính từ",
    meaning:
      "hay thẹn, dễ xấu hổ, nên thường thiếu tự nhiên, mạnh bạo: tính hay cả thẹn",
    example: "tính hay cả thẹn",
  },
  {
    word: "tối kỵ",
    part_of_speech: "tính từ",
    meaning:
      "kị nhất, cần hết sức tránh: cãi nhau trước mặt con cái là điều tối kị",
    example: "cãi nhau trước mặt con cái là điều tối kị",
  },
  {
    word: "tối mắt tối mũi",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) bận túi bụi, như không còn nhìn thấy gì được nữa: bận tối mắt tối mũi",
    example: "bận tối mắt tối mũi",
  },
  {
    word: "tối mật",
    part_of_speech: "tính từ",
    meaning: "hết sức cần được giữ bí mật: tài liệu tối mật",
    example: "tài liệu tối mật",
  },
  {
    word: "tội lỗi",
    part_of_speech: "danh từ",
    meaning:
      "tội phạm phải (nói khái quát): cố tình che giấu mọi tội lỗi * đi vào con đường tội lỗi",
    example: "cố tình che giấu mọi tội lỗi * đi vào con đường tội lỗi",
  },
  {
    word: "tối mắt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ở trạng thái mắt như chẳng còn nhìn thấy gì được nữa: bận tối mắt (rất bận) * tối mắt vì tiền",
    example: "bận tối mắt (rất bận) * tối mắt vì tiền",
  },
  {
    word: "tối lửa tắt đèn",
    part_of_speech: "",
    meaning: "ví lúc gặp khó khăn, hoạn nạn: hàng xóm tối lửa tắt đèn có nhau",
    example: "hàng xóm tối lửa tắt đèn có nhau",
  },
  {
    word: "tôi luyện",
    part_of_speech: "động từ",
    meaning:
      "làm cho tinh thần, ý chí trải qua những thử thách gay go trong thực tiễn hoạt động và đấu tranh mà trở nên kiên định, vững vàng: được tôi luyện trong đấu tranh",
    example: "được tôi luyện trong đấu tranh",
  },
  {
    word: "tối mịt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) tối đến mức như bóng đen bao phủ tất cả, chẳng nhìn thấy gì: đi từ sáng đến tối mịt mới về",
    example: "đi từ sáng đến tối mịt mới về",
  },
  {
    word: "tối mò",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) tối đến mức không nhìn thấy gì, phải mò mẫm: cái hang tối mò",
    example: "cái hang tối mò",
  },
  {
    word: "tội nợ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) cái chỉ mang lại những sự phiền phức, khổ cực mà đành phải gánh chịu, khó bề dứt bỏ (nói khái quát): tự dưng lại đi tha cái của ấy về, đúng là tội nợ!",
    example: "tự dưng lại đi tha cái của ấy về, đúng là tội nợ!",
  },
  {
    word: "tội nhân",
    part_of_speech: "danh từ",
    meaning: "(cũ) như tội phạm (ng2): đưa tội nhân đi hành hình",
    example: "đưa tội nhân đi hành hình",
  },
  {
    word: "tối mù",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) tối đến mức chẳng trông thấy gì: trời tối mù",
    example: "trời tối mù",
  },
  {
    word: "tôi ngươi",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) đầy tớ, trong quan hệ với chủ, và bề tôi, trong quan hệ với vua chúa, theo quan niệm phong kiến: đạo tôi ngươi",
    example: "đạo tôi ngươi",
  },
  {
    word: "tội nghiệp",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) tội lỗi của một người đã làm ở kiếp trước, tạo thành cái nghiệp người đó phải chịu ở kiếp sau, theo quan niệm của đạo Phật: "Xét trong tội nghiệp Thuý Kiều, Mắc điều tình ái, khỏi điều tà dâm." (TKiều)',
    example:
      'Xét trong tội nghiệp Thuý Kiều, Mắc điều tình ái, khỏi điều tà dâm." (TKiều)',
  },
  {
    word: "tội nghiệp",
    part_of_speech: "tính từ",
    meaning:
      "đáng thương vì gặp phải cảnh ngộ đau khổ, không may: cảnh mẹ goá con côi trông thật tội nghiệp * đứa trẻ tội nghiệp",
    example: "cảnh mẹ goá con côi trông thật tội nghiệp * đứa trẻ tội nghiệp",
  },
  {
    word: "tội nghiệp",
    part_of_speech: "tính từ",
    meaning: "từ biểu thị ý thương hại, thông cảm: đừng mắng nó, tội nghiệp!",
    example: "đừng mắng nó, tội nghiệp!",
  },
  {
    word: "tối om",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) tối đến mức có cảm giác như mọi nguồn ánh sáng từ mọi phía đều bị bịt kín hết: nhà cửa tối om * trời tối om như mực",
    example: "nhà cửa tối om * trời tối om như mực",
  },
  {
    word: "tối ngày",
    part_of_speech: "danh từ",
    meaning:
      'cả ngày, suốt từ sáng sớm đến tối mịt: đi tối ngày * "Giàu đâu những kẻ ngủ trưa, Sang đâu những kẻ say sưa tối ngày." (ca dao)',
    example:
      'đi tối ngày * "Giàu đâu những kẻ ngủ trưa, Sang đâu những kẻ say sưa tối ngày." (ca dao)',
  },
  {
    word: "tội phạm",
    part_of_speech: "danh từ",
    meaning:
      "hành vi nguy hiểm cho xã hội được quy định trong luật: đấu tranh phòng chống tội phạm * các yếu tố cấu thành tội phạm",
    example: "đấu tranh phòng chống tội phạm * các yếu tố cấu thành tội phạm",
  },
  {
    word: "tội phạm",
    part_of_speech: "danh từ",
    meaning: "kẻ phạm tội: truy bắt tội phạm",
    example: "truy bắt tội phạm",
  },
  {
    word: "tôi rèn",
    part_of_speech: "động từ",
    meaning: "(hiếm) như tôi luyện: tôi rèn thể lực",
    example: "tôi rèn thể lực",
  },
  {
    word: "tối sầm",
    part_of_speech: "tính từ",
    meaning:
      "trở nên tối và u ám khắp cả một cách đột ngột: trời đang nắng bỗng tối sầm * mặt tối sầm lại",
    example: "trời đang nắng bỗng tối sầm * mặt tối sầm lại",
  },
  {
    word: "tồi tàn",
    part_of_speech: "tính từ",
    meaning:
      "quá tồi, đến mức thảm hại: chiếc xe đạp tồi tàn * căn nhà tồi tàn, rách nát",
    example: "chiếc xe đạp tồi tàn * căn nhà tồi tàn, rách nát",
  },
  {
    word: "tối tân",
    part_of_speech: "tính từ",
    meaning:
      "mới nhất, hiện đại nhất: máy móc tối tân * trang thiết bị tối tân * vũ khí tối tân",
    example: "máy móc tối tân * trang thiết bị tối tân * vũ khí tối tân",
  },
  {
    word: "tối tăm",
    part_of_speech: "tính từ",
    meaning:
      "tối, thiếu ánh sáng (nói khái quát): nhà cửa tối tăm, ẩm thấp * trời đất tối tăm mờ mịt",
    example: "nhà cửa tối tăm, ẩm thấp * trời đất tối tăm mờ mịt",
  },
  {
    word: "tối tăm",
    part_of_speech: "tính từ",
    meaning:
      "(cảnh sống) không có lối thoát, không có tương lai: kiếp sống tối tăm",
    example: "kiếp sống tối tăm",
  },
  {
    word: "tối tăm",
    part_of_speech: "tính từ",
    meaning:
      "không được thông minh hoặc không được sáng sủa (nói khái quát): đầu óc tối tăm * lời văn tối tăm, khó hiểu",
    example: "đầu óc tối tăm * lời văn tối tăm, khó hiểu",
  },
  {
    word: "tối tăm mặt mũi",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) ở trạng thái tưởng như không còn nhìn thấy gì ở xung quanh do chịu một tác động mạnh mẽ nào đó: cái tát làm tối tăm mặt mũi",
    example: "cái tát làm tối tăm mặt mũi",
  },
  {
    word: "tồi tệ",
    part_of_speech: "tính từ",
    meaning:
      "tồi, tệ đến mức như không còn có thể nào hơn thế nữa: sức khoẻ ngày một tồi tệ * đối xử tồi tệ",
    example: "sức khoẻ ngày một tồi tệ * đối xử tồi tệ",
  },
  {
    word: "tồi tệ",
    part_of_speech: "tính từ",
    meaning:
      "không sáng sủa, không rõ ràng, khó hiểu: cách trình bày tối * câu thơ hơi tối nghĩa",
    example: "cách trình bày tối * câu thơ hơi tối nghĩa",
  },
  {
    word: "tồi tệ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) tỏ ra hiểu biết rất chậm: đầu óc tối, nói mãi mà vẫn không hiểu",
    example: "đầu óc tối, nói mãi mà vẫn không hiểu",
  },
  {
    word: "tồi tệ",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian kể từ khi không còn ánh sáng mặt trời cho đến lúc mọi người, nói chung, thường đi ngủ: buổi tối * đi từ sáng đến tối mới về",
    example: "buổi tối * đi từ sáng đến tối mới về",
  },
  {
    word: "tồi tệ",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) đêm: ngủ một tối ở nhà trọ",
    example: "ngủ một tối ở nhà trọ",
  },
  {
    word: "tồi tệ",
    part_of_speech: "phụ từ",
    meaning: "cực kì, hết sức: thư tối khẩn * một vấn đề tối quan trọng",
    example: "thư tối khẩn * một vấn đề tối quan trọng",
  },
  {
    word: "tối thiểu",
    part_of_speech: "tính từ",
    meaning:
      "ít nhất, không thể ít hơn được nữa: mức lương tối thiểu * nhu cầu tối thiểu",
    example: "mức lương tối thiểu * nhu cầu tối thiểu",
  },
  {
    word: "tội tình",
    part_of_speech: "danh từ",
    meaning:
      "tội lỗi phạm phải, đáng phải trừng phạt: nó có tội tình gì đâu mà đánh nó?",
    example: "nó có tội tình gì đâu mà đánh nó?",
  },
  {
    word: "tối thượng",
    part_of_speech: "tính từ",
    meaning:
      "cao nhất, có tác dụng chi phối tất cả: mục đích tối thượng * quyền lực tối thượng",
    example: "mục đích tối thượng * quyền lực tối thượng",
  },
  {
    word: "tôi tớ",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người đi ở, trong quan hệ với chủ, trong xã hội cũ (nói khái quát): bọn tôi tớ trong nhà * hạng tôi tớ",
    example: "bọn tôi tớ trong nhà * hạng tôi tớ",
  },
  {
    word: "tối trời",
    part_of_speech: "tính từ",
    meaning:
      '(khẩu ngữ) tối vì không có ánh sáng của trăng, sao: "Cách sông nên phải luỵ đò, Tối trời nên phải luỵ o bán dầu." (ca dao)',
    example:
      'Cách sông nên phải luỵ đò, Tối trời nên phải luỵ o bán dầu." (ca dao)',
  },
  {
    word: "tôi tối",
    part_of_speech: "tính từ",
    meaning: "hơi tối, không được sáng sủa: cái áo màu hơi tôi tối",
    example: "cái áo màu hơi tôi tối",
  },
  {
    word: "tối ư",
    part_of_speech: "phụ từ",
    meaning:
      "(cũ, khẩu ngữ) cực kì, không còn có thể hơn: một con người tối ư tàn nhẫn * chuyện tối ư quan trọng",
    example: "một con người tối ư tàn nhẫn * chuyện tối ư quan trọng",
  },
  {
    word: "tối ưu",
    part_of_speech: "tính từ",
    meaning: "tốt nhất, đưa lại hiệu quả tốt nhất: giải pháp tối ưu",
    example: "giải pháp tối ưu",
  },
  {
    word: "tội trạng",
    part_of_speech: "danh từ",
    meaning: "cứ liệu và những tình tiết của một tội phạm: kể tội trạng",
    example: "kể tội trạng",
  },
  {
    word: "tôm",
    part_of_speech: "động từ",
    meaning: "(Thông tục) bắt gọn (kẻ chống đối, phạm pháp): tôm gọn cả lũ",
    example: "tôm gọn cả lũ",
  },
  {
    word: "tội vạ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) tội lỗi và những sự trừng phạt phải gánh chịu: mọi người cứ làm đi, tội vạ đâu tôi chịu",
    example: "mọi người cứ làm đi, tội vạ đâu tôi chịu",
  },
  {
    word: "tốn",
    part_of_speech: "danh từ",
    meaning:
      "tên một quẻ trong bát quái, thường tượng trưng cho gió: cung tốn * quẻ tốn",
    example: "cung tốn * quẻ tốn",
  },
  {
    word: "tốn",
    part_of_speech: "động từ",
    meaning:
      "phải dùng vào công việc gì một số lượng nào đó: tốn ít nguyên liệu * tốn nhiều công luyện tập",
    example: "tốn ít nguyên liệu * tốn nhiều công luyện tập",
  },
  {
    word: "tốn",
    part_of_speech: "động từ",
    meaning:
      "hoặc t dùng mất nhiều, không tương xứng với kết quả: xe chạy tốn xăng * đi làm gì cho tốn công",
    example: "xe chạy tốn xăng * đi làm gì cho tốn công",
  },
  {
    word: "tôm tép",
    part_of_speech: "danh từ",
    meaning:
      'tôm và tép (nói khái quát); thường dùng để ví hạng người bị coi là thấp kém, không có địa vị trong xã hội: phận tôm tép * "Sá chi đồi cát vũng lầy, Những loài tôm tép biết ngày nào khôn." (ca dao)',
    example:
      'phận tôm tép * "Sá chi đồi cát vũng lầy, Những loài tôm tép biết ngày nào khôn." (ca dao)',
  },
  {
    word: "tôn",
    part_of_speech: "danh từ",
    meaning:
      "thép tấm, ít carbon, có tráng mạ kẽm ở bề mặt: thùng tôn * nhà lợp mái tôn",
    example: "thùng tôn * nhà lợp mái tôn",
  },
  {
    word: "tôn",
    part_of_speech: "động từ",
    meaning:
      "đắp thêm vào để cho cao hơn, vững hơn: tôn nền nhà * tôn cao đoạn đê bị sụt lở",
    example: "tôn nền nhà * tôn cao đoạn đê bị sụt lở",
  },
  {
    word: "tôn",
    part_of_speech: "động từ",
    meaning:
      "làm tăng thêm cho thấy rõ hơn, nổi bật hơn, nhờ ưu thế hoặc sự tương phản với những cái khác làm nền: hình thức đẹp làm tôn nội dung",
    example: "hình thức đẹp làm tôn nội dung",
  },
  {
    word: "tôn",
    part_of_speech: "động từ",
    meaning:
      "coi là xứng đáng và đưa lên một địa vị cao quý: tôn làm thầy * Hồ Xuân Hương được tôn là bà chúa thơ nôm",
    example: "tôn làm thầy * Hồ Xuân Hương được tôn là bà chúa thơ nôm",
  },
  {
    word: "tồn",
    part_of_speech: "động từ",
    meaning:
      "đang còn lại, chưa được giải quyết, xử lí, v.v.: hàng tồn * còn tồn lại nhiều đơn từ chưa giải quyết",
    example: "hàng tồn * còn tồn lại nhiều đơn từ chưa giải quyết",
  },
  {
    word: "tôn chỉ",
    part_of_speech: "danh từ",
    meaning:
      "nguyên tắc chính chi phối mục đích hoạt động của một tổ chức, một đoàn thể: tôn chỉ của đạo Phật * tôn chỉ của tờ báo",
    example: "tôn chỉ của đạo Phật * tôn chỉ của tờ báo",
  },
  {
    word: "tổn",
    part_of_speech: "động từ",
    meaning:
      '(khẩu ngữ, hiếm) tốn mất nhiều: "Chồng khôn thì nổi cơ đồ, Chồng dại luống tổn công phu nặng mình." (ca dao)',
    example:
      'Chồng khôn thì nổi cơ đồ, Chồng dại luống tổn công phu nặng mình." (ca dao)',
  },
  {
    word: "tổn",
    part_of_speech: "động từ",
    meaning:
      "làm mất mát, làm thiệt hại đến: làm tổn thanh danh * hao binh tổn tướng (tng)",
    example: "làm tổn thanh danh * hao binh tổn tướng (tng)",
  },
  {
    word: "tồn dư",
    part_of_speech: "động từ",
    meaning:
      "còn lại, thừa lại do chưa được giải quyết, xử lí hết: tồn dư kinh phí cuối năm",
    example: "tồn dư kinh phí cuối năm",
  },
  {
    word: "tốn kém",
    part_of_speech: "động từ",
    meaning:
      "tốn mất nhiều tiền của (nói khái quát): ăn tiêu tốn kém * bày vẽ làm gì cho thêm tốn kém",
    example: "ăn tiêu tốn kém * bày vẽ làm gì cho thêm tốn kém",
  },
  {
    word: "tồn kho",
    part_of_speech: "động từ",
    meaning:
      "(hàng hoá) còn đọng lại trong kho, chưa được sử dụng hoặc tiêu thụ hết: hàng tồn kho * tiêu thụ nốt số sản phẩm còn tồn kho",
    example: "hàng tồn kho * tiêu thụ nốt số sản phẩm còn tồn kho",
  },
  {
    word: "tồn giữ",
    part_of_speech: "động từ",
    meaning:
      "còn giữ lại, không để mất đi, hoặc không giao nộp: ngôi chùa còn tồn giữ được nhiều di vật cổ",
    example: "ngôi chùa còn tồn giữ được nhiều di vật cổ",
  },
  {
    word: "tồn đọng",
    part_of_speech: "động từ",
    meaning:
      "còn lưu lại, đọng lại, chưa được xử lí, giải quyết: tồn đọng vốn * nợ tồn đọng",
    example: "tồn đọng vốn * nợ tồn đọng",
  },
  {
    word: "tổn hại",
    part_of_speech: "",
    meaning:
      "làm mất mát, hư hại lớn: làm tổn hại đến danh dự * khắc phục những tổn hại về kinh tế",
    example: "làm tổn hại đến danh dự * khắc phục những tổn hại về kinh tế",
  },
  {
    word: "tồn khoản",
    part_of_speech: "danh từ",
    meaning:
      "số tiền chưa sử dụng thuộc một khoản nào đó, được phản ánh trên sổ sách kế toán: tồn khoản quỹ tiền mặt",
    example: "tồn khoản quỹ tiền mặt",
  },
  {
    word: "tôn kính",
    part_of_speech: "động từ",
    meaning: "hết sức kính trọng: tôn kính mẹ cha * tỏ lòng tôn kính",
    example: "tôn kính mẹ cha * tỏ lòng tôn kính",
  },
  {
    word: "tồn lưu",
    part_of_speech: "động từ",
    meaning:
      "còn lại do chưa được xử lí hoặc phân giải hết (thường nói về cái độc hại): thuốc bảo vệ thực vật tồn lưu trên rau quả",
    example: "thuốc bảo vệ thực vật tồn lưu trên rau quả",
  },
  {
    word: "tồn nghi",
    part_of_speech: "tính từ",
    meaning:
      "có điểm, có chỗ đang còn nghi ngờ, chờ được xác minh (thường nói về vấn đề nghiên cứu): tên tác giả của cuốn sách đang còn là vấn đề tồn nghi",
    example: "tên tác giả của cuốn sách đang còn là vấn đề tồn nghi",
  },
  {
    word: "tổn phí",
    part_of_speech: "động từ",
    meaning:
      "bỏ mất đi một cách vô ích: tổn phí nhiều tiền của * làm thế chỉ tổn phí thì giờ",
    example: "tổn phí nhiều tiền của * làm thế chỉ tổn phí thì giờ",
  },
  {
    word: "tôn phò",
    part_of_speech: "động từ",
    meaning:
      "(cũ) tôn kính, trung thành và hết lòng phò vua, chúa (nói khái quát): tôn phò nhà vua",
    example: "tôn phò nhà vua",
  },
  {
    word: "tôn nghiêm",
    part_of_speech: "tính từ",
    meaning:
      "trang nghiêm, gợi sự coi trọng, tôn kính: nơi thờ cúng tôn nghiêm",
    example: "nơi thờ cúng tôn nghiêm",
  },
  {
    word: "tôn sùng",
    part_of_speech: "động từ",
    meaning: "kính trọng đến mức gần như sùng bái: tư tưởng tôn sùng cá nhân",
    example: "tư tưởng tôn sùng cá nhân",
  },
  {
    word: "tôn sư trọng đạo",
    part_of_speech: "",
    meaning:
      "kính trọng thầy và coi trọng những kiến thức, cái đạo của thầy truyền lại, theo nho giáo: phát huy truyền thống tôn sư trọng đạo",
    example: "phát huy truyền thống tôn sư trọng đạo",
  },
  {
    word: "tồn tại",
    part_of_speech: "động từ",
    meaning:
      "ở trạng thái có thật, con người có thể nhận biết bằng giác quan, không phải do tưởng tượng ra: quá trình hình thành và tồn tại của sự vật * không có gì tồn tại vĩnh viễn",
    example:
      "quá trình hình thành và tồn tại của sự vật * không có gì tồn tại vĩnh viễn",
  },
  {
    word: "tồn tại",
    part_of_speech: "động từ",
    meaning:
      "còn lại, chưa mất đi, chưa được giải quyết: còn tồn tại nhiều khuyết điểm",
    example: "còn tồn tại nhiều khuyết điểm",
  },
  {
    word: "tồn tại",
    part_of_speech: "danh từ",
    meaning:
      "thế giới bên ngoài có được một cách khách quan, độc lập với ý thức của con người: tư duy và tồn tại",
    example: "tư duy và tồn tại",
  },
  {
    word: "tồn tại",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) vấn đề còn tồn tại (nói tắt): khắc phục các tồn tại",
    example: "khắc phục các tồn tại",
  },
  {
    word: "tổn thất",
    part_of_speech: "",
    meaning:
      "mất mát, thiệt hại: tổn thất về người và của * khắc phục những tổn thất sau cơn bão",
    example: "tổn thất về người và của * khắc phục những tổn thất sau cơn bão",
  },
  {
    word: "tôn tạo",
    part_of_speech: "động từ",
    meaning:
      "sửa chữa, làm lại những chỗ hư hỏng để bảo tồn một di tích lịch sử: trùng tu và tôn tạo lại ngôi chùa cổ",
    example: "trùng tu và tôn tạo lại ngôi chùa cổ",
  },
  {
    word: "tôn thờ",
    part_of_speech: "động từ",
    meaning:
      "ngưỡng mộ, coi trọng đến mức cho là thiêng liêng đối với mình: tôn thờ thần tượng",
    example: "tôn thờ thần tượng",
  },
  {
    word: "tổn thọ",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) làm giảm tuổi thọ: lo nghĩ nhiều đâm tổn thọ",
    example: "lo nghĩ nhiều đâm tổn thọ",
  },
  {
    word: "tôn trọng",
    part_of_speech: "động từ",
    meaning:
      "tỏ thái độ đánh giá cao và cho là không được vi phạm hoặc xúc phạm đến: tôn trọng lời hứa * tôn trọng chủ quyền và toàn vẹn lãnh thổ của mỗi nước",
    example:
      "tôn trọng lời hứa * tôn trọng chủ quyền và toàn vẹn lãnh thổ của mỗi nước",
  },
  {
    word: "tôn ti",
    part_of_speech: "danh từ",
    meaning:
      "trật tự có trên có dưới (nói về thứ bậc, trật tự trong xã hội): giữ gìn tôn ti trật tự",
    example: "giữ gìn tôn ti trật tự",
  },
  {
    word: "tổn thương",
    part_of_speech: "",
    meaning:
      "vùng mô bị suy giảm chức năng do bị tổn hại vì bệnh hoặc vì thương tích: tổn thương cột sống * các tổn thương do bỏng gây ra",
    example: "tổn thương cột sống * các tổn thương do bỏng gây ra",
  },
  {
    word: "tổn thương",
    part_of_speech: "",
    meaning:
      "(tình cảm) mất mát một phần, không còn được hoàn toàn nguyên vẹn như trước: lòng tự trọng bị tổn thương",
    example: "lòng tự trọng bị tổn thương",
  },
  {
    word: "tồn trữ",
    part_of_speech: "động từ",
    meaning: "(hiếm) cất giữ để dùng về sau: tồn trữ hàng hoá",
    example: "tồn trữ hàng hoá",
  },
  {
    word: "tông",
    part_of_speech: "danh từ",
    meaning: "cán (của một số dụng cụ): tông đục",
    example: "tông đục",
  },
  {
    word: "tông",
    part_of_speech: "danh từ",
    meaning: "(cũ) dòng dõi: lấy vợ xem tông, lấy chồng xem giống (tng)",
    example: "lấy vợ xem tông, lấy chồng xem giống (tng)",
  },
  {
    word: "tông",
    part_of_speech: "danh từ",
    meaning:
      "mảng màu trong hội hoạ, phân biệt được với nhau nhờ sắc độ chủ đạo đậm nhạt, hay nóng lạnh: dùng tông màu đen, trắng * bức tranh thiên về tông màu lạnh",
    example: "dùng tông màu đen, trắng * bức tranh thiên về tông màu lạnh",
  },
  {
    word: "tông",
    part_of_speech: "danh từ",
    meaning:
      "giọng hát, thường gồm nhiều loại: giọng trưởng, giọng thứ, giọng cao, giọng trung và giọng trầm: hát lạc tông, sai nhịp",
    example: "hát lạc tông, sai nhịp",
  },
  {
    word: "tông",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) đâm mạnh vào: tông cửa chạy ra * hai xe tông nhau",
    example: "tông cửa chạy ra * hai xe tông nhau",
  },
  {
    word: "tôn xưng",
    part_of_speech: "động từ",
    meaning: "gọi tôn lên một cách kính trọng: được tôn xưng là bà lớn",
    example: "được tôn xưng là bà lớn",
  },
  {
    word: "tồn vong",
    part_of_speech: "động từ",
    meaning:
      "(văn chương) tồn tại hay diệt vong, còn hay mất (thường nói về vận mệnh của dân tộc, đất nước): sự tồn vong của một dân tộc",
    example: "sự tồn vong của một dân tộc",
  },
  {
    word: "tồn ứ",
    part_of_speech: "động từ",
    meaning:
      "tồn nhiều đến mức ứ lại, không di chuyển hoặc không giải quyết được: hàng bị tồn ứ trong kho",
    example: "hàng bị tồn ứ trong kho",
  },
  {
    word: "tôn vinh",
    part_of_speech: "động từ",
    meaning:
      "tôn lên vị trí, danh hiệu cao quý vì được ngưỡng mộ hoặc vì có năng lực, phẩm chất đặc biệt: tôn vinh cái đẹp * một ca sĩ đang được tôn vinh",
    example: "tôn vinh cái đẹp * một ca sĩ đang được tôn vinh",
  },
  {
    word: "tổng",
    part_of_speech: "danh từ",
    meaning:
      "(Từ cũ) đơn vị hành chính ở nông thôn thời phong kiến, gồm một số xã: chưa đỗ ông nghè đã đe hàng tổng (tng)",
    example: "chưa đỗ ông nghè đã đe hàng tổng (tng)",
  },
  {
    word: "tổng",
    part_of_speech: "danh từ",
    meaning: "kết quả của phép cộng: tính tổng của hai số * tổng các số hạng",
    example: "tính tổng của hai số * tổng các số hạng",
  },
  {
    word: "tổng bãi công",
    part_of_speech: "động từ",
    meaning:
      "bãi công đồng loạt trong một hoặc nhiều ngành: cuộc tổng bãi công trên toàn quốc",
    example: "cuộc tổng bãi công trên toàn quốc",
  },
  {
    word: "tổng bí thư",
    part_of_speech: "danh từ",
    meaning:
      "người đứng đầu ban bí thư trung ương, hoặc đứng đầu ban chấp hành trung ương trong một số chính đảng: tổng bí thư Đảng cộng sản",
    example: "tổng bí thư Đảng cộng sản",
  },
  {
    word: "tống biệt",
    part_of_speech: "động từ",
    meaning:
      "(cũ, hiếm) tiễn đưa người đi xa: bài thơ tống biệt * mấy lời tống biệt",
    example: "bài thơ tống biệt * mấy lời tống biệt",
  },
  {
    word: "tống",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đánh mạnh và thẳng, thường bằng nắm tay: tống một quả đấm vào bụng",
    example: "tống một quả đấm vào bụng",
  },
  {
    word: "tống",
    part_of_speech: "động từ",
    meaning:
      "đẩy ra, đưa ra khỏi bằng một tác động mạnh: tống hết các thứ rác rưởi ra khỏi nhà * rửa ruột để tống chất độc ra ngoài",
    example:
      "tống hết các thứ rác rưởi ra khỏi nhà * rửa ruột để tống chất độc ra ngoài",
  },
  {
    word: "tống",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) dùng quyền lực đuổi đi, đưa đi, bằng hành động mạnh mẽ, dứt khoát: tống vào tù * tống ra khỏi nhà * tống đi cho khuất mắt!",
    example: "tống vào tù * tống ra khỏi nhà * tống đi cho khuất mắt!",
  },
  {
    word: "tống",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) đưa đến, gửi đến mà bất chấp có đồng ý nhận hay không: tống một cái giấy đòi nợ",
    example: "tống một cái giấy đòi nợ",
  },
  {
    word: "tống",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) cho vào bên trong cho bằng được, bất kể như thế nào: tống tất cả quần áo vào ba lô",
    example: "tống tất cả quần áo vào ba lô",
  },
  {
    word: "tông chi",
    part_of_speech: "danh từ",
    meaning:
      '(hiếm) các chi trong một họ (nói tổng quát): "Yêu nhau yêu cả đường đi, Ghét nhau ghét cả tông chi họ hàng." (ca dao)',
    example:
      'Yêu nhau yêu cả đường đi, Ghét nhau ghét cả tông chi họ hàng." (ca dao)',
  },
  {
    word: "tống chung",
    part_of_speech: "động từ",
    meaning: "(cũ, trang trọng) đưa người chết đến nơi chôn cất: lễ tống chung",
    example: "lễ tống chung",
  },
  {
    word: "tống cổ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đuổi đi hoặc bắt phải đi bằng hành động mạnh mẽ, dứt khoát: tống cổ ra khỏi nhà",
    example: "tống cổ ra khỏi nhà",
  },
  {
    word: "tổng chỉ huy",
    part_of_speech: "danh từ",
    meaning:
      "người đứng đầu ban chỉ huy ở cấp cao nhất: tổng chỉ huy chiến dịch",
    example: "tổng chỉ huy chiến dịch",
  },
  {
    word: "tổng chi",
    part_of_speech: "danh từ",
    meaning: "tổng số chi: tổng chi của một tháng",
    example: "tổng chi của một tháng",
  },
  {
    word: "tổng bộ",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) cơ quan chỉ huy trung ương của một số đoàn thể chính trị: tổng bộ Việt Minh",
    example: "tổng bộ Việt Minh",
  },
  {
    word: "tổng cộng",
    part_of_speech: "động từ",
    meaning: "cộng tất cả lại: tổng cộng các khoản chi thu * tính tổng cộng",
    example: "tổng cộng các khoản chi thu * tính tổng cộng",
  },
  {
    word: "tổng công ti",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức kinh doanh gồm nhiều công ti trong cùng một ngành kinh tế: tổng công ti xây dựng",
    example: "tổng công ti xây dựng",
  },
  {
    word: "tổng cục",
    part_of_speech: "danh từ",
    meaning:
      "cơ quan trung ương quản lí một ngành chuyên môn thuộc một bộ hay trực thuộc chính phủ: tổng cục thống kê * tổng cục du lịch",
    example: "tổng cục thống kê * tổng cục du lịch",
  },
  {
    word: "tổng công ty",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức kinh doanh gồm nhiều công ti trong cùng một ngành kinh tế: tổng công ti xây dựng",
    example: "tổng công ti xây dựng",
  },
  {
    word: "tổng dự toán",
    part_of_speech: "danh từ",
    meaning:
      "bản dự toán chung của ngân sách trong một thời kì, thường một năm, hoặc bản dự toán chung các khoản chi cho toàn bộ các hạng mục công trình: bản tổng dự toán ngân sách",
    example: "bản tổng dự toán ngân sách",
  },
  {
    word: "tổng đài",
    part_of_speech: "danh từ",
    meaning:
      "máy nối với nhiều máy điện thoại để dùng chung một đường dây: tổng đài 1080 * gọi điện thoại qua tổng đài",
    example: "tổng đài 1080 * gọi điện thoại qua tổng đài",
  },
  {
    word: "tống đạt",
    part_of_speech: "động từ",
    meaning:
      "chuyển đến đương sự giấy tờ của cơ quan hành pháp: tống đạt quyết định triệu tập của toà án",
    example: "tống đạt quyết định triệu tập của toà án",
  },
  {
    word: "tổng động viên",
    part_of_speech: "động từ",
    meaning:
      "động viên toàn bộ lực lượng của cả nước: thi hành lệnh tổng động viên",
    example: "thi hành lệnh tổng động viên",
  },
  {
    word: "tổng đội",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức gồm nhiều đội cùng làm một nhiệm vụ: tổng đội thanh niên xung phong",
    example: "tổng đội thanh niên xung phong",
  },
  {
    word: "tông đường",
    part_of_speech: "danh từ",
    meaning: "nhà thờ họ; thường dùng để chỉ dòng họ: nối dõi tông đường",
    example: "nối dõi tông đường",
  },
  {
    word: "tổng đốc",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) chức quan đứng đầu bộ máy cai trị một tỉnh lớn thời phong kiến, thực dân: quan tổng đốc",
    example: "quan tổng đốc",
  },
  {
    word: "tổng hoà",
    part_of_speech: "danh từ",
    meaning: "sự tổng hợp, tổng thể: con người là tổng hoà của các mối quan hệ",
    example: "con người là tổng hoà của các mối quan hệ",
  },
  {
    word: "tống giam",
    part_of_speech: "động từ",
    meaning: "bắt đưa vào nhà giam: bị tống giam",
    example: "bị tống giam",
  },
  {
    word: "tổng hành dinh",
    part_of_speech: "danh từ",
    meaning:
      "nơi tướng chỉ huy và cơ quan tổng tham mưu đóng: tấn công vào tổng hành dinh của giặc",
    example: "tấn công vào tổng hành dinh của giặc",
  },
  {
    word: "tổng hợp",
    part_of_speech: "động từ",
    meaning:
      "tổ hợp các yếu tố riêng rẽ nào đó làm thành một chỉnh thể: tổng hợp số liệu * bài viết được tổng hợp từ nhiều nguồn khác nhau",
    example:
      "tổng hợp số liệu * bài viết được tổng hợp từ nhiều nguồn khác nhau",
  },
  {
    word: "tổng hợp",
    part_of_speech: "tính từ",
    meaning:
      "được chế tạo ra từ những chất đơn giản bằng phản ứng hoá học: sợi tổng hợp",
    example: "sợi tổng hợp",
  },
  {
    word: "tổng hợp",
    part_of_speech: "tính từ",
    meaning:
      "bao gồm nhiều thành phần có quan hệ chặt chẽ với nhau, làm thành một chỉnh thể: sức mạnh tổng hợp * sân khấu là một loại hình nghệ thuật tổng hợp",
    example:
      "sức mạnh tổng hợp * sân khấu là một loại hình nghệ thuật tổng hợp",
  },
  {
    word: "tổng hợp",
    part_of_speech: "tính từ",
    meaning:
      "bao gồm nhiều loại, nhiều thứ khác nhau: trường đại học tổng hợp * bách hoá tổng hợp",
    example: "trường đại học tổng hợp * bách hoá tổng hợp",
  },
  {
    word: "tổng hội",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức gồm nhiều hội thuộc cùng một ngành hoạt động: tổng hội sinh viên * tổng hội Phật giáo Việt Nam",
    example: "tổng hội sinh viên * tổng hội Phật giáo Việt Nam",
  },
  {
    word: "tổng kho",
    part_of_speech: "danh từ",
    meaning: "kho chính có lượng chứa lớn: tổng kho xăng dầu",
    example: "tổng kho xăng dầu",
  },
  {
    word: "tổng khởi nghĩa",
    part_of_speech: "",
    meaning:
      "khởi nghĩa trong cả nước: cuộc tổng khởi nghĩa tháng Tám năm 1945",
    example: "cuộc tổng khởi nghĩa tháng Tám năm 1945",
  },
  {
    word: "tổng kết",
    part_of_speech: "động từ",
    meaning:
      "nhìn lại toàn bộ việc đã làm, khi đã kết thúc hoặc sau một giai đoạn, để có sự đánh giá, rút ra những kết luận chung: tổng kết năm học * họp tổng kết cuối năm",
    example: "tổng kết năm học * họp tổng kết cuối năm",
  },
  {
    word: "tổng lực",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ các lực lượng được sử dụng một cách tổng hợp: sức mạnh tổng lực * huy động tổng lực cho trận đánh",
    example: "sức mạnh tổng lực * huy động tổng lực cho trận đánh",
  },
  {
    word: "tổng luận",
    part_of_speech: "danh từ",
    meaning:
      "bài viết bàn một cách khái quát về một vấn đề gì đó: tổng luận tình hình thế giới trong năm vừa qua",
    example: "tổng luận tình hình thế giới trong năm vừa qua",
  },
  {
    word: "tống khứ",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) đuổi đi xa: tống khứ nó đi cho khuất mắt!",
    example: "tống khứ nó đi cho khuất mắt!",
  },
  {
    word: "tổng lượng",
    part_of_speech: "danh từ",
    meaning:
      "số lượng tính toàn bộ, theo một tiêu chí nào đó: tổng lượng gạo xuất khẩu trong quý I tăng cao",
    example: "tổng lượng gạo xuất khẩu trong quý I tăng cao",
  },
  {
    word: "tồng ngồng",
    part_of_speech: "tính từ",
    meaning:
      "(thông tục) không mặc quần áo, mà trần truồng, để lộ hết các chỗ kín của thân thể ra, trông khó coi: đứa trẻ đứng tắm tồng ngồng",
    example: "đứa trẻ đứng tắm tồng ngồng",
  },
  {
    word: "tồng ngồng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có vóc dáng như người lớn, không còn bé nhỏ gì nữa (hàm ý chê): lớn tồng ngồng rồi mà vẫn chưa biết làm gì",
    example: "lớn tồng ngồng rồi mà vẫn chưa biết làm gì",
  },
  {
    word: "tông môn",
    part_of_speech: "danh từ",
    meaning: "(cũ) dòng họ: làm rạng rỡ tông môn",
    example: "làm rạng rỡ tông môn",
  },
  {
    word: "tổng nha",
    part_of_speech: "danh từ",
    meaning:
      "như nha (từ dùng trong bộ máy của chính quyền Sài Gòn trước 1975): tổng nha cảnh sát",
    example: "tổng nha cảnh sát",
  },
  {
    word: "tổng quan",
    part_of_speech: "",
    meaning:
      "(hiếm) có tính chất nhìn chung, bao quát: kiến thức tổng quan * có cái nhìn tổng quan",
    example: "kiến thức tổng quan * có cái nhìn tổng quan",
  },
  {
    word: "tổng quát",
    part_of_speech: "động từ",
    meaning:
      "nhìn chung toàn bộ, không chú ý đến chi tiết: nhìn tổng quát * đánh giá tổng quát tình hình kinh tế cả năm",
    example: "nhìn tổng quát * đánh giá tổng quát tình hình kinh tế cả năm",
  },
  {
    word: "tông phái",
    part_of_speech: "danh từ",
    meaning:
      "ngành trong một họ: tông phái hoàng gia * các tông phái họ Nguyễn",
    example: "tông phái hoàng gia * các tông phái họ Nguyễn",
  },
  {
    word: "tông phái",
    part_of_speech: "danh từ",
    meaning:
      "phái trong một học thuyết, một tôn giáo: thiền tông là một tông phái của đạo Phật",
    example: "thiền tông là một tông phái của đạo Phật",
  },
  {
    word: "tổng phổ",
    part_of_speech: "danh từ",
    meaning:
      "bản nhạc ghi cho dàn nhạc nhiều bè với nhiều loại nhạc cụ cùng chơi: bản tổng phổ",
    example: "bản tổng phổ",
  },
  {
    word: "tổng sản lượng",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ sản lượng trong một năm: tổng sản lượng lương thực trong năm tăng 20%",
    example: "tổng sản lượng lương thực trong năm tăng 20%",
  },
  {
    word: "tổng số",
    part_of_speech: "danh từ",
    meaning:
      "số cộng chung tất cả: thắng cử với 60% tổng số phiếu bầu * nhà máy có tổng số 2.000 công nhân",
    example:
      "thắng cử với 60% tổng số phiếu bầu * nhà máy có tổng số 2.000 công nhân",
  },
  {
    word: "tống táng",
    part_of_speech: "động từ",
    meaning: "(cũ) chôn cất.",
    example: "cái gì không dùng được thì tống táng đi",
  },
  {
    word: "tống táng",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) một cách vội vã, chỉ cốt cho chóng hết, chóng xong: bán tống táng đống hàng cũ",
    example: "bán tống táng đống hàng cũ",
  },
  {
    word: "tổng thành",
    part_of_speech: "danh từ",
    meaning:
      "cụm đồng bộ các bộ phận trong máy móc, đảm bảo một chức năng hoạt động chính nào đó: phân xưởng lắp tổng thành",
    example: "phân xưởng lắp tổng thành",
  },
  {
    word: "tổng tấn công",
    part_of_speech: "động từ",
    meaning:
      "tiến công có tính chất chiến lược nhằm giành thắng lợi quyết định trong chiến tranh: cuộc tổng tiến công và nổi dậy mùa xuân 1975",
    example: "cuộc tổng tiến công và nổi dậy mùa xuân 1975",
  },
  {
    word: "tổng tập",
    part_of_speech: "danh từ",
    meaning: "tuyển tập tác phẩm của nhiều tác giả: tổng tập văn học Việt Nam",
    example: "tổng tập văn học Việt Nam",
  },
  {
    word: "tổng thể",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp nhiều sự vật có quan hệ chặt chẽ với nhau, làm thành một thể thống nhất có những đặc trưng chung: tổng thể kiến trúc * tổng thể nền kinh tế quốc dân",
    example: "tổng thể kiến trúc * tổng thể nền kinh tế quốc dân",
  },
  {
    word: "tổng thể",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) có tính chất của tổng thể: quy hoạch tổng thể * có cái nhìn tổng thể",
    example: "quy hoạch tổng thể * có cái nhìn tổng thể",
  },
  {
    word: "tổng thu",
    part_of_speech: "danh từ",
    meaning: "tổng số thu: tính tổng thu hằng tháng",
    example: "tính tổng thu hằng tháng",
  },
  {
    word: "tổng thư kí",
    part_of_speech: "danh từ",
    meaning:
      "người đứng đầu ban thư kí phụ trách công việc chung của một tổ chức, một đoàn thể lớn: tổng thư kí Liên Hợp Quốc * tổng thư kí liên đoàn bóng đá",
    example: "tổng thư kí Liên Hợp Quốc * tổng thư kí liên đoàn bóng đá",
  },
  {
    word: "tổng thuật",
    part_of_speech: "động từ",
    meaning:
      "thuật lại một cách khái quát những nội dung cơ bản: tổng thuật các trận bóng đá trong tuần",
    example: "tổng thuật các trận bóng đá trong tuần",
  },
  {
    word: "tống tiền",
    part_of_speech: "động từ",
    meaning: "đe doạ hoặc hành hung để bắt phải nộp tiền: bắt cóc để tống tiền",
    example: "bắt cóc để tống tiền",
  },
  {
    word: "tống tiễn",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tống cổ đi một cách nhanh chóng, dứt khoát (nói về người từ nơi khác đến): chỉ muốn tống tiễn đi cho rảnh mắt",
    example: "chỉ muốn tống tiễn đi cho rảnh mắt",
  },
  {
    word: "tông tích",
    part_of_speech: "danh từ",
    meaning:
      "nguồn gốc, lai lịch của một người: biết rõ tông tích * giấu tông tích",
    example: "biết rõ tông tích * giấu tông tích",
  },
  {
    word: "tổng thư ký",
    part_of_speech: "danh từ",
    meaning:
      "người đứng đầu ban thư kí phụ trách công việc chung của một tổ chức, một đoàn thể lớn: tổng thư kí Liên Hợp Quốc * tổng thư kí liên đoàn bóng đá",
    example: "tổng thư kí Liên Hợp Quốc * tổng thư kí liên đoàn bóng đá",
  },
  {
    word: "tổng tiến công",
    part_of_speech: "động từ",
    meaning:
      "tiến công có tính chất chiến lược nhằm giành thắng lợi quyết định trong chiến tranh: cuộc tổng tiến công và nổi dậy mùa xuân 1975",
    example: "cuộc tổng tiến công và nổi dậy mùa xuân 1975",
  },
  {
    word: "tông tốc",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) (nói) liền một mạch hết mọi điều, không suy tính, cân nhắc gì cả: có gì cũng tông tốc nói ra",
    example: "có gì cũng tông tốc nói ra",
  },
  {
    word: "tốp ca",
    part_of_speech: "danh từ",
    meaning:
      "hình thức biểu diễn nghệ thuật, do một tốp năm bảy người cùng hát: bài hát do tốp ca nữ thể hiện",
    example: "bài hát do tốp ca nữ thể hiện",
  },
  {
    word: "tồng tộc",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) từ gợi tả lối nói năng có gì cũng đem tuôn ra hết một cách nhanh nhảu, dễ dàng: có gì nói tồng tộc ra hết * khai tồng tộc",
    example: "có gì nói tồng tộc ra hết * khai tồng tộc",
  },
  {
    word: "tốp",
    part_of_speech: "danh từ",
    meaning:
      "nhóm gồm một số ít người hoặc vật, cùng đi hoặc cùng hoạt động với nhau: tốp lính * đi thành từng tốp * mỗi tốp thợ có 5 người",
    example: "tốp lính * đi thành từng tốp * mỗi tốp thợ có 5 người",
  },
  {
    word: "tốp",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) ngừng lại, hãm lại: xe tốp máy",
    example: "xe tốp máy",
  },
  {
    word: "tổng vệ sinh",
    part_of_speech: "động từ",
    meaning:
      "quét dọn, làm vệ sinh chung ở mọi chỗ cùng một lúc: tổng vệ sinh toàn thành phố",
    example: "tổng vệ sinh toàn thành phố",
  },
  {
    word: "tốt",
    part_of_speech: "danh từ",
    meaning:
      "quân có giá trị thấp nhất trong bàn cờ tướng, cờ vua hoặc bộ tam cúc: đôi tốt * cờ bí gí tốt",
    example: "đôi tốt * cờ bí gí tốt",
  },
  {
    word: "tốt",
    part_of_speech: "tính từ",
    meaning:
      "có phẩm chất, chất lượng cao hơn mức bình thường: vải tốt * tốt gỗ hơn tốt nước sơn (tng)",
    example: "vải tốt * tốt gỗ hơn tốt nước sơn (tng)",
  },
  {
    word: "tốt",
    part_of_speech: "tính từ",
    meaning:
      "có những biểu hiện đáng quý về tư cách, đạo đức, hành vi, được mọi người đánh giá cao: tốt tính * có lòng tốt * gương người tốt việc tốt",
    example: "tốt tính * có lòng tốt * gương người tốt việc tốt",
  },
  {
    word: "tốt",
    part_of_speech: "tính từ",
    meaning:
      "vừa ý, không có gì làm cho phải phàn nàn: kết quả tốt * máy chạy tốt * mọi việc đều tốt cả",
    example: "kết quả tốt * máy chạy tốt * mọi việc đều tốt cả",
  },
  {
    word: "tốt",
    part_of_speech: "tính từ",
    meaning:
      "thuận lợi, có khả năng mang lại nhiều điều hay: thời tiết tốt * điều kiện tốt * có được cơ hội tốt",
    example: "thời tiết tốt * điều kiện tốt * có được cơ hội tốt",
  },
  {
    word: "tốt",
    part_of_speech: "tính từ",
    meaning:
      "ở tình trạng phát triển mạnh, biểu hiện có nhiều sức sống (thường nói về cây cỏ): cỏ cây xanh tốt * tóc tốt * người===== đẹp =====",
    example: "cỏ cây xanh tốt * tóc tốt * người===== đẹp =====",
  },
  {
    word: "tốt",
    part_of_speech: "tính từ",
    meaning: "đẹp: văn hay chữ tốt",
    example: "văn hay chữ tốt",
  },
  {
    word: "tốt",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) từ biểu thị điều vừa nêu ra, theo ý người nói, là hoàn toàn có khả năng (dùng để trả lời ý hoài nghi của người đối thoại): cũ nhưng vẫn dùng tốt * ngần này thì nó gánh tốt",
    example: "cũ nhưng vẫn dùng tốt * ngần này thì nó gánh tốt",
  },
  {
    word: "tốt bụng",
    part_of_speech: "tính từ",
    meaning:
      "có lòng tốt, hay thương người và sẵn sàng giúp đỡ người khác: một con người tốt bụng",
    example: "một con người tốt bụng",
  },
  {
    word: "tột",
    part_of_speech: "phụ từ",
    meaning:
      "đến mức cao nhất, không thể hơn: nguy khốn đến tột mức * địa vị tột cao",
    example: "nguy khốn đến tột mức * địa vị tột cao",
  },
  {
    word: "tột bậc",
    part_of_speech: "danh từ",
    meaning: "bậc cao nhất, mức độ cao nhất: chu đáo đến tột bậc",
    example: "chu đáo đến tột bậc",
  },
  {
    word: "tột bậc",
    part_of_speech: "tính từ",
    meaning:
      "ở bậc cao nhất, không còn có thể hơn: tột bậc sang giàu * cố gắng tột bậc * đau đớn tột bậc",
    example: "tột bậc sang giàu * cố gắng tột bậc * đau đớn tột bậc",
  },
  {
    word: "tốt đẹp",
    part_of_speech: "tính từ",
    meaning:
      "được đánh giá là làm hài lòng, được như mong muốn: truyền thống tốt đẹp * hội nghị thành công tốt đẹp",
    example: "truyền thống tốt đẹp * hội nghị thành công tốt đẹp",
  },
  {
    word: "tột cùng",
    part_of_speech: "",
    meaning:
      "tới giới hạn cuối cùng, không thể hơn được nữa: vui sướng tột cùng",
    example: "vui sướng tột cùng",
  },
  {
    word: "tột đỉnh",
    part_of_speech: "",
    meaning:
      "đỉnh cao nhất, mức độ cao nhất: căng thẳng đến tột đỉnh * vươn tới tột đỉnh vinh quang",
    example: "căng thẳng đến tột đỉnh * vươn tới tột đỉnh vinh quang",
  },
  {
    word: "tốt đôi",
    part_of_speech: "tính từ",
    meaning:
      '(đôi nam nữ) có sự tương xứng, hoà hợp với nhau để làm thành hoặc có thể trở thành cặp vợ chồng hạnh phúc: "Chàng đà yên phận tốt đôi, Em nay lẻ bạn mồ côi một mình." (ca dao)',
    example:
      'Chàng đà yên phận tốt đôi, Em nay lẻ bạn mồ côi một mình." (ca dao)',
  },
  {
    word: "tốt giọng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có giọng hát hoặc giọng nói hay, dễ nghe: chọn người tốt giọng làm phát thanh viên",
    example: "chọn người tốt giọng làm phát thanh viên",
  },
  {
    word: "tốt nái",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có khả năng sinh đẻ nhiều (thường nói về lợn nái): con lợn tốt nái",
    example: "con lợn tốt nái",
  },
  {
    word: "tột độ",
    part_of_speech: "",
    meaning:
      "mức độ cao nhất, không còn có thể hơn được nữa của một trạng thái (thường nói về trạng thái tình cảm): tức giận tột độ * ánh mắt biểu lộ sự buồn rầu đến tột độ",
    example: "tức giận tột độ * ánh mắt biểu lộ sự buồn rầu đến tột độ",
  },
  {
    word: "tốt lành",
    part_of_speech: "tính từ",
    meaning:
      "tốt đẹp, may mắn, mang lại sự yên vui, không có điều gì khó khăn, trắc trở: thời tiết tốt lành * tin tốt lành",
    example: "thời tiết tốt lành * tin tốt lành",
  },
  {
    word: "tốt nết",
    part_of_speech: "tính từ",
    meaning: "có tính nết tốt, dễ mến: con bé không xinh nhưng tốt nết",
    example: "con bé không xinh nhưng tốt nết",
  },
  {
    word: "tốt ngày",
    part_of_speech: "tính từ",
    meaning:
      "(ngày) tốt lành, có khả năng mang lại nhiều may mắn, theo quan niệm dân gian: chọn hôm tốt ngày để đi dạm hỏi",
    example: "chọn hôm tốt ngày để đi dạm hỏi",
  },
  {
    word: "tốt mã",
    part_of_speech: "tính từ",
    meaning:
      'có vẻ bên ngoài đẹp đẽ (thường hàm ý chê): chàng trai tốt mã * "Con gà tốt mã vì lông, Răng đen vì thuốc rượu nồng vì men." (ca dao)',
    example:
      'chàng trai tốt mã * "Con gà tốt mã vì lông, Răng đen vì thuốc rượu nồng vì men." (ca dao)',
  },
  {
    word: "tốt nhịn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) giỏi nhịn, không phản ứng lại khi gặp điều trái ý: tốt nhịn nên ít xảy ra to tiếng",
    example: "tốt nhịn nên ít xảy ra to tiếng",
  },
  {
    word: "tốt nghiệp",
    part_of_speech: "động từ",
    meaning:
      "được công nhận đã đạt tiêu chuẩn kiểm tra kiến thức hoặc trình độ nghiệp vụ sau khi học xong một trường hoặc một bậc học, một cấp học: luận văn tốt nghiệp * kĩ sư mới tốt nghiệp",
    example: "luận văn tốt nghiệp * kĩ sư mới tốt nghiệp",
  },
  {
    word: "tốt số",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có số phận may mắn, thường gặp những điều như ý: tốt số lấy được chồng tài",
    example: "tốt số lấy được chồng tài",
  },
  {
    word: "tốt phúc",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có nhiều phúc, thường gặp may mắn: tốt phúc nên thoát nạn * tốt phúc lấy được vợ hiền",
    example: "tốt phúc nên thoát nạn * tốt phúc lấy được vợ hiền",
  },
  {
    word: "tốt tính",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có nhiều tính tốt, thể hiện trong cách ăn ở, cư xử thường ngày: một người tốt tính",
    example: "một người tốt tính",
  },
  {
    word: "tơ",
    part_of_speech: "danh từ",
    meaning:
      "sợi rất mảnh, mượt, do tằm, nhện nhả ra: tằm nhả tơ * nhện chăng tơ",
    example: "tằm nhả tơ * nhện chăng tơ",
  },
  {
    word: "tơ",
    part_of_speech: "danh từ",
    meaning:
      "tơ do con tằm nhả ra, dùng làm sợi để dệt: ươm tơ * quay tơ dệt lụa * buôn chỉ bán tơ",
    example: "ươm tơ * quay tơ dệt lụa * buôn chỉ bán tơ",
  },
  {
    word: "tơ",
    part_of_speech: "danh từ",
    meaning: "sợi rất mảnh và mượt như tơ tằm: tơ chuối * tơ dứa",
    example: "tơ chuối * tơ dứa",
  },
  {
    word: "tơ",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, văn chương) dây đàn; cũng dùng để chỉ cây đàn: đàn đứt dây tơ * tiếng tơ, tiếng trúc",
    example: "đàn đứt dây tơ * tiếng tơ, tiếng trúc",
  },
  {
    word: "tơ",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) sợi dây; dùng để biểu trưng cho mối tình gắn bó đôi nam nữ: "Nuôi con những ước về sau, Trao tơ phải lứa, gieo cầu đáng nơi." (TKiều)',
    example:
      'Nuôi con những ước về sau, Trao tơ phải lứa, gieo cầu đáng nơi." (TKiều)',
  },
  {
    word: "tơ",
    part_of_speech: "tính từ",
    meaning:
      "(lông, tóc) rất mảnh sợi, mềm và mượt như tơ: lông tơ * mái tóc tơ",
    example: "lông tơ * mái tóc tơ",
  },
  {
    word: "tơ",
    part_of_speech: "tính từ",
    meaning:
      "(động vật, thực vật) còn non, mới vừa lớn lên: gà mái tơ * hàng dừa tơ",
    example: "gà mái tơ * hàng dừa tơ",
  },
  {
    word: "tơ",
    part_of_speech: "tính từ",
    meaning:
      '(khẩu ngữ) (thanh niên) mới lớn lên, chưa có vợ, có chồng: trai tơ * "Bầu già thì mướp cũng xơ, Nạ dòng trang điểm gái tơ mất chồng." (ca dao)',
    example:
      'trai tơ * "Bầu già thì mướp cũng xơ, Nạ dòng trang điểm gái tơ mất chồng." (ca dao)',
  },
  {
    word: "tột vời",
    part_of_speech: "tính từ",
    meaning: "(cũ) ở mức cao nhất, không gì sánh nổi: đức hạnh tột vời",
    example: "đức hạnh tột vời",
  },
  {
    word: "tớ",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) đầy tớ (nói tắt): "Trước thầy sau tớ lao xao, Nhà băng đưa mối, rước vào lầu trang." (TKiều)',
    example:
      'Trước thầy sau tớ lao xao, Nhà băng đưa mối, rước vào lầu trang." (TKiều)',
  },
  {
    word: "tớ",
    part_of_speech: "đại từ",
    meaning:
      "từ dùng để tự xưng một cách thân mật giữa bạn bè thường còn ít tuổi: cậu giúp tớ việc này nhé * chuyện đó, tớ không biết",
    example: "cậu giúp tớ việc này nhé * chuyện đó, tớ không biết",
  },
  {
    word: "tở",
    part_of_speech: "động từ",
    meaning:
      "rời ra hoặc làm cho rời nhau ra, không còn kết dính vào với nhau nữa: vôi tở * đất tở ra từng tảng",
    example: "vôi tở * đất tở ra từng tảng",
  },
  {
    word: "tờ",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị riêng lẻ những mảnh giấy được cắt, xén vuông vắn: quyển sách bị rách mất một tờ * nén bạc đâm toạc tờ giấy (tng)",
    example: "quyển sách bị rách mất một tờ * nén bạc đâm toạc tờ giấy (tng)",
  },
  {
    word: "tờ",
    part_of_speech: "danh từ",
    meaning:
      "tờ giấy có viết hay in một nội dung nhất định, theo một kiểu, một mẫu nào đó: tờ đơn * mua một tờ báo * phát hiện một tờ tiền giả",
    example: "tờ đơn * mua một tờ báo * phát hiện một tờ tiền giả",
  },
  {
    word: "tờ",
    part_of_speech: "danh từ",
    meaning:
      "mặt tờ giấy rất phẳng, dùng để ví trạng thái cảnh vật hoàn toàn yên tĩnh, không có chút động: mặt nước lặng tờ * bốn bề lặng phắc như tờ",
    example: "mặt nước lặng tờ * bốn bề lặng phắc như tờ",
  },
  {
    word: "tốt tươi",
    part_of_speech: "tính từ",
    meaning: "như tươi tốt: cây cối tốt tươi",
    example: "cây cối tốt tươi",
  },
  {
    word: "tơ duyên",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) sợi tơ hồng ràng buộc đôi trai gái; chỉ tình yêu nam nữ, tình duyên vợ chồng: "Trăm nghìn gửi lại tình quân, Tơ duyên ngắn ngủi có ngần ấy thôi." (TKiều)',
    example:
      'Trăm nghìn gửi lại tình quân, Tơ duyên ngắn ngủi có ngần ấy thôi." (TKiều)',
  },
  {
    word: "tơ đồng",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) đàn, tiếng đàn: "Cùng trong một tiếng tơ đồng, Người ngoài cười nụ, người trong khóc thầm!" (TKiều)',
    example:
      'Cùng trong một tiếng tơ đồng, Người ngoài cười nụ, người trong khóc thầm!" (TKiều)',
  },
  {
    word: "tơ hào",
    part_of_speech: "động từ",
    meaning:
      "lấy một phần rất nhỏ, không đáng kể của công hay của người khác làm của riêng: không tơ hào lấy một đồng tiền công quỹ",
    example: "không tơ hào lấy một đồng tiền công quỹ",
  },
  {
    word: "tơ hào",
    part_of_speech: "động từ",
    meaning:
      'tơ màng đến, dù chỉ thoáng qua: "Giường rộng thì ghé lưng vào, Nghìn năm ai có tơ hào với ai." (ca dao)',
    example:
      'Giường rộng thì ghé lưng vào, Nghìn năm ai có tơ hào với ai." (ca dao)',
  },
  {
    word: "tơ lụa",
    part_of_speech: "danh từ",
    meaning:
      "hàng dệt bằng tơ tằm như lụa, vải, v.v. (nói khái quát): cửa hàng tơ lụa * nghề tơ lụa",
    example: "cửa hàng tơ lụa * nghề tơ lụa",
  },
  {
    word: "tơ lơ mơ",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như lơ tơ mơ: hiểu một cách tơ lơ mơ",
    example: "hiểu một cách tơ lơ mơ",
  },
  {
    word: "tơ hồng",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) sợi chỉ đỏ, dùng để biểu trưng cho tình duyên do trời định, theo một điển tích cổ của Trung Quốc: "Dây tơ hồng chưa xe đã mắc, Rượu quỳnh tương chưa nhắp đã say." (ca dao)',
    example:
      'Dây tơ hồng chưa xe đã mắc, Rượu quỳnh tương chưa nhắp đã say." (ca dao)',
  },
  {
    word: "tơ lòng",
    part_of_speech: "danh từ",
    meaning:
      '(văn chương) nỗi thương nhớ người yêu vương vấn trong lòng, vấn vít như tơ: trăm mối tơ lòng * "Tiếc thay chút nghĩa cũ càng, Dầu lìa ngó ý còn vương tơ lòng." (TKiều)',
    example:
      'trăm mối tơ lòng * "Tiếc thay chút nghĩa cũ càng, Dầu lìa ngó ý còn vương tơ lòng." (TKiều)',
  },
  {
    word: "tơ màng",
    part_of_speech: "động từ",
    meaning: "nghĩ đến và mong muốn có được: không tơ màng danh lợi",
    example: "không tơ màng danh lợi",
  },
  {
    word: "tờ mây",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) giấy hoa tiên có vẽ mây: "Chiếc thoa với bức tờ mây, Duyên này thì giữ vật này của chung." (TKiều)',
    example:
      'Chiếc thoa với bức tờ mây, Duyên này thì giữ vật này của chung." (TKiều)',
  },
  {
    word: "tở mở",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) hớn hở, phấn khởi: reo hò tở mở",
    example: "reo hò tở mở",
  },
  {
    word: "tơ mành",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) sợi tơ mảnh, dùng để ví tình yêu vương vấn của đôi trai gái: "Cho hay là thói hữu tình, Đố ai dứt mối tơ mành cho xong!" (TKiều)',
    example:
      'Cho hay là thói hữu tình, Đố ai dứt mối tơ mành cho xong!" (TKiều)',
  },
  {
    word: "tơ mơ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tơ tưởng đến một cách không đứng đắn (trong quan hệ nam nữ): tơ mơ cô hàng xóm",
    example: "tơ mơ cô hàng xóm",
  },
  {
    word: "tơ mơ",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như tờ mờ: đi từ tơ mơ đất",
    example: "đi từ tơ mơ đất",
  },
  {
    word: "tơ mơ",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như lơ mơ: hiểu tơ mơ",
    example: "hiểu tơ mơ",
  },
  {
    word: "tờ rơi",
    part_of_speech: "danh từ",
    meaning:
      "tờ giấy nhỏ có nội dung vận động, tuyên truyền hay quảng cáo, được rải, thả ở chỗ đông người hoặc được phát một cách rộng rãi: phát tờ rơi tuyên truyền về 'kế hoạch hoá gia đình'",
    example: "phát tờ rơi tuyên truyền về 'kế hoạch hoá gia đình'",
  },
  {
    word: "tờ mờ đất",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (lúc) tờ mờ sáng, lúc còn nhìn chưa rõ mặt đất: ra đi từ tờ mờ đất",
    example: "ra đi từ tờ mờ đất",
  },
  {
    word: "tơ tằm",
    part_of_speech: "danh từ",
    meaning:
      "tơ do con tằm nhả ra, dùng để dệt vải, lụa: lụa tơ tằm * hàng tơ tằm",
    example: "lụa tơ tằm * hàng tơ tằm",
  },
  {
    word: "tờ mờ",
    part_of_speech: "tính từ",
    meaning:
      "(trời) còn mờ mờ, chưa sáng hẳn, chưa nhìn thấy rõ nét cảnh vật: dậy từ lúc tờ mờ",
    example: "dậy từ lúc tờ mờ",
  },
  {
    word: "tơ tình",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) tình yêu vương vấn như tơ: chắp mối tơ tình * "Hỡi ơi, nói hết sự duyên, Tơ tình đứt ruột, lửa phiền cháy gan!" (TKiều)',
    example:
      'chắp mối tơ tình * "Hỡi ơi, nói hết sự duyên, Tơ tình đứt ruột, lửa phiền cháy gan!" (TKiều)',
  },
  {
    word: "tơ tưởng",
    part_of_speech: "động từ",
    meaning:
      '(khẩu ngữ) nghĩ liên miên không dứt đến người hoặc cái mà mình nhớ mong, ước muốn: tơ tưởng chuyện làm giàu * "Duyên kia ai đợi mà chờ, Tình kia ai tưởng mà tơ tưởng tình." (ca dao)',
    example:
      'tơ tưởng chuyện làm giàu * "Duyên kia ai đợi mà chờ, Tình kia ai tưởng mà tơ tưởng tình." (ca dao)',
  },
  {
    word: "tờ trình",
    part_of_speech: "danh từ",
    meaning:
      "văn bản mang những thông tin và yêu cầu cụ thể về một vấn đề để trình lên cấp trên xem xét, phê duyệt: tờ trình về dự án Luật doanh nghiệp",
    example: "tờ trình về dự án Luật doanh nghiệp",
  },
  {
    word: "tơ vương",
    part_of_speech: "",
    meaning:
      "tơ bị dính vào nhau; dùng để ví tình cảm yêu đương vương vấn, khó dứt bỏ: mối tơ vương * không còn tơ vương gì đến nhau nữa",
    example: "mối tơ vương * không còn tơ vương gì đến nhau nữa",
  },
  {
    word: "tơ vò",
    part_of_speech: "danh từ",
    meaning:
      "tơ bị vò rối; dùng để ví tình hình rối rắm khó nghĩ ra cách giải quyết: trăm mối tơ vò * lòng rối như tơ vò",
    example: "trăm mối tơ vò * lòng rối như tơ vò",
  },
  {
    word: "tơi",
    part_of_speech: "danh từ",
    meaning:
      '(Khẩu ngữ) áo tơi (nói tắt): "Ra về anh nón em tơi, Lẽ nào hai đứa đi trời cả hai." (Cdao)',
    example: 'Ra về anh nón em tơi, Lẽ nào hai đứa đi trời cả hai." (Cdao)',
  },
  {
    word: "tơi",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái rời ra thành những hạt hoặc sợi nhỏ, không còn dính vào với nhau nữa: đập tơi đất * giã ruốc cho thật tơi * khoai bở tơi",
    example: "đập tơi đất * giã ruốc cho thật tơi * khoai bở tơi",
  },
  {
    word: "tới bến",
    part_of_speech: "",
    meaning:
      "(phương ngữ, khẩu ngữ) (vui chơi, hưởng thụ) tới cùng, tới mức độ cao nhất: chơi tới bến thì thôi * nhậu một trận tới bến",
    example: "chơi tới bến thì thôi * nhậu một trận tới bến",
  },
  {
    word: "tơi bời",
    part_of_speech: "tính từ",
    meaning:
      "tả tơi không còn ra hình thù gì nữa, do bị tàn phá mạnh mẽ và dồn dập: vườn tược tơi bời sau trận bão * đánh cho một trận tơi bời",
    example: "vườn tược tơi bời sau trận bão * đánh cho một trận tơi bời",
  },
  {
    word: "tơ trúc",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, văn chương) dây đàn và ống sáo; chỉ tiếng đàn và tiếng sáo: tơ trúc dập dìu",
    example: "tơ trúc dập dìu",
  },
  {
    word: "tới lui",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) như lui tới: thỉnh thoảng tới lui thăm viếng",
    example: "thỉnh thoảng tới lui thăm viếng",
  },
  {
    word: "tới lui",
    part_of_speech: "động từ",
    meaning: "tiến tới, tiến lên hay lùi lại (nói khái quát): tới lui đều khó",
    example: "tới lui đều khó",
  },
  {
    word: "tới lui",
    part_of_speech: "phụ từ",
    meaning:
      "(phương ngữ, khẩu ngữ) lặp đi lặp lại rất nhiều lần, hoặc mặt này mặt khác rất kĩ: cò kè trả giá tới lui * nghĩ tới lui mãi vẫn không ra",
    example: "cò kè trả giá tới lui * nghĩ tới lui mãi vẫn không ra",
  },
  {
    word: "tời",
    part_of_speech: "danh từ",
    meaning:
      "thiết bị có trục quay, trên trục có cuốn dây, dùng để kéo vật nặng: cỗ máy được nâng lên bằng tời",
    example: "cỗ máy được nâng lên bằng tời",
  },
  {
    word: "tới",
    part_of_speech: "động từ",
    meaning:
      "đến một nơi nào đó: mời bạn tới nhà * tới ngã ba thì quẹo phải * câu chuyện đã tới tai giám đốc",
    example:
      "mời bạn tới nhà * tới ngã ba thì quẹo phải * câu chuyện đã tới tai giám đốc",
  },
  {
    word: "tới",
    part_of_speech: "động từ",
    meaning:
      "đến khoảng thời gian cụ thể nào đó: chờ tới lượt thì vào * tới hè thì đi * chuyện đó, tới bây giờ tôi mới hiểu",
    example:
      "chờ tới lượt thì vào * tới hè thì đi * chuyện đó, tới bây giờ tôi mới hiểu",
  },
  {
    word: "tới",
    part_of_speech: "động từ",
    meaning:
      "từ biểu thị hướng của hoạt động thẳng lên phía trước: bước tới một bước * được thể càng lấn tới",
    example: "bước tới một bước * được thể càng lấn tới",
  },
  {
    word: "tới",
    part_of_speech: "động từ",
    meaning:
      "đến được đích của hoạt động: vừa về tới nhà * xa quá, bắn không tới * cao không tới, thấp không thông (tng)",
    example:
      "vừa về tới nhà * xa quá, bắn không tới * cao không tới, thấp không thông (tng)",
  },
  {
    word: "tới",
    part_of_speech: "động từ",
    meaning:
      "đến liền ngay sau cái hiện nay: xuống ở ga tới * tuần tới sẽ đi * việc này sẽ bàn ở buổi họp tới",
    example: "xuống ở ga tới * tuần tới sẽ đi * việc này sẽ bàn ở buổi họp tới",
  },
  {
    word: "tới",
    part_of_speech: "kết từ",
    meaning:
      "như đến (ng2; nhưng ý mạnh hơn): nói chuyện tới khuya * nói tới thế mà vẫn không hiểu",
    example: "nói chuyện tới khuya * nói tới thế mà vẫn không hiểu",
  },
  {
    word: "tới",
    part_of_speech: "kết từ",
    meaning:
      "đến một đối tượng nào đó: đừng động tới nó * tác động tới tinh thần * chuyện đó, tôi chưa nghĩ tới",
    example:
      "đừng động tới nó * tác động tới tinh thần * chuyện đó, tôi chưa nghĩ tới",
  },
  {
    word: "tới",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý nhấn mạnh số lượng cao: bài viết dài tới hai chục trang * đông tới hàng vạn người",
    example: "bài viết dài tới hai chục trang * đông tới hàng vạn người",
  },
  {
    word: "tới tấp",
    part_of_speech: "tính từ",
    meaning:
      "liên tiếp, dồn dập, cái này chưa qua cái khác đã đến: đạn bay tới tấp * đánh tới tấp * tin tức tới tấp bay về",
    example: "đạn bay tới tấp * đánh tới tấp * tin tức tới tấp bay về",
  },
  {
    word: "tởm",
    part_of_speech: "động từ",
    meaning:
      "có cảm giác ghê sợ, buồn nôn và muốn tránh xa vì quá bẩn thỉu: bẩn phát tởm lên",
    example: "bẩn phát tởm lên",
  },
  {
    word: "tơi tả",
    part_of_speech: "tính từ",
    meaning: "như tả tơi: quần áo rách tơi tả",
    example: "quần áo rách tơi tả",
  },
  {
    word: "tới số",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ, khẩu ngữ) đến ngày tận số, đến lúc phải chết (hàm ý khinh): bọn chúng đã tới số rồi!",
    example: "bọn chúng đã tới số rồi!",
  },
  {
    word: "tơi tới",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) một cách nhanh, mạnh và liên tục, như không ngừng, không nghỉ: lúa được nước, lên tơi tới",
    example: "lúa được nước, lên tơi tới",
  },
  {
    word: "tợn tạo",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) tợn, không biết sợ, không kiêng nể, e dè (nói khái quát): đứa trẻ tợn tạo, ngỗ nghịch",
    example: "đứa trẻ tợn tạo, ngỗ nghịch",
  },
  {
    word: "tởn",
    part_of_speech: "động từ",
    meaning: "(Phương ngữ, Khẩu ngữ) sợ mà chừa đi: bị một lần tởn đến già",
    example: "bị một lần tởn đến già",
  },
  {
    word: "tớn tác",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như nhớn nhác: chạy tớn tác tìm chỗ trốn",
    example: "chạy tớn tác tìm chỗ trốn",
  },
  {
    word: "tợn",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ)",
    example: "con chó rất tợn * mặt để râu quai nón trông khá tợn",
  },
  {
    word: "tợn",
    part_of_speech: "tính từ",
    meaning: "(ng1): con chó rất tợn * mặt để râu quai nón trông khá tợn",
    example: "lão ta tợn lắm, chẳng sợ gì hết",
  },
  {
    word: "tợn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) bạo đến mức liều lĩnh, không biết sợ hãi là gì: lão ta tợn lắm, chẳng sợ gì hết",
    example: "trời rét tợn * được thể càng khóc tợn",
  },
  {
    word: "tởm lợm",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có cảm giác ghê tởm đến lợm giọng, buồn nôn: mùi máu tanh tởm lợm",
    example: "mùi máu tanh tởm lợm",
  },
  {
    word: "tớp",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) như tợp: tớp ngụm nước chè",
    example: "tớp ngụm nước chè",
  },
  {
    word: "tợp",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) uống nhanh một ngụm: tợp một hớp rượu",
    example: "tợp một hớp rượu",
  },
  {
    word: "tợp",
    part_of_speech: "động từ",
    meaning:
      "đớp nhanh lấy (thường nói về động vật): cá tợp mồi * bị chó tợp vào chân",
    example: "cá tợp mồi * bị chó tợp vào chân",
  },
  {
    word: "tợp",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) như ngụm: làm một tợp rượu",
    example: "làm một tợp rượu",
  },
  {
    word: "trà",
    part_of_speech: "danh từ",
    meaning:
      "búp hoặc lá cây chè đã sao, đã chế biến, để pha nước uống: pha trà * uống trà * trà sen (trà ướp hương sen)",
    example: "pha trà * uống trà * trà sen (trà ướp hương sen)",
  },
  {
    word: "trà",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp những cây cùng loại cùng gieo trồng và thu hoạch trong một thời gian, một đợt: trà lúa sớm * trà khoai",
    example: "trà lúa sớm * trà khoai",
  },
  {
    word: "trà",
    part_of_speech: "danh từ",
    meaning:
      "(Phương ngữ) lứa tuổi: hai đứa cùng trà với nhau * xấu như ma cũng thể trà con gái (tng)",
    example:
      "hai đứa cùng trà với nhau * xấu như ma cũng thể trà con gái (tng)",
  },
  {
    word: "trả",
    part_of_speech: "danh từ",
    meaning:
      "chim nhỏ, lông xanh biếc, mỏ lớn và thẳng, màu đỏ, chuyên bắt cá: chim trả * màu xanh cánh trả",
    example: "chim trả * màu xanh cánh trả",
  },
  {
    word: "trả",
    part_of_speech: "động từ",
    meaning:
      "đưa lại cho người khác cái đã vay, đã mượn của người ấy: trả nợ * trả quyển sách cho bạn * có vay có trả",
    example: "trả nợ * trả quyển sách cho bạn * có vay có trả",
  },
  {
    word: "trả",
    part_of_speech: "động từ",
    meaning:
      "đưa lại cho người khác cái đã lấy đi hoặc đã nhận được từ người ấy: trả lại tiền thừa * được trả tự do * thư không có người nhận phải gửi trả lại",
    example:
      "trả lại tiền thừa * được trả tự do * thư không có người nhận phải gửi trả lại",
  },
  {
    word: "trả",
    part_of_speech: "động từ",
    meaning:
      "đưa cho người khác số tiền hoặc vật để đổi lấy cái gì đó của người ấy, từ người ấy: trả lương * trả công * trả mũ áo từ quan",
    example: "trả lương * trả công * trả mũ áo từ quan",
  },
  {
    word: "trả",
    part_of_speech: "động từ",
    meaning:
      "làm trở lại cho người khác điều tương xứng với những gì người ấy đã làm cho mình: trả ơn * trả được mối thù * bắn trả quyết liệt",
    example: "trả ơn * trả được mối thù * bắn trả quyết liệt",
  },
  {
    word: "trả",
    part_of_speech: "động từ",
    meaning: "trả giá (nói tắt): trả rẻ nên không bán",
    example: "trả rẻ nên không bán",
  },
  {
    word: "trã",
    part_of_speech: "danh từ",
    meaning: "nồi đất rộng miệng và nông, thường dùng để kho nấu: trã cá kho",
    example: "trã cá kho",
  },
  {
    word: "tra",
    part_of_speech: "động từ",
    meaning:
      "bỏ từng hạt giống vào chỗ đất đã cuốc xới để cho mọc mầm, lên cây: tra đỗ * tra ngô",
    example: "tra đỗ * tra ngô",
  },
  {
    word: "tra",
    part_of_speech: "động từ",
    meaning:
      "cho một chất nào đó vào trong một vật để tạo ra tác dụng mong muốn: tra mắm muối vào canh * tra dầu vào ổ khoá * tra thuốc đau mắt",
    example: "tra mắm muối vào canh * tra dầu vào ổ khoá * tra thuốc đau mắt",
  },
  {
    word: "tra",
    part_of_speech: "động từ",
    meaning:
      "cho một vật nào đó vào cái được làm ra rất khớp để giữ chặt, ôm chặt lấy nó: tra cán cuốc * tra gươm vào vỏ * tra chân vào cùm",
    example: "tra cán cuốc * tra gươm vào vỏ * tra chân vào cùm",
  },
  {
    word: "tra",
    part_of_speech: "động từ",
    meaning:
      "lắp, đính một bộ phận phụ nhưng quan trọng nào đó để một vật trở thành hoàn chỉnh: tra cổ áo * quả mìn chưa tra kíp nổ",
    example: "tra cổ áo * quả mìn chưa tra kíp nổ",
  },
  {
    word: "tra",
    part_of_speech: "động từ",
    meaning:
      "truy hỏi gắt gao hoặc doạ dẫm, đánh đập nhằm buộc phải khai ra sự thật: tra cho ra sự thật",
    example: "tra cho ra sự thật",
  },
  {
    word: "tra",
    part_of_speech: "động từ",
    meaning:
      "tìm một số liệu, một điều cần biết nào đó trong sách chuyên dùng hoặc trong tài liệu được ghi chép, sắp xếp có hệ thống: tra từ điển * tra số điện thoại trong danh bạ",
    example: "tra từ điển * tra số điện thoại trong danh bạ",
  },
  {
    word: "tra",
    part_of_speech: "tính từ",
    meaning: "(Phương ngữ) già: ông tra bà lão * vịt ăn tra, gà ăn non (tng)",
    example: "ông tra bà lão * vịt ăn tra, gà ăn non (tng)",
  },
  {
    word: "trả bài",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ, hoặc cũ) (học sinh) trình bày trước giáo viên bài đã học để giáo viên kiểm tra: gọi học sinh lên bảng trả bài",
    example: "gọi học sinh lên bảng trả bài",
  },
  {
    word: "trà dư tửu hậu",
    part_of_speech: "",
    meaning:
      "chỉ lúc nhàn rỗi (như lúc vừa thưởng thức xong chén chè, chén rượu): câu chuyện lúc trà dư tửu hậu",
    example: "câu chuyện lúc trà dư tửu hậu",
  },
  {
    word: "tra cứu",
    part_of_speech: "động từ",
    meaning:
      "tìm tòi qua sách báo, tài liệu để biết đích xác một điều nào đó: tra cứu sổ sách * mua quyển từ điển để tiện tra cứu",
    example: "tra cứu sổ sách * mua quyển từ điển để tiện tra cứu",
  },
  {
    word: "trả chậm",
    part_of_speech: "động từ",
    meaning:
      "(phương thức mua bán hoặc cho vay) sau một thời gian mới thanh toán, với các điều kiện tuỳ thuộc vào sự thoả thuận giữa hai bên: bán hàng trả chậm * vốn vay trả chậm",
    example: "bán hàng trả chậm * vốn vay trả chậm",
  },
  {
    word: "trả giá",
    part_of_speech: "động từ",
    meaning:
      "(Nam) đưa ra một giá theo ý mình để đề nghị với người bán: cò kè trả giá",
    example: "cò kè trả giá",
  },
  {
    word: "trả giá",
    part_of_speech: "động từ",
    meaning:
      "phải chịu mất mát tương xứng với điều mình gây ra: trả giá cho lỗi lầm của mình",
    example: "trả giá cho lỗi lầm của mình",
  },
  {
    word: "trả góp",
    part_of_speech: "động từ",
    meaning:
      "(phương thức mua bán) trả trước một phần tiền, phần còn lại trả dần trong một thời gian nhất định và theo mức lãi suất quy định: vay trả góp * mua nhà trả góp",
    example: "vay trả góp * mua nhà trả góp",
  },
  {
    word: "trà đạo",
    part_of_speech: "danh từ",
    meaning:
      "triết lí, nghệ thuật uống và thưởng thức trà đã đạt đến đỉnh cao (ở một số nước phương Đông): nghi lễ trà đạo * trà đạo Nhật Bản",
    example: "nghi lễ trà đạo * trà đạo Nhật Bản",
  },
  {
    word: "trả đũa",
    part_of_speech: "động từ",
    meaning:
      "chống trả lại một cách đích đáng cho hả nỗi tức giận: đòn trả đũa",
    example: "đòn trả đũa",
  },
  {
    word: "trá hàng",
    part_of_speech: "động từ",
    meaning: "giả vờ đầu hàng: mượn kế trá hàng để lừa địch",
    example: "mượn kế trá hàng để lừa địch",
  },
  {
    word: "trá hình",
    part_of_speech: "động từ",
    meaning:
      "đóng giả hình dạng một loại người khác để không bị nhận ra: ăn mặc trá hình * trá hình thành nhà sư",
    example: "ăn mặc trá hình * trá hình thành nhà sư",
  },
  {
    word: "trá hình",
    part_of_speech: "động từ",
    meaning:
      "mang một hình thức giả để che giấu thực chất: quán cà phê trá hình * một hình thức bóc lột trá hình",
    example: "quán cà phê trá hình * một hình thức bóc lột trá hình",
  },
  {
    word: "trả lời",
    part_of_speech: "động từ",
    meaning:
      "nói cho người nào đó biết điều người ấy hỏi hoặc yêu cầu: hỏi nhưng không trả lời * viết thư trả lời * trả lời các câu hỏi trong bài tập",
    example:
      "hỏi nhưng không trả lời * viết thư trả lời * trả lời các câu hỏi trong bài tập",
  },
  {
    word: "trả lời",
    part_of_speech: "động từ",
    meaning: "đáp lại bằng thái độ nào đó: trả lời bằng hành động",
    example: "trả lời bằng hành động",
  },
  {
    word: "tra khảo",
    part_of_speech: "động từ",
    meaning:
      "tra hỏi một cách gắt gao, thường có đánh đập để bắt cung khai: tra khảo tù nhân",
    example: "tra khảo tù nhân",
  },
  {
    word: "tra khảo",
    part_of_speech: "động từ",
    meaning: "(cũ, hiếm) như tra cứu (ng1): tra khảo điển tích",
    example: "tra khảo điển tích",
  },
  {
    word: "trà lá",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) uống nước chè, hút thuốc lá, tiêu phí thời gian vào những thú vui nhỏ (nói khái quát): suốt ngày trà lá, bia bọt",
    example: "suốt ngày trà lá, bia bọt",
  },
  {
    word: "tra hỏi",
    part_of_speech: "động từ",
    meaning:
      "truy hỏi gắt gao nhằm buộc phải nói ra sự thật: tra hỏi bị can * suốt ngày tra hỏi, vặn vẹo",
    example: "tra hỏi bị can * suốt ngày tra hỏi, vặn vẹo",
  },
  {
    word: "trả miếng",
    part_of_speech: "động từ",
    meaning:
      "đối đáp, đối phó lại lời nói, hành động xúc phạm đến mình bằng lời nói, hành động tương tự (thường hàm ý chê): ăn miếng trả miếng * trả miếng bằng lời mỉa mai",
    example: "ăn miếng trả miếng * trả miếng bằng lời mỉa mai",
  },
  {
    word: "trả phép",
    part_of_speech: "động từ",
    meaning:
      "về lại nơi làm việc sau thời gian đi nghỉ phép: sắp đến ngày trả phép * trả phép đúng hạn",
    example: "sắp đến ngày trả phép * trả phép đúng hạn",
  },
  {
    word: "trả thù",
    part_of_speech: "động từ",
    meaning:
      "làm cho người đã gây hại, gây tai hoạ cho bản thân mình hoặc người thân phải chịu điều tương xứng với những gì người ấy đã gây ra: trả thù cho cha mẹ bị giết hại",
    example: "trả thù cho cha mẹ bị giết hại",
  },
  {
    word: "trả nghĩa",
    part_of_speech: "động từ",
    meaning: "đền đáp lại ơn nghĩa: trả nghĩa mẹ cha",
    example: "trả nghĩa mẹ cha",
  },
  {
    word: "tra tấn",
    part_of_speech: "động từ",
    meaning:
      "dùng cực hình làm cho đau đớn để buộc phải cung khai: đòn tra tấn * bị tra tấn đến tàn phế",
    example: "đòn tra tấn * bị tra tấn đến tàn phế",
  },
  {
    word: "trà trộn",
    part_of_speech: "động từ",
    meaning:
      "lẩn vào đám đông để khỏi bị phát hiện: kẻ gian trà trộn vào đám đông, lẩn mất",
    example: "kẻ gian trà trộn vào đám đông, lẩn mất",
  },
  {
    word: "tra vấn",
    part_of_speech: "động từ",
    meaning:
      "hỏi đi hỏi lại một cách kĩ lưỡng để tìm cho ra điều gì: tra vấn bị can",
    example: "tra vấn bị can",
  },
  {
    word: "trà thất",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) phòng trà hoặc quán uống trà sang trọng: ngồi đàm luận trong trà thất",
    example: "ngồi đàm luận trong trà thất",
  },
  {
    word: "tra xét",
    part_of_speech: "động từ",
    meaning: "xét hỏi để kiểm tra: tra xét cho ra vụ việc",
    example: "tra xét cho ra vụ việc",
  },
  {
    word: "trác",
    part_of_speech: "động từ",
    meaning: "(Phương ngữ) đánh lừa để đùa chơi cho vui: bị trác một vố",
    example: "bị trác một vố",
  },
  {
    word: "trác táng",
    part_of_speech: "động từ",
    meaning:
      "chơi bời truỵ lạc vô độ: ăn chơi trác táng * lao vào những cuộc trác táng",
    example: "ăn chơi trác táng * lao vào những cuộc trác táng",
  },
  {
    word: "trác tuyệt",
    part_of_speech: "tính từ",
    meaning:
      "cao vượt hẳn lên, không có gì sánh kịp (thường nói về những giá trị có tính chất siêu hình): bài thơ trác tuyệt * những áng văn trác tuyệt",
    example: "bài thơ trác tuyệt * những áng văn trác tuyệt",
  },
  {
    word: "trách",
    part_of_speech: "động từ",
    meaning:
      'nói ra những lời không bằng lòng về người có quan hệ gần gũi nào đó, cho là đã có hành vi, thái độ không đúng, không hay, không tốt đối với mình hoặc có liên quan đến mình: buông lời trách khéo * "Lửa tâm càng dập, càng nồng, Trách người đen bạc, ra lòng trăng hoa." (TKiều)',
    example:
      'buông lời trách khéo * "Lửa tâm càng dập, càng nồng, Trách người đen bạc, ra lòng trăng hoa." (TKiều)',
  },
  {
    word: "trạc",
    part_of_speech: "danh từ",
    meaning:
      "đồ đan bằng tre rộng miệng, nông lòng, thường dùng để khiêng đất: khiêng mấy trạc đất",
    example: "khiêng mấy trạc đất",
  },
  {
    word: "trạc",
    part_of_speech: "danh từ",
    meaning:
      'khoảng, độ (nói về tuổi): cô ta trạc tuổi cậu * "Quá niên trạc ngoại tứ tuần, Mày râu nhẵn nhụi, áo quần bảnh bao." (TKiều)',
    example:
      'cô ta trạc tuổi cậu * "Quá niên trạc ngoại tứ tuần, Mày râu nhẵn nhụi, áo quần bảnh bao." (TKiều)',
  },
  {
    word: "trác việt",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như trác tuyệt: tư tưởng trác việt",
    example: "tư tưởng trác việt",
  },
  {
    word: "trách mắng",
    part_of_speech: "động từ",
    meaning: "trách người dưới bằng những lời nói nặng: lên tiếng trách mắng",
    example: "lên tiếng trách mắng",
  },
  {
    word: "trách cứ",
    part_of_speech: "động từ",
    meaning:
      "trách người nào đó, cho là phải chịu trách nhiệm về điều không hay, không tốt đã xảy ra: lỗi do mình, còn trách cứ ai",
    example: "lỗi do mình, còn trách cứ ai",
  },
  {
    word: "trách nhiệm",
    part_of_speech: "danh từ",
    meaning:
      "phần việc được giao cho hoặc coi như được giao cho, phải bảo đảm làm tròn, nếu kết quả không tốt thì phải gánh chịu phần hậu quả: việc này thuộc trách nhiệm của trưởng phòng * trốn tránh trách nhiệm",
    example:
      "việc này thuộc trách nhiệm của trưởng phòng * trốn tránh trách nhiệm",
  },
  {
    word: "trách nhiệm",
    part_of_speech: "danh từ",
    meaning:
      "sự ràng buộc đối với lời nói, hành vi của mình, bảo đảm đúng đắn, nếu sai trái thì phải gánh chịu phần hậu quả: chịu trách nhiệm về hành vi của mình * có trách nhiệm với công việc",
    example:
      "chịu trách nhiệm về hành vi của mình * có trách nhiệm với công việc",
  },
  {
    word: "trách móc",
    part_of_speech: "động từ",
    meaning:
      "tỏ cho người có quan hệ gần gũi nào đó biết là mình không bằng lòng về những điều không đúng, không hay, không tốt mà người đó đã làm đối với mình hoặc có liên quan đến mình: buông lời trách móc * không trách móc nửa lời",
    example: "buông lời trách móc * không trách móc nửa lời",
  },
  {
    word: "trải",
    part_of_speech: "danh từ",
    meaning:
      "thuyền nhỏ và dài, dùng trong các cuộc thi bơi thuyền: hội bơi trải",
    example: "hội bơi trải",
  },
  {
    word: "trải",
    part_of_speech: "động từ",
    meaning:
      "mở rộng ra trên mặt phẳng: trải chiếu * nền nhà trải thảm * biển xanh trải dài vô tận",
    example: "trải chiếu * nền nhà trải thảm * biển xanh trải dài vô tận",
  },
  {
    word: "trải",
    part_of_speech: "động từ",
    meaning:
      'đã từng qua, từng biết, từng chịu đựng: trải nhiều đắng cay * "Trải qua một cuộc bể dâu, Những điều trông thấy mà đau đớn lòng." (TKiều)',
    example:
      'trải nhiều đắng cay * "Trải qua một cuộc bể dâu, Những điều trông thấy mà đau đớn lòng." (TKiều)',
  },
  {
    word: "trái cây",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ) hoa quả: giỏ trái cây * nước ép trái cây",
    example: "giỏ trái cây * nước ép trái cây",
  },
  {
    word: "trái",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) quả: cây ăn trái * trái lựu đạn * trái núi",
    example: "cây ăn trái * trái lựu đạn * trái núi",
  },
  {
    word: "trái",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) mìn: đặt trái",
    example: "đặt trái",
  },
  {
    word: "trái",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) đậu mùa: lên trái",
    example: "lên trái",
  },
  {
    word: "trái",
    part_of_speech: "tính từ",
    meaning:
      "ở cùng một bên với quả tim; đối lập với phải: tay trái * đến ngã ba thì rẽ trái * nghề tay trái (b; nghề phụ, nghề làm thêm)",
    example:
      "tay trái * đến ngã ba thì rẽ trái * nghề tay trái (b; nghề phụ, nghề làm thêm)",
  },
  {
    word: "trái",
    part_of_speech: "tính từ",
    meaning:
      "(mặt của hàng dệt, may) không được coi là chính, thường trông thô, xấu; đối lập với phải: mặc áo trái * trải chiếu trái * lộn trái chiếc quần ra phơi",
    example: "mặc áo trái * trải chiếu trái * lộn trái chiếc quần ra phơi",
  },
  {
    word: "trái",
    part_of_speech: "tính từ",
    meaning:
      "không thuận theo, mà ngược lại: trái lời mẹ dặn * đi trái đường * hành vi trái pháp luật",
    example: "trái lời mẹ dặn * đi trái đường * hành vi trái pháp luật",
  },
  {
    word: "trái",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) ngược với lẽ phải: trái lè lè ra còn cãi * phân rõ phải trái, đúng sai",
    example: "trái lè lè ra còn cãi * phân rõ phải trái, đúng sai",
  },
  {
    word: "trái",
    part_of_speech: "tính từ",
    meaning:
      "không bình thường, ngược lại với thói thường, với quy luật: rau trái vụ * nắng trái tiết * lúc trái gió trở trời",
    example: "rau trái vụ * nắng trái tiết * lúc trái gió trở trời",
  },
  {
    word: "trái chứng",
    part_of_speech: "tính từ",
    meaning:
      "có những thay đổi bất thường về tính tình, trở nên khó tính: già rồi nên sinh trái chứng",
    example: "già rồi nên sinh trái chứng",
  },
  {
    word: "trái cựa",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (làm việc gì) trái ngược hẳn với thói quen, thói thường (hàm ý chê): viết trái cựa * nói trái cựa, không ai nghe được",
    example: "viết trái cựa * nói trái cựa, không ai nghe được",
  },
  {
    word: "trai",
    part_of_speech: "danh từ",
    meaning:
      "động vật thân mềm, có vỏ cứng gồm hai mảnh, sống ở đáy nước, một số loài có thể tiết ra ngọc hoặc vỏ có vân đẹp dùng làm đồ mĩ nghệ: tủ khảm trai * nuôi trai lấy ngọc",
    example: "tủ khảm trai * nuôi trai lấy ngọc",
  },
  {
    word: "trai",
    part_of_speech: "danh từ",
    meaning:
      "người thuộc nam giới (thường là còn ít tuổi; nói khái quát); phân biệt với gái: sinh được một trai, một gái * bé trai",
    example: "sinh được một trai, một gái * bé trai",
  },
  {
    word: "trai",
    part_of_speech: "danh từ",
    meaning:
      '(Khẩu ngữ) người đàn ông là nhân tình: bỏ nhà theo trai * "Hai tay cầm hai quả hồng, Quả chát phần chồng, quả ngọt phần trai." (Cdao)',
    example:
      'bỏ nhà theo trai * "Hai tay cầm hai quả hồng, Quả chát phần chồng, quả ngọt phần trai." (Cdao)',
  },
  {
    word: "trại cải tạo",
    part_of_speech: "danh từ",
    meaning:
      "trại quản lí tập trung một số loại người xấu trong xã hội để buộc phải lao động, học tập và rèn luyện nhằm cải tạo thành người tốt, người lương thiện: bị đưa đi trại cải tạo",
    example: "bị đưa đi trại cải tạo",
  },
  {
    word: "trải đời",
    part_of_speech: "",
    meaning:
      "đã trải qua nhiều hoàn cảnh, tình huống sống khác nhau ở đời nên tỏ ra già dặn kinh nghiệm trong cuộc sống: nhìn bằng con mắt trải đời * một con người khôn ngoan và trải đời",
    example:
      "nhìn bằng con mắt trải đời * một con người khôn ngoan và trải đời",
  },
  {
    word: "trại giam",
    part_of_speech: "danh từ",
    meaning:
      "nơi giam giữ những người bị coi là có tội: khu trại giam * làm quản giáo ở trại giam",
    example: "khu trại giam * làm quản giáo ở trại giam",
  },
  {
    word: "trại",
    part_of_speech: "danh từ",
    meaning:
      "lều dựng để ở tạm tại một nơi chỉ đến một thời gian rồi đi: dựng trại bên bờ suối * cắm trại * đốt lửa trại",
    example: "dựng trại bên bờ suối * cắm trại * đốt lửa trại",
  },
  {
    word: "trại",
    part_of_speech: "danh từ",
    meaning:
      "khu dân cư mới lập ra hoặc khu nhà xây cất riêng, có tính chất biệt lập, để khẩn hoang, chăn nuôi, v.v.: xóm trại * trại chăn nuôi",
    example: "xóm trại * trại chăn nuôi",
  },
  {
    word: "trại",
    part_of_speech: "danh từ",
    meaning:
      "nơi tổ chức để nhiều người đến ở tập trung trong một thời gian theo một yêu cầu nhất định: trại trẻ mồ côi * trại cải tạo * trại sáng tác",
    example: "trại trẻ mồ côi * trại cải tạo * trại sáng tác",
  },
  {
    word: "trại",
    part_of_speech: "tính từ",
    meaning: "(nói) chệch âm đi một chút một cách có ý thức:  nói trại thành",
    example: "nói trại thành",
  },
  {
    word: "trái đào",
    part_of_speech: "danh từ",
    meaning:
      "mớ tóc trông như hình quả đào, để chừa lại hai bên đầu cạo trọc của trẻ em (thường là trẻ em gái) theo kiểu để tóc thời trước: tóc để trái đào",
    example: "tóc để trái đào",
  },
  {
    word: "trai gái",
    part_of_speech: "danh từ",
    meaning:
      "những người còn trẻ tuổi, gồm cả con trai và con gái (nói khái quát): già trẻ trai gái * trai gái đủ cả",
    example: "già trẻ trai gái * trai gái đủ cả",
  },
  {
    word: "trai gái",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) có quan hệ yêu đương không chính đáng: rượu chè trai gái",
    example: "rượu chè trai gái",
  },
  {
    word: "trái gió trở trời",
    part_of_speech: "",
    meaning:
      "(khoảng thời gian) thời tiết thay đổi bất thường, dễ sinh đau ốm: mỗi lần trái gió trở trời là vết thương cũ lại tấy lên",
    example: "mỗi lần trái gió trở trời là vết thương cũ lại tấy lên",
  },
  {
    word: "trái gió trở trời",
    part_of_speech: "",
    meaning:
      "đau ốm (lối nói kiêng tránh): có người chăm sóc khi trái gió trở trời",
    example: "có người chăm sóc khi trái gió trở trời",
  },
  {
    word: "trại hè",
    part_of_speech: "danh từ",
    meaning:
      "hình thức trại để vui chơi giải trí hay để tập trung làm một công tác đặc biệt, tổ chức trong dịp hè: trại hè sinh viên",
    example: "trại hè sinh viên",
  },
  {
    word: "trái đất",
    part_of_speech: "danh từ",
    meaning:
      "(viết hoa khi nói về mặt là một thiên thể) hành tinh thứ ba trong Hệ Mặt Trời, trên đó loài người chúng ta đang sống: Trái Đất quay quanh Mặt Trời * loài người trên trái đất * đi nửa vòng trái đất",
    example:
      "Trái Đất quay quanh Mặt Trời * loài người trên trái đất * đi nửa vòng trái đất",
  },
  {
    word: "trái khoán",
    part_of_speech: "danh từ",
    meaning:
      "phiếu chứng nhận khoản tiền vay của nhà nước hoặc các công ti lớn, có uy tín, người chủ của phiếu được hưởng lợi tức hằng năm cho đến khi hoàn lại vốn vay theo quy định: phát hành trái phiếu * mua bán cổ phiếu, trái phiếu",
    example: "phát hành trái phiếu * mua bán cổ phiếu, trái phiếu",
  },
  {
    word: "trái lại",
    part_of_speech: "",
    meaning:
      "tổ hợp biểu thị điều sắp nêu ra có nội dung trái với điều vừa nói đến hoặc trái với điều vừa phủ định: nó giỏi, trái lại em nó rất dốt * đứa bé không sợ, trái lại còn tỏ ra thích thú",
    example:
      "nó giỏi, trái lại em nó rất dốt * đứa bé không sợ, trái lại còn tỏ ra thích thú",
  },
  {
    word: "trái khoáy",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ngược với lẽ thường một cách oái oăm: lối làm việc trái khoáy * thời tiết trái khoáy",
    example: "lối làm việc trái khoáy * thời tiết trái khoáy",
  },
  {
    word: "trai lơ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có vẻ lẳng lơ, tỏ ra dễ dãi trong quan hệ nam nữ: có tính trai lơ",
    example: "có tính trai lơ",
  },
  {
    word: "trại mồ côi",
    part_of_speech: "danh từ",
    meaning: "nơi nuôi tập trung trẻ mồ côi: lớn lên ở trại mồ côi",
    example: "lớn lên ở trại mồ côi",
  },
  {
    word: "trái ngang",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như ngang trái: tình duyên trái ngang",
    example: "tình duyên trái ngang",
  },
  {
    word: "trái mùa",
    part_of_speech: "tính từ",
    meaning:
      "(hoa quả, thời tiết) không đúng mùa như bình thường: chanh trái mùa * hoa nở trái mùa",
    example: "chanh trái mùa * hoa nở trái mùa",
  },
  {
    word: "trái mùa",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) không hợp thời: tư tưởng trái mùa * ăn mặc trái mùa",
    example: "tư tưởng trái mùa * ăn mặc trái mùa",
  },
  {
    word: "trái phiếu",
    part_of_speech: "danh từ",
    meaning:
      "phiếu chứng nhận khoản tiền vay của nhà nước hoặc các công ti lớn, có uy tín, người chủ của phiếu được hưởng lợi tức hằng năm cho đến khi hoàn lại vốn vay theo quy định: phát hành trái phiếu * mua bán cổ phiếu, trái phiếu",
    example: "phát hành trái phiếu * mua bán cổ phiếu, trái phiếu",
  },
  {
    word: "trải nghiệm",
    part_of_speech: "",
    meaning:
      "(hiếm) trải qua, kinh qua: đã từng trải nghiệm trên thương trường",
    example: "đã từng trải nghiệm trên thương trường",
  },
  {
    word: "trái nghĩa",
    part_of_speech: "tính từ",
    meaning: "có nghĩa trái ngược nhau: cặp từ trái nghĩa *  trái nghĩa với",
    example: "cặp từ trái nghĩa *  trái nghĩa với",
  },
  {
    word: "trái ngược",
    part_of_speech: "tính từ",
    meaning:
      "trái hẳn lại (nói khái quát): có nhiều ý kiến trái ngược * tính nết hai người trái ngược nhau",
    example: "có nhiều ý kiến trái ngược * tính nết hai người trái ngược nhau",
  },
  {
    word: "trái nết",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như trái tính: già rồi nên sinh trái nết",
    example: "già rồi nên sinh trái nết",
  },
  {
    word: "trái phép",
    part_of_speech: "tính từ",
    meaning:
      "trái với pháp luật hoặc với điều được cấp có thẩm quyền cho phép: chuyển hàng trái phép qua biên giới * bắt giam người trái phép",
    example: "chuyển hàng trái phép qua biên giới * bắt giam người trái phép",
  },
  {
    word: "trái tính",
    part_of_speech: "tính từ",
    meaning:
      "có tính nết khác với bình thường, trở nên khó tính, khó chiều: người già thường hay trái tính",
    example: "người già thường hay trái tính",
  },
  {
    word: "trái rạ",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) bỏng rạ: nổi trái rạ",
    example: "nổi trái rạ",
  },
  {
    word: "trai tráng",
    part_of_speech: "",
    meaning:
      'người đàn ông còn trẻ và khoẻ mạnh (nói khái quát): trai tráng trong làng * "Cao su đi dễ khó về, Khi đi trai tráng khi về bủng beo." (ca dao)',
    example:
      'trai tráng trong làng * "Cao su đi dễ khó về, Khi đi trai tráng khi về bủng beo." (ca dao)',
  },
  {
    word: "trái tim",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương) tim của con người, coi là biểu tượng của tình cảm: trái tim nhân hậu * yêu bằng cả trái tim",
    example: "trái tim nhân hậu * yêu bằng cả trái tim",
  },
  {
    word: "trái tai",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) trái lẽ thường, khó nghe: chuyện trái tai * nghe rất trái tai",
    example: "chuyện trái tai * nghe rất trái tai",
  },
  {
    word: "trai trẻ",
    part_of_speech: "",
    meaning:
      "người con trai trẻ tuổi (nói khái quát): bọn trai trẻ trong làng * thời trai trẻ",
    example: "bọn trai trẻ trong làng * thời trai trẻ",
  },
  {
    word: "trái tính trái nết",
    part_of_speech: "tính từ",
    meaning:
      "như trái tính (nhưng nghĩa mạnh hơn): con bé trái tính trái nết nên rất khó chiều",
    example: "con bé trái tính trái nết nên rất khó chiều",
  },
  {
    word: "trái vụ",
    part_of_speech: "tính từ",
    meaning: "(cây trồng) trái thời vụ: chanh trái vụ * lúa trái vụ",
    example: "chanh trái vụ * lúa trái vụ",
  },
  {
    word: "trảm",
    part_of_speech: "động từ",
    meaning: "(Từ cũ) chém đầu: xử trảm * tiền trảm hậu tấu",
    example: "xử trảm * tiền trảm hậu tấu",
  },
  {
    word: "trạm trưởng",
    part_of_speech: "danh từ",
    meaning: "người đứng đầu một trạm: trạm trưởng trạm thu mua",
    example: "trạm trưởng trạm thu mua",
  },
  {
    word: "trạm",
    part_of_speech: "danh từ",
    meaning:
      "nhà, nơi bố trí ở dọc đường giao thông để làm một nhiệm vụ nhất định nào đó: trạm gác * trạm giao liên * trạm kiểm soát",
    example: "trạm gác * trạm giao liên * trạm kiểm soát",
  },
  {
    word: "trạm",
    part_of_speech: "danh từ",
    meaning:
      "cơ sở của một số cơ quan chuyên môn đặt ở các địa phương: trạm bơm * trạm biến thế * trạm cứu thương",
    example: "trạm bơm * trạm biến thế * trạm cứu thương",
  },
  {
    word: "trái xoan",
    part_of_speech: "danh từ",
    meaning:
      "(khuôn mặt) hình bầu dục, giống hình quả xoan, trông thanh tú, nhẹ nhõm: khuôn mặt trái xoan",
    example: "khuôn mặt trái xoan",
  },
  {
    word: "tràn",
    part_of_speech: "danh từ",
    meaning:
      "khoảng đất có những đặc điểm chung nào đó, có thể trồng trọt, chăn nuôi: tràn ruộng bậc thang",
    example: "tràn ruộng bậc thang",
  },
  {
    word: "tràn",
    part_of_speech: "danh từ",
    meaning: "nơi chứa hàng: tràn than",
    example: "tràn than",
  },
  {
    word: "tràn",
    part_of_speech: "động từ",
    meaning:
      'chảy qua miệng hoặc bờ vì đầy quá: nước tràn bờ * "Nỗi riêng, riêng những bàn hoàn, Dầu chong trắng đĩa, lệ tràn thấm khăn." (TKiều)',
    example:
      'nước tràn bờ * "Nỗi riêng, riêng những bàn hoàn, Dầu chong trắng đĩa, lệ tràn thấm khăn." (TKiều)',
  },
  {
    word: "tràn",
    part_of_speech: "động từ",
    meaning:
      "di chuyển từ nơi khác đến với số lượng lớn, trên một diện rộng, bất chấp mọi chướng ngại: giặc tràn vào làng * gió mùa đông bắc tràn về",
    example: "giặc tràn vào làng * gió mùa đông bắc tràn về",
  },
  {
    word: "tràn",
    part_of_speech: "phụ từ",
    meaning:
      "(Khẩu ngữ) (làm việc gì) cứ thế mà làm, không chút tự hạn chế mình, vì không nghĩ gì đến đúng hay sai, nên hay không: cáo ốm nghỉ tràn * nói gì cũng cười tràn",
    example: "cáo ốm nghỉ tràn * nói gì cũng cười tràn",
  },
  {
    word: "trạm xá",
    part_of_speech: "danh từ",
    meaning: "cơ sở chữa bệnh nhỏ ở xã hoặc cơ quan: khám bệnh ở trạm xá xã",
    example: "khám bệnh ở trạm xá xã",
  },
  {
    word: "trám",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi chung nhiều cây to cùng họ, có nhựa thường dùng để làm hương, một số loài có quả ăn được: rừng trám * mắt lưới hình quả trám",
    example: "rừng trám * mắt lưới hình quả trám",
  },
  {
    word: "trám",
    part_of_speech: "động từ",
    meaning:
      "miết nhựa, hoặc chất kết dính nói chung, để làm cho kín, cho gắn chặt lại với nhau: trám khe hở * trám thuyền * đút tiền để trám miệng (b)",
    example: "trám khe hở * trám thuyền * đút tiền để trám miệng (b)",
  },
  {
    word: "trám",
    part_of_speech: "động từ",
    meaning:
      "(Phương ngữ) chặn bít lại các ngả đường: trám các ngả đường * cho người trám ở ngã ba",
    example: "trám các ngả đường * cho người trám ở ngã ba",
  },
  {
    word: "tràm",
    part_of_speech: "danh từ",
    meaning:
      "cây to cùng họ với ổi, vỏ xốp, lá hình bầu dục nhọn, có mùi thơm, dùng để cất tinh dầu, làm thuốc, vỏ cây dùng để xảm thuyền: rừng tràm * hương tràm",
    example: "rừng tràm * hương tràm",
  },
  {
    word: "tràn cung mây",
    part_of_speech: "phụ từ",
    meaning:
      '(khẩu ngữ) một cách hết sức thoải mái, không cần biết tự hạn chế, không nghĩ gì đến hậu quả: nói tràn cung mây * "Thà rằng lấy chú xẩm xoan, Công nợ chẳng có, hát tràn cung mây." (ca dao)',
    example:
      'nói tràn cung mây * "Thà rằng lấy chú xẩm xoan, Công nợ chẳng có, hát tràn cung mây." (ca dao)',
  },
  {
    word: "trán",
    part_of_speech: "danh từ",
    meaning:
      "phần trên của mặt từ chỗ có tóc mọc đến lông mày: vầng trán rộng * vắt tay lên trán suy nghĩ",
    example: "vầng trán rộng * vắt tay lên trán suy nghĩ",
  },
  {
    word: "tràn trề",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều đến mức như không chứa hết được mà phải để tràn bớt ra ngoài: mương máng tràn trề nước * lòng tràn trề hạnh phúc",
    example: "mương máng tràn trề nước * lòng tràn trề hạnh phúc",
  },
  {
    word: "tráng",
    part_of_speech: "động từ",
    meaning:
      "nhúng qua hoặc giội thêm một lần nước (thường là sau khi đã cọ rửa) để làm cho sạch: tráng bát bằng nước sôi * tráng qua cái chậu cho sạch",
    example: "tráng bát bằng nước sôi * tráng qua cái chậu cho sạch",
  },
  {
    word: "tráng",
    part_of_speech: "động từ",
    meaning:
      "đổ nước bột, trứng, v.v. thành một lớp mỏng trên mặt khuôn, chảo để hấp hoặc rán: tráng bánh cuốn * trứng tráng",
    example: "tráng bánh cuốn * trứng tráng",
  },
  {
    word: "tráng",
    part_of_speech: "động từ",
    meaning:
      "phủ một lớp mỏng có công dụng đặc biệt, như chống gỉ, chống ăn mòn, v.v., trên khắp bề mặt: gạch tráng men * chiếc vòng tráng bạc",
    example: "gạch tráng men * chiếc vòng tráng bạc",
  },
  {
    word: "tráng",
    part_of_speech: "động từ",
    meaning:
      "dùng dung dịch hoá chất làm cho hình ảnh hiện lên trên mặt phim: tráng phim",
    example: "tráng phim",
  },
  {
    word: "tráng",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) trống, quang: phơi quần áo ở chỗ tráng",
    example: "phơi quần áo ở chỗ tráng",
  },
  {
    word: "tràn lan",
    part_of_speech: "",
    meaning:
      "(nước chảy) tràn ra, lan ra khắp mọi chỗ, đâu cũng có: nước chảy tràn lan khắp nhà",
    example: "nước chảy tràn lan khắp nhà",
  },
  {
    word: "tràn lan",
    part_of_speech: "",
    meaning:
      "lan rộng ra một cách không có giới hạn: khói lửa tràn lan * cỏ dại mọc tràn lan * viết tràn lan, không có trọng tâm",
    example:
      "khói lửa tràn lan * cỏ dại mọc tràn lan * viết tràn lan, không có trọng tâm",
  },
  {
    word: "tràn đầy",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái có nhiều đến mức không còn có thể chứa đựng thêm một chút nào nữa: bể nước tràn đầy * một cơ thể tràn đầy sức sống",
    example: "bể nước tràn đầy * một cơ thể tràn đầy sức sống",
  },
  {
    word: "tràn ngập",
    part_of_speech: "",
    meaning:
      "có rất nhiều, đến mức như bao phủ, che lấp hết cả bề mặt: không gian tràn ngập hương hoa sữa * niềm vui tràn ngập",
    example: "không gian tràn ngập hương hoa sữa * niềm vui tràn ngập",
  },
  {
    word: "trang",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ) mẫu đơn: bông trang",
    example: "bông trang",
  },
  {
    word: "trang",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng gồm một miếng gỗ tra vào cán dài, để san hoặc cào dồn lại thành đống: dùng trang san đều thóc",
    example: "dùng trang san đều thóc",
  },
  {
    word: "trang",
    part_of_speech: "động từ",
    meaning: "san đều bằng cái trang: trang thóc ra cho đều",
    example: "trang thóc ra cho đều",
  },
  {
    word: "trang",
    part_of_speech: "danh từ",
    meaning:
      "mỗi mặt của từng tờ giấy trong sách, báo, vở: bài được đăng trên trang nhất * cuốn sách dày nghìn trang * lịch sử đã sang trang mới (b)",
    example:
      "bài được đăng trên trang nhất * cuốn sách dày nghìn trang * lịch sử đã sang trang mới (b)",
  },
  {
    word: "trang",
    part_of_speech: "danh từ",
    meaning:
      "phần của một tờ báo (thường là một trang) hay một chương trình (phát thanh, truyền hình hoặc truyền thông), luôn chỉ dành riêng cho một vấn đề: trang  * trang  *  của đài truyền hình",
    example: "trang  * trang  *  của đài truyền hình",
  },
  {
    word: "trang",
    part_of_speech: "danh từ",
    meaning:
      "(Từ cũ, Văn chương) từ dùng để gọi tôn người có tài đức, đáng được nêu gương sáng cho người đời: trang hào kiệt * trang anh hùng * một trang nam tử",
    example: "trang hào kiệt * trang anh hùng * một trang nam tử",
  },
  {
    word: "trạng",
    part_of_speech: "danh từ",
    meaning:
      '(Từ cũ) trạng nguyên (gọi tắt): "Cùng nhau một bọn đi thi, Người thì đỗ trạng kẻ thì về không." (Cdao)',
    example:
      'Cùng nhau một bọn đi thi, Người thì đỗ trạng kẻ thì về không." (Cdao)',
  },
  {
    word: "trạng",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) nhân vật có tài đặc biệt trong truyện kể dân gian; cũng dùng để chỉ người có tài đặc biệt về mặt nào đó (thường hàm ý vui đùa): trạng thơ * phán như trạng",
    example: "trạng thơ * phán như trạng",
  },
  {
    word: "trang bị",
    part_of_speech: "động từ",
    meaning:
      "cung cấp cho mọi thứ cần thiết để có thể hoạt động: trang bị vũ khí * tự trang bị kiến thức",
    example: "trang bị vũ khí * tự trang bị kiến thức",
  },
  {
    word: "trang bị",
    part_of_speech: "danh từ",
    meaning: "những thứ được trang bị (nói tổng quát): trang bị tối tân",
    example: "trang bị tối tân",
  },
  {
    word: "tràng",
    part_of_speech: "danh từ",
    meaning: "dạ con của một số động vật, về mặt là thực phẩm: tràng lợn luộc",
    example: "tràng lợn luộc",
  },
  {
    word: "tràng",
    part_of_speech: "danh từ",
    meaning:
      "chuỗi gồm nhiều vật nhỏ cùng loại xâu, kết lại với nhau thành vòng, thành dây dài: tràng pháo * kết thành tràng hoa",
    example: "tràng pháo * kết thành tràng hoa",
  },
  {
    word: "tràng",
    part_of_speech: "danh từ",
    meaning:
      "chuỗi âm thanh phát ra liên tục: nói một tràng * súng nổ thành từng tràng",
    example: "nói một tràng * súng nổ thành từng tràng",
  },
  {
    word: "trang âm",
    part_of_speech: "",
    meaning:
      "bố trí trang thiết bị âm thanh cho một phòng thu âm hay một chương trình biểu diễn: phụ trách trang âm",
    example: "phụ trách trang âm",
  },
  {
    word: "tràng giang đại hải",
    part_of_speech: "",
    meaning:
      "ví lời lẽ rất dài dòng và lan man (tựa như nước ở sông dài, biển rộng): nói tràng giang đại hải",
    example: "nói tràng giang đại hải",
  },
  {
    word: "tráng ca",
    part_of_speech: "danh từ",
    meaning:
      "bài ca hùng tráng, thường ca ngợi những sự tích anh hùng: khúc tráng ca",
    example: "khúc tráng ca",
  },
  {
    word: "trảng",
    part_of_speech: "danh từ",
    meaning:
      "khoảng đất rộng giữa rừng hoặc giữa hai khu rừng: trảng cỏ * trảng cát",
    example: "trảng cỏ * trảng cát",
  },
  {
    word: "trang điểm",
    part_of_speech: "động từ",
    meaning:
      "làm cho vẻ người đẹp lên bằng cách dùng son phấn, quần áo, đồ trang sức, v.v.: trang điểm cô dâu * trang điểm qua loa",
    example: "trang điểm cô dâu * trang điểm qua loa",
  },
  {
    word: "tràng hạt",
    part_of_speech: "danh từ",
    meaning:
      "chuỗi hạt dài người theo đạo Phật dùng lần từng hạt khi tụng kinh: cổ đeo tràng hạt * tay lần tràng hạt",
    example: "cổ đeo tràng hạt * tay lần tràng hạt",
  },
  {
    word: "tràng kỉ",
    part_of_speech: "danh từ",
    meaning:
      "ghế dài, thường bằng gỗ, có lưng tựa và tay vịn ở hai đầu: bộ tràng kỉ bằng gỗ lim",
    example: "bộ tràng kỉ bằng gỗ lim",
  },
  {
    word: "trang hoàng",
    part_of_speech: "động từ",
    meaning:
      "làm cho một nơi nào đó đẹp lên bằng cách bày biện thêm những vật đẹp mắt một cách hợp thẩm mĩ: trang hoàng nhà cửa * hội trường được trang hoàng rực rỡ",
    example: "trang hoàng nhà cửa * hội trường được trang hoàng rực rỡ",
  },
  {
    word: "trang kim",
    part_of_speech: "động từ",
    meaning: "phủ trên mặt một lớp kim loại mỏng: tờ trang kim",
    example: "tờ trang kim",
  },
  {
    word: "tráng kiện",
    part_of_speech: "tính từ",
    meaning: "(người đàn ông) khoẻ mạnh, có sức lực dồi dào: cơ thể tráng kiện",
    example: "cơ thể tráng kiện",
  },
  {
    word: "trạng huống",
    part_of_speech: "danh từ",
    meaning:
      "tình trạng có tính chất đặc biệt trong một lúc nào đó, gặp phải trong cuộc sống thực tế hay trải qua trong đời sống nội tâm: mô tả những trạng huống tâm lí của người bệnh",
    example: "mô tả những trạng huống tâm lí của người bệnh",
  },
  {
    word: "tráng miệng",
    part_of_speech: "động từ",
    meaning:
      "ăn một ít hoa quả hoặc đồ ngọt liền ngay sau bữa cơm: ăn hoa quả tráng miệng * món tráng miệng",
    example: "ăn hoa quả tráng miệng * món tráng miệng",
  },
  {
    word: "tràng kỷ",
    part_of_speech: "danh từ",
    meaning:
      "ghế dài, thường bằng gỗ, có lưng tựa và tay vịn ở hai đầu: bộ tràng kỉ bằng gỗ lim",
    example: "bộ tràng kỉ bằng gỗ lim",
  },
  {
    word: "tráng lệ",
    part_of_speech: "tính từ",
    meaning:
      "(công trình kiến trúc) to lớn và đẹp một cách lộng lẫy: lâu đài tráng lệ",
    example: "lâu đài tráng lệ",
  },
  {
    word: "trang nghiêm",
    part_of_speech: "tính từ",
    meaning:
      "có những hình thức biểu thị thái độ hết sức coi trọng, tôn kính: nơi đền miếu trang nghiêm * đứng trang nghiêm chào cờ",
    example: "nơi đền miếu trang nghiêm * đứng trang nghiêm chào cờ",
  },
  {
    word: "trang lứa",
    part_of_speech: "danh từ",
    meaning:
      "lớp người cùng một lứa tuổi và trong cùng một môi trường sống, nói chung: bạn bè cùng trang lứa * các thế hệ học sinh thuộc nhiều trang lứa",
    example:
      "bạn bè cùng trang lứa * các thế hệ học sinh thuộc nhiều trang lứa",
  },
  {
    word: "trang mục",
    part_of_speech: "danh từ",
    meaning:
      "phần chuyên dành cho một chủ đề, một thể loại, trên báo chí: trang mục",
    example: "trang mục",
  },
  {
    word: "tràng nhạc",
    part_of_speech: "danh từ",
    meaning: "xâu nhạc buộc quanh cổ ngựa: ngựa đeo tràng nhạc",
    example: "ngựa đeo tràng nhạc",
  },
  {
    word: "trang nhã",
    part_of_speech: "tính từ",
    meaning: "lịch sự và thanh nhã: màu sắc trang nhã * lời văn trang nhã",
    example: "màu sắc trang nhã * lời văn trang nhã",
  },
  {
    word: "trạng ngữ",
    part_of_speech: "danh từ",
    meaning:
      "thành phần phụ trong câu, biểu thị ý nghĩa tình huống: thời gian, địa điểm, nguyên nhân, mục đích, phương tiện, v.v.: trong câu 'ngày mai tôi đi' thì 'ngày mai' là trạng ngữ",
    example: "trong câu 'ngày mai tôi đi' thì 'ngày mai' là trạng ngữ",
  },
  {
    word: "trạng nguyên",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) học vị của người đỗ đầu khoa thi đình thời phong kiến: đỗ trạng nguyên",
    example: "đỗ trạng nguyên",
  },
  {
    word: "trang sức",
    part_of_speech: "động từ",
    meaning:
      "làm tôn vẻ đẹp hình thức của con người bằng cách đeo, gắn thêm những vật quý, đẹp: đồ trang sức * đeo hoa tai để trang sức",
    example: "đồ trang sức * đeo hoa tai để trang sức",
  },
  {
    word: "trang sức",
    part_of_speech: "danh từ",
    meaning: "vật quý, đẹp dùng để trang sức: mua sắm trang sức",
    example: "mua sắm trang sức",
  },
  {
    word: "trang phục",
    part_of_speech: "danh từ",
    meaning:
      "quần áo mặc ngoài, nói chung: bộ trang phục dân tộc * trang phục trong công sở",
    example: "bộ trang phục dân tộc * trang phục trong công sở",
  },
  {
    word: "trang phục",
    part_of_speech: "động từ",
    meaning: "(hiếm) ăn mặc nói chung: lối trang phục trên sân khấu tuồng",
    example: "lối trang phục trên sân khấu tuồng",
  },
  {
    word: "tráng sĩ",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người đàn ông có sức lực cường tráng và chí khí mạnh mẽ: người tráng sĩ",
    example: "người tráng sĩ",
  },
  {
    word: "trạng thái",
    part_of_speech: "danh từ",
    meaning:
      "tình trạng của một sự vật hoặc một con người, coi như không có gì thay đổi trong một khoảng thời gian nào đó: sự vật luôn luôn ở trạng thái động * trạng thái tâm lí",
    example: "sự vật luôn luôn ở trạng thái động * trạng thái tâm lí",
  },
  {
    word: "trạng thái",
    part_of_speech: "danh từ",
    meaning:
      "cách tồn tại của một vật do mức độ liên kết giữa các phân tử của nó: vật chất tồn tại trong ba trạng thái là rắn, lỏng và khí",
    example: "vật chất tồn tại trong ba trạng thái là rắn, lỏng và khí",
  },
  {
    word: "trang trí",
    part_of_speech: "động từ",
    meaning:
      "sắp xếp, bố trí các vật có hình khối, đường nét, màu sắc khác nhau sao cho tạo ra một sự hài hoà, làm đẹp mắt một khoảng không gian nào đó: trang trí nội thất * trần nhà trang trí hoa văn",
    example: "trang trí nội thất * trần nhà trang trí hoa văn",
  },
  {
    word: "trang trại",
    part_of_speech: "danh từ",
    meaning:
      "trại lớn sản xuất nông nghiệp (nói khái quát): trang trại cà phê * phát triển kinh tế trang trại",
    example: "trang trại cà phê * phát triển kinh tế trang trại",
  },
  {
    word: "trang trải",
    part_of_speech: "động từ",
    meaning:
      "thu xếp tiền nong để chi trả cho nhu cầu của cuộc sống, hoặc để trả cho hết, cho xong các khoản nợ nần: trang trải nợ nần * đồng lương không đủ trang trải cho cuộc sống",
    example: "trang trải nợ nần * đồng lương không đủ trang trải cho cuộc sống",
  },
  {
    word: "trang thiết bị",
    part_of_speech: "danh từ",
    meaning:
      "trang bị và thiết bị (nói gộp): trang thiết bị quân sự * trang thiết bị y tế",
    example: "trang thiết bị quân sự * trang thiết bị y tế",
  },
  {
    word: "trạng từ",
    part_of_speech: "danh từ",
    meaning:
      "(ngữ pháp) từ chuyên bổ túc nghĩa cho một động từ, tính từ hoặc một phụ từ khác: 'sẽ', 'đã', 'đang', 'rất', 'lắm' là một số phụ từ trong tiếng Việt.",
    example:
      "'sẽ', 'đã', 'đang', 'rất', 'lắm' là một số phụ từ trong tiếng Việt.",
  },
  {
    word: "tranh",
    part_of_speech: "danh từ",
    meaning: "cỏ tranh (nói tắt): đồi tranh",
    example: "đồi tranh",
  },
  {
    word: "tranh",
    part_of_speech: "danh từ",
    meaning:
      "tấm kết bằng cỏ tranh, rạ, v.v. để lợp nhà: nhà tranh vách đất * túp lều tranh",
    example: "nhà tranh vách đất * túp lều tranh",
  },
  {
    word: "tranh",
    part_of_speech: "danh từ",
    meaning:
      "tác phẩm hội hoạ phản ánh hiện thực bằng đường nét và màu sắc: tranh biếm hoạ * triển lãm tranh",
    example: "tranh biếm hoạ * triển lãm tranh",
  },
  {
    word: "tranh",
    part_of_speech: "động từ",
    meaning:
      "tìm cách giành lấy, làm thành của mình: hai con thú tranh mồi * tranh công * tranh giải vô địch",
    example: "hai con thú tranh mồi * tranh công * tranh giải vô địch",
  },
  {
    word: "tranh",
    part_of_speech: "động từ",
    meaning:
      "tìm cách làm nhanh việc gì đó trước người khác, không để cho người khác kịp làm: mua tranh hàng * tranh nhau hỏi",
    example: "mua tranh hàng * tranh nhau hỏi",
  },
  {
    word: "trang trọng",
    part_of_speech: "tính từ",
    meaning:
      "có những yếu tố biểu hiện sự hết mực coi trọng: cuộc tiếp đón trang trọng * bức ảnh được treo ở nơi trang trọng nhất",
    example:
      "cuộc tiếp đón trang trọng * bức ảnh được treo ở nơi trang trọng nhất",
  },
  {
    word: "tránh",
    part_of_speech: "động từ",
    meaning:
      "tự di chuyển sang một bên, một phía để khỏi làm vướng nhau, khỏi va vào nhau: hai xe tránh nhau * đi tránh sang bên nhường đường",
    example: "hai xe tránh nhau * đi tránh sang bên nhường đường",
  },
  {
    word: "tránh",
    part_of_speech: "động từ",
    meaning:
      "chủ động làm cho mình khỏi phải tiếp xúc hoặc khỏi phải chịu tác động trực tiếp của cái gì đó không hay, không thích: vào hầm tránh đạn * chim bay về phương nam tránh rét * tránh voi chẳng xấu mặt nào (tng)",
    example:
      "vào hầm tránh đạn * chim bay về phương nam tránh rét * tránh voi chẳng xấu mặt nào (tng)",
  },
  {
    word: "tránh",
    part_of_speech: "động từ",
    meaning:
      "chủ động làm cho điều không hay nào đó không xảy ra với mình: thực hành tiết kiệm, tránh lãng phí * thất bại không tránh khỏi",
    example: "thực hành tiết kiệm, tránh lãng phí * thất bại không tránh khỏi",
  },
  {
    word: "tránh",
    part_of_speech: "động từ",
    meaning:
      "tự giữ không làm điều gì đó: tránh làm cho người bệnh quá căng thẳng",
    example: "tránh làm cho người bệnh quá căng thẳng",
  },
  {
    word: "tranh ảnh",
    part_of_speech: "danh từ",
    meaning:
      "tranh và ảnh (nói khái quát): bé học chữ qua tranh ảnh * trong phòng dán đầy tranh ảnh",
    example: "bé học chữ qua tranh ảnh * trong phòng dán đầy tranh ảnh",
  },
  {
    word: "tranh cãi",
    part_of_speech: "động từ",
    meaning:
      "bàn cãi gay gắt để phân rõ phải trái: tranh cãi kịch liệt * vụ việc gây tranh cãi",
    example: "tranh cãi kịch liệt * vụ việc gây tranh cãi",
  },
  {
    word: "trành",
    part_of_speech: "danh từ",
    meaning:
      '(phương ngữ) lưỡi gươm, lưỡi dao cùn và đã mất cán: "Gươm linh sút cán còn trành, Bình hương dẫu bể, miểng sành còn thơm." (ca dao)',
    example:
      'Gươm linh sút cán còn trành, Bình hương dẫu bể, miểng sành còn thơm." (ca dao)',
  },
  {
    word: "trành",
    part_of_speech: "động từ",
    meaning:
      "nghiêng hẳn về một bên, mất thăng bằng (thường nói về thuyền): chiếc thuyền trành như sắp lật",
    example: "chiếc thuyền trành như sắp lật",
  },
  {
    word: "tranh cường",
    part_of_speech: "động từ",
    meaning:
      '(cũ, hiếm) như tranh hùng: "Trước cờ, ai dám tranh cường, Năm năm hùng cứ một phương hải tần." (TKiều)',
    example:
      'Trước cờ, ai dám tranh cường, Năm năm hùng cứ một phương hải tần." (TKiều)',
  },
  {
    word: "tranh chấp",
    part_of_speech: "động từ",
    meaning:
      "tranh giành nhau một cách giằng co cái không rõ thuộc về bên nào: tranh chấp đất đai * tranh chấp thị trường",
    example: "tranh chấp đất đai * tranh chấp thị trường",
  },
  {
    word: "tranh chấp",
    part_of_speech: "động từ",
    meaning:
      "đấu tranh giằng co khi có ý kiến bất đồng, thường là trong vấn đề quyền lợi giữa hai bên: tranh chấp ý kiến * giải quyết tranh chấp thương mại quốc tế",
    example: "tranh chấp ý kiến * giải quyết tranh chấp thương mại quốc tế",
  },
  {
    word: "tranh dân gian",
    part_of_speech: "danh từ",
    meaning:
      "thể loại tranh thường có nội dung phản ánh cảnh sinh hoạt của nhân dân, thiên về lối cách điệu hoá, được lưu truyền lâu đời và rộng rãi trong dân gian: tranh dân gian Hàng Trống",
    example: "tranh dân gian Hàng Trống",
  },
  {
    word: "tranh cử",
    part_of_speech: "động từ",
    meaning:
      "ra ứng cử trong một cuộc vận động bầu cử, đối lập với những ứng cử viên khác: vận động tranh cử * tranh cử tổng thống",
    example: "vận động tranh cử * tranh cử tổng thống",
  },
  {
    word: "tranh đấu",
    part_of_speech: "động từ",
    meaning:
      "(cũ) như đấu tranh (nhưng thường có ý khái quát hơn): cuộc tranh đấu * xếp bút nghiên lên đường tranh đấu",
    example: "cuộc tranh đấu * xếp bút nghiên lên đường tranh đấu",
  },
  {
    word: "tranh đua",
    part_of_speech: "động từ",
    meaning: "(hiếm) như đua tranh: tranh đua với đời",
    example: "tranh đua với đời",
  },
  {
    word: "tranh giành",
    part_of_speech: "động từ",
    meaning:
      "tranh nhau để giành lấy (nói khái quát): tranh giành của cải * tranh giành quyền lực",
    example: "tranh giành của cải * tranh giành quyền lực",
  },
  {
    word: "tranh đoạt",
    part_of_speech: "động từ",
    meaning:
      "tranh giành để chiếm hẳn về mình: tranh đoạt quyền hành * tranh đoạt thị phần",
    example: "tranh đoạt quyền hành * tranh đoạt thị phần",
  },
  {
    word: "tranh hùng",
    part_of_speech: "động từ",
    meaning:
      "đọ sức với nhau để giành vị trí của kẻ mạnh (giữa hai hoặc nhiều thế lực lớn): trận tranh hùng giữa hai võ sĩ",
    example: "trận tranh hùng giữa hai võ sĩ",
  },
  {
    word: "tránh mặt",
    part_of_speech: "động từ",
    meaning: "tránh không gặp hoặc không để cho gặp: tránh mặt không tiếp",
    example: "tránh mặt không tiếp",
  },
  {
    word: "tranh luận",
    part_of_speech: "động từ",
    meaning:
      "bàn cãi để tìm ra lẽ phải: tranh luận về công việc * cuộc tranh luận sôi nổi",
    example: "tranh luận về công việc * cuộc tranh luận sôi nổi",
  },
  {
    word: "tránh né",
    part_of_speech: "động từ",
    meaning:
      "như né tránh (nhưng có ý chủ động hơn): tránh né những câu hỏi khó",
    example: "tránh né những câu hỏi khó",
  },
  {
    word: "tránh tiếng",
    part_of_speech: "động từ",
    meaning:
      "tránh cho mình khỏi bị mang tiếng: tránh tiếng thị phi * tránh tiếng nên không ra mặt giúp",
    example: "tránh tiếng thị phi * tránh tiếng nên không ra mặt giúp",
  },
  {
    word: "tranh thủ",
    part_of_speech: "động từ",
    meaning:
      "tận dụng một cách tích cực cái bình thường có thể không sử dụng đến: ăn tranh thủ trong giờ giải lao * tranh thủ thời cơ",
    example: "ăn tranh thủ trong giờ giải lao * tranh thủ thời cơ",
  },
  {
    word: "tranh thủ",
    part_of_speech: "động từ",
    meaning:
      "giành lấy về cho mình sự đồng tình và ủng hộ: tranh thủ dư luận * tranh thủ sự giúp đỡ của bạn bè",
    example: "tranh thủ dư luận * tranh thủ sự giúp đỡ của bạn bè",
  },
  {
    word: "tranh tối tranh sáng",
    part_of_speech: "",
    meaning: "(trời) chưa sáng hẳn hoặc chưa tối hẳn, đang còn ánh sáng lờ mờ.",
    example: "thời buổi tranh tối tranh sáng",
  },
  {
    word: "tranh tụng",
    part_of_speech: "động từ",
    meaning: "(hiếm) như kiện cáo: tranh tụng về ruộng đất",
    example: "tranh tụng về ruộng đất",
  },
  {
    word: "tráo",
    part_of_speech: "động từ",
    meaning:
      "đưa cái nọ vào thay thế cho cái kia để đánh lừa: tráo bài thi cho nhau * tráo hàng xấu lấy hàng tốt * lường thưng tráo đấu (tng)",
    example:
      "tráo bài thi cho nhau * tráo hàng xấu lấy hàng tốt * lường thưng tráo đấu (tng)",
  },
  {
    word: "tráo",
    part_of_speech: "động từ",
    meaning:
      "đổi ngược vị trí đầu, đuôi hoặc trên, dưới của các vật cùng loại xếp cạnh nhau: tráo bài trước khi chia * nằm tráo đầu đuôi",
    example: "tráo bài trước khi chia * nằm tráo đầu đuôi",
  },
  {
    word: "tráo",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) trố: tráo mắt nhìn",
    example: "tráo mắt nhìn",
  },
  {
    word: "trào",
    part_of_speech: "động từ",
    meaning:
      "chảy tràn ra, do dâng lên quá miệng của vật đựng: cơm sôi trào cả ra ngoài * thương trào nước mắt",
    example: "cơm sôi trào cả ra ngoài * thương trào nước mắt",
  },
  {
    word: "trào",
    part_of_speech: "động từ",
    meaning:
      "cuộn dâng lên một cách mạnh mẽ: sóng biển trào lên * trong lòng trào lên niềm thương cảm",
    example: "sóng biển trào lên * trong lòng trào lên niềm thương cảm",
  },
  {
    word: "trao",
    part_of_speech: "động từ",
    meaning:
      "đưa tận tay cho người khác với thái độ tin cậy, trân trọng: trao chìa khoá * trao giải thưởng",
    example: "trao chìa khoá * trao giải thưởng",
  },
  {
    word: "trao",
    part_of_speech: "động từ",
    meaning:
      "giao cho người khác một cách trân trọng nhiệm vụ, quyền lợi nào đó: trao quyền * trao nhiệm vụ",
    example: "trao quyền * trao nhiệm vụ",
  },
  {
    word: "trao đổi",
    part_of_speech: "động từ",
    meaning:
      "chuyển qua lại cho nhau những vật tương đương nào đó (nói khái quát): trao đổi thư từ * trao đổi hàng hoá * chính sách trao đổi tù binh",
    example:
      "trao đổi thư từ * trao đổi hàng hoá * chính sách trao đổi tù binh",
  },
  {
    word: "trao đổi",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bàn bạc ý kiến với nhau để đi đến thống nhất: vấn đề này cần phải trao đổi thêm",
    example: "vấn đề này cần phải trao đổi thêm",
  },
  {
    word: "tráo đổi",
    part_of_speech: "động từ",
    meaning:
      "đổi bằng cách tráo cái này bằng một cái khác: tráo đổi vị trí cho nhau",
    example: "tráo đổi vị trí cho nhau",
  },
  {
    word: "tráo chác",
    part_of_speech: "",
    meaning:
      '(cũ, hiếm) như tráo trở: "Nực cười con tạo trớ trinh, Chữ duyên tráo chác, chữ tình lãng xao." (ca dao)',
    example:
      'Nực cười con tạo trớ trinh, Chữ duyên tráo chác, chữ tình lãng xao." (ca dao)',
  },
  {
    word: "trào dâng",
    part_of_speech: "động từ",
    meaning:
      "dâng lên nhiều, tràn đầy và mạnh mẽ (thường nói về cảm xúc, tình cảm): sóng biển trào dâng * nỗi xúc động trào dâng",
    example: "sóng biển trào dâng * nỗi xúc động trào dâng",
  },
  {
    word: "trao gửi",
    part_of_speech: "động từ",
    meaning:
      "(văn chương) trao (cái quý giá) cho người nào đó với tất cả lòng tin cậy: trao gửi tình cảm * trao gửi cả cuộc đời",
    example: "trao gửi tình cảm * trao gửi cả cuộc đời",
  },
  {
    word: "trào lộng",
    part_of_speech: "tính từ",
    meaning:
      "(lối văn) có tính chất chế giễu để đùa cợt, gây cười: giọng văn trào lộng",
    example: "giọng văn trào lộng",
  },
  {
    word: "trào phúng",
    part_of_speech: "tính từ",
    meaning:
      "có tác dụng gây cười để châm biếm, phê phán: thơ trào phúng * giọng điệu trào phúng",
    example: "thơ trào phúng * giọng điệu trào phúng",
  },
  {
    word: "trào lưu",
    part_of_speech: "danh từ",
    meaning:
      "xu hướng đang được đông đảo người theo trong một lĩnh vực tư tưởng, văn hoá, v.v. nào đó: trào lưu văn hoá mới * trào lưu văn học hiện thực",
    example: "trào lưu văn hoá mới * trào lưu văn học hiện thực",
  },
  {
    word: "trao tặng",
    part_of_speech: "động từ",
    meaning: "trao cho một cách trang trọng: trao tặng huân chương lao động",
    example: "trao tặng huân chương lao động",
  },
  {
    word: "trao trả",
    part_of_speech: "động từ",
    meaning: "trao để trả lại, theo thoả thuận: trao trả tù binh",
    example: "trao trả tù binh",
  },
  {
    word: "tráo trở",
    part_of_speech: "",
    meaning:
      "dễ dàng thay đổi, làm trái lại điều đã nói, đã hứa, đã cam kết: lòng người tráo trở",
    example: "lòng người tráo trở",
  },
  {
    word: "trao tráo",
    part_of_speech: "tính từ",
    meaning: "(mắt) mở to và nhìn thẳng, không chớp: mắt mở trao tráo",
    example: "mắt mở trao tráo",
  },
  {
    word: "tráo trưng",
    part_of_speech: "",
    meaning: "(mắt) giương to lên và nhìn đảo qua đảo lại: mắt tráo trưng",
    example: "mắt tráo trưng",
  },
  {
    word: "tráp",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng hình hộp nhỏ bằng gỗ, thời trước dùng để đựng các vật nhỏ hay giấy tờ, trầu cau: tráp đựng trầu * cắp tráp theo hầu",
    example: "tráp đựng trầu * cắp tráp theo hầu",
  },
  {
    word: "trát",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) lệnh bằng văn bản của quan lại truyền xuống cho dân, cho cấp dưới: lính cầm trát về làng bắt phu",
    example: "lính cầm trát về làng bắt phu",
  },
  {
    word: "trát",
    part_of_speech: "động từ",
    meaning:
      "làm cho kín hoặc phẳng bằng cách phủ và xoa một lớp dính và mịn lên bề mặt: trát vách * tường trát xi măng * bôi tro trát trấu (tng)",
    example: "trát vách * tường trát xi măng * bôi tro trát trấu (tng)",
  },
  {
    word: "trau chuốt",
    part_of_speech: "động từ",
    meaning:
      "sửa sang, tô điểm cẩn thận từng chi tiết cho hình thức đẹp hơn: ăn mặc trau chuốt * trau chuốt từng câu văn",
    example: "ăn mặc trau chuốt * trau chuốt từng câu văn",
  },
  {
    word: "trảy",
    part_of_speech: "động từ",
    meaning: "róc cho sạch: trảy mắt tre",
    example: "trảy mắt tre",
  },
  {
    word: "trau",
    part_of_speech: "động từ",
    meaning: "(hiếm) làm cho bóng, cho đẹp lên bằng cách mài, giũa: trau ngọc",
    example: "trau ngọc",
  },
  {
    word: "trau dồi",
    part_of_speech: "động từ",
    meaning:
      "làm cho ngày càng trở thành tốt đẹp hơn, có chất lượng cao hơn: trau dồi kiến thức * trau dồi đạo đức",
    example: "trau dồi kiến thức * trau dồi đạo đức",
  },
  {
    word: "trắc",
    part_of_speech: "danh từ",
    meaning:
      "cây to ở rừng thuộc họ đậu, gỗ màu đỏ, về sau đen, thớ rất mịn, thuộc loại gỗ quý: bàn ghế làm bằng gỗ trắc",
    example: "bàn ghế làm bằng gỗ trắc",
  },
  {
    word: "trắc",
    part_of_speech: "tính từ",
    meaning:
      "(âm tiết) có thanh hỏi, ngã, sắc hoặc nặng; phân biệt với bằng: câu thơ gieo vần trắc * luật bằng trắc trong thơ đường luật",
    example: "câu thơ gieo vần trắc * luật bằng trắc trong thơ đường luật",
  },
  {
    word: "trắc ẩn",
    part_of_speech: "động từ",
    meaning:
      "thương xót một cách kín đáo trong lòng: động lòng trắc ẩn * ánh mắt đầy vẻ trắc ẩn",
    example: "động lòng trắc ẩn * ánh mắt đầy vẻ trắc ẩn",
  },
  {
    word: "trắc địa",
    part_of_speech: "động từ",
    meaning:
      "nghiên cứu hình dáng, kích thước Trái Đất và dùng phương pháp đo chính xác vẽ bản đồ một phần hoặc toàn bộ bề mặt Trái Đất: đường trắc địa * kĩ thuật trắc địa bản đồ",
    example: "đường trắc địa * kĩ thuật trắc địa bản đồ",
  },
  {
    word: "trắc địa",
    part_of_speech: "danh từ",
    meaning: "trắc địa học (nói tắt): ngành trắc địa",
    example: "ngành trắc địa",
  },
  {
    word: "trắc trở",
    part_of_speech: "",
    meaning:
      "có trở ngại, làm cho không tiến hành được dễ dàng, thuận lợi: đường đi trắc trở * tình duyên trắc trở * gặp nhiều trắc trở trên đường đời",
    example:
      "đường đi trắc trở * tình duyên trắc trở * gặp nhiều trắc trở trên đường đời",
  },
  {
    word: "trắc thủ",
    part_of_speech: "danh từ",
    meaning:
      "người sử dụng một loại khí tài nào đó để đo lường hoặc định vị: trắc thủ radar",
    example: "trắc thủ radar",
  },
  {
    word: "trắc nghiệm",
    part_of_speech: "động từ",
    meaning:
      "khảo sát và đo lường khi làm các thí nghiệm khoa học trong phòng.",
    example: "trắc nghiệm tâm lí * thi trắc nghiệm * câu hỏi trắc nghiệm",
  },
  {
    word: "trằm",
    part_of_speech: "danh từ",
    meaning:
      '(phương ngữ) hoa tai: "Giúp em đôi chiếu em nằm, Đôi chăn em đắp, đôi trằm em đeo." (ca dao)',
    example:
      'Giúp em đôi chiếu em nằm, Đôi chăn em đắp, đôi trằm em đeo." (ca dao)',
  },
  {
    word: "trăm",
    part_of_speech: "danh từ",
    meaning:
      "số đếm, bằng mười chục: một trăm đồng * trăm rưỡi (một trăm năm mươi)",
    example: "một trăm đồng * trăm rưỡi (một trăm năm mươi)",
  },
  {
    word: "trăm",
    part_of_speech: "danh từ",
    meaning:
      "số lượng lớn không xác định, nói chung: trăm hoa đua nở * khổ cực trăm bề",
    example: "trăm hoa đua nở * khổ cực trăm bề",
  },
  {
    word: "trăm họ",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) mọi người dân thường (nói tổng quát): vỗ yên trăm họ * đất nước loạn lạc, trăm họ lầm than",
    example: "vỗ yên trăm họ * đất nước loạn lạc, trăm họ lầm than",
  },
  {
    word: "trăm sự",
    part_of_speech: "danh từ",
    meaning:
      '(khẩu ngữ) hết thảy mọi điều, thường là rắc rối, khó khăn: trăm sự đều do hiểu lầm mà ra * "Nhạn ơi, trăm sự nhờ mày, Gửi thư đem đến tận tay cho chàng." (ca dao)',
    example:
      'trăm sự đều do hiểu lầm mà ra * "Nhạn ơi, trăm sự nhờ mày, Gửi thư đem đến tận tay cho chàng." (ca dao)',
  },
  {
    word: "trăm năm",
    part_of_speech: "danh từ",
    meaning:
      '(văn chương) khoảng thời gian trọn vẹn của một đời người, nói chung: "Đã nguyền hai chữ  * , Trăm năm thề chẳng ôm cầm thuyền ai." (TKiều)',
    example:
      'Đã nguyền hai chữ  * , Trăm năm thề chẳng ôm cầm thuyền ai." (TKiều)',
  },
  {
    word: "trăm năm",
    part_of_speech: "danh từ",
    meaning:
      "suốt cả đời người (nói về tình nghĩa vợ chồng): chọn bạn trăm năm * tính chuyện trăm năm",
    example: "chọn bạn trăm năm * tính chuyện trăm năm",
  },
  {
    word: "trăm ngàn",
    part_of_speech: "danh từ",
    meaning:
      'cả trăm cả nghìn; chỉ số lượng rất nhiều và đủ thứ: trăm nghìn cay đắng * "Trăm nghìn gửi lại tình quân, Tơ duyên ngắn ngủi có ngần ấy thôi." (TKiều)',
    example:
      'trăm nghìn cay đắng * "Trăm nghìn gửi lại tình quân, Tơ duyên ngắn ngủi có ngần ấy thôi." (TKiều)',
  },
  {
    word: "trăm nghìn",
    part_of_speech: "danh từ",
    meaning:
      'cả trăm cả nghìn; chỉ số lượng rất nhiều và đủ thứ: trăm nghìn cay đắng * "Trăm nghìn gửi lại tình quân, Tơ duyên ngắn ngủi có ngần ấy thôi." (TKiều)',
    example:
      'trăm nghìn cay đắng * "Trăm nghìn gửi lại tình quân, Tơ duyên ngắn ngủi có ngần ấy thôi." (TKiều)',
  },
  {
    word: "trăm thứ bà giằn",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) nhiều thứ linh tinh, lôi thôi: đồ đạc lỉnh kỉnh, trăm thứ bà giằn",
    example: "đồ đạc lỉnh kỉnh, trăm thứ bà giằn",
  },
  {
    word: "trằn trọc",
    part_of_speech: "động từ",
    meaning:
      "trở mình luôn, cố ngủ mà không ngủ được vì có điều phải lo nghĩ: trằn trọc cả đêm không ngủ",
    example: "trằn trọc cả đêm không ngủ",
  },
  {
    word: "trắng",
    part_of_speech: "tính từ",
    meaning:
      "có màu như màu của vôi, của bông: áo trắng * phấn trắng * tóc trắng như cước",
    example: "áo trắng * phấn trắng * tóc trắng như cước",
  },
  {
    word: "trắng",
    part_of_speech: "tính từ",
    meaning:
      "có màu sáng, phân biệt với những cái cùng loại mà sẫm màu hoặc có màu khác: đường trắng * người da trắng * rượu trắng",
    example: "đường trắng * người da trắng * rượu trắng",
  },
  {
    word: "trắng",
    part_of_speech: "tính từ",
    meaning:
      "hoàn toàn không có hoặc không còn gì cả: làm giàu từ hai bàn tay trắng * thức trắng đêm * bỏ phiếu trắng",
    example: "làm giàu từ hai bàn tay trắng * thức trắng đêm * bỏ phiếu trắng",
  },
  {
    word: "trắng",
    part_of_speech: "tính từ",
    meaning:
      "(nói) rõ hết sự thật, không che giấu gì cả: có gì thì chị cứ nói trắng ra",
    example: "có gì thì chị cứ nói trắng ra",
  },
  {
    word: "trắng",
    part_of_speech: "tính từ",
    meaning:
      "(nốt nhạc) có độ dài bằng hai nốt đen hoặc một nửa nốt tròn: nốt la trắng",
    example: "nốt la trắng",
  },
  {
    word: "trằn",
    part_of_speech: "động từ",
    meaning:
      "vùng mạnh, trườn mạnh để cố thoát ra hoặc di chuyển đi chỗ khác: trằn lại, không chịu đi",
    example: "trằn lại, không chịu đi",
  },
  {
    word: "trằn",
    part_of_speech: "động từ",
    meaning: "căng hết sức ra làm việc gì: trằn lưng ra mà trả nợ",
    example: "trằn lưng ra mà trả nợ",
  },
  {
    word: "trăm tuổi",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian sống bằng một trăm năm, được coi là rất thọ (thường dùng trong lời chúc thọ các cụ già): mong ông bà sống lâu trăm tuổi",
    example: "mong ông bà sống lâu trăm tuổi",
  },
  {
    word: "trăm tuổi",
    part_of_speech: "động từ",
    meaning:
      "(người già) chết (lối nói kiêng tránh): lúc trăm tuổi * sau khi cha mẹ trăm tuổi",
    example: "lúc trăm tuổi * sau khi cha mẹ trăm tuổi",
  },
  {
    word: "trăn trở",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) trở mình luôn, không nằm yên ở một tư thế: trăn trở suốt đêm * nằm trăn trở, mãi không ngủ được",
    example: "trăn trở suốt đêm * nằm trăn trở, mãi không ngủ được",
  },
  {
    word: "trăn trở",
    part_of_speech: "động từ",
    meaning:
      "hoặc d băn khoăn không yên lòng vì đang có điều khiến phải suy nghĩ nhiều: trăn trở lo âu * những trăn trở trong cuộc sống",
    example: "trăn trở lo âu * những trăn trở trong cuộc sống",
  },
  {
    word: "trắng án",
    part_of_speech: "tính từ",
    meaning: "được toà án xử là vô tội: được toà xử trắng án",
    example: "được toà xử trắng án",
  },
  {
    word: "trăng",
    part_of_speech: "danh từ",
    meaning:
      'mặt trăng nhìn thấy về ban đêm: sáng tựa trăng rằm * "Vầng trăng ai xẻ làm đôi, Nửa in gối chiếc, nửa soi dặm trường." (TKiều)',
    example:
      'sáng tựa trăng rằm * "Vầng trăng ai xẻ làm đôi, Nửa in gối chiếc, nửa soi dặm trường." (TKiều)',
  },
  {
    word: "trăng",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương) tháng (âm lịch): hẹn cuối trăng sẽ về * lúa ba trăng",
    example: "hẹn cuối trăng sẽ về * lúa ba trăng",
  },
  {
    word: "trắng bong",
    part_of_speech: "tính từ",
    meaning:
      "trắng đến mức như hoàn toàn không có một vết ố bẩn nào: áo giặt trắng bong",
    example: "áo giặt trắng bong",
  },
  {
    word: "trắng bệch",
    part_of_speech: "tính từ",
    meaning: "trắng một cách nhợt nhạt: mặt trắng bệch",
    example: "mặt trắng bệch",
  },
  {
    word: "trắng bốp",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (quần áo) rất trắng và sạch, như mới hoàn toàn: chiếc áo trắng bốp",
    example: "chiếc áo trắng bốp",
  },
  {
    word: "trắng bóc",
    part_of_speech: "tính từ",
    meaning: "(nước da) trắng nõn nà, phô ra vẻ đẹp: nước da trắng bóc",
    example: "nước da trắng bóc",
  },
  {
    word: "trắng dã",
    part_of_speech: "tính từ",
    meaning:
      "(mắt) như chỉ nhìn thấy có tròng trắng, trông đáng sợ: mắt trắng dã",
    example: "mắt trắng dã",
  },
  {
    word: "trắng đen",
    part_of_speech: "tính từ",
    meaning:
      "tốt hay xấu, đúng hay sai, về mặt cần phân biệt rạch ròi: lẫn lộn trắng đen * hiểu rõ trắng đen",
    example: "lẫn lộn trắng đen * hiểu rõ trắng đen",
  },
  {
    word: "trắng hếu",
    part_of_speech: "tính từ",
    meaning:
      "trắng một màu và như trơ hết cả ra, trông không đẹp mắt: đầu cạo trắng hếu * bụng ếch trắng hếu",
    example: "đầu cạo trắng hếu * bụng ếch trắng hếu",
  },
  {
    word: "trăng già",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) Nguyệt Lão (hàm ý trách móc): "Trêu ngươi chi bấy trăng già, Trao con chỉ thắm mà ra tơ mành!" (CO)',
    example:
      'Trêu ngươi chi bấy trăng già, Trao con chỉ thắm mà ra tơ mành!" (CO)',
  },
  {
    word: "trăng gió",
    part_of_speech: "danh từ",
    meaning:
      'chỉ quan hệ yêu đương lăng nhăng, hời hợt (nói khái quát): "Sớm đào tối mận lân la, Trước còn trăng gió, sau ra đá vàng." (TKiều)',
    example:
      'Sớm đào tối mận lân la, Trước còn trăng gió, sau ra đá vàng." (TKiều)',
  },
  {
    word: "trăng hoa",
    part_of_speech: "danh từ",
    meaning:
      "chỉ quan hệ trai gái lăng nhăng, không đứng đắn (nói khái quát; thường nói về đàn ông): quen thói trăng hoa * chuyện trăng hoa",
    example: "quen thói trăng hoa * chuyện trăng hoa",
  },
  {
    word: "trắng lốp",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) trắng nổi hẳn lên, như đập vào mắt mọi người: tường quét vôi trắng lốp * chiếc áo trắng lốp",
    example: "tường quét vôi trắng lốp * chiếc áo trắng lốp",
  },
  {
    word: "trắng mắt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) sững sờ do nhận ra một sự thật đau xót nào đó: có thế mới trắng mắt ra!",
    example: "có thế mới trắng mắt ra!",
  },
  {
    word: "trăng mật",
    part_of_speech: "danh từ",
    meaning: "như tuần trăng mật: hưởng kì trăng mật",
    example: "hưởng kì trăng mật",
  },
  {
    word: "trắng ngần",
    part_of_speech: "tính từ",
    meaning: "trắng và bóng, vẻ tinh khiết, sạch sẽ: hạt gạo trắng ngần",
    example: "hạt gạo trắng ngần",
  },
  {
    word: "trắng nhởn",
    part_of_speech: "tính từ",
    meaning: "rất trắng, gây cảm giác ghê sợ: hàm răng trắng nhởn",
    example: "hàm răng trắng nhởn",
  },
  {
    word: "trắng ngà",
    part_of_speech: "tính từ",
    meaning: "trắng màu ngà voi, hơi vàng, trông đẹp: cái khăn màu trắng ngà",
    example: "cái khăn màu trắng ngà",
  },
  {
    word: "trắng muốt",
    part_of_speech: "tính từ",
    meaning:
      "trắng và mịn màng, trông đẹp: hàm răng trắng muốt * con mèo có bộ lông trắng muốt",
    example: "hàm răng trắng muốt * con mèo có bộ lông trắng muốt",
  },
  {
    word: "trắng nõn",
    part_of_speech: "tính từ",
    meaning: "trắng mịn và mượt, trông mềm mại và tươi đẹp: nước da trắng nõn",
    example: "nước da trắng nõn",
  },
  {
    word: "trắng nuột",
    part_of_speech: "tính từ",
    meaning: "trắng và bóng, mượt, trông đẹp: sợi tơ trắng nuột",
    example: "sợi tơ trắng nuột",
  },
  {
    word: "trắng tay",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) bị mất hết tất cả tiền bạc của cải, hoàn toàn không còn gì: trắng tay vì cờ bạc",
    example: "trắng tay vì cờ bạc",
  },
  {
    word: "trắng phau",
    part_of_speech: "tính từ",
    meaning:
      "trắng hoàn toàn, không có lấy một vết nào của màu khác: đàn cò trắng phau * bãi cát trắng phau",
    example: "đàn cò trắng phau * bãi cát trắng phau",
  },
  {
    word: "trăng trắng",
    part_of_speech: "tính từ",
    meaning: "có màu hơi trắng: dải ngân hà trăng trắng",
    example: "dải ngân hà trăng trắng",
  },
  {
    word: "trắng phếch",
    part_of_speech: "tính từ",
    meaning:
      "bị ngả sang màu trắng đục, nhợt nhạt, không đều, trông không đẹp mắt: tường vôi trắng phếch",
    example: "tường vôi trắng phếch",
  },
  {
    word: "trắng tinh",
    part_of_speech: "tính từ",
    meaning:
      "rất trắng và đều một màu, gây cảm giác rất sạch: muối trắng tinh * tờ giấy trắng tinh",
    example: "muối trắng tinh * tờ giấy trắng tinh",
  },
  {
    word: "trăng tròn",
    part_of_speech: "danh từ",
    meaning:
      "trăng có hình rất tròn, vào những đêm giữa tháng âm lịch: tuổi trăng tròn (tuổi 15, 16)",
    example: "tuổi trăng tròn (tuổi 15, 16)",
  },
  {
    word: "trắng toát",
    part_of_speech: "tính từ",
    meaning:
      "trắng lắm, như đập mạnh vào mắt mọi người: tường quét vôi trắng toát",
    example: "tường quét vôi trắng toát",
  },
  {
    word: "trăng trối",
    part_of_speech: "động từ",
    meaning:
      "trối lại (nói khái quát): thực hiện lời trối trăng * không kịp trối trăng",
    example: "thực hiện lời trối trăng * không kịp trối trăng",
  },
  {
    word: "trắng trợn",
    part_of_speech: "tính từ",
    meaning:
      "ngang ngược, bất chấp cả luật pháp, lẽ phải: cướp bóc trắng trợn * ăn nói trắng trợn",
    example: "cướp bóc trắng trợn * ăn nói trắng trợn",
  },
  {
    word: "trâm",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) vật trang sức của phụ nữ thời xưa, dùng để cài tóc hoặc cài mũ vào mái tóc: lược giắt trâm cài",
    example: "lược giắt trâm cài",
  },
  {
    word: "trắng trẻo",
    part_of_speech: "tính từ",
    meaning: "(da dẻ) trắng và đẹp (nói khái quát): nước da trắng trẻo",
    example: "nước da trắng trẻo",
  },
  {
    word: "trắng trơn",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) hoàn toàn không có cái gì cả, trong khi lẽ ra thường phải có: nhà cửa trắng trơn, không còn đồ đạc gì",
    example: "nhà cửa trắng trơn, không còn đồ đạc gì",
  },
  {
    word: "trầm",
    part_of_speech: "danh từ",
    meaning: "trầm hương (nói tắt): đốt trầm",
    example: "đốt trầm",
  },
  {
    word: "trầm",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) chìm, hoặc làm cho chìm ngập dưới nước: trầm mình dưới nước",
    example: "trầm mình dưới nước",
  },
  {
    word: "trầm",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) (ruộng hoặc vùng đất) trũng, ngập nước: chân ruộng trầm * lội qua một bãi trầm",
    example: "chân ruộng trầm * lội qua một bãi trầm",
  },
  {
    word: "trầm",
    part_of_speech: "tính từ",
    meaning:
      "(giọng, tiếng) thấp và ấm: giọng trầm * tiếng đàn khi bổng khi trầm",
    example: "giọng trầm * tiếng đàn khi bổng khi trầm",
  },
  {
    word: "trầm",
    part_of_speech: "tính từ",
    meaning:
      "có biểu hiện kém sôi nổi, kém hoạt động: người trầm tính * phong trào có vẻ trầm xuống",
    example: "người trầm tính * phong trào có vẻ trầm xuống",
  },
  {
    word: "trắng xoá",
    part_of_speech: "tính từ",
    meaning: "trắng đều khắp trên một diện rất rộng: bọt nước tung trắng xoá",
    example: "bọt nước tung trắng xoá",
  },
  {
    word: "trầm bổng",
    part_of_speech: "tính từ",
    meaning:
      "(âm thanh) lúc trầm lúc bổng, nghe êm tai: tiếng đàn trầm bổng * âm thanh trầm bổng du dương",
    example: "tiếng đàn trầm bổng * âm thanh trầm bổng du dương",
  },
  {
    word: "trâm anh",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, văn chương) trâm cài đầu và dải mũ; dùng để chỉ dòng dõi quyền quý, cao sang trong xã hội phong kiến: dòng dõi trâm anh",
    example: "dòng dõi trâm anh",
  },
  {
    word: "trầm cảm",
    part_of_speech: "",
    meaning:
      "(trạng thái tinh thần) bi quan, phiền muộn, luôn cảm thấy mệt mỏi và tuyệt vọng: mắc chứng trầm cảm",
    example: "mắc chứng trầm cảm",
  },
  {
    word: "trầm hùng",
    part_of_speech: "tính từ",
    meaning:
      "vừa tha thiết vừa mạnh mẽ, làm thôi thúc lòng người: bài thơ có giai điệu trầm hùng",
    example: "bài thơ có giai điệu trầm hùng",
  },
  {
    word: "trầm kha",
    part_of_speech: "tính từ",
    meaning:
      "(bệnh) nghiêm trọng kéo dài, khó chữa; thường dùng để ví tình trạng không hay trầm trọng và kéo dài, khó giải quyết: mắc bệnh trầm kha * tham nhũng đã trở thành căn bệnh trầm kha",
    example: "mắc bệnh trầm kha * tham nhũng đã trở thành căn bệnh trầm kha",
  },
  {
    word: "trầm hương",
    part_of_speech: "danh từ",
    meaning:
      "cây to, lá dài, gỗ màu vàng nhạt có xen những thớ màu đen, dùng để đốt lấy hương thơm và làm thuốc: đốt trầm hương * gỗ trầm hương",
    example: "đốt trầm hương * gỗ trầm hương",
  },
  {
    word: "trầm lắng",
    part_of_speech: "tính từ",
    meaning:
      "lắng đọng lại, đi vào chiều sâu tâm hồn: giọng thơ trầm lắng * giai điệu trầm lắng",
    example: "giọng thơ trầm lắng * giai điệu trầm lắng",
  },
  {
    word: "trầm luân",
    part_of_speech: "động từ",
    meaning:
      "chìm đắm trong bể khổ, theo quan niệm của đạo Phật: kiếp trầm luân",
    example: "kiếp trầm luân",
  },
  {
    word: "trầm tĩnh",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra trầm lặng và bình tĩnh, không để cho có những biến đổi đột ngột, không bối rối, nóng nảy: tính trầm tĩnh, ít nói",
    example: "tính trầm tĩnh, ít nói",
  },
  {
    word: "trầm mặc",
    part_of_speech: "tính từ",
    meaning:
      "có dáng vẻ đang tập trung suy tư, ngẫm nghĩ điều gì: ngồi trầm mặc suy nghĩ * vẻ mặt trầm mặc",
    example: "ngồi trầm mặc suy nghĩ * vẻ mặt trầm mặc",
  },
  {
    word: "trầm mặc",
    part_of_speech: "tính từ",
    meaning:
      "(văn chương) im lìm, gợi cảm giác thâm nghiêm, sâu lắng: cảnh chùa trang nghiêm trầm mặc",
    example: "cảnh chùa trang nghiêm trầm mặc",
  },
  {
    word: "trầm lặng",
    part_of_speech: "tính từ",
    meaning:
      "lặng lẽ, ít hoạt động, không có biểu hiện sôi nổi bên ngoài: tính trầm lặng, ít nói, ít cười * cuộc sống trầm lặng",
    example: "tính trầm lặng, ít nói, ít cười * cuộc sống trầm lặng",
  },
  {
    word: "trẫm mình",
    part_of_speech: "động từ",
    meaning: "(cũ) gieo mình xuống nước để tự tử: nhảy xuống sông trẫm mình",
    example: "nhảy xuống sông trẫm mình",
  },
  {
    word: "trầm ngâm",
    part_of_speech: "tính từ",
    meaning:
      "có dáng vẻ đang suy nghĩ, nghiền ngẫm điều gì: nét mặt trầm ngâm * trầm ngâm suy nghĩ",
    example: "nét mặt trầm ngâm * trầm ngâm suy nghĩ",
  },
  {
    word: "trầm tích",
    part_of_speech: "danh từ",
    meaning:
      "chất do các vật thể trong nước sông, hồ, biển lắng đọng lâu ngày kết lại mà thành: bùn trầm tích * lớp trầm tích dưới đáy biển",
    example: "bùn trầm tích * lớp trầm tích dưới đáy biển",
  },
  {
    word: "trậm trầy trậm trật",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) như trầy trật (nhưng ý nhấn mạnh hơn): công việc trậm trầy trậm trật",
    example: "công việc trậm trầy trậm trật",
  },
  {
    word: "trầm trồ",
    part_of_speech: "động từ",
    meaning:
      "thốt ra lời khen ngợi với vẻ ngạc nhiên, thán phục: trầm trồ khen ngợi",
    example: "trầm trồ khen ngợi",
  },
  {
    word: "trầm trọng",
    part_of_speech: "tính từ",
    meaning:
      "ở tình trạng nghiêm trọng, có thể dẫn tới hậu quả hết sức tai hại: những sai phạm trầm trọng * bệnh tình ngày càng trầm trọng",
    example: "những sai phạm trầm trọng * bệnh tình ngày càng trầm trọng",
  },
  {
    word: "trầm uất",
    part_of_speech: "",
    meaning: "buồn u uất trong lòng: mắc chứng trầm uất * bị trầm uất",
    example: "mắc chứng trầm uất * bị trầm uất",
  },
  {
    word: "trầm tư",
    part_of_speech: "",
    meaning:
      "có dáng vẻ đang hết sức tập trung suy nghĩ điều gì: ngồi trầm tư suy nghĩ * nét mặt trầm tư",
    example: "ngồi trầm tư suy nghĩ * nét mặt trầm tư",
  },
  {
    word: "trận",
    part_of_speech: "danh từ",
    meaning:
      "cuộc chiến đấu diễn ra trong một thời gian và ở một khu vực nhất định: trận phục kích * xông trận",
    example: "trận phục kích * xông trận",
  },
  {
    word: "trận",
    part_of_speech: "danh từ",
    meaning:
      "cuộc thi đấu có sự tranh giành được thua: trận bóng đá * thắng liên tiếp mấy trận liền",
    example: "trận bóng đá * thắng liên tiếp mấy trận liền",
  },
  {
    word: "trận",
    part_of_speech: "danh từ",
    meaning:
      "lần, đợt diễn ra mạnh mẽ, dữ dội của một hiện tượng tự nhiên, xã hội hoặc sinh lí, tâm lí nào đó (thường là không hay) trong một thời gian nhất định: trận cuồng phong * trận đói * mắng cho một trận",
    example: "trận cuồng phong * trận đói * mắng cho một trận",
  },
  {
    word: "trấn",
    part_of_speech: "động từ",
    meaning:
      "ở trụ tại nơi nào đó, thường để ngăn giữ, bảo vệ: hai chiếc xe tăng trấn ở hai đầu cầu * đứng trấn ngay cửa, không cho ai vào",
    example:
      "hai chiếc xe tăng trấn ở hai đầu cầu * đứng trấn ngay cửa, không cho ai vào",
  },
  {
    word: "trấn",
    part_of_speech: "động từ",
    meaning:
      "ngăn chặn bằng phù phép không cho ma quỷ đến làm hại, theo tín ngưỡng dân gian: bùa trấn quỷ * làm phép trấn tà",
    example: "bùa trấn quỷ * làm phép trấn tà",
  },
  {
    word: "trấn",
    part_of_speech: "động từ",
    meaning: "(Phương ngữ) dìm xuống nước cho bị ngạt: trấn nước cho chết ngạt",
    example: "trấn nước cho chết ngạt",
  },
  {
    word: "trấn",
    part_of_speech: "động từ",
    meaning: "(Khẩu ngữ) trấn lột (nói tắt): bị lưu manh trấn hết tiền",
    example: "bị lưu manh trấn hết tiền",
  },
  {
    word: "trần",
    part_of_speech: "danh từ",
    meaning:
      "mặt phẳng nằm ngang giới hạn phía trên cùng của gian phòng hoặc toa xe: đầu chạm vào trần xe * ngó trân trân lên trần nhà",
    example: "đầu chạm vào trần xe * ngó trân trân lên trần nhà",
  },
  {
    word: "trần",
    part_of_speech: "danh từ",
    meaning:
      "cõi đời, thế giới mà con người sinh sống: tiên giáng trần * lìa trần (chết) * người trần * trần sao âm vậy",
    example: "tiên giáng trần * lìa trần (chết) * người trần * trần sao âm vậy",
  },
  {
    word: "trần",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái để lộ nửa phần trên của thân thể: mình trần trùng trục * cởi trần * tấm lưng trần",
    example: "mình trần trùng trục * cởi trần * tấm lưng trần",
  },
  {
    word: "trần",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái không được che, bọc, để lộ cả ra: để đầu trần đi giữa trời nắng * lưỡi lê tuốt trần",
    example: "để đầu trần đi giữa trời nắng * lưỡi lê tuốt trần",
  },
  {
    word: "trần",
    part_of_speech: "tính từ",
    meaning:
      "(cái xấu xa) ở trạng thái không còn được che đậy nữa mà để lộ rõ nguyên hình, chân tướng: lột trần mặt nạ * phơi trần bộ mặt xấu xa",
    example: "lột trần mặt nạ * phơi trần bộ mặt xấu xa",
  },
  {
    word: "trần",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái không có cái thường đi kèm theo, mà chỉ độc có như thế mà thôi: cưỡi ngựa trần (không có yên) * nằm ngủ trần, không cần màn",
    example: "cưỡi ngựa trần (không có yên) * nằm ngủ trần, không cần màn",
  },
  {
    word: "trần",
    part_of_speech: "phụ từ",
    meaning:
      "chỉ độc như thế mà thôi, không còn gì khác nữa: trong nhà có trần bộ bàn ghế * trên người chỉ trần chiếc quần cộc",
    example:
      "trong nhà có trần bộ bàn ghế * trên người chỉ trần chiếc quần cộc",
  },
  {
    word: "trân",
    part_of_speech: "tính từ",
    meaning:
      "ngây ra, không thấy có một cử động, một phản ứng gì cả: mặt trân ra, không hiểu gì * đứng chết trân tại chỗ * mắt mở trân trân",
    example:
      "mặt trân ra, không hiểu gì * đứng chết trân tại chỗ * mắt mở trân trân",
  },
  {
    word: "trân",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) trơ ra, không biết xấu hổ: mắng tới thế mà mặt vẫn trân ra * trân trân ra cười",
    example: "mắng tới thế mà mặt vẫn trân ra * trân trân ra cười",
  },
  {
    word: "trấn an",
    part_of_speech: "động từ",
    meaning:
      "làm cho yên lòng, hết hoang mang lo sợ: trấn an dư luận * trấn an tinh thần * tự trấn an mình",
    example: "trấn an dư luận * trấn an tinh thần * tự trấn an mình",
  },
  {
    word: "trần ai",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, văn chương) cõi đời vất vả gian truân: địa ngục trần ai * thoát vòng trần ai",
    example: "địa ngục trần ai * thoát vòng trần ai",
  },
  {
    word: "trần ai",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) vất vả, khổ sở: cuộc sống cũng trần ai lắm",
    example: "cuộc sống cũng trần ai lắm",
  },
  {
    word: "trân châu",
    part_of_speech: "danh từ",
    meaning: "ngọc trai quý: chuỗi hạt trân châu * viên ngọc trân châu",
    example: "chuỗi hạt trân châu * viên ngọc trân châu",
  },
  {
    word: "trấn áp",
    part_of_speech: "động từ",
    meaning:
      "dẹp sự chống đối bằng cách dùng lực hoặc uy quyền (thường nói về hành động chính đáng): trấn áp tội phạm * trấn áp cuộc bạo loạn",
    example: "trấn áp tội phạm * trấn áp cuộc bạo loạn",
  },
  {
    word: "trấn áp",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) nén xuống, dẹp đi những xúc cảm của nội tâm bằng sự tự chủ của bản thân: cất tiếng hát để trấn áp nỗi sợ",
    example: "cất tiếng hát để trấn áp nỗi sợ",
  },
  {
    word: "trấn át",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) át đi để ngăn chặn không cho hoạt động: trấn át ý kiến của mọi người",
    example: "trấn át ý kiến của mọi người",
  },
  {
    word: "trần duyên",
    part_of_speech: "danh từ",
    meaning:
      'những điều ràng buộc, gắn bó con người vào cõi đời trần tục, theo quan niệm của đạo Phật (nói khái quát): nợ trần duyên * "Cho hay giọt nước cành dương, Lửa lòng tưới tắt mọi đường trần duyên." (TKiều)',
    example:
      'nợ trần duyên * "Cho hay giọt nước cành dương, Lửa lòng tưới tắt mọi đường trần duyên." (TKiều)',
  },
  {
    word: "trận đồ",
    part_of_speech: "danh từ",
    meaning:
      "bản đồ về thế trận của các bên tham chiến: quan sát trận đồ của giặc",
    example: "quan sát trận đồ của giặc",
  },
  {
    word: "trận địa",
    part_of_speech: "danh từ",
    meaning:
      "khu vực địa hình dùng để bố trí lực lượng chiến đấu: trận địa pháo * trận địa tên lửa",
    example: "trận địa pháo * trận địa tên lửa",
  },
  {
    word: "trần đời",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) cõi đời, trên đời (nói khái quát; thường dùng để nhấn mạnh ý khẳng định về một mức độ tuyệt đối nào đó): ngon nhất trần đời * khổ trần đời * trần đời chưa thấy ai đoảng như thế!",
    example:
      "ngon nhất trần đời * khổ trần đời * trần đời chưa thấy ai đoảng như thế!",
  },
  {
    word: "trần gian",
    part_of_speech: "danh từ",
    meaning: "thế giới của con người trên mặt đất: còn nặng nợ trần gian",
    example: "còn nặng nợ trần gian",
  },
  {
    word: "trần giới",
    part_of_speech: "danh từ",
    meaning: "(cũ, hiếm) như trần gian: người trần giới",
    example: "người trần giới",
  },
  {
    word: "trấn giữ",
    part_of_speech: "động từ",
    meaning:
      "bảo vệ nơi xung yếu, chống mọi sự xâm chiếm, xâm nhập: quân lính trấn giữ hai đầu cầu",
    example: "quân lính trấn giữ hai đầu cầu",
  },
  {
    word: "trấn lột",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đe doạ trực tiếp, làm cho khiếp sợ để cướp của: bọn trấn lột * bị trấn lột hết tiền bạc",
    example: "bọn trấn lột * bị trấn lột hết tiền bạc",
  },
  {
    word: "trấn ngự",
    part_of_speech: "động từ",
    meaning: "(hiếm) chặn lại không cho gây tác hại: trấn ngự dòng sông",
    example: "trấn ngự dòng sông",
  },
  {
    word: "trấn thủ",
    part_of_speech: "động từ",
    meaning: "(cũ) như trấn giữ: trấn thủ nơi xung yếu",
    example: "trấn thủ nơi xung yếu",
  },
  {
    word: "trần thế",
    part_of_speech: "danh từ",
    meaning: "như trần gian: cuộc sống nơi trần thế",
    example: "cuộc sống nơi trần thế",
  },
  {
    word: "trận mạc",
    part_of_speech: "danh từ",
    meaning:
      "nơi diễn ra các cuộc chiến đấu (nói khái quát); cũng dùng để nói chung về việc đánh trận: xông pha nơi trận mạc",
    example: "xông pha nơi trận mạc",
  },
  {
    word: "trần thuật",
    part_of_speech: "động từ",
    meaning:
      "kể lại, thuật lại một câu chuyện hoặc sự việc với các chi tiết và diễn biến của nó: văn trần thuật",
    example: "văn trần thuật",
  },
  {
    word: "trận tiền",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, hiếm) mặt trận, nơi đang diễn ra các cuộc chiến đấu: hi sinh nơi trận tiền",
    example: "hi sinh nơi trận tiền",
  },
  {
    word: "trấn tĩnh",
    part_of_speech: "động từ",
    meaning:
      "lấy lại bình tĩnh hoặc giữ cho khỏi mất bình tĩnh: lúng túng nhưng trấn tĩnh được ngay * sợ nhưng vẫn cố trấn tĩnh",
    example: "lúng túng nhưng trấn tĩnh được ngay * sợ nhưng vẫn cố trấn tĩnh",
  },
  {
    word: "trân trối",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) (nhìn) thẳng và lâu, không chớp mắt: nhìn trân trối",
    example: "nhìn trân trối",
  },
  {
    word: "trần trụi",
    part_of_speech: "tính từ",
    meaning:
      "(thân thể hoặc bộ phận thân thể) ở trạng thái phơi bày ra tất cả, không được che đậy gì: tấm lưng trần trụi",
    example: "tấm lưng trần trụi",
  },
  {
    word: "trân trọng",
    part_of_speech: "động từ",
    meaning:
      "tỏ ý quý, coi trọng: trân trọng kỉ vật của tổ tiên * xin trân trọng cảm ơn!",
    example: "trân trọng kỉ vật của tổ tiên * xin trân trọng cảm ơn!",
  },
  {
    word: "trần tình",
    part_of_speech: "động từ",
    meaning:
      "(cũ) trình bày với bề trên việc riêng hoặc ý kiến riêng của mình: dâng biểu trần tình",
    example: "dâng biểu trần tình",
  },
  {
    word: "trần truồng",
    part_of_speech: "tính từ",
    meaning:
      "hoàn toàn không mặc quần áo, để lộ toàn thân thể: thân thể trần truồng",
    example: "thân thể trần truồng",
  },
  {
    word: "trần tục",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương, hiếm) cõi đời trên mặt đất, cõi trần: người trần tục * thoát vòng trần tục",
    example: "người trần tục * thoát vòng trần tục",
  },
  {
    word: "trần tục",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về cuộc sống trên cõi trần, coi là vật chất, tầm thường, không có gì thanh cao: những ham muốn trần tục * thoát vòng trần tục",
    example: "những ham muốn trần tục * thoát vòng trần tục",
  },
  {
    word: "trần trùi trụi",
    part_of_speech: "tính từ",
    meaning:
      "trần trụi hoàn toàn, không được che đậy, che phủ gì cả: mình trần trùi trụi",
    example: "mình trần trùi trụi",
  },
  {
    word: "trập trùng",
    part_of_speech: "tính từ",
    meaning:
      "tiếp liền nhau hết lớp này đến lớp khác thành dãy dài và cao thấp không đều: đồi núi trập trùng",
    example: "đồi núi trập trùng",
  },
  {
    word: "trật",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) lật ngược để bỏ ra đồ đang đội, đang mặc, bằng một động tác đột ngột: trật nón ra sau * trật vai áo cho xem vết sẹo",
    example: "trật nón ra sau * trật vai áo cho xem vết sẹo",
  },
  {
    word: "trật",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) trơ: mọi người đi hết còn trật lại một mình",
    example: "mọi người đi hết còn trật lại một mình",
  },
  {
    word: "trật",
    part_of_speech: "động từ",
    meaning:
      "ra ngoài vị trí, không còn khớp vào vị trí vốn có với một vật khác: tàu bị trật bánh * ngã trật khớp",
    example: "tàu bị trật bánh * ngã trật khớp",
  },
  {
    word: "trật",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) không đúng, không trúng: làm trật bài toán * bắn trật mục tiêu",
    example: "làm trật bài toán * bắn trật mục tiêu",
  },
  {
    word: "trận tuyến",
    part_of_speech: "danh từ",
    meaning:
      "hệ thống bố trí lực lượng chiến đấu, có phân rõ ranh giới giữa hai bên giao chiến: chọc thủng trận tuyến * phía bên kia trận tuyến",
    example: "chọc thủng trận tuyến * phía bên kia trận tuyến",
  },
  {
    word: "trận tuyến",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức rộng rãi tập hợp những lực lượng cùng đấu tranh cho một mục đích chung: thành lập trận tuyến phòng chống tội phạm",
    example: "thành lập trận tuyến phòng chống tội phạm",
  },
  {
    word: "trật tự",
    part_of_speech: "danh từ",
    meaning:
      "sự sắp xếp theo một thứ tự, một quy tắc nhất định: bàn ghế kê có trật tự * trật tự từ trong câu",
    example: "bàn ghế kê có trật tự * trật tự từ trong câu",
  },
  {
    word: "trật tự",
    part_of_speech: "danh từ",
    meaning:
      "tình trạng ổn định, có tổ chức, có kỉ luật: giữ trật tự trị an * nói chuyện làm mất trật tự trong lớp",
    example: "giữ trật tự trị an * nói chuyện làm mất trật tự trong lớp",
  },
  {
    word: "trật tự",
    part_of_speech: "tính từ",
    meaning:
      "có trật tự, ổn định, không ồn ào: cả lớp trật tự nghe cô giáo giảng bài",
    example: "cả lớp trật tự nghe cô giáo giảng bài",
  },
  {
    word: "trấu",
    part_of_speech: "danh từ",
    meaning: "lớp vỏ cứng đã tách ra của hạt thóc: bếp đun trấu",
    example: "bếp đun trấu",
  },
  {
    word: "trật lất",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ, khẩu ngữ) trật hết, không đúng, không trúng chỗ nào: đoán trật lất hết trơn",
    example: "đoán trật lất hết trơn",
  },
  {
    word: "trâng tráo",
    part_of_speech: "tính từ",
    meaning:
      "ngang ngược, xấc láo, tỏ ra trơ trơ trước sự chê cười, khinh bỉ của người khác: bộ mặt trâng tráo",
    example: "bộ mặt trâng tráo",
  },
  {
    word: "trẩu",
    part_of_speech: "danh từ",
    meaning:
      "cây cùng họ với thầu dầu, hoa đơn tính, màu trắng, quả phía ngoài có nhiều gân nổi, hạt cho dầu dùng để chế sơn: dầu trẩu",
    example: "dầu trẩu",
  },
  {
    word: "trầu",
    part_of_speech: "danh từ",
    meaning: "trầu không (nói tắt): lá trầu * giàn trầu",
    example: "lá trầu * giàn trầu",
  },
  {
    word: "trầu",
    part_of_speech: "danh từ",
    meaning:
      "lá trầu đã têm, dùng để nhai cùng với cau cho thơm miệng, đỏ môi: ăn trầu * nước cốt trầu * miếng trầu là đầu câu chuyện (tng)",
    example: "ăn trầu * nước cốt trầu * miếng trầu là đầu câu chuyện (tng)",
  },
  {
    word: "trâu",
    part_of_speech: "danh từ",
    meaning:
      "động vật nhai lại, sừng rỗng và cong, lông thưa và thường đen, ưa đầm nước, nuôi để lấy sức kéo, ăn thịt hay lấy sữa: chăn trâu * yếu trâu còn hơn khoẻ bò (tng)",
    example: "chăn trâu * yếu trâu còn hơn khoẻ bò (tng)",
  },
  {
    word: "trây",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) ì ra, cố tình không làm cái việc biết là lẽ ra phải làm, mặc dù có ý kiến yêu cầu hoặc phản đối của người khác: trây nợ * nói mãi mà vẫn trây ra, không nhúc nhích",
    example: "trây nợ * nói mãi mà vẫn trây ra, không nhúc nhích",
  },
  {
    word: "trây",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) bôi: trây bùn lên mặt * tay bẩn mà trây vô áo",
    example: "trây bùn lên mặt * tay bẩn mà trây vô áo",
  },
  {
    word: "trẩy",
    part_of_speech: "động từ",
    meaning:
      "đi đến nơi xa (thường nói về một số đông người): trẩy hội * dòng người trẩy về kinh",
    example: "trẩy hội * dòng người trẩy về kinh",
  },
  {
    word: "trẩy",
    part_of_speech: "động từ",
    meaning: "hái, thu hái (thường là quả): trẩy ổi * trẩy đậu",
    example: "trẩy ổi * trẩy đậu",
  },
  {
    word: "trầu không",
    part_of_speech: "danh từ",
    meaning:
      "cây leo, thường trồng thành giàn, lá hình tim, có mùi hăng, thường dùng để ăn trầu: giàn trầu không",
    example: "giàn trầu không",
  },
  {
    word: "trâu ngựa",
    part_of_speech: "danh từ",
    meaning:
      'trâu và ngựa (nói khái quát); dùng để ví kiếp tôi đòi phải đem thân làm việc nặng nhọc để phục vụ người khác và phải chịu cảnh sống vất vả, đoạ đày: kiếp trâu ngựa * "Tái sinh chưa dứt hương thề, Làm thân trâu ngựa đền nghì trúc mai." (TKiều)',
    example:
      'kiếp trâu ngựa * "Tái sinh chưa dứt hương thề, Làm thân trâu ngựa đền nghì trúc mai." (TKiều)',
  },
  {
    word: "trẩy hội",
    part_of_speech: "động từ",
    meaning:
      "đi dự ngày hội hằng năm (thường nói về một số đông người): trẩy hội chùa Hương * người đông như trẩy hội",
    example: "trẩy hội chùa Hương * người đông như trẩy hội",
  },
  {
    word: "trầy",
    part_of_speech: "",
    meaning: "(phương ngữ) như sầy: ngã trầy da",
    example: "ngã trầy da",
  },
  {
    word: "trầy trật",
    part_of_speech: "tính từ",
    meaning:
      "vất vả, phải mất nhiều công sức và trải qua nhiều lần vấp váp, thất bại: trầy trật mãi mới làm xong",
    example: "trầy trật mãi mới làm xong",
  },
  {
    word: "trây ì",
    part_of_speech: "động từ",
    meaning: "trây ra một cách lì lợm, đáng ghét: trây ì không chịu trả nợ",
    example: "trây ì không chịu trả nợ",
  },
  {
    word: "trầy vi tróc vảy",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) ví trường hợp phải chịu tổn thương mất mát hoặc phải hết sức khó nhọc cho một việc làm nào đó: làm trầy vi tróc vảy mà vẫn không đủ sống",
    example: "làm trầy vi tróc vảy mà vẫn không đủ sống",
  },
  {
    word: "trầy trụa",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) sây sát: ngã trầy trụa cả tay chân",
    example: "ngã trầy trụa cả tay chân",
  },
  {
    word: "trầy xước",
    part_of_speech: "tính từ",
    meaning:
      "có vết trầy, vết xước trên bề mặt (nói khái quát): da tay bị trầy xước * mặt đĩa có nhiều vết trầy xước",
    example: "da tay bị trầy xước * mặt đĩa có nhiều vết trầy xước",
  },
  {
    word: "tre",
    part_of_speech: "danh từ",
    meaning:
      "cây thân cứng, rỗng ở các gióng, đặc ở mấu, mọc thành bụi, thường dùng để làm nhà và đan lát: luỹ tre * tre già măng mọc (tng)",
    example: "luỹ tre * tre già măng mọc (tng)",
  },
  {
    word: "trẻ",
    part_of_speech: "tính từ",
    meaning:
      "ở vào thời kì còn ít tuổi, cơ thể đang phát triển mạnh, đang sung sức: thời trẻ * anh bạn trẻ * tuổi đời còn rất trẻ * trẻ cậy cha, già cậy con (tng)",
    example:
      "thời trẻ * anh bạn trẻ * tuổi đời còn rất trẻ * trẻ cậy cha, già cậy con (tng)",
  },
  {
    word: "trẻ",
    part_of_speech: "tính từ",
    meaning:
      "có vẻ ngoài trông có vẻ như ít tuổi hơn so với những người cùng độ tuổi hoặc so với những người khác: nhỏ người nên trẻ lâu * dạo này trông trẻ ra",
    example: "nhỏ người nên trẻ lâu * dạo này trông trẻ ra",
  },
  {
    word: "trẻ",
    part_of_speech: "tính từ",
    meaning:
      "còn mới, có thời gian tồn tại hoặc hoạt động chưa lâu như những cái, những người cùng loại: một ngành công nghiệp trẻ * cây bút trẻ * còn trẻ tuổi nghề",
    example: "một ngành công nghiệp trẻ * cây bút trẻ * còn trẻ tuổi nghề",
  },
  {
    word: "trẻ",
    part_of_speech: "danh từ",
    meaning:
      "đứa bé, đứa nhỏ (nói khái quát): trẻ sơ sinh * người trông trẻ * thỏ thẻ như trẻ lên ba (tng)",
    example: "trẻ sơ sinh * người trông trẻ * thỏ thẻ như trẻ lên ba (tng)",
  },
  {
    word: "trẻ em",
    part_of_speech: "danh từ",
    meaning:
      "như trẻ con (nhưng dùng với ý thân mật): trẻ em khuyết tật * bảo vệ phụ nữ và trẻ em",
    example: "trẻ em khuyết tật * bảo vệ phụ nữ và trẻ em",
  },
  {
    word: "trẻ con",
    part_of_speech: "danh từ",
    meaning:
      "những đứa trẻ (nói khái quát): bọn trẻ con trong xóm * trẻ con mất lòng người lớn (tng)",
    example: "bọn trẻ con trong xóm * trẻ con mất lòng người lớn (tng)",
  },
  {
    word: "trẻ con",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất của trẻ con (thường hàm ý coi thường): chuyện trẻ con * trò trẻ con * tính còn trẻ con quá",
    example: "chuyện trẻ con * trò trẻ con * tính còn trẻ con quá",
  },
  {
    word: "trẻ con",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) tỏ ra tâm tình, thân thiết: chuyện trò rất tri kỉ",
    example: "chuyện trò rất tri kỉ",
  },
  {
    word: "trẻ hoá",
    part_of_speech: "động từ",
    meaning:
      "làm cho thành phần gồm có nhiều người trẻ hơn, để có được nhiều nhân tố tích cực hơn: trẻ hoá đội hình bóng đá * trẻ hoá đội ngũ cán bộ trong công ti",
    example: "trẻ hoá đội hình bóng đá * trẻ hoá đội ngũ cán bộ trong công ti",
  },
  {
    word: "trẻ mỏ",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) như trẻ con: trông nom trẻ mỏ * lớn tướng rồi chứ còn trẻ mỏ gì nữa!",
    example: "trông nom trẻ mỏ * lớn tướng rồi chứ còn trẻ mỏ gì nữa!",
  },
  {
    word: "trẻ măng",
    part_of_speech: "tính từ",
    meaning:
      "rất trẻ, chỉ vừa mới đến tuổi trưởng thành: gương mặt trẻ măng * một chiến sĩ trẻ măng",
    example: "gương mặt trẻ măng * một chiến sĩ trẻ măng",
  },
  {
    word: "trẻ nít",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ, khẩu ngữ) trẻ nhỏ: bầy trẻ nít trong xóm",
    example: "bầy trẻ nít trong xóm",
  },
  {
    word: "trẻ ranh",
    part_of_speech: "danh từ",
    meaning:
      '(khẩu ngữ) trẻ con, không đáng coi ra gì: đồ trẻ ranh! * "Lại còn bưng bít giấu quanh, Làm chi những thói trẻ ranh nực cười!" (TKiều)',
    example:
      'đồ trẻ ranh! * "Lại còn bưng bít giấu quanh, Làm chi những thói trẻ ranh nực cười!" (TKiều)',
  },
  {
    word: "trẻ trai",
    part_of_speech: "",
    meaning: "(cũ) như trai trẻ: thời trẻ trai",
    example: "thời trẻ trai",
  },
  {
    word: "trẻ thơ",
    part_of_speech: "",
    meaning:
      "như trẻ con (nhưng hàm ý còn dại, còn ngây thơ): nụ cười trẻ thơ * gương mặt trẻ thơ",
    example: "nụ cười trẻ thơ * gương mặt trẻ thơ",
  },
  {
    word: "tre trẻ",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) hơi trẻ, khá trẻ: một cô gái tre trẻ",
    example: "một cô gái tre trẻ",
  },
  {
    word: "trẻ trung",
    part_of_speech: "tính từ",
    meaning:
      "trẻ hoặc tỏ ra trẻ, có những biểu hiện của tuổi trẻ: gương mặt trẻ trung * tâm hồn trẻ trung",
    example: "gương mặt trẻ trung * tâm hồn trẻ trung",
  },
  {
    word: "trẽn",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) ngượng, xấu hổ: cười cho đỡ trẽn",
    example: "cười cho đỡ trẽn",
  },
  {
    word: "treo",
    part_of_speech: "động từ",
    meaning:
      "làm cho được giữ chặt vào một điểm ở trên cao, và để cho buông thõng xuống: treo đèn lồng * treo cờ tổ quốc * nghìn cân treo sợi tóc (tng)",
    example: "treo đèn lồng * treo cờ tổ quốc * nghìn cân treo sợi tóc (tng)",
  },
  {
    word: "treo",
    part_of_speech: "động từ",
    meaning:
      "làm cho được cố định hoàn toàn ở một vị trí trên cao, dựa vào một vật khác: tường treo nhiều tranh quý * treo biển quảng cáo",
    example: "tường treo nhiều tranh quý * treo biển quảng cáo",
  },
  {
    word: "treo",
    part_of_speech: "động từ",
    meaning: "nêu giải thưởng: treo tiền thưởng cho người bắt được hung thủ",
    example: "treo tiền thưởng cho người bắt được hung thủ",
  },
  {
    word: "treo",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tạm gác, tạm đình lại trong một thời gian: bị treo bằng * trọng tài bị treo còi",
    example: "bị treo bằng * trọng tài bị treo còi",
  },
  {
    word: "treo",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) (máy tính) ở vào trạng thái mất khả năng hoạt động, hoàn toàn không thể phản ứng lại được với bất kì tín hiệu nào được đưa vào từ bàn phím hoặc các thiết bị ngoại vi khác: máy tính nhiễm virus nên hay bị treo",
    example: "máy tính nhiễm virus nên hay bị treo",
  },
  {
    word: "trèo",
    part_of_speech: "động từ",
    meaning:
      'di chuyển thân thể lên cao bằng cử động kết hợp của tay níu, bám và chân đẩy, di chuyển từng nấc một trên một vật khác: trèo cây * trèo tường * "Yêu nhau mấy núi cũng trèo, Mấy sông cũng lội mấy đèo cũng qua." (ca dao)',
    example:
      'trèo cây * trèo tường * "Yêu nhau mấy núi cũng trèo, Mấy sông cũng lội mấy đèo cũng qua." (ca dao)',
  },
  {
    word: "tréo",
    part_of_speech: "tính từ",
    meaning:
      "(chân, tay) ở tư thế cái nọ gác, vắt lên cái kia, thành hình những đường xiên cắt nhau: ngồi vắt tréo chân",
    example: "ngồi vắt tréo chân",
  },
  {
    word: "trẹo",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái bị trật khớp xương: trẹo chân * trẹo khớp * ngã trẹo đầu gối",
    example: "trẹo chân * trẹo khớp * ngã trẹo đầu gối",
  },
  {
    word: "treo cổ",
    part_of_speech: "động từ",
    meaning:
      "thắt cổ bằng cách tròng thòng lọng vào cổ và treo trên cao: treo cổ tự tử * bước lên giá treo cổ",
    example: "treo cổ tự tử * bước lên giá treo cổ",
  },
  {
    word: "tréo giò",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ở trong tình trạng hoàn toàn không ăn khớp, trái ngược nhau một cách không hợp lí trong công việc: bố trí công tác tréo giò nên rất khó làm",
    example: "bố trí công tác tréo giò nên rất khó làm",
  },
  {
    word: "treo giò",
    part_of_speech: "động từ",
    meaning:
      "đình chỉ, không cho cầu thủ tham gia thi đấu, một hình thức kỉ luật, thường dùng trong bóng đá: cầu thủ bị treo giò hai trận",
    example: "cầu thủ bị treo giò hai trận",
  },
  {
    word: "tréo khoeo",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả kiểu ngồi, nằm ở tư thế hai chân gấp lại, chân nọ vắt lên chân kia: nằm tréo khoeo",
    example: "nằm tréo khoeo",
  },
  {
    word: "tréo mảy",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) như tréo khoeo: ngồi tréo mảy",
    example: "ngồi tréo mảy",
  },
  {
    word: "treo mõm",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) nhịn đói, không có gì mà ăn: không chịu lao động thì chỉ có treo mõm",
    example: "không chịu lao động thì chỉ có treo mõm",
  },
  {
    word: "treo niêu",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) lâm vào cảnh phải nhịn đói, ăn đói: nếu mất mùa là treo niêu",
    example: "nếu mất mùa là treo niêu",
  },
  {
    word: "trèo trẹo",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng của hai vật cứng nghiến, xiết mạnh vào nhau: nghiến răng trèo trẹo",
    example: "nghiến răng trèo trẹo",
  },
  {
    word: "tréo ngoe",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ, hoặc kng) rất trái khoáy, oái oăm: tình thế tréo ngoe",
    example: "tình thế tréo ngoe",
  },
  {
    word: "trễ",
    part_of_speech: "động từ",
    meaning:
      "bị sa xuống, tụt xuống thấp hơn vị trí bình thường: mặc quần trễ rốn * cặp kính trắng trễ xuống sống mũi",
    example: "mặc quần trễ rốn * cặp kính trắng trễ xuống sống mũi",
  },
  {
    word: "trễ",
    part_of_speech: "tính từ",
    meaning: "(Nam) chậm, muộn: đến trễ nửa giờ * bận họp nên về trễ",
    example: "đến trễ nửa giờ * bận họp nên về trễ",
  },
  {
    word: "trẹt",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) nông lòng hoặc đáy: đĩa trẹt lòng * chậu trẹt",
    example: "đĩa trẹt lòng * chậu trẹt",
  },
  {
    word: "trét",
    part_of_speech: "động từ",
    meaning:
      "làm cho kín bằng cách nhét một chất dính vào chỗ hở và miết kĩ: trét thuyền * trét xi măng vào chỗ nứt",
    example: "trét thuyền * trét xi măng vào chỗ nứt",
  },
  {
    word: "trê",
    part_of_speech: "danh từ",
    meaning: "cá trê (nói tắt): con trắm, con trê",
    example: "con trắm, con trê",
  },
  {
    word: "trệ",
    part_of_speech: "động từ",
    meaning: "(hiếm) như xệ: béo quá, má trệ xuống",
    example: "béo quá, má trệ xuống",
  },
  {
    word: "trễ nải",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra thiếu hăng hái, thiếu cố gắng, ít để tâm tới, khiến công việc chậm trễ, ít kết quả: trễ nải việc học hành * trễ nải công việc",
    example: "trễ nải việc học hành * trễ nải công việc",
  },
  {
    word: "trề",
    part_of_speech: "động từ",
    meaning: "chìa môi dưới ra: trề môi chê đắt",
    example: "trề môi chê đắt",
  },
  {
    word: "trên",
    part_of_speech: "danh từ",
    meaning:
      "phía những vị trí cao hơn trong không gian so với một vị trí xác định nào đó, hay so với các vị trí khác nói chung: máy bay bay trên đầu * trên trời dưới đất * đứng trên cao nhìn xuống",
    example:
      "máy bay bay trên đầu * trên trời dưới đất * đứng trên cao nhìn xuống",
  },
  {
    word: "trên",
    part_of_speech: "danh từ",
    meaning:
      "vùng địa lí cao hơn so với một vùng xác định nào đó, hay so với các vùng khác nói chung: lên phía mạn trên * trên rừng dưới biển",
    example: "lên phía mạn trên * trên rừng dưới biển",
  },
  {
    word: "trên",
    part_of_speech: "danh từ",
    meaning:
      "phía những vị trí ở trước một vị trí xác định nào đó, hay so với các vị trí khác nói chung, trong một trật tự sắp xếp nhất định: ngồi ở hàng ghế trên * như đã nói ở trên * làng trên xóm dưới",
    example: "ngồi ở hàng ghế trên * như đã nói ở trên * làng trên xóm dưới",
  },
  {
    word: "trên",
    part_of_speech: "danh từ",
    meaning:
      "phía những vị trí cao hơn so với một vị trí xác định nào đó, hay so với các vị trí khác nói chung, trong một hệ thống cấp bậc, thứ bậc: học sinh các lớp trên * vâng lời người trên",
    example: "học sinh các lớp trên * vâng lời người trên",
  },
  {
    word: "trên",
    part_of_speech: "danh từ",
    meaning:
      "mức cao hơn hay số lượng nhiều hơn một mức, một số lượng xác định nào đó: học lực trên trung bình * sản lượng đạt trên mười tấn",
    example: "học lực trên trung bình * sản lượng đạt trên mười tấn",
  },
  {
    word: "trên",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là đích nhằm tới của một hoạt động theo hướng từ thấp đến cao: chạy lên trên đồi * mầm cây trồi lên trên mặt đất",
    example: "chạy lên trên đồi * mầm cây trồi lên trên mặt đất",
  },
  {
    word: "trên",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là vị trí của vật được nói đến ở sát bề mặt của một vật nào đó đỡ từ bên dưới, hay sát bề mặt ở phía có thể nhìn thấy rõ: sao trên trời * trên tường treo một bức tranh * vết sẹo trên trán",
    example:
      "sao trên trời * trên tường treo một bức tranh * vết sẹo trên trán",
  },
  {
    word: "trên",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là nơi diễn ra của hoạt động, sự việc được nói đến: gặp nhau trên đường đi công tác * nghe giảng trên lớp * phát biểu trên ti vi",
    example:
      "gặp nhau trên đường đi công tác * nghe giảng trên lớp * phát biểu trên ti vi",
  },
  {
    word: "trên",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là cơ sở quy định phạm vi, nội dung, tính chất của hoạt động, nhận thức, ý kiến được nói đến: làm việc trên cơ sở tự nguyện * bài thi đạt điểm 75 trên 100",
    example: "làm việc trên cơ sở tự nguyện * bài thi đạt điểm 75 trên 100",
  },
  {
    word: "trễ tràng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) trễ xuống một cách lỏng lẻo và tự nhiên: tóc búi trễ tràng",
    example: "tóc búi trễ tràng",
  },
  {
    word: "trễ tràng",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như trễ nải: trống canh trễ tràng",
    example: "trống canh trễ tràng",
  },
  {
    word: "trệch",
    part_of_speech: "tính từ",
    meaning: "trật ra ngoài, không khớp: xe lửa trệch bánh * viết trệch dòng",
    example: "xe lửa trệch bánh * viết trệch dòng",
  },
  {
    word: "trễ phép",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) trả phép muộn, đi nghỉ phép về quá thời gian quy định: trễ phép vì bị nhỡ tàu",
    example: "trễ phép vì bị nhỡ tàu",
  },
  {
    word: "trên cơ",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) hơn hẳn về khả năng, trình độ hoặc cơ hội (trong một lĩnh vực nào đó): một đối thủ trên cơ * đội bóng trên cơ",
    example: "một đối thủ trên cơ * đội bóng trên cơ",
  },
  {
    word: "trên hết",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) trên tất cả, hơn hết cả: vui là trên hết * với chị, gia đình là trên hết!",
    example: "vui là trên hết * với chị, gia đình là trên hết!",
  },
  {
    word: "trên dưới",
    part_of_speech: "danh từ",
    meaning:
      "cả người trên lẫn người dưới, không trừ một ai: trên dưới đồng lòng đánh giặc * ăn ở phải biết trên dưới",
    example: "trên dưới đồng lòng đánh giặc * ăn ở phải biết trên dưới",
  },
  {
    word: "trên dưới",
    part_of_speech: "danh từ",
    meaning:
      "số lượng trên chút ít hoặc dưới chút ít: cuộc họp có trên dưới 20 người * sản lượng đạt trên dưới mười tấn",
    example:
      "cuộc họp có trên dưới 20 người * sản lượng đạt trên dưới mười tấn",
  },
  {
    word: "trển",
    part_of_speech: "đại từ",
    meaning: "(phương ngữ, khẩu ngữ) trên ấy: đi lên trển",
    example: "đi lên trển",
  },
  {
    word: "trên tài",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) hơn hẳn về khả năng, trình độ (trong một lĩnh vực nào đó): hát trên tài cả ca sĩ chuyên nghiệp",
    example: "hát trên tài cả ca sĩ chuyên nghiệp",
  },
  {
    word: "trết",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) dính bết chặt vào: bùn trết đầy quần áo",
    example: "bùn trết đầy quần áo",
  },
  {
    word: "trệt",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) ở dưới cùng, sát đất: tầng trệt * lên lầu xuống trệt",
    example: "tầng trệt * lên lầu xuống trệt",
  },
  {
    word: "trệt",
    part_of_speech: "tính từ",
    meaning: "chỉ có một tầng, không có gác: dãy nhà trệt",
    example: "dãy nhà trệt",
  },
  {
    word: "trệt",
    part_of_speech: "phụ từ",
    meaning: "(phương ngữ) bệt: ngồi trệt xuống sàn",
    example: "ngồi trệt xuống sàn",
  },
  {
    word: "trêu",
    part_of_speech: "động từ",
    meaning:
      'dùng lời nói, cử chỉ làm cho bực tức, xấu hổ, nhằm đùa vui: trêu em * "Sột soạt gió trêu tà áo biếc, Trên giàn thiên lý, bóng xuân sang." (HMTử; 5)',
    example:
      'trêu em * "Sột soạt gió trêu tà áo biếc, Trên giàn thiên lý, bóng xuân sang." (HMTử; 5)',
  },
  {
    word: "trêu chọc",
    part_of_speech: "động từ",
    meaning: "trêu (nói khái quát): bọn trẻ trêu chọc nhau",
    example: "bọn trẻ trêu chọc nhau",
  },
  {
    word: "trêu ngươi",
    part_of_speech: "động từ",
    meaning:
      'cố ý trêu cho tức lên bằng cách bày ra trước mắt những điều gai mắt, ngang ngược: giở trò trêu ngươi * "Trách bà mụ khéo trêu ngươi, Nặn người thế ấy, nặn tôi thế này." (ca dao)',
    example:
      'giở trò trêu ngươi * "Trách bà mụ khéo trêu ngươi, Nặn người thế ấy, nặn tôi thế này." (ca dao)',
  },
  {
    word: "trệu",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như trẹo: ngã trệu chân",
    example: "ngã trệu chân",
  },
  {
    word: "trếu tráo",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như trệu trạo: nhai trếu tráo",
    example: "nhai trếu tráo",
  },
  {
    word: "trêu tức",
    part_of_speech: "động từ",
    meaning: "cố ý khiêu khích làm cho tức lên: cố ý trêu tức nhau",
    example: "cố ý trêu tức nhau",
  },
  {
    word: "trêu ghẹo",
    part_of_speech: "động từ",
    meaning:
      "trêu để đùa vui hoặc để tán tỉnh (nói khái quát): buông lời trêu ghẹo * trêu ghẹo phụ nữ",
    example: "buông lời trêu ghẹo * trêu ghẹo phụ nữ",
  },
  {
    word: "trĩ",
    part_of_speech: "danh từ",
    meaning:
      "chim cùng họ với gà, sống ở rừng, con trống có bộ lông đẹp, đuôi dài: chim trĩ",
    example: "chim trĩ",
  },
  {
    word: "trĩ",
    part_of_speech: "danh từ",
    meaning:
      "bệnh dãn tĩnh mạch hậu môn, thường sinh ra chứng đi ngoài ra máu: mắc bệnh trĩ * cắt trĩ",
    example: "mắc bệnh trĩ * cắt trĩ",
  },
  {
    word: "trệu trạo",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả lối nhai qua loa hoặc nhai có vẻ khó nhọc, như của người móm hoặc đau răng: nhai trệu trạo",
    example: "nhai trệu trạo",
  },
  {
    word: "trí",
    part_of_speech: "danh từ",
    meaning:
      "khả năng nhận thức, ghi nhớ, suy nghĩ, phán đoán, v.v. của con người (nói khái quát): trí thông minh * giàu trí tưởng tượng * kích thích trí tò mò của trẻ",
    example:
      "trí thông minh * giàu trí tưởng tượng * kích thích trí tò mò của trẻ",
  },
  {
    word: "trị",
    part_of_speech: "động từ",
    meaning:
      "chữa, làm cho lành bệnh hoặc khỏi một chứng nào đó trên cơ thể: trị bệnh * dầu trị gàu * thuốc trị trứng cá",
    example: "trị bệnh * dầu trị gàu * thuốc trị trứng cá",
  },
  {
    word: "trị",
    part_of_speech: "động từ",
    meaning:
      "làm cho mất khả năng gây hại bằng cách diệt trừ hoặc cải tạo: thuốc trị muỗi * trị sâu cắn lúa * công tác trị thuỷ",
    example: "thuốc trị muỗi * trị sâu cắn lúa * công tác trị thuỷ",
  },
  {
    word: "trị",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) trừng phạt, đưa vào khuôn khổ: trị bọn lưu manh * trị thói xấu * trị cho nó một mẻ",
    example: "trị bọn lưu manh * trị thói xấu * trị cho nó một mẻ",
  },
  {
    word: "trị",
    part_of_speech: "động từ",
    meaning:
      "cai trị (nói tắt): trị nước * tầng lớp bị trị * chính sách chia để trị",
    example: "trị nước * tầng lớp bị trị * chính sách chia để trị",
  },
  {
    word: "trị an",
    part_of_speech: "",
    meaning:
      "giữ gìn an ninh và trật tự xã hội: công tác trị an * bảo vệ trị an * giữ gìn trật tự trị an",
    example: "công tác trị an * bảo vệ trị an * giữ gìn trật tự trị an",
  },
  {
    word: "trí giả",
    part_of_speech: "danh từ",
    meaning:
      "(trang trọng) người có trình độ học vấn uyên thâm, hiểu biết sâu rộng: bậc trí giả * nhà trí giả",
    example: "bậc trí giả * nhà trí giả",
  },
  {
    word: "trì",
    part_of_speech: "động từ",
    meaning: "(Phương ngữ) níu giữ: trì lại không cho đi",
    example: "trì lại không cho đi",
  },
  {
    word: "tri ân",
    part_of_speech: "động từ",
    meaning: "(cũ) biết ơn: tỏ lòng tri ân",
    example: "tỏ lòng tri ân",
  },
  {
    word: "tri âm",
    part_of_speech: "danh từ",
    meaning:
      'người hiểu tiếng đàn của người khác; chỉ người bạn thấu hiểu được lòng mình: bạn tri âm * "Thưa rằng: Nay gặp tri âm, Xin đưa một vật để cầm làm tin." (LVT)',
    example:
      'bạn tri âm * "Thưa rằng: Nay gặp tri âm, Xin đưa một vật để cầm làm tin." (LVT)',
  },
  {
    word: "trị giá",
    part_of_speech: "động từ",
    meaning:
      "được định giá thành tiền hoặc vật ngang giá có tính chất như tiền tệ: chiếc xe trị giá 20 triệu đồng",
    example: "chiếc xe trị giá 20 triệu đồng",
  },
  {
    word: "trí khôn",
    part_of_speech: "danh từ",
    meaning:
      "khả năng suy nghĩ và hiểu biết: mất trí khôn * không đủ trí khôn để ứng phó",
    example: "mất trí khôn * không đủ trí khôn để ứng phó",
  },
  {
    word: "tri kỉ",
    part_of_speech: "danh từ",
    meaning: "bạn tâm tình: đôi tri kỉ * bạn tri kỉ",
    example: "đôi tri kỉ * bạn tri kỉ",
  },
  {
    word: "tri kỉ",
    part_of_speech: "danh từ",
    meaning: "điều đoán phỏng chừng: một ức đoán vu vơ",
    example: "một ức đoán vu vơ",
  },
  {
    word: "tri kỷ",
    part_of_speech: "danh từ",
    meaning: "bạn tâm tình: đôi tri kỉ * bạn tri kỉ",
    example: "đôi tri kỉ * bạn tri kỉ",
  },
  {
    word: "tri kỷ",
    part_of_speech: "danh từ",
    meaning: "điều đoán phỏng chừng: một ức đoán vu vơ",
    example: "một ức đoán vu vơ",
  },
  {
    word: "trị liệu",
    part_of_speech: "động từ",
    meaning:
      "chữa bệnh: phương pháp trị liệu * kết quả trị liệu * vật lí trị liệu",
    example: "phương pháp trị liệu * kết quả trị liệu * vật lí trị liệu",
  },
  {
    word: "trí mạng",
    part_of_speech: "tính từ",
    meaning: "có thể nguy hiểm đến tính mạng: giáng một đòn trí mạng",
    example: "giáng một đòn trí mạng",
  },
  {
    word: "trì kéo",
    part_of_speech: "động từ",
    meaning:
      "cố kéo lại, kìm giữ khiến cho không thể tiếp tục vận động hoặc phát triển được: một số doanh nghiệp trì kéo nhau",
    example: "một số doanh nghiệp trì kéo nhau",
  },
  {
    word: "tri hô",
    part_of_speech: "động từ",
    meaning: "(cũ) hô hoán: tri hô làng nước",
    example: "tri hô làng nước",
  },
  {
    word: "trí lực",
    part_of_speech: "danh từ",
    meaning:
      "năng lực trí tuệ: rèn luyện cả thể lực và trí lực * phát triển trí lực của trẻ",
    example: "rèn luyện cả thể lực và trí lực * phát triển trí lực của trẻ",
  },
  {
    word: "trì hoãn",
    part_of_speech: "động từ",
    meaning:
      "để chậm lại, làm kéo dài thời gian: trì hoãn món nợ * việc gấp, không thể trì hoãn",
    example: "trì hoãn món nợ * việc gấp, không thể trì hoãn",
  },
  {
    word: "trí não",
    part_of_speech: "danh từ",
    meaning: "như trí óc: thói quen đã ăn sâu vào trí não",
    example: "thói quen đã ăn sâu vào trí não",
  },
  {
    word: "tri năng",
    part_of_speech: "danh từ",
    meaning: "(cũ, hiếm) năng lực hiểu biết: con người có tri năng",
    example: "con người có tri năng",
  },
  {
    word: "trí nhớ",
    part_of_speech: "danh từ",
    meaning:
      "khả năng giữ lại và tái hiện ra trong trí những điều đã biết, đã trải qua: lục tìm trong trí nhớ * có trí nhớ tốt",
    example: "lục tìm trong trí nhớ * có trí nhớ tốt",
  },
  {
    word: "trí sĩ",
    part_of_speech: "động từ",
    meaning:
      "(cũ) thôi làm quan, về nghỉ: Nguyễn Bỉnh Khiêm về trí sĩ ở Bạch Vân am",
    example: "Nguyễn Bỉnh Khiêm về trí sĩ ở Bạch Vân am",
  },
  {
    word: "trí năng",
    part_of_speech: "danh từ",
    meaning: "năng lực hiểu biết và suy nghĩ: phát triển trí năng của trẻ",
    example: "phát triển trí năng của trẻ",
  },
  {
    word: "tri phủ",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) chức quan đứng đầu bộ máy cai trị một phủ dưới thời phong kiến, thực dân: quan tri phủ",
    example: "quan tri phủ",
  },
  {
    word: "tri ngộ",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) biết giá trị của người nào đó mà người đời ít biết đến, và coi trọng, giúp đỡ, đối đãi xứng đáng: tấm lòng tri ngộ * ơn tri ngộ",
    example: "tấm lòng tri ngộ * ơn tri ngộ",
  },
  {
    word: "trí óc",
    part_of_speech: "danh từ",
    meaning:
      "óc của con người, coi là biểu trưng của khả năng nhận thức, tư duy: lao động trí óc * mở mang trí óc * trí óc còn non nớt",
    example: "lao động trí óc * mở mang trí óc * trí óc còn non nớt",
  },
  {
    word: "trị thuỷ",
    part_of_speech: "động từ",
    meaning:
      "cải tạo sông ngòi, điều tiết dòng chảy để ngăn ngừa lũ lụt, đồng thời sử dụng được sức nước: công tác trị thuỷ",
    example: "công tác trị thuỷ",
  },
  {
    word: "trì trệ",
    part_of_speech: "tính từ",
    meaning:
      "lâm vào tình trạng phát triển chậm chạp đến mức như ngừng lại, không tiến lên được: công việc trì trệ * nền kinh tế trì trệ",
    example: "công việc trì trệ * nền kinh tế trì trệ",
  },
  {
    word: "trị tội",
    part_of_speech: "động từ",
    meaning: "trừng trị kẻ có tội: trị tội kẻ sát nhân",
    example: "trị tội kẻ sát nhân",
  },
  {
    word: "tri thức",
    part_of_speech: "danh từ",
    meaning:
      "những điều hiểu biết có hệ thống về sự vật, hiện tượng tự nhiên hoặc xã hội (nói khái quát): tri thức khoa học * kinh tế tri thức",
    example: "tri thức khoa học * kinh tế tri thức",
  },
  {
    word: "trị sự",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận chịu trách nhiệm việc quản lí của một tờ báo, tạp chí hoặc một tổ chức nào đó: ban trị sự của toà báo",
    example: "ban trị sự của toà báo",
  },
  {
    word: "trí trá",
    part_of_speech: "tính từ",
    meaning: "gian dối, có ý lừa lọc: thái độ trí trá * làm ăn trí trá",
    example: "thái độ trí trá * làm ăn trí trá",
  },
  {
    word: "trí thức",
    part_of_speech: "danh từ",
    meaning:
      "người chuyên làm việc lao động trí óc và có tri thức chuyên môn cần thiết cho hoạt động nghề nghiệp của mình: giới trí thức * một nhà trí thức yêu nước",
    example: "giới trí thức * một nhà trí thức yêu nước",
  },
  {
    word: "trí tuệ",
    part_of_speech: "danh từ",
    meaning:
      "khả năng nhận thức lí tính đạt đến một trình độ nhất định: trí tuệ minh mẫn * sản phẩm trí tuệ * quyền sở hữu trí tuệ",
    example: "trí tuệ minh mẫn * sản phẩm trí tuệ * quyền sở hữu trí tuệ",
  },
  {
    word: "trí tưởng",
    part_of_speech: "danh từ",
    meaning: "như trí nhớ: ghi sâu trong trí tưởng",
    example: "ghi sâu trong trí tưởng",
  },
  {
    word: "trích đoạn",
    part_of_speech: "danh từ",
    meaning:
      "đoạn trích ra từ một tác phẩm văn học, một vở kịch, v.v.: trích đoạn vở kịch * đọc hai trích đoạn tiểu thuyết",
    example: "trích đoạn vở kịch * đọc hai trích đoạn tiểu thuyết",
  },
  {
    word: "trị vì",
    part_of_speech: "động từ",
    meaning: "ở ngôi vua cai trị đất nước: trị vì thiên hạ",
    example: "trị vì thiên hạ",
  },
  {
    word: "trỉa",
    part_of_speech: "động từ",
    meaning:
      "gieo trồng bằng cách tra hạt giống vào từng hốc và lấp đất lên: trỉa đỗ",
    example: "trỉa đỗ",
  },
  {
    word: "trích ngang",
    part_of_speech: "động từ",
    meaning:
      "chọn ghi một số điểm quan trọng (trong lí lịch) để giúp hiểu biết cơ bản về một người: lí lịch trích ngang",
    example: "lí lịch trích ngang",
  },
  {
    word: "trích dẫn",
    part_of_speech: "động từ",
    meaning:
      "dẫn nguyên văn một câu hay một đoạn văn nào đó: trích dẫn tác phẩm * bài viết có trích dẫn mấy câu Kiều",
    example: "trích dẫn tác phẩm * bài viết có trích dẫn mấy câu Kiều",
  },
  {
    word: "trích lục",
    part_of_speech: "động từ",
    meaning:
      "(cũ) rút ra từng phần và sao lại: trích lục bản đồ * bản trích lục nội dung đăng kí kinh doanh",
    example: "trích lục bản đồ * bản trích lục nội dung đăng kí kinh doanh",
  },
  {
    word: "trích",
    part_of_speech: "động từ",
    meaning:
      "lấy ra, rút ra một phần của toàn bộ: khoản tiền thưởng được trích từ ngân sách * trích nguyên văn bài thơ",
    example:
      "khoản tiền thưởng được trích từ ngân sách * trích nguyên văn bài thơ",
  },
  {
    word: "trích lập",
    part_of_speech: "động từ",
    meaning:
      "trích ra một khoản riêng để lập thành một quỹ khác: trích lập quỹ khen thưởng",
    example: "trích lập quỹ khen thưởng",
  },
  {
    word: "trịch thượng",
    part_of_speech: "tính từ",
    meaning:
      "ra vẻ như kẻ bề trên, tự cho mình là hơn và tỏ ra khinh thường người khác trong đối xử: giọng trịch thượng * thái độ kiêu căng, trịch thượng",
    example: "giọng trịch thượng * thái độ kiêu căng, trịch thượng",
  },
  {
    word: "triển lãm",
    part_of_speech: "",
    meaning:
      "trưng bày vật phẩm, tranh ảnh để mọi người đến xem: triển lãm tranh * triển lãm thư tịch cổ",
    example: "triển lãm tranh * triển lãm thư tịch cổ",
  },
  {
    word: "triện",
    part_of_speech: "danh từ",
    meaning:
      "lối viết chữ Hán thời cổ khuôn thành hình vuông thích hợp với việc khắc vào con dấu hay trang trí: chữ triện",
    example: "chữ triện",
  },
  {
    word: "triện",
    part_of_speech: "danh từ",
    meaning: "(cũ) con dấu (thường khắc chữ triện): triện đồng * khắc triện",
    example: "triện đồng * khắc triện",
  },
  {
    word: "triển khai",
    part_of_speech: "động từ",
    meaning:
      "mở rộng ra trên một phạm vi, quy mô lớn: triển khai dự án * triển khai đội hình chiến đấu",
    example: "triển khai dự án * triển khai đội hình chiến đấu",
  },
  {
    word: "triển",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) lên (gân): triển gân lên",
    example: "triển gân lên",
  },
  {
    word: "triền",
    part_of_speech: "danh từ",
    meaning:
      "dải đất thoai thoải ở hai bên bờ sông hoặc hai bên sườn núi: đi dọc theo triền đê * triền đồi thoai thoải",
    example: "đi dọc theo triền đê * triền đồi thoai thoải",
  },
  {
    word: "triêng",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) quang, gióng: đôi triêng",
    example: "đôi triêng",
  },
  {
    word: "triêng",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) vành: triêng mũ",
    example: "triêng mũ",
  },
  {
    word: "triển vọng",
    part_of_speech: "danh từ",
    meaning:
      "khả năng phát triển trong tương lai (thường là tốt đẹp): triển vọng của nền kinh tế * một thị trường đầy triển vọng",
    example: "triển vọng của nền kinh tế * một thị trường đầy triển vọng",
  },
  {
    word: "triền miên",
    part_of_speech: "tính từ",
    meaning:
      "liên tiếp một cách dai dẳng, kéo dài, khó chấm dứt: mưa triền miên * suy nghĩ triền miên",
    example: "mưa triền miên * suy nghĩ triền miên",
  },
  {
    word: "triết gia",
    part_of_speech: "danh từ",
    meaning: "(trang trọng) nhà triết học: các triết gia Hi Lạp cổ đại",
    example: "các triết gia Hi Lạp cổ đại",
  },
  {
    word: "triệt để",
    part_of_speech: "tính từ",
    meaning:
      "ở mức độ cao nhất không còn có thể hơn về tất cả các mặt: khai thác triệt để mọi nguồn lực sẵn có * xoá bỏ triệt để những hủ tục",
    example:
      "khai thác triệt để mọi nguồn lực sẵn có * xoá bỏ triệt để những hủ tục",
  },
  {
    word: "triệt",
    part_of_speech: "động từ",
    meaning:
      "trừ bỏ hoàn toàn, không để cho tiếp tục tồn tại: phải triệt tận gốc mầm loạn * triệt đường sinh sống",
    example: "phải triệt tận gốc mầm loạn * triệt đường sinh sống",
  },
  {
    word: "triết học",
    part_of_speech: "danh từ",
    meaning:
      "khoa học nghiên cứu về những quy luật chung nhất của thế giới và sự nhận thức thế giới: môn triết học * nghiên cứu triết học",
    example: "môn triết học * nghiên cứu triết học",
  },
  {
    word: "triết",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) triết học (nói tắt): môn triết * giờ triết",
    example: "môn triết * giờ triết",
  },
  {
    word: "triệt hạ",
    part_of_speech: "động từ",
    meaning:
      "phá huỷ hoàn toàn trên cả một vùng: toàn bộ khu rừng đã bị triệt hạ",
    example: "toàn bộ khu rừng đã bị triệt hạ",
  },
  {
    word: "triết lí",
    part_of_speech: "danh từ",
    meaning: "lí luận triết học: triết lí phương Đông * triết lí của Phật giáo",
    example: "triết lí phương Đông * triết lí của Phật giáo",
  },
  {
    word: "triết lí",
    part_of_speech: "danh từ",
    meaning:
      "quan niệm chung của con người về những vấn đề nhân sinh và xã hội: triết lí sống",
    example: "triết lí sống",
  },
  {
    word: "triết lí",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) thuyết lí về những vấn đề nhân sinh và xã hội (hàm ý chê): tính thích triết lí * hay triết lí cao xa",
    example: "tính thích triết lí * hay triết lí cao xa",
  },
  {
    word: "triệt phá",
    part_of_speech: "động từ",
    meaning:
      "phá huỷ hoàn toàn: lâm tặc triệt phá rừng * triệt phá một đường dây buôn lậu lớn",
    example: "lâm tặc triệt phá rừng * triệt phá một đường dây buôn lậu lớn",
  },
  {
    word: "triết lý",
    part_of_speech: "danh từ",
    meaning: "lí luận triết học: triết lí phương Đông * triết lí của Phật giáo",
    example: "triết lí phương Đông * triết lí của Phật giáo",
  },
  {
    word: "triết lý",
    part_of_speech: "danh từ",
    meaning:
      "quan niệm chung của con người về những vấn đề nhân sinh và xã hội: triết lí sống",
    example: "triết lí sống",
  },
  {
    word: "triết lý",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) thuyết lí về những vấn đề nhân sinh và xã hội (hàm ý chê): tính thích triết lí * hay triết lí cao xa",
    example: "tính thích triết lí * hay triết lí cao xa",
  },
  {
    word: "triệt tiêu",
    part_of_speech: "động từ",
    meaning:
      "làm cho trở thành số không, hoàn toàn không còn nữa: hai số đối xứng triệt tiêu nhau * dao động bị triệt tiêu",
    example: "hai số đối xứng triệt tiêu nhau * dao động bị triệt tiêu",
  },
  {
    word: "triều cống",
    part_of_speech: "động từ",
    meaning:
      "(cũ) (vua nước chư hầu) đem dâng nộp cống phẩm cho vua của nước mà mình chịu thần phục: đem phẩm vật đến triều cống",
    example: "đem phẩm vật đến triều cống",
  },
  {
    word: "triều",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) thuỷ triều (nói tắt): lúc triều xuống",
    example: "lúc triều xuống",
  },
  {
    word: "triều",
    part_of_speech: "danh từ",
    meaning: "triều đình (nói tắt): vào triều yết vua * các quan trong triều",
    example: "vào triều yết vua * các quan trong triều",
  },
  {
    word: "triều",
    part_of_speech: "danh từ",
    meaning: "triều đại (nói tắt): triều Lê * triều nhà Nguyễn",
    example: "triều Lê * triều nhà Nguyễn",
  },
  {
    word: "triều đại",
    part_of_speech: "danh từ",
    meaning:
      "thời gian trị vì của một ông vua hay của một dòng họ vua: triều đại Lê Thánh Tông * các triều đại phong kiến Trung Quốc",
    example: "triều đại Lê Thánh Tông * các triều đại phong kiến Trung Quốc",
  },
  {
    word: "triều chính",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) công việc cai trị của triều đình: tham dự triều chính * việc triều chính",
    example: "tham dự triều chính * việc triều chính",
  },
  {
    word: "triều cường",
    part_of_speech: "danh từ",
    meaning:
      "hiện tượng thuỷ triều dâng lên cao nhất, xảy ra vào thời kì trăng non hoặc trăng tròn: nước triều cường",
    example: "nước triều cường",
  },
  {
    word: "triệu",
    part_of_speech: "danh từ",
    meaning: "số đếm, bằng một trăm vạn: hai triệu đồng * triệu người như một",
    example: "hai triệu đồng * triệu người như một",
  },
  {
    word: "triệu",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) ra lệnh gọi: triệu danh y vào cung chữa bệnh * triệu đại sứ về nước",
    example: "triệu danh y vào cung chữa bệnh * triệu đại sứ về nước",
  },
  {
    word: "triệu chứng",
    part_of_speech: "danh từ",
    meaning:
      "dấu hiệu báo trước điều gì đó sắp xảy ra: mây đen là triệu chứng trời sắp mưa * cái máy có triệu chứng sắp hỏng",
    example:
      "mây đen là triệu chứng trời sắp mưa * cái máy có triệu chứng sắp hỏng",
  },
  {
    word: "triệu chứng",
    part_of_speech: "danh từ",
    meaning:
      "biểu hiện của bệnh: có triệu chứng về gan * các triệu chứng của bệnh sốt rét",
    example: "có triệu chứng về gan * các triệu chứng của bệnh sốt rét",
  },
  {
    word: "triều kiến",
    part_of_speech: "động từ",
    meaning: "(cũ) vào chầu ra mắt nhà vua: vào triều kiến và tạ ơn vua",
    example: "vào triều kiến và tạ ơn vua",
  },
  {
    word: "triều đình",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) nơi các quan vào chầu vua và bàn việc nước; thường dùng để chỉ cơ quan trung ương, do vua trực tiếp đứng đầu, của nhà nước quân chủ: triều đình nhà Nguyễn * làm quan trong triều đình",
    example: "triều đình nhà Nguyễn * làm quan trong triều đình",
  },
  {
    word: "triều phục",
    part_of_speech: "danh từ",
    meaning: "(cũ) lễ phục các quan mặc khi vào chầu vua: mặc triều phục",
    example: "mặc triều phục",
  },
  {
    word: "triệu hồi",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) ra lệnh gọi về (thường nói về đại diện ngoại giao): triệu hồi đại sứ",
    example: "triệu hồi đại sứ",
  },
  {
    word: "trình báo",
    part_of_speech: "động từ",
    meaning:
      "báo cho cơ quan chính quyền hoặc người có trách nhiệm biết việc xảy ra có liên quan đến trật tự, trị an: trình báo công an vụ mất trộm * trình báo với cấp trên",
    example: "trình báo công an vụ mất trộm * trình báo với cấp trên",
  },
  {
    word: "triều thần",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) các quan lại trong triều đình (nói tổng quát): triệu tập triều thần",
    example: "triệu tập triều thần",
  },
  {
    word: "trình",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) (cũ) báo cáo cho người cấp trên biết để xem xét: đi trình quan",
    example: "đi trình quan",
  },
  {
    word: "trình",
    part_of_speech: "động từ",
    meaning:
      "đưa lên cho cấp trên hoặc cấp có thẩm quyền thấy, biết để xem xét, thông qua, giải quyết, v.v.: trình đơn lên toà án * trình dự án lên quốc hội",
    example: "trình đơn lên toà án * trình dự án lên quốc hội",
  },
  {
    word: "trình",
    part_of_speech: "động từ",
    meaning:
      "(cũ) từ dùng để mở đầu lời nói với người trên, tỏ ý tôn kính, lễ phép: trình cụ, mọi việc đã xong cả rồi ạ",
    example: "trình cụ, mọi việc đã xong cả rồi ạ",
  },
  {
    word: "triệu phú",
    part_of_speech: "danh từ",
    meaning: "người rất giàu, có bạc triệu: nhà triệu phú",
    example: "nhà triệu phú",
  },
  {
    word: "trinh bạch",
    part_of_speech: "tính từ",
    meaning:
      'trong trắng, không một chút nhơ bẩn, xấu xa: cuộc đời trinh bạch * "Thân lươn bao quản lấm đầu, Chút lòng trinh bạch từ sau cũng chừa." (TKiều)',
    example:
      'cuộc đời trinh bạch * "Thân lươn bao quản lấm đầu, Chút lòng trinh bạch từ sau cũng chừa." (TKiều)',
  },
  {
    word: "triệu tập",
    part_of_speech: "động từ",
    meaning:
      "gọi, mời mọi người đến tập trung tại một địa điểm (thường là để tiến hành hội nghị hoặc mở lớp học): triệu tập cuộc họp * triệu tập các cổ đông * giấy triệu tập",
    example: "triệu tập cuộc họp * triệu tập các cổ đông * giấy triệu tập",
  },
  {
    word: "trình bày",
    part_of_speech: "động từ",
    meaning:
      "nói ra một cách rõ ràng và đầy đủ cho người khác (thường là cấp trên hoặc số đông) hiểu rõ: trình bày đầu đuôi câu chuyện * trình bày hoàn cảnh",
    example: "trình bày đầu đuôi câu chuyện * trình bày hoàn cảnh",
  },
  {
    word: "trình bày",
    part_of_speech: "động từ",
    meaning:
      "biểu diễn một tác phẩm nghệ thuật trước mọi người: bài hát do một ca sĩ trẻ trình bày",
    example: "bài hát do một ca sĩ trẻ trình bày",
  },
  {
    word: "trình bày",
    part_of_speech: "động từ",
    meaning:
      "xếp đặt, bố trí cho đẹp và nổi bật: tờ báo được trình bày rất bắt mắt * hoạ sĩ trình bày bìa",
    example: "tờ báo được trình bày rất bắt mắt * hoạ sĩ trình bày bìa",
  },
  {
    word: "trinh",
    part_of_speech: "danh từ",
    meaning:
      "(Từ cũ) đồng tiền có giá trị bằng nửa xu, dùng thời trước: hết sạch chẳng còn một trinh",
    example: "hết sạch chẳng còn một trinh",
  },
  {
    word: "trinh",
    part_of_speech: "danh từ",
    meaning:
      "màng trinh (nói tắt): phá trinh * mất trinh  * người con gái còn trinh",
    example: "phá trinh * mất trinh  * người con gái còn trinh",
  },
  {
    word: "trinh",
    part_of_speech: "tính từ",
    meaning:
      "(người con gái) còn tân, chưa giao hợp lần nào: gái trinh * trinh nữ",
    example: "gái trinh * trinh nữ",
  },
  {
    word: "trinh",
    part_of_speech: "tính từ",
    meaning:
      'trinh tiết của người phụ nữ: "Đã cho vào bậc bố kinh, Đạo tòng phu lấy chữ Trinh làm đầu." (TKiều)',
    example:
      'Đã cho vào bậc bố kinh, Đạo tòng phu lấy chữ Trinh làm đầu." (TKiều)',
  },
  {
    word: "trình diễn",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) đưa ra diễn trước công chúng: trình diễn thời trang * màn trình diễn xiếc",
    example: "trình diễn thời trang * màn trình diễn xiếc",
  },
  {
    word: "trình chiếu",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) đưa ra chiếu trước công chúng: bộ phim sắp được trình chiếu",
    example: "bộ phim sắp được trình chiếu",
  },
  {
    word: "trình duyệt",
    part_of_speech: "danh từ",
    meaning:
      "chương trình máy tính cho phép xem được các thông tin, hình ảnh, v.v. trình bày trên trang web: trình duyệt web",
    example: "trình duyệt web",
  },
  {
    word: "trình duyệt",
    part_of_speech: "động từ",
    meaning:
      "trình lên cho cấp có thẩm quyền xem xét để phê duyệt: trình duyệt dự án đầu tư",
    example: "trình duyệt dự án đầu tư",
  },
  {
    word: "trình bầy",
    part_of_speech: "động từ",
    meaning:
      "nói ra một cách rõ ràng và đầy đủ cho người khác (thường là cấp trên hoặc số đông) hiểu rõ: trình bày đầu đuôi câu chuyện * trình bày hoàn cảnh",
    example: "trình bày đầu đuôi câu chuyện * trình bày hoàn cảnh",
  },
  {
    word: "trình bầy",
    part_of_speech: "động từ",
    meaning:
      "biểu diễn một tác phẩm nghệ thuật trước mọi người: bài hát do một ca sĩ trẻ trình bày",
    example: "bài hát do một ca sĩ trẻ trình bày",
  },
  {
    word: "trình bầy",
    part_of_speech: "động từ",
    meaning:
      "xếp đặt, bố trí cho đẹp và nổi bật: tờ báo được trình bày rất bắt mắt * hoạ sĩ trình bày bìa",
    example: "tờ báo được trình bày rất bắt mắt * hoạ sĩ trình bày bìa",
  },
  {
    word: "trình diện",
    part_of_speech: "động từ",
    meaning:
      "đến để cho cơ quan hoặc người có trách nhiệm biết là mình có mặt: trình diện quan * trình diện chính quyền",
    example: "trình diện quan * trình diện chính quyền",
  },
  {
    word: "trình diện",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) ra mắt mọi người: đưa bạn gái về trình diện gia đình",
    example: "đưa bạn gái về trình diện gia đình",
  },
  {
    word: "trình độ",
    part_of_speech: "danh từ",
    meaning:
      "mức độ về sự hiểu biết, về kĩ năng được xác định hoặc đánh giá theo tiêu chuẩn nhất định nào đó: trình độ nhận thức * trình độ văn hoá * trình độ tay nghề còn non",
    example:
      "trình độ nhận thức * trình độ văn hoá * trình độ tay nghề còn non",
  },
  {
    word: "trình độ",
    part_of_speech: "danh từ",
    meaning:
      "hoặc t (khẩu ngữ) nhận thức hoặc kĩ năng được coi là khá cao trong một lĩnh vực nào đó: người có trình độ",
    example: "người có trình độ",
  },
  {
    word: "trình làng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đưa ra giới thiệu chính thức trước công chúng: bài hát sắp được trình làng * công ti vừa trình làng loại sản phẩm mới",
    example:
      "bài hát sắp được trình làng * công ti vừa trình làng loại sản phẩm mới",
  },
  {
    word: "trinh nữ",
    part_of_speech: "danh từ",
    meaning: "(cây) xấu hổ: hoa trinh nữ",
    example: "hoa trinh nữ",
  },
  {
    word: "trinh nguyên",
    part_of_speech: "tính từ",
    meaning:
      "còn nguyên vẹn sự trong trắng, tinh khiết: tấm lòng trinh nguyên * màu trắng trinh nguyên",
    example: "tấm lòng trinh nguyên * màu trắng trinh nguyên",
  },
  {
    word: "trinh sát",
    part_of_speech: "động từ",
    meaning:
      "dò xét, thu thập tình hình để phục vụ tác chiến: đi trinh sát trận địa * máy bay trinh sát",
    example: "đi trinh sát trận địa * máy bay trinh sát",
  },
  {
    word: "trinh sát",
    part_of_speech: "danh từ",
    meaning: "người làm nhiệm vụ trinh sát: cử trinh sát theo dõi đối tượng",
    example: "cử trinh sát theo dõi đối tượng",
  },
  {
    word: "trình tấu",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) trình diễn một bản nhạc trước công chúng: trình tấu bản giao hưởng",
    example: "trình tấu bản giao hưởng",
  },
  {
    word: "trình thức",
    part_of_speech: "danh từ",
    meaning:
      "mẫu chung nhất của một loại người, một loại động tác, v.v., trong nghệ thuật sân khấu, có phạm vi co dãn rộng rãi để diễn viên có thể sáng tạo thêm: những trình thức cổ điển của sân khấu tuồng",
    example: "những trình thức cổ điển của sân khấu tuồng",
  },
  {
    word: "trinh thám",
    part_of_speech: "động từ",
    meaning: "(cũ) dò xét, thám thính: máy bay trinh thám",
    example: "máy bay trinh thám",
  },
  {
    word: "trinh thám",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) mật thám hoặc thám tử: nhà trinh thám * cử trinh thám đi dò xét tình hình",
    example: "nhà trinh thám * cử trinh thám đi dò xét tình hình",
  },
  {
    word: "trinh thám",
    part_of_speech: "tính từ",
    meaning:
      "có nội dung kể những vụ án li kì và hoạt động của các thám tử điều tra tìm ra thủ phạm: truyện trinh thám * phim trinh thám",
    example: "truyện trinh thám * phim trinh thám",
  },
  {
    word: "trinh trắng",
    part_of_speech: "tính từ",
    meaning:
      "(văn chương) như trinh bạch: màu hoa ban trinh trắng * tính hồn nhiên, trinh trắng như trẻ thơ",
    example:
      "màu hoa ban trinh trắng * tính hồn nhiên, trinh trắng như trẻ thơ",
  },
  {
    word: "trình tự",
    part_of_speech: "danh từ",
    meaning:
      "sự sắp xếp lần lượt, thứ tự trước sau: trình tự lịch sử * thực hiện đúng trình tự * kể theo trình tự diễn biến",
    example:
      "trình tự lịch sử * thực hiện đúng trình tự * kể theo trình tự diễn biến",
  },
  {
    word: "trịnh trọng",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra rất nghiêm trang, biểu thị thái độ hết sức coi trọng điều mình đang nói, việc mình đang làm: trịnh trọng tuyên bố * kỉ vật được đặt trịnh trọng trong tủ kính",
    example: "trịnh trọng tuyên bố * kỉ vật được đặt trịnh trọng trong tủ kính",
  },
  {
    word: "trít",
    part_of_speech: "động từ",
    meaning:
      "làm cho chỗ hở bị bịt kín hoặc lỗ thông bị tắc đi: trít chõ đồ xôi * trít bùn vào kẽ vách",
    example: "trít chõ đồ xôi * trít bùn vào kẽ vách",
  },
  {
    word: "trít",
    part_of_speech: "tính từ",
    meaning:
      "(Phương ngữ) (mắt) ở trạng thái nhắm nghiền lại: nhắm trít mắt lại * cười trít mắt",
    example: "nhắm trít mắt lại * cười trít mắt",
  },
  {
    word: "trinh tiết",
    part_of_speech: "",
    meaning:
      "(người phụ nữ) còn tân, còn trong trắng khi chưa có chồng, hoặc giữ được trọn lòng chung thuỷ với chồng: giữ tròn trinh tiết * người phụ nữ trinh tiết",
    example: "giữ tròn trinh tiết * người phụ nữ trinh tiết",
  },
  {
    word: "trĩu nặng",
    part_of_speech: "tính từ",
    meaning: "như nặng trĩu: mí mắt trĩu nặng * lòng trĩu nặng lo âu",
    example: "mí mắt trĩu nặng * lòng trĩu nặng lo âu",
  },
  {
    word: "trìu mến",
    part_of_speech: "",
    meaning:
      "biểu lộ tình yêu thương tha thiết: ánh mắt trìu mến * cử chỉ trìu mến",
    example: "ánh mắt trìu mến * cử chỉ trìu mến",
  },
  {
    word: "tríu",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) quấn lấy không chịu rời: đứa bé tríu lấy mẹ, không chịu rời nửa bước",
    example: "đứa bé tríu lấy mẹ, không chịu rời nửa bước",
  },
  {
    word: "trĩu",
    part_of_speech: "tính từ",
    meaning:
      "bị sa thấp hoặc cong oằn hẳn xuống do sức nặng: lúa trĩu bông * cây sai trĩu quả * gánh nặng, trĩu cả vai",
    example: "lúa trĩu bông * cây sai trĩu quả * gánh nặng, trĩu cả vai",
  },
  {
    word: "trỏ",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) chỉ: trỏ đường * trỏ tay sang phải",
    example: "trỏ đường * trỏ tay sang phải",
  },
  {
    word: "trĩu trịt",
    part_of_speech: "tính từ",
    meaning: "quá nhiều, làm cho trĩu xuống: cành cây trĩu trịt quả",
    example: "cành cây trĩu trịt quả",
  },
  {
    word: "tro",
    part_of_speech: "danh từ",
    meaning:
      "chất còn lại của một số vật sau khi cháy hết, nát vụn như bột và thường có màu xám: tro bếp * cháy thành tro * nắm tro tàn",
    example: "tro bếp * cháy thành tro * nắm tro tàn",
  },
  {
    word: "trò chơi",
    part_of_speech: "danh từ",
    meaning:
      "hoạt động bày ra để vui chơi, giải trí: trò chơi dân gian * chơi trò chơi",
    example: "trò chơi dân gian * chơi trò chơi",
  },
  {
    word: "trọ",
    part_of_speech: "động từ",
    meaning:
      "ở tạm, ngủ tạm một thời gian tại nhà người khác, nơi khác: ở trọ * thuê phòng để trọ học",
    example: "ở trọ * thuê phòng để trọ học",
  },
  {
    word: "trò",
    part_of_speech: "danh từ",
    meaning:
      "hoạt động diễn ra trước mặt người khác, trước đám đông để mua vui: trò ảo thuật * trò giải trí * nói một câu pha trò",
    example: "trò ảo thuật * trò giải trí * nói một câu pha trò",
  },
  {
    word: "trò",
    part_of_speech: "danh từ",
    meaning:
      "việc làm bị coi là không ngay thẳng hoặc thiếu nghiêm chỉnh: giở trò lừa đảo * trò cờ bạc",
    example: "giở trò lừa đảo * trò cờ bạc",
  },
  {
    word: "trò",
    part_of_speech: "danh từ",
    meaning: "học trò (nói tắt): tình thầy trò * con ngoan trò giỏi",
    example: "tình thầy trò * con ngoan trò giỏi",
  },
  {
    word: "trò đời",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) sự việc (thường là việc xấu) thường tình ở đời, không có gì đáng ngạc nhiên: trò đời trâu buộc ghét trâu ăn * trò đời nó thế!",
    example: "trò đời trâu buộc ghét trâu ăn * trò đời nó thế!",
  },
  {
    word: "trò cười",
    part_of_speech: "danh từ",
    meaning:
      "trò bày ra để cười cho vui; thường dùng để chỉ việc làm lố lăng, đáng chê cười: làm trò cười cho thiên hạ",
    example: "làm trò cười cho thiên hạ",
  },
  {
    word: "trò hề",
    part_of_speech: "danh từ",
    meaning:
      "trò bày đặt ra để mua vui; thường dùng để ví việc làm giả dối, nhưng không lừa bịp được ai và đáng khinh bỉ: trò hề công lí * trò hề bầu bán của chính phủ bù nhìn",
    example: "trò hề công lí * trò hề bầu bán của chính phủ bù nhìn",
  },
  {
    word: "trò chuyện",
    part_of_speech: "động từ",
    meaning: "như chuyện trò: ngồi quây quần trò chuyện",
    example: "ngồi quây quần trò chuyện",
  },
  {
    word: "trò đùa",
    part_of_speech: "danh từ",
    meaning:
      "trò bày ra để đùa vui; thường dùng để chỉ sự việc không coi là quan trọng, đáng kể (do thái độ thiếu nghiêm túc trong công việc, cuộc sống): trò đùa trẻ con * chiến tranh đâu phải trò đùa",
    example: "trò đùa trẻ con * chiến tranh đâu phải trò đùa",
  },
  {
    word: "trò trống",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) việc có giá trị, đáng kể (nói khái quát): ngữ nó thì làm được trò trống gì!",
    example: "ngữ nó thì làm được trò trống gì!",
  },
  {
    word: "trọ trẹ",
    part_of_speech: "tính từ",
    meaning:
      "có giọng nói khó nghe, khác nhiều so với chuẩn, do phát âm đặc biệt địa phương hoặc do chỉ mới biết rất ít (đối với tiếng nước ngoài): nói trọ trẹ * giọng trọ trẹ, khó nghe",
    example: "nói trọ trẹ * giọng trọ trẹ, khó nghe",
  },
  {
    word: "trò ma",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) trò lừa bịp, gian giảo: giở trò ma",
    example: "giở trò ma",
  },
  {
    word: "trọc",
    part_of_speech: "tính từ",
    meaning: "(đầu) không có tóc: trọc đầu * đầu cạo trọc",
    example: "trọc đầu * đầu cạo trọc",
  },
  {
    word: "trọc",
    part_of_speech: "tính từ",
    meaning:
      "(đồi, núi) không có cây cối mọc như thường thấy: sườn núi trọc * trồng cây phủ xanh đồi trọc",
    example: "sườn núi trọc * trồng cây phủ xanh đồi trọc",
  },
  {
    word: "tróc",
    part_of_speech: "động từ",
    meaning:
      "mất đi mảng da, vỏ, hoặc lớp phủ bên ngoài: ngã bị tróc da * cây tróc vỏ * sơn tróc từng mảng",
    example: "ngã bị tróc da * cây tróc vỏ * sơn tróc từng mảng",
  },
  {
    word: "tróc",
    part_of_speech: "động từ",
    meaning:
      "bong ra, không còn dính nữa: nhãn vở bị tróc * giấy dán tường đã tróc ra từng tờ",
    example: "nhãn vở bị tróc * giấy dán tường đã tróc ra từng tờ",
  },
  {
    word: "tróc",
    part_of_speech: "động từ",
    meaning:
      "(cũ, hoặc kng) bắt hoặc lấy cho bằng được bằng sức mạnh: tróc tiền sưu thuế",
    example: "tróc tiền sưu thuế",
  },
  {
    word: "tróc",
    part_of_speech: "động từ",
    meaning:
      "bật mạnh lưỡi hoặc hai đầu ngón tay vào nhau cho phát ra tiếng kêu giòn, gọn (thường dùng để làm hiệu): tróc tay làm nhịp * tróc lưỡi làm ám hiệu",
    example: "tróc tay làm nhịp * tróc lưỡi làm ám hiệu",
  },
  {
    word: "trọc lốc",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) trọc hoàn toàn, đến mức nhẵn thín, trơ trụi: đầu cạo trọc lốc",
    example: "đầu cạo trọc lốc",
  },
  {
    word: "trò vè",
    part_of_speech: "",
    meaning: "(hiếm) như trò trống: không làm nên trò vè gì!",
    example: "không làm nên trò vè gì!",
  },
  {
    word: "trọc hếu",
    part_of_speech: "tính từ",
    meaning:
      "(thông tục) (đầu) trọc hoàn toàn, đến mức như trắng hếu: đầu cạo trọc hếu",
    example: "đầu cạo trọc hếu",
  },
  {
    word: "trọc phú",
    part_of_speech: "danh từ",
    meaning: "người giàu có mà dốt nát, bần tiện: gã trọc phú",
    example: "gã trọc phú",
  },
  {
    word: "trọc tếu",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (đầu) trọc hoàn toàn, không còn sợi tóc nào, trông trơ, xấu: đầu trọc tếu",
    example: "đầu trọc tếu",
  },
  {
    word: "trói",
    part_of_speech: "động từ",
    meaning:
      "buộc chặt để cho không thể cử động, vận động tự do được nữa: trói chân gà * trói tay ra đằng sau * cởi trói",
    example: "trói chân gà * trói tay ra đằng sau * cởi trói",
  },
  {
    word: "tròi",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) lòi ra, trồi ra: dây thắt lưng tròi ra ngoài",
    example: "dây thắt lưng tròi ra ngoài",
  },
  {
    word: "tróc nã",
    part_of_speech: "động từ",
    meaning:
      "(cũ) lùng bắt một cách gắt gao cho bằng được kẻ có tội: lệnh tróc nã * tróc nã tên hung thủ",
    example: "lệnh tróc nã * tróc nã tên hung thủ",
  },
  {
    word: "trói buộc",
    part_of_speech: "động từ",
    meaning:
      "kìm giữ chặt, làm cho hoạt động bị gò bó, mất tự do: bị trói buộc trong vòng lễ giáo",
    example: "bị trói buộc trong vòng lễ giáo",
  },
  {
    word: "trói chân",
    part_of_speech: "động từ",
    meaning:
      "ngăn cản, ràng buộc, không cho tự do: bị trói chân vì công việc gia đình",
    example: "bị trói chân vì công việc gia đình",
  },
  {
    word: "tròn",
    part_of_speech: "tính từ",
    meaning:
      "có hình dáng, đường nét giống như hình tròn, đường tròn: khuôn mặt tròn * tròn mắt ngạc nhiên * ngồi quây tròn quanh bếp lửa",
    example:
      "khuôn mặt tròn * tròn mắt ngạc nhiên * ngồi quây tròn quanh bếp lửa",
  },
  {
    word: "tròn",
    part_of_speech: "tính từ",
    meaning:
      "có hình khối giống như hình cầu hoặc hình trụ: quả bóng tròn * trái đất tròn * người béo tròn * kẻ vo tròn, người bóp bẹp (tng)",
    example:
      "quả bóng tròn * trái đất tròn * người béo tròn * kẻ vo tròn, người bóp bẹp (tng)",
  },
  {
    word: "tròn",
    part_of_speech: "tính từ",
    meaning:
      "(âm thanh) có âm sắc tự nhiên nghe rõ từng tiếng, dễ nghe: giọng tròn, ấm * nói chưa tròn tiếng",
    example: "giọng tròn, ấm * nói chưa tròn tiếng",
  },
  {
    word: "tròn",
    part_of_speech: "tính từ",
    meaning:
      "có vừa đúng đến số lượng nào đó, không thiếu, không thừa hoặc không có những đơn vị lẻ: tròn mười tám tuổi * mua hết 50 nghìn tròn * làm tròn số",
    example: "tròn mười tám tuổi * mua hết 50 nghìn tròn * làm tròn số",
  },
  {
    word: "tròn",
    part_of_speech: "tính từ",
    meaning:
      "(làm việc gì) đầy đủ, trọn vẹn, không có gì phải chê trách: làm tròn trách nhiệm * lo tròn bổn phận",
    example: "làm tròn trách nhiệm * lo tròn bổn phận",
  },
  {
    word: "trõm",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (mắt) trũng sâu xuống, lõm vào một cách khác thường: thức nhiều, mắt trõm sâu",
    example: "thức nhiều, mắt trõm sâu",
  },
  {
    word: "tròn bóng",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như đứng bóng: mặt trời đã tròn bóng",
    example: "mặt trời đã tròn bóng",
  },
  {
    word: "tròm trèm",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) xấp xỉ: tuổi tròm trèm bảy mươi",
    example: "tuổi tròm trèm bảy mươi",
  },
  {
    word: "trọn",
    part_of_speech: "tính từ",
    meaning:
      "đầy đủ, đến tận cùng một giới hạn, phạm vi nào đó: thức trọn một đêm * hứng trọn cả băng đạn * sống với nhau trọn đời",
    example:
      "thức trọn một đêm * hứng trọn cả băng đạn * sống với nhau trọn đời",
  },
  {
    word: "trọn",
    part_of_speech: "tính từ",
    meaning:
      "đầy đủ tất cả, không có gì khiếm khuyết: giữ trọn lời thề * sống trọn tình trọn nghĩa",
    example: "giữ trọn lời thề * sống trọn tình trọn nghĩa",
  },
  {
    word: "tròn trịa",
    part_of_speech: "tính từ",
    meaning: "tròn đều, vẻ gọn đẹp (nói khái quát): khuôn mặt tròn trịa",
    example: "khuôn mặt tròn trịa",
  },
  {
    word: "tròn trặn",
    part_of_speech: "tính từ",
    meaning:
      "tròn đều và đầy đặn (nói khái quát): đôi vai tròn trặn * vóc người tròn trặn",
    example: "đôi vai tròn trặn * vóc người tròn trặn",
  },
  {
    word: "tròn trĩnh",
    part_of_speech: "tính từ",
    meaning:
      "tròn và đầy đặn, trông đẹp: gương mặt tròn trĩnh * chữ viết tròn trĩnh",
    example: "gương mặt tròn trĩnh * chữ viết tròn trĩnh",
  },
  {
    word: "tròn vo",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) rất tròn: cái đầu tròn vo * miệng há tròn vo",
    example: "cái đầu tròn vo * miệng há tròn vo",
  },
  {
    word: "trọn gói",
    part_of_speech: "tính từ",
    meaning:
      "(hình thức dịch vụ) bao gồm toàn bộ các khâu phục vụ khách hàng từ đầu đến cuối: bao thầu trọn gói * giá trọn gói",
    example: "bao thầu trọn gói * giá trọn gói",
  },
  {
    word: "trọn vẹn",
    part_of_speech: "tính từ",
    meaning:
      "hoàn toàn đầy đủ, không thiếu mặt nào: chép lại trọn vẹn bài thơ * niềm vui không trọn vẹn",
    example: "chép lại trọn vẹn bài thơ * niềm vui không trọn vẹn",
  },
  {
    word: "trọng",
    part_of_speech: "động từ",
    meaning:
      "cho là có ý nghĩa, tác dụng lớn, cần phải chú ý: trọng danh dự * tư tưởng trọng nam khinh nữ",
    example: "trọng danh dự * tư tưởng trọng nam khinh nữ",
  },
  {
    word: "trọng",
    part_of_speech: "động từ",
    meaning:
      "đánh giá cao và tránh làm trái ý, tránh xúc phạm đến: ông ấy rất được mọi người trọng",
    example: "ông ấy rất được mọi người trọng",
  },
  {
    word: "trọng",
    part_of_speech: "tính từ",
    meaning:
      "ở mức độ rất cao, rất nặng, không thể coi thường: phạm tội trọng * mắc bệnh trọng",
    example: "phạm tội trọng * mắc bệnh trọng",
  },
  {
    word: "tròn xoay",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) tròn đều cả mọi phía: mặt tròn xoay * người tròn xoay",
    example: "mặt tròn xoay * người tròn xoay",
  },
  {
    word: "tròng",
    part_of_speech: "danh từ",
    meaning: "phần nằm trong ổ mắt: tròng mắt đỏ hoe * nước mắt lưng tròng",
    example: "tròng mắt đỏ hoe * nước mắt lưng tròng",
  },
  {
    word: "tròng",
    part_of_speech: "danh từ",
    meaning:
      "thòng lọng buộc vào đầu gậy, dùng để mắc vào cổ chó, lợn mà bắt: mang tròng đi bắt chó * chịu cảnh một cổ hai tròng (b)",
    example: "mang tròng đi bắt chó * chịu cảnh một cổ hai tròng (b)",
  },
  {
    word: "tròng",
    part_of_speech: "danh từ",
    meaning:
      "kế bày sẵn để lừa cho mắc vào (khi đã mắc thì khó bề gỡ ra): chui đầu vào tròng * bày kế dụ người vào tròng",
    example: "chui đầu vào tròng * bày kế dụ người vào tròng",
  },
  {
    word: "tròng",
    part_of_speech: "động từ",
    meaning:
      "mắc tròng vào cổ: tròng dây vào cổ con vật * tròng ách bóc lột vào cổ (b)",
    example: "tròng dây vào cổ con vật * tròng ách bóc lột vào cổ (b)",
  },
  {
    word: "tròn xoe",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) rất tròn, tựa như được căng đều ra mọi phía: mắt tròn xoe ngơ ngác * tán lá tròn xoe",
    example: "mắt tròn xoe ngơ ngác * tán lá tròn xoe",
  },
  {
    word: "trọng án",
    part_of_speech: "danh từ",
    meaning: "vụ án gây hậu quả đặc biệt nghiêm trọng: vụ trọng án",
    example: "vụ trọng án",
  },
  {
    word: "trong",
    part_of_speech: "danh từ",
    meaning:
      "phía những vị trí thuộc phạm vi được xác định nào đó; đối lập với ngoài: trong rừng * quần áo để trong tủ * người trong họ * sản phẩm trong nước",
    example:
      "trong rừng * quần áo để trong tủ * người trong họ * sản phẩm trong nước",
  },
  {
    word: "trong",
    part_of_speech: "danh từ",
    meaning:
      "phía sau, so với phía trước, hoặc phía những vị trí ở gần trung tâm, so với những vị trí ở xa trung tâm: nhà trong * đưa bóng vào trong vòng cấm địa",
    example: "nhà trong * đưa bóng vào trong vòng cấm địa",
  },
  {
    word: "trong",
    part_of_speech: "danh từ",
    meaning:
      "vùng địa lí ở vào phía nam so với địa phương xác định nào đó lấy làm mốc, trong phạm vi đất nước Việt Nam: người miền trong * trong Nam ngoài Bắc",
    example: "người miền trong * trong Nam ngoài Bắc",
  },
  {
    word: "trong",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian trước thời điểm xác định nào đó không bao lâu: về quê từ trong Tết * chuyện xảy ra hồi trong năm",
    example: "về quê từ trong Tết * chuyện xảy ra hồi trong năm",
  },
  {
    word: "trong",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là điều kiện, hoàn cảnh, môi trường của hoạt động, sự việc được nói đến: sống trong nhung lụa * trưởng thành trong chiến đấu",
    example: "sống trong nhung lụa * trưởng thành trong chiến đấu",
  },
  {
    word: "trong",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là giới hạn về thời gian của hoạt động, sự việc được nói đến: đi ngay trong đêm nay * công trình hoàn thành trong ba năm",
    example: "đi ngay trong đêm nay * công trình hoàn thành trong ba năm",
  },
  {
    word: "trong",
    part_of_speech: "tính từ",
    meaning:
      "tinh khiết, không có gợn, mắt có thể nhìn thấu suốt qua: nước trong * bầu trời trong * đôi mắt trong * trong như pha lê",
    example: "nước trong * bầu trời trong * đôi mắt trong * trong như pha lê",
  },
  {
    word: "trong",
    part_of_speech: "tính từ",
    meaning:
      "(âm thanh) không có tạp âm, không lẫn tiếng ồn, nghe phân biệt rất rõ các âm với nhau: giọng hát trong * tiếng suối trong",
    example: "giọng hát trong * tiếng suối trong",
  },
  {
    word: "trong ấm ngoài êm",
    part_of_speech: "",
    meaning:
      '(quan hệ gia đình) được êm ấm mọi bề: "Mọi bề trong ấm ngoài êm, Chị dù chín suối cũng cam tấc lòng." (NĐM)',
    example:
      'Mọi bề trong ấm ngoài êm, Chị dù chín suối cũng cam tấc lòng." (NĐM)',
  },
  {
    word: "trỏng",
    part_of_speech: "đại từ",
    meaning: "(Nam, khẩu ngữ) trong ấy: vô trỏng * Chỉ đang ở trỏng.",
    example: "vô trỏng * Chỉ đang ở trỏng.",
  },
  {
    word: "trọng âm",
    part_of_speech: "danh từ",
    meaning:
      "sự nhấn mạnh làm nổi bật khi phát âm một âm tiết nào đó trong từ đa tiết, trong một tổ hợp từ hoặc trong chuỗi lời nói, bằng cách tăng cao độ, cường độ, trường độ: trọng âm của từ trong tiếng Anh * đọc đúng trọng âm",
    example: "trọng âm của từ trong tiếng Anh * đọc đúng trọng âm",
  },
  {
    word: "trọng bệnh",
    part_of_speech: "danh từ",
    meaning: "(cũ, hiếm) bệnh nặng: lâm trọng bệnh",
    example: "lâm trọng bệnh",
  },
  {
    word: "trọng dụng",
    part_of_speech: "động từ",
    meaning:
      "tin cậy và giao cho những công việc, chức vụ quan trọng, xứng đáng: trọng dụng nhân tài * được cấp trên trọng dụng",
    example: "trọng dụng nhân tài * được cấp trên trọng dụng",
  },
  {
    word: "trọng đãi",
    part_of_speech: "động từ",
    meaning:
      "đối đãi rất hậu, biểu thị thái độ coi trọng: trọng đãi người tài * được trọng đãi như khách quý",
    example: "trọng đãi người tài * được trọng đãi như khách quý",
  },
  {
    word: "trọng điểm",
    part_of_speech: "danh từ",
    meaning:
      "điểm, nơi được xác định là có vai trò quan trọng so với những điểm, những nơi khác: vùng kinh tế trọng điểm * ngành hàng trọng điểm",
    example: "vùng kinh tế trọng điểm * ngành hàng trọng điểm",
  },
  {
    word: "trong lành",
    part_of_speech: "tính từ",
    meaning:
      "trong sạch và có tác dụng tốt đối với cơ thể con người: khí hậu trong lành * hít thở bầu không khí trong lành",
    example: "khí hậu trong lành * hít thở bầu không khí trong lành",
  },
  {
    word: "trọng nể",
    part_of_speech: "động từ",
    meaning: "(hiếm) như nể trọng: được người đời trọng nể",
    example: "được người đời trọng nể",
  },
  {
    word: "trọng đại",
    part_of_speech: "tính từ",
    meaning:
      "có tầm quan trọng lớn lao: sứ mệnh trọng đại * sự kiện trọng đại trong đời",
    example: "sứ mệnh trọng đại * sự kiện trọng đại trong đời",
  },
  {
    word: "trọng lượng",
    part_of_speech: "danh từ",
    meaning: "trọng lực tác dụng vào một vật: môi trường không trọng lượng",
    example: "môi trường không trọng lượng",
  },
  {
    word: "trọng lượng",
    part_of_speech: "danh từ",
    meaning:
      "khối lượng của một vật cụ thể nào đó: trọng lượng cơ thể * trọng lượng mỗi bao là 50kg",
    example: "trọng lượng cơ thể * trọng lượng mỗi bao là 50kg",
  },
  {
    word: "trọng lượng",
    part_of_speech: "danh từ",
    meaning:
      "sức thuyết phục cao: một bằng chứng không trọng lượng * lời nói có trọng lượng",
    example: "một bằng chứng không trọng lượng * lời nói có trọng lượng",
  },
  {
    word: "trọng pháo",
    part_of_speech: "danh từ",
    meaning: "pháo cỡ lớn, pháo hạng nặng: khẩu trọng pháo",
    example: "khẩu trọng pháo",
  },
  {
    word: "trọng phạm",
    part_of_speech: "",
    meaning: "phạm tội nặng: kẻ trọng phạm",
    example: "kẻ trọng phạm",
  },
  {
    word: "trong suốt",
    part_of_speech: "tính từ",
    meaning:
      "trong đến mức có thể nhìn xuyên suốt qua: dòng nước trong suốt * bầu trời trong suốt như thuỷ tinh",
    example: "dòng nước trong suốt * bầu trời trong suốt như thuỷ tinh",
  },
  {
    word: "trong sạch",
    part_of_speech: "tính từ",
    meaning:
      "trong và không có chất bẩn lẫn vào (nói khái quát): không khí ban mai trong sạch * dòng nước trong sạch",
    example: "không khí ban mai trong sạch * dòng nước trong sạch",
  },
  {
    word: "trong sạch",
    part_of_speech: "tính từ",
    meaning:
      "có phẩm chất đạo đức tốt đẹp, không bị một vết nhơ bẩn nào: tâm hồn trong sạch * sống trong sạch * làm trong sạch đội ngũ",
    example: "tâm hồn trong sạch * sống trong sạch * làm trong sạch đội ngũ",
  },
  {
    word: "trong ngoài",
    part_of_speech: "danh từ",
    meaning:
      "cả trong lẫn ngoài (nói khái quát); khắp mọi nơi, mọi chỗ: tiếng đồn vang khắp trong ngoài",
    example: "tiếng đồn vang khắp trong ngoài",
  },
  {
    word: "trọng nghĩa khinh tài",
    part_of_speech: "",
    meaning:
      'coi trọng đạo nghĩa và không chú ý gì đến tiền tài: "Chiếc thoa nào của mấy mươi, Mà lòng trọng nghĩa khinh tài xiết bao!" (TKiều)',
    example:
      'Chiếc thoa nào của mấy mươi, Mà lòng trọng nghĩa khinh tài xiết bao!" (TKiều)',
  },
  {
    word: "trong sáng",
    part_of_speech: "tính từ",
    meaning:
      "trong và sáng, không một chút vẩn đục, không một vết mờ: bầu trời trong sáng * đôi mắt trong sáng * một cô gái hồn nhiên, trong sáng",
    example:
      "bầu trời trong sáng * đôi mắt trong sáng * một cô gái hồn nhiên, trong sáng",
  },
  {
    word: "trong sáng",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái giữ được bản sắc tốt đẹp, không có hiện tượng pha tạp: giữ gìn sự trong sáng của tiếng Việt * bài hát có ca từ trong sáng",
    example:
      "giữ gìn sự trong sáng của tiếng Việt * bài hát có ca từ trong sáng",
  },
  {
    word: "trong sáng",
    part_of_speech: "tính từ",
    meaning:
      "hoàn toàn lành mạnh, vô tư, không một chút mờ ám: tâm hồn trong sáng * tình yêu trong sáng",
    example: "tâm hồn trong sáng * tình yêu trong sáng",
  },
  {
    word: "trọng tài",
    part_of_speech: "danh từ",
    meaning:
      "người điều khiển và xác định thành tích của cuộc thi đấu trong một số môn thể thao: trọng tài bóng đá * trọng tài chính * trọng tài biên",
    example: "trọng tài bóng đá * trọng tài chính * trọng tài biên",
  },
  {
    word: "trọng tài",
    part_of_speech: "danh từ",
    meaning:
      "người được cử ra để phân xử, giải quyết những vụ tranh chấp: trọng tài kinh tế * hội đồng trọng tài lao động",
    example: "trọng tài kinh tế * hội đồng trọng tài lao động",
  },
  {
    word: "trọng tải",
    part_of_speech: "danh từ",
    meaning:
      "khối lượng có thể chở được mỗi chuyến của phương tiện vận tải: trọng tải của xe là 2,5 tấn * chở quá trọng tải",
    example: "trọng tải của xe là 2,5 tấn * chở quá trọng tải",
  },
  {
    word: "trọng tâm",
    part_of_speech: "danh từ",
    meaning: "điểm đặt của trọng lực: kê lệch trọng tâm nên dễ đổ",
    example: "kê lệch trọng tâm nên dễ đổ",
  },
  {
    word: "trọng tâm",
    part_of_speech: "danh từ",
    meaning: "giao điểm của ba đường trung tuyến trong một tam giác.",
    example: "nhiệm vụ trọng tâm * đi thẳng vào trọng tâm của vấn đề",
  },
  {
    word: "trọng thị",
    part_of_speech: "động từ",
    meaning: "coi trọng: đón tiếp trọng thị * tinh thần trọng thị",
    example: "đón tiếp trọng thị * tinh thần trọng thị",
  },
  {
    word: "trọng thần",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người bề tôi quan trọng, giữ chức vụ lớn: trọng thần của triều đình",
    example: "trọng thần của triều đình",
  },
  {
    word: "trọng thể",
    part_of_speech: "tính từ",
    meaning:
      "được tiến hành với những hình thức nghiêm trang và long trọng: cuộc mít tinh trọng thể * lễ cưới được cử hành rất trọng thể",
    example: "cuộc mít tinh trọng thể * lễ cưới được cử hành rất trọng thể",
  },
  {
    word: "trọng tội",
    part_of_speech: "danh từ",
    meaning: "tội rất nặng: giết người là một trọng tội",
    example: "giết người là một trọng tội",
  },
  {
    word: "trọng trách",
    part_of_speech: "danh từ",
    meaning:
      "trách nhiệm lớn, nặng nề, quan trọng: giữ trọng trách lớn * hoàn thành trọng trách được giao",
    example: "giữ trọng trách lớn * hoàn thành trọng trách được giao",
  },
  {
    word: "trọng thương",
    part_of_speech: "tính từ",
    meaning: "bị thương nặng: bị đánh trọng thương",
    example: "bị đánh trọng thương",
  },
  {
    word: "tròng trành",
    part_of_speech: "tính từ",
    meaning:
      'ở trạng thái nghiêng qua nghiêng lại, không giữ được thăng bằng: thuyền tròng trành sắp lật * "Tròng trành như nón không quai, Như thuyền không lái như ai không chồng." (ca dao)',
    example:
      'thuyền tròng trành sắp lật * "Tròng trành như nón không quai, Như thuyền không lái như ai không chồng." (ca dao)',
  },
  {
    word: "trong trắng",
    part_of_speech: "tính từ",
    meaning:
      "còn giữ được nguyên bản chất tốt đẹp ban đầu, chưa hề gợn một vết nhơ: tâm hồn trong trắng",
    example: "tâm hồn trong trắng",
  },
  {
    word: "trọng thưởng",
    part_of_speech: "động từ",
    meaning:
      "thưởng phần thưởng có giá trị lớn, trên hẳn mức bình thường: trọng thưởng người có công * được nhà vua trọng thưởng",
    example: "trọng thưởng người có công * được nhà vua trọng thưởng",
  },
  {
    word: "trong trẻo",
    part_of_speech: "tính từ",
    meaning:
      "rất trong, gây cảm giác dễ chịu: vòm trời trong trẻo * đôi mắt trong trẻo",
    example: "vòm trời trong trẻo * đôi mắt trong trẻo",
  },
  {
    word: "trong veo",
    part_of_speech: "tính từ",
    meaning:
      "rất trong, như có thể nhìn thấu suốt được: trời trong veo * đôi mắt trong veo",
    example: "trời trong veo * đôi mắt trong veo",
  },
  {
    word: "trong vắt",
    part_of_speech: "tính từ",
    meaning:
      "rất trong, không một chút vẩn đục: dòng nước trong vắt * bầu trời đêm trong vắt",
    example: "dòng nước trong vắt * bầu trời đêm trong vắt",
  },
  {
    word: "trọng vọng",
    part_of_speech: "động từ",
    meaning:
      "hết sức coi trọng và ngưỡng mộ (nói về số đông): được người đời trọng vọng",
    example: "được người đời trọng vọng",
  },
  {
    word: "trót",
    part_of_speech: "động từ",
    meaning:
      "lỡ làm hoặc để xảy ra (điều không hay, không thích hợp nào đó) rồi sau đó lấy làm tiếc, nhưng cũng đành chịu: trót tiêu hết tiền * trót hứa nên phải làm",
    example: "trót tiêu hết tiền * trót hứa nên phải làm",
  },
  {
    word: "trót",
    part_of_speech: "tính từ",
    meaning:
      "(làm việc gì) trọn vẹn cả quá trình, cho đến cùng: thức trót đêm * làm trót buổi * đã thương thì thương cho trót",
    example: "thức trót đêm * làm trót buổi * đã thương thì thương cho trót",
  },
  {
    word: "trọng yếu",
    part_of_speech: "tính từ",
    meaning: "hết sức quan trọng: nhiệm vụ trọng yếu * nhân vật trọng yếu",
    example: "nhiệm vụ trọng yếu * nhân vật trọng yếu",
  },
  {
    word: "trọng trường",
    part_of_speech: "danh từ",
    meaning:
      "khoảng không gian chung quanh một vật và chịu sức hút của vật đó: trọng trường của Trái Đất * gia tốc trọng trường",
    example: "trọng trường của Trái Đất * gia tốc trọng trường",
  },
  {
    word: "trót dại",
    part_of_speech: "động từ",
    meaning: "trót làm điều dại dột: cháu nó trót dại, mong anh bỏ quá cho",
    example: "cháu nó trót dại, mong anh bỏ quá cho",
  },
  {
    word: "trót lọt",
    part_of_speech: "tính từ",
    meaning:
      "(làm việc gì) qua được tất cả các bước khó khăn, không bị cản lại, mắc lại: chuyến hàng lậu qua biên giới trót lọt * mọi việc đều xong xuôi trót lọt",
    example:
      "chuyến hàng lậu qua biên giới trót lọt * mọi việc đều xong xuôi trót lọt",
  },
  {
    word: "trố",
    part_of_speech: "động từ",
    meaning:
      "(mắt) giương to ra để nhìn, biểu lộ sự ngạc nhiên hoặc sợ hãi: trố mắt kinh ngạc",
    example: "trố mắt kinh ngạc",
  },
  {
    word: "trố",
    part_of_speech: "tính từ",
    meaning: "(hiếm) (mắt) quá to và trông như lồi ra: mắt trố",
    example: "mắt trố",
  },
  {
    word: "trổ",
    part_of_speech: "động từ",
    meaning:
      "nảy ra, đâm ra từ thân cây, cành cây (nói khái quát): lúa trổ đòng đòng * cau đang trổ buồng",
    example: "lúa trổ đòng đòng * cau đang trổ buồng",
  },
  {
    word: "trổ",
    part_of_speech: "động từ",
    meaning:
      "đưa ra thể hiện hoặc thi thố cho thấy rõ: trổ ngón lừa bịp * trổ hết tài năng",
    example: "trổ ngón lừa bịp * trổ hết tài năng",
  },
  {
    word: "trổ",
    part_of_speech: "động từ",
    meaning:
      "mở lối thông ra bằng cách phá thủng đi một mảng: nhà trổ nhiều ô cửa sổ * trổ hàng rào làm lối đi",
    example: "nhà trổ nhiều ô cửa sổ * trổ hàng rào làm lối đi",
  },
  {
    word: "trổ",
    part_of_speech: "danh từ",
    meaning:
      "(Phương ngữ) lối thông nhỏ được đào ra, khoét ra: chó chui qua trổ rào",
    example: "chó chui qua trổ rào",
  },
  {
    word: "trổ",
    part_of_speech: "động từ",
    meaning:
      "tạo nên những hình khối nghệ thuật bằng cách đục, gọt, khắc vào chất liệu: cột nhà trổ hình rồng",
    example: "cột nhà trổ hình rồng",
  },
  {
    word: "trộ",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) trận (mưa, gió, v.v.): trộ mưa rào",
    example: "trộ mưa rào",
  },
  {
    word: "trộ",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) doạ cho sợ: trộ trẻ con",
    example: "trộ trẻ con",
  },
  {
    word: "trộ",
    part_of_speech: "động từ",
    meaning:
      "cố ý tỏ ra là mình tài giỏi hơn người, hòng làm cho người khác phải nể phục: nói chữ để trộ nhau",
    example: "nói chữ để trộ nhau",
  },
  {
    word: "trỗ",
    part_of_speech: "động từ",
    meaning: "như trổ (ng1; thường nói về lúa, ngô): ngô trỗ cờ * lúa trỗ bông",
    example: "ngô trỗ cờ * lúa trỗ bông",
  },
  {
    word: "trô trố",
    part_of_speech: "động từ",
    meaning: "như trố (nhưng ý nhấn mạnh hơn): nhìn trô trố",
    example: "nhìn trô trố",
  },
  {
    word: "trối",
    part_of_speech: "danh từ",
    meaning:
      "đốt ở sát mặt đất của cây mạ, có vòng rễ ăn vào đất: mạ nhổ bị đứt trối",
    example: "mạ nhổ bị đứt trối",
  },
  {
    word: "trối",
    part_of_speech: "động từ",
    meaning:
      "dặn dò lại trước khi chết: chết không kịp trối * trối lại vài lời cho con cháu",
    example: "chết không kịp trối * trối lại vài lời cho con cháu",
  },
  {
    word: "trổ tài",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tỏ ra cho mọi người thấy cái tài của mình (thường hàm ý đùa vui): trổ tài ăn nói * được dịp trổ tài",
    example: "trổ tài ăn nói * được dịp trổ tài",
  },
  {
    word: "trồi",
    part_of_speech: "động từ",
    meaning:
      "nhô lên hoặc nhô ra và nổi hẳn lên trên bề mặt: trồi đầu lên trên mặt nước * mầm cây trồi lên",
    example: "trồi đầu lên trên mặt nước * mầm cây trồi lên",
  },
  {
    word: "trốc",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) đầu (của người, động vật): đỉnh trốc",
    example: "đỉnh trốc",
  },
  {
    word: "trốc",
    part_of_speech: "danh từ",
    meaning: "(cũ, hoặc ph) trên, chỗ cao nhất: ăn trên ngồi trốc (tng)",
    example: "ăn trên ngồi trốc (tng)",
  },
  {
    word: "trốc",
    part_of_speech: "động từ",
    meaning:
      "làm cho bật tung lên cả mảng, cả khối: bão làm trốc mái nhà * cây bị trốc gốc",
    example: "bão làm trốc mái nhà * cây bị trốc gốc",
  },
  {
    word: "trội",
    part_of_speech: "tính từ",
    meaning:
      "vượt hẳn lên về số lượng, chất lượng so với những cái khác cùng loại: người cao, đứng trội hơn đám bạn * học trội nhất lớp",
    example: "người cao, đứng trội hơn đám bạn * học trội nhất lớp",
  },
  {
    word: "trội",
    part_of_speech: "tính từ",
    meaning:
      "nhiều hơn lên, tăng thêm lên: cân trội thêm một ít * tính trội vài đồng",
    example: "cân trội thêm một ít * tính trội vài đồng",
  },
  {
    word: "trỗi",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) nhổm người dậy không nằm nữa, thường là sau khi thức giấc: trỗi dậy * đang nằm bỗng trỗi người lên nhìn",
    example: "trỗi dậy * đang nằm bỗng trỗi người lên nhìn",
  },
  {
    word: "trỗi",
    part_of_speech: "động từ",
    meaning: "dấy lên, nổi lên mạnh mẽ: nỗi nhớ trỗi lên trong lòng",
    example: "nỗi nhớ trỗi lên trong lòng",
  },
  {
    word: "trỗi",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) cất lên, vang lên: tiếng kèn trỗi lên",
    example: "tiếng kèn trỗi lên",
  },
  {
    word: "trối chết",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) hết sức, quá sức chịu đựng, tưởng như sắp chết: làm trối chết * chạy trối chết mà vẫn không thoát",
    example: "làm trối chết * chạy trối chết mà vẫn không thoát",
  },
  {
    word: "trôi chảy",
    part_of_speech: "tính từ",
    meaning:
      "(công việc) được tiến hành thuận lợi, không bị vấp váp, trở ngại gì: mọi việc đều trôi chảy * công việc được tiến hành rất trôi chảy",
    example: "mọi việc đều trôi chảy * công việc được tiến hành rất trôi chảy",
  },
  {
    word: "trôi chảy",
    part_of_speech: "tính từ",
    meaning:
      "(hoạt động nói năng) được tiến hành một cách dễ dàng, không có vấp váp: đọc rất trôi chảy * trả lời trôi chảy",
    example: "đọc rất trôi chảy * trả lời trôi chảy",
  },
  {
    word: "trối già",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) (làm việc gì) nhằm cho thật thoả mãn lúc tuổi già, coi là lần cuối trong đời: đi chơi một chuyến trối già",
    example: "đi chơi một chuyến trối già",
  },
  {
    word: "trối kệ",
    part_of_speech: "động từ",
    meaning: "(cũ, khẩu ngữ) như mặc kệ: trối kệ sự đời",
    example: "trối kệ sự đời",
  },
  {
    word: "trôi dạt",
    part_of_speech: "động từ",
    meaning:
      "bị cuốn đi theo sóng gió, hoặc theo dòng chảy đến một nơi nào đó: gió to làm bèo trôi dạt khắp nơi * thuyền bị bão, trôi dạt vào đảo hoang",
    example:
      "gió to làm bèo trôi dạt khắp nơi * thuyền bị bão, trôi dạt vào đảo hoang",
  },
  {
    word: "trôi dạt",
    part_of_speech: "động từ",
    meaning:
      "bị hoàn cảnh sinh sống xô đẩy làm cho phải lưu lạc đến nơi xa lạ: người bốn phương trôi dạt tới đây",
    example: "người bốn phương trôi dạt tới đây",
  },
  {
    word: "trôi nổi",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) nổi trên mặt nước và trôi lênh đênh, không có hướng nhất định: bèo trôi nổi trên mặt nước * cỏ rác trôi nổi trên sông",
    example: "bèo trôi nổi trên mặt nước * cỏ rác trôi nổi trên sông",
  },
  {
    word: "trôi nổi",
    part_of_speech: "động từ",
    meaning:
      "sống vất vưởng nay đây mai đó, không ổn định: sống trôi nổi nay đây mai đó",
    example: "sống trôi nổi nay đây mai đó",
  },
  {
    word: "trôi nổi",
    part_of_speech: "động từ",
    meaning:
      "để cho tồn tại và biến động một cách tự nhiên trên thị trường, không có sự kiểm soát: hàng giả trôi nổi trên thị trường",
    example: "hàng giả trôi nổi trên thị trường",
  },
  {
    word: "trôi",
    part_of_speech: "danh từ",
    meaning: "cá trôi (nói tắt): đầu trôi, môi mè (tng)",
    example: "đầu trôi, môi mè (tng)",
  },
  {
    word: "trôi",
    part_of_speech: "động từ",
    meaning:
      "di chuyển tự nhiên theo dòng chảy: khúc gỗ trôi bập bềnh * nước chảy bèo trôi",
    example: "khúc gỗ trôi bập bềnh * nước chảy bèo trôi",
  },
  {
    word: "trôi",
    part_of_speech: "động từ",
    meaning: "di chuyển tự nhiên theo một hướng nhất định: mây lững lờ trôi",
    example: "mây lững lờ trôi",
  },
  {
    word: "trôi",
    part_of_speech: "động từ",
    meaning:
      "(thời gian) qua đi tự nhiên, ngoài sự để ý của con người: một tiếng đồng hồ trôi qua * ngày tháng trôi đi",
    example: "một tiếng đồng hồ trôi qua * ngày tháng trôi đi",
  },
  {
    word: "trôi",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) xong xuôi một cách thuận lợi, không bị trắc trở: cố gắng làm trôi mọi việc * nuốt không trôi nên phải nhả ra",
    example: "cố gắng làm trôi mọi việc * nuốt không trôi nên phải nhả ra",
  },
  {
    word: "trối trăng",
    part_of_speech: "động từ",
    meaning:
      "trối lại (nói khái quát): thực hiện lời trối trăng * không kịp trối trăng",
    example: "thực hiện lời trối trăng * không kịp trối trăng",
  },
  {
    word: "trồi sụt",
    part_of_speech: "động từ",
    meaning:
      "trồi lên, sụt xuống, lúc thấp lúc cao thất thường: mặt đường bị trồi sụt * giá cả trồi sụt thất thường",
    example: "mặt đường bị trồi sụt * giá cả trồi sụt thất thường",
  },
  {
    word: "trôi sông",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) thả cho trôi theo dòng sông: đóng bè trôi sông * loại nó phải cho trôi sông",
    example: "đóng bè trôi sông * loại nó phải cho trôi sông",
  },
  {
    word: "trộm cướp",
    part_of_speech: "động từ",
    meaning:
      "lấy trộm và cướp giật của cải (nói khái quát): trộm cướp tài sản * nạn trộm cướp",
    example: "trộm cướp tài sản * nạn trộm cướp",
  },
  {
    word: "trộm cướp",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) kẻ trộm, kẻ cướp (nói khái quát): trộm cướp hoành hành * đề phòng trộm cướp",
    example: "trộm cướp hoành hành * đề phòng trộm cướp",
  },
  {
    word: "trộm cắp",
    part_of_speech: "động từ",
    meaning: "lấy trộm, lấy cắp của cải (nói khái quát): quen thói trộm cắp",
    example: "quen thói trộm cắp",
  },
  {
    word: "trộm cắp",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) kẻ trộm, kẻ cắp (nói khái quát): trộm cắp như rươi",
    example: "trộm cắp như rươi",
  },
  {
    word: "trộm",
    part_of_speech: "động từ",
    meaning:
      "lấy của người một cách lén lút, nhân lúc đêm hôm hoặc lúc vắng người: lấy trộm tiền * hái trộm quả * nhà bị mất trộm",
    example: "lấy trộm tiền * hái trộm quả * nhà bị mất trộm",
  },
  {
    word: "trộm",
    part_of_speech: "động từ",
    meaning:
      "làm việc gì đó một cách lén lút, thầm vụng: ảnh chụp trộm * đọc trộm thư * liếc trộm",
    example: "ảnh chụp trộm * đọc trộm thư * liếc trộm",
  },
  {
    word: "trộm",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) kẻ trộm (nói tắt): bắt trộm * bị trộm vào nhà",
    example: "bắt trộm * bị trộm vào nhà",
  },
  {
    word: "trộm phép",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) chưa được phép của ai mà đã làm việc gì đó (dùng trong lời xin lỗi một cách lịch sự hoặc lời phân trần với ý khiêm nhường): trộm phép bác, cháu xem trước rồi",
    example: "trộm phép bác, cháu xem trước rồi",
  },
  {
    word: "trôn",
    part_of_speech: "danh từ",
    meaning: "(Thông tục) đít: miệng nôn trôn tháo",
    example: "miệng nôn trôn tháo",
  },
  {
    word: "trôn",
    part_of_speech: "danh từ",
    meaning:
      "phần dưới cùng ở phía bên ngoài một số vật đựng; đối lập với miệng: trôn thúng * trôn bát * trôn niêu",
    example: "trôn thúng * trôn bát * trôn niêu",
  },
  {
    word: "trôn",
    part_of_speech: "danh từ",
    meaning:
      "phần dưới cùng ở phía bên ngoài một số quả; đối lập với cuống: cà đỏ trôn",
    example: "cà đỏ trôn",
  },
  {
    word: "trốn",
    part_of_speech: "động từ",
    meaning:
      "giấu mình vào chỗ kín đáo để khỏi bị trông thấy: sợ quá, trốn dưới gầm giường * bọn cướp trốn trong rừng",
    example: "sợ quá, trốn dưới gầm giường * bọn cướp trốn trong rừng",
  },
  {
    word: "trốn",
    part_of_speech: "động từ",
    meaning:
      "bỏ đi, tránh đi nơi khác một cách bí mật để khỏi bị giữ lại, khỏi bị bắt: tù trốn trại * trốn ra nước ngoài",
    example: "tù trốn trại * trốn ra nước ngoài",
  },
  {
    word: "trốn",
    part_of_speech: "động từ",
    meaning:
      "tìm cách lảng tránh một nhiệm vụ nào đó: tìm cách trốn việc * trốn nghĩa vụ quân sự * trốn nợ",
    example: "tìm cách trốn việc * trốn nghĩa vụ quân sự * trốn nợ",
  },
  {
    word: "trốn",
    part_of_speech: "động từ",
    meaning:
      "(trẻ em) bỏ qua một giai đoạn tập vận động ban đầu nào đó: trẻ trốn lẫy",
    example: "trẻ trốn lẫy",
  },
  {
    word: "trộn",
    part_of_speech: "động từ",
    meaning:
      "đảo lộn lên cho thứ nọ lẫn vào thứ kia: trộn vữa xây nhà * trộn bê tông * trộn lên cho đều",
    example: "trộn vữa xây nhà * trộn bê tông * trộn lên cho đều",
  },
  {
    word: "trộn",
    part_of_speech: "động từ",
    meaning:
      "cho thêm thứ khác vào và đảo lộn lên cho lẫn đều vào nhau: cơm trộn muối vừng * muối trộn hạt tiêu",
    example: "cơm trộn muối vừng * muối trộn hạt tiêu",
  },
  {
    word: "trôn kim",
    part_of_speech: "danh từ",
    meaning:
      'đầu có lỗ để xâu chỉ của kim khâu: "Ngư rằng: Làm đạo rể con, Cũng như sợi chỉ mà lòn trôn kim." (LVT)',
    example:
      'Ngư rằng: Làm đạo rể con, Cũng như sợi chỉ mà lòn trôn kim." (LVT)',
  },
  {
    word: "trốn lính",
    part_of_speech: "động từ",
    meaning: "bỏ trốn để khỏi bị bắt đi lính: bị bắt vì tội trốn lính",
    example: "bị bắt vì tội trốn lính",
  },
  {
    word: "trôn ốc",
    part_of_speech: "danh từ",
    meaning:
      "hình xoáy tròn liên tiếp nhiều vòng giống như đường xoắn quanh vỏ con ốc: cầu thang xoáy hình trôn ốc",
    example: "cầu thang xoáy hình trôn ốc",
  },
  {
    word: "trốn nắng",
    part_of_speech: "động từ",
    meaning:
      "tránh vào một chỗ để khỏi phải chịu nắng: trốn nắng, không dám ra ngoài đường",
    example: "trốn nắng, không dám ra ngoài đường",
  },
  {
    word: "trồng",
    part_of_speech: "động từ",
    meaning:
      "vùi hay cắm cành hoặc gốc cây giống xuống đất cho mọc thành cây: xới đất trồng rau * ăn quả nhớ kẻ trồng cây (tng)",
    example: "xới đất trồng rau * ăn quả nhớ kẻ trồng cây (tng)",
  },
  {
    word: "trồng",
    part_of_speech: "động từ",
    meaning:
      "chôn phần chân xuống đất để giữ vững ở tư thế đứng thẳng: trồng cây nêu * trồng cột trụ",
    example: "trồng cây nêu * trồng cột trụ",
  },
  {
    word: "trộng",
    part_of_speech: "tính từ",
    meaning: "(Phương ngữ) khá lớn, khá to: khoai trộng củ",
    example: "khoai trộng củ",
  },
  {
    word: "trốn thuế",
    part_of_speech: "động từ",
    meaning:
      "làm đủ mọi cách để trốn tránh cho khỏi phải đóng thuế: tội trốn thuế",
    example: "tội trốn thuế",
  },
  {
    word: "trốn tránh",
    part_of_speech: "động từ",
    meaning:
      "trốn hoặc tránh để khỏi phải gặp, phải làm hoặc phải chịu điều không hay, không thích nào đó (nói khái quát): trốn tránh công việc * trốn tránh trách nhiệm",
    example: "trốn tránh công việc * trốn tránh trách nhiệm",
  },
  {
    word: "trống bỏi",
    part_of_speech: "danh từ",
    meaning:
      "đồ chơi của trẻ con, giống hình cái trống, làm bằng giấy: già chơi trống bỏi (tng)",
    example: "già chơi trống bỏi (tng)",
  },
  {
    word: "trông",
    part_of_speech: "động từ",
    meaning:
      "nhìn để nhận biết: ngước mắt trông trời * xa quá, không trông thấy gì * nhìn xa trông rộng (tng)",
    example:
      "ngước mắt trông trời * xa quá, không trông thấy gì * nhìn xa trông rộng (tng)",
  },
  {
    word: "trông",
    part_of_speech: "động từ",
    meaning:
      "để ý nhìn ngó, coi sóc, giữ gìn cho yên ổn: trông trẻ * nhờ người trông nhà * ngồi trông hàng",
    example: "trông trẻ * nhờ người trông nhà * ngồi trông hàng",
  },
  {
    word: "trông",
    part_of_speech: "động từ",
    meaning: "(phương ngữ)",
    example: "trông tin nhà",
  },
  {
    word: "trông",
    part_of_speech: "động từ",
    meaning: "(ng1): trông tin nhà",
    example: "mọi việc đều trông cả vào anh * lúc khó khăn biết trông vào ai?",
  },
  {
    word: "trông",
    part_of_speech: "động từ",
    meaning:
      "hướng đến với lòng hi vọng, mong đợi được giúp đỡ: mọi việc đều trông cả vào anh * lúc khó khăn biết trông vào ai?",
    example: "ngôi nhà trông về hướng nam",
  },
  {
    word: "trống canh",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) trống đánh để cầm canh; thường dùng để chỉ khoảng thời gian một canh: "Lời quê chắp nhặt dông dài, Mua vui cũng được một vài trống canh." (TKiều)',
    example:
      'Lời quê chắp nhặt dông dài, Mua vui cũng được một vài trống canh." (TKiều)',
  },
  {
    word: "trống",
    part_of_speech: "danh từ",
    meaning:
      "nhạc khí rỗng, thường có hình trụ, thân bằng gỗ hoặc kim loại có một hoặc hai mặt thường bịt da căng, dùng dùi hay tay để gõ thành tiếng: tiếng trống trường * đánh trống",
    example: "tiếng trống trường * đánh trống",
  },
  {
    word: "trống",
    part_of_speech: "tính từ",
    meaning:
      "(chim, gà) thuộc giống đực; phân biệt với mái: gà trống * con chim trống",
    example: "gà trống * con chim trống",
  },
  {
    word: "trống",
    part_of_speech: "tính từ",
    meaning:
      "không có gì ở trong, khác với điều thường thấy: bãi đất trống * tiền vào nhà khó như gió vào nhà trống (tng)",
    example: "bãi đất trống * tiền vào nhà khó như gió vào nhà trống (tng)",
  },
  {
    word: "trống",
    part_of_speech: "tính từ",
    meaning:
      "để hở hoàn toàn, không được ngăn, che như thường thấy: cánh cửa để trống * ghé mắt nhòm qua chỗ trống",
    example: "cánh cửa để trống * ghé mắt nhòm qua chỗ trống",
  },
  {
    word: "trống",
    part_of_speech: "tính từ",
    meaning:
      "(khoảng, vị trí) không được dùng đến hoặc chưa được dùng đến: trong rạp còn nhiều ghế trống * điền vào chỗ trống",
    example: "trong rạp còn nhiều ghế trống * điền vào chỗ trống",
  },
  {
    word: "trông cậy",
    part_of_speech: "động từ",
    meaning:
      "trông vào, hi vọng dựa được vào khi khó khăn, đau yếu: trông cậy con cái lúc tuổi già * mọi việc trông cậy cả vào anh",
    example: "trông cậy con cái lúc tuổi già * mọi việc trông cậy cả vào anh",
  },
  {
    word: "trông chừng",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) như xem chừng: trông chừng trời sắp mưa * lúa má này trông chừng lại đói to",
    example: "trông chừng trời sắp mưa * lúa má này trông chừng lại đói to",
  },
  {
    word: "trông chờ",
    part_of_speech: "động từ",
    meaning:
      "chờ đợi với nhiều hi vọng: trông chờ ngày hội ngộ * việc ai nấy làm, không thể trông chờ vào người khác",
    example:
      "trông chờ ngày hội ngộ * việc ai nấy làm, không thể trông chờ vào người khác",
  },
  {
    word: "trông coi",
    part_of_speech: "động từ",
    meaning:
      "để ý nhìn ngó, coi sóc, giữ gìn cho yên ổn, cho mọi việc được bình thường: trông coi nhà cửa * trông coi thợ thuyền",
    example: "trông coi nhà cửa * trông coi thợ thuyền",
  },
  {
    word: "trống hoác",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) trống một khoảng rộng, không có gì bên trong hoặc không được che chắn gì: căn nhà trống hoác, chẳng có đồ đạc gì",
    example: "căn nhà trống hoác, chẳng có đồ đạc gì",
  },
  {
    word: "trông đợi",
    part_of_speech: "động từ",
    meaning: "như trông chờ: trông đợi ngày chiến thắng",
    example: "trông đợi ngày chiến thắng",
  },
  {
    word: "trống đồng",
    part_of_speech: "danh từ",
    meaning:
      "nhạc khí gõ thời cổ, hình cái trống, đúc bằng đồng, trên mặt có khắc chạm những hoạ tiết trang trí: trống đồng Đông Sơn",
    example: "trống đồng Đông Sơn",
  },
  {
    word: "trống huếch",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) trống rỗng và hở rộng ra, hoàn toàn không thấy có gì bên trong: túp lều trống huếch",
    example: "túp lều trống huếch",
  },
  {
    word: "trống hốc",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) trống một khoảng tương đối rộng và sâu, không được che chắn gì, để lộ hết bên trong: miệng hang trống hốc",
    example: "miệng hang trống hốc",
  },
  {
    word: "trống không",
    part_of_speech: "tính từ",
    meaning:
      "trống hoàn toàn, không có gì ở trong như thường thấy: bãi đất trống không * cái chòi trống không",
    example: "bãi đất trống không * cái chòi trống không",
  },
  {
    word: "trống không",
    part_of_speech: "tính từ",
    meaning:
      "(cách nói năng) thiếu những từ ngữ xưng hô cụ thể để cho rõ ai nói và nói với ai, như thường đòi hỏi: trả lời trống không * hỏi trống không",
    example: "trả lời trống không * hỏi trống không",
  },
  {
    word: "trông mong",
    part_of_speech: "động từ",
    meaning: "mong đợi và hi vọng: trông mong vào con cái",
    example: "trông mong vào con cái",
  },
  {
    word: "trống lốc",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) trống hoàn toàn, không có gì che phủ: cửa hầm trống lốc * quả đồi trống lốc",
    example: "cửa hầm trống lốc * quả đồi trống lốc",
  },
  {
    word: "trống lổng",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) trống không, trống rỗng: nhà cửa trống lổng * trả lời trống lổng",
    example: "nhà cửa trống lổng * trả lời trống lổng",
  },
  {
    word: "trông ngóng",
    part_of_speech: "động từ",
    meaning:
      "mong đợi thiết tha được thấy, được gặp: trông ngóng tin nhà * trông ngóng người yêu",
    example: "trông ngóng tin nhà * trông ngóng người yêu",
  },
  {
    word: "trông nom",
    part_of_speech: "động từ",
    meaning:
      "để ý đến, chăm sóc và giữ gìn cho mọi việc được tốt đẹp: trông nom nhà cửa * trông nom con cái",
    example: "trông nom nhà cửa * trông nom con cái",
  },
  {
    word: "trống ngực",
    part_of_speech: "danh từ",
    meaning:
      "nhịp đập mạnh, gấp của quả tim khi sợ hãi, hồi hộp hay dùng sức quá nhiều: sợ quá, trống ngực đánh thình thình",
    example: "sợ quá, trống ngực đánh thình thình",
  },
  {
    word: "trống quân",
    part_of_speech: "danh từ",
    meaning:
      "điệu hát dân gian đối đáp giữa trai và gái, nhạc phổ theo thơ lục bát, có tiếng đánh nhịp khi dứt câu: hát trống quân",
    example: "hát trống quân",
  },
  {
    word: "trồng trọt",
    part_of_speech: "động từ",
    meaning:
      "trồng cây cung cấp sản phẩm nông nghiệp (nói khái quát): đất trồng trọt * phát triển chăn nuôi và trồng trọt",
    example: "đất trồng trọt * phát triển chăn nuôi và trồng trọt",
  },
  {
    word: "trống trải",
    part_of_speech: "tính từ",
    meaning:
      "trống hoàn toàn, không có gì che chắn ở chung quanh hoặc thiếu đi những cái thường có ở bên trong: căn phòng trống trải",
    example: "căn phòng trống trải",
  },
  {
    word: "trống trải",
    part_of_speech: "tính từ",
    meaning:
      "có cảm giác thiếu đi những tình cảm thân thiết đầm ấm: trong lòng trống trải, cô đơn",
    example: "trong lòng trống trải, cô đơn",
  },
  {
    word: "trống rỗng",
    part_of_speech: "tính từ",
    meaning:
      "trống hoàn toàn, không có gì ở trong: căn nhà trống rỗng * túi trống rỗng, không còn một xu",
    example: "căn nhà trống rỗng * túi trống rỗng, không còn một xu",
  },
  {
    word: "trống rỗng",
    part_of_speech: "tính từ",
    meaning:
      "hoàn toàn không có chút nội dung, kiến thức, tư tưởng nào có giá trị: đầu óc trống rỗng",
    example: "đầu óc trống rỗng",
  },
  {
    word: "trồng trộng",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) hơi to, hơi lớn: con cá trồng trộng cỡ bắp tay",
    example: "con cá trồng trộng cỡ bắp tay",
  },
  {
    word: "trống trơ",
    part_of_speech: "tính từ",
    meaning: "trống đến mức như trơ ra, không có gì: ngôi nhà trống trơ",
    example: "ngôi nhà trống trơ",
  },
  {
    word: "trống trơn",
    part_of_speech: "tính từ",
    meaning:
      "trống hoàn toàn trên một khoảng rộng, không có gì ở trên đó, trong đó như thường thấy: bãi đất trống trơn * khoảnh rừng bị phá trống trơn",
    example: "bãi đất trống trơn * khoảnh rừng bị phá trống trơn",
  },
  {
    word: "trống tuếch",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ, hiếm) trống hoàn toàn, không thấy có gì trên đó cả: khu đất trống tuếch",
    example: "khu đất trống tuếch",
  },
  {
    word: "trốt",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) lốc: trận gió trốt * con trốt",
    example: "trận gió trốt * con trốt",
  },
  {
    word: "trống vắng",
    part_of_speech: "tính từ",
    meaning:
      "vắng vẻ vì thiếu mất đi cái thường phải có, gây cảm giác buồn và trống trải: căn phòng trống vắng * cảm giác trống vắng, cô đơn",
    example: "căn phòng trống vắng * cảm giác trống vắng, cô đơn",
  },
  {
    word: "trớ",
    part_of_speech: "động từ",
    meaning: "(trẻ sơ sinh) nôn: trẻ bị trớ * cứ ăn vào lại trớ ra",
    example: "trẻ bị trớ * cứ ăn vào lại trớ ra",
  },
  {
    word: "trớ",
    part_of_speech: "động từ",
    meaning: "(Phương ngữ) tránh: tìm cách nói trớ đi",
    example: "tìm cách nói trớ đi",
  },
  {
    word: "trông vời",
    part_of_speech: "động từ",
    meaning:
      '(văn chương) nhìn ra phương xa, vẻ suy tư, nghĩ ngợi: trông vời trời bể mênh mang * "Bốn phương mây trắng một màu, Trông vời cố quốc biết đâu là nhà?" (TKiều)',
    example:
      'trông vời trời bể mênh mang * "Bốn phương mây trắng một màu, Trông vời cố quốc biết đâu là nhà?" (TKiều)',
  },
  {
    word: "trống tuềnh trống toàng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) trống đến mức như hoàn toàn không được che chắn gì hoặc thiếu hẳn những gì cần có bên trong, gợi vẻ thiếu thốn: nhà cửa trống tuềnh trống toàng",
    example: "nhà cửa trống tuềnh trống toàng",
  },
  {
    word: "trợ chiến",
    part_of_speech: "động từ",
    meaning:
      "chi viện, hỗ trợ cho một đơn vị đang chiến đấu: đơn vị trợ chiến * đem quân trợ chiến",
    example: "đơn vị trợ chiến * đem quân trợ chiến",
  },
  {
    word: "trơ",
    part_of_speech: "tính từ",
    meaning:
      "có khả năng không biến đổi hình dạng, trạng thái, tính chất trước mọi tác động mạnh từ bên ngoài: đất rắn, bổ mấy nhát và vẫn trơ ra * ngồi trơ như pho tượng",
    example: "đất rắn, bổ mấy nhát và vẫn trơ ra * ngồi trơ như pho tượng",
  },
  {
    word: "trơ",
    part_of_speech: "tính từ",
    meaning:
      "không hoặc rất khó tác dụng hoá học với chất khác: khí trơ * độ trơ của một nguyên tố",
    example: "khí trơ * độ trơ của một nguyên tố",
  },
  {
    word: "trơ",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra không biết hổ thẹn, không biết ngượng trước sự chê bai, phê phán của người khác: nói thế mà nó vẫn trơ ra * mặt trơ như mặt thớt",
    example: "nói thế mà nó vẫn trơ ra * mặt trơ như mặt thớt",
  },
  {
    word: "trơ",
    part_of_speech: "tính từ",
    meaning:
      "ở vào trạng thái phơi bày ra, lộ trần ra do không còn hoặc không có được sự che phủ, bao bọc thường thấy: gầy trơ xương * cây trụi lá, trơ cành",
    example: "gầy trơ xương * cây trụi lá, trơ cành",
  },
  {
    word: "trơ",
    part_of_speech: "tính từ",
    meaning:
      "ở vào tình trạng chỉ còn lẻ loi một mình: mọi người đều đã đi cả, còn trơ lại một mình",
    example: "mọi người đều đã đi cả, còn trơ lại một mình",
  },
  {
    word: "trơ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) sượng mặt vì ở vào tình trạng khác biệt quá so với chung quanh, không có sự gần gũi hoà hợp: tìm lời hỏi chuyện cho đỡ trơ * ăn mặc hở hang, trông cũng trơ",
    example: "tìm lời hỏi chuyện cho đỡ trơ * ăn mặc hở hang, trông cũng trơ",
  },
  {
    word: "trơ",
    part_of_speech: "tính từ",
    meaning: "(quả) có hạt to, cùi mỏng và dính vào hạt: nhãn trơ",
    example: "nhãn trơ",
  },
  {
    word: "trơ",
    part_of_speech: "tính từ",
    meaning: "cùn, mòn đến mức không còn tác dụng nữa: lưỡi dao đã trơ",
    example: "lưỡi dao đã trơ",
  },
  {
    word: "trở",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ) tang: nhà có trở * để trở",
    example: "nhà có trở * để trở",
  },
  {
    word: "trở",
    part_of_speech: "động từ",
    meaning:
      "đảo ngược vị trí, cho đầu thành đuôi, trên thành dưới và ngược lại: trở cá cho chín đều * nằm trở đầu đuôi * dễ như trở bàn tay (tng)",
    example:
      "trở cá cho chín đều * nằm trở đầu đuôi * dễ như trở bàn tay (tng)",
  },
  {
    word: "trở",
    part_of_speech: "động từ",
    meaning:
      "quay ngược lại, đi về hướng hay vị trí ban đầu: trở về quê cũ * trở lại câu chuyện đang nói",
    example: "trở về quê cũ * trở lại câu chuyện đang nói",
  },
  {
    word: "trở",
    part_of_speech: "động từ",
    meaning:
      '(diễn biến) chuyển sang chiều hướng khác, thường là xấu đi: trời trở gió * "Hai em hỏi trước, han sau, Đứng trông, chàng cũng trở sầu làm tươi." (TKiều)',
    example:
      'trời trở gió * "Hai em hỏi trước, han sau, Đứng trông, chàng cũng trở sầu làm tươi." (TKiều)',
  },
  {
    word: "trở",
    part_of_speech: "động từ",
    meaning:
      "(từ cái mốc xác định) hướng về một phía nào đó để tính phạm vi thời gian, không gian, số lượng: từ Vinh trở ra * những năm 80 trở về trước",
    example: "từ Vinh trở ra * những năm 80 trở về trước",
  },
  {
    word: "trở chứng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bỗng nhiên sinh ra tật xấu hoặc thay đổi trạng thái theo chiều hướng xấu: đang đi tự nhiên xe trở chứng, chết máy",
    example: "đang đi tự nhiên xe trở chứng, chết máy",
  },
  {
    word: "trở dạ",
    part_of_speech: "động từ",
    meaning: "như chuyển dạ: chị ấy trở dạ lúc nửa đêm",
    example: "chị ấy trở dạ lúc nửa đêm",
  },
  {
    word: "trợ cấp",
    part_of_speech: "động từ",
    meaning:
      "cấp tiền để trợ giúp cho người thiếu thốn, khó khăn: trợ cấp thất nghiệp * được hưởng trợ cấp hằng tháng",
    example: "trợ cấp thất nghiệp * được hưởng trợ cấp hằng tháng",
  },
  {
    word: "trợ bút",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) cộng tác viên của một tờ báo: làm trợ bút cho một tờ báo tỉnh",
    example: "làm trợ bút cho một tờ báo tỉnh",
  },
  {
    word: "trợ giá",
    part_of_speech: "động từ",
    meaning:
      "(nhà nước) cấp thêm cho người sản xuất một khoản tiền bù đắp cho thiệt hại do phải bán sản phẩm với giá thấp: sách được trợ giá để phục vụ học sinh miền núi",
    example: "sách được trợ giá để phục vụ học sinh miền núi",
  },
  {
    word: "trơ khấc",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) trơ lại một mình, không còn ai, không còn gì bên cạnh: mọi người đã đi hết chỉ còn trơ khấc mỗi một mình",
    example: "mọi người đã đi hết chỉ còn trơ khấc mỗi một mình",
  },
  {
    word: "trơ lì",
    part_of_speech: "tính từ",
    meaning:
      "trơ ra một cách bướng bỉnh, lì lợm: càng nói lại càng trơ lì ra, không biết ngượng",
    example: "càng nói lại càng trơ lì ra, không biết ngượng",
  },
  {
    word: "trợ động từ",
    part_of_speech: "danh từ",
    meaning:
      "động từ chuyên dùng phụ thêm cho một động từ khác: ,  *  là những trợ động từ trong tiếng Việt",
    example: ",  *  là những trợ động từ trong tiếng Việt",
  },
  {
    word: "trở lại",
    part_of_speech: "động từ",
    meaning:
      "quay về, quay lại nơi bắt đầu, nơi xuất phát: trở lại quê nhà * quay ngược trở lại",
    example: "trở lại quê nhà * quay ngược trở lại",
  },
  {
    word: "trở lại",
    part_of_speech: "động từ",
    meaning:
      "chuyển về trạng thái, tính chất (thường là tốt đẹp) ban đầu: không gian yên tĩnh trở lại * sức khoẻ đã trở lại bình thường",
    example: "không gian yên tĩnh trở lại * sức khoẻ đã trở lại bình thường",
  },
  {
    word: "trở lại",
    part_of_speech: "động từ",
    meaning:
      "lấy đó làm mốc được coi là tối đa, không thể hơn: chỗ đó được mươi cân trở lại * chỉ mươi ngày trở lại là xong",
    example: "chỗ đó được mươi cân trở lại * chỉ mươi ngày trở lại là xong",
  },
  {
    word: "trợ lực",
    part_of_speech: "động từ",
    meaning: "giúp để tăng thêm sức mạnh, sức lực: bắn trợ lực * thuốc trợ lực",
    example: "bắn trợ lực * thuốc trợ lực",
  },
  {
    word: "trợ lí",
    part_of_speech: "danh từ",
    meaning:
      "người giúp việc trực tiếp cho một người ở chức vụ cao hoặc trong một lĩnh vực chuyên môn nào đó: trợ lí giám đốc * trợ lí giảng dạy",
    example: "trợ lí giám đốc * trợ lí giảng dạy",
  },
  {
    word: "trơ mắt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ngẩn người ra, chỉ biết giương mắt nhìn (trước điều không hay xảy đến) mà không có phản ứng gì lại, do quá bất ngờ, hoặc quá yếu thế: bị người ta lấy đồ mà cứ trơ mắt ra nhìn",
    example: "bị người ta lấy đồ mà cứ trơ mắt ra nhìn",
  },
  {
    word: "trợ giúp",
    part_of_speech: "động từ",
    meaning:
      "giúp đỡ (thường về vật chất) cho đỡ khó khăn, thiếu thốn: trợ giúp vốn * trợ giúp về kĩ thuật",
    example: "trợ giúp vốn * trợ giúp về kĩ thuật",
  },
  {
    word: "trở mình",
    part_of_speech: "động từ",
    meaning: "xoay người để đổi thế nằm: trở mình cho đỡ mỏi",
    example: "trở mình cho đỡ mỏi",
  },
  {
    word: "trở mặt",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đột nhiên đối xử ngược hẳn lại với sự tử tế trước đó: trở mặt nói xấu bạn * trở mặt như trở bàn tay",
    example: "trở mặt nói xấu bạn * trở mặt như trở bàn tay",
  },
  {
    word: "trợ lý",
    part_of_speech: "danh từ",
    meaning:
      "người giúp việc trực tiếp cho một người ở chức vụ cao hoặc trong một lĩnh vực chuyên môn nào đó: trợ lí giám đốc * trợ lí giảng dạy",
    example: "trợ lí giám đốc * trợ lí giảng dạy",
  },
  {
    word: "trở lực",
    part_of_speech: "danh từ",
    meaning: "cái gây ra sức cản trở lớn: gặp trở lực lớn",
    example: "gặp trở lực lớn",
  },
  {
    word: "trợ tá",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như trợ lí: một trợ tá đắc lực",
    example: "một trợ tá đắc lực",
  },
  {
    word: "trở nên",
    part_of_speech: "động từ",
    meaning:
      "chuyển sang trạng thái khác: công việc trở nên thuận lợi * tay chân trở nên luống cuống",
    example: "công việc trở nên thuận lợi * tay chân trở nên luống cuống",
  },
  {
    word: "trở nên",
    part_of_speech: "động từ",
    meaning: "như trở thành: trở nên giàu có",
    example: "trở nên giàu có",
  },
  {
    word: "trợ thời",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) tạm trong một thời gian để cho qua bước khó khăn: tìm nơi trú chân trợ thời",
    example: "tìm nơi trú chân trợ thời",
  },
  {
    word: "trở tay",
    part_of_speech: "động từ",
    meaning:
      "đối phó ngay trước tình huống bất ngờ: quá bất ngờ nên trở tay không kịp",
    example: "quá bất ngờ nên trở tay không kịp",
  },
  {
    word: "trở ngại",
    part_of_speech: "danh từ",
    meaning:
      "cái gây khó khăn, làm cản trở: trở ngại về vốn * gặp trở ngại lớn * vượt qua mọi trở ngại",
    example: "trở ngại về vốn * gặp trở ngại lớn * vượt qua mọi trở ngại",
  },
  {
    word: "trở ngại",
    part_of_speech: "động từ",
    meaning:
      "cản trở, làm cho không tiến hành được dễ dàng, suôn sẻ: công việc suôn sẻ, không có gì trở ngại",
    example: "công việc suôn sẻ, không có gì trở ngại",
  },
  {
    word: "trơ tráo",
    part_of_speech: "tính từ",
    meaning:
      "trơ ra một cách lì lợm, ngang ngược, không hề biết hổ thẹn: thái độ trơ tráo * bộ mặt trơ tráo",
    example: "thái độ trơ tráo * bộ mặt trơ tráo",
  },
  {
    word: "trơ thổ địa",
    part_of_speech: "tính từ",
    meaning:
      "(thông tục) trơ có một mình, không có hoặc không còn cái gì khác: suốt đời cứ trơ thổ địa, chẳng vợ con gì",
    example: "suốt đời cứ trơ thổ địa, chẳng vợ con gì",
  },
  {
    word: "trơ thổ địa",
    part_of_speech: "tính từ",
    meaning:
      "trơ ra không nhúc nhích hoặc phản ứng gì: nói tới thế mà nó vẫn cứ ngồi trơ thổ địa ra đấy!",
    example: "nói tới thế mà nó vẫn cứ ngồi trơ thổ địa ra đấy!",
  },
  {
    word: "trợ thính",
    part_of_speech: "động từ",
    meaning:
      "giúp làm tăng khả năng nghe của tai: thiết bị trợ thính * máy trợ thính",
    example: "thiết bị trợ thính * máy trợ thính",
  },
  {
    word: "trợ thủ",
    part_of_speech: "danh từ",
    meaning: "người giúp sức trong công việc: một trợ thủ đắc lực",
    example: "một trợ thủ đắc lực",
  },
  {
    word: "trở thành",
    part_of_speech: "động từ",
    meaning:
      "thành ra là: ước mơ trở thành cô giáo * hai người trở thành đôi bạn thân",
    example: "ước mơ trở thành cô giáo * hai người trở thành đôi bạn thân",
  },
  {
    word: "trợ tim",
    part_of_speech: "động từ",
    meaning: "làm tăng sức hoạt động của tim: thuốc trợ tim * máy trợ tim",
    example: "thuốc trợ tim * máy trợ tim",
  },
  {
    word: "trơ trẽn",
    part_of_speech: "tính từ",
    meaning:
      "trơ đến mức lố bịch, đáng ghét: bộ mặt trơ trẽn * ăn mặc trơ trẽn",
    example: "bộ mặt trơ trẽn * ăn mặc trơ trẽn",
  },
  {
    word: "trơ trơ",
    part_of_speech: "tính từ",
    meaning:
      'rất trơ, không thay đổi gì trước mọi tác động: nói mãi mà nó vẫn trơ trơ * "Trăm năm bia đá thì mòn, Nghìn năm bia miệng hãy còn trơ trơ." (ca dao)',
    example:
      'nói mãi mà nó vẫn trơ trơ * "Trăm năm bia đá thì mòn, Nghìn năm bia miệng hãy còn trơ trơ." (ca dao)',
  },
  {
    word: "trời",
    part_of_speech: "danh từ",
    meaning:
      "khoảng không gian vô tận mà ta nhìn thấy như một hình vòm úp trên mặt đất: ngửa mặt nhìn trời * sao trên trời",
    example: "ngửa mặt nhìn trời * sao trên trời",
  },
  {
    word: "trời",
    part_of_speech: "danh từ",
    meaning:
      "trạng thái của khí quyển, của khoảng không gian bao quanh con người ở một nơi, vào một lúc nào đó: trời tối đen như mực * trời trở lạnh * được ngày đẹp trời",
    example: "trời tối đen như mực * trời trở lạnh * được ngày đẹp trời",
  },
  {
    word: "trời",
    part_of_speech: "danh từ",
    meaning:
      "(động hoặc thực vật) hoang dại, có sẵn trong tự nhiên, không phải do con người nuôi, trồng: ngỗng trời * vịt trời * cải trời",
    example: "ngỗng trời * vịt trời * cải trời",
  },
  {
    word: "trời",
    part_of_speech: "danh từ",
    meaning:
      "lực lượng siêu tự nhiên, coi như ở trên cao, sáng tạo và quyết định số phận muôn loài trên mặt đất, theo tôn giáo, tín ngưỡng dân gian: ông trời * của trời cho * số trời đã định * cầu trời khấn Phật",
    example: "ông trời * của trời cho * số trời đã định * cầu trời khấn Phật",
  },
  {
    word: "trời",
    part_of_speech: "trợ từ",
    meaning:
      'từ biểu thị ý nhấn mạnh mức độ là rất lâu, rất dài của khoảng thời gian đã qua: đi cả ngày trời mới tới * "Chốc đà mười mấy năm trời, Còn ra khi đã da mồi tóc sương." (TKiều)',
    example:
      'đi cả ngày trời mới tới * "Chốc đà mười mấy năm trời, Còn ra khi đã da mồi tóc sương." (TKiều)',
  },
  {
    word: "trời",
    part_of_speech: "cảm từ",
    meaning:
      "(Khẩu ngữ) tiếng thốt ra để biểu lộ sự ngạc nhiên hay để than thở: trời, sao lại đến nông nỗi này?",
    example: "trời, sao lại đến nông nỗi này?",
  },
  {
    word: "trợ từ",
    part_of_speech: "danh từ",
    meaning:
      "từ chuyên dùng để thêm vào cho câu, biểu thị thái độ của người nói, như ngạc nhiên, nghi ngờ, mỉa mai, vui mừng, v.v.: ,  * ,  * ,  *  là những trợ từ trong tiếng Việt",
    example: ",  * ,  * ,  *  là những trợ từ trong tiếng Việt",
  },
  {
    word: "trơ trọi",
    part_of_speech: "tính từ",
    meaning:
      "lẻ loi một mình, không có ai, không có gì bên cạnh: sống trơ trọi một mình * ngôi nhà trơ trọi giữa cánh đồng",
    example: "sống trơ trọi một mình * ngôi nhà trơ trọi giữa cánh đồng",
  },
  {
    word: "trở trời",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) thay đổi thời tiết, thường là xấu đi, về mặt gây ảnh hưởng đến sức khoẻ hoặc đời sống sinh hoạt: trở trời, người đau ê ẩm",
    example: "trở trời, người đau ê ẩm",
  },
  {
    word: "trở trời",
    part_of_speech: "",
    meaning:
      "(hiếm) mệt, ốm nhẹ do thời tiết thay đổi: bà cụ trở trời * thằng bé trở trời, không chịu ăn",
    example: "bà cụ trở trời * thằng bé trở trời, không chịu ăn",
  },
  {
    word: "trời biển",
    part_of_speech: "danh từ",
    meaning:
      "trời và biển (nói khái quát); thường dùng để ví cái rộng lớn, bao la (thường là cái trừu tượng): công ơn trời biển",
    example: "công ơn trời biển",
  },
  {
    word: "trời có mắt",
    part_of_speech: "",
    meaning:
      "trời bao giờ cũng sáng suốt, công bằng (cho nên ở hiền thì gặp lành, ở ác thì gặp dữ), theo tín ngưỡng dân gian: ác giả ác báo, đúng là trời có mắt!",
    example: "ác giả ác báo, đúng là trời có mắt!",
  },
  {
    word: "trơ trụi",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) trơ ra, hoàn toàn không còn gì: cây bàng trơ trụi lá",
    example: "cây bàng trơ trụi lá",
  },
  {
    word: "trớ trêu",
    part_of_speech: "tính từ",
    meaning:
      "có vẻ như trêu cợt, làm phiền muộn, rắc rối một cách oái oăm: lâm vào cảnh trớ trêu * thật là trớ trêu!",
    example: "lâm vào cảnh trớ trêu * thật là trớ trêu!",
  },
  {
    word: "trợ vốn",
    part_of_speech: "động từ",
    meaning:
      "giúp đỡ thêm vốn để kinh doanh, sản xuất: trợ vốn cho nông dân làm kinh tế",
    example: "trợ vốn cho nông dân làm kinh tế",
  },
  {
    word: "trời già",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) ông trời, về mặt tạo ra những ngang trái, khổ đau (hàm ý trách móc): "Tức gan riêng giận trời già, Lòng này ai tỏ cho ta, hỡi lòng?" (TKiều)',
    example:
      'Tức gan riêng giận trời già, Lòng này ai tỏ cho ta, hỡi lòng?" (TKiều)',
  },
  {
    word: "trời đất ơi",
    part_of_speech: "cảm từ",
    meaning:
      "(khẩu ngữ) tiếng kêu biểu lộ sự ngạc nhiên hay để than thở: trời đất ơi, ai bảo mày làm thế?",
    example: "trời đất ơi, ai bảo mày làm thế?",
  },
  {
    word: "trời đánh",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) sét đánh; dùng làm tiếng mắng kẻ ngang ngược, bướng bỉnh, không ai trị nổi: đồ trời đánh! * bọn trẻ trời đánh",
    example: "đồ trời đánh! * bọn trẻ trời đánh",
  },
  {
    word: "trời giáng",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) trời đánh; dùng để ví tác động mạnh mẽ, bất ngờ, làm đau đớn dữ dội: đòn trời giáng * một cái tát trời giáng",
    example: "đòn trời giáng * một cái tát trời giáng",
  },
  {
    word: "trời đất",
    part_of_speech: "danh từ",
    meaning:
      'trời và đất (nói khái quát): có trời đất chứng giám * "Nghĩ đời mà ngán cho đời, Tài tình chi lắm cho trời đất ghen!" (TKiều)',
    example:
      'có trời đất chứng giám * "Nghĩ đời mà ngán cho đời, Tài tình chi lắm cho trời đất ghen!" (TKiều)',
  },
  {
    word: "trời đất",
    part_of_speech: "cảm từ",
    meaning: "(khẩu ngữ) như trời đất ơi: trời đất, làm gì mà kì vậy?",
    example: "trời đất, làm gì mà kì vậy?",
  },
  {
    word: "trời trồng",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) ví trạng thái đứng ngây ra như bị chôn chân tại chỗ: đứng như trời trồng",
    example: "đứng như trời trồng",
  },
  {
    word: "trời ơi đất hỡi",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) như trời ơi (ngI; nhưng ý nhấn mạnh hơn): của trời ơi đất hỡi",
    example: "của trời ơi đất hỡi",
  },
  {
    word: "trơn",
    part_of_speech: "tính từ",
    meaning:
      "có bề mặt rất nhẵn, làm cho vật khác khi chạm lên thì dễ bị trượt, bị tuột đi: bào gỗ cho trơn * dùng dầu xả cho trơn tóc * đường trơn",
    example: "bào gỗ cho trơn * dùng dầu xả cho trơn tóc * đường trơn",
  },
  {
    word: "trơn",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) lưu loát, trôi chảy, không vấp váp: trả lời rất trơn",
    example: "trả lời rất trơn",
  },
  {
    word: "trơn",
    part_of_speech: "tính từ",
    meaning:
      "có bề mặt được giữ nguyên ở trạng thái đơn giản, không có trang trí: vải trơn * gạch trơn, không có hoa văn",
    example: "vải trơn * gạch trơn, không có hoa văn",
  },
  {
    word: "trơn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) chỉ làm nhiệm vụ bình thường, không có cấp bậc, chức vụ gì: anh lính trơn",
    example: "anh lính trơn",
  },
  {
    word: "trơn",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ, khẩu ngữ) nhẵn, không có, không còn một chút gì: nhà cửa cháy trơn cả * nồi cơm sạch trơn * không thấy ai hết trơn",
    example:
      "nhà cửa cháy trơn cả * nồi cơm sạch trơn * không thấy ai hết trơn",
  },
  {
    word: "trời ơi",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (của) tình cờ mà có được, không phải do bỏ sức làm ra: của trời ơi",
    example: "của trời ơi",
  },
  {
    word: "trời ơi",
    part_of_speech: "tính từ",
    meaning:
      "vu vơ, không có căn cứ: nói toàn chuyện trời ơi * hàng trôi nổi, bán với giá trời ơi",
    example: "nói toàn chuyện trời ơi * hàng trôi nổi, bán với giá trời ơi",
  },
  {
    word: "trời ơi",
    part_of_speech: "cảm từ",
    meaning: "(khẩu ngữ) như trời đất ơi: trời ơi, sao tôi lại khổ thế này?",
    example: "trời ơi, sao tôi lại khổ thế này?",
  },
  {
    word: "trớn",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ) đà: xe lấy trớn lên dốc",
    example: "xe lấy trớn lên dốc",
  },
  {
    word: "trớn",
    part_of_speech: "động từ",
    meaning: "(Ít dùng) như trợn: trớn mắt",
    example: "trớn mắt",
  },
  {
    word: "trợn trạo",
    part_of_speech: "động từ",
    meaning: "(mắt) trợn lên vẻ càn rỡ, dữ tợn: mắt láo liêng trợn trạo",
    example: "mắt láo liêng trợn trạo",
  },
  {
    word: "trợn trạo",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) xấc láo, tỏ vẻ không coi ai ra gì: thằng cha trợn trạo lắm!",
    example: "thằng cha trợn trạo lắm!",
  },
  {
    word: "trớt",
    part_of_speech: "phụ từ",
    meaning: "(phương ngữ) quách: mần trớt đi cho xong",
    example: "mần trớt đi cho xong",
  },
  {
    word: "trợn",
    part_of_speech: "động từ",
    meaning: "(mắt) mở căng ra hết cỡ: mắt trợn tròn * trợn mắt lên quát",
    example: "mắt trợn tròn * trợn mắt lên quát",
  },
  {
    word: "trơn tru",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) có bề mặt bằng và nhẵn, không gồ ghề, không lồi lõm: bào cho thật trơn tru",
    example: "bào cho thật trơn tru",
  },
  {
    word: "trơn tru",
    part_of_speech: "tính từ",
    meaning:
      "trôi chảy, không ngập ngừng, không vấp váp: trả lời trơn tru * đọc một cách trơn tru",
    example: "trả lời trơn tru * đọc một cách trơn tru",
  },
  {
    word: "trơn tru",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) thuận lợi, không vướng mắc: mọi việc đều trơn tru * máy móc vận hành trơn tru",
    example: "mọi việc đều trơn tru * máy móc vận hành trơn tru",
  },
  {
    word: "trợn trừng",
    part_of_speech: "động từ",
    meaning:
      "(mắt) trợn lên nhìn thẳng không chớp, lộ rõ vẻ tức giận, hùng hổ hoặc khiếp sợ: đôi mắt trợn trừng lộ vẻ kinh hãi",
    example: "đôi mắt trợn trừng lộ vẻ kinh hãi",
  },
  {
    word: "trơn nhẫy",
    part_of_speech: "tính từ",
    meaning:
      "trơn và bóng láng như có dầu, mỡ bôi lên trên: lưng trơn nhẫy * mặt đường trơn nhẫy",
    example: "lưng trơn nhẫy * mặt đường trơn nhẫy",
  },
  {
    word: "trợt lớt",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) trượt hết cả: đoán trợt lớt hết",
    example: "đoán trợt lớt hết",
  },
  {
    word: "trơn tuột",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) trơn tới mức không bám được, không giữ lại được: bậc đá trơn tuột",
    example: "bậc đá trơn tuột",
  },
  {
    word: "trù",
    part_of_speech: "động từ",
    meaning:
      "lợi dụng quyền lực đối xử thô bạo hoặc bất công với người dưới quyền mình để trả thù một cách nhỏ nhen: sợ bị cấp trên trù nên không dám tố cáo",
    example: "sợ bị cấp trên trù nên không dám tố cáo",
  },
  {
    word: "trù",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) lo liệu, tính toán trước: trù sẵn mọi việc",
    example: "trù sẵn mọi việc",
  },
  {
    word: "tru",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) trâu: con tru",
    example: "con tru",
  },
  {
    word: "tru",
    part_of_speech: "động từ",
    meaning:
      "rú lên thành tiếng to và kéo dài: tiếng sói tru * con chó tru lên từng hồi thảm thiết",
    example: "tiếng sói tru * con chó tru lên từng hồi thảm thiết",
  },
  {
    word: "tru",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) kêu, khóc rú lên: tru rầm nhà",
    example: "tru rầm nhà",
  },
  {
    word: "trú ẩn",
    part_of_speech: "động từ",
    meaning:
      "ẩn giấu mình ở nơi có vật che chắn để được an toàn: tìm nơi trú ẩn * xuống hầm trú ẩn",
    example: "tìm nơi trú ẩn * xuống hầm trú ẩn",
  },
  {
    word: "trụ",
    part_of_speech: "danh từ",
    meaning: "cột vững chắc để đỡ vật nặng: trụ cầu * trụ bê tông * cây trụ đá",
    example: "trụ cầu * trụ bê tông * cây trụ đá",
  },
  {
    word: "trụ",
    part_of_speech: "động từ",
    meaning:
      "bám, giữ chắc tại một vị trí, không để cho bị bật đi nơi khác: cột nhà đã bị mục, khó trụ được lâu * du kích trụ lại để đánh địch",
    example:
      "cột nhà đã bị mục, khó trụ được lâu * du kích trụ lại để đánh địch",
  },
  {
    word: "trù bị",
    part_of_speech: "động từ",
    meaning:
      "chuẩn bị, sắp xếp trước cho một công việc chung quan trọng (thường là hội nghị) nào đó: cuộc họp trù bị * hội nghị trù bị",
    example: "cuộc họp trù bị * hội nghị trù bị",
  },
  {
    word: "trù bị",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như dự bị: quân trù bị * lực lượng trù bị",
    example: "quân trù bị * lực lượng trù bị",
  },
  {
    word: "trú",
    part_of_speech: "động từ",
    meaning:
      "ở tạm nơi không phải nhà mình: trú nhờ nhà bạn * tìm nơi trú tạm một đêm",
    example: "trú nhờ nhà bạn * tìm nơi trú tạm một đêm",
  },
  {
    word: "trú",
    part_of_speech: "động từ",
    meaning: "lánh tạm vào nơi được che chắn: trú mưa * xuống hầm trú đạn",
    example: "trú mưa * xuống hầm trú đạn",
  },
  {
    word: "trù dập",
    part_of_speech: "động từ",
    meaning: "trù và vùi dập (nói khái quát): trù dập nhân viên",
    example: "trù dập nhân viên",
  },
  {
    word: "trú chân",
    part_of_speech: "động từ",
    meaning:
      '(khẩu ngữ) dừng lại nghỉ tạm, ở tạm, để rồi lại đi tiếp: "Em về dọn quán bán hàng, Để anh là khách đi đàng trú chân." (ca dao)',
    example:
      'Em về dọn quán bán hàng, Để anh là khách đi đàng trú chân." (ca dao)',
  },
  {
    word: "trù ẻo",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) trù cho ai đó gặp phải điều không may, theo quan niệm dân gian (nói khái quát): nói trù ẻo * đừng có trù ẻo!",
    example: "nói trù ẻo * đừng có trù ẻo!",
  },
  {
    word: "trụ cột",
    part_of_speech: "danh từ",
    meaning:
      "người, lực lượng làm chỗ dựa chủ yếu và vững chắc: trụ cột của gia đình",
    example: "trụ cột của gia đình",
  },
  {
    word: "trù mật",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) đông đúc, người ở dày đặc và làm ăn có vẻ thịnh vượng: thành phố trù mật",
    example: "thành phố trù mật",
  },
  {
    word: "trù phú",
    part_of_speech: "tính từ",
    meaning: "đông người ở và giàu có: vùng dân cư trù phú",
    example: "vùng dân cư trù phú",
  },
  {
    word: "trú ngụ",
    part_of_speech: "động từ",
    meaning:
      "ở, sinh sống tạm tại một nơi nào đó không phải quê hương mình: trú ngụ ở nhà người quen",
    example: "trú ngụ ở nhà người quen",
  },
  {
    word: "trù liệu",
    part_of_speech: "động từ",
    meaning:
      "tính toán, lo liệu trước: trù liệu mọi phương án cho kế hoạch tác chiến",
    example: "trù liệu mọi phương án cho kế hoạch tác chiến",
  },
  {
    word: "trụ sinh",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) kháng sinh: thuốc trụ sinh",
    example: "thuốc trụ sinh",
  },
  {
    word: "trú quán",
    part_of_speech: "danh từ",
    meaning:
      "nơi thường ở và đang ở của một người nào đó: khai rõ nguyên quán và trú quán",
    example: "khai rõ nguyên quán và trú quán",
  },
  {
    word: "trù tính",
    part_of_speech: "động từ",
    meaning:
      "tính toán trước một cách cụ thể: trù tính sản lượng lúa thu hoạch * trù tính các khoản mua vật liệu",
    example:
      "trù tính sản lượng lúa thu hoạch * trù tính các khoản mua vật liệu",
  },
  {
    word: "trú quân",
    part_of_speech: "động từ",
    meaning:
      "tạm dừng lại đóng quân để nghỉ ngơi trước khi hành quân tiếp: bãi trú quân của đơn vị * thay đổi địa điểm trú quân",
    example: "bãi trú quân của đơn vị * thay đổi địa điểm trú quân",
  },
  {
    word: "tru tréo",
    part_of_speech: "động từ",
    meaning:
      "kêu la, làm ầm lên một cách quá đáng: khóc tru tréo * tru tréo ầm ĩ",
    example: "khóc tru tréo * tru tréo ầm ĩ",
  },
  {
    word: "truất",
    part_of_speech: "động từ",
    meaning:
      "tước bỏ không cho giữ, không cho hưởng địa vị, chức vụ hay quyền lợi nào đó: truất ngôi hoàng hậu * bị truất quyền thi đấu",
    example: "truất ngôi hoàng hậu * bị truất quyền thi đấu",
  },
  {
    word: "trụ trì",
    part_of_speech: "động từ",
    meaning: "chủ trì, trông nom công việc ở chùa: sư cụ trụ trì ngôi chùa này",
    example: "sư cụ trụ trì ngôi chùa này",
  },
  {
    word: "trù trừ",
    part_of_speech: "động từ",
    meaning:
      "ở trạng thái còn e ngại, do dự, chưa đủ quyết tâm để quyết định ngay: cứ trù trừ mãi chưa chịu đi",
    example: "cứ trù trừ mãi chưa chịu đi",
  },
  {
    word: "truân chuyên",
    part_of_speech: "tính từ",
    meaning:
      '(văn chương) gian nan, vất vả: gặp bước truân chuyên * "Thuở trời đất nổi cơn gió bụi, Khách má hồng nhiều nỗi truân chuyên." (CPN)',
    example:
      'gặp bước truân chuyên * "Thuở trời đất nổi cơn gió bụi, Khách má hồng nhiều nỗi truân chuyên." (CPN)',
  },
  {
    word: "trục",
    part_of_speech: "danh từ",
    meaning:
      "thanh tròn quay được hoặc mang các vật quay: trục bánh xe * trục máy",
    example: "trục bánh xe * trục máy",
  },
  {
    word: "trục",
    part_of_speech: "danh từ",
    meaning: "trục lăn (nói tắt): mặt sân được lăn bằng trục gỗ",
    example: "mặt sân được lăn bằng trục gỗ",
  },
  {
    word: "trục",
    part_of_speech: "danh từ",
    meaning: "đường tưởng tượng quanh đó một thiên thể quay: trục Trái Đất",
    example: "trục Trái Đất",
  },
  {
    word: "trục",
    part_of_speech: "danh từ",
    meaning:
      "đường thẳng trên đó đã chọn một chiều gọi là chiều dương: trục toạ độ * trục đối xứng",
    example: "trục toạ độ * trục đối xứng",
  },
  {
    word: "trục",
    part_of_speech: "danh từ",
    meaning:
      "tuyến chính trong một hệ thống giao thông, thuỷ lợi, v.v.: trục đường bộ",
    example: "trục đường bộ",
  },
  {
    word: "trục",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) làm cho nhỏ đất hoặc cho hạt lúa rụng khỏi bông bằng trục lăn: trục đất * dùng trâu kéo xe trục lúa",
    example: "trục đất * dùng trâu kéo xe trục lúa",
  },
  {
    word: "trục",
    part_of_speech: "động từ",
    meaning:
      "nhấc vật nặng từ dưới lên, thường bằng máy hoặc bằng tời: trục tàu đắm",
    example: "trục tàu đắm",
  },
  {
    word: "trụ sở",
    part_of_speech: "danh từ",
    meaning:
      "nơi làm việc hằng ngày của một cơ quan: trụ sở uỷ ban xã * cơ quan đã chuyển trụ sở",
    example: "trụ sở uỷ ban xã * cơ quan đã chuyển trụ sở",
  },
  {
    word: "trù úm",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) trù người dưới quyền mình (nói khái quát): bị thủ trưởng trù úm",
    example: "bị thủ trưởng trù úm",
  },
  {
    word: "trúc",
    part_of_speech: "danh từ",
    meaning:
      "cây cùng họ với tre nhưng nhỏ hơn, gióng thẳng: mành trúc * chiếu trúc",
    example: "mành trúc * chiếu trúc",
  },
  {
    word: "trúc",
    part_of_speech: "danh từ",
    meaning: "(cũ, văn chương) ống sáo làm bằng trúc: tiếng tơ tiếng trúc",
    example: "tiếng tơ tiếng trúc",
  },
  {
    word: "trúc bâu",
    part_of_speech: "danh từ",
    meaning: "vải trắng mịn, khổ rộng: áo trúc bâu",
    example: "áo trúc bâu",
  },
  {
    word: "trục lợi",
    part_of_speech: "động từ",
    meaning:
      "kiếm lợi riêng một cách không chính đáng: đầu cơ trục lợi * lợi dụng quyền hạn để trục lợi",
    example: "đầu cơ trục lợi * lợi dụng quyền hạn để trục lợi",
  },
  {
    word: "trục lăn",
    part_of_speech: "danh từ",
    meaning:
      "khối hình trụ nặng dùng để lăn cho rụng hạt lúa hoặc làm nhỏ đất.",
    example: "cuốn giấy qua trục lăn",
  },
  {
    word: "trúc tơ",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) như tơ trúc: "Dựng cờ, nổi trống, lên đàng, Trúc tơ nổi trước, kiệu vàng theo sau." (TKiều)',
    example:
      'Dựng cờ, nổi trống, lên đàng, Trúc tơ nổi trước, kiệu vàng theo sau." (TKiều)',
  },
  {
    word: "trúc trắc",
    part_of_speech: "tính từ",
    meaning:
      "(lời văn) có nhiều chỗ đọc nghe không xuôi, không trôi chảy: câu thơ trúc trắc, khó đọc",
    example: "câu thơ trúc trắc, khó đọc",
  },
  {
    word: "trúc mai",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) cây trúc và cây mai, hai cây thường trồng hoặc vẽ cạnh nhau; dùng để chỉ tình nghĩa gắn bó thuỷ chung, khăng khít giữa bạn bè, vợ chồng: "Một nhà sum họp trúc mai, Càng sâu nghĩa bể, càng dài tình sông." (TKiều)',
    example:
      'Một nhà sum họp trúc mai, Càng sâu nghĩa bể, càng dài tình sông." (TKiều)',
  },
  {
    word: "trục xuất",
    part_of_speech: "động từ",
    meaning:
      "đuổi ra khỏi (thường là lãnh thổ một nước): phạm tội nên bị trục xuất về nước",
    example: "phạm tội nên bị trục xuất về nước",
  },
  {
    word: "trục trặc",
    part_of_speech: "",
    meaning:
      "(máy móc) ở trạng thái hoạt động không bình thường do có bộ phận bị sai, hỏng: máy móc trục trặc * trục trặc kĩ thuật",
    example: "máy móc trục trặc * trục trặc kĩ thuật",
  },
  {
    word: "trục trặc",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) ở tình trạng gặp khó khăn, vướng mắc, không được trôi chảy: công việc trục trặc * gặp trục trặc",
    example: "công việc trục trặc * gặp trục trặc",
  },
  {
    word: "trui",
    part_of_speech: "động từ",
    meaning: "(Phương ngữ) tôi (hợp kim): trui thép",
    example: "trui thép",
  },
  {
    word: "trụi lủi",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) trụi đến mức nhìn trơ ra không còn gì: bụi tre bị cháy trụi lủi * đầu cạo trụi lủi",
    example: "bụi tre bị cháy trụi lủi * đầu cạo trụi lủi",
  },
  {
    word: "trục vớt",
    part_of_speech: "động từ",
    meaning:
      "đưa vật nặng chìm dưới nước lên bằng máy móc, thiết bị: trục vớt tàu thuyền đắm",
    example: "trục vớt tàu thuyền đắm",
  },
  {
    word: "trui rèn",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) tôi luyện: được trui rèn trong chiến đấu",
    example: "được trui rèn trong chiến đấu",
  },
  {
    word: "trụi thui lủi",
    part_of_speech: "tính từ",
    meaning: "trụi hoàn toàn, không còn một tí nào: cái đầu cạo trụi thui lủi",
    example: "cái đầu cạo trụi thui lủi",
  },
  {
    word: "trụi",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái bị mất hết sạch lớp lá hoặc lông bao phủ, để trơ ra thân hoặc bộ phận của thân: cây trụi lá * con gà bị vặt trụi lông",
    example: "cây trụi lá * con gà bị vặt trụi lông",
  },
  {
    word: "trụi",
    part_of_speech: "tính từ",
    meaning:
      "hết mất sạch (cái có số lượng tương đối nhiều), chỉ còn trơ ra những gì không thể bị tác động đến: lửa thiêu trụi nhà cửa * làng mạc bị phá trụi * hái trụi quả",
    example: "lửa thiêu trụi nhà cửa * làng mạc bị phá trụi * hái trụi quả",
  },
  {
    word: "trụm",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) trọn, hết tất cả: chết trụm cả lũ * bắt trụm toán cướp",
    example: "chết trụm cả lũ * bắt trụm toán cướp",
  },
  {
    word: "trùm",
    part_of_speech: "danh từ",
    meaning: "người đứng đầu giáo dân trong một họ đạo: ông trùm họ đạo",
    example: "ông trùm họ đạo",
  },
  {
    word: "trùm",
    part_of_speech: "danh từ",
    meaning:
      "kẻ cầm đầu một nhóm, một tổ chức có mục đích xấu: trùm mật thám * trùm đế quốc * bắt được tên trùm buôn lậu",
    example: "trùm mật thám * trùm đế quốc * bắt được tên trùm buôn lậu",
  },
  {
    word: "trùm",
    part_of_speech: "động từ",
    meaning:
      "phủ lên trên và che kín các phía: đầu trùm khăn * trùm chăn kín mít * bóng tối trùm lên cảnh vật",
    example: "đầu trùm khăn * trùm chăn kín mít * bóng tối trùm lên cảnh vật",
  },
  {
    word: "trụi thùi lụi",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ, khẩu ngữ) như trụi thui lủi: nhà cửa cháy trụi thùi lụi hết trơn",
    example: "nhà cửa cháy trụi thùi lụi hết trơn",
  },
  {
    word: "trùm sỏ",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) như đầu sỏ: bắt được tên trùm sỏ",
    example: "bắt được tên trùm sỏ",
  },
  {
    word: "trúng",
    part_of_speech: "tính từ",
    meaning:
      "đúng vào một đối tượng, một chỗ nào đó (thường là mục tiêu): ném trúng đích * hòn đá rơi trúng chân * bách phát bách trúng",
    example: "ném trúng đích * hòn đá rơi trúng chân * bách phát bách trúng",
  },
  {
    word: "trúng",
    part_of_speech: "tính từ",
    meaning:
      "đúng với thực tế, với đòi hỏi cụ thể: đoán trúng ý bạn * nói trúng tim đen",
    example: "đoán trúng ý bạn * nói trúng tim đen",
  },
  {
    word: "trúng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) đúng vào dịp, vào thời gian nào đó một cách ngẫu nhiên: ra đi trúng hôm trời mưa * sinh trúng ngày quốc khánh",
    example: "ra đi trúng hôm trời mưa * sinh trúng ngày quốc khánh",
  },
  {
    word: "trúng",
    part_of_speech: "động từ",
    meaning:
      "bị tổn thương, tổn thất, do tác động của cái nhằm trực tiếp vào mình: bị trúng đạn * trúng thương * trúng phải kế hiểm",
    example: "bị trúng đạn * trúng thương * trúng phải kế hiểm",
  },
  {
    word: "trúng",
    part_of_speech: "động từ",
    meaning:
      "(cơ thể) chịu tác động làm tổn thương của chất ăn uống độc hại hoặc của yếu tố thời tiết bất thường: trúng độc * trúng gió",
    example: "trúng độc * trúng gió",
  },
  {
    word: "trúng",
    part_of_speech: "động từ",
    meaning:
      "đạt được một danh hiệu, một giải thưởng, v.v. nào đó do kết quả một sự tuyển chọn trong số đông, hoặc do một sự may mắn: trúng số độc đắc * trúng vào ban chấp hành chi hội",
    example: "trúng số độc đắc * trúng vào ban chấp hành chi hội",
  },
  {
    word: "trúng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) (làm ăn, buôn bán, v.v.) gặp may mắn, thuận lợi lớn và thu được kết quả tốt: đi buôn trúng lớn * trúng một quả đậm",
    example: "đi buôn trúng lớn * trúng một quả đậm",
  },
  {
    word: "trúm",
    part_of_speech: "danh từ",
    meaning:
      "đồ đan bằng tre, hình ống, hai đầu có hom, dùng để bắt lươn: đặt trúm bắt lươn",
    example: "đặt trúm bắt lươn",
  },
  {
    word: "trùm chăn",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) ví thái độ chính trị nằm yên không hoạt động, không hợp tác với các thế lực phản động đang cầm quyền nhưng cũng không dám chống lại: một trí thức trùm chăn",
    example: "một trí thức trùm chăn",
  },
  {
    word: "trũng",
    part_of_speech: "tính từ",
    meaning:
      "lõm sâu so với xung quanh: vùng đất trũng * chân ruộng trũng * thức nhiều, mắt trũng sâu",
    example: "vùng đất trũng * chân ruộng trũng * thức nhiều, mắt trũng sâu",
  },
  {
    word: "trung",
    part_of_speech: "tính từ",
    meaning:
      "ở vào khoảng giữa của hai cực, không to mà cũng không nhỏ, không cao mà cũng không thấp: hạng trung * thường thường bậc trung",
    example: "hạng trung * thường thường bậc trung",
  },
  {
    word: "trung",
    part_of_speech: "tính từ",
    meaning:
      "(viết hoa) (miền) ở khoảng giữa của nước Việt Nam, trong quan hệ với miền ở phía bắc (miền Bắc) và miền ở phía nam (miền Nam): người miền Trung",
    example: "người miền Trung",
  },
  {
    word: "trung",
    part_of_speech: "tính từ",
    meaning:
      '(cũ) một lòng một dạ với vua, theo đạo đức nho giáo: tôi trung * "Ta đây một tấm lòng trung, Quyết đem giãi trước mặt rồng có phen." (NĐM)',
    example:
      'tôi trung * "Ta đây một tấm lòng trung, Quyết đem giãi trước mặt rồng có phen." (NĐM)',
  },
  {
    word: "trung",
    part_of_speech: "tính từ",
    meaning: "trung thành (ng1; nói tắt): trung với nước, hiếu với dân",
    example: "trung với nước, hiếu với dân",
  },
  {
    word: "trùng",
    part_of_speech: "danh từ",
    meaning: "tên gọi chung một số động vật bậc thấp: tiếng trùng kêu ra rả",
    example: "tiếng trùng kêu ra rả",
  },
  {
    word: "trùng",
    part_of_speech: "danh từ",
    meaning:
      "vi trùng (nói tắt): trùng uốn ván * bị nhiễm trùng * thuốc sát trùng",
    example: "trùng uốn ván * bị nhiễm trùng * thuốc sát trùng",
  },
  {
    word: "trùng",
    part_of_speech: "danh từ",
    meaning:
      "con quỷ làm cho gia đình có người mới chết lại xảy ra cái chết tiếp theo, theo mê tín: yểm bùa trừ trùng * bị trùng bắt",
    example: "yểm bùa trừ trùng * bị trùng bắt",
  },
  {
    word: "trùng",
    part_of_speech: "động từ",
    meaning:
      "ở vào, xảy ra vào cùng một thời gian: ngày mồng một Tết trùng ngày chủ nhật * hai trận đấu bóng trùng giờ",
    example:
      "ngày mồng một Tết trùng ngày chủ nhật * hai trận đấu bóng trùng giờ",
  },
  {
    word: "trùng",
    part_of_speech: "động từ",
    meaning:
      "giống như nhau, tựa như là cái này lặp lại cái kia: những ý kiến trùng nhau * hai người trùng tên nhưng khác họ",
    example: "những ý kiến trùng nhau * hai người trùng tên nhưng khác họ",
  },
  {
    word: "trùng",
    part_of_speech: "danh từ",
    meaning:
      "(Văn chương) tầng, lớp giống nhau chồng chất lên nhau: mấy trùng mây xanh * vượt qua muôn trùng sóng cả",
    example: "mấy trùng mây xanh * vượt qua muôn trùng sóng cả",
  },
  {
    word: "trung bình cộng",
    part_of_speech: "danh từ",
    meaning:
      "số có được bằng cách lấy tổng tất cả các số trong tập hợp được xét rồi chia cho số các số ấy: số trung bình cộng * trung bình cộng của 2, 6, 7 là 5",
    example: "số trung bình cộng * trung bình cộng của 2, 6, 7 là 5",
  },
  {
    word: "trụng",
    part_of_speech: "động từ",
    meaning:
      "(Phương ngữ) nhúng vào nước sôi: trụng bát đĩa trước khi dùng * gà trụng nước sôi",
    example: "trụng bát đĩa trước khi dùng * gà trụng nước sôi",
  },
  {
    word: "trung bình",
    part_of_speech: "tính từ",
    meaning:
      "ở vào khoảng giữa của hai cực trong bậc thang đánh giá, không khá cũng không kém, không cao cũng không thấp: vóc người trung bình * học lực trung bình * năng suất đạt mức trung bình",
    example:
      "vóc người trung bình * học lực trung bình * năng suất đạt mức trung bình",
  },
  {
    word: "trung bình",
    part_of_speech: "tính từ",
    meaning:
      "tính tổng cộng lại và chia đều ra, lấy con số chung: lượng mưa trung bình hằng năm * vận tốc trung bình",
    example: "lượng mưa trung bình hằng năm * vận tốc trung bình",
  },
  {
    word: "trung bình nhân",
    part_of_speech: "danh từ",
    meaning:
      "số có được bằng cách lấy căn của tích tất cả các số trong tập hợp được xét (có bao nhiêu số thì lấy căn bậc bấy nhiêu): 6 là trung bình nhân của 4 và 9",
    example: "6 là trung bình nhân của 4 và 9",
  },
  {
    word: "trung cấp",
    part_of_speech: "tính từ",
    meaning:
      "thuộc cấp giữa, trên sơ cấp, dưới cao cấp: trường trung cấp sư phạm * sinh viên hệ trung cấp",
    example: "trường trung cấp sư phạm * sinh viên hệ trung cấp",
  },
  {
    word: "trung châu",
    part_of_speech: "danh từ",
    meaning:
      "miền ở khoảng giữa, không giáp núi và cũng không giáp biển: miền trung châu * các tỉnh trung châu Bắc Bộ",
    example: "miền trung châu * các tỉnh trung châu Bắc Bộ",
  },
  {
    word: "trung chuyển",
    part_of_speech: "động từ",
    meaning:
      "làm khâu trung gian, nhận để chuyển đi tiếp trong quá trình vận chuyển: trạm trung chuyển hàng hoá * đóng vai trò trung chuyển",
    example: "trạm trung chuyển hàng hoá * đóng vai trò trung chuyển",
  },
  {
    word: "trung cổ",
    part_of_speech: "danh từ",
    meaning:
      "(thường viết hoa) thời trung đại trong lịch sử châu Âu: những tàn dư thời Trung Cổ * xã hội thời Trung Cổ",
    example: "những tàn dư thời Trung Cổ * xã hội thời Trung Cổ",
  },
  {
    word: "trung dung",
    part_of_speech: "tính từ",
    meaning:
      "không thiên về một bên nào, mà luôn giữ thái độ đứng giữa, không thái quá cũng không bất cập trong quan hệ đối với người, với việc (một chủ trương của nho giáo): tư tưởng trung dung",
    example: "tư tưởng trung dung",
  },
  {
    word: "trùng dương",
    part_of_speech: "danh từ",
    meaning: "(văn chương) biển cả liên tiếp nhau: tàu vượt trùng dương",
    example: "tàu vượt trùng dương",
  },
  {
    word: "trúng cử",
    part_of_speech: "động từ",
    meaning: "được bầu trong một cuộc bầu cử: trúng cử tổng thống",
    example: "trúng cử tổng thống",
  },
  {
    word: "trung đại",
    part_of_speech: "danh từ",
    meaning:
      "thời đại giữa cổ đại và cận đại trong lịch sử, về cơ bản tương ứng với thời phong kiến: lịch sử trung đại * văn học trung đại Việt Nam",
    example: "lịch sử trung đại * văn học trung đại Việt Nam",
  },
  {
    word: "trung điểm",
    part_of_speech: "danh từ",
    meaning: "điểm giữa một đoạn thẳng: xác định trung điểm của đoạn AB",
    example: "xác định trung điểm của đoạn AB",
  },
  {
    word: "trung du",
    part_of_speech: "danh từ",
    meaning:
      "miền đất ở khoảng trung lưu của sông, giữa thượng du và hạ du: vùng trung du",
    example: "vùng trung du",
  },
  {
    word: "trung dũng",
    part_of_speech: "tính từ",
    meaning: "trung thành và dũng cảm: một chiến sĩ trung dũng, kiên cường",
    example: "một chiến sĩ trung dũng, kiên cường",
  },
  {
    word: "trùng điệp",
    part_of_speech: "tính từ",
    meaning:
      "liên tiếp nhau, hết lớp này đến lớp khác như không bao giờ hết: núi non trùng điệp * quân đi trùng điệp",
    example: "núi non trùng điệp * quân đi trùng điệp",
  },
  {
    word: "trung gian",
    part_of_speech: "tính từ",
    meaning:
      "ở khoảng giữa, có tính chất chuyển tiếp hoặc nối liền giữa hai cái gì: vị trí trung gian * cấp trung gian",
    example: "vị trí trung gian * cấp trung gian",
  },
  {
    word: "trung gian",
    part_of_speech: "tính từ",
    meaning:
      "hoặc d ở giữa, giữ vai trò môi giới trong quan hệ giữa hai bên: công ti trung gian * làm trung gian hoà giải",
    example: "công ti trung gian * làm trung gian hoà giải",
  },
  {
    word: "trúng giá",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ, khẩu ngữ) bán được với giá cao hơn hẳn mức bình thường: cà phê năm nay trúng giá",
    example: "cà phê năm nay trúng giá",
  },
  {
    word: "trung hậu",
    part_of_speech: "tính từ",
    meaning:
      "có những tình cảm tốt đẹp và chân thành, trước sau như một, trong quan hệ đối xử với mọi người: người phụ nữ trung hậu",
    example: "người phụ nữ trung hậu",
  },
  {
    word: "trúng độc",
    part_of_speech: "động từ",
    meaning:
      "ở trong tình trạng các hoạt động của cơ thể bị rối loạn do bị nhiễm độc: cơ thể bị trúng độc",
    example: "cơ thể bị trúng độc",
  },
  {
    word: "trung hoà",
    part_of_speech: "động từ",
    meaning: "làm mất hoặc giảm bớt tính acid hoặc base: phản ứng trung hoà",
    example: "phản ứng trung hoà",
  },
  {
    word: "trung hạn",
    part_of_speech: "tính từ",
    meaning:
      "có thời hạn trung bình (được quy định dành cho một loại hoạt động), phân biệt với ngắn hạn, dài hạn: vốn vay trung hạn * lãi suất trung hạn",
    example: "vốn vay trung hạn * lãi suất trung hạn",
  },
  {
    word: "trúng gió",
    part_of_speech: "động từ",
    meaning:
      "bị luồng gió đột ngột tác động đến cơ thể, làm sinh bệnh: bị trúng gió, phải nằm liệt giường",
    example: "bị trúng gió, phải nằm liệt giường",
  },
  {
    word: "trung hưng",
    part_of_speech: "",
    meaning:
      "(triều đại) hưng thịnh trở lại sau một thời kì suy yếu: dấy nghiệp trung hưng * nhà Lê trung hưng",
    example: "dấy nghiệp trung hưng * nhà Lê trung hưng",
  },
  {
    word: "trùng hợp",
    part_of_speech: "động từ",
    meaning:
      "xảy ra vào cùng một thời gian với nhau: một sự trùng hợp ngẫu nhiên",
    example: "một sự trùng hợp ngẫu nhiên",
  },
  {
    word: "trùng hợp",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) giống nhau, phù hợp với nhau: ý kiến hai người khá trùng hợp",
    example: "ý kiến hai người khá trùng hợp",
  },
  {
    word: "trung học",
    part_of_speech: "danh từ",
    meaning:
      "bậc học trong giáo dục phổ thông, gồm hai cấp trung học cơ sở và trung học phổ thông: học sinh trung học",
    example: "học sinh trung học",
  },
  {
    word: "trung học",
    part_of_speech: "danh từ",
    meaning:
      "trung học chuyên nghiệp (nói tắt): trường trung học kĩ thuật * tốt nghiệp trung học sư phạm",
    example: "trường trung học kĩ thuật * tốt nghiệp trung học sư phạm",
  },
  {
    word: "trùng khơi",
    part_of_speech: "danh từ",
    meaning: "(văn chương) biển xa mênh mông: hòn đảo nằm giữa trùng khơi",
    example: "hòn đảo nằm giữa trùng khơi",
  },
  {
    word: "trung kiên",
    part_of_speech: "tính từ",
    meaning:
      "trung thành và kiên định đến cùng, không có gì lay chuyển được: tấm lòng trung kiên * một chiến sĩ trung kiên",
    example: "tấm lòng trung kiên * một chiến sĩ trung kiên",
  },
  {
    word: "trùng lặp",
    part_of_speech: "động từ",
    meaning:
      "lặp lại một cách thừa, vô ích: bài viết có nhiều đoạn trùng lặp * bố trí công việc bị trùng lặp",
    example: "bài viết có nhiều đoạn trùng lặp * bố trí công việc bị trùng lặp",
  },
  {
    word: "trung lưu",
    part_of_speech: "danh từ",
    meaning:
      "đoạn sông giữa thượng lưu và hạ lưu, thường kể cả vùng phụ cận: vùng trung lưu sông Hồng",
    example: "vùng trung lưu sông Hồng",
  },
  {
    word: "trung lưu",
    part_of_speech: "danh từ",
    meaning:
      "tầng lớp giữa trong xã hội, dưới thượng lưu và trên hạ lưu: tầng lớp trung lưu",
    example: "tầng lớp trung lưu",
  },
  {
    word: "trúng mánh",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) (làm ăn) gặp may, thu khoản lợi lớn: làm ăn trúng mánh * trúng mánh liên tiếp nên giàu to",
    example: "làm ăn trúng mánh * trúng mánh liên tiếp nên giàu to",
  },
  {
    word: "trung lộ",
    part_of_speech: "danh từ",
    meaning:
      "khu vực ở ngay phía trước khung thành trên sân bóng đá: để mất bóng ở khu trung lộ * tấn công vào trung lộ",
    example: "để mất bóng ở khu trung lộ * tấn công vào trung lộ",
  },
  {
    word: "trung lập",
    part_of_speech: "tính từ",
    meaning:
      "đứng ở giữa hai bên đối lập, không theo hoặc không phụ thuộc vào bên nào: nước trung lập * chính sách ngoại giao trung lập",
    example: "nước trung lập * chính sách ngoại giao trung lập",
  },
  {
    word: "trung liệt",
    part_of_speech: "tính từ",
    meaning:
      'có tinh thần giữ trọn lòng trung nghĩa, dám khảng khái hi sinh: "Sống trung liệt, thác anh linh, Suối vàng thơm phách, mây xanh thoả hồn." (NĐM)',
    example:
      'Sống trung liệt, thác anh linh, Suối vàng thơm phách, mây xanh thoả hồn." (NĐM)',
  },
  {
    word: "trung nghĩa",
    part_of_speech: "tính từ",
    meaning:
      "hết mực trung thành, một lòng vì việc nghĩa: tấm lòng trung nghĩa * con người trung nghĩa",
    example: "tấm lòng trung nghĩa * con người trung nghĩa",
  },
  {
    word: "trung nông",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) nông dân có đủ ruộng đất, trâu bò, công cụ để tự mình lao động sinh sống, dưới chế độ cũ; phân biệt với phú nông, bần nông: xuất thân từ gia đình trung nông * thành phần trung nông",
    example: "xuất thân từ gia đình trung nông * thành phần trung nông",
  },
  {
    word: "trung nguyên",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) miền đồng bằng ở giữa một nước: vùng trung nguyên Tây Tạng",
    example: "vùng trung nguyên Tây Tạng",
  },
  {
    word: "trung nguyên",
    part_of_speech: "danh từ",
    meaning:
      "(thường viết hoa) rằm tháng bảy, một trong những ngày tết trong năm theo phong tục cổ truyền: tết Trung Nguyên",
    example: "tết Trung Nguyên",
  },
  {
    word: "trung niên",
    part_of_speech: "tính từ",
    meaning: "đã quá tuổi thanh niên, nhưng chưa đến tuổi già: tuổi trung niên",
    example: "tuổi trung niên",
  },
  {
    word: "trúng phóc",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ, khẩu ngữ) (nói, đoán) trúng ngay, đúng hoàn toàn: nói trúng phóc * đoán trúng phóc",
    example: "nói trúng phóc * đoán trúng phóc",
  },
  {
    word: "trúng phong",
    part_of_speech: "động từ",
    meaning:
      "từ dùng trong y học cổ truyền để chỉ trường hợp bị các bệnh như: xuất huyết não do cao huyết áp, co thắt mạch máu não, liệt dây thần kinh số 7 ngoại biên, v.v.: mặt tái như người trúng phong",
    example: "mặt tái như người trúng phong",
  },
  {
    word: "trung phong",
    part_of_speech: "danh từ",
    meaning:
      "cầu thủ thuộc hàng tiền đạo, thường hoạt động ở khu vực giữa bên sân đối phương: đội hình chơi với một trung phong",
    example: "đội hình chơi với một trung phong",
  },
  {
    word: "trùng phùng",
    part_of_speech: "động từ",
    meaning:
      "(văn chương) gặp lại nhau sau thời gian dài xa cách: buổi trùng phùng",
    example: "buổi trùng phùng",
  },
  {
    word: "trung sĩ",
    part_of_speech: "danh từ",
    meaning: "bậc quân hàm trên hạ sĩ, dưới thượng sĩ: trung sĩ pháo binh",
    example: "trung sĩ pháo binh",
  },
  {
    word: "trung tâm",
    part_of_speech: "danh từ",
    meaning:
      "nơi ở giữa của một vùng nào đó; thường là nơi dân cư tập trung đông đúc nhất: trung tâm thị xã * nhà hát nằm giữa trung tâm thành phố",
    example: "trung tâm thị xã * nhà hát nằm giữa trung tâm thành phố",
  },
  {
    word: "trung tâm",
    part_of_speech: "danh từ",
    meaning:
      "nơi tập trung những hoạt động trong một lĩnh vực nào đó, có ảnh hưởng lớn đối với những nơi khác: thủ đô là trung tâm chính trị, văn hoá của cả nước * trung tâm công nghiệp",
    example:
      "thủ đô là trung tâm chính trị, văn hoá của cả nước * trung tâm công nghiệp",
  },
  {
    word: "trung tâm",
    part_of_speech: "danh từ",
    meaning:
      "cơ quan phối hợp những hoạt động nghiên cứu hoặc dịch vụ trong một lĩnh vực nào đó: trung tâm ngoại ngữ * trung tâm xúc tiến việc làm",
    example: "trung tâm ngoại ngữ * trung tâm xúc tiến việc làm",
  },
  {
    word: "trung tâm",
    part_of_speech: "tính từ",
    meaning:
      "quan trọng nhất, có tác dụng quyết định, chi phối đối với những cái khác: nhân vật trung tâm của câu chuyện",
    example: "nhân vật trung tâm của câu chuyện",
  },
  {
    word: "trúng quả",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) may mắn có được món lợi lớn một cách dễ dàng (thường trong buôn bán, làm ăn): đi buôn trúng quả * trúng quả đậm",
    example: "đi buôn trúng quả * trúng quả đậm",
  },
  {
    word: "trung thần",
    part_of_speech: "danh từ",
    meaning: "(cũ) bề tôi trung thành với vua: bậc trung thần",
    example: "bậc trung thần",
  },
  {
    word: "trung thành",
    part_of_speech: "tính từ",
    meaning:
      "trước sau một lòng một dạ, giữ trọn niềm tin, giữ trọn những tình cảm gắn bó, những điều đã cam kết đối với ai hay cái gì: trung thành với tổ quốc * bề tôi trung thành",
    example: "trung thành với tổ quốc * bề tôi trung thành",
  },
  {
    word: "trung thành",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) đúng với sự thật vốn có, không thêm bớt, thay đổi: dịch trung thành với nguyên bản",
    example: "dịch trung thành với nguyên bản",
  },
  {
    word: "trúng thầu",
    part_of_speech: "động từ",
    meaning:
      "được lựa chọn để kí kết và thực hiện hợp đồng với bên mời thầu: trúng thầu dự án xây dựng khu đô thị mới",
    example: "trúng thầu dự án xây dựng khu đô thị mới",
  },
  {
    word: "trung thực",
    part_of_speech: "tính từ",
    meaning: "ngay thẳng, thật thà: con người trung thực",
    example: "con người trung thực",
  },
  {
    word: "trung thực",
    part_of_speech: "tính từ",
    meaning:
      "(phản ánh lại) đúng với sự thật, không làm sai lạc đi: báo cáo thiếu trung thực * âm thanh trung thực",
    example: "báo cáo thiếu trung thực * âm thanh trung thực",
  },
  {
    word: "trung thu",
    part_of_speech: "danh từ",
    meaning:
      "(thường viết hoa) rằm tháng tám; ngày tết của trẻ em, theo phong tục cổ truyền: tết Trung Thu * phá cỗ Trung Thu",
    example: "tết Trung Thu * phá cỗ Trung Thu",
  },
  {
    word: "trúng thực",
    part_of_speech: "động từ",
    meaning:
      "ở trong tình trạng các hoạt động tiêu hoá của cơ thể bị rối loạn do ăn uống phải thức ăn có chất độc hoặc kém phẩm chất: trúng thực vì ăn phải nấm độc",
    example: "trúng thực vì ăn phải nấm độc",
  },
  {
    word: "trùng trục",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) từ gợi tả dáng vẻ to tròn quá cỡ, trông hơi thô: béo tròn trùng trục",
    example: "béo tròn trùng trục",
  },
  {
    word: "trùng trục",
    part_of_speech: "tính từ",
    meaning:
      "ở trần hoàn toàn, để lộ ra thân hình béo, khoẻ: mình trần trùng trục",
    example: "mình trần trùng trục",
  },
  {
    word: "trung tín",
    part_of_speech: "tính từ",
    meaning: "(cũ) trung thành với lời hứa, đáng tin cậy: một lòng trung tín",
    example: "một lòng trung tín",
  },
  {
    word: "trùng trùng",
    part_of_speech: "tính từ",
    meaning:
      "liên tiếp nhau, chồng tiếp lên nhau, hết lớp này đến lớp khác, tựa như không bao giờ hết: sóng biển trùng trùng",
    example: "sóng biển trùng trùng",
  },
  {
    word: "trung tu",
    part_of_speech: "động từ",
    meaning: "sửa chữa vừa: trung tu xe máy",
    example: "trung tu xe máy",
  },
  {
    word: "trung trực",
    part_of_speech: "tính từ",
    meaning:
      "vuông góc với một đoạn thẳng tại điểm giữa của đoạn thẳng ấy: đường trung trực * mặt phẳng trung trực",
    example: "đường trung trực * mặt phẳng trung trực",
  },
  {
    word: "trùng tu",
    part_of_speech: "động từ",
    meaning:
      "tu sửa lại công trình kiến trúc: trùng tu ngôi chùa cổ * cung điện được trùng tu nhiều lần",
    example: "trùng tu ngôi chùa cổ * cung điện được trùng tu nhiều lần",
  },
  {
    word: "trúng tủ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) trúng vào những gì mình đã đoán trước và đã đặc biệt học kĩ, nắm vững để đi thi: đề thi ra trúng tủ",
    example: "đề thi ra trúng tủ",
  },
  {
    word: "trúng tủ",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) trúng vào những điều mình giữ riêng cho mình, tưởng không ai biết và cũng không muốn cho ai biết: nói trúng tủ làm nó giật mình",
    example: "nói trúng tủ làm nó giật mình",
  },
  {
    word: "trung tuyến",
    part_of_speech: "danh từ",
    meaning:
      "khu vực nối liền giữa hậu phương và tiền tuyến: chuyển thương binh về trung tuyến",
    example: "chuyển thương binh về trung tuyến",
  },
  {
    word: "trung tuyến",
    part_of_speech: "danh từ",
    meaning: "khu vực giữa của sân bóng đá: làm chủ khu trung tuyến",
    example: "làm chủ khu trung tuyến",
  },
  {
    word: "trung tuần",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian mười ngày giữa tháng; phân biệt với thượng tuần, hạ tuần: hội nghị tổ chức vào trung tuần tháng tám",
    example: "hội nghị tổ chức vào trung tuần tháng tám",
  },
  {
    word: "trung ương",
    part_of_speech: "tính từ",
    meaning:
      "thuộc bộ phận chính, quan trọng nhất, có tác dụng chi phối các bộ phận xung quanh có liên quan: thần kinh trung ương * bộ xử lí trung ương",
    example: "thần kinh trung ương * bộ xử lí trung ương",
  },
  {
    word: "trung ương",
    part_of_speech: "tính từ",
    meaning:
      "thuộc cấp lãnh đạo cao nhất, chung cho cả nước: ban chấp hành trung ương * cơ quan trung ương",
    example: "ban chấp hành trung ương * cơ quan trung ương",
  },
  {
    word: "trung ương",
    part_of_speech: "tính từ",
    meaning:
      "thuộc quyền quản lí của các cơ quan trung ương: nhà hát kịch trung ương * ngân hàng trung ương",
    example: "nhà hát kịch trung ương * ngân hàng trung ương",
  },
  {
    word: "trung ương",
    part_of_speech: "danh từ",
    meaning:
      "(thường viết hoa) ban chấp hành trung ương, uỷ ban trung ương, hoặc cơ quan trung ương (nói tắt); cấp lãnh đạo cao nhất của cả nước: thành phố trực thuộc Trung ương",
    example: "thành phố trực thuộc Trung ương",
  },
  {
    word: "trúng tuyển",
    part_of_speech: "động từ",
    meaning: "thi đỗ: trúng tuyển đại học",
    example: "trúng tuyển đại học",
  },
  {
    word: "trúng tuyển",
    part_of_speech: "động từ",
    meaning: "được tuyển: trúng tuyển nghĩa vụ quân sự",
    example: "trúng tuyển nghĩa vụ quân sự",
  },
  {
    word: "truông",
    part_of_speech: "danh từ",
    meaning:
      'vùng đất hoang, rộng, có nhiều cây cỏ: "Thương anh em cũng muốn vô, Sợ truông nhà Hồ, sợ phá Tam Giang." (ca dao)',
    example:
      'Thương anh em cũng muốn vô, Sợ truông nhà Hồ, sợ phá Tam Giang." (ca dao)',
  },
  {
    word: "truồng",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái không mặc quần, mặc váy, để lộ cả phần nửa dưới của cơ thể: để truồng * cởi truồng",
    example: "để truồng * cởi truồng",
  },
  {
    word: "truy",
    part_of_speech: "động từ",
    meaning: "đuổi theo, không để cho thoát: truy địch * truy bắt tội phạm",
    example: "truy địch * truy bắt tội phạm",
  },
  {
    word: "truy",
    part_of_speech: "động từ",
    meaning:
      "tìm, hỏi, xét cho kì ra sự thật về một sự việc nào đó: truy nguyên nhân * truy cho ra thủ phạm",
    example: "truy nguyên nhân * truy cho ra thủ phạm",
  },
  {
    word: "truy",
    part_of_speech: "động từ",
    meaning:
      "hỏi bài nhau để xem đã thuộc chưa (một hình thức học sinh giúp nhau học tập): giờ truy bài",
    example: "giờ truy bài",
  },
  {
    word: "truy",
    part_of_speech: "động từ",
    meaning:
      "từ biểu thị hành động nói đến là việc lẽ ra trước đây đã phải làm: truy nộp sản lượng * truy tặng danh hiệu anh hùng",
    example: "truy nộp sản lượng * truy tặng danh hiệu anh hùng",
  },
  {
    word: "trút",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ) tê tê: vảy trút",
    example: "vảy trút",
  },
  {
    word: "trút",
    part_of_speech: "động từ",
    meaning:
      "làm cho thoát ra ngoài vật chứa và chảy xuống, rơi xuống nhiều bằng cách nghiêng vật chứa: trút bạc vào túi * mưa như trút nước",
    example: "trút bạc vào túi * mưa như trút nước",
  },
  {
    word: "trút",
    part_of_speech: "động từ",
    meaning:
      "làm cho thoát ra, rời ra khỏi người, không mang trong mình hoặc trên người nữa (thường nói về cái trừu tượng): trút bầu tâm sự * trút hơi thở cuối cùng",
    example: "trút bầu tâm sự * trút hơi thở cuối cùng",
  },
  {
    word: "truy cập",
    part_of_speech: "động từ",
    meaning:
      "tác động tới dữ liệu hoặc các lệnh chương trình của một ổ đĩa, một máy tính khác nằm trong mạng để thu được thông tin cần thiết: truy cập Internet * truy cập ổ đĩa cứng * tăng tốc độ truy cập",
    example: "truy cập Internet * truy cập ổ đĩa cứng * tăng tốc độ truy cập",
  },
  {
    word: "truy bức",
    part_of_speech: "động từ",
    meaning:
      "dồn ép, tác động mạnh đến tinh thần, buộc phải nhận: truy bức con nợ * bị truy bức, bắt phải khai",
    example: "truy bức con nợ * bị truy bức, bắt phải khai",
  },
  {
    word: "truy cứu",
    part_of_speech: "động từ",
    meaning:
      "tìm hiểu đầy đủ các cứ liệu, các tình tiết về một vụ phạm pháp: bị truy cứu trách nhiệm hình sự",
    example: "bị truy cứu trách nhiệm hình sự",
  },
  {
    word: "truy đuổi",
    part_of_speech: "động từ",
    meaning: "đuổi bắt ráo riết: truy đuổi quân giặc * bị truy đuổi ráo riết",
    example: "truy đuổi quân giặc * bị truy đuổi ráo riết",
  },
  {
    word: "truy điệu",
    part_of_speech: "động từ",
    meaning:
      "(làm lễ) tỏ lòng thương tiếc, tưởng nhớ công lao người đã chết: lễ truy điệu được tổ chức trang trọng",
    example: "lễ truy điệu được tổ chức trang trọng",
  },
  {
    word: "truy hoan",
    part_of_speech: "động từ",
    meaning:
      '(cũ) theo đuổi thú ăn chơi, hưởng lạc: cảnh truy hoan * "Miệt mài trong cuộc truy hoan, Càng quen thuộc nết, càng dan díu tình." (TKiều)',
    example:
      'cảnh truy hoan * "Miệt mài trong cuộc truy hoan, Càng quen thuộc nết, càng dan díu tình." (TKiều)',
  },
  {
    word: "truy hỏi",
    part_of_speech: "động từ",
    meaning:
      "hỏi vặn, hỏi ráo riết, buộc phải nói ra sự thật: bị truy hỏi gắt gao",
    example: "bị truy hỏi gắt gao",
  },
  {
    word: "truy ép",
    part_of_speech: "động từ",
    meaning: "như truy bức: truy ép, bắt phải khai",
    example: "truy ép, bắt phải khai",
  },
  {
    word: "truy hoàn",
    part_of_speech: "động từ",
    meaning: "(cũ, hiếm) như bồi hoàn: truy hoàn công quỹ",
    example: "truy hoàn công quỹ",
  },
  {
    word: "truỵ lạc",
    part_of_speech: "",
    meaning:
      "sa ngã vào lối sống ăn chơi thấp hèn, xấu xa: lối sống truỵ lạc * bị lôi kéo vào vòng truỵ lạc",
    example: "lối sống truỵ lạc * bị lôi kéo vào vòng truỵ lạc",
  },
  {
    word: "truy hô",
    part_of_speech: "động từ",
    meaning: "vừa rượt đuổi vừa hô hoán: thoáng thấy kẻ trộm, vội truy hô lên",
    example: "thoáng thấy kẻ trộm, vội truy hô lên",
  },
  {
    word: "truy nhận",
    part_of_speech: "động từ",
    meaning:
      "công nhận một danh hiệu nào đó cho người đã chết: truy nhận danh hiệu anh hùng * được truy nhận là liệt sĩ",
    example: "truy nhận danh hiệu anh hùng * được truy nhận là liệt sĩ",
  },
  {
    word: "truy nguyên",
    part_of_speech: "động từ",
    meaning:
      "(cũ) tìm đến tận căn nguyên, gốc rễ của sự việc: truy nguyên vụ tham ô",
    example: "truy nguyên vụ tham ô",
  },
  {
    word: "truy kích",
    part_of_speech: "động từ",
    meaning:
      "đuổi đánh quân địch đang rút chạy: thừa thắng, truy kích đến cùng * cuộc truy kích",
    example: "thừa thắng, truy kích đến cùng * cuộc truy kích",
  },
  {
    word: "truy nã",
    part_of_speech: "động từ",
    meaning:
      "lùng bắt ráo riết kẻ phạm tội đang lẩn trốn: phát lệnh truy nã * đối tượng truy nã nguy hiểm",
    example: "phát lệnh truy nã * đối tượng truy nã nguy hiểm",
  },
  {
    word: "truy nhập",
    part_of_speech: "động từ",
    meaning: "như truy cập (nhưng ít dùng hơn): truy nhập mạng",
    example: "truy nhập mạng",
  },
  {
    word: "truy lĩnh",
    part_of_speech: "động từ",
    meaning:
      "lĩnh hoặc lĩnh thêm khoản tiền lẽ ra phải được lĩnh từ trước: truy lĩnh tiền lương của tháng trước * truy lĩnh tiền phụ cấp",
    example: "truy lĩnh tiền lương của tháng trước * truy lĩnh tiền phụ cấp",
  },
  {
    word: "truy sát",
    part_of_speech: "động từ",
    meaning:
      '(cũ) truy đuổi ráo riết để giết hại: "Quan quân truy sát đuổi dài, Hằm hằm sát khí, ngất trời ai đang!" (TKiều)',
    example:
      'Quan quân truy sát đuổi dài, Hằm hằm sát khí, ngất trời ai đang!" (TKiều)',
  },
  {
    word: "truỵ tim mạch",
    part_of_speech: "động từ",
    meaning:
      "(tình trạng) suy sụp hệ tuần hoàn, tim đập nhanh, khả năng đưa máu đến các bộ phận cơ thể kém, mạch nhanh, yếu, rời rạc: hội chứng truỵ tim mạch",
    example: "hội chứng truỵ tim mạch",
  },
  {
    word: "truy tặng",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) tặng thưởng cho người đã chết: truy tặng danh hiệu anh hùng * truy tặng huân chương",
    example: "truy tặng danh hiệu anh hùng * truy tặng huân chương",
  },
  {
    word: "truy lùng",
    part_of_speech: "động từ",
    meaning:
      "đuổi theo và lùng bắt: truy lùng tội phạm * bị địch truy lùng ráo riết",
    example: "truy lùng tội phạm * bị địch truy lùng ráo riết",
  },
  {
    word: "truy tìm",
    part_of_speech: "động từ",
    meaning:
      "dò xét tìm cho ra: truy tìm tung tích * truy tìm nguyên nhân vụ việc",
    example: "truy tìm tung tích * truy tìm nguyên nhân vụ việc",
  },
  {
    word: "truy quét",
    part_of_speech: "động từ",
    meaning:
      "truy lùng nhằm tiêu diệt sạch trên một phạm vi rộng: truy quét các tụ điểm ma tuý",
    example: "truy quét các tụ điểm ma tuý",
  },
  {
    word: "truỵ thai",
    part_of_speech: "động từ",
    meaning: "có hiện tượng đe doạ bị sẩy thai: ngã truỵ thai",
    example: "ngã truỵ thai",
  },
  {
    word: "truy thu",
    part_of_speech: "động từ",
    meaning:
      "thu hoặc thu thêm khoản tiền lẽ ra đã phải nộp trước đó: truy thu nợ đọng * truy thu tiền thuế",
    example: "truy thu nợ đọng * truy thu tiền thuế",
  },
  {
    word: "truy xét",
    part_of_speech: "động từ",
    meaning: "xét hỏi đến cùng để tìm cho ra: truy xét nghi can",
    example: "truy xét nghi can",
  },
  {
    word: "truyền",
    part_of_speech: "động từ",
    meaning:
      "chuyển cái mình đang nắm giữ cho người khác, thường thuộc thế hệ sau: truyền nghề * truyền ngôi báu * truyền kiến thức cho học sinh",
    example: "truyền nghề * truyền ngôi báu * truyền kiến thức cho học sinh",
  },
  {
    word: "truyền",
    part_of_speech: "động từ",
    meaning:
      "(hiện tượng vật lí) đưa dẫn từ nơi này đến nơi khác: nhiệt truyền từ vật nóng sang vật lạnh * vật truyền điện",
    example: "nhiệt truyền từ vật nóng sang vật lạnh * vật truyền điện",
  },
  {
    word: "truyền",
    part_of_speech: "động từ",
    meaning:
      "lan rộng ra hoặc làm lan rộng ra cho nhiều người, nhiều nơi biết: truyền tin * câu chuyện truyền ra khắp vùng",
    example: "truyền tin * câu chuyện truyền ra khắp vùng",
  },
  {
    word: "truyền",
    part_of_speech: "động từ",
    meaning:
      "đưa vào trong cơ thể người khác: truyền nước * truyền máu * muỗi truyền vi trùng sốt rét",
    example: "truyền nước * truyền máu * muỗi truyền vi trùng sốt rét",
  },
  {
    word: "truyền",
    part_of_speech: "động từ",
    meaning: "(cũ) ra lệnh: vua truyền mở hội * truyền cho vào hầu",
    example: "vua truyền mở hội * truyền cho vào hầu",
  },
  {
    word: "truy tố",
    part_of_speech: "động từ",
    meaning:
      "đưa người coi là phạm tội ra toà để xét xử: bị truy tố về tội lừa đảo",
    example: "bị truy tố về tội lừa đảo",
  },
  {
    word: "truy vấn",
    part_of_speech: "động từ",
    meaning: "(hiếm) truy hỏi: bị truy vấn gắt gao",
    example: "bị truy vấn gắt gao",
  },
  {
    word: "truy xuất",
    part_of_speech: "động từ",
    meaning:
      "lấy thông tin cần thiết thông qua máy tính cá nhân: truy xuất dữ liệu * truy xuất thông tin từ Internet",
    example: "truy xuất dữ liệu * truy xuất thông tin từ Internet",
  },
  {
    word: "truyện",
    part_of_speech: "danh từ",
    meaning:
      "tác phẩm văn học miêu tả tính cách nhân vật và diễn biến của sự kiện thông qua lời kể của nhà văn: sáng tác truyện * truyện trinh thám",
    example: "sáng tác truyện * truyện trinh thám",
  },
  {
    word: "truyện cổ",
    part_of_speech: "danh từ",
    meaning:
      "sáng tác văn học thuộc loại tự sự, có từ thời cổ: truyện cổ Grim * truyện cổ Trung Hoa",
    example: "truyện cổ Grim * truyện cổ Trung Hoa",
  },
  {
    word: "truyền cảm",
    part_of_speech: "động từ",
    meaning:
      "làm cho người nghe, người xem, người đọc thấy rung động trong lòng, có những cảm xúc mạnh mẽ: giọng đọc truyền cảm * bài thơ có sức truyền cảm mạnh mẽ",
    example: "giọng đọc truyền cảm * bài thơ có sức truyền cảm mạnh mẽ",
  },
  {
    word: "truyền bá",
    part_of_speech: "động từ",
    meaning:
      "phổ biến rộng rãi cho nhiều người, nhiều nơi: truyền bá tư tưởng mới * truyền bá tri thức khoa học",
    example: "truyền bá tư tưởng mới * truyền bá tri thức khoa học",
  },
  {
    word: "truyền đạo",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) truyền giáo: nhà truyền đạo",
    example: "nhà truyền đạo",
  },
  {
    word: "truyền khẩu",
    part_of_speech: "động từ",
    meaning:
      "truyền lại bằng lời, không có văn bản viết, từ người này sang người khác, từ đời này sang đời khác: văn học truyền khẩu * bài thơ được truyền khẩu trong giới sinh viên",
    example:
      "văn học truyền khẩu * bài thơ được truyền khẩu trong giới sinh viên",
  },
  {
    word: "truyền giáo",
    part_of_speech: "động từ",
    meaning:
      "truyền bá tôn giáo (thường nói về đạo Kitô): nhà truyền giáo * đi truyền giáo khắp nơi",
    example: "nhà truyền giáo * đi truyền giáo khắp nơi",
  },
  {
    word: "truyền đạt",
    part_of_speech: "động từ",
    meaning:
      "thông báo lại, truyền lại (ý kiến, chỉ thị, nghị quyết của cấp trên) cho người khác nắm được mà thực hiện: truyền đạt nghị quyết * truyền đạt mệnh lệnh của cấp trên",
    example: "truyền đạt nghị quyết * truyền đạt mệnh lệnh của cấp trên",
  },
  {
    word: "truyền đạt",
    part_of_speech: "động từ",
    meaning:
      "truyền thụ lại, thường bằng lời nói trực tiếp: truyền đạt kiến thức cho học sinh",
    example: "truyền đạt kiến thức cho học sinh",
  },
  {
    word: "truyền đơn",
    part_of_speech: "danh từ",
    meaning:
      "tờ giấy nhỏ có nội dung tuyên truyền đấu tranh chính trị, dùng để phân phát rộng rãi: tờ truyền đơn * rải truyền đơn",
    example: "tờ truyền đơn * rải truyền đơn",
  },
  {
    word: "truyền hình",
    part_of_speech: "động từ",
    meaning:
      "truyền hình ảnh, thường đồng thời có cả âm thanh, đi xa bằng radio hoặc bằng đường dây: truyền hình trực tiếp trận bóng đá",
    example: "truyền hình trực tiếp trận bóng đá",
  },
  {
    word: "truyền hình",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) vô truyến truyền hình (nói tắt): bộ phim đã được phát trên truyền hình",
    example: "bộ phim đã được phát trên truyền hình",
  },
  {
    word: "truyền kiếp",
    part_of_speech: "tính từ",
    meaning:
      "rất lâu đời, tựa như truyền lại từ kiếp này sang kiếp khác, mãi mãi vẫn còn (chỉ nói về cái không hay): mối thù truyền kiếp * món nợ truyền kiếp",
    example: "mối thù truyền kiếp * món nợ truyền kiếp",
  },
  {
    word: "truyện nôm",
    part_of_speech: "danh từ",
    meaning:
      "truyện dài viết bằng chữ Nôm, thường theo thể thơ lục bát: truyện nôm khuyết danh",
    example: "truyện nôm khuyết danh",
  },
  {
    word: "truyền tải",
    part_of_speech: "động từ",
    meaning:
      "truyền đi qua phương tiện nào đó (nói khái quát): đường dây truyền tải điện * truyền tải thông tin",
    example: "đường dây truyền tải điện * truyền tải thông tin",
  },
  {
    word: "truyền miệng",
    part_of_speech: "động từ",
    meaning:
      "truyền lại bằng lời, không có văn bản viết, từ người này sang người khác, từ đời này sang đời khác: văn học truyền khẩu * bài thơ được truyền khẩu trong giới sinh viên",
    example:
      "văn học truyền khẩu * bài thơ được truyền khẩu trong giới sinh viên",
  },
  {
    word: "truyền nhiễm",
    part_of_speech: "động từ",
    meaning: "lây (nói khái quát): bệnh truyền nhiễm",
    example: "bệnh truyền nhiễm",
  },
  {
    word: "truyền thống",
    part_of_speech: "danh từ",
    meaning:
      "thói quen hình thành đã lâu đời trong lối sống và nếp nghĩ, được truyền lại từ thế hệ này sang thế hệ khác: truyền thống yêu nước * gia đình có truyền thống hiếu học",
    example: "truyền thống yêu nước * gia đình có truyền thống hiếu học",
  },
  {
    word: "truyền thống",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất truyền thống, được truyền lại từ các đời trước: trang phục truyền thống * đám cưới được cử hành theo nghi lễ truyền thống",
    example:
      "trang phục truyền thống * đám cưới được cử hành theo nghi lễ truyền thống",
  },
  {
    word: "truyền thanh",
    part_of_speech: "động từ",
    meaning:
      "truyền âm thanh đi xa bằng radio hoặc bằng đường dây: đài truyền thanh * loa truyền thanh",
    example: "đài truyền thanh * loa truyền thanh",
  },
  {
    word: "truyền thụ",
    part_of_speech: "động từ",
    meaning:
      "(cũ) truyền lại tri thức, kinh nghiệm cho người nào đó: truyền thụ nghề thuốc cho con * truyền thụ tri thức cho học sinh",
    example: "truyền thụ nghề thuốc cho con * truyền thụ tri thức cho học sinh",
  },
  {
    word: "truyền thông",
    part_of_speech: "động từ",
    meaning:
      "(kĩ thuật) truyền dữ liệu theo những quy tắc và cách thức nhất định: công nghệ truyền thông",
    example: "công nghệ truyền thông",
  },
  {
    word: "truyền thông",
    part_of_speech: "động từ",
    meaning:
      "thông tin và tuyên truyền, nói chung: phương tiện truyền thông * mở rộng mạng lưới truyền thông đến từng cơ sở",
    example:
      "phương tiện truyền thông * mở rộng mạng lưới truyền thông đến từng cơ sở",
  },
  {
    word: "trữ",
    part_of_speech: "động từ",
    meaning:
      "cất, chứa vào một chỗ để dành sẵn cho lúc cần: bể trữ nước * kho trữ thóc * mua trữ đồ ăn",
    example: "bể trữ nước * kho trữ thóc * mua trữ đồ ăn",
  },
  {
    word: "truyền tụng",
    part_of_speech: "động từ",
    meaning:
      "truyền miệng cho nhau với lòng ngưỡng mộ: bài thơ được nhiều người truyền tụng",
    example: "bài thơ được nhiều người truyền tụng",
  },
  {
    word: "trừ bỏ",
    part_of_speech: "động từ",
    meaning:
      "làm cho mất hẳn đi, cho không còn tồn tại để gây tác động xấu được nữa (nói khái quát): trừ bỏ một hủ tục",
    example: "trừ bỏ một hủ tục",
  },
  {
    word: "trừ",
    part_of_speech: "động từ",
    meaning:
      "bớt đi một phần khỏi tổng số: 4 trừ 2 còn 2 * làm hỏng bị trừ tiền công",
    example: "4 trừ 2 còn 2 * làm hỏng bị trừ tiền công",
  },
  {
    word: "trừ",
    part_of_speech: "động từ",
    meaning:
      "để riêng ra, không kể, không tính đến trong đó: mọi người đều đã đi cả, trừ nó * làm việc cả tuần, trừ chủ nhật",
    example: "mọi người đều đã đi cả, trừ nó * làm việc cả tuần, trừ chủ nhật",
  },
  {
    word: "trừ",
    part_of_speech: "động từ",
    meaning:
      "làm cho mất đi, không còn tồn tại để gây hại được nữa: trừ giặc giã * trừ hậu hoạ * thuốc trừ sâu",
    example: "trừ giặc giã * trừ hậu hoạ * thuốc trừ sâu",
  },
  {
    word: "trừ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) (lấy cái khác nào đó) thay cho: ăn sắn trừ cơm * bắt đồ đạc trừ nợ",
    example: "ăn sắn trừ cơm * bắt đồ đạc trừ nợ",
  },
  {
    word: "truyền thuyết",
    part_of_speech: "danh từ",
    meaning:
      "truyện dân gian truyền miệng về các nhân vật và sự kiện có liên quan đến lịch sử, thường mang nhiều yếu tố thần kì: truyền thuyết các vua Hùng * truyện truyền thuyết",
    example: "truyền thuyết các vua Hùng * truyện truyền thuyết",
  },
  {
    word: "truyền thần",
    part_of_speech: "động từ",
    meaning:
      "(vẽ, chụp ảnh) miêu tả chân dung một người như thật, như lột tả được cả thần sắc: vẽ truyền thần * bức ảnh truyền thần",
    example: "vẽ truyền thần * bức ảnh truyền thần",
  },
  {
    word: "trừ bì",
    part_of_speech: "động từ",
    meaning: "trừ bớt đi trọng lượng của bao bì: một bao là 50 cân chưa trừ bì",
    example: "một bao là 50 cân chưa trừ bì",
  },
  {
    word: "trự",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) đồng tiền: hết sạch, không còn lấy một trự",
    example: "hết sạch, không còn lấy một trự",
  },
  {
    word: "trừ bị",
    part_of_speech: "tính từ",
    meaning:
      "dành sẵn để khi cần là có ngay (thường nói về binh lính): quân trừ bị",
    example: "quân trừ bị",
  },
  {
    word: "trừ gian",
    part_of_speech: "động từ",
    meaning: "diệt trừ kẻ gian: công tác trừ gian",
    example: "công tác trừ gian",
  },
  {
    word: "trừ bữa",
    part_of_speech: "động từ",
    meaning: "(ăn thức gì đó) thay cho bữa cơm hằng ngày: ăn khoai trừ bữa",
    example: "ăn khoai trừ bữa",
  },
  {
    word: "trứ danh",
    part_of_speech: "tính từ",
    meaning:
      "rất nổi tiếng, ai cũng biết: hoạ sĩ trứ danh * cuốn tiểu thuyết trứ danh",
    example: "hoạ sĩ trứ danh * cuốn tiểu thuyết trứ danh",
  },
  {
    word: "trừ hao",
    part_of_speech: "động từ",
    meaning:
      "trừ trước đi phần có thể bị hao hụt, mất mát: cân dôi ra để trừ hao",
    example: "cân dôi ra để trừ hao",
  },
  {
    word: "trữ kim",
    part_of_speech: "danh từ",
    meaning:
      "vàng dự trữ tại ngân hàng phát hành để bảo đảm cho tiền tệ được ổn định và làm quỹ dự trữ cho thanh toán quốc tế: quỹ trữ kim",
    example: "quỹ trữ kim",
  },
  {
    word: "trữ lượng",
    part_of_speech: "danh từ",
    meaning:
      "lượng khoáng sản hoặc nói chung những gì có ích trong thiên nhiên mà còn chưa khai thác, dự tính có trong một vùng: trữ lượng dầu khí * trữ lượng vàng",
    example: "trữ lượng dầu khí * trữ lượng vàng",
  },
  {
    word: "trừ diệt",
    part_of_speech: "động từ",
    meaning: "(hiếm) như diệt trừ: trừ diệt sâu bọ",
    example: "trừ diệt sâu bọ",
  },
  {
    word: "trừ khử",
    part_of_speech: "động từ",
    meaning: "diệt trừ để loại bỏ hẳn đi: trừ khử tên gian tặc",
    example: "trừ khử tên gian tặc",
  },
  {
    word: "trực ban",
    part_of_speech: "động từ",
    meaning:
      "trực theo phiên làm việc để bảo đảm công tác liên tục: sổ trực ban * làm nhiệm vụ trực ban",
    example: "sổ trực ban * làm nhiệm vụ trực ban",
  },
  {
    word: "trực ban",
    part_of_speech: "danh từ",
    meaning: "người làm nhiệm vụ trực ban: gặp trực ban của công trường",
    example: "gặp trực ban của công trường",
  },
  {
    word: "trừ phi",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là một giả thiết mà chỉ trong trường hợp đó điều được nói đến mới không còn là đúng nữa: tôi sẽ đến, trừ phi trời mưa * bệnh nhân khó qua khỏi, trừ phi có thuốc tiên",
    example:
      "tôi sẽ đến, trừ phi trời mưa * bệnh nhân khó qua khỏi, trừ phi có thuốc tiên",
  },
  {
    word: "trực",
    part_of_speech: "động từ",
    meaning:
      "có mặt thường xuyên tại nơi và trong thời gian quy định để giải quyết những việc có thể xảy ra: thay phiên trực * bác sĩ trực đêm * trực bên giường bệnh",
    example: "thay phiên trực * bác sĩ trực đêm * trực bên giường bệnh",
  },
  {
    word: "trực",
    part_of_speech: "phụ từ",
    meaning: "(phương ngữ) chợt: trực nhớ ra",
    example: "trực nhớ ra",
  },
  {
    word: "trữ tình",
    part_of_speech: "tính từ",
    meaning:
      "có nội dung phản ánh hiện thực bằng cách biểu hiện những ý nghĩ, xúc cảm, tâm trạng riêng của con người trước cuộc sống: thơ trữ tình * những làn điệu quan họ mang đậm chất trữ tình",
    example: "thơ trữ tình * những làn điệu quan họ mang đậm chất trữ tình",
  },
  {
    word: "trưa trật",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) trưa lắm, muộn lắm so với giờ giấc buổi sáng: trời đã trưa trật mà chưa dậy",
    example: "trời đã trưa trật mà chưa dậy",
  },
  {
    word: "trực chiến",
    part_of_speech: "động từ",
    meaning:
      "thường trực ở vị trí chiến đấu để sẵn sàng chiến đấu: dân quân trực chiến * tổ trực chiến",
    example: "dân quân trực chiến * tổ trực chiến",
  },
  {
    word: "trưa",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian giữa ban ngày, vào lúc mặt trời lên cao nhất: giữa trưa * giờ nghỉ trưa",
    example: "giữa trưa * giờ nghỉ trưa",
  },
  {
    word: "trưa",
    part_of_speech: "tính từ",
    meaning:
      'muộn so với giờ giấc buổi sáng: ngủ dậy trưa * "Chàng buông vạt áo em ra, Để em đi chợ kẻo mà chợ trưa." (ca dao)',
    example:
      'ngủ dậy trưa * "Chàng buông vạt áo em ra, Để em đi chợ kẻo mà chợ trưa." (ca dao)',
  },
  {
    word: "trừ tà",
    part_of_speech: "động từ",
    meaning: "diệt trừ tà ma: thầy phù thuỷ trừ tà * làm phép trừ tà",
    example: "thầy phù thuỷ trừ tà * làm phép trừ tà",
  },
  {
    word: "trứ tác",
    part_of_speech: "động từ",
    meaning: "(Từ cũ) viết thành tác phẩm: trước tác văn thơ * nghề trước tác",
    example: "trước tác văn thơ * nghề trước tác",
  },
  {
    word: "trứ tác",
    part_of_speech: "danh từ",
    meaning:
      "(Trang trọng) tác phẩm viết: một trước tác của Lenin * những trước tác bất hủ",
    example: "một trước tác của Lenin * những trước tác bất hủ",
  },
  {
    word: "trực giác",
    part_of_speech: "",
    meaning:
      "nhận thức trực tiếp, không phải bằng suy luận của lí trí: dự đoán bằng trực giác * trực giác mách bảo",
    example: "dự đoán bằng trực giác * trực giác mách bảo",
  },
  {
    word: "trực nhật",
    part_of_speech: "động từ",
    meaning:
      "làm nhiệm vụ theo dõi, đôn đốc việc thực hiện nội quy, giữ gìn trật tự, vệ sinh, v.v. của cơ quan, trường, lớp, v.v. trong một ngày: phân công trực nhật * đến phiên trực nhật",
    example: "phân công trực nhật * đến phiên trực nhật",
  },
  {
    word: "trực nhật",
    part_of_speech: "danh từ",
    meaning: "người trực nhật: phê bình trực nhật",
    example: "phê bình trực nhật",
  },
  {
    word: "trực khuẩn",
    part_of_speech: "danh từ",
    meaning: "vi trùng hình que thẳng: trực trùng kiết lị",
    example: "trực trùng kiết lị",
  },
  {
    word: "trực giao",
    part_of_speech: "động từ",
    meaning: "vuông góc với nhau: hai đường thẳng trực giao",
    example: "hai đường thẳng trực giao",
  },
  {
    word: "trực diện",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất trực tiếp, mặt đối mặt: đánh trực diện * đấu tranh trực diện",
    example: "đánh trực diện * đấu tranh trực diện",
  },
  {
    word: "trực quan",
    part_of_speech: "động từ",
    meaning: "(cũ) như trực giác: hiểu bằng trực quan",
    example: "hiểu bằng trực quan",
  },
  {
    word: "trực quan",
    part_of_speech: "động từ",
    meaning:
      "(phương pháp giảng dạy) dùng những vật cụ thể hay ngôn ngữ cử chỉ làm cho học sinh có được hình ảnh cụ thể về những điều được học: giáo cụ trực quan",
    example: "giáo cụ trực quan",
  },
  {
    word: "trực thăng",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) máy bay trực thăng (nói tắt): chuyên chở bằng trực thăng",
    example: "chuyên chở bằng trực thăng",
  },
  {
    word: "trực thăng vận",
    part_of_speech: "động từ",
    meaning:
      "di chuyển lực lượng quân sự bằng máy bay trực thăng: trực thăng vận binh lính đến địa điểm tập kích",
    example: "trực thăng vận binh lính đến địa điểm tập kích",
  },
  {
    word: "trực tính",
    part_of_speech: "tính từ",
    meaning:
      "có tính hay nói thẳng, không để bụng: người trực tính * trực tính nên hay nói thẳng",
    example: "người trực tính * trực tính nên hay nói thẳng",
  },
  {
    word: "trực thuộc",
    part_of_speech: "động từ",
    meaning:
      "chịu sự lãnh đạo trực tiếp của một cấp nào đó: trung tâm trực thuộc bộ * thành phố trực thuộc tỉnh",
    example: "trung tâm trực thuộc bộ * thành phố trực thuộc tỉnh",
  },
  {
    word: "trực tiếp",
    part_of_speech: "tính từ",
    meaning:
      "có quan hệ thẳng với đối tượng tiếp xúc, không qua khâu trung gian: tiếp xúc trực tiếp * bộ phận trực tiếp sản xuất",
    example: "tiếp xúc trực tiếp * bộ phận trực tiếp sản xuất",
  },
  {
    word: "trưng",
    part_of_speech: "động từ",
    meaning:
      "để ở vị trí dễ thấy nhất, sao cho càng nhiều người nhìn thấy rõ càng tốt: trưng đèn * trưng biển hiệu",
    example: "trưng đèn * trưng biển hiệu",
  },
  {
    word: "trưng",
    part_of_speech: "động từ",
    meaning: "trưng thầu (nói tắt): trưng thuế chợ",
    example: "trưng thuế chợ",
  },
  {
    word: "trứng",
    part_of_speech: "danh từ",
    meaning:
      "khối hình bầu dục hoặc hình cầu do một số động vật cái đẻ ra, sau có thể nở thành con: gà đẻ trứng * trứng chim * cá đầy một bụng trứng",
    example: "gà đẻ trứng * trứng chim * cá đầy một bụng trứng",
  },
  {
    word: "trứng",
    part_of_speech: "danh từ",
    meaning:
      "trứng gà hoặc trứng vịt (nói tắt): rán trứng * chưng trứng * mua một chục trứng",
    example: "rán trứng * chưng trứng * mua một chục trứng",
  },
  {
    word: "trứng",
    part_of_speech: "danh từ",
    meaning: "tế bào sinh dục cái ở người hoặc một số động vật: kì rụng trứng",
    example: "kì rụng trứng",
  },
  {
    word: "trưng bày",
    part_of_speech: "động từ",
    meaning:
      "bày ở nơi trang trọng cho công chúng xem để tuyên truyền, giới thiệu: trưng bày hàng hoá * phòng trưng bày tranh",
    example: "trưng bày hàng hoá * phòng trưng bày tranh",
  },
  {
    word: "trừng",
    part_of_speech: "động từ",
    meaning:
      "mở to mắt và tập trung nhìn thẳng vào, thường để biểu lộ sự bực tức hoặc ý hăm doạ: trừng mắt đe doạ",
    example: "trừng mắt đe doạ",
  },
  {
    word: "trực tuyến",
    part_of_speech: "tính từ",
    meaning:
      "(máy tính) ở trong trạng thái được kết nối và thâm nhập trực tiếp vào một mạng máy tính; phân biệt với ngoại tuyến: đường truyền trực tuyến * truy cập trực tuyến * tra từ điển trực tuyến",
    example:
      "đường truyền trực tuyến * truy cập trực tuyến * tra từ điển trực tuyến",
  },
  {
    word: "trực tuyến",
    part_of_speech: "tính từ",
    meaning:
      "(tin tức, âm thanh, hình ảnh, v.v.) được cung cấp trực tiếp trên mạng Internet đồng thời hoặc ngay sau khi xảy ra một sự kiện nào đó: trả lời trực tuyến về công tác tuyển sinh",
    example: "trả lời trực tuyến về công tác tuyển sinh",
  },
  {
    word: "trực trùng",
    part_of_speech: "danh từ",
    meaning: "vi trùng hình que thẳng: trực trùng kiết lị",
    example: "trực trùng kiết lị",
  },
  {
    word: "trứng cá",
    part_of_speech: "danh từ",
    meaning:
      "nốt nhỏ trông tựa trứng cá, thường thấy trên da mặt người đang tuổi dậy thì: mặt nổi đầy trứng cá * nặn trứng cá",
    example: "mặt nổi đầy trứng cá * nặn trứng cá",
  },
  {
    word: "trưng cầu",
    part_of_speech: "động từ",
    meaning:
      "hỏi ý kiến của số đông người một cách có tổ chức: trưng cầu ý kiến",
    example: "trưng cầu ý kiến",
  },
  {
    word: "trứng cuốc",
    part_of_speech: "",
    meaning:
      "(chuối tiêu) chín tới mức vỏ chuyển sang màu vàng sẫm và lốm đốm chấm nâu, trông tựa như màu vỏ trứng chim cuốc: chuối trứng cuốc",
    example: "chuối trứng cuốc",
  },
  {
    word: "trưng dụng",
    part_of_speech: "động từ",
    meaning:
      "(cơ quan nhà nước) tạm lấy đi (vật hoặc người thuộc quyền sở hữu hay quyền quản lí của tư nhân, tập thể hay cơ quan, xí nghiệp cấp dưới) để sử dụng trong một thời gian vào một công việc nào đó, do yêu cầu đặc biệt: trưng dụng thợ thuyền * trưng dụng người phục vụ hội nghị",
    example: "trưng dụng thợ thuyền * trưng dụng người phục vụ hội nghị",
  },
  {
    word: "trưng khẩn",
    part_of_speech: "động từ",
    meaning:
      "(cũ) nhận đất hoang không có chủ để khai khẩn theo pháp luật, dưới thời phong kiến, thực dân: trưng khẩn đất hoang",
    example: "trưng khẩn đất hoang",
  },
  {
    word: "trưng mua",
    part_of_speech: "động từ",
    meaning:
      "(cơ quan nhà nước) buộc tư nhân phải bán cho nhà nước theo giá quy định: trưng mua lương thực",
    example: "trưng mua lương thực",
  },
  {
    word: "trứng nước",
    part_of_speech: "",
    meaning:
      '(văn chương) (trẻ con) ở thời kì mới sinh ra chưa được bao lâu, đang còn non nớt, thơ dại, cần được chăm chút, giữ gìn: "Công cha đức mẹ cao dày, Cưu mang trứng nước những ngày ngây thơ." (ca dao)',
    example:
      'Công cha đức mẹ cao dày, Cưu mang trứng nước những ngày ngây thơ." (ca dao)',
  },
  {
    word: "trưng tập",
    part_of_speech: "động từ",
    meaning:
      "(cũ) (cơ quan nhà nước) buộc một người nào đó phải làm việc cho nhà nước trong một thời gian: trưng tập trai tráng đi phu",
    example: "trưng tập trai tráng đi phu",
  },
  {
    word: "trứng sáo",
    part_of_speech: "danh từ",
    meaning:
      "màu xanh nhạt, trông tựa như màu vỏ trứng chim sáo (thường nói về vải, lụa): áo xanh trứng sáo",
    example: "áo xanh trứng sáo",
  },
  {
    word: "trừng trộ",
    part_of_speech: "động từ",
    meaning:
      "trừng mắt để tỏ thái độ (nói khái quát): chưa nghe hết câu đã trừng trộ, quát tháo",
    example: "chưa nghe hết câu đã trừng trộ, quát tháo",
  },
  {
    word: "trưng thầu",
    part_of_speech: "động từ",
    meaning: "nhận thầu với cơ quan nhà nước để kinh doanh: trưng thầu bến bãi",
    example: "trưng thầu bến bãi",
  },
  {
    word: "trừng phạt",
    part_of_speech: "động từ",
    meaning:
      "trị kẻ có tội bằng hình phạt: trừng phạt kẻ phản bội * đòn trừng phạt",
    example: "trừng phạt kẻ phản bội * đòn trừng phạt",
  },
  {
    word: "trưng thu",
    part_of_speech: "động từ",
    meaning:
      "(cơ quan nhà nước) buộc tư nhân hoặc tập thể phải giao tài sản thuộc quyền sở hữu của mình cho nhà nước: trưng thu lương thực * trưng thu ruộng đất của địa chủ",
    example: "trưng thu lương thực * trưng thu ruộng đất của địa chủ",
  },
  {
    word: "trừng trị",
    part_of_speech: "động từ",
    meaning:
      "trị kẻ có tội lớn bằng hình phạt đích đáng: trừng trị tên phản quốc * thẳng tay trừng trị",
    example: "trừng trị tên phản quốc * thẳng tay trừng trị",
  },
  {
    word: "trừng trừng",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả lối nhìn thẳng và lâu không chớp mắt, thường biểu lộ sự ngạc nhiên hoặc căm giận: mắt mở trừng trừng * trừng trừng nhìn nhau",
    example: "mắt mở trừng trừng * trừng trừng nhìn nhau",
  },
  {
    word: "trước bạ",
    part_of_speech: "động từ",
    meaning:
      "đăng kí quyền sở hữu đối với một số loại tài sản theo quy định của pháp luật: sổ trước bạ * đăng kí trước bạ",
    example: "sổ trước bạ * đăng kí trước bạ",
  },
  {
    word: "trước hết",
    part_of_speech: "danh từ",
    meaning:
      "trước tất cả những cái khác, vì quan trọng hơn cả: trước hết phải lo vấn đề nhân lực",
    example: "trước hết phải lo vấn đề nhân lực",
  },
  {
    word: "trước",
    part_of_speech: "danh từ",
    meaning:
      "phía những vị trí mà mắt nhìn thẳng có thể thấy được: tiến lên trước * phía trước là rừng già * nhìn trước ngó sau",
    example: "tiến lên trước * phía trước là rừng già * nhìn trước ngó sau",
  },
  {
    word: "trước",
    part_of_speech: "danh từ",
    meaning:
      "phía không bị sự vật xác định nào đó che khuất, hoặc ở mặt chính của sự vật, thường bày ra cho người ta thấy: đứng trước một cây to * mặt trước tấm vải * hai chân trước",
    example: "đứng trước một cây to * mặt trước tấm vải * hai chân trước",
  },
  {
    word: "trước",
    part_of_speech: "danh từ",
    meaning:
      "phía tương đối gần vị trí lấy làm mốc hơn, tính từ vị trí mốc đó trở lại: ngồi ở hàng ghế trước * cửa trước của ô tô",
    example: "ngồi ở hàng ghế trước * cửa trước của ô tô",
  },
  {
    word: "trước",
    part_of_speech: "danh từ",
    meaning:
      "khoảng của những thời điểm chưa đến một thời điểm nào đó được lấy làm mốc: báo trước cho biết * nghĩ kĩ trước khi nói * trước khác, bây giờ khác",
    example:
      "báo trước cho biết * nghĩ kĩ trước khi nói * trước khác, bây giờ khác",
  },
  {
    word: "trước",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là thực tế, tình hình tác động trực tiếp, làm cho có thái độ, hoạt động, sự phản ứng được nói đến: bình tĩnh trước hiểm nguy * mọi người đều bình đẳng trước pháp luật",
    example:
      "bình tĩnh trước hiểm nguy * mọi người đều bình đẳng trước pháp luật",
  },
  {
    word: "trưng vay",
    part_of_speech: "động từ",
    meaning:
      "buộc tư nhân phải cho nhà nước vay tiền hoặc hiện vật nào đó: trưng vay thóc gạo",
    example: "trưng vay thóc gạo",
  },
  {
    word: "trước kia",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian trong quá khứ; đối lập với bây giờ, sau này: cuộc sống trước kia * trước kia đây là bãi đất hoang",
    example: "cuộc sống trước kia * trước kia đây là bãi đất hoang",
  },
  {
    word: "trước sau",
    part_of_speech: "danh từ",
    meaning:
      'cả phía trước lẫn phía sau; khắp các phía: nhìn ngó trước sau * "Trước sau nào thấy bóng người, Hoa đào năm ngoái còn cười gió đông." (TKiều)',
    example:
      'nhìn ngó trước sau * "Trước sau nào thấy bóng người, Hoa đào năm ngoái còn cười gió đông." (TKiều)',
  },
  {
    word: "trước sau",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, văn chương) đầu đuôi, cả về trước lẫn về sau một cách cặn kẽ: dặn dò trước sau * cân nhắc trước sau * nói có trước sau",
    example: "dặn dò trước sau * cân nhắc trước sau * nói có trước sau",
  },
  {
    word: "trước sau",
    part_of_speech: "danh từ",
    meaning:
      "trước cũng như sau, lúc nào cũng thế: trước sau một lòng * ăn ở có trước có sau",
    example: "trước sau một lòng * ăn ở có trước có sau",
  },
  {
    word: "trước sau",
    part_of_speech: "danh từ",
    meaning:
      "không trước thì sau, thế nào cũng sẽ xảy ra: trước sau cũng phải làm * trước sau gì chuyện này cũng bị lộ",
    example: "trước sau cũng phải làm * trước sau gì chuyện này cũng bị lộ",
  },
  {
    word: "trườn",
    part_of_speech: "động từ",
    meaning:
      "nằm sấp áp sát mặt đất, dùng sức đẩy thân mình về phía trước: rắn trườn vào hang * trườn mình qua hàng rào dây thép",
    example: "rắn trườn vào hang * trườn mình qua hàng rào dây thép",
  },
  {
    word: "trước nay",
    part_of_speech: "danh từ",
    meaning:
      "từ trước kia cho đến bây giờ: trước nay mọi người vẫn làm như vậy",
    example: "trước nay mọi người vẫn làm như vậy",
  },
  {
    word: "trước nhất",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) như trước tiên: việc trước nhất phải làm * trước nhất tôi phải xem kĩ lại đã",
    example: "việc trước nhất phải làm * trước nhất tôi phải xem kĩ lại đã",
  },
  {
    word: "trước tiên",
    part_of_speech: "danh từ",
    meaning:
      "trước tất cả những người khác, việc khác: trông thấy trước tiên * nói trước tiên * việc trước tiên phải làm",
    example:
      "trông thấy trước tiên * nói trước tiên * việc trước tiên phải làm",
  },
  {
    word: "trước mắt",
    part_of_speech: "danh từ",
    meaning:
      "hiện nay và trong thời gian ngắn sắp tới: mục tiêu trước mắt * trước mắt, hãy cứ đợi xem đã",
    example: "mục tiêu trước mắt * trước mắt, hãy cứ đợi xem đã",
  },
  {
    word: "trượng",
    part_of_speech: "danh từ",
    meaning:
      "gậy dài bằng gỗ, thời trước dùng để đánh người bị xử phạt: đánh hai mươi trượng",
    example: "đánh hai mươi trượng",
  },
  {
    word: "trượng",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị đo độ dài, bằng mười thước Trung Quốc cổ (tức 3,33 mét): trời cao muôn trượng",
    example: "trời cao muôn trượng",
  },
  {
    word: "trước tác",
    part_of_speech: "động từ",
    meaning: "(Từ cũ) viết thành tác phẩm: trước tác văn thơ * nghề trước tác",
    example: "trước tác văn thơ * nghề trước tác",
  },
  {
    word: "trước tác",
    part_of_speech: "danh từ",
    meaning:
      "(Trang trọng) tác phẩm viết: một trước tác của Lenin * những trước tác bất hủ",
    example: "một trước tác của Lenin * những trước tác bất hủ",
  },
  {
    word: "trưởng",
    part_of_speech: "danh từ",
    meaning:
      "người đứng đầu một đơn vị, tổ chức: trưởng họ * trưởng bản * trưởng ban văn nghệ",
    example: "trưởng họ * trưởng bản * trưởng ban văn nghệ",
  },
  {
    word: "trưởng",
    part_of_speech: "tính từ",
    meaning:
      "được coi là đứng đầu trong gia đình, trong họ: người con trưởng * anh trưởng",
    example: "người con trưởng * anh trưởng",
  },
  {
    word: "trường",
    part_of_speech: "danh từ",
    meaning:
      "khoảng đất rộng và bằng phẳng, chuyên dùng làm nơi tiến hành một loại hoạt động nhất định có đông người tham gia, thường là thi đấu hay luyện tập: luyện tập ở trường bắn * trường đấu bò tót",
    example: "luyện tập ở trường bắn * trường đấu bò tót",
  },
  {
    word: "trường",
    part_of_speech: "danh từ",
    meaning:
      "nơi diễn ra các hoạt động chính trị, xã hội, v.v. sôi nổi: đấu tranh trên trường ngoại giao * có uy tín trên trường quốc tế",
    example: "đấu tranh trên trường ngoại giao * có uy tín trên trường quốc tế",
  },
  {
    word: "trường",
    part_of_speech: "danh từ",
    meaning:
      "khoảng không gian trong đó một đại lượng nào đó có một trị số xác định tại mọi điểm: trường vận tốc * trường nhiệt độ",
    example: "trường vận tốc * trường nhiệt độ",
  },
  {
    word: "trường",
    part_of_speech: "danh từ",
    meaning:
      "dạng vật chất tồn tại trong một khoảng không gian mà vật nào trong đó cũng chịu tác dụng của một lực: trường hấp dẫn * trường điện từ",
    example: "trường hấp dẫn * trường điện từ",
  },
  {
    word: "trường",
    part_of_speech: "danh từ",
    meaning:
      "trường học (nhưng thường dùng với nghĩa cụ thể): trường viết văn * trường đại học * học sinh đến trường",
    example: "trường viết văn * trường đại học * học sinh đến trường",
  },
  {
    word: "trường",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) có bề dài đo được bao nhiêu đó (thường nói về gỗ): cái bàn trường ba thước",
    example: "cái bàn trường ba thước",
  },
  {
    word: "trường",
    part_of_speech: "tính từ",
    meaning:
      "như dài (ng2): khúc gỗ trường * giống lợn mình trường * giọng hát rất trường",
    example: "khúc gỗ trường * giống lợn mình trường * giọng hát rất trường",
  },
  {
    word: "trường",
    part_of_speech: "tính từ",
    meaning:
      "(khoảng không gian, thời gian) có cảm giác rất dài, rất lâu: đường trường * thân gái dặm trường",
    example: "đường trường * thân gái dặm trường",
  },
  {
    word: "trường ca",
    part_of_speech: "danh từ",
    meaning:
      "tác phẩm dài bằng thơ, có nội dung ý nghĩa xã hội rộng lớn: trường ca Đam San * bản trường ca",
    example: "trường ca Đam San * bản trường ca",
  },
  {
    word: "trướng",
    part_of_speech: "danh từ",
    meaning:
      "bức lụa, vải, trên có thêu chữ hoặc hình, dùng làm lễ vật, tặng phẩm: trướng mừng thọ * đi phúng một bức trướng",
    example: "trướng mừng thọ * đi phúng một bức trướng",
  },
  {
    word: "trướng",
    part_of_speech: "danh từ",
    meaning: "bức màn che có hình thêu, thời xưa thường dùng: trướng hoa",
    example: "trướng hoa",
  },
  {
    word: "trướng",
    part_of_speech: "tính từ",
    meaning:
      "(bụng) đầy ứ và căng phình lên, gây cảm giác khó chịu: bụng trướng to * căng trướng",
    example: "bụng trướng to * căng trướng",
  },
  {
    word: "trường bắn",
    part_of_speech: "danh từ",
    meaning:
      "khu vực địa hình có thiết bị cần thiết chuyên dùng để bắn đạn thật.",
    example: "giải phạm nhân ra trường bắn",
  },
  {
    word: "trương",
    part_of_speech: "động từ",
    meaning:
      "căng phình lên vì hút nhiều nước: cơm trương * bụng trương to * trương phềnh phềnh",
    example: "cơm trương * bụng trương to * trương phềnh phềnh",
  },
  {
    word: "trương",
    part_of_speech: "động từ",
    meaning: "(cũ)",
    example: "trương cờ * trương khẩu hiệu",
  },
  {
    word: "trường đấu",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như đấu trường: võ sĩ bước lên trường đấu",
    example: "võ sĩ bước lên trường đấu",
  },
  {
    word: "trường bay",
    part_of_speech: "danh từ",
    meaning: "(cũ) sân bay: trường bay Gia Lâm",
    example: "trường bay Gia Lâm",
  },
  {
    word: "trường chinh",
    part_of_speech: "động từ",
    meaning:
      "(văn chương) (đoàn đông người) làm cuộc hành trình dài lâu vì mục đích lớn: vạn dặm trường chinh * cuộc trường chinh",
    example: "vạn dặm trường chinh * cuộc trường chinh",
  },
  {
    word: "trường cửu",
    part_of_speech: "tính từ",
    meaning:
      "(văn chương) lâu dài và vững bền: sự nghiệp trường cửu * một tác phẩm có sức sống trường cửu",
    example: "sự nghiệp trường cửu * một tác phẩm có sức sống trường cửu",
  },
  {
    word: "trường đời",
    part_of_speech: "danh từ",
    meaning:
      "xã hội, về mặt là nơi con người tiếp nhận kiến thức và kinh nghiệm thực tế: kinh nghiệm trường đời * những vấp váp trên trường đời",
    example: "kinh nghiệm trường đời * những vấp váp trên trường đời",
  },
  {
    word: "trường học",
    part_of_speech: "danh từ",
    meaning:
      "nơi tiến hành giảng dạy, đào tạo toàn diện hay về một lĩnh vực chuyên môn nào đó cho học sinh, học viên: mở trường học tư * xây dựng trường học",
    example: "mở trường học tư * xây dựng trường học",
  },
  {
    word: "trường học",
    part_of_speech: "danh từ",
    meaning:
      "nơi rèn luyện, bồi dưỡng con người về mặt nào đó: môi trường quân đội là trường học lớn của thanh niên",
    example: "môi trường quân đội là trường học lớn của thanh niên",
  },
  {
    word: "trường đoạn",
    part_of_speech: "danh từ",
    meaning:
      "phần của tác phẩm điện ảnh có kết cấu tương đối hoàn chỉnh và độc lập, thể hiện một vấn đề của nội dung tác phẩm: trích một trường đoạn của bộ phim",
    example: "trích một trường đoạn của bộ phim",
  },
  {
    word: "trưởng giả",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người xuất thân bình dân nhờ buôn bán, kinh doanh mà giàu có, trong xã hội cũ: hạng trưởng giả * trưởng giả học làm sang",
    example: "hạng trưởng giả * trưởng giả học làm sang",
  },
  {
    word: "trưởng giả",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) giàu có và chỉ thiên về hưởng thụ: xã hội trưởng giả * cuộc sống trưởng giả",
    example: "xã hội trưởng giả * cuộc sống trưởng giả",
  },
  {
    word: "trường đua",
    part_of_speech: "danh từ",
    meaning:
      "nơi luyện tập và đua ngựa, xe đạp, mô tô, v.v.: đưa ngựa đến trường đua",
    example: "đưa ngựa đến trường đua",
  },
  {
    word: "trưởng đoàn",
    part_of_speech: "danh từ",
    meaning:
      "người đứng đầu, lãnh đạo một đoàn công tác: trưởng đoàn đàm phán * trưởng đoàn thanh tra",
    example: "trưởng đoàn đàm phán * trưởng đoàn thanh tra",
  },
  {
    word: "trường hợp",
    part_of_speech: "danh từ",
    meaning:
      "việc xảy ra hoặc giả định xảy ra, nói về mặt tính chất cụ thể của nó, lần này khác những lần khác: trường hợp khó khăn * một trường hợp điển hình",
    example: "trường hợp khó khăn * một trường hợp điển hình",
  },
  {
    word: "trường hợp",
    part_of_speech: "danh từ",
    meaning:
      "tình hình cụ thể trong đó sự việc nói đến xảy ra hoặc giả định xảy ra, trong quan hệ với các tình hình khác có thể có: dự kiến mọi trường hợp * trong trường hợp xảy ra hoả hoạn phải gọi ngay số điện thoại 114",
    example:
      "dự kiến mọi trường hợp * trong trường hợp xảy ra hoả hoạn phải gọi ngay số điện thoại 114",
  },
  {
    word: "trường kì",
    part_of_speech: "tính từ",
    meaning: "lâu dài: cuộc kháng chiến trường kì",
    example: "cuộc kháng chiến trường kì",
  },
  {
    word: "trường kỉ",
    part_of_speech: "danh từ",
    meaning:
      "ghế dài, thường bằng gỗ, có lưng tựa và tay vịn ở hai đầu: bộ tràng kỉ bằng gỗ lim",
    example: "bộ tràng kỉ bằng gỗ lim",
  },
  {
    word: "trương lực",
    part_of_speech: "danh từ",
    meaning: "sức căng của cơ, theo cách gọi của y học: trương lực của cơ bắp",
    example: "trương lực của cơ bắp",
  },
  {
    word: "trường kỳ",
    part_of_speech: "tính từ",
    meaning: "lâu dài: cuộc kháng chiến trường kì",
    example: "cuộc kháng chiến trường kì",
  },
  {
    word: "trưởng lão",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) (hiếm) người đàn ông cao tuổi có uy tín trong làng: các trưởng lão trong làng",
    example: "các trưởng lão trong làng",
  },
  {
    word: "trưởng lão",
    part_of_speech: "danh từ",
    meaning:
      "người đàn ông đã có một quá trình tu hành lâu năm theo đạo Phật: các bậc cao tăng trưởng lão",
    example: "các bậc cao tăng trưởng lão",
  },
  {
    word: "trường kỷ",
    part_of_speech: "danh từ",
    meaning:
      "ghế dài, thường bằng gỗ, có lưng tựa và tay vịn ở hai đầu: bộ tràng kỉ bằng gỗ lim",
    example: "bộ tràng kỉ bằng gỗ lim",
  },
  {
    word: "trường ốc",
    part_of_speech: "danh từ",
    meaning: "(cũ) trường thi: lận đận trường ốc",
    example: "lận đận trường ốc",
  },
  {
    word: "trường ốc",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) như trường sở: xây dựng trường ốc * trường ốc khang trang sạch đẹp",
    example: "xây dựng trường ốc * trường ốc khang trang sạch đẹp",
  },
  {
    word: "trường phái",
    part_of_speech: "danh từ",
    meaning:
      "nhóm nhà khoa học hoặc văn nghệ sĩ có chung một khuynh hướng tư tưởng, một phương pháp luận hoặc phương pháp sáng tác (thường có một người tiêu biểu đứng đầu): các trường phái triết học * trường phái siêu thực",
    example: "các trường phái triết học * trường phái siêu thực",
  },
  {
    word: "trường phái",
    part_of_speech: "danh từ",
    meaning:
      "môn phái võ, về mặt có những đặc trưng riêng: trường phái Thiếu Lâm",
    example: "trường phái Thiếu Lâm",
  },
  {
    word: "trưởng phòng",
    part_of_speech: "danh từ",
    meaning:
      "người đứng đầu điều khiển công việc của một phòng: trưởng phòng hành chính",
    example: "trưởng phòng hành chính",
  },
  {
    word: "trường sinh",
    part_of_speech: "động từ",
    meaning: "(cũ) sống lâu, sống mãi: thuốc trường sinh * thuật trường sinh",
    example: "thuốc trường sinh * thuật trường sinh",
  },
  {
    word: "trướng rủ màn che",
    part_of_speech: "",
    meaning:
      '(cũ, văn chương) tả cảnh sống cấm cung của người con gái quyền quý, tách mình ra khỏi mọi quan hệ với xã hội: "Êm đềm trướng rủ màn che, Tường đông ong bướm đi về mặc ai." (TKiều)',
    example:
      'Êm đềm trướng rủ màn che, Tường đông ong bướm đi về mặc ai." (TKiều)',
  },
  {
    word: "trượng phu",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) người đàn ông có khí phách, theo quan niệm của xã hội phong kiến: đấng trượng phu * "Ghé vai gánh đỡ sơn hà, Sao cho tỏ mặt mới là trượng phu." (ca dao)',
    example:
      'đấng trượng phu * "Ghé vai gánh đỡ sơn hà, Sao cho tỏ mặt mới là trượng phu." (ca dao)',
  },
  {
    word: "trượng phu",
    part_of_speech: "danh từ",
    meaning:
      '(văn chương, hiếm) từ người phụ nữ dùng để gọi chồng; lang quân: "Một năm một nhạt mùi son phấn, Trượng phu còn thơ thẩn miền khơi." (CPN)',
    example:
      'Một năm một nhạt mùi son phấn, Trượng phu còn thơ thẩn miền khơi." (CPN)',
  },
  {
    word: "trường quy",
    part_of_speech: "danh từ",
    meaning: "(cũ) nội quy trường thi: bài thi bị đánh hỏng vì phạm trường quy",
    example: "bài thi bị đánh hỏng vì phạm trường quy",
  },
  {
    word: "trường sinh học",
    part_of_speech: "danh từ",
    meaning:
      "trường năng lượng tồn tại trong mỗi cơ thể sống, toả ra thành lớp sóng điện bao trùm quanh cơ thể, có khả năng ảnh hưởng đến các thực thể sống khác khi tiếp xúc: trường sinh học của lá cây",
    example: "trường sinh học của lá cây",
  },
  {
    word: "trường quay",
    part_of_speech: "danh từ",
    meaning:
      "nơi được thiết kế theo yêu cầu đặc biệt để có đủ mọi tiện nghi cần thiết chuyên dùng cho việc diễn xuất và quay phim: thiết kế trường quay * khách mời của trường quay",
    example: "thiết kế trường quay * khách mời của trường quay",
  },
  {
    word: "trường thành",
    part_of_speech: "danh từ",
    meaning:
      "bức thành dài và vững chắc: xây đắp trường thành * bức trường thành",
    example: "xây đắp trường thành * bức trường thành",
  },
  {
    word: "trường sở",
    part_of_speech: "danh từ",
    meaning:
      "trụ sở của một trường học: xây dựng trường sở * trường sở khang trang",
    example: "xây dựng trường sở * trường sở khang trang",
  },
  {
    word: "trường thọ",
    part_of_speech: "động từ",
    meaning: "(trang trọng) thọ lâu, sống lâu: xin chúc cụ trường thọ!",
    example: "xin chúc cụ trường thọ!",
  },
  {
    word: "trường tồn",
    part_of_speech: "động từ",
    meaning:
      "(văn chương, trang trọng) tồn tại lâu dài, mãi mãi: vũ trụ trường tồn * tác phẩm trường tồn cùng thời gian",
    example: "vũ trụ trường tồn * tác phẩm trường tồn cùng thời gian",
  },
  {
    word: "trưởng thành",
    part_of_speech: "động từ",
    meaning:
      "(người, sinh vật) phát triển đến mức hoàn chỉnh, đầy đủ về mọi mặt: tuổi trưởng thành * con cái đã trưởng thành * cây đang độ trưởng thành",
    example:
      "tuổi trưởng thành * con cái đã trưởng thành * cây đang độ trưởng thành",
  },
  {
    word: "trưởng thành",
    part_of_speech: "động từ",
    meaning:
      "trở nên lớn mạnh, vững vàng, qua quá trình thử thách, rèn luyện: trưởng thành về mặt chính trị",
    example: "trưởng thành về mặt chính trị",
  },
  {
    word: "trừu",
    part_of_speech: "danh từ",
    meaning:
      'hàng dệt bằng tơ, mịn hơn nhiễu: "Chớ tham vóc lĩnh trừu hoa, Lấy chồng làm lẽ người ta giày vò." (ca dao)',
    example:
      'Chớ tham vóc lĩnh trừu hoa, Lấy chồng làm lẽ người ta giày vò." (ca dao)',
  },
  {
    word: "trượt giá",
    part_of_speech: "danh từ",
    meaning:
      "hoặc đg hiện tượng đồng tiền bị mất giá do lạm phát: đồng dollar đang bị trượt giá",
    example: "đồng dollar đang bị trượt giá",
  },
  {
    word: "trường thi",
    part_of_speech: "danh từ",
    meaning: "(cũ) nơi thi cử thời phong kiến: sĩ tử lều chõng vào trường thi",
    example: "sĩ tử lều chõng vào trường thi",
  },
  {
    word: "trượt",
    part_of_speech: "động từ",
    meaning:
      "di chuyển liên tục trên một mặt phẳng trơn hoặc dọc theo vật gì theo đà được tạo ra bởi một chuyển động mạnh đột ngột ban đầu: trượt chân suýt ngã * xe bị trượt dốc * trượt từ trên cao xuống",
    example: "trượt chân suýt ngã * xe bị trượt dốc * trượt từ trên cao xuống",
  },
  {
    word: "trượt",
    part_of_speech: "động từ",
    meaning: "không trúng vào chỗ nhằm tới: bắn trượt * sút trượt khung thành",
    example: "bắn trượt * sút trượt khung thành",
  },
  {
    word: "trượt",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) (thi cử) hỏng, không đỗ: thi trượt đại học * bị đánh trượt",
    example: "thi trượt đại học * bị đánh trượt",
  },
  {
    word: "trượt băng",
    part_of_speech: "động từ",
    meaning:
      "trượt trên băng bằng một loại giày riêng (một môn thể thao): trượt băng nghệ thuật",
    example: "trượt băng nghệ thuật",
  },
  {
    word: "trừu tượng",
    part_of_speech: "tính từ",
    meaning:
      "có được sự khái quát hoá trong tư duy, trên cơ sở dựa vào các thuộc tính, các quan hệ của sự vật; phân biệt với cụ thể: ,  *  là những khái niệm trừu tượng",
    example: ",  *  là những khái niệm trừu tượng",
  },
  {
    word: "trừu tượng",
    part_of_speech: "tính từ",
    meaning:
      "khó hiểu, khó hình dung vì không có gì cụ thể cả: tranh trừu tượng",
    example: "tranh trừu tượng",
  },
  {
    word: "trường vốn",
    part_of_speech: "tính từ",
    meaning: "có nhiều vốn để làm ăn lâu dài: muốn làm ăn lớn phải trường vốn",
    example: "muốn làm ăn lớn phải trường vốn",
  },
  {
    word: "tú",
    part_of_speech: "danh từ",
    meaning: "tú lơ khơ (nói tắt): mua một bộ tú * chơi tú",
    example: "mua một bộ tú * chơi tú",
  },
  {
    word: "tu",
    part_of_speech: "động từ",
    meaning:
      "sống theo những quy định chặt chẽ nhằm sửa mình theo đúng giáo lí của một tôn giáo nào đó: tu tại gia * cắt tóc đi tu",
    example: "tu tại gia * cắt tóc đi tu",
  },
  {
    word: "tu",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) uống nhiều liền một mạch bằng cách ngậm trực tiếp vào miệng vật đựng: tu nước ừng ực * tu một hơi hết nửa chai",
    example: "tu nước ừng ực * tu một hơi hết nửa chai",
  },
  {
    word: "tu",
    part_of_speech: "động từ",
    meaning:
      "từ mô phỏng tiếng bật ra to và kéo dài từng hồi như tiếng kèn, còi rúc, v.v.: tiếng kèn tu lên một hồi * khóc tu tu",
    example: "tiếng kèn tu lên một hồi * khóc tu tu",
  },
  {
    word: "tụ bạ",
    part_of_speech: "động từ",
    meaning:
      "(cũ) tụ tập nhau lại làm những việc xấu: tụ bạ nhau để rượu chè, cờ bạc",
    example: "tụ bạ nhau để rượu chè, cờ bạc",
  },
  {
    word: "tủ",
    part_of_speech: "danh từ",
    meaning:
      "đồ đựng, thường bằng gỗ, hình hộp để đứng, có ngăn và cánh cửa, dùng để cất, chứa đồ đạc: tủ sách * quần áo để trong tủ * nóc tủ",
    example: "tủ sách * quần áo để trong tủ * nóc tủ",
  },
  {
    word: "tủ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) cái được cho là có giá trị nhất, có tác dụng lớn, chỉ riêng mình có và biết, khi cần mới đưa ra để giành ưu thế: bài hát tủ * giở ngón tủ",
    example: "bài hát tủ * giở ngón tủ",
  },
  {
    word: "tủ",
    part_of_speech: "danh từ",
    meaning:
      "vấn đề đoán là sẽ được hỏi đến khi thi cử, nên tập trung học hoặc dạy vào đó để chuẩn bị: dạy tủ * học tủ * đề thi bị lệch tủ",
    example: "dạy tủ * học tủ * đề thi bị lệch tủ",
  },
  {
    word: "tủ",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) phủ: tủ vải bạt lên đống đồ đạc * tủ rơm rạ vào gốc cây",
    example: "tủ vải bạt lên đống đồ đạc * tủ rơm rạ vào gốc cây",
  },
  {
    word: "tù",
    part_of_speech: "danh từ",
    meaning:
      "người phạm tội bị giam giữ: tù kinh tế * tù chính trị * dẫn tù về trại",
    example: "tù kinh tế * tù chính trị * dẫn tù về trại",
  },
  {
    word: "tù",
    part_of_speech: "danh từ",
    meaning: "nhà tù: ngồi tù * vào tù * được ra tù",
    example: "ngồi tù * vào tù * được ra tù",
  },
  {
    word: "tù",
    part_of_speech: "động từ",
    meaning:
      "bị giam giữ ở trong tù vì phạm tội: phạt 20 năm tù * bị tù vì tội tham ô * mãn hạn tù",
    example: "phạt 20 năm tù * bị tù vì tội tham ô * mãn hạn tù",
  },
  {
    word: "tù",
    part_of_speech: "tính từ",
    meaning:
      "(nước) bị ứ đọng lại một chỗ, không chảy thoát đi đâu được: vũng nước tù",
    example: "vũng nước tù",
  },
  {
    word: "tù",
    part_of_speech: "tính từ",
    meaning: "không nhọn, mà hơi tròn đầu: dùng lâu ngày, mũi dùi bị tù",
    example: "dùng lâu ngày, mũi dùi bị tù",
  },
  {
    word: "tụ",
    part_of_speech: "động từ",
    meaning:
      "tập trung dần lại, đọng dần lại một nơi, làm cho đông thêm, nhiều thêm: bàn chân tụ máu * bọn trẻ tụ lại thành đám đông",
    example: "bàn chân tụ máu * bọn trẻ tụ lại thành đám đông",
  },
  {
    word: "tù cẳng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) cảm thấy tù túng, khó chịu vì bị bó buộc ở lâu một chỗ, ít được đi lại, hoạt động: ở nhà lâu cũng thấy tù cẳng",
    example: "ở nhà lâu cũng thấy tù cẳng",
  },
  {
    word: "tu bổ",
    part_of_speech: "động từ",
    meaning:
      "sửa chữa và làm thêm ít nhiều cho tốt, cho hoàn chỉnh hơn: tu bổ đê điều * tu bổ nhà cửa",
    example: "tu bổ đê điều * tu bổ nhà cửa",
  },
  {
    word: "tủ chè",
    part_of_speech: "danh từ",
    meaning:
      "tủ dài và thấp dùng để đựng ấm chén và bày các đồ vật đẹp, quý: tủ chè sập gụ",
    example: "tủ chè sập gụ",
  },
  {
    word: "tù binh",
    part_of_speech: "danh từ",
    meaning:
      "người của lực lượng vũ trang đối phương bị bắt trong chiến tranh: bị bắt làm tù binh * trao đổi tù binh",
    example: "bị bắt làm tù binh * trao đổi tù binh",
  },
  {
    word: "tu chí",
    part_of_speech: "động từ",
    meaning:
      "có ý thức tự sửa mình cho tốt hơn: tu chí học hành * tu chí làm ăn",
    example: "tu chí học hành * tu chí làm ăn",
  },
  {
    word: "tu chỉnh",
    part_of_speech: "động từ",
    meaning: "(cũ) sửa sang lại cho tốt hơn: tu chỉnh cầu cống, đê điều",
    example: "tu chỉnh cầu cống, đê điều",
  },
  {
    word: "tù đày",
    part_of_speech: "động từ",
    meaning:
      "bị giam giữ trong nhà tù và phải chịu mọi điều khổ sở, cực nhục: năm năm tù đày * thoát cảnh tù đày",
    example: "năm năm tù đày * thoát cảnh tù đày",
  },
  {
    word: "tu dưỡng",
    part_of_speech: "động từ",
    meaning:
      "rèn luyện, trau dồi để nâng cao phẩm chất: tu dưỡng tinh thần * tu dưỡng đạo đức",
    example: "tu dưỡng tinh thần * tu dưỡng đạo đức",
  },
  {
    word: "tụ cư",
    part_of_speech: "động từ",
    meaning:
      "tập trung sinh sống tại một khu vực: sống tụ cư ở đồng bằng * nơi tụ cư của nhiều loài động thực vật",
    example: "sống tụ cư ở đồng bằng * nơi tụ cư của nhiều loài động thực vật",
  },
  {
    word: "tụ điểm",
    part_of_speech: "danh từ",
    meaning:
      "điểm tập trung nhiều đầu mối của một hoạt động nào đó: tụ điểm ca nhạc * tụ điểm vui chơi, giải trí * tụ điểm kinh tế",
    example: "tụ điểm ca nhạc * tụ điểm vui chơi, giải trí * tụ điểm kinh tế",
  },
  {
    word: "tụ họp",
    part_of_speech: "động từ",
    meaning:
      "cùng nhau tập hợp lại một nơi với mục đích nhất định: mọi người đã tụ họp đông đủ * tụ họp nhau để bàn luận",
    example: "mọi người đã tụ họp đông đủ * tụ họp nhau để bàn luận",
  },
  {
    word: "tù đọng",
    part_of_speech: "",
    meaning:
      "ở tình trạng chất bẩn bị ứ đọng lại lâu ngày, không thoát đi được: ao hồ tù đọng",
    example: "ao hồ tù đọng",
  },
  {
    word: "tù giam",
    part_of_speech: "động từ",
    meaning:
      "(án tù) bị giam thật sự; phân biệt với án treo: chịu hình phạt hai năm tù giam",
    example: "chịu hình phạt hai năm tù giam",
  },
  {
    word: "tù hãm",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) (nước ao hồ) bị đọng lại lâu ngày không thoát ra nơi khác được: ao nước tù hãm",
    example: "ao nước tù hãm",
  },
  {
    word: "tù hãm",
    part_of_speech: "tính từ",
    meaning:
      "ở hoàn cảnh sống tù túng không có lối thoát: sống trong cảnh tù hãm",
    example: "sống trong cảnh tù hãm",
  },
  {
    word: "tu hành",
    part_of_speech: "động từ",
    meaning:
      "rời bỏ cuộc sống đời thường để tu theo một tôn giáo nào đó (nói khái quát): tu hành theo đạo Phật * nhà tu hành",
    example: "tu hành theo đạo Phật * nhà tu hành",
  },
  {
    word: "tụ hội",
    part_of_speech: "động từ",
    meaning:
      "(văn chương) từ khắp nơi về họp lại với nhau một chỗ: du khách bốn phương tụ hội về lễ Phật",
    example: "du khách bốn phương tụ hội về lễ Phật",
  },
  {
    word: "tú hụ",
    part_of_speech: "tính từ",
    meaning: "như tú ụ: bát cơm đầy tú hụ",
    example: "bát cơm đầy tú hụ",
  },
  {
    word: "tu huýt",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) còi nhỏ, dùng làm đồ chơi: thổi tu huýt",
    example: "thổi tu huýt",
  },
  {
    word: "tú khẩu cẩm tâm",
    part_of_speech: "",
    meaning:
      '(cũ, văn chương) như cẩm tâm tú khẩu: "Xem thơ nức nở khen thầm, Giá đành tú khẩu, cẩm tâm khác thường!" (TKiều)',
    example:
      'Xem thơ nức nở khen thầm, Giá đành tú khẩu, cẩm tâm khác thường!" (TKiều)',
  },
  {
    word: "tu luyện",
    part_of_speech: "động từ",
    meaning:
      "tu hành và luyện tập công phu (thường chỉ nói về Đạo giáo): tu luyện thành tiên * khổ công tu luyện",
    example: "tu luyện thành tiên * khổ công tu luyện",
  },
  {
    word: "tu luyện",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) tu dưỡng và rèn luyện: tu luyện thành tài * tu luyện nhân cách",
    example: "tu luyện thành tài * tu luyện nhân cách",
  },
  {
    word: "tu kín",
    part_of_speech: "động từ",
    meaning:
      "(người theo đạo Kitô) tu ở một nơi riêng biệt, không giao thiệp với người đời: nhà tu kín",
    example: "nhà tu kín",
  },
  {
    word: "tú lơ khơ",
    part_of_speech: "danh từ",
    meaning:
      "bài lá gồm năm mươi tư quân, dùng cho nhiều lối chơi bài khác nhau: chơi tú lơ khơ",
    example: "chơi tú lơ khơ",
  },
  {
    word: "tu mi",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) mày râu: tu mi nam tử * "Tu mi tỏ mặt trượng phu, Đem trung hiếu để trả thù non sông." (SKTT)',
    example:
      'tu mi nam tử * "Tu mi tỏ mặt trượng phu, Đem trung hiếu để trả thù non sông." (SKTT)',
  },
  {
    word: "tù mù",
    part_of_speech: "tính từ",
    meaning: "như lù mù: ánh đèn dầu tù mù",
    example: "ánh đèn dầu tù mù",
  },
  {
    word: "tù mù",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có cái gì đó không rõ ràng, không minh bạch: kiểu tính toán tù mù * làm ăn tù mù",
    example: "kiểu tính toán tù mù * làm ăn tù mù",
  },
  {
    word: "tụ nghĩa",
    part_of_speech: "động từ",
    meaning:
      "(cũ) từ các nơi tập hợp nhau lại để làm việc đại nghĩa: Lam Sơn từng là nơi tụ nghĩa của hào kiệt bốn phương",
    example: "Lam Sơn từng là nơi tụ nghĩa của hào kiệt bốn phương",
  },
  {
    word: "tù ngồi",
    part_of_speech: "động từ",
    meaning: "(cũ) như tù giam: bị kết án sáu năm tù ngồi",
    example: "bị kết án sáu năm tù ngồi",
  },
  {
    word: "tu nghiệp sinh",
    part_of_speech: "danh từ",
    meaning:
      "người đi tu nghiệp ở nước ngoài: gặp mặt các tu nghiệp sinh Việt Nam ở Nga",
    example: "gặp mặt các tu nghiệp sinh Việt Nam ở Nga",
  },
  {
    word: "tu sĩ",
    part_of_speech: "danh từ",
    meaning: "người tu hành (thường nói về đạo Kitô): nữ tu sĩ",
    example: "nữ tu sĩ",
  },
  {
    word: "tu sửa",
    part_of_speech: "động từ",
    meaning: "sửa lại cho hợp lí và tốt hơn: tu sửa lại nhà cửa",
    example: "tu sửa lại nhà cửa",
  },
  {
    word: "tù nhân",
    part_of_speech: "danh từ",
    meaning: "người bị cầm tù: tù nhân chính trị",
    example: "tù nhân chính trị",
  },
  {
    word: "tu nghiệp",
    part_of_speech: "động từ",
    meaning: "trau dồi nghiệp vụ: đi tu nghiệp ở nước ngoài",
    example: "đi tu nghiệp ở nước ngoài",
  },
  {
    word: "tủ sách",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp sách, báo dùng cho cá nhân, gia đình hay một tập thể nhỏ: tủ sách gia đình",
    example: "tủ sách gia đình",
  },
  {
    word: "tủ sách",
    part_of_speech: "danh từ",
    meaning:
      "những sách cùng một loại của cùng một nhà xuất bản, giới thiệu từng vấn đề khác nhau, nhưng có thể cùng theo một chủ đề nhằm phục vụ một đối tượng nhất định (nói tổng quát): tủ sách pháp luật * tủ sách thiếu nhi",
    example: "tủ sách pháp luật * tủ sách thiếu nhi",
  },
  {
    word: "tủ sắt",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) két (đựng tiền bạc và những thứ quan trọng): tiền cất trong tủ sắt",
    example: "tiền cất trong tủ sắt",
  },
  {
    word: "tu tạo",
    part_of_speech: "động từ",
    meaning: "sửa chữa và xây dựng lại hoặc xây dựng thêm: tu tạo đình miếu",
    example: "tu tạo đình miếu",
  },
  {
    word: "tù tì",
    part_of_speech: "phụ từ",
    meaning: "(khẩu ngữ, hiếm) như liền tù tì: đánh một giấc tù tì tới sáng",
    example: "đánh một giấc tù tì tới sáng",
  },
  {
    word: "tú tài",
    part_of_speech: "danh từ",
    meaning: "(cũ) học vị của người đỗ khoa thi hương, dưới cử nhân: đỗ tú tài",
    example: "đỗ tú tài",
  },
  {
    word: "tu thân",
    part_of_speech: "động từ",
    meaning:
      '(cũ) tu dưỡng về đạo đức: "Làm trai quyết chí tu thân, Công danh chớ vội, nợ nần chớ lo." (ca dao)',
    example:
      'Làm trai quyết chí tu thân, Công danh chớ vội, nợ nần chớ lo." (ca dao)',
  },
  {
    word: "tụ tập",
    part_of_speech: "động từ",
    meaning:
      "tụ họp nhau lại thành đám đông: bọn trẻ tụ tập ngoài bãi bóng * tụ tập nhau lại để nhậu nhẹt",
    example: "bọn trẻ tụ tập ngoài bãi bóng * tụ tập nhau lại để nhậu nhẹt",
  },
  {
    word: "tù tội",
    part_of_speech: "động từ",
    meaning: "ở tù, về mặt chịu khổ cực (nói khái quát): lâm vào cảnh tù tội",
    example: "lâm vào cảnh tù tội",
  },
  {
    word: "tu thư",
    part_of_speech: "động từ",
    meaning: "(cũ) biên soạn sách giáo khoa: ban tu thư",
    example: "ban tu thư",
  },
  {
    word: "tù túng",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái các hoạt động bị hạn chế trong một phạm vi chật hẹp, cảm thấy gò bó, không thoải mái: cuộc sống chật hẹp, tù túng",
    example: "cuộc sống chật hẹp, tù túng",
  },
  {
    word: "tu tỉnh",
    part_of_speech: "động từ",
    meaning: "nhận ra lỗi lầm của bản thân và tự sửa chữa: tu tỉnh mà làm ăn",
    example: "tu tỉnh mà làm ăn",
  },
  {
    word: "tù treo",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tù án treo; phân biệt với tù giam: cho hưởng 18 tháng tù treo",
    example: "cho hưởng 18 tháng tù treo",
  },
  {
    word: "tu từ",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về tu từ học, có tính chất của tu từ học: biện pháp tu từ * câu hỏi tu từ",
    example: "biện pháp tu từ * câu hỏi tu từ",
  },
  {
    word: "tú ụ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) đầy, nhiều đến mức như chồng chất lên thành ụ, thành ngọn, không thể chứa thêm được nữa: bát cơm đầy tú ụ * gác xép xếp tú ụ đồ đạc",
    example: "bát cơm đầy tú ụ * gác xép xếp tú ụ đồ đạc",
  },
  {
    word: "tua",
    part_of_speech: "danh từ",
    meaning:
      "vật trang trí gồm nhiều sợi nhỏ, mềm, có màu sắc, thường viền xung quanh hoặc để rủ xuống cho đẹp: tua cờ * áo có gắn tua",
    example: "tua cờ * áo có gắn tua",
  },
  {
    word: "tua",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận nhỏ và mềm, có hình giống như cái tua: tua cá mực * tua hoa cau",
    example: "tua cá mực * tua hoa cau",
  },
  {
    word: "tua",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) vòng, lượt: tua biểu diễn * tua du lịch * đổi tua gác",
    example: "tua biểu diễn * tua du lịch * đổi tua gác",
  },
  {
    word: "tua",
    part_of_speech: "động từ",
    meaning:
      "làm cho băng (hình hoặc nhạc) quay đến đúng vị trí cần sử dụng: tua băng * tua lại đoạn đầu của bộ phim",
    example: "tua băng * tua lại đoạn đầu của bộ phim",
  },
  {
    word: "tua rua",
    part_of_speech: "danh từ",
    meaning:
      "cụm sao nhỏ kết thành một đám lờ mờ, thấy được vào lúc sáng sớm đầu tháng sáu dương lịch: chòm sao tua rua",
    example: "chòm sao tua rua",
  },
  {
    word: "túa",
    part_of_speech: "động từ",
    meaning:
      "chảy ra, tuôn tràn ra: nước túa thành dòng * ngón chân bị vấp, túa máu * túa mồ hôi",
    example: "nước túa thành dòng * ngón chân bị vấp, túa máu * túa mồ hôi",
  },
  {
    word: "túa",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) kéo nhau ra nơi nào đó cùng một lúc rất đông, không có trật tự: ong vỡ tổ bay túa ra * chạy túa ra",
    example: "ong vỡ tổ bay túa ra * chạy túa ra",
  },
  {
    word: "tủa",
    part_of_speech: "động từ",
    meaning:
      "(nhiều vật cứng, nhọn) đâm thẳng ra nhiều phía: rễ tủa ra xung quanh * xương rồng tủa gai",
    example: "rễ tủa ra xung quanh * xương rồng tủa gai",
  },
  {
    word: "tủa",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) toả ra khắp các ngả cùng một lúc rất nhiều, không có trật tự: mọi người tủa ra các phía",
    example: "mọi người tủa ra các phía",
  },
  {
    word: "tù và",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ dùng để báo hiệu thời trước, làm bằng sừng trâu, bò hoặc vỏ ốc, dùng hơi để thổi, tiếng vang trầm và xa: thổi tù và * ăn cơm nhà vác tù và hàng tổng (tng)",
    example: "thổi tù và * ăn cơm nhà vác tù và hàng tổng (tng)",
  },
  {
    word: "tua tủa",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả dáng chĩa ra không đều của nhiều vật cứng, nhọn, gây cảm giác ghê sợ: râu mọc tua tủa * bờ tường cắm mảnh chai tua tủa",
    example: "râu mọc tua tủa * bờ tường cắm mảnh chai tua tủa",
  },
  {
    word: "tuần",
    part_of_speech: "danh từ",
    meaning: "tuần lễ (nói tắt): ở chơi một tuần * hai ngày nghỉ cuối tuần",
    example: "ở chơi một tuần * hai ngày nghỉ cuối tuần",
  },
  {
    word: "tuần",
    part_of_speech: "danh từ",
    meaning:
      'khoảng thời gian nhất định: tuần trăng sáng * "Phong lưu rất mực hồng quần, Xuân xanh xấp xỉ tới tuần cập kê." (TKiều)',
    example:
      'tuần trăng sáng * "Phong lưu rất mực hồng quần, Xuân xanh xấp xỉ tới tuần cập kê." (TKiều)',
  },
  {
    word: "tuần",
    part_of_speech: "danh từ",
    meaning: "đợt, lượt: thắp một tuần hương * uống mấy tuần trà * tuần chay",
    example: "thắp một tuần hương * uống mấy tuần trà * tuần chay",
  },
  {
    word: "tuần",
    part_of_speech: "danh từ",
    meaning:
      "lễ cúng người mới chết, sau bảy ngày hoặc một số lần bảy ngày (hai mươi mốt ngày, bốn mươi chín ngày), và khi tròn một trăm ngày, theo tục lệ cổ truyền: cúng tuần * làm tuần * đến tuần bốn chín ngày",
    example: "cúng tuần * làm tuần * đến tuần bốn chín ngày",
  },
  {
    word: "tuần",
    part_of_speech: "động từ",
    meaning:
      "đi để quan sát, xem xét trong một khu vực nhằm giữ gìn trật tự, an ninh: xe tuần đường",
    example: "xe tuần đường",
  },
  {
    word: "tuần duyên",
    part_of_speech: "động từ",
    meaning: "tuần phòng vùng ven biển hoặc gần bờ biển: tàu tuần duyên",
    example: "tàu tuần duyên",
  },
  {
    word: "tuần báo",
    part_of_speech: "danh từ",
    meaning: "báo ra mỗi tuần lễ một kì: tuần báo du lịch * đi mua tờ tuần báo",
    example: "tuần báo du lịch * đi mua tờ tuần báo",
  },
  {
    word: "tuân",
    part_of_speech: "động từ",
    meaning:
      "làm đúng theo một cách có ý thức điều đã định ra hoặc coi như đã được định ra: tuân lệnh * tuân theo pháp luật",
    example: "tuân lệnh * tuân theo pháp luật",
  },
  {
    word: "tuần hoàn",
    part_of_speech: "động từ",
    meaning:
      "lặp đi lặp lại đều đặn sau những khoảng thời gian bằng nhau (gọi là chu kì): chuyển động tuần hoàn của mặt trời * bốn mùa luân chuyển tuần hoàn",
    example:
      "chuyển động tuần hoàn của mặt trời * bốn mùa luân chuyển tuần hoàn",
  },
  {
    word: "tuần hoàn",
    part_of_speech: "động từ",
    meaning:
      "(máu) chuyển vận từ tim đi khắp cơ thể rồi lại trở về tim: bộ máy tuần hoàn * bị rối loạn tuần hoàn não",
    example: "bộ máy tuần hoàn * bị rối loạn tuần hoàn não",
  },
  {
    word: "tuấn kiệt",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) người có tài trí hơn hẳn người thường (thường nói về người đàn ông còn trẻ): "Tuấn kiệt như sao buổi sớm, Nhân tài như lá mùa thu." (BNĐC)',
    example: 'Tuấn kiệt như sao buổi sớm, Nhân tài như lá mùa thu." (BNĐC)',
  },
  {
    word: "tuần hành",
    part_of_speech: "động từ",
    meaning: "(cũ) đi điều tra, xem xét tình hình thực tế: vua đi tuần hành",
    example: "vua đi tuần hành",
  },
  {
    word: "tuần hành",
    part_of_speech: "động từ",
    meaning:
      "diễu hành trên các đường phố để biểu dương lực lượng và biểu thị thái độ chính trị đối với những vấn đề quan trọng: tuần hành thị uy * tuần hành phản đối chiến tranh",
    example: "tuần hành thị uy * tuần hành phản đối chiến tranh",
  },
  {
    word: "tuần lễ",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian bảy ngày, từ thứ hai đến chủ nhật: tuần lễ cuối tháng",
    example: "tuần lễ cuối tháng",
  },
  {
    word: "tuần lễ",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian bảy ngày bất kì: được nghỉ phép một tuần lễ * tuần lễ liên hoan phim quốc tế",
    example: "được nghỉ phép một tuần lễ * tuần lễ liên hoan phim quốc tế",
  },
  {
    word: "tuấn mã",
    part_of_speech: "danh từ",
    meaning: "ngựa đẹp và khoẻ, phi nhanh: con tuấn mã",
    example: "con tuấn mã",
  },
  {
    word: "tuần thú",
    part_of_speech: "động từ",
    meaning:
      "(cũ) (vua) đi xem xét tình hình các nơi xa kinh đô: nhà vua đi tuần thú",
    example: "nhà vua đi tuần thú",
  },
  {
    word: "tuần phòng",
    part_of_speech: "động từ",
    meaning: "tuần tra và canh phòng: tuần phòng cẩn mật",
    example: "tuần phòng cẩn mật",
  },
  {
    word: "tuân thủ",
    part_of_speech: "động từ",
    meaning:
      "giữ và làm đúng theo điều đã quy định: tuân thủ nguyên tắc * tuân thủ luật pháp",
    example: "tuân thủ nguyên tắc * tuân thủ luật pháp",
  },
  {
    word: "tuần ti",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) việc kiểm soát và đánh thuế hàng hoá vận chuyển từ nơi này đến nơi khác, thời phong kiến: sở tuần ti * thuế tuần ti",
    example: "sở tuần ti * thuế tuần ti",
  },
  {
    word: "tuẫn tiết",
    part_of_speech: "động từ",
    meaning:
      "(cũ, trang trọng) tự tử để bảo toàn khí tiết: tổng đốc Hoàng Diệu đã tuẫn tiết khi Hà thành thất thủ",
    example: "tổng đốc Hoàng Diệu đã tuẫn tiết khi Hà thành thất thủ",
  },
  {
    word: "tuần tiễu",
    part_of_speech: "động từ",
    meaning:
      "tuần tra để phát hiện và diệt trừ quân đối địch nếu có, nhằm giữ gìn an ninh: đi tuần tiễu * tàu tuần tiễu trên vịnh Bắc Bộ",
    example: "đi tuần tiễu * tàu tuần tiễu trên vịnh Bắc Bộ",
  },
  {
    word: "tuấn tú",
    part_of_speech: "tính từ",
    meaning:
      "(người con trai) có vẻ mặt đẹp, sáng sủa, thông minh: khuôn mặt khôi ngô tuấn tú",
    example: "khuôn mặt khôi ngô tuấn tú",
  },
  {
    word: "tuần trăng mật",
    part_of_speech: "danh từ",
    meaning:
      "những ngày đầu sau lễ cưới, được xem là thời gian đằm thắm, hạnh phúc nhất của cuộc sống vợ chồng: đi hưởng tuần trăng mật",
    example: "đi hưởng tuần trăng mật",
  },
  {
    word: "tuần tự",
    part_of_speech: "phụ từ",
    meaning:
      "theo một trình tự nhất định: làm tuần tự từng bước * công việc được tiến hành theo tuần tự",
    example: "làm tuần tự từng bước * công việc được tiến hành theo tuần tự",
  },
  {
    word: "tuất",
    part_of_speech: "danh từ",
    meaning:
      "(thường viết hoa) kí hiệu thứ mười một trong địa chi (lấy chó làm tượng trưng; sau dậu trước hợi), dùng trong phép đếm thời gian cổ truyền của Trung Quốc và một số nước châu á, trong đó có Việt Nam: giờ Tuất (từ 19 đến 21 giờ) * tuổi Tuất * năm Bính Tuất",
    example: "giờ Tuất (từ 19 đến 21 giờ) * tuổi Tuất * năm Bính Tuất",
  },
  {
    word: "tuất",
    part_of_speech: "danh từ",
    meaning: "tiền tuất (nói tắt): nhận tuất",
    example: "nhận tuất",
  },
  {
    word: "tuần trăng",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương) chu kì mặt trăng xuất hiện trên bầu trời mà ta nhìn thấy từ đầu đến cuối tháng âm lịch; dùng để chỉ tháng âm lịch: ra đi đã tròn một tuần trăng",
    example: "ra đi đã tròn một tuần trăng",
  },
  {
    word: "tuần tra",
    part_of_speech: "động từ",
    meaning: "đi tuần: tuần tra biên giới * lực lượng tuần tra",
    example: "tuần tra biên giới * lực lượng tuần tra",
  },
  {
    word: "túc cầu",
    part_of_speech: "danh từ",
    meaning:
      "môn thể thao chia thành hai đội, cầu thủ dùng chân điều khiển bóng và tìm cách dùng chân hoặc đầu đưa bóng lọt vào khung thành của đối phương: cầu thủ bóng đá * giải bóng đá thế giới",
    example: "cầu thủ bóng đá * giải bóng đá thế giới",
  },
  {
    word: "túc",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) thổi cho kêu: túc một hồi còi",
    example: "túc một hồi còi",
  },
  {
    word: "tục",
    part_of_speech: "danh từ",
    meaning:
      "thói quen từ lâu đời trong đời sống nhân dân, được mọi người nói chung công nhận và làm theo: tục ăn trầu * tục thách cưới",
    example: "tục ăn trầu * tục thách cưới",
  },
  {
    word: "tục",
    part_of_speech: "danh từ",
    meaning:
      "cõi đời trên mặt đất, coi là vật chất, tầm thường, không thanh cao, đối lập với cõi thần tiên hoặc nói chung một thế giới tưởng tượng nào đó: thoát tục * xa lánh cõi tục",
    example: "thoát tục * xa lánh cõi tục",
  },
  {
    word: "tục",
    part_of_speech: "danh từ",
    meaning:
      "người đời (dùng trong dân gian, phân biệt với trong sách vở): làng Phù Đổng, tục gọi là làng Gióng",
    example: "làng Phù Đổng, tục gọi là làng Gióng",
  },
  {
    word: "tục",
    part_of_speech: "tính từ",
    meaning:
      "thô bỉ, thiếu lịch sự, thiếu văn hoá: nói tục * lỡ mồm văng tục * ăn tục nói phét",
    example: "nói tục * lỡ mồm văng tục * ăn tục nói phét",
  },
  {
    word: "tục lệ",
    part_of_speech: "danh từ",
    meaning:
      "điều quy định có từ lâu đời, đã trở thành thói quen trong đời sống xã hội (nói khái quát): cưới xin theo tục lệ truyền thống * xoá bỏ những tục lệ lạc hậu",
    example: "cưới xin theo tục lệ truyền thống * xoá bỏ những tục lệ lạc hậu",
  },
  {
    word: "túc khiên",
    part_of_speech: "danh từ",
    meaning:
      'tội lỗi từ kiếp trước, theo quan niệm của đạo Phật: "(...) Túc khiên đã rửa lâng lâng sạch rồi." (TKiều)',
    example: '(...) Túc khiên đã rửa lâng lâng sạch rồi." (TKiều)',
  },
  {
    word: "tục luỵ",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) mối ràng buộc ở cõi đời làm con người phải chịu nhiều khổ ải: thoát vòng tục luỵ * "Mùi tục luỵ dường kia cay đắng, Vui chi mà đeo đẳng trần duyên." (CO)',
    example:
      'thoát vòng tục luỵ * "Mùi tục luỵ dường kia cay đắng, Vui chi mà đeo đẳng trần duyên." (CO)',
  },
  {
    word: "túc nho",
    part_of_speech: "danh từ",
    meaning: "(cũ) nhà nho có học vấn uyên thâm: bậc túc nho",
    example: "bậc túc nho",
  },
  {
    word: "tục ngữ",
    part_of_speech: "danh từ",
    meaning:
      "câu ngắn gọn, thường có vần điệu, đúc kết tri thức, kinh nghiệm sống và đạo đức thực tiễn của nhân dân: tục ngữ có câu",
    example: "tục ngữ có câu",
  },
  {
    word: "tục huyền",
    part_of_speech: "động từ",
    meaning:
      "(cũ, văn chương) lấy vợ khác, sau khi vợ trước chết: vợ chết đã lâu nhưng vẫn chưa tục huyền",
    example: "vợ chết đã lâu nhưng vẫn chưa tục huyền",
  },
  {
    word: "túc tắc",
    part_of_speech: "phụ từ",
    meaning:
      "(Khẩu ngữ) (làm việc gì) thong thả, không nhanh, không nhiều, nhưng đều đặn: buôn bán túc tắc cũng đủ sống * túc tắc làm dần cũng xong",
    example: "buôn bán túc tắc cũng đủ sống * túc tắc làm dần cũng xong",
  },
  {
    word: "túc trái",
    part_of_speech: "danh từ",
    meaning: "nợ từ kiếp trước, theo quan niệm của đạo Phật: túc trái tiền oan",
    example: "túc trái tiền oan",
  },
  {
    word: "tục tĩu",
    part_of_speech: "tính từ",
    meaning:
      "tục một cách quá đáng và lộ liễu, trắng trợn: những lời chửi rủa tục tĩu * hình vẽ tục tĩu",
    example: "những lời chửi rủa tục tĩu * hình vẽ tục tĩu",
  },
  {
    word: "tục tằn",
    part_of_speech: "tính từ",
    meaning: "tục, thô lỗ (nói khái quát): nói năng tục tằn",
    example: "nói năng tục tằn",
  },
  {
    word: "tục truyền",
    part_of_speech: "động từ",
    meaning:
      "truyền khẩu lại từ xưa trong dân gian (thường dùng ở đầu lời kể một truyền thuyết): tục truyền ông Gióng dẹp giặc xong thì cưỡi ngựa sắt về trời",
    example: "tục truyền ông Gióng dẹp giặc xong thì cưỡi ngựa sắt về trời",
  },
  {
    word: "túc túc",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng gọi gà hoặc tiếng gà mái gọi con: gà mẹ túc túc gọi con",
    example: "gà mẹ túc túc gọi con",
  },
  {
    word: "túc trái tiền oan",
    part_of_speech: "",
    meaning:
      'nợ nần, oán thù từ kiếp trước để lại, nay phải trả, theo quan niệm đạo Phật: "Đã đành túc trái tiền oan, Cũng liều ngọc nát, hoa tàn mà chi!" (TKiều)',
    example:
      'Đã đành túc trái tiền oan, Cũng liều ngọc nát, hoa tàn mà chi!" (TKiều)',
  },
  {
    word: "túc trực",
    part_of_speech: "động từ",
    meaning:
      "có mặt thường xuyên ở bên cạnh để trông nom hoặc sẵn sàng làm việc gì: túc trực bên giường bệnh * túc trực điện thoại",
    example: "túc trực bên giường bệnh * túc trực điện thoại",
  },
  {
    word: "tuế nguyệt",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) năm và tháng; thường dùng trong văn chương để chỉ sự vận động của thời gian, nói chung: "Cũng đành tuế nguyệt phôi pha, Ngồi trông ngắm cảnh thế ra dường nào." (TS)',
    example:
      "Cũng đành tuế nguyệt phôi pha, Ngồi trông ngắm cảnh thế ra dường nào.",
  },
  {
    word: "tục tử",
    part_of_speech: "danh từ",
    meaning: "(cũ) kẻ tầm thường, thô tục: kẻ phàm phu tục tử * phường tục tử",
    example: "kẻ phàm phu tục tử * phường tục tử",
  },
  {
    word: "tuệch toạc",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) bộc tuệch (nói khái quát): tính tuệch toạc, có gì nói ra hết",
    example: "tính tuệch toạc, có gì nói ra hết",
  },
  {
    word: "tuế toá",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (nói năng) có vẻ dễ dãi, cốt cho xong, cho qua: nói tuế toá cho xong chuyện",
    example: "nói tuế toá cho xong chuyện",
  },
  {
    word: "tuềnh toàng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) đơn sơ, trống trải, vẻ tạm bợ: nhà cửa tuềnh toàng, chẳng có gì đáng giá",
    example: "nhà cửa tuềnh toàng, chẳng có gì đáng giá",
  },
  {
    word: "tuềnh toàng",
    part_of_speech: "tính từ",
    meaning:
      "(tính người) đơn giản và dễ dãi đến mức thiếu cẩn thận, thiếu chu đáo: tính nết tuềnh toàng * ăn mặc đơn giản đến mức tuềnh toàng",
    example: "tính nết tuềnh toàng * ăn mặc đơn giản đến mức tuềnh toàng",
  },
  {
    word: "tủi cực",
    part_of_speech: "tính từ",
    meaning:
      "cảm thấy tủi vì nỗi cực khổ của mình: tủi cực vì thân phận tôi đòi * chịu bao cay đắng, tủi cực",
    example: "tủi cực vì thân phận tôi đòi * chịu bao cay đắng, tủi cực",
  },
  {
    word: "túi",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận may liền vào áo hay quần, dùng để đựng vật nhỏ đem theo người: túi áo * túi ngực * hai tay thọc túi quần",
    example: "túi áo * túi ngực * hai tay thọc túi quần",
  },
  {
    word: "túi",
    part_of_speech: "danh từ",
    meaning:
      'đồ đựng bằng vải, da, cước, v.v. thường có quai xách: xách túi đi làm * "Tay cầm túi bạc kè kè, Nói quấy nói quá người nghe rầm rầm." (Cdao)',
    example:
      'xách túi đi làm * "Tay cầm túi bạc kè kè, Nói quấy nói quá người nghe rầm rầm." (Cdao)',
  },
  {
    word: "tui",
    part_of_speech: "đại từ",
    meaning: "(Nam, khẩu ngữ) tôi: Tui hông biết.",
    example: "Tui hông biết.",
  },
  {
    word: "tủi",
    part_of_speech: "động từ",
    meaning:
      'tự cảm thấy thương xót và buồn cho mình: gặp nhau vừa mừng vừa tủi * "Nghĩ đời mà tủi cho đời, Nín đi cũng tức, nói thời luỵ sa." (Cdao)',
    example:
      'gặp nhau vừa mừng vừa tủi * "Nghĩ đời mà tủi cho đời, Nín đi cũng tức, nói thời luỵ sa." (Cdao)',
  },
  {
    word: "túi bụi",
    part_of_speech: "tính từ",
    meaning:
      "dồn dập, chưa hết cái này đã tiếp đến cái khác, làm cho không kịp ứng phó: bận túi bụi * đấm đá túi bụi",
    example: "bận túi bụi * đấm đá túi bụi",
  },
  {
    word: "tụi",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) như bọn (ng2; nhưng hàm ý coi thường hơn hoặc thân mật hơn): tụi con nít * tụi bạn trong lớp * tụi buôn lậu",
    example: "tụi con nít * tụi bạn trong lớp * tụi buôn lậu",
  },
  {
    word: "túi bóng",
    part_of_speech: "danh từ",
    meaning:
      "túi bằng nylon mỏng, thường dùng để đựng các vật nhỏ, nhẹ: cho mớ rau vào túi bóng",
    example: "cho mớ rau vào túi bóng",
  },
  {
    word: "tủi hổ",
    part_of_speech: "tính từ",
    meaning:
      "tự lấy làm hổ thẹn và buồn cho mình: nỗi xót xa tủi hổ * tủi hổ vì những lỗi lầm của mình",
    example: "nỗi xót xa tủi hổ * tủi hổ vì những lỗi lầm của mình",
  },
  {
    word: "túi tham",
    part_of_speech: "danh từ",
    meaning:
      'lòng tham vô độ: "Đồ tế nhuyễn, của riêng tây, Sạch sành sanh vét cho đầy túi tham." (TKiều)',
    example:
      'Đồ tế nhuyễn, của riêng tây, Sạch sành sanh vét cho đầy túi tham." (TKiều)',
  },
  {
    word: "tủi nhục",
    part_of_speech: "tính từ",
    meaning:
      "tự thấy nhục nhã và xót xa, đau khổ: cuộc sống tủi nhục * nỗi tủi nhục của người dân mất nước",
    example: "cuộc sống tủi nhục * nỗi tủi nhục của người dân mất nước",
  },
  {
    word: "túi mật",
    part_of_speech: "danh từ",
    meaning:
      "bọc chứa mật, hình quả trứng, nằm ở dưới gan: có sỏi trong túi mật",
    example: "có sỏi trong túi mật",
  },
  {
    word: "tủi hờn",
    part_of_speech: "",
    meaning:
      "cảm thấy buồn bã, xót xa cho thân phận mình và có ý như oán trách: giọt nước mắt tủi hờn * ánh mắt chất chứa tủi hờn",
    example: "giọt nước mắt tủi hờn * ánh mắt chất chứa tủi hờn",
  },
  {
    word: "túi tiền",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) số tiền đại khái có trong tay để có thể chi tiêu: túi tiền eo hẹp * chọn sản phẩm phù hợp với túi tiền",
    example: "túi tiền eo hẹp * chọn sản phẩm phù hợp với túi tiền",
  },
  {
    word: "tủi thân",
    part_of_speech: "động từ",
    meaning:
      "tủi cho bản thân mình: tủi thân vì bị mắng oan * tấm tức khóc vì tủi thân",
    example: "tủi thân vì bị mắng oan * tấm tức khóc vì tủi thân",
  },
  {
    word: "túm",
    part_of_speech: "động từ",
    meaning:
      "nắm giữ chặt trong tay: túm tóc * túm lấy cổ áo * vừa gặp đã túm lấy hỏi",
    example: "túm tóc * túm lấy cổ áo * vừa gặp đã túm lấy hỏi",
  },
  {
    word: "túm",
    part_of_speech: "động từ",
    meaning:
      "nắm hay buộc gộp các mép, các góc lại với nhau cho kín, cho gọn: buộc túm ống quần * túm bốn góc khăn lại",
    example: "buộc túm ống quần * túm bốn góc khăn lại",
  },
  {
    word: "túm",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) như tóm (ng2): túm được tên trộm",
    example: "túm được tên trộm",
  },
  {
    word: "túm",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ, hiếm) như xúm: mọi người túm lại xem rất đông",
    example: "mọi người túm lại xem rất đông",
  },
  {
    word: "túm",
    part_of_speech: "danh từ",
    meaning:
      "lượng những vật cùng loại có thể túm lại và nắm gọn trong bàn tay: một túm tóc * túm nhãn * bứt một túm lá",
    example: "một túm tóc * túm nhãn * bứt một túm lá",
  },
  {
    word: "tụm",
    part_of_speech: "động từ",
    meaning: "tụ lại, họp lại vào một chỗ với nhau: đứng tụm lại một chỗ",
    example: "đứng tụm lại một chỗ",
  },
  {
    word: "tũm",
    part_of_speech: "tính từ",
    meaning: "như tõm: quả sung rơi tũm xuống nước",
    example: "quả sung rơi tũm xuống nước",
  },
  {
    word: "tùm hum",
    part_of_speech: "tính từ",
    meaning: "như tùm hụp: khăn quấn tùm hum",
    example: "khăn quấn tùm hum",
  },
  {
    word: "tum húm",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) nhỏ, hẹp và chật chội: túp lều tum húm",
    example: "túp lều tum húm",
  },
  {
    word: "tùm hụp",
    part_of_speech: "tính từ",
    meaning:
      "thấp sụp xuống sát phía dưới và như che kín cả: mái tranh tùm hụp * mũ kéo tùm hụp xuống tận mắt",
    example: "mái tranh tùm hụp * mũ kéo tùm hụp xuống tận mắt",
  },
  {
    word: "tùm lum tà la",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ, khẩu ngữ) như tùm lum (nhưng ý nhấn mạnh hơn): đồ đạc bỏ tùm lum tà la",
    example: "đồ đạc bỏ tùm lum tà la",
  },
  {
    word: "tùm",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng vật to và nặng rơi xuống nước: nhảy tùm xuống ao",
    example: "nhảy tùm xuống ao",
  },
  {
    word: "túm năm tụm ba",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) xúm nhau lại thành những nhóm nhỏ: ngồi túm năm tụm ba lại bàn tán",
    example: "ngồi túm năm tụm ba lại bàn tán",
  },
  {
    word: "tum húp",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như húp (nhưng ý mức độ nhiều hơn): mắt sưng tum húp",
    example: "mắt sưng tum húp",
  },
  {
    word: "tun hủn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) quá ngắn, đến mức không bình thường (hàm ý chê): ngón tay mập và ngắn tun hủn * cái váy ngắn tun hủn",
    example: "ngón tay mập và ngắn tun hủn * cái váy ngắn tun hủn",
  },
  {
    word: "tùm tũm",
    part_of_speech: "tính từ",
    meaning: "như tòm tõm: ếch nhái nhảy tùm tũm xuống ao",
    example: "ếch nhái nhảy tùm tũm xuống ao",
  },
  {
    word: "tùm lum",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ở trạng thái lan rộng ra một cách lộn xộn và tựa như không có giới hạn, chỗ nào cũng thấy có: cỏ mọc tùm lum * kiện cáo tùm lum",
    example: "cỏ mọc tùm lum * kiện cáo tùm lum",
  },
  {
    word: "túm tụm",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) từ gợi tả trạng thái xúm nhau lại, dồn thật sát vào nhau trên một khoảng hẹp: ngồi túm tụm lại một chỗ * túm tụm nhau lại để nói chuyện",
    example: "ngồi túm tụm lại một chỗ * túm tụm nhau lại để nói chuyện",
  },
  {
    word: "tun hút",
    part_of_speech: "tính từ",
    meaning:
      "sâu tít mãi vào thành một đường hẹp và dài: đường hầm sâu tun hút * ngôi nhà tun hút tận cuối ngõ",
    example: "đường hầm sâu tun hút * ngôi nhà tun hút tận cuối ngõ",
  },
  {
    word: "tùng",
    part_of_speech: "danh từ",
    meaning:
      '(văn chương) cây thông: "Không ai hôm sớm bạn cùng, Nương mai mai gãy, dựa tùng tùng xiêu." (ca dao)',
    example:
      'Không ai hôm sớm bạn cùng, Nương mai mai gãy, dựa tùng tùng xiêu." (ca dao)',
  },
  {
    word: "tùng",
    part_of_speech: "tính từ",
    meaning: "từ mô phỏng tiếng trống lớn: trống đánh tùng tùng",
    example: "trống đánh tùng tùng",
  },
  {
    word: "tủn mủn",
    part_of_speech: "tính từ",
    meaning:
      "quá vụn vặt và nhỏ mọn đến mức gây cảm giác khó chịu: tính toán tủn mủn",
    example: "tính toán tủn mủn",
  },
  {
    word: "tủm tỉm",
    part_of_speech: "động từ",
    meaning:
      "từ gợi tả kiểu cười không mở miệng, chỉ thấy cử động đôi môi một cách kín đáo: tủm tỉm cười một mình",
    example: "tủm tỉm cười một mình",
  },
  {
    word: "tung",
    part_of_speech: "động từ",
    meaning:
      "làm cho di chuyển mạnh và đột ngột lên cao: tung bóng cho bạn * tung chân sút * gió thổi tung bụi lên",
    example: "tung bóng cho bạn * tung chân sút * gió thổi tung bụi lên",
  },
  {
    word: "tung",
    part_of_speech: "động từ",
    meaning:
      "làm cho đột ngột mở rộng mạnh ra, gần như ở mọi hướng: tung chăn vùng dậy * tung lưới đánh cá * mở tung cánh cửa * mái tóc xổ tung",
    example:
      "tung chăn vùng dậy * tung lưới đánh cá * mở tung cánh cửa * mái tóc xổ tung",
  },
  {
    word: "tung",
    part_of_speech: "động từ",
    meaning:
      "đưa ra cùng một lúc, nhằm mọi hướng: tung hàng ra bán * tung tiền ra mua để tích trữ * tung tin đồn nhảm",
    example:
      "tung hàng ra bán * tung tiền ra mua để tích trữ * tung tin đồn nhảm",
  },
  {
    word: "tung",
    part_of_speech: "động từ",
    meaning:
      "làm cho rời ra thành nhiều mảnh và bật đi theo mọi hướng: mìn nổ tung * nhà cửa bị phá tung",
    example: "mìn nổ tung * nhà cửa bị phá tung",
  },
  {
    word: "tung",
    part_of_speech: "động từ",
    meaning:
      "làm cho các bộ phận tách rời ra một cách lộn xộn, không còn trật tự nào cả: lục tung va li * tháo tung cái máy * làm rối tung mọi việc",
    example: "lục tung va li * tháo tung cái máy * làm rối tung mọi việc",
  },
  {
    word: "tùng bách",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, văn chương) các cây thuộc loài thông (nói khái quát); thường dùng để ví lòng kiên trinh: sống hiên ngang như tùng bách",
    example: "sống hiên ngang như tùng bách",
  },
  {
    word: "túng",
    part_of_speech: "tính từ",
    meaning:
      "ở vào hoàn cảnh thiếu thốn tiền nong, gặp khó khăn trong sinh hoạt vật chất hằng ngày: túng tiền tiêu * đói ăn vụng, túng làm càn (tng)",
    example: "túng tiền tiêu * đói ăn vụng, túng làm càn (tng)",
  },
  {
    word: "túng",
    part_of_speech: "tính từ",
    meaning:
      "ở vào thế gặp khó khăn mà chưa tìm được cách giải quyết: làm thơ túng vần * cờ túng nước",
    example: "làm thơ túng vần * cờ túng nước",
  },
  {
    word: "tụng",
    part_of_speech: "động từ",
    meaning: "đọc kinh Phật với giọng to, đều đều: tụng kinh niệm Phật",
    example: "tụng kinh niệm Phật",
  },
  {
    word: "tung hê",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) vứt bỏ đi, một cách không tiếc: tức quá, tung hê cả mâm cơm",
    example: "tức quá, tung hê cả mâm cơm",
  },
  {
    word: "túng bấn",
    part_of_speech: "tính từ",
    meaning:
      'túng quá đến mức không còn biết xoay xở, giải quyết ra sao (nói khái quát): cảnh nhà túng bấn * "Nợ ai vay chín trả mười, Phòng khi túng bấn có người cho vay." (ca dao)',
    example:
      'cảnh nhà túng bấn * "Nợ ai vay chín trả mười, Phòng khi túng bấn có người cho vay." (ca dao)',
  },
  {
    word: "tung hoành",
    part_of_speech: "động từ",
    meaning:
      'hoạt động một cách mạnh mẽ và ngang dọc theo ý muốn, không gì ngăn cản nổi: mặc sức tung hoành * "Một tay gây dựng cơ đồ, Bấy lâu bể Sở, sông Ngô tung hoành!" (TKiều)',
    example:
      'mặc sức tung hoành * "Một tay gây dựng cơ đồ, Bấy lâu bể Sở, sông Ngô tung hoành!" (TKiều)',
  },
  {
    word: "tung hứng",
    part_of_speech: "động từ",
    meaning:
      "tung lên rồi đón bắt một cách khéo léo: biểu diễn trò tung hứng * kẻ tung người hứng",
    example: "biểu diễn trò tung hứng * kẻ tung người hứng",
  },
  {
    word: "tụng ca",
    part_of_speech: "động từ",
    meaning: "(cũ, hiếm) như ca tụng: những lời tụng ca đất nước",
    example: "những lời tụng ca đất nước",
  },
  {
    word: "tung hô",
    part_of_speech: "động từ",
    meaning: "cùng hô to lên những tiếng chúc tụng vua chúa: tung hô vạn tuế",
    example: "tung hô vạn tuế",
  },
  {
    word: "tung hô",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) cùng hô to những lời chào mừng kèm theo những cử chỉ biểu thị sự hoan nghênh nhiệt liệt: được mọi người tung hô, tán thưởng",
    example: "được mọi người tung hô, tán thưởng",
  },
  {
    word: "tùng phèo",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) như lộn phèo (nhưng nghĩa mạnh hơn và hàm ý hài hước): ngã lộn tùng phèo * cãi nhau lộn tùng phèo",
    example: "ngã lộn tùng phèo * cãi nhau lộn tùng phèo",
  },
  {
    word: "tung lưới",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) làm cho lưới của khung thành đối phương bật rung lên khi đưa bóng lọt vào để tạo bàn thắng: sút tung lưới đối phương",
    example: "sút tung lưới đối phương",
  },
  {
    word: "tụng niệm",
    part_of_speech: "động từ",
    meaning: "tụng kinh và niệm Phật (nói khái quát): chắp tay tụng niệm",
    example: "chắp tay tụng niệm",
  },
  {
    word: "tùng quân",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) cây thông và cây trúc; thường dùng để tượng trưng cho người trượng phu, quân tử: "Nghìn tầm nhờ bóng tùng quân, Tuyết sương che chở cho thân cát đằng." (TKiều)',
    example:
      'Nghìn tầm nhờ bóng tùng quân, Tuyết sương che chở cho thân cát đằng." (TKiều)',
  },
  {
    word: "tung tăng",
    part_of_speech: "động từ",
    meaning:
      "di chuyển không ngừng từ chỗ nọ đến chỗ kia với những động tác biểu thị sự vui thích (thường nói về trẻ con hoặc con vật nhỏ): bướm tung tăng bay lượn * bé chạy tung tăng trong vườn",
    example: "bướm tung tăng bay lượn * bé chạy tung tăng trong vườn",
  },
  {
    word: "tùng lâm",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) rừng rậm; thường dùng để chỉ nơi tu hành đạo Phật: "Gập ghềnh nhỡ bước thuyền quyên, Đem thân bồ liễu nương miền tùng lâm." (PT)',
    example:
      'Gập ghềnh nhỡ bước thuyền quyên, Đem thân bồ liễu nương miền tùng lâm." (PT)',
  },
  {
    word: "tung tẩy",
    part_of_speech: "động từ",
    meaning:
      "chuyển động lên xuống, qua lại một cách tự nhiên, liên tiếp, trông vui mắt: vừa đi vừa tung tẩy đôi tay * đôi quang gánh tung tẩy trên vai",
    example: "vừa đi vừa tung tẩy đôi tay * đôi quang gánh tung tẩy trên vai",
  },
  {
    word: "tung tẩy",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đi lại, hoạt động một cách tự do, thoải mái, tuỳ theo ý thích: được tự do, tha hồ tung tẩy",
    example: "được tự do, tha hồ tung tẩy",
  },
  {
    word: "túng quẫn",
    part_of_speech: "tính từ",
    meaning:
      "ở vào tình thế nghèo túng tới mức không có lối thoát (nói khái quát): lâm vào cảnh túng quẫn",
    example: "lâm vào cảnh túng quẫn",
  },
  {
    word: "tung tích",
    part_of_speech: "danh từ",
    meaning:
      "dấu vết giúp cho việc xác minh, tìm ra đối tượng: giấu kín tung tích * tìm cho ra tung tích kẻ gian",
    example: "giấu kín tung tích * tìm cho ra tung tích kẻ gian",
  },
  {
    word: "tung toé",
    part_of_speech: "động từ",
    meaning:
      "văng ra lung tung khắp mọi phía: bùn bắn tung toé * nước phụt lên tung toé * gạo vãi tung toé ra nhà",
    example:
      "bùn bắn tung toé * nước phụt lên tung toé * gạo vãi tung toé ra nhà",
  },
  {
    word: "tung thâm",
    part_of_speech: "danh từ",
    meaning: "chiều sâu của trận địa: đánh tung thâm * tiến vào tung thâm",
    example: "đánh tung thâm * tiến vào tung thâm",
  },
  {
    word: "túng thế",
    part_of_speech: "tính từ",
    meaning:
      "ở vào tình thế rất khó khăn, không có cách nào khác: túng thế làm liều",
    example: "túng thế làm liều",
  },
  {
    word: "túng thiếu",
    part_of_speech: "tính từ",
    meaning:
      "ở vào hoàn cảnh khó khăn, thiếu thốn về đời sống vật chất (nói khái quát): hoàn cảnh túng thiếu * giúp đỡ nhau lúc túng thiếu",
    example: "hoàn cảnh túng thiếu * giúp đỡ nhau lúc túng thiếu",
  },
  {
    word: "tùng tiệm",
    part_of_speech: "động từ",
    meaning: "dè sẻn và tạm cho là đủ trong việc chi dùng: chi tiêu tùng tiệm",
    example: "chi tiêu tùng tiệm",
  },
  {
    word: "tuổi hoa",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương) tuổi còn niên thiếu (ý nói lứa tuổi đẹp như hoa): lứa tuổi hoa * tạp chí tuổi hoa",
    example: "lứa tuổi hoa * tạp chí tuổi hoa",
  },
  {
    word: "tuổi đời",
    part_of_speech: "danh từ",
    meaning:
      "tuổi, nói về mặt thời gian con người đã sống trên đời và trong sự so sánh với cái gì đó: tuổi đời còn rất trẻ",
    example: "tuổi đời còn rất trẻ",
  },
  {
    word: "tuồi",
    part_of_speech: "động từ",
    meaning:
      "vận động tự di chuyển ở tư thế áp sát thân mình trên bề mặt, dọc theo vật gì: rắn tuồi ra khỏi hang * đứa bé tuồi xuống khỏi lưng mẹ",
    example: "rắn tuồi ra khỏi hang * đứa bé tuồi xuống khỏi lưng mẹ",
  },
  {
    word: "tuổi đầu",
    part_of_speech: "danh từ",
    meaning:
      '(khẩu ngữ) tuổi của một người, về mặt là tuổi đáng lẽ như thế nào đó (nhưng thực tế lại không thế; hàm ý chê trách hoặc cảm thương): ngần này tuổi đầu rồi còn dại * "Vua chúa còn có khi lầm, Huống chi bà lão tám lăm tuổi đầu." (ca dao)',
    example:
      'ngần này tuổi đầu rồi còn dại * "Vua chúa còn có khi lầm, Huống chi bà lão tám lăm tuổi đầu." (ca dao)',
  },
  {
    word: "tuổi",
    part_of_speech: "danh từ",
    meaning:
      "năm, dùng làm đơn vị để tính thời gian sống của người: kém một tháng đầy hai tuổi * người cao tuổi * mỗi năm thêm một tuổi",
    example:
      "kém một tháng đầy hai tuổi * người cao tuổi * mỗi năm thêm một tuổi",
  },
  {
    word: "tuổi",
    part_of_speech: "danh từ",
    meaning:
      "năm, dùng làm đơn vị để tính thời gian hoạt động liên tục trong một nghề, một tổ chức: bảy năm tuổi nghề * huy hiệu 40 năm tuổi Đảng",
    example: "bảy năm tuổi nghề * huy hiệu 40 năm tuổi Đảng",
  },
  {
    word: "tuổi",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian đã tồn tại từ khi ra đời cho đến một thời điểm xác định nào đó (thường là hiện tại): em bé được ba tháng tuổi * mạ được mười lăm ngày tuổi",
    example: "em bé được ba tháng tuổi * mạ được mười lăm ngày tuổi",
  },
  {
    word: "tuổi",
    part_of_speech: "danh từ",
    meaning:
      "năm sinh tính theo âm lịch và gọi theo địa chi, thường dùng trong việc xem số, bói toán: tuổi Nhâm Thìn * tuổi Ngọ",
    example: "tuổi Nhâm Thìn * tuổi Ngọ",
  },
  {
    word: "tuổi",
    part_of_speech: "danh từ",
    meaning:
      "thời kì nhất định trong đời người, về mặt có những đặc trưng tâm sinh lí nào đó: tuổi ấu thơ * tuổi già * trẻ đang tuổi ăn, tuổi ngủ",
    example: "tuổi ấu thơ * tuổi già * trẻ đang tuổi ăn, tuổi ngủ",
  },
  {
    word: "tuổi",
    part_of_speech: "danh từ",
    meaning:
      "hàm lượng kim loại quý (vàng, bạc, platin) trong hợp kim dùng để làm đồ trang sức và đúc tiền: vàng mười tuổi",
    example: "vàng mười tuổi",
  },
  {
    word: "tuổi hồi xuân",
    part_of_speech: "danh từ",
    meaning:
      "thời kì sắp sửa bước sang tuổi già (thường giữa bốn mươi - năm mươi tuổi), về mặt sinh lí có những biến đổi nhất định: bước vào tuổi hồi xuân",
    example: "bước vào tuổi hồi xuân",
  },
  {
    word: "tuổi hạc",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) tuổi thọ, tuổi cao (ví sống lâu như chim hạc): "Thương cha tuổi hạc đã cao, E khi ấm lạnh buổi nào biết đâu." (LVT)',
    example:
      'Thương cha tuổi hạc đã cao, E khi ấm lạnh buổi nào biết đâu." (LVT)',
  },
  {
    word: "tuổi mụ",
    part_of_speech: "danh từ",
    meaning:
      "tuổi coi như có ngay từ lúc mới sinh ra, tính năm sinh ra đã là một tuổi rồi, theo cách tính tuổi cổ truyền: năm nay 18, kể cả tuổi mụ là 19",
    example: "năm nay 18, kể cả tuổi mụ là 19",
  },
  {
    word: "tuổi tác",
    part_of_speech: "danh từ",
    meaning: "tuổi của con người (nói khái quát): chênh lệch về tuổi tác",
    example: "chênh lệch về tuổi tác",
  },
  {
    word: "tuổi tác",
    part_of_speech: "danh từ",
    meaning:
      "tuổi đã cao (nói khái quát): già nua tuổi tác * bị lẫn vì tuổi tác",
    example: "già nua tuổi tác * bị lẫn vì tuổi tác",
  },
  {
    word: "tuổi thọ",
    part_of_speech: "danh từ",
    meaning:
      "thời gian sống được của một người, một sinh vật: người Nhật có tuổi thọ trung bình cao",
    example: "người Nhật có tuổi thọ trung bình cao",
  },
  {
    word: "tuổi thọ",
    part_of_speech: "danh từ",
    meaning:
      "thời gian sử dụng được của một sản phẩm, thường được tính từ lúc bắt đầu sử dụng cho đến lúc hư hỏng không thể dùng được nữa: sản phẩm có tuổi thọ cao * tắt điện đột ngột có thể làm giảm tuổi thọ của máy",
    example:
      "sản phẩm có tuổi thọ cao * tắt điện đột ngột có thể làm giảm tuổi thọ của máy",
  },
  {
    word: "tuổi thơ",
    part_of_speech: "danh từ",
    meaning:
      "độ tuổi còn nhỏ, còn non dại: kí ức tuổi thơ * những kỉ niệm tuổi thơ",
    example: "kí ức tuổi thơ * những kỉ niệm tuổi thơ",
  },
  {
    word: "tuổi tôi",
    part_of_speech: "danh từ",
    meaning:
      "tuổi tính từ ngày sinh đến khi vừa tròn mười hai tháng: em bé vừa đầy tuổi tôi",
    example: "em bé vừa đầy tuổi tôi",
  },
  {
    word: "tuôn",
    part_of_speech: "động từ",
    meaning:
      "di chuyển ra thành dòng, thành luồng, nhiều và liên tục: mồ hôi tuôn ra như tắm * khói tuôn cuồn cuộn",
    example: "mồ hôi tuôn ra như tắm * khói tuôn cuồn cuộn",
  },
  {
    word: "tuôn",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đưa ra, cho ra nhiều và liên tục: tuôn tiền của ra để chạy chọt * tuôn ra những lời tục tĩu",
    example: "tuôn tiền của ra để chạy chọt * tuôn ra những lời tục tĩu",
  },
  {
    word: "tuổi trẻ",
    part_of_speech: "danh từ",
    meaning:
      "độ tuổi thanh niên, thiếu niên: tuổi trẻ sôi nổi và bồng bột * đầu xanh tuổi trẻ",
    example: "tuổi trẻ sôi nổi và bồng bột * đầu xanh tuổi trẻ",
  },
  {
    word: "tuồng",
    part_of_speech: "danh từ",
    meaning:
      "(cũng hát bội) kịch hát dân tộc cổ truyền, mang tính chất tượng trưng và ước lệ, lời viết theo các thể văn vần cổ, thường chuyên về đề tài lịch sử: vở tuồng * hát tuồng * đi xem tuồng",
    example: "vở tuồng * hát tuồng * đi xem tuồng",
  },
  {
    word: "tuồng",
    part_of_speech: "danh từ",
    meaning:
      'hạng người cùng có một đặc điểm chung nào đó (hàm ý coi thường): tuồng ô hợp * "Bởi vì cha mẹ không thương, Cố lòng ép uổng lấy tuồng vũ phu." (ca dao)',
    example:
      'tuồng ô hợp * "Bởi vì cha mẹ không thương, Cố lòng ép uổng lấy tuồng vũ phu.',
  },
  {
    word: "tuồng",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) vẻ bề ngoài: xem tuồng mọi việc đã ổn",
    example: "xem tuồng mọi việc đã ổn",
  },
  {
    word: "tuồn tuột",
    part_of_speech: "tính từ",
    meaning:
      "thẳng một mạch, như không thể giữ lại, cản lại được: xe đứt phanh, lao tuồn tuột xuống dốc * không hỏi cũng tự khai tuồn tuột",
    example:
      "xe đứt phanh, lao tuồn tuột xuống dốc * không hỏi cũng tự khai tuồn tuột",
  },
  {
    word: "tuông",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) xông bừa tới trước, vượt bừa qua, bất chấp trở ngại: tuông qua rào * phá vòng vây, tuông chạy",
    example: "tuông qua rào * phá vòng vây, tuông chạy",
  },
  {
    word: "tuông",
    part_of_speech: "động từ",
    meaning:
      "rơi hoặc làm cho rơi mạnh xuống liên tục: đất đá tuông xuống rào rào",
    example: "đất đá tuông xuống rào rào",
  },
  {
    word: "tuổi xanh",
    part_of_speech: "danh từ",
    meaning:
      '(văn chương) như tuổi trẻ: "Thương thay công tử tuổi xanh, Long đong mấy hội, gập ghềnh mấy phen." (NĐM)',
    example:
      'Thương thay công tử tuổi xanh, Long đong mấy hội, gập ghềnh mấy phen." (NĐM)',
  },
  {
    word: "tuột",
    part_of_speech: "động từ",
    meaning:
      "bị rời ra khỏi, không còn giữ lại được nữa: tuột tay đánh rơi * xe đạp tuột xích * áo bị tuột chỉ",
    example: "tuột tay đánh rơi * xe đạp tuột xích * áo bị tuột chỉ",
  },
  {
    word: "tuột",
    part_of_speech: "động từ",
    meaning: "(da) bong ra một mảng: bị bỏng tuột da",
    example: "bị bỏng tuột da",
  },
  {
    word: "tuột",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) tụt ra khỏi người: tuột giày đi chân không * quần tuột xuống gối",
    example: "tuột giày đi chân không * quần tuột xuống gối",
  },
  {
    word: "tuột",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) tụt (từ trên cao xuống): tuột từ trên cây xuống",
    example: "tuột từ trên cây xuống",
  },
  {
    word: "tuột",
    part_of_speech: "tính từ",
    meaning:
      "dứt khoát và mau lẹ làm cho rời bỏ, rời khỏi đi: lôi tuột ngay đi * xe lao tuột xuống dốc * rũ tuột trách nhiệm * vỗ tuột nợ",
    example:
      "lôi tuột ngay đi * xe lao tuột xuống dốc * rũ tuột trách nhiệm * vỗ tuột nợ",
  },
  {
    word: "tuốt",
    part_of_speech: "động từ",
    meaning:
      "vuốt mạnh một vật theo suốt chiều dài và khắp cả các phía, để làm cho những gì bám vào nó phải rời ra: tuốt rau ngót * máy tuốt lúa",
    example: "tuốt rau ngót * máy tuốt lúa",
  },
  {
    word: "tuốt",
    part_of_speech: "động từ",
    meaning:
      "rút mạnh một vật dài ra khỏi vỏ (thường là gươm, kiếm): tuốt gươm khỏi vỏ * lưỡi lê tuốt trần * đánh tuốt xác (kng)",
    example: "tuốt gươm khỏi vỏ * lưỡi lê tuốt trần * đánh tuốt xác (kng)",
  },
  {
    word: "tuốt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) thẳng một mạch cho đến tận nơi: đi vô tuốt Sài Gòn * kéo tuốt ra ngoài vườn",
    example: "đi vô tuốt Sài Gòn * kéo tuốt ra ngoài vườn",
  },
  {
    word: "tuốt",
    part_of_speech: "đại từ",
    meaning:
      "(khẩu ngữ) tất cả, không chừa, không trừ một cái gì hoặc một ai: có gì bán tuốt * đều như nhau tuốt * tất cả là tại anh ta tuốt",
    example: "có gì bán tuốt * đều như nhau tuốt * tất cả là tại anh ta tuốt",
  },
  {
    word: "tuồn",
    part_of_speech: "động từ",
    meaning:
      "di chuyển đến nơi khác một cách mau lẹ, thường là áp sát thân mình trên bề mặt hoặc dọc theo vật gì: con rắn tuồn qua hàng rào * tuồn người ra khỏi miệng hang",
    example: "con rắn tuồn qua hàng rào * tuồn người ra khỏi miệng hang",
  },
  {
    word: "tuồn",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) chuyển cho người khác hoặc chuyển đến nơi khác một cách kín đáo: rác rưởi ở các nhà tuồn ra đường * tuồn hàng lậu qua biên giới",
    example: "rác rưởi ở các nhà tuồn ra đường * tuồn hàng lậu qua biên giới",
  },
  {
    word: "tuồng như",
    part_of_speech: "",
    meaning: "(hiếm) có vẻ như là: nói giọng tuồng như trách móc",
    example: "nói giọng tuồng như trách móc",
  },
  {
    word: "tuột dốc",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) tụt dốc: nền kinh tế bị tuột dốc",
    example: "nền kinh tế bị tuột dốc",
  },
  {
    word: "tuốt tuồn tuột",
    part_of_speech: "đại từ",
    meaning:
      "(khẩu ngữ) như tuốt tuột (nhưng ý nhấn mạnh hơn): khai tuốt tuồn tuột",
    example: "khai tuốt tuồn tuột",
  },
  {
    word: "tuốt tuột",
    part_of_speech: "đại từ",
    meaning:
      "(khẩu ngữ) như tuốt (nhưng nghĩa mạnh hơn): đoán sai tuốt tuột * mắng tuốt tuột cả lớn lẫn bé",
    example: "đoán sai tuốt tuột * mắng tuốt tuột cả lớn lẫn bé",
  },
  {
    word: "tụt",
    part_of_speech: "động từ",
    meaning:
      "di chuyển từ trên cao xuống, bằng cách bám vào một vật và tự buông mình xuống dần dần: từ trên cây tụt xuống * em bé tụt khỏi lòng mẹ",
    example: "từ trên cây tụt xuống * em bé tụt khỏi lòng mẹ",
  },
  {
    word: "tụt",
    part_of_speech: "động từ",
    meaning:
      "rời hoặc làm cho rời khỏi một vị trí và di chuyển xuống một vị trí thấp hơn một cách tự nhiên: trượt chân, tụt xuống hố * kính tụt xuống tận mũi * quần tụt đến gối",
    example:
      "trượt chân, tụt xuống hố * kính tụt xuống tận mũi * quần tụt đến gối",
  },
  {
    word: "tụt",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) giảm xuống, hạ thấp xuống một cách rõ rệt về số lượng, mức độ, trình độ, v.v.: nhiệt độ tụt xuống thấp * học lực ngày càng tụt",
    example: "nhiệt độ tụt xuống thấp * học lực ngày càng tụt",
  },
  {
    word: "tụt",
    part_of_speech: "động từ",
    meaning:
      "rời hoặc làm cho rời khỏi một vị trí để lùi lại phía sau: tụt lại phía sau * ngồi tụt vào một góc * ngôi nhà nằm tụt trong ngõ",
    example:
      "tụt lại phía sau * ngồi tụt vào một góc * ngôi nhà nằm tụt trong ngõ",
  },
  {
    word: "tụt dốc",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) như xuống dốc (nhưng ý nhấn mạnh hơn): nền kinh tế đang đứng trước nguy cơ tụt dốc",
    example: "nền kinh tế đang đứng trước nguy cơ tụt dốc",
  },
  {
    word: "tút",
    part_of_speech: "danh từ",
    meaning:
      "gói đóng sẵn gồm một số lượng nhất định (thường là mười) bao thuốc lá cùng loại: tút thuốc lá",
    example: "tút thuốc lá",
  },
  {
    word: "tuốt luốt",
    part_of_speech: "đại từ",
    meaning: "(phương ngữ) như tuốt tuột: đi tuốt luốt * khai tuốt luốt hết",
    example: "đi tuốt luốt * khai tuốt luốt hết",
  },
  {
    word: "túp",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị những nhà nhỏ, thấp, che lợp sơ sài: túp lều tranh * túp nhà lá xiêu vẹo",
    example: "túp lều tranh * túp nhà lá xiêu vẹo",
  },
  {
    word: "tụt hậu",
    part_of_speech: "động từ",
    meaning:
      "tụt lại phía sau, không theo kịp mọi người: nền kinh tế tụt hậu * tụt hậu về giáo dục",
    example: "nền kinh tế tụt hậu * tụt hậu về giáo dục",
  },
  {
    word: "tuy",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là một sự thật đáng lẽ làm cho điều được nói đến không thể xảy ra, nhằm nhấn mạnh ý nghĩa của điều vẫn xảy ra ấy: tuổi tuy nhỏ nhưng chí lớn * đồng ý, tuy bụng còn phân vân",
    example: "tuổi tuy nhỏ nhưng chí lớn * đồng ý, tuy bụng còn phân vân",
  },
  {
    word: "tuỷ",
    part_of_speech: "danh từ",
    meaning: "phần mềm ở giữa ống xương.",
    example: "viêm tuỷ răng",
  },
  {
    word: "tuỳ",
    part_of_speech: "động từ",
    meaning:
      "dựa theo điều kiện, tình thế mà làm cho phù hợp: làm việc tuỳ sức * tuỳ theo hoàn cảnh mà ứng phó",
    example: "làm việc tuỳ sức * tuỳ theo hoàn cảnh mà ứng phó",
  },
  {
    word: "tuỳ",
    part_of_speech: "động từ",
    meaning:
      "để cho người nào đó theo ý muốn của mình mà quyết định: việc đó tuỳ anh định liệu * muốn đi hay ở thì tuỳ",
    example: "việc đó tuỳ anh định liệu * muốn đi hay ở thì tuỳ",
  },
  {
    word: "tuỳ nghi",
    part_of_speech: "tính từ",
    meaning:
      "tuỳ theo hoàn cảnh, làm thế nào cho thích hợp: tuỳ nghi di tản * việc có thế, cứ tuỳ nghi mà định liệu",
    example: "tuỳ nghi di tản * việc có thế, cứ tuỳ nghi mà định liệu",
  },
  {
    word: "tuy nhiên",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là một nhận xét có phần nào trái với điều nhận xét vừa đưa ra trước đó, nhưng cần nêu để bổ sung: bài làm có tiến bộ, tuy nhiên vẫn còn một số sai sót",
    example: "bài làm có tiến bộ, tuy nhiên vẫn còn một số sai sót",
  },
  {
    word: "tuỳ cơ",
    part_of_speech: "động từ",
    meaning:
      "tuỳ theo tình hình cụ thể: tuỳ cơ định liệu * tuỳ cơ mà hành động",
    example: "tuỳ cơ định liệu * tuỳ cơ mà hành động",
  },
  {
    word: "tuỳ hứng",
    part_of_speech: "tính từ",
    meaning:
      "(làm việc gì) tuỳ theo cảm hứng, thích thú của cá nhân, không theo một quy định hay cách thức cụ thể nào cả: lối làm việc tuỳ hứng * sáng tác kiểu tuỳ hứng",
    example: "lối làm việc tuỳ hứng * sáng tác kiểu tuỳ hứng",
  },
  {
    word: "tuy líp",
    part_of_speech: "danh từ",
    meaning:
      "cây trồng làm cảnh ở xứ lạnh, mọc từ củ về mùa xuân, hoa to hình cốc mọc trên một thân cao, màu sắc rực rỡ: Hà Lan là xứ sở của hoa tuy líp",
    example: "Hà Lan là xứ sở của hoa tuy líp",
  },
  {
    word: "tuý luý",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) say (rượu) đến mức hoàn toàn không còn biết gì nữa: say tuý luý * uống rượu đến tuý luý",
    example: "say tuý luý * uống rượu đến tuý luý",
  },
  {
    word: "tuy rằng",
    part_of_speech: "kết từ",
    meaning:
      'như tuy (nhưng nghĩa mạnh hơn): "Hoa sen mọc bãi cát lầm, Tuy rằng lấm láp vẫn mầm hoa sen." (ca dao)',
    example:
      'Hoa sen mọc bãi cát lầm, Tuy rằng lấm láp vẫn mầm hoa sen." (ca dao)',
  },
  {
    word: "tuỳ tâm",
    part_of_speech: "động từ",
    meaning:
      "tuỳ theo lòng thảo của mình, không có gì bó buộc: giúp nhiều hay ít là tuỳ tâm",
    example: "giúp nhiều hay ít là tuỳ tâm",
  },
  {
    word: "tuỳ thuộc",
    part_of_speech: "động từ",
    meaning:
      "tuỳ theo điều kiện nào đó: thành công hay thất bại đều tuỳ thuộc ở anh * khó hay dễ còn tuỳ thuộc ở khả năng của mỗi người",
    example:
      "thành công hay thất bại đều tuỳ thuộc ở anh * khó hay dễ còn tuỳ thuộc ở khả năng của mỗi người",
  },
  {
    word: "tuỳ tiện",
    part_of_speech: "tính từ",
    meaning:
      "tiện đâu làm đó, không có nguyên tắc nào cả: làm ăn tuỳ tiện * nói năng tuỳ tiện * nhà cửa xây dựng tùy tiện",
    example: "làm ăn tuỳ tiện * nói năng tuỳ tiện * nhà cửa xây dựng tùy tiện",
  },
  {
    word: "tuỳ tiện",
    part_of_speech: "tính từ",
    meaning: "(cũ) như tuỳ nghi: được tuỳ tiện định liệu",
    example: "được tuỳ tiện định liệu",
  },
  {
    word: "tuỳ táng",
    part_of_speech: "tính từ",
    meaning:
      "(đồ vật) được chôn theo cùng với người chết theo phong tục thời xưa: tìm thấy ngôi mộ cổ với rất nhiều đồ tuỳ táng",
    example: "tìm thấy ngôi mộ cổ với rất nhiều đồ tuỳ táng",
  },
  {
    word: "tuỳ thân",
    part_of_speech: "tính từ",
    meaning:
      "thường được mang theo người: giấy tờ tuỳ thân * chiếc ba lô tuỳ thân",
    example: "giấy tờ tuỳ thân * chiếc ba lô tuỳ thân",
  },
  {
    word: "tuỳ thích",
    part_of_speech: "động từ",
    meaning:
      "tuỳ theo ý thích riêng của bản thân, không bị gò ép, hạn chế: muốn làm gì tuỳ thích",
    example: "muốn làm gì tuỳ thích",
  },
  {
    word: "tuỳ tùng",
    part_of_speech: "động từ",
    meaning:
      "đi theo để giúp việc (thường là cho một nhân vật quan trọng nào đó): nhân viên tuỳ tùng * lính tuỳ tùng",
    example: "nhân viên tuỳ tùng * lính tuỳ tùng",
  },
  {
    word: "tuỳ tùng",
    part_of_speech: "danh từ",
    meaning:
      "người đi theo để giúp việc: một đoàn tuỳ tùng * phái tuỳ tùng đi theo",
    example: "một đoàn tuỳ tùng * phái tuỳ tùng đi theo",
  },
  {
    word: "tuy vậy",
    part_of_speech: "kết từ",
    meaning:
      "tổ hợp biểu thị điều sắp nêu ra là trái với điều người ta có thể nghĩ dựa vào những điều vừa nói đến trước đó: làm quần quật cả ngày, tuy vậy vẫn không đủ ăn * số nó tuy vậy mà sướng",
    example:
      "làm quần quật cả ngày, tuy vậy vẫn không đủ ăn * số nó tuy vậy mà sướng",
  },
  {
    word: "tuỳ viên",
    part_of_speech: "danh từ",
    meaning:
      "chức vụ thấp nhất trong một sứ quán, sau bí thư thứ ba, thường được giao nhiệm vụ thực hiện từng công việc nhỏ của sứ quán.",
    example: "tuỳ viên quân sự",
  },
  {
    word: "tuyến",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận chuyên tiết các chất giúp cho hoạt động sinh lí của các cơ quan trong cơ thể hay của toàn cơ thể: tuyến mồ hôi * tuyến nước bọt * tuyến sữa",
    example: "tuyến mồ hôi * tuyến nước bọt * tuyến sữa",
  },
  {
    word: "tuyến",
    part_of_speech: "danh từ",
    meaning:
      "đường, về mặt có vị trí xác định, phân ranh giới rõ ràng: vạch tuyến * tuần tra trên tuyến biên giới",
    example: "vạch tuyến * tuần tra trên tuyến biên giới",
  },
  {
    word: "tuyến",
    part_of_speech: "danh từ",
    meaning:
      "đường, về mặt là bộ phận của một mạng lưới giao thông, thuỷ lợi, v.v. nào đó: các tuyến xe buýt * tuyến đường sắt Bắc - Nam * tuyến đê xung yếu",
    example:
      "các tuyến xe buýt * tuyến đường sắt Bắc - Nam * tuyến đê xung yếu",
  },
  {
    word: "tuyến",
    part_of_speech: "danh từ",
    meaning:
      "phần đường dành riêng cho từng loại xe cộ: đường phân tuyến * tuyến ô tô * tuyến xe đạp",
    example: "đường phân tuyến * tuyến ô tô * tuyến xe đạp",
  },
  {
    word: "tuyến",
    part_of_speech: "danh từ",
    meaning:
      "hệ thống bố trí lực lượng trên từng khu vực của mặt trận, từ sát hậu phương đến nơi trực tiếp tác chiến với địch: chọc thủng tuyến phòng ngự của địch * bị thương phải chuyển về tuyến sau",
    example:
      "chọc thủng tuyến phòng ngự của địch * bị thương phải chuyển về tuyến sau",
  },
  {
    word: "tuyến",
    part_of_speech: "danh từ",
    meaning:
      "hệ thống bố trí các cơ quan, thường là trong tổ chức y tế, giáo dục, theo từng cấp từ trung ương đến các địa phương: học trái tuyến * đưa bệnh nhân lên tuyến trên",
    example: "học trái tuyến * đưa bệnh nhân lên tuyến trên",
  },
  {
    word: "tuyến",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp sự vật được liên kết lại theo một đặc điểm chung nào đó, trong quan hệ đối lập với những tập hợp khác: hai tuyến nhân vật trong tác phẩm * tuyến du lịch nội địa",
    example: "hai tuyến nhân vật trong tác phẩm * tuyến du lịch nội địa",
  },
  {
    word: "tuyển",
    part_of_speech: "động từ",
    meaning:
      "chọn lấy một số theo yêu cầu, trong một số đông, số nhiều cùng loại: tuyển nhân viên * tuyển lao động",
    example: "tuyển nhân viên * tuyển lao động",
  },
  {
    word: "tuyền",
    part_of_speech: "tính từ",
    meaning:
      '(phương ngữ, cũ) toàn: "Lỡ làng chút phận thuyền quyên, Bể sâu, sóng cả, có tuyền được vay?" (TKiều)',
    example:
      'Lỡ làng chút phận thuyền quyên, Bể sâu, sóng cả, có tuyền được vay?" (TKiều)',
  },
  {
    word: "tuyền",
    part_of_speech: "tính từ",
    meaning:
      "thuần một màu, không có màu khác xen vào: con mèo đen tuyền * màu trắng tuyền",
    example: "con mèo đen tuyền * màu trắng tuyền",
  },
  {
    word: "tuyền",
    part_of_speech: "phụ từ",
    meaning: "như toàn: tuyền một màu xanh",
    example: "tuyền một màu xanh",
  },
  {
    word: "tuyên",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tuyên án (nói tắt): án đã tuyên * bị toà tuyên tử hình",
    example: "án đã tuyên * bị toà tuyên tử hình",
  },
  {
    word: "tuyên án",
    part_of_speech: "động từ",
    meaning:
      "công bố bản án trước phiên toà: đọc lời tuyên án * toà tuyên án chung thân",
    example: "đọc lời tuyên án * toà tuyên án chung thân",
  },
  {
    word: "tuỳ ý",
    part_of_speech: "động từ",
    meaning:
      "tuỳ theo ý mình, muốn thế nào cũng được: muốn làm gì tuỳ ý * việc này, tùy ý anh giải quyết",
    example: "muốn làm gì tuỳ ý * việc này, tùy ý anh giải quyết",
  },
  {
    word: "tuyên bố",
    part_of_speech: "động từ",
    meaning:
      "chính thức thông báo cho mọi người biết (thường là vấn đề có tầm quan trọng): tuyên bố lí do cuộc họp * công ti tuyên bố phá sản * tuyên bố hùng hồn",
    example:
      "tuyên bố lí do cuộc họp * công ti tuyên bố phá sản * tuyên bố hùng hồn",
  },
  {
    word: "tuyên bố",
    part_of_speech: "danh từ",
    meaning: "bản tuyên bố: chính phủ ra tuyên bố",
    example: "chính phủ ra tuyên bố",
  },
  {
    word: "tuyển chọn",
    part_of_speech: "động từ",
    meaning:
      "tuyển (nói khái quát): tuyển chọn cầu thủ * tuyển chọn những bài hát hay trong năm",
    example: "tuyển chọn cầu thủ * tuyển chọn những bài hát hay trong năm",
  },
  {
    word: "tuyển cử",
    part_of_speech: "động từ",
    meaning: "(trang trọng) bầu cử: tuyển cử đại biểu quốc hội * ngày tuyển cử",
    example: "tuyển cử đại biểu quốc hội * ngày tuyển cử",
  },
  {
    word: "tuyên dương",
    part_of_speech: "động từ",
    meaning:
      "trịnh trọng và chính thức biểu dương, khen ngợi: tuyên dương một học sinh xuất sắc * dự lễ tuyên dương",
    example: "tuyên dương một học sinh xuất sắc * dự lễ tuyên dương",
  },
  {
    word: "tuyên chiến",
    part_of_speech: "động từ",
    meaning:
      "tuyên bố bắt đầu tiến hành chiến tranh với phe đối lập: tháng 12 năm 1939 Anh tuyên chiến với Đức * tuyên chiến với ma tuý (b)",
    example:
      "tháng 12 năm 1939 Anh tuyên chiến với Đức * tuyên chiến với ma tuý (b)",
  },
  {
    word: "tuyển dụng",
    part_of_speech: "động từ",
    meaning:
      "chọn và nhận vào làm việc: thông báo tuyển dụng lao động * hợp đồng tuyển dụng",
    example: "thông báo tuyển dụng lao động * hợp đồng tuyển dụng",
  },
  {
    word: "tuyền đài",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) âm phủ: "Nợ tình chưa trả cho ai, Khối tình mang xuống Tuyền đài chửa tan." (TKiều)',
    example:
      'Nợ tình chưa trả cho ai, Khối tình mang xuống Tuyền đài chửa tan." (TKiều)',
  },
  {
    word: "tuyên đọc",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) đọc to lên một cách trịnh trọng cho mọi người nghe: tuyên đọc chiếu chỉ * tuyên đọc bản tuyên ngôn độc lập",
    example: "tuyên đọc chiếu chỉ * tuyên đọc bản tuyên ngôn độc lập",
  },
  {
    word: "tuyên giáo",
    part_of_speech: "động từ",
    meaning:
      "tuyên truyền và giáo dục (nói tắt): công tác tuyên giáo * ban tuyên giáo",
    example: "công tác tuyên giáo * ban tuyên giáo",
  },
  {
    word: "tuyển mộ",
    part_of_speech: "động từ",
    meaning:
      "tuyển chọn người một cách rộng rãi để tổ chức thành lực lượng làm việc gì: tuyển mộ lính đánh thuê",
    example: "tuyển mộ lính đánh thuê",
  },
  {
    word: "tuyên huấn",
    part_of_speech: "động từ",
    meaning:
      "tuyên truyền và huấn luyện (nói tắt): ban tuyên huấn * cán bộ tuyên huấn",
    example: "ban tuyên huấn * cán bộ tuyên huấn",
  },
  {
    word: "tuyên ngôn",
    part_of_speech: "danh từ",
    meaning:
      "bản tuyên bố có tính chất cương lĩnh của một chính đảng, một tổ chức: bản tuyên ngôn độc lập",
    example: "bản tuyên ngôn độc lập",
  },
  {
    word: "tuyển lựa",
    part_of_speech: "động từ",
    meaning:
      "tuyển theo tiêu chuẩn (nói khái quát): tuyển lựa cán bộ * tuyển lựa được nhiều giống lúa tốt",
    example: "tuyển lựa cán bộ * tuyển lựa được nhiều giống lúa tốt",
  },
  {
    word: "tuyển tập",
    part_of_speech: "danh từ",
    meaning:
      "sách tập hợp nhiều bài, nhiều tác phẩm được tuyển chọn (của một hay nhiều tác giả): tuyển tập thơ Việt Nam",
    example: "tuyển tập thơ Việt Nam",
  },
  {
    word: "tuyển quân",
    part_of_speech: "động từ",
    meaning: "tuyển người vào quân đội: đợt tuyển quân",
    example: "đợt tuyển quân",
  },
  {
    word: "tuyên phạt",
    part_of_speech: "động từ",
    meaning:
      "công bố hình phạt tại phiên toà: bị toà tuyên phạt một năm tù treo",
    example: "bị toà tuyên phạt một năm tù treo",
  },
  {
    word: "tuyên thệ",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) trịnh trọng đọc lời thề (thường trong buổi lễ): giơ tay tuyên thệ * lễ tuyên thệ nhậm chức tổng thống",
    example: "giơ tay tuyên thệ * lễ tuyên thệ nhậm chức tổng thống",
  },
  {
    word: "tuyển sinh",
    part_of_speech: "động từ",
    meaning:
      "tuyển học sinh, sinh viên vào trường học: tuyển sinh đại học * kì thi tuyển sinh",
    example: "tuyển sinh đại học * kì thi tuyển sinh",
  },
  {
    word: "tuyển thủ",
    part_of_speech: "danh từ",
    meaning:
      "người được tuyển chọn để tham gia thi đấu thể thao: tuyển thủ bóng đá * các tuyển thủ quốc gia",
    example: "tuyển thủ bóng đá * các tuyển thủ quốc gia",
  },
  {
    word: "tuyến tính",
    part_of_speech: "danh từ",
    meaning:
      "tính chất nối tiếp nhau theo đường thẳng: vận tốc tuyến tính * trật tự tuyến tính",
    example: "vận tốc tuyến tính * trật tự tuyến tính",
  },
  {
    word: "tuyến tính",
    part_of_speech: "danh từ",
    meaning: "bậc nhất: phương trình tuyến tính * hàm số tuyến tính",
    example: "phương trình tuyến tính * hàm số tuyến tính",
  },
  {
    word: "tuyên uý",
    part_of_speech: "danh từ",
    meaning:
      "sĩ quan là người tu hành, chuyên làm công việc tôn giáo trong tổ chức quân đội một số nước: cha tuyên uý * sĩ quan tuyên uý",
    example: "cha tuyên uý * sĩ quan tuyên uý",
  },
  {
    word: "tuyên xử",
    part_of_speech: "động từ",
    meaning: "(toà án) công bố kết quả xét xử: toà tuyên xử 4 năm tù giam",
    example: "toà tuyên xử 4 năm tù giam",
  },
  {
    word: "tuyên truyền",
    part_of_speech: "động từ",
    meaning:
      "phổ biến, giải thích rộng rãi để thuyết phục mọi người tán thành, ủng hộ, làm theo: tuyên truyền đường lối, chính sách * tuyên truyền kế hoạch hoá gia đình",
    example:
      "tuyên truyền đường lối, chính sách * tuyên truyền kế hoạch hoá gia đình",
  },
  {
    word: "tuyết",
    part_of_speech: "danh từ",
    meaning:
      "tinh thể băng nhỏ và trắng kết thành khối xốp, nhẹ, rơi ở vùng có khí hậu lạnh: tuyết rơi * trắng như tuyết",
    example: "tuyết rơi * trắng như tuyết",
  },
  {
    word: "tuyết",
    part_of_speech: "danh từ",
    meaning:
      "lớp xơ ngắn đều, mịn và mượt trên mặt một số hàng dệt: tuyết nhung * quần đã sờn tuyết",
    example: "tuyết nhung * quần đã sờn tuyết",
  },
  {
    word: "tuyết",
    part_of_speech: "danh từ",
    meaning:
      "lớp mịn màu trắng ngà phủ trên búp, lá non, cánh hoa một số cây: chè tuyết * hoa mất tuyết",
    example: "chè tuyết * hoa mất tuyết",
  },
  {
    word: "tuyệt",
    part_of_speech: "động từ",
    meaning:
      "bị mất đi hoàn toàn mọi khả năng có được sự tiếp nối, sự tiếp tục (thường nói về sự phát triển của nòi giống): loài thú này đã bị tuyệt giống * tuyệt đường tiếp tế",
    example: "loài thú này đã bị tuyệt giống * tuyệt đường tiếp tế",
  },
  {
    word: "tuyệt",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) như tuyệt nhiên: tuyệt không màng danh lợi * tuyệt chẳng một ai biết",
    example: "tuyệt không màng danh lợi * tuyệt chẳng một ai biết",
  },
  {
    word: "tuyệt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) đẹp, hay, tốt đến mức làm cho thích thú tột bậc, coi như không còn có thể đòi hỏi gì hơn: chiếc áo rất tuyệt * giọng ca thật tuyệt * được như thế thì tuyệt quá!",
    example:
      "chiếc áo rất tuyệt * giọng ca thật tuyệt * được như thế thì tuyệt quá!",
  },
  {
    word: "tuyệt",
    part_of_speech: "phụ từ",
    meaning:
      "(đẹp, hay, tốt) đến mức như không còn có thể hơn: vế đối hay tuyệt * một cô gái tuyệt đẹp * món ăn ngon tuyệt",
    example: "vế đối hay tuyệt * một cô gái tuyệt đẹp * món ăn ngon tuyệt",
  },
  {
    word: "tuyệt bút",
    part_of_speech: "danh từ",
    meaning:
      '(hiếm) bài văn, bài thơ viết lần cuối cùng trong đời, để lại trước khi chết: "Dưới đèn sẵn bức tiên hoa, Một thiên tuyệt bút, gọi là để sau." (TKiều)',
    example:
      'Dưới đèn sẵn bức tiên hoa, Một thiên tuyệt bút, gọi là để sau." (TKiều)',
  },
  {
    word: "tuyệt bút",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, hoặc kng) tác phẩm văn học, hội hoạ hay, đẹp tột bậc: bức tranh tuyệt bút * Truyện Kiều' là một tuyệt bút",
    example: "bức tranh tuyệt bút * Truyện Kiều' là một tuyệt bút",
  },
  {
    word: "tuyệt chiêu",
    part_of_speech: "",
    meaning:
      "chiêu võ riêng rất hiểm, có tính chất quyết định để giành phần thắng; thường dùng trong khẩu ngữ để chỉ hình thức, cách thức hoạt động riêng, hoặc bất cứ cái gì ở người khác không có, mà khi đem sử dụng đặc biệt có hiệu quả: ra đòn tuyệt chiêu * tung tuyệt chiêu để câu khách",
    example: "ra đòn tuyệt chiêu * tung tuyệt chiêu để câu khách",
  },
  {
    word: "tuyệt chủng",
    part_of_speech: "động từ",
    meaning:
      "bị mất hẳn nòi giống: một loài thú đang có nguy cơ bị tuyệt chủng",
    example: "một loài thú đang có nguy cơ bị tuyệt chủng",
  },
  {
    word: "tuyệt diệt",
    part_of_speech: "động từ",
    meaning:
      "(nòi giống) bị mất hẳn, không còn tồn tại nữa: loài khủng long đã bị tuyệt diệt",
    example: "loài khủng long đã bị tuyệt diệt",
  },
  {
    word: "tuyệt diệu",
    part_of_speech: "tính từ",
    meaning:
      "hay, tốt đến mức kì lạ, khiến người ta phải khâm phục: áng văn tuyệt diệu * khoảnh khắc tuyệt diệu * một người có trí nhớ tuyệt diệu",
    example:
      "áng văn tuyệt diệu * khoảnh khắc tuyệt diệu * một người có trí nhớ tuyệt diệu",
  },
  {
    word: "tuyệt đỉnh",
    part_of_speech: "",
    meaning: "như tột đỉnh: tuyệt đỉnh vinh quang * sung sướng tuyệt đỉnh",
    example: "tuyệt đỉnh vinh quang * sung sướng tuyệt đỉnh",
  },
  {
    word: "tuyệt giao",
    part_of_speech: "động từ",
    meaning:
      "cắt đứt mọi quan hệ, không còn đi lại, giao thiệp với nhau nữa: vì hiểu lầm nên hai nhà đã tuyệt giao với nhau",
    example: "vì hiểu lầm nên hai nhà đã tuyệt giao với nhau",
  },
  {
    word: "tuyệt đối",
    part_of_speech: "tính từ",
    meaning:
      "hoàn toàn, không có một sự hạn chế hay một trường hợp ngoại lệ nào cả: tuyệt đối an toàn * bí mật tuyệt đối * tuyệt đối chấp hành mệnh lệnh",
    example:
      "tuyệt đối an toàn * bí mật tuyệt đối * tuyệt đối chấp hành mệnh lệnh",
  },
  {
    word: "tuyệt đối",
    part_of_speech: "tính từ",
    meaning:
      "không phụ thuộc vào hoàn cảnh, vào quan hệ với cái khác nào cả: giá trị tuyệt đối * chân lí tuyệt đối",
    example: "giá trị tuyệt đối * chân lí tuyệt đối",
  },
  {
    word: "tuyệt kỹ",
    part_of_speech: "danh từ",
    meaning:
      "kĩ thuật đặc biệt khéo léo, tinh vi: biểu diễn những tuyệt kĩ võ nghệ",
    example: "biểu diễn những tuyệt kĩ võ nghệ",
  },
  {
    word: "tuyệt đích",
    part_of_speech: "",
    meaning:
      "(hiếm) mức cao tột cùng, không thể hơn được nữa: tuyệt đích của hạnh phúc * ước vọng tuyệt đích",
    example: "tuyệt đích của hạnh phúc * ước vọng tuyệt đích",
  },
  {
    word: "tuyệt kĩ",
    part_of_speech: "danh từ",
    meaning:
      "kĩ thuật đặc biệt khéo léo, tinh vi: biểu diễn những tuyệt kĩ võ nghệ",
    example: "biểu diễn những tuyệt kĩ võ nghệ",
  },
  {
    word: "tuyệt hảo",
    part_of_speech: "tính từ",
    meaning:
      "có chất lượng, phẩm chất cao hết mức, khó có thể hơn: chất lượng tuyệt hảo * nước mắm tuyệt hảo",
    example: "chất lượng tuyệt hảo * nước mắm tuyệt hảo",
  },
  {
    word: "tuyệt mệnh",
    part_of_speech: "động từ",
    meaning:
      "(những lời) để lại trước khi tự tử: lời tuyệt mệnh * bức thư tuyệt mệnh",
    example: "lời tuyệt mệnh * bức thư tuyệt mệnh",
  },
  {
    word: "tuyệt mĩ",
    part_of_speech: "tính từ",
    meaning:
      "đẹp đến mức không còn có thể hơn: cảnh quan tuyệt mĩ * vẻ đẹp tuyệt mĩ",
    example: "cảnh quan tuyệt mĩ * vẻ đẹp tuyệt mĩ",
  },
  {
    word: "tuyệt mỹ",
    part_of_speech: "tính từ",
    meaning:
      "đẹp đến mức không còn có thể hơn: cảnh quan tuyệt mĩ * vẻ đẹp tuyệt mĩ",
    example: "cảnh quan tuyệt mĩ * vẻ đẹp tuyệt mĩ",
  },
  {
    word: "tuyệt mật",
    part_of_speech: "tính từ",
    meaning:
      "rất bí mật, cần được tuyệt đối giữ kín: thông tin tuyệt mật * tài liệu tuyệt mật",
    example: "thông tin tuyệt mật * tài liệu tuyệt mật",
  },
  {
    word: "tuyệt nhiên",
    part_of_speech: "phụ từ",
    meaning:
      "hoàn toàn, tuyệt đối (không): tuyệt nhiên không một bóng người * tuyệt nhiên không đả động tới chuyện cũ",
    example:
      "tuyệt nhiên không một bóng người * tuyệt nhiên không đả động tới chuyện cũ",
  },
  {
    word: "tuyệt thực",
    part_of_speech: "động từ",
    meaning:
      "nhịn đói không chịu ăn (một hình thức đấu tranh chính trị, nêu một yêu sách hoặc biểu thị một sự phản kháng): tuyệt thực để phản đối chiến tranh",
    example: "tuyệt thực để phản đối chiến tranh",
  },
  {
    word: "tuyệt nọc",
    part_of_speech: "động từ",
    meaning:
      "bị diệt trừ hoàn toàn, không còn có khả năng phát sinh để gây hại nữa: chữa bệnh phải chữa cho tuyệt nọc",
    example: "chữa bệnh phải chữa cho tuyệt nọc",
  },
  {
    word: "tuyệt tác",
    part_of_speech: "danh từ",
    meaning:
      "tác phẩm văn học, nghệ thuật hay, đẹp đến mức không còn có thể có cái hơn: bức tranh tuyệt tác * một tuyệt tác văn học",
    example: "bức tranh tuyệt tác * một tuyệt tác văn học",
  },
  {
    word: "tuyết sương",
    part_of_speech: "danh từ",
    meaning:
      'tuyết và sương; dùng để chỉ nỗi gian nan, vất vả phải chịu đựng: "Ruột tằm, ngày một héo hon, Tuyết sương ngày một hao mòn hình ve." (TKiều)',
    example:
      'Ruột tằm, ngày một héo hon, Tuyết sương ngày một hao mòn hình ve." (TKiều)',
  },
  {
    word: "tuyết sương",
    part_of_speech: "danh từ",
    meaning:
      'tả màu trắng trên tóc, râu; chỉ tuổi già: "Xương mai một nắm hao gầy, Tóc mây một mái đã đầy tuyết sương." (TĐà; 7)',
    example:
      'Xương mai một nắm hao gầy, Tóc mây một mái đã đầy tuyết sương." (TĐà; 7)',
  },
  {
    word: "tuyệt sắc",
    part_of_speech: "",
    meaning:
      "(hiếm) có nhan sắc tuyệt đẹp, không ai có thể sánh được: người con gái tuyệt sắc",
    example: "người con gái tuyệt sắc",
  },
  {
    word: "tuyệt tình",
    part_of_speech: "động từ",
    meaning:
      "cắt đứt mọi quan hệ tình cảm, không còn tình nghĩa gì: tuyệt tình với bạn bè",
    example: "tuyệt tình với bạn bè",
  },
  {
    word: "tuyệt vọng",
    part_of_speech: "động từ",
    meaning:
      "mất hết mọi hi vọng: một mối tình tuyệt vọng * càng chờ càng tuyệt vọng",
    example: "một mối tình tuyệt vọng * càng chờ càng tuyệt vọng",
  },
  {
    word: "tuyệt thế",
    part_of_speech: "tính từ",
    meaning:
      "(cũ) nhất trên đời, không ai sánh bằng (thường nói về sắc đẹp): tài hoa tuyệt thế * tuyệt thế giai nhân",
    example: "tài hoa tuyệt thế * tuyệt thế giai nhân",
  },
  {
    word: "tuyệt trần",
    part_of_speech: "tính từ",
    meaning:
      "(tốt, đẹp) nhất trên đời, không có gì sánh bằng: đẹp tuyệt trần * nhan sắc tuyệt trần",
    example: "đẹp tuyệt trần * nhan sắc tuyệt trần",
  },
  {
    word: "tuýp",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) ống nhỏ, dài, thường bằng kim loại: tuýp thuốc mỡ * tuýp kem đánh răng * đèn tuýp",
    example: "tuýp thuốc mỡ * tuýp kem đánh răng * đèn tuýp",
  },
  {
    word: "tuynen",
    part_of_speech: "danh từ",
    meaning:
      "công trình ngầm dưới đất hoặc dưới nước, có dạng ống hay hình vòm để đặt máy móc thiết bị hoặc làm đường giao thông: hệ thống tuynen của công trình thuỷ điện",
    example: "hệ thống tuynen của công trình thuỷ điện",
  },
  {
    word: "tuynen",
    part_of_speech: "danh từ",
    meaning: "lò nung có dạng hình ống: gạch tuynen (gạch nung bằng lò tuynen)",
    example: "gạch tuynen (gạch nung bằng lò tuynen)",
  },
  {
    word: "tuyệt vời",
    part_of_speech: "tính từ",
    meaning:
      "đạt đến mức được coi là lí tưởng, không gì có thể sánh được: đẹp tuyệt vời * thông minh tuyệt vời * thật là tuyệt vời!",
    example: "đẹp tuyệt vời * thông minh tuyệt vời * thật là tuyệt vời!",
  },
  {
    word: "tuyn",
    part_of_speech: "danh từ",
    meaning:
      "hàng dệt mỏng thành một mạng những mắt lưới rất nhỏ, tròn hoặc hình đa giác đều: màn tuyn * vải tuyn",
    example: "màn tuyn * vải tuyn",
  },
  {
    word: "tuyệt xảo",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) hết sức tinh xảo: một tác phẩm tuyệt xảo * bộ bàn ghế được chạm trổ tuyệt xảo",
    example: "một tác phẩm tuyệt xảo * bộ bàn ghế được chạm trổ tuyệt xảo",
  },
  {
    word: "tử",
    part_of_speech: "động từ",
    meaning: "chết: vượt qua cửa tử * tham sinh uý tử",
    example: "vượt qua cửa tử * tham sinh uý tử",
  },
  {
    word: "tư",
    part_of_speech: "danh từ",
    meaning:
      "bốn (không dùng để đếm): ngày thứ tư * bốn tư (bốn mươi bốn) * gấp tờ giấy làm tư",
    example: "ngày thứ tư * bốn tư (bốn mươi bốn) * gấp tờ giấy làm tư",
  },
  {
    word: "tư",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về cá nhân, của riêng từng cá nhân; phân biệt với công: chuyện đời tư * mở trường tư * việc công, việc tư",
    example: "chuyện đời tư * mở trường tư * việc công, việc tư",
  },
  {
    word: "từ",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) ông từ (nói tắt): từ giữ đền",
    example: "từ giữ đền",
  },
  {
    word: "từ",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị ngôn ngữ nhỏ nhất có nghĩa hoàn chỉnh và cấu tạo ổn định, dùng để đặt câu: từ đơn * cách dùng từ * kết hợp từ thành câu",
    example: "từ đơn * cách dùng từ * kết hợp từ thành câu",
  },
  {
    word: "từ",
    part_of_speech: "danh từ",
    meaning: "từ tính (nói tắt): thanh kim loại bị nhiễm từ",
    example: "thanh kim loại bị nhiễm từ",
  },
  {
    word: "từ",
    part_of_speech: "động từ",
    meaning:
      "bỏ không nhìn nhận, tự coi là không có quan hệ, không có trách nhiệm gì nữa đối với người nào đó: từ đứa con hư * từ mặt nhau",
    example: "từ đứa con hư * từ mặt nhau",
  },
  {
    word: "từ",
    part_of_speech: "động từ",
    meaning:
      "thôi không nhận làm một chức vụ nào đó nữa: từ quan về ở ẩn * từ chức giám đốc",
    example: "từ quan về ở ẩn * từ chức giám đốc",
  },
  {
    word: "từ",
    part_of_speech: "động từ",
    meaning:
      "thoái thác, không chịu nhận lấy về mình: dầu gian nan cũng không từ",
    example: "dầu gian nan cũng không từ",
  },
  {
    word: "từ",
    part_of_speech: "động từ",
    meaning:
      "chừa ra, tránh không đụng đến hoặc không dùng đến: không từ một thủ đoạn nào * vơ vét không từ một cái gì",
    example: "không từ một thủ đoạn nào * vơ vét không từ một cái gì",
  },
  {
    word: "từ",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nói là điểm xuất phát, điểm khởi đầu hay là nguồn gốc của việc được nói đến: từ Nam ra Bắc * dậy từ sáng sớm  * đọc từ chương hai",
    example: "từ Nam ra Bắc * dậy từ sáng sớm  * đọc từ chương hai",
  },
  {
    word: "từ",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nói là điểm xuất phát rất thấp, để hàm ý rằng mức độ được nói đến là rất cao, ít nhiều triệt để: giống từ cái mắt, cái miệng * để ý từ lời ăn tiếng nói",
    example: "giống từ cái mắt, cái miệng * để ý từ lời ăn tiếng nói",
  },
  {
    word: "tuýt",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng âm thanh cao và dài thành hồi của tiếng còi: tiếng còi tuýt tuýt",
    example: "tiếng còi tuýt tuýt",
  },
  {
    word: "tuýt",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) như huýt (ng2): cảnh sát tuýt còi",
    example: "cảnh sát tuýt còi",
  },
  {
    word: "từ a đến z",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) từ đầu đến cuối, toàn bộ một công việc nào đó: nhận làm từ A đến Z * dịch vụ trọn gói, từ A đến Z",
    example: "nhận làm từ A đến Z * dịch vụ trọn gói, từ A đến Z",
  },
  {
    word: "từ khóa",
    part_of_speech: "danh từ",
    meaning:
      "những gì trong một câu, một đoạn, một văn bản, mang một ý nghĩa quan trọng hoặc có mục đích nhấn mạnh theo ý của người viết",
    example: "từ khóa SEO",
  },
  {
    word: "tứ",
    part_of_speech: "danh từ",
    meaning:
      "ý của bài thơ nảy ra trong quá trình nhận thức, cảm thụ và phản ánh hiện thực: nảy ra tứ thơ mới * tứ thơ nghèo nàn",
    example: "nảy ra tứ thơ mới * tứ thơ nghèo nàn",
  },
  {
    word: "tứ",
    part_of_speech: "danh từ",
    meaning: "bốn (chỉ dùng để đếm): tứ mùa * tứ phương",
    example: "tứ mùa * tứ phương",
  },
  {
    word: "tự ái",
    part_of_speech: "động từ",
    meaning:
      "do quá nghĩ đến mình mà sinh ra giận dỗi, khó chịu, khi cảm thấy bị đánh giá thấp hoặc bị coi thường: lòng tự ái bị tổn thương * tính hay tự ái * tự ái vặt",
    example: "lòng tự ái bị tổn thương * tính hay tự ái * tự ái vặt",
  },
  {
    word: "tư bản",
    part_of_speech: "danh từ",
    meaning:
      "giá trị mang lại cho kẻ chiếm hữu nó giá trị thặng dư, có được bằng cách bóc lột lao động làm thuê: sở hữu tư bản * lưu thông tư bản * đầu tư tư bản vào sản xuất",
    example: "sở hữu tư bản * lưu thông tư bản * đầu tư tư bản vào sản xuất",
  },
  {
    word: "tư bản",
    part_of_speech: "danh từ",
    meaning:
      "người chiếm hữu tư bản, bóc lột lao động làm thuê, trong quan hệ với lao động làm thuê (nói khái quát): nhà tư bản * các tập đoàn kinh tế tư bản",
    example: "nhà tư bản * các tập đoàn kinh tế tư bản",
  },
  {
    word: "tư bản",
    part_of_speech: "tính từ",
    meaning: "tư bản chủ nghĩa (nói tắt): các nước tư bản",
    example: "các nước tư bản",
  },
  {
    word: "tự",
    part_of_speech: "danh từ",
    meaning: "người giữ chùa: ông tự",
    example: "ông tự",
  },
  {
    word: "tự",
    part_of_speech: "đại từ",
    meaning:
      "từ dùng để chỉ bản thân chủ thể nhằm biểu thị việc nói đến là do chính chủ thể làm hoặc gây ra, chỉ bằng sức lực, khả năng của riêng mình: tự lượng sức mình * bé đã biết tự mặc lấy quần áo * việc của họ, để cho họ tự giải quyết",
    example:
      "tự lượng sức mình * bé đã biết tự mặc lấy quần áo * việc của họ, để cho họ tự giải quyết",
  },
  {
    word: "tự",
    part_of_speech: "đại từ",
    meaning:
      "từ dùng để chỉ bản thân chủ thể nhằm biểu thị chủ thể đồng thời cũng chính là khách thể chịu sự chi phối của hành động, hoạt động do mình làm hoặc gây ra: tự hứa với mình * tự mình làm khổ mình",
    example: "tự hứa với mình * tự mình làm khổ mình",
  },
  {
    word: "tự",
    part_of_speech: "kết từ",
    meaning:
      "(văn chương) như từ (ng1; nhưng nghĩa mạnh hơn): lời nói xuất phát tự đáy lòng",
    example: "lời nói xuất phát tự đáy lòng",
  },
  {
    word: "tự",
    part_of_speech: "kết từ",
    meaning:
      "(khẩu ngữ) tại, tại vì: việc ấy tự nó mà ra * tự tôi nên hỏng việc",
    example: "việc ấy tự nó mà ra * tự tôi nên hỏng việc",
  },
  {
    word: "từ bi",
    part_of_speech: "tính từ",
    meaning:
      "có lòng yêu và thương người, theo quan niệm của đạo Phật: đức Phật từ bi * có lòng từ bi, hỉ xả",
    example: "đức Phật từ bi * có lòng từ bi, hỉ xả",
  },
  {
    word: "tứ bề",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương) bốn bề, xung quanh: nơi đảo vắng, tứ bề sóng vỗ * tứ bề lặng ngắt",
    example: "nơi đảo vắng, tứ bề sóng vỗ * tứ bề lặng ngắt",
  },
  {
    word: "tự biên",
    part_of_speech: "động từ",
    meaning:
      "(người không chuyên nghiệp) tự mình biên soạn lấy tiết mục văn nghệ để biểu diễn: tiết mục múa tự biên",
    example: "tiết mục múa tự biên",
  },
  {
    word: "tự biên tự diễn",
    part_of_speech: "",
    meaning:
      "tự sáng tác và biểu diễn một cách không chuyên nghiệp: vở chèo do đội văn nghệ xã tự biên tự diễn",
    example: "vở chèo do đội văn nghệ xã tự biên tự diễn",
  },
  {
    word: "từ biệt",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) chào để đi xa: từ biệt bạn để đi xa * từ biệt cõi đời (b; chết) * chia tay không một lời từ biệt",
    example:
      "từ biệt bạn để đi xa * từ biệt cõi đời (b; chết) * chia tay không một lời từ biệt",
  },
  {
    word: "tư biện",
    part_of_speech: "động từ",
    meaning:
      "chỉ suy luận đơn thuần, không dựa vào kinh nghiệm, vào thực tiễn: triết học tư biện",
    example: "triết học tư biện",
  },
  {
    word: "tử biệt",
    part_of_speech: "động từ",
    meaning:
      "(cũ, trang trọng) chia tay vĩnh viễn với người vừa chết: nỗi đau tử biệt",
    example: "nỗi đau tử biệt",
  },
  {
    word: "tử biệt sinh li",
    part_of_speech: "",
    meaning:
      'như sinh li tử biệt: "Đau lòng tử biệt sinh li, Thân còn chẳng tiếc, tiếc gì đến duyên!" (TKiều)',
    example:
      'Đau lòng tử biệt sinh li, Thân còn chẳng tiếc, tiếc gì đến duyên!" (TKiều)',
  },
  {
    word: "từ bỏ",
    part_of_speech: "động từ",
    meaning:
      "bỏ đi không nhìn nhận, tự coi là không có quan hệ gì nữa: từ bỏ quê hương * từ bỏ đứa con hư",
    example: "từ bỏ quê hương * từ bỏ đứa con hư",
  },
  {
    word: "từ bỏ",
    part_of_speech: "động từ",
    meaning:
      "thôi không tiếp tục theo đuổi nữa: từ bỏ ước mơ * từ bỏ sự nghiệp * từ bỏ một thói quen xấu",
    example: "từ bỏ ước mơ * từ bỏ sự nghiệp * từ bỏ một thói quen xấu",
  },
  {
    word: "tử biệt sinh ly",
    part_of_speech: "",
    meaning:
      'như sinh li tử biệt: "Đau lòng tử biệt sinh li, Thân còn chẳng tiếc, tiếc gì đến duyên!" (TKiều)',
    example:
      'Đau lòng tử biệt sinh li, Thân còn chẳng tiếc, tiếc gì đến duyên!" (TKiều)',
  },
  {
    word: "tứ bình",
    part_of_speech: "danh từ",
    meaning: "tranh tứ bình (nói tắt): bộ tứ bình",
    example: "bộ tứ bình",
  },
  {
    word: "tự cấp",
    part_of_speech: "động từ",
    meaning:
      "tự đảm bảo việc cung cấp nhu cầu tiêu dùng nào đó cho mình: chăn nuôi để tự cấp một phần thực phẩm",
    example: "chăn nuôi để tự cấp một phần thực phẩm",
  },
  {
    word: "tự cao",
    part_of_speech: "tính từ",
    meaning:
      "tự cho mình là hơn người và tỏ ra coi thường người khác: tưởng mình giỏi nên sinh tự cao",
    example: "tưởng mình giỏi nên sinh tự cao",
  },
  {
    word: "tứ chi",
    part_of_speech: "danh từ",
    meaning:
      "hai tay và hai chân của cơ thể người, hoặc bốn chân của cơ thể động vật (nói tổng quát): liệt tứ chi",
    example: "liệt tứ chi",
  },
  {
    word: "tự cấp tự túc",
    part_of_speech: "",
    meaning:
      "sản xuất ra nhằm thoả mãn yêu cầu tiêu dùng của mình, không trao đổi trên thị trường: nền kinh tế tự cấp tự túc",
    example: "nền kinh tế tự cấp tự túc",
  },
  {
    word: "tư chất",
    part_of_speech: "danh từ",
    meaning:
      "tính chất có sẵn của một người, thường nói về mặt trí tuệ: người có tư chất tốt * tư chất thông minh",
    example: "người có tư chất tốt * tư chất thông minh",
  },
  {
    word: "tử chiến",
    part_of_speech: "động từ",
    meaning:
      "chiến đấu rất quyết liệt, không kể gì sống chết: quyết một trận tử chiến",
    example: "quyết một trận tử chiến",
  },
  {
    word: "tứ chiếng",
    part_of_speech: "",
    meaning:
      '(khẩu ngữ) (người) đến từ khắp bốn phương, từ khắp mọi nơi, không thuần nhất (hàm ý coi khinh), phân biệt với cư dân nơi sở tại: dân tứ chiếng * "Trai tứ chiếng gái giang hồ, Gặp nhau làm nổi cơ đồ cũng nên." (ca dao)',
    example:
      'dân tứ chiếng * "Trai tứ chiếng gái giang hồ, Gặp nhau làm nổi cơ đồ cũng nên." (ca dao)',
  },
  {
    word: "tư cách",
    part_of_speech: "danh từ",
    meaning:
      "cách ăn ở, cư xử, biểu hiện phẩm chất đạo đức của một người: tư cách mẫu mực * thiếu tư cách * một con người có tư cách",
    example: "tư cách mẫu mực * thiếu tư cách * một con người có tư cách",
  },
  {
    word: "tư cách",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ nói chung những điều yêu cầu đối với một cá nhân để có thể được công nhận ở một vị trí, thực hiện một chức năng xã hội nào đó: tư cách pháp nhân * kiểm tra tư cách đại biểu",
    example: "tư cách pháp nhân * kiểm tra tư cách đại biểu",
  },
  {
    word: "tư cách",
    part_of_speech: "danh từ",
    meaning:
      "một mặt nào đó trong các mặt chức năng, cương vị, vị trí của một người, một sự vật: tham gia với tư cách nhà tài trợ * phát biểu với tư cách cá nhân",
    example: "tham gia với tư cách nhà tài trợ * phát biểu với tư cách cá nhân",
  },
  {
    word: "tự chủ",
    part_of_speech: "động từ",
    meaning:
      "hay t tự điều hành, quản lí mọi công việc của mình, không bị ai chi phối: ý thức độc lập tự chủ * quyền tự chủ của một dân tộc",
    example: "ý thức độc lập tự chủ * quyền tự chủ của một dân tộc",
  },
  {
    word: "tự chủ",
    part_of_speech: "động từ",
    meaning:
      "tự làm chủ tình cảm, hành động của mình, không để bị hoàn cảnh chi phối: giận quá nên mất tự chủ",
    example: "giận quá nên mất tự chủ",
  },
  {
    word: "từ chối",
    part_of_speech: "động từ",
    meaning:
      "không chịu nhận cái được dành cho hoặc được yêu cầu: từ chối lời mời * nói thế nào cũng nhất định từ chối",
    example: "từ chối lời mời * nói thế nào cũng nhất định từ chối",
  },
  {
    word: "từ chức",
    part_of_speech: "động từ",
    meaning: "xin thôi không giữ chức vụ hiện đang giữ: đệ đơn xin từ chức",
    example: "đệ đơn xin từ chức",
  },
  {
    word: "tử cung",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận sinh dục bên trong của phụ nữ hay động vật có vú giống cái, chứa thai trong suốt thời kì thai nghén: chửa ngoài dạ con",
    example: "chửa ngoài dạ con",
  },
  {
    word: "từ chương",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) như văn chương (ng1): "Có người xưa vốn bậc văn nhân, Cùng với từ chương trót nợ nần." (TrHLiệu; 1)',
    example:
      'Có người xưa vốn bậc văn nhân, Cùng với từ chương trót nợ nần." (TrHLiệu; 1)',
  },
  {
    word: "từ chương",
    part_of_speech: "danh từ",
    meaning:
      "lối văn chương phổ biến thời trước, chỉ coi trọng hình thức, kĩ xảo, không chú trọng nội dung, không thiết thực: lối học từ chương",
    example: "lối học từ chương",
  },
  {
    word: "tự cường",
    part_of_speech: "động từ",
    meaning:
      "tự làm cho mình ngày một mạnh lên, không chịu thua kém người: ý thức tự cường dân tộc",
    example: "ý thức tự cường dân tộc",
  },
  {
    word: "tự do",
    part_of_speech: "danh từ",
    meaning:
      "phạm trù triết học chỉ khả năng biểu hiện ý chí, làm theo ý muốn của mình trên cơ sở nhận thức được quy luật phát triển của tự nhiên và xã hội: tự do là cái tất yếu được nhận thức",
    example: "tự do là cái tất yếu được nhận thức",
  },
  {
    word: "tự do",
    part_of_speech: "danh từ",
    meaning:
      "trạng thái một dân tộc, một xã hội và các thành viên không bị cấm đoán, hạn chế vô lí trong các hoạt động xã hội - chính trị: đấu tranh cho tự do của đất nước * một dân tộc đã giành được tự do",
    example:
      "đấu tranh cho tự do của đất nước * một dân tộc đã giành được tự do",
  },
  {
    word: "tự do",
    part_of_speech: "danh từ",
    meaning:
      "trạng thái không bị giam cầm hoặc không bị làm nô lệ: trả tự do cho tù binh",
    example: "trả tự do cho tù binh",
  },
  {
    word: "tự do",
    part_of_speech: "danh từ",
    meaning:
      "trạng thái không bị cấm đoán, hạn chế vô lí trong việc làm nào đó: bị gò bó, mất hết tự do",
    example: "bị gò bó, mất hết tự do",
  },
  {
    word: "tự do",
    part_of_speech: "tính từ",
    meaning: "có các quyền tự do về xã hội - chính trị: một dân tộc tự do",
    example: "một dân tộc tự do",
  },
  {
    word: "tự do",
    part_of_speech: "tính từ",
    meaning: "không bị lực lượng ngoại xâm chiếm đóng: rút quân ra vùng tự do",
    example: "rút quân ra vùng tự do",
  },
  {
    word: "tự do",
    part_of_speech: "tính từ",
    meaning:
      "không bị cấm đoán, hạn chế vô lí trong hoạt động cụ thể nào đó: tự do bay nhảy * cho trẻ tự do, thích chơi gì thì chơi",
    example: "tự do bay nhảy * cho trẻ tự do, thích chơi gì thì chơi",
  },
  {
    word: "tự do",
    part_of_speech: "tính từ",
    meaning:
      "không có những sự ràng buộc, hạn chế về những mặt nào đó, đối lập với những trường hợp thông thường khác: thí sinh tự do * lao động tự do * triển lãm mở cửa cho người xem vào tự do",
    example:
      "thí sinh tự do * lao động tự do * triển lãm mở cửa cho người xem vào tự do",
  },
  {
    word: "tư dinh",
    part_of_speech: "danh từ",
    meaning:
      "(trang trọng) dinh thự riêng: xây cất tư dinh * tư dinh của viên đại sứ",
    example: "xây cất tư dinh * tư dinh của viên đại sứ",
  },
  {
    word: "tư doanh",
    part_of_speech: "tính từ",
    meaning:
      "do tư nhân kinh doanh; phân biệt với quốc doanh: công ti tư doanh * xí nghiệp tư doanh",
    example: "công ti tư doanh * xí nghiệp tư doanh",
  },
  {
    word: "tự dạng",
    part_of_speech: "danh từ",
    meaning: "dáng chữ viết riêng của mỗi người: so tự dạng để tìm thủ phạm",
    example: "so tự dạng để tìm thủ phạm",
  },
  {
    word: "tự do chủ nghĩa",
    part_of_speech: "tính từ",
    meaning:
      "tuỳ tiện theo ý riêng, không chịu sự ràng buộc của nguyên tắc tổ chức: lối sống tự do chủ nghĩa",
    example: "lối sống tự do chủ nghĩa",
  },
  {
    word: "tự dưng",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) tự nhiên, không rõ vì sao: tự dưng nước mắt cứ trào ra * mọi thứ không phải tự dưng mà có",
    example: "tự dưng nước mắt cứ trào ra * mọi thứ không phải tự dưng mà có",
  },
  {
    word: "tự dưỡng",
    part_of_speech: "động từ",
    meaning:
      "(sinh vật) có khả năng tự chế tạo được chất dinh dưỡng hữu cơ từ chất vô cơ lấy trong môi trường ngoài để nuôi cơ thể: cây xanh là sinh vật tự dưỡng",
    example: "cây xanh là sinh vật tự dưỡng",
  },
  {
    word: "tư duy",
    part_of_speech: "",
    meaning:
      "giai đoạn cao của quá trình nhận thức, đi sâu vào bản chất và phát hiện ra tính quy luật của sự vật bằng những hình thức như biểu tượng, khái niệm, phán đoán và suy lí: đổi mới tư duy * tư duy khoa học * khả năng tư duy kém",
    example: "đổi mới tư duy * tư duy khoa học * khả năng tư duy kém",
  },
  {
    word: "tự đắc",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra thích thú về một thành công nào đó của mình và tự cho mình là hay, là giỏi: mặt vênh vênh tự đắc * lên mặt tự đắc",
    example: "mặt vênh vênh tự đắc * lên mặt tự đắc",
  },
  {
    word: "tự điển",
    part_of_speech: "danh từ",
    meaning: "(cũ) từ điển: Hán ngữ tự điển",
    example: "Hán ngữ tự điển",
  },
  {
    word: "tử địa",
    part_of_speech: "danh từ",
    meaning:
      "nơi rất nguy hiểm đến tính mạng; chỗ chết: lừa giặc vào tử địa * thoát vòng tử địa",
    example: "lừa giặc vào tử địa * thoát vòng tử địa",
  },
  {
    word: "từ điển song ngữ",
    part_of_speech: "danh từ",
    meaning: "từ điển hai thứ tiếng: từ điển song ngữ Anh - Việt",
    example: "từ điển song ngữ Anh - Việt",
  },
  {
    word: "từ điển giải thích",
    part_of_speech: "danh từ",
    meaning:
      "từ điển giải thích các nghĩa của từ và ngữ trong một ngôn ngữ: từ điển giải thích tiếng Việt",
    example: "từ điển giải thích tiếng Việt",
  },
  {
    word: "tư đồ",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) chức quan to thời xưa, tuỳ theo từng triều đại mà có thể có những nhiệm vụ khác nhau: quan tư đồ",
    example: "quan tư đồ",
  },
  {
    word: "tự động",
    part_of_speech: "tính từ",
    meaning:
      "(làm việc gì) tự mình làm, không chờ có người bảo: tự động bỏ về * mọi người, không ai bảo ai đều tự động đến giúp",
    example: "tự động bỏ về * mọi người, không ai bảo ai đều tự động đến giúp",
  },
  {
    word: "tự động",
    part_of_speech: "tính từ",
    meaning:
      "(máy móc) có khả năng, sau khi đã được khởi động, tự hoạt động mà không cần có người tham gia trực tiếp: máy ảnh tự động * phần mềm biên dịch tự động",
    example: "máy ảnh tự động * phần mềm biên dịch tự động",
  },
  {
    word: "từ đường",
    part_of_speech: "danh từ",
    meaning:
      "nhà thờ tổ tiên của một họ: từ đường họ Nguyễn * ngôi từ đường cổ kính",
    example: "từ đường họ Nguyễn * ngôi từ đường cổ kính",
  },
  {
    word: "từ điển tường giải",
    part_of_speech: "danh từ",
    meaning:
      "từ điển giải thích các nghĩa của từ và ngữ trong một ngôn ngữ: từ điển giải thích tiếng Việt",
    example: "từ điển giải thích tiếng Việt",
  },
  {
    word: "từ điển",
    part_of_speech: "danh từ",
    meaning:
      "sách tra cứu tập hợp các đơn vị ngôn ngữ (thường là đơn vị từ vựng) và sắp xếp theo một thứ tự nhất định, cung cấp một số kiến thức cần thiết đối với từng đơn vị: từ điển tiếng Việt * từ điển trực tuyến * tra từ điển",
    example: "từ điển tiếng Việt * từ điển trực tuyến * tra từ điển",
  },
  {
    word: "từ đồng nghĩa",
    part_of_speech: "danh từ",
    meaning:
      "từ có nghĩa giống nhau, nhưng có vỏ ngữ âm khác nhau:   * ,  *  là những từ đồng nghĩa",
    example: "* ,  *  là những từ đồng nghĩa",
  },
  {
    word: "từ đồng âm",
    part_of_speech: "danh từ",
    meaning:
      "từ có vỏ ngữ âm giống nhau, nhưng khác nhau về nghĩa: đá' (hòn đá) và 'đá' (đá bóng) là hai từ đồng âm",
    example: "đá' (hòn đá) và 'đá' (đá bóng) là hai từ đồng âm",
  },
  {
    word: "tư gia",
    part_of_speech: "danh từ",
    meaning: "(cũ) nhà riêng: mời đến thăm tư gia",
    example: "mời đến thăm tư gia",
  },
  {
    word: "tự động hoá",
    part_of_speech: "động từ",
    meaning:
      "sử dụng rộng rãi và có hệ thống những máy móc, thiết bị tự động để làm nhiều chức năng điều khiển, kiểm tra mà trước đây phải do con người thực hiện: công nghệ tự động hoá * tự động hoá sản xuất",
    example: "công nghệ tự động hoá * tự động hoá sản xuất",
  },
  {
    word: "tự giác",
    part_of_speech: "tính từ",
    meaning:
      "(làm việc gì) tự mình hiểu mà làm, không cần nhắc nhở, đốc thúc: tự giác học tập * tự giác làm việc, không để ai nhắc nhở * có tinh thần tự giác cao",
    example:
      "tự giác học tập * tự giác làm việc, không để ai nhắc nhở * có tinh thần tự giác cao",
  },
  {
    word: "tự giác",
    part_of_speech: "tính từ",
    meaning:
      "(giai cấp, tầng lớp xã hội) có ý thức về quyền lợi của mình và về vai trò, vị trí của mình trong xã hội, đấu tranh có tổ chức, có lãnh đạo; phân biệt với tự phát: đấu tranh tự giác",
    example: "đấu tranh tự giác",
  },
  {
    word: "tử hình",
    part_of_speech: "danh từ",
    meaning: "hình phạt phải chịu tội chết: chịu án tử hình",
    example: "chịu án tử hình",
  },
  {
    word: "tự hào",
    part_of_speech: "",
    meaning:
      "lấy làm hài lòng, hãnh diện về cái tốt đẹp mà mình có: lòng tự hào dân tộc * tự hào về thành tích đã đạt được",
    example: "lòng tự hào dân tộc * tự hào về thành tích đã đạt được",
  },
  {
    word: "tự hành",
    part_of_speech: "tính từ",
    meaning:
      "(thiết bị, máy móc) có thể tự di chuyển để vận hành: máy trộn bê tông tự hành",
    example: "máy trộn bê tông tự hành",
  },
  {
    word: "từ giã",
    part_of_speech: "động từ",
    meaning:
      "chào (cái có quan hệ thân thiết, gắn bó) để rời đi xa, với ý nghĩ rằng có thể không còn có dịp quay trở về gặp lại nữa: từ giã tuổi thơ * từ giã cõi đời (b; chết)",
    example: "từ giã tuổi thơ * từ giã cõi đời (b; chết)",
  },
  {
    word: "tự hoại",
    part_of_speech: "động từ",
    meaning:
      "(chất hữu cơ) bị hoại đi dần dần qua một quá trình tự nhiên: bể tự hoại * hố xí tự hoại",
    example: "bể tự hoại * hố xí tự hoại",
  },
  {
    word: "tứ giác",
    part_of_speech: "danh từ",
    meaning: "đa giác có bốn cạnh: hình tứ giác",
    example: "hình tứ giác",
  },
  {
    word: "từ hoá",
    part_of_speech: "động từ",
    meaning: "làm cho trở thành có từ tính: lõi thép đã được từ hoá",
    example: "lõi thép đã được từ hoá",
  },
  {
    word: "tư hữu",
    part_of_speech: "tính từ",
    meaning:
      "thuộc quyền sở hữu của cá nhân; phân biệt với công hữu: ruộng đất tư hữu * chế độ tư hữu * quyền tư hữu tài sản",
    example: "ruộng đất tư hữu * chế độ tư hữu * quyền tư hữu tài sản",
  },
  {
    word: "tự khắc",
    part_of_speech: "phụ từ",
    meaning:
      "tự nó sẽ đến, sẽ xảy ra (thường là hay, là lành), như là kết quả tự nhiên của điều nào đó vừa được nói đến, không cần phải có sự can thiệp từ bên ngoài vào: làm nhiều tự khắc sẽ quen * cứ nói như thế, tự khắc anh ấy sẽ hiểu",
    example:
      "làm nhiều tự khắc sẽ quen * cứ nói như thế, tự khắc anh ấy sẽ hiểu",
  },
  {
    word: "tử huyệt",
    part_of_speech: "danh từ",
    meaning:
      "huyệt nguy hiểm, có thể làm chết người khi bị tác động; cũng dùng để chỉ nơi bị coi là điểm yếu: đánh vào tử huyệt",
    example: "đánh vào tử huyệt",
  },
  {
    word: "tứ kết",
    part_of_speech: "danh từ",
    meaning:
      "vòng đấu để chọn bốn đội hoặc bốn vận động viên vào bán kết: trận tứ kết * đội bóng được lọt vào tứ kết",
    example: "trận tứ kết * đội bóng được lọt vào tứ kết",
  },
  {
    word: "từ hư",
    part_of_speech: "danh từ",
    meaning:
      "từ không có chức năng định danh, không có khả năng độc lập làm thành phần câu, được dùng để biểu thị quan hệ ngữ pháp giữa các thực từ; phân biệt với thực từ: đã, đang, sẽ... là những hư từ",
    example: "đã, đang, sẽ... là những hư từ",
  },
  {
    word: "tư hữu hoá",
    part_of_speech: "động từ",
    meaning:
      "làm cho trở thành thuộc quyền sở hữu riêng của cá nhân: ruộng đất bị tư hữu hoá",
    example: "ruộng đất bị tư hữu hoá",
  },
  {
    word: "tự kiêu",
    part_of_speech: "tính từ",
    meaning: "như tự cao: thói tự kiêu",
    example: "thói tự kiêu",
  },
  {
    word: "tự kỉ ám thị",
    part_of_speech: "",
    meaning:
      "tự làm nảy sinh trong ý thức những ý nghĩ nào đó về chính bản thân mình và luôn cho rằng điều đó là có thật: chữa bệnh bằng phương pháp tự kỉ ám thị",
    example: "chữa bệnh bằng phương pháp tự kỉ ám thị",
  },
  {
    word: "tự kỷ ám thị",
    part_of_speech: "",
    meaning:
      "tự làm nảy sinh trong ý thức những ý nghĩ nào đó về chính bản thân mình và luôn cho rằng điều đó là có thật: chữa bệnh bằng phương pháp tự kỉ ám thị",
    example: "chữa bệnh bằng phương pháp tự kỉ ám thị",
  },
  {
    word: "từ láy",
    part_of_speech: "danh từ",
    meaning:
      "từ đa tiết trong đó một hoặc hai âm tiết có hình thức là láy âm của âm tiết kia: ,  * ,  * , v.v. là những từ láy",
    example: ",  * ,  * , v.v. là những từ láy",
  },
  {
    word: "tự lập",
    part_of_speech: "động từ",
    meaning:
      "tự xây dựng lấy cuộc sống cho mình, không ỷ lại, nhờ vả người khác: có tính tự lập * sống tự lập",
    example: "có tính tự lập * sống tự lập",
  },
  {
    word: "tư lợi",
    part_of_speech: "danh từ",
    meaning:
      "lợi ích riêng của cá nhân, về mặt đem đối lập với lợi ích chung: mưu cầu tư lợi * làm việc vì tư lợi",
    example: "mưu cầu tư lợi * làm việc vì tư lợi",
  },
  {
    word: "tư lợi",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) lấy của chung làm thành của riêng: hành vi tư lợi * không tư lợi của công",
    example: "hành vi tư lợi * không tư lợi của công",
  },
  {
    word: "từ loại",
    part_of_speech: "danh từ",
    meaning:
      "phạm trù ngữ pháp bao gồm các từ có chung đặc điểm ngữ pháp và ý nghĩa khái quát, như danh từ, động từ, tính từ, v.v.: đưa ra các tiêu chí xác định từ loại * từ loại danh từ",
    example: "đưa ra các tiêu chí xác định từ loại * từ loại danh từ",
  },
  {
    word: "tư liệu",
    part_of_speech: "danh từ",
    meaning:
      "những thứ vật chất con người sử dụng trong một lĩnh vực hoạt động nhất định nào đó (nói khái quát): tư liệu sinh hoạt * tư liệu sản xuất",
    example: "tư liệu sinh hoạt * tư liệu sản xuất",
  },
  {
    word: "tư liệu",
    part_of_speech: "danh từ",
    meaning:
      "tài liệu sử dụng cho việc nghiên cứu (nói khái quát): thu thập tư liệu * tư liệu tham khảo * phim tư liệu",
    example: "thu thập tư liệu * tư liệu tham khảo * phim tư liệu",
  },
  {
    word: "tứ linh",
    part_of_speech: "danh từ",
    meaning:
      "bốn con vật: long (rồng), lân (kì lân), quy (rùa) và phượng, được coi là linh thiêng theo quan niệm cũ (nói tổng quát): bức chạm tứ linh",
    example: "bức chạm tứ linh",
  },
  {
    word: "tư lương",
    part_of_speech: "động từ",
    meaning:
      '(cũ, văn chương) tưởng nhớ da diết: nặng lòng tư lương * "(...) Thâu đêm mong mỏi, ngày ngày tư lương." (HTr)',
    example:
      'nặng lòng tư lương * "(...) Thâu đêm mong mỏi, ngày ngày tư lương." (HTr)',
  },
  {
    word: "tư lự",
    part_of_speech: "động từ",
    meaning:
      "có vẻ đang phải nghĩ ngợi, bận tâm về điều gì: đôi mắt tư lự * vẻ mặt tư lự",
    example: "đôi mắt tư lự * vẻ mặt tư lự",
  },
  {
    word: "tự lực",
    part_of_speech: "tính từ",
    meaning:
      "(làm việc gì) tự sức mình, với sức lực của bản thân, không nhờ cậy ai: có ý chí tự lực * tinh thần tự lực",
    example: "có ý chí tự lực * tinh thần tự lực",
  },
  {
    word: "từ mẫu",
    part_of_speech: "danh từ",
    meaning: "(cũ) mẹ hiền: lương y như từ mẫu",
    example: "lương y như từ mẫu",
  },
  {
    word: "tự mãn",
    part_of_speech: "tính từ",
    meaning:
      "tự lấy làm thoả mãn về những gì mình đã đạt được, mà không cần phải cố gắng hơn nữa: vẻ mặt tự mãn * tự mãn với thành tích đã đạt được",
    example: "vẻ mặt tự mãn * tự mãn với thành tích đã đạt được",
  },
  {
    word: "tự nguyện",
    part_of_speech: "động từ",
    meaning:
      "tự mình muốn làm, không phải bị thúc ép, bắt buộc: tự nguyện ra đi * làm việc trên tinh thần tự nguyện",
    example: "tự nguyện ra đi * làm việc trên tinh thần tự nguyện",
  },
  {
    word: "từ nguyên",
    part_of_speech: "danh từ",
    meaning: "nguồn gốc của từ ngữ: giải thích từ nguyên * từ điển từ nguyên",
    example: "giải thích từ nguyên * từ điển từ nguyên",
  },
  {
    word: "từ ngữ",
    part_of_speech: "danh từ",
    meaning:
      "từ và ngữ (nói khái quát): từ ngữ khoa học * dùng từ ngữ chính xác",
    example: "từ ngữ khoa học * dùng từ ngữ chính xác",
  },
  {
    word: "tử ngoại",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về quang phổ tiếp cận với miền phổ mắt thường nhìn thấy được, về phía màu tím: tia tử ngoại",
    example: "tia tử ngoại",
  },
  {
    word: "tứ ngôn",
    part_of_speech: "danh từ",
    meaning: "thể thơ mỗi câu có bốn âm tiết: thơ tứ ngôn",
    example: "thơ tứ ngôn",
  },
  {
    word: "từ nan",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) từ chối, thoái thác việc khó khăn: dẫu nguy hiểm cũng không từ nan",
    example: "dẫu nguy hiểm cũng không từ nan",
  },
  {
    word: "tử nạn",
    part_of_speech: "động từ",
    meaning:
      "chết do chiến tranh hay do tai nạn: nhiều dân thường tử nạn trong cuộc chiến * 12 học sinh đã tử nạn trong vụ đắm đò",
    example:
      "nhiều dân thường tử nạn trong cuộc chiến * 12 học sinh đã tử nạn trong vụ đắm đò",
  },
  {
    word: "tử ngữ",
    part_of_speech: "danh từ",
    meaning:
      "ngôn ngữ xưa, ngày nay không ai dùng để nói nữa; phân biệt với sinh ngữ: tiếng Latin, tiếng Hi Lạp cổ là những tử ngữ",
    example: "tiếng Latin, tiếng Hi Lạp cổ là những tử ngữ",
  },
  {
    word: "từ nhiệm",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) như từ chức: đơn từ nhiệm của thủ tướng * diễn văn từ nhiệm",
    example: "đơn từ nhiệm của thủ tướng * diễn văn từ nhiệm",
  },
  {
    word: "tư nhân",
    part_of_speech: "danh từ",
    meaning:
      "một cá nhân nào đó (chứ không phải nhà nước hay đoàn thể): doanh nghiệp tư nhân * xí nghiệp giao cho tư nhân quản lí",
    example: "doanh nghiệp tư nhân * xí nghiệp giao cho tư nhân quản lí",
  },
  {
    word: "từ phản nghĩa",
    part_of_speech: "danh từ",
    meaning:
      "từ có nghĩa không những trái ngược nhau (như tốt và xấu), mà còn đối lập với nhau, nghĩa từ này là sự phủ định của nghĩa từ kia, và ngược lại:  và  *  là cặp từ phản nghĩa",
    example: "và  *  là cặp từ phản nghĩa",
  },
  {
    word: "tự nhiên",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ nói chung những gì tồn tại sẵn có trong vũ trụ mà không phải do con người tạo ra: quy luật tự nhiên * cải tạo tự nhiên * các loài sinh vật trong tự nhiên",
    example:
      "quy luật tự nhiên * cải tạo tự nhiên * các loài sinh vật trong tự nhiên",
  },
  {
    word: "tự nhiên",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về tự nhiên hoặc có tính chất của tự nhiên, không phải do con người tạo ra hoặc tác động hay can thiệp vào: rừng tự nhiên * điều kiện tự nhiên * quy luật đào thải tự nhiên",
    example: "rừng tự nhiên * điều kiện tự nhiên * quy luật đào thải tự nhiên",
  },
  {
    word: "tự nhiên",
    part_of_speech: "tính từ",
    meaning:
      "(cử chỉ, nói năng, v.v.) bình thường như vốn có của bản thân, không có gì là gượng gạo, kiểu cách hoặc gò bó, giả tạo: ăn uống tự nhiên, không làm khách * cử chỉ lúng túng, mất tự nhiên",
    example:
      "ăn uống tự nhiên, không làm khách * cử chỉ lúng túng, mất tự nhiên",
  },
  {
    word: "tự nhiên",
    part_of_speech: "tính từ",
    meaning:
      "(sự việc xảy ra) không có hoặc không rõ lí do, tựa như là một hiện tượng thuần tuý trong tự nhiên vậy: tự nhiên trở nên giàu có * hai má tự nhiên đỏ bừng",
    example: "tự nhiên trở nên giàu có * hai má tự nhiên đỏ bừng",
  },
  {
    word: "tự nhiên",
    part_of_speech: "tính từ",
    meaning:
      "theo lẽ thường ở đời, phù hợp với lẽ thường của tự nhiên: thuận theo lẽ tự nhiên * cố gắng chăm chỉ, chịu khó rồi tự nhiên sẽ học giỏi",
    example:
      "thuận theo lẽ tự nhiên * cố gắng chăm chỉ, chịu khó rồi tự nhiên sẽ học giỏi",
  },
  {
    word: "tự phát",
    part_of_speech: "tính từ",
    meaning:
      "phát sinh ra một cách tự nhiên, không có ý thức tự giác hoặc không có lãnh đạo: hành động tự phát * đầu tư tự phát, thiếu bài bản",
    example: "hành động tự phát * đầu tư tự phát, thiếu bài bản",
  },
  {
    word: "tự nhủ",
    part_of_speech: "động từ",
    meaning: "tự bảo mình: tự nhủ phải cố gắng hơn nữa",
    example: "tự nhủ phải cố gắng hơn nữa",
  },
  {
    word: "tứ phía",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) bốn phía, xung quanh: đạn bay tứ phía * tứ phía không một bóng người",
    example: "đạn bay tứ phía * tứ phía không một bóng người",
  },
  {
    word: "tư pháp",
    part_of_speech: "danh từ",
    meaning:
      "việc xét xử các hành vi phạm pháp và các vụ kiện tụng trong nhân dân (nói khái quát): cơ quan tư pháp * cán bộ tư pháp",
    example: "cơ quan tư pháp * cán bộ tư pháp",
  },
  {
    word: "tự phục vụ",
    part_of_speech: "động từ",
    meaning:
      "tự mình làm lấy những việc phục vụ cho nhu cầu sinh hoạt hằng ngày của mình, không cần có người giúp, người phục vụ: tập dần cho trẻ thói quen tự phục vụ",
    example: "tập dần cho trẻ thói quen tự phục vụ",
  },
  {
    word: "tự phục vụ",
    part_of_speech: "động từ",
    meaning:
      "(khách hàng) tự mình phục vụ cho mình (lối tổ chức của một số cửa hàng buôn bán và dịch vụ): cửa hàng ăn tự phục vụ",
    example: "cửa hàng ăn tự phục vụ",
  },
  {
    word: "tứ phương",
    part_of_speech: "danh từ",
    meaning:
      "bốn phương: đông, tây, nam, bắc; khắp mọi nơi: đi tứ phương * có bệnh thì vái tứ phương",
    example: "đi tứ phương * có bệnh thì vái tứ phương",
  },
  {
    word: "tự phụ",
    part_of_speech: "",
    meaning:
      "tự đánh giá quá cao tài năng, thành tích của mình, do đó coi thường mọi người, kể cả người trên mình: có tính tự phụ * biết mình thông minh nên rất tự phụ",
    example: "có tính tự phụ * biết mình thông minh nên rất tự phụ",
  },
  {
    word: "tứ quý",
    part_of_speech: "danh từ",
    meaning: "(cũ) bốn mùa trong năm: xuân, hạ, thu, đông: bộ tranh tứ quý",
    example: "bộ tranh tứ quý",
  },
  {
    word: "tứ quý",
    part_of_speech: "danh từ",
    meaning:
      "bốn loại cây, tiêu biểu cho bốn mùa trong năm: mai, tùng (hoặc lan), cúc, trúc (nói tổng quát): tủ có chạm tứ quý",
    example: "tủ có chạm tứ quý",
  },
  {
    word: "tự quản",
    part_of_speech: "động từ",
    meaning:
      "tự mình trông coi, quản lí với nhau công việc của mình, không cần có ai điều khiển: kí túc xá do sinh viên tự quản * hợp tác xã tự quản",
    example: "kí túc xá do sinh viên tự quản * hợp tác xã tự quản",
  },
  {
    word: "tử quy",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) (chim) cuốc: "Nghĩ nông nỗi ngẩn ngơ đòi lúc, Tiếng tử quy thêm giục lòng thương." (ATV)',
    example:
      'Nghĩ nông nỗi ngẩn ngơ đòi lúc, Tiếng tử quy thêm giục lòng thương." (ATV)',
  },
  {
    word: "tự quyền",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tự cho mình có quyền làm điều gì đó: tự quyền định đoạt mọi việc",
    example: "tự quyền định đoạt mọi việc",
  },
  {
    word: "tứ quí",
    part_of_speech: "danh từ",
    meaning: "(cũ) bốn mùa trong năm: xuân, hạ, thu, đông: bộ tranh tứ quý",
    example: "bộ tranh tứ quý",
  },
  {
    word: "tứ quí",
    part_of_speech: "danh từ",
    meaning:
      "bốn loại cây, tiêu biểu cho bốn mùa trong năm: mai, tùng (hoặc lan), cúc, trúc (nói tổng quát): tủ có chạm tứ quý",
    example: "tủ có chạm tứ quý",
  },
  {
    word: "tư sản",
    part_of_speech: "danh từ",
    meaning:
      "người thuộc giai cấp chiếm hữu các tư liệu sản xuất chủ yếu, sống và làm giàu bằng cách bóc lột lao động làm thuê: giai cấp tư sản * nhà tư sản",
    example: "giai cấp tư sản * nhà tư sản",
  },
  {
    word: "tư sản",
    part_of_speech: "tính từ",
    meaning:
      "thuộc giai cấp tư sản, có tính chất của giai cấp tư sản: cuộc cách mạng tư sản * lối sống tư sản * giọng nói sặc mùi tư sản (kng)",
    example:
      "cuộc cách mạng tư sản * lối sống tư sản * giọng nói sặc mùi tư sản (kng)",
  },
  {
    word: "tứ sắc",
    part_of_speech: "danh từ",
    meaning:
      "trò chơi bằng bài lá có một trăm mười hai quân, bốn màu xanh, vàng, đỏ, trắng khác nhau cho bốn người chơi: đánh tứ sắc",
    example: "đánh tứ sắc",
  },
  {
    word: "tự quyết",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) tự mình quyết định lấy: tự quyết lấy mọi việc * việc lớn nên không dám tự quyết",
    example: "tự quyết lấy mọi việc * việc lớn nên không dám tự quyết",
  },
  {
    word: "tự quyết",
    part_of_speech: "động từ",
    meaning:
      "(dân tộc) tự mình định đoạt những công việc thuộc về vận mệnh của mình (như lập thành một nước riêng, hay là cùng với dân tộc khác lập thành một nước trên cơ sở bình đẳng): quyền dân tộc tự quyết",
    example: "quyền dân tộc tự quyết",
  },
  {
    word: "tử sĩ",
    part_of_speech: "danh từ",
    meaning: "(cũ) người chết trận.",
    example: "thu nhặt hài cốt tử sĩ",
  },
  {
    word: "tự sát",
    part_of_speech: "động từ",
    meaning:
      "tự giết mình một cách cố ý (thường bằng khí giới): rút súng tự sát * tự sát để khỏi rơi vào tay giặc",
    example: "rút súng tự sát * tự sát để khỏi rơi vào tay giặc",
  },
  {
    word: "tử sinh",
    part_of_speech: "động từ",
    meaning:
      '(hiếm) như sinh tử: "Tử sinh liều giữa trận tiền, Dạn dày cho biết gan liền tướng quân!" (TKiều)',
    example:
      'Tử sinh liều giữa trận tiền, Dạn dày cho biết gan liền tướng quân!" (TKiều)',
  },
  {
    word: "tự sự",
    part_of_speech: "danh từ",
    meaning:
      "thể loại văn học trong đó nhà văn phản ánh thế giới bên ngoài bằng cách kể lại sự việc, miêu tả tính cách, thông qua một cốt truyện tương đối hoàn chỉnh: văn tự sự * thể loại tự sự",
    example: "văn tự sự * thể loại tự sự",
  },
  {
    word: "tử số",
    part_of_speech: "danh từ",
    meaning:
      "số viết trên vạch ngang của phân số, chỉ rõ phân số chứa bao nhiêu phần bằng nhau của đơn vị; phân biệt với mẫu số: trong phân số N thì 2 là tử số, 3 là mẫu số",
    example: "trong phân số N thì 2 là tử số, 3 là mẫu số",
  },
  {
    word: "từ tạ",
    part_of_speech: "động từ",
    meaning:
      '(cũ, trang trọng) tỏ lời cảm ơn và xin ra về: "Anh em từ tạ lên đường, Non cao cách trở đường trường hiểm nguy." (PCCH)',
    example:
      'Anh em từ tạ lên đường, Non cao cách trở đường trường hiểm nguy." (PCCH)',
  },
  {
    word: "tự tại",
    part_of_speech: "tính từ",
    meaning:
      "thư thái, không có điều gì phải lo nghĩ, phiền muộn: an nhiên tự tại * ung dung tự tại",
    example: "an nhiên tự tại * ung dung tự tại",
  },
  {
    word: "tử tế",
    part_of_speech: "tính từ",
    meaning:
      "có được tương đối đầy đủ những gì thường đòi hỏi phải có để được coi trọng, không bị coi là quá sơ sài, lôi thôi hoặc thiếu đứng đắn: ăn mặc tử tế * được học hành tử tế * con nhà tử tế",
    example: "ăn mặc tử tế * được học hành tử tế * con nhà tử tế",
  },
  {
    word: "tử tế",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra có lòng tốt trong đối xử với nhau: anh ấy là người tử tế * đối xử với nhau rất tử tế",
    example: "anh ấy là người tử tế * đối xử với nhau rất tử tế",
  },
  {
    word: "từ tâm",
    part_of_speech: "",
    meaning:
      '(Từ cũ, Ít dùng) lòng tốt, lòng thương người: có từ tâm * "Bao bà cụ từ tâm như mẹ, Yêu quý con như đẻ con ra." (THữu; 7)',
    example:
      'có từ tâm * "Bao bà cụ từ tâm như mẹ, Yêu quý con như đẻ con ra." (THữu; 7)',
  },
  {
    word: "tứ tán",
    part_of_speech: "động từ",
    meaning:
      "tản ra khắp mọi phía: thấy động, đàn chim bay tứ tán * gia đình tứ tán mỗi người một nơi",
    example:
      "thấy động, đàn chim bay tứ tán * gia đình tứ tán mỗi người một nơi",
  },
  {
    word: "tự tận",
    part_of_speech: "động từ",
    meaning: "(cũ) tự tử: uống thuốc độc tự tận",
    example: "uống thuốc độc tự tận",
  },
  {
    word: "tự tạo",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) (thiết bị, thường là vũ khí) tự chế tạo lấy để tự trang bị, vì không có điều kiện mua sắm: súng tự tạo * thiết bị tự tạo * cây đàn tự tạo",
    example: "súng tự tạo * thiết bị tự tạo * cây đàn tự tạo",
  },
  {
    word: "tử thần",
    part_of_speech: "danh từ",
    meaning: "thần chết: lưỡi hái tử thần",
    example: "lưỡi hái tử thần",
  },
  {
    word: "tư thất",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) nhà riêng của quan lại, thường làm ngay bên cạnh công đường: tư thất của quan huyện",
    example: "tư thất của quan huyện",
  },
  {
    word: "tự thị",
    part_of_speech: "",
    meaning:
      "tự đánh giá mình quá cao và coi thường người khác: thái độ tự thị",
    example: "thái độ tự thị",
  },
  {
    word: "tự thân",
    part_of_speech: "danh từ",
    meaning: "tự bản thân: tự thân lập nghiệp * tự thân vận động",
    example: "tự thân lập nghiệp * tự thân vận động",
  },
  {
    word: "tư thế",
    part_of_speech: "danh từ",
    meaning:
      "cách đặt toàn thân thể và các bộ phận của thân thể như thế nào đó ở yên tại một vị trí nhất định: tư thế hiên ngang * tập bắn ở các tư thế nằm, quỳ, đứng",
    example: "tư thế hiên ngang * tập bắn ở các tư thế nằm, quỳ, đứng",
  },
  {
    word: "tư thế",
    part_of_speech: "danh từ",
    meaning:
      "cách đi đứng, ăn mặc, nói năng, v.v. của một người, phù hợp với cương vị của người đó (nói tổng quát): tư thế quân nhân * ăn mặc chỉnh tề, rất có tư thế",
    example: "tư thế quân nhân * ăn mặc chỉnh tề, rất có tư thế",
  },
  {
    word: "tử thi",
    part_of_speech: "danh từ",
    meaning: "thân thể người đã chết: khám nghiệm tử thi",
    example: "khám nghiệm tử thi",
  },
  {
    word: "tự thiêu",
    part_of_speech: "động từ",
    meaning:
      "tự châm lửa đốt cháy mình: nhà sư tự thiêu để phản đối chiến tranh",
    example: "nhà sư tự thiêu để phản đối chiến tranh",
  },
  {
    word: "từ thiện",
    part_of_speech: "tính từ",
    meaning:
      "có lòng thương người, sẵn sàng giúp đỡ người nghèo khó để làm phúc: quỹ từ thiện * hội từ thiện * làm từ thiện",
    example: "quỹ từ thiện * hội từ thiện * làm từ thiện",
  },
  {
    word: "tư thông",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) có quan hệ tình dục bất chính, lén lút với nhau: tư thông với trai * hai người tư thông với nhau",
    example: "tư thông với trai * hai người tư thông với nhau",
  },
  {
    word: "tư thông",
    part_of_speech: "động từ",
    meaning:
      "liên hệ, tiếp xúc ngấm ngầm với đối phương để mưu làm phản: tư thông với giặc",
    example: "tư thông với giặc",
  },
  {
    word: "tư thù",
    part_of_speech: "danh từ",
    meaning: "mối thù riêng: mối tư thù * vì tư thù mà trù úm nhân viên",
    example: "mối tư thù * vì tư thù mà trù úm nhân viên",
  },
  {
    word: "tự thú",
    part_of_speech: "động từ",
    meaning:
      "tự mình nhận tội và khai ra các hành động phạm pháp của mình trước khi bị phát hiện hoặc bị cưỡng chế: lời tự thú * kẻ sát nhân đã ra tự thú",
    example: "lời tự thú * kẻ sát nhân đã ra tự thú",
  },
  {
    word: "tử thù",
    part_of_speech: "danh từ",
    meaning:
      "thù sâu sắc, một mất một còn: mối tử thù * giữa hai nhà có tử thù",
    example: "mối tử thù * giữa hai nhà có tử thù",
  },
  {
    word: "tử thù",
    part_of_speech: "danh từ",
    meaning: "(hiếm) kẻ thù sâu sắc, không đội trời chung: coi nhau như tử thù",
    example: "coi nhau như tử thù",
  },
  {
    word: "tự thuật",
    part_of_speech: "động từ",
    meaning: "tự kể về mình: bài thơ tự thuật",
    example: "bài thơ tự thuật",
  },
  {
    word: "cả thể",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) luôn một thể, cùng một lúc: đợi tôi rồi mai ta đi cả thể",
    example: "đợi tôi rồi mai ta đi cả thể",
  },
  {
    word: "cá thể",
    part_of_speech: "danh từ",
    meaning:
      "từng sinh vật riêng lẻ, phân biệt với loài hoặc chủng loại: khu bảo tồn hiện có khoảng hai trăm cá thể các loài thú quý hiếm",
    example: "khu bảo tồn hiện có khoảng hai trăm cá thể các loài thú quý hiếm",
  },
  {
    word: "cá thể",
    part_of_speech: "tính từ",
    meaning:
      "riêng lẻ từng người, không phải tập thể: làm ăn cá thể * thành phần kinh tế cá thể",
    example: "làm ăn cá thể * thành phần kinh tế cá thể",
  },
  {
    word: "cà thọt",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) khập khiễng: chân đi cà thọt",
    example: "chân đi cà thọt",
  },
  {
    word: "cá tính",
    part_of_speech: "danh từ",
    meaning:
      "những đặc trưng tâm lí của cá nhân, bao gồm tính cách, sở thích, v.v.: một con người có cá tính * cá tính mạnh mẽ",
    example: "một con người có cá tính * cá tính mạnh mẽ",
  },
  {
    word: "cả tin",
    part_of_speech: "tính từ",
    meaning:
      "tin ngay một cách dễ dãi mà không cần suy xét: nhẹ dạ cả tin * cả tin nên               hay bị lừa",
    example: "nhẹ dạ cả tin * cả tin nên               hay bị lừa",
  },
  {
    word: "cà tong",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) cao và gầy, mảnh khảnh: thân hình cà tong",
    example: "thân hình cà tong",
  },
  {
    word: "cà tong cà teo",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) như cà tong (nhưng ý nhấn mạnh hơn): người cà tong cà teo",
    example: "người cà tong cà teo",
  },
  {
    word: "cá trôi",
    part_of_speech: "danh từ",
    meaning:
      "cá nước ngọt thân tròn, dài, lưng màu tro xám, ruột rất dài: lôi thôi như cá trôi sổ ruột (tng)",
    example: "lôi thôi như cá trôi sổ ruột (tng)",
  },
  {
    word: "ca tụng",
    part_of_speech: "động từ",
    meaning:
      "nêu lên để ca ngợi, để tỏ lòng biết ơn hoặc kính phục: ca tụng công đức * một văn sĩ được người đời ca tụng",
    example: "ca tụng công đức * một văn sĩ được người đời ca tụng",
  },
  {
    word: "cà trớn",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ, khẩu ngữ) quá đà, không nghiêm túc: tính hay cà trớn * ăn nói cà trớn",
    example: "tính hay cà trớn * ăn nói cà trớn",
  },
  {
    word: "ca từ",
    part_of_speech: "danh từ",
    meaning: "lời của bài hát: ca khúc có ca từ trong sáng",
    example: "ca khúc có ca từ trong sáng",
  },
  {
    word: "ca trù",
    part_of_speech: "danh từ",
    meaning:
      "ca khúc dùng trong các buổi tế lễ, hội hè thời trước: nghệ nhân ca trù * hát ca trù",
    example: "nghệ nhân ca trù * hát ca trù",
  },
  {
    word: "cá vàng",
    part_of_speech: "danh từ",
    meaning:
      "cá cảnh, vây to, đuôi lớn và xoè rộng, thân thường hoá màu vàng đỏ: bể nuôi cá vàng",
    example: "bể nuôi cá vàng",
  },
  {
    word: "ca ve",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) gái nhảy: làm ca ve ở vũ trường",
    example: "làm ca ve ở vũ trường",
  },
  {
    word: "ca vát",
    part_of_speech: "danh từ",
    meaning:
      "băng vải hoặc lụa quàng quanh cổ áo sơ mi, được thắt nút và buông xuống trước ngực, khi mặc âu phục: thắt ca vát * cổ đeo ca vát",
    example: "thắt ca vát * cổ đeo ca vát",
  },
  {
    word: "ca-ki",
    part_of_speech: "danh từ",
    meaning:
      "vải dày dệt bằng sợi xe, thường có màu vàng sẫm, hay dùng để may âu phục: vải kaki * quần kaki",
    example: "vải kaki * quần kaki",
  },
  {
    word: "cá vượt vũ môn",
    part_of_speech: "",
    meaning:
      '(cũ) ví người học trò đi thi được đỗ đạt vinh hiển; cũng dùng để ví người thành đạt hoặc được thoả chí, toại nguyện: "Phận gái lấy được chồng khôn, Xem bằng cá vượt Vũ môn hoá rồng." (ca dao)',
    example:
      'Phận gái lấy được chồng khôn, Xem bằng cá vượt Vũ môn hoá rồng." (ca dao)',
  },
  {
    word: "cà xốc",
    part_of_speech: "",
    meaning: "(phương ngữ) như xấc láo: ăn nói cà xốc",
    example: "ăn nói cà xốc",
  },
  {
    word: "ca-ra",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị đo khối lượng đá quý và ngọc trai, bằng 200 milligram: viên kim cương nặng 300 carat",
    example: "viên kim cương nặng 300 carat",
  },
  {
    word: "ca-ra",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị biểu thị tỉ lệ vàng trong hợp kim vàng, bằng 1/24 khối lượng của hợp kim: vàng 24 carat (vàng nguyên chất)",
    example: "vàng 24 carat (vàng nguyên chất)",
  },
  {
    word: "ca xướng",
    part_of_speech: "động từ",
    meaning: "(cũ) như xướng ca: ham mê ca xướng",
    example: "ham mê ca xướng",
  },
  {
    word: "ca-me-ra",
    part_of_speech: "danh từ",
    meaning: "máy quay phim thu hình: đứng trước ống kính camera",
    example: "đứng trước ống kính camera",
  },
  {
    word: "các bin",
    part_of_speech: "danh từ",
    meaning: "súng trường gọn nhẹ, nửa tự động hoặc tự động: súng các bin",
    example: "súng các bin",
  },
  {
    word: "ca-ta-lô",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) danh mục giới thiệu mẫu hàng, dịch vụ, v.v., thường có tranh ảnh minh hoạ: catalogue thời trang",
    example: "catalogue thời trang",
  },
  {
    word: "các-bon",
    part_of_speech: "danh từ",
    meaning:
      "nguyên tố hoá học, thành phần chính của than và chất hữu cơ: khí carbon",
    example: "khí carbon",
  },
  {
    word: "các",
    part_of_speech: "danh từ",
    meaning:
      "thẻ ghi nhận một giá trị hoặc một tư cách nào đó: các điện thoại * đeo các vào dự hội nghị",
    example: "các điện thoại * đeo các vào dự hội nghị",
  },
  {
    word: "các",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ số lượng nhiều được xác định, gồm tất cả sự vật muốn nói đến: các ngày trong tuần * các nước trên thế giới",
    example: "các ngày trong tuần * các nước trên thế giới",
  },
  {
    word: "các",
    part_of_speech: "động từ",
    meaning:
      "bù thêm vào trong việc đổi chác: muốn đổi phải các thêm tiền * có các vàng cũng chẳng thèm",
    example: "muốn đổi phải các thêm tiền * có các vàng cũng chẳng thèm",
  },
  {
    word: "các tông",
    part_of_speech: "danh từ",
    meaning:
      "giấy dày, xốp, thường làm bằng nguyên liệu xấu, dùng để đóng bìa sách, làm hộp, v.v.: thùng các tông",
    example: "thùng các tông",
  },
  {
    word: "cách",
    part_of_speech: "danh từ",
    meaning:
      "toàn thể nói chung những gì cần thiết để tiến hành một hoạt động cụ thể, nhằm một mục đích nào đó: cách đi đứng khoan thai * việc ấy đã có cách giải quyết * tìm cách gây chia rẽ nội bộ",
    example:
      "cách đi đứng khoan thai * việc ấy đã có cách giải quyết * tìm cách gây chia rẽ nội bộ",
  },
  {
    word: "cách",
    part_of_speech: "danh từ",
    meaning:
      "phạm trù ngữ pháp gắn với danh ngữ trong một số ngôn ngữ, biểu thị chức năng cú pháp của danh ngữ đó trong câu: tiếng Nga có sáu cách",
    example: "tiếng Nga có sáu cách",
  },
  {
    word: "cách",
    part_of_speech: "động từ",
    meaning:
      "không tiếp nối nhau, vì ở giữa có một vật hoặc một khoảng không gian, thời gian nào đó: hai nhà cách nhau một bức tường * cách đây mấy năm",
    example: "hai nhà cách nhau một bức tường * cách đây mấy năm",
  },
  {
    word: "cách",
    part_of_speech: "động từ",
    meaning:
      "không để âm, nhiệt, điện, truyền qua: cao su có khả năng cách điện * phòng cách âm",
    example: "cao su có khả năng cách điện * phòng cách âm",
  },
  {
    word: "cách",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) cách chức (nói tắt): viên tri huyện đã bị cách",
    example: "viên tri huyện đã bị cách",
  },
  {
    word: "cạch",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) chừa, từ bỏ hẳn vì sợ hoặc vì ghét: cạch mặt nó ra! * cạch không dám bén mảng đến * cạch đến già",
    example: "cạch mặt nó ra! * cạch không dám bén mảng đến * cạch đến già",
  },
  {
    word: "cạch",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) từ mô phỏng tiếng gọn, đanh và khô do hai vật cứng va chạm vào nhau: có tiếng cạch cửa",
    example: "có tiếng cạch cửa",
  },
  {
    word: "cách âm",
    part_of_speech: "động từ",
    meaning:
      "ngăn không để cho âm bên trong lan truyền ra bên ngoài, và ngược lại: hệ thống cách âm của phòng thu",
    example: "hệ thống cách âm của phòng thu",
  },
  {
    word: "cách điện",
    part_of_speech: "động từ",
    meaning:
      "ngăn không cho dòng điện chạy qua: sứ cách điện * dùng cao su làm chất cách điện",
    example: "sứ cách điện * dùng cao su làm chất cách điện",
  },
  {
    word: "cách điện",
    part_of_speech: "động từ",
    meaning: "cách điệu hoá (nói tắt): áo dài cách điệu",
    example: "áo dài cách điệu",
  },
  {
    word: "cách chức",
    part_of_speech: "động từ",
    meaning:
      "(hình thức kỉ luật) không cho giữ chức vụ đang làm nữa: cách chức một cán bộ hủ hoá * bị cách chức vì tội tham ô",
    example: "cách chức một cán bộ hủ hoá * bị cách chức vì tội tham ô",
  },
  {
    word: "cách biệt",
    part_of_speech: "động từ",
    meaning:
      'cách xa nhau hoàn toàn, không liên lạc gì được với nhau: sống cách biệt với mọi người * "Yêu nhau chẳng lấy được nhau, Bắc Nam cách biệt ngậm sầu đôi nơi." (ca dao)',
    example:
      'sống cách biệt với mọi người * "Yêu nhau chẳng lấy được nhau, Bắc Nam cách biệt ngậm sầu đôi nơi." (ca dao)',
  },
  {
    word: "cách biệt",
    part_of_speech: "động từ",
    meaning:
      "có sự phân biệt, sự ngăn cách do khác nhau quá xa: nền kinh tế giữa hai nước vẫn còn cách biệt",
    example: "nền kinh tế giữa hai nước vẫn còn cách biệt",
  },
  {
    word: "cách li",
    part_of_speech: "động từ",
    meaning:
      "không để cho tiếp xúc với những người hoặc vật khác, nhằm ngừa trước điều gì (thường là nhằm tránh lây bệnh): cách li bệnh nhân mắc bệnh truyền nhiễm * phòng cách li",
    example: "cách li bệnh nhân mắc bệnh truyền nhiễm * phòng cách li",
  },
  {
    word: "cách ly",
    part_of_speech: "động từ",
    meaning:
      "không để cho tiếp xúc với những người hoặc vật khác, nhằm ngừa trước điều gì (thường là nhằm tránh lây bệnh): cách li bệnh nhân mắc bệnh truyền nhiễm * phòng cách li",
    example: "cách li bệnh nhân mắc bệnh truyền nhiễm * phòng cách li",
  },
  {
    word: "cách điệu hoá",
    part_of_speech: "động từ",
    meaning:
      "thể hiện thành hình tượng nghệ thuật bằng cách chọn và làm nổi bật những nét tiêu biểu nhất: trên bìa sách, hoa sen đã được cách điệu hoá",
    example: "trên bìa sách, hoa sen đã được cách điệu hoá",
  },
  {
    word: "cách mạng",
    part_of_speech: "danh từ",
    meaning:
      "cuộc biến đổi xã hội - chính trị lớn và căn bản, thực hiện bằng việc lật đổ một chế độ xã hội lỗi thời, lập nên một chế độ xã hội mới, tiến bộ: cách mạng tháng Tám năm 1945",
    example: "cách mạng tháng Tám năm 1945",
  },
  {
    word: "cách mạng",
    part_of_speech: "danh từ",
    meaning:
      "cuộc đấu tranh nhằm thực hiện một cuộc cách mạng xã hội: làm cách mạng * tham gia cách mạng",
    example: "làm cách mạng * tham gia cách mạng",
  },
  {
    word: "cách mạng",
    part_of_speech: "danh từ",
    meaning:
      "quá trình thay đổi lớn và căn bản theo hướng tiến bộ trong một lĩnh vực nào đó: cách mạng tư tưởng và văn hoá * cuộc cách mạng kĩ thuật",
    example: "cách mạng tư tưởng và văn hoá * cuộc cách mạng kĩ thuật",
  },
  {
    word: "cách mạng",
    part_of_speech: "danh từ",
    meaning: "(viết hoa) cách mạng tháng Tám (nói tắt): thời trước Cách mạng",
    example: "thời trước Cách mạng",
  },
  {
    word: "cách mạng",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về cách mạng, có tính chất cách mạng: chính quyền cách mạng * nền văn học cách mạng",
    example: "chính quyền cách mạng * nền văn học cách mạng",
  },
  {
    word: "cách mạng hoá",
    part_of_speech: "động từ",
    meaning: "làm cho trở thành có tính chất cách mạng: cách mạng hoá tư tưởng",
    example: "cách mạng hoá tư tưởng",
  },
  {
    word: "cách mặt khuất lời",
    part_of_speech: "",
    meaning:
      '(văn chương) (người sống với người chết) xa cách nhau, hoàn toàn không có sợi dây liên lạc nào: "Dạ đài cách mặt khuất lời, Tưới xin giọt lệ cho người thác oan." (TKiều)',
    example:
      'Dạ đài cách mặt khuất lời, Tưới xin giọt lệ cho người thác oan." (TKiều)',
  },
  {
    word: "cách nhiệt",
    part_of_speech: "động từ",
    meaning:
      "ngăn không để cho nhiệt truyền qua: trần nhà được chống nóng bằng một lớp cách nhiệt",
    example: "trần nhà được chống nóng bằng một lớp cách nhiệt",
  },
  {
    word: "cách quãng",
    part_of_speech: "tính từ",
    meaning:
      "không liền nhau, không liên tục do cách nhau từng đoạn, từng quãng: hầm đào cách quãng * thời gian học bị cách quãng",
    example: "hầm đào cách quãng * thời gian học bị cách quãng",
  },
  {
    word: "cách rách",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) phiền phức, rầy rà: bày vẽ làm gì cho cách rách",
    example: "bày vẽ làm gì cho cách rách",
  },
  {
    word: "cách nhật",
    part_of_speech: "tính từ",
    meaning: "cách một ngày lại diễn ra một lần: sốt rét cách nhật",
    example: "sốt rét cách nhật",
  },
  {
    word: "cách mệnh",
    part_of_speech: "danh từ",
    meaning:
      "cuộc biến đổi xã hội - chính trị lớn và căn bản, thực hiện bằng việc lật đổ một chế độ xã hội lỗi thời, lập nên một chế độ xã hội mới, tiến bộ: cách mạng tháng Tám năm 1945",
    example: "cách mạng tháng Tám năm 1945",
  },
  {
    word: "cách mệnh",
    part_of_speech: "danh từ",
    meaning:
      "cuộc đấu tranh nhằm thực hiện một cuộc cách mạng xã hội: làm cách mạng * tham gia cách mạng",
    example: "làm cách mạng * tham gia cách mạng",
  },
  {
    word: "cách mệnh",
    part_of_speech: "danh từ",
    meaning:
      "quá trình thay đổi lớn và căn bản theo hướng tiến bộ trong một lĩnh vực nào đó: cách mạng tư tưởng và văn hoá * cuộc cách mạng kĩ thuật",
    example: "cách mạng tư tưởng và văn hoá * cuộc cách mạng kĩ thuật",
  },
  {
    word: "cách mệnh",
    part_of_speech: "danh từ",
    meaning: "(viết hoa) cách mạng tháng Tám (nói tắt): thời trước Cách mạng",
    example: "thời trước Cách mạng",
  },
  {
    word: "cách mệnh",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về cách mạng, có tính chất cách mạng: chính quyền cách mạng * nền văn học cách mạng",
    example: "chính quyền cách mạng * nền văn học cách mạng",
  },
  {
    word: "cách ra cách rách",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) như cách rách (nhưng ý mức độ nhiều hơn): suốt ngày cứ bám theo cách ra cách rách",
    example: "suốt ngày cứ bám theo cách ra cách rách",
  },
  {
    word: "cách thuỷ",
    part_of_speech: "tính từ",
    meaning:
      "(cách nấu) không để cho nước tiếp xúc trực tiếp với vật nấu (làm chín bằng hơi nước): hấp cách thuỷ",
    example: "hấp cách thuỷ",
  },
  {
    word: "cách tân",
    part_of_speech: "động từ",
    meaning: "đổi mới (thường nói về văn hoá, nghệ thuật): cách tân nghệ thuật",
    example: "cách tân nghệ thuật",
  },
  {
    word: "cách thức",
    part_of_speech: "danh từ",
    meaning:
      "hình thức diễn ra của một hành động: cách thức băng bó vết thương * trao đổi cách thức tiến hành",
    example: "cách thức băng bó vết thương * trao đổi cách thức tiến hành",
  },
  {
    word: "cái",
    part_of_speech: "danh từ",
    meaning: "(cũ) mẹ: con dại cái mang (tng)",
    example: "con dại cái mang (tng)",
  },
  {
    word: "cái",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) từ dùng để gọi người con gái ngang hàng hoặc hàng dưới một cách thân mật: cái Lan có nhà không hả bác?",
    example: "cái Lan có nhà không hả bác?",
  },
  {
    word: "cái",
    part_of_speech: "danh từ",
    meaning: "giống để gây ra một số chất chua: cái mẻ * cái giấm",
    example: "cái mẻ * cái giấm",
  },
  {
    word: "cái",
    part_of_speech: "danh từ",
    meaning:
      "vai chủ một ván bài, một đám bạc hay một bát họ: nhà cái * làm cái",
    example: "nhà cái * làm cái",
  },
  {
    word: "cái",
    part_of_speech: "danh từ",
    meaning:
      "phần chất đặc, thường là phần chính trong món ăn có nước: khôn ăn cái, dại ăn nước (tng)",
    example: "khôn ăn cái, dại ăn nước (tng)",
  },
  {
    word: "cái",
    part_of_speech: "tính từ",
    meaning:
      "(động vật) thuộc về giống có thể đẻ con hoặc đẻ trứng: chó cái * sư tử cái",
    example: "chó cái * sư tử cái",
  },
  {
    word: "cái",
    part_of_speech: "tính từ",
    meaning:
      "(hoa) không có nhị đực, chỉ có nhị cái, hoặc cây chỉ có hoa như thế: hoa mướp cái * đu đủ cái",
    example: "hoa mướp cái * đu đủ cái",
  },
  {
    word: "cái",
    part_of_speech: "tính từ",
    meaning:
      "thuộc loại to, thường là chính so với những cái khác, loại phụ hoặc nhỏ hơn: cột cái * rễ cái * ngón tay cái * sông cái * đường cái",
    example: "cột cái * rễ cái * ngón tay cái * sông cái * đường cái",
  },
  {
    word: "cái",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ cá thể sự vật, sự việc với nghĩa rất khái quát: đủ cả, không thiếu cái gì * lo cái ăn cái mặc * phân biệt cái hay cái dở * trong cái rủi có cái may",
    example:
      "đủ cả, không thiếu cái gì * lo cái ăn cái mặc * phân biệt cái hay cái dở * trong cái rủi có cái may",
  },
  {
    word: "cái",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị riêng lẻ thuộc loại vật vô sinh: cái bàn này cao * cái áo hoa * hai cái nhà mới",
    example: "cái bàn này cao * cái áo hoa * hai cái nhà mới",
  },
  {
    word: "cái",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) từ dùng để chỉ từng cá thể động vật thuộc một số loại, thường là nhỏ bé hoặc đã được nhân cách hoá: con ong, cái kiến",
    example: "con ong, cái kiến",
  },
  {
    word: "cái",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị riêng lẻ động tác hoặc quá trình ngắn: ngã một cái rất đau * nghỉ tay cái đã * loáng một cái đã biến mất",
    example:
      "ngã một cái rất đau * nghỉ tay cái đã * loáng một cái đã biến mất",
  },
  {
    word: "cái",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý nhấn mạnh về sắc thái xác định của sự vật mà người nói muốn nêu nổi bật với tính chất, tính cách nào đó: cái cây bưởi ấy rất sai quả * cái ngày đáng ghi nhớ ấy",
    example: "cái cây bưởi ấy rất sai quả * cái ngày đáng ghi nhớ ấy",
  },
  {
    word: "cài",
    part_of_speech: "động từ",
    meaning:
      "làm cho một vật nhỏ mắc chặt vào một bộ phận nào đó: cửa đóng then cài * tóc cài hoa * cài lại khuy áo * xe cài số lùi",
    example:
      "cửa đóng then cài * tóc cài hoa * cài lại khuy áo * xe cài số lùi",
  },
  {
    word: "cài",
    part_of_speech: "động từ",
    meaning:
      "bí mật sắp đặt, bố trí xen vào: thợ săn cài bẫy * cài người vào hàng ngũ đối phương",
    example: "thợ săn cài bẫy * cài người vào hàng ngũ đối phương",
  },
  {
    word: "cài",
    part_of_speech: "động từ",
    meaning: "(Khẩu ngữ) cài đặt (nói tắt): cài phần mềm nhận dạng chữ Việt",
    example: "cài phần mềm nhận dạng chữ Việt",
  },
  {
    word: "cách trở",
    part_of_speech: "động từ",
    meaning:
      'ngăn cách, gây trở ngại: "Liêu Dương cách trở sơn khê, Xuân đường kíp gọi Sinh về hộ tang." (TKiều)',
    example:
      'Liêu Dương cách trở sơn khê, Xuân đường kíp gọi Sinh về hộ tang." (TKiều)',
  },
  {
    word: "cách trở quan san",
    part_of_speech: "",
    meaning:
      '(cũ, văn chương) như cách núi ngăn sông: "Rồi ra cách trở quan san, Chẳng may tiếng hạc khơi ngàn non hoa." (PT)',
    example:
      'Rồi ra cách trở quan san, Chẳng may tiếng hạc khơi ngàn non hoa." (PT)',
  },
  {
    word: "cãi",
    part_of_speech: "động từ",
    meaning:
      "dùng lời lẽ chống chế, bác bỏ ý kiến người khác nhằm bảo vệ ý kiến hoặc việc làm của mình: đã làm sai lại còn cãi * gà mái cãi nước sôi (tng)",
    example: "đã làm sai lại còn cãi * gà mái cãi nước sôi (tng)",
  },
  {
    word: "cãi",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) bào chữa (cho một bên đương sự ở trước toà): luật sư cãi cho trắng án",
    example: "luật sư cãi cho trắng án",
  },
  {
    word: "cải",
    part_of_speech: "danh từ",
    meaning:
      "cây có hoa gồm bốn cánh xếp thành hình chữ thập, có nhiều loài, thường được trồng làm rau ăn: bát canh cải",
    example: "bát canh cải",
  },
  {
    word: "cải",
    part_of_speech: "động từ",
    meaning: "đổi khác đi: cải tên * cải dạng",
    example: "cải tên * cải dạng",
  },
  {
    word: "cải",
    part_of_speech: "động từ",
    meaning:
      "làm cho thành hình trang trí nổi trên mặt hàng đan, dệt, bằng cách đặt các sợi theo một lối nhất định khi dệt, đan: lụa cải hoa",
    example: "lụa cải hoa",
  },
  {
    word: "cai",
    part_of_speech: "danh từ",
    meaning:
      "(Từ cũ) chức thấp nhất trong tổ chức quân đội thời phong kiến, thực dân: cai khố đỏ",
    example: "cai khố đỏ",
  },
  {
    word: "cai",
    part_of_speech: "danh từ",
    meaning:
      "người trông coi một số người lao động làm thuê ở nhà máy, công trường thời phong kiến, thực dân: cai phu mỏ",
    example: "cai phu mỏ",
  },
  {
    word: "cai",
    part_of_speech: "động từ",
    meaning:
      "thôi hẳn, không ăn, uống hoặc hút những thức dùng đã thành thói quen: cai rượu * cai thuốc",
    example: "cai rượu * cai thuốc",
  },
  {
    word: "cái bang",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, hiếm) người chuyên đi ăn xin, tổ chức thành nhóm: nhóm cái bang * bang chủ cái bang",
    example: "nhóm cái bang * bang chủ cái bang",
  },
  {
    word: "cải biến",
    part_of_speech: "động từ",
    meaning:
      "làm cho thay đổi thành khác trước rõ rệt: cải biến nền công nghiệp lạc hậu",
    example: "cải biến nền công nghiệp lạc hậu",
  },
  {
    word: "cải bẹ",
    part_of_speech: "danh từ",
    meaning: "cải lá có bẹ to: cải bẹ muối dưa",
    example: "cải bẹ muối dưa",
  },
  {
    word: "cải biên",
    part_of_speech: "động từ",
    meaning:
      "sửa đổi hoặc biên soạn lại (thường nói về tác phẩm nghệ thuật) cho phù hợp với yêu cầu mới: cải biên tuồng cổ * chèo cải biên",
    example: "cải biên tuồng cổ * chèo cải biên",
  },
  {
    word: "cải cách",
    part_of_speech: "",
    meaning:
      "sửa đổi cái cũ đã trở thành lạc hậu để cho phù hợp, đáp ứng yêu cầu của tình hình: thực hiện cải cách giáo dục * những cải cách cơ bản của nền kinh tế",
    example:
      "thực hiện cải cách giáo dục * những cải cách cơ bản của nền kinh tế",
  },
  {
    word: "cải chính",
    part_of_speech: "động từ",
    meaning:
      "chữa cho chính xác, cho đúng sự thật: cải chính những lời vu cáo * cải chính cách xưng hô",
    example: "cải chính những lời vu cáo * cải chính cách xưng hô",
  },
  {
    word: "cãi cọ",
    part_of_speech: "động từ",
    meaning:
      "cãi nhau lôi thôi giữa hai bên: bọn trẻ cãi cọ nhau * cuộc cãi cọ",
    example: "bọn trẻ cãi cọ nhau * cuộc cãi cọ",
  },
  {
    word: "cài đặt",
    part_of_speech: "động từ",
    meaning:
      "đưa một (hoặc một bộ) phần mềm vào máy tính theo những trình tự và cách thức nhất định để sử dụng: cài đặt phần mềm * máy tính được cài đặt hệ thống bảo mật",
    example: "cài đặt phần mềm * máy tính được cài đặt hệ thống bảo mật",
  },
  {
    word: "cải dạng",
    part_of_speech: "động từ",
    meaning:
      "thay đổi bộ dạng, cách ăn mặc v.v. giả làm một người khác: cải dạng thành người ăn xin",
    example: "cải dạng thành người ăn xin",
  },
  {
    word: "cai đầu dài",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) kẻ chuyên đứng ra nhận thầu công việc rồi giao lại cho người khác làm với tiền công rẻ mạt để kiếm lời: cai đầu dài trong ngành xây dựng",
    example: "cai đầu dài trong ngành xây dựng",
  },
  {
    word: "cải củ",
    part_of_speech: "danh từ",
    meaning:
      "cải hoa màu trắng, rễ phồng thành củ màu trắng, dùng làm thức ăn: dưa cải củ muối xổi",
    example: "dưa cải củ muối xổi",
  },
  {
    word: "cải hối",
    part_of_speech: "động từ",
    meaning: "(hiếm) như hối cải: biết cải hối để làm người lương thiện",
    example: "biết cải hối để làm người lương thiện",
  },
  {
    word: "cãi lộn",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) cãi cọ nhau có tính chất hơn thua: cuộc cãi lộn * xảy ra chuyện đôi co, cãi lộn",
    example: "cuộc cãi lộn * xảy ra chuyện đôi co, cãi lộn",
  },
  {
    word: "cải lương",
    part_of_speech: "danh từ",
    meaning:
      "kịch hát ra đời vào đầu thế kỉ XX, bắt nguồn từ nhạc tài tử, dân ca Nam bộ: nghệ sĩ cải lương * vở cải lương * ca cải lương",
    example: "nghệ sĩ cải lương * vở cải lương * ca cải lương",
  },
  {
    word: "cải lương",
    part_of_speech: "tính từ",
    meaning:
      "(cũ) thuộc về chủ nghĩa cải lương, theo chủ nghĩa cải lương: tư tưởng cải lương",
    example: "tư tưởng cải lương",
  },
  {
    word: "cải mả",
    part_of_speech: "tính từ",
    meaning: "(Thông tục) (răng) có màu rất bẩn: răng cải mả",
    example: "răng cải mả",
  },
  {
    word: "cải lão hoàn đồng",
    part_of_speech: "",
    meaning: "làm cho người già trẻ lại: thuốc cải lão hoàn đồng",
    example: "thuốc cải lão hoàn đồng",
  },
  {
    word: "cai nghiện",
    part_of_speech: "động từ",
    meaning:
      "thôi hẳn, bỏ hẳn, không dùng ma tuý nữa để cắt đứt cơn nghiện: trung tâm cai nghiện",
    example: "trung tâm cai nghiện",
  },
  {
    word: "cái rụp",
    part_of_speech: "",
    meaning:
      "(phương ngữ, khẩu ngữ) ngay lập tức, rất nhanh, rất gọn: điện mất cái rụp * đưa tay chào cái rụp * đồng ý cái rụp",
    example: "điện mất cái rụp * đưa tay chào cái rụp * đồng ý cái rụp",
  },
  {
    word: "cai quản",
    part_of_speech: "động từ",
    meaning:
      "phụ trách việc trông coi: cai quản một toán thợ * mọi việc trong nhà đều giao cho chị cai quản",
    example:
      "cai quản một toán thợ * mọi việc trong nhà đều giao cho chị cai quản",
  },
  {
    word: "cải tạo",
    part_of_speech: "động từ",
    meaning:
      "làm cho chất lượng thay đổi về căn bản, theo hướng tốt: cải tạo đất bạc màu * cải tạo tư tưởng * cải tạo bộ máy hành chính",
    example:
      "cải tạo đất bạc màu * cải tạo tư tưởng * cải tạo bộ máy hành chính",
  },
  {
    word: "cải tạo",
    part_of_speech: "động từ",
    meaning:
      "giáo dục (những người mắc lỗi lầm) làm cho thay đổi trở thành người tốt, người lương thiện: trại cải tạo tập trung * đi lao động cải tạo",
    example: "trại cải tạo tập trung * đi lao động cải tạo",
  },
  {
    word: "cải sửa",
    part_of_speech: "động từ",
    meaning:
      "sửa chữa, thay đổi cho khác trước để phù hợp với yêu cầu mới: cải sửa một số nội dung trong điều lệ",
    example: "cải sửa một số nội dung trong điều lệ",
  },
  {
    word: "cai thầu",
    part_of_speech: "danh từ",
    meaning:
      "người đứng trung gian nhận việc giữa chủ thầu và một số người lao động làm thuê: cai thầu xây dựng",
    example: "cai thầu xây dựng",
  },
  {
    word: "cai sữa",
    part_of_speech: "động từ",
    meaning:
      "thôi hẳn không cho bú nữa, mà nuôi bằng những thức ăn khác thay cho sữa: lợn con đã cai sữa * cai sữa cho con",
    example: "lợn con đã cai sữa * cai sữa cho con",
  },
  {
    word: "cải thiện",
    part_of_speech: "động từ",
    meaning:
      "làm cho tình hình có sự chuyển biến, phần nào có tốt hơn: phát triển sản xuất để cải thiện đời sống * cải thiện môi trường đầu tư",
    example:
      "phát triển sản xuất để cải thiện đời sống * cải thiện môi trường đầu tư",
  },
  {
    word: "cải tiến",
    part_of_speech: "động từ",
    meaning:
      "sửa đổi cho tiến bộ hơn: cải tiến công cụ lao động * cào cải tiến",
    example: "cải tiến công cụ lao động * cào cải tiến",
  },
  {
    word: "cải tổ",
    part_of_speech: "động từ",
    meaning: "tổ chức lại cho khác hẳn trước: cải tổ nội các",
    example: "cải tổ nội các",
  },
  {
    word: "cải tổ",
    part_of_speech: "động từ",
    meaning:
      "thay đổi căn bản và toàn diện về tổ chức, thể chế, cơ chế, v.v., trong mọi lĩnh vực kinh tế, chính trị, xã hội, nhằm khắc phục hậu quả sai lầm trong quá khứ, đưa xã hội tiến lên: chính sách cải tổ",
    example: "chính sách cải tổ",
  },
  {
    word: "cai trị",
    part_of_speech: "động từ",
    meaning:
      "sử dụng bộ máy hành chính thực hiện quyền thống trị, áp bức: cai trị đất nước * bộ máy cai trị",
    example: "cai trị đất nước * bộ máy cai trị",
  },
  {
    word: "cải trang",
    part_of_speech: "động từ",
    meaning:
      "thay đổi cách ăn mặc và diện mạo để người khác khó nhận ra: cải trang thành lái buôn",
    example: "cải trang thành lái buôn",
  },
  {
    word: "cải tử hoàn sinh",
    part_of_speech: "",
    meaning: "làm cho thoát khỏi cáI chết đã cận kề: ơn cải tử hoàn sinh",
    example: "ơn cải tử hoàn sinh",
  },
  {
    word: "cái trò",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị điều sắp nêu ra là việc thường thấy ở đời, không có gì đáng phải ngạc nhiên: cái trò nó thế, đã đâm lao thì phải theo lao",
    example: "cái trò nó thế, đã đâm lao thì phải theo lao",
  },
  {
    word: "cãi vã",
    part_of_speech: "động từ",
    meaning:
      "cãi nhau dằng dai về việc không đáng cãi (nói khái quát): cãi vã nhau vì những chuyện không đâu",
    example: "cãi vã nhau vì những chuyện không đâu",
  },
  {
    word: "cam",
    part_of_speech: "danh từ",
    meaning:
      "cây ăn quả, hoa màu trắng, quả tròn, có múi, nhiều nước, bé hơn quả bưởi, khi chín thường có màu vàng đỏ, vị ngọt hoặc chua: màu da cam * cốc nước cam",
    example: "màu da cam * cốc nước cam",
  },
  {
    word: "cam",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi chung một số bệnh dai dẳng ở trẻ em, thường do suy dinh dưỡng sinh ra: cam răng * thuốc cam",
    example: "cam răng * thuốc cam",
  },
  {
    word: "cam",
    part_of_speech: "danh từ",
    meaning:
      "chi tiết máy có thể làm chi tiết máy khác chuyển động qua lại theo quy luật nhất định, nhờ hình dạng đặc biệt của mặt tiếp xúc của nó: trục cam",
    example: "trục cam",
  },
  {
    word: "cam",
    part_of_speech: "động từ",
    meaning:
      'cảm thấy có thể bằng lòng làm hoặc chấp nhận việc gì đó: có nhiều nhặn gì cho cam * "Dù cho chờ đợi mấy đông, Đắng cay cũng chịu mặn nồng cũng cam." (Cdao)',
    example:
      'có nhiều nhặn gì cho cam * "Dù cho chờ đợi mấy đông, Đắng cay cũng chịu mặn nồng cũng cam." (Cdao)',
  },
  {
    word: "cám",
    part_of_speech: "động từ",
    meaning:
      'động lòng thương, cảm thương trước một cảnh ngộ nào đó: "Ai làm nên bước phân li, Cám công mưa nắng kẻ đi, người về." (Cdao)',
    example:
      'Ai làm nên bước phân li, Cám công mưa nắng kẻ đi, người về." (Cdao)',
  },
  {
    word: "cạm",
    part_of_speech: "danh từ",
    meaning:
      'dụng cụ thô sơ để lừa bắt thú vật: đặt cạm bẫy hươu * "Phong lưu là cạm ở đời, Hồng nhan là bả những người tài hoa." (ca dao)',
    example:
      'đặt cạm bẫy hươu * "Phong lưu là cạm ở đời, Hồng nhan là bả những người tài hoa." (ca dao)',
  },
  {
    word: "cảm biết",
    part_of_speech: "động từ",
    meaning:
      "cảm nhận và biết được thông qua cảm giác: đứa trẻ đã cảm biết được tình thương yêu",
    example: "đứa trẻ đã cảm biết được tình thương yêu",
  },
  {
    word: "cảm",
    part_of_speech: "động từ",
    meaning:
      "nhận biết bằng giác quan, bằng cảm tính: cảm thấy lạnh * cảm thấy thoải mái như ở nhà * cảm thấy đau ở tay",
    example:
      "cảm thấy lạnh * cảm thấy thoải mái như ở nhà * cảm thấy đau ở tay",
  },
  {
    word: "cảm",
    part_of_speech: "động từ",
    meaning: "làm cho rung động trong lòng: bài thơ cảm được người đọc",
    example: "bài thơ cảm được người đọc",
  },
  {
    word: "cảm",
    part_of_speech: "động từ",
    meaning: "nhận biết và mến phục: cảm lòng tốt của bạn",
    example: "cảm lòng tốt của bạn",
  },
  {
    word: "cảm",
    part_of_speech: "động từ",
    meaning:
      '(Khẩu ngữ) có cảm tình và như chớm yêu (nói về quan hệ nam nữ): xem chừng nó đã cảm cô ta * "(…) nàng yêu Lương không phải vì cảm cái vẻ khôi ngô tuấn tú của chàng." (KhHưng; 4)',
    example:
      'xem chừng nó đã cảm cô ta * "(…) nàng yêu Lương không phải vì cảm cái vẻ khôi ngô tuấn tú của chàng." (KhHưng; 4)',
  },
  {
    word: "cảm",
    part_of_speech: "động từ",
    meaning:
      "bị ốm nhẹ do cơ thể chịu tác động đột ngột của thời tiết: bị cảm * ăn bát cháo hành để giải cảm",
    example: "bị cảm * ăn bát cháo hành để giải cảm",
  },
  {
    word: "cạm bẫy",
    part_of_speech: "danh từ",
    meaning:
      "bẫy để lừa bắt loài vật (nói khái quát): đặt cạm bẫy để đánh bắt thú rừng",
    example: "đặt cạm bẫy để đánh bắt thú rừng",
  },
  {
    word: "cạm bẫy",
    part_of_speech: "danh từ",
    meaning:
      "cái bố trí sẵn để lừa cho người ta sa vào vòng nguy hiểm (nói khái quát): sa vào cạm bẫy của kẻ thù * cạm bẫy tình",
    example: "sa vào cạm bẫy của kẻ thù * cạm bẫy tình",
  },
  {
    word: "cam chịu",
    part_of_speech: "động từ",
    meaning:
      "bằng lòng chịu vì cho là không thể nào khác được: cam chịu cuộc sống nghèo khổ * biết nhẫn nhịn và cam chịu",
    example: "cam chịu cuộc sống nghèo khổ * biết nhẫn nhịn và cam chịu",
  },
  {
    word: "cám cảnh",
    part_of_speech: "động từ",
    meaning:
      'động lòng thương cảm trước một cảnh ngộ: "Vịt nằm bờ mía rỉa lông, Cám cảnh thương chồng đi học đường xa." (ca dao)',
    example:
      'Vịt nằm bờ mía rỉa lông, Cám cảnh thương chồng đi học đường xa." (ca dao)',
  },
  {
    word: "cám dỗ",
    part_of_speech: "động từ",
    meaning:
      "khêu gợi lòng ham muốn đến mức làm cho sa ngã: không cưỡng được sức cám dỗ của đồng tiền",
    example: "không cưỡng được sức cám dỗ của đồng tiền",
  },
  {
    word: "cảm động",
    part_of_speech: "động từ",
    meaning:
      "có sự rung động trong lòng do tác động của một sự việc khách quan mà mình đồng tình hoặc khâm phục: cảm động đến rơi nước mắt  * bộ phim làm cảm động lòng người",
    example: "cảm động đến rơi nước mắt  * bộ phim làm cảm động lòng người",
  },
  {
    word: "cảm động",
    part_of_speech: "tính từ",
    meaning: "có tác dụng làm cảm động: câu chuyện rất cảm động",
    example: "câu chuyện rất cảm động",
  },
  {
    word: "cam đoan",
    part_of_speech: "động từ",
    meaning:
      "khẳng định điều mình trình bày là đúng và hứa chịu trách nhiệm để cho người khác tin: làm giấy cam đoan * cam đoan không tái phạm",
    example: "làm giấy cam đoan * cam đoan không tái phạm",
  },
  {
    word: "cam go",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) gay go, gian khổ: chịu đựng nhiều cam go, thử thách * cuộc chiến đầy cam go",
    example: "chịu đựng nhiều cam go, thử thách * cuộc chiến đầy cam go",
  },
  {
    word: "cảm hàn",
    part_of_speech: "động từ",
    meaning: "cảm do bị nhiễm lạnh đột ngột: mắc chứng cảm hàn",
    example: "mắc chứng cảm hàn",
  },
  {
    word: "cảm giác",
    part_of_speech: "",
    meaning:
      "hình thức thấp nhất của nhận thức, cho ta biết những thuộc tính riêng lẻ của sự vật đang tác động vào giác quan ta: cảm giác mệt mỏi * có cảm giác sợ hãi * cảm giác có điều không lành sắp xảy ra",
    example:
      "cảm giác mệt mỏi * có cảm giác sợ hãi * cảm giác có điều không lành sắp xảy ra",
  },
  {
    word: "cám hấp",
    part_of_speech: "tính từ",
    meaning: "(thông tục) dở hơi: đồ cám hấp! (tiếng rủa)",
    example: "đồ cám hấp! (tiếng rủa)",
  },
  {
    word: "cảm hứng",
    part_of_speech: "danh từ",
    meaning:
      "trạng thái tâm lí có cảm xúc và hết sức hứng thú, tạo điều kiện để óc tưởng tượng, sáng tạo hoạt động có hiệu quả: khơi nguồn cảm hứng",
    example: "khơi nguồn cảm hứng",
  },
  {
    word: "cảm hoá",
    part_of_speech: "động từ",
    meaning:
      "(bằng lời nói, việc làm) làm cho xúc động mà nghe theo, chuyển biến theo hướng tốt: cảm hoá kẻ lầm đường",
    example: "cảm hoá kẻ lầm đường",
  },
  {
    word: "cam kết",
    part_of_speech: "động từ",
    meaning:
      "chính thức cam đoan làm đúng những điều đã hứa: giữ đúng lời cam kết * cam kết không tái phạm",
    example: "giữ đúng lời cam kết * cam kết không tái phạm",
  },
  {
    word: "cam kết",
    part_of_speech: "danh từ",
    meaning: "bản cam kết: viết cam kết * hoàn trả nợ vay theo cam kết",
    example: "viết cam kết * hoàn trả nợ vay theo cam kết",
  },
  {
    word: "tư thương",
    part_of_speech: "danh từ",
    meaning:
      "người buôn bán cá thể: sản phẩm do tư thương bao tiêu * bị tư thương ép giá",
    example: "sản phẩm do tư thương bao tiêu * bị tư thương ép giá",
  },
  {
    word: "tự tin",
    part_of_speech: "động từ",
    meaning:
      "tin vào bản thân mình: tự tin ở sức mình * giọng nói dứt khoát, đầy vẻ tự tin",
    example: "tự tin ở sức mình * giọng nói dứt khoát, đầy vẻ tự tin",
  },
  {
    word: "tư thục",
    part_of_speech: "tính từ",
    meaning: "(trường học) do tư nhân mở: nhà trẻ tư thục * trường tư thục",
    example: "nhà trẻ tư thục * trường tư thục",
  },
  {
    word: "tự tiện",
    part_of_speech: "tính từ",
    meaning:
      "(làm việc gì) theo ý thích của mình, không xin phép, không hỏi ý kiến ai cả: tự tiện dùng đồ của người khác * muốn gì phải hỏi, không được tự tiện",
    example:
      "tự tiện dùng đồ của người khác * muốn gì phải hỏi, không được tự tiện",
  },
  {
    word: "tự ti",
    part_of_speech: "tính từ",
    meaning:
      "tự đánh giá mình thấp nên tỏ ra thiếu tự tin: tự ti về khả năng của mình * tính hay tự ti",
    example: "tự ti về khả năng của mình * tính hay tự ti",
  },
  {
    word: "tự tình",
    part_of_speech: "động từ",
    meaning:
      'như tình tự: "Mảng tin xiết nỗi kinh hoàng, Băng mình lẻn trước đài trang tự tình." (TKiều)',
    example:
      'Mảng tin xiết nỗi kinh hoàng, Băng mình lẻn trước đài trang tự tình." (TKiều)',
  },
  {
    word: "tự tình",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) rách bươm, rách mướp: quần áo tưa như xơ mướp * hai ống quần bị gai cào, tưa ra",
    example: "quần áo tưa như xơ mướp * hai ống quần bị gai cào, tưa ra",
  },
  {
    word: "tự tôn",
    part_of_speech: "danh từ",
    meaning: "(Từ cũ) cháu trai thừa tự, nối nghiệp ông bà: tự tôn của nhà Lê",
    example: "tự tôn của nhà Lê",
  },
  {
    word: "tự tôn",
    part_of_speech: "danh từ",
    meaning:
      "tự tôn trọng mình, không để cho ai coi thường, coi khinh mình: lòng tự tôn dân tộc",
    example: "lòng tự tôn dân tộc",
  },
  {
    word: "tư tình",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, hiếm) tình cảm riêng (nên thường có sự thiên vị): "Tạ ân vào trước tâu quì, Việc công đâu dám bận chi tư tình." (NĐM)',
    example:
      'Tạ ân vào trước tâu quì, Việc công đâu dám bận chi tư tình." (NĐM)',
  },
  {
    word: "tư tình",
    part_of_speech: "danh từ",
    meaning: "tình yêu vụng trộm: hai người có tư tình với nhau",
    example: "hai người có tư tình với nhau",
  },
  {
    word: "tư tình",
    part_of_speech: "động từ",
    meaning:
      "có quan hệ yêu đương vụng trộm, không chính đáng: tư tình với trai",
    example: "tư tình với trai",
  },
  {
    word: "tử tội",
    part_of_speech: "danh từ",
    meaning: "kẻ phạm vào tội chết: đưa tử tội ra pháp trường",
    example: "đưa tử tội ra pháp trường",
  },
  {
    word: "tư trang",
    part_of_speech: "danh từ",
    meaning:
      "đồ trang sức quý và của cải của người phụ nữ mang theo khi về nhà chồng (nói tổng quát): món tư trang * tư trang của cô dâu",
    example: "món tư trang * tư trang của cô dâu",
  },
  {
    word: "tư trang",
    part_of_speech: "danh từ",
    meaning:
      "các thứ đồ đạc cần thiết mang theo người của một cá nhân (nói tổng quát): tư trang gọn gàng * hành khách tự quản lí tư trang",
    example: "tư trang gọn gàng * hành khách tự quản lí tư trang",
  },
  {
    word: "tự trào",
    part_of_speech: "động từ",
    meaning:
      "tự châm biếm, chế giễu (một hình thức văn trào phúng): bài thơ tự trào",
    example: "bài thơ tự trào",
  },
  {
    word: "từ trái nghĩa",
    part_of_speech: "danh từ",
    meaning:
      "từ có nghĩa trái ngược nhau: ,  * ,  *  là những cặp từ trái nghĩa",
    example: ",  * ,  *  là những cặp từ trái nghĩa",
  },
  {
    word: "tự trầm",
    part_of_speech: "động từ",
    meaning:
      "tự tử bằng cách trầm mình xuống vùng nước sâu: nhảy xuống sông tự trầm",
    example: "nhảy xuống sông tự trầm",
  },
  {
    word: "từ tốn",
    part_of_speech: "tính từ",
    meaning: "tỏ ra khiêm nhường, hoà nhã: nói năng từ tốn * cử chỉ từ tốn",
    example: "nói năng từ tốn * cử chỉ từ tốn",
  },
  {
    word: "tự trị",
    part_of_speech: "động từ",
    meaning:
      "tự quản lí lấy công việc nội bộ của mình (thường nói về một bộ phận trong một quốc gia): khu tự trị * thành lập chính quyền tự trị",
    example: "khu tự trị * thành lập chính quyền tự trị",
  },
  {
    word: "tự trọng",
    part_of_speech: "động từ",
    meaning:
      "coi trọng và giữ gìn phẩm cách, danh dự của mình: lòng tự trọng * người biết tự trọng",
    example: "lòng tự trọng * người biết tự trọng",
  },
  {
    word: "tứ tuần",
    part_of_speech: "danh từ",
    meaning: "(cũ, trang trọng) bốn mươi tuổi: bước sang tuổi tứ tuần",
    example: "bước sang tuổi tứ tuần",
  },
  {
    word: "từ trong trứng",
    part_of_speech: "",
    meaning:
      "ngay từ khi đang còn là phôi thai, là mầm mống hoặc ngay từ trước khi nảy sinh, trước khi xuất hiện: đập tan âm mưu nổi loạn từ trong trứng",
    example: "đập tan âm mưu nổi loạn từ trong trứng",
  },
  {
    word: "tứ trụ",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) bốn chức quan đại học sĩ to nhất trong triều đình phong kiến (nói tổng quát): tứ trụ triều đình",
    example: "tứ trụ triều đình",
  },
  {
    word: "tự truyện",
    part_of_speech: "danh từ",
    meaning: "truyện tác giả viết về chính bản thân mình: tác phẩm tự truyện",
    example: "tác phẩm tự truyện",
  },
  {
    word: "tư túi",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) lấy của công làm của riêng một cách lén lút: tư túi tiền công quỹ",
    example: "tư túi tiền công quỹ",
  },
  {
    word: "tứ tung",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ở bất cứ chỗ nào, khắp mọi nơi: xác pháo bay tứ tung * nhà dột tứ tung * bọn trẻ bỏ chạy tứ tung",
    example: "xác pháo bay tứ tung * nhà dột tứ tung * bọn trẻ bỏ chạy tứ tung",
  },
  {
    word: "tứ tung",
    part_of_speech: "tính từ",
    meaning:
      "lộn xộn, bừa bãi, chỗ nào cũng thấy có (thường nói về đồ đạc): sách vở để tứ tung * va li bị lục tứ tung cả lên",
    example: "sách vở để tứ tung * va li bị lục tứ tung cả lên",
  },
  {
    word: "tự túc",
    part_of_speech: "động từ",
    meaning:
      "tự đảm bảo cho mình những nhu cầu vật chất nào đó, không dựa vào bên ngoài: tự túc lương thực * du học tự túc",
    example: "tự túc lương thực * du học tự túc",
  },
  {
    word: "tự tử",
    part_of_speech: "động từ",
    meaning:
      "tự giết chết mình một cách cố ý: tự tử bằng thuốc độc * nhảy xuống sông tự tử",
    example: "tự tử bằng thuốc độc * nhảy xuống sông tự tử",
  },
  {
    word: "tự tư tự lợi",
    part_of_speech: "",
    meaning:
      "chỉ tính toán lợi ích vật chất cho riêng mình, không nghĩ đến lợi ích chung: thái độ tự tư tự lợi",
    example: "thái độ tự tư tự lợi",
  },
  {
    word: "tứ tuyệt",
    part_of_speech: "danh từ",
    meaning:
      "thể thơ mỗi bài gồm bốn câu, mỗi câu có năm hoặc bảy âm tiết: thơ tứ tuyệt",
    example: "thơ tứ tuyệt",
  },
  {
    word: "tư văn",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) chức sắc, chức dịch và nói chung quan viên trong làng thời trước (nói khái quát): hội tư văn trong làng",
    example: "hội tư văn trong làng",
  },
  {
    word: "tư tưởng",
    part_of_speech: "danh từ",
    meaning:
      "sự suy nghĩ hoặc ý nghĩ: tập trung tư tưởng * chuẩn bị tư tưởng lên đường",
    example: "tập trung tư tưởng * chuẩn bị tư tưởng lên đường",
  },
  {
    word: "tư tưởng",
    part_of_speech: "danh từ",
    meaning:
      "quan điểm và ý nghĩ chung của con người đối với hiện thực khách quan và đối với xã hội (nói tổng quát): đổi mới tư tưởng * tư tưởng tiến bộ * hệ tư tưởng nho giáo",
    example: "đổi mới tư tưởng * tư tưởng tiến bộ * hệ tư tưởng nho giáo",
  },
  {
    word: "tự vấn",
    part_of_speech: "động từ",
    meaning: "tự hỏi mình để xem xét lại mình: tự vấn lương tâm",
    example: "tự vấn lương tâm",
  },
  {
    word: "tự vẫn",
    part_of_speech: "động từ",
    meaning: "(cũ) tự tử bằng cách tự cắt cổ: rút gươm tự vẫn",
    example: "rút gươm tự vẫn",
  },
  {
    word: "tự vẫn",
    part_of_speech: "động từ",
    meaning: "như tự tử: treo cổ tự vẫn",
    example: "treo cổ tự vẫn",
  },
  {
    word: "tự vị",
    part_of_speech: "danh từ",
    meaning:
      "sách tra cứu tập hợp các đơn vị ngôn ngữ (thường là đơn vị từ vựng) và sắp xếp theo một thứ tự nhất định, cung cấp một số kiến thức cần thiết đối với từng đơn vị: từ điển tiếng Việt * từ điển trực tuyến * tra từ điển",
    example: "từ điển tiếng Việt * từ điển trực tuyến * tra từ điển",
  },
  {
    word: "tư vấn",
    part_of_speech: "động từ",
    meaning:
      "góp ý kiến về những vấn đề được hỏi đến, nhưng không có quyền quyết định: chuyên gia tư vấn * dịch vụ tư vấn pháp luật",
    example: "chuyên gia tư vấn * dịch vụ tư vấn pháp luật",
  },
  {
    word: "tư vị",
    part_of_speech: "động từ",
    meaning: "(cũ, hiếm) như thiên vị: sống công bằng, không tư vị ai",
    example: "sống công bằng, không tư vị ai",
  },
  {
    word: "tự vệ",
    part_of_speech: "động từ",
    meaning:
      "tự bảo vệ mình chống lại mọi sự xâm phạm từ bên ngoài: bản năng tự vệ * học mấy miếng võ để tự vệ",
    example: "bản năng tự vệ * học mấy miếng võ để tự vệ",
  },
  {
    word: "tự vệ",
    part_of_speech: "danh từ",
    meaning:
      "lực lượng vũ trang địa phương không thoát li sản xuất, được tổ chức ở cơ quan, xí nghiệp, đường phố, v.v. để chiến đấu tại chỗ, bảo vệ cơ sở: đội tự vệ * lực lượng tự vệ của nông trường",
    example: "đội tự vệ * lực lượng tự vệ của nông trường",
  },
  {
    word: "tử vong",
    part_of_speech: "động từ",
    meaning:
      "chết (thường nói về bệnh nhân): ca tử vong * tử vong vì bệnh AIDS",
    example: "ca tử vong * tử vong vì bệnh AIDS",
  },
  {
    word: "tử vì đạo",
    part_of_speech: "",
    meaning: "(người sùng đạo) chịu chết vì đạo: tinh thần tử vì đạo",
    example: "tinh thần tử vì đạo",
  },
  {
    word: "từ vựng học",
    part_of_speech: "danh từ",
    meaning: "bộ môn ngôn ngữ học nghiên cứu về từ vựng: lí thuyết từ vựng học",
    example: "lí thuyết từ vựng học",
  },
  {
    word: "tử vi",
    part_of_speech: "danh từ",
    meaning:
      "thuật đoán số, dựa vào ngày giờ, năm sinh và vào các ngôi sao: xem tử vi * lá số tử vi",
    example: "xem tử vi * lá số tử vi",
  },
  {
    word: "từ vựng",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ nói chung các từ vị, hoặc các từ, của một ngôn ngữ: đơn vị từ vựng * làm giàu vốn từ vựng",
    example: "đơn vị từ vựng * làm giàu vốn từ vựng",
  },
  {
    word: "tứ xứ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) khắp mọi nơi: dân tứ xứ * bạn bè tứ xứ * đi khắp tứ xứ",
    example: "dân tứ xứ * bạn bè tứ xứ * đi khắp tứ xứ",
  },
  {
    word: "tự ý",
    part_of_speech: "tính từ",
    meaning:
      "(làm việc gì) theo ý riêng của mình, không kể gì đến những điều ràng buộc đối với mình: tự ý bỏ việc * tư thương tự ý nâng giá hàng hoá",
    example: "tự ý bỏ việc * tư thương tự ý nâng giá hàng hoá",
  },
  {
    word: "tự xưng",
    part_of_speech: "động từ",
    meaning:
      "tự giới thiệu tên họ, nghề nghiệp, chức vị của mình khi tiếp xúc với người khác: tự xưng tên mình",
    example: "tự xưng tên mình",
  },
  {
    word: "tự xưng",
    part_of_speech: "động từ",
    meaning:
      "tự gán cho mình một danh nghĩa, một tư cách nào đó: một tổ chức tự xưng là dân chủ",
    example: "một tổ chức tự xưng là dân chủ",
  },
  {
    word: "tự xưng",
    part_of_speech: "động từ",
    meaning:
      "tự nhận cho mình một danh hiệu cao quý nào đó và tuyên bố cho mọi người biết: Lê Lợi tự xưng là Bình Định Vương",
    example: "Lê Lợi tự xưng là Bình Định Vương",
  },
  {
    word: "tưa",
    part_of_speech: "danh từ",
    meaning:
      "bệnh ở trẻ nhỏ đang còn bú, có những vết loét nhỏ ở màng nhầy miệng, ở lưỡi, do một loại nấm sinh ra: trẻ bị tưa lưỡi",
    example: "trẻ bị tưa lưỡi",
  },
  {
    word: "tức cảnh",
    part_of_speech: "động từ",
    meaning:
      "(cũ) ngắm cảnh mà có cảm xúc, nảy ra tứ thơ, lời thơ: bài thơ tức cảnh",
    example: "bài thơ tức cảnh",
  },
  {
    word: "tứa",
    part_of_speech: "động từ",
    meaning:
      "chảy ra thành giọt trên một diện tương đối rộng: tay bị gai cào tứa máu * mồ hôi tứa xuống lưng",
    example: "tay bị gai cào tứa máu * mồ hôi tứa xuống lưng",
  },
  {
    word: "tựa hồ",
    part_of_speech: "tính từ",
    meaning:
      "giống như là, có vẻ như là: mắt nhìn xa xăm, tựa hồ đang suy nghĩ",
    example: "mắt nhìn xa xăm, tựa hồ đang suy nghĩ",
  },
  {
    word: "tựa",
    part_of_speech: "danh từ",
    meaning:
      "bài viết ở đầu sách trình bày một số điểm cần thiết về cuốn sách đó: viết lời tựa",
    example: "viết lời tựa",
  },
  {
    word: "tựa",
    part_of_speech: "động từ",
    meaning:
      "áp sát vào vật gì để nhờ vào đó mà giữ ở nguyên một tư thế nhất định: đứng tựa lưng vào tường * tựa đầu vào vai bạn",
    example: "đứng tựa lưng vào tường * tựa đầu vào vai bạn",
  },
  {
    word: "tựa",
    part_of_speech: "danh từ",
    meaning: "bộ phận của ghế dùng để tựa lưng vào khi ngồi: ghế có tựa",
    example: "ghế có tựa",
  },
  {
    word: "tựa",
    part_of_speech: "tính từ",
    meaning:
      "giống như cái rất điển hình nào đó (so sánh để nêu bật mức độ của một tính chất): sáng tựa trăng rằm * coi cái chết nhẹ tựa lông hồng",
    example: "sáng tựa trăng rằm * coi cái chết nhẹ tựa lông hồng",
  },
  {
    word: "tức",
    part_of_speech: "danh từ",
    meaning: "(cũ) lãi (cho vay): đấu tranh đòi giảm tô, giảm tức",
    example: "đấu tranh đòi giảm tô, giảm tức",
  },
  {
    word: "tức",
    part_of_speech: "danh từ",
    meaning:
      "ở trạng thái bị dồn nén quá chặt đến mức như muốn phá bung ra: áo may chật, mặc hơi tức * tức nước vỡ bờ (tng)",
    example: "áo may chật, mặc hơi tức * tức nước vỡ bờ (tng)",
  },
  {
    word: "tức",
    part_of_speech: "danh từ",
    meaning:
      "ở trạng thái cảm giác có cái gì bị dồn ứ, nén chặt ở một bộ phận nào đó của cơ thể, làm rất khó chịu: tức ngực * ăn no tức bụng * bụng đầy hơi, tức anh ách",
    example: "tức ngực * ăn no tức bụng * bụng đầy hơi, tức anh ách",
  },
  {
    word: "tức",
    part_of_speech: "danh từ",
    meaning:
      "có cảm giác rất bực bội, khó chịu khi có điều sai trái, vô lí nào đó tác động đến mình, mà mình thấy đành chịu, không làm gì được: chọc cho tức * nói cho bõ tức * tức như bò đá (tng)",
    example: "chọc cho tức * nói cho bõ tức * tức như bò đá (tng)",
  },
  {
    word: "tức",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra cũng chính là điều vừa nói đến, tuy cách nói có khác, nêu thêm để nói rõ một khía cạnh nào đó: ngày kia, tức chủ nhật, chúng ta sẽ lên đường",
    example: "ngày kia, tức chủ nhật, chúng ta sẽ lên đường",
  },
  {
    word: "tức cười",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) buồn cười, nực cười: chuyện tức cười * ngó mà tức cười",
    example: "chuyện tức cười * ngó mà tức cười",
  },
  {
    word: "từa tựa",
    part_of_speech: "tính từ",
    meaning: "hơi giống, gần giống: ăn mặc từa tựa như nhau",
    example: "ăn mặc từa tựa như nhau",
  },
  {
    word: "tức khắc",
    part_of_speech: "phụ từ",
    meaning:
      "(sự việc xảy ra) liền ngay sau đó: nhận được tin, tức khắc đi ngay",
    example: "nhận được tin, tức khắc đi ngay",
  },
  {
    word: "tức mình",
    part_of_speech: "động từ",
    meaning:
      "tức trong lòng, khó chịu trong lòng: chờ lâu không được, tức mình bỏ về",
    example: "chờ lâu không được, tức mình bỏ về",
  },
  {
    word: "tức khí",
    part_of_speech: "động từ",
    meaning: "tức vì bị chạm tự ái: tức khí choảng nhau",
    example: "tức khí choảng nhau",
  },
  {
    word: "tức thị",
    part_of_speech: "động từ",
    meaning: "(cũ, khẩu ngữ) tức là: nói thế tức thị không đồng ý",
    example: "nói thế tức thị không đồng ý",
  },
  {
    word: "tức là",
    part_of_speech: "",
    meaning:
      "tổ hợp biểu thị ý có nghĩa là, cũng chính là: im lặng tức là đồng ý * nó nói thế, tức là nó đã hiểu",
    example: "im lặng tức là đồng ý * nó nói thế, tức là nó đã hiểu",
  },
  {
    word: "tức giận",
    part_of_speech: "động từ",
    meaning: "tức và rất giận (nói khái quát): mặt hầm hầm tức giận",
    example: "mặt hầm hầm tức giận",
  },
  {
    word: "tức thì",
    part_of_speech: "phụ từ",
    meaning: "liền ngay lúc đó: phản ứng tức thì * có hiệu quả tức thì",
    example: "phản ứng tức thì * có hiệu quả tức thì",
  },
  {
    word: "tức thì",
    part_of_speech: "phụ từ",
    meaning: "(hiếm) liền ngay trước đó: vừa về tức thì",
    example: "vừa về tức thì",
  },
  {
    word: "tức thời",
    part_of_speech: "",
    meaning: "như tức thì: giải pháp tức thời",
    example: "giải pháp tức thời",
  },
  {
    word: "tức tốc",
    part_of_speech: "phụ từ",
    meaning:
      "(Khẩu ngữ) (làm việc gì) ngay lập tức, vì rất gấp: tức tốc lên đường * nhận được tin, tức tốc bổ đi tìm",
    example: "tức tốc lên đường * nhận được tin, tức tốc bổ đi tìm",
  },
  {
    word: "tức tưởi",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả tiếng nấc lên thành từng cơn của người đang chất chứa nhiều đau khổ, uất ức trong lòng: khóc tức tưởi * giọng nghẹn ngào tức tưởi",
    example: "khóc tức tưởi * giọng nghẹn ngào tức tưởi",
  },
  {
    word: "tức như bò đá",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) rất tức, rất bực mình mà không thể làm gì được: nghe nó nói tức như bò đá",
    example: "nghe nó nói tức như bò đá",
  },
  {
    word: "từng",
    part_of_speech: "danh từ",
    meaning:
      "một lượng, một chừng mực cụ thể nhất định nào đó: xa nhau từng ấy năm trời * từng này tuổi đầu còn dại",
    example: "xa nhau từng ấy năm trời * từng này tuổi đầu còn dại",
  },
  {
    word: "từng",
    part_of_speech: "đại từ",
    meaning:
      "từ dùng để chỉ đối tượng là mỗi một đơn vị riêng lẻ của những sự vật được nói đến, hết đơn vị này đến đơn vị khác: dặn từng lời cặn kẽ * mong đợi từng phút giây * đứt từng khúc ruột",
    example:
      "dặn từng lời cặn kẽ * mong đợi từng phút giây * đứt từng khúc ruột",
  },
  {
    word: "từng",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị hành động, hoạt động nói đến đã diễn ra trong quá khứ, hoặc điều nói đến đã trải qua trong một thời gian nào đó: hai người đã từng gặp nhau * một sự kiện lớn chưa từng thấy",
    example: "hai người đã từng gặp nhau * một sự kiện lớn chưa từng thấy",
  },
  {
    word: "tức tối",
    part_of_speech: "",
    meaning: "tức trong lòng (nói khái quát): vẻ mặt tức tối",
    example: "vẻ mặt tức tối",
  },
  {
    word: "tưng hửng",
    part_of_speech: "động từ",
    meaning:
      "ngẩn ra vì bị mất hứng thú đột ngột do sự việc lại xảy ra trái với điều mình đang mong muốn và tin chắc: chưng hửng vì bị từ chối bất ngờ * mặt chưng hửng",
    example: "chưng hửng vì bị từ chối bất ngờ * mặt chưng hửng",
  },
  {
    word: "từng trải",
    part_of_speech: "",
    meaning:
      "đã trải qua nhiều nên hiểu biết và có nhiều kinh nghiệm: từng trải trong thương trường * một con người từng trải",
    example: "từng trải trong thương trường * một con người từng trải",
  },
  {
    word: "tưng tức",
    part_of_speech: "",
    meaning: "cảm thấy hơi tức: ăn no, bụng hơi tưng tức",
    example: "ăn no, bụng hơi tưng tức",
  },
  {
    word: "tưng bừng",
    part_of_speech: "tính từ",
    meaning:
      "(quang cảnh, không khí) nhộn nhịp, vui vẻ: phố xá tưng bừng cờ hoa * không khí tưng bừng của ngày hội",
    example: "phố xá tưng bừng cờ hoa * không khí tưng bừng của ngày hội",
  },
  {
    word: "tưng bừng",
    part_of_speech: "tính từ",
    meaning:
      "(ánh sáng, màu sắc) có những biểu hiện rõ rệt, mạnh mẽ như bừng lên: mặt đỏ tưng bừng * đuốc cháy tưng bừng",
    example: "mặt đỏ tưng bừng * đuốc cháy tưng bừng",
  },
  {
    word: "từng li từng tí",
    part_of_speech: "",
    meaning:
      "từng chi tiết nhỏ nhặt nhất: để ý từng li từng tí * được cha mẹ săn sóc từng li từng tí",
    example: "để ý từng li từng tí * được cha mẹ săn sóc từng li từng tí",
  },
  {
    word: "tưng tửng",
    part_of_speech: "tính từ",
    meaning:
      "ra vẻ như không có gì, nửa như đùa nửa như thật: giọng nói tưng tửng * bộ mặt tưng tửng",
    example: "giọng nói tưng tửng * bộ mặt tưng tửng",
  },
  {
    word: "tưng tưng",
    part_of_speech: "tính từ",
    meaning: "từ mô phỏng tiếng như tiếng gảy dây đàn: tiếng đàn tưng tưng",
    example: "tiếng đàn tưng tưng",
  },
  {
    word: "tưới",
    part_of_speech: "động từ",
    meaning:
      "làm cho thấm ướt đều bằng cách đổ nước, phun nước trên bề mặt: gánh nước tưới rau",
    example: "gánh nước tưới rau",
  },
  {
    word: "tước",
    part_of_speech: "danh từ",
    meaning:
      "(Từ cũ) danh vị nhà vua phong cho các quan to hoặc cho những người có công lớn: phong tước bá * được thăng tước",
    example: "phong tước bá * được thăng tước",
  },
  {
    word: "tước",
    part_of_speech: "động từ",
    meaning:
      "tách nhỏ ra dọc theo thớ của vật: tước lạt * tước lá chuối làm bánh * tước sợi dây làm hai",
    example: "tước lạt * tước lá chuối làm bánh * tước sợi dây làm hai",
  },
  {
    word: "tước",
    part_of_speech: "động từ",
    meaning:
      "dùng sức mạnh hay quyền lực lấy đi, không cho sử dụng: tước vũ khí * bị tước quyền công dân",
    example: "tước vũ khí * bị tước quyền công dân",
  },
  {
    word: "tược",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) chồi, lộc: cây đâm tược",
    example: "cây đâm tược",
  },
  {
    word: "tước vị",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) chức tước và danh vị của quan lại: có tước vị cao * phong tước vị",
    example: "có tước vị cao * phong tước vị",
  },
  {
    word: "tước hiệu",
    part_of_speech: "danh từ",
    meaning: "(cũ) tên gọi chức vị được vua ban cho: sắc phong tước hiệu",
    example: "sắc phong tước hiệu",
  },
  {
    word: "tước đoạt",
    part_of_speech: "động từ",
    meaning:
      "tước và chiếm lấy: tước đoạt vũ khí * nông dân bị cường hào tước đoạt ruộng đất",
    example: "tước đoạt vũ khí * nông dân bị cường hào tước đoạt ruộng đất",
  },
  {
    word: "tước lộc",
    part_of_speech: "danh từ",
    meaning: "(cũ) phẩm tước và bổng lộc của quan lại: vua ban tước lộc",
    example: "vua ban tước lộc",
  },
  {
    word: "tươi",
    part_of_speech: "tính từ",
    meaning:
      '(hoa lá, cây cối đã cắt, hái) đang còn giữ chất nước, chưa úa, chưa héo, chưa khô: rau tươi * củi còn tươi * "Hoa tàn mà lại thêm tươi, Trăng tàn mà lại hơn mười rằm xưa." (TKiều)',
    example:
      'rau tươi * củi còn tươi * "Hoa tàn mà lại thêm tươi, Trăng tàn mà lại hơn mười rằm xưa." (TKiều)',
  },
  {
    word: "tươi",
    part_of_speech: "tính từ",
    meaning:
      "(thực phẩm) còn mới, còn giữ nguyên chất, chưa ươn, chưa bị biến chất: tôm tươi * mớ cá tươi * miếng thịt còn tươi nguyên",
    example: "tôm tươi * mớ cá tươi * miếng thịt còn tươi nguyên",
  },
  {
    word: "tươi",
    part_of_speech: "tính từ",
    meaning:
      "còn rất mới, chưa ráo nước, chưa khô: ngã bật máu tươi * nét chữ còn tươi vết mực",
    example: "ngã bật máu tươi * nét chữ còn tươi vết mực",
  },
  {
    word: "tươi",
    part_of_speech: "tính từ",
    meaning: "(màu sắc) đẹp, sáng, ưa nhìn: mái ngói đỏ tươi * tà áo tươi màu",
    example: "mái ngói đỏ tươi * tà áo tươi màu",
  },
  {
    word: "tươi",
    part_of_speech: "tính từ",
    meaning:
      "(nét mặt) có biểu hiện vui vẻ, phấn khởi: cười rất tươi * mặt tươi như hoa",
    example: "cười rất tươi * mặt tươi như hoa",
  },
  {
    word: "tươi",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) khá hơn bình thường về đời sống vật chất, và vui vẻ hơn: cả nhà được một bữa ăn tươi",
    example: "cả nhà được một bữa ăn tươi",
  },
  {
    word: "tươi",
    part_of_speech: "tính từ",
    meaning:
      "dôi ra một chút so với khối lượng được ghi trên mặt cân: cân tươi lên để trừ bì * miếng thịt năm lạng tươi",
    example: "cân tươi lên để trừ bì * miếng thịt năm lạng tươi",
  },
  {
    word: "tươi mát",
    part_of_speech: "tính từ",
    meaning:
      "tươi và dịu mát, gây cảm giác dễ chịu, ưa thích: màu sắc tươi mát * không khí tươi mát, trong lành",
    example: "màu sắc tươi mát * không khí tươi mát, trong lành",
  },
  {
    word: "tươi cười",
    part_of_speech: "tính từ",
    meaning: "(vẻ mặt) vui vẻ, hồ hởi: vẻ mặt tươi cười * tươi cười niềm nở",
    example: "vẻ mặt tươi cười * tươi cười niềm nở",
  },
  {
    word: "tươi mưởi",
    part_of_speech: "tính từ",
    meaning: "(cũ, hiếm) như tươi bưởi: mặt mày tươi mưởi, hớn hở",
    example: "mặt mày tươi mưởi, hớn hở",
  },
  {
    word: "tươi rói",
    part_of_speech: "tính từ",
    meaning:
      "rất tươi với vẻ sinh động, hấp dẫn: mẻ cá tươi rói * gương mặt tươi rói * cười tươi rói",
    example: "mẻ cá tươi rói * gương mặt tươi rói * cười tươi rói",
  },
  {
    word: "tươi hơn hớn",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) tươi một cách rạng rỡ, hớn hở: mặt tươi hơn hớn",
    example: "mặt tươi hơn hớn",
  },
  {
    word: "tươi nhuận",
    part_of_speech: "tính từ",
    meaning:
      "rất tươi, tựa như thấm đầy chất nước ở bên trong: da dẻ tươi nhuận",
    example: "da dẻ tươi nhuận",
  },
  {
    word: "tươi roi rói",
    part_of_speech: "tính từ",
    meaning: "như tươi rói (nhưng ý nhấn mạnh hơn): mặt tươi roi rói",
    example: "mặt tươi roi rói",
  },
  {
    word: "tưới tắm",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tưới cho cây trồng (nói khái quát): tưới tắm mấy luống hoa",
    example: "tưới tắm mấy luống hoa",
  },
  {
    word: "tươi sáng",
    part_of_speech: "tính từ",
    meaning: "tươi đẹp và sáng sủa: màu sắc tươi sáng * tương lai tươi sáng",
    example: "màu sắc tươi sáng * tương lai tươi sáng",
  },
  {
    word: "tươi sống",
    part_of_speech: "tính từ",
    meaning:
      "(thực phẩm) được giữ nguyên ở dạng tươi, chứ không chế biến: thực phẩm tươi sống * hải sản tươi sống",
    example: "thực phẩm tươi sống * hải sản tươi sống",
  },
  {
    word: "tưới tiêu",
    part_of_speech: "động từ",
    meaning:
      "đưa nước vào và làm thoát nước đi theo nhu cầu sinh trưởng của cây trồng (nói khái quát): hệ thống tưới tiêu",
    example: "hệ thống tưới tiêu",
  },
  {
    word: "tươi tắn",
    part_of_speech: "tính từ",
    meaning:
      "tươi, nhìn thấy thích mắt (nói khái quát): màu sắc tươi tắn * miệng cười tươi tắn",
    example: "màu sắc tươi tắn * miệng cười tươi tắn",
  },
  {
    word: "tươi tỉnh",
    part_of_speech: "tính từ",
    meaning: "(nét mặt) tươi tắn và vui vẻ, hớn hở: mặt mũi tươi tỉnh",
    example: "mặt mũi tươi tỉnh",
  },
  {
    word: "tươi vui",
    part_of_speech: "tính từ",
    meaning: "như vui tươi: nét mặt tươi vui hẳn lên",
    example: "nét mặt tươi vui hẳn lên",
  },
  {
    word: "tươi trẻ",
    part_of_speech: "tính từ",
    meaning: "tươi tắn và trẻ trung: tâm hồn tươi trẻ",
    example: "tâm hồn tươi trẻ",
  },
  {
    word: "tươi tốt",
    part_of_speech: "tính từ",
    meaning:
      "(cây cối) xanh tốt do được phát triển trong điều kiện thuận lợi: luỹ tre tươi tốt * mùa màng tươi tốt",
    example: "luỹ tre tươi tốt * mùa màng tươi tốt",
  },
  {
    word: "tươm tất",
    part_of_speech: "tính từ",
    meaning:
      "có đủ những cái cần thiết để đáp ứng yêu cầu, thường về sinh hoạt vật chất, gây cảm giác hài lòng: ăn mặc tươm tất * cơm rượu chuẩn bị tươm tất",
    example: "ăn mặc tươm tất * cơm rượu chuẩn bị tươm tất",
  },
  {
    word: "tướng",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) quan võ cầm đầu một đạo quân thời trước: bắt sống tướng giặc * hao binh tổn tướng",
    example: "bắt sống tướng giặc * hao binh tổn tướng",
  },
  {
    word: "tướng",
    part_of_speech: "danh từ",
    meaning: "cấp quân hàm trên cấp tá: quân hàm cấp tướng",
    example: "quân hàm cấp tướng",
  },
  {
    word: "tướng",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi quân cờ hay quân bài cao nhất trong cờ tướng hay trong bài tam cúc, bài tứ sắc: chiếu tướng * tướng ông, tướng bà",
    example: "chiếu tướng * tướng ông, tướng bà",
  },
  {
    word: "tướng",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) từ dùng để gọi những người ngang hàng hoặc người dưới còn ít tuổi (hàm ý vui đùa, suồng sã): thôi, làm đi các tướng!",
    example: "thôi, làm đi các tướng!",
  },
  {
    word: "tướng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) rất to: gánh một gánh tướng * ăn hết một bát tướng cơm",
    example: "gánh một gánh tướng * ăn hết một bát tướng cơm",
  },
  {
    word: "tướng",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) (to, lớn) quá mức thường: mặt sưng tướng * sợ quá, hét tướng lên",
    example: "mặt sưng tướng * sợ quá, hét tướng lên",
  },
  {
    word: "tướng",
    part_of_speech: "danh từ",
    meaning:
      "vẻ mặt và dáng người (nói tổng quát), thường được coi là sự biểu hiện của tâm tính, khả năng hay số mệnh của một người: trông tướng như đàn ông * có tướng làm quan * tướng người vất vả",
    example: "trông tướng như đàn ông * có tướng làm quan * tướng người vất vả",
  },
  {
    word: "tươi thắm",
    part_of_speech: "tính từ",
    meaning:
      "rất tươi với những màu sắc đẹp đẽ: đoá hoa tươi thắm * đôi môi tươi thắm",
    example: "đoá hoa tươi thắm * đôi môi tươi thắm",
  },
  {
    word: "tương",
    part_of_speech: "danh từ",
    meaning:
      "nước chấm, làm từ gạo nếp (hoặc ngô), đậu nành và muối: cá kho tương * nát như tương",
    example: "cá kho tương * nát như tương",
  },
  {
    word: "tương",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) ném hoặc đưa ra một cách bừa bãi, bất kể thế nào: tương cả muối vào nồi nước chè * tương ra toàn những lời trái tai",
    example:
      "tương cả muối vào nồi nước chè * tương ra toàn những lời trái tai",
  },
  {
    word: "tường",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận xây bằng gạch, đá để chống đỡ sàn gác và mái, hoặc để ngăn cách: tường rào * trèo tường * tường xây con kiến",
    example: "tường rào * trèo tường * tường xây con kiến",
  },
  {
    word: "tường",
    part_of_speech: "động từ",
    meaning:
      "(văn chương, hiếm) biết rõ, hiểu rõ: chưa tường thực hư * tường mặt tỏ tên",
    example: "chưa tường thực hư * tường mặt tỏ tên",
  },
  {
    word: "tươm",
    part_of_speech: "động từ",
    meaning:
      "chảy ra nhiều từ trong cơ thể qua những lỗ rất nhỏ: mồ hôi tươm ra ướt trán",
    example: "mồ hôi tươm ra ướt trán",
  },
  {
    word: "tươm",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái rách nát đến mức như không còn hình thù gì nữa: quả chuối bị giẫm nát tươm * gai xé tươm quần áo",
    example: "quả chuối bị giẫm nát tươm * gai xé tươm quần áo",
  },
  {
    word: "tươm",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) có thể coi là được, thậm chí là tốt rồi, trong điều kiện vật chất khó có thể đòi hỏi hơn: ngôi nhà sửa lại trông cũng khá tươm",
    example: "ngôi nhà sửa lại trông cũng khá tươm",
  },
  {
    word: "tượng binh",
    part_of_speech: "danh từ",
    meaning: "quân cưỡi voi chiến đấu, thời xưa: đội tượng binh",
    example: "đội tượng binh",
  },
  {
    word: "tường bao",
    part_of_speech: "danh từ",
    meaning:
      "tường xây kín xung quanh để bảo vệ đất đai, nhà ở: ngôi nhà có tường bao kín mít",
    example: "ngôi nhà có tường bao kín mít",
  },
  {
    word: "tưởng chừng",
    part_of_speech: "động từ",
    meaning:
      "tưởng như là, nghĩ như là (nhưng thật ra không phải): biển xanh tưởng chừng vô tận * bệnh nặng tưởng chừng không qua khỏi",
    example:
      "biển xanh tưởng chừng vô tận * bệnh nặng tưởng chừng không qua khỏi",
  },
  {
    word: "tưởng bở",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tưởng lầm rằng đây là dịp tốt, có nhiều thuận lợi để làm việc gì đó có lợi cho mình: giàu trí tưởng bở * đừng có tưởng bở!",
    example: "giàu trí tưởng bở * đừng có tưởng bở!",
  },
  {
    word: "tưởng",
    part_of_speech: "động từ",
    meaning:
      "nghĩ đến nhiều một cách cụ thể và với tình cảm thiết tha: mải chơi, không tưởng đến học hành",
    example: "mải chơi, không tưởng đến học hành",
  },
  {
    word: "tưởng",
    part_of_speech: "động từ",
    meaning:
      "nghĩ và tin chắc (điều thật ra không phải): tưởng là dễ, ai ngờ * tôi tưởng anh đã đi rồi",
    example: "tưởng là dễ, ai ngờ * tôi tưởng anh đã đi rồi",
  },
  {
    word: "tưởng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) từ dùng chêm vào trong câu để làm nhẹ bớt ý khẳng định và cho có sắc thái khiêm nhường: việc đó tưởng cũng dễ thôi * tôi tưởng việc này chúng ta không nên bàn đến nữa",
    example:
      "việc đó tưởng cũng dễ thôi * tôi tưởng việc này chúng ta không nên bàn đến nữa",
  },
  {
    word: "tượng",
    part_of_speech: "danh từ",
    meaning: "(hiếm) voi: người quản tượng * đội tượng binh",
    example: "người quản tượng * đội tượng binh",
  },
  {
    word: "tượng",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi một quân trong cờ tướng hay trong bài tam cúc, bài tứ sắc: lên tượng * đôi tượng vàng",
    example: "lên tượng * đôi tượng vàng",
  },
  {
    word: "tượng",
    part_of_speech: "danh từ",
    meaning:
      "hình người hay vật được tạc nên bằng một chất liệu rắn: tạc tượng * bức tượng đá",
    example: "tạc tượng * bức tượng đá",
  },
  {
    word: "tướng cướp",
    part_of_speech: "danh từ",
    meaning: "kẻ cầm đầu toán cướp: tóm được tên tướng cướp",
    example: "tóm được tên tướng cướp",
  },
  {
    word: "tượng đài",
    part_of_speech: "danh từ",
    meaning:
      "công trình kiến trúc lớn gồm một hoặc nhiều bức tượng, đặt ở địa điểm thích hợp, dùng làm biểu trưng cho một dân tộc, một địa phương, đánh dấu một sự kiện lịch sử hay tưởng niệm người có công lao lớn: tượng đài vua Lý Thái Tổ * tượng đài liệt sĩ vô danh",
    example: "tượng đài vua Lý Thái Tổ * tượng đài liệt sĩ vô danh",
  },
  {
    word: "tương đương",
    part_of_speech: "tính từ",
    meaning:
      "có giá trị ngang nhau: tuổi tác tương đương nhau * số tiền tương đương một tấn thóc",
    example: "tuổi tác tương đương nhau * số tiền tương đương một tấn thóc",
  },
  {
    word: "tương đối",
    part_of_speech: "tính từ",
    meaning:
      "ở một mức nào đó, trong quan hệ so sánh với những cái khác cùng loại: kết quả tương đối tốt * kinh tế tương đối phát triển",
    example: "kết quả tương đối tốt * kinh tế tương đối phát triển",
  },
  {
    word: "tương đối",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ở mức đại khái trên trung bình, có thể tạm hài lòng: hình thức trông cũng tương đối",
    example: "hình thức trông cũng tương đối",
  },
  {
    word: "tương giao",
    part_of_speech: "động từ",
    meaning:
      '(cũ) giao thiệp, kết thân với nhau: "Miếng trầu là nghĩa tương giao, Muốn cho đây đấy duyên vào hợp duyên." (ca dao)',
    example:
      'Miếng trầu là nghĩa tương giao, Muốn cho đây đấy duyên vào hợp duyên." (ca dao)',
  },
  {
    word: "tường giải",
    part_of_speech: "động từ",
    meaning: "giải thích một cách tường tận, rõ ràng: từ điển tường giải",
    example: "từ điển tường giải",
  },
  {
    word: "tương đồng",
    part_of_speech: "tính từ",
    meaning:
      "giống nhau (bên cạnh những cái khác nhau): ý kiến tương đồng * hai nước có nhiều điểm tương đồng về văn hoá",
    example: "ý kiến tương đồng * hai nước có nhiều điểm tương đồng về văn hoá",
  },
  {
    word: "tượng hình",
    part_of_speech: "động từ",
    meaning:
      "(từ) có tác dụng gợi lên những hình ảnh, dáng vẻ cụ thể: ,  * ,  *  là những từ tượng hình",
    example: ",  * ,  *  là những từ tượng hình",
  },
  {
    word: "tượng hình",
    part_of_speech: "động từ",
    meaning:
      "có những nét mô phỏng theo hình dáng sự vật (một kiểu cấu tạo chữ viết): chữ Hán là một thứ chữ tượng hình",
    example: "chữ Hán là một thứ chữ tượng hình",
  },
  {
    word: "tương hỗ",
    part_of_speech: "tính từ",
    meaning: "qua lại lẫn nhau: quan hệ tương hỗ * tác động tương hỗ",
    example: "quan hệ tương hỗ * tác động tương hỗ",
  },
  {
    word: "tương hợp",
    part_of_speech: "động từ",
    meaning: "phù hợp với nhau: hình thức phải tương hợp với nội dung",
    example: "hình thức phải tương hợp với nội dung",
  },
  {
    word: "tương hợp",
    part_of_speech: "động từ",
    meaning:
      "(từ phụ thuộc về ngữ pháp) có giống, số, cách, ngôi của từ mà nó phụ thuộc vào, biểu thị sự liên hệ cú pháp giữa các từ trong ngữ và câu ở một số ngôn ngữ: trong tiếng Anh, động từ tương hợp về ngôi và số với chủ ngữ",
    example: "trong tiếng Anh, động từ tương hợp về ngôi và số với chủ ngữ",
  },
  {
    word: "tương khắc",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất xung khắc nhau, không hợp nhau: hai anh em tương khắc nhau",
    example: "hai anh em tương khắc nhau",
  },
  {
    word: "tương kỵ",
    part_of_speech: "tính từ",
    meaning: "có tính chất kị nhau: hai vị thuốc này tương kị nhau",
    example: "hai vị thuốc này tương kị nhau",
  },
  {
    word: "tương kị",
    part_of_speech: "tính từ",
    meaning: "có tính chất kị nhau: hai vị thuốc này tương kị nhau",
    example: "hai vị thuốc này tương kị nhau",
  },
  {
    word: "tương lai",
    part_of_speech: "danh từ",
    meaning:
      "Thời gian sẽ đến về sau này; phân biệt với hiện tại và quá khứ: Các em sẽ là chủ nhân tương lai của đất nước",
    example: "Các em sẽ là chủ nhân tương lai của đất nước",
  },
  {
    word: "tương lai",
    part_of_speech: "danh từ",
    meaning:
      "đời sống về sau này: tính chuyện tương lai * lo cho tương lai của con cái * Tương lai nào cho chúng ta! * Lo cho tương lai của các con",
    example:
      "tính chuyện tương lai * lo cho tương lai của con cái * Tương lai nào cho chúng ta! * Lo cho tương lai của các con",
  },
  {
    word: "tương liên",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) có mối quan hệ liên kết với nhau, tương ứng với nhau: mối tương liên * đồng bệnh tương liên",
    example: "mối tương liên * đồng bệnh tương liên",
  },
  {
    word: "tướng lĩnh",
    part_of_speech: "danh từ",
    meaning:
      "tướng chỉ huy quân đội (nói khái quát): hội đồng tướng lĩnh * triệu tập tướng lĩnh, chuẩn bị xuất quân",
    example: "hội đồng tướng lĩnh * triệu tập tướng lĩnh, chuẩn bị xuất quân",
  },
  {
    word: "tương ngộ",
    part_of_speech: "động từ",
    meaning:
      "(cũ, văn chương) gặp mặt nhau: anh hùng tương ngộ * duyên tương ngộ",
    example: "anh hùng tương ngộ * duyên tương ngộ",
  },
  {
    word: "tưởng nhớ",
    part_of_speech: "động từ",
    meaning:
      "nhớ đến, nghĩ đến (thường là người đã chết) với tình cảm thiết tha: tưởng nhớ công lao của các vị anh hùng",
    example: "tưởng nhớ công lao của các vị anh hùng",
  },
  {
    word: "tường minh",
    part_of_speech: "tính từ",
    meaning: "(diễn đạt) tỉ mỉ và rõ ràng: giải thích một cách tường minh",
    example: "giải thích một cách tường minh",
  },
  {
    word: "tướng mạo",
    part_of_speech: "danh từ",
    meaning: "vẻ mặt và dáng người: tướng mạo khôi ngô",
    example: "tướng mạo khôi ngô",
  },
  {
    word: "tưởng niệm",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) tưởng nhớ đến người đã chết với lòng tôn kính và biết ơn: đài tưởng niệm * tưởng niệm người quá cố",
    example: "đài tưởng niệm * tưởng niệm người quá cố",
  },
  {
    word: "tương phùng",
    part_of_speech: "động từ",
    meaning:
      '(cũ, văn chương) gặp gỡ nhau: buổi tương phùng * "Lá hồng là mối chỉ hồng, Nước bèo kia cũng tương phùng có phen." (BC)',
    example:
      'buổi tương phùng * "Lá hồng là mối chỉ hồng, Nước bèo kia cũng tương phùng có phen." (BC)',
  },
  {
    word: "tương quan",
    part_of_speech: "",
    meaning:
      "có quan hệ qua lại với nhau: mối tương quan * vạn vật tương quan * hai vấn đề tương quan với nhau",
    example:
      "mối tương quan * vạn vật tương quan * hai vấn đề tương quan với nhau",
  },
  {
    word: "tương phản",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất trái ngược, đối chọi nhau rõ rệt:  và  *  là hai màu tương phản",
    example: "và  *  là hai màu tương phản",
  },
  {
    word: "tướng quốc",
    part_of_speech: "danh từ",
    meaning: "(cũ, hiếm) tể tướng: phủ tướng quốc",
    example: "phủ tướng quốc",
  },
  {
    word: "tướng sĩ",
    part_of_speech: "danh từ",
    meaning:
      "tướng và nói chung những người chỉ huy, cùng với binh sĩ (nói tổng quát): ba quân tướng sĩ * tướng sĩ một lòng đánh giặc",
    example: "ba quân tướng sĩ * tướng sĩ một lòng đánh giặc",
  },
  {
    word: "tướng số",
    part_of_speech: "danh từ",
    meaning:
      "thuật xem tướng và xem số để đoán vận mệnh con người (nói tổng quát): xem tướng số * không tin ở tướng số",
    example: "xem tướng số * không tin ở tướng số",
  },
  {
    word: "tướng quân",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) từ dùng để gọi một cách tôn kính vị tướng chỉ huy thời trước: nhị vị tướng quân * đô đốc tướng quân",
    example: "nhị vị tướng quân * đô đốc tướng quân",
  },
  {
    word: "tướng soái",
    part_of_speech: "danh từ",
    meaning: "(cũ) như tướng lĩnh: các tướng soái của Lê Lợi",
    example: "các tướng soái của Lê Lợi",
  },
  {
    word: "tương tàn",
    part_of_speech: "động từ",
    meaning: "tàn sát lẫn nhau: cảnh huynh đệ tương tàn",
    example: "cảnh huynh đệ tương tàn",
  },
  {
    word: "tường tận",
    part_of_speech: "tính từ",
    meaning:
      "rõ đến từng chi tiết: hiểu tường tận vấn đề * kể tường tận từng chi tiết",
    example: "hiểu tường tận vấn đề * kể tường tận từng chi tiết",
  },
  {
    word: "tương tác",
    part_of_speech: "động từ",
    meaning:
      "tác động qua lại lẫn nhau: lực tương tác giữa các vật * quan hệ tương tác",
    example: "lực tương tác giữa các vật * quan hệ tương tác",
  },
  {
    word: "tượng thanh",
    part_of_speech: "động từ",
    meaning:
      "(từ) mô phỏng, gợi tả âm thanh trong thực tế: ,  *  là những từ tượng thanh",
    example: ",  *  là những từ tượng thanh",
  },
  {
    word: "tướng tá",
    part_of_speech: "danh từ",
    meaning: "tướng và tá, sĩ quan cao cấp (nói khái quát): đủ mặt tướng tá",
    example: "đủ mặt tướng tá",
  },
  {
    word: "tướng tá",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) tướng mạo: tướng tá như hộ Pháp",
    example: "tướng tá như hộ Pháp",
  },
  {
    word: "tương thích",
    part_of_speech: "tính từ",
    meaning:
      "phù hợp, thích hợp, tương ứng với nhau: độ tương thích giữa linh kiện và máy * phần mềm tương thích",
    example: "độ tương thích giữa linh kiện và máy * phần mềm tương thích",
  },
  {
    word: "tưởng thưởng",
    part_of_speech: "động từ",
    meaning:
      "(cũ) thưởng, khen thưởng để ghi nhớ công lao: tưởng thưởng công lao * được triều đình tưởng thưởng",
    example: "tưởng thưởng công lao * được triều đình tưởng thưởng",
  },
  {
    word: "tương tri",
    part_of_speech: "động từ",
    meaning:
      '(cũ, văn chương) hiểu nhau, biết rõ lòng nhau: bạn tương tri * "Mấy lời tâm phúc ruột rà, Tương tri dường ấy mới là tương tri!" (TKiều)',
    example:
      'bạn tương tri * "Mấy lời tâm phúc ruột rà, Tương tri dường ấy mới là tương tri!" (TKiều)',
  },
  {
    word: "tường thuật",
    part_of_speech: "động từ",
    meaning:
      "kể lại rõ ràng, tường tận: tường thuật buổi lễ khai mạc * tường thuật trực tiếp trận bóng đá",
    example:
      "tường thuật buổi lễ khai mạc * tường thuật trực tiếp trận bóng đá",
  },
  {
    word: "tương thân tương ái",
    part_of_speech: "",
    meaning:
      "thương yêu, gắn bó thân thiết với nhau: tinh thần tương thân tương ái",
    example: "tinh thần tương thân tương ái",
  },
  {
    word: "tượng trưng",
    part_of_speech: "động từ",
    meaning:
      "dùng một sự vật cụ thể có hình thức hoặc tính chất thích hợp để gợi ra sự liên tưởng đến một cái trừu tượng nào đó: chim bồ câu tượng trưng cho hoà bình",
    example: "chim bồ câu tượng trưng cho hoà bình",
  },
  {
    word: "tượng trưng",
    part_of_speech: "danh từ",
    meaning:
      "sự vật cụ thể được dùng để tượng trưng cho cái trừu tượng nào đó: xiềng xích là tượng trưng của sự nô lệ",
    example: "xiềng xích là tượng trưng của sự nô lệ",
  },
  {
    word: "tượng trưng",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất tượng trưng, hình thức, ước lệ, không phải đầy đủ như thật: cuốc tượng trưng mấy nhát để làm lễ động thổ",
    example: "cuốc tượng trưng mấy nhát để làm lễ động thổ",
  },
  {
    word: "tường trình",
    part_of_speech: "động từ",
    meaning:
      "trình bày, báo cáo lại đầy đủ, rõ ràng một vấn đề nào đó trước cấp trên hoặc trước tổ chức: tường trình rõ đầu đuôi sự việc * bản tường trình lí lịch",
    example: "tường trình rõ đầu đuôi sự việc * bản tường trình lí lịch",
  },
  {
    word: "tương trợ",
    part_of_speech: "động từ",
    meaning: "giúp đỡ lẫn nhau: tương trợ lẫn nhau",
    example: "tương trợ lẫn nhau",
  },
  {
    word: "tương truyền",
    part_of_speech: "động từ",
    meaning:
      "truyền miệng nhau trong dân gian từ đời nọ qua đời kia: tương truyền thành hoàng làng này thiêng lắm",
    example: "tương truyền thành hoàng làng này thiêng lắm",
  },
  {
    word: "tương tư",
    part_of_speech: "động từ",
    meaning:
      'nhớ (người yêu) da diết: sầu tương tư * "Gió mưa là bệnh của giời, Tương tư là bệnh của tôi yêu nàng." (NgBính; 15)',
    example:
      'sầu tương tư * "Gió mưa là bệnh của giời, Tương tư là bệnh của tôi yêu nàng." (NgBính; 15)',
  },
  {
    word: "tương tự",
    part_of_speech: "tính từ",
    meaning:
      "gần giống như thế, về những mặt được nói đến nào đó: hai từ có nghĩa tương tự nhau * rơi vào một tình huống tương tự",
    example: "hai từ có nghĩa tương tự nhau * rơi vào một tình huống tương tự",
  },
  {
    word: "tương ứng",
    part_of_speech: "động từ",
    meaning:
      "có mối quan hệ phù hợp với nhau: trách nhiệm tương ứng với quyền hành * tỉ lệ lãi suất tương ứng với phần vốn góp",
    example:
      "trách nhiệm tương ứng với quyền hành * tỉ lệ lãi suất tương ứng với phần vốn góp",
  },
  {
    word: "tưởng tượng",
    part_of_speech: "động từ",
    meaning:
      "tạo ra trong trí hình ảnh những cái không có ở trước mắt hoặc chưa hề có: tưởng tượng cuộc sống tương lai * thành công ngoài sức tưởng tượng",
    example:
      "tưởng tượng cuộc sống tương lai * thành công ngoài sức tưởng tượng",
  },
  {
    word: "tường vi",
    part_of_speech: "danh từ",
    meaning:
      "cây nhỡ, cành có bốn cạnh, lá hình bầu dục dài, mọc đối, hoa mọc thành từng chùm, màu hồng hay đỏ: hoa tường vi",
    example: "hoa tường vi",
  },
  {
    word: "tướp",
    part_of_speech: "tính từ",
    meaning: "xơ, nát ra thành từng mảnh: quần áo rách tướp * xé tướp tờ giấy",
    example: "quần áo rách tướp * xé tướp tờ giấy",
  },
  {
    word: "tướp",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) (máu) chảy ra, tươm ra ở vết da rách nát: bàn tay tướp máu",
    example: "bàn tay tướp máu",
  },
  {
    word: "tướp",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) cái đã bị xơ ra, tướp ra: tướp cói khô * giũ sạch tướp đay",
    example: "tướp cói khô * giũ sạch tướp đay",
  },
  {
    word: "tưởng vọng",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) tưởng nhớ người đã chết với tình cảm thiết tha: tưởng vọng các liệt sĩ",
    example: "tưởng vọng các liệt sĩ",
  },
  {
    word: "tưởng vọng",
    part_of_speech: "động từ",
    meaning:
      "tưởng đến và mong ước: tưởng vọng cuộc sống giàu sang * tưởng vọng về quê hương",
    example: "tưởng vọng cuộc sống giàu sang * tưởng vọng về quê hương",
  },
  {
    word: "tương xứng",
    part_of_speech: "tính từ",
    meaning:
      "có mối quan hệ phù hợp với nhau về mức độ: tiền lương tương xứng với nhiệm vụ *  chịu mức án tương xứng với tội danh",
    example:
      "tiền lương tương xứng với nhiệm vụ *  chịu mức án tương xứng với tội danh",
  },
  {
    word: "tườu",
    part_of_speech: "danh từ",
    meaning: "(thông tục) con khỉ, dùng làm tiếng rủa: đồ con tườu!",
    example: "đồ con tườu!",
  },
  {
    word: "tướt",
    part_of_speech: "danh từ",
    meaning: "bệnh ỉa chảy nhẹ ở trẻ em: trẻ mọc răng hay đi tướt",
    example: "trẻ mọc răng hay đi tướt",
  },
  {
    word: "tướt",
    part_of_speech: "tính từ",
    meaning: "(thông tục) tướt bơ (nói tắt): còn tướt mới xong",
    example: "còn tướt mới xong",
  },
  {
    word: "tướt bơ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) vất vả, mất nhiều công sức để làm một việc gì đó: chạy tướt bơ mới tới",
    example: "chạy tướt bơ mới tới",
  },
  {
    word: "tửu",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) rượu: làm tí tửu cho tưng bừng",
    example: "làm tí tửu cho tưng bừng",
  },
  {
    word: "tựu",
    part_of_speech: "động từ",
    meaning: "(hiếm) tụ lại ở một nơi, một chỗ: mọi người đã tựu đông đủ",
    example: "mọi người đã tựu đông đủ",
  },
  {
    word: "tửu sắc",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) rượu và gái, về mặt là những thú ham mê có hại: ham mê tửu sắc",
    example: "ham mê tửu sắc",
  },
  {
    word: "tựu trường",
    part_of_speech: "động từ",
    meaning:
      "(học sinh) tập trung tại trường vào ngày khai giảng: buổi tựu trường",
    example: "buổi tựu trường",
  },
  {
    word: "tựu trung",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là cái chung, cái chính trong những điều vừa nói đến: mỗi người một ý, nhưng tựu trung đều tán thành cả",
    example: "mỗi người một ý, nhưng tựu trung đều tán thành cả",
  },
  {
    word: "tửu lượng",
    part_of_speech: "danh từ",
    meaning: "sức uống rượu được nhiều hay ít: tửu lượng cao",
    example: "tửu lượng cao",
  },
  {
    word: "tỷ",
    part_of_speech: "danh từ",
    meaning:
      "số đếm, bằng một nghìn triệu: một tỉ đồng * phải tiền tỉ mới mua được",
    example: "một tỉ đồng * phải tiền tỉ mới mua được",
  },
  {
    word: "tỵ",
    part_of_speech: "danh từ",
    meaning:
      "(thường viết Tị, Tỵ) kí hiệu thứ sáu trong địa chi (lấy rắn làm tượng trưng; sau thìn trước ngọ), dùng trong phép đếm thời gian cổ truyền của Trung Quốc và một số nước châu á, trong đó có Việt Nam: giờ Tị (từ 9 giờ sáng đến 11 giờ trưa) * năm Tị * tuổi Tị",
    example: "giờ Tị (từ 9 giờ sáng đến 11 giờ trưa) * năm Tị * tuổi Tị",
  },
  {
    word: "tỵ",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ, hiếm) như tí: tị nữa là xong * còn có một tị cơm",
    example: "tị nữa là xong * còn có một tị cơm",
  },
  {
    word: "tỵ",
    part_of_speech: "động từ",
    meaning:
      "tỏ ra không bằng lòng trước cái người khác được hưởng, vì so sánh và cho rằng mình bị thiệt: con chị tị con em * chia đều cho bọn trẻ khỏi tị",
    example: "con chị tị con em * chia đều cho bọn trẻ khỏi tị",
  },
  {
    word: "ty",
    part_of_speech: "danh từ",
    meaning: "(cũ) sở: ti nông nghiệp * ti giáo dục",
    example: "ti nông nghiệp * ti giáo dục",
  },
  {
    word: "ty",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi chung những chi tiết máy hay dụng cụ có dạng thanh, cần, ống, đòn hình trụ: ti ghi đông xe đạp",
    example: "ti ghi đông xe đạp",
  },
  {
    word: "ty",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, văn chương) sợi tơ, thường dùng để làm dây đàn: tiếng ti, tiếng trúc",
    example: "tiếng ti, tiếng trúc",
  },
  {
    word: "ty",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bú (dùng trong cách nói với trẻ em): cho bé ti * ti một hơi rồi ngủ",
    example: "cho bé ti * ti một hơi rồi ngủ",
  },
  {
    word: "ty",
    part_of_speech: "động từ",
    meaning: "như tí: hạt sạn nhỏ ti",
    example: "hạt sạn nhỏ ti",
  },
  {
    word: "tỳ",
    part_of_speech: "danh từ",
    meaning: "lá lách, theo cách gọi trong đông y: thuốc bổ tì",
    example: "thuốc bổ tì",
  },
  {
    word: "tỳ",
    part_of_speech: "danh từ",
    meaning:
      "vết xước, vết bẩn trên một vật nào đó, làm cho xấu đi: viên ngọc có tì",
    example: "viên ngọc có tì",
  },
  {
    word: "tỳ",
    part_of_speech: "động từ",
    meaning:
      "đè mạnh xuống hoặc áp mạnh vào một chỗ tựa chắc chắn, để có được một thế vững: tì cằm vào đầu gối * tì tay xuống mặt bàn",
    example: "tì cằm vào đầu gối * tì tay xuống mặt bàn",
  },
  {
    word: "tý",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) vú (dùng khi nói với trẻ con hoặc theo cách nói của trẻ con): bú tí * bé sờ tí mẹ",
    example: "bú tí * bé sờ tí mẹ",
  },
  {
    word: "tý",
    part_of_speech: "danh từ",
    meaning:
      "(thường viết Tí, Tý) kí hiệu thứ nhất trong địa chi (lấy chuột làm tượng trưng; trước sửu), dùng trong phép đếm thời gian cổ truyền của Trung Quốc và một số nước châu á, trong đó có Việt Nam: tuổi Tí * sinh vào giờ Tí (từ 11 giờ đêm đến 1 giờ sáng)",
    example: "tuổi Tí * sinh vào giờ Tí (từ 11 giờ đêm đến 1 giờ sáng)",
  },
  {
    word: "tý",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) lượng, phần rất nhỏ, rất ít, gần như không đáng kể: cho thêm tí muối * đợi một tí * chẳng có tí hi vọng nào * tí tuổi đầu đã học đòi",
    example:
      "cho thêm tí muối * đợi một tí * chẳng có tí hi vọng nào * tí tuổi đầu đã học đòi",
  },
  {
    word: "tý",
    part_of_speech: "tính từ",
    meaning:
      "quá nhỏ, quá bé, đến mức như khó nhìn thấy: một ngôi sao bé tí * đôi mắt nhỏ tí",
    example: "một ngôi sao bé tí * đôi mắt nhỏ tí",
  },
  {
    word: "tỷ dụ",
    part_of_speech: "danh từ",
    meaning:
      "và đg (cũ, hiếm) ví dụ: dẫn một câu làm tỉ dụ * tỉ dụ nó không có nhà thì sao?",
    example: "dẫn một câu làm tỉ dụ * tỉ dụ nó không có nhà thì sao?",
  },
  {
    word: "tỷ dụ",
    part_of_speech: "danh từ",
    meaning:
      "phép so sánh để làm nổi bật một tính chất nào đó: nói  *  là dùng phép tỉ dụ",
    example: "nói  *  là dùng phép tỉ dụ",
  },
  {
    word: "tỷ giá",
    part_of_speech: "danh từ",
    meaning:
      "quan hệ so sánh các mức giá của các loại hàng hoá khác nhau có liên quan trong sản xuất và tiêu dùng: tỉ giá tiền tệ * tăng tỉ giá đồng dollar",
    example: "tỉ giá tiền tệ * tăng tỉ giá đồng dollar",
  },
  {
    word: "tỷ lệ bản đồ",
    part_of_speech: "danh từ",
    meaning:
      "tỉ số cho biết mức độ thu nhỏ của mặt đất lên bản đồ, được biểu thị bằng một phân số mà tử số bằng 1: tỉ lệ bản đồ 1/500.000",
    example: "tỉ lệ bản đồ 1/500.000",
  },
  {
    word: "tỷ lệ thuận",
    part_of_speech: "tính từ",
    meaning:
      "có quan hệ phụ thuộc lẫn nhau giữa hai đại lượng, sao cho khi đại lượng này tăng giảm bao nhiêu lần thì đại lượng kia cũng tăng giảm bấy nhiêu lần: trong chuyển động đều, quãng đường tỉ lệ thuận với thời gian",
    example: "trong chuyển động đều, quãng đường tỉ lệ thuận với thời gian",
  },
  {
    word: "tỷ lệ",
    part_of_speech: "danh từ",
    meaning:
      "tỉ số giữa các phần của một tổng thể, hay giữa một phần nào đó với tổng thể: tỉ lệ thất nghiệp * tỉ lệ nữ chiếm 2/3 trong tổng số công nhân của nhà máy",
    example:
      "tỉ lệ thất nghiệp * tỉ lệ nữ chiếm 2/3 trong tổng số công nhân của nhà máy",
  },
  {
    word: "tỷ lệ",
    part_of_speech: "danh từ",
    meaning:
      "tỉ số giữa các kích thước của vật trên hình vẽ, ảnh chụp, bản đồ với kích thước thật của nó: bản đồ quy hoạch được vẽ với tỉ lệ 1/500",
    example: "bản đồ quy hoạch được vẽ với tỉ lệ 1/500",
  },
  {
    word: "tỷ lệ",
    part_of_speech: "tính từ",
    meaning:
      "tỉ lệ thuận (nói tắt): chu vi hình tròn tỉ lệ với bán kính của nó",
    example: "chu vi hình tròn tỉ lệ với bán kính của nó",
  },
  {
    word: "tỷ mỉ",
    part_of_speech: "tính từ",
    meaning:
      "đầy đủ mọi khía cạnh, kĩ đến từng chi tiết nhỏ: dặn dò tỉ mỉ * kế hoạch đã được tính toán tỉ mỉ",
    example: "dặn dò tỉ mỉ * kế hoạch đã được tính toán tỉ mỉ",
  },
  {
    word: "tỷ phú",
    part_of_speech: "danh từ",
    meaning: "người rất giàu, có bạc tỉ: nhà tỉ phú",
    example: "nhà tỉ phú",
  },
  {
    word: "tỷ số",
    part_of_speech: "danh từ",
    meaning:
      "thương số các số đo của hai đại lượng cùng loại với cùng một đơn vị đo: tỉ số hai đoạn thẳng * tỉ số chung cuộc là 0 - 0 * thắng với tỉ số sát nút",
    example:
      "tỉ số hai đoạn thẳng * tỉ số chung cuộc là 0 - 0 * thắng với tỉ số sát nút",
  },
  {
    word: "tỷ như",
    part_of_speech: "",
    meaning:
      '(khẩu ngữ) ví như, ví dụ như: "Trai tơ gặp gái đang xuân, Tỉ như trời hạn nửa chừng gặp mưa." (ca dao)',
    example:
      'Trai tơ gặp gái đang xuân, Tỉ như trời hạn nửa chừng gặp mưa." (ca dao)',
  },
  {
    word: "tỷ trọng",
    part_of_speech: "danh từ",
    meaning:
      "tỉ số giữa trọng lượng của một thể tích chất nào đó với trọng lượng nước có cùng thể tích.",
    example: "tăng tỉ trọng xuất siêu * hàng nhập khẩu chiếm một tỉ trọng lớn",
  },
  {
    word: "tỷ suất",
    part_of_speech: "danh từ",
    meaning:
      "tỉ lệ phần trăm so sánh một đại lượng với một đại lượng khác có liên quan để thể hiện mức cao thấp của đại lượng đó: tỉ suất khấu hao * tỉ suất lợi nhuận",
    example: "tỉ suất khấu hao * tỉ suất lợi nhuận",
  },
  {
    word: "ủ",
    part_of_speech: "động từ",
    meaning:
      "phủ kín, trùm kín để giữ lửa hoặc giữ nhiệt độ: ủ than * ủ cơm cho nóng * lấy chăn ủ ấm cho con",
    example: "ủ than * ủ cơm cho nóng * lấy chăn ủ ấm cho con",
  },
  {
    word: "ủ",
    part_of_speech: "động từ",
    meaning:
      "phủ kín nguyên liệu chế biến để tạo ra nhiệt độ thích hợp cho vi sinh vật hoạt động, nhằm làm cho nguyên liệu lên men hay phân huỷ: ủ mốc làm tương * ủ thóc giống",
    example: "ủ mốc làm tương * ủ thóc giống",
  },
  {
    word: "ủ",
    part_of_speech: "động từ",
    meaning:
      "nung nóng kim loại hay hợp kim, rồi làm nguội dần dần để làm tăng độ dẻo: ủ thép",
    example: "ủ thép",
  },
  {
    word: "ủ",
    part_of_speech: "động từ",
    meaning:
      '(Từ cũ, Văn chương) héo rũ xuống, không tươi: "Gió vàng một phút thoảng qua, Lá ngô biến sắc cánh hoa ủ mầu." (QÂTK)',
    example:
      'Gió vàng một phút thoảng qua, Lá ngô biến sắc cánh hoa ủ mầu." (QÂTK)',
  },
  {
    word: "ủ",
    part_of_speech: "động từ",
    meaning:
      '(nét mặt) lộ vẻ buồn bã, rầu rĩ: "Nàng càng mặt ủ mày chau, Càng nghe mụ nói, càng đau như dần." (TKiều)',
    example:
      'Nàng càng mặt ủ mày chau, Càng nghe mụ nói, càng đau như dần." (TKiều)',
  },
  {
    word: "u",
    part_of_speech: "danh từ",
    meaning:
      "khối thịt nổi hẳn lên trên cơ thể, do tự nhiên hoặc do bị va đập mạnh mà có: có u ở trán * vai nổi u",
    example: "có u ở trán * vai nổi u",
  },
  {
    word: "u",
    part_of_speech: "danh từ",
    meaning: "khối u (nói tắt): u ác tính * mổ cắt u",
    example: "u ác tính * mổ cắt u",
  },
  {
    word: "u",
    part_of_speech: "động từ",
    meaning:
      "sưng thành khối nổi lên do bị va đập mạnh: ngã u đầu * đôi vai u lên vì gánh nhiều",
    example: "ngã u đầu * đôi vai u lên vì gánh nhiều",
  },
  {
    word: "u",
    part_of_speech: "danh từ",
    meaning:
      "(Phương ngữ, Từ cũ) mẹ (chỉ dùng để xưng gọi, ở một số vùng nông thôn): thầy u",
    example: "thầy u",
  },
  {
    word: "ù",
    part_of_speech: "động từ",
    meaning:
      "(trò chơi tổ tôm, tài bàn, v.v.) thắng ván bài khi gặp được đúng quân mình đang chờ: ù liền ba ván * chờ ù",
    example: "ù liền ba ván * chờ ù",
  },
  {
    word: "ù",
    part_of_speech: "tính từ",
    meaning:
      "(tai) ở trạng thái nghe như có tiếng vang đều đều liên tục, làm cho không phân biệt được rõ các âm thanh: nước vào làm ù tai * tai ù đặc, không nghe thấy gì",
    example: "nước vào làm ù tai * tai ù đặc, không nghe thấy gì",
  },
  {
    word: "ù",
    part_of_speech: "phụ từ",
    meaning:
      "(Khẩu ngữ) một cách nhanh chóng, liền một mạch: chạy ù ra chợ * làm ù đi cho xong",
    example: "chạy ù ra chợ * làm ù đi cho xong",
  },
  {
    word: "tỳ vị",
    part_of_speech: "danh từ",
    meaning: "lá lách và dạ dày, theo cách gọi trong đông y: tì vị yếu",
    example: "tì vị yếu",
  },
  {
    word: "u ẩn",
    part_of_speech: "tính từ",
    meaning:
      "sâu kín trong lòng, không bộc lộ ra (thường nói về tình cảm đau buồn): mối tình u ẩn * nỗi buồn u ẩn",
    example: "mối tình u ẩn * nỗi buồn u ẩn",
  },
  {
    word: "u ám",
    part_of_speech: "tính từ",
    meaning: "(bầu trời) mờ tối đi, do có nhiều mây đen bao phủ: bầu trời u ám",
    example: "bầu trời u ám",
  },
  {
    word: "u ám",
    part_of_speech: "tính từ",
    meaning:
      "đen tối, không thấy có gì sáng sủa: những ngày u ám dưới chế độ thực dân",
    example: "những ngày u ám dưới chế độ thực dân",
  },
  {
    word: "u buồn",
    part_of_speech: "tính từ",
    meaning: "buồn âm thầm và lặng lẽ: nét mặt u buồn * đôi mắt u buồn",
    example: "nét mặt u buồn * đôi mắt u buồn",
  },
  {
    word: "ủ bệnh",
    part_of_speech: "động từ",
    meaning:
      "ở trong giai đoạn từ khi nhiễm đến khi phát bệnh: thời gian ủ bệnh",
    example: "thời gian ủ bệnh",
  },
  {
    word: "ủ ấp",
    part_of_speech: "động từ",
    meaning: "như ấp ủ: ủ ấp hi vọng",
    example: "ủ ấp hi vọng",
  },
  {
    word: "ù cạc",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) ngớ ngẩn, không hiểu biết gì: hỏi gì nó cũng ù cạc",
    example: "hỏi gì nó cũng ù cạc",
  },
  {
    word: "ủ dột",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) (bầu trời) âm u, xám xịt, gây cảm giác nặng nề, buồn chán: bầu trời ủ dột",
    example: "bầu trời ủ dột",
  },
  {
    word: "ủ dột",
    part_of_speech: "tính từ",
    meaning:
      '(nét mặt hoặc dáng điệu) lộ rõ vẻ buồn bã, rầu rĩ: vẻ mặt ủ dột * "Lòng nàng xiết nỗi xót xa, Má đào ủ dột mặt hoa âu sầu." (QÂTK)',
    example:
      'vẻ mặt ủ dột * "Lòng nàng xiết nỗi xót xa, Má đào ủ dột mặt hoa âu sầu." (QÂTK)',
  },
  {
    word: "u hoài",
    part_of_speech: "tính từ",
    meaning: "buồn nhớ âm thầm, dai dẳng: tâm trạng u hoài * nỗi u hoài",
    example: "tâm trạng u hoài * nỗi u hoài",
  },
  {
    word: "u mê",
    part_of_speech: "tính từ",
    meaning:
      "mê muội đến mức không còn phân biệt, nhận thức được gì: đầu óc u mê, không phân biệt được tốt xấu",
    example: "đầu óc u mê, không phân biệt được tốt xấu",
  },
  {
    word: "ủ ê",
    part_of_speech: "tính từ",
    meaning:
      "buồn rầu âm thầm, ngấm ngầm và dai dẳng: nét mặt ủ ê * tâm trạng ủ ê",
    example: "nét mặt ủ ê * tâm trạng ủ ê",
  },
  {
    word: "u nhã",
    part_of_speech: "tính từ",
    meaning: "(cũ, hiếm) thanh nhã và u buồn: cảnh chùa tịch mịch và u nhã",
    example: "cảnh chùa tịch mịch và u nhã",
  },
  {
    word: "u minh",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) âm phủ và dương gian (nói khái quát): "Nẻo u minh khéo chia đôi ngả, Nghĩ đòi phen nồng nã đòi phen." (ATV)',
    example:
      'Nẻo u minh khéo chia đôi ngả, Nghĩ đòi phen nồng nã đòi phen." (ATV)',
  },
  {
    word: "u minh",
    part_of_speech: "tính từ",
    meaning: "(cũ, văn chương) (thế giới) của linh hồn người chết: cõi u minh",
    example: "cõi u minh",
  },
  {
    word: "ù lì",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có vẻ trơ lì ra, coi như không biết gì đến: ngồi ù lì một chỗ * thằng bé rất ù lì, cả ngày không mở miệng",
    example: "ngồi ù lì một chỗ * thằng bé rất ù lì, cả ngày không mở miệng",
  },
  {
    word: "ù lì",
    part_of_speech: "tính từ",
    meaning: "đần độn, chậm chạp: con người ù lì",
    example: "con người ù lì",
  },
  {
    word: "u ơ",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng kêu khóc nhỏ, rời rạc và không rõ, gây cảm giác buồn, khó chịu: khóc u ơ",
    example: "khóc u ơ",
  },
  {
    word: "u ơ",
    part_of_speech: "tính từ",
    meaning:
      'từ mô phỏng tiếng nói không rõ tiếng của trẻ thơ: nói u ơ * "U ơ ra trước hương đài, Tưởng quang cảnh ấy chua cay dường nào!" (ATV)',
    example:
      'nói u ơ * "U ơ ra trước hương đài, Tưởng quang cảnh ấy chua cay dường nào!" (ATV)',
  },
  {
    word: "ù ờ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ, hiếm) (trả lời) lúng túng, không rõ ràng, do không biết hoặc không muốn cho biết: trả lời ù ờ * hỏi gì cũng chỉ ù ờ cho qua chuyện",
    example: "trả lời ù ờ * hỏi gì cũng chỉ ù ờ cho qua chuyện",
  },
  {
    word: "ù ờ",
    part_of_speech: "tính từ",
    meaning: "khù khờ, chẳng biết gì: ù ờ nên bị thiên hạ cưỡi cổ",
    example: "ù ờ nên bị thiên hạ cưỡi cổ",
  },
  {
    word: "u sầu",
    part_of_speech: "tính từ",
    meaning: "(văn chương) như u buồn: tâm trạng u sầu",
    example: "tâm trạng u sầu",
  },
  {
    word: "ú ớ",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng thốt ra từ trong cổ, nghe không rõ tiếng gì khi mê sảng, khi cổ bị chẹn hoặc khi quá sợ hãi: ú ớ nói mê * miệng kêu ú ớ * sợ đến ú ớ, không nói thành lời",
    example: "ú ớ nói mê * miệng kêu ú ớ * sợ đến ú ớ, không nói thành lời",
  },
  {
    word: "ú ớ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (nói năng) lơ mơ, không có gì rõ ràng, do lúng túng không biết hoặc làm ra bộ không biết: nói năng ú ớ * trả lời ú ớ",
    example: "nói năng ú ớ * trả lời ú ớ",
  },
  {
    word: "u nang",
    part_of_speech: "danh từ",
    meaning: "u có bọc chứa chất lỏng: u nang buồng trứng",
    example: "u nang buồng trứng",
  },
  {
    word: "ủ rũ",
    part_of_speech: "tính từ",
    meaning:
      "(cành lá) ở trạng thái bị héo rũ xuống, hầu như không còn sức sống: hoa trong bình ủ rũ * nắng hạn, cây cối ủ rũ hết",
    example: "hoa trong bình ủ rũ * nắng hạn, cây cối ủ rũ hết",
  },
  {
    word: "ủ rũ",
    part_of_speech: "tính từ",
    meaning:
      "buồn rầu đến mức như rũ xuống, không còn hơi sức nữa: ngồi ủ rũ ở một xó",
    example: "ngồi ủ rũ ở một xó",
  },
  {
    word: "ù té",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) vụt chạy đi rất nhanh: bọn trẻ ù té chạy",
    example: "bọn trẻ ù té chạy",
  },
  {
    word: "ú tim",
    part_of_speech: "danh từ",
    meaning: "trò chơi đi trốn, đi tìm của trẻ em: chơi trò ú tim",
    example: "chơi trò ú tim",
  },
  {
    word: "u tịch",
    part_of_speech: "tính từ",
    meaning: "(văn chương) vắng vẻ và tĩnh mịch: nơi rừng sâu u tịch",
    example: "nơi rừng sâu u tịch",
  },
  {
    word: "u u",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng âm thanh hơi ù và kéo dài liên hồi, như từ xa vang vọng lại: tiếng dế gáy u u",
    example: "tiếng dế gáy u u",
  },
  {
    word: "u tối",
    part_of_speech: "tính từ",
    meaning:
      "mờ tối, gợi lên sự buồn bã, cô quạnh: căn phòng u tối * cặp mắt u tối",
    example: "căn phòng u tối * cặp mắt u tối",
  },
  {
    word: "u tối",
    part_of_speech: "tính từ",
    meaning:
      "ngu dốt, tối tăm do bị kìm hãm: tâm trí u tối * cuộc sống u tối dưới chế độ phong kiến",
    example: "tâm trí u tối * cuộc sống u tối dưới chế độ phong kiến",
  },
  {
    word: "ú ụ",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ, hiếm) như tú ụ: bát cơm đầy ú ụ",
    example: "bát cơm đầy ú ụ",
  },
  {
    word: "ù ù",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng động mạnh, trầm và kéo dài liên tiếp thành chuỗi, như tiếng các luồng không khí phát ra khi bị cuốn đi rất nhanh: gió réo ù ù * tiếng máy bay ù ù vọng lại",
    example: "gió réo ù ù * tiếng máy bay ù ù vọng lại",
  },
  {
    word: "u trầm",
    part_of_speech: "tính từ",
    meaning: "trầm lặng và u buồn sâu lắng: âm hưởng u trầm * không khí u trầm",
    example: "âm hưởng u trầm * không khí u trầm",
  },
  {
    word: "u uẩn",
    part_of_speech: "tính từ",
    meaning:
      "sâu kín trong lòng, không bộc lộ ra (thường nói về tình cảm đau buồn): mối tình u ẩn * nỗi buồn u ẩn",
    example: "mối tình u ẩn * nỗi buồn u ẩn",
  },
  {
    word: "ù xoẹ",
    part_of_speech: "tính từ",
    meaning:
      "(thông tục) (làm) bừa đi cho xong việc mà không theo một nguyên tắc nào cả: làm ù xoẹ cho xong * tính toán ù xoẹ",
    example: "làm ù xoẹ cho xong * tính toán ù xoẹ",
  },
  {
    word: "u uất",
    part_of_speech: "tính từ",
    meaning:
      "buồn thầm kín xen lẫn bực tức, mà không sao nói ra được: tâm trạng u uất * buồn u uất",
    example: "tâm trạng u uất * buồn u uất",
  },
  {
    word: "u xơ",
    part_of_speech: "danh từ",
    meaning:
      "u lành, có dạng khối tròn, tổ chức bên trong là sợi cơ, thường có nhân: u xơ tử cung",
    example: "u xơ tử cung",
  },
  {
    word: "úa",
    part_of_speech: "động từ",
    meaning:
      "(lá cây) ngả sang màu vàng và bắt đầu héo, không còn xanh tươi nữa: rau úa * màu cỏ úa * được mùa lúa úa mùa cau (tng)",
    example: "rau úa * màu cỏ úa * được mùa lúa úa mùa cau (tng)",
  },
  {
    word: "úa",
    part_of_speech: "động từ",
    meaning:
      "trở nên có màu vàng xỉn, không còn tươi, còn sáng nữa: tấm ảnh đã úa màu",
    example: "tấm ảnh đã úa màu",
  },
  {
    word: "ùa",
    part_of_speech: "động từ",
    meaning:
      "di chuyển với số lượng nhiều cùng một lúc, một cách rất nhanh, mạnh: ánh sáng ùa vào phòng * bọn trẻ ùa ra sân chơi",
    example: "ánh sáng ùa vào phòng * bọn trẻ ùa ra sân chơi",
  },
  {
    word: "ùa",
    part_of_speech: "phụ từ",
    meaning: "(khẩu ngữ, hiếm) như ào: nhảy ùa xuống nước",
    example: "nhảy ùa xuống nước",
  },
  {
    word: "ủa",
    part_of_speech: "cảm từ",
    meaning:
      "(phương ngữ) tiếng thốt ra biểu lộ sự ngạc nhiên, sửng sốt: ủa, sao nhanh quá vậy?",
    example: "ủa, sao nhanh quá vậy?",
  },
  {
    word: "uẩn súc",
    part_of_speech: "tính từ",
    meaning: "(cũ) (học thức) sâu rộng, uyên bác: một học giả uẩn súc",
    example: "một học giả uẩn súc",
  },
  {
    word: "uẩn khúc",
    part_of_speech: "danh từ",
    meaning:
      "điều rắc rối, éo le còn giấu kín, chưa được bày tỏ hoặc làm sáng tỏ ra: làm rõ những uẩn khúc trong vụ án",
    example: "làm rõ những uẩn khúc trong vụ án",
  },
  {
    word: "uất",
    part_of_speech: "động từ",
    meaning:
      "tức giận lắm, đến mức cảm thấy không còn chịu nổi nữa, nhưng vẫn phải cố nén lại trong lòng: uất lên tận cổ * uất quá, nổi xung lên",
    example: "uất lên tận cổ * uất quá, nổi xung lên",
  },
  {
    word: "uất hận",
    part_of_speech: "danh từ",
    meaning:
      "nỗi căm giận sâu sắc chất chứa âm ỉ trong lòng: lòng đầy uất hận * ôm niềm uất hận",
    example: "lòng đầy uất hận * ôm niềm uất hận",
  },
  {
    word: "uất hận",
    part_of_speech: "động từ",
    meaning:
      "căm giận sâu sắc trong lòng: uất hận kẻ phụ bạc * mặt đỏ bừng lên vì xấu hổ và uất hận",
    example: "uất hận kẻ phụ bạc * mặt đỏ bừng lên vì xấu hổ và uất hận",
  },
  {
    word: "uất nghẹn",
    part_of_speech: "động từ",
    meaning:
      "uất lắm, đến mức cảm thấy như nghẹn lên đến cổ, nhưng vẫn phải cố kìm nén lại trong lòng: giọng nói uất nghẹn",
    example: "giọng nói uất nghẹn",
  },
  {
    word: "ubnd",
    part_of_speech: "danh từ",
    meaning:
      "cơ quan chấp hành có nhiệm vụ tổ chức thực hiện các nghị quyết của hội đồng nhân dân, quản lí công tác của nhà nước ở địa phương: uỷ ban nhân dân xã",
    example: "uỷ ban nhân dân xã",
  },
  {
    word: "uế khí",
    part_of_speech: "danh từ",
    meaning: "hơi có mùi hôi thối bốc lên từ nơi bẩn thỉu: bãi rác đầy uế khí",
    example: "bãi rác đầy uế khí",
  },
  {
    word: "ục",
    part_of_speech: "động từ",
    meaning: "(thông tục) đấm mạnh: ục vào ngực * ục cho mấy quả",
    example: "ục vào ngực * ục cho mấy quả",
  },
  {
    word: "ục",
    part_of_speech: "động từ",
    meaning: "đánh nhau (bằng tay chân): hai bên đang ục nhau",
    example: "hai bên đang ục nhau",
  },
  {
    word: "ục",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng trầm đục như tiếng của một vật gì nổ hay vỡ bung ra: đổ ục rượu ra bát * bụng sôi ục ục",
    example: "đổ ục rượu ra bát * bụng sôi ục ục",
  },
  {
    word: "ục",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) (vật đựng hoặc chắn nước) bục mạnh ra, vỡ bung ra: chiếc xô ục đáy * bị ục mất một quãng đê",
    example: "chiếc xô ục đáy * bị ục mất một quãng đê",
  },
  {
    word: "ục ịch",
    part_of_speech: "tính từ",
    meaning:
      "béo quá, trông nặng nề, khó khăn khi vận động: dáng người ục ịch * béo ục ịch",
    example: "dáng người ục ịch * béo ục ịch",
  },
  {
    word: "ục ịch",
    part_of_speech: "tính từ",
    meaning: "(dáng đi lại) nặng nề, khó khăn: béo quá, đi lại ục ịch",
    example: "béo quá, đi lại ục ịch",
  },
  {
    word: "uất ức",
    part_of_speech: "động từ",
    meaning: "uất lắm mà đành chịu, không làm gì được: khóc nức lên vì uất ức",
    example: "khóc nức lên vì uất ức",
  },
  {
    word: "uể oải",
    part_of_speech: "tính từ",
    meaning:
      "(hoạt động) chậm chạp, thiếu nhanh nhẹn, hăng hái (do mệt mỏi hoặc không có hứng thú): chân tay uể oải * tiếng rao hàng uể oải * uể oải đứng dậy",
    example: "chân tay uể oải * tiếng rao hàng uể oải * uể oải đứng dậy",
  },
  {
    word: "úi",
    part_of_speech: "động từ",
    meaning:
      "(tôm, cá) nổi lờ đờ trên mặt nước (vì một lí do nào đó): tôm tép úi đầy mặt ao * nước bẩn, cá úi hàng loạt",
    example: "tôm tép úi đầy mặt ao * nước bẩn, cá úi hàng loạt",
  },
  {
    word: "úi",
    part_of_speech: "cảm từ",
    meaning: "như ối: úi, đau quá!",
    example: "úi, đau quá!",
  },
  {
    word: "uế tạp",
    part_of_speech: "tính từ",
    meaning:
      "dơ bẩn, ở nơi đáng lẽ phải được giữ sạch sẽ, tinh khiết: làm uế tạp nơi thờ cúng",
    example: "làm uế tạp nơi thờ cúng",
  },
  {
    word: "ui ui",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) (tiết trời) không nắng hoặc nắng dịu, nhưng oi oi khó chịu: nắng ui ui * trời ui ui như muốn mưa",
    example: "nắng ui ui * trời ui ui như muốn mưa",
  },
  {
    word: "úi chà",
    part_of_speech: "cảm từ",
    meaning:
      "(khẩu ngữ) tiếng thốt ra biểu thị sự ngạc nhiên: úi chà, đẹp gớm nhỉ!",
    example: "úi chà, đẹp gớm nhỉ!",
  },
  {
    word: "úm",
    part_of_speech: "động từ",
    meaning: "(hiếm) đọc thần chú làm phép: thầy phù thuỷ úm",
    example: "thầy phù thuỷ úm",
  },
  {
    word: "úm",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) bịp, đánh lừa người không biết: thôi, đừng úm nhau nữa!",
    example: "thôi, đừng úm nhau nữa!",
  },
  {
    word: "ủi",
    part_of_speech: "động từ",
    meaning:
      "đẩy đất đá nổi trên mặt đất đi nơi khác để san lấp cho phẳng: máy ủi * xe ủi * ủi đất san nền",
    example: "máy ủi * xe ủi * ủi đất san nền",
  },
  {
    word: "ủi",
    part_of_speech: "động từ",
    meaning: "(Nam) là (quần áo): ủi quần áo cho thẳng",
    example: "ủi quần áo cho thẳng",
  },
  {
    word: "úi dà",
    part_of_speech: "cảm từ",
    meaning: "(khẩu ngữ) như ôi dào: úi dà, có mà đến đêm mới xong!",
    example: "úi dà, có mà đến đêm mới xong!",
  },
  {
    word: "úi dào",
    part_of_speech: "cảm từ",
    meaning: "(khẩu ngữ) như ôi dào: úi dào, vẽ chuyện!",
    example: "úi dào, vẽ chuyện!",
  },
  {
    word: "um",
    part_of_speech: "tính từ",
    meaning:
      "(khói, mùi, bóng tối) dày đặc và lan ra trên một khoảng rộng: khói bốc um lên * thối um * căn phòng tối um",
    example: "khói bốc um lên * thối um * căn phòng tối um",
  },
  {
    word: "um",
    part_of_speech: "tính từ",
    meaning: "(cây cối) nhiều và dày, rậm rạp: cỏ mọc tốt um * bãi mía xanh um",
    example: "cỏ mọc tốt um * bãi mía xanh um",
  },
  {
    word: "um",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như om: hét um nhà",
    example: "hét um nhà",
  },
  {
    word: "ùm",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng phát ra nghe trầm, giống như tiếng của một vật nặng rơi xuống chỗ nước sâu: nhảy ùm xuống ao * hòn đá lăn đánh ùm xuống nước * tiếng dội nước ùm ùm",
    example:
      "nhảy ùm xuống ao * hòn đá lăn đánh ùm xuống nước * tiếng dội nước ùm ùm",
  },
  {
    word: "úm ba la",
    part_of_speech: "",
    meaning:
      "những tiếng dùng trong câu thần chú của thầy phù thuỷ; thường dùng như những tiếng làm phép cho một điều lạ nào đó xảy ra, với ý đùa vui: úm ba la, búp bê ở đâu hiện ra!",
    example: "úm ba la, búp bê ở đâu hiện ra!",
  },
  {
    word: "ùn",
    part_of_speech: "động từ",
    meaning:
      "đùn lên thành lớp dày đặc: khói ùn lên * mặt nước ùn bọt * mây đen ùn lên ở phía chân trời",
    example: "khói ùn lên * mặt nước ùn bọt * mây đen ùn lên ở phía chân trời",
  },
  {
    word: "ùn",
    part_of_speech: "động từ",
    meaning:
      "dồn, đọng lại thành khối lớn: rác ùn lên thành đống * dòng người ùn lại",
    example: "rác ùn lên thành đống * dòng người ùn lại",
  },
  {
    word: "ùn",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) đùn đẩy cho người khác: ùn việc cho nhau",
    example: "ùn việc cho nhau",
  },
  {
    word: "ùn tắc",
    part_of_speech: "động từ",
    meaning:
      "ùn lại làm tắc nghẽn giao thông: ùn tắc giao thông * đường sá chật hẹp, dễ gây ùn tắc",
    example: "ùn tắc giao thông * đường sá chật hẹp, dễ gây ùn tắc",
  },
  {
    word: "ủn ỉn",
    part_of_speech: "động từ",
    meaning: "từ mô phỏng tiếng lợn kêu nhỏ: đàn lợn ủn ỉn đòi ăn",
    example: "đàn lợn ủn ỉn đòi ăn",
  },
  {
    word: "um tùm",
    part_of_speech: "tính từ",
    meaning: "(cây cối) rậm rạp, dày đặc: cây cối um tùm",
    example: "cây cối um tùm",
  },
  {
    word: "ủng",
    part_of_speech: "danh từ",
    meaning:
      "giày cao su, cổ cao đến đầu gối, dùng để đi trong nước, lội bùn, v.v.: đi ủng để lội nước",
    example: "đi ủng để lội nước",
  },
  {
    word: "ủng",
    part_of_speech: "tính từ",
    meaning:
      "mềm nhũn ra và có mùi khó ngửi, do chín quá hoặc do để quá lâu: cam ủng * chuối chín ủng",
    example: "cam ủng * chuối chín ủng",
  },
  {
    word: "ung",
    part_of_speech: "danh từ",
    meaning:
      "nhọt lớn, gây đau nhiều, thường nguy hiểm cho tính mạng: lên ung * cái sảy nảy cái ung (tng)",
    example: "lên ung * cái sảy nảy cái ung (tng)",
  },
  {
    word: "ung",
    part_of_speech: "tính từ",
    meaning: "(trứng gà, vịt) bị hỏng, bị thối: trứng ung",
    example: "trứng ung",
  },
  {
    word: "ùn ùn",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả sự tuôn ra, kéo đến nhiều và liên tiếp, với mật độ dày đặc: khói ùn ùn bốc cao * mây đen ùn ùn kéo đến * giàu lên ùn ùn",
    example: "khói ùn ùn bốc cao * mây đen ùn ùn kéo đến * giàu lên ùn ùn",
  },
  {
    word: "úng",
    part_of_speech: "động từ",
    meaning: "úng thuỷ (nói tắt): ruộng bị úng * chiêm khê mùa úng (tng)",
    example: "ruộng bị úng * chiêm khê mùa úng (tng)",
  },
  {
    word: "úng ngập",
    part_of_speech: "động từ",
    meaning:
      "úng thuỷ cả một khu vực, không tiêu thoát được: ruộng trũng nên thường xuyên úng ngập",
    example: "ruộng trũng nên thường xuyên úng ngập",
  },
  {
    word: "ung nhọt",
    part_of_speech: "danh từ",
    meaning: "nhọt lớn (nói khái quát): uống thuốc làm tiêu ung nhọt",
    example: "uống thuốc làm tiêu ung nhọt",
  },
  {
    word: "ung nhọt",
    part_of_speech: "danh từ",
    meaning:
      "ví hiện tượng xấu xa, thối nát từ bên trong, gây tác hại lớn cho xã hội: nạn tham nhũng là ung nhọt của xã hội",
    example: "nạn tham nhũng là ung nhọt của xã hội",
  },
  {
    word: "ung độc",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như ung nhọt: người đầy ung độc",
    example: "người đầy ung độc",
  },
  {
    word: "ủng hộ",
    part_of_speech: "động từ",
    meaning:
      "tỏ thái độ đồng tình bằng lời nói hoặc bằng hành động bênh vực, giúp đỡ: ủng hộ cuộc chiến tranh chính nghĩa * lên tiếng ủng hộ",
    example: "ủng hộ cuộc chiến tranh chính nghĩa * lên tiếng ủng hộ",
  },
  {
    word: "ủng hộ",
    part_of_speech: "động từ",
    meaning:
      "giúp đỡ bằng vật chất, tinh thần nhằm chia sẻ những khó nhọc, mất mát, đau thương: ủng hộ đồng bào bị lũ lụt * quyên tiền ủng hộ nạn nhân chất độc màu da cam",
    example:
      "ủng hộ đồng bào bị lũ lụt * quyên tiền ủng hộ nạn nhân chất độc màu da cam",
  },
  {
    word: "ung dung",
    part_of_speech: "tính từ",
    meaning:
      "có dáng điệu, cử chỉ tỏ ra bình tĩnh, thư thái, không có gì lo lắng, hoặc vội vã: ung dung tự tại * dáng điệu ung dung",
    example: "ung dung tự tại * dáng điệu ung dung",
  },
  {
    word: "ung dung",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) thoải mái, không phải vất vả lo lắng gì về điều kiện vật chất: sống ung dung",
    example: "sống ung dung",
  },
  {
    word: "ung bướu",
    part_of_speech: "danh từ",
    meaning:
      "ung và bướu nổi trên cơ thể (nói khái quát): nổi ung bướu * chữa trị ung bướu",
    example: "nổi ung bướu * chữa trị ung bướu",
  },
  {
    word: "ùng oàng",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng nổ rền vang, đều đặn và liên tiếp của bom đạn: tiếng đại bác bắn ùng oàng",
    example: "tiếng đại bác bắn ùng oàng",
  },
  {
    word: "ung thư",
    part_of_speech: "danh từ",
    meaning:
      "u ác tính, thường có di căn, rất khó tiệt trừ, dễ gây tử vong: ung thư gan * tế bào ung thư",
    example: "ung thư gan * tế bào ung thư",
  },
  {
    word: "ùng ục",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng âm thanh trầm đục, phát ra liên tiếp như tiếng nước sôi mạnh hoặc bị khuấy động mạnh trong vật chứa kín: nước sôi ùng ục",
    example: "nước sôi ùng ục",
  },
  {
    word: "úng thuỷ",
    part_of_speech: "động từ",
    meaning:
      "(hiện tượng) ứ đọng nhiều nước ở nơi đất trũng: cánh đồng bị úng thuỷ * cây cối chết vì úng thuỷ",
    example: "cánh đồng bị úng thuỷ * cây cối chết vì úng thuỷ",
  },
  {
    word: "uốn câu",
    part_of_speech: "động từ",
    meaning:
      "(bông lúa) cong trĩu xuống như cần câu do bắt đầu đọng sữa để kết hạt: lúa đã uốn câu",
    example: "lúa đã uốn câu",
  },
  {
    word: "uốn khúc",
    part_of_speech: "động từ",
    meaning:
      "uốn cong thành từng khúc, từng đoạn: dòng sông uốn khúc * con đường quanh co uốn khúc",
    example: "dòng sông uốn khúc * con đường quanh co uốn khúc",
  },
  {
    word: "ung ủng",
    part_of_speech: "tính từ",
    meaning: "hơi ủng: quả cam đã ung ủng",
    example: "quả cam đã ung ủng",
  },
  {
    word: "uốn dẻo",
    part_of_speech: "động từ",
    meaning:
      "làm động tác uốn mình một cách mềm mại, khéo léo, trông đẹp mắt: tiết mục xiếc uốn dẻo",
    example: "tiết mục xiếc uốn dẻo",
  },
  {
    word: "uốn éo",
    part_of_speech: "động từ",
    meaning:
      "cố ý làm cho ra vẻ mềm mại, dịu dàng, nhưng hơi quá đáng, trông không tự nhiên: đi đứng uốn éo * giọng nói uốn éo",
    example: "đi đứng uốn éo * giọng nói uốn éo",
  },
  {
    word: "uốn éo",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nũng nịu để được chiều chuộng: thằng bé uốn éo mẹ * phụ nữ hay uốn éo",
    example: "thằng bé uốn éo mẹ * phụ nữ hay uốn éo",
  },
  {
    word: "uốn",
    part_of_speech: "động từ",
    meaning:
      "làm cho một vật dài nào đó có hình dáng cong theo ý muốn: uốn lưỡi câu * uốn cây cảnh * tóc uốn quăn * dòng sông uốn quanh làng",
    example:
      "uốn lưỡi câu * uốn cây cảnh * tóc uốn quăn * dòng sông uốn quanh làng",
  },
  {
    word: "uốn",
    part_of_speech: "động từ",
    meaning: "dạy dỗ, chỉ bảo, đưa dần vào khuôn phép: uốn con từ khi còn nhỏ",
    example: "uốn con từ khi còn nhỏ",
  },
  {
    word: "uốn",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) làm nũng, đòi được chiều chuộng (thường nói về trẻ con): thằng bé được chiều nên uốn lắm",
    example: "thằng bé được chiều nên uốn lắm",
  },
  {
    word: "uốn lượn",
    part_of_speech: "động từ",
    meaning:
      "uốn thành đường cong và lượn liên tiếp với vẻ mềm mại (nói khái quát): con đường uốn lượn quanh những ngọn đồi",
    example: "con đường uốn lượn quanh những ngọn đồi",
  },
  {
    word: "uốn ván",
    part_of_speech: "danh từ",
    meaning:
      "bệnh cấp tính do một loại vi khuẩn thâm nhập vào cơ thể qua vết thương, gây nên những cơn co cứng, khó thở, thường dẫn đến tử vong: vi trùng uốn ván * tiêm phòng uốn ván",
    example: "vi trùng uốn ván * tiêm phòng uốn ván",
  },
  {
    word: "uổng",
    part_of_speech: "động từ",
    meaning:
      "để mất đi một cách đáng tiếc do đã không được dùng một cách có ích: uổng công chờ đợi * chết uổng mạng",
    example: "uổng công chờ đợi * chết uổng mạng",
  },
  {
    word: "uổng phí",
    part_of_speech: "động từ",
    meaning:
      "bỏ phí mất đi, chẳng được ích lợi gì (nói khái quát): uổng phí thì giờ * làm thế chỉ uổng phí tiền bạc",
    example: "uổng phí thì giờ * làm thế chỉ uổng phí tiền bạc",
  },
  {
    word: "uốn nắn",
    part_of_speech: "động từ",
    meaning:
      "nắn lại cho có hình dáng như ý muốn (nói khái quát): uốn nắn cây cảnh * uốn nắn bờ ruộng cho thẳng",
    example: "uốn nắn cây cảnh * uốn nắn bờ ruộng cho thẳng",
  },
  {
    word: "uốn nắn",
    part_of_speech: "động từ",
    meaning:
      "hướng dẫn, chỉ bảo để sửa chữa lại cho đúng, cho tốt: uốn nắn từng động tác * uốn nắn cho con cái nên người",
    example: "uốn nắn từng động tác * uốn nắn cho con cái nên người",
  },
  {
    word: "uốn tóc",
    part_of_speech: "động từ",
    meaning: "làm cho tóc quăn và giữ nếp theo một kiểu nhất định: thợ uốn tóc",
    example: "thợ uốn tóc",
  },
  {
    word: "uống",
    part_of_speech: "động từ",
    meaning: "đưa chất lỏng vào miệng rồi nuốt: uống thuốc * uống rượu",
    example: "uống thuốc * uống rượu",
  },
  {
    word: "úp",
    part_of_speech: "động từ",
    meaning:
      "(từ thế để ngửa) lật xuống thành sấp hoặc để phía mặt quay xuống dưới hay áp sát vào vật khác: úp bát vào chạn * thuyền bị lật úp * đứng úp mặt vào tường",
    example: "úp bát vào chạn * thuyền bị lật úp * đứng úp mặt vào tường",
  },
  {
    word: "úp",
    part_of_speech: "động từ",
    meaning:
      "che, đậy lên trên bằng một vật trũng lòng: úp lồng bàn lên mâm cơm * nồi tròn thì úp vung tròn (tng)",
    example: "úp lồng bàn lên mâm cơm * nồi tròn thì úp vung tròn (tng)",
  },
  {
    word: "úp",
    part_of_speech: "động từ",
    meaning:
      "chụp bắt một cách nhanh gọn, bất ngờ: dùng nơm úp cá * lấy thúng úp voi (tng)",
    example: "dùng nơm úp cá * lấy thúng úp voi (tng)",
  },
  {
    word: "ụp",
    part_of_speech: "động từ",
    meaning:
      "lật đổ xuống cả khối một cách nhanh, mạnh và đột ngột: căn nhà bị đổ ụp * bóng tối ụp xuống * tai hoạ ụp xuống đầu (b)",
    example: "căn nhà bị đổ ụp * bóng tối ụp xuống * tai hoạ ụp xuống đầu (b)",
  },
  {
    word: "úp mở",
    part_of_speech: "động từ",
    meaning:
      "nói mập mờ, nửa muốn che giấu, nửa muốn để lộ ra: nói thẳng, không cần úp mở",
    example: "nói thẳng, không cần úp mở",
  },
  {
    word: "úp súp",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như lụp xụp: túp lều úp súp",
    example: "túp lều úp súp",
  },
  {
    word: "úp thìa",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) (tư thế nằm, ngồi) áp sát ngực vào lưng người khác: ngồi úp thìa * nằm úp thìa cho khỏi lạnh",
    example: "ngồi úp thìa * nằm úp thìa cho khỏi lạnh",
  },
  {
    word: "út ít",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) như út (hàm ý âu yếm): cậu con trai út ít * đứa cháu út ít trong nhà",
    example: "cậu con trai út ít * đứa cháu út ít trong nhà",
  },
  {
    word: "uý",
    part_of_speech: "danh từ",
    meaning: "cấp quân hàm dưới cấp tá: sĩ quan cấp uý",
    example: "sĩ quan cấp uý",
  },
  {
    word: "ụt ịt",
    part_of_speech: "động từ",
    meaning:
      "từ mô phỏng tiếng lợn kêu nhỏ và ngắn, liên tiếp: đàn lợn ụt ịt đòi ăn",
    example: "đàn lợn ụt ịt đòi ăn",
  },
  {
    word: "ụt ịt",
    part_of_speech: "tính từ",
    meaning: "(hiếm) (người) béo và lùn: người béo ụt ịt",
    example: "người béo ụt ịt",
  },
  {
    word: "uy",
    part_of_speech: "danh từ",
    meaning: "(cũ, văn chương)",
    example:
      'Chư hầu mến đức, nép uy, Xa thời tiến cống, gần thì làm tôi." (TNNL)',
  },
  {
    word: "uỷ ban",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức gồm một nhóm người được bầu hoặc được cử ra để làm một nhiệm vụ quan trọng nào đó: uỷ ban khởi nghĩa",
    example: "uỷ ban khởi nghĩa",
  },
  {
    word: "uỷ ban",
    part_of_speech: "danh từ",
    meaning:
      "cơ quan nhà nước đứng đầu là một chủ nhiệm lãnh đạo và quản lí một ngành công tác nào đó: uỷ ban thanh tra * uỷ ban thường vụ quốc hội",
    example: "uỷ ban thanh tra * uỷ ban thường vụ quốc hội",
  },
  {
    word: "uỷ ban",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) uỷ ban nhân dân (nói tắt): uỷ ban xã * trụ sở uỷ ban",
    example: "uỷ ban xã * trụ sở uỷ ban",
  },
  {
    word: "út",
    part_of_speech: "tính từ",
    meaning:
      "sau cùng hoặc nhỏ tuổi nhất trong hàng các con hoặc em trong nhà: con út * em út * giàu con út, khó con út (tng)",
    example: "con út * em út * giàu con út, khó con út (tng)",
  },
  {
    word: "uy hiếp",
    part_of_speech: "động từ",
    meaning:
      "dùng uy lực đe doạ, ép buộc làm cho phải khiếp sợ mà khuất phục: uy hiếp tinh thần",
    example: "uy hiếp tinh thần",
  },
  {
    word: "uỷ ban nhân dân",
    part_of_speech: "danh từ",
    meaning:
      "cơ quan chấp hành có nhiệm vụ tổ chức thực hiện các nghị quyết của hội đồng nhân dân, quản lí công tác của nhà nước ở địa phương: uỷ ban nhân dân xã",
    example: "uỷ ban nhân dân xã",
  },
  {
    word: "uy danh",
    part_of_speech: "danh từ",
    meaning: "uy quyền và danh tiếng: uy danh lừng lẫy",
    example: "uy danh lừng lẫy",
  },
  {
    word: "uý lạo",
    part_of_speech: "động từ",
    meaning:
      "thăm hỏi, an ủi (bằng lời nói, vật phẩm) những người vì sự nghiệp chung mà chịu mất mát hoặc vất vả, khó nhọc: uý lạo thương binh",
    example: "uý lạo thương binh",
  },
  {
    word: "uỷ lạo",
    part_of_speech: "động từ",
    meaning:
      "thăm hỏi, an ủi (bằng lời nói, vật phẩm) những người vì sự nghiệp chung mà chịu mất mát hoặc vất vả, khó nhọc: uý lạo thương binh",
    example: "uý lạo thương binh",
  },
  {
    word: "uỷ ban quân quản",
    part_of_speech: "danh từ",
    meaning:
      "cơ quan có tính chất quân sự, lập ra lâm thời để điều hành mọi công việc ở những nơi quan trọng vừa mới chiếm được của đối phương: thành lập uỷ ban quân quản",
    example: "thành lập uỷ ban quân quản",
  },
  {
    word: "uy linh",
    part_of_speech: "danh từ",
    meaning:
      'sức mạnh thiêng liêng: uy linh của trời đất * "Bỗng đâu lại gặp một người, Hơn đời trí dũng, nghiêng trời uy linh." (TKiều)',
    example:
      'uy linh của trời đất * "Bỗng đâu lại gặp một người, Hơn đời trí dũng, nghiêng trời uy linh." (TKiều)',
  },
  {
    word: "uỷ mị",
    part_of_speech: "tính từ",
    meaning:
      "có những biểu hiện yếu đuối về tình cảm, tinh thần: tình cảm uỷ mị * lời thơ uỷ mị",
    example: "tình cảm uỷ mị * lời thơ uỷ mị",
  },
  {
    word: "uy nghi",
    part_of_speech: "tính từ",
    meaning:
      "có dáng vẻ chững chạc, bề thế, gợi sự tôn kính: ngôi đền uy nghi * diện mạo uy nghi",
    example: "ngôi đền uy nghi * diện mạo uy nghi",
  },
  {
    word: "uỷ mỵ",
    part_of_speech: "tính từ",
    meaning:
      "có những biểu hiện yếu đuối về tình cảm, tinh thần: tình cảm uỷ mị * lời thơ uỷ mị",
    example: "tình cảm uỷ mị * lời thơ uỷ mị",
  },
  {
    word: "uy phong",
    part_of_speech: "tính từ",
    meaning:
      "có dáng vẻ thể hiện một uy lực mạnh mẽ, khiến cho người khác phải kính nể: dáng vẻ oai phong * oai phong lẫm liệt",
    example: "dáng vẻ oai phong * oai phong lẫm liệt",
  },
  {
    word: "uy nghiêm",
    part_of_speech: "tính từ",
    meaning:
      "có dáng vẻ trang nghiêm, gợi sự tôn kính: không khí uy nghiêm của buổi lễ",
    example: "không khí uy nghiêm của buổi lễ",
  },
  {
    word: "uy lực",
    part_of_speech: "danh từ",
    meaning:
      "sức mạnh to lớn khiến cho phải nể sợ, phải khuất phục: uy lực của đồng tiền * giọng nói đầy uy lực",
    example: "uy lực của đồng tiền * giọng nói đầy uy lực",
  },
  {
    word: "uỷ quyền",
    part_of_speech: "động từ",
    meaning:
      "giao một số quyền có tính chất pháp lí của mình cho người khác sử dụng: giấy uỷ quyền * huyện uỷ quyền cho xã giải quyết vụ việc",
    example: "giấy uỷ quyền * huyện uỷ quyền cho xã giải quyết vụ việc",
  },
  {
    word: "uỷ nhiệm",
    part_of_speech: "động từ",
    meaning:
      "giao cho người khác làm thay một nhiệm vụ thuộc trách nhiệm của mình: được uỷ nhiệm điều hành cuộc họp * giấy uỷ nhiệm sử dụng đất",
    example: "được uỷ nhiệm điều hành cuộc họp * giấy uỷ nhiệm sử dụng đất",
  },
  {
    word: "uy quyền",
    part_of_speech: "danh từ",
    meaning: "quyền lực khiến người ta phải nể sợ: uy quyền của người lãnh đạo",
    example: "uy quyền của người lãnh đạo",
  },
  {
    word: "uỷ thác",
    part_of_speech: "động từ",
    meaning:
      "giao phó việc quan trọng cho người tin cậy làm thay mình: uỷ thác việc điều hành công ti cho trợ lí",
    example: "uỷ thác việc điều hành công ti cho trợ lí",
  },
  {
    word: "uy thế",
    part_of_speech: "danh từ",
    meaning:
      "thế mạnh do quyền lực tạo nên, khiến người ta phải e dè, nể sợ: uy thế quân sự * gây dựng uy thế",
    example: "uy thế quân sự * gây dựng uy thế",
  },
  {
    word: "uỷ nhiệm thư",
    part_of_speech: "danh từ",
    meaning: "(trang trọng) thư uỷ nhiệm: trình uỷ nhiệm thư",
    example: "trình uỷ nhiệm thư",
  },
  {
    word: "uy tín",
    part_of_speech: "danh từ",
    meaning:
      "sự tín nhiệm và mến phục được mọi người công nhận: uy tín nghề nghiệp * làm ăn có uy tín * mất uy tín",
    example: "uy tín nghề nghiệp * làm ăn có uy tín * mất uy tín",
  },
  {
    word: "uỷ trị",
    part_of_speech: "động từ",
    meaning:
      "giao cho một nước thắng trận quyền cai trị có thời hạn một vùng lãnh thổ nào đó vốn là thuộc địa của một nước bại trận (một hình thức quản lí thuộc địa theo quyết định của Hội quốc liên sau Đại chiến thế giới lần thứ nhất): quyền uỷ trị * chế độ uỷ trị",
    example: "quyền uỷ trị * chế độ uỷ trị",
  },
  {
    word: "uy vũ",
    part_of_speech: "danh từ",
    meaning: "sức mạnh của vũ lực, quyền lực: không khuất phục trước uy vũ",
    example: "không khuất phục trước uy vũ",
  },
  {
    word: "uỷ viên",
    part_of_speech: "danh từ",
    meaning:
      "thành viên của một ban hay một uỷ ban: uỷ viên bộ chính trị * uỷ viên ban chấp hành",
    example: "uỷ viên bộ chính trị * uỷ viên ban chấp hành",
  },
  {
    word: "uyển ngữ",
    part_of_speech: "danh từ",
    meaning:
      'phương thức nói giảm nhẹ, thay cho lối nói có thể bị coi là sỗ sàng dễ làm xúc phạm, làm khó chịu: Nói "khuất núi" thay cho "chết" là cách dùng uyển ngữ.',
    example: 'Nói "khuất núi" thay cho "chết" là cách dùng uyển ngữ.',
  },
  {
    word: "uyển chuyển",
    part_of_speech: "tính từ",
    meaning:
      "có dáng điệu, đường nét mềm mại, gây cảm giác dịu dàng, ưa thích: dáng đi uyển chuyển * đường nét uyển chuyển",
    example: "dáng đi uyển chuyển * đường nét uyển chuyển",
  },
  {
    word: "uyển chuyển",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) mềm dẻo, linh hoạt, không cứng nhắc, máy móc: lối quản lí cứng nhắc, thiếu uyển chuyển",
    example: "lối quản lí cứng nhắc, thiếu uyển chuyển",
  },
  {
    word: "uỵch",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng động to, trầm và gọn giống như tiếng vật nặng rơi xuống đất: ngã đánh uỵch * từ trên giường, nhảy uỵch xuống đất",
    example: "ngã đánh uỵch * từ trên giường, nhảy uỵch xuống đất",
  },
  {
    word: "uỵch",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) đánh mạnh bằng quả đấm hoặc khuỷu tay: uỵch cho một trận * hai thằng đang uỵch nhau",
    example: "uỵch cho một trận * hai thằng đang uỵch nhau",
  },
  {
    word: "uyên thâm",
    part_of_speech: "tính từ",
    meaning:
      "có kiến thức rất sâu về một lĩnh vực chuyên môn nào đó: học vấn uyên thâm",
    example: "học vấn uyên thâm",
  },
  {
    word: "uyên bác",
    part_of_speech: "tính từ",
    meaning: "có kiến thức sâu rộng: kiến thức uyên bác * một học giả uyên bác",
    example: "kiến thức uyên bác * một học giả uyên bác",
  },
  {
    word: "uyên",
    part_of_speech: "danh từ",
    meaning:
      '(văn chương, hiếm) uyên ương (nói tắt): rẽ thuý chia uyên * "Lâm Tri từ thuở uyên bay, Buồng không thương kẻ tháng ngày chiếc thân." (TKiều)',
    example:
      'rẽ thuý chia uyên * "Lâm Tri từ thuở uyên bay, Buồng không thương kẻ tháng ngày chiếc thân." (TKiều)',
  },
  {
    word: "ư",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý hỏi, tỏ ra hơi lấy làm lạ hoặc còn băn khoăn: thật ư? * mai đi rồi ư? * chỉ có thế thôi ư?",
    example: "thật ư? * mai đi rồi ư? * chỉ có thế thôi ư?",
  },
  {
    word: "ư",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị thái độ ngạc nhiên trước điều mình có phần không ngờ tới, có ý như muốn hỏi lại người đối thoại hoặc tự hỏi lại mình: anh đấy ư? * giờ mà mọi người vẫn ngồi cả đây ư? * nghèo đến thế kia ư?",
    example:
      "anh đấy ư? * giờ mà mọi người vẫn ngồi cả đây ư? * nghèo đến thế kia ư?",
  },
  {
    word: "ư",
    part_of_speech: "trợ từ",
    meaning:
      "(khẩu ngữ) từ biểu thị thái độ không được bằng lòng về điều gì đó, có ý như muốn hỏi lại người đối thoại để người đó tự suy nghĩ lấy: cứ bôi việc ra thế này ư? * học hành như thế ư?",
    example: "cứ bôi việc ra thế này ư? * học hành như thế ư?",
  },
  {
    word: "ư",
    part_of_speech: "trợ từ",
    meaning:
      "(khẩu ngữ) từ biểu thị ý nhấn mạnh mức độ rất cao, như không còn có thể hơn được nữa: việc tối ư quan trọng * phong thái rất ư là nghệ sĩ",
    example: "việc tối ư quan trọng * phong thái rất ư là nghệ sĩ",
  },
  {
    word: "uyên ương",
    part_of_speech: "danh từ",
    meaning:
      "chim trời cùng họ với vịt, sống ở nước, con đực (uyên) và con cái (ương) sống không bao giờ rời nhau; thường dùng trong văn chương để ví cặp vợ chồng đẹp đôi, gắn bó: đôi uyên ương",
    example: "đôi uyên ương",
  },
  {
    word: "uỳnh uỵch",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng động to, trầm và liên tiếp như nhiều tiếng vật nặng rơi xuống đất: chạy uỳnh uỵch",
    example: "chạy uỳnh uỵch",
  },
  {
    word: "ứ",
    part_of_speech: "động từ",
    meaning:
      "dồn từ nhiều nơi lại một chỗ, không lưu thông được: cống tắc, nước ứ lại * hàng hoá ứ trong kho",
    example: "cống tắc, nước ứ lại * hàng hoá ứ trong kho",
  },
  {
    word: "ứ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nhiều, đầy đến mức không còn có chỗ nào chứa thêm được nữa: chiếc xe ứ khách * ăn mãi đến phát ứ",
    example: "chiếc xe ứ khách * ăn mãi đến phát ứ",
  },
  {
    word: "ứ",
    part_of_speech: "động từ",
    meaning: "(hiếm) như ứa: nước mắt ứ ra",
    example: "nước mắt ứ ra",
  },
  {
    word: "ứ",
    part_of_speech: "cảm từ",
    meaning:
      "(khẩu ngữ) tiếng thốt ra tỏ ý không bằng lòng, hay phản đối nhẹ nhàng với ý hơi nũng nịu: ứ, em không đi * ứ, con ở đây với ba cơ?",
    example: "ứ, em không đi * ứ, con ở đây với ba cơ?",
  },
  {
    word: "ứ",
    part_of_speech: "phụ từ",
    meaning:
      "không (theo cách nói của trẻ em với ý hơi nũng nịu): ứ phải * ứ thèm * ứ cho chị đi cùng đâu",
    example: "ứ phải * ứ thèm * ứ cho chị đi cùng đâu",
  },
  {
    word: "ứ đọng",
    part_of_speech: "động từ",
    meaning:
      "dồn tắc lâu tại một chỗ (nói khái quát): nước mưa ứ đọng gây ngập úng * giải quyết các đơn từ ứ đọng từ năm trước",
    example:
      "nước mưa ứ đọng gây ngập úng * giải quyết các đơn từ ứ đọng từ năm trước",
  },
  {
    word: "ừ ào",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) ừ đại đi cho qua chuyện, không để ý lắm: nói gì hắn cũng ừ ào * ừ ào cho qua chuyện",
    example: "nói gì hắn cũng ừ ào * ừ ào cho qua chuyện",
  },
  {
    word: "ứ hơi",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) quá sức chịu đựng, không chịu đựng nổi được nữa: mệt ứ hơi",
    example: "mệt ứ hơi",
  },
  {
    word: "ứ tắc",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) ứ lại, làm cho tắc, không lưu thông được: cống bị ứ tắc * giờ cao điểm, đường sá ứ tắc",
    example: "cống bị ứ tắc * giờ cao điểm, đường sá ứ tắc",
  },
  {
    word: "ừ hữ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) trả lời không rõ ràng, không ra đồng ý cũng không ra từ chối: nói gì cũng ừ hữ, không gật cũng không lắc",
    example: "nói gì cũng ừ hữ, không gật cũng không lắc",
  },
  {
    word: "ứ trệ",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) ứ đọng lại, làm cho không lưu thông được: nước lụt ứ trệ * hàng hoá ứ trệ, không bán được",
    example: "nước lụt ứ trệ * hàng hoá ứ trệ, không bán được",
  },
  {
    word: "ư ử",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng rên nhỏ, trầm và kéo dài trong cổ họng, phát ra thành chuỗi ngắn một: rên ư ử",
    example: "rên ư ử",
  },
  {
    word: "ứ ừ",
    part_of_speech: "cảm từ",
    meaning:
      "(khẩu ngữ) tiếng thốt ra ở đầu câu nói tỏ ý không bằng lòng với vẻ nũng nịu (thường là của trẻ con): ứ ừ, con không ăn đâu * (- con ra đây đi với bố!) - ứ ừ, con đi với mẹ cơ!",
    example:
      "ứ ừ, con không ăn đâu * (- con ra đây đi với bố!) - ứ ừ, con đi với mẹ cơ!",
  },
  {
    word: "ứa",
    part_of_speech: "động từ",
    meaning:
      "tiết ra nhiều và chảy thành giọt: thèm ứa nước miếng * vết thương ứa máu * thân cây ứa nhựa",
    example: "thèm ứa nước miếng * vết thương ứa máu * thân cây ứa nhựa",
  },
  {
    word: "ứa",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) nhiều đến mức như thừa ra, không dùng hết, chứa hết được: nhà ứa của * gạo còn ứa ra đấy, sợ gì!",
    example: "nhà ứa của * gạo còn ứa ra đấy, sợ gì!",
  },
  {
    word: "ức",
    part_of_speech: "danh từ",
    meaning: "phần ngực của chim, thú: con trâu ức nở",
    example: "con trâu ức nở",
  },
  {
    word: "ức",
    part_of_speech: "động từ",
    meaning:
      "tức lắm nhưng ở trong thế đành phải chịu, không làm gì được: bị mắng oan nên rất ức * ức đến cổ mà vẫn phải nhịn",
    example: "bị mắng oan nên rất ức * ức đến cổ mà vẫn phải nhịn",
  },
  {
    word: "ưa chuộng",
    part_of_speech: "động từ",
    meaning:
      "thích dùng hơn những cái khác, thường là cùng loại: ưa chuộng hàng ngoại * quần bò được giới trẻ ưa chuộng",
    example: "ưa chuộng hàng ngoại * quần bò được giới trẻ ưa chuộng",
  },
  {
    word: "ưa nhìn",
    part_of_speech: "tính từ",
    meaning:
      "có duyên, càng nhìn càng có cảm giác ưa thích, mặc dù bề ngoài không phải là đẹp lắm: khuôn mặt ưa nhìn",
    example: "khuôn mặt ưa nhìn",
  },
  {
    word: "ưa",
    part_of_speech: "động từ",
    meaning:
      "có cảm tình, dễ bằng lòng chấp nhận do thấy phù hợp với mình: trẻ con ưa nịnh * xấu tính nên chẳng ai ưa * nhẹ không ưa, ưa nặng",
    example:
      "trẻ con ưa nịnh * xấu tính nên chẳng ai ưa * nhẹ không ưa, ưa nặng",
  },
  {
    word: "ưa",
    part_of_speech: "động từ",
    meaning: "hợp với điều kiện nào đó: da mặt không ưa phấn * gạo ưa nước",
    example: "da mặt không ưa phấn * gạo ưa nước",
  },
  {
    word: "ức chế",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) ngăn cản hoặc kìm hãm hoạt động: bị quan lại ức chế * không chịu nổi sự ức chế",
    example: "bị quan lại ức chế * không chịu nổi sự ức chế",
  },
  {
    word: "ức chế",
    part_of_speech: "động từ",
    meaning:
      "ngăn cản hoặc làm giảm hoạt động của một cơ quan nào đó trong cơ thể: ức chế sự phát triển của các khối u",
    example: "ức chế sự phát triển của các khối u",
  },
  {
    word: "ức chế",
    part_of_speech: "động từ",
    meaning:
      "ngăn cản các hiện tượng tâm lí làm cho không xảy ra hoặc không thành là có ý thức: ức chế tâm lí",
    example: "ức chế tâm lí",
  },
  {
    word: "ưa thích",
    part_of_speech: "động từ",
    meaning:
      "thích hơn những cái khác: món ăn ưa thích * môn thể thao ưa thích",
    example: "món ăn ưa thích * môn thể thao ưa thích",
  },
  {
    word: "ựa",
    part_of_speech: "động từ",
    meaning:
      "đẩy chất gì đó từ dạ dày lên miệng: đứa bé bú no, bị ựa sữa * đánh cho ựa cơm",
    example: "đứa bé bú no, bị ựa sữa * đánh cho ựa cơm",
  },
  {
    word: "ực",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng nuốt mạnh chất lỏng: uống ực một hơi hết cốc bia",
    example: "uống ực một hơi hết cốc bia",
  },
  {
    word: "ức hiếp",
    part_of_speech: "động từ",
    meaning:
      "dùng quyền lực, quyền thế bắt người khác phải chịu những điều bất công, oan ức: ỷ mạnh ức hiếp yếu * bị cường hào ức hiếp",
    example: "ỷ mạnh ức hiếp yếu * bị cường hào ức hiếp",
  },
  {
    word: "ức đoán",
    part_of_speech: "động từ",
    meaning: "đoán phỏng chừng: sự việc xảy ra đúng như ức đoán",
    example: "sự việc xảy ra đúng như ức đoán",
  },
  {
    word: "ửng",
    part_of_speech: "động từ",
    meaning:
      "bắt đầu hơi đỏ lên: bình minh ửng đỏ * ửng hồng đôi má * trái cam ửng vàng",
    example: "bình minh ửng đỏ * ửng hồng đôi má * trái cam ửng vàng",
  },
  {
    word: "ửng",
    part_of_speech: "tính từ",
    meaning: "có màu đỏ hồng lên, trông thích mắt: mặt đỏ ửng",
    example: "mặt đỏ ửng",
  },
  {
    word: "ưng",
    part_of_speech: "danh từ",
    meaning:
      "chim lớn, chân cao, cánh dài, ăn thịt, thường nuôi làm chim săn: mắt sáng như mắt chim ưng",
    example: "mắt sáng như mắt chim ưng",
  },
  {
    word: "ưng",
    part_of_speech: "động từ",
    meaning:
      "bằng lòng, cảm thấy thích vì hợp với ý mình: chọn mãi mà vẫn chưa ưng cái nào",
    example: "chọn mãi mà vẫn chưa ưng cái nào",
  },
  {
    word: "ứng chiến",
    part_of_speech: "động từ",
    meaning: "chiến đấu đánh trả đối phương: đưa quân ra ứng chiến",
    example: "đưa quân ra ứng chiến",
  },
  {
    word: "ứng chiến",
    part_of_speech: "động từ",
    meaning:
      "(đơn vị quân đội) sẵn sàng cơ động để tham gia tác chiến: quân ứng chiến * binh đoàn ứng chiến",
    example: "quân ứng chiến * binh đoàn ứng chiến",
  },
  {
    word: "ứng cứu",
    part_of_speech: "động từ",
    meaning:
      "cứu giúp, giải nguy kịp thời cho nhau lúc gặp nạn: ứng cứu cho đồng đội đang bị bao vây",
    example: "ứng cứu cho đồng đội đang bị bao vây",
  },
  {
    word: "ứng cử",
    part_of_speech: "động từ",
    meaning:
      "tự ghi tên trong danh sách để được bầu chọn trong cuộc bầu cử: ứng cử chức tổng thống",
    example: "ứng cử chức tổng thống",
  },
  {
    word: "ứng biến",
    part_of_speech: "động từ",
    meaning:
      "đối phó linh hoạt với những tình huống bất ngờ xảy ra (tuỳ vào tình hình cụ thể): có tài ứng biến * phải tuỳ cơ mà ứng biến",
    example: "có tài ứng biến * phải tuỳ cơ mà ứng biến",
  },
  {
    word: "ứng dụng",
    part_of_speech: "động từ",
    meaning:
      "đem lí thuyết dùng vào thực tiễn: ứng dụng kĩ thuật mới vào công tác chọn giống",
    example: "ứng dụng kĩ thuật mới vào công tác chọn giống",
  },
  {
    word: "ứng dụng",
    part_of_speech: "danh từ",
    meaning: "cái, điều được đem dùng vào thực tiễn: những ứng dụng khoa học",
    example: "những ứng dụng khoa học",
  },
  {
    word: "ứng dụng",
    part_of_speech: "danh từ",
    meaning:
      "chương trình máy tính chuyên xử lí một công việc: Word là một ứng dụng soạn thảo văn bản * Máy này cài đặt nhiều ứng dụng.",
    example:
      "Word là một ứng dụng soạn thảo văn bản * Máy này cài đặt nhiều ứng dụng.",
  },
  {
    word: "ứng đáp",
    part_of_speech: "động từ",
    meaning: "(hiếm) như đối đáp: ứng đáp trôi chảy",
    example: "ứng đáp trôi chảy",
  },
  {
    word: "ứng cử viên",
    part_of_speech: "danh từ",
    meaning:
      "người ứng cử: ứng cử viên tổng thổng * ứng cử viên của chức vô địch mùa bóng 2006",
    example:
      "ứng cử viên tổng thổng * ứng cử viên của chức vô địch mùa bóng 2006",
  },
  {
    word: "ưng chuẩn",
    part_of_speech: "động từ",
    meaning: "(cũ) như chuẩn y: bản sửa đổi đã được nghị viện ưng chuẩn",
    example: "bản sửa đổi đã được nghị viện ưng chuẩn",
  },
  {
    word: "ưng khuyển",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, hiếm) chim ưng và chó nuôi để đi săn; ví bọn tôi tớ theo chủ làm càn: "Song còn bao nỗi chua cay, Gớm quân Ưng Khuyển, ghê bầy Sở Khanh." (THữu; 13)',
    example:
      'Song còn bao nỗi chua cay, Gớm quân Ưng Khuyển, ghê bầy Sở Khanh." (THữu; 13)',
  },
  {
    word: "ứng tác",
    part_of_speech: "động từ",
    meaning:
      "sáng tác và biểu diễn ngay tại chỗ, không có chuẩn bị trước: hát giao duyên ứng tác * bài thơ ứng tác",
    example: "hát giao duyên ứng tác * bài thơ ứng tác",
  },
  {
    word: "ứng phó",
    part_of_speech: "động từ",
    meaning:
      "chủ động, sẵn sàng đáp lại tình thế bất lợi một cách kịp thời: ứng phó với nguy cơ cháy rừng * liệu cách ứng phó",
    example: "ứng phó với nguy cơ cháy rừng * liệu cách ứng phó",
  },
  {
    word: "ứng thí",
    part_of_speech: "động từ",
    meaning: "(cũ) đi thi: học trò ứng thí",
    example: "học trò ứng thí",
  },
  {
    word: "ứng khẩu",
    part_of_speech: "động từ",
    meaning:
      "nói ngay thành văn, thành thơ mà không cần chuẩn bị trước: hát ứng khẩu * ứng khẩu một bài thơ",
    example: "hát ứng khẩu * ứng khẩu một bài thơ",
  },
  {
    word: "ứng đối",
    part_of_speech: "động từ",
    meaning: "đối đáp nhanh: giỏi ứng đối",
    example: "giỏi ứng đối",
  },
  {
    word: "ứng tấu",
    part_of_speech: "động từ",
    meaning:
      "chơi nhạc theo cảm hứng mới nảy sinh, không theo bản nhạc viết sẵn: ứng tấu nhạc jazz * biểu diễn theo lối ứng tấu",
    example: "ứng tấu nhạc jazz * biểu diễn theo lối ứng tấu",
  },
  {
    word: "ưng thuận",
    part_of_speech: "động từ",
    meaning:
      'thuận theo, đồng ý với yêu cầu nào đó của người khác: gật đầu ưng thuận * "Miếng trầu nên nghĩa, chàng ơi!, Chàng mà ưng thuận, thiếp tôi theo cùng." (ca dao)',
    example:
      'gật đầu ưng thuận * "Miếng trầu nên nghĩa, chàng ơi!, Chàng mà ưng thuận, thiếp tôi theo cùng." (ca dao)',
  },
  {
    word: "ứng nghiệm",
    part_of_speech: "động từ",
    meaning:
      "có hiệu quả đúng như đã tiên đoán, cầu nguyện, v.v.: lời cầu nguyện đã ứng nghiệm",
    example: "lời cầu nguyện đã ứng nghiệm",
  },
  {
    word: "ứng xử",
    part_of_speech: "động từ",
    meaning:
      "thể hiện thái độ, hành động thích hợp trước những việc có quan hệ giữa mình với người khác: biết cách ứng xử * ứng xử khôn khéo, thông minh * văn hoá ứng xử",
    example: "biết cách ứng xử * ứng xử khôn khéo, thông minh * văn hoá ứng xử",
  },
  {
    word: "ưng ý",
    part_of_speech: "động từ",
    meaning:
      "cảm thấy bằng lòng vì hợp với ý của mình: món quà ưng ý * chiếc áo cũng đẹp nhưng chưa thật ưng ý",
    example: "món quà ưng ý * chiếc áo cũng đẹp nhưng chưa thật ưng ý",
  },
  {
    word: "ứng trực",
    part_of_speech: "động từ",
    meaning:
      "trực sẵn để kịp giải quyết khi có sự cố xảy ra: cắt người ứng trực trên đê khi có lũ",
    example: "cắt người ứng trực trên đê khi có lũ",
  },
  {
    word: "ước ao",
    part_of_speech: "động từ",
    meaning: "như ao ước: ước ao một gia đình hạnh phúc",
    example: "ước ao một gia đình hạnh phúc",
  },
  {
    word: "ước",
    part_of_speech: "động từ",
    meaning:
      "mong có được điều biết là rất khó hoặc không hiện thực: điều ước * cầu được ước thấy (tng)",
    example: "điều ước * cầu được ước thấy (tng)",
  },
  {
    word: "ước",
    part_of_speech: "động từ",
    meaning:
      "(cũ) hẹn, thoả thuận với nhau sẽ cùng thực hiện, tuân giữ điều quan trọng gì đó trong quan hệ với nhau: hai người đã ước với nhau * phụ lời ước",
    example: "hai người đã ước với nhau * phụ lời ước",
  },
  {
    word: "ước",
    part_of_speech: "động từ",
    meaning:
      "đoán định một cách đại khái, dựa trên sự quan sát và tính toán qua loa: sản lượng lúa ước đạt 3 tạ một sào * việc này, ước khoảng hai ngày thì xong",
    example:
      "sản lượng lúa ước đạt 3 tạ một sào * việc này, ước khoảng hai ngày thì xong",
  },
  {
    word: "ưng ức",
    part_of_speech: "động từ",
    meaning: "cảm thấy hơi ức: nghe xong thấy ưng ức",
    example: "nghe xong thấy ưng ức",
  },
  {
    word: "ứng tuyển",
    part_of_speech: "động từ",
    meaning:
      "đăng kí tham gia cuộc tuyển chọn: hồ sơ ứng tuyển * ứng tuyển vào vị trí kế toán",
    example: "hồ sơ ứng tuyển * ứng tuyển vào vị trí kế toán",
  },
  {
    word: "ừng ực",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng nuốt chất lỏng mạnh và liên tiếp từng hơi dài: tu nước ừng ực",
    example: "tu nước ừng ực",
  },
  {
    word: "ưng ửng",
    part_of_speech: "tính từ",
    meaning: "hơi đỏ hồng lên: má ưng ửng hồng",
    example: "má ưng ửng hồng",
  },
  {
    word: "ứng viên",
    part_of_speech: "danh từ",
    meaning:
      "người tham dự cuộc thi tuyển: ứng viên xin việc * một số ứng viên đã được tuyển dụng",
    example: "ứng viên xin việc * một số ứng viên đã được tuyển dụng",
  },
  {
    word: "ước hẹn",
    part_of_speech: "động từ",
    meaning: "(văn chương) như hẹn ước: quên lời ước hẹn",
    example: "quên lời ước hẹn",
  },
  {
    word: "ước lượng",
    part_of_speech: "động từ",
    meaning:
      "ước chừng số lượng, dựa trên sự quan sát và tính toán đại khái: tải thóc ước lượng khoảng 50 cân * ước lượng thời gian hoàn thành",
    example:
      "tải thóc ước lượng khoảng 50 cân * ước lượng thời gian hoàn thành",
  },
  {
    word: "ước mong",
    part_of_speech: "",
    meaning: "như mong ước: thoả lòng ước mong * một ước mong giản dị",
    example: "thoả lòng ước mong * một ước mong giản dị",
  },
  {
    word: "ước chừng",
    part_of_speech: "động từ",
    meaning: "ước vào khoảng: từ đây đến đó ước chừng mươi cây số",
    example: "từ đây đến đó ước chừng mươi cây số",
  },
  {
    word: "ước chừng",
    part_of_speech: "động từ",
    meaning:
      "đại khái, không thật chính xác: tính ước chừng * vẽ ước chừng, không cần chính xác",
    example: "tính ước chừng * vẽ ước chừng, không cần chính xác",
  },
  {
    word: "ước lệ",
    part_of_speech: "danh từ",
    meaning:
      "quy ước biểu trưng trong biểu hiện nghệ thuật: bài thơ có nhiều hình ảnh mang tính ước lệ",
    example: "bài thơ có nhiều hình ảnh mang tính ước lệ",
  },
  {
    word: "ước lệ",
    part_of_speech: "danh từ",
    meaning:
      "quy ước đã thống nhất với nhau: tiếng lóng ít nhiều có tính ước lệ",
    example: "tiếng lóng ít nhiều có tính ước lệ",
  },
  {
    word: "ước lệ",
    part_of_speech: "tính từ",
    meaning: "có tính quy ước: hình ảnh ước lệ * ngôn ngữ sân khấu ước lệ",
    example: "hình ảnh ước lệ * ngôn ngữ sân khấu ước lệ",
  },
  {
    word: "ước định",
    part_of_speech: "động từ",
    meaning:
      "định trước, theo thoả thuận với nhau: ước định nơi gặp gỡ * ngày cưới đã được ước định",
    example: "ước định nơi gặp gỡ * ngày cưới đã được ước định",
  },
  {
    word: "ước định",
    part_of_speech: "động từ",
    meaning: "định chừng: ước định xem hết bao nhiêu",
    example: "ước định xem hết bao nhiêu",
  },
  {
    word: "ước lược",
    part_of_speech: "động từ",
    meaning: "rút gọn: ước lược phân số",
    example: "ước lược phân số",
  },
  {
    word: "ước muốn",
    part_of_speech: "động từ",
    meaning:
      "mong muốn thiết tha: ước muốn trở thành người nổi tiếng * ước muốn một cuộc sống hạnh phúc",
    example:
      "ước muốn trở thành người nổi tiếng * ước muốn một cuộc sống hạnh phúc",
  },
  {
    word: "ước muốn",
    part_of_speech: "danh từ",
    meaning: "điều mong muốn: đạt được ước muốn",
    example: "đạt được ước muốn",
  },
  {
    word: "ước vọng",
    part_of_speech: "danh từ",
    meaning: "điều mong muốn rất thiết tha: thoả mãn ước vọng",
    example: "thoả mãn ước vọng",
  },
  {
    word: "ước vọng",
    part_of_speech: "động từ",
    meaning:
      "mong mỏi thiết tha: ước vọng được hoà bình * ước vọng một tương lai tươi đẹp",
    example: "ước vọng được hoà bình * ước vọng một tương lai tươi đẹp",
  },
  {
    word: "ươm ướm",
    part_of_speech: "động từ",
    meaning: "nói ướm thử để thăm dò ý kiến: ươm ướm xem ý nó thế nào",
    example: "ươm ướm xem ý nó thế nào",
  },
  {
    word: "ước số",
    part_of_speech: "danh từ",
    meaning: "số chia hết của một số khác: 1, 3, 5 là ước số của 15",
    example: "1, 3, 5 là ước số của 15",
  },
  {
    word: "ước tính",
    part_of_speech: "động từ",
    meaning:
      "tính áng chừng trên đại thể: ước tính sản lượng lúa là 2 tấn * chi phí ước tính hàng tỉ đồng",
    example: "ước tính sản lượng lúa là 2 tấn * chi phí ước tính hàng tỉ đồng",
  },
  {
    word: "ươn",
    part_of_speech: "tính từ",
    meaning:
      "(tôm, cá) không còn tươi nữa, đã chớm có mùi hôi: cá không ăn muối cá ươn (tng)",
    example: "cá không ăn muối cá ươn (tng)",
  },
  {
    word: "ươn",
    part_of_speech: "tính từ",
    meaning:
      "(trẻ con) không được khoẻ, hơi ốm (lối nói kiêng tránh): trẻ ươn người nên quấy * cháu bé ươn mình",
    example: "trẻ ươn người nên quấy * cháu bé ươn mình",
  },
  {
    word: "ươn",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) hèn, kém: đàn ông như thế thì ươn quá!",
    example: "đàn ông như thế thì ươn quá!",
  },
  {
    word: "ươm",
    part_of_speech: "động từ",
    meaning:
      "gieo hạt cho mọc thành cây non để đem đi trồng ở nơi khác: ươm cây giống * ươm bèo hoa dâu",
    example: "ươm cây giống * ươm bèo hoa dâu",
  },
  {
    word: "ươm",
    part_of_speech: "động từ",
    meaning:
      "kéo sợi tơ ra khỏi kén khi cho kén vào nước đang sôi: ươm tơ, dệt lụa * lò ươm",
    example: "ươm tơ, dệt lụa * lò ươm",
  },
  {
    word: "ước số chung",
    part_of_speech: "danh từ",
    meaning:
      "ước số đồng thời của nhiều số: 3 là ước số chung của 6, 9, 12, 15, 18, …",
    example: "3 là ước số chung của 6, 9, 12, 15, 18, …",
  },
  {
    word: "ướm",
    part_of_speech: "động từ",
    meaning:
      "đặt thử vào để xem có vừa, có hợp không: ướm giày * ướm chiếc vòng vào cổ",
    example: "ướm giày * ướm chiếc vòng vào cổ",
  },
  {
    word: "ướm",
    part_of_speech: "động từ",
    meaning:
      'nói xa xôi để thử thăm dò ý kiến xem có thuận không: ướm hỏi * "Hôm xưa tướng phủ mới vào, Khoe con má phấn, ướm trao chỉ hồng." (NĐM)',
    example:
      'ướm hỏi * "Hôm xưa tướng phủ mới vào, Khoe con má phấn, ướm trao chỉ hồng." (NĐM)',
  },
  {
    word: "ườn",
    part_of_speech: "",
    meaning:
      "(nằm) ở tư thế duỗi dài người ra (vì lười biếng): nằm ườn cả ngày * sáng bảnh ra rồi còn ườn xác ra đấy!",
    example: "nằm ườn cả ngày * sáng bảnh ra rồi còn ườn xác ra đấy!",
  },
  {
    word: "ưỡn ẹo",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả dáng đi uốn éo, cố làm ra vẻ mềm mại, duyên dáng, nhưng thiếu tự nhiên, gây ấn tượng kệch cỡm, thiếu đứng đắn: dáng đi ưỡn ẹo",
    example: "dáng đi ưỡn ẹo",
  },
  {
    word: "ưỡn",
    part_of_speech: "động từ",
    meaning:
      "làm cho ngực hay bụng nhô ra phía trước bằng cách hơi ngửa người về đằng sau: ưỡn ngực * ưỡn bụng * đứa bé ưỡn người lên, không chịu ngồi",
    example: "ưỡn ngực * ưỡn bụng * đứa bé ưỡn người lên, không chịu ngồi",
  },
  {
    word: "ươn hèn",
    part_of_speech: "tính từ",
    meaning:
      "hèn kém về bản lĩnh đến mức đáng khinh: tính ươn hèn * kẻ ươn hèn",
    example: "tính ươn hèn * kẻ ươn hèn",
  },
  {
    word: "ương bướng",
    part_of_speech: "tính từ",
    meaning:
      "bướng bỉnh, cứ làm theo ý mình (nói khái quát): tính ngang ngạnh, ương bướng",
    example: "tính ngang ngạnh, ương bướng",
  },
  {
    word: "ương ngạnh",
    part_of_speech: "tính từ",
    meaning:
      "bướng bỉnh, không chịu nghe theo, nhiều khi còn cố ý làm khác đi: đứa trẻ ương ngạnh",
    example: "đứa trẻ ương ngạnh",
  },
  {
    word: "ươn ướt",
    part_of_speech: "tính từ",
    meaning: "hơi ướt: bờ mi ươn ướt",
    example: "bờ mi ươn ướt",
  },
  {
    word: "ương",
    part_of_speech: "động từ",
    meaning: "(cũ)",
    example: "vớt cá bột về ương",
  },
  {
    word: "ương",
    part_of_speech: "tính từ",
    meaning: "(quả cây) gần chín: ổi ương * đu đủ ương, chưa chín",
    example: "ổi ương * đu đủ ương, chưa chín",
  },
  {
    word: "ương",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) gàn, khăng khăng theo ý mình, không chịu nghe ai: con bé ương lắm",
    example: "con bé ương lắm",
  },
  {
    word: "ương gàn",
    part_of_speech: "tính từ",
    meaning:
      "bướng bỉnh một cách gàn dở, trái với lẽ thường: tính nết ương gàn",
    example: "tính nết ương gàn",
  },
  {
    word: "ướp",
    part_of_speech: "động từ",
    meaning:
      "làm cho thực phẩm ngấm gia vị để tăng vị thơm ngon khi ăn: ướp thịt để rán * cá ướp muối",
    example: "ướp thịt để rán * cá ướp muối",
  },
  {
    word: "ướp",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) ướp lạnh (nói tắt): thịt ướp",
    example: "thịt ướp",
  },
  {
    word: "ướp",
    part_of_speech: "động từ",
    meaning:
      "làm cho hương liệu chuyển sang và thấm vào thức uống (thường là chè) để tăng vị thơm ngon: chè ướp sen * bột sắn ướp hoa nhài",
    example: "chè ướp sen * bột sắn ướp hoa nhài",
  },
  {
    word: "ướt át",
    part_of_speech: "tính từ",
    meaning:
      "ướt nhiều, gây cảm giác khó chịu (nói khái quát): đường sá ướt át * người ướt át mồ hôi",
    example: "đường sá ướt át * người ướt át mồ hôi",
  },
  {
    word: "ướt át",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) có chứa nhiều tình cảm uỷ mị, yếu đuối: tình cảm ướt át * giọng văn ướt át",
    example: "tình cảm ướt át * giọng văn ướt át",
  },
  {
    word: "ướp lạnh",
    part_of_speech: "động từ",
    meaning:
      "cho vào tủ nước đá hoặc môi trường nước đá để giữ cho khỏi hỏng hoặc để cho thêm ngon: cá ướp lạnh * mít ướp lạnh * khăn mặt ướp lạnh",
    example: "cá ướp lạnh * mít ướp lạnh * khăn mặt ướp lạnh",
  },
  {
    word: "ướt đầm",
    part_of_speech: "tính từ",
    meaning:
      'như ướt đẫm: "Người về em những khóc thầm, Bên song vạt áo ướt đầm như mưa." (ca dao)',
    example:
      'Người về em những khóc thầm, Bên song vạt áo ướt đầm như mưa." (ca dao)',
  },
  {
    word: "ướt",
    part_of_speech: "tính từ",
    meaning:
      "có thấm nước hay có nước trên bề mặt: lưng áo ướt mồ hôi * củi ướt không cháy * mắt ướt",
    example: "lưng áo ướt mồ hôi * củi ướt không cháy * mắt ướt",
  },
  {
    word: "ướt mèm",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) ướt đẫm và dính bết vào nhau: quần áo ướt mèm",
    example: "quần áo ướt mèm",
  },
  {
    word: "ướt rượt",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) ướt đến mức như sũng những nước: đôi mắt ướt rượt * đầu tóc ướt rượt",
    example: "đôi mắt ướt rượt * đầu tóc ướt rượt",
  },
  {
    word: "ướt đẫm",
    part_of_speech: "tính từ",
    meaning:
      "ướt nhiều và đều khắp: áo ướt đẫm mồ hôi * cỏ cây ướt đẫm sương đêm",
    example: "áo ướt đẫm mồ hôi * cỏ cây ướt đẫm sương đêm",
  },
  {
    word: "ướt sũng",
    part_of_speech: "tính từ",
    meaning:
      "ướt nhiều, vì ngâm lâu trong nước hoặc thấm đẫm nước: quần áo ướt sũng",
    example: "quần áo ướt sũng",
  },
  {
    word: "ướt sượt",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) như ướt rượt: tóc tai ướt sượt",
    example: "tóc tai ướt sượt",
  },
  {
    word: "ưu ái",
    part_of_speech: "động từ",
    meaning: "yêu thương và lo lắng cho: lòng ưu ái * được cấp trên ưu ái",
    example: "lòng ưu ái * được cấp trên ưu ái",
  },
  {
    word: "ưu",
    part_of_speech: "tính từ",
    meaning:
      "(cũ) giỏi, trong hệ thống phê điểm để xếp hạng (ưu, bình, thứ, liệt) trong học tập, thi cử ngày trước: đỗ hạng ưu * bằng ưu",
    example: "đỗ hạng ưu * bằng ưu",
  },
  {
    word: "ưu",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) ưu điểm (nói tắt): ưu nhiều hơn khuyết * nêu rõ cả ưu lẫn khuyết",
    example: "ưu nhiều hơn khuyết * nêu rõ cả ưu lẫn khuyết",
  },
  {
    word: "ưu đãi",
    part_of_speech: "động từ",
    meaning:
      "dành cho những điều kiện, quyền lợi đặc biệt hơn so với những đối tượng khác: được mua với giá ưu đãi * vùng đất được thiên nhiên ưu đãi",
    example: "được mua với giá ưu đãi * vùng đất được thiên nhiên ưu đãi",
  },
  {
    word: "ưu sầu",
    part_of_speech: "động từ",
    meaning:
      '(cũ, hiếm) lo buồn rầu rĩ: "Tình ly biệt thờ ơ góp lại, Mối ưu sầu gỡ mãi chưa xong." (TTK)',
    example: 'Tình ly biệt thờ ơ góp lại, Mối ưu sầu gỡ mãi chưa xong." (TTK)',
  },
  {
    word: "ưu phiền",
    part_of_speech: "động từ",
    meaning:
      "(cũ) buồn xen lẫn lo âu, không yên trong lòng: nét mặt ưu phiền * tâm trạng ưu phiền",
    example: "nét mặt ưu phiền * tâm trạng ưu phiền",
  },
  {
    word: "ưu điểm",
    part_of_speech: "danh từ",
    meaning:
      "điểm tốt, điểm hay: ưu điểm của phiên bản mới * phát huy ưu điểm, khắc phục nhược điểm",
    example:
      "ưu điểm của phiên bản mới * phát huy ưu điểm, khắc phục nhược điểm",
  },
  {
    word: "ưu khuyết điểm",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) ưu điểm và khuyết điểm (nói gộp): đánh giá ưu khuyết điểm của từng cá nhân",
    example: "đánh giá ưu khuyết điểm của từng cá nhân",
  },
  {
    word: "ưu thế",
    part_of_speech: "danh từ",
    meaning: "thế mạnh hơn: ưu thế sân nhà * mất ưu thế cạnh tranh",
    example: "ưu thế sân nhà * mất ưu thế cạnh tranh",
  },
  {
    word: "ưu tiên",
    part_of_speech: "tính từ",
    meaning:
      "được chú ý trước nhất, trước những đối tượng khác, vì được coi trọng hơn: ưu tiên phát triển công nghiệp * tuyển công nhân, ưu tiên thợ lành nghề",
    example:
      "ưu tiên phát triển công nghiệp * tuyển công nhân, ưu tiên thợ lành nghề",
  },
  {
    word: "ưu tiên",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) cho được hưởng quyền ưu tiên trong một việc cụ thể nào đó: ưu tiên phụ nữ, cho làm việc nhẹ * được cộng điểm ưu tiên",
    example: "ưu tiên phụ nữ, cho làm việc nhẹ * được cộng điểm ưu tiên",
  },
  {
    word: "ưu tư",
    part_of_speech: "động từ",
    meaning: "lo nghĩ sâu sắc, kín đáo: nét mặt ưu tư * lòng nặng trĩu ưu tư",
    example: "nét mặt ưu tư * lòng nặng trĩu ưu tư",
  },
  {
    word: "ưu tú",
    part_of_speech: "tính từ",
    meaning:
      "(người) có năng lực và phẩm chất tốt đẹp, được đánh giá cao hơn cả: nhà giáo ưu tú * một chiến sĩ cách mạng ưu tú",
    example: "nhà giáo ưu tú * một chiến sĩ cách mạng ưu tú",
  },
  {
    word: "vá",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng để xúc đất đá, thường làm bằng sắt, hình giống cái xẻng: vá xúc đất",
    example: "vá xúc đất",
  },
  {
    word: "vá",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) môi (múc thức ăn): cái vá múc canh",
    example: "cái vá múc canh",
  },
  {
    word: "vá",
    part_of_speech: "động từ",
    meaning:
      "làm kín chỗ bị rách, bị thủng, bị hở bằng cách phủ lên một mảnh, một lớp và làm cho dính chặt, gắn chặt vào: vá săm xe đạp * vá quần áo",
    example: "vá săm xe đạp * vá quần áo",
  },
  {
    word: "vá",
    part_of_speech: "tính từ",
    meaning:
      "(thú vật) có một vài mảng lông khác màu với lông toàn thân: bò vá * chó vá",
    example: "bò vá * chó vá",
  },
  {
    word: "ưu việt",
    part_of_speech: "tính từ",
    meaning:
      "tốt hơn hẳn, vượt trội hơn hẳn những cái khác: tính năng ưu việt của máy tính thế hệ mới",
    example: "tính năng ưu việt của máy tính thế hệ mới",
  },
  {
    word: "vã",
    part_of_speech: "động từ",
    meaning:
      "vốc nước vỗ nhẹ lên cho ướt toàn bề mặt: vã nước lên mặt cho tỉnh ngủ",
    example: "vã nước lên mặt cho tỉnh ngủ",
  },
  {
    word: "vã",
    part_of_speech: "động từ",
    meaning:
      "toát ra, đổ ra nhiều (thường nói về mồ hôi): mồ hôi vã ra như tắm * nói vã bọt mép mà nó vẫn không nghe",
    example: "mồ hôi vã ra như tắm * nói vã bọt mép mà nó vẫn không nghe",
  },
  {
    word: "vã",
    part_of_speech: "tính từ",
    meaning:
      "(nói năng) kéo dài mà không có nội dung, không có mục đích thiết thực: chửi vã * chuyện vã",
    example: "chửi vã * chuyện vã",
  },
  {
    word: "va",
    part_of_speech: "động từ",
    meaning:
      "đụng mạnh (thường là không may, không cố ý): va đầu vào tường * rét quá, hai hàm răng va vào nhau lập cập",
    example: "va đầu vào tường * rét quá, hai hàm răng va vào nhau lập cập",
  },
  {
    word: "vả",
    part_of_speech: "danh từ",
    meaning:
      "cây cùng họ với sung, lá to, quả lớn hơn quả sung, ăn được: lòng vả cũng như lòng sung (tng)",
    example: "lòng vả cũng như lòng sung (tng)",
  },
  {
    word: "vả",
    part_of_speech: "động từ",
    meaning: "tát mạnh (thường là vào miệng): vả cho mấy cái",
    example: "vả cho mấy cái",
  },
  {
    word: "vả",
    part_of_speech: "đại từ",
    meaning:
      "(Phương ngữ, Khẩu ngữ) anh ta, ông ta (nói về người cùng lứa hoặc lớn tuổi hơn một chút): tôi vừa gặp vả mấy hôm trước",
    example: "tôi vừa gặp vả mấy hôm trước",
  },
  {
    word: "vả",
    part_of_speech: "kết từ",
    meaning:
      "(Ít dùng) như vả lại: tôi không biết, vả có biết cũng không giúp gì được",
    example: "tôi không biết, vả có biết cũng không giúp gì được",
  },
  {
    word: "và",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) vài: "Ai về tôi gửi thư ra, Gửi dăm câu nhớ, gửi và câu thương." (ca dao)',
    example:
      'Ai về tôi gửi thư ra, Gửi dăm câu nhớ, gửi và câu thương." (ca dao)',
  },
  {
    word: "và",
    part_of_speech: "động từ",
    meaning:
      "dùng đũa đưa cơm cùng thức ăn từ bát vào miệng: bé đã biết tự và cơm",
    example: "bé đã biết tự và cơm",
  },
  {
    word: "và",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị quan hệ liên hợp giữa hai sự vật, hiện tượng, quá trình, tính chất cùng loại, cùng phạm trù: anh và em * học thêm toán và văn",
    example: "anh và em * học thêm toán và văn",
  },
  {
    word: "và",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là điều nói thêm để nhấn mạnh, khẳng định thêm điều vừa nói đến: cô bé ấy hát rất hay, và xinh nữa",
    example: "cô bé ấy hát rất hay, và xinh nữa",
  },
  {
    word: "và",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là điều xảy ra, diễn ra tiếp theo hoặc là kết quả, hậu quả của điều vừa nói đến: lắng nghe, và khẽ gật đầu",
    example: "lắng nghe, và khẽ gật đầu",
  },
  {
    word: "và",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý nhấn mạnh vào ý nghĩa kết luận của điều nêu ra: và thế là hết * và rồi mọi chuyện lại đâu vào đấy",
    example: "và thế là hết * và rồi mọi chuyện lại đâu vào đấy",
  },
  {
    word: "vạ",
    part_of_speech: "danh từ",
    meaning:
      "tai hoạ bỗng dưng đến với một người nào đó: mang vạ * tai bay vạ gió (tng)",
    example: "mang vạ * tai bay vạ gió (tng)",
  },
  {
    word: "vạ",
    part_of_speech: "danh từ",
    meaning:
      "điều tội lỗi phải gánh chịu: đổ vạ cho người khác * vạ mồm vạ miệng",
    example: "đổ vạ cho người khác * vạ mồm vạ miệng",
  },
  {
    word: "vạ",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) hình phạt, thường bằng tiền, đối với người đã vi phạm tục làng thời phong kiến: nộp vạ * phạt vạ * ngả vạ",
    example: "nộp vạ * phạt vạ * ngả vạ",
  },
  {
    word: "vả chăng",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là thêm một lẽ thuyết minh cho điều vừa nói đến là có cơ sở: tôi không làm, vả chăng có làm cũng vô ích",
    example: "tôi không làm, vả chăng có làm cũng vô ích",
  },
  {
    word: "vả chăng",
    part_of_speech: "kết từ",
    meaning: "như vả lại: nơi đó rất đẹp, vả chăng khí hậu cũng tốt nữa",
    example: "nơi đó rất đẹp, vả chăng khí hậu cũng tốt nữa",
  },
  {
    word: "va chạm",
    part_of_speech: "động từ",
    meaning:
      "va vào nhau (nói khái quát): có tiếng ổ khoá va chạm vào nhau * hai chiếc thuyền va chạm nhau",
    example: "có tiếng ổ khoá va chạm vào nhau * hai chiếc thuyền va chạm nhau",
  },
  {
    word: "va chạm",
    part_of_speech: "động từ",
    meaning:
      "có mâu thuẫn hoặc xích mích với nhau trong quan hệ, tiếp xúc: xảy ra va chạm * hai bên đã vài lần va chạm",
    example: "xảy ra va chạm * hai bên đã vài lần va chạm",
  },
  {
    word: "va chạm",
    part_of_speech: "động từ",
    meaning: "(hiếm) như động chạm: va chạm đến quyền lợi",
    example: "va chạm đến quyền lợi",
  },
  {
    word: "va chạm",
    part_of_speech: "danh từ",
    meaning:
      "những điều không nhất trí, mâu thuẫn nhau trong quan hệ, tiếp xúc: tránh mọi va chạm trong công việc",
    example: "tránh mọi va chạm trong công việc",
  },
  {
    word: "va đập",
    part_of_speech: "động từ",
    meaning: "va chạm mạnh: hàng dễ vỡ, tránh va đập",
    example: "hàng dễ vỡ, tránh va đập",
  },
  {
    word: "vạ gì mà",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị ý phủ định đối với điều sắp nêu ra, cho rằng đó là việc không nên làm, vì chỉ có thể mang lại điều không hay, không lợi cho bản thân: vạ gì mà sinh sự với nó",
    example: "vạ gì mà sinh sự với nó",
  },
  {
    word: "vạ lây",
    part_of_speech: "động từ",
    meaning:
      "bị mắc phải tai hoạ một cách oan uổng: chơi với nó rồi có ngày vạ lây",
    example: "chơi với nó rồi có ngày vạ lây",
  },
  {
    word: "vạ miệng",
    part_of_speech: "danh từ",
    meaning:
      '(khẩu ngữ) tai vạ do nói năng không thận trọng gây nên: "Chuyện triều đình quốc gia, chúng ta biết gì mà bàn bạc cho thêm lời. Nhỡ ra lại vạ miệng thì khốn." (NgTuân; 11)',
    example:
      'Chuyện triều đình quốc gia, chúng ta biết gì mà bàn bạc cho thêm lời. Nhỡ ra lại vạ miệng thì khốn." (NgTuân; 11)',
  },
  {
    word: "va li",
    part_of_speech: "danh từ",
    meaning:
      "vật dùng để đựng hành lí, thường làm bằng da, hình hộp chữ nhật, có quai xách: xếp quần áo vào va li",
    example: "xếp quần áo vào va li",
  },
  {
    word: "vả lại",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là thêm một lẽ khẳng định điều muốn nói: tôi không mua, vả lại cũng chẳng có tiền",
    example: "tôi không mua, vả lại cũng chẳng có tiền",
  },
  {
    word: "va quệt",
    part_of_speech: "động từ",
    meaning:
      "(phương tiện giao thông) va chạm vào nhau, thường không gây thiệt hại lớn: vụ va quệt xe máy * hai xe chỉ va quyệt nhẹ",
    example: "vụ va quệt xe máy * hai xe chỉ va quyệt nhẹ",
  },
  {
    word: "vạ vịt",
    part_of_speech: "danh từ",
    meaning:
      '(khẩu ngữ) tai vạ bỗng tự đâu đến, một cách không ngờ: "Vợ chồng tôi trót nghe nhà ông nghị xui dại, thành ra bị cái vạ vịt." (NgCHoan; 11)',
    example:
      'Vợ chồng tôi trót nghe nhà ông nghị xui dại, thành ra bị cái vạ vịt." (NgCHoan; 11)',
  },
  {
    word: "va vấp",
    part_of_speech: "động từ",
    meaning:
      "va phải, vấp phải khi đang đi, do không chú ý (nói khái quát): cẩn thận không lại va vấp * đi đứng cẩn thận để tránh va vấp",
    example: "cẩn thận không lại va vấp * đi đứng cẩn thận để tránh va vấp",
  },
  {
    word: "va vấp",
    part_of_speech: "động từ",
    meaning:
      "gặp phải trở ngại, khó khăn trong hoạt động, công tác, thường do còn non nớt, thiếu kinh nghiệm nên không lường trước được: còn trẻ nên hay va vấp",
    example: "còn trẻ nên hay va vấp",
  },
  {
    word: "va vấp",
    part_of_speech: "danh từ",
    meaning:
      "trở ngại, khó khăn gặp phải: cuộc sống đầy rẫy va vấp * trải qua nhiều va vấp",
    example: "cuộc sống đầy rẫy va vấp * trải qua nhiều va vấp",
  },
  {
    word: "vác",
    part_of_speech: "động từ",
    meaning:
      "mang, chuyển (thường là vật nặng hoặc cồng kềnh) bằng cách đặt lên vai: vác cuốc ra đồng * vai vác một bao hàng nặng",
    example: "vác cuốc ra đồng * vai vác một bao hàng nặng",
  },
  {
    word: "vác",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) mang ra, đưa ra để làm việc gì: vác bài tập ra làm * vác rổ đi chợ từ sáng",
    example: "vác bài tập ra làm * vác rổ đi chợ từ sáng",
  },
  {
    word: "vác",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) tự mang thân mình đến (hàm ý mỉa mai, khinh bỉ): lại vác xác đến * vác mồm đến ăn không",
    example: "lại vác xác đến * vác mồm đến ăn không",
  },
  {
    word: "vác",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp những vật rời, thường là vật dài, được bó lại để vác trong một lần: một vác mía",
    example: "một vác mía",
  },
  {
    word: "vạc",
    part_of_speech: "danh từ",
    meaning:
      "chim có chân cao, cùng họ với diệc, cò, thường đi ăn đêm, kêu rất to: kêu như vạc",
    example: "kêu như vạc",
  },
  {
    word: "vạc",
    part_of_speech: "danh từ",
    meaning: "đồ dùng để nấu, giống cái chảo nhưng to và sâu hơn: vạc dầu",
    example: "vạc dầu",
  },
  {
    word: "vạc",
    part_of_speech: "danh từ",
    meaning: "đỉnh lớn: đúc vạc đồng * thế chân vạc (thế vững chắc)",
    example: "đúc vạc đồng * thế chân vạc (thế vững chắc)",
  },
  {
    word: "vạc",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) giát (giường): vạc giường",
    example: "vạc giường",
  },
  {
    word: "vạc",
    part_of_speech: "danh từ",
    meaning: "chõng: bộ vạc tre",
    example: "bộ vạc tre",
  },
  {
    word: "vạc",
    part_of_speech: "động từ",
    meaning: "(than, củi) cháy đã gần tàn, không còn ánh lửa: bếp lửa đã vạc",
    example: "bếp lửa đã vạc",
  },
  {
    word: "vạc",
    part_of_speech: "động từ",
    meaning:
      "làm cho đứt, lìa ra bằng cách đưa nhanh lưỡi sắc theo chiều nghiêng trên bề mặt: vạc bờ * hết nạc vạc đến xương (tng)",
    example: "vạc bờ * hết nạc vạc đến xương (tng)",
  },
  {
    word: "vạ vật",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ở trạng thái để bừa bãi, không được cất giữ, bảo quản: quần áo vứt vạ vật, mỗi nơi một cái",
    example: "quần áo vứt vạ vật, mỗi nơi một cái",
  },
  {
    word: "vạ vật",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái bạ đâu ngồi (hoặc nằm) đó, gặp đâu hay đó, do không được chú ý, chăm nom đến hoặc do điều kiện vật chất quá thiếu thốn: nằm vạ vật * ngồi vạ vật cả ngày ở sân ga để chờ tàu",
    example: "nằm vạ vật * ngồi vạ vật cả ngày ở sân ga để chờ tàu",
  },
  {
    word: "vá víu",
    part_of_speech: "động từ",
    meaning:
      "vá nhiều chỗ và không cẩn thận (nói khái quát): vá víu lại chiếc áo rách",
    example: "vá víu lại chiếc áo rách",
  },
  {
    word: "vá víu",
    part_of_speech: "tính từ",
    meaning:
      "gồm nhiều phần không khớp, không đồng bộ, có tính chất chắp vá để đối phó tạm thời: căn nhà vá víu, tồi tàn",
    example: "căn nhà vá víu, tồi tàn",
  },
  {
    word: "vạch",
    part_of_speech: "động từ",
    meaning:
      "tạo thành đường, thành nét (thường là khi vẽ, viết): vạch một đường thẳng trên nền đất * vạch phấn để đánh dấu",
    example: "vạch một đường thẳng trên nền đất * vạch phấn để đánh dấu",
  },
  {
    word: "vạch",
    part_of_speech: "động từ",
    meaning:
      "gạt sang một bên để có được một khoảng trống, để làm lộ ra phần bị che khuất: vạch rào chui ra * vạch áo cho người xem lưng (tng)",
    example: "vạch rào chui ra * vạch áo cho người xem lưng (tng)",
  },
  {
    word: "vạch",
    part_of_speech: "động từ",
    meaning:
      "làm lộ ra, làm cho thấy được (thường là cái không hay, muốn che giấu): vạch tội trước pháp luật * vạch ra những thiếu sót cần khắc phục",
    example: "vạch tội trước pháp luật * vạch ra những thiếu sót cần khắc phục",
  },
  {
    word: "vạch",
    part_of_speech: "động từ",
    meaning:
      "nêu ra, làm cho thấy rõ để theo đó mà thực hiện: vạch kế hoạch * vạch những ý chính trước khi viết",
    example: "vạch kế hoạch * vạch những ý chính trước khi viết",
  },
  {
    word: "vạch",
    part_of_speech: "danh từ",
    meaning: "đường nét (thường là thẳng) được vạch ra trên bề mặt: vạch cấm",
    example: "vạch cấm",
  },
  {
    word: "vaccin",
    part_of_speech: "danh từ",
    meaning:
      "yếu tố mang mầm bệnh đã giảm độc tính, dùng đưa vào cơ thể để tạo miễn dịch, chủ động phòng bệnh: uống vaccine phòng bệnh bại liệt",
    example: "uống vaccine phòng bệnh bại liệt",
  },
  {
    word: "vách",
    part_of_speech: "danh từ",
    meaning:
      "bức làm bằng vật liệu nhẹ như tre, gỗ, v.v., để che chắn hoặc ngăn cách trong nhà: trát vách * nhà tranh vách đất",
    example: "trát vách * nhà tranh vách đất",
  },
  {
    word: "vách",
    part_of_speech: "danh từ",
    meaning:
      "bề mặt dựng đứng bằng đất, đá, v.v., thường có tác dụng che chắn, ngăn cách: vách núi * vách đá dựng đứng",
    example: "vách núi * vách đá dựng đứng",
  },
  {
    word: "vác mặt",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) tự mình đi đến một nơi nào đó (hàm ý khinh bỉ): giờ mà còn chưa thấy vác mặt đến",
    example: "giờ mà còn chưa thấy vác mặt đến",
  },
  {
    word: "vác mặt",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) vênh mặt lên, tỏ ý coi thường người khác: vác mặt lên làm cao",
    example: "vác mặt lên làm cao",
  },
  {
    word: "vạch mặt",
    part_of_speech: "động từ",
    meaning:
      "làm cho lộ rõ bộ mặt thật xấu xa, để mọi người khỏi lầm: vạch mặt kẻ gian",
    example: "vạch mặt kẻ gian",
  },
  {
    word: "vãi",
    part_of_speech: "danh từ",
    meaning: "người đàn bà có tuổi chuyên đi chùa lễ Phật.",
    example: "ông sư bà vãi",
  },
  {
    word: "vãi",
    part_of_speech: "động từ",
    meaning:
      "ném rải ra nhiều phía trên một diện tích nhất định (thường với những vật có dạng hạt nhỏ): vãi hạt cải * vãi thóc cho gà",
    example: "vãi hạt cải * vãi thóc cho gà",
  },
  {
    word: "vãi",
    part_of_speech: "động từ",
    meaning:
      "ở trạng thái rơi lung tung ra nhiều nơi, nhiều chỗ (thường nói về vật có dạng hạt nhỏ): cơm vãi ra chiếu * rá thủng, gạo vãi đầy nhà",
    example: "cơm vãi ra chiếu * rá thủng, gạo vãi đầy nhà",
  },
  {
    word: "vãi",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) để rơi ra, chảy ra do cơ thể không điều khiển, không kiềm chế được: cười vãi nước mắt * sợ đến vãi đái",
    example: "cười vãi nước mắt * sợ đến vãi đái",
  },
  {
    word: "vạch trần",
    part_of_speech: "động từ",
    meaning:
      "làm cho sự thật xấu xa đang được che giấu phơi bày ra để mọi người cùng thấy rõ: vạch trần bộ mặt xảo quyệt * vạch trần âm mưu đen tối",
    example: "vạch trần bộ mặt xảo quyệt * vạch trần âm mưu đen tối",
  },
  {
    word: "vái",
    part_of_speech: "",
    meaning:
      "chắp tay giơ lên hạ xuống, đồng thời cúi đầu, để tỏ sự cung kính của mình: chắp tay vái Phật * vái ba vái",
    example: "chắp tay vái Phật * vái ba vái",
  },
  {
    word: "vải",
    part_of_speech: "danh từ",
    meaning:
      "hàng dệt bằng sợi bông, thường thô, không mịn như hàng tơ lụa: vải phin * vải pha nylon * học trò áo vải (học trò nghèo)",
    example: "vải phin * vải pha nylon * học trò áo vải (học trò nghèo)",
  },
  {
    word: "vải",
    part_of_speech: "danh từ",
    meaning:
      "hàng dệt bằng các loại sợi, dùng để may mặc nói chung: mua vải về may áo * chọn vải sáng màu",
    example: "mua vải về may áo * chọn vải sáng màu",
  },
  {
    word: "vại",
    part_of_speech: "danh từ",
    meaning: "đồ đựng bằng sành, gốm, hình trụ, lòng sâu: vại nước * vại dưa",
    example: "vại nước * vại dưa",
  },
  {
    word: "vại",
    part_of_speech: "danh từ",
    meaning: "(Khẩu ngữ) cốc vại (nói tắt): rủ bạn vào quán làm vài vại bia",
    example: "rủ bạn vào quán làm vài vại bia",
  },
  {
    word: "vai",
    part_of_speech: "danh từ",
    meaning:
      "phần cơ thể nối liền hai cánh tay (hoặc hai chân trước ở loài thú) với thân: quàng tay lên vai bạn * mua miếng thịt vai",
    example: "quàng tay lên vai bạn * mua miếng thịt vai",
  },
  {
    word: "vai",
    part_of_speech: "danh từ",
    meaning:
      "vai của con người, coi là biểu hiện của thứ bậc trên dưới trong quan hệ gia đình, họ hàng: vai dưới * những người vai trên",
    example: "vai dưới * những người vai trên",
  },
  {
    word: "vai",
    part_of_speech: "danh từ",
    meaning:
      "vai của con người, coi là biểu tượng của sức lực: chung vai gánh vác * kề vai sát cánh",
    example: "chung vai gánh vác * kề vai sát cánh",
  },
  {
    word: "vai",
    part_of_speech: "danh từ",
    meaning: "bộ phận của áo, che hai vai: áo sờn vai",
    example: "áo sờn vai",
  },
  {
    word: "vai",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận của một số vật, trông giống hình cái vai hoặc có tác dụng gánh, đỡ như cái vai: vai lọ * vai cày * vai giường",
    example: "vai lọ * vai cày * vai giường",
  },
  {
    word: "vai",
    part_of_speech: "danh từ",
    meaning:
      "nhân vật trong kịch bản được diễn viên thể hiện trong kịch hoặc trong phim: vai chính * phân vai diễn * thủ vai tên tướng cướp",
    example: "vai chính * phân vai diễn * thủ vai tên tướng cướp",
  },
  {
    word: "vài",
    part_of_speech: "danh từ",
    meaning:
      "số lượng rất ít, khoảng hai, ba: nhà chỉ có vài người * nói vài câu cho qua chuyện",
    example: "nhà chỉ có vài người * nói vài câu cho qua chuyện",
  },
  {
    word: "vài ba",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) như vài: nói vài ba câu chuyện * đơn cử vài ba ví dụ",
    example: "nói vài ba câu chuyện * đơn cử vài ba ví dụ",
  },
  {
    word: "vái lạy",
    part_of_speech: "động từ",
    meaning: "vừa vái vừa lạy (nói khái quát): vái lạy tổ tiên",
    example: "vái lạy tổ tiên",
  },
  {
    word: "vai vế",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) (hiếm) thứ bậc trên dưới trong quan hệ gia đình, họ hàng: tuy ít tuổi hơn, nhưng về vai vế lại là chú",
    example: "tuy ít tuổi hơn, nhưng về vai vế lại là chú",
  },
  {
    word: "vai vế",
    part_of_speech: "danh từ",
    meaning:
      "vị trí cao, quan trọng trong xã hội, do chức vụ, cấp bậc hay quyền lực mà có (nói khái quát): nhân vật vai vế * có vai vế trong làng",
    example: "nhân vật vai vế * có vai vế trong làng",
  },
  {
    word: "vai trò",
    part_of_speech: "danh từ",
    meaning:
      "tác dụng, chức năng của ai hoặc cái gì trong sự hoạt động, sự phát triển chung của một tập thể, một tổ chức: vai trò của người cha trong gia đình * tri thức giữ vai trò quyết định",
    example:
      "vai trò của người cha trong gia đình * tri thức giữ vai trò quyết định",
  },
  {
    word: "vải vóc",
    part_of_speech: "danh từ",
    meaning: "vải để may mặc (nói khái quát): lụa là vải vóc",
    example: "lụa là vải vóc",
  },
  {
    word: "vam",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ chuyên dùng với cấu tạo thích hợp có thể bám vào các chi tiết để tạo lực khi tháo hoặc lắp các chi tiết máy gắn với nhau bằng trục và lỗ: dùng vam để tháo vòng bi * vam phá khoá",
    example: "dùng vam để tháo vòng bi * vam phá khoá",
  },
  {
    word: "vạm vỡ",
    part_of_speech: "tính từ",
    meaning:
      "có thân hình to lớn, nở nang, rắn chắc, trông rất khoẻ mạnh (thường nói về đàn ông): người cao to vạm vỡ * cánh tay vạm vỡ",
    example: "người cao to vạm vỡ * cánh tay vạm vỡ",
  },
  {
    word: "vàn",
    part_of_speech: "tính từ",
    meaning:
      "(ruộng) ở độ cao trung bình, ít bị hạn hoặc úng, dễ canh tác: chân ruộng vàn",
    example: "chân ruộng vàn",
  },
  {
    word: "vàm",
    part_of_speech: "danh từ",
    meaning:
      "cửa sông, nơi rạch chảy ra sông hoặc sông con chảy ra sông lớn: vàm kênh * men theo các vàm sông",
    example: "vàm kênh * men theo các vàm sông",
  },
  {
    word: "vạn",
    part_of_speech: "danh từ",
    meaning: "số đếm, bằng mười nghìn: mua một vạn gạch",
    example: "mua một vạn gạch",
  },
  {
    word: "vạn",
    part_of_speech: "danh từ",
    meaning:
      "số lượng rất lớn, không xác định được: đường xa vạn dặm * trăm người bán vạn người mua",
    example: "đường xa vạn dặm * trăm người bán vạn người mua",
  },
  {
    word: "vạn",
    part_of_speech: "danh từ",
    meaning:
      "làng của những người làm nghề đánh cá, thường ở trên mặt sông: vạn chài",
    example: "vạn chài",
  },
  {
    word: "vạn",
    part_of_speech: "danh từ",
    meaning:
      "(Phương ngữ) tổ chức gồm những người cùng làm một nghề với nhau: vạn buôn * vạn cấy",
    example: "vạn buôn * vạn cấy",
  },
  {
    word: "vãn",
    part_of_speech: "",
    meaning:
      "có số lượng đã giảm dần đi đến mức chỉ còn lại không đáng kể, không còn đông, nhiều như lúc đầu: chợ đã vãn người * công việc đã vãn",
    example: "chợ đã vãn người * công việc đã vãn",
  },
  {
    word: "ván",
    part_of_speech: "danh từ",
    meaning: "tấm gỗ phẳng và mỏng: tấm ván * xẻ ván đóng thuyền",
    example: "tấm ván * xẻ ván đóng thuyền",
  },
  {
    word: "ván",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) áo quan: đóng ván * cỗ ván sơn son",
    example: "đóng ván * cỗ ván sơn son",
  },
  {
    word: "ván",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng lần được thua trong một số trò chơi hoặc môn thể thao: chơi thêm một ván cờ * đánh một ván cầu lông",
    example: "chơi thêm một ván cờ * đánh một ván cầu lông",
  },
  {
    word: "vạn chài",
    part_of_speech: "danh từ",
    meaning:
      "làng của những người sống trên sông nước, làm nghề chèo đò, đánh cá, v.v.; cũng dùng để chỉ nghề chài lưới: dân vạn chài * theo nghề vạn chài",
    example: "dân vạn chài * theo nghề vạn chài",
  },
  {
    word: "vãn cảnh",
    part_of_speech: "động từ",
    meaning: "đến để ngắm cảnh: đi vãn cảnh chùa",
    example: "đi vãn cảnh chùa",
  },
  {
    word: "vãn hồi",
    part_of_speech: "động từ",
    meaning:
      "làm cho trở lại tình trạng bình thường như trước đó: tình thế khó có thể vãn hồi",
    example: "tình thế khó có thể vãn hồi",
  },
  {
    word: "vạn bất đắc dĩ",
    part_of_speech: "",
    meaning:
      "như bất đắc dĩ (nhưng nghĩa mạnh hơn): vạn bất đắc dĩ mới phải dùng kế ấy",
    example: "vạn bất đắc dĩ mới phải dùng kế ấy",
  },
  {
    word: "vạn đò",
    part_of_speech: "danh từ",
    meaning: "như vạn chài: xóm vạn đò",
    example: "xóm vạn đò",
  },
  {
    word: "van lạy",
    part_of_speech: "động từ",
    meaning:
      "cầu xin một cách nhẫn nhục: van lạy rối rít * van lạy xin tha tội",
    example: "van lạy rối rít * van lạy xin tha tội",
  },
  {
    word: "van lơn",
    part_of_speech: "động từ",
    meaning:
      "cầu xin một cách khẩn khoản: giọng van lơn * nhìn bằng ánh mắt van lơn",
    example: "giọng van lơn * nhìn bằng ánh mắt van lơn",
  },
  {
    word: "vạn nhất",
    part_of_speech: "kết từ",
    meaning:
      "(cũ) từ biểu thị điều sắp nêu ra là điều không hay nào đó mà biết là rất ít có khả năng xảy ra: vạn nhất có việc gì phải báo ngay cho tôi biết",
    example: "vạn nhất có việc gì phải báo ngay cho tôi biết",
  },
  {
    word: "van nài",
    part_of_speech: "động từ",
    meaning:
      "cầu xin một cách tha thiết, dai dẳng: nói như van nài * ánh mắt van nài",
    example: "nói như van nài * ánh mắt van nài",
  },
  {
    word: "ván ngựa",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) ván đặt lên hai chân gỗ (gọi là cặp ngựa) để nằm: trong buồng có kê một bộ ván ngựa",
    example: "trong buồng có kê một bộ ván ngựa",
  },
  {
    word: "vạn năng",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều công dụng, có thể dùng với nhiều chức năng khác nhau: chìa khoá vạn năng",
    example: "chìa khoá vạn năng",
  },
  {
    word: "vạn tuế",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) muôn năm, muôn tuổi (thường dùng trong lời tung hô, chúc tụng): tung hô vạn tuế * đức vua vạn tuế!",
    example: "tung hô vạn tuế * đức vua vạn tuế!",
  },
  {
    word: "van vỉ",
    part_of_speech: "động từ",
    meaning:
      "cầu xin một cách khẩn khoản, tha thiết: van vỉ mãi cũng chẳng ích gì * giọng van vỉ",
    example: "van vỉ mãi cũng chẳng ích gì * giọng van vỉ",
  },
  {
    word: "vạn vật",
    part_of_speech: "danh từ",
    meaning:
      "muôn vật, muôn loài trong tự nhiên (nói khái quát): vạn vật hữu linh * bóng tối đã bao trùm lên vạn vật",
    example: "vạn vật hữu linh * bóng tối đã bao trùm lên vạn vật",
  },
  {
    word: "váng",
    part_of_speech: "danh từ",
    meaning:
      "lớp mỏng kết lại, đóng lại trên bề mặt của một chất lỏng: váng dầu * chậu nước đầy váng mỡ",
    example: "váng dầu * chậu nước đầy váng mỡ",
  },
  {
    word: "váng",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) mạng (nhện): quét váng nhện",
    example: "quét váng nhện",
  },
  {
    word: "váng",
    part_of_speech: "tính từ",
    meaning: "ở trạng thái hơi chóng mặt, khó chịu trong người: váng đầu",
    example: "váng đầu",
  },
  {
    word: "váng",
    part_of_speech: "tính từ",
    meaning:
      "vang to lên đến mức làm chói tai, khó chịu: hét váng nhà * khóc váng lên",
    example: "hét váng nhà * khóc váng lên",
  },
  {
    word: "váng",
    part_of_speech: "tính từ",
    meaning:
      "có cảm giác như không còn nghe được gì, do bị tác động của âm thanh có cường độ quá mạnh: tiếng sấm nổ váng tai",
    example: "tiếng sấm nổ váng tai",
  },
  {
    word: "van vát",
    part_of_speech: "tính từ",
    meaning: "hơi vát: khoai thái thành miếng van vát",
    example: "khoai thái thành miếng van vát",
  },
  {
    word: "van xin",
    part_of_speech: "động từ",
    meaning: "cầu xin một cách khẩn khoản, nhẫn nhục: van xin tha tội",
    example: "van xin tha tội",
  },
  {
    word: "vàng bạc",
    part_of_speech: "danh từ",
    meaning:
      "vàng và bạc (nói khái quát); thường dùng để chỉ những thứ quý giá: thì giờ là vàng bạc",
    example: "thì giờ là vàng bạc",
  },
  {
    word: "vàng",
    part_of_speech: "danh từ",
    meaning:
      "kim loại quý có màu vàng óng ánh, không gỉ, dễ dát mỏng và kéo sợi hơn các kim loại khác, thường dùng để làm đồ trang sức: dây chuyền vàng * lửa thử vàng gian nan thử sức (tng)",
    example: "dây chuyền vàng * lửa thử vàng gian nan thử sức (tng)",
  },
  {
    word: "vàng",
    part_of_speech: "danh từ",
    meaning:
      "cái rất đáng quý, ví như vàng: quỹ Tấm lòng vàng * gặp lại ông bạn vàng",
    example: "quỹ Tấm lòng vàng * gặp lại ông bạn vàng",
  },
  {
    word: "vàng",
    part_of_speech: "danh từ",
    meaning:
      "đồ làm bằng giấy giả hình vàng thoi, vàng lá để đốt cúng cho người chết theo tập tục dân gian (nói khái quát): đốt vàng * hoá vàng * tiền vàng",
    example: "đốt vàng * hoá vàng * tiền vàng",
  },
  {
    word: "vàng",
    part_of_speech: "tính từ",
    meaning:
      "có màu như màu của hoa mướp, của nghệ: vườn cam chín vàng * vàng như nghệ",
    example: "vườn cam chín vàng * vàng như nghệ",
  },
  {
    word: "vang",
    part_of_speech: "danh từ",
    meaning:
      "cây nhỡ có nhiều gai, hoa vàng, quả cứng, gỗ màu đỏ, thường dùng để nhuộm: đỏ như vang, vàng như nghệ",
    example: "đỏ như vang, vàng như nghệ",
  },
  {
    word: "vang",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) rượu vang (nói tắt): vang trắng * vang đỏ",
    example: "vang trắng * vang đỏ",
  },
  {
    word: "vang",
    part_of_speech: "danh từ",
    meaning:
      "có âm thanh to truyền đi dội lại mạnh và lan toả rộng ra xung quanh: âm thanh vang xa * tiếng chiêng trống vang trời",
    example: "âm thanh vang xa * tiếng chiêng trống vang trời",
  },
  {
    word: "vang dậy",
    part_of_speech: "động từ",
    meaning:
      "vang lên mạnh mẽ, như làm rung chuyển cả không gian: vỗ tay vang dậy * uy danh đã vang dậy khắp nơi",
    example: "vỗ tay vang dậy * uy danh đã vang dậy khắp nơi",
  },
  {
    word: "vang động",
    part_of_speech: "động từ",
    meaning:
      "vang lên và làm náo động xung quanh: tiếng reo hò vang động cả một vùng",
    example: "tiếng reo hò vang động cả một vùng",
  },
  {
    word: "vàng hoe",
    part_of_speech: "tính từ",
    meaning:
      "có màu vàng nhạt, nhưng tươi và ánh lên: tóc vàng hoe * nắng sớm vàng hoe",
    example: "tóc vàng hoe * nắng sớm vàng hoe",
  },
  {
    word: "vàng đá",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) như đá vàng: "Một niềm vàng đá khăng khăng, Ba thu cũng đợi chín trăng cũng chờ." (ca dao)',
    example:
      'Một niềm vàng đá khăng khăng, Ba thu cũng đợi chín trăng cũng chờ." (ca dao)',
  },
  {
    word: "vàng ệch",
    part_of_speech: "tính từ",
    meaning:
      "có màu vàng đục, trông rất xấu: da vàng ệch * ngọn đèn vàng ệch, leo lét",
    example: "da vàng ệch * ngọn đèn vàng ệch, leo lét",
  },
  {
    word: "vang dội",
    part_of_speech: "động từ",
    meaning:
      "vang và dội lên mạnh mẽ, truyền đi rất xa, rất rộng: tiếng chiêng trống vang dội khu rừng * chiến thắng vang dội",
    example: "tiếng chiêng trống vang dội khu rừng * chiến thắng vang dội",
  },
  {
    word: "vàng hươm",
    part_of_speech: "tính từ",
    meaning: "có màu vàng tươi và đều, nhìn đẹp mắt: nong kén vàng hươm",
    example: "nong kén vàng hươm",
  },
  {
    word: "vàng hực",
    part_of_speech: "tính từ",
    meaning:
      "có màu vàng đậm, tươi ánh lên: mặt trời vàng hực, toả hơi nóng như nung",
    example: "mặt trời vàng hực, toả hơi nóng như nung",
  },
  {
    word: "vãng lai",
    part_of_speech: "động từ",
    meaning: "qua lại (thường để thăm viếng): khách vãng lai",
    example: "khách vãng lai",
  },
  {
    word: "vàng khè",
    part_of_speech: "tính từ",
    meaning:
      "có màu vàng sẫm, tối, không đẹp mắt: nước chè bám vàng khè trên nền nhà",
    example: "nước chè bám vàng khè trên nền nhà",
  },
  {
    word: "vàng khé",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có màu vàng chói mắt, nhìn khó chịu: cái áo màu vàng khé",
    example: "cái áo màu vàng khé",
  },
  {
    word: "vang lừng",
    part_of_speech: "động từ",
    meaning:
      "vang lên và truyền đi rất xa, như ở đâu cũng nghe thấy: tiếng reo vang lừng * danh tiếng vang lừng",
    example: "tiếng reo vang lừng * danh tiếng vang lừng",
  },
  {
    word: "vàng mã",
    part_of_speech: "danh từ",
    meaning:
      "vàng và mã, đồ làm bằng giấy để đốt cúng cho người chết theo tín ngưỡng dân gian (nói khái quát): đốt vàng mã",
    example: "đốt vàng mã",
  },
  {
    word: "vàng mười",
    part_of_speech: "danh từ",
    meaning: "vàng nguyên chất: nén vàng mười",
    example: "nén vàng mười",
  },
  {
    word: "vàng ối",
    part_of_speech: "tính từ",
    meaning: "có màu vàng đậm và đều khắp: vườn cam chín vàng ối",
    example: "vườn cam chín vàng ối",
  },
  {
    word: "vàng rộm",
    part_of_speech: "tính từ",
    meaning:
      "có màu vàng sẫm, pha sắc đỏ, đều và khắp cả: mẻ bánh rán vàng rộm",
    example: "mẻ bánh rán vàng rộm",
  },
  {
    word: "vàng tây",
    part_of_speech: "danh từ",
    meaning: "hợp kim của vàng với một ít đồng: dây chuyền vàng tây",
    example: "dây chuyền vàng tây",
  },
  {
    word: "vàng son",
    part_of_speech: "danh từ",
    meaning:
      "chất liệu trang trí làm cho đẹp và bền, như vàng và son (nói khái quát); thường dùng trong văn chương để ví sự đẹp đẽ, rực rỡ: quá khứ vàng son * thời vàng son",
    example: "quá khứ vàng son * thời vàng son",
  },
  {
    word: "vàng ngọc",
    part_of_speech: "danh từ",
    meaning:
      "vàng và ngọc; dùng để ví cái hết sức quý giá: thì giờ vàng ngọc * lời vàng ngọc",
    example: "thì giờ vàng ngọc * lời vàng ngọc",
  },
  {
    word: "vang vọng",
    part_of_speech: "động từ",
    meaning: "vang tới, vọng tới từ xa: tiếng sóng vang vọng",
    example: "tiếng sóng vang vọng",
  },
  {
    word: "vàng vọt",
    part_of_speech: "tính từ",
    meaning:
      "có màu vàng nhợt nhạt, vẻ yếu ớt: mặt mũi xanh xao vàng vọt * nắng chiều vàng vọt",
    example: "mặt mũi xanh xao vàng vọt * nắng chiều vàng vọt",
  },
  {
    word: "vàng võ",
    part_of_speech: "tính từ",
    meaning:
      "có sắc da vàng trên gương mặt, trông hốc hác, bệnh tật: nước da vàng võ",
    example: "nước da vàng võ",
  },
  {
    word: "váng vất",
    part_of_speech: "tính từ",
    meaning: "váng (nói khái quát): đầu óc váng vất * người ngây ngấy váng vất",
    example: "đầu óc váng vất * người ngây ngấy váng vất",
  },
  {
    word: "vàng xuộm",
    part_of_speech: "tính từ",
    meaning: "như vàng ối: cỏ tranh vàng xuộm",
    example: "cỏ tranh vàng xuộm",
  },
  {
    word: "vành đai",
    part_of_speech: "danh từ",
    meaning:
      "dải đất bao quanh một khu vực, có quan hệ trực tiếp đối với khu vực ấy: vành đai thành phố * vành đai phòng thủ",
    example: "vành đai thành phố * vành đai phòng thủ",
  },
  {
    word: "vành móng ngựa",
    part_of_speech: "danh từ",
    meaning:
      "cái chắn hình móng ngựa đặt trong phòng xử án để bị cáo đứng trước toà: đứng trước vành móng ngựa",
    example: "đứng trước vành móng ngựa",
  },
  {
    word: "vành",
    part_of_speech: "danh từ",
    meaning:
      "vòng tròn bao quanh miệng hay ở phần ngoài cùng của một số vật để cho cứng, cho chắc: vành nón * cạp lại vành thúng",
    example: "vành nón * cạp lại vành thúng",
  },
  {
    word: "vành",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận vòng tròn bằng gỗ hoặc kim loại của bánh xe: xe bị cong vành * sơn vành xe",
    example: "xe bị cong vành * sơn vành xe",
  },
  {
    word: "vành",
    part_of_speech: "danh từ",
    meaning: "bộ phận ngoài cùng bao quanh một số vật: vành tai * mũ rộng vành",
    example: "vành tai * mũ rộng vành",
  },
  {
    word: "vành",
    part_of_speech: "danh từ",
    meaning:
      'từ dùng để chỉ một số loại vật có hình tròn: vành khăn trắng * "Đêm thu gió lọt song đào, Nửa vành trăng khuyết, ba sao giữa trời." (TKiều)',
    example:
      'vành khăn trắng * "Đêm thu gió lọt song đào, Nửa vành trăng khuyết, ba sao giữa trời." (TKiều)',
  },
  {
    word: "vành",
    part_of_speech: "động từ",
    meaning: "căng rộng ra, mở to hai bên ra: vành mắt ra mà nhìn cho rõ",
    example: "vành mắt ra mà nhìn cho rõ",
  },
  {
    word: "vành",
    part_of_speech: "danh từ",
    meaning:
      '(Khẩu ngữ) cách, mánh khoé: đủ mọi vành * "Bây giờ tình mới rõ tình, Thôi thôi đã mắc vào vành chẳng sai!" (TKiều)',
    example:
      'đủ mọi vành * "Bây giờ tình mới rõ tình, Thôi thôi đã mắc vào vành chẳng sai!" (TKiều)',
  },
  {
    word: "vào cầu",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) ví việc gặp may, có được mối làm ăn tốt, kiếm tiền dễ dàng: đang lúc vào cầu",
    example: "đang lúc vào cầu",
  },
  {
    word: "vanh vách",
    part_of_speech: "tính từ",
    meaning:
      "(nói, đọc) thông thạo, rõ ràng, một cách đáng ngạc nhiên: kể vanh vách tên từng người * em bé đọc báo vanh vách",
    example: "kể vanh vách tên từng người * em bé đọc báo vanh vách",
  },
  {
    word: "vào cuộc",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bắt đầu tham gia thật sự vào một việc quan trọng: bắt tay vào cuộc * các nhà chức trách đã vào cuộc",
    example: "bắt tay vào cuộc * các nhà chức trách đã vào cuộc",
  },
  {
    word: "vành vạnh",
    part_of_speech: "tính từ",
    meaning: "từ gợi tả dáng vẻ tròn đều và đầy đặn: trăng tròn vành vạnh",
    example: "trăng tròn vành vạnh",
  },
  {
    word: "vào khoảng",
    part_of_speech: "",
    meaning:
      "khoảng được xác định đại khái, gần đúng: vào khoảng nửa đêm * anh ta vào khoảng bốn mươi tuổi",
    example: "vào khoảng nửa đêm * anh ta vào khoảng bốn mươi tuổi",
  },
  {
    word: "vào hùa",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) theo nhau làm việc gì đó không tốt: vào hùa với nhau trêu bạn",
    example: "vào hùa với nhau trêu bạn",
  },
  {
    word: "vào đề",
    part_of_speech: "động từ",
    meaning: "mở đầu vấn đề định nói: vào đề luôn, không cần rào đón",
    example: "vào đề luôn, không cần rào đón",
  },
  {
    word: "vào",
    part_of_speech: "động từ",
    meaning:
      "di chuyển đến một vị trí ở phía trong, hẹp hơn, hoặc ở phía nam trong phạm vi nước Việt Nam: vào Nam ra Bắc * từ ngoài khơi vào đất liền * xe vào nội thành",
    example: "vào Nam ra Bắc * từ ngoài khơi vào đất liền * xe vào nội thành",
  },
  {
    word: "vào",
    part_of_speech: "động từ",
    meaning:
      "bắt đầu trở thành người của một tổ chức nào đó: vào biên chế * vào đoàn",
    example: "vào biên chế * vào đoàn",
  },
  {
    word: "vào",
    part_of_speech: "động từ",
    meaning:
      "bắt đầu tiến hành, tham gia một loại hoạt động nào đó, hoặc bước sang một đơn vị thời gian mới: làng vào đám * vào năm học mới * trời vào thu * vào sổ điểm",
    example: "làng vào đám * vào năm học mới * trời vào thu * vào sổ điểm",
  },
  {
    word: "vào",
    part_of_speech: "động từ",
    meaning:
      "tỏ ra đã theo đúng, không ra ngoài các quy định: vào khuôn phép * mọi việc đâu đã vào đấy",
    example: "vào khuôn phép * mọi việc đâu đã vào đấy",
  },
  {
    word: "vào",
    part_of_speech: "động từ",
    meaning:
      "ở trong khoảng thời gian xác định đại khái nào đó: vào dịp Tết * vào giờ này hôm qua",
    example: "vào dịp Tết * vào giờ này hôm qua",
  },
  {
    word: "vào",
    part_of_speech: "động từ",
    meaning:
      "thuộc một loại nào đó trong một hệ thống phân loại, đánh giá: vào loại ghê gớm * sức học vào loại khá",
    example: "vào loại ghê gớm * sức học vào loại khá",
  },
  {
    word: "vào",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) (học tập) thu nhận được, tiếp thu được: học không vào",
    example: "học không vào",
  },
  {
    word: "vào",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị sự vật hoặc điều sắp nêu ra là cái hướng tới, cái làm căn cứ cho hoạt động, cho điều vừa nói đến: quay mặt vào tường * phụ thuộc vào gia đình * dựa vào sức mình là chính",
    example:
      "quay mặt vào tường * phụ thuộc vào gia đình * dựa vào sức mình là chính",
  },
  {
    word: "vào",
    part_of_speech: "trợ từ",
    meaning:
      "(khẩu ngữ) từ biểu thị ý yêu cầu người đối thoại hãy làm việc gì đó với mức độ cao hơn, nhiều hơn: mặc cho thật ấm vào! * ăn nhiều vào cho khoẻ!",
    example: "mặc cho thật ấm vào! * ăn nhiều vào cho khoẻ!",
  },
  {
    word: "vào",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý phê phán, chê trách về một việc làm thái quá, với hàm ý sẽ dẫn đến hậu quả không hay là dĩ nhiên: ăn cho lắm vào rồi lại kêu đau bụng",
    example: "ăn cho lắm vào rồi lại kêu đau bụng",
  },
  {
    word: "vào mẩy",
    part_of_speech: "động từ",
    meaning: "(lúa) bắt đầu đọng sữa để kết hạt: lúa đang vào mẩy",
    example: "lúa đang vào mẩy",
  },
  {
    word: "vào luồn ra cúi",
    part_of_speech: "",
    meaning:
      'luồn cúi, quỵ luỵ để cầu cạnh danh lợi, bổng lộc: "Áo xiêm ràng buộc lấy nhau, Vào luồn ra cúi công hầu mà chi?" (TKiều)',
    example:
      'Áo xiêm ràng buộc lấy nhau, Vào luồn ra cúi công hầu mà chi?" (TKiều)',
  },
  {
    word: "vào tròng",
    part_of_speech: "động từ",
    meaning: "bị mắc mưu, bị sa vào bẫy: dụ địch vào tròng",
    example: "dụ địch vào tròng",
  },
  {
    word: "vào sổ",
    part_of_speech: "động từ",
    meaning:
      "ghi thành mục trong sổ sách để làm bằng, để theo dõi: vào sổ toàn bộ những khoản thu chi trong tháng",
    example: "vào sổ toàn bộ những khoản thu chi trong tháng",
  },
  {
    word: "vào vai",
    part_of_speech: "động từ",
    meaning:
      "(diễn viên) thể hiện nhân vật trong kịch bản trên sân khấu hoặc trong điện ảnh: vào vai một tên cướp",
    example: "vào vai một tên cướp",
  },
  {
    word: "vát",
    part_of_speech: "tính từ",
    meaning:
      "lệch sang một bên, tạo thành đường xiên chéo: chặt vát ống tre * miếng vải bị cắt vát",
    example: "chặt vát ống tre * miếng vải bị cắt vát",
  },
  {
    word: "vát",
    part_of_speech: "động từ",
    meaning: "(hiếm) như vạt: đầu gậy được vát nhọn",
    example: "đầu gậy được vát nhọn",
  },
  {
    word: "vay",
    part_of_speech: "động từ",
    meaning:
      "nhận tiền hay cái gì của người khác để sử dụng với điều kiện sẽ trả lại bằng cái cùng loại có số lượng hoặc giá trị tương đương: vay tiền * cho vay vốn * vay tạm mấy cân gạo",
    example: "vay tiền * cho vay vốn * vay tạm mấy cân gạo",
  },
  {
    word: "vay",
    part_of_speech: "động từ",
    meaning:
      '(thương, lo, v.v.) thay cho người khác, vì người khác, mà người đó vốn không có quan hệ gì với mình: thương vay khóc mướn * "Thấy nàng hiếu trọng tình thâm, Vì nàng, nghĩ cũng thương thầm xót vay." (TKiều)',
    example:
      'thương vay khóc mướn * "Thấy nàng hiếu trọng tình thâm, Vì nàng, nghĩ cũng thương thầm xót vay." (TKiều)',
  },
  {
    word: "vạt",
    part_of_speech: "danh từ",
    meaning: "thân áo: vạt trước * áo tứ thân có bốn vạt",
    example: "vạt trước * áo tứ thân có bốn vạt",
  },
  {
    word: "vạt",
    part_of_speech: "danh từ",
    meaning: "miếng đất hẹp, dài, thường dùng để trồng trọt: vạt rừng",
    example: "vạt rừng",
  },
  {
    word: "vạt",
    part_of_speech: "động từ",
    meaning: "đẽo xiên: vạt nhọn đoạn tre",
    example: "vạt nhọn đoạn tre",
  },
  {
    word: "váy",
    part_of_speech: "danh từ",
    meaning:
      "đồ mặc che phần thân dưới của phụ nữ, không chia làm hai ống như quần: váy cưới * váy dạ hội * mặc váy ngắn",
    example: "váy cưới * váy dạ hội * mặc váy ngắn",
  },
  {
    word: "váy",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) ngoáy (tai): váy tai",
    example: "váy tai",
  },
  {
    word: "vảy",
    part_of_speech: "danh từ",
    meaning:
      "mảnh nhỏ và cứng bằng chất sừng hay xương úp lên nhau ở một số động vật có xương sống, có chức năng bảo vệ cơ thể: vảy ốc * vảy cá",
    example: "vảy ốc * vảy cá",
  },
  {
    word: "vảy",
    part_of_speech: "danh từ",
    meaning: "vật mỏng và nhỏ có hình vảy: mụn đã tróc vảy",
    example: "mụn đã tróc vảy",
  },
  {
    word: "vày",
    part_of_speech: "danh từ",
    meaning: "dụng cụ để cuộn tơ hay chỉ: vày quay tơ",
    example: "vày quay tơ",
  },
  {
    word: "vạy",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) ách: vạy cày",
    example: "vạy cày",
  },
  {
    word: "váy áo",
    part_of_speech: "danh từ",
    meaning:
      "váy và áo, đồ mặc của phụ nữ (nói khái quát): sắm sửa váy áo * váy áo loè loẹt",
    example: "sắm sửa váy áo * váy áo loè loẹt",
  },
  {
    word: "vay lãi",
    part_of_speech: "động từ",
    meaning:
      "vay với điều kiện khi trả phải thêm một khoản ngoài cái gốc ban đầu theo tỉ lệ phần trăm, gọi là lãi: đi vay lãi * cho vay lãi",
    example: "đi vay lãi * cho vay lãi",
  },
  {
    word: "vay mượn",
    part_of_speech: "động từ",
    meaning: "vay (nói khái quát): bấn quá, đành phải vay mượn người quen",
    example: "bấn quá, đành phải vay mượn người quen",
  },
  {
    word: "vay mượn",
    part_of_speech: "động từ",
    meaning:
      "lấy cái đã có sẵn của người khác dùng làm của mình, thay cho việc tự mình sáng tạo ra (nói khái quát): vay mượn cốt truyện * từ vay mượn",
    example: "vay mượn cốt truyện * từ vay mượn",
  },
  {
    word: "vặn",
    part_of_speech: "động từ",
    meaning:
      "làm cho chuyển động theo một chiều nào đó của vòng quay: vặn vòi nước * vặn nhỏ ngọn đèn * vặn mình cho đỡ mỏi",
    example: "vặn vòi nước * vặn nhỏ ngọn đèn * vặn mình cho đỡ mỏi",
  },
  {
    word: "vặn",
    part_of_speech: "động từ",
    meaning:
      "xoắn hai đầu của những vật dài, mềm theo chiều ngược nhau cho chặt vào nhau, kết thành một vật nhất định: vặn thừng * vặn chổi",
    example: "vặn thừng * vặn chổi",
  },
  {
    word: "vặn",
    part_of_speech: "động từ",
    meaning:
      "hỏi và bắt phải trả lời cho rõ vào điều biết là lúng túng, khó trả lời: bị cô giáo vặn * hỏi vặn",
    example: "bị cô giáo vặn * hỏi vặn",
  },
  {
    word: "vằm",
    part_of_speech: "động từ",
    meaning:
      "chặt, bổ nhanh tay và liên tiếp bằng vật sắc cho nát vụn ra: vằm đất cho kĩ để gieo hạt * đồ chết vằm! (tiếng rủa)",
    example: "vằm đất cho kĩ để gieo hạt * đồ chết vằm! (tiếng rủa)",
  },
  {
    word: "vặc",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) tỏ sự không đồng ý bằng lời lẽ, thái độ gay gắt, khó chịu: hai chị em suốt ngày vặc nhau * vừa nghe nói đã vặc lại",
    example: "hai chị em suốt ngày vặc nhau * vừa nghe nói đã vặc lại",
  },
  {
    word: "văn",
    part_of_speech: "danh từ",
    meaning:
      "hình thức ngôn ngữ được trau chuốt cho hay, đẹp: câu văn * viết văn * văn hay chữ tốt (tng)",
    example: "câu văn * viết văn * văn hay chữ tốt (tng)",
  },
  {
    word: "văn",
    part_of_speech: "danh từ",
    meaning:
      "lối viết riêng của một tác giả văn học: văn Nguyễn Tuân * thích văn Nam Cao",
    example: "văn Nguyễn Tuân * thích văn Nam Cao",
  },
  {
    word: "văn",
    part_of_speech: "danh từ",
    meaning: "(Khẩu ngữ) văn học (nói tắt): tốt nghiệp khoa văn * ngành văn",
    example: "tốt nghiệp khoa văn * ngành văn",
  },
  {
    word: "văn",
    part_of_speech: "danh từ",
    meaning:
      "hoa văn (nói tắt): mặt trống có văn khắc chìm * tạo văn trên đồ gốm",
    example: "mặt trống có văn khắc chìm * tạo văn trên đồ gốm",
  },
  {
    word: "vắn",
    part_of_speech: "tính từ",
    meaning:
      '(cũ, hoặc ph) ngắn: "Sông sâu sào vắn khó dò, Muốn qua thăm bậu sợ đò không đưa." (ca dao)',
    example:
      'Sông sâu sào vắn khó dò, Muốn qua thăm bậu sợ đò không đưa." (ca dao)',
  },
  {
    word: "văn bản",
    part_of_speech: "danh từ",
    meaning:
      "bản viết hoặc in, mang nội dung nhất định, thường để lưu lại: văn bản chữ Nôm * văn bản kí kết giữa hai nước",
    example: "văn bản chữ Nôm * văn bản kí kết giữa hai nước",
  },
  {
    word: "văn bản",
    part_of_speech: "danh từ",
    meaning:
      "chuỗi kí hiệu ngôn ngữ hay nói chung những kí hiệu thuộc một hệ thống nào đó, làm thành một chỉnh thể mang một nội dung ý nghĩa trọn vẹn: văn bản hành chính",
    example: "văn bản hành chính",
  },
  {
    word: "vằn",
    part_of_speech: "danh từ",
    meaning:
      "những vệt màu lượn song song trên lông một số loài thú: lông hổ màu vàng có vằn đen",
    example: "lông hổ màu vàng có vằn đen",
  },
  {
    word: "vằn",
    part_of_speech: "động từ",
    meaning:
      "(mắt) nổi lên những tia máu đỏ, trông có vẻ hung dữ: mắt vằn lên, giận dữ",
    example: "mắt vằn lên, giận dữ",
  },
  {
    word: "văn bằng",
    part_of_speech: "danh từ",
    meaning:
      "(trang trọng) giấy chứng nhận tốt nghiệp hoặc chứng nhận học vị: cấp văn bằng * văn bằng tốt nghiệp đại học",
    example: "cấp văn bằng * văn bằng tốt nghiệp đại học",
  },
  {
    word: "văn chương",
    part_of_speech: "danh từ",
    meaning: "như văn học: tác phẩm văn chương",
    example: "tác phẩm văn chương",
  },
  {
    word: "văn chương",
    part_of_speech: "danh từ",
    meaning: "lời văn, câu văn (nói khái quát): văn chương cầu kì",
    example: "văn chương cầu kì",
  },
  {
    word: "văn cảnh",
    part_of_speech: "danh từ",
    meaning: "như ngữ cảnh: nghĩa của từ được xác định cụ thể trong văn cảnh",
    example: "nghĩa của từ được xác định cụ thể trong văn cảnh",
  },
  {
    word: "văn công",
    part_of_speech: "danh từ",
    meaning:
      "công tác biểu diễn nghệ thuật sân khấu: đoàn văn công * diễn viên văn công",
    example: "đoàn văn công * diễn viên văn công",
  },
  {
    word: "văn công",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) diễn viên văn công (nói tắt): cô văn công * trở thành văn công",
    example: "cô văn công * trở thành văn công",
  },
  {
    word: "văn bia",
    part_of_speech: "danh từ",
    meaning: "văn bản khắc trên bia đá, nói chung: soạn văn bia",
    example: "soạn văn bia",
  },
  {
    word: "văn đàn",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) diễn đàn văn học: nổi tiếng trên văn đàn * tranh luận trên văn đàn",
    example: "nổi tiếng trên văn đàn * tranh luận trên văn đàn",
  },
  {
    word: "văn giới",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) giới sáng tác, nghiên cứu văn học: một bậc đàn anh trong văn giới",
    example: "một bậc đàn anh trong văn giới",
  },
  {
    word: "văn đoàn",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) nhóm gồm những người sáng tác văn học, phê bình văn học có chung một khuynh hướng nghệ thuật: nhóm Tự Lực văn đoàn",
    example: "nhóm Tự Lực văn đoàn",
  },
  {
    word: "văn hoá",
    part_of_speech: "danh từ",
    meaning:
      "tổng thể nói chung những giá trị vật chất và tinh thần do con người sáng tạo ra trong quá trình lịch sử: kho tàng văn hoá dân tộc * văn hoá phương Tây",
    example: "kho tàng văn hoá dân tộc * văn hoá phương Tây",
  },
  {
    word: "văn hoá",
    part_of_speech: "danh từ",
    meaning:
      "những hoạt động của con người nhằm thoả mãn nhu cầu đời sống tinh thần (nói tổng quát): sinh hoạt văn hoá văn nghệ",
    example: "sinh hoạt văn hoá văn nghệ",
  },
  {
    word: "văn hoá",
    part_of_speech: "danh từ",
    meaning:
      "tri thức, kiến thức khoa học (nói khái quát): học văn hoá * trình độ văn hoá",
    example: "học văn hoá * trình độ văn hoá",
  },
  {
    word: "văn hoá",
    part_of_speech: "danh từ",
    meaning:
      "trình độ cao trong sinh hoạt xã hội, biểu hiện của văn minh: người thiếu văn hoá * cư xử rất có văn hoá",
    example: "người thiếu văn hoá * cư xử rất có văn hoá",
  },
  {
    word: "văn hoá",
    part_of_speech: "danh từ",
    meaning:
      "tổng thể nói chung những giá trị vật chất và tinh thần của một thời kì lịch sử cổ xưa, được xác định trên cơ sở một tổng thể những di vật tìm thấy được có những đặc điểm giống nhau: văn hoá Đông Sơn * văn hoá Sa Huỳnh",
    example: "văn hoá Đông Sơn * văn hoá Sa Huỳnh",
  },
  {
    word: "văn hào",
    part_of_speech: "danh từ",
    meaning:
      "nhà văn lỗi lạc: văn hào Lỗ Tấn * Lev Tolstoi là một đại văn hào Nga",
    example: "văn hào Lỗ Tấn * Lev Tolstoi là một đại văn hào Nga",
  },
  {
    word: "văn học",
    part_of_speech: "danh từ",
    meaning:
      "nghệ thuật dùng ngôn ngữ và hình tượng để thể hiện đời sống và xã hội con người: hình tượng văn học * tác phẩm văn học * nhà phê bình văn học",
    example: "hình tượng văn học * tác phẩm văn học * nhà phê bình văn học",
  },
  {
    word: "văn hoá phẩm",
    part_of_speech: "danh từ",
    meaning:
      "sản phẩm phục vụ đời sống văn hoá (nói khái quát): cửa hàng văn hoá phẩm",
    example: "cửa hàng văn hoá phẩm",
  },
  {
    word: "văn hiến",
    part_of_speech: "danh từ",
    meaning:
      "truyền thống văn hoá lâu đời và tốt đẹp của một dân tộc: đất nước ngàn năm văn hiến",
    example: "đất nước ngàn năm văn hiến",
  },
  {
    word: "văn hoa",
    part_of_speech: "tính từ",
    meaning:
      "bóng bẩy, hoa mĩ trong cách nói, cách viết, nhưng thường ít có nội dung: ăn nói văn hoa * lời lẽ văn hoa, bóng bẩy",
    example: "ăn nói văn hoa * lời lẽ văn hoa, bóng bẩy",
  },
  {
    word: "văn khoa",
    part_of_speech: "danh từ",
    meaning: "(cũ) khoa văn học: cử nhân văn khoa",
    example: "cử nhân văn khoa",
  },
  {
    word: "văn kiện",
    part_of_speech: "danh từ",
    meaning:
      "văn bản có ý nghĩa quan trọng về xã hội - chính trị: công bố các văn kiện của hội nghị",
    example: "công bố các văn kiện của hội nghị",
  },
  {
    word: "văn khế",
    part_of_speech: "danh từ",
    meaning: "(cũ) văn tự (trong mua bán): làm văn khế bán ruộng",
    example: "làm văn khế bán ruộng",
  },
  {
    word: "văn khố",
    part_of_speech: "danh từ",
    meaning:
      "kho lớn lưu trữ tài liệu, sách báo: bản gốc của cuốn sử được lưu trữ trong văn khố",
    example: "bản gốc của cuốn sử được lưu trữ trong văn khố",
  },
  {
    word: "văn liệu",
    part_of_speech: "danh từ",
    meaning: "tư liệu văn học: lấy văn liệu ở văn học dân gian",
    example: "lấy văn liệu ở văn học dân gian",
  },
  {
    word: "văn minh",
    part_of_speech: "danh từ",
    meaning:
      "trình độ phát triển đạt đến một mức nhất định của xã hội loài người, có nền văn hoá vật chất và tinh thần với những đặc trưng riêng: văn minh Ai Cập * nền văn minh nhân loại",
    example: "văn minh Ai Cập * nền văn minh nhân loại",
  },
  {
    word: "văn minh",
    part_of_speech: "tính từ",
    meaning:
      "có những đặc trưng của văn minh, của nền văn hoá phát triển cao: một xã hội văn minh * nếp sống văn minh",
    example: "một xã hội văn minh * nếp sống văn minh",
  },
  {
    word: "văn minh",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về giai đoạn phát triển thứ ba, sau thời đại dã man, trong lịch sử xã hội loài người kể từ khi có thuật luyện kim và chữ viết (theo phân kì lịch sử xã hội của L. H. Morgan): thời đại văn minh",
    example: "thời đại văn minh",
  },
  {
    word: "văn miếu",
    part_of_speech: "danh từ",
    meaning: "miếu thờ Khổng Tử: dựng văn miếu",
    example: "dựng văn miếu",
  },
  {
    word: "văn nghiệp",
    part_of_speech: "danh từ",
    meaning: "(cũ) sự nghiệp văn học: văn nghiệp của Nguyễn Trãi",
    example: "văn nghiệp của Nguyễn Trãi",
  },
  {
    word: "văn nhân",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) người có học thức, biết làm văn, làm thơ: "Trông chừng thấy một văn nhân, Lỏng buông tay khấu bước lần dặm băng." (TKiều)',
    example:
      'Trông chừng thấy một văn nhân, Lỏng buông tay khấu bước lần dặm băng." (TKiều)',
  },
  {
    word: "văn nghệ",
    part_of_speech: "danh từ",
    meaning:
      "văn học và nghệ thuật (nói tắt): hội văn nghệ * tác phẩm văn nghệ",
    example: "hội văn nghệ * tác phẩm văn nghệ",
  },
  {
    word: "văn nghệ",
    part_of_speech: "danh từ",
    meaning:
      "các hoạt động biểu diễn nghệ thuật như ca, múa, nhạc, v.v. phục vụ vui chơi, giải trí (nói khái quát): đi tập văn nghệ * liên hoan văn nghệ * buổi biểu diễn văn nghệ",
    example: "đi tập văn nghệ * liên hoan văn nghệ * buổi biểu diễn văn nghệ",
  },
  {
    word: "văn nghệ sĩ",
    part_of_speech: "danh từ",
    meaning: "người chuyên làm công tác văn học, nghệ thuật: giới văn nghệ sĩ",
    example: "giới văn nghệ sĩ",
  },
  {
    word: "văn phạm",
    part_of_speech: "danh từ",
    meaning: "(cũ) ngữ pháp: viết không đúng văn phạm",
    example: "viết không đúng văn phạm",
  },
  {
    word: "văn phái",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, hiếm) trường phái văn học; nhóm nhà văn có cùng một khuynh hướng nghệ thuật: văn phái lãng mạn",
    example: "văn phái lãng mạn",
  },
  {
    word: "văn phòng phẩm",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng cho công tác văn phòng, như giấy, bút, v.v. (nói khái quát): cửa hàng văn phòng phẩm",
    example: "cửa hàng văn phòng phẩm",
  },
  {
    word: "văn phòng",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận phụ trách công việc giấy tờ, hành chính trong một cơ quan: phụ trách văn phòng * cán bộ văn phòng",
    example: "phụ trách văn phòng * cán bộ văn phòng",
  },
  {
    word: "văn phong",
    part_of_speech: "danh từ",
    meaning: "phong cách viết riêng của mỗi nhà văn: văn phong của Nguyễn Tuân",
    example: "văn phong của Nguyễn Tuân",
  },
  {
    word: "vắn tắt",
    part_of_speech: "tính từ",
    meaning:
      "ngắn gọn, chỉ gồm những điểm cơ bản nhất: trình bày vắn tắt * thông báo tình hình một cách vắn tắt",
    example: "trình bày vắn tắt * thông báo tình hình một cách vắn tắt",
  },
  {
    word: "văn tế",
    part_of_speech: "danh từ",
    meaning:
      "loại văn thể hiện sự thương tiếc đối với người đã mất, thường có vần điệu, đọc trong lúc cúng tế: bài văn tế",
    example: "bài văn tế",
  },
  {
    word: "văn thân",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) nhà nho có tiếng trong xã hội cũ: Phan Chu Chinh là một văn thân yêu nước",
    example: "Phan Chu Chinh là một văn thân yêu nước",
  },
  {
    word: "văn thể",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) văn nghệ và thể dục, thể thao (nói gộp): tham gia các hoạt động văn thể",
    example: "tham gia các hoạt động văn thể",
  },
  {
    word: "văn sĩ",
    part_of_speech: "danh từ",
    meaning: "(cũ) nhà văn: các văn sĩ yêu nước * một văn sĩ mới nổi danh",
    example: "các văn sĩ yêu nước * một văn sĩ mới nổi danh",
  },
  {
    word: "văn vẻ",
    part_of_speech: "tính từ",
    meaning: "(cách nói, cách viết) chải chuốt, bóng bẩy: ăn nói rất văn vẻ",
    example: "ăn nói rất văn vẻ",
  },
  {
    word: "văn tự",
    part_of_speech: "danh từ",
    meaning: "(cũ) chữ viết: văn tự chữ Hán * nhận dạng văn tự",
    example: "văn tự chữ Hán * nhận dạng văn tự",
  },
  {
    word: "văn tự",
    part_of_speech: "danh từ",
    meaning:
      "giấy tờ do hai bên thoả thuận kí kết trong việc mua bán: văn tự bán nhà * bán trời không văn tự (tng)",
    example: "văn tự bán nhà * bán trời không văn tự (tng)",
  },
  {
    word: "văn thư",
    part_of_speech: "danh từ",
    meaning: "(hiếm) công văn, giấy tờ (nói khái quát): lưu trữ văn thư",
    example: "lưu trữ văn thư",
  },
  {
    word: "văn thư",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận của văn phòng phụ trách việc giao nhận và quản lí công văn, giấy tờ: cán bộ văn thư * công tác văn thư",
    example: "cán bộ văn thư * công tác văn thư",
  },
  {
    word: "văn thư",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) người làm công tác văn thư: cô văn thư * làm văn thư",
    example: "cô văn thư * làm văn thư",
  },
  {
    word: "văn võ",
    part_of_speech: "danh từ",
    meaning: "văn và võ (nói gộp): văn võ bá quan * văn võ song toàn",
    example: "văn võ bá quan * văn võ song toàn",
  },
  {
    word: "văn vật",
    part_of_speech: "danh từ",
    meaning:
      "truyền thống văn hoá tốt đẹp của một vùng, một dân tộc, biểu hiện ở nhiều nhân tài trong lịch sử và nhiều di tích lịch sử: đất nước ngàn năm văn vật",
    example: "đất nước ngàn năm văn vật",
  },
  {
    word: "vằn vện",
    part_of_speech: "tính từ",
    meaning:
      "(quần áo) có nhiều vệt màu trông tựa như những đường vằn trên lông một số loài thú: bọn lính dù mặc quần áo vằn vện",
    example: "bọn lính dù mặc quần áo vằn vện",
  },
  {
    word: "vằn vèo",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như ngoằn ngoèo: đường lên núi quanh co, vằn vèo",
    example: "đường lên núi quanh co, vằn vèo",
  },
  {
    word: "văng",
    part_of_speech: "danh từ",
    meaning:
      "thanh tre có gắn đinh ghim ở hai đầu, dùng để căng mặt vải, mặt hàng trên khung cửi cho thẳng: cắm văng",
    example: "cắm văng",
  },
  {
    word: "văng",
    part_of_speech: "động từ",
    meaning:
      "thình lình bị bật ra khỏi vị trí và di chuyển nhanh đến một chỗ nào đó, do phải chịu một tác động mạnh và đột ngột: cú hất làm quả bóng văng xa * văng mất một cái đinh ốc",
    example: "cú hất làm quả bóng văng xa * văng mất một cái đinh ốc",
  },
  {
    word: "văng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bật ra, phát ra những tiếng thô tục, chửi rủa, v.v.: văng ra một câu chửi * tính hay văng tục",
    example: "văng ra một câu chửi * tính hay văng tục",
  },
  {
    word: "văng",
    part_of_speech: "phụ từ",
    meaning: "(phương ngữ, khẩu ngữ) như phắt: làm văng đi",
    example: "làm văng đi",
  },
  {
    word: "vặn vẹo",
    part_of_speech: "động từ",
    meaning:
      "uốn qua uốn lại, nghiêng ngả theo nhiều hướng khác nhau: thân cây vặn vẹo theo chiều gió",
    example: "thân cây vặn vẹo theo chiều gió",
  },
  {
    word: "vặn vẹo",
    part_of_speech: "động từ",
    meaning:
      "bẻ gập qua lại theo nhiều hướng khác nhau: vặn vẹo hai tay * vặn vẹo chiếc mũ vải trong tay",
    example: "vặn vẹo hai tay * vặn vẹo chiếc mũ vải trong tay",
  },
  {
    word: "vặn vẹo",
    part_of_speech: "động từ",
    meaning: "hỏi vặn đi vặn lại: hỏi vặn vẹo * hơi một tí là vặn vẹo",
    example: "hỏi vặn vẹo * hơi một tí là vặn vẹo",
  },
  {
    word: "vặn vẹo",
    part_of_speech: "tính từ",
    meaning:
      "không thẳng, mà có nhiều chỗ cong, vặn theo nhiều hướng khác nhau: khúc gỗ vặn vẹo",
    example: "khúc gỗ vặn vẹo",
  },
  {
    word: "vắng",
    part_of_speech: "tính từ",
    meaning:
      "không có mặt, không xuất hiện ở một nơi nào đó như bình thường: mẹ vắng nhà * vắng chúa nhà gà vọc niêu tôm (tng)",
    example: "mẹ vắng nhà * vắng chúa nhà gà vọc niêu tôm (tng)",
  },
  {
    word: "vắng",
    part_of_speech: "tính từ",
    meaning:
      "không hoặc ít có người qua lại, lui tới hoạt động: quãng đường vắng * chợ vắng * cửa hàng vắng khách",
    example: "quãng đường vắng * chợ vắng * cửa hàng vắng khách",
  },
  {
    word: "vắng",
    part_of_speech: "tính từ",
    meaning:
      "yên ắng, không hoặc rất ít có biểu hiện của hoạt động con người: đêm thanh, cảnh vắng",
    example: "đêm thanh, cảnh vắng",
  },
  {
    word: "vắng bặt",
    part_of_speech: "tính từ",
    meaning:
      "vắng lâu và không hề có một chút tin tức nào: vắng bặt tin nhà * đi đâu mà vắng bặt mấy tháng trời",
    example: "vắng bặt tin nhà * đi đâu mà vắng bặt mấy tháng trời",
  },
  {
    word: "vằng",
    part_of_speech: "danh từ",
    meaning:
      "nông cụ dùng để cắt lúa, giống như cái hái, nhưng lưỡi cắt lắp ở phía ngoài: lưỡi vằng",
    example: "lưỡi vằng",
  },
  {
    word: "vằng",
    part_of_speech: "động từ",
    meaning: "(trâu, bò) dùng đầu và sừng hất quặt ngang để đánh.",
    example: "vằng mạnh đến nỗi đứt tung dây trói",
  },
  {
    word: "vằng",
    part_of_speech: "động từ",
    meaning:
      "dùng sức hất mạnh người sang hai bên để thoát khỏi sự níu giữ: vằng mạnh đến nỗi đứt tung dây trói",
    example: "vừa nghe nói đã vằng lại ngay",
  },
  {
    word: "vẳng",
    part_of_speech: "động từ",
    meaning:
      '(âm thanh) đưa lại từ xa: tiếng suối từ xa vẳng lại * "Vẳng nghe chim vịt kêu chiều, Bâng khuâng nhớ mẹ, chín chiều ruột đau." (ca dao)',
    example:
      'tiếng suối từ xa vẳng lại * "Vẳng nghe chim vịt kêu chiều, Bâng khuâng nhớ mẹ, chín chiều ruột đau." (ca dao)',
  },
  {
    word: "văng mạng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (làm việc gì) bất chấp, không kể đến hậu quả ra sao: ăn nói văng mạng",
    example: "ăn nói văng mạng",
  },
  {
    word: "vắng mặt",
    part_of_speech: "tính từ",
    meaning:
      "không có ở nơi lẽ ra phải có mặt: kết án tử hình vắng mặt * điểm danh xem những ai vắng mặt",
    example: "kết án tử hình vắng mặt * điểm danh xem những ai vắng mặt",
  },
  {
    word: "vắng lặng",
    part_of_speech: "tính từ",
    meaning: "vắng vẻ và lặng lẽ: làng xóm vắng lặng",
    example: "làng xóm vắng lặng",
  },
  {
    word: "vắng hoe",
    part_of_speech: "tính từ",
    meaning: "vắng, không thấy ai cả: đường phố vắng hoe",
    example: "đường phố vắng hoe",
  },
  {
    word: "vắng ngắt",
    part_of_speech: "tính từ",
    meaning: "vắng, không một bóng người: phố xá vắng ngắt",
    example: "phố xá vắng ngắt",
  },
  {
    word: "vắng teo",
    part_of_speech: "tính từ",
    meaning: "rất vắng, tạo cảm giác buồn: chợ vắng teo",
    example: "chợ vắng teo",
  },
  {
    word: "vắng tiếng",
    part_of_speech: "tính từ",
    meaning:
      "không thấy tiếng hoặc không thấy có tin tức hay dấu hiệu hoạt động trong một thời gian dài: vắng tiếng trên văn đàn",
    example: "vắng tiếng trên văn đàn",
  },
  {
    word: "vắng tanh",
    part_of_speech: "tính từ",
    meaning:
      "vắng đến mức như không có chút biểu hiện nào của hoạt động con người: chợ vắng tanh * mùa hè, sân trường vắng tanh",
    example: "chợ vắng tanh * mùa hè, sân trường vắng tanh",
  },
  {
    word: "văng tê",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) (làm việc gì) bừa đi, không kể gì hết: nói văng tê",
    example: "nói văng tê",
  },
  {
    word: "văng vẳng",
    part_of_speech: "động từ",
    meaning:
      "(âm thanh) vọng lại từ xa nhưng nghe không thật rõ lắm: tiếng gà văng vẳng * tiếng sáo vẫn văng vẳng bên tai",
    example: "tiếng gà văng vẳng * tiếng sáo vẫn văng vẳng bên tai",
  },
  {
    word: "vặt",
    part_of_speech: "động từ",
    meaning:
      "làm cho lông, lá đứt rời ra bằng cách nắm và giật mạnh về một phía: vặt lông gà * vặt từng nhúm cỏ",
    example: "vặt lông gà * vặt từng nhúm cỏ",
  },
  {
    word: "vặt",
    part_of_speech: "tính từ",
    meaning:
      "không đáng kể, nhưng thường có, thường xảy ra: chuyên đi ăn cắp vặt * chuyện vặt, không đáng kể * xin tiền tiêu vặt",
    example:
      "chuyên đi ăn cắp vặt * chuyện vặt, không đáng kể * xin tiền tiêu vặt",
  },
  {
    word: "vắng tin",
    part_of_speech: "tính từ",
    meaning:
      'không có tin tức gì (thường là của người thân ở xa) trong thời gian tương đối lâu: "Chờ chàng xuân mãn hè qua, Bông lan đã nở, sao mà vắng tin!" (ca dao)',
    example:
      'Chờ chàng xuân mãn hè qua, Bông lan đã nở, sao mà vắng tin!" (ca dao)',
  },
  {
    word: "vắng vẻ",
    part_of_speech: "tính từ",
    meaning:
      "vắng, không có người (nói khái quát): canh khuya vắng vẻ * đường quê vắng vẻ",
    example: "canh khuya vắng vẻ * đường quê vắng vẻ",
  },
  {
    word: "vằng vặc",
    part_of_speech: "tính từ",
    meaning:
      "(ánh trăng) rất sáng, không một chút gợn, khiến có thể nhìn rõ các vật: trăng sáng vằng vặc",
    example: "trăng sáng vằng vặc",
  },
  {
    word: "vắt chân chữ ngũ",
    part_of_speech: "",
    meaning:
      "(kiểu ngồi, nằm) gấp hai chân lại, chân nọ vắt ngang lên đầu gối chân kia (như hình chữ ngũ 五 của tiếng Hán): nằm bắt chân chữ ngũ",
    example: "nằm bắt chân chữ ngũ",
  },
  {
    word: "vắt",
    part_of_speech: "động từ",
    meaning:
      "bóp mạnh hoặc vặn xoắn bằng bàn tay để làm nước ở vật có chứa nước chảy ra hết: vắt chanh * vắt quần áo cho kĩ * vắt cổ chày ra nước (tng)",
    example: "vắt chanh * vắt quần áo cho kĩ * vắt cổ chày ra nước (tng)",
  },
  {
    word: "vắt",
    part_of_speech: "động từ",
    meaning:
      "giữ cơm còn nóng trong lòng bàn tay hoặc trong miếng vải mềm rồi bóp nhuyễn cho chặt lại thành khối: vắt cơm thành từng nắm",
    example: "vắt cơm thành từng nắm",
  },
  {
    word: "vắt",
    part_of_speech: "danh từ",
    meaning: "lượng cơm, xôi được tạo thành nắm: một vắt cơm * vắt xôi",
    example: "một vắt cơm * vắt xôi",
  },
  {
    word: "vắt",
    part_of_speech: "động từ",
    meaning:
      "đặt hoặc nằm ngang qua một vật khác và để cho buông thõng xuống: vắt quần áo lên dây * nằm vắt tay lên trán * con đường vắt ngang sườn núi",
    example:
      "vắt quần áo lên dây * nằm vắt tay lên trán * con đường vắt ngang sườn núi",
  },
  {
    word: "vắt óc",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) làm việc trí óc một cách hết sức căng thẳng: vắt óc suy nghĩ",
    example: "vắt óc suy nghĩ",
  },
  {
    word: "vặt vãnh",
    part_of_speech: "tính từ",
    meaning:
      "nhỏ nhặt, không đáng kể (nói khái quát): toàn chuyện vặt vãnh * buôn bán vặt vãnh để kiếm sống",
    example: "toàn chuyện vặt vãnh * buôn bán vặt vãnh để kiếm sống",
  },
  {
    word: "vắt mũi chưa sạch",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) nói người còn quá non trẻ, chưa biết gì (hàm ý mỉa mai, coi thường): vắt mũi chưa sạch đã ti toe",
    example: "vắt mũi chưa sạch đã ti toe",
  },
  {
    word: "vắt sổ",
    part_of_speech: "động từ",
    meaning: "may mép vải để sợi vải khỏi sổ ra: máy vắt sổ * vắt sổ kép",
    example: "máy vắt sổ * vắt sổ kép",
  },
  {
    word: "vẩn",
    part_of_speech: "động từ",
    meaning:
      'cuộn nổi chất bẩn lên làm mất đi sự trong lắng vốn có: "Tiếc thay nước đã đánh phèn, Mà cho bùn lại vẩn lên mấy lần!" (TKiều)',
    example:
      'Tiếc thay nước đã đánh phèn, Mà cho bùn lại vẩn lên mấy lần!" (TKiều)',
  },
  {
    word: "vận",
    part_of_speech: "danh từ",
    meaning:
      'sự may rủi lớn gặp phải, vốn đã được định sẵn từ trước một cách thần bí, theo quan niệm duy tâm: vận đỏ * "Nào hay sông cạn bể vùi, Lòng trời tráo trở vận người biệt li." (ATV)',
    example:
      'vận đỏ * "Nào hay sông cạn bể vùi, Lòng trời tráo trở vận người biệt li." (ATV)',
  },
  {
    word: "vận",
    part_of_speech: "động từ",
    meaning:
      "đưa hết sức lực, khả năng ra làm việc gì: vận gân cốt * vận hết lí lẽ để biện minh",
    example: "vận gân cốt * vận hết lí lẽ để biện minh",
  },
  {
    word: "vận",
    part_of_speech: "động từ",
    meaning:
      "tự gán vào, tự cho là có quan hệ đến: nghe chuyện người lại vận vào mình",
    example: "nghe chuyện người lại vận vào mình",
  },
  {
    word: "vận",
    part_of_speech: "động từ",
    meaning: "(Phương ngữ) mặc (quần áo): vận bộ đồ màu xanh",
    example: "vận bộ đồ màu xanh",
  },
  {
    word: "vậm vạp",
    part_of_speech: "tính từ",
    meaning: "to lớn và khoẻ: dáng người vậm vạp",
    example: "dáng người vậm vạp",
  },
  {
    word: "vắt vẻo",
    part_of_speech: "tính từ",
    meaning:
      "ở vị trí trên cao nhưng không có thế và chỗ dựa vững chắc, tựa như chỉ vắt ngang qua cái gì: ngồi vắt vẻo trên cành cây",
    example: "ngồi vắt vẻo trên cành cây",
  },
  {
    word: "vắt vẻo",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái buông thõng từ trên cao xuống và đưa qua đưa lại, vẻ mềm mại: buộc hai túm tóc vắt vẻo đằng sau",
    example: "buộc hai túm tóc vắt vẻo đằng sau",
  },
  {
    word: "vân",
    part_of_speech: "danh từ",
    meaning:
      "những đường cong lượn song song hình thành tự nhiên trên mặt gỗ, trên mặt đá hay ở đầu ngón tay: lấy dấu vân tay * vân đá * gỗ lát có nhiều vân",
    example: "lấy dấu vân tay * vân đá * gỗ lát có nhiều vân",
  },
  {
    word: "vân",
    part_of_speech: "danh từ",
    meaning:
      "hàng dệt bằng tơ trên mặt có những đường tựa như vân: tấm lụa vân",
    example: "tấm lụa vân",
  },
  {
    word: "vần",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận chủ yếu của âm tiết trong tiếng Việt, không có phụ âm đầu và thanh điệu: ,  * ,  *  có cùng một vần",
    example: ",  * ,  *  có cùng một vần",
  },
  {
    word: "vần",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận cần và đủ để tạo thành âm tiết trong tiếng Việt, không có phụ âm đầu: vần bằng * vần trắc * ,  *  có cùng một vần",
    example: "vần bằng * vần trắc * ,  *  có cùng một vần",
  },
  {
    word: "vần",
    part_of_speech: "danh từ",
    meaning:
      "tổ hợp các con chữ phụ âm với con chữ nguyên âm, ghép lại với nhau để viết các âm tiết trong tiếng Việt: tập ghép vần * học đánh vần",
    example: "tập ghép vần * học đánh vần",
  },
  {
    word: "vần",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) chữ cái đứng đầu của một từ, về mặt dùng làm căn cứ để xếp các từ trong một danh sách: xếp tên theo vần * mục từ  *  ở vần C",
    example: "xếp tên theo vần * mục từ  *  ở vần C",
  },
  {
    word: "vần",
    part_of_speech: "danh từ",
    meaning:
      "hiện tượng có vần được lặp lại hoặc gần giống nhau giữa những âm tiết có vị trí nhất định trong câu (thường là câu thơ) để tạo nhịp điệu và tăng sức gợi cảm: gieo vần * vần hơi ép",
    example: "gieo vần * vần hơi ép",
  },
  {
    word: "vần",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) câu thơ: mấy vần thơ xuân",
    example: "mấy vần thơ xuân",
  },
  {
    word: "vần",
    part_of_speech: "tính từ",
    meaning:
      "(thơ, văn) có vần, nghe hay và dễ nhớ: câu thơ không được vần lắm",
    example: "câu thơ không được vần lắm",
  },
  {
    word: "vấn",
    part_of_speech: "động từ",
    meaning: "quấn thành vòng: vấn điếu thuốc lá * tóc vấn đuôi gà",
    example: "vấn điếu thuốc lá * tóc vấn đuôi gà",
  },
  {
    word: "vần chân",
    part_of_speech: "danh từ",
    meaning: "vần ở những âm tiết cuối cùng của các câu thơ: gieo vần chân",
    example: "gieo vần chân",
  },
  {
    word: "vấn an",
    part_of_speech: "động từ",
    meaning: "(cũ, trang trọng) hỏi thăm sức khoẻ người bề trên: vấn an cha mẹ",
    example: "vấn an cha mẹ",
  },
  {
    word: "vận chuyển",
    part_of_speech: "động từ",
    meaning:
      "mang chuyển đồ vật, hàng hoá đến một nơi khác tương đối xa, bằng phương tiện nào đó: vận chuyển hàng hoá * phương tiện vận chuyển",
    example: "vận chuyển hàng hoá * phương tiện vận chuyển",
  },
  {
    word: "vẫn",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị sự tiếp tục, tiếp diễn như trước của hành động, trạng thái, tính chất nào đó mà không có gì thay đổi, vào thời điểm nói đến: quả vẫn còn xanh * trời vẫn tối * vẫn ông ta làm chủ nhiệm",
    example: "quả vẫn còn xanh * trời vẫn tối * vẫn ông ta làm chủ nhiệm",
  },
  {
    word: "vẫn",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị ý khẳng định về điều xảy ra, diễn ra như bình thường, cho dù điều kiện là không bình thường: khó vẫn phải làm * nghèo vẫn hoàn nghèo * nói mãi vẫn thế",
    example: "khó vẫn phải làm * nghèo vẫn hoàn nghèo * nói mãi vẫn thế",
  },
  {
    word: "vẫn",
    part_of_speech: "phụ từ",
    meaning:
      'từ biểu thị ý khẳng định về một sự đánh giá, cho là hơn hoặc là kém so với cái đưa ra để đối chiếu, so sánh, tuy rằng cái này đã được đánh giá là tốt: có vẫn hơn không * "Ta về ta tắm ao ta, Dù trong dù đục ao nhà vẫn hơn." (ca dao)',
    example:
      'có vẫn hơn không * "Ta về ta tắm ao ta, Dù trong dù đục ao nhà vẫn hơn." (ca dao)',
  },
  {
    word: "vấn đề",
    part_of_speech: "danh từ",
    meaning:
      "điều cần được xem xét, nghiên cứu, giải quyết: vấn đề thời sự * lật ngược vấn đề * giải quyết vấn đề",
    example: "vấn đề thời sự * lật ngược vấn đề * giải quyết vấn đề",
  },
  {
    word: "vận động",
    part_of_speech: "động từ",
    meaning:
      "(hiện tượng) thay đổi vị trí không ngừng của vật thể trong quan hệ với những vật thể khác.",
    example: "chịu khó vận động cho cơ thể khoẻ mạnh * lười vận động",
  },
  {
    word: "vận động",
    part_of_speech: "động từ",
    meaning:
      "thay đổi tư thế, vị trí của thân thể hay bộ phận cơ thể, về mặt có tác dụng giữ gìn và tăng cường sức khoẻ: chịu khó vận động cho cơ thể khoẻ mạnh * lười vận động",
    example: "lối đánh vận động",
  },
  {
    word: "vận động",
    part_of_speech: "động từ",
    meaning: "di chuyển, thay đổi vị trí trong chiến đấu: lối đánh vận động",
    example: "vận động nhân dân ủng hộ đồng bào bị lũ lụt * vận động tranh cử",
  },
  {
    word: "vần công",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) đổi công lao động: làm vần công",
    example: "làm vần công",
  },
  {
    word: "vấn đáp",
    part_of_speech: "động từ",
    meaning: "hỏi và trả lời (nói khái quát): thi vấn đáp",
    example: "thi vấn đáp",
  },
  {
    word: "vận dụng",
    part_of_speech: "động từ",
    meaning:
      "đem tri thức, lí luận áp dụng vào thực tiễn: vận dụng những kiến thức đã học trong trường",
    example: "vận dụng những kiến thức đã học trong trường",
  },
  {
    word: "vận động viên",
    part_of_speech: "danh từ",
    meaning:
      "người chuyên luyện tập, thi đấu và biểu diễn một môn thể thao nhất định: vận động viên bơi lội",
    example: "vận động viên bơi lội",
  },
  {
    word: "vận đơn",
    part_of_speech: "danh từ",
    meaning:
      "chứng từ cấp cho người gửi hàng, xác nhận trách nhiệm chuyên chở hàng tới nơi quy định và giao cho người nhận hàng: vận đơn đường biển",
    example: "vận đơn đường biển",
  },
  {
    word: "vẩn đục",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái có nhiều gợn bẩn nổi lên, làm cho không còn trong sạch nữa: dòng nước gợn bùn, vẩn đục * tâm hồn bị vẩn đục",
    example: "dòng nước gợn bùn, vẩn đục * tâm hồn bị vẩn đục",
  },
  {
    word: "vận hạn",
    part_of_speech: "danh từ",
    meaning:
      "điều không may lớn gặp phải do số phận, theo quan niệm duy tâm (nói khái quát): vận hạn đen đủi * gặp lúc vận hạn",
    example: "vận hạn đen đủi * gặp lúc vận hạn",
  },
  {
    word: "vận hành",
    part_of_speech: "động từ",
    meaning:
      "(máy móc, thiết bị) hoạt động, làm việc hoặc được làm cho hoạt động, làm việc: quy tắc vận hành máy",
    example: "quy tắc vận hành máy",
  },
  {
    word: "vần lưng",
    part_of_speech: "danh từ",
    meaning:
      "vần ở giữa câu: đổ mồ hôi trán, dán mồ hôi lưng' là câu có vần lưng",
    example: "đổ mồ hôi trán, dán mồ hôi lưng' là câu có vần lưng",
  },
  {
    word: "vận khí",
    part_of_speech: "danh từ",
    meaning:
      "chiều hướng phát triển tốt, xấu của sự vật, sự việc theo quy luật tự nhiên, tại một thời điểm cụ thể, theo thuật phong thuỷ: vận khí xấu",
    example: "vận khí xấu",
  },
  {
    word: "vận hội",
    part_of_speech: "danh từ",
    meaning:
      "sự may rủi, thịnh suy lớn được định sẵn từ trước một cách thần bí, theo quan niệm duy tâm: vận hội đã suy",
    example: "vận hội đã suy",
  },
  {
    word: "vận mệnh",
    part_of_speech: "danh từ",
    meaning:
      "cuộc sống nói chung, về mặt những điều hay dở, được mất đang đón chờ: vận mệnh quốc gia * một dân tộc được làm chủ vận mệnh của mình",
    example: "vận mệnh quốc gia * một dân tộc được làm chủ vận mệnh của mình",
  },
  {
    word: "vấn nạn",
    part_of_speech: "danh từ",
    meaning:
      "vấn đề khó khăn lớn có tính chất xã hội, đang phải đương đầu đối phó một cách cấp thiết: giải quyết dứt điểm vấn nạn dạy học thêm * vấn nạn tham nhũng",
    example: "giải quyết dứt điểm vấn nạn dạy học thêm * vấn nạn tham nhũng",
  },
  {
    word: "vần ngược",
    part_of_speech: "danh từ",
    meaning:
      "vần ghép con chữ phụ âm sau các con chữ nguyên âm trong chữ quốc ngữ; phân biệt với vần xuôi: ,  * ,  *  là những vần ngược",
    example: ",  * ,  *  là những vần ngược",
  },
  {
    word: "vận tốc",
    part_of_speech: "danh từ",
    meaning:
      "Cách nói tắt của véc tơ vận tốc tức thời, nó là đại lượng vật lí đặc trưng cho trạng thái chuyển động của vật về mặt nhanh hay chậm và hướng chuyển động tại thời điểm nào đó: Ví dụ:",
    example: "Ví dụ:",
  },
  {
    word: "vận tải",
    part_of_speech: "động từ",
    meaning:
      "chuyên chở người hoặc đồ vật, hàng hoá trên quãng đường tương đối dài: vận tải hàng hoá",
    example: "vận tải hàng hoá",
  },
  {
    word: "vận trù",
    part_of_speech: "động từ",
    meaning:
      "tính toán, lo liệu các vấn đề về sắp xếp, tổ chức: vận trù phương án",
    example: "vận trù phương án",
  },
  {
    word: "vận số",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ những điều may rủi lớn đã được định sẵn một cách thần bí, theo mê tín: tin vào vận số",
    example: "tin vào vận số",
  },
  {
    word: "vân vân",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) như vân vi: "Nén hương đến trước Phật đài, Nỗi lòng khấn chửa cạn lời vân vân." (TKiều)',
    example:
      'Nén hương đến trước Phật đài, Nỗi lòng khấn chửa cạn lời vân vân." (TKiều)',
  },
  {
    word: "vần vè",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có vần với nhau, tựa như trong thơ: hay nói những câu vần vè",
    example: "hay nói những câu vần vè",
  },
  {
    word: "vân vê",
    part_of_speech: "động từ",
    meaning: "vê đi vê lại nhiều lần một cách nhẹ nhàng: tay vân vê tà áo",
    example: "tay vân vê tà áo",
  },
  {
    word: "vấn vít",
    part_of_speech: "động từ",
    meaning:
      "quấn lại, xoắn lại nhiều vòng với nhau: những sợi tơ hồng vấn vít",
    example: "những sợi tơ hồng vấn vít",
  },
  {
    word: "vấn vít",
    part_of_speech: "động từ",
    meaning:
      'vương vấn trong trí, trong lòng: mối sầu vấn vít * "Nàng còn đứng tựa hiên tây, Chín hồi vấn vít như vầy mối tơ." (TKiều)',
    example:
      'mối sầu vấn vít * "Nàng còn đứng tựa hiên tây, Chín hồi vấn vít như vầy mối tơ." (TKiều)',
  },
  {
    word: "vần vò",
    part_of_speech: "động từ",
    meaning:
      "xoay trở, vò nắn liên tục trong tay: không biết nói gì, cứ vần vò cái mũ",
    example: "không biết nói gì, cứ vần vò cái mũ",
  },
  {
    word: "vân vi",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) đầu đuôi mọi lẽ, đầu đuôi sự tình: "Cúc Hoa nghe nói thương thay, Lạy trình cha mẹ giãi bày vân vi." (PCCH)',
    example:
      'Cúc Hoa nghe nói thương thay, Lạy trình cha mẹ giãi bày vân vi." (PCCH)',
  },
  {
    word: "vân vũ",
    part_of_speech: "danh từ",
    meaning: "(cũ, hiếm) mây và mưa (nói khái quát): vân vũ đầy trời",
    example: "vân vũ đầy trời",
  },
  {
    word: "vẩn vơ",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái suy nghĩ, nói năng hay đi lại mà không ý thức rõ mình muốn gì, nhằm vào cái gì, lí do tại sao: đi vẩn vơ ngoài đường * nghĩ ngợi vẩn vơ",
    example: "đi vẩn vơ ngoài đường * nghĩ ngợi vẩn vơ",
  },
  {
    word: "vần vũ",
    part_of_speech: "động từ",
    meaning:
      "(trời mây) chuyển động cuồn cuộn báo hiệu cơn mưa: mây đen vần vũ",
    example: "mây đen vần vũ",
  },
  {
    word: "vận xuất",
    part_of_speech: "động từ",
    meaning: "đưa ra, chuyển ra khỏi nơi khai thác: vận xuất than",
    example: "vận xuất than",
  },
  {
    word: "vấn vương",
    part_of_speech: "động từ",
    meaning: "như vương vấn: lòng còn vấn vương",
    example: "lòng còn vấn vương",
  },
  {
    word: "vâng",
    part_of_speech: "động từ",
    meaning:
      "nghe theo, tuân theo lời sai bảo, dạy bảo: vâng lời cha mẹ * vâng mệnh nhà vua",
    example: "vâng lời cha mẹ * vâng mệnh nhà vua",
  },
  {
    word: "vâng",
    part_of_speech: "cảm từ",
    meaning:
      "tiếng dùng để đáp lại lời người khác một cách lễ phép, tỏ ý nghe theo, ưng thuận hoặc thừa nhận điều người đối thoại hỏi đến: (- nhớ học bài nhé!) - vâng!",
    example: "(- nhớ học bài nhé!) - vâng!",
  },
  {
    word: "vần xuôi",
    part_of_speech: "danh từ",
    meaning:
      "vần ghép con chữ phụ âm trước các con chữ nguyên âm trong chữ quốc ngữ; phân biệt với vần ngược: ,  * ,  * ,  *  là những vần xuôi",
    example: ",  * ,  * ,  *  là những vần xuôi",
  },
  {
    word: "vầng",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị một số vật thể hình tròn: vầng trăng * vầng thái dương * vầng hào quang",
    example: "vầng trăng * vầng thái dương * vầng hào quang",
  },
  {
    word: "vâng dạ",
    part_of_speech: "động từ",
    meaning:
      "đáp lại lời sai bảo một cách lễ phép bằng những tiếng vâng và dạ, tỏ ý nghe theo, vâng theo: chỉ vâng dạ để đấy * vâng dạ rối rít",
    example: "chỉ vâng dạ để đấy * vâng dạ rối rít",
  },
  {
    word: "vầng dương",
    part_of_speech: "danh từ",
    meaning: "(văn chương) mặt trời: vầng dương chói lọi",
    example: "vầng dương chói lọi",
  },
  {
    word: "vấp",
    part_of_speech: "động từ",
    meaning:
      "đụng mạnh chân vào một vật, do vô ý lúc đang đi: vấp phải viên gạch, suýt ngã",
    example: "vấp phải viên gạch, suýt ngã",
  },
  {
    word: "vấp",
    part_of_speech: "động từ",
    meaning:
      "ngắc ngứ, không lưu loát, không trôi chảy: học lớp 3 rồi mà đọc vẫn còn vấp * mất bình tĩnh nên càng nói càng vấp",
    example:
      "học lớp 3 rồi mà đọc vẫn còn vấp * mất bình tĩnh nên càng nói càng vấp",
  },
  {
    word: "vấp",
    part_of_speech: "động từ",
    meaning:
      "gặp phải trở ngại hoặc thất bại một cách bất ngờ: vấp phải ổ phục kích của địch",
    example: "vấp phải ổ phục kích của địch",
  },
  {
    word: "vập",
    part_of_speech: "động từ",
    meaning:
      "bị đập mạnh và đột ngột (thường là đầu, mặt) vào vật cứng: ngã vập mặt xuống đất * vập đầu vào tường",
    example: "ngã vập mặt xuống đất * vập đầu vào tường",
  },
  {
    word: "vầng đông",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương) vầng sáng ở phương đông; dùng để chỉ mặt trời buổi sáng sớm: vầng đông le lói phía chân trời",
    example: "vầng đông le lói phía chân trời",
  },
  {
    word: "vấp váp",
    part_of_speech: "động từ",
    meaning:
      "bị vấp, không lưu loát, trôi chảy (nói khái quát): nói một hơi, không hề vấp váp",
    example: "nói một hơi, không hề vấp váp",
  },
  {
    word: "vấp váp",
    part_of_speech: "động từ",
    meaning:
      "vấp phải trở ngại hoặc thất bại (nói khái quát): mới bắt tay vào công việc, tránh sao khỏi vấp váp",
    example: "mới bắt tay vào công việc, tránh sao khỏi vấp váp",
  },
  {
    word: "vấp váp",
    part_of_speech: "danh từ",
    meaning:
      "trở ngại, thất bại vấp phải (nói khái quát): gặp nhiều vấp váp trên đường đời",
    example: "gặp nhiều vấp váp trên đường đời",
  },
  {
    word: "vấp ngã",
    part_of_speech: "động từ",
    meaning:
      "thất bại, sa ngã do thiếu kinh nghiệm, thiếu hiểu biết: bị vấp ngã trên đường đời * có vấp ngã mới có thành công",
    example: "bị vấp ngã trên đường đời * có vấp ngã mới có thành công",
  },
  {
    word: "vật chứng",
    part_of_speech: "danh từ",
    meaning:
      "vật được dùng làm công cụ, phương tiện phạm tội, có giá trị chứng minh tội phạm: cố ý làm hỏng vật chứng của vụ án * chưa tìm ra vật chứng",
    example: "cố ý làm hỏng vật chứng của vụ án * chưa tìm ra vật chứng",
  },
  {
    word: "vất",
    part_of_speech: "tính từ",
    meaning: "(Khẩu ngữ) vất vả (nói tắt): ít người nên làm hơi vất",
    example: "ít người nên làm hơi vất",
  },
  {
    word: "vật chất",
    part_of_speech: "danh từ",
    meaning:
      "hiện thực khách quan tồn tại ở bên ngoài ý thức của con người và độc lập đối với ý thức: thế giới vật chất",
    example: "thế giới vật chất",
  },
  {
    word: "vật chất",
    part_of_speech: "danh từ",
    meaning:
      "những thứ thuộc về nhu cầu thể xác của con người như ăn uống, ăn mặc, đi lại, v.v. (nói khái quát): đời sống vật chất",
    example: "đời sống vật chất",
  },
  {
    word: "vật đổi sao dời",
    part_of_speech: "",
    meaning:
      '(văn chương) mọi vật đổi thay: "Dẫu rằng vật đổi sao dời, Tử sinh, cũng giữ lấy lời tử sinh!" (TKiều)',
    example:
      'Dẫu rằng vật đổi sao dời, Tử sinh, cũng giữ lấy lời tử sinh!" (TKiều)',
  },
  {
    word: "vật dụng",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) đồ dùng thường ngày trong sinh hoạt: mua sắm vật dụng trong gia đình",
    example: "mua sắm vật dụng trong gia đình",
  },
  {
    word: "vật",
    part_of_speech: "danh từ",
    meaning:
      "cái có hình khối, tồn tại trong không gian, có thể nhận biết được: vật báu * của ngon vật lạ (tng)",
    example: "vật báu * của ngon vật lạ (tng)",
  },
  {
    word: "vật",
    part_of_speech: "danh từ",
    meaning: "thú vật, súc vật (nói tắt): giống vật * con vật",
    example: "giống vật * con vật",
  },
  {
    word: "vật",
    part_of_speech: "động từ",
    meaning:
      "ôm, túm lấy nhau và dùng sức cố làm cho đối phương ngã xuống: chơi vật nhau * đấu vật",
    example: "chơi vật nhau * đấu vật",
  },
  {
    word: "vật",
    part_of_speech: "động từ",
    meaning:
      "ngã mạnh, như đổ cả thân thể xuống: nghe tin dữ, ngã vật xuống * nằm vật ra",
    example: "nghe tin dữ, ngã vật xuống * nằm vật ra",
  },
  {
    word: "vật",
    part_of_speech: "động từ",
    meaning:
      "đưa cơ thể hoặc bộ phận cơ thể lên rồi quật mạnh xuống hoặc lăn đi lộn lại nhiều lần: vật mình than khóc",
    example: "vật mình than khóc",
  },
  {
    word: "vật",
    part_of_speech: "động từ",
    meaning:
      "làm nghiêng mạnh, ngả hẳn sang một bên: gió vật cây cối nghiêng ngả",
    example: "gió vật cây cối nghiêng ngả",
  },
  {
    word: "vật",
    part_of_speech: "động từ",
    meaning: "(cá) vật vã, quẫy mạnh khi đẻ trứng: cá vật đẻ * mùa cá vật",
    example: "cá vật đẻ * mùa cá vật",
  },
  {
    word: "vật",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) giết thịt (súc vật loại lớn): vật bò khao quân * vật con lợn để ăn mừng",
    example: "vật bò khao quân * vật con lợn để ăn mừng",
  },
  {
    word: "vật",
    part_of_speech: "động từ",
    meaning:
      "(thần linh) làm cho đau ốm hoặc chết đột ngột, theo mê tín: trời đánh, thánh vật * trót báng bổ, sợ bị thần vật",
    example: "trời đánh, thánh vật * trót báng bổ, sợ bị thần vật",
  },
  {
    word: "vật chủ",
    part_of_speech: "danh từ",
    meaning:
      "sinh vật mang các loài kí sinh: bọ chét sống kí sinh trên một số vật chủ như mèo, chó, v.v",
    example: "bọ chét sống kí sinh trên một số vật chủ như mèo, chó, v.v",
  },
  {
    word: "vật giá",
    part_of_speech: "danh từ",
    meaning:
      "giá cả của các loại hàng hoá và dịch vụ: ổn định vật giá * ban vật giá chính phủ",
    example: "ổn định vật giá * ban vật giá chính phủ",
  },
  {
    word: "vật lí",
    part_of_speech: "danh từ",
    meaning: "vật lí học (nói tắt): môn vật lí",
    example: "môn vật lí",
  },
  {
    word: "vật lí",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về vật lí học, có tính chất vật lí học: tác động vật lí * tính chất vật lí",
    example: "tác động vật lí * tính chất vật lí",
  },
  {
    word: "vật lí trị liệu",
    part_of_speech: "danh từ",
    meaning:
      "phương pháp phòng chữa bệnh bằng cách sử dụng các yếu tố vật lí như: ánh sáng, nhiệt, điện, và dùng xoa bóp, thể dục, v.v.: chữa bệnh bằng vật lí trí liệu",
    example: "chữa bệnh bằng vật lí trí liệu",
  },
  {
    word: "vật liệu",
    part_of_speech: "danh từ",
    meaning:
      "vật dùng để làm ra cái gì (nói khái quát): vật liệu xây dựng * vận chuyển vật liệu",
    example: "vật liệu xây dựng * vận chuyển vật liệu",
  },
  {
    word: "vật lực",
    part_of_speech: "danh từ",
    meaning:
      "những phương tiện vật chất dùng vào một công cuộc nào đó (nói tổng quát): giúp đỡ cả nhân lực lẫn vật lực",
    example: "giúp đỡ cả nhân lực lẫn vật lực",
  },
  {
    word: "vật lý",
    part_of_speech: "danh từ",
    meaning: "vật lí học (nói tắt): môn vật lí",
    example: "môn vật lí",
  },
  {
    word: "vật lý",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về vật lí học, có tính chất vật lí học: tác động vật lí * tính chất vật lí",
    example: "tác động vật lí * tính chất vật lí",
  },
  {
    word: "vật lộn",
    part_of_speech: "động từ",
    meaning:
      "dùng hết sức để chống chọi, đối phó lại một cách vất vả: vật lộn với đời để kiếm sống * vật lộn với sóng dữ",
    example: "vật lộn với đời để kiếm sống * vật lộn với sóng dữ",
  },
  {
    word: "vật mang",
    part_of_speech: "danh từ",
    meaning: "vật thể lưu giữ một dạng vật chất nào đó: vật mang thông tin",
    example: "vật mang thông tin",
  },
  {
    word: "vật nài",
    part_of_speech: "động từ",
    meaning: "cố nài xin: phải vật nài mãi mới cho",
    example: "phải vật nài mãi mới cho",
  },
  {
    word: "vật lý trị liệu",
    part_of_speech: "danh từ",
    meaning:
      "phương pháp phòng chữa bệnh bằng cách sử dụng các yếu tố vật lí như: ánh sáng, nhiệt, điện, và dùng xoa bóp, thể dục, v.v.: chữa bệnh bằng vật lí trí liệu",
    example: "chữa bệnh bằng vật lí trí liệu",
  },
  {
    word: "vất vả",
    part_of_speech: "tính từ",
    meaning:
      "ở vào tình trạng phải bỏ ra nhiều sức lực hay tâm trí vào một việc gì trong một thời gian dài: làm lụng vất vả * đường xa nên đi lại khá vất vả * vất vả về đường chồng con",
    example:
      "làm lụng vất vả * đường xa nên đi lại khá vất vả * vất vả về đường chồng con",
  },
  {
    word: "vật thể",
    part_of_speech: "danh từ",
    meaning:
      "vật cụ thể, có những thuộc tính vật lí nhất định: văn hoá phi vật thể * xuất hiện vật thể lạ trên bầu trời",
    example: "văn hoá phi vật thể * xuất hiện vật thể lạ trên bầu trời",
  },
  {
    word: "vật phẩm",
    part_of_speech: "danh từ",
    meaning:
      "vật được làm ra (nói khái quát): mua những vật phẩm có giá trị * tiến cúng vật phẩm",
    example: "mua những vật phẩm có giá trị * tiến cúng vật phẩm",
  },
  {
    word: "vật tư",
    part_of_speech: "danh từ",
    meaning:
      "nguyên vật liệu, máy móc, phụ tùng, v.v. dùng cho sản xuất, xây dựng nói chung: cung ứng vật tư * phòng vật tư",
    example: "cung ứng vật tư * phòng vật tư",
  },
  {
    word: "vật nuôi",
    part_of_speech: "danh từ",
    meaning:
      "gia súc, gia cầm, nói chung: chăm sóc vật nuôi * chuyển đổi cây trồng và vật nuôi",
    example: "chăm sóc vật nuôi * chuyển đổi cây trồng và vật nuôi",
  },
  {
    word: "vật vã",
    part_of_speech: "động từ",
    meaning: "vật mình lăn lộn vì đau đớn: vật vã khóc than * vật vã mình mẩy",
    example: "vật vã khóc than * vật vã mình mẩy",
  },
  {
    word: "vây",
    part_of_speech: "động từ",
    meaning:
      "tạo thành một vòng bao lấy xung quanh một cái gì: ngồi vây quanh bếp lửa * vây đồn giặc * thoát khỏi vòng vây",
    example: "ngồi vây quanh bếp lửa * vây đồn giặc * thoát khỏi vòng vây",
  },
  {
    word: "vất vưởng",
    part_of_speech: "tính từ",
    meaning:
      "ở tình trạng bị bỏ trơ trọi một nơi, không ai ngó ngàng đến, gây cảm giác như bị bỏ đi: chiếc xe hỏng nằm vất vưởng ở góc nhà",
    example: "chiếc xe hỏng nằm vất vưởng ở góc nhà",
  },
  {
    word: "vất vưởng",
    part_of_speech: "tính từ",
    meaning:
      "ở tình trạng đời sống không có gì bảo đảm, không ổn định, sống ngày nào biết ngày ấy: sống vất vưởng nơi đầu đường, xó chợ",
    example: "sống vất vưởng nơi đầu đường, xó chợ",
  },
  {
    word: "vật vờ",
    part_of_speech: "động từ",
    meaning:
      "lay động, ngả nghiêng một cách yếu ớt theo chiều gió, theo dòng nước: vệt khói bay vật vờ * những ngọn tre non vật vờ trước gió",
    example: "vệt khói bay vật vờ * những ngọn tre non vật vờ trước gió",
  },
  {
    word: "vật vờ",
    part_of_speech: "tính từ",
    meaning:
      '(cuộc sống) không ổn định, không chắc chắn, hoàn toàn tuỳ theo sự đưa đẩy của hoàn cảnh: sống vật vờ * "Vật vờ trong áng phồn hoa, Ba mươi sáu động, ai là chủ nhân?" (BC)',
    example:
      'sống vật vờ * "Vật vờ trong áng phồn hoa, Ba mươi sáu động, ai là chủ nhân?" (BC)',
  },
  {
    word: "vẩu",
    part_of_speech: "tính từ",
    meaning: "(răng cửa hàm trên) nhô ra, chìa ra phía trước: răng vẩu",
    example: "răng vẩu",
  },
  {
    word: "vấu",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) mấu: vấu tre",
    example: "vấu tre",
  },
  {
    word: "vẫy",
    part_of_speech: "động từ",
    meaning:
      "đưa lên đưa xuống hay đưa qua đưa lại một cách đều đặn và liên tiếp, thường để ra hiệu hay biểu lộ tình cảm: vẫy tay chào * vẫy xe ô tô * con chó vẫy đuôi rối rít",
    example: "vẫy tay chào * vẫy xe ô tô * con chó vẫy đuôi rối rít",
  },
  {
    word: "vầy",
    part_of_speech: "động từ",
    meaning:
      'dùng tay, chân quấy hoặc vò, giẫm lung tung, làm cho bị bẩn, bị nhàu nát: bọn trẻ đang vầy nước * "Còn nhiều ân ái chan chan, Hay gì vầy cánh hoa tàn mà chơi?" (TKiều)',
    example:
      'bọn trẻ đang vầy nước * "Còn nhiều ân ái chan chan, Hay gì vầy cánh hoa tàn mà chơi?" (TKiều)',
  },
  {
    word: "vấy",
    part_of_speech: "động từ",
    meaning:
      "dính chất dơ bẩn hoặc đáng ghê tởm: bùn vấy lên tận gấu áo * mực vấy ra đầy vở * bàn tay vấy máu",
    example: "bùn vấy lên tận gấu áo * mực vấy ra đầy vở * bàn tay vấy máu",
  },
  {
    word: "vẩy",
    part_of_speech: "động từ",
    meaning:
      "đưa tay hoặc vật cầm trong tay từ trên xuống bằng một động tác nhanh, mạnh, để làm cho chất lỏng đang bám vào văng đi hết: vẩy rau sống * vẩy nước rồi mới quét cho đỡ bụi",
    example: "vẩy rau sống * vẩy nước rồi mới quét cho đỡ bụi",
  },
  {
    word: "vẩy",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bắn súng ngắn bằng động tác rất nhanh: vẩy liền một lúc mấy phát súng",
    example: "vẩy liền một lúc mấy phát súng",
  },
  {
    word: "vây bọc",
    part_of_speech: "động từ",
    meaning: "vây kín mọi phía, không để hở chỗ nào: nhà có tường bao vây bọc",
    example: "nhà có tường bao vây bọc",
  },
  {
    word: "vây cánh",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp người câu kết với nhau vì những quyền lợi riêng không chính đáng (nói khái quát): thu nạp để thêm vây cánh",
    example: "thu nạp để thêm vây cánh",
  },
  {
    word: "vây ép",
    part_of_speech: "động từ",
    meaning:
      "bao vây và liên tục tấn công, khiến cho khả năng hoạt động của đối phương ngày càng bị hạn chế: vây ép đồn địch",
    example: "vây ép đồn địch",
  },
  {
    word: "vẫy gọi",
    part_of_speech: "động từ",
    meaning:
      "(văn chương) kêu gọi và giục giã tiến lên: tương lai đang vẫy gọi",
    example: "tương lai đang vẫy gọi",
  },
  {
    word: "vậy",
    part_of_speech: "đại từ",
    meaning:
      "như thế (nhưng nghĩa cụ thể hơn): đúng như vậy * thật vậy * nói vậy mà cũng nghe được",
    example: "đúng như vậy * thật vậy * nói vậy mà cũng nghe được",
  },
  {
    word: "vậy",
    part_of_speech: "đại từ",
    meaning:
      "từ dùng để chỉ điều vừa được nói đến là xuất phát điểm cho điều sắp nêu ra: vậy phải làm thế nào bây giờ * vậy thì tôi đi ngay",
    example: "vậy phải làm thế nào bây giờ * vậy thì tôi đi ngay",
  },
  {
    word: "vậy",
    part_of_speech: "trợ từ",
    meaning:
      "từ dùng để nhấn mạnh tính chất cụ thể của điều muốn hỏi, gắn liền với hiện thực đã biết: chuyện gì vậy? * sao vậy? * tiếng động gì vậy?",
    example: "chuyện gì vậy? * sao vậy? * tiếng động gì vậy?",
  },
  {
    word: "vậy",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý khẳng định về điều kết luận đành là phải thế, không còn cách nào khác: cứ để như thế vậy * không có thì phải dùng vậy",
    example: "cứ để như thế vậy * không có thì phải dùng vậy",
  },
  {
    word: "vây hãm",
    part_of_speech: "động từ",
    meaning:
      "bao vây dài ngày làm cho đối phương phải khốn đốn về mọi mặt, để tiến tới tiêu diệt hoặc buộc phải đầu hàng: đưa quân đến vây hãm thành",
    example: "đưa quân đến vây hãm thành",
  },
  {
    word: "vậy mà",
    part_of_speech: "",
    meaning: "như thế mà: vậy mà tôi lại không được biết",
    example: "vậy mà tôi lại không được biết",
  },
  {
    word: "vây ráp",
    part_of_speech: "động từ",
    meaning:
      "vây chặn và lùng bắt khắp các ngả: địch tổ chức vây ráp, truy lùng cán bộ",
    example: "địch tổ chức vây ráp, truy lùng cán bộ",
  },
  {
    word: "vầy vậy",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) tạm được, không hoàn toàn như ý nhưng cũng không có gì phải phàn nàn: công việc vẫn vầy vậy thôi",
    example: "công việc vẫn vầy vậy thôi",
  },
  {
    word: "vầy vò",
    part_of_speech: "động từ",
    meaning:
      'dùng tay quấy hoặc vò đảo lung tung (nói khái quát): "Lạnh lùng ai đắp áo cho, Nghe lời ai dỗ, vầy vò áo đi." (ca dao)',
    example: 'Lạnh lùng ai đắp áo cho, Nghe lời ai dỗ, vầy vò áo đi." (ca dao)',
  },
  {
    word: "vẫy vùng",
    part_of_speech: "động từ",
    meaning:
      'hoạt động một cách tự do, tuỳ thích, không chịu một sự kiềm chế nào cả: vẫy vùng trong nước * "Giang hồ quen thú vẫy vùng, Gươm đàn nửa gánh, non sông một chèo." (TKiều)',
    example:
      'vẫy vùng trong nước * "Giang hồ quen thú vẫy vùng, Gươm đàn nửa gánh, non sông một chèo." (TKiều)',
  },
  {
    word: "vè",
    part_of_speech: "danh từ",
    meaning:
      '(Ít dùng) nhánh lúa: "Ngày đi lúa chửa chia vè, Ngày về lúa đã đỏ hoe đầy đồng." (Cdao)',
    example:
      'Ngày đi lúa chửa chia vè, Ngày về lúa đã đỏ hoe đầy đồng." (Cdao)',
  },
  {
    word: "vè",
    part_of_speech: "danh từ",
    meaning: "que cắm để làm mốc ở nơi ngập nước: cắm vè",
    example: "cắm vè",
  },
  {
    word: "vè",
    part_of_speech: "danh từ",
    meaning:
      "bài văn vần thường được truyền miệng trong dân gian, kể lại chuyện người thật, việc thật để ca ngợi hay chê bai, châm biếm: đặt vè * làm bài vè",
    example: "đặt vè * làm bài vè",
  },
  {
    word: "ve",
    part_of_speech: "danh từ",
    meaning:
      "(cũng ve sầu) bọ có cánh trong suốt, con đực kêu ve ve về mùa hè: tiếng ve kêu mùa hạ * mình gầy xác ve (tng)",
    example: "tiếng ve kêu mùa hạ * mình gầy xác ve (tng)",
  },
  {
    word: "ve",
    part_of_speech: "danh từ",
    meaning:
      "bọ có chân đốt, hút máu và sống kí sinh trên các động vật có xương sống như trâu, bò, v.v.",
    example: "mắt có ve",
  },
  {
    word: "ve",
    part_of_speech: "danh từ",
    meaning: "sẹo nhỏ ở mi mắt: mắt có ve",
    example: "ve thuốc * ve rượu",
  },
  {
    word: "ve",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) ve áo (nói tắt).",
    example: "đi ve gái",
  },
  {
    word: "ve",
    part_of_speech: "tính từ",
    meaning: "có màu tựa như màu xanh lá mạ: xanh ve * quét vôi ve",
    example: "xanh ve * quét vôi ve",
  },
  {
    word: "vẽ",
    part_of_speech: "động từ",
    meaning:
      "tạo hoặc gợi ra hình ảnh sự vật trên một mặt phẳng bằng các đường nét, màu sắc: vẽ tranh * vẽ bản đồ * nét vẽ còn non",
    example: "vẽ tranh * vẽ bản đồ * nét vẽ còn non",
  },
  {
    word: "vẽ",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) vạch ra, chỉ ra cho: vẽ đường chỉ lối",
    example: "vẽ đường chỉ lối",
  },
  {
    word: "vẽ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bày đặt thêm cái không cần thiết: vẽ, có gì mà ơn với huệ! * chỉ khéo vẽ!",
    example: "vẽ, có gì mà ơn với huệ! * chỉ khéo vẽ!",
  },
  {
    word: "vẽ",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) gỡ phần thịt trong con cá, khúc cá ra: dùng đũa vẽ khúc cá",
    example: "dùng đũa vẽ khúc cá",
  },
  {
    word: "vẻ",
    part_of_speech: "danh từ",
    meaning:
      'những nét bề ngoài nhìn trên đại thể, thường được đánh giá là đẹp của người hay cảnh vật (nói tổng quát): vẻ đẹp * muôn màu muôn vẻ * "Mai cốt cách, tuyết tinh thần, Mỗi người một vẻ, mười phân vẹn mười." (TKiều)',
    example:
      'vẻ đẹp * muôn màu muôn vẻ * "Mai cốt cách, tuyết tinh thần, Mỗi người một vẻ, mười phân vẹn mười." (TKiều)',
  },
  {
    word: "vẻ",
    part_of_speech: "danh từ",
    meaning:
      "cái biểu hiện bên ngoài thông qua nét mặt, cử chỉ, cách nói năng, v.v., cho thấy trạng thái tinh thần - tình cảm bên trong: vẻ mặt ngơ ngác * ra vẻ ta đây * ánh mắt đượm vẻ buồn",
    example: "vẻ mặt ngơ ngác * ra vẻ ta đây * ánh mắt đượm vẻ buồn",
  },
  {
    word: "ve chai",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ, khẩu ngữ) chai lọ bằng thuỷ tinh nói chung được thu gom để bán lại: thu lượm ve chai * bán ve chai",
    example: "thu lượm ve chai * bán ve chai",
  },
  {
    word: "vé",
    part_of_speech: "danh từ",
    meaning:
      "mảnh giấy nhỏ chứng nhận đã trả tiền cho một suất đi tàu xe, xem giải trí, v.v., thường chỉ dùng được một lần: vé xem kịch * mua mấy vé xổ số * đặt vé máy bay",
    example: "vé xem kịch * mua mấy vé xổ số * đặt vé máy bay",
  },
  {
    word: "vé",
    part_of_speech: "danh từ",
    meaning: "(Khẩu ngữ) tờ một trăm dollar Mĩ: xin được việc cũng mất 10 vé",
    example: "xin được việc cũng mất 10 vé",
  },
  {
    word: "vẽ chuyện",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bày đặt thêm những cái không cần thiết, thường dẫn đến phiền toái: đừng có vẽ chuyện!",
    example: "đừng có vẽ chuyện!",
  },
  {
    word: "ve sầu",
    part_of_speech: "danh từ",
    meaning:
      "(cũng ve sầu) bọ có cánh trong suốt, con đực kêu ve ve về mùa hè: tiếng ve kêu mùa hạ * mình gầy xác ve (tng)",
    example: "tiếng ve kêu mùa hạ * mình gầy xác ve (tng)",
  },
  {
    word: "ve sầu",
    part_of_speech: "danh từ",
    meaning:
      "bọ có chân đốt, hút máu và sống kí sinh trên các động vật có xương sống như trâu, bò, v.v.",
    example: "mắt có ve",
  },
  {
    word: "ve sầu",
    part_of_speech: "danh từ",
    meaning: "sẹo nhỏ ở mi mắt: mắt có ve",
    example: "ve thuốc * ve rượu",
  },
  {
    word: "ve sầu",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) ve áo (nói tắt).",
    example: "đi ve gái",
  },
  {
    word: "ve sầu",
    part_of_speech: "tính từ",
    meaning: "có màu tựa như màu xanh lá mạ: xanh ve * quét vôi ve",
    example: "xanh ve * quét vôi ve",
  },
  {
    word: "vẽ trò",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ, hiếm) như vẽ chuyện: chỉ được cái vẽ trò!",
    example: "chỉ được cái vẽ trò!",
  },
  {
    word: "vẽ trò",
    part_of_speech: "động từ",
    meaning:
      '(khẩu ngữ) bày ra, đặt ra làm cho thêm phiền phức, thêm rối rắm: vẽ vời làm gì cho tốn kém * "Trách ai sao khéo vẽ vời, Trách ai khéo đặt những lời bướm ong." (ca dao)',
    example:
      'vẽ vời làm gì cho tốn kém * "Trách ai sao khéo vẽ vời, Trách ai khéo đặt những lời bướm ong." (ca dao)',
  },
  {
    word: "vẻ vang",
    part_of_speech: "tính từ",
    meaning:
      "có tác dụng đem lại vinh dự lớn và niềm tự hào chính đáng: những trang sử vẻ vang của dân tộc",
    example: "những trang sử vẻ vang của dân tộc",
  },
  {
    word: "vé số",
    part_of_speech: "danh từ",
    meaning: "vé xổ số (nói tắt): trúng vé số * bán vé số",
    example: "trúng vé số * bán vé số",
  },
  {
    word: "ve ve",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng kêu của ve sầu hoặc tiếng đập cánh của một số côn trùng nhỏ: ve sầu kêu ve ve",
    example: "ve sầu kêu ve ve",
  },
  {
    word: "ve ve",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) ve sầu: con ve ve",
    example: "con ve ve",
  },
  {
    word: "ve vẩy",
    part_of_speech: "động từ",
    meaning:
      "đưa đi đưa lại theo hướng này hướng khác một cách uyển chuyển, mềm mại: con chó ve vẩy đuôi * ve vẩy cái quạt trong tay",
    example: "con chó ve vẩy đuôi * ve vẩy cái quạt trong tay",
  },
  {
    word: "vẽ sự",
    part_of_speech: "động từ",
    meaning: "(cũ) như vẽ chuyện: ôi dào, vẽ sự!",
    example: "ôi dào, vẽ sự!",
  },
  {
    word: "vè vè",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng thanh, trầm, kéo dài và đều đều nghe như từ xa vọng lại: tiếng máy bay vè vè trên đầu * vè vè chiếc xe máy mới",
    example: "tiếng máy bay vè vè trên đầu * vè vè chiếc xe máy mới",
  },
  {
    word: "ve vãn",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) như tán tỉnh: ve vãn phụ nữ",
    example: "ve vãn phụ nữ",
  },
  {
    word: "vẽ vời",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) vẽ (nói khái quát): cũng biết vẽ vời đôi chút",
    example: "cũng biết vẽ vời đôi chút",
  },
  {
    word: "vẽ vời",
    part_of_speech: "động từ",
    meaning:
      "tô vẽ, làm tăng thêm vẻ đẹp hình thức vốn không có: thêm thắt, vẽ vời cho nhân vật * tính thích vẽ vời, phô trương",
    example: "thêm thắt, vẽ vời cho nhân vật * tính thích vẽ vời, phô trương",
  },
  {
    word: "véc-ni",
    part_of_speech: "danh từ",
    meaning:
      "dung dịch nhựa dùng phết lên đồ gỗ thành một lớp mỏng để chống ẩm hoặc làm cho bóng đẹp: tủ đánh vernis",
    example: "tủ đánh vernis",
  },
  {
    word: "ven đô",
    part_of_speech: "danh từ",
    meaning: "vùng ngoại ô của thủ đô: vùng ven đô * làng cổ ven đô",
    example: "vùng ven đô * làng cổ ven đô",
  },
  {
    word: "ven",
    part_of_speech: "danh từ",
    meaning:
      "phần đất chạy dọc theo sát một bên: nhà ở ven sông * cho xe đỗ lại ven đường * vùng ven đô",
    example: "nhà ở ven sông * cho xe đỗ lại ven đường * vùng ven đô",
  },
  {
    word: "ven",
    part_of_speech: "danh từ",
    meaning: "(Khẩu ngữ) tĩnh mạch: tiêm ven",
    example: "tiêm ven",
  },
  {
    word: "vén",
    part_of_speech: "động từ",
    meaning:
      "thu phần buông xuống lên phía trên hoặc sang một bên cho gọn lại: vén quần đến đầu gối * vén tóc vào mang tai * vén màn",
    example: "vén quần đến đầu gối * vén tóc vào mang tai * vén màn",
  },
  {
    word: "vén",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) dồn gọn lại, tập trung vào một chỗ: vén đống thóc * vén luống",
    example: "vén đống thóc * vén luống",
  },
  {
    word: "vẹm",
    part_of_speech: "danh từ",
    meaning: "trai to ở ven biển, vỏ màu xanh đen: ăn như vẹm",
    example: "ăn như vẹm",
  },
  {
    word: "vẹn toàn",
    part_of_speech: "tính từ",
    meaning:
      "có được đầy đủ các mặt, không bị thiếu đi một mặt nào: tài sắc vẹn toàn",
    example: "tài sắc vẹn toàn",
  },
  {
    word: "ven nội",
    part_of_speech: "danh từ",
    meaning:
      "vùng sát xung quanh nội thành: làng ven nội * mở rộng các vùng ven nội",
    example: "làng ven nội * mở rộng các vùng ven nội",
  },
  {
    word: "vẹn",
    part_of_speech: "tính từ",
    meaning:
      "(văn chương) còn giữ được nguyên, không mất mát, không biến đổi chút nào: giữ vẹn lời thề * vẹn đạo làm con",
    example: "giữ vẹn lời thề * vẹn đạo làm con",
  },
  {
    word: "vẹn",
    part_of_speech: "tính từ",
    meaning:
      'đầy đủ, không thiếu sót chút nào: vẹn cả đôi đường * "Mai cốt cách, tuyết tinh thần, Mỗi người một vẻ, mười phân vẹn mười." (TKiều)',
    example:
      'vẹn cả đôi đường * "Mai cốt cách, tuyết tinh thần, Mỗi người một vẻ, mười phân vẹn mười." (TKiều)',
  },
  {
    word: "vẹn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (di chuyển) nhanh đến mức như phát ra tiếng gió: chạy vù ra sân * đạp vù ra chợ mua thêm ít thức ăn",
    example: "chạy vù ra sân * đạp vù ra chợ mua thêm ít thức ăn",
  },
  {
    word: "vẹn tròn",
    part_of_speech: "tính từ",
    meaning: "(văn chương) như trọn vẹn: hiếu nghĩa vẹn tròn",
    example: "hiếu nghĩa vẹn tròn",
  },
  {
    word: "vẻn vẹn",
    part_of_speech: "tính từ",
    meaning:
      "có số lượng chỉ chừng ấy thôi (hàm ý là quá ít ỏi): bức thư vẻn vẹn có mấy chữ * hành lí chỉ vẻn vẹn có một chiếc va li",
    example:
      "bức thư vẻn vẹn có mấy chữ * hành lí chỉ vẻn vẹn có một chiếc va li",
  },
  {
    word: "veo",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả tiếng phát ra như tiếng xé không khí của một vật nhỏ bay vút sát ngang qua rất nhanh: hòn sỏi bay veo qua mặt * tiếng đạn bay veo qua vai",
    example: "hòn sỏi bay veo qua mặt * tiếng đạn bay veo qua vai",
  },
  {
    word: "veo",
    part_of_speech: "phụ từ",
    meaning:
      "(Khẩu ngữ) (hết đi, tiêu hao đi) một cách rất nhanh và không để lại dấu vết gì: bán hết veo * đói veo * làm veo một tí là xong",
    example: "bán hết veo * đói veo * làm veo một tí là xong",
  },
  {
    word: "vẹo vọ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) bị vẹo, lệch, mất cân đối: dáng đi vẹo vọ * bàn ghế vẹo vọ",
    example: "dáng đi vẹo vọ * bàn ghế vẹo vọ",
  },
  {
    word: "vèo",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) lướt qua rất nhanh rồi biến mất, không kịp nhìn thấy: đạn vèo qua bên tai * chiếc máy bay vèo qua bầu trời",
    example: "đạn vèo qua bên tai * chiếc máy bay vèo qua bầu trời",
  },
  {
    word: "vèo",
    part_of_speech: "phụ từ",
    meaning:
      '(khẩu ngữ) (di chuyển hoặc biến đổi trạng thái) một cách hết sức nhanh chóng, chỉ trong khoảnh khắc: cháy vèo * "Sóng biếc theo làn hơi gợn tí, Lá vàng trước gió khẽ đưa vèo." (NgKhuyến; 3)',
    example:
      'cháy vèo * "Sóng biếc theo làn hơi gợn tí, Lá vàng trước gió khẽ đưa vèo." (NgKhuyến; 3)',
  },
  {
    word: "véo",
    part_of_speech: "động từ",
    meaning:
      "kẹp (vật mềm) giữa hai đầu ngón tay rồi vừa xoắn vừa giật: véo tai * véo má em * véo thêm một ít xôi",
    example: "véo tai * véo má em * véo thêm một ít xôi",
  },
  {
    word: "vèo vèo",
    part_of_speech: "",
    meaning:
      "như vèo (nhưng ý liên tiếp và nhấn mạnh hơn): phóng xe máy vèo vèo * thời gian trôi vèo vèo",
    example: "phóng xe máy vèo vèo * thời gian trôi vèo vèo",
  },
  {
    word: "vẹo",
    part_of_speech: "tính từ",
    meaning:
      "bị nghiêng, bị lệch hẳn về một bên, không thẳng, không cân như bình thường: bị vẹo cột sống * gió mạnh làm túp lều vẹo hẳn về một bên",
    example: "bị vẹo cột sống * gió mạnh làm túp lều vẹo hẳn về một bên",
  },
  {
    word: "véo von",
    part_of_speech: "tính từ",
    meaning:
      '(âm thanh) cao và trong, lên xuống nhịp nhàng, nghe vui và êm tai: chim hót véo von * "Chinh phu ruổi ngựa lên miền Bắc, Tiếng địch bên thành thổi véo von." (ThCan; 3)',
    example:
      'chim hót véo von * "Chinh phu ruổi ngựa lên miền Bắc, Tiếng địch bên thành thổi véo von." (ThCan; 3)',
  },
  {
    word: "veo veo",
    part_of_speech: "tính từ",
    meaning: "như veo (nhưng ý liên tục và nhấn mạnh hơn): đạn bay veo veo",
    example: "đạn bay veo veo",
  },
  {
    word: "veo veo",
    part_of_speech: "phụ từ",
    meaning:
      "(cách di chuyển) hết sức nhanh và dễ dàng, như không có gì vướng mắc, cản trở: con thuyền lướt veo veo * phóng xe máy veo veo",
    example: "con thuyền lướt veo veo * phóng xe máy veo veo",
  },
  {
    word: "version",
    part_of_speech: "danh từ",
    meaning:
      "phiên bản (của một chương trình máy tính): cài đặt version mới nhất",
    example: "cài đặt version mới nhất",
  },
  {
    word: "vernis",
    part_of_speech: "danh từ",
    meaning:
      "dung dịch nhựa dùng phết lên đồ gỗ thành một lớp mỏng để chống ẩm hoặc làm cho bóng đẹp: tủ đánh vernis",
    example: "tủ đánh vernis",
  },
  {
    word: "vét",
    part_of_speech: "danh từ",
    meaning:
      "áo ngắn kiểu Âu, tay dài, cổ bẻ, dùng để mặc ngoài: mặc vét * thợ cắt áo vét",
    example: "mặc vét * thợ cắt áo vét",
  },
  {
    word: "vét",
    part_of_speech: "động từ",
    meaning:
      "lấy cho kì hết những gì còn ở tận sát đáy: vét sạch nồi * vét bùn",
    example: "vét sạch nồi * vét bùn",
  },
  {
    word: "vét",
    part_of_speech: "động từ",
    meaning:
      "thu nhặt cho kì hết không chừa lại chút nào: đợt thi vét * vét túi cũng chẳng còn xu nào",
    example: "đợt thi vét * vét túi cũng chẳng còn xu nào",
  },
  {
    word: "vét đĩa",
    part_of_speech: "tính từ",
    meaning:
      "(thông tục) thuộc loại kém nhất, tồi nhất: đồ vét đĩa! * loại vét đĩa thì nói làm gì!",
    example: "đồ vét đĩa! * loại vét đĩa thì nói làm gì!",
  },
  {
    word: "vẹt",
    part_of_speech: "danh từ",
    meaning:
      "chim thường có lông màu xanh biếc, mỏ quặp màu đỏ, có thể bắt chước tiếng người: nói như vẹt (nói nhiều và trôi chảy, nhưng không hiểu gì)",
    example: "nói như vẹt (nói nhiều và trôi chảy, nhưng không hiểu gì)",
  },
  {
    word: "vẹt",
    part_of_speech: "tính từ",
    meaning: "bị mòn hẳn đi, thiếu hẳn đi một mảng: giày vẹt gót",
    example: "giày vẹt gót",
  },
  {
    word: "vẹt",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) gạt, đẩy sang hai bên: vẹt đám người để lấy lối đi",
    example: "vẹt đám người để lấy lối đi",
  },
  {
    word: "vê",
    part_of_speech: "động từ",
    meaning:
      "xoay, vo nhẹ cho tròn, cho xoắn lại bằng các đầu ngón tay: vê điếu thuốc * vê gấu áo * vê bột làm bánh",
    example: "vê điếu thuốc * vê gấu áo * vê bột làm bánh",
  },
  {
    word: "vệ",
    part_of_speech: "danh từ",
    meaning:
      "phần đất làm thành rìa, mép: vệ sông * đứng ở vệ đường * ngồi bệt xuống vệ cỏ",
    example: "vệ sông * đứng ở vệ đường * ngồi bệt xuống vệ cỏ",
  },
  {
    word: "về",
    part_of_speech: "động từ",
    meaning:
      'di chuyển trở lại chỗ của mình, nơi ở, nơi quê hương của mình: về chỗ ngồi * chim về tổ * về quê * "Người ơi người ở đừng về (...)" (ca dao)',
    example:
      'về chỗ ngồi * chim về tổ * về quê * "Người ơi người ở đừng về (...)" (ca dao)',
  },
  {
    word: "về",
    part_of_speech: "động từ",
    meaning:
      "di chuyển đến nơi mình có quan hệ gắn bó coi như nhà mình, quê hương mình, hoặc người nhà mình: về thăm quê Bác * các đại biểu về dự hội nghị",
    example: "về thăm quê Bác * các đại biểu về dự hội nghị",
  },
  {
    word: "về",
    part_of_speech: "động từ",
    meaning:
      "từ biểu thị hướng của hoạt động nhằm trở lại chỗ cũ hoặc nhằm đưa đến phía, nơi của bản thân mình: chạy về nhà * thu tay về * mua về làm quà * quay về",
    example: "chạy về nhà * thu tay về * mua về làm quà * quay về",
  },
  {
    word: "về",
    part_of_speech: "động từ",
    meaning:
      "di chuyển hoặc được vận chuyển đến đích cuối cùng: hàng đã về kho * tàu sắp về ga",
    example: "hàng đã về kho * tàu sắp về ga",
  },
  {
    word: "về",
    part_of_speech: "động từ",
    meaning: "chết (lối nói kiêng tránh): về với tổ tiên * về cõi vĩnh hằng",
    example: "về với tổ tiên * về cõi vĩnh hằng",
  },
  {
    word: "về",
    part_of_speech: "động từ",
    meaning:
      "ở vào trong khoảng thời gian nào đó: trời đã về chiều * từ nay về sau * cảnh về già",
    example: "trời đã về chiều * từ nay về sau * cảnh về già",
  },
  {
    word: "về",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là phạm vi, phương hướng của hoạt động, hay phạm vi của tính chất được nói đến: nhìn về phía trước * giỏi về hoá học * về chuyện này, tôi không có ý kiến gì",
    example:
      "nhìn về phía trước * giỏi về hoá học * về chuyện này, tôi không có ý kiến gì",
  },
  {
    word: "vế",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) bắp đùi: quần xắn tới vế",
    example: "quần xắn tới vế",
  },
  {
    word: "vế",
    part_of_speech: "danh từ",
    meaning:
      "một trong những phần có cấu trúc giống nhau, có quan hệ với nhau từng cặp, cấu tạo nên một thể hoàn chỉnh: ra một vế câu đối * hai vế câu được nối bởi một liên từ",
    example: "ra một vế câu đối * hai vế câu được nối bởi một liên từ",
  },
  {
    word: "vế",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ biểu thức viết ở một bên dấu bằng hoặc dấu lớn hơn, dấu nhỏ hơn: chuyển vế phải đổi dấu * biến đổi cả hai vế của phương trình",
    example: "chuyển vế phải đổi dấu * biến đổi cả hai vế của phương trình",
  },
  {
    word: "vế",
    part_of_speech: "danh từ",
    meaning:
      "địa vị, thế lực của một người trong xã hội: người ngang vế * chịu lép vế",
    example: "người ngang vế * chịu lép vế",
  },
  {
    word: "vệ quốc",
    part_of_speech: "động từ",
    meaning: "bảo vệ tổ quốc: chiến tranh vệ quốc",
    example: "chiến tranh vệ quốc",
  },
  {
    word: "vệ quốc",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) vệ quốc quân (nói tắt): gia nhập vệ quốc",
    example: "gia nhập vệ quốc",
  },
  {
    word: "vệ quốc quân",
    part_of_speech: "danh từ",
    meaning:
      "quân đội bảo vệ tổ quốc chống xâm lược (thường dùng để gọi quân đội nhân dân Việt Nam thời kì đầu sau Cách mạng tháng Tám): chiến sĩ vệ quốc quân",
    example: "chiến sĩ vệ quốc quân",
  },
  {
    word: "vệ sĩ",
    part_of_speech: "danh từ",
    meaning:
      "người chuyên làm nhiệm vụ bảo vệ nhân vật quan trọng: tuyển vệ sĩ",
    example: "tuyển vệ sĩ",
  },
  {
    word: "vệ sinh",
    part_of_speech: "danh từ",
    meaning:
      "những biện pháp phòng bệnh, giữ gìn và tăng cường sức khoẻ (nói khái quát): ăn ở hợp vệ sinh * vệ sinh lao động",
    example: "ăn ở hợp vệ sinh * vệ sinh lao động",
  },
  {
    word: "vệ sinh",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) không chứa chất bẩn hoặc những yếu tố gây hại cho sức khoẻ: chỗ ở chật chội, thiếu vệ sinh * đồ ăn ở đây rất vệ sinh",
    example: "chỗ ở chật chội, thiếu vệ sinh * đồ ăn ở đây rất vệ sinh",
  },
  {
    word: "vệ sinh",
    part_of_speech: "động từ",
    meaning: "làm cho sạch nói chung: vệ sinh răng miệng * vệ sinh đường phố",
    example: "vệ sinh răng miệng * vệ sinh đường phố",
  },
  {
    word: "vệ sinh",
    part_of_speech: "động từ",
    meaning: "đại tiện (lối nói kiêng tránh): đi vệ sinh * giấy vệ sinh",
    example: "đi vệ sinh * giấy vệ sinh",
  },
  {
    word: "về vườn",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) (người có chức vị cao) nghỉ việc về nhà, không còn giữ chức vụ gì nữa (thường dùng với hàm ý châm biếm): tham ô nên phải về vườn sớm",
    example: "tham ô nên phải về vườn sớm",
  },
  {
    word: "vếch",
    part_of_speech: "động từ",
    meaning: "(hiếm) như nghếch: trâu vếch sừng * vếch mặt lên trời",
    example: "trâu vếch sừng * vếch mặt lên trời",
  },
  {
    word: "vệ tinh nhân tạo",
    part_of_speech: "danh từ",
    meaning:
      "khí cụ nghiên cứu vũ trụ được con người đưa vào bay quanh quỹ đạo Trái Đất hay một thiên thể khác: phóng vệ tinh nhân tạo",
    example: "phóng vệ tinh nhân tạo",
  },
  {
    word: "vệ tinh địa tĩnh",
    part_of_speech: "danh từ",
    meaning:
      "vệ tinh nhân tạo của Trái Đất, có quỹ đạo nằm trong mặt phẳng xích đạo, có vận tốc góc bằng vận tốc góc của Trái Đất: phát sóng truyền hình qua vệ tinh địa tĩnh",
    example: "phát sóng truyền hình qua vệ tinh địa tĩnh",
  },
  {
    word: "vệ tinh",
    part_of_speech: "danh từ",
    meaning:
      "thiên thể quay xung quanh một hành tinh: Mặt Trăng là vệ tinh của Trái Đất",
    example: "Mặt Trăng là vệ tinh của Trái Đất",
  },
  {
    word: "vệ tinh",
    part_of_speech: "danh từ",
    meaning:
      "cái cùng loại nhưng nhỏ hơn, có chức năng phụ trợ cho cái khác và ở vùng xung quanh cái khác đó: thành phố vệ tinh * các xí nghiệp vệ tinh",
    example: "thành phố vệ tinh * các xí nghiệp vệ tinh",
  },
  {
    word: "vện",
    part_of_speech: "tính từ",
    meaning: "(chó) có vằn trên lông màu vàng xám: chó vện",
    example: "chó vện",
  },
  {
    word: "vểnh",
    part_of_speech: "động từ",
    meaning: "chìa ra và cong lên: vểnh râu * vểnh tai lên nghe ngóng",
    example: "vểnh râu * vểnh tai lên nghe ngóng",
  },
  {
    word: "vênh vang",
    part_of_speech: "",
    meaning:
      "(vẻ mặt, thái độ) kiêu ngạo, lên mặt, khoe khoang tự đắc với người khác về những cái mình có: vênh vang ta đây hơn người * mới có tí tiền đã vênh vang",
    example: "vênh vang ta đây hơn người * mới có tí tiền đã vênh vang",
  },
  {
    word: "vênh váo",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) bị vênh nhiều chỗ (nói khái quát): cánh cửa gỗ bị co lại, vênh váo",
    example: "cánh cửa gỗ bị co lại, vênh váo",
  },
  {
    word: "vênh váo",
    part_of_speech: "tính từ",
    meaning:
      "có vẻ mặt kiêu ngạo, hợm hĩnh, tỏ ra không coi ai ra gì: bộ mặt vênh váo * vênh váo như bố vợ phải đấm (tng)",
    example: "bộ mặt vênh váo * vênh váo như bố vợ phải đấm (tng)",
  },
  {
    word: "vênh vác",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) (vẻ mặt, thái độ) hợm hĩnh, đáng ghét (thường là do có tiền của hơn người): lúc nào cũng vênh vác ta đây",
    example: "lúc nào cũng vênh vác ta đây",
  },
  {
    word: "vênh",
    part_of_speech: "tính từ",
    meaning:
      'cong lên ở một bên, một phía nào đó: đũa vênh * "Phải duyên phải kiếp thời theo, Trái duyên trái kiếp như kèo đục vênh." (ca dao)',
    example:
      'đũa vênh * "Phải duyên phải kiếp thời theo, Trái duyên trái kiếp như kèo đục vênh." (ca dao)',
  },
  {
    word: "vênh",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả vẻ mặt vênh lên tỏ ý kiêu ngạo, tự đắc một cách đáng ghét: con bé ấy vênh lắm * mới giàu một chút đã vênh",
    example: "con bé ấy vênh lắm * mới giàu một chút đã vênh",
  },
  {
    word: "vênh",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) đưa chếch (mặt) lên: vênh mặt lên thách thức",
    example: "vênh mặt lên thách thức",
  },
  {
    word: "vết thương",
    part_of_speech: "danh từ",
    meaning:
      "chỗ bị thương trên cơ thể: băng bó vết thương * vết thương lòng (b) * hàn gắn vết thương chiến tranh (b)",
    example:
      "băng bó vết thương * vết thương lòng (b) * hàn gắn vết thương chiến tranh (b)",
  },
  {
    word: "vênh vênh",
    part_of_speech: "tính từ",
    meaning: "hơi vênh: tấm ván===== hơi vênh =====",
    example: "tấm ván===== hơi vênh =====",
  },
  {
    word: "vênh vênh",
    part_of_speech: "động từ",
    meaning:
      "(mặt) vênh lên, trông đáng ghét: vênh vênh cái mặt, ra vẻ khinh đời",
    example: "vênh vênh cái mặt, ra vẻ khinh đời",
  },
  {
    word: "vết",
    part_of_speech: "danh từ",
    meaning:
      "dấu còn lưu lại trên bề mặt một vật, do một vật nào đó đã đi qua hoặc tác động vào: vết mực * vết sẹo * mặt đã có vết nhăn * vết chân in trên cát",
    example: "vết mực * vết sẹo * mặt đã có vết nhăn * vết chân in trên cát",
  },
  {
    word: "vệt",
    part_of_speech: "danh từ",
    meaning:
      "hình dài nổi rõ trên bề mặt một vật, do tác động của một vật khác đi qua: vệt mực * vệt đèn pha loang loáng",
    example: "vệt mực * vệt đèn pha loang loáng",
  },
  {
    word: "vết xe đổ",
    part_of_speech: "",
    meaning:
      "dấu vết còn in lại của bánh xe bị đổ; dùng để ví con đường, cách thức sai lầm mà người nào đó đã đi, đã làm và đã thất bại (hàm ý không nên đi theo, làm theo con đường, cách thức ấy): giẫm lên vết xe đổ của người khác",
    example: "giẫm lên vết xe đổ của người khác",
  },
  {
    word: "vếu",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ, hiếm) như sưng vếu: bị ngã, mồm vếu lên",
    example: "bị ngã, mồm vếu lên",
  },
  {
    word: "vết tích",
    part_of_speech: "danh từ",
    meaning:
      "cái còn để lại của cái đã thuộc về quá khứ: vết tích của chiến tranh * không để lại một vết tích gì",
    example: "vết tích của chiến tranh * không để lại một vết tích gì",
  },
  {
    word: "vêu",
    part_of_speech: "tính từ",
    meaning: "gầy hốc hác: mặt gầy vêu",
    example: "mặt gầy vêu",
  },
  {
    word: "vêu",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có dáng vẻ trơ ra vì không biết làm gì: ế hàng, ngồi vêu cả buổi",
    example: "ế hàng, ngồi vêu cả buổi",
  },
  {
    word: "vều",
    part_of_speech: "tính từ",
    meaning: "(môi, mặt) sưng, phồng to lên: mặt mũi sưng vều * ngã vều môi",
    example: "mặt mũi sưng vều * ngã vều môi",
  },
  {
    word: "vì",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận gồm những thanh cứng, chắc, dùng để chống đỡ trong công trình xây dựng, trong hầm lò: vì kèo * thay vì ngang",
    example: "vì kèo * thay vì ngang",
  },
  {
    word: "vì",
    part_of_speech: "danh từ",
    meaning: "từ dùng để chỉ từng ngôi sao: các vì sao lấp lánh",
    example: "các vì sao lấp lánh",
  },
  {
    word: "vì",
    part_of_speech: "động từ",
    meaning:
      '(cũ, văn chương) nể: "Không kiêng cũng có chút vì, Đừng còn múa mỏ có khi oan hồn." (MPXH)',
    example:
      'Không kiêng cũng có chút vì, Đừng còn múa mỏ có khi oan hồn." (MPXH)',
  },
  {
    word: "vì",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là lí do hoặc nguyên nhân của điều vừa được nói đến: mất xe vì không cẩn thận * yêu vì nết, trọng vì tài * thi trượt vì lười học",
    example:
      "mất xe vì không cẩn thận * yêu vì nết, trọng vì tài * thi trượt vì lười học",
  },
  {
    word: "vì",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là mục đích hướng tới của hoạt động vừa được nói đến: làm vì lợi ích chung * cả đời vì dân, vì nước",
    example: "làm vì lợi ích chung * cả đời vì dân, vì nước",
  },
  {
    word: "ví",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng bỏ túi hoặc cầm tay, có nhiều ngăn để đựng tiền, giấy tờ, thường làm bằng da: mở ví lấy tiền * ví xách tay",
    example: "mở ví lấy tiền * ví xách tay",
  },
  {
    word: "ví",
    part_of_speech: "động từ",
    meaning:
      "so sánh sự giống nhau về một tính chất nhất định với cái cụ thể nào đó để tạo thành một hình ảnh gợi tả: công lao của cha mẹ ví như trời biển",
    example: "công lao của cha mẹ ví như trời biển",
  },
  {
    word: "ví",
    part_of_speech: "kết từ",
    meaning:
      '(cũ, văn chương) từ dùng để nêu một giả thiết, thường về điều không thể có hoặc khó có thể có: "Ví đây đổi phận làm trai được, Thì sự anh hùng há bấy nhiêu." (HXHương; 13)',
    example:
      'Ví đây đổi phận làm trai được, Thì sự anh hùng há bấy nhiêu." (HXHương; 13)',
  },
  {
    word: "vi",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) vây (cá): vi cá",
    example: "vi cá",
  },
  {
    word: "vỉ",
    part_of_speech: "danh từ",
    meaning:
      "vật hình tấm có nhiều lỗ nhỏ, thường đan bằng tre, dùng để lót giữ trong nồi, vại, v.v.",
    example: "vỉ thuốc * vỉ cúc bấm * mỗi vỉ cặp tóc có mười cái",
  },
  {
    word: "vêu vao",
    part_of_speech: "tính từ",
    meaning:
      "hốc hác, gầy guộc: mặt mũi vêu vao * gầy vêu vao, trông chỉ còn da bọc xương",
    example: "mặt mũi vêu vao * gầy vêu vao, trông chỉ còn da bọc xương",
  },
  {
    word: "ví bằng",
    part_of_speech: "kết từ",
    meaning:
      '(văn chương, hiếm) tổ hợp dùng để nêu một giả thiết hoặc một điều kiện nhằm nói rõ cái gì sẽ xảy ra đối với trường hợp vừa được nói đến: "Ví bằng thú thật cùng ta, Cũng dung kẻ dưới mới là lượng trên." (TKiều)',
    example:
      'Ví bằng thú thật cùng ta, Cũng dung kẻ dưới mới là lượng trên." (TKiều)',
  },
  {
    word: "vị",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng người có danh hiệu hoặc chức vị, với ý kính trọng: các vị đại biểu * vị quan thanh liêm",
    example: "các vị đại biểu * vị quan thanh liêm",
  },
  {
    word: "vị",
    part_of_speech: "danh từ",
    meaning: "dạ dày (theo cách gọi trong đông y): thuốc bổ vị",
    example: "thuốc bổ vị",
  },
  {
    word: "vị",
    part_of_speech: "danh từ",
    meaning:
      "thuộc tính của sự vật nhận biết được bằng lưỡi: vị cay của ớt * vị chua * không mùi, không vị",
    example: "vị cay của ớt * vị chua * không mùi, không vị",
  },
  {
    word: "vị",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng loại dược liệu dùng trong thang thuốc đông y: thêm vài vị vào thang thuốc",
    example: "thêm vài vị vào thang thuốc",
  },
  {
    word: "vị",
    part_of_speech: "kết từ",
    meaning: "(cũ) vì: vị tình, vị nghĩa, ai vị đĩa xôi đầy (tng)",
    example: "vị tình, vị nghĩa, ai vị đĩa xôi đầy (tng)",
  },
  {
    word: "vi cảnh",
    part_of_speech: "động từ",
    meaning: "vi phạm luật lệ nơi công cộng: phạt vi cảnh",
    example: "phạt vi cảnh",
  },
  {
    word: "vi chất",
    part_of_speech: "danh từ",
    meaning:
      "chất chỉ cần một lượng rất nhỏ, nhưng có tác dụng lớn đến sự phát triển của cơ thể: bị bướu cổ do thiếu vi chất",
    example: "bị bướu cổ do thiếu vi chất",
  },
  {
    word: "vị chi",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) từ dùng để mở đầu một lời tính gộp tất cả các khoản vừa nói: ba người, mỗi người năm chục, vị chi là trăm rưỡi",
    example: "ba người, mỗi người năm chục, vị chi là trăm rưỡi",
  },
  {
    word: "ví dặm",
    part_of_speech: "danh từ",
    meaning:
      "hát ví và hát dặm, thể loại hát dân gian của vùng Nghệ Tĩnh: hát ví dặm * câu hò ví dặm",
    example: "hát ví dặm * câu hò ví dặm",
  },
  {
    word: "vì chưng",
    part_of_speech: "kết từ",
    meaning:
      '(cũ) như vì (ng1): "Vì chưng bác mẹ tôi nghèo, Cho nên tôi phải băm bèo thái khoai." (ca dao)',
    example:
      'Vì chưng bác mẹ tôi nghèo, Cho nên tôi phải băm bèo thái khoai." (ca dao)',
  },
  {
    word: "vị chủng",
    part_of_speech: "tính từ",
    meaning:
      "chỉ chú ý, tôn trọng dân tộc mình, coi thường, coi khinh các dân tộc khác: tư tưởng vị chủng",
    example: "tư tưởng vị chủng",
  },
  {
    word: "ví dầu",
    part_of_speech: "kết từ",
    meaning:
      "(phương ngữ, văn chương) ví dù: “Ví dầu cầu ván đóng đinh, Cầu tre lắt lẻo gập ghềnh khó đi.” (ca dao)",
    example: "“Ví dầu cầu ván đóng đinh, Cầu tre lắt lẻo gập ghềnh khó đi.”",
  },
  {
    word: "ví dù",
    part_of_speech: "kết từ",
    meaning:
      '(văn chương) tổ hợp dùng để nêu một giả thiết, thường là không bình thường để khẳng định hoặc nhấn mạnh một ý nào đó: "Ví dù giải kết đến điều, Thì đem vàng đá mà liều với thân!" (TKiều)',
    example:
      'Ví dù giải kết đến điều, Thì đem vàng đá mà liều với thân!" (TKiều)',
  },
  {
    word: "vi điện tử",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về vi điện tử học: kĩ thuật vi điện tử * lắp ráp mạch vi điện tử",
    example: "kĩ thuật vi điện tử * lắp ráp mạch vi điện tử",
  },
  {
    word: "vĩ độ",
    part_of_speech: "danh từ",
    meaning:
      "khoảng cách tính bằng độ cung kể từ xích đạo đến một vĩ tuyến nào đó theo hai chiều, lên Bắc Cực hoặc xuống Nam Cực: lãnh thổ Việt Nam nằm trải dài trên 15 vĩ độ",
    example: "lãnh thổ Việt Nam nằm trải dài trên 15 vĩ độ",
  },
  {
    word: "ví dụ",
    part_of_speech: "",
    meaning: "như thí dụ: dẫn thêm ví dụ * ví dụ mai mưa thì làm thế nào?",
    example: "dẫn thêm ví dụ * ví dụ mai mưa thì làm thế nào?",
  },
  {
    word: "vĩ đại",
    part_of_speech: "tính từ",
    meaning:
      "có tầm cỡ và giá trị lớn lao, đáng khâm phục: sự nghiệp vĩ đại * chiến thắng vĩ đại * những phát minh vĩ đại * con người vĩ đại * đầu óc vĩ đại",
    example:
      "sự nghiệp vĩ đại * chiến thắng vĩ đại * những phát minh vĩ đại * con người vĩ đại * đầu óc vĩ đại",
  },
  {
    word: "vi hành",
    part_of_speech: "động từ",
    meaning:
      "(cũ, trang trọng) (vua, quan) cải trang đi ra khỏi nơi ở để xem xét tình hình dân chúng: nhà vua đi vi hành",
    example: "nhà vua đi vi hành",
  },
  {
    word: "vi khuẩn",
    part_of_speech: "danh từ",
    meaning:
      "vi sinh vật đơn bào, chưa có nhân phân hoá, sinh sản chủ yếu bằng lối phân đôi: vi khuẩn lao (= gây bệnh lao) * Ruột chứa nhiều vi khuẩn có lợi.",
    example: "vi khuẩn lao (= gây bệnh lao) * Ruột chứa nhiều vi khuẩn có lợi.",
  },
  {
    word: "vi khí hậu",
    part_of_speech: "danh từ",
    meaning:
      "khí hậu của một vùng rất nhỏ (như ở một thung lũng, sườn núi, cánh rừng, v.v.), có những đặc điểm khác biệt với các vùng lân cận: môi trường vi khí hậu",
    example: "môi trường vi khí hậu",
  },
  {
    word: "vị kỉ",
    part_of_speech: "tính từ",
    meaning:
      "chỉ biết chăm lo đến lợi ích của cá nhân mình, xem thường lợi ích của người khác, của xã hội: lối sống vị kỉ * có đầu óc vị kỉ",
    example: "lối sống vị kỉ * có đầu óc vị kỉ",
  },
  {
    word: "vị kỷ",
    part_of_speech: "tính từ",
    meaning:
      "chỉ biết chăm lo đến lợi ích của cá nhân mình, xem thường lợi ích của người khác, của xã hội: lối sống vị kỉ * có đầu óc vị kỉ",
    example: "lối sống vị kỉ * có đầu óc vị kỉ",
  },
  {
    word: "vi mô",
    part_of_speech: "danh từ",
    meaning:
      "đối tượng có quy mô nhỏ trong hệ thống, được coi là cấp thấp nhất; phân biệt với vĩ mô: thế giới vi mô",
    example: "thế giới vi mô",
  },
  {
    word: "vi mô",
    part_of_speech: "tính từ",
    meaning:
      "thuộc cấp đơn vị kinh tế cơ sở; phân biệt với vĩ mô: quản lí vi mô",
    example: "quản lí vi mô",
  },
  {
    word: "vi lượng",
    part_of_speech: "danh từ",
    meaning:
      "lượng chất rất nhỏ cũng đủ để có một tác dụng quan trọng: bón phân vi lượng * trong nước khoáng có nhiều nguyên tố vi lượng",
    example:
      "bón phân vi lượng * trong nước khoáng có nhiều nguyên tố vi lượng",
  },
  {
    word: "vĩ mô",
    part_of_speech: "danh từ",
    meaning:
      "đối tượng có quy mô lớn nhất, bao quát toàn hệ thống; phân biệt với vi mô: thế giới vĩ mô * cấu trúc vĩ mô",
    example: "thế giới vĩ mô * cấu trúc vĩ mô",
  },
  {
    word: "vĩ mô",
    part_of_speech: "tính từ",
    meaning:
      "thuộc phạm vi toàn bộ nền kinh tế; phân biệt với vi mô: quản lí vĩ mô",
    example: "quản lí vĩ mô",
  },
  {
    word: "vì nể",
    part_of_speech: "động từ",
    meaning: "nể và tôn trọng: được bạn bè vì nể",
    example: "được bạn bè vì nể",
  },
  {
    word: "vị ngữ",
    part_of_speech: "danh từ",
    meaning:
      "thành phần chính yếu của một câu đơn, nói rõ hoạt động, tính chất, trạng thái của đối tượng được nêu ở chủ ngữ: xác định thành phần chủ ngữ và vị ngữ của câu",
    example: "xác định thành phần chủ ngữ và vị ngữ của câu",
  },
  {
    word: "vĩ nhân",
    part_of_speech: "danh từ",
    meaning:
      "người có tài đức vượt hẳn mọi người và có sự nghiệp, công lao đặc biệt lớn đối với xã hội: bậc vĩ nhân * những vĩ nhân của thế giới",
    example: "bậc vĩ nhân * những vĩ nhân của thế giới",
  },
  {
    word: "vi phân",
    part_of_speech: "tính từ",
    meaning: "thuộc về vi phân: phép tính vi phân",
    example: "phép tính vi phân",
  },
  {
    word: "ví như",
    part_of_speech: "",
    meaning: "(hiếm) như nếu như: ví như không xong, mai phải làm bù",
    example: "ví như không xong, mai phải làm bù",
  },
  {
    word: "ví như",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) ví dụ như: có rất nhiều việc phải làm, ví như cơm nước, giặt giũ, quét dọn...",
    example:
      "có rất nhiều việc phải làm, ví như cơm nước, giặt giũ, quét dọn...",
  },
  {
    word: "vị ngã",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như vị kỉ: tư tưởng vị ngã",
    example: "tư tưởng vị ngã",
  },
  {
    word: "vi phạm",
    part_of_speech: "động từ",
    meaning:
      "không tuân theo hoặc làm trái lại những điều quy định: vi phạm luật giao thông * vi phạm bản quyền",
    example: "vi phạm luật giao thông * vi phạm bản quyền",
  },
  {
    word: "vị nể",
    part_of_speech: "động từ",
    meaning: "nể và tôn trọng: được bạn bè vì nể",
    example: "được bạn bè vì nể",
  },
  {
    word: "vi phẫu",
    part_of_speech: "danh từ",
    meaning: "vi phẫu thuật (nói tắt): kĩ thuật vi phẫu * mổ vi phẫu",
    example: "kĩ thuật vi phẫu * mổ vi phẫu",
  },
  {
    word: "vi phẫu thuật",
    part_of_speech: "danh từ",
    meaning:
      "phẫu thuật tiến hành trên cấu trúc sống rất nhỏ bằng sử dụng kính hiển vi và tia laser: áp dụng vi phẫu thuật trong mổ mắt",
    example: "áp dụng vi phẫu thuật trong mổ mắt",
  },
  {
    word: "ví phỏng",
    part_of_speech: "kết từ",
    meaning:
      "tổ hợp dùng để nêu một giả thiết về trường hợp rất có khả năng xảy ra: ví phỏng tôi đến muộn thì mọi người cứ tiến hành trước",
    example: "ví phỏng tôi đến muộn thì mọi người cứ tiến hành trước",
  },
  {
    word: "vi sinh",
    part_of_speech: "danh từ",
    meaning: "vi sinh vật (nói tắt): sản xuất phân vi sinh",
    example: "sản xuất phân vi sinh",
  },
  {
    word: "vỉ ruồi",
    part_of_speech: "danh từ",
    meaning:
      "vật dùng để đập ruồi, thường đan bằng nan tre mỏng và có cán dài: đan vỉ ruồi",
    example: "đan vỉ ruồi",
  },
  {
    word: "vì sao",
    part_of_speech: "",
    meaning: "vì lẽ gì: vì sao anh lại làm thế?",
    example: "vì sao anh lại làm thế?",
  },
  {
    word: "vị tất",
    part_of_speech: "phụ từ",
    meaning: "(cũ) chưa hẳn, chưa chắc: nói như thế, vị tất ông ấy đã biết",
    example: "nói như thế, vị tất ông ấy đã biết",
  },
  {
    word: "vi sóng",
    part_of_speech: "danh từ",
    meaning: "sóng điện từ có bước sóng cực ngắn: lò vi sóng",
    example: "lò vi sóng",
  },
  {
    word: "vị tha",
    part_of_speech: "tính từ",
    meaning:
      "có tinh thần chăm lo đến lợi ích của người khác một cách vô tư, sẵn sàng vì lợi ích của người khác mà hi sinh lợi ích của cá nhân mình: giàu lòng vị tha * sống vị tha",
    example: "giàu lòng vị tha * sống vị tha",
  },
  {
    word: "vĩ thanh",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương) lời cuối cùng, phần kết (của một tác phẩm): khúc vĩ thanh",
    example: "khúc vĩ thanh",
  },
  {
    word: "vị thành niên",
    part_of_speech: "tính từ",
    meaning:
      "chưa đến tuổi được pháp luật công nhận là công dân với đầy đủ các quyền và nghĩa vụ: tuổi vị thành niên",
    example: "tuổi vị thành niên",
  },
  {
    word: "vì thế",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra có lí do hoặc nguyên nhân là điều vừa được nói đến: không đi học đều, vì thế không hiểu bài",
    example: "không đi học đều, vì thế không hiểu bài",
  },
  {
    word: "vi thần",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) từ quan lại thời phong kiến dùng để xưng với vua: vi thần xin khấu kiến bệ hạ",
    example: "vi thần xin khấu kiến bệ hạ",
  },
  {
    word: "vi tính",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) máy vi tính (nói tắt): sử dụng vi tính thành thạo * thế giới vi tính",
    example: "sử dụng vi tính thành thạo * thế giới vi tính",
  },
  {
    word: "vị thế",
    part_of_speech: "danh từ",
    meaning:
      "vị trí, địa vị, về mặt có vai trò, ảnh hưởng đến những mối quan hệ trong xã hội: có vị thế cao trong xã hội",
    example: "có vị thế cao trong xã hội",
  },
  {
    word: "vi tiểu hình hoá",
    part_of_speech: "danh từ",
    meaning:
      "phương pháp giảm đáng kể khối lượng và kích thước các thiết bị điện tử bằng cách giảm kích thước các phần tử riêng rẽ của nó, xây dựng kết cấu và công nghệ chế tạo hợp lí hoá, áp dụng các mạch tích hợp, v.v: vi tiểu hình hoá các thiết bị điện tử cá nhân",
    example: "vi tiểu hình hoá các thiết bị điện tử cá nhân",
  },
  {
    word: "ví thử",
    part_of_speech: "kết từ",
    meaning:
      'tổ hợp dùng để nêu một giả thiết trái với thực tế để làm căn cứ cho lập luận, chứng minh: "Ví thử là dại, một mình mình dại chứ cả làng này người ta dại à?" (ĐVũ; 1)',
    example:
      'Ví thử là dại, một mình mình dại chứ cả làng này người ta dại à?" (ĐVũ; 1)',
  },
  {
    word: "vị trí",
    part_of_speech: "danh từ",
    meaning:
      "chỗ, nơi được xác định dành riêng cho người, vật hoặc việc nào đó: vị trí địa lí * rời vị trí chiến đấu * để quyển sách vào đúng vị trí cũ",
    example:
      "vị trí địa lí * rời vị trí chiến đấu * để quyển sách vào đúng vị trí cũ",
  },
  {
    word: "vị trí",
    part_of_speech: "danh từ",
    meaning:
      "địa vị, vai trò trong xã hội, trong một tổ chức nào đó: vị trí trụ cột trong gia đình * có vị trí trong xã hội",
    example: "vị trí trụ cột trong gia đình * có vị trí trong xã hội",
  },
  {
    word: "vị từ",
    part_of_speech: "danh từ",
    meaning:
      "phạm trù từ loại bao gồm động từ và tính từ, thường có khả năng trực tiếp làm vị ngữ trong câu: nhóm vị từ tâm lí tình cảm",
    example: "nhóm vị từ tâm lí tình cảm",
  },
  {
    word: "vi trùng",
    part_of_speech: "danh từ",
    meaning: "vi khuẩn gây bệnh: ổ vi trùng * nhiễm vi trùng uốn ván",
    example: "ổ vi trùng * nhiễm vi trùng uốn ván",
  },
  {
    word: "vi vu",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) đi đây đi đó một cách tự do, thoải mái: vi vu đây đó * đi vi vu",
    example: "vi vu đây đó * đi vi vu",
  },
  {
    word: "vi vu",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng như tiếng gió thổi nhè nhẹ qua cành lá: tiếng sáo diều vi vu trầm bổng",
    example: "tiếng sáo diều vi vu trầm bổng",
  },
  {
    word: "vi vút",
    part_of_speech: "tính từ",
    meaning: "từ mô phỏng tiếng như tiếng gió rít: gió bấc vi vút từng cơn",
    example: "gió bấc vi vút từng cơn",
  },
  {
    word: "vi-đê-ô",
    part_of_speech: "danh từ",
    meaning: "máy chiếu băng hình (băng video).",
    example: "quay video * xem video",
  },
  {
    word: "vi-ni-lông",
    part_of_speech: "danh từ",
    meaning: "sợi làm bằng hoá chất tổng hợp: vải vinylon",
    example: "vải vinylon",
  },
  {
    word: "vi-da",
    part_of_speech: "danh từ",
    meaning:
      "dấu thị thực của cơ quan đại diện một nước ngoài đóng trên một hộ chiếu, cho phép người mang hộ chiếu được đi vào, đi qua hoặc rời khỏi nước đó: cấp visa",
    example: "cấp visa",
  },
  {
    word: "vi-ô-lông",
    part_of_speech: "danh từ",
    meaning:
      "đàn bốn dây, nhỏ và nhẹ, khi chơi cặp giữa vai và cằm, kéo bằng vĩ: nghệ sĩ đàn violon",
    example: "nghệ sĩ đàn violon",
  },
  {
    word: "vi-rút",
    part_of_speech: "danh từ",
    meaning:
      "vi sinh vật nhỏ nhất, không thể nhìn thấy cả bằng kính hiển vi, phần lớn có thể gây bệnh: virus gây bệnh dại",
    example: "virus gây bệnh dại",
  },
  {
    word: "vi-ô-lét",
    part_of_speech: "danh từ",
    meaning:
      "cây thân thảo, lá nhỏ xẻ nhiều, hoa màu tím, cánh mỏng, thường nở vào dịp Tết Nguyên Đán: hoa violet",
    example: "hoa violet",
  },
  {
    word: "vía",
    part_of_speech: "danh từ",
    meaning:
      "yếu tố vô hình tồn tại phụ thuộc vào thể xác, được coi là tạo nên phần tinh thần của mỗi người, khi người chết thì cũng mất đi, theo quan niệm duy tâm: ba hồn bảy vía * cứng vía nên không sợ * sợ hết vía",
    example: "ba hồn bảy vía * cứng vía nên không sợ * sợ hết vía",
  },
  {
    word: "vía",
    part_of_speech: "danh từ",
    meaning:
      "cái coi là yếu tố thần bí có thể ảnh hưởng đến vận may rủi, đến sự lành dữ của người khác, theo quan niệm mê tín: lành vía * người xấu vía",
    example: "lành vía * người xấu vía",
  },
  {
    word: "vía",
    part_of_speech: "danh từ",
    meaning:
      "vật dùng để đeo trên người hoặc để đốt đi, vì cho là có phép lạ tránh được tai hoạ, bệnh tật, theo quan niệm thời xưa: đốt vía",
    example: "đốt vía",
  },
  {
    word: "vía",
    part_of_speech: "danh từ",
    meaning:
      "vật thường bằng giấy dùng trong lễ tang ngày trước, giả làm những thứ đưa linh hồn người chết bay lên trời, theo tín ngưỡng dân gian: cờ vía * chạy như ngựa vía (tng)",
    example: "cờ vía * chạy như ngựa vía (tng)",
  },
  {
    word: "vía",
    part_of_speech: "danh từ",
    meaning:
      "lễ ngày sinh (thường là của thần thánh, trời Phật): ngày vía Phật tổ",
    example: "ngày vía Phật tổ",
  },
  {
    word: "vỉa hè",
    part_of_speech: "danh từ",
    meaning:
      "phần dọc theo hai bên đường phố, thường được lát gạch chuyên dùng, dành riêng cho người đi bộ: cấm lấn chiếm vỉa hè",
    example: "cấm lấn chiếm vỉa hè",
  },
  {
    word: "video",
    part_of_speech: "danh từ",
    meaning: "máy chiếu băng hình (băng video).",
    example: "quay video * xem video",
  },
  {
    word: "vía van",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) vía (nói khái quát): sợ vía van * gọi vía gọi van",
    example: "sợ vía van * gọi vía gọi van",
  },
  {
    word: "việc gì",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) (sự việc xảy ra) có thiệt hại gì: xe đổ nhưng may mà không ai việc gì",
    example: "xe đổ nhưng may mà không ai việc gì",
  },
  {
    word: "việc gì",
    part_of_speech: "",
    meaning:
      "không can hệ gì đến, dính líu gì đến: chuyện của tôi, việc gì đến anh",
    example: "chuyện của tôi, việc gì đến anh",
  },
  {
    word: "việc gì",
    part_of_speech: "",
    meaning:
      "chẳng có gì mà cần phải: có gì thì cứ nói thẳng, việc gì phải rào đón quanh co",
    example: "có gì thì cứ nói thẳng, việc gì phải rào đón quanh co",
  },
  {
    word: "việc đã rồi",
    part_of_speech: "",
    meaning:
      "việc đã xảy ra rồi, không thể thay đổi được nữa, mặc dù có thể không muốn, không tán đồng cách làm đó: việc đã rồi, có trách mắng cũng vô ích",
    example: "việc đã rồi, có trách mắng cũng vô ích",
  },
  {
    word: "vỉa",
    part_of_speech: "danh từ",
    meaning:
      "lớp khoáng sản hay đất đá nằm chạy dài và có độ dày tương đối không đổi, do quá trình trầm tích ổn định tạo nên: vỉa than * vỉa quặng",
    example: "vỉa than * vỉa quặng",
  },
  {
    word: "vỉa",
    part_of_speech: "danh từ",
    meaning:
      "phần chạy dọc theo rìa hoặc xung quanh một bề mặt, thường được xây lát để giữ cho chắc: mặt nền được bó vỉa bằng đá ong",
    example: "mặt nền được bó vỉa bằng đá ong",
  },
  {
    word: "vỉa",
    part_of_speech: "danh từ",
    meaning: "câu mở trước khi vào điệu chính trong chèo: hát vỉa",
    example: "hát vỉa",
  },
  {
    word: "việc",
    part_of_speech: "danh từ",
    meaning:
      "cái, điều phải làm, về mặt công sức phải bỏ ra: việc nhà * việc nước * bận việc đồng áng",
    example: "việc nhà * việc nước * bận việc đồng áng",
  },
  {
    word: "việc",
    part_of_speech: "danh từ",
    meaning:
      "cái làm hằng ngày theo nghề và được trả công: thợ học việc * nghỉ việc buổi sáng",
    example: "thợ học việc * nghỉ việc buổi sáng",
  },
  {
    word: "việc",
    part_of_speech: "danh từ",
    meaning:
      "chuyện xảy ra, đòi hỏi phải giải quyết: việc lôi thôi * lúc có việc thì mất mặt",
    example: "việc lôi thôi * lúc có việc thì mất mặt",
  },
  {
    word: "việc",
    part_of_speech: "danh từ",
    meaning:
      "từ có tác dụng danh từ hoá (sự vật hoá) một hoạt động, một hành động nào đó: việc học hành * chú ý việc phòng chống thiên tai",
    example: "việc học hành * chú ý việc phòng chống thiên tai",
  },
  {
    word: "viêm",
    part_of_speech: "danh từ",
    meaning:
      "hiện tượng tổn thương ở một bộ phận cơ thể, biểu hiện bằng triệu chứng sưng đỏ, gây nóng và đau: viêm họng * viêm khớp * bị viêm phổi",
    example: "viêm họng * viêm khớp * bị viêm phổi",
  },
  {
    word: "việc làm",
    part_of_speech: "danh từ",
    meaning:
      "hành động cụ thể: lời nói phải đi đôi với việc làm * một việc làm đúng đắn",
    example: "lời nói phải đi đôi với việc làm * một việc làm đúng đắn",
  },
  {
    word: "việc làm",
    part_of_speech: "danh từ",
    meaning:
      "công việc được giao cho làm thường ngày và được trả công: tìm việc làm * trung tâm môi giới việc làm",
    example: "tìm việc làm * trung tâm môi giới việc làm",
  },
  {
    word: "viên",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị những vật thường là nhỏ và tròn, được làm bằng cùng một chất liệu, có hình khối giống nhau, kích thước bằng nhau: viên thuốc * viên bi * viên đạn * kê thêm mấy viên gạch",
    example: "viên thuốc * viên bi * viên đạn * kê thêm mấy viên gạch",
  },
  {
    word: "viên",
    part_of_speech: "động từ",
    meaning:
      "vê thành từng khối nhỏ và tròn: viên bột làm bánh * viên cục đất thành hòn bi",
    example: "viên bột làm bánh * viên cục đất thành hòn bi",
  },
  {
    word: "viên",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) từ dùng để chỉ từng người giữ chức vụ nào đó: viên lục sự già * viên thuyền trưởng",
    example: "viên lục sự già * viên thuyền trưởng",
  },
  {
    word: "viền",
    part_of_speech: "động từ",
    meaning:
      "vê mép vải cho tròn lại rồi khâu hoặc đính thêm vào một miếng vải khác cho kín và làm nổi rõ đường mép lên: cổ áo viền đăng ten * đường viền",
    example: "cổ áo viền đăng ten * đường viền",
  },
  {
    word: "viễn",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) viễn thị (nói tắt): đeo kính viễn",
    example: "đeo kính viễn",
  },
  {
    word: "viện dẫn",
    part_of_speech: "động từ",
    meaning:
      "đưa ra, dẫn ra để minh hoạ hoặc làm chỗ dựa cho lập luận: viện dẫn sách kinh điển * viện dẫn nhiều số liệu",
    example: "viện dẫn sách kinh điển * viện dẫn nhiều số liệu",
  },
  {
    word: "viện bảo tàng",
    part_of_speech: "danh từ",
    meaning:
      "cơ quan sưu tầm, cất giữ, trưng bày những tài liệu, hiện vật có giá trị, ý nghĩa lịch sử: viện bảo tàng mĩ thuật",
    example: "viện bảo tàng mĩ thuật",
  },
  {
    word: "viện",
    part_of_speech: "danh từ",
    meaning:
      "cơ quan nghiên cứu khoa học hoặc tên gọi một số cơ quan đặc biệt: viện Văn học * viện kiểm sát nhân dân",
    example: "viện Văn học * viện kiểm sát nhân dân",
  },
  {
    word: "viện",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) bệnh viện (nói tắt): nằm viện * ra viện * đưa người nhà đi viện",
    example: "nằm viện * ra viện * đưa người nhà đi viện",
  },
  {
    word: "viện",
    part_of_speech: "động từ",
    meaning:
      "đưa ra một lí do nào đó và dựa vào đó để không hoặc làm việc gì: viện cớ bận, không đi * viện đủ mọi lí do",
    example: "viện cớ bận, không đi * viện đủ mọi lí do",
  },
  {
    word: "viện binh",
    part_of_speech: "danh từ",
    meaning: "quân cứu viện: xin viện binh * đưa viện binh ra tiếp viện",
    example: "xin viện binh * đưa viện binh ra tiếp viện",
  },
  {
    word: "viễn cảnh",
    part_of_speech: "danh từ",
    meaning:
      "cảnh chụp ảnh hoặc quay phim được thể hiện ở cự li xa để có thể thu được hình ảnh trên một khung cảnh rộng; đối lập với cận cảnh.",
    example: "viễn cảnh về một thế giới đại đồng",
  },
  {
    word: "viêm nhiễm",
    part_of_speech: "",
    meaning: "viêm do nhiễm trùng: viêm nhiễm đường hô hấp",
    example: "viêm nhiễm đường hô hấp",
  },
  {
    word: "viễn chinh",
    part_of_speech: "động từ",
    meaning:
      "đi đánh nhau ở phương xa, ngoài bờ cõi nước mình: đội quân viễn chinh",
    example: "đội quân viễn chinh",
  },
  {
    word: "viên chức",
    part_of_speech: "danh từ",
    meaning:
      "người làm việc trong một cơ quan của nhà nước hay trong một tổ chức kinh doanh tư nhân thời trước: viên chức sở xe lửa * đại hội công nhân viên chức",
    example: "viên chức sở xe lửa * đại hội công nhân viên chức",
  },
  {
    word: "viễn du",
    part_of_speech: "động từ",
    meaning: "đi chơi phương xa: cuộc viễn du * chuyến viễn du",
    example: "cuộc viễn du * chuyến viễn du",
  },
  {
    word: "viện hàn lâm",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức khoa học ở một số nước mà thành viên là những nhà khoa học hoặc những văn nghệ sĩ nổi tiếng: viện hàn lâm khoa học Nga * viện hàn lâm mĩ thuật",
    example: "viện hàn lâm khoa học Nga * viện hàn lâm mĩ thuật",
  },
  {
    word: "viện phí",
    part_of_speech: "danh từ",
    meaning:
      "khoản tiền phải nộp cho bệnh viện về chi phí nằm điều trị: nộp viện phí cho người nhà * thanh toán tiền viện phí",
    example: "nộp viện phí cho người nhà * thanh toán tiền viện phí",
  },
  {
    word: "viễn dương",
    part_of_speech: "tính từ",
    meaning:
      "(tàu thuyền) có khả năng đi được tới nơi biển xa và dài ngày: tàu viễn dương",
    example: "tàu viễn dương",
  },
  {
    word: "viên ngoại",
    part_of_speech: "danh từ",
    meaning: "(cũ) chức quan nhỏ thuộc các bộ trong triều đình phong kiến.",
    example:
      'Có nhà viên ngoại họ Vương, Gia tư nghĩ cũng thường thường bực trung." (TKiều)',
  },
  {
    word: "viễn phương",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) phương xa: "Có người khách ở viễn phương, Xa nghe cũng nức tiếng nàng tìm chơi." (TKiều)',
    example:
      'Có người khách ở viễn phương, Xa nghe cũng nức tiếng nàng tìm chơi." (TKiều)',
  },
  {
    word: "viễn khách",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) khách từ phương xa tới: "Gần miền có một mụ nào, Đưa người viễn khách tìm vào vấn danh." (TKiều)',
    example:
      'Gần miền có một mụ nào, Đưa người viễn khách tìm vào vấn danh." (TKiều)',
  },
  {
    word: "viên mãn",
    part_of_speech: "tính từ",
    meaning:
      "(cũ, hiếm) đầy đủ, trọn vẹn: kết quả viên mãn * mặt đầy vẻ viên mãn * nụ cười viên mãn",
    example: "kết quả viên mãn * mặt đầy vẻ viên mãn * nụ cười viên mãn",
  },
  {
    word: "viên tịch",
    part_of_speech: "động từ",
    meaning: "(trang trọng) chết (nói về các nhà sư): sư cụ đã viên tịch",
    example: "sư cụ đã viên tịch",
  },
  {
    word: "viễn thám",
    part_of_speech: "động từ",
    meaning:
      "quan sát đối tượng từ rất xa bằng các phương tiện kĩ thuật hiện đại: phóng tàu đi viễn thám vũ trụ * cuộc viễn thám Mặt Trăng",
    example: "phóng tàu đi viễn thám vũ trụ * cuộc viễn thám Mặt Trăng",
  },
  {
    word: "viện sĩ",
    part_of_speech: "danh từ",
    meaning: "thành viên viện hàn lâm: viện sĩ viện hàn lâm khoa học Nga",
    example: "viện sĩ viện hàn lâm khoa học Nga",
  },
  {
    word: "viện trợ",
    part_of_speech: "động từ",
    meaning:
      "giúp đỡ về vật chất (thường là giữa các nước): hàng viện trợ * viện trợ cho đồng bào bị lũ lụt",
    example: "hàng viện trợ * viện trợ cho đồng bào bị lũ lụt",
  },
  {
    word: "viện trợ",
    part_of_speech: "danh từ",
    meaning: "khoản viện trợ: gửi viện trợ",
    example: "gửi viện trợ",
  },
  {
    word: "viễn thông",
    part_of_speech: "danh từ",
    meaning:
      "sự liên lạc giữa hai điểm cách xa nhau, có khoảng cách thực tế không giới hạn, bằng mọi phương thức: vệ tinh viễn thông",
    example: "vệ tinh viễn thông",
  },
  {
    word: "viễn tưởng",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất tưởng tượng về một tương lai xa xôi: truyện khoa học viễn tưởng",
    example: "truyện khoa học viễn tưởng",
  },
  {
    word: "viển vông",
    part_of_speech: "tính từ",
    meaning:
      "không thiết thực, hết sức xa rời thực tế: mơ ước viển vông * toàn nói những chuyện viển vông",
    example: "mơ ước viển vông * toàn nói những chuyện viển vông",
  },
  {
    word: "viễn thị",
    part_of_speech: "tính từ",
    meaning:
      "(mắt) chỉ nhìn thấy rõ được những vật ở xa, do bị tật; trái với cận thị: mắt bị viễn thị",
    example: "mắt bị viễn thị",
  },
  {
    word: "viễn vọng",
    part_of_speech: "động từ",
    meaning: "trông xa: kính viễn vọng",
    example: "kính viễn vọng",
  },
  {
    word: "viễn xứ",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương) nơi hoàn toàn xa xôi, cách biệt: bỏ làng đi viễn xứ * người viễn xứ",
    example: "bỏ làng đi viễn xứ * người viễn xứ",
  },
  {
    word: "viếng thăm",
    part_of_speech: "động từ",
    meaning:
      'như thăm viếng: "Trải bao thỏ lặn, ác tà, ấy mồ vô chủ, ai mà viếng thăm!" (TKiều)',
    example:
      'Trải bao thỏ lặn, ác tà, ấy mồ vô chủ, ai mà viếng thăm!" (TKiều)',
  },
  {
    word: "viết",
    part_of_speech: "động từ",
    meaning:
      "vạch những đường nét tạo thành chữ: tập viết * viết chính tả * lớn rồi mà chưa biết viết",
    example: "tập viết * viết chính tả * lớn rồi mà chưa biết viết",
  },
  {
    word: "viết",
    part_of_speech: "động từ",
    meaning:
      "ghi ra nội dung muốn nói đã được sắp xếp bằng chữ: viết thư * viết báo cáo * viết sách cho thiếu nhi",
    example: "viết thư * viết báo cáo * viết sách cho thiếu nhi",
  },
  {
    word: "viết",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) bút: mua cây viết",
    example: "mua cây viết",
  },
  {
    word: "viếng",
    part_of_speech: "động từ",
    meaning:
      "tỏ lòng thương tiếc người đã chết trước linh cữu hoặc trước mộ: đi viếng mộ liệt sĩ * vào lăng viếng Bác",
    example: "đi viếng mộ liệt sĩ * vào lăng viếng Bác",
  },
  {
    word: "vịn",
    part_of_speech: "động từ",
    meaning:
      "đặt bàn tay tựa vào để có được thế vững: bà vịn vai cháu * em bé vịn thành giường đứng lên",
    example: "bà vịn vai cháu * em bé vịn thành giường đứng lên",
  },
  {
    word: "vịn",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) vin vào: vịn cớ ốm để xin nghỉ",
    example: "vịn cớ ốm để xin nghỉ",
  },
  {
    word: "viết lách",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) viết (thường là viết văn; nói khái quát): việc viết lách * gần đây chẳng viết lách được gì",
    example: "việc viết lách * gần đây chẳng viết lách được gì",
  },
  {
    word: "viết tay",
    part_of_speech: "động từ",
    meaning:
      "viết bằng bút, trên giấy; phân biệt với đánh máy, in: tài liệu viết tay * bản viết tay",
    example: "tài liệu viết tay * bản viết tay",
  },
  {
    word: "vin",
    part_of_speech: "động từ",
    meaning: "với tay mà níu (cành cây) xuống: vin cành hái hoa",
    example: "vin cành hái hoa",
  },
  {
    word: "vin",
    part_of_speech: "động từ",
    meaning:
      "dựa vào một lí do nào đó để làm luôn việc gì: vin vào cảnh con mọn, không đi họp * vin vào một câu nói hớ để sinh sự",
    example:
      "vin vào cảnh con mọn, không đi họp * vin vào một câu nói hớ để sinh sự",
  },
  {
    word: "việt vị",
    part_of_speech: "danh từ",
    meaning:
      "lỗi của cầu thủ bóng đá khi nhận bóng để tiến công ở phần sân đối phương mà phía trước không có cầu thủ nào của phía đối phương, trừ thủ môn: rơi vào bẫy việt vị",
    example: "rơi vào bẫy việt vị",
  },
  {
    word: "vinh",
    part_of_speech: "tính từ",
    meaning:
      "được dư luận xã hội đánh giá cao và rất kính trọng: phu quý phụ vinh * chết vinh còn hơn sống nhục",
    example: "phu quý phụ vinh * chết vinh còn hơn sống nhục",
  },
  {
    word: "vinh dự",
    part_of_speech: "danh từ",
    meaning:
      "biểu hiện sự kính trọng, sự đánh giá cao của tập thể, của xã hội đối với những cống hiến to lớn của cá nhân hay tập thể nào đó: một vinh dự lớn * niềm vinh dự lớn lao",
    example: "một vinh dự lớn * niềm vinh dự lớn lao",
  },
  {
    word: "vinh dự",
    part_of_speech: "tính từ",
    meaning:
      "sung sướng về tinh thần khi được hưởng một vinh dự: lấy làm vinh dự",
    example: "lấy làm vinh dự",
  },
  {
    word: "vĩnh hằng",
    part_of_speech: "tính từ",
    meaning: "có tính chất tồn tại mãi mãi như thế: về cõi vĩnh hằng (chết)",
    example: "về cõi vĩnh hằng (chết)",
  },
  {
    word: "vĩnh biệt",
    part_of_speech: "động từ",
    meaning:
      "xa lìa nhau mãi mãi, không bao giờ còn gặp lại (thường nói về người vừa qua đời): vĩnh biệt cõi đời * chào vĩnh biệt * lá thư vĩnh biệt",
    example: "vĩnh biệt cõi đời * chào vĩnh biệt * lá thư vĩnh biệt",
  },
  {
    word: "vinh danh",
    part_of_speech: "động từ",
    meaning:
      "tôn vinh tên tuổi, công lao: buổi lễ vinh danh doanh nhân tiêu biểu",
    example: "buổi lễ vinh danh doanh nhân tiêu biểu",
  },
  {
    word: "vinh hoa",
    part_of_speech: "",
    meaning:
      "(cũ, văn chương) vẻ vang và được hưởng sung sướng về vật chất, theo quan niệm cũ: được hưởng vinh hoa, phú quý",
    example: "được hưởng vinh hoa, phú quý",
  },
  {
    word: "vịnh",
    part_of_speech: "danh từ",
    meaning:
      "phần biển, đại dương hoặc hồ lớn ăn sâu vào đất liền: vịnh Bắc Bộ",
    example: "vịnh Bắc Bộ",
  },
  {
    word: "vịnh",
    part_of_speech: "động từ",
    meaning:
      "làm thơ về phong cảnh hoặc sự vật trước mắt (một lối làm thơ phổ biến thời trước): vịnh cái quạt * làm một bài vịnh phong cảnh",
    example: "vịnh cái quạt * làm một bài vịnh phong cảnh",
  },
  {
    word: "vinh hiển",
    part_of_speech: "tính từ",
    meaning:
      '(cũ, văn chương) như hiển vinh: "Ba vuông sánh với bảy tròn, Đời cha vinh hiển đời con sang giầu." (ca dao)',
    example:
      'Ba vuông sánh với bảy tròn, Đời cha vinh hiển đời con sang giầu." (ca dao)',
  },
  {
    word: "vinh hạnh",
    part_of_speech: "danh từ",
    meaning: "điều mang lại vinh dự: được ngài đến thăm là một vinh hạnh lớn",
    example: "được ngài đến thăm là một vinh hạnh lớn",
  },
  {
    word: "vinh hạnh",
    part_of_speech: "tính từ",
    meaning:
      "sung sướng vì có được vinh dự: niềm vinh hạnh * rất vinh hạnh được quen biết ông",
    example: "niềm vinh hạnh * rất vinh hạnh được quen biết ông",
  },
  {
    word: "vĩnh cửu",
    part_of_speech: "tính từ",
    meaning: "rất lâu dài, gần như sẽ còn mãi mãi: tình yêu vĩnh cửu",
    example: "tình yêu vĩnh cửu",
  },
  {
    word: "vinh quang",
    part_of_speech: "tính từ",
    meaning:
      "có giá trị tinh thần cao, đem lại niềm tự hào chính đáng: sự nghiệp vinh quang * lao động là vinh quang",
    example: "sự nghiệp vinh quang * lao động là vinh quang",
  },
  {
    word: "vinh qui",
    part_of_speech: "động từ",
    meaning:
      '(cũ) trở về làng một cách vẻ vang (thường nói về người thi đỗ khoa thi đình): vinh quy bái tổ * "Tưng bừng vua mở khoa thi, Tôi đỗ quan Trạng, vinh quy về làng." (NgBính; 7)',
    example:
      'vinh quy bái tổ * "Tưng bừng vua mở khoa thi, Tôi đỗ quan Trạng, vinh quy về làng." (NgBính; 7)',
  },
  {
    word: "vĩnh viễn",
    part_of_speech: "tính từ",
    meaning:
      "có sự tồn tại ngoài thời gian hoặc trong mọi thời gian, không có bắt đầu cũng không có kết thúc: vật chất vĩnh viễn tồn tại",
    example: "vật chất vĩnh viễn tồn tại",
  },
  {
    word: "vĩnh viễn",
    part_of_speech: "tính từ",
    meaning:
      "liên tục mãi mãi, từ đây trở đi: chia tay vĩnh viễn * để lại di chứng vĩnh viễn",
    example: "chia tay vĩnh viễn * để lại di chứng vĩnh viễn",
  },
  {
    word: "vinh quy",
    part_of_speech: "động từ",
    meaning:
      '(cũ) trở về làng một cách vẻ vang (thường nói về người thi đỗ khoa thi đình): vinh quy bái tổ * "Tưng bừng vua mở khoa thi, Tôi đỗ quan Trạng, vinh quy về làng." (NgBính; 7)',
    example:
      'vinh quy bái tổ * "Tưng bừng vua mở khoa thi, Tôi đỗ quan Trạng, vinh quy về làng." (NgBính; 7)',
  },
  {
    word: "vinylon",
    part_of_speech: "danh từ",
    meaning: "sợi làm bằng hoá chất tổng hợp: vải vinylon",
    example: "vải vinylon",
  },
  {
    word: "viola",
    part_of_speech: "danh từ",
    meaning:
      "đàn dây, kéo bằng vĩ như violon nhưng kích thước lớn hơn và tạo ra âm thanh trầm hơn: kéo viola",
    example: "kéo viola",
  },
  {
    word: "violet",
    part_of_speech: "danh từ",
    meaning:
      "cây thân thảo, lá nhỏ xẻ nhiều, hoa màu tím, cánh mỏng, thường nở vào dịp Tết Nguyên Đán: hoa violet",
    example: "hoa violet",
  },
  {
    word: "violon",
    part_of_speech: "danh từ",
    meaning:
      "đàn bốn dây, nhỏ và nhẹ, khi chơi cặp giữa vai và cằm, kéo bằng vĩ: nghệ sĩ đàn violon",
    example: "nghệ sĩ đàn violon",
  },
  {
    word: "visa",
    part_of_speech: "danh từ",
    meaning:
      "dấu thị thực của cơ quan đại diện một nước ngoài đóng trên một hộ chiếu, cho phép người mang hộ chiếu được đi vào, đi qua hoặc rời khỏi nước đó: cấp visa",
    example: "cấp visa",
  },
  {
    word: "virus",
    part_of_speech: "danh từ",
    meaning:
      "vi sinh vật nhỏ nhất, không thể nhìn thấy cả bằng kính hiển vi, phần lớn có thể gây bệnh: virus gây bệnh dại",
    example: "virus gây bệnh dại",
  },
  {
    word: "vít",
    part_of_speech: "danh từ",
    meaning:
      "vật bằng kim loại hình côn hoặc hình trụ có ren, thường dùng để kẹp chặt các mối ghép tháo được: bắt vít",
    example: "bắt vít",
  },
  {
    word: "vít",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ, hiếm) bít kín: vít khe hở * vít hết các lối ra",
    example: "vít khe hở * vít hết các lối ra",
  },
  {
    word: "vít",
    part_of_speech: "động từ",
    meaning:
      "kéo cho cong hẳn, thấp hẳn một đầu xuống: vít cần rượu * vít cành hái quả",
    example: "vít cần rượu * vít cành hái quả",
  },
  {
    word: "vịt",
    part_of_speech: "danh từ",
    meaning:
      "gia cầm nuôi để lấy thịt và trứng, mỏ dẹp và rộng, chân thấp có màng da giữa các ngón, bơi giỏi, bay kém.",
    example: "vịt dầu * vịt nước mắm",
  },
  {
    word: "víu",
    part_of_speech: "động từ",
    meaning: "(hiếm) bíu lấy, níu lấy: víu cành hoa * bé víu lấy tay mẹ",
    example: "víu cành hoa * bé víu lấy tay mẹ",
  },
  {
    word: "vỏ",
    part_of_speech: "danh từ",
    meaning:
      "lớp mỏng bọc bên ngoài của cây, quả: bóc vỏ chuối * vỏ quýt dày có móng tay nhọn (tng)",
    example: "bóc vỏ chuối * vỏ quýt dày có móng tay nhọn (tng)",
  },
  {
    word: "vỏ",
    part_of_speech: "danh từ",
    meaning:
      "phần cứng bọc bên ngoài cơ thể một số động vật nhỏ: vỏ ốc * vỏ hến",
    example: "vỏ ốc * vỏ hến",
  },
  {
    word: "vỏ",
    part_of_speech: "danh từ",
    meaning:
      "cái bọc bên ngoài hoặc làm thành bao đựng của một số đồ vật: vỏ gối * may vỏ chăn * vỏ bao diêm",
    example: "vỏ gối * may vỏ chăn * vỏ bao diêm",
  },
  {
    word: "vỏ",
    part_of_speech: "danh từ",
    meaning:
      "vỏ hoặc rễ của một số cây, dùng để ăn trầu: vỏ chay * mua khúc vỏ về ăn trầu",
    example: "vỏ chay * mua khúc vỏ về ăn trầu",
  },
  {
    word: "vỏ",
    part_of_speech: "danh từ",
    meaning: "(Nam) lốp: thay vỏ xe",
    example: "thay vỏ xe",
  },
  {
    word: "vò",
    part_of_speech: "danh từ",
    meaning: "hũ lớn: vò rượu",
    example: "vò rượu",
  },
  {
    word: "vò",
    part_of_speech: "động từ",
    meaning:
      'chà đi xát lại giữa hai lòng bàn tay hay bàn chân, làm cho nhàu nát, rối bời hoặc làm cho sạch: vò quần áo * "Nỗi lòng đòi đoạn xa gần, Chẳng vò mà rối, chẳng dần mà đau!" (TKiều)',
    example:
      'vò quần áo * "Nỗi lòng đòi đoạn xa gần, Chẳng vò mà rối, chẳng dần mà đau!" (TKiều)',
  },
  {
    word: "vo",
    part_of_speech: "động từ",
    meaning:
      "làm cho vật mềm, dẻo tròn lại bằng cách đặt vào giữa hai lòng bàn tay mà xoa theo vòng tròn: vo thuốc tễ",
    example: "vo thuốc tễ",
  },
  {
    word: "vo",
    part_of_speech: "động từ",
    meaning:
      "làm cho sạch gạo, đỗ, v.v. bằng cách cho vào rá và xát kĩ trong nước: vo gạo thổi cơm * vo đỗ",
    example: "vo gạo thổi cơm * vo đỗ",
  },
  {
    word: "vo",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) xắn (quần, áo) bằng cách cuộn tròn lên: quần vo quá gối",
    example: "quần vo quá gối",
  },
  {
    word: "vo",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) (làm việc gì) một cách đơn giản, trực tiếp, không có những phương tiện vốn thường phải dùng: hát vo * không cần chăng dây, cứ thế cấy vo",
    example: "hát vo * không cần chăng dây, cứ thế cấy vo",
  },
  {
    word: "vó",
    part_of_speech: "danh từ",
    meaning:
      "bàn chân của một số thú có guốc, như trâu, bò, ngựa: vó bò * ngựa cất vó phóng đi",
    example: "vó bò * ngựa cất vó phóng đi",
  },
  {
    word: "vó",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) chân và tay (giơ lên trời khi bị ngã ngửa ra; hàm ý vui đùa): ngã chổng vó lên trời",
    example: "ngã chổng vó lên trời",
  },
  {
    word: "vó",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ dùng bắt cá, tôm gồm có một tấm lưới, bốn góc mắc vào bốn đầu gọng để kéo: kéo vó * gọng vó",
    example: "kéo vó * gọng vó",
  },
  {
    word: "võ",
    part_of_speech: "danh từ",
    meaning:
      "thuật đánh nhau bằng chân tay không hay bằng binh khí (như côn, kiếm, v.v.): có võ * võ dân tộc * đấu võ",
    example: "có võ * võ dân tộc * đấu võ",
  },
  {
    word: "võ",
    part_of_speech: "danh từ",
    meaning: "(cũ) quân sự; phân biệt với văn: quan võ * con nhà võ",
    example: "quan võ * con nhà võ",
  },
  {
    word: "võ",
    part_of_speech: "tính từ",
    meaning:
      'gầy hốc hác: người gầy võ * "Bấy lâu tưởng võ trông gầy, Mười phần xuân độ còn nay nửa phần." (HT)',
    example:
      'người gầy võ * "Bấy lâu tưởng võ trông gầy, Mười phần xuân độ còn nay nửa phần." (HT)',
  },
  {
    word: "vó câu",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) vó ngựa, bước chân ngựa: "Đoạn trường thay! Lúc phân kỳ, Vó câu khấp khểnh, bánh xe gập ghềnh." (TKiều)',
    example:
      'Đoạn trường thay! Lúc phân kỳ, Vó câu khấp khểnh, bánh xe gập ghềnh." (TKiều)',
  },
  {
    word: "võ bị",
    part_of_speech: "danh từ",
    meaning: "(cũ) việc quân sự (nói khái quát): trường võ bị",
    example: "trường võ bị",
  },
  {
    word: "vỏ bào",
    part_of_speech: "danh từ",
    meaning:
      "những mảnh mỏng, nhỏ và xoăn từ gỗ rơi ra khi bào: đun bằng vỏ bào",
    example: "đun bằng vỏ bào",
  },
  {
    word: "võ công",
    part_of_speech: "danh từ",
    meaning: "khả năng về võ thuật: luyện võ công * võ công thâm hậu",
    example: "luyện võ công * võ công thâm hậu",
  },
  {
    word: "vỏ chai",
    part_of_speech: "danh từ",
    meaning: "chai không, bên trong không đựng gì: thu nhặt vỏ chai",
    example: "thu nhặt vỏ chai",
  },
  {
    word: "võ đường",
    part_of_speech: "danh từ",
    meaning: "trường dạy võ thuật: mở võ đường",
    example: "mở võ đường",
  },
  {
    word: "võ biền",
    part_of_speech: "danh từ",
    meaning:
      "(Từ cũ) quan võ (thường dùng với hàm ý kém về học thức): con nhà võ biền * tướng võ biền",
    example: "con nhà võ biền * tướng võ biền",
  },
  {
    word: "võ đài",
    part_of_speech: "danh từ",
    meaning: "đài đấu võ: các đấu thủ bước lên võ đài",
    example: "các đấu thủ bước lên võ đài",
  },
  {
    word: "vỏ lụa",
    part_of_speech: "danh từ",
    meaning:
      "lớp vỏ thứ hai, trong vỏ cứng, thường mỏng và mịn, bọc lấy hạt, quả, củ: lớp vỏ lụa ở lạc",
    example: "lớp vỏ lụa ở lạc",
  },
  {
    word: "võ đoán",
    part_of_speech: "tính từ",
    meaning:
      "chỉ dựa vào ý chủ quan, không có căn cứ nào cả: kết luận một cách võ đoán * một nhận xét võ đoán",
    example: "kết luận một cách võ đoán * một nhận xét võ đoán",
  },
  {
    word: "võ đoán",
    part_of_speech: "tính từ",
    meaning:
      "không có lí do, có tính chất tuỳ tiện: tính chất võ đoán của kí hiệu ngôn ngữ",
    example: "tính chất võ đoán của kí hiệu ngôn ngữ",
  },
  {
    word: "võ lâm",
    part_of_speech: "danh từ",
    meaning:
      "nhóm những người cùng trường phái võ thuật, thường có khu vực hoạt động riêng biệt nơi rừng núi: một cao thủ võ lâm",
    example: "một cao thủ võ lâm",
  },
  {
    word: "võ nghệ",
    part_of_speech: "danh từ",
    meaning:
      "nghề võ, nghệ thuật đánh võ: võ nghệ cao cường * luyện tập võ nghệ",
    example: "võ nghệ cao cường * luyện tập võ nghệ",
  },
  {
    word: "võ sinh",
    part_of_speech: "danh từ",
    meaning: "người học võ: chiêu mộ võ sinh * huấn luyện võ sinh",
    example: "chiêu mộ võ sinh * huấn luyện võ sinh",
  },
  {
    word: "võ sĩ",
    part_of_speech: "danh từ",
    meaning:
      "người giỏi võ nghệ: võ sĩ quyền Anh * hai võ sĩ bắt đầu bước lên võ đài",
    example: "võ sĩ quyền Anh * hai võ sĩ bắt đầu bước lên võ đài",
  },
  {
    word: "võ sĩ đạo",
    part_of_speech: "danh từ",
    meaning:
      "đạo của các võ sĩ Nhật Bản thời trước, luôn coi trọng tinh thần thượng võ, tuyệt đối trung thành với vua chúa, sẵn sàng hi sinh cả tính mạng của mình: tinh thần võ sĩ đạo",
    example: "tinh thần võ sĩ đạo",
  },
  {
    word: "võ thuật",
    part_of_speech: "danh từ",
    meaning: "thuật đánh võ: luyện tập võ thuật * giỏi võ thuật",
    example: "luyện tập võ thuật * giỏi võ thuật",
  },
  {
    word: "võ vàng",
    part_of_speech: "tính từ",
    meaning:
      'xanh xao, hốc hác: "Hai hàng nước mắt châu sa, Hồn mai thất thểu mặt hoa võ vàng!" (CC)',
    example:
      'Hai hàng nước mắt châu sa, Hồn mai thất thểu mặt hoa võ vàng!" (CC)',
  },
  {
    word: "vo viên",
    part_of_speech: "động từ",
    meaning:
      "vo tròn trong lòng bàn tay: vo viên nhúm thuốc lào * vo viên tờ giấy, quẳng vào sọt rác",
    example: "vo viên nhúm thuốc lào * vo viên tờ giấy, quẳng vào sọt rác",
  },
  {
    word: "vò võ",
    part_of_speech: "tính từ",
    meaning:
      'từ gợi tả cảnh sống lẻ loi, đơn độc kéo dài: "Nhớ em vắng vẻ cô phòng, Một mình vò võ đêm đông lạnh lùng." (ca dao)',
    example:
      'Nhớ em vắng vẻ cô phòng, Một mình vò võ đêm đông lạnh lùng." (ca dao)',
  },
  {
    word: "võ vẽ",
    part_of_speech: "tính từ",
    meaning:
      "ở mức mới biết qua một ít, nên chưa thông thạo: võ vẽ dăm ba chữ thánh hiền * biết võ vẽ",
    example: "võ vẽ dăm ba chữ thánh hiền * biết võ vẽ",
  },
  {
    word: "vò xé",
    part_of_speech: "động từ",
    meaning:
      "vò, xé, làm cho rách nát tan tành (nói khái quát); dùng để ví việc làm cho phải đau đớn, day dứt, khổ sở về tinh thần: vò xé tâm can * nỗi đau đớn đang vò xé trong lòng",
    example: "vò xé tâm can * nỗi đau đớn đang vò xé trong lòng",
  },
  {
    word: "vo vo",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng như tiếng một đàn côn trùng có cánh phát ra khi bay: muỗi bay vo vo suốt đêm * tiếng sáo diều vo vo",
    example: "muỗi bay vo vo suốt đêm * tiếng sáo diều vo vo",
  },
  {
    word: "vo vo",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) từ gợi tả vẻ chuyển động một cách rất nhanh và dễ dàng: guồng sợi quay vo vo * máy chạy vo vo",
    example: "guồng sợi quay vo vo * máy chạy vo vo",
  },
  {
    word: "vo ve",
    part_of_speech: "động từ",
    meaning:
      "từ mô phỏng tiếng kêu nho nhỏ kéo dài của một số côn trùng có cánh phát ra khi bay: ong vo ve hút mật * tiếng muỗi bay vo ve",
    example: "ong vo ve hút mật * tiếng muỗi bay vo ve",
  },
  {
    word: "voan",
    part_of_speech: "danh từ",
    meaning:
      "hàng dệt rất mỏng bằng tơ, sợi dọc và sợi ngang xe tương đối săn: áo voan * khăn voan",
    example: "áo voan * khăn voan",
  },
  {
    word: "vóc",
    part_of_speech: "danh từ",
    meaning:
      "thân người, về mặt to nhỏ, cao thấp: vóc người mảnh mai, yếu đuối",
    example: "vóc người mảnh mai, yếu đuối",
  },
  {
    word: "vóc",
    part_of_speech: "danh từ",
    meaning:
      'hàng dệt bằng tơ, bóng mịn, có hoa: "Hỡi cô yếm trắng loà loà, Yếm nhiễu, yếm vóc hay là trúc bâu?" (Cdao)',
    example:
      'Hỡi cô yếm trắng loà loà, Yếm nhiễu, yếm vóc hay là trúc bâu?" (Cdao)',
  },
  {
    word: "vóc dạc",
    part_of_speech: "danh từ",
    meaning: "vóc người (nói khái quát): vóc dạc to lớn",
    example: "vóc dạc to lớn",
  },
  {
    word: "vóc dáng",
    part_of_speech: "danh từ",
    meaning: "như dáng vóc: vóc dáng cân đối",
    example: "vóc dáng cân đối",
  },
  {
    word: "vóc hạc",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, văn chương) hình dáng cao, gầy (ví như chim hạc): vóc hạc héo hon",
    example: "vóc hạc héo hon",
  },
  {
    word: "vọc",
    part_of_speech: "động từ",
    meaning:
      "thò tay, chân vào và bốc, quấy, làm những động tác chỉ để chơi, nghịch: trẻ vọc đất * vắng chúa nhà gà vọc niêu tôm (tng)",
    example: "trẻ vọc đất * vắng chúa nhà gà vọc niêu tôm (tng)",
  },
  {
    word: "vọc vạch",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) như võ vẽ: biết vọc vạch dăm ba chữ Hán * vọc vạch làm thơ",
    example: "biết vọc vạch dăm ba chữ Hán * vọc vạch làm thơ",
  },
  {
    word: "voi",
    part_of_speech: "danh từ",
    meaning:
      "thú lớn sống ở vùng nhiệt đới, mũi dài thành vòi, răng nanh dài thành ngà, tai to, da rất dày, có thể nuôi để tải hàng, kéo gỗ, v.v.: khoẻ như voi * cưỡi voi ra trận",
    example: "khoẻ như voi * cưỡi voi ra trận",
  },
  {
    word: "vòi",
    part_of_speech: "danh từ",
    meaning:
      "phần mũi rất dài của con voi, có thể cuộn tròn lại để lấy và giữ các vật: vòi voi",
    example: "vòi voi",
  },
  {
    word: "vòi",
    part_of_speech: "danh từ",
    meaning:
      "phần miệng của một số côn trùng, dùng để hút thức ăn: vòi bướm * con muỗi cong vòi lên đốt",
    example: "vòi bướm * con muỗi cong vòi lên đốt",
  },
  {
    word: "vòi",
    part_of_speech: "danh từ",
    meaning: "bộ phận của nhuỵ hoa, thường hình ống dài, tiếp trên bầu.",
    example: "vòi ấm * vòi bơm * vòi nước",
  },
  {
    word: "vòi",
    part_of_speech: "động từ",
    meaning:
      "ép đòi bằng được người khác phải cho cái mình muốn, làm khó chịu: trẻ vòi quà * vòi tiền mẹ",
    example: "trẻ vòi quà * vòi tiền mẹ",
  },
  {
    word: "vòi hoa sen",
    part_of_speech: "danh từ",
    meaning:
      "vòi nước có hình như gương sen, khi mở nước phun ra thành chùm tia nhỏ: phòng tắm có vòi hoa sen",
    example: "phòng tắm có vòi hoa sen",
  },
  {
    word: "vòi nước",
    part_of_speech: "danh từ",
    meaning: "vòi lắp ở ống nước hay bể nước, có van khoá, mở: mở vòi nước",
    example: "mở vòi nước",
  },
  {
    word: "vòi rồng",
    part_of_speech: "danh từ",
    meaning:
      "hiện tượng gió xoáy với tốc độ rất lớn, có thể cuốn theo nhiều vật trên đường đi của nó.",
    example: "dùng vòi rồng để chữa cháy",
  },
  {
    word: "vòi vĩnh",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) vòi (nói khái quát): vòi vĩnh tiền bạc * tính hay vòi vĩnh",
    example: "vòi vĩnh tiền bạc * tính hay vòi vĩnh",
  },
  {
    word: "voi giày",
    part_of_speech: "",
    meaning:
      "voi dùng vòi quấn người, đưa lên cao rồi quật xuống, dùng chân đạp cho đến chết (một hình phạt nặng thời xưa); thường dùng làm tiếng rủa cay độc người phụ nữ lăng loàn, mất nết: đồ voi giày!",
    example: "đồ voi giày!",
  },
  {
    word: "vòi vọi",
    part_of_speech: "tính từ",
    meaning:
      "ở quá tầm nhìn của mắt, như không thấy đâu là tận cùng: đường xa vòi vọi * vách núi cao vòi vọi",
    example: "đường xa vòi vọi * vách núi cao vòi vọi",
  },
  {
    word: "voice mail",
    part_of_speech: "danh từ",
    meaning:
      "lời nhắn trực tiếp qua hệ thống điện thoại, thư điện tử mà người khác có thể nghe lại sau đó: đăng kí dịch vụ thư thoại * hộp thư thoại",
    example: "đăng kí dịch vụ thư thoại * hộp thư thoại",
  },
  {
    word: "von",
    part_of_speech: "danh từ",
    meaning:
      "bệnh nấm hại lúa, làm cho cây lúa phát triển quá cao, có màu xanh nhạt, không đẻ nhánh và không có bông: lúa von",
    example: "lúa von",
  },
  {
    word: "vòm",
    part_of_speech: "danh từ",
    meaning:
      "vật có hình cong, khum và úp xuống như hình mu rùa: vòm cây * nước từ trên vòm hang nhỏ xuống",
    example: "vòm cây * nước từ trên vòm hang nhỏ xuống",
  },
  {
    word: "vòm",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận hình cong xây nối giữa hai tường, cột hoặc móng: vòm nhà thờ * vòm cổng",
    example: "vòm nhà thờ * vòm cổng",
  },
  {
    word: "vòm trời",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) bầu trời (thường dùng để nói về ban đêm): vòm trời đen kịt * những vì sao lấp lánh trên vòm trời",
    example: "vòm trời đen kịt * những vì sao lấp lánh trên vòm trời",
  },
  {
    word: "vòm miệng",
    part_of_speech: "danh từ",
    meaning:
      "thành trên của khoang miệng, ngăn miệng với lỗ mũi, có hình giống như miệng con ếch há ra: phẫu thuật vá hàm ếch * cháu bé bị hở hàm ếch",
    example: "phẫu thuật vá hàm ếch * cháu bé bị hở hàm ếch",
  },
  {
    word: "vòm miệng",
    part_of_speech: "danh từ",
    meaning: "có hình giống miệng con ếch há ra: hầm hàm ếch * giày hàm ếch",
    example: "hầm hàm ếch * giày hàm ếch",
  },
  {
    word: "vòm miệng",
    part_of_speech: "danh từ",
    meaning:
      "phần đào khoét sâu vào vách công sự: công sự hàm ếch * khoét hàm ếch",
    example: "công sự hàm ếch * khoét hàm ếch",
  },
  {
    word: "vón",
    part_of_speech: "động từ",
    meaning:
      "(bột, hạt nhỏ) kết lại thành hòn, thành cục: bột bị vón * gạo vón lại từng cục",
    example: "bột bị vón * gạo vón lại từng cục",
  },
  {
    word: "vỏn vẹn",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như vẻn vẹn: trong túi chỉ còn vỏn vẹn mấy chục bạc",
    example: "trong túi chỉ còn vỏn vẹn mấy chục bạc",
  },
  {
    word: "vòn",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) beo: bụng ỏng đít vòn",
    example: "bụng ỏng đít vòn",
  },
  {
    word: "vòn vọt",
    part_of_speech: "tính từ",
    meaning:
      "rất nhanh và liên tiếp, gây cảm giác không gì cản lại được: giá cả tăng vòn vọt",
    example: "giá cả tăng vòn vọt",
  },
  {
    word: "vong",
    part_of_speech: "danh từ",
    meaning: "vong hồn (nói tắt): cúng vong * chiều như chiều vong (tng)",
    example: "cúng vong * chiều như chiều vong (tng)",
  },
  {
    word: "vong ân",
    part_of_speech: "động từ",
    meaning: "quên ơn: kẻ vong ân * đồ vong ân bội nghĩa!",
    example: "kẻ vong ân * đồ vong ân bội nghĩa!",
  },
  {
    word: "vóng",
    part_of_speech: "tính từ",
    meaning:
      "(cây) có thân, lá vươn cao và dài hơn so với bình thường, không cứng cây: lúa mọc vóng dễ đổ",
    example: "lúa mọc vóng dễ đổ",
  },
  {
    word: "vóng",
    part_of_speech: "tính từ",
    meaning: "cao vượt hẳn lên, nhưng gầy, mảnh: thân hình cao vóng",
    example: "thân hình cao vóng",
  },
  {
    word: "von vót",
    part_of_speech: "tính từ",
    meaning: "nhọn và cao vút lên: cây cao von vót",
    example: "cây cao von vót",
  },
  {
    word: "vỏng",
    part_of_speech: "tính từ",
    meaning: "đầy nước, lõng bõng: cơm chan vỏng",
    example: "cơm chan vỏng",
  },
  {
    word: "vòng",
    part_of_speech: "danh từ",
    meaning:
      "đường cong khép kín: khoanh một vòng * vẽ thêm mấy vòng * quấn vài vòng dây cho chặt",
    example: "khoanh một vòng * vẽ thêm mấy vòng * quấn vài vòng dây cho chặt",
  },
  {
    word: "vòng",
    part_of_speech: "danh từ",
    meaning:
      "vật được tạo ra có hình một đường tròn, thường dùng làm đồ chơi, đồ trang sức, trang trí, v.v.: vòng tay * vòng đeo cổ * chiếc vòng bạc",
    example: "vòng tay * vòng đeo cổ * chiếc vòng bạc",
  },
  {
    word: "vòng",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) vòng tránh thai (nói tắt): đặt vòng * đi tháo vòng",
    example: "đặt vòng * đi tháo vòng",
  },
  {
    word: "vòng",
    part_of_speech: "danh từ",
    meaning:
      "lần chuyển động, di chuyển từ một điểm nào đó để rồi quay trở về chính điểm ấy: dạo một vòng quanh phố",
    example: "dạo một vòng quanh phố",
  },
  {
    word: "vòng",
    part_of_speech: "danh từ",
    meaning:
      "chu vi của một vật được coi như là có hình tròn: vòng ngực * vòng eo lí tưởng",
    example: "vòng ngực * vòng eo lí tưởng",
  },
  {
    word: "vòng",
    part_of_speech: "danh từ",
    meaning:
      "phạm vi, về mặt giới hạn không gian và thời gian không thể vượt qua của hoạt động, sự việc nào đó: làm trong vòng một tháng là xong * chuyện xảy ra vòng tháng bảy năm ngoái",
    example:
      "làm trong vòng một tháng là xong * chuyện xảy ra vòng tháng bảy năm ngoái",
  },
  {
    word: "vòng",
    part_of_speech: "danh từ",
    meaning:
      "lần thi đấu hoặc bỏ phiếu trong một cuộc thi đấu hoặc bầu cử phải qua nhiều lần: vòng sơ khảo * vòng chung kết * được lọt vào vòng hai",
    example: "vòng sơ khảo * vòng chung kết * được lọt vào vòng hai",
  },
  {
    word: "vòng",
    part_of_speech: "động từ",
    meaning:
      "làm cho có hình cong, hình vòng cung, thường để ôm lấy vật gì: vòng tay ôm con vào lòng",
    example: "vòng tay ôm con vào lòng",
  },
  {
    word: "vòng",
    part_of_speech: "động từ",
    meaning:
      "di chuyển không theo đường thẳng mà theo một đường cong, đường vòng cung: cho xe vòng lại * vòng theo sườn đồi",
    example: "cho xe vòng lại * vòng theo sườn đồi",
  },
  {
    word: "vòng",
    part_of_speech: "tính từ",
    meaning:
      "không theo đường thẳng, mà theo đường cong, quanh co, uốn khúc: đi đường vòng * đoạn vòng",
    example: "đi đường vòng * đoạn vòng",
  },
  {
    word: "võng",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng bện bằng sợi hoặc làm bằng vải dai, dày, hai đầu mắc lên cao, ở giữa chùng xuống, để nằm, ngồi, có thể đưa đi đưa lại: mắc võng * đưa võng * tiếng võng kẽo cà kẽo kẹt",
    example: "mắc võng * đưa võng * tiếng võng kẽo cà kẽo kẹt",
  },
  {
    word: "võng",
    part_of_speech: "động từ",
    meaning:
      "khiêng người đi bằng võng: võng thương binh về phía sau * võng người ốm đi bệnh viện",
    example: "võng thương binh về phía sau * võng người ốm đi bệnh viện",
  },
  {
    word: "võng",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái bị cong xuống hoặc chùng xuống ở giữa, tựa như hình cái võng: mái nhà bị võng * dây điện võng xuống ngay trước cửa nhà",
    example: "mái nhà bị võng * dây điện võng xuống ngay trước cửa nhà",
  },
  {
    word: "vọng",
    part_of_speech: "động từ",
    meaning:
      '(văn chương) nhìn, hướng về nơi mà tâm trí đang tưởng nhớ, trông chờ: vọng về cố hương * lầu vọng nguyệt * "Nhân tình ai chả vọng cao, Bởi chưng cái khó nó rào cái khôn." (ca dao)',
    example:
      'vọng về cố hương * lầu vọng nguyệt * "Nhân tình ai chả vọng cao, Bởi chưng cái khó nó rào cái khôn." (ca dao)',
  },
  {
    word: "vọng",
    part_of_speech: "động từ",
    meaning:
      "nộp tiền hay lễ vật theo lệ cho làng để được ngôi thứ thời phong kiến: vọng quan viên",
    example: "vọng quan viên",
  },
  {
    word: "vọng",
    part_of_speech: "động từ",
    meaning: "(âm thanh) từ xa đưa lại: tiếng hát từ xa vọng lại",
    example: "tiếng hát từ xa vọng lại",
  },
  {
    word: "vong bản",
    part_of_speech: "động từ",
    meaning:
      "quên gốc rễ của mình, không nghĩ gì đến tổ tiên, nòi giống: loại người vong bản",
    example: "loại người vong bản",
  },
  {
    word: "vòng cung",
    part_of_speech: "danh từ",
    meaning: "vòng cong như một phần của đường tròn: đường vòng cung",
    example: "đường vòng cung",
  },
  {
    word: "vòng đai",
    part_of_speech: "danh từ",
    meaning: "(ng4): vòng đai khí hậu",
    example: "vòng đai khí hậu",
  },
  {
    word: "vòng đai",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như vành đai: vòng đai ấp chiến lược",
    example: "vòng đai ấp chiến lược",
  },
  {
    word: "vọng cổ",
    part_of_speech: "danh từ",
    meaning:
      "điệu hát cải lương, giọng buồn và kéo dài, nghe như tiếng thở than, ai oán: ca một bài vọng cổ",
    example: "ca một bài vọng cổ",
  },
  {
    word: "vòng loại",
    part_of_speech: "danh từ",
    meaning:
      "vòng thi đấu đầu tiên để chọn ra người, đội đủ điều kiện để vào thi đấu tiếp vòng sau: đá vòng loại * vòng loại World Cup",
    example: "đá vòng loại * vòng loại World Cup",
  },
  {
    word: "võng mạc",
    part_of_speech: "danh từ",
    meaning:
      "lớp màng ở phía sau nhãn cầu, nơi hiện ra ảnh của vật: viêm võng mạc",
    example: "viêm võng mạc",
  },
  {
    word: "vong linh",
    part_of_speech: "danh từ",
    meaning:
      "linh hồn người đã chết: nghiêng mình trước vong linh người đã khuất",
    example: "nghiêng mình trước vong linh người đã khuất",
  },
  {
    word: "vong hồn",
    part_of_speech: "danh từ",
    meaning: "như vong linh: khấu đầu trước vong hồn tổ tiên",
    example: "khấu đầu trước vong hồn tổ tiên",
  },
  {
    word: "võng lọng",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) võng và lọng (nói khái quát); chỉ phương tiện và vật trang hoàng kèm theo khi đi đường của quan lại thời xưa: "Người hiền thì phải gian nan, Kẻ gian võng lọng nghênh ngang đi về." (ca dao)',
    example:
      'Người hiền thì phải gian nan, Kẻ gian võng lọng nghênh ngang đi về." (ca dao)',
  },
  {
    word: "vòng kiềng",
    part_of_speech: "danh từ",
    meaning: "(kiểu đi) bàn chân bước vòng vào trong: chân đi vòng kiềng",
    example: "chân đi vòng kiềng",
  },
  {
    word: "vong mạng",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như bạt mạng: bọn tàn quân chạy vong mạng vào rừng",
    example: "bọn tàn quân chạy vong mạng vào rừng",
  },
  {
    word: "vong nhân",
    part_of_speech: "danh từ",
    meaning: "(cũ, hiếm) người đã chết (nói khái quát): ngày xá tội vong nhân",
    example: "ngày xá tội vong nhân",
  },
  {
    word: "vòng tròn",
    part_of_speech: "danh từ",
    meaning:
      "vòng hình tròn: nắm tay nhau đứng thành vòng tròn * vẽ một vòng tròn * đấu vòng tròn",
    example:
      "nắm tay nhau đứng thành vòng tròn * vẽ một vòng tròn * đấu vòng tròn",
  },
  {
    word: "vòng quanh",
    part_of_speech: "động từ",
    meaning:
      "di chuyển thành một vòng tròn xung quanh: đi dạo vòng quanh hồ * nước mắt vòng quanh",
    example: "đi dạo vòng quanh hồ * nước mắt vòng quanh",
  },
  {
    word: "vòng quanh",
    part_of_speech: "động từ",
    meaning:
      "nói vòng vèo, không đi thẳng, đi trực tiếp vào vấn đề: nói vòng quanh",
    example: "nói vòng quanh",
  },
  {
    word: "vọng ngoại",
    part_of_speech: "động từ",
    meaning:
      "có tư tưởng, tâm lí hướng theo những cái của nước ngoài: tư tưởng vọng ngoại * xu hướng vọng ngoại của thanh niên",
    example: "tư tưởng vọng ngoại * xu hướng vọng ngoại của thanh niên",
  },
  {
    word: "vòng tay",
    part_of_speech: "danh từ",
    meaning:
      "vòng của hai cánh tay ôm; thường dùng với phong cách văn chương để chỉ sự yêu thương, che chở của người thân: lớn lên trong vòng tay của cha mẹ",
    example: "lớn lên trong vòng tay của cha mẹ",
  },
  {
    word: "vọng tộc",
    part_of_speech: "danh từ",
    meaning: "(cũ) dòng họ có danh tiếng trong xã hội cũ: con nhà vọng tộc",
    example: "con nhà vọng tộc",
  },
  {
    word: "vòng vây",
    part_of_speech: "danh từ",
    meaning:
      "vòng khép kín bao lấy đối phương, không cho thoát ra ngoài: siết chặt vòng vây * thoát khỏi vòng vây",
    example: "siết chặt vòng vây * thoát khỏi vòng vây",
  },
  {
    word: "vòng vòng",
    part_of_speech: "",
    meaning: "như lòng vòng: đạp xe vòng vòng quanh hồ",
    example: "đạp xe vòng vòng quanh hồ",
  },
  {
    word: "vòng vo",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (nói) vòng quanh, không đi thẳng vào vấn đề: nói vòng vo * lối giải thích vòng vo",
    example: "nói vòng vo * lối giải thích vòng vo",
  },
  {
    word: "vòng vo",
    part_of_speech: "tính từ",
    meaning:
      "(di chuyển) vòng qua vòng lại theo nhiều hướng khác nhau: xe chạy vòng vo * con đường rất vòng vo, hiểm trở",
    example: "xe chạy vòng vo * con đường rất vòng vo, hiểm trở",
  },
  {
    word: "vòng vèo",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có nhiều chỗ, nhiều đoạn vòng qua vòng lại theo nhiều hướng khác nhau: chiếc xe chạy vòng vèo qua các phố * trình bày vòng vèo",
    example: "chiếc xe chạy vòng vèo qua các phố * trình bày vòng vèo",
  },
  {
    word: "vót",
    part_of_speech: "động từ",
    meaning:
      "làm cho nhẵn, tròn hoặc nhọn bằng cách đưa nhẹ lưỡi dao nhiều lần trên bề mặt thân tre, gỗ, v.v.: vót đũa * vót chông * vót tăm",
    example: "vót đũa * vót chông * vót tăm",
  },
  {
    word: "vót",
    part_of_speech: "tính từ",
    meaning:
      "nhọn và cao vượt hẳn lên: cây cao vót * giọng tự nhiên cao vót lên",
    example: "cây cao vót * giọng tự nhiên cao vót lên",
  },
  {
    word: "vót",
    part_of_speech: "động từ",
    meaning:
      "(chất lỏng) phun ra thành dòng mạnh và đột ngột: trúng đạn, máu vọt ra * nước vọt lên từ dưới đất",
    example: "trúng đạn, máu vọt ra * nước vọt lên từ dưới đất",
  },
  {
    word: "vót",
    part_of_speech: "động từ",
    meaning:
      "thay đổi tốc độ đột ngột và rất nhanh: chạy vọt lên trước * tăng ga cho xe vọt lên",
    example: "chạy vọt lên trước * tăng ga cho xe vọt lên",
  },
  {
    word: "vót",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) buột (miệng): vọt miệng nói ra",
    example: "vọt miệng nói ra",
  },
  {
    word: "vót",
    part_of_speech: "tính từ",
    meaning:
      "tăng lên đột ngột và rất nhanh: giá cả tăng vọt * mới có một năm mà con bé đã cao vọt",
    example: "giá cả tăng vọt * mới có một năm mà con bé đã cao vọt",
  },
  {
    word: "vồ",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ gồm một đoạn gỗ chắc và nặng có tra cán, dùng để nện, đập: vồ đập đất",
    example: "vồ đập đất",
  },
  {
    word: "vồ",
    part_of_speech: "động từ",
    meaning:
      "lao mình tới rất nhanh để tóm lấy, bắt lấy một cách bất ngờ: mèo vồ chuột * hổ vồ mồi",
    example: "mèo vồ chuột * hổ vồ mồi",
  },
  {
    word: "vồ",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) lao người tới ôm chặt lấy: đứa trẻ vồ lấy mẹ",
    example: "đứa trẻ vồ lấy mẹ",
  },
  {
    word: "vồ",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) nắm ngay, giành ngay lấy một cách vội vã: đi học về là vồ ngay quyển truyện * vồ lấy cơ hội",
    example: "đi học về là vồ ngay quyển truyện * vồ lấy cơ hội",
  },
  {
    word: "vô",
    part_of_speech: "động từ",
    meaning: "(Nam) vào: Vô nhà lấy cho mẹ cái giỏ!",
    example: "Vô nhà lấy cho mẹ cái giỏ!",
  },
  {
    word: "vô",
    part_of_speech: "tiền tố",
    meaning:
      'cấu tạo tính từ, phụ từ, có nghĩa "không", "không có", như: vô dụng, vô địch, vô đạo đức, vô học, vô thuỷ vô chung, v.v. TRÁI hữu',
    example: "vô dụng, vô địch, vô đạo đức, vô học, vô thuỷ vô chung, v.v.",
  },
  {
    word: "vố",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ giống như cái vồ hoặc cái búa nhỏ, quản tượng dùng để dạy và điều khiển voi.",
    example: "choảng cho một vố * bị lừa một vố đau điếng",
  },
  {
    word: "vô biên",
    part_of_speech: "tính từ",
    meaning:
      "(văn chương) rộng lớn đến mức như không có giới hạn: sức mạnh vô biên * hạnh phúc vô biên",
    example: "sức mạnh vô biên * hạnh phúc vô biên",
  },
  {
    word: "vỗ",
    part_of_speech: "động từ",
    meaning:
      "đập bàn tay lên bề mặt: vỗ vào vai bạn * vỗ đùi cười ha hả * vỗ tay lên mặt trống",
    example: "vỗ vào vai bạn * vỗ đùi cười ha hả * vỗ tay lên mặt trống",
  },
  {
    word: "vỗ",
    part_of_speech: "động từ",
    meaning:
      "đập liên tiếp vào một vật khác và làm phát ra tiếng: chim vỗ cánh * sóng vỗ bờ",
    example: "chim vỗ cánh * sóng vỗ bờ",
  },
  {
    word: "vỗ",
    part_of_speech: "động từ",
    meaning:
      "làm cho ướt, dính một lớp mỏng bằng động tác vỗ nhẹ nhiều lần lên bề mặt: vỗ nước lên mặt cho tỉnh ngủ",
    example: "vỗ nước lên mặt cho tỉnh ngủ",
  },
  {
    word: "vỗ",
    part_of_speech: "động từ",
    meaning:
      "(làm việc gì) tác động thẳng vào đối phương một cách mạnh mẽ, quyết liệt: đánh vỗ vào lưng địch * nói vỗ ngay vào mặt",
    example: "đánh vỗ vào lưng địch * nói vỗ ngay vào mặt",
  },
  {
    word: "vỗ",
    part_of_speech: "động từ",
    meaning:
      "phủi tay hết sức trắng trợn, coi như không có điều ràng buộc nào đó đối với mình nữa: vỗ nợ * vỗ ơn * vỗ lời cam kết",
    example: "vỗ nợ * vỗ ơn * vỗ lời cam kết",
  },
  {
    word: "vỗ",
    part_of_speech: "động từ",
    meaning:
      "cho ăn dồn nhiều thức ăn hoặc chăm bón đặc biệt trong thời gian ngắn để cho chóng béo, chóng phát triển: vỗ cho lợn chóng lớn * bón vỗ cho lúa",
    example: "vỗ cho lợn chóng lớn * bón vỗ cho lúa",
  },
  {
    word: "vỗ béo",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) vỗ cho chóng béo: vỗ béo cho đàn lợn",
    example: "vỗ béo cho đàn lợn",
  },
  {
    word: "vô bổ",
    part_of_speech: "tính từ",
    meaning: "không có, không mang lại ích lợi gì: làm những việc vô bổ",
    example: "làm những việc vô bổ",
  },
  {
    word: "vô bờ",
    part_of_speech: "tính từ",
    meaning:
      "(tình cảm, lòng mong muốn, v.v.) rộng lớn đến mức cảm thấy như không có giới hạn: lòng yêu thương vô bờ * hạnh phúc vô bờ",
    example: "lòng yêu thương vô bờ * hạnh phúc vô bờ",
  },
  {
    word: "vô chừng",
    part_of_speech: "tính từ",
    meaning:
      '(khẩu ngữ) không có mức độ, giới hạn: khổ vô chừng * "Từ ngày gặp gỡ giữa đường, Nghe lời bạn nói nhớ thương vô chừng." (ca dao)',
    example:
      'khổ vô chừng * "Từ ngày gặp gỡ giữa đường, Nghe lời bạn nói nhớ thương vô chừng." (ca dao)',
  },
  {
    word: "vô cớ",
    part_of_speech: "tính từ",
    meaning:
      "(sự việc, hành động xảy ra) không có cớ, không có lí do: đánh người vô cớ * một nỗi buồn vô cớ",
    example: "đánh người vô cớ * một nỗi buồn vô cớ",
  },
  {
    word: "vô căn cứ",
    part_of_speech: "tính từ",
    meaning:
      "hoàn toàn không có căn cứ, không có cơ sở gì: lời buộc tội vô căn cứ * nỗi bực tức vô căn cứ",
    example: "lời buộc tội vô căn cứ * nỗi bực tức vô căn cứ",
  },
  {
    word: "vô cảm",
    part_of_speech: "tính từ",
    meaning:
      "không có cảm xúc, không có tình cảm (trước những tình huống đáng ra phải có): cái nhìn vô cảm * vô cảm trước nỗi đau của người khác",
    example: "cái nhìn vô cảm * vô cảm trước nỗi đau của người khác",
  },
  {
    word: "vô chính phủ",
    part_of_speech: "tính từ",
    meaning:
      "không có tổ chức, không có kỉ luật: tình trạng vô chính phủ * tự do vô chính phủ",
    example: "tình trạng vô chính phủ * tự do vô chính phủ",
  },
  {
    word: "vô chính phủ",
    part_of_speech: "tính từ",
    meaning: "theo chủ nghĩa vô chính phủ: phần tử vô chính phủ",
    example: "phần tử vô chính phủ",
  },
  {
    word: "vô chủ",
    part_of_speech: "tính từ",
    meaning:
      'không thuộc quyền sở hữu của ai cả, không được ai trông coi, chăm sóc: ngôi nhà vô chủ * "Trải bao thỏ lặn, ác tà, ấy mồ vô chủ, ai mà viếng thăm!" (TKiều)',
    example:
      'ngôi nhà vô chủ * "Trải bao thỏ lặn, ác tà, ấy mồ vô chủ, ai mà viếng thăm!" (TKiều)',
  },
  {
    word: "vô can",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) không có dính dáng gì, không có quan hệ gì: việc đó vô can đến tôi",
    example: "việc đó vô can đến tôi",
  },
  {
    word: "vô can",
    part_of_speech: "tính từ",
    meaning:
      "được coi như không dính líu đến vụ án đang xét: vô can nên được tha bổng",
    example: "vô can nên được tha bổng",
  },
  {
    word: "vô công rồi nghề",
    part_of_speech: "",
    meaning:
      "không có việc làm thường xuyên hoặc không phải bận bịu, lo lắng gì (nên thường làm những việc không đâu vào đâu; hàm ý chê): kẻ vô công rồi nghề, cả ngày chỉ la cà quán xá",
    example: "kẻ vô công rồi nghề, cả ngày chỉ la cà quán xá",
  },
  {
    word: "vô cùng",
    part_of_speech: "tính từ",
    meaning: "không có chỗ tận cùng, không có giới hạn: cõi vô cùng",
    example: "cõi vô cùng",
  },
  {
    word: "vô cùng",
    part_of_speech: "phụ từ",
    meaning:
      "đến mức độ cao nhất, không thể diễn tả nổi: vô cùng đau xót * ghét vô cùng * đẹp vô cùng",
    example: "vô cùng đau xót * ghét vô cùng * đẹp vô cùng",
  },
  {
    word: "vô cơ",
    part_of_speech: "tính từ",
    meaning:
      "(Ít dùng) không thuộc giới sinh vật, không phải là vật có sự sống: giới vô cơ",
    example: "giới vô cơ",
  },
  {
    word: "vô cực",
    part_of_speech: "tính từ",
    meaning:
      "có giá trị tuyệt đối lớn hơn bất kì số nào cho trước: âm vô cực * dương vô cực",
    example: "âm vô cực * dương vô cực",
  },
  {
    word: "vô cùng tận",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) không bao giờ hết, không có chỗ tận cùng: khoảng không gian vô cùng tận",
    example: "khoảng không gian vô cùng tận",
  },
  {
    word: "vô dụng",
    part_of_speech: "tính từ",
    meaning: "không dùng được vào việc gì cả: kẻ vô dụng * đồ vô dụng",
    example: "kẻ vô dụng * đồ vô dụng",
  },
  {
    word: "vô định",
    part_of_speech: "tính từ",
    meaning:
      "không có định hướng, không được xác định rõ: mây bay vô định * cuộc đời phiêu lưu vô định",
    example: "mây bay vô định * cuộc đời phiêu lưu vô định",
  },
  {
    word: "vô định",
    part_of_speech: "tính từ",
    meaning: "có vô số nghiệm: phương trình vô định",
    example: "phương trình vô định",
  },
  {
    word: "vô duyên",
    part_of_speech: "tính từ",
    meaning:
      "không có duyên, thiếu những gì tế nhị, đáng yêu, làm cho không có gì hấp dẫn, vừa lòng: câu nói vô duyên * vô duyên chưa nói đã cười",
    example: "câu nói vô duyên * vô duyên chưa nói đã cười",
  },
  {
    word: "vô duyên",
    part_of_speech: "tính từ",
    meaning:
      '(Từ cũ) không có duyên trời định để có thể có được mối quan hệ tình cảm gắn bó với nhau: "Khóc than khôn xiết sự tình, Khéo vô duyên bấy là mình với ta!" (TKiều)',
    example:
      'Khóc than khôn xiết sự tình, Khéo vô duyên bấy là mình với ta!" (TKiều)',
  },
  {
    word: "vô duyên",
    part_of_speech: "tính từ",
    meaning:
      'không có duyên số tốt, bị số phận dành cho toàn những chuyện không may: "Trông chồng mà chẳng thấy chồng, Đã đành một nỗi má hồng vô duyên." (LVT)',
    example:
      'Trông chồng mà chẳng thấy chồng, Đã đành một nỗi má hồng vô duyên." (LVT)',
  },
  {
    word: "vô danh tiểu tốt",
    part_of_speech: "",
    meaning:
      "người tầm thường, hèn mọn, không ai tính đến (ví như hạng lính quèn không tên tuổi): kẻ vô danh tiểu tốt",
    example: "kẻ vô danh tiểu tốt",
  },
  {
    word: "vô danh",
    part_of_speech: "tính từ",
    meaning:
      "không mấy ai biết đến tên tuổi, không để lại tên tuổi: mộ liệt sĩ vô danh * một cây bút vô danh",
    example: "mộ liệt sĩ vô danh * một cây bút vô danh",
  },
  {
    word: "vô đạo",
    part_of_speech: "tính từ",
    meaning:
      "tàn bạo, ngang ngược, bất chấp đạo lí: làm điều vô đạo * hôn quân vô đạo",
    example: "làm điều vô đạo * hôn quân vô đạo",
  },
  {
    word: "vô điều kiện",
    part_of_speech: "tính từ",
    meaning:
      "không kèm theo bất kì một điều kiện nào: đầu hàng vô điều kiện * chấp nhận vô điều kiện",
    example: "đầu hàng vô điều kiện * chấp nhận vô điều kiện",
  },
  {
    word: "vô địch",
    part_of_speech: "tính từ",
    meaning: "không đối thủ nào địch nổi: sức mạnh vô địch",
    example: "sức mạnh vô địch",
  },
  {
    word: "vô địch",
    part_of_speech: "danh từ",
    meaning:
      "người hoặc đội đã thắng tất cả các đối thủ khác trong một cuộc thi đấu thể thao đặc biệt: nhà vô địch * hai lần đoạt chức vô địch * đương kim vô địch",
    example: "nhà vô địch * hai lần đoạt chức vô địch * đương kim vô địch",
  },
  {
    word: "vồ ếch",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) ví trường hợp đang đi thình lình bị ngã, tay chống xuống đất: đường trơn nên vồ ếch liên tục",
    example: "đường trơn nên vồ ếch liên tục",
  },
  {
    word: "vô độ",
    part_of_speech: "tính từ",
    meaning: "không có chừng mực, mức độ: lòng tham vô độ * hoang dâm vô độ",
    example: "lòng tham vô độ * hoang dâm vô độ",
  },
  {
    word: "vô giáo dục",
    part_of_speech: "tính từ",
    meaning:
      "không được giáo dục, không được dạy bảo: nó là đứa vô giáo dục * đồ vô giáo dục! (tiếng mắng chửi)",
    example: "nó là đứa vô giáo dục * đồ vô giáo dục! (tiếng mắng chửi)",
  },
  {
    word: "vô giá",
    part_of_speech: "tính từ",
    meaning:
      "rất quý, rất có giá trị, đến mức không thể định được một giá nào cho xứng đáng: tài sản vô giá * một tác phẩm hội hoạ vô giá",
    example: "tài sản vô giá * một tác phẩm hội hoạ vô giá",
  },
  {
    word: "vô gia cư",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) không có nhà ở, không có gia đình: lang thang như một kẻ vô gia cư",
    example: "lang thang như một kẻ vô gia cư",
  },
  {
    word: "vô hạn",
    part_of_speech: "tính từ",
    meaning: "không có giới hạn: tri thức là vô hạn * lòng buồn vô hạn",
    example: "tri thức là vô hạn * lòng buồn vô hạn",
  },
  {
    word: "vô hại",
    part_of_speech: "tính từ",
    meaning: "không gây tác hại gì: nói những câu vô hại * hành động vô hại",
    example: "nói những câu vô hại * hành động vô hại",
  },
  {
    word: "vô hiệu",
    part_of_speech: "tính từ",
    meaning:
      "không có hiệu lực, không mang lại kết quả: mọi lời can ngăn đều vô hiệu",
    example: "mọi lời can ngăn đều vô hiệu",
  },
  {
    word: "vô giá trị",
    part_of_speech: "tính từ",
    meaning:
      "không có giá trị: một cuốn sách vô giá trị * toàn những đồ lặt vặt, vô giá trị",
    example: "một cuốn sách vô giá trị * toàn những đồ lặt vặt, vô giá trị",
  },
  {
    word: "vô hình",
    part_of_speech: "tính từ",
    meaning:
      "không nhìn thấy được hình thể (nhưng lại thấy có tác động): cạm bẫy vô hình * bàn tay vô hình",
    example: "cạm bẫy vô hình * bàn tay vô hình",
  },
  {
    word: "vô hình trung",
    part_of_speech: "",
    meaning:
      "tuy không chủ ý, chủ tâm nhưng tự nhiên lại là như thế (tạo ra, gây ra việc nói đến): không nói gì, vô hình trung là tỏ ý tán thành",
    example: "không nói gì, vô hình trung là tỏ ý tán thành",
  },
  {
    word: "vô hiệu hoá",
    part_of_speech: "động từ",
    meaning:
      "làm cho trở nên vô hiệu: vô hiệu hoá thiết bị gây nhiễu * vô hiệu hoá hai mũi tấn công của địch",
    example:
      "vô hiệu hoá thiết bị gây nhiễu * vô hiệu hoá hai mũi tấn công của địch",
  },
  {
    word: "vô học",
    part_of_speech: "tính từ",
    meaning:
      "không có học thức, không được giáo dục (hàm ý coi thường): đồ vô học! (tiếng mắng chửi) * con nhà vô học",
    example: "đồ vô học! (tiếng mắng chửi) * con nhà vô học",
  },
  {
    word: "vô hồi kì trận",
    part_of_speech: "",
    meaning: "(khẩu ngữ) như liên hồi kì trận: súng bắn vô hồi kì trận",
    example: "súng bắn vô hồi kì trận",
  },
  {
    word: "vô kể",
    part_of_speech: "phụ từ",
    meaning:
      "đến mức không thể kể hết được: thiệt hại vô kể * mừng vô kể * người đông vô kể",
    example: "thiệt hại vô kể * mừng vô kể * người đông vô kể",
  },
  {
    word: "vô ích",
    part_of_speech: "tính từ",
    meaning:
      "không có ích lợi gì, không được việc gì: tốn công vô ích * chuyện đã rồi, có cố gắng cũng vô ích",
    example: "tốn công vô ích * chuyện đã rồi, có cố gắng cũng vô ích",
  },
  {
    word: "vô hồn",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái đờ đẫn như người mất hồn, không biểu lộ chút suy nghĩ, cảm xúc nào (thường do bị tổn thương nặng nề về tinh thần): cặp mắt vô hồn * cái xác vô hồn",
    example: "cặp mắt vô hồn * cái xác vô hồn",
  },
  {
    word: "vô kỉ luật",
    part_of_speech: "tính từ",
    meaning:
      "không chịu tuân theo kỉ luật: hành động vô kỉ luật * có thái độ vô kỉ luật",
    example: "hành động vô kỉ luật * có thái độ vô kỉ luật",
  },
  {
    word: "vô khối",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) rất nhiều, nhưng không biết chính xác là bao nhiêu: còn vô khối việc phải làm * người ta đồn ra vô khối chuyện lạ",
    example: "còn vô khối việc phải làm * người ta đồn ra vô khối chuyện lạ",
  },
  {
    word: "vô lại",
    part_of_speech: "danh từ",
    meaning:
      "kẻ du đãng, bất lương, mất hết nhân cách: kẻ vô lại * đồ vô lại! (tiếng chửi rủa)",
    example: "kẻ vô lại * đồ vô lại! (tiếng chửi rủa)",
  },
  {
    word: "vô lăng",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) tay lái ô tô, tàu thuỷ, v.v., có dạng vành tròn: cầm chắc vô lăng",
    example: "cầm chắc vô lăng",
  },
  {
    word: "vô kỷ luật",
    part_of_speech: "tính từ",
    meaning:
      "không chịu tuân theo kỉ luật: hành động vô kỉ luật * có thái độ vô kỉ luật",
    example: "hành động vô kỉ luật * có thái độ vô kỉ luật",
  },
  {
    word: "vô lê",
    part_of_speech: "động từ",
    meaning:
      "sút bóng khi bóng còn đang ở trên không (chưa chạm đất): ghi bàn bằng cú tung người đá vô lê",
    example: "ghi bàn bằng cú tung người đá vô lê",
  },
  {
    word: "vô lo",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) không biết lo nghĩ hoặc không có gì phải lo nghĩ: một người vô lo",
    example: "một người vô lo",
  },
  {
    word: "vô lễ",
    part_of_speech: "",
    meaning:
      "không có lễ độ đối với người trên: ăn nói vô lễ * không được vô lễ với thầy giáo",
    example: "ăn nói vô lễ * không được vô lễ với thầy giáo",
  },
  {
    word: "vô liêm sỉ",
    part_of_speech: "tính từ",
    meaning:
      "mất nhân cách tới mức trơ trẽn, không còn biết hổ thẹn là gì: hạng người vô liêm sỉ",
    example: "hạng người vô liêm sỉ",
  },
  {
    word: "vô loài",
    part_of_speech: "tính từ",
    meaning: "hoàn toàn mất hết nhân phẩm: quân vô loài!",
    example: "quân vô loài!",
  },
  {
    word: "vô lí",
    part_of_speech: "tính từ",
    meaning:
      "không có lí, không hợp lẽ phải: chuyện rất vô lí * tức giận một cách vô lí",
    example: "chuyện rất vô lí * tức giận một cách vô lí",
  },
  {
    word: "vô lương",
    part_of_speech: "tính từ",
    meaning:
      'độc ác, không có lương tâm: kẻ vô lương * "Lời ngay, đông mặt trong ngoài, Kẻ chê bất nghĩa, người cười vô lương." (TKiều)',
    example:
      'kẻ vô lương * "Lời ngay, đông mặt trong ngoài, Kẻ chê bất nghĩa, người cười vô lương." (TKiều)',
  },
  {
    word: "vô luận",
    part_of_speech: "phụ từ",
    meaning:
      "bất cứ, không loại trừ trường hợp nào cả: đã phạm luật thì vô luận người nào cũng phải phạt",
    example: "đã phạm luật thì vô luận người nào cũng phải phạt",
  },
  {
    word: "vô lối",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) không theo một cái lẽ nào cả, trái với lẽ phải, lẽ thường: ghen tuông vô lối * đánh người vô lối",
    example: "ghen tuông vô lối * đánh người vô lối",
  },
  {
    word: "vô luân",
    part_of_speech: "tính từ",
    meaning:
      "không có đạo đức, bất chấp luân thường, đạo lí: hạng người vô luân",
    example: "hạng người vô luân",
  },
  {
    word: "vô nghĩa",
    part_of_speech: "tính từ",
    meaning:
      "không có ý nghĩa, không có giá trị: nói những điều vô nghĩa * đã cố gắng nhưng tất cả đều vô nghĩa",
    example: "nói những điều vô nghĩa * đã cố gắng nhưng tất cả đều vô nghĩa",
  },
  {
    word: "vô nghĩa",
    part_of_speech: "tính từ",
    meaning:
      '(Ít dùng) không có tình nghĩa: "Biết mà lòng chẳng oán hờn, Mặc ai vô nghĩa, bất nhân cũng đành." (TS)',
    example:
      'Biết mà lòng chẳng oán hờn, Mặc ai vô nghĩa, bất nhân cũng đành." (TS)',
  },
  {
    word: "vô ngần",
    part_of_speech: "phụ từ",
    meaning:
      "(văn chương) đến mức không có gì sánh bằng, sánh kịp: đẹp vô ngần * tấm lòng ấy thật quý giá vô ngần",
    example: "đẹp vô ngần * tấm lòng ấy thật quý giá vô ngần",
  },
  {
    word: "vỗ ngực",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tự khẳng định mình trước mọi người một cách kiêu ngạo, huênh hoang: vỗ ngực tự xưng",
    example: "vỗ ngực tự xưng",
  },
  {
    word: "vô nghiệm",
    part_of_speech: "tính từ",
    meaning: "không có nghiệm: phương trình vô nghiệm",
    example: "phương trình vô nghiệm",
  },
  {
    word: "vô nguyên tắc",
    part_of_speech: "tính từ",
    meaning:
      "không có hoặc không theo đúng nguyên tắc: sống vô nguyên tắc * lối làm việc vô nguyên tắc",
    example: "sống vô nguyên tắc * lối làm việc vô nguyên tắc",
  },
  {
    word: "vô lý",
    part_of_speech: "tính từ",
    meaning:
      "không có lí, không hợp lẽ phải: chuyện rất vô lí * tức giận một cách vô lí",
    example: "chuyện rất vô lí * tức giận một cách vô lí",
  },
  {
    word: "vô phép",
    part_of_speech: "động từ",
    meaning:
      '(Kiểu cách) xin phép một cách lịch sự (thường dùng trước khi nói hoặc làm điều gì mà bản thân cảm thấy không được lịch sự, lễ phép cho lắm): "Thôi thế chào ông. Cháu vô phép ông đi trước. Cháu vội lắm." (NCao; 8)',
    example:
      'Thôi thế chào ông. Cháu vô phép ông đi trước. Cháu vội lắm." (NCao; 8)',
  },
  {
    word: "vô nhân",
    part_of_speech: "tính từ",
    meaning: "(cũ, hiếm) như bất nhân: kẻ vô nhân",
    example: "kẻ vô nhân",
  },
  {
    word: "vô ơn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) không nghĩ gì đến công ơn của người khác đối với mình: thái độ vô ơn * kẻ vô ơn",
    example: "thái độ vô ơn * kẻ vô ơn",
  },
  {
    word: "vô nhân đạo",
    part_of_speech: "tính từ",
    meaning:
      "tàn ác, dã man, không có chút gì lòng thương yêu, quý trọng con người: hành động vô nhân đạo",
    example: "hành động vô nhân đạo",
  },
  {
    word: "vô phương",
    part_of_speech: "tính từ",
    meaning: "không có phương cách gì giải quyết: vô phương cứu chữa",
    example: "vô phương cứu chữa",
  },
  {
    word: "vô phúc",
    part_of_speech: "tính từ",
    meaning:
      "không có hoặc không được hưởng phúc đức của ông cha để lại (nên thường không tử tế hoặc không được may mắn), theo quan niệm cũ: con nhà vô phúc * ai vô phúc mới vớ phải nó!",
    example: "con nhà vô phúc * ai vô phúc mới vớ phải nó!",
  },
  {
    word: "vô phúc",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) không may xảy ra việc gì đó: phóng nhanh, vô phúc mà va vào người ta thì khốn!",
    example: "phóng nhanh, vô phúc mà va vào người ta thì khốn!",
  },
  {
    word: "vô sỉ",
    part_of_speech: "tính từ",
    meaning: "vô liêm sỉ (nói tắt): kẻ vô sỉ",
    example: "kẻ vô sỉ",
  },
  {
    word: "vô sinh",
    part_of_speech: "tính từ",
    meaning:
      "không có sự sống, không phải là sinh vật: thế giới vô sinh * đất, đá là những vật vô sinh",
    example: "thế giới vô sinh * đất, đá là những vật vô sinh",
  },
  {
    word: "vô sinh",
    part_of_speech: "tính từ",
    meaning: "không có khả năng sinh sản: mắc chứng vô sinh",
    example: "mắc chứng vô sinh",
  },
  {
    word: "vô sản",
    part_of_speech: "danh từ",
    meaning:
      "người thuộc giai cấp công nhân dưới chế độ tư bản (nói khái quát).",
    example: "cố nông là những người vô sản ở nông thôn",
  },
  {
    word: "vô sản",
    part_of_speech: "tính từ",
    meaning:
      "thuộc giai cấp công nhân, có tính chất của giai cấp công nhân: cách mạng vô sản * tinh thần quốc tế vô sản",
    example: "cách mạng vô sản * tinh thần quốc tế vô sản",
  },
  {
    word: "vô song",
    part_of_speech: "tính từ",
    meaning:
      "có một không hai, không ai, không cái gì có thể sánh kịp: sức mạnh vô song * tài nghệ vô song",
    example: "sức mạnh vô song * tài nghệ vô song",
  },
  {
    word: "vô sự",
    part_of_speech: "tính từ",
    meaning:
      "không việc gì, không gặp rủi ro, tai nạn (như đã lo ngại): bình yên vô sự",
    example: "bình yên vô sự",
  },
  {
    word: "vô tài",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như bất tài: kẻ vô tài",
    example: "kẻ vô tài",
  },
  {
    word: "vỗ tay",
    part_of_speech: "động từ",
    meaning:
      "đập hai lòng bàn tay vào nhau cho phát ra thành tiếng (thường liên tiếp, để tỏ ý hoan nghênh, tán thành): vỗ tay đôm đốp * vỗ tay tán thưởng",
    example: "vỗ tay đôm đốp * vỗ tay tán thưởng",
  },
  {
    word: "vô số",
    part_of_speech: "tính từ",
    meaning:
      "nhiều lắm, đến mức không thể đếm hết, kể hết được: nhà giàu, tiền bạc vô số * quyển sách còn vô số lỗi",
    example: "nhà giàu, tiền bạc vô số * quyển sách còn vô số lỗi",
  },
  {
    word: "vô tâm",
    part_of_speech: "tính từ",
    meaning:
      "không hay để ý, cả đến những điều người khác thường chú ý: vô tâm nên nói trước quên sau * người vô tâm",
    example: "vô tâm nên nói trước quên sau * người vô tâm",
  },
  {
    word: "vô thanh",
    part_of_speech: "tính từ",
    meaning:
      "(phụ âm) trong quá trình cấu tạo không có sự tham gia của dây thanh (các dây thanh không rung lên khi phát âm); phân biệt với hữu thanh: p, t, k là những phụ âm vô thanh trong tiếng Việt",
    example: "p, t, k là những phụ âm vô thanh trong tiếng Việt",
  },
  {
    word: "vô tận",
    part_of_speech: "tính từ",
    meaning:
      "không bao giờ hết, không bao giờ cạn: không gian vô tận * nguồn tài nguyên vô tận",
    example: "không gian vô tận * nguồn tài nguyên vô tận",
  },
  {
    word: "vô thời hạn",
    part_of_speech: "tính từ",
    meaning: "không có thời hạn nào cả: hợp đồng có giá trị vô thời hạn",
    example: "hợp đồng có giá trị vô thời hạn",
  },
  {
    word: "vô thưởng vô phạt",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) chẳng ích lợi gì nhưng cũng chẳng tác hại gì: toàn những chuyện vô thưởng vô phạt!",
    example: "toàn những chuyện vô thưởng vô phạt!",
  },
  {
    word: "vô thức",
    part_of_speech: "tính từ",
    meaning:
      "ở ngoài ý thức của con người: hành động vô thức * một cử chỉ gần như vô thức",
    example: "hành động vô thức * một cử chỉ gần như vô thức",
  },
  {
    word: "vô thức",
    part_of_speech: "danh từ",
    meaning:
      "những gì có ở con người mà bản thân con người không nhận ra được, không ý thức được, nhưng vẫn chi phối hành vi (nói tổng quát): cõi vô thức",
    example: "cõi vô thức",
  },
  {
    word: "vô thiên lủng",
    part_of_speech: "tính từ",
    meaning:
      "(thông tục) nhiều lắm, nhiều đến mức không sao kể hết được: khoai lang ở đây thì vô thiên lủng",
    example: "khoai lang ở đây thì vô thiên lủng",
  },
  {
    word: "vô tích sự",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) chẳng được việc gì, chẳng được ích lợi gì: con người vô tích sự * đồ vô tích sự! (tiếng mắng)",
    example: "con người vô tích sự * đồ vô tích sự! (tiếng mắng)",
  },
  {
    word: "vô thừa nhận",
    part_of_speech: "tính từ",
    meaning: "không có ai nhận là của mình: đứa trẻ vô thừa nhận",
    example: "đứa trẻ vô thừa nhận",
  },
  {
    word: "vô tỉ",
    part_of_speech: "danh từ",
    meaning:
      "số được viết dưới dạng phân số thập phân vô hạn không tuần hoàn; phân biệt với số hữu tỉ: số pi (( = 3,1415926535...) là một số vô tỉ",
    example: "số pi (( = 3,1415926535...) là một số vô tỉ",
  },
  {
    word: "vô tội",
    part_of_speech: "tính từ",
    meaning: "không có tội: người dân vô tội * vô tội nên được thả tự do",
    example: "người dân vô tội * vô tội nên được thả tự do",
  },
  {
    word: "vô tổ chức",
    part_of_speech: "tính từ",
    meaning:
      "không có tổ chức hoặc coi thường nguyên tắc tổ chức: thái độ vô tổ chức * mạnh ai nấy làm, rất vô tổ chức",
    example: "thái độ vô tổ chức * mạnh ai nấy làm, rất vô tổ chức",
  },
  {
    word: "vô tội vạ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (việc làm) bừa bãi, tuỳ tiện, bất chấp nguyên tắc, luật lệ: nói năng vô tội vạ * ra lệnh bắt người vô tội vạ",
    example: "nói năng vô tội vạ * ra lệnh bắt người vô tội vạ",
  },
  {
    word: "vô tình",
    part_of_speech: "tính từ",
    meaning:
      'không có tình nghĩa, không có tình cảm: kẻ vô tình, vô nghĩa * "Về dinh ngẫm nghĩ việc nhà, Đành người có nghĩa sao ta vô tình." (HT)',
    example:
      'kẻ vô tình, vô nghĩa * "Về dinh ngẫm nghĩ việc nhà, Đành người có nghĩa sao ta vô tình." (HT)',
  },
  {
    word: "vô tình",
    part_of_speech: "tính từ",
    meaning:
      "không chủ định, không cố ý: vô tình bắt gặp * việc đó chỉ là vô tình, không cố ý",
    example: "vô tình bắt gặp * việc đó chỉ là vô tình, không cố ý",
  },
  {
    word: "vô trách nhiệm",
    part_of_speech: "tính từ",
    meaning:
      "không có tinh thần trách nhiệm: vô trách nhiệm với con cái * một con người vô trách nhiệm",
    example: "vô trách nhiệm với con cái * một con người vô trách nhiệm",
  },
  {
    word: "vô tuyến",
    part_of_speech: "danh từ",
    meaning:
      "phương thức truyền tín hiệu đi xa bằng sóng điện từ (không cần dây dẫn); phân biệt với hữu tuyến: các thiết bị thông tin vô tuyến",
    example: "các thiết bị thông tin vô tuyến",
  },
  {
    word: "vô tuyến",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) vô tuyến truyền hình (nói tắt): xem vô tuyến * vô tuyến màu",
    example: "xem vô tuyến * vô tuyến màu",
  },
  {
    word: "vô trùng",
    part_of_speech: "tính từ",
    meaning:
      "không có hoặc đã được làm cho không còn vi trùng: bông băng vô trùng",
    example: "bông băng vô trùng",
  },
  {
    word: "vô trùng",
    part_of_speech: "động từ",
    meaning:
      "làm cho thành vô trùng: vô trùng phòng mổ * dụng cụ phẫu thuật đã được vô trùng",
    example: "vô trùng phòng mổ * dụng cụ phẫu thuật đã được vô trùng",
  },
  {
    word: "vô tri",
    part_of_speech: "tính từ",
    meaning:
      'không có khả năng nhận biết: vật vô tri * "Hoài lời nói kẻ vô tri, Một trăm gánh chì đúc chẳng nên chuông." (ca dao)',
    example:
      'vật vô tri * "Hoài lời nói kẻ vô tri, Một trăm gánh chì đúc chẳng nên chuông." (ca dao)',
  },
  {
    word: "vô tuyến truyền hình",
    part_of_speech: "danh từ",
    meaning:
      "việc truyền hình bằng radio: hãng vô tuyến truyền hình * xem vô tuyến truyền hình",
    example: "hãng vô tuyến truyền hình * xem vô tuyến truyền hình",
  },
  {
    word: "vô tuyến điện",
    part_of_speech: "danh từ",
    meaning:
      "(cũng vô tuyến điện) phương thức truyền tín hiệu đi xa bằng sự bức xạ sóng điện từ",
    example: "nghe radio",
  },
  {
    word: "vô tư lự",
    part_of_speech: "tính từ",
    meaning:
      "không phải suy nghĩ, lo lắng gì: vẻ mặt vô tư lự * con người vô tư lự",
    example: "vẻ mặt vô tư lự * con người vô tư lự",
  },
  {
    word: "vô vàn",
    part_of_speech: "",
    meaning:
      "từ biểu thị mức độ cao hoặc số lượng nhiều đến nỗi không thể biết chính xác là bao nhiêu: bầu trời vô vàn vì sao lung linh * vượt qua vô vàn thử thách",
    example: "bầu trời vô vàn vì sao lung linh * vượt qua vô vàn thử thách",
  },
  {
    word: "vô tư",
    part_of_speech: "tính từ",
    meaning: "không có lo nghĩ gì: sống hồn nhiên và vô tư * tính rất vô tư",
    example: "sống hồn nhiên và vô tư * tính rất vô tư",
  },
  {
    word: "vô tư",
    part_of_speech: "tính từ",
    meaning:
      "không nghĩ đến, không vì lợi ích riêng: giúp đỡ vô tư, không vụ lợi",
    example: "giúp đỡ vô tư, không vụ lợi",
  },
  {
    word: "vô tư",
    part_of_speech: "tính từ",
    meaning:
      "không thiên vị ai cả: trọng tài làm việc vô tư * nhận xét một cách vô tư, khách quan",
    example: "trọng tài làm việc vô tư * nhận xét một cách vô tư, khách quan",
  },
  {
    word: "vô tỷ",
    part_of_speech: "danh từ",
    meaning:
      "số được viết dưới dạng phân số thập phân vô hạn không tuần hoàn; phân biệt với số hữu tỉ: số pi (( = 3,1415926535...) là một số vô tỉ",
    example: "số pi (( = 3,1415926535...) là một số vô tỉ",
  },
  {
    word: "vô vị",
    part_of_speech: "tính từ",
    meaning: "nhạt nhẽo, không có mùi vị gì: món ăn vô vị",
    example: "món ăn vô vị",
  },
  {
    word: "vô vị",
    part_of_speech: "tính từ",
    meaning:
      "không có ý nghĩa, không có gì thú vị, gây cảm giác chán: câu chuyện vô vị * cảnh sống vô vị",
    example: "câu chuyện vô vị * cảnh sống vô vị",
  },
  {
    word: "vỗ về",
    part_of_speech: "động từ",
    meaning:
      "vỗ nhẹ vào người, để tỏ tình cảm âu yếm, nâng niu: người mẹ vỗ về cho con ngủ",
    example: "người mẹ vỗ về cho con ngủ",
  },
  {
    word: "vỗ về",
    part_of_speech: "động từ",
    meaning:
      "làm yên lòng, làm dịu đi những nỗi buồn phiền hay bất bình, bằng những lời lẽ khuyên nhủ dịu dàng: vỗ về dân chúng",
    example: "vỗ về dân chúng",
  },
  {
    word: "vô ý",
    part_of_speech: "tính từ",
    meaning:
      "không để ý, do sơ suất: vô ý làm vỡ chiếc bình quý * vô ý để dao phạm vào tay",
    example: "vô ý làm vỡ chiếc bình quý * vô ý để dao phạm vào tay",
  },
  {
    word: "vô ý",
    part_of_speech: "tính từ",
    meaning:
      "không có ý tứ, không biết giữ gìn ý tứ: ăn nói rất vô ý * con bé vô ý quá, mồm miệng cứ bô bô",
    example: "ăn nói rất vô ý * con bé vô ý quá, mồm miệng cứ bô bô",
  },
  {
    word: "vồ vập",
    part_of_speech: "tính từ",
    meaning:
      'tỏ ra có thái độ niềm nở, ân cần khi gặp gỡ: vồ vập hỏi han * "Cậu có gặp hắn thì chào qua loa thôi, chẳng việc gì mà phải vồ vập." (KhHưng; 2)',
    example:
      'vồ vập hỏi han * "Cậu có gặp hắn thì chào qua loa thôi, chẳng việc gì mà phải vồ vập." (KhHưng; 2)',
  },
  {
    word: "vô vọng",
    part_of_speech: "tính từ",
    meaning:
      "không còn có thể có hi vọng được gì: mong chờ một cách vô vọng * cuộc tình duyên vô vọng",
    example: "mong chờ một cách vô vọng * cuộc tình duyên vô vọng",
  },
  {
    word: "vô ý thức",
    part_of_speech: "tính từ",
    meaning:
      "không có chủ định, không nhận biết rõ việc mình đang làm là không đúng, là sai trái: hành vi vô ý thức * đồ vô ý thức! (tiếng mắng chửi)",
    example: "hành vi vô ý thức * đồ vô ý thức! (tiếng mắng chửi)",
  },
  {
    word: "vô ý vô tứ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) không có ý tứ, không biết giữ gìn ý tứ: nói năng vô ý vô tứ",
    example: "nói năng vô ý vô tứ",
  },
  {
    word: "vốc",
    part_of_speech: "động từ",
    meaning:
      "lấy vật rời vụn hoặc chất lỏng lên bằng cách khum ngửa lòng hai bàn tay và ghép sát lại: vốc nước suối rửa mặt * vốc gạo bỏ vào soong",
    example: "vốc nước suối rửa mặt * vốc gạo bỏ vào soong",
  },
  {
    word: "vốc",
    part_of_speech: "danh từ",
    meaning:
      "lượng chứa trong lòng bàn tay khi vốc: một vốc muối * con gà to bằng vốc tay",
    example: "một vốc muối * con gà to bằng vốc tay",
  },
  {
    word: "vội",
    part_of_speech: "tính từ",
    meaning:
      "(làm việc gì) hết sức nhanh để cho kịp, cho xong do bị thúc bách về thời gian: đang vội đi thì lại có khách * ăn vội được bát cơm",
    example: "đang vội đi thì lại có khách * ăn vội được bát cơm",
  },
  {
    word: "vội",
    part_of_speech: "tính từ",
    meaning:
      '(làm việc gì) sớm hơn bình thường do cố tình không muốn chờ hoặc do vô ý: chưa chi đã vội lo * đừng vội mừng * "Thuyền đi, tôi sẽ rời chân lại, Tôi nhớ tình ta, anh vội quên." (ThLữ; 1)',
    example:
      'chưa chi đã vội lo * đừng vội mừng * "Thuyền đi, tôi sẽ rời chân lại, Tôi nhớ tình ta, anh vội quên." (ThLữ; 1)',
  },
  {
    word: "vôi hoá",
    part_of_speech: "động từ",
    meaning:
      "(hệ thống xương) bị lắng đọng nhiều chất calcium: vôi hoá cột sống",
    example: "vôi hoá cột sống",
  },
  {
    word: "vôi",
    part_of_speech: "danh từ",
    meaning:
      "chất màu trắng, thu được khi nung từ một loại đá, thường dùng làm vật liệu xây dựng: tường quét vôi trắng xoá * đào hố tôi vôi",
    example: "tường quét vôi trắng xoá * đào hố tôi vôi",
  },
  {
    word: "vội vàng",
    part_of_speech: "tính từ",
    meaning:
      'tỏ ra rất vội (nói khái quát): bước chân vội vàng * "Những mừng được chốn an thân, Vội vàng nào kịp tính gần, tính xa." (TKiều)',
    example:
      'bước chân vội vàng * "Những mừng được chốn an thân, Vội vàng nào kịp tính gần, tính xa." (TKiều)',
  },
  {
    word: "vốn dĩ",
    part_of_speech: "phụ từ",
    meaning:
      "như vốn (nhưng nghĩa mạnh hơn): người nông dân vốn dĩ thật thà, chất phác",
    example: "người nông dân vốn dĩ thật thà, chất phác",
  },
  {
    word: "vội vã",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra rất vội, muốn tranh thủ thời gian đến mức tối đa để cho kịp: được tin, vội vã đi ngay * ăn vội vã mấy miếng cơm * bước chân vội vã",
    example:
      "được tin, vội vã đi ngay * ăn vội vã mấy miếng cơm * bước chân vội vã",
  },
  {
    word: "vội vã",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra vội, không kịp có sự suy nghĩ, cân nhắc: một quyết định hơi vội vã * chưa kịp suy nghĩ đã vội vã làm ngay",
    example: "một quyết định hơi vội vã * chưa kịp suy nghĩ đã vội vã làm ngay",
  },
  {
    word: "vốn",
    part_of_speech: "danh từ",
    meaning:
      "tiền của bỏ ra lúc đầu, dùng trong sản xuất, kinh doanh nhằm sinh lợi: chung vốn * đầu tư vốn * vốn cố định",
    example: "chung vốn * đầu tư vốn * vốn cố định",
  },
  {
    word: "vốn",
    part_of_speech: "danh từ",
    meaning:
      "tổng thể nói chung những gì sẵn có hay tích luỹ được, dùng trong một lĩnh vực hoạt động nào đó: có vốn từ phong phú * vốn hiểu biết rộng * vốn sống",
    example: "có vốn từ phong phú * vốn hiểu biết rộng * vốn sống",
  },
  {
    word: "vốn",
    part_of_speech: "phụ từ",
    meaning:
      'nguyên đã có từ trước, nguyên trước kia đã thế: tính vốn nhút nhát * "Thông minh vốn sẵn tính trời, Pha nghề thi hoạ, đủ mùi ca ngâm." (TKiều)',
    example:
      'tính vốn nhút nhát * "Thông minh vốn sẵn tính trời, Pha nghề thi hoạ, đủ mùi ca ngâm." (TKiều)',
  },
  {
    word: "vốn liếng",
    part_of_speech: "danh từ",
    meaning:
      "vốn (nói khái quát): vốn liếng ít ỏi * có chút vốn liếng về văn học",
    example: "vốn liếng ít ỏi * có chút vốn liếng về văn học",
  },
  {
    word: "vốn sống",
    part_of_speech: "danh từ",
    meaning:
      "tổng thể nói chung những tri thức, kinh nghiệm tích luỹ được về cuộc sống của một người: trau dồi vốn sống",
    example: "trau dồi vốn sống",
  },
  {
    word: "vồn vã",
    part_of_speech: "tính từ",
    meaning:
      "vui vẻ, đầy nhiệt tình khi tiếp xúc: vồn vã đón tiếp * chào hỏi vồn vã",
    example: "vồn vã đón tiếp * chào hỏi vồn vã",
  },
  {
    word: "vổng",
    part_of_speech: "động từ",
    meaning: "chổng ngược lên cao: buộc tóc vổng cao lên * cán cân vổng lên",
    example: "buộc tóc vổng cao lên * cán cân vổng lên",
  },
  {
    word: "vồng",
    part_of_speech: "danh từ",
    meaning: "luống đất đắp cao, hình khum khum: vồng khoai",
    example: "vồng khoai",
  },
  {
    word: "vồng",
    part_of_speech: "động từ",
    meaning:
      "lớn vượt hẳn lên một cách nhanh chóng: cây chuối vồng lên trông thấy * em bé lớn vồng lên",
    example: "cây chuối vồng lên trông thấy * em bé lớn vồng lên",
  },
  {
    word: "vồng",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) ngồng: vồng cải",
    example: "vồng cải",
  },
  {
    word: "vống",
    part_of_speech: "tính từ",
    meaning: "(Ít dùng) như vóng: cao vống lên",
    example: "cao vống lên",
  },
  {
    word: "vồn vập",
    part_of_speech: "động từ",
    meaning: "(hiếm) như vồ vập: vồn vập hỏi han",
    example: "vồn vập hỏi han",
  },
  {
    word: "vơ",
    part_of_speech: "động từ",
    meaning:
      "thu những thứ nằm rải rác lại một chỗ để lấy hết cho nhanh, không cần lựa chọn, sắp xếp: vơ bèo * vơ củi * vơ quần áo tống vào va li",
    example: "vơ bèo * vơ củi * vơ quần áo tống vào va li",
  },
  {
    word: "vơ",
    part_of_speech: "động từ",
    meaning:
      "tóm lấy bằng động tác mau lẹ, vội vàng, không chút đắn đo, chỉ cốt cho nhanh: vơ vội cái nón rồi đi ngay",
    example: "vơ vội cái nón rồi đi ngay",
  },
  {
    word: "vơ",
    part_of_speech: "động từ",
    meaning:
      '(khẩu ngữ) lấy hết, nhận hết về mình, không kể như thế nào, nên hay không nên: việc không đâu cũng vơ vào mình * "Ông tơ thực nhẽ đa đoan, Xe tơ sao khéo vơ quàng vơ xiên." (TKiều)',
    example:
      'việc không đâu cũng vơ vào mình * "Ông tơ thực nhẽ đa đoan, Xe tơ sao khéo vơ quàng vơ xiên." (TKiều)',
  },
  {
    word: "vơ",
    part_of_speech: "tính từ",
    meaning: "không có cơ sở gì nhưng vẫn cứ làm: đoán vơ * xấu hổ vì nhận vơ",
    example: "đoán vơ * xấu hổ vì nhận vơ",
  },
  {
    word: "vờ",
    part_of_speech: "danh từ",
    meaning: "tên gọi thông thường của phù du: xác như vờ",
    example: "xác như vờ",
  },
  {
    word: "vờ",
    part_of_speech: "động từ",
    meaning:
      "làm ra vẻ như, làm cho người ta tưởng thật là như thế: vờ hỏi * vờ như không thấy * nằm im vờ ngủ",
    example: "vờ hỏi * vờ như không thấy * nằm im vờ ngủ",
  },
  {
    word: "vỡ",
    part_of_speech: "động từ",
    meaning:
      "(vật cứng, giòn) rời ra thành nhiều mảnh do tác động của lực cơ học: kính vỡ * cái đĩa rơi xuống đất, vỡ tan * lành làm gáo vỡ làm muôi (tng)",
    example:
      "kính vỡ * cái đĩa rơi xuống đất, vỡ tan * lành làm gáo vỡ làm muôi (tng)",
  },
  {
    word: "vỡ",
    part_of_speech: "động từ",
    meaning:
      "không còn nguyên khối nữa, mà có những mảnh, những mảng lớn bị tách rời ra do không chịu nổi tác động mạnh của lực cơ học: đê vỡ * tức nước vỡ bờ (tng)",
    example: "đê vỡ * tức nước vỡ bờ (tng)",
  },
  {
    word: "vỡ",
    part_of_speech: "động từ",
    meaning:
      "không còn là một khối có tổ chức nữa, mà bị tan rã do có tác động từ bên ngoài vào: vỡ đội hình * cơ sở bí mật bị vỡ từ năm 1965",
    example: "vỡ đội hình * cơ sở bí mật bị vỡ từ năm 1965",
  },
  {
    word: "vỡ",
    part_of_speech: "động từ",
    meaning: "bắt đầu hiểu ra: học mãi rồi cũng vỡ dần ra",
    example: "học mãi rồi cũng vỡ dần ra",
  },
  {
    word: "vỡ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) (chuyện) đã bị lộ ra, không còn giấu giếm được nữa: cố không để vỡ chuyện * chuyện mà vỡ ra thì xấu mặt cả lũ",
    example: "cố không để vỡ chuyện * chuyện mà vỡ ra thì xấu mặt cả lũ",
  },
  {
    word: "vỡ",
    part_of_speech: "động từ",
    meaning: "vỡ hoang (nói tắt): vỡ đất trồng cây",
    example: "vỡ đất trồng cây",
  },
  {
    word: "vớ",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) nắm lấy cái gì đó ở tầm tay lên một cách rất nhanh: vớ vội cái mũ rồi đi * vớ lấy cái gậy, vụt lại",
    example: "vớ vội cái mũ rồi đi * vớ lấy cái gậy, vụt lại",
  },
  {
    word: "vớ",
    part_of_speech: "động từ",
    meaning:
      "(Thông tục) có được một cách không ngờ: vớ được món hời * chết đuối vớ được cọc (tng)",
    example: "vớ được món hời * chết đuối vớ được cọc (tng)",
  },
  {
    word: "vớ bẫm",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) vớ được món lợi béo bở: vụ đó, bà ấy vớ bẫm",
    example: "vụ đó, bà ấy vớ bẫm",
  },
  {
    word: "vớ bở",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) kiếm được món lợi một cách may mắn, không ngờ: đến muộn mà lại vớ bở",
    example: "đến muộn mà lại vớ bở",
  },
  {
    word: "vợ",
    part_of_speech: "danh từ",
    meaning:
      "người phụ nữ đã kết hôn, trong quan hệ với người đàn ông kết hôn với mình (chồng): cưới vợ * chưa lấy vợ",
    example: "cưới vợ * chưa lấy vợ",
  },
  {
    word: "vợ bé",
    part_of_speech: "danh từ",
    meaning:
      '(phương ngữ) vợ lẽ: "Gió đưa bụi chuối sau hè, Anh mê vợ bé, bỏ bè con thơ." (ca dao)',
    example: 'Gió đưa bụi chuối sau hè, Anh mê vợ bé, bỏ bè con thơ." (ca dao)',
  },
  {
    word: "vở",
    part_of_speech: "danh từ",
    meaning:
      "tập giấy được đóng lại để viết, thường có bìa bọc ngoài: vở tập viết * vở bài tập toán",
    example: "vở tập viết * vở bài tập toán",
  },
  {
    word: "vở",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị tác phẩm sân khấu: vở chèo * một vở kịch hay",
    example: "vở chèo * một vở kịch hay",
  },
  {
    word: "vợ chồng",
    part_of_speech: "danh từ",
    meaning:
      'vợ và chồng, về mặt thành một đôi với nhau (nói khái quát): một cặp vợ chồng hạnh phúc * "Đi đâu có anh có tôi, Người ta mới biết rằng đôi vợ chồng." (ca dao)',
    example:
      'một cặp vợ chồng hạnh phúc * "Đi đâu có anh có tôi, Người ta mới biết rằng đôi vợ chồng." (ca dao)',
  },
  {
    word: "vỡ chợ",
    part_of_speech: "",
    meaning: "(khẩu ngữ) ví cảnh ồn ào, ầm ĩ, hỗn loạn: ồn ào như vỡ chợ",
    example: "ồn ào như vỡ chợ",
  },
  {
    word: "vợ con",
    part_of_speech: "danh từ",
    meaning:
      "vợ và con, về mặt là gia đình riêng của người đàn ông (nói khái quát): vợ con đề huề * tính chuyện vợ con",
    example: "vợ con đề huề * tính chuyện vợ con",
  },
  {
    word: "vơ đũa cả nắm",
    part_of_speech: "",
    meaning:
      "ví thái độ đánh giá xô bồ, coi tất cả như nhau, không phân biệt người tốt với người xấu, việc hay với việc dở: đừng có vơ đũa cả nắm!",
    example: "đừng có vơ đũa cả nắm!",
  },
  {
    word: "vỡ lẽ",
    part_of_speech: "động từ",
    meaning:
      "hiểu ra được thực chất điều mà trước đó chưa biết rõ, chưa hiểu rõ: suy nghĩ một hồi mới vỡ lẽ * thảo luận cho vỡ lẽ",
    example: "suy nghĩ một hồi mới vỡ lẽ * thảo luận cho vỡ lẽ",
  },
  {
    word: "vỡ hoang",
    part_of_speech: "động từ",
    meaning: "làm cho đất hoang trở thành đất trồng trọt: đất vỡ hoang",
    example: "đất vỡ hoang",
  },
  {
    word: "vỡ lòng",
    part_of_speech: "động từ",
    meaning: "(cũ) bắt đầu học chữ (nói về trẻ em): lớp vỡ lòng * học vỡ lòng",
    example: "lớp vỡ lòng * học vỡ lòng",
  },
  {
    word: "vỡ lòng",
    part_of_speech: "động từ",
    meaning:
      '(khẩu ngữ) bắt đầu học một môn học hay một nghề nào đó: trình độ vỡ lòng * "Xót mình cửa các buồng khuê, Vỡ lòng, học lấy những nghề nghiệp hay!" (TKiều)',
    example:
      'trình độ vỡ lòng * "Xót mình cửa các buồng khuê, Vỡ lòng, học lấy những nghề nghiệp hay!" (TKiều)',
  },
  {
    word: "vỡ lở",
    part_of_speech: "động từ",
    meaning:
      "(chuyện không hay) bị lộ ra làm nhiều người biết, không còn giấu giếm được nữa: câu chuyện vỡ lở * việc đã vỡ lở, có giấu cũng chẳng được",
    example: "câu chuyện vỡ lở * việc đã vỡ lở, có giấu cũng chẳng được",
  },
  {
    word: "vỡ mộng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) thất vọng trước sự thực xảy ra trái với điều mình mơ ước: vỡ mộng làm giàu",
    example: "vỡ mộng làm giàu",
  },
  {
    word: "vơ vẩn",
    part_of_speech: "tính từ",
    meaning: "như vẩn vơ: mắt nhìn vơ vẩn",
    example: "mắt nhìn vơ vẩn",
  },
  {
    word: "vỡ vạc",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) mới khai khẩn, chưa trồng trọt gì: mảnh đất mới vỡ vạc",
    example: "mảnh đất mới vỡ vạc",
  },
  {
    word: "vỡ vạc",
    part_of_speech: "động từ",
    meaning:
      "mới bắt đầu hiểu ra (nói khái quát): giờ mới vỡ vạc ra nhiều chuyện",
    example: "giờ mới vỡ vạc ra nhiều chuyện",
  },
  {
    word: "vớ vẩn",
    part_of_speech: "tính từ",
    meaning:
      "chẳng có nghĩa lí gì, chẳng có tác dụng gì thiết thực: toàn những thứ vớ vẩn * hỏi vớ vẩn * nghĩ vớ nghĩ vẩn",
    example: "toàn những thứ vớ vẩn * hỏi vớ vẩn * nghĩ vớ nghĩ vẩn",
  },
  {
    word: "vớ vẩn",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) suy nghĩ, nói năng hay làm việc gì đó một cách thiếu cân nhắc, thiếu chín chắn: đừng có vớ vẩn!",
    example: "đừng có vớ vẩn!",
  },
  {
    word: "vỡ nợ",
    part_of_speech: "động từ",
    meaning:
      "lâm vào tình trạng thua lỗ, thất bại liên tiếp trong kinh doanh, phải bán hết tài sản để trả nợ mà vẫn không đủ: nhà buôn vỡ nợ",
    example: "nhà buôn vỡ nợ",
  },
  {
    word: "vơ vét",
    part_of_speech: "động từ",
    meaning:
      "lấy đi cho bằng hết, không chừa một thứ gì: vơ vét những gì còn sót lại * quan lại ra sức vơ vét của cải của dân",
    example:
      "vơ vét những gì còn sót lại * quan lại ra sức vơ vét của cải của dân",
  },
  {
    word: "vơ vất",
    part_of_speech: "tính từ",
    meaning: "như vất vưởng: sống vơ vất đầu đường xó chợ",
    example: "sống vơ vất đầu đường xó chợ",
  },
  {
    word: "vời",
    part_of_speech: "tính từ",
    meaning:
      'xa lắm: xa vời * "Những mong cá nước sum vầy, Bao ngờ đôi ngả nước mây cách vời." (CPN)',
    example:
      'xa vời * "Những mong cá nước sum vầy, Bao ngờ đôi ngả nước mây cách vời." (CPN)',
  },
  {
    word: "vời",
    part_of_speech: "động từ",
    meaning:
      "(cũ, trang trọng) cho mời một người dưới nào đó đến: được nhà vua vời vào cung",
    example: "được nhà vua vời vào cung",
  },
  {
    word: "vờ vĩnh",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) giả vờ (nói khái quát): biết rồi lại còn vờ vĩnh",
    example: "biết rồi lại còn vờ vĩnh",
  },
  {
    word: "với",
    part_of_speech: "động từ",
    meaning:
      "vươn tay ra cố cho tới một vật ở hơi quá tầm tay của mình: với tay lên mắc áo * cao quá với không tới",
    example: "với tay lên mắc áo * cao quá với không tới",
  },
  {
    word: "với",
    part_of_speech: "động từ",
    meaning:
      'đạt tới được cái khó có thể vươn tới: "Vắn tay với chẳng tới kèo, Cha mẹ anh nghèo chẳng với được em." (Cdao)',
    example:
      'Vắn tay với chẳng tới kèo, Cha mẹ anh nghèo chẳng với được em." (Cdao)',
  },
  {
    word: "với",
    part_of_speech: "động từ",
    meaning:
      "từ biểu thị hướng của hành động, hoạt động nhằm tới một đối tượng ở một khoảng cách hơi quá tầm: gọi với theo * nhìn với cho đến lúc đi khuất",
    example: "gọi với theo * nhìn với cho đến lúc đi khuất",
  },
  {
    word: "với",
    part_of_speech: "danh từ",
    meaning:
      "khoảng cách bằng một cánh tay vươn thẳng của người bình thường: chiếc phao chỉ còn cách hơn một với",
    example: "chiếc phao chỉ còn cách hơn một với",
  },
  {
    word: "vơi",
    part_of_speech: "tính từ",
    meaning:
      'còn thiếu một ít nữa mới đầy: đong vơi * "Lồng cồng như mẹ chồng xới xôi, Bát đầy thì ít, bát vơi thì nhiều." (ca dao)',
    example:
      'đong vơi * "Lồng cồng như mẹ chồng xới xôi, Bát đầy thì ít, bát vơi thì nhiều." (ca dao)',
  },
  {
    word: "vơi",
    part_of_speech: "động từ",
    meaning:
      'bớt dần, cạn dần đi, không còn đầy nữa: nồi cơm đã vơi một nửa * "Ai ngờ bỗng mỗi năm một nhạt, Nguồn ân kia chẳng tát mà vơi." (CO)',
    example:
      'nồi cơm đã vơi một nửa * "Ai ngờ bỗng mỗi năm một nhạt, Nguồn ân kia chẳng tát mà vơi." (CO)',
  },
  {
    word: "vờ vịt",
    part_of_speech: "động từ",
    meaning:
      '(khẩu ngữ) giả vờ để che giấu điều gì đó (nói khái quát): đừng có vờ vịt! * "Bà ấy không rõ vờ vịt hay thật, mà trông có vẻ thiểu não buồn rầu lắm." (BBThi; 5)',
    example:
      'đừng có vờ vịt! * "Bà ấy không rõ vờ vịt hay thật, mà trông có vẻ thiểu não buồn rầu lắm." (BBThi; 5)',
  },
  {
    word: "vợi",
    part_of_speech: "động từ",
    meaning:
      "lấy bớt ra một phần ở đồ đựng này chuyển sang đồ đựng khác: vợi gạo trong thùng ra tải * vợi nước  ở trong thùng phuy ra chậu",
    example:
      "vợi gạo trong thùng ra tải * vợi nước  ở trong thùng phuy ra chậu",
  },
  {
    word: "vợi",
    part_of_speech: "động từ",
    meaning:
      "giảm bớt đi so với trước: cót thóc vợi dần * nỗi đau đã vợi phần nào",
    example: "cót thóc vợi dần * nỗi đau đã vợi phần nào",
  },
  {
    word: "với lại",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là thêm một lẽ, bổ sung cho lí do vừa nói đến để càng có thể khẳng định điều muốn nói: tôi không muốn đi, với lại trời cũng bắt đầu mưa rồi",
    example: "tôi không muốn đi, với lại trời cũng bắt đầu mưa rồi",
  },
  {
    word: "vơi đầy",
    part_of_speech: "tính từ",
    meaning:
      '(văn chương) như đầy vơi: "Ai đi muôn dặm non sông, Để ai chứa chất sầu đong vơi đầy." (ca dao)',
    example:
      'Ai đi muôn dặm non sông, Để ai chứa chất sầu đong vơi đầy." (ca dao)',
  },
  {
    word: "vời vợi",
    part_of_speech: "tính từ",
    meaning:
      "có mức độ cao, xa hoặc sâu tưởng như không sao có thể tới được: cao vời vợi * xa vời vợi",
    example: "cao vời vợi * xa vời vợi",
  },
  {
    word: "vờn",
    part_of_speech: "động từ",
    meaning:
      "lượn qua lại trước một đối tượng nào đó với những động tác tựa như đùa giỡn, sát vào rồi lại xa ra ngay: mèo vờn chuột",
    example: "mèo vờn chuột",
  },
  {
    word: "vú",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận cơ thể ở ngực của người hay ở bụng của thú, có núm nhỏ nhô lên, ở phụ nữ hay thú giống cái có bầu to tiết sữa để nuôi con.",
    example: "vú dừa * vú chiêng",
  },
  {
    word: "vú",
    part_of_speech: "danh từ",
    meaning: "bộ phận có hình cái vú ở một số vật: vú dừa * vú chiêng",
    example: "vú nuôi * đi làm vú cho một nhà địa chủ",
  },
  {
    word: "vớt vát",
    part_of_speech: "động từ",
    meaning:
      "cố lấy lại, giữ lại được phần nào hay phần ấy: nói vớt vát vài câu * nhà cháy sạch, may mà vớt vát được ít tiền",
    example: "nói vớt vát vài câu * nhà cháy sạch, may mà vớt vát được ít tiền",
  },
  {
    word: "vợt",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng làm bằng lưới hoặc vải thưa, khâu vào một cái vòng có cán, để bắt cá, tôm, bướm, v.v.: vợt bắt bướm * bắt cá bằng vợt",
    example: "vợt bắt bướm * bắt cá bằng vợt",
  },
  {
    word: "vợt",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ thể thao gồm một mặt hình bầu dục có cán cầm, dùng để đánh bóng bàn, cầu lông, quần vợt: vợt cầu lông * căng lại lưới vợt",
    example: "vợt cầu lông * căng lại lưới vợt",
  },
  {
    word: "vợt",
    part_of_speech: "động từ",
    meaning: "bắt bằng cái vợt: đi vợt cá * vợt cào cào",
    example: "đi vợt cá * vợt cào cào",
  },
  {
    word: "vớt",
    part_of_speech: "động từ",
    meaning: "lấy từ dưới nước lên: vớt bèo * vớt xác người chết đuối",
    example: "vớt bèo * vớt xác người chết đuối",
  },
  {
    word: "vớt",
    part_of_speech: "động từ",
    meaning:
      "lấy thêm cho đỗ, mặc dù còn thiếu điểm chút ít, trong thi cử: đỗ vớt * vớt thêm mấy thí sinh",
    example: "đỗ vớt * vớt thêm mấy thí sinh",
  },
  {
    word: "vớt",
    part_of_speech: "động từ",
    meaning:
      "cố làm thêm điều gì đó để được chút nào hay chút ấy: cấy vớt một vụ lúa * nói vớt mấy câu",
    example: "cấy vớt một vụ lúa * nói vớt mấy câu",
  },
  {
    word: "vởn vơ",
    part_of_speech: "động từ",
    meaning:
      "lảng vảng, nhởn nhơ đây đó: đàn bướm vởn vơ quanh khóm hoa * đi lại vởn vơ",
    example: "đàn bướm vởn vơ quanh khóm hoa * đi lại vởn vơ",
  },
  {
    word: "vụ",
    part_of_speech: "danh từ",
    meaning:
      "thời kì trong một năm tập trung vào một công việc nào đó về lao động sản xuất nông nghiệp: một năm cấy hai vụ * vải đang vào vụ",
    example: "một năm cấy hai vụ * vải đang vào vụ",
  },
  {
    word: "vụ",
    part_of_speech: "danh từ",
    meaning:
      "việc, sự việc không hay cần phải giải quyết: vụ tham nhũng * vụ tranh chấp * tìm ra nguyên nhân của vụ cháy",
    example: "vụ tham nhũng * vụ tranh chấp * tìm ra nguyên nhân của vụ cháy",
  },
  {
    word: "vụ",
    part_of_speech: "danh từ",
    meaning:
      "cơ quan chuyên môn trong một bộ hoặc cơ quan ngang bộ có chức năng giúp lãnh đạo nghiên cứu và quản lí việc thi hành các chế độ, chính sách: vụ kế hoạch * vụ phó vụ tổ chức cán bộ",
    example: "vụ kế hoạch * vụ phó vụ tổ chức cán bộ",
  },
  {
    word: "vụ",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) con quay: đánh vụ",
    example: "đánh vụ",
  },
  {
    word: "vù",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng phát ra như tiếng của vật gì bay vụt qua rất nhanh, cọ xát mạnh vào không khí: đạn bay vù qua đầu * quạt quay vù vù",
    example: "đạn bay vù qua đầu * quạt quay vù vù",
  },
  {
    word: "vù",
    part_of_speech: "tính từ",
    meaning:
      "sức mạnh dùng để trấn áp, cưỡng bức: dùng vũ lực để uy hiếp nhằm chiếm đoạt tài sản",
    example: "dùng vũ lực để uy hiếp nhằm chiếm đoạt tài sản",
  },
  {
    word: "vu",
    part_of_speech: "động từ",
    meaning:
      "bịa ra rằng người khác đã làm điều xấu, việc xấu nào đó nhằm làm hại: bị vu cho là ăn cắp * vu xằng nhận bậy",
    example: "bị vu cho là ăn cắp * vu xằng nhận bậy",
  },
  {
    word: "vũ",
    part_of_speech: "danh từ",
    meaning: "múa: điệu vũ dân gian * chương trình ca, vũ, nhạc",
    example: "điệu vũ dân gian * chương trình ca, vũ, nhạc",
  },
  {
    word: "vũ đài",
    part_of_speech: "danh từ",
    meaning: "(cũ, hiếm)",
    example: "vũ đài chính trị * vũ đài quốc tế",
  },
  {
    word: "vũ bão",
    part_of_speech: "danh từ",
    meaning:
      "mưa và bão; dùng để ví sự việc diễn ra với khí thế nhanh, mạnh và dồn dập trên quy mô lớn: thế quân mạnh như vũ bão * phong trào giải phóng dân tộc nổi lên như vũ bão",
    example:
      "thế quân mạnh như vũ bão * phong trào giải phóng dân tộc nổi lên như vũ bão",
  },
  {
    word: "vũ công",
    part_of_speech: "danh từ",
    meaning: "nghệ sĩ múa hoặc khiêu vũ: đoàn vũ công",
    example: "đoàn vũ công",
  },
  {
    word: "vũ đạo",
    part_of_speech: "danh từ",
    meaning:
      "động tác múa cách điệu trong kịch hát do diễn viên thể hiện, gần với múa ước lệ: kĩ thuật vũ đạo * vũ đạo tuồng",
    example: "kĩ thuật vũ đạo * vũ đạo tuồng",
  },
  {
    word: "vu cáo",
    part_of_speech: "động từ",
    meaning: "bịa đặt chuyện xấu để buộc tội người nào đó: bác bỏ lời vu cáo",
    example: "bác bỏ lời vu cáo",
  },
  {
    word: "vũ điệu",
    part_of_speech: "danh từ",
    meaning: "điệu múa: vũ điệu tango",
    example: "vũ điệu tango",
  },
  {
    word: "vũ đoàn",
    part_of_speech: "danh từ",
    meaning:
      "đoàn hoặc nhóm nghệ sĩ chuyên biểu diễn về nhảy múa: hát có vũ đoàn phụ hoạ",
    example: "hát có vũ đoàn phụ hoạ",
  },
  {
    word: "vũ hội",
    part_of_speech: "danh từ",
    meaning:
      "cuộc vui có khiêu vũ, thường có đông người tham gia: tham dự vũ hội hoá trang",
    example: "tham dự vũ hội hoá trang",
  },
  {
    word: "vũ khí",
    part_of_speech: "danh từ",
    meaning:
      "phương tiện dùng để sát thương và phá hoại nói chung: trang bị vũ khí tối tân * thiếu vũ khí, đạn dược",
    example: "trang bị vũ khí tối tân * thiếu vũ khí, đạn dược",
  },
  {
    word: "vũ khí",
    part_of_speech: "danh từ",
    meaning: "phương tiện để tiến hành đấu tranh: dùng ngòi bút làm vũ khí",
    example: "dùng ngòi bút làm vũ khí",
  },
  {
    word: "vú em",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận cơ thể ở ngực của người hay ở bụng của thú, có núm nhỏ nhô lên, ở phụ nữ hay thú giống cái có bầu to tiết sữa để nuôi con.",
    example: "vú dừa * vú chiêng",
  },
  {
    word: "vú em",
    part_of_speech: "danh từ",
    meaning: "bộ phận có hình cái vú ở một số vật: vú dừa * vú chiêng",
    example: "vú nuôi * đi làm vú cho một nhà địa chủ",
  },
  {
    word: "vu hồi",
    part_of_speech: "động từ",
    meaning: "(hiếm) vòng qua, đi vòng qua: đường vu hồi",
    example: "đường vu hồi",
  },
  {
    word: "vu hồi",
    part_of_speech: "động từ",
    meaning: "đánh vòng lại: đánh vu hồi",
    example: "đánh vu hồi",
  },
  {
    word: "vụ lợi",
    part_of_speech: "động từ",
    meaning:
      "mưu cầu lợi ích cho riêng mình: giúp đỡ vô tư, không vụ lợi * có mục đích vụ lợi",
    example: "giúp đỡ vô tư, không vụ lợi * có mục đích vụ lợi",
  },
  {
    word: "vũ khúc",
    part_of_speech: "danh từ",
    meaning:
      "tác phẩm âm nhạc miêu tả một quang cảnh, phong cách, sắc thái múa của một vùng hay một tộc người nào đó: vũ khúc Tây Nguyên * vũ khúc cổ điển",
    example: "vũ khúc Tây Nguyên * vũ khúc cổ điển",
  },
  {
    word: "vũ kịch",
    part_of_speech: "danh từ",
    meaning:
      "loại hình sân khấu chủ yếu dùng động tác múa để thể hiện tính cách và hành động của nhân vật: Nhà hát nhạc vũ kịch Việt Nam",
    example: "Nhà hát nhạc vũ kịch Việt Nam",
  },
  {
    word: "vu khống",
    part_of_speech: "động từ",
    meaning:
      "bịa đặt chuyện xấu cho người khác để làm mất danh dự, mất uy tín: bịa chuyện để vu khống",
    example: "bịa chuyện để vu khống",
  },
  {
    word: "vũ phu",
    part_of_speech: "tính từ",
    meaning:
      "(người đàn ông) có thái độ, hành động thô bạo đối với người khác, thường là với phụ nữ: kẻ vũ phu * người chồng vũ phu",
    example: "kẻ vũ phu * người chồng vũ phu",
  },
  {
    word: "vu oan",
    part_of_speech: "động từ",
    meaning:
      "vu cho người nào đó làm cho người ta bị oan: bị vu oan cho là ăn cắp",
    example: "bị vu oan cho là ăn cắp",
  },
  {
    word: "vũ sư",
    part_of_speech: "danh từ",
    meaning: "người làm nghề dạy khiêu vũ: mời vũ sư đến dạy tại nhà",
    example: "mời vũ sư đến dạy tại nhà",
  },
  {
    word: "vu qui",
    part_of_speech: "động từ",
    meaning: "(cũ, hoặc trtr) đi lấy chồng, về nhà chồng: lễ vu quy",
    example: "lễ vu quy",
  },
  {
    word: "vũ lực",
    part_of_speech: "danh từ",
    meaning:
      "sức mạnh về quân sự, sức mạnh của quân đội: can thiệp bằng vũ lực * dùng vũ lực để xâm chiếm",
    example: "can thiệp bằng vũ lực * dùng vũ lực để xâm chiếm",
  },
  {
    word: "vu quy",
    part_of_speech: "động từ",
    meaning: "(cũ, hoặc trtr) đi lấy chồng, về nhà chồng: lễ vu quy",
    example: "lễ vu quy",
  },
  {
    word: "vũ trường",
    part_of_speech: "danh từ",
    meaning:
      "nơi được xây dựng, thiết kế để dành riêng cho việc khiêu vũ: nhà hàng, vũ trường mọc lên như nấm",
    example: "nhà hàng, vũ trường mọc lên như nấm",
  },
  {
    word: "vu vạ",
    part_of_speech: "động từ",
    meaning: "vu cho làm chuyện xấu nhằm gây tai hoạ: vu vạ cho người vô tội",
    example: "vu vạ cho người vô tội",
  },
  {
    word: "vũ trang",
    part_of_speech: "động từ",
    meaning:
      "trang bị vũ khí để chiến đấu: toàn dân vũ trang đánh giặc * được vũ trang đầy đủ",
    example: "toàn dân vũ trang đánh giặc * được vũ trang đầy đủ",
  },
  {
    word: "vũ trang",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất quân sự và có trang bị vũ khí: lực lượng vũ trang * đấu tranh vũ trang",
    example: "lực lượng vũ trang * đấu tranh vũ trang",
  },
  {
    word: "vụ việc",
    part_of_speech: "danh từ",
    meaning:
      "việc, sự việc không hay xảy ra, thường gây được sự chú ý (nói khái quát): vụ việc bê bối * cơ quan chức năng đang làm rõ vụ việc",
    example: "vụ việc bê bối * cơ quan chức năng đang làm rõ vụ việc",
  },
  {
    word: "vu vơ",
    part_of_speech: "tính từ",
    meaning:
      "không có căn cứ, không nhằm mục đích gì cả: thấy động, bắn vu vơ mấy phát * hỏi một câu vu vơ * lo sợ vu vơ",
    example: "thấy động, bắn vu vơ mấy phát * hỏi một câu vu vơ * lo sợ vu vơ",
  },
  {
    word: "vua chúa",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người đứng đầu một nước thời phong kiến (nói khái quát): vua chúa nhà Nguyễn",
    example: "vua chúa nhà Nguyễn",
  },
  {
    word: "vu vu",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng như tiếng gió thổi nhẹ qua lỗ hổng nhỏ: tiếng sáo diều vu vu",
    example: "tiếng sáo diều vu vu",
  },
  {
    word: "vùa",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) đồ dùng để đựng, hình giống cái bát: vùa gạo",
    example: "vùa gạo",
  },
  {
    word: "vũ trụ",
    part_of_speech: "danh từ",
    meaning:
      "khoảng không gian vô cùng tận chứa các thiên hà: bay vào vũ trụ * thám hiểm vũ trụ",
    example: "bay vào vũ trụ * thám hiểm vũ trụ",
  },
  {
    word: "vua quan",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) những người nắm quyền cai trị trong nhà nước phong kiến (nói khái quát): vua quan nhà Lý",
    example: "vua quan nhà Lý",
  },
  {
    word: "vua",
    part_of_speech: "danh từ",
    meaning:
      "người đứng đầu nhà nước, thường lên cầm quyền bằng con đường kế vị: phép vua thua lệ làng (tng)",
    example: "phép vua thua lệ làng (tng)",
  },
  {
    word: "vua",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) nhà tư bản độc quyền trong một ngành nào đó: vua ô tô * vua dầu lửa",
    example: "vua ô tô * vua dầu lửa",
  },
  {
    word: "vua",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) người được coi là nhất, không ai hơn trong một chuyên môn nào đó: vua cờ * ông vua nhạc Pop * vua bóng đá",
    example: "vua cờ * ông vua nhạc Pop * vua bóng đá",
  },
  {
    word: "vục",
    part_of_speech: "động từ",
    meaning:
      "úp nghiêng miệng vật đựng và ấn sâu xuống để múc, xúc: vục tay xuống bùn * vục nón xuống ao múc nước",
    example: "vục tay xuống bùn * vục nón xuống ao múc nước",
  },
  {
    word: "vục",
    part_of_speech: "động từ",
    meaning: "chúi hẳn đầu xuống cho nhúng ngập vào: vục đầu vào chậu nước",
    example: "vục đầu vào chậu nước",
  },
  {
    word: "vục",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bật mạnh dậy đến mức như chúi người xuống: ngã nhưng vục dậy được ngay",
    example: "ngã nhưng vục dậy được ngay",
  },
  {
    word: "vua tôi",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) vua và bề tôi (nói khái quát): vua tôi một lòng * đạo vua tôi",
    example: "vua tôi một lòng * đạo vua tôi",
  },
  {
    word: "vui",
    part_of_speech: "",
    meaning:
      'ở trạng thái thấy thích thú của người đang gặp việc hợp nguyện vọng hoặc đang có điều làm cho hài lòng: niềm vui * vui như Tết * "Ông tơ ghét bỏ chi nhau, Chưa vui sum họp đã sầu chia phôi!" (TKiều)',
    example:
      'niềm vui * vui như Tết * "Ông tơ ghét bỏ chi nhau, Chưa vui sum họp đã sầu chia phôi!" (TKiều)',
  },
  {
    word: "vui",
    part_of_speech: "",
    meaning: "có tác dụng làm cho vui: tin vui * nói vui * kể chuyện vui",
    example: "tin vui * nói vui * kể chuyện vui",
  },
  {
    word: "vui đùa",
    part_of_speech: "động từ",
    meaning: "chơi đùa một cách vui vẻ, thoải mái: bọn trẻ vui đùa ngoài sân",
    example: "bọn trẻ vui đùa ngoài sân",
  },
  {
    word: "vùi đầu",
    part_of_speech: "động từ",
    meaning:
      "để hết tâm trí vào một việc nào đó, không còn biết gì đến những việc khác: vùi đầu vào học",
    example: "vùi đầu vào học",
  },
  {
    word: "vùi",
    part_of_speech: "động từ",
    meaning:
      "cho vào trong đất cát, tro than, v.v. rồi phủ kín lại: vùi củ khoai vào tro nóng * vùi sâu nỗi đau trong lòng (b)",
    example: "vùi củ khoai vào tro nóng * vùi sâu nỗi đau trong lòng (b)",
  },
  {
    word: "vui chơi",
    part_of_speech: "động từ",
    meaning:
      "hoạt động giải trí một cách vui vẻ, thoải mái (nói khái quát): được vui chơi thoả thích * khu vui chơi giải trí",
    example: "được vui chơi thoả thích * khu vui chơi giải trí",
  },
  {
    word: "vui chân",
    part_of_speech: "tính từ",
    meaning:
      'cảm thấy thích thú khi đi nên cứ thế bước chân đi mà không chú ý đến đoạn đường và thời gian: "Dan tay ngõ mận, đường hoa, Vui chân một phút thoắt đà đến dinh." (LNT)',
    example:
      'Dan tay ngõ mận, đường hoa, Vui chân một phút thoắt đà đến dinh." (LNT)',
  },
  {
    word: "vùi dập",
    part_of_speech: "động từ",
    meaning:
      "đè nén, chèn ép một cách thô bạo khiến cho không phát triển được: thân phận bị vùi dập",
    example: "thân phận bị vùi dập",
  },
  {
    word: "vùi liễu dập hoa",
    part_of_speech: "",
    meaning:
      '(văn chương) như vùi hoa dập liễu: "Hung hăng chẳng hỏi, chẳng tra, Đang tay vùi liễu, dập hoa tơi bời." (TKiều)',
    example:
      'Hung hăng chẳng hỏi, chẳng tra, Đang tay vùi liễu, dập hoa tơi bời." (TKiều)',
  },
  {
    word: "vui sướng",
    part_of_speech: "tính từ",
    meaning:
      "vui vẻ và sung sướng (nói khái quát): trong lòng vui sướng * giọt nước mắt vui sướng",
    example: "trong lòng vui sướng * giọt nước mắt vui sướng",
  },
  {
    word: "vui mừng",
    part_of_speech: "",
    meaning:
      "rất vui vì được như mong muốn (nói khái quát): vui mừng trước thắng lợi * rất vui mừng khi gặp lại bạn cũ",
    example: "vui mừng trước thắng lợi * rất vui mừng khi gặp lại bạn cũ",
  },
  {
    word: "vui miệng",
    part_of_speech: "tính từ",
    meaning:
      "cảm thấy thích thú khi nói chuyện hoặc khi ăn, uống, v.v. nên cứ tiếp diễn, kéo dài: vui miệng hút liền hai điếu thuốc * nói đùa cho vui miệng",
    example: "vui miệng hút liền hai điếu thuốc * nói đùa cho vui miệng",
  },
  {
    word: "vui nhộn",
    part_of_speech: "tính từ",
    meaning:
      "vui vẻ và ồn ào, có tác dụng làm cho mọi người cùng vui (nói khái quát): không khí vui nhộn ngày khai trường",
    example: "không khí vui nhộn ngày khai trường",
  },
  {
    word: "vui thích",
    part_of_speech: "tính từ",
    meaning: "vui vẻ và thích thú: vui thích vì được đi chơi",
    example: "vui thích vì được đi chơi",
  },
  {
    word: "vui thú",
    part_of_speech: "tính từ",
    meaning:
      'vui vẻ và hứng thú: mệt mỏi chứ chẳng vui thú gì * "Anh ơi, anh ở lại nhà, Thôi đừng vui thú nguyệt hoa chơi bời." (ca dao)',
    example:
      'mệt mỏi chứ chẳng vui thú gì * "Anh ơi, anh ở lại nhà, Thôi đừng vui thú nguyệt hoa chơi bời." (ca dao)',
  },
  {
    word: "vui lòng",
    part_of_speech: "",
    meaning:
      "vui vẻ trong lòng: làm vui lòng cha mẹ * có chút quà mọn, mong cụ vui lòng nhận cho!",
    example:
      "làm vui lòng cha mẹ * có chút quà mọn, mong cụ vui lòng nhận cho!",
  },
  {
    word: "vui tai",
    part_of_speech: "tính từ",
    meaning: "cảm thấy thích thú khi nghe: âm thanh nghe rất vui tai",
    example: "âm thanh nghe rất vui tai",
  },
  {
    word: "vui mắt",
    part_of_speech: "tính từ",
    meaning:
      "có tác dụng làm cho thích thú khi nhìn: những chiếc đèn nhấp nháy trông cũng vui mắt",
    example: "những chiếc đèn nhấp nháy trông cũng vui mắt",
  },
  {
    word: "vui tính",
    part_of_speech: "tính từ",
    meaning: "có tính luôn luôn vui vẻ, hay gây cười: một người vui tính",
    example: "một người vui tính",
  },
  {
    word: "vui tươi",
    part_of_speech: "tính từ",
    meaning: "vui vẻ và tươi tắn: nét mặt vui tươi",
    example: "nét mặt vui tươi",
  },
  {
    word: "vun",
    part_of_speech: "động từ",
    meaning:
      "làm cho các vật rời dồn lại một chỗ thành đống: vun lá cây thành một đống * đi vun ngô",
    example: "vun lá cây thành một đống * đi vun ngô",
  },
  {
    word: "vun",
    part_of_speech: "tính từ",
    meaning: "(Phương ngữ) đầy có ngọn: đĩa thức ăn đầy vun",
    example: "đĩa thức ăn đầy vun",
  },
  {
    word: "vui vẻ",
    part_of_speech: "tính từ",
    meaning:
      "có vẻ ngoài lộ rõ tâm trạng rất vui: nét mặt vui vẻ * vui vẻ nhận lời",
    example: "nét mặt vui vẻ * vui vẻ nhận lời",
  },
  {
    word: "vui vầy",
    part_of_speech: "động từ",
    meaning:
      'vui cùng nhau trong cảnh đầm ấm, hoà thuận: cá nước vui vầy * "Một nhà về đến quan nha, Đoàn viên vội mở tiệc hoa vui vầy." (TKiều)',
    example:
      'cá nước vui vầy * "Một nhà về đến quan nha, Đoàn viên vội mở tiệc hoa vui vầy." (TKiều)',
  },
  {
    word: "vun đắp",
    part_of_speech: "động từ",
    meaning:
      "làm cho ngày một thêm bền vững và phát triển tốt đẹp hơn (nói khái quát): vun đắp cho các con * vun đắp hạnh phúc gia đình",
    example: "vun đắp cho các con * vun đắp hạnh phúc gia đình",
  },
  {
    word: "vụn",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái là những mảnh, mẩu nhỏ, có hình dạng và kích thước khác nhau, do bị cắt xé hoặc gãy vỡ ra: thu mua sắt vụn * vải vụn * xé vụn tờ giấy",
    example: "thu mua sắt vụn * vải vụn * xé vụn tờ giấy",
  },
  {
    word: "vụn",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái là những cái nhỏ nhặt không có giá trị đáng kể: mớ cá vụn * món tiền vụn",
    example: "mớ cá vụn * món tiền vụn",
  },
  {
    word: "vụn",
    part_of_speech: "danh từ",
    meaning: "mảnh, mẩu vụn (nói khái quát): vụn sắt * vụn thuỷ tinh",
    example: "vụn sắt * vụn thuỷ tinh",
  },
  {
    word: "vun trồng",
    part_of_speech: "động từ",
    meaning:
      "trồng và chăm sóc (nói khái quát): vun trồng cây cối * vun trồng công đức",
    example: "vun trồng cây cối * vun trồng công đức",
  },
  {
    word: "vun vào",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tác động đến tâm lí người khác làm cho không còn lưỡng lự trong việc riêng tư nào đó (thường là việc hôn nhân): nói vun vào * vun vào cho hai người thành đôi",
    example: "nói vun vào * vun vào cho hai người thành đôi",
  },
  {
    word: "vụn vặt",
    part_of_speech: "tính từ",
    meaning:
      "nhỏ nhặt, không đáng kể: toàn những chi tiết vụn vặt * hay để ý những chuyện vụn vặt",
    example: "toàn những chi tiết vụn vặt * hay để ý những chuyện vụn vặt",
  },
  {
    word: "vun quén",
    part_of_speech: "động từ",
    meaning:
      "chăm lo vun đắp, gây dựng: vun quén cho gia đình * vun quén, thu dọn nhà cửa",
    example: "vun quén cho gia đình * vun quén, thu dọn nhà cửa",
  },
  {
    word: "vun vút",
    part_of_speech: "động từ",
    meaning:
      "vút qua một cách rất nhanh và mất hút ngay: xe lao vun vút qua cầu * thuyền đi vun vút như tên bay",
    example: "xe lao vun vút qua cầu * thuyền đi vun vút như tên bay",
  },
  {
    word: "vun vút",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng như tiếng roi quất mạnh và liên tiếp trong không khí: tiếng roi quất vun vút vào không khí",
    example: "tiếng roi quất vun vút vào không khí",
  },
  {
    word: "vun vén",
    part_of_speech: "động từ",
    meaning: "thu xếp lại cho gọn: vun vén nhà cửa",
    example: "vun vén nhà cửa",
  },
  {
    word: "vun vén",
    part_of_speech: "động từ",
    meaning:
      "chăm lo gây dựng, về mặt đời sống riêng: biết vun vén cho gia đình",
    example: "biết vun vén cho gia đình",
  },
  {
    word: "vùn vụt",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả tốc độ di chuyển hoặc tăng tiến rất nhanh, liên tục, đến mức như không kịp nhận biết được: tên bay vùn vụt * thời gian vùn vụt trôi",
    example: "tên bay vùn vụt * thời gian vùn vụt trôi",
  },
  {
    word: "vung",
    part_of_speech: "danh từ",
    meaning:
      "nắp đậy nồi hay một số đồ dùng để đun nấu khác, thường có dạng hình chỏm cầu: đậy kín nắp vung * nồi tròn thì úp vung tròn (tng)",
    example: "đậy kín nắp vung * nồi tròn thì úp vung tròn (tng)",
  },
  {
    word: "vung",
    part_of_speech: "động từ",
    meaning:
      "giơ lên và làm động tác rất nhanh, mạnh theo một đường tròn, hướng tới phía trước hoặc sang một bên: vung tay ném * vung roi định quật",
    example: "vung tay ném * vung roi định quật",
  },
  {
    word: "vung",
    part_of_speech: "động từ",
    meaning:
      "ném mạnh và rộng ra các phía bằng động tác vung tay: vung phân đạm cho lúa * vung gạo cho gà",
    example: "vung phân đạm cho lúa * vung gạo cho gà",
  },
  {
    word: "vung",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) từ biểu thị hành động, hoạt động lung tung, không giữ gìn, không theo một hướng cụ thể nào: chửi vung lên * tìm vung lên mà không thấy",
    example: "chửi vung lên * tìm vung lên mà không thấy",
  },
  {
    word: "vùng",
    part_of_speech: "danh từ",
    meaning:
      "phần đất đai hoặc không gian tương đối rộng, có những đặc điểm nhất định về tự nhiên hoặc xã hội: vùng cao * vùng chiêm trũng * dân vùng biển",
    example: "vùng cao * vùng chiêm trũng * dân vùng biển",
  },
  {
    word: "vùng",
    part_of_speech: "danh từ",
    meaning:
      "cánh đồng lớn gồm nhiều thửa ruộng có cùng một độ cao: bờ vùng bờ thửa",
    example: "bờ vùng bờ thửa",
  },
  {
    word: "vùng",
    part_of_speech: "danh từ",
    meaning:
      "phần nhất định của cơ thể, phân biệt với các phần xung quanh: đau ở vùng ức * vùng bụng",
    example: "đau ở vùng ức * vùng bụng",
  },
  {
    word: "vùng",
    part_of_speech: "động từ",
    meaning:
      "dùng sức vận động mạnh và đột ngột toàn thân hoặc một bộ phận cơ thể nào đó để thoát khỏi tình trạng bị trói, bị níu giữ: cố vùng ra nhưng không được",
    example: "cố vùng ra nhưng không được",
  },
  {
    word: "vùng",
    part_of_speech: "động từ",
    meaning:
      "chuyển mạnh và đột ngột từ một trạng thái tĩnh sang trạng thái động: vùng tỉnh giấc * vùng lên lật đổ ách thống trị (b)",
    example: "vùng tỉnh giấc * vùng lên lật đổ ách thống trị (b)",
  },
  {
    word: "vun xới",
    part_of_speech: "động từ",
    meaning:
      "xới đất và vun gốc cho cây (nói khái quát): vun xới mấy luống hoa",
    example: "vun xới mấy luống hoa",
  },
  {
    word: "vun xới",
    part_of_speech: "động từ",
    meaning:
      "chăm nom, săn sóc, tạo điều kiện cho phát triển: vun xới cho hạnh phúc gia đình",
    example: "vun xới cho hạnh phúc gia đình",
  },
  {
    word: "vùng biên",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) vùng tiếp giáp với đường biên giới: chợ vùng biên * thị xã vùng biên",
    example: "chợ vùng biên * thị xã vùng biên",
  },
  {
    word: "vụng",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như vũng (ng2): thuyền đậu trong vụng",
    example: "thuyền đậu trong vụng",
  },
  {
    word: "vụng",
    part_of_speech: "tính từ",
    meaning:
      'không khéo trong hoạt động chân tay, nên kết quả đạt được thường không tốt, không đẹp: nấu ăn rất vụng * "Rượu ngon chẳng quản be sành, áo rách khéo vá hơn lành vụng may." (ca dao)',
    example:
      'nấu ăn rất vụng * "Rượu ngon chẳng quản be sành, áo rách khéo vá hơn lành vụng may." (ca dao)',
  },
  {
    word: "vụng",
    part_of_speech: "tính từ",
    meaning:
      "không khéo, không biết cách nói năng, cư xử sao cho thích hợp nên dễ làm mất lòng người khác: vụng ăn, vụng nói * vụng miệng",
    example: "vụng ăn, vụng nói * vụng miệng",
  },
  {
    word: "vụng",
    part_of_speech: "tính từ",
    meaning:
      'lén lút, không để người khác biết: ăn vụng * nói vụng * "Lòng tôi yêu vụng nhớ thầm, Trách ông Nguyệt Lão xe nhầm duyên ai!" (ca dao)',
    example:
      'ăn vụng * nói vụng * "Lòng tôi yêu vụng nhớ thầm, Trách ông Nguyệt Lão xe nhầm duyên ai!" (ca dao)',
  },
  {
    word: "vũng",
    part_of_speech: "danh từ",
    meaning: "chỗ trũng nhỏ có chất lỏng đọng lại: vũng nước mưa * vũng máu",
    example: "vũng nước mưa * vũng máu",
  },
  {
    word: "vũng",
    part_of_speech: "danh từ",
    meaning:
      "khoảng biển ăn sâu vào đất liền nên ít sóng gió, thường làm nơi cho tàu thuyền neo đậu, trú ẩn khi gặp bão: vũng Cam Ranh",
    example: "vũng Cam Ranh",
  },
  {
    word: "vùng biển",
    part_of_speech: "danh từ",
    meaning:
      "vùng biển ven bờ, có chiều rộng quy định (thường không vượt quá 12 hải lí), thuộc chủ quyền của một nước ven biển: bảo vệ chủ quyền lãnh hải tổ quốc",
    example: "bảo vệ chủ quyền lãnh hải tổ quốc",
  },
  {
    word: "vùng cao",
    part_of_speech: "danh từ",
    meaning:
      "vùng rừng núi, về mặt là khu dân cư, phân biệt với vùng đồng bằng: có chính sách ưu tiên cho con em vùng cao",
    example: "có chính sách ưu tiên cho con em vùng cao",
  },
  {
    word: "vùng đất",
    part_of_speech: "danh từ",
    meaning: "địa phận của một nước: bảo vệ vùng trời, vùng đất của tổ quốc",
    example: "bảo vệ vùng trời, vùng đất của tổ quốc",
  },
  {
    word: "vùng đệm",
    part_of_speech: "danh từ",
    meaning:
      "vùng nằm giữa, mang tính chuyển tiếp giữa những vùng có tính chất khác biệt hoặc đối lập nhau: xây dựng vùng đệm cho khu bảo tồn di tích",
    example: "xây dựng vùng đệm cho khu bảo tồn di tích",
  },
  {
    word: "vung phí",
    part_of_speech: "động từ",
    meaning: "(hiếm) như phung phí: ăn tiêu vung phí",
    example: "ăn tiêu vung phí",
  },
  {
    word: "vụng dại",
    part_of_speech: "tính từ",
    meaning: "(hiếm) vụng về, không được nhanh nhẹn: tay chân vụng dại",
    example: "tay chân vụng dại",
  },
  {
    word: "vụng dại",
    part_of_speech: "tính từ",
    meaning: "dại dột, không được khôn ngoan: con còn vụng dại",
    example: "con còn vụng dại",
  },
  {
    word: "vùng sâu vùng xa",
    part_of_speech: "danh từ",
    meaning:
      "vùng sâu và vùng xa (nói khái quát): mở rộng mạng lưới giao thông đến các vùng sâu vùng xa",
    example: "mở rộng mạng lưới giao thông đến các vùng sâu vùng xa",
  },
  {
    word: "vùng sâu",
    part_of_speech: "danh từ",
    meaning:
      "vùng dân cư thưa thớt nằm sâu trong rừng núi hoặc vùng ngập nước, giao thông không thuận tiện nên thường chậm phát triển: chính sách ưu tiên với học sinh vùng sâu",
    example: "chính sách ưu tiên với học sinh vùng sâu",
  },
  {
    word: "vung tàn tán",
    part_of_speech: "",
    meaning: "(khẩu ngữ) lung tung, khắp các hướng: bắn vung tàn tán",
    example: "bắn vung tàn tán",
  },
  {
    word: "vung thiên địa",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) lung tung, không kể gì cả: tức quá, chửi vung thiên địa",
    example: "tức quá, chửi vung thiên địa",
  },
  {
    word: "vụng trộm",
    part_of_speech: "tính từ",
    meaning:
      "lén lút, giấu giếm, không dám để cho người khác biết: cuộc tình duyên vụng trộm *  làm một cách vụng trộm",
    example: "cuộc tình duyên vụng trộm *  làm một cách vụng trộm",
  },
  {
    word: "vùng trời",
    part_of_speech: "danh từ",
    meaning:
      "phạm vi trên không thuộc chủ quyền của một nước: vùng trời tổ quốc * canh giữ vùng trời",
    example: "vùng trời tổ quốc * canh giữ vùng trời",
  },
  {
    word: "vung vãi",
    part_of_speech: "động từ",
    meaning:
      "rơi ra, vãi ra một cách bừa bãi (nói khái quát): gạo vung vãi khắp nhà * quần áo để vung vãi",
    example: "gạo vung vãi khắp nhà * quần áo để vung vãi",
  },
  {
    word: "vùng vằng",
    part_of_speech: "động từ",
    meaning:
      "từ gợi tả bộ điệu tỏ ra giận dỗi, không bằng lòng, bằng những động tác như vung tay vung chân, lúc lắc thân mình, v.v.: vùng vằng đòi về",
    example: "vùng vằng đòi về",
  },
  {
    word: "vụng về",
    part_of_speech: "tính từ",
    meaning: "tỏ ra vụng (nói khái quát): cử chỉ vụng về * nói năng vụng về",
    example: "cử chỉ vụng về * nói năng vụng về",
  },
  {
    word: "vung vít",
    part_of_speech: "tính từ",
    meaning: "lung tung, bừa bãi: chi tiêu vung vít * tức quá, nói vung vít",
    example: "chi tiêu vung vít * tức quá, nói vung vít",
  },
  {
    word: "vung vẩy",
    part_of_speech: "động từ",
    meaning:
      "đưa qua đưa lại liên tiếp một cách tự nhiên (thường nói về tay, chân): hai tay vung vẩy theo nhịp bước",
    example: "hai tay vung vẩy theo nhịp bước",
  },
  {
    word: "vuông",
    part_of_speech: "tính từ",
    meaning:
      "có bề mặt là một hình giống như hình vuông: khăn vuông * chia thành các ô vuông * vuông thành sắc cạnh (tng)",
    example: "khăn vuông * chia thành các ô vuông * vuông thành sắc cạnh (tng)",
  },
  {
    word: "vuông",
    part_of_speech: "tính từ",
    meaning:
      "từ dùng ghép sau danh từ tên đơn vị đo độ dài để tạo thành một tổ hợp tên đơn vị đo diện tích: kilomet vuông (km2) * mảnh đất gần trăm mét vuông",
    example: "kilomet vuông (km2) * mảnh đất gần trăm mét vuông",
  },
  {
    word: "vuông",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị dân gian dùng để đo vải, dùng phổ biến thời trước, bằng bề ngang (hoặc khổ) của tấm vải: một vuông vải",
    example: "một vuông vải",
  },
  {
    word: "vuông",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) vật có bề mặt giống như hình vuông: vuông cỏ * vuông đất * nhìn qua vuông cửa sổ",
    example: "vuông cỏ * vuông đất * nhìn qua vuông cửa sổ",
  },
  {
    word: "vùng vẫy",
    part_of_speech: "động từ",
    meaning:
      "vùng mạnh liên tiếp cho thoát khỏi tình trạng đang bị giữ chặt (nói khái quát): con cá vùng vẫy trong nước * cố sức vùng vẫy để thoát",
    example: "con cá vùng vẫy trong nước * cố sức vùng vẫy để thoát",
  },
  {
    word: "vùng vẫy",
    part_of_speech: "động từ",
    meaning: "như vẫy vùng: tha hồ vùng vẫy",
    example: "tha hồ vùng vẫy",
  },
  {
    word: "vùng ven",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) ngoại ô: xây dựng khu chung cư ở vùng ven",
    example: "xây dựng khu chung cư ở vùng ven",
  },
  {
    word: "vuông tròn",
    part_of_speech: "tính từ",
    meaning:
      '(cũ, văn chương) tốt đẹp về mọi mặt (thường nói về việc sinh đẻ hay việc tình duyên): "Trăm năm tính cuộc vuông tròn, Phải dò cho đến ngọn nguồn lạch sông." (TKiều)',
    example:
      'Trăm năm tính cuộc vuông tròn, Phải dò cho đến ngọn nguồn lạch sông." (TKiều)',
  },
  {
    word: "vuông vức",
    part_of_speech: "tính từ",
    meaning:
      "vuông, có góc cạnh đâu ra đấy: căn phòng vuông vức * tường xây vuông vức",
    example: "căn phòng vuông vức * tường xây vuông vức",
  },
  {
    word: "vuông vắn",
    part_of_speech: "tính từ",
    meaning:
      "vuông và trông đẹp mắt (nói khái quát): nhà cửa san sát, vuông vắn * những thửa ruộng vuông vắn như bàn cờ",
    example:
      "nhà cửa san sát, vuông vắn * những thửa ruộng vuông vắn như bàn cờ",
  },
  {
    word: "vuông vắn",
    part_of_speech: "tính từ",
    meaning:
      "có đường nét gãy góc, đều đặn và rõ ràng: gương mặt vuông vắn * nét chữ vuông vắn",
    example: "gương mặt vuông vắn * nét chữ vuông vắn",
  },
  {
    word: "vuốt mắt",
    part_of_speech: "động từ",
    meaning:
      "vuốt cho mắt của người vừa mới chết nhắm hẳn lại; thường để biểu thị sự vĩnh biệt người thân thiết: chết không người vuốt mắt",
    example: "chết không người vuốt mắt",
  },
  {
    word: "vuốt",
    part_of_speech: "danh từ",
    meaning: "móng nhọn, sắc và cong của một số loài vật như hổ, báo: vuốt hổ",
    example: "vuốt hổ",
  },
  {
    word: "vuốt",
    part_of_speech: "động từ",
    meaning:
      "áp lòng bàn tay lên vật gì và đưa nhẹ xuôi theo chiều thuận để cho thẳng, cho phẳng: vuốt má * ngồi vuốt râu * vuốt tóc",
    example: "vuốt má * ngồi vuốt râu * vuốt tóc",
  },
  {
    word: "vuốt",
    part_of_speech: "động từ",
    meaning: "(hiếm) như vuốt đuôi: cố nói vuốt một câu",
    example: "cố nói vuốt một câu",
  },
  {
    word: "vuốt mặt không kịp",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) không kịp nói gì, không kịp làm gì cho đỡ xấu hổ, mà đành phải chịu nhục: bị chửi đến vuốt mặt không kịp",
    example: "bị chửi đến vuốt mặt không kịp",
  },
  {
    word: "vuốt ve",
    part_of_speech: "động từ",
    meaning:
      "vuốt nhẹ nhiều lần để tỏ tình cảm yêu thương, trìu mến: người mẹ vuốt ve bàn tay con * vuốt ve mái tóc óng mượt",
    example: "người mẹ vuốt ve bàn tay con * vuốt ve mái tóc óng mượt",
  },
  {
    word: "vuốt ve",
    part_of_speech: "động từ",
    meaning:
      "bằng lời nói, việc làm tỏ vẻ quan tâm, thông cảm nhằm chiếm cảm tình hay lôi kéo, mua chuộc: giọng vuốt ve, mơn trớn * lời nói vuốt ve",
    example: "giọng vuốt ve, mơn trớn * lời nói vuốt ve",
  },
  {
    word: "vuốt đuôi",
    part_of_speech: "",
    meaning:
      "nói hoặc làm điều gì sau khi sự việc đã xong xuôi, tỏ ra mình cũng góp công sức vào hoặc để lấy lòng: nói vuốt đuôi",
    example: "nói vuốt đuôi",
  },
  {
    word: "vút",
    part_of_speech: "động từ",
    meaning:
      "di chuyển rất nhanh, thẳng một đường và như mất hút ngay: tên trộm vút ra khỏi cửa * tiếng sáo vút cao",
    example: "tên trộm vút ra khỏi cửa * tiếng sáo vút cao",
  },
  {
    word: "vút",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng phát ra như tiếng roi quất mạnh rít trong không khí: tiếng roi quật đánh vút một cái",
    example: "tiếng roi quật đánh vút một cái",
  },
  {
    word: "vút",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) như vụt (ng1): vút cho mấy roi",
    example: "vút cho mấy roi",
  },
  {
    word: "vụt",
    part_of_speech: "động từ",
    meaning:
      "dùng roi, gậy đánh bằng động tác rất nhanh, mạnh: vụt cho mấy roi",
    example: "vụt cho mấy roi",
  },
  {
    word: "vụt",
    part_of_speech: "động từ",
    meaning:
      "đập bóng, cầu bằng động tác rất nhanh và mạnh (trong bóng bàn, quần vợt, cầu lông, v.v.): kĩ thuật vụt bóng",
    example: "kĩ thuật vụt bóng",
  },
  {
    word: "vụt",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) quăng mạnh: vụt mấy trái lựu đạn",
    example: "vụt mấy trái lựu đạn",
  },
  {
    word: "vụt",
    part_of_speech: "động từ",
    meaning:
      "di chuyển rất nhanh và đột ngột, đến mức không nhìn rõ hình dạng: chạy vụt đi * đàn chim bay vụt lên",
    example: "chạy vụt đi * đàn chim bay vụt lên",
  },
  {
    word: "vụt",
    part_of_speech: "động từ",
    meaning:
      "từ biểu thị sự chuyển đổi trạng thái diễn ra rất nhanh và đột ngột: vụt đứng dậy * vụt nhớ ra * vụt nảy ra sáng kiến",
    example: "vụt đứng dậy * vụt nhớ ra * vụt nảy ra sáng kiến",
  },
  {
    word: "vừa",
    part_of_speech: "tính từ",
    meaning:
      "thuộc cỡ không lớn, nhưng không phải cỡ nhỏ, hoặc ở mức độ không cao, không nhiều, nhưng không phải mức độ thấp, ít: nhà máy loại vừa * áo cỡ vừa * nó cũng chẳng phải tay vừa",
    example: "nhà máy loại vừa * áo cỡ vừa * nó cũng chẳng phải tay vừa",
  },
  {
    word: "vừa",
    part_of_speech: "tính từ",
    meaning:
      "khớp, đúng, hợp với, về mặt kích thước, khả năng, thời gian, v.v.: dép đi không vừa chân * việc ấy vừa sức anh ta * chuẩn bị dần đi là vừa",
    example:
      "dép đi không vừa chân * việc ấy vừa sức anh ta * chuẩn bị dần đi là vừa",
  },
  {
    word: "vừa",
    part_of_speech: "tính từ",
    meaning:
      "ở mức đủ để thoả mãn được yêu cầu: bao nhiêu cũng không vừa * mang vừa thôi, không ai xách được đâu!",
    example:
      "bao nhiêu cũng không vừa * mang vừa thôi, không ai xách được đâu!",
  },
  {
    word: "vừa",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị sự việc xảy ra liền ngay trước thời điểm sự việc vừa được nói đến, thường là chỉ trước một thời gian ngắn, coi như không đáng kể: trời vừa sáng * vừa ăn cơm xong * chuyện vừa xảy ra hôm qua",
    example: "trời vừa sáng * vừa ăn cơm xong * chuyện vừa xảy ra hôm qua",
  },
  {
    word: "vữa",
    part_of_speech: "danh từ",
    meaning:
      "hỗn hợp chất kết dính của vôi, xi măng, thạch cao, v.v. với cát và nước để xây, trát: trộn vữa",
    example: "trộn vữa",
  },
  {
    word: "vữa",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái không còn dẻo, quánh nữa, mà bị rời ra và chảy nước do bị biến chất, bị phân huỷ: bát cơm để vữa ra * hồ dán bị vữa",
    example: "bát cơm để vữa ra * hồ dán bị vữa",
  },
  {
    word: "vụt một cái",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) thình lình và một cách rất nhanh (đã diễn ra sự biến đổi): vụt một cái đã biến đâu mất",
    example: "vụt một cái đã biến đâu mất",
  },
  {
    word: "vựa",
    part_of_speech: "danh từ",
    meaning: "nơi được quây kín để cất trữ thóc lúa: vựa thóc",
    example: "vựa thóc",
  },
  {
    word: "vựa",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) nơi cất chứa một số sản phẩm để bán dần, ở một số vùng nông thôn Nam Bộ Việt Nam: vựa cá * vựa than * làm chủ một vựa gạo",
    example: "vựa cá * vựa than * làm chủ một vựa gạo",
  },
  {
    word: "vừa mắt",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) ưng ý khi nhìn thấy: chiếc áo trông rất vừa mắt",
    example: "chiếc áo trông rất vừa mắt",
  },
  {
    word: "vừa lòng",
    part_of_speech: "động từ",
    meaning:
      'cảm thấy bằng lòng vì hợp với ý của mình: làm vừa lòng cha mẹ * "Lời nói chẳng mất tiền mua, Liệu lời mà nói cho vừa lòng nhau." (ca dao)',
    example:
      'làm vừa lòng cha mẹ * "Lời nói chẳng mất tiền mua, Liệu lời mà nói cho vừa lòng nhau." (ca dao)',
  },
  {
    word: "vựa lúa",
    part_of_speech: "danh từ",
    meaning:
      "vùng sản xuất ra nhiều thóc gạo: đồng bằng sông Cửu Long là vựa lúa của cả nước",
    example: "đồng bằng sông Cửu Long là vựa lúa của cả nước",
  },
  {
    word: "vừa mồm",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) không nhiều lời, quá lời: vừa mồm thôi, kẻo mang vạ vào thân",
    example: "vừa mồm thôi, kẻo mang vạ vào thân",
  },
  {
    word: "vừa miệng",
    part_of_speech: "tính từ",
    meaning:
      "(thức ăn) có vị đúng mức, không nhạt quá, cũng không mặn quá hoặc ngọt quá: nêm thêm chút gia vị cho vừa miệng",
    example: "nêm thêm chút gia vị cho vừa miệng",
  },
  {
    word: "vừa qua",
    part_of_speech: "",
    meaning:
      "trước lúc nói một khoảng thời gian đại khái nào đó gần với thời điểm hiện tại: mấy ngày vừa qua * vừa qua phải nằm viện mất một tuần",
    example: "mấy ngày vừa qua * vừa qua phải nằm viện mất một tuần",
  },
  {
    word: "vừa mới",
    part_of_speech: "phụ từ",
    meaning:
      "ngay trước đây (hoặc trước đấy) không lâu: nó vừa mới đi xong * chuyện vừa mới đây, chứ lâu la gì",
    example: "nó vừa mới đi xong * chuyện vừa mới đây, chứ lâu la gì",
  },
  {
    word: "vừa nãy",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) vừa mới rồi, ban nãy: vừa nãy tôi nói lỡ lời, xin bác đừng giận",
    example: "vừa nãy tôi nói lỡ lời, xin bác đừng giận",
  },
  {
    word: "vừa rồi",
    part_of_speech: "",
    meaning:
      "vừa mới gần đây thôi: tuần vừa rồi * lần gặp vừa rồi, trông nó vẫn khoẻ",
    example: "tuần vừa rồi * lần gặp vừa rồi, trông nó vẫn khoẻ",
  },
  {
    word: "vừa phải",
    part_of_speech: "tính từ",
    meaning:
      "ở mức thoả đáng, hợp lí: quan tâm vừa phải * giữ khoảng cách vừa phải",
    example: "quan tâm vừa phải * giữ khoảng cách vừa phải",
  },
  {
    word: "vừa ý",
    part_of_speech: "tính từ",
    meaning:
      "đúng với ý muốn, với yêu cầu của mình: chọn mãi mới được cái áo vừa ý * có mấy cũng không vừa ý",
    example: "chọn mãi mới được cái áo vừa ý * có mấy cũng không vừa ý",
  },
  {
    word: "vừa vặn",
    part_of_speech: "tính từ",
    meaning: "vừa khớp, vừa đúng: áo mặc vừa vặn * số tiền còn vừa vặn để mua",
    example: "áo mặc vừa vặn * số tiền còn vừa vặn để mua",
  },
  {
    word: "vực",
    part_of_speech: "danh từ",
    meaning: "chỗ nước sâu nhất ở sông, hồ hoặc biển.",
    example: "rơi xuống vực sâu * đứng bên bờ vực thẳm",
  },
  {
    word: "vực",
    part_of_speech: "danh từ",
    meaning:
      "lượng đựng vừa đầy đến miệng đồ đong: một vực bò gạo * chỉ ăn được hai vực cơm",
    example: "một vực bò gạo * chỉ ăn được hai vực cơm",
  },
  {
    word: "vực",
    part_of_speech: "động từ",
    meaning: "nâng, đỡ cho ngồi dậy, đứng dậy: vực người ốm dậy",
    example: "vực người ốm dậy",
  },
  {
    word: "vực",
    part_of_speech: "động từ",
    meaning:
      "giúp đỡ cho vượt qua tình trạng yếu kém để vươn lên: có thực mới vực được đạo * quan tâm để vực những học sinh yếu",
    example: "có thực mới vực được đạo * quan tâm để vực những học sinh yếu",
  },
  {
    word: "vực",
    part_of_speech: "động từ",
    meaning:
      "tập, luyện cho con vật còn non hoặc chưa quen biết làm việc: vực nghé * vực cho trâu bò cày",
    example: "vực nghé * vực cho trâu bò cày",
  },
  {
    word: "vững bền",
    part_of_speech: "tính từ",
    meaning: "như bền vững: cơ nghiệp vững bền",
    example: "cơ nghiệp vững bền",
  },
  {
    word: "vừng",
    part_of_speech: "danh từ",
    meaning:
      "cây hoa màu trắng, quả có khía, khi chín tự nứt ra, hạt nhỏ màu đen hoặc trắng, chứa nhiều dầu, dùng để ăn: dầu vừng * hoa vừng",
    example: "dầu vừng * hoa vừng",
  },
  {
    word: "vững chãi",
    part_of_speech: "tính từ",
    meaning:
      "có khả năng chịu những tác động mạnh từ bên ngoài mà không lung lay, đổ ngã: bức tường thành vững chãi",
    example: "bức tường thành vững chãi",
  },
  {
    word: "vững",
    part_of_speech: "tính từ",
    meaning:
      "có khả năng giữ nguyên vị trí trên một mặt nền hoặc giữ nguyên tư thế, khó bị lung lay, bị ngã, bị đổ: em bé đi đã vững * tay lái chưa vững",
    example: "em bé đi đã vững * tay lái chưa vững",
  },
  {
    word: "vững",
    part_of_speech: "tính từ",
    meaning:
      'có khả năng chịu những tác động bất lợi từ bên ngoài mà vẫn giữ nguyên trạng thái, không suy yếu, không biến đổi, không mất đi: "Dù ai nói ngả nói nghiêng, Lòng ta vẫn vững như kiềng ba chân." (ca dao)',
    example:
      'Dù ai nói ngả nói nghiêng, Lòng ta vẫn vững như kiềng ba chân." (ca dao)',
  },
  {
    word: "vững",
    part_of_speech: "tính từ",
    meaning:
      "có khả năng đương đầu với những hoàn cảnh bất lợi để thực hiện như bình thường nhiệm vụ, chức năng của mình: vững tay lái * tay nghề chưa vững * kèm cho cháu bé học thật vững",
    example:
      "vững tay lái * tay nghề chưa vững * kèm cho cháu bé học thật vững",
  },
  {
    word: "vững dạ",
    part_of_speech: "tính từ",
    meaning:
      "cảm thấy có được chỗ dựa để không có gì phải lo sợ, mặc dù có nguy hiểm: thấy anh bình tĩnh, tôi cũng vững dạ hơn",
    example: "thấy anh bình tĩnh, tôi cũng vững dạ hơn",
  },
  {
    word: "vững mạnh",
    part_of_speech: "tính từ",
    meaning:
      "có khả năng chịu đựng mọi thử thách và phát huy tác dụng một cách mạnh mẽ: nền kinh tế vững mạnh * xây dựng đơn vị vững mạnh toàn diện",
    example: "nền kinh tế vững mạnh * xây dựng đơn vị vững mạnh toàn diện",
  },
  {
    word: "vững chắc",
    part_of_speech: "tính từ",
    meaning:
      "có khả năng chịu tác động mạnh từ bên ngoài mà vẫn giữ nguyên được trạng thái, tính chất, không bị phá huỷ, đổ vỡ: bức tường xây vững chắc * chỗ dựa vững chắc",
    example: "bức tường xây vững chắc * chỗ dựa vững chắc",
  },
  {
    word: "vững tâm",
    part_of_speech: "tính từ",
    meaning:
      'cảm thấy có được chỗ dựa, có được điều kiện để yên tâm, không có gì phải lo ngại, mặc dù có khó khăn, nguy hiểm: vững tâm chờ đợi * "Chuyện gì mình cũng có lường tính trước thì tới lúc xảy ra mình vẫn vững tâm hơn." (AĐức; 16)',
    example:
      'vững tâm chờ đợi * "Chuyện gì mình cũng có lường tính trước thì tới lúc xảy ra mình vẫn vững tâm hơn." (AĐức; 16)',
  },
  {
    word: "vững vàng",
    part_of_speech: "tính từ",
    meaning:
      "có khả năng đứng vững trước mọi thử thách, mọi tác động bất lợi từ bên ngoài (nói khái quát): ngồi rất vững vàng * lập trường vững vàng * vững vàng vượt qua mọi khó khăn",
    example:
      "ngồi rất vững vàng * lập trường vững vàng * vững vàng vượt qua mọi khó khăn",
  },
  {
    word: "vườn",
    part_of_speech: "danh từ",
    meaning:
      "khu đất thường ở sát cạnh nhà, được rào kín xung quanh để trồng rau, hoa hay cây ăn quả: mảnh vườn * vườn hoa",
    example: "mảnh vườn * vườn hoa",
  },
  {
    word: "vườn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (người làm một nghề nào đó) không chuyên nghiệp và ở nông thôn (thường hàm ý chê, coi thường): thợ vườn * ông lang vườn",
    example: "thợ vườn * ông lang vườn",
  },
  {
    word: "vươn",
    part_of_speech: "động từ",
    meaning:
      "tự làm cho thân thể hoặc một bộ phận thân thể dãn dài ra: vươn vai hít thở * cố vươn tay ra với",
    example: "vươn vai hít thở * cố vươn tay ra với",
  },
  {
    word: "vươn",
    part_of_speech: "động từ",
    meaning:
      "phát triển dài theo một hướng nào đó: ống khói nhà máy vươn cao * con đường cứ ngày một vươn dài",
    example: "ống khói nhà máy vươn cao * con đường cứ ngày một vươn dài",
  },
  {
    word: "vươn",
    part_of_speech: "động từ",
    meaning:
      "cố gắng tiến tới, đạt tới cái tốt hơn, đẹp hơn: vươn tới đỉnh cao của khoa học * vươn lên dẫn đầu phong trào",
    example: "vươn tới đỉnh cao của khoa học * vươn lên dẫn đầu phong trào",
  },
  {
    word: "vượn",
    part_of_speech: "danh từ",
    meaning:
      "loài linh trưởng có hình dạng giống như người, không có đuôi, hai chi trước rất dài, sống chủ yếu ở rừng núi cao, rất sợ nước, có tiếng kêu vang và thánh thót, nghe như hót: chim kêu vượn hót",
    example: "chim kêu vượn hót",
  },
  {
    word: "vươn mình",
    part_of_speech: "động từ",
    meaning:
      "(văn chương) chuyển mình vươn lên với khí thế mạnh mẽ: nhân dân vươn mình chống quân xâm lược",
    example: "nhân dân vươn mình chống quân xâm lược",
  },
  {
    word: "vườn tược",
    part_of_speech: "danh từ",
    meaning: "vườn riêng của gia đình (nói khái quát): chăm nom vườn tược",
    example: "chăm nom vườn tược",
  },
  {
    word: "vương giả",
    part_of_speech: "danh từ",
    meaning: "(cũ) người làm vua: bậc vương giả",
    example: "bậc vương giả",
  },
  {
    word: "vương giả",
    part_of_speech: "tính từ",
    meaning:
      "có đời sống vật chất sung sướng, giàu sang như vua chúa: cuộc sống vương giả * nhà ấy thuộc loại vương giả nhất vùng",
    example: "cuộc sống vương giả * nhà ấy thuộc loại vương giả nhất vùng",
  },
  {
    word: "vượng",
    part_of_speech: "động từ",
    meaning:
      "ở trạng thái đang phát triển theo hướng đi lên, mạnh lên: làm ăn đang thời kì vượng * sức đã vượng lên",
    example: "làm ăn đang thời kì vượng * sức đã vượng lên",
  },
  {
    word: "vướng",
    part_of_speech: "động từ",
    meaning:
      "bị cái gì đó cản lại, giữ lại, khiến cho không hoạt động dễ dàng, tự do được như bình thường: vướng phải dây * bụi vào mắt nên hơi vướng",
    example: "vướng phải dây * bụi vào mắt nên hơi vướng",
  },
  {
    word: "vương bá",
    part_of_speech: "danh từ",
    meaning: "(cũ, hiếm) như vương hầu: dựng nghiệp vương bá",
    example: "dựng nghiệp vương bá",
  },
  {
    word: "vướng bận",
    part_of_speech: "động từ",
    meaning: "vướng víu, bận bịu (nói khái quát): vướng bận chuyện gia đình",
    example: "vướng bận chuyện gia đình",
  },
  {
    word: "vượng khí",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) khí đất tốt, mang lại nhiều may mắn về danh hay lợi, theo thuật địa lí: vượng khí của non sông",
    example: "vượng khí của non sông",
  },
  {
    word: "vương",
    part_of_speech: "danh từ",
    meaning: "(Từ cũ) vua: xưng vương",
    example: "xưng vương",
  },
  {
    word: "vương",
    part_of_speech: "danh từ",
    meaning:
      "tước, chỉ phong cho người trong hoàng tộc hoặc vua chư hầu có công lớn, có quyền lực sau vua, thời phong kiến: phong tước vương",
    example: "phong tước vương",
  },
  {
    word: "vương",
    part_of_speech: "động từ",
    meaning:
      "mắc vào, dính vào: nhện vương tơ * bỏ thì thương, vương thì tội (tng)",
    example: "nhện vương tơ * bỏ thì thương, vương thì tội (tng)",
  },
  {
    word: "vương",
    part_of_speech: "động từ",
    meaning:
      "(Văn chương) còn rơi rớt lại một ít: vẻ buồn còn vương trên nét mặt",
    example: "vẻ buồn còn vương trên nét mặt",
  },
  {
    word: "vương",
    part_of_speech: "động từ",
    meaning:
      "rơi vãi ra mỗi nơi một ít: cỏ rác vương đầy lối đi * mực vương ra vở",
    example: "cỏ rác vương đầy lối đi * mực vương ra vở",
  },
  {
    word: "vướng mắc",
    part_of_speech: "động từ",
    meaning:
      "bị cái gì đó cản trở trong quá trình hoạt động (nói khái quát): vướng mắc chuyện gia đình",
    example: "vướng mắc chuyện gia đình",
  },
  {
    word: "vướng mắc",
    part_of_speech: "danh từ",
    meaning:
      "điều làm cho phải băn khoăn, suy nghĩ, tư tưởng không thoải mái: còn nhiều vướng mắc chưa giải quyết",
    example: "còn nhiều vướng mắc chưa giải quyết",
  },
  {
    word: "vương quốc",
    part_of_speech: "danh từ",
    meaning:
      "nước có người đứng đầu là vua: vương quốc Anh * vương quốc Thái Lan",
    example: "vương quốc Anh * vương quốc Thái Lan",
  },
  {
    word: "vương quốc",
    part_of_speech: "danh từ",
    meaning:
      "nơi được coi là nằm dưới sự ngự trị, chi phối của một cá nhân, một tổ chức hay một mặt hoạt động nào đó: vương quốc của cà phê * vương quốc của trí tưởng tượng",
    example: "vương quốc của cà phê * vương quốc của trí tưởng tượng",
  },
  {
    word: "vương triều",
    part_of_speech: "danh từ",
    meaning:
      "triều đại hoặc triều đình: vương triều nhà Hán * vương triều sụp đổ",
    example: "vương triều nhà Hán * vương triều sụp đổ",
  },
  {
    word: "vương quyền",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) quyền hành của nhà vua, quyền hành nằm trong tay vua: rồng là con vật tượng trưng cho vương quyền",
    example: "rồng là con vật tượng trưng cho vương quyền",
  },
  {
    word: "vương tôn",
    part_of_speech: "danh từ",
    meaning: "(cũ) con cháu nhà quyền quý thời phong kiến: vương tôn công tử",
    example: "vương tôn công tử",
  },
  {
    word: "vương tướng",
    part_of_speech: "danh từ",
    meaning:
      "vương và tướng, những chức tước cao nhất trong triều đình phong kiến (nói khái quát); thường dùng trong khẩu ngữ để chỉ sự nghiệp lớn, chức vụ cao (hàm ý mỉa mai): chẳng làm nên vương tướng gì",
    example: "chẳng làm nên vương tướng gì",
  },
  {
    word: "vương vấn",
    part_of_speech: "động từ",
    meaning:
      "thường cứ phải nghĩ đến, nhớ đến, ngay cả khi đang làm những việc khác, không thể dứt đi được: tơ lòng vương vấn * chẳng có gì vương vấn",
    example: "tơ lòng vương vấn * chẳng có gì vương vấn",
  },
  {
    word: "vương miện",
    part_of_speech: "danh từ",
    meaning: "mũ của vua.",
    example: "đoạt vương miện hoa hậu",
  },
  {
    word: "vướng vất",
    part_of_speech: "động từ",
    meaning:
      "cảm thấy như có điều gì còn vướng mắc, làm cho phải bận tâm: cứ thấy vướng vất vì cách giải quyết chưa thật ổn thoả",
    example: "cứ thấy vướng vất vì cách giải quyết chưa thật ổn thoả",
  },
  {
    word: "vương vất",
    part_of_speech: "động từ",
    meaning:
      "vương lại chút ít, chưa mất hẳn, làm cho phải bận tâm: mùi nước hoa vương vất đâu đây",
    example: "mùi nước hoa vương vất đâu đây",
  },
  {
    word: "vương vãi",
    part_of_speech: "động từ",
    meaning:
      "rơi rải rác mỗi nơi một ít (nói khái quát): thức ăn vương vãi trên bàn * nhặt những hạt thóc vương vãi",
    example: "thức ăn vương vãi trên bàn * nhặt những hạt thóc vương vãi",
  },
  {
    word: "vương vít",
    part_of_speech: "động từ",
    meaning: "(hiếm) như vương vấn: tơ duyên vương vít",
    example: "tơ duyên vương vít",
  },
  {
    word: "vương víu",
    part_of_speech: "động từ",
    meaning:
      "vướng nhiều chỗ rất khó gỡ, khó dứt, làm cho hoạt động bị cản trở (nói khái quát): vương víu nợ nần",
    example: "vương víu nợ nần",
  },
  {
    word: "vướng víu",
    part_of_speech: "động từ",
    meaning:
      "vướng nhiều, làm cản trở (nói khái quát): dây dợ lằng nhằng, vướng víu * con cái vướng víu, không đi đâu được",
    example:
      "dây dợ lằng nhằng, vướng víu * con cái vướng víu, không đi đâu được",
  },
  {
    word: "vượt",
    part_of_speech: "động từ",
    meaning:
      "di chuyển qua nơi có khó khăn, trở ngại để đến một nơi khác: trèo đèo vượt suối * vượt sông * học sinh nghèo vượt khó",
    example: "trèo đèo vượt suối * vượt sông * học sinh nghèo vượt khó",
  },
  {
    word: "vượt",
    part_of_speech: "động từ",
    meaning:
      "tiến nhanh hơn và bỏ lại phía sau: đi vượt lên trước * phóng nhanh vượt ẩu * tăng tốc để vượt xe trước",
    example:
      "đi vượt lên trước * phóng nhanh vượt ẩu * tăng tốc để vượt xe trước",
  },
  {
    word: "vượt",
    part_of_speech: "động từ",
    meaning:
      "ra khỏi giới hạn nào đó: vượt chỉ tiêu * không dám làm vượt quyền hạn * vấn đề vượt ngoài tầm kiểm soát",
    example:
      "vượt chỉ tiêu * không dám làm vượt quyền hạn * vấn đề vượt ngoài tầm kiểm soát",
  },
  {
    word: "vượt bậc",
    part_of_speech: "động từ",
    meaning:
      "bỏ qua bậc thông thường để tiến tới bậc cao hơn hẳn: tiến bộ vượt bậc * nền kinh tế tăng trưởng vượt bậc",
    example: "tiến bộ vượt bậc * nền kinh tế tăng trưởng vượt bậc",
  },
  {
    word: "vượt ngục",
    part_of_speech: "động từ",
    meaning: "(tù nhân) trốn khỏi nhà tù: tù vượt ngục",
    example: "tù vượt ngục",
  },
  {
    word: "vượt tuyến",
    part_of_speech: "động từ",
    meaning:
      "bỏ qua, vượt qua cấp độ, phạm vi hoạt động: bệnh nhân được chuyển vượt tuyến lên bệnh viện trung ương * đường chuyền vượt tuyến (trong bóng đá)",
    example:
      "bệnh nhân được chuyển vượt tuyến lên bệnh viện trung ương * đường chuyền vượt tuyến (trong bóng đá)",
  },
  {
    word: "vượt cấp",
    part_of_speech: "động từ",
    meaning:
      "bỏ qua các bậc thông thường, đưa lên cấp cao hơn: được thăng chức vượt cấp * kiến nghị vượt cấp",
    example: "được thăng chức vượt cấp * kiến nghị vượt cấp",
  },
  {
    word: "x",
    part_of_speech: "",
    meaning:
      "kí hiệu của ẩn số trong đại số.  xem (viết tắt; dùng trong các lời ghi chú, trích dẫn).",
    example: "ông X * chuyện xảy ra ở xí nghiệp X",
  },
  {
    word: "vượt trội",
    part_of_speech: "động từ",
    meaning:
      "trội hẳn lên, vượt hẳn lên mức bình thường: chi phí vượt trội * thành tích vượt trội",
    example: "chi phí vượt trội * thành tích vượt trội",
  },
  {
    word: "vứt",
    part_of_speech: "động từ",
    meaning:
      "ném đi vì cho là không còn giá trị, không còn tác dụng: vứt vào sọt rác * vứt cái cũ đi để mua cái mới * coi như đồ vứt đi",
    example:
      "vứt vào sọt rác * vứt cái cũ đi để mua cái mới * coi như đồ vứt đi",
  },
  {
    word: "vứt",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) để bừa, để vội vào bất kì đâu, không chú ý giữ gìn: sách vở vứt lung tung * quần áo vứt mỗi nơi một chiếc",
    example: "sách vở vứt lung tung * quần áo vứt mỗi nơi một chiếc",
  },
  {
    word: "xã",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị hành chính cơ sở ở nông thôn, bao gồm một số thôn: chủ tịch xã * xã này có bốn thôn",
    example: "chủ tịch xã * xã này có bốn thôn",
  },
  {
    word: "xả",
    part_of_speech: "động từ",
    meaning:
      "thải hơi hoặc nước ra ngoài: xả bớt hơi trong nồi áp suất * xả nước để thau bể",
    example: "xả bớt hơi trong nồi áp suất * xả nước để thau bể",
  },
  {
    word: "xả",
    part_of_speech: "động từ",
    meaning:
      "làm cho tuôn mạnh ra với khối lượng lớn: xả một loạt hết cả băng đạn * xả stress",
    example: "xả một loạt hết cả băng đạn * xả stress",
  },
  {
    word: "xả",
    part_of_speech: "động từ",
    meaning: "chặt, chém cho đứt ra thành mảng lớn: xả thịt * chém xả cánh tay",
    example: "xả thịt * chém xả cánh tay",
  },
  {
    word: "xả",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) làm cho sạch bằng cách giũ trong nước hoặc cho dòng nước mạnh chảy qua: xả quần áo * xả nước vào người",
    example: "xả quần áo * xả nước vào người",
  },
  {
    word: "x-quang",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) tia X: chụp X-quang",
    example: "chụp X-quang",
  },
  {
    word: "xà bần",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ, khẩu ngữ) đồ phế thải như gạch ngói, vôi vữa, v.v. từ các công trình xây dựng (nói khái quát): thu dọn các đống xà bần",
    example: "thu dọn các đống xà bần",
  },
  {
    word: "xa",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ thô sơ quay bằng tay, dùng để kéo sợi, đánh ống, đánh suốt: quay xa * lật đật như xa vật ống vải (tng)",
    example: "quay xa * lật đật như xa vật ống vải (tng)",
  },
  {
    word: "xa",
    part_of_speech: "tính từ",
    meaning:
      'ở một khoảng cách tương đối lớn, trong không gian hoặc thời gian: đường xa * đi làm ăn xa * một ngày không xa * "Dầu xa nhích lại cho gần, Làm thân con nhện mấy lần vương tơ." (Cdao)',
    example:
      'đường xa * đi làm ăn xa * một ngày không xa * "Dầu xa nhích lại cho gần, Làm thân con nhện mấy lần vương tơ." (Cdao)',
  },
  {
    word: "xa",
    part_of_speech: "tính từ",
    meaning:
      "có sự chênh lệch tương đối lớn về chất lượng, mức độ, v.v.: công danh ngày một tiến xa * hai người khác xa nhau * về sắc đẹp, nó còn kém xa chị nó",
    example:
      "công danh ngày một tiến xa * hai người khác xa nhau * về sắc đẹp, nó còn kém xa chị nó",
  },
  {
    word: "xa",
    part_of_speech: "tính từ",
    meaning:
      "hướng về những sự việc còn lâu mới xảy ra: tính hay lo xa * nhìn xa trông rộng",
    example: "tính hay lo xa * nhìn xa trông rộng",
  },
  {
    word: "xa",
    part_of_speech: "tính từ",
    meaning:
      "có quan hệ họ hàng phải ngược lên nhiều đời mới xác định được: bà con xa * hai người có họ xa với nhau",
    example: "bà con xa * hai người có họ xa với nhau",
  },
  {
    word: "xa",
    part_of_speech: "động từ",
    meaning:
      'rời khỏi để đi xa, không còn được gần gũi nữa: xa quê hương * "Chim xa rừng thương cây nhớ cội, Người xa người tội lắm người ơi!" (Cdao)',
    example:
      'xa quê hương * "Chim xa rừng thương cây nhớ cội, Người xa người tội lắm người ơi!" (Cdao)',
  },
  {
    word: "xá",
    part_of_speech: "động từ",
    meaning:
      "tha cho, miễn cho, không bắt phải chịu: xá tội * cháu trót dại, mong cụ xá cho!",
    example: "xá tội * cháu trót dại, mong cụ xá cho!",
  },
  {
    word: "xạ",
    part_of_speech: "danh từ",
    meaning: "xạ hương (nói tắt): túi xạ",
    example: "túi xạ",
  },
  {
    word: "xà",
    part_of_speech: "danh từ",
    meaning:
      "thanh vật liệu cứng, chắc, có kích thước nhỏ hơn rầm, đặt ngang trên một số điểm tựa để đỡ các bộ phận bên trên của công trình xây dựng: xà nhà",
    example: "xà nhà",
  },
  {
    word: "xà",
    part_of_speech: "danh từ",
    meaning: "xà đơn, xà kép, hoặc xà lệch (nói tắt): tập xà * lên xà",
    example: "tập xà * lên xà",
  },
  {
    word: "xà bông",
    part_of_speech: "danh từ",
    meaning: "(Nam) xà phòng: cục xà bông * rửa tay bằng xà bông",
    example: "cục xà bông * rửa tay bằng xà bông",
  },
  {
    word: "xa cách",
    part_of_speech: "động từ",
    meaning:
      "ở cách xa nhau hoàn toàn, không có sự liên lạc gì với nhau: gặp lại nhau sau bao ngày xa cách",
    example: "gặp lại nhau sau bao ngày xa cách",
  },
  {
    word: "xa cách",
    part_of_speech: "động từ",
    meaning:
      "tách biệt, không có sự gần gũi, hoà nhập: quan hệ giữa hai người không còn xa cách nữa",
    example: "quan hệ giữa hai người không còn xa cách nữa",
  },
  {
    word: "xà cạp",
    part_of_speech: "danh từ",
    meaning:
      "miếng vải dài dùng quấn quanh ống chân hay quấn ngoài ống quần cho gọn và tránh xây xát khi làm việc chân tay: chân quấn xà cạp",
    example: "chân quấn xà cạp",
  },
  {
    word: "xa gần",
    part_of_speech: "tính từ",
    meaning:
      'như gần xa: "Sự lòng ngỏ với băng nhân, Tin sương đồn đại xa gần xôn xao." (TKiều)',
    example:
      'Sự lòng ngỏ với băng nhân, Tin sương đồn đại xa gần xôn xao." (TKiều)',
  },
  {
    word: "xả đông",
    part_of_speech: "động từ",
    meaning:
      "làm cho thực phẩm không còn ở trạng thái bị đông cứng (do được bảo quản ở nhiệt độ thấp): xả đông thực phẩm trước khi chế biến",
    example: "xả đông thực phẩm trước khi chế biến",
  },
  {
    word: "xa chạy cao bay",
    part_of_speech: "",
    meaning:
      'như cao chạy xa bay: "Liệu mà xa chạy cao bay, ái ân ta có ngần này mà thôi!" (TKiều)',
    example: 'Liệu mà xa chạy cao bay, ái ân ta có ngần này mà thôi!" (TKiều)',
  },
  {
    word: "xà cừ",
    part_of_speech: "danh từ",
    meaning:
      "cây gỗ to cùng họ với xoan, lá kép lông chim, quả tròn, hạt có cánh, gỗ màu nâu đỏ, rắn, thớ xoắn, thường dùng để đóng thuyền và làm gỗ dán: gỗ xà cừ",
    example: "gỗ xà cừ",
  },
  {
    word: "xà cừ",
    part_of_speech: "danh từ",
    meaning: "lớp có màu sắc óng ánh ở mặt trong vỏ con trai: tủ khảm xà cừ",
    example: "tủ khảm xà cừ",
  },
  {
    word: "xa giá",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, trang trọng) xe của vua đi; cũng dùng để chỉ nhà vua khi đi lại bằng xe ở ngoài cung: bảo vệ xa giá * theo hầu xa giá",
    example: "bảo vệ xa giá * theo hầu xa giá",
  },
  {
    word: "xã giao",
    part_of_speech: "danh từ",
    meaning: "sự giao tiếp bình thường trong xã hội: giữ đúng phép xã giao",
    example: "giữ đúng phép xã giao",
  },
  {
    word: "xã giao",
    part_of_speech: "động từ",
    meaning:
      "giao tiếp bình thường giữa người với người trong xã hội: người kém xã giao * giỏi xã giao",
    example: "người kém xã giao * giỏi xã giao",
  },
  {
    word: "xã giao",
    part_of_speech: "tính từ",
    meaning:
      "chỉ có tính chất lịch sự theo phép xã giao: cười xã giao * hỏi một câu xã giao",
    example: "cười xã giao * hỏi một câu xã giao",
  },
  {
    word: "xã hội hoá",
    part_of_speech: "động từ",
    meaning:
      "làm cho trở thành của chung của xã hội: xã hội hoá tư liệu sản xuất",
    example: "xã hội hoá tư liệu sản xuất",
  },
  {
    word: "xã hội hoá",
    part_of_speech: "động từ",
    meaning:
      "làm cho trở thành sự nghiệp chung của xã hội: đẩy mạnh xã hội hoá nền giáo dục",
    example: "đẩy mạnh xã hội hoá nền giáo dục",
  },
  {
    word: "xã hội chủ nghĩa",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) chủ nghĩa xã hội, một phương pháp điều hành nhà nước dựa trên lợi ích của đa số nhân dân, chủ nghĩa xã hội bao gồm chủ nghĩa xã hội thực chất và chủ nghĩa xã hội hình thức.: xây dựng xã hội chủ nghĩa",
    example: "xây dựng xã hội chủ nghĩa",
  },
  {
    word: "xã hội chủ nghĩa",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về chủ nghĩa xã hội, có tính chất của chủ nghĩa xã hội: nước xã hội chủ nghĩa",
    example: "nước xã hội chủ nghĩa",
  },
  {
    word: "xã hội đen",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp những kẻ chuyên làm những việc phi pháp như trộm cướp, buôn lậu, đâm thuê chém mướn, v.v., hoạt động có tổ chức theo băng đảng, phe phái và luật lệ riêng: dân xã hội đen * triệt phá một băng xã hội đen",
    example: "dân xã hội đen * triệt phá một băng xã hội đen",
  },
  {
    word: "xa hoa",
    part_of_speech: "tính từ",
    meaning:
      "quá sang trọng và có tính chất phô trương một cách hoang phí: ăn mặc xa hoa * lối sống xa hoa",
    example: "ăn mặc xa hoa * lối sống xa hoa",
  },
  {
    word: "xã hội",
    part_of_speech: "danh từ",
    meaning:
      "hình thức sinh hoạt chung có tổ chức của loài người ở một trình độ phát triển nhất định, được hình thành trong quá trình lịch sử: xã hội tư bản * cải tạo xã hội * quy luật phát triển của xã hội",
    example: "xã hội tư bản * cải tạo xã hội * quy luật phát triển của xã hội",
  },
  {
    word: "xã hội",
    part_of_speech: "danh từ",
    meaning:
      "đông đảo những người cùng sống một thời (nói tổng quát): dư luận xã hội * tệ nạn xã hội * bị xã hội chê cười",
    example: "dư luận xã hội * tệ nạn xã hội * bị xã hội chê cười",
  },
  {
    word: "xã hội",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp người có địa vị kinh tế - chính trị cùng những lợi ích, hình thức sinh hoạt như nhau: xã hội thượng lưu * phân chia đẳng cấp xã hội",
    example: "xã hội thượng lưu * phân chia đẳng cấp xã hội",
  },
  {
    word: "xả hơi",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nghỉ không làm việc để đỡ căng thẳng và lấy lại sức: nghỉ xả hơi",
    example: "nghỉ xả hơi",
  },
  {
    word: "xã hội học",
    part_of_speech: "danh từ",
    meaning:
      "khoa học nghiên cứu về quá trình và quy luật phát triển của các hiện tượng trong đời sống xã hội: nghiên cứu xã hội học",
    example: "nghiên cứu xã hội học",
  },
  {
    word: "xa lạ",
    part_of_speech: "tính từ",
    meaning:
      "không hề quen, chưa từng biết đến: người quen chứ chẳng phải ai xa lạ",
    example: "người quen chứ chẳng phải ai xa lạ",
  },
  {
    word: "xa lạ",
    part_of_speech: "tính từ",
    meaning:
      "hoàn toàn không thích hợp, vì trái với bản chất: một luận điệu xa lạ * nếp sống xa lạ",
    example: "một luận điệu xa lạ * nếp sống xa lạ",
  },
  {
    word: "xa khơi",
    part_of_speech: "tính từ",
    meaning:
      '(văn chương) rất xa, tựa như ở mãi tít tận ngoài khơi: ngàn dặm xa khơi * "Anh rõ trước sẽ có ngày cách biệt, Ngó như gần nhưng vẫn thiệt xa khơi!" (HMTử; 8)',
    example:
      'ngàn dặm xa khơi * "Anh rõ trước sẽ có ngày cách biệt, Ngó như gần nhưng vẫn thiệt xa khơi!" (HMTử; 8)',
  },
  {
    word: "xa lánh",
    part_of_speech: "động từ",
    meaning:
      "tránh xa, tránh mọi sự tiếp xúc, quan hệ: xa lánh cõi đời * bị bạn bè xa lánh",
    example: "xa lánh cõi đời * bị bạn bè xa lánh",
  },
  {
    word: "xả láng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tự buông thả trong sinh hoạt không chút tự kiềm chế, để cho được hoàn toàn tự do, thoải mái: vui chơi xả láng",
    example: "vui chơi xả láng",
  },
  {
    word: "xa lắc",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) rất xa, đến mức tưởng chừng như không thể hình dung ra được, không thể đến được: ở một nơi xa lắc * nhớ lại những chuyện xa lắc",
    example: "ở một nơi xa lắc * nhớ lại những chuyện xa lắc",
  },
  {
    word: "xà ích",
    part_of_speech: "danh từ",
    meaning: "người điều khiển xe ngựa: người xà ích",
    example: "người xà ích",
  },
  {
    word: "xạ kích",
    part_of_speech: "động từ",
    meaning: "bắn súng (nói khái quát): giờ tập xạ kích",
    example: "giờ tập xạ kích",
  },
  {
    word: "xa lìa",
    part_of_speech: "động từ",
    meaning: "lìa bỏ, rời xa hẳn cái vốn gắn bó mật thiết: mẹ con xa lìa nhau",
    example: "mẹ con xa lìa nhau",
  },
  {
    word: "xà lim",
    part_of_speech: "danh từ",
    meaning: "buồng hẹp để giam riêng từng người tù: bị tống vào xà lim",
    example: "bị tống vào xà lim",
  },
  {
    word: "xa lông",
    part_of_speech: "danh từ",
    meaning:
      "bộ bàn ghế dùng để tiếp khách, có ghế to, chân thấp, lưng tựa và tay đỡ: bộ xa lông",
    example: "bộ xa lông",
  },
  {
    word: "xa ngái",
    part_of_speech: "tính từ",
    meaning:
      '(phương ngữ) như xa xôi: "Giang sơn một gánh nặng nề, Quản chi xa ngái đi về mấy phen." (ca dao)',
    example:
      'Giang sơn một gánh nặng nề, Quản chi xa ngái đi về mấy phen." (ca dao)',
  },
  {
    word: "xa lộ",
    part_of_speech: "danh từ",
    meaning:
      "đường lớn, rộng, thường phân luồng cho xe đi theo một chiều, với tốc độ cao: xa lộ Bắc - Nam * xe chạy vào xa lộ",
    example: "xa lộ Bắc - Nam * xe chạy vào xa lộ",
  },
  {
    word: "xà lỏn",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) quần xà lỏn (nói tắt): mặc xà lỏn",
    example: "mặc xà lỏn",
  },
  {
    word: "xà ngang",
    part_of_speech: "danh từ",
    meaning: "thanh xà bắc ngang nối hai đầu cột của ngôi nhà.",
    example: "sút bóng trúng xà ngang",
  },
  {
    word: "xà phòng",
    part_of_speech: "danh từ",
    meaning:
      "chất dùng để giặt rửa, chế tạo bằng cách cho một chất kiềm tác dụng với một chất béo: bong bóng xà phòng * rửa tay bằng xà phòng",
    example: "bong bóng xà phòng * rửa tay bằng xà phòng",
  },
  {
    word: "xã luận",
    part_of_speech: "danh từ",
    meaning:
      "bài chính trình bày quan điểm của tờ báo về một vấn đề thời sự quan trọng, thường đăng ở trang nhất: bài xã luận",
    example: "bài xã luận",
  },
  {
    word: "xa tanh",
    part_of_speech: "danh từ",
    meaning:
      "hàng dệt theo các dạng vân đoạn, mặt phải bóng và mịn: vải xa tanh hoa * quần xa tanh",
    example: "vải xa tanh hoa * quần xa tanh",
  },
  {
    word: "xa rời",
    part_of_speech: "động từ",
    meaning:
      'tách khỏi, không còn giữ mối quan hệ mật thiết nữa (nói khái quát): xa rời quần chúng * "Đưa lên ta ví đôi lời, Kẻo rồi én bắc xa rời nhạn đông." (ca dao)',
    example:
      'xa rời quần chúng * "Đưa lên ta ví đôi lời, Kẻo rồi én bắc xa rời nhạn đông." (ca dao)',
  },
  {
    word: "xã tắc",
    part_of_speech: "danh từ",
    meaning: "(cũ) đất nước: giữ yên xã tắc * có nhiều công lao với xã tắc",
    example: "giữ yên xã tắc * có nhiều công lao với xã tắc",
  },
  {
    word: "xa thẳm",
    part_of_speech: "tính từ",
    meaning:
      "xa đến mức như mờ đi, chìm sâu vào khoảng không: nơi xa thẳm * phía chân trời xa thẳm",
    example: "nơi xa thẳm * phía chân trời xa thẳm",
  },
  {
    word: "xa tắp",
    part_of_speech: "tính từ",
    meaning: "xa và kéo dài đến hết tầm mắt: chân trời xa tắp",
    example: "chân trời xa tắp",
  },
  {
    word: "xả thân",
    part_of_speech: "động từ",
    meaning: "hi sinh thân mình vì việc nghĩa: xả thân ngoài chiến trường",
    example: "xả thân ngoài chiến trường",
  },
  {
    word: "xả thân",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) uỷ ban nhân dân xã (nói tắt): họp ở trên xã * bị gọi lên xã",
    example: "họp ở trên xã * bị gọi lên xã",
  },
  {
    word: "xả thân",
    part_of_speech: "động từ",
    meaning:
      "(cũ) chức vị ở làng xã thời phong kiến, có thể bỏ tiền ra mua, lớn hơn nhiêu: mua nhiêu mua xã",
    example: "mua nhiêu mua xã",
  },
  {
    word: "xạ trị",
    part_of_speech: "động từ",
    meaning:
      "điều trị bệnh (thường là ung thư) bằng phương pháp chiếu tia bức xạ (tia X, tia gamma, v.v.) đâm xuyên vào vùng gây bệnh: xạ trị ung thư vòm họng * máy xạ trị",
    example: "xạ trị ung thư vòm họng * máy xạ trị",
  },
  {
    word: "xạ thủ",
    part_of_speech: "danh từ",
    meaning: "người bắn giỏi: xạ thủ đại liên * xạ thủ B.40",
    example: "xạ thủ đại liên * xạ thủ B.40",
  },
  {
    word: "xạ thủ",
    part_of_speech: "danh từ",
    meaning:
      "vận động viên môn bắn súng: các xạ thủ của đội tuyển bắn súng Việt Nam",
    example: "các xạ thủ của đội tuyển bắn súng Việt Nam",
  },
  {
    word: "xa tít",
    part_of_speech: "tính từ",
    meaning:
      'xa lắm, đến mức mắt thường không thể nhìn tới được: ở xa tít ngoài khơi * "Con đường xa tít bên sông, Bóng chiều đã xế mà không thấy người." (ca dao)',
    example:
      'ở xa tít ngoài khơi * "Con đường xa tít bên sông, Bóng chiều đã xế mà không thấy người." (ca dao)',
  },
  {
    word: "xa vắng",
    part_of_speech: "tính từ",
    meaning:
      "xa xôi và vắng vẻ: bến đò xa vắng * nơi xa vắng, ít người qua lại",
    example: "bến đò xa vắng * nơi xa vắng, ít người qua lại",
  },
  {
    word: "xa vắng",
    part_of_speech: "động từ",
    meaning:
      'ở cách xa nhau, không gặp mặt nhau: "Đêm thu gió lọt song đào, Chồng ai xa vắng gió vào chi đây." (TĐà; 1)',
    example:
      'Đêm thu gió lọt song đào, Chồng ai xa vắng gió vào chi đây." (TĐà; 1)',
  },
  {
    word: "xa vời vợi",
    part_of_speech: "tính từ",
    meaning: "như xa vời (ng1; nhưng ý nhấn mạnh hơn): mắt nhìn xa vời vợi",
    example: "mắt nhìn xa vời vợi",
  },
  {
    word: "xa vời",
    part_of_speech: "tính từ",
    meaning:
      "quá xa, đến mức trở nên cách biệt, khó có thể tới được: những vì sao xa vời * kí ức xa vời",
    example: "những vì sao xa vời * kí ức xa vời",
  },
  {
    word: "xa vời",
    part_of_speech: "tính từ",
    meaning: "quá xa xôi, viển vông: điều đó nghe có vẻ xa vời",
    example: "điều đó nghe có vẻ xa vời",
  },
  {
    word: "xa xăm",
    part_of_speech: "tính từ",
    meaning:
      "rất xa, rất lâu rồi (nói khái quát): những vì sao xa xăm * dĩ vãng xa xăm",
    example: "những vì sao xa xăm * dĩ vãng xa xăm",
  },
  {
    word: "xa xăm",
    part_of_speech: "tính từ",
    meaning:
      "có vẻ như đang mơ màng, chìm đắm vào một nơi nào đó rất xa: cái nhìn xa xăm * đôi mắt buồn xa xăm",
    example: "cái nhìn xa xăm * đôi mắt buồn xa xăm",
  },
  {
    word: "xá xị",
    part_of_speech: "danh từ",
    meaning:
      "nước giải khát mùi thơm, vị ngọt: uống xá xị * chai nước ngọt xá xị",
    example: "uống xá xị * chai nước ngọt xá xị",
  },
  {
    word: "xá xị",
    part_of_speech: "danh từ",
    meaning:
      "vải trắng có mặt láng bóng, thường được dùng thời trước: vải xá xị",
    example: "vải xá xị",
  },
  {
    word: "xa xỉ phẩm",
    part_of_speech: "danh từ",
    meaning:
      "hàng tiêu dùng đắt tiền mà không thật cần thiết cho đời sống bình thường: đồ xa xỉ phẩm",
    example: "đồ xa xỉ phẩm",
  },
  {
    word: "xa xa",
    part_of_speech: "tính từ",
    meaning: "hơi xa: đứng xa xa ra một chút",
    example: "đứng xa xa ra một chút",
  },
  {
    word: "xa xa",
    part_of_speech: "tính từ",
    meaning:
      'ở phía đằng xa: có tiếng gà gáy xa xa * "Buồn trông cửa bể chiều hôm, Thuyền ai thấp thoáng cánh buồm xa xa?" (TKiều)',
    example:
      'có tiếng gà gáy xa xa * "Buồn trông cửa bể chiều hôm, Thuyền ai thấp thoáng cánh buồm xa xa?" (TKiều)',
  },
  {
    word: "xà xẻo",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) ăn bớt, ăn xén từng ít một (nói khái quát): xà xẻo tiền công của thợ",
    example: "xà xẻo tiền công của thợ",
  },
  {
    word: "xa xỉ",
    part_of_speech: "tính từ",
    meaning:
      "tốn nhiều tiền một cách không cần thiết hoặc chưa thật cần thiết: hàng xa xỉ * ăn chơi xa xỉ",
    example: "hàng xa xỉ * ăn chơi xa xỉ",
  },
  {
    word: "xã viên",
    part_of_speech: "danh từ",
    meaning:
      "thành viên của một hợp tác xã: họp tổ xã viên * bình bầu xã viên xuất sắc",
    example: "họp tổ xã viên * bình bầu xã viên xuất sắc",
  },
  {
    word: "xa xót",
    part_of_speech: "động từ",
    meaning: "(hiếm) như xót xa: lòng bồi hồi xa xót",
    example: "lòng bồi hồi xa xót",
  },
  {
    word: "xa xôi",
    part_of_speech: "tính từ",
    meaning:
      "xa và cách trở về không gian, thời gian (nói khái quát): đường sá xa xôi * nơi biên ải xa xôi * kí ức xa xôi",
    example: "đường sá xa xôi * nơi biên ải xa xôi * kí ức xa xôi",
  },
  {
    word: "xa xôi",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về cái chưa tới, mà cũng không biết bao giờ mới tới: nghĩ ngợi xa xôi * tính chuyện xa xôi",
    example: "nghĩ ngợi xa xôi * tính chuyện xa xôi",
  },
  {
    word: "xa xôi",
    part_of_speech: "tính từ",
    meaning:
      "(lối nói) không đi thẳng vào vấn đề, mà chỉ có tính chất gợi ý để tự suy ra mà hiểu lấy: nói xa xôi * những lời bóng gió xa xôi",
    example: "nói xa xôi * những lời bóng gió xa xôi",
  },
  {
    word: "xác",
    part_of_speech: "danh từ",
    meaning:
      "phần thân thể của con người, đối lập với phần hồn: người lớn xác * hồn lìa khỏi xác * thẫn thờ như cái xác không hồn",
    example:
      "người lớn xác * hồn lìa khỏi xác * thẫn thờ như cái xác không hồn",
  },
  {
    word: "xác",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) cái bản thân của mỗi con người (hàm ý coi khinh): nghĩ làm gì cho nhọc xác * kệ xác hắn! * vừa nhắc tới đã lù lù dẫn xác về",
    example:
      "nghĩ làm gì cho nhọc xác * kệ xác hắn! * vừa nhắc tới đã lù lù dẫn xác về",
  },
  {
    word: "xác",
    part_of_speech: "danh từ",
    meaning:
      "thân người hay động vật đã chết: chết mất xác * xác bướm * chiến trường ngổn ngang xác giặc",
    example: "chết mất xác * xác bướm * chiến trường ngổn ngang xác giặc",
  },
  {
    word: "xác",
    part_of_speech: "danh từ",
    meaning:
      "lớp da, lớp vỏ đã trút bỏ của một số loài vật sau khi lột vỏ: xác ve * xác rắn lột * cua vừa lột xác",
    example: "xác ve * xác rắn lột * cua vừa lột xác",
  },
  {
    word: "xác",
    part_of_speech: "danh từ",
    meaning:
      "phần vỏ hay bã của vật còn lại sau khi đã được dùng: xác mía * xác cau * tan xác pháo",
    example: "xác mía * xác cau * tan xác pháo",
  },
  {
    word: "xác",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái như chỉ còn trơ trụi cái vỏ, cái hình thức bên ngoài: mình gầy xác * mớ tóc khô xác * nhà nghèo xác * xác như vờ",
    example: "mình gầy xác * mớ tóc khô xác * nhà nghèo xác * xác như vờ",
  },
  {
    word: "xác lập",
    part_of_speech: "động từ",
    meaning:
      "lập nên trên cơ sở vững chắc: xác lập quyền thừa kế * quan hệ ngoại giao giữa hai nước đã được xác lập",
    example:
      "xác lập quyền thừa kế * quan hệ ngoại giao giữa hai nước đã được xác lập",
  },
  {
    word: "xạc",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) mắng gay gắt: bị xạc cho một trận",
    example: "bị xạc cho một trận",
  },
  {
    word: "xác định",
    part_of_speech: "động từ",
    meaning:
      "đưa ra kết quả cụ thể, rõ ràng và chính xác sau khi nghiên cứu, tìm tòi, tính toán: xác định toạ độ * xác định niên đại chiếc ấm cổ",
    example: "xác định toạ độ * xác định niên đại chiếc ấm cổ",
  },
  {
    word: "xác định",
    part_of_speech: "động từ",
    meaning:
      "định rõ, vạch rõ một cách hợp lí để theo đó mà làm: xác định mục đích học tập * xác định phương châm làm việc",
    example: "xác định mục đích học tập * xác định phương châm làm việc",
  },
  {
    word: "xác định",
    part_of_speech: "tính từ",
    meaning:
      "đã được biết hoặc được định trước một cách hoàn toàn rõ ràng, chính xác: toạ độ xác định * vị trí xác định",
    example: "toạ độ xác định * vị trí xác định",
  },
  {
    word: "xa xưa",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về một thời đã qua rất lâu rồi (nói khái quát): thời xa xưa * chuyện cổ xa xưa",
    example: "thời xa xưa * chuyện cổ xa xưa",
  },
  {
    word: "xác minh",
    part_of_speech: "động từ",
    meaning:
      "làm cho rõ sự thật qua thực tế và chứng cớ cụ thể: xác minh lí lịch * xác minh lời khai của hung thủ",
    example: "xác minh lí lịch * xác minh lời khai của hung thủ",
  },
  {
    word: "xác đáng",
    part_of_speech: "tính từ",
    meaning:
      "đúng đắn và có sức thuyết phục: lí lẽ xác đáng * đề nghị xác đáng * lời khuyên xác đáng",
    example: "lí lẽ xác đáng * đề nghị xác đáng * lời khuyên xác đáng",
  },
  {
    word: "xác suất",
    part_of_speech: "danh từ",
    meaning:
      "số đo phần chắc của một biến cố ngẫu nhiên: kiểm tra xác suất * xác suất không cao",
    example: "kiểm tra xác suất * xác suất không cao",
  },
  {
    word: "xác thực",
    part_of_speech: "tính từ",
    meaning:
      "đúng với sự thật, không sai chút nào: chứng cứ xác thực * bài viết thiếu căn cứ xác thực",
    example: "chứng cứ xác thực * bài viết thiếu căn cứ xác thực",
  },
  {
    word: "xác thịt",
    part_of_speech: "danh từ",
    meaning:
      "thể xác của con người, thường dùng để nói về khoái lạc tầm thường: thú vui xác thịt",
    example: "thú vui xác thịt",
  },
  {
    word: "xác nhận",
    part_of_speech: "động từ",
    meaning:
      "thừa nhận là đúng sự thật: xác nhận chất lượng sản phẩm * kí xác nhận",
    example: "xác nhận chất lượng sản phẩm * kí xác nhận",
  },
  {
    word: "xác tín",
    part_of_speech: "động từ",
    meaning: "đúng đắn, đáng tin cậy: tin tức xác tín",
    example: "tin tức xác tín",
  },
  {
    word: "xác vờ",
    part_of_speech: "tính từ",
    meaning:
      'nghèo tới mức như chỉ có trơ thân, tựa như xác những con vờ trôi trên mặt nước: "Bác mày giàu, giàu lắm, chứ không xác vờ như bố mày đây!" (MVKháng; 5)',
    example:
      'Bác mày giàu, giàu lắm, chứ không xác vờ như bố mày đây!" (MVKháng; 5)',
  },
  {
    word: "xạc xào",
    part_of_speech: "tính từ",
    meaning: "như xào xạc: tiếng gió xạc xào",
    example: "tiếng gió xạc xào",
  },
  {
    word: "xác xơ",
    part_of_speech: "tính từ",
    meaning: "như xơ xác: cây cối xác xơ",
    example: "cây cối xác xơ",
  },
  {
    word: "xách",
    part_of_speech: "động từ",
    meaning:
      "cầm nhấc lên hay mang đi bằng một tay để buông thẳng xuống: xách làn đi chợ * xách va li * tay xách nách mang",
    example: "xách làn đi chợ * xách va li * tay xách nách mang",
  },
  {
    word: "xách",
    part_of_speech: "động từ",
    meaning: "cầm mà kéo lên: xách tai * xách cao quần cho khỏi ướt",
    example: "xách tai * xách cao quần cho khỏi ướt",
  },
  {
    word: "xách",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) mang đi: xách cần đi câu * xách em đi chơi",
    example: "xách cần đi câu * xách em đi chơi",
  },
  {
    word: "xách mé",
    part_of_speech: "tính từ",
    meaning:
      "(cách nói năng) xấc xược, thiếu lịch sự, thiếu lễ phép: ăn nói xách mé * hỏi một câu xách mé",
    example: "ăn nói xách mé * hỏi một câu xách mé",
  },
  {
    word: "xài",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) tiêu, dùng: hết tiền xài * xài nhiều điện",
    example: "hết tiền xài * xài nhiều điện",
  },
  {
    word: "xái",
    part_of_speech: "danh từ",
    meaning:
      "phần bã thuốc phiện, thuốc lào còn lại sau khi đã hút: xái thuốc phiện * nạo xái * hút điếu xái",
    example: "xái thuốc phiện * nạo xái * hút điếu xái",
  },
  {
    word: "xải",
    part_of_speech: "danh từ",
    meaning:
      '(cũng xải) đồ đan bằng tre nứa, hình tròn, lòng sâu, trát sơn ở mặt ngoài, thường dùng để đựng chất lỏng: "Rủ nhau đi gánh nước thuyền, Đứt quang vỡ sải nước liền ra sông." (ca dao)',
    example:
      'Rủ nhau đi gánh nước thuyền, Đứt quang vỡ sải nước liền ra sông." (ca dao)',
  },
  {
    word: "xải",
    part_of_speech: "danh từ",
    meaning:
      "độ dài bằng khoảng cách từ đầu bàn tay này đến đầu bàn tay kia khi dang thẳng cánh tay: chiếc gậy dài một sải tay",
    example: "chiếc gậy dài một sải tay",
  },
  {
    word: "xải",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) dang, duỗi thật hết cỡ: sải bước * chim sải cánh bay",
    example: "sải bước * chim sải cánh bay",
  },
  {
    word: "xảm",
    part_of_speech: "động từ",
    meaning: "trít khe hở: xảm thuyền",
    example: "xảm thuyền",
  },
  {
    word: "xám",
    part_of_speech: "tính từ",
    meaning:
      "có màu trung gian giữa đen và trắng, như màu của tro: bộ lông màu xám tro * mặt xám như chì * bầu trời xám",
    example: "bộ lông màu xám tro * mặt xám như chì * bầu trời xám",
  },
  {
    word: "xám ngoét",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) như xám ngắt (thường nói về màu da): mặt xám ngoét, cắt không ra giọt máu",
    example: "mặt xám ngoét, cắt không ra giọt máu",
  },
  {
    word: "xam",
    part_of_speech: "tính từ",
    meaning:
      "xen thêm vào với cái chính: làm xam việc * nói xam vào * cho trẻ ăn xam",
    example: "làm xam việc * nói xam vào * cho trẻ ăn xam",
  },
  {
    word: "xám ngắt",
    part_of_speech: "tính từ",
    meaning:
      "xám một màu, gây cảm giác lạnh lẽo như không có sự sống: trời đông xám ngắt",
    example: "trời đông xám ngắt",
  },
  {
    word: "xài phí",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) tiêu dùng phung phí: xài phí tiền bạc * có bao nhiêu xài phí bấy nhiêu",
    example: "xài phí tiền bạc * có bao nhiêu xài phí bấy nhiêu",
  },
  {
    word: "xam xám",
    part_of_speech: "tính từ",
    meaning: "có màu hơi xám: mái tranh xam xám",
    example: "mái tranh xam xám",
  },
  {
    word: "xán lạn",
    part_of_speech: "tính từ",
    meaning: "rực rỡ, chói lọi: tiền đồ xán lạn * tương lai xán lạn",
    example: "tiền đồ xán lạn * tương lai xán lạn",
  },
  {
    word: "xám xịt",
    part_of_speech: "tính từ",
    meaning: "xám đen lại, trông tối và xấu: da dẻ xám xịt",
    example: "da dẻ xám xịt",
  },
  {
    word: "xáng",
    part_of_speech: "danh từ",
    meaning: "máy đào kênh và vét bùn: xáng vét bùn",
    example: "xáng vét bùn",
  },
  {
    word: "xáng",
    part_of_speech: "động từ",
    meaning: "(Nam, khẩu ngữ) đánh, đập mạnh xuống: xáng cho một gậy",
    example: "xáng cho một gậy",
  },
  {
    word: "xàng xê",
    part_of_speech: "danh từ",
    meaning:
      "làn điệu trong hát bài chòi, cải lương, có tiết tấu dịu dàng, trang trọng (vốn là một bài nhạc lễ trang nghiêm để rước thần): điệu xàng xê",
    example: "điệu xàng xê",
  },
  {
    word: "xàng xê",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) lựa cách chuyển khoản này sang khoản kia để lấy đi một ít mà người khác khó phát hiện: xàng xê các khoản công quỹ",
    example: "xàng xê các khoản công quỹ",
  },
  {
    word: "xán",
    part_of_speech: "động từ",
    meaning: "(Phương ngữ) quăng, ném mạnh xuống: xán bể chiếc chén",
    example: "xán bể chiếc chén",
  },
  {
    word: "xang",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) đưa qua đưa lại: chân xang qua xang lại",
    example: "chân xang qua xang lại",
  },
  {
    word: "xanh",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) trời, ông trời: "Xanh kia thăm thẳm từng trên, Vì ai gây dựng cho nên nỗi này?" (CPN)',
    example:
      'Xanh kia thăm thẳm từng trên, Vì ai gây dựng cho nên nỗi này?" (CPN)',
  },
  {
    word: "xanh",
    part_of_speech: "tính từ",
    meaning:
      "có màu như màu của lá cây, của nước biển: luỹ tre xanh * trời xanh * mặt xanh như tàu lá",
    example: "luỹ tre xanh * trời xanh * mặt xanh như tàu lá",
  },
  {
    word: "xanh",
    part_of_speech: "tính từ",
    meaning:
      "(quả cây) chưa chín (vỏ vẫn còn xanh, chưa chuyển sang màu vàng hoặc đỏ): ổi xanh * đu đủ xanh",
    example: "ổi xanh * đu đủ xanh",
  },
  {
    word: "xanh",
    part_of_speech: "tính từ",
    meaning:
      '(văn chương) (người, tuổi đời) còn trẻ: tuổi xanh * "Phũ phàng chi bấy Hoá công!, Ngày xanh mòn mỏi, má hồng phôi pha." (TKiều)',
    example:
      'tuổi xanh * "Phũ phàng chi bấy Hoá công!, Ngày xanh mòn mỏi, má hồng phôi pha." (TKiều)',
  },
  {
    word: "xanh",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) miền rừng núi, dùng để chỉ khu căn cứ cách mạng trong thời kì kháng chiến chống Mĩ: cả nhà đã lên xanh",
    example: "cả nhà đã lên xanh",
  },
  {
    word: "xanh biếc",
    part_of_speech: "tính từ",
    meaning:
      "xanh đậm và tươi ánh lên: dòng sông xanh biếc * bãi dâu xanh biếc",
    example: "dòng sông xanh biếc * bãi dâu xanh biếc",
  },
  {
    word: "xanh cỏ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có cỏ mọc trên mộ đã xanh; ý nói chết đã khá lâu rồi: không có tao thì nó đã xanh cỏ rồi!",
    example: "không có tao thì nó đã xanh cỏ rồi!",
  },
  {
    word: "xanh lam",
    part_of_speech: "tính từ",
    meaning: "như lam: nền trời xanh lam",
    example: "nền trời xanh lam",
  },
  {
    word: "xanh lè",
    part_of_speech: "tính từ",
    meaning: "xanh gắt, trông khó chịu: ánh lửa hàn xanh lè",
    example: "ánh lửa hàn xanh lè",
  },
  {
    word: "xanh lè",
    part_of_speech: "tính từ",
    meaning: "(quả cây) còn rất xanh, không thể ăn được: chuối xanh lè",
    example: "chuối xanh lè",
  },
  {
    word: "xanh lơ",
    part_of_speech: "tính từ",
    meaning: "xanh nhạt như màu của nước lơ: áo màu xanh lơ",
    example: "áo màu xanh lơ",
  },
  {
    word: "xanh mắt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ở trạng thái quá sợ hãi, đến mức mặt mày biến sắc, nhợt nhạt: bị một phen xanh mắt * sợ xanh mắt",
    example: "bị một phen xanh mắt * sợ xanh mắt",
  },
  {
    word: "xanh lướt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (nước da) rất xanh, vì ốm yếu lâu ngày: mặt xanh lướt như tàu lá",
    example: "mặt xanh lướt như tàu lá",
  },
  {
    word: "xanh lét",
    part_of_speech: "tính từ",
    meaning:
      "xanh có pha những tia sáng lạnh, gây cảm giác rờn rợn: ngọn lửa xanh lét",
    example: "ngọn lửa xanh lét",
  },
  {
    word: "xanh mét",
    part_of_speech: "tính từ",
    meaning: "(nước da) xanh nhợt như không còn chút máu: mặt mày xanh mét",
    example: "mặt mày xanh mét",
  },
  {
    word: "xanh rì",
    part_of_speech: "tính từ",
    meaning:
      "xanh đậm và đều như màu của cây cỏ rậm rạp: ruộng lúa xanh rì * cỏ mọc xanh rì",
    example: "ruộng lúa xanh rì * cỏ mọc xanh rì",
  },
  {
    word: "xanh ngắt",
    part_of_speech: "tính từ",
    meaning:
      'xanh thuần một màu trên diện rộng: ngàn dâu xanh ngắt * "Trời thu xanh ngắt mấy từng cao, Cần trúc lơ phơ gió hắt hiu." (NgKhuyến; 4)',
    example:
      'ngàn dâu xanh ngắt * "Trời thu xanh ngắt mấy từng cao, Cần trúc lơ phơ gió hắt hiu." (NgKhuyến; 4)',
  },
  {
    word: "xanh rờn",
    part_of_speech: "tính từ",
    meaning:
      "xanh mượt mà như màu của lá cây non: cỏ non xanh rờn * ruộng lúa xanh rờn",
    example: "cỏ non xanh rờn * ruộng lúa xanh rờn",
  },
  {
    word: "xanh rớt",
    part_of_speech: "tính từ",
    meaning: "(nước da) rất xanh, trông yếu ớt, bệnh tật: da mặt xanh rớt",
    example: "da mặt xanh rớt",
  },
  {
    word: "xanh tươi",
    part_of_speech: "tính từ",
    meaning: "tươi tốt, đầy sức sống: cây cối xanh tươi",
    example: "cây cối xanh tươi",
  },
  {
    word: "xanh um",
    part_of_speech: "tính từ",
    meaning: "xanh tốt um tùm: cỏ mọc xanh um",
    example: "cỏ mọc xanh um",
  },
  {
    word: "xạo",
    part_of_speech: "tính từ",
    meaning:
      "(Nam) dối, không đúng sự thật: đừng tin, hắn nói xạo đó * Mày đừng có xạo!",
    example: "đừng tin, hắn nói xạo đó * Mày đừng có xạo!",
  },
  {
    word: "xáo",
    part_of_speech: "động từ",
    meaning:
      "làm cho thay đổi vị trí từ dưới lên trên hay từ chỗ này sang chỗ khác một cách lộn xộn: xáo tung đống tài liệu * quần áo bị xáo lộn lên",
    example: "xáo tung đống tài liệu * quần áo bị xáo lộn lên",
  },
  {
    word: "xáo",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) như xới (ng1): xáo đất * xáo ngô",
    example: "xáo đất * xáo ngô",
  },
  {
    word: "xáo",
    part_of_speech: "động từ",
    meaning:
      "nấu thịt với nhiều nước và các loại rau, gia vị riêng: vịt xáo măng * trăm voi không được bát nước xáo (tng)",
    example: "vịt xáo măng * trăm voi không được bát nước xáo (tng)",
  },
  {
    word: "xanh xao",
    part_of_speech: "tính từ",
    meaning:
      "(nước da) xanh nhợt, vẻ ốm yếu: sắc mặt xanh xao * người xanh xao vàng vọt",
    example: "sắc mặt xanh xao * người xanh xao vàng vọt",
  },
  {
    word: "xao",
    part_of_speech: "động từ",
    meaning:
      'chao động, lay động: "Trời xanh dưới nước cũng xanh, Trên non gió thổi dưới gành sóng xao." (Cdao)',
    example:
      'Trời xanh dưới nước cũng xanh, Trên non gió thổi dưới gành sóng xao." (Cdao)',
  },
  {
    word: "xào",
    part_of_speech: "động từ",
    meaning:
      "làm chín thức ăn bằng cách đảo đều với dầu mỡ và mắm muối trên bếp lửa: xào su hào * xào rau * thịt bê xào sả ớt",
    example: "xào su hào * xào rau * thịt bê xào sả ớt",
  },
  {
    word: "xảo",
    part_of_speech: "tính từ",
    meaning: "xảo quyệt (nói tắt): mắc mưu xảo * thằng cha rất xảo",
    example: "mắc mưu xảo * thằng cha rất xảo",
  },
  {
    word: "xáo động",
    part_of_speech: "động từ",
    meaning:
      "làm đảo lộn và mất hẳn sự yên tĩnh vốn có: tiếng chó sủa làm xáo động trưa hè * ~ tâm trí bị xáo động",
    example: "tiếng chó sủa làm xáo động trưa hè * ~ tâm trí bị xáo động",
  },
  {
    word: "xao động",
    part_of_speech: "động từ",
    meaning:
      "lay động, không yên: mặt nước xao động * tiếng sáo làm xao động tâm hồn",
    example: "mặt nước xao động * tiếng sáo làm xao động tâm hồn",
  },
  {
    word: "xao lãng",
    part_of_speech: "động từ",
    meaning:
      "không để tâm, không dồn công sức vào công việc chính phải làm, do bị lôi cuốn vào những cái khác: sao nhãng việc học hành * không được sao nhãng nhiệm vụ",
    example: "sao nhãng việc học hành * không được sao nhãng nhiệm vụ",
  },
  {
    word: "xào nấu",
    part_of_speech: "động từ",
    meaning: "nấu món ăn với dầu mỡ (nói khái quát): xào nấu thức ăn",
    example: "xào nấu thức ăn",
  },
  {
    word: "xảo trá",
    part_of_speech: "tính từ",
    meaning:
      "dối trá, lừa lọc một cách khôn khéo, tinh vi: thủ đoạn xảo trá * tâm địa xảo trá",
    example: "thủ đoạn xảo trá * tâm địa xảo trá",
  },
  {
    word: "xảo quyệt",
    part_of_speech: "tính từ",
    meaning:
      "dối trá, lừa lọc một cách quỷ quyệt, khó lường: mưu mô xảo quyệt * thủ đoạn xảo quyệt",
    example: "mưu mô xảo quyệt * thủ đoạn xảo quyệt",
  },
  {
    word: "xảo ngôn",
    part_of_speech: "danh từ",
    meaning: "(hiếm) lời nói khéo, nhưng giả dối: dùng xảo ngôn để lừa người",
    example: "dùng xảo ngôn để lừa người",
  },
  {
    word: "xao nhãng",
    part_of_speech: "động từ",
    meaning:
      "không để tâm, không dồn công sức vào công việc chính phải làm, do bị lôi cuốn vào những cái khác: sao nhãng việc học hành * không được sao nhãng nhiệm vụ",
    example: "sao nhãng việc học hành * không được sao nhãng nhiệm vụ",
  },
  {
    word: "xảo thuật",
    part_of_speech: "danh từ",
    meaning: "cách thức khéo léo, tinh xảo: bộ phim sử dụng nhiều xảo thuật",
    example: "bộ phim sử dụng nhiều xảo thuật",
  },
  {
    word: "xao xác",
    part_of_speech: "tính từ",
    meaning:
      'từ gợi tả những tiếng như tiếng chim vỗ cánh, tiếng gà gáy, v.v. nối tiếp nhau làm xao động cảnh không gian vắng lặng: "Mỗi lần nắng mới hắt bên song, Xao xác, gà trưa gáy não nùng." (LTrLư; 6)',
    example:
      'Mỗi lần nắng mới hắt bên song, Xao xác, gà trưa gáy não nùng." (LTrLư; 6)',
  },
  {
    word: "xáo xác",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả vẻ rối loạn, nhớn nhác vì hoảng sợ: thấy động đàn gà xáo xác * cả xóm xáo xác vì vụ hoả hoạn",
    example: "thấy động đàn gà xáo xác * cả xóm xáo xác vì vụ hoả hoạn",
  },
  {
    word: "xáo trộn",
    part_of_speech: "động từ",
    meaning:
      "làm cho mọi thứ lẫn vào nhau lung tung lên, không còn phân biệt được nữa: xáo trộn quân bài * sinh hoạt của gia đình bị xáo trộn",
    example: "xáo trộn quân bài * sinh hoạt của gia đình bị xáo trộn",
  },
  {
    word: "xào xạc",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng như tiếng lá cây lay động va chạm nhẹ vào nhau: lá cây xào xạc * gió thổi trong vườn cau xào xạc",
    example: "lá cây xào xạc * gió thổi trong vườn cau xào xạc",
  },
  {
    word: "xáp",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) (khẩu ngữ) giáp: những ngày xáp Tết * tránh xáp mặt nhau",
    example: "những ngày xáp Tết * tránh xáp mặt nhau",
  },
  {
    word: "xáp",
    part_of_speech: "động từ",
    meaning: "tiến sát vào: xáp lại gần nhau * xáp mặt địch",
    example: "xáp lại gần nhau * xáp mặt địch",
  },
  {
    word: "xáo xới",
    part_of_speech: "động từ",
    meaning: "(hiếm) như xới xáo: xáo xới đất để trồng rau",
    example: "xáo xới đất để trồng rau",
  },
  {
    word: "xào xạo",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng phát ra như tiếng cọ xát của nhiều vật nhỏ, cứng: sỏi đá xào xạo dưới chân * tiếng vót chông xào xạo",
    example: "sỏi đá xào xạo dưới chân * tiếng vót chông xào xạo",
  },
  {
    word: "xào xáo",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) như xào nấu: xào xáo lại thức ăn",
    example: "xào xáo lại thức ăn",
  },
  {
    word: "xao xuyến",
    part_of_speech: "động từ",
    meaning:
      "ở trạng thái có những tình cảm dấy lên trong lòng và thường kéo dài khó dứt: một nỗi buồn xao xuyến * xao xuyến trong lòng",
    example: "một nỗi buồn xao xuyến * xao xuyến trong lòng",
  },
  {
    word: "xát",
    part_of_speech: "động từ",
    meaning:
      "áp mạnh sát lên trên bề mặt và đưa đi đưa lại nhiều lần cho sạch, cho ngấm: xát xà phòng * xát sạch vỏ đỗ * ruột gan như xát muối",
    example: "xát xà phòng * xát sạch vỏ đỗ * ruột gan như xát muối",
  },
  {
    word: "xay",
    part_of_speech: "động từ",
    meaning:
      "làm cho tróc vỏ, vỡ ra hay nhỏ mịn bằng cối quay: xay cà phê * cối xay lúa",
    example: "xay cà phê * cối xay lúa",
  },
  {
    word: "xảy",
    part_of_speech: "động từ",
    meaning:
      "(xảy ra, xảy đến) (sự việc thường là không hay) phát sinh ra một cách tự nhiên: xảy ra hoả hoạn * xảy ra án mạng * sự việc xảy đến bất ngờ",
    example: "xảy ra hoả hoạn * xảy ra án mạng * sự việc xảy đến bất ngờ",
  },
  {
    word: "xảy",
    part_of_speech: "phụ từ",
    meaning:
      '(Từ cũ) chợt, bỗng: "Mảng còn nghĩ việc tới lui, Xảy nghe trống đã giục thôi vào trường." (LVT)',
    example:
      'Mảng còn nghĩ việc tới lui, Xảy nghe trống đã giục thôi vào trường." (LVT)',
  },
  {
    word: "xay xát",
    part_of_speech: "động từ",
    meaning:
      "xay và xát lương thực bằng máy (nói khái quát): cửa hàng xay xát * xay xát gạo",
    example: "cửa hàng xay xát * xay xát gạo",
  },
  {
    word: "xáy",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) dùng vật có đầu nhọn để đâm, nghiền nhè nhẹ cho giập ra: xáy trầu",
    example: "xáy trầu",
  },
  {
    word: "xáp lá cà",
    part_of_speech: "động từ",
    meaning:
      "đánh gần bằng báng súng, lưỡi lê, dao găm, gươm giáo, gậy gộc, v.v., hoặc bằng tay không: hai bên xông vào đánh giáp lá cà",
    example: "hai bên xông vào đánh giáp lá cà",
  },
  {
    word: "xắm nắm",
    part_of_speech: "tính từ",
    meaning: "rối rít, tíu tít khi làm một việc thích thú: xắm nắm đi xem hội",
    example: "xắm nắm đi xem hội",
  },
  {
    word: "xăm",
    part_of_speech: "danh từ",
    meaning: "lưới mau mắt, dùng để bắt tôm tép, cá con: thả xăm",
    example: "thả xăm",
  },
  {
    word: "xăm",
    part_of_speech: "danh từ",
    meaning: "quẻ thẻ xin ở đền chùa để đoán tương lai, theo mê tín: xin xăm",
    example: "xin xăm",
  },
  {
    word: "xăm",
    part_of_speech: "động từ",
    meaning:
      "dùng kim nhọn châm vào da thành các hình rồi bôi nước lá chàm hoặc mực cho nổi rõ hình lên: xăm mình * xăm lông mày",
    example: "xăm mình * xăm lông mày",
  },
  {
    word: "xăm",
    part_of_speech: "động từ",
    meaning:
      "dùng vật có mũi nhọn châm nhiều lỗ vào củ hay quả cây để làm mứt: xăm gừng * xăm táo làm mứt",
    example: "xăm gừng * xăm táo làm mứt",
  },
  {
    word: "xăm",
    part_of_speech: "động từ",
    meaning: "chọc bằng vật có mũi nhọn để lấy thức ăn: xăm miếng xoài",
    example: "xăm miếng xoài",
  },
  {
    word: "xăm",
    part_of_speech: "động từ",
    meaning:
      "đâm, chọc bằng vật có mũi nhọn để thăm dò, tìm kiếm: xăm trúng hầm bí mật",
    example: "xăm trúng hầm bí mật",
  },
  {
    word: "xăm xăm",
    part_of_speech: "phụ từ",
    meaning:
      'từ gợi tả dáng đi nhanh và liền một mạch nhằm thẳng tới nơi đã định: "Nghề riêng nhớ ít, tưởng nhiều, Xăm xăm đè nẻo Lam Kiều lần sang." (TKiều)',
    example:
      'Nghề riêng nhớ ít, tưởng nhiều, Xăm xăm đè nẻo Lam Kiều lần sang." (TKiều)',
  },
  {
    word: "xăm xắp",
    part_of_speech: "tính từ",
    meaning:
      "(nước) ở mức không đầy lắm, chỉ đủ phủ kín khắp bề mặt: nước xăm xắp mặt ruộng",
    example: "nước xăm xắp mặt ruộng",
  },
  {
    word: "xắn",
    part_of_speech: "động từ",
    meaning:
      "lật ra và cuộn gấp ống quần hay ống tay áo lên cao cho gọn gàng: quần xắn đến gối",
    example: "quần xắn đến gối",
  },
  {
    word: "xắn",
    part_of_speech: "động từ",
    meaning:
      "làm đứt rời ra thành từng miếng to bằng cách dùng vật có cạnh cứng hoặc có lưỡi sắc ấn mạnh xuống: xắn một miếng bánh chưng * dùng mai xắn đất",
    example: "xắn một miếng bánh chưng * dùng mai xắn đất",
  },
  {
    word: "xăm xúi",
    part_of_speech: "phụ từ",
    meaning:
      "từ gợi tả dáng đi vội vàng, mải miết, không để ý đến xung quanh: đi xăm xúi một mạch",
    example: "đi xăm xúi một mạch",
  },
  {
    word: "xăm xắn",
    part_of_speech: "tính từ",
    meaning:
      "nhanh nhảu (trong công việc): xăm xắn thu dọn nhà cửa * xăm xắn đi trước dẫn đường",
    example: "xăm xắn thu dọn nhà cửa * xăm xắn đi trước dẫn đường",
  },
  {
    word: "xẵng",
    part_of_speech: "tính từ",
    meaning:
      "(giọng nói) gay gắt, tỏ vẻ khó chịu, không bằng lòng: xẵng giọng hỏi * nói xẵng",
    example: "xẵng giọng hỏi * nói xẵng",
  },
  {
    word: "xằng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) xằng bậy (nói tắt): làm xằng * đoán xằng * không nên nghĩ xằng",
    example: "làm xằng * đoán xằng * không nên nghĩ xằng",
  },
  {
    word: "xăng",
    part_of_speech: "danh từ",
    meaning:
      "dầu nhẹ, dễ bay hơi, dễ bốc cháy, được cất từ dầu mỏ, than đá, dùng làm chất đốt cho các loại động cơ: xe chạy tốn xăng",
    example: "xe chạy tốn xăng",
  },
  {
    word: "xằng bậy",
    part_of_speech: "tính từ",
    meaning:
      "sai, trái và bậy bạ, không đúng đắn: ăn nói xằng bậy * làm điều xằng bậy",
    example: "ăn nói xằng bậy * làm điều xằng bậy",
  },
  {
    word: "xăng xái",
    part_of_speech: "tính từ",
    meaning: "tỏ ra nhanh nhảu: xăng xái dẫn đường * bước đi xăng xái",
    example: "xăng xái dẫn đường * bước đi xăng xái",
  },
  {
    word: "xắp",
    part_of_speech: "tính từ",
    meaning:
      "(nước) ở mức mấp mé, gần ngập: nước lên xắp mặt đê * nước xắp mắt cá chân",
    example: "nước lên xắp mặt đê * nước xắp mắt cá chân",
  },
  {
    word: "xắp",
    part_of_speech: "phụ từ",
    meaning:
      "(phương ngữ) (làm việc gì) một cách tạm thời vì không phải là việc chính và không có điều kiện làm thường xuyên: học xắp vào buổi tối * đám thợ xắp",
    example: "học xắp vào buổi tối * đám thợ xắp",
  },
  {
    word: "xắt",
    part_of_speech: "động từ",
    meaning:
      "cắt ra thành từng miếng nhỏ bằng cách ấn thẳng lưỡi dao xuống: khoai lang xắt mỏng * đắt xắt ra miếng (tng)",
    example: "khoai lang xắt mỏng * đắt xắt ra miếng (tng)",
  },
  {
    word: "xăng xít",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như lăng xăng: chạy xăng xít",
    example: "chạy xăng xít",
  },
  {
    word: "xấc láo",
    part_of_speech: "tính từ",
    meaning: "tỏ ra vô lễ, không còn coi người khác ra gì: đứa trẻ xấc láo",
    example: "đứa trẻ xấc láo",
  },
  {
    word: "xắng xở",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) tỏ ra sốt sắng, nhanh nhảu: xắng xở nói * xắng xở chạy đi trước",
    example: "xắng xở nói * xắng xở chạy đi trước",
  },
  {
    word: "xăng văng",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) vội vã và tất tả: chạy xăng văng hết chỗ nọ tới chỗ kia",
    example: "chạy xăng văng hết chỗ nọ tới chỗ kia",
  },
  {
    word: "xấc",
    part_of_speech: "tính từ",
    meaning: "thiếu lễ độ, khinh thường người khác: thái độ rất xấc",
    example: "thái độ rất xấc",
  },
  {
    word: "xấc xược",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra vô lễ, khinh thường, xúc phạm người trên: thái độ xấc xược * ăn nói xấc xược",
    example: "thái độ xấc xược * ăn nói xấc xược",
  },
  {
    word: "xẩm",
    part_of_speech: "danh từ",
    meaning:
      'người mù chuyên đi hát rong: "Tối trời bắt xẩm trông sao, Xẩm thề có thấy ông nào, xẩm đui!" (Cdao)',
    example:
      'Tối trời bắt xẩm trông sao, Xẩm thề có thấy ông nào, xẩm đui!" (Cdao)',
  },
  {
    word: "xâm lăng",
    part_of_speech: "động từ",
    meaning: "như xâm lược: hoạ xâm lăng * quân xâm lăng",
    example: "hoạ xâm lăng * quân xâm lăng",
  },
  {
    word: "xâm canh",
    part_of_speech: "động từ",
    meaning:
      "trồng trọt trên đất không thuộc địa phận của mình: ruộng xâm canh",
    example: "ruộng xâm canh",
  },
  {
    word: "xâm hại",
    part_of_speech: "động từ",
    meaning:
      "xâm phạm đến khiến cho bị tổn hại: rừng ngập mặn bị xâm hại * bị xâm hại đến thân thể",
    example: "rừng ngập mặn bị xâm hại * bị xâm hại đến thân thể",
  },
  {
    word: "xâm nhập",
    part_of_speech: "động từ",
    meaning:
      "đi vào một cách trái phép, thường gây ra tác hại: xâm nhập lãnh thổ * ma tuý xâm nhập vào học đường",
    example: "xâm nhập lãnh thổ * ma tuý xâm nhập vào học đường",
  },
  {
    word: "xâm nhập",
    part_of_speech: "động từ",
    meaning:
      "(yếu tố bên ngoài) nhập vào và tác động đến, gây tác hại: virus xâm nhập vào cơ thể",
    example: "virus xâm nhập vào cơ thể",
  },
  {
    word: "xâm chiếm",
    part_of_speech: "động từ",
    meaning:
      "chiếm đoạt cái thuộc chủ quyền của người khác bằng vũ lực: xâm chiếm đất đai",
    example: "xâm chiếm đất đai",
  },
  {
    word: "xâm chiếm",
    part_of_speech: "động từ",
    meaning:
      "choán hết, chi phối hết tâm tư, tình cảm: nỗi buồn xâm chiếm cõi lòng",
    example: "nỗi buồn xâm chiếm cõi lòng",
  },
  {
    word: "xâm lược",
    part_of_speech: "động từ",
    meaning:
      "cướp đoạt chủ quyền và lãnh thổ của nước khác bằng vũ lực hoặc bằng các thủ đoạn chính trị, kinh tế: chiến tranh xâm lược * đánh đuổi quân xâm lược",
    example: "chiến tranh xâm lược * đánh đuổi quân xâm lược",
  },
  {
    word: "xâm lấn",
    part_of_speech: "động từ",
    meaning:
      "chiếm dần đất đai, lãnh thổ của người khác ở cạnh mình: xâm lấn đất đai * bị giặc sang xâm lấn",
    example: "xâm lấn đất đai * bị giặc sang xâm lấn",
  },
  {
    word: "xâm xẩm",
    part_of_speech: "tính từ",
    meaning: "(trời) vừa mới bắt đầu tối: trời vừa sâm sẩm * sâm sẩm tối",
    example: "trời vừa sâm sẩm * sâm sẩm tối",
  },
  {
    word: "xâm phạm",
    part_of_speech: "động từ",
    meaning:
      "động đến quyền lợi của người khác, chủ quyền của nước khác: xâm phạm bờ cõi * xâm phạm thân thể * quyền tác giả bị xâm phạm",
    example: "xâm phạm bờ cõi * xâm phạm thân thể * quyền tác giả bị xâm phạm",
  },
  {
    word: "xâm thực",
    part_of_speech: "động từ",
    meaning:
      "ăn vào, lấn vào, làm cho bị huỷ hoại: bờ sông bị xâm thực mạnh * nước mặn xâm thực sâu vào đất liền",
    example: "bờ sông bị xâm thực mạnh * nước mặn xâm thực sâu vào đất liền",
  },
  {
    word: "xấp xỉ",
    part_of_speech: "tính từ",
    meaning:
      'gần như ngang bằng nhau, hơn kém nhau không đáng kể: hai đứa cao xấp xỉ nhau * "Phong lưu rất mực hồng quần, Xuân xanh xấp xỉ tới tuần cập kê." (TKiều)',
    example:
      'hai đứa cao xấp xỉ nhau * "Phong lưu rất mực hồng quần, Xuân xanh xấp xỉ tới tuần cập kê." (TKiều)',
  },
  {
    word: "xập xệ",
    part_of_speech: "tính từ",
    meaning: "(hiếm) lôi thôi, tồi tàn: nhà cửa xập xệ",
    example: "nhà cửa xập xệ",
  },
  {
    word: "xầm xì",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) như thầm thì: xầm xì trò chuyện",
    example: "xầm xì trò chuyện",
  },
  {
    word: "xầm xì",
    part_of_speech: "động từ",
    meaning:
      "bàn tán riêng với nhau, không nói công khai ra: xầm xì bàn tán * làm như thế chẳng khỏi người ta xầm xì",
    example: "xầm xì bàn tán * làm như thế chẳng khỏi người ta xầm xì",
  },
  {
    word: "xập xình",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng nhạc có nổi rõ nhiều tiếng trống, kèn ồn ào: tiếng nhạc xập xình",
    example: "tiếng nhạc xập xình",
  },
  {
    word: "xấp",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp nhiều vật mỏng cùng loại xếp chồng lên nhau ngay ngắn: xấp tiền * xấp báo cũ * mua một xấp vải",
    example: "xấp tiền * xấp báo cũ * mua một xấp vải",
  },
  {
    word: "xấp xoã",
    part_of_speech: "tính từ",
    meaning:
      "(tóc) ở trạng thái xoã ra và bồng bềnh một cách tự nhiên: tóc bay xấp xoã",
    example: "tóc bay xấp xoã",
  },
  {
    word: "xập xoè",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả dáng vẻ xoè ra gập lại liên tiếp, đều đặn của vật mỏng hình cánh, thường gây ra tiếng động nhẹ: bướm bay xập xoè * nếp váy rung rinh xập xoè",
    example: "bướm bay xập xoè * nếp váy rung rinh xập xoè",
  },
  {
    word: "xâu",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) tiền hồ: tiền xâu * chứa bạc lấy xâu",
    example: "tiền xâu * chứa bạc lấy xâu",
  },
  {
    word: "xâu",
    part_of_speech: "động từ",
    meaning:
      "xuyên qua lỗ hoặc nói chung xuyên qua bằng sợi dây, bằng que để giữ hoặc kết các vật lại với nhau: xâu kim * xâu chuỗi hạt * xâu lỗ tai",
    example: "xâu kim * xâu chuỗi hạt * xâu lỗ tai",
  },
  {
    word: "xâu",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp những vật được xâu chung lại với nhau: xâu chìa khoá * xâu tiền xu * xâu cá thành từng xâu",
    example: "xâu chìa khoá * xâu tiền xu * xâu cá thành từng xâu",
  },
  {
    word: "xâu",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) tập hợp nhiều người cùng một loại không được coi trọng như nhau, làm thành một đám, một dãy: kéo theo một xâu trẻ con",
    example: "kéo theo một xâu trẻ con",
  },
  {
    word: "xâu",
    part_of_speech: "danh từ",
    meaning: "dãy các kí tự đặt kế tiếp nhau: xử lí xâu kí tự",
    example: "xử lí xâu kí tự",
  },
  {
    word: "xất bất xang bang",
    part_of_speech: "",
    meaning:
      "(phương ngữ, khẩu ngữ) lao đao, khốn đốn, không còn biết phải xoay xở thế nào nữa: chạy xất bất xang bang",
    example: "chạy xất bất xang bang",
  },
  {
    word: "xấu",
    part_of_speech: "tính từ",
    meaning:
      "có hình thức, vẻ ngoài khó coi, gây cảm giác khó chịu, làm cho không muốn nhìn ngắm: chữ xấu * xấu như ma lem",
    example: "chữ xấu * xấu như ma lem",
  },
  {
    word: "xấu",
    part_of_speech: "tính từ",
    meaning:
      "có phẩm chất kém, giá trị thấp: gạo xấu * loại vải xấu * giấy xấu, viết hay bị nhoè",
    example: "gạo xấu * loại vải xấu * giấy xấu, viết hay bị nhoè",
  },
  {
    word: "xấu",
    part_of_speech: "tính từ",
    meaning:
      "thuộc loại có thể gây hại, mang lại điều không hay, đáng phải dè chừng: bị kẻ xấu hãm hại * thời tiết xấu * bệnh tình ngày càng xấu đi",
    example: "bị kẻ xấu hãm hại * thời tiết xấu * bệnh tình ngày càng xấu đi",
  },
  {
    word: "xấu",
    part_of_speech: "tính từ",
    meaning:
      "trái với đạo đức, đáng chê trách, đáng xấu hổ: chơi xấu với bạn bè * xấu mặt vì con * xấu chàng hổ ai (tng)",
    example: "chơi xấu với bạn bè * xấu mặt vì con * xấu chàng hổ ai (tng)",
  },
  {
    word: "xấu đói",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ, hiếm) như háu đói: có tính xấu đói",
    example: "có tính xấu đói",
  },
  {
    word: "xấu chơi",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) không tốt trong cách ăn ở, đối xử với nhau: xấu chơi nên bị bạn bè tẩy chay",
    example: "xấu chơi nên bị bạn bè tẩy chay",
  },
  {
    word: "xâu chuỗi",
    part_of_speech: "động từ",
    meaning:
      "tập hợp, liên kết lại thành một chuỗi, một tuyến: xâu chuỗi các sự kiện lại với nhau",
    example: "xâu chuỗi các sự kiện lại với nhau",
  },
  {
    word: "xấu hổ",
    part_of_speech: "động từ",
    meaning:
      "cảm thấy hổ thẹn khi thấy mình có lỗi hoặc kém cỏi trước người khác: xấu hổ vì đã nói dối * con hư làm cha mẹ xấu hổ",
    example: "xấu hổ vì đã nói dối * con hư làm cha mẹ xấu hổ",
  },
  {
    word: "xấu hổ",
    part_of_speech: "động từ",
    meaning: "ngượng ngùng, e thẹn: tính hay xấu hổ * mặt đỏ bừng vì xấu hổ",
    example: "tính hay xấu hổ * mặt đỏ bừng vì xấu hổ",
  },
  {
    word: "xấu bụng",
    part_of_speech: "tính từ",
    meaning: "có tâm địa xấu, hay làm hại người khác: kẻ xấu bụng",
    example: "kẻ xấu bụng",
  },
  {
    word: "xấu số",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có số phận không may: đứa trẻ xấu số, mồ côi cả cha lẫn mẹ",
    example: "đứa trẻ xấu số, mồ côi cả cha lẫn mẹ",
  },
  {
    word: "xấu số",
    part_of_speech: "tính từ",
    meaning: "bị chết một cách oan uổng: thắp nén hương cho người xấu số",
    example: "thắp nén hương cho người xấu số",
  },
  {
    word: "xấu tính",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có tính hay cáu gắt, không muốn gần gũi, giúp đỡ người khác: thằng cha rất xấu tính * con người xấu tính",
    example: "thằng cha rất xấu tính * con người xấu tính",
  },
  {
    word: "xâu xé",
    part_of_speech: "động từ",
    meaning: "cắn xé nhau để tranh giành: đàn chó xâu xé miếng mồi",
    example: "đàn chó xâu xé miếng mồi",
  },
  {
    word: "xâu xé",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) giằng xé, làm đau đớn về tinh thần: những mâu thuẫn xâu xé trong lòng",
    example: "những mâu thuẫn xâu xé trong lòng",
  },
  {
    word: "xấu xa",
    part_of_speech: "tính từ",
    meaning:
      'có đạo đức kém, đến mức tồi tệ, đáng khinh bỉ: ý nghĩ xấu xa * làm điều xấu xa * "(...) Ong qua bướm lại đã thừa xấu xa." (TKiều)',
    example:
      'ý nghĩ xấu xa * làm điều xấu xa * "(...) Ong qua bướm lại đã thừa xấu xa." (TKiều)',
  },
  {
    word: "xấu xí",
    part_of_speech: "tính từ",
    meaning:
      "có hình thức khó coi, đến mức không ai muốn nhìn: bộ quần áo xấu xí * mặt mũi xấu xí * chữ viết xấu xí, nguệch ngoạc",
    example:
      "bộ quần áo xấu xí * mặt mũi xấu xí * chữ viết xấu xí, nguệch ngoạc",
  },
  {
    word: "xây cất",
    part_of_speech: "động từ",
    meaning:
      "xây dựng nên công trình kiến trúc (nói khái quát): xây cất nhà cửa * mồ mả được xây cất đàng hoàng",
    example: "xây cất nhà cửa * mồ mả được xây cất đàng hoàng",
  },
  {
    word: "xây",
    part_of_speech: "động từ",
    meaning:
      "gắn các loại vật liệu vào nhau bằng chất kết dính (thường là vữa) để làm thành một công trình hay bộ phận công trình: xây nhà * tường xây con kiến * xây tổ ấm (b)",
    example: "xây nhà * tường xây con kiến * xây tổ ấm (b)",
  },
  {
    word: "xây",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) quay (mặt, lưng) về phía nào đó: ngồi xây lưng lại * xây mặt ngó chỗ khác",
    example: "ngồi xây lưng lại * xây mặt ngó chỗ khác",
  },
  {
    word: "xây đắp",
    part_of_speech: "động từ",
    meaning:
      "xây dựng, bồi đắp cho vững chắc thêm (nói khái quát): xây đắp thành trì * xây đắp hạnh phúc",
    example: "xây đắp thành trì * xây đắp hạnh phúc",
  },
  {
    word: "xây dựng gia đình",
    part_of_speech: "động từ",
    meaning:
      "lấy vợ hoặc lấy chồng, lập gia đình riêng: ngoài ba mươi tuổi mới xây dựng gia đình",
    example: "ngoài ba mươi tuổi mới xây dựng gia đình",
  },
  {
    word: "xây xẩm",
    part_of_speech: "tính từ",
    meaning:
      "bị hoa mắt, choáng váng đột ngột, không nhìn thấy gì: xây xẩm mặt mày * trong người xây xẩm khó chịu",
    example: "xây xẩm mặt mày * trong người xây xẩm khó chịu",
  },
  {
    word: "xây dựng",
    part_of_speech: "động từ",
    meaning:
      "làm nên công trình kiến trúc theo một kế hoạch nhất định: xây dựng nhà cửa * vật liệu xây dựng",
    example: "xây dựng nhà cửa * vật liệu xây dựng",
  },
  {
    word: "xây dựng",
    part_of_speech: "động từ",
    meaning:
      "làm cho hình thành một chỉnh thể về xã hội, chính trị, kinh tế, văn hoá theo một phương hướng nhất định: xây dựng cơ đồ * xây dựng đất nước",
    example: "xây dựng cơ đồ * xây dựng đất nước",
  },
  {
    word: "xây dựng",
    part_of_speech: "động từ",
    meaning:
      "tạo ra, sáng tạo ra cái có giá trị tinh thần, có ý nghĩa trừu tượng: xây dựng đề cương * xây dựng những ước mơ",
    example: "xây dựng đề cương * xây dựng những ước mơ",
  },
  {
    word: "xây dựng",
    part_of_speech: "tính từ",
    meaning:
      "(thái độ, ý kiến) có thiện ý, nhằm mục đích làm cho tốt hơn: phê bình trên tinh thần xây dựng",
    example: "phê bình trên tinh thần xây dựng",
  },
  {
    word: "xây lắp",
    part_of_speech: "động từ",
    meaning:
      "xây dựng công trình và lắp đặt thiết bị, máy móc bên trong (nói khái quát): xây lắp công trình * công ti xây lắp điện",
    example: "xây lắp công trình * công ti xây lắp điện",
  },
  {
    word: "xe",
    part_of_speech: "danh từ",
    meaning:
      "phương tiện đi lại hoặc vận tải trên bộ, có bánh lăn: đi xe * chạy xe nhanh * đánh xe ra khỏi ga ra",
    example: "đi xe * chạy xe nhanh * đánh xe ra khỏi ga ra",
  },
  {
    word: "xe",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi một quân trong cờ tướng hay trong bài tam cúc, bài tứ sắc: đi con xe * đôi xe đen",
    example: "đi con xe * đôi xe đen",
  },
  {
    word: "xe",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) chuyên chở bằng xe: xe hàng ra bến * xe người ốm đến bệnh viện",
    example: "xe hàng ra bến * xe người ốm đến bệnh viện",
  },
  {
    word: "xe",
    part_of_speech: "danh từ",
    meaning: "ống dài và nhỏ dùng để hút thuốc lào, thuốc phiện: xe điếu",
    example: "xe điếu",
  },
  {
    word: "xe",
    part_of_speech: "động từ",
    meaning:
      "làm cho các sợi nhỏ xoắn chặt với nhau thành sợi lớn: xe chỉ * xe dây thừng * dã tràng xe cát",
    example: "xe chỉ * xe dây thừng * dã tràng xe cát",
  },
  {
    word: "xe",
    part_of_speech: "động từ",
    meaning:
      "(Văn chương) làm cho kết đôi với nhau thành vợ chồng: duyên trời xe * kết tóc xe tơ",
    example: "duyên trời xe * kết tóc xe tơ",
  },
  {
    word: "xé",
    part_of_speech: "động từ",
    meaning:
      "làm cho đứt rời ra thành từng mảnh bằng cách dùng tay giật mạnh hoặc kéo về hai phía ngược nhau: xé tờ giấy làm đôi * tiếng kêu xé lòng * xé bỏ hiệp ước (b)",
    example: "xé tờ giấy làm đôi * tiếng kêu xé lòng * xé bỏ hiệp ước (b)",
  },
  {
    word: "xé",
    part_of_speech: "động từ",
    meaning:
      "làm cho chia rời ra thành từng phần, từng mảnh: ánh chớp xé màn đêm * tiếng đạn xé gió * con tàu xé sóng ra khơi",
    example: "ánh chớp xé màn đêm * tiếng đạn xé gió * con tàu xé sóng ra khơi",
  },
  {
    word: "xẻ",
    part_of_speech: "động từ",
    meaning:
      "cưa tách gỗ ra thành những tấm mỏng theo chiều dọc: xẻ gỗ * thợ xẻ",
    example: "xẻ gỗ * thợ xẻ",
  },
  {
    word: "xẻ",
    part_of_speech: "động từ",
    meaning:
      'chia, cắt cho rời ra theo chiều dọc, không để liền: áo xẻ tà * "Vầng trăng ai xẻ làm đôi, Nửa in gối chiếc, nửa soi dặm trường." (TKiều)',
    example:
      'áo xẻ tà * "Vầng trăng ai xẻ làm đôi, Nửa in gối chiếc, nửa soi dặm trường." (TKiều)',
  },
  {
    word: "xẻ",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) bổ: xẻ trái mít làm đôi",
    example: "xẻ trái mít làm đôi",
  },
  {
    word: "xẻ",
    part_of_speech: "động từ",
    meaning:
      'đào thành đường dài, thường cho thông, thoát: xẻ rãnh thoát nước * "Xẻ dọc Trường Sơn, đi cứu nước, Mà lòng phơi phới dậy tương lai." (THữu; 43)',
    example:
      'xẻ rãnh thoát nước * "Xẻ dọc Trường Sơn, đi cứu nước, Mà lòng phơi phới dậy tương lai." (THữu; 43)',
  },
  {
    word: "xe bãi",
    part_of_speech: "danh từ",
    meaning:
      "xe cũ ở các bãi thải công nghiệp được nhập về để sử dụng lại: kinh doanh, buôn bán các loại xe bãi",
    example: "kinh doanh, buôn bán các loại xe bãi",
  },
  {
    word: "xe bò",
    part_of_speech: "danh từ",
    meaning:
      "xe thô sơ do trâu bò kéo, có hai bánh, dùng để chuyên chở vật nặng: xe bò chở gạch * đẩy xe bò",
    example: "xe bò chở gạch * đẩy xe bò",
  },
  {
    word: "xe cộ",
    part_of_speech: "danh từ",
    meaning: "xe (nói khái quát): xe cộ nườm nượp * tai nạn xe cộ",
    example: "xe cộ nườm nượp * tai nạn xe cộ",
  },
  {
    word: "xe cơ giới",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi chung các loại xe có động cơ: làn đường dành cho xe cơ giới",
    example: "làn đường dành cho xe cơ giới",
  },
  {
    word: "xe đò",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ, khẩu ngữ) ô tô ca: lơ xe đò * nhảy xe đò về quê",
    example: "lơ xe đò * nhảy xe đò về quê",
  },
  {
    word: "xe hàng",
    part_of_speech: "danh từ",
    meaning: "(cũ) xe khách: mua vé xe hàng đi Hà Nội",
    example: "mua vé xe hàng đi Hà Nội",
  },
  {
    word: "xe hoa",
    part_of_speech: "danh từ",
    meaning:
      "xe con có trang trí hoa của nhà trai đi đón dâu: cô dâu đang bước lên xe hoa",
    example: "cô dâu đang bước lên xe hoa",
  },
  {
    word: "xe hoa",
    part_of_speech: "danh từ",
    meaning:
      "xe có trang trí, đi trong các buổi lễ diễu hành: chiếc xe hoa đang tiến vào lễ đài",
    example: "chiếc xe hoa đang tiến vào lễ đài",
  },
  {
    word: "xe kéo",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) xe tay: phu xe kéo",
    example: "phu xe kéo",
  },
  {
    word: "xe hoả",
    part_of_speech: "danh từ",
    meaning: "(cũ) xe lửa: đầu máy xe hoả",
    example: "đầu máy xe hoả",
  },
  {
    word: "xe khách",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) ô tô lớn chở hành khách trên các tuyến đường dài, thường là các đường liên tỉnh: bến xe khách Bắc-Nam",
    example: "bến xe khách Bắc-Nam",
  },
  {
    word: "xe hơi",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) ô tô: sắm xe hơi, nhà lầu",
    example: "sắm xe hơi, nhà lầu",
  },
  {
    word: "xé lẻ",
    part_of_speech: "động từ",
    meaning:
      "chia, tách nhỏ ra làm nhiều phần, nhiều bộ phận riêng rẽ, không để nguyên khối nữa: khoản tiền bị xé lẻ * xé lẻ đội hình",
    example: "khoản tiền bị xé lẻ * xé lẻ đội hình",
  },
  {
    word: "xe máy",
    part_of_speech: "danh từ",
    meaning:
      "xe hai bánh, chạy bằng động cơ: sửa chữa xe máy * bằng lái xe máy",
    example: "sửa chữa xe máy * bằng lái xe máy",
  },
  {
    word: "xé phay",
    part_of_speech: "động từ",
    meaning:
      "xé thành miếng nhỏ và trộn với gia vị (thường nói về thịt gà luộc): thịt gà xé phay",
    example: "thịt gà xé phay",
  },
  {
    word: "xe lửa",
    part_of_speech: "danh từ",
    meaning: "(cũ) tàu hoả: nhà ga xe lửa",
    example: "nhà ga xe lửa",
  },
  {
    word: "xe ngựa",
    part_of_speech: "danh từ",
    meaning:
      "xe do ngựa kéo, thường có hai bánh, dùng để chở người hoặc hàng hoá: cỗ xe ngựa * đánh xe ngựa",
    example: "cỗ xe ngựa * đánh xe ngựa",
  },
  {
    word: "xe pháo",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) xe, về mặt dùng để đi lại, vận chuyển (nói khái quát): đường đông nghẹt xe pháo * chuẩn bị tiền xe pháo",
    example: "đường đông nghẹt xe pháo * chuẩn bị tiền xe pháo",
  },
  {
    word: "xé rào",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) có hành vi vượt ra ngoài khuôn phép, luật lệ: tư thương xé rào, bán phá giá sản phẩm",
    example: "tư thương xé rào, bán phá giá sản phẩm",
  },
  {
    word: "xe ôm",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) xe máy chuyên dùng để chở khách: đi xe ôm * làm nghề chạy xe ôm",
    example: "đi xe ôm * làm nghề chạy xe ôm",
  },
  {
    word: "cảm kích",
    part_of_speech: "động từ",
    meaning:
      "cảm động và được kích thích tinh thần trước hành vi tốt đẹp của người khác: cảm kích trong lòng * cảm kích vì sự tiếp đãi ân cần",
    example: "cảm kích trong lòng * cảm kích vì sự tiếp đãi ân cần",
  },
  {
    word: "cảm mến",
    part_of_speech: "động từ",
    meaning: "có thiện cảm, có tình cảm mến yêu: đem lòng cảm mến",
    example: "đem lòng cảm mến",
  },
  {
    word: "cam lòng",
    part_of_speech: "động từ",
    meaning:
      "(cũ) thoả lòng, cảm thấy tự bằng lòng làm việc gì hoặc trước việc gì: được vậy thì dẫu chết cũng cam lòng",
    example: "được vậy thì dẫu chết cũng cam lòng",
  },
  {
    word: "cam lòng",
    part_of_speech: "động từ",
    meaning: "(hiếm) như cam tâm: cam lòng theo giặc",
    example: "cam lòng theo giặc",
  },
  {
    word: "cảm nghiệm",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) cảm nhận được qua chiêm nghiệm từ thực tế: chưa cảm nghiệm được hết giá trị của cuộc sống",
    example: "chưa cảm nghiệm được hết giá trị của cuộc sống",
  },
  {
    word: "cảm nghĩ",
    part_of_speech: "",
    meaning:
      "ý nghĩ nảy sinh do có sự rung động trước điều gì: điều đó gợi lên nhiều cảm nghĩ * phát biểu cảm nghĩ",
    example: "điều đó gợi lên nhiều cảm nghĩ * phát biểu cảm nghĩ",
  },
  {
    word: "cảm khái",
    part_of_speech: "động từ",
    meaning:
      "có cảm xúc và thương cảm ngậm ngùi: lời thơ cảm khái * cảm khái trước cảnh chia li",
    example: "lời thơ cảm khái * cảm khái trước cảnh chia li",
  },
  {
    word: "cảm nhận",
    part_of_speech: "động từ",
    meaning:
      "nhận biết bằng cảm tính hoặc bằng giác quan: cảm nhận được nỗi đau của bạn * cảm nhận thấy có điều không hay sắp xảy ra",
    example:
      "cảm nhận được nỗi đau của bạn * cảm nhận thấy có điều không hay sắp xảy ra",
  },
  {
    word: "cam phận",
    part_of_speech: "động từ",
    meaning:
      "cam chịu với cảnh sống không như ý của mình: cam phận làm lẽ mọn * sống cam phận",
    example: "cam phận làm lẽ mọn * sống cam phận",
  },
  {
    word: "cảm phiền",
    part_of_speech: "động từ",
    meaning:
      "phiền, làm phiền (từ dùng trong lời yêu cầu, đề nghị một cách lịch sự hoặc kiểu cách): cảm phiền anh cho tôi đi nhờ * cảm phiền bác chuyển giúp món quà",
    example: "cảm phiền anh cho tôi đi nhờ * cảm phiền bác chuyển giúp món quà",
  },
  {
    word: "cảm quan",
    part_of_speech: "",
    meaning:
      "nhận thức, cảm nhận trực tiếp bằng các giác quan: kiểm tra sản phẩm bằng phương pháp cảm quan",
    example: "kiểm tra sản phẩm bằng phương pháp cảm quan",
  },
  {
    word: "cảm phục",
    part_of_speech: "động từ",
    meaning: "cảm động và khâm phục: cảm phục tinh thần dũng cảm",
    example: "cảm phục tinh thần dũng cảm",
  },
  {
    word: "cảm ơn",
    part_of_speech: "động từ",
    meaning:
      "tỏ sự biết ơn (đối với người đã giúp đỡ mình): tỏ lòng cảm ơn * cảm ơn sự giúp đỡ của mọi người",
    example: "tỏ lòng cảm ơn * cảm ơn sự giúp đỡ của mọi người",
  },
  {
    word: "cảm ơn",
    part_of_speech: "động từ",
    meaning:
      "từ dùng trong lời nói lịch sự, để bày tỏ sự cảm kích với người đã làm việc gì đó cho mình, hoặc để nhận lời hay từ chối điều gì: cảm ơn mọi người đã chú ý lắng nghe",
    example: "cảm ơn mọi người đã chú ý lắng nghe",
  },
  {
    word: "cam sành",
    part_of_speech: "danh từ",
    meaning:
      'cam quả có vỏ dày, sần sùi: "Chẳng chua cũng thể là chanh, Chẳng ngọt cũng thể cam sành chín cây." (ca dao)',
    example:
      'Chẳng chua cũng thể là chanh, Chẳng ngọt cũng thể cam sành chín cây." (ca dao)',
  },
  {
    word: "cảm tạ",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) tỏ lòng biết ơn: nói mấy lời cảm tạ * xin cảm tạ tấm thịnh tình của các bạn dành cho tôi!",
    example:
      "nói mấy lời cảm tạ * xin cảm tạ tấm thịnh tình của các bạn dành cho tôi!",
  },
  {
    word: "cảm thụ",
    part_of_speech: "động từ",
    meaning:
      "(giác quan) tiếp nhận sự kích thích của sự vật bên ngoàI: năng lực cảm thụ của tai",
    example: "năng lực cảm thụ của tai",
  },
  {
    word: "cảm thụ",
    part_of_speech: "động từ",
    meaning:
      "nhận biết được cái tế nhị bằng cảm tính: cảm thụ cái hay, cái đẹp của một bài thơ * khả năng cảm thụ nghệ thuật",
    example:
      "cảm thụ cái hay, cái đẹp của một bài thơ * khả năng cảm thụ nghệ thuật",
  },
  {
    word: "cam tâm",
    part_of_speech: "động từ",
    meaning:
      "cảm thấy vẫn tự bằng lòng được khi làm điều thừa biết là xấu xa, nhục nhã: cam tâm ruồng bỏ vợ con",
    example: "cam tâm ruồng bỏ vợ con",
  },
  {
    word: "cam tâm",
    part_of_speech: "động từ",
    meaning:
      '(cũ) thoả lòng: "(…) Bính muốn ở mãi đây dù bị mưa rét cũng cam tâm." (NgHồng; 1)',
    example: '(…) Bính muốn ở mãi đây dù bị mưa rét cũng cam tâm." (NgHồng; 1)',
  },
  {
    word: "cảm thông",
    part_of_speech: "động từ",
    meaning:
      "thông cảm và chia sẻ một cách sâu sắc: cảm thông với nỗi đau của người khác",
    example: "cảm thông với nỗi đau của người khác",
  },
  {
    word: "cảm thức",
    part_of_speech: "danh từ",
    meaning:
      "điều nhận thức được bằng cảm quan; nhận thức cảm giác: cảm thức dân tộc * cảm thức về thời gian của trẻ nhỏ",
    example: "cảm thức dân tộc * cảm thức về thời gian của trẻ nhỏ",
  },
  {
    word: "cảm từ",
    part_of_speech: "danh từ",
    meaning:
      '(ngữ pháp) từ dùng riêng biệt, không có quan hệ cú pháp với những từ khác, chuyên biểu thị sự phản ứng tình cảm, dùng làm tiếng gọi, tiếng đáp, tiếng reo vui, than vãn, nguyền rủa, chửi bới, v.v.: "ái chà", "ôi", "chao ôi" là một số cảm từ trong tiếng Việt.',
    example: 'ái chà", "ôi", "chao ôi" là một số cảm từ trong tiếng Việt.',
  },
  {
    word: "cảm thương",
    part_of_speech: "động từ",
    meaning:
      'như thương cảm: "Cảm thương con hạc ở chùa, Muốn bay da diết, có rùa giữ chân." (ca dao)',
    example:
      'Cảm thương con hạc ở chùa, Muốn bay da diết, có rùa giữ chân." (ca dao)',
  },
  {
    word: "cảm tình",
    part_of_speech: "danh từ",
    meaning:
      "tình cảm tốt (đối với người, với sự việc): gây được cảm tình * có cảm tình với nhau",
    example: "gây được cảm tình * có cảm tình với nhau",
  },
  {
    word: "cảm tình",
    part_of_speech: "động từ",
    meaning:
      'có quan hệ trực tiếp làm ảnh hưởng đến, tác động đến: việc của tôi can gì đến anh * "(...) Tội con con chịu can chi đến chàng!" (PCCH)',
    example:
      'việc của tôi can gì đến anh * "(...) Tội con con chịu can chi đến chàng!" (PCCH)',
  },
  {
    word: "cảm tử",
    part_of_speech: "động từ",
    meaning:
      "sẵn sàng nhận lấy cái chết, tình nguyện hi sinh mà chiến đấu vì nghĩa lớn: đội quân cảm tử * đánh bom cảm tử",
    example: "đội quân cảm tử * đánh bom cảm tử",
  },
  {
    word: "cảm tính",
    part_of_speech: "danh từ",
    meaning:
      "giai đoạn đầu của nhận thức, dựa trên cảm giác, chưa nắm được bản chất và quy luật của sự vật: nhận thức cảm tính",
    example: "nhận thức cảm tính",
  },
  {
    word: "cảm tưởng",
    part_of_speech: "danh từ",
    meaning:
      "sự suy nghĩ hoặc ý nghĩ nảy sinh do tiếp xúc với sự vật khách quan: phát biểu cảm tưởng * trông quen quen, cảm tưởng như gặp ở đâu rồi!",
    example:
      "phát biểu cảm tưởng * trông quen quen, cảm tưởng như gặp ở đâu rồi!",
  },
  {
    word: "camera",
    part_of_speech: "danh từ",
    meaning: "máy quay phim thu hình: đứng trước ống kính camera",
    example: "đứng trước ống kính camera",
  },
  {
    word: "cảm ứng",
    part_of_speech: "danh từ",
    meaning: "cảm ứng điện từ (nói tắt): trường điện cảm ứng * bộ cảm ứng",
    example: "trường điện cảm ứng * bộ cảm ứng",
  },
  {
    word: "cảm ứng",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) (khả năng) tiếp thu các kích thích của môi trường và phản ứng lạI: các giác quan cảm ứng * da trẻ em dễ cảm ứng với sự thay đổi của thời tiết",
    example:
      "các giác quan cảm ứng * da trẻ em dễ cảm ứng với sự thay đổi của thời tiết",
  },
  {
    word: "cạn",
    part_of_speech: "tính từ",
    meaning:
      '(vật, nơi chứa nước) ở tình trạng hết dần hoặc đã hết sạch nước: bể cạn nước * "Sen xa hồ sen khô hồ cạn, Lựu xa đào lựu ngả đào nghiêng." (ca dao)',
    example:
      'bể cạn nước * "Sen xa hồ sen khô hồ cạn, Lựu xa đào lựu ngả đào nghiêng." (ca dao)',
  },
  {
    word: "cạn",
    part_of_speech: "tính từ",
    meaning:
      "ở tình trạng đã hết hoặc gần hết, không còn mấy nữa: vốn liếng cạn sạch * cạn bầu tâm sự * nói cho cạn lời",
    example: "vốn liếng cạn sạch * cạn bầu tâm sự * nói cho cạn lời",
  },
  {
    word: "cạn",
    part_of_speech: "tính từ",
    meaning:
      '(cũ, hoặc ph) như nông: "Lên non mới biết non cao, Lội sông mới biết sông nào cạn sâu." (ca dao)',
    example:
      'Lên non mới biết non cao, Lội sông mới biết sông nào cạn sâu." (ca dao)',
  },
  {
    word: "cạn",
    part_of_speech: "tính từ",
    meaning:
      "(suy nghĩ) hời hợt, không sâu sắc: nó là đứa cạn nghĩ * suy nghĩ hơi cạn * cạn lòng",
    example: "nó là đứa cạn nghĩ * suy nghĩ hơi cạn * cạn lòng",
  },
  {
    word: "cạn",
    part_of_speech: "danh từ",
    meaning:
      "chỗ nông hoặc không có nước, phân biệt với chỗ sâu hoặc có nước: rau muống cạn * bỏ thuyền lên cạn * thuyền mắc cạn",
    example: "rau muống cạn * bỏ thuyền lên cạn * thuyền mắc cạn",
  },
  {
    word: "can",
    part_of_speech: "động từ",
    meaning:
      "nối vải hay giấy cho dài ra, rộng ra: can thêm một gấu áo * can giấy làm diều",
    example: "can thêm một gấu áo * can giấy làm diều",
  },
  {
    word: "can",
    part_of_speech: "động từ",
    meaning:
      "sao lại theo từng nét của bản vẽ mẫu đặt áp sát ở dưới hay ở trên mặt giấy: can bản đồ",
    example: "can bản đồ",
  },
  {
    word: "can",
    part_of_speech: "động từ",
    meaning:
      "khuyên ngăn ai đó thôi hoặc không nên làm việc gì: việc này rất nguy hiểm, tôi can anh đấy! * thấy đánh nhau thì nhảy vào can",
    example:
      "việc này rất nguy hiểm, tôi can anh đấy! * thấy đánh nhau thì nhảy vào can",
  },
  {
    word: "cán",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận dùng để cầm, nắm ở một số dụng cụ, đồ vật, thường có hình trụ: cán cuốc * cán dao * cán cờ",
    example: "cán cuốc * cán dao * cán cờ",
  },
  {
    word: "cán",
    part_of_speech: "động từ",
    meaning:
      "ép cho mỏng đều bằng trục lăn: cán bột làm bánh * kĩ thuật cán thép",
    example: "cán bột làm bánh * kĩ thuật cán thép",
  },
  {
    word: "cán",
    part_of_speech: "động từ",
    meaning: "(tàu, xe) lăn đè lên trên người hoặc động vật: bị xe cán chết",
    example: "bị xe cán chết",
  },
  {
    word: "cảm xúc",
    part_of_speech: "động từ",
    meaning:
      "có tư tưởng, tình cảm nảy sinh do tiếp xúc với sự việc khách quan: người dễ cảm xúc",
    example: "người dễ cảm xúc",
  },
  {
    word: "cảm xúc",
    part_of_speech: "danh từ",
    meaning:
      "tình cảm nảy sinh do có sự rung động trong lòng: bày tỏ cảm xúc * cố ghìm nén cảm xúc * mặt lạnh tanh, không một chút cảm xúc",
    example:
      "bày tỏ cảm xúc * cố ghìm nén cảm xúc * mặt lạnh tanh, không một chút cảm xúc",
  },
  {
    word: "cản",
    part_of_speech: "động từ",
    meaning:
      "ngăn giữ lại, không cho tiếp tục vận động hoặc hoạt động theo một hướng nào đó: cản bước tiến của địch * đã quyết thì không ai cản được",
    example: "cản bước tiến của địch * đã quyết thì không ai cản được",
  },
  {
    word: "cản",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) đập ngăn nước: đắp cản trên sông * xả cản",
    example: "đắp cản trên sông * xả cản",
  },
  {
    word: "cán bộ",
    part_of_speech: "danh từ",
    meaning:
      "người làm việc trong cơ quan, đoàn thể, đảm nhiệm một công tác lãnh đạo hoặc công tác quản lí, công tác nghiệp vụ chuyên môn nhất định: cán bộ nghiên cứu * cán bộ lãnh đạo * cán bộ khoa học",
    example: "cán bộ nghiên cứu * cán bộ lãnh đạo * cán bộ khoa học",
  },
  {
    word: "càn",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) vượt thẳng qua bất chấp mọi trở ngại gặp phảI: đi càn rừng * xe tăng càn qua bãi mìn",
    example: "đi càn rừng * xe tăng càn qua bãi mìn",
  },
  {
    word: "càn",
    part_of_speech: "động từ",
    meaning:
      "đưa quân ồ ạt tràn vào vùng nào đó để lùng sục, tiêu diệt đối phương: du kích chống càn",
    example: "du kích chống càn",
  },
  {
    word: "càn",
    part_of_speech: "tính từ",
    meaning:
      "(hành động) bừa, không kể gì phải hay trái, nên hay không nên: chó dại cắn càn * nói càn nói bậy",
    example: "chó dại cắn càn * nói càn nói bậy",
  },
  {
    word: "cán cân",
    part_of_speech: "danh từ",
    meaning:
      "đòn cân, thường dùng để ví mối tương quan giữa hai bên, hai lực lượng: cán cân thương mại * cán cân công lí",
    example: "cán cân thương mại * cán cân công lí",
  },
  {
    word: "can dự",
    part_of_speech: "động từ",
    meaning:
      'dự vào, tham gia vào việc, thường là việc không hay: can dự vào một vụ cướp * "(...) tôi đâu đủ ba đầu sáu tay để can dự vào mọi chuyện lớn nhỏ trên đời này được." (NgKiên; 8)',
    example:
      'can dự vào một vụ cướp * "(...) tôi đâu đủ ba đầu sáu tay để can dự vào mọi chuyện lớn nhỏ trên đời này được." (NgKiên; 8)',
  },
  {
    word: "can dự",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) (sự việc) có quan hệ trực tiếp: việc của nó, can dự gì đến mình? * chuyện của tôi, chẳng can dự đến ai hết!",
    example:
      "việc của nó, can dự gì đến mình? * chuyện của tôi, chẳng can dự đến ai hết!",
  },
  {
    word: "can án",
    part_of_speech: "động từ",
    meaning: "phạm tội và đã bị kết án: can án giết người",
    example: "can án giết người",
  },
  {
    word: "càn bậy",
    part_of_speech: "tính từ",
    meaning:
      "(hành động) bậy bạ, bất chấp phải trái, khuôn phép: ăn nói càn bậy * làm lắm điều càn bậy",
    example: "ăn nói càn bậy * làm lắm điều càn bậy",
  },
  {
    word: "can đảm",
    part_of_speech: "tính từ",
    meaning:
      "có dũng khí để không sợ nguy hiểm, đau khổ: một con người can đảm *  không đủ can đảm để nhận lỗi",
    example: "một con người can đảm *  không đủ can đảm để nhận lỗi",
  },
  {
    word: "cạn chén",
    part_of_speech: "động từ",
    meaning: "uống hết chén rượu: xin mời quý vị cạn chén",
    example: "xin mời quý vị cạn chén",
  },
  {
    word: "can cớ",
    part_of_speech: "danh từ",
    meaning:
      '(hiếm) như cơn cớ: "Dù khi gió kép, mưa đơn, Có ta đây, cũng chẳng can cớ gì!" (TKiều)',
    example:
      'Dù khi gió kép, mưa đơn, Có ta đây, cũng chẳng can cớ gì!" (TKiều)',
  },
  {
    word: "can hệ",
    part_of_speech: "động từ",
    meaning:
      '(sự việc) liên quan trực tiếp, làm ảnh hưởng (đến ai hoặc việc gì): điều đó không can hệ gì đến tôi * "Bây giờ Quỳ thấy việc ấy (...) có can hệ mật thiết đến đời nàng." (ĐĐThu; 2)',
    example:
      'điều đó không can hệ gì đến tôi * "Bây giờ Quỳ thấy việc ấy (...) có can hệ mật thiết đến đời nàng." (ĐĐThu; 2)',
  },
  {
    word: "can hệ",
    part_of_speech: "tính từ",
    meaning: "(cũ) hệ trọng: việc này can hệ lắm!",
    example: "việc này can hệ lắm!",
  },
  {
    word: "can gián",
    part_of_speech: "động từ",
    meaning: "(cũ, hiếm) khuyên can vua hoặc người trên: dâng sớ can gián vua",
    example: "dâng sớ can gián vua",
  },
  {
    word: "càn khôn",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) trời đất, vũ trụ: "Cán cân tạo hoá rơi đâu mất, Miệng túi càn khôn khép lại rồi." (HXHương; 21)',
    example:
      'Cán cân tạo hoá rơi đâu mất, Miệng túi càn khôn khép lại rồi." (HXHương; 21)',
  },
  {
    word: "cạn lời",
    part_of_speech: "động từ",
    meaning:
      'nói hết, bày tỏ hết: "Nhớ lời thề thốt năm xưa, Tình đây duyên đó phân chưa cạn lời." (ca dao)',
    example:
      'Nhớ lời thề thốt năm xưa, Tình đây duyên đó phân chưa cạn lời." (ca dao)',
  },
  {
    word: "can ngăn",
    part_of_speech: "động từ",
    meaning:
      "can không để cho làm (nói khái quát): đã quyết thì không ai can ngăn nổi",
    example: "đã quyết thì không ai can ngăn nổi",
  },
  {
    word: "cạn kiệt",
    part_of_speech: "động từ",
    meaning:
      "cạn sạch, đến mức không còn tìm đâu, lấy đâu ra nữa: bể nước đã cạn kiệt * cạn kiệt sức lực",
    example: "bể nước đã cạn kiệt * cạn kiệt sức lực",
  },
  {
    word: "can phạm",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) phạm vào tội mà pháp luật đã quy định: can phạm vào tội giết người",
    example: "can phạm vào tội giết người",
  },
  {
    word: "cản phá",
    part_of_speech: "động từ",
    meaning:
      "ngăn cản, làm cho đối phương không tiến công được (nói khái quát): hậu vệ cản phá bóng * cản phá các đợt tấn công của địch",
    example: "hậu vệ cản phá bóng * cản phá các đợt tấn công của địch",
  },
  {
    word: "can qua",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) mộc và giáo; chỉ chiến tranh, về mặt giết chóc, loạn lạc: "Bao giờ dân nổi can qua, Con vua thất thế, lại ra ở chùa." (ca dao)',
    example:
      'Bao giờ dân nổi can qua, Con vua thất thế, lại ra ở chùa." (ca dao)',
  },
  {
    word: "càn lướt",
    part_of_speech: "",
    meaning:
      "xông thẳng tới một cách mạnh mẽ và vượt qua tất cả, bất chấp mọi sự ngăn cản, trở ngạI: càn lướt vào đám đông * lối chơi bóng càn lướt",
    example: "càn lướt vào đám đông * lối chơi bóng càn lướt",
  },
  {
    word: "cản quang",
    part_of_speech: "động từ",
    meaning: "ngăn không cho tia roentgen xuyên qua: chất cản quang",
    example: "chất cản quang",
  },
  {
    word: "cản ngăn",
    part_of_speech: "động từ",
    meaning: "như ngăn cản: cản ngăn một việc làm sai trái",
    example: "cản ngăn một việc làm sai trái",
  },
  {
    word: "càn quét",
    part_of_speech: "động từ",
    meaning:
      "hành quân để vây ráp, bắt bớ, giết chóc hàng loạt: giặc mở cuộc càn quét lớn",
    example: "giặc mở cuộc càn quét lớn",
  },
  {
    word: "càn quấy",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có những hành động càn rỡ, không chịu vào khuôn phép: loại người càn quấy * một lũ thanh niên càn quấy",
    example: "loại người càn quấy * một lũ thanh niên càn quấy",
  },
  {
    word: "cạn queo",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) (vật, nơi chứa nước) cạn đến mức hầu như không còn sót lại tí nào: bể nước cạn queo",
    example: "bể nước cạn queo",
  },
  {
    word: "cán sự",
    part_of_speech: "danh từ",
    meaning: "cán bộ chuyên trách một loại công việc nhất định: ban cán sự lớp",
    example: "ban cán sự lớp",
  },
  {
    word: "can tội",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) phạm vào tội: can tội giết người * can tội trốn thuế",
    example: "can tội giết người * can tội trốn thuế",
  },
  {
    word: "cản trở",
    part_of_speech: "",
    meaning:
      "gây trở ngại, làm cho không tiến hành được dễ dàng: cây đổ làm cản trở giao thông * cố tình cản trở công việc của người khác",
    example:
      "cây đổ làm cản trở giao thông * cố tình cản trở công việc của người khác",
  },
  {
    word: "can thiệp",
    part_of_speech: "động từ",
    meaning:
      "dự vào việc của người khác nhằm tác động đến để cho việc diễn biến theo mục đích nào đó: không can thiệp vào chuyện riêng của người khác * can thiệp vũ trang * nhờ pháp luật can thiệp",
    example:
      "không can thiệp vào chuyện riêng của người khác * can thiệp vũ trang * nhờ pháp luật can thiệp",
  },
  {
    word: "cạn xợt",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ, khẩu ngữ) rất nông, rất cạn: con suối cạn xợt",
    example: "con suối cạn xợt",
  },
  {
    word: "cáng",
    part_of_speech: "danh từ",
    meaning:
      "võng mắc vào đòn, có mui che, thời trước dùng để khiêng người: phu khiêng cáng",
    example: "phu khiêng cáng",
  },
  {
    word: "cáng",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ có hai đòn để khiêng người ốm hoặc người bị thương: chiếc cáng cứu thương",
    example: "chiếc cáng cứu thương",
  },
  {
    word: "cáng",
    part_of_speech: "động từ",
    meaning:
      "khiêng đi bằng cáng: phu trạm cáng người qua núi * cáng thương binh về tuyến sau",
    example: "phu trạm cáng người qua núi * cáng thương binh về tuyến sau",
  },
  {
    word: "cáng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) cáng đáng (nói tắt): nhà ít người nên phải cáng hết mọi việc",
    example: "nhà ít người nên phải cáng hết mọi việc",
  },
  {
    word: "càn rỡ",
    part_of_speech: "tính từ",
    meaning:
      "ngang ngược, không kể gì phải trái, hay dở: ăn nói càn rỡ * những việc làm càn rỡ",
    example: "ăn nói càn rỡ * những việc làm càn rỡ",
  },
  {
    word: "can trường",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, văn chương) gan và ruột; dùng để chỉ nỗi lòng, tâm tình: thổ lộ can trường * can trường xót xa",
    example: "thổ lộ can trường * can trường xót xa",
  },
  {
    word: "can trường",
    part_of_speech: "tính từ",
    meaning: "gan góc, không sợ nguy hiểm: làm được thế đã là can trường lắm!",
    example: "làm được thế đã là can trường lắm!",
  },
  {
    word: "càng",
    part_of_speech: "danh từ",
    meaning:
      "hai chân trước rất lớn ở một số loài như tôm, cua, dùng để kẹp thức ăn và tự vệ: càng tôm * con cua tám cẳng hai càng",
    example: "càng tôm * con cua tám cẳng hai càng",
  },
  {
    word: "càng",
    part_of_speech: "danh từ",
    meaning:
      "hai chân sau cùng, lớn và khoẻ ở một số loài như cào cào, châu chấu, dế, v.v., dùng để bật nhảy.",
    example: "càng xe bò * cái kìm bị gãy một càng",
  },
  {
    word: "càng",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị mức độ tăng thêm là do nguyên nhân nhất định nào đó: có gió, lửa càng bốc to * khó khăn càng chồng chất",
    example: "có gió, lửa càng bốc to * khó khăn càng chồng chất",
  },
  {
    word: "càng",
    part_of_speech: "phụ từ",
    meaning:
      'từ biểu thị mức độ cùng tăng thêm như nhau: càng làm càng thấy khó * trời càng về chiều càng lạnh * "Dễ dàng là thói hồng nhan, Càng cay nghiệt lắm, càng oan trái nhiều!" (TKiều)',
    example:
      'càng làm càng thấy khó * trời càng về chiều càng lạnh * "Dễ dàng là thói hồng nhan, Càng cay nghiệt lắm, càng oan trái nhiều!" (TKiều)',
  },
  {
    word: "cảng",
    part_of_speech: "danh từ",
    meaning:
      "nơi có công trình và thiết bị phục vụ cho tàu, thuyền ra vào để hành khách lên xuống và xếp dỡ hàng hoá: cảng sông * cảng biển * cảng hàng không",
    example: "cảng sông * cảng biển * cảng hàng không",
  },
  {
    word: "cảng hàng không",
    part_of_speech: "danh từ",
    meaning:
      "sân bay lớn, có công trình và thiết bị chuyên dùng cho việc bốc dỡ hàng hoá và hành khách lên xuống: cảng hàng không dân dụng Nội Bài",
    example: "cảng hàng không dân dụng Nội Bài",
  },
  {
    word: "càng ngày càng",
    part_of_speech: "",
    meaning:
      "như ngày càng: trời càng ngày càng lạnh * người đến xem càng ngày càng đông",
    example: "trời càng ngày càng lạnh * người đến xem càng ngày càng đông",
  },
  {
    word: "càng cua",
    part_of_speech: "danh từ",
    meaning: "chứng bệnh gây viêm tấy, sưng to ở kẽ ngón tay: lên càng cua",
    example: "lên càng cua",
  },
  {
    word: "cánh",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận để bay của chim, dơi, côn trùng, có hình tấm, rộng bản, thành đôi đối xứng nhau ở hai bên thân mình và có thể mở ra khép vào: cánh bướm rập rờn * chim nghiêng cánh lượn",
    example: "cánh bướm rập rờn * chim nghiêng cánh lượn",
  },
  {
    word: "cánh",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận giống hình cánh chim chìa ra hai bên thân máy bay để tạo độ thăng bằng khi bay: máy bay cánh cụp cánh xoè",
    example: "máy bay cánh cụp cánh xoè",
  },
  {
    word: "cánh",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận của hoa, hình những lá mỏng, có màu sắc, nằm ở xung quanh nhị hoa, phía trong đài hoa: bông hoa năm cánh * hoa rã cánh",
    example: "bông hoa năm cánh * hoa rã cánh",
  },
  {
    word: "cánh",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận chìa ra xung quanh một tâm, như hình cánh hoa, ở một số vật: cánh chong chóng quay tít * cánh quạt máy * ngôi sao vàng năm cánh",
    example:
      "cánh chong chóng quay tít * cánh quạt máy * ngôi sao vàng năm cánh",
  },
  {
    word: "cánh",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận hình tấm có thể khép vào mở ra được, ở một số vật: khép cánh cửa lại * cánh tủ * cánh buồm đỏ thắm",
    example: "khép cánh cửa lại * cánh tủ * cánh buồm đỏ thắm",
  },
  {
    word: "cánh",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận của cơ thể người, từ vai đến cổ tay ở hai bên thân mình; thường coi là biểu tượng của hoạt động đấu tranh của con người: khoác cánh nhau đi * tát thẳng cánh * kề vai sát cánh",
    example: "khoác cánh nhau đi * tát thẳng cánh * kề vai sát cánh",
  },
  {
    word: "cánh",
    part_of_speech: "danh từ",
    meaning:
      "khoảng đất dài và rộng nằm trải ra: cánh đồng * cánh rừng bạt ngàn * hai thửa ruộng liền cánh",
    example: "cánh đồng * cánh rừng bạt ngàn * hai thửa ruộng liền cánh",
  },
  {
    word: "cánh",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận lực lượng ở về một phía, một bên nào đó của một đội ngũ, một tổ chức: đội quân chia làm ba cánh * cánh tả của một chính đảng",
    example: "đội quân chia làm ba cánh * cánh tả của một chính đảng",
  },
  {
    word: "cánh",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) phe, bọn (có ý khinh thường hoặc thân mật): cánh đi buôn chuyến",
    example: "cánh đi buôn chuyến",
  },
  {
    word: "cáng đáng",
    part_of_speech: "động từ",
    meaning:
      "nhận lấy và làm phần công việc (thường khó khăn), coi đó là trách nhiệm và nghĩa vụ của mình: cáng đáng mọi việc trong nhà * việc này, tôi không cáng đáng nổi",
    example: "cáng đáng mọi việc trong nhà * việc này, tôi không cáng đáng nổi",
  },
  {
    word: "cảnh",
    part_of_speech: "danh từ",
    meaning:
      "nhạc khí gõ gồm một thanh la nhỏ bằng đồng thau, mắc vào một cái khung, thường đánh cùng với tiu.",
    example: "ngắm cảnh * cảnh mùa xuân",
  },
  {
    word: "cảnh",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ sự vật, hiện tượng bày ra trước mắt ở một nơi, một lúc nào đó: ngắm cảnh * cảnh mùa xuân",
    example: "nuôi cá vàng làm cảnh * vườn cây cảnh * cá cảnh",
  },
  {
    word: "cảnh",
    part_of_speech: "danh từ",
    meaning:
      "(Nam kiểng) vật nuôi, trồng hoặc tạo ra để ngắm, để giải trí: nuôi cá vàng làm cảnh * vườn cây cảnh * cá cảnh",
    example: "kịch một hồi hai cảnh",
  },
  {
    word: "cảnh",
    part_of_speech: "danh từ",
    meaning:
      "phần nhỏ của một hồi hoặc một màn kịch, trong đó sự việc diễn ra tại một địa điểm nhất định: kịch một hồi hai cảnh",
    example: "hoàn thành một cảnh quay",
  },
  {
    word: "cảnh",
    part_of_speech: "danh từ",
    meaning:
      "hình ảnh sự vật ở một nơi, một lúc nào đó, được ghi lại bằng phim: hoàn thành một cảnh quay",
    example: "cảnh nghèo * cảnh tù đày * cảnh sống vất vưởng",
  },
  {
    word: "cạnh",
    part_of_speech: "danh từ",
    meaning:
      "chỗ một mặt phẳng tiếp giáp với một mặt phẳng khác trong cùng một vật: mảnh chai có cạnh sắc * không tì ngực vào cạnh bàn",
    example: "mảnh chai có cạnh sắc * không tì ngực vào cạnh bàn",
  },
  {
    word: "cạnh",
    part_of_speech: "danh từ",
    meaning:
      "chỗ sát liền bên: nhà ở cạnh đường * đứng cạnh nhau * bên cạnh thuận lợi cũng còn một số khó khăn",
    example:
      "nhà ở cạnh đường * đứng cạnh nhau * bên cạnh thuận lợi cũng còn một số khó khăn",
  },
  {
    word: "cạnh",
    part_of_speech: "danh từ",
    meaning:
      "đoạn thẳng làm thành phần của một hình: hình vuông có bốn cạnh bằng nhau * cạnh của một góc",
    example: "hình vuông có bốn cạnh bằng nhau * cạnh của một góc",
  },
  {
    word: "canh",
    part_of_speech: "danh từ",
    meaning:
      "món ăn có nhiều nước, thường nấu bằng rau với thịt hoặc tôm cá, dùng ăn với cơm: nấu canh * bát canh cua",
    example: "nấu canh * bát canh cua",
  },
  {
    word: "canh",
    part_of_speech: "danh từ",
    meaning:
      "sợi dọc trên khung cửi hay máy dệt đã luồn qua go và khổ; phân biệt với sợi ngang, gọi là chỉ: canh tơ chỉ vải",
    example: "canh tơ chỉ vải",
  },
  {
    word: "canh",
    part_of_speech: "danh từ",
    meaning:
      'khoảng thời gian bằng một phần năm của đêm, thời trước dùng làm đơn vị tính thời gian về ban đêm: trống điểm canh * "Người về chiếc bóng năm canh, Kẻ đi muôn dặm một mình xa xôi." (TKiều)',
    example:
      'trống điểm canh * "Người về chiếc bóng năm canh, Kẻ đi muôn dặm một mình xa xôi." (TKiều)',
  },
  {
    word: "canh",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị riêng lẻ trong những buổi đánh bạc (thường về ban đêm): canh bạc",
    example: "canh bạc",
  },
  {
    word: "canh",
    part_of_speech: "động từ",
    meaning:
      "luôn luôn trông coi để đề phòng bất trắc: canh đê phòng lụt * chòi canh dưa * cắt người canh cửa",
    example: "canh đê phòng lụt * chòi canh dưa * cắt người canh cửa",
  },
  {
    word: "canh",
    part_of_speech: "động từ",
    meaning: "làm cho đặc lại bằng cách đun nhỏ lửa: canh thuốc * canh mật",
    example: "canh thuốc * canh mật",
  },
  {
    word: "cành",
    part_of_speech: "danh từ",
    meaning:
      "nhánh cây mọc từ thân hay từ nhánh to ra: cành hoa * không hái hoa, bẻ cành",
    example: "cành hoa * không hái hoa, bẻ cành",
  },
  {
    word: "cành",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (bụng) đầy căng lên, gây cảm giác khó chịu: ăn một bữa no cành * bụng căng cành như cái trống",
    example: "ăn một bữa no cành * bụng căng cành như cái trống",
  },
  {
    word: "canh bạc",
    part_of_speech: "danh từ",
    meaning:
      "cuộc đánh bạc; thường dùng để chỉ cuộc đánh đổi một mất một còn, có tính chất mạo hiểm: canh bạc quyền lực * canh bạc chính trị",
    example: "canh bạc quyền lực * canh bạc chính trị",
  },
  {
    word: "cảnh báo",
    part_of_speech: "động từ",
    meaning:
      "báo trước cho biết việc nguy cấp có thể sẽ xảy ra: cảnh báo nguy cơ cháy rừng * rung một hồi chuông cảnh báo",
    example: "cảnh báo nguy cơ cháy rừng * rung một hồi chuông cảnh báo",
  },
  {
    word: "cành cạch",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng âm thanh phát ra trầm đục, nghe hơi nặng, giống như tiếng hai vật cứng gõ nhẹ vào nhau từng chặp một: tiếng búa gõ vào sắt cành cạch",
    example: "tiếng búa gõ vào sắt cành cạch",
  },
  {
    word: "canh chầy",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) canh khuya: "Gió mùa thu mẹ ru con ngủ, Năm canh chầy, thức đủ năm canh." (ca dao)',
    example:
      'Gió mùa thu mẹ ru con ngủ, Năm canh chầy, thức đủ năm canh." (ca dao)',
  },
  {
    word: "canh chừng",
    part_of_speech: "động từ",
    meaning: "như trông chừng: canh chừng củi lửa * canh chừng bọn giặc",
    example: "canh chừng củi lửa * canh chừng bọn giặc",
  },
  {
    word: "cánh cung",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận của cái cung, làm bằng vật liệu bền, dai, có hình cong đều đặn, hai đầu buộc dây cung: dãy núi cong cong hình cánh cung",
    example: "dãy núi cong cong hình cánh cung",
  },
  {
    word: "cảnh cáo",
    part_of_speech: "động từ",
    meaning:
      "báo cho biết phải từ bỏ hành vi sai lầm hoặc không chính đáng của mình, nếu không sẽ bị xử trí, trừng phạt: nổ súng cảnh cáo",
    example: "nổ súng cảnh cáo",
  },
  {
    word: "cảnh cáo",
    part_of_speech: "động từ",
    meaning:
      "khiển trách nghiêm khắc và báo cho biết nếu không sửa chữa khuyết điểm thì sẽ bị xử lí nặng hơn (một hình thức kỉ luật): cảnh cáo trước toàn thể cơ quan * phạt cảnh cáo",
    example: "cảnh cáo trước toàn thể cơ quan * phạt cảnh cáo",
  },
  {
    word: "canh cửi",
    part_of_speech: "động từ",
    meaning:
      '(cũ) dệt vải, lụa theo lối thủ công (nói khái quát): theo nghề canh cửi * "Đêm hè gió mát trăng thanh, Em ngồi canh cửi còn anh vá chài." (ca dao)',
    example:
      'theo nghề canh cửi * "Đêm hè gió mát trăng thanh, Em ngồi canh cửi còn anh vá chài." (ca dao)',
  },
  {
    word: "canh cánh",
    part_of_speech: "tính từ",
    meaning:
      "(điều lo, nghĩ) lúc nào cũng ở bên lòng, không để cho yên: lo canh cánh * canh cánh bên lòng",
    example: "lo canh cánh * canh cánh bên lòng",
  },
  {
    word: "cánh cứng",
    part_of_speech: "danh từ",
    meaning:
      "sâu bọ có đôi cánh trước dày và cứng, như bọ hung, xén tóc, cà niễng, v.v.: bọ cánh cứng",
    example: "bọ cánh cứng",
  },
  {
    word: "cánh gà",
    part_of_speech: "danh từ",
    meaning:
      "vật thường làm bằng các loại vật liệu mỏng hình tấm, dùng để che chếch hai bên, trông như hai cánh con gà xoè ra: mắc cánh gà vào xe xích lô",
    example: "mắc cánh gà vào xe xích lô",
  },
  {
    word: "cánh gà",
    part_of_speech: "danh từ",
    meaning:
      "khu vực nằm khuất chéo phía hai bên sân khấu (thường có màn vải che kín), dùng làm lối ra vào sân khấu hoặc làm nơi chuẩn bị cho diễn viên: đứng khuất phía trong cánh gà * cánh gà sân khấu",
    example: "đứng khuất phía trong cánh gà * cánh gà sân khấu",
  },
  {
    word: "cánh gà",
    part_of_speech: "danh từ",
    meaning:
      "khu vực nằm chéo hai bên và kề tiếp với một địa điểm hay địa hình chính nào đó: đi theo đường cánh gà * tuần tra khu vực cánh gà cửa khẩu",
    example: "đi theo đường cánh gà * tuần tra khu vực cánh gà cửa khẩu",
  },
  {
    word: "canh gà",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) tiếng gà gáy canh năm, lúc trời sắp sáng; cũng dùng để chỉ khoảng thời gian về cuối của đêm: "Gió đưa cành trúc la đà, Tiếng chuông Trấn Võ canh gà Thọ Xương." (ca dao)',
    example:
      'Gió đưa cành trúc la đà, Tiếng chuông Trấn Võ canh gà Thọ Xương." (ca dao)',
  },
  {
    word: "cảnh gần",
    part_of_speech: "danh từ",
    meaning:
      "cảnh chụp ảnh hoặc quay phim được thể hiện ở cự li gần (thường lấy hình người khoảng từ ngực trở lên); đối lập với viễn cảnh: bức ảnh chụp cận cảnh",
    example: "bức ảnh chụp cận cảnh",
  },
  {
    word: "canh gác",
    part_of_speech: "động từ",
    meaning:
      "trông coi để giữ, để bảo vệ và đề phòng bất trắc: canh gác biên giới * cử người canh gác",
    example: "canh gác biên giới * cử người canh gác",
  },
  {
    word: "cánh gián",
    part_of_speech: "danh từ",
    meaning: "màu nâu thẫm và bóng như màu cánh con gián: tủ sơn màu cánh gián",
    example: "tủ sơn màu cánh gián",
  },
  {
    word: "cảnh giác",
    part_of_speech: "",
    meaning:
      "chú ý đề phòng và có cảm giác nhạy bén trước sự biến đổi xấu đi của tình hình hoặc trước mối nguy hiểm có thể xảy ra: cảnh giác với bọn người xấu * đề cao cảnh giác * mất cảnh giác",
    example: "cảnh giác với bọn người xấu * đề cao cảnh giác * mất cảnh giác",
  },
  {
    word: "cảnh giới",
    part_of_speech: "động từ",
    meaning:
      "canh gác, tuần phòng ở phía ngoài để phát hiện địch và kịp thời đối phó: radar cảnh giới bầu trời * đứng cảnh giới trong vọng gác",
    example: "radar cảnh giới bầu trời * đứng cảnh giới trong vọng gác",
  },
  {
    word: "cảnh huống",
    part_of_speech: "danh từ",
    meaning:
      "tình huống xảy ra trong một hoàn cảnh nhất định: lâm vào cảnh huống khó khăn * vượt qua được cảnh huống ngặt nghèo",
    example:
      "lâm vào cảnh huống khó khăn * vượt qua được cảnh huống ngặt nghèo",
  },
  {
    word: "canh giữ",
    part_of_speech: "động từ",
    meaning:
      "trông coi để gìn giữ cho không bị mất mát hay bị xâm phạm: cổng thành được canh giữ rất nghiêm mật * canh giữ bầu trời tổ quốc",
    example:
      "cổng thành được canh giữ rất nghiêm mật * canh giữ bầu trời tổ quốc",
  },
  {
    word: "cánh hẩu",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, khẩu ngữ) bạn bè tụ tập kết giao với nhau, thường là để chơi bời hoặc làm những việc không chính đáng: tụ tập bọn cánh hẩu để đánh chén",
    example: "tụ tập bọn cánh hẩu để đánh chén",
  },
  {
    word: "cạnh khế",
    part_of_speech: "danh từ",
    meaning:
      "vật có khía, giống hình quả khế cắt ngang: bánh xe cạnh khế * bừa cạnh khế",
    example: "bánh xe cạnh khế * bừa cạnh khế",
  },
  {
    word: "cạnh khoé",
    part_of_speech: "tính từ",
    meaning:
      "(lối nói năng) không chỉ thẳng ra mà nói gần nói xa, nhằm xỏ xiên, xoi móc: buông lời cạnh khoé * nói cạnh khoé",
    example: "buông lời cạnh khoé * nói cạnh khoé",
  },
  {
    word: "canh khuya",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) canh đã về khuya, đêm đã khuya: "Cớ sao trằn trọc canh khuya?, Màu hoa lê hãy dầm dề giọt mưa?" (TKiều)',
    example:
      'Cớ sao trằn trọc canh khuya?, Màu hoa lê hãy dầm dề giọt mưa?" (TKiều)',
  },
  {
    word: "cánh kéo giá cả",
    part_of_speech: "",
    meaning:
      "sự chênh lệch về mặt giá cả giữa một số mặt hàng khi đem ra so sánh trong cùng một thời điểm: thu hẹp cánh kéo giá cả giữa nông sản và hàng công nghiệp",
    example: "thu hẹp cánh kéo giá cả giữa nông sản và hàng công nghiệp",
  },
  {
    word: "cánh kiến",
    part_of_speech: "danh từ",
    meaning:
      "côn trùng cánh nửa cỡ nhỏ, sống thành bầy trên cây, tiết ra một chất nhựa màu đỏ thẫm, dùng để gắn: nuôi cánh kiến",
    example: "nuôi cánh kiến",
  },
  {
    word: "cánh kiến",
    part_of_speech: "danh từ",
    meaning:
      "chất do con cánh kiến tiết ra: xuất khẩu cánh kiến * màu cánh kiến",
    example: "xuất khẩu cánh kiến * màu cánh kiến",
  },
  {
    word: "cánh kiến đỏ",
    part_of_speech: "danh từ",
    meaning:
      "côn trùng cánh nửa cỡ nhỏ, sống thành bầy trên cây, tiết ra một chất nhựa màu đỏ thẫm, dùng để gắn: nuôi cánh kiến",
    example: "nuôi cánh kiến",
  },
  {
    word: "cánh kiến đỏ",
    part_of_speech: "danh từ",
    meaning:
      "chất do con cánh kiến tiết ra: xuất khẩu cánh kiến * màu cánh kiến",
    example: "xuất khẩu cánh kiến * màu cánh kiến",
  },
  {
    word: "cảnh ngộ",
    part_of_speech: "danh từ",
    meaning:
      "cảnh không hay gặp phải (trong cuộc đời): cảnh ngộ éo le * gặp cảnh ngộ không may",
    example: "cảnh ngộ éo le * gặp cảnh ngộ không may",
  },
  {
    word: "canh nông",
    part_of_speech: "động từ",
    meaning:
      '(cũ) cày cấy, làm ruộng: "Bởi anh chăm việc canh nông, Cho nên mới có bồ trong bịch ngoài." (ca dao)',
    example:
      'Bởi anh chăm việc canh nông, Cho nên mới có bồ trong bịch ngoài." (ca dao)',
  },
  {
    word: "canh phòng",
    part_of_speech: "động từ",
    meaning:
      "trông coi để giữ cho khỏi xảy ra việc bất trắc: canh phòng đê điều * lính tráng canh phòng rất cẩn mật",
    example: "canh phòng đê điều * lính tráng canh phòng rất cẩn mật",
  },
  {
    word: "cảnh phục",
    part_of_speech: "danh từ",
    meaning: "quần áo đồng phục của cảnh sát: mặc cảnh phục",
    example: "mặc cảnh phục",
  },
  {
    word: "cảnh quan",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận của bề mặt trái đất, với những đặc điểm riêng về địa lí, khí hậu, thuỷ văn, v.v., phân biệt hẳn với những bộ phận xung quanh: cảnh quan rừng nhiệt đới",
    example: "cảnh quan rừng nhiệt đới",
  },
  {
    word: "cảnh quan",
    part_of_speech: "danh từ",
    meaning:
      "cảnh đẹp tự nhiên hoặc do con người tạo ra: cảnh quan kiến trúc đô thị",
    example: "cảnh quan kiến trúc đô thị",
  },
  {
    word: "cánh quạt",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận hình lá mỏng trong máy, khi máy vận hành thì quay, tạo ra sức đẩy hoặc sức kéo: cánh quạt của turbin * máy bay cánh quạt",
    example: "cánh quạt của turbin * máy bay cánh quạt",
  },
  {
    word: "cánh tay",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận của tay từ bả vai đến cổ tay: những cánh tay giơ lên * cánh tay trần rắn chắc",
    example: "những cánh tay giơ lên * cánh tay trần rắn chắc",
  },
  {
    word: "cánh sen",
    part_of_speech: "danh từ",
    meaning:
      "màu phớt hồng như màu của cánh hoa sen: chiếc áo cánh sen * son môi màu cánh sen",
    example: "chiếc áo cánh sen * son môi màu cánh sen",
  },
  {
    word: "canh tác",
    part_of_speech: "động từ",
    meaning: "cày cấy, trồng trọt: đất canh tác * cải tiến kĩ thuật canh tác",
    example: "đất canh tác * cải tiến kĩ thuật canh tác",
  },
  {
    word: "cánh sẻ",
    part_of_speech: "tính từ",
    meaning:
      "tả hình đan chéo vào nhau hàng loạt như hình cánh chim sẻ: rào cánh sẻ * bắn chéo cánh sẻ",
    example: "rào cánh sẻ * bắn chéo cánh sẻ",
  },
  {
    word: "cảnh sắc",
    part_of_speech: "danh từ",
    meaning:
      "cảnh thiên nhiên với những nét riêng đặc sắc của nó: cảnh sắc thiên nhiên tươi đẹp",
    example: "cảnh sắc thiên nhiên tươi đẹp",
  },
  {
    word: "cảnh sát",
    part_of_speech: "danh từ",
    meaning:
      "người thuộc lực lượng vũ trang do nhà nước lập ra để giữ gìn an ninh và trật tự xã hội: cảnh sát hình sự * cảnh sát giao thông",
    example: "cảnh sát hình sự * cảnh sát giao thông",
  },
  {
    word: "cánh trả",
    part_of_speech: "danh từ",
    meaning:
      "màu xanh biếc và óng ánh như màu lông trên cánh chim trả: xe đạp màu cánh trả",
    example: "xe đạp màu cánh trả",
  },
  {
    word: "canh ti",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) chung tiền của hoặc kết hợp với nhau để cùng làm việc gì và cùng hưởng lợi: hai bên canh ti sản xuất * hùn vốn canh ti buôn bán",
    example: "hai bên canh ti sản xuất * hùn vốn canh ti buôn bán",
  },
  {
    word: "cảnh tỉnh",
    part_of_speech: "động từ",
    meaning: "làm cho tỉnh ngộ: lời cảnh tỉnh * rung lên hồi chuông cảnh tỉnh",
    example: "lời cảnh tỉnh * rung lên hồi chuông cảnh tỉnh",
  },
  {
    word: "cánh tay phải",
    part_of_speech: "",
    meaning:
      "ví người giúp việc gần gũi và đắc lực nhất không thể thiếu được: viên trợ lí là cánh tay phải của giám đốc",
    example: "viên trợ lí là cánh tay phải của giám đốc",
  },
  {
    word: "cạnh tranh sinh tồn",
    part_of_speech: "động từ",
    meaning:
      "(hiện tượng các sinh vật trong tự nhiên) đấu tranh với nhau để giành lấy sự sống còn và phát triển: cạnh tranh sinh tồn là một quy luật của tự nhiên",
    example: "cạnh tranh sinh tồn là một quy luật của tự nhiên",
  },
  {
    word: "cạnh tranh",
    part_of_speech: "động từ",
    meaning:
      "tranh đua nhau để giành lấy lợi ích về phía mình, giữa những người, những tổ chức có cùng lĩnh vực hoạt động như nhau: bán phá giá để cạnh tranh * cạnh tranh lành mạnh",
    example: "bán phá giá để cạnh tranh * cạnh tranh lành mạnh",
  },
  {
    word: "cảnh tượng",
    part_of_speech: "danh từ",
    meaning:
      "cảnh bày ra trước mắt và gây nên những ấn tượng nhất định: cảnh tượng đau lòng",
    example: "cảnh tượng đau lòng",
  },
  {
    word: "cảnh trí",
    part_of_speech: "danh từ",
    meaning:
      "cảnh thiên nhiên, về mặt được sắp xếp rất hài hoà: đi xem cảnh trí trong vùng * cảnh trí phong quang",
    example: "đi xem cảnh trí trong vùng * cảnh trí phong quang",
  },
  {
    word: "cảnh vật",
    part_of_speech: "danh từ",
    meaning:
      "cảnh thiên nhiên và sự vật cụ thể bày ra trước mắt: cảnh vật thay đổi * ngắm nhìn cảnh vật hai bên đường",
    example: "cảnh vật thay đổi * ngắm nhìn cảnh vật hai bên đường",
  },
  {
    word: "canh ty",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) chung tiền của hoặc kết hợp với nhau để cùng làm việc gì và cùng hưởng lợi: hai bên canh ti sản xuất * hùn vốn canh ti buôn bán",
    example: "hai bên canh ti sản xuất * hùn vốn canh ti buôn bán",
  },
  {
    word: "cảnh xa",
    part_of_speech: "danh từ",
    meaning:
      "cảnh chụp ảnh hoặc quay phim được thể hiện ở cự li xa để có thể thu được hình ảnh trên một khung cảnh rộng; đối lập với cận cảnh.",
    example: "viễn cảnh về một thế giới đại đồng",
  },
  {
    word: "cảnh vẻ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) tỏ ra thanh cảnh, cầu kì (thường nói về cách ăn uống): ăn uống cảnh vẻ",
    example: "ăn uống cảnh vẻ",
  },
  {
    word: "cảnh vệ",
    part_of_speech: "danh từ",
    meaning:
      "người thuộc lực lượng vũ trang chuyên làm nhiệm vụ canh gác, bảo vệ: chiến sĩ cảnh vệ",
    example: "chiến sĩ cảnh vệ",
  },
  {
    word: "cào",
    part_of_speech: "động từ",
    meaning: "san bằng hoặc làm nhỏ đất, làm cỏ bằng cái cào: cào đất * cào cỏ",
    example: "cào đất * cào cỏ",
  },
  {
    word: "cào",
    part_of_speech: "động từ",
    meaning:
      "ấn các móng nhọn hoặc những vật tương tự vào và kéo mạnh trên bề mặt: quần áo bị gai cào rách * bị mèo cào",
    example: "quần áo bị gai cào rách * bị mèo cào",
  },
  {
    word: "cáo bạch",
    part_of_speech: "",
    meaning: "báo cho mọi người biết rõ: giấy cáo bạch * dán cáo bạch",
    example: "giấy cáo bạch * dán cáo bạch",
  },
  {
    word: "cạo",
    part_of_speech: "động từ",
    meaning:
      "làm đứt lông, tóc hoặc râu bằng cách đưa lưỡi dao sát mặt da: cạo râu * đầu cạo trọc * cạo lông lợn",
    example: "cạo râu * đầu cạo trọc * cạo lông lợn",
  },
  {
    word: "cạo",
    part_of_speech: "động từ",
    meaning:
      "làm cho lớp mỏng bên ngoài rời ra, bong ra bằng cách dùng vật có cạnh sắc đưa sát bề mặt: cạo lớp sơn cũ * cạo khoai * cạo sạch khói bám ở đít nồi",
    example: "cạo lớp sơn cũ * cạo khoai * cạo sạch khói bám ở đít nồi",
  },
  {
    word: "cạo",
    part_of_speech: "động từ",
    meaning: "(Khẩu ngữ) trách mắng một cách gay gắt: bị cạo một trận nên thân",
    example: "bị cạo một trận nên thân",
  },
  {
    word: "cao",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị cũ đo ruộng đất ở Nam Bộ, bằng khoảng 1/10 hecta: nhận cày mấy chục cao ruộng",
    example: "nhận cày mấy chục cao ruộng",
  },
  {
    word: "cao",
    part_of_speech: "danh từ",
    meaning:
      "thuốc đông y chế bằng các dược liệu lấy từ một số động vật hay thực vật, chiết bằng rượu hoặc nước rồi cô lại ở một thể thích hợp: cao hổ cốt * cao trăn",
    example: "cao hổ cốt * cao trăn",
  },
  {
    word: "cao",
    part_of_speech: "tính từ",
    meaning:
      "có khoảng cách bao nhiêu đó, tính từ đầu này đến cuối đầu kia theo chiều thẳng đứng (gọi là chiều cao) của vật ở trạng thái đứng thẳng: người cao một mét bảy mươi * núi cao trên 4.000 mét",
    example: "người cao một mét bảy mươi * núi cao trên 4.000 mét",
  },
  {
    word: "cao",
    part_of_speech: "tính từ",
    meaning:
      "có khoảng cách xa với mặt đất lớn hơn mức bình thường hoặc lớn hơn so với những vật khác: giày cao cổ * toà nhà cao chọc trời * mặt trời đã lên cao",
    example: "giày cao cổ * toà nhà cao chọc trời * mặt trời đã lên cao",
  },
  {
    word: "cao",
    part_of_speech: "tính từ",
    meaning:
      "hơn hẳn mức trung bình về số lượng hay chất lượng, trình độ, giá cả, v.v.: tuổi đã cao * mưu cao kế hiểm * giá quá cao, không mua nổi",
    example: "tuổi đã cao * mưu cao kế hiểm * giá quá cao, không mua nổi",
  },
  {
    word: "cao",
    part_of_speech: "tính từ",
    meaning:
      "(âm thanh) có tần số rung động lớn: nốt nhạc cao * cất cao tiếng hát",
    example: "nốt nhạc cao * cất cao tiếng hát",
  },
  {
    word: "cáo",
    part_of_speech: "danh từ",
    meaning:
      "thú ăn thịt, sống ở rừng, gần giống chó, nhưng chân thấp, tai to, mõm dài và nhọn, rất tinh khôn: khôn như cáo",
    example: "khôn như cáo",
  },
  {
    word: "cáo",
    part_of_speech: "tính từ",
    meaning: "(Khẩu ngữ) tinh ranh, gian giảo: thằng cha ấy cáo lắm!",
    example: "thằng cha ấy cáo lắm!",
  },
  {
    word: "cáo",
    part_of_speech: "danh từ",
    meaning:
      "(Từ cũ) bài văn thường lấy danh nghĩa nhà vua để công bố cho dân chúng biết những điều có tầm quan trọng lớn: Nguyễn Trãi viết bài cáo Bình Ngô",
    example: "Nguyễn Trãi viết bài cáo Bình Ngô",
  },
  {
    word: "cáo",
    part_of_speech: "động từ",
    meaning:
      "(Từ cũ) thưa, trình (với người có trách nhiệm): dẫn nhau lên cáo quan",
    example: "dẫn nhau lên cáo quan",
  },
  {
    word: "cáo",
    part_of_speech: "động từ",
    meaning:
      "viện cớ để từ chối, để xin khỏi phải làm: cáo ốm, không đến dự tiệc * cáo lão về hưu",
    example: "cáo ốm, không đến dự tiệc * cáo lão về hưu",
  },
  {
    word: "cao bồi",
    part_of_speech: "danh từ",
    meaning:
      "người đàn ông thường cưỡi ngựa, làm nghề chăn các đàn gia súc, ở những vùng miền Tây nước Mĩ.",
    example: "một gã cao bồi",
  },
  {
    word: "cào bằng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) coi như nhau, ngang nhau, không phân biệt mức độ hơn kém, cao thấp (cái lẽ ra phải phân biệt): cào bằng thành thích * tính cào bằng, không kể tốt xấu",
    example: "cào bằng thành thích * tính cào bằng, không kể tốt xấu",
  },
  {
    word: "cáo biệt",
    part_of_speech: "động từ",
    meaning: "(cũ, trang trọng) như cáo từ: đứng dậy cáo biệt mọi người",
    example: "đứng dậy cáo biệt mọi người",
  },
  {
    word: "cao cả",
    part_of_speech: "tính từ",
    meaning:
      "rất cao quý: sự hi sinh cao cả * bảo vệ tổ quốc là một nhiệm vụ cao cả",
    example: "sự hi sinh cao cả * bảo vệ tổ quốc là một nhiệm vụ cao cả",
  },
  {
    word: "cao áp",
    part_of_speech: "tính từ",
    meaning:
      "(điện) có hiệu thế cao, thường là cao hơn 650 volt; phân biệt với hạ thế: điện cao thế * đường dây cao thế",
    example: "điện cao thế * đường dây cao thế",
  },
  {
    word: "cao cấp",
    part_of_speech: "tính từ",
    meaning: "thuộc cấp cao: cán bộ cao cấp * sĩ quan cao cấp trong quân đội",
    example: "cán bộ cao cấp * sĩ quan cao cấp trong quân đội",
  },
  {
    word: "cao cấp",
    part_of_speech: "tính từ",
    meaning:
      "(chất lượng, mức độ, v.v.) có giá trị cao, trên mức bình thường: vật liệu cao cấp * chuyên kinh doanh các mặt hàng thời trang cao cấp",
    example:
      "vật liệu cao cấp * chuyên kinh doanh các mặt hàng thời trang cao cấp",
  },
  {
    word: "cáo buộc",
    part_of_speech: "động từ",
    meaning:
      "tố cáo nhằm bắt phải nhận tội: bị cáo buộc là chủ mưu * lời cáo buộc",
    example: "bị cáo buộc là chủ mưu * lời cáo buộc",
  },
  {
    word: "cào cấu",
    part_of_speech: "động từ",
    meaning:
      "cào và cấu, làm cho rách nát (nói khái quát): trên người có nhiều vết cào cấu",
    example: "trên người có nhiều vết cào cấu",
  },
  {
    word: "cào cấu",
    part_of_speech: "động từ",
    meaning:
      '(khẩu ngữ) vơ vét hoặc cóp nhặt mỗi nơi một ít: cào cấu của dân * "Chết! Cậu phải đi xoay chứ? Cậu phải cố cào cấu cho nó ra tiền chứ?" (VTrPhụng; 15)',
    example:
      'cào cấu của dân * "Chết! Cậu phải đi xoay chứ? Cậu phải cố cào cấu cho nó ra tiền chứ?" (VTrPhụng; 15)',
  },
  {
    word: "cao dày",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) trời cao và đất dày; dùng để chỉ đấng thiêng liêng, theo quan niệm thời xưa: "Độ sinh nhờ đức cao dày, Lập am rồi sẽ rước thầy ở chung." (TKiều)',
    example:
      'Độ sinh nhờ đức cao dày, Lập am rồi sẽ rước thầy ở chung." (TKiều)',
  },
  {
    word: "cao dày",
    part_of_speech: "tính từ",
    meaning: "(hiếm) (công ơn, công đức) lớn lao như trời đất: công ơn cao dày",
    example: "công ơn cao dày",
  },
  {
    word: "cao cường",
    part_of_speech: "tính từ",
    meaning:
      "hơn hẳn người thường (thường nói về võ nghệ, pháp thuật): võ nghệ cao cường * bản lĩnh cao cường",
    example: "võ nghệ cao cường * bản lĩnh cao cường",
  },
  {
    word: "cáo chung",
    part_of_speech: "động từ",
    meaning:
      "(văn chương) có dấu hiệu cho biết là đã đến lúc suy tàn, kết thúc hoặc sụp đổ (thường nói về một chế độ xã hội): chủ nghĩa thực dân đã đến hồi cáo chung",
    example: "chủ nghĩa thực dân đã đến hồi cáo chung",
  },
  {
    word: "cao chạy xa bay",
    part_of_speech: "",
    meaning:
      "chạy trốn đi thật nhanh và thật xa (để tránh điều nguy hiểm): tên lừa đảo đã cao chạy xa bay",
    example: "tên lừa đảo đã cao chạy xa bay",
  },
  {
    word: "cao dỏng",
    part_of_speech: "tính từ",
    meaning: "(dáng người) cao, gầy và có vẻ mảnh khảnh: dáng người cao dỏng",
    example: "dáng người cao dỏng",
  },
  {
    word: "cao đạo",
    part_of_speech: "tính từ",
    meaning:
      "(văn chương, hiếm) thanh cao, không màng danh lợi, không để ý đến cái tầm thường của cuộc đời: một nhà nho cao đạo",
    example: "một nhà nho cao đạo",
  },
  {
    word: "cao đẳng",
    part_of_speech: "tính từ",
    meaning:
      "thuộc bậc học cao, trên trung học, dưới đại học: trường cao đẳng sư phạm * trình độ cao đẳng",
    example: "trường cao đẳng sư phạm * trình độ cao đẳng",
  },
  {
    word: "cao đẳng",
    part_of_speech: "tính từ",
    meaning:
      "(sinh vật) thuộc bậc cao, có tổ chức cơ thể phát triển đầy đủ, phức tạp: người thuộc loại động vật cao đẳng",
    example: "người thuộc loại động vật cao đẳng",
  },
  {
    word: "cao điểm",
    part_of_speech: "danh từ",
    meaning: "như điểm cao: đánh chiếm một cao điểm",
    example: "đánh chiếm một cao điểm",
  },
  {
    word: "cao điểm",
    part_of_speech: "danh từ",
    meaning:
      "lúc mức độ sử dụng, hoạt động, v.v. của một số đông diễn ra cao nhất: giờ cao điểm * tháng cao điểm phòng chống tội phạm ma tuý",
    example: "giờ cao điểm * tháng cao điểm phòng chống tội phạm ma tuý",
  },
  {
    word: "cao đẹp",
    part_of_speech: "tính từ",
    meaning:
      "cao quý và đẹp đẽ: lí tưởng cao đẹp * những phẩm chất cao đẹp của người chiến sĩ",
    example: "lí tưởng cao đẹp * những phẩm chất cao đẹp của người chiến sĩ",
  },
  {
    word: "cao độ",
    part_of_speech: "danh từ",
    meaning: "độ cao (thường nói về âm thanh).",
    example: "căm hận đến cao độ",
  },
  {
    word: "cáo già",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có nhiều mánh khoé tinh khôn, lọc lõi và xảo quyệt: hắn là một tay cáo già",
    example: "hắn là một tay cáo già",
  },
  {
    word: "cao giá",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có giá trị hoặc tài năng được đánh giá cao: một diễn viên cao giá",
    example: "một diễn viên cao giá",
  },
  {
    word: "xe song mã",
    part_of_speech: "danh từ",
    meaning: "xe hai ngựa kéo: cỗ xe song mã",
    example: "cỗ xe song mã",
  },
  {
    word: "xe tải",
    part_of_speech: "danh từ",
    meaning: "ô tô lớn để chở hàng: xe tải chở hàng * đường cấm xe tải",
    example: "xe tải chở hàng * đường cấm xe tải",
  },
  {
    word: "xe tăng",
    part_of_speech: "danh từ",
    meaning:
      "xe có vỏ thép dày, chạy bằng xích sắt, có sức vận động cao, hoả lực mạnh, dùng để chiến đấu: lính xe tăng",
    example: "lính xe tăng",
  },
  {
    word: "xè xè",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng phát ra đều đều, rè và kéo dài như tiếng kim loại cọ xát liên tiếp vào vật cứng: tiếng máy cưa chạy xè xè suốt ngày",
    example: "tiếng máy cưa chạy xè xè suốt ngày",
  },
  {
    word: "xe-mi-na",
    part_of_speech: "danh từ",
    meaning:
      "buổi sinh hoạt học tập để thảo luận những vấn đề chuyên môn ở đại học hoặc trên đại học: tổ chức một seminar về văn học cận đại",
    example: "tổ chức một seminar về văn học cận đại",
  },
  {
    word: "xe thồ",
    part_of_speech: "danh từ",
    meaning:
      "xe đạp được cải tiến để chuyên dùng vào việc vận chuyển: chở gạch bằng xe thồ",
    example: "chở gạch bằng xe thồ",
  },
  {
    word: "xem",
    part_of_speech: "động từ",
    meaning: "nhận biết bằng mắt: xem sách * đi xem hội * xem ti vi",
    example: "xem sách * đi xem hội * xem ti vi",
  },
  {
    word: "xem",
    part_of_speech: "động từ",
    meaning:
      "nhận định, đánh giá, dựa vào kết quả quan sát được: việc này xem ra không ổn * tình hình xem cũng êm êm",
    example: "việc này xem ra không ổn * tình hình xem cũng êm êm",
  },
  {
    word: "xem",
    part_of_speech: "động từ",
    meaning:
      "từ biểu thị kết quả nhận định có thể có được của một hoạt động nào đó: nhớ lại xem * có gì thì cứ nói ra xem nào * việc ấy mà vào tay nó xem, cứ là xong hết",
    example:
      "nhớ lại xem * có gì thì cứ nói ra xem nào * việc ấy mà vào tay nó xem, cứ là xong hết",
  },
  {
    word: "xem",
    part_of_speech: "động từ",
    meaning:
      "đoán số mệnh, hoạ phúc, dựa vào thuật số, bói toán: xem một quẻ bói",
    example: "xem một quẻ bói",
  },
  {
    word: "xem",
    part_of_speech: "động từ",
    meaning: "coi như, coi là: xem nhau như người nhà",
    example: "xem nhau như người nhà",
  },
  {
    word: "xem bói",
    part_of_speech: "động từ",
    meaning:
      "nhờ thầy bói đoán việc lành dữ, hoạ phúc, theo mê tín: đi xem bói",
    example: "đi xem bói",
  },
  {
    word: "xem chừng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) chú ý đề phòng điều không hay có thể xảy ra: xem chừng kẻo ngã",
    example: "xem chừng kẻo ngã",
  },
  {
    word: "xem chừng",
    part_of_speech: "phụ từ",
    meaning:
      "tổ hợp biểu thị ý nhận định một cách không hoàn toàn chắc chắn, trên cơ sở những gì đã thấy, đã quan sát được: tình hình xem chừng không ổn * xem chừng hắn đã núng thế",
    example: "tình hình xem chừng không ổn * xem chừng hắn đã núng thế",
  },
  {
    word: "xem lại",
    part_of_speech: "động từ",
    meaning:
      "xem xét đánh giá lại một vấn đề nào đó, để nếu cần thì thay đổi quyết định cho phù hợp và đúng đắn hơn: xem lại toàn bộ sự việc * về kiến nghị này, chúng tôi sẽ xem lại",
    example: "xem lại toàn bộ sự việc * về kiến nghị này, chúng tôi sẽ xem lại",
  },
  {
    word: "xem mạch",
    part_of_speech: "động từ",
    meaning: "như bắt mạch: bác sĩ xem mạch cho bệnh nhân",
    example: "bác sĩ xem mạch cho bệnh nhân",
  },
  {
    word: "xem mặt",
    part_of_speech: "động từ",
    meaning:
      "đến nhà người con gái để nhìn mặt người định hỏi làm vợ, theo tục lệ cũ: đi xem mặt",
    example: "đi xem mặt",
  },
  {
    word: "xem ra",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị ý nhận định một cách không hoàn toàn khẳng định, dựa vào những dấu hiệu quan sát được: anh ta xem ra cũng đàng hoàng * chuyện này xem ra khó thành",
    example: "anh ta xem ra cũng đàng hoàng * chuyện này xem ra khó thành",
  },
  {
    word: "xem xét",
    part_of_speech: "động từ",
    meaning:
      "tìm hiểu, quan sát kĩ để đánh giá, rút ra những nhận xét, kết luận cần thiết: xem xét tình hình * xem xét hiện trường vụ án",
    example: "xem xét tình hình * xem xét hiện trường vụ án",
  },
  {
    word: "xem ngày",
    part_of_speech: "động từ",
    meaning:
      "xem âm lịch chọn lấy ngày lành tháng tốt để làm việc gì quan trọng, theo tín ngưỡng dân gian: xem ngày để động thổ",
    example: "xem ngày để động thổ",
  },
  {
    word: "xen",
    part_of_speech: "động từ",
    meaning:
      "làm cho ở vào vị trí giữa những cái khác: xen vào giữa đám đông * nói xen vào một câu",
    example: "xen vào giữa đám đông * nói xen vào một câu",
  },
  {
    word: "xen",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) dự vào: đừng xen vào chuyện của người khác",
    example: "đừng xen vào chuyện của người khác",
  },
  {
    word: "xen cài",
    part_of_speech: "động từ",
    meaning:
      "xen vào, cài lẫn vào nhau: câu chuyện có xen cài nhiều tình tiết hư ảo",
    example: "câu chuyện có xen cài nhiều tình tiết hư ảo",
  },
  {
    word: "xén",
    part_of_speech: "động từ",
    meaning:
      "cắt cho đứt gọn (thường là chỗ không cần thiết để cho bằng nhau): xén mạ * xén mép vải * xén hàng rào",
    example: "xén mạ * xén mép vải * xén hàng rào",
  },
  {
    word: "xén",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) lấy bớt đi một phần nhỏ để hưởng hoặc dùng vào việc khác: xén tiền công quỹ * tiêu xén vào tiền tiết kiệm",
    example: "xén tiền công quỹ * tiêu xén vào tiền tiết kiệm",
  },
  {
    word: "xem tướng",
    part_of_speech: "động từ",
    meaning:
      "đoán số mệnh, tương lai bằng cách nhìn vào tướng mạo, theo thuật tướng số: thuật xem tướng",
    example: "thuật xem tướng",
  },
  {
    word: "xen canh",
    part_of_speech: "động từ",
    meaning:
      "trồng hai ba thứ cây cùng một lúc trên cùng một thửa đất (một phương thức canh tác): xen canh lạc với ngô * trồng xen canh",
    example: "xen canh lạc với ngô * trồng xen canh",
  },
  {
    word: "xẻn lẻn",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) như bẽn lẽn: cười xẻn lẻn",
    example: "cười xẻn lẻn",
  },
  {
    word: "xen lẫn",
    part_of_speech: "động từ",
    meaning: "có lẫn vào giữa những cái khác: niềm vui xen lẫn nỗi buồn",
    example: "niềm vui xen lẫn nỗi buồn",
  },
  {
    word: "xen kẽ",
    part_of_speech: "động từ",
    meaning:
      "(những cái khác loại) ở xen cạnh nhau, cái nọ tiếp cái kia một cách liên tục, đều đặn: ngồi xen kẽ nam nữ * trồng xen kẽ hai loại cây",
    example: "ngồi xen kẽ nam nữ * trồng xen kẽ hai loại cây",
  },
  {
    word: "xèn xẹt",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng những tiếng động kéo dài và liên tiếp như tiếng rít của vật gì bay nhanh và mạnh trong không khí hoặc tiếng kim loại cọ xát vào vật cứng: tiếng mảnh đạn xé không khí xèn xẹt",
    example: "tiếng mảnh đạn xé không khí xèn xẹt",
  },
  {
    word: "xẻo",
    part_of_speech: "danh từ",
    meaning: "lạch con ở Nam Bộ: con xẻo * chống xuồng vô xẻo",
    example: "con xẻo * chống xuồng vô xẻo",
  },
  {
    word: "xẻo",
    part_of_speech: "động từ",
    meaning: "cắt gọn ra một miếng, một phần nhỏ: xẻo tai * xẻo một miếng thịt",
    example: "xẻo tai * xẻo một miếng thịt",
  },
  {
    word: "xẻng",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ gồm một lưỡi sắc mỏng to bản và hơi khum, tra vào cán, dùng để xúc đất cát, vật liệu rời: dùng xẻng xúc cát",
    example: "dùng xẻng xúc cát",
  },
  {
    word: "xèo",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng như tiếng phát ra khi mỡ cháy hoặc thả thanh sắt nung nóng vào nước: tiếng mỡ cháy xèo",
    example: "tiếng mỡ cháy xèo",
  },
  {
    word: "xeo",
    part_of_speech: "động từ",
    meaning: "bẩy cho chuyển đi nơi khác: xeo gỗ * đòn xeo",
    example: "xeo gỗ * đòn xeo",
  },
  {
    word: "xeo",
    part_of_speech: "động từ",
    meaning:
      "láng lớp bột giấy vào khuôn thủ công hoặc vào lưới trên máy để hình thành tờ giấy: xeo giấy * máy xeo * thợ xeo",
    example: "xeo giấy * máy xeo * thợ xeo",
  },
  {
    word: "xèng",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) đồng tiền kẽm, đơn vị tiền tệ giá trị nhỏ nhất thời phong kiến: không còn một đồng xèng",
    example: "không còn một đồng xèng",
  },
  {
    word: "xéo",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) giẫm mạnh, giẫm bừa lên: xéo nát đám lúa * con giun xéo lắm cũng quằn (tng)",
    example: "xéo nát đám lúa * con giun xéo lắm cũng quằn (tng)",
  },
  {
    word: "xéo",
    part_of_speech: "động từ",
    meaning:
      "(Thông tục) đi ngay, rời khỏi nhanh (hàm ý coi khinh): xéo ngay cho khuất mắt!",
    example: "xéo ngay cho khuất mắt!",
  },
  {
    word: "xéo",
    part_of_speech: "tính từ",
    meaning:
      "(Phương ngữ) như chéo: cắt xéo vải * liếc xéo * nhìn xéo về một bên",
    example: "cắt xéo vải * liếc xéo * nhìn xéo về một bên",
  },
  {
    word: "xẹo xọ",
    part_of_speech: "tính từ",
    meaning:
      "nghiêng ngả, không đều, không ngay ngắn: chữ viết xẹo xọ * say rượu, bước đi xẹo xọ",
    example: "chữ viết xẹo xọ * say rượu, bước đi xẹo xọ",
  },
  {
    word: "xeo xéo",
    part_of_speech: "tính từ",
    meaning: "hơi xéo: nhìn xeo xéo * miếng vải cắt xeo xéo",
    example: "nhìn xeo xéo * miếng vải cắt xeo xéo",
  },
  {
    word: "xẹo",
    part_of_speech: "tính từ",
    meaning: "(hiếm) lệch hẳn về một bên: bức tranh treo bị xẹo",
    example: "bức tranh treo bị xẹo",
  },
  {
    word: "xẹt",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) bay vụt qua một cách rất nhanh: làn đạn xẹt qua đầu",
    example: "làn đạn xẹt qua đầu",
  },
  {
    word: "xẹp lép",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) xẹp xuống hoàn toàn, không còn tí gì bên trong: quả bóng xẹp lép * bụng xẹp lép",
    example: "quả bóng xẹp lép * bụng xẹp lép",
  },
  {
    word: "xét duyệt",
    part_of_speech: "động từ",
    meaning:
      "xem xét để duyệt và công nhậ: xét duyệt dự án * kế hoạch đang chờ xét duyệt",
    example: "xét duyệt dự án * kế hoạch đang chờ xét duyệt",
  },
  {
    word: "xét",
    part_of_speech: "động từ",
    meaning:
      "tìm hiểu, cân nhắc kĩ trước khi đánh giá, kết luận về cái gì: xét thành tích * xét lẽ thiệt hơn * việc đó để xét sau",
    example: "xét thành tích * xét lẽ thiệt hơn * việc đó để xét sau",
  },
  {
    word: "xét",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) khám, soát: xét vé",
    example: "xét vé",
  },
  {
    word: "xẹp",
    part_of_speech: "động từ",
    meaning:
      "giảm thể tích vì đã trở thành rỗng, xốp, chất chứa bên trong đã thoát ra: xe xẹp lốp * quả bóng hết hơi, xẹp xuống",
    example: "xe xẹp lốp * quả bóng hết hơi, xẹp xuống",
  },
  {
    word: "xẹp",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) giảm xuống, yếu đi: sức khoẻ xẹp đi trông thấy * phong trào ngày một xẹp dần",
    example: "sức khoẻ xẹp đi trông thấy * phong trào ngày một xẹp dần",
  },
  {
    word: "xép xẹp",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như xẹp lép: hạt lúa xép xẹp * bụng xép xẹp vì đói",
    example: "hạt lúa xép xẹp * bụng xép xẹp vì đói",
  },
  {
    word: "xép",
    part_of_speech: "danh từ",
    meaning: "vũng biển nhỏ: thuyền đi vào xép",
    example: "thuyền đi vào xép",
  },
  {
    word: "xép",
    part_of_speech: "tính từ",
    meaning: "nhỏ, phụ: cái buồng xép * phiên chợ xép * dân phố xép",
    example: "cái buồng xép * phiên chợ xép * dân phố xép",
  },
  {
    word: "xét lại",
    part_of_speech: "tính từ",
    meaning:
      "theo chủ nghĩa xét lại, thuộc về chủ nghĩa xét lại: các phần tử xét lại",
    example: "các phần tử xét lại",
  },
  {
    word: "xét hỏi",
    part_of_speech: "động từ",
    meaning:
      "(nhà chức trách) hỏi kĩ để phát hiện hành vi phạm pháp hoặc tìm hiểu sự thật về một vụ án, v.v. (nói khái quát): xét hỏi giấy tờ * toà xét hỏi các đương sự",
    example: "xét hỏi giấy tờ * toà xét hỏi các đương sự",
  },
  {
    word: "xét đoán",
    part_of_speech: "động từ",
    meaning:
      "xem xét để nhận định, đánh giá: xét đoán tình hình * không nên xét đoán vội vàng",
    example: "xét đoán tình hình * không nên xét đoán vội vàng",
  },
  {
    word: "xét soi",
    part_of_speech: "động từ",
    meaning:
      '(hiếm) như soi xét: "Dù khi thiếp có phũ phàng, Trên đầu nhật nguyệt hai hàng xét soi!" (PCCH)',
    example:
      'Dù khi thiếp có phũ phàng, Trên đầu nhật nguyệt hai hàng xét soi!" (PCCH)',
  },
  {
    word: "xét nét",
    part_of_speech: "động từ",
    meaning:
      "để ý từng cái quá nhỏ nhặt để đánh giá, nhận xét con người: xét nét từng li từng tí * nhìn bằng ánh mắt xét nét",
    example: "xét nét từng li từng tí * nhìn bằng ánh mắt xét nét",
  },
  {
    word: "xét nghiệm",
    part_of_speech: "",
    meaning:
      "phân tích vật mẫu bằng phương pháp khoa học để giúp chẩn đoán bệnh: xét nghiệm máu * bệnh nhân đã được làm xét nghiệm",
    example: "xét nghiệm máu * bệnh nhân đã được làm xét nghiệm",
  },
  {
    word: "xệ",
    part_of_speech: "động từ",
    meaning:
      "sa và lệch xuống vì quá nặng: người béo xệ * má chảy xệ * bụng xệ",
    example: "người béo xệ * má chảy xệ * bụng xệ",
  },
  {
    word: "xét xử",
    part_of_speech: "động từ",
    meaning:
      "xem xét và xử các vụ án (nói khái quát): xét xử tội phạm * đưa vụ án ra xét xử * hội đồng xét xử",
    example: "xét xử tội phạm * đưa vụ án ra xét xử * hội đồng xét xử",
  },
  {
    word: "xê",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) chuyển dịch một đoạn ngắn để tránh hoặc nhường chỗ cho người khác, cái khác: đứng xê ra * ngồi xê ra một tí",
    example: "đứng xê ra * ngồi xê ra một tí",
  },
  {
    word: "xế",
    part_of_speech: "động từ",
    meaning:
      '(bóng nắng, bóng trăng) chếch xuống về phía tây: nắng xế * "Chênh chênh bóng nguyệt xế mành, Tựa ngồi bên triện một mình thiu thiu." (TKiều)',
    example:
      'nắng xế * "Chênh chênh bóng nguyệt xế mành, Tựa ngồi bên triện một mình thiu thiu." (TKiều)',
  },
  {
    word: "xế",
    part_of_speech: "động từ",
    meaning:
      "ở vị trí chếch về một bên so với vị trí được coi là thẳng, là chuẩn: chiếc xe đỗ ngay xế cổng * hai nhà ở xế nhau",
    example: "chiếc xe đỗ ngay xế cổng * hai nhà ở xế nhau",
  },
  {
    word: "xế",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) khoảng thời gian quá trưa gần sang chiều: mới ăn cơm hồi xế",
    example: "mới ăn cơm hồi xế",
  },
  {
    word: "xê dịch",
    part_of_speech: "động từ",
    meaning:
      "chuyển vị trí đi một quãng ngắn (nói khái quát): xê dịch chỗ ngồi * bàn ghế bị xê dịch",
    example: "xê dịch chỗ ngồi * bàn ghế bị xê dịch",
  },
  {
    word: "xê dịch",
    part_of_speech: "động từ",
    meaning:
      "thay đổi, biến đổi trong một khoảng nhất định: nhiệt độ chỉ xê dịch từ 1O đến 2OC",
    example: "nhiệt độ chỉ xê dịch từ 1O đến 2OC",
  },
  {
    word: "xế bóng",
    part_of_speech: "tính từ",
    meaning:
      "có bóng nắng chiếu xiên khi mặt trời gần lặn: chiều tà xế bóng * nương tựa nhau lúc tuổi già xế bóng (b)",
    example: "chiều tà xế bóng * nương tựa nhau lúc tuổi già xế bóng (b)",
  },
  {
    word: "xế chiều",
    part_of_speech: "tính từ",
    meaning: "gần cuối buổi chiều: trời đã xế chiều * tuổi đã xế chiều",
    example: "trời đã xế chiều * tuổi đã xế chiều",
  },
  {
    word: "xê ri",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp gồm những vật cùng loại, có chung một đặc trưng nào đó: số xê ri của sản phẩm * hai tấm vé có cùng xê ri",
    example: "số xê ri của sản phẩm * hai tấm vé có cùng xê ri",
  },
  {
    word: "xê xích",
    part_of_speech: "tính từ",
    meaning:
      "chênh lệch, hơn kém nhau chút ít, không đáng kể: con số có thể xê xích ít nhiều * hai người xê xích nhau một hai tuổi",
    example:
      "con số có thể xê xích ít nhiều * hai người xê xích nhau một hai tuổi",
  },
  {
    word: "xế lô",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ, khẩu ngữ) xích lô: đạp xế lô",
    example: "đạp xế lô",
  },
  {
    word: "xế tà",
    part_of_speech: "tính từ",
    meaning:
      '(văn chương) (bóng nắng, bóng trăng) chếch về phía tây, khi chiều hoặc đêm đã quá muộn: trăng đã xế tà * "Bước tới đèo Ngang bóng xế tà, Cỏ cây chen đá, lá chen hoa." (BHThQuan; 3)',
    example:
      'trăng đã xế tà * "Bước tới đèo Ngang bóng xế tà, Cỏ cây chen đá, lá chen hoa." (BHThQuan; 3)',
  },
  {
    word: "xê-mi-na",
    part_of_speech: "danh từ",
    meaning:
      "buổi sinh hoạt học tập để thảo luận những vấn đề chuyên môn ở đại học hoặc trên đại học: tổ chức một seminar về văn học cận đại",
    example: "tổ chức một seminar về văn học cận đại",
  },
  {
    word: "xề xệ",
    part_of_speech: "động từ",
    meaning: "hơi bị sa xuống, xệ xuống một chút: khẩu súng lục xề xệ bên hông",
    example: "khẩu súng lục xề xệ bên hông",
  },
  {
    word: "xếch",
    part_of_speech: "tính từ",
    meaning:
      "không ngay ngắn, có một bên như bị kéo ngược lên: mắt xếch * đôi lông mày xếch ngược",
    example: "mắt xếch * đôi lông mày xếch ngược",
  },
  {
    word: "xếch",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) cầm mà kéo cao quần lên, làm cho không còn ngay ngắn: xếch cao quần lên",
    example: "xếch cao quần lên",
  },
  {
    word: "xệch",
    part_of_speech: "tính từ",
    meaning: "lệch hẳn đi đến mức biến dạng: mặt xệch đi vì đau đớn",
    example: "mặt xệch đi vì đau đớn",
  },
  {
    word: "xệch xạc",
    part_of_speech: "tính từ",
    meaning:
      "lệch, biến dạng đi (nói khái quát): hàng quán xệch xạc * miệng mếu đến xệch xạc",
    example: "hàng quán xệch xạc * miệng mếu đến xệch xạc",
  },
  {
    word: "xềnh xệch",
    part_of_speech: "phụ từ",
    meaning:
      "từ gợi tả dáng điệu lôi, kéo lết mạnh trên mặt đất một cách không thương tiếc, không giữ gìn: lôi bao gạo xềnh xệch * nắm tay kéo đi xềnh xệch",
    example: "lôi bao gạo xềnh xệch * nắm tay kéo đi xềnh xệch",
  },
  {
    word: "xệp",
    part_of_speech: "phụ từ",
    meaning:
      "(nằm, ngồi) sát xuống, tựa như bị dán chặt vào bề mặt: nằm xệp trên giường * ngồi xệp xuống đất",
    example: "nằm xệp trên giường * ngồi xệp xuống đất",
  },
  {
    word: "xềm xệp",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) (ngồi, nằm) xệp xuống một chỗ trong thời gian tương đối lâu: gà mái nằm xềm xệp trong ổ",
    example: "gà mái nằm xềm xệp trong ổ",
  },
  {
    word: "xên",
    part_of_speech: "động từ",
    meaning:
      "làm cho đường ăn sạch và trong bằng cách đun nước đường cùng với lòng trắng trứng, khuấy đều cho chất bẩn quấn lẫn vào lòng trắng trứng và tách riêng ra: xên đường làm mứt",
    example: "xên đường làm mứt",
  },
  {
    word: "xên",
    part_of_speech: "động từ",
    meaning: "đun nhỏ lửa cho đường ngấm vào mứt và khô lại: xên mứt gừng",
    example: "xên mứt gừng",
  },
  {
    word: "xềnh xoàng",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra quá dễ dãi, sơ sài trong sinh hoạt, coi như thế nào cũng xong: ăn mặc xuềnh xoàng * căn phòng xuềnh xoàng",
    example: "ăn mặc xuềnh xoàng * căn phòng xuềnh xoàng",
  },
  {
    word: "xênh xang",
    part_of_speech: "tính từ",
    meaning: "(hiếm) (ăn mặc) bảnh bao, chưng diện: áo mũ xênh xang",
    example: "áo mũ xênh xang",
  },
  {
    word: "xênh xang",
    part_of_speech: "tính từ",
    meaning:
      'có vẻ nghênh ngang, tự đắc: đi lại xênh xang * "Đã từng tắm gội ơn mưa móc, Cũng phải xênh xang hội gió mây." (NCTrứ; 2)',
    example:
      'đi lại xênh xang * "Đã từng tắm gội ơn mưa móc, Cũng phải xênh xang hội gió mây." (NCTrứ; 2)',
  },
  {
    word: "xếp",
    part_of_speech: "động từ",
    meaning:
      "đặt từng cái một theo đúng vị trí, hàng lối hoặc trật tự nhất định: xếp quần áo vào va li * xếp sách lên giá * trò chơi xếp hình",
    example: "xếp quần áo vào va li * xếp sách lên giá * trò chơi xếp hình",
  },
  {
    word: "xếp",
    part_of_speech: "động từ",
    meaning:
      "đặt vào vị trí trong hệ thống phân loại, đánh giá: học lực xếp loại khá * được xếp vào bậc chuyên viên",
    example: "học lực xếp loại khá * được xếp vào bậc chuyên viên",
  },
  {
    word: "xếp",
    part_of_speech: "động từ",
    meaning:
      'để lại, gác lại một chỗ nào đó, tạm thời không chú ý đến: xếp việc ấy lại * "Chàng tuổi trẻ vốn dòng hào kiệt, Xếp bút nghiên theo việc đao cung." (CPN)',
    example:
      'xếp việc ấy lại * "Chàng tuổi trẻ vốn dòng hào kiệt, Xếp bút nghiên theo việc đao cung." (CPN)',
  },
  {
    word: "xếp",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp những vật cùng loại có hình tấm mỏng xếp chồng lên nhau làm thành một đơn vị: một xếp giấy * xếp vải hoa",
    example: "một xếp giấy * xếp vải hoa",
  },
  {
    word: "xếp",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) gấp: xếp tờ giấy thành hình máy bay",
    example: "xếp tờ giấy thành hình máy bay",
  },
  {
    word: "xếp bằng",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) xếp bằng tròn (nói tắt): ngồi xếp bằng trên sập",
    example: "ngồi xếp bằng trên sập",
  },
  {
    word: "xêu",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) đũa cả: đôi xêu",
    example: "đôi xêu",
  },
  {
    word: "xếp bằng tròn",
    part_of_speech: "động từ",
    meaning:
      "(hai chân) gập lại và xếp chéo vào nhau, đùi và mông sát xuống mặt nền: ngồi xếp bằng tròn trên chiếu",
    example: "ngồi xếp bằng tròn trên chiếu",
  },
  {
    word: "xếp hàng",
    part_of_speech: "động từ",
    meaning:
      "đứng thành hàng theo thứ tự: học sinh xếp hàng vào lớp * xếp hàng mua thực phẩm",
    example: "học sinh xếp hàng vào lớp * xếp hàng mua thực phẩm",
  },
  {
    word: "xếp xó",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) xếp vào một góc nào đó, không nhìn ngó gì đến vì không còn tác dụng nữa: xe hỏng nên đành xếp xó",
    example: "xe hỏng nên đành xếp xó",
  },
  {
    word: "xếp đặt",
    part_of_speech: "động từ",
    meaning:
      "sắp xếp theo ý định của mình: đồ đạc xếp đặt ngăn nắp * xếp đặt công việc",
    example: "đồ đạc xếp đặt ngăn nắp * xếp đặt công việc",
  },
  {
    word: "xếp dọn",
    part_of_speech: "động từ",
    meaning:
      "sắp đặt lại cho gọn gàng, sạch sẽ (nói khái quát): xếp dọn sách vở * xếp dọn nhà cửa cho gọn gàng",
    example: "xếp dọn sách vở * xếp dọn nhà cửa cho gọn gàng",
  },
  {
    word: "xếp hạng",
    part_of_speech: "động từ",
    meaning:
      "xếp vào một thứ hạng nào đó trong một hệ thống đánh giá, phân loại: đứng đầu bảng xếp hạng * một di tích lịch sử được xếp hạng",
    example: "đứng đầu bảng xếp hạng * một di tích lịch sử được xếp hạng",
  },
  {
    word: "xếp dỡ",
    part_of_speech: "động từ",
    meaning:
      "xếp và dỡ hàng hoá từ kho bãi lên phương tiện vận tải hoặc từ phương tiện vận tải xuống kho bãi (nói khái quát): công nhân xếp dỡ * phương tiện xếp dỡ",
    example: "công nhân xếp dỡ * phương tiện xếp dỡ",
  },
  {
    word: "xỉ",
    part_of_speech: "danh từ",
    meaning:
      "chất thải rắn và xốp còn lại trong quá trình luyện kim, đốt lò: xỉ than * xỉ sắt",
    example: "xỉ than * xỉ sắt",
  },
  {
    word: "xi",
    part_of_speech: "danh từ",
    meaning:
      "chất làm bằng cánh kiến pha lẫn tinh dầu, dùng để niêm phong bao, túi, gắn kín nút chai lọ, v.v.: gắn xi vào nút lọ mực * đóng dấu xi",
    example: "gắn xi vào nút lọ mực * đóng dấu xi",
  },
  {
    word: "xi",
    part_of_speech: "danh từ",
    meaning:
      "chất dùng để đánh bóng da thuộc, sàn gỗ, v.v.: xi đánh giày * sàn nhà được đánh xi bóng loáng",
    example: "xi đánh giày * sàn nhà được đánh xi bóng loáng",
  },
  {
    word: "xi",
    part_of_speech: "động từ",
    meaning:
      "kích thích trẻ con đái, ỉa bằng cách phát ra tiếng xi kéo dài: xi trẻ đái",
    example: "xi trẻ đái",
  },
  {
    word: "xí",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) chọn giữ trước, giành lấy trước cho mình: xí phần * đi sớm để xí chỗ",
    example: "xí phần * đi sớm để xí chỗ",
  },
  {
    word: "xí",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) tí: thêm xí muối nữa là vừa * mỗi người một xí",
    example: "thêm xí muối nữa là vừa * mỗi người một xí",
  },
  {
    word: "xì",
    part_of_speech: "động từ",
    meaning:
      "(hơi bị nén) bật hoặc làm cho bật thoát mạnh ra qua chỗ hở hẹp: quả bóng bị xì hơi * lựu đạn xì khói",
    example: "quả bóng bị xì hơi * lựu đạn xì khói",
  },
  {
    word: "xì",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) phì mạnh hơi qua kẽ răng, làm bật lên tiếng xì, để tỏ thái độ không bằng lòng hoặc coi thường, khinh bỉ: không trả lời, chỉ xì một tiếng",
    example: "không trả lời, chỉ xì một tiếng",
  },
  {
    word: "xì",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) như hỉ: xì mũi",
    example: "xì mũi",
  },
  {
    word: "xì",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) đưa ra hoặc nói lộ ra, do bắt buộc (hàm ý chê): doạ một câu là xì ra hết * nói mãi mới chịu xì tiền ra",
    example: "doạ một câu là xì ra hết * nói mãi mới chịu xì tiền ra",
  },
  {
    word: "xì căng đan",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) vụ, việc bê bối, gây tai tiếng trong dư luận xã hội: gây xì căng đan * vụ xì căng đan chính trị",
    example: "gây xì căng đan * vụ xì căng đan chính trị",
  },
  {
    word: "xì ke",
    part_of_speech: "danh từ",
    meaning:
      "(thông tục) thuốc phiện: hút xì ke * kiên quyết xoá nạn xì ke, ma tuý",
    example: "hút xì ke * kiên quyết xoá nạn xì ke, ma tuý",
  },
  {
    word: "xì ke",
    part_of_speech: "tính từ",
    meaning: "(thông tục) có thói nghiện ma tuý: đối tượng xì ke * bọn xì ke",
    example: "đối tượng xì ke * bọn xì ke",
  },
  {
    word: "xị",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) chai nhỏ có dung tích khoảng một phần tư lít: một xị rượu * xị nước mắm",
    example: "một xị rượu * xị nước mắm",
  },
  {
    word: "xị",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) xệ xuống một cách nặng nề (thường nói về vẻ mặt không vui, không vừa lòng): mặt béo xị * mới đùa một câu mặt đã xị xuống",
    example: "mặt béo xị * mới đùa một câu mặt đã xị xuống",
  },
  {
    word: "xì gà",
    part_of_speech: "danh từ",
    meaning:
      "thuốc hút chế từ sợi khô của lá cây thuốc lá và được cuốn bằng chính lá cây thuốc lá để nguyên: miệng ngậm điếu xì gà",
    example: "miệng ngậm điếu xì gà",
  },
  {
    word: "xỉ vả",
    part_of_speech: "động từ",
    meaning:
      "mắng nhiếc thậm tệ, làm cho phải xấu hổ, nhục nhã: nặng lời xỉ vả * tự xỉ vả mình",
    example: "nặng lời xỉ vả * tự xỉ vả mình",
  },
  {
    word: "xi nê",
    part_of_speech: "danh từ",
    meaning: "(cũ, khẩu ngữ) điện ảnh: đi xem xi nê",
    example: "đi xem xi nê",
  },
  {
    word: "xí nghiệp",
    part_of_speech: "danh từ",
    meaning:
      "cơ sở sản xuất, kinh doanh tương đối lớn, có nhà xưởng và trang thiết bị cần thiết: xí nghiệp may * xí nghiệp dược phẩm",
    example: "xí nghiệp may * xí nghiệp dược phẩm",
  },
  {
    word: "xi nhan",
    part_of_speech: "danh từ",
    meaning:
      "đèn báo hiệu xin đường của các phương tiện giao thông: xe bị hỏng xi nhan",
    example: "xe bị hỏng xi nhan",
  },
  {
    word: "xi nhan",
    part_of_speech: "động từ",
    meaning:
      "làm tín hiệu xin đường (thường là bằng đèn xi nhan): giơ tay xi nhan xin đường * xi nhan cho xe lùi lại",
    example: "giơ tay xi nhan xin đường * xi nhan cho xe lùi lại",
  },
  {
    word: "xì xằng",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ, hiếm) như nhì nhằng (ng3): buôn bán xì xằng",
    example: "buôn bán xì xằng",
  },
  {
    word: "xì xào",
    part_of_speech: "tính từ",
    meaning:
      "có tiếng chuyện trò, bàn tán nho nhỏ, hỗn tạp không tách bạch nên nghe không rõ lời: có tiếng xì xào phía cuối lớp",
    example: "có tiếng xì xào phía cuối lớp",
  },
  {
    word: "xì xào",
    part_of_speech: "động từ",
    meaning:
      "bàn tán riêng với nhau, có ý chê bai, dè bỉu: xì xào bán tán * thiên hạ xì xào nhiều về chuyện ấy",
    example: "xì xào bán tán * thiên hạ xì xào nhiều về chuyện ấy",
  },
  {
    word: "xì xị",
    part_of_speech: "động từ",
    meaning: "hơi xị xuống: mặt xì xị, chẳng nói chẳng rằng",
    example: "mặt xì xị, chẳng nói chẳng rằng",
  },
  {
    word: "xì xồ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nói bằng thứ tiếng xa lạ (thường của người Âu), nghe không hiểu được: mấy người ngoại quốc đang xì xồ với nhau",
    example: "mấy người ngoại quốc đang xì xồ với nhau",
  },
  {
    word: "xì xồ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) từ mô phỏng tiếng nói chuyện của một số người nước ngoài (thường của người Âu), nghe không hiểu được: nói tiếng Tây xì xồ",
    example: "nói tiếng Tây xì xồ",
  },
  {
    word: "xì xèo",
    part_of_speech: "động từ",
    meaning:
      "bàn tán nhỏ to và dai dẳng với nhau, với ý phàn nàn hoặc chê bai, gây cảm giác khó chịu: xì xèo thắc mắc",
    example: "xì xèo thắc mắc",
  },
  {
    word: "xí xoá",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bỏ qua, coi như không hề có gì, không hề xảy ra điều gì trong quan hệ với nhau: cười xí xoá * xí xoá mọi chuyện * món nợ đó coi như xí xoá",
    example: "cười xí xoá * xí xoá mọi chuyện * món nợ đó coi như xí xoá",
  },
  {
    word: "xí xớn",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) có những cử chỉ, hành vi tỏ ra không được đứng đắn (hàm ý chê): đừng có xí xớn * xí xớn với tay hàng xóm",
    example: "đừng có xí xớn * xí xớn với tay hàng xóm",
  },
  {
    word: "xì xoẹt",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng phát ra lúc to lúc nhỏ và đều đều như tiếng cắt bằng vật sắc vào vật cứng: cưa xì xoẹt",
    example: "cưa xì xoẹt",
  },
  {
    word: "xì xục",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) trằn trọc, lăn qua lăn lại: mất ngủ, xì xục cả đêm",
    example: "mất ngủ, xì xục cả đêm",
  },
  {
    word: "xi-béc-nê-tích",
    part_of_speech: "danh từ",
    meaning:
      "khoa học nghiên cứu những quy luật tổng quát của các quá trình thu nhận, lưu trữ, truyền dẫn, xử lí và sử dụng thông tin: khoa điều khiển học",
    example: "khoa điều khiển học",
  },
  {
    word: "xỉa",
    part_of_speech: "động từ",
    meaning:
      "đâm, chọc thẳng vào một cách nhanh, mạnh và dứt khoát: xỉa lưỡi lê vào ngực * xỉa cho nó mấy nhát",
    example: "xỉa lưỡi lê vào ngực * xỉa cho nó mấy nhát",
  },
  {
    word: "xỉa",
    part_of_speech: "động từ",
    meaning:
      "chọc và xoi nhẹ các kẽ răng cho sạch bựa: xỉa răng * cầm cái tăm vừa đi vừa xỉa",
    example: "xỉa răng * cầm cái tăm vừa đi vừa xỉa",
  },
  {
    word: "xỉa",
    part_of_speech: "động từ",
    meaning:
      "chỉ thẳng ngón tay vào mặt người khác để chửi mắng: xỉa thẳng vào mặt mà chửi",
    example: "xỉa thẳng vào mặt mà chửi",
  },
  {
    word: "xỉa",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) xen vào việc không dính líu đến mình: không nên xỉa vào chuyện của người khác",
    example: "không nên xỉa vào chuyện của người khác",
  },
  {
    word: "xỉa",
    part_of_speech: "động từ",
    meaning:
      "bỏ ra liên tiếp từng cái một trong một nắm cầm ở tay để có thể đếm được: xỉa tiền ra đếm",
    example: "xỉa tiền ra đếm",
  },
  {
    word: "xì xụp",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng như tiếng húp mạnh liên tiếp: húp cháo xì xụp * ăn uống xì xụp",
    example: "húp cháo xì xụp * ăn uống xì xụp",
  },
  {
    word: "xích",
    part_of_speech: "danh từ",
    meaning:
      "dây kim loại gồm nhiều vòng, nhiều khúc giống nhau, móc nối liên tiếp với nhau: xích xe tăng * xe đạp tuột xích * nối lại các mắt xích",
    example: "xích xe tăng * xe đạp tuột xích * nối lại các mắt xích",
  },
  {
    word: "xích",
    part_of_speech: "động từ",
    meaning: "buộc, giữ bằng dây xích: xích con chó lại",
    example: "xích con chó lại",
  },
  {
    word: "xích",
    part_of_speech: "động từ",
    meaning:
      "chuyển dịch vị trí trong khoảng rất ngắn: ngồi xích vào * xích lên một chút * xích lại gần nhau",
    example: "ngồi xích vào * xích lên một chút * xích lại gần nhau",
  },
  {
    word: "xía",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) xen vào: chuyện của tôi, mắc mớ gì mà anh xía vô?",
    example: "chuyện của tôi, mắc mớ gì mà anh xía vô?",
  },
  {
    word: "xịch",
    part_of_speech: "tính từ",
    meaning:
      "(cũng sịch) từ mô phỏng tiếng động mạnh và đột ngột như tiếng ô tô dừng đột ngột: ô tô đỗ xịch trước cửa * cánh cửa xịch mở",
    example: "ô tô đỗ xịch trước cửa * cánh cửa xịch mở",
  },
  {
    word: "xịch",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) xích, dịch ra chút ít: ngồi xịch ra",
    example: "ngồi xịch ra",
  },
  {
    word: "xỉa xói",
    part_of_speech: "động từ",
    meaning:
      "xỉa liên tiếp vào mặt người khác để mắng chửi: xỉa xói vào mặt nhau mà chửi",
    example: "xỉa xói vào mặt nhau mà chửi",
  },
  {
    word: "xích lô",
    part_of_speech: "danh từ",
    meaning:
      "xe ba bánh do người đạp, dùng để chuyên chở người hoặc hàng hoá: đạp xích lô * gọi xích lô đi chơi phố",
    example: "đạp xích lô * gọi xích lô đi chơi phố",
  },
  {
    word: "xích mích",
    part_of_speech: "động từ",
    meaning:
      "có va chạm lặt vặt trong quan hệ với nhau: anh em xích mích với nhau",
    example: "anh em xích mích với nhau",
  },
  {
    word: "xích mích",
    part_of_speech: "danh từ",
    meaning:
      "điều va chạm, sự không hoà thuận trong quan hệ với nhau: hai nhà có xích mích với nhau * nảy sinh xích mích",
    example: "hai nhà có xích mích với nhau * nảy sinh xích mích",
  },
  {
    word: "xích vệ",
    part_of_speech: "danh từ",
    meaning:
      "lực lượng vũ trang của đảng cộng sản ở địa phương trong thời kì đầu cách mạng: đội xích vệ",
    example: "đội xích vệ",
  },
  {
    word: "xích thằng",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) sợi chỉ đỏ; dùng để chỉ duyên vợ chồng, trong điển tích về Nguyệt Lão: "Cạn lời, khách mới thưa rằng, Buộc chân, thôi cũng xích thằng nhiệm trao." (TKiều)',
    example:
      'Cạn lời, khách mới thưa rằng, Buộc chân, thôi cũng xích thằng nhiệm trao." (TKiều)',
  },
  {
    word: "xích xiềng",
    part_of_speech: "danh từ",
    meaning: "như xiềng xích: đập tan xích xiềng thực dân",
    example: "đập tan xích xiềng thực dân",
  },
  {
    word: "xiêm áo",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) đồ mặc của người quyền quý thời phong kiến, như áo, xiêm, v.v. (nói khái quát): xiêm áo thướt tha",
    example: "xiêm áo thướt tha",
  },
  {
    word: "xiếc",
    part_of_speech: "danh từ",
    meaning:
      "nghệ thuật sân khấu, do người hoặc thú biểu diễn những động tác nhào lộn, leo trèo, v.v. đặc biệt khéo léo: tiết mục xiếc * diễn viên xiếc * rạp xiếc",
    example: "tiết mục xiếc * diễn viên xiếc * rạp xiếc",
  },
  {
    word: "xiên",
    part_of_speech: "động từ",
    meaning:
      "đâm sâu vào hoặc đâm xuyên qua bằng vật dài, nhỏ và thường có đầu nhọn: xiên cá * xiên thịt nướng chả",
    example: "xiên cá * xiên thịt nướng chả",
  },
  {
    word: "xiên",
    part_of_speech: "danh từ",
    meaning:
      "vật hình dài, có một hay vài ba mũi nhọn, dùng để đâm xuyên qua: lấy xiên xiên cá * mua một xiên chả",
    example: "lấy xiên xiên cá * mua một xiên chả",
  },
  {
    word: "xiên",
    part_of_speech: "tính từ",
    meaning:
      "không đúng với hướng thẳng đứng, hướng nằm ngang: đường kẻ bị xiên * cột mốc bị xiên * hạt mưa bay xiên",
    example: "đường kẻ bị xiên * cột mốc bị xiên * hạt mưa bay xiên",
  },
  {
    word: "xiên",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) chiếu thẳng vào: tia nắng xiên vào mặt * ánh trăng xiên qua khe cửa",
    example: "tia nắng xiên vào mặt * ánh trăng xiên qua khe cửa",
  },
  {
    word: "xiêm y",
    part_of_speech: "danh từ",
    meaning: "(cũ) như xiêm áo: xiêm y tha thướt",
    example: "xiêm y tha thướt",
  },
  {
    word: "xiên xẹo",
    part_of_speech: "tính từ",
    meaning:
      "xiên, không thẳng, không ngay (nói khái quát): dòng chữ viết xiên xẹo * bước đi xiên xẹo",
    example: "dòng chữ viết xiên xẹo * bước đi xiên xẹo",
  },
  {
    word: "xiên xẹo",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) không ngay thẳng, thật thà: ăn nói xiên xẹo * con người xiên xẹo, khó lường",
    example: "ăn nói xiên xẹo * con người xiên xẹo, khó lường",
  },
  {
    word: "xiết",
    part_of_speech: "động từ",
    meaning:
      "làm cho vừa chuyển động mạnh vừa áp thật sát trên bề mặt một vật khác: xiết lưỡi dao vào đá mài * dùng vỏ chai xiết đỗ xanh",
    example: "xiết lưỡi dao vào đá mài * dùng vỏ chai xiết đỗ xanh",
  },
  {
    word: "xiết",
    part_of_speech: "động từ",
    meaning:
      "(dòng nước) chảy rất mạnh và nhanh: dòng nước xiết * nước lũ chảy xiết",
    example: "dòng nước xiết * nước lũ chảy xiết",
  },
  {
    word: "xiết",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) xiết nợ (nói tắt): bị xiết hết đồ đạc",
    example: "bị xiết hết đồ đạc",
  },
  {
    word: "xiết",
    part_of_speech: "động từ",
    meaning:
      "(văn chương) cho đến hết, đến cùng: mừng vui khôn xiết * nói sao cho xiết * đẹp không bút nào tả xiết",
    example:
      "mừng vui khôn xiết * nói sao cho xiết * đẹp không bút nào tả xiết",
  },
  {
    word: "xiết",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) được, nổi: nặng quá, hai người khiêng không xiết",
    example: "nặng quá, hai người khiêng không xiết",
  },
  {
    word: "xiềng",
    part_of_speech: "danh từ",
    meaning:
      "xích lớn, hai đầu có vòng sắt để khoá chặt chân hoặc tay: chân đeo xiềng * dây xiềng",
    example: "chân đeo xiềng * dây xiềng",
  },
  {
    word: "xiềng",
    part_of_speech: "động từ",
    meaning: "khoá giữ bằng xiềng: chân bị xiềng",
    example: "chân bị xiềng",
  },
  {
    word: "xiểng liểng",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như liểng xiểng: bị thua xiểng liểng",
    example: "bị thua xiểng liểng",
  },
  {
    word: "xiềng xích",
    part_of_speech: "danh từ",
    meaning:
      "xiềng (nói khái quát); dùng để chỉ sự trói buộc, áp bức nặng nề: đập tan xiềng xích nô lệ",
    example: "đập tan xiềng xích nô lệ",
  },
  {
    word: "xiềng xích",
    part_of_speech: "động từ",
    meaning: "(hiếm) xiềng (nói khái quát): chân tay bị xiềng xích",
    example: "chân tay bị xiềng xích",
  },
  {
    word: "xiết bao",
    part_of_speech: "phụ từ",
    meaning:
      '(văn chương) đến mức không sao nói cho hết: hạnh phúc xiết bao * "Chiếc thoa nào của mấy mươi, Mà lòng trọng nghĩa khinh tài xiết bao!" (TKiều)',
    example:
      'hạnh phúc xiết bao * "Chiếc thoa nào của mấy mươi, Mà lòng trọng nghĩa khinh tài xiết bao!" (TKiều)',
  },
  {
    word: "xiêu lòng",
    part_of_speech: "động từ",
    meaning:
      "không giữ được lòng kiên định, ngả theo, nghe theo ý của người khác do bị thuyết phục, bị quyến rũ: xiêu lòng chấp thuận * xiêu lòng bởi lời đường mật",
    example: "xiêu lòng chấp thuận * xiêu lòng bởi lời đường mật",
  },
  {
    word: "xiêu",
    part_of_speech: "động từ",
    meaning:
      'nghiêng, lệch về một bên, không còn ở vị trí thẳng nữa: cây cột xiêu * "Lạ cho cái sóng khuynh thành, Làm cho đổ quán xiêu đình, như chơi!" (TKiều)',
    example:
      'cây cột xiêu * "Lạ cho cái sóng khuynh thành, Làm cho đổ quán xiêu đình, như chơi!" (TKiều)',
  },
  {
    word: "xiêu",
    part_of_speech: "động từ",
    meaning:
      'bắt đầu nghe theo, ưng theo ý của người khác do được thuyết phục, không còn kiên định ý kiến nữa: nghe nói có lí nên cũng xiêu * "Qua chơi nghe tiếng nàng Kiều, Tấm lòng nhi nữ cũng xiêu anh hùng." (TKiều)',
    example:
      'nghe nói có lí nên cũng xiêu * "Qua chơi nghe tiếng nàng Kiều, Tấm lòng nhi nữ cũng xiêu anh hùng." (TKiều)',
  },
  {
    word: "xiết nợ",
    part_of_speech: "động từ",
    meaning:
      "lấy của người khác, bất kể đồng ý hay không, để trừ vào nợ: bắt đồ đạc để xiết nợ",
    example: "bắt đồ đạc để xiết nợ",
  },
  {
    word: "xiêu xiêu",
    part_of_speech: "động từ",
    meaning:
      'hơi xiêu: "Sóng tình dường đã xiêu xiêu, Xem trong âu yếm có chiều lả lơi." (TKiều)',
    example:
      'Sóng tình dường đã xiêu xiêu, Xem trong âu yếm có chiều lả lơi." (TKiều)',
  },
  {
    word: "xiêu vẹo",
    part_of_speech: "tính từ",
    meaning:
      "nghiêng lệch theo những hướng khác nhau, không còn đứng được thẳng, được vững nữa: túp lều xiêu vẹo * say rượu, bước đi xiêu vẹo",
    example: "túp lều xiêu vẹo * say rượu, bước đi xiêu vẹo",
  },
  {
    word: "xin",
    part_of_speech: "động từ",
    meaning:
      "ngỏ ý với người nào đó, mong người ấy cho mình cái gì hoặc đồng ý cho mình làm điều gì: xin tiền * xin chữ kí * đơn xin việc * xin tha tội",
    example: "xin tiền * xin chữ kí * đơn xin việc * xin tha tội",
  },
  {
    word: "xin",
    part_of_speech: "động từ",
    meaning:
      "từ dùng ở đầu lời yêu cầu, biểu thị thái độ khiêm tốn, lịch sự: xin giữ trật tự * xin mọi người chú ý * xin quý khách vui lòng cho xem vé",
    example:
      "xin giữ trật tự * xin mọi người chú ý * xin quý khách vui lòng cho xem vé",
  },
  {
    word: "xin",
    part_of_speech: "động từ",
    meaning:
      "từ dùng trong những lời chào mời, cảm ơn, v.v., biểu thị thái độ khiêm tốn, lễ phép: xin cảm ơn * xin mời vào * xin ông cứ tự nhiên",
    example: "xin cảm ơn * xin mời vào * xin ông cứ tự nhiên",
  },
  {
    word: "xỉn",
    part_of_speech: "tính từ",
    meaning:
      "có màu ngả sang màu đen bẩn và kém vẻ bóng bẩy: nước kền đã xỉn * nồi đồng bị xỉn đen * vải xỉn màu",
    example: "nước kền đã xỉn * nồi đồng bị xỉn đen * vải xỉn màu",
  },
  {
    word: "xỉn",
    part_of_speech: "tính từ",
    meaning: "(Khẩu ngữ) say rượu, bia: mới uống vài cốc đã xỉn",
    example: "mới uống vài cốc đã xỉn",
  },
  {
    word: "xin đủ",
    part_of_speech: "",
    meaning:
      '(khẩu ngữ) tổ hợp dùng để biểu thị sự phản đối trước thái độ, lời lẽ của người khác đối với mình do thấy không còn có thể chấp nhận, chịu đựng được nữa: "Thôi thôi xin đủ! Chúng tôi không cần đến cái thứ hối hận của anh!" (NgKhTrường; 1)',
    example:
      'Thôi thôi xin đủ! Chúng tôi không cần đến cái thứ hối hận của anh!" (NgKhTrường; 1)',
  },
  {
    word: "xin đểu",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) ép buộc người khác phải cho, phải nộp một cách ngang ngược: bị bọn đầu gấu xin đểu",
    example: "bị bọn đầu gấu xin đểu",
  },
  {
    word: "xin âm dương",
    part_of_speech: "động từ",
    meaning:
      "xin quẻ bằng cách gieo hai đồng tiền, nếu một ngửa một sấp thì là quẻ tốt: gieo tiền để xin âm dương",
    example: "gieo tiền để xin âm dương",
  },
  {
    word: "xin đi đằng đầu",
    part_of_speech: "",
    meaning: "(khẩu ngữ) như đi đằng đầu: nó mà thi đỗ thì tôi xin đi đằng đầu",
    example: "nó mà thi đỗ thì tôi xin đi đằng đầu",
  },
  {
    word: "xịn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) thuộc loại sang, đắt tiền: vải Nhật xịn * xe xịn * dùng toàn đồ xịn",
    example: "vải Nhật xịn * xe xịn * dùng toàn đồ xịn",
  },
  {
    word: "xin xỉn",
    part_of_speech: "tính từ",
    meaning: "hơi xỉn: nước kền mạ đã xin xỉn",
    example: "nước kền mạ đã xin xỉn",
  },
  {
    word: "xin lỗi",
    part_of_speech: "động từ",
    meaning:
      "xin được tha thứ vì đã biết lỗi: xin lỗi vì đã đến muộn * ngỏ lời xin lỗi",
    example: "xin lỗi vì đã đến muộn * ngỏ lời xin lỗi",
  },
  {
    word: "xin lỗi",
    part_of_speech: "động từ",
    meaning:
      "từ dùng để mở đầu lời nói một cách lịch sự khi có việc phải làm phiền tới người khác: xin lỗi, anh cho tôi lên trước * xin lỗi vì đã làm phiền chị",
    example: "xin lỗi, anh cho tôi lên trước * xin lỗi vì đã làm phiền chị",
  },
  {
    word: "xin xỏ",
    part_of_speech: "động từ",
    meaning:
      "xin một cách khúm núm, với thái độ tự hạ mình (nói khái quát): đi xin xỏ, cầu cạnh * không xin xỏ gì hết",
    example: "đi xin xỏ, cầu cạnh * không xin xỏ gì hết",
  },
  {
    word: "xinh",
    part_of_speech: "tính từ",
    meaning:
      "có hình dáng và những đường nét rất dễ coi, ưa nhìn (thường nói về trẻ em, phụ nữ trẻ): em bé rất xinh * miệng cười xinh * gương mặt khá xinh",
    example: "em bé rất xinh * miệng cười xinh * gương mặt khá xinh",
  },
  {
    word: "xinh",
    part_of_speech: "tính từ",
    meaning:
      "có hình dáng nhỏ nhắn, thanh thoát, trông thích mắt: đôi bàn tay xinh * chiếc bút rất xinh",
    example: "đôi bàn tay xinh * chiếc bút rất xinh",
  },
  {
    word: "xình xịch",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng trầm và đều đều phát ra liên tục như tiếng của máy nổ: máy chạy xình xịch * đoàn tàu xình xịch chuyển bánh",
    example: "máy chạy xình xịch * đoàn tàu xình xịch chuyển bánh",
  },
  {
    word: "xinh xắn",
    part_of_speech: "tính từ",
    meaning: "xinh và rất ưa nhìn: gương mặt xinh xắn * căn phòng xinh xắn",
    example: "gương mặt xinh xắn * căn phòng xinh xắn",
  },
  {
    word: "xinh xẻo",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như xinh xắn: cái miệng đến là xinh xẻo!",
    example: "cái miệng đến là xinh xẻo!",
  },
  {
    word: "xinh đẹp",
    part_of_speech: "tính từ",
    meaning:
      'rất xinh và có được sự hài hoà, trông thích mắt: nhan sắc xinh đẹp * "Khác nào quạ mượn lông công, Ngoài hình xinh đẹp trong lòng xấu xa." (ca dao)',
    example:
      'nhan sắc xinh đẹp * "Khác nào quạ mượn lông công, Ngoài hình xinh đẹp trong lòng xấu xa." (ca dao)',
  },
  {
    word: "xinh tươi",
    part_of_speech: "tính từ",
    meaning:
      "xinh và tươi tắn, có sức sống: thiếu nữ xinh tươi * nụ cười thật xinh tươi",
    example: "thiếu nữ xinh tươi * nụ cười thật xinh tươi",
  },
  {
    word: "xịt",
    part_of_speech: "động từ",
    meaning:
      "phun mạnh thành tia, thành luồng: xịt nước hoa * đầu xịt gôm * xe xịt khói mù mịt",
    example: "xịt nước hoa * đầu xịt gôm * xe xịt khói mù mịt",
  },
  {
    word: "xịt",
    part_of_speech: "tính từ",
    meaning:
      "bị xì hết hơi ra, không còn căng phồng như trước: quả bóng xịt * xe bị xịt lốp",
    example: "quả bóng xịt * xe bị xịt lốp",
  },
  {
    word: "xịt",
    part_of_speech: "tính từ",
    meaning: "bị hỏng, không nổ được: pháo xịt * lựu đạn xịt, không nổ",
    example: "pháo xịt * lựu đạn xịt, không nổ",
  },
  {
    word: "xịt",
    part_of_speech: "tính từ",
    meaning:
      "(màu sắc) đã mất hết vẻ tươi, chuyển sang đục, tối, trông xấu: quả cà thâm xịt * đôi môi xám xịt",
    example: "quả cà thâm xịt * đôi môi xám xịt",
  },
  {
    word: "xinh xinh",
    part_of_speech: "tính từ",
    meaning:
      "hơi xinh, trông ưa nhìn, đáng yêu: ngôi nhà xinh xinh * cô ta trông cũng xinh xinh",
    example: "ngôi nhà xinh xinh * cô ta trông cũng xinh xinh",
  },
  {
    word: "xíu",
    part_of_speech: "",
    meaning:
      "(phương ngữ) nhỏ, ít đến mức hoàn toàn không đáng kể: chiếc chén bé xíu * đợi một xíu * còn có xíu xíu thôi",
    example: "chiếc chén bé xíu * đợi một xíu * còn có xíu xíu thôi",
  },
  {
    word: "xỉu",
    part_of_speech: "động từ",
    meaning:
      "lả đi, rũ xuống, không còn sức cử động: xỉu đi vì đói * mệt muốn xỉu * sợ quá, té xỉu",
    example: "xỉu đi vì đói * mệt muốn xỉu * sợ quá, té xỉu",
  },
  {
    word: "xịu",
    part_of_speech: "động từ",
    meaning:
      "(nét mặt) trở nên ủ rũ và như sa xuống, vì buồn nản, thất vọng: xịu mặt vì bị mắng",
    example: "xịu mặt vì bị mắng",
  },
  {
    word: "xịu",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) rũ người xuống, như không còn sức nữa: người xịu xuống vì mệt",
    example: "người xịu xuống vì mệt",
  },
  {
    word: "xo",
    part_of_speech: "tính từ",
    meaning: "có vẻ ủ rũ, teo tóp lại: người gầy xo * mặt buồn xo",
    example: "người gầy xo * mặt buồn xo",
  },
  {
    word: "xìu",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) mềm, xẹp hẳn xuống, không còn căng và cứng nữa: lốp xe bị xìu * chân tay yếu xìu",
    example: "lốp xe bị xìu * chân tay yếu xìu",
  },
  {
    word: "xìu",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) tỏ vẻ buồn chán, không còn có nhiệt tình, hăng hái như trước: mặt xìu xuống",
    example: "mặt xìu xuống",
  },
  {
    word: "xó",
    part_of_speech: "danh từ",
    meaning:
      "góc nhỏ hẹp, tối tăm, ít được chú ý tới: xó bếp * ngồi vào một xó * xe hỏng phải vứt xó",
    example: "xó bếp * ngồi vào một xó * xe hỏng phải vứt xó",
  },
  {
    word: "xỏ lá ba que",
    part_of_speech: "",
    meaning: "ba que và xỏ lá (nói khái quát): rặt một bọn ba que xỏ lá",
    example: "rặt một bọn ba que xỏ lá",
  },
  {
    word: "xỏ lá",
    part_of_speech: "tính từ",
    meaning:
      "có tính hay lừa gạt người một cách tai quái, đểu giả, dưới cái vẻ bề ngoài tử tế: đồ xỏ lá!",
    example: "đồ xỏ lá!",
  },
  {
    word: "xỏ mũi",
    part_of_speech: "động từ",
    meaning:
      '(khẩu ngữ) ví trường hợp sai khiến, điều khiển người khác một cách quá dễ dàng: "Cái tay đội trưởng cũ ngu ngơ quá, bị chúng nó xỏ mũi cả." (KQThuỵ; 1)',
    example:
      'Cái tay đội trưởng cũ ngu ngơ quá, bị chúng nó xỏ mũi cả." (KQThuỵ; 1)',
  },
  {
    word: "xỏ",
    part_of_speech: "động từ",
    meaning:
      "cho thẳng một vật (thường nhỏ, dài) luồn qua, xuyên qua chỗ thủng, chỗ trống của một vật khác: xỏ kim * xỏ thừng vào mũi trâu * xỏ đòn gánh vào quang",
    example: "xỏ kim * xỏ thừng vào mũi trâu * xỏ đòn gánh vào quang",
  },
  {
    word: "xỏ",
    part_of_speech: "động từ",
    meaning: "tạo thành một lỗ để có thể xỏ: xỏ lỗ tai * xỏ mũi đeo vòng",
    example: "xỏ lỗ tai * xỏ mũi đeo vòng",
  },
  {
    word: "xỏ",
    part_of_speech: "động từ",
    meaning:
      "cho tay, chân vào để mang vào người: xỏ chân vào bít tất * tay xỏ túi quần",
    example: "xỏ chân vào bít tất * tay xỏ túi quần",
  },
  {
    word: "xỏ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) lợi dụng chỗ sơ hở để làm cho người ta sa vào tình trạng bất lợi, bị thiệt hại: hỏi xỏ * khen xỏ * bị xỏ một vố đau",
    example: "hỏi xỏ * khen xỏ * bị xỏ một vố đau",
  },
  {
    word: "xọ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) chuyển đột ngột sang câu khác, chuyện khác không dính líu gì với nhau: câu nọ xọ câu kia * đang chuyện nọ lại xọ chuyện kia",
    example: "câu nọ xọ câu kia * đang chuyện nọ lại xọ chuyện kia",
  },
  {
    word: "xỏ xiên",
    part_of_speech: "động từ",
    meaning:
      "nói xỏ một cách bóng gió để tỏ thái độ khinh miệt, đả kích (nói khái quát): ăn nói xỏ xiên * hỏi xỏ xiên",
    example: "ăn nói xỏ xiên * hỏi xỏ xiên",
  },
  {
    word: "xo ro",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả dáng người cố thu nhỏ lại, thường vì lạnh hoặc buồn: ngồi xo ro một góc",
    example: "ngồi xo ro một góc",
  },
  {
    word: "xỏ ngọt",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nói xỏ một cách nhẹ nhàng, nhưng thấm thía: xỏ ngọt một câu",
    example: "xỏ ngọt một câu",
  },
  {
    word: "xoá",
    part_of_speech: "động từ",
    meaning: "làm cho mất dấu vết trên bề mặt: xoá bảng * xoá sạch dấu vết",
    example: "xoá bảng * xoá sạch dấu vết",
  },
  {
    word: "xoá",
    part_of_speech: "động từ",
    meaning: "gạch bỏ đi: xoá đi một chữ * xoá tên trong danh sách",
    example: "xoá đi một chữ * xoá tên trong danh sách",
  },
  {
    word: "xoá",
    part_of_speech: "động từ",
    meaning:
      "làm cho mất hẳn đi, không còn tồn tại hoặc không còn tác dụng nữa: xoá nợ * xoá bỏ hận thù * thời gian đã xoá mờ kỉ niệm",
    example: "xoá nợ * xoá bỏ hận thù * thời gian đã xoá mờ kỉ niệm",
  },
  {
    word: "xó xỉnh",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) nơi chật hẹp, tối tăm, ít người biết đến (nói khái quát): chui rúc trong các xó xỉnh * tìm khắp mọi xó xỉnh",
    example: "chui rúc trong các xó xỉnh * tìm khắp mọi xó xỉnh",
  },
  {
    word: "xoã",
    part_of_speech: "động từ",
    meaning:
      "buông thả xuống và xoè ra một cách tự nhiên: chim xoã cánh * tóc để xoã",
    example: "chim xoã cánh * tóc để xoã",
  },
  {
    word: "xo-nat",
    part_of_speech: "danh từ",
    meaning:
      "bản nhạc gồm ba hoặc bốn chương khác nhau về nhịp điệu và tính chất, nối tiếp với nhau: bản sonata của Beethoven",
    example: "bản sonata của Beethoven",
  },
  {
    word: "xoa",
    part_of_speech: "động từ",
    meaning:
      "áp lòng bàn tay vào và đưa đi đưa lại một cách nhẹ nhàng trên bề mặt vật gì: xoa đầu bé * xoa bụng * xoa hai bàn tay vào nhau",
    example: "xoa đầu bé * xoa bụng * xoa hai bàn tay vào nhau",
  },
  {
    word: "xoa",
    part_of_speech: "động từ",
    meaning:
      "bôi đều một lớp mỏng lên bề mặt: xoa dầu vào chỗ đau * xoa phấn lên mặt",
    example: "xoa dầu vào chỗ đau * xoa phấn lên mặt",
  },
  {
    word: "xoà",
    part_of_speech: "động từ",
    meaning:
      "buông xuống và toả ra trên một diện rộng: cành cây xoà xuống mặt nước",
    example: "cành cây xoà xuống mặt nước",
  },
  {
    word: "xoá đói giảm nghèo",
    part_of_speech: "",
    meaning:
      "xoá bỏ tình trạng đói kém và giảm dần sự nghèo nàn, lạc hậu: chương trình xoá đói giảm nghèo",
    example: "chương trình xoá đói giảm nghèo",
  },
  {
    word: "xoá bỏ",
    part_of_speech: "động từ",
    meaning:
      "làm mất hẳn đi, khiến cho không còn tồn tại hoặc không còn tác dụng nữa: xoá bỏ tên trong danh sách * xoá bỏ chế độ người bóc lột người",
    example: "xoá bỏ tên trong danh sách * xoá bỏ chế độ người bóc lột người",
  },
  {
    word: "xoa dịu",
    part_of_speech: "động từ",
    meaning:
      "tác động hoặc có khả năng tác động đến tâm lí, tinh thần của người nào đó nhằm làm cho giảm nhẹ sự căng thẳng: xoa dịu nỗi đau * nói xoa dịu",
    example: "xoa dịu nỗi đau * nói xoa dịu",
  },
  {
    word: "xoạc",
    part_of_speech: "động từ",
    meaning: "dang chân rộng ra hết cỡ: đứng xoạc chân",
    example: "đứng xoạc chân",
  },
  {
    word: "xoạc",
    part_of_speech: "động từ",
    meaning: "rách toạc ra: quần bị xoạc * bị chém xoạc bả vai",
    example: "quần bị xoạc * bị chém xoạc bả vai",
  },
  {
    word: "xoá mù",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) xoá nạn mù chữ: phong trào xoá mù ở các huyện miền núi",
    example: "phong trào xoá mù ở các huyện miền núi",
  },
  {
    word: "xoác",
    part_of_speech: "",
    meaning: "(phương ngữ) ôm: gốc cây to hai người xoác * một xoác lúa",
    example: "gốc cây to hai người xoác * một xoác lúa",
  },
  {
    word: "xoá sổ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) làm cho mất hẳn đi, không còn tồn tại nữa, bằng những biện pháp hoặc động tác mạnh mẽ: băng cướp đã bị xoá sổ",
    example: "băng cướp đã bị xoá sổ",
  },
  {
    word: "xoá nhoà",
    part_of_speech: "động từ",
    meaning:
      "làm cho mờ đi, cho không còn nhận rõ, phân biệt rõ được: cảnh vật bị xoá nhoà trong sương * xoá nhoà ranh giới",
    example: "cảnh vật bị xoá nhoà trong sương * xoá nhoà ranh giới",
  },
  {
    word: "xoài",
    part_of_speech: "động từ",
    meaning:
      "ở tư thế duỗi thẳng chân tay ra: nằm xoài trên cỏ * ngã xoài xuống nền đất",
    example: "nằm xoài trên cỏ * ngã xoài xuống nền đất",
  },
  {
    word: "xoải",
    part_of_speech: "động từ",
    meaning:
      "vươn rộng ra hết sức về cả hai phía (thường là chân, cánh): xoải chân bước tới * chim xoải cánh bay",
    example: "xoải chân bước tới * chim xoải cánh bay",
  },
  {
    word: "xoải",
    part_of_speech: "tính từ",
    meaning: "hơi dốc, thoai thoải: bờ dốc xoải * sườn đồi xoải",
    example: "bờ dốc xoải * sườn đồi xoải",
  },
  {
    word: "xoang",
    part_of_speech: "danh từ",
    meaning:
      "khoảng rỗng thành hốc thuộc vùng xương ở đầu, mặt: xoang mũi * xoang trán * bị viêm xoang",
    example: "xoang mũi * xoang trán * bị viêm xoang",
  },
  {
    word: "xoang",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) điệu đàn, điệu hát: "Tiêu đâu rủ phượng véo von, Một xoang như gọi nước non mấy niềm." (HT)',
    example:
      'Tiêu đâu rủ phượng véo von, Một xoang như gọi nước non mấy niềm." (HT)',
  },
  {
    word: "xoan",
    part_of_speech: "danh từ",
    meaning:
      "cây to, lá kép, hoa tím, quả hình trứng to bằng ngón tay, gỗ có chất đắng, không mọt, thường dùng để làm nhà: gỗ xoan * mặt trái xoan",
    example: "gỗ xoan * mặt trái xoan",
  },
  {
    word: "xoan",
    part_of_speech: "tính từ",
    meaning:
      '(Từ cũ) xuân: "Trai ba mươi tuổi đang xoan, Gái ba mươi tuổi đã toan về già." (Cdao)',
    example:
      'Trai ba mươi tuổi đang xoan, Gái ba mươi tuổi đã toan về già." (Cdao)',
  },
  {
    word: "xoạng",
    part_of_speech: "động từ",
    meaning: "(hiếm) như xoạc: xoạng chân ra hai bên",
    example: "xoạng chân ra hai bên",
  },
  {
    word: "xoàn",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ, cũ) kim cương: nhẫn hột xoàn",
    example: "nhẫn hột xoàn",
  },
  {
    word: "xoành xoạch",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) liên tục, hết lần này đến lần khác trong một thời gian ngắn (hàm ý chê): máy hỏng xoành xoạch * kế hoạch thay đổi xoành xoạch",
    example: "máy hỏng xoành xoạch * kế hoạch thay đổi xoành xoạch",
  },
  {
    word: "xoàng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) thường, tầm thường, không có gì đáng nói:  bị cảm xoàng * tay ấy chẳng phải hạng xoàng đâu!",
    example: "bị cảm xoàng * tay ấy chẳng phải hạng xoàng đâu!",
  },
  {
    word: "xoàng xĩnh",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) xoàng (nói khái quát): ăn mặc xoàng xĩnh * bữa cơm xoàng xĩnh",
    example: "ăn mặc xoàng xĩnh * bữa cơm xoàng xĩnh",
  },
  {
    word: "xoay",
    part_of_speech: "động từ",
    meaning: "(Ít dùng) quay tròn: chong chóng xoay tít mù",
    example: "chong chóng xoay tít mù",
  },
  {
    word: "xoay",
    part_of_speech: "động từ",
    meaning:
      "làm cho chuyển động chút ít theo chiều của vòng quay: xoay nắm đấm cửa * xoay cái ốc cho chặt * xoay mâm cơm",
    example: "xoay nắm đấm cửa * xoay cái ốc cho chặt * xoay mâm cơm",
  },
  {
    word: "xoay",
    part_of_speech: "động từ",
    meaning:
      "đổi hướng hoặc làm cho đổi hướng: xoay người lại * gió xoay chiều * xoay ngược tình thế (b)",
    example: "xoay người lại * gió xoay chiều * xoay ngược tình thế (b)",
  },
  {
    word: "xoay",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) tìm hết mọi cách để mong đạt được kết quả: xoay đủ mọi nghề * dụ dỗ không được xoay ra doạ dẫm",
    example: "xoay đủ mọi nghề * dụ dỗ không được xoay ra doạ dẫm",
  },
  {
    word: "xoay",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) tìm cách này cách khác để cho có được: xoay tiền * xoay vé đi xem phim",
    example: "xoay tiền * xoay vé đi xem phim",
  },
  {
    word: "xoay trở",
    part_of_speech: "động từ",
    meaning:
      "xoay qua xoay lại (nói khái quát): xoay trở người * chặt quá, không có chỗ để xoay trở tay chân",
    example: "xoay trở người * chặt quá, không có chỗ để xoay trở tay chân",
  },
  {
    word: "xoay trở",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) làm cách này cách khác, sao cho giải quyết có lợi: xoay trở cách làm ăn * xoay trở đủ đường",
    example: "xoay trở cách làm ăn * xoay trở đủ đường",
  },
  {
    word: "xoáy",
    part_of_speech: "động từ",
    meaning:
      "làm cho ăn sâu vào theo đường vòng tròn: mũi khoan xoáy vào tường * nhìn như xoáy vào người khác",
    example: "mũi khoan xoáy vào tường * nhìn như xoáy vào người khác",
  },
  {
    word: "xoáy",
    part_of_speech: "động từ",
    meaning:
      "làm cho nắp đậy xoay theo đường tròn để đóng hay mở: xoáy mở nắp bút * xoáy nút chai cho chặt",
    example: "xoáy mở nắp bút * xoáy nút chai cho chặt",
  },
  {
    word: "xoáy",
    part_of_speech: "động từ",
    meaning:
      "(vật thể) vừa xoay tròn quanh mình, vừa di chuyển mạnh: cơn lốc xoáy * dòng nước xoáy mạnh * quả bóng đi xoáy",
    example: "cơn lốc xoáy * dòng nước xoáy mạnh * quả bóng đi xoáy",
  },
  {
    word: "xoáy",
    part_of_speech: "động từ",
    meaning:
      "làm thành đường cuộn vòng và hẹp dần quanh một vị trí: tóc xoáy từng đám * lúm đồng tiền xoáy tròn trên má",
    example: "tóc xoáy từng đám * lúm đồng tiền xoáy tròn trên má",
  },
  {
    word: "xoáy",
    part_of_speech: "động từ",
    meaning:
      "tập trung đi sâu vào: cuộc họp xoáy vào vấn đề phòng chống lũ lụt",
    example: "cuộc họp xoáy vào vấn đề phòng chống lũ lụt",
  },
  {
    word: "xoáy",
    part_of_speech: "danh từ",
    meaning: "chỗ nước chảy cuộn tròn, trũng sâu ở giữa: xoáy nước",
    example: "xoáy nước",
  },
  {
    word: "xoáy",
    part_of_speech: "danh từ",
    meaning: "(Ít dùng) khoáy: đầu có hai xoáy * xoáy trâu",
    example: "đầu có hai xoáy * xoáy trâu",
  },
  {
    word: "xoáy",
    part_of_speech: "động từ",
    meaning: "(Thông tục) ăn cắp: bị xoáy mất cái ví",
    example: "bị xoáy mất cái ví",
  },
  {
    word: "xoay chuyển",
    part_of_speech: "động từ",
    meaning:
      "làm cho thay đổi, biến chuyển (nói khái quát): xoay chuyển tình thế",
    example: "xoay chuyển tình thế",
  },
  {
    word: "xoay trần",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) cởi trần ra để làm việc gì vất vả: xoay trần ra cuốc đất",
    example: "xoay trần ra cuốc đất",
  },
  {
    word: "xoay vần",
    part_of_speech: "động từ",
    meaning:
      '(văn chương) thay đổi lần lượt theo lẽ tự nhiên: "Xưa nay tạo hoá xoay vần, Hết bần lại phú, chẳng cần gì đâu." (ca dao)',
    example:
      'Xưa nay tạo hoá xoay vần, Hết bần lại phú, chẳng cần gì đâu." (ca dao)',
  },
  {
    word: "xoắn",
    part_of_speech: "động từ",
    meaning:
      "vặn chéo vào nhau cho quấn chặt lấy nhau: xoắn sợi thừng * sợi chỉ xoắn * hai bàn tay đan xoắn vào nhau",
    example: "xoắn sợi thừng * sợi chỉ xoắn * hai bàn tay đan xoắn vào nhau",
  },
  {
    word: "xoắn",
    part_of_speech: "động từ",
    meaning:
      "quấn, bám chặt lấy, không rời ra: đứa bé xoắn lấy mẹ * xoắn vào hỏi chuyện",
    example: "đứa bé xoắn lấy mẹ * xoắn vào hỏi chuyện",
  },
  {
    word: "xoay xở",
    part_of_speech: "động từ",
    meaning:
      "làm hết cách này đến cách khác để giải quyết cho được khó khăn, hoặc để có cho được cái cần có: xoay xở tiền nong * không có anh, thì tôi không biết xoay xở ra làm sao",
    example:
      "xoay xở tiền nong * không có anh, thì tôi không biết xoay xở ra làm sao",
  },
  {
    word: "xoẳn",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) ở mức không còn tí gì, hết sạch: hết xoẳn * có đồng nào tiêu xoẳn đồng ấy",
    example: "hết xoẳn * có đồng nào tiêu xoẳn đồng ấy",
  },
  {
    word: "xoẳn",
    part_of_speech: "phụ từ",
    meaning: "ở mức vừa vặn, không thừa không thiếu chút nào: áo mặc vừa xoẳn",
    example: "áo mặc vừa xoẳn",
  },
  {
    word: "xoăn",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái bị cuộn lại thành từng vòng tròn nhỏ: tóc xoăn * vỏ bào xoăn tít",
    example: "tóc xoăn * vỏ bào xoăn tít",
  },
  {
    word: "xóc",
    part_of_speech: "động từ",
    meaning:
      "lắc, hất cho vật đựng bên trong bị xáo trộn lên: xóc mạnh chai nước * xóc thẻ * cá xóc muối",
    example: "xóc mạnh chai nước * xóc thẻ * cá xóc muối",
  },
  {
    word: "xóc",
    part_of_speech: "động từ",
    meaning:
      "(xe cộ) bị nẩy lên do đi trên đường gồ ghề: chiếc xe bị xóc, nẩy lên bần bật",
    example: "chiếc xe bị xóc, nẩy lên bần bật",
  },
  {
    word: "xóc",
    part_of_speech: "tính từ",
    meaning:
      "(đường đi) gồ ghề, làm cho xe cộ bị nẩy lên: đường xóc nên phải đi chậm",
    example: "đường xóc nên phải đi chậm",
  },
  {
    word: "xóc",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có tác dụng gây kích thích khó chịu ở cổ (thường nói về thuốc hút): thuốc lào hút hơi xóc",
    example: "thuốc lào hút hơi xóc",
  },
  {
    word: "xóc",
    part_of_speech: "động từ",
    meaning:
      "đâm mạnh vào bằng vật cứng và nhọn để lấy lên: dùng nĩa xóc miếng bánh * xóc bó lúa để gánh",
    example: "dùng nĩa xóc miếng bánh * xóc bó lúa để gánh",
  },
  {
    word: "xóc",
    part_of_speech: "động từ",
    meaning:
      "đâm thủng hoặc bị đâm thủng bằng vật nhọn: bị nứa xóc vào chân * xóc phải chông",
    example: "bị nứa xóc vào chân * xóc phải chông",
  },
  {
    word: "xóc",
    part_of_speech: "danh từ",
    meaning:
      "lượng gồm một số con vật cùng loại (thường là cua, tôm, cá) được xâu lại hoặc được cặp lại bằng thanh tre: mua hai xóc cua",
    example: "mua hai xóc cua",
  },
  {
    word: "xoắn xuýt",
    part_of_speech: "động từ",
    meaning:
      "xoắn lấy, bám chặt lấy không chịu rời ra: đứa bé xoắn xuýt bên mẹ * xoắn xuýt lại hỏi han",
    example: "đứa bé xoắn xuýt bên mẹ * xoắn xuýt lại hỏi han",
  },
  {
    word: "xọc",
    part_of_speech: "động từ",
    meaning: "đâm mạnh và sâu vào: xọc lò * xọc vào chuyện của người khác (b)",
    example: "xọc lò * xọc vào chuyện của người khác (b)",
  },
  {
    word: "xọc",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) xộc: chạy xọc vào nhà * mùi hăng nồng xọc lên mũi",
    example: "chạy xọc vào nhà * mùi hăng nồng xọc lên mũi",
  },
  {
    word: "xóc đĩa",
    part_of_speech: "danh từ",
    meaning:
      "lối chơi cờ bạc dùng bốn đồng tiền xóc mạnh trong một cái đĩa úp kín, ai đoán trúng có mấy đồng sấp mấy đồng ngửa thì được: chơi xóc đĩa",
    example: "chơi xóc đĩa",
  },
  {
    word: "xoen xoét",
    part_of_speech: "động từ",
    meaning:
      "từ gợi tả lối nói luôn mồm (thường là những điều không thành thực) một cách dễ dàng, trơn tru như không biết ngượng: xoen xoét thề bồi * chỉ xoen xoét cái mồm!",
    example: "xoen xoét thề bồi * chỉ xoen xoét cái mồm!",
  },
  {
    word: "xoè",
    part_of_speech: "danh từ",
    meaning: "tên một điệu múa của dân tộc Thái: múa xoè * điệu xoè",
    example: "múa xoè * điệu xoè",
  },
  {
    word: "xoè",
    part_of_speech: "động từ",
    meaning:
      "mở rộng ra quanh một điểm: xoè bàn tay ra * con công xoè đuôi múa * váy xoè",
    example: "xoè bàn tay ra * con công xoè đuôi múa * váy xoè",
  },
  {
    word: "xoè",
    part_of_speech: "động từ",
    meaning: "làm cho diêm, lửa bùng cháy: xoè lửa * xoè diêm châm thuốc",
    example: "xoè lửa * xoè diêm châm thuốc",
  },
  {
    word: "xoèn xoẹt",
    part_of_speech: "tính từ",
    meaning: "như xoẹt (nhưng với ý liên tiếp): tiếng cắt lúa xoèn xoẹt",
    example: "tiếng cắt lúa xoèn xoẹt",
  },
  {
    word: "xóc xách",
    part_of_speech: "tính từ",
    meaning:
      "từ mô tả tiếng phát ra như tiếng vật cứng nhỏ va chạm vào nhau khi bị lắc, bị xáo trộn: trong túi xóc xách mấy đồng xu",
    example: "trong túi xóc xách mấy đồng xu",
  },
  {
    word: "xoẹt",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng như tiếng cắt nhanh, gọn bằng vật sắc: cắt đánh xoẹt một cái * luồng đạn xoẹt qua tai",
    example: "cắt đánh xoẹt một cái * luồng đạn xoẹt qua tai",
  },
  {
    word: "xoẹt",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) (làm việc gì) một cách rất nhanh, như chỉ trong khoảnh khắc: làm xoẹt một cái là xong * cắt xoẹt mớ tóc",
    example: "làm xoẹt một cái là xong * cắt xoẹt mớ tóc",
  },
  {
    word: "xoi",
    part_of_speech: "động từ",
    meaning:
      "dùng vật hình que nhỏ chọc vào cho thông, cho hết tắc: xoi cống * xoi vòi ấm * xoi thông ống điếu",
    example: "xoi cống * xoi vòi ấm * xoi thông ống điếu",
  },
  {
    word: "xoi",
    part_of_speech: "động từ",
    meaning:
      "làm cho thủng, cho có lỗ bằng cách dùng vật nhọn chọc vào: xoi lỗ * xoi thủng vỏ sò",
    example: "xoi lỗ * xoi thủng vỏ sò",
  },
  {
    word: "xoi",
    part_of_speech: "động từ",
    meaning: "mở thông đường xuyên qua những trở ngại: xoi đường đi trong rừng",
    example: "xoi đường đi trong rừng",
  },
  {
    word: "xoi",
    part_of_speech: "động từ",
    meaning: "tạo thành đường rãnh trên mặt gỗ bằng lưỡi bào nhỏ: xoi cạnh bàn",
    example: "xoi cạnh bàn",
  },
  {
    word: "xói lở",
    part_of_speech: "động từ",
    meaning:
      "(hiện tượng nước) xói vào làm sụt lở đất đá: trận mưa lớn gây xói lở đất đá",
    example: "trận mưa lớn gây xói lở đất đá",
  },
  {
    word: "xói",
    part_of_speech: "động từ",
    meaning:
      "(dòng nước) chảy mạnh và thẳng vào một chỗ, làm đất đá mòn lở dần đi: mưa làm xói đất * nước xói vào chân đê",
    example: "mưa làm xói đất * nước xói vào chân đê",
  },
  {
    word: "xói",
    part_of_speech: "động từ",
    meaning:
      "hướng thẳng vào với một cường độ mạnh: nắng xói vào mặt * những lời chì chiết xói vào tận óc",
    example: "nắng xói vào mặt * những lời chì chiết xói vào tận óc",
  },
  {
    word: "xói mòn",
    part_of_speech: "động từ",
    meaning:
      "(hiện tượng) làm huỷ hoại dần dần lớp đất đá trên mặt đất do tác dụng của dòng nước chảy, của sức gió, v.v.: mưa lớn gây xói mòn đất * trồng cây để chống xói mòn",
    example: "mưa lớn gây xói mòn đất * trồng cây để chống xói mòn",
  },
  {
    word: "xoi móc",
    part_of_speech: "động từ",
    meaning: "(hiếm) như soi mói: cái nhìn xoi móc",
    example: "cái nhìn xoi móc",
  },
  {
    word: "xoi mói",
    part_of_speech: "động từ",
    meaning:
      "để ý, moi móc những sai sót, những chuyện riêng tư của người khác, với dụng ý xấu: cái nhìn soi mói * soi mói chuyện của người khác",
    example: "cái nhìn soi mói * soi mói chuyện của người khác",
  },
  {
    word: "xói móc",
    part_of_speech: "động từ",
    meaning: "như soi mói (nhưng nghĩa mạnh hơn): xói móc nhau",
    example: "xói móc nhau",
  },
  {
    word: "xom",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) chĩa: cầm cái xom",
    example: "cầm cái xom",
  },
  {
    word: "xom",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) đâm bằng xom: đi xom cá",
    example: "đi xom cá",
  },
  {
    word: "xoi xói",
    part_of_speech: "tính từ",
    meaning:
      "(hoạt động diễn ra) liên tiếp không ngừng, nhiều lần trong khoảng thời gian ngắn, gây cảm giác khó chịu: ăn xoi xói luôn miệng * nói xoi xói cả ngày",
    example: "ăn xoi xói luôn miệng * nói xoi xói cả ngày",
  },
  {
    word: "xon xón",
    part_of_speech: "phụ từ",
    meaning:
      "(nói, đi, chạy) luôn miệng, luôn chân và liên tiếp không ngừng (thường nói về trẻ nhỏ): nói xon xón cả ngày * em bé chạy xon xón theo mẹ",
    example: "nói xon xón cả ngày * em bé chạy xon xón theo mẹ",
  },
  {
    word: "xong",
    part_of_speech: "động từ",
    meaning:
      "(công việc, sự việc) đã xảy ra trọn vẹn, đã kết thúc: gặt hái vừa xong * ăn xong thì mới đi * trời vừa mới mưa xong",
    example: "gặt hái vừa xong * ăn xong thì mới đi * trời vừa mới mưa xong",
  },
  {
    word: "xong",
    part_of_speech: "động từ",
    meaning:
      "yên ổn, không có chuyện gì: tiến không được mà lùi cũng không xong",
    example: "tiến không được mà lùi cũng không xong",
  },
  {
    word: "xóm",
    part_of_speech: "danh từ",
    meaning:
      "khu dân cư ở nông thôn, nhỏ hơn làng, gồm nhiều nhà ở liền nhau: làng trên xóm dưới * nhà ở cuối xóm",
    example: "làng trên xóm dưới * nhà ở cuối xóm",
  },
  {
    word: "xóm",
    part_of_speech: "danh từ",
    meaning:
      "nơi ở tập trung của nhiều gia đình làm cùng nghề nghiệp: xóm chài * xóm ngụ cư * xóm liều",
    example: "xóm chài * xóm ngụ cư * xóm liều",
  },
  {
    word: "xóm liều",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) xóm tập trung nhiều đối tượng bất hảo và người ngụ cư trái phép, thường là nơi phát sinh nhiều tệ nạn xã hội phức tạp: dân xóm liều * giải toả các xóm liều",
    example: "dân xóm liều * giải toả các xóm liều",
  },
  {
    word: "xóm giềng",
    part_of_speech: "danh từ",
    meaning: "những người hàng xóm (nói khái quát): bà con xóm giềng",
    example: "bà con xóm giềng",
  },
  {
    word: "xóm làng",
    part_of_speech: "danh từ",
    meaning: "như làng xóm: xóm làng yên tĩnh",
    example: "xóm làng yên tĩnh",
  },
  {
    word: "xon xót",
    part_of_speech: "tính từ",
    meaning: "hơi xót: tay bị gai cào xon xót",
    example: "tay bị gai cào xon xót",
  },
  {
    word: "xõng",
    part_of_speech: "tính từ",
    meaning:
      "(lối nói) cụt ngủn, không có những tiếng xưng hô cần thiết, gây ấn tượng thiếu lịch sự: hỏi xõng * buông xõng một câu",
    example: "hỏi xõng * buông xõng một câu",
  },
  {
    word: "xọp",
    part_of_speech: "tính từ",
    meaning:
      "gầy đến mức như người teo nhỏ hẳn đi: gầy xọp * bị ốm, người xọp hẳn đi",
    example: "gầy xọp * bị ốm, người xọp hẳn đi",
  },
  {
    word: "xong xả",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) xong xuôi mọi thứ: công việc như thế là xong xả",
    example: "công việc như thế là xong xả",
  },
  {
    word: "xóp xọp",
    part_of_speech: "tính từ",
    meaning: "như xọp (nhưng nghĩa mạnh hơn): người xóp xọp",
    example: "người xóp xọp",
  },
  {
    word: "xong đời",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) hết đời, không còn sống nữa hoặc không còn hi vọng gì nữa: thế là xong đời!",
    example: "thế là xong đời!",
  },
  {
    word: "xong xuôi",
    part_of_speech: "tính từ",
    meaning:
      "xong hết cả, ổn thoả, trọn vẹn: chuẩn bị xong xuôi mọi thứ * cơm nước xong xuôi rồi mới đi",
    example: "chuẩn bị xong xuôi mọi thứ * cơm nước xong xuôi rồi mới đi",
  },
  {
    word: "xong chuyện",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) qua loa cốt cho xong để không còn phải để ý đến nữa, bất kể kết quả như thế nào: ăn đi cho xong chuyện * trả lời qua quýt cho xong chuyện",
    example: "ăn đi cho xong chuyện * trả lời qua quýt cho xong chuyện",
  },
  {
    word: "xót",
    part_of_speech: "",
    meaning:
      "có cảm giác đau rát như khi vết thương bị xát muối: mắt đau nên tra thuốc vào thấy xót",
    example: "mắt đau nên tra thuốc vào thấy xót",
  },
  {
    word: "xót",
    part_of_speech: "",
    meaning: "thương thấm thía: xót con * của đau con xót (tng)",
    example: "xót con * của đau con xót (tng)",
  },
  {
    word: "xót",
    part_of_speech: "",
    meaning: "(Khẩu ngữ) tiếc lắm: xót công xót của * mất tiền ai mà chả xót",
    example: "xót công xót của * mất tiền ai mà chả xót",
  },
  {
    word: "xót ruột",
    part_of_speech: "động từ",
    meaning:
      "cảm thấy nóng và khó chịu trong ruột vì thiếu chất nước, chất tươi mát: húp tạm bát cháo cho đỡ xót ruột",
    example: "húp tạm bát cháo cho đỡ xót ruột",
  },
  {
    word: "xót ruột",
    part_of_speech: "động từ",
    meaning: "đau đớn trong lòng: thấy con bị đau mà xót ruột",
    example: "thấy con bị đau mà xót ruột",
  },
  {
    word: "xót ruột",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tiếc lắm, đến mức như cào xé trong ruột: tiêu pha nhiều cũng xót ruột",
    example: "tiêu pha nhiều cũng xót ruột",
  },
  {
    word: "xót thương",
    part_of_speech: "động từ",
    meaning: "(văn chương) như thương xót: xót thương cho thân phận",
    example: "xót thương cho thân phận",
  },
  {
    word: "xồ",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) chạy xổ ra, nhảy xổ ra: con chó xồ ra cắn",
    example: "con chó xồ ra cắn",
  },
  {
    word: "xô",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng đựng nước, đáy nhỏ, miệng loe rộng có gắn quai xách, thường làm bằng kim loại hoặc bằng nhựa: xách mấy xô nước",
    example: "xách mấy xô nước",
  },
  {
    word: "xô",
    part_of_speech: "động từ",
    meaning:
      "đẩy mạnh cho ngã, cho đổ: xô đổ bức tường * xô cửa chạy ra * sóng xô bãi cát",
    example: "xô đổ bức tường * xô cửa chạy ra * sóng xô bãi cát",
  },
  {
    word: "xô",
    part_of_speech: "động từ",
    meaning: "làm cho bị dồn về một phía: mền bông bị xô * mái ngói xô nghiêng",
    example: "mền bông bị xô * mái ngói xô nghiêng",
  },
  {
    word: "xô",
    part_of_speech: "động từ",
    meaning:
      "kéo đến, chạy đến nhanh và bất ngờ, thường với số lượng nhiều: mọi người xô lại xem",
    example: "mọi người xô lại xem",
  },
  {
    word: "xô",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) ở tình trạng để lẫn lộn, không phân biệt tốt, xấu, tinh, thô: bán xô, không cho chọn * mua xô cả lố",
    example: "bán xô, không cho chọn * mua xô cả lố",
  },
  {
    word: "xót xa",
    part_of_speech: "tính từ",
    meaning:
      'thương tiếc rất sâu sắc, khó nguôi: xót xa trong lòng * "Khi tỉnh rượu, lúc tàn canh, Giật mình, mình lại thương mình xót xa." (TKiều)',
    example:
      'xót xa trong lòng * "Khi tỉnh rượu, lúc tàn canh, Giật mình, mình lại thương mình xót xa." (TKiều)',
  },
  {
    word: "xổ",
    part_of_speech: "động từ",
    meaning:
      "mở tung ra, tháo tung ra (cái đang được xếp lại, buộc lại): khăn khố bị xổ tung * xổ tóc ra chải",
    example: "khăn khố bị xổ tung * xổ tóc ra chải",
  },
  {
    word: "xổ",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) tẩy (giun): xổ giun * thuốc xổ",
    example: "xổ giun * thuốc xổ",
  },
  {
    word: "xổ",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) phát ra, phóng ra hàng loạt, bất kể như thế nào: xổ một tràng tiểu liên * xổ một tràng tiếng Tây",
    example: "xổ một tràng tiểu liên * xổ một tràng tiếng Tây",
  },
  {
    word: "xổ",
    part_of_speech: "động từ",
    meaning:
      "xông tới một cách mạnh mẽ và đột ngột: con chó xổ ra cắn * nhảy xổ vào đánh",
    example: "con chó xổ ra cắn * nhảy xổ vào đánh",
  },
  {
    word: "xô bồ",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) lẫn lộn các thứ khác nhau về chất lượng, không phân biệt tốt, xấu: bán xô bồ, không phân loại",
    example: "bán xô bồ, không phân loại",
  },
  {
    word: "xô bồ",
    part_of_speech: "tính từ",
    meaning:
      'không theo một trật tự, một quy tắc nào cả, hết sức lộn xộn, tuỳ tiện: ăn uống xô bồ * "Chim khôn tránh bẫy, tránh dò, Người khôn tránh chốn xô bồ mới khôn." (ca dao)',
    example:
      'ăn uống xô bồ * "Chim khôn tránh bẫy, tránh dò, Người khôn tránh chốn xô bồ mới khôn." (ca dao)',
  },
  {
    word: "xô xát",
    part_of_speech: "động từ",
    meaning: "cãi cọ và xung đột với nhau: xảy ra xô xát * hai bên xô xát nhau",
    example: "xảy ra xô xát * hai bên xô xát nhau",
  },
  {
    word: "xô đẩy",
    part_of_speech: "động từ",
    meaning:
      "xô nhau, đẩy nhau (nói khái quát): đi lần lượt, không chen lấn, xô đẩy",
    example: "đi lần lượt, không chen lấn, xô đẩy",
  },
  {
    word: "xô đẩy",
    part_of_speech: "động từ",
    meaning:
      "dồn vào, đẩy vào một cảnh ngộ thường là không hay: hoàn cảnh xô đẩy * bị xô đẩy đến bước đường cùng",
    example: "hoàn cảnh xô đẩy * bị xô đẩy đến bước đường cùng",
  },
  {
    word: "xổ số",
    part_of_speech: "danh từ",
    meaning:
      "trò chơi may rủi có giải cho những vé có số đúng với con số được quay ra: vé xổ số * trúng xổ số",
    example: "vé xổ số * trúng xổ số",
  },
  {
    word: "xô viết",
    part_of_speech: "danh từ",
    meaning:
      "hình thức tổ chức chính quyền chuyên chính vô sản, bắt nguồn trong phong trào cách mạng 1905-1907 ở Nga: xây dựng các làng xô viết ở nông thôn * phong trào Xô Viết Nghệ Tĩnh",
    example:
      "xây dựng các làng xô viết ở nông thôn * phong trào Xô Viết Nghệ Tĩnh",
  },
  {
    word: "xốc nổi",
    part_of_speech: "tính từ",
    meaning: "hăng hái nhưng thiếu chín chắn: tính tình xốc nổi",
    example: "tính tình xốc nổi",
  },
  {
    word: "xô-nát",
    part_of_speech: "danh từ",
    meaning:
      "bản nhạc gồm ba hoặc bốn chương khác nhau về nhịp điệu và tính chất, nối tiếp với nhau: bản sonata của Beethoven",
    example: "bản sonata của Beethoven",
  },
  {
    word: "xốc",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) số lượng nhiều, được coi như một tập hợp (thường hàm ý xem thường): kể một xốc chuyện * bắt hàng xốc trộm cướp",
    example: "kể một xốc chuyện * bắt hàng xốc trộm cướp",
  },
  {
    word: "xốc",
    part_of_speech: "động từ",
    meaning:
      "lật và giở tung, hất tung lên: xốc rơm cho nhanh khô * xốc quần áo trong va li",
    example: "xốc rơm cho nhanh khô * xốc quần áo trong va li",
  },
  {
    word: "xốc",
    part_of_speech: "động từ",
    meaning:
      "nhấc đưa lên bằng động tác nhanh, gọn, mạnh: xốc ba lô lên vai * xốc lại tay nải",
    example: "xốc ba lô lên vai * xốc lại tay nải",
  },
  {
    word: "xốc",
    part_of_speech: "động từ",
    meaning:
      "(Ít dùng) kéo quần áo lên để sửa sang cho ngay ngắn, gọn gàng: xốc lại quần áo cho chỉnh tề",
    example: "xốc lại quần áo cho chỉnh tề",
  },
  {
    word: "xốc",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) tiến thẳng tới phía trước không một chút do dự: xốc thẳng vào nhà * xốc vào đồn địch * chạy xốc tới",
    example: "xốc thẳng vào nhà * xốc vào đồn địch * chạy xốc tới",
  },
  {
    word: "xốc",
    part_of_speech: "động từ",
    meaning: "(lợn) dũi mạnh mõm vào để ăn: con lợn xốc mõm vào chậu cám",
    example: "con lợn xốc mõm vào chậu cám",
  },
  {
    word: "xộc",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) xông vào, xông tới một cách đột ngột, sỗ sàng: con chó xộc ra cắn * chạy xộc vào buồng",
    example: "con chó xộc ra cắn * chạy xộc vào buồng",
  },
  {
    word: "xộc",
    part_of_speech: "động từ",
    meaning:
      "bốc lên hết sức mạnh mẽ và gây tác động đáng kể: khói xộc vào mũi",
    example: "khói xộc vào mũi",
  },
  {
    word: "xốc xáo",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như xông xáo: xốc xáo trong công tác",
    example: "xốc xáo trong công tác",
  },
  {
    word: "xổi",
    part_of_speech: "tính từ",
    meaning:
      "chỉ tạm trong thời gian ngắn: vay xổi ít tiền * cà muối xổi * ăn xổi ở thì (tng)",
    example: "vay xổi ít tiền * cà muối xổi * ăn xổi ở thì (tng)",
  },
  {
    word: "xốc vác",
    part_of_speech: "",
    meaning:
      "làm được đủ mọi việc, đặc biệt là những việc nặng nhọc, vất vả: xốc vác việc gia đình * người yếu nên không thể xốc vác được",
    example: "xốc vác việc gia đình * người yếu nên không thể xốc vác được",
  },
  {
    word: "xộc xệch",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả vẻ lỏng lẻo và không gọn gàng, ngay ngắn: cà vạt xộc xệch * gói hàng buộc xộc xệch, dễ tung",
    example: "cà vạt xộc xệch * gói hàng buộc xộc xệch, dễ tung",
  },
  {
    word: "xộc xệch",
    part_of_speech: "tính từ",
    meaning:
      "có các bộ phận bị lỏng ra, không còn khớp chặt với nhau, khiến sử dụng không tốt: bàn ghế xộc xệch * chiếc xe đạp đã xộc xệch",
    example: "bàn ghế xộc xệch * chiếc xe đạp đã xộc xệch",
  },
  {
    word: "xộc xệch",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ở tình trạng thiếu sự hoạt động ăn khớp, đồng bộ giữa các bộ phận: tổ chức xộc xệch",
    example: "tổ chức xộc xệch",
  },
  {
    word: "xốc xếch",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả cách ăn mặc lôi thôi, không ngay ngắn, gọn gàng: quần áo xốc xếch",
    example: "quần áo xốc xếch",
  },
  {
    word: "xối",
    part_of_speech: "động từ",
    meaning: "giội mạnh nước từ trên xuống: xối nước gội đầu * mưa như xối",
    example: "xối nước gội đầu * mưa như xối",
  },
  {
    word: "xối",
    part_of_speech: "động từ",
    meaning:
      "diễn ra với cường độ mạnh, số lượng nhiều (tựa như xối nước): nắng xối * bắn xối vào lô cốt",
    example: "nắng xối * bắn xối vào lô cốt",
  },
  {
    word: "xôi",
    part_of_speech: "danh từ",
    meaning: "món ăn bằng gạo nếp đồ chín: đồ xôi * một nắm xôi",
    example: "đồ xôi * một nắm xôi",
  },
  {
    word: "xôi gấc",
    part_of_speech: "danh từ",
    meaning:
      "xôi nấu trộn với ruột gấc, màu đỏ, vị hơi ngọt: ăn mày đòi xôi gấc (tng)",
    example: "ăn mày đòi xôi gấc (tng)",
  },
  {
    word: "xối xả",
    part_of_speech: "tính từ",
    meaning:
      "rất nhiều và với cường độ mạnh: mưa tuôn xối xả * mắng xối xả vào mặt",
    example: "mưa tuôn xối xả * mắng xối xả vào mặt",
  },
  {
    word: "xôi thịt",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, khẩu ngữ) xôi và thịt (nói khái quát); dùng để chỉ tệ ăn uống, chè chén trong các dịp đình đám hoặc để tranh giành ngôi thứ của cường hào ở nông thôn thời trước: nạn xôi thịt",
    example: "nạn xôi thịt",
  },
  {
    word: "xôi thịt",
    part_of_speech: "tính từ",
    meaning:
      "(thông tục) tham lam, chỉ thích chè chén, hưởng thụ: đầu óc xôi thịt",
    example: "đầu óc xôi thịt",
  },
  {
    word: "xôm trò",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ, khẩu ngữ) rôm rả, có nhiều trò vui: ngày hội rất xôm trò * chỗ nào có ổng cũng xôm trò",
    example: "ngày hội rất xôm trò * chỗ nào có ổng cũng xôm trò",
  },
  {
    word: "xôm",
    part_of_speech: "tính từ",
    meaning: "(Phương ngữ) đỏm dáng, bảnh choẹ: ăn bận xôm quá ta!",
    example: "ăn bận xôm quá ta!",
  },
  {
    word: "xôm",
    part_of_speech: "tính từ",
    meaning: "rôm, rôm rả: chuyện kể rất xôm",
    example: "chuyện kể rất xôm",
  },
  {
    word: "xồm xoàm",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) xồm lên rất nhiều (nói khái quát): râu ria xồm xoàm * lông lá xồm xoàm",
    example: "râu ria xồm xoàm * lông lá xồm xoàm",
  },
  {
    word: "xốn",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) đau nhức, tựa như có gì đâm ở bên trong (thường nói về mắt): mắt xốn * vết thương lại xốn lên",
    example: "mắt xốn * vết thương lại xốn lên",
  },
  {
    word: "xôm tụ",
    part_of_speech: "tính từ",
    meaning: "(Phương ngữ, Khẩu ngữ) đông vui, rôm rả: ngồi vô cho xôm tụ",
    example: "ngồi vô cho xôm tụ",
  },
  {
    word: "xốn xang",
    part_of_speech: "tính từ",
    meaning:
      "ở tâm trạng có những xúc động tình cảm khiến trong lòng rạo rực, bứt rứt không yên: lòng dạ xốn xang * xốn xang mong ngóng",
    example: "lòng dạ xốn xang * xốn xang mong ngóng",
  },
  {
    word: "xốn xang",
    part_of_speech: "tính từ",
    meaning:
      '(Phương ngữ) đau nhức nhối, xót xa: "Xốn xang như muối xát gừng, Phải chi hồi trước ai đừng biết ai!" (Cdao)',
    example:
      'Xốn xang như muối xát gừng, Phải chi hồi trước ai đừng biết ai!" (Cdao)',
  },
  {
    word: "xôn xang",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như xốn xang (ng1): lòng dạ xôn xang",
    example: "lòng dạ xôn xang",
  },
  {
    word: "xôm xốp",
    part_of_speech: "tính từ",
    meaning: "hơi xốp: đám bông xôm xốp",
    example: "đám bông xôm xốp",
  },
  {
    word: "xồm",
    part_of_speech: "tính từ",
    meaning: "(râu, lông) rậm, dài và xù lên: râu xồm * chó lông xồm",
    example: "râu xồm * chó lông xồm",
  },
  {
    word: "xôn xao",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả những âm thanh, tiếng động rộn lên từ nhiều phía xen lẫn nhau: cười nói xôn xao",
    example: "cười nói xôn xao",
  },
  {
    word: "xôn xao",
    part_of_speech: "động từ",
    meaning:
      "rộn lên đây đó những lời bàn tán: xôn xao bàn tán * vụ việc làm xôn xao dư luận",
    example: "xôn xao bàn tán * vụ việc làm xôn xao dư luận",
  },
  {
    word: "xôn xao",
    part_of_speech: "động từ",
    meaning:
      'rung động, xao xuyến trong lòng: "Một ngày không kháp mặt chàng, Ra vào ngơ ngẩn dạ vàng xôn xao." (Cdao)',
    example:
      'Một ngày không kháp mặt chàng, Ra vào ngơ ngẩn dạ vàng xôn xao." (Cdao)',
  },
  {
    word: "xông",
    part_of_speech: "động từ",
    meaning:
      "tiến mạnh và thẳng tới phía trước, bất chấp trở ngại: xông vào đánh * đạp cửa xông vào * thừa thắng xông lên",
    example: "xông vào đánh * đạp cửa xông vào * thừa thắng xông lên",
  },
  {
    word: "xông",
    part_of_speech: "động từ",
    meaning:
      "(mối) đùn lên, bắt vào đồ đạc, đục khoét làm hư hỏng: nhà bị mối xông",
    example: "nhà bị mối xông",
  },
  {
    word: "xông",
    part_of_speech: "động từ",
    meaning:
      "(hơi, mùi) bốc lên mạnh, thường gây khó chịu: mùi khai xông lên nồng nặc",
    example: "mùi khai xông lên nồng nặc",
  },
  {
    word: "xông",
    part_of_speech: "động từ",
    meaning: "diệt trừ bằng khói, khí độc: xông muỗi * xông khói",
    example: "xông muỗi * xông khói",
  },
  {
    word: "xông",
    part_of_speech: "động từ",
    meaning:
      "cho hơi nóng bốc vào người hoặc bộ phận cơ thể để chữa bệnh: hái nắm lá về nấu nước xông",
    example: "hái nắm lá về nấu nước xông",
  },
  {
    word: "xổng",
    part_of_speech: "động từ",
    meaning:
      "thoát ra khỏi nơi bị nhốt, bị giam cầm, bị giữ lại: lợn sổng ra khỏi chuồng * để sổng mất con mồi",
    example: "lợn sổng ra khỏi chuồng * để sổng mất con mồi",
  },
  {
    word: "xông xênh",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có nhiều tiền và có thể chi tiêu thoải mái, không bị gò bó, hạn chế: tiền bạc xông xênh * tiêu xông xênh",
    example: "tiền bạc xông xênh * tiêu xông xênh",
  },
  {
    word: "xốp",
    part_of_speech: "tính từ",
    meaning:
      "không chắc và nhẹ, có nhiều lỗ hổng bên trong: đất xốp * bông xốp",
    example: "đất xốp * bông xốp",
  },
  {
    word: "xốp",
    part_of_speech: "tính từ",
    meaning: "(quả) xơ và ít nước: quả chanh xốp",
    example: "quả chanh xốp",
  },
  {
    word: "xông đất",
    part_of_speech: "động từ",
    meaning:
      "đến nhà người khác đầu tiên trong ngày mồng một tết Nguyên Đán, có tác dụng sẽ mang lại điều tốt lành hoặc điều không may suốt cả năm cho gia đình ấy, theo tín ngưỡng dân gian: tục xông đất * chọn người xông đất",
    example: "tục xông đất * chọn người xông đất",
  },
  {
    word: "xông pha",
    part_of_speech: "động từ",
    meaning:
      'dấn thân vào nơi gian nguy, khó khăn, khồng hề quản ngại: xông pha trận mạc * "Xông pha gió bãi trăng ngàn, Tên reo đầu ngựa giáo dan mặt thành." (CPN)',
    example:
      'xông pha trận mạc * "Xông pha gió bãi trăng ngàn, Tên reo đầu ngựa giáo dan mặt thành." (CPN)',
  },
  {
    word: "xồng xộc",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) từ gợi tả dáng điệu xông thẳng vào, thẳng đến một cách nhanh và đột ngột: xồng xộc vào nhà * chạy xồng xộc đến",
    example: "xồng xộc vào nhà * chạy xồng xộc đến",
  },
  {
    word: "xốp xộp",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) rất xốp: gỗ bấc xốp xộp",
    example: "gỗ bấc xốp xộp",
  },
  {
    word: "xông xáo",
    part_of_speech: "động từ",
    meaning:
      "xông vào bất cứ đâu, bất chấp khó khăn nguy hiểm: xông xáo nơi chiến trường * cầu thủ xông xáo khắp sân cỏ",
    example: "xông xáo nơi chiến trường * cầu thủ xông xáo khắp sân cỏ",
  },
  {
    word: "xông xáo",
    part_of_speech: "tính từ",
    meaning:
      "hăng hái trong mọi hoạt động, bất chấp trở ngại, khó khăn: một phóng viên xông xáo",
    example: "một phóng viên xông xáo",
  },
  {
    word: "xốp xồm xộp",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) như xốp xộp (nhưng ý nhấn mạnh hơn; thường hàm ý chê): khúc gỗ xốp xồm xộp",
    example: "khúc gỗ xốp xồm xộp",
  },
  {
    word: "xơ",
    part_of_speech: "danh từ",
    meaning:
      "sợi dai lẫn trong phần nạc của một số rau, củ, quả hoặc trong phần vỏ một số quả: xơ mướp * xơ mít * sắn nhiều xơ * tước xơ rau bí",
    example: "xơ mướp * xơ mít * sắn nhiều xơ * tước xơ rau bí",
  },
  {
    word: "xơ",
    part_of_speech: "tính từ",
    meaning:
      "ở tình trạng như chỉ còn trơ ra những tua, sợi do bị mòn rách, huỷ hoại: quần xơ gấu * mũ xơ vành * tóc bị xơ",
    example: "quần xơ gấu * mũ xơ vành * tóc bị xơ",
  },
  {
    word: "xốt vang",
    part_of_speech: "danh từ",
    meaning: "món ăn nấu bằng thịt bò có gia ít rượu: bánh mì xốt vang",
    example: "bánh mì xốt vang",
  },
  {
    word: "xốt",
    part_of_speech: "danh từ",
    meaning: "nước xốt (nói tắt): bánh mì ăn với xốt cà chua",
    example: "bánh mì ăn với xốt cà chua",
  },
  {
    word: "xốt",
    part_of_speech: "động từ",
    meaning: "nấu thức ăn mặn với nước xốt: đậu phụ xốt * cá xốt cà chua",
    example: "đậu phụ xốt * cá xốt cà chua",
  },
  {
    word: "xơ cua",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) có sẵn để thay thế khi cần thiết: xe có lốp xơ cua",
    example: "xe có lốp xơ cua",
  },
  {
    word: "xở",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) gỡ ra, làm bung ra: xở món tơ rối * xở buồm ra",
    example: "xở món tơ rối * xở buồm ra",
  },
  {
    word: "xơ hoá",
    part_of_speech: "động từ",
    meaning:
      "(hiện tượng) có các mô trở nên cứng và mất chức năng: xơ hoá phổi * buồng trứng bị xơ hoá",
    example: "xơ hoá phổi * buồng trứng bị xơ hoá",
  },
  {
    word: "xơ rơ",
    part_of_speech: "tính từ",
    meaning:
      '(phương ngữ) xơ xác, trơ trụi: ruộng vườn xơ rơ * "Bão bùng cành ngọn xơ rơ, Chim không nơi đỗ dật dờ phương nao?" (ca dao)',
    example:
      'ruộng vườn xơ rơ * "Bão bùng cành ngọn xơ rơ, Chim không nơi đỗ dật dờ phương nao?" (ca dao)',
  },
  {
    word: "xơ xác",
    part_of_speech: "tính từ",
    meaning:
      'ở tình trạng không có gì còn nguyên vẹn, lành lặn, trông thảm hại: mái lều tranh xơ xác * "Trông chừng khói ngất song thưa, Hoa trôi giạt thắm, liễu xơ xác vàng." (TKiều)',
    example:
      'mái lều tranh xơ xác * "Trông chừng khói ngất song thưa, Hoa trôi giạt thắm, liễu xơ xác vàng." (TKiều)',
  },
  {
    word: "xớ rớ",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) như lớ xớ: thấy lạ, xớ rớ đứng lại xem",
    example: "thấy lạ, xớ rớ đứng lại xem",
  },
  {
    word: "xơ múi",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) lợi lộc kiếm chác được: hết sạch, không còn xơ múi gì",
    example: "hết sạch, không còn xơ múi gì",
  },
  {
    word: "xơ múi",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) kiếm chác, vơ vét: chẳng xơ múi được gì!",
    example: "chẳng xơ múi được gì!",
  },
  {
    word: "xơ cứng",
    part_of_speech: "tính từ",
    meaning:
      "(hiện tượng tế bào) cứng lại do thoái hoá, làm mất chức năng: xơ cứng động mạch",
    example: "xơ cứng động mạch",
  },
  {
    word: "xơ cứng",
    part_of_speech: "tính từ",
    meaning:
      "cứng nhắc, trì trệ, không còn khả năng hoạt động: đầu óc xơ cứng * một cơ chế quản lí xơ cứng",
    example: "đầu óc xơ cứng * một cơ chế quản lí xơ cứng",
  },
  {
    word: "xờ xạc",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như xơ xác: vườn chuối xờ xạc",
    example: "vườn chuối xờ xạc",
  },
  {
    word: "xới",
    part_of_speech: "danh từ",
    meaning: "(Khẩu ngữ) quê hương, xứ sở: bỏ xới mà đi",
    example: "bỏ xới mà đi",
  },
  {
    word: "xới",
    part_of_speech: "động từ",
    meaning:
      "lật và đảo từng mảng một, từng lớp một, từ dưới lên trên: xới cỏ * sách vở bị xới tung lên",
    example: "xới cỏ * sách vở bị xới tung lên",
  },
  {
    word: "xới",
    part_of_speech: "động từ",
    meaning:
      "dùng đũa lấy cơm, xôi từng ít một từ trong nồi ra: xới cơm * xới xôi ra đĩa",
    example: "xới cơm * xới xôi ra đĩa",
  },
  {
    word: "xới xáo",
    part_of_speech: "động từ",
    meaning:
      "xới đất để trồng trọt (nói khái quát): xới xáo cho kĩ để trồng rau",
    example: "xới xáo cho kĩ để trồng rau",
  },
  {
    word: "xơ vữa",
    part_of_speech: "tính từ",
    meaning:
      "(tế bào thành mạch máu) ở tình trạng xơ hoá, làm cho không còn khả năng đàn hồi để lưu chuyển máu: xơ vữa động mạch",
    example: "xơ vữa động mạch",
  },
  {
    word: "xơi xơi",
    part_of_speech: "tính từ",
    meaning:
      '(khẩu ngữ) lắm lời một cách quá quắt, không chịu ngớt: mắng xơi xơi * "Tội đâu có phép đấy rồi, Can chi mà cứ xơi xơi nhọc mình." (NĐM)',
    example:
      'mắng xơi xơi * "Tội đâu có phép đấy rồi, Can chi mà cứ xơi xơi nhọc mình." (NĐM)',
  },
  {
    word: "xởi",
    part_of_speech: "động từ",
    meaning:
      "làm cho tơi ra, cho khỏi dồn cục lại: xởi cơm * xởi rơm cho nhanh khô",
    example: "xởi cơm * xởi rơm cho nhanh khô",
  },
  {
    word: "xởi lởi",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có thái độ cởi mở, dễ tiếp xúc, dễ hoà đồng với người khác: chuyện trò xởi lởi * tính tình xởi lởi",
    example: "chuyện trò xởi lởi * tính tình xởi lởi",
  },
  {
    word: "xởi lởi",
    part_of_speech: "tính từ",
    meaning: "rộng rãi, tốt bụng: xởi lởi trời cho (tng)",
    example: "xởi lởi trời cho (tng)",
  },
  {
    word: "xơi",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) ăn, uống hoặc hút (thường dùng trong lời mời chào): xơi cơm * xơi nước * xơi miếng trầu",
    example: "xơi cơm * xơi nước * xơi miếng trầu",
  },
  {
    word: "xơi",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) phải chịu, bị (điều không hay): xơi điểm hai * xơi trận đòn đau",
    example: "xơi điểm hai * xơi trận đòn đau",
  },
  {
    word: "xơn xớt",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) như thơn thớt: xơn xớt nói cười",
    example: "xơn xớt nói cười",
  },
  {
    word: "xơi tái",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) đoạt được, thực hiện được một cách dễ dàng, nhanh gọn: cái xe vừa đấy đã bị bọn trộm xơi tái",
    example: "cái xe vừa đấy đã bị bọn trộm xơi tái",
  },
  {
    word: "xớt",
    part_of_speech: "động từ",
    meaning:
      '(khẩu ngữ) bắt đi, lấy đi một cách mau lẹ: "Chim nhàn xớt cá lên khơi, Phút đâu trận gió rã rời điểu ngư." (ca dao)',
    example:
      'Chim nhàn xớt cá lên khơi, Phút đâu trận gió rã rời điểu ngư." (ca dao)',
  },
  {
    word: "xu",
    part_of_speech: "danh từ",
    meaning:
      "(Từ cũ) đơn vị tiền tệ nhỏ nhất trước đây của nước Việt Nam, bằng một phần trăm đồng.",
    example: "trả đủ, không thiếu một xu * không một xu dính túi",
  },
  {
    word: "xù",
    part_of_speech: "động từ",
    meaning:
      "(con vật) tự làm cho bộ lông dựng đứng lên: nhím xù lông * con gà mái xù lông",
    example: "nhím xù lông * con gà mái xù lông",
  },
  {
    word: "xù",
    part_of_speech: "tính từ",
    meaning:
      "(tóc, lông) ở trạng thái dựng lên và rối: tóc xù * bít tất xù * chải tóc cho đỡ xù",
    example: "tóc xù * bít tất xù * chải tóc cho đỡ xù",
  },
  {
    word: "xù",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (to, lớn) quá cỡ, trông khó coi: chiếc áo bông to xù * đôi bàn tay to xù",
    example: "chiếc áo bông to xù * đôi bàn tay to xù",
  },
  {
    word: "xù",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ, khẩu ngữ) cố tình không chịu trả: mượn tiền rồi xù mất * xù thuế * xù nợ",
    example: "mượn tiền rồi xù mất * xù thuế * xù nợ",
  },
  {
    word: "xụ",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) (mặt) xị xuống vì buồn bã, lo âu: buồn xụ mặt * xụ mặt xuống lo lắng",
    example: "buồn xụ mặt * xụ mặt xuống lo lắng",
  },
  {
    word: "xu hướng",
    part_of_speech: "danh từ",
    meaning:
      "sự thiên về một hướng nào đó trong quá trình hoạt động: xu hướng chính trị * đi theo xu hướng chung của thời đại",
    example: "xu hướng chính trị * đi theo xu hướng chung của thời đại",
  },
  {
    word: "xu mị",
    part_of_speech: "động từ",
    meaning: "(cũ, hiếm) như phỉnh nịnh: xu mị kẻ quyền thế",
    example: "xu mị kẻ quyền thế",
  },
  {
    word: "xu phụ",
    part_of_speech: "động từ",
    meaning: "(cũ) hùa theo để cầu lợi: xu phụ kẻ quyền thế",
    example: "xu phụ kẻ quyền thế",
  },
  {
    word: "xú uế",
    part_of_speech: "tính từ",
    meaning: "hôi thối: mùi xú uế xông nồng nặc",
    example: "mùi xú uế xông nồng nặc",
  },
  {
    word: "xu nịnh",
    part_of_speech: "động từ",
    meaning: "nịnh nọt nhằm cầu lợi: xun xoe xu nịnh",
    example: "xun xoe xu nịnh",
  },
  {
    word: "xu xoa",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) thạch: xu xoa được chế biến từ rong biển",
    example: "xu xoa được chế biến từ rong biển",
  },
  {
    word: "xu thế",
    part_of_speech: "danh từ",
    meaning:
      "chiều hướng phát triển hợp quy luật: xu thế phát triển * đi ngược với xu thế của thời đại",
    example: "xu thế phát triển * đi ngược với xu thế của thời đại",
  },
  {
    word: "xu thế",
    part_of_speech: "danh từ",
    meaning:
      "hướng hoạt động, phát triển chung, chủ yếu trong một thời gian nào đó: xuất khẩu đang có xu thế giảm",
    example: "xuất khẩu đang có xu thế giảm",
  },
  {
    word: "xua đuổi",
    part_of_speech: "động từ",
    meaning:
      "đuổi đi không cho lại gần, với thái độ coi khinh: xua đuổi tà ma * đi đến đâu cũng bị xua đuổi",
    example: "xua đuổi tà ma * đi đến đâu cũng bị xua đuổi",
  },
  {
    word: "xua đuổi",
    part_of_speech: "động từ",
    meaning: "xua tan đi điều đang ám ảnh: xua đuổi nỗi ám ảnh",
    example: "xua đuổi nỗi ám ảnh",
  },
  {
    word: "xu thời",
    part_of_speech: "động từ",
    meaning:
      "tuỳ thời thế, thấy mạnh thì theo nhằm mục đích cầu lợi: kẻ xu thời * đả kích thói xu thời",
    example: "kẻ xu thời * đả kích thói xu thời",
  },
  {
    word: "xù xì",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều nốt nhỏ không đều nổi trên bề mặt, khiến cho khi sờ vào thấy không mịn: vỏ cây xù xì * da tay xù xì",
    example: "vỏ cây xù xì * da tay xù xì",
  },
  {
    word: "xuân",
    part_of_speech: "danh từ",
    meaning:
      "mùa chuyển tiếp từ đông sang hạ, thời tiết ấm dần lên, thường được coi là mở đầu của năm: mưa xuân * trời vào xuân",
    example: "mưa xuân * trời vào xuân",
  },
  {
    word: "xuân",
    part_of_speech: "danh từ",
    meaning:
      '(Văn chương) năm, dùng để tính thời gian đã trôi qua: "Xuân này đến nữa đã ba xuân, Đóm lửa tình duyên tắt nguội dần." (NgBính; 5)',
    example:
      'Xuân này đến nữa đã ba xuân, Đóm lửa tình duyên tắt nguội dần." (NgBính; 5)',
  },
  {
    word: "xuân",
    part_of_speech: "tính từ",
    meaning:
      '(Văn chương) thuộc về tuổi trẻ, coi là tươi đẹp, tràn đầy sức sống: tuổi xuân * "Gió đưa cây trúc ngã quỳ, Ba năm chực tiết còn gì là xuân!" (Cdao)',
    example:
      'tuổi xuân * "Gió đưa cây trúc ngã quỳ, Ba năm chực tiết còn gì là xuân!" (Cdao)',
  },
  {
    word: "xua tan",
    part_of_speech: "động từ",
    meaning:
      "làm tan đi, cho mất hẳn đi: xua tan bóng tối * tiếng nổ làm xua tan cơn mộng mị",
    example: "xua tan bóng tối * tiếng nổ làm xua tan cơn mộng mị",
  },
  {
    word: "xua",
    part_of_speech: "động từ",
    meaning:
      "làm động tác đưa tay qua lại tỏ thái độ khước từ hoặc ra hiệu bảo thôi đi: xua tay từ chối * xua tay ngăn lại",
    example: "xua tay từ chối * xua tay ngăn lại",
  },
  {
    word: "xua",
    part_of_speech: "động từ",
    meaning:
      "làm các động tác để đuổi đi hoặc đuổi dồn về một phía: xua muỗi * xua vịt ra đồng * xua lính xông lên",
    example: "xua muỗi * xua vịt ra đồng * xua lính xông lên",
  },
  {
    word: "xua",
    part_of_speech: "động từ",
    meaning:
      "làm cho tan đi, mất đi (nói về cái trừu tượng): xua tan mây mù * xua đi nỗi nhớ",
    example: "xua tan mây mù * xua đi nỗi nhớ",
  },
  {
    word: "xuân đường",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) người cha (ví với nhà có trồng cây xuân): "Liêu Dương cách trở sơn khê, Xuân đường kíp gọi Sinh về hộ tang." (TKiều)',
    example:
      'Liêu Dương cách trở sơn khê, Xuân đường kíp gọi Sinh về hộ tang." (TKiều)',
  },
  {
    word: "xuân huyên",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) cha mẹ (ví với cây xuân và cỏ huyên, hai loài cây cỏ sống lâu): "Xuân huyên lo sợ xiết bao, Quá ra khi đến thế nào mà hay!" (TKiều)',
    example:
      'Xuân huyên lo sợ xiết bao, Quá ra khi đến thế nào mà hay!" (TKiều)',
  },
  {
    word: "xuân sắc",
    part_of_speech: "danh từ",
    meaning:
      "cảnh sắc mùa xuân; thường dùng để ví sắc vẻ trẻ trung, tươi đẹp: thời xuân sắc * tuổi còn xuân sắc",
    example: "thời xuân sắc * tuổi còn xuân sắc",
  },
  {
    word: "xuân thu",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) mùa xuân và mùa thu; thường dùng trong văn học cổ để chỉ tuổi tác: "Gẫm mình chưa mấy xuân thu, Sầu vương đã chịu, oán thù đã mang." (ca dao)',
    example:
      'Gẫm mình chưa mấy xuân thu, Sầu vương đã chịu, oán thù đã mang." (ca dao)',
  },
  {
    word: "xuân xanh",
    part_of_speech: "danh từ",
    meaning:
      '(văn chương) tuổi trẻ, ví như mùa xuân tươi đẹp: "Phong lưu rất mực hồng quần, Xuân xanh xấp xỉ tới tuần cập kê." (TKiều)',
    example:
      'Phong lưu rất mực hồng quần, Xuân xanh xấp xỉ tới tuần cập kê." (TKiều)',
  },
  {
    word: "xuất",
    part_of_speech: "động từ",
    meaning:
      "===== đưa ra: xuất tiền trả lương * xuất hàng ra bán * phiếu xuất kho",
    example: "xuất tiền trả lương * xuất hàng ra bán * phiếu xuất kho",
  },
  {
    word: "xuất",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) xuất khẩu (nói tắt): xuất gạo ra nước ngoài * hàng xuất",
    example: "xuất gạo ra nước ngoài * hàng xuất",
  },
  {
    word: "xuất",
    part_of_speech: "động từ",
    meaning: "đưa ra: xuất con xe * xuất thẻ nhà báo",
    example: "xuất con xe * xuất thẻ nhà báo",
  },
  {
    word: "xuất bản phẩm",
    part_of_speech: "danh từ",
    meaning:
      "sản phẩm của ngành in như sách báo, tranh ảnh, v.v. được đưa ra phát hành: phát hành xuất bản phẩm",
    example: "phát hành xuất bản phẩm",
  },
  {
    word: "xuất bản",
    part_of_speech: "động từ",
    meaning:
      "in ra thành sách báo, tranh ảnh để phát hành: xuất bản một tập thơ * sách mới xuất bản",
    example: "xuất bản một tập thơ * sách mới xuất bản",
  },
  {
    word: "xuất biên",
    part_of_speech: "động từ",
    meaning: "(cũ, hiếm) như xuất khẩu: hàng xuất biên",
    example: "hàng xuất biên",
  },
  {
    word: "xuất chinh",
    part_of_speech: "động từ",
    meaning:
      '(cũ) ra trận: "Chín lần gươm báu trao tay, Nửa đêm truyền hịch định ngày xuất chinh." (CPN)',
    example:
      'Chín lần gươm báu trao tay, Nửa đêm truyền hịch định ngày xuất chinh." (CPN)',
  },
  {
    word: "xuất chúng",
    part_of_speech: "tính từ",
    meaning:
      "hơn hẳn mọi người về tài năng, trí tuệ: văn chương xuất chúng * một con người xuất chúng",
    example: "văn chương xuất chúng * một con người xuất chúng",
  },
  {
    word: "xuất cảnh",
    part_of_speech: "động từ",
    meaning:
      "qua biên giới, ra khỏi lãnh thổ của một nước; phân biệt với nhập cảnh: làm thủ tục xuất cảnh * xuất cảnh trái phép",
    example: "làm thủ tục xuất cảnh * xuất cảnh trái phép",
  },
  {
    word: "xuất cảng",
    part_of_speech: "động từ",
    meaning: "(cũ) như xuất khẩu: xuất cảng than * thuế xuất cảng",
    example: "xuất cảng than * thuế xuất cảng",
  },
  {
    word: "xuất cảng",
    part_of_speech: "động từ",
    meaning:
      "đưa ra nước ngoài cái thuộc về đặc thù riêng của nước mình; phân biệt với nhập cảng: cách mạng không thể xuất cảng",
    example: "cách mạng không thể xuất cảng",
  },
  {
    word: "xuất hiện",
    part_of_speech: "động từ",
    meaning:
      "hiện ra và nhìn thấy được: một bóng người xuất hiện * hàng giả xuất hiện trên thị trường",
    example: "một bóng người xuất hiện * hàng giả xuất hiện trên thị trường",
  },
  {
    word: "xuất hiện",
    part_of_speech: "động từ",
    meaning: "nảy sinh ra, hình thành ra: xuất hiện một trường phái mới",
    example: "xuất hiện một trường phái mới",
  },
  {
    word: "xuất hành",
    part_of_speech: "động từ",
    meaning:
      "bắt đầu rời nhà để lên đường đi xa, nói về mặt vào ngày tốt hay ngày xấu, theo tín ngưỡng dân gian: chọn ngày xuất hành",
    example: "chọn ngày xuất hành",
  },
  {
    word: "xuất hành",
    part_of_speech: "động từ",
    meaning:
      "đi ra khỏi nhà lần đầu tiên trong năm mới âm lịch, nói về mặt giờ tốt hay xấu, theo tín ngưỡng dân gian: năm nay kiêng xuất hành vào giờ Tị",
    example: "năm nay kiêng xuất hành vào giờ Tị",
  },
  {
    word: "xuất khẩu",
    part_of_speech: "động từ",
    meaning:
      "đưa hàng hoá hoặc vốn ra nước ngoài để buôn bán, kinh doanh; phân biệt với nhập khẩu: xuất khẩu gạo * đi xuất khẩu lao động",
    example: "xuất khẩu gạo * đi xuất khẩu lao động",
  },
  {
    word: "xuất kích",
    part_of_speech: "động từ",
    meaning:
      "rời trận địa hoặc căn cứ để đi đánh địch: đợi lệnh xuất kích * đã đến giờ xuất kích",
    example: "đợi lệnh xuất kích * đã đến giờ xuất kích",
  },
  {
    word: "xuất giá",
    part_of_speech: "động từ",
    meaning:
      "(cũ) đi lấy chồng: xuất giá tòng phu (đi lấy chồng phải phục tùng chồng, theo lễ giáo phong kiến)",
    example:
      "xuất giá tòng phu (đi lấy chồng phải phục tùng chồng, theo lễ giáo phong kiến)",
  },
  {
    word: "xuất huyết",
    part_of_speech: "động từ",
    meaning:
      "(hiện tượng) chảy máu ở các bộ phận bên trong cơ thể: xuất huyết não * bị xuất huyết dạ dày",
    example: "xuất huyết não * bị xuất huyết dạ dày",
  },
  {
    word: "xuất kì bất ý",
    part_of_speech: "",
    meaning:
      "bất thình lình, thừa lúc người ta không ngờ, làm cho không kịp đối phó: quân ta xuất kì bất ý tập kích đồn địch",
    example: "quân ta xuất kì bất ý tập kích đồn địch",
  },
  {
    word: "xuất nhập khẩu",
    part_of_speech: "động từ",
    meaning: "xuất khẩu và nhập khẩu (nói gộp): hàng hoá xuất nhập khẩu",
    example: "hàng hoá xuất nhập khẩu",
  },
  {
    word: "xuất phát",
    part_of_speech: "động từ",
    meaning:
      "bắt đầu đi, bắt đầu di động: giờ xuất phát * đoàn đua xuất phát từ Hà Nội",
    example: "giờ xuất phát * đoàn đua xuất phát từ Hà Nội",
  },
  {
    word: "xuất phát",
    part_of_speech: "động từ",
    meaning:
      "bắt đầu từ, nảy sinh từ (cái lấy đó làm gốc, làm căn cứ): xuất phát từ tình hình thực tế * lời nói xuất phát tự đáy lòng",
    example: "xuất phát từ tình hình thực tế * lời nói xuất phát tự đáy lòng",
  },
  {
    word: "xuất ngoại",
    part_of_speech: "động từ",
    meaning: "đi ra nước ngoài: lần đầu tiên được xuất ngoại",
    example: "lần đầu tiên được xuất ngoại",
  },
  {
    word: "xuất ngũ",
    part_of_speech: "động từ",
    meaning: "ra khỏi quân đội: bộ đội xuất ngũ",
    example: "bộ đội xuất ngũ",
  },
  {
    word: "xuất nhập cảnh",
    part_of_speech: "động từ",
    meaning: "xuất cảnh và nhập cảnh (nói gộp): thủ tục xuất nhập cảnh",
    example: "thủ tục xuất nhập cảnh",
  },
  {
    word: "xuất kỳ bất ý",
    part_of_speech: "",
    meaning:
      "bất thình lình, thừa lúc người ta không ngờ, làm cho không kịp đối phó: quân ta xuất kì bất ý tập kích đồn địch",
    example: "quân ta xuất kì bất ý tập kích đồn địch",
  },
  {
    word: "xuất quân",
    part_of_speech: "động từ",
    meaning: "(quân đội) lên đường đi chiến đấu: nhận được lệnh xuất quân",
    example: "nhận được lệnh xuất quân",
  },
  {
    word: "xuất phát điểm",
    part_of_speech: "danh từ",
    meaning:
      "điểm lấy đó làm gốc, làm căn cứ: xuất phát điểm khác nhau dẫn đến kết quả khác nhau",
    example: "xuất phát điểm khác nhau dẫn đến kết quả khác nhau",
  },
  {
    word: "xuất sắc",
    part_of_speech: "tính từ",
    meaning:
      "đạt được những thành tích nổi bật hơn hẳn mức bình thường: thành tích xuất sắc * học sinh xuất sắc * cầu thủ xuất sắc",
    example: "thành tích xuất sắc * học sinh xuất sắc * cầu thủ xuất sắc",
  },
  {
    word: "xuất thân",
    part_of_speech: "động từ",
    meaning:
      "sinh ra, lớn lên, được đào tạo ở nơi nào đó trước khi có cuộc sống tự lập và sự nghiệp riêng: xuất thân từ gia đình nông dân * thành phần xuất thân",
    example: "xuất thân từ gia đình nông dân * thành phần xuất thân",
  },
  {
    word: "xuất thần",
    part_of_speech: "",
    meaning:
      "ở trạng thái hết sức hưng phấn, khả năng sáng tạo như được thăng hoa, khiến công việc đạt được kết quả vượt xa mức bình thường: giây phút xuất thần",
    example: "giây phút xuất thần",
  },
  {
    word: "xuất trình",
    part_of_speech: "động từ",
    meaning:
      "đưa giấy tờ chứng thực ra trình với cơ quan hay người có trách nhiệm kiểm tra: xuất trình thẻ nhà báo * xuất trình giấy tờ tuỳ thân",
    example: "xuất trình thẻ nhà báo * xuất trình giấy tờ tuỳ thân",
  },
  {
    word: "xuất xử",
    part_of_speech: "động từ",
    meaning:
      "(cũ) ra làm quan hoặc lui về ở ẩn (nói khái quát): lẽ xuất xử của kẻ sĩ",
    example: "lẽ xuất xử của kẻ sĩ",
  },
  {
    word: "xuất thế",
    part_of_speech: "động từ",
    meaning:
      "lánh đời, không tham gia hoạt động xã hội, đi ở ẩn, đi tu, theo quan niệm của đạo Phật: xuất thế tu hành * có tư tưởng xuất thế",
    example: "xuất thế tu hành * có tư tưởng xuất thế",
  },
  {
    word: "xuất trận",
    part_of_speech: "động từ",
    meaning: "(cũ) ra trận: trước giờ xuất trận * tiếng kèn xuất trận",
    example: "trước giờ xuất trận * tiếng kèn xuất trận",
  },
  {
    word: "xuất viện",
    part_of_speech: "động từ",
    meaning:
      "ra khỏi bệnh viện sau một thời gian nằm điều trị; phân biệt với nhập viện: bệnh nhân đã được xuất viện",
    example: "bệnh nhân đã được xuất viện",
  },
  {
    word: "xúc động",
    part_of_speech: "động từ",
    meaning:
      "rung động mạnh mẽ trong lòng và trong thời gian tương đối ngắn, nhiều khi làm tê liệt nhận thức: lòng bồi hồi xúc động * không mảy may xúc động",
    example: "lòng bồi hồi xúc động * không mảy may xúc động",
  },
  {
    word: "xúc động",
    part_of_speech: "danh từ",
    meaning: "sự rung động trong lòng: không nén nổi xúc động",
    example: "không nén nổi xúc động",
  },
  {
    word: "xuất xứ",
    part_of_speech: "danh từ",
    meaning:
      "nguồn gốc của một văn bản hoặc tài liệu được trích dẫn ra: xuất xứ của bài thơ",
    example: "xuất xứ của bài thơ",
  },
  {
    word: "xuất xứ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) nguồn gốc hình thành của sản phẩm: chiếc lọ có xuất xứ từ Trung Quốc * hàng không rõ xuất xứ",
    example: "chiếc lọ có xuất xứ từ Trung Quốc * hàng không rõ xuất xứ",
  },
  {
    word: "xuất xưởng",
    part_of_speech: "động từ",
    meaning:
      "(sản phẩm) xuất ra khỏi nhà máy để đưa đi tiêu thụ: xe máy mới xuất xưởng",
    example: "xe máy mới xuất xưởng",
  },
  {
    word: "xúc",
    part_of_speech: "động từ",
    meaning:
      "lấy vật rời ra bằng dụng cụ có lòng trũng: xúc cơm * dùng xẻng xúc than * ghét như xúc đất đổ đi (kng)",
    example: "xúc cơm * dùng xẻng xúc than * ghét như xúc đất đổ đi (kng)",
  },
  {
    word: "xúc",
    part_of_speech: "động từ",
    meaning:
      'bắt tôm tép bằng cách dùng rổ, vợt, v.v. vục sâu xuống nước rồi nhấc nhanh lên: "Công anh xúc tép nuôi cò, Cò ăn cò lớn cò dò lên cây." (ca dao)',
    example: 'Công anh xúc tép nuôi cò, Cò ăn cò lớn cò dò lên cây." (ca dao)',
  },
  {
    word: "xúc cảm",
    part_of_speech: "",
    meaning: "như cảm xúc: dễ xúc cảm * mối xúc cảm",
    example: "dễ xúc cảm * mối xúc cảm",
  },
  {
    word: "xúc tác",
    part_of_speech: "động từ",
    meaning:
      "gây nên phản ứng hoá học bằng lượng nhỏ của một chất còn nguyên sau phản ứng: chất xúc tác * men xúc tác",
    example: "chất xúc tác * men xúc tác",
  },
  {
    word: "xúc giác",
    part_of_speech: "danh từ",
    meaning:
      "cảm giác về hình thể, trạng thái bên ngoài của sự vật, về nóng lạnh, về đau đớn, v.v. thu nhận được do những kích thích tác động vào một số cơ quan nằm trên mặt da: cơ quan xúc giác",
    example: "cơ quan xúc giác",
  },
  {
    word: "xúc phạm",
    part_of_speech: "động từ",
    meaning:
      "động chạm đến, làm tổn thương đến cái cao quý, thiêng liêng cần phải giữ gìn: xúc phạm đến danh dự * buông lời xúc phạm",
    example: "xúc phạm đến danh dự * buông lời xúc phạm",
  },
  {
    word: "xuể",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị khả năng thực hiện của điều vừa được nói đến: đông không đếm xuể * chỗ thóc này phải ba thùng chứa mới xuể",
    example: "đông không đếm xuể * chỗ thóc này phải ba thùng chứa mới xuể",
  },
  {
    word: "xúc tiến",
    part_of_speech: "động từ",
    meaning:
      "làm cho tiến triển nhanh hơn: xúc tiến hợp tác buôn bán * việc điều tra đang được xúc tiến",
    example: "xúc tiến hợp tác buôn bán * việc điều tra đang được xúc tiến",
  },
  {
    word: "xúc xiểm",
    part_of_speech: "động từ",
    meaning:
      "đặt điều xúi giục người này làm hại hoặc gây mâu thuẫn, xích mích với người khác: xúc xiểm người chồng bỏ vợ * nghe lời xúc xiểm",
    example: "xúc xiểm người chồng bỏ vợ * nghe lời xúc xiểm",
  },
  {
    word: "xúc xích",
    part_of_speech: "danh từ",
    meaning:
      "món ăn làm bằng ruột lợn nhồi thịt xay nhỏ rồi hun khói và luộc nhỏ lửa: bánh mì ăn với xúc xích",
    example: "bánh mì ăn với xúc xích",
  },
  {
    word: "xúc xích",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) dây kim loại, gồm nhiều vòng nhỏ móc nối vào nhau: sợi dây xúc xích",
    example: "sợi dây xúc xích",
  },
  {
    word: "xuề xoà",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra dễ dãi, đơn giản, thế nào cũng xong: ăn mặc xuề xoà * tính xuề xoà, dễ bỏ qua mọi chuyện",
    example: "ăn mặc xuề xoà * tính xuề xoà, dễ bỏ qua mọi chuyện",
  },
  {
    word: "xuê xoa",
    part_of_speech: "động từ",
    meaning:
      "tỏ ra dễ dãi, không giữ đúng nguyên tắc, chỉ cốt cho xong, cho êm chuyện: cười xuê xoa * xuê xoa nương nhẹ",
    example: "cười xuê xoa * xuê xoa nương nhẹ",
  },
  {
    word: "xuềnh xoàng",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra quá dễ dãi, sơ sài trong sinh hoạt, coi như thế nào cũng xong: ăn mặc xuềnh xoàng * căn phòng xuềnh xoàng",
    example: "ăn mặc xuềnh xoàng * căn phòng xuềnh xoàng",
  },
  {
    word: "xụi",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) (chân tay) mềm rũ hoặc xệ xuống: đôi chân xụi xuống vì mệt mỏi",
    example: "đôi chân xụi xuống vì mệt mỏi",
  },
  {
    word: "xui",
    part_of_speech: "động từ",
    meaning:
      "nói để người khác nghe theo mà làm việc gì đó một cách thiếu suy nghĩ, thường là việc đáng lẽ không nên làm: xui trẻ nói dối * xui nguyên giục bị (tng)",
    example: "xui trẻ nói dối * xui nguyên giục bị (tng)",
  },
  {
    word: "xui",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) xúi quẩy, đen đủi: gặp chuyện xui",
    example: "gặp chuyện xui",
  },
  {
    word: "xui bẩy",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ, hiếm) như xúi bẩy: xui bẩy nhau đi kiện",
    example: "xui bẩy nhau đi kiện",
  },
  {
    word: "xúi",
    part_of_speech: "động từ",
    meaning:
      "xui làm việc không tốt, có tác hại đến người khác: xúi trẻ nói bậy",
    example: "xúi trẻ nói bậy",
  },
  {
    word: "xúi",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) xúi quẩy (nói tắt): vận xúi",
    example: "vận xúi",
  },
  {
    word: "xui khiến",
    part_of_speech: "động từ",
    meaning:
      "làm cho tự nhiên đưa đến, tự nhiên xảy ra: duyên trời xui khiến * số phận xui khiến cho hai người gặp nhau",
    example: "duyên trời xui khiến * số phận xui khiến cho hai người gặp nhau",
  },
  {
    word: "xúi bẩy",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) xui và kích động người khác làm bậy, với dụng ý xấu: xúi bẩy hai người đánh nhau",
    example: "xúi bẩy hai người đánh nhau",
  },
  {
    word: "xui xẻo",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) đen đủi, không gặp may: gặp chuyện xui xẻo * làm ăn xui xẻo",
    example: "gặp chuyện xui xẻo * làm ăn xui xẻo",
  },
  {
    word: "xụi lơ",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ, khẩu ngữ) không buồn cử động vì mệt mỏi hoặc chán nản: mặt xụi lơ * mệt quá, ngồi xụi lơ",
    example: "mặt xụi lơ * mệt quá, ngồi xụi lơ",
  },
  {
    word: "xúi giục",
    part_of_speech: "động từ",
    meaning:
      "xui và thúc đẩy người khác làm việc sai trái, với dụng ý xấu: xúi giục kẻ xấu làm loạn * nghe lời xúi giục",
    example: "xúi giục kẻ xấu làm loạn * nghe lời xúi giục",
  },
  {
    word: "xúm",
    part_of_speech: "động từ",
    meaning:
      "tụ tập nhau lại quanh một điểm: cả nhà xúm lại hỏi han * bọn trẻ xúm quanh bà nghe kể chuyện",
    example: "cả nhà xúm lại hỏi han * bọn trẻ xúm quanh bà nghe kể chuyện",
  },
  {
    word: "xúi quẩy",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) không may mắn, không gặp may: gặp chuyện xúi quẩy",
    example: "gặp chuyện xúi quẩy",
  },
  {
    word: "xung điện",
    part_of_speech: "danh từ",
    meaning:
      "dòng điện xuất hiện đột ngột trong thời gian ngắn: thiết bị chống xung điện",
    example: "thiết bị chống xung điện",
  },
  {
    word: "xung động",
    part_of_speech: "danh từ",
    meaning:
      "luồng kích thích lan từ nơi này đến nơi khác của cơ thể: xung động thần kinh",
    example: "xung động thần kinh",
  },
  {
    word: "xung động",
    part_of_speech: "danh từ",
    meaning:
      "hành động có tính chất bột phát, thường do ảnh hưởng của những kích động mạnh: kìm nén cơn xung động * cảm tình xung động",
    example: "kìm nén cơn xung động * cảm tình xung động",
  },
  {
    word: "xúm xít",
    part_of_speech: "động từ",
    meaning:
      "xúm lại rất đông: bọn trẻ xúm xít quanh chiếc xe đạp mới * xúm xít lại hỏi chuyện",
    example: "bọn trẻ xúm xít quanh chiếc xe đạp mới * xúm xít lại hỏi chuyện",
  },
  {
    word: "xun xoe",
    part_of_speech: "động từ",
    meaning:
      "từ gợi tả dáng vẻ, cử chỉ săn đón, vồn vã quá đáng nhằm nịnh nọt: bộ dạng xun xoe * chỉ giỏi xun xoe bợ đỡ!",
    example: "bộ dạng xun xoe * chỉ giỏi xun xoe bợ đỡ!",
  },
  {
    word: "xung khắc",
    part_of_speech: "tính từ",
    meaning:
      "không hợp nhau nên hay dẫn đến bất hoà: anh em xung khắc nhau * tuổi hai người xung khắc",
    example: "anh em xung khắc nhau * tuổi hai người xung khắc",
  },
  {
    word: "xung",
    part_of_speech: "động từ",
    meaning: "tức, giận: chưa nghe hết câu đã nổi xung lên",
    example: "chưa nghe hết câu đã nổi xung lên",
  },
  {
    word: "xung",
    part_of_speech: "tính từ",
    meaning:
      "kị, khắc nhau (theo mê tín): năm xung tháng hạn * hai tuổi xung nhau",
    example: "năm xung tháng hạn * hai tuổi xung nhau",
  },
  {
    word: "xung",
    part_of_speech: "động từ",
    meaning: "tác dụng trong khoảng thời gian cực kì ngắn: tín hiệu xung",
    example: "tín hiệu xung",
  },
  {
    word: "xung kích",
    part_of_speech: "động từ",
    meaning:
      "làm nhiệm vụ xung phong trong chiến đấu: chiến sĩ xung kích * đại đội xung kích",
    example: "chiến sĩ xung kích * đại đội xung kích",
  },
  {
    word: "xung kích",
    part_of_speech: "động từ",
    meaning:
      "đi đầu làm những nhiệm vụ khó khăn, gay go nhất: thanh niên xung kích * vị trí xung kích của báo chí",
    example: "thanh niên xung kích * vị trí xung kích của báo chí",
  },
  {
    word: "xung thiên",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) (hiện tượng tâm lí) hết sức mạnh mẽ và dữ dội, tựa như bốc cao đến tận trời: thế xung thiên",
    example: "thế xung thiên",
  },
  {
    word: "xung đột",
    part_of_speech: "động từ",
    meaning:
      "đánh nhau giữa những lực lượng đối địch (nói khái quát): quân đội hai bên xung đột với nhau * cuộc xung đột",
    example: "quân đội hai bên xung đột với nhau * cuộc xung đột",
  },
  {
    word: "xung đột",
    part_of_speech: "động từ",
    meaning:
      "va chạm, chống đối nhau do mâu thuẫn gay gắt: xung đột sắc tộc * xung đột về quyền lợi",
    example: "xung đột sắc tộc * xung đột về quyền lợi",
  },
  {
    word: "xung đột",
    part_of_speech: "danh từ",
    meaning:
      "sự va chạm, chống đối lẫn nhau: những xung đột nội tâm của nhân vật * giải quyết xung đột",
    example: "những xung đột nội tâm của nhân vật * giải quyết xung đột",
  },
  {
    word: "xung phong",
    part_of_speech: "động từ",
    meaning:
      "xông thẳng vào đánh (trong chiến đấu): phát lệnh xung phong * dẫn đầu mũi xung phong",
    example: "phát lệnh xung phong * dẫn đầu mũi xung phong",
  },
  {
    word: "xung phong",
    part_of_speech: "động từ",
    meaning:
      "tự nguyện nhận làm nhiệm vụ khó khăn: xung phong nhập ngũ * xung phong lên phát biểu",
    example: "xung phong nhập ngũ * xung phong lên phát biểu",
  },
  {
    word: "xung quanh",
    part_of_speech: "danh từ",
    meaning:
      "khoảng không gian bao quanh một sự vật: vây kín xung quanh * bạn bè xung quanh",
    example: "vây kín xung quanh * bạn bè xung quanh",
  },
  {
    word: "xung quanh",
    part_of_speech: "danh từ",
    meaning:
      "phạm vi có liên quan đến một sự việc: có nhiều ý kiến xung quanh vấn đề này",
    example: "có nhiều ý kiến xung quanh vấn đề này",
  },
  {
    word: "xung trận",
    part_of_speech: "động từ",
    meaning: "xông ra trận, xông vào trận đánh: trước giờ xung trận",
    example: "trước giờ xung trận",
  },
  {
    word: "xùng xình",
    part_of_speech: "tính từ",
    meaning:
      '(phương ngữ) thùng thình: "Xùng xình áo lụa mới may, Hôm qua thấy bận, bữa nay mất rồi?" (ca dao)',
    example:
      'Xùng xình áo lụa mới may, Hôm qua thấy bận, bữa nay mất rồi?" (ca dao)',
  },
  {
    word: "xủng xẻng",
    part_of_speech: "tính từ",
    meaning:
      "như xủng xoảng (nhưng tiếng nghe nhỏ hơn và ít vang): tiền xu kêu xủng xẻng",
    example: "tiền xu kêu xủng xẻng",
  },
  {
    word: "xung yếu",
    part_of_speech: "tính từ",
    meaning:
      "có vị trí đặc biệt quan trọng: quãng đê xung yếu * vị trí xung yếu",
    example: "quãng đê xung yếu * vị trí xung yếu",
  },
  {
    word: "xúng xính",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả dáng điệu của người tỏ ra hài lòng trong bộ quần áo rộng và dài, nhưng sang, diện: em bé xúng xính trong bộ váy mới",
    example: "em bé xúng xính trong bộ váy mới",
  },
  {
    word: "xuôi tai",
    part_of_speech: "tính từ",
    meaning: "hợp với ý người nghe: lời nói xuôi tai * nghe cũng xuôi tai",
    example: "lời nói xuôi tai * nghe cũng xuôi tai",
  },
  {
    word: "xủng xoảng",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng các đồ vật bằng kim loại va vào nhau: xô chậu va vào nhau xủng xoảng",
    example: "xô chậu va vào nhau xủng xoảng",
  },
  {
    word: "xuôi",
    part_of_speech: "tính từ",
    meaning:
      "(vận động) theo cùng một chiều tự nhiên với dòng chảy, chiều gió, v.v.: bơi xuôi dòng nước * đi xuôi theo chiều gió * nước mắt chảy xuôi (b)",
    example:
      "bơi xuôi dòng nước * đi xuôi theo chiều gió * nước mắt chảy xuôi (b)",
  },
  {
    word: "xuôi",
    part_of_speech: "tính từ",
    meaning:
      '(khẩu ngữ) ổn thoả, không gặp vướng mắc, trở ngại gì: việc đó khó xuôi * "Tính bài lót đó luồn đây, Có ba trăm lạng, việc này mới xuôi." (TKiều)',
    example:
      'việc đó khó xuôi * "Tính bài lót đó luồn đây, Có ba trăm lạng, việc này mới xuôi." (TKiều)',
  },
  {
    word: "xuôi",
    part_of_speech: "tính từ",
    meaning:
      "(câu thơ, câu văn) trúc trắc, không vần, không liền mạch: văn viết không xuôi * câu thơ đọc khá xuôi",
    example: "văn viết không xuôi * câu thơ đọc khá xuôi",
  },
  {
    word: "xuôi",
    part_of_speech: "tính từ",
    meaning:
      "hoặc d (vùng) ở vùng đồng bằng, ven biển, phía có thể đi xuôi dòng sông để đến: ở dưới xuôi * mai tôi sẽ về xuôi * lên ngược xuống xuôi",
    example: "ở dưới xuôi * mai tôi sẽ về xuôi * lên ngược xuống xuôi",
  },
  {
    word: "xuôi",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đi về phía miền xuôi hoặc theo một hướng được coi là chiều xuôi: kẻ xuôi người ngược * tàu xuôi Nam Định",
    example: "kẻ xuôi người ngược * tàu xuôi Nam Định",
  },
  {
    word: "xuôi",
    part_of_speech: "động từ",
    meaning:
      "chịu đồng ý, nghe theo, không còn giữ ý kiến trái lại: nói nhiều chắc nó sẽ xuôi * nghe chừng anh ta đã xuôi",
    example: "nói nhiều chắc nó sẽ xuôi * nghe chừng anh ta đã xuôi",
  },
  {
    word: "xuôi xị",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ, khẩu ngữ) ngây đờ ra vì mệt mỏi, chán nản: mặt xuôi xị",
    example: "mặt xuôi xị",
  },
  {
    word: "xuôi ngược",
    part_of_speech: "động từ",
    meaning: "như ngược xuôi: thuyền bè xuôi ngược",
    example: "thuyền bè xuôi ngược",
  },
  {
    word: "xuôi chiều",
    part_of_speech: "động từ",
    meaning:
      "thuận theo một chiều, không có ý kiến gì ngược lại: có nhiều ý kiến xuôi chiều * mọi việc đều xuôi chiều",
    example: "có nhiều ý kiến xuôi chiều * mọi việc đều xuôi chiều",
  },
  {
    word: "xuồng",
    part_of_speech: "danh từ",
    meaning:
      "thuyền nhỏ không có mái che, thường đi kèm theo thuyền lớn hoặc tàu thuỷ: chống xuồng",
    example: "chống xuồng",
  },
  {
    word: "xuộm",
    part_of_speech: "tính từ",
    meaning:
      "đậm và đều khắp một màu (thường là màu vàng, đỏ): bụi đất đỏ xuộm * trái bưởi vàng xuộm",
    example: "bụi đất đỏ xuộm * trái bưởi vàng xuộm",
  },
  {
    word: "xuống cân",
    part_of_speech: "động từ",
    meaning:
      "(trọng lượng cơ thể) sụt cân so với trước do người gầy đi, thường là biểu hiện của sức khoẻ giảm sút: người bệnh bị xuống cân",
    example: "người bệnh bị xuống cân",
  },
  {
    word: "xuống cấp",
    part_of_speech: "động từ",
    meaning:
      "sút kém hẳn đi về chất lượng so với trước (thường nói về công trình xây dựng): trường học xuống cấp nghiêm trọng",
    example: "trường học xuống cấp nghiêm trọng",
  },
  {
    word: "xuống",
    part_of_speech: "động từ",
    meaning:
      "di chuyển đến một vị trí thấp hơn hay được coi là thấp hơn: xuống núi * xe từ từ xuống dốc * xuống ngựa",
    example: "xuống núi * xe từ từ xuống dốc * xuống ngựa",
  },
  {
    word: "xuống",
    part_of_speech: "động từ",
    meaning:
      "giảm số lượng hay hạ mức độ, cấp bậc: nước sông đã xuống * nhiệt độ xuống thấp * hàng xuống giá",
    example: "nước sông đã xuống * nhiệt độ xuống thấp * hàng xuống giá",
  },
  {
    word: "xuống",
    part_of_speech: "động từ",
    meaning: "truyền đến các cấp dưới: xuống ơn * xuống lệnh * vua xuống chiếu",
    example: "xuống ơn * xuống lệnh * vua xuống chiếu",
  },
  {
    word: "xuống",
    part_of_speech: "động từ",
    meaning:
      "từ biểu thị hướng di chuyển từ vị trí cao đến vị trí thấp hơn: lặn xuống nước * nhảy tùm xuống sông * từ trên cao nhìn xuống",
    example: "lặn xuống nước * nhảy tùm xuống sông * từ trên cao nhìn xuống",
  },
  {
    word: "xuống",
    part_of_speech: "động từ",
    meaning:
      "từ biểu thị hướng biến đổi của hoạt động, tính chất từ cao đến thấp, từ nhiều đến ít: lốp xe bị xẹp xuống * nhiệt độ tụt xuống",
    example: "lốp xe bị xẹp xuống * nhiệt độ tụt xuống",
  },
  {
    word: "xuồng ba lá",
    part_of_speech: "danh từ",
    meaning:
      "xuồng được làm từ ba tấm ván ghép lại: bơi xuồng ba lá đi câu tôm",
    example: "bơi xuồng ba lá đi câu tôm",
  },
  {
    word: "xuống dốc",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) ví tình trạng bị sút kém rất nhanh, khó cứu vãn: công ti đang dần bị xuống dốc * giai đoạn xuống dốc",
    example: "công ti đang dần bị xuống dốc * giai đoạn xuống dốc",
  },
  {
    word: "xuống đường",
    part_of_speech: "động từ",
    meaning:
      "(người ở thành thị) ra đường để trực tiếp tham gia cuộc đấu tranh quần chúng: sinh viên xuống đường biểu tình",
    example: "sinh viên xuống đường biểu tình",
  },
  {
    word: "xuống tay",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) có hành động bạo lực trực tiếp nhằm vào ai đó, để trừng phạt: thấy tội nghiệp nên không nỡ xuống tay",
    example: "thấy tội nghiệp nên không nỡ xuống tay",
  },
  {
    word: "xuống tay",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) giảm sút rõ rệt về trình độ, tay nghề trong công việc, nghề nghiệp: một tay vợt đã xuống tay",
    example: "một tay vợt đã xuống tay",
  },
  {
    word: "xuống nước",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đổi thái độ, tỏ ra nhún nhường, chịu nhượng bộ, do biết mình đã yếu thế: núng thế, phải xuống nước thương lượng",
    example: "núng thế, phải xuống nước thương lượng",
  },
  {
    word: "xuống mã",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) có vẻ ngoài xấu đi so với trước: dạo này cô ta xuống mã lắm",
    example: "dạo này cô ta xuống mã lắm",
  },
  {
    word: "xuống giống",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bắt đầu gieo hạt giống cho một vụ gieo trồng mới: chuẩn bị xuống giống cho vụ tới",
    example: "chuẩn bị xuống giống cho vụ tới",
  },
  {
    word: "xuống thang",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) giảm mức độ hoạt động xuống dần từng bước một, từ cao xuống thấp: thắng lợi của ta buộc địch phải xuống thang chiến tranh",
    example: "thắng lợi của ta buộc địch phải xuống thang chiến tranh",
  },
  {
    word: "xút",
    part_of_speech: "danh từ",
    meaning:
      "chất rắn dễ hút ẩm, dễ tan trong nước, có tính base mạnh, là một trong các hoá chất cơ bản dùng trong công nghiệp hoá học: bị xút ăn tay",
    example: "bị xút ăn tay",
  },
  {
    word: "xuống tóc",
    part_of_speech: "động từ",
    meaning: "cắt tóc đi tu (theo đạo Phật): xuống tóc quy y",
    example: "xuống tóc quy y",
  },
  {
    word: "xuyên",
    part_of_speech: "động từ",
    meaning:
      "làm cho thủng suốt từ bên này sang bên kia: viên đạn xuyên qua tường * đường hầm xuyên qua núi",
    example: "viên đạn xuyên qua tường * đường hầm xuyên qua núi",
  },
  {
    word: "xuyên",
    part_of_speech: "động từ",
    meaning:
      "vượt qua từ đầu này sang đầu kia: ánh nắng xuyên qua khe cửa * chủ nghĩa nhân đạo là sợi chỉ đỏ xuyên suốt tác phẩm",
    example:
      "ánh nắng xuyên qua khe cửa * chủ nghĩa nhân đạo là sợi chỉ đỏ xuyên suốt tác phẩm",
  },
  {
    word: "xuyến",
    part_of_speech: "danh từ",
    meaning:
      "hàng dệt bằng tơ theo dạng vân điểm, sợi dọc và sợi ngang đều nhỏ và săn: vóc xuyến * áo xuyến",
    example: "vóc xuyến * áo xuyến",
  },
  {
    word: "xuyến",
    part_of_speech: "danh từ",
    meaning: "vòng trang sức bằng vàng, ngọc, phụ nữ đeo ở cổ tay: xuyến vàng",
    example: "xuyến vàng",
  },
  {
    word: "xuyến",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) ấm chuyên: xuyến pha trà",
    example: "xuyến pha trà",
  },
  {
    word: "xúp",
    part_of_speech: "danh từ",
    meaning:
      "món ăn lỏng kiểu Âu, nấu bằng thịt hoặc cá với rau, đậu, có thêm gia vị, thường dùng làm món khai vị: món xúp gà * xúp khoai tây",
    example: "món xúp gà * xúp khoai tây",
  },
  {
    word: "xuyên tạc",
    part_of_speech: "động từ",
    meaning:
      "trình bày sai sự thật với dụng ý xấu: xuyên tạc sự thật * luận điệu xuyên tạc",
    example: "xuyên tạc sự thật * luận điệu xuyên tạc",
  },
  {
    word: "xuýt",
    part_of_speech: "động từ",
    meaning: "như suỵt: xuýt chó ra đuổi",
    example: "xuýt chó ra đuổi",
  },
  {
    word: "xuýt",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) xúi giục làm điều không hay: xuýt trẻ đánh nhau",
    example: "xuýt trẻ đánh nhau",
  },
  {
    word: "xuýt",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bịa thêm ra: có ít xuýt ra nhiều * câu chuyện bị đồn xuýt ra",
    example: "có ít xuýt ra nhiều * câu chuyện bị đồn xuýt ra",
  },
  {
    word: "xuyên táo",
    part_of_speech: "động từ",
    meaning: "(bắn) xuyên qua nhiều mục tiêu bằng một phát đạn: bắn xuyên táo",
    example: "bắn xuyên táo",
  },
  {
    word: "xuýt xoa",
    part_of_speech: "động từ",
    meaning:
      "phát ra những tiếng gió khe khẽ trong miệng để biểu thị cảm giác đau, rét, hoặc tiếc rẻ, thương xót, kinh ngạc: xuýt xoa vì đau * miệng xuýt xoa thán phục",
    example: "xuýt xoa vì đau * miệng xuýt xoa thán phục",
  },
  {
    word: "xử",
    part_of_speech: "động từ",
    meaning:
      "hành động theo cách nào đó, thể hiện thái độ đối với người khác trong một hoàn cảnh nhất định: xử tệ với bạn bè * rơi vào tình huống khó xử",
    example: "xử tệ với bạn bè * rơi vào tình huống khó xử",
  },
  {
    word: "xử",
    part_of_speech: "động từ",
    meaning:
      "xem xét và giải quyết việc tố tụng, phạm pháp, tranh chấp, v.v.: toà xử án * xử vụ kiện cáo * cho tự xử",
    example: "toà xử án * xử vụ kiện cáo * cho tự xử",
  },
  {
    word: "xử",
    part_of_speech: "động từ",
    meaning:
      "thi hành án (tử hình): bị đem đi xử bắn * đưa ra pháp trường xử chém",
    example: "bị đem đi xử bắn * đưa ra pháp trường xử chém",
  },
  {
    word: "xứ",
    part_of_speech: "danh từ",
    meaning:
      "khu vực địa lí có chung một số đặc điểm tự nhiên hoặc xã hội nào đó: xứ Đoài * rừng hồi xứ Lạng * thực vật xứ lạnh",
    example: "xứ Đoài * rừng hồi xứ Lạng * thực vật xứ lạnh",
  },
  {
    word: "xứ",
    part_of_speech: "danh từ",
    meaning: "giáo xứ (nói tắt): nhà thờ xứ",
    example: "nhà thờ xứ",
  },
  {
    word: "xử lý",
    part_of_speech: "động từ",
    meaning:
      "làm cho chịu những tác động vật lí, hoá học nhất định để biến đổi hợp mục đích: xử lí vết thương * xử lí nước thải",
    example: "xử lí vết thương * xử lí nước thải",
  },
  {
    word: "xử lý",
    part_of_speech: "động từ",
    meaning:
      "áp dụng những thao tác nhất định để nghiên cứu, sử dụng: xử lí thông tin * dữ liệu chưa qua xử lí",
    example: "xử lí thông tin * dữ liệu chưa qua xử lí",
  },
  {
    word: "xử lý",
    part_of_speech: "động từ",
    meaning:
      "xem xét và giải quyết về mặt tổ chức một vụ phạm lỗi nào đó: xử lí các vụ vi phạm pháp luật * bị xử lí kỉ luật",
    example: "xử lí các vụ vi phạm pháp luật * bị xử lí kỉ luật",
  },
  {
    word: "xử lí",
    part_of_speech: "động từ",
    meaning:
      "làm cho chịu những tác động vật lí, hoá học nhất định để biến đổi hợp mục đích: xử lí vết thương * xử lí nước thải",
    example: "xử lí vết thương * xử lí nước thải",
  },
  {
    word: "xử lí",
    part_of_speech: "động từ",
    meaning:
      "áp dụng những thao tác nhất định để nghiên cứu, sử dụng: xử lí thông tin * dữ liệu chưa qua xử lí",
    example: "xử lí thông tin * dữ liệu chưa qua xử lí",
  },
  {
    word: "xử lí",
    part_of_speech: "động từ",
    meaning:
      "xem xét và giải quyết về mặt tổ chức một vụ phạm lỗi nào đó: xử lí các vụ vi phạm pháp luật * bị xử lí kỉ luật",
    example: "xử lí các vụ vi phạm pháp luật * bị xử lí kỉ luật",
  },
  {
    word: "xử phạt",
    part_of_speech: "động từ",
    meaning:
      "buộc phải chịu một hình phạt hoặc hình thức khiển trách nào đó: xử phạt hành chính * quy định các mức xử phạt",
    example: "xử phạt hành chính * quy định các mức xử phạt",
  },
  {
    word: "xử sự",
    part_of_speech: "động từ",
    meaning:
      "có thái độ, hành động như thế nào đó trước những việc có quan hệ giữa mình với người khác: xử sự khéo léo * biết cách xử sự",
    example: "xử sự khéo léo * biết cách xử sự",
  },
  {
    word: "xứ sở",
    part_of_speech: "danh từ",
    meaning:
      "quê hương, đất nước: trở về xứ sở * xứ sở thần tiên * quê hương xứ sở",
    example: "trở về xứ sở * xứ sở thần tiên * quê hương xứ sở",
  },
  {
    word: "xử thế",
    part_of_speech: "động từ",
    meaning: "đối xử với người đời: biết cách xử thế * thuật xử thế",
    example: "biết cách xử thế * thuật xử thế",
  },
  {
    word: "xử quyết",
    part_of_speech: "động từ",
    meaning: "(cũ) như xử tử: đưa phạm nhân đi xử quyết",
    example: "đưa phạm nhân đi xử quyết",
  },
  {
    word: "xử trí",
    part_of_speech: "động từ",
    meaning:
      "đối phó, giải quyết vấn đề cụ thể do tình hình đề ra: liệu đường mà xử trí * còn do dự chưa biết xử trí ra sao",
    example: "liệu đường mà xử trí * còn do dự chưa biết xử trí ra sao",
  },
  {
    word: "xưa nay",
    part_of_speech: "danh từ",
    meaning:
      "từ xưa đến nay, từ trước đến bây giờ: xưa nay anh ấy vẫn vậy * chuyện lạ, xưa nay chưa từng thấy",
    example: "xưa nay anh ấy vẫn vậy * chuyện lạ, xưa nay chưa từng thấy",
  },
  {
    word: "xưa",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về thời đã qua từ rất lâu rồi: thời xưa * nhắc lại chuyện xưa * chuyện ấy đã xưa lắm rồi",
    example: "thời xưa * nhắc lại chuyện xưa * chuyện ấy đã xưa lắm rồi",
  },
  {
    word: "xưa",
    part_of_speech: "tính từ",
    meaning: "đã có từ trước, từ lâu: duyên xưa * tình xưa nghĩa cũ",
    example: "duyên xưa * tình xưa nghĩa cũ",
  },
  {
    word: "xưa",
    part_of_speech: "danh từ",
    meaning:
      'thời đã qua từ rất lâu rồi; phân biệt với nay: từ xưa đến nay * "Vội sang vườn Thuý dò la, Nhìn phong cảnh cũ, nay đà khác xưa." (TKiều)',
    example:
      'từ xưa đến nay * "Vội sang vườn Thuý dò la, Nhìn phong cảnh cũ, nay đà khác xưa." (TKiều)',
  },
  {
    word: "xức",
    part_of_speech: "động từ",
    meaning:
      "bôi cho dính vào, thấm vào người nhằm một tác dụng nào đó: xức dầu gió * xức nước hoa",
    example: "xức dầu gió * xức nước hoa",
  },
  {
    word: "xứng",
    part_of_speech: "tính từ",
    meaning:
      "vừa với, hợp với đòi hỏi khách quan của người hoặc cái nào đó: xứng đôi vừa lứa * phần thưởng không xứng với công lao",
    example: "xứng đôi vừa lứa * phần thưởng không xứng với công lao",
  },
  {
    word: "xưng",
    part_of_speech: "động từ",
    meaning:
      "tự gọi mình là gì đó khi nói với người khác, biểu thị tính chất mối quan hệ giữa mình với người ấy: gọi anh xưng tôi * xưng là cháu * nói với ai cũng xưng em ngọt xớt",
    example:
      "gọi anh xưng tôi * xưng là cháu * nói với ai cũng xưng em ngọt xớt",
  },
  {
    word: "xưng",
    part_of_speech: "động từ",
    meaning:
      "tự nhận cho mình một danh hiệu cao quý nào đó và tuyên bố để mọi người biết: xưng ngôi hoàng đế * tự xưng là lương y",
    example: "xưng ngôi hoàng đế * tự xưng là lương y",
  },
  {
    word: "xưng",
    part_of_speech: "động từ",
    meaning:
      '(Khẩu ngữ) tự nói ra những điều về bản thân mình cho người khác biết: xưng tên tuổi * "Nghĩ đà bưng kín miệng bình, Nào ai có khảo mà mình lại xưng?" (TKiều)',
    example:
      'xưng tên tuổi * "Nghĩ đà bưng kín miệng bình, Nào ai có khảo mà mình lại xưng?" (TKiều)',
  },
  {
    word: "xưng danh",
    part_of_speech: "động từ",
    meaning: "nêu tên cho người khác biết: tự xưng danh",
    example: "tự xưng danh",
  },
  {
    word: "xưng đế",
    part_of_speech: "động từ",
    meaning: "(cũ) tự tôn xưng mình là hoàng đế: Triệu Đà xưng đế ở phương Nam",
    example: "Triệu Đà xưng đế ở phương Nam",
  },
  {
    word: "xừng",
    part_of_speech: "động từ",
    meaning:
      "(lông, tóc, vây) cứng lên và dựng ngược lên, thường để biểu thị sẵn sàng đánh trả sự tiến công đang đe doạ: cá xừng vây * con gà xừng lông",
    example: "cá xừng vây * con gà xừng lông",
  },
  {
    word: "xứng đôi",
    part_of_speech: "tính từ",
    meaning:
      "(trai gái lấy nhau) không có sự chênh lệch đáng kể về mọi mặt: đôi lứa xứng đôi",
    example: "đôi lứa xứng đôi",
  },
  {
    word: "xứng đáng",
    part_of_speech: "tính từ",
    meaning:
      "đáng với, xứng với một danh hiệu, vinh dự hay quyền lợi, trách nhiệm nào đó: xứng đáng với lời khen ngợi * được hưởng đồng lương xứng đáng",
    example: "xứng đáng với lời khen ngợi * được hưởng đồng lương xứng đáng",
  },
  {
    word: "xưng hô",
    part_of_speech: "động từ",
    meaning:
      "tự xưng mình và gọi người khác là gì đó khi nói với nhau để biểu thị tính chất của mối quan hệ với nhau: xưng hô mày - tao * thay đổi cách xưng hô",
    example: "xưng hô mày - tao * thay đổi cách xưng hô",
  },
  {
    word: "xưng xưng",
    part_of_speech: "động từ",
    meaning:
      "nói quả quyết một cách trơ tráo điều không đúng với sự thật: xưng xưng cãi lấy được * xưng xưng đổ tội cho người khác",
    example: "xưng xưng cãi lấy được * xưng xưng đổ tội cho người khác",
  },
  {
    word: "xưng tội",
    part_of_speech: "động từ",
    meaning:
      "(con chiên) tự kể tội lỗi của mình trước linh mục để mong được tha thứ: đến nhà thờ xưng tội",
    example: "đến nhà thờ xưng tội",
  },
  {
    word: "xưng tụng",
    part_of_speech: "động từ",
    meaning: "ca ngợi người nào đó: được người đời tán dương xưng tụng",
    example: "được người đời tán dương xưng tụng",
  },
  {
    word: "xưng hùng xưng bá",
    part_of_speech: "",
    meaning:
      "(cũ) tự coi mình có quyền chi phối trong một vùng, một khoảnh, không chịu phục tùng một quyền lực nào: xưng hùng xưng bá một phương",
    example: "xưng hùng xưng bá một phương",
  },
  {
    word: "xược",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) thiếu lễ phép, tỏ ra coi thường và xúc phạm người trên: nói xược * con bé xược lắm, không chút lễ phép gì!",
    example: "nói xược * con bé xược lắm, không chút lễ phép gì!",
  },
  {
    word: "xược",
    part_of_speech: "tính từ",
    meaning:
      "gầy, tựa như nhìn thấy xương: khuôn mặt xương * bàn tay xương * người gầy và xương",
    example: "khuôn mặt xương * bàn tay xương * người gầy và xương",
  },
  {
    word: "xược",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) khó làm và ít lợi lộc: việc này xương lắm, chẳng ai muốn nhận",
    example: "việc này xương lắm, chẳng ai muốn nhận",
  },
  {
    word: "xửng vửng",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) choáng váng vì một tác động mạnh mẽ bất ngờ: cái bạt tai làm xửng vửng cả người",
    example: "cái bạt tai làm xửng vửng cả người",
  },
  {
    word: "xước măng rô",
    part_of_speech: "danh từ",
    meaning:
      "hiện tượng bị xước mẩu da hình sợi xung quanh móng tay, gây đau: tay bị xước măng rô",
    example: "tay bị xước măng rô",
  },
  {
    word: "xương",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận cứng và chắc làm thành bộ khung của cơ thể người và động vật: xương cá * bị ngã gẫy xương * người gầy, chỉ còn da bọc xương",
    example: "xương cá * bị ngã gẫy xương * người gầy, chỉ còn da bọc xương",
  },
  {
    word: "xương",
    part_of_speech: "danh từ",
    meaning: "phần cứng làm sườn trong một số vật: xương quạt",
    example: "xương quạt",
  },
  {
    word: "xước",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) tước: dùng răng xước vỏ mía",
    example: "dùng răng xước vỏ mía",
  },
  {
    word: "xước",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) lật hai đầu mối khăn cho vểnh ngược lên ở phía trước đầu (một lối quấn khăn ở Nam Bộ): xước khăn đầu rìu",
    example: "xước khăn đầu rìu",
  },
  {
    word: "xước",
    part_of_speech: "tính từ",
    meaning:
      "có vệt nhỏ trên bề mặt, do bị vật nhỏ, sắc quệt vào: gai cào xước da * đĩa CD bị xước nhiều nên khó xem",
    example: "gai cào xước da * đĩa CD bị xước nhiều nên khó xem",
  },
  {
    word: "xướng",
    part_of_speech: "động từ",
    meaning:
      "hô to lên từng tên, từng mục để mọi người nghe rõ: xướng danh * xướng tên gọi từng người vào một",
    example: "xướng danh * xướng tên gọi từng người vào một",
  },
  {
    word: "xướng",
    part_of_speech: "động từ",
    meaning:
      "(cũ, hoặc kng) nêu ra, đề ra trước tiên: xướng ra một dòng thơ mới * xướng lên việc đi tham quan",
    example: "xướng ra một dòng thơ mới * xướng lên việc đi tham quan",
  },
  {
    word: "xướng",
    part_of_speech: "động từ",
    meaning:
      "hoặc d đọc to giọng, rõ âm và ngân nga ở những chỗ cần thiết: diễn viên tuồng xướng mấy câu thơ",
    example: "diễn viên tuồng xướng mấy câu thơ",
  },
  {
    word: "xướng âm",
    part_of_speech: "động từ",
    meaning:
      "đọc tên các nốt nhạc theo đúng độ cao, độ dài, độ mạnh quy định cho mỗi bậc cung trong một gam: lấy giọng tập xướng âm",
    example: "lấy giọng tập xướng âm",
  },
  {
    word: "xướng ca",
    part_of_speech: "động từ",
    meaning: "(cũ) ca hát: đàn hát xướng ca",
    example: "đàn hát xướng ca",
  },
  {
    word: "xưởng",
    part_of_speech: "danh từ",
    meaning:
      "cơ sở sản xuất hay sửa chữa công nghiệp hoặc thủ công nghiệp, có quy mô nhỏ hơn xí nghiệp: xưởng may * xưởng mộc * xưởng sửa chữa cơ khí",
    example: "xưởng may * xưởng mộc * xưởng sửa chữa cơ khí",
  },
  {
    word: "xưởng",
    part_of_speech: "danh từ",
    meaning: "nơi làm việc của hoạ sĩ hoặc nhà điêu khắc: xưởng vẽ * xưởng hoạ",
    example: "xưởng vẽ * xưởng hoạ",
  },
  {
    word: "xương cốt",
    part_of_speech: "danh từ",
    meaning: "xương (nói khái quát): già rồi nhưng xương cốt còn rắn chắc",
    example: "già rồi nhưng xương cốt còn rắn chắc",
  },
  {
    word: "xương chậu",
    part_of_speech: "danh từ",
    meaning: "phần xương của đai hông: ngã bị giập xương chậu",
    example: "ngã bị giập xương chậu",
  },
  {
    word: "xướng hoạ",
    part_of_speech: "động từ",
    meaning:
      "đối đáp với nhau bằng những bài thơ cùng một thể, một vần, để tỏ sự đồng tình hay chống đối: xướng hoạ văn thơ * cùng nhau xướng hoạ",
    example: "xướng hoạ văn thơ * cùng nhau xướng hoạ",
  },
  {
    word: "xương mai",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) ví dáng vóc gầy guộc (tựa như cành mai khẳng khiu): "Xương mai một nắm hao gầy, Tóc mây một mái đã đầy tuyết sương." (TĐà; 7)',
    example:
      'Xương mai một nắm hao gầy, Tóc mây một mái đã đầy tuyết sương." (TĐà; 7)',
  },
  {
    word: "xương máu",
    part_of_speech: "danh từ",
    meaning:
      "xương và máu, cái tạo nên mạng sống của con người (nói khái quát; thường nói khi phải hi sinh): hi sinh xương máu * bài học xương máu",
    example: "hi sinh xương máu * bài học xương máu",
  },
  {
    word: "xương sống",
    part_of_speech: "danh từ",
    meaning:
      "xương gồm nhiều đốt, nằm dọc lưng động vật có xương sống, làm trụ cột cho cơ thể động vật: đốt xương sống * bị vẹo xương sống",
    example: "đốt xương sống * bị vẹo xương sống",
  },
  {
    word: "xương xẩu",
    part_of_speech: "danh từ",
    meaning:
      "xương của thú vật hoặc phần xương còn lại sau khi đã ăn hết thịt (nói khái quát): con bò gầy, xương xẩu nhô ra * xương xẩu bỏ đầy ra mâm",
    example: "con bò gầy, xương xẩu nhô ra * xương xẩu bỏ đầy ra mâm",
  },
  {
    word: "xương xẩu",
    part_of_speech: "danh từ",
    meaning:
      "ví cái người khác đã vứt bỏ, chẳng mang lại lợi lộc bao nhiêu: ruộng ngon đã chia hết, chỉ còn toàn xương xẩu",
    example: "ruộng ngon đã chia hết, chỉ còn toàn xương xẩu",
  },
  {
    word: "xương xẩu",
    part_of_speech: "tính từ",
    meaning: "gầy đến nhô xương, nổi xương lên: khuôn mặt xương xẩu",
    example: "khuôn mặt xương xẩu",
  },
  {
    word: "ý",
    part_of_speech: "danh từ",
    meaning:
      "điều suy nghĩ, ý nghĩ (nói khái quát): nói chưa hết ý * nảy ra một ý hay",
    example: "nói chưa hết ý * nảy ra một ý hay",
  },
  {
    word: "ý",
    part_of_speech: "danh từ",
    meaning:
      "nội dung những gì đã được nói ra bằng lời: lời hay ý đẹp * bài văn chưa đủ ý * vạch ra những ý chính",
    example: "lời hay ý đẹp * bài văn chưa đủ ý * vạch ra những ý chính",
  },
  {
    word: "ý",
    part_of_speech: "danh từ",
    meaning:
      "ý kiến về việc gì (nói khái quát): theo ý tôi thì không nên * ý chị định thế nào?",
    example: "theo ý tôi thì không nên * ý chị định thế nào?",
  },
  {
    word: "ý",
    part_of_speech: "danh từ",
    meaning:
      "ý muốn hoặc ý định, thường không biểu hiện ra: thăm dò ý bạn * có ý trêu chọc * chỉ là lời nói chơi chứ không có ý gì",
    example:
      "thăm dò ý bạn * có ý trêu chọc * chỉ là lời nói chơi chứ không có ý gì",
  },
  {
    word: "ý",
    part_of_speech: "danh từ",
    meaning: "ý tứ (nói tắt): đi đứng phải có ý chứ! * giữ ý khi nói năng",
    example: "đi đứng phải có ý chứ! * giữ ý khi nói năng",
  },
  {
    word: "ý",
    part_of_speech: "danh từ",
    meaning: "(Khẩu ngữ) tình ý (nói tắt): hai người có ý với nhau",
    example: "hai người có ý với nhau",
  },
  {
    word: "ý",
    part_of_speech: "danh từ",
    meaning:
      "những dấu hiệu biểu hiện ra bên ngoài cho thấy được ý nghĩ, ý định, tình cảm: nét mặt có ý không vui * cái nguýt tỏ ý hờn giận",
    example: "nét mặt có ý không vui * cái nguýt tỏ ý hờn giận",
  },
  {
    word: "xương xương",
    part_of_speech: "tính từ",
    meaning: "hơi gầy, trông như chỉ thấy xương: khuôn mặt xương xương",
    example: "khuôn mặt xương xương",
  },
  {
    word: "ỷ",
    part_of_speech: "động từ",
    meaning:
      'dựa vào ưu thế hay lí do nào đó của mình để làm điều lẽ ra không nên làm: ỷ thế làm càn * "Trăng kia chớ ỷ mình tròn, Ba mươi mồng một trăng lòn dưới mây." (ca dao)',
    example:
      'ỷ thế làm càn * "Trăng kia chớ ỷ mình tròn, Ba mươi mồng một trăng lòn dưới mây." (ca dao)',
  },
  {
    word: "xương tuỷ",
    part_of_speech: "danh từ",
    meaning:
      "xương và tuỷ (nói khái quát); thường dùng để chỉ phần sâu nhất bên trong của con người: bóc lột đến tận xương tuỷ * thói quen đã ăn sâu vào xương tuỷ",
    example: "bóc lột đến tận xương tuỷ * thói quen đã ăn sâu vào xương tuỷ",
  },
  {
    word: "y bạ",
    part_of_speech: "danh từ",
    meaning: "sổ theo dõi sức khoẻ và tình hình bệnh tật của cá nhân: sổ y bạ",
    example: "sổ y bạ",
  },
  {
    word: "y",
    part_of_speech: "danh từ",
    meaning:
      "y học, y khoa hoặc y tế (nói tắt): ngành y * đại học y * sinh viên trường y",
    example: "ngành y * đại học y * sinh viên trường y",
  },
  {
    word: "y",
    part_of_speech: "đại từ",
    meaning:
      "từ dùng để chỉ người (thường là đàn ông) ở ngôi thứ ba với hàm ý ít nhiều coi thường: chẳng ai biết y từ đâu đến",
    example: "chẳng ai biết y từ đâu đến",
  },
  {
    word: "y",
    part_of_speech: "tính từ",
    meaning:
      "đúng như vậy, không sai, không có thay đổi gì cả: sao y bản chính * mọi chuyện vẫn y như cũ * y lệnh mà làm",
    example: "sao y bản chính * mọi chuyện vẫn y như cũ * y lệnh mà làm",
  },
  {
    word: "ý chừng",
    part_of_speech: "phụ từ",
    meaning:
      "tổ hợp biểu thị ý phỏng đoán về người nào đó, trên cơ sở căn cứ vào những điều đã nhận thấy, đã quan sát được: không nói gì, ý chừng bằng lòng",
    example: "không nói gì, ý chừng bằng lòng",
  },
  {
    word: "ý chí",
    part_of_speech: "danh từ",
    meaning:
      "khả năng tự xác định mục đích cho hành động và quyết tâm đạt cho được mục đích đó: giữ vững ý chí chiến đấu * một con người có ý chí",
    example: "giữ vững ý chí chiến đấu * một con người có ý chí",
  },
  {
    word: "y án",
    part_of_speech: "động từ",
    meaning:
      "(toà án cấp trên) đồng ý với án do toà án cấp dưới đã xử: toà phúc thẩm xử y án sơ thẩm * quyết định y án tử hình",
    example: "toà phúc thẩm xử y án sơ thẩm * quyết định y án tử hình",
  },
  {
    word: "y chang",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ, khẩu ngữ) như y hệt: giống y chang * đồ đạc trong nhà vẫn y chang ngày trước",
    example: "giống y chang * đồ đạc trong nhà vẫn y chang ngày trước",
  },
  {
    word: "y cụ",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ dùng để khám và chữa bệnh; dụng cụ y tế: y cụ, thuốc men được trang bị đầy đủ",
    example: "y cụ, thuốc men được trang bị đầy đủ",
  },
  {
    word: "ý định",
    part_of_speech: "danh từ",
    meaning:
      "ý muốn cụ thể làm việc gì đó: từ bỏ ý định * quyết tâm thực hiện ý định",
    example: "từ bỏ ý định * quyết tâm thực hiện ý định",
  },
  {
    word: "y hệt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) giống hoàn toàn như cái có sẵn nào đó, đến mức tưởng như là một: giống nhau y hệt * quần áo y hệt nhau * cô ta vẫn y hệt ngày xưa",
    example: "giống nhau y hệt * quần áo y hệt nhau * cô ta vẫn y hệt ngày xưa",
  },
  {
    word: "ỷ lại",
    part_of_speech: "động từ",
    meaning:
      "dựa vào công sức của người khác một cách quá đáng, tự bản thân không chịu cố gắng: không chịu cố gắng, chỉ ỷ lại vào cha mẹ * có tính ỷ lại",
    example: "không chịu cố gắng, chỉ ỷ lại vào cha mẹ * có tính ỷ lại",
  },
  {
    word: "y giới",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) giới những người làm nghề chữa bệnh: một nhân tài trong y giới",
    example: "một nhân tài trong y giới",
  },
  {
    word: "ý hợp tâm đầu",
    part_of_speech: "",
    meaning:
      'như tâm đầu ý hợp: "Hai bên ý hợp, tâm đầu, Khi thân, chẳng lọ là cầu mới thân!" (TKiều)',
    example:
      'Hai bên ý hợp, tâm đầu, Khi thân, chẳng lọ là cầu mới thân!" (TKiều)',
  },
  {
    word: "y đức",
    part_of_speech: "danh từ",
    meaning: "đạo đức của người thầy thuốc: giữ gìn y đức",
    example: "giữ gìn y đức",
  },
  {
    word: "ý đồ",
    part_of_speech: "danh từ",
    meaning:
      "ý muốn thực hiện việc gì đó, có tính toán kĩ và kín đáo: ý đồ nghệ thuật * hiểu được ý đồ của đối phương",
    example: "ý đồ nghệ thuật * hiểu được ý đồ của đối phương",
  },
  {
    word: "ý kiến",
    part_of_speech: "danh từ",
    meaning:
      "cách nhìn, cách nghĩ, cách đánh giá riêng của mỗi người về sự vật, sự việc, về một vấn đề nào đó: hỏi ý kiến bạn bè * phát biểu ý kiến * góp ý kiến xây dựng",
    example: "hỏi ý kiến bạn bè * phát biểu ý kiến * góp ý kiến xây dựng",
  },
  {
    word: "ý kiến",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) lời phát biểu có tính chất nhận xét, phê bình: phải có ý kiến với anh ta",
    example: "phải có ý kiến với anh ta",
  },
  {
    word: "y học",
    part_of_speech: "danh từ",
    meaning:
      "khoa học nghiên cứu về bệnh lí, cách phòng và chữa bệnh: sách y học * y học cổ truyền",
    example: "sách y học * y học cổ truyền",
  },
  {
    word: "y khoa",
    part_of_speech: "danh từ",
    meaning: "như y học: sinh viên y khoa * giám định y khoa",
    example: "sinh viên y khoa * giám định y khoa",
  },
  {
    word: "y lệnh",
    part_of_speech: "danh từ",
    meaning: "lệnh điều trị của bác sĩ: điều trị theo đúng y lệnh",
    example: "điều trị theo đúng y lệnh",
  },
  {
    word: "y lí",
    part_of_speech: "danh từ",
    meaning:
      "lí luận của y học, gồm các quan niệm về bệnh tật và về cách phòng, chữa bệnh: am hiểu y lí * giỏi về y lí",
    example: "am hiểu y lí * giỏi về y lí",
  },
  {
    word: "y nguyên",
    part_of_speech: "tính từ",
    meaning:
      "nguyên như thế, hoàn toàn không thấy có thay đổi gì: đồ đạc vẫn y nguyên * thuật lại y nguyên câu chuyện",
    example: "đồ đạc vẫn y nguyên * thuật lại y nguyên câu chuyện",
  },
  {
    word: "y lý",
    part_of_speech: "danh từ",
    meaning:
      "lí luận của y học, gồm các quan niệm về bệnh tật và về cách phòng, chữa bệnh: am hiểu y lí * giỏi về y lí",
    example: "am hiểu y lí * giỏi về y lí",
  },
  {
    word: "ý nghĩ",
    part_of_speech: "danh từ",
    meaning:
      "điều nảy sinh do kết quả hoạt động của trí tuệ: đoán được ý nghĩ của bạn * mỗi người theo đuổi một ý nghĩ riêng",
    example: "đoán được ý nghĩ của bạn * mỗi người theo đuổi một ý nghĩ riêng",
  },
  {
    word: "y môn",
    part_of_speech: "danh từ",
    meaning:
      "màn vải hoặc gỗ chạm khắc che phía trên giữa hai hàng cột ở nơi thờ cúng: dải y môn",
    example: "dải y môn",
  },
  {
    word: "ý nguyện",
    part_of_speech: "danh từ",
    meaning: "điều mong muốn tha thiết: ý nguyện hoà bình * đạt được ý nguyện",
    example: "ý nguyện hoà bình * đạt được ý nguyện",
  },
  {
    word: "ý nghĩa",
    part_of_speech: "danh từ",
    meaning:
      "nội dung chứa đựng trong một hình thức biểu hiện bằng ngôn ngữ, văn tự hoặc bằng một kí hiệu nào đó: bài thơ có ý nghĩa châm biếm * lời nói hàm nhiều ý nghĩa",
    example: "bài thơ có ý nghĩa châm biếm * lời nói hàm nhiều ý nghĩa",
  },
  {
    word: "ý nghĩa",
    part_of_speech: "danh từ",
    meaning:
      "giá trị, tác dụng: chiến thắng có ý nghĩa quyết định * việc đó chẳng có ý nghĩa gì đối với tôi",
    example:
      "chiến thắng có ý nghĩa quyết định * việc đó chẳng có ý nghĩa gì đối với tôi",
  },
  {
    word: "ý nhị",
    part_of_speech: "tính từ",
    meaning:
      "(lời nói, cử chỉ) có nhiều ý nghĩa, nhưng kín đáo, tế nhị: mỉm cười ý nhị * câu nói ý nhị",
    example: "mỉm cười ý nhị * câu nói ý nhị",
  },
  {
    word: "ý muốn",
    part_of_speech: "danh từ",
    meaning:
      "điều mong muốn sẽ thực hiện được: làm theo ý muốn của cha mẹ * sinh con ngoài ý muốn",
    example: "làm theo ý muốn của cha mẹ * sinh con ngoài ý muốn",
  },
  {
    word: "y như",
    part_of_speech: "tính từ",
    meaning: "giống hệt như: nói y như thật * hai cha con giống y như nhau",
    example: "nói y như thật * hai cha con giống y như nhau",
  },
  {
    word: "y như",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị điều sắp nêu ra là điều xảy ra nhiều lần, lần nào cũng giống như lần nào: cứ giao việc cho nó là y như hỏng",
    example: "cứ giao việc cho nó là y như hỏng",
  },
  {
    word: "y như rằng",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) như y như (ng2): hễ về đến nhà là y như rằng quát tháo, la lối",
    example: "hễ về đến nhà là y như rằng quát tháo, la lối",
  },
  {
    word: "y như rằng",
    part_of_speech: "",
    meaning:
      "tổ hợp biểu thị điều xảy ra là đúng như đã nói hoặc đã đoán biết từ trước: đã bảo cho vào tủ lạnh kẻo hỏng, y như rằng",
    example: "đã bảo cho vào tủ lạnh kẻo hỏng, y như rằng",
  },
  {
    word: "ý niệm",
    part_of_speech: "danh từ",
    meaning:
      "sự hiểu biết, nhận thức bước đầu về một sự vật, sự việc hay quan hệ, quá trình nào đó: ý niệm về sự vật * ý niệm về không gian, thời gian",
    example: "ý niệm về sự vật * ý niệm về không gian, thời gian",
  },
  {
    word: "y phục",
    part_of_speech: "danh từ",
    meaning:
      "(trang trọng) quần áo, đồ mặc (nói khái quát): y phục dạ hội * chỉnh đốn lại y phục",
    example: "y phục dạ hội * chỉnh đốn lại y phục",
  },
  {
    word: "y sì",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như y hệt: giảng y sì như trong sách",
    example: "giảng y sì như trong sách",
  },
  {
    word: "y thuật",
    part_of_speech: "danh từ",
    meaning:
      "thuật chữa bệnh, phương pháp chữa bệnh; cũng dùng để chỉ tài năng của người thầy thuốc: y thuật Trung Quốc * y thuật uyên thâm",
    example: "y thuật Trung Quốc * y thuật uyên thâm",
  },
  {
    word: "y sinh",
    part_of_speech: "danh từ",
    meaning:
      "người đang học trường y khoa: y sinh thực tập được tham gia vào ca mổ",
    example: "y sinh thực tập được tham gia vào ca mổ",
  },
  {
    word: "y tế",
    part_of_speech: "danh từ",
    meaning:
      "ngành y học ứng dụng, chuyên việc phòng, chữa bệnh và bảo vệ sức khoẻ: trạm y tế xã * nhân viên y tế * thiết bị y tế",
    example: "trạm y tế xã * nhân viên y tế * thiết bị y tế",
  },
  {
    word: "ý thức hệ",
    part_of_speech: "danh từ",
    meaning: "(cũ) hệ tư tưởng: ý thức hệ phong kiến",
    example: "ý thức hệ phong kiến",
  },
  {
    word: "ý thức",
    part_of_speech: "danh từ",
    meaning:
      "khả năng của con người phản ánh và tái hiện hiện thực vào trong tư duy: mối quan hệ giữa vật chất và ý thức",
    example: "mối quan hệ giữa vật chất và ý thức",
  },
  {
    word: "ý thức",
    part_of_speech: "danh từ",
    meaning:
      "sự nhận thức trực tiếp, tức thời về hoạt động tâm lí của bản thân; sự nhận thức rõ ràng về việc mình đang làm, đang nghĩ: hành động có ý thức * không có ý thức về thời gian",
    example: "hành động có ý thức * không có ý thức về thời gian",
  },
  {
    word: "ý thức",
    part_of_speech: "danh từ",
    meaning:
      "sự nhận thức đúng đắn, biểu hiện bằng thái độ, hành động cần phải có: ý thức kỉ luật * thiếu ý thức trách nhiệm * cư xử rất có ý thức",
    example: "ý thức kỉ luật * thiếu ý thức trách nhiệm * cư xử rất có ý thức",
  },
  {
    word: "ý thức",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) có nhận thức đúng đắn, biểu hiện bằng thái độ, hành động cần phải có: ý thức được việc làm của mình",
    example: "ý thức được việc làm của mình",
  },
  {
    word: "y trang",
    part_of_speech: "danh từ",
    meaning: "quần áo và tư trang (nói khái quát): sắm sửa y trang",
    example: "sắm sửa y trang",
  },
  {
    word: "ý tứ",
    part_of_speech: "danh từ",
    meaning:
      "những suy nghĩ sâu lắng được gửi gắm trong lời nói, bài viết (nói tổng quát): bài thơ ngắn gọn, ý tứ sâu sắc",
    example: "bài thơ ngắn gọn, ý tứ sâu sắc",
  },
  {
    word: "ý tứ",
    part_of_speech: "danh từ",
    meaning:
      'ý định kín đáo, không nói ra: dò la ý tứ * "Chàng về xem ý tứ nhà, Sự mình cũng rắp lân la giải bày." (TKiều)',
    example:
      'dò la ý tứ * "Chàng về xem ý tứ nhà, Sự mình cũng rắp lân la giải bày." (TKiều)',
  },
  {
    word: "ý tứ",
    part_of_speech: "danh từ",
    meaning:
      "sự cẩn thận trong cử chỉ, lời nói, tránh những sơ suất làm cho người khác hiểu lầm: giữ gìn ý tứ * ăn nói có ý tứ * đi đứng thiếu ý tứ",
    example: "giữ gìn ý tứ * ăn nói có ý tứ * đi đứng thiếu ý tứ",
  },
  {
    word: "ý tứ",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) cẩn trọng trong cử chỉ, lời nói, tránh những sơ suất: nói năng thoải mái, không phải ý tứ",
    example: "nói năng thoải mái, không phải ý tứ",
  },
  {
    word: "y vụ",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận quản lí, điều hành công việc chuyên môn theo chế độ, quy chế trong bệnh viện: phòng y vụ",
    example: "phòng y vụ",
  },
  {
    word: "ý vị",
    part_of_speech: "danh từ",
    meaning:
      "ý hay, gợi cảm xúc hoặc gây được hứng thú: câu thơ đậm đà ý vị * bài thơ có ý vị thanh cao",
    example: "câu thơ đậm đà ý vị * bài thơ có ý vị thanh cao",
  },
  {
    word: "ý vị",
    part_of_speech: "tính từ",
    meaning:
      "có ý nghĩa, gợi cảm xúc, gây được hứng thú: câu nói ý vị * nói thẳng ra thì còn gì là ý vị",
    example: "câu nói ý vị * nói thẳng ra thì còn gì là ý vị",
  },
  {
    word: "ý tưởng",
    part_of_speech: "danh từ",
    meaning:
      "điều nảy ra, nghĩ ra trong đầu, thường chưa được trọn vẹn: triển khai ý tưởng * ý tưởng quá cao siêu",
    example: "triển khai ý tưởng * ý tưởng quá cao siêu",
  },
  {
    word: "ý trung nhân",
    part_of_speech: "danh từ",
    meaning: "(cũ, văn chương) người yêu: chưa có ý trung nhân",
    example: "chưa có ý trung nhân",
  },
  {
    word: "yếm",
    part_of_speech: "danh từ",
    meaning:
      "phần vỏ cứng che bụng dưới lớp mai của một số loài vật: yếm rùa * bóc yếm cua",
    example: "yếm rùa * bóc yếm cua",
  },
  {
    word: "yếm",
    part_of_speech: "danh từ",
    meaning: "phần da trễ xuống thành tấm mỏng chạy dọc trước ngực của bò.",
    example:
      'dải yếm * "Hỡi cô yếm trắng loà loà, Yếm nhiễu, yếm vóc hay là trúc bâu?" (ca dao)',
  },
  {
    word: "yếm",
    part_of_speech: "danh từ",
    meaning:
      'đồ mặc lót che ngực của phụ nữ thời trước: dải yếm * "Hỡi cô yếm trắng loà loà, Yếm nhiễu, yếm vóc hay là trúc bâu?" (ca dao)',
    example: "cho bé mặc yếm",
  },
  {
    word: "yểm hộ",
    part_of_speech: "động từ",
    meaning:
      "dùng hoả lực bảo vệ, che chở cho người khác hành động: bắn yểm hộ * pháo binh yểm hộ cho bộ binh",
    example: "bắn yểm hộ * pháo binh yểm hộ cho bộ binh",
  },
  {
    word: "yểm",
    part_of_speech: "động từ",
    meaning:
      "chôn, dán hay giấu bùa chú để trấn, trừ ma quỷ, theo mê tín: yểm bùa",
    example: "yểm bùa",
  },
  {
    word: "yếm dãi",
    part_of_speech: "danh từ",
    meaning:
      "phần vỏ cứng che bụng dưới lớp mai của một số loài vật: yếm rùa * bóc yếm cua",
    example: "yếm rùa * bóc yếm cua",
  },
  {
    word: "yếm dãi",
    part_of_speech: "danh từ",
    meaning: "phần da trễ xuống thành tấm mỏng chạy dọc trước ngực của bò.",
    example:
      'dải yếm * "Hỡi cô yếm trắng loà loà, Yếm nhiễu, yếm vóc hay là trúc bâu?" (ca dao)',
  },
  {
    word: "yếm dãi",
    part_of_speech: "danh từ",
    meaning:
      'đồ mặc lót che ngực của phụ nữ thời trước: dải yếm * "Hỡi cô yếm trắng loà loà, Yếm nhiễu, yếm vóc hay là trúc bâu?" (ca dao)',
    example: "cho bé mặc yếm",
  },
  {
    word: "yếm thế",
    part_of_speech: "tính từ",
    meaning: "có tư tưởng chán đời: tư tưởng yếm thế * nhà nho yếm thế",
    example: "tư tưởng yếm thế * nhà nho yếm thế",
  },
  {
    word: "yếm khí",
    part_of_speech: "tính từ",
    meaning:
      "(sinh vật hoặc quá trình sinh học) chỉ sống và hoạt động, tác động được trong môi trường không có không khí; phân biệt với háo khí: sinh vật yếm khí * xử lí rác bằng công nghệ ủ yếm khí",
    example: "sinh vật yếm khí * xử lí rác bằng công nghệ ủ yếm khí",
  },
  {
    word: "yên ắng",
    part_of_speech: "tính từ",
    meaning:
      "yên lặng hoàn toàn, không một chút ồn ào, xáo động: đêm khuya yên ắng * chiến trường yên ắng, không một tiếng súng",
    example: "đêm khuya yên ắng * chiến trường yên ắng, không một tiếng súng",
  },
  {
    word: "yên ả",
    part_of_speech: "tính từ",
    meaning:
      "(cảnh vật) yên tĩnh, gây cảm giác thanh bình, dễ chịu: trưa hè yên ả * dòng sông yên ả trôi * cuộc sống yên ả",
    example: "trưa hè yên ả * dòng sông yên ả trôi * cuộc sống yên ả",
  },
  {
    word: "yến",
    part_of_speech: "danh từ",
    meaning:
      "chim biển cỡ nhỏ, cùng họ với én, cánh dài và nhọn, làm tổ bằng nước bọt ở vách đá cao.",
    example: "ăn yến * vua ban yến",
  },
  {
    word: "yến",
    part_of_speech: "danh từ",
    meaning:
      "chim cùng họ với sẻ, cỡ nhỏ, màu vàng, trắng hay xanh, hót hay, nuôi làm cảnh.",
    example: "một yến thịt * đong mấy yến gạo",
  },
  {
    word: "yên",
    part_of_speech: "danh từ",
    meaning:
      "mảnh da uốn cong đặt trên lưng ngựa, làm chỗ ngồi cho người cưỡi ngựa: ngồi trên yên ngựa",
    example: "ngồi trên yên ngựa",
  },
  {
    word: "yên",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận bọc da, thường có đệm lò xo, gắn trên các loại xe hai, ba bánh làm chỗ ngồi cho người đi xe: yên xe đạp",
    example: "yên xe đạp",
  },
  {
    word: "yên",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái không động đậy, xê xích hoặc thay đổi vị trí, tư thế: ngồi yên * nằm yên không động đậy * đồ đạc vẫn yên một chỗ",
    example: "ngồi yên * nằm yên không động đậy * đồ đạc vẫn yên một chỗ",
  },
  {
    word: "yên",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái ổn định, không có biến động, xáo trộn, rắc rối: biển lặng sóng yên * tình hình đã yên * để yên cho nó nói",
    example: "biển lặng sóng yên * tình hình đã yên * để yên cho nó nói",
  },
  {
    word: "yên ấm",
    part_of_speech: "tính từ",
    meaning: "như êm ấm: gia đình yên ấm",
    example: "gia đình yên ấm",
  },
  {
    word: "yên bình",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như thanh bình: cuộc sống đã trở lại yên bình",
    example: "cuộc sống đã trở lại yên bình",
  },
  {
    word: "yến anh",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) ví cảnh trai gái dập dìu, tấp nập: "Gần xa nô nức yến anh, Chị em sắm sửa bộ hành chơi xuân." (TKiều)',
    example:
      'Gần xa nô nức yến anh, Chị em sắm sửa bộ hành chơi xuân." (TKiều)',
  },
  {
    word: "yến anh",
    part_of_speech: "danh từ",
    meaning: "ví quan hệ trai gái tự do, phóng túng: chán chường yến anh",
    example: "chán chường yến anh",
  },
  {
    word: "yên giấc nghìn thu",
    part_of_speech: "",
    meaning:
      "(cũ, vch, trang trọng) chết (ví như một giấc ngủ dài mãi mãi): ông cụ đã yên giấc nghìn thu",
    example: "ông cụ đã yên giấc nghìn thu",
  },
  {
    word: "yên giấc",
    part_of_speech: "động từ",
    meaning:
      "ngủ yên, ngủ say, không thức tỉnh giữa chừng: em bé đang yên giấc * ngủ không yên giấc",
    example: "em bé đang yên giấc * ngủ không yên giấc",
  },
  {
    word: "yên hà",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) khói và ráng; chỉ cảnh thiên nhiên nơi núi rừng mà các nhà nho, đạo sĩ ẩn dật: "Nghêu ngao vui thú yên hà, Mai là bạn cũ hạc là người quen." (ca dao)',
    example:
      'Nghêu ngao vui thú yên hà, Mai là bạn cũ hạc là người quen." (ca dao)',
  },
  {
    word: "yên hàn",
    part_of_speech: "tính từ",
    meaning:
      "(cũ) yên ổn, hoà bình, không có chiến tranh, loạn lạc: đất nước yên hàn",
    example: "đất nước yên hàn",
  },
  {
    word: "yên nghỉ",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) (người chết) được chôn cất, coi như ngủ yên vĩnh viễn: về nơi yên nghỉ cuối cùng",
    example: "về nơi yên nghỉ cuối cùng",
  },
  {
    word: "yên lành",
    part_of_speech: "tính từ",
    meaning:
      "yên ổn, không xảy ra điều gì chẳng lành: giấc ngủ yên lành * cuộc sống yên lành",
    example: "giấc ngủ yên lành * cuộc sống yên lành",
  },
  {
    word: "yên ổn",
    part_of_speech: "tính từ",
    meaning:
      "bình yên, ổn định, không có rối loạn trật tự, không có gì đe doạ: đời sống yên ổn * yên ổn làm ăn",
    example: "đời sống yên ổn * yên ổn làm ăn",
  },
  {
    word: "yên lặng",
    part_of_speech: "tính từ",
    meaning:
      "yên và không có tiếng động: bốn bề yên lặng * ngồi yên lặng * mặt nước trở lại yên lặng",
    example: "bốn bề yên lặng * ngồi yên lặng * mặt nước trở lại yên lặng",
  },
  {
    word: "yên lòng",
    part_of_speech: "tính từ",
    meaning:
      "(đang có điều có thể làm cho lo lắng, áy náy) có trạng thái tâm lí yên ổn, không có điều gì phải lo lắng: làm yên lòng người ra trận * yên lòng nhắm mắt",
    example: "làm yên lòng người ra trận * yên lòng nhắm mắt",
  },
  {
    word: "yên phận",
    part_of_speech: "động từ",
    meaning:
      "bằng lòng với thân phận, với những gì mình có (tuy không phải là nhiều, là tốt), không đòi hỏi gì hơn: yên phận làm ăn * tư tưởng yên phận",
    example: "yên phận làm ăn * tư tưởng yên phận",
  },
  {
    word: "yên tâm",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái tâm lí yên ổn, không có gì phải băn khoăn, lo lắng: yên tâm công tác * cứ yên tâm, rồi mọi việc sẽ ổn",
    example: "yên tâm công tác * cứ yên tâm, rồi mọi việc sẽ ổn",
  },
  {
    word: "yên tĩnh",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái không có tiếng ồn, tiếng động hoặc không bị xáo động: trưa hè yên tĩnh * mặt hồ yên tĩnh * tìm nơi yên tĩnh ngồi học",
    example: "trưa hè yên tĩnh * mặt hồ yên tĩnh * tìm nơi yên tĩnh ngồi học",
  },
  {
    word: "yến tiệc",
    part_of_speech: "danh từ",
    meaning: "(cũ) tiệc lớn (nói khái quát): mời dự yến tiệc",
    example: "mời dự yến tiệc",
  },
  {
    word: "yên thân",
    part_of_speech: "tính từ",
    meaning:
      "(đời sống riêng thường bị quấy rầy, nhũng nhiễu) có được sự yên ổn: tìm được chốn yên thân",
    example: "tìm được chốn yên thân",
  },
  {
    word: "yêng hùng",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ, hiếm) anh hùng (nói trại với dụng ý châm biếm, giễu cợt): phải như thế mới là yêng hùng * nổi máu yêng hùng",
    example: "phải như thế mới là yêng hùng * nổi máu yêng hùng",
  },
  {
    word: "yên vui",
    part_of_speech: "tính từ",
    meaning:
      "yên ổn và vui vẻ (nói khái quát): cuộc sống yên vui * tinh thần chẳng được yên vui",
    example: "cuộc sống yên vui * tinh thần chẳng được yên vui",
  },
  {
    word: "yên vị",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) ngồi yên vào chỗ: mọi người đã yên vị trong khán phòng * yên vị ở ghế giám đốc",
    example: "mọi người đã yên vị trong khán phòng * yên vị ở ghế giám đốc",
  },
  {
    word: "yên trí",
    part_of_speech: "động từ",
    meaning:
      "cảm thấy tin tưởng, thấy không có gì phải lo ngại (về ý nghĩ nào đó): thi xong, yên trí là mình sẽ đỗ * cứ yên trí, đâu khắc có đó",
    example: "thi xong, yên trí là mình sẽ đỗ * cứ yên trí, đâu khắc có đó",
  },
  {
    word: "yết hầu",
    part_of_speech: "danh từ",
    meaning:
      "đoạn ống tiêu hoá ở động vật có xương sống, nằm sau khoang miệng, trước thực quản, có lỗ thông với đường hô hấp.",
    example: "vị trí yết hầu * đánh vào yết hầu địch",
  },
  {
    word: "yết",
    part_of_speech: "động từ",
    meaning:
      "nêu nội dung cần công bố, thông báo ở nơi công cộng cho mọi người biết: yết tên lên bảng * yết danh sách cử tri",
    example: "yết tên lên bảng * yết danh sách cử tri",
  },
  {
    word: "yết kiến",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) gặp người ở cương vị cao với tư cách là khách: vào triều yết kiến đức vua * xin yết kiến ông cố vấn",
    example: "vào triều yết kiến đức vua * xin yết kiến ông cố vấn",
  },
  {
    word: "yết hậu",
    part_of_speech: "danh từ",
    meaning:
      "thể thơ thường chỉ có bốn câu, câu cuối cụt, chỉ có một hoặc hai âm tiết: thể thơ yết hậu",
    example: "thể thơ yết hậu",
  },
  {
    word: "yêu",
    part_of_speech: "danh từ",
    meaning:
      "(Ít dùng) vật tưởng tượng có hình thù kì dị, chuyên làm hại người: con yêu râu xanh * làm phép trừ yêu * yêu quái",
    example: "con yêu râu xanh * làm phép trừ yêu * yêu quái",
  },
  {
    word: "yêu",
    part_of_speech: "động từ",
    meaning:
      "có tình cảm dễ chịu khi tiếp xúc với một đối tượng nào đó, muốn gần gũi và thường sẵn sàng vì đối tượng đó mà hết lòng: yêu nước * cha mẹ yêu con * đứa bé trông thật đáng yêu",
    example: "yêu nước * cha mẹ yêu con * đứa bé trông thật đáng yêu",
  },
  {
    word: "yêu",
    part_of_speech: "động từ",
    meaning:
      "có tình cảm thắm thiết dành riêng cho một người khác giới nào đó, muốn chung sống và cùng nhau gắn bó cuộc đời: chưa yêu ai * hai người yêu nhau tha thiết * thầm yêu trộm nhớ",
    example: "chưa yêu ai * hai người yêu nhau tha thiết * thầm yêu trộm nhớ",
  },
  {
    word: "yêu",
    part_of_speech: "phụ từ",
    meaning:
      "(chê trách, đánh mắng, lườm nguýt) một cách nhẹ nhàng, nhằm biểu lộ tình cảm thương yêu, quý mến: trách yêu * tát yêu",
    example: "trách yêu * tát yêu",
  },
  {
    word: "yếu",
    part_of_speech: "tính từ",
    meaning:
      "có sức lực kém dưới mức bình thường: người yếu * tuổi già sức yếu * chân yếu, phải chống gậy",
    example: "người yếu * tuổi già sức yếu * chân yếu, phải chống gậy",
  },
  {
    word: "yếu",
    part_of_speech: "tính từ",
    meaning: "ốm (thường nói về người già): bà cụ dạo này yếu luôn",
    example: "bà cụ dạo này yếu luôn",
  },
  {
    word: "yếu",
    part_of_speech: "tính từ",
    meaning:
      "có mức độ, năng lực hoặc tác dụng ít, kém so với bình thường: cơn bão yếu dần * ánh sáng yếu * học lực yếu * đánh đúng chỗ yếu",
    example: "cơn bão yếu dần * ánh sáng yếu * học lực yếu * đánh đúng chỗ yếu",
  },
  {
    word: "yểu",
    part_of_speech: "tính từ",
    meaning: "có tuổi thọ rất ngắn: mệnh yểu",
    example: "mệnh yểu",
  },
  {
    word: "yêu chuộng",
    part_of_speech: "động từ",
    meaning:
      "yêu và tỏ ra quý hơn những cái khác: yêu chuộng hoà bình * yêu chuộng thể thao",
    example: "yêu chuộng hoà bình * yêu chuộng thể thao",
  },
  {
    word: "yêu cầu",
    part_of_speech: "động từ",
    meaning:
      "nêu ra điều gì với người nào đó, tỏ ý muốn người đó làm, vì đó là việc thuộc nhiệm vụ, trách nhiệm hoặc quyền hạn, khả năng của người ấy: yêu cầu giữ trật tự * yêu cầu toà xử lại vụ án",
    example: "yêu cầu giữ trật tự * yêu cầu toà xử lại vụ án",
  },
  {
    word: "yêu cầu",
    part_of_speech: "danh từ",
    meaning:
      "điều cần phải đạt được trong một việc nào đó: bài làm chưa đúng với yêu cầu của đề thi * sản phẩm đạt yêu cầu",
    example: "bài làm chưa đúng với yêu cầu của đề thi * sản phẩm đạt yêu cầu",
  },
  {
    word: "yết thị",
    part_of_speech: "động từ",
    meaning:
      "(cũ) dán giấy công bố ở nơi công cộng để thông báo cho mọi người biết: yết thị danh sách thí sinh trúng tuyển",
    example: "yết thị danh sách thí sinh trúng tuyển",
  },
  {
    word: "yết thị",
    part_of_speech: "danh từ",
    meaning: "(cũ) bản thông báo được niêm yết: tờ yết thị * dán yết thị",
    example: "tờ yết thị * dán yết thị",
  },
  {
    word: "yêu dấu",
    part_of_speech: "động từ",
    meaning:
      "(văn chương) yêu tha thiết trong lòng: quê hương yêu dấu * đem lòng yêu dấu",
    example: "quê hương yêu dấu * đem lòng yêu dấu",
  },
  {
    word: "yêu chiều",
    part_of_speech: "động từ",
    meaning: "yêu thương và chiều chuộng: được bố mẹ yêu chiều",
    example: "được bố mẹ yêu chiều",
  },
  {
    word: "yêu đào",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) cây đào non mới nở hoa; dùng để ví người con gái đẹp: "Vẻ chi một đoá yêu đào, Vườn hồng chi dám ngăn rào chim xanh." (TKiều)',
    example:
      'Vẻ chi một đoá yêu đào, Vườn hồng chi dám ngăn rào chim xanh." (TKiều)',
  },
  {
    word: "yếu địa",
    part_of_speech: "danh từ",
    meaning: "khu vực đặc biệt quan trọng: chiếm được yếu địa của địch",
    example: "chiếm được yếu địa của địch",
  },
  {
    word: "yểu điệu",
    part_of_speech: "tính từ",
    meaning:
      '(người phụ nữ) có dáng người mềm mại, thướt tha: "Người yểu điệu, kẻ văn chương, Trai tài, gái sắc, xuân đương vừa thì." (TKiều)',
    example:
      'Người yểu điệu, kẻ văn chương, Trai tài, gái sắc, xuân đương vừa thì." (TKiều)',
  },
  {
    word: "yếu điểm",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) điểm quan trọng nhất: bảo vệ yếu điểm quân sự * yếu điểm của vấn đề",
    example: "bảo vệ yếu điểm quân sự * yếu điểm của vấn đề",
  },
  {
    word: "yêu đời",
    part_of_speech: "động từ",
    meaning:
      "luôn lạc quan, vui vẻ và tin tưởng vào cuộc sống: tâm hồn lạc quan, yêu đời",
    example: "tâm hồn lạc quan, yêu đời",
  },
  {
    word: "yếu đuối",
    part_of_speech: "tính từ",
    meaning:
      "thiếu hẳn sức mạnh thể chất hoặc tinh thần, khó có thể chịu đựng được khó khăn, thử thách: thể chất yếu đuối * tình cảm yếu đuối",
    example: "thể chất yếu đuối * tình cảm yếu đuối",
  },
  {
    word: "yêu đương",
    part_of_speech: "động từ",
    meaning:
      "yêu nhau giữa nam nữ (nói khái quát): chuyện yêu đương * quan hệ yêu đương * tự do yêu đương",
    example: "chuyện yêu đương * quan hệ yêu đương * tự do yêu đương",
  },
  {
    word: "yếu hèn",
    part_of_speech: "tính từ",
    meaning: "như hèn yếu: thân phận yếu hèn",
    example: "thân phận yếu hèn",
  },
  {
    word: "yêu kiều",
    part_of_speech: "tính từ",
    meaning:
      "có vẻ đẹp thướt tha, mềm mại: bóng dáng yêu kiều của người thiếu nữ",
    example: "bóng dáng yêu kiều của người thiếu nữ",
  },
  {
    word: "yếu lĩnh",
    part_of_speech: "danh từ",
    meaning:
      "điểm mấu chốt của toàn bộ động tác kĩ thuật: nắm vững yếu lĩnh bắn súng",
    example: "nắm vững yếu lĩnh bắn súng",
  },
  {
    word: "yếu kém",
    part_of_speech: "tính từ",
    meaning:
      "yếu hẳn so với mức bình thường, có nhiều nhược điểm: trình độ yếu kém * yếu kém về công tác quản lí",
    example: "trình độ yếu kém * yếu kém về công tác quản lí",
  },
  {
    word: "yếu lược",
    part_of_speech: "tính từ",
    meaning:
      "(cũ) chỉ tóm tắt những điều cơ bản, cần thiết nhất: binh thư yếu lược",
    example: "binh thư yếu lược",
  },
  {
    word: "yêu mến",
    part_of_speech: "động từ",
    meaning:
      "có tình cảm thân thiết, thích gần gũi: được bạn bè yêu mến * đem lòng yêu mến",
    example: "được bạn bè yêu mến * đem lòng yêu mến",
  },
  {
    word: "yêu ma",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) ma quỷ và yêu quái; thường dùng để ví kẻ độc ác, ranh mãnh: một lũ yêu ma chuyên nghề lừa lọc",
    example: "một lũ yêu ma chuyên nghề lừa lọc",
  },
  {
    word: "yếu mềm",
    part_of_speech: "tính từ",
    meaning: "như mềm yếu: tình cảm yếu mềm",
    example: "tình cảm yếu mềm",
  },
  {
    word: "yêu kính",
    part_of_speech: "động từ",
    meaning: "(hiếm) như kính yêu: yêu kính cha mẹ",
    example: "yêu kính cha mẹ",
  },
  {
    word: "yêu quý",
    part_of_speech: "động từ",
    meaning:
      "yêu mến và quý trọng: yêu quý loài vật * yêu quý con cái * người bạn yêu quý",
    example: "yêu quý loài vật * yêu quý con cái * người bạn yêu quý",
  },
  {
    word: "yêu thuật",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như ma thuật (ng2): yêu thuật của phù thuỷ",
    example: "yêu thuật của phù thuỷ",
  },
  {
    word: "yếu ớt",
    part_of_speech: "tính từ",
    meaning:
      "yếu đến mức sức lực hoặc tác dụng coi như không đáng kể: chân tay yếu ớt * chống cự yếu ớt",
    example: "chân tay yếu ớt * chống cự yếu ớt",
  },
  {
    word: "yêu thương",
    part_of_speech: "động từ",
    meaning:
      "có tình cảm gắn bó tha thiết và quan tâm chăm sóc hết lòng: yêu thương con cái * tình yêu thương đồng loại",
    example: "yêu thương con cái * tình yêu thương đồng loại",
  },
  {
    word: "yêu quí",
    part_of_speech: "động từ",
    meaning:
      "yêu mến và quý trọng: yêu quý loài vật * yêu quý con cái * người bạn yêu quý",
    example: "yêu quý loài vật * yêu quý con cái * người bạn yêu quý",
  },
  {
    word: "yếu thế",
    part_of_speech: "tính từ",
    meaning: "ở vào thế yếu: yếu thế nên đành chịu nhún * địa vị yếu thế",
    example: "yếu thế nên đành chịu nhún * địa vị yếu thế",
  },
  {
    word: "yếu tố",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận cấu thành một sự vật, sự việc, hiện tượng: yếu tố cấu tạo từ * yếu tố văn hoá * những yếu tố cấu thành tội phạm",
    example:
      "yếu tố cấu tạo từ * yếu tố văn hoá * những yếu tố cấu thành tội phạm",
  },
  {
    word: "yếu tố",
    part_of_speech: "danh từ",
    meaning:
      "cái cần thiết tạo điều kiện hình thành nên cái khác: yếu tố con người quyết định sự phát triển của xã hội",
    example: "yếu tố con người quyết định sự phát triển của xã hội",
  },
  {
    word: "yêu sách",
    part_of_speech: "động từ",
    meaning:
      "đòi hỏi một cách gắt gao, không nhân nhượng, vì tự cho là mình có quyền: thợ thuyền yêu sách đòi chủ tăng lương",
    example: "thợ thuyền yêu sách đòi chủ tăng lương",
  },
  {
    word: "yêu sách",
    part_of_speech: "danh từ",
    meaning:
      "điều đòi hỏi về quyền lợi: đưa ra yêu sách * bác bỏ những yêu sách phi lí",
    example: "đưa ra yêu sách * bác bỏ những yêu sách phi lí",
  },
  {
    word: "yêu tinh",
    part_of_speech: "danh từ",
    meaning:
      "vật tưởng tượng có hình thù quái dị, có nhiều phép thuật và độc ác: con yêu tinh * đồ yêu tinh! (tiếng chửi rủa)",
    example: "con yêu tinh * đồ yêu tinh! (tiếng chửi rủa)",
  },
  {
    word: "yêu vì",
    part_of_speech: "động từ",
    meaning:
      '(cũ) yêu quý và vì nể: "Nửa mừng nửa lại hồ nghi, Biết rằng bạn có yêu vì hay không?" (ca dao)',
    example:
      'Nửa mừng nửa lại hồ nghi, Biết rằng bạn có yêu vì hay không?" (ca dao)',
  },
  {
    word: "yểu tướng",
    part_of_speech: "tính từ",
    meaning: "có tướng chết yểu: anh ta trông yểu tướng",
    example: "anh ta trông yểu tướng",
  },
  {
    word: "yoga",
    part_of_speech: "danh từ",
    meaning:
      "học thuyết và phương pháp tự điều khiển tâm lí và sinh lí của con người trong một hệ thống triết học - tôn giáo của ấn Độ, nhằm đạt đến trạng thái giải thoát.",
    example: "luyện yoga",
  },
  {
    word: "yếu xìu",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) rất yếu, khó có thể làm việc gì được: người yếu xìu",
    example: "người yếu xìu",
  },
  {
    word: "cao hứng",
    part_of_speech: "tính từ",
    meaning:
      "có hứng thú ở mức cao, tạo nên cảm xúc mạnh mẽ, thôi thúc muốn làm những việc mà lúc thường ít khi làm được: cao hứng làm một bài thơ",
    example: "cao hứng làm một bài thơ",
  },
  {
    word: "cao kều",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) cao vượt hẳn lên và gầy, không cân đối (thường nói về dáng người): dáng người cao kều",
    example: "dáng người cao kều",
  },
  {
    word: "cao kiến",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) ý kiến hay và sáng suốt: đưa ra những cao kiến * thực là một cao kiến",
    example: "đưa ra những cao kiến * thực là một cao kiến",
  },
  {
    word: "cao kiến",
    part_of_speech: "tính từ",
    meaning:
      "có ý kiến hay và sáng suốt, có khả năng nhìn xa thấy trước hơn hẳn người thường: người cao kiến",
    example: "người cao kiến",
  },
  {
    word: "cao lanh",
    part_of_speech: "danh từ",
    meaning:
      "đất sét mịn, màu trắng hoặc vàng, dùng trong công nghiệp sản xuất đồ sứ, gạch chịu lửa, giấy, v.v.: mỏ cao lanh",
    example: "mỏ cao lanh",
  },
  {
    word: "cáo lão",
    part_of_speech: "động từ",
    meaning:
      "(quan lại cao cấp thời phong kiến) xin được về nghỉ hưu vì tuổi đã cao: cáo lão về quê",
    example: "cáo lão về quê",
  },
  {
    word: "cao lêu nghêu",
    part_of_speech: "tính từ",
    meaning: "cao quá cỡ và gầy, trông mất cân đối: người cao lêu nghêu",
    example: "người cao lêu nghêu",
  },
  {
    word: "cáo lỗi",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) xin lỗi, xin thứ lỗi: xin cáo lỗi cùng bạn đọc gần xa",
    example: "xin cáo lỗi cùng bạn đọc gần xa",
  },
  {
    word: "cao minh",
    part_of_speech: "tính từ",
    meaning: "(cũ) có nhận thức đúng và sáng suốt: vị vua cao minh",
    example: "vị vua cao minh",
  },
  {
    word: "cáo lui",
    part_of_speech: "động từ",
    meaning: "(trang trọng) xin phép ra về: xin cáo lui * đứng dậy cáo lui",
    example: "xin cáo lui * đứng dậy cáo lui",
  },
  {
    word: "cao lương",
    part_of_speech: "danh từ",
    meaning:
      "cây lương thực cùng họ với ngô, thân và lá lớn, gié ngắn, hạt to tròn: tăng diện tích cây cao lương",
    example: "tăng diện tích cây cao lương",
  },
  {
    word: "cao lương",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) thịt béo và gạo ngon; món ăn ngon (nói khái quát): "Miếng cao lương phong lưu nhưng lợm, Mùi hoắc lê thanh đạm mà ngon." (CO)',
    example:
      'Miếng cao lương phong lưu nhưng lợm, Mùi hoắc lê thanh đạm mà ngon." (CO)',
  },
  {
    word: "cao ngất",
    part_of_speech: "tính từ",
    meaning: "rất cao, quá tầm mắt: toà nhà cao ngất",
    example: "toà nhà cao ngất",
  },
  {
    word: "cao ngạo",
    part_of_speech: "tính từ",
    meaning:
      "kiêu kì, ngạo mạn, tự coi là hơn hẳn người khác: tính khí cao ngạo",
    example: "tính khí cao ngạo",
  },
  {
    word: "cao nguyên",
    part_of_speech: "danh từ",
    meaning:
      "vùng đất rộng lớn và cao, xung quanh có sườn dốc rõ rệt: cao nguyên Lâm Đồng",
    example: "cao nguyên Lâm Đồng",
  },
  {
    word: "cao nghệu",
    part_of_speech: "tính từ",
    meaning:
      "cao quá cỡ, có vẻ chông chênh và rất mất cân đối: chòi canh cao nghệu",
    example: "chòi canh cao nghệu",
  },
  {
    word: "cao nhòng",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như cao lêu nghêu: người cao nhòng",
    example: "người cao nhòng",
  },
  {
    word: "cao ốc",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) nhà cao tầng: toà cao ốc",
    example: "toà cao ốc",
  },
  {
    word: "cao niên",
    part_of_speech: "tính từ",
    meaning:
      "(cũ, trang trọng) như cao tuổi: bậc cao niên * các cụ cao niên trong làng",
    example: "bậc cao niên * các cụ cao niên trong làng",
  },
  {
    word: "cao nhân",
    part_of_speech: "danh từ",
    meaning: "(cũ) người có tài năng và nhân cách lớn: bậc cao nhân",
    example: "bậc cao nhân",
  },
  {
    word: "cao nhã",
    part_of_speech: "tính từ",
    meaning: "thanh cao và trang nhã: thú chơi cao nhã",
    example: "thú chơi cao nhã",
  },
  {
    word: "cáo phó",
    part_of_speech: "",
    meaning:
      "(trang trọng) báo tin về việc (trong gia đình, cơ quan) vừa có người chết: đăng tin cáo phó",
    example: "đăng tin cáo phó",
  },
  {
    word: "cao quí",
    part_of_speech: "tính từ",
    meaning:
      "có giá trị lớn về mặt tinh thần, rất đáng quý trọng: tình cảm cao quý * phần thưởng cao quý * phẩm chất cao quý của người thầy giáo",
    example:
      "tình cảm cao quý * phần thưởng cao quý * phẩm chất cao quý của người thầy giáo",
  },
  {
    word: "cao quý",
    part_of_speech: "tính từ",
    meaning:
      "có giá trị lớn về mặt tinh thần, rất đáng quý trọng: tình cảm cao quý * phần thưởng cao quý * phẩm chất cao quý của người thầy giáo",
    example:
      "tình cảm cao quý * phần thưởng cao quý * phẩm chất cao quý của người thầy giáo",
  },
  {
    word: "cao ráo",
    part_of_speech: "tính từ",
    meaning:
      "cao và khô ráo (nói khái quát): chỗ đất cao ráo * nhà cửa cao ráo, thoáng đãng",
    example: "chỗ đất cao ráo * nhà cửa cao ráo, thoáng đãng",
  },
  {
    word: "cao ráo",
    part_of_speech: "tính từ",
    meaning:
      "cao và gọn gàng, trông dễ ưa (thường chỉ nói về dáng người): dáng người cao ráo",
    example: "dáng người cao ráo",
  },
  {
    word: "cao tay",
    part_of_speech: "tính từ",
    meaning:
      "có khả năng xử lí, ứng phó tài tình hơn người khác trước những việc nan giải: thầy thuốc cao tay * gặp phải một đối thủ cao tay",
    example: "thầy thuốc cao tay * gặp phải một đối thủ cao tay",
  },
  {
    word: "cao sản",
    part_of_speech: "tính từ",
    meaning:
      "có sản lượng cao: ruộng cao sản * giống lúa cao sản * sắn cao sản",
    example: "ruộng cao sản * giống lúa cao sản * sắn cao sản",
  },
  {
    word: "cao siêu",
    part_of_speech: "tính từ",
    meaning:
      "hơn hẳn mức thường về mặt giá trị tinh thần: tài nghệ cao siêu * triết lí cao siêu * ý tưởng cao siêu",
    example: "tài nghệ cao siêu * triết lí cao siêu * ý tưởng cao siêu",
  },
  {
    word: "cao siêu",
    part_of_speech: "tính từ",
    meaning: "(hiếm) cao xa, không thực tế: mơ ước cao siêu",
    example: "mơ ước cao siêu",
  },
  {
    word: "cao sang",
    part_of_speech: "tính từ",
    meaning:
      "cao quý và sang trọng: địa vị cao sang * thuộc dòng dõi cao sang, quyền quý",
    example: "địa vị cao sang * thuộc dòng dõi cao sang, quyền quý",
  },
  {
    word: "cao tăng",
    part_of_speech: "danh từ",
    meaning:
      "nhà sư tu hành lâu năm, thông hiểu giáo lí của đạo Phật và có đức độ cao: một vị cao tăng đời Lý",
    example: "một vị cao tăng đời Lý",
  },
  {
    word: "cao thế",
    part_of_speech: "tính từ",
    meaning:
      "(điện) có hiệu thế cao, thường là cao hơn 650 volt; phân biệt với hạ thế: điện cao thế * đường dây cao thế",
    example: "điện cao thế * đường dây cao thế",
  },
  {
    word: "cao su",
    part_of_speech: "danh từ",
    meaning:
      "cây to cùng họ với thầu dầu, thân có nhiều nhựa mủ: nông trường cao su * đồn điền cao su",
    example: "nông trường cao su * đồn điền cao su",
  },
  {
    word: "cao su",
    part_of_speech: "danh từ",
    meaning:
      "hợp chất dễ đàn hồi và dai, chế từ mủ cây cao su hoặc bằng phương pháp tổng hợp: lốp cao su * dép cao su",
    example: "lốp cao su * dép cao su",
  },
  {
    word: "cao su",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) có thể co dãn, không cố định: giờ cao su",
    example: "giờ cao su",
  },
  {
    word: "cảo táng",
    part_of_speech: "động từ",
    meaning:
      '(cũ, hiếm) chôn qua loa, không có khâm liệm, quan quách gì: "Hồ công nghe nói thương tình, Truyền cho cảo táng di hình bên sông." (TKiều)',
    example:
      'Hồ công nghe nói thương tình, Truyền cho cảo táng di hình bên sông." (TKiều)',
  },
  {
    word: "cao thâm",
    part_of_speech: "tính từ",
    meaning:
      "(cũ) (trình độ học vấn, kĩ thuật) cao và sâu: một nền triết học cao thâm * Phật pháp cao thâm",
    example: "một nền triết học cao thâm * Phật pháp cao thâm",
  },
  {
    word: "cao tần",
    part_of_speech: "tính từ",
    meaning: "có tần số cao từ 10.000 hertz trở lên: dòng điện cao tần",
    example: "dòng điện cao tần",
  },
  {
    word: "cao tầng",
    part_of_speech: "tính từ",
    meaning: "(nhà) có nhiều tầng: nhà cao tầng * khu chung cư cao tầng",
    example: "nhà cao tầng * khu chung cư cao tầng",
  },
  {
    word: "cáo thị",
    part_of_speech: "danh từ",
    meaning: "(cũ) bản thông cáo cho nhân dân biết: đọc cáo thị * dán cáo thị",
    example: "đọc cáo thị * dán cáo thị",
  },
  {
    word: "cao thủ",
    part_of_speech: "",
    meaning:
      "người tài giỏi, có khả năng hành động và ứng phó hơn hẳn người thường: một cao thủ võ lâm * bậc cao thủ trong làng cờ tướng * tay ấy rất cao thủ (kng)",
    example:
      "một cao thủ võ lâm * bậc cao thủ trong làng cờ tướng * tay ấy rất cao thủ (kng)",
  },
  {
    word: "cáo thoái",
    part_of_speech: "động từ",
    meaning:
      "(cũ, hiếm) như cáo lui: mọi việc đã xong, tôi xin cáo thoái về trước",
    example: "mọi việc đã xong, tôi xin cáo thoái về trước",
  },
  {
    word: "cáo trạng",
    part_of_speech: "danh từ",
    meaning: "bản nêu tội trạng: kiểm sát viên đọc bản cáo trạng",
    example: "kiểm sát viên đọc bản cáo trạng",
  },
  {
    word: "cao thượng",
    part_of_speech: "tính từ",
    meaning:
      "có phẩm chất, đạo đức cao cả, vượt hẳn lên trên những cái tầm thường, nhỏ nhen: tấm lòng cao thượng * làm ra vẻ cao thượng",
    example: "tấm lòng cao thượng * làm ra vẻ cao thượng",
  },
  {
    word: "cao tuổi",
    part_of_speech: "tính từ",
    meaning:
      "(người) nhiều tuổi, đã già (cách nói lịch sự): hội người cao tuổi * các cụ cao tuổi trong làng",
    example: "hội người cao tuổi * các cụ cao tuổi trong làng",
  },
  {
    word: "cao trào",
    part_of_speech: "danh từ",
    meaning: "giai đoạn phát triển cao nhất của sự việc: cao trào cách mạng",
    example: "cao trào cách mạng",
  },
  {
    word: "cao trào",
    part_of_speech: "danh từ",
    meaning:
      "giai đoạn mâu thuẫn xung đột phát triển đến mức sâu sắc nhất, căng thẳng nhất trong tình tiết của một tác phẩm nghệ thuật như âm nhạc, kịch, truyện, v.v.: vở diễn đang đến đoạn cao trào",
    example: "vở diễn đang đến đoạn cao trào",
  },
  {
    word: "cao tốc",
    part_of_speech: "tính từ",
    meaning: "có tốc độ cao: tàu cao tốc * đường cao tốc",
    example: "tàu cao tốc * đường cao tốc",
  },
  {
    word: "cao trình",
    part_of_speech: "danh từ",
    meaning:
      "độ cao tại một điểm so với mặt chuẩn: công trình nằm trên cao trình 800 mét so với mực nước biển",
    example: "công trình nằm trên cao trình 800 mét so với mực nước biển",
  },
  {
    word: "cao uỷ",
    part_of_speech: "danh từ",
    meaning:
      "viên chức cao cấp của một tổ chức quốc tế, phụ trách một loạI vấn đề nhất định: cao uỷ Liên Hợp Quốc về vấn đề người tị nạn",
    example: "cao uỷ Liên Hợp Quốc về vấn đề người tị nạn",
  },
  {
    word: "cao uỷ",
    part_of_speech: "danh từ",
    meaning:
      "viên chức cao cấp, đại diện của một nước ở nước khác, tương đương đại sứ: cao uỷ Pháp ở Đông Dương (thời trước 1945)",
    example: "cao uỷ Pháp ở Đông Dương (thời trước 1945)",
  },
  {
    word: "cao vọng",
    part_of_speech: "danh từ",
    meaning: "(hiếm) điều mong ước cao xa: mơ ước nhiều cao vọng",
    example: "mơ ước nhiều cao vọng",
  },
  {
    word: "cáo từ",
    part_of_speech: "động từ",
    meaning: "(trang trọng) chào ra về: đứng dậy cáo từ ra về * xin cáo từ",
    example: "đứng dậy cáo từ ra về * xin cáo từ",
  },
  {
    word: "cao vút",
    part_of_speech: "tính từ",
    meaning:
      "rất cao, như vươn thẳng lên không trung: ống khói nhà máy cao vút * tiếng sáo ngân lên cao vút",
    example: "ống khói nhà máy cao vút * tiếng sáo ngân lên cao vút",
  },
  {
    word: "cao xạ",
    part_of_speech: "danh từ",
    meaning: "pháo cao xạ (nói tắt): khẩu cao xạ * trung đoàn cao xạ",
    example: "khẩu cao xạ * trung đoàn cao xạ",
  },
  {
    word: "cao xa",
    part_of_speech: "tính từ",
    meaning:
      "cao và xa xôi, có vẻ như không thực tế, khó đạt tới: triết lí cao xa khó hiểu * không mơ ước gì cao xa * nói những điều cao xa",
    example:
      "triết lí cao xa khó hiểu * không mơ ước gì cao xa * nói những điều cao xa",
  },
  {
    word: "cáp",
    part_of_speech: "danh từ",
    meaning:
      "dây bện gồm nhiều sợi kim loại nhỏ xoắn chặt lại với nhau, chịu được sức kéo lớn: dây cáp cần cẩu * cáp cầu treo",
    example: "dây cáp cần cẩu * cáp cầu treo",
  },
  {
    word: "cáp",
    part_of_speech: "danh từ",
    meaning:
      "dây đặc biệt dùng để dẫn điện cao thế hay truyền tín hiệu, thường có vỏ bọc cách điện: cáp điện thoại * đường cáp cao thế * hệ thống cáp truyền hình",
    example: "cáp điện thoại * đường cáp cao thế * hệ thống cáp truyền hình",
  },
  {
    word: "cạp",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận buộc hoặc viền xung quanh miệng hay mép một số đồ đan lát để giữ cho khỏi sổ ra: cạp rổ bị bung * cạp chiếu",
    example: "cạp rổ bị bung * cạp chiếu",
  },
  {
    word: "cạp",
    part_of_speech: "danh từ",
    meaning: "nẹp vải khâu liền vào chỗ thắt lưng quần, váy: quần bị rách cạp",
    example: "quần bị rách cạp",
  },
  {
    word: "cạp",
    part_of_speech: "động từ",
    meaning: "làm hoặc buộc cạp cho cái gì: cạp lại cái rá",
    example: "cạp lại cái rá",
  },
  {
    word: "cạp",
    part_of_speech: "động từ",
    meaning:
      "đắp thêm đất vào cho vững hơn, chắc hơn: bờ ao được cạp bằng gạch",
    example: "bờ ao được cạp bằng gạch",
  },
  {
    word: "cạp",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) ngoạm: cạp củ khoai * cạp một miếng thật to",
    example: "cạp củ khoai * cạp một miếng thật to",
  },
  {
    word: "carat",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị đo khối lượng đá quý và ngọc trai, bằng 200 milligram: viên kim cương nặng 300 carat",
    example: "viên kim cương nặng 300 carat",
  },
  {
    word: "carat",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị biểu thị tỉ lệ vàng trong hợp kim vàng, bằng 1/24 khối lượng của hợp kim: vàng 24 carat (vàng nguyên chất)",
    example: "vàng 24 carat (vàng nguyên chất)",
  },
  {
    word: "carbon",
    part_of_speech: "danh từ",
    meaning:
      "nguyên tố hoá học, thành phần chính của than và chất hữu cơ: khí carbon",
    example: "khí carbon",
  },
  {
    word: "cát",
    part_of_speech: "danh từ",
    meaning:
      "đá vụn thành hạt nhỏ dưới 2 millimet, có thành phần chủ yếu là thạch anh và các khoáng vật khác: bãi cát * đãi cát lấy vàng * dã tràng xe cát",
    example: "bãi cát * đãi cát lấy vàng * dã tràng xe cát",
  },
  {
    word: "cát",
    part_of_speech: "danh từ",
    meaning:
      "hình hạt rất nhỏ và đều trên mặt hàng dệt do sợi săn co lại tạo thành: thứ nhiễu nhỏ cát",
    example: "thứ nhiễu nhỏ cát",
  },
  {
    word: "cát cứ",
    part_of_speech: "động từ",
    meaning:
      "chia cắt lãnh thổ để chiếm giữ và lập chủ quyền riêng, không phục tùng chủ quyền trung ương: mỗi người cát cứ một phương * trước đời Đinh, mười hai sứ quân chia nhau cát cứ mỗi vùng",
    example:
      "mỗi người cát cứ một phương * trước đời Đinh, mười hai sứ quân chia nhau cát cứ mỗi vùng",
  },
  {
    word: "cát đen",
    part_of_speech: "danh từ",
    meaning:
      "cát mịn hạt và có lẫn nhiều chất bẩn: tường xây bằng vôi và cát đen",
    example: "tường xây bằng vôi và cát đen",
  },
  {
    word: "cát két",
    part_of_speech: "danh từ",
    meaning:
      "mũ mềm, chóp bằng hơi bẹt, thường bằng dạ hoặc vải, đằng trước có lưỡi trai nhỏ: một người đàn ông đội cát két bằng dạ xám",
    example: "một người đàn ông đội cát két bằng dạ xám",
  },
  {
    word: "cát đằng",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) cây sắn (cát) và cây bìm (đằng), hai loại cây leo sống bám vào những cây khác; dùng để ví thân phận lẽ mọn: "Nghìn tầm nhờ bóng tùng quân, Tuyết sương che chở cho thân cát đằng." (TKiều)',
    example:
      'Nghìn tầm nhờ bóng tùng quân, Tuyết sương che chở cho thân cát đằng." (TKiều)',
  },
  {
    word: "cát hung",
    part_of_speech: "tính từ",
    meaning:
      '(cũ) lành hoặc dữ, theo mê tín: "Lão bà khi ấy luận bàn, Xin xem đôi tuổi cho toàn cát hung." (PCCH)',
    example:
      'Lão bà khi ấy luận bàn, Xin xem đôi tuổi cho toàn cát hung." (PCCH)',
  },
  {
    word: "cát pha",
    part_of_speech: "tính từ",
    meaning: "(đất) chứa nhiều hạt cát hơn các loại hạt khác: đất cát pha",
    example: "đất cát pha",
  },
  {
    word: "cát vàng",
    part_of_speech: "danh từ",
    meaning: "cát to và sạch hơn cát đen: trộn vữa bằng xi măng với cát vàng",
    example: "trộn vữa bằng xi măng với cát vàng",
  },
  {
    word: "cát lầm ngọc trắng",
    part_of_speech: "",
    meaning:
      '(cũ, văn chương) ví người phụ nữ trong trắng, cao quý bị vùi dập, đoạ đày: "Vì ta cho luỵ đến người, Cát lầm ngọc trắng, thiệt đời xuân xanh." (TKiều)',
    example:
      'Vì ta cho luỵ đến người, Cát lầm ngọc trắng, thiệt đời xuân xanh." (TKiều)',
  },
  {
    word: "cát tuyến",
    part_of_speech: "danh từ",
    meaning:
      "đường thẳng cắt một đường cong hoặc cắt một số đường thẳng cho trước: cát tuyến của một đường tròn * cát tuyến của hai đường song song",
    example: "cát tuyến của một đường tròn * cát tuyến của hai đường song song",
  },
  {
    word: "catalogue",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) danh mục giới thiệu mẫu hàng, dịch vụ, v.v., thường có tranh ảnh minh hoạ: catalogue thời trang",
    example: "catalogue thời trang",
  },
  {
    word: "cát sê",
    part_of_speech: "danh từ",
    meaning:
      "tiền thù lao cho một hợp đồng hoặc một lần biểu diễn của nghệ sĩ: tiền cát sê * ca sĩ nổi tiếng thường được trả cát sê cao",
    example: "tiền cát sê * ca sĩ nổi tiếng thường được trả cát sê cao",
  },
  {
    word: "cát luỹ",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) như cát đằng: "Tin nhà ngày một vắng tin, Mặn tình cát luỹ, lạt tình tao khang." (TKiều)',
    example:
      'Tin nhà ngày một vắng tin, Mặn tình cát luỹ, lạt tình tao khang." (TKiều)',
  },
  {
    word: "catwalk",
    part_of_speech: "danh từ",
    meaning:
      "sàn hẹp và dài để người mẫu trình diễn thời trang: nổi danh trên sàn catwalk",
    example: "nổi danh trên sàn catwalk",
  },
  {
    word: "cau",
    part_of_speech: "danh từ",
    meaning:
      'cây thân thẳng hình cột, không phân cành, lá mọc thành chùm ở ngọn, quả nhỏ hình trứng mọc thành buồng, dùng để ăn trầu: "Vào vườn hái quả cau xanh, Bổ ra làm sáu mời anh xơi trầu." (ca dao)',
    example:
      'Vào vườn hái quả cau xanh, Bổ ra làm sáu mời anh xơi trầu." (ca dao)',
  },
  {
    word: "cau",
    part_of_speech: "động từ",
    meaning:
      "nhíu lông mày lại, tới mức làm nhăn da trán (thường do bực tức hoặc do nghĩ ngợi): mặt cau lại vì đau bụng * cau mặt tỏ ý khó chịu",
    example: "mặt cau lại vì đau bụng * cau mặt tỏ ý khó chịu",
  },
  {
    word: "cau có",
    part_of_speech: "",
    meaning:
      "nhăn nhó vì khó chịu, bực dọc: nét mặt cau có * tính hay cau có, gắt gỏng",
    example: "nét mặt cau có * tính hay cau có, gắt gỏng",
  },
  {
    word: "cáu gắt",
    part_of_speech: "động từ",
    meaning: "hay quát tháo, gắt gỏng vì đang buồn bực, khó chịu: cáu gắt ầm ĩ",
    example: "cáu gắt ầm ĩ",
  },
  {
    word: "cáu bẳn",
    part_of_speech: "",
    meaning: "hay cáu gắt một cách vô lí: ốm đau nhiều đâm ra hay cáu bẳn",
    example: "ốm đau nhiều đâm ra hay cáu bẳn",
  },
  {
    word: "cáu",
    part_of_speech: "danh từ",
    meaning:
      "chất bụi bẩn bám vào da hoặc chất cặn bẩn bám vào vật: cáu bám ở cổ * cáu nước chè trong chén",
    example: "cáu bám ở cổ * cáu nước chè trong chén",
  },
  {
    word: "cáu",
    part_of_speech: "tính từ",
    meaning: "bẩn do có cáu bám vào: chân tay cáu ghét * cái nắp ấm cáu đen",
    example: "chân tay cáu ghét * cái nắp ấm cáu đen",
  },
  {
    word: "cáu",
    part_of_speech: "tính từ",
    meaning:
      "bực tức đến mức dễ nổi nóng và sẵn sàng có những phản ứng mạnh mẽ bằng lời nói hoặc hành động thiếu suy nghĩ: hơi một tí là nổi cáu * nghe nó nói mà phát cáu",
    example: "hơi một tí là nổi cáu * nghe nó nói mà phát cáu",
  },
  {
    word: "càu cạu",
    part_of_speech: "tính từ",
    meaning: "có vẻ bực dọc, giận dữ: nét mặt càu cạu",
    example: "nét mặt càu cạu",
  },
  {
    word: "cáu giận",
    part_of_speech: "động từ",
    meaning:
      "bực tức tới mức không kiềm chế nổi và có những phản ứng dữ dội: cáu giận vợ con",
    example: "cáu giận vợ con",
  },
  {
    word: "càu nhàu",
    part_of_speech: "động từ",
    meaning:
      "nói lẩm bẩm tỏ ý không bằng lòng: càu nhàu phản đối * hơi một tí là càu nhàu",
    example: "càu nhàu phản đối * hơi một tí là càu nhàu",
  },
  {
    word: "cáu kỉnh",
    part_of_speech: "",
    meaning: "cáu (nói khái quát): giọng cáu kỉnh",
    example: "giọng cáu kỉnh",
  },
  {
    word: "cáy",
    part_of_speech: "danh từ",
    meaning:
      "cua sống ở nước lợ, có một càng rất lớn, chân có lông, thường dùng làm mắm: đời cua cua máy, đời cáy cáy đào (tng)",
    example: "đời cua cua máy, đời cáy cáy đào (tng)",
  },
  {
    word: "cay",
    part_of_speech: "danh từ",
    meaning:
      "(Ít dùng) phần để cắm vào chuôi hoặc cán của một số dụng cụ: cay dao * liềm long cay",
    example: "cay dao * liềm long cay",
  },
  {
    word: "cay",
    part_of_speech: "tính từ",
    meaning:
      "có vị làm cho nóng, tê xót đầu lưỡi, như vị của ớt, của gừng, v.v.: gừng cay muối mặn * vị cay của ớt",
    example: "gừng cay muối mặn * vị cay của ớt",
  },
  {
    word: "cay",
    part_of_speech: "tính từ",
    meaning:
      "(một số giác quan) có cảm giác hơi xót và khó chịu, do bị kích thích: khói làm cay mắt * thấy cay cay sống mũi",
    example: "khói làm cay mắt * thấy cay cay sống mũi",
  },
  {
    word: "cay",
    part_of_speech: "tính từ",
    meaning:
      "hay đg. (Khẩu ngữ) tức tối vì bị thất bại hoặc thua thiệt nặng nề: bị một vố rất cay * bị thua cay",
    example: "bị một vố rất cay * bị thua cay",
  },
  {
    word: "cáu sườn",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) tức mình và nổi cáu: nghe nó nói mà cáu sườn",
    example: "nghe nó nói mà cáu sườn",
  },
  {
    word: "cáu tiết",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) cáu giận đến mức nổi nóng do bị chọc tức, có thể dẫn đến những phản ứng hoặc hành vi thô bạo: cáu tiết tát cho một cái",
    example: "cáu tiết tát cho một cái",
  },
  {
    word: "cạy",
    part_of_speech: "động từ",
    meaning:
      "làm bật ra bằng cách bẩy vào khe hở: cạy tung nắp hòm * cạy răng cũng chẳng nói",
    example: "cạy tung nắp hòm * cạy răng cũng chẳng nói",
  },
  {
    word: "cày",
    part_of_speech: "danh từ",
    meaning:
      "nông cụ có lưỡi bằng sắt, gang, dùng sức kéo để lật, xới hoặc làm vỡ lớp đất trồng trọt: vác cày ra đồng * kéo cày thay trâu",
    example: "vác cày ra đồng * kéo cày thay trâu",
  },
  {
    word: "cày",
    part_of_speech: "động từ",
    meaning: "lật, xới đất lên bằng cái cày: cày ruộng",
    example: "cày ruộng",
  },
  {
    word: "cày",
    part_of_speech: "động từ",
    meaning:
      "xới đất lên và làm cho mặt đất trở nên nham nhở: mặt đất bị bom cày nát",
    example: "mặt đất bị bom cày nát",
  },
  {
    word: "cay cú",
    part_of_speech: "tính từ",
    meaning:
      "tức tối vì bị mất mát, thua thiệt và nôn nóng muốn gỡ lại cho kì được: cay cú cờ bạc * bị thua nên cay cú",
    example: "cay cú cờ bạc * bị thua nên cay cú",
  },
  {
    word: "cay chua",
    part_of_speech: "tính từ",
    meaning: "như chua cay: lời nói cay chua * lên giọng cay chua",
    example: "lời nói cay chua * lên giọng cay chua",
  },
  {
    word: "cày cấy",
    part_of_speech: "động từ",
    meaning:
      "làm việc đồng ruộng (nói khái quát): công việc cày cấy * ruộng bỏ hoang, không người cày cấy",
    example: "công việc cày cấy * ruộng bỏ hoang, không người cày cấy",
  },
  {
    word: "cày cuốc",
    part_of_speech: "động từ",
    meaning:
      "cày và cuốc; chỉ công việc nhà nông (nói khái quát): chăm chỉ cày cuốc",
    example: "chăm chỉ cày cuốc",
  },
  {
    word: "cày cục",
    part_of_speech: "động từ",
    meaning:
      "cắm cúi làm việc gì một cách chật vật: cày cục cả buổi mới chữa xong cái xe hỏng",
    example: "cày cục cả buổi mới chữa xong cái xe hỏng",
  },
  {
    word: "cay cực",
    part_of_speech: "tính từ",
    meaning: "cực nhục và xót xa: nỗi cay cực của người dân mất nước",
    example: "nỗi cay cực của người dân mất nước",
  },
  {
    word: "cay độc",
    part_of_speech: "tính từ",
    meaning:
      "thâm hiểm đến mức khiến cho người khác phải đau đớn, xót xa đến cực độ: lời rủa cay độc * nói những lời cay độc",
    example: "lời rủa cay độc * nói những lời cay độc",
  },
  {
    word: "cay đắng",
    part_of_speech: "tính từ",
    meaning:
      'đau khổ, xót xa một cách thấm thía: thất bại cay đắng * "Mùi tục luỵ dường kia cay đắng, Vui chi mà đeo đẳng trần duyên." (CO)',
    example:
      'thất bại cay đắng * "Mùi tục luỵ dường kia cay đắng, Vui chi mà đeo đẳng trần duyên." (CO)',
  },
  {
    word: "cay nghiệt",
    part_of_speech: "tính từ",
    meaning:
      "khắt khe, nghiệt ngã trong đối xử, làm cho người khác phải khổ sở: người mẹ ghẻ cay nghiệt",
    example: "người mẹ ghẻ cay nghiệt",
  },
  {
    word: "cay sè",
    part_of_speech: "tính từ",
    meaning:
      "(mắt) có cảm giác cay khó chịu, do thiếu ngủ hoặc bị khói xông: mắt cay sè vì buồn ngủ",
    example: "mắt cay sè vì buồn ngủ",
  },
  {
    word: "cắc ca cắc củm",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) như cắc củm (nhưng ý nhấn mạnh hơn): cắc ca cắc củm mãi mới đủ tiền sắm cho con chiếc xe đạp",
    example: "cắc ca cắc củm mãi mới đủ tiền sắm cho con chiếc xe đạp",
  },
  {
    word: "cắc",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ, Từ cũ) hào: bạc cắc * không còn một cắc",
    example: "bạc cắc * không còn một cắc",
  },
  {
    word: "cắm",
    part_of_speech: "động từ",
    meaning:
      "làm cho một vật, thường là dài hoặc có đầu nhọn, mắc sâu vào và đứng được trên một vật khác: cắm hoa vào lọ * mũi tên cắm vào thân cây * cắm cột mốc phân định biên giới",
    example:
      "cắm hoa vào lọ * mũi tên cắm vào thân cây * cắm cột mốc phân định biên giới",
  },
  {
    word: "cắm",
    part_of_speech: "động từ",
    meaning:
      "đánh dấu, thường bằng cách cắm cọc, cho biết đã chiếm hữu ruộng đất, nhà cửa: địa chủ cắm đất, cắm nhà của nông dân",
    example: "địa chủ cắm đất, cắm nhà của nông dân",
  },
  {
    word: "cắm",
    part_of_speech: "động từ",
    meaning:
      "dựng tạm chỗ ở, thường bằng cách dùng cọc cắm làm cột: cắm lều * cắm trại",
    example: "cắm lều * cắm trại",
  },
  {
    word: "cắm",
    part_of_speech: "động từ",
    meaning:
      "để cho bám chắc hoặc tự bám chắc một nơi nào đó mà hoạt động: đơn vị cắm lại một tổ trinh sát",
    example: "đơn vị cắm lại một tổ trinh sát",
  },
  {
    word: "cắm",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đặt đồ vật lại làm tin để vay tiền hoặc mua chịu, thường trong thời gian ngắn: cắm quán * cắm cả đồng hồ, xe máy để lấy tiền trả nợ",
    example: "cắm quán * cắm cả đồng hồ, xe máy để lấy tiền trả nợ",
  },
  {
    word: "cắm",
    part_of_speech: "động từ",
    meaning:
      "chúc xuống, cúi hẳn đầu xuống: đứng cắm mặt xuống đất * cắm đầu chạy",
    example: "đứng cắm mặt xuống đất * cắm đầu chạy",
  },
  {
    word: "cắc củm",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) góp nhặt, chắt chiu, dành dụm từng tí một: cắc củm từng đồng",
    example: "cắc củm từng đồng",
  },
  {
    word: "cắc cớ",
    part_of_speech: "tính từ",
    meaning:
      'có vẻ hơi trái khoáy, ngược đời và oái oăm: "Duyên sao cắc cớ lỡ làng, Cầm gương gương tối, cầm vàng vàng phai." (Cdao)',
    example:
      'Duyên sao cắc cớ lỡ làng, Cầm gương gương tối, cầm vàng vàng phai." (Cdao)',
  },
  {
    word: "căm",
    part_of_speech: "động từ",
    meaning:
      'giận và tức kẻ đã làm điều không tốt đối với mình, nhưng phải cố nén trong lòng: căm kẻ chơi khăm mình * "Hoa kia nói hẳn nghiêng thành, Chào hoa, hoa lại vô tình mới căm." (QÂTK)',
    example:
      'căm kẻ chơi khăm mình * "Hoa kia nói hẳn nghiêng thành, Chào hoa, hoa lại vô tình mới căm.',
  },
  {
    word: "căm",
    part_of_speech: "phụ từ",
    meaning: "căm căm: trời lạnh căm",
    example: "trời lạnh căm",
  },
  {
    word: "cặm",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) cắm: cặm sào xuống bùn",
    example: "cặm sào xuống bùn",
  },
  {
    word: "cặm cụi",
    part_of_speech: "",
    meaning:
      "chăm chú và mải miết làm việc gì: ngồi cặm cụi viết * cặm cụi may vá * cặm cụi làm ăn",
    example: "ngồi cặm cụi viết * cặm cụi may vá * cặm cụi làm ăn",
  },
  {
    word: "cắc kè",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) tắc kè: con cắc kè",
    example: "con cắc kè",
  },
  {
    word: "cắm cổ",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) như cắm đầu: cắm cổ chạy một mạch * cắm cổ chép bài",
    example: "cắm cổ chạy một mạch * cắm cổ chép bài",
  },
  {
    word: "căm căm",
    part_of_speech: "phụ từ",
    meaning:
      '(rét, lạnh) rất đậm, như có kim châm vào da thịt, đến mức phải run lên cầm cập: rét căm căm * "Lúc ấy, gió bấc thổi căm căm, buốt đến tận xương." (NgCHoan; 9)',
    example:
      'rét căm căm * "Lúc ấy, gió bấc thổi căm căm, buốt đến tận xương." (NgCHoan; 9)',
  },
  {
    word: "căm gan",
    part_of_speech: "động từ",
    meaning:
      "giận lắm mà phải nén lại trong lòng không để bộc lộ ra: căm gan, tím ruột",
    example: "căm gan, tím ruột",
  },
  {
    word: "căm hờn",
    part_of_speech: "động từ",
    meaning: "căm giận và oán hờn sâu sắc: căm hờn kẻ phụ bạc * lòng căm hờn",
    example: "căm hờn kẻ phụ bạc * lòng căm hờn",
  },
  {
    word: "căm giận",
    part_of_speech: "động từ",
    meaning:
      "căm ghét và giận dữ (nói khái quát): căm giận kẻ hại mình * nỗi căm giận phừng phừng",
    example: "căm giận kẻ hại mình * nỗi căm giận phừng phừng",
  },
  {
    word: "cắm đầu",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) (cúi đầu xuống) làm việc gì một cách mải miết, không để ý đến xung quanh: cắm đầu đi thẳng * về đến nhà là cắm đầu vào máy tính",
    example: "cắm đầu đi thẳng * về đến nhà là cắm đầu vào máy tính",
  },
  {
    word: "cắm đầu",
    part_of_speech: "động từ",
    meaning:
      "mù quáng, thiếu suy nghĩ mà nghe theo, làm theo người khác: ai bảo gì cũng cắm đầu nghe theo",
    example: "ai bảo gì cũng cắm đầu nghe theo",
  },
  {
    word: "cắm cúi",
    part_of_speech: "động từ",
    meaning:
      "từ gợi tả dáng vẻ hơi cúi xuống, chăm chú và mải miết làm việc gì, không để ý đến xung quanh: cắm cúi viết",
    example: "cắm cúi viết",
  },
  {
    word: "căm hận",
    part_of_speech: "động từ",
    meaning: "(hiếm) như căm hờn: căm hận kẻ phản bội",
    example: "căm hận kẻ phản bội",
  },
  {
    word: "căm ghét",
    part_of_speech: "động từ",
    meaning: "căm giận và oán ghét: căm ghét những kẻ xấu xa",
    example: "căm ghét những kẻ xấu xa",
  },
  {
    word: "căm phẫn",
    part_of_speech: "động từ",
    meaning:
      "căm giận và phẫn nộ trước điều tàn ác, ngang ngược: lòng căm phẫn * quan lại tham tàn, lòng người căm phẫn",
    example: "lòng căm phẫn * quan lại tham tàn, lòng người căm phẫn",
  },
  {
    word: "cắm sào đợi nước",
    part_of_speech: "",
    meaning:
      'ví tình trạng chờ đợi một cách thụ động, thiếu sự nỗ lực của bản thân: "Em về giục mẹ cùng thầy, Cắm sào đợi nước biết ngày nào trong?" (ca dao)',
    example:
      'Em về giục mẹ cùng thầy, Cắm sào đợi nước biết ngày nào trong?" (ca dao)',
  },
  {
    word: "căm uất",
    part_of_speech: "động từ",
    meaning:
      "căm giận, uất ức, vì không làm gì được, phải kìm nén trong lòng: kìm nén nỗi căm uất trong lòng * căm uất con người bội bạc",
    example: "kìm nén nỗi căm uất trong lòng * căm uất con người bội bạc",
  },
  {
    word: "căm thù",
    part_of_speech: "động từ",
    meaning:
      "căm giận đến mức thôi thúc phải trả thù: căm thù giặc * lòng căm thù",
    example: "căm thù giặc * lòng căm thù",
  },
  {
    word: "căm tức",
    part_of_speech: "động từ",
    meaning:
      "căm giận và bực tức (kẻ đã làm hại đến mình): căm tức bọn cường hào, ác bá * nét mặt lộ vẻ căm tức",
    example: "căm tức bọn cường hào, ác bá * nét mặt lộ vẻ căm tức",
  },
  {
    word: "cặn bã",
    part_of_speech: "danh từ",
    meaning:
      "phần chất còn lại sau khi đã lọc lấy hết cái tốt, cái tinh chất (nói khái quát); thường dùng để ví cái xấu xa, thấp hèn, chỉ đáng bỏ đi: thải chất cặn bã ra khỏi cơ thể * phần tử cặn bã của xã hội",
    example: "thải chất cặn bã ra khỏi cơ thể * phần tử cặn bã của xã hội",
  },
  {
    word: "căn",
    part_of_speech: "danh từ",
    meaning:
      "từ chỉ từng đơn vị nhà ở không lớn lắm: căn nhà có ba phòng * căn lều",
    example: "căn nhà có ba phòng * căn lều",
  },
  {
    word: "căn",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) gian nhà: nhà ba căn, hai chái * căn giữa là nơi đặt bàn thờ tổ tiên",
    example: "nhà ba căn, hai chái * căn giữa là nơi đặt bàn thờ tổ tiên",
  },
  {
    word: "căn",
    part_of_speech: "danh từ",
    meaning:
      "biểu thức hoặc số mà nhân với chính nó một số lần nào đó (nhân n lần nếu là căn bậc n) thì được biểu thức hay số đã cho trước: căn bậc 2 của 25 là 5 và -5 * 2 là căn bậc 3 của 8",
    example: "căn bậc 2 của 25 là 5 và -5 * 2 là căn bậc 3 của 8",
  },
  {
    word: "căn",
    part_of_speech: "danh từ",
    meaning: "dấu căn (nói tắt): biểu thức dưới căn",
    example: "biểu thức dưới căn",
  },
  {
    word: "căn",
    part_of_speech: "động từ",
    meaning:
      "đệm vào giữa hai mặt phẳng của hai vật nào đó một hay nhiều miếng mỏng để có được khoảng cách như yêu cầu giữa hai vật với nhau: căn cho thật chuẩn",
    example: "căn cho thật chuẩn",
  },
  {
    word: "cặn",
    part_of_speech: "danh từ",
    meaning:
      "tạp chất trong nước, lắng xuống đáy vật đựng: cơm thừa canh cặn * uống nước cả cặn (tng)",
    example: "cơm thừa canh cặn * uống nước cả cặn (tng)",
  },
  {
    word: "cằn",
    part_of_speech: "tính từ",
    meaning:
      "(đất trồng trọt) không có hoặc hết màu mỡ: đồng khô đất cằn * vùng đất cằn đầy sỏi đá",
    example: "đồng khô đất cằn * vùng đất cằn đầy sỏi đá",
  },
  {
    word: "cằn",
    part_of_speech: "tính từ",
    meaning:
      "(cây cối) không lớn, không mọc lên được do thiếu chất dinh dưỡng: lúa cằn * một thân sấu cằn",
    example: "lúa cằn * một thân sấu cằn",
  },
  {
    word: "căn bệnh",
    part_of_speech: "danh từ",
    meaning: "nguyên nhân của bệnh: chưa tìm ra căn bệnh",
    example: "chưa tìm ra căn bệnh",
  },
  {
    word: "căn bệnh",
    part_of_speech: "danh từ",
    meaning:
      "loại bệnh: ung thư là một căn bệnh nan y * tham nhũng đã trở thành một căn bệnh của xã hội",
    example:
      "ung thư là một căn bệnh nan y * tham nhũng đã trở thành một căn bệnh của xã hội",
  },
  {
    word: "cắm sừng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) (vợ) lừa chồng để ngoại tình: bị vợ cắm sừng mà không biết",
    example: "bị vợ cắm sừng mà không biết",
  },
  {
    word: "cắn",
    part_of_speech: "động từ",
    meaning:
      "giữ và siết chặt giữa hai hàm răng, thường để làm đứt, làm thủng: cắn miếng bánh * bị chó cắn * cắn chặt môi lại * cõng rắn cắn gà nhà (tng)",
    example:
      "cắn miếng bánh * bị chó cắn * cắn chặt môi lại * cõng rắn cắn gà nhà (tng)",
  },
  {
    word: "cắn",
    part_of_speech: "động từ",
    meaning:
      "làm đau buốt, ngứa ngáy khó chịu, như bị cắn: rôm cắn * kiến cắn * bị rệp cắn khắp người * (Nam) bị muỗi cắn",
    example: "rôm cắn * kiến cắn * bị rệp cắn khắp người * (Nam)",
  },
  {
    word: "cắn",
    part_of_speech: "động từ",
    meaning:
      "khớp vào nhau rất chặt: bàn đóng cắn mộng * thúng thóc đầy cắn cạp",
    example: "bị muỗi cắn",
  },
  {
    word: "cắn",
    part_of_speech: "động từ",
    meaning:
      "(Phương ngữ) sủa: có tiếng chó cắn ngoài ngõ * thấy người lạ, lũ chó cắn xao lên",
    example: "bàn đóng cắn mộng * thúng thóc đầy cắn cạp",
  },
  {
    word: "căn bản",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) cái gốc rễ, cái cốt yếu quy định bản chất của sự vật: về căn bản * suy luận dựa trên căn bản kinh tế * một gia đình có căn bản",
    example:
      "về căn bản * suy luận dựa trên căn bản kinh tế * một gia đình có căn bản",
  },
  {
    word: "căn bản",
    part_of_speech: "tính từ",
    meaning:
      "cốt yếu, có tác dụng quy định bản chất của sự vật: lưu ý những điểm căn bản * sự khác nhau căn bản",
    example: "lưu ý những điểm căn bản * sự khác nhau căn bản",
  },
  {
    word: "căn bản",
    part_of_speech: "phụ từ",
    meaning:
      "nói chung về những nét chính, nét chủ yếu: công việc căn bản là đã xong",
    example: "công việc căn bản là đã xong",
  },
  {
    word: "cằn cặt",
    part_of_speech: "tính từ",
    meaning:
      "hay kêu ca, gắt gỏng và bắt bẻ một cách khắt khe: khó tính, cứ cằn cặt suốt ngày",
    example: "khó tính, cứ cằn cặt suốt ngày",
  },
  {
    word: "cằn cặt",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như ngằn ngặt: đứa bé đói sữa khóc cằn cặt",
    example: "đứa bé đói sữa khóc cằn cặt",
  },
  {
    word: "cắn chỉ",
    part_of_speech: "tính từ",
    meaning:
      "(môi) có quết trầu đóng thành ngấn thanh và dài như sợi chỉ: cặp môi cắn chỉ",
    example: "cặp môi cắn chỉ",
  },
  {
    word: "căn cắt",
    part_of_speech: "phụ từ",
    meaning: "(rét) đến mức cảm thấy buốt xương: trời rét căn cắt",
    example: "trời rét căn cắt",
  },
  {
    word: "cằn cỗi",
    part_of_speech: "tính từ",
    meaning:
      "(đất trồng trọt) cằn quá, không còn chút màu mỡ: ruộng đất cằn cỗi",
    example: "ruộng đất cằn cỗi",
  },
  {
    word: "cằn cỗi",
    part_of_speech: "tính từ",
    meaning:
      "không đủ sức lớn và phát triển, sớm trở nên già cỗi, do thiếu điều kiện dinh dưỡng: cây cối cằn cỗi * một bóng người già nua cằn cỗi",
    example: "cây cối cằn cỗi * một bóng người già nua cằn cỗi",
  },
  {
    word: "cằn cỗi",
    part_of_speech: "tính từ",
    meaning:
      "mất hết sức sống, sức sáng tạo, do không được nuôi dưỡng, bồi dưỡng tốt: tâm hồn cằn cỗi",
    example: "tâm hồn cằn cỗi",
  },
  {
    word: "căn chỉnh",
    part_of_speech: "động từ",
    meaning:
      "điều chỉnh lại cho cân đối, cho đúng với khoảng cách hoặc vị trí theo như yêu cầu (nói khái quát): căn chỉnh máy móc * căn chỉnh lề của một văn bản",
    example: "căn chỉnh máy móc * căn chỉnh lề của một văn bản",
  },
  {
    word: "cắn câu",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) mắc mưu cám dỗ của kẻ khác: cô bé đã cắn câu!",
    example: "cô bé đã cắn câu!",
  },
  {
    word: "căn cơ",
    part_of_speech: "tính từ",
    meaning:
      "cần kiệm và biết lo toan để gây dựng vốn liếng làm ăn: tính rất căn cơ",
    example: "tính rất căn cơ",
  },
  {
    word: "căn cứ",
    part_of_speech: "động từ",
    meaning:
      "dựa vào, lấy làm tiền đề hoặc cơ sở (để lập luận hoặc hành động): căn cứ vào tình hình thực tế để đánh giá * căn cứ theo luật mà xét xử",
    example:
      "căn cứ vào tình hình thực tế để đánh giá * căn cứ theo luật mà xét xử",
  },
  {
    word: "căn cứ",
    part_of_speech: "danh từ",
    meaning:
      "cái làm chỗ dựa, làm cơ sở (để lập luận hoặc hành động): bài viết không có căn cứ khoa học * kết luận thiếu căn cứ",
    example: "bài viết không có căn cứ khoa học * kết luận thiếu căn cứ",
  },
  {
    word: "căn cứ",
    part_of_speech: "danh từ",
    meaning:
      "vùng, khu vực làm chỗ dựa vững chắc (cho các hoạt động chính trị hoặc quân sự): vùng căn cứ kháng chiến * khu căn cứ quân sự * căn cứ không quân",
    example: "vùng căn cứ kháng chiến * khu căn cứ quân sự * căn cứ không quân",
  },
  {
    word: "căn cứ địa",
    part_of_speech: "danh từ",
    meaning:
      "vùng làm chỗ dựa vững chắc để tiến hành đấu tranh lâu dài: xây dựng căn cứ địa cách mạng",
    example: "xây dựng căn cứ địa cách mạng",
  },
  {
    word: "cắn cỏ",
    part_of_speech: "động từ",
    meaning:
      '(cũ) tổ hợp dùng để tỏ ý van xin một cách thảm thiết: "Tôi lạy ông! Tôi cắn rơm cắn cỏ tôi lạy ông! Ông mặc người ta!" (NCao; 28)',
    example:
      'Tôi lạy ông! Tôi cắn rơm cắn cỏ tôi lạy ông! Ông mặc người ta!" (NCao; 28)',
  },
  {
    word: "cằn cọc",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) không đủ sức lớn lên được như bình thường (nói khái quát): cây cối cằn cọc * đứa bé cằn cọc, không lớn nổi",
    example: "cây cối cằn cọc * đứa bé cằn cọc, không lớn nổi",
  },
  {
    word: "căn cước",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) những điểm để nhận rõ được một người như họ và tên, ngày và nơi sinh, cha mẹ đẻ, đặc điểm về nhân dạng, v.v. (nói tổng quát): xét căn cước của một người",
    example: "xét căn cước của một người",
  },
  {
    word: "căn cước",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) giấy căn cước (nói tắt): thẻ căn cước",
    example: "thẻ căn cước",
  },
  {
    word: "căn cứ quân sự",
    part_of_speech: "danh từ",
    meaning:
      "khu vực có thiết bị công trình quân sự và dự trữ vật tư, làm chỗ dựa để chuẩn bị và tiến hành chiến tranh: thành lập khu căn cứ quân sự",
    example: "thành lập khu căn cứ quân sự",
  },
  {
    word: "căn hộ",
    part_of_speech: "danh từ",
    meaning:
      "chỗ ở riêng biệt của một gia đình trong một khu nhà lớn, bao gồm buồng ở, bếp, buồng vệ sinh, v.v.: căn hộ khép kín * mua một căn hộ ở khu chung cư",
    example: "căn hộ khép kín * mua một căn hộ ở khu chung cư",
  },
  {
    word: "căn hộ",
    part_of_speech: "danh từ",
    meaning:
      "tính toán, cân nhắc sao cho luôn giữ ở trong khả năng cho phép: căn ke thời tiết để xuống giống * phải căn ke từng đồng",
    example: "căn ke thời tiết để xuống giống * phải căn ke từng đồng",
  },
  {
    word: "căn do",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như nguyên do: căn do của sự việc",
    example: "căn do của sự việc",
  },
  {
    word: "cặn kẽ",
    part_of_speech: "tính từ",
    meaning:
      "kĩ lưỡng, đầy đủ mọi khía cạnh: giải thích cặn kẽ cho mọi người hiểu * tìm hiểu thật cặn kẽ",
    example: "giải thích cặn kẽ cho mọi người hiểu * tìm hiểu thật cặn kẽ",
  },
  {
    word: "cằn nhằn",
    part_of_speech: "động từ",
    meaning:
      "nói lẩm bẩm dai dẳng, tỏ ý bực tức, phàn nàn về việc đã xảy ra: cằn nhằn vì bị làm mất ngủ * tính hay cằn nhằn",
    example: "cằn nhằn vì bị làm mất ngủ * tính hay cằn nhằn",
  },
  {
    word: "căn dặn",
    part_of_speech: "động từ",
    meaning:
      "dặn dò tỉ mỉ, cẩn thận, thường với người dưới: căn dặn từng li từng tí * nhớ lời mẹ căn dặn",
    example: "căn dặn từng li từng tí * nhớ lời mẹ căn dặn",
  },
  {
    word: "cắn răng",
    part_of_speech: "động từ",
    meaning: "cố chịu đựng, cố chấp nhận, không kêu ca: cắn răng chịu đựng",
    example: "cắn răng chịu đựng",
  },
  {
    word: "cắn ổ",
    part_of_speech: "động từ",
    meaning:
      "(gia súc) tha rơm rác làm ổ, báo hiệu có triệu chứng sắp đẻ: con lợn nái sắp đến ngày cắn ổ",
    example: "con lợn nái sắp đến ngày cắn ổ",
  },
  {
    word: "căn nguyên",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) nguyên nhân căn bản làm cho sự vật hoặc sự việc phát sinh: tìm ra căn nguyên của bệnh * hỏi rõ căn nguyên câu chuyện",
    example: "tìm ra căn nguyên của bệnh * hỏi rõ căn nguyên câu chuyện",
  },
  {
    word: "cắn rơm cắn cỏ",
    part_of_speech: "động từ",
    meaning:
      '(cũ) tổ hợp dùng để tỏ ý van xin một cách thảm thiết: "Tôi lạy ông! Tôi cắn rơm cắn cỏ tôi lạy ông! Ông mặc người ta!" (NCao; 28)',
    example:
      'Tôi lạy ông! Tôi cắn rơm cắn cỏ tôi lạy ông! Ông mặc người ta!" (NCao; 28)',
  },
  {
    word: "ăn diện",
    part_of_speech: "động từ",
    meaning: "diện (nói khái quát): biết cách ăn diện * đua đòi ăn diện",
    example: "biết cách ăn diện * đua đòi ăn diện",
  },
  {
    word: "ăn dè",
    part_of_speech: "động từ",
    meaning:
      "ăn dần từng ít một, để chia cho đủ số lần ăn: ít thức ăn nên phải ăn dè",
    example: "ít thức ăn nên phải ăn dè",
  },
  {
    word: "ăn dỗ",
    part_of_speech: "động từ",
    meaning: "(hiếm) dỗ dành, lừa phỉnh để ăn của người khác: ăn dỗ trẻ con",
    example: "ăn dỗ trẻ con",
  },
  {
    word: "ăn đất",
    part_of_speech: "động từ",
    meaning:
      '(khẩu ngữ) chết (hàm ý mỉa mai hoặc vui đùa): "Thằng cha cảnh sát nó đi bữa nay thì mấy người đã nằm ra ăn đất rồi." (NgThi; 7)',
    example:
      'Thằng cha cảnh sát nó đi bữa nay thì mấy người đã nằm ra ăn đất rồi." (NgThi; 7)',
  },
  {
    word: "ăn đong",
    part_of_speech: "động từ",
    meaning:
      'ăn bằng gạo mua từng bữa vì túng thiếu: "Dốc bồ thương kẻ ăn đong, Vắng chồng thương kẻ nằm không một mình." (ca dao)',
    example:
      'Dốc bồ thương kẻ ăn đong, Vắng chồng thương kẻ nằm không một mình." (ca dao)',
  },
  {
    word: "ăn ghém",
    part_of_speech: "động từ",
    meaning:
      'ăn sống (rau, quả) kèm với các thức ăn khác trong bữa ăn: xà lách ăn ghém * "Bao giờ rau diếp làm đình, Gỗ lim ăn ghém thì mình lấy ta." (ca dao)',
    example:
      'xà lách ăn ghém * "Bao giờ rau diếp làm đình, Gỗ lim ăn ghém thì mình lấy ta." (ca dao)',
  },
  {
    word: "ăn ghém",
    part_of_speech: "động từ",
    meaning: "nhai (thuốc lào) kèm với trầu: vê thuốc lào ăn ghém",
    example: "vê thuốc lào ăn ghém",
  },
  {
    word: "ăn giá",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) như ngã giá: hàng đã ăn giá xong",
    example: "hàng đã ăn giá xong",
  },
  {
    word: "ăn đời ở kiếp",
    part_of_speech: "",
    meaning:
      "sống lâu đời, sống trọn đời (ở đâu hay với ai): vợ chồng ăn đời ở kiếp với nhau",
    example: "vợ chồng ăn đời ở kiếp với nhau",
  },
  {
    word: "ăn đủ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) hưởng được nhiều lợi lộc: giá cả leo thang, bọn đầu cơ ăn đủ",
    example: "giá cả leo thang, bọn đầu cơ ăn đủ",
  },
  {
    word: "ăn đủ",
    part_of_speech: "động từ",
    meaning:
      "hứng chịu hoàn toàn điều không hay hoặc thiệt hại về mình: xe gây tai nạn, tài xế bỏ chạy, mình chủ hàng ăn đủ",
    example: "xe gây tai nạn, tài xế bỏ chạy, mình chủ hàng ăn đủ",
  },
  {
    word: "ăn đứt",
    part_of_speech: "động từ",
    meaning:
      '(khẩu ngữ) hơn hẳn, trội hơn hẳn về mặt nào đó được đem ra so sánh: "Cung thương làu bậc ngũ âm, Nghề riêng ăn đứt hồ cầm một trương." (TKiều)',
    example:
      'Cung thương làu bậc ngũ âm, Nghề riêng ăn đứt hồ cầm một trương." (TKiều)',
  },
  {
    word: "ăn giải",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) giành được phần thưởng trong một cuộc thi: tham dự nhưng không được ăn giải",
    example: "tham dự nhưng không được ăn giải",
  },
  {
    word: "ăn đường",
    part_of_speech: "động từ",
    meaning:
      "ăn uống, chi tiêu về việc ăn uống khi đi đường xa: gạo ăn đường * đem theo tiền ăn đường",
    example: "gạo ăn đường * đem theo tiền ăn đường",
  },
  {
    word: "ăn gian",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) cố ý tính sai, làm sai đi để thu lợi về mình: chơi ăn gian * tính ăn gian cả trăm nghìn",
    example: "chơi ăn gian * tính ăn gian cả trăm nghìn",
  },
  {
    word: "ăn gỏi",
    part_of_speech: "động từ",
    meaning:
      "ăn sống thịt động vật, thường là cá, tôm, cua, với gia vị: ăn gỏi cá",
    example: "ăn gỏi cá",
  },
  {
    word: "ăn gió nằm mưa",
    part_of_speech: "",
    meaning:
      '(văn chương) (cảnh đi đường xa) chịu đựng gió mưa vất vả ngoài trời: "Quản bao tháng đợi, năm chờ, Nghĩ người ăn gió nằm mưa xót thầm." (TKiều)',
    example:
      'Quản bao tháng đợi, năm chờ, Nghĩ người ăn gió nằm mưa xót thầm." (TKiều)',
  },
  {
    word: "ăn hại",
    part_of_speech: "động từ",
    meaning:
      "chỉ ăn và gây tốn kém, thiệt hại cho người khác, không làm được gì có ích: đồ ăn hại! (tiếng mắng)",
    example: "đồ ăn hại! (tiếng mắng)",
  },
  {
    word: "ăn hàng",
    part_of_speech: "động từ",
    meaning:
      'ăn quà ngoài hàng, ngoài chợ: "Học trò học trỏ học trò, Chưa đi tới chợ đã lo ăn hàng." (ca dao)',
    example:
      'Học trò học trỏ học trò, Chưa đi tới chợ đã lo ăn hàng." (ca dao)',
  },
  {
    word: "ăn hàng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) (tàu, xe) tiếp nhận hàng để chuyên chở đi nơi khác: tàu đang ăn hàng",
    example: "tàu đang ăn hàng",
  },
  {
    word: "ăn gửi nằm nhờ",
    part_of_speech: "",
    meaning:
      'sống nhờ ở nhà người khác một cách tạm bợ: "Cái nhà này thì chỉ là ăn gửi nằm nhờ, còn ai thiết gì đến." (MPTư; 1)',
    example:
      'Cái nhà này thì chỉ là ăn gửi nằm nhờ, còn ai thiết gì đến." (MPTư; 1)',
  },
  {
    word: "ăn học",
    part_of_speech: "động từ",
    meaning: "ăn và học (nói khái quát): được ăn học tử tế",
    example: "được ăn học tử tế",
  },
  {
    word: "ăn hỏi",
    part_of_speech: "động từ",
    meaning:
      "làm lễ hỏi vợ theo tục lệ cổ truyền: đem trầu cau đến ăn hỏi * lễ ăn hỏi",
    example: "đem trầu cau đến ăn hỏi * lễ ăn hỏi",
  },
  {
    word: "ăn hiếp",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) (nhất là Nam) (Bắc thường bắt nạt) ỷ thế mạnh bắt người khác phải chịu lép mà làm theo ý muốn của mình: cậy khoẻ ăn hiếp yếu",
    example: "cậy khoẻ ăn hiếp yếu",
  },
  {
    word: "ăn không",
    part_of_speech: "động từ",
    meaning:
      'chỉ ăn tiêu mà không làm: "Ăn không rồi lại nằm không, Mấy non cũng lở mấy công em cũng hoài." (ca dao)',
    example:
      'Ăn không rồi lại nằm không, Mấy non cũng lở mấy công em cũng hoài." (ca dao)',
  },
  {
    word: "ăn không",
    part_of_speech: "động từ",
    meaning:
      "lấy không của người khác bằng mánh khoé: bị địa chủ ăn không mấy sào ruộng",
    example: "bị địa chủ ăn không mấy sào ruộng",
  },
  {
    word: "ăn không ăn hỏng",
    part_of_speech: "động từ",
    meaning:
      'như ăn không (nhưng ý nhấn mạnh): "Con trâu ấy lão có ăn không ăn hỏng của ai đâu, chính do mồ hôi nước mắt của cả gia đình trong bao nhiêu năm trời mới có được." (ĐVũ; 1)',
    example:
      'Con trâu ấy lão có ăn không ăn hỏng của ai đâu, chính do mồ hôi nước mắt của cả gia đình trong bao nhiêu năm trời mới có được." (ĐVũ; 1)',
  },
  {
    word: "ăn khách",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) (mặt hàng hoặc loại hình dịch vụ) bán được nhiều do được khách ưa chuộng: mặt hàng này đang rất ăn khách * một bộ phim ăn khách",
    example: "mặt hàng này đang rất ăn khách * một bộ phim ăn khách",
  },
  {
    word: "ăn lái",
    part_of_speech: "động từ",
    meaning:
      "(tàu, thuyền) đi nhanh, không gặp trở ngại gì: thuyền mỗi lúc một ăn lái hơn",
    example: "thuyền mỗi lúc một ăn lái hơn",
  },
  {
    word: "ăn kiêng",
    part_of_speech: "động từ",
    meaning:
      "tránh ăn uống những thứ có hại cho sức khoẻ (khi đau ốm, khi rèn luyện thân thể, hoặc theo quan niệm tôn giáo): ăn kiêng để giảm cân",
    example: "ăn kiêng để giảm cân",
  },
  {
    word: "ăn khớp",
    part_of_speech: "động từ",
    meaning: "khớp với nhau, gắn chặt lại với nhau: mộng ăn khớp",
    example: "mộng ăn khớp",
  },
  {
    word: "ăn khớp",
    part_of_speech: "động từ",
    meaning:
      "khớp, hợp với nhau, không có gì mâu thuẫn: sổ sách phải ăn khớp với chứng từ * lời nói trước sau không ăn khớp",
    example:
      "sổ sách phải ăn khớp với chứng từ * lời nói trước sau không ăn khớp",
  },
  {
    word: "ăn khớp",
    part_of_speech: "tính từ",
    meaning:
      "vừa khít với nhau, hợp với nhau về mặt kích thước, khả năng, v.v.: mộng ghép rất ăn khớp",
    example: "mộng ghép rất ăn khớp",
  },
  {
    word: "ăn liền",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có thể ăn ngay, không cần qua chế biến, nấu nướng (thứ thường phải chế biến, nấu nướng): mì ăn liền",
    example: "mì ăn liền",
  },
  {
    word: "ăn lận",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) như ăn gian: chơi ăn lận * ăn lận tiền của khách hàng",
    example: "chơi ăn lận * ăn lận tiền của khách hàng",
  },
  {
    word: "ăn mảnh",
    part_of_speech: "động từ",
    meaning:
      '(khẩu ngữ) làm giấu giếm người khác để hưởng riêng một mình: "Nghề nào nghiệp ấy, ăn mảnh một mình là không xong đâu." (DHướng; 1)',
    example:
      'Nghề nào nghiệp ấy, ăn mảnh một mình là không xong đâu." (DHướng; 1)',
  },
  {
    word: "ăn lời",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) vâng lời khuyên bảo của người trên: thằng bé khó bảo, không ăn lời cha mẹ",
    example: "thằng bé khó bảo, không ăn lời cha mẹ",
  },
  {
    word: "ăn mày",
    part_of_speech: "động từ",
    meaning:
      'xin của bố thí để sống: xách bị đi ăn mày * "Ông cứ tong cả cái gia tài mấy ngàn bạc ấy đi thì lại ăn mày sớm!" (LKhai; 1)',
    example:
      'xách bị đi ăn mày * "Ông cứ tong cả cái gia tài mấy ngàn bạc ấy đi thì lại ăn mày sớm!" (LKhai; 1)',
  },
  {
    word: "ăn mày",
    part_of_speech: "động từ",
    meaning:
      "(cũ) cầu xin của thánh, của Phật, theo tín ngưỡng: ăn mày cửa Phật",
    example: "ăn mày cửa Phật",
  },
  {
    word: "ăn mày đòi xôi gấc",
    part_of_speech: "",
    meaning:
      "ví trường hợp đã thiếu thốn cùng cực mà còn muốn đòi hỏi cho được thứ này thứ nọ một cách quá đáng, không biết thân biết phận: ăn mày đòi xôi gấc, ăn chực đòi bánh chưng (tng)",
    example: "ăn mày đòi xôi gấc, ăn chực đòi bánh chưng (tng)",
  },
  {
    word: "ăn mặc",
    part_of_speech: "động từ",
    meaning: "mặc (nói khái quát): ăn mặc gọn gàng * thích ăn mặc đẹp",
    example: "ăn mặc gọn gàng * thích ăn mặc đẹp",
  },
  {
    word: "ăn may",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) có được, đạt được do may mắn chứ không phải do thực lực: trận ấy thắng được là do ăn may",
    example: "trận ấy thắng được là do ăn may",
  },
  {
    word: "ăn mòn",
    part_of_speech: "động từ",
    meaning:
      "(hiện tượng) làm cho bị mòn dần hoặc bị phá huỷ ở lớp bề mặt, do tác dụng hoá học hoặc điện hoá học: acid ăn mòn sắt",
    example: "acid ăn mòn sắt",
  },
  {
    word: "ăn mừng",
    part_of_speech: "động từ",
    meaning:
      "ăn uống, vui chơi nhân dịp có việc vui mừng: mở tiệc ăn mừng chiến thắng",
    example: "mở tiệc ăn mừng chiến thắng",
  },
  {
    word: "ăn nhằm",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) như ăn thua: ngần ấy thì ăn nhằm gì!",
    example: "ngần ấy thì ăn nhằm gì!",
  },
  {
    word: "ăn nhập",
    part_of_speech: "động từ",
    meaning:
      "liên quan, phù hợp với nhau trong cùng một yêu cầu, một nội dung: hỏi một câu chẳng ăn nhập gì * bài viết không ăn nhập với chủ đề",
    example: "hỏi một câu chẳng ăn nhập gì * bài viết không ăn nhập với chủ đề",
  },
  {
    word: "ăn năn",
    part_of_speech: "động từ",
    meaning:
      'cảm thấy day dứt, đau khổ về lỗi lầm của mình: biết ăn năn hối lỗi * "Ăn năn thì sự đã rồi!, Nể lòng người cũ, vâng lời một phen." (TKiều)',
    example:
      'biết ăn năn hối lỗi * "Ăn năn thì sự đã rồi!, Nể lòng người cũ, vâng lời một phen." (TKiều)',
  },
  {
    word: "ăn nhịp",
    part_of_speech: "động từ",
    meaning:
      "có sự hoà hợp, ăn khớp với nhau về nhịp điệu, tiết tấu: tiếng hát ăn nhịp với tiếng đàn",
    example: "tiếng hát ăn nhịp với tiếng đàn",
  },
  {
    word: "ăn nhậu",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) ăn uống, chè chén: suốt ngày chỉ chơi bời ăn nhậu",
    example: "suốt ngày chỉ chơi bời ăn nhậu",
  },
  {
    word: "ăn nói",
    part_of_speech: "động từ",
    meaning:
      'nói năng (về mặt coi như có khả năng nào đó trong việc giao tiếp bằng lời): ăn nói lưu loát * có tài ăn nói * "Quái, tao lạ cái ông nghị nhà mày ăn nói lắm giọng!" (NgCHoan; 4)',
    example:
      'ăn nói lưu loát * có tài ăn nói * "Quái, tao lạ cái ông nghị nhà mày ăn nói lắm giọng!" (NgCHoan; 4)',
  },
  {
    word: "ăn quỵt",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) cố tình ăn không, lấy không, không chịu trả cái lẽ ra phải trả: vay rồi ăn quỵt luôn, không trả * ăn quỵt tiền công của thợ",
    example: "vay rồi ăn quỵt luôn, không trả * ăn quỵt tiền công của thợ",
  },
  {
    word: "ăn ở",
    part_of_speech: "động từ",
    meaning: "ăn và ở (nói khái quát): thu xếp chỗ ăn ở",
    example: "thu xếp chỗ ăn ở",
  },
  {
    word: "ăn ở",
    part_of_speech: "động từ",
    meaning:
      "(vợ chồng) lấy nhau, sống chung với nhau: ăn ở với nhau được hai mặt con * ăn ở với nhau như vợ chồng",
    example: "ăn ở với nhau được hai mặt con * ăn ở với nhau như vợ chồng",
  },
  {
    word: "ăn ở",
    part_of_speech: "động từ",
    meaning:
      'cư xử, đối xử trong đời sống: ăn ở hiền lành * biết cách ăn ở * "Trách trời ăn ở không cân, Để cho hoa sói đứng sân chịu sầu." (ca dao)',
    example:
      'ăn ở hiền lành * biết cách ăn ở * "Trách trời ăn ở không cân, Để cho hoa sói đứng sân chịu sầu." (ca dao)',
  },
  {
    word: "ăn rỗi",
    part_of_speech: "động từ",
    meaning: "(tằm lúc gần chín) ăn khoẻ và rất nhanh: ăn như tằm ăn rỗi (tng)",
    example: "ăn như tằm ăn rỗi (tng)",
  },
  {
    word: "ăn rơ",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) hợp ý nhau, tạo ra sự nhất trí trong hành động, lời nói (thường dùng với nghĩa xấu): kế toán ăn rơ với giám đốc để rút tiền công quỹ",
    example: "kế toán ăn rơ với giám đốc để rút tiền công quỹ",
  },
  {
    word: "ăn sương",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) kiếm sống bằng nghề mãi dâm hoặc ăn trộm về ban đêm: gái ăn sương",
    example: "gái ăn sương",
  },
  {
    word: "ăn theo",
    part_of_speech: "động từ",
    meaning:
      "được hưởng một số chế độ cung cấp về lương thực, thực phẩm, theo chế độ cung cấp dành cho người có trách nhiệm nuôi dưỡng (theo chế độ bao cấp thời trước): con nhỏ và mẹ già được hưởng suất ăn theo",
    example: "con nhỏ và mẹ già được hưởng suất ăn theo",
  },
  {
    word: "ăn theo",
    part_of_speech: "động từ",
    meaning:
      '(khẩu ngữ) được hưởng hoặc có được nhờ dựa theo cái khác, người khác, không phải do tự bản thân có hoặc làm nên: "Nước lên cá đuối ăn theo, Lái buôn hết gạo bỏ neo cầm chừng." (ca dao)',
    example:
      'Nước lên cá đuối ăn theo, Lái buôn hết gạo bỏ neo cầm chừng." (ca dao)',
  },
  {
    word: "ăn tạp",
    part_of_speech: "động từ",
    meaning:
      "ăn được nhiều loại thức ăn khác nhau, không kén chọn: lợn là động vật ăn tạp",
    example: "lợn là động vật ăn tạp",
  },
  {
    word: "ăn thề",
    part_of_speech: "động từ",
    meaning:
      "cùng thề với nhau một cách trang nghiêm: làm lễ ăn thề * cắt máu ăn thề",
    example: "làm lễ ăn thề * cắt máu ăn thề",
  },
  {
    word: "ăn thông",
    part_of_speech: "động từ",
    meaning:
      "thông với nhau một mạch từ nơi nọ đến nơi kia, không bị cản trở, ngăn cách: các hang động ăn thông với nhau",
    example: "các hang động ăn thông với nhau",
  },
  {
    word: "ăn thua",
    part_of_speech: "động từ",
    meaning:
      "tranh phần thắng (nói khái quát): quyết một phen ăn thua với địch * chơi vui, không cốt ăn thua",
    example: "quyết một phen ăn thua với địch * chơi vui, không cốt ăn thua",
  },
  {
    word: "ăn thua",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đạt được kết quả hay có một tác dụng nào đó (nói khái quát): làm như thế thì không ăn thua * ngần này tiền thì ăn thua gì",
    example: "làm như thế thì không ăn thua * ngần này tiền thì ăn thua gì",
  },
  {
    word: "ăn tiêu",
    part_of_speech: "động từ",
    meaning:
      "chi tiêu cho đời sống hằng ngày: ăn tiêu tằn tiện * phải làm thêm mới đủ tiền ăn tiêu hằng ngày",
    example: "ăn tiêu tằn tiện * phải làm thêm mới đủ tiền ăn tiêu hằng ngày",
  },
  {
    word: "ăn tiền",
    part_of_speech: "động từ",
    meaning: "nhận của hối lộ: ăn tiền của dân",
    example: "ăn tiền của dân",
  },
  {
    word: "ăn tiền",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) được việc, có kết quả tốt: làm thế mới ăn tiền",
    example: "làm thế mới ăn tiền",
  },
  {
    word: "ăn tiền",
    part_of_speech: "động từ",
    meaning: "(phương ngữ, khẩu ngữ) lấy tiền công: làm mướn ăn tiền",
    example: "làm mướn ăn tiền",
  },
  {
    word: "ăn trộm",
    part_of_speech: "động từ",
    meaning:
      "lấy của người khác một cách lén lút, nhân lúc đêm hôm hoặc lúc vắng người: vào vườn ăn trộm quả * ăn trộm đồ của người khác",
    example: "vào vườn ăn trộm quả * ăn trộm đồ của người khác",
  },
  {
    word: "ăn tuyết nằm sương",
    part_of_speech: "",
    meaning:
      '(văn chương) như ăn gió nằm mưa: "Xiết bao ăn tuyết nằm sương, Màn trời chiếu đất dặm trường lao đao." (LVT)',
    example:
      'Xiết bao ăn tuyết nằm sương, Màn trời chiếu đất dặm trường lao đao." (LVT)',
  },
  {
    word: "ăn tục nói phét",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) ăn nói thô tục, ba hoa (thiếu văn hoá): chỉ được cái ăn tục nói phét!",
    example: "chỉ được cái ăn tục nói phét!",
  },
  {
    word: "ăn uống",
    part_of_speech: "động từ",
    meaning: "ăn và uống (nói khái quát): ăn uống điều độ * chưa ăn uống gì",
    example: "ăn uống điều độ * chưa ăn uống gì",
  },
  {
    word: "ăn uống",
    part_of_speech: "động từ",
    meaning:
      "ăn uống nhân dịp gì: ăn uống linh đình * tổ chức ăn uống mừng tân gia",
    example: "ăn uống linh đình * tổ chức ăn uống mừng tân gia",
  },
  {
    word: "ăn vạ",
    part_of_speech: "động từ",
    meaning:
      'ở ì, nằm ì ra để đòi cho kì được hoặc để bắt đền: "(...) mụ te tái chạy đến tận nhà chửi bới rồi nằm lăn ra cổng ăn vạ, vu cho đánh." (NgKhải; 21)',
    example:
      '(...) mụ te tái chạy đến tận nhà chửi bới rồi nằm lăn ra cổng ăn vạ, vu cho đánh." (NgKhải; 21)',
  },
  {
    word: "ăn vay",
    part_of_speech: "động từ",
    meaning:
      "vay mượn của người khác để sinh sống qua ngày (do bị túng thiếu): nhiều gia đình rơi vào tình trạng ăn vay",
    example: "nhiều gia đình rơi vào tình trạng ăn vay",
  },
  {
    word: "ăn vã",
    part_of_speech: "động từ",
    meaning: "chỉ ăn thức ăn, không ăn cùng với cơm: ăn vã thức ăn",
    example: "ăn vã thức ăn",
  },
  {
    word: "ăn vụng",
    part_of_speech: "động từ",
    meaning:
      "ăn lén lút, vụng trộm: mèo ăn vụng cá * đói ăn vụng, túng làm càn (tng)",
    example: "mèo ăn vụng cá * đói ăn vụng, túng làm càn (tng)",
  },
  {
    word: "ắng",
    part_of_speech: "tính từ",
    meaning:
      "có cảm giác như bị vật gì làm tắc, làm nghẹn ở cổ họng: cổ ắng lại, không nói nên lời",
    example: "cổ ắng lại, không nói nên lời",
  },
  {
    word: "ắng",
    part_of_speech: "tính từ",
    meaning: "im bặt, vắng bặt: tiếng súng ắng đi một lúc",
    example: "tiếng súng ắng đi một lúc",
  },
  {
    word: "ăn ý",
    part_of_speech: "tính từ",
    meaning:
      "hợp ý với nhau, tạo ra sự nhất trí trong hành động, lời nói: chọn bạn diễn ăn ý * đội bóng chơi thiếu ăn ý",
    example: "chọn bạn diễn ăn ý * đội bóng chơi thiếu ăn ý",
  },
  {
    word: "ăn xin",
    part_of_speech: "động từ",
    meaning: "như ăn mày: dắt nhau đi ăn xin",
    example: "dắt nhau đi ăn xin",
  },
  {
    word: "ăn xổi ở thì",
    part_of_speech: "",
    meaning:
      'chỉ tính chuyện tạm bợ trước mắt, không suy nghĩ đến chuyện lâu dài: "Phải điều ăn xổi ở thì, Tiết trăm năm nỡ bỏ đi một ngày." (TKiều)',
    example:
      'Phải điều ăn xổi ở thì, Tiết trăm năm nỡ bỏ đi một ngày." (TKiều)',
  },
  {
    word: "ẳng",
    part_of_speech: "động từ",
    meaning:
      "từ mô phỏng tiếng chó kêu khi bị đánh: con chó ẳng lên một tiếng như bị đánh",
    example: "con chó ẳng lên một tiếng như bị đánh",
  },
  {
    word: "ăn xài",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) như ăn tiêu: ăn xài hoang phí",
    example: "ăn xài hoang phí",
  },
  {
    word: "ăn xổi",
    part_of_speech: "động từ",
    meaning:
      "(cà, dưa vừa mới muối) ăn ngay, không phải đợi chế biến lâu: cà muối ăn xổi",
    example: "cà muối ăn xổi",
  },
  {
    word: "ăn xổi",
    part_of_speech: "động từ",
    meaning: "muốn đạt được kết quả ngay vì nóng vội: tư tưởng ăn xổi",
    example: "tư tưởng ăn xổi",
  },
  {
    word: "ằng ặc",
    part_of_speech: "tính từ",
    meaning:
      'từ mô phỏng âm thanh phát ra trầm đục, yếu ớt, nghe không thành tiếng như bị tắc nghẹt trong cổ họng: kêu ằng ặc * "Ninh khóc ằng ặc như người nuốt phải ngụm gì đắng quá, nó quánh vào cổ họng." (NCao; 33)',
    example:
      'kêu ằng ặc * "Ninh khóc ằng ặc như người nuốt phải ngụm gì đắng quá, nó quánh vào cổ họng." (NCao; 33)',
  },
  {
    word: "ắp",
    part_of_speech: "tính từ",
    meaning:
      "đầy đến mức không còn có thể chứa thêm vào được nữa: ruộng ắp nước * một bát đầy ắp thức ăn",
    example: "ruộng ắp nước * một bát đầy ắp thức ăn",
  },
  {
    word: "ăng ẳng",
    part_of_speech: "động từ",
    meaning:
      "từ mô phỏng tiếng chó kêu to và liên tiếp từng hồi (khi bị đánh, bị đau): con chó bị đánh, kêu lên ăng ẳng",
    example: "con chó bị đánh, kêu lên ăng ẳng",
  },
  {
    word: "ắng cổ",
    part_of_speech: "động từ",
    meaning:
      "chịu im, không còn nói được gì nữa: chứng cớ rành rành nên ắng cổ, không cãi được nữa",
    example: "chứng cớ rành rành nên ắng cổ, không cãi được nữa",
  },
  {
    word: "ắt hẳn",
    part_of_speech: "phụ từ",
    meaning:
      'như ắt (nhưng ý khẳng định hơn): nếu nóng vội, ắt hẳn sẽ hỏng việc * "Làm ơn ắt hẳn nên ơn, Trời nào phụ kẻ có nhơn bao giờ." (ca dao)',
    example:
      'nếu nóng vội, ắt hẳn sẽ hỏng việc * "Làm ơn ắt hẳn nên ơn, Trời nào phụ kẻ có nhơn bao giờ." (ca dao)',
  },
  {
    word: "ắng lặng",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái im bặt mọi âm thanh, tiếng động: bốn bề ắng lặng như tờ",
    example: "bốn bề ắng lặng như tờ",
  },
  {
    word: "ắt",
    part_of_speech: "phụ từ",
    meaning:
      'từ biểu thị ý khẳng định điều cho là chắc chắn sẽ xảy ra với điều kiện đã nói đến; chắc hẳn là: nếu làm được, ắt anh ta đã làm * "Trầu không vôi ắt trầu lạt, Cau không hạt, ắt cau già." (ca dao)',
    example:
      'nếu làm được, ắt anh ta đã làm * "Trầu không vôi ắt trầu lạt, Cau không hạt, ắt cau già." (ca dao)',
  },
  {
    word: "âm",
    part_of_speech: "danh từ",
    meaning:
      "một trong hai mặt đối lập lớn (thường quan niệm là mặt phủ định, tiêu cực; đối lập với dương là mặt khẳng định, tích cực) của muôn vật tồn tại trong vũ trụ, theo quan niệm của triết học cổ đại phương Đông (như đêm đối lập với ngày, nữ đối lập với nam, chết đối lập với sống, v.v.): phần âm của mố cầu * chiều âm của một trục",
    example: "phần âm của mố cầu * chiều âm của một trục",
  },
  {
    word: "âm",
    part_of_speech: "tính từ",
    meaning:
      "(sự kiện) mang tính chất tĩnh, lạnh, hay (sự vật) thuộc về nữ tính hoặc về huyết dịch, theo quan niệm của đông y: thang thuốc bổ âm",
    example: "thang thuốc bổ âm",
  },
  {
    word: "âm",
    part_of_speech: "tính từ",
    meaning:
      "bé hơn số không; phân biệt với dương: kết quả là một số âm * nhiệt độ xuống đến âm 10 độ",
    example: "kết quả là một số âm * nhiệt độ xuống đến âm 10 độ",
  },
  {
    word: "âm",
    part_of_speech: "danh từ",
    meaning: "cái mà tai có thể nghe được: thu âm * máy ghi âm",
    example: "thu âm * máy ghi âm",
  },
  {
    word: "âm",
    part_of_speech: "danh từ",
    meaning: "đơn vị ngữ âm nhỏ nhất: đánh vần từng âm một",
    example: "đánh vần từng âm một",
  },
  {
    word: "âm",
    part_of_speech: "động từ",
    meaning: "(hiếm) vọng, dội lại: tiếng hổ gầm âm vào vách núi",
    example: "tiếng hổ gầm âm vào vách núi",
  },
  {
    word: "ấm",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng bằng đất nung hoặc kim loại, có vòi, dùng để đựng nước uống hoặc để đun nước, sắc thuốc: sắc thuốc bằng ấm đất * pha ấm trà * đun một ấm nước",
    example: "sắc thuốc bằng ấm đất * pha ấm trà * đun một ấm nước",
  },
  {
    word: "ắt là",
    part_of_speech: "phụ từ",
    meaning:
      'như ắt hẳn: "Mình không lấy qua, ắt là mình thiệt, Qua không lấy mình, qua biết lấy ai." (ca dao)',
    example:
      'Mình không lấy qua, ắt là mình thiệt, Qua không lấy mình, qua biết lấy ai." (ca dao)',
  },
  {
    word: "ẩm",
    part_of_speech: "tính từ",
    meaning:
      "có thấm một ít nước hoặc có chứa nhiều hơi nước: quần áo còn ẩm, chưa khô * thuốc chống ẩm",
    example: "quần áo còn ẩm, chưa khô * thuốc chống ẩm",
  },
  {
    word: "ầm",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng động to, trầm và vang xa: súng nổ ầm trời * cây đổ đánh ầm một cái",
    example: "súng nổ ầm trời * cây đổ đánh ầm một cái",
  },
  {
    word: "ầm",
    part_of_speech: "tính từ",
    meaning: "to tiếng và ồn ào: gắt ầm lên * hét ầm nhà * đồn ầm cả lên",
    example: "gắt ầm lên * hét ầm nhà * đồn ầm cả lên",
  },
  {
    word: "ầm ã",
    part_of_speech: "tính từ",
    meaning:
      '(hiếm) có nhiều tiếng to và ồn, rền liên tiếp (nói khái quát): tiếng trực thăng ầm ã * "(...) những làn sóng không bao giờ mệt mỏi ầm ã đập vào bờ." (NgTNTú; 1)',
    example:
      'tiếng trực thăng ầm ã * "(...) những làn sóng không bao giờ mệt mỏi ầm ã đập vào bờ." (NgTNTú; 1)',
  },
  {
    word: "ậm ạch",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả dáng vẻ chuyển động, vận động nặng nề, khó nhọc, chậm chạp: chiếc xe ậm ạch bò lên dốc * công việc vẫn ậm ạch, chưa có gì tiến triển",
    example:
      "chiếc xe ậm ạch bò lên dốc * công việc vẫn ậm ạch, chưa có gì tiến triển",
  },
  {
    word: "âm âm",
    part_of_speech: "tính từ",
    meaning:
      'từ mô phỏng tiếng động từ xa vọng tới, nghe rền vang, đều đều và kéo dài: "Anh (…) nằm nghe tiếng rừng đêm âm âm như tiếng sóng vỗ bờ xa." (ĐGiỏi; 5)',
    example:
      'Anh (…) nằm nghe tiếng rừng đêm âm âm như tiếng sóng vỗ bờ xa." (ĐGiỏi; 5)',
  },
  {
    word: "âm âm",
    part_of_speech: "tính từ",
    meaning: "như âm u: bầu trời âm âm một màu tro",
    example: "bầu trời âm âm một màu tro",
  },
  {
    word: "ấm áp",
    part_of_speech: "tính từ",
    meaning:
      'ấm và gây cảm giác dễ chịu (nói khái quát): nắng xuân ấm áp * giọng đọc ấm áp, truyền cảm * "Họ ngồi bên nhau, không nói, nhưng cũng thấy ấm áp hơn." (NgĐThi; 6)',
    example:
      'nắng xuân ấm áp * giọng đọc ấm áp, truyền cảm * "Họ ngồi bên nhau, không nói, nhưng cũng thấy ấm áp hơn." (NgĐThi; 6)',
  },
  {
    word: "ấm ách",
    part_of_speech: "tính từ",
    meaning:
      "(bụng) đầy ứ, gây cảm giác tức, khó chịu: bụng ấm ách như bị đầy hơi * tức ấm ách",
    example: "bụng ấm ách như bị đầy hơi * tức ấm ách",
  },
  {
    word: "âm ấm",
    part_of_speech: "tính từ",
    meaning: "hơi ấm: pha nước âm ấm * giọng hát âm ấm",
    example: "pha nước âm ấm * giọng hát âm ấm",
  },
  {
    word: "ầm ầm",
    part_of_speech: "tính từ",
    meaning:
      'từ mô phỏng tiếng động vang to và rền liên tiếp: cười nói ầm ầm * "Đổi hoa lót xuống chiếu nằm, Bướm ong bay lại ầm ầm tứ vi!" (TKiều)',
    example:
      'cười nói ầm ầm * "Đổi hoa lót xuống chiếu nằm, Bướm ong bay lại ầm ầm tứ vi!" (TKiều)',
  },
  {
    word: "âm ẩm",
    part_of_speech: "tính từ",
    meaning: "hơi ẩm: quần áo phơi vẫn còn âm ẩm",
    example: "quần áo phơi vẫn còn âm ẩm",
  },
  {
    word: "âm công",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) như âm đức: "Một niềm vì nước, vì dân, Âm công cất một đồng cân đã già?" (TKiều)',
    example:
      'Một niềm vì nước, vì dân, Âm công cất một đồng cân đã già?" (TKiều)',
  },
  {
    word: "ấm cúng",
    part_of_speech: "tính từ",
    meaning:
      "có tác dụng gây cảm giác thân mật, dễ chịu: căn phòng ấm cúng * cảnh gia đình ấm cúng",
    example: "căn phòng ấm cúng * cảnh gia đình ấm cúng",
  },
  {
    word: "âm cực dương hồi",
    part_of_speech: "",
    meaning:
      'khí âm đã đến cùng cực thì khí dương trở lại, vận đen đến cùng cực thì sẽ lại đến vận đỏ: "Đời người đến thế thì thôi, Trong cơ âm cực dương hồi khôn hay." (TKiều)',
    example:
      'Đời người đến thế thì thôi, Trong cơ âm cực dương hồi khôn hay." (TKiều)',
  },
  {
    word: "âm điệu",
    part_of_speech: "danh từ",
    meaning:
      "độ cao khác nhau của chuỗi âm thanh gây được một ấn tượng, một cảm giác nào đó: âm điệu du dương * âm điệu trầm hùng của bài thơ",
    example: "âm điệu du dương * âm điệu trầm hùng của bài thơ",
  },
  {
    word: "ấm đầu",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) trẻ con) hơi sốt, hơi ốm (lối nói kiêng tránh): thằng bé bị ấm đầu",
    example: "thằng bé bị ấm đầu",
  },
  {
    word: "ấm đầu",
    part_of_speech: "tính từ",
    meaning:
      "có những biểu hiện về tính tình, hành vi không bình thường: ấm đầu hay sao mà làm thế?",
    example: "ấm đầu hay sao mà làm thế?",
  },
  {
    word: "âm đức",
    part_of_speech: "danh từ",
    meaning:
      "việc làm tốt cho người khác, có thể người đời không biết, nhưng con cháu sau này sẽ được hưởng cái đức để lại, theo tín ngưỡng dân gian: nhờ âm đức của tổ tông * thiếu âm đức",
    example: "nhờ âm đức của tổ tông * thiếu âm đức",
  },
  {
    word: "âm hưởng",
    part_of_speech: "danh từ",
    meaning: "(Ít dùng) tiếng vang.",
    example: "âm hưởng của đàn bầu * âm hưởng của bài thơ",
  },
  {
    word: "âm ỉ",
    part_of_speech: "tính từ",
    meaning:
      'ngấm ngầm, không dữ dội, nhưng kéo dài: bụng đau âm ỉ * "Một mình âm ỉ đêm chầy, Đĩa dầu vơi, nước mắt đầy, năm canh." (TKiều)',
    example:
      'bụng đau âm ỉ * "Một mình âm ỉ đêm chầy, Đĩa dầu vơi, nước mắt đầy, năm canh." (TKiều)',
  },
  {
    word: "ầm ĩ",
    part_of_speech: "tính từ",
    meaning:
      "ồn ào, náo động, gây cảm giác khó chịu: quát tháo ầm ĩ * reo hò ầm ĩ * chưa hiểu mô tê gì đã làm ầm ĩ lên",
    example:
      "quát tháo ầm ĩ * reo hò ầm ĩ * chưa hiểu mô tê gì đã làm ầm ĩ lên",
  },
  {
    word: "ầm ì",
    part_of_speech: "tính từ",
    meaning:
      'từ mô phỏng tiếng động nghe nhỏ, rền đều đều và kéo dài từ xa vọng tới: tiếng máy bay ầm ì ở chân trời * "Tiếng sấm ầm ì như vọng lại từ lòng đất." (LVThảo; 8)',
    example:
      'tiếng máy bay ầm ì ở chân trời * "Tiếng sấm ầm ì như vọng lại từ lòng đất." (LVThảo; 8)',
  },
  {
    word: "ẩm mốc",
    part_of_speech: "tính từ",
    meaning:
      "ẩm và có mốc do thiếu ánh sáng hoặc do không được chăm sóc (nói khái quát): căn phòng ẩm mốc * càng vào sâu trong hang càng ẩm mốc",
    example: "căn phòng ẩm mốc * càng vào sâu trong hang càng ẩm mốc",
  },
  {
    word: "âm nhạc",
    part_of_speech: "danh từ",
    meaning:
      "nghệ thuật dùng những hình thức tổ hợp âm thanh nhất định diễn đạt tư tưởng và tình cảm: người sành âm nhạc * buổi biểu diễn âm nhạc dân tộc",
    example: "người sành âm nhạc * buổi biểu diễn âm nhạc dân tộc",
  },
  {
    word: "âm lịch",
    part_of_speech: "danh từ",
    meaning:
      "lịch tính thời gian theo sự chuyển động của Mặt Trăng xung quanh Trái Đất, lấy thời gian Mặt Trăng đi hết một vòng (29 ngày 12 giờ 44 phút) làm một tháng, tháng thiếu 29 ngày, tháng đủ 30 ngày, ngày không trăng làm ngày đầu tháng, ngày trăng tròn làm ngày giữa tháng: một tháng âm lịch có 29 hoặc 30 ngày",
    example: "một tháng âm lịch có 29 hoặc 30 ngày",
  },
  {
    word: "âm lịch",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi thông thường của âm dương lịch dùng phổ biến trước đây và ngày nay còn dùng trong dân gian: Tết âm lịch",
    example: "Tết âm lịch",
  },
  {
    word: "âm mưu",
    part_of_speech: "danh từ",
    meaning:
      "mưu kế ngầm (làm việc xấu, việc phi nghĩa): một âm mưu đen tối * phá tan âm mưu của địch",
    example: "một âm mưu đen tối * phá tan âm mưu của địch",
  },
  {
    word: "âm mưu",
    part_of_speech: "động từ",
    meaning: "có âm mưu: bọn phản động âm mưu phá hoại",
    example: "bọn phản động âm mưu phá hoại",
  },
  {
    word: "ấm no",
    part_of_speech: "tính từ",
    meaning:
      "đầy đủ về vật chất, như đủ ăn, đủ mặc (nói khái quát): cuộc sống ấm no",
    example: "cuộc sống ấm no",
  },
  {
    word: "ấm oái",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng nói, tiếng kêu của nhiều người cùng một lúc, nghe chói tai: bọn trẻ cãi nhau ấm oái",
    example: "bọn trẻ cãi nhau ấm oái",
  },
  {
    word: "ẩm sì",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) rất ẩm: quần áo ẩm sì * nền đất ẩm sì",
    example: "quần áo ẩm sì * nền đất ẩm sì",
  },
  {
    word: "ấm ớ",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) (thái độ) tỏ ra không chắc chắn, không hẳn là biết, nhưng cũng không hẳn là không biết: hỏi cái gì cũng ấm ớ",
    example: "hỏi cái gì cũng ấm ớ",
  },
  {
    word: "ấm ớ",
    part_of_speech: "",
    meaning:
      "(lối làm việc) đại khái, không rõ ràng, không đâu vào đâu: học hành ấm ớ",
    example: "học hành ấm ớ",
  },
  {
    word: "âm phủ",
    part_of_speech: "danh từ",
    meaning:
      'cõi âm, thế giới của linh hồn người chết, theo tín ngưỡng dân gian: tiền âm phủ * "Vua Ngô băm sáu tán vàng, Chết xuống âm phủ chẳng mang được gì." (ca dao)',
    example:
      'tiền âm phủ * "Vua Ngô băm sáu tán vàng, Chết xuống âm phủ chẳng mang được gì." (ca dao)',
  },
  {
    word: "âm tần",
    part_of_speech: "danh từ",
    meaning: "tần số âm thanh: phần khuếch đại âm tần của radio và ampli",
    example: "phần khuếch đại âm tần của radio và ampli",
  },
  {
    word: "âm thanh",
    part_of_speech: "danh từ",
    meaning:
      'âm (nói khái quát): chuỗi âm thanh xô bồ  * tốc độ âm thanh * "Nó lắng nghe những âm thanh dội lại từ phía trước mặt." (NgThi; 2)',
    example:
      'chuỗi âm thanh xô bồ  * tốc độ âm thanh * "Nó lắng nghe những âm thanh dội lại từ phía trước mặt." (NgThi; 2)',
  },
  {
    word: "ẩm thực",
    part_of_speech: "động từ",
    meaning: "ăn uống: văn hoá ẩm thực * nghệ thuật ẩm thực",
    example: "văn hoá ẩm thực * nghệ thuật ẩm thực",
  },
  {
    word: "ẩm thấp",
    part_of_speech: "tính từ",
    meaning:
      "ẩm, do đọng nhiều hơi nước (nói khái quát): khí hậu ẩm thấp * ngôi nhà tối tăm, ẩm thấp",
    example: "khí hậu ẩm thấp * ngôi nhà tối tăm, ẩm thấp",
  },
  {
    word: "âm thầm",
    part_of_speech: "tính từ",
    meaning:
      'lặng lẽ trong hoạt động, không tỏ ra cho người khác biết: âm thầm hi sinh * đau khổ âm thầm * "Trong cung quế âm thầm chiếc bóng, Đêm năm canh trông ngóng lần lần." (CO)',
    example:
      'âm thầm hi sinh * đau khổ âm thầm * "Trong cung quế âm thầm chiếc bóng, Đêm năm canh trông ngóng lần lần." (CO)',
  },
  {
    word: "âm ti",
    part_of_speech: "danh từ",
    meaning:
      'cõi âm, thế giới của linh hồn người chết, theo tín ngưỡng dân gian: tiền âm phủ * "Vua Ngô băm sáu tán vàng, Chết xuống âm phủ chẳng mang được gì." (ca dao)',
    example:
      'tiền âm phủ * "Vua Ngô băm sáu tán vàng, Chết xuống âm phủ chẳng mang được gì." (ca dao)',
  },
  {
    word: "âm tiết",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị phát âm tự nhiên nhỏ nhất trong ngôn ngữ: sạch sành sanh' là từ láy có ba âm tiết",
    example: "sạch sành sanh' là từ láy có ba âm tiết",
  },
  {
    word: "âm tính",
    part_of_speech: "tính từ",
    meaning:
      "(kết quả xét nghiệm) không thấy có mầm bệnh đối với một số bệnh nào đó, hoặc không thấy có phản ứng đối với một số thuốc đặc biệt nào đó; đối lập với dương tính: xét nghiệm cho kết quả âm tính",
    example: "xét nghiệm cho kết quả âm tính",
  },
  {
    word: "âm u",
    part_of_speech: "tính từ",
    meaning:
      "(khung cảnh) thiếu ánh sáng tự nhiên, gây một cảm giác nặng nề: rừng núi âm u * bầu trời âm u",
    example: "rừng núi âm u * bầu trời âm u",
  },
  {
    word: "âm ty",
    part_of_speech: "danh từ",
    meaning:
      'cõi âm, thế giới của linh hồn người chết, theo tín ngưỡng dân gian: tiền âm phủ * "Vua Ngô băm sáu tán vàng, Chết xuống âm phủ chẳng mang được gì." (ca dao)',
    example:
      'tiền âm phủ * "Vua Ngô băm sáu tán vàng, Chết xuống âm phủ chẳng mang được gì." (ca dao)',
  },
  {
    word: "Âm ty",
    part_of_speech: "danh từ",
    meaning:
      'cõi âm, thế giới của linh hồn người chết, theo tín ngưỡng dân gian: tiền âm phủ * "Vua Ngô băm sáu tán vàng, Chết xuống âm phủ chẳng mang được gì." (ca dao)',
    example:
      'tiền âm phủ * "Vua Ngô băm sáu tán vàng, Chết xuống âm phủ chẳng mang được gì." (ca dao)',
  },
  {
    word: "căn số",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) như số phận: "Phải chi lên được trên trời, Để xem căn số đổi dời về đâu?" (ca dao)',
    example:
      'Phải chi lên được trên trời, Để xem căn số đổi dời về đâu?" (ca dao)',
  },
  {
    word: "cắn rứt",
    part_of_speech: "động từ",
    meaning: "giày vò day dứt, không để cho yên: lương tâm bị cắn rứt",
    example: "lương tâm bị cắn rứt",
  },
  {
    word: "cắn xé",
    part_of_speech: "động từ",
    meaning:
      "cắn và xé làm cho rách nát, đau đớn (nói khái quát): đàn chó sói cắn xé nhau * lương tâm bị giày vò, cắn xé (b)",
    example: "đàn chó sói cắn xé nhau * lương tâm bị giày vò, cắn xé (b)",
  },
  {
    word: "cẳng",
    part_of_speech: "danh từ",
    meaning: "(Khẩu ngữ) chân người hoặc súc vật: co cẳng chạy * gặm cẳng gà",
    example: "co cẳng chạy * gặm cẳng gà",
  },
  {
    word: "căn vặn",
    part_of_speech: "động từ",
    meaning:
      'gạn hỏi cho đến cùng, cốt cho lộ ra sự việc: căn vặn cho ra lẽ * "Cùng nhau căn vặn đến điều, Chỉ non thề bể nặng gieo đến lời." (TKiều)',
    example:
      'căn vặn cho ra lẽ * "Cùng nhau căn vặn đến điều, Chỉ non thề bể nặng gieo đến lời." (TKiều)',
  },
  {
    word: "căng",
    part_of_speech: "động từ",
    meaning:
      "kéo cho thật thẳng ra theo bề dài hoặc theo mọi hướng trên một bề mặt: căng dây * căng mặt trống * căng bạt che mưa",
    example: "căng dây * căng mặt trống * căng bạt che mưa",
  },
  {
    word: "căng",
    part_of_speech: "động từ",
    meaning:
      "tập trung sức hoạt động đến cao độ vào một hướng nhất định: căng hết sức ra mà làm * căng mắt nhìn trong bóng tối",
    example: "căng hết sức ra mà làm * căng mắt nhìn trong bóng tối",
  },
  {
    word: "căng",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái dãn thẳng ra đến mức cao nhất, do sức kéo hoặc do lực ép từ bên trong: quả bóng bơm rất căng * no căng bụng * vú căng sữa",
    example: "quả bóng bơm rất căng * no căng bụng * vú căng sữa",
  },
  {
    word: "căng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ở mức độ cao trên mức bình thường: làm việc rất căng * tình hình coi bộ vẫn còn căng",
    example: "làm việc rất căng * tình hình coi bộ vẫn còn căng",
  },
  {
    word: "căng",
    part_of_speech: "tính từ",
    meaning:
      "(đường đạn, đường bóng) thẳng, vì được phóng mạnh: đường bóng căng và xoáy",
    example: "đường bóng căng và xoáy",
  },
  {
    word: "cắn trắt",
    part_of_speech: "",
    meaning:
      "cắn vỡ vỏ hạt thóc để nhằn lấy từng hạt gạo: hộ pháp cắn trắt (tng)",
    example: "hộ pháp cắn trắt (tng)",
  },
  {
    word: "căng cắc",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng phát ra liên tiếp, vang và đanh gọn, như tiếng của vật cứng, giòn bị bẻ gãy hay bị nghiền vỡ: nhai xương căng cắc",
    example: "nhai xương căng cắc",
  },
  {
    word: "căng thẳng",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái sự chú ý, sự suy nghĩ được tập trung đến mức rất cao: đầu óc căng thẳng * làm việc căng thẳng * thần kinh quá căng thẳng vì lo lắng",
    example:
      "đầu óc căng thẳng * làm việc căng thẳng * thần kinh quá căng thẳng vì lo lắng",
  },
  {
    word: "căng thẳng",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái mâu thuẫn phát triển đến cao độ: quan hệ căng thẳng * tình hình chiến sự ngày càng trở nên căng thẳng",
    example:
      "quan hệ căng thẳng * tình hình chiến sự ngày càng trở nên căng thẳng",
  },
  {
    word: "cặp bồ",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) có quan hệ yêu đương (thường là không chính đáng): cặp bồ với một thương gia giàu có",
    example: "cặp bồ với một thương gia giàu có",
  },
  {
    word: "cắp",
    part_of_speech: "động từ",
    meaning: "kẹp vào nách hay bên sườn: cắp sách đi học * cắp thúng đi chợ",
    example: "cắp sách đi học * cắp thúng đi chợ",
  },
  {
    word: "cắp",
    part_of_speech: "động từ",
    meaning:
      "dùng móng hoặc càng, v.v. kẹp chặt: diều hâu cắp gà con * bị cua cắp",
    example: "diều hâu cắp gà con * bị cua cắp",
  },
  {
    word: "cắp",
    part_of_speech: "động từ",
    meaning: "lấy của người một cách lén lút, nhằm lúc sơ hở: lấy cắp",
    example: "lấy cắp",
  },
  {
    word: "căng tin",
    part_of_speech: "danh từ",
    meaning:
      "nơi bán quà bánh, hàng giải khát và có thể cả một số hàng tiêu dùng, trong nội bộ một cơ quan, xí nghiệp: ăn cơm dưới căng tin",
    example: "ăn cơm dưới căng tin",
  },
  {
    word: "cặp",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp gồm hai vật, hai cá thể cùng loại đi đôi với nhau thành một thể thống nhất: cặp mắt * một cặp vợ chồng * mua một cặp bánh chưng",
    example: "cặp mắt * một cặp vợ chồng * mua một cặp bánh chưng",
  },
  {
    word: "cặp",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng để đựng sách thời trước, gồm một đế gỗ đóng vào hai khung gỗ.",
    example: "cặp mạ",
  },
  {
    word: "cặp",
    part_of_speech: "danh từ",
    meaning: "quang gồm có hai thanh tre cứng để gánh mạ, cỏ, v.v.: cặp mạ",
    example: "dùng cặp gắp than * chiếc cặp tóc",
  },
  {
    word: "cặp",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng gồm hai thanh cứng để kẹp đồ vật và giữ chặt lại: dùng cặp gắp than * chiếc cặp tóc",
    example: "cặp học sinh * cặp da * cắp cặp đi học",
  },
  {
    word: "cặp",
    part_of_speech: "động từ",
    meaning:
      "giữ chặt lại bằng cái cặp: cặp quần áo phơi trên dây cho khỏi rơi * cặp tóc lại cho gọn",
    example: "cặp quần áo phơi trên dây cho khỏi rơi * cặp tóc lại cho gọn",
  },
  {
    word: "cặp",
    part_of_speech: "động từ",
    meaning:
      "đặt nhiệt kế, thường là vào nách rồi kẹp lại, để đo thân nhiệt: cặp nhiệt kế",
    example: "cặp nhiệt kế",
  },
  {
    word: "cặp",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đi đôi, quan hệ với nhau thành một đôi: hai người cặp với nhau đã lâu",
    example: "hai người cặp với nhau đã lâu",
  },
  {
    word: "cặp",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) dọc theo, men theo: nhà xây cặp theo bờ sông * đi cặp hai bên đường",
    example: "nhà xây cặp theo bờ sông * đi cặp hai bên đường",
  },
  {
    word: "cặp díp",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) dính liền hai cái với nhau: gắp cặp díp * tiền bị cặp díp",
    example: "gắp cặp díp * tiền bị cặp díp",
  },
  {
    word: "cắp ca cắp củm",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) như cắc củm (nhưng ý nhấn mạnh hơn): cắc ca cắc củm mãi mới đủ tiền sắm cho con chiếc xe đạp",
    example: "cắc ca cắc củm mãi mới đủ tiền sắm cho con chiếc xe đạp",
  },
  {
    word: "cắp củm",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) góp nhặt, chắt chiu, dành dụm từng tí một: cắc củm từng đồng",
    example: "cắc củm từng đồng",
  },
  {
    word: "cặp kèm",
    part_of_speech: "tính từ",
    meaning: "(mắt) kém, nhìn không rõ: già rồi nên mắt cập kèm",
    example: "già rồi nên mắt cập kèm",
  },
  {
    word: "cặp lồng",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng để đựng thức ăn mang đi, bằng kim loại hoặc nhựa, thường có nhiều ngăn lồng vào nhau và quai để xách: cặp lồng cơm",
    example: "cặp lồng cơm",
  },
  {
    word: "cặp kè",
    part_of_speech: "động từ",
    meaning:
      "theo liền bên cạnh, không rời nhau: suốt ngày cặp kè với nhau như hình với bóng",
    example: "suốt ngày cặp kè với nhau như hình với bóng",
  },
  {
    word: "cắt",
    part_of_speech: "danh từ",
    meaning:
      "chim ăn thịt, nhỏ hơn diều hâu, cánh dài và nhọn, bay rất nhanh: nhanh như cắt",
    example: "nhanh như cắt",
  },
  {
    word: "cắt",
    part_of_speech: "động từ",
    meaning:
      "làm cho đứt bằng vật sắc: cắt cỏ * cắt tóc * cắt móng tay * ruột đau như cắt",
    example: "cắt cỏ * cắt tóc * cắt móng tay * ruột đau như cắt",
  },
  {
    word: "cắt",
    part_of_speech: "động từ",
    meaning:
      "thái các vị thuốc đông y theo đơn để làm thành thang thuốc: đi cắt thang thuốc bổ",
    example: "đi cắt thang thuốc bổ",
  },
  {
    word: "cắt",
    part_of_speech: "động từ",
    meaning:
      "phân thành nhiều đoạn, nhiều mảnh: đường xe lửa cắt ngang cánh đồng * cắt đội hình quân địch ra để tiêu diệt",
    example:
      "đường xe lửa cắt ngang cánh đồng * cắt đội hình quân địch ra để tiêu diệt",
  },
  {
    word: "cắt",
    part_of_speech: "động từ",
    meaning:
      "làm đứt đoạn, không để cho được liên tục, tiếp tục: cắt đứt quan hệ * cắt ngang câu nói * cắt nguồn viện trợ",
    example: "cắt đứt quan hệ * cắt ngang câu nói * cắt nguồn viện trợ",
  },
  {
    word: "cắt",
    part_of_speech: "động từ",
    meaning:
      "tách ra, làm cho rời ra khỏi: cắt một huyện để nhập vào tỉnh bên * máy bay cắt bom",
    example: "cắt một huyện để nhập vào tỉnh bên * máy bay cắt bom",
  },
  {
    word: "cắt",
    part_of_speech: "động từ",
    meaning:
      "tách ra một phần để bỏ bớt, làm cho bớt đi: bài viết bị cắt mất một đoạn * cắt những khoản chi tiêu không cần thiết",
    example:
      "bài viết bị cắt mất một đoạn * cắt những khoản chi tiêu không cần thiết",
  },
  {
    word: "cắt",
    part_of_speech: "động từ",
    meaning:
      "tách một phần dữ liệu đã được đánh dấu trong máy tính để chuyển đến một vị trí khác hoặc bỏ đi: cắt đi một đoạn văn bản * cắt một cột trong bảng",
    example: "cắt đi một đoạn văn bản * cắt một cột trong bảng",
  },
  {
    word: "cắt",
    part_of_speech: "động từ",
    meaning:
      "phân đi làm việc gì theo sự luân phiên lần lượt: cắt người canh gác",
    example: "cắt người canh gác",
  },
  {
    word: "cắt",
    part_of_speech: "động từ",
    meaning:
      "đỡ bóng sang phía đối phương bằng động tác giống như chặt mạnh, sao cho bóng xoáy và thấp (trong bóng bàn hoặc quần vợt): cú cắt bóng tuyệt đẹp",
    example: "cú cắt bóng tuyệt đẹp",
  },
  {
    word: "cặp nhiệt",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) đo thân nhiệt bằng nhiệt kế: cặp nhiệt cho người ốm",
    example: "cặp nhiệt cho người ốm",
  },
  {
    word: "cắt cúp",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) làm cho gián đoạn hoặc bỏ bớt đi một số khâu, một số phần (nói khái quát): điện đóm bị cắt cúp liên tục",
    example: "điện đóm bị cắt cúp liên tục",
  },
  {
    word: "cắt cơn",
    part_of_speech: "động từ",
    meaning:
      "làm dứt tạm thời cơn bệnh hoặc cơn nghiện một cách nhanh chóng: uống thuốc để cắt cơn sốt rét",
    example: "uống thuốc để cắt cơn sốt rét",
  },
  {
    word: "cắt cầu",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) cắt đứt, thôi không tiếp tục quan hệ nữa (thường trong việc kinh doanh, làm ăn): làm không được thì cắt cầu ngay",
    example: "làm không được thì cắt cầu ngay",
  },
  {
    word: "cắt cổ",
    part_of_speech: "tính từ",
    meaning:
      "(giá cả hoặc mức lãi) cao đến mức đáng sợ: bán với giá cắt cổ * cho vay với lãi suất cắt cổ",
    example: "bán với giá cắt cổ * cho vay với lãi suất cắt cổ",
  },
  {
    word: "cắt giảm",
    part_of_speech: "động từ",
    meaning:
      "làm giảm bớt đi về số lượng (nói khái quát): cắt giảm biên chế * ngân sách bị cắt giảm",
    example: "cắt giảm biên chế * ngân sách bị cắt giảm",
  },
  {
    word: "cắt lượt",
    part_of_speech: "động từ",
    meaning:
      "phân công lần lượt theo thứ tự; chia phiên: cắt lượt nhau canh gác",
    example: "cắt lượt nhau canh gác",
  },
  {
    word: "cắt đặt",
    part_of_speech: "động từ",
    meaning:
      "tính toán, sắp xếp công việc và cắt cử người đi làm: cắt đặt công việc * mọi việc đã cắt đặt đâu vào đấy",
    example: "cắt đặt công việc * mọi việc đã cắt đặt đâu vào đấy",
  },
  {
    word: "cắt lớp",
    part_of_speech: "động từ",
    meaning:
      "dùng tia X hay sóng siêu âm để thu được hình ảnh vật thể nói chung, hay những tổn thương trong cơ thể nói riêng, theo những độ sâu khác nhau trong không gian ba chiều: kĩ thuật chụp cắt lớp * máy siêu âm cắt lớp",
    example: "kĩ thuật chụp cắt lớp * máy siêu âm cắt lớp",
  },
  {
    word: "cắt cử",
    part_of_speech: "động từ",
    meaning: "cắt đi làm việc gì (nói khái quát): cắt cử người trông nom",
    example: "cắt cử người trông nom",
  },
  {
    word: "cầm",
    part_of_speech: "danh từ",
    meaning:
      'đàn cổ hình ống máng úp, có năm hoặc bảy dây tơ; thường dùng trong văn học cổ để chỉ đàn nói chung: "Phòng loan dìu dặt phím cầm, Chật nhà lan huệ, đầy sân quế hoè." (PCCH)',
    example:
      'Phòng loan dìu dặt phím cầm, Chật nhà lan huệ, đầy sân quế hoè." (PCCH)',
  },
  {
    word: "cầm",
    part_of_speech: "động từ",
    meaning:
      "giữ trong bàn tay hoặc giữa các ngón tay: cầm bút viết * cầm súng đánh giặc * cầm tay nhau",
    example: "cầm bút viết * cầm súng đánh giặc * cầm tay nhau",
  },
  {
    word: "cầm",
    part_of_speech: "động từ",
    meaning:
      "đưa tay nhận lấy: cầm lấy ít tiền mà chi tiêu * có đưa tôi cũng không cầm!",
    example: "cầm lấy ít tiền mà chi tiêu * có đưa tôi cũng không cầm!",
  },
  {
    word: "cầm",
    part_of_speech: "động từ",
    meaning:
      "nắm để điều khiển, để chỉ huy: cầm lái * cầm quân đi đánh giặc * cầm quyền",
    example: "cầm lái * cầm quân đi đánh giặc * cầm quyền",
  },
  {
    word: "cầm",
    part_of_speech: "động từ",
    meaning:
      "gửi của cải cho người khác giữ lại làm tin để vay tiền: cầm ruộng cho địa chủ * hiệu cầm đồ",
    example: "cầm ruộng cho địa chủ * hiệu cầm đồ",
  },
  {
    word: "cầm",
    part_of_speech: "động từ",
    meaning:
      "coi như là chủ quan đã nắm được, biết được: trận này đội nhà cầm phần thắng trong tay",
    example: "trận này đội nhà cầm phần thắng trong tay",
  },
  {
    word: "cầm",
    part_of_speech: "động từ",
    meaning:
      "giữ lại một chỗ, không cho tự do hoạt động: thế giặc đang mạnh, khó bề cầm được chân chúng",
    example: "thế giặc đang mạnh, khó bề cầm được chân chúng",
  },
  {
    word: "cầm",
    part_of_speech: "động từ",
    meaning: "giữ khách ở lại, không để ra về; lưu lại: cầm khách ở lại",
    example: "cầm khách ở lại",
  },
  {
    word: "cầm",
    part_of_speech: "động từ",
    meaning:
      "làm cho ngừng chảy ra ngoài cơ thể (nói về chất đang chảy ra nhiều và ngoài ý muốn): tiêm thuốc cầm máu * không cầm được nước mắt",
    example: "tiêm thuốc cầm máu * không cầm được nước mắt",
  },
  {
    word: "cầm",
    part_of_speech: "động từ",
    meaning:
      "nén giữ lại bên trong, không để biểu hiện ra (nói về tình cảm): không cầm được mối thương tâm * cố cầm cơn nóng giận",
    example: "không cầm được mối thương tâm * cố cầm cơn nóng giận",
  },
  {
    word: "cắt tiết",
    part_of_speech: "động từ",
    meaning:
      "cứa vào động mạch, thường là ở cổ, cho máu chảy ra để giết thịt (thường nói về gia cầm): cắt tiết gà",
    example: "cắt tiết gà",
  },
  {
    word: "cắt nghĩa",
    part_of_speech: "động từ",
    meaning:
      "giải thích cho rõ nghĩa, cho hiểu được nghĩa: cắt nghĩa một câu thơ chữ Hán",
    example: "cắt nghĩa một câu thơ chữ Hán",
  },
  {
    word: "cắt xén",
    part_of_speech: "động từ",
    meaning:
      "cắt bỏ bớt một số phần, làm cho mất tính chất nguyên vẹn, hoàn chỉnh: kịch bản phim bị cắt xén nhiều chỗ * cắt xén tiền lương của công nhân",
    example:
      "kịch bản phim bị cắt xén nhiều chỗ * cắt xén tiền lương của công nhân",
  },
  {
    word: "câm",
    part_of_speech: "tính từ",
    meaning: "không có hoặc mất khả năng nói, do bị tật.",
    example: "đạn câm (không nổ) * tín hiệu câm",
  },
  {
    word: "câm",
    part_of_speech: "tính từ",
    meaning:
      "không phát ra tiếng như những vật cùng loại: đạn câm (không nổ) * tín hiệu câm",
    example: "bản đồ câm * kịch câm * phim câm",
  },
  {
    word: "câm",
    part_of_speech: "tính từ",
    meaning:
      "không có tiếng nói hoặc không có thuyết minh như những thứ cùng loại: bản đồ câm * kịch câm * phim câm",
    example: "câm ngay miệng lại!",
  },
  {
    word: "cẩm",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) cảnh sát trưởng thời Pháp thuộc; cũng dùng để chỉ sở cảnh sát thực dân: viên cẩm * bị bắt lên cẩm",
    example: "viên cẩm * bị bắt lên cẩm",
  },
  {
    word: "cấm",
    part_of_speech: "động từ",
    meaning:
      "không cho phép làm việc gì đó hoặc không cho phép tồn tại: cấm người qua lại * cấm hút thuốc * cấm không được nói * sách cấm",
    example:
      "cấm người qua lại * cấm hút thuốc * cấm không được nói * sách cấm",
  },
  {
    word: "cấm",
    part_of_speech: "động từ",
    meaning:
      "không cho phép tự do qua lại hoặc đi vào một khu vực nào đó: cấm đường * rừng cấm * khu vực cấm",
    example: "cấm đường * rừng cấm * khu vực cấm",
  },
  {
    word: "cấm",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) tuyệt đối không, chẳng hề: cấm bao giờ nó cười * cấm thấy mặt nó đâu",
    example: "cấm bao giờ nó cười * cấm thấy mặt nó đâu",
  },
  {
    word: "cấm ca cấm cảu",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) gắt gỏng, cáu kỉnh: giọng cấm cảu * ăn nói cấm cảu",
    example: "giọng cấm cảu * ăn nói cấm cảu",
  },
  {
    word: "cầm bằng",
    part_of_speech: "",
    meaning:
      '(cũ) tổ hợp dùng để nêu một giả thiết, coi đó là khả năng hoặc trường hợp xấu nhất đành phải chấp nhận; cứ kể như, cứ coi như là: "Cố đấm ăn xôi, xôi lại hẩm, Cầm bằng làm mướn, mướn không công." (HXHương; 25)',
    example:
      'Cố đấm ăn xôi, xôi lại hẩm, Cầm bằng làm mướn, mướn không công." (HXHương; 25)',
  },
  {
    word: "cầm canh",
    part_of_speech: "động từ",
    meaning: "(tín hiệu âm thanh) báo hiệu từng canh một: tiếng mõ cầm canh",
    example: "tiếng mõ cầm canh",
  },
  {
    word: "cầm canh",
    part_of_speech: "động từ",
    meaning:
      "(âm thanh) nghe đều đều, từng lúc lại vang lên trong đêm tối: đại bác bắn cầm canh * tiếng pháo nổ cầm canh",
    example: "đại bác bắn cầm canh * tiếng pháo nổ cầm canh",
  },
  {
    word: "cấm cảu",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) gắt gỏng, cáu kỉnh: giọng cấm cảu * ăn nói cấm cảu",
    example: "giọng cấm cảu * ăn nói cấm cảu",
  },
  {
    word: "cấm cẳn",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như cấm cảu: giọng cấm cẳn",
    example: "giọng cấm cẳn",
  },
  {
    word: "cầm cập",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng hai hàm răng va vào nhau liên tiếp, thường vì run: rét run cầm cập",
    example: "rét run cầm cập",
  },
  {
    word: "cấm chỉ",
    part_of_speech: "động từ",
    meaning: "cấm hẳn, không cho phép: cấm chỉ không cho đến nhà",
    example: "cấm chỉ không cho đến nhà",
  },
  {
    word: "cầm chân",
    part_of_speech: "động từ",
    meaning:
      "giữ lại ở một chỗ, một vị trí, không cho tự do hoạt động, phát triển: cầm chân địch",
    example: "cầm chân địch",
  },
  {
    word: "cầm chắc",
    part_of_speech: "động từ",
    meaning:
      "tin chắc chắn (điều sắp nói tới) sẽ đúng như vậy: cầm chắc phần thắng * bị thua là cầm chắc cái chết",
    example: "cầm chắc phần thắng * bị thua là cầm chắc cái chết",
  },
  {
    word: "cầm chầu",
    part_of_speech: "động từ",
    meaning:
      "đánh trống thưởng thức nhằm tỏ ý khen chê khi xem hát trong các buổi hát ngày trước: cầm chầu điểm hát",
    example: "cầm chầu điểm hát",
  },
  {
    word: "cầm chừng",
    part_of_speech: "động từ",
    meaning:
      'giữ ở mức vừa phải, cốt cho có, cho lấy lệ để chờ đợi: tiêu pha cầm chừng * "Cơm ăn mỗi bữa một lưng, Nước uống cầm chừng, để dạ thương em." (ca dao)',
    example:
      'tiêu pha cầm chừng * "Cơm ăn mỗi bữa một lưng, Nước uống cầm chừng, để dạ thương em." (ca dao)',
  },
  {
    word: "cầm cờ chạy hiệu",
    part_of_speech: "động từ",
    meaning:
      "đóng vai lính cầm cờ chạy đi chạy lại trên sân khấu tuồng cổ: làm lính chạy hiệu rạp hát!",
    example: "làm lính chạy hiệu rạp hát!",
  },
  {
    word: "cấm cố",
    part_of_speech: "động từ",
    meaning: "giam cầm trong ngục, không cho ra ngoài: bị chung thân cấm cố",
    example: "bị chung thân cấm cố",
  },
  {
    word: "cầm cự",
    part_of_speech: "động từ",
    meaning:
      "giữ thế chống đỡ, giằng co nhằm giữ vững hoặc kéo dài thêm thời gian: bệnh nặng, chỉ cầm cự được vài ngày * đuối sức nên không cầm cự được lâu",
    example:
      "bệnh nặng, chỉ cầm cự được vài ngày * đuối sức nên không cầm cự được lâu",
  },
  {
    word: "cầm đã bén dây",
    part_of_speech: "",
    meaning:
      '(văn chương) đàn đã lên dây; ví tình cảm nam nữ, vợ chồng đã mặn nồng, khăng khít: "Trót vì cầm đã bén dây, Chẳng trăm năm cũng một ngày duyên ta." (TKiều)',
    example:
      'Trót vì cầm đã bén dây, Chẳng trăm năm cũng một ngày duyên ta." (TKiều)',
  },
  {
    word: "cầm cố",
    part_of_speech: "động từ",
    meaning:
      "giao tài sản (thường là bất động sản) cho người khác giữ làm tin để vay tiền (nói khái quát): cầm cố ruộng vườn",
    example: "cầm cố ruộng vườn",
  },
  {
    word: "cấm cung",
    part_of_speech: "danh từ",
    meaning: "(cũ) như cung cấm: lọt vào cấm cung",
    example: "lọt vào cấm cung",
  },
  {
    word: "cấm cung",
    part_of_speech: "động từ",
    meaning:
      "cấm không được phép ra khỏi nhà, không được phép tự do tiếp xúc với người ngoài (thường nói về con gái nhà quyền quý thời phong kiến): sống cấm cung * suốt ngày cấm cung trong bốn bức tường",
    example: "sống cấm cung * suốt ngày cấm cung trong bốn bức tường",
  },
  {
    word: "cấm cửa",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) cấm hẳn, không cho phép đến nhà mình nữa: cấm cửa, không cho bén mảng đến nữa!",
    example: "cấm cửa, không cho bén mảng đến nữa!",
  },
  {
    word: "cấm địa",
    part_of_speech: "danh từ",
    meaning:
      "khu vực cấm, người không có phận sự không được qua lại: khu cấm địa của doanh trại bộ đội",
    example: "khu cấm địa của doanh trại bộ đội",
  },
  {
    word: "cấm địa",
    part_of_speech: "danh từ",
    meaning:
      "khu vực sát cầu môn, không cho phép cầu thủ đội nhà phạm lỗi vì dễ bị phạt đền: đi bóng vào vùng cấm địa",
    example: "đi bóng vào vùng cấm địa",
  },
  {
    word: "cầm đầu",
    part_of_speech: "động từ",
    meaning:
      "nắm quyền điều khiển, chỉ huy một đám người, một tổ chức (thường là phi pháp): cầm đầu một tổ chức buôn lậu quốc tế * kẻ cầm đầu",
    example: "cầm đầu một tổ chức buôn lậu quốc tế * kẻ cầm đầu",
  },
  {
    word: "cầm đồ",
    part_of_speech: "động từ",
    meaning: "cầm đồ đạc để vay tiền (nói khái quát): hiệu cầm đồ",
    example: "hiệu cầm đồ",
  },
  {
    word: "câm họng",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) đành phải im, do lâm vào thế yếu: chứng cớ rành rành, đành phải câm họng",
    example: "chứng cớ rành rành, đành phải câm họng",
  },
  {
    word: "cầm giữ",
    part_of_speech: "động từ",
    meaning:
      "giữ lại một chỗ, không cho tiếp tục hoạt động nữa (thường là có chủ đích): cầm giữ chân địch",
    example: "cầm giữ chân địch",
  },
  {
    word: "cấm đoán",
    part_of_speech: "động từ",
    meaning:
      "ngăn cấm một cách độc đoán: cấm đoán đủ điều * thích làm gì thì làm, không ai cấm đoán",
    example: "cấm đoán đủ điều * thích làm gì thì làm, không ai cấm đoán",
  },
  {
    word: "cấm khẩu",
    part_of_speech: "động từ",
    meaning:
      "(người bệnh) ở tình trạng miệng cứng lại, không nói được nữa: người bệnh đã cấm khẩu",
    example: "người bệnh đã cấm khẩu",
  },
  {
    word: "cầm hơi",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) (ăn uống chút ít) để giữ lấy một chút hơi sức cho khỏi chết đói: rau cháo cầm hơi",
    example: "rau cháo cầm hơi",
  },
  {
    word: "câm lặng",
    part_of_speech: "tính từ",
    meaning:
      "im lặng hoàn toàn, như không thể nói hay phát ra một tiếng động nào: ngồi câm lặng * mối tình câm lặng",
    example: "ngồi câm lặng * mối tình câm lặng",
  },
  {
    word: "cấm kị",
    part_of_speech: "động từ",
    meaning: "bắt phải kiêng tránh (nói khái quát): điều cấm kị",
    example: "điều cấm kị",
  },
  {
    word: "câm miệng hến",
    part_of_speech: "",
    meaning:
      "nín lặng hoàn toàn, không nói năng gì: ngồi câm miệng hến, không dám nói câu nào",
    example: "ngồi câm miệng hến, không dám nói câu nào",
  },
  {
    word: "cầm lòng",
    part_of_speech: "động từ",
    meaning:
      'nén giữ tình cảm, xúc động: không cầm lòng được trước cảnh thương tâm * "Nguyệt hoa, hoa nguyệt, não nùng, Đêm xuân ai dễ cầm lòng được chăng!" (TKiều)',
    example:
      'không cầm lòng được trước cảnh thương tâm * "Nguyệt hoa, hoa nguyệt, não nùng, Đêm xuân ai dễ cầm lòng được chăng!" (TKiều)',
  },
  {
    word: "câm nín",
    part_of_speech: "tính từ",
    meaning: "nín lặng, không nói một lời: ngồi câm nín",
    example: "ngồi câm nín",
  },
  {
    word: "cẩm nang",
    part_of_speech: "danh từ",
    meaning:
      "túi gấm trong truyện cổ, chứa những lời khuyên bí ẩn (thường là ghi cách giải quyết khi gặp khó khăn lớn).",
    example: "cẩm nang du lịch * cẩm nang sử dụng thuốc",
  },
  {
    word: "cầm sắt",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) cầm và sắt, tên hai thứ đàn cổ, hoà thanh với nhau; dùng để ví tình vợ chồng hoà hợp, gắn bó: "Chàng dù nghĩ đến tình xa, Đem tình cầm sắt đổi ra cầm cờ." (TKiều)',
    example:
      'Chàng dù nghĩ đến tình xa, Đem tình cầm sắt đổi ra cầm cờ." (TKiều)',
  },
  {
    word: "cầm quyền",
    part_of_speech: "động từ",
    meaning: "nắm giữ chính quyền: nhà cầm quyền",
    example: "nhà cầm quyền",
  },
  {
    word: "cầm thú",
    part_of_speech: "danh từ",
    meaning:
      "chim muông và thú vật (nói khái quát); dùng để chỉ hạng người đê tiện, mất hết nhân tính: loài cầm thú * lòng dạ cầm thú",
    example: "loài cầm thú * lòng dạ cầm thú",
  },
  {
    word: "cầm quân",
    part_of_speech: "động từ",
    meaning:
      "chỉ huy quân đội hoặc một tập thể có tổ chức: có tài cầm quân * cầm quân ra trận",
    example: "có tài cầm quân * cầm quân ra trận",
  },
  {
    word: "cầm trịch",
    part_of_speech: "động từ",
    meaning:
      "điều khiển, chỉ dẫn để công việc tiến hành đúng và nhịp nhàng: đứng ra cầm trịch",
    example: "đứng ra cầm trịch",
  },
  {
    word: "cấm tiệt",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) cấm hẳn, cấm hoàn toàn, một cách nghiêm khắc: cấm tiệt, không cho đàn đúm",
    example: "cấm tiệt, không cho đàn đúm",
  },
  {
    word: "cấm vận",
    part_of_speech: "động từ",
    meaning:
      "cấm buôn bán và giao lưu kinh tế với một nước nào đó, nhằm bao vây và phá hoại kinh tế: chính sách cấm vận * cấm vận kinh tế",
    example: "chính sách cấm vận * cấm vận kinh tế",
  },
  {
    word: "cầm tù",
    part_of_speech: "động từ",
    meaning: "giam giữ trong nhà tù: bị cầm tù suốt mấy năm trời",
    example: "bị cầm tù suốt mấy năm trời",
  },
  {
    word: "cẩm tú",
    part_of_speech: "danh từ",
    meaning:
      '(Từ cũ, Văn chương) gấm thêu; dùng để ví cảnh thiên nhiên tươi đẹp hoặc văn thơ hay: "Mai sinh là bậc thiên tài, Câu văn cẩm tú, vẻ người y quan." (NĐM)',
    example:
      'Mai sinh là bậc thiên tài, Câu văn cẩm tú, vẻ người y quan." (NĐM)',
  },
  {
    word: "cầm tinh",
    part_of_speech: "động từ",
    meaning:
      "có năm sinh ứng với một con vật tượng trưng nào đó (theo địa chi), theo cách tính thời gian cổ truyền của Trung Quốc và một số nước châu á: tuổi Dần, cầm tinh con hổ",
    example: "tuổi Dần, cầm tinh con hổ",
  },
  {
    word: "cân",
    part_of_speech: "danh từ",
    meaning: "dụng cụ đo khối lượng: bàn cân * đòn cân * cân tạ",
    example: "bàn cân * đòn cân * cân tạ",
  },
  {
    word: "cân",
    part_of_speech: "danh từ",
    meaning: "khối lượng được đo: thêm vào cho nặng cân * hơi nhẹ cân",
    example: "thêm vào cho nặng cân * hơi nhẹ cân",
  },
  {
    word: "cân",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị cũ đo khối lượng bằng 16 lạng ta, tức bằng khoảng 0,605 kilogram: một cân vàng * kẻ tám lạng, người nửa cân (tng)",
    example: "một cân vàng * kẻ tám lạng, người nửa cân (tng)",
  },
  {
    word: "cân",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi thông thường của kilogram: một cân đường * hai chục cân gạo",
    example: "một cân đường * hai chục cân gạo",
  },
  {
    word: "cân",
    part_of_speech: "động từ",
    meaning: "đo khối lượng bằng cái cân: cân thử xem nặng nhẹ thế nào",
    example: "cân thử xem nặng nhẹ thế nào",
  },
  {
    word: "cân",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) cân để lấy ra một khối lượng nhất định của vật: chị cân cho tôi ba lạng thịt * cân nửa cân lạc",
    example: "chị cân cho tôi ba lạng thịt * cân nửa cân lạc",
  },
  {
    word: "cân",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) cân các vị thuốc đông y theo đơn để làm thành thang thuốc: cân mấy chén thuốc",
    example: "cân mấy chén thuốc",
  },
  {
    word: "cân",
    part_of_speech: "tính từ",
    meaning:
      "có hai phía ngang bằng nhau, không lệch: gánh không cân, đầu nặng đầu nhẹ * chỉnh lại bức tranh cho cân",
    example: "gánh không cân, đầu nặng đầu nhẹ * chỉnh lại bức tranh cho cân",
  },
  {
    word: "cân",
    part_of_speech: "tính từ",
    meaning:
      "(tam giác hoặc hình thang) có hai cạnh bên bằng nhau: tam giác cân * hình thang cân",
    example: "tam giác cân * hình thang cân",
  },
  {
    word: "cân",
    part_of_speech: "tính từ",
    meaning:
      "ngang nhau, tương đương với nhau: lực lượng giữa ta và địch không cân nhau * cuộc chiến không cân sức",
    example:
      "lực lượng giữa ta và địch không cân nhau * cuộc chiến không cân sức",
  },
  {
    word: "cận",
    part_of_speech: "tính từ",
    meaning: "(Ít dùng) gần: đứng cận * nhà ở cận nhau",
    example: "đứng cận * nhà ở cận nhau",
  },
  {
    word: "cận",
    part_of_speech: "tính từ",
    meaning: "(Khẩu ngữ) cận thị (nói tắt): mắt bị cận",
    example: "mắt bị cận",
  },
  {
    word: "cần",
    part_of_speech: "danh từ",
    meaning:
      'cây thân dài, hoa họp thành tán, thường trồng ở ruộng lầy hoặc ao cạn, dùng làm rau ăn: "Có con mà gả chồng gần, Có bát canh cần nó cũng đem cho." (Cdao)',
    example: 'Có con mà gả chồng gần, Có bát canh cần nó cũng đem cho." (Cdao)',
  },
  {
    word: "cần",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận hình thanh dài ở một số đồ dùng, có thể nâng lên hạ xuống được: cần anten * cần bật bông",
    example: "cần anten * cần bật bông",
  },
  {
    word: "cần",
    part_of_speech: "danh từ",
    meaning:
      "ống nhỏ và rỗng, thường bằng sậy, trúc, có thể vít cong xuống, dùng để hút rượu hoặc hút thuốc: điếu có cần dài * dùng cần uống rượu",
    example: "điếu có cần dài * dùng cần uống rượu",
  },
  {
    word: "cần",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận mang bàn phím, nối liền đầu có trục so dây với bầu cộng hưởng của một số nhạc khí: cần đàn",
    example: "cần đàn",
  },
  {
    word: "cần",
    part_of_speech: "danh từ",
    meaning:
      "thanh tre nhỏ xuyên qua bầu đàn trong đàn bầu, dùng để nắn tiếng: cần đàn bầu * so dây nắn cần",
    example: "cần đàn bầu * so dây nắn cần",
  },
  {
    word: "cần",
    part_of_speech: "động từ",
    meaning:
      "không thể không làm, không thể không có, vì nếu không làm, không có thì sẽ có hại: việc cần phải đi * những thứ cần dùng * quyển sách rất cần cho mọi người",
    example:
      "việc cần phải đi * những thứ cần dùng * quyển sách rất cần cho mọi người",
  },
  {
    word: "cần",
    part_of_speech: "tính từ",
    meaning:
      "phải được giải quyết gấp, vì để chậm trễ sẽ có hại: thư cần, phải chuyển ngay",
    example: "thư cần, phải chuyển ngay",
  },
  {
    word: "cần",
    part_of_speech: "tính từ",
    meaning:
      "siêng năng, chăm chỉ (nói khái quát): gương cần, kiệm, liêm, chính * nhất nước, nhì phân, tam cần, tứ giống (tng)",
    example:
      "gương cần, kiệm, liêm, chính * nhất nước, nhì phân, tam cần, tứ giống (tng)",
  },
  {
    word: "cấn",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ) cặn: cấn nước chè * cốc nước đã lắng hết cấn",
    example: "cấn nước chè * cốc nước đã lắng hết cấn",
  },
  {
    word: "cấn",
    part_of_speech: "động từ",
    meaning:
      "(Phương ngữ) vướng, đụng phải cái gì có cạnh: ván kê không bằng, nằm cấn lưng",
    example: "ván kê không bằng, nằm cấn lưng",
  },
  {
    word: "cấn",
    part_of_speech: "động từ",
    meaning: "vướng, mắc: cấn giá sách nên không kê được tủ",
    example: "cấn giá sách nên không kê được tủ",
  },
  {
    word: "cấn",
    part_of_speech: "động từ",
    meaning:
      "(Phương ngữ) bắn hoặc gán nợ: đem cấn chiếc xe cho chủ nợ * cấn khoản nợ sang cho người khác",
    example: "đem cấn chiếc xe cho chủ nợ * cấn khoản nợ sang cho người khác",
  },
  {
    word: "cẩn",
    part_of_speech: "động từ",
    meaning: "(Phương ngữ) khảm: tủ cẩn xà cừ",
    example: "tủ cẩn xà cừ",
  },
  {
    word: "cấn cái",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) vướng mắc: còn một số điều cấn cái * cấn cái chuyện chồng con",
    example: "còn một số điều cấn cái * cấn cái chuyện chồng con",
  },
  {
    word: "cân bằng",
    part_of_speech: "tính từ",
    meaning:
      "ngang nhau, tương đương với nhau: cán cân thu chi đã cân bằng * trọng lượng hai bên cân bằng nhau",
    example: "cán cân thu chi đã cân bằng * trọng lượng hai bên cân bằng nhau",
  },
  {
    word: "cân bằng",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái trong đó tất cả các lực và tất cả các xu hướng đều hoàn toàn loại trừ lẫn nhau: con lắc đang ở vị trí cân bằng",
    example: "con lắc đang ở vị trí cân bằng",
  },
  {
    word: "cân bằng",
    part_of_speech: "động từ",
    meaning:
      "làm cho trở thành cân bằng: cân bằng ngân sách * cân bằng mức thu chi hàng tháng",
    example: "cân bằng ngân sách * cân bằng mức thu chi hàng tháng",
  },
  {
    word: "cân bằng",
    part_of_speech: "danh từ",
    meaning: "trạng thái cân bằng: cân bằng bền * cân bằng động",
    example: "cân bằng bền * cân bằng động",
  },
  {
    word: "cận cảnh",
    part_of_speech: "danh từ",
    meaning:
      "cảnh chụp ảnh hoặc quay phim được thể hiện ở cự li gần (thường lấy hình người khoảng từ ngực trở lên); đối lập với viễn cảnh: bức ảnh chụp cận cảnh",
    example: "bức ảnh chụp cận cảnh",
  },
  {
    word: "cận chiến",
    part_of_speech: "",
    meaning: "đánh gần, đánh áp sát: phát huy sở trường khi cận chiến",
    example: "phát huy sở trường khi cận chiến",
  },
  {
    word: "cần cù",
    part_of_speech: "tính từ",
    meaning: "chăm chỉ và chịu khó: cần cù lao động * tính cần cù, chịu khó",
    example: "cần cù lao động * tính cần cù, chịu khó",
  },
  {
    word: "cần cẩu",
    part_of_speech: "danh từ",
    meaning: "máy có cần dài để nâng, hạ, hoặc di chuyển vật nặng: lái cần cẩu",
    example: "lái cần cẩu",
  },
  {
    word: "cân đai",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) khăn bịt tóc để đội mũ và đai đeo ngang lưng; y phục của quan lại, quý tộc lớn thời phong kiến: "Khôi khoa đỗ trạng ngày rầy, Sắc ban áo mãng cân đai rỡ ràng." (PCCH)',
    example:
      'Khôi khoa đỗ trạng ngày rầy, Sắc ban áo mãng cân đai rỡ ràng." (PCCH)',
  },
  {
    word: "cân đối",
    part_of_speech: "tính từ",
    meaning:
      "tương xứng hợp lí và hài hoà giữa các phần với nhau: thân hình cân đối",
    example: "thân hình cân đối",
  },
  {
    word: "cân đối",
    part_of_speech: "động từ",
    meaning:
      "làm cho cân đối: cân đối cung và cầu * cân đối lại tình hình thu chi của doanh nghiệp",
    example:
      "cân đối cung và cầu * cân đối lại tình hình thu chi của doanh nghiệp",
  },
  {
    word: "cận kề",
    part_of_speech: "động từ",
    meaning:
      "rất gần, như ở sát ngay bên cạnh: tết nhất đã cận kề * người bệnh đang cận kề cái chết",
    example: "tết nhất đã cận kề * người bệnh đang cận kề cái chết",
  },
  {
    word: "cần đốp",
    part_of_speech: "danh từ",
    meaning: "lá dừa nước chằm sẵn thành tấm để lợp nhà: nhà lợp bằng cần đốp",
    example: "nhà lợp bằng cần đốp",
  },
  {
    word: "cân kẹo",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) cân (nói khái quát; thường hàm ý chê): bán cả mớ, chẳng cân kẹo gì hết!",
    example: "bán cả mớ, chẳng cân kẹo gì hết!",
  },
  {
    word: "cận đại",
    part_of_speech: "danh từ",
    meaning:
      "thời đại lịch sử, sau thời trung đại, trước thời hiện đại: lịch sử thế giới cận đại * nền văn học cận đại",
    example: "lịch sử thế giới cận đại * nền văn học cận đại",
  },
  {
    word: "cần kiệm",
    part_of_speech: "tính từ",
    meaning: "cần cù và tiết kiệm: tính cần kiệm * ăn tiêu cần kiệm",
    example: "tính cần kiệm * ăn tiêu cần kiệm",
  },
  {
    word: "cần kíp",
    part_of_speech: "tính từ",
    meaning:
      "cần được giải quyết ngay, giải quyết kịp thời: nhiệm vụ cần kíp * việc cần kíp, phải làm ngay",
    example: "nhiệm vụ cần kíp * việc cần kíp, phải làm ngay",
  },
  {
    word: "cần mẫn",
    part_of_speech: "tính từ",
    meaning: "siêng năng và lanh lợi: làm việc cần mẫn * siêng năng cần mẫn",
    example: "làm việc cần mẫn * siêng năng cần mẫn",
  },
  {
    word: "cân nhắc",
    part_of_speech: "động từ",
    meaning:
      "so sánh, suy xét một cách cẩn thận để lựa chọn: cân nhắc thiệt hơn * phải cân nhắc kĩ trước khi quyết định",
    example: "cân nhắc thiệt hơn * phải cân nhắc kĩ trước khi quyết định",
  },
  {
    word: "cận nhiệt đới",
    part_of_speech: "danh từ",
    meaning: "đới nằm giữa nhiệt đới và ôn đới: khí hậu cận nhiệt đới",
    example: "khí hậu cận nhiệt đới",
  },
  {
    word: "cẩn mật",
    part_of_speech: "tính từ",
    meaning:
      "cẩn thận, không để có sơ suất: giữ gìn cẩn mật * canh phòng cẩn mật",
    example: "giữ gìn cẩn mật * canh phòng cẩn mật",
  },
  {
    word: "cần lao",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) cần cù trong lao động, không ngại gian khổ: cuộc đời cần lao",
    example: "cuộc đời cần lao",
  },
  {
    word: "cần lao",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, hiếm) như lao động: xuất thân trong đám cần lao * giai cấp cần lao (công nhân và nông dân)",
    example:
      "xuất thân trong đám cần lao * giai cấp cần lao (công nhân và nông dân)",
  },
  {
    word: "cân ta",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) đơn vị đo khối lượng cũ, khoảng bằng 0,605 kilogram; phân biệt với kilogram.",
    example: "dùng cân ta để cân",
  },
  {
    word: "cân não",
    part_of_speech: "danh từ",
    meaning:
      "gân và não; thường dùng để chỉ tinh thần, tâm lí của con người: căng thẳng cân não * đòn cân não",
    example: "căng thẳng cân não * đòn cân não",
  },
  {
    word: "cần sa",
    part_of_speech: "danh từ",
    meaning:
      "cây có chứa chất ma tuý, có thể dùng trộn với thuốc lá để hút: hút cần sa",
    example: "hút cần sa",
  },
  {
    word: "cẩn thận",
    part_of_speech: "tính từ",
    meaning:
      "thận trọng trong hành động hoặc lời nói của mình, tránh sơ suất, để khỏi xảy ra điều bất lợi hoặc không hay: đường trơn, đi cẩn thận kẻo ngã * việc này nên hết sức cẩn thận",
    example: "đường trơn, đi cẩn thận kẻo ngã * việc này nên hết sức cẩn thận",
  },
  {
    word: "cẩn tắc",
    part_of_speech: "tính từ",
    meaning: "(cũ, khẩu ngữ) cẩn thận: cẩn tắc không bao giờ thừa",
    example: "cẩn tắc không bao giờ thừa",
  },
  {
    word: "cận thành",
    part_of_speech: "tính từ",
    meaning:
      "có khoảng cách gần sát với khung thành: sút bóng cận thành * cú tạt bóng cận thành",
    example: "sút bóng cận thành * cú tạt bóng cận thành",
  },
  {
    word: "cân tiểu li",
    part_of_speech: "danh từ",
    meaning:
      "cân chính xác, dùng để cân những vật rất nhỏ: cân vàng bằng cân tiểu li",
    example: "cân vàng bằng cân tiểu li",
  },
  {
    word: "cần thiết",
    part_of_speech: "tính từ",
    meaning:
      "cần đến mức không thể nào không làm hoặc không có: tài liệu cần thiết cho công việc * không cần thiết phải làm thế",
    example: "tài liệu cần thiết cho công việc * không cần thiết phải làm thế",
  },
  {
    word: "cân tiểu ly",
    part_of_speech: "danh từ",
    meaning:
      "cân chính xác, dùng để cân những vật rất nhỏ: cân vàng bằng cân tiểu li",
    example: "cân vàng bằng cân tiểu li",
  },
  {
    word: "cấn trừ",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ, hoặc kng) trả dần, trừ nợ dần bằng hình thức gán tài sản cho chủ nợ: đem lô đất cấn trừ vào khoản nợ vay của ngân hàng",
    example: "đem lô đất cấn trừ vào khoản nợ vay của ngân hàng",
  },
  {
    word: "cần vương",
    part_of_speech: "động từ",
    meaning:
      "(cũ) (bề tôi) hết lòng vì vua khi gặp nguy biến: vua ra chiếu cần vương * phong trào cần vương",
    example: "vua ra chiếu cần vương * phong trào cần vương",
  },
  {
    word: "cẩn trọng",
    part_of_speech: "tính từ",
    meaning:
      "cẩn thận vì rất coi trọng: kỉ vật được giữ gìn cẩn trọng * tính toán thật cẩn trọng trước khi làm",
    example:
      "kỉ vật được giữ gìn cẩn trọng * tính toán thật cẩn trọng trước khi làm",
  },
  {
    word: "cập",
    part_of_speech: "động từ",
    meaning:
      "(tàu, thuyền) ghé sát vào: thuyền cập bến * ca nô cập sát vào mạn tàu * tàu vừa cập cảng",
    example: "thuyền cập bến * ca nô cập sát vào mạn tàu * tàu vừa cập cảng",
  },
  {
    word: "cân xô",
    part_of_speech: "động từ",
    meaning:
      "cân cả mớ, không phân biệt cỡ loại, chất lượng của vật được cân: cân xô cả mớ cá",
    example: "cân xô cả mớ cá",
  },
  {
    word: "cân xứng",
    part_of_speech: "tính từ",
    meaning:
      "cân đối và phù hợp với nhau: hình thức chưa cân xứng với nội dung * hai người không cân xứng nhau",
    example:
      "hình thức chưa cân xứng với nội dung * hai người không cân xứng nhau",
  },
  {
    word: "cấp",
    part_of_speech: "danh từ",
    meaning:
      "loại, hạng trong một hệ thống (xếp theo trình độ cao thấp, trên dưới, v.v.): chính quyền các cấp * sĩ quan cấp tá * học hết cấp III",
    example: "chính quyền các cấp * sĩ quan cấp tá * học hết cấp III",
  },
  {
    word: "cấp",
    part_of_speech: "danh từ",
    meaning:
      "hàng mỏng, dệt bằng tơ tằm, có nhiều hoa, bóng và mịn: chiếc áo may bằng lụa cấp",
    example: "chiếc áo may bằng lụa cấp",
  },
  {
    word: "cấp",
    part_of_speech: "động từ",
    meaning:
      "giao cho hưởng, giao cho toàn quyền sử dụng: cấp học bổng cho học sinh * cấp đất làm nhà",
    example: "cấp học bổng cho học sinh * cấp đất làm nhà",
  },
  {
    word: "cấp",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như gấp: việc cấp lắm!",
    example: "việc cấp lắm!",
  },
  {
    word: "cần yếu",
    part_of_speech: "tính từ",
    meaning: "cần thiết và quan trọng: điều kiện cần yếu * nhiệm vụ cần yếu",
    example: "điều kiện cần yếu * nhiệm vụ cần yếu",
  },
  {
    word: "câng",
    part_of_speech: "tính từ",
    meaning:
      "(mặt) trơ lì và vênh váo, tỏ ra bướng bỉnh, trông rất đáng ghét: mặt cứ câng lên, trông đến ghét * mặt câng câng",
    example: "mặt cứ câng lên, trông đến ghét * mặt câng câng",
  },
  {
    word: "cấp bộ",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức của nhà nước, đảng hoặc đoàn thể theo từng cấp, ở địa phương: các cấp bộ Đảng ở cơ sở",
    example: "các cấp bộ Đảng ở cơ sở",
  },
  {
    word: "cấp báo",
    part_of_speech: "động từ",
    meaning: "(cũ) báo gấp cho biết: tin cấp báo",
    example: "tin cấp báo",
  },
  {
    word: "cấp bách",
    part_of_speech: "tính từ",
    meaning:
      "rất gấp, cần phải được giải quyết ngay: nhiệm vụ cấp bách * việc cấp bách phải làm ngay",
    example: "nhiệm vụ cấp bách * việc cấp bách phải làm ngay",
  },
  {
    word: "cấp bách",
    part_of_speech: "tính từ",
    meaning:
      "căng thẳng, gay go, đòi hỏi phải hành động gấp, không thể chậm trễ: tình thế cấp bách",
    example: "tình thế cấp bách",
  },
  {
    word: "cấp cứu",
    part_of_speech: "động từ",
    meaning:
      "cứu chữa gấp để thoát khỏi tình trạng nguy kịch: phòng cấp cứu * xe cấp cứu",
    example: "phòng cấp cứu * xe cấp cứu",
  },
  {
    word: "cấp dưỡng",
    part_of_speech: "động từ",
    meaning:
      "(cũ) cung cấp (cho người già yếu hoặc tàn tật) những thứ cần thiết cho đời sống vật chất: khoản tiền cấp dưỡng * nâng cao chế độ cấp dưỡng cho thương binh",
    example: "khoản tiền cấp dưỡng * nâng cao chế độ cấp dưỡng cho thương binh",
  },
  {
    word: "cấp độ",
    part_of_speech: "danh từ",
    meaning:
      "cấp, bậc trong một hệ thống (nói khái quát): các cấp độ của một hệ thống * tay nghề đã đạt đến cấp độ cao",
    example: "các cấp độ của một hệ thống * tay nghề đã đạt đến cấp độ cao",
  },
  {
    word: "cấp hiệu",
    part_of_speech: "danh từ",
    meaning:
      "dấu hiệu chỉ cấp quân hàm, đeo ở hai cầu vai hoặc ở hai ve cổ áo: mặc bộ quân phục mang cấp hiệu đại tá",
    example: "mặc bộ quân phục mang cấp hiệu đại tá",
  },
  {
    word: "cập kèm",
    part_of_speech: "tính từ",
    meaning: "(mắt) kém, nhìn không rõ: già rồi nên mắt cập kèm",
    example: "già rồi nên mắt cập kèm",
  },
  {
    word: "cập kênh",
    part_of_speech: "tính từ",
    meaning:
      "dễ nghiêng lệch bên này, bên kia khi đụng vào, vì có các góc kê không bằng nhau: ván kê cập kênh",
    example: "ván kê cập kênh",
  },
  {
    word: "cấp nước",
    part_of_speech: "",
    meaning:
      "cung cấp nước cho các nhu cầu sinh hoạt và sản xuất: công trình cấp nước của thành phố",
    example: "công trình cấp nước của thành phố",
  },
  {
    word: "cập nhật",
    part_of_speech: "động từ",
    meaning:
      "thay đổi và/hoặc bổ sung các thông tin cho phù hợp với thực tế hiện thời: cập nhật thông tin * dữ liệu mới được cập nhật",
    example: "cập nhật thông tin * dữ liệu mới được cập nhật",
  },
  {
    word: "cập nhật",
    part_of_speech: "động từ",
    meaning:
      "(cũ) thay đổi và/hoặc bổ sung kịp thời từng ngày một, không để chậm sang ngày hôm sau: sổ sách ghi cập nhật",
    example: "sổ sách ghi cập nhật",
  },
  {
    word: "cấp phối",
    part_of_speech: "danh từ",
    meaning:
      "vật liệu dùng để rải đường, gồm các thành phần hạt của đất, cát, sỏi, v.v. trộn lẫn theo một tỉ lệ nhất định: mặt đường rải cấp phối",
    example: "mặt đường rải cấp phối",
  },
  {
    word: "cấp tập",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) bắn===== dồn dập, liên tiếp: một loạt pháo cấp tập rải khắp trận địa",
    example: "một loạt pháo cấp tập rải khắp trận địa",
  },
  {
    word: "cấp tập",
    part_of_speech: "tính từ",
    meaning: "dồn dập, liên tiếp: phải làm cấp tập mới kịp * súng bắn cấp tập",
    example: "phải làm cấp tập mới kịp * súng bắn cấp tập",
  },
  {
    word: "cập kê",
    part_of_speech: "tính từ",
    meaning:
      '(cũ) (người con gái) đến tuổi cài trâm (15 tuổi, là tuổi có thể gả chồng được, thời xưa): "Phong lưu rất mực hồng quần, Xuân xanh xấp xỉ tới tuần cập kê." (TKiều)',
    example:
      'Phong lưu rất mực hồng quần, Xuân xanh xấp xỉ tới tuần cập kê." (TKiều)',
  },
  {
    word: "cấp số cộng",
    part_of_speech: "danh từ",
    meaning:
      "dãy số (hữu hạn hay vô hạn) trong đó từ số thứ hai trở đi mỗi số bằng số đứng trước cộng thêm một số không đổi: dãy 2, 4, 6, 8, 10, 12 là một cấp số cộng",
    example: "dãy 2, 4, 6, 8, 10, 12 là một cấp số cộng",
  },
  {
    word: "cấp thoát nước",
    part_of_speech: "",
    meaning:
      "cung cấp nước sử dụng và thoát nước thải (trong một phạm vi dân cư nhất định): cải tạo hệ thống cấp thoát nước của thành phố",
    example: "cải tạo hệ thống cấp thoát nước của thành phố",
  },
  {
    word: "cập rập",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) vội vàng và gấp gáp: công việc cập rập * chuẩn bị cập rập quá nên thiếu chu đáo",
    example: "công việc cập rập * chuẩn bị cập rập quá nên thiếu chu đáo",
  },
  {
    word: "cấp phát",
    part_of_speech: "động từ",
    meaning:
      "cấp cho (theo chế độ, theo quy định): cấp phát quân trang cho bộ đội * cấp phát kinh phí",
    example: "cấp phát quân trang cho bộ đội * cấp phát kinh phí",
  },
  {
    word: "cấp số nhân",
    part_of_speech: "danh từ",
    meaning:
      "dãy số (hữu hạn hay vô hạn) trong đó từ số thứ hai trở đi mỗi số bằng số đứng trước nhân với một số không đổi: dãy 2, 4, 8, 16, 32 là một cấp số nhân",
    example: "dãy 2, 4, 8, 16, 32 là một cấp số nhân",
  },
  {
    word: "cấp thiết",
    part_of_speech: "tính từ",
    meaning:
      "rất cần thiết, phải được giải quyết ngay: đòi hỏi cấp thiết * việc cấp thiết, cần phải giải quyết ngay",
    example: "đòi hỏi cấp thiết * việc cấp thiết, cần phải giải quyết ngay",
  },
  {
    word: "cấp tính",
    part_of_speech: "tính từ",
    meaning: "(bệnh) ở trạng thái phát triển nhanh: sốt rét cấp tính",
    example: "sốt rét cấp tính",
  },
  {
    word: "cấp tốc",
    part_of_speech: "tính từ",
    meaning:
      "rất nhanh để tranh thủ thời gian: cuộc hành quân cấp tốc * hội ý cấp tốc * học một lớp tiếng Anh cấp tốc",
    example:
      "cuộc hành quân cấp tốc * hội ý cấp tốc * học một lớp tiếng Anh cấp tốc",
  },
  {
    word: "cấp tiến",
    part_of_speech: "tính từ",
    meaning: "có tư tưởng chính trị tiến bộ: trí thức cấp tiến",
    example: "trí thức cấp tiến",
  },
  {
    word: "cất",
    part_of_speech: "động từ",
    meaning:
      "nhấc lên, đưa lên, làm cho bắt đầu hoạt động để làm việc gì: cất bước * cất gánh lên vai * ngựa cất vó * cất cao đôi cánh",
    example: "cất bước * cất gánh lên vai * ngựa cất vó * cất cao đôi cánh",
  },
  {
    word: "cất",
    part_of_speech: "động từ",
    meaning: "dựng lên (nói về nhà cửa): cất nhà * cất nóc",
    example: "cất nhà * cất nóc",
  },
  {
    word: "cất",
    part_of_speech: "động từ",
    meaning: "làm vang lên: cất tiếng hát * cất giọng hò",
    example: "cất tiếng hát * cất giọng hò",
  },
  {
    word: "cất",
    part_of_speech: "động từ",
    meaning:
      "nhấc lên để bỏ ra khỏi người, không mang nữa: cất mũ chào * lòng như vừa cất được gánh nặng (b)",
    example: "cất mũ chào * lòng như vừa cất được gánh nặng (b)",
  },
  {
    word: "cất",
    part_of_speech: "động từ",
    meaning: "dừng hẳn lại (nói về cơn đau): bệnh nhân đã cất cơn sốt",
    example: "bệnh nhân đã cất cơn sốt",
  },
  {
    word: "cất",
    part_of_speech: "động từ",
    meaning:
      "để vào một chỗ nhất định, thường là kín đáo hoặc chắc chắn, nhằm giữ lại trong khi chưa dùng đến: cất tiền vào tủ * hàng hoá cất trong kho",
    example: "cất tiền vào tủ * hàng hoá cất trong kho",
  },
  {
    word: "cất",
    part_of_speech: "động từ",
    meaning:
      "mang đi cả chuyến một số lượng lớn hàng hoá để buôn: cất hàng về xuôi",
    example: "cất hàng về xuôi",
  },
  {
    word: "cất",
    part_of_speech: "động từ",
    meaning:
      "dùng nhiệt làm cho chất lỏng trong một hỗn hợp hoá hơi, rồi cho hơi gặp lạnh ngưng lại, để thu chất nguyên chất hoặc tinh khiết hơn: cất tinh dầu * cất rượu * nước cất",
    example: "cất tinh dầu * cất rượu * nước cất",
  },
  {
    word: "cật",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) thận, bầu dục: cật lợn * nấu cháo tim, cật",
    example: "cật lợn * nấu cháo tim, cật",
  },
  {
    word: "cật",
    part_of_speech: "danh từ",
    meaning: "(hiếm) phần lưng ở chỗ ngang bụng: chung lưng đấu cật (tng)",
    example: "chung lưng đấu cật (tng)",
  },
  {
    word: "cật",
    part_of_speech: "danh từ",
    meaning: "phần cứng ở mặt bề ngoài thân cây tre, nứa: cật tre * lạt cật",
    example: "cật tre * lạt cật",
  },
  {
    word: "cất binh",
    part_of_speech: "động từ",
    meaning: "(cũ) cất quân: cất binh đi dẹp giặc",
    example: "cất binh đi dẹp giặc",
  },
  {
    word: "cất cánh",
    part_of_speech: "động từ",
    meaning:
      "(máy bay) bắt đầu rời mặt đất bay lên: sắp đến giờ máy bay cất cánh * nền kinh tế đang cất cánh (b)",
    example: "sắp đến giờ máy bay cất cánh * nền kinh tế đang cất cánh (b)",
  },
  {
    word: "cất cánh",
    part_of_speech: "động từ",
    meaning:
      "phát triển rất nhanh về kinh tế, khác hẳn sự phát triển chậm trước đó: nền kinh tế đang cất cánh",
    example: "nền kinh tế đang cất cánh",
  },
  {
    word: "cất công",
    part_of_speech: "động từ",
    meaning:
      "bỏ ra nhiều công sức làm việc gì: cất công tìm kiếm * đã cất công đi mấy chục cây số, chẳng lẽ lại về không?",
    example:
      "cất công tìm kiếm * đã cất công đi mấy chục cây số, chẳng lẽ lại về không?",
  },
  {
    word: "cất giữ",
    part_of_speech: "động từ",
    meaning:
      "cất và giữ gìn cho nguyên vẹn, cho khỏi hư hỏng, trong một thời gian (nói khái quát): cất giữ thức ăn trong tủ lạnh * cất giữ hồ sơ",
    example: "cất giữ thức ăn trong tủ lạnh * cất giữ hồ sơ",
  },
  {
    word: "cất chức",
    part_of_speech: "động từ",
    meaning: "(cũ) cách chức: cất chức lí trưởng",
    example: "cất chức lí trưởng",
  },
  {
    word: "cất bước",
    part_of_speech: "động từ",
    meaning:
      "nhấc chân để bước đi: mỏi quá, cất bước không nổi * lủi thủi cất bước quay về",
    example: "mỏi quá, cất bước không nổi * lủi thủi cất bước quay về",
  },
  {
    word: "cất bước",
    part_of_speech: "động từ",
    meaning:
      "(Văn chương) bắt đầu ra đi, bắt đầu cuộc đi xa: cất bước lên đường * cất bước ra đi",
    example: "cất bước lên đường * cất bước ra đi",
  },
  {
    word: "cất giấu",
    part_of_speech: "động từ",
    meaning:
      "cất vào nơi kín đáo, chắc chắn, cho người khác không thể thấy, không thể tìm ra được (nói khái quát): cất giấu tài liệu mật",
    example: "cất giấu tài liệu mật",
  },
  {
    word: "cật sức",
    part_of_speech: "phụ từ",
    meaning:
      "(hiếm) như cật lực: đi cật sức một ngày mới tới * lao động cật sức",
    example: "đi cật sức một ngày mới tới * lao động cật sức",
  },
  {
    word: "cất nhắc",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) lao động nhẹ (nói về người sức yếu): mệt mỏi không cất nhắc được việc gì",
    example: "mệt mỏi không cất nhắc được việc gì",
  },
  {
    word: "cất nhắc",
    part_of_speech: "động từ",
    meaning:
      "nâng đỡ, đưa lên một chức vụ cao hơn: được cất nhắc vào chức trưởng phòng",
    example: "được cất nhắc vào chức trưởng phòng",
  },
  {
    word: "cật lực",
    part_of_speech: "phụ từ",
    meaning:
      "(làm việc gì) một cách hết sức lực, hết sức mình: chạy cật lực * làm cật lực mà vẫn không đủ ăn",
    example: "chạy cật lực * làm cật lực mà vẫn không đủ ăn",
  },
  {
    word: "cất tiếng",
    part_of_speech: "động từ",
    meaning:
      "lên giọng để nói: cất tiếng phản đối * tất cả đều lặng im, không ai buồn cất tiếng",
    example: "cất tiếng phản đối * tất cả đều lặng im, không ai buồn cất tiếng",
  },
  {
    word: "cật ruột",
    part_of_speech: "danh từ",
    meaning: "(cũ, hiếm) như ruột thịt: người cật ruột",
    example: "người cật ruột",
  },
  {
    word: "cật vấn",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) vặn hỏi: lính gác cật vấn người qua lại * tự cật vấn lương tâm",
    example: "lính gác cật vấn người qua lại * tự cật vấn lương tâm",
  },
  {
    word: "cất trữ",
    part_of_speech: "động từ",
    meaning:
      "cất, giữ lại để phòng khi cần đến: cất trữ lương thực * cất trữ vàng phòng khi đồng tiền mất giá",
    example: "cất trữ lương thực * cất trữ vàng phòng khi đồng tiền mất giá",
  },
  {
    word: "cất vó",
    part_of_speech: "động từ",
    meaning:
      "(ngựa) vươn cao hai chân trước để bắt đầu phi: ngựa cất vó phóng đi",
    example: "ngựa cất vó phóng đi",
  },
  {
    word: "cậu",
    part_of_speech: "danh từ",
    meaning: "em trai hoặc anh của mẹ (có thể dùng để xưng gọi).",
    example: "cậu bé trông thật đáng yêu * mấy cậu học trò",
  },
  {
    word: "cậu",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ hoặc gọi người con trai còn nhỏ tuổi, thường với ý mến trọng: cậu bé trông thật đáng yêu * mấy cậu học trò",
    example: "cậu ấm * cậu lệ * cậu cai",
  },
  {
    word: "cậu",
    part_of_speech: "danh từ",
    meaning:
      "(Từ cũ) từ trong xã hội cũ dùng để chỉ hoặc gọi người con trai nhà giàu sang, hoặc cai, lính, với ý coi trọng: cậu ấm * cậu lệ * cậu cai",
    example: "cậu làm giúp tớ * chào các cậu!",
  },
  {
    word: "cậu",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để gọi nhau một cách thân mật giữa bạn bè, thường là giữa những người còn ít tuổi: cậu làm giúp tớ * chào các cậu!",
    example: "cậu trông cháu cho chị một lúc",
  },
  {
    word: "cấu",
    part_of_speech: "động từ",
    meaning:
      "ấn mạnh các móng hoặc vuốt vào da thịt rồi giật mạnh, làm cho đau: cấu vào tay bạn",
    example: "cấu vào tay bạn",
  },
  {
    word: "cầu",
    part_of_speech: "danh từ",
    meaning:
      "đồ chơi bằng vải, hình tròn như quả cam, dùng để tung, bắt: múa lân tung cầu * tục gieo cầu kén rể",
    example: "múa lân tung cầu * tục gieo cầu kén rể",
  },
  {
    word: "cầu",
    part_of_speech: "danh từ",
    meaning:
      "đồ chơi gồm một đế nhỏ hình tròn, trên mặt cắm lông chim, túm giấy mỏng hoặc những thứ tương tự, dùng để đá chuyền qua lại cho nhau hoặc để đánh qua lại bằng vợt: chơi đá cầu * giao cầu chưa qua lưới",
    example: "chơi đá cầu * giao cầu chưa qua lưới",
  },
  {
    word: "cầu",
    part_of_speech: "danh từ",
    meaning:
      'công trình xây dựng bắc qua sông, suối, hồ, chỗ trũng, v.v. để tiện đi lại: bắc cầu tre * "Dưới dòng nước chảy trong veo, Bên cầu tơ liễu bóng chiều thướt tha." (TKiều)',
    example:
      'bắc cầu tre * "Dưới dòng nước chảy trong veo, Bên cầu tơ liễu bóng chiều thướt tha." (TKiều)',
  },
  {
    word: "cầu",
    part_of_speech: "động từ",
    meaning:
      "muốn hoặc theo đuổi điều gì có lợi cho bản thân: cầu danh lợi * bán nước cầu vinh",
    example: "cầu danh lợi * bán nước cầu vinh",
  },
  {
    word: "cầu",
    part_of_speech: "động từ",
    meaning:
      "xin thần linh ban cho những điều mong muốn: cầu trời khấn Phật * cầu thần thánh ban lộc",
    example: "cầu trời khấn Phật * cầu thần thánh ban lộc",
  },
  {
    word: "cầu",
    part_of_speech: "động từ",
    meaning:
      "yêu cầu về hàng hoá, trong quan hệ với khả năng cung cấp hàng hoá trên thị trường: cân đối giữa cung và cầu * có cung ắt có cầu",
    example: "cân đối giữa cung và cầu * có cung ắt có cầu",
  },
  {
    word: "cẩu",
    part_of_speech: "động từ",
    meaning:
      "nâng, hạ và chuyển vật nặng bằng phương tiện cơ giới, thường là bằng máy có cần dài (gọi là cần cẩu): cẩu hàng * cẩu khối đá nặng 20 tấn lên xe",
    example: "cẩu hàng * cẩu khối đá nặng 20 tấn lên xe",
  },
  {
    word: "cầu an",
    part_of_speech: "động từ",
    meaning: "chỉ mong được yên thân: tư tưởng cầu an, ngại khó",
    example: "tư tưởng cầu an, ngại khó",
  },
  {
    word: "câu",
    part_of_speech: "danh từ",
    meaning: "(hiếm) bồ câu (nói tắt): chim câu trắng",
    example: "chim câu trắng",
  },
  {
    word: "câu",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị cơ bản của lời nói, do từ tạo thành, có một ngữ điệu nhất định, diễn đạt một ý trọn vẹn: đặt câu * nói chưa hết câu * nghe câu được câu chăng",
    example: "đặt câu * nói chưa hết câu * nghe câu được câu chăng",
  },
  {
    word: "câu",
    part_of_speech: "danh từ",
    meaning: "câu thơ (nói tắt): bài thơ có tám câu, mỗi câu bảy chữ",
    example: "bài thơ có tám câu, mỗi câu bảy chữ",
  },
  {
    word: "câu",
    part_of_speech: "động từ",
    meaning:
      "bắt cá, tôm, v.v. bằng cần câu, thường có mắc mồi ở lưỡi câu: câu cá ở hồ * đi câu mực",
    example: "câu cá ở hồ * đi câu mực",
  },
  {
    word: "câu",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) dụ một cách khéo léo để kiếm lợi: câu khách hàng",
    example: "câu khách hàng",
  },
  {
    word: "câu",
    part_of_speech: "động từ",
    meaning:
      "móc và chuyển vật nặng từ dưới lên (thường bằng cần cẩu): chiếc cần cẩu đang câu các kiện hàng * câu cây gỗ lên xe",
    example: "chiếc cần cẩu đang câu các kiện hàng * câu cây gỗ lên xe",
  },
  {
    word: "câu",
    part_of_speech: "động từ",
    meaning:
      "bắn cho đạn đi theo hình cầu vồng rồi rơi xuống đích ở xa: đại bác câu vào lô cốt",
    example: "đại bác câu vào lô cốt",
  },
  {
    word: "cậu ấm",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) từ thời trước dùng để gọi con trai nhà quan: cậu ấm, cô chiêu",
    example: "cậu ấm, cô chiêu",
  },
  {
    word: "cầu bơ cầu bất",
    part_of_speech: "tính từ",
    meaning:
      "bơ vơ không nơi nương tựa: thằng bé mồ côi sống cầu bơ cầu bất nơi đầu đường xó chợ",
    example: "thằng bé mồ côi sống cầu bơ cầu bất nơi đầu đường xó chợ",
  },
  {
    word: "cầu cạnh",
    part_of_speech: "động từ",
    meaning:
      "xin xỏ, nhờ vả người có quyền thế để mong được việc gì: cầu cạnh để vay mượn * không phải cầu cạnh ai hết",
    example: "cầu cạnh để vay mượn * không phải cầu cạnh ai hết",
  },
  {
    word: "cầu chì",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận bảo vệ trong mạch điện, gồm phần chính là một dây kim loại dễ nóng chảy (thường là dây chì) để tự động cắt mạch điện khi dòng điện tăng lên quá mức quy định: đứt cầu chì",
    example: "đứt cầu chì",
  },
  {
    word: "câu chấp",
    part_of_speech: "động từ",
    meaning: "(cũ, hiếm) như cố chấp: tính hơi câu chấp",
    example: "tính hơi câu chấp",
  },
  {
    word: "cấu chí",
    part_of_speech: "động từ",
    meaning:
      "cấu véo nhau để trêu ghẹo, đùa nghịch: bọn trẻ suốt ngày cấu chí nhau",
    example: "bọn trẻ suốt ngày cấu chí nhau",
  },
  {
    word: "cầu cống",
    part_of_speech: "danh từ",
    meaning:
      "cầu và cống, về mặt là những công trình bảo đảm sự giao thông (nói khái quát): xây dựng cầu cống",
    example: "xây dựng cầu cống",
  },
  {
    word: "câu cú",
    part_of_speech: "danh từ",
    meaning: "câu văn (nói khái quát; thường hàm ý chê): câu cú lộn xộn",
    example: "câu cú lộn xộn",
  },
  {
    word: "cầu chúc",
    part_of_speech: "động từ",
    meaning:
      "tỏ lời chúc cầu mong một điều tốt lành nào đó: cầu chúc hai người hạnh phúc",
    example: "cầu chúc hai người hạnh phúc",
  },
  {
    word: "cầu cứu",
    part_of_speech: "động từ",
    meaning: "xin được cứu giúp: cầu cứu viện binh * ánh mắt cầu cứu",
    example: "cầu cứu viện binh * ánh mắt cầu cứu",
  },
  {
    word: "câu chuyện",
    part_of_speech: "danh từ",
    meaning:
      "sự việc hoặc chuyện được nói ra: câu chuyện thương tâm * đang dở câu chuyện thì có khách",
    example: "câu chuyện thương tâm * đang dở câu chuyện thì có khách",
  },
  {
    word: "câu dầm",
    part_of_speech: "động từ",
    meaning: "câu bằng cách thả dây dài ngâm lưỡi câu lâu dưới nước.",
    example: "hồ sơ để câu dầm cả tháng không giải quyết",
  },
  {
    word: "cầu dao",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận có hình giống con dao, lắp ở chỗ đầu mối mạch điện, dùng để đóng, ngắt mạch điện: đóng cầu dao điện",
    example: "đóng cầu dao điện",
  },
  {
    word: "câu đố",
    part_of_speech: "danh từ",
    meaning:
      "câu văn vần mô tả người, vật, hiện tượng, v.v. một cách lắt léo hoặc úp mở, dùng để đố nhau: giải được câu đố khó",
    example: "giải được câu đố khó",
  },
  {
    word: "câu đối",
    part_of_speech: "danh từ",
    meaning:
      "thể văn gồm hai vế câu có số lượng từ bằng nhau và đối chọi nhau cả về lời lẫn ý.",
    example: "đôi câu đối sơn son thếp vàng",
  },
  {
    word: "cầu đường",
    part_of_speech: "danh từ",
    meaning: "cầu cống và đường sá: xây dựng cầu đường * kĩ sư cầu đường",
    example: "xây dựng cầu đường * kĩ sư cầu đường",
  },
  {
    word: "cầu duyên",
    part_of_speech: "động từ",
    meaning:
      "cầu (xin thần thánh) cho được may mắn về đường tình duyên (theo tín ngưỡng dân gian): đi lễ cầu duyên",
    example: "đi lễ cầu duyên",
  },
  {
    word: "cầu hiền",
    part_of_speech: "động từ",
    meaning: "(cũ) tìm và thu nạp người hiền tài: xuống chiếu cầu hiền",
    example: "xuống chiếu cầu hiền",
  },
  {
    word: "câu kéo",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) như câu cú: câu kéo kiểu gì mà lạ vậy!",
    example: "câu kéo kiểu gì mà lạ vậy!",
  },
  {
    word: "câu kéo",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) câu (nói khái quát): câu kéo kiểu gì mà cả ngày chỉ được vài con cá ranh",
    example: "câu kéo kiểu gì mà cả ngày chỉ được vài con cá ranh",
  },
  {
    word: "cầu hoà",
    part_of_speech: "động từ",
    meaning: "xin ngừng chiến, không giao tranh nữa: sai sứ giả đến cầu hoà",
    example: "sai sứ giả đến cầu hoà",
  },
  {
    word: "cầu hoà",
    part_of_speech: "động từ",
    meaning:
      "mong hoà, không dám mong thắng (thường nói trong chơi cờ): ván cờ này chỉ cầu hoà",
    example: "ván cờ này chỉ cầu hoà",
  },
  {
    word: "cấu hình",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp các thiết bị (phần cứng) của máy tính kết nối với nhau thành một hệ thống, được dự tính để thực hiện những chức năng định trước: kiểm tra cấu hình của máy * máy tính có cấu hình cao",
    example: "kiểm tra cấu hình của máy * máy tính có cấu hình cao",
  },
  {
    word: "cấu hình",
    part_of_speech: "danh từ",
    meaning:
      "sự chọn lựa trong quá trình thiết lập phần cứng hoặc phần mềm sao cho hệ thống máy tính hoạt động đúng với yêu cầu của người sử dụng: thiết lập các thông số cấu hình của máy tính",
    example: "thiết lập các thông số cấu hình của máy tính",
  },
  {
    word: "cầu hôn",
    part_of_speech: "động từ",
    meaning: "(trang trọng) ngỏ lời để xin được lấy làm vợ: ngỏ lời cầu hôn",
    example: "ngỏ lời cầu hôn",
  },
  {
    word: "cầu hồn",
    part_of_speech: "động từ",
    meaning:
      "cầu cho linh hồn người chết được yên, được lên thiên đường: làm lễ cầu hồn",
    example: "làm lễ cầu hồn",
  },
  {
    word: "cấu kết",
    part_of_speech: "động từ",
    meaning:
      "(với ai) hợp lại với nhau thành phe cánh để cùng thực hiện âm mưu xấu xa: câu kết với giặc",
    example: "câu kết với giặc",
  },
  {
    word: "cầu khẩn",
    part_of_speech: "động từ",
    meaning: "cầu xin một cách khẩn khoản: ánh mắt cầu khẩn * lời cầu khẩn",
    example: "ánh mắt cầu khẩn * lời cầu khẩn",
  },
  {
    word: "cầu khiến",
    part_of_speech: "động từ",
    meaning: "yêu cầu làm hay không làm việc gì (nói khái quát): câu cầu khiến",
    example: "câu cầu khiến",
  },
  {
    word: "câu khách",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tìm cách để thu hút khách hàng nhằm kiếm lợi (hàm ý chê): phim có nhiều cảnh giật gân để câu khách * hạ giá bán để câu khách",
    example:
      "phim có nhiều cảnh giật gân để câu khách * hạ giá bán để câu khách",
  },
  {
    word: "cầu kinh",
    part_of_speech: "động từ",
    meaning: "đọc kinh cầu nguyện: lễ cầu kinh",
    example: "lễ cầu kinh",
  },
  {
    word: "cầu kì",
    part_of_speech: "tính từ",
    meaning:
      "không đơn giản, không tự nhiên, mà quá chú trọng về mặt nào đó, khiến cho có vẻ khác thường một cách cố ý: ăn mặc cầu kì * trang điểm quá cầu kì * lễ nghi cầu kì, phức tạp",
    example: "ăn mặc cầu kì * trang điểm quá cầu kì * lễ nghi cầu kì, phức tạp",
  },
  {
    word: "câu kết",
    part_of_speech: "động từ",
    meaning:
      "(với ai) hợp lại với nhau thành phe cánh để cùng thực hiện âm mưu xấu xa: câu kết với giặc",
    example: "câu kết với giặc",
  },
  {
    word: "cấu kiện",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận hoặc linh kiện dùng để cấu tạo nên một chỉnh thể (như máy móc, công trình, v.v.): sản xuất các cấu kiện bê tông * lắp ráp các cấu kiện máy tính",
    example: "sản xuất các cấu kiện bê tông * lắp ráp các cấu kiện máy tính",
  },
  {
    word: "cầu kiến",
    part_of_speech: "động từ",
    meaning:
      "(cũ) xin được gặp (người có địa vị cao): sứ thần các nước xin được vào cầu kiến nhà vua",
    example: "sứ thần các nước xin được vào cầu kiến nhà vua",
  },
  {
    word: "câu lạc bộ",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức được lập ra cho nhiều người tham gia sinh hoạt văn hoá, giải trí trong những lĩnh vực nhất định: câu lạc bộ những người chơi tem * tham gia câu lạc bộ thơ",
    example: "câu lạc bộ những người chơi tem * tham gia câu lạc bộ thơ",
  },
  {
    word: "câu lạc bộ",
    part_of_speech: "danh từ",
    meaning:
      "nhà dùng làm nơi tổ chức các hoạt động văn hoá, chính trị, giải trí, thể thao, v.v. nhất định: chơi bóng bàn ở câu lạc bộ",
    example: "chơi bóng bàn ở câu lạc bộ",
  },
  {
    word: "cầu may",
    part_of_speech: "động từ",
    meaning:
      "chỉ trông mong vào sự may mắn, không có sự đảm bảo tin chắc: làm cầu may, không chắc đã có kết quả",
    example: "làm cầu may, không chắc đã có kết quả",
  },
  {
    word: "câu liêm",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ gồm một lưỡi quắm hình lưỡi liềm lắp vào cán dài, dùng để móc vào mà giật, cắt những vật ở trên cao: dùng câu liêm chữa cháy",
    example: "dùng câu liêm chữa cháy",
  },
  {
    word: "cầu môn",
    part_of_speech: "danh từ",
    meaning: "khung thành: đưa bóng lọt vào cầu môn",
    example: "đưa bóng lọt vào cầu môn",
  },
  {
    word: "cầu mong",
    part_of_speech: "động từ",
    meaning:
      "mong ước tha thiết điều may mắn, tốt lành sẽ đến: cầu mong tai qua nạn khỏi * cầu mong cho mưa thuận gió hoà",
    example: "cầu mong tai qua nạn khỏi * cầu mong cho mưa thuận gió hoà",
  },
  {
    word: "câu nệ",
    part_of_speech: "động từ",
    meaning:
      "xử lí thiếu linh hoạt, cứ rập khuôn theo cái đã định sẵn: câu nệ theo nếp cũ * chỉ chú ý nội dung, không câu nệ hình thức",
    example: "câu nệ theo nếp cũ * chỉ chú ý nội dung, không câu nệ hình thức",
  },
  {
    word: "câu nệ",
    part_of_speech: "động từ",
    meaning: "ngại ngùng, giữ kẽ: cứ tự nhiên, không có gì phải câu nệ",
    example: "cứ tự nhiên, không có gì phải câu nệ",
  },
  {
    word: "cầu nguyện",
    part_of_speech: "động từ",
    meaning:
      "cầu xin thần linh ban cho điều tốt lành: lời cầu nguyện * đọc kinh cầu nguyện",
    example: "lời cầu nguyện * đọc kinh cầu nguyện",
  },
  {
    word: "cầu phúc",
    part_of_speech: "động từ",
    meaning:
      "cầu xin thần thánh ban cho điều tốt lành, hạnh phúc: đến chùa cầu phúc",
    example: "đến chùa cầu phúc",
  },
  {
    word: "cầu siêu",
    part_of_speech: "động từ",
    meaning:
      "cầu xin cho linh hồn người chết được siêu thoát, theo đạo Phật: làm lễ cầu siêu ở chùa * tụng kinh cầu siêu",
    example: "làm lễ cầu siêu ở chùa * tụng kinh cầu siêu",
  },
  {
    word: "cầu nối",
    part_of_speech: "danh từ",
    meaning:
      "cái giữ vai trò làm trung gian để cho các bên được gần gũi nhau hơn trong các vấn đề cùng quan tâm: làm cầu nối giữa các đối tác",
    example: "làm cầu nối giữa các đối tác",
  },
  {
    word: "cầu phao",
    part_of_speech: "danh từ",
    meaning:
      "cầu ghép nổi trên mặt nước nhờ các phao hoặc vật nổi: bộ đội bắc cầu phao để vượt sông",
    example: "bộ đội bắc cầu phao để vượt sông",
  },
  {
    word: "cầu thang",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận gồm nhiều bậc, dùng để lên xuống các tầng nhà: cầu thang gỗ * leo lên cầu thang * gầm cầu thang",
    example: "cầu thang gỗ * leo lên cầu thang * gầm cầu thang",
  },
  {
    word: "cẩu thả",
    part_of_speech: "tính từ",
    meaning:
      "(làm việc gì) không đến nơi đến chốn, không cẩn thận, chỉ cốt cho xong: làm ăn cẩu thả * tính cẩu thả",
    example: "làm ăn cẩu thả * tính cẩu thả",
  },
  {
    word: "cấu tạo",
    part_of_speech: "động từ",
    meaning:
      "tạo ra bằng cách kết hợp nhiều bộ phận lại: yếu tố cấu tạo từ * cách cấu tạo một bài văn * nguyên lí cấu tạo máy",
    example:
      "yếu tố cấu tạo từ * cách cấu tạo một bài văn * nguyên lí cấu tạo máy",
  },
  {
    word: "cấu tạo",
    part_of_speech: "danh từ",
    meaning:
      "thành phần và cách sắp xếp, tổ chức các thành phần của một chỉnh thể: máy có cấu tạo gọn nhẹ * cấu tạo nguyên tử và hạt nhân",
    example: "máy có cấu tạo gọn nhẹ * cấu tạo nguyên tử và hạt nhân",
  },
  {
    word: "cấu thành",
    part_of_speech: "động từ",
    meaning:
      "làm thành, tạo nên: các bộ phận cấu thành của nền kinh tế * yếu tố cấu thành tội phạm",
    example:
      "các bộ phận cấu thành của nền kinh tế * yếu tố cấu thành tội phạm",
  },
  {
    word: "cầu thân",
    part_of_speech: "động từ",
    meaning:
      '(cũ, văn chương) xin kết hôn với ai hoặc làm thông gia với gia đình nào đó: "Thương mình chẳng tiếc vàng cân, Trèo non lặn suối quyết cầu thân mới vừa." (ca dao)',
    example:
      'Thương mình chẳng tiếc vàng cân, Trèo non lặn suối quyết cầu thân mới vừa." (ca dao)',
  },
  {
    word: "cầu thân",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) muốn làm thân với nhau: nụ cười cầu thân * cầu thân với người quyền thế hòng nhờ vả",
    example: "nụ cười cầu thân * cầu thân với người quyền thế hòng nhờ vả",
  },
  {
    word: "câu thơ",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị cơ bản của lời thơ, do từ tạo thành, có một tiết tấu nhất định, thường viết bằng một dòng: câu thơ lục bát * giải thích nghĩa một câu thơ cổ",
    example: "câu thơ lục bát * giải thích nghĩa một câu thơ cổ",
  },
  {
    word: "cầu thủ",
    part_of_speech: "danh từ",
    meaning:
      "người tập luyện hoặc thi đấu một môn bóng nào đó: cầu thủ bóng đá * cầu thủ bóng rổ",
    example: "cầu thủ bóng đá * cầu thủ bóng rổ",
  },
  {
    word: "cầu treo",
    part_of_speech: "danh từ",
    meaning:
      "cầu có các nhịp được làm bằng hệ thống dây treo vào các cột trụ: bắc cầu treo qua hẻm núi",
    example: "bắc cầu treo qua hẻm núi",
  },
  {
    word: "câu thúc",
    part_of_speech: "động từ",
    meaning:
      "gò bó, trói buộc, làm mất tự do: bị lễ giáo phong kiến câu thúc * không chịu bị câu thúc, ràng buộc",
    example:
      "bị lễ giáo phong kiến câu thúc * không chịu bị câu thúc, ràng buộc",
  },
  {
    word: "cầu toàn",
    part_of_speech: "động từ",
    meaning: "ngu si đần độn: tư tưởng cầu toàn",
    example: "tư tưởng cầu toàn",
  },
  {
    word: "cấu trúc",
    part_of_speech: "danh từ",
    meaning:
      "quan hệ giữa các thành phần tạo nên một chỉnh thể (nói tổng quát): cấu trúc câu * nghiên cứu cấu trúc của xương",
    example: "cấu trúc câu * nghiên cứu cấu trúc của xương",
  },
  {
    word: "cấu trúc",
    part_of_speech: "động từ",
    meaning:
      "làm ra, tạo nên một chỉnh thể với những thành phần và quan hệ nhất định: cách cấu trúc dữ liệu",
    example: "cách cấu trúc dữ liệu",
  },
  {
    word: "cầu trường",
    part_of_speech: "danh từ",
    meaning:
      "sân bóng đá (thường nói lúc có rất đông người xem): cả cầu trường hò reo vang dội",
    example: "cả cầu trường hò reo vang dội",
  },
  {
    word: "cấu tứ",
    part_of_speech: "động từ",
    meaning:
      "(văn nghệ sĩ) suy nghĩ, xác định và tổ chức về cả hai mặt nội dung và nghệ thuật trong quá trình chuẩn bị sáng tác một tác phẩm: bài thơ có cấu tứ rất lạ",
    example: "bài thơ có cấu tứ rất lạ",
  },
  {
    word: "cầu tự",
    part_of_speech: "động từ",
    meaning:
      "cầu xin Trời Phật cho sinh con, thường là con trai để nối dõi (theo quan niệm cũ): con cầu tự * hiếm muộn, phải đến chùa cầu tự",
    example: "con cầu tự * hiếm muộn, phải đến chùa cầu tự",
  },
  {
    word: "cầu viện",
    part_of_speech: "động từ",
    meaning: "xin cứu viện: cho người đi cầu viện",
    example: "cho người đi cầu viện",
  },
  {
    word: "cầu vai",
    part_of_speech: "danh từ",
    meaning: "miếng vải đính hai bên vai áo sơ mi: đeo quân hàm ở cầu vai",
    example: "đeo quân hàm ở cầu vai",
  },
  {
    word: "cầu vai",
    part_of_speech: "danh từ",
    meaning:
      "miếng vải đệm suốt từ vai nọ sang vai kia, ở phần trên lưng áo sơ mi: cầu vai áo may hơi rộng",
    example: "cầu vai áo may hơi rộng",
  },
  {
    word: "cầu vồng",
    part_of_speech: "danh từ",
    meaning:
      "hiện tượng quang học khí quyển, là hình vòng cung gồm nhiều dải sáng, phân biệt đủ bảy màu chính, xuất hiện trên bầu trời phía đối diện với mặt trời (hay mặt trăng), do hiện tượng các tia sáng mặt trời bị khúc xạ và phản xạ qua những giọt nước trong màn mưa hoặc mây mù tạo thành: bảy sắc cầu vồng * bắn cầu vồng (bắn theo hình cầu vồng)",
    example: "bảy sắc cầu vồng * bắn cầu vồng (bắn theo hình cầu vồng)",
  },
  {
    word: "cầu xin",
    part_of_speech: "động từ",
    meaning:
      "xin một cách khẩn khoản, thiết tha, nhẫn nhục: cầu xin trời Phật che chở",
    example: "cầu xin trời Phật che chở",
  },
  {
    word: "cấu xé",
    part_of_speech: "động từ",
    meaning: "cấu và xé, làm cho rách nát, đau đớn: lao vào cấu xé nhau",
    example: "lao vào cấu xé nhau",
  },
  {
    word: "cấu xé",
    part_of_speech: "động từ",
    meaning:
      "tranh giành nhau kịch liệt và tìm cách hại nhau: các phe phái tìm cách cấu xé lẫn nhau",
    example: "các phe phái tìm cách cấu xé lẫn nhau",
  },
  {
    word: "cấu véo",
    part_of_speech: "động từ",
    meaning:
      "cấu và véo vào da thịt để làm cho đau hoặc để trêu chọc (nói khái quát): bọn trẻ cấu véo nhau",
    example: "bọn trẻ cấu véo nhau",
  },
  {
    word: "cấu véo",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bớt xén, lấy đi từng ít một để làm của riêng: cấu véo vào công quỹ",
    example: "cấu véo vào công quỹ",
  },
  {
    word: "cấy",
    part_of_speech: "động từ",
    meaning:
      "cắm cây non xuống chỗ đất khác cho tiếp tục sinh trưởng: cấy lúa * cấy rau * có cấy có trông, có trồng có ăn (tng)",
    example: "cấy lúa * cấy rau * có cấy có trông, có trồng có ăn (tng)",
  },
  {
    word: "cấy",
    part_of_speech: "động từ",
    meaning:
      "trồng lúa, làm ruộng (nói chung): chuẩn bị cấy vụ chiêm *  ruộng cấy hai vụ",
    example: "chuẩn bị cấy vụ chiêm *  ruộng cấy hai vụ",
  },
  {
    word: "cấy",
    part_of_speech: "động từ",
    meaning:
      "dùng kĩ thuật và biện pháp khoa học cao để đưa một đối tượng có kích thước rất nhỏ hoặc có cấu tạo rất phức tạp như vi trùng, mô, v.v. vào một môi trường nào đấy để thực hiện những yêu cầu nhất định như nghiên cứu, chữa bệnh hoặc tạo ra một giống mới, v.v.: cấy vi trùng lao * kĩ thuật cấy da",
    example: "cấy vi trùng lao * kĩ thuật cấy da",
  },
  {
    word: "cây",
    part_of_speech: "danh từ",
    meaning:
      "thực vật có rễ, thân, lá rõ rệt, hoặc vật có hình thù giống những thực vật có thân, lá: cây tre * ăn quả nhớ kẻ trồng cây (tng)",
    example: "cây tre * ăn quả nhớ kẻ trồng cây (tng)",
  },
  {
    word: "cây",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng vật có thân thẳng, cao, hoặc dài (trông giống như hình thân cây): cây cột * cây nến * cây rơm * cây sào",
    example: "cây cột * cây nến * cây rơm * cây sào",
  },
  {
    word: "cây",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ, khẩu ngữ) gỗ: mua cây làm nhà",
    example: "mua cây làm nhà",
  },
  {
    word: "cây",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) từ dùng để chỉ người nổi trội về một mặt nào đó trong sinh hoạt, trong cuộc sống: cô bé là cây văn nghệ của lớp * cây làm bàn của đội bóng",
    example: "cô bé là cây văn nghệ của lớp * cây làm bàn của đội bóng",
  },
  {
    word: "cây",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) cây số (nói tắt): còn chừng ba cây nữa là đến nơi",
    example: "còn chừng ba cây nữa là đến nơi",
  },
  {
    word: "cây",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) lạng (vàng): căn nhà này giá 35 cây",
    example: "căn nhà này giá 35 cây",
  },
  {
    word: "cậy",
    part_of_speech: "danh từ",
    meaning:
      'cây giống cây hồng, nhưng quả bé và chát, có nhựa dính như keo: "Còn duyên buôn cậy bán hồng, Hết duyên buôn mít cho chồng nhặt xơ." (ca dao)',
    example:
      'Còn duyên buôn cậy bán hồng, Hết duyên buôn mít cho chồng nhặt xơ." (ca dao)',
  },
  {
    word: "cậy",
    part_of_speech: "động từ",
    meaning:
      '(hiếm) như nhờ: cậy người mai mối * "Cậy em, em có chịu lời?, Ngồi lên cho chị lạy, rồi sẽ thưa." (TKiều)',
    example:
      'cậy người mai mối * "Cậy em, em có chịu lời?, Ngồi lên cho chị lạy, rồi sẽ thưa." (TKiều)',
  },
  {
    word: "cậy",
    part_of_speech: "động từ",
    meaning:
      "ỷ vào ưu thế nào đó của mình: cậy thế làm càn * cậy nhà gần nên bắt nạt người khác",
    example: "cậy thế làm càn * cậy nhà gần nên bắt nạt người khác",
  },
  {
    word: "cầy",
    part_of_speech: "danh từ",
    meaning:
      "thú ăn thịt, sống ở hang hốc, mõm nhọn, tai nhỏ, mình dài, chân thấp, có tuyến tiết mùi đặc biệt.",
    example: "thịt cầy * cầy tơ bảy món",
  },
  {
    word: "cây bụi",
    part_of_speech: "danh từ",
    meaning:
      "cây gỗ nhỏ, có nhiều cành mọc sát gốc, tạo nên một khóm rậm: rừng cây bụi * sim, mua là những loài cây bụi",
    example: "rừng cây bụi * sim, mua là những loài cây bụi",
  },
  {
    word: "cây bút",
    part_of_speech: "danh từ",
    meaning:
      "người chuyên viết văn, viết báo (về mặt có một tính chất nào đó): một cây bút trẻ * cây bút phóng sự nổi tiếng",
    example: "một cây bút trẻ * cây bút phóng sự nổi tiếng",
  },
  {
    word: "cây bông",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) pháo hoa hình cây, khi đốt xoè thành nhiều màu: đốt cây bông",
    example: "đốt cây bông",
  },
  {
    word: "cây cỏ",
    part_of_speech: "danh từ",
    meaning: "như cỏ cây: chim muông, cây cỏ",
    example: "chim muông, cây cỏ",
  },
  {
    word: "cây cảnh",
    part_of_speech: "danh từ",
    meaning:
      "cây trồng để làm cảnh (nói chung): phát triển nghề trồng hoa, cây cảnh * nghệ thuật chơi cây cảnh",
    example: "phát triển nghề trồng hoa, cây cảnh * nghệ thuật chơi cây cảnh",
  },
  {
    word: "cây cổ thụ",
    part_of_speech: "danh từ",
    meaning: "cây to sống đã lâu năm: cây đa cổ thụ",
    example: "cây đa cổ thụ",
  },
  {
    word: "cây công nghiệp",
    part_of_speech: "danh từ",
    meaning:
      "cây trồng cung cấp nguyên liệu cho các ngành công nghiệp, như cao su, dầu, v.v.: tăng diện tích cây công nghiệp",
    example: "tăng diện tích cây công nghiệp",
  },
  {
    word: "cây cối",
    part_of_speech: "danh từ",
    meaning:
      "cây (nói khái quát): bảo vệ cây cối trong công viên * cây cối mọc um tùm",
    example: "bảo vệ cây cối trong công viên * cây cối mọc um tùm",
  },
  {
    word: "cây gỗ",
    part_of_speech: "danh từ",
    meaning:
      "cây có thân to, cho gỗ dùng để xây dựng nhà cửa, đóng đồ đạc, v.v.: phát triển rừng cây gỗ",
    example: "phát triển rừng cây gỗ",
  },
  {
    word: "cây cọ",
    part_of_speech: "danh từ",
    meaning:
      "cây bút lông để vẽ; cũng dùng để chỉ người vẽ tranh, hoạ sĩ (về mặt có một tính chất nào đó): một cây cọ trẻ có nhiều triển vọng",
    example: "một cây cọ trẻ có nhiều triển vọng",
  },
  {
    word: "cậy cục",
    part_of_speech: "động từ",
    meaning:
      "cầu cạnh nhờ vả một cách vất vả: cậy cục mãi mới xin được một chỗ làm",
    example: "cậy cục mãi mới xin được một chỗ làm",
  },
  {
    word: "cây đa cây đề",
    part_of_speech: "",
    meaning:
      "cây đa và cây đề, những cây to, sống lâu năm; ví người có thâm niên cao, có uy tín lớn trong nghề: toàn các cây đa cây đề trong ngành",
    example: "toàn các cây đa cây đề trong ngành",
  },
  {
    word: "cấy ghép",
    part_of_speech: "động từ",
    meaning:
      "cấy hoặc ghép một bộ phận của cơ thể sống lên một chỗ khác của cơ thể đó hoặc lên một cơ thể khác: cấy ghép tuỷ sống * cấy ghép nội tạng",
    example: "cấy ghép tuỷ sống * cấy ghép nội tạng",
  },
  {
    word: "cây hoa màu",
    part_of_speech: "danh từ",
    meaning:
      "cây trồng trên cạn (trừ lúa ra, như ngô, khoai, đậu, vừng, v.v.), dùng làm lương thực và thực phẩm, hoặc làm thức ăn chăn nuôi (nói khái quát): trồng hoa màu * tăng diện tích hoa màu",
    example: "trồng hoa màu * tăng diện tích hoa màu",
  },
  {
    word: "cấy hái",
    part_of_speech: "động từ",
    meaning:
      "cấy cày, trồng trọt và thu hoạch (nói khái quát): thời tiết này thì cấy hái gì!",
    example: "thời tiết này thì cấy hái gì!",
  },
  {
    word: "cây leo",
    part_of_speech: "danh từ",
    meaning:
      "cây có thân yếu không tự mọc đứng được một mình, mà phải bám vào cây hoặc vật khác bằng cách tự quấn thân xung quanh hoặc nhờ những tua cuốn, như mướp, gấc, v.v.: bầu, bí thuộc loài cây leo",
    example: "bầu, bí thuộc loài cây leo",
  },
  {
    word: "cây lương thực",
    part_of_speech: "danh từ",
    meaning:
      "cây trồng để cung cấp chất bột dùng làm thức ăn chính cho người, như lúa, ngô, khoai, sắn, v.v.: phát triển cây lương thực trên diện rộng",
    example: "phát triển cây lương thực trên diện rộng",
  },
  {
    word: "cấy mô",
    part_of_speech: "động từ",
    meaning:
      "chuyển hoặc tách một mô của cơ thể sinh vật sang một cơ thể khác, hoặc nuôi trong môi trường nhân tạo, nhằm mục đích nhân giống hay nghiên cứu khoa học: nhân giống bằng phương pháp cấy mô",
    example: "nhân giống bằng phương pháp cấy mô",
  },
  {
    word: "cây nhà lá vườn",
    part_of_speech: "",
    meaning:
      "hoa quả và nói chung những thứ tự nhà mình làm ra (dùng để nói về quà đem biếu hoặc mời khách): biếu anh mấy quả cam, cây nhà lá vườn",
    example: "biếu anh mấy quả cam, cây nhà lá vườn",
  },
  {
    word: "cây quỳnh cành dao",
    part_of_speech: "",
    meaning:
      '(cũ, văn chương) ví người và cảnh tươi đẹp hài hoà, làm tôn giá trị của nhau lên: "Hài văn lần bước dặm xanh, Một vùng như thể cây quỳnh, cành dao." (TKiều)',
    example:
      'Hài văn lần bước dặm xanh, Một vùng như thể cây quỳnh, cành dao." (TKiều)',
  },
  {
    word: "cây số",
    part_of_speech: "danh từ",
    meaning:
      "trụ xây hoặc cột chôn cạnh đường để làm mốc cho khoảng cách từng kilomet một, trên đó có ghi số kilomet tính từ một nơi nào đó hoặc cách xa một nơi nào đó: xe dừng ở cây số 42 * cột cây số",
    example: "xe dừng ở cây số 42 * cột cây số",
  },
  {
    word: "cây số",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi thông thường của kilomet: đất của nông trường trải dài khoảng hai cây số",
    example: "đất của nông trường trải dài khoảng hai cây số",
  },
  {
    word: "cây trồng",
    part_of_speech: "danh từ",
    meaning:
      "cây được thuần hoá, chọn lọc để đưa vào trồng trọt trong sản xuất nông nghiệp (nói khái quát): lựa chọn giống cây trồng * chuyên canh một loại cây trồng",
    example: "lựa chọn giống cây trồng * chuyên canh một loại cây trồng",
  },
  {
    word: "cây thế",
    part_of_speech: "danh từ",
    meaning:
      "cây cảnh được uốn tỉa, tạo dáng vẻ riêng: tạo dáng cho cây thế * nghệ thuật chơi cây thế",
    example: "tạo dáng cho cây thế * nghệ thuật chơi cây thế",
  },
  {
    word: "cây thuốc",
    part_of_speech: "danh từ",
    meaning: "cây trồng làm thuốc chữa bệnh: trồng cây thuốc",
    example: "trồng cây thuốc",
  },
  {
    word: "cây viết",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) bút: cây viết chì",
    example: "cây viết chì",
  },
  {
    word: "cây viết",
    part_of_speech: "danh từ",
    meaning: "cây bút: một cây viết trẻ nhiều triển vọng",
    example: "một cây viết trẻ nhiều triển vọng",
  },
  {
    word: "cây xanh",
    part_of_speech: "danh từ",
    meaning:
      "cây cỏ được trồng để bảo vệ môi trường, nói chung: trồng cây xanh trong thành phố",
    example: "trồng cây xanh trong thành phố",
  },
  {
    word: "cc",
    part_of_speech: "danh từ",
    meaning:
      "(F: centimètre-cube, viết tắt) phân khối: bán 200 CC máu * xe máy có động cơ 110 CC",
    example: "bán 200 CC máu * xe máy có động cơ 110 CC",
  },
  {
    word: "cha",
    part_of_speech: "danh từ",
    meaning:
      "người đàn ông có con, trong quan hệ với con (có thể dùng để xưng gọi): cha và con * công cha nghĩa mẹ",
    example: "cha và con * công cha nghĩa mẹ",
  },
  {
    word: "cha",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để gọi linh mục hoặc linh mục tự xưng khi nói với người theo Công giáo: nghe cha giảng đạo",
    example: "nghe cha giảng đạo",
  },
  {
    word: "cha",
    part_of_speech: "danh từ",
    meaning:
      "(Phương ngữ, Khẩu ngữ) từ dùng để gọi người đàn ông thuộc hàng bạn bè hàm ý thân mật: thôi đi mấy cha, uống vừa vừa chứ!",
    example: "thôi đi mấy cha, uống vừa vừa chứ!",
  },
  {
    word: "cha",
    part_of_speech: "danh từ",
    meaning:
      '(Thông tục) từ dùng trong một số tiếng chửi rủa, chửi mắng: "Chém cha cái kiếp lấy chồng chung, Kẻ đắp chăn bông, kẻ lạnh lùng." (HXHương; 25)',
    example:
      'Chém cha cái kiếp lấy chồng chung, Kẻ đắp chăn bông, kẻ lạnh lùng." (HXHương; 25)',
  },
  {
    word: "chả",
    part_of_speech: "danh từ",
    meaning:
      "món ăn làm bằng thịt, cá hoặc tôm thái miếng, băm hoặc giã nhỏ, ướp gia vị, rồi rán hoặc nướng: chả cá * bún chả * chả rán * nem công chả phượng",
    example: "chả cá * bún chả * chả rán * nem công chả phượng",
  },
  {
    word: "chả",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ) giò: gói chả",
    example: "gói chả",
  },
  {
    word: "chả",
    part_of_speech: "phụ từ",
    meaning: "(Khẩu ngữ) như chẳng: chả biết * chán chả buồn nói",
    example: "chả biết * chán chả buồn nói",
  },
  {
    word: "cha anh",
    part_of_speech: "danh từ",
    meaning:
      "những người lớn tuổi thuộc thế hệ trước (thế hệ cha, anh), trong quan hệ với lớp người thuộc thế hệ con em mình hoặc coi như con em của mình (nói khái quát): nối gót cha anh",
    example: "nối gót cha anh",
  },
  {
    word: "chà",
    part_of_speech: "danh từ",
    meaning:
      "cành cây có nhiều nhánh nhỏ, thường dùng để rào hoặc thả dưới nước cho cá đến ở: thả chà",
    example: "thả chà",
  },
  {
    word: "chà",
    part_of_speech: "động từ",
    meaning:
      "áp mạnh bàn tay, bàn chân hoặc vật gì có mặt phẳng xuống và đưa đi đưa lại nhiều lần trên bề mặt để làm cho tróc, vỡ hoặc nát ra: chà đậu * đám cây bị voi chà nát",
    example: "chà đậu * đám cây bị voi chà nát",
  },
  {
    word: "chà",
    part_of_speech: "cảm từ",
    meaning:
      "tiếng thốt ra, biểu lộ ý than phiền hoặc ngạc nhiên, tán thưởng: chà, buồn ngủ quá! * chà, đẹp đấy!",
    example: "chà, buồn ngủ quá! * chà, đẹp đấy!",
  },
  {
    word: "chả chớt",
    part_of_speech: "tính từ",
    meaning:
      "(giọng) nửa đùa nửa thật, không đứng đắn: ăn nói chả chớt * giọng chả chớt",
    example: "ăn nói chả chớt * giọng chả chớt",
  },
  {
    word: "chà đạp",
    part_of_speech: "động từ",
    meaning:
      "giẫm lên và giày xéo cho nát, thường dùng để ví hành động vi phạm một cách thô bạo cái đáng lẽ phải được tôn trọng: nhân cách bị chà đạp * chà đạp lên thân phận người phụ nữ",
    example: "nhân cách bị chà đạp * chà đạp lên thân phận người phụ nữ",
  },
  {
    word: "cha già con cọc",
    part_of_speech: "",
    meaning:
      "cha đã nhiều tuổi mà con thì còn bé dại; chỉ cảnh người đàn ông có con muộn: sống trong cảnh cha già con cọc",
    example: "sống trong cảnh cha già con cọc",
  },
  {
    word: "cha đẻ",
    part_of_speech: "danh từ",
    meaning:
      "người tạo ra, sáng lập ra cái mà trước đó chưa từng có: Einstein là cha đẻ của thuyết tương đối",
    example: "Einstein là cha đẻ của thuyết tương đối",
  },
  {
    word: "cha chú",
    part_of_speech: "danh từ",
    meaning:
      "người đàn ông có tuổi thuộc thế hệ trước (thế hệ cha, chú), trong quan hệ với lớp người thuộc thế hệ con cháu của mình hoặc coi như con cháu của mình (nói khái quát): bậc cha chú",
    example: "bậc cha chú",
  },
  {
    word: "cha đời",
    part_of_speech: "",
    meaning:
      '(thông tục) tiếng vừa dùng để chửi vừa dùng để than: "Cha đời cái áo rách này, Mất chúng mất bạn vì mày áo ơi!" (ca dao)',
    example:
      'Cha đời cái áo rách này, Mất chúng mất bạn vì mày áo ơi!" (ca dao)',
  },
  {
    word: "chả giò",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) giò lụa: gói chả giò",
    example: "gói chả giò",
  },
  {
    word: "chả là",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp dùng để đưa đẩy lời nói, nhằm phân bua hoặc thanh minh (điều gì): chả là mấy hôm nay bị ốm, nên mới phải nghỉ",
    example: "chả là mấy hôm nay bị ốm, nên mới phải nghỉ",
  },
  {
    word: "cha mẹ",
    part_of_speech: "danh từ",
    meaning: "cha và mẹ (nói khái quát): hiếu thuận với cha mẹ",
    example: "hiếu thuận với cha mẹ",
  },
  {
    word: "chạc",
    part_of_speech: "danh từ",
    meaning: "chỗ cành cây chẽ làm nhiều nhánh: ngồi trên một chạc cây",
    example: "ngồi trên một chạc cây",
  },
  {
    word: "chạc",
    part_of_speech: "danh từ",
    meaning: "chi tiết máy hình chạc cây: chạc chữ Y",
    example: "chạc chữ Y",
  },
  {
    word: "chạc",
    part_of_speech: "danh từ",
    meaning:
      "dây bện bằng lạt tre, lạt nứa, nhỏ và ngắn hơn dây thừng, dùng để buộc: đánh chạc * xỏ chạc vào mũi trâu",
    example: "đánh chạc * xỏ chạc vào mũi trâu",
  },
  {
    word: "chạc",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) ghẹ vào của người khác để khỏi phải trả tiền: ăn chạc * hết tiền đi chạc xe",
    example: "ăn chạc * hết tiền đi chạc xe",
  },
  {
    word: "cha nội",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) từ dùng trong đối thoại để gọi đùa người đàn ông còn trẻ (tỏ ý thân mật): thôi đi, cha nội! * lề mề quá mấy cha nội ơi!",
    example: "thôi đi, cha nội! * lề mề quá mấy cha nội ơi!",
  },
  {
    word: "cha ông",
    part_of_speech: "danh từ",
    meaning: "như ông cha: tiếp bước cha ông",
    example: "tiếp bước cha ông",
  },
  {
    word: "cha truyền con nối",
    part_of_speech: "",
    meaning:
      "nói về sự kế thừa từ đời nọ sang đời kia những tính chất hoặc chức tước, địa vị: nghề cha truyền con nối",
    example: "nghề cha truyền con nối",
  },
  {
    word: "chà xát",
    part_of_speech: "động từ",
    meaning: "(hiếm) chà đi chà lại nhiều lần: chà xát hai bàn tay vào nhau",
    example: "chà xát hai bàn tay vào nhau",
  },
  {
    word: "chài",
    part_of_speech: "danh từ",
    meaning:
      "lưới hình nón, mép dưới có chì, chóp buộc vào một dây dài, dùng để quăng xuống nước chụp lấy cá mà bắt: quăng chài trên sông * mất cả chì lẫn chài",
    example: "quăng chài trên sông * mất cả chì lẫn chài",
  },
  {
    word: "chài",
    part_of_speech: "động từ",
    meaning:
      'đánh cá bằng chài: chài cá * "Chồng chài, vợ lưới, con câu, Sông Ngô bể Sở biết đâu là nhà." (Cdao)',
    example:
      'chài cá * "Chồng chài, vợ lưới, con câu, Sông Ngô bể Sở biết đâu là nhà." (Cdao)',
  },
  {
    word: "chài",
    part_of_speech: "động từ",
    meaning:
      "đánh bắt tôm cá (nói khái quát): dân chài * nghề chài * thuyền chài * làng chài",
    example: "dân chài * nghề chài * thuyền chài * làng chài",
  },
  {
    word: "chài",
    part_of_speech: "động từ",
    meaning:
      "dùng tà thuật, ma quỷ làm cho người khác mê muội, đau ốm, v.v., theo mê tín: bị ma chài",
    example: "bị ma chài",
  },
  {
    word: "chài",
    part_of_speech: "động từ",
    meaning: "(Khẩu ngữ) quyến rũ làm cho say đắm: bị gái chài",
    example: "bị gái chài",
  },
  {
    word: "chạm",
    part_of_speech: "động từ",
    meaning: "đụng nhẹ vào: chân chạm đất * chạm tay vào bóng",
    example: "chân chạm đất * chạm tay vào bóng",
  },
  {
    word: "chạm",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) gặp một cách đột nhiên, bất ngờ: chạm phải toán biệt kích của địch * hai người vô tình chạm nhau ở chân cầu thang",
    example:
      "chạm phải toán biệt kích của địch * hai người vô tình chạm nhau ở chân cầu thang",
  },
  {
    word: "chạm",
    part_of_speech: "động từ",
    meaning:
      "động đến cái mà người khác thấy phải giữ gìn, phải coi trọng: chạm đến danh dự * bị chạm tự ái * chạm vào nỗi đau của người khác",
    example:
      "chạm đến danh dự * bị chạm tự ái * chạm vào nỗi đau của người khác",
  },
  {
    word: "chạm",
    part_of_speech: "động từ",
    meaning:
      "khắc, đục lên bề mặt vật rắn như gỗ, đá, kim loại, v.v., để tạo thành những đường nét, hình khối mang tính nghệ thuật: chân sập chạm rồng",
    example: "chân sập chạm rồng",
  },
  {
    word: "chải",
    part_of_speech: "động từ",
    meaning:
      "làm cho thẳng, mượt, sạch, bằng lược hoặc bàn chải: chải đầu * chải quần bò cho sạch",
    example: "chải đầu * chải quần bò cho sạch",
  },
  {
    word: "chải chuốt",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ, hiếm) sửa sang, tô điểm công phu, cầu kì cho hình thức bên ngoài: chải chuốt quần áo * suốt ngày chỉ chải chuốt",
    example: "chải chuốt quần áo * suốt ngày chỉ chải chuốt",
  },
  {
    word: "chải chuốt",
    part_of_speech: "tính từ",
    meaning:
      '(hình thức bên ngoài của con người) được sửa sang, tô điểm công phu, có phần cầu kì: ăn mặc chải chuốt * "Một chàng vừa trạc thanh xuân, Hình dung chải chuốt, áo khăn dịu dàng." (TKiều)',
    example:
      'ăn mặc chải chuốt * "Một chàng vừa trạc thanh xuân, Hình dung chải chuốt, áo khăn dịu dàng." (TKiều)',
  },
  {
    word: "chải chuốt",
    part_of_speech: "tính từ",
    meaning:
      "(văn chương) được gọt giũa công phu, có phần cầu kì: câu văn chải chuốt",
    example: "câu văn chải chuốt",
  },
  {
    word: "chai",
    part_of_speech: "danh từ",
    meaning:
      "đồ đựng bằng thuỷ tinh hoặc nhựa cổ nhỏ và dài, thường dùng để đựng chất lỏng: chai nửa lít * chai nước mắm",
    example: "chai nửa lít * chai nước mắm",
  },
  {
    word: "chai",
    part_of_speech: "danh từ",
    meaning:
      "chỗ da dày và cứng lại, do bị cọ xát nhiều: hai bàn tay nổi chai vì làm lụng vất vả",
    example: "hai bàn tay nổi chai vì làm lụng vất vả",
  },
  {
    word: "chai",
    part_of_speech: "tính từ",
    meaning:
      "(da) đã trở thành dày và cứng vì bị cọ xát nhiều: làm nhiều chai cả tay",
    example: "làm nhiều chai cả tay",
  },
  {
    word: "chai",
    part_of_speech: "tính từ",
    meaning:
      "(đất) đã trở thành cứng, không tơi xốp, khó cày bừa: đất chai như đá * bón phân hữu cơ cho đất ruộng khỏi chai",
    example: "đất chai như đá * bón phân hữu cơ cho đất ruộng khỏi chai",
  },
  {
    word: "chai",
    part_of_speech: "tính từ",
    meaning:
      "đã trở thành trơ, lì, vì đã quá quen: chai mặt, không còn biết xấu hổ nữa",
    example: "chai mặt, không còn biết xấu hổ nữa",
  },
  {
    word: "chài lưới",
    part_of_speech: "danh từ",
    meaning:
      "chài và lưới; chỉ nghề đánh cá (nói khái quát): sống bằng nghề chài lưới",
    example: "sống bằng nghề chài lưới",
  },
  {
    word: "chai lì",
    part_of_speech: "tính từ",
    meaning:
      "dày dạn và trơ lì do tiếp xúc nhiều, đến mức như không còn tình cảm, cảm xúc: vẻ mặt chai lì, vô cảm",
    example: "vẻ mặt chai lì, vô cảm",
  },
  {
    word: "chạm khắc",
    part_of_speech: "động từ",
    meaning: "chạm và khắc (nói khái quát): những hình chạm khắc tinh xảo",
    example: "những hình chạm khắc tinh xảo",
  },
  {
    word: "chai sạn",
    part_of_speech: "tính từ",
    meaning:
      "(da, thường ở bàn tay) chai và nổi thành cục nhỏ, cứng: bàn tay chai sạn",
    example: "bàn tay chai sạn",
  },
  {
    word: "chai sạn",
    part_of_speech: "tính từ",
    meaning: "dày dạn, quen chịu đựng gian khổ: một con người chai sạn",
    example: "một con người chai sạn",
  },
  {
    word: "chạm cốc",
    part_of_speech: "động từ",
    meaning:
      "nâng cốc rượu, bia lên và khẽ chạm vào cốc của nhau để chúc mừng: chạm cốc chúc mừng",
    example: "chạm cốc chúc mừng",
  },
  {
    word: "chàm",
    part_of_speech: "tính từ",
    meaning:
      "có màu lam sẫm (giữa màu tím và màu lam): áo chàm * tay đã nhúng chàm (b; dính líu vào việc xấu)",
    example: "áo chàm * tay đã nhúng chàm (b; dính líu vào việc xấu)",
  },
  {
    word: "chàm",
    part_of_speech: "danh từ",
    meaning:
      "bệnh ngoài da ở trẻ em, thường làm nổi từng mảng mẩn đỏ, ngứa và rỉ nước: mặt nổi chàm",
    example: "mặt nổi chàm",
  },
  {
    word: "chạm khảm",
    part_of_speech: "động từ",
    meaning: "chạm và khảm (nói khái quát): kĩ thuật chạm khảm của người xưa",
    example: "kĩ thuật chạm khảm của người xưa",
  },
  {
    word: "chạm nọc",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nói trúng vào điểm xấu, ý định xấu của người khác mà người đó muốn giữ kín: bị chạm nọc, lập tức nổi xung lên",
    example: "bị chạm nọc, lập tức nổi xung lên",
  },
  {
    word: "chạm mặt",
    part_of_speech: "động từ",
    meaning: "gặp nhau mặt đối mặt: tránh chạm mặt nhau",
    example: "tránh chạm mặt nhau",
  },
  {
    word: "chạm ngõ",
    part_of_speech: "động từ",
    meaning:
      "(gia đình người con trai) đến nhà người con gái để hai gia đình chính thức ước hẹn cho đôi trai gái đính hôn với nhau: lễ chạm ngõ",
    example: "lễ chạm ngõ",
  },
  {
    word: "chạm trán",
    part_of_speech: "động từ",
    meaning:
      "gặp nhau bất ngờ và phải đương đầu, đối phó với nhau: hai võ sĩ đã nhiều lần chạm trán với nhau",
    example: "hai võ sĩ đã nhiều lần chạm trán với nhau",
  },
  {
    word: "chạm nổi",
    part_of_speech: "động từ",
    meaning:
      "chạm theo lối tạo ra những hình nét trang trí nhô lên trên mặt nền: mặt gỗ chạm nổi",
    example: "mặt gỗ chạm nổi",
  },
  {
    word: "chạm súng",
    part_of_speech: "động từ",
    meaning:
      "(hai bên đối địch) gặp nhau bất ngờ và nổ súng bắn vào nhau: chạm súng với một toán phỉ",
    example: "chạm súng với một toán phỉ",
  },
  {
    word: "chạm trổ",
    part_of_speech: "động từ",
    meaning:
      "chạm để trang trí (nói khái quát): nghệ thuật chạm trổ * chiếc tủ chè được chạm trổ rất tinh vi",
    example: "nghệ thuật chạm trổ * chiếc tủ chè được chạm trổ rất tinh vi",
  },
  {
    word: "chan chát",
    part_of_speech: "tính từ",
    meaning:
      "như chát (nhưng ý liên tiếp và mức độ nhiều hơn): tiếng búa nện chan chát",
    example: "tiếng búa nện chan chát",
  },
  {
    word: "chan chát",
    part_of_speech: "tính từ",
    meaning:
      "(giọng nói) to, mạnh và xẵng, liên tiếp, gây cảm giác khó chịu cho người nghe: giọng chan chát * mắng chan chát vào mặt",
    example: "giọng chan chát * mắng chan chát vào mặt",
  },
  {
    word: "chan chát",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (văn chương đối nhau) chặt chẽ từng ý, từng từ một: hai câu thơ đối nhau chan chát",
    example: "hai câu thơ đối nhau chan chát",
  },
  {
    word: "chạn",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng thường bằng gỗ hoặc tre, gồm nhiều ngăn, các mặt thường có giát thưa hoặc lưới sắt, dùng để xếp bát đĩa hoặc cất thức ăn: chạn bát * chó chui gầm chạn (tng)",
    example: "chạn bát * chó chui gầm chạn (tng)",
  },
  {
    word: "chan chan",
    part_of_speech: "tính từ",
    meaning:
      '(cũ, văn chương) ở trạng thái tràn đầy, tràn trề, không biết bao nhiêu mà kể: một bầu nhiệt huyết chan chan  * "Còn nhiều ân ái chan chan, Hay gì vầy cánh hoa tàn mà chơi?" (TKiều)',
    example:
      'một bầu nhiệt huyết chan chan  * "Còn nhiều ân ái chan chan, Hay gì vầy cánh hoa tàn mà chơi?" (TKiều)',
  },
  {
    word: "chán chê",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (làm việc gì) rất nhiều, rất lâu, đến mức chán, không thiết nữa: ăn một bữa chán chê * chờ chán chê mà chẳng thấy ai đến",
    example: "ăn một bữa chán chê * chờ chán chê mà chẳng thấy ai đến",
  },
  {
    word: "chán",
    part_of_speech: "động từ",
    meaning:
      "ở trạng thái không còn thèm muốn, thích thú nữa, vì đã quá thoả mãn: chán thịt mỡ * ngủ lắm cũng chán mắt * cảnh đẹp nhìn không chán",
    example: "chán thịt mỡ * ngủ lắm cũng chán mắt * cảnh đẹp nhìn không chán",
  },
  {
    word: "chán",
    part_of_speech: "động từ",
    meaning:
      "ở trạng thái không những không thấy thích thú mà còn muốn tránh, vì đã phải tiếp xúc kéo dài với cái mình không ưa: chán đời * chán cuộc sống tầm thường",
    example: "chán đời * chán cuộc sống tầm thường",
  },
  {
    word: "chán",
    part_of_speech: "tính từ",
    meaning: "có tác dụng làm cho người ta chán: vở kịch xem quá chán",
    example: "vở kịch xem quá chán",
  },
  {
    word: "chán",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) đạt đến mức độ, số lượng mà người nói cho là nhiều: còn chán người giỏi * vẫn sớm chán * còn chán việc để làm",
    example: "còn chán người giỏi * vẫn sớm chán * còn chán việc để làm",
  },
  {
    word: "chan",
    part_of_speech: "động từ",
    meaning: "cho nhiều thức ăn nước vào bát cơm để ăn: cơm chan canh",
    example: "cơm chan canh",
  },
  {
    word: "chán đến mang tai",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) chán đến mức không thể nào tiếp nhận thêm được nữa: nói mãi một chuyện, nghe chán đến mang tai",
    example: "nói mãi một chuyện, nghe chán đến mang tai",
  },
  {
    word: "chán ghét",
    part_of_speech: "động từ",
    meaning:
      "chán và ghét đến mức không thể chịu đựng thêm nữa (thường là với chế độ hoặc tình trạng cuộc sống): chán ghét cuộc sống đơn điệu, tẻ nhạt",
    example: "chán ghét cuộc sống đơn điệu, tẻ nhạt",
  },
  {
    word: "chán mớ đời",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) chán đến mức không chịu nổi, muốn vứt bỏ hết (dùng để tỏ ý bực mình về một việc gì): tụi nó làm ăn chán mớ đời!",
    example: "tụi nó làm ăn chán mớ đời!",
  },
  {
    word: "chán chường",
    part_of_speech: "tính từ",
    meaning:
      'chán đến mức không còn thiết tha, thích thú gì nữa vì đã quá thất vọng: vẻ mặt chán chường * "Chấn vừa chán chường vừa lo sợ, lúng túng không biết làm sao thoát được cái cảnh này." (NgVBổng; 1)',
    example:
      'vẻ mặt chán chường * "Chấn vừa chán chường vừa lo sợ, lúng túng không biết làm sao thoát được cái cảnh này." (NgVBổng; 1)',
  },
  {
    word: "chan hoà",
    part_of_speech: "động từ",
    meaning: "tràn đầy và đều khắp mọi nơi: nước mắt chan hoà",
    example: "nước mắt chan hoà",
  },
  {
    word: "chan hoà",
    part_of_speech: "động từ",
    meaning:
      "(tình cảm, lối sống) hoà vào với nhau, không còn thấy có sự xa lạ, cách biệt: sống chan hoà với bà con lối xóm * tình cảm chan hoà",
    example: "sống chan hoà với bà con lối xóm * tình cảm chan hoà",
  },
  {
    word: "chán nản",
    part_of_speech: "",
    meaning:
      "cảm thấy rất chán và nản lòng, không còn muốn tiếp tục nữa, không còn thiết gì nữa: chán nản công việc * thấy khó nên sinh lòng chán nản",
    example: "chán nản công việc * thấy khó nên sinh lòng chán nản",
  },
  {
    word: "chán ngán",
    part_of_speech: "",
    meaning:
      "không còn thấy thích thú, thiết tha gì nữa, vì đã quá thất vọng: chán ngán cuộc sống bon chen",
    example: "chán ngán cuộc sống bon chen",
  },
  {
    word: "chán ngắt",
    part_of_speech: "tính từ",
    meaning:
      "hết sức buồn tẻ, nhạt nhẽo, không một chút gì hấp dẫn: câu chuyện chán ngắt",
    example: "câu chuyện chán ngắt",
  },
  {
    word: "chàng",
    part_of_speech: "danh từ",
    meaning:
      "người đàn ông trẻ tuổi có vẻ đáng mến, đáng yêu: mấy chàng trai trẻ * chàng hoạ sĩ vui tính * kén được chàng rể hiền",
    example:
      "mấy chàng trai trẻ * chàng hoạ sĩ vui tính * kén được chàng rể hiền",
  },
  {
    word: "chàng",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) từ phụ nữ dùng để gọi chồng hoặc người yêu còn trẻ, có ý thân thiết: "Chàng đi cho thiếp đi cùng, Đói no thiếp chịu lạnh lùng thiếp theo." (ca dao)',
    example:
      'Chàng đi cho thiếp đi cùng, Đói no thiếp chịu lạnh lùng thiếp theo." (ca dao)',
  },
  {
    word: "chán phè",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) chán đến mức không thể chịu nổi được nữa, vì chẳng thấy có gì hay cả: nói chuyện với họ chán phè",
    example: "nói chuyện với họ chán phè",
  },
  {
    word: "chán vạn",
    part_of_speech: "tính từ",
    meaning:
      '(khẩu ngữ) nhiều lắm, đến mức không kể hết được: "Có tiền chán vạn người hầu, Có bấc có dầu chán vạn người khêu." (ca dao)',
    example:
      'Có tiền chán vạn người hầu, Có bấc có dầu chán vạn người khêu." (ca dao)',
  },
  {
    word: "chán phèo",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ, hiếm) như chán phè: bộ phim xem chán phèo",
    example: "bộ phim xem chán phèo",
  },
  {
    word: "chang",
    part_of_speech: "tính từ",
    meaning:
      '(trời nắng) gay gắt, ánh nắng chiếu thẳng xuống khắp nơi: trời nắng chang chang * "Tiếng bà ru cháu xế trưa, Chang chang nắng hạ võng đưa rầu rầu." (HCầm; 1)',
    example:
      'trời nắng chang chang * "Tiếng bà ru cháu xế trưa, Chang chang nắng hạ võng đưa rầu rầu." (HCầm; 1)',
  },
  {
    word: "chang bang",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) (bụng) phình to: bụng chửa chang bang",
    example: "bụng chửa chang bang",
  },
  {
    word: "chang chang",
    part_of_speech: "tính từ",
    meaning:
      '(trời nắng) gay gắt, ánh nắng chiếu thẳng xuống khắp nơi: trời nắng chang chang * "Tiếng bà ru cháu xế trưa, Chang chang nắng hạ võng đưa rầu rầu." (HCầm; 1)',
    example:
      'trời nắng chang chang * "Tiếng bà ru cháu xế trưa, Chang chang nắng hạ võng đưa rầu rầu." (HCầm; 1)',
  },
  {
    word: "chàng hảng",
    part_of_speech: "",
    meaning: "(phương ngữ) giạng háng: đứng chàng hảng",
    example: "đứng chàng hảng",
  },
  {
    word: "chàng ràng",
    part_of_speech: "động từ",
    meaning:
      '(phương ngữ) làm chậm chạp để kéo dài thời gian: đã muộn lại còn chàng ràng * "Chợ chiều nhiều khế ế chanh, Nhiều con gái hoá nên anh chàng ràng." (ca dao)',
    example:
      'đã muộn lại còn chàng ràng * "Chợ chiều nhiều khế ế chanh, Nhiều con gái hoá nên anh chàng ràng." (ca dao)',
  },
  {
    word: "chàng ràng",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) quanh quẩn bên cạnh, không chịu rời: đứa bé chàng ràng bên cạnh mẹ",
    example: "đứa bé chàng ràng bên cạnh mẹ",
  },
  {
    word: "chành",
    part_of_speech: "động từ",
    meaning:
      "mở rộng ra về bề ngang (thường nói về môi, miệng): chành miệng * chành môi ra cười",
    example: "chành miệng * chành môi ra cười",
  },
  {
    word: "chàng màng",
    part_of_speech: "động từ",
    meaning:
      "lớt phớt bên ngoài, không thật sự đi sâu vào vấn đề: làm gì cũng chàng màng, không đến đầu đến đũa",
    example: "làm gì cũng chàng màng, không đến đầu đến đũa",
  },
  {
    word: "chàng màng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tán tỉnh, muốn có quan hệ yêu đương, thường là không chính đáng: chàng màng cô hàng xóm",
    example: "chàng màng cô hàng xóm",
  },
  {
    word: "chánh",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) người đứng đầu một đơn vị tổ chức, phân biệt với người phó: chánh thanh tra nhà nước * chánh văn phòng",
    example: "chánh thanh tra nhà nước * chánh văn phòng",
  },
  {
    word: "chánh",
    part_of_speech: "danh từ",
    meaning: "chánh tổng (gọi tắt): cụ chánh",
    example: "cụ chánh",
  },
  {
    word: "chánh",
    part_of_speech: "danh từ",
    meaning:
      '(Nam, thường cũ) biến thể của "chính" trong một số từ gốc Hán: chánh nghĩa, chánh trị, bưu chánh, hành chánh',
    example: "chánh nghĩa, chánh trị, bưu chánh, hành chánh",
  },
  {
    word: "chạng vạng",
    part_of_speech: "tính từ",
    meaning: "hơi mờ tối, khi mặt trời vừa mới lặn: trời chạng vạng tối",
    example: "trời chạng vạng tối",
  },
  {
    word: "chành bành",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) ở trạng thái banh rộng ra, trông không được đẹp mắt hoặc không được kín đáo: gói quần áo mở chành bành * ngồi chành bành hai chân trên ghế",
    example: "gói quần áo mở chành bành * ngồi chành bành hai chân trên ghế",
  },
  {
    word: "chạnh",
    part_of_speech: "động từ",
    meaning:
      'thoáng gợn lên trong lòng một tình cảm, ý nghĩ nào đó, thường là buồn: chạnh nhớ nhà * "Hiên tà gác bóng chênh chênh, Nỗi riêng, riêng chạnh tấc riêng một mình." (TKiều)',
    example:
      'chạnh nhớ nhà * "Hiên tà gác bóng chênh chênh, Nỗi riêng, riêng chạnh tấc riêng một mình." (TKiều)',
  },
  {
    word: "chánh án",
    part_of_speech: "danh từ",
    meaning:
      "người đứng đầu một toà án: chánh án toà án nhân dân tối cao * viên chánh án",
    example: "chánh án toà án nhân dân tối cao * viên chánh án",
  },
  {
    word: "chành chạnh",
    part_of_speech: "phụ từ",
    meaning:
      "(hiếm) (vuông vắn) đến mức có góc cạnh rõ ràng: mặt vuông chành chạnh",
    example: "mặt vuông chành chạnh",
  },
  {
    word: "chanh chua",
    part_of_speech: "tính từ",
    meaning: "chua ngoa, lắm điều (thường nói về phụ nữ): ăn nói chanh chua",
    example: "ăn nói chanh chua",
  },
  {
    word: "chanh cốm",
    part_of_speech: "danh từ",
    meaning: "chanh quả nhỏ, vỏ màu lục đậm.",
    example: "tuổi chanh cốm",
  },
  {
    word: "chành choẹ",
    part_of_speech: "động từ",
    meaning: "(trẻ con) cãi cọ, tranh giành nhau: bọn trẻ đang chành choẹ nhau",
    example: "bọn trẻ đang chành choẹ nhau",
  },
  {
    word: "chào",
    part_of_speech: "động từ",
    meaning:
      "tỏ thái độ kính trọng hoặc quan tâm đối với ai bằng lời nói hay cử chỉ, khi gặp nhau hoặc khi từ biệt: cất tiếng chào thầy * chào tạm biệt",
    example: "cất tiếng chào thầy * chào tạm biệt",
  },
  {
    word: "chào",
    part_of_speech: "động từ",
    meaning:
      "tỏ thái độ kính cẩn trước cái gì thiêng liêng, cao quý: đứng nghiêm làm lễ chào cờ",
    example: "đứng nghiêm làm lễ chào cờ",
  },
  {
    word: "chào",
    part_of_speech: "động từ",
    meaning:
      "mời ăn uống hoặc mua hàng: chào hàng * lời chào cao hơn mâm cỗ (tng)",
    example: "chào hàng * lời chào cao hơn mâm cỗ (tng)",
  },
  {
    word: "cháo",
    part_of_speech: "danh từ",
    meaning:
      "món ăn bằng gạo hoặc bột, nấu loãng và nhừ, có thể thêm thịt, cá, v.v.: nấu cháo * bát cháo hành",
    example: "nấu cháo * bát cháo hành",
  },
  {
    word: "chánh văn phòng",
    part_of_speech: "danh từ",
    meaning:
      "người đứng đầu văn phòng một cơ quan lớn: chánh văn phòng bộ ngoại giao",
    example: "chánh văn phòng bộ ngoại giao",
  },
  {
    word: "chao",
    part_of_speech: "động từ",
    meaning:
      "đưa qua đưa lại dưới nước, khi nghiêng bên này khi nghiêng bên kia, thường để rửa, để xúc: chao chân ở cầu ao * chao rổ xúc tôm",
    example: "chao chân ở cầu ao * chao rổ xúc tôm",
  },
  {
    word: "chao",
    part_of_speech: "động từ",
    meaning:
      "nghiêng nhanh từ bên này sang bên kia, và ngược lạI: chiếc thuyền chao qua chao lại",
    example: "chiếc thuyền chao qua chao lại",
  },
  {
    word: "chao",
    part_of_speech: "cảm từ",
    meaning:
      "tiếng thốt ra khi xúc động đột ngột: chao, trăng đêm nay mới đẹp làm sao!",
    example: "chao, trăng đêm nay mới đẹp làm sao!",
  },
  {
    word: "chão",
    part_of_speech: "danh từ",
    meaning: "thừng to và bền: đánh chão * dai như chão",
    example: "đánh chão * dai như chão",
  },
  {
    word: "chạnh lòng",
    part_of_speech: "động từ",
    meaning: "tự ái vì cảm thấy như bị thương hại: nói sơ ý làm bạn chạnh lòng",
    example: "nói sơ ý làm bạn chạnh lòng",
  },
  {
    word: "chao đảo",
    part_of_speech: "động từ",
    meaning:
      "nghiêng qua nghiêng lại, không giữ được thăng bằng: con tàu bị sóng đánh chao đảo",
    example: "con tàu bị sóng đánh chao đảo",
  },
  {
    word: "chao đảo",
    part_of_speech: "động từ",
    meaning:
      "không vững vàng, không kiên định về tinh thần, tư tưởng: bị chao đảo trước khó khăn",
    example: "bị chao đảo trước khó khăn",
  },
  {
    word: "chao động",
    part_of_speech: "động từ",
    meaning:
      "lắc lư, nghiêng qua nghiêng lại: mặt biển chao động * con thuyền tròng trành chao động",
    example: "mặt biển chao động * con thuyền tròng trành chao động",
  },
  {
    word: "chảo",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng thường được làm bằng nhôm, gang, miệng rộng, lòng nông, có hai quai hoặc cán để cầm, dùng để xào, rán thức ăn: chảo chống dính",
    example: "chảo chống dính",
  },
  {
    word: "chảo",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng trong đối thoại để chỉ con mình hoặc con người khác, còn nhỏ hoặc còn trẻ, coi như hàng cháu của mình hoặc của người cùng đối thoại với mình: anh chị được mấy cháu?",
    example: "anh chị được mấy cháu?",
  },
  {
    word: "chào bán",
    part_of_speech: "động từ",
    meaning:
      "đưa ra thông báo muốn bán một mặt hàng cụ thể nào đó, với đầy đủ thông tin cần thiết kèm theo: chào bán một mặt hàng mới",
    example: "chào bán một mặt hàng mới",
  },
  {
    word: "chào đón",
    part_of_speech: "động từ",
    meaning: "(trang trọng) hân hoan đón mừng: chào đón đoàn đại biểu",
    example: "chào đón đoàn đại biểu",
  },
  {
    word: "chao chát",
    part_of_speech: "tính từ",
    meaning: "(hiếm) tráo trở, không thật thà: con người chao chát",
    example: "con người chao chát",
  },
  {
    word: "chao chát",
    part_of_speech: "tính từ",
    meaning:
      "(lối nói năng) lớn tiếng và lắm lời một cách quá quắt (thường nói về phụ nữ): chao chát phủ đầu * giọng chao chát như cãi nhau",
    example: "chao chát phủ đầu * giọng chao chát như cãi nhau",
  },
  {
    word: "chào giá",
    part_of_speech: "động từ",
    meaning:
      "(bên bán hoặc bên mua) cho biết rõ giá cả muốn bán hoặc mua một mặt hàng nhất định, kèm theo những yêu cầu như tên hàng, tính năng, phẩm chất, quy cách, số lượng, điều kiện giao hàng, v.v.: bảng chào giá các mặt hàng điện tử",
    example: "bảng chào giá các mặt hàng điện tử",
  },
  {
    word: "chao đèn",
    part_of_speech: "động từ",
    meaning:
      "đưa qua đưa lại dưới nước, khi nghiêng bên này khi nghiêng bên kia, thường để rửa, để xúc: chao chân ở cầu ao * chao rổ xúc tôm",
    example: "chao chân ở cầu ao * chao rổ xúc tôm",
  },
  {
    word: "chao đèn",
    part_of_speech: "động từ",
    meaning:
      "nghiêng nhanh từ bên này sang bên kia, và ngược lạI: chiếc thuyền chao qua chao lại",
    example: "chiếc thuyền chao qua chao lại",
  },
  {
    word: "chao đèn",
    part_of_speech: "cảm từ",
    meaning:
      "tiếng thốt ra khi xúc động đột ngột: chao, trăng đêm nay mới đẹp làm sao!",
    example: "chao, trăng đêm nay mới đẹp làm sao!",
  },
  {
    word: "chào đời",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) được sinh ra, ra đời: một bé trai vừa mới chào đời * cất tiếng khóc chào đời",
    example: "một bé trai vừa mới chào đời * cất tiếng khóc chào đời",
  },
  {
    word: "chào hàng",
    part_of_speech: "động từ",
    meaning: "mời khách mua hàng: tiếng chào hàng đon đả",
    example: "tiếng chào hàng đon đả",
  },
  {
    word: "cháo lão",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) cháo cho người ốm (nói khái quát): hằng ngày phải lo thuốc men, cháo lão cho ông cụ",
    example: "hằng ngày phải lo thuốc men, cháo lão cho ông cụ",
  },
  {
    word: "cháo lòng",
    part_of_speech: "danh từ",
    meaning:
      "cháo nấu bằng gạo với nước luộc lòng lợn, có cho thêm lòng và tiết lợn, ăn kèm gia vị.",
    example: "chiếc áo màu cháo lòng",
  },
  {
    word: "chào hỏi",
    part_of_speech: "động từ",
    meaning:
      "chào và hỏi han khi gặp nhau (nói khái quát): không chào hỏi ai * câu chào hỏi xã giao",
    example: "không chào hỏi ai * câu chào hỏi xã giao",
  },
  {
    word: "chào mừng",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) vui mừng chào đón: nhiệt liệt chào mừng các vị khách quý * thi đua lập thành tích chào mừng ngày quốc khánh",
    example:
      "nhiệt liệt chào mừng các vị khách quý * thi đua lập thành tích chào mừng ngày quốc khánh",
  },
  {
    word: "chào rơi",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) chào mời lấy lệ, không thật bụng: miệng chào rơi, bụng khấn trời đừng ăn (tng)",
    example: "miệng chào rơi, bụng khấn trời đừng ăn (tng)",
  },
  {
    word: "chao ôi",
    part_of_speech: "cảm từ",
    meaning:
      "tiếng thốt ra khi xúc động mạnh, thường để than thở: chao ôi, sao mà buồn!",
    example: "chao ôi, sao mà buồn!",
  },
  {
    word: "chào mời",
    part_of_speech: "động từ",
    meaning: "như mời chào: chào mời khách mua hàng",
    example: "chào mời khách mua hàng",
  },
  {
    word: "chào thua",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đành phải chịu thua, xin thua (thường hàm ý hài hước): việc đó thì tôi xin chào thua!",
    example: "việc đó thì tôi xin chào thua!",
  },
  {
    word: "chạp mả",
    part_of_speech: "động từ",
    meaning:
      "thăm và sửa sang lại mồ mả tổ tiên trong tháng chạp, theo tục lệ cổ truyền: đi chạp mả * ngày chạp mả",
    example: "đi chạp mả * ngày chạp mả",
  },
  {
    word: "chát chúa",
    part_of_speech: "tính từ",
    meaning:
      "(âm thanh) to và vang dội, nghe rất chói tai: tiếng búa nện chát chúa",
    example: "tiếng búa nện chát chúa",
  },
  {
    word: "chat",
    part_of_speech: "động từ",
    meaning:
      "trò chuyện, trao đổi trực tiếp với nhau thông qua mạng Internet bằng cách gõ nội dung từ bàn phím hoặc nói qua micro (voice chat): quán chat * lần tìm địa chỉ để chat",
    example: "quán chat * lần tìm địa chỉ để chat",
  },
  {
    word: "chat",
    part_of_speech: "tính từ",
    meaning:
      'có vị như vị của chuối xanh: chuối còn xanh nên chát * "Con cò đậu cọc bờ ao, Ăn sung sung chát, ăn đào đào chua." (ca dao)',
    example:
      'chuối còn xanh nên chát * "Con cò đậu cọc bờ ao, Ăn sung sung chát, ăn đào đào chua." (ca dao)',
  },
  {
    word: "chat",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng một vật cứng đập mạnh vào một vật cứng khác, nghe chói tai: đập đánh chát một cái",
    example: "đập đánh chát một cái",
  },
  {
    word: "chat",
    part_of_speech: "tính từ",
    meaning: "từ mô phỏng tiếng trống chầu trong hát ả đào: tom tom tom chát",
    example: "tom tom tom chát",
  },
  {
    word: "chat",
    part_of_speech: "tính từ",
    meaning:
      "(âm thanh) to và vang dội mạnh, gây cảm giác rất khó chịu: tiếng búa đập chát tai * nghe chát cả óc",
    example: "tiếng búa đập chát tai * nghe chát cả óc",
  },
  {
    word: "chát xít",
    part_of_speech: "tính từ",
    meaning:
      "chát đến mức lưỡi như bị se lại, xít lại, không còn nuốt được: chuối xanh ăn chát xít",
    example: "chuối xanh ăn chát xít",
  },
  {
    word: "cháu",
    part_of_speech: "danh từ",
    meaning:
      "người thuộc một thế hệ sau nhưng không phải là con, trong quan hệ với người thuộc thế hệ trước (có thể dùng để xưng gọi): hai ông cháu * đứa cháu ngoại * cháu dâu",
    example: "hai ông cháu * đứa cháu ngoại * cháu dâu",
  },
  {
    word: "cháu",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng trong đối thoại để gọi thân mật người coi như hàng cháu của mình, hoặc để tự xưng với người mình kính trọng, coi như bậc ông bà, chú bác của mình: cháu xin ông tha lỗi * cháu chào chú bộ đội * mẹ có nhà không hả cháu?",
    example:
      "cháu xin ông tha lỗi * cháu chào chú bộ đội * mẹ có nhà không hả cháu?",
  },
  {
    word: "chạt",
    part_of_speech: "danh từ",
    meaning:
      "nước biển lọc qua cát, phơi để lấy muối theo lối sản xuất muối thủ công: phơi chạt",
    example: "phơi chạt",
  },
  {
    word: "chạt",
    part_of_speech: "danh từ",
    meaning: "khoảng đất đắp để chứa và phơi nước chạt: đắp lại bờ chạt",
    example: "đắp lại bờ chạt",
  },
  {
    word: "chạt",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) tạt mạnh: đất đá văng chạt sang hai bên",
    example: "đất đá văng chạt sang hai bên",
  },
  {
    word: "cháu đích tôn",
    part_of_speech: "danh từ",
    meaning: "cháu trai trưởng bên nội: ông bà đã có cháu đích tôn",
    example: "ông bà đã có cháu đích tôn",
  },
  {
    word: "chát lè",
    part_of_speech: "tính từ",
    meaning:
      'chát lắm, như không thể nuốt nổi: "Thà rằng ăn nửa quả hồng, Còn hơn ăn cả chùm sung chát lè." (ca dao)',
    example:
      'Thà rằng ăn nửa quả hồng, Còn hơn ăn cả chùm sung chát lè." (ca dao)',
  },
  {
    word: "cháy",
    part_of_speech: "động từ",
    meaning:
      "chịu tác động của lửa và tự tiêu huỷ: cháy nhà * lò than âm ỉ cháy * cháy thành than",
    example: "cháy nhà * lò than âm ỉ cháy * cháy thành than",
  },
  {
    word: "cháy",
    part_of_speech: "động từ",
    meaning: "(lửa) bốc cao thành ngọn: lửa cháy rừng rực một góc trời",
    example: "lửa cháy rừng rực một góc trời",
  },
  {
    word: "cháy",
    part_of_speech: "động từ",
    meaning:
      "có cảm giác như nóng ran lên do bị kích thích mạnh: lo cháy ruột cháy gan * khát cháy họng",
    example: "lo cháy ruột cháy gan * khát cháy họng",
  },
  {
    word: "cháy",
    part_of_speech: "động từ",
    meaning:
      "bị đen sạm đi do chịu tác động mạnh của sức nóng hoặc độ lạnh: da cháy nắng * mạ bị cháy lá",
    example: "da cháy nắng * mạ bị cháy lá",
  },
  {
    word: "cháy",
    part_of_speech: "động từ",
    meaning:
      "bị đứt mạch điện do cường độ dòng điện lớn quá giới hạn cho phép: bóng đèn bị cháy * cháy cầu chì",
    example: "bóng đèn bị cháy * cháy cầu chì",
  },
  {
    word: "cháy",
    part_of_speech: "động từ",
    meaning:
      "toả ra nhiệt và ánh sáng khi tham gia một phản ứng hoá học: phốt pho là chất có thể tự cháy trong không khí",
    example: "phốt pho là chất có thể tự cháy trong không khí",
  },
  {
    word: "cháy",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) hết sạch, không còn để bán, để cung cấp trong khi nhu cầu cần mua, cần sử dụng còn nhiều: cháy phòng khách sạn * cháy vé tàu trong dịp Tết",
    example: "cháy phòng khách sạn * cháy vé tàu trong dịp Tết",
  },
  {
    word: "cháy",
    part_of_speech: "danh từ",
    meaning:
      "lớp cơm, cháo, v.v. bị sém vàng do đun quá lửa và đóng thành mảng ở sát đáy nồi: hết cơm, chỉ còn cháy * ăn một miếng cháy",
    example: "hết cơm, chỉ còn cháy * ăn một miếng cháy",
  },
  {
    word: "chảy",
    part_of_speech: "động từ",
    meaning:
      "(nước, chất lỏng) di chuyển thành dòng: dòng sông chảy xiết * nước chảy đá mòn (tng)",
    example: "dòng sông chảy xiết * nước chảy đá mòn (tng)",
  },
  {
    word: "chảy",
    part_of_speech: "động từ",
    meaning:
      "thoát ra ngoài thành giọt, thành dòng: nóng chảy mồ hôi * chảy nước mắt * vỡ đầu chảy máu",
    example: "nóng chảy mồ hôi * chảy nước mắt * vỡ đầu chảy máu",
  },
  {
    word: "chảy",
    part_of_speech: "động từ",
    meaning:
      "chuyển từ thể rắn sang thể lỏng, hoặc từ trạng thái đặc sang trạng thái nhão, do tác động của nhiệt, của độ ẩm: nước đá tan chảy * nung chảy đồng để đúc tượng",
    example: "nước đá tan chảy * nung chảy đồng để đúc tượng",
  },
  {
    word: "chảy",
    part_of_speech: "động từ",
    meaning:
      "trở thành mềm nhão và dãn dài ra: lụa chảy * chiếc áo chảy * hai má chảy xệ",
    example: "lụa chảy * chiếc áo chảy * hai má chảy xệ",
  },
  {
    word: "chảy",
    part_of_speech: "tính từ",
    meaning:
      "(vật đựng) bị thủng, bị rò rỉ, khiến cho chất lỏng chứa ở trong có thể thoát ra ngoài: nồi chảy * thùng chảy không đựng được nước",
    example: "nồi chảy * thùng chảy không đựng được nước",
  },
  {
    word: "chau",
    part_of_speech: "động từ",
    meaning:
      'nhíu khẽ lông mày lại, thường vì do nghĩ ngợi, buồn phiền hay bực bội: chau mày tỏ vẻ khó chịu * "Khi tựa gối, khi cúi đầu, Khi vò chín khúc, khi chau đôi mày." (TKiều)',
    example:
      'chau mày tỏ vẻ khó chịu * "Khi tựa gối, khi cúi đầu, Khi vò chín khúc, khi chau đôi mày." (TKiều)',
  },
  {
    word: "chạy án",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) lo lót, chạy chọt hòng tìm cách bóp méo, xoay chuyển vụ án theo hướng có lợi cho bị can (hoặc bị cáo): phát hiện một đường dây chạy án",
    example: "phát hiện một đường dây chạy án",
  },
  {
    word: "chay",
    part_of_speech: "danh từ",
    meaning:
      "cây to cùng họ với mít, quả có múi, ruột màu đỏ, vị chua, ăn được, vỏ hoặc rễ dùng để ăn trầu hoặc để nhuộm",
    example: "lập đàn làm chay",
  },
  {
    word: "chay",
    part_of_speech: "tính từ",
    meaning:
      "không ăn thịt cá, hoặc không ăn tất cả các thức ăn nguồn gốc động vật, nói chung: cơm chay * ăn mặn nói ngay còn hơn ăn chay nói dối (tng)",
    example: "cơm chay * ăn mặn nói ngay còn hơn ăn chay nói dối (tng)",
  },
  {
    word: "chay",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) (bánh) không có nhân, không có chất mặn, chất thịt như thường có: bánh dẻo chay * bánh bao chay",
    example: "bánh dẻo chay * bánh bao chay",
  },
  {
    word: "chay",
    part_of_speech: "tính từ",
    meaning:
      "không có cái gì bổ trợ thêm vào để cho tốt hơn: cấy chay (= không bón phân trước) * hát chay (= không có nhạc đệm)",
    example: "cấy chay (= không bón phân trước) * hát chay",
  },
  {
    word: "chạy ăn",
    part_of_speech: "động từ",
    meaning:
      'lo kiếm cái ăn cho gia đình một cách chật vật: "Van nợ lắm khi tràn nước mắt, Chạy ăn từng bữa toát mồ hôi." (TrTXương; 6)',
    example:
      'Van nợ lắm khi tràn nước mắt, Chạy ăn từng bữa toát mồ hôi." (TrTXương; 6)',
  },
  {
    word: "chạy chọt",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) cầu cạnh, lo lót để nhờ cậy hoặc lo liệu việc gì: chạy chọt khắp nơi để xin việc",
    example: "chạy chọt khắp nơi để xin việc",
  },
  {
    word: "cháy bỏng",
    part_of_speech: "động từ",
    meaning:
      "nóng như thiêu như đốt, như bỏng cả da thịt: trưa hè cháy bỏng * nụ hôn cháy bỏng (b)",
    example: "trưa hè cháy bỏng * nụ hôn cháy bỏng (b)",
  },
  {
    word: "chạy bàn",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) phục vụ bàn ăn trong nhà hàng, khách sạn: nhân viên chạy bàn của khách sạn",
    example: "nhân viên chạy bàn của khách sạn",
  },
  {
    word: "chạy",
    part_of_speech: "động từ",
    meaning:
      "(người, động vật) di chuyển thân thể bằng những bước nhanh, mạnh và liên tiếp: chạy một mạch về nhà * đi nhanh như chạy",
    example: "chạy một mạch về nhà * đi nhanh như chạy",
  },
  {
    word: "chạy",
    part_of_speech: "động từ",
    meaning:
      "(người) di chuyển nhanh đến nơi khác, không kể bằng cách gì: chạy xe lên thành phố (đi bằng xe) * chạy vội ra chợ mua ít thức ăn",
    example:
      "chạy xe lên thành phố (đi bằng xe) * chạy vội ra chợ mua ít thức ăn",
  },
  {
    word: "chạy",
    part_of_speech: "động từ",
    meaning:
      "(phương tiện giao thông) di chuyển nhanh đến nơi khác trên một bề mặt: tàu chạy trên đường sắt * thuyền chạy dưới sông",
    example: "tàu chạy trên đường sắt * thuyền chạy dưới sông",
  },
  {
    word: "chạy",
    part_of_speech: "động từ",
    meaning:
      "(máy móc hoặc đồ dùng có máy móc) hoạt động, làm việc: máy chạy thông ca * đồng hồ chạy chậm * đài chạy pin (hoạt động bằng pin)",
    example:
      "máy chạy thông ca * đồng hồ chạy chậm * đài chạy pin (hoạt động bằng pin)",
  },
  {
    word: "chạy",
    part_of_speech: "động từ",
    meaning:
      "điều khiển cho phương tiện, máy móc di chuyển hoặc hoạt động: làm nghề chạy xe ôm * chạy máy phát điện",
    example: "làm nghề chạy xe ôm * chạy máy phát điện",
  },
  {
    word: "chạy",
    part_of_speech: "động từ",
    meaning:
      "điều khiển cho tia X, tia phóng xạ hoặc các thiết bị chuyên dụng tác động đến bộ phận cơ thể để chữa bệnh: chạy tia tử ngoại",
    example: "chạy tia tử ngoại",
  },
  {
    word: "chạy",
    part_of_speech: "động từ",
    meaning:
      "mang và chuyển đi nhanh (nói về công văn, thư từ): liên lạc chạy công văn hoả tốc * chạy thư",
    example: "liên lạc chạy công văn hoả tốc * chạy thư",
  },
  {
    word: "chạy",
    part_of_speech: "động từ",
    meaning:
      "nhanh chóng tránh trước đi điều gì không hay, thường bằng cách chạy hoặc chuyển đi nơi khác: chạy lụt * chạy con mã (trong cờ tướng) * mưa ập xuống, không kịp chạy các thứ phơi ở sân",
    example:
      "chạy lụt * chạy con mã (trong cờ tướng) * mưa ập xuống, không kịp chạy các thứ phơi ở sân",
  },
  {
    word: "chạy",
    part_of_speech: "động từ",
    meaning:
      "chịu bỏ dở, không theo đuổi đến cùng: các thầy lang đều chạy, vì bệnh đã quá nặng",
    example: "các thầy lang đều chạy, vì bệnh đã quá nặng",
  },
  {
    word: "chạy",
    part_of_speech: "động từ",
    meaning:
      "khẩn trương tìm kiếm, lo liệu để mau chóng có được, đạt được cái đang rất cần, rất muốn: chạy thầy chạy thuốc * chạy đủ tiền học phí cho con * chạy theo thành tích",
    example:
      "chạy thầy chạy thuốc * chạy đủ tiền học phí cho con * chạy theo thành tích",
  },
  {
    word: "chạy",
    part_of_speech: "động từ",
    meaning:
      "nằm trải ra thành dải dài và hẹp: con đường chạy qua làng * dãy núi chạy dọc theo bờ biển * hàng tít lớn chạy suốt trang báo",
    example:
      "con đường chạy qua làng * dãy núi chạy dọc theo bờ biển * hàng tít lớn chạy suốt trang báo",
  },
  {
    word: "chạy",
    part_of_speech: "động từ",
    meaning:
      "làm nổi lên thành đường dài để trang trí: chạy một đường viền * mép khăn trải bàn được chạy chỉ kim tuyến",
    example: "chạy một đường viền * mép khăn trải bàn được chạy chỉ kim tuyến",
  },
  {
    word: "chạy",
    part_of_speech: "tính từ",
    meaning:
      "(việc diễn ra) thuận lợi, trôi chảy, không bị ngừng trệ: công việc tháng này có vẻ chạy hơn tháng trước",
    example: "công việc tháng này có vẻ chạy hơn tháng trước",
  },
  {
    word: "chạy chợ",
    part_of_speech: "động từ",
    meaning:
      "buôn bán nhỏ ở chợ để kiếm sống: chạy chợ bán rau * chạy chợ cả ngày chỉ được mấy chục bạc",
    example: "chạy chợ bán rau * chạy chợ cả ngày chỉ được mấy chục bạc",
  },
  {
    word: "cháy chợ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) (chợ) hết sạch loại hàng nào đó, không còn để bán ra trong khi còn nhiều người muốn mua: ba mươi Tết, hoa đào cháy chợ",
    example: "ba mươi Tết, hoa đào cháy chợ",
  },
  {
    word: "chạy chữa",
    part_of_speech: "động từ",
    meaning:
      "tìm thầy tìm thuốc để chữa cho người bệnh: chạy chữa thuốc thang * tìm thầy chạy chữa",
    example: "chạy chữa thuốc thang * tìm thầy chạy chữa",
  },
  {
    word: "chày cối",
    part_of_speech: "",
    meaning:
      "(thông tục) ví sự bướng bỉnh, liều lĩnh, chẳng kể gì đến lí lẽ, phải tráI: cứ chày cối mãi không chịu trả nợ * cãi chày cãi cối",
    example: "cứ chày cối mãi không chịu trả nợ * cãi chày cãi cối",
  },
  {
    word: "chạy đằng trời",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) chạy đâu cho thoát: nó mà biết thì có mà chạy đằng trời!",
    example: "nó mà biết thì có mà chạy đằng trời!",
  },
  {
    word: "chạy điện",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) cho tia X, tia phóng xạ tác động đến bộ phận cơ thể để chữa bệnh: kĩ thuật chạy điện * điều trị ung thư bằng phương pháp chạy điện",
    example: "kĩ thuật chạy điện * điều trị ung thư bằng phương pháp chạy điện",
  },
  {
    word: "chạy đôn chạy đáo",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) chạy vạy vất vả, hết chỗ này đến chỗ khác vì một việc gì đó: chạy đôn chạy đáo tìm việc làm",
    example: "chạy đôn chạy đáo tìm việc làm",
  },
  {
    word: "chạy hậu",
    part_of_speech: "động từ",
    meaning: "(cũ, hiếm) biến chứng sau khi hết sởi hoặc đậu mùa: sởi chạy hậu",
    example: "sởi chạy hậu",
  },
  {
    word: "chạy đua",
    part_of_speech: "động từ",
    meaning:
      "cố vượt qua nhau để giành phần thắng, phần hơn trong công việc gì: chạy đua giành quyền đăng cai thế vận hội * chạy đua với thời gian",
    example:
      "chạy đua giành quyền đăng cai thế vận hội * chạy đua với thời gian",
  },
  {
    word: "chạy hiệu",
    part_of_speech: "động từ",
    meaning:
      "đóng vai lính cầm cờ chạy đi chạy lại trên sân khấu tuồng cổ: làm lính chạy hiệu rạp hát!",
    example: "làm lính chạy hiệu rạp hát!",
  },
  {
    word: "chạy mánh",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) làm môi giới giữa bên mua và bên bán để kiếm lợi: làm chân chạy mánh",
    example: "làm chân chạy mánh",
  },
  {
    word: "chạy làng",
    part_of_speech: "động từ",
    meaning:
      "bỏ cuộc, không chịu trả tiền, hoặc nhằm chối bỏ trách nhiệm về việc gì: thua bạc chạy làng",
    example: "thua bạc chạy làng",
  },
  {
    word: "chảy rữa",
    part_of_speech: "động từ",
    meaning: "trở nên ướt, nhão do hút hơi nước: muối chảy rữa * kẹo chảy rữa",
    example: "muối chảy rữa * kẹo chảy rữa",
  },
  {
    word: "chạy long tóc gáy",
    part_of_speech: "",
    meaning:
      "(thông tục) chạy vạy vất vả ngược xuôi để lo liệu việc cần kíp: phải chạy long tóc gáy mới lo đủ số vật liệu ấy",
    example: "phải chạy long tóc gáy mới lo đủ số vật liệu ấy",
  },
  {
    word: "chạy ngược chạy xuôi",
    part_of_speech: "",
    meaning:
      "như chạy đôn chạy đáo: chạy ngược chạy xuôi mà chẳng được việc gì",
    example: "chạy ngược chạy xuôi mà chẳng được việc gì",
  },
  {
    word: "chảy máu",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) ví tình trạng mất hoặc bị thất thoát những thứ có giá trị do không quản lí được hoặc không biết cách khai thác, sử dụng: tình trạng chảy máu chất xám * nạn chảy máu cổ vật * chảy máu ngoại tệ",
    example:
      "tình trạng chảy máu chất xám * nạn chảy máu cổ vật * chảy máu ngoại tệ",
  },
  {
    word: "chạy sô",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tham gia nhiều sô diễn trong cùng một buổi ở những địa điểm khác nhau (hàm ý chê): hát chạy sô",
    example: "hát chạy sô",
  },
  {
    word: "chạy tàu",
    part_of_speech: "động từ",
    meaning:
      "điều khiển cho tàu chạy trên một tuyến đường: rút ngắn thời gian chạy tàu",
    example: "rút ngắn thời gian chạy tàu",
  },
  {
    word: "chạy sấp chạy ngửa",
    part_of_speech: "",
    meaning:
      'chạy hấp tấp, vội vã, hòng cho kịp hoặc để thoát khỏi cái gì đó: "Vì sợ quân địch đuổi kịp, ai nấy chạy sấp chạy ngửa, người nọ níu áo người kia, chẳng còn ra thể thống gì cả." (HLNTC)',
    example:
      'Vì sợ quân địch đuổi kịp, ai nấy chạy sấp chạy ngửa, người nọ níu áo người kia, chẳng còn ra thể thống gì cả." (HLNTC)',
  },
  {
    word: "chạy vạy",
    part_of_speech: "động từ",
    meaning:
      "xoay xở một cách vất vả để lo liệu việc gì: một mình chạy vạy nuôi con ăn học",
    example: "một mình chạy vạy nuôi con ăn học",
  },
  {
    word: "cháy túi",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) hết sạch tiền, không còn đồng nào trong túi: thua bạc cháy túi",
    example: "thua bạc cháy túi",
  },
  {
    word: "chạy tội",
    part_of_speech: "động từ",
    meaning:
      "lo lót, tìm mọi cách hòng giảm tội hoặc thoát tội: hối lộ để chạy tội * làm hồ sơ giả để hòng chạy tội",
    example: "hối lộ để chạy tội * làm hồ sơ giả để hòng chạy tội",
  },
  {
    word: "chắc",
    part_of_speech: "tính từ",
    meaning:
      "có khả năng chịu đựng tác dụng của lực cơ học mà vẫn giữ nguyên trạng thái toàn khối hoặc giữ nguyên vị trí gắn chặt vào vật khác, không bị tách rời: đinh đóng rất chắc * thang dựa chắc vào tường",
    example: "đinh đóng rất chắc * thang dựa chắc vào tường",
  },
  {
    word: "chắc",
    part_of_speech: "tính từ",
    meaning:
      "có sự phát triển đầy đủ, tạo nên một khối gắn chặt vào vật khác, không bị tách rời: lúa chắc hạt, cứng cây * bắp thịt chắc * cua chắc thịt",
    example: "lúa chắc hạt, cứng cây * bắp thịt chắc * cua chắc thịt",
  },
  {
    word: "chắc",
    part_of_speech: "tính từ",
    meaning:
      "hoàn toàn đúng như thế, khó có thể sai hay thay đổi được: hứa chắc sẽ đến * chưa chắc đã đúng * có chắc là như thế không?",
    example: "hứa chắc sẽ đến * chưa chắc đã đúng * có chắc là như thế không?",
  },
  {
    word: "chắc",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều khả năng, rất có thể: chắc anh ta không đến * việc này chắc là khó",
    example: "chắc anh ta không đến * việc này chắc là khó",
  },
  {
    word: "chắc",
    part_of_speech: "động từ",
    meaning:
      'nghĩ là sẽ đúng như thế: cứ chắc là được, ai ngờ lại thua * "Đến bây giờ mới thấy đây, Mà lòng đã chắc những ngày một hai!" (TKiều)',
    example:
      'cứ chắc là được, ai ngờ lại thua * "Đến bây giờ mới thấy đây, Mà lòng đã chắc những ngày một hai!" (TKiều)',
  },
  {
    word: "chắc",
    part_of_speech: "trợ từ",
    meaning:
      "(khẩu ngữ) từ biểu thị ý muốn hỏi về điều mà thật ra mình đã khẳng định, nhưng tỏ vẻ nửa tin nửa ngờ hoặc có phần ngạc nhiên: anh quen người ấy chắc? * mình tôi làm được chắc? * cậu tưởng làm như thế là tôi vui chắc?",
    example:
      "anh quen người ấy chắc? * mình tôi làm được chắc? * cậu tưởng làm như thế là tôi vui chắc?",
  },
  {
    word: "chắc ăn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) rất chắc chắn, hoàn toàn đảm bảo được kết quả: bắn phát nào chắc ăn phát đó * có chắc ăn mới làm",
    example: "bắn phát nào chắc ăn phát đó * có chắc ăn mới làm",
  },
  {
    word: "chắc hẳn",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị ý tin chắc là như thế: chuyện ấy, chắc hẳn anh đã biết? * chắc hẳn mọi người đang chờ",
    example: "chuyện ấy, chắc hẳn anh đã biết? * chắc hẳn mọi người đang chờ",
  },
  {
    word: "chắc chắn",
    part_of_speech: "tính từ",
    meaning:
      "rất vững chắc, rất bảo đảm, khó có thể phá huỷ, lay chuyển hoặc làm cho thay đổi được: cất giấu tại một nơi chắc chắn * nhà xây rất chắc chắn",
    example: "cất giấu tại một nơi chắc chắn * nhà xây rất chắc chắn",
  },
  {
    word: "chắc chắn",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất khẳng định dứt khoát, có thể tin chắc là đúng như thế: hứa chắc chắn * chưa có gì chắc chắn cả",
    example: "hứa chắc chắn * chưa có gì chắc chắn cả",
  },
  {
    word: "chắc chắn",
    part_of_speech: "tính từ",
    meaning:
      "có thể khẳng định dứt khoát là như thế: anh ta chắc chắn biết việc ấy * chắc chắn cuối tuần này sẽ xong",
    example: "anh ta chắc chắn biết việc ấy * chắc chắn cuối tuần này sẽ xong",
  },
  {
    word: "chắc chắn",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) tin một cách quả quyết là đúng như thế: tôi chắc chắn anh ta không có ở nhà * chắc chắn là ông đã nhìn lầm!",
    example:
      "tôi chắc chắn anh ta không có ở nhà * chắc chắn là ông đã nhìn lầm!",
  },
  {
    word: "chắc chân",
    part_of_speech: "tính từ",
    meaning:
      "có được sự đảm bảo chắc chắn về địa vị hoặc hoàn cảnh sinh sống: tìm được một chỗ làm chắc chân",
    example: "tìm được một chỗ làm chắc chân",
  },
  {
    word: "chắc như đinh đóng cột",
    part_of_speech: "",
    meaning:
      "(nói, hứa) rất chắc chắn, như không có gì làm thay đổi được: nói chắc như đinh đóng cột",
    example: "nói chắc như đinh đóng cột",
  },
  {
    word: "chắc lép",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có tính so đo, tính toán để cầm chắc phần hơn, không bị thiệt trong quan hệ với người khác: tính hay chắc lép",
    example: "tính hay chắc lép",
  },
  {
    word: "chắc dạ",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) no bụng, no được lâu: ăn cơm cho chắc dạ",
    example: "ăn cơm cho chắc dạ",
  },
  {
    word: "chắc dạ",
    part_of_speech: "tính từ",
    meaning:
      "vững tâm, không còn phải lo lắng: đã chuẩn bị kĩ càng trước khi thi nên cũng thấy chắc dạ",
    example: "đã chuẩn bị kĩ càng trước khi thi nên cũng thấy chắc dạ",
  },
  {
    word: "chắc mẩm",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tin chắc và yên trí là sẽ đúng như vậy: cứ chắc mẩm là đúng, ai ngờ lại sai",
    example: "cứ chắc mẩm là đúng, ai ngờ lại sai",
  },
  {
    word: "chắc như cua gạch",
    part_of_speech: "",
    meaning: "(cơ bắp) rất chắc và khoẻ mạnh: người chắc như cua gạch",
    example: "người chắc như cua gạch",
  },
  {
    word: "chắc như cua gạch",
    part_of_speech: "",
    meaning: "như chắc như đinh đóng cột: nói chắc như cua gạch",
    example: "nói chắc như cua gạch",
  },
  {
    word: "chằm",
    part_of_speech: "danh từ",
    meaning:
      "vùng đất thấp và rộng bỏ hoang, thường bị ngập nước: chằm Dạ Trạch * chân ruộng chằm",
    example: "chằm Dạ Trạch * chân ruộng chằm",
  },
  {
    word: "chằm",
    part_of_speech: "động từ",
    meaning:
      "khâu từng mũi qua nhiều lớp để làm cho chắc: chằm nón * quần chằm áo vá",
    example: "chằm nón * quần chằm áo vá",
  },
  {
    word: "chắc tay",
    part_of_speech: "tính từ",
    meaning:
      "vững vàng về tay nghề, về công việc: lái xe chưa thật chắc tay * cày đã chắc tay",
    example: "lái xe chưa thật chắc tay * cày đã chắc tay",
  },
  {
    word: "chắc nình nịch",
    part_of_speech: "tính từ",
    meaning: "như chắc nịch (nhưng ý nhấn mạnh hơn): thân hình chắc nình nịch",
    example: "thân hình chắc nình nịch",
  },
  {
    word: "chăm",
    part_of_speech: "tính từ",
    meaning:
      "có sự chú ý thường xuyên làm công việc gì đó (thường là việc có ích) một cách đều đặn: học rất chăm * chăm làm",
    example: "học rất chăm * chăm làm",
  },
  {
    word: "chăm",
    part_of_speech: "động từ",
    meaning:
      "trông nom, săn sóc cẩn thận và thường xuyên: chăm con * chăm người ốm",
    example: "chăm con * chăm người ốm",
  },
  {
    word: "chắc nịch",
    part_of_speech: "tính từ",
    meaning: "rắn chắc đến mức như được dồn nén chặt: cánh tay chắc nịch",
    example: "cánh tay chắc nịch",
  },
  {
    word: "chắc nịch",
    part_of_speech: "tính từ",
    meaning:
      "rắn rỏi và dứt khoát, thể hiện sự vững vàng, mạnh mẽ: câu trả lời chắc nịch * giọng văn chắc nịch",
    example: "câu trả lời chắc nịch * giọng văn chắc nịch",
  },
  {
    word: "chắc xanh",
    part_of_speech: "tính từ",
    meaning:
      "(hạt lúa) ở trạng thái nhân đã đặc và cứng, nhưng vỏ còn xanh: những bông lúa chắc xanh",
    example: "những bông lúa chắc xanh",
  },
  {
    word: "chặm",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) thấm từng ít một cho khô: chặm nước mắt * kéo vạt áo chặm mồ hôi",
    example: "chặm nước mắt * kéo vạt áo chặm mồ hôi",
  },
  {
    word: "chăm bẳm",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) chằm chằm: ngó chăm bẳm vô mặt người ta",
    example: "ngó chăm bẳm vô mặt người ta",
  },
  {
    word: "chăm bẵm",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) chăm nom một cách chu đáo: chăm bẵm đàn con thơ",
    example: "chăm bẵm đàn con thơ",
  },
  {
    word: "chăm chỉ",
    part_of_speech: "tính từ",
    meaning:
      "chăm (nói khái quát): học hành chăm chỉ * chăm chỉ luyện tập * làm ăn rất chăm chỉ",
    example: "học hành chăm chỉ * chăm chỉ luyện tập * làm ăn rất chăm chỉ",
  },
  {
    word: "chăm bón",
    part_of_speech: "động từ",
    meaning:
      "chăm nom vun bón cho cây cối, ruộng vườn: chăm bón cây trồng * công chăm bón",
    example: "chăm bón cây trồng * công chăm bón",
  },
  {
    word: "chằm chằm",
    part_of_speech: "tính từ",
    meaning:
      "(cách nhìn) chăm chú, thẳng và lâu, không chớp mắt, thường có ý dò xét: nhìn chằm chằm vào mặt",
    example: "nhìn chằm chằm vào mặt",
  },
  {
    word: "chăm chắm",
    part_of_speech: "tính từ",
    meaning:
      "(nhìn) thẳng và rất tập trung, tưởng như không rời: mắt nhìn chăm chắm",
    example: "mắt nhìn chăm chắm",
  },
  {
    word: "chăm chăm",
    part_of_speech: "tính từ",
    meaning:
      "có sự tập trung chú ý cao độ vào việc gì: chỉ chăm chăm vào một việc * nhìn chăm chăm",
    example: "chỉ chăm chăm vào một việc * nhìn chăm chăm",
  },
  {
    word: "chăm chút",
    part_of_speech: "động từ",
    meaning:
      "trông nom, săn sóc tỉ mỉ, chu đáo: chăm chút nhan sắc * chăm chút từng miếng ăn giấc ngủ cho con",
    example: "chăm chút nhan sắc * chăm chút từng miếng ăn giấc ngủ cho con",
  },
  {
    word: "chằm chặp",
    part_of_speech: "tính từ",
    meaning: "như chằm chằm: mắt nhìn chằm chặp",
    example: "mắt nhìn chằm chặp",
  },
  {
    word: "chắm chúi",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) chăm chú làm việc gì đó mà không để ý đến xung quanh: ngồi chắm chúi đọc sách",
    example: "ngồi chắm chúi đọc sách",
  },
  {
    word: "chăm chú",
    part_of_speech: "tính từ",
    meaning:
      "(làm việc gì) có sự tập trung tâm trí: học sinh chăm chú nghe giảng * nhìn một cách chăm chú",
    example: "học sinh chăm chú nghe giảng * nhìn một cách chăm chú",
  },
  {
    word: "chăn",
    part_of_speech: "danh từ",
    meaning:
      "(Nam mền) đồ dùng bằng vải, len, dạ, v.v. may, dệt thành tấm để đắp cho ấm: chăn len * đắp chăn",
    example: "chăn len *",
  },
  {
    word: "chăn",
    part_of_speech: "động từ",
    meaning:
      "đưa gia súc, gia cầm đi kiếm ăn và trông nom chúng: chăn bò * chăn ngỗng * trẻ chăn trâu",
    example: "chăn bò * chăn ngỗng * trẻ chăn trâu",
  },
  {
    word: "chắn",
    part_of_speech: "danh từ",
    meaning:
      "lối chơi bài, cứ hai quân cùng loại hợp lại thành một đôI, gọi là chắn, khác loại hợp lại thành một cạ: đánh chắn",
    example: "đánh chắn",
  },
  {
    word: "chắn",
    part_of_speech: "động từ",
    meaning:
      "ngăn giữ lại, không cho vượt qua hay tiếp tục di chuyển tới nữa: chắn dòng nước lũ * trồng cây chắn gió * đứng chắn ngay trước mặt",
    example:
      "chắn dòng nước lũ * trồng cây chắn gió * đứng chắn ngay trước mặt",
  },
  {
    word: "chắn",
    part_of_speech: "động từ",
    meaning: "(hiếm) ngăn để phân chia ra: chắn phòng khách làm hai phòng nhỏ",
    example: "chắn phòng khách làm hai phòng nhỏ",
  },
  {
    word: "chắn",
    part_of_speech: "danh từ",
    meaning:
      "vật để ngăn lại, không cho qua: nhấc chắn cho xe xuống phà * cấm vượt qua chắn đường tàu",
    example: "nhấc chắn cho xe xuống phà * cấm vượt qua chắn đường tàu",
  },
  {
    word: "chắn",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) dùng vật có lưỡi sắc xén mạnh cho đứt: chắn đứt rễ * chắn chồi",
    example: "chắn đứt rễ * chắn chồi",
  },
  {
    word: "chăm nom",
    part_of_speech: "động từ",
    meaning:
      "để ý, trông nom thường xuyên: chăm nom người ốm * chăm nom vườn tược",
    example: "chăm nom người ốm * chăm nom vườn tược",
  },
  {
    word: "chăm lo",
    part_of_speech: "",
    meaning:
      "thường xuyên quan tâm, lo lắng đến để làm cho tốt hơn: chăm lo sản xuất * chăm lo việc nhà",
    example: "chăm lo sản xuất * chăm lo việc nhà",
  },
  {
    word: "chặn",
    part_of_speech: "động từ",
    meaning:
      "giữ chặt lại hoặc đè mạnh xuống, không cho tự do cử động hoặc di động: lấy ghế chặn cửa * chặn cho tờ giấy khỏi bay",
    example: "lấy ghế chặn cửa * chặn cho tờ giấy khỏi bay",
  },
  {
    word: "chặn",
    part_of_speech: "động từ",
    meaning:
      "giữ hẳn lại, làm cho sự hoạt động theo một hướng nào đó phải ngừng hẳn: cầu thủ chặn được đường bóng * chặn kín các ngả đường, không cho thoát",
    example:
      "cầu thủ chặn được đường bóng * chặn kín các ngả đường, không cho thoát",
  },
  {
    word: "chặn",
    part_of_speech: "động từ",
    meaning:
      "ngăn ngừa trước, không cho xảy ra: tiêm để chặn cơn sốt * nói chặn trước",
    example: "tiêm để chặn cơn sốt * nói chặn trước",
  },
  {
    word: "chắn bóng",
    part_of_speech: "động từ",
    meaning:
      "dùng tay ngăn bóng đập của đối phương ở trên lưới, trong bóng chuyền: kĩ thuật chắn bóng trên lưới",
    example: "kĩ thuật chắn bóng trên lưới",
  },
  {
    word: "chăm sóc",
    part_of_speech: "động từ",
    meaning:
      "săn sóc thường xuyên: chăm sóc vườn hoa cây cảnh * chăm sóc con cái cẩn thận",
    example: "chăm sóc vườn hoa cây cảnh * chăm sóc con cái cẩn thận",
  },
  {
    word: "chẵn",
    part_of_speech: "tính từ",
    meaning:
      "(số) nguyên, tròn, không có phần lẻ: vừa chẵn hai nghìn đồng * một trăm chẵn",
    example: "vừa chẵn hai nghìn đồng * một trăm chẵn",
  },
  {
    word: "chẵn",
    part_of_speech: "tính từ",
    meaning:
      "(số nguyên) chia hết cho 2; phân biệt với lẻ: 20 là số chẵn * đi ngày chẵn, kiêng ngày lẻ",
    example: "20 là số chẵn * đi ngày chẵn, kiêng ngày lẻ",
  },
  {
    word: "chăn đơn gối chiếc",
    part_of_speech: "",
    meaning:
      '(cũ, văn chương) tả cảnh cô đơn, lẻ loi của người phụ nữ không chồng hoặc xa chồng: "Đêm đêm riêng giữ phòng không, Chăn đơn gối chiếc lạnh lùng một thân." (ca dao)',
    example:
      'Đêm đêm riêng giữ phòng không, Chăn đơn gối chiếc lạnh lùng một thân." (ca dao)',
  },
  {
    word: "chắn cạ",
    part_of_speech: "danh từ",
    meaning:
      "lối chơi bài, cứ hai quân cùng loại hợp lại thành một đôI, gọi là chắn, khác loại hợp lại thành một cạ: đánh chắn",
    example: "đánh chắn",
  },
  {
    word: "chắn cạ",
    part_of_speech: "động từ",
    meaning:
      "ngăn giữ lại, không cho vượt qua hay tiếp tục di chuyển tới nữa: chắn dòng nước lũ * trồng cây chắn gió * đứng chắn ngay trước mặt",
    example:
      "chắn dòng nước lũ * trồng cây chắn gió * đứng chắn ngay trước mặt",
  },
  {
    word: "chắn cạ",
    part_of_speech: "động từ",
    meaning: "(hiếm) ngăn để phân chia ra: chắn phòng khách làm hai phòng nhỏ",
    example: "chắn phòng khách làm hai phòng nhỏ",
  },
  {
    word: "chắn cạ",
    part_of_speech: "danh từ",
    meaning:
      "vật để ngăn lại, không cho qua: nhấc chắn cho xe xuống phà * cấm vượt qua chắn đường tàu",
    example: "nhấc chắn cho xe xuống phà * cấm vượt qua chắn đường tàu",
  },
  {
    word: "chắn cạ",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) dùng vật có lưỡi sắc xén mạnh cho đứt: chắn đứt rễ * chắn chồi",
    example: "chắn đứt rễ * chắn chồi",
  },
  {
    word: "chằn chặn",
    part_of_speech: "phụ từ",
    meaning:
      "(bằng, đều) đến mức không còn có thể hơn nữa: bằng chằn chặn * vuông chằn chặn * hàm răng trắng và đều chằn chặn",
    example:
      "bằng chằn chặn * vuông chằn chặn * hàm răng trắng và đều chằn chặn",
  },
  {
    word: "chăn dắt",
    part_of_speech: "động từ",
    meaning: "chăn gia súc, gia cầm (nói khái quát): chăn dắt trâu bò",
    example: "chăn dắt trâu bò",
  },
  {
    word: "chăn dắt",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) trông nom, dìu dắt: chăn dắt đàn em nhỏ * mụ tú bà chuyên chăn dắt gái",
    example: "chăn dắt đàn em nhỏ * mụ tú bà chuyên chăn dắt gái",
  },
  {
    word: "chặn hậu",
    part_of_speech: "động từ",
    meaning:
      "đi sau cùng để chặn địch: đội quân chặn hậu * dẫn binh đi chặn hậu",
    example: "đội quân chặn hậu * dẫn binh đi chặn hậu",
  },
  {
    word: "chăn gối",
    part_of_speech: "động từ",
    meaning:
      '(cũ, văn chương) chung chăn gối (nói tắt): tính chuyện chăn gối * "Chưa chăn gối, cũng vợ chồng, Lòng nào mà nỡ dứt lòng cho đang?" (TKiều)',
    example:
      'tính chuyện chăn gối * "Chưa chăn gối, cũng vợ chồng, Lòng nào mà nỡ dứt lòng cho đang?" (TKiều)',
  },
  {
    word: "chăn thả",
    part_of_speech: "động từ",
    meaning:
      "nuôi súc vật theo cách thả cho tự đi kiếm ăn ở môi trường tự nhiên (trong phạm vi có thể kiểm soát được): nuôi dê bằng hình thức chăn thả",
    example: "nuôi dê bằng hình thức chăn thả",
  },
  {
    word: "chặn họng",
    part_of_speech: "động từ",
    meaning:
      '(thông tục) chặn ngang không cho nói ra, một cách thô bạo: nói chặn họng * "Ông hơi mở miệng nói là họ chặn họng ngay." (NCao; 13)',
    example:
      'nói chặn họng * "Ông hơi mở miệng nói là họ chặn họng ngay." (NCao; 13)',
  },
  {
    word: "chặn đứng",
    part_of_speech: "động từ",
    meaning:
      "chặn ngay lại, làm cho phải ngừng hẳn ngay lập tức: chặn đứng cuộc tiến công * nạn dịch bị chặn đứng",
    example: "chặn đứng cuộc tiến công * nạn dịch bị chặn đứng",
  },
  {
    word: "chăn nuôi",
    part_of_speech: "",
    meaning:
      "nuôi gia súc, gia cầm (nói khái quát): chăn nuôi bò sữa * trại chăn nuôi * phát triển chăn nuôi",
    example: "chăn nuôi bò sữa * trại chăn nuôi * phát triển chăn nuôi",
  },
  {
    word: "chẵn lẻ",
    part_of_speech: "danh từ",
    meaning:
      "trò cờ bạc dùng sáu đồng tiền gieo xuống, tính số chẵn hay lẻ của các mặt sấp, ngửa mà định được thua: đánh chẵn lẻ",
    example: "đánh chẵn lẻ",
  },
  {
    word: "chằn tinh",
    part_of_speech: "danh từ",
    meaning:
      "yêu quái có hình thù dữ tợn, gớm ghiếc trong truyện cổ tích, thần thoại: dữ như chằn tinh",
    example: "dữ như chằn tinh",
  },
  {
    word: "chắn xích",
    part_of_speech: "danh từ",
    meaning: "tấm mỏng che xích xe đạp, mô tô, v.v.: chắn xích xe đạp",
    example: "chắn xích xe đạp",
  },
  {
    word: "chằng",
    part_of_speech: "động từ",
    meaning:
      "buộc từ bên nọ sang bên kia thành nhiều vòng cho thật chặt: chằng gói hàng sau xe đạp",
    example: "chằng gói hàng sau xe đạp",
  },
  {
    word: "chằng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) lấy hoặc nhận vơ về mình cái của người khác một cách tuỳ tiện: tiêu chằng * ăn chằng vay bửa",
    example: "tiêu chằng * ăn chằng vay bửa",
  },
  {
    word: "chắn song",
    part_of_speech: "danh từ",
    meaning:
      "hàng thanh gỗ hoặc sắt lắp thẳng đứng cách đều nhau để làm vật chắn, thường lắp ở các cửa sổ: chấn song cửa sổ * dãy hàng rào chấn song sắt",
    example: "chấn song cửa sổ * dãy hàng rào chấn song sắt",
  },
  {
    word: "chặng",
    part_of_speech: "danh từ",
    meaning:
      "đoạn đường hoặc quãng thời gian nhất định nào đó: chặng đường hành quân * chặng nghỉ * đoàn đua xe đã vào chặng cuối",
    example:
      "chặng đường hành quân * chặng nghỉ * đoàn đua xe đã vào chặng cuối",
  },
  {
    word: "chẳng",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị ý phủ định dứt khoát điều được nêu ra sau đó: chẳng thấy mặt mũi nó bao giờ * chẳng biết gì sất * không thừa nhưng cũng chẳng thiếu",
    example:
      "chẳng thấy mặt mũi nó bao giờ * chẳng biết gì sất * không thừa nhưng cũng chẳng thiếu",
  },
  {
    word: "chẳng",
    part_of_speech: "trợ từ",
    meaning:
      "(khẩu ngữ) từ biểu thị ý nhấn mạnh thêm về sắc thái nghĩa của từ hoặc tổ hợp từ đứng liền sau: có xe, chẳng tội gì mà đi bộ * đi như thế, chẳng thà ở nhà còn hơn",
    example:
      "có xe, chẳng tội gì mà đi bộ * đi như thế, chẳng thà ở nhà còn hơn",
  },
  {
    word: "chăng",
    part_of_speech: "động từ",
    meaning: "như giăng: chăng dây phơi * chăng đèn kết hoa * nhện chăng tơ",
    example: "chăng dây phơi * chăng đèn kết hoa * nhện chăng tơ",
  },
  {
    word: "chăng",
    part_of_speech: "phụ từ",
    meaning: "(cũ) từ biểu thị ý phủ định: nghe lõm bõm câu được câu chăng",
    example: "nghe lõm bõm câu được câu chăng",
  },
  {
    word: "chăng",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị ý muốn hỏi, tỏ ra còn nửa tin nửa ngờ: chậm rồi chăng? * nhầm chăng? * việc ấy có nên chăng?",
    example: "chậm rồi chăng? * nhầm chăng? * việc ấy có nên chăng?",
  },
  {
    word: "chăng",
    part_of_speech: "trợ từ",
    meaning:
      "(hiếm) như chăng nữa: dẫu có khó chăng cũng phải làm * dù có muốn chăng cũng không được tự tiện lấy",
    example:
      "dẫu có khó chăng cũng phải làm * dù có muốn chăng cũng không được tự tiện lấy",
  },
  {
    word: "chẳng bù",
    part_of_speech: "",
    meaning:
      "tổ hợp biểu thị điều sắp nói là trường hợp khác hẳn hoặc không thể sánh được với điều vừa nói đến (nêu ra để đối chiếu làm nổi bật trường hợp vừa được nói đến): người chị thì béo trục béo tròn, chẳng bù cho người em",
    example: "người chị thì béo trục béo tròn, chẳng bù cho người em",
  },
  {
    word: "chằng chéo",
    part_of_speech: "tính từ",
    meaning:
      "chéo lên nhau thành nhiều đường, nhiều mối lộn xộn: rễ cây mọc chằng chéo * những đường vẽ chằng chéo trên bản đồ",
    example: "rễ cây mọc chằng chéo * những đường vẽ chằng chéo trên bản đồ",
  },
  {
    word: "chằng chằng",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) không rời, không dứt ra: đứa bé bám mẹ chằng chằng * nhìn chằng chằng",
    example: "đứa bé bám mẹ chằng chằng * nhìn chằng chằng",
  },
  {
    word: "chằng chịt",
    part_of_speech: "tính từ",
    meaning:
      "thành nhiều đường, nhiều vết đan vào nhau dày đặc và không theo hàng lối nhất định: dây thép gai chằng chịt * mặt rỗ chằng chịt",
    example: "dây thép gai chằng chịt * mặt rỗ chằng chịt",
  },
  {
    word: "chẳng đâu vào đâu",
    part_of_speech: "",
    meaning:
      "như không đâu vào đâu: hàng ngũ lộn xộn, chẳng đâu vào đâu * toàn những chuyện chẳng đâu vào đâu!",
    example:
      "hàng ngũ lộn xộn, chẳng đâu vào đâu * toàn những chuyện chẳng đâu vào đâu!",
  },
  {
    word: "chẳng hạn",
    part_of_speech: "",
    meaning:
      "tổ hợp biểu thị ý nhấn mạnh về cái được dẫn chứng, được nêu làm thí dụ; ví dụ như (): có nhiều ưu điểm, chẳng hạn như cần cù, giản dị",
    example: "có nhiều ưu điểm, chẳng hạn như cần cù, giản dị",
  },
  {
    word: "chẳng lẽ",
    part_of_speech: "",
    meaning:
      "như không lẽ: chẳng lẽ lại chịu bó tay? * tôi là bố nó, chẳng lẽ tôi lại không hiểu nó?",
    example:
      "chẳng lẽ lại chịu bó tay? * tôi là bố nó, chẳng lẽ tôi lại không hiểu nó?",
  },
  {
    word: "chẳng mấy chốc",
    part_of_speech: "",
    meaning: "(khẩu ngữ) chẳng bao lâu: cứ đà này thì chẳng mấy chốc mà giàu!",
    example: "cứ đà này thì chẳng mấy chốc mà giàu!",
  },
  {
    word: "chẳng mấy khi",
    part_of_speech: "",
    meaning: "(khẩu ngữ) ít có dịp, ít khi: hai người chẳng mấy khi gặp nhau",
    example: "hai người chẳng mấy khi gặp nhau",
  },
  {
    word: "chẳng mấy nỗi",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) chẳng lâu gì, chẳng bao lâu (sẽ xảy ra điều thường không hay nào đó): hàng kém chất lượng, dùng chẳng mấy nỗi mà hỏng",
    example: "hàng kém chất lượng, dùng chẳng mấy nỗi mà hỏng",
  },
  {
    word: "chẳng nói chẳng rằng",
    part_of_speech: "",
    meaning:
      "lẳng lặng, không nói một lời nào: Nó không nói không rằng bỏ nhà đi biền biệt.",
    example: "Nó không nói không rằng bỏ nhà đi biền biệt.",
  },
  {
    word: "chăng nữa",
    part_of_speech: "",
    meaning: "như đi nữa: dù có thế nào chăng nữa cũng phải đi",
    example: "dù có thế nào chăng nữa cũng phải đi",
  },
  {
    word: "chẳng qua",
    part_of_speech: "",
    meaning:
      'tổ hợp biểu thị mức độ hạn chế của sự việc (thường hàm ý phân bua); cũng chỉ là, cũng chỉ vì: việc đó chẳng qua do không biết mà ra * "Chồng gì anh, vợ gì tôi, Chẳng qua là cái nợ đời chi đây!" (ca dao)',
    example:
      'việc đó chẳng qua do không biết mà ra * "Chồng gì anh, vợ gì tôi, Chẳng qua là cái nợ đời chi đây!" (ca dao)',
  },
  {
    word: "chắp",
    part_of_speech: "danh từ",
    meaning: "mụn nhỏ mọc ở rìa mí mắt: mắt lên chắp",
    example: "mắt lên chắp",
  },
  {
    word: "chắp",
    part_of_speech: "động từ",
    meaning:
      "làm cho liền lại bằng cách ghép vào với nhau: chắp các mảnh vỡ lại với nhau * chắp mối tơ duyên (b)",
    example: "chắp các mảnh vỡ lại với nhau * chắp mối tơ duyên (b)",
  },
  {
    word: "chắp",
    part_of_speech: "động từ",
    meaning: "áp hoặc nắm hai bàn tay vào nhau: chắp tay vái lia lịa",
    example: "chắp tay vái lia lịa",
  },
  {
    word: "chắp cánh",
    part_of_speech: "động từ",
    meaning:
      "tạo điều kiện tốt nhất để đạt tới đỉnh cao (ví như chắp dài thêm cánh để bay cao hơn, xa hơn): chắp cánh cho những ước mơ",
    example: "chắp cánh cho những ước mơ",
  },
  {
    word: "chẳng những",
    part_of_speech: "kết từ",
    meaning:
      "tổ hợp biểu thị điều sắp nêu ra chỉ mới là một phần, một mặt của sự việc, để nhằm nhấn mạnh về cái phần khác, mặt khác sẽ nêu tiếp liền sau đó: cô ấy không những đẹp mà còn rất thông minh",
    example: "cô ấy không những đẹp mà còn rất thông minh",
  },
  {
    word: "chẳng nhẽ",
    part_of_speech: "",
    meaning:
      "như không lẽ: chẳng lẽ lại chịu bó tay? * tôi là bố nó, chẳng lẽ tôi lại không hiểu nó?",
    example:
      "chẳng lẽ lại chịu bó tay? * tôi là bố nó, chẳng lẽ tôi lại không hiểu nó?",
  },
  {
    word: "chẳng thể",
    part_of_speech: "phụ từ",
    meaning:
      "như không thể (nhưng có ý nhấn mạnh hơn): chuyện đó chẳng thể làm ngay được",
    example: "chuyện đó chẳng thể làm ngay được",
  },
  {
    word: "chẳng nữa",
    part_of_speech: "kết từ",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị điều sắp nêu ra là trường hợp không hay có thể xảy ra nếu như không thực hiện điều vừa được nói đến; nếu không như vậy, thì …: tranh thủ gặt cho xong, chẳng nữa trời mưa, lại hỏng hết",
    example: "tranh thủ gặt cho xong, chẳng nữa trời mưa, lại hỏng hết",
  },
  {
    word: "chẳng trách",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị điều vừa nói đến là nguyên nhân tất yếu đã dẫn đến điều sắp nêu ra (thường là không hay), không có gì phải ngạc nhiên: hư đốn thế, chẳng trách chả ai ưa * không học bài, chẳng trách bị điểm kém",
    example:
      "hư đốn thế, chẳng trách chả ai ưa * không học bài, chẳng trách bị điểm kém",
  },
  {
    word: "chắp nhặt",
    part_of_speech: "động từ",
    meaning:
      '(cũ, hiếm) nhặt nhạnh từ nhiều nơi rồi chắp nối lại (thường nói về việc viết văn): "Lời quê chắp nhặt dông dài, Mua vui cũng được một vài trống canh." (TKiều)',
    example:
      'Lời quê chắp nhặt dông dài, Mua vui cũng được một vài trống canh." (TKiều)',
  },
  {
    word: "chắt",
    part_of_speech: "danh từ",
    meaning:
      "con của cháu nội hay cháu ngoại: đứa chắt nội * đời cháu, đời chắt",
    example: "đứa chắt nội * đời cháu, đời chắt",
  },
  {
    word: "chắt",
    part_of_speech: "động từ",
    meaning:
      "lấy riêng một ít nước ra khỏi một hỗn hợp có lẫn chất lỏng và chất đặc: cơm sôi chắt bớt nước",
    example: "cơm sôi chắt bớt nước",
  },
  {
    word: "chắp nối",
    part_of_speech: "động từ",
    meaning:
      "gắn kết nhiều phần, nhiều bộ phận lại với nhau cho thành một thể thống nhất: chắp nối những tình tiết của vụ án",
    example: "chắp nối những tình tiết của vụ án",
  },
  {
    word: "chắp nối",
    part_of_speech: "động từ",
    meaning:
      "nối lại quan hệ hoặc làm cho có quan hệ với nhau: ông tơ chắp nối cho hai người thành đôi",
    example: "ông tơ chắp nối cho hai người thành đôi",
  },
  {
    word: "chặt chẽ",
    part_of_speech: "tính từ",
    meaning:
      "gắn với nhau rất chặt (nói về cái trừu tượng): phối hợp chặt chẽ * hệ thống chặt chẽ",
    example: "phối hợp chặt chẽ * hệ thống chặt chẽ",
  },
  {
    word: "chặt chẽ",
    part_of_speech: "tính từ",
    meaning:
      "không để rời khỏi sự theo dõi, không buông lỏng: chỉ đạo chặt chẽ * quản lí chặt chẽ mọi đối tượng",
    example: "chỉ đạo chặt chẽ * quản lí chặt chẽ mọi đối tượng",
  },
  {
    word: "chắp vá",
    part_of_speech: "động từ",
    meaning:
      "ghép nhiều thứ không cùng một bộ với nhau để làm thành cái gì đó: chiếc áo được chắp vá từ những mảnh vải thừa",
    example: "chiếc áo được chắp vá từ những mảnh vải thừa",
  },
  {
    word: "chắp vá",
    part_of_speech: "tính từ",
    meaning:
      "(các phần) không khớp với nhau, không làm thành hệ thống do không được đồng bộ: một mớ kiến thức chắp vá * lối làm ăn chắp vá",
    example: "một mớ kiến thức chắp vá * lối làm ăn chắp vá",
  },
  {
    word: "chắp cánh liền cành",
    part_of_speech: "",
    meaning:
      '(cũ, văn chương) ví tình cảm nam nữ gắn bó khăng khít với nhau: "Trong khi chắp cánh liền cành, Mà lòng rẻ rúng đã dành một bên" (TKiều)',
    example:
      'Trong khi chắp cánh liền cành, Mà lòng rẻ rúng đã dành một bên" (TKiều)',
  },
  {
    word: "chặt chịa",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ, khẩu ngữ) như chặt chẽ: mộng ráp chặt chịa",
    example: "mộng ráp chặt chịa",
  },
  {
    word: "chắt bóp",
    part_of_speech: "động từ",
    meaning:
      "(chi tiêu) hạn chế, tằn tiện hết mức để dành dụm từng ít một: chi tiêu chắt bóp * chắt bóp từng đồng",
    example: "chi tiêu chắt bóp * chắt bóp từng đồng",
  },
  {
    word: "chặt",
    part_of_speech: "động từ",
    meaning:
      "làm đứt ngang ra bằng cách dùng vật có lưỡi sắc giáng mạnh xuống: chặt ngang thân cây * chặt khúc xương làm đôi",
    example: "chặt ngang thân cây * chặt khúc xương làm đôi",
  },
  {
    word: "chặt",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) như chém: chai nước ngọt giá có hai nghìn rưởi mà ở đây chặt tới năm nghìn",
    example: "chai nước ngọt giá có hai nghìn rưởi mà ở đây chặt tới năm nghìn",
  },
  {
    word: "chặt",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái bám vào nhau rất chắc, khó tách, khó gỡ ra: cửa khoá rất chặt * hai hàm răng nghiến chặt * lạt mềm buộc chặt (tng)",
    example:
      "cửa khoá rất chặt * hai hàm răng nghiến chặt * lạt mềm buộc chặt (tng)",
  },
  {
    word: "chặt",
    part_of_speech: "tính từ",
    meaning:
      "rất khít, không còn kẽ hở nào: nằm ép chặt mình xuống đất * nền đất được nện chặt * bố cục bài viết rất chặt (b)",
    example:
      "nằm ép chặt mình xuống đất * nền đất được nện chặt * bố cục bài viết rất chặt (b)",
  },
  {
    word: "chặt",
    part_of_speech: "tính từ",
    meaning:
      "hết sức sát sao, không lúc nào rời hay buông lỏng: chỉ đạo rất chặt * kiểm soát chặt mọi nguồn hàng",
    example: "chỉ đạo rất chặt * kiểm soát chặt mọi nguồn hàng",
  },
  {
    word: "chặt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) sít sao, chi li trong sự tính toán, không rộng rãi: chi tiêu quá chặt",
    example: "chi tiêu quá chặt",
  },
  {
    word: "chắt chiu",
    part_of_speech: "động từ",
    meaning:
      "dành dụm cẩn thận từng ít một vì coi là quý: chắt chiu từng hạt gạo * chắt chiu dành dụm từng đồng",
    example: "chắt chiu từng hạt gạo * chắt chiu dành dụm từng đồng",
  },
  {
    word: "chắt chiu",
    part_of_speech: "động từ",
    meaning:
      'chăm chút, nâng niu từng li từng tí vì coi là quý: "Người ngoan ai chả nâng niu, Hoa thơm ai chả chắt chiu trên cành." (ca dao)',
    example:
      'Người ngoan ai chả nâng niu, Hoa thơm ai chả chắt chiu trên cành." (ca dao)',
  },
  {
    word: "chặt đẹp",
    part_of_speech: "động từ",
    meaning: "(thông tục) như chém đẹp: bị chủ hàng chặt đẹp",
    example: "bị chủ hàng chặt đẹp",
  },
  {
    word: "chậc",
    part_of_speech: "cảm từ",
    meaning:
      "tiếng tắc lưỡi, biểu lộ sự miễn cưỡng đồng ý cho xong: chậc, đi thì đi!",
    example: "chậc, đi thì đi!",
  },
  {
    word: "chấm",
    part_of_speech: "danh từ",
    meaning:
      "cái hình tròn và nhỏ: chiếc máy bay chỉ còn là một chấm nhỏ trên bầu trời * chấm đỏ trên bản đồ đánh dấu khu vực quân sự",
    example:
      "chiếc máy bay chỉ còn là một chấm nhỏ trên bầu trời * chấm đỏ trên bản đồ đánh dấu khu vực quân sự",
  },
  {
    word: "chấm",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) dấu chấm (nói tắt): chữ 'i' có một chấm trên đầu",
    example: "chữ 'i' có một chấm trên đầu",
  },
  {
    word: "chấm",
    part_of_speech: "động từ",
    meaning:
      "tạo ra các chấm khi viết, vẽ: hết câu phải chấm * hoạ sĩ chấm mấy nét bút",
    example: "hết câu phải chấm * hoạ sĩ chấm mấy nét bút",
  },
  {
    word: "chấm",
    part_of_speech: "động từ",
    meaning:
      "đánh giá và cho điểm: giáo viên chấm bài * chấm thi * chấm công lao động",
    example: "giáo viên chấm bài * chấm thi * chấm công lao động",
  },
  {
    word: "chấm",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) chọn, kén người mình vừa ý nhất: chấm người vào đội văn nghệ * chấm được một cô xinh nhất đội",
    example: "chấm người vào đội văn nghệ * chấm được một cô xinh nhất đội",
  },
  {
    word: "chấm",
    part_of_speech: "động từ",
    meaning:
      "chạm vừa tới một điểm nào đó: quần dài chấm gót * tóc chấm ngang vai",
    example: "quần dài chấm gót * tóc chấm ngang vai",
  },
  {
    word: "chấm",
    part_of_speech: "động từ",
    meaning:
      "làm cho chạm dính vào hoặc thấm qua một chất lỏng, chất vụn nào đó: chấm ngòi bút vào lọ mực * khoai sọ chấm vừng",
    example: "chấm ngòi bút vào lọ mực * khoai sọ chấm vừng",
  },
  {
    word: "chấm",
    part_of_speech: "động từ",
    meaning: "thấm từng ít một cho khô: lấy khăn chấm mồ hôi * chấm nước mắt",
    example: "lấy khăn chấm mồ hôi * chấm nước mắt",
  },
  {
    word: "chắt lót",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) như chắt bóp: chi tiêu chắt lót, tằn tiện",
    example: "chi tiêu chắt lót, tằn tiện",
  },
  {
    word: "chắt lọc",
    part_of_speech: "động từ",
    meaning:
      "chọn lấy cái tinh tuý nhất, có giá trị và cần thiết nhất: chắt lọc lấy những tinh hoa văn hoá của dân tộc * kinh nghiệm được chắt lọc từ cuộc sống",
    example:
      "chắt lọc lấy những tinh hoa văn hoá của dân tộc * kinh nghiệm được chắt lọc từ cuộc sống",
  },
  {
    word: "chẩm",
    part_of_speech: "danh từ",
    meaning: "phần sọ nhô ra ở phía sau dưới của đầu: xương chẩm",
    example: "xương chẩm",
  },
  {
    word: "chấm ảnh",
    part_of_speech: "động từ",
    meaning:
      "tô thêm những dấu chấm nhỏ để sửa lại bức ảnh chụp cho đẹp hơn: kĩ thuật chấm ảnh",
    example: "kĩ thuật chấm ảnh",
  },
  {
    word: "châm",
    part_of_speech: "động từ",
    meaning:
      "đâm nhẹ bằng mũi nhọn nhỏ: gai châm vào người * đau buốt như kim châm",
    example: "gai châm vào người * đau buốt như kim châm",
  },
  {
    word: "châm",
    part_of_speech: "động từ",
    meaning:
      "đâm nhẹ mũi kim vào các huyệt trên da để chữa bệnh theo đông y: kĩ thuật châm kim gây tê",
    example: "kĩ thuật châm kim gây tê",
  },
  {
    word: "châm",
    part_of_speech: "động từ",
    meaning:
      "gí lửa vào làm cho bắt cháy: châm đèn * châm điếu thuốc * châm ngòi nổ",
    example: "châm đèn * châm điếu thuốc * châm ngòi nổ",
  },
  {
    word: "châm",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) rót (thường nói về nước chè, rượu): châm trà * châm rượu * châm dầu vào đèn",
    example: "châm trà * châm rượu * châm dầu vào đèn",
  },
  {
    word: "chậm",
    part_of_speech: "tính từ",
    meaning:
      "có tốc độ, nhịp độ dưới mức bình thường: xe chạy chậm * thời gian trôi thật chậm * nền kinh tế chậm phát triển * chậm hiểu",
    example:
      "xe chạy chậm * thời gian trôi thật chậm * nền kinh tế chậm phát triển * chậm hiểu",
  },
  {
    word: "chậm",
    part_of_speech: "tính từ",
    meaning:
      "(sự việc diễn ra) sau thời điểm quy định hoặc thời điểm thường lệ: tàu về chậm mất mười phút * cây chậm ra hoa * em bé chậm biết nói",
    example:
      "tàu về chậm mất mười phút * cây chậm ra hoa * em bé chậm biết nói",
  },
  {
    word: "chậm",
    part_of_speech: "tính từ",
    meaning:
      "không được nhanh nhẹn, thiếu linh hoạt: tác phong hơi chậm * người vừa vụng lại vừa chậm * khả năng phán đoán và xử lí hơi chậm",
    example:
      "tác phong hơi chậm * người vừa vụng lại vừa chậm * khả năng phán đoán và xử lí hơi chậm",
  },
  {
    word: "châm bẩm",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) chằm chằm: ngó chăm bẳm vô mặt người ta",
    example: "ngó chăm bẳm vô mặt người ta",
  },
  {
    word: "chầm bập",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) vồn vã, vồ vập: chầm bập hỏi han",
    example: "chầm bập hỏi han",
  },
  {
    word: "châm biếm",
    part_of_speech: "động từ",
    meaning:
      "chế giễu một cách hóm hỉnh nhằm phê phán: châm biếm thói hư tật xấu * giọng châm biếm chua cay * tranh châm biếm",
    example:
      "châm biếm thói hư tật xấu * giọng châm biếm chua cay * tranh châm biếm",
  },
  {
    word: "chậm chạp",
    part_of_speech: "tính từ",
    meaning:
      "chậm (nói khái quát): lê từng bước chậm chạp * tiến độ thi công chậm chạp * tác phong chậm chạp",
    example:
      "lê từng bước chậm chạp * tiến độ thi công chậm chạp * tác phong chậm chạp",
  },
  {
    word: "chầm chậm",
    part_of_speech: "tính từ",
    meaning: "hơi chậm: cho xe chạy chầm chậm",
    example: "cho xe chạy chầm chậm",
  },
  {
    word: "châm chọc",
    part_of_speech: "động từ",
    meaning:
      "nói xói móc nhằm trêu chọc, làm cho người ta bực tức, khó chịu: giọng mỉa mai châm chọc * nói châm chọc",
    example: "giọng mỉa mai châm chọc * nói châm chọc",
  },
  {
    word: "châm chích",
    part_of_speech: "động từ",
    meaning: "(hiếm) châm (nói khái quát): đau như bị nhiều mũi kim châm chích",
    example: "đau như bị nhiều mũi kim châm chích",
  },
  {
    word: "châm chích",
    part_of_speech: "động từ",
    meaning:
      "nói xói móc, cạnh khoé, nhằm làm cho người ta đau đớn, khó chịu: mẹ chồng châm chích con dâu",
    example: "mẹ chồng châm chích con dâu",
  },
  {
    word: "chầm chập",
    part_of_speech: "phụ từ",
    meaning:
      "(bênh) một mực và thiên lệch, không kể gì sai đúng: bênh con chầm chập",
    example: "bênh con chầm chập",
  },
  {
    word: "châm chước",
    part_of_speech: "động từ",
    meaning:
      "thêm chỗ này, bớt chỗ kia, thêm bớt sao cho vừa phải: châm chước yêu cầu của hai bên",
    example: "châm chước yêu cầu của hai bên",
  },
  {
    word: "châm chước",
    part_of_speech: "động từ",
    meaning:
      "giảm nhẹ bớt yêu cầu hoặc sự trừng phạt, vì chiếu cố đến hoàn cảnh cụ thể: cháu nó còn dại, mong bác châm chước cho!",
    example: "cháu nó còn dại, mong bác châm chước cho!",
  },
  {
    word: "châm cứu",
    part_of_speech: "động từ",
    meaning:
      "châm kim (châm) hay đốt nóng (cứu) ở các huyệt trên da để chữa bệnh theo đông y (nói tổng quát): môn châm cứu * điều trị bằng châm cứu",
    example: "môn châm cứu * điều trị bằng châm cứu",
  },
  {
    word: "chấm hết",
    part_of_speech: "động từ",
    meaning: "đặt dấu chấm để kết thúc bài viết: bài viết đến đó thì chấm hết",
    example: "bài viết đến đó thì chấm hết",
  },
  {
    word: "chấm hết",
    part_of_speech: "động từ",
    meaning:
      "chấm dứt hẳn, coi như không còn gì nữa: mọi việc đến đấy coi như chấm hết",
    example: "mọi việc đến đấy coi như chấm hết",
  },
  {
    word: "chấm dứt",
    part_of_speech: "động từ",
    meaning:
      "làm cho ngừng hẳn, thôi hẳn: chấm dứt cuộc cãi cọ * chiến tranh đã chấm dứt",
    example: "chấm dứt cuộc cãi cọ * chiến tranh đã chấm dứt",
  },
  {
    word: "châm ngôn",
    part_of_speech: "danh từ",
    meaning:
      "câu nói ngắn gọn có tác dụng hướng dẫn, khuyên răn về đạo đức, cách sống: châm ngôn có câu: đi một ngày đàng, học một sàng khôn",
    example: "châm ngôn có câu: đi một ngày đàng, học một sàng khôn",
  },
  {
    word: "chấm phá",
    part_of_speech: "động từ",
    meaning:
      "vẽ phác nhanh bằng mấy nét chính và đơn sơ nhất: bức tranh chấm phá * những nét vẽ chấm phá",
    example: "bức tranh chấm phá * những nét vẽ chấm phá",
  },
  {
    word: "chấm mút",
    part_of_speech: "động từ",
    meaning:
      '(thông tục) kiếm chác bằng cách bớt xén chút ít: chẳng chấm mút được gì * "Tiền của người ta, nhưng bác cũng hy vọng chấm mút chút đỉnh." (THoài; 34)',
    example:
      'chẳng chấm mút được gì * "Tiền của người ta, nhưng bác cũng hy vọng chấm mút chút đỉnh." (THoài; 34)',
  },
  {
    word: "chậm rì",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) rất chậm, gần như ì ra một chỗ, đến mức làm phát bực: xe chạy chậm rì",
    example: "xe chạy chậm rì",
  },
  {
    word: "chậm rãi",
    part_of_speech: "tính từ",
    meaning:
      "(động tác) chầm chậm, không vội vàng: bước đi chậm rãi * nói chậm rãi",
    example: "bước đi chậm rãi * nói chậm rãi",
  },
  {
    word: "chầm vập",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như chầm bập: cử chỉ chầm vập * chầm vập mời chào",
    example: "cử chỉ chầm vập * chầm vập mời chào",
  },
  {
    word: "chấn",
    part_of_speech: "danh từ",
    meaning:
      "tên một quẻ trong bát quái, thường tượng trưng cho sấm sét: quẻ chấn",
    example: "quẻ chấn",
  },
  {
    word: "chân",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận dưới cùng của cơ thể người hay động vật, dùng để đi, đứng, chạy, nhảy, v.v.: co chân đá * thú bốn chân * đi chân cao chân thấp * nước đến chân mới nhảy (tng)",
    example:
      "co chân đá * thú bốn chân * đi chân cao chân thấp * nước đến chân mới nhảy (tng)",
  },
  {
    word: "chân",
    part_of_speech: "danh từ",
    meaning:
      "chân con người, coi là biểu tượng của cương vị, tư cách hay phận sự nào đó trong một tổ chức: có chân trong hội đồng khoa học * thiếu một chân tổ tôm (kng) * kế chân người khác",
    example:
      "có chân trong hội đồng khoa học * thiếu một chân tổ tôm (kng) * kế chân người khác",
  },
  {
    word: "chân",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) một phần tư con vật có bốn chân, khi chung nhau sử dụng hoặc chia nhau thịt: hai nhà chung nhau một chân lợn",
    example: "hai nhà chung nhau một chân lợn",
  },
  {
    word: "chân",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận dưới cùng của một số đồ dùng, có tác dụng đỡ cho các bộ phận khác: chân đèn * chân giường * vững như kiềng ba chân",
    example: "chân đèn * chân giường * vững như kiềng ba chân",
  },
  {
    word: "chân",
    part_of_speech: "danh từ",
    meaning:
      "phần dưới cùng của một số vật, tiếp giáp và bám chặt vào mặt nền: chân núi * chân tường * chân răng",
    example: "chân núi * chân tường * chân răng",
  },
  {
    word: "chân",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị những đám ruộng thuộc một loại nào đó: chân ruộng trũng * chân đất bạc màu * chân mạ (chuyên để gieo mạ)",
    example:
      "chân ruộng trũng * chân đất bạc màu * chân mạ (chuyên để gieo mạ)",
  },
  {
    word: "chân",
    part_of_speech: "tính từ",
    meaning: "thật, đúng với hiện thực (nói khái quát): phân biệt chân với giả",
    example: "phân biệt chân với giả",
  },
  {
    word: "chậm tiến",
    part_of_speech: "tính từ",
    meaning:
      "có trình độ giác ngộ hoặc trình độ phát triển chậm hơn, thấp hơn so với yêu cầu và đà tiến chung: giúp đỡ người chậm tiến * thành phần chậm tiến * nước chậm tiến",
    example: "giúp đỡ người chậm tiến * thành phần chậm tiến * nước chậm tiến",
  },
  {
    word: "chậm trễ",
    part_of_speech: "tính từ",
    meaning:
      "chậm so với yêu cầu hoặc với thời hạn: thông tin liên lạc chậm trễ * đi ngay, không chậm trễ",
    example: "thông tin liên lạc chậm trễ * đi ngay, không chậm trễ",
  },
  {
    word: "chẩn",
    part_of_speech: "động từ",
    meaning:
      "cứu giúp cho dân nghèo đói hoặc bị tai hoạ, bằng cách phân phát tiền, gạo, v.v. (trong xã hội cũ): phát chẩn * đi lĩnh chẩn",
    example: "phát chẩn * đi lĩnh chẩn",
  },
  {
    word: "chẩn bệnh",
    part_of_speech: "động từ",
    meaning: "(Từ cũ) chẩn đoán bệnh (nói tắt): bác sĩ chẩn bệnh",
    example: "bác sĩ chẩn bệnh",
  },
  {
    word: "chần",
    part_of_speech: "động từ",
    meaning:
      "may nhiều đường để ép chặt các lớp vải hoặc bông vào với nhau: chần cổ áo * chần áo bông",
    example: "chần cổ áo * chần áo bông",
  },
  {
    word: "chần",
    part_of_speech: "động từ",
    meaning:
      "nhúng qua nước sôi cho chín tái hoặc cho sạch: thịt bò chần tái * đĩa hành chần * chần qua bánh phở",
    example: "thịt bò chần tái * đĩa hành chần * chần qua bánh phở",
  },
  {
    word: "chần",
    part_of_speech: "động từ",
    meaning: "(Thông tục) đánh, đập: chần cho một trận",
    example: "chần cho một trận",
  },
  {
    word: "chân chấu",
    part_of_speech: "danh từ",
    meaning:
      "răng của lưỡi liềm, lưỡi hái, v.v., được giũa thành hàng nhọn và sắc, giống hình gai chân con châu chấu: liềm mòn hết chân chấu",
    example: "liềm mòn hết chân chấu",
  },
  {
    word: "chân chất",
    part_of_speech: "tính từ",
    meaning:
      "bộc lộ bản chất tốt đẹp đúng nguyên như tính chất tự nhiên vốn có, không che đậy, giả dối: người nông dân chân chất * một vẻ đẹp chân chất",
    example: "người nông dân chân chất * một vẻ đẹp chân chất",
  },
  {
    word: "chân chỉ hạt bột",
    part_of_speech: "danh từ",
    meaning:
      "tua bằng chỉ màu có kết hạt trang trí, thường được đính vào mép các bức thêu: bức trướng thêu có viền chân chỉ hạt bột",
    example: "bức trướng thêu có viền chân chỉ hạt bột",
  },
  {
    word: "chân chính",
    part_of_speech: "tính từ",
    meaning:
      "hoàn toàn xứng với tên gọi (tốt đẹp): một nhà giáo chân chính * người nghệ sĩ chân chính",
    example: "một nhà giáo chân chính * người nghệ sĩ chân chính",
  },
  {
    word: "chân chính",
    part_of_speech: "tính từ",
    meaning:
      "thật sự như vậy, không sai: một tình yêu chân chính * vì lợi ích chân chính của người lao động",
    example:
      "một tình yêu chân chính * vì lợi ích chân chính của người lao động",
  },
  {
    word: "chấn chỉnh",
    part_of_speech: "động từ",
    meaning:
      "sắp đặt, sửa sang lại cho ngay ngắn, cho hết lộn xộn, hết chuệch choạc: chấn chỉnh lại hàng ngũ * chấn chỉnh kỉ cương phép nước",
    example: "chấn chỉnh lại hàng ngũ * chấn chỉnh kỉ cương phép nước",
  },
  {
    word: "chân chim",
    part_of_speech: "danh từ",
    meaning:
      "vết nứt, rạn hoặc nhăn rẽ ra thành nhiều đường khác nhau từ một điểm, trông giống hình chân con chim: đôi mắt đã rạn chân chim",
    example: "đôi mắt đã rạn chân chim",
  },
  {
    word: "chân chỉ",
    part_of_speech: "tính từ",
    meaning: "(hiếm) thật thà, chất phác, không gian giảo: làm ăn chân chỉ",
    example: "làm ăn chân chỉ",
  },
  {
    word: "chần chừ",
    part_of_speech: "động từ",
    meaning:
      "đắn đo, do dự, chưa có quyết tâm để làm ngay việc gì: thái độ chần chừ * chần chừ mãi không quyết định được",
    example: "thái độ chần chừ * chần chừ mãi không quyết định được",
  },
  {
    word: "chân dung",
    part_of_speech: "danh từ",
    meaning:
      "tác phẩm hội hoạ, điêu khắc, nhiếp ảnh thể hiện đúng diện mạo, thần sắc, hình dáng (một người nào đó): bức chân dung * vẽ chân dung * chân dung người chiến sĩ cách mạng",
    example:
      "bức chân dung * vẽ chân dung * chân dung người chiến sĩ cách mạng",
  },
  {
    word: "chân đế",
    part_of_speech: "danh từ",
    meaning:
      "đa giác lồi nhỏ nhất chứa tất cả các điểm tiếp xúc giữa một vật với mặt phẳng nằm ngang đỡ nó.",
    example: "chân đế của máy quay camera",
  },
  {
    word: "chân đồng vai sắt",
    part_of_speech: "",
    meaning:
      "như xương đồng da sắt: người chiến sĩ pháo binh chân đồng vai sắt",
    example: "người chiến sĩ pháo binh chân đồng vai sắt",
  },
  {
    word: "chân đất",
    part_of_speech: "danh từ",
    meaning: "chân đi không, không mang giày dép: bỏ giày đi chân đất",
    example: "bỏ giày đi chân đất",
  },
  {
    word: "chấn động",
    part_of_speech: "động từ",
    meaning: "(hiếm) rung động mạnh: cơn chấn động * bị chấn động thần kinh",
    example: "cơn chấn động * bị chấn động thần kinh",
  },
  {
    word: "chấn động",
    part_of_speech: "động từ",
    meaning:
      "(sự kiện, tin tức trọng đại) làm náo động lòng người: bài thơ gây chấn động dư luận * chiến thắng làm chấn động hoàn cầu",
    example:
      "bài thơ gây chấn động dư luận * chiến thắng làm chấn động hoàn cầu",
  },
  {
    word: "chẩn đoán",
    part_of_speech: "động từ",
    meaning:
      "xác định bệnh, dựa theo triệu chứng và kết quả xét nghiệm: chẩn đoán và điều trị bệnh * thiết bị chẩn đoán lâm sàng",
    example: "chẩn đoán và điều trị bệnh * thiết bị chẩn đoán lâm sàng",
  },
  {
    word: "chẩn đoán",
    part_of_speech: "động từ",
    meaning:
      "xác định hiện tượng trục trặc bất thường, thường là trong máy móc: chẩn đoán đúng các lỗi của ổ đĩa máy tính",
    example: "chẩn đoán đúng các lỗi của ổ đĩa máy tính",
  },
  {
    word: "chân giày chân dép",
    part_of_speech: "",
    meaning:
      'tả cảnh sống nhàn hạ, sung sướng: "Chân giày chân dép vào ra, Kêu dâu cũng lỡ kêu bà khó kêu." (MPXH)',
    example:
      'Chân giày chân dép vào ra, Kêu dâu cũng lỡ kêu bà khó kêu." (MPXH)',
  },
  {
    word: "chân giá trị",
    part_of_speech: "danh từ",
    meaning: "giá trị thực: chân giá trị của con người",
    example: "chân giá trị của con người",
  },
  {
    word: "chân giò",
    part_of_speech: "danh từ",
    meaning: "chân lợn đã làm thịt: chân giò hầm",
    example: "chân giò hầm",
  },
  {
    word: "chân kiềng",
    part_of_speech: "danh từ",
    meaning: "thế vững chắc như ba chân của cái kiềng: tạo thế chân kiềng",
    example: "tạo thế chân kiềng",
  },
  {
    word: "chân không",
    part_of_speech: "danh từ",
    meaning:
      "khoảng không gian không chứa một dạng vật chất nào cả: bơm chân không * môi trường chân không",
    example: "bơm chân không * môi trường chân không",
  },
  {
    word: "chấn hưng",
    part_of_speech: "động từ",
    meaning:
      "(cũ) làm cho hưng thịnh và phát triển: sự nghiệp chấn hưng giáo dục",
    example: "sự nghiệp chấn hưng giáo dục",
  },
  {
    word: "chân gỗ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) kẻ thông đồng với kẻ khác tìm cách dụ dỗ, thuyết phục đối phương theo ý đồ của mình (trong các việc mua bán, làm ăn): làm chân gỗ trong việc tuyển lao động",
    example: "làm chân gỗ trong việc tuyển lao động",
  },
  {
    word: "chân gỗ",
    part_of_speech: "danh từ",
    meaning:
      "người làm trung gian giới thiệu cho hai bên làm quen với nhau để xây dựng quan hệ hôn nhân: nhờ người làm chân gỗ",
    example: "nhờ người làm chân gỗ",
  },
  {
    word: "chân kính",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận bằng hạt quặng rất cứng, dùng để đỡ trục bánh xe đồng hồ: đồng hồ mười bảy chân kính",
    example: "đồng hồ mười bảy chân kính",
  },
  {
    word: "chân hàng",
    part_of_speech: "danh từ",
    meaning:
      "nơi tập trung các đầu mối thu gom hàng hoá để phân phối đi các nơi: đại lí có chân hàng ổn định * tổ chức chân hàng ở các địa phương",
    example: "đại lí có chân hàng ổn định * tổ chức chân hàng ở các địa phương",
  },
  {
    word: "chân lấm tay bùn",
    part_of_speech: "",
    meaning:
      'tả cảnh làm ăn lam lũ, vất vả ngoài đồng ruộng: "(…) mình chỉ là một anh dân quê, phải chân lấm tay bùn thì mới khỏi chết đói." (VTrPhụng; 15)',
    example:
      '(…) mình chỉ là một anh dân quê, phải chân lấm tay bùn thì mới khỏi chết đói." (VTrPhụng; 15)',
  },
  {
    word: "chân lí",
    part_of_speech: "danh từ",
    meaning:
      "sự phản ánh chính xác sự vật khách quan và quy luật của chúng vào ý thức con người: tìm ra chân lí * bảo vệ chân lí",
    example: "tìm ra chân lí * bảo vệ chân lí",
  },
  {
    word: "chân lý",
    part_of_speech: "danh từ",
    meaning:
      "sự phản ánh chính xác sự vật khách quan và quy luật của chúng vào ý thức con người: tìm ra chân lí * bảo vệ chân lí",
    example: "tìm ra chân lí * bảo vệ chân lí",
  },
  {
    word: "chân mây cuối trời",
    part_of_speech: "",
    meaning:
      '(cũ, văn chương) như chân trời góc biển: "Gìn vàng giữ ngọc cho hay, Cho đành lòng kẻ chân mây cuối trời!" (TKiều)',
    example:
      'Gìn vàng giữ ngọc cho hay, Cho đành lòng kẻ chân mây cuối trời!" (TKiều)',
  },
  {
    word: "chân mây",
    part_of_speech: "danh từ",
    meaning:
      '(văn chương, hiếm) như chân trời: "Buồn trông nội cỏ dầu dầu, Chân mây mặt đất một màu xanh xanh." (TKiều)',
    example:
      'Buồn trông nội cỏ dầu dầu, Chân mây mặt đất một màu xanh xanh." (TKiều)',
  },
  {
    word: "chẩn mạch",
    part_of_speech: "động từ",
    meaning: "(cũ) bắt mạch để đoán bệnh: thầy lang chẩn mạch",
    example: "thầy lang chẩn mạch",
  },
  {
    word: "chân nâng",
    part_of_speech: "danh từ",
    meaning: "bàn đạp mắc hai bên yên ngựa: bộ chân nâng ở yên ngựa",
    example: "bộ chân nâng ở yên ngựa",
  },
  {
    word: "chân mày",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) lông mày: cặp chân mày rậm",
    example: "cặp chân mày rậm",
  },
  {
    word: "chân như",
    part_of_speech: "danh từ",
    meaning:
      'nguyên lí tuyệt đối, vĩnh cửu, không thay đổi, không sinh không diệt, theo quan niệm của đạo Phật: "Nhạn rằng: Sư phụ xuất gia, Chân như để dạ phồn hoa gác ngoài." (SKTT)',
    example:
      'Nhạn rằng: Sư phụ xuất gia, Chân như để dạ phồn hoa gác ngoài." (SKTT)',
  },
  {
    word: "chân quì",
    part_of_speech: "danh từ",
    meaning:
      "chân thấp, dáng cong ở một số đồ gỗ, đồ đồng (trông giống dáng chân đang quỳ): sập chân quỳ * lư hương chân quỳ",
    example: "sập chân quỳ * lư hương chân quỳ",
  },
  {
    word: "chân quỳ",
    part_of_speech: "danh từ",
    meaning:
      "chân thấp, dáng cong ở một số đồ gỗ, đồ đồng (trông giống dáng chân đang quỳ): sập chân quỳ * lư hương chân quỳ",
    example: "sập chân quỳ * lư hương chân quỳ",
  },
  {
    word: "chân phương",
    part_of_speech: "tính từ",
    meaning:
      "(chữ viết) ngay ngắn, đơn giản, rõ ràng và đủ từng nét, đúng quy cách: nét chữ chân phương",
    example: "nét chữ chân phương",
  },
  {
    word: "chân quê",
    part_of_speech: "tính từ",
    meaning:
      "mộc mạc, chân chất và bình dị, như bản chất vốn có ở thôn quê: một cô gái chân quê  * sống rất chân quê",
    example: "một cô gái chân quê  * sống rất chân quê",
  },
  {
    word: "chân rết",
    part_of_speech: "danh từ",
    meaning:
      "đường đan, thêu, v.v. thành hình nhiều nhánh nhỏ toả ra hai bên một đường chính như hình chân con rết: mạng chân rết",
    example: "mạng chân rết",
  },
  {
    word: "chân rết",
    part_of_speech: "danh từ",
    meaning:
      "chỉ những con đường hoặc tổ chức chi nhánh toả ra từ một con đường hoặc tổ chức chính: hệ thống mương máng chân rết * các chân rết của tổng công ti",
    example: "hệ thống mương máng chân rết * các chân rết của tổng công ti",
  },
  {
    word: "chân tay",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như tay chân: sai chân tay đi đòi nợ",
    example: "sai chân tay đi đòi nợ",
  },
  {
    word: "chân tài",
    part_of_speech: "danh từ",
    meaning: "tài năng thật sự: một chân tài về âm nhạc",
    example: "một chân tài về âm nhạc",
  },
  {
    word: "chấn song",
    part_of_speech: "danh từ",
    meaning:
      "hàng thanh gỗ hoặc sắt lắp thẳng đứng cách đều nhau để làm vật chắn, thường lắp ở các cửa sổ: chấn song cửa sổ * dãy hàng rào chấn song sắt",
    example: "chấn song cửa sổ * dãy hàng rào chấn song sắt",
  },
  {
    word: "chân thành",
    part_of_speech: "tính từ",
    meaning:
      "rất thành thật, xuất phát tự đáy lòng: lòng chân thành * chân thành góp ý với bạn",
    example: "lòng chân thành * chân thành góp ý với bạn",
  },
  {
    word: "chân tình",
    part_of_speech: "danh từ",
    meaning:
      "lòng thành thật: một tấm chân tình * lấy chân tình mà đối xử với nhau",
    example: "một tấm chân tình * lấy chân tình mà đối xử với nhau",
  },
  {
    word: "chân tình",
    part_of_speech: "tính từ",
    meaning:
      "có lòng thành thật, đầy nhiệt tình: sự giúp đỡ chân tình * thái độ chân tình, cởi mở",
    example: "sự giúp đỡ chân tình * thái độ chân tình, cởi mở",
  },
  {
    word: "chẩn trị",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) chẩn mạch và trị bệnh, theo đông y: chẩn trị bệnh tiểu đường",
    example: "chẩn trị bệnh tiểu đường",
  },
  {
    word: "chân tơ kẽ tóc",
    part_of_speech: "",
    meaning:
      "những điều hết sức tỉ mỉ, cặn kẽ, đến từng chi tiết của sự việc: tìm hiểu đến tận chân tơ kẽ tóc",
    example: "tìm hiểu đến tận chân tơ kẽ tóc",
  },
  {
    word: "chấn thương",
    part_of_speech: "",
    meaning:
      "(tình trạng) thương tổn ở bộ phận cơ thể do tác động từ bên ngoài: bị chấn thương sọ não",
    example: "bị chấn thương sọ não",
  },
  {
    word: "chân thật",
    part_of_speech: "tính từ",
    meaning:
      "(ý thức, tình cảm) đúng đắn, có như thế nào thì bày tỏ đúng như thế: tình cảm chân thật * bộ phim phản ánh chân thật cuộc sống",
    example: "tình cảm chân thật * bộ phim phản ánh chân thật cuộc sống",
  },
  {
    word: "chân trời",
    part_of_speech: "danh từ",
    meaning:
      "đường giới hạn của tầm mắt ở nơi xa tít, trông tưởng như bầu trời tiếp xúc với mặt đất hay mặt biển: mặt trời nhô lên ở chân trời",
    example: "mặt trời nhô lên ở chân trời",
  },
  {
    word: "chân trời",
    part_of_speech: "danh từ",
    meaning:
      "phạm vi rộng lớn mở ra cho một hoạt động hoặc sự việc có triển vọng lớn lao nào đó: đi đến những chân trời mới",
    example: "đi đến những chân trời mới",
  },
  {
    word: "chân trời góc biển",
    part_of_speech: "",
    meaning:
      "chỉ nơi xa xăm, cách trở: ở tận nơi chân trời góc biển * đi đến tận chân trời góc biển",
    example: "ở tận nơi chân trời góc biển * đi đến tận chân trời góc biển",
  },
  {
    word: "chấn tử",
    part_of_speech: "danh từ",
    meaning:
      "thanh kim loại đặt song song với nhau và kẹp chặt vào một thanh kim loại khác, trong anten định hướng dùng để thu các tín hiệu vô tuyến điện: anten mười sáu chấn tử",
    example: "anten mười sáu chấn tử",
  },
  {
    word: "chân tu",
    part_of_speech: "động từ",
    meaning: "tu hành chân chính: bậc chân tu",
    example: "bậc chân tu",
  },
  {
    word: "chân tướng",
    part_of_speech: "danh từ",
    meaning:
      "bộ mặt thật, bản chất thật (thường là xấu xa) vốn được che giấu: lộ rõ chân tướng * chân tướng của kẻ phản bội",
    example: "lộ rõ chân tướng * chân tướng của kẻ phản bội",
  },
  {
    word: "chân ướt chân ráo",
    part_of_speech: "",
    meaning:
      "tả tình trạng vừa mới đến một nơi nào, chưa kịp hiểu tình hình, sự thể ở nơi ấy như thế nào: vừa chân ướt chân ráo về tới nhà đã bị ăn mắng",
    example: "vừa chân ướt chân ráo về tới nhà đã bị ăn mắng",
  },
  {
    word: "chân váy",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) váy may rời, không dính liền với áo: áo trắng mặc với chân váy đen",
    example: "áo trắng mặc với chân váy đen",
  },
  {
    word: "chân vịt",
    part_of_speech: "danh từ",
    meaning: "bộ phận máy có cánh quạt quay dưới nước để tạo nên sức đẩy.",
    example: "chân vịt máy khâu",
  },
  {
    word: "chân vạc",
    part_of_speech: "danh từ",
    meaning:
      "thế vững chắc và ổn định do ba lực lượng ngang nhau liên kết tạo thành: đóng quân thành thế chân vạc",
    example: "đóng quân thành thế chân vạc",
  },
  {
    word: "chân xác",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) đúng như có thật trong thực tế: những dữ kiện khoa học chân xác",
    example: "những dữ kiện khoa học chân xác",
  },
  {
    word: "chân voi",
    part_of_speech: "danh từ",
    meaning: "bệnh phù rất to ở chân: mắc bệnh chân voi",
    example: "mắc bệnh chân voi",
  },
  {
    word: "chập",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) khoảng thời gian tương đối ngắn: mưa một chập * mắng cho một chập * chập này trời rét đậm",
    example: "mưa một chập * mắng cho một chập * chập này trời rét đậm",
  },
  {
    word: "chập",
    part_of_speech: "động từ",
    meaning:
      "đặt liền bên nhau những vật mảnh hoặc dài và gộp làm một: chập hai sợi lại cho chắc * hai tờ giấy chập vào nhau * ba kim đồng hồ chập làm một",
    example:
      "chập hai sợi lại cho chắc * hai tờ giấy chập vào nhau * ba kim đồng hồ chập làm một",
  },
  {
    word: "chập",
    part_of_speech: "động từ",
    meaning:
      "(dây điện, dây tóc đồng hồ, v.v.) chạm dính vào nhau (gây ra những trục trặc nào đó): dây điện chập, làm cháy cầu chì * đồng hồ bị chập dây tóc",
    example: "dây điện chập, làm cháy cầu chì * đồng hồ bị chập dây tóc",
  },
  {
    word: "chập",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (tính tình) bất thường, hơi dở hơi, hâm hấp: tính nó hơi chập",
    example: "tính nó hơi chập",
  },
  {
    word: "chấp",
    part_of_speech: "động từ",
    meaning:
      "cho đối phương được hưởng những điều kiện nào đó lợi hơn khi bắt đầu cuộc chơi, cuộc đấu: đánh cờ, chấp một xe",
    example: "đánh cờ, chấp một xe",
  },
  {
    word: "chấp",
    part_of_speech: "động từ",
    meaning:
      "địch lại mà không sợ đối phương có thế lợi hơn mình: một mình chấp ba người",
    example: "một mình chấp ba người",
  },
  {
    word: "chấp",
    part_of_speech: "động từ",
    meaning: "để bụng: tôi lỡ lời, mong anh đừng chấp * không chấp trẻ con!",
    example: "tôi lỡ lời, mong anh đừng chấp * không chấp trẻ con!",
  },
  {
    word: "chấp bút",
    part_of_speech: "động từ",
    meaning:
      "khởi thảo văn bản theo ý kiến đã thống nhất của một tập thể: cuốn sách do một giáo sư nổi tiếng chấp bút",
    example: "cuốn sách do một giáo sư nổi tiếng chấp bút",
  },
  {
    word: "chập cheng",
    part_of_speech: "động từ",
    meaning:
      "từ mô phỏng tiếng chũm choẹ: tiếng chũm choẹ chập cheng vang lên từ đám cúng",
    example: "tiếng chũm choẹ chập cheng vang lên từ đám cúng",
  },
  {
    word: "chập cheng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) không được bình thường về mặt tâm lí, có những hành vi khác thường: tính hơi chập cheng",
    example: "tính hơi chập cheng",
  },
  {
    word: "chấp choá",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) có nhiều ánh chớp làm loá mắt: ánh đèn pin chấp choá trong đêm",
    example: "ánh đèn pin chấp choá trong đêm",
  },
  {
    word: "chấp choá",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) chập choạng: trời đã chấp choá mặt người",
    example: "trời đã chấp choá mặt người",
  },
  {
    word: "chập choạng",
    part_of_speech: "tính từ",
    meaning:
      "mờ mờ tối, dở tối dở sáng (thường nói về lúc chiều tối): trời vừa chập choạng tối",
    example: "trời vừa chập choạng tối",
  },
  {
    word: "chập choạng",
    part_of_speech: "tính từ",
    meaning:
      "có những động tác không vững, không đều do không giữ được thăng bằng trong khi di chuyển: trời tối, bước đi chập choạng",
    example: "trời tối, bước đi chập choạng",
  },
  {
    word: "chập chờn",
    part_of_speech: "",
    meaning:
      'ở trạng thái nửa ngủ nửa thức, nửa tỉnh nửa mê: giấc ngủ chập chờn * "Chập chờn cơn tỉnh, cơn mê, Rốn ngồi chẳng tiện, dứt về chỉn khôn." (TKiều)',
    example:
      'giấc ngủ chập chờn * "Chập chờn cơn tỉnh, cơn mê, Rốn ngồi chẳng tiện, dứt về chỉn khôn." (TKiều)',
  },
  {
    word: "chập chờn",
    part_of_speech: "",
    meaning:
      "ở trạng thái khi ẩn khi hiện, khi tỏ khi mờ, khi rõ khi không: ánh đuốc chập chờn ở phía đằng xa * nhình ảnh quê hương cứ chập chờn trước mắt",
    example:
      "ánh đuốc chập chờn ở phía đằng xa * nhình ảnh quê hương cứ chập chờn trước mắt",
  },
  {
    word: "chấp hành",
    part_of_speech: "động từ",
    meaning:
      "thi hành, thực hiện (những điều quy định trong chính sách, pháp luật, kế hoạch, mệnh lệnh, phán quyết): nghiêm chỉnh chấp hành luật giao thông * ý thức chấp hành pháp luật",
    example:
      "nghiêm chỉnh chấp hành luật giao thông * ý thức chấp hành pháp luật",
  },
  {
    word: "chấp kinh",
    part_of_speech: "động từ",
    meaning:
      '(cũ, văn chương) giữ theo đạo thường, lẽ thường: "Có khi biến có khi thường, Có quyền nào phải một đường chấp kinh." (TKiều)',
    example:
      'Có khi biến có khi thường, Có quyền nào phải một đường chấp kinh." (TKiều)',
  },
  {
    word: "chập chững",
    part_of_speech: "tính từ",
    meaning:
      "có những bước chưa vững vì mới tập đI: em bé chập chững tập đi * mới chập chững bước vào nghề (b)",
    example: "em bé chập chững tập đi * mới chập chững bước vào nghề (b)",
  },
  {
    word: "chập chồng",
    part_of_speech: "tính từ",
    meaning: "(cũ) trập trùng: dãy núi chập chồng",
    example: "dãy núi chập chồng",
  },
  {
    word: "chấp chới",
    part_of_speech: "động từ",
    meaning:
      "ở trạng thái thăng bằng bất định, khi lên khi xuống, khi nghiêng bên này khi ngả sang bên kia: bướm bay chấp chới",
    example: "bướm bay chấp chới",
  },
  {
    word: "chấp chới",
    part_of_speech: "động từ",
    meaning:
      'rung rinh và khi mờ khi tỏ: ánh đèn chấp chới như sao * "Đuốc hoa chấp chới năm canh nguyệt (...)" (LTKN)',
    example:
      'ánh đèn chấp chới như sao * "Đuốc hoa chấp chới năm canh nguyệt (...)" (LTKN)',
  },
  {
    word: "chấp chới",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nhấp nháy mắt và liếc nhìn một cách không đứng đắn, có ý ve vãn: đôi mắt chấp chới",
    example: "đôi mắt chấp chới",
  },
  {
    word: "chập mạch",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) (thần kinh) có những biểu hiện không bình thường (hàm ý coi thường): rõ cái đồ chập mạch!",
    example: "rõ cái đồ chập mạch!",
  },
  {
    word: "chấp nê",
    part_of_speech: "động từ",
    meaning: "(cũ) như chấp nhặt: ai lại chấp nê trẻ con như thế!",
    example: "ai lại chấp nê trẻ con như thế!",
  },
  {
    word: "chấp nhặt",
    part_of_speech: "động từ",
    meaning: "để bụng trách móc về những sai sót nhỏ nhặt: tính hay chấp nhặt",
    example: "tính hay chấp nhặt",
  },
  {
    word: "chấp nhận",
    part_of_speech: "động từ",
    meaning:
      "đồng ý nhận (điều người khác yêu cầu hoặc đề ra): không chấp nhận số phận * chấp nhận khó khăn * lời yêu cầu vẫn chưa được chấp nhận",
    example:
      "không chấp nhận số phận * chấp nhận khó khăn * lời yêu cầu vẫn chưa được chấp nhận",
  },
  {
    word: "chập tối",
    part_of_speech: "danh từ",
    meaning:
      "lúc trời mới bắt đầu tối: đi từ mờ sáng đến chập tối * trời vừa chập tối",
    example: "đi từ mờ sáng đến chập tối * trời vừa chập tối",
  },
  {
    word: "chấp nhất",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) giữ khăng khăng một mực quan điểm theo cái định sẵn, không chịu thay đổi: tính hay chấp nhất",
    example: "tính hay chấp nhất",
  },
  {
    word: "chấp thuận",
    part_of_speech: "động từ",
    meaning:
      "(cấp có thẩm quyền) chấp nhận điều yêu cầu hoặc đề nghị: kiến nghị được hội đồng chấp thuận",
    example: "kiến nghị được hội đồng chấp thuận",
  },
  {
    word: "chật",
    part_of_speech: "tính từ",
    meaning:
      "có kích thước nhỏ so với vật cần bọc hoặc cần chứa bên trong: nhà chật người đông * áo may chật",
    example: "nhà chật người đông * áo may chật",
  },
  {
    word: "chật",
    part_of_speech: "tính từ",
    meaning:
      "nhiều, đông quá mức trong một phạm vi nhất định nào đó: người xem đứng chật hai bên đường * nhà ở quá chật * đồ đạc nhét chật cả tủ",
    example:
      "người xem đứng chật hai bên đường * nhà ở quá chật * đồ đạc nhét chật cả tủ",
  },
  {
    word: "chất",
    part_of_speech: "danh từ",
    meaning:
      "vật chất tồn tại ở một thể nhất định và là cái cấu tạo nên các vật thể: chất béo * thức ăn có chứa nhiều chất đạm * cải tạo chất đất",
    example: "chất béo * thức ăn có chứa nhiều chất đạm * cải tạo chất đất",
  },
  {
    word: "chất",
    part_of_speech: "danh từ",
    meaning:
      "tính chất, yếu tố cấu tạo của sự vật: vở kịch có nhiều chất thơ * bài hát mang đậm chất trữ tình * một tính cách đậm chất Nam Bộ",
    example:
      "vở kịch có nhiều chất thơ * bài hát mang đậm chất trữ tình * một tính cách đậm chất Nam Bộ",
  },
  {
    word: "chất",
    part_of_speech: "danh từ",
    meaning:
      "phạm trù triết học chỉ tổng thể nói chung những tính chất, thuộc tính cơ bản của sự vật, làm cho sự vật này phân biệt với sự vật khác; phân biệt với lượng: sự biến đổi về chất",
    example: "sự biến đổi về chất",
  },
  {
    word: "chất",
    part_of_speech: "động từ",
    meaning:
      "xếp cái nọ lên trên cái kia cho thành khối, thành đống lớn: chất hàng lên xe * củi chất thành đống",
    example: "chất hàng lên xe * củi chất thành đống",
  },
  {
    word: "chấp pháp",
    part_of_speech: "động từ",
    meaning: "(cũ) chịu trách nhiệm thi hành pháp luật: cơ quan chấp pháp",
    example: "cơ quan chấp pháp",
  },
  {
    word: "chất béo",
    part_of_speech: "danh từ",
    meaning: "tên gọi thông thường của lipid: thức ăn có nhiều chất béo",
    example: "thức ăn có nhiều chất béo",
  },
  {
    word: "chất cháy",
    part_of_speech: "danh từ",
    meaning:
      "chất rất dễ bén lửa và gây cháy (như xăng, dầu, phốt pho, napalm, v.v.): không đem theo chất cháy, chất nổ vào phòng họp",
    example: "không đem theo chất cháy, chất nổ vào phòng họp",
  },
  {
    word: "chất bốc",
    part_of_speech: "danh từ",
    meaning:
      "chất khí hoặc hơi cháy bốc ra khi than bị nung nóng: lượng chất bốc của than",
    example: "lượng chất bốc của than",
  },
  {
    word: "chất chồng",
    part_of_speech: "động từ",
    meaning: "(hiếm) như chồng chất: hàng hoá chất chồng trong kho",
    example: "hàng hoá chất chồng trong kho",
  },
  {
    word: "chất bôi trơn",
    part_of_speech: "danh từ",
    meaning:
      "chất làm giảm ma sát của các chi tiết chuyển động, hoặc làm giảm sự biến dạng trong quá trình gia công các kim loại: dầu nhờn là một trong những chất bôi trơn thông dụng",
    example: "dầu nhờn là một trong những chất bôi trơn thông dụng",
  },
  {
    word: "chất chỉ thị",
    part_of_speech: "danh từ",
    meaning:
      "chất có khả năng thay đổi tính chất một cách đột biến và dễ quan sát dưới tác dụng của sự thay đổi môi trường, thường dùng để xác định sự bắt đầu hay kết thúc của một phản ứng hoá học: quỳ là một chất chỉ thị thường dùng để kiểm tra nồng độ của acid",
    example: "quỳ là một chất chỉ thị thường dùng để kiểm tra nồng độ của acid",
  },
  {
    word: "chật cứng",
    part_of_speech: "tính từ",
    meaning:
      "chật đến mức như không cựa được: trên xe đã chật cứng người * người ngồi chật cứng cả căn phòng",
    example: "trên xe đã chật cứng người * người ngồi chật cứng cả căn phòng",
  },
  {
    word: "chất chứa",
    part_of_speech: "động từ",
    meaning: "(hiếm) như chứa chất: nỗi bực dọc chất chứa trong lòng",
    example: "nỗi bực dọc chất chứa trong lòng",
  },
  {
    word: "chất dẻo",
    part_of_speech: "danh từ",
    meaning:
      "chất có khả năng tạo hình dưới tác dụng của nhiệt độ và áp suất, sau đó giữ nguyên hình dạng đã tạo: sản xuất sợi chất dẻo * sử dụng túi chất dẻo",
    example: "sản xuất sợi chất dẻo * sử dụng túi chất dẻo",
  },
  {
    word: "chật chội",
    part_of_speech: "tính từ",
    meaning:
      "chật, gây nên cảm giác bức bối khó chịu (nói khái quát; thường nói về nơi ở, điều kiện ở): nhà cửa chật chội",
    example: "nhà cửa chật chội",
  },
  {
    word: "chất độc",
    part_of_speech: "danh từ",
    meaning:
      "chất làm phá huỷ, ức chế hoặc làm chết cơ thể sống: chất độc hoá học * cơ thể bị nhiễm chất độc",
    example: "chất độc hoá học * cơ thể bị nhiễm chất độc",
  },
  {
    word: "chật hẹp",
    part_of_speech: "tính từ",
    meaning: "vừa chật vừa hẹp: đường sá chật hẹp * căn phòng chật hẹp",
    example: "đường sá chật hẹp * căn phòng chật hẹp",
  },
  {
    word: "chật hẹp",
    part_of_speech: "tính từ",
    meaning:
      "có phạm vi quá hẹp do những hạn chế của bản thân: khuôn khổ chật hẹp của bài báo * ý nghĩ chật hẹp",
    example: "khuôn khổ chật hẹp của bài báo * ý nghĩ chật hẹp",
  },
  {
    word: "chất đốt",
    part_of_speech: "danh từ",
    meaning:
      "chất khi cháy toả ra nhiều nhiệt, dùng trong đời sống và công nghiệp, như để đun, chạy máy, v.v.: củi, than, xăng là những chất đốt",
    example: "củi, than, xăng là những chất đốt",
  },
  {
    word: "chất kết dính",
    part_of_speech: "danh từ",
    meaning:
      "chất có thể chuyển từ thể lỏng, nhão sang thể rắn để gắn liền các vật rời thành một khối cứng: xi măng là một chất kết dính",
    example: "xi măng là một chất kết dính",
  },
  {
    word: "chất lỏng",
    part_of_speech: "danh từ",
    meaning:
      "chất ở trạng thái có thể chảy được, có thể tích nhất định và có hình dạng tuỳ thuộc vào vật chứa: bình đựng chất lỏng * nước là một dạng chất lỏng",
    example: "bình đựng chất lỏng * nước là một dạng chất lỏng",
  },
  {
    word: "chất khí",
    part_of_speech: "danh từ",
    meaning: "chất ở trạng thái khí: metan là một chất khí dễ cháy",
    example: "metan là một chất khí dễ cháy",
  },
  {
    word: "chất liệu",
    part_of_speech: "danh từ",
    meaning:
      "vật liệu, tư liệu để tạo ra sản phẩm: sản phẩm được làm từ chất liệu nhựa tổng hợp",
    example: "sản phẩm được làm từ chất liệu nhựa tổng hợp",
  },
  {
    word: "chất khử",
    part_of_speech: "danh từ",
    meaning: "chất có khả năng khử chất khác: carbon là một chất khử",
    example: "carbon là một chất khử",
  },
  {
    word: "chất lượng",
    part_of_speech: "danh từ",
    meaning:
      "cái tạo nên phẩm chất, giá trị của một sự vật, sự việc: hàng kém chất lượng * nâng cao chất lượng giảng dạy",
    example: "hàng kém chất lượng * nâng cao chất lượng giảng dạy",
  },
  {
    word: "chất ngất",
    part_of_speech: "tính từ",
    meaning:
      "cao ngất và có nhiều lớp, nhiều tầng chồng lên nhau: một xe hàng đầy chất ngất * những dãy núi cao chất ngất",
    example: "một xe hàng đầy chất ngất * những dãy núi cao chất ngất",
  },
  {
    word: "chật ních",
    part_of_speech: "tính từ",
    meaning:
      "chật đến mức như không thể lèn hoặc chen thêm vào được nữa: túi nhét chật ních * rạp hát chật ních những người",
    example: "túi nhét chật ních * rạp hát chật ních những người",
  },
  {
    word: "chất nổ",
    part_of_speech: "danh từ",
    meaning:
      "chất có khả năng gây nên một phản ứng hoá học nhanh, mạnh, toả ra nhiều nhiệt và ánh sáng, đồng thời sinh ra khí và kèm theo tiếng nổ, thường dùng làm mìn, đạn dược: phạm tội buôn bán chất nổ trái phép",
    example: "phạm tội buôn bán chất nổ trái phép",
  },
  {
    word: "chất phác",
    part_of_speech: "tính từ",
    meaning:
      "bộc lộ bản chất tốt đẹp một cách tự nhiên, không giả dối, màu mè: con người hiền lành, chất phác",
    example: "con người hiền lành, chất phác",
  },
  {
    word: "chất vấn",
    part_of_speech: "động từ",
    meaning:
      "hỏi và yêu cầu phải giải thích rõ ràng: đại biểu quốc hội trả lời chất vấn",
    example: "đại biểu quốc hội trả lời chất vấn",
  },
  {
    word: "chật vật",
    part_of_speech: "tính từ",
    meaning:
      "(làm việc gì) có vẻ vất vả, khó nhọc: có làm được cũng phải chật vật * chật vật mãi mới kê được cái tủ",
    example: "có làm được cũng phải chật vật * chật vật mãi mới kê được cái tủ",
  },
  {
    word: "chật vật",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều khó khăn về vật chất, khiến phải vất vả nhiều: đời sống chật vật * hoàn cảnh gia đình cũng không đến nỗi chật vật",
    example:
      "đời sống chật vật * hoàn cảnh gia đình cũng không đến nỗi chật vật",
  },
  {
    word: "chất thải",
    part_of_speech: "danh từ",
    meaning:
      "rác và các vật bỏ đi sau một quá trình sử dụng, nói chung: chất thải công nghiệp * xử lí chất thải",
    example: "chất thải công nghiệp * xử lí chất thải",
  },
  {
    word: "chất xám",
    part_of_speech: "danh từ",
    meaning:
      "mô cấu tạo bởi rất nhiều tế bào thần kinh có màu xám nằm ở vỏ ngoài của não; thường dùng để chỉ tri thức, trí tuệ, óc sáng tạo: chảy máu chất xám * đầu tư chất xám",
    example: "chảy máu chất xám * đầu tư chất xám",
  },
  {
    word: "chẩu",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) chúm môi lại và dẩu ra phía trước: chẩu mỏ ra chửi * môi nó chẩu ra",
    example: "chẩu mỏ ra chửi * môi nó chẩu ra",
  },
  {
    word: "châu",
    part_of_speech: "danh từ",
    meaning:
      "phần của bề mặt Trái Đất được phân chia theo quy ước, có thể gồm cả một đại lục hay một phần đại lục và các đảo phụ cận: các nước thuộc khu vực châu Á * năm châu bốn biển",
    example: "các nước thuộc khu vực châu Á * năm châu bốn biển",
  },
  {
    word: "châu",
    part_of_speech: "danh từ",
    meaning: "(cũ, văn chương) ngọc trai: mắt sáng như châu * gạo châu củi quế",
    example: "mắt sáng như châu * gạo châu củi quế",
  },
  {
    word: "châu",
    part_of_speech: "danh từ",
    meaning:
      'nước mắt: "Lại càng ủ dột nét hoa, Sầu tuôn đứt nối, châu sa vắn dài." (TKiều)',
    example:
      'Lại càng ủ dột nét hoa, Sầu tuôn đứt nối, châu sa vắn dài." (TKiều)',
  },
  {
    word: "châu",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị hành chính ở Việt Nam thời thuộc Hán, Đường, tương đương với cả nước hoặc với một tỉnh: châu Hoan, châu Ái * châu Thuận Hoá",
    example: "châu Hoan, châu Ái * châu Thuận Hoá",
  },
  {
    word: "châu",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) chụm (đầu) vào một chỗ: châu đầu lại nói chuyện",
    example: "châu đầu lại nói chuyện",
  },
  {
    word: "chậu",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng thường làm bằng sành sứ, nhựa hoặc kim loại, miệng rộng, lòng nông, dùng để đựng nước rửa ráy, tắm giặt, hoặc để trồng cây, v.v.: chậu hoa * chậu rửa mặt * chậu nước đầy",
    example: "chậu hoa * chậu rửa mặt * chậu nước đầy",
  },
  {
    word: "chầu",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) bữa ăn uống hoặc vui chơi giải trí: đãi một chầu phở * nhậu một chầu",
    example: "đãi một chầu phở * nhậu một chầu",
  },
  {
    word: "chầu",
    part_of_speech: "động từ",
    meaning:
      "(cũ) hầu (vua, chúa) trong cung đình để chờ nghe lệnh: chầu vua * sân chầu (sân các quan chầu vua) * áo chầu (áo mặc để đi chầu)",
    example:
      "chầu vua * sân chầu (sân các quan chầu vua) * áo chầu (áo mặc để đi chầu)",
  },
  {
    word: "chầu",
    part_of_speech: "động từ",
    meaning:
      "hướng vào, quay vào một cái khác được coi là trung tâm: chạm hình rồng chầu mặt nguyệt",
    example: "chạm hình rồng chầu mặt nguyệt",
  },
  {
    word: "chấu",
    part_of_speech: "danh từ",
    meaning: "(Khẩu ngữ) chân chấu (nói tắt): lưỡi liềm đã mòn hết chấu",
    example: "lưỡi liềm đã mòn hết chấu",
  },
  {
    word: "châu lục",
    part_of_speech: "danh từ",
    meaning:
      "vùng đất liền làm thành một châu của Trái Đất: các châu lục Âu, Á, Phi * cuộc thi tài giữa các đội bóng đến từ nhiều châu lục",
    example:
      "các châu lục Âu, Á, Phi * cuộc thi tài giữa các đội bóng đến từ nhiều châu lục",
  },
  {
    word: "chầu chực",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) ở bên cạnh để chờ đợi sự sai khiến: đứng chầu chực bên cạnh chờ sai bảo * các quan chầu chực ở nội cung",
    example:
      "đứng chầu chực bên cạnh chờ sai bảo * các quan chầu chực ở nội cung",
  },
  {
    word: "chầu chực",
    part_of_speech: "động từ",
    meaning:
      "chờ đợi mất nhiều thì giờ để đạt một yêu cầu gì: chầu chực suốt buổi mới được việc",
    example: "chầu chực suốt buổi mới được việc",
  },
  {
    word: "chầu diêm vương",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) chết xuống âm phủ (hàm ý hài hước hoặc coi thường): không nhanh thì đã chầu Diêm Vương rồi!",
    example: "không nhanh thì đã chầu Diêm Vương rồi!",
  },
  {
    word: "châu chấu đá xe",
    part_of_speech: "",
    meaning:
      'ví trường hợp yếu mà dám chống lại kẻ mạnh hơn gấp bội: "Nực cười châu chấu đá xe, Tưởng rằng chấu ngã, ai dè xe nghiêng." (ca dao)',
    example:
      'Nực cười châu chấu đá xe, Tưởng rằng chấu ngã, ai dè xe nghiêng." (ca dao)',
  },
  {
    word: "châu lệ",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) nước mắt: "Trạng nguyên nghe nói đăm chiêu, Tức thì châu lệ đều đều nhỏ sa." (PCCH)',
    example:
      'Trạng nguyên nghe nói đăm chiêu, Tức thì châu lệ đều đều nhỏ sa." (PCCH)',
  },
  {
    word: "chầu hẫu",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả dáng ngồi chực bên cạnh, chăm chú chờ, xem hoặc hóng chuyện: mấy đứa bé ngồi chầu hẫu nghe kể chuyện",
    example: "mấy đứa bé ngồi chầu hẫu nghe kể chuyện",
  },
  {
    word: "châu ngọc",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương) ngọc và ngọc trai (nói khái quát); dùng để ví cái hết sức đẹp đẽ, quý giá: những lời châu ngọc",
    example: "những lời châu ngọc",
  },
  {
    word: "châu thổ",
    part_of_speech: "danh từ",
    meaning:
      "đồng bằng ở vùng cửa sông do phù sa bồi đắp nên: châu thổ sông Cửu Long * đồng bằng châu thổ sông Hồng",
    example: "châu thổ sông Cửu Long * đồng bằng châu thổ sông Hồng",
  },
  {
    word: "chầu rìa",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) ngồi chực bên cạnh đám chơi bài, cờ, v.v., để xem, không tham gia chính thức: ngồi chầu rìa xem đánh tổ tôm",
    example: "ngồi chầu rìa xem đánh tổ tôm",
  },
  {
    word: "chầu văn",
    part_of_speech: "danh từ",
    meaning:
      "lối hát cổ truyền, có làn điệu phong phú, dùng để ca tụng thần thánh trong khi cúng bái, lên đồng: hát chầu văn * điệu chầu văn",
    example: "hát chầu văn * điệu chầu văn",
  },
  {
    word: "chầu văn",
    part_of_speech: "động từ",
    meaning:
      "hát có đàn hoà theo, để ca tụng thần thánh khi cúng bái, lên đồng, theo lối hát cổ truyền: xem chầu văn trong phủ thánh",
    example: "xem chầu văn trong phủ thánh",
  },
  {
    word: "chầu trời",
    part_of_speech: "động từ",
    meaning:
      '(khẩu ngữ) chết (thường hàm ý hài hước): "Bao giờ ông lão chầu Trời, Thì ta lại lấy một người trai tơ." (ca dao)',
    example:
      'Bao giờ ông lão chầu Trời, Thì ta lại lấy một người trai tơ." (ca dao)',
  },
  {
    word: "chầu ông vải",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) chết (hàm ý hài hước hoặc coi khinh): đánh cho nó về chầu ông vải!",
    example: "đánh cho nó về chầu ông vải!",
  },
  {
    word: "chấy",
    part_of_speech: "động từ",
    meaning: "rang và nghiền nhỏ: tôm chấy",
    example: "tôm chấy",
  },
  {
    word: "chầy",
    part_of_speech: "tính từ",
    meaning:
      '(cũ) muộn, chậm: chẳng chóng thì chầy * "Đành lòng chờ đó ít lâu, Chầy chăng là một năm sau, vội gì!" (TKiều)',
    example:
      'chẳng chóng thì chầy * "Đành lòng chờ đó ít lâu, Chầy chăng là một năm sau, vội gì!" (TKiều)',
  },
  {
    word: "chầy",
    part_of_speech: "tính từ",
    meaning:
      'lâu, dài: canh chầy * "Một mình âm ỉ đêm chầy, Đĩa dầu vơi, nước mắt đầy, năm canh." (TKiều)',
    example:
      'canh chầy * "Một mình âm ỉ đêm chầy, Đĩa dầu vơi, nước mắt đầy, năm canh." (TKiều)',
  },
  {
    word: "chây lười",
    part_of_speech: "tính từ",
    meaning:
      "lười nhác không chịu làm gì cả (nói khái quát): thái độ chây lười * chây lười lao động",
    example: "thái độ chây lười * chây lười lao động",
  },
  {
    word: "chây ì",
    part_of_speech: "động từ",
    meaning:
      "cố tình ì ra, nhất định không chịu thay đổi, bất kể thế nào: thái độ chây ì, trốn tránh trách nhiệm * chây ì không trả nợ",
    example: "thái độ chây ì, trốn tránh trách nhiệm * chây ì không trả nợ",
  },
  {
    word: "chẻ",
    part_of_speech: "động từ",
    meaning:
      "tách theo chiều dọc thành từng mảnh, từng thanh: chẻ củi * chẻ rau muống * chẻ lạt (chẻ tre, nứa thành lạt)",
    example: "chẻ củi * chẻ rau muống * chẻ lạt (chẻ tre, nứa thành lạt)",
  },
  {
    word: "chè",
    part_of_speech: "danh từ",
    meaning:
      "cây nhỡ, lá dày cạnh có răng cưa, hoa màu trắng, quả có ba múi, trồng để lấy lá, búp, nụ pha nước uống: hái chè * đồi chè * pha chè",
    example: "hái chè * đồi chè * pha chè",
  },
  {
    word: "chè",
    part_of_speech: "danh từ",
    meaning:
      "món ăn ngọt nấu bằng đường hay mật với chất có bột như gạo, đậu, v.v.: chè đỗ đen",
    example: "chè đỗ đen",
  },
  {
    word: "che",
    part_of_speech: "động từ",
    meaning:
      "làm cho người ta không còn nhìn thấy được bằng cách dùng một vật ngăn hoặc phủ lên: che miệng cười * mây che khuất mặt trăng * vải thưa che mắt thánh (tng)",
    example:
      "che miệng cười * mây che khuất mặt trăng * vải thưa che mắt thánh (tng)",
  },
  {
    word: "che",
    part_of_speech: "động từ",
    meaning:
      "ngăn cho khỏi bị một tác động nào đó từ bên ngoài: phủ vải bạt che mưa * gió chiều nào che chiều ấy (tng)",
    example: "phủ vải bạt che mưa * gió chiều nào che chiều ấy (tng)",
  },
  {
    word: "chẽ",
    part_of_speech: "danh từ",
    meaning: "nhánh của một buồng, một chùm: chẽ lúa * một chẽ cau",
    example: "chẽ lúa * một chẽ cau",
  },
  {
    word: "chẽ",
    part_of_speech: "động từ",
    meaning:
      "phân ra thành nhánh: cành cây chẽ thành hai nhánh nhỏ * đến đây đường chẽ thành hai lối",
    example:
      "cành cây chẽ thành hai nhánh nhỏ * đến đây đường chẽ thành hai lối",
  },
  {
    word: "che chở",
    part_of_speech: "động từ",
    meaning:
      "ngăn, che để bảo vệ cho khỏi sự xâm hại từ bên ngoài: lợi dụng các hang đá để làm nơi che chở * chị em đùm bọc, che chở lẫn nhau",
    example:
      "lợi dụng các hang đá để làm nơi che chở * chị em đùm bọc, che chở lẫn nhau",
  },
  {
    word: "chè chén",
    part_of_speech: "động từ",
    meaning:
      "ăn uống một cách lãng phí: chè chén say sưa * ngồi chè chén với nhau",
    example: "chè chén say sưa * ngồi chè chén với nhau",
  },
  {
    word: "ché",
    part_of_speech: "danh từ",
    meaning:
      "đồ đựng bằng sành, sứ, thân tròn phình to ở giữa, miệng loe và có nắp đậy, thường dùng để đựng rượu: ché rượu cần",
    example: "ché rượu cần",
  },
  {
    word: "che chắn",
    part_of_speech: "động từ",
    meaning:
      "che để bảo vệ khỏi những tác động bất lợi từ bên ngoài (nói khái quát): nhà cửa được che chắn kín đáo * lợi dụng địa hình để tạo thế che chắn",
    example:
      "nhà cửa được che chắn kín đáo * lợi dụng địa hình để tạo thế che chắn",
  },
  {
    word: "che đậy",
    part_of_speech: "động từ",
    meaning:
      "đậy lên, phủ lên để giữ cho khỏi bị hư hỏng (nói khái quát): che đậy hàng hoá cho khỏi ướt",
    example: "che đậy hàng hoá cho khỏi ướt",
  },
  {
    word: "che đậy",
    part_of_speech: "động từ",
    meaning:
      "che giấu không cho người ta nhìn thấy được cái thực chất, thường là xấu xa: che đậy tội lỗi * luận điệu xảo trá không che đậy được bản chất xấu xa",
    example:
      "che đậy tội lỗi * luận điệu xảo trá không che đậy được bản chất xấu xa",
  },
  {
    word: "che giấu",
    part_of_speech: "động từ",
    meaning:
      "giấu đi, không để lộ ra cho người khác biết: không nên che giấu khuyết điểm * che giấu mọi tội lỗi",
    example: "không nên che giấu khuyết điểm * che giấu mọi tội lỗi",
  },
  {
    word: "chẻ hoe",
    part_of_speech: "tính từ",
    meaning:
      "(thông tục) rất rõ ràng, không có gì mập mờ, che đậy: sự thật chẻ hoe * nói chẻ hoe",
    example: "sự thật chẻ hoe * nói chẻ hoe",
  },
  {
    word: "che lấp",
    part_of_speech: "động từ",
    meaning:
      "che kín làm cho không còn nhìn thấy được nữa: đường mòn bị cỏ che lấp * mây đen che lấp bầu trời",
    example: "đường mòn bị cỏ che lấp * mây đen che lấp bầu trời",
  },
  {
    word: "che kín",
    part_of_speech: "động từ",
    meaning:
      "che cho không còn hở ra, không để lộ ra bên ngoài để có thể nhìn thấy được: mây đen che kín bầu trời * tóc dài che kín gáy",
    example: "mây đen che kín bầu trời * tóc dài che kín gáy",
  },
  {
    word: "chè lá",
    part_of_speech: "danh từ",
    meaning:
      "chè tàu, thuốc lá và những thứ tương tự thường dùng để biếu xén, hối lộ khi cầu cạnh việc gì: chè lá cho quan trên",
    example: "chè lá cho quan trên",
  },
  {
    word: "che phủ",
    part_of_speech: "động từ",
    meaning:
      "phủ khắp lên bề mặt, làm cho không còn nhìn thấy hoặc không còn nhìn rõ được nữa: trồng cây che phủ đất trống, đồi trọc",
    example: "trồng cây che phủ đất trống, đồi trọc",
  },
  {
    word: "che mờ",
    part_of_speech: "động từ",
    meaning:
      "làm cho không còn khả năng nhìn rõ nét được nữa do có vật gì (thường là thưa, mỏng) che phủ: sương mù che mờ cảnh vật",
    example: "sương mù che mờ cảnh vật",
  },
  {
    word: "chè mạn",
    part_of_speech: "danh từ",
    meaning:
      "chè thô sản xuất bằng búp của một giống chè lá to (trước đây thường trồng ở mạn ngược): pha một ấm chè mạn",
    example: "pha một ấm chè mạn",
  },
  {
    word: "chẻ tre",
    part_of_speech: "tính từ",
    meaning:
      "(thế thắng) dồn dập và dễ dàng (ví dễ như chẻ thanh tre): thế chẻ tre",
    example: "thế chẻ tre",
  },
  {
    word: "chè tươi",
    part_of_speech: "danh từ",
    meaning: "lá chè già mới hái, dùng để nấu nước uống: bát nước chè xanh",
    example: "bát nước chè xanh",
  },
  {
    word: "chè xanh",
    part_of_speech: "danh từ",
    meaning: "lá chè già mới hái, dùng để nấu nước uống: bát nước chè xanh",
    example: "bát nước chè xanh",
  },
  {
    word: "chém đẹp",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) như chém (nhưng nghĩa nhấn mạnh hơn): bị chủ quán chém đẹp",
    example: "bị chủ quán chém đẹp",
  },
  {
    word: "chém cha",
    part_of_speech: "",
    meaning:
      '(văn chương) tiếng nguyền rủa: "Chém cha cái số hoa đào, Gỡ ra rồi lại buộc vào như chơi!" (TKiều)',
    example:
      'Chém cha cái số hoa đào, Gỡ ra rồi lại buộc vào như chơi!" (TKiều)',
  },
  {
    word: "chèm nhèm",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) như nhem nhuốc: mặt mũi chèm nhèm * mực dính chèm nhèm khắp áo",
    example: "mặt mũi chèm nhèm * mực dính chèm nhèm khắp áo",
  },
  {
    word: "chém giết",
    part_of_speech: "động từ",
    meaning:
      "đâm chém để giết nhau (nói khái quát): cảnh chém giết trong phim ảnh",
    example: "cảnh chém giết trong phim ảnh",
  },
  {
    word: "chém to kho mặn",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) ví lối làm việc hoặc ăn nói quá đơn giản, thô kệch, chỉ chú trọng về thực chất mà coi nhẹ sự khéo léo, tế nhị về hình thức bên ngoài: quen thói chém to kho mặn",
    example: "quen thói chém to kho mặn",
  },
  {
    word: "chém",
    part_of_speech: "động từ",
    meaning:
      "làm cho đứt bằng cách bổ mạnh lưỡi gươm, lưỡi dao vào: chém đầu * chém tre, đẵn gỗ",
    example: "chém đầu * chém tre, đẵn gỗ",
  },
  {
    word: "chém",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) lợi dụng tình thế của người mua để bán với giá quá đắt, giá cắt cổ: chỉ đáng mười nghìn mà chúng chém tới hai mươi nghìn",
    example: "chỉ đáng mười nghìn mà chúng chém tới hai mươi nghìn",
  },
  {
    word: "chèn",
    part_of_speech: "động từ",
    meaning:
      "đưa thêm một vật gì đó vào khe hở để giữ chặt lại ở một vị trí cố định: chèn bánh xe * chèn cửa cẩn thận",
    example: "chèn bánh xe * chèn cửa cẩn thận",
  },
  {
    word: "chèn",
    part_of_speech: "động từ",
    meaning:
      "cản lại, ngáng lại, không cho vượt lên: xe trước chèn không cho xe sau vượt lên * cầu thủ chèn bóng trái phép",
    example:
      "xe trước chèn không cho xe sau vượt lên * cầu thủ chèn bóng trái phép",
  },
  {
    word: "chèn",
    part_of_speech: "động từ",
    meaning:
      "đưa thêm kí tự hoặc hình ảnh xen vào một vị trí nào đó của văn bản được soạn thảo trên máy tính: chèn thêm một vài kí tự vào giữa văn bản * chèn hình ảnh vào cuối trang",
    example:
      "chèn thêm một vài kí tự vào giữa văn bản * chèn hình ảnh vào cuối trang",
  },
  {
    word: "chèn",
    part_of_speech: "danh từ",
    meaning:
      "vật dùng để chèn bánh xe, thường làm bằng gỗ, hình trụ, đáy tam giác: chuẩn bị sẵn chèn khi xe lên dốc",
    example: "chuẩn bị sẵn chèn khi xe lên dốc",
  },
  {
    word: "chén",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng để uống nước, uống rượu, thường bằng sành, sứ, nhỏ và sâu lòng: bộ ấm chén * chén rượu nhạt",
    example: "bộ ấm chén * chén rượu nhạt",
  },
  {
    word: "chén",
    part_of_speech: "danh từ",
    meaning: "(Nam) bát nhỏ, thường dùng để ăn cơm: chén cơm",
    example: "chén cơm",
  },
  {
    word: "chén",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) thang (thuốc đông y): cân một chén thuốc bổ",
    example: "cân một chén thuốc bổ",
  },
  {
    word: "chén",
    part_of_speech: "động từ",
    meaning: "(thông tục) ăn, về mặt coi như một thú vui: chén một bữa no nê",
    example: "chén một bữa no nê",
  },
  {
    word: "chen",
    part_of_speech: "động từ",
    meaning:
      "lách giữa đám đông để chiếm chỗ, chiếm lối đi: đông quá không chen vào nổi * chen nhau vào mua hàng * chen lên phía trước",
    example:
      "đông quá không chen vào nổi * chen nhau vào mua hàng * chen lên phía trước",
  },
  {
    word: "chen",
    part_of_speech: "động từ",
    meaning:
      'xen lẫn vào: nói chen vào một câu * "Trong đầm gì đẹp bằng sen, Lá xanh bông trắng lại chen nhị vàng." (ca dao)',
    example:
      'nói chen vào một câu * "Trong đầm gì đẹp bằng sen, Lá xanh bông trắng lại chen nhị vàng." (ca dao)',
  },
  {
    word: "chém vè",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) ẩn mình dưới nước hoặc những nơi lùm bụi rậm rạp gần bờ nước để trốn (chỉ nói về người): chém vè ngoài ruộng lúa",
    example: "chém vè ngoài ruộng lúa",
  },
  {
    word: "chen chân",
    part_of_speech: "động từ",
    meaning: "chen vào để đứng, để chiếm chỗ: người đông, chen chân không lọt",
    example: "người đông, chen chân không lọt",
  },
  {
    word: "chẽn",
    part_of_speech: "tính từ",
    meaning: "(kiểu quần áo) ngắn và ôm bó sát người: quần chẽn * áo may chẽn",
    example: "quần chẽn * áo may chẽn",
  },
  {
    word: "chen chúc",
    part_of_speech: "động từ",
    meaning:
      "chen nhau một cách lộn xộn: đám đông chen chúc xô đẩy nhau * nhà cửa chen chúc nhau mọc lên",
    example: "đám đông chen chúc xô đẩy nhau * nhà cửa chen chúc nhau mọc lên",
  },
  {
    word: "chén chú chén anh",
    part_of_speech: "",
    meaning:
      '(khẩu ngữ) ăn uống, chè chén thân mật với nhau: "Có tiền chén chú chén anh, Hết tiền đủng đỉnh ra tình không vui." (ca dao)',
    example:
      'Có tiền chén chú chén anh, Hết tiền đủng đỉnh ra tình không vui." (ca dao)',
  },
  {
    word: "chen lấn",
    part_of_speech: "động từ",
    meaning:
      "dùng sức chen để chiếm chỗ, chiếm lối: đi theo hàng, không được chen lấn, xô đẩy",
    example: "đi theo hàng, không được chen lấn, xô đẩy",
  },
  {
    word: "chèn ép",
    part_of_speech: "động từ",
    meaning:
      "lấn át, kìm hãm không cho phát triển: hàng ngoại chèn ép hàng nội * chèn ép nhân viên cấp dưới",
    example: "hàng ngoại chèn ép hàng nội * chèn ép nhân viên cấp dưới",
  },
  {
    word: "chẹn",
    part_of_speech: "danh từ",
    meaning: "nhánh của bông lúa: chẹn lúa",
    example: "chẹn lúa",
  },
  {
    word: "chẹn",
    part_of_speech: "động từ",
    meaning:
      "đè nặng hoặc chặn ngang làm cho nghẹt, cho tắc lại: đất đá chẹn mất cửa hang * chẹn khuỷu tay lên cổ làm cho không thở được",
    example:
      "đất đá chẹn mất cửa hang * chẹn khuỷu tay lên cổ làm cho không thở được",
  },
  {
    word: "chen vai thích cánh",
    part_of_speech: "",
    meaning:
      "đua sức với nhau để cùng làm việc gì: chen vai thích cánh với đời",
    example: "chen vai thích cánh với đời",
  },
  {
    word: "chén quỳnh",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) chén rượu ngon: "Đầy vơi chúc một chén quỳnh, Vì duyên duyên uống, vì tình tình say." (ca dao)',
    example:
      'Đầy vơi chúc một chén quỳnh, Vì duyên duyên uống, vì tình tình say." (ca dao)',
  },
  {
    word: "chèo",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ dùng để bơi thuyền, là một thanh dài, đầu trên tròn, có tay nắm, đầu dưới dẹp và rộng bản: buông dầm, cầm chèo * gác chèo lên mạn thuyền",
    example: "buông dầm, cầm chèo * gác chèo lên mạn thuyền",
  },
  {
    word: "chèo",
    part_of_speech: "động từ",
    meaning: "gạt nước bằng mái chèo làm cho thuyền di chuyển: chèo thuyền",
    example: "chèo thuyền",
  },
  {
    word: "chèo",
    part_of_speech: "danh từ",
    meaning:
      "kịch hát dân gian cổ truyền, làn điệu bắt nguồn từ dân ca Bắc Bộ: hát chèo",
    example: "hát chèo",
  },
  {
    word: "chén tạc chén thù",
    part_of_speech: "",
    meaning:
      '(cũ) cùng nhau uống rượu một cách thân mật, vui vẻ: "Vợ chồng chén tạc chén thù, Bắt nàng đứng chực trì hồ hai nơi." (TKiều)',
    example:
      'Vợ chồng chén tạc chén thù, Bắt nàng đứng chực trì hồ hai nơi." (TKiều)',
  },
  {
    word: "chéo",
    part_of_speech: "tính từ",
    meaning:
      "thành hình một đường xiên: cắt chéo tờ giấy * đập chéo bóng * hạt mưa bay chéo",
    example: "cắt chéo tờ giấy * đập chéo bóng * hạt mưa bay chéo",
  },
  {
    word: "chéo",
    part_of_speech: "tính từ",
    meaning:
      "thành hình những đường xiên cắt nhau: đan chéo vào nhau * bắn chéo cánh sẻ",
    example: "đan chéo vào nhau * bắn chéo cánh sẻ",
  },
  {
    word: "chéo",
    part_of_speech: "danh từ",
    meaning:
      "hàng dệt trên mặt có những đường xiên từ biên bên này sang biên bên kia: vải chéo * lụa chéo",
    example: "vải chéo * lụa chéo",
  },
  {
    word: "chéo",
    part_of_speech: "danh từ",
    meaning:
      "phần hoặc mảnh nhỏ giới hạn bởi hai cạnh của một góc và một đường chéo: mảnh ruộng chéo",
    example: "mảnh ruộng chéo",
  },
  {
    word: "cheo",
    part_of_speech: "danh từ",
    meaning:
      "thú giống hươu nhưng cỡ rất nhỏ, chạy nhanh, tính nhát: nhát như cheo",
    example: "nhát như cheo",
  },
  {
    word: "cheo",
    part_of_speech: "danh từ",
    meaning:
      "khoản tiền hay hiện vật mà người con trai phải nộp cho làng của người con gái khi cưới, theo tục lệ cũ: tục nộp cheo ngày cưới * tiền cheo",
    example: "tục nộp cheo ngày cưới * tiền cheo",
  },
  {
    word: "chèo kéo",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) cố níu lại mời mọc cho bằng được: chèo kéo khách hàng",
    example: "chèo kéo khách hàng",
  },
  {
    word: "cheo chéo",
    part_of_speech: "tính từ",
    meaning: "hơi chéo: mưa bay cheo chéo",
    example: "mưa bay cheo chéo",
  },
  {
    word: "chèo chống",
    part_of_speech: "động từ",
    meaning:
      "chèo và chống để đưa thuyền bè đi (nói khái quát): chèo chống mãi mới đưa được thuyền vào bờ",
    example: "chèo chống mãi mới đưa được thuyền vào bờ",
  },
  {
    word: "chèo chống",
    part_of_speech: "động từ",
    meaning: "xoay xở, đối phó với các khó khăn: một mình chèo chống nuôi con",
    example: "một mình chèo chống nuôi con",
  },
  {
    word: "chèo chẹo",
    part_of_speech: "tính từ",
    meaning:
      "(đòi điều gì) rất dai, cho kì được, gây cảm giác khó chịu (thường nói về trẻ con): đứa bé đòi ăn chèo chẹo * khóc chèo chẹo",
    example: "đứa bé đòi ăn chèo chẹo * khóc chèo chẹo",
  },
  {
    word: "chèo lái",
    part_of_speech: "danh từ",
    meaning:
      "mái chèo ở phía sau thuyền dùng để lái; phân biệt với chèo mũi: cầm chèo lái",
    example: "cầm chèo lái",
  },
  {
    word: "chèo lái",
    part_of_speech: "động từ",
    meaning: "điều khiển thuyền bằng chèo lái; phân biệt với chèo mũi.",
    example: "vững tay chèo lái trong gió bão",
  },
  {
    word: "chèo lái",
    part_of_speech: "động từ",
    meaning:
      "chèo và lái để đưa thuyền đi (nói khái quát): vững tay chèo lái trong gió bão",
    example: "một mình chèo lái giữa thương trường",
  },
  {
    word: "cheo leo",
    part_of_speech: "tính từ",
    meaning:
      'cao và không có chỗ bấu víu, gây cảm giác nguy hiểm, dễ bị rơi, ngã: vách đá cheo leo * "Ghé mắt trông ngang thấy bảng treo, Kìa đền Thái Thú đứng cheo leo." (HXHương; 13)',
    example:
      'vách đá cheo leo * "Ghé mắt trông ngang thấy bảng treo, Kìa đền Thái Thú đứng cheo leo." (HXHương; 13)',
  },
  {
    word: "chèo queo",
    part_of_speech: "tính từ",
    meaning: "(lối nằm) nghiêng và co người lại: nằm chèo queo một góc",
    example: "nằm chèo queo một góc",
  },
  {
    word: "chép miệng",
    part_of_speech: "động từ",
    meaning:
      "ngậm miệng lại rồi mở ra, tạo thành tiếng kêu khẽ thường để tỏ ý tiếc hoặc than phiền điều gì: chép miệng ra vẻ tiếc rẻ * chép miệng khen ngon",
    example: "chép miệng ra vẻ tiếc rẻ * chép miệng khen ngon",
  },
  {
    word: "chẹt",
    part_of_speech: "động từ",
    meaning:
      "làm cho nghẹt, cho tắc lại bằng cách bóp chặt hoặc ép chặt từ một phía nào đó: chẹt lấy cổ * cây đổ chẹt lối đi * bóp chẹt",
    example: "chẹt lấy cổ * cây đổ chẹt lối đi * bóp chẹt",
  },
  {
    word: "chẹt",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) (xe cộ) cán, đè lên: ô tô chẹt chết người",
    example: "ô tô chẹt chết người",
  },
  {
    word: "chét",
    part_of_speech: "danh từ",
    meaning:
      "lượng vừa nắm gọn trong vòng hai bàn tay: một chét lúa * con gà vừa một chét tay",
    example: "một chét lúa * con gà vừa một chét tay",
  },
  {
    word: "chép",
    part_of_speech: "động từ",
    meaning:
      "viết lại theo bản có sẵn: chép bài tập vào vở * chép những câu thơ hay vào sổ tay",
    example: "chép bài tập vào vở * chép những câu thơ hay vào sổ tay",
  },
  {
    word: "chép",
    part_of_speech: "động từ",
    meaning: "ghi ra thành văn bản: nghe xong rồi chép ra giấy * nhà chép sử",
    example: "nghe xong rồi chép ra giấy * nhà chép sử",
  },
  {
    word: "chép",
    part_of_speech: "động từ",
    meaning:
      "(học sinh làm bài) viết lại y nguyên bài làm của người khác, một cách gian lận: chép bài của bạn",
    example: "chép bài của bạn",
  },
  {
    word: "cheo veo",
    part_of_speech: "tính từ",
    meaning: "trơ trọi ở trên cao: cheo veo trên đỉnh núi * cheo veo dốc đá",
    example: "cheo veo trên đỉnh núi * cheo veo dốc đá",
  },
  {
    word: "chê",
    part_of_speech: "động từ",
    meaning:
      "tỏ ra không thích, không vừa ý vì cho là kém, là xấu: chê ít không lấy * lợn chê cám (bỏ cám không ăn vì ốm) * cao chê ngỏng, thấp chê lùn (tng)",
    example:
      "chê ít không lấy * lợn chê cám (bỏ cám không ăn vì ốm) * cao chê ngỏng, thấp chê lùn (tng)",
  },
  {
    word: "chế",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ) tang: để chế",
    example: "để chế",
  },
  {
    word: "chế",
    part_of_speech: "động từ",
    meaning:
      "dùng lời nói trêu chọc làm cho người ta xấu hổ, thường để vui cười: bài vè chế anh chàng sợ vợ * chế thói tham ăn",
    example: "bài vè chế anh chàng sợ vợ * chế thói tham ăn",
  },
  {
    word: "chế",
    part_of_speech: "động từ",
    meaning: "làm ra một chất mới nào đó: chế thuốc * xưởng chế dầu",
    example: "chế thuốc * xưởng chế dầu",
  },
  {
    word: "chế",
    part_of_speech: "động từ",
    meaning: "(Khẩu ngữ) chế tạo (nói tắt): chế vũ khí",
    example: "chế vũ khí",
  },
  {
    word: "chế",
    part_of_speech: "động từ",
    meaning:
      "(Phương ngữ) rót vào để cho phát huy tác dụng: chế nước sôi vào ấm trà",
    example: "chế nước sôi vào ấm trà",
  },
  {
    word: "chế áp",
    part_of_speech: "động từ",
    meaning:
      "kìm hãm, ngăn giữ, khiến đối phương không thể tự do hoạt động: chế áp địch",
    example: "chế áp địch",
  },
  {
    word: "chế bản",
    part_of_speech: "động từ",
    meaning:
      "chuyển nội dung văn bản trên máy tính thành bản trình bày theo yêu cầu nhất định để đem in: phần mềm chế bản * chế bản quyển từ điển",
    example: "phần mềm chế bản * chế bản quyển từ điển",
  },
  {
    word: "chế bản",
    part_of_speech: "danh từ",
    meaning:
      "văn bản đã được trình bày trên máy tính để đem in: làm xong chế bản * chế bản không đạt yêu cầu",
    example: "làm xong chế bản * chế bản không đạt yêu cầu",
  },
  {
    word: "chế biến",
    part_of_speech: "động từ",
    meaning:
      "làm cho biến đổi thành chất có thể dùng được hoặc dùng tốt hơn: chế biến thức ăn * dây chuyền chế biến gỗ",
    example: "chế biến thức ăn * dây chuyền chế biến gỗ",
  },
  {
    word: "chế định",
    part_of_speech: "động từ",
    meaning:
      "đặt ra, quy định thành thể lệ, chế độ: quyền hoạt động của các doanh nghiệp đã được nhà nước chế định thành luật",
    example:
      "quyền hoạt động của các doanh nghiệp đã được nhà nước chế định thành luật",
  },
  {
    word: "chế định",
    part_of_speech: "danh từ",
    meaning: "như định chế: quyền sở hữu là một chế định của luật dân sự",
    example: "quyền sở hữu là một chế định của luật dân sự",
  },
  {
    word: "chê bai",
    part_of_speech: "động từ",
    meaning:
      "tỏ lời chê (nói khái quát): chê bai hết người nọ đến người kia * lên tiếng chê bai",
    example: "chê bai hết người nọ đến người kia * lên tiếng chê bai",
  },
  {
    word: "chê cười",
    part_of_speech: "động từ",
    meaning: "chê và tỏ ý chế nhạo (nói khái quát): bị thiên hạ chê cười",
    example: "bị thiên hạ chê cười",
  },
  {
    word: "chế độ",
    part_of_speech: "danh từ",
    meaning:
      "chỉnh thể chính trị, kinh tế, văn hoá hình thành trong những điều kiện lịch sử nhất định: Pháp là một nhà nước theo chế độ cộng hoà",
    example: "Pháp là một nhà nước theo chế độ cộng hoà",
  },
  {
    word: "chế độ",
    part_of_speech: "danh từ",
    meaning:
      "những điều quy định cần tuân theo trong một việc nào đó: chế độ trợ cấp thôi việc",
    example: "chế độ trợ cấp thôi việc",
  },
  {
    word: "chế ngự",
    part_of_speech: "động từ",
    meaning:
      "ngăn chặn, kiềm chế nhằm hạn chế những tác hại hoặc bắt phải phục tùng: chế ngự thiên nhiên * chế ngự cơn nóng giận",
    example: "chế ngự thiên nhiên * chế ngự cơn nóng giận",
  },
  {
    word: "chế giễu",
    part_of_speech: "động từ",
    meaning:
      "nêu thành trò cười nhằm chỉ trích, phê phán: chế giễu những thói hư, tật xấu * bị bạn bè chế giễu",
    example: "chế giễu những thói hư, tật xấu * bị bạn bè chế giễu",
  },
  {
    word: "chế nhạo",
    part_of_speech: "động từ",
    meaning:
      "nêu thành trò cười để tỏ ý mỉa mai, coi thường: những tiếng cười chế nhạo",
    example: "những tiếng cười chế nhạo",
  },
  {
    word: "chế phẩm",
    part_of_speech: "danh từ",
    meaning: "sản phẩm được chế tạo ra: các chế phẩm được lấy từ dầu mỏ",
    example: "các chế phẩm được lấy từ dầu mỏ",
  },
  {
    word: "chê ỏng chê eo",
    part_of_speech: "động từ",
    meaning:
      '(khẩu ngữ) chê hết điều nọ đến điều kia một cách khó tính: "Tiền bạc đựng nứt ví, nhưng mua gì cũng chê ỏng chê eo, trả giá rẻ mạt." (ĐGiỏi; 4)',
    example:
      'Tiền bạc đựng nứt ví, nhưng mua gì cũng chê ỏng chê eo, trả giá rẻ mạt." (ĐGiỏi; 4)',
  },
  {
    word: "chế tạo",
    part_of_speech: "động từ",
    meaning:
      "sử dụng nguyên vật liệu tạo ra sản phẩm máy móc hoặc linh kiện máy móc: chế tạo linh kiện bán dẫn * hãng chế tạo máy bay",
    example: "chế tạo linh kiện bán dẫn * hãng chế tạo máy bay",
  },
  {
    word: "chê trách",
    part_of_speech: "động từ",
    meaning:
      "chê và tỏ ý trách vì không được hài lòng (nói khái quát): một hành động đáng bị chê trách",
    example: "một hành động đáng bị chê trách",
  },
  {
    word: "chế tạo máy",
    part_of_speech: "danh từ",
    meaning:
      "tổng hợp các ngành công nghiệp nặng chế tạo máy móc: tốt nghiệp kĩ sư ngành chế tạo máy",
    example: "tốt nghiệp kĩ sư ngành chế tạo máy",
  },
  {
    word: "chế tác",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) sử dụng nguyên vật liệu và sức sáng tạo để làm ra (thường là sản phẩm tinh xảo, rất quý giá): nghệ thuật chế tác kim hoàn * chế tác lễ nhạc",
    example: "nghệ thuật chế tác kim hoàn * chế tác lễ nhạc",
  },
  {
    word: "chế xuất",
    part_of_speech: "động từ",
    meaning:
      "chuyên sản xuất, chế tạo hàng hoá để xuất khẩu: khu chế xuất * doanh nghiệp chế xuất",
    example: "khu chế xuất * doanh nghiệp chế xuất",
  },
  {
    word: "chệch",
    part_of_speech: "tính từ",
    meaning:
      "không đúng ở vị trí phải có hoặc không đúng với hướng phải nhằm tới: bắn chệch mục tiêu * đọc chệch",
    example: "bắn chệch mục tiêu * đọc chệch",
  },
  {
    word: "chệch choạc",
    part_of_speech: "tính từ",
    meaning:
      "không đồng đều và không ăn khớp với nhau: các khâu phối hợp còn chệch choạc * hàng ngũ chệch choạc",
    example: "các khâu phối hợp còn chệch choạc * hàng ngũ chệch choạc",
  },
  {
    word: "chêm",
    part_of_speech: "động từ",
    meaning:
      "làm cho chặt bằng cách cho thêm những mảnh nhỏ và cứng vào khe hở: chêm cán cuốc",
    example: "chêm cán cuốc",
  },
  {
    word: "chêm",
    part_of_speech: "động từ",
    meaning: "nói xen vào: thỉnh thoảng lại chêm vào một câu",
    example: "thỉnh thoảng lại chêm vào một câu",
  },
  {
    word: "chêm",
    part_of_speech: "danh từ",
    meaning:
      "vật cứng, nhỏ, dùng để chêm vào chỗ hở cho chặt: đặt chêm * tháo chêm",
    example: "đặt chêm * tháo chêm",
  },
  {
    word: "chếch",
    part_of_speech: "tính từ",
    meaning:
      'xiên, lệch đi chút ít so với hướng thẳng: nhìn chếch về bên trái * "Bóng nắng nghiêng nghiêng rọi chếch xuống chỗ tôi ngồi." (ĐGiỏi; 4)',
    example:
      'nhìn chếch về bên trái * "Bóng nắng nghiêng nghiêng rọi chếch xuống chỗ tôi ngồi." (ĐGiỏi; 4)',
  },
  {
    word: "chễm chệ",
    part_of_speech: "tính từ",
    meaning: "từ gợi tả dáng ngồi nghiêm trang, bệ vệ: ngồi chễm chệ trên sập",
    example: "ngồi chễm chệ trên sập",
  },
  {
    word: "chệnh choạng",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái mất thăng bằng, lúc nghiêng bên này, lúc ngả sang bên kia: tay lái chệnh choạng * đi chệnh choạng như người say",
    example: "tay lái chệnh choạng * đi chệnh choạng như người say",
  },
  {
    word: "chếnh choáng",
    part_of_speech: "tính từ",
    meaning:
      "hơi choáng váng, chóng mặt, như khi ngà ngà say rượu: hơi men chếnh choáng",
    example: "hơi men chếnh choáng",
  },
  {
    word: "chênh chếch",
    part_of_speech: "tính từ",
    meaning:
      'hơi chếch về một phía: "Gương nga chênh chếch dòm song, Vàng gieo ngấn nước, cây lồng bóng sân." (TKiều)',
    example:
      'Gương nga chênh chếch dòm song, Vàng gieo ngấn nước, cây lồng bóng sân." (TKiều)',
  },
  {
    word: "chểnh mảng",
    part_of_speech: "",
    meaning:
      'không để tâm thường xuyên đến công việc thuộc phận sự của mình: làm ăn chểnh mảng * "Xưa kia ngọc ở tay ta, Bởi ta chểnh mảng ngọc ra tay người." (Cdao)',
    example:
      'làm ăn chểnh mảng * "Xưa kia ngọc ở tay ta, Bởi ta chểnh mảng ngọc ra tay người." (Cdao)',
  },
  {
    word: "chềnh ềnh",
    part_of_speech: "tính từ",
    meaning: "như chình ình: nằm chềnh ềnh ngay cửa ra vào",
    example: "nằm chềnh ềnh ngay cửa ra vào",
  },
  {
    word: "chênh lệch",
    part_of_speech: "tính từ",
    meaning:
      "cao thấp khác nhau, không bằng nhau, không ngang nhau (nói khái quát): tuổi tác chênh lệch * giá cả chênh lệch",
    example: "tuổi tác chênh lệch * giá cả chênh lệch",
  },
  {
    word: "chênh",
    part_of_speech: "tính từ",
    meaning:
      "có một bên cao, một bên thấp, nằm nghiêng sang một bên so với vị trí bình thường trên một mặt bằng: tủ kê bị chênh",
    example: "tủ kê bị chênh",
  },
  {
    word: "chênh",
    part_of_speech: "tính từ",
    meaning:
      "cao thấp khác nhau, không bằng nhau, không ngang nhau: chênh nhau vài tuổi * lực lượng hai bên chênh nhau nhiều",
    example: "chênh nhau vài tuổi * lực lượng hai bên chênh nhau nhiều",
  },
  {
    word: "chênh vênh",
    part_of_speech: "tính từ",
    meaning:
      "ở vị trí cao mà không có chỗ dựa chắc chắn, gây cảm giác trơ trọi, thiếu vững chãi: đứng chênh vênh trên mỏm đá * nhịp cầu chênh vênh",
    example: "đứng chênh vênh trên mỏm đá * nhịp cầu chênh vênh",
  },
  {
    word: "chết",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) đến mức rất cao, như không thể hơn được nữa: chán chết * người ta cười chết!",
    example: "chán chết * người ta cười chết!",
  },
  {
    word: "chết",
    part_of_speech: "cảm từ",
    meaning:
      "tiếng thốt ra biểu thị sự lo lắng, sửng sốt: chết, sao lại làm thế! * chết, trời đã sáng rồi kia à?",
    example: "chết, sao lại làm thế! * chết, trời đã sáng rồi kia à?",
  },
  {
    word: "chết chưa",
    part_of_speech: "cảm từ",
    meaning:
      "tiếng thốt ra biểu thị thái độ sửng sốt, lo lắng khi bất ngờ nhận ra một việc có thể ảnh hưởng không tốt cho mình hoặc cho ai, cho việc gì: chết chưa! đã 12 giờ rồi à?",
    example: "chết chưa! đã 12 giờ rồi à?",
  },
  {
    word: "chết chưa",
    part_of_speech: "cảm từ",
    meaning:
      "(khẩu ngữ) đáng đời chưa (dùng với ý giễu cợt, mỉa mai): chết chưa, đã bảo rồi lại không nghe!",
    example: "chết chưa, đã bảo rồi lại không nghe!",
  },
  {
    word: "chết chẹt",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) lâm vào tình thế mắc kẹt ở giữa, không thể có lối thoát: chết chẹt giữa hai gọng kìm",
    example: "chết chẹt giữa hai gọng kìm",
  },
  {
    word: "chết chửa",
    part_of_speech: "cảm từ",
    meaning:
      "(phương ngữ) như chết chưa (nhưng ý nhấn mạnh hơn): chết chửa, sao mày lại làm thế?",
    example: "chết chửa, sao mày lại làm thế?",
  },
  {
    word: "chết cha",
    part_of_speech: "",
    meaning: "(thông tục) như bỏ mẹ: chết cha, sao lại làm như thế nhỉ!",
    example: "chết cha, sao lại làm như thế nhỉ!",
  },
  {
    word: "chết dở",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) lâm vào tình thế gay go khiến cho rất khó xoay xở, khó tìm ra lối thoát: chết dở vì lạc đường",
    example: "chết dở vì lạc đường",
  },
  {
    word: "chết chóc",
    part_of_speech: "động từ",
    meaning:
      "chết nhiều và tàn khốc (nói về người; nói khái quát): cảnh chết chóc * chiến tranh gây chết chóc đau thương",
    example: "cảnh chết chóc * chiến tranh gây chết chóc đau thương",
  },
  {
    word: "chết đầu nước",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) bị thất bại, gục ngã đầu tiên, sớm nhất, ngay từ khi mới bắt đầu hành động: nếu có chuyện gì thì mình sẽ chết đầu nước!",
    example: "nếu có chuyện gì thì mình sẽ chết đầu nước!",
  },
  {
    word: "chết điếng",
    part_of_speech: "động từ",
    meaning:
      "lặng người đi vì bị một tác động quá đau đớn, quá bất ngờ: nghe tin dữ, chết điếng cả người * ngồi chết điếng",
    example: "nghe tin dữ, chết điếng cả người * ngồi chết điếng",
  },
  {
    word: "chết gí",
    part_of_speech: "động từ",
    meaning:
      "(cây cỏ) chết vì bị đè chặn, không thể mọc lên nổi: cỏ bị chết gí trong bùn",
    example: "cỏ bị chết gí trong bùn",
  },
  {
    word: "chết gí",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) ở vào tình trạng phải ở yên một chỗ, không hoạt động gì được: trời mưa, phải nằm chết gí ở nhà * xe hỏng máy, nằm chết gí giữa đường",
    example:
      "trời mưa, phải nằm chết gí ở nhà * xe hỏng máy, nằm chết gí giữa đường",
  },
  {
    word: "chết giấc",
    part_of_speech: "động từ",
    meaning:
      "ngất đi vì quá đau, quá mệt hoặc bị xúc động mạnh: sợ chết giấc * nghe tin dữ, ngã lăn ra chết giấc",
    example: "sợ chết giấc * nghe tin dữ, ngã lăn ra chết giấc",
  },
  {
    word: "chết giẫm",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) chết mà chẳng ai thèm đoái hoài (thường chỉ dùng làm tiếng chửi mắng): đồ chết giẫm!",
    example: "đồ chết giẫm!",
  },
  {
    word: "chết mệt",
    part_of_speech: "động từ",
    meaning:
      'say đắm đến mức như không còn biết gì nữa: chết mệt cô bé hàng xóm * "Chim khôn chết mệt vì mồi, Người khôn chết mệt vì lời nhỏ to." (ca dao)',
    example:
      'chết mệt cô bé hàng xóm * "Chim khôn chết mệt vì mồi, Người khôn chết mệt vì lời nhỏ to." (ca dao)',
  },
  {
    word: "chết mệt",
    part_of_speech: "tính từ",
    meaning:
      "mệt đến mức tưởng như có thể chết đi được: chết mệt vì đống quần áo bẩn",
    example: "chết mệt vì đống quần áo bẩn",
  },
  {
    word: "chết mê chết mệt",
    part_of_speech: "",
    meaning:
      "như chết mệt (nhưng nghĩa mạnh hơn): chết mê chết mệt chàng trai hàng xóm",
    example: "chết mê chết mệt chàng trai hàng xóm",
  },
  {
    word: "chết như ngả rạ",
    part_of_speech: "",
    meaning:
      "chết hàng loạt, xác nằm ngổn ngang, la liệt khắp mặt đất: gặp nạn đói, người chết như ngả rạ",
    example: "gặp nạn đói, người chết như ngả rạ",
  },
  {
    word: "chết rấp",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) chết vùi thây đi (thường dùng làm tiếng chửi rủa): đồ chết rấp!",
    example: "đồ chết rấp!",
  },
  {
    word: "chết nỗi",
    part_of_speech: "cảm từ",
    meaning:
      "tổ hợp biểu thị ý ngạc nhiên, lo lắng, thông cảm hoặc phân trần, v.v.: chết nỗi! sao nó hư thế! * chết nỗi, thế mà tôi không biết",
    example: "chết nỗi! sao nó hư thế! * chết nỗi, thế mà tôi không biết",
  },
  {
    word: "chết xác",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) cực nhọc, kiệt sức đến mức thể xác như không thể chịu hơn được nữa: mệt chết xác",
    example: "mệt chết xác",
  },
  {
    word: "chết tươi",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) chết ngay lập tức, một cách hết sức đột ngột: bị sét đánh chết tươi",
    example: "bị sét đánh chết tươi",
  },
  {
    word: "chết tiệt",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) chết sạch, không còn sót một người nào; thường dùng để nguyền rủa: đồ chết tiệt! * chiếc xe chết tiệt, hơi một tí là hỏng!",
    example: "đồ chết tiệt! * chiếc xe chết tiệt, hơi một tí là hỏng!",
  },
  {
    word: "chết yểu",
    part_of_speech: "động từ",
    meaning:
      "chết lúc còn bé, còn trẻ (thường do ốm yếu, bệnh tật): tướng người chết yểu",
    example: "tướng người chết yểu",
  },
  {
    word: "chết tốt",
    part_of_speech: "động từ",
    meaning:
      '(phương ngữ, khẩu ngữ) chết ngay lập tức: "Chú coi cây này ngon không! Thằng nào cả gan thò đầu vô, tôi xáng cho một cây là chết tốt!" (AĐức; 16)',
    example:
      'Chú coi cây này ngon không! Thằng nào cả gan thò đầu vô, tôi xáng cho một cây là chết tốt!" (AĐức; 16)',
  },
  {
    word: "chết thật",
    part_of_speech: "cảm từ",
    meaning:
      "(khẩu ngữ) như chết (nhưng nghĩa mạnh hơn): chết thật, sao nó lại hư đốn thế?",
    example: "chết thật, sao nó lại hư đốn thế?",
  },
  {
    word: "chết trôi",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) chết đuối: mặt trắng bệch như người chết trôi",
    example: "mặt trắng bệch như người chết trôi",
  },
  {
    word: "chỉ",
    part_of_speech: "danh từ",
    meaning:
      "dây bằng sợi xe chặt, dài và mảnh, dùng để khâu, thêu, may vá: mảnh như sợi chỉ * vết thương đã cắt chỉ",
    example: "mảnh như sợi chỉ * vết thương đã cắt chỉ",
  },
  {
    word: "chỉ",
    part_of_speech: "danh từ",
    meaning:
      "sợi ngang trên khung cửi hoặc máy dệt; phân biệt với sợi dọc, gọi là canh: canh tơ chỉ vải",
    example: "canh tơ chỉ vải",
  },
  {
    word: "chỉ",
    part_of_speech: "danh từ",
    meaning: "(cũ, xưa) lệnh bằng văn bản của vua, chúa: vua giáng chỉ",
    example: "vua giáng chỉ",
  },
  {
    word: "chỉ",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) đồng cân (vàng): chiếc nhẫn vàng hai chỉ",
    example: "chiếc nhẫn vàng hai chỉ",
  },
  {
    word: "chỉ",
    part_of_speech: "đại từ",
    meaning: "(Nam, khẩu ngữ) chị ấy: Chừng nào chỉ về? Xem thêm ảnh, bả, ổng",
    example: "Chừng nào chỉ về?",
  },
  {
    word: "chỉ",
    part_of_speech: "động từ",
    meaning:
      "làm cho người ta nhìn thấy, nhận ra cái gì, bằng cách hướng tay hoặc vật dùng làm hiệu về phía cái ấy: công an chỉ đường * mũi tên chỉ (về) hướng Nam * kim đồng hồ chỉ năm giờ",
    example:
      "công an chỉ đường * mũi tên chỉ (về) hướng Nam * kim đồng hồ chỉ năm giờ",
  },
  {
    word: "chỉ",
    part_of_speech: "động từ",
    meaning:
      "làm cho biết, cho thấy được điều cần biết để làm việc gì: chỉ rõ khuyết điểm trong công tác * chỉ cho cách làm ăn",
    example: "chỉ rõ khuyết điểm trong công tác * chỉ cho cách làm ăn",
  },
  {
    word: "chỉ",
    part_of_speech: "động từ",
    meaning: "nêu cho biết, biểu thị: nói bâng quơ, không nhằm chỉ vào ai",
    example: "nói bâng quơ, không nhằm chỉ vào ai",
  },
  {
    word: "chỉ",
    part_of_speech: "phụ từ",
    meaning:
      'từ biểu thị phạm vi được hạn định, không có gì, không có ai thêm nữa: chỉ lo cho bản thân * chỉ biết ăn, không biết làm * "Nhà anh chỉ có một gian, Nửa thì làm bếp, nửa toan làm buồng." (Cdao)',
    example:
      'chỉ lo cho bản thân * chỉ biết ăn, không biết làm * "Nhà anh chỉ có một gian, Nửa thì làm bếp, nửa toan làm buồng." (Cdao)',
  },
  {
    word: "chị",
    part_of_speech: "danh từ",
    meaning:
      "người phụ nữ cùng một thế hệ trong gia đình, trong họ, nhưng thuộc hàng hoặc vai trên, trong quan hệ với em của mình (có thể dùng để xưng gọi): chị ruột * chị dâu * người chị họ * chị ngã em nâng (tng)",
    example: "chị ruột * chị dâu * người chị họ * chị ngã em nâng (tng)",
  },
  {
    word: "chị",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ hoặc gọi người phụ nữ lớn tuổi hơn mình, coi như chị, hoặc để người phụ nữ tự xưng với người ít tuổi hơn, coi như em: chị bán hàng * chị cho tôi hỏi thăm...",
    example: "chị bán hàng * chị cho tôi hỏi thăm...",
  },
  {
    word: "chị",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để gọi người phụ nữ thuộc thế hệ sau mình một cách tôn trọng (theo cách gọi thay cho con của mình): chị ngồi chơi để tôi gọi em nó về",
    example: "chị ngồi chơi để tôi gọi em nó về",
  },
  {
    word: "chi",
    part_of_speech: "danh từ",
    meaning:
      "chân hoặc tay của động vật có xương sống: tứ chi * chi sau của loài ếch nhái phát triển hơn chi trước",
    example: "tứ chi * chi sau của loài ếch nhái phát triển hơn chi trước",
  },
  {
    word: "chi",
    part_of_speech: "danh từ",
    meaning: "ngành trong một họ: người cùng họ, nhưng khác chi",
    example: "người cùng họ, nhưng khác chi",
  },
  {
    word: "chi",
    part_of_speech: "danh từ",
    meaning: "đơn vị phân loại sinh học, dưới họ, trên loài",
    example: "một chi có 12 con giáp",
  },
  {
    word: "chi",
    part_of_speech: "động từ",
    meaning:
      "bỏ tiền ra dùng vào việc gì: chi tiền để mua sắm * kiểm tra tình hình thu, chi hằng tháng",
    example: "chi tiền để mua sắm * kiểm tra tình hình thu, chi hằng tháng",
  },
  {
    word: "chi",
    part_of_speech: "đại từ",
    meaning:
      '(phương ngữ hoặc khẩu ngữ) gì: không biết chi * "Duyên kia có phụ chi tình, Mà toan chia gánh chung tình làm hai?" (TKiều)',
    example:
      'không biết chi * "Duyên kia có phụ chi tình, Mà toan chia gánh chung tình làm hai?" (TKiều)',
  },
  {
    word: "chi bằng",
    part_of_speech: "",
    meaning:
      "tổ hợp biểu thị điều sắp nêu ra là việc nên làm hơn cả: sửa đi sửa lại, chi bằng đi mua cái mới * hỏi dò hỏi quanh, chi bằng cứ hỏi thẳng",
    example:
      "sửa đi sửa lại, chi bằng đi mua cái mới * hỏi dò hỏi quanh, chi bằng cứ hỏi thẳng",
  },
  {
    word: "chì",
    part_of_speech: "danh từ",
    meaning:
      "kim loại nặng màu xám xanh, mềm, dễ nóng chảy, khó bị ăn mòn, dùng để chế hợp kim, đúc ống dẫn nước, chữ in, v.v..",
    example: "mất cả chì lẫn chài (tng)",
  },
  {
    word: "chỉ bảo",
    part_of_speech: "động từ",
    meaning:
      "dạy bảo một cách cụ thể, tường tận (nói khái quát): lời chỉ bảo ân cần * chỉ bảo cách làm ăn",
    example: "lời chỉ bảo ân cần * chỉ bảo cách làm ăn",
  },
  {
    word: "chí",
    part_of_speech: "danh từ",
    meaning:
      "ý muốn bền bỉ nhằm theo đuổi một mục đích, một điều gì tốt đẹp: nuôi chí lớn * có chí làm giàu",
    example: "nuôi chí lớn * có chí làm giàu",
  },
  {
    word: "chí",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là điểm cuối cùng của phạm vi đang đề cập: đi từ Nam chí Bắc * từ cổ chí kim",
    example: "đi từ Nam chí Bắc * từ cổ chí kim",
  },
  {
    word: "chí",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị mức độ cao nhất, không còn có thể hơn: nói chí phải * sống chí tình chí nghĩa",
    example: "nói chí phải * sống chí tình chí nghĩa",
  },
  {
    word: "chị chàng",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) người phụ nữ còn trẻ (hàm ý coi thường hoặc bông đùa): chị chàng nhà quê",
    example: "chị chàng nhà quê",
  },
  {
    word: "chi chát",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như chí chát: tiếng búa nện chi chát",
    example: "tiếng búa nện chi chát",
  },
  {
    word: "chí chát",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng vật rắn nện nhiều lần vào một vật rắn khác, nghe đanh và chói tai: tiếng búa nện chí chát",
    example: "tiếng búa nện chí chát",
  },
  {
    word: "chi bộ",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức cơ sở của một chính đảng: các chi bộ trong đảng bộ nhà máy",
    example: "các chi bộ trong đảng bộ nhà máy",
  },
  {
    word: "chì chiết",
    part_of_speech: "động từ",
    meaning:
      "đay nghiến, dằn vặt một cách cay nghiệt làm người ta khó chịu: lên giọng chì chiết * tính hay chì chiết",
    example: "lên giọng chì chiết * tính hay chì chiết",
  },
  {
    word: "chí chết",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) (làm việc gì vất vả) đến mức như đã kiệt sức, không thể làm gì hơn được nữa: chạy chí chết mà vẫn không kịp * lo chí chết",
    example: "chạy chí chết mà vẫn không kịp * lo chí chết",
  },
  {
    word: "chi chít",
    part_of_speech: "tính từ",
    meaning:
      "(vật nhỏ) rất nhiều và cái này sít cái kia, hầu như không còn chỗ trống, chỗ hở: chữ viết chi chít * cành cây chi chít quả * bầu trời chi chít sao",
    example:
      "chữ viết chi chít * cành cây chi chít quả * bầu trời chi chít sao",
  },
  {
    word: "chí choé",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả tiếng loàI vật nhỏ hoặc trẻ con kêu la ồn ào, lộn xộn, nghe chói tai: chuột cắn nhau chí choé * bọn trẻ cãi nhau chí choé",
    example: "chuột cắn nhau chí choé * bọn trẻ cãi nhau chí choé",
  },
  {
    word: "chí công",
    part_of_speech: "tính từ",
    meaning:
      '(hiếm) công bằng, chính trực, không chút thiên vị: Thượng Đế chí công * "Đuốc vương giả chí công là thế, Chẳng soi cho đến khoé âm nhai." (CO)',
    example:
      'Thượng Đế chí công * "Đuốc vương giả chí công là thế, Chẳng soi cho đến khoé âm nhai." (CO)',
  },
  {
    word: "chí cốt",
    part_of_speech: "tính từ",
    meaning: "(bạn) rất gắn bó, thân thiết: bạn chí cốt",
    example: "bạn chí cốt",
  },
  {
    word: "chỉ dẫn",
    part_of_speech: "động từ",
    meaning:
      "bảo cho biết phương hướng, cách thức tiến hành công việc một cách cặn kẽ: được người lớn chỉ dẫn mọi điều",
    example: "được người lớn chỉ dẫn mọi điều",
  },
  {
    word: "chỉ dẫn",
    part_of_speech: "danh từ",
    meaning: "điều chỉ dẫn: uống thuốc theo đúng chỉ dẫn của bác sĩ",
    example: "uống thuốc theo đúng chỉ dẫn của bác sĩ",
  },
  {
    word: "chi cục",
    part_of_speech: "danh từ",
    meaning:
      "chi nhánh của cục hoặc tổng cục: chi cục thú y * chi cục thuế ở các quận, huyện",
    example: "chi cục thú y * chi cục thuế ở các quận, huyện",
  },
  {
    word: "chi dùng",
    part_of_speech: "động từ",
    meaning:
      "bỏ tiền ra dùng cho nhu cầu đời sống hằng ngày (nói khái quát): lương tháng không đủ để chi dùng",
    example: "lương tháng không đủ để chi dùng",
  },
  {
    word: "chỉ đạo",
    part_of_speech: "động từ",
    meaning:
      "hướng dẫn cụ thể, theo một đường lối, chủ trương nhất định: chỉ đạo công tác * trực tiếp chỉ đạo chiến đấu * ban chỉ đạo",
    example: "chỉ đạo công tác * trực tiếp chỉ đạo chiến đấu * ban chỉ đạo",
  },
  {
    word: "chỉ đâu đánh đó",
    part_of_speech: "",
    meaning:
      "bảo cái gì thì làm cái đấy một cách máy móc, không chủ động, không tự quyết định: thiên lôi chỉ đâu đánh đấy (tng)",
    example: "thiên lôi chỉ đâu đánh đấy (tng)",
  },
  {
    word: "chỉ đâu đánh đấy",
    part_of_speech: "",
    meaning:
      "bảo cái gì thì làm cái đấy một cách máy móc, không chủ động, không tự quyết định: thiên lôi chỉ đâu đánh đấy (tng)",
    example: "thiên lôi chỉ đâu đánh đấy (tng)",
  },
  {
    word: "chỉ định",
    part_of_speech: "động từ",
    meaning:
      "(cấp hoặc người có thẩm quyền) quyết định chọn, cử ra để làm việc gì: chỉ định người đi công tác * không ai xung phong thì phải chỉ định",
    example:
      "chỉ định người đi công tác * không ai xung phong thì phải chỉ định",
  },
  {
    word: "chỉ định",
    part_of_speech: "danh từ",
    meaning:
      "điều đã được chỉ định (để theo đó mà chấp hành): làm theo chỉ định của cấp trên",
    example: "làm theo chỉ định của cấp trên",
  },
  {
    word: "chỉ điểm",
    part_of_speech: "động từ",
    meaning:
      "chỉ, bảo cho biết mục tiêu, đối tượng (để bắt bớ, bắn phá): chỉ điểm cho giặc",
    example: "chỉ điểm cho giặc",
  },
  {
    word: "chỉ điểm",
    part_of_speech: "danh từ",
    meaning: "kẻ làm việc chỉ điểm: làm chỉ điểm",
    example: "làm chỉ điểm",
  },
  {
    word: "chi đoàn",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức cơ sở của đoàn thanh niên: chi đoàn cơ sở * bí thư chi đoàn",
    example: "chi đoàn cơ sở * bí thư chi đoàn",
  },
  {
    word: "chỉ được cái",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) chỉ có mặt sắp nêu ra là nổi bật, là đáng kể (thường hàm ý chê): chỉ được cái ăn là nhanh! * chỉ được cái nói leo!",
    example: "chỉ được cái ăn là nhanh! * chỉ được cái nói leo!",
  },
  {
    word: "chi đội",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị tổ chức của lực lượng vũ trang cách mạng Việt Nam trong thời kì trước và sau Cách mạng tháng Tám, tương đương tiểu đoàn hoặc trung đoàn.",
    example: "chi đội lớp 4E",
  },
  {
    word: "chị em",
    part_of_speech: "danh từ",
    meaning:
      "chị và em trong gia đình; thường dùng để chỉ những người phụ nữ (thường còn trẻ) có quan hệ gần gũi, thân thiết (nói khái quát): nhà có hai chị em * gặp mặt chị em trong chi hội phụ nữ",
    example: "nhà có hai chị em * gặp mặt chị em trong chi hội phụ nữ",
  },
  {
    word: "chỉ huy",
    part_of_speech: "động từ",
    meaning:
      "điều khiển sự hoạt động của một lực lượng, một tập thể có tổ chức: chỉ huy chiến dịch * trực tiếp chỉ huy trận đánh",
    example: "chỉ huy chiến dịch * trực tiếp chỉ huy trận đánh",
  },
  {
    word: "chỉ huy",
    part_of_speech: "danh từ",
    meaning: "người chỉ huy (nói tắt): báo cáo với chỉ huy",
    example: "báo cáo với chỉ huy",
  },
  {
    word: "chỉ giáo",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng, hoặc kc) (xin) có lời nhận xét, góp ý cho bản thân: có gì sai sót, mong được bạn đọc chỉ giáo * ai biết xin vui lòng chỉ giáo cho",
    example:
      "có gì sai sót, mong được bạn đọc chỉ giáo * ai biết xin vui lòng chỉ giáo cho",
  },
  {
    word: "chỉ huy dàn nhạc",
    part_of_speech: "danh từ",
    meaning: "người điều khiển một dàn nhạc: chỉ huy dàn nhạc giao hưởng",
    example: "chỉ huy dàn nhạc giao hưởng",
  },
  {
    word: "chỉ giới",
    part_of_speech: "danh từ",
    meaning:
      "điểm hoặc đường đánh dấu giới hạn cho một khu vực dành riêng cho việc gì: chỉ giới quy hoạch * vượt quá chỉ giới an toàn giao thông",
    example: "chỉ giới quy hoạch * vượt quá chỉ giới an toàn giao thông",
  },
  {
    word: "chí hiếu",
    part_of_speech: "tính từ",
    meaning: "rất mực có hiếu: người con chí hiếu",
    example: "người con chí hiếu",
  },
  {
    word: "chi hội",
    part_of_speech: "danh từ",
    meaning: "chi nhánh hoặc tổ chức cơ sở của hội: chi hội phụ nữ tỉnh",
    example: "chi hội phụ nữ tỉnh",
  },
  {
    word: "chí hướng",
    part_of_speech: "danh từ",
    meaning:
      "ý muốn và quyết tâm đạt tới một mục tiêu tốt đẹp trong tương lai: chí hướng hoạt động * theo đuổi chí hướng * bạn cùng chí hướng",
    example: "chí hướng hoạt động * theo đuổi chí hướng * bạn cùng chí hướng",
  },
  {
    word: "chị gái",
    part_of_speech: "danh từ",
    meaning: "chị ruột, phân biệt với chị họ, chị dâu: quý chị dâu như chị gái",
    example: "quý chị dâu như chị gái",
  },
  {
    word: "chỉ huy trưởng",
    part_of_speech: "danh từ",
    meaning: "người đứng đầu ban chỉ huy: chỉ huy trưởng chiến dịch",
    example: "chỉ huy trưởng chiến dịch",
  },
  {
    word: "chi khu",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị hành chính - quân sự của chính quyền Sài Gòn trước 1975, tương đương với quận: chi khu hành chính * chi khu quân sự",
    example: "chi khu hành chính * chi khu quân sự",
  },
  {
    word: "chí ít",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (mức độ đạt được) ít nhất, ít ra: việc này, chí ít cũng năm ngày nữa mới xong",
    example: "việc này, chí ít cũng năm ngày nữa mới xong",
  },
  {
    word: "chí lí",
    part_of_speech: "tính từ",
    meaning: "rất có lí, rất đúng: ông nói thật chí lí!",
    example: "ông nói thật chí lí!",
  },
  {
    word: "chí khí",
    part_of_speech: "danh từ",
    meaning:
      "ý chí và tinh thần: chí khí anh hùng * một con người đầy chí khí và nghị lực",
    example: "chí khí anh hùng * một con người đầy chí khí và nghị lực",
  },
  {
    word: "chi lưu",
    part_of_speech: "danh từ",
    meaning:
      "sông nhánh, trong quan hệ với sông cái: sông Lô là một chi lưu của sông Hồng",
    example: "sông Lô là một chi lưu của sông Hồng",
  },
  {
    word: "chỉ lệnh",
    part_of_speech: "danh từ",
    meaning:
      "lệnh của cấp trên giao cho cấp dưới thi hành: ra chỉ lệnh sản xuất * thực hiện nghiêm túc các chỉ lệnh của cấp trên",
    example:
      "ra chỉ lệnh sản xuất * thực hiện nghiêm túc các chỉ lệnh của cấp trên",
  },
  {
    word: "chỉ lệnh",
    part_of_speech: "danh từ",
    meaning:
      "câu lệnh đã được thông dịch hoặc biên dịch chỉ thị cho máy tính làm việc: loại máy mới được bổ sung thêm nhiều chỉ lệnh",
    example: "loại máy mới được bổ sung thêm nhiều chỉ lệnh",
  },
  {
    word: "chi li",
    part_of_speech: "tính từ",
    meaning:
      "tỉ mỉ và rạch ròi, từng li từng tí: tính toán chi li * chi li từng đồng",
    example: "tính toán chi li * chi li từng đồng",
  },
  {
    word: "chí lý",
    part_of_speech: "tính từ",
    meaning: "rất có lí, rất đúng: ông nói thật chí lí!",
    example: "ông nói thật chí lí!",
  },
  {
    word: "chỉ mảnh tơ mành",
    part_of_speech: "",
    meaning:
      '(cũ, văn chương) những thứ mỏng mảnh, dễ đứt; thường dùng để chỉ mối tình duyên không bền chặt: "Phải đâu gió lá chim cành, Mà đem chỉ mảnh tơ mành xe chung." (ca dao)',
    example:
      'Phải đâu gió lá chim cành, Mà đem chỉ mảnh tơ mành xe chung." (ca dao)',
  },
  {
    word: "chí mạng",
    part_of_speech: "tính từ",
    meaning: "có thể nguy hiểm đến tính mạng: giáng một đòn trí mạng",
    example: "giáng một đòn trí mạng",
  },
  {
    word: "chỉ mỗi tội",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) chỉ có một điều đáng tiếc (làm hạn chế cái hay, cái tốt vừa nói đến): con bé rất xinh, chỉ mỗi tội hơi thấp",
    example: "con bé rất xinh, chỉ mỗi tội hơi thấp",
  },
  {
    word: "chí nguy",
    part_of_speech: "tính từ",
    meaning:
      "hết sức nguy khốn: tình hình thật chí nguy * làm vừa thôi, kẻo mà lao lực thì chí nguy",
    example:
      "tình hình thật chí nguy * làm vừa thôi, kẻo mà lao lực thì chí nguy",
  },
  {
    word: "chi phái",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) ngành, nhánh trong một họ hoặc một trường pháI: họp mặt các chi phái * trưởng chi phái của một dòng võ",
    example: "họp mặt các chi phái * trưởng chi phái của một dòng võ",
  },
  {
    word: "chị nuôi",
    part_of_speech: "danh từ",
    meaning:
      "người phụ nữ làm cấp dưỡng, trong quan hệ với những đối tượng phục vụ của mình: chị nuôi của tiểu đoàn",
    example: "chị nuôi của tiểu đoàn",
  },
  {
    word: "chí nguyện",
    part_of_speech: "danh từ",
    meaning: "(cũ) chí hướng và nguyện vọng: thoả chí nguyện",
    example: "thoả chí nguyện",
  },
  {
    word: "chi nhánh",
    part_of_speech: "danh từ",
    meaning:
      "nhánh phụ, phân ra từ nhánh chính: các chi nhánh của sông Hồng * một chi nhánh của dòng họ Nguyễn",
    example: "các chi nhánh của sông Hồng * một chi nhánh của dòng họ Nguyễn",
  },
  {
    word: "chi nhánh",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị cấp dưới của một cơ quan, tổ chức (thường là tổ chức kinh doanh): công ti mới mở thêm chi nhánh",
    example: "công ti mới mở thêm chi nhánh",
  },
  {
    word: "chí sĩ",
    part_of_speech: "danh từ",
    meaning:
      "người trí thức thời trước có ý chí và tiết tháo, quyết tâm đấu tranh vì chính nghĩa: Phan Chu Trinh là một chí sĩ yêu nước",
    example: "Phan Chu Trinh là một chí sĩ yêu nước",
  },
  {
    word: "chi phí sản xuất",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ hao phí lao động sống và lao động quá khứ cần thiết để làm ra sản phẩm: giảm chi phí sản xuất",
    example: "giảm chi phí sản xuất",
  },
  {
    word: "chi phối",
    part_of_speech: "động từ",
    meaning:
      "có tác dụng chỉ đạo hoặc khống chế (đối với ai hoặc trong việc gì): chi phối sản xuất * không để cho tình cảm chi phối",
    example: "chi phối sản xuất * không để cho tình cảm chi phối",
  },
  {
    word: "chi phí",
    part_of_speech: "động từ",
    meaning:
      "chi tiêu vào công việc gì (nói khái quát): chi phí cho việc vận chuyển * tiền chi phí",
    example: "chi phí cho việc vận chuyển * tiền chi phí",
  },
  {
    word: "chi phí",
    part_of_speech: "danh từ",
    meaning: "khoản chi phí: chi phí vận chuyển",
    example: "chi phí vận chuyển",
  },
  {
    word: "chi phí lưu thông",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ chi phí để đưa hàng hoá từ nơi sản xuất ra đến tay người tiêu dùng: giảm chi phí lưu thông hàng hoá",
    example: "giảm chi phí lưu thông hàng hoá",
  },
  {
    word: "chì than",
    part_of_speech: "danh từ",
    meaning:
      "chất liệu để vẽ, thành phần gồm bột than hoặc muội trộn với chất kết dính: bức vẽ được thể hiện bằng chất liệu chì than",
    example: "bức vẽ được thể hiện bằng chất liệu chì than",
  },
  {
    word: "chí thân",
    part_of_speech: "tính từ",
    meaning: "hết sức thân thiết: bạn chí thân",
    example: "bạn chí thân",
  },
  {
    word: "chỉ số",
    part_of_speech: "danh từ",
    meaning:
      "con số biểu hiện tương đối tình hình biến động của một hiện tượng ở các thời kì khác nhau: các chỉ số kinh tế * chỉ số chứng khoán * chỉ số thông minh",
    example: "các chỉ số kinh tế * chỉ số chứng khoán * chỉ số thông minh",
  },
  {
    word: "chỉ số",
    part_of_speech: "danh từ",
    meaning:
      "số hoặc chữ thường được ghi dưới bên phải một biểu thức để phân biệt: chỉ số của A1, A2, An là 1, 2, n",
    example: "chỉ số của A1, A2, An là 1, 2, n",
  },
  {
    word: "chỉ số",
    part_of_speech: "danh từ",
    meaning:
      "số hoặc chữ ghi trên dấu căn để chỉ bậc của căn: chỉ số của căn thức S là 3",
    example: "chỉ số của căn thức S là 3",
  },
  {
    word: "chỉ thiên",
    part_of_speech: "động từ",
    meaning: "hướng thẳng lên trời, không nhằm một đích cụ thể: bắn chỉ thiên",
    example: "bắn chỉ thiên",
  },
  {
    word: "chỉ thị",
    part_of_speech: "động từ",
    meaning:
      "(cơ quan hoặc người lãnh đạo cấp trên) có ý kiến mang tính chất mệnh lệnh, phát biểu trực tiếp hoặc bằng văn bản, cho cấp dưới thi hành: tổng tư lệnh chỉ thị cho toàn quân chuẩn bị chiến dịch",
    example: "tổng tư lệnh chỉ thị cho toàn quân chuẩn bị chiến dịch",
  },
  {
    word: "chỉ thị",
    part_of_speech: "danh từ",
    meaning:
      "điều cấp trên chỉ thị cho cấp dưới: xin chỉ thị của tỉnh * nhận chỉ thị",
    example: "xin chỉ thị của tỉnh * nhận chỉ thị",
  },
  {
    word: "chi thu",
    part_of_speech: "động từ",
    meaning: "như thu chi: tính toán các khoản chi thu trong ngày",
    example: "tính toán các khoản chi thu trong ngày",
  },
  {
    word: "chí thiết",
    part_of_speech: "tính từ",
    meaning:
      "hết sức thân thiết, gắn bó: người đồng đội chí thiết * tình bạn của họ thật là chí thiết",
    example: "người đồng đội chí thiết * tình bạn của họ thật là chí thiết",
  },
  {
    word: "chi tiết",
    part_of_speech: "danh từ",
    meaning:
      "điểm nhỏ, phần rất nhỏ trong nội dung sự việc hoặc hiện tượng: dẫn ra từng chi tiết cụ thể * lắng nghe không bỏ sót một chi tiết nào",
    example:
      "dẫn ra từng chi tiết cụ thể * lắng nghe không bỏ sót một chi tiết nào",
  },
  {
    word: "chi tiết",
    part_of_speech: "danh từ",
    meaning:
      "thành phần hoặc bộ phận riêng lẻ có thể tháo lắp được (như đinh ốc, trục, bánh xe, v.v.) trong máy móc, thiết bị: tháo rời từng chi tiết trước khi sửa chữa",
    example: "tháo rời từng chi tiết trước khi sửa chữa",
  },
  {
    word: "chi tiết",
    part_of_speech: "tính từ",
    meaning:
      "đầy đủ đến từng điểm nhỏ nhất: báo cáo chi tiết * trình bày chi tiết từng vấn đề",
    example: "báo cáo chi tiết * trình bày chi tiết từng vấn đề",
  },
  {
    word: "chi tiêu",
    part_of_speech: "động từ",
    meaning:
      "sử dụng tiền bạc vào việc gì (nói khái quát): chi tiêu một món tiền lớn * cắt giảm chi tiêu",
    example: "chi tiêu một món tiền lớn * cắt giảm chi tiêu",
  },
  {
    word: "chí tình",
    part_of_speech: "tính từ",
    meaning:
      "hết sức chân thành và sâu sắc: ăn ở rất chí tình * lời khuyên chí tình",
    example: "ăn ở rất chí tình * lời khuyên chí tình",
  },
  {
    word: "chí thú",
    part_of_speech: "tính từ",
    meaning:
      "chăm chỉ và hết sức tập trung, cố gắng trong công việc, thường là công việc gắn liền với lợi ích của riêng mình: chí thú làm ăn * chí thú học hành",
    example: "chí thú làm ăn * chí thú học hành",
  },
  {
    word: "chỉ tội",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) chỉ có một điều đáng tiếc (làm hạn chế cái hay, cái tốt vừa nói đến): con bé rất xinh, chỉ mỗi tội hơi thấp",
    example: "con bé rất xinh, chỉ mỗi tội hơi thấp",
  },
  {
    word: "chỉ tiêu",
    part_of_speech: "danh từ",
    meaning:
      "mức quy định phải đạt tới trong kế hoạch: hoàn thành vượt mức chỉ tiêu đề ra * phân bổ chỉ tiêu cho từng đơn vị",
    example:
      "hoàn thành vượt mức chỉ tiêu đề ra * phân bổ chỉ tiêu cho từng đơn vị",
  },
  {
    word: "chỉ tiêu",
    part_of_speech: "danh từ",
    meaning: "mức biểu hiện của một đặc điểm, một chức năng: chỉ tiêu sinh lí",
    example: "chỉ tiêu sinh lí",
  },
  {
    word: "chí tôn",
    part_of_speech: "",
    meaning:
      '(cũ) rất mực tôn kính; thường dùng trong văn học cổ để tôn xưng vua, Thượng Đế: đấng chí tôn * "Trên trướng gấm chí tôn vòi vọi, Những khi nào gần gũi quân vương." (CO)',
    example:
      'đấng chí tôn * "Trên trướng gấm chí tôn vòi vọi, Những khi nào gần gũi quân vương." (CO)',
  },
  {
    word: "chỉ trích",
    part_of_speech: "động từ",
    meaning:
      "vạch sai lầm, khuyết điểm nhằm chê trách, phê phán: lên tiếng chỉ trích * bị báo chí chỉ trích kịch liệt",
    example: "lên tiếng chỉ trích * bị báo chí chỉ trích kịch liệt",
  },
  {
    word: "chi trả",
    part_of_speech: "động từ",
    meaning:
      "bỏ tiền ra để trả cho một khoản nào đó (nói khái quát): chi trả lương cho công nhân * chi trả các khoản nợ nần",
    example: "chi trả lương cho công nhân * chi trả các khoản nợ nần",
  },
  {
    word: "chỉ trỏ",
    part_of_speech: "động từ",
    meaning:
      "chỉ bằng tay (nói khái quát): vừa xem vừa chỉ trỏ * bị thiên hạ chỉ trỏ, xì xào",
    example: "vừa xem vừa chỉ trỏ * bị thiên hạ chỉ trỏ, xì xào",
  },
  {
    word: "chỉ trỏ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) dắt dẫn, mách bảo trong việc mua bán để kiếm hoa hồng: anh ta chuyên làm nghề chỉ trỏ",
    example: "anh ta chuyên làm nghề chỉ trỏ",
  },
  {
    word: "chia",
    part_of_speech: "động từ",
    meaning:
      'tách ra làm thành từng phần, từ một chỉnh thể: chia đôi quả cam * bài văn chia thành ba đoạn * "Duyên kia có phụ chi tình, Mà toan chia gánh chung tình làm hai?" (TKiều)',
    example:
      'chia đôi quả cam * bài văn chia thành ba đoạn * "Duyên kia có phụ chi tình, Mà toan chia gánh chung tình làm hai?" (TKiều)',
  },
  {
    word: "chia",
    part_of_speech: "động từ",
    meaning:
      "tìm một trong hai thừa số của một tích khi đã biết thừa số kia: bé học phép tính chia * 6 chia cho 3 được 2",
    example: "bé học phép tính chia * 6 chia cho 3 được 2",
  },
  {
    word: "chia",
    part_of_speech: "động từ",
    meaning:
      "cho được hưởng một phần của cái gì đó: chia quà cho các cháu * chia lợi tức * chia gia sản cho con cái",
    example: "chia quà cho các cháu * chia lợi tức * chia gia sản cho con cái",
  },
  {
    word: "chia",
    part_of_speech: "động từ",
    meaning:
      "cùng chịu hoặc cùng hưởng một phần cái buồn, cái vui với người khác, để tỏ sự thông cảm với nhau: viết thư chia buồn * đến chia vui cùng với gia đình",
    example: "viết thư chia buồn * đến chia vui cùng với gia đình",
  },
  {
    word: "chia",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tự phân ra nhiều ngả, nhiều hướng: chia nhau đi tìm * đến ngã tư, mỗi người chia nhau đi một ngả",
    example: "chia nhau đi tìm * đến ngã tư, mỗi người chia nhau đi một ngả",
  },
  {
    word: "chia",
    part_of_speech: "động từ",
    meaning:
      "biến đổi động từ theo ngôi, số, giống, thời gian, v.v. trong một số ngôn ngữ: cách chia động từ trong tiếng Pháp",
    example: "cách chia động từ trong tiếng Pháp",
  },
  {
    word: "chi viện",
    part_of_speech: "động từ",
    meaning:
      "dùng nhân lực, vật lực, tài lực và/hoặc hành động thực tế giúp để tăng lực lượng, vượt qua khó khăn (thường là trong đấu tranh vũ trang): chi viện cho tiền tuyến * pháo binh bắn chi viện cho bộ binh",
    example: "chi viện cho tiền tuyến * pháo binh bắn chi viện cho bộ binh",
  },
  {
    word: "chí tử",
    part_of_speech: "tính từ",
    meaning:
      "(đòn đánh) hết sức nguy hiểm, có thể gây tử vong: giáng những đòn chí tử * đánh nhau chí tử",
    example: "giáng những đòn chí tử * đánh nhau chí tử",
  },
  {
    word: "chí tử",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) hết cả sức lực, đến mức như không còn có thể chịu được nữa: chạy chí tử",
    example: "chạy chí tử",
  },
  {
    word: "chỉ vẽ",
    part_of_speech: "động từ",
    meaning:
      "bày vẽ cho biết một cách cụ thể: chỉ vẽ cách làm ăn * chỉ vẽ từng đường đi nước bước",
    example: "chỉ vẽ cách làm ăn * chỉ vẽ từng đường đi nước bước",
  },
  {
    word: "chìa",
    part_of_speech: "danh từ",
    meaning: "chìa khoá (nói tắt): tra chìa vào khoá * khoá rơi mất chìa",
    example: "tra chìa vào khoá * khoá rơi mất chìa",
  },
  {
    word: "chìa",
    part_of_speech: "động từ",
    meaning:
      "đưa ngang ra phía trước: chìa tay ra đón con * chìa cho xem tấm thẻ",
    example: "chìa tay ra đón con * chìa cho xem tấm thẻ",
  },
  {
    word: "chìa",
    part_of_speech: "động từ",
    meaning:
      "nhô ra phía trước, so với những cái cùng hàng: cành cây mọc chìa ra bờ sông",
    example: "cành cây mọc chìa ra bờ sông",
  },
  {
    word: "chĩa",
    part_of_speech: "động từ",
    meaning: "đâm bằng chĩa: đi chĩa cá",
    example: "đi chĩa cá",
  },
  {
    word: "chĩa",
    part_of_speech: "động từ",
    meaning:
      "hướng thẳng mũi nhọn, hoặc đầu mũi nói chung vào một hướng, một mục tiêu nào đó: chĩa súng vào ngực * nòng pháo chĩa lên trời",
    example: "chĩa súng vào ngực * nòng pháo chĩa lên trời",
  },
  {
    word: "chìa khoá",
    part_of_speech: "danh từ",
    meaning:
      "vật bằng kim loại dùng tra vào ổ khoá để mở hoặc để khoá: chùm chìa khoá * để quên chìa khoá ở nhà",
    example: "chùm chìa khoá * để quên chìa khoá ở nhà",
  },
  {
    word: "chìa khoá",
    part_of_speech: "danh từ",
    meaning:
      "điều mấu chốt giúp cho giải quyết được việc gì, hoặc vấn đề gì: cải tiến kĩ thuật là chìa khoá để tăng năng suất lao động",
    example: "cải tiến kĩ thuật là chìa khoá để tăng năng suất lao động",
  },
  {
    word: "chia chác",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) chia cho nhiều người (nói khái quát): chia chác những khoản tiền kiếm được * gây gổ nhau vì chia chác không đều",
    example:
      "chia chác những khoản tiền kiếm được * gây gổ nhau vì chia chác không đều",
  },
  {
    word: "chia hết cho",
    part_of_speech: "động từ",
    meaning: "là bội số của số nguyên được nói đến: 9 chia hết cho 3",
    example: "9 chia hết cho 3",
  },
  {
    word: "chia cắt",
    part_of_speech: "động từ",
    meaning:
      "phân ra thành nhiều đoạn, nhiều phần tách biệt nhau, làm cho không còn nguyên vẹn nữa: chiến tranh đã chia cắt đất nước thành hai miền Nam - Bắc * chia cắt đội hình địch để tiêu diệt",
    example:
      "chiến tranh đã chia cắt đất nước thành hai miền Nam - Bắc * chia cắt đội hình địch để tiêu diệt",
  },
  {
    word: "chia li",
    part_of_speech: "động từ",
    meaning:
      "(người thân) rời xa nhau, mỗi người một ngả, không còn được gần gũi, chung sống với nhau nữa: sum họp và chia li * phút chia li * cuộc chia li đầy lưu luyến",
    example: "sum họp và chia li * phút chia li * cuộc chia li đầy lưu luyến",
  },
  {
    word: "chia để trị",
    part_of_speech: "động từ",
    meaning:
      "gây chia rẽ giữa các dân tộc, địa phương, tầng lớp, v.v. để dễ thống trị (một chính sách thường dùng của chủ nghĩa thực dân): thực hiện chính sách chia để trị",
    example: "thực hiện chính sách chia để trị",
  },
  {
    word: "chia lìa",
    part_of_speech: "động từ",
    meaning:
      'làm cho phải lìa xa nhau, mỗi người một nơi, cách biệt hẳn: vợ chồng phải chia lìa nhau * "Bắc nam hai ngả phân chia, Nỗi buồn vấn vít chia lìa tâm can." (ca dao)',
    example:
      'vợ chồng phải chia lìa nhau * "Bắc nam hai ngả phân chia, Nỗi buồn vấn vít chia lìa tâm can." (ca dao)',
  },
  {
    word: "chia ly",
    part_of_speech: "động từ",
    meaning:
      "(người thân) rời xa nhau, mỗi người một ngả, không còn được gần gũi, chung sống với nhau nữa: sum họp và chia li * phút chia li * cuộc chia li đầy lưu luyến",
    example: "sum họp và chia li * phút chia li * cuộc chia li đầy lưu luyến",
  },
  {
    word: "chia phôi",
    part_of_speech: "động từ",
    meaning:
      '(văn chương) như chia li: "Ông tơ ghét bỏ chi nhau, Chưa vui sum họp đã sầu chia phôi!" (TKiều)',
    example:
      'Ông tơ ghét bỏ chi nhau, Chưa vui sum họp đã sầu chia phôi!" (TKiều)',
  },
  {
    word: "chia tay",
    part_of_speech: "động từ",
    meaning:
      "rời nhau, mỗi người đi một nơi: chia tay để lên đường * phút chia tay đầy lưu luyến",
    example: "chia tay để lên đường * phút chia tay đầy lưu luyến",
  },
  {
    word: "chia tay",
    part_of_speech: "động từ",
    meaning:
      "cắt đứt quan hệ tình cảm, thường là tình yêu, tình vợ chồng: không hợp nhau nên phải chia tay",
    example: "không hợp nhau nên phải chia tay",
  },
  {
    word: "chia sẻ",
    part_of_speech: "động từ",
    meaning:
      "cùng chia với nhau để cùng hưởng hoặc cùng chịu: chia sẻ một phần trách nhiệm * chia sẻ cho nhau niềm vui, nỗi buồn",
    example:
      "chia sẻ một phần trách nhiệm * chia sẻ cho nhau niềm vui, nỗi buồn",
  },
  {
    word: "chia rẽ",
    part_of_speech: "động từ",
    meaning:
      "làm cho mâu thuẫn với nhau, khiến cho mất đoàn kết, mất đi sự thống nhất: gây chia rẽ nội bộ * phá vỡ âm mưu chia rẽ của các thế lực thù địch",
    example:
      "gây chia rẽ nội bộ * phá vỡ âm mưu chia rẽ của các thế lực thù địch",
  },
  {
    word: "chích",
    part_of_speech: "động từ",
    meaning:
      "đâm nhẹ cho thủng thành một lỗ nhỏ và không sâu bằng vật có đầu nhọn: đau như bị kim chích * lấy mũi dao chích vào thân cây",
    example: "đau như bị kim chích * lấy mũi dao chích vào thân cây",
  },
  {
    word: "chích",
    part_of_speech: "động từ",
    meaning: "(Nam) (côn trùng) đốt: bị muỗi/ong chích",
    example: "bị muỗi/ong chích",
  },
  {
    word: "chích",
    part_of_speech: "động từ",
    meaning: "(Nam) tiêm: chích thuốc * chích ngừa",
    example: "chích thuốc * chích ngừa",
  },
  {
    word: "chích choác",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) tiêm ma tuý (nói khái quát): đám con nghiện tụ tập chích choác dưới gầm cầu",
    example: "đám con nghiện tụ tập chích choác dưới gầm cầu",
  },
  {
    word: "chia vè",
    part_of_speech: "động từ",
    meaning:
      '(lúa) trổ nhánh: "Ngày đi lúa chửa chia vè, Ngày về lúa đã đỏ hoe đầy đồng." (ca dao)',
    example:
      'Ngày đi lúa chửa chia vè, Ngày về lúa đã đỏ hoe đầy đồng." (ca dao)',
  },
  {
    word: "chia xẻ",
    part_of_speech: "động từ",
    meaning:
      "chia thành nhiều phần làm cho không còn nguyên là một khối nữa: chia xẻ lực lượng * mảnh đất bị chia xẻ ra làm nhiều miếng",
    example: "chia xẻ lực lượng * mảnh đất bị chia xẻ ra làm nhiều miếng",
  },
  {
    word: "chiếc",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị một số đồ vật vốn dùng thành đôi mà tách lẻ ra: chiếc giày * chiếc đũa",
    example: "chiếc giày * chiếc đũa",
  },
  {
    word: "chiếc",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị thuộc một số vật vô sinh: chiếc nón * chiếc đồng hồ * hai chiếc máy bay * chiếc lá",
    example: "chiếc nón * chiếc đồng hồ * hai chiếc máy bay * chiếc lá",
  },
  {
    word: "chiếc",
    part_of_speech: "danh từ",
    meaning:
      '(văn chương) lẻ loi, đơn lẻ, không còn thành đôi, thành cặp: chăn đơn gối chiếc * "Lâm Tri từ thuở uyên bay, Buồng không thương kẻ tháng ngày chiếc thân." (TKiều)',
    example:
      'chăn đơn gối chiếc * "Lâm Tri từ thuở uyên bay, Buồng không thương kẻ tháng ngày chiếc thân." (TKiều)',
  },
  {
    word: "chiêm bao",
    part_of_speech: "động từ",
    meaning:
      'thấy những chuyện thường ngày vẫn nghĩ tới, hoặc sự việc không có thực xảy ra trong giấc ngủ: chiêm bao gặp bạn cũ * giấc chiêm bao * "Gió đâu sịch bức mành mành, Tỉnh ra mới biết là mình chiêm bao." (TKiều)',
    example:
      'chiêm bao gặp bạn cũ * giấc chiêm bao * "Gió đâu sịch bức mành mành, Tỉnh ra mới biết là mình chiêm bao." (TKiều)',
  },
  {
    word: "chiếm",
    part_of_speech: "động từ",
    meaning:
      "lấy của người khác làm của mình bằng bạo lực hoặc dựa vào quyền thế: chiếm đất * chiếm của công làm của riêng",
    example: "chiếm đất * chiếm của công làm của riêng",
  },
  {
    word: "chiếm",
    part_of_speech: "động từ",
    meaning:
      "giành được về phần mình: chiếm giải nhất * chiếm ưu thế * chiếm được cảm tình của độc giả",
    example: "chiếm giải nhất * chiếm ưu thế * chiếm được cảm tình của độc giả",
  },
  {
    word: "chiếm",
    part_of_speech: "động từ",
    meaning:
      "làm cho một khoảng không gian, thời gian hoặc một phần nào đó không còn trống nữa, do sự tồn tại của mình ở đó: khu triển lãm chiếm một khoảng đất rộng * cuộc họp chiếm mất nhiều thì giờ * chiếm tỉ lệ 10%",
    example:
      "khu triển lãm chiếm một khoảng đất rộng * cuộc họp chiếm mất nhiều thì giờ * chiếm tỉ lệ 10%",
  },
  {
    word: "chiếm",
    part_of_speech: "động từ",
    meaning:
      "như xâm chiếm: niềm vui chiếm lấy tâm hồn * hình ảnh cô gái chiếm toàn bộ tâm trí anh",
    example:
      "niềm vui chiếm lấy tâm hồn * hình ảnh cô gái chiếm toàn bộ tâm trí anh",
  },
  {
    word: "chiêm",
    part_of_speech: "tính từ",
    meaning:
      "(lúa hay hoa màu) gieo cấy ở miền Bắc Việt Nam vào đầu mùa lạnh, khô (tháng mười, tháng mười một) và thu hoạch vào đầu mùa nóng, mưa nhiều (tháng năm, tháng sáu); phân biệt với mùa: lúa chiêm",
    example: "lúa chiêm",
  },
  {
    word: "chiêm",
    part_of_speech: "tính từ",
    meaning: "(ra hoa, ra quả) không đúng mùa: na chiêm * ổi chiêm",
    example: "na chiêm * ổi chiêm",
  },
  {
    word: "chiếm dụng",
    part_of_speech: "động từ",
    meaning:
      "chiếm lấy và sử dụng một cách trái phép: chiếm dụng vỉa hè làm nơi buôn bán * chiếm dụng ruộng đất của nông dân",
    example:
      "chiếm dụng vỉa hè làm nơi buôn bán * chiếm dụng ruộng đất của nông dân",
  },
  {
    word: "chiếc bóng",
    part_of_speech: "tính từ",
    meaning:
      '(cũ, văn chương) lẻ loi, một mình một bóng: "Người về chiếc bóng năm canh, Kẻ đi muôn dặm một mình xa xôi." (TKiều)',
    example:
      'Người về chiếc bóng năm canh, Kẻ đi muôn dặm một mình xa xôi." (TKiều)',
  },
  {
    word: "chiếm đóng",
    part_of_speech: "động từ",
    meaning:
      "đưa quân đội đến chiếm giữ đất đai, lãnh thổ của nước khác: ngôi làng đã bị giặc chiếm đóng",
    example: "ngôi làng đã bị giặc chiếm đóng",
  },
  {
    word: "chiếm giữ",
    part_of_speech: "động từ",
    meaning: "chiếm và giữ lấy cho riêng mình: chiếm giữ tài sản công",
    example: "chiếm giữ tài sản công",
  },
  {
    word: "chiếm giữ",
    part_of_speech: "động từ",
    meaning:
      "giữ lấy, đảm nhiệm lấy vị trí quan trọng: hai anh em thay nhau chiếm giữ các vị trí chủ chốt của công ti * chiếm giữ hành lang bên cánh trái",
    example:
      "hai anh em thay nhau chiếm giữ các vị trí chủ chốt của công ti * chiếm giữ hành lang bên cánh trái",
  },
  {
    word: "chiếm giữ",
    part_of_speech: "động từ",
    meaning: "giành được và giữ về phần mình: chiếm giữ ngôi đầu bảng",
    example: "chiếm giữ ngôi đầu bảng",
  },
  {
    word: "chiêm chiếp",
    part_of_speech: "động từ",
    meaning: "như chiếp (ý liên tiếp): gà con kêu chiêm chiếp",
    example: "gà con kêu chiêm chiếp",
  },
  {
    word: "chiếm đoạt",
    part_of_speech: "động từ",
    meaning:
      "chiếm lấy của người khác bằng vũ lực hoặc quyền thế: chiếm đoạt ngôi báu * phạm tội chiếm đoạt tài sản của công dân",
    example: "chiếm đoạt ngôi báu * phạm tội chiếm đoạt tài sản của công dân",
  },
  {
    word: "chiếm cứ",
    part_of_speech: "động từ",
    meaning: "chiếm giữ một nơi, một vùng nào đó: chiếm cứ một vùng",
    example: "chiếm cứ một vùng",
  },
  {
    word: "chiếm hữu",
    part_of_speech: "động từ",
    meaning:
      "nắm giữ (tư liệu sản xuất, tài sản lớn) làm của riêng: giai cấp địa chủ chiếm hữu ruộng đất * chiếm hữu lực lượng sản xuất",
    example:
      "giai cấp địa chủ chiếm hữu ruộng đất * chiếm hữu lực lượng sản xuất",
  },
  {
    word: "chiêm tinh",
    part_of_speech: "động từ",
    meaning:
      "quan sát sao trên trời mà đoán việc lành dữ (một hình thức bói toán): nhà chiêm tinh * thuật chiêm tinh",
    example: "nhà chiêm tinh * thuật chiêm tinh",
  },
  {
    word: "chiếm lĩnh",
    part_of_speech: "động từ",
    meaning:
      "chiếm lấy để giành quyền làm chủ: chiếm lĩnh thị trường * chiếm lĩnh trận địa",
    example: "chiếm lĩnh thị trường * chiếm lĩnh trận địa",
  },
  {
    word: "chiến",
    part_of_speech: "danh từ",
    meaning:
      "chiến tranh (nói tắt): cuộc chiến chưa đến hồi kết thúc * đập tan âm mưu gây chiến",
    example: "cuộc chiến chưa đến hồi kết thúc * đập tan âm mưu gây chiến",
  },
  {
    word: "chiến",
    part_of_speech: "động từ",
    meaning: "chiến đấu, về mặt chức năng, công dụng: lính chiến * tàu chiến",
    example: "lính chiến * tàu chiến",
  },
  {
    word: "chiêm nghiệm",
    part_of_speech: "động từ",
    meaning:
      "xem xét và đoán định bằng kinh nghiệm, sự từng trảI: chiêm nghiệm mọi lẽ phải trái ở đời",
    example: "chiêm nghiệm mọi lẽ phải trái ở đời",
  },
  {
    word: "chiên",
    part_of_speech: "danh từ",
    meaning:
      "đồ dệt bằng lông thú hoặc bằng xơ bông, thường dùng làm chăn, nệm: chăn chiên",
    example: "chăn chiên",
  },
  {
    word: "chiên",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) rán: ngô chiên * thịt gà chiên",
    example: "ngô chiên * thịt gà chiên",
  },
  {
    word: "chiêm ngưỡng",
    part_of_speech: "động từ",
    meaning:
      "ngẩng nhìn và ngắm một cách trang nghiêm, kính cẩn: chiêm ngưỡng dung nhan",
    example: "chiêm ngưỡng dung nhan",
  },
  {
    word: "chiến bại",
    part_of_speech: "động từ",
    meaning:
      "bị đánh bại, thất bại sau một quá trình đấu tranh: kẻ chiến bại * đoàn quân chiến bại",
    example: "kẻ chiến bại * đoàn quân chiến bại",
  },
  {
    word: "chiến binh",
    part_of_speech: "danh từ",
    meaning:
      "lính trực tiếp tham gia chiến đấu: đoàn chiến binh ra trận * người chiến binh",
    example: "đoàn chiến binh ra trận * người chiến binh",
  },
  {
    word: "chiến bào",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) áo của tướng sĩ thời phong kiến mặc khi ra trận: "Giã nhà đeo bức chiến bào, Thét roi cầu Vị ào ào gió thu." (CPN)',
    example: 'Giã nhà đeo bức chiến bào, Thét roi cầu Vị ào ào gió thu." (CPN)',
  },
  {
    word: "chiến cuộc",
    part_of_speech: "danh từ",
    meaning:
      "tình hình trong một thời gian và ở một chiến khu nhất định của hai bên trong chiến tranh: theo dõi diễn biến của chiến cuộc",
    example: "theo dõi diễn biến của chiến cuộc",
  },
  {
    word: "chiến đấu",
    part_of_speech: "động từ",
    meaning:
      "đánh nhau giữa các lực lượng vũ trang trong chiến tranh: chiến đấu chống giặc ngoại xâm * lên đường đi chiến đấu",
    example: "chiến đấu chống giặc ngoại xâm * lên đường đi chiến đấu",
  },
  {
    word: "chiến đấu",
    part_of_speech: "động từ",
    meaning:
      "dùng sức mạnh vật chất hay tinh thần chống lại một cách quyết liệt với quân thù, với khó khăn, trở ngại nói chung: chiến đấu với bệnh tật * chiến đấu với thiên tai",
    example: "chiến đấu với bệnh tật * chiến đấu với thiên tai",
  },
  {
    word: "chiến hào",
    part_of_speech: "danh từ",
    meaning: "hào để ẩn nấp, che chắn khi tác chiến: đào chiến hào",
    example: "đào chiến hào",
  },
  {
    word: "chiến chinh",
    part_of_speech: "động từ",
    meaning: "như chinh chiến: chiến chinh nơi phương xa",
    example: "chiến chinh nơi phương xa",
  },
  {
    word: "chiến công",
    part_of_speech: "danh từ",
    meaning:
      "công lao trong chiến đấu: lập chiến công * những chiến công oanh liệt",
    example: "lập chiến công * những chiến công oanh liệt",
  },
  {
    word: "chiến dịch",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ nói chung các trận chiến đấu diễn ra trên một chiến trường và trong một thời gian, tiến hành theo kế hoạch và ý định thống nhất, nhằm thực hiện mục đích chiến lược nhất định: chiến dịch Điện Biên Phủ",
    example: "chiến dịch Điện Biên Phủ",
  },
  {
    word: "chiến dịch",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ nói chung những việc làm tập trung và khẩn trương, tiến hành trong một thời gian nhất định, nhằm thực hiện một mục đích nhất định: phát động chiến dịch phòng bệnh mùa hè * mở chiến dịch truy quét tội phạm trên toàn quốc",
    example:
      "phát động chiến dịch phòng bệnh mùa hè * mở chiến dịch truy quét tội phạm trên toàn quốc",
  },
  {
    word: "chiến hạm",
    part_of_speech: "danh từ",
    meaning: "tàu chiến lớn: pháo từ chiến hạm bắn vào bờ",
    example: "pháo từ chiến hạm bắn vào bờ",
  },
  {
    word: "chiến hữu",
    part_of_speech: "danh từ",
    meaning: "bạn cùng chiến đấu.",
    example: "anh em chiến hữu",
  },
  {
    word: "chiến mã",
    part_of_speech: "danh từ",
    meaning: "(cũ) ngựa chiến: con chiến mã",
    example: "con chiến mã",
  },
  {
    word: "chiến lược quân sự",
    part_of_speech: "danh từ",
    meaning: "như chiến lược: thực hiện chiến lược quân sự mới",
    example: "thực hiện chiến lược quân sự mới",
  },
  {
    word: "chiến khu",
    part_of_speech: "danh từ",
    meaning: "khu vực tác chiến rộng lớn có ý nghĩa chiến lược.",
    example: "chiến khu Việt Bắc",
  },
  {
    word: "chiến sĩ",
    part_of_speech: "danh từ",
    meaning:
      "người thuộc lực lượng vũ trang nhân dân (thường không phải là cấp chỉ huy): chiến sĩ công an * chiến sĩ pháo binh",
    example: "chiến sĩ công an * chiến sĩ pháo binh",
  },
  {
    word: "chiến sĩ",
    part_of_speech: "danh từ",
    meaning:
      "người chiến đấu cho một sự nghiệp, một lí tưởng: chiến sĩ cách mạng",
    example: "chiến sĩ cách mạng",
  },
  {
    word: "chiến thuật",
    part_of_speech: "danh từ",
    meaning:
      "sách lược, phương pháp tác chiến: chiến thuật du kích * dùng chiến thuật tiến công",
    example: "chiến thuật du kích * dùng chiến thuật tiến công",
  },
  {
    word: "chiến thuật",
    part_of_speech: "danh từ",
    meaning:
      "phương pháp sử dụng trong đấu tranh, thi đấu và công tác: chiến thuật thi đấu * thay đổi chiến thuật kinh doanh",
    example: "chiến thuật thi đấu * thay đổi chiến thuật kinh doanh",
  },
  {
    word: "chiến thuật",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) thuộc về chiến thuật, phục vụ chiến thuật: máy bay chiến thuật",
    example: "máy bay chiến thuật",
  },
  {
    word: "chiến thắng",
    part_of_speech: "động từ",
    meaning:
      "giành được phần thắng trong chiến tranh, chiến đấu hoặc trong một cuộc thi đấu thể thao: chiến thắng giặc ngoại xâm * giành chiến thắng chung cuộc",
    example: "chiến thắng giặc ngoại xâm * giành chiến thắng chung cuộc",
  },
  {
    word: "chiến thắng",
    part_of_speech: "động từ",
    meaning:
      "thắng được qua một quá trình đấu tranh: chiến thắng thiên tai * chiến thắng nghèo nàn và lạc hậu",
    example: "chiến thắng thiên tai * chiến thắng nghèo nàn và lạc hậu",
  },
  {
    word: "chiến thắng",
    part_of_speech: "danh từ",
    meaning:
      "thắng lợi giành được trong chiến đấu, chiến tranh: chiến thắng Điện Biên Phủ * liên hoan mừng chiến thắng",
    example: "chiến thắng Điện Biên Phủ * liên hoan mừng chiến thắng",
  },
  {
    word: "chiến tích",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) thành tích lập được trong chiến đấu: lập chiến tích * những chiến tích vang dội",
    example: "lập chiến tích * những chiến tích vang dội",
  },
  {
    word: "chiến sự",
    part_of_speech: "danh từ",
    meaning:
      "việc chiến đấu, giao tranh giữa các lực lượng quân sự (nói khái quát): tin chiến sự * tình hình chiến sự",
    example: "tin chiến sự * tình hình chiến sự",
  },
  {
    word: "chiến lợi phẩm",
    part_of_speech: "danh từ",
    meaning:
      "vũ khí, đồ dùng, trang thiết bị thu được của địch khi thắng trận: thu nhặt chiến lợi phẩm",
    example: "thu nhặt chiến lợi phẩm",
  },
  {
    word: "chiến luỹ",
    part_of_speech: "danh từ",
    meaning: "tuyến công sự xây đắp kiên cố để phòng thủ: đắp chiến luỹ",
    example: "đắp chiến luỹ",
  },
  {
    word: "chiến lược",
    part_of_speech: "danh từ",
    meaning:
      "kế hoạch và sách lược toàn cục chỉ đạo chiến tranh: chiến lược chiến tranh du kích",
    example: "chiến lược chiến tranh du kích",
  },
  {
    word: "chiến lược",
    part_of_speech: "danh từ",
    meaning:
      "kế hoạch và sách lược toàn cục trong một thời kì lịch sử nhất định: chiến lược cách mạng",
    example: "chiến lược cách mạng",
  },
  {
    word: "chiến lược",
    part_of_speech: "danh từ",
    meaning:
      "kế hoạch cụ thể nhằm thực hiện một công việc gì: chiến lược phát triển kinh tế * chiến lược marketing",
    example: "chiến lược phát triển kinh tế * chiến lược marketing",
  },
  {
    word: "chiến lược",
    part_of_speech: "tính từ",
    meaning: "có tính chất chiến lược: vị trí chiến lược * mặt hàng chiến lược",
    example: "vị trí chiến lược * mặt hàng chiến lược",
  },
  {
    word: "chiến tranh",
    part_of_speech: "danh từ",
    meaning:
      "sự xung đột vũ trang giữa các các dân tộc, các quốc gia, các giai cấp, các tập đoàn nhằm thực hiện mục đích chính trị, kinh tế nhất định: chiến tranh xâm lược * chiến tranh giải phóng dân tộc * dập tắt lò lửa chiến tranh",
    example:
      "chiến tranh xâm lược * chiến tranh giải phóng dân tộc * dập tắt lò lửa chiến tranh",
  },
  {
    word: "chiến tướng",
    part_of_speech: "danh từ",
    meaning: "(cũ) tướng cầm quân đánh trận: mất hai chiến tướng",
    example: "mất hai chiến tướng",
  },
  {
    word: "chiến trận",
    part_of_speech: "danh từ",
    meaning:
      "trận đánh nhau giữa quân đội hai bên: tham gia chiến trận * một người lão luyện trong chiến trận",
    example: "tham gia chiến trận * một người lão luyện trong chiến trận",
  },
  {
    word: "chiến trận",
    part_of_speech: "danh từ",
    meaning:
      "như chiến trường (ng 1): xông pha nơi chiến trận * hi sinh ngoài chiến trận",
    example: "xông pha nơi chiến trận * hi sinh ngoài chiến trận",
  },
  {
    word: "chiến tuyến",
    part_of_speech: "danh từ",
    meaning: "tuyến tiếp xúc giữa hai lực lượng đối lập: bên kia chiến tuyến",
    example: "bên kia chiến tuyến",
  },
  {
    word: "chiết",
    part_of_speech: "động từ",
    meaning: "rót bớt sang một đồ đựng khác: chiết rượu từ vò sang chai",
    example: "chiết rượu từ vò sang chai",
  },
  {
    word: "chiết",
    part_of_speech: "động từ",
    meaning:
      "tách một chất ra khỏi dung dịch bằng một dung môi khác: chiết hoạt chất * cao cồn được chiết từ rượu cồn",
    example: "chiết hoạt chất * cao cồn được chiết từ rượu cồn",
  },
  {
    word: "chiết",
    part_of_speech: "động từ",
    meaning:
      "trừ bớt một phần, không để cho hưởng hết: nghỉ nhiều nên bị chiết tiền lương",
    example: "nghỉ nhiều nên bị chiết tiền lương",
  },
  {
    word: "chiết",
    part_of_speech: "động từ",
    meaning:
      "thu bớt lại, làm cho hẹp lại (nói về đan, khâu): chiết nách mười mũi * đường chiết ở ống tay áo",
    example: "chiết nách mười mũi * đường chiết ở ống tay áo",
  },
  {
    word: "chiết",
    part_of_speech: "động từ",
    meaning:
      "nhân giống cây bằng cách róc một khoanh vỏ ở cành và bọc đất ẩm lại cho rễ phụ mọc, rồi cắt ra trồng: chiết cam * trồng bằng cành chiết",
    example: "chiết cam * trồng bằng cành chiết",
  },
  {
    word: "chiến trường",
    part_of_speech: "danh từ",
    meaning:
      "nơi diễn ra các cuộc chiến đấu: hi sinh ở chiến trường * chiến trường ngổn ngang xác giặc",
    example: "hi sinh ở chiến trường * chiến trường ngổn ngang xác giặc",
  },
  {
    word: "chiến trường",
    part_of_speech: "danh từ",
    meaning:
      "nơi diễn ra chiến tranh, nằm trong một khu vực hoặc nhiều khu vực có liên quan với nhau về địa lí và về ý nghĩa chiến lược: chi viện cho chiến trường miền Nam * chiến trường châu Âu trong Đại chiến thế giới thứ hai",
    example:
      "chi viện cho chiến trường miền Nam * chiến trường châu Âu trong Đại chiến thế giới thứ hai",
  },
  {
    word: "chiến xa",
    part_of_speech: "danh từ",
    meaning:
      "xe dùng để chiến đấu, có vỏ thép và có trang bị vũ khí: xe tăng là một loại chiến xa",
    example: "xe tăng là một loại chiến xa",
  },
  {
    word: "chiết quang",
    part_of_speech: "",
    meaning: "(hiện tượng) làm cho tia sáng gãy khúc: môi trường chiết quang",
    example: "môi trường chiết quang",
  },
  {
    word: "chiết xuất",
    part_of_speech: "động từ",
    meaning:
      "tách để lấy tinh chất từ thảo mộc hoặc một hỗn hợp chất: chiết xuất tinh dầu bưởi",
    example: "chiết xuất tinh dầu bưởi",
  },
  {
    word: "chiết khấu",
    part_of_speech: "động từ",
    meaning:
      "(trong mua bán) giảm một số phần trăm giá quy định: tăng chiết khấu bán lẻ * sách được bán với chiết khấu 30%",
    example: "tăng chiết khấu bán lẻ * sách được bán với chiết khấu 30%",
  },
  {
    word: "chiết trung",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) (phương pháp nghiên cứu hoặc giải quyết vấn đề) dung hoà, thường là một cách khiên cưỡng, các ý kiến khác nhau cho gọi là vừa phải: một ý kiến có tính chất chiết trung",
    example: "một ý kiến có tính chất chiết trung",
  },
  {
    word: "chiều",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian từ sau trưa đến trước tối: từ sáng đến chiều * ba giờ chiều * trời đã về chiều",
    example: "từ sáng đến chiều * ba giờ chiều * trời đã về chiều",
  },
  {
    word: "chiều",
    part_of_speech: "danh từ",
    meaning:
      "khoảng cách từ cạnh, mặt hoặc đầu này đến cạnh, mặt hoặc đầu kia của một hình, một vật: chiều cao * mỗi chiều dài 3 mét * phong trào vừa có chiều rộng, vừa có chiều sâu (b)",
    example:
      "chiều cao * mỗi chiều dài 3 mét * phong trào vừa có chiều rộng, vừa có chiều sâu (b)",
  },
  {
    word: "chiều",
    part_of_speech: "danh từ",
    meaning:
      'phía, bề: đoàn kết một chiều * "Dỗ dành khuyên giải trăm chiều, Lửa phiền càng dập, càng khêu mối phiền." (TKiều)',
    example:
      'đoàn kết một chiều * "Dỗ dành khuyên giải trăm chiều, Lửa phiền càng dập, càng khêu mối phiền." (TKiều)',
  },
  {
    word: "chiều",
    part_of_speech: "danh từ",
    meaning:
      '(Ít dùng) vẻ, dáng bên ngoài: ra chiều đồng ý * "Sóng tình dường đã xiêu xiêu, Xem trong âu yếm có chiều lả lơi." (TKiều)',
    example:
      'ra chiều đồng ý * "Sóng tình dường đã xiêu xiêu, Xem trong âu yếm có chiều lả lơi." (TKiều)',
  },
  {
    word: "chiều",
    part_of_speech: "danh từ",
    meaning:
      "hướng đi trên một đường, hướng quay xung quanh một điểm hay một trục: đường một chiều * theo chiều kim đồng hồ * gió chiều nào che chiều ấy (tng)",
    example:
      "đường một chiều * theo chiều kim đồng hồ * gió chiều nào che chiều ấy (tng)",
  },
  {
    word: "chiều",
    part_of_speech: "danh từ",
    meaning:
      "hướng diễn biến, xu thế của một quá trình: bệnh có chiều trầm trọng hơn * xem ra gió có chiều mạnh hơn lúc sáng",
    example:
      "bệnh có chiều trầm trọng hơn * xem ra gió có chiều mạnh hơn lúc sáng",
  },
  {
    word: "chiều",
    part_of_speech: "động từ",
    meaning:
      "làm theo hoặc đồng ý cho làm theo ý thích để được vừa lòng: mẹ chiều con * chiều theo nguyện vọng * được chiều quá đâm hư",
    example: "mẹ chiều con * chiều theo nguyện vọng * được chiều quá đâm hư",
  },
  {
    word: "chiêu",
    part_of_speech: "danh từ",
    meaning:
      "miếng, đòn hoặc thế võ; thường dùng để chỉ cái cách thức riêng nào đó: chiêu võ hiểm * tung chiêu quyết định * mắc chiêu lừa đảo của bọn cò mồi",
    example:
      "chiêu võ hiểm * tung chiêu quyết định * mắc chiêu lừa đảo của bọn cò mồi",
  },
  {
    word: "chiêu",
    part_of_speech: "động từ",
    meaning:
      "uống một ít, thường để dễ nuốt trôi thứ khác: chiêu một ngụm nước",
    example: "chiêu một ngụm nước",
  },
  {
    word: "chiêu",
    part_of_speech: "tính từ",
    meaning:
      "(cũ) (tay hoặc chân) tráI: tay chiêu đập niêu không vỡ (tng) * chân đăm đá chân chiêu (tng)",
    example: "tay chiêu đập niêu không vỡ (tng) * chân đăm đá chân chiêu (tng)",
  },
  {
    word: "chiết tự",
    part_of_speech: "động từ",
    meaning:
      "phân tích chữ Hán ra từng yếu tố, căn cứ vào nghĩa của các yếu tố mà đoán việc lành dữ, theo một thuật bói toán ngày xưa.",
    example: "giải thích nghĩa của từ theo lối chiết tự",
  },
  {
    word: "chiêu bài",
    part_of_speech: "danh từ",
    meaning:
      "biển quảng cáo treo trước cửa hiệu; thường dùng để chỉ cái danh nghĩa giả dối bề ngoàI: núp dưới chiêu bài 'khai hoá' để thực hiện chính sách thực dân",
    example: "núp dưới chiêu bài 'khai hoá' để thực hiện chính sách thực dân",
  },
  {
    word: "chiểu",
    part_of_speech: "động từ",
    meaning:
      "(cũ) dựa vào, căn cứ vào điều đã được quy định thành văn bản: chiểu theo luật mà thi hành",
    example: "chiểu theo luật mà thi hành",
  },
  {
    word: "chiếu",
    part_of_speech: "danh từ",
    meaning:
      "đồ dệt bằng cói, nylon, v.v. dùng trải ra để nằm, ngồi: trải chiếu * dệt chiếu",
    example: "trải chiếu * dệt chiếu",
  },
  {
    word: "chiếu",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) điều vua công bố cho dân chúng biết bằng văn bản (thường về vấn đề chung của đất nước): chiếu dời đô * xuống chiếu cầu hiền",
    example: "chiếu dời đô * xuống chiếu cầu hiền",
  },
  {
    word: "chiếu",
    part_of_speech: "động từ",
    meaning:
      "làm cho luồng sáng phát ra hướng đến một nơi nào đó: chiếu đèn pin vào mặt * ngọn đèn chiếu sáng khắp nhà",
    example: "chiếu đèn pin vào mặt * ngọn đèn chiếu sáng khắp nhà",
  },
  {
    word: "chiếu",
    part_of_speech: "động từ",
    meaning:
      "chiếu sáng qua phim để làm hiện hình lên màn ảnh: rạp chiếu phim * phim đã chiếu được hai tập",
    example: "rạp chiếu phim * phim đã chiếu được hai tập",
  },
  {
    word: "chiếu",
    part_of_speech: "động từ",
    meaning:
      "biểu diễn một hình bằng cách kẻ qua từng điểm của hình ấy những đường thẳng song song với một phương cố định (hoặc cùng đi qua một điểm cố định) rồi lấy hình tạo nên bởi các giao điểm của những đường thẳng này với một đường thẳng cố định hoặc mặt phẳng cố định.",
    example: "chiếu hướng nam mà đi",
  },
  {
    word: "chiếu",
    part_of_speech: "động từ",
    meaning: "nhằm thẳng đến, hướng thẳng đến: chiếu hướng nam mà đi",
    example: "đấm tốt chiếu tướng",
  },
  {
    word: "chiếu",
    part_of_speech: "động từ",
    meaning:
      "nhằm thẳng và uy hiếp trực tiếp con tướng hoặc con vua của đối phương trong cờ tướng, cờ vua: đấm tốt chiếu tướng",
    example: "chiếu theo pháp luật mà thi hành",
  },
  {
    word: "chiêu an",
    part_of_speech: "động từ",
    meaning: "(cũ) kêu gọi kẻ chống đối đầu hàng để cho yên ổn.",
    example: "vua hạ chiếu chiêu an",
  },
  {
    word: "chiều chiều",
    part_of_speech: "danh từ",
    meaning:
      'chiều này sang chiều khác, chiều nào cũng thế (nói về hành động lặp đi lặp lại theo thời gian): "Chiều chiều ra đứng ngõ sau, Ngó về quê mẹ ruột đau chín chiều." (ca dao)',
    example:
      'Chiều chiều ra đứng ngõ sau, Ngó về quê mẹ ruột đau chín chiều." (ca dao)',
  },
  {
    word: "chiêu binh mãi mã",
    part_of_speech: "",
    meaning:
      "(cũ) chiêu mộ binh lính, mua ngựa chiến để chuẩn bị chiến tranh: chiêu binh mãi mã chờ ngày xuất quân",
    example: "chiêu binh mãi mã chờ ngày xuất quân",
  },
  {
    word: "chiếu chỉ",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) chiếu thư và thánh chỉ; những điều vua công bố và ra lệnh bằng văn bản (nói khái quát): vua xuống chiếu chỉ",
    example: "vua xuống chiếu chỉ",
  },
  {
    word: "chiếu bóng",
    part_of_speech: "động từ",
    meaning:
      "chiếu hình ảnh thu được qua phim lên màn ảnh để xem: buổi chiếu phim * rạp chiếu phim",
    example: "buổi chiếu phim * rạp chiếu phim",
  },
  {
    word: "chiêu dân",
    part_of_speech: "động từ",
    meaning: "chiêu mộ dân: chiêu dân lập ấp",
    example: "chiêu dân lập ấp",
  },
  {
    word: "chiêu đãi",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) đón tiếp và mời ăn tiệc, vui chơi (thường là long trọng): mở tiệc chiêu đãi * chiêu đãi bạn một chầu phở",
    example: "mở tiệc chiêu đãi * chiêu đãi bạn một chầu phở",
  },
  {
    word: "chiều chuộng",
    part_of_speech: "động từ",
    meaning:
      "hết sức chiều vì yêu, vì coi trọng (nói khái quát): chiều chuộng vợ con * được chiều chuộng từ thuở bé",
    example: "chiều chuộng vợ con * được chiều chuộng từ thuở bé",
  },
  {
    word: "chiêu đăm",
    part_of_speech: "",
    meaning:
      '(cũ) như đăm chiêu: "Gà kia mày gáy chiêu đăm, Để chủ tao nằm, tao ngủ chút nao." (ca dao)',
    example:
      'Gà kia mày gáy chiêu đăm, Để chủ tao nằm, tao ngủ chút nao." (ca dao)',
  },
  {
    word: "chiếu cố",
    part_of_speech: "động từ",
    meaning:
      "chú ý đến tình hình, hoàn cảnh riêng mà có sự cân nhắc, châm chước: chiếu cố đến người già và trẻ em * giảm nhẹ án tù vì chiếu cố hoàn cảnh phạm tội",
    example:
      "chiếu cố đến người già và trẻ em * giảm nhẹ án tù vì chiếu cố hoàn cảnh phạm tội",
  },
  {
    word: "chiếu cố",
    part_of_speech: "động từ",
    meaning:
      "(Kiểu cách) đặc biệt quan tâm và có phần trọng thị (đối với người dưới): cảm ơn bác đã chiếu cố đến thăm",
    example: "cảm ơn bác đã chiếu cố đến thăm",
  },
  {
    word: "chiếu đậu",
    part_of_speech: "danh từ",
    meaning: "chiếu cói loại tốt, màu trắng ngà: mua đôi chiếu đậu",
    example: "mua đôi chiếu đậu",
  },
  {
    word: "chiêu hàng",
    part_of_speech: "động từ",
    meaning: "(cũ) kêu gọi đầu hàng: hịch chiêu hàng",
    example: "hịch chiêu hàng",
  },
  {
    word: "chiêu hồn",
    part_of_speech: "động từ",
    meaning: "gọi hồn người chết về, theo mê tín: văn chiêu hồn",
    example: "văn chiêu hồn",
  },
  {
    word: "chiều hướng",
    part_of_speech: "danh từ",
    meaning:
      "hướng diễn biến, phát triển của sự việc, sự vật: sự việc diễn biến theo chiều hướng tốt * tốc độ sản xuất có chiều hướng giảm",
    example:
      "sự việc diễn biến theo chiều hướng tốt * tốc độ sản xuất có chiều hướng giảm",
  },
  {
    word: "chiều hôm",
    part_of_speech: "danh từ",
    meaning:
      '(văn chương) lúc mặt trời sắp lặn: nắng quái chiều hôm * "Chàng về để thiếp cho ai, Chiều hôm vắng vẻ, sớm mai lạnh lùng." (ca dao)',
    example:
      'nắng quái chiều hôm * "Chàng về để thiếp cho ai, Chiều hôm vắng vẻ, sớm mai lạnh lùng." (ca dao)',
  },
  {
    word: "chiếu manh",
    part_of_speech: "danh từ",
    meaning:
      'manh chiếu rách: "Vai mang một tấm tơi chằm, Đầu bịt khăn chế mình nằm chiếu manh." (MPXH)',
    example:
      'Vai mang một tấm tơi chằm, Đầu bịt khăn chế mình nằm chiếu manh." (MPXH)',
  },
  {
    word: "chiêu khách",
    part_of_speech: "động từ",
    meaning: "tìm cách thu hút khách hàng: khuyến mãi để chiêu khách",
    example: "khuyến mãi để chiêu khách",
  },
  {
    word: "chiêu hồi",
    part_of_speech: "động từ",
    meaning:
      "kêu gọi trở về (từ của chính quyền Sài Gòn trước 1975 chỉ chính sách dụ dỗ, mua chuộc, cưỡng ép một số người rời bỏ hàng ngũ kháng chiến mà đầu hàng họ): địch kêu gọi chiêu hồi",
    example: "địch kêu gọi chiêu hồi",
  },
  {
    word: "chiếu lệ",
    part_of_speech: "",
    meaning:
      "(làm việc gì) chỉ theo lệ thường, theo lẽ thường, cốt cho có mà thôi: hỏi thăm vài câu chiếu lệ * làm chiếu lệ cho xong",
    example: "hỏi thăm vài câu chiếu lệ * làm chiếu lệ cho xong",
  },
  {
    word: "chiêu mộ",
    part_of_speech: "động từ",
    meaning:
      "(cũ) tìm người ở khắp nơi và tập hợp lại để làm việc gì (nói khái quát): chiêu mộ binh sĩ",
    example: "chiêu mộ binh sĩ",
  },
  {
    word: "chiếu phim",
    part_of_speech: "động từ",
    meaning:
      "chiếu hình ảnh thu được qua phim lên màn ảnh để xem: buổi chiếu phim * rạp chiếu phim",
    example: "buổi chiếu phim * rạp chiếu phim",
  },
  {
    word: "chiếu thư",
    part_of_speech: "danh từ",
    meaning: "(cũ) tờ chiếu của vua: bức chiếu thư",
    example: "bức chiếu thư",
  },
  {
    word: "chiêu sinh",
    part_of_speech: "động từ",
    meaning:
      "(trường học) mời gọi người đến đăng kí theo học (bằng một hình thức nhất định nào đó): chiêu sinh khoá học mới",
    example: "chiêu sinh khoá học mới",
  },
  {
    word: "chiều tối",
    part_of_speech: "danh từ",
    meaning: "lúc mới bắt đầu tối: đi từ mờ sáng đến chiều tối mới về",
    example: "đi từ mờ sáng đến chiều tối mới về",
  },
  {
    word: "chiêu thức",
    part_of_speech: "danh từ",
    meaning:
      "chiêu, cách thức (nói khái quát): áp dụng những chiêu thức khuyến mãi hấp dẫn",
    example: "áp dụng những chiêu thức khuyến mãi hấp dẫn",
  },
  {
    word: "chiều qua",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) chiều hôm qua (nói tắt): đi từ chiều qua",
    example: "đi từ chiều qua",
  },
  {
    word: "chiếu xạ",
    part_of_speech: "động từ",
    meaning:
      "chiếu tia bức xạ lên một phần hoặc toàn bộ đối tượng nhằm một mục đích nào đó: trị liệu bằng chiếu xạ",
    example: "trị liệu bằng chiếu xạ",
  },
  {
    word: "chiếu tướng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nhìn thẳng vào mặt: bị chiếu tướng, cô bé đỏ mặt * ngồi chiếu tướng",
    example: "bị chiếu tướng, cô bé đỏ mặt * ngồi chiếu tướng",
  },
  {
    word: "chiều tà",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương) khoảng thời gian về chiều, lúc mặt trời xế bóng: buổi chiều tà * ánh chiều tà",
    example: "buổi chiều tà * ánh chiều tà",
  },
  {
    word: "chiêu tập",
    part_of_speech: "động từ",
    meaning:
      "(cũ) làm cho người từ nhiều nơi tập hợp lại để cùng làm việc gì: chiêu tập binh mã",
    example: "chiêu tập binh mã",
  },
  {
    word: "chìm",
    part_of_speech: "động từ",
    meaning:
      "di chuyển từ trên mặt nước hoặc mặt chất lỏng xuống phía đáy, do tác dụng của trọng lượng: tảng đá chìm hẳn xuống đáy sông * con tàu đang chìm dần * lớp đất cát chìm xuống đáy bể lọc",
    example:
      "tảng đá chìm hẳn xuống đáy sông * con tàu đang chìm dần * lớp đất cát chìm xuống đáy bể lọc",
  },
  {
    word: "chìm",
    part_of_speech: "động từ",
    meaning: "ở sâu dưới mặt nước, không nổi trên mặt nước: cá rô phi ăn chìm",
    example: "cá rô phi ăn chìm",
  },
  {
    word: "chìm",
    part_of_speech: "động từ",
    meaning:
      "ở sâu dưới bề mặt, không nhô lên: lô cốt chìm * khắc chữ chìm * đường dây điện đi chìm trong tường",
    example: "lô cốt chìm * khắc chữ chìm * đường dây điện đi chìm trong tường",
  },
  {
    word: "chìm",
    part_of_speech: "động từ",
    meaning:
      "bị phủ bởi một khối, lớp gì đó, làm cho bị che lấp, bị lấn át: chìm sâu trong lớp đất đá * rừng núi chìm trong màn đêm",
    example: "chìm sâu trong lớp đất đá * rừng núi chìm trong màn đêm",
  },
  {
    word: "chìm",
    part_of_speech: "động từ",
    meaning:
      "lắng xuống, biểu hiện sự kém sôi nổi, kém hoạt động: phong trào thi đua có phần chìm xuống * không khí buổi họp bỗng dưng chìm hẳn",
    example:
      "phong trào thi đua có phần chìm xuống * không khí buổi họp bỗng dưng chìm hẳn",
  },
  {
    word: "chìm đắm",
    part_of_speech: "động từ",
    meaning:
      "bị bao phủ hoàn toàn bởi một cái gì có phạm vi tác động lớn: cảnh vật chìm đắm trong màn sương * con tàu bị chìm đắm giữa biển khơi",
    example:
      "cảnh vật chìm đắm trong màn sương * con tàu bị chìm đắm giữa biển khơi",
  },
  {
    word: "chìm đắm",
    part_of_speech: "động từ",
    meaning:
      "mắc sâu vào cái gì đó, khó thoát ra khỏi (thường là cái không hay): chìm đắm trong vòng truỵ lạc",
    example: "chìm đắm trong vòng truỵ lạc",
  },
  {
    word: "chim",
    part_of_speech: "danh từ",
    meaning:
      "động vật có xương sống, đẻ trứng, đầu có mỏ, thân phủ lông vũ, có cánh để bay: con chim non * chim hót líu lo",
    example: "con chim non * chim hót líu lo",
  },
  {
    word: "chim",
    part_of_speech: "động từ",
    meaning:
      "(cũ, thông tục) tán tỉnh, ve vãn (nói về quan hệ nam nữ): chim gái",
    example: "chim gái",
  },
  {
    word: "chim chuột",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) tán tỉnh, ve vãn một cách thô lỗ (nói khái quát): giở trò chim chuột",
    example: "giở trò chim chuột",
  },
  {
    word: "chim chóc",
    part_of_speech: "danh từ",
    meaning: "chim (ở ngoài tự nhiên; nói khái quát): chim chóc trong rừng",
    example: "chim chóc trong rừng",
  },
  {
    word: "chim cút",
    part_of_speech: "danh từ",
    meaning:
      "chim nhỏ cùng họ với gà, đuôi cộc, chân ngắn, lông màu nâu xám, thường sống ở đồi cỏ, lủi rất nhanh trong bụi cây, cũng được nuôi để lấy thịt, trứng: béo như con cun cút",
    example: "béo như con cun cút",
  },
  {
    word: "chim muông",
    part_of_speech: "danh từ",
    meaning:
      "chim và thú (nói khái quát): săn bắt chim muông * cả khu rừng vắng lặng không một bóng chim muông",
    example:
      "săn bắt chim muông * cả khu rừng vắng lặng không một bóng chim muông",
  },
  {
    word: "chìm nghỉm",
    part_of_speech: "động từ",
    meaning:
      "chìm hẳn, không còn thấy tăm tích gì trên mặt nước: hòn đá rơi xuống nước chìm nghỉm",
    example: "hòn đá rơi xuống nước chìm nghỉm",
  },
  {
    word: "chìm ngập",
    part_of_speech: "động từ",
    meaning:
      "bị bao phủ, che lấp hoàn toàn trên một diện rộng: chìm ngập trong công việc * thành phố chìm ngập trong bóng đêm",
    example: "chìm ngập trong công việc * thành phố chìm ngập trong bóng đêm",
  },
  {
    word: "chìm ngập",
    part_of_speech: "động từ",
    meaning:
      "ngập sâu vào một việc xấu, hoặc một trạng thái tâm lí xấu: chìm ngập trong tệ cờ bạc, rượu chè * chìm ngập trong suy tư, buồn thảm",
    example:
      "chìm ngập trong tệ cờ bạc, rượu chè * chìm ngập trong suy tư, buồn thảm",
  },
  {
    word: "chìm nổi",
    part_of_speech: "tính từ",
    meaning:
      'lúc chìm lúc nổi, thường nói về cảnh ngộ long đong, vất vả: cuộc đời chìm nổi * "Hoa trôi nước chảy xuôi dòng, Xót thân chìm nổi, đau lòng hợp tan!" (TKiều)',
    example:
      'cuộc đời chìm nổi * "Hoa trôi nước chảy xuôi dòng, Xót thân chìm nổi, đau lòng hợp tan!" (TKiều)',
  },
  {
    word: "chim sa cá lặn",
    part_of_speech: "",
    meaning:
      "(cũ, văn chương) ví nhan sắc đẹp tuyệt trần của người phụ nữ: nhan sắc chim sa cá lặn",
    example: "nhan sắc chim sa cá lặn",
  },
  {
    word: "chin chít",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng kêu nhỏ và liên tiếp giống như tiếng chuột hoặc tiếng chim con kêu: chuột con kêu chin chít",
    example: "chuột con kêu chin chít",
  },
  {
    word: "chín",
    part_of_speech: "danh từ",
    meaning:
      "số (ghi bằng 9) liền sau số tám trong dãy số tự nhiên: ba trăm lẻ chín * chín sáu (kng; chín mươi sáu)",
    example: "ba trăm lẻ chín * chín sáu (kng; chín mươi sáu)",
  },
  {
    word: "chín",
    part_of_speech: "danh từ",
    meaning:
      "(quả, hạt hoặc hoa) ở vào giai đoạn phát triển đầy đủ nhất, thường có màu đỏ hoặc vàng, có hương thơm, vị ngon: vườn cam chín đỏ * lúa chín đầy đồng * hoa ngâu chín",
    example: "vườn cam chín đỏ * lúa chín đầy đồng * hoa ngâu chín",
  },
  {
    word: "chín",
    part_of_speech: "danh từ",
    meaning:
      "(sâu, tằm) ở vào giai đoạn phát triển đầy đủ, sắp làm kén, hoá nhộng: lứa tằm vừa chín * sâu sắp chín",
    example: "lứa tằm vừa chín * sâu sắp chín",
  },
  {
    word: "chín",
    part_of_speech: "danh từ",
    meaning:
      "(thức ăn) được nấu nướng kĩ đến mức ăn được: thịt luộc chưa chín * nồi khoai đã chín",
    example: "thịt luộc chưa chín * nồi khoai đã chín",
  },
  {
    word: "chín",
    part_of_speech: "danh từ",
    meaning:
      "kĩ lưỡng, thấu đáo, đầy đủ mọi khía cạnh: phải suy nghĩ cho thật chín rồi hãy làm",
    example: "phải suy nghĩ cho thật chín rồi hãy làm",
  },
  {
    word: "chín",
    part_of_speech: "danh từ",
    meaning:
      "(màu da mặt, môi) đỏ ửng lên: ngượng chín cả mặt * đôi gò má chín đỏ vì nắng * làn môi chín mọng",
    example:
      "ngượng chín cả mặt * đôi gò má chín đỏ vì nắng * làn môi chín mọng",
  },
  {
    word: "chìm xuồng",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) (vụ việc tiêu cực) ở tình trạng chìm xuống, do đã được cố ý cho qua, không giải quyết, không đề cập tới nữa: kiên quyết không để chìm xuồng vụ chạy trường * vụ án bị chìm xuồng, gây bất bình trong dư luận",
    example:
      "kiên quyết không để chìm xuồng vụ chạy trường * vụ án bị chìm xuồng, gây bất bình trong dư luận",
  },
  {
    word: "chìm xuồng",
    part_of_speech: "",
    meaning: "thất bại, phá sản: công ti đứng trước nguy cơ chìm xuồng",
    example: "công ti đứng trước nguy cơ chìm xuồng",
  },
  {
    word: "chim trời cá nước",
    part_of_speech: "",
    meaning:
      'chim trên trời, cá dưới nước; ví sự xa cách, khó có thể gặp gỡ, sum họp được với nhau: "Chim trời cá nước chi đây, Cá lội đằng cá, chuồn bay đằng chuồn." (ca dao)',
    example:
      'Chim trời cá nước chi đây, Cá lội đằng cá, chuồn bay đằng chuồn." (ca dao)',
  },
  {
    word: "chín chắn",
    part_of_speech: "tính từ",
    meaning:
      "thận trọng, không nông nổi, không bộp chộp: suy nghĩ chín chắn * càng lớn, nó càng chín chắn hơn",
    example: "suy nghĩ chín chắn * càng lớn, nó càng chín chắn hơn",
  },
  {
    word: "chỉn chu",
    part_of_speech: "tính từ",
    meaning:
      "chu đáo, cẩn thận, không chê trách gì được: quần áo chỉn chu * tính toán rất chỉn chu",
    example: "quần áo chỉn chu * tính toán rất chỉn chu",
  },
  {
    word: "chín cây",
    part_of_speech: "tính từ",
    meaning: "(quả cây) chín khi đang còn trên cây: chuối chín cây",
    example: "chuối chín cây",
  },
  {
    word: "chỉn",
    part_of_speech: "phụ từ",
    meaning:
      '(cũ) chỉ: "Thân em như chiếc thuyền be, Chỉn e gió ngược, thêm dè sóng xao." (ca dao)',
    example:
      'Thân em như chiếc thuyền be, Chỉn e gió ngược, thêm dè sóng xao." (ca dao)',
  },
  {
    word: "chín bói",
    part_of_speech: "động từ",
    meaning:
      "chín lác đác một vài quả trong thời kì đầu cây mới có quả: lứa xoài đã bắt đầu chín bói",
    example: "lứa xoài đã bắt đầu chín bói",
  },
  {
    word: "chín mé",
    part_of_speech: "danh từ",
    meaning: "chứng viêm, tấy ở cạnh móng tay, móng chân: ngón chân bị chín mé",
    example: "ngón chân bị chín mé",
  },
  {
    word: "chín người mười ý",
    part_of_speech: "",
    meaning:
      "tả tình trạng mỗi người một ý khác nhau nên rất khó thống nhất ý kiến: chín người mười ý, chẳng biết đường nào mà lần",
    example: "chín người mười ý, chẳng biết đường nào mà lần",
  },
  {
    word: "chín muồi",
    part_of_speech: "tính từ",
    meaning: "(quả cây) rất chín, đạt đến độ ngon nhất: chuối chín muồi",
    example: "chuối chín muồi",
  },
  {
    word: "chín muồi",
    part_of_speech: "tính từ",
    meaning:
      "đạt đến độ phát triển đầy đủ nhất, có thể tác động vào để thay đổi trạng thái hoặc chuyển giai đoạn phát triển: điều kiện chín muồi * thời cơ đã chín muồi",
    example: "điều kiện chín muồi * thời cơ đã chín muồi",
  },
  {
    word: "chín mõm",
    part_of_speech: "tính từ",
    meaning:
      "(quả cây) chín đến mức trở nên mềm nhũn, dễ giập nát: quả đu đủ chín mõm",
    example: "quả đu đủ chín mõm",
  },
  {
    word: "chín rộ",
    part_of_speech: "động từ",
    meaning: "(quả cây, hạt) chín đều khắp cả loạt: vườn cam chín rộ",
    example: "vườn cam chín rộ",
  },
  {
    word: "chín ép",
    part_of_speech: "tính từ",
    meaning:
      "(quả cây) chín một cách không được tự nhiên, khi điều kiện chưa đủ: chuối chín ép * hồng xiêm chín ép, ăn hơi chát",
    example: "chuối chín ép * hồng xiêm chín ép, ăn hơi chát",
  },
  {
    word: "chín chữ cù lao",
    part_of_speech: "",
    meaning:
      '(văn chương) chín điều khó nhọc (sinh đẻ, nuôi nấng, dạy dỗ, v.v.) của cha mẹ nuôi con; dùng để chỉ công lao khó nhọc của cha mẹ đối với con cái, nói chung: "Đội ơn chín chữ cù lao, Sinh thành kể mấy non cao cho bằng." (ca dao)',
    example:
      'Đội ơn chín chữ cù lao, Sinh thành kể mấy non cao cho bằng." (ca dao)',
  },
  {
    word: "chín rục",
    part_of_speech: "tính từ",
    meaning:
      "(quả cây, hạt) chín quá, đến mức mềm nhũn, bấy ra: quả chuối chín rục",
    example: "quả chuối chín rục",
  },
  {
    word: "chín suối",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) thế giới của người chết, nơi âm phủ: ngậm cười chín suối * "Dầu anh lỗi đạo tình thâm, Hồn về chín suối, xác cầm dương gian." (ca dao)',
    example:
      'ngậm cười chín suối * "Dầu anh lỗi đạo tình thâm, Hồn về chín suối, xác cầm dương gian." (ca dao)',
  },
  {
    word: "chĩnh",
    part_of_speech: "danh từ",
    meaning:
      "đồ đựng bằng đất nung, miệng hơi thu lại, đáy thót, nhỏ hơn chum: chĩnh mắm",
    example: "chĩnh mắm",
  },
  {
    word: "chính",
    part_of_speech: "tính từ",
    meaning:
      "quan trọng hơn cả so với những cái khác cùng loạI: đi theo lối cổng chính * nhiệm vụ chính * nguồn thu nhập chính * tự mình là chính",
    example:
      "đi theo lối cổng chính * nhiệm vụ chính * nguồn thu nhập chính * tự mình là chính",
  },
  {
    word: "chính",
    part_of_speech: "tính từ",
    meaning:
      "rất ngay thẳng, rất đúng đắn về mặt đạo đức: nêu gương cần, kiệm, liêm, chính * phân biệt chính - tà",
    example: "nêu gương cần, kiệm, liêm, chính * phân biệt chính - tà",
  },
  {
    word: "chính",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý nhấn mạnh rằng đích xác như vậy, không phải ai khác, không phải gì khác: chính nó chứ không phải ai khác * chính mắt tôi trông thấy",
    example: "chính nó chứ không phải ai khác * chính mắt tôi trông thấy",
  },
  {
    word: "chín tới",
    part_of_speech: "động từ",
    meaning:
      "(cơm hoặc hoa quả) vừa đến độ chín, ăn ngon: quả đu đủ chín tới * nồi cơm vừa chín tới",
    example: "quả đu đủ chín tới * nồi cơm vừa chín tới",
  },
  {
    word: "chín tầng mây",
    part_of_speech: "",
    meaning:
      "chỉ khoảng rất cao trên không trung: cánh diều lơ lửng trên chín tầng mây",
    example: "cánh diều lơ lửng trên chín tầng mây",
  },
  {
    word: "chỉnh",
    part_of_speech: "tính từ",
    meaning:
      "cân đối, có trật tự hợp lí, đúng quy tắc giữa các thành phần cấu tạo: đôi câu đối rất chỉnh",
    example: "đôi câu đối rất chỉnh",
  },
  {
    word: "chỉnh",
    part_of_speech: "động từ",
    meaning:
      "sửa lại vị trí, tư thế cho ngay ngắn, cho đúng: chỉnh lại đường ngắm * chỉnh lại thế ngồi trước khi chụp ảnh",
    example: "chỉnh lại đường ngắm * chỉnh lại thế ngồi trước khi chụp ảnh",
  },
  {
    word: "chỉnh",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) phê bình một cách gay gắt (người cấp dưới) để uốn nắn lại cho đúng: bị cấp trên chỉnh cho một trận",
    example: "bị cấp trên chỉnh cho một trận",
  },
  {
    word: "chính âm",
    part_of_speech: "danh từ",
    meaning: "cách phát âm được coi là chuẩn: chính âm của tiếng Việt",
    example: "chính âm của tiếng Việt",
  },
  {
    word: "chinh an",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) yên ngựa của người đi xa; thường dùng để chỉ việc đi đường xa hoặc đi đánh trận ở nơi xa: "Dặm hồng bụi cuốn chinh an, Trông người đã khuất mấy ngàn dâu xanh." (TKiều)',
    example:
      'Dặm hồng bụi cuốn chinh an, Trông người đã khuất mấy ngàn dâu xanh." (TKiều)',
  },
  {
    word: "chình",
    part_of_speech: "danh từ",
    meaning:
      '(phương ngữ) chĩnh nhỏ: "Xa sông xách nước bằng chình, Sẩy tay rớt xuống, gẫm mình vô duyên." (ca dao)',
    example:
      'Xa sông xách nước bằng chình, Sẩy tay rớt xuống, gẫm mình vô duyên." (ca dao)',
  },
  {
    word: "chính biến",
    part_of_speech: "danh từ",
    meaning:
      "biến cố chính trị do các tập đoàn thống trị gây ra nhằm giành giật chính quyền: cuộc chính biến * phát động chính biến",
    example: "cuộc chính biến * phát động chính biến",
  },
  {
    word: "chinh chiến",
    part_of_speech: "động từ",
    meaning:
      "chiến đấu ngoài mặt trận (nói khái quát): đi chinh chiến * mải mê chinh chiến",
    example: "đi chinh chiến * mải mê chinh chiến",
  },
  {
    word: "chĩnh chện",
    part_of_speech: "tính từ",
    meaning: "có dáng vẻ đàng hoàng, bệ vệ: ngồi chĩnh chện trên sập",
    example: "ngồi chĩnh chện trên sập",
  },
  {
    word: "chính chuyên",
    part_of_speech: "tính từ",
    meaning: "(cũ) một lòng chung thuỷ với chồng: gái chính chuyên",
    example: "gái chính chuyên",
  },
  {
    word: "chính cung",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, hiếm) cung ở chính giữa, nơi hoàng hậu ở; thường dùng để gọi hoàng hậu: chính cung hoàng hậu",
    example: "chính cung hoàng hậu",
  },
  {
    word: "chính danh",
    part_of_speech: "tính từ",
    meaning: "(cũ) như đích danh: nêu chính danh ông giám đốc",
    example: "nêu chính danh ông giám đốc",
  },
  {
    word: "chính danh",
    part_of_speech: "tính từ",
    meaning:
      "có nội dung, có chất lượng đúng với tên gọi: hàng nội địa chính danh * nhà khoa học chính danh",
    example: "hàng nội địa chính danh * nhà khoa học chính danh",
  },
  {
    word: "chính cống",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) đích thực, đúng nguồn gốc: ông là người miền Nam chính cống * hàng ngoại chính cống",
    example: "ông là người miền Nam chính cống * hàng ngoại chính cống",
  },
  {
    word: "chính diện",
    part_of_speech: "danh từ",
    meaning:
      "phía trước mặt: phía chính diện của ngôi nhà * tấn công chính diện vào đội hình địch",
    example:
      "phía chính diện của ngôi nhà * tấn công chính diện vào đội hình địch",
  },
  {
    word: "chính diện",
    part_of_speech: "danh từ",
    meaning:
      "mặt tốt, mặt tích cực (thường nói về nhân vật trong tác phẩm văn học nghệ thuật): nhân vật chính diện của tác phẩm * vai chính diện",
    example: "nhân vật chính diện của tác phẩm * vai chính diện",
  },
  {
    word: "chính đại quang minh",
    part_of_speech: "",
    meaning:
      "ngay thẳng, rõ ràng, không chút mờ ám: một con người quang minh chính đại",
    example: "một con người quang minh chính đại",
  },
  {
    word: "chính đảng",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức chính trị đại diện cho một giai cấp, một tầng lớp hoặc một tập đoàn xã hội, đấu tranh cho quyền lợi của giai cấp, tầng lớp, tập đoàn xã hội ấy: chính đảng của giai cấp công nhân",
    example: "chính đảng của giai cấp công nhân",
  },
  {
    word: "chính đạo",
    part_of_speech: "danh từ",
    meaning:
      "con đường ngay thẳng, đúng đắn: làm theo chính đạo * giữ chính đạo",
    example: "làm theo chính đạo * giữ chính đạo",
  },
  {
    word: "chính hiệu",
    part_of_speech: "tính từ",
    meaning:
      "đúng thực với tên gọi, đúng với nguồn gốc: hàng ngoại chính hiệu * một tay chơi chính hiệu",
    example: "hàng ngoại chính hiệu * một tay chơi chính hiệu",
  },
  {
    word: "chính đáng",
    part_of_speech: "tính từ",
    meaning:
      "hợp lí và hợp pháp: nguyện vọng chính đáng * bảo đảm quyền lợi chính đáng của người lao động",
    example:
      "nguyện vọng chính đáng * bảo đảm quyền lợi chính đáng của người lao động",
  },
  {
    word: "chỉnh đốn",
    part_of_speech: "động từ",
    meaning:
      "sửa sang, sắp đặt lại cho đúng phép tắc, cho có nền nếp: chỉnh đốn hàng ngũ * chỉnh đốn lại tác phong và nền nếp của học sinh",
    example:
      "chỉnh đốn hàng ngũ * chỉnh đốn lại tác phong và nền nếp của học sinh",
  },
  {
    word: "chính giới",
    part_of_speech: "danh từ",
    meaning: "giới hoạt động chính trị: theo dư luận của chính giới",
    example: "theo dư luận của chính giới",
  },
  {
    word: "chình ình",
    part_of_speech: "tính từ",
    meaning:
      "(nằm, đứng, ngồi) lù lù trước mắt mọi người: nằm chình ình ở giữa nhà",
    example: "nằm chình ình ở giữa nhà",
  },
  {
    word: "chỉnh hình",
    part_of_speech: "danh từ",
    meaning:
      "bộ môn y học nghiên cứu và điều trị những tật (có từ lúc mới sinh hoặc về sau mới có) của xương, khớp, cơ, v.v., khôi phục ngoại hình và cơ năng sinh lí: phẫu thuật chỉnh hình * chỉnh hình khớp gối",
    example: "phẫu thuật chỉnh hình * chỉnh hình khớp gối",
  },
  {
    word: "chính khách",
    part_of_speech: "danh từ",
    meaning:
      "người chuyên hoạt động chính trị, thường có tiếng tăm nhất định: một chính khách nổi tiếng",
    example: "một chính khách nổi tiếng",
  },
  {
    word: "chính kiến",
    part_of_speech: "danh từ",
    meaning:
      "nhận thức và quan điểm chính trị: chính kiến đúng đắn * bất đồng về chính kiến",
    example: "chính kiến đúng đắn * bất đồng về chính kiến",
  },
  {
    word: "chính kiến",
    part_of_speech: "danh từ",
    meaning:
      "ý kiến, quan điểm riêng trước sự việc gì: bảo vệ chính kiến của mình",
    example: "bảo vệ chính kiến của mình",
  },
  {
    word: "chỉnh lí",
    part_of_speech: "động từ",
    meaning:
      "sửa chữa, sắp xếp lại cho đúng hơn và gọn gàng hơn: chỉnh lí lại bản thảo trước khi in * kiểm tra, chỉnh lí tài liệu trước khi công bố chính thức",
    example:
      "chỉnh lí lại bản thảo trước khi in * kiểm tra, chỉnh lí tài liệu trước khi công bố chính thức",
  },
  {
    word: "chính khoá",
    part_of_speech: "danh từ",
    meaning: "chương trình học tập chính thức, bắt buộc: bài học chính khoá",
    example: "bài học chính khoá",
  },
  {
    word: "chỉnh lưu",
    part_of_speech: "động từ",
    meaning:
      "biến dòng điện xoay chiều thành dòng điện một chiều: chỉnh lưu dòng điện",
    example: "chỉnh lưu dòng điện",
  },
  {
    word: "chỉnh lý",
    part_of_speech: "động từ",
    meaning:
      "sửa chữa, sắp xếp lại cho đúng hơn và gọn gàng hơn: chỉnh lí lại bản thảo trước khi in * kiểm tra, chỉnh lí tài liệu trước khi công bố chính thức",
    example:
      "chỉnh lí lại bản thảo trước khi in * kiểm tra, chỉnh lí tài liệu trước khi công bố chính thức",
  },
  {
    word: "chính khí",
    part_of_speech: "danh từ",
    meaning: "(cũ) chí khí khảng khái, bất khuất: nêu cao chính khí",
    example: "nêu cao chính khí",
  },
  {
    word: "chính luận",
    part_of_speech: "danh từ",
    meaning:
      "thể văn phân tích, bình luận các vấn đề chính trị, xã hội đương thời: phong cách chính luận * văn chính luận",
    example: "phong cách chính luận * văn chính luận",
  },
  {
    word: "chính ngạch",
    part_of_speech: "tính từ",
    meaning:
      "thuộc ngạch chính, hạng chính: công chức chính ngạch * thuế chính ngạch * hàng nhập khẩu chính ngạch",
    example:
      "công chức chính ngạch * thuế chính ngạch * hàng nhập khẩu chính ngạch",
  },
  {
    word: "chính nghĩa",
    part_of_speech: "danh từ",
    meaning:
      "đạo lí công bằng, chính trực: sức mạnh của chính nghĩa tất thắng * bảo vệ chính nghĩa",
    example: "sức mạnh của chính nghĩa tất thắng * bảo vệ chính nghĩa",
  },
  {
    word: "chính nghĩa",
    part_of_speech: "tính từ",
    meaning:
      "hợp với chính nghĩa, vì chính nghĩa: hành động chính nghĩa * cuộc đấu tranh chính nghĩa",
    example: "hành động chính nghĩa * cuộc đấu tranh chính nghĩa",
  },
  {
    word: "chinh phụ",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, văn chương) vợ của người đàn ông đang đi đánh trận thời phong kiến: chinh phụ chờ chồng",
    example: "chinh phụ chờ chồng",
  },
  {
    word: "chính phủ",
    part_of_speech: "danh từ",
    meaning:
      "cơ quan hành pháp và hành chính cao nhất của một nước, thực hiện công việc quản lí nhà nước ở cấp trung ương: thủ tướng chính phủ * dự án được chính phủ phê duyệt",
    example: "thủ tướng chính phủ * dự án được chính phủ phê duyệt",
  },
  {
    word: "chinh phu",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) người đàn ông đi đánh trận thời phong kiến: khách chinh phu * "Hồn tử sĩ gió ù ù thổi, Mặt chinh phu trăng dõi dõi soi." (CPN)',
    example:
      'khách chinh phu * "Hồn tử sĩ gió ù ù thổi, Mặt chinh phu trăng dõi dõi soi." (CPN)',
  },
  {
    word: "chính phẩm",
    part_of_speech: "danh từ",
    meaning:
      "sản phẩm có chất lượng đúng tiêu chuẩn quy định; phân biệt với thứ phẩm: hàng chính phẩm",
    example: "hàng chính phẩm",
  },
  {
    word: "chính quả",
    part_of_speech: "danh từ",
    meaning:
      "kết quả tu hành đắc đạo, theo quan niệm của đạo Phật: tu thành chính quả",
    example: "tu thành chính quả",
  },
  {
    word: "chính qui",
    part_of_speech: "tính từ",
    meaning:
      "phù hợp với những gì được chính thức quy định, hoặc phù hợp với tiêu chuẩn được công nhận nói chung: quân đội chính quy * cán bộ chuyên môn được đào tạo chính quy",
    example: "quân đội chính quy * cán bộ chuyên môn được đào tạo chính quy",
  },
  {
    word: "chinh phục",
    part_of_speech: "động từ",
    meaning:
      "dùng vũ lực bắt nước khác hoặc dân tộc khác phải khuất phục: chính sách chinh phục thuộc địa của thực dân",
    example: "chính sách chinh phục thuộc địa của thực dân",
  },
  {
    word: "chinh phục",
    part_of_speech: "động từ",
    meaning:
      "nắm được quy luật của tự nhiên và vận dụng để phần nào tác động ngược lại, phần nào chi phối tự nhiên: hoài bão chinh phục vũ trụ * dự án chinh phục sao Hoả",
    example: "hoài bão chinh phục vũ trụ * dự án chinh phục sao Hoả",
  },
  {
    word: "chinh phục",
    part_of_speech: "động từ",
    meaning:
      "tác động đến đối phương, làm cho đối phương bị hấp dẫn mà hướng về phía mình: tiếng hát chinh phục lòng người * bị đối phương chinh phục",
    example: "tiếng hát chinh phục lòng người * bị đối phương chinh phục",
  },
  {
    word: "chính quy hoá",
    part_of_speech: "động từ",
    meaning: "làm cho trở thành chính quy: chính quy hoá quân đội",
    example: "chính quy hoá quân đội",
  },
  {
    word: "chính quy",
    part_of_speech: "tính từ",
    meaning:
      "phù hợp với những gì được chính thức quy định, hoặc phù hợp với tiêu chuẩn được công nhận nói chung: quân đội chính quy * cán bộ chuyên môn được đào tạo chính quy",
    example: "quân đội chính quy * cán bộ chuyên môn được đào tạo chính quy",
  },
  {
    word: "chính sách",
    part_of_speech: "danh từ",
    meaning:
      "sách lược và các chủ trương, biện pháp cụ thể để thực hiện đường lối và nhiệm vụ trong một thời kì lịch sử nhất định: chính sách kinh tế * chính sách mở cửa",
    example: "chính sách kinh tế * chính sách mở cửa",
  },
  {
    word: "chính quyền",
    part_of_speech: "danh từ",
    meaning:
      "quyền điều khiển bộ máy nhà nước: đấu tranh giành chính quyền * nắm chính quyền",
    example: "đấu tranh giành chính quyền * nắm chính quyền",
  },
  {
    word: "chính quyền",
    part_of_speech: "danh từ",
    meaning:
      "bộ máy điều hành, quản lí công việc của nhà nước: đại diện chính quyền * bộ máy chính quyền * các cấp chính quyền",
    example: "đại diện chính quyền * bộ máy chính quyền * các cấp chính quyền",
  },
  {
    word: "chính sách xã hội",
    part_of_speech: "danh từ",
    meaning:
      "chính sách giải quyết các vấn đề xã hội nhằm tác động trực tiếp vào con người, điều chỉnh quan hệ, lợi ích giữa con người với con người, con người với xã hội: gia đình thương binh, liệt sĩ được hưởng chính sách xã hội",
    example: "gia đình thương binh, liệt sĩ được hưởng chính sách xã hội",
  },
  {
    word: "chính sử",
    part_of_speech: "danh từ",
    meaning:
      "sử do nhà nước phong kiến chính thức tổ chức biên soạn; phân biệt với dã sử: tư liệu chính sử * bộ chính sử triều Nguyễn",
    example: "tư liệu chính sử * bộ chính sử triều Nguyễn",
  },
  {
    word: "chính sự",
    part_of_speech: "danh từ",
    meaning: "(cũ) việc chính trị: bàn chính sự",
    example: "bàn chính sự",
  },
  {
    word: "chỉnh sửa",
    part_of_speech: "động từ",
    meaning:
      "chỉnh lại, sửa lại cho đúng, cho phù hợp (nói khái quát): chỉnh sửa câu chữ * điều luật đã được chỉnh sửa cho phù hợp",
    example: "chỉnh sửa câu chữ * điều luật đã được chỉnh sửa cho phù hợp",
  },
  {
    word: "chính tâm",
    part_of_speech: "",
    meaning:
      "(hiếm) lòng ngay thẳng hoặc làm cho lòng ngay thẳng, theo quan niệm của đạo nho: chính tâm của người quân tử",
    example: "chính tâm của người quân tử",
  },
  {
    word: "chính tả",
    part_of_speech: "danh từ",
    meaning:
      "cách viết chữ được coi là chuẩn: viết sai chính tả * giờ học chính tả * từ điển chính tả",
    example: "viết sai chính tả * giờ học chính tả * từ điển chính tả",
  },
  {
    word: "chỉnh tề",
    part_of_speech: "tính từ",
    meaning:
      "gọn gàng, ngay ngắn và đúng phép tắc: ăn mặc chỉnh tề * đội ngũ chỉnh tề",
    example: "ăn mặc chỉnh tề * đội ngũ chỉnh tề",
  },
  {
    word: "chính thị",
    part_of_speech: "trợ từ",
    meaning: "(hiếm) như đích thị: chính thị là lão ta ăn cắp",
    example: "chính thị là lão ta ăn cắp",
  },
  {
    word: "chính thể",
    part_of_speech: "danh từ",
    meaning:
      "hình thức tổ chức của một nhà nước: chính thể dân chủ * chính thể cộng hoà",
    example: "chính thể dân chủ * chính thể cộng hoà",
  },
  {
    word: "chính thức",
    part_of_speech: "tính từ",
    meaning:
      "do chính phủ hoặc cơ quan có quyền lực hợp pháp công bố hoặc đưa ra: bản tuyên bố chính thức của bộ ngoại giao * thông tin chưa chính thức",
    example:
      "bản tuyên bố chính thức của bộ ngoại giao * thông tin chưa chính thức",
  },
  {
    word: "chính thức",
    part_of_speech: "tính từ",
    meaning:
      "hợp với những tiêu chuẩn được công nhận, hoặc đúng thủ tục quy định: đại biểu chính thức * làm lễ chính thức kết hôn",
    example: "đại biểu chính thức * làm lễ chính thức kết hôn",
  },
  {
    word: "chính thống",
    part_of_speech: "tính từ",
    meaning:
      "thuộc dòng chính của một học phái, một tôn giáo, theo đúng tinh thần của người đề xướng, sáng lập ra học phái hoặc tôn giáo ấy: tôn giáo chính thống * học phái chính thống",
    example: "tôn giáo chính thống * học phái chính thống",
  },
  {
    word: "chính thống",
    part_of_speech: "tính từ",
    meaning:
      "được thừa nhận là chính thức trong một thời đại, một chế độ: tư tưởng chính thống * nền văn học chính thống",
    example: "tư tưởng chính thống * nền văn học chính thống",
  },
  {
    word: "chính thức hoá",
    part_of_speech: "động từ",
    meaning: "làm cho trở thành chính thức: chính thức hoá quan hệ ngoại giao",
    example: "chính thức hoá quan hệ ngoại giao",
  },
  {
    word: "chính tố",
    part_of_speech: "danh từ",
    meaning:
      "thành tố chính, trong quan hệ với thành tố phụ (gọi là phụ tố): danh ngữ có chính tố là một danh từ",
    example: "danh ngữ có chính tố là một danh từ",
  },
  {
    word: "chính tông",
    part_of_speech: "tính từ",
    meaning: "thuộc dòng chính: tôn giáo chính tông",
    example: "tôn giáo chính tông",
  },
  {
    word: "chính tông",
    part_of_speech: "tính từ",
    meaning: "đúng nguồn gốc, đúng dòng dõi: nhà nho chính tông",
    example: "nhà nho chính tông",
  },
  {
    word: "chính trị",
    part_of_speech: "danh từ",
    meaning:
      "những vấn đề về tổ chức và điều khiển bộ máy nhà nước, hoặc những hoạt động của một giai cấp, một chính đảng nhằm giành hoặc duy trì quyền điều khiển bộ máy nhà nước (nói tổng quát): đường lối chính trị * tổ chức chính trị * tình hình chính trị trong nước",
    example:
      "đường lối chính trị * tổ chức chính trị * tình hình chính trị trong nước",
  },
  {
    word: "chính trị",
    part_of_speech: "danh từ",
    meaning:
      "Chính trị còn được hiểu là chủ trương, chính sách của Đảng cầm quyền. Các chủ trương, chính sách này sẽ được cụ thể hóa thành pháp luật của Nhà nước.",
    example: "vững vàng về chính trị * cán bộ chính trị * ý thức chính trị",
  },
  {
    word: "chính trị",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) khéo léo, mềm mỏng trong quan hệ đối xử để đạt được mục đích mong muốn: một thái độ rất chính trị",
    example: "một thái độ rất chính trị",
  },
  {
    word: "chính trị gia",
    part_of_speech: "danh từ",
    meaning: "người chuyên hoạt động chính trị: một chính trị gia kì cựu",
    example: "một chính trị gia kì cựu",
  },
  {
    word: "chỉnh trang",
    part_of_speech: "động từ",
    meaning:
      "sửa sang, sắp đặt lại cho ngay ngắn, đẹp đẽ: chỉnh trang đường phố * chỉnh trang, tu sửa lại nhà cửa",
    example: "chỉnh trang đường phố * chỉnh trang, tu sửa lại nhà cửa",
  },
  {
    word: "chính trị phạm",
    part_of_speech: "danh từ",
    meaning:
      "người vì có những hoạt động chính trị nào đó mà bị chính phủ coi là phạm tội và bị kết án tù: ân xá chính trị phạm",
    example: "ân xá chính trị phạm",
  },
  {
    word: "chính trực",
    part_of_speech: "tính từ",
    meaning:
      "ngay thẳng, vô tư: một người công minh, chính trực * thanh liêm chính trực",
    example: "một người công minh, chính trực * thanh liêm chính trực",
  },
  {
    word: "chính xác",
    part_of_speech: "tính từ",
    meaning:
      "hoàn toàn đúng, không sai chút nào: con số chính xác * thông tin kịp thời và chính xác * đồng hồ chạy không chính xác",
    example:
      "con số chính xác * thông tin kịp thời và chính xác * đồng hồ chạy không chính xác",
  },
  {
    word: "chính trường",
    part_of_speech: "danh từ",
    meaning: "nơi diễn ra các hoạt động chính trị: tham gia chính trường",
    example: "tham gia chính trường",
  },
  {
    word: "chính vụ",
    part_of_speech: "tính từ",
    meaning: "(trồng trọt) thuộc về vụ chính trong năm: lúa chính vụ",
    example: "lúa chính vụ",
  },
  {
    word: "chính yếu",
    part_of_speech: "tính từ",
    meaning:
      "chính và quan trọng nhất; phân biệt với thứ yếu: lí do chính yếu * mục tiêu chính yếu",
    example: "lí do chính yếu * mục tiêu chính yếu",
  },
  {
    word: "chíp hôi",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) trẻ con, không đáng coi ra gì: đồ chíp hôi!",
    example: "đồ chíp hôi!",
  },
  {
    word: "chịt",
    part_of_speech: "động từ",
    meaning:
      "làm cho tắc lại, không thông bằng cách chặn ngang, giữ chặt, bóp chặt: chịt cửa hầm * chịt mất lối đi",
    example: "chịt cửa hầm * chịt mất lối đi",
  },
  {
    word: "chịt",
    part_of_speech: "động từ",
    meaning: "như chít: áo chặt, chịt lấy thân mình",
    example: "áo chặt, chịt lấy thân mình",
  },
  {
    word: "chịt",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) như rịt: bám chịt, không cho đi * giữ chịt lấy tờ báo, không cho ai xem",
    example: "bám chịt, không cho đi * giữ chịt lấy tờ báo, không cho ai xem",
  },
  {
    word: "chít",
    part_of_speech: "động từ",
    meaning: "quấn chặt khăn trên đầu: đầu chít khăn",
    example: "đầu chít khăn",
  },
  {
    word: "chít",
    part_of_speech: "động từ",
    meaning: "(đồ mặc) bó sát vào thân hình: áo chít lấy thân mình",
    example: "áo chít lấy thân mình",
  },
  {
    word: "chít",
    part_of_speech: "động từ",
    meaning: "khâu, may cho hẹp lại: quần chít ống",
    example: "quần chít ống",
  },
  {
    word: "chít",
    part_of_speech: "động từ",
    meaning:
      "bịt kín chỗ rò, chỗ hở bằng một chất gì đó: chít khe hở * chít lỗ thủng bằng nhựa đường",
    example: "chít khe hở * chít lỗ thủng bằng nhựa đường",
  },
  {
    word: "chíu chít",
    part_of_speech: "động từ",
    meaning:
      "từ mô phỏng tiếng chim, tiếng gà kêu: gà con lạc mẹ kêu chíu chít",
    example: "gà con lạc mẹ kêu chíu chít",
  },
  {
    word: "chíu chít",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) như chi chít (nhưng thường chỉ nói về quả): quả cây sai chíu chít",
    example: "quả cây sai chíu chít",
  },
  {
    word: "chiu chíu",
    part_of_speech: "động từ",
    meaning: "như chíu (nhưng ý liên tiếp và dồn dập): đạn bay chiu chíu",
    example: "đạn bay chiu chíu",
  },
  {
    word: "chịu đực",
    part_of_speech: "động từ",
    meaning:
      "(súc vật cái) để cho con đực giao cấu: lợn nái sắp đến kì chịu đực",
    example: "lợn nái sắp đến kì chịu đực",
  },
  {
    word: "chịu",
    part_of_speech: "động từ",
    meaning:
      "nhận lấy điều không hay, bất lợi cho mình: chịu tội * chịu đòn * chịu trách nhiệm * không chịu đầu hàng số phận",
    example:
      "chịu tội * chịu đòn * chịu trách nhiệm * không chịu đầu hàng số phận",
  },
  {
    word: "chịu",
    part_of_speech: "động từ",
    meaning:
      "thích ứng hoặc tiếp nhận một tác động nào đó, thường là không hay, từ bên ngoài: khả năng chịu lạnh tốt * chịu sự quản lí của bố mẹ * chịu ảnh hưởng trực tiếp của cơn bão",
    example:
      "khả năng chịu lạnh tốt * chịu sự quản lí của bố mẹ * chịu ảnh hưởng trực tiếp của cơn bão",
  },
  {
    word: "chịu",
    part_of_speech: "động từ",
    meaning:
      "nợ lại, chưa trả ngay: mua chịu * không bán chịu * tôi còn chịu anh cái ơn cứu mạng",
    example: "mua chịu * không bán chịu * tôi còn chịu anh cái ơn cứu mạng",
  },
  {
    word: "chịu",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) thừa nhận cái hay, cái hơn của người khác: không ai chịu ai * về mặt tính toán thì ai cũng phải chịu hắn",
    example: "không ai chịu ai * về mặt tính toán thì ai cũng phải chịu hắn",
  },
  {
    word: "chịu",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tự nhận bất lực, không làm nổi: chịu, không thể nào nhớ nổi! * khó quá, xin chịu!",
    example: "chịu, không thể nào nhớ nổi! * khó quá, xin chịu!",
  },
  {
    word: "chịu",
    part_of_speech: "động từ",
    meaning:
      "bằng lòng, đồng ý, tuy vốn không muốn, không thích: năn nỉ mãi mới chịu giúp * nói mãi mới chịu nghe * việc đó nó không chịu đâu",
    example:
      "năn nỉ mãi mới chịu giúp * nói mãi mới chịu nghe * việc đó nó không chịu đâu",
  },
  {
    word: "chịu",
    part_of_speech: "động từ",
    meaning:
      "cố gắng làm việc gì một cách tự nguyện: chịu học hỏi ở người khác * lười, không chịu suy nghĩ",
    example: "chịu học hỏi ở người khác * lười, không chịu suy nghĩ",
  },
  {
    word: "chíu",
    part_of_speech: "động từ",
    meaning: "từ mô phỏng tiếng rít của đạn bay: viên đạn chíu qua mang tai",
    example: "viên đạn chíu qua mang tai",
  },
  {
    word: "chịu lời",
    part_of_speech: "động từ",
    meaning:
      '(cũ) nhận lời làm việc gì: nó đã chịu lời * "Cậy em, em có chịu lời?, Ngồi lên cho chị lạy, rồi sẽ thưa." (TKiều)',
    example:
      'nó đã chịu lời * "Cậy em, em có chịu lời?, Ngồi lên cho chị lạy, rồi sẽ thưa." (TKiều)',
  },
  {
    word: "chịu khó",
    part_of_speech: "tính từ",
    meaning:
      "không quản ngại khó khăn, vất vả trong công việc: chịu khó học tập * chịu khó làm ăn * tính rất chịu khó",
    example: "chịu khó học tập * chịu khó làm ăn * tính rất chịu khó",
  },
  {
    word: "chịu đựng",
    part_of_speech: "động từ",
    meaning:
      "cố gắng thích ứng với những tác động hết sức không có lợi cho mình: chịu đựng gian khổ * cắn răng chịu đựng",
    example: "chịu đựng gian khổ * cắn răng chịu đựng",
  },
  {
    word: "chịu nhiệt",
    part_of_speech: "tính từ",
    meaning:
      "(vật liệu) có khả năng giữ nguyên hoặc chỉ thay đổi rất ít các tính chất cơ học khi ở nhiệt độ cao: bê tông chịu nhiệt * gạch chịu nhiệt",
    example: "bê tông chịu nhiệt * gạch chịu nhiệt",
  },
  {
    word: "chịu chơi",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) sẵn sàng làm những việc (thường tốn nhiều sức lực, tiền của) mà người khác hay ngại làm hoặc không dám làm: rất chịu chơi",
    example: "rất chịu chơi",
  },
  {
    word: "chịu tải",
    part_of_speech: "động từ",
    meaning:
      "chịu tác dụng của tải trọng hoặc phụ tải: khả năng chịu tải của lốp * sức chịu tải của cầu",
    example: "khả năng chịu tải của lốp * sức chịu tải của cầu",
  },
  {
    word: "chịu lửa",
    part_of_speech: "tính từ",
    meaning: "như chịu nhiệt: vật liệu chịu lửa * gạch chịu lửa",
    example: "vật liệu chịu lửa * gạch chịu lửa",
  },
  {
    word: "chịu phép",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đành chịu bất lực hoàn toàn, không thể làm gì hơn: tình thế này, có giỏi cũng phải chịu phép",
    example: "tình thế này, có giỏi cũng phải chịu phép",
  },
  {
    word: "chịu thua",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đành chịu, đành nhận là thua: việc này tôi xin chịu thua",
    example: "việc này tôi xin chịu thua",
  },
  {
    word: "chịu tang",
    part_of_speech: "động từ",
    meaning: "để tang người bậc trên (như cha, mẹ, v.v.): chịu tang mẹ",
    example: "chịu tang mẹ",
  },
  {
    word: "chịu trống",
    part_of_speech: "động từ",
    meaning: "(gia cầm mái) để cho con trống đạp mái: gà chịu trống",
    example: "gà chịu trống",
  },
  {
    word: "chõ",
    part_of_speech: "danh từ",
    meaning:
      "nồi dùng để đồ xôi, gồm hai tầng, tầng dưới đựng nước, tầng trên đựng gạo có lỗ nhỏ ở đáy để hơi nước bốc lên làm chín gạo: bắc chõ thổi xôi",
    example: "bắc chõ thổi xôi",
  },
  {
    word: "chõ",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) hướng thẳng hoặc tập trung âm thanh về phía nào đó: chõ loa vào trong xóm * ngồi trong buồng nói chõ ra",
    example: "chõ loa vào trong xóm * ngồi trong buồng nói chõ ra",
  },
  {
    word: "chõ",
    part_of_speech: "động từ",
    meaning:
      "(Thông tục) nói xen vào việc không dính líu đến mình: nghe ngứa tai, nói chõ vào một câu",
    example: "nghe ngứa tai, nói chõ vào một câu",
  },
  {
    word: "chịu trận",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) chịu đựng, chấp nhận điều không hay về mình mà không né tránh: không chạy được, đành đứng chịu trận",
    example: "không chạy được, đành đứng chịu trận",
  },
  {
    word: "chó",
    part_of_speech: "danh từ",
    meaning:
      "gia súc thuộc nhóm ăn thịt, nuôi để giữ nhà hay đi săn: chó cậy gần nhà, gà cậy gần chuồng (tng)",
    example: "chó cậy gần nhà, gà cậy gần chuồng (tng)",
  },
  {
    word: "chó",
    part_of_speech: "danh từ",
    meaning:
      "(Thông tục) con chó; dùng để ví kẻ đáng khinh miệt, và làm tiếng mắng nhiếc: đồ chó! * cư xử như thế thì chó thật!",
    example: "đồ chó! * cư xử như thế thì chó thật!",
  },
  {
    word: "cho",
    part_of_speech: "động từ",
    meaning:
      "chuyển cái thuộc sở hữu của mình sang thành của người khác mà không đổi lấy gì cả: cho quà * cho tiền",
    example: "cho quà * cho tiền",
  },
  {
    word: "cho",
    part_of_speech: "động từ",
    meaning:
      "làm người khác có được, nhận được cái gì hoặc điều kiện để làm việc gì: cô giáo cho điểm * cho thời gian để chuẩn bị * lịch sử cho ta nhiều bài học quý",
    example:
      "cô giáo cho điểm * cho thời gian để chuẩn bị * lịch sử cho ta nhiều bài học quý",
  },
  {
    word: "cho",
    part_of_speech: "động từ",
    meaning:
      "tạo ra ở khách thể một hoạt động nào đó: cho xe đi chậm lại * cho máy chạy thử * cho người đi tìm",
    example: "cho xe đi chậm lại * cho máy chạy thử * cho người đi tìm",
  },
  {
    word: "cho",
    part_of_speech: "động từ",
    meaning:
      "chuyển sự vật đến một chỗ nào đó để phát huy tác dụng: cho dầu vào máy * cho mì chính vào nồi canh * hàng đã cho lên tàu",
    example:
      "cho dầu vào máy * cho mì chính vào nồi canh * hàng đã cho lên tàu",
  },
  {
    word: "cho",
    part_of_speech: "động từ",
    meaning:
      "coi là, nghĩ rằng: tự cho mình là giỏi * tôi cho rằng đó không phải là việc xấu",
    example: "tự cho mình là giỏi * tôi cho rằng đó không phải là việc xấu",
  },
  {
    word: "cho",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) chuyển, đưa hoặc bán cho (nói tắt): anh cho tôi chiếc mũ kia * cho một cốc bia nhé",
    example: "anh cho tôi chiếc mũ kia * cho một cốc bia nhé",
  },
  {
    word: "cho",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là đối tượng nhằm đến hoặc đối tượng chịu tác động, ảnh hưởng của điều vừa được nói đến: gửi thư cho bạn * đưa tiền cho mẹ * nói cho mọi người rõ * không may cho anh ta",
    example:
      "gửi thư cho bạn * đưa tiền cho mẹ * nói cho mọi người rõ * không may cho anh ta",
  },
  {
    word: "cho",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là yêu cầu, mục đích, mức độ nhằm đạt tới của điều vừa được nói đến: viết cho rõ ràng * học cho giỏi * chờ cho trời sáng hãy đi * đói cho sạch, rách cho thơm (tng)",
    example:
      "viết cho rõ ràng * học cho giỏi * chờ cho trời sáng hãy đi * đói cho sạch, rách cho thơm (tng)",
  },
  {
    word: "cho",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là kết quả tự nhiên, hoặc là hệ quả tất yếu của điều vừa được nói đến: khôn cho người ta dái, dại cho người ta thương, dở dở ương ương tổ người ta ghét (tng)",
    example:
      "khôn cho người ta dái, dại cho người ta thương, dở dở ương ương tổ người ta ghét (tng)",
  },
  {
    word: "cho",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý nhấn mạnh về mức độ (cho là có thể như thế): mặc cho mưa gió, vẫn cứ đi * không tin cho lắm",
    example: "mặc cho mưa gió, vẫn cứ đi * không tin cho lắm",
  },
  {
    word: "cho",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý nhấn mạnh về một tác động không hay phải chịu đựng: đánh cho một trận * làm như thế để nó mắng cho!",
    example: "đánh cho một trận * làm như thế để nó mắng cho!",
  },
  {
    word: "cho",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị một đề nghị, một yêu cầu, với mong muốn có được sự đồng ý, thông cảm: mong anh giúp cho * để tôi làm cho * mời ông đi cho!",
    example: "mong anh giúp cho * để tôi làm cho * mời ông đi cho!",
  },
  {
    word: "chó chết",
    part_of_speech: "",
    meaning: "(thông tục) tiếng dùng để rủa, để chửi: đồ chó chết!",
    example: "đồ chó chết!",
  },
  {
    word: "cho dù",
    part_of_speech: "kết từ",
    meaning:
      "như dù cho: cho dù trời mưa, vẫn đi * tôi sẽ vẫn làm, cho dù có thế nào chăng nữa",
    example:
      "cho dù trời mưa, vẫn đi * tôi sẽ vẫn làm, cho dù có thế nào chăng nữa",
  },
  {
    word: "cho cùng",
    part_of_speech: "",
    meaning:
      "cho đến tận cùng, đến hết mọi lẽ: xét cho cùng, sự việc không có gì to tát * suy cho cùng thì anh cũng có lỗi",
    example:
      "xét cho cùng, sự việc không có gì to tát * suy cho cùng thì anh cũng có lỗi",
  },
  {
    word: "chó đẻ",
    part_of_speech: "danh từ",
    meaning:
      "cây nhỏ cùng họ với thầu dầu, mọc hoang, lá mọc thành hai dãy trông như lá kép lông chim, dùng làm thuốc hoặc làm phân xanh.  (thông tục) như chó chết: thằng cha chó đẻ quá đi mất!",
    example: "thằng cha chó đẻ quá đi mất!",
  },
  {
    word: "chó đểu",
    part_of_speech: "tính từ",
    meaning:
      "(thông tục) đểu giả hết sức (thường dùng làm tiếng chửi): quân chó đểu!",
    example: "quân chó đểu!",
  },
  {
    word: "chó ghẻ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) ví kẻ bị ghét bỏ, đáng ghê tởm: đồ chó ghẻ! (tiếng chửi)",
    example: "đồ chó ghẻ! (tiếng chửi)",
  },
  {
    word: "chò hỏ",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) như chồm chỗm: ngồi chò hỏ trên ghế",
    example: "ngồi chò hỏ trên ghế",
  },
  {
    word: "chó má",
    part_of_speech: "danh từ",
    meaning:
      "chó (nói khái quát); dùng để ví và làm tiếng chửi những kẻ đểu giả, xấu xa, mất hết nhân cách: làm như thế thì chó má quá!",
    example: "làm như thế thì chó má quá!",
  },
  {
    word: "cho hay",
    part_of_speech: "",
    meaning:
      'tổ hợp biểu thị điều sắp nêu ra là kết luận có tính chất chân lí ở đời rút ra từ những điều đã nói đến: cho hay, không phải cái gì muốn là cũng được * "Cho hay muôn sự tại trời, Phụ người chẳng bỏ khi người phụ ta!" (TKiều)',
    example:
      'cho hay, không phải cái gì muốn là cũng được * "Cho hay muôn sự tại trời, Phụ người chẳng bỏ khi người phụ ta!" (TKiều)',
  },
  {
    word: "chõ mồm",
    part_of_speech: "động từ",
    meaning: "(thông tục) như chõ miệng: ai khiến mày chõ mồm vào thế?",
    example: "ai khiến mày chõ mồm vào thế?",
  },
  {
    word: "chõ miệng",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) như chõ: việc gì đến anh mà anh cứ chõ miệng vào * chõ miệng vào chuyện của người khác",
    example:
      "việc gì đến anh mà anh cứ chõ miệng vào * chõ miệng vào chuyện của người khác",
  },
  {
    word: "cho rồi",
    part_of_speech: "",
    meaning:
      '(phương ngữ, khẩu ngữ) cho xong: làm ngay đi cho rồi! * "Thôi thì một thác cho rồi, Tấm lòng phó mặc trên trời, dưới sông!" (TKiều)',
    example:
      'làm ngay đi cho rồi! * "Thôi thì một thác cho rồi, Tấm lòng phó mặc trên trời, dưới sông!" (TKiều)',
  },
  {
    word: "cho nên",
    part_of_speech: "kết từ",
    meaning:
      "từ dùng trước đoạn câu nêu kết quả của nguyên nhân đã nói đến: vội quá cho nên quên * lười biếng cho nên người ta ghét",
    example: "vội quá cho nên quên * lười biếng cho nên người ta ghét",
  },
  {
    word: "chó săn chim mồi",
    part_of_speech: "",
    meaning: "(cũ) như chó săn: bọn chó săn chim mồi",
    example: "bọn chó săn chim mồi",
  },
  {
    word: "chõ mũi",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) can thiệp vào việc không dính líu đến mình: đừng chõ mũi vào chuyện của người khác",
    example: "đừng chõ mũi vào chuyện của người khác",
  },
  {
    word: "cho qua",
    part_of_speech: "động từ",
    meaning:
      "coi như không có gì quan trọng, không cần chú ý đến: chuyện cũ cho qua * việc này không thể cho qua",
    example: "chuyện cũ cho qua * việc này không thể cho qua",
  },
  {
    word: "chó săn",
    part_of_speech: "danh từ",
    meaning: "chó tinh khôn, rất thính hơi, chuyên dùng vào việc đi săn.",
    example: "đồ chó săn!",
  },
  {
    word: "cho qua chuyện",
    part_of_speech: "",
    meaning: "(làm việc gì) chỉ cốt cho xong: ừ hữ cho qua chuyện",
    example: "ừ hữ cho qua chuyện",
  },
  {
    word: "choá",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) bộ phận hình phễu có tráng chất phản quang, dùng lắp vào đèn để phản chiếu ánh sáng đi xa hơn và sáng hơn: choá đèn pha * đèn pin mới thay choá",
    example: "choá đèn pha * đèn pin mới thay choá",
  },
  {
    word: "choá",
    part_of_speech: "tính từ",
    meaning:
      "(ánh sáng) chói loà, làm chói mắt: nắng choá mắt * đèn pha sáng choá",
    example: "nắng choá mắt * đèn pha sáng choá",
  },
  {
    word: "choai",
    part_of_speech: "tính từ",
    meaning:
      "(ở vào độ tuổi) không còn bé lắm, nhưng cũng chưa lớn hẳn: gà trống choai",
    example: "gà trống choai",
  },
  {
    word: "cho xong",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) cho khỏi phải rầy rà, phiền phức (còn hơn phải làm cái việc mà mình không muốn): trả quách cho xong, nợ mãi làm gì * biết thế chẳng lấy cho xong",
    example: "trả quách cho xong, nợ mãi làm gì * biết thế chẳng lấy cho xong",
  },
  {
    word: "choài",
    part_of_speech: "động từ",
    meaning:
      "vươn dài hai tay và toàn thân ra phía trước, theo chiều nằm ngang: choài tay bắt bóng * em bé choài ra gần mép giường",
    example: "choài tay bắt bóng * em bé choài ra gần mép giường",
  },
  {
    word: "choái",
    part_of_speech: "danh từ",
    meaning:
      "que cắm để làm chỗ tựa cho cây thân leo bám vào: cắm choái cho cây mướp",
    example: "cắm choái cho cây mướp",
  },
  {
    word: "choãi",
    part_of_speech: "động từ",
    meaning: "(chân) mở rộng khoảng cách ra về cả hai phía: đứng choãi chân",
    example: "đứng choãi chân",
  },
  {
    word: "choãi",
    part_of_speech: "động từ",
    meaning:
      "có độ dốc giảm dần và trở thành thoai thoải về phía chân: chân đê choãi đều * sườn núi choãi dần về phía biển",
    example: "chân đê choãi đều * sườn núi choãi dần về phía biển",
  },
  {
    word: "choa",
    part_of_speech: "đại từ",
    meaning:
      '(Phương ngữ) tôi, tao hoặc chúng tôi, chúng tao: "Thôi thì thác cũng ra ma, Ruộng choa, choa cứ hai mùa làm ăn." (Cdao)',
    example:
      'Thôi thì thác cũng ra ma, Ruộng choa, choa cứ hai mùa làm ăn." (Cdao)',
  },
  {
    word: "choạc",
    part_of_speech: "động từ",
    meaning: "(hiếm) như xoạc: choạc chân",
    example: "choạc chân",
  },
  {
    word: "choai choai",
    part_of_speech: "tính từ",
    meaning:
      "như choai (thường hàm ý chê): thanh niên choai choai * một lũ choai choai",
    example: "thanh niên choai choai * một lũ choai choai",
  },
  {
    word: "choáng",
    part_of_speech: "danh từ",
    meaning:
      "(cũng choáng) tình trạng toàn thân suy sụp đột ngột do rối loạn các chức năng sinh lí quan trọng, có thể dẫn tới tử vong: chấn thương nặng gây sốc * tử vong do sốc thuốc",
    example: "chấn thương nặng gây sốc * tử vong do sốc thuốc",
  },
  {
    word: "choáng",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) tình trạng tinh thần suy sụp đột ngột do tác động mạnh của những điều bất lợi đối với bản thân: cú sốc * bị sốc vì nghe tin dữ",
    example: "cú sốc * bị sốc vì nghe tin dữ",
  },
  {
    word: "choang",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng to và vang như tiếng bát đĩa rơi vỡ, hoặc tiếng của vật bằng kim khí va mạnh vào nhau nghe chói tai: chiếc bát rơi đánh choang một cái",
    example: "chiếc bát rơi đánh choang một cái",
  },
  {
    word: "choàng",
    part_of_speech: "động từ",
    meaning:
      "dang rộng cánh tay ra để ôm vào: bé choàng lấy cổ mẹ * ôm choàng lấy nhau",
    example: "bé choàng lấy cổ mẹ * ôm choàng lấy nhau",
  },
  {
    word: "choàng",
    part_of_speech: "động từ",
    meaning:
      "khoác vòng qua, khoác vòng quanh: choàng khăn lên đầu * choàng vội chiếc áo lên mình",
    example: "choàng khăn lên đầu * choàng vội chiếc áo lên mình",
  },
  {
    word: "choàng",
    part_of_speech: "động từ",
    meaning:
      "cử động, chuyển động nhanh, đột ngột và có phần hoảng hốt, do phản ứng bị động: mở choàng mắt * choàng tỉnh dậy",
    example: "mở choàng mắt * choàng tỉnh dậy",
  },
  {
    word: "choang choác",
    part_of_speech: "tính từ",
    meaning:
      'từ gợi tả tiếng kêu, la to liên tục và nghe chói tai: "(...) chỉ cần anh mở miệng là chị sẽ choang choác lên, đến hàng xóm cũng phải điên đầu." (NgKiên; 15)',
    example:
      '(...) chỉ cần anh mở miệng là chị sẽ choang choác lên, đến hàng xóm cũng phải điên đầu." (NgKiên; 15)',
  },
  {
    word: "choán",
    part_of_speech: "động từ",
    meaning:
      "lấn sang cả một khoảng không gian, thời gian nào đó, không còn chỗ cho những cái khác: chiếc giường kê choán gần hết cả căn buồng * buổi họp choán mất nhiều thì giờ",
    example:
      "chiếc giường kê choán gần hết cả căn buồng * buổi họp choán mất nhiều thì giờ",
  },
  {
    word: "choán",
    part_of_speech: "động từ",
    meaning:
      "lấn sang phạm vi của người khác: đứng choán cả lối đi * ngồi choán chỗ * choán quyền",
    example: "đứng choán cả lối đi * ngồi choán chỗ * choán quyền",
  },
  {
    word: "choảng",
    part_of_speech: "động từ",
    meaning:
      "đập mạnh làm phát thành tiếng to và vang: choảng cho mấy búa vào thành tàu * tiếng búa choảng lên đe",
    example: "choảng cho mấy búa vào thành tàu * tiếng búa choảng lên đe",
  },
  {
    word: "choảng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đánh nhau rất dữ: hai bên choảng nhau kịch liệt * bị choảng một phát vào đầu",
    example: "hai bên choảng nhau kịch liệt * bị choảng một phát vào đầu",
  },
  {
    word: "choạng",
    part_of_speech: "động từ",
    meaning: "(hiếm) như giạng: đứng choạng chân",
    example: "đứng choạng chân",
  },
  {
    word: "choang choảng",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng âm thanh to và vang như tiếng của vật bằng kim khí va mạnh vào nhau liên tiếp, nghe chói tai: tiếng cuốc xẻng va vào đá choang choảng",
    example: "tiếng cuốc xẻng va vào đá choang choảng",
  },
  {
    word: "choang choang",
    part_of_speech: "tính từ",
    meaning:
      "như choang (nhưng ý liên tiếp và mức độ mạnh hơn): tiếng bát đĩa choang choang",
    example: "tiếng bát đĩa choang choang",
  },
  {
    word: "choang choang",
    part_of_speech: "tính từ",
    meaning:
      "(tiếng nói, quát tháo) to và vang lên, nghe chói tai: cãi nhau choang choang * quát tháo choang choang",
    example: "cãi nhau choang choang * quát tháo choang choang",
  },
  {
    word: "choáng choàng",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như cuống cuồng: chạy choáng choàng như bị ma đuổi",
    example: "chạy choáng choàng như bị ma đuổi",
  },
  {
    word: "choáng lộn",
    part_of_speech: "tính từ",
    meaning:
      "hào nhoáng và bóng lộn, trông có vẻ sang trọng: phòng khách choáng lộn",
    example: "phòng khách choáng lộn",
  },
  {
    word: "choạng vạng",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như loạng choạng: say rượu, bước đi choạng vạng",
    example: "say rượu, bước đi choạng vạng",
  },
  {
    word: "choáng ngợp",
    part_of_speech: "động từ",
    meaning:
      "ngợp đến mức gần như choáng váng: choáng ngợp trước sự mênh mông của biển cả",
    example: "choáng ngợp trước sự mênh mông của biển cả",
  },
  {
    word: "chóc",
    part_of_speech: "danh từ",
    meaning:
      "cây cùng họ với khoai sọ, củ dùng để ăn hoặc làm thuốc: ăn cơm độn chóc",
    example: "ăn cơm độn chóc",
  },
  {
    word: "choắt cheo",
    part_of_speech: "tính từ",
    meaning: "(hiếm) choắt (nói khái quát): người choắt cheo vì đói",
    example: "người choắt cheo vì đói",
  },
  {
    word: "chọc gan",
    part_of_speech: "động từ",
    meaning: "(phương ngữ, khẩu ngữ) như chọc tức: đừng có chọc gan bả nữa",
    example: "đừng có chọc gan bả nữa",
  },
  {
    word: "chọc",
    part_of_speech: "động từ",
    meaning:
      "đâm thẳng và mạnh bằng vật dài, nhằm làm cho thủng hoặc rụng, v.v.: chọc thủng bao gạo * lấy sào chọc ổi * chọc thủng vòng vây (b)",
    example: "chọc thủng bao gạo * lấy sào chọc ổi * chọc thủng vòng vây (b)",
  },
  {
    word: "chọc",
    part_of_speech: "động từ",
    meaning:
      "(Nam) dùng lời nói, cử chỉ làm cho bực tức: nói chọc mấy câu * hay chọc người khác",
    example: "nói chọc mấy câu * hay chọc người khác",
  },
  {
    word: "choáng váng",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái mất cảm giác về sự thăng bằng, cảm thấy mọi vật xung quanh như đang chao đảo: đầu óc choáng váng * bị một đòn choáng váng",
    example: "đầu óc choáng váng * bị một đòn choáng váng",
  },
  {
    word: "choắt",
    part_of_speech: "tính từ",
    meaning:
      "bé và gầy đến mức như bị teo lại: người bé choắt * khuôn mặt gầy choắt",
    example: "người bé choắt * khuôn mặt gầy choắt",
  },
  {
    word: "chọc ghẹo",
    part_of_speech: "động từ",
    meaning:
      "dùng lời nói, cử chỉ để đùa cợt làm cho người khác xấu hổ hoặc bực tức: bọn trẻ chọc ghẹo nhau",
    example: "bọn trẻ chọc ghẹo nhau",
  },
  {
    word: "chọc tiết",
    part_of_speech: "động từ",
    meaning:
      "đâm vào cổ cho máu chảy ra để giết thịt (thường nói về gia súc): chọc tiết lợn",
    example: "chọc tiết lợn",
  },
  {
    word: "chọc trời",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả hình dáng cao vút lên tưởng như chạm đến trời xanh: những toà nhà chọc trời * ống khói cao chọc trời",
    example: "những toà nhà chọc trời * ống khói cao chọc trời",
  },
  {
    word: "chọc tức",
    part_of_speech: "động từ",
    meaning: "cố tình trêu cho tức lên: nói chọc tức * nói kháy, chọc tức nhau",
    example: "nói chọc tức * nói kháy, chọc tức nhau",
  },
  {
    word: "chóc ngóc",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) ngóc đầu lên: lặn một lúc lại chóc ngóc đầu lên mặt nước",
    example: "lặn một lúc lại chóc ngóc đầu lên mặt nước",
  },
  {
    word: "chóc ngóc",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) trơ trọi, lẻ loi một mình: không đi đâu, ngồi chóc ngóc ở nhà * đứng chóc ngóc một xó",
    example: "không đi đâu, ngồi chóc ngóc ở nhà * đứng chóc ngóc một xó",
  },
  {
    word: "chọc quê",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ, khẩu ngữ) trêu chọc cho là quê mùa, làm cho ngượng, cho xấu hổ: đừng chọc quê nó nữa!",
    example: "đừng chọc quê nó nữa!",
  },
  {
    word: "chọc trời khuấy nước",
    part_of_speech: "",
    meaning:
      'ví hành động ngang tàng, gây náo động mọi nơi, không kiêng sợ bất cứ thế lực nào: "Chọc trời khuấy nước mặc dầu, Dọc ngang nào biết trên đầu có ai?" (TKiều)',
    example:
      'Chọc trời khuấy nước mặc dầu, Dọc ngang nào biết trên đầu có ai?" (TKiều)',
  },
  {
    word: "choé",
    part_of_speech: "tính từ",
    meaning: "(màu vàng hoặc đỏ) tươi và sáng lên óng ánh: vàng choé * đỏ choé",
    example: "vàng choé * đỏ choé",
  },
  {
    word: "chòi",
    part_of_speech: "danh từ",
    meaning:
      "nhà nhỏ xây trên cổng một số công đường thời trước hoặc dựng sơ sài trên cột, trên cây cao, thường dùng làm nơi canh phòng: chòi canh",
    example: "chòi canh",
  },
  {
    word: "chòi",
    part_of_speech: "động từ",
    meaning:
      "nhô ra, ngoi lên một cách khó khăn: mầm cây chòi lên mặt đất * cố chòi khỏi mặt nước",
    example: "mầm cây chòi lên mặt đất * cố chòi khỏi mặt nước",
  },
  {
    word: "chòi",
    part_of_speech: "động từ",
    meaning:
      "(Phương ngữ) cất chân lên cao, tỏ vẻ như muốn bước đi, muốn di chuyển (thường nói về ngựa): con ngựa cất cao mình, chòi mạnh hai chân trước * hai chân bé chòi đạp trong không khí",
    example:
      "con ngựa cất cao mình, chòi mạnh hai chân trước * hai chân bé chòi đạp trong không khí",
  },
  {
    word: "chòi",
    part_of_speech: "động từ",
    meaning:
      '(Ít dùng) chọc cho rụng: "Trên cây có quả chín muồi, Anh trông mỏi mắt, anh chòi mỏi tay." (Cdao)',
    example:
      'Trên cây có quả chín muồi, Anh trông mỏi mắt, anh chòi mỏi tay." (Cdao)',
  },
  {
    word: "chói",
    part_of_speech: "động từ",
    meaning: "chiếu sáng mạnh: đèn điện chói sáng * nắng chói vào mặt",
    example: "đèn điện chói sáng * nắng chói vào mặt",
  },
  {
    word: "chói",
    part_of_speech: "tính từ",
    meaning:
      "có cảm giác thị giác hoặc thính giác bị rối loạn do tác động của ánh sáng hoặc âm thanh có cường độ quá mạnh: tiếng nổ chói tai * ánh sáng làm chói mắt",
    example: "tiếng nổ chói tai * ánh sáng làm chói mắt",
  },
  {
    word: "chói",
    part_of_speech: "tính từ",
    meaning:
      "(màu sắc) tươi quá, đến mức như làm loá mắt: hoa gạo đỏ chói * chiếc áo vàng chói",
    example: "hoa gạo đỏ chói * chiếc áo vàng chói",
  },
  {
    word: "chói",
    part_of_speech: "tính từ",
    meaning:
      "có cảm giác nhói buốt như bị đâm tại một chỗ nào đó: đầu đau chói  * chói xương hông",
    example: "đầu đau chói  * chói xương hông",
  },
  {
    word: "choèn choèn",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) nhỏ hẹp hoặc nông đến mức coi như không đáng kể: mảnh ván bé choèn choèn * con suối nông choèn choèn",
    example: "mảnh ván bé choèn choèn * con suối nông choèn choèn",
  },
  {
    word: "choe choé",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng kêu to, đột ngột nhiều lần liên tiếp, nghe chói tai: kêu choe choé",
    example: "kêu choe choé",
  },
  {
    word: "chói chang",
    part_of_speech: "tính từ",
    meaning:
      "(ánh nắng) có độ sáng mạnh và toả rộng, làm cho loá mắt: nắng chói chang",
    example: "nắng chói chang",
  },
  {
    word: "chói loà",
    part_of_speech: "tính từ",
    meaning: "sáng đến mức nhìn loá cả mắt: ánh chớp chói loà  * nắng chói loà",
    example: "ánh chớp chói loà  * nắng chói loà",
  },
  {
    word: "chói ngời",
    part_of_speech: "tính từ",
    meaning: "chói sáng và đẹp rực rỡ: ánh bình minh chói ngời",
    example: "ánh bình minh chói ngời",
  },
  {
    word: "chọi",
    part_of_speech: "động từ",
    meaning:
      "đập mạnh vật rắn này vào một vật rắn khác (thường là những vật có kích thước nhỏ): chọi đồng xu xuống nền gạch * trứng chọi với đá (tng)",
    example: "chọi đồng xu xuống nền gạch * trứng chọi với đá (tng)",
  },
  {
    word: "chọi",
    part_of_speech: "động từ",
    meaning:
      "chống cự, đối phó lại, bằng sức mạnh: một người không thể chọi với cả bọn được",
    example: "một người không thể chọi với cả bọn được",
  },
  {
    word: "chọi",
    part_of_speech: "động từ",
    meaning:
      "(loài vật cùng loại) đấu sức với nhau để phân hơn thua: xem chọi gà * trẻ con chơi chọi dế * lễ hội chọi trâu ở Đồ Sơn",
    example: "xem chọi gà * trẻ con chơi chọi dế * lễ hội chọi trâu ở Đồ Sơn",
  },
  {
    word: "chọi",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) (văn chương) đối nhau chặt chẽ: hai vế đối chọi nhau từng chữ một",
    example: "hai vế đối chọi nhau từng chữ một",
  },
  {
    word: "choi choi",
    part_of_speech: "danh từ",
    meaning:
      "chim nhỏ sống gần bờ nước, cỡ bằng sáo, cẳng cao, mỏ dài, hay nhảy: nhảy như con choi choi",
    example: "nhảy như con choi choi",
  },
  {
    word: "choi chói",
    part_of_speech: "tính từ",
    meaning: "hơi chói: mắt choi chói vì nắng",
    example: "mắt choi chói vì nắng",
  },
  {
    word: "chói lói",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như chói lọi: mặt trời chói lói",
    example: "mặt trời chói lói",
  },
  {
    word: "chỏi",
    part_of_speech: "động từ",
    meaning:
      "(Phương ngữ) chống cho khỏi ngã, khỏi đổ: chân yếu, đi phải chỏi gậy",
    example: "chân yếu, đi phải chỏi gậy",
  },
  {
    word: "chói lọi",
    part_of_speech: "tính từ",
    meaning:
      'sáng và đẹp rực rỡ: nắng hè chói lọi * "Đồn rằng chúa mở khoa thi, Bảng vàng chói lọi đỗ thì tên anh." (ca dao)',
    example:
      'nắng hè chói lọi * "Đồn rằng chúa mở khoa thi, Bảng vàng chói lọi đỗ thì tên anh." (ca dao)',
  },
  {
    word: "chõm",
    part_of_speech: "tính từ",
    meaning: "(Ít dùng) nhỏ, dài và thót lại: lợn sề mặt chõm",
    example: "lợn sề mặt chõm",
  },
  {
    word: "chỏm cầu",
    part_of_speech: "danh từ",
    meaning:
      "một trong hai phần của mặt cầu có được do một mặt phẳng cắt mặt cầu ấy: hình chỏm cầu",
    example: "hình chỏm cầu",
  },
  {
    word: "cholesterol",
    part_of_speech: "danh từ",
    meaning:
      "chất có trong máu, mỡ và tế bào của người, động vật, nếu có hàm lượng cao sẽ gây nên các bệnh về tim mạch: thừa cholesterol trong máu",
    example: "thừa cholesterol trong máu",
  },
  {
    word: "chòm chọp",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng phát ra khi bú mẹ hoặc khi lợn ăn thức ăn lỏng: tiếng lợn ăn cám chòm chọp",
    example: "tiếng lợn ăn cám chòm chọp",
  },
  {
    word: "chòm",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp gồm nhiều cây, nhiều sợi hoặc nhiều vật mọc chụm vào nhau: chòm lá xanh om * chòm râu bạc",
    example: "chòm lá xanh om * chòm râu bạc",
  },
  {
    word: "chòm",
    part_of_speech: "danh từ",
    meaning: "xóm nhỏ ở một số vùng: chòm trên xóm dưới",
    example: "chòm trên xóm dưới",
  },
  {
    word: "chỏm",
    part_of_speech: "danh từ",
    meaning: "phần nhô lên trên cùng của một số vật: chỏm mũ * chỏm núi",
    example: "chỏm mũ * chỏm núi",
  },
  {
    word: "chỏm",
    part_of_speech: "danh từ",
    meaning:
      "túm tóc để chừa lại trên đỉnh đầu cạo trọc của trẻ em trai, theo kiểu để tóc thời trước: bạn từ hồi còn để chỏm",
    example: "bạn từ hồi còn để chỏm",
  },
  {
    word: "chọn",
    part_of_speech: "động từ",
    meaning:
      "xem xét, so sánh để lấy ra cái hợp yêu cầu trong nhiều cái cùng loại: chọn giống * chọn quả cam mọng nước * chọn bạn mà chơi",
    example: "chọn giống * chọn quả cam mọng nước * chọn bạn mà chơi",
  },
  {
    word: "chòm sao",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp gồm nhiều ngôi sao tựa hồ như kết với nhau thành một hình nào đó: chòm sao Bắc Đẩu",
    example: "chòm sao Bắc Đẩu",
  },
  {
    word: "chon chỏn",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) nhỏ và nhô cao lên trên một cái gì khác, trông khó coi: búi tóc chon chỏn trên đỉnh đầu",
    example: "búi tóc chon chỏn trên đỉnh đầu",
  },
  {
    word: "chòm xóm",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) chòm và xóm; khu vực dân cư nhỏ nhất ở nông thôn (nói khái quát): bà con chòm xóm",
    example: "bà con chòm xóm",
  },
  {
    word: "chọn lọc",
    part_of_speech: "động từ",
    meaning:
      "chọn lấy cái tốt, cái tinh tuý, trên cơ sở loại bỏ nhiều cái cùng loại (nói khái quát): chọn lọc giống lúa * tiếp thu có chọn lọc",
    example: "chọn lọc giống lúa * tiếp thu có chọn lọc",
  },
  {
    word: "chọn mặt gửi vàng",
    part_of_speech: "",
    meaning:
      'chọn người có khả năng và đáng tin cậy để giao phó cái quý giá, cái quan trọng: "Tôi quý anh Hai là bậc can trường, nên mới dám chọn mặt gửi vàng." (ĐGiỏi; 4)',
    example:
      'Tôi quý anh Hai là bậc can trường, nên mới dám chọn mặt gửi vàng." (ĐGiỏi; 4)',
  },
  {
    word: "chọn phối",
    part_of_speech: "động từ",
    meaning:
      "chọn những con đực và con cái thuộc giống tốt cho giao phối để tạo ra giống tốt hơn: kĩ thuật chọn phối bò lai",
    example: "kĩ thuật chọn phối bò lai",
  },
  {
    word: "chòng chọc",
    part_of_speech: "tính từ",
    meaning:
      "(nhìn) thẳng và lâu vào một chỗ mà không chớp mắt, biểu lộ sự ham muốn hoặc tò mò: nhìn chòng chọc",
    example: "nhìn chòng chọc",
  },
  {
    word: "chóng",
    part_of_speech: "tính từ",
    meaning:
      "không mất nhiều thời gian để quá trình được kết thúc hoặc hoạt động đạt được kết quả: chóng đói * chóng quên * hoa chóng tàn * đi chóng rồi về",
    example: "chóng đói * chóng quên * hoa chóng tàn * đi chóng rồi về",
  },
  {
    word: "chõng",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng để nằm, ngồi, làm bằng tre hoặc nứa, hình giống cái giường nhưng thường hẹp và thấp hơn: chõng bán hàng",
    example: "chõng bán hàng",
  },
  {
    word: "chon von",
    part_of_speech: "tính từ",
    meaning:
      "trơ trọi ở trên cao, không có chỗ dựa chắc chắn: đứng chon von trên mỏm đá * đỉnh núi chon von",
    example: "đứng chon von trên mỏm đá * đỉnh núi chon von",
  },
  {
    word: "chòng ghẹo",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) dùng lời nói hoặc hành động, thường là không đứng đắn, để đùa nghịch làm cho người khác xấu hổ, bực tức hoặc sợ hãi: buông lời chòng ghẹo * chòng ghẹo phụ nữ",
    example: "buông lời chòng ghẹo * chòng ghẹo phụ nữ",
  },
  {
    word: "chong",
    part_of_speech: "động từ",
    meaning:
      'để cháy sáng trong khoảng thời gian tương đối lâu: chong đèn suốt đêm * "Người vào chung gối loan phòng, Nàng ra tựa bóng đèn chong canh dài." (TKiều)',
    example:
      'chong đèn suốt đêm * "Người vào chung gối loan phòng, Nàng ra tựa bóng đèn chong canh dài." (TKiều)',
  },
  {
    word: "chong",
    part_of_speech: "động từ",
    meaning:
      "(mắt) mở rất lâu không nhắm: chong mắt nhìn * mắt cứ chong chong, không sao ngủ được",
    example: "chong mắt nhìn * mắt cứ chong chong, không sao ngủ được",
  },
  {
    word: "chong",
    part_of_speech: "động từ",
    meaning:
      "(Phương ngữ) để ở vị trí sẵn sàng, hướng thẳng về một mục tiêu nào đó: chong súng theo máy bay",
    example: "chong súng theo máy bay",
  },
  {
    word: "chỏng chơ",
    part_of_speech: "tính từ",
    meaning:
      "trơ trọi và lộn xộn, xiên xẹo, không ai ngó ngàng đến: rổ rá vứt chỏng chơ ngoài sân * nằm chỏng chơ một mình",
    example: "rổ rá vứt chỏng chơ ngoài sân * nằm chỏng chơ một mình",
  },
  {
    word: "chong chóng",
    part_of_speech: "danh từ",
    meaning:
      "đồ chơi làm bằng giấy hay lá cây, có nhiều cánh, quay bằng sức gió: chiếc chong chóng quay tít",
    example: "chiếc chong chóng quay tít",
  },
  {
    word: "chong chóng",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận hình cánh quạt trong máy móc, quay được nhờ động cơ hoặc sức gió để tạo ra sức đẩy, sức nâng hoặc sức kéo: chong chóng máy bay",
    example: "chong chóng máy bay",
  },
  {
    word: "chong chóng",
    part_of_speech: "tính từ",
    meaning:
      'như chóng (nhưng hàm ý thúc giục hơn): "Em về chong chóng mà ra, Kẻo anh chờ đợi sương sa lạnh lùng." (ca dao)',
    example:
      'Em về chong chóng mà ra, Kẻo anh chờ đợi sương sa lạnh lùng." (ca dao)',
  },
  {
    word: "chỏng gọng",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) nằm giơ ngược chân hoặc cẳng lên: ngã chỏng gọng",
    example: "ngã chỏng gọng",
  },
  {
    word: "chỏng gọng",
    part_of_speech: "động từ",
    meaning:
      "từ gợi tả dáng nằm trơ trọi một mình: xe hỏng nằm chỏng gọng một xó * nằm chỏng gọng ở nhà",
    example: "xe hỏng nằm chỏng gọng một xó * nằm chỏng gọng ở nhà",
  },
  {
    word: "chỏng lỏn",
    part_of_speech: "tính từ",
    meaning:
      "(cách ăn nói) cụt lủn và với vẻ hỗn xược, gây khó chịu: ăn nói chỏng lỏn",
    example: "ăn nói chỏng lỏn",
  },
  {
    word: "chóng vánh",
    part_of_speech: "tính từ",
    meaning:
      "rất nhanh gọn và dễ dàng, mất ít thì giờ hơn người ta nghĩ: thay đổi chóng vánh * giải quyết chóng vánh",
    example: "thay đổi chóng vánh * giải quyết chóng vánh",
  },
  {
    word: "chỏng quèo",
    part_of_speech: "động từ",
    meaning:
      "nằm cong người lại (thường do bị đẩy ngã): nằm chỏng quèo * bị đẩy, ngã chỏng quèo trên mặt đất",
    example: "nằm chỏng quèo * bị đẩy, ngã chỏng quèo trên mặt đất",
  },
  {
    word: "chóng mặt",
    part_of_speech: "động từ",
    meaning:
      "ở trạng thái thấy mọi vật xung quanh và cả bản thân mình hình như đang quay vòng hoặc đang nghiêng ngả: nhức đầu chóng mặt * giá cả tăng đến chóng mặt",
    example: "nhức đầu chóng mặt * giá cả tăng đến chóng mặt",
  },
  {
    word: "choòng",
    part_of_speech: "danh từ",
    meaning:
      "thanh thép dài có dạng hình trụ, thường có nhiều cạnh, dùng để truyền chuyển động từ máy khoan đến mũi khoan: choòng khoan lỗ",
    example: "choòng khoan lỗ",
  },
  {
    word: "chóp",
    part_of_speech: "danh từ",
    meaning:
      "phần ở trên cùng của một số vật thường có dạng hình nón: chóp núi * nón bị thủng chóp * cặp kính lão trễ xuống chóp mũi",
    example: "chóp núi * nón bị thủng chóp * cặp kính lão trễ xuống chóp mũi",
  },
  {
    word: "chóp",
    part_of_speech: "danh từ",
    meaning: "bộ phận hình nón úp trên một số vật: chóp ống khói",
    example: "chóp ống khói",
  },
  {
    word: "chòng vòng",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) cố nấn ná để chờ, có phần sốt ruột: chòng vòng chờ đợi",
    example: "chòng vòng chờ đợi",
  },
  {
    word: "chóp bu",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) người hoặc nhóm người đứng đầu, có địa vị, cấp bậc cao nhất: cơ quan chóp bu * các nhân vật chóp bu trong nghị viện",
    example: "cơ quan chóp bu * các nhân vật chóp bu trong nghị viện",
  },
  {
    word: "chót",
    part_of_speech: "danh từ",
    meaning:
      "phần ở điểm giới hạn cuối cùng, đến đó là hết: trên chót đỉnh cột cờ * tin giờ chót * đỗ hạng chót",
    example: "trên chót đỉnh cột cờ * tin giờ chót * đỗ hạng chót",
  },
  {
    word: "chỗ đứng",
    part_of_speech: "danh từ",
    meaning:
      "vị trí, vai trò trong gia đình, xã hội hoặc trong một tổ chức, một phạm vi nào đó: tác phẩm đã có chỗ đứng xứng đáng * tìm được chỗ đứng trong xã hội",
    example:
      "tác phẩm đã có chỗ đứng xứng đáng * tìm được chỗ đứng trong xã hội",
  },
  {
    word: "chộ",
    part_of_speech: "động từ",
    meaning:
      '(phương ngữ) thấy: "Anh chộ em ít nói, ít cười, Mới dốc lòng chờ đợi chín mười năm ni." (ca dao)',
    example:
      'Anh chộ em ít nói, ít cười, Mới dốc lòng chờ đợi chín mười năm ni." (ca dao)',
  },
  {
    word: "chóp chép",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng nhai hoặc chép miệng nhiều lần: nhai trầu chóp chép * chóp chép cái miệng",
    example: "nhai trầu chóp chép * chóp chép cái miệng",
  },
  {
    word: "chỗ",
    part_of_speech: "danh từ",
    meaning:
      "khoảng không gian xác định có thể nhìn thấy được toàn bộ ở đó người hay vật tồn tại hoặc sự việc gì đó xảy ra: nhường chỗ cho cụ già * loay hoay tìm chỗ đỗ xe * còn một chỗ trống",
    example:
      "nhường chỗ cho cụ già * loay hoay tìm chỗ đỗ xe * còn một chỗ trống",
  },
  {
    word: "chỗ",
    part_of_speech: "danh từ",
    meaning:
      "phạm vi được xác định với đặc điểm riêng biệt nào đó: gãi đúng chỗ ngứa * khắc phục chỗ yếu, phát huy chỗ mạnh * theo chỗ chúng tôi được biết",
    example:
      "gãi đúng chỗ ngứa * khắc phục chỗ yếu, phát huy chỗ mạnh * theo chỗ chúng tôi được biết",
  },
  {
    word: "chỗ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) mối quan hệ thân tình nào đó: chỗ bạn bè với nhau, cậu đừng ngại * hai người là chỗ quen biết cũ",
    example:
      "chỗ bạn bè với nhau, cậu đừng ngại * hai người là chỗ quen biết cũ",
  },
  {
    word: "chỗ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) người được lựa chọn để kết hôn: tìm chỗ xứng đôi * cháu nó đã có chỗ nào chưa?",
    example: "tìm chỗ xứng đôi * cháu nó đã có chỗ nào chưa?",
  },
  {
    word: "chót vót",
    part_of_speech: "tính từ",
    meaning:
      "cao vượt hẳn lên trên tất cả, trông trơ trọi: ngọn cây cao chót vót * đứng chót vót trên đỉnh núi",
    example: "ngọn cây cao chót vót * đứng chót vót trên đỉnh núi",
  },
  {
    word: "chỗ phạm",
    part_of_speech: "danh từ",
    meaning:
      "chỗ trên thân thể dễ bị nguy hiểm đến tính mạng khi bị thương: đánh trúng chỗ phạm * gáy là chỗ phạm",
    example: "đánh trúng chỗ phạm * gáy là chỗ phạm",
  },
  {
    word: "chồi",
    part_of_speech: "danh từ",
    meaning:
      "phần đâm ra từ đầu ngọn, kẽ lá, cành hoặc từ rễ, về sau phát triển thành cành hoặc thành cây: cây đâm chồi nảy lộc * chồi non",
    example: "cây đâm chồi nảy lộc * chồi non",
  },
  {
    word: "chốc lở",
    part_of_speech: "danh từ",
    meaning:
      "chốc và lở; bệnh ngoài da nói chung do vi trùng gây nên, làm thành những mụn mủ, thường gây đau đớn và ngứa ngáy khó chịu, khi khỏi không để lại sẹo: chốc lở đầy người",
    example: "chốc lở đầy người",
  },
  {
    word: "chốc lát",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian ngắn, một chốc, một lát (nói khái quát): ngồi chốc lát rồi lại đi * chỉ trong chốc lát, mọi thứ đã thay đổi hẳn",
    example:
      "ngồi chốc lát rồi lại đi * chỉ trong chốc lát, mọi thứ đã thay đổi hẳn",
  },
  {
    word: "chốc mòng",
    part_of_speech: "động từ",
    meaning:
      '(cũ, văn chương) trông mong, mong đợi: "Nước non cách mấy buồng thêu, Những là trộm dấu thầm yêu chốc mòng." (TKiều)',
    example:
      'Nước non cách mấy buồng thêu, Những là trộm dấu thầm yêu chốc mòng." (TKiều)',
  },
  {
    word: "chốc chốc",
    part_of_speech: "phụ từ",
    meaning:
      "từng lúc một, từng khoảng thời gian ngắn một (lại xảy ra hiện tượng tương tự): chốc chốc lại có người đến hỏi",
    example: "chốc chốc lại có người đến hỏi",
  },
  {
    word: "chốc",
    part_of_speech: "danh từ",
    meaning:
      "bệnh ở da đầu do vi trùng gây nên, làm thành những mụn mủ, khi khỏi không để lại sẹo: bị chốc đầu",
    example: "bị chốc đầu",
  },
  {
    word: "chốc",
    part_of_speech: "danh từ",
    meaning:
      'khoảng thời gian tương đối ngắn: đợi chốc nữa hãy đi * chẳng mấy chốc mà hỏng * "Từ con lưu lạc quê người, Bèo trôi sóng vỗ, chốc mười lăm năm." (TKiều)',
    example:
      'đợi chốc nữa hãy đi * chẳng mấy chốc mà hỏng * "Từ con lưu lạc quê người, Bèo trôi sóng vỗ, chốc mười lăm năm." (TKiều)',
  },
  {
    word: "chổi cùn rế rách",
    part_of_speech: "",
    meaning:
      "chỉ những thứ cũ và linh tinh đáng bỏ đi: toàn những thứ chổi cùn rế rách",
    example: "toàn những thứ chổi cùn rế rách",
  },
  {
    word: "chối",
    part_of_speech: "động từ",
    meaning:
      "không nhận là đã làm, đã gây ra: chứng cớ rành rành mà còn chối * chối bay chối biến",
    example: "chứng cớ rành rành mà còn chối * chối bay chối biến",
  },
  {
    word: "chối",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) từ chối (nói tắt): tìm cách chối khéo lời mời * nói thế nào cũng chối đây đẩy",
    example: "tìm cách chối khéo lời mời * nói thế nào cũng chối đây đẩy",
  },
  {
    word: "chối",
    part_of_speech: "tính từ",
    meaning:
      "có những tác động gây kích thích khó chịu, làm cho không thể tiếp tục, tiếp nhận hoặc chịu đựng thêm được nữa: nghe nó nói mà chối cả tai * chối quá, không sao nuốt nổi",
    example: "nghe nó nói mà chối cả tai * chối quá, không sao nuốt nổi",
  },
  {
    word: "chối cãi",
    part_of_speech: "động từ",
    meaning:
      "cãi, không chịu thừa nhận một điều có thật (có liên quan đến mình): chứng cớ rành rành, không thể chối cãi",
    example: "chứng cớ rành rành, không thể chối cãi",
  },
  {
    word: "chổi rễ",
    part_of_speech: "danh từ",
    meaning:
      "chổi quét rác, thường làm bằng cành cây chổi: lông mày chổi sể (lông mày rậm và cứng)",
    example: "lông mày chổi sể (lông mày rậm và cứng)",
  },
  {
    word: "chổi sể",
    part_of_speech: "danh từ",
    meaning:
      "chổi quét rác, thường làm bằng cành cây chổi: lông mày chổi sể (lông mày rậm và cứng)",
    example: "lông mày chổi sể (lông mày rậm và cứng)",
  },
  {
    word: "chổi",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng để quét, thường làm bằng cây chổi (thanh hao), rơm, cọng cây, v.v.: bện chổi rơm * cầm chổi quét nhà",
    example: "bện chổi rơm * cầm chổi quét nhà",
  },
  {
    word: "chối bỏ",
    part_of_speech: "động từ",
    meaning:
      "không chịu tiếp nhận, không thừa nhận cái vốn dĩ có quan hệ hoặc có giá trị đối với mình: chối bỏ quá khứ * chối bỏ trách nhiệm",
    example: "chối bỏ quá khứ * chối bỏ trách nhiệm",
  },
  {
    word: "chối từ",
    part_of_speech: "động từ",
    meaning: "như từ chối: chối từ lời mời",
    example: "chối từ lời mời",
  },
  {
    word: "chồm",
    part_of_speech: "động từ",
    meaning:
      "cất cao mình lên và lao mạnh về phía trước: ngựa cất vó chồm lên * con chó chồm lên lao thẳng vào tên trộm",
    example: "ngựa cất vó chồm lên * con chó chồm lên lao thẳng vào tên trộm",
  },
  {
    word: "chồm",
    part_of_speech: "động từ",
    meaning: "bật mạnh người lên: giật mình chồm dậy",
    example: "giật mình chồm dậy",
  },
  {
    word: "chôm",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ, khẩu ngữ) nhón, lấy cắp (thường những vật nhỏ): chôm đồ * bị kẻ cắp chôm mất chiếc ví",
    example: "chôm đồ * bị kẻ cắp chôm mất chiếc ví",
  },
  {
    word: "chôm chỉa",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ, khẩu ngữ) chôm (nói khái quát): chôm chỉa đồ của nhau",
    example: "chôm chỉa đồ của nhau",
  },
  {
    word: "chôm chôm",
    part_of_speech: "danh từ",
    meaning:
      "bọ cánh nửa trông giống con nhện, chân dài và mảnh giống gọng vó, hay nhảy trên mặt nước hồ ao: nhảy như chôm chôm",
    example: "nhảy như chôm chôm",
  },
  {
    word: "chôm chôm",
    part_of_speech: "danh từ",
    meaning:
      "cây ăn quả gần với vải, vỏ màu đỏ hoặc vàng, có nhiều gai mềm và dài, vị ngọt hơi chua: trái chôm chôm",
    example: "trái chôm chôm",
  },
  {
    word: "chồm chỗm",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả dáng ngồi toàn thân hơi nhô về phía trước, hai chân thì gập lại: ngồi chồm chỗm trên ghế",
    example: "ngồi chồm chỗm trên ghế",
  },
  {
    word: "chốn",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương) nơi (thường nói về nơi ở): không chốn nương thân * về thăm chốn cũ * đi đến nơi về đến chốn",
    example: "không chốn nương thân * về thăm chốn cũ * đi đến nơi về đến chốn",
  },
  {
    word: "chôn",
    part_of_speech: "động từ",
    meaning:
      "đặt xuống lỗ đào dưới đất và lấp đất lại: chôn cột * chôn chặt mối tình đầu",
    example: "chôn cột * chôn chặt mối tình đầu",
  },
  {
    word: "chôn cất",
    part_of_speech: "động từ",
    meaning:
      "chôn người chết theo nghi thức (nói khái quát): chôn cất người chết",
    example: "chôn cất người chết",
  },
  {
    word: "chồn",
    part_of_speech: "tính từ",
    meaning:
      "(chân, tay) mỏi đến mức không còn muốn cử động gì nữa: mới quai búa một lúc mà đã chồn cả tay * đi mãi cũng chồn chân",
    example: "mới quai búa một lúc mà đã chồn cả tay * đi mãi cũng chồn chân",
  },
  {
    word: "chống",
    part_of_speech: "động từ",
    meaning:
      "đặt một vật hình thanh dài cho đứng vững ở một điểm rồi tựa vào một vật khác để giữ cho vật này khỏi đổ, khỏi ngã: hàng cột chống mái hiên * chân yếu phải chống gậy * tay chống cằm",
    example:
      "hàng cột chống mái hiên * chân yếu phải chống gậy * tay chống cằm",
  },
  {
    word: "chống",
    part_of_speech: "động từ",
    meaning:
      "tì mạnh vào một đầu của chiếc sào đã được cắm nghiêng xuống nước, dùng sức đẩy mạnh để cho thuyền bè di chuyển theo hướng ngược lại: chống sào * vụng chèo khéo chống (tng)",
    example: "chống sào * vụng chèo khéo chống (tng)",
  },
  {
    word: "chống",
    part_of_speech: "động từ",
    meaning:
      "hoạt động ngược lại, gây trở ngại cho hành động của ai hoặc làm cản trở sức tác động của cái gì: chống giặc ngoại xâm * chống tham nhũng * gạch chống nóng * chống mê tín, dị đoan",
    example:
      "chống giặc ngoại xâm * chống tham nhũng * gạch chống nóng * chống mê tín, dị đoan",
  },
  {
    word: "chông",
    part_of_speech: "danh từ",
    meaning:
      "vật có đầu nhọn và sắc, thường được cắm thành đám dày để làm bẫy hoặc làm vật chướng ngại: vót chông * cài bẫy chông",
    example: "vót chông * cài bẫy chông",
  },
  {
    word: "chôn chân",
    part_of_speech: "động từ",
    meaning: "ở mãi một nơi, không đi đâu được: cả ngày phải chôn chân ở nhà",
    example: "cả ngày phải chôn chân ở nhà",
  },
  {
    word: "chôn chân",
    part_of_speech: "động từ",
    meaning:
      "kìm giữ chặt ở một nơi, không cho di chuyển: du kích chôn chân giặc trong bốt",
    example: "du kích chôn chân giặc trong bốt",
  },
  {
    word: "chộn rộn",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) nhốn nháo, lộn xộn: sân ga chộn rộn * tình hình đang chộn rộn",
    example: "sân ga chộn rộn * tình hình đang chộn rộn",
  },
  {
    word: "chộn rộn",
    part_of_speech: "tính từ",
    meaning:
      "rộn ràng, hối hả: không khí chộn rộn ngày giáp Tết * lòng chộn rộn những tình cảm khó tả",
    example:
      "không khí chộn rộn ngày giáp Tết * lòng chộn rộn những tình cảm khó tả",
  },
  {
    word: "chồng",
    part_of_speech: "danh từ",
    meaning:
      'người đàn ông đã kết hôn, trong quan hệ với người phụ nữ kết hôn với mình (vợ): lấy chồng * "Chồng gì anh, vợ gì tôi, Chẳng qua là cái nợ đời chi đây!" (ca dao)',
    example:
      'lấy chồng * "Chồng gì anh, vợ gì tôi, Chẳng qua là cái nợ đời chi đây!" (ca dao)',
  },
  {
    word: "chồng",
    part_of_speech: "động từ",
    meaning:
      "đặt cái nọ sát liền lên bên trên cái kia (thường nói về vật cùng loại): cái nọ chồng lên cái kia * vá chồng lên miếng vá cũ",
    example: "cái nọ chồng lên cái kia * vá chồng lên miếng vá cũ",
  },
  {
    word: "chồng",
    part_of_speech: "danh từ",
    meaning:
      "khối do nhiều vật cùng loại đặt chồng lên nhau: chồng sách cũ * mấy chồng bát đĩa * một chồng gạch",
    example: "chồng sách cũ * mấy chồng bát đĩa * một chồng gạch",
  },
  {
    word: "chồng chất",
    part_of_speech: "động từ",
    meaning:
      "chồng lên nhau thành nhiều tầng, nhiều lớp ngổn ngang: hàng hoá chồng chất trên xe * khó khăn chồng chất",
    example: "hàng hoá chồng chất trên xe * khó khăn chồng chất",
  },
  {
    word: "chồng chéo",
    part_of_speech: "động từ",
    meaning:
      "chồng lên nhau, chéo lên nhau không theo một thứ tự nào cả: những thân gỗ xếp chồng chéo lên nhau * bố trí để công việc không bị chồng chéo",
    example:
      "những thân gỗ xếp chồng chéo lên nhau * bố trí để công việc không bị chồng chéo",
  },
  {
    word: "chống án",
    part_of_speech: "động từ",
    meaning:
      "(đương sự) không đồng ý với kết luận và quyết định của toà án cấp dưới và yêu cầu toà án cấp trên xử lại: làm đơn chống án",
    example: "làm đơn chống án",
  },
  {
    word: "chổng",
    part_of_speech: "động từ",
    meaning:
      "giơ ngược lên trên cái bộ phận vốn ở vị trí bên dưới: chổng mông * ngã, bị chổng bốn vó lên trời",
    example: "chổng mông * ngã, bị chổng bốn vó lên trời",
  },
  {
    word: "chống chế",
    part_of_speech: "động từ",
    meaning:
      "cố viện lí, viện cớ để thanh minh, bênh vực hoặc để che đậy, lảng tránh một việc làm sai nào đó: đã làm sai lại còn chống chế * chỉ giỏi chống chế!",
    example: "đã làm sai lại còn chống chế * chỉ giỏi chống chế!",
  },
  {
    word: "chống chếnh",
    part_of_speech: "tính từ",
    meaning:
      "(nơi, chỗ) thiếu hẳn sự che chắn cần thiết ở chung quanh hoặc thiếu hẳn những thứ cần có ở bên trong: nhà cửa chống chếnh",
    example: "nhà cửa chống chếnh",
  },
  {
    word: "chống chếnh",
    part_of_speech: "tính từ",
    meaning:
      "thiếu vắng những cái thân thiết trong cuộc sống: cảm giác chống chếnh * tiễn bạn đi rồi, lòng thấy chống chếnh",
    example: "cảm giác chống chếnh * tiễn bạn đi rồi, lòng thấy chống chếnh",
  },
  {
    word: "chông chênh",
    part_of_speech: "tính từ",
    meaning:
      "không vững chãi, không ổn định vì không có chỗ dựa chắc chắn: đứng chông chênh * lập luận chông chênh",
    example: "đứng chông chênh * lập luận chông chênh",
  },
  {
    word: "chồng con",
    part_of_speech: "danh từ",
    meaning:
      "chồng và con, về mặt là gia đình riêng của người phụ nữ (nói khái quát): tính chuyện chồng con * ngoài ba mươi mà vẫn chưa chồng con gì",
    example: "tính chuyện chồng con * ngoài ba mươi mà vẫn chưa chồng con gì",
  },
  {
    word: "chống cự",
    part_of_speech: "động từ",
    meaning:
      "đánh trả lại để tự vệ: chống cự yếu ớt * đứng chịu trận, không chống cự",
    example: "chống cự yếu ớt * đứng chịu trận, không chống cự",
  },
  {
    word: "chống đối",
    part_of_speech: "động từ",
    meaning:
      "chống lại một cách trực tiếp với thái độ quyết liệt hoặc đối địch (nói khái quát): chống đối chính quyền * hành động chống đối",
    example: "chống đối chính quyền * hành động chống đối",
  },
  {
    word: "chống chọi",
    part_of_speech: "động từ",
    meaning:
      "chống lại một cách quyết liệt để bảo vệ mình trước một lực lượng mạnh hơn hoặc trước sự tác động mạnh mẽ nào đó: chống chọi với bệnh tật * quyết chống chọi đến cùng",
    example: "chống chọi với bệnh tật * quyết chống chọi đến cùng",
  },
  {
    word: "chống giữ",
    part_of_speech: "động từ",
    meaning: "chống lại để bảo vệ, để giữ gìn: chống giữ thành trì",
    example: "chống giữ thành trì",
  },
  {
    word: "chổng kềnh",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) ngã hoặc đổ ngửa ra: xe đổ chổng kềnh * ngã chổng kềnh",
    example: "xe đổ chổng kềnh * ngã chổng kềnh",
  },
  {
    word: "chông gai",
    part_of_speech: "danh từ",
    meaning:
      'chông và gai (nói khái quát), dùng để ví những trở ngại, khó khăn, nguy hiểm gặp phải trong quá trình thực hiện một việc gì: đạp bằng chông gai * "Bỗng đâu gặp bước chông gai, Non cao, nước thẳm nào ai biết gì?" (LNT)',
    example:
      'đạp bằng chông gai * "Bỗng đâu gặp bước chông gai, Non cao, nước thẳm nào ai biết gì?" (LNT)',
  },
  {
    word: "chống đỡ",
    part_of_speech: "động từ",
    meaning: "chống để giữ cho vững, cho khỏi đổ: hàng cột chống đỡ mái nhà",
    example: "hàng cột chống đỡ mái nhà",
  },
  {
    word: "chống đỡ",
    part_of_speech: "động từ",
    meaning:
      "chống lại để cố gắng tự bảo vệ mình khỏi những tác động gây hại từ bên ngoài: người yếu không đủ sức chống đỡ * chống đỡ với mưa nắng",
    example: "người yếu không đủ sức chống đỡ * chống đỡ với mưa nắng",
  },
  {
    word: "chồng loan vợ phượng",
    part_of_speech: "",
    meaning:
      '(cũ, văn chương) cảnh vợ chồng đẹp đôi, hạnh phúc: "Ước sao cho hợp một nhà, Chồng loan vợ phượng đôi ta chung tình." (ca dao)',
    example:
      'Ước sao cho hợp một nhà, Chồng loan vợ phượng đôi ta chung tình." (ca dao)',
  },
  {
    word: "chồng lấn",
    part_of_speech: "động từ",
    meaning:
      "(khu vực) sát liền nhau, có phần lấn sang phạm vi của nhau, làm cho ranh giới không được rõ ràng, khó phân định: các vùng chồng lấn trên biển * giải quyết các tranh chấp ở vùng chồng lấn",
    example:
      "các vùng chồng lấn trên biển * giải quyết các tranh chấp ở vùng chồng lấn",
  },
  {
    word: "chống nẹ",
    part_of_speech: "động từ",
    meaning:
      "chống một cánh tay xuống điểm tựa để nghiêng người sang một bên: đứng chống nẹ lên chiếc bàn làm việc",
    example: "đứng chống nẹ lên chiếc bàn làm việc",
  },
  {
    word: "chồng ngồng",
    part_of_speech: "tính từ",
    meaning:
      "(thông tục) không mặc quần áo, mà trần truồng, để lộ hết các chỗ kín của thân thể ra, trông khó coi: đứa trẻ đứng tắm tồng ngồng",
    example: "đứa trẻ đứng tắm tồng ngồng",
  },
  {
    word: "chồng ngồng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có vóc dáng như người lớn, không còn bé nhỏ gì nữa (hàm ý chê): lớn tồng ngồng rồi mà vẫn chưa biết làm gì",
    example: "lớn tồng ngồng rồi mà vẫn chưa biết làm gì",
  },
  {
    word: "chống nạnh",
    part_of_speech: "động từ",
    meaning:
      "(đứng) chống tay vào hông, thường để tỏ thái độ thách thức hoặc đáo để: đứng chống nạnh * tay chống nạnh",
    example: "đứng chống nạnh * tay chống nạnh",
  },
  {
    word: "chống phá",
    part_of_speech: "động từ",
    meaning:
      "chống lại bằng hoạt động phá hoại (nói khái quát): phần tử chống phá cách mạng * hoạt động chống phá",
    example: "phần tử chống phá cách mạng * hoạt động chống phá",
  },
  {
    word: "chổng vó",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) như chỏng gọng: ngã chổng vó",
    example: "ngã chổng vó",
  },
  {
    word: "chộp giật",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ, hiếm) như chụp giật: làm ăn kiểu chộp giật",
    example: "làm ăn kiểu chộp giật",
  },
  {
    word: "chột",
    part_of_speech: "tính từ",
    meaning: "có một mắt bị hỏng: chột mắt trái",
    example: "chột mắt trái",
  },
  {
    word: "chột",
    part_of_speech: "tính từ",
    meaning:
      "(cây trồng hoặc gia súc) mất khả năng phát triển bình thường: cây bị chột * con chó chột đi sau trận ốm",
    example: "cây bị chột * con chó chột đi sau trận ốm",
  },
  {
    word: "chột",
    part_of_speech: "tính từ",
    meaning:
      "thấy sợ và mất bình tĩnh vì đột ngột cảm thấy điều mình đang giấu giếm hình như bị phát hiện: bị hỏi bất ngờ, nên hơi chột",
    example: "bị hỏi bất ngờ, nên hơi chột",
  },
  {
    word: "chốt",
    part_of_speech: "danh từ",
    meaning:
      "thanh cài qua lỗ có sẵn để giữ chặt một vật lại hay giữ chặt nhiều vật với nhau: cổng đã cài chốt * chốt lựu đạn",
    example: "cổng đã cài chốt * chốt lựu đạn",
  },
  {
    word: "chốt",
    part_of_speech: "danh từ",
    meaning: "(cũ) trục giữa: chốt cối xay",
    example: "chốt cối xay",
  },
  {
    word: "chốt",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) cái cốt yếu: nắm được chốt của vấn đề * chốt của câu chuyện",
    example: "nắm được chốt của vấn đề * chốt của câu chuyện",
  },
  {
    word: "chốt",
    part_of_speech: "danh từ",
    meaning:
      "vị trí quân sự có hoả lực mạnh dùng để khống chế và giữ vững một khu vực trong một thời gian nào đó: bám chốt * quân địch tràn lên chiếm chốt",
    example: "bám chốt * quân địch tràn lên chiếm chốt",
  },
  {
    word: "chốt",
    part_of_speech: "động từ",
    meaning: "cài bằng chốt: cổng chưa chốt * chốt chặt cửa lại",
    example: "cổng chưa chốt * chốt chặt cửa lại",
  },
  {
    word: "chốt",
    part_of_speech: "động từ",
    meaning:
      "đóng quân để khống chế và giữ vững một khu vực trong một thời gian nào đó: cho quân chốt các ngả đường ra vào thành phố",
    example: "cho quân chốt các ngả đường ra vào thành phố",
  },
  {
    word: "chống trả",
    part_of_speech: "động từ",
    meaning: "chống lại bằng cách đánh trả: chống trả quyết liệt",
    example: "chống trả quyết liệt",
  },
  {
    word: "chộp",
    part_of_speech: "động từ",
    meaning:
      "đưa tay ra rất nhanh để nắm lấy: chộp được con cá * chộp lấy cổ tay tên cướp",
    example: "chộp được con cá * chộp lấy cổ tay tên cướp",
  },
  {
    word: "chộp",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bắt giữ lấy một cách nhanh gọn: chộp được tên cướp * chộp lấy thời cơ",
    example: "chộp được tên cướp * chộp lấy thời cơ",
  },
  {
    word: "chột dạ",
    part_of_speech: "tính từ",
    meaning:
      "giật mình lo sợ vì cảm thấy điều mình đang giấu giếm có nguy cơ bị phát hiện: thấy có người đi lại phía mình, tên gian chột dạ",
    example: "thấy có người đi lại phía mình, tên gian chột dạ",
  },
  {
    word: "chờ",
    part_of_speech: "động từ",
    meaning:
      "ở trong trạng thái đang mong ngóng ai hoặc cái gì sẽ tới, sẽ xảy ra: chờ tàu * chờ tới lượt mình * chờ cho tạnh mưa thì đi",
    example: "chờ tàu * chờ tới lượt mình * chờ cho tạnh mưa thì đi",
  },
  {
    word: "chở",
    part_of_speech: "động từ",
    meaning:
      "mang chuyển đi nơi khác bằng tàu bè, xe cộ, v.v.: xe bò chở đất * chở khách sang sông * tàu chở hàng",
    example: "xe bò chở đất * chở khách sang sông * tàu chở hàng",
  },
  {
    word: "chớ",
    part_of_speech: "phụ từ",
    meaning:
      'từ biểu thị ý khuyên ngăn dứt khoát: chớ có dại mà nghe theo nó * "Được mùa chớ phụ ngô khoai, Đến khi thất bát lấy ai bạn cùng." (ca dao)',
    example:
      'chớ có dại mà nghe theo nó * "Được mùa chớ phụ ngô khoai, Đến khi thất bát lấy ai bạn cùng." (ca dao)',
  },
  {
    word: "chớ",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) từ biểu thị ý phủ định dứt khoát điều chưa hề xảy ra bao giờ: chớ thấy mặt nó bao giờ * dù khó khăn, chớ hề thở than",
    example: "chớ thấy mặt nó bao giờ * dù khó khăn, chớ hề thở than",
  },
  {
    word: "chợ búa",
    part_of_speech: "danh từ",
    meaning:
      "chợ (nói khái quát): chợ búa vắng teo * chỉ làm ruộng chứ có chợ búa gì đâu!",
    example: "chợ búa vắng teo * chỉ làm ruộng chứ có chợ búa gì đâu!",
  },
  {
    word: "chợ",
    part_of_speech: "danh từ",
    meaning:
      "nơi công cộng để mọi người đến mua bán hàng hoá, có thể được quy định vào những buổi hoặc những ngày nhất định: phiên chợ * ồn ào như chợ vỡ * đầu đường xó chợ (tng)",
    example: "phiên chợ * ồn ào như chợ vỡ * đầu đường xó chợ (tng)",
  },
  {
    word: "chợ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (hàng hoá) có chất lượng thấp, giá cả tương đối rẻ, bày bán ở nhiều nơi: hàng chợ",
    example: "hàng chợ",
  },
  {
    word: "chớ chi",
    part_of_speech: "kết từ",
    meaning: "(phương ngữ) như giá như: chớ chi biết trước thì đâu đến nỗi",
    example: "chớ chi biết trước thì đâu đến nỗi",
  },
  {
    word: "chờ chực",
    part_of_speech: "động từ",
    meaning:
      "chờ đợi lâu, mất nhiều thì giờ, để làm việc gì: mất công chờ chực * chờ chực cả ngày mới gặp được",
    example: "mất công chờ chực * chờ chực cả ngày mới gặp được",
  },
  {
    word: "chở che",
    part_of_speech: "động từ",
    meaning: "(văn chương, hiếm) như che chở: được gia đình đùm bọc, chở che",
    example: "được gia đình đùm bọc, chở che",
  },
  {
    word: "chợ chiều",
    part_of_speech: "danh từ",
    meaning:
      'chợ về chiều, lúc gần tan; ví cảnh tàn cuộc, rời rạc, không còn ồn ào, sôi nổi: không khí chợ chiều * "Khi anh gặp chị, thì đôi bên đã là cảnh xế muộn chợ chiều rồi, cho nên cũng dễ dãi mà lấy nhau." (THoài; 29)',
    example:
      'không khí chợ chiều * "Khi anh gặp chị, thì đôi bên đã là cảnh xế muộn chợ chiều rồi, cho nên cũng dễ dãi mà lấy nhau." (THoài; 29)',
  },
  {
    word: "chớ có trách",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) như đừng có trách: mày liệu hồn, làm hỏng thì chớ có trách!",
    example: "mày liệu hồn, làm hỏng thì chớ có trách!",
  },
  {
    word: "chợ đen",
    part_of_speech: "danh từ",
    meaning:
      'nơi mua bán hàng hoá, tiền tệ một cách lén lút, bất hợp pháp với giá cả tuỳ tiện: giá chợ đen * "Anh Hoàng là một nhà văn, nhưng đồng thời cũng là một tay chợ đen rất tài tình." (NCao; 8)',
    example:
      'giá chợ đen * "Anh Hoàng là một nhà văn, nhưng đồng thời cũng là một tay chợ đen rất tài tình." (NCao; 8)',
  },
  {
    word: "chờ đợi",
    part_of_speech: "động từ",
    meaning:
      "chờ, thường trong khoảng thời gian khá dài (nói khái quát): chờ đợi người yêu * uổng công chờ đợi",
    example: "chờ đợi người yêu * uổng công chờ đợi",
  },
  {
    word: "chờ mong",
    part_of_speech: "động từ",
    meaning:
      'chờ với nhiều hi vọng thế nào cũng sẽ xảy ra: "Non cao những ngóng cùng trông, Suối khô dòng lệ chờ mong tháng ngày." (TĐà; 7)',
    example:
      'Non cao những ngóng cùng trông, Suối khô dòng lệ chờ mong tháng ngày." (TĐà; 7)',
  },
  {
    word: "chợ trưa dưa héo",
    part_of_speech: "",
    meaning:
      'ví cảnh ế ẩm, muộn mằn về đường tình duyên của người con gáI: "Em về giục mẹ cùng cha, Chợ trưa dưa héo, nghĩ mà buồn tênh!" (ca dao)',
    example:
      'Em về giục mẹ cùng cha, Chợ trưa dưa héo, nghĩ mà buồn tênh!" (ca dao)',
  },
  {
    word: "chợ nổi",
    part_of_speech: "danh từ",
    meaning:
      "chợ họp một cách tự phát trên mặt sông, mặt nước, các hoạt động mua bán diễn ra trên thuyền, trên xuồng: chợ nổi vùng đồng bằng sông Cửu Long",
    example: "chợ nổi vùng đồng bằng sông Cửu Long",
  },
  {
    word: "chơi",
    part_of_speech: "động từ",
    meaning:
      "hoạt động giải trí hoặc nghỉ ngơi: trẻ con chơi ngoài sân * đi chơi phố * chơi bài * ăn tuỳ nơi, chơi tuỳ lúc (tng)",
    example:
      "trẻ con chơi ngoài sân * đi chơi phố * chơi bài * ăn tuỳ nơi, chơi tuỳ lúc (tng)",
  },
  {
    word: "chơi",
    part_of_speech: "động từ",
    meaning:
      "hoạt động (dùng một đối tượng nào đó) để tiêu khiển, để làm thú vui: chơi tem * chơi cây cảnh",
    example: "chơi tem * chơi cây cảnh",
  },
  {
    word: "chơi",
    part_of_speech: "động từ",
    meaning:
      "quan hệ với nhau trên cơ sở quen biết, gần gũi hoặc vì cùng chung thú vui, thú tiêu khiển: chơi thân với nhau từ nhỏ * chọn bạn mà chơi",
    example: "chơi thân với nhau từ nhỏ * chọn bạn mà chơi",
  },
  {
    word: "chơi",
    part_of_speech: "động từ",
    meaning:
      "hoạt động chỉ nhằm cho vui mà thôi, không có mục đích gì khác: đùa một tí chơi * thử chơi cho biết chứ không định làm thật",
    example: "đùa một tí chơi * thử chơi cho biết chứ không định làm thật",
  },
  {
    word: "chơi",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) (trẻ con) tỏ ra khoẻ mạnh, không đau ốm: cháu nó vẫn chơi",
    example: "cháu nó vẫn chơi",
  },
  {
    word: "chơi",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) hành động gây hại cho người khác, nhưng lại xem như trò vui: bị nó chơi cho một vố đau điếng",
    example: "bị nó chơi cho một vố đau điếng",
  },
  {
    word: "chơ vơ",
    part_of_speech: "tính từ",
    meaning:
      'lẻ loi, trơ trọi giữa khoảng trống rộng: cái quán chơ vơ giữa đồng * "Ai ngờ chim lưới, cá câu, Chơ vơ ai biết ai đâu mà tìm." (ca dao)',
    example:
      'cái quán chơ vơ giữa đồng * "Ai ngờ chim lưới, cá câu, Chơ vơ ai biết ai đâu mà tìm." (ca dao)',
  },
  {
    word: "chơi đểu",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) lợi dụng sự sơ hở hoặc tình cảnh của người khác để bày trò lừa gạt hoặc làm hại: nó chơi đểu, định lừa cả mình!",
    example: "nó chơi đểu, định lừa cả mình!",
  },
  {
    word: "chơi ngang",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) có hành động ngang ngược, bất chấp phép tắc: cậy thế chơi ngang",
    example: "cậy thế chơi ngang",
  },
  {
    word: "chơi ngang",
    part_of_speech: "động từ",
    meaning:
      '(trai gái đã có vợ, có chồng) có quan hệ nam nữ bất chính: "Có chồng càng dễ chơi ngang, Đẻ ra con thiếp, con chàng, con ai?" (ca dao)',
    example:
      'Có chồng càng dễ chơi ngang, Đẻ ra con thiếp, con chàng, con ai?" (ca dao)',
  },
  {
    word: "chơi bời",
    part_of_speech: "động từ",
    meaning: "chơi với nhau (nói khái quát): không chơi bời với ai",
    example: "không chơi bời với ai",
  },
  {
    word: "chơi bời",
    part_of_speech: "động từ",
    meaning:
      "ham chơi những trò tiêu khiển không lành mạnh: chơi bời cờ bạc * nổi tiếng chơi bời",
    example: "chơi bời cờ bạc * nổi tiếng chơi bời",
  },
  {
    word: "chơi bời",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) làm việc gì một cách hời hợt, không quan tâm đến mục đích cũng như kết quả cụ thể: làm chơi bời như vậy thì bao giờ cho xong",
    example: "làm chơi bời như vậy thì bao giờ cho xong",
  },
  {
    word: "chơi đùa",
    part_of_speech: "động từ",
    meaning:
      "chơi và đùa (nói khái quát; thường nói về trẻ em): bọn trẻ chơi đùa ngoài sân",
    example: "bọn trẻ chơi đùa ngoài sân",
  },
  {
    word: "chơi khăm",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bày ra những trò ác ngầm để hại người khác: bị chơi khăm một vố",
    example: "bị chơi khăm một vố",
  },
  {
    word: "chơi trội",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) cố ý phô trương mặt mạnh của mình để tỏ ra ta đây nổi trội, tài giỏi hơn hẳn người khác: thích chơi trội",
    example: "thích chơi trội",
  },
  {
    word: "chơi vơi",
    part_of_speech: "tính từ",
    meaning:
      'trơ trọi giữa khoảng trống rộng, không biết bấu víu vào đâu: con thuyền chơi vơi giữa biển cả * cảm giác chơi vơi * "Mặt trăng chơi vơi trên nền trời không mây gợn." (NgCHoan; 11)',
    example:
      'con thuyền chơi vơi giữa biển cả * cảm giác chơi vơi * "Mặt trăng chơi vơi trên nền trời không mây gợn." (NgCHoan; 11)',
  },
  {
    word: "chơi trèo",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) có quan hệ bè bạn không bình thường với những người có địa vị cao hơn hẳn: biết phận nghèo, không dám chơi trèo",
    example: "biết phận nghèo, không dám chơi trèo",
  },
  {
    word: "chới với",
    part_of_speech: "động từ",
    meaning:
      "từ gợi tả cánh tay run rẩy cố với lên khoảng không nhiều lần, như muốn tìm chỗ bám víu: chới với giữa dòng nước xiết",
    example: "chới với giữa dòng nước xiết",
  },
  {
    word: "chơm chởm",
    part_of_speech: "tính từ",
    meaning: "có nhiều đầu nhọn nhô lên: bờ tường chơm chởm mảnh chai",
    example: "bờ tường chơm chởm mảnh chai",
  },
  {
    word: "chơi xỏ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) lợi dụng chỗ sơ hở để ngầm hại hoặc làm cho bị bẽ mặt: bị bạn chơi xỏ * bị chơi xỏ một vố",
    example: "bị bạn chơi xỏ * bị chơi xỏ một vố",
  },
  {
    word: "chơi xấu",
    part_of_speech: "động từ",
    meaning:
      "(cách xử sự) tỏ ra là không phải, không tốt, có ý làm hại đến người khác: chơi xấu với bạn",
    example: "chơi xấu với bạn",
  },
  {
    word: "chơi với lửa",
    part_of_speech: "",
    meaning:
      "ví việc đùa dại dột với cái nguy hiểm hoặc việc làm mạo hiểm dễ bị phản tác dụng: không nên chơi với lửa",
    example: "không nên chơi với lửa",
  },
  {
    word: "chờm",
    part_of_speech: "động từ",
    meaning:
      "nhô ra và phủ trùm sang phạm vi của cái khác: tóc để chờm vai * cỏ mọc chờm cả lối đi",
    example: "tóc để chờm vai * cỏ mọc chờm cả lối đi",
  },
  {
    word: "chớm",
    part_of_speech: "động từ",
    meaning:
      'có những biểu hiện đầu tiên của một quá trình phát triển: tóc đã chớm bạc * tình yêu mới chớm * "Sáng chớm lạnh trong lòng Hà Nội, Những phố dài xao xác hơi may" (NgĐThi; 3)',
    example:
      'tóc đã chớm bạc * tình yêu mới chớm * "Sáng chớm lạnh trong lòng Hà Nội, Những phố dài xao xác hơi may" (NgĐThi; 3)',
  },
  {
    word: "chờm bờm",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) như bờm xờm: đầu chờm bờm như tổ quạ",
    example: "đầu chờm bờm như tổ quạ",
  },
  {
    word: "chờn",
    part_of_speech: "",
    meaning:
      "không còn ăn khớp nữa vì đã bị mòn do ma sát: đinh ốc bị chờn răng * khoá đã chờn",
    example: "đinh ốc bị chờn răng * khoá đã chờn",
  },
  {
    word: "chờn",
    part_of_speech: "",
    meaning:
      "(Khẩu ngữ) không còn có đủ quyết tâm để tiếp tục việc gì nữa, do đã thấy ngại hoặc sợ sau khi gặp khó khăn: gặp khó khăn nên cũng chờn",
    example: "gặp khó khăn nên cũng chờn",
  },
  {
    word: "chờn vờn",
    part_of_speech: "động từ",
    meaning:
      "lượn quanh quẩn không rời, lúc gần lúc xa, khi ẩn khi hiện: chuồn chuồn chờn vờn mặt nước * con mèo chờn vờn quanh mâm cơm",
    example: "chuồn chuồn chờn vờn mặt nước * con mèo chờn vờn quanh mâm cơm",
  },
  {
    word: "chờn chợn",
    part_of_speech: "",
    meaning: "hơi chợn: đi qua bãi tha ma cũng thấy chờn chợn",
    example: "đi qua bãi tha ma cũng thấy chờn chợn",
  },
  {
    word: "chớp bể mưa nguồn",
    part_of_speech: "danh từ",
    meaning:
      "hiện tượng ánh sáng loé mạnh rồi tắt ngay do sự phóng điện giữa hai đám mây hoặc giữa mây và mặt đất: tia chớp * chớp giật liên hồi",
    example: "tia chớp * chớp giật liên hồi",
  },
  {
    word: "chớp bể mưa nguồn",
    part_of_speech: "danh từ",
    meaning: "ánh sáng loé mạnh lên rồi tắt ngay, nói chung: ánh chớp lửa hàn",
    example: "ánh chớp lửa hàn",
  },
  {
    word: "chớp bể mưa nguồn",
    part_of_speech: "động từ",
    meaning:
      "loé hoặc làm loé ánh sáng, rồi vụt tắt ngay: chớp đèn pin * lửa đại bác chớp liên tiếp",
    example: "chớp đèn pin * lửa đại bác chớp liên tiếp",
  },
  {
    word: "chớp bể mưa nguồn",
    part_of_speech: "động từ",
    meaning:
      "(mắt) nhắm lại rồi mở ra ngay: mắt nhìn không chớp * chớp mắt lia lịa",
    example: "mắt nhìn không chớp * chớp mắt lia lịa",
  },
  {
    word: "chớp bể mưa nguồn",
    part_of_speech: "động từ",
    meaning:
      "giành lấy rất nhanh, không bỏ lỡ dịp may hiếm có: chớp thời cơ * biết chớp lấy cơ hội",
    example: "chớp thời cơ * biết chớp lấy cơ hội",
  },
  {
    word: "chớp",
    part_of_speech: "danh từ",
    meaning:
      "hiện tượng ánh sáng loé mạnh rồi tắt ngay do sự phóng điện giữa hai đám mây hoặc giữa mây và mặt đất: tia chớp * chớp giật liên hồi",
    example: "tia chớp * chớp giật liên hồi",
  },
  {
    word: "chớp",
    part_of_speech: "danh từ",
    meaning: "ánh sáng loé mạnh lên rồi tắt ngay, nói chung: ánh chớp lửa hàn",
    example: "ánh chớp lửa hàn",
  },
  {
    word: "chớp",
    part_of_speech: "động từ",
    meaning:
      "loé hoặc làm loé ánh sáng, rồi vụt tắt ngay: chớp đèn pin * lửa đại bác chớp liên tiếp",
    example: "chớp đèn pin * lửa đại bác chớp liên tiếp",
  },
  {
    word: "chớp",
    part_of_speech: "động từ",
    meaning:
      "(mắt) nhắm lại rồi mở ra ngay: mắt nhìn không chớp * chớp mắt lia lịa",
    example: "mắt nhìn không chớp * chớp mắt lia lịa",
  },
  {
    word: "chớp",
    part_of_speech: "động từ",
    meaning:
      "giành lấy rất nhanh, không bỏ lỡ dịp may hiếm có: chớp thời cơ * biết chớp lấy cơ hội",
    example: "chớp thời cơ * biết chớp lấy cơ hội",
  },
  {
    word: "chợn",
    part_of_speech: "",
    meaning:
      "có cảm giác sợ đến lạnh người khi đứng trước hay nghĩ đến mối nguy hiểm lớn: đi đêm một mình cũng thấy chợn",
    example: "đi đêm một mình cũng thấy chợn",
  },
  {
    word: "chợp",
    part_of_speech: "động từ",
    meaning:
      "nhắm mắt ngủ trong khoảng thời gian rất ngắn, tựa như vừa mới ngủ đã thức giấc: vừa mới chợp đi một tí  * cả đêm không chợp mắt",
    example: "vừa mới chợp đi một tí  * cả đêm không chợp mắt",
  },
  {
    word: "chớn",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) ngấn, vệt còn in dấu lại: những chớn bùn còn in dấu hai bên mạn thuyền",
    example: "những chớn bùn còn in dấu hai bên mạn thuyền",
  },
  {
    word: "chớp chới",
    part_of_speech: "động từ",
    meaning:
      "ở trạng thái thăng bằng bất định, khi lên khi xuống, khi nghiêng bên này khi ngả sang bên kia: bướm bay chấp chới",
    example: "bướm bay chấp chới",
  },
  {
    word: "chớp chới",
    part_of_speech: "động từ",
    meaning:
      'rung rinh và khi mờ khi tỏ: ánh đèn chấp chới như sao * "Đuốc hoa chấp chới năm canh nguyệt (...)" (LTKN)',
    example:
      'ánh đèn chấp chới như sao * "Đuốc hoa chấp chới năm canh nguyệt (...)" (LTKN)',
  },
  {
    word: "chớp chới",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nhấp nháy mắt và liếc nhìn một cách không đứng đắn, có ý ve vãn: đôi mắt chấp chới",
    example: "đôi mắt chấp chới",
  },
  {
    word: "chớp mắt",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) khoảng thời gian rất ngắn (tựa như chỉ bằng một cái nháy mắt): sự việc xảy ra trong nháy mắt",
    example: "sự việc xảy ra trong nháy mắt",
  },
  {
    word: "chớt nhả",
    part_of_speech: "",
    meaning:
      "ăn nói đùa cợt không đứng đắn: ăn nói chớt nhả * đùa hơi chớt nhả",
    example: "ăn nói chớt nhả * đùa hơi chớt nhả",
  },
  {
    word: "chợt",
    part_of_speech: "phụ từ",
    meaning:
      "(xảy ra) thình lình và trong khoảnh khắc: chợt nhớ lại chuyện cũ * trời chợt nắng, chợt mưa",
    example: "chợt nhớ lại chuyện cũ * trời chợt nắng, chợt mưa",
  },
  {
    word: "chớp nhoáng",
    part_of_speech: "tính từ",
    meaning:
      "hết sức nhanh chóng, chỉ trong khoảng thời gian rất ngắn: cuộc hội ý chớp nhoáng * sự việc xảy đến chớp nhoáng",
    example: "cuộc hội ý chớp nhoáng * sự việc xảy đến chớp nhoáng",
  },
  {
    word: "chủ",
    part_of_speech: "danh từ",
    meaning:
      "người có quyền sở hữu về tài sản nào đó: chủ nhà * chủ doanh nghiệp * chủ tài khoản",
    example: "chủ nhà * chủ doanh nghiệp * chủ tài khoản",
  },
  {
    word: "chủ",
    part_of_speech: "danh từ",
    meaning:
      "người thuê người làm, trong quan hệ với người làm thuê: quan hệ giữa chủ và thợ",
    example: "quan hệ giữa chủ và thợ",
  },
  {
    word: "chủ",
    part_of_speech: "danh từ",
    meaning:
      "người có quyền quản lí, xử lí toàn bộ các công việc theo lợi ích của mình: thanh niên là người chủ tương lai của đất nước * không làm chủ được bản thân",
    example:
      "thanh niên là người chủ tương lai của đất nước * không làm chủ được bản thân",
  },
  {
    word: "chủ",
    part_of_speech: "danh từ",
    meaning: "người chủ nhà, trong quan hệ với khách: tiền chủ hậu khách",
    example: "tiền chủ hậu khách",
  },
  {
    word: "chủ",
    part_of_speech: "tính từ",
    meaning: "chính, chủ yếu: động mạch chủ * con bài chủ",
    example: "động mạch chủ * con bài chủ",
  },
  {
    word: "chủ bài",
    part_of_speech: "danh từ",
    meaning: "con bài vào loạI có ưu thế hơn cả trong ván bài, theo quy ước.",
    example: "đến phút chót mới tung chủ bài",
  },
  {
    word: "chú",
    part_of_speech: "danh từ",
    meaning:
      "em trai của cha (có thể dùng để xưng gọi): ông chú bà thím * sẩy cha còn chú, sẩy mẹ bú dì (tng)",
    example: "ông chú bà thím * sẩy cha còn chú, sẩy mẹ bú dì (tng)",
  },
  {
    word: "chú",
    part_of_speech: "danh từ",
    meaning:
      "từ thiếu nhi dùng để chỉ hoặc gọi người đàn ông đáng bậc chú mình, với ý yêu mến, kính trọng: chú bộ đội * chú công nhân * chú công an",
    example: "chú bộ đội * chú công nhân * chú công an",
  },
  {
    word: "chú",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ một cậu bé với ý yêu mến, thân mật: chú bé thật láu lỉnh * chú nhóc",
    example: "chú bé thật láu lỉnh * chú nhóc",
  },
  {
    word: "chú",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ người con trai hoặc người đàn ông trẻ tuổi: chú tiểu * chú rể",
    example: "chú tiểu * chú rể",
  },
  {
    word: "chú",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ con vật theo lối nhân cách hoá, với ý hài hước: chú dế mèn * mấy chú ếch con",
    example: "chú dế mèn * mấy chú ếch con",
  },
  {
    word: "chú",
    part_of_speech: "danh từ",
    meaning: "thần chú (nói tắt): vị pháp sư đọc chú",
    example: "vị pháp sư đọc chú",
  },
  {
    word: "chú",
    part_of_speech: "động từ",
    meaning: "niệm thần chú: tay ấn, miệng chú",
    example: "tay ấn, miệng chú",
  },
  {
    word: "chú",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) ghi phụ thêm để làm cho rõ: chú thêm cách đọc một từ nước ngoài",
    example: "chú thêm cách đọc một từ nước ngoài",
  },
  {
    word: "chu",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) đầy đủ và đạt mức yêu cầu, có thể làm cho yên tâm, hài lòng: được thế này là chu lắm",
    example: "được thế này là chu lắm",
  },
  {
    word: "chủ biên",
    part_of_speech: "danh từ",
    meaning:
      "người chủ trì công tác biên soạn một công trình tập thể: chủ biên quyển từ điển",
    example: "chủ biên quyển từ điển",
  },
  {
    word: "chu cấp",
    part_of_speech: "động từ",
    meaning:
      "cấp cho (thường là tự nguyện) những thứ cần thiết để bảo đảm đời sống: chu cấp tiền bạc * được gia đình chu cấp đầy đủ",
    example: "chu cấp tiền bạc * được gia đình chu cấp đầy đủ",
  },
  {
    word: "chủ chiến",
    part_of_speech: "động từ",
    meaning:
      "chủ trương tiến hành chiến tranh; đối lập với chủ hoà: phe chủ chiến",
    example: "phe chủ chiến",
  },
  {
    word: "chu cha",
    part_of_speech: "cảm từ",
    meaning:
      '(phương ngữ) tiếng thốt ra biểu lộ sự ngạc nhiên, thán phục, vui mừng hoặc tức giận, v.v.: "Chu cha sao nắng bể đầu, Anh về làm rể ngõ hầu an thân." (ca dao)',
    example:
      'Chu cha sao nắng bể đầu, Anh về làm rể ngõ hầu an thân." (ca dao)',
  },
  {
    word: "chủ chốt",
    part_of_speech: "tính từ",
    meaning:
      "quan trọng nhất, có tác dụng làm nòng cốt: cán bộ chủ chốt * nhiệm vụ chủ chốt",
    example: "cán bộ chủ chốt * nhiệm vụ chủ chốt",
  },
  {
    word: "chu chuyển",
    part_of_speech: "động từ",
    meaning:
      "vận động tuần hoàn có chu kì (thường nói về hiện tượng kinh tế): chu chuyển vốn",
    example: "chu chuyển vốn",
  },
  {
    word: "chủ đạo",
    part_of_speech: "tính từ",
    meaning:
      "chủ yếu và có tác dụng chi phối đối với toàn bộ: vị trí chủ đạo * giữ vai trò chủ đạo * cảm hứng chủ đạo của bài thơ",
    example:
      "vị trí chủ đạo * giữ vai trò chủ đạo * cảm hứng chủ đạo của bài thơ",
  },
  {
    word: "chủ công",
    part_of_speech: "tính từ",
    meaning:
      "(bộ phận) chủ yếu và có trách nhiệm chính trong việc tiến công đối phương ở hướng quan trọng nhất: nhiệm vụ chủ công",
    example: "nhiệm vụ chủ công",
  },
  {
    word: "chủ công",
    part_of_speech: "tính từ",
    meaning:
      "có tác dụng quan trọng nhất: công nghiệp là lực lượng chủ công của nền kinh tế quốc dân",
    example: "công nghiệp là lực lượng chủ công của nền kinh tế quốc dân",
  },
  {
    word: "chủ đề",
    part_of_speech: "danh từ",
    meaning:
      "tư tưởng trung tâm biểu hiện trong một tác phẩm văn học nghệ thuật, là chủ thể và nòng cốt của nội dung tác phẩm, biểu hiện nhận thức, sự đánh giá và tư tưởng của tác giả đối với đời sống hiện thực: chủ đề của tác phẩm",
    example: "chủ đề của tác phẩm",
  },
  {
    word: "chủ đề",
    part_of_speech: "danh từ",
    meaning:
      "đề tài được chọn làm nội dung chủ yếu: cuộc hội thảo xung quanh chủ đề 'chống tham nhũng'",
    example: "cuộc hội thảo xung quanh chủ đề 'chống tham nhũng'",
  },
  {
    word: "chu đáo",
    part_of_speech: "tính từ",
    meaning:
      "rất cẩn thận, không để có sơ suất: chuẩn bị chu đáo * trông nom nhà cửa rất chu đáo",
    example: "chuẩn bị chu đáo * trông nom nhà cửa rất chu đáo",
  },
  {
    word: "chú dẫn",
    part_of_speech: "động từ",
    meaning:
      "chú thích và dẫn chứng cho rõ thêm: cuối trang sách có lời chú dẫn tỉ mỉ của tác giả",
    example: "cuối trang sách có lời chú dẫn tỉ mỉ của tác giả",
  },
  {
    word: "chu du",
    part_of_speech: "động từ",
    meaning: "(cũ) đi chơi nhiều nơi xa: chu du thiên hạ",
    example: "chu du thiên hạ",
  },
  {
    word: "chủ đích",
    part_of_speech: "danh từ",
    meaning: "mục đích chính: chủ đích của đời người * hành động có chủ đích",
    example: "chủ đích của đời người * hành động có chủ đích",
  },
  {
    word: "chủ định",
    part_of_speech: "danh từ",
    meaning:
      "mục đích, ý định có sẵn: nhân tiện ghé thăm, không có chủ định * có chủ định làm phản",
    example: "nhân tiện ghé thăm, không có chủ định * có chủ định làm phản",
  },
  {
    word: "chủ hoà",
    part_of_speech: "động từ",
    meaning:
      "chủ trương hoà bình, thôi không tiến hành chiến tranh; đối lập với chủ chiến: phái chủ hoà",
    example: "phái chủ hoà",
  },
  {
    word: "chủ động",
    part_of_speech: "",
    meaning:
      "tự mình quyết định hành động, không bị chi phối bởi người khác hoặc hoàn cảnh bên ngoàI: nắm quyền chủ động * chủ động tấn công",
    example: "nắm quyền chủ động * chủ động tấn công",
  },
  {
    word: "chú giải",
    part_of_speech: "động từ",
    meaning: "(cũ) như chú thích: xem thêm chú giải ở cuối sách",
    example: "xem thêm chú giải ở cuối sách",
  },
  {
    word: "chủ khách",
    part_of_speech: "danh từ",
    meaning:
      'chủ nhà và khách, trong mối quan hệ với nhau: "Ngoài thì chủ khách dập dìu, Một nhà huyên với một Kiều ở trong." (TKiều)',
    example:
      'Ngoài thì chủ khách dập dìu, Một nhà huyên với một Kiều ở trong." (TKiều)',
  },
  {
    word: "chủ hôn",
    part_of_speech: "danh từ",
    meaning: "người chủ trì lễ cưới: làm chủ hôn cho đôi trẻ",
    example: "làm chủ hôn cho đôi trẻ",
  },
  {
    word: "chủ kiến",
    part_of_speech: "danh từ",
    meaning: "(hiếm) ý kiến riêng của mình: người có chủ kiến",
    example: "người có chủ kiến",
  },
  {
    word: "chu kỳ",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian nhất định để một quá trình tuần hoàn lặp lại sự diễn biến của nó một cách đều đặn: chu kì quay của Trái Đất là một ngày đêm",
    example: "chu kì quay của Trái Đất là một ngày đêm",
  },
  {
    word: "chu kỳ",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian tương đối không đổi giữa hai lần diễn ra kế tiếp nhau của một hiện tượng thường xuyên lặp đi lặp lại: chu kì sinh đẻ của cá * chu kì kinh nguyệt",
    example: "chu kì sinh đẻ của cá * chu kì kinh nguyệt",
  },
  {
    word: "chu kì",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian nhất định để một quá trình tuần hoàn lặp lại sự diễn biến của nó một cách đều đặn: chu kì quay của Trái Đất là một ngày đêm",
    example: "chu kì quay của Trái Đất là một ngày đêm",
  },
  {
    word: "chu kì",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian tương đối không đổi giữa hai lần diễn ra kế tiếp nhau của một hiện tượng thường xuyên lặp đi lặp lại: chu kì sinh đẻ của cá * chu kì kinh nguyệt",
    example: "chu kì sinh đẻ của cá * chu kì kinh nguyệt",
  },
  {
    word: "chủ nghĩa",
    part_of_speech: "danh từ",
    meaning:
      "học thuyết lí luận hoặc hệ tư tưởng về các vấn đề thế giới khách quan, đời sống xã hội và học thuật: chủ nghĩa duy vật * chủ nghĩa yêu nước",
    example: "chủ nghĩa duy vật * chủ nghĩa yêu nước",
  },
  {
    word: "chủ nghĩa",
    part_of_speech: "danh từ",
    meaning:
      "thành tố ghép trước để cấu tạo một số ít danh từ, có nghĩa chế độ kinh tế - xã hội: chủ nghĩa tư bản * chủ nghĩa xã hội",
    example: "chủ nghĩa tư bản * chủ nghĩa xã hội",
  },
  {
    word: "chủ nghĩa",
    part_of_speech: "danh từ",
    meaning:
      "thành tố ghép sau để cấu tạo tính từ, có nghĩa thuộc về chủ nghĩa, thuộc về chế độ kinh tế - xã hội: hiện thực chủ nghĩa * tư bản chủ nghĩa",
    example: "hiện thực chủ nghĩa * tư bản chủ nghĩa",
  },
  {
    word: "chú mày",
    part_of_speech: "đại từ",
    meaning:
      "(khẩu ngữ) như chú mình (nhưng có phần hơi sỗ sàng): chú mày ra đây anh bảo",
    example: "chú mày ra đây anh bảo",
  },
  {
    word: "chủ lực",
    part_of_speech: "danh từ",
    meaning:
      "lực lượng chính, nòng cốt, có tác dụng quyết định thắng lợi: lực lượng chủ lực * gạo là mặt hàng xuất khẩu chủ lực",
    example: "lực lượng chủ lực * gạo là mặt hàng xuất khẩu chủ lực",
  },
  {
    word: "chủ lực",
    part_of_speech: "danh từ",
    meaning: "bộ đội chủ lực (nói tắt): sư đoàn chủ lực * quân chủ lực",
    example: "sư đoàn chủ lực * quân chủ lực",
  },
  {
    word: "chủ mưu",
    part_of_speech: "động từ",
    meaning: "lập mưu kế: bắt được kẻ chủ mưu trong vụ án giết người",
    example: "bắt được kẻ chủ mưu trong vụ án giết người",
  },
  {
    word: "chủ mưu",
    part_of_speech: "danh từ",
    meaning:
      "mưu kế đã được xếp đặt từ trước: đây là một hành động phá hoại có chủ mưu",
    example: "đây là một hành động phá hoại có chủ mưu",
  },
  {
    word: "chú mục",
    part_of_speech: "động từ",
    meaning: "(hiếm) nhìn chăm chăm: trăm con mắt chú mục vào một mục tiêu",
    example: "trăm con mắt chú mục vào một mục tiêu",
  },
  {
    word: "chú mình",
    part_of_speech: "đại từ",
    meaning:
      "(khẩu ngữ) tổ hợp dùng trong đối thoại để gọi một cách thân mật em trai, hoặc người đàn ông khác chưa lớn tuổi lắm, coi như vai em trai của mình: chú mình định đi đâu thế?",
    example: "chú mình định đi đâu thế?",
  },
  {
    word: "chủ ngữ",
    part_of_speech: "danh từ",
    meaning:
      'một trong hai thành phần chính của câu đơn thông thường, nêu đối tượng mà hành động, tính chất, trạng thái được nói rõ trong vị ngữ: trong câu "thời tiết rất đẹp", "thời tiết" là chủ ngữ',
    example: 'trong câu "thời tiết rất đẹp", "thời tiết" là chủ ngữ',
  },
  {
    word: "chủ ngữ",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như chủ từ: xác định chủ ngữ của phán đoán",
    example: "xác định chủ ngữ của phán đoán",
  },
  {
    word: "chủ nhân",
    part_of_speech: "danh từ",
    meaning: "người chủ nhà: chủ nhân và quan khách",
    example: "chủ nhân và quan khách",
  },
  {
    word: "chủ nhân",
    part_of_speech: "danh từ",
    meaning:
      "người sở hữu tài sản hoặc nắm giữ quyền lực: chủ nhân của ngôi nhà",
    example: "chủ nhân của ngôi nhà",
  },
  {
    word: "chủ nô",
    part_of_speech: "danh từ",
    meaning:
      "(Từ cũ) người chiếm hữu tư liệu sản xuất và nô lệ trong chế độ chiếm hữu nô lệ: giai cấp chủ nô",
    example: "giai cấp chủ nô",
  },
  {
    word: "chủ nợ",
    part_of_speech: "danh từ",
    meaning:
      "người cho vay nợ, hoặc bán chịu hàng, trong quan hệ với con nợ: đồ đạc gán cho chủ nợ",
    example: "đồ đạc gán cho chủ nợ",
  },
  {
    word: "chủ quyền",
    part_of_speech: "danh từ",
    meaning:
      "quyền làm chủ của một nước trong các vấn đề đối nội và đối ngoại: giữ vững chủ quyền quốc gia * khẳng định chủ quyền",
    example: "giữ vững chủ quyền quốc gia * khẳng định chủ quyền",
  },
  {
    word: "chủ quản",
    part_of_speech: "động từ",
    meaning:
      "có trách nhiệm chính trong việc quản lí: cơ quan chủ quản * ngành chủ quản * bộ chủ quản",
    example: "cơ quan chủ quản * ngành chủ quản * bộ chủ quản",
  },
  {
    word: "chủ nhiệm",
    part_of_speech: "danh từ",
    meaning:
      "người đứng đầu và chịu trách nhiệm chính trong một số cơ quan nhà nước, một số tổ chức: chủ nhiệm khoa * chủ nhiệm hợp tác xã * thầy chủ nhiệm",
    example: "chủ nhiệm khoa * chủ nhiệm hợp tác xã * thầy chủ nhiệm",
  },
  {
    word: "chủ quan",
    part_of_speech: "danh từ",
    meaning:
      "ý thức, tinh thần của con người, trong quan hệ đối lập với khách quan: nhận định chủ quan * làm theo chủ quan",
    example: "nhận định chủ quan * làm theo chủ quan",
  },
  {
    word: "chủ quan",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về tự bản thân mình, về cái vốn có của mình, không thuộc về khách quan: năng lực chủ quan * điều kiện chủ quan",
    example: "năng lực chủ quan * điều kiện chủ quan",
  },
  {
    word: "chủ quan",
    part_of_speech: "tính từ",
    meaning:
      "(nhận thức của con người) không xuất phát từ thực tế, mà xuất phát từ ý thức, nguyện vọng, ý chí của mình: chủ quan khinh địch * tính hay chủ quan * phải tính toán kĩ, không được chủ quan",
    example:
      "chủ quan khinh địch * tính hay chủ quan * phải tính toán kĩ, không được chủ quan",
  },
  {
    word: "chủ sự",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) viên quan nhỏ trong các bộ thời xưa: được bổ làm chủ sự bộ Hình",
    example: "được bổ làm chủ sự bộ Hình",
  },
  {
    word: "chú tâm",
    part_of_speech: "động từ",
    meaning:
      "để hết tâm trí (vào việc gì): chú tâm học hành * đừng chú tâm vào những chuyện vặt vãnh",
    example: "chú tâm học hành * đừng chú tâm vào những chuyện vặt vãnh",
  },
  {
    word: "chủ tâm",
    part_of_speech: "danh từ",
    meaning: "ý định có sẵn: việc làm có chủ tâm",
    example: "việc làm có chủ tâm",
  },
  {
    word: "chủ tâm",
    part_of_speech: "động từ",
    meaning:
      "có ý định sẵn để làm việc gì: chủ tâm khiêu khích * không chủ tâm làm hại ai",
    example: "chủ tâm khiêu khích * không chủ tâm làm hại ai",
  },
  {
    word: "chu tất",
    part_of_speech: "tính từ",
    meaning:
      "đầy đủ và xong xuôi đâu vào đấy, không thiếu sót gì: lo tang lễ chu tất * mọi việc đã được chuẩn bị chu tất",
    example: "lo tang lễ chu tất * mọi việc đã được chuẩn bị chu tất",
  },
  {
    word: "chủ tịch",
    part_of_speech: "danh từ",
    meaning:
      "người đứng đầu một nước, một cơ quan làm việc theo chế độ hội đồng hoặc uỷ ban: chủ tịch nước * chủ tịch công đoàn * chủ tịch uỷ ban nhân dân",
    example: "chủ tịch nước * chủ tịch công đoàn * chủ tịch uỷ ban nhân dân",
  },
  {
    word: "chủ thể",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận chính, giữ vai trò chủ đạo: vai trò chủ thể * dân tộc Kinh là dân tộc chủ thể ở Việt Nam",
    example: "vai trò chủ thể * dân tộc Kinh là dân tộc chủ thể ở Việt Nam",
  },
  {
    word: "chủ thể",
    part_of_speech: "danh từ",
    meaning:
      "con người với tư cách là một sinh vật có ý thức và ý chí, trong quan hệ đối lập với thế giới bên ngoài (gọi là khách thể): chủ thể nhận thức * chủ thể sáng tạo * phân biệt giữa chủ thể và khách thể",
    example:
      "chủ thể nhận thức * chủ thể sáng tạo * phân biệt giữa chủ thể và khách thể",
  },
  {
    word: "chủ thể",
    part_of_speech: "danh từ",
    meaning:
      "đối tượng gây ra hành động, trong quan hệ đối lập với đối tượng bị sự chi phối của hành động (gọi là khách thể): chủ thể hành động",
    example: "chủ thể hành động",
  },
  {
    word: "chủ thể",
    part_of_speech: "danh từ",
    meaning:
      "người là đối tượng sở hữu, chịu trách nhiệm chính của một vấn đề có tính pháp lí: chủ thể của bản hợp đồng * chủ thể kinh doanh",
    example: "chủ thể của bản hợp đồng * chủ thể kinh doanh",
  },
  {
    word: "chủ thầu",
    part_of_speech: "danh từ",
    meaning:
      "người đứng ra nhận thầu một công trình hay một loại dịch vụ: chủ thầu xây dựng",
    example: "chủ thầu xây dựng",
  },
  {
    word: "chú thích",
    part_of_speech: "",
    meaning:
      "ghi phụ thêm để giải thích cho rõ: chú thích cho bức tranh * sách có nhiều hình ảnh và chú thích",
    example: "chú thích cho bức tranh * sách có nhiều hình ảnh và chú thích",
  },
  {
    word: "chu toàn",
    part_of_speech: "tính từ",
    meaning: "đầy đủ và trọn vẹn: lo chu toàn mọi việc",
    example: "lo chu toàn mọi việc",
  },
  {
    word: "chủ toạ",
    part_of_speech: "động từ",
    meaning:
      "điều khiển cuộc họp: đứng ra chủ toạ buổi họp hội đồng quản trị công ti",
    example: "đứng ra chủ toạ buổi họp hội đồng quản trị công ti",
  },
  {
    word: "chủ toạ",
    part_of_speech: "danh từ",
    meaning:
      "tập trung quan tâm vào việc gì đó: quá chú mục vào một việc mà không quan tâm đến những việc khác",
    example: "quá chú mục vào một việc mà không quan tâm đến những việc khác",
  },
  {
    word: "chủ trì",
    part_of_speech: "động từ",
    meaning:
      "điều hành và chịu trách nhiệm chính về công việc: chủ trì buổi lễ * người chủ trì",
    example: "chủ trì buổi lễ * người chủ trì",
  },
  {
    word: "chủ tịch đoàn",
    part_of_speech: "danh từ",
    meaning:
      "tập thể những người trong cơ quan thường vụ hay cơ quan dân cử lãnh đạo công tác giữa hai kì đại hội của một số cơ quan, đoàn thể.",
    example: "chủ tịch đoàn đại hội * ngồi ghế chủ tịch đoàn",
  },
  {
    word: "chu trình",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ nói chung diễn biến của một quá trình mà lúc kết thúc lại trở về trạng thái ban đầu: hệ thống máy hoạt động theo một chu trình khép kín",
    example: "hệ thống máy hoạt động theo một chu trình khép kín",
  },
  {
    word: "chủ trương",
    part_of_speech: "danh từ",
    meaning:
      "ý định, quyết định về phương hướng hành động (thường nói về công việc chung): nắm vững chủ trương * thực hiện chủ trương",
    example: "nắm vững chủ trương * thực hiện chủ trương",
  },
  {
    word: "chủ trương",
    part_of_speech: "động từ",
    meaning:
      "có ý định, quyết định về đường lối, phương hướng hành động (thường nói về công việc chung): chủ trương cải tổ * nhà nước chủ trương xoá đói giảm nghèo",
    example: "chủ trương cải tổ * nhà nước chủ trương xoá đói giảm nghèo",
  },
  {
    word: "chủ từ",
    part_of_speech: "danh từ",
    meaning:
      "một trong ba bộ phận của mệnh đề, biểu thị đối tượng của phán đoán (trong logic học): xác định chủ từ của phán đoán",
    example: "xác định chủ từ của phán đoán",
  },
  {
    word: "chú trọng",
    part_of_speech: "động từ",
    meaning:
      "đặc biệt coi trọng: chú trọng đến công tác giảng dạy * cốt ở nội dung, không chú trọng hình thức",
    example:
      "chú trọng đến công tác giảng dạy * cốt ở nội dung, không chú trọng hình thức",
  },
  {
    word: "chủ trị",
    part_of_speech: "động từ",
    meaning:
      "(dược phẩm) có tác dụng chủ yếu chữa trị một bệnh nào đó: thuốc chủ trị bệnh lao",
    example: "thuốc chủ trị bệnh lao",
  },
  {
    word: "chu vi",
    part_of_speech: "danh từ",
    meaning:
      "độ dài của đường khép kín giới hạn một hình phẳng: chu vi đường tròn * chu vi hình chữ nhật",
    example: "chu vi đường tròn * chu vi hình chữ nhật",
  },
  {
    word: "chu vi",
    part_of_speech: "danh từ",
    meaning: "vùng bao quanh, khu vây quanh: khu chu vi thành phố",
    example: "khu chu vi thành phố",
  },
  {
    word: "chủ xướng",
    part_of_speech: "động từ",
    meaning: "(cũ) khởi xướng: chủ xướng một phong trào",
    example: "chủ xướng một phong trào",
  },
  {
    word: "chúa",
    part_of_speech: "danh từ",
    meaning: "(cũ) chủ: chúa đất",
    example: "chúa đất",
  },
  {
    word: "chúa",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người có quyền lực cao nhất trong một miền, hay trong một nước có vua thời phong kiến: vua Lê, chúa Trịnh * vào hầu trong phủ chúa",
    example: "vua Lê, chúa Trịnh * vào hầu trong phủ chúa",
  },
  {
    word: "chúa",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người nắm quyền cai quản một chỗ hay việc nào đó (thường là hung dữ, độc ác): chúa ngục * chúa đảo",
    example: "chúa ngục * chúa đảo",
  },
  {
    word: "chúa",
    part_of_speech: "danh từ",
    meaning:
      "(thường viết hoa) đấng tạo ra trời đất, làm chủ muôn loài, theo Công giáo: cầu Chúa * ngày Chúa giáng sinh",
    example: "cầu Chúa * ngày Chúa giáng sinh",
  },
  {
    word: "chúa",
    part_of_speech: "danh từ",
    meaning:
      "con cái, chuyên việc sinh đẻ trong một số loài côn trùng sống thành đàn: ong chúa và ong thợ",
    example: "ong chúa và ong thợ",
  },
  {
    word: "chúa",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) rất giỏi, rất tài về một việc gì (thường là việc đáng chê, hàm ý mỉa mai): gì chứ tán gái thì nó chúa lắm",
    example: "gì chứ tán gái thì nó chúa lắm",
  },
  {
    word: "chúa",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) ở mức độ cao của một tính cách hoặc trạng thái tinh thần: tôi chúa ghét thói ba hoa nịnh hót * nó là chúa lười * chúa là liều!",
    example:
      "tôi chúa ghét thói ba hoa nịnh hót * nó là chúa lười * chúa là liều!",
  },
  {
    word: "chủ yếu",
    part_of_speech: "tính từ",
    meaning:
      "quan trọng nhất, có tác dụng quyết định; phân biệt với thứ yếu: nội dung chủ yếu của hợp đồng * nhiệm vụ chủ yếu * chủ yếu dựa vào sức mình là chính",
    example:
      "nội dung chủ yếu của hợp đồng * nhiệm vụ chủ yếu * chủ yếu dựa vào sức mình là chính",
  },
  {
    word: "chua cay",
    part_of_speech: "tính từ",
    meaning:
      'cay đắng, xót xa, làm cho khó chịu về tinh thần: nếm mùi thất bại chua cay * "U ơ ra trước hương đài, Tưởng quang cảnh ấy chua cay dường nào!" (ATV)',
    example:
      'nếm mùi thất bại chua cay * "U ơ ra trước hương đài, Tưởng quang cảnh ấy chua cay dường nào!" (ATV)',
  },
  {
    word: "chua",
    part_of_speech: "động từ",
    meaning:
      "(cũ, khẩu ngữ) ghi thêm vào cho rõ: chua nghĩa trong ngoặc * có chua thêm một câu ở phía dưới",
    example: "chua nghĩa trong ngoặc * có chua thêm một câu ở phía dưới",
  },
  {
    word: "chua",
    part_of_speech: "tính từ",
    meaning: "có vị như vị của chanh, giấm: dưa chua * thích ăn của chua",
    example: "dưa chua * thích ăn của chua",
  },
  {
    word: "chua",
    part_of_speech: "tính từ",
    meaning:
      "(đất trồng) có chứa nhiều chất acid: đồng chua nước mặn * bón vôi cho ruộng để khử chua",
    example: "đồng chua nước mặn * bón vôi cho ruộng để khử chua",
  },
  {
    word: "chua",
    part_of_speech: "tính từ",
    meaning:
      "có mùi của chất lên men như mùi của giấm: mùi chua của bỗng rượu * chiếc áo chua mùi mồ hôi",
    example: "mùi chua của bỗng rượu * chiếc áo chua mùi mồ hôi",
  },
  {
    word: "chua",
    part_of_speech: "tính từ",
    meaning: "(giọng nói) cao the thé, nghe khó chịu: giọng chua như mẻ",
    example: "giọng chua như mẻ",
  },
  {
    word: "chua chát",
    part_of_speech: "tính từ",
    meaning:
      "đau xót, chán ngán trong lòng vì phải chịu đựng thất bại, hoặc điều mỉa mai nào đó ngoài ý muốn: mỉm cười chua chát * sự thật chua chát",
    example: "mỉm cười chua chát * sự thật chua chát",
  },
  {
    word: "chủ ý",
    part_of_speech: "danh từ",
    meaning:
      "ý định chính, ý định có sẵn (để làm việc gì): không có chủ ý gì * đoán được chủ ý của đối phương",
    example: "không có chủ ý gì * đoán được chủ ý của đối phương",
  },
  {
    word: "chủ ý",
    part_of_speech: "động từ",
    meaning:
      "có ý định sẵn: không chủ ý giết người * hắn đã chủ ý muốn giấu nên cứ lờ đi",
    example: "không chủ ý giết người * hắn đã chủ ý muốn giấu nên cứ lờ đi",
  },
  {
    word: "chùa",
    part_of_speech: "danh từ",
    meaning:
      "công trình được xây cất lên, làm nơi thờ Phật, thường có nhà sư ở: tiếng chuông chùa",
    example: "tiếng chuông chùa",
  },
  {
    word: "chùa",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) thuộc về nhà chùa, của chung, không do mình làm ra nên không biết tiếc, không có trách nhiệm: tiền chùa * của chùa nên không xót * ăn cơm nhà, làm việc chùa",
    example: "tiền chùa * của chùa nên không xót * ăn cơm nhà, làm việc chùa",
  },
  {
    word: "chùa chiền",
    part_of_speech: "danh từ",
    meaning: "chùa (nói khái quát): tu bổ chùa chiền",
    example: "tu bổ chùa chiền",
  },
  {
    word: "chú ý",
    part_of_speech: "động từ",
    meaning:
      "để hết tâm trí vào: chú ý lắng nghe * đang mải nghĩ nên không chú ý",
    example: "chú ý lắng nghe * đang mải nghĩ nên không chú ý",
  },
  {
    word: "chú ý",
    part_of_speech: "động từ",
    meaning:
      "lưu ý, để tâm đến một cách thường xuyên: chú ý dạy dỗ con cái * được cấp trên chú ý",
    example: "chú ý dạy dỗ con cái * được cấp trên chú ý",
  },
  {
    word: "chua hoá",
    part_of_speech: "động từ",
    meaning:
      "(hiện tượng đất trồng) trở nên chua do có độ acid tăng cao: xử lí ruộng bị chua hoá",
    example: "xử lí ruộng bị chua hoá",
  },
  {
    word: "chua lè",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) như chua loét: mấy quả xoài xanh chua lè",
    example: "mấy quả xoài xanh chua lè",
  },
  {
    word: "chua lòm",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) chua đến mức khó chịu, thường do mùi vị bị biến chất: mùi mồ hôi chua lòm",
    example: "mùi mồ hôi chua lòm",
  },
  {
    word: "chua loét",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) chua đến mức không chịu được, nếu phải ăn, ngửi: quả cam chua loét * mùi mồ hôi chua loét",
    example: "quả cam chua loét * mùi mồ hôi chua loét",
  },
  {
    word: "chua ngọt",
    part_of_speech: "tính từ",
    meaning: "(thức ăn nấu) có vị chua lẫn vị ngọt: sườn xào chua ngọt",
    example: "sườn xào chua ngọt",
  },
  {
    word: "chua ngoét",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như chua loét: mấy quả xoài xanh chua ngoét",
    example: "mấy quả xoài xanh chua ngoét",
  },
  {
    word: "chua ngoa",
    part_of_speech: "tính từ",
    meaning:
      "(nói năng) ngoa ngoắt, lắm lời, nghe khó chịu (thường nói về phụ nữ): ăn nói chua ngoa",
    example: "ăn nói chua ngoa",
  },
  {
    word: "chúa tể",
    part_of_speech: "danh từ",
    meaning:
      "kẻ nắm toàn bộ quyền thống trị, quyền chi phối: làm chúa tể một vùng * chúa tể rừng xanh",
    example: "làm chúa tể một vùng * chúa tể rừng xanh",
  },
  {
    word: "chua xót",
    part_of_speech: "tính từ",
    meaning:
      'xót xa, đau đớn một cách thấm thía: cảnh ngộ chua xót * "Trèo lên cây khế nửa ngày, Ai làm chua xót lòng này khế ơi!" (ca dao)',
    example:
      'cảnh ngộ chua xót * "Trèo lên cây khế nửa ngày, Ai làm chua xót lòng này khế ơi!" (ca dao)',
  },
  {
    word: "chuẩn",
    part_of_speech: "danh từ",
    meaning:
      "cái được chọn làm căn cứ để đối chiếu, để hướng theo đó mà làm cho đúng: cắm cọc làm chuẩn",
    example: "cắm cọc làm chuẩn",
  },
  {
    word: "chuẩn",
    part_of_speech: "danh từ",
    meaning:
      "cái được định ra thành tiêu chuẩn: sản phẩm được sản xuất theo chuẩn quốc tế",
    example: "sản phẩm được sản xuất theo chuẩn quốc tế",
  },
  {
    word: "chuẩn",
    part_of_speech: "danh từ",
    meaning:
      "cái được công nhận là===== đúng theo quy định hoặc theo thói quen phổ biến: chuẩn chính tả * chuẩn phát âm",
    example: "chuẩn chính tả * chuẩn phát âm",
  },
  {
    word: "chuẩn",
    part_of_speech: "tính từ",
    meaning:
      "đúng theo quy định hoặc theo thói quen phổ biến: phát âm rất chuẩn",
    example: "phát âm rất chuẩn",
  },
  {
    word: "chuẩn bị",
    part_of_speech: "động từ",
    meaning:
      "làm cho có sẵn cái cần thiết để làm việc gì: chuẩn bị đối phó với thiên tai * chuẩn bị hành trang lên đường * tất cả đã được chuẩn bị sẵn sàng",
    example:
      "chuẩn bị đối phó với thiên tai * chuẩn bị hành trang lên đường * tất cả đã được chuẩn bị sẵn sàng",
  },
  {
    word: "chuẩn chi",
    part_of_speech: "động từ",
    meaning:
      "(cấp có thẩm quyền) đồng ý cho chi: thủ trưởng đơn vị đã chuẩn chi",
    example: "thủ trưởng đơn vị đã chuẩn chi",
  },
  {
    word: "chuẩn hoá",
    part_of_speech: "động từ",
    meaning:
      "làm cho trở thành có chuẩn rõ ràng: chuẩn hoá chính tả tiếng Việt",
    example: "chuẩn hoá chính tả tiếng Việt",
  },
  {
    word: "chuẩn gốc",
    part_of_speech: "danh từ",
    meaning:
      "chuẩn có độ chính xác cao nhất trong phạm vi quốc gia hoặc quốc tế, dùng để thể hiện đơn vị đo và tạo ra chuẩn thứ: xác định theo chuẩn gốc",
    example: "xác định theo chuẩn gốc",
  },
  {
    word: "chuẩn mực",
    part_of_speech: "",
    meaning: "như chuẩn: chuẩn mực đạo đức * cách phát âm chuẩn mực",
    example: "chuẩn mực đạo đức * cách phát âm chuẩn mực",
  },
  {
    word: "chục",
    part_of_speech: "danh từ",
    meaning:
      "số gộp chung mười đơn vị làm một: một chục trứng * mấy chục người",
    example: "một chục trứng * mấy chục người",
  },
  {
    word: "chục",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) số gộp chung mười đơn vị làm một, nhưng lại được cộng thêm hai, bốn, sáu hoặc tám đơn vị nữa, thường áp dụng trong việc mua bán lẻ một số nông phẩm: một chục xoài mười hai trái",
    example: "một chục xoài mười hai trái",
  },
  {
    word: "chuẩn xác",
    part_of_speech: "tính từ",
    meaning:
      "hoàn toàn đúng với thực tế hoặc với những điều đã tính toán: thông tin chuẩn xác * đồng hồ chạy thiếu chuẩn xác",
    example: "thông tin chuẩn xác * đồng hồ chạy thiếu chuẩn xác",
  },
  {
    word: "chuẩn y",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) (cấp trên) đồng ý cho thực hiện (đúng như cấp dưới đề nghị hoặc dự thảo): kế hoạch đã được cấp trên chuẩn y",
    example: "kế hoạch đã được cấp trên chuẩn y",
  },
  {
    word: "chúc",
    part_of_speech: "động từ",
    meaning:
      "nghiêng hẳn một đầu xuống: nòng súng chúc xuống đất * chiếc máy bay chúc đầu xuống",
    example: "nòng súng chúc xuống đất * chiếc máy bay chúc đầu xuống",
  },
  {
    word: "chúc",
    part_of_speech: "động từ",
    meaning:
      'nói ra lời mong ước điều may mắn, tốt đẹp cho người khác: thư chúc Tết * chúc lên đường may mắn * "Đầy vơi chúc một chén quỳnh, Vì duyên duyên uống, vì tình tình say." (Cdao)',
    example:
      'thư chúc Tết * chúc lên đường may mắn * "Đầy vơi chúc một chén quỳnh, Vì duyên duyên uống, vì tình tình say." (Cdao)',
  },
  {
    word: "chúc thư",
    part_of_speech: "danh từ",
    meaning:
      "bản di chúc, đặc biệt về việc xử lí các tài sản của mình sau khi chết: lập chúc thư",
    example: "lập chúc thư",
  },
  {
    word: "chúc mừng",
    part_of_speech: "động từ",
    meaning: "chúc nhân dịp vui mừng: chúc mừng năm mới * chúc mừng  thắng lợi",
    example: "chúc mừng năm mới * chúc mừng  thắng lợi",
  },
  {
    word: "chúc thọ",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) chúc (người già) sống lâu: con cháu chúc thọ ông bà",
    example: "con cháu chúc thọ ông bà",
  },
  {
    word: "chúc phúc",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) chúc được thần thánh ban cho phúc lành, theo quan niệm tôn giáo: ngày đầu năm mới con cháu đến chúc phúc ông bà",
    example: "ngày đầu năm mới con cháu đến chúc phúc ông bà",
  },
  {
    word: "chuếnh choáng",
    part_of_speech: "tính từ",
    meaning:
      "hơi choáng váng, chóng mặt, như khi ngà ngà say rượu: hơi men chếnh choáng",
    example: "hơi men chếnh choáng",
  },
  {
    word: "chúc tụng",
    part_of_speech: "động từ",
    meaning: "chúc mừng và ca tụng: lời chúc tụng",
    example: "lời chúc tụng",
  },
  {
    word: "chúi",
    part_of_speech: "động từ",
    meaning:
      "ngả phần đầu về phía trước: dáng đi chúi đầu về phía trước * chúi nòng súng xuống",
    example: "dáng đi chúi đầu về phía trước * chúi nòng súng xuống",
  },
  {
    word: "chuệnh choạng",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái mất thăng bằng, lúc nghiêng bên này, lúc ngả sang bên kia: tay lái chệnh choạng * đi chệnh choạng như người say",
    example: "tay lái chệnh choạng * đi chệnh choạng như người say",
  },
  {
    word: "chui",
    part_of_speech: "động từ",
    meaning:
      "đưa đầu hay toàn thân vào hoặc qua chỗ hẹp, chỗ thấp hoặc kín: chui xuống hầm * chuột từ dưới hang chui lên * từ dưới gầm xe chui ra",
    example:
      "chui xuống hầm * chuột từ dưới hang chui lên * từ dưới gầm xe chui ra",
  },
  {
    word: "chui",
    part_of_speech: "động từ",
    meaning:
      "lọt vào (tổ chức, hàng ngũ) để tiến hành những hoạt động lén lút, xấu xa: kẻ xấu đã chui vào tổ chức",
    example: "kẻ xấu đã chui vào tổ chức",
  },
  {
    word: "chui",
    part_of_speech: "động từ",
    meaning:
      "làm vụng trộm, lén lút việc không đúng theo quy định: hàng giả bán chui trên thị trường * chưa đủ tuổi nên phải cưới chui",
    example:
      "hàng giả bán chui trên thị trường * chưa đủ tuổi nên phải cưới chui",
  },
  {
    word: "chùi",
    part_of_speech: "động từ",
    meaning:
      "chà mạnh vào một vật mềm để làm cho sạch vết bẩn: chùi chân vào thảm * ăn vụng không biết chùi mép (tng)",
    example: "chùi chân vào thảm * ăn vụng không biết chùi mép (tng)",
  },
  {
    word: "chùi",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) lau: chùi nước mắt",
    example: "chùi nước mắt",
  },
  {
    word: "chuệch choạc",
    part_of_speech: "tính từ",
    meaning:
      "không đồng đều và không ăn khớp với nhau: các khâu phối hợp còn chệch choạc * hàng ngũ chệch choạc",
    example: "các khâu phối hợp còn chệch choạc * hàng ngũ chệch choạc",
  },
  {
    word: "chúi đầu",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) để hết tâm trí vào làm việc gì, không để ý đến xung quanh: chúi đầu vào đám bạc * cả ngày chỉ chúi đầu vào giặt giũ, nấu nướng",
    example:
      "chúi đầu vào đám bạc * cả ngày chỉ chúi đầu vào giặt giũ, nấu nướng",
  },
  {
    word: "chui lủi",
    part_of_speech: "động từ",
    meaning:
      "lẩn lút nơi kín đáo, không dám xuất hiện công khai, đàng hoàng: sống chui lủi trong rừng",
    example: "sống chui lủi trong rừng",
  },
  {
    word: "chui rúc",
    part_of_speech: "động từ",
    meaning:
      "chui vào nơi quá chật hẹp (nói khái quát): con chó chui rúc khắp các lùm bụi",
    example: "con chó chui rúc khắp các lùm bụi",
  },
  {
    word: "chui rúc",
    part_of_speech: "động từ",
    meaning:
      "ở nơi quá chật chội, bẩn thỉu hoặc lẩn trốn ở nơi kín đáo, không dám xuất hiện công khai: sống chui rúc trong một căn nhà ổ chuột",
    example: "sống chui rúc trong một căn nhà ổ chuột",
  },
  {
    word: "chui luồn",
    part_of_speech: "động từ",
    meaning:
      "chui (nói khái quát): chui luồn qua các bờ bụi * tìm cách chui luồn vào tổ chức địch",
    example: "chui luồn qua các bờ bụi * tìm cách chui luồn vào tổ chức địch",
  },
  {
    word: "chui luồn",
    part_of_speech: "động từ",
    meaning:
      "hạ mình một cách đê hèn trước người có quyền thế để mưu cầu danh lợi: tìm cách chui luồn xin xỏ",
    example: "tìm cách chui luồn xin xỏ",
  },
  {
    word: "chụm",
    part_of_speech: "động từ",
    meaning:
      'làm cho gần lại với nhau để quây quanh một điểm: chụm chân nhảy * chụm đầu vào bàn tán * "Một cây làm chẳng nên non, Ba cây chụm lại nên hòn núi cao." (Cdao)',
    example:
      'chụm chân nhảy * chụm đầu vào bàn tán * "Một cây làm chẳng nên non, Ba cây chụm lại nên hòn núi cao." (Cdao)',
  },
  {
    word: "chụm",
    part_of_speech: "động từ",
    meaning:
      "(Phương ngữ) cho củi vào bếp để đun: chụm thêm củi vô bếp * chụm cho sôi ấm nước",
    example: "chụm thêm củi vô bếp * chụm cho sôi ấm nước",
  },
  {
    word: "chum",
    part_of_speech: "danh từ",
    meaning:
      "đồ đựng bằng gốm, loại lớn, miệng tròn, giữa phình ra, thót dần về phía đáy: chum tương",
    example: "chum tương",
  },
  {
    word: "chũm",
    part_of_speech: "danh từ",
    meaning: "núm hình chóp: chũm cau",
    example: "chũm cau",
  },
  {
    word: "chúi nhủi",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) ngã chúi xuống, không gượng được: bị vấp phải hòn đá, ngã chúi nhủi",
    example: "bị vấp phải hòn đá, ngã chúi nhủi",
  },
  {
    word: "chùm",
    part_of_speech: "danh từ",
    meaning:
      "cụm hoa hoặc quả mọc trên các nhánh của một trục chính: chùm hoa bưởi * chùm nhãn",
    example: "chùm hoa bưởi * chùm nhãn",
  },
  {
    word: "chùm",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp gồm nhiều vật cùng loại chụm lại quanh một điểm: chùm chìa khoá * chùm bánh tét * chùm tin (cụm gồm nhiều tin)",
    example: "chùm chìa khoá * chùm bánh tét * chùm tin (cụm gồm nhiều tin)",
  },
  {
    word: "chùm",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp nhiều tia hoặc hạt xuất phát từ một nguồn: chùm tia X * chùm laser",
    example: "chùm tia X * chùm laser",
  },
  {
    word: "chúm chím",
    part_of_speech: "động từ",
    meaning:
      "từ gợi tả dáng môi hơi mấp máy và chúm lại, không hé mở ra: miệng cười chúm chím",
    example: "miệng cười chúm chím",
  },
  {
    word: "chúm",
    part_of_speech: "động từ",
    meaning:
      "thu lại gần nhau thành hình núm tròn: chúm miệng huýt sáo * chúm mấy đầu ngón tay lại rồi xoè ra",
    example: "chúm miệng huýt sáo * chúm mấy đầu ngón tay lại rồi xoè ra",
  },
  {
    word: "chum chúm",
    part_of_speech: "động từ",
    meaning: "như chúm (nhưng mức độ ít hơn): môi chum chúm",
    example: "môi chum chúm",
  },
  {
    word: "chun",
    part_of_speech: "danh từ",
    meaning:
      "(Nam thun) (khẩu ngữ) dây chun (nói tắt): đứt chun quần * sợi chun buộc hàng",
    example: "đứt chun quần * sợi chun buộc hàng",
  },
  {
    word: "chun",
    part_of_speech: "động từ",
    meaning:
      '(vật có khả năng co dãn) tự co lại, thu ngắn lại: sợi đã chun lại * đỉa chun mình * "Mặt hắn chun ngay lại, miếng cám đắng chát và nghẹn bứ trong cổ." (KLân) đồng thun',
    example:
      'sợi đã chun lại * đỉa chun mình * "Mặt hắn chun ngay lại, miếng cám đắng chát và nghẹn bứ trong cổ.',
  },
  {
    word: "chun",
    part_of_speech: "động từ",
    meaning:
      "(Nam, khẩu ngữ) chui: chun vào hang trốn * Mày ở đâu chun ra vậy?",
    example: "chun vào hang trốn * Mày ở đâu chun ra vậy?",
  },
  {
    word: "chùm nhum",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) xúm xít lại thành nhóm: chủ khách ngồi chùm nhum trên sập * bọn trẻ đứng chùm nhum ở góc sân",
    example:
      "chủ khách ngồi chùm nhum trên sập * bọn trẻ đứng chùm nhum ở góc sân",
  },
  {
    word: "chun chủn",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) như chủn (nhưng ý mức độ nhiều hơn): cái bím tóc ngắn chun chủn",
    example: "cái bím tóc ngắn chun chủn",
  },
  {
    word: "chum hum",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) từ gợi tả dáng cúi gập mình xuống, lưng khum lại hoặc dáng nằm úp sấp mình trên hai tay, hai chân co lại, lưng uốn cong lên: nằm chum hum trên giường * đứng chum hum cấy lúa",
    example: "nằm chum hum trên giường * đứng chum hum cấy lúa",
  },
  {
    word: "chùn",
    part_of_speech: "động từ",
    meaning:
      "rụt lại vì sợ, vì ngại, không dám tiếp tục hành động nữa: chùn lại không dám bước nữa * không chùn bước trước khó khăn",
    example: "chùn lại không dám bước nữa * không chùn bước trước khó khăn",
  },
  {
    word: "chùn chùn",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) như chun chủn: chân ngắn chùn chùn * gian nhà thấp chùn chùn",
    example: "chân ngắn chùn chùn * gian nhà thấp chùn chùn",
  },
  {
    word: "chủn",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) (ngắn) đến mức quá đáng, trông khó coi: chiếc váy ngắn chủn",
    example: "chiếc váy ngắn chủn",
  },
  {
    word: "chủn",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về mọi người, mọi vật, có liên quan đến tất cả; phân biệt với riêng: của chung * việc chung * lợi ích chung * cha chung không ai khóc (tng)",
    example:
      "của chung * việc chung * lợi ích chung * cha chung không ai khóc (tng)",
  },
  {
    word: "chủn",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất bao quát, gồm những cái chính, cái cơ bản: quan điểm chung * đặc tính chung * đường lối chung",
    example: "quan điểm chung * đặc tính chung * đường lối chung",
  },
  {
    word: "chủn",
    part_of_speech: "tính từ",
    meaning:
      "cùng với nhau, chứ không phải người nào người ấy tách riêng ra: ở chung một nhà * niềm vui chung * sống chung với nhau như vợ chồng",
    example:
      "ở chung một nhà * niềm vui chung * sống chung với nhau như vợ chồng",
  },
  {
    word: "chủn",
    part_of_speech: "động từ",
    meaning: "cùng có với nhau: hai nhà chung sân * chung chăn chung gối",
    example: "hai nhà chung sân * chung chăn chung gối",
  },
  {
    word: "chủn",
    part_of_speech: "động từ",
    meaning: "góp lại với nhau: chung vốn làm ăn * chung sức cùng làm",
    example: "chung vốn làm ăn * chung sức cùng làm",
  },
  {
    word: "chùng",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái không được kéo ra cho căng, thẳng: dây đàn bị chùng * giọng bỗng chùng xuống (hạ thấp xuống, không còn hăng hái nữa)",
    example:
      "dây đàn bị chùng * giọng bỗng chùng xuống (hạ thấp xuống, không còn hăng hái nữa)",
  },
  {
    word: "chùng",
    part_of_speech: "tính từ",
    meaning: "(Ít dùng) như thụng: ống quần hơi chùng * áo chùng",
    example: "ống quần hơi chùng * áo chùng",
  },
  {
    word: "chùng",
    part_of_speech: "tính từ",
    meaning: "(Phương ngữ) vụng, lén: ăn chùng * thương chùng, nhớ vụng",
    example: "ăn chùng * thương chùng, nhớ vụng",
  },
  {
    word: "chùn chũn",
    part_of_speech: "phụ từ",
    meaning: "(khẩu ngữ) như chun chủn: cái đuôi ngắn chùn chũn",
    example: "cái đuôi ngắn chùn chũn",
  },
  {
    word: "chùn chụt",
    part_of_speech: "tính từ",
    meaning:
      "như chụt (nhưng ý liên tiếp và mức độ nhiều): mút chùn chụt * hôn chùn chụt",
    example: "mút chùn chụt * hôn chùn chụt",
  },
  {
    word: "chúng",
    part_of_speech: "đại từ",
    meaning:
      "Từ dùng để chỉ những người, những con vật đã được nói đến, thường với ý coi khinh: mấy con chó này chúng khôn lắm * toán lính và tên chỉ huy của chúng",
    example:
      "mấy con chó này chúng khôn lắm * toán lính và tên chỉ huy của chúng",
  },
  {
    word: "chúng",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị số lượng nhiều được xác định (gồm tất cả những người, động vật muốn nói đến): chúng cháu chào ông ạ! * hai đứa ấy hư lắm, phải cho chúng một trận",
    example:
      "chúng cháu chào ông ạ! * hai đứa ấy hư lắm, phải cho chúng một trận",
  },
  {
    word: "ấm ứ",
    part_of_speech: "động từ",
    meaning:
      "nói năng lúng túng, không trôi chảy, không thành ý, thành lời rành rọt: ấm ứ một hồi mới nói được",
    example: "ấm ứ một hồi mới nói được",
  },
  {
    word: "ậm ừ",
    part_of_speech: "động từ",
    meaning: "như ầm ừ: ậm ừ cho qua chuyện",
    example: "ậm ừ cho qua chuyện",
  },
  {
    word: "ầm ừ",
    part_of_speech: "động từ",
    meaning:
      'từ gợi tả lối trả lời không rõ ràng, dứt khoát, không hẳn đồng ý, cũng không hẳn từ chối: ầm ừ cho qua chuyện * "Chị ầm ừ, không ra gật cũng không ra lắc." (BBThi; 5)',
    example:
      'ầm ừ cho qua chuyện * "Chị ầm ừ, không ra gật cũng không ra lắc." (BBThi; 5)',
  },
  {
    word: "ấm ức",
    part_of_speech: "động từ",
    meaning:
      "bực tức mà phải cố nén lại, không thể nói ra hoặc nói hết ra được: ấm ức trong lòng * bị mắng oan nên ấm ức",
    example: "ấm ức trong lòng * bị mắng oan nên ấm ức",
  },
  {
    word: "ẩm ương",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) dở, chẳng ra làm sao, chẳng có tác dụng gì: tính khí ẩm ương * chuyện ẩm ương",
    example: "tính khí ẩm ương * chuyện ẩm ương",
  },
  {
    word: "ậm ực",
    part_of_speech: "tính từ",
    meaning: "ấm ức lắm: ậm ực muốn khóc",
    example: "ậm ực muốn khóc",
  },
  {
    word: "âm vang",
    part_of_speech: "động từ",
    meaning:
      "(âm thanh) vang và ngân xa: tiếng cồng chiêng âm vang cả núi rừng",
    example: "tiếng cồng chiêng âm vang cả núi rừng",
  },
  {
    word: "âm vang",
    part_of_speech: "danh từ",
    meaning:
      '(hiếm) âm thanh còn vọng lại: "Không một bóng chim bay ngang, không một âm vang nào ngoài tiếng gió buồn tê tái (...)" (NgHồng; 1)',
    example:
      'Không một bóng chim bay ngang, không một âm vang nào ngoài tiếng gió buồn tê tái (...)" (NgHồng; 1)',
  },
  {
    word: "ẩm ướt",
    part_of_speech: "tính từ",
    meaning:
      "ẩm, do thấm nhiều nước hoặc có chứa nhiều hơi nước (nói khái quát): nền nhà ẩm ướt * cỏ cây ẩm ướt vì sương đêm",
    example: "nền nhà ẩm ướt * cỏ cây ẩm ướt vì sương đêm",
  },
  {
    word: "ẩm xìu",
    part_of_speech: "tính từ",
    meaning: "ẩm và mềm ỉu: miếng bánh đa ẩm xìu",
    example: "miếng bánh đa ẩm xìu",
  },
  {
    word: "ân ái",
    part_of_speech: "",
    meaning:
      'như ái ân: "Còn nhiều ân ái chan chan, Hay gì vầy cánh hoa tàn mà chơi?" (TKiều)',
    example:
      'Còn nhiều ân ái chan chan, Hay gì vầy cánh hoa tàn mà chơi?" (TKiều)',
  },
  {
    word: "ẩn",
    part_of_speech: "động từ",
    meaning: "như ẩy: ẩn cánh cửa bước vào",
    example: "ẩn cánh cửa bước vào",
  },
  {
    word: "ẩn",
    part_of_speech: "động từ",
    meaning:
      'giấu mình vào nơi kín đáo cho không lộ ra, cho khó thấy: bọn cướp ẩn trong rừng * mặt trời ẩn sau ngọn núi * "(...) chị nói chuyện mà cặp mắt chị như ẩn một nụ cười." (DThXQuý; 1)',
    example:
      'bọn cướp ẩn trong rừng * mặt trời ẩn sau ngọn núi * "(...) chị nói chuyện mà cặp mắt chị như ẩn một nụ cười." (DThXQuý; 1)',
  },
  {
    word: "ẩn",
    part_of_speech: "danh từ",
    meaning: "ẩn số (nói tắt): phương trình này có 2 ẩn",
    example: "phương trình này có 2 ẩn",
  },
  {
    word: "ân",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) ơn: "Tóc tơ các tích mọi khi, Oán thì trả oán, ân thì trả ân." (TKiều)',
    example:
      'Tóc tơ các tích mọi khi, Oán thì trả oán, ân thì trả ân." (TKiều)',
  },
  {
    word: "ấn",
    part_of_speech: "danh từ",
    meaning: "con dấu của vua hoặc quan: treo ấn từ quan",
    example: "treo ấn từ quan",
  },
  {
    word: "ấn",
    part_of_speech: "động từ",
    meaning:
      'dùng tay đè xuống, gí xuống: ấn chuông  * "(...) ở đất này đã ngu, đã nhịn thì chúng nó ấn cho đến không còn ngóc đầu lên được." (NCao; 3)',
    example:
      'ấn chuông  * "(...) ở đất này đã ngu, đã nhịn thì chúng nó ấn cho đến không còn ngóc đầu lên được." (NCao; 3)',
  },
  {
    word: "ấn",
    part_of_speech: "động từ",
    meaning: "dồn nhét vào: ấn hàng vào bao",
    example: "ấn hàng vào bao",
  },
  {
    word: "ấn",
    part_of_speech: "động từ",
    meaning: "ép phải nhận, phải làm: ấn việc cho người khác",
    example: "ấn việc cho người khác",
  },
  {
    word: "ấn bản",
    part_of_speech: "danh từ",
    meaning: "bản sách in: các ấn bản khác nhau của Truyện Kiều",
    example: "các ấn bản khác nhau của Truyện Kiều",
  },
  {
    word: "ân cần",
    part_of_speech: "tính từ",
    meaning:
      '(đối xử) đầy nhiệt tình và chu đáo: tiếp đãi ân cần * "Thuý Vân chợt tỉnh giấc xuân, Dưới đèn ghé đến, ân cần hỏi han." (TKiều)',
    example:
      'tiếp đãi ân cần * "Thuý Vân chợt tỉnh giấc xuân, Dưới đèn ghé đến, ân cần hỏi han." (TKiều)',
  },
  {
    word: "ẩn chứa",
    part_of_speech: "động từ",
    meaning:
      "có chứa ở bên trong, không để lộ rõ ra: lời ru ẩn chứa một tâm sự * ẩn chứa một nghị lực phi thường",
    example: "lời ru ẩn chứa một tâm sự * ẩn chứa một nghị lực phi thường",
  },
  {
    word: "ẩn dật",
    part_of_speech: "động từ",
    meaning:
      "(cũ) (nhà nho có tài đức thời phong kiến) lánh đời ở ẩn: một nho sĩ ẩn dật * sống ẩn dật",
    example: "một nho sĩ ẩn dật * sống ẩn dật",
  },
  {
    word: "ấn định",
    part_of_speech: "động từ",
    meaning:
      "định ra một cách chính thức điều cụ thể (thường là mức độ hoặc ngày giờ) về một việc chung và quan trọng: ấn định mức thuế * ấn định ngày bầu cử",
    example: "ấn định mức thuế * ấn định ngày bầu cử",
  },
  {
    word: "ân giảm",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) (nhà nước đối với phạm nhân) giảm nhẹ hình phạt, coi là một đặc ân: làm đơn xin ân giảm",
    example: "làm đơn xin ân giảm",
  },
  {
    word: "ẩn giấu",
    part_of_speech: "động từ",
    meaning:
      "chứa đựng một cách kín đáo, không để lộ ra: nhiều tài nguyên còn ẩn giấu trong lòng đất * trong lòng ẩn giấu bao nỗi niềm",
    example:
      "nhiều tài nguyên còn ẩn giấu trong lòng đất * trong lòng ẩn giấu bao nỗi niềm",
  },
  {
    word: "ân hận",
    part_of_speech: "động từ",
    meaning:
      "băn khoăn, day dứt và tự trách mình đã để xảy ra việc không hay: ân hận vì đã làm phật lòng cha mẹ * không có gì phải ân hận",
    example: "ân hận vì đã làm phật lòng cha mẹ * không có gì phải ân hận",
  },
  {
    word: "ấn loát",
    part_of_speech: "động từ",
    meaning: "in, in ấn (nói khái quát): cơ quan ấn loát * kĩ thuật ấn loát",
    example: "cơ quan ấn loát * kĩ thuật ấn loát",
  },
  {
    word: "ẩn hiện",
    part_of_speech: "động từ",
    meaning:
      "lúc ẩn, lúc hiện, lúc nhìn thấy rõ, lúc không: con thuyền ẩn hiện trong sương * tập bắn bia ẩn hiện",
    example: "con thuyền ẩn hiện trong sương * tập bắn bia ẩn hiện",
  },
  {
    word: "ân huệ",
    part_of_speech: "danh từ",
    meaning:
      "(trang trọng) ơn (thường là của người trên ban cho người dưới): ban ân huệ * việc nhỏ có gì đâu mà ân với huệ?",
    example: "ban ân huệ * việc nhỏ có gì đâu mà ân với huệ?",
  },
  {
    word: "ân nghĩa",
    part_of_speech: "danh từ",
    meaning:
      "tình nghĩa thắm thiết, gắn bó do có chịu ơn sâu với nhau: ân nghĩa sinh thành * báo đáp ân nghĩa",
    example: "ân nghĩa sinh thành * báo đáp ân nghĩa",
  },
  {
    word: "ẩn nấp",
    part_of_speech: "động từ",
    meaning:
      "giấu mình ở nơi kín đáo hoặc nơi có vật che chở: xuống hầm ẩn nấp",
    example: "xuống hầm ẩn nấp",
  },
  {
    word: "ân oán",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) ân huệ và thù oán (thường nói nặng về thù oán): ân oán rạch ròi",
    example: "ân oán rạch ròi",
  },
  {
    word: "ẩn náu",
    part_of_speech: "động từ",
    meaning:
      "lánh ở nơi kín đáo để chờ dịp hoạt động: toán cướp ẩn náu trong rừng",
    example: "toán cướp ẩn náu trong rừng",
  },
  {
    word: "ẩn số",
    part_of_speech: "danh từ",
    meaning: "số chưa biết: ẩn số của một phương trình",
    example: "ẩn số của một phương trình",
  },
  {
    word: "ẩn số",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) cái chưa biết, đang cần tìm hiểu: lai lịch của cô ta còn là một ẩn số",
    example: "lai lịch của cô ta còn là một ẩn số",
  },
  {
    word: "ấn tín",
    part_of_speech: "danh từ",
    meaning: "con dấu của vua quan thời trước: trả ấn tín, từ quan về ở ẩn",
    example: "trả ấn tín, từ quan về ở ẩn",
  },
  {
    word: "ấn phẩm",
    part_of_speech: "danh từ",
    meaning:
      "sản phẩm của ngành in như sách báo, tranh ảnh, v.v.: các ấn phẩm văn hoá",
    example: "các ấn phẩm văn hoá",
  },
  {
    word: "ân tình",
    part_of_speech: "danh từ",
    meaning:
      'tình nghĩa thắm thiết do có chịu ân sâu với nhau: "Nàng rằng: Nhờ cậy uy linh, Hãy xin báo đáp ân tình cho phu." (TKiều)',
    example:
      'Nàng rằng: Nhờ cậy uy linh, Hãy xin báo đáp ân tình cho phu." (TKiều)',
  },
  {
    word: "ẩn ức",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương) hình ảnh, sự việc đã qua được lưu giữ sâu kín trong trí nhớ: gợi nhớ biết bao ẩn ức về tuổi thơ",
    example: "gợi nhớ biết bao ẩn ức về tuổi thơ",
  },
  {
    word: "ẩn ức",
    part_of_speech: "danh từ",
    meaning:
      "nỗi ấm ức bị kìm nén lâu ngày, để lại dấu ấn sâu đậm trong tâm trí, có tác động nhất định đến tâm lí và phép ứng xử cá nhân: cuộc đời làm quan đầy ẩn ức",
    example: "cuộc đời làm quan đầy ẩn ức",
  },
  {
    word: "ấn tượng",
    part_of_speech: "danh từ",
    meaning:
      "nhận thức cảm tính xen lẫn với cảm xúc còn lưu giữ lại trong đầu óc (về sự vật, hiện tượng khách quan): gây ấn tượng * tác phẩm để lại ấn tượng tốt trong lòng độc giả",
    example: "gây ấn tượng * tác phẩm để lại ấn tượng tốt trong lòng độc giả",
  },
  {
    word: "ấn tượng",
    part_of_speech: "tính từ",
    meaning:
      "có tác dụng gây cảm xúc mạnh mẽ và tạo thành dấu ấn trong nhận thức: gương mặt rất ấn tượng * một pha biểu diễn ấn tượng",
    example: "gương mặt rất ấn tượng * một pha biểu diễn ấn tượng",
  },
  {
    word: "ân xá",
    part_of_speech: "động từ",
    meaning:
      "(quyết định theo luật pháp của cơ quan quyền lực nhà nước tối cao hoặc nguyên thủ quốc gia) miễn hoặc giảm hình phạt cho phạm nhân đã có biểu hiện hối cải nhân dịp có lễ lớn: nộp đơn xin ân xá * ân xá cho tù chính trị",
    example: "nộp đơn xin ân xá * ân xá cho tù chính trị",
  },
  {
    word: "ấp",
    part_of_speech: "danh từ",
    meaning: "làng, xóm nhỏ được lập nên ở nơi mới khai khẩn: chiêu dân lập ấp",
    example: "chiêu dân lập ấp",
  },
  {
    word: "ấp",
    part_of_speech: "động từ",
    meaning:
      "(loài chim) nằm phủ lên trứng cho ấm trứng để nở ra con: ngan ấp trứng * gà mái ấp",
    example: "ngan ấp trứng * gà mái ấp",
  },
  {
    word: "ấp",
    part_of_speech: "động từ",
    meaning: "làm cho trứng có đủ độ ấm để nở: ấp trứng vịt bằng máy",
    example: "ấp trứng vịt bằng máy",
  },
  {
    word: "ấp",
    part_of_speech: "động từ",
    meaning:
      "ôm lấy hoặc áp sát vào trên cả bề mặt: bé ấp đầu vào lòng mẹ * ấp lá thư lên ngực",
    example: "bé ấp đầu vào lòng mẹ * ấp lá thư lên ngực",
  },
  {
    word: "ẩn ý",
    part_of_speech: "danh từ",
    meaning:
      "ý kín đáo bên trong, vốn là cái chính muốn nói, nhưng không nói rõ, chỉ để ngầm hiểu: lời nói có ẩn ý * nói rõ ràng, không có ẩn ý gì",
    example: "lời nói có ẩn ý * nói rõ ràng, không có ẩn ý gì",
  },
  {
    word: "ập",
    part_of_speech: "động từ",
    meaning:
      "đến một cách nhanh, mạnh, đột ngột, với số lượng nhiều: mưa ập xuống * cảnh sát ập vào khám nhà * cơn buồn ngủ ập đến",
    example: "mưa ập xuống * cảnh sát ập vào khám nhà * cơn buồn ngủ ập đến",
  },
  {
    word: "ập",
    part_of_speech: "động từ",
    meaning:
      "chuyển vị trí nhanh, mạnh và đột ngột: đóng ập cửa lại * căn nhà đổ ập xuống * các cánh quân đánh ập vào đồn địch",
    example:
      "đóng ập cửa lại * căn nhà đổ ập xuống * các cánh quân đánh ập vào đồn địch",
  },
  {
    word: "ầng ậng",
    part_of_speech: "tính từ",
    meaning:
      "(nước mắt) nhiều và dâng đầy khoé mắt như chực tuôn chảy ra: mắt ầng ậng nước",
    example: "mắt ầng ậng nước",
  },
  {
    word: "ấp iu",
    part_of_speech: "động từ",
    meaning: "ôm ấp và nâng niu: mẹ ấp iu con",
    example: "mẹ ấp iu con",
  },
  {
    word: "ấp ủ",
    part_of_speech: "động từ",
    meaning: "ôm trong lòng và giữ cho được ấm.",
    example: "ấp ủ những hi vọng lớn lao * đề tài ấp ủ từ lâu",
  },
  {
    word: "ấp úng",
    part_of_speech: "động từ",
    meaning:
      "từ gợi tả cách nói không nên lời hoặc nói không gãy gọn, không rành mạch vì lúng túng: trả lời ấp úng * ấp úng như ngậm hột thị",
    example: "trả lời ấp úng * ấp úng như ngậm hột thị",
  },
  {
    word: "ất giáp",
    part_of_speech: "trợ từ",
    meaning: "(khẩu ngữ) như mô tê: chưa biết ất giáp gì đã sồn sồn lên",
    example: "chưa biết ất giáp gì đã sồn sồn lên",
  },
  {
    word: "ẩu",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) cẩu thả, bừa bãi, không kể gì phép tắc, nền nếp, cách thức: làm ẩu * lái xe chạy ẩu",
    example: "làm ẩu * lái xe chạy ẩu",
  },
  {
    word: "âu",
    part_of_speech: "danh từ",
    meaning:
      "đồ đựng trông giống cái ang, nhưng nhỏ hơn: âu sành * âu đựng trầu",
    example: "âu sành * âu đựng trầu",
  },
  {
    word: "âu",
    part_of_speech: "phụ từ",
    meaning:
      '(Văn chương) có lẽ, hẳn là như thế chăng: thôi, âu cũng là tại số! * "Nghìn xưa âu cũng thế này, Từ bi âu liệu bớt tay mới vừa." (TKiều)',
    example:
      'thôi, âu cũng là tại số! * "Nghìn xưa âu cũng thế này, Từ bi âu liệu bớt tay mới vừa." (TKiều)',
  },
  {
    word: "âu ca",
    part_of_speech: "động từ",
    meaning:
      '(cũ, văn chương) cùng nhau hát để ca ngợi: "Trời thu vừa gặp tiết lành, Muôn dân yên khoẻ thái bình âu ca." (ca dao)',
    example:
      'Trời thu vừa gặp tiết lành, Muôn dân yên khoẻ thái bình âu ca." (ca dao)',
  },
  {
    word: "ấu chúa",
    part_of_speech: "danh từ",
    meaning: "(cũ) chúa còn nhỏ tuổi: theo phò ấu chúa",
    example: "theo phò ấu chúa",
  },
  {
    word: "ẩu đả",
    part_of_speech: "động từ",
    meaning: "đánh nhau hỗn loạn: xông vào ẩu đả nhau * vụ ẩu đả",
    example: "xông vào ẩu đả nhau * vụ ẩu đả",
  },
  {
    word: "ầu ơ",
    part_of_speech: "cảm từ",
    meaning:
      '(phương ngữ) tiếng mở đầu câu hát ru: "Ầu ơ... Ví dầu cầu ván đóng đinh, Cầu tre lắt lẻo gập ghềnh khó đi." (ca dao)',
    example:
      'Ầu ơ... Ví dầu cầu ván đóng đinh, Cầu tre lắt lẻo gập ghềnh khó đi." (ca dao)',
  },
  {
    word: "âu lo",
    part_of_speech: "động từ",
    meaning:
      "lo đến mức thường xuyên và sâu sắc: ánh mắt đầy lo âu * lòng thấp thỏm lo âu",
    example: "ánh mắt đầy lo âu * lòng thấp thỏm lo âu",
  },
  {
    word: "âu là",
    part_of_speech: "phụ từ",
    meaning:
      "(văn chương) hay là, chi bằng: đã đến nước này, âu là ta phải liều vậy",
    example: "đã đến nước này, âu là ta phải liều vậy",
  },
  {
    word: "âu phục",
    part_of_speech: "danh từ",
    meaning:
      "quần áo may theo kiểu châu Âu, kiểu phương Tây (thường nói về y phục nam): mặc âu phục",
    example: "mặc âu phục",
  },
  {
    word: "ấu thơ",
    part_of_speech: "tính từ",
    meaning:
      'như thơ ấu: "Thương con đương độ ấu thơ, Con côi, mẹ goá bây giờ cậy ai!" (TS)',
    example:
      'Thương con đương độ ấu thơ, Con côi, mẹ goá bây giờ cậy ai!" (TS)',
  },
  {
    word: "ấu trĩ",
    part_of_speech: "tính từ",
    meaning:
      "non nớt, có những suy nghĩ giản đơn, thiếu kinh nghiệm: ấu trĩ về chính trị * suy nghĩ hết sức ấu trĩ",
    example: "ấu trĩ về chính trị * suy nghĩ hết sức ấu trĩ",
  },
  {
    word: "ẩu tả",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) quá ẩu: làm ăn ẩu tả * quen thói ẩu tả",
    example: "làm ăn ẩu tả * quen thói ẩu tả",
  },
  {
    word: "âu yếm",
    part_of_speech: "",
    meaning:
      'biểu lộ tình thương yêu, trìu mến bằng dáng điệu, cử chỉ, giọng nói: cử chỉ âu yếm * "Sóng tình dường đã xiêu xiêu, Xem trong âu yếm có chiều lả lơi." (TKiều)',
    example:
      'cử chỉ âu yếm * "Sóng tình dường đã xiêu xiêu, Xem trong âu yếm có chiều lả lơi." (TKiều)',
  },
  {
    word: "ấy",
    part_of_speech: "đại từ",
    meaning:
      "từ dùng để chỉ cái đã được nhắc tới, biết tới, nhưng không ở kề bên người nói hoặc không thuộc về hiện tại: đưa cho tôi quyển sách ấy * cô ấy chưa đến * ngày ấy đã xa rồi * rau nào sâu ấy (tng)",
    example:
      "đưa cho tôi quyển sách ấy * cô ấy chưa đến * ngày ấy đã xa rồi * rau nào sâu ấy (tng)",
  },
  {
    word: "ấy",
    part_of_speech: "đại từ",
    meaning:
      "(khẩu ngữ) từ dùng để gọi một cách thân mật người thuộc hàng bạn bè còn ít tuổi, thường không biết tên hoặc tránh gọi tên: ấy tên là gì? * ấy ơi! giúp tớ một tay!",
    example: "ấy tên là gì? * ấy ơi! giúp tớ một tay!",
  },
  {
    word: "ấy",
    part_of_speech: "trợ từ",
    meaning:
      "(khẩu ngữ) từ biểu thị ý nhấn mạnh như muốn láy lại điều vừa nói đến: nó đang bận làm gì ấy * tôi ấy ư, lúc nào đi cũng được * làm như thế, mình cứ thấy thế nào ấy!",
    example:
      "nó đang bận làm gì ấy * tôi ấy ư, lúc nào đi cũng được * làm như thế, mình cứ thấy thế nào ấy!",
  },
  {
    word: "ấy",
    part_of_speech: "cảm từ",
    meaning:
      "tiếng thốt ra từ đầu câu để gợi sự chú ý và để tỏ ý ngăn cản hay là không bằng lòng, hoặc ý khẳng định: ấy, đừng làm thế! * ấy, thì tôi cũng nghĩ thế",
    example: "ấy, đừng làm thế! * ấy, thì tôi cũng nghĩ thế",
  },
  {
    word: "âu sầu",
    part_of_speech: "tính từ",
    meaning:
      'buồn sâu sắc xen lẫn lo âu: "Lòng nàng xiết nỗi xót xa, Má đào ủ dột mặt hoa âu sầu." (QÂTK)',
    example: 'Lòng nàng xiết nỗi xót xa, Má đào ủ dột mặt hoa âu sầu." (QÂTK)',
  },
  {
    word: "ấu trùng",
    part_of_speech: "danh từ",
    meaning:
      "dạng mới nở từ trứng ra của các loại động vật chân đốt (như côn trùng, tôm, cua...), qua nhiều lần lột xác mới hoá thành con trưởng thành: bọ gậy là ấu trùng của muỗi",
    example: "bọ gậy là ấu trùng của muỗi",
  },
  {
    word: "bá",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) tước thứ ba, sau tước hầu, trước tước tử, trong bậc thang chức tước hàng quan lại thời phong kiến.",
    example: "làm bá một phương * xưng hùng xưng bá",
  },
  {
    word: "bá",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) thủ lĩnh của một liên minh các chư hầu thời phong kiến (Trung Quốc thời cổ đại) dựa vào quyền lực chi phối, cầm đầu một số chư hầu khác: làm bá một phương * xưng hùng xưng bá",
    example: "cường hào ác bá",
  },
  {
    word: "bá",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) kẻ dựa vào quyền thế thống trị, có những hành động ngang ngược: cường hào ác bá",
    example: "Cò về thăm bá thăm dì, Thăm cô xứ bắc, thăm dì xứ Đông.",
  },
  {
    word: "bá",
    part_of_speech: "danh từ",
    meaning:
      '(phương ngữ) chị của mẹ (có thể dùng để xưng gọi): "Cò về thăm bá thăm dì, Thăm cô xứ bắc, thăm dì xứ Đông." (ca dao)',
    example: "khẩu súng trường bá đỏ",
  },
  {
    word: "bá",
    part_of_speech: "động từ",
    meaning: "quàng tay (lên vai, cổ): bá vai bá cổ",
    example: "bá vai bá cổ",
  },
  {
    word: "ba",
    part_of_speech: "danh từ",
    meaning: "(Nam) cha: thưa ba con đi học!",
    example: "thưa ba con đi học!",
  },
  {
    word: "ba",
    part_of_speech: "danh từ",
    meaning:
      "số 3: năm mươi ba * ba trăm bảy (ba trăm bảy mươi) * cao một mét ba (một mét ba mươi phân)",
    example:
      "năm mươi ba * ba trăm bảy (ba trăm bảy mươi) * cao một mét ba (một mét ba mươi phân)",
  },
  {
    word: "ba",
    part_of_speech: "danh từ",
    meaning:
      'từ chỉ số lượng không xác định, nhưng là rất ít, không đáng kể: mới ba tuổi đầu mà đã học đòi * "Còn ba hột cơm ranh! Ăn chẳng bõ dính răng." (NCao; 4)',
    example:
      'mới ba tuổi đầu mà đã học đòi * "Còn ba hột cơm ranh! Ăn chẳng bõ dính răng." (NCao; 4)',
  },
  {
    word: "ba",
    part_of_speech: "danh từ",
    meaning:
      'từ chỉ số lượng không xác định, nhưng không phải một vài, mà là nhiều: "Một cây làm chẳng nên non, Ba cây chụm lại, nên hòn núi cao." (ca dao)',
    example: "Một cây làm chẳng nên non, Ba cây chụm lại, nên hòn núi cao.",
  },
  {
    word: "ẩy",
    part_of_speech: "động từ",
    meaning: "đẩy nhanh một cái: ẩy cửa bước vào * ẩy cho ngã",
    example: "ẩy cửa bước vào * ẩy cho ngã",
  },
  {
    word: "bã",
    part_of_speech: "danh từ",
    meaning:
      "phần xác còn lại sau khi đã lấy hết chất nước cốt: bã rượu * bã chè * theo voi ăn bã mía (tng)",
    example: "bã rượu * bã chè * theo voi ăn bã mía (tng)",
  },
  {
    word: "bã",
    part_of_speech: "tính từ",
    meaning:
      'rời, nát và nhạt nhẽo như chỉ là cái bã còn lại: giò bã * "Miếng cám ngậm trong miệng hắn đã bã ra chát sít." (KLân; 9)',
    example:
      'giò bã * "Miếng cám ngậm trong miệng hắn đã bã ra chát sít." (KLân; 9)',
  },
  {
    word: "bã",
    part_of_speech: "tính từ",
    meaning:
      "mệt mỏi quá mức, tưởng như chân tay rã rời, không còn gắng gượng để hoạt động bình thường được: mệt quá, người cứ bã ra * mệt bã cả người",
    example: "mệt quá, người cứ bã ra * mệt bã cả người",
  },
  {
    word: "bả",
    part_of_speech: "danh từ",
    meaning:
      "thức ăn có thuốc độc dùng làm mồi để lừa giết thú vật nhỏ: bả chuột * đánh bả chó",
    example: "bả chuột * đánh bả chó",
  },
  {
    word: "bả",
    part_of_speech: "danh từ",
    meaning:
      'cái có sức cám dỗ, mê hoặc khiến cho không còn tỉnh táo, thậm chí có thể bị mắc lừa: "Mồi phú quý dử làng xa mã, Bả vinh hoa lừa gã công khanh.',
    example: "Mồi phú quý dử làng xa mã, Bả vinh hoa lừa gã công khanh.",
  },
  {
    word: "bả",
    part_of_speech: "đại từ",
    meaning: "(Nam, khẩu ngữ) bà ấy: Bả nói khi nào tới?",
    example: "Bả nói khi nào tới?",
  },
  {
    word: "bả",
    part_of_speech: "động từ",
    meaning:
      "trát chất kết dính như sơn, mastic, v.v. vào cho kín hoặc cho bằng phẳng: tường bả mastic * bả sơn vào mạn thuyền",
    example: "tường bả mastic * bả sơn vào mạn thuyền",
  },
  {
    word: "b",
    part_of_speech: "",
    meaning:
      "kí hiệu phân loại trên dưới: thứ hai, sau A: sản phẩm loại B * nhà số 4B (sau số 4A)",
    example: "sản phẩm loại B * nhà số 4B (sau số 4A)",
  },
  {
    word: "bà",
    part_of_speech: "danh từ",
    meaning:
      "người đàn bà sinh ra cha, mẹ hoặc cùng thế hệ với người sinh ra cha, mẹ (có thể dùng để xưng gọi): bà nội * cháu chào bà ạ! * con hư tại mẹ, cháu hư tại bà (tng)",
    example: "bà nội * cháu chào bà ạ! * con hư tại mẹ, cháu hư tại bà (tng)",
  },
  {
    word: "bà",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ hoặc gọi người đàn bà đứng tuổi hoặc được kính trọng: bà giáo * bà bộ trưởng * bà mẹ Việt Nam anh hùng",
    example: "bà giáo * bà bộ trưởng * bà mẹ Việt Nam anh hùng",
  },
  {
    word: "bà",
    part_of_speech: "danh từ",
    meaning:
      "từ người đàn bà dùng để tự xưng khi tức giận, muốn tỏ vẻ trịch thượng hoặc hách dịch: rồi sẽ biết tay bà!",
    example: "rồi sẽ biết tay bà!",
  },
  {
    word: "bạ",
    part_of_speech: "động từ",
    meaning:
      "tuỳ tiện, gặp dịp là làm, là nói, không phân biệt, cân nhắc nên hay không nên: bạ đâu ngồi đấy",
    example: "bạ đâu ngồi đấy",
  },
  {
    word: "ba bề bốn bên",
    part_of_speech: "",
    meaning:
      'khắp bốn phía xung quanh: "Bản Hua Tát ở trong thung lũng hẹp và dài, ba bề bốn bên là núi cao bao bọc (...)" (NgHThiệp; 4)',
    example:
      'Bản Hua Tát ở trong thung lũng hẹp và dài, ba bề bốn bên là núi cao bao bọc (...)" (NgHThiệp; 4)',
  },
  {
    word: "bà ba",
    part_of_speech: "danh từ",
    meaning:
      "quần áo kiểu Nam Bộ, gồm có áo cánh, tay dài rộng, tà xẻ thấp và quần dài, không túi, cạp rộng luồn dải rút: bận bà ba đen",
    example: "bận bà ba đen",
  },
  {
    word: "ba bị",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi một hình người quái dị do người ta bịa ra để doạ trẻ con: ông ba bị",
    example: "ông ba bị",
  },
  {
    word: "ba bốn",
    part_of_speech: "danh từ",
    meaning:
      'số lượng chỉ ít thôi, chừng độ ba hoặc bốn gì đó: từ đây đến đó cũng phải ba bốn ngày * "Bấy chầy dãi nguyệt, dầu hoa, Mười phần xuân có gầy ba bốn phần." (TKiều)',
    example:
      'từ đây đến đó cũng phải ba bốn ngày * "Bấy chầy dãi nguyệt, dầu hoa, Mười phần xuân có gầy ba bốn phần." (TKiều)',
  },
  {
    word: "bã bời",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như rã rời: tâm trạng bã bời",
    example: "tâm trạng bã bời",
  },
  {
    word: "ba bảy",
    part_of_speech: "danh từ",
    meaning:
      'số lượng không phải chỉ có một, mà là nhiều (cái khác nhau): có ba bảy cách làm * "Một liều ba bảy cũng liều, Cầm bằng con trẻ chơi diều đứt dây." (ca dao)',
    example:
      'có ba bảy cách làm * "Một liều ba bảy cũng liều, Cầm bằng con trẻ chơi diều đứt dây." (ca dao)',
  },
  {
    word: "ba chân bốn cẳng",
    part_of_speech: "",
    meaning:
      '(khẩu ngữ) (đi, chạy) hết sức nhanh, hết sức vội vã: "Tôi lại ba chân bốn cẳng nhắm mắt nhắm mũi lao về phía tiếng ồn ào đang có một sức cuốn hút không cưỡng được." (ĐGiỏi; 4)',
    example:
      'Tôi lại ba chân bốn cẳng nhắm mắt nhắm mũi lao về phía tiếng ồn ào đang có một sức cuốn hút không cưỡng được." (ĐGiỏi; 4)',
  },
  {
    word: "ba chỉ",
    part_of_speech: "danh từ",
    meaning:
      "phần thịt lợn ở vùng bụng, có ba thớ nạc xen với mỡ: thịt ba chỉ * mua miếng ba chỉ",
    example: "thịt ba chỉ * mua miếng ba chỉ",
  },
  {
    word: "bá chủ",
    part_of_speech: "danh từ",
    meaning:
      "kẻ hoặc nước mạnh dựa vào vũ lực để thống trị, chi phối cả một khu vực rộng lớn, trong quan hệ với khu vực phụ thuộc nó: giành ngôi bá chủ * nuôi mộng làm bá chủ thế giới",
    example: "giành ngôi bá chủ * nuôi mộng làm bá chủ thế giới",
  },
  {
    word: "ba chìm bảy nổi",
    part_of_speech: "",
    meaning:
      'ví cảnh ngộ khi lên khi xuống, long đong vất vả nhiều phen: "Ba chìm bảy nổi lênh đênh, Có khi để ngả để nghênh thiệt thòi." (ca dao)',
    example:
      'Ba chìm bảy nổi lênh đênh, Có khi để ngả để nghênh thiệt thòi." (ca dao)',
  },
  {
    word: "bà chúa",
    part_of_speech: "danh từ",
    meaning:
      "người đàn bà tài giỏi, được coi là người đứng đầu một lĩnh vực nào đó: Hồ Xuân Hương được tôn là bà chúa thơ Nôm",
    example: "Hồ Xuân Hương được tôn là bà chúa thơ Nôm",
  },
  {
    word: "bà cô",
    part_of_speech: "danh từ",
    meaning:
      "người phụ nữ nhiều tuổi mà chưa có chồng, hoặc đang tuổi lấy chồng mà đã chết: bà cô ông mãnh",
    example: "bà cô ông mãnh",
  },
  {
    word: "ba cọc ba đồng",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) (khoản thu nhập) ít ỏi và chỉ trong phạm vi nhất định: lương ba cọc ba đồng",
    example: "lương ba cọc ba đồng",
  },
  {
    word: "bà con",
    part_of_speech: "danh từ",
    meaning:
      "quan hệ họ hàng hoặc người có quan hệ họ hàng (nói khái quát): một người bà con xa * không còn bà con thân thích",
    example: "một người bà con xa * không còn bà con thân thích",
  },
  {
    word: "bà con",
    part_of_speech: "danh từ",
    meaning:
      "những người có quan hệ thân thiết, gần gũi (nói khái quát): bà con hàng xóm * bà con nông dân",
    example: "bà con hàng xóm * bà con nông dân",
  },
  {
    word: "bà cốt",
    part_of_speech: "danh từ",
    meaning: "người đàn bà làm nghề đồng bóng: bà cốt lên đồng",
    example: "bà cốt lên đồng",
  },
  {
    word: "ba đào",
    part_of_speech: "danh từ",
    meaning:
      '(Từ cũ, Văn chương) sóng to; thường dùng để ví cảnh ngộ chìm nổi, gian nan, vất vả: "Thương ai ruột thắt, gan bào, Nghĩ ai tủi phận ba đào thở than." (Cdao)',
    example:
      'Thương ai ruột thắt, gan bào, Nghĩ ai tủi phận ba đào thở than." (Cdao)',
  },
  {
    word: "ba gác",
    part_of_speech: "danh từ",
    meaning:
      "xe gỗ hai bánh, có hai càng do người kéo, dùng để chở hàng: xe ba gác",
    example: "xe ba gác",
  },
  {
    word: "ba gai",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ, khẩu ngữ) lấc cấc, bướng bỉnh, hay sinh chuyện gây gổ: tính rất ba gai",
    example: "tính rất ba gai",
  },
  {
    word: "bà già",
    part_of_speech: "danh từ",
    meaning:
      "người phụ nữ đã cao tuổi, thường dùng để chỉ mẹ mình hoặc người thuộc bậc mẹ mình trong cách nói thân mật: bà già tôi còn khoẻ",
    example: "bà già tôi còn khoẻ",
  },
  {
    word: "ba hoa",
    part_of_speech: "",
    meaning:
      "nói quá nhiều, thường có ý khoe khoang, khoác lác: chỉ được cái ba hoa!",
    example: "chỉ được cái ba hoa!",
  },
  {
    word: "bả lả",
    part_of_speech: "tính từ",
    meaning: "lả lơi, không đứng đắn: cười nói bả lả",
    example: "cười nói bả lả",
  },
  {
    word: "ba hồn chín vía",
    part_of_speech: "",
    meaning:
      'hồn vía của người đàn bà, theo quan niệm xưa: "Người thì chẳng đáng đồng chì, Ba hồn chín vía đòi đi võng đào." (ca dao)',
    example:
      'Người thì chẳng đáng đồng chì, Ba hồn chín vía đòi đi võng đào." (ca dao)',
  },
  {
    word: "ba láp",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ, khẩu ngữ) không đứng đắn, không có nghĩa lí gì: nói toàn chuyện ba láp",
    example: "nói toàn chuyện ba láp",
  },
  {
    word: "ba lăng nhăng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) vớ vẩn, không đâu vào đâu, không có giá trị, ý nghĩa gì: ăn nói ba lăng nhăng",
    example: "ăn nói ba lăng nhăng",
  },
  {
    word: "ba lê",
    part_of_speech: "danh từ",
    meaning:
      "nghệ thuật múa cổ điển trên sân khấu thể hiện một chủ đề nhất định, có nhạc đệm: xem biểu diễn ba lê",
    example: "xem biểu diễn ba lê",
  },
  {
    word: "bà nhạc",
    part_of_speech: "danh từ",
    meaning: "(cũ, trtr hoặc kc) mẹ vợ: ông nhạc, bà nhạc",
    example: "ông nhạc, bà nhạc",
  },
  {
    word: "ba phải",
    part_of_speech: "tính từ",
    meaning:
      "đằng nào cũng cho là đúng, là phải, không có hoặc không dám bộc lộ quan điểm, chính kiến riêng: con người ba phải * đồ ba phải! (tiếng mắng)",
    example: "con người ba phải * đồ ba phải! (tiếng mắng)",
  },
  {
    word: "bá quan",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) các quan trong triều đình, dưới đại thần (nói tổng quát): bá quan văn võ",
    example: "bá quan văn võ",
  },
  {
    word: "ba quân",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) ba đạo quân hoặc ba cánh quân lớn (tiền quân, trung quân và hậu quân, hoặc tả quân, trung quân và hữu quân); chỉ tất cả binh sĩ dưới quyền chỉ huy của một viên tướng, nói chung: thề trước ba quân * bày tiệc khao thưởng ba quân",
    example: "thề trước ba quân * bày tiệc khao thưởng ba quân",
  },
  {
    word: "ba que xỏ lá",
    part_of_speech: "",
    meaning: "ba que và xỏ lá (nói khái quát): rặt một bọn ba que xỏ lá",
    example: "rặt một bọn ba que xỏ lá",
  },
  {
    word: "ba rọi",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) ba chỉ: thịt ba rọi",
    example: "thịt ba rọi",
  },
  {
    word: "ba rọi",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) nửa đùa nửa thật, có ý xỏ xiên: lối nói ba rọi * tính ba rọi",
    example: "lối nói ba rọi * tính ba rọi",
  },
  {
    word: "ba rọi",
    part_of_speech: "tính từ",
    meaning: "pha tạp một cách lố lăng: nói tiếng Tây ba rọi",
    example: "nói tiếng Tây ba rọi",
  },
  {
    word: "ba que",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) xảo trá, đểu giả: giở trò ba que",
    example: "giở trò ba que",
  },
  {
    word: "ba sinh",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) đời đời kiếp kiếp (thường nói về tình duyên gắn bó với nhau), theo quan niệm của đạo Phật: duyên nợ ba sinh * "Mừng thầm chốn ấy chữ bài, Ba sinh âu hẳn duyên trời chi đây!" (TKiều)',
    example:
      'duyên nợ ba sinh * "Mừng thầm chốn ấy chữ bài, Ba sinh âu hẳn duyên trời chi đây!" (TKiều)',
  },
  {
    word: "ba rem",
    part_of_speech: "danh từ",
    meaning:
      "đáp án có kèm theo điểm cụ thể của từng phần, dùng làm căn cứ để chấm thi: chấm theo đúng barem",
    example: "chấm theo đúng barem",
  },
  {
    word: "ba toong",
    part_of_speech: "danh từ",
    meaning:
      "gậy ngắn cầm tay để chống, thường có một đầu cong: chân yếu phải chống ba toong",
    example: "chân yếu phải chống ba toong",
  },
  {
    word: "ba trợn",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ, khẩu ngữ) có nhiều biểu hiện xấu về tư cách, như thiếu đứng đắn, thiếu thật thà, không thể tin cậy được: thằng cha ăn nói rất ba trợn",
    example: "thằng cha ăn nói rất ba trợn",
  },
  {
    word: "ba vạ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) bị sử dụng tuỳ tiện, không được trông nom chăm sóc, không ra gì: cái xe ba vạ * đồ ba vạ!",
    example: "cái xe ba vạ * đồ ba vạ!",
  },
  {
    word: "bả vai",
    part_of_speech: "danh từ",
    meaning:
      "phần thân thể ở phía trên lưng, ngay dưới vai: bị thương nơi bả vai",
    example: "bị thương nơi bả vai",
  },
  {
    word: "bá vơ",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) vu vơ, không đâu vào đâu: lo chuyện bá vơ",
    example: "lo chuyện bá vơ",
  },
  {
    word: "bà xã",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) từ dùng để gọi người vợ một cách thân mật, đùa vui: bà xã nhà anh * bà xã đã về đấy à?",
    example: "bà xã nhà anh * bà xã đã về đấy à?",
  },
  {
    word: "bá vương",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người làm nên nghiệp bá, nghiệp vương (nói khái quát): nuôi mộng bá vương",
    example: "nuôi mộng bá vương",
  },
  {
    word: "ba xạo",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ, hiếm) như xạo: toàn nói những chuyện ba xạo!",
    example: "toàn nói những chuyện ba xạo!",
  },
  {
    word: "ba xu",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) rẻ tiền, không có giá trị, ý nghĩa gì, không có gì đáng kể: truyện kiếm hiệp ba xu",
    example: "truyện kiếm hiệp ba xu",
  },
  {
    word: "ba-dan",
    part_of_speech: "danh từ",
    meaning:
      "đá màu đen hay xám sẫm, do chất nóng chảy phun trào từ lòng đất lên trên mặt đất tạo nên: đá basalt",
    example: "đá basalt",
  },
  {
    word: "ba-ri-e",
    part_of_speech: "danh từ",
    meaning: "rào chắn, rào cản: xe chở gỗ lậu vượt barie",
    example: "xe chở gỗ lậu vượt barie",
  },
  {
    word: "bác",
    part_of_speech: "danh từ",
    meaning:
      "anh của cha hoặc chị dâu của cha (có thể dùng để xưng gọi): bác ruột * bác gái * anh em con chú con bác",
    example: "bác ruột * bác gái * anh em con chú con bác",
  },
  {
    word: "bác",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ) cô, cậu hoặc dì ở hàng anh hay chị của cha mẹ.",
    example:
      'bác mẹ * "Cùng giọt máu bác sinh ra, Khác giọt máu mẹ mà ra khác lòng." (Cdao)',
  },
  {
    word: "bác",
    part_of_speech: "danh từ",
    meaning:
      '(Từ cũ) cha: bác mẹ * "Cùng giọt máu bác sinh ra, Khác giọt máu mẹ mà ra khác lòng." (Cdao)',
    example: "bác công nhân già * bác bảo vệ",
  },
  {
    word: "bác",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng trong đối thoại để gọi người coi như bậc bác của mình với ý kính trọng, hoặc để tự xưng một cách thân mật với người coi như hàng cháu của mình.",
    example: "mời bác lại nhà tôi chơi",
  },
  {
    word: "bác",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ người lớn tuổi với ý tôn trọng, hoặc chỉ người nhiều tuổi hơn cha mẹ mình: bác công nhân già * bác bảo vệ",
    example: "vào lăng viếng Bác",
  },
  {
    word: "bác",
    part_of_speech: "động từ",
    meaning:
      "làm chín thức ăn mặn bằng cách đun nhỏ lửa và quấy cho đến khi sền sệt: bác trứng * bác mắm",
    example: "bác trứng * bác mắm",
  },
  {
    word: "bác",
    part_of_speech: "động từ",
    meaning:
      'gạt bỏ ý kiến, quan điểm của người khác bằng lí lẽ: bác lời vu cáo * "Lão bác ngay lý do không bằng lòng của vợ (...)" (ĐVũ; 1)',
    example:
      'bác lời vu cáo * "Lão bác ngay lý do không bằng lòng của vợ (...)" (ĐVũ; 1)',
  },
  {
    word: "bác",
    part_of_speech: "động từ",
    meaning: "không chấp nhận: bị toà bác đơn * đề nghị đưa ra bị bác",
    example: "bị toà bác đơn * đề nghị đưa ra bị bác",
  },
  {
    word: "bạc ác",
    part_of_speech: "tính từ",
    meaning: "bất nhân, ăn ở ác: con người bạc ác",
    example: "con người bạc ác",
  },
  {
    word: "bạc",
    part_of_speech: "danh từ",
    meaning:
      "kim loại quý màu trắng sáng, mềm, khó gỉ, dẫn điện tốt, thường dùng để mạ hoặc làm đồ trang sức: vòng bạc * bức tượng mạ bạc * nén bạc đâm toạc tờ giấy (tng)",
    example: "vòng bạc * bức tượng mạ bạc * nén bạc đâm toạc tờ giấy (tng)",
  },
  {
    word: "bạc",
    part_of_speech: "danh từ",
    meaning: "tiền đúc bằng bạc (nói khái quát): đồng bạc trắng",
    example: "đồng bạc trắng",
  },
  {
    word: "bạc",
    part_of_speech: "danh từ",
    meaning:
      '(khẩu ngữ) đồng bạc (nói tắt): cái lọ đáng giá hơn trăm bạc * "(...) van lạy hết người nọ đến người kia, mới vay được non chục bạc (...)" (NCao; 5)',
    example:
      'cái lọ đáng giá hơn trăm bạc * "(...) van lạy hết người nọ đến người kia, mới vay được non chục bạc (...)" (NCao; 5)',
  },
  {
    word: "bạc",
    part_of_speech: "danh từ",
    meaning: "trò chơi ăn tiền (nói khái quát): canh bạc * chơi bạc",
    example: "canh bạc * chơi bạc",
  },
  {
    word: "bạc",
    part_of_speech: "danh từ",
    meaning: "bạc lót (nói tắt): bạc quạt máy",
    example: "bạc quạt máy",
  },
  {
    word: "bạc",
    part_of_speech: "tính từ",
    meaning:
      'có màu trắng đục, như màu của bạc: áng mây bạc * "Còn duyên âu lại còn người, Còn vừng trăng bạc, còn lời nguyền xưa." (TKiều)',
    example:
      'áng mây bạc * "Còn duyên âu lại còn người, Còn vừng trăng bạc, còn lời nguyền xưa." (TKiều)',
  },
  {
    word: "bạc",
    part_of_speech: "tính từ",
    meaning:
      "(râu, tóc) đã ngả sang màu trắng, thường vì tuổi già: chòm râu bạc * mái tóc bạc * tóc đốm bạc",
    example: "chòm râu bạc * mái tóc bạc * tóc đốm bạc",
  },
  {
    word: "bạc",
    part_of_speech: "tính từ",
    meaning: "đã phai màu, không còn giữ nguyên màu cũ: quần bạc gối",
    example: "quần bạc gối",
  },
  {
    word: "bạc",
    part_of_speech: "tính từ",
    meaning:
      '(cũ) mỏng manh, ít ỏi, không được trọn vẹn: mệnh bạc * tài hèn đức bạc * "Phận sao phận bạc như tờ, Nợ sinh thành biết bao giờ trả xong." (HT)',
    example:
      'mệnh bạc * tài hèn đức bạc * "Phận sao phận bạc như tờ, Nợ sinh thành biết bao giờ trả xong." (HT)',
  },
  {
    word: "bạc",
    part_of_speech: "tính từ",
    meaning: "ít ỏi, sơ sài: lễ bạc lòng thành",
    example: "lễ bạc lòng thành",
  },
  {
    word: "bạc",
    part_of_speech: "tính từ",
    meaning:
      'không giữ được tình nghĩa trọn vẹn trước sau như một: ăn ở bạc * "Trừ cụ ra, thì cái đất này bạc lắm cụ ạ. Cứ cúng xong ra khỏi ngõ là họ quên ngay mình." (MPTư; 1)',
    example:
      'ăn ở bạc * "Trừ cụ ra, thì cái đất này bạc lắm cụ ạ. Cứ cúng xong ra khỏi ngõ là họ quên ngay mình." (MPTư; 1)',
  },
  {
    word: "ba-zan",
    part_of_speech: "danh từ",
    meaning:
      "đá màu đen hay xám sẫm, do chất nóng chảy phun trào từ lòng đất lên trên mặt đất tạo nên: đá basalt",
    example: "đá basalt",
  },
  {
    word: "bạc bẽo",
    part_of_speech: "tính từ",
    meaning:
      "không nghĩ gì đến tình nghĩa, công ơn, phủ nhận quan hệ tình cảm ân nghĩa: đối xử bạc bẽo  * ăn ở bạc bẽo",
    example: "đối xử bạc bẽo  * ăn ở bạc bẽo",
  },
  {
    word: "bạc bẽo",
    part_of_speech: "tính từ",
    meaning: "không đền bù tương xứng với công lao: nghề bạc bẽo",
    example: "nghề bạc bẽo",
  },
  {
    word: "bác bỏ",
    part_of_speech: "động từ",
    meaning:
      "bác đi, không chấp nhận, không thừa nhận: đề nghị đưa ra bị bác bỏ * bác bỏ tin đồn",
    example: "đề nghị đưa ra bị bác bỏ * bác bỏ tin đồn",
  },
  {
    word: "bác ái",
    part_of_speech: "tính từ",
    meaning: "có lòng thương yêu rộng khắp: có lòng bác ái",
    example: "có lòng bác ái",
  },
  {
    word: "chung chạ",
    part_of_speech: "",
    meaning:
      "chung với nhau trong sinh hoạt đến mức không còn phân biệt cái gì là riêng nữa (thường hàm ý chê): của ai người ấy dùng, không nên chung chạ * quần áo mặc chung chạ",
    example:
      "của ai người ấy dùng, không nên chung chạ * quần áo mặc chung chạ",
  },
  {
    word: "chung chạ",
    part_of_speech: "",
    meaning:
      "sống chung với nhau như vợ chồng (thường hàm ý chê): hai người chung chạ với nhau đã lâu",
    example: "hai người chung chạ với nhau đã lâu",
  },
  {
    word: "chúng bạn",
    part_of_speech: "danh từ",
    meaning: "bạn bè nói chung: theo kịp chúng bạn * bị chúng bạn cười chê",
    example: "theo kịp chúng bạn * bị chúng bạn cười chê",
  },
  {
    word: "chung chung",
    part_of_speech: "tính từ",
    meaning:
      "rất chung, không cụ thể: phát biểu chung chung * trả lời chung chung * nhận xét rất chung chung",
    example:
      "phát biểu chung chung * trả lời chung chung * nhận xét rất chung chung",
  },
  {
    word: "chủng",
    part_of_speech: "danh từ",
    meaning: "(cũ) loài (động vật, thực vật): phát hiện một chủng vi khuẩn mới",
    example: "phát hiện một chủng vi khuẩn mới",
  },
  {
    word: "chủng",
    part_of_speech: "danh từ",
    meaning: "giống (người): chủng da vàng * nước Mĩ có nhiều chủng người",
    example: "chủng da vàng * nước Mĩ có nhiều chủng người",
  },
  {
    word: "chủng",
    part_of_speech: "danh từ",
    meaning: "loại, chủng loại: hàng hoá đa chủng",
    example: "hàng hoá đa chủng",
  },
  {
    word: "chủng",
    part_of_speech: "động từ",
    meaning:
      "cấy vaccin hay độc tố vi khuẩn vào da thịt để phòng, chẩn đoán hoặc nghiên cứu bệnh: chủng vaccin * chủng trực khuẩn lao cho chuột bạch",
    example: "chủng vaccin * chủng trực khuẩn lao cho chuột bạch",
  },
  {
    word: "chủng chẳng",
    part_of_speech: "tính từ",
    meaning:
      "(nói năng) không rành mạch và rời rạc một cách cố ý, để tỏ thái độ không thích thú, không mặn mà gì cho lắm: ăn nói chủng chẳng * trả lời chủng chẳng",
    example: "ăn nói chủng chẳng * trả lời chủng chẳng",
  },
  {
    word: "chùng chình",
    part_of_speech: "động từ",
    meaning:
      'cố ý nấn ná, làm chậm chạp để kéo dài thời gian: chùng chình chưa muốn đi * "(...) chàng đã cố ý làm chùng chình cho cuộc bầu cử kéo dài đến mười hai giờ (...)" (KhHưng; 2)',
    example:
      'chùng chình chưa muốn đi * "(...) chàng đã cố ý làm chùng chình cho cuộc bầu cử kéo dài đến mười hai giờ (...)" (KhHưng; 2)',
  },
  {
    word: "chung chiêng",
    part_of_speech: "",
    meaning:
      "nghiêng qua nghiêng lại, có cảm giác như lơ lửng trong không trung: chiếc cầu treo chung chiêng",
    example: "chiếc cầu treo chung chiêng",
  },
  {
    word: "chung cư",
    part_of_speech: "danh từ",
    meaning:
      "khu nhà ở cao tầng, được thiết kế theo kiểu có từng căn hộ riêng biệt khép kín: nhà chung cư * căn hộ chung cư",
    example: "nhà chung cư * căn hộ chung cư",
  },
  {
    word: "chung cuộc",
    part_of_speech: "danh từ",
    meaning:
      "giai đoạn cuối cùng, kết thúc của một quá trình thi đấu hoặc của một cuộc thi: kết quả chung cuộc * giành thắng lợi chung cuộc",
    example: "kết quả chung cuộc * giành thắng lợi chung cuộc",
  },
  {
    word: "chung cuộc",
    part_of_speech: "phụ từ",
    meaning: "(hiếm) rốt cuộc: chung cuộc, phần thắng về tay đội chủ nhà",
    example: "chung cuộc, phần thắng về tay đội chủ nhà",
  },
  {
    word: "chung đụng",
    part_of_speech: "động từ",
    meaning:
      "ăn ở, sinh hoạt chung với nhau (thường gây nên những điều phiền toái): sống chung đụng với nhau * làm ăn chung đụng",
    example: "sống chung đụng với nhau * làm ăn chung đụng",
  },
  {
    word: "chung đúc",
    part_of_speech: "động từ",
    meaning:
      "kết tụ tinh hoa, tinh tuý lại để tạo nên cái có giá trị lớn về mặt tinh thần: hồn thiêng sông núi đã chung đúc nên hào khí anh hùng",
    example: "hồn thiêng sông núi đã chung đúc nên hào khí anh hùng",
  },
  {
    word: "chủng loại",
    part_of_speech: "danh từ",
    meaning: "giống loài: các chủng loại thực vật",
    example: "các chủng loại thực vật",
  },
  {
    word: "chủng loại",
    part_of_speech: "danh từ",
    meaning:
      "loại (hàng hoá; nói khái quát): chủng loại hàng hoá * có nhiều chủng loại xe con mới",
    example: "chủng loại hàng hoá * có nhiều chủng loại xe con mới",
  },
  {
    word: "chung khảo",
    part_of_speech: "danh từ",
    meaning:
      "vòng xét tuyển cuối cùng, quyết định việc tuyển chọn trong một cuộc thi tuyển qua nhiều vòng: vòng chung khảo cuộc thi viết truyện ngắn",
    example: "vòng chung khảo cuộc thi viết truyện ngắn",
  },
  {
    word: "chung đỉnh",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, hiếm) như đỉnh chung: "Đói no có thiếp có chàng, Còn hơn chung đỉnh giàu sang một mình." (ca dao)',
    example:
      'Đói no có thiếp có chàng, Còn hơn chung đỉnh giàu sang một mình." (ca dao)',
  },
  {
    word: "chung lưng",
    part_of_speech: "động từ",
    meaning:
      'cùng góp sức, hợp lực để làm việc gì: "Chung lưng mở một ngôi hàng, Quanh năm buôn phấn, bán hương đã lề." (TKiều)',
    example:
      'Chung lưng mở một ngôi hàng, Quanh năm buôn phấn, bán hương đã lề." (TKiều)',
  },
  {
    word: "chung kết",
    part_of_speech: "danh từ",
    meaning:
      "vòng thi đấu (hoặc vòng thi) cuối cùng để chọn đội hay vận động viên vô địch (hoặc người chiếm giải nhất): trận chung kết bóng đá * lọt vào vòng chung kết cuộc thi hoa hậu",
    example: "trận chung kết bóng đá * lọt vào vòng chung kết cuộc thi hoa hậu",
  },
  {
    word: "chúng mày",
    part_of_speech: "đại từ",
    meaning:
      "tổ hợp dùng để gọi nhóm người ngang hàng hoặc hàng dưới khi nói với nhóm người ấy, tỏ ý coi thường hoặc thân mật: bọn chúng mày * đi thôi chúng mày ơi!",
    example: "bọn chúng mày * đi thôi chúng mày ơi!",
  },
  {
    word: "chúng mình",
    part_of_speech: "đại từ",
    meaning:
      "(khẩu ngữ) như chúng ta (dùng với người ngang hàng để tỏ ý thân mật): anh đợi tôi rồi chúng mình cùng đi * bọn chúng mình",
    example: "anh đợi tôi rồi chúng mình cùng đi * bọn chúng mình",
  },
  {
    word: "chúng nó",
    part_of_speech: "đại từ",
    meaning:
      "tổ hợp dùng để chỉ nhóm người ngang hàng hay hàng dưới hoặc nhóm động vật đã được xác định nào đó: bọn trẻ bây giờ chúng nó khôn lắm * phải cho chúng nó biết tay!",
    example: "bọn trẻ bây giờ chúng nó khôn lắm * phải cho chúng nó biết tay!",
  },
  {
    word: "chung quanh",
    part_of_speech: "danh từ",
    meaning:
      "khoảng không gian bao quanh một sự vật: vây kín xung quanh * bạn bè xung quanh",
    example: "vây kín xung quanh * bạn bè xung quanh",
  },
  {
    word: "chung quanh",
    part_of_speech: "danh từ",
    meaning:
      "phạm vi có liên quan đến một sự việc: có nhiều ý kiến xung quanh vấn đề này",
    example: "có nhiều ý kiến xung quanh vấn đề này",
  },
  {
    word: "chung quy",
    part_of_speech: "phụ từ",
    meaning:
      "quy cho đến cùng, về thực chất của sự việc: câu chuyện chung quy chỉ có thế * chung quy là tại mình cả",
    example: "câu chuyện chung quy chỉ có thế * chung quy là tại mình cả",
  },
  {
    word: "chung quy lại",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) như chung quy: thi mấy lần mà vẫn không đỗ, chung quy lại là tại dốt",
    example: "thi mấy lần mà vẫn không đỗ, chung quy lại là tại dốt",
  },
  {
    word: "chung qui",
    part_of_speech: "phụ từ",
    meaning:
      "quy cho đến cùng, về thực chất của sự việc: câu chuyện chung quy chỉ có thế * chung quy là tại mình cả",
    example: "câu chuyện chung quy chỉ có thế * chung quy là tại mình cả",
  },
  {
    word: "chung qui lại",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) như chung quy: thi mấy lần mà vẫn không đỗ, chung quy lại là tại dốt",
    example: "thi mấy lần mà vẫn không đỗ, chung quy lại là tại dốt",
  },
  {
    word: "chúng ta",
    part_of_speech: "đại từ",
    meaning:
      "tổ hợp người nói dùng để chỉ bản thân mình cùng với người đối thoại: tổ quốc của chúng ta * ngày mai chúng ta sẽ bàn tiếp",
    example: "tổ quốc của chúng ta * ngày mai chúng ta sẽ bàn tiếp",
  },
  {
    word: "chúng sinh",
    part_of_speech: "danh từ",
    meaning:
      "tất cả những sinh vật nói chung; cũng dùng để chỉ người và động vật, theo quan niệm của đạo Phật: phổ độ chúng sinh",
    example: "phổ độ chúng sinh",
  },
  {
    word: "chúng sinh",
    part_of_speech: "danh từ",
    meaning:
      'tất cả những cô hồn không ai thờ cúng, theo quan niệm dân gian: cúng chúng sinh * "Thương thay thập loại chúng sinh, Hồn đơn phách chiếc lênh đênh quê người." (CH)',
    example:
      'cúng chúng sinh * "Thương thay thập loại chúng sinh, Hồn đơn phách chiếc lênh đênh quê người." (CH)',
  },
  {
    word: "chung thẩm",
    part_of_speech: "động từ",
    meaning:
      "(toà án) quyết định lần cuối cùng về một vụ án làm cho bản án có hiệu lực pháp luật, sau đó đương sự không được chống án nữa: toà xử phiên chung thẩm",
    example: "toà xử phiên chung thẩm",
  },
  {
    word: "chung tình",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) tình yêu chung đúc dồn vào một mối: mối chung tình * "Duyên kia có phụ chi tình, Mà toan chia gánh chung tình làm hai?" (TKiều)',
    example:
      'mối chung tình * "Duyên kia có phụ chi tình, Mà toan chia gánh chung tình làm hai?" (TKiều)',
  },
  {
    word: "chung tình",
    part_of_speech: "động từ",
    meaning:
      "có tình yêu hoặc dành cả tình yêu cho một người duy nhất: một người đàn ông chung tình * chung tình với nhau",
    example: "một người đàn ông chung tình * chung tình với nhau",
  },
  {
    word: "chung thân",
    part_of_speech: "tính từ",
    meaning:
      "suốt đời, cho đến hết đời: bị kết án tù chung thân * món nợ lãi chung thân cũng không trả hết",
    example:
      "bị kết án tù chung thân * món nợ lãi chung thân cũng không trả hết",
  },
  {
    word: "chúng tao",
    part_of_speech: "đại từ",
    meaning:
      "(khẩu ngữ) như chúng tôi (dùng với người bậc dưới, người thân hoặc với hàm ý khinh thường): chuyện của mày, chúng tao không tham gia",
    example: "chuyện của mày, chúng tao không tham gia",
  },
  {
    word: "chuốc",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) cố để có cho bằng được (cái tưởng là quý): chuốc lấy hư danh",
    example: "chuốc lấy hư danh",
  },
  {
    word: "chuốc",
    part_of_speech: "động từ",
    meaning:
      "nhận lấy ngoài ý muốn của mình (cái không hay): chuốc vạ vào thân * chuốc lấy thất bại * mua thù chuốc oán",
    example: "chuốc vạ vào thân * chuốc lấy thất bại * mua thù chuốc oán",
  },
  {
    word: "chuốc",
    part_of_speech: "động từ",
    meaning:
      '(cũ) rót rượu để mời uống: "Tay Tiên chuốc chén rượu đào, Đổ đi thì tiếc, uống vào thì say." (ca dao)',
    example:
      'Tay Tiên chuốc chén rượu đào, Đổ đi thì tiếc, uống vào thì say." (ca dao)',
  },
  {
    word: "chung thuỷ",
    part_of_speech: "tính từ",
    meaning:
      "có tình cảm trước sau như một, không thay đổi: người bạn chung thuỷ * nguyện chung thuỷ với nhau suốt đời",
    example: "người bạn chung thuỷ * nguyện chung thuỷ với nhau suốt đời",
  },
  {
    word: "chủng tộc",
    part_of_speech: "danh từ",
    meaning:
      "tập đoàn người hình thành trong quá trình lịch sử, cùng một nguồn gốc, có chung những đặc điểm di truyền về màu da, về cấu tạo cơ thể, v.v.: không phân biệt chủng tộc",
    example: "không phân biệt chủng tộc",
  },
  {
    word: "chuôi",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận ngắn, dùng để cầm nắm, ở một số dụng cụ có lưỡi sắc, nhọn: chuôi dao nạm bạc * nắm đằng chuôi",
    example: "chuôi dao nạm bạc * nắm đằng chuôi",
  },
  {
    word: "chuối",
    part_of_speech: "danh từ",
    meaning:
      "cây ăn quả phổ biến ở vùng nhiệt đới, thân ngầm, lá to, có bẹ ôm lấy nhau thành một thân giả hình trụ, quả dài hơi cong, xếp thành buồng gồm nhiều nải: buồng chuối",
    example: "buồng chuối",
  },
  {
    word: "chúng tôi",
    part_of_speech: "đại từ",
    meaning:
      "tổ hợp dùng để nhân danh một số người mà tự xưng: ngày mai chúng tôi sẽ đi * công ti chúng tôi",
    example: "ngày mai chúng tôi sẽ đi * công ti chúng tôi",
  },
  {
    word: "chúng tôi",
    part_of_speech: "đại từ",
    meaning:
      "tổ hợp dùng để cá nhân tự xưng thay cho tôi một cách trang trọng khi viết sách, báo, đơn từ hoặc khi nói trước đám đông, trước người trên: chúng tôi xin chân thành cảm ơn bạn đọc",
    example: "chúng tôi xin chân thành cảm ơn bạn đọc",
  },
  {
    word: "chuộc",
    part_of_speech: "động từ",
    meaning:
      "đưa tiền của để đổi lấy về cái vốn là của mình mà người khác đang nắm giữ, chiếm giữ: bắt cóc người để đòi tiền chuộc * bán thóc để chuộc ruộng",
    example: "bắt cóc người để đòi tiền chuộc * bán thóc để chuộc ruộng",
  },
  {
    word: "chuộc",
    part_of_speech: "động từ",
    meaning:
      "làm điều tốt đẹp để bù lại lỗi lầm do mình gây ra trước đây: lập công chuộc tội * tu nhân tích đức mong chuộc lại lỗi lầm",
    example: "lập công chuộc tội * tu nhân tích đức mong chuộc lại lỗi lầm",
  },
  {
    word: "chuội",
    part_of_speech: "động từ",
    meaning: "luộc sơ qua: chuội qua miếng thịt",
    example: "chuội qua miếng thịt",
  },
  {
    word: "chuội",
    part_of_speech: "động từ",
    meaning:
      "cho hàng dệt hay tơ, sợi mộc vào nước có hoá chất để làm cho sạch tạp chất, hồ, keo, v.v.: chuội tơ",
    example: "chuội tơ",
  },
  {
    word: "chuội",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tuột ra khỏi tay, không giữ lại được: con cá chuội khỏi tay rơi xuống nước",
    example: "con cá chuội khỏi tay rơi xuống nước",
  },
  {
    word: "chuồi",
    part_of_speech: "động từ",
    meaning:
      "trượt xuống hoặc cho trượt xuống theo đường dốc: chuồi khúc gỗ xuống sườn núi * con cá chuồi xuống ao",
    example: "chuồi khúc gỗ xuống sườn núi * con cá chuồi xuống ao",
  },
  {
    word: "chuồi",
    part_of_speech: "động từ",
    meaning:
      "đẩy cho lọt vào trong một cách nhanh và gọn: chuồi nhanh gói quà vào túi xách",
    example: "chuồi nhanh gói quà vào túi xách",
  },
  {
    word: "chuỗi",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp gồm nhiều hạt xâu thành dây, dùng làm vật trang sức: tay lần chuỗi hạt * cổ đeo chuỗi ngọc",
    example: "tay lần chuỗi hạt * cổ đeo chuỗi ngọc",
  },
  {
    word: "chuỗi",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp gồm nhiều vật nhỏ cùng loại hoặc có hình dạng gần giống nhau, xâu thành dây: một chuỗi tiền xu",
    example: "một chuỗi tiền xu",
  },
  {
    word: "chuỗi",
    part_of_speech: "danh từ",
    meaning:
      'tổng thể nói chung những sự vật hay sự việc cùng loại kế tiếp nhau: từng chuỗi đạn bay vèo vèo * "Cuộc đời bà cụ là những chuỗi ngày lo lắng và chờ mong con." (NgMChâu; 3)',
    example:
      'từng chuỗi đạn bay vèo vèo * "Cuộc đời bà cụ là những chuỗi ngày lo lắng và chờ mong con." (NgMChâu; 3)',
  },
  {
    word: "chuối mắn",
    part_of_speech: "danh từ",
    meaning: "chuối quả nhỏ và mập: ngón tay chuối mắn (ngắn và mập)",
    example: "ngón tay chuối mắn (ngắn và mập)",
  },
  {
    word: "chuôm",
    part_of_speech: "danh từ",
    meaning:
      "chỗ trũng có đọng nước ở ngoài đồng, thường có thả cành cây cho cá ở: tát chuôm",
    example: "tát chuôm",
  },
  {
    word: "chuôm",
    part_of_speech: "danh từ",
    meaning: "cành cây thả xuống nước cho cá ở: thả chuôm",
    example: "thả chuôm",
  },
  {
    word: "chuồn",
    part_of_speech: "danh từ",
    meaning:
      'chuồn chuồn (nói tắt): phận mỏng cánh chuồn (tng) * "Chuồn chuồn có cánh thì bay, Kẻo thằng be bé bắt mày chuồn ơi." (ca dao)',
    example:
      'phận mỏng cánh chuồn (tng) * "Chuồn chuồn có cánh thì bay, Kẻo thằng be bé bắt mày chuồn ơi." (ca dao)',
  },
  {
    word: "chuồn",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bỏ đi một cách nhanh chóng và lặng lẽ: thấy động vội chuồn ra cửa sau * tên trộm đã chuồn mất",
    example: "thấy động vội chuồn ra cửa sau * tên trộm đã chuồn mất",
  },
  {
    word: "chuồn chuồn",
    part_of_speech: "danh từ",
    meaning:
      "côn trùng có đuôi dài, hai đôi cánh dạng màng mỏng, bay giỏi, ăn sâu bọ: chuồn chuồn ớt",
    example: "chuồn chuồn ớt",
  },
  {
    word: "chuông",
    part_of_speech: "danh từ",
    meaning:
      "nhạc khí đúc bằng hợp kim đồng, lòng rỗng, miệng loa tròn, thành cao, thường có quai để treo, tiếng trong và ngân dài, thường dùng trong các buổi lễ tôn giáo: đúc chuông * tiếng chuông chùa",
    example: "đúc chuông * tiếng chuông chùa",
  },
  {
    word: "chuông",
    part_of_speech: "danh từ",
    meaning:
      "vật bằng kim loại, có nhiều hình dáng khác nhau, phát ra tiếng kêu trong và vang để báo hiệu: bấm chuông cửa * chuông điện thoại réo * đặt chuông đồng hồ",
    example: "bấm chuông cửa * chuông điện thoại réo * đặt chuông đồng hồ",
  },
  {
    word: "chuồng chồ",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) chuồng xí: bẩn như cái chuồng chồ",
    example: "bẩn như cái chuồng chồ",
  },
  {
    word: "chuồng trại",
    part_of_speech: "danh từ",
    meaning:
      "chỗ xây dựng làm nơi để chăn nuôi (nói khái quát): xây dựng chuồng trại",
    example: "xây dựng chuồng trại",
  },
  {
    word: "chuồng",
    part_of_speech: "danh từ",
    meaning:
      "chỗ được ngăn chắn các phía để làm nơi nhốt giữ hoặc nuôi các con vật: xây chuồng lợn * xua gà vào chuồng * mất bò mới lo làm chuồng (tng)",
    example:
      "xây chuồng lợn * xua gà vào chuồng * mất bò mới lo làm chuồng (tng)",
  },
  {
    word: "chuồng",
    part_of_speech: "danh từ",
    meaning:
      "chỗ được ngăn chắn làm nơi chứa giữ, hoặc đựng vật gì: chuồng trấu * chuồng phân",
    example: "chuồng trấu * chuồng phân",
  },
  {
    word: "chuộng",
    part_of_speech: "động từ",
    meaning:
      "quý và thích hơn những cái khác: ham thanh chuộng lạ * chuộng hình thức",
    example: "ham thanh chuộng lạ * chuộng hình thức",
  },
  {
    word: "chuốt",
    part_of_speech: "động từ",
    meaning:
      "dùng lưỡi sắc đưa nhẹ nhiều lần trên bề mặt của vật để làm cho thật nhẵn: chuốt lại mấy đôi đũa * chuốt từng mũi tên",
    example: "chuốt lại mấy đôi đũa * chuốt từng mũi tên",
  },
  {
    word: "chuốt",
    part_of_speech: "động từ",
    meaning: "sửa chữa công phu cho bóng bẩy: chuốt từng câu từng chữ",
    example: "chuốt từng câu từng chữ",
  },
  {
    word: "chuột",
    part_of_speech: "danh từ",
    meaning:
      "thú gặm nhấm, mõm nhọn, tai bầu dục, đuôi thon dài, thường phá hại mùa màng và có thể truyền bệnh dịch hạch: bẫy chuột * mèo nhỏ bắt chuột con (tng)",
    example: "bẫy chuột * mèo nhỏ bắt chuột con (tng)",
  },
  {
    word: "chuột",
    part_of_speech: "danh từ",
    meaning:
      "thiết bị cầm tay liên kết với máy tính, có một hoặc nhiều nút ấn, khi cho chuyển động trên một mặt phẳng thì sẽ gây ra việc chuyển động con trỏ trên màn hình để dễ dàng chọn lựa các thành phần, và khi ấn nút nó sẽ truyền lệnh cho máy tính thực hiện một chức năng nào đó: kích chuột vào biểu tượng * chuột không dây",
    example: "kích chuột vào biểu tượng * chuột không dây",
  },
  {
    word: "chuột nhắt",
    part_of_speech: "danh từ",
    meaning: "chuột nhỏ, thường sống trong nhà: bé như con chuột nhắt",
    example: "bé như con chuột nhắt",
  },
  {
    word: "chuột rút",
    part_of_speech: "danh từ",
    meaning:
      "hiện tượng bắp thịt bị co rút và đau đột ngột: đang bơi thì bị chuột rút",
    example: "đang bơi thì bị chuột rút",
  },
  {
    word: "chụp ếch",
    part_of_speech: "động từ",
    meaning: "(thông tục) như vồ ếch: đường trơn đi coi chừng chụp ếch",
    example: "đường trơn đi coi chừng chụp ếch",
  },
  {
    word: "chụp giật",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) giật lấy, tranh giành lấy một cách trắng trợn: làm ăn kiểu chụp giật",
    example: "làm ăn kiểu chụp giật",
  },
  {
    word: "chụp",
    part_of_speech: "động từ",
    meaning:
      "làm cho phủ kín từ trên xuống bằng một động tác nhanh, gọn: chụp cái mũ lên đầu * bóng tối chụp xuống cánh đồng (b)",
    example: "chụp cái mũ lên đầu * bóng tối chụp xuống cánh đồng (b)",
  },
  {
    word: "chụp",
    part_of_speech: "động từ",
    meaning:
      "nắm bắt lấy bằng một động tác nhanh, gọn: chụp được con ếch * giơ tay chụp chú gà con",
    example: "chụp được con ếch * giơ tay chụp chú gà con",
  },
  {
    word: "chụp",
    part_of_speech: "động từ",
    meaning:
      "ghi lại nhanh hình ảnh bằng máy ảnh: chụp vài kiểu ảnh * chụp X-quang (chiếu tia X)",
    example: "chụp vài kiểu ảnh * chụp X-quang (chiếu tia X)",
  },
  {
    word: "chụp",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận hình phễu úp trên lò, bếp, v.v. để thu hút và làm thoát khí nóng, khí độc hoặc khói, bụi: khói từ bếp lò theo đường chụp thoát ra ngoài",
    example: "khói từ bếp lò theo đường chụp thoát ra ngoài",
  },
  {
    word: "chụp",
    part_of_speech: "danh từ",
    meaning: "chụp đèn (nói tắt): đèn bị gió thổi tắt vì không có chụp",
    example: "đèn bị gió thổi tắt vì không có chụp",
  },
  {
    word: "chút",
    part_of_speech: "danh từ",
    meaning:
      'lượng rất nhỏ, rất ít, gần như không đáng kể: chờ chút * bớt chút thời gian * "Bấy lâu mới được một ngày, Dừng chân, gạn chút niềm tây gọi là..." (TKiều)',
    example:
      'chờ chút * bớt chút thời gian * "Bấy lâu mới được một ngày, Dừng chân, gạn chút niềm tây gọi là..." (TKiều)',
  },
  {
    word: "chụp mũ",
    part_of_speech: "động từ",
    meaning:
      "quy cho người khác khuyết điểm nặng về tư tưởng một cách chủ quan, không có căn cứ: lối phê bình chụp mũ * hay chụp mũ lung tung",
    example: "lối phê bình chụp mũ * hay chụp mũ lung tung",
  },
  {
    word: "chút ít",
    part_of_speech: "danh từ",
    meaning: "một phần rất nhỏ, rất ít: kế hoạch có thay đổi chút ít",
    example: "kế hoạch có thay đổi chút ít",
  },
  {
    word: "chụt",
    part_of_speech: "tính từ",
    meaning: "từ mô phỏng tiếng hôn, tiếng mút mạnh: hôn chụt vào má",
    example: "hôn chụt vào má",
  },
  {
    word: "chụt chịt",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) mập mạp, thấp và có vẻ nặng nề (thường nói về trẻ em): thằng nhỏ béo chụt chịt",
    example: "thằng nhỏ béo chụt chịt",
  },
  {
    word: "chút đỉnh",
    part_of_speech: "danh từ",
    meaning:
      "một phần nào đó rất nhỏ, coi như không đáng là bao: cố ăn chút đỉnh cho lại người * khá hơn chút đỉnh",
    example: "cố ăn chút đỉnh cho lại người * khá hơn chút đỉnh",
  },
  {
    word: "chút xíu",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) một chút, không đáng kể: xin thêm chút xíu muối * đợi chút xíu",
    example: "xin thêm chút xíu muối * đợi chút xíu",
  },
  {
    word: "chút chít",
    part_of_speech: "tính từ",
    meaning: "từ mô phỏng tiếng chuột kêu: chuột kêu chút chít",
    example: "chuột kêu chút chít",
  },
  {
    word: "chút chít",
    part_of_speech: "danh từ",
    meaning:
      "đồ chơi trẻ em giống hình búp bê, có thể phát ra tiếng kêu chút chít: con chút chít",
    example: "con chút chít",
  },
  {
    word: "chút chít",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) béo tròn và hơi thấp (thường nói về trẻ em): béo chút chít",
    example: "béo chút chít",
  },
  {
    word: "chuyên",
    part_of_speech: "động từ",
    meaning:
      "rót nước trà từ chén tống sang các chén quân, theo lối uống trà cổ truyền: chuyên trà",
    example: "chuyên trà",
  },
  {
    word: "chuyên",
    part_of_speech: "động từ",
    meaning:
      "mang, chuyền từ tay người này sang tay người kia: chuyên tay nhau từng xô nước",
    example: "chuyên tay nhau từng xô nước",
  },
  {
    word: "chuyên",
    part_of_speech: "tính từ",
    meaning:
      "chỉ làm hoặc chủ yếu chỉ làm một việc gì: ca sĩ không chuyên * học trường chuyên * chỉ chuyên nói phét!",
    example: "ca sĩ không chuyên * học trường chuyên * chỉ chuyên nói phét!",
  },
  {
    word: "chuyên",
    part_of_speech: "tính từ",
    meaning:
      '(làm công việc gì) có sự tập trung tâm trí một cách thường xuyên: "Đi đò tát nước cho chuyên, Lấy chồng thì phải giữ duyên cho chồng." (ca dao)',
    example:
      'Đi đò tát nước cho chuyên, Lấy chồng thì phải giữ duyên cho chồng." (ca dao)',
  },
  {
    word: "chuỳ",
    part_of_speech: "danh từ",
    meaning:
      "vũ khí thời cổ, làm bằng gỗ hay kim loại, đầu tròn và to, có cán cầm để đánh: múa chuỳ * quả chuỳ đồng",
    example: "múa chuỳ * quả chuỳ đồng",
  },
  {
    word: "chuỳ",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) đòn, vố nặng: bị giáng cho một chuỳ",
    example: "bị giáng cho một chuỳ",
  },
  {
    word: "chuyền",
    part_of_speech: "động từ",
    meaning:
      "đưa chuyển từng quãng ngắn từ người này, chỗ này sang người khác, chỗ khác: chuyền bóng cho đồng đội * chuyền tay nhau điếu thuốc",
    example: "chuyền bóng cho đồng đội * chuyền tay nhau điếu thuốc",
  },
  {
    word: "chuyền",
    part_of_speech: "động từ",
    meaning:
      "di chuyển thân thể từng quãng ngắn trên không từ chỗ này sang chỗ khác: chim chuyền cành * chuyền từ ngọn cây này qua ngọn cây khác",
    example: "chim chuyền cành * chuyền từ ngọn cây này qua ngọn cây khác",
  },
  {
    word: "chuyến",
    part_of_speech: "danh từ",
    meaning:
      "lần vận chuyển, đi lại (thường bằng phương tiện vận tải): chuyến tàu đêm * chuyến hàng",
    example: "chuyến tàu đêm * chuyến hàng",
  },
  {
    word: "chuyến",
    part_of_speech: "danh từ",
    meaning: "lần đi xa: chuyến thăm của tổng thống * đi chơi một chuyến",
    example: "chuyến thăm của tổng thống * đi chơi một chuyến",
  },
  {
    word: "chuyến",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) lần xảy ra sự việc gì ít nhiều quan trọng: chuyến này thế nào cũng được tăng lương",
    example: "chuyến này thế nào cũng được tăng lương",
  },
  {
    word: "chuyện",
    part_of_speech: "danh từ",
    meaning:
      "sự việc được kể lại, nhắc lại, hoặc được nói đến: chuyện lạ có thật * ngồi nghe kể chuyện * không nhắc lại chuyện cũ",
    example:
      "chuyện lạ có thật * ngồi nghe kể chuyện * không nhắc lại chuyện cũ",
  },
  {
    word: "chuyện",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) việc, công việc, nói chung: chuyện chồng con * lo chuyện học hành",
    example: "chuyện chồng con * lo chuyện học hành",
  },
  {
    word: "chuyện",
    part_of_speech: "danh từ",
    meaning:
      "việc lôi thôi, rắc rối: gây chuyện * xảy ra chuyện * chắc là có chuyện nên mới về muộn",
    example: "gây chuyện * xảy ra chuyện * chắc là có chuyện nên mới về muộn",
  },
  {
    word: "chuyện",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) việc nghĩ là đương nhiên, không có gì lạ để cần phảI nói: chuyện, tỉ phú lại chả giàu!",
    example: "chuyện, tỉ phú lại chả giàu!",
  },
  {
    word: "chuyện",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nói chuyện, trò chuyện: chuyện gẫu với nhau cả đêm * đứng chuyện phiếm một lúc rồi bỏ đi",
    example: "chuyện gẫu với nhau cả đêm * đứng chuyện phiếm một lúc rồi bỏ đi",
  },
  {
    word: "chuyển",
    part_of_speech: "động từ",
    meaning:
      "đưa một thứ gì từ nơi này đến nơi khác: chuyển đồ lên gác * chuyển tiền qua đường bưu điện * nhờ chuyển lời cảm ơn",
    example:
      "chuyển đồ lên gác * chuyển tiền qua đường bưu điện * nhờ chuyển lời cảm ơn",
  },
  {
    word: "chuyển",
    part_of_speech: "động từ",
    meaning:
      "thay đổi vị trí, phương hướng, trạng thái, v.v. sang một vị trí, phương hướng, trạng thái khác: chuyển chỗ ở * trời chuyển lạnh * chuyển hướng tấn công",
    example: "chuyển chỗ ở * trời chuyển lạnh * chuyển hướng tấn công",
  },
  {
    word: "chuyển",
    part_of_speech: "động từ",
    meaning:
      "có sự vận động, đổi khác, không còn đứng yên hoặc giữ nguyên trạng thái cũ nữa: tàu từ từ chuyển bánh * dù khó khăn cũng không chuyển lòng * uống đúng thuốc, bệnh đã bắt đầu chuyển",
    example:
      "tàu từ từ chuyển bánh * dù khó khăn cũng không chuyển lòng * uống đúng thuốc, bệnh đã bắt đầu chuyển",
  },
  {
    word: "chuyên án",
    part_of_speech: "danh từ",
    meaning:
      "vụ án lớn và phức tạp, cần có tổ chức chuyên môn riêng để phá án: mở rộng chuyên án * thành lập ban chuyên án",
    example: "mở rộng chuyên án * thành lập ban chuyên án",
  },
  {
    word: "chuyên ban",
    part_of_speech: "",
    meaning:
      "ban riêng về một số môn học hoặc vấn đề nào đó: học sinh chuyên ban * chuyên ban khoa học tự nhiên * hội nghị có bảy chuyên ban",
    example:
      "học sinh chuyên ban * chuyên ban khoa học tự nhiên * hội nghị có bảy chuyên ban",
  },
  {
    word: "chuyển biến",
    part_of_speech: "",
    meaning:
      "biến đổi sang trạng thái khác với trước (thường nói về lĩnh vực tư tưởng, hoạt động của con người, và theo hướng tích cực): bệnh tình chuyển biến tốt * nền kinh tế bắt đầu có những chuyển biến tích cực",
    example:
      "bệnh tình chuyển biến tốt * nền kinh tế bắt đầu có những chuyển biến tích cực",
  },
  {
    word: "chuyên biệt",
    part_of_speech: "tính từ",
    meaning:
      "chỉ riêng cho một loại, một thứ hoặc một yêu cầu nhất định: tác dụng chuyên biệt * trường học chuyên biệt cho trẻ khuyết tật",
    example: "tác dụng chuyên biệt * trường học chuyên biệt cho trẻ khuyết tật",
  },
  {
    word: "chuyển biên",
    part_of_speech: "động từ",
    meaning:
      "soạn lại để chuyển một bản nhạc của nhạc khí này thành bản nhạc của nhạc khí khác: chuyển biên bản nhạc của sáo trúc sang cho đàn bầu",
    example: "chuyển biên bản nhạc của sáo trúc sang cho đàn bầu",
  },
  {
    word: "chuyên canh",
    part_of_speech: "động từ",
    meaning:
      "(vùng đất) trồng chỉ thuần một loại cây nào đó: chuyên canh lúa * vùng chuyên canh cây công nghiệp",
    example: "chuyên canh lúa * vùng chuyên canh cây công nghiệp",
  },
  {
    word: "chuyên cần",
    part_of_speech: "tính từ",
    meaning:
      "rất chăm chỉ, siêng năng một cách đều đặn: lao động chuyên cần * chuyên cần học tập",
    example: "lao động chuyên cần * chuyên cần học tập",
  },
  {
    word: "chuyên chế",
    part_of_speech: "động từ",
    meaning:
      "(vua chúa) nắm toàn bộ quyền lực tối cao, cai trị một cách độc đoán: ách chuyên chế",
    example: "ách chuyên chế",
  },
  {
    word: "chuyên chú",
    part_of_speech: "động từ",
    meaning:
      "tập trung sự chú ý (vào việc gì) một cách bền bỉ: chuyên chú học hành",
    example: "chuyên chú học hành",
  },
  {
    word: "chuyên chở",
    part_of_speech: "động từ",
    meaning:
      "mang chuyển đồ vật, hàng hoá nhiều, nặng đi đường xa (nói khái quát): chuyên chở hàng hoá",
    example: "chuyên chở hàng hoá",
  },
  {
    word: "chuyển dạ",
    part_of_speech: "động từ",
    meaning:
      "có triệu chứng (thường là đau bụng) sắp đẻ: chị ấy chuyển dạ lúc nửa đêm",
    example: "chị ấy chuyển dạ lúc nửa đêm",
  },
  {
    word: "chuyên cơ",
    part_of_speech: "danh từ",
    meaning:
      "máy bay chuyên dùng cho những chuyến bay đặc biệt hoặc chở nhân vật đặc biệt quan trọng: chiếc chuyên cơ chở tổng thống",
    example: "chiếc chuyên cơ chở tổng thống",
  },
  {
    word: "chuyển chú",
    part_of_speech: "động từ",
    meaning:
      "ghi chú để chỉ dẫn người đọc xem ở chỗ khác: cách thức chuyển chú trong từ điển",
    example: "cách thức chuyển chú trong từ điển",
  },
  {
    word: "chuyển dịch",
    part_of_speech: "động từ",
    meaning:
      "thay đổi, hoặc làm thay đổi vị trí trong khoảng ngắn: chuyển dịch đồ đạc trong phòng * vị trí đã bị chuyển dịch",
    example: "chuyển dịch đồ đạc trong phòng * vị trí đã bị chuyển dịch",
  },
  {
    word: "chuyển dịch",
    part_of_speech: "động từ",
    meaning: "thay đổi khác trước: chuyển dịch cơ cấu cây trồng",
    example: "chuyển dịch cơ cấu cây trồng",
  },
  {
    word: "chuyển dịch",
    part_of_speech: "động từ",
    meaning: "(cũ) như chuyển nhượng: chuyển dịch ruộng đất * chuyển dịch vốn",
    example: "chuyển dịch ruộng đất * chuyển dịch vốn",
  },
  {
    word: "chuyên dùng",
    part_of_speech: "tính từ",
    meaning:
      "chỉ để dùng riêng cho những việc, những mục đích nhất định: xe chuyên dùng * các loại máy móc chuyên dùng",
    example: "xe chuyên dùng * các loại máy móc chuyên dùng",
  },
  {
    word: "chuyển động",
    part_of_speech: "động từ",
    meaning:
      "hoặc d thay đổi vị trí theo thời gian: con lắc chuyển động * không khí chuyển động sinh ra gió",
    example: "con lắc chuyển động * không khí chuyển động sinh ra gió",
  },
  {
    word: "chuyển động",
    part_of_speech: "động từ",
    meaning:
      "vận động, hoạt động gây ra rung động, rung chuyển: động cơ chuyển động ầm ầm",
    example: "động cơ chuyển động ầm ầm",
  },
  {
    word: "chuyên doanh",
    part_of_speech: "động từ",
    meaning:
      "chuyên kinh doanh (một mặt hàng hoặc một loại hàng nhất định): công ti chuyên doanh hàng nông sản * cửa hàng chuyên doanh vật liệu xây dựng",
    example:
      "công ti chuyên doanh hàng nông sản * cửa hàng chuyên doanh vật liệu xây dựng",
  },
  {
    word: "chuyển dời",
    part_of_speech: "động từ",
    meaning:
      "thay đổi vị trí, dời hẳn tới chỗ khác: chuyển dời nhà máy ra ngoại thành",
    example: "chuyển dời nhà máy ra ngoại thành",
  },
  {
    word: "chuyên đề",
    part_of_speech: "danh từ",
    meaning:
      "vấn đề chuyên môn (được nghiên cứu hoặc thảo luận): chuyên đề văn học cổ * thảo luận từng chuyên đề",
    example: "chuyên đề văn học cổ * thảo luận từng chuyên đề",
  },
  {
    word: "chuyển đổi",
    part_of_speech: "động từ",
    meaning:
      "đổi từ một loại này sang một loại khác: chuyển đổi ngoại tệ * chuyển đổi chương trình làm việc trên máy tính",
    example:
      "chuyển đổi ngoại tệ * chuyển đổi chương trình làm việc trên máy tính",
  },
  {
    word: "chuyển đổi",
    part_of_speech: "động từ",
    meaning:
      "thay đổi từng bước từ cái này sang cái khác (thường là cho tốt hơn) để không gây xáo trộn lớn: chuyển đổi cơ cấu cây trồng * chuyển đổi loại hình kinh doanh",
    example: "chuyển đổi cơ cấu cây trồng * chuyển đổi loại hình kinh doanh",
  },
  {
    word: "chuyên dụng",
    part_of_speech: "tính từ",
    meaning: "như chuyên dùng: thiết bị chuyên dụng",
    example: "thiết bị chuyên dụng",
  },
  {
    word: "chuyển hướng",
    part_of_speech: "động từ",
    meaning: "đổi hướng: cơn bão đã chuyển hướng * chuyển hướng tấn công",
    example: "cơn bão đã chuyển hướng * chuyển hướng tấn công",
  },
  {
    word: "chuyên gia",
    part_of_speech: "danh từ",
    meaning:
      "người tinh thông một ngành chuyên môn khoa học, kĩ thuật: chuyên gia tin học * mời chuyên gia nước ngoài",
    example: "chuyên gia tin học * mời chuyên gia nước ngoài",
  },
  {
    word: "chuyển giao",
    part_of_speech: "động từ",
    meaning:
      "giao cho người khác nhận: chuyển giao công nghệ * chuyển giao quyền lực",
    example: "chuyển giao công nghệ * chuyển giao quyền lực",
  },
  {
    word: "chuyển khoản",
    part_of_speech: "động từ",
    meaning:
      "chuyển tiền từ tài khoản này sang tài khoản khác qua ngân hàng hoặc qua các trung tâm thanh toán (một hình thức thanh toán không dùng tiền mặt): thanh toán bằng chuyển khoản",
    example: "thanh toán bằng chuyển khoản",
  },
  {
    word: "chuyển lay",
    part_of_speech: "động từ",
    meaning: "(hiếm) như lay chuyển: khó mà chuyển lay được ý chí của ông ấy",
    example: "khó mà chuyển lay được ý chí của ông ấy",
  },
  {
    word: "chuyên khoa",
    part_of_speech: "danh từ",
    meaning:
      "bộ môn (trong khoa học, kĩ thuật): chuyên khoa da liễu * bác sĩ chuyên khoa thần kinh",
    example: "chuyên khoa da liễu * bác sĩ chuyên khoa thần kinh",
  },
  {
    word: "chuyên khảo",
    part_of_speech: "động từ",
    meaning:
      "khảo sát và nghiên cứu riêng về một vấn đề: tập chuyên khảo về chèo cổ",
    example: "tập chuyên khảo về chèo cổ",
  },
  {
    word: "chuyển hoá",
    part_of_speech: "động từ",
    meaning:
      "biến đổi sang dạng hoặc hình thái khác: sự chuyển hoá của năng lượng",
    example: "sự chuyển hoá của năng lượng",
  },
  {
    word: "chuyên môn hoá",
    part_of_speech: "động từ",
    meaning:
      "làm cho trở thành chuyên về một việc, một lĩnh vực nhất định: chuyên môn hoá đội ngũ công nhân",
    example: "chuyên môn hoá đội ngũ công nhân",
  },
  {
    word: "chuyên nghiệp",
    part_of_speech: "tính từ",
    meaning:
      "chuyên về một nghề; phân biệt với nghiệp dư: ca sĩ chuyên nghiệp * nhà phê bình chuyên nghiệp",
    example: "ca sĩ chuyên nghiệp * nhà phê bình chuyên nghiệp",
  },
  {
    word: "chuyên nghiệp",
    part_of_speech: "danh từ",
    meaning:
      "nghề nghiệp chuyên môn: quân nhân chuyên nghiệp * trường trung học chuyên nghiệp",
    example: "quân nhân chuyên nghiệp * trường trung học chuyên nghiệp",
  },
  {
    word: "chuyên môn",
    part_of_speech: "danh từ",
    meaning:
      "học vấn về một ngành khoa học, kĩ thuật: kiến thức chuyên môn * năng lực chuyên môn",
    example: "kiến thức chuyên môn * năng lực chuyên môn",
  },
  {
    word: "chuyên môn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) chuyên làm một việc gì (thường là không hay): chuyên môn đi làm muộn * chuyên môn nói phét",
    example: "chuyên môn đi làm muộn * chuyên môn nói phét",
  },
  {
    word: "chuyển mình",
    part_of_speech: "động từ",
    meaning:
      "chuyển động toàn bộ để bắt đầu có sự vận động, sự thay đổi mạnh mẽ: sự chuyển mình của đất nước sau chiến tranh * nền kinh tế đang chuyển mình",
    example:
      "sự chuyển mình của đất nước sau chiến tranh * nền kinh tế đang chuyển mình",
  },
  {
    word: "chuyên luận",
    part_of_speech: "danh từ",
    meaning:
      "tác phẩm nghiên cứu bàn luận riêng về một vấn đề thuộc lĩnh vực chuyên môn nào đó: viết chuyên luận * chuyên luận về thi hào Nguyễn Du",
    example: "viết chuyên luận * chuyên luận về thi hào Nguyễn Du",
  },
  {
    word: "chuyên mục",
    part_of_speech: "danh từ",
    meaning:
      "mục thường kì trên các phương tiện thông tin đại chúng dành riêng cho một vấn đề: chuyên mục 'Thời trang và văn hoá' của đài truyền hình",
    example: "chuyên mục 'Thời trang và văn hoá' của đài truyền hình",
  },
  {
    word: "chuyên ngành",
    part_of_speech: "danh từ",
    meaning:
      "ngành chuyên môn hẹp: giáo viên chuyên ngành * tốt nghiệp chuyên ngành vật lí hạt nhân",
    example: "giáo viên chuyên ngành * tốt nghiệp chuyên ngành vật lí hạt nhân",
  },
  {
    word: "chuyển ngữ",
    part_of_speech: "danh từ",
    meaning:
      "ngôn ngữ được dùng để truyền thụ kiến thức: dùng tiếng mẹ đẻ làm chuyển ngữ",
    example: "dùng tiếng mẹ đẻ làm chuyển ngữ",
  },
  {
    word: "chuyển ngữ",
    part_of_speech: "động từ",
    meaning: "như chuyển dịch: bài thơ được chuyển ngữ sang tiếng Pháp",
    example: "bài thơ được chuyển ngữ sang tiếng Pháp",
  },
  {
    word: "chuyển nhượng",
    part_of_speech: "động từ",
    meaning:
      "nhượng lại cho người khác (cái thuộc quyền sở hữu của mình hoặc quyền lợi mình đang được hưởng): chuyển nhượng quyền sử dụng đất * chuyển nhượng cửa hàng",
    example: "chuyển nhượng quyền sử dụng đất * chuyển nhượng cửa hàng",
  },
  {
    word: "chuyên sử",
    part_of_speech: "danh từ",
    meaning:
      "sử chuyên nghiên cứu về một nhân vật, một sự kiện, một thời kì hay một địa phương nhất định: bộ chuyên sử về triều đại nhà Lý",
    example: "bộ chuyên sử về triều đại nhà Lý",
  },
  {
    word: "chuyển phát",
    part_of_speech: "động từ",
    meaning:
      "chuyển thông tin, thư tín, bưu kiện, v.v. tới người nhận: dịch vụ chuyển phát thư tín của bưu điện * thư chuyển phát nhanh",
    example: "dịch vụ chuyển phát thư tín của bưu điện * thư chuyển phát nhanh",
  },
  {
    word: "chuyên quyền",
    part_of_speech: "động từ",
    meaning:
      "nắm toàn bộ quyền hành và tự ý quyết định mọi việc: chuyên quyền cậy thế",
    example: "chuyên quyền cậy thế",
  },
  {
    word: "chuyển tải",
    part_of_speech: "động từ",
    meaning:
      "chuyển hành khách hoặc hàng hoá từ phương tiện vận tải này sang phương tiện vận tải khác, hoặc từ đoạn đường này qua đoạn đường khác: phương tiện chuyển tải hành khách * chuyển tải hàng hoá",
    example: "phương tiện chuyển tải hành khách * chuyển tải hàng hoá",
  },
  {
    word: "chuyển tải",
    part_of_speech: "động từ",
    meaning:
      "chuyển đến, đem đến một nơi khác hoặc đối tượng khác: khả năng chuyển tải của lưới điện * bài báo ngắn, nhưng vẫn chuyển tải đầy đủ thông tin",
    example:
      "khả năng chuyển tải của lưới điện * bài báo ngắn, nhưng vẫn chuyển tải đầy đủ thông tin",
  },
  {
    word: "chuyên tâm",
    part_of_speech: "động từ",
    meaning:
      "tập trung tâm trí một cách bền bỉ (vào việc gì): chuyên tâm nghiên cứu văn học * chuyên tâm với nghề",
    example: "chuyên tâm nghiên cứu văn học * chuyên tâm với nghề",
  },
  {
    word: "chuyên sâu",
    part_of_speech: "tính từ",
    meaning:
      "(học tập, nghiên cứu) sâu vào một vấn đề, một lĩnh vực chuyên môn nào đó: đào tạo chuyên sâu * cán bộ chuyên sâu trong lĩnh vực kinh tế",
    example: "đào tạo chuyên sâu * cán bộ chuyên sâu trong lĩnh vực kinh tế",
  },
  {
    word: "chuyên san",
    part_of_speech: "danh từ",
    meaning:
      "tạp chí (hoặc số đặc biệt của tạp chí) chuyên đăng những bài có nội dung thuộc một lĩnh vực nhất định: chuyên san kinh tế * chuyên san toán học",
    example: "chuyên san kinh tế * chuyên san toán học",
  },
  {
    word: "chuyển thể",
    part_of_speech: "động từ",
    meaning:
      "chuyển tác phẩm văn học thành kịch bản sân khấu hoặc điện ảnh: bộ phim được chuyển thể từ một truyện ngắn cùng tên",
    example: "bộ phim được chuyển thể từ một truyện ngắn cùng tên",
  },
  {
    word: "chuyển tiếp",
    part_of_speech: "động từ",
    meaning:
      "nối đoạn trước với đoạn tiếp theo cho liền mạch: câu chuyển tiếp trong bài văn * thời kì chuyển tiếp",
    example: "câu chuyển tiếp trong bài văn * thời kì chuyển tiếp",
  },
  {
    word: "chuyên trang",
    part_of_speech: "danh từ",
    meaning:
      "trang báo có nội dung chuyên phản ánh hoặc bàn luận về một vấn đề: chuyên trang văn nghệ",
    example: "chuyên trang văn nghệ",
  },
  {
    word: "chuyên trách",
    part_of_speech: "động từ",
    meaning:
      "chuyên làm và chịu trách nhiệm về một công tác nào đó: cán bộ chuyên trách",
    example: "cán bộ chuyên trách",
  },
  {
    word: "chuyện trò",
    part_of_speech: "động từ",
    meaning:
      "nói chuyện thân mật với nhau: ngồi chuyện trò với nhau * vừa đi vừa chuyện trò",
    example: "ngồi chuyện trò với nhau * vừa đi vừa chuyện trò",
  },
  {
    word: "chữ",
    part_of_speech: "danh từ",
    meaning:
      "hệ thống kí hiệu bằng đường nét đặt ra để ghi tiếng nói: chữ quốc ngữ * học chữ Hán * chữ T * viết chữ thường",
    example: "chữ quốc ngữ * học chữ Hán * chữ T * viết chữ thường",
  },
  {
    word: "chữ",
    part_of_speech: "danh từ",
    meaning:
      "lối viết chữ, nét chữ riêng của mỗi người: chữ viết rất đẹp * chữ như gà bới (chữ rất xấu) * câu đối viết bằng chữ thảo",
    example:
      "chữ viết rất đẹp * chữ như gà bới (chữ rất xấu) * câu đối viết bằng chữ thảo",
  },
  {
    word: "chữ",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi thông thường của tiếng hoặc từ trong tiếng Việt: lá cờ thêu sáu chữ vàng * một chữ bẻ đôi cũng không biết (rất dốt, không biết chữ nào)",
    example:
      "lá cờ thêu sáu chữ vàng * một chữ bẻ đôi cũng không biết (rất dốt, không biết chữ nào)",
  },
  {
    word: "chữ",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi thông thường của từ ngữ gốc Hán: tật sính dùng chữ * dốt mà hay nói chữ",
    example: "tật sính dùng chữ * dốt mà hay nói chữ",
  },
  {
    word: "chữ",
    part_of_speech: "danh từ",
    meaning:
      'kiến thức văn hoá, chữ nghĩa học được (nói khái quát): chữ thầy trả thầy * "Muốn sang thì bắc cầu kiều, Muốn con hay chữ phải yêu lấy thầy." (Cdao)',
    example:
      'chữ thầy trả thầy * "Muốn sang thì bắc cầu kiều, Muốn con hay chữ phải yêu lấy thầy." (Cdao)',
  },
  {
    word: "chữ",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để cụ thể hoá nội dung một khái niệm trừu tượng (như đạo đức, tinh thần, tâm lí, v.v.) đã được xác định: ở đời mấy ai học được chữ ngờ * giữ tròn chữ hiếu",
    example: "ở đời mấy ai học được chữ ngờ * giữ tròn chữ hiếu",
  },
  {
    word: "chữ",
    part_of_speech: "danh từ",
    meaning:
      "(Từ cũ, Văn chương) lời từ xưa truyền lại (thường dùng khi dẫn những câu sách tiếng Hán): sách có chữ: bán anh em xa, mua láng giềng gần",
    example: "sách có chữ: bán anh em xa, mua láng giềng gần",
  },
  {
    word: "chữ",
    part_of_speech: "danh từ",
    meaning:
      "(Từ cũ) đồng tiền đúc ngày xưa: một đồng một chữ cũng không có (rất nghèo)",
    example: "một đồng một chữ cũng không có (rất nghèo)",
  },
  {
    word: "chuyên trị",
    part_of_speech: "động từ",
    meaning:
      "(thuốc) chuyên chữa một loại bệnh: thuốc chuyên trị bệnh ngoài da",
    example: "thuốc chuyên trị bệnh ngoài da",
  },
  {
    word: "chuyên trị",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) chuyên, thường xuyên (làm việc gì đó, thường là không hay): chuyên trị bị điểm kém * chuyên trị nói ngọng",
    example: "chuyên trị bị điểm kém * chuyên trị nói ngọng",
  },
  {
    word: "chuyển tự",
    part_of_speech: "động từ",
    meaning:
      "chuyển cách viết từ ngữ bằng một hệ thống chữ cái này thành cách viết bằng một hệ thống chữ cái khác, theo quy tắc tương ứng giữa hai hệ thống chữ cái: phiên âm theo lối chuyển tự",
    example: "phiên âm theo lối chuyển tự",
  },
  {
    word: "chuyên viên",
    part_of_speech: "danh từ",
    meaning:
      "người có trình độ thành thạo về một lĩnh vực chuyên môn: chuyên viên kinh tế",
    example: "chuyên viên kinh tế",
  },
  {
    word: "chuyên viên",
    part_of_speech: "danh từ",
    meaning:
      "cán bộ có trình độ nghiệp vụ chuyên môn cao, chuyên làm công tác nghiên cứu giúp cho lãnh đạo ở một cơ quan quản lí: chuyên viên cấp cao của bộ Ngoại giao",
    example: "chuyên viên cấp cao của bộ Ngoại giao",
  },
  {
    word: "chuyển vận",
    part_of_speech: "động từ",
    meaning:
      "vận hành tuần hoàn: sự chuyển vận của Trái Đất xung quanh Mặt Trời",
    example: "sự chuyển vận của Trái Đất xung quanh Mặt Trời",
  },
  {
    word: "chuyển vận",
    part_of_speech: "động từ",
    meaning: "vận động tự chuyển dời: sức chuyển vận của dòng nước",
    example: "sức chuyển vận của dòng nước",
  },
  {
    word: "chuyển vận",
    part_of_speech: "động từ",
    meaning: "(hiếm) như vận chuyển: chuyển vận vũ khí",
    example: "chuyển vận vũ khí",
  },
  {
    word: "chuyện vãn",
    part_of_speech: "động từ",
    meaning:
      "nói chuyện vui, cốt để cho qua thì giờ: chuyện vãn với nhau cả buổi tối",
    example: "chuyện vãn với nhau cả buổi tối",
  },
  {
    word: "chuyên tu",
    part_of_speech: "động từ",
    meaning:
      "chỉ chuyên học về một hoặc một số môn trong thời gian rút ngắn: học chuyên tu * lớp chuyên tu tin học",
    example: "học chuyên tu * lớp chuyên tu tin học",
  },
  {
    word: "chuyển vần",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) vận động xoay chuyển theo lối tuần hoàn; thường dùng trong văn học cổ để ví sự đổi thay của tự nhiên và cuộc đời: trời đất chuyển vần * thế sự chuyển vần",
    example: "trời đất chuyển vần * thế sự chuyển vần",
  },
  {
    word: "chư",
    part_of_speech: "",
    meaning:
      "yếu tố gốc Hán ghép trước một số danh từ gốc Hán chỉ người, có nghĩa các, dùng để xưng gọi một cách trang trọng: xin cảm ơn chư vị * xin chư huynh thứ lỗi",
    example: "xin cảm ơn chư vị * xin chư huynh thứ lỗi",
  },
  {
    word: "chữ bát",
    part_of_speech: "danh từ",
    meaning:
      "chữ 八 trong tiếng Hán; dùng để tả kiểu đi hai bàn chân xoạc ra hai bên: chân đi chữ bát",
    example: "chân đi chữ bát",
  },
  {
    word: "chừ",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) giờ, bây giờ: từ sáng tới chừ * đi mô chừ?",
    example: "từ sáng tới chừ * đi mô chừ?",
  },
  {
    word: "chữ điền",
    part_of_speech: "danh từ",
    meaning:
      "chữ 田 trong tiếng Hán, dùng để tả hình dáng vuông vức (thường của khuôn mặt): mặt vuông chữ điền",
    example: "mặt vuông chữ điền",
  },
  {
    word: "chừ bự",
    part_of_speech: "tính từ",
    meaning:
      '(phương ngữ) (vẻ mặt) có vẻ như sưng to lên vì giận, dỗi (hàm ý chê): "Thằng Lý quạu quọ, mặt chừ bự như cái mâm (...)" (TrHLong; 1)',
    example: 'Thằng Lý quạu quọ, mặt chừ bự như cái mâm (...)" (TrHLong; 1)',
  },
  {
    word: "chữ cái",
    part_of_speech: "danh từ",
    meaning:
      "kí hiệu dùng để ghi âm vị trong chữ viết ghi âm: học thuộc các chữ cái * chữ cái tiếng Việt",
    example: "học thuộc các chữ cái * chữ cái tiếng Việt",
  },
  {
    word: "chữ cái",
    part_of_speech: "danh từ",
    meaning: "bảng chữ cái (nói tắt): chữ quốc ngữ dùng chữ cái Latin",
    example: "chữ quốc ngữ dùng chữ cái Latin",
  },
  {
    word: "chữ chi",
    part_of_speech: "danh từ",
    meaning:
      "chữ 之 trong tiếng Hán; dùng để tả đường nét gấp khúc: đường chữ chi",
    example: "đường chữ chi",
  },
  {
    word: "chứ",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là cái ý phủ định, ngược lại với điều vừa nói đến, và cũng để nhằm bổ sung, khẳng định thêm cho điều muốn nói: nhớ chứ quên thế nào được * thà chết chứ không chịu khai",
    example: "nhớ chứ quên thế nào được * thà chết chứ không chịu khai",
  },
  {
    word: "chứ",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý ít nhiều đã khẳng định về điều nêu ra để hỏi, tựa như chỉ là để xác định thêm: anh chưa ngủ đấy chứ? * cậu biết anh ta chứ? * anh đồng ý chứ?",
    example: "anh chưa ngủ đấy chứ? * cậu biết anh ta chứ? * anh đồng ý chứ?",
  },
  {
    word: "chứ",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý nhấn mạnh thêm điều vừa khẳng định hoặc yêu cầu, cho là không có khả năng ngược lại: nói khẽ chứ! * cũng vui đấy chứ! * nói vừa vừa chứ!",
    example: "nói khẽ chứ! * cũng vui đấy chứ! * nói vừa vừa chứ!",
  },
  {
    word: "chữ kí",
    part_of_speech: "danh từ",
    meaning:
      "chữ viết nhanh dưới một dạng đặc biệt (không giống chữ thông thường), dùng làm kí hiệu cho tên của mình và thường không thay đổi, mỗi người tự viết lấy để xác nhận tính chính xác của một văn bản hoặc để nhận trách nhiệm của mình về một văn bản: giả mạo chữ kí * xin chữ kí",
    example: "giả mạo chữ kí * xin chữ kí",
  },
  {
    word: "chư hầu",
    part_of_speech: "danh từ",
    meaning:
      "(Từ cũ) chúa phong kiến (ở Trung Quốc thời cổ đại) bị phụ thuộc, phải phục tùng một chúa phong kiến lớn, mạnh hơn, trong quan hệ với chúa phong kiến ấy.",
    example: "các nước chư hầu",
  },
  {
    word: "chứ lại",
    part_of_speech: "trợ từ",
    meaning: "như chứ lị: thế chứ lại! * đẹp hơn chứ lại!",
    example: "thế chứ lại! * đẹp hơn chứ lại!",
  },
  {
    word: "chứ lị",
    part_of_speech: "trợ từ",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị ý nhấn mạnh thêm điều vừa khẳng định, cho là không thể có ý kiến nào khác: có thế chứ lị! * vui chứ lị! * hơn đứt đi chứ lị!",
    example: "có thế chứ lị! * vui chứ lị! * hơn đứt đi chứ lị!",
  },
  {
    word: "chữ ký",
    part_of_speech: "danh từ",
    meaning:
      "chữ viết nhanh dưới một dạng đặc biệt (không giống chữ thông thường), dùng làm kí hiệu cho tên của mình và thường không thay đổi, mỗi người tự viết lấy để xác nhận tính chính xác của một văn bản hoặc để nhận trách nhiệm của mình về một văn bản: giả mạo chữ kí * xin chữ kí",
    example: "giả mạo chữ kí * xin chữ kí",
  },
  {
    word: "chữ nghĩa",
    part_of_speech: "danh từ",
    meaning:
      "từ ngữ và nghĩa của từ ngữ (nói khái quát): chữ nghĩa rối rắm khó hiểu * dùng sai chữ nghĩa",
    example: "chữ nghĩa rối rắm khó hiểu * dùng sai chữ nghĩa",
  },
  {
    word: "chữ nghĩa",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) vốn học thức (nói khái quát): con người có chữ nghĩa * chữ nghĩa kém cỏi",
    example: "con người có chữ nghĩa * chữ nghĩa kém cỏi",
  },
  {
    word: "chữ nhân",
    part_of_speech: "danh từ",
    meaning:
      "chữ G trong tiếng Hán; dùng để tả cái có đường nét, hình dáng giống như chữ ấy: đầu chít khăn chữ nhân",
    example: "đầu chít khăn chữ nhân",
  },
  {
    word: "chữ nho",
    part_of_speech: "danh từ",
    meaning:
      "chữ Hán, theo cách gọi thông thường của người Việt Nam thời trước: học chữ nho * biết dăm ba chữ nho * thầy đồ dạy chữ nho",
    example: "học chữ nho * biết dăm ba chữ nho * thầy đồ dạy chữ nho",
  },
  {
    word: "chữ nôm",
    part_of_speech: "danh từ",
    meaning:
      "chữ viết cổ của tiếng Việt, dựa vào chữ Hán mà đặt ra: nền văn học chữ Nôm",
    example: "nền văn học chữ Nôm",
  },
  {
    word: "chữ nổi",
    part_of_speech: "danh từ",
    meaning:
      "hệ thống chữ viết đặc biệt, dành riêng cho người mù, gồm những chấm nổi trên mặt giấy, có thể sờ để nhận biết được: sách chữ nổi * lớp dạy chữ nổi cho người khiếm thị",
    example: "sách chữ nổi * lớp dạy chữ nổi cho người khiếm thị",
  },
  {
    word: "chữ quốc ngữ",
    part_of_speech: "danh từ",
    meaning:
      "chữ viết ghi âm của tiếng Việt, được tạo ra trên cơ sở hệ chữ cái Latin: học chữ quốc ngữ * sách báo viết bằng chữ quốc ngữ",
    example: "học chữ quốc ngữ * sách báo viết bằng chữ quốc ngữ",
  },
  {
    word: "chữ số",
    part_of_speech: "danh từ",
    meaning:
      "kí hiệu cơ bản dùng để viết các số: tìm số có hai chữ số chia hết cho 5",
    example: "tìm số có hai chữ số chia hết cho 5",
  },
  {
    word: "chữ thập đỏ",
    part_of_speech: "danh từ",
    meaning:
      "dấu chữ thập màu đỏ trên nền trắng, dùng làm dấu hiệu riêng của tổ chức cứu thương: xe chữ thập đỏ * hội chữ thập đỏ",
    example: "xe chữ thập đỏ * hội chữ thập đỏ",
  },
  {
    word: "chữ thập",
    part_of_speech: "danh từ",
    meaning:
      "chữ 十 trong tiếng Hán; dùng để tả cái có hình hai đường cắt nhau vuông góc, trông giống như chữ ấy: buộc chéo hình chữ thập",
    example: "buộc chéo hình chữ thập",
  },
  {
    word: "chữ viết",
    part_of_speech: "danh từ",
    meaning:
      "như chữ: xây dựng chữ viết cho các dân tộc thiểu số * hệ thống chữ viết tiếng Việt",
    example:
      "xây dựng chữ viết cho các dân tộc thiểu số * hệ thống chữ viết tiếng Việt",
  },
  {
    word: "chư vị",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, trang trọng) từ dùng để xưng gọi chung tất cả những người đến dự cuộc họp; các vị: mời chư vị an toạ",
    example: "mời chư vị an toạ",
  },
  {
    word: "chư vị",
    part_of_speech: "danh từ",
    meaning: "các vị thần về Đạo giáo: thờ chư vị",
    example: "thờ chư vị",
  },
  {
    word: "chứa",
    part_of_speech: "động từ",
    meaning:
      "giữ, tích ở bên trong: kho chứa thóc * mỏ chứa dầu * câu chuyện chứa đầy mâu thuẫn",
    example: "kho chứa thóc * mỏ chứa dầu * câu chuyện chứa đầy mâu thuẫn",
  },
  {
    word: "chứa",
    part_of_speech: "động từ",
    meaning:
      'cất giấu hoặc để cho ở trong nhà một cách bất hợp pháp: chứa hàng lậu * chứa gái mại dâm * "Trăng rằng trăng chẳng nguyệt hoa, Sao trăng chứa Cuội trong nhà hỡi trăng?" (ca dao)',
    example:
      'chứa hàng lậu * chứa gái mại dâm * "Trăng rằng trăng chẳng nguyệt hoa, Sao trăng chứa Cuội trong nhà hỡi trăng?" (ca dao)',
  },
  {
    word: "chữ tòng",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) nguyên tắc của lễ giáo phong kiến bắt người phụ nữ khi đã lấy chồng thì phải theo chồng, hoàn toàn phục tùng chồng (xuất giá tòng phu): "Nàng rằng: Phận gái chữ tòng, Chàng đi, thiếp cũng quyết lòng xin đi." (TKiều)',
    example:
      'Nàng rằng: Phận gái chữ tòng, Chàng đi, thiếp cũng quyết lòng xin đi." (TKiều)',
  },
  {
    word: "chữa",
    part_of_speech: "động từ",
    meaning:
      "làm cho khỏi bệnh hoặc hết hư hỏng: phòng bệnh hơn chữa bệnh * thợ chữa xe máy",
    example: "phòng bệnh hơn chữa bệnh * thợ chữa xe máy",
  },
  {
    word: "chữa",
    part_of_speech: "động từ",
    meaning:
      "thêm bớt, sửa đổi hoặc điều chỉnh chút ít cho trở thành thích hợp với yêu cầu: chữa áo dài thành áo cánh * lỡ lời, vội nói chữa",
    example: "chữa áo dài thành áo cánh * lỡ lời, vội nói chữa",
  },
  {
    word: "chưa",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị ý phủ định điều được nói đến là không có hoặc không xảy ra cho đến hiện tại hoặc đến một thời điểm nào đó được xem là mốc, trong quá khứ hoặc tương lai (nhưng sau đó có thể xảy ra): trời chưa sáng * chưa biết ai đúng ai sai * trong nhà chưa tỏ, ngoài ngõ đã tường (tng)",
    example:
      "trời chưa sáng * chưa biết ai đúng ai sai * trong nhà chưa tỏ, ngoài ngõ đã tường (tng)",
  },
  {
    word: "chưa",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị ý muốn hỏi về điều mà cho đến một thời điểm được xác định nào đó không biết có xảy ra hay không: tìm thấy nó chưa? * việc ấy xảy ra đã lâu chưa?",
    example: "tìm thấy nó chưa? * việc ấy xảy ra đã lâu chưa?",
  },
  {
    word: "chưa",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) từ biểu thị ý khẳng định về một điều mà người nói cho là đã có biểu hiện hay tác động rõ ràng, và nêu ra như muốn hỏi lại để được sự đồng tình, đồng ý của người nghe: khổ thân chưa! * rõ đẹp mặt chưa! * thấy chưa, tôi nói có sai đâu!",
    example:
      "khổ thân chưa! * rõ đẹp mặt chưa! * thấy chưa, tôi nói có sai đâu!",
  },
  {
    word: "chưa biết chừng",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) như không biết chừng (nhưng thường chỉ nói về sự việc có thể sẽ xảy ra): chưa biết chừng vì buồn mà sinh bệnh",
    example: "chưa biết chừng vì buồn mà sinh bệnh",
  },
  {
    word: "chứa chan",
    part_of_speech: "",
    meaning: "có nhiều, chứa đầy đến mức tràn ra: nước mắt chứa chan",
    example: "nước mắt chứa chan",
  },
  {
    word: "chứa chan",
    part_of_speech: "",
    meaning:
      "(tình cảm) tràn đầy và sâu đậm: bài thơ chứa chan tình quê hương * trong lòng chứa chan hi vọng",
    example: "bài thơ chứa chan tình quê hương * trong lòng chứa chan hi vọng",
  },
  {
    word: "chừa",
    part_of_speech: "động từ",
    meaning:
      "bớt lại, dành riêng ra một phần nào đó cho việc khác: viết phải chừa lề * chừa một khoảng trống để lấy lối đi",
    example: "viết phải chừa lề * chừa một khoảng trống để lấy lối đi",
  },
  {
    word: "chừa",
    part_of_speech: "động từ",
    meaning:
      '(khẩu ngữ) trừ ra, không động chạm đến, vì kiêng nể hoặc khinh ghét: chửi tất, không chừa một ai * chừa cái mặt nó ra! * "Rằng: Hồng nhan tự thuở xưa, Cái điều bạc mệnh có chừa ai đâu." (TKiều)',
    example:
      'chửi tất, không chừa một ai * chừa cái mặt nó ra! * "Rằng: Hồng nhan tự thuở xưa, Cái điều bạc mệnh có chừa ai đâu." (TKiều)',
  },
  {
    word: "chừa",
    part_of_speech: "động từ",
    meaning:
      "bỏ hẳn không tiếp tục nữa, vì biết là không hay hoặc có hại: chừa cái tật nói leo * đánh chết cái nết không chừa (tng)",
    example: "chừa cái tật nói leo * đánh chết cái nết không chừa (tng)",
  },
  {
    word: "chửa",
    part_of_speech: "động từ",
    meaning:
      "(phụ nữ hoặc một số động vật giống cái) có thai hoặc bọc trứng ở trong bụng: bụng mang dạ chửa * trâu chửa",
    example: "bụng mang dạ chửa * trâu chửa",
  },
  {
    word: "chửa",
    part_of_speech: "phụ từ",
    meaning:
      '(Khẩu ngữ) như chưa: "Ngày đi em chửa có chồng, Ngày về em đã tay bồng tay mang." (Cdao)',
    example:
      'Ngày đi em chửa có chồng, Ngày về em đã tay bồng tay mang." (Cdao)',
  },
  {
    word: "chứa chấp",
    part_of_speech: "động từ",
    meaning:
      "chứa một cách trái phép (nói khái quát): chứa chấp kẻ gian * chứa chấp cờ bạc",
    example: "chứa chấp kẻ gian * chứa chấp cờ bạc",
  },
  {
    word: "chứa đựng",
    part_of_speech: "động từ",
    meaning:
      "có giữ ở bên trong: trong túi chứa đựng đủ thứ linh tinh * câu nói chứa đựng một uẩn khúc",
    example:
      "trong túi chứa đựng đủ thứ linh tinh * câu nói chứa đựng một uẩn khúc",
  },
  {
    word: "chữa cháy",
    part_of_speech: "động từ",
    meaning: "dập tắt lửa của đám cháy để ngăn hoả hoạn: xe chữa cháy",
    example: "xe chữa cháy",
  },
  {
    word: "chữa cháy",
    part_of_speech: "động từ",
    meaning:
      "giải quyết việc cấp bách, cốt để tạm thời đối phó, chưa giải quyết vấn đề một cách căn bản: trót làm sai nên phải tìm cách chữa cháy",
    example: "trót làm sai nên phải tìm cách chữa cháy",
  },
  {
    word: "chưa chừng",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) như chưa biết chừng (nhưng sắc thái khẩu ngữ mạnh hơn): chưa chừng nó làm được cũng nên",
    example: "chưa chừng nó làm được cũng nên",
  },
  {
    word: "chứa chất",
    part_of_speech: "động từ",
    meaning:
      'chứa đựng nhiều và tích lại đã lâu: cái nhìn chứa chất căm hờn * "Ai đi muôn dặm non sông, Để ai chứa chất sầu đong vơi đầy." (ca dao)',
    example:
      'cái nhìn chứa chất căm hờn * "Ai đi muôn dặm non sông, Để ai chứa chất sầu đong vơi đầy." (ca dao)',
  },
  {
    word: "chữa trị",
    part_of_speech: "động từ",
    meaning:
      "chữa và điều trị bệnh (nói khái quát): đưa người ốm đến bệnh viện chữa trị",
    example: "đưa người ốm đến bệnh viện chữa trị",
  },
  {
    word: "chữa thẹn",
    part_of_speech: "động từ",
    meaning:
      "làm cho mình đỡ thẹn vì đã có lời nói hoặc hành vi đáng xấu hổ: cười chữa thẹn * nói một câu để chữa thẹn",
    example: "cười chữa thẹn * nói một câu để chữa thẹn",
  },
  {
    word: "chức",
    part_of_speech: "danh từ",
    meaning:
      "danh vị thể hiện cấp bậc, quyền hạn và trách nhiệm của một người trong hệ thống tổ chức của nhà nước hay đoàn thể: thăng quan tiến chức * giữ chức giám đốc",
    example: "thăng quan tiến chức * giữ chức giám đốc",
  },
  {
    word: "chức",
    part_of_speech: "danh từ",
    meaning:
      "đặc tính hoá học của một chất do một nhóm nguyên tố trong đó gây nên: chức acid * chức rượu",
    example: "chức acid * chức rượu",
  },
  {
    word: "chức danh",
    part_of_speech: "danh từ",
    meaning:
      "chức trên danh nghĩa, không có nhiệm vụ quản lí: chức danh phó giáo sư",
    example: "chức danh phó giáo sư",
  },
  {
    word: "chức dịch",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người có chức vị trong bộ máy chính quyền ở làng và tổng thời trước (nói tổng quát): bọn chức dịch trong làng",
    example: "bọn chức dịch trong làng",
  },
  {
    word: "chức sắc",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người có chức vị và phẩm hàm ở nông thôn thời trước: các chức sắc trong làng * kẻ chức sắc",
    example: "các chức sắc trong làng * kẻ chức sắc",
  },
  {
    word: "chức sắc",
    part_of_speech: "danh từ",
    meaning: "người có chức vị trong một số tôn giáo: các tín đồ và chức sắc",
    example: "các tín đồ và chức sắc",
  },
  {
    word: "chức sắc",
    part_of_speech: "danh từ",
    meaning:
      "quyền chức và địa vị (nói khái quát): không có chức sắc gì * giới chức sắc trong thành phố",
    example: "không có chức sắc gì * giới chức sắc trong thành phố",
  },
  {
    word: "chức nữ",
    part_of_speech: "danh từ",
    meaning:
      'tên một vì sao rất sáng ở phía bắc dải Ngân Hà; cũng là tên một nhân vật trong thần thoại Trung Quốc: chòm sao Chức Nữ * "Hữu tình chi bấy Ngưu lang, Tấm lòng Chức Nữ vì chàng mà nghiêng." (LVT)',
    example:
      'chòm sao Chức Nữ * "Hữu tình chi bấy Ngưu lang, Tấm lòng Chức Nữ vì chàng mà nghiêng." (LVT)',
  },
  {
    word: "chức quyền",
    part_of_speech: "danh từ",
    meaning: "quyền lực trong phạm vi chức vụ: lợi dụng chức quyền để trục lợi",
    example: "lợi dụng chức quyền để trục lợi",
  },
  {
    word: "chức năng",
    part_of_speech: "danh từ",
    meaning:
      "hoạt động, tác dụng bình thường hoặc đặc trưng của một cơ quan, một hệ cơ quan nào đó trong cơ thể: tổn thương chức năng gan * chức năng của da là bảo vệ cơ thể",
    example: "tổn thương chức năng gan * chức năng của da là bảo vệ cơ thể",
  },
  {
    word: "chức năng",
    part_of_speech: "danh từ",
    meaning:
      "vai trò hoặc đặc trưng của một người nào đó, một cái gì đó: chức năng của người mẹ * cơ quan chức năng",
    example: "chức năng của người mẹ * cơ quan chức năng",
  },
  {
    word: "chức phận",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) bổn phận phải làm tròn theo chức vụ của mình: làm đúng chức phận",
    example: "làm đúng chức phận",
  },
  {
    word: "chức phận",
    part_of_speech: "danh từ",
    meaning: "như chức vụ: một người có chức phận",
    example: "một người có chức phận",
  },
  {
    word: "chực",
    part_of_speech: "động từ",
    meaning:
      'chờ sẵn, đợi sẵn để có thể làm ngay việc gì đó: chực ở cửa hàng đợi mua * "Tú bà chực sẵn bên màn, Lựa lời khuyên giải mơn man gỡ dần." (TKiều)',
    example:
      'chực ở cửa hàng đợi mua * "Tú bà chực sẵn bên màn, Lựa lời khuyên giải mơn man gỡ dần." (TKiều)',
  },
  {
    word: "chực",
    part_of_speech: "động từ",
    meaning:
      "ở vào thế sắp xảy ra, chỉ cần một tác động nhỏ là có thể xảy ra ngay việc nói đến: quay người chực bỏ chạy * mấy lần chực nói rồi lại thôi",
    example: "quay người chực bỏ chạy * mấy lần chực nói rồi lại thôi",
  },
  {
    word: "chực",
    part_of_speech: "động từ",
    meaning: "(ăn uống) nhờ vào phần của người khác: ăn chực cơm * bú chực",
    example: "ăn chực cơm * bú chực",
  },
  {
    word: "chức trách",
    part_of_speech: "danh từ",
    meaning:
      "trách nhiệm trong phạm vi chức vụ hay nhiệm vụ: chức trách của giám đốc * không làm tròn chức trách",
    example: "chức trách của giám đốc * không làm tròn chức trách",
  },
  {
    word: "chức tước",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) chức và tước, những danh vị thời phong kiến (nói khái quát): phong chức tước * có chức tước",
    example: "phong chức tước * có chức tước",
  },
  {
    word: "chực tiết",
    part_of_speech: "động từ",
    meaning:
      '(cũ, hiếm) như thủ tiết: "Gió đưa cây trúc ngã quỳ, Ba năm chực tiết còn gì là xuân." (ca dao)',
    example:
      'Gió đưa cây trúc ngã quỳ, Ba năm chực tiết còn gì là xuân." (ca dao)',
  },
  {
    word: "chức vị",
    part_of_speech: "danh từ",
    meaning:
      "địa vị tương ứng với chức: chức vị tổng thống * giữ một chức vị cao trong tổ chức",
    example: "chức vị tổng thống * giữ một chức vị cao trong tổ chức",
  },
  {
    word: "chửi bới",
    part_of_speech: "động từ",
    meaning:
      "chửi to tiếng bằng những lời moi móc xúc phạm một cách quá đáng (nói khái quát): chửi bới nhau om sòm",
    example: "chửi bới nhau om sòm",
  },
  {
    word: "chức vụ",
    part_of_speech: "danh từ",
    meaning:
      "nhiệm vụ và quyền hạn tương ứng với chức: thừa hành chức vụ * giữ chức vụ cố vấn chính phủ",
    example: "thừa hành chức vụ * giữ chức vụ cố vấn chính phủ",
  },
  {
    word: "chửi",
    part_of_speech: "động từ",
    meaning:
      "thốt ra những lời lẽ thô tục, cay độc để xúc phạm, làm nhục người khác: chửi cha không bằng pha tiếng (tng)",
    example: "chửi cha không bằng pha tiếng (tng)",
  },
  {
    word: "chửi rủa",
    part_of_speech: "động từ",
    meaning:
      "chửi và nguyền rủa (nói khái quát): chửi rủa thậm tệ * luôn mồm chửi rủa",
    example: "chửi rủa thậm tệ * luôn mồm chửi rủa",
  },
  {
    word: "chững",
    part_of_speech: "động từ",
    meaning:
      "ngừng lại giữa chừng một cách đột ngột: đang đi bỗng chững lại * hàng hoá dạo này bán có vẻ chững",
    example: "đang đi bỗng chững lại * hàng hoá dạo này bán có vẻ chững",
  },
  {
    word: "chững",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) (trẻ con mới tập đứng) đứng chưa vững: cháu bé mới biết chững",
    example: "cháu bé mới biết chững",
  },
  {
    word: "chững",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) chững chạc (nói tắt): ăn mặc rất chững",
    example: "ăn mặc rất chững",
  },
  {
    word: "chừng",
    part_of_speech: "danh từ",
    meaning:
      "mức, hạn được xác định tương đối, đại kháI: chi tiêu có chừng * chừng hai giờ sáng ~người cao chừng mét bảy",
    example: "chi tiêu có chừng * chừng hai giờ sáng ~người cao chừng mét bảy",
  },
  {
    word: "chừng",
    part_of_speech: "danh từ",
    meaning:
      "quãng đường hoặc khoảng thời gian được xác định đại kháI: im lặng chừng một phút * đứa bé chừng 5, 6 tuổi",
    example: "im lặng chừng một phút * đứa bé chừng 5, 6 tuổi",
  },
  {
    word: "chừng",
    part_of_speech: "phụ từ",
    meaning:
      '(tình hình sự việc nào đó) có vẻ như sắp xảy ra: "Cụ hâm rượu nữa đi thôi, Be này chừng sắp cạn rồi còn đâu!" (TrHTrân; 2)',
    example:
      'Cụ hâm rượu nữa đi thôi, Be này chừng sắp cạn rồi còn đâu!" (TrHTrân; 2)',
  },
  {
    word: "chửi mắng",
    part_of_speech: "động từ",
    meaning:
      "chửi và mắng (nói khái quát): chửi mắng thậm tệ * bị đánh đập, chửi mắng",
    example: "chửi mắng thậm tệ * bị đánh đập, chửi mắng",
  },
  {
    word: "chưng",
    part_of_speech: "động từ",
    meaning:
      "cố ý đưa ra, bày ra cho nhiều người thấy để khoe: chưng bộ quần áo mới",
    example: "chưng bộ quần áo mới",
  },
  {
    word: "chưng",
    part_of_speech: "động từ",
    meaning:
      "đun nhỏ lửa và lâu cho bốc hơi và đặc lại (nói về thức ăn lỏng): chưng trứng * mắn tép chưng",
    example: "chưng trứng * mắn tép chưng",
  },
  {
    word: "chưng",
    part_of_speech: "động từ",
    meaning:
      "dùng nhiệt làm cho các chất trong một hỗn hợp lần lượt hoá hơi để thu riêng từng chất: chưng dầu mỏ * kĩ thuật chưng than đá",
    example: "chưng dầu mỏ * kĩ thuật chưng than đá",
  },
  {
    word: "chựng",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) như chững: hàng hoá dạo này có vẻ chựng lại",
    example: "hàng hoá dạo này có vẻ chựng lại",
  },
  {
    word: "chứng",
    part_of_speech: "danh từ",
    meaning:
      "dấu hiệu lộ ra cho thấy cơ thể đang có bệnh: chứng hoa mắt chóng mặt * chứng buồn nôn ở những bệnh nhân bị chấn thương sọ não",
    example:
      "chứng hoa mắt chóng mặt * chứng buồn nôn ở những bệnh nhân bị chấn thương sọ não",
  },
  {
    word: "chứng",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) bệnh (thường nói về những bệnh thông thường, có triệu chứng rõ rệt): chứng mất ngủ ở người già * mắc chứng đau lưng",
    example: "chứng mất ngủ ở người già * mắc chứng đau lưng",
  },
  {
    word: "chứng",
    part_of_speech: "danh từ",
    meaning: "thói, tật (thường là xấu): chứng ba hoa * chứng nào tật ấy",
    example: "chứng ba hoa * chứng nào tật ấy",
  },
  {
    word: "chứng",
    part_of_speech: "danh từ",
    meaning:
      "cái đưa ra để bảo đảm sự việc là có thật: không có gì làm chứng * nói có sách, mách có chứng (tng)",
    example: "không có gì làm chứng * nói có sách, mách có chứng (tng)",
  },
  {
    word: "chứng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) xác nhận rằng biết rõ điều đó là đúng sự thật: xin trời phật chứng cho lòng thành * việc đó ai chứng cho mày?",
    example: "xin trời phật chứng cho lòng thành * việc đó ai chứng cho mày?",
  },
  {
    word: "chứng bệnh",
    part_of_speech: "danh từ",
    meaning: "bệnh (nói khái quát): chứng bệnh cũ lại tái phát",
    example: "chứng bệnh cũ lại tái phát",
  },
  {
    word: "chứng cớ",
    part_of_speech: "danh từ",
    meaning:
      "cái được dẫn ra để làm căn cứ xác định điều gì đó là có thật: không đủ chứng cứ để kết tội",
    example: "không đủ chứng cứ để kết tội",
  },
  {
    word: "chứng chỉ",
    part_of_speech: "danh từ",
    meaning:
      "giấy chứng nhận trình độ học vấn hoặc chuyên môn, do cơ quan có thẩm quyền cấp: chứng chỉ tin học * cấp chứng chỉ",
    example: "chứng chỉ tin học * cấp chứng chỉ",
  },
  {
    word: "chưng diện",
    part_of_speech: "động từ",
    meaning:
      "ăn mặc hoặc trang hoàng đẹp, sang trọng cốt để khoe: chưng diện áo quần * thích chưng diện",
    example: "chưng diện áo quần * thích chưng diện",
  },
  {
    word: "chững chàng",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ, hiếm) như chững chạc: dáng điệu chững chàng",
    example: "dáng điệu chững chàng",
  },
  {
    word: "chưng cất",
    part_of_speech: "động từ",
    meaning: "chưng hoặc cất (nói khái quát): chưng cất tinh dầu",
    example: "chưng cất tinh dầu",
  },
  {
    word: "chứng cứ",
    part_of_speech: "danh từ",
    meaning:
      "cái được dẫn ra để làm căn cứ xác định điều gì đó là có thật: không đủ chứng cứ để kết tội",
    example: "không đủ chứng cứ để kết tội",
  },
  {
    word: "chứng dẫn",
    part_of_speech: "",
    meaning: "(cũ, hiếm) như dẫn chứng: những điều được chứng dẫn từ sách vở",
    example: "những điều được chứng dẫn từ sách vở",
  },
  {
    word: "chừng độ",
    part_of_speech: "danh từ",
    meaning: "như mức độ: ăn tiêu có chừng độ",
    example: "ăn tiêu có chừng độ",
  },
  {
    word: "chừng độ",
    part_of_speech: "danh từ",
    meaning:
      "khoảng được xác định một cách đại khái: tuổi chừng độ đôi mươi * từ đây đến đó chừng độ dăm cây số",
    example: "tuổi chừng độ đôi mươi * từ đây đến đó chừng độ dăm cây số",
  },
  {
    word: "chững chạc",
    part_of_speech: "tính từ",
    meaning: "đứng đắn, đàng hoàng: ăn nói chững chạc * đi đứng chững chạc",
    example: "ăn nói chững chạc * đi đứng chững chạc",
  },
  {
    word: "chứng khoán",
    part_of_speech: "danh từ",
    meaning:
      "cổ phiếu hoặc trái phiếu có thể mua bán: mua bán chứng khoán * thị trường chứng khoán * sở giao dịch chứng khoán",
    example:
      "mua bán chứng khoán * thị trường chứng khoán * sở giao dịch chứng khoán",
  },
  {
    word: "chứng kiến",
    part_of_speech: "động từ",
    meaning:
      "trông thấy tận mắt (sự việc nào đó xảy ra): chứng kiến vụ tai nạn giao thông",
    example: "chứng kiến vụ tai nạn giao thông",
  },
  {
    word: "chứng kiến",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) dự và công nhận bằng sự có mặt: chứng kiến buổi lễ kí kết * được mời đến chứng kiến",
    example: "chứng kiến buổi lễ kí kết * được mời đến chứng kiến",
  },
  {
    word: "chừng đỗi",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ, hiếm) như chừng mực: chơi bời gì cũng phải có chừng đỗi",
    example: "chơi bời gì cũng phải có chừng đỗi",
  },
  {
    word: "chứng minh",
    part_of_speech: "động từ",
    meaning:
      "xác định có căn cứ là đúng hay sai, có hay không: thực tế đã chứng minh là nó đúng * chứng minh bằng lí luận",
    example: "thực tế đã chứng minh là nó đúng * chứng minh bằng lí luận",
  },
  {
    word: "chứng minh",
    part_of_speech: "động từ",
    meaning:
      "dùng suy luận logic vạch rõ điều gì đó là đúng: chứng minh một định lí",
    example: "chứng minh một định lí",
  },
  {
    word: "chứng minh",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) chứng minh thư (nói tắt): kiểm tra chứng minh của từng người",
    example: "kiểm tra chứng minh của từng người",
  },
  {
    word: "chứng lý",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) lí lẽ, bằng chứng đưa ra để khẳng định hoặc bào chữa: xem xét các chứng lí * có đầy đủ chứng lí khoa học để kết luận",
    example: "xem xét các chứng lí * có đầy đủ chứng lí khoa học để kết luận",
  },
  {
    word: "chứng lí",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) lí lẽ, bằng chứng đưa ra để khẳng định hoặc bào chữa: xem xét các chứng lí * có đầy đủ chứng lí khoa học để kết luận",
    example: "xem xét các chứng lí * có đầy đủ chứng lí khoa học để kết luận",
  },
  {
    word: "chưng hửng",
    part_of_speech: "động từ",
    meaning:
      "ngẩn ra vì bị mất hứng thú đột ngột do sự việc lại xảy ra trái với điều mình đang mong muốn và tin chắc: chưng hửng vì bị từ chối bất ngờ * mặt chưng hửng",
    example: "chưng hửng vì bị từ chối bất ngờ * mặt chưng hửng",
  },
  {
    word: "chừng mực",
    part_of_speech: "danh từ",
    meaning:
      "mức độ vừa phảI: ăn tiêu có chừng mực * làm gì cũng phải có chừng mực nhất định",
    example: "ăn tiêu có chừng mực * làm gì cũng phải có chừng mực nhất định",
  },
  {
    word: "chứng nhận",
    part_of_speech: "động từ",
    meaning:
      "(cấp có thẩm quyền) xác nhận là có, là đúng sự thật: giấy chứng nhận sức khoẻ * chứng nhận quyền sở hữu trí tuệ",
    example: "giấy chứng nhận sức khoẻ * chứng nhận quyền sở hữu trí tuệ",
  },
  {
    word: "chừng như",
    part_of_speech: "",
    meaning:
      "tổ hợp biểu thị ý phỏng đoán một cách dè dặt dựa trên những gì quan sát thấy hoặc cảm nhận được: chừng như trời sắp mưa * nét mặt đăm chiêu, chừng như suy nghĩ lung lắm",
    example:
      "chừng như trời sắp mưa * nét mặt đăm chiêu, chừng như suy nghĩ lung lắm",
  },
  {
    word: "chứng giám",
    part_of_speech: "động từ",
    meaning:
      "(lực lượng siêu nhiên) soi xét và chứng cho, theo tín ngưỡng dân gian: nói có trời đất chứng giám",
    example: "nói có trời đất chứng giám",
  },
  {
    word: "chứng minh thư",
    part_of_speech: "danh từ",
    meaning:
      "giấy chứng nhận tên tuổi, năm sinh, quê quán và những đặc điểm về nhân dạng do cơ quan có thẩm quyền cấp cho công dân: làm đơn xin cấp giấy chứng minh",
    example: "làm đơn xin cấp giấy chứng minh",
  },
  {
    word: "chứng quả",
    part_of_speech: "động từ",
    meaning:
      "(người tu theo đạo Phật) được thấy kết quả tu hành đã đắc đạo: tu hành đã sắp đến ngày chứng quả",
    example: "tu hành đã sắp đến ngày chứng quả",
  },
  {
    word: "chườm",
    part_of_speech: "động từ",
    meaning:
      "áp vật nóng hoặc lạnh vào da để làm giảm đau hoặc giảm sốt: chườm khăn ướt lên trán cho giảm sốt",
    example: "chườm khăn ướt lên trán cho giảm sốt",
  },
  {
    word: "chứng thư",
    part_of_speech: "danh từ",
    meaning: "(cũ) giấy tờ để làm bằng: chiếu theo các chứng thư để lại",
    example: "chiếu theo các chứng thư để lại",
  },
  {
    word: "chứng thư",
    part_of_speech: "danh từ",
    meaning:
      "giấy chứng nhận (về đặc điểm, chất lượng hàng hoá) có giá trị pháp lí: cấp chứng thư giám định hàng hoá * lập chứng thư cho lô hàng mới nhập",
    example:
      "cấp chứng thư giám định hàng hoá * lập chứng thư cho lô hàng mới nhập",
  },
  {
    word: "chứng thương",
    part_of_speech: "động từ",
    meaning:
      "(cơ quan chức năng) chứng nhận mức độ thương tích: giấy chứng thương",
    example: "giấy chứng thương",
  },
  {
    word: "chứng thực",
    part_of_speech: "",
    meaning:
      "(cấp có thẩm quyền) xác nhận (lời nói, bản khai) là đúng sự thật, để có giá trị pháp lí: chứng thực lời khai * văn bản có chứng thực của Uỷ ban Nhân dân",
    example: "chứng thực lời khai * văn bản có chứng thực của Uỷ ban Nhân dân",
  },
  {
    word: "chứng từ",
    part_of_speech: "danh từ",
    meaning:
      "giấy tờ dùng làm bằng chứng về việc chi thu, xuất nhập: hoá đơn, chứng từ đều hợp lệ",
    example: "hoá đơn, chứng từ đều hợp lệ",
  },
  {
    word: "chứng tích",
    part_of_speech: "danh từ",
    meaning:
      "vết tích hay hiện vật còn lưu lại có giá trị làm chứng cho một sự việc đã qua: phát hiện những chứng tích của nền văn hoá cổ",
    example: "phát hiện những chứng tích của nền văn hoá cổ",
  },
  {
    word: "chứng tỏ",
    part_of_speech: "động từ",
    meaning:
      "tỏ cho thấy rõ điều gì đó một cách có căn cứ: muốn chứng tỏ tài năng * điều đó chứng tỏ nó chẳng biết gì",
    example: "muốn chứng tỏ tài năng * điều đó chứng tỏ nó chẳng biết gì",
  },
  {
    word: "chước",
    part_of_speech: "danh từ",
    meaning:
      'cách khôn khéo để thoát khỏi thế bí hoặc để giải quyết cho được việc gì: bày mưu đặt chước * "Thừa cơ lẻn bước ra đi, Ba mươi sáu chước, chước gì là hơn?" (TKiều)',
    example:
      'bày mưu đặt chước * "Thừa cơ lẻn bước ra đi, Ba mươi sáu chước, chước gì là hơn?" (TKiều)',
  },
  {
    word: "chưởng",
    part_of_speech: "danh từ",
    meaning: "đòn mạnh đánh bằng lòng bàn tay: cho nó một chưởng * tung chưởng",
    example: "cho nó một chưởng * tung chưởng",
  },
  {
    word: "chưởng",
    part_of_speech: "tính từ",
    meaning:
      "(truyện, phim) thuộc loại truyện mô tả những cảnh đánh nhau rất li kì bằng phép thuật phóng ra từ lòng bàn tay những sức mạnh ghê gớm: truyện chưởng * xem phim chưởng",
    example: "truyện chưởng * xem phim chưởng",
  },
  {
    word: "chương hồi",
    part_of_speech: "danh từ",
    meaning:
      "chương và hồi trong một thể loại tiểu thuyết thời trước của Trung Quốc (nói khái quát): tiểu thuyết chương hồi",
    example: "tiểu thuyết chương hồi",
  },
  {
    word: "chương",
    part_of_speech: "danh từ",
    meaning:
      "phần của sách hay của một công trình khoa học có nội dung tương đối trọn vẹn: quyển sách có ba chương * luận án gồm 4 chương",
    example: "quyển sách có ba chương * luận án gồm 4 chương",
  },
  {
    word: "chương chướng",
    part_of_speech: "tính từ",
    meaning: "hơi chướng: nhìn trông chương chướng mắt",
    example: "nhìn trông chương chướng mắt",
  },
  {
    word: "chưởng khế",
    part_of_speech: "danh từ",
    meaning: "(cũ) công chứng viên: viên chưởng khế",
    example: "viên chưởng khế",
  },
  {
    word: "chướng",
    part_of_speech: "tính từ",
    meaning:
      "trái với lẽ thường và gây cho mọi người cảm giác khó coi, hoặc khó chịu: cái tủ kê giữa nhà trông hơi chướng * nói nghe chướng tai",
    example: "cái tủ kê giữa nhà trông hơi chướng * nói nghe chướng tai",
  },
  {
    word: "chướng ngại",
    part_of_speech: "danh từ",
    meaning:
      "cái gây cản trở sự hoạt động, cản trở bước tiến: vượt qua mọi chướng ngại",
    example: "vượt qua mọi chướng ngại",
  },
  {
    word: "chường",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) cố ý để lộ ra trước mọi người cho ai cũng thấy, tuy đáng lẽ nên ẩn đi, giấu đi (hàm ý coi khinh): không muốn chường mặt giữa đám đông",
    example: "không muốn chường mặt giữa đám đông",
  },
  {
    word: "chướng khí",
    part_of_speech: "danh từ",
    meaning:
      "khí ẩm, coi là độc, dễ sinh bệnh, bốc lên ở vùng rừng núi nhiệt đới và cận nhiệt đới: đề phòng chướng khí",
    example: "đề phòng chướng khí",
  },
  {
    word: "chướng ngại vật",
    part_of_speech: "danh từ",
    meaning:
      "vật thể nhân tạo hay tự nhiên, thường dùng trong phòng ngự để làm cản bước tiến của đối phương: thi vượt chướng ngại vật",
    example: "thi vượt chướng ngại vật",
  },
  {
    word: "chương mục",
    part_of_speech: "danh từ",
    meaning:
      "chương và mục của một văn bản (nói khái quát): các chương mục của một bộ luật",
    example: "các chương mục của một bộ luật",
  },
  {
    word: "chương trình",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ những dự kiến hoạt động theo một trình tự nhất định và trong một thời gian nhất định, nêu vắn tắt: chương trình ca nhạc * chương trình điện khí hoá miền núi",
    example: "chương trình ca nhạc * chương trình điện khí hoá miền núi",
  },
  {
    word: "chương trình",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ nội dung học tập, giảng dạy được quy định chính thức cho từng môn, từng lớp hoặc từng cấp học, bậc học, nêu vắn tắt: chương trình toán lớp 10",
    example: "chương trình toán lớp 10",
  },
  {
    word: "chương trình",
    part_of_speech: "danh từ",
    meaning:
      "dãy các chỉ lệnh được viết theo một ngôn ngữ lập trình, có cú pháp nhất định, chỉ thị cho máy tính thực hiện một bài toán sao cho đúng với cách thức đã định: chương trình soạn thảo văn bản * cài đặt chương trình",
    example: "chương trình soạn thảo văn bản * cài đặt chương trình",
  },
  {
    word: "chướng tai gai mắt",
    part_of_speech: "",
    meaning:
      "khó nghe, khó coi vì rất trái lẽ thường: toàn những cảnh chướng tai gai mắt!",
    example: "toàn những cảnh chướng tai gai mắt!",
  },
  {
    word: "chương trình nghị sự",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp những vấn đề dự kiến sẽ đem ra trình bày, thảo luận theo một trình tự nhất định ở hội nghị: chương trình nghị sự của Chính phủ",
    example: "chương trình nghị sự của Chính phủ",
  },
  {
    word: "chượp",
    part_of_speech: "danh từ",
    meaning:
      "nguyên liệu thuỷ sản (thường là cá ướp muối) đang phân huỷ dùng để làm nước mắm: dùng cá cơm để muối chượp",
    example: "dùng cá cơm để muối chượp",
  },
  {
    word: "cn",
    part_of_speech: "",
    meaning: "công nguyên (viết tắt): thế kỉ I tr. CN (trước công nguyên)",
    example: "thế kỉ I tr. CN (trước công nguyên)",
  },
  {
    word: "cỏ",
    part_of_speech: "danh từ",
    meaning:
      "cây thân mềm và thấp, thường mọc lan thành đám trên mặt đất, có nhiều loài khác nhau, dùng để làm thức ăn cho trâu, bò, ngựa, v.v.: cỏ mọc đầy lối đi * cắt cỏ",
    example: "cỏ mọc đầy lối đi * cắt cỏ",
  },
  {
    word: "co",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) thân hình, nói về mặt đường nét, sự cân đối: cô gái có co người đẹp",
    example: "cô gái có co người đẹp",
  },
  {
    word: "co",
    part_of_speech: "danh từ",
    meaning: "(Khẩu ngữ) cỡ chữ in: sách in chữ co 11",
    example: "sách in chữ co 11",
  },
  {
    word: "co",
    part_of_speech: "động từ",
    meaning:
      "gập tay hoặc chân vào, hoặc tự thu gọn thân hình lạI: ngồi co chân lên ghế * khéo ăn thì no, khéo co thì ấm (tng)",
    example: "ngồi co chân lên ghế * khéo ăn thì no, khéo co thì ấm (tng)",
  },
  {
    word: "co",
    part_of_speech: "động từ",
    meaning:
      "tự thu nhỏ bớt thể tích, phạm vi (do chịu sự tác động từ bên ngoài): vải co lại sau khi giặt",
    example: "vải co lại sau khi giặt",
  },
  {
    word: "cọ",
    part_of_speech: "danh từ",
    meaning:
      "cây cao, thuộc họ dừa, lá hình quạt, mọc thành chùm ở ngọn, thường dùng để lợp nhà, làm nón, v.v.: nhà lợp lá cọ",
    example: "nhà lợp lá cọ",
  },
  {
    word: "cọ",
    part_of_speech: "danh từ",
    meaning: "bút lông dùng để vẽ: cây cọ vẽ",
    example: "cây cọ vẽ",
  },
  {
    word: "cọ",
    part_of_speech: "động từ",
    meaning:
      "áp vào và chuyển động sát bề mặt một vật rắn khác: trâu cọ sừng vào thân cây * hai tàu chuối cọ vào nhau sột soạt",
    example: "trâu cọ sừng vào thân cây * hai tàu chuối cọ vào nhau sột soạt",
  },
  {
    word: "cọ",
    part_of_speech: "động từ",
    meaning:
      "làm cho sạch lớp bẩn bám ở mặt ngoài bằng cách dùng vật ráp chà xát nhiều lần: cọ rêu bám trong bể nước * cọ nồi cho sạch",
    example: "cọ rêu bám trong bể nước * cọ nồi cho sạch",
  },
  {
    word: "có",
    part_of_speech: "động từ",
    meaning:
      "từ biểu thị trạng thái tồn tại nào đó nói chung: có bóng người ngoài cửa sổ * trong túi có tiền * lúc có lúc không",
    example:
      "có bóng người ngoài cửa sổ * trong túi có tiền * lúc có lúc không",
  },
  {
    word: "có",
    part_of_speech: "động từ",
    meaning:
      "từ biểu thị trạng thái tồn tại trong mối quan hệ giữa người hoặc sự vật với cái thuộc quyền sở hữu, quyền chi phối (của chủ thể): người cày có ruộng * mọi công dân đều có quyền bình đẳng trước pháp luật",
    example:
      "người cày có ruộng * mọi công dân đều có quyền bình đẳng trước pháp luật",
  },
  {
    word: "có",
    part_of_speech: "động từ",
    meaning:
      "từ biểu thị trạng thái tồn tại trong mối quan hệ giữa người hoặc sự vật với thuộc tính, tính chất, hoặc mối quan hệ tác động qua lại lẫn nhau, v.v.: anh ta có lòng tốt * động vật có vú * có công với đất nước * thịt đã có mùi",
    example:
      "anh ta có lòng tốt * động vật có vú * có công với đất nước * thịt đã có mùi",
  },
  {
    word: "có",
    part_of_speech: "động từ",
    meaning:
      "từ biểu thị trạng thái tồn tại trong mối quan hệ giữa chỉnh thể với bộ phận: nhà có năm gian * sách có ba chương * chuyện kể có đầu có đuôi",
    example: "nhà có năm gian * sách có ba chương * chuyện kể có đầu có đuôi",
  },
  {
    word: "có",
    part_of_speech: "động từ",
    meaning:
      "từ biểu thị trạng thái tồn tại trong mối quan hệ nguồn gốc, thân thuộc, tác động qua lại với nhau, v.v. nói chung: chị ấy có một con * nói có sách, mách có chứng (tng)",
    example: "chị ấy có một con * nói có sách, mách có chứng (tng)",
  },
  {
    word: "có",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) tương đối giàu: bố mẹ có, con cái được nhờ * lúc có phải nghĩ khi túng thiếu",
    example: "bố mẹ có, con cái được nhờ * lúc có phải nghĩ khi túng thiếu",
  },
  {
    word: "có",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị ý khẳng định trạng thái tồn tại, sự xảy ra của điều gì: bệnh có phần thuyên giảm * tôi có biết anh ấy * có cứng mới đứng đầu gió (tng)",
    example:
      "bệnh có phần thuyên giảm * tôi có biết anh ấy * có cứng mới đứng đầu gió (tng)",
  },
  {
    word: "có",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị ý muốn hỏi về điều muốn được khẳng định là như thế (hay là trái lại): từ đây đến đó có xa không? * có đúng như thế không? * mày có nói không thì bảo?",
    example:
      "từ đây đến đó có xa không? * có đúng như thế không? * mày có nói không thì bảo?",
  },
  {
    word: "có",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị ý nhấn mạnh thêm sắc thái khẳng định về số lượng, mức độ chỉ đến thế không hơn không kém: chỉ có ngần ấy người tham gia * nó chỉ biết có thế thôi * ăn có mỗi một bát",
    example:
      "chỉ có ngần ấy người tham gia * nó chỉ biết có thế thôi * ăn có mỗi một bát",
  },
  {
    word: "có",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị ý nhấn mạnh thêm về giả thiết hoặc điều phỏng đoán: anh có đi thì tôi chờ * có mà nói phét ấy chứ!",
    example: "anh có đi thì tôi chờ * có mà nói phét ấy chứ!",
  },
  {
    word: "có",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị ý nhấn mạnh thêm về sắc thái khẳng định trong lời khuyên ngăn hoặc lời phủ nhận: tôi đâu có nói như vậy * chớ có nói dối như thế * có mà chạy đằng trời!",
    example:
      "tôi đâu có nói như vậy * chớ có nói dối như thế * có mà chạy đằng trời!",
  },
  {
    word: "cỏ cây",
    part_of_speech: "danh từ",
    meaning:
      "cỏ và cây; các loài cây trong thiên nhiên (nói khái quát): cỏ cây xanh tốt",
    example: "cỏ cây xanh tốt",
  },
  {
    word: "co bóp",
    part_of_speech: "động từ",
    meaning:
      "co thắt lại rồi dãn ra như cũ một cách liên tiếp (nói về hoạt động của một số bộ phận trong cơ thể): dạ dày co bóp để nghiền thức ăn * tim co bóp để vận chuyển máu",
    example: "dạ dày co bóp để nghiền thức ăn * tim co bóp để vận chuyển máu",
  },
  {
    word: "có bề gì",
    part_of_speech: "",
    meaning: "(giả thiết) có việc gì không hay xảy ra: lỡ có bề gì thì sao?",
    example: "lỡ có bề gì thì sao?",
  },
  {
    word: "có ăn",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) đủ ăn, không dư dả cho lắm: nhà có ăn",
    example: "nhà có ăn",
  },
  {
    word: "cò",
    part_of_speech: "danh từ",
    meaning:
      "chim có chân cao, cổ dài, mỏ nhọn, lông thường trắng, sống thành bầy ở gần vùng nước, ăn các loài tôm cá nhỏ: đục nước béo cò (tng)",
    example: "đục nước béo cò (tng)",
  },
  {
    word: "cò",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) người môi giới trong các hoạt động giao dịch như mua bán, chuyển nhượng, v.v. để kiếm lời (hàm ý coi thường): cò vé xe * cò nhà đất",
    example: "cò vé xe * cò nhà đất",
  },
  {
    word: "cò",
    part_of_speech: "danh từ",
    meaning: "(cũ, khẩu ngữ) như cẩm: cò mật thám",
    example: "cò mật thám",
  },
  {
    word: "cò",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận của súng, khi tác động vào thì đạn nổ và đầu đạn được bắn đI: cò súng * bóp cò * súng cướp cò",
    example: "cò súng * bóp cò * súng cướp cò",
  },
  {
    word: "cò",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) nhị: cây đàn cò",
    example: "cây đàn cò",
  },
  {
    word: "cò bợ",
    part_of_speech: "danh từ",
    meaning:
      "cò có cổ và ngực màu nâu thẫm, thường có dáng ủ rũ: mệt lử cò bợ (rất mệt)",
    example: "mệt lử cò bợ (rất mệt)",
  },
  {
    word: "có chăng",
    part_of_speech: "",
    meaning:
      'hoạ là, nếu mà có thì cũng chỉ là (cái không thường có hoặc không như người ta thường nghĩ): "Sau bảy năm, ra đi cái bị, trở về vẫn hoàn cái bị. Có chăng, được thêm hai lỗ mũi đen sì những than (...)" (ĐVũ; 1)',
    example:
      'Sau bảy năm, ra đi cái bị, trở về vẫn hoàn cái bị. Có chăng, được thêm hai lỗ mũi đen sì những than (...)" (ĐVũ; 1)',
  },
  {
    word: "có bề nào",
    part_of_speech: "",
    meaning: "(giả thiết) có việc gì không hay xảy ra: lỡ có bề gì thì sao?",
    example: "lỡ có bề gì thì sao?",
  },
  {
    word: "cò con",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ít ỏi, vụn vặt, không đáng kể (nói về cái bỏ ra để làm việc gì): buôn bán cò con * làm ăn cò con",
    example: "buôn bán cò con * làm ăn cò con",
  },
  {
    word: "co cụm",
    part_of_speech: "động từ",
    meaning:
      "dồn lại, tập trung lại thành cụm, thành đám (nói khái quát): bị tấn công, địch co cụm lại trong đồn",
    example: "bị tấn công, địch co cụm lại trong đồn",
  },
  {
    word: "có chửa",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) như chửa: con bò đang có chửa",
    example: "con bò đang có chửa",
  },
  {
    word: "cò cưa",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) kéo nhị, đàn một cách vụng về (ví như kéo cưa): mới học đàn nên cũng chỉ cò cưa được vài bài",
    example: "mới học đàn nên cũng chỉ cò cưa được vài bài",
  },
  {
    word: "cò cưa",
    part_of_speech: "động từ",
    meaning: "giằng co mãI: cò cưa mãi mà vẫn không mua được",
    example: "cò cưa mãi mà vẫn không mua được",
  },
  {
    word: "có của",
    part_of_speech: "tính từ",
    meaning: "tương đối giàu có: nhà có của",
    example: "nhà có của",
  },
  {
    word: "cò cử",
    part_of_speech: "động từ",
    meaning:
      '(thông tục) thở khò khè trong cổ họng (thường nói về người bị hen suyễn): "Chồng hen lại lấy vợ hen, Đêm nằm cò cử như kèn thổi đôi." (ca dao)',
    example:
      'Chồng hen lại lấy vợ hen, Đêm nằm cò cử như kèn thổi đôi." (ca dao)',
  },
  {
    word: "có dễ",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị ý khẳng định một cách dè dặt về điều nghĩ rằng là như vậy: từ đó đến nay có dễ đã hai năm rồi * có dễ trời đã gần sáng",
    example: "từ đó đến nay có dễ đã hai năm rồi * có dễ trời đã gần sáng",
  },
  {
    word: "có da có thịt",
    part_of_speech: "",
    meaning: "béo ra, đỡ gầy hơn trước: chịu khó ăn uống cho có da có thịt",
    example: "chịu khó ăn uống cho có da có thịt",
  },
  {
    word: "cỏ gà",
    part_of_speech: "danh từ",
    meaning:
      "cỏ thường mang một tổ trùng kí sinh ở đầu chồi non, thân mảnh và dai, trẻ con thường lấy để tết lại làm trò chơi gọi là chọi gà: mùa hè đang nắng cỏ gà trắng thì mưa (tng)",
    example: "mùa hè đang nắng cỏ gà trắng thì mưa (tng)",
  },
  {
    word: "co dãn",
    part_of_speech: "động từ",
    meaning: "co vào và dãn ra (nói khái quát): cao su là chất co dãn",
    example: "cao su là chất co dãn",
  },
  {
    word: "co dãn",
    part_of_speech: "động từ",
    meaning:
      "thu hẹp lại hoặc mở rộng ra tuỳ theo hoàn cảnh, chứ không cố định: co dãn thời gian cho phù hợp",
    example: "co dãn thời gian cho phù hợp",
  },
  {
    word: "có điều",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị điều sắp nêu ra là một ý bổ sung quan trọng, thường làm giảm điều vừa nói đến: thằng bé thông minh, có điều hơi chủ quan",
    example: "thằng bé thông minh, có điều hơi chủ quan",
  },
  {
    word: "có đi có lại",
    part_of_speech: "",
    meaning:
      "đối xử tốt lại với người đã đối xử tốt với mình: có đi có lại mới toại lòng nhau (tng)",
    example: "có đi có lại mới toại lòng nhau (tng)",
  },
  {
    word: "co giãn",
    part_of_speech: "động từ",
    meaning: "co vào và dãn ra (nói khái quát): cao su là chất co dãn",
    example: "cao su là chất co dãn",
  },
  {
    word: "co giãn",
    part_of_speech: "động từ",
    meaning:
      "thu hẹp lại hoặc mở rộng ra tuỳ theo hoàn cảnh, chứ không cố định: co dãn thời gian cho phù hợp",
    example: "co dãn thời gian cho phù hợp",
  },
  {
    word: "có giá",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có giá trị, được đánh giá cao: một diễn viên có giá * đồ đạc trong nhà chẳng có cái nào có giá",
    example: "một diễn viên có giá * đồ đạc trong nhà chẳng có cái nào có giá",
  },
  {
    word: "có hạn",
    part_of_speech: "tính từ",
    meaning:
      "có sự hạn chế trong một chừng mực hoặc mức độ nhất định: chỉ tiêu tuyển sinh có hạn * kinh phí cũng có hạn * vốn hiểu biết còn có hạn",
    example:
      "chỉ tiêu tuyển sinh có hạn * kinh phí cũng có hạn * vốn hiểu biết còn có hạn",
  },
  {
    word: "co giật",
    part_of_speech: "động từ",
    meaning:
      "(hiện tượng các cơ trong cơ thể) co rút lại rồi giật mạnh một cách không bình thường: sốt cao dễ gây nên hiện tượng co giật",
    example: "sốt cao dễ gây nên hiện tượng co giật",
  },
  {
    word: "có hậu",
    part_of_speech: "tính từ",
    meaning:
      "có phần kết thúc tốt đẹp, lạc quan (nói về truyện kể, truyện phim, v.v.): bộ phim kết thúc có hậu",
    example: "bộ phim kết thúc có hậu",
  },
  {
    word: "có hậu",
    part_of_speech: "tính từ",
    meaning:
      "(đối xử) trọn vẹn nghĩa tình, có trước có sau: ăn ở có hậu * bà là con người có hậu",
    example: "ăn ở có hậu * bà là con người có hậu",
  },
  {
    word: "có học",
    part_of_speech: "tính từ",
    meaning: "có trình độ học thức nhất định, có văn hoá: người có học",
    example: "người có học",
  },
  {
    word: "có hiếu",
    part_of_speech: "tính từ",
    meaning:
      "kính yêu và hết lòng chăm sóc cha mẹ, đúng với bổn phận làm con: người con có hiếu * có hiếu với cha mẹ",
    example: "người con có hiếu * có hiếu với cha mẹ",
  },
  {
    word: "có hạng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) thuộc hạng được đánh giá cao, không phải tầm thường: một vận động viên có hạng",
    example: "một vận động viên có hạng",
  },
  {
    word: "có khi",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị ý khẳng định một cách dè dặt về điều nghĩ rằng có thể như thế: tình thế này có khi phải tìm cách khác * bây giờ mới đi thì có khi hơi muộn",
    example:
      "tình thế này có khi phải tìm cách khác * bây giờ mới đi thì có khi hơi muộn",
  },
  {
    word: "cò kè",
    part_of_speech: "động từ",
    meaning:
      'kèo nèo thêm bớt từng chút một khi mặc cả: "Cò kè bớt một, thêm hai, Giờ lâu ngã giá vàng ngoài bốn trăm." (TKiều)',
    example:
      'Cò kè bớt một, thêm hai, Giờ lâu ngã giá vàng ngoài bốn trăm." (TKiều)',
  },
  {
    word: "có ích",
    part_of_speech: "tính từ",
    meaning:
      "có tác dụng đem lại điều có lợi, đem lại hiệu quả tốt: động vật có ích * cố gắng học tập để trở thành người có ích cho gia đình và xã hội",
    example:
      "động vật có ích * cố gắng học tập để trở thành người có ích cho gia đình và xã hội",
  },
  {
    word: "cò lả",
    part_of_speech: "danh từ",
    meaning:
      "điệu hát dân gian, nét nhạc vui và nhịp nhàng, lời ca dựa vào thơ lục bát, tiếng chẵn trong câu thường được hát lặp lại: điệu cò lả",
    example: "điệu cò lả",
  },
  {
    word: "co kéo",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) lôi kéo giằng co: co kéo khách hàng",
    example: "co kéo khách hàng",
  },
  {
    word: "co kéo",
    part_of_speech: "động từ",
    meaning:
      "lấy chỗ này bù vào chỗ kia, xoay xở sao cho đủ trong một khuôn khổ chật hẹp: phải khéo co kéo lắm mới đủ chi tiêu cho cả tháng",
    example: "phải khéo co kéo lắm mới đủ chi tiêu cho cả tháng",
  },
  {
    word: "cỏ lác",
    part_of_speech: "danh từ",
    meaning:
      "cỏ thuộc họ cói, thân ba cạnh, thường mọc ở vùng ngập nước: cỏ lác mọc lút đầu người",
    example: "cỏ lác mọc lút đầu người",
  },
  {
    word: "có lẽ nào",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) như lẽ nào: con mình sinh ra, có lẽ nào lại không thương? * người như thế có lẽ nào lại chịu khuất phục?",
    example:
      "con mình sinh ra, có lẽ nào lại không thương? * người như thế có lẽ nào lại chịu khuất phục?",
  },
  {
    word: "có lẽ",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị ý phỏng đoán hoặc khẳng định một cách dè dặt về điều nghĩ rằng có thể là như thế: có lẽ nó nói đúng * có lẽ phải chờ hơi lâu",
    example: "có lẽ nó nói đúng * có lẽ phải chờ hơi lâu",
  },
  {
    word: "có lí",
    part_of_speech: "tính từ",
    meaning: "hợp lẽ phảI: nói có lí",
    example: "nói có lí",
  },
  {
    word: "có lý",
    part_of_speech: "tính từ",
    meaning: "hợp lẽ phảI: nói có lí",
    example: "nói có lí",
  },
  {
    word: "có lí có lẽ",
    part_of_speech: "tính từ",
    meaning: "như có lí (nhưng nghĩa mạnh hơn): nói gì cũng phải có lí có lẽ",
    example: "nói gì cũng phải có lí có lẽ",
  },
  {
    word: "có lý có lẽ",
    part_of_speech: "tính từ",
    meaning: "như có lí (nhưng nghĩa mạnh hơn): nói gì cũng phải có lí có lẽ",
    example: "nói gì cũng phải có lí có lẽ",
  },
  {
    word: "có máu mặt",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tỏ ra có tiền của dư dật, hoặc có thế lực, so với mọi người xung quanh: dân chơi có máu mặt",
    example: "dân chơi có máu mặt",
  },
  {
    word: "có mặt",
    part_of_speech: "động từ",
    meaning:
      "có ở tại nơi nào đó lúc sự việc xảy ra: mọi người đã có mặt đông đủ",
    example: "mọi người đã có mặt đông đủ",
  },
  {
    word: "cò mồi",
    part_of_speech: "danh từ",
    meaning:
      "cò dùng làm chim mồi; dùng để ví kẻ chuyên dụ người khác vào tròng trong các trò bịp bợm: bọn cò mồi",
    example: "bọn cò mồi",
  },
  {
    word: "có nghĩa",
    part_of_speech: "tính từ",
    meaning:
      "có sự gắn bó, thuỷ chung trong quan hệ tình cảm: sống có tình, có nghĩa",
    example: "sống có tình, có nghĩa",
  },
  {
    word: "có nhân",
    part_of_speech: "tính từ",
    meaning: "có lòng thương người: một con người có nhân",
    example: "một con người có nhân",
  },
  {
    word: "co quắp",
    part_of_speech: "động từ",
    meaning:
      "(thân mình và chân tay) co gập hẳn lại: chân tay co quắp * nằm co quắp một góc giường",
    example: "chân tay co quắp * nằm co quắp một góc giường",
  },
  {
    word: "cỏ rả",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) cỏ (nói khái quát): cỏ rả mọc um tùm",
    example: "cỏ rả mọc um tùm",
  },
  {
    word: "cỏ rả",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ, hiếm) tồi tàn, thấp hèn: làm như thế thì cỏ rả quá",
    example: "làm như thế thì cỏ rả quá",
  },
  {
    word: "co rúm",
    part_of_speech: "động từ",
    meaning:
      'co thật nhỏ, đến mức như rúm ró hẳn lại: sợ co rúm người lại * "Mặt Đoàn co rúm lại một cách đau đớn." (KLân; 6)',
    example:
      'sợ co rúm người lại * "Mặt Đoàn co rúm lại một cách đau đớn." (KLân; 6)',
  },
  {
    word: "co ro",
    part_of_speech: "động từ",
    meaning:
      'co người, thu nhỏ người lại, thường cho đỡ rét: nằm co ro * "Ông đồ ngồi co ro trong cái áo bông cũ mà nhìn trời mưa (…)" (VTrPhụng; 4)',
    example:
      'nằm co ro * "Ông đồ ngồi co ro trong cái áo bông cũ mà nhìn trời mưa (…)" (VTrPhụng; 4)',
  },
  {
    word: "có tuổi",
    part_of_speech: "tính từ",
    meaning:
      'tương đối nhiều tuổi, không còn trẻ nữa: "Bây giờ mẹ đã có tuổi rồi, chả còn sống được bao lâu nữa, tội gì mẹ còn phải vất vả." (ThLam; 3)',
    example:
      'Bây giờ mẹ đã có tuổi rồi, chả còn sống được bao lâu nữa, tội gì mẹ còn phải vất vả." (ThLam; 3)',
  },
  {
    word: "co-le-xte-ron",
    part_of_speech: "danh từ",
    meaning:
      "chất có trong máu, mỡ và tế bào của người, động vật, nếu có hàm lượng cao sẽ gây nên các bệnh về tim mạch: thừa cholesterol trong máu",
    example: "thừa cholesterol trong máu",
  },
  {
    word: "có thể",
    part_of_speech: "phụ từ",
    meaning:
      "có khả năng hoặc điều kiện để làm việc gì; đối lập với không thể: tự tôi có thể giải quyết được việc ấy * cố gắng hết sức trong phạm vi có thể",
    example:
      "tự tôi có thể giải quyết được việc ấy * cố gắng hết sức trong phạm vi có thể",
  },
  {
    word: "có thể",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị ý khẳng định một cách không dứt khoát về khả năng khách quan xảy ra sự việc nào đó; đối lập với không thể: có thể tôi đã hiểu sai ý anh * giờ này, có thể nó đã về đến nhà rồi",
    example:
      "có thể tôi đã hiểu sai ý anh * giờ này, có thể nó đã về đến nhà rồi",
  },
  {
    word: "có tình",
    part_of_speech: "tính từ",
    meaning:
      "có tình cảm trong quan hệ đối xử gắn bó với ai: nói có lí có tình * ăn ở có tình",
    example: "nói có lí có tình * ăn ở có tình",
  },
  {
    word: "cọ xát",
    part_of_speech: "động từ",
    meaning:
      "cọ đi xát lại vào nhau: dùng bàn chải cọ xát lưng trâu * tiếng cánh cửa cọ xát vào bản lề nghe kèn kẹt",
    example:
      "dùng bàn chải cọ xát lưng trâu * tiếng cánh cửa cọ xát vào bản lề nghe kèn kẹt",
  },
  {
    word: "cọ xát",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tiếp xúc, va chạm với trở ngại, hoặc với thử thách thực tế: chưa có điều kiện cọ xát nhiều với thực tế",
    example: "chưa có điều kiện cọ xát nhiều với thực tế",
  },
  {
    word: "co vòi",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) rụt lại, không dám tiếp tục hành động hung hăng như trước nữa: sợ co vòi",
    example: "sợ co vòi",
  },
  {
    word: "cọc",
    part_of_speech: "danh từ",
    meaning:
      "đoạn tre, gỗ, v.v. thường có đầu nhọn, dùng để cắm vào đất hoặc vào vật khác: cắm cọc * cọc rào * máy đóng cọc bê tông",
    example: "cắm cọc * cọc rào * máy đóng cọc bê tông",
  },
  {
    word: "cọc",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp gồm nhiều đồng tiền xếp chồng lên nhau thành hình trụ: cọc tiền xu",
    example: "cọc tiền xu",
  },
  {
    word: "cóc khô",
    part_of_speech: "trợ từ",
    meaning: "(thông tục) như cóc (nhưng nghĩa mạnh hơn): chẳng có cóc khô gì!",
    example: "chẳng có cóc khô gì!",
  },
  {
    word: "cóc",
    part_of_speech: "danh từ",
    meaning:
      "động vật thuộc loài ếch nhái, mõm ngắn, da xù xì, thường ở cạn, di chuyển bằng cách nhảy: xù xì như da cóc",
    example: "xù xì như da cóc",
  },
  {
    word: "cóc",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) nhỏ và không cố định ở một chỗ, có thể thay đổi địa điểm nhanh (ví như lối nhảy của con cóc): quán cóc bên hè phố * dẹp bỏ chợ cóc * kiên quyết xoá bỏ nạn xe dù, xe cóc",
    example:
      "quán cóc bên hè phố * dẹp bỏ chợ cóc * kiên quyết xoá bỏ nạn xe dù, xe cóc",
  },
  {
    word: "cóc",
    part_of_speech: "phụ từ",
    meaning:
      "(thông tục) từ biểu thị ý phủ định dứt khoát về điều vừa được nói đến, cho là không bao giờ như thế: đánh thì đánh, cóc sợ * anh có ăn thì ăn, tôi cóc thèm!",
    example: "đánh thì đánh, cóc sợ * anh có ăn thì ăn, tôi cóc thèm!",
  },
  {
    word: "cóc",
    part_of_speech: "trợ từ",
    meaning:
      "(thông tục) từ biểu thị ý nhấn mạnh thêm về sắc thái phủ định dứt khoát, cho là không bao giờ có như thế: mày thì biết cóc gì * việc cóc gì mà phải sợ!",
    example: "mày thì biết cóc gì * việc cóc gì mà phải sợ!",
  },
  {
    word: "cọc cà cọc cạch",
    part_of_speech: "tính từ",
    meaning:
      "có các bộ phận đã quá xộc xệch, như sắp hỏng đến nơi: chiếc xe đạp cọc cà cọc cạch",
    example: "chiếc xe đạp cọc cà cọc cạch",
  },
  {
    word: "cọc cà cọc cạch",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều tiếng cọc cạch phát ra liên tiếp, nghe không êm tai, rất khó chịu: cọc cà cọc cạch cả đêm, không ai ngủ được",
    example: "cọc cà cọc cạch cả đêm, không ai ngủ được",
  },
  {
    word: "cóc cáy",
    part_of_speech: "tính từ",
    meaning:
      "(thông tục) có mặt ngoài sần sùi, trông xấu xí, bẩn thỉu: tường nhà cóc cáy * bàn ghế cóc cáy, bẩn thỉu",
    example: "tường nhà cóc cáy * bàn ghế cóc cáy, bẩn thỉu",
  },
  {
    word: "cóc gặm",
    part_of_speech: "tính từ",
    meaning:
      "(thông tục) (đồ dùng) có trạng thái nham nhở, sứt mẻ: mấy chiếc bát cóc gặm * đi một đôi giày cóc gặm",
    example: "mấy chiếc bát cóc gặm * đi một đôi giày cóc gặm",
  },
  {
    word: "cóc cách",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng gọn và cao của vật cứng va đập vào nhau liên tiếp và không đều: tiếng đục đẽo cóc cách cả ngày",
    example: "tiếng đục đẽo cóc cách cả ngày",
  },
  {
    word: "cóc nhảy",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (lối làm việc) không theo tuần tự mà bỏ qua từng đoạn, từng quãng ngắn: đọc cóc nhảy",
    example: "đọc cóc nhảy",
  },
  {
    word: "cọc cạch",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) gồm những vật vốn không cùng đôi, cùng loại ghép lại với nhau: đi guốc cọc cạch * bộ ấm chén cọc cạch",
    example: "đi guốc cọc cạch * bộ ấm chén cọc cạch",
  },
  {
    word: "cọc cạch",
    part_of_speech: "tính từ",
    meaning:
      "có các bộ phận đã xộc xệch, sắp hư hỏng, khó sử dụng: cái máy chữ cọc cạch * chiếc xe đạp cọc cạch",
    example: "cái máy chữ cọc cạch * chiếc xe đạp cọc cạch",
  },
  {
    word: "cọc cạch",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng phát ra của hai vật cứng va vào nhau, nghe trầm và không êm tai: xe bò lăn cọc cạch trên đường đá",
    example: "xe bò lăn cọc cạch trên đường đá",
  },
  {
    word: "cóc tía",
    part_of_speech: "danh từ",
    meaning: "cóc có da bụng màu vàng tía.",
    example: "gan cóc tía * đồ cóc tía!",
  },
  {
    word: "cói",
    part_of_speech: "danh từ",
    meaning:
      "cỏ cao và thẳng, thân ba cạnh, trồng ở vùng nước lợ, dùng để dệt chiếu, đan buồm, v.v.: bao cói * bị cói * chiếu cói",
    example: "bao cói * bị cói * chiếu cói",
  },
  {
    word: "cõi",
    part_of_speech: "danh từ",
    meaning:
      "vùng đất rộng lớn, có ranh giới và quyền sở hữu rõ rệt: hoà bình được lập lại trên toàn cõi Đông Dương",
    example: "hoà bình được lập lại trên toàn cõi Đông Dương",
  },
  {
    word: "cõi",
    part_of_speech: "danh từ",
    meaning:
      'khoảng rộng lớn thuộc phạm vi tồn tại của cái gì: cõi nát bàn * cõi hư vô * "Trăm năm trong cõi người ta, Chữ Tài chữ Mệnh khéo là ghét nhau." (TKiều)',
    example:
      'cõi nát bàn * cõi hư vô * "Trăm năm trong cõi người ta, Chữ Tài chữ Mệnh khéo là ghét nhau." (TKiều)',
  },
  {
    word: "cocktail",
    part_of_speech: "danh từ",
    meaning:
      "đồ uống được pha chế từ nhiều thứ rượu, thường thêm xi rô, trái cây, hương liệu, v.v. cho chung vào một cái bình và lắc đều: kĩ thuật pha chế cocktail",
    example: "kĩ thuật pha chế cocktail",
  },
  {
    word: "coi",
    part_of_speech: "động từ",
    meaning: "(Nam) xem: đi coi hát * ra ngoài coi tình hình thế nào",
    example: "đi coi hát * ra ngoài coi tình hình thế nào",
  },
  {
    word: "coi",
    part_of_speech: "động từ",
    meaning:
      "thấy có vẻ, trông có vẻ: mặt mũi coi cũng dễ thương * coi cũng dễ chứ không khó",
    example: "mặt mũi coi cũng dễ thương * coi cũng dễ chứ không khó",
  },
  {
    word: "coi",
    part_of_speech: "động từ",
    meaning:
      "(Nam) trông (cho khỏi bị hư hại): trâu bò thả rông, không có ai coi * ở nhà coi em",
    example: "trâu bò thả rông, không có ai coi * ở nhà coi em",
  },
  {
    word: "coi",
    part_of_speech: "động từ",
    meaning:
      "có ý kiến đánh giá và tỏ thái độ đối với cái gì, vấn đề gì: coi như rơm như rác * coi là mẫu mực * coi nhau không ra gì",
    example: "coi như rơm như rác * coi là mẫu mực * coi nhau không ra gì",
  },
  {
    word: "cõi âm",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương) thế giới của linh hồn người chết; phân biệt với cõi dương: người cõi âm",
    example: "người cõi âm",
  },
  {
    word: "còi",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ bằng kim loại hay nhựa, phát ra tiếng cao và vang khi thổi hoặc bóp, ấn vào, dùng để báo hiệu: trọng tài thổi còi kết thúc trận đấu * tiếng còi tan tầm của nhà máy * xe bấm còi inh ỏi",
    example:
      "trọng tài thổi còi kết thúc trận đấu * tiếng còi tan tầm của nhà máy * xe bấm còi inh ỏi",
  },
  {
    word: "còi",
    part_of_speech: "tính từ",
    meaning:
      "nhỏ, yếu, không lớn lên được như bình thường (thường do bệnh hoặc do suy dinh dưỡng): thằng bé còi dơ xương * bụi tre còi",
    example: "thằng bé còi dơ xương * bụi tre còi",
  },
  {
    word: "coi bộ",
    part_of_speech: "phụ từ",
    meaning: "(phương ngữ) có vẻ như: làm thoăn thoắt, coi bộ thành thạo lắm",
    example: "làm thoăn thoắt, coi bộ thành thạo lắm",
  },
  {
    word: "coi chừng",
    part_of_speech: "động từ",
    meaning:
      "chú ý giữ gìn, đề phòng điều không hay có thể thình lình xảy ra: coi chừng kẻ gian * đừng đi đâu xa, coi chừng lạc",
    example: "coi chừng kẻ gian * đừng đi đâu xa, coi chừng lạc",
  },
  {
    word: "còi cọc",
    part_of_speech: "tính từ",
    meaning: "còi (nói khái quát): người còi cọc",
    example: "người còi cọc",
  },
  {
    word: "cõi lòng",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương) nơi chất chứa tình cảm sâu kín của mỗi con người: tan nát cõi lòng * nỗi buồn xâm chiếm cả cõi lòng",
    example: "tan nát cõi lòng * nỗi buồn xâm chiếm cả cõi lòng",
  },
  {
    word: "cõi đời",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương) thế giới hiện tại, nơi cuộc sống của mỗi con người trải qua với đủ buồn vui, sướng khổ: từ giã cõi đời",
    example: "từ giã cõi đời",
  },
  {
    word: "coi khinh",
    part_of_speech: "động từ",
    meaning:
      "tỏ ra khinh và không coi ra gì: coi khinh đối thủ * lên mặt coi khinh",
    example: "coi khinh đối thủ * lên mặt coi khinh",
  },
  {
    word: "coi rẻ",
    part_of_speech: "động từ",
    meaning:
      "cho là không đáng quý, không đáng quan tâm nên không coi trọng đúng mức: coi rẻ tính mạng * bị người đời coi rẻ",
    example: "coi rẻ tính mạng * bị người đời coi rẻ",
  },
  {
    word: "coi ngó",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) trông nom: coi ngó nhà cửa",
    example: "coi ngó nhà cửa",
  },
  {
    word: "coi mắt",
    part_of_speech: "động từ",
    meaning:
      "đến nhà người con gái để nhìn mặt người định hỏi làm vợ, theo tục lệ cũ: đi xem mặt",
    example: "đi xem mặt",
  },
  {
    word: "coi mòi",
    part_of_speech: "phụ từ",
    meaning:
      "(phương ngữ, khẩu ngữ) coi chừng như, có vẻ như: coi mòi làm ăn cũng khá",
    example: "coi mòi làm ăn cũng khá",
  },
  {
    word: "coi sóc",
    part_of_speech: "động từ",
    meaning: "trông nom và săn sóc: coi sóc đàn em",
    example: "coi sóc đàn em",
  },
  {
    word: "coi nhẹ",
    part_of_speech: "động từ",
    meaning:
      "cho là không quan trọng nên không chú ý đúng mức: coi nhẹ đồng tiền",
    example: "coi nhẹ đồng tiền",
  },
  {
    word: "cõi tục",
    part_of_speech: "danh từ",
    meaning: "(văn chương) cõi đời trần tục: xa lánh cõi tục",
    example: "xa lánh cõi tục",
  },
  {
    word: "coi thường",
    part_of_speech: "động từ",
    meaning:
      "xem thường, cho là không quan trọng nên không chú ý gì đến: coi thường danh lợi * tưởng dễ nên coi thường",
    example: "coi thường danh lợi * tưởng dễ nên coi thường",
  },
  {
    word: "coi trọng",
    part_of_speech: "động từ",
    meaning:
      "cho là quan trọng nên hết sức quan tâm, chú ý đến: coi trọng tình cảm",
    example: "coi trọng tình cảm",
  },
  {
    word: "còm",
    part_of_speech: "tính từ",
    meaning: "(Khẩu ngữ) gầy và có vẻ còi cọc: con ngựa còm * tấm thân còm",
    example: "con ngựa còm * tấm thân còm",
  },
  {
    word: "còm",
    part_of_speech: "tính từ",
    meaning:
      "ít ỏi hoặc nhỏ bé một cách thảm hại: có mấy đồng bạc còm * gom được ít vốn còm",
    example: "có mấy đồng bạc còm * gom được ít vốn còm",
  },
  {
    word: "còm",
    part_of_speech: "tính từ",
    meaning: "(Ít dùng) như còng: lưng còm",
    example: "lưng còm",
  },
  {
    word: "còi xương",
    part_of_speech: "tính từ",
    meaning:
      "(bệnh ở trẻ nhỏ hoặc súc vật non) có xương kém phát triển hoặc bị biến dạng do thiếu calcium: trẻ bị còi xương",
    example: "trẻ bị còi xương",
  },
  {
    word: "còm cõi",
    part_of_speech: "tính từ",
    meaning: "gầy yếu và còi cọc: đôi vai còm cõi * thân hình còm cõi",
    example: "đôi vai còm cõi * thân hình còm cõi",
  },
  {
    word: "còm nhom",
    part_of_speech: "tính từ",
    meaning: "gầy còm quá mức, trông thiếu sức sống: thân hình còm nhom",
    example: "thân hình còm nhom",
  },
  {
    word: "cỏm rỏm",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ, hiếm) như còm nhom (thường nói về người già): cỏm rỏm như ông lão tám mươi",
    example: "cỏm rỏm như ông lão tám mươi",
  },
  {
    word: "com-pa",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng để dựng hình tròn (khi biết tâm và bán kính), gồm hai nhánh có thể mở to nhỏ tuỳ ý: chiếc compass bằng thép không gỉ",
    example: "chiếc compass bằng thép không gỉ",
  },
  {
    word: "com-măng-đô",
    part_of_speech: "danh từ",
    meaning:
      "toán quân được trang bị và huấn luyện đặc biệt để chuyên đánh đột kích, trong quân đội một số nước đế quốc: lính commando",
    example: "lính commando",
  },
  {
    word: "com-măng-đô",
    part_of_speech: "danh từ",
    meaning: "(hiếm) chất keo dùng để dán: cồn dán",
    example: "cồn dán",
  },
  {
    word: "commando",
    part_of_speech: "danh từ",
    meaning:
      "toán quân được trang bị và huấn luyện đặc biệt để chuyên đánh đột kích, trong quân đội một số nước đế quốc: lính commando",
    example: "lính commando",
  },
  {
    word: "commando",
    part_of_speech: "danh từ",
    meaning: "(hiếm) chất keo dùng để dán: cồn dán",
    example: "cồn dán",
  },
  {
    word: "còn",
    part_of_speech: "danh từ",
    meaning:
      "quả cầu bằng vải có nhiều dải màu, dùng để tung, ném làm trò chơi trong ngày hội ở một số dân tộc miền núi: ném còn",
    example: "ném còn",
  },
  {
    word: "còn",
    part_of_speech: "động từ",
    meaning: "tiếp tục tồn tại: kẻ còn, người mất * chiến tranh không còn nữa",
    example: "kẻ còn, người mất * chiến tranh không còn nữa",
  },
  {
    word: "còn",
    part_of_speech: "động từ",
    meaning:
      "tiếp tục có, tiếp tục diễn ra, không phải đã hết cả hoặc đã mất đi: còn tiền tiêu * trời vẫn còn mưa",
    example: "còn tiền tiêu * trời vẫn còn mưa",
  },
  {
    word: "còn",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị sự tiếp tục, tiếp diễn của hành động, trạng thái cho đến một lúc nào đó: khuya rồi mà vẫn còn thức * anh ta còn rất trẻ * đang còn dở tay",
    example: "khuya rồi mà vẫn còn thức * anh ta còn rất trẻ * đang còn dở tay",
  },
  {
    word: "còn",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị ý khẳng định về một hành động, tính chất nào đó, cả trong trường hợp được nêu thêm ra để đối chiếu, so sánh: hôm qua còn nắng to hơn hôm nay * thà như thế còn hơn * đã không giúp đỡ, lại còn quấy rầy",
    example:
      "hôm qua còn nắng to hơn hôm nay * thà như thế còn hơn * đã không giúp đỡ, lại còn quấy rầy",
  },
  {
    word: "còn",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là một trường hợp khác hoặc trái lại, đối chiếu với điều vừa nói đến: nó ở nhà, còn anh? * nắng thì đi, còn mưa thì nghỉ",
    example: "nó ở nhà, còn anh? * nắng thì đi, còn mưa thì nghỉ",
  },
  {
    word: "compass",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng để dựng hình tròn (khi biết tâm và bán kính), gồm hai nhánh có thể mở to nhỏ tuỳ ý: chiếc compass bằng thép không gỉ",
    example: "chiếc compass bằng thép không gỉ",
  },
  {
    word: "con bạc",
    part_of_speech: "danh từ",
    meaning: "kẻ đánh bạc (hàm ý coi khinh): con bạc khát nước",
    example: "con bạc khát nước",
  },
  {
    word: "con",
    part_of_speech: "danh từ",
    meaning:
      "người hoặc động vật thuộc thế hệ sau, trong quan hệ với người hoặc động vật trực tiếp sinh ra (có thể dùng để xưng gọi): lợn nái đẻ được mười con * con hơn cha là nhà có phúc (tng)",
    example: "lợn nái đẻ được mười con * con hơn cha là nhà có phúc (tng)",
  },
  {
    word: "con",
    part_of_speech: "tính từ",
    meaning:
      "thuộc loại nhỏ, loại phụ, trong quan hệ với cái lớn, cái chính: chặt rễ con, chừa rễ cái * bỏ đường con, đi theo đường lớn",
    example: "chặt rễ con, chừa rễ cái * bỏ đường con, đi theo đường lớn",
  },
  {
    word: "con",
    part_of_speech: "tính từ",
    meaning: "nhỏ, bé: dao con * cái bát con * trước nhà có cái sân con",
    example: "dao con * cái bát con * trước nhà có cái sân con",
  },
  {
    word: "con",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị những cá thể động vật: con mèo * con chim * trong chuồng nuôi hai con ngựa",
    example: "con mèo * con chim * trong chuồng nuôi hai con ngựa",
  },
  {
    word: "con",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị một số vật, thường có đặc điểm hoạt động hoặc hình thể giống động vật: con tim * con sông bên lở bên bồi * con đường làng * con tàu bắt đầu chuyển bánh",
    example:
      "con tim * con sông bên lở bên bồi * con đường làng * con tàu bắt đầu chuyển bánh",
  },
  {
    word: "con",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng cá nhân người đàn bà, con gái với ý không coi trọng hoặc thân mật: con kia, lại đây tao bảo * con chị cõng con em",
    example: "con kia, lại đây tao bảo * con chị cõng con em",
  },
  {
    word: "con",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) hình thể, vóc dáng của con người, nói chung: một người đàn ông to con * nhỏ con nhưng được cái rất nhanh nhẹn",
    example: "một người đàn ông to con * nhỏ con nhưng được cái rất nhanh nhẹn",
  },
  {
    word: "con cái",
    part_of_speech: "danh từ",
    meaning:
      "con, những người thuộc thế hệ con (nói khái quát): chăm nom con cái * cháu là con cái nhà ai?",
    example: "chăm nom con cái * cháu là con cái nhà ai?",
  },
  {
    word: "con buôn",
    part_of_speech: "danh từ",
    meaning:
      "người làm nghề buôn bán, thường dùng những mánh khoé lừa lọc để kiếm lời: mánh lới con buôn * giở giọng con buôn",
    example: "mánh lới con buôn * giở giọng con buôn",
  },
  {
    word: "con cháu",
    part_of_speech: "danh từ",
    meaning:
      "con và cháu; những người thuộc các thế hệ sau (nói khái quát): lưu truyền cho con cháu mai sau",
    example: "lưu truyền cho con cháu mai sau",
  },
  {
    word: "con cả",
    part_of_speech: "danh từ",
    meaning:
      "người con lớn nhất trong gia đình; phân biệt với con thứ: con cả trong một gia đình",
    example: "con cả trong một gia đình",
  },
  {
    word: "con chạy",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận có thể trượt tuỳ ý theo một đường nào đó trong một số máy móc, thiết bị, dụng cụ đo: con chạy của thước kẹp",
    example: "con chạy của thước kẹp",
  },
  {
    word: "con chạy",
    part_of_speech: "danh từ",
    meaning:
      "kí hiệu nhấp nháy trên màn hình máy tính, chỉ vị trí kí tự kế tiếp sẽ xuất hiện, hoặc tại vị trí đó một kí tự cần được sửa đổi, thay thế hay đưa thêm vào: di chuyển con chạy",
    example: "di chuyển con chạy",
  },
  {
    word: "con chạch",
    part_of_speech: "danh từ",
    meaning:
      "bờ đất nhỏ đắp cao vồng lên và chạy dài (tựa như lưng con chạch) để ngăn nước: be con chạch",
    example: "be con chạch",
  },
  {
    word: "con chiên ghẻ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) thành viên xấu làm ô danh một đoàn thể: một con chiên ghẻ trong làng báo",
    example: "một con chiên ghẻ trong làng báo",
  },
  {
    word: "con chiên",
    part_of_speech: "danh từ",
    meaning:
      "tín đồ Công giáo, trong quan hệ với Chúa và cha cố: một con chiên ngoan đạo",
    example: "một con chiên ngoan đạo",
  },
  {
    word: "con cà con kê",
    part_of_speech: "",
    meaning: "(khẩu ngữ) như cà kê (nhưng nghĩa mạnh hơn): kể lể con cà con kê",
    example: "kể lể con cà con kê",
  },
  {
    word: "con cúi",
    part_of_speech: "danh từ",
    meaning:
      "dải bông cuốn lại để kéo thành sợi: xe con cúi * kéo con cúi ra chỉ",
    example: "xe con cúi * kéo con cúi ra chỉ",
  },
  {
    word: "con cúi",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) cuộn rơm tết chặt, thường dùng để giữ lửa: bện con cúi * lửa phát ra từ con cúi",
    example: "bện con cúi * lửa phát ra từ con cúi",
  },
  {
    word: "con chú con bác",
    part_of_speech: "danh từ",
    meaning:
      "con cái của anh em trai, trong quan hệ với nhau: anh em con chú con bác",
    example: "anh em con chú con bác",
  },
  {
    word: "con con",
    part_of_speech: "tính từ",
    meaning:
      'bé nhỏ, trông xinh xắn: bé con con * "Đề huề lưng túi gió trăng, Sau chân theo một vài thằng con con." (TKiều)',
    example:
      'bé con con * "Đề huề lưng túi gió trăng, Sau chân theo một vài thằng con con." (TKiều)',
  },
  {
    word: "con cón",
    part_of_speech: "tính từ",
    meaning:
      "có dáng đi gọn gàng và nhanh nhẹn: con cón chạy về * chân đi con cón",
    example: "con cón chạy về * chân đi con cón",
  },
  {
    word: "cỏn con",
    part_of_speech: "tính từ",
    meaning: "nhỏ bé hết sức, chẳng đáng kể gì: chút lợi cỏn con",
    example: "chút lợi cỏn con",
  },
  {
    word: "con đen",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) dân thường, không có địa vị trong xã hội (gọi theo quan niệm phong kiến, hàm ý coi là khờ khạo): "Mập mờ đánh lận con đen, Bao nhiêu cũng bấy nhiêu tiền, mất chi?" (TKiều)',
    example:
      'Mập mờ đánh lận con đen, Bao nhiêu cũng bấy nhiêu tiền, mất chi?" (TKiều)',
  },
  {
    word: "con đẻ",
    part_of_speech: "danh từ",
    meaning:
      "con do chính mình đẻ ra; phân biệt với con nuôI: con nuôi cũng quý như con đẻ",
    example: "con nuôi cũng quý như con đẻ",
  },
  {
    word: "con đẻ",
    part_of_speech: "danh từ",
    meaning:
      "kết quả trực tiếp của một sự việc nào đó: nghèo đói là con đẻ của sự dốt nát",
    example: "nghèo đói là con đẻ của sự dốt nát",
  },
  {
    word: "con em",
    part_of_speech: "danh từ",
    meaning:
      "những người còn nhỏ tuổi, đặt trong quan hệ với cha anh của mình (nói khái quát): vì tương lai con em chúng ta",
    example: "vì tương lai con em chúng ta",
  },
  {
    word: "con gái",
    part_of_speech: "danh từ",
    meaning:
      'người thuộc giới nữ còn ít tuổi, chưa có chồng: đã qua thời con gái * "Thưa rằng: bác mẹ em răn, Làm thân con gái chớ ăn trầu người." (Cdao)',
    example:
      'đã qua thời con gái * "Thưa rằng: bác mẹ em răn, Làm thân con gái chớ ăn trầu người." (Cdao)',
  },
  {
    word: "con gái",
    part_of_speech: "danh từ",
    meaning:
      "(cây lúa) thời kì đang độ phát triển mạnh, đẻ nhánh nhiều: lúa đang thì con gái",
    example: "lúa đang thì con gái",
  },
  {
    word: "con hát",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người làm nghề đàn hát (gọi theo quan niệm thời trước, với ý coi khinh): bọn con hát",
    example: "bọn con hát",
  },
  {
    word: "con đội",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận dùng để kê hoặc đội bộ phận khác: thay con đội ở các mố cầu",
    example: "thay con đội ở các mố cầu",
  },
  {
    word: "con gái con đứa",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) con gái (nói khái quát; hàm ý chê bai): con gái con đứa gì mà lại như thế?",
    example: "con gái con đứa gì mà lại như thế?",
  },
  {
    word: "con giống",
    part_of_speech: "danh từ",
    meaning:
      "đồ chơi của trẻ em hình các giống vật, thường nặn bằng bột: đồ chơi nặn hình con giống",
    example: "đồ chơi nặn hình con giống",
  },
  {
    word: "con giống",
    part_of_speech: "danh từ",
    meaning:
      "hình các giống vật trang trí trên vải vóc, quần áo, v.v.: tranh con giống * áo thêu con giống",
    example: "tranh con giống * áo thêu con giống",
  },
  {
    word: "con giống",
    part_of_speech: "danh từ",
    meaning:
      "cây hoặc con vật nhỏ dùng để cấy trồng, chăn nuôi hoặc gây giống: trồng một ít con giống su hào * lựa con giống rất kĩ trước khi thả nuôi",
    example:
      "trồng một ít con giống su hào * lựa con giống rất kĩ trước khi thả nuôi",
  },
  {
    word: "con heo",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (phim ảnh, sách báo) có hình ảnh khiêu dâm, kích dục một cách bẩn thỉu: phim con heo",
    example: "phim con heo",
  },
  {
    word: "con giáp",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) tên gọi chung các con vật ứng với tuổi của mỗi người, theo quan niệm cổ truyền: 12 con giáp * hơn nhau một con giáp (hơn một tuổi)",
    example: "12 con giáp * hơn nhau một con giáp (hơn một tuổi)",
  },
  {
    word: "con mọn",
    part_of_speech: "danh từ",
    meaning: "con còn rất nhỏ, đang đòi hỏi phải chăm sóc nhiều: bận con mọn",
    example: "bận con mọn",
  },
  {
    word: "còn khuya",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) còn lâu lắm mới có chuyện đó (hàm ý phủ định một cách mỉa mai): còn khuya nó mới chịu nghe! * chờ đến lượt thì còn khuya!",
    example: "còn khuya nó mới chịu nghe! * chờ đến lượt thì còn khuya!",
  },
  {
    word: "con lăn",
    part_of_speech: "danh từ",
    meaning:
      "vật hình trụ hoặc hình tròn xoay quanh trục của nó hoặc lăn trên mặt của vật khác: hệ thống con lăn trên đà tàu",
    example: "hệ thống con lăn trên đà tàu",
  },
  {
    word: "con mẹ",
    part_of_speech: "danh từ",
    meaning:
      "(thông tục) từ dùng để chỉ người đàn bà nào đó (hàm ý coi khinh): con mẹ chủ quán * con mẹ này ngang bướng lắm!",
    example: "con mẹ chủ quán * con mẹ này ngang bướng lắm!",
  },
  {
    word: "con lắc",
    part_of_speech: "danh từ",
    meaning:
      "vật nặng treo vào một điểm hoặc một trục cố định, dao động do tác dụng của trọng lực: con lắc đồng hồ",
    example: "con lắc đồng hồ",
  },
  {
    word: "còn mệt",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) còn lâu lắm, còn phải vất vả lắm, chẳng biết đến bao giờ mới có chuyện đó (hàm ý phủ định một cách mỉa mai, hoặc hàm ý thiếu tin tưởng): còn mệt mới xong * theo kịp được nó thì còn mệt!",
    example: "còn mệt mới xong * theo kịp được nó thì còn mệt!",
  },
  {
    word: "con nghiện",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) người nghiện thuốc phiện, ma tuý, nói chung (hàm ý coi thường): nó là một con nghiện",
    example: "nó là một con nghiện",
  },
  {
    word: "còn mồ ma",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) (thời người nào đó) còn sống: hồi còn mồ ma mẹ, nhà không đến nỗi túng bấn",
    example: "hồi còn mồ ma mẹ, nhà không đến nỗi túng bấn",
  },
  {
    word: "con một",
    part_of_speech: "danh từ",
    meaning:
      'đứa con duy nhất của gia đình: là con một nên được cha mẹ chiều * "Về bên trai, chàng là con một, hai chị chàng lại lấy chồng sớm." (KhHưng; 2)',
    example:
      'là con một nên được cha mẹ chiều * "Về bên trai, chàng là con một, hai chị chàng lại lấy chồng sớm." (KhHưng; 2)',
  },
  {
    word: "con nhỏ",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) con bé: con nhỏ ghê thiệt! * con nhỏ coi vậy mà khá!",
    example: "con nhỏ ghê thiệt! * con nhỏ coi vậy mà khá!",
  },
  {
    word: "con người",
    part_of_speech: "danh từ",
    meaning:
      "người, về mặt những đặc trưng bản chất nào đó: cuộc sống của con người * xây dựng con người mới",
    example: "cuộc sống của con người * xây dựng con người mới",
  },
  {
    word: "con nít",
    part_of_speech: "danh từ",
    meaning:
      "những đứa trẻ (nói khái quát): bọn trẻ con trong xóm * trẻ con mất lòng người lớn (tng)",
    example: "bọn trẻ con trong xóm * trẻ con mất lòng người lớn (tng)",
  },
  {
    word: "con nít",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất của trẻ con (thường hàm ý coi thường): chuyện trẻ con * trò trẻ con * tính còn trẻ con quá",
    example: "chuyện trẻ con * trò trẻ con * tính còn trẻ con quá",
  },
  {
    word: "con nít",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) tỏ ra tâm tình, thân thiết: chuyện trò rất tri kỉ",
    example: "chuyện trò rất tri kỉ",
  },
  {
    word: "con nhà",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, khẩu ngữ) con cái của gia đình dòng dõi, có nền nếp gia giáo: tiểu thư ra dáng con nhà * "Họ Vương tên gọi Hỉ đồng, Bút nghiên tay giỏi, nghi dung con nhà." (NĐM)',
    example:
      'tiểu thư ra dáng con nhà * "Họ Vương tên gọi Hỉ đồng, Bút nghiên tay giỏi, nghi dung con nhà." (NĐM)',
  },
  {
    word: "còn nước còn tát",
    part_of_speech: "",
    meaning:
      'ví trường hợp còn một chút hi vọng nào dù là mong manh, thì còn ra sức cứu chữa đến cùng: "Trúng phong nặng lắm... Nhưng còn nước còn tát, con tin còn cứu được!" (ĐGiỏi; 5)',
    example:
      'Trúng phong nặng lắm... Nhưng còn nước còn tát, con tin còn cứu được!" (ĐGiỏi; 5)',
  },
  {
    word: "con nước",
    part_of_speech: "danh từ",
    meaning:
      "lần dâng lên hay rút xuống của mực nước triều ở cửa sông hay ven biển: con nước lên * con nước thuỷ triều",
    example: "con nước lên * con nước thuỷ triều",
  },
  {
    word: "con rạ",
    part_of_speech: "danh từ",
    meaning:
      "con từ đứa thứ hai trở đi, nói về việc chửa đẻ; phân biệt với con so: sinh con rạ",
    example: "sinh con rạ",
  },
  {
    word: "con ranh",
    part_of_speech: "danh từ",
    meaning:
      "đứa con cho là đầu thai trở đi trở lại nhiều lần do lần nào đẻ ra cũng không nuôi được, để đòi một cái nợ của kiếp trước, theo mê tín.",
    example: "khôn như con ranh * con ranh, đi đâu mà giờ mới vác mặt về?",
  },
  {
    word: "còn phải nói",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị ý khẳng định hoàn toàn về một điều đã quá rõ ràng, không còn gì phải bàn cãi nữa: bánh gai Hải Dương thì còn phải nói!",
    example: "bánh gai Hải Dương thì còn phải nói!",
  },
  {
    word: "con quay",
    part_of_speech: "động từ",
    meaning:
      "chuyển động hoặc làm cho chuyển động quanh một trục hay một điểm ở trung tâm một cách đều đặn, liên tục: cánh chong chóng quay tít * quay tơ * Trái Đất quay quanh Mặt Trời",
    example:
      "cánh chong chóng quay tít * quay tơ * Trái Đất quay quanh Mặt Trời",
  },
  {
    word: "con quay",
    part_of_speech: "động từ",
    meaning:
      "chuyển động hoặc làm cho chuyển động để đổi hướng, để hướng về phía nào đó: quay mặt đi, không nhìn * đứng quay lưng lại * đi được một đoạn lại quay về",
    example:
      "quay mặt đi, không nhìn * đứng quay lưng lại * đi được một đoạn lại quay về",
  },
  {
    word: "con quay",
    part_of_speech: "động từ",
    meaning:
      "chuyển tiếp sang hoạt động khác, việc khác: hết việc này lại quay sang việc khác",
    example: "hết việc này lại quay sang việc khác",
  },
  {
    word: "con quay",
    part_of_speech: "động từ",
    meaning:
      "làm chín vàng cả khối thịt bằng cách xoay đều trên lửa hoặc rán trong chảo mỡ đậy kín: quay con gà * thịt quay",
    example: "quay con gà * thịt quay",
  },
  {
    word: "con quay",
    part_of_speech: "động từ",
    meaning: "quay phim (nói tắt): bộ phim mới quay * khởi quay",
    example: "bộ phim mới quay * khởi quay",
  },
  {
    word: "con quay",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) hỏi vặn vẹo cặn kẽ (thường nói về việc hỏi bài, thi cử): bị thầy giáo quay * quay cho một lúc, không biết đường nào mà trả lời",
    example:
      "bị thầy giáo quay * quay cho một lúc, không biết đường nào mà trả lời",
  },
  {
    word: "con quay",
    part_of_speech: "danh từ",
    meaning:
      'đồ chơi của trẻ em, bằng gỗ, khi chơi thì đánh cho quay tít: đẽo quay * "Cái quay búng sẵn trên trời, Mờ mờ nhân ảnh như người đi đêm." (CO)',
    example:
      'đẽo quay * "Cái quay búng sẵn trên trời, Mờ mờ nhân ảnh như người đi đêm." (CO)',
  },
  {
    word: "con rối",
    part_of_speech: "danh từ",
    meaning:
      "hình mẫu người hay vật dùng trên sân khấu múa rối; thường dùng để ví kẻ hành động theo sự sai khiến của người khác, làm trò cười cho mọi người: nghệ sĩ điều khiển con rối * làm con rối cho kẻ khác giật dây",
    example: "nghệ sĩ điều khiển con rối * làm con rối cho kẻ khác giật dây",
  },
  {
    word: "con tạo",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) tạo hoá (với ý trách móc, oán hận): "Cũng liều nhắm mắt đưa chân, Mà xem con Tạo xoay vần đến đâu!" (TKiều)',
    example:
      'Cũng liều nhắm mắt đưa chân, Mà xem con Tạo xoay vần đến đâu!" (TKiều)',
  },
  {
    word: "con thơ",
    part_of_speech: "danh từ",
    meaning:
      "con còn nhỏ dại, thơ ngây, về mặt phải nuôi nấng dạy dỗ: đàn con thơ",
    example: "đàn con thơ",
  },
  {
    word: "con tin",
    part_of_speech: "danh từ",
    meaning:
      "người bị bắt giữ dùng làm tin để đòi thực hiện những yêu cầu nào đó: bị bắt làm con tin * kế hoạch giải thoát con tin",
    example: "bị bắt làm con tin * kế hoạch giải thoát con tin",
  },
  {
    word: "con số",
    part_of_speech: "danh từ",
    meaning: "chữ số: kim giờ chỉ vào con số 12",
    example: "kim giờ chỉ vào con số 12",
  },
  {
    word: "con số",
    part_of_speech: "danh từ",
    meaning:
      "số cụ thể: xác định con số nạn nhân trong vụ tai nạn * không nhớ con số chính xác",
    example:
      "xác định con số nạn nhân trong vụ tai nạn * không nhớ con số chính xác",
  },
  {
    word: "con thoi",
    part_of_speech: "danh từ",
    meaning:
      "thoi trong khung cửi hoặc máy dệt; thường dùng để ví sự hoạt động nhanh và qua lại nhiều lần: đi lại như con thoi * chuyến ngoại giao con thoi (đi nhiều nước và liên tục)",
    example:
      "đi lại như con thoi * chuyến ngoại giao con thoi (đi nhiều nước và liên tục)",
  },
  {
    word: "con thứ",
    part_of_speech: "danh từ",
    meaning: "con sinh sau con cả: là con thứ trong nhà",
    example: "là con thứ trong nhà",
  },
  {
    word: "con tính",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) bài tính thực hiện phép tính đơn giản: làm sai một con tính",
    example: "làm sai một con tính",
  },
  {
    word: "con trốt",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) lốc: trận gió trốt * con trốt",
    example: "trận gió trốt * con trốt",
  },
  {
    word: "con trai con đứa",
    part_of_speech: "danh từ",
    meaning:
      '(khẩu ngữ) con trai (nói khái quát; hàm ý chê bai): "Nín đi, con trai con đứa gì mà lại xấu thói thế. Năm mới đã khóc, rông cả năm thôi." (KLân; 3)',
    example:
      'Nín đi, con trai con đứa gì mà lại xấu thói thế. Năm mới đã khóc, rông cả năm thôi." (KLân; 3)',
  },
  {
    word: "con trai",
    part_of_speech: "danh từ",
    meaning:
      "người thuộc giới nam còn ít tuổi, thường chưa có vợ: nhà có hai con trai",
    example: "nhà có hai con trai",
  },
  {
    word: "con toán",
    part_of_speech: "danh từ",
    meaning: "con chạy trên bàn tính: gảy con toán",
    example: "gảy con toán",
  },
  {
    word: "còn xơi",
    part_of_speech: "",
    meaning: "(thông tục) như còn mệt: có được thì cũng còn xơi",
    example: "có được thì cũng còn xơi",
  },
  {
    word: "concerto",
    part_of_speech: "danh từ",
    meaning:
      "bản nhạc hoà tấu cho một nhạc khí và dàn nhạc: bản concerto cho violon và dàn nhạc",
    example: "bản concerto cho violon và dàn nhạc",
  },
  {
    word: "con trẻ",
    part_of_speech: "danh từ",
    meaning: "như trẻ con (nhưng hàm ý thân mật): hết lòng thương yêu con trẻ",
    example: "hết lòng thương yêu con trẻ",
  },
  {
    word: "con trượt",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận có thể trượt tuỳ ý theo một đường nào đó trong một số máy móc, thiết bị, dụng cụ đo: con chạy của thước kẹp",
    example: "con chạy của thước kẹp",
  },
  {
    word: "con trượt",
    part_of_speech: "danh từ",
    meaning:
      "kí hiệu nhấp nháy trên màn hình máy tính, chỉ vị trí kí tự kế tiếp sẽ xuất hiện, hoặc tại vị trí đó một kí tự cần được sửa đổi, thay thế hay đưa thêm vào: di chuyển con chạy",
    example: "di chuyển con chạy",
  },
  {
    word: "con trỏ",
    part_of_speech: "danh từ",
    meaning:
      "kí hiệu di chuyển quanh màn hình máy tính theo sự điều khiển chuột của người dùng: di chuyển con trỏ đến vị trí cần kích chuột",
    example: "di chuyển con trỏ đến vị trí cần kích chuột",
  },
  {
    word: "cóng",
    part_of_speech: "danh từ",
    meaning:
      "đồ đựng bằng sành hình trụ, miệng rộng, có nắp đậy, thân hơi phình, đáy lồi: cóng nước",
    example: "cóng nước",
  },
  {
    word: "cóng",
    part_of_speech: "tính từ",
    meaning: "tê cứng vì rét: nước lạnh làm cóng cả tay",
    example: "nước lạnh làm cóng cả tay",
  },
  {
    word: "cõng",
    part_of_speech: "động từ",
    meaning:
      "mang trên lưng, thường bằng cách còng lưng xuống và quặt tay ra phía sau để đỡ: cõng em đi chơi",
    example: "cõng em đi chơi",
  },
  {
    word: "còng",
    part_of_speech: "danh từ",
    meaning:
      "cua nhỏ sống ở ven biển, có cuống mắt rất dài: cua với còng, cũng dòng nhà nó (tng)",
    example: "cua với còng, cũng dòng nhà nó (tng)",
  },
  {
    word: "còng",
    part_of_speech: "danh từ",
    meaning:
      "vòng kim khí có chằng dây xích dùng để khoá tay hoặc chân người bị bắt, người tù: còng số tám (có hình giống số tám)",
    example: "còng số tám (có hình giống số tám)",
  },
  {
    word: "còng",
    part_of_speech: "động từ",
    meaning: "khoá tay, chân bằng còng: bị còng tay giải về đồn công an",
    example: "bị còng tay giải về đồn công an",
  },
  {
    word: "còng",
    part_of_speech: "tính từ",
    meaning: "(lưng) cong xuống, không thẳng ra được: lưng còng",
    example: "lưng còng",
  },
  {
    word: "cong",
    part_of_speech: "danh từ",
    meaning: "đồ đựng bằng sành, hông phình, miệng rộng: cong nước ăn",
    example: "cong nước ăn",
  },
  {
    word: "cong",
    part_of_speech: "tính từ",
    meaning:
      "không thẳng, mà cũng không gãy gập: làn mi cong * uốn cong thanh sắt * đoạn đường cong",
    example: "làn mi cong * uốn cong thanh sắt * đoạn đường cong",
  },
  {
    word: "còng cọc",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) từ mô tả dáng gò lưng xuống để đạp xe một cách vất vả, nặng nhọc: suốt ngày còng cọc trên cái xe đạp cũ",
    example: "suốt ngày còng cọc trên cái xe đạp cũ",
  },
  {
    word: "còng quèo",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) cong ở nhiều đoạn, nhiều chỗ: thanh sắt còng quèo * “Bóng Đoàn in dài trên vách đất thành một vệt đen còng quèo.” (KLân; 6)",
    example:
      "thanh sắt còng quèo * “Bóng Đoàn in dài trên vách đất thành một vệt đen còng quèo.” (KLân; 6)",
  },
  {
    word: "cong queo",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) cong ở nhiều khúc, nhiều đoạn, theo các hướng khác nhau: cành cây cong queo",
    example: "cành cây cong queo",
  },
  {
    word: "cong cớn",
    part_of_speech: "tính từ",
    meaning:
      "(người phụ nữ) có vẻ đanh đá, biểu hiện thông qua lời nói quá quắt và cử chỉ khó chịu như chẩu môi, vênh mặt, v.v.: nét mặt cong cớn * người phụ nữ cong cớn",
    example: "nét mặt cong cớn * người phụ nữ cong cớn",
  },
  {
    word: "cong tớn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) cong lên một cách quá đáng và khó coi: đôi môi cong tớn",
    example: "đôi môi cong tớn",
  },
  {
    word: "cọng",
    part_of_speech: "danh từ",
    meaning:
      "thân cành của các loài cây thân mềm như lúa, đậu, rau cỏ: cọng rơm * cọng rau muống",
    example: "cọng rơm * cọng rau muống",
  },
  {
    word: "cọng",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) vật có hình que dài và mảnh: mấy cọng bún * đầu lơ thơ vài cọng tóc",
    example: "mấy cọng bún * đầu lơ thơ vài cọng tóc",
  },
  {
    word: "còng queo",
    part_of_speech: "tính từ",
    meaning: "từ gợi tả dáng nằm co quắp và cứng đờ ra: nằm còng queo dưới đất",
    example: "nằm còng queo dưới đất",
  },
  {
    word: "cong vắt",
    part_of_speech: "tính từ",
    meaning: "như cong vút: đôi lông mày tỉa cong vắt * cặp sừng trâu cong vắt",
    example: "đôi lông mày tỉa cong vắt * cặp sừng trâu cong vắt",
  },
  {
    word: "cong veo",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) rất cong (thường hàm ý chê): mấy tấm ván cong veo",
    example: "mấy tấm ván cong veo",
  },
  {
    word: "container",
    part_of_speech: "danh từ",
    meaning:
      "thiết bị có dạng một thùng chứa hình hộp lớn, có dung tích tiêu chuẩn, dùng để đựng hàng hoá chuyên chở đi xa bằng các loại phương tiện vận tải khác nhau: xe chở container * nhập một container linh kiện máy tính",
    example: "xe chở container * nhập một container linh kiện máy tính",
  },
  {
    word: "cong vút",
    part_of_speech: "tính từ",
    meaning:
      "cong thành hình vòng cung và nhọn dần ở một đầu, tạo cảm giác như vút thẳng lên: những mái đình cong vút * làn mi đen cong vút",
    example: "những mái đình cong vút * làn mi đen cong vút",
  },
  {
    word: "cóp",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) sao y nguyên của người khác làm của mình: cóp bài của bạn",
    example: "cóp bài của bạn",
  },
  {
    word: "cóp nhặt",
    part_of_speech: "động từ",
    meaning: "tập hợp, gom góp lại dần dần từng ít một: góp nhặt từng đồng",
    example: "góp nhặt từng đồng",
  },
  {
    word: "cọp",
    part_of_speech: "động từ",
    meaning:
      '(cũ) tủi thẹn, tự cảm thấy mình xấu, kém cỏi: xấu chàng hổ ai (tng) * "Hổ sinh ra phận thơ đào, Công cha nghĩa mẹ kiếp nào trả xong." (TKiều)',
    example:
      'xấu chàng hổ ai (tng) * "Hổ sinh ra phận thơ đào, Công cha nghĩa mẹ kiếp nào trả xong." (TKiều)',
  },
  {
    word: "cosine",
    part_of_speech: "danh từ",
    meaning:
      "hàm số lượng giác của một góc, mà đối với góc nhọn của tam giác vuông thì bằng tỉ số giữa cạnh kề với góc ấy và cạnh huyền: cosine của góc 60O bằng L",
    example: "cosine của góc 60O bằng L",
  },
  {
    word: "cót",
    part_of_speech: "danh từ",
    meaning:
      "vật hình tấm, được làm từ những nan tre nứa mỏng đan chéo và khít vào nhau, dùng để che đậy: tấm cót * tường bằng cót",
    example: "tấm cót * tường bằng cót",
  },
  {
    word: "cót",
    part_of_speech: "danh từ",
    meaning:
      "đồ đựng (thường là thóc, ngô) được làm bằng tấm cót quây kín đặt trên một cái nong: cót thóc * một cót ngô",
    example: "cót thóc * một cót ngô",
  },
  {
    word: "cót",
    part_of_speech: "danh từ",
    meaning: "(Khẩu ngữ) dây cót (nói tắt): đồng hồ đứt cót",
    example: "đồng hồ đứt cót",
  },
  {
    word: "cót két",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng như tiếng tre nứa cọ xát xiết mạnh vào nhau, nghe hơi chói tai: tiếng chõng tre kêu cót két",
    example: "tiếng chõng tre kêu cót két",
  },
  {
    word: "cọt kẹt",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng tựa như tiếng cót két, nhưng trầm hơn: tiếng võng đưa cọt kẹt",
    example: "tiếng võng đưa cọt kẹt",
  },
  {
    word: "cotton",
    part_of_speech: "danh từ",
    meaning: "chất sợi bông, phân biệt với nylon hoặc sợi tổng hợp: vải cotton",
    example: "vải cotton",
  },
  {
    word: "cô",
    part_of_speech: "danh từ",
    meaning:
      "em gái hoặc chị của cha (có thể dùng để xưng gọi): hai cô cháu * bà cô ông chú",
    example: "hai cô cháu * bà cô ông chú",
  },
  {
    word: "cô",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ hoặc gọi người con gái hoặc người phụ nữ còn trẻ tuổi: mấy cô, cậu học trò * cô hàng xén * cô giao liên của trung đoàn",
    example: "mấy cô, cậu học trò * cô hàng xén * cô giao liên của trung đoàn",
  },
  {
    word: "cô",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng trong đối thoại để gọi người phụ nữ coi như bậc cô của mình với ý yêu mến, kính trọng, hoặc để người phụ nữ tự xưng một cách thân mật với người coi như hàng cháu của mình: cô ấy là bạn của mẹ tôi * cô cảm ơn sự giúp đỡ của cháu!",
    example: "cô ấy là bạn của mẹ tôi * cô cảm ơn sự giúp đỡ của cháu!",
  },
  {
    word: "cô",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng trong đối thoại để gọi em gái đã lớn tuổi với ý coi trọng, hoặc để gọi một cách thân mật người phụ nữ coi như vai em của mình (gọi theo cách gọi của con mình): cô trông cháu giúp anh một tí nhé!",
    example: "cô trông cháu giúp anh một tí nhé!",
  },
  {
    word: "cô",
    part_of_speech: "động từ",
    meaning:
      "đun lâu và nhỏ lửa để một dung dịch bốc hơi nước cho đặc lại: ba chén thuốc bắc cô lại chỉ còn một chén * thuốc được điều chế ở dạng cô đặc",
    example:
      "ba chén thuốc bắc cô lại chỉ còn một chén * thuốc được điều chế ở dạng cô đặc",
  },
  {
    word: "cô",
    part_of_speech: "tính từ",
    meaning: "chỉ có một mình, không dựa được vào ai: thân cô, thế cô",
    example: "thân cô, thế cô",
  },
  {
    word: "cô",
    part_of_speech: "tính từ",
    meaning:
      "từ dùng để gọi cô giáo hoặc cô giáo dùng để tự xưng khi nói với học sinh: thưa cô cho em vào lớp * cô chào các em",
    example: "thưa cô cho em vào lớp * cô chào các em",
  },
  {
    word: "cộ",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) (cơ thể hoặc bộ phận cơ thể) to lớn: thân hình to cộ",
    example: "thân hình to cộ",
  },
  {
    word: "cỗ",
    part_of_speech: "danh từ",
    meaning:
      "tất cả những món ăn bày thành mâm để cúng lễ và ăn uống, theo tục lệ: ăn cỗ * phá cỗ trung thu * lời chào cao hơn mâm cỗ (tng)",
    example: "ăn cỗ * phá cỗ trung thu * lời chào cao hơn mâm cỗ (tng)",
  },
  {
    word: "cỗ",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị một số vật do nhiều bộ phận cùng loại hợp thành: cỗ lòng lợn * cỗ bài tam cúc * cỗ xe tăng",
    example: "cỗ lòng lợn * cỗ bài tam cúc * cỗ xe tăng",
  },
  {
    word: "cổ",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận của cơ thể, nối đầu với thân: so vai rụt cổ * bé ôm choàng lấy cổ mẹ * ách giữa đàng quàng vào cổ (tng)",
    example:
      "so vai rụt cổ * bé ôm choàng lấy cổ mẹ * ách giữa đàng quàng vào cổ (tng)",
  },
  {
    word: "cổ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) cổ của con người, coi là biểu tượng của sự cứng cỏi, bướng bỉnh, không chịu khuất phục: cứng đầu cứng cổ * đè đầu cưỡi cổ",
    example: "cứng đầu cứng cổ * đè đầu cưỡi cổ",
  },
  {
    word: "cổ",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận của áo, yếm hoặc giày, bao quanh cổ hoặc cổ chân, cổ tay: áo cổ chui * giày cao cổ * cổ tay áo hơi rộng",
    example: "áo cổ chui * giày cao cổ * cổ tay áo hơi rộng",
  },
  {
    word: "cổ",
    part_of_speech: "danh từ",
    meaning:
      "chỗ eo lại ở gần phần đầu của một số đồ vật, giống hình cái cổ, thường là bộ phận nối liền thân với miệng ở một số đồ đựng: cổ chai * nước đổ đầy đến ngang cổ lọ",
    example: "cổ chai * nước đổ đầy đến ngang cổ lọ",
  },
  {
    word: "cổ",
    part_of_speech: "danh từ",
    meaning:
      "thuộc về thời xa xưa, trong quan hệ với kim (thuộc về thời nay): áng văn cổ * chiếc bình cổ",
    example: "áng văn cổ * chiếc bình cổ",
  },
  {
    word: "cổ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) lỗi thời, không còn hợp thời nữa: quan niệm cổ * ông cụ tính hơi cổ",
    example: "quan niệm cổ * ông cụ tính hơi cổ",
  },
  {
    word: "cô bác",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để gọi thân mật những người cao tuổi coi như cùng một thế hệ với cha mẹ mình (nói khái quát): cảm ơn sự giúp đỡ tận tình của bà con cô bác",
    example: "cảm ơn sự giúp đỡ tận tình của bà con cô bác",
  },
  {
    word: "cồ",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ, khẩu ngữ) có vẻ to lớn nhưng ngộc nghệch (thường nói về gia cầm): lạch bạch như con vịt cồ * gà trống cồ",
    example: "lạch bạch như con vịt cồ * gà trống cồ",
  },
  {
    word: "cố",
    part_of_speech: "danh từ",
    meaning: "(Nam) cụ (= ông/bà của cha/mẹ): ông cố",
    example: "ông cố",
  },
  {
    word: "cố",
    part_of_speech: "động từ",
    meaning:
      "đưa sức, đưa trí ra nhiều hơn bình thường để làm việc gì đó: làm cố cho xong * cố ăn hết bát cơm * cố nhớ lại",
    example: "làm cố cho xong * cố ăn hết bát cơm * cố nhớ lại",
  },
  {
    word: "cố",
    part_of_speech: "động từ",
    meaning:
      "(cũ, hiếm) giao bất động sản làm tin để vay tiền: đem cố ruộng cho địa chủ",
    example: "đem cố ruộng cho địa chủ",
  },
  {
    word: "cố",
    part_of_speech: "phụ tố",
    meaning:
      "(Hán) ghép trước trong một số tổ hợp chỉ người có chức vị cao, có nghĩa đã qua đời, với ý trang trọng: cố thủ tướng * cố giáo sư đồng nguyên",
    example: "cố thủ tướng * cố giáo sư",
  },
  {
    word: "cỗ bàn",
    part_of_speech: "danh từ",
    meaning: "cỗ, mâm cỗ (nói khái quát): cỗ bàn tươm tất * chuẩn bị cỗ bàn",
    example: "cỗ bàn tươm tất * chuẩn bị cỗ bàn",
  },
  {
    word: "cổ bồng",
    part_of_speech: "tính từ",
    meaning:
      "có hình eo lại, thắt lại ở giữa thân như hình cái trống bồng: áo may theo lối thắt cổ bồng",
    example: "áo may theo lối thắt cổ bồng",
  },
  {
    word: "cổ chày",
    part_of_speech: "danh từ",
    meaning:
      "chỗ eo lạI ở giữa cái chày, dùng để cầm nắm khi giã: vắt cổ chày ra nước (tng)",
    example: "vắt cổ chày ra nước (tng)",
  },
  {
    word: "cố chấp",
    part_of_speech: "",
    meaning:
      "khăng khăng giữ ý kiến của mình một cách cứng nhắc, không chịu thay đổi: một người bảo thủ, cố chấp",
    example: "một người bảo thủ, cố chấp",
  },
  {
    word: "cố chấp",
    part_of_speech: "",
    meaning:
      "để bụng những sơ suất của người khác đối với mình đến mức có định kiến: tính hay cố chấp",
    example: "tính hay cố chấp",
  },
  {
    word: "cố chí",
    part_of_speech: "động từ",
    meaning: "cố làm việc gì một cách kiên định: cố chí làm ăn",
    example: "cố chí làm ăn",
  },
  {
    word: "cô chiêu",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) từ thời trước dùng để gọi con gái nhà quan: cậu ấm, cô chiêu",
    example: "cậu ấm, cô chiêu",
  },
  {
    word: "cố công",
    part_of_speech: "động từ",
    meaning: "cố gắng một cách bền bỉ: cố công tìm kiếm * cố công theo đuổi",
    example: "cố công tìm kiếm * cố công theo đuổi",
  },
  {
    word: "cố cùng",
    part_of_speech: "tính từ",
    meaning:
      'nghèo đói, túng quẫn đến mức cùng cực: "Thứ nhất sợ kẻ anh hùng, Thứ nhì sợ kẻ cố cùng liều thân." (ca dao)',
    example:
      'Thứ nhất sợ kẻ anh hùng, Thứ nhì sợ kẻ cố cùng liều thân." (ca dao)',
  },
  {
    word: "cổ cứng",
    part_of_speech: "danh từ",
    meaning:
      "cổ áo sơ mi cứng, phẳng do được dựng bằng một lớp vải dính: áo trắng cổ cồn",
    example: "áo trắng cổ cồn",
  },
  {
    word: "cô dâu",
    part_of_speech: "danh từ",
    meaning:
      "người con gái lấy chồng, trong hôm làm lễ cưới: nghệ thuật trang điểm cô dâu",
    example: "nghệ thuật trang điểm cô dâu",
  },
  {
    word: "cổ cồn",
    part_of_speech: "danh từ",
    meaning:
      "cổ áo sơ mi cứng, phẳng do được dựng bằng một lớp vải dính: áo trắng cổ cồn",
    example: "áo trắng cổ cồn",
  },
  {
    word: "cổ đại",
    part_of_speech: "danh từ",
    meaning: "thời đại xưa nhất trong lịch sử: lịch sử cổ đại Trung Quốc",
    example: "lịch sử cổ đại Trung Quốc",
  },
  {
    word: "cổ điển",
    part_of_speech: "tính từ",
    meaning:
      "(tác giả, tác phẩm văn học, nghệ thuật) có tính chất tiêu biểu, được coi là mẫu mực của thời cổ hoặc thời kì trước đây: nền nghệ thuật cổ điển * tác phẩm văn học cổ điển * nhạc cổ điển",
    example: "nền nghệ thuật cổ điển * tác phẩm văn học cổ điển * nhạc cổ điển",
  },
  {
    word: "cổ điển",
    part_of_speech: "tính từ",
    meaning:
      "theo lề lối cũ, đã có rất lâu từ trước; đối lập với hiện đạI: lối tư duy cổ điển * cách làm cổ điển",
    example: "lối tư duy cổ điển * cách làm cổ điển",
  },
  {
    word: "cố chết",
    part_of_speech: "động từ",
    meaning:
      "cố sức đến mức liều mạng, không kể gì nguy hiểm: cãi cố chết (cố cãi cho bằng được) * cố chết để giữ thành",
    example: "cãi cố chết (cố cãi cho bằng được) * cố chết để giữ thành",
  },
  {
    word: "cô đọng",
    part_of_speech: "tính từ",
    meaning:
      "có cách trình bày, diễn đạt ngắn gọn nhưng bao hàm nhiều ý: thông tin rất cô đọng * lời thơ cô đọng",
    example: "thông tin rất cô đọng * lời thơ cô đọng",
  },
  {
    word: "cố đô",
    part_of_speech: "danh từ",
    meaning: "kinh đô cũ: cố đô Huế",
    example: "cố đô Huế",
  },
  {
    word: "cố định",
    part_of_speech: "tính từ",
    meaning:
      "được giữ nguyên trạng thái, không di động, không biến đổi: tài sản cố định * ở cố định một chỗ",
    example: "tài sản cố định * ở cố định một chỗ",
  },
  {
    word: "cố định",
    part_of_speech: "động từ",
    meaning:
      "làm cho được giữ nguyên vị trí, không di động, không biến đổi: bó nẹp để cố định chỗ xương gãy * cố định mức lãi suất cho vay",
    example: "bó nẹp để cố định chỗ xương gãy * cố định mức lãi suất cho vay",
  },
  {
    word: "cổ động",
    part_of_speech: "động từ",
    meaning:
      "dùng lời nói, sách báo, tranh ảnh, v.v. tác động đến tư tưởng, tình cảm của số đông nhằm lôi cuốn tham gia vào những hoạt động xã hội - chính trị nhất định: cổ động bầu cử * cuộc thi sáng tác tranh cổ động",
    example: "cổ động bầu cử * cuộc thi sáng tác tranh cổ động",
  },
  {
    word: "cô đúc",
    part_of_speech: "động từ",
    meaning:
      "rút lấy những ý cốt yếu để diễn đạt bằng hình thức ngắn gọn: bài viết đã cô đúc được toàn bộ tác phẩm",
    example: "bài viết đã cô đúc được toàn bộ tác phẩm",
  },
  {
    word: "cô đúc",
    part_of_speech: "tính từ",
    meaning:
      "có hình thức thể hiện ngắn gọn nhưng đủ nội dung cốt yếu: cách viết rất cô đúc",
    example: "cách viết rất cô đúc",
  },
  {
    word: "cổ động viên",
    part_of_speech: "danh từ",
    meaning:
      "người tham gia cổ động, tuyên truyền tích cực để ủng hộ cho một ứng cử viên trong cuộc tuyển cử, hay cho một đội thể thao trong cuộc thi đấu: cổ động viên bóng đá",
    example: "cổ động viên bóng đá",
  },
  {
    word: "cổ đông",
    part_of_speech: "danh từ",
    meaning:
      "người có cổ phiếu trong một công ti cổ phần: danh sách cổ đông sáng lập * họp đại hội đồng cổ đông",
    example: "danh sách cổ đông sáng lập * họp đại hội đồng cổ đông",
  },
  {
    word: "cô đơn",
    part_of_speech: "tính từ",
    meaning:
      "chỉ có một mình, không sống cùng với người khác, cái khác: nỗi cô đơn * cảnh sống cô đơn",
    example: "nỗi cô đơn * cảnh sống cô đơn",
  },
  {
    word: "cổ giả",
    part_of_speech: "tính từ",
    meaning: "quê mùa, cổ hủ: bà ấy có vẻ cổ giả",
    example: "bà ấy có vẻ cổ giả",
  },
  {
    word: "cố gắng",
    part_of_speech: "",
    meaning:
      "bỏ công sức ra nhiều hơn mức bình thường để làm việc gì (nói khái quát): cố gắng học hành * có nhiều cố gắng trong công tác",
    example: "cố gắng học hành * có nhiều cố gắng trong công tác",
  },
  {
    word: "cô độc",
    part_of_speech: "tính từ",
    meaning:
      "chỉ riêng một mình, tách khỏi mọi liên hệ với xung quanh: sống cô độc trong túp lều tranh",
    example: "sống cô độc trong túp lều tranh",
  },
  {
    word: "cô giáo",
    part_of_speech: "danh từ",
    meaning: "người phụ nữ làm nghề dạy học: cô giáo chủ nhiệm",
    example: "cô giáo chủ nhiệm",
  },
  {
    word: "cổ hủ",
    part_of_speech: "tính từ",
    meaning:
      "(ý thức, lề lối) cũ kĩ và quá lạc hậu: tư tưởng cổ hủ, lạc hậu * đầu óc cổ hủ * xoá bỏ những tục lệ cổ hủ",
    example:
      "tư tưởng cổ hủ, lạc hậu * đầu óc cổ hủ * xoá bỏ những tục lệ cổ hủ",
  },
  {
    word: "cố kết",
    part_of_speech: "động từ",
    meaning:
      "đồng tâm kết lại thành một khối vững chắc: quyền lợi đã cố kết hai người lại với nhau",
    example: "quyền lợi đã cố kết hai người lại với nhau",
  },
  {
    word: "cổ họng",
    part_of_speech: "danh từ",
    meaning:
      "phần của khí quản, thực quản ở bên trong cổ: khát khô cổ họng * cổ họng nghẹn lại, không thốt nên lời",
    example: "khát khô cổ họng * cổ họng nghẹn lại, không thốt nên lời",
  },
  {
    word: "cố hương",
    part_of_speech: "danh từ",
    meaning:
      '(văn chương) quê hương đã xa cách từ lâu: "Công tư vẹn cả hai bề, Dần dà rồi sẽ liệu về cố hương." (TKiều)',
    example: 'Công tư vẹn cả hai bề, Dần dà rồi sẽ liệu về cố hương." (TKiều)',
  },
  {
    word: "cố hữu",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) bạn cũ: “Lả lơi bên nói, bên cười, Bên mừng cố hữu, bên mời tân lang.” (BC)",
    example:
      "“Lả lơi bên nói, bên cười, Bên mừng cố hữu, bên mời tân lang.” (BC)",
  },
  {
    word: "cố hữu",
    part_of_speech: "tính từ",
    meaning: "vốn có sẵn từ lâu: căn bệnh cố hữu",
    example: "căn bệnh cố hữu",
  },
  {
    word: "cổ kim",
    part_of_speech: "danh từ",
    meaning: "(cũ) xưa nay: chuyện cổ kim * cổ kim chưa từng thấy bao giờ",
    example: "chuyện cổ kim * cổ kim chưa từng thấy bao giờ",
  },
  {
    word: "cố kỉnh",
    part_of_speech: "động từ",
    meaning: "(cũ) cố gắng: cố kỉnh lo toan * cố kỉnh làm ăn",
    example: "cố kỉnh lo toan * cố kỉnh làm ăn",
  },
  {
    word: "cổ lai",
    part_of_speech: "danh từ",
    meaning: "(cũ, hiếm) xưa nay: chuyện ấy, cổ lai có mấy người hiểu được",
    example: "chuyện ấy, cổ lai có mấy người hiểu được",
  },
  {
    word: "cổ kính",
    part_of_speech: "tính từ",
    meaning:
      "cổ và có vẻ trang nghiêm: toà lâu đài cổ kính * cây đa già cổ kính",
    example: "toà lâu đài cổ kính * cây đa già cổ kính",
  },
  {
    word: "cổ lệ",
    part_of_speech: "động từ",
    meaning: "(cũ) khuyến khích, khích lệ: cổ lệ phong trào",
    example: "cổ lệ phong trào",
  },
  {
    word: "cổ lỗ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) cũ và quá lạc hậu (hàm ý chê): chiếc xe cổ lỗ * đầu óc cổ lỗ",
    example: "chiếc xe cổ lỗ * đầu óc cổ lỗ",
  },
  {
    word: "cô liêu",
    part_of_speech: "tính từ",
    meaning:
      '(văn chương) lẻ loi và hoang vắng: buồn cô liêu * "Nắng xuống, trời lên sâu chót vót, Sông dài, trời rộng, bến cô liêu." (HCận; 13)',
    example:
      'buồn cô liêu * "Nắng xuống, trời lên sâu chót vót, Sông dài, trời rộng, bến cô liêu." (HCận; 13)',
  },
  {
    word: "cố lão",
    part_of_speech: "danh từ",
    meaning: "(cũ, hiếm) như bô lão: các cố lão trong làng",
    example: "các cố lão trong làng",
  },
  {
    word: "cổ lỗ sĩ",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như cổ lỗ (hàm ý hài hước): bộ quần áo cổ lỗ sĩ",
    example: "bộ quần áo cổ lỗ sĩ",
  },
  {
    word: "cô miên",
    part_of_speech: "động từ",
    meaning:
      '(cũ, văn chương) ngủ một mình, cô đơn: "Lạnh lùng thay giấc cô miên, Mùi hương tịch mịch, bóng đèn thâm u." (CO)',
    example:
      'Lạnh lùng thay giấc cô miên, Mùi hương tịch mịch, bóng đèn thâm u." (CO)',
  },
  {
    word: "cô lập",
    part_of_speech: "động từ",
    meaning:
      "làm cho trở thành hoàn toàn cô độc, không có được sự đồng tình hoặc sự viện trợ: lâm vào thế bị cô lập * bao vây, cô lập địch",
    example: "lâm vào thế bị cô lập * bao vây, cô lập địch",
  },
  {
    word: "cổ lục",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) sách ghi chép chuyện xưa: "Rõ ràng ghi chép mấy dòng, Trích trong cổ lục dẫn cùng hậu lai." (LH)',
    example:
      'Rõ ràng ghi chép mấy dòng, Trích trong cổ lục dẫn cùng hậu lai." (LH)',
  },
  {
    word: "cổ nhân",
    part_of_speech: "danh từ",
    meaning: "người xưa: làm theo lời dạy của cổ nhân * cổ nhân có câu…",
    example: "làm theo lời dạy của cổ nhân * cổ nhân có câu…",
  },
  {
    word: "cô mình",
    part_of_speech: "đại từ",
    meaning:
      '(khẩu ngữ) tổ hợp dùng để gọi người con gái còn trẻ tuổi, coi như vai em mình, với ý trêu ghẹo hoặc đùa cợt: "Anh còn cái cối giã bèo, Anh về bán nốt anh theo cô mình." (ca dao)',
    example:
      'Anh còn cái cối giã bèo, Anh về bán nốt anh theo cô mình." (ca dao)',
  },
  {
    word: "cố nhân",
    part_of_speech: "danh từ",
    meaning: "(văn chương) bạn cũ: gặp lại cố nhân",
    example: "gặp lại cố nhân",
  },
  {
    word: "cố nhân",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) vợ hoặc chồng cũ, người yêu cũ: "Trách ai lấp nẻo sông Ngân, Làm cho đôi lứa cố nhân bặt đường." (ca dao)',
    example:
      'Trách ai lấp nẻo sông Ngân, Làm cho đôi lứa cố nhân bặt đường." (ca dao)',
  },
  {
    word: "cổ ngữ",
    part_of_speech: "danh từ",
    meaning: "(hiếm) ngôn ngữ cổ: cuốn sách viết bằng cổ ngữ Latin",
    example: "cuốn sách viết bằng cổ ngữ Latin",
  },
  {
    word: "cổ ngữ",
    part_of_speech: "danh từ",
    meaning:
      "cách ngôn lưu truyền lại từ thời cổ: cổ ngữ có câu 'nước xa không cứu được lửa gần'",
    example: "cổ ngữ có câu 'nước xa không cứu được lửa gần'",
  },
  {
    word: "cố nhiên",
    part_of_speech: "tính từ",
    meaning:
      "vốn là như vậy theo lẽ thường xưa nay: lẽ cố nhiên * việc đó cố nhiên sẽ phải xảy ra",
    example: "lẽ cố nhiên * việc đó cố nhiên sẽ phải xảy ra",
  },
  {
    word: "cổ phần hoá",
    part_of_speech: "động từ",
    meaning:
      "làm cho trở thành công ti cổ phần: thực hiện cổ phần hoá doanh nghiệp",
    example: "thực hiện cổ phần hoá doanh nghiệp",
  },
  {
    word: "cô nương",
    part_of_speech: "danh từ",
    meaning:
      "(Từ cũ, Văn chương) từ dùng để gọi người con gái với ý coi trọng: mời cô nương lên xe * quý cô nương",
    example: "mời cô nương lên xe * quý cô nương",
  },
  {
    word: "cổ phần",
    part_of_speech: "danh từ",
    meaning:
      "phần vốn góp vào một tổ chức kinh doanh: mua cổ phần * cổ đông được chia lãi theo cổ phần",
    example: "mua cổ phần * cổ đông được chia lãi theo cổ phần",
  },
  {
    word: "cổ quái",
    part_of_speech: "tính từ",
    meaning: "(hình dáng) quái dị: hình thù cổ quái",
    example: "hình thù cổ quái",
  },
  {
    word: "cô phòng",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) buồng riêng của một người sống cảnh cô đơn: "Nhớ em vắng vẻ cô phòng, Một mình vò võ đêm đông lạnh lùng." (ca dao)',
    example:
      'Nhớ em vắng vẻ cô phòng, Một mình vò võ đêm đông lạnh lùng." (ca dao)',
  },
  {
    word: "cô phòng",
    part_of_speech: "danh từ",
    meaning:
      "cảnh cô đơn của người phụ nữ không chồng hoặc xa chồng: kẻ cô phòng",
    example: "kẻ cô phòng",
  },
  {
    word: "cổ phiếu",
    part_of_speech: "danh từ",
    meaning:
      "phiếu chứng nhận quyền sở hữu cổ phần trong một công ti cổ phần: mua bán cổ phiếu * thị trường cổ phiếu",
    example: "mua bán cổ phiếu * thị trường cổ phiếu",
  },
  {
    word: "cổ phong",
    part_of_speech: "danh từ",
    meaning:
      "thể thơ cổ của Trung Quốc, có trước thơ Đường luật, chỉ cần vần, không cần đối, không bó buộc về niêm luật và không hạn định số câu: thơ cổ phong của Tản Đà",
    example: "thơ cổ phong của Tản Đà",
  },
  {
    word: "cô quả",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) vương hầu ở Trung Quốc thời cổ đại: "Nghênh ngang một cõi biên thuỳ, Thiếu gì cô quả, thiếu gì bá vương!" (TKiều)',
    example:
      'Nghênh ngang một cõi biên thuỳ, Thiếu gì cô quả, thiếu gì bá vương!" (TKiều)',
  },
  {
    word: "cô quả",
    part_of_speech: "tính từ",
    meaning:
      "(cũ) ở vào tình cảnh mồ côi, goá bụa (nói khái quát): người phụ nữ cô quả",
    example: "người phụ nữ cô quả",
  },
  {
    word: "cô quạnh",
    part_of_speech: "tính từ",
    meaning: "lẻ loi và hiu quạnh: túp lều cô quạnh * cuộc sống cô quạnh",
    example: "túp lều cô quạnh * cuộc sống cô quạnh",
  },
  {
    word: "cố sống cố chết",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) như cố chết (nhưng nghĩa mạnh hơn): bọn địch cố sống cố chết chống cự đến cùng",
    example: "bọn địch cố sống cố chết chống cự đến cùng",
  },
  {
    word: "cố sát",
    part_of_speech: "động từ",
    meaning: "giết người một cách cố ý: phạm tội cố sát",
    example: "phạm tội cố sát",
  },
  {
    word: "cổ suý",
    part_of_speech: "động từ",
    meaning: "(hiếm) tán thưởng, ủng hộ: luôn cổ suý cái mới",
    example: "luôn cổ suý cái mới",
  },
  {
    word: "cổ sử",
    part_of_speech: "danh từ",
    meaning: "sử thời cổ đại: nghiên cứu cổ sử * cổ sử Ai Cập",
    example: "nghiên cứu cổ sử * cổ sử Ai Cập",
  },
  {
    word: "cố tật",
    part_of_speech: "danh từ",
    meaning:
      "tật, thói xấu mắc từ lâu, rất khó chữa hoặc không chữa được: mắc cố tật hay quên",
    example: "mắc cố tật hay quên",
  },
  {
    word: "cổ tay",
    part_of_speech: "danh từ",
    meaning:
      'chỗ nối bàn tay với cẳng tay: "Cổ tay em trắng như ngà, Con mắt em liếc như là dao cau." (ca dao)',
    example:
      'Cổ tay em trắng như ngà, Con mắt em liếc như là dao cau." (ca dao)',
  },
  {
    word: "cổ thi",
    part_of_speech: "danh từ",
    meaning:
      "thể thơ cổ của Trung Quốc, có trước thơ Đường luật, chỉ cần vần, không cần đối, không bó buộc về niêm luật và không hạn định số câu: thơ cổ phong của Tản Đà",
    example: "thơ cổ phong của Tản Đà",
  },
  {
    word: "cổ sơ",
    part_of_speech: "tính từ",
    meaning:
      "rất xa xưa, thuộc về buổi đầu của lịch sử xã hội loài người: thời kì cổ sơ",
    example: "thời kì cổ sơ",
  },
  {
    word: "cổ sơ",
    part_of_speech: "tính từ",
    meaning:
      "có từ lâu đời và còn rất thô sơ: công cụ cổ sơ * lối canh tác cổ sơ",
    example: "công cụ cổ sơ * lối canh tác cổ sơ",
  },
  {
    word: "cố quốc",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) đất nước, tổ quốc đã xa cách lâu (nói khi đang còn ở nước ngoài): "Mã Phụng vào tâu Phiên vương, Xin về cố quốc Nam bang chưng là." (MPXH)',
    example:
      'Mã Phụng vào tâu Phiên vương, Xin về cố quốc Nam bang chưng là." (MPXH)',
  },
  {
    word: "cố quốc",
    part_of_speech: "danh từ",
    meaning:
      'như cố hương: "Bốn phương mây trắng một màu, Trông vời cố quốc biết đâu là nhà?" (TKiều)',
    example:
      'Bốn phương mây trắng một màu, Trông vời cố quốc biết đâu là nhà?" (TKiều)',
  },
  {
    word: "cố thây",
    part_of_speech: "tính từ",
    meaning:
      "(thông tục) liều lĩnh, ngang bướng một cách trâng tráo: kẻ bần cùng cố thây",
    example: "kẻ bần cùng cố thây",
  },
  {
    word: "cô tịch",
    part_of_speech: "tính từ",
    meaning:
      "(cũ, văn chương) lẻ loi và quạnh vắng: cảnh chùa cô tịch lúc chiều hôm",
    example: "cảnh chùa cô tịch lúc chiều hôm",
  },
  {
    word: "cổ thụ",
    part_of_speech: "danh từ",
    meaning: "cây to sống đã lâu năm: cây đa cổ thụ",
    example: "cây đa cổ thụ",
  },
  {
    word: "cổ tích",
    part_of_speech: "danh từ",
    meaning:
      "di tích lịch sử (thường là công trình kiến trúc): đi thăm các đền chùa, cổ tích",
    example: "đi thăm các đền chùa, cổ tích",
  },
  {
    word: "cổ tích",
    part_of_speech: "danh từ",
    meaning:
      "truyện cổ dân gian phản ánh cuộc đấu tranh trong xã hội, thể hiện tình cảm, đạo đức, mơ ước của nhân dân, về hình thức thường mang nhiều yếu tố thần kì, tượng trưng và ước lệ: nghe bà đọc cổ tích * ông bụt trong cổ tích",
    example: "nghe bà đọc cổ tích * ông bụt trong cổ tích",
  },
  {
    word: "cố thủ",
    part_of_speech: "động từ",
    meaning:
      "cố giữ bằng được (thường là địa điểm đang bị tấn công): rút vào thành cố thủ",
    example: "rút vào thành cố thủ",
  },
  {
    word: "cố tình",
    part_of_speech: "động từ",
    meaning:
      "cứ làm theo ý định của mình, dù đã biết là không nên: cố tình xuyên tạc sự thật * cố tình trêu tức",
    example: "cố tình xuyên tạc sự thật * cố tình trêu tức",
  },
  {
    word: "cổ tự học",
    part_of_speech: "danh từ",
    meaning: "khoa học chuyên nghiên cứu về chữ viết thời cổ: ngành cổ tự học",
    example: "ngành cổ tự học",
  },
  {
    word: "cổ truyền",
    part_of_speech: "tính từ",
    meaning:
      "từ xưa truyền lại, vốn có từ xưa: nhạc cổ truyền * tổ chức lễ cưới theo phong tục cổ truyền",
    example: "nhạc cổ truyền * tổ chức lễ cưới theo phong tục cổ truyền",
  },
  {
    word: "cố tri",
    part_of_speech: "tính từ",
    meaning: "cũ, quen biết thân thiết từ lâu: bạn cố tri",
    example: "bạn cố tri",
  },
  {
    word: "cố tri",
    part_of_speech: "danh từ",
    meaning:
      'bạn cũ: gặp lại cố tri * "Gió đưa cây cúc ngã quỳ, Đi đâu mà bỏ cố tri đợi chờ." (ca dao)',
    example:
      'gặp lại cố tri * "Gió đưa cây cúc ngã quỳ, Đi đâu mà bỏ cố tri đợi chờ." (ca dao)',
  },
  {
    word: "cổ tự",
    part_of_speech: "danh từ",
    meaning:
      "chữ Hán được viết theo lối cổ: bức trướng được viết theo lối cổ tự",
    example: "bức trướng được viết theo lối cổ tự",
  },
  {
    word: "cổ trướng",
    part_of_speech: "danh từ",
    meaning: "chứng bụng trướng to, thường do xơ gan: xơ gan cổ trướng",
    example: "xơ gan cổ trướng",
  },
  {
    word: "cổ tức",
    part_of_speech: "danh từ",
    meaning:
      "số tiền hằng năm được trích ra từ lợi nhuận của công ti để trả cho cổ đông: hưởng cổ tức * chia cổ tức",
    example: "hưởng cổ tức * chia cổ tức",
  },
  {
    word: "cố vấn",
    part_of_speech: "động từ",
    meaning:
      "đưa ra ý kiến, lời khuyên cho ai đó tham khảo khi giải quyết một công việc quan trọng: cố vấn về pháp luật * bí kế nên nhờ người cố vấn hộ",
    example: "cố vấn về pháp luật * bí kế nên nhờ người cố vấn hộ",
  },
  {
    word: "cố vấn",
    part_of_speech: "danh từ",
    meaning:
      "người am tường về một lĩnh vực nào đó và thường xuyên được hỏi ý kiến để tham khảo khi giải quyết công việc: ngài cố vấn * làm cố vấn quân sự",
    example: "ngài cố vấn * làm cố vấn quân sự",
  },
  {
    word: "cổ văn",
    part_of_speech: "danh từ",
    meaning:
      "văn cổ Trung Quốc, được viết bằng văn ngôn: nghiên cứu cổ văn * bình cổ văn",
    example: "nghiên cứu cổ văn * bình cổ văn",
  },
  {
    word: "cổ vũ",
    part_of_speech: "động từ",
    meaning:
      "tác động đến tinh thần làm cho hăng hái hoạt động: cổ vũ cho đội nhà * cổ vũ tinh thần",
    example: "cổ vũ cho đội nhà * cổ vũ tinh thần",
  },
  {
    word: "cổ xưa",
    part_of_speech: "tính từ",
    meaning:
      "rất lâu rồi, thuộc về thời cổ (nói khái quát): phong tục cổ xưa * thời kì cổ xưa",
    example: "phong tục cổ xưa * thời kì cổ xưa",
  },
  {
    word: "cổ xuý",
    part_of_speech: "động từ",
    meaning: "(cũ) đề xướng và tuyên truyền: phong trào cổ xuý chữ quốc ngữ",
    example: "phong trào cổ xuý chữ quốc ngữ",
  },
  {
    word: "cố ý",
    part_of_speech: "động từ",
    meaning:
      "có ý định làm việc gì và cố thực hiện ý định đó: cố ý lái câu chuyện sang hướng khác * chuyện đó chỉ do vô tình, không cố ý",
    example:
      "cố ý lái câu chuyện sang hướng khác * chuyện đó chỉ do vô tình, không cố ý",
  },
  {
    word: "cổ vật",
    part_of_speech: "danh từ",
    meaning:
      "vật được chế tạo từ thời cổ, có giá trị văn hoá, nghệ thuật, lịch sử nhất định: sưu tầm cổ vật * viện bảo tàng có nhiều cổ vật",
    example: "sưu tầm cổ vật * viện bảo tàng có nhiều cổ vật",
  },
  {
    word: "cô-ta",
    part_of_speech: "danh từ",
    meaning:
      "số lượng hoặc tỉ lệ tối đa cho phép, như về hàng hoá xuất khẩu, nhập khẩu trong một thời gian nhất định, v.v.; giấy phép cấp trong trường hợp nói trên: phân bổ quota không đều * xin được một quota xuất khẩu gạo",
    example: "phân bổ quota không đều * xin được một quota xuất khẩu gạo",
  },
  {
    word: "cốc",
    part_of_speech: "danh từ",
    meaning:
      "chim lông đen, cổ dài, chân có màng da, bơi lặn rất giỏi để bắt cá: cốc mò cò xơi (tng)",
    example: "cốc mò cò xơi (tng)",
  },
  {
    word: "cốc",
    part_of_speech: "danh từ",
    meaning:
      "(Nam li) đồ dùng để uống nước, uống rượu, v.v. thường làm bằng thuỷ tinh hoặc nhựa, có thành cao, lòng sâu và không có quai: cốc nước chanh * rót nước vào cốc",
    example: "cốc nước chanh * rót nước vào cốc",
  },
  {
    word: "cốc",
    part_of_speech: "động từ",
    meaning:
      "(Nam) gõ vào đầu bằng một đầu ngón tay gập lại: bị cốc mấy cái đau điếng",
    example: "bị cốc mấy cái đau điếng",
  },
  {
    word: "cốc đế",
    part_of_speech: "danh từ",
    meaning:
      "chim cốc cỡ lớn, màu đen, chân có màng bơi, thường sống ở khu vực sông nước, ao hồ có nhiều cá.",
    example: "già cốc đế còn chơi trống bỏi",
  },
  {
    word: "cộc",
    part_of_speech: "động từ",
    meaning: "đụng mạnh đầu vào vật cứng: đầu cộc đánh chát vào cột nhà",
    example: "đầu cộc đánh chát vào cột nhà",
  },
  {
    word: "cộc",
    part_of_speech: "tính từ",
    meaning:
      'ngắn vì thiếu một đoạn: áo cộc tay * mặc quần cộc * "Con kiến mày leo cành đào, Leo phải cành cộc, leo vào leo ra." (ca dao)',
    example:
      'áo cộc tay * mặc quần cộc * "Con kiến mày leo cành đào, Leo phải cành cộc, leo vào leo ra." (ca dao)',
  },
  {
    word: "cô-tông",
    part_of_speech: "danh từ",
    meaning: "chất sợi bông, phân biệt với nylon hoặc sợi tổng hợp: vải cotton",
    example: "vải cotton",
  },
  {
    word: "cốc láo",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) lếu láo, hỗn xược: ăn nói cốc láo",
    example: "ăn nói cốc láo",
  },
  {
    word: "cộc lốc",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (lối nói năng) ngắn, cụt đến mức gây cảm giác khó chịu: hỏi cộc lốc * trả lời cộc lốc",
    example: "hỏi cộc lốc * trả lời cộc lốc",
  },
  {
    word: "cộc cằn",
    part_of_speech: "tính từ",
    meaning: "như cục cằn: ăn nói cộc cằn, thô lỗ",
    example: "ăn nói cộc cằn, thô lỗ",
  },
  {
    word: "cỗi",
    part_of_speech: "danh từ",
    meaning: "(cũ, văn chương) cội: cỗi si già",
    example: "cỗi si già",
  },
  {
    word: "cỗi",
    part_of_speech: "tính từ",
    meaning:
      '(cây cối) già, không còn sức phát triển: "Chốn sơn lâm lá cỗi thông vàng, Cây bao nhiêu lá thương chàng bấy nhiêu." (ca dao)',
    example:
      'Chốn sơn lâm lá cỗi thông vàng, Cây bao nhiêu lá thương chàng bấy nhiêu." (ca dao)',
  },
  {
    word: "côi",
    part_of_speech: "tính từ",
    meaning: "mồ côi (nói tắt): mẹ goá, con côi",
    example: "mẹ goá, con côi",
  },
  {
    word: "cội",
    part_of_speech: "danh từ",
    meaning: "gốc cây to, lâu năm: cội thông già * lá rụng về cội (tng)",
    example: "cội thông già * lá rụng về cội (tng)",
  },
  {
    word: "cối",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ làm bằng vật liệu rắn như đá, gỗ, v.v., ở giữa có lòng sâu, dùng để đựng các thứ khi giã hoặc xay: nặng như cái cối đá * cối giã gạo",
    example: "nặng như cái cối đá * cối giã gạo",
  },
  {
    word: "cối",
    part_of_speech: "danh từ",
    meaning:
      "lượng chất được giã hoặc xay bằng cối trong một lần: xay vài cối thóc",
    example: "xay vài cối thóc",
  },
  {
    word: "cối",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) lượng vôi vữa hoặc đất nhão trong một lần trộn, dùng để xây dựng: nhào khoảng chục cối đất * trộn thêm mấy cối hồ",
    example: "nhào khoảng chục cối đất * trộn thêm mấy cối hồ",
  },
  {
    word: "côi cút",
    part_of_speech: "tính từ",
    meaning:
      'lẻ loi, trơ trọi, không nơi nương tựa: đứa bé côi cút * "Người sao năm thiếp bảy thê, Người sao côi cút sớm khuya chịu sầu?" (ca dao)',
    example:
      'đứa bé côi cút * "Người sao năm thiếp bảy thê, Người sao côi cút sớm khuya chịu sầu?" (ca dao)',
  },
  {
    word: "cội nguồn",
    part_of_speech: "danh từ",
    meaning: "như nguồn gốc: cội nguồn dân tộc",
    example: "cội nguồn dân tộc",
  },
  {
    word: "cỗi rễ",
    part_of_speech: "danh từ",
    meaning: "như gốc rễ: tìm cho ra cội rễ của sự việc",
    example: "tìm cho ra cội rễ của sự việc",
  },
  {
    word: "cội rễ",
    part_of_speech: "danh từ",
    meaning: "như gốc rễ: tìm cho ra cội rễ của sự việc",
    example: "tìm cho ra cội rễ của sự việc",
  },
  {
    word: "cộm",
    part_of_speech: "tính từ",
    meaning:
      "căng to hoặc nổi cao lên, gây cảm giác vướng víu do đựng quá đầy hoặc quá chặt: phong bì dày cộm * túi cộm lên vì giấy tờ",
    example: "phong bì dày cộm * túi cộm lên vì giấy tờ",
  },
  {
    word: "cộm",
    part_of_speech: "tính từ",
    meaning:
      "có cảm giác khó chịu ở da thịt, đặc biệt ở mắt, do có gì vướng ở phía trong: mắt thấy hơi cộm như bị bụi bay vào",
    example: "mắt thấy hơi cộm như bị bụi bay vào",
  },
  {
    word: "côm cốp",
    part_of_speech: "tính từ",
    meaning:
      "như cốp (nhưng ý liên tiếp và mức độ mạnh hơn): ngựa gõ móng côm cốp trên mặt đường",
    example: "ngựa gõ móng côm cốp trên mặt đường",
  },
  {
    word: "cốm",
    part_of_speech: "danh từ",
    meaning:
      "món ăn làm bằng thóc nếp non rang chín, giã sạch vỏ, màu xanh, hương vị thơm: chè cốm",
    example: "chè cốm",
  },
  {
    word: "côn",
    part_of_speech: "danh từ",
    meaning: "gậy dùng để múa võ, đánh võ: múa côn",
    example: "múa côn",
  },
  {
    word: "côn",
    part_of_speech: "danh từ",
    meaning:
      "khối nón cụt: hình côn * siết lại côn cho bánh xe đỡ rơ * chỉnh côn xe đạp",
    example: "hình côn * siết lại côn cho bánh xe đỡ rơ * chỉnh côn xe đạp",
  },
  {
    word: "cồn",
    part_of_speech: "danh từ",
    meaning: "dải đồi cát do tác động của gió tạo thành: cồn cát",
    example: "cồn cát",
  },
  {
    word: "cồn",
    part_of_speech: "động từ",
    meaning:
      "nổi cao lên thành từng đợt liên tiếp và dồn dập (nói về sóng): mặt biển sóng cồn",
    example: "mặt biển sóng cồn",
  },
  {
    word: "cồn",
    part_of_speech: "động từ",
    meaning:
      "như cồn cào: uống nước chè lúc đói nên cồn ruột * trong lòng cồn lên một cảm giác nuối tiếc",
    example:
      "uống nước chè lúc đói nên cồn ruột * trong lòng cồn lên một cảm giác nuối tiếc",
  },
  {
    word: "cồn",
    part_of_speech: "danh từ",
    meaning:
      "rượu có nồng độ cao, dùng để đốt, sát trùng hoặc pha chế dược liệu: đèn cồn * xoa cồn sát trùng trước khi tiêm thuốc",
    example: "đèn cồn * xoa cồn sát trùng trước khi tiêm thuốc",
  },
  {
    word: "cồm cộp",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng to, trầm và vang xa, như tiếng của vật cứng nện liên tiếp trên mặt nền cứng: tiếng giày nện cồm cộp",
    example: "tiếng giày nện cồm cộp",
  },
  {
    word: "cồn cào",
    part_of_speech: "",
    meaning:
      "có cảm giác như ruột bị cào xé, giày vò thành từng cơn liên tiếp: bụng đói cồn cào * ruột gan cồn cào",
    example: "bụng đói cồn cào * ruột gan cồn cào",
  },
  {
    word: "côn đồ",
    part_of_speech: "danh từ",
    meaning: "kẻ chuyên gây sự, hành hung: bọn lưu manh, côn đồ",
    example: "bọn lưu manh, côn đồ",
  },
  {
    word: "côn đồ",
    part_of_speech: "tính từ",
    meaning:
      "có những hành động ngang ngược, thô bạo: giở thói côn đồ * một lũ thanh niên trông hết sức côn đồ",
    example: "giở thói côn đồ * một lũ thanh niên trông hết sức côn đồ",
  },
  {
    word: "côn quyền",
    part_of_speech: "danh từ",
    meaning:
      'môn võ dùng gậy và môn võ dùng tay không; chỉ các môn võ nghệ á Đông (nói khái quát): "Đường đường một đấng anh hào, Côn quyền hơn sức, lược thao gồm tài." (TKiều)',
    example:
      'Đường đường một đấng anh hào, Côn quyền hơn sức, lược thao gồm tài." (TKiều)',
  },
  {
    word: "côn quang",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) gậy gộc; dùng để chỉ kẻ côn đồ, vô lại: "Trời hôm xế bóng tà tà, Côn quang, đâu bỗng gặp ba bốn người." (NĐM)',
    example:
      'Trời hôm xế bóng tà tà, Côn quang, đâu bỗng gặp ba bốn người." (NĐM)',
  },
  {
    word: "côn trùng học",
    part_of_speech: "danh từ",
    meaning: "khoa học chuyên nghiên cứu về côn trùng: nhà côn trùng học",
    example: "nhà côn trùng học",
  },
  {
    word: "côn trùng",
    part_of_speech: "danh từ",
    meaning:
      "động vật chân đốt, cơ thể chia thành ba phần, có một đôi râu, ba đôi chân, phần lớn có cánh: tiếng côn trùng kêu rả rích",
    example: "tiếng côn trùng kêu rả rích",
  },
  {
    word: "cộng",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) cọng1",
    example: "hoạt động chống cộng",
  },
  {
    word: "cộng",
    part_of_speech: "động từ",
    meaning:
      "tính gộp vào, thêm vào: 2 cộng với 2 là 4 * cộng tiền hàng * cộng sổ",
    example: "2 cộng với 2 là 4 * cộng tiền hàng * cộng sổ",
  },
  {
    word: "cổng",
    part_of_speech: "danh từ",
    meaning:
      "lối ra vào ở một khu vực đã được rào ngăn, thường có cửa để đóng, mở: cổng ngõ * cổng làng * đứng chờ ở ngoài cổng",
    example: "cổng ngõ * cổng làng * đứng chờ ở ngoài cổng",
  },
  {
    word: "cổng",
    part_of_speech: "danh từ",
    meaning:
      "thiết bị dùng để hướng dẫn và làm cho đồng bộ việc chuyển dữ liệu giữa đơn vị xử lí trung tâm của máy tính với các thiết bị ngoại vi (như máy in, chuột, modem, v.v.), hoặc giữa các máy tính với nhau trong một mạng máy tính: cổng máy in",
    example: "cổng máy in",
  },
  {
    word: "công an",
    part_of_speech: "danh từ",
    meaning:
      "cơ quan nhà nước chuyên giữ gìn trật tự, an ninh chung: đồn công an * bộ công an",
    example: "đồn công an * bộ công an",
  },
  {
    word: "công an",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) nhân viên làm việc trong cơ quan an ninh: nhờ công an chỉ đường * công an bắt cướp",
    example: "nhờ công an chỉ đường * công an bắt cướp",
  },
  {
    word: "công",
    part_of_speech: "danh từ",
    meaning:
      "sức lực, trí tuệ bỏ ra để làm việc gì: lấy công làm lãi * kẻ góp của, người góp công * uổng công chờ đợi",
    example:
      "lấy công làm lãi * kẻ góp của, người góp công * uổng công chờ đợi",
  },
  {
    word: "công",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị để tính sức lao động bỏ ra, bằng lao động trung bình trong một ngày của một người: giúp nhau vài công lợp nhà",
    example: "giúp nhau vài công lợp nhà",
  },
  {
    word: "công",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị để tính phần đóng góp vào lao động của súc vật dùng làm sức kéo hoặc của một số công cụ trung bình trong một ngày: cần khoảng hai công trâu để cày xong thửa ruộng",
    example: "cần khoảng hai công trâu để cày xong thửa ruộng",
  },
  {
    word: "công",
    part_of_speech: "danh từ",
    meaning:
      'thù lao được trả bằng tiền hoặc của cải vật chất cho công lao động làm thuê: "Người ta đi cấy lấy công, Tôi nay đi cấy còn trông nhiều bề." (ca dao)',
    example:
      'Người ta đi cấy lấy công, Tôi nay đi cấy còn trông nhiều bề." (ca dao)',
  },
  {
    word: "công",
    part_of_speech: "danh từ",
    meaning:
      "công lao (nói tắt): gia đình có công với cách mạng * công sinh thành và nuôi dưỡng * giết giặc lập công",
    example:
      "gia đình có công với cách mạng * công sinh thành và nuôi dưỡng * giết giặc lập công",
  },
  {
    word: "công",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) tước cao nhất trong bậc thang chức tước hàng quan lại thời phong kiến (công, hầu, bá, tử, nam): ban tước công",
    example: "ban tước công",
  },
  {
    word: "công",
    part_of_speech: "động từ",
    meaning:
      "hoạt động nhằm tiêu diệt, hoặc chiếm vị trí của đối phương: công thủ toàn diện * công đồn",
    example: "công thủ toàn diện * công đồn",
  },
  {
    word: "công",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) (thuốc) tác động quá mạnh gây nên những phản ứng có hại, do không hợp với cơ thể hoặc do dùng quá liều lượng: bị công thuốc",
    example: "bị công thuốc",
  },
  {
    word: "công",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) ngậm tha đi: chó công mất miếng thịt",
    example: "chó công mất miếng thịt",
  },
  {
    word: "công",
    part_of_speech: "tính từ",
    meaning:
      'thuộc về nhà nước, chung cho mọi người; phân biệt với tư: việc công * "Sứ trời sớm giục đường mây, Phép công là trọng niềm tây sá nào." (CPN)',
    example:
      'việc công * "Sứ trời sớm giục đường mây, Phép công là trọng niềm tây sá nào." (CPN)',
  },
  {
    word: "công",
    part_of_speech: "tính từ",
    meaning:
      '(hiếm) công bằng (nói tắt): đối xử không công * "Trời sao Trời ở chẳng công, Người ba bốn vợ, người không vợ nào." (ca dao)',
    example:
      'đối xử không công * "Trời sao Trời ở chẳng công, Người ba bốn vợ, người không vợ nào." (ca dao)',
  },
  {
    word: "công ăn việc làm",
    part_of_speech: "danh từ",
    meaning:
      "việc làm để sinh sống (nói khái quát): không có công ăn việc làm ổn định",
    example: "không có công ăn việc làm ổn định",
  },
  {
    word: "công bộc",
    part_of_speech: "danh từ",
    meaning: "người đầy tớ chung của mọi người: cán bộ là công bộc của dân",
    example: "cán bộ là công bộc của dân",
  },
  {
    word: "công bằng",
    part_of_speech: "tính từ",
    meaning: "theo đúng lẽ phảI, không thiên vị: đối xử công bằng",
    example: "đối xử công bằng",
  },
  {
    word: "công cán",
    part_of_speech: "danh từ",
    meaning:
      'việc làm được với nhiều vất vả, khó nhọc (nói khái quát): "Dã tràng xe cát biển Đông, Nhọc nhằn mà chẳng nên công cán gì." (ca dao)',
    example:
      'Dã tràng xe cát biển Đông, Nhọc nhằn mà chẳng nên công cán gì." (ca dao)',
  },
  {
    word: "công cán",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) tiền công (nói khái quát): công cán bèo bọt",
    example: "công cán bèo bọt",
  },
  {
    word: "công chánh",
    part_of_speech: "danh từ",
    meaning:
      "ngành chuyên môn về quản lí và xây dựng các công trình công cộng (như cầu cống, đường sá, v.v.): sở giao thông công chính * nhân viên sở công chính",
    example: "sở giao thông công chính * nhân viên sở công chính",
  },
  {
    word: "công bội",
    part_of_speech: "danh từ",
    meaning:
      "số mà nhân với mỗi số hạng của một cấp số nhân thì được số hạng liền sau: cấp số nhân 3, 6, 12, 24, 48 có công bội 2",
    example: "cấp số nhân 3, 6, 12, 24, 48 có công bội 2",
  },
  {
    word: "công chính",
    part_of_speech: "danh từ",
    meaning:
      "ngành chuyên môn về quản lí và xây dựng các công trình công cộng (như cầu cống, đường sá, v.v.): sở giao thông công chính * nhân viên sở công chính",
    example: "sở giao thông công chính * nhân viên sở công chính",
  },
  {
    word: "công chiếu",
    part_of_speech: "động từ",
    meaning:
      "(phim) được chiếu rộng rãi cho công chúng xem: bộ phim được công chiếu vào dịp quốc khánh",
    example: "bộ phim được công chiếu vào dịp quốc khánh",
  },
  {
    word: "công bố",
    part_of_speech: "động từ",
    meaning:
      "thông báo công khai cho mọi người biết: công bố một đạo luật mới * tài liệu chưa từng được công bố",
    example: "công bố một đạo luật mới * tài liệu chưa từng được công bố",
  },
  {
    word: "cổng chào",
    part_of_speech: "danh từ",
    meaning:
      "vật trang trí hình giống cái cổng dựng lên trên lối đi để chào mừng nhân một dịp trọng thể: cổng chào được kết bằng lá dừa",
    example: "cổng chào được kết bằng lá dừa",
  },
  {
    word: "công chúng",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ những người đọc, người xem, người nghe, trong quan hệ với tác giả, diễn viên, v.v. (nói tổng quát): tập thơ vừa ra mắt công chúng * biểu diễn trước công chúng",
    example: "tập thơ vừa ra mắt công chúng * biểu diễn trước công chúng",
  },
  {
    word: "công cốc",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) công khó nhọc mà chẳng được gì (nói khái quát): làm cả tháng trời giờ thành công cốc",
    example: "làm cả tháng trời giờ thành công cốc",
  },
  {
    word: "công chứng",
    part_of_speech: "danh từ",
    meaning:
      "sự chứng thực của cơ quan nhà nước có thẩm quyền nhằm xác nhận về mặt pháp lí các văn bản, hoặc bản sao từ bản gốc: bản sao có công chứng",
    example: "bản sao có công chứng",
  },
  {
    word: "công chứng",
    part_of_speech: "danh từ",
    meaning:
      "cơ quan nhà nước có thẩm quyền công chứng: công chứng nhà nước * dấu công chứng",
    example: "công chứng nhà nước * dấu công chứng",
  },
  {
    word: "công chuyện",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) việc, công việc: bận lo công chuyện * đi có công chuyện",
    example: "bận lo công chuyện * đi có công chuyện",
  },
  {
    word: "công cụ",
    part_of_speech: "danh từ",
    meaning: "đồ dùng để lao động, sản xuất: công cụ sản xuất",
    example: "công cụ sản xuất",
  },
  {
    word: "công cụ",
    part_of_speech: "danh từ",
    meaning:
      "cái được dùng để tiến hành một việc nào đó, hoặc để đạt đến một mục đích nào đó: ngôn ngữ là công cụ giao tiếp của con người * từ điển là loại sách công cụ",
    example:
      "ngôn ngữ là công cụ giao tiếp của con người * từ điển là loại sách công cụ",
  },
  {
    word: "công cuộc",
    part_of_speech: "danh từ",
    meaning:
      "việc lớn có tính chất chung cho cả xã hội: công cuộc kháng chiến kiến quốc * công cuộc xây dựng nước nhà",
    example: "công cuộc kháng chiến kiến quốc * công cuộc xây dựng nước nhà",
  },
  {
    word: "công chức",
    part_of_speech: "danh từ",
    meaning:
      "người được tuyển dụng và bổ nhiệm giữ một công vụ thường xuyên trong cơ quan nhà nước, hưởng lương từ ngân sách nhà nước: thi tuyển công chức",
    example: "thi tuyển công chức",
  },
  {
    word: "công cộng",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về mọi người hoặc để phục vụ chung cho mọi người trong xã hội: bể nước công cộng * trạm điện thoại công cộng",
    example: "bể nước công cộng * trạm điện thoại công cộng",
  },
  {
    word: "cộng cư",
    part_of_speech: "động từ",
    meaning:
      "(các dân tộc) sống cùng, sống chung trên một vùng đất, một địa bàn: địa bàn là nơi cộng cư của nhiều dân tộc",
    example: "địa bàn là nơi cộng cư của nhiều dân tộc",
  },
  {
    word: "công danh",
    part_of_speech: "danh từ",
    meaning:
      "sự nghiệp, địa vị và tiếng tăm trong xã hội: bước đường công danh * công danh thành đạt",
    example: "bước đường công danh * công danh thành đạt",
  },
  {
    word: "công diễn",
    part_of_speech: "động từ",
    meaning:
      "diễn công khai và chính thức trước công chúng: vở kịch được công diễn tại nhà hát thành phố",
    example: "vở kịch được công diễn tại nhà hát thành phố",
  },
  {
    word: "công dụng",
    part_of_speech: "danh từ",
    meaning: "lợi ích mang lại khi đem sử dụng: công dụng của thuốc",
    example: "công dụng của thuốc",
  },
  {
    word: "công du",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) (nhân vật quan trọng) đi công tác, đi làm việc công ở nơi xa (thường là ra nước ngoài): chuyến công du nước ngoài của Thủ tướng",
    example: "chuyến công du nước ngoài của Thủ tướng",
  },
  {
    word: "công điện",
    part_of_speech: "danh từ",
    meaning: "điện báo của cơ quan nhà nước: công điện khẩn",
    example: "công điện khẩn",
  },
  {
    word: "công dân",
    part_of_speech: "danh từ",
    meaning:
      "người dân, về mặt có quyền lợi và nghĩa vụ với nhà nước: làm tròn nghĩa vụ công dân * tước quyền công dân",
    example: "làm tròn nghĩa vụ công dân * tước quyền công dân",
  },
  {
    word: "công đoàn",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức quần chúng của công nhân, viên chức có nhiệm vụ bảo vệ những lợi ích kinh tế, chính trị và xã hội cho người lao động: công đoàn nhà máy * thành lập các công đoàn cơ sở",
    example: "công đoàn nhà máy * thành lập các công đoàn cơ sở",
  },
  {
    word: "công đoạn",
    part_of_speech: "danh từ",
    meaning:
      "khâu hoặc giai đoạn trong dây chuyền làm việc hoặc sản xuất mang tính công nghiệp: công đoạn lắp ráp * các công đoạn xử lí nước sạch",
    example: "công đoạn lắp ráp * các công đoạn xử lí nước sạch",
  },
  {
    word: "cộng đồng",
    part_of_speech: "danh từ",
    meaning:
      "toàn thể những người cùng sống, có những điểm giống nhau, gắn bó thành một khối trong sinh hoạt xã hội: cộng đồng làng xã * hoà nhập với cộng đồng",
    example: "cộng đồng làng xã * hoà nhập với cộng đồng",
  },
  {
    word: "công đường",
    part_of_speech: "danh từ",
    meaning:
      "(Từ cũ) nơi làm việc của quan lại thời phong kiến: bị đưa ra công đường xét xử",
    example: "bị đưa ra công đường xét xử",
  },
  {
    word: "công hiệu",
    part_of_speech: "danh từ",
    meaning: "kết quả, tác dụng thấy rõ ngay: công hiệu của thuốc",
    example: "công hiệu của thuốc",
  },
  {
    word: "công hiệu",
    part_of_speech: "tính từ",
    meaning: "có kết quả, tác dụng tốt: thuốc đã uống nhưng không công hiệu",
    example: "thuốc đã uống nhưng không công hiệu",
  },
  {
    word: "cống hiến",
    part_of_speech: "động từ",
    meaning:
      "đóng góp cái quý giá của mình vào sự nghiệp chung: đem tài năng cống hiến cho đất nước * cống hiến tuổi xuân cho nghệ thuật",
    example:
      "đem tài năng cống hiến cho đất nước * cống hiến tuổi xuân cho nghệ thuật",
  },
  {
    word: "cống hiến",
    part_of_speech: "động từ",
    meaning:
      "đưa ra để phục vụ tập thể (cái do công sức của mình tạo ra; thường nói về văn học, nghệ thuật): đoàn ca kịch đã cống hiến cho khán giả một đêm diễn tuyệt vời",
    example: "đoàn ca kịch đã cống hiến cho khán giả một đêm diễn tuyệt vời",
  },
  {
    word: "cống hiến",
    part_of_speech: "danh từ",
    meaning:
      "sự cống hiến, phần cống hiến: những cống hiến to lớn cho nền khoa học nước nhà",
    example: "những cống hiến to lớn cho nền khoa học nước nhà",
  },
  {
    word: "công đức",
    part_of_speech: "danh từ",
    meaning:
      "công lao và ân đức đối với xã hội: ca tụng công đức của tiền nhân",
    example: "ca tụng công đức của tiền nhân",
  },
  {
    word: "công hầu",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) tước công và tước hầu; chức tước cao trong triều đình phong kiến (nói khái quát): "Áo xiêm ràng buộc lấy nhau, Vào luồn ra cúi công hầu mà chi?" (TKiều)',
    example:
      'Áo xiêm ràng buộc lấy nhau, Vào luồn ra cúi công hầu mà chi?" (TKiều)',
  },
  {
    word: "công hàm",
    part_of_speech: "danh từ",
    meaning:
      "công văn ngoại giao của nước này gửi cho nước khác: trao đổi công hàm giữa hai nước",
    example: "trao đổi công hàm giữa hai nước",
  },
  {
    word: "cộng hoà",
    part_of_speech: "tính từ",
    meaning:
      "(chính thể) có quyền lực tối cao thuộc về các cơ quan dân cử: nền cộng hoà",
    example: "nền cộng hoà",
  },
  {
    word: "cộng hoà",
    part_of_speech: "danh từ",
    meaning:
      "(thường viết hoa) nước theo chế độ cộng hoà: Cộng hoà xã hội chủ nghĩa Việt Nam * Cộng hoà Pháp",
    example: "Cộng hoà xã hội chủ nghĩa Việt Nam * Cộng hoà Pháp",
  },
  {
    word: "cộng hưởng",
    part_of_speech: "",
    meaning:
      "(hiện tượng một hệ được kích thích) dao động với biên độ rất lớn khi tần số của dao động kích thích bằng hoặc gần bằng tần số của dao động riêng của hệ: cộng hưởng từ * hộp cộng hưởng của đàn bầu",
    example: "cộng hưởng từ * hộp cộng hưởng của đàn bầu",
  },
  {
    word: "công hữu",
    part_of_speech: "tính từ",
    meaning:
      "thuộc quyền sở hữu của toàn xã hội hoặc của tập thể; phân biệt với tư hữu: tài sản công hữu",
    example: "tài sản công hữu",
  },
  {
    word: "cồng kềnh",
    part_of_speech: "tính từ",
    meaning:
      "(đồ vật) không gọn, choán nhiều chỗ và gây vướng víu: hàng hoá chất cồng kềnh trên xe * mang vác cồng kềnh",
    example: "hàng hoá chất cồng kềnh trên xe * mang vác cồng kềnh",
  },
  {
    word: "cồng kềnh",
    part_of_speech: "tính từ",
    meaning:
      "(tổ chức) có nhiều bộ phận không cần thiết, làm vướng sự hoạt động: biên chế cồng kềnh * bộ máy hành chính cồng kềnh",
    example: "biên chế cồng kềnh * bộ máy hành chính cồng kềnh",
  },
  {
    word: "công ích",
    part_of_speech: "danh từ",
    meaning:
      "lợi ích chung, lợi ích công cộng: dịch vụ công ích * lao động công ích * làm việc công ích",
    example: "dịch vụ công ích * lao động công ích * làm việc công ích",
  },
  {
    word: "công khai",
    part_of_speech: "",
    meaning:
      "không giữ kín, không giấu giếm mà để cho mọi người đều có thể biết: phiên toà xét xử công khai * công khai tài chính",
    example: "phiên toà xét xử công khai * công khai tài chính",
  },
  {
    word: "công hữu hoá",
    part_of_speech: "động từ",
    meaning:
      "làm cho tư liệu sản xuất từ chỗ là của tư nhân trở thành của chung của toàn xã hội hoặc của tập thể: công hữu hoá ruộng đất",
    example: "công hữu hoá ruộng đất",
  },
  {
    word: "công kênh",
    part_of_speech: "động từ",
    meaning:
      "mang người nào đó đi bằng cách để ngồi hoặc đứng trên vai: công kênh con lên vai",
    example: "công kênh con lên vai",
  },
  {
    word: "công kích",
    part_of_speech: "động từ",
    meaning: "tiến công bằng binh lực và hoả lực mạnh: công kích mục tiêu",
    example: "công kích mục tiêu",
  },
  {
    word: "công kích",
    part_of_speech: "động từ",
    meaning:
      "chỉ trích, phản đối gay gắt: bị công kích kịch liệt * công kích thói cửa quyền",
    example: "bị công kích kịch liệt * công kích thói cửa quyền",
  },
  {
    word: "công lao",
    part_of_speech: "danh từ",
    meaning:
      "công đóng góp cho việc chung, sự nghiệp chung: có công lao với tổ quốc * lập nhiều công lao",
    example: "có công lao với tổ quốc * lập nhiều công lao",
  },
  {
    word: "công lao",
    part_of_speech: "danh từ",
    meaning:
      'công sức khó nhọc, vất vả: công lao học hành * "Em đừng đắn thấp đo cao, Để anh đi lại công lao nhọc nhằn." (ca dao)',
    example:
      'công lao học hành * "Em đừng đắn thấp đo cao, Để anh đi lại công lao nhọc nhằn." (ca dao)',
  },
  {
    word: "công khố",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) kho cất giữ tiền bạc của nhà nước: trông coi công khố * tiền để trong công khố",
    example: "trông coi công khố * tiền để trong công khố",
  },
  {
    word: "công khố",
    part_of_speech: "danh từ",
    meaning: "công quỹ: hao hụt công khố",
    example: "hao hụt công khố",
  },
  {
    word: "công lập",
    part_of_speech: "tính từ",
    meaning:
      "do nhà nước lập ra; phân biệt với dân lập: trường đại học công lập",
    example: "trường đại học công lập",
  },
  {
    word: "công lênh",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) công sức bỏ vào việc gì: "Chàng ơi! Có thấu chăng chàng, Một bát cơm vàng, biết mấy công lênh." (ca dao)',
    example:
      'Chàng ơi! Có thấu chăng chàng, Một bát cơm vàng, biết mấy công lênh." (ca dao)',
  },
  {
    word: "công luận",
    part_of_speech: "danh từ",
    meaning:
      "dư luận chung của xã hội: tiếng nói của công luận * đưa vấn đề ra trước công luận",
    example: "tiếng nói của công luận * đưa vấn đề ra trước công luận",
  },
  {
    word: "công lên việc xuống",
    part_of_speech: "",
    meaning:
      "bận bịu nhiều công việc (thường là việc quan trọng): công lên việc xuống gì mà bắt người khác phải phục dịch?",
    example: "công lên việc xuống gì mà bắt người khác phải phục dịch?",
  },
  {
    word: "công lí",
    part_of_speech: "danh từ",
    meaning:
      "lẽ phù hợp với đạo lí và lợi ích chung của xã hội: yêu hoà bình và công lí * cán cân công lí * đấu tranh vì công lí",
    example: "yêu hoà bình và công lí * cán cân công lí * đấu tranh vì công lí",
  },
  {
    word: "công lý",
    part_of_speech: "danh từ",
    meaning:
      "lẽ phù hợp với đạo lí và lợi ích chung của xã hội: yêu hoà bình và công lí * cán cân công lí * đấu tranh vì công lí",
    example: "yêu hoà bình và công lí * cán cân công lí * đấu tranh vì công lí",
  },
  {
    word: "công minh",
    part_of_speech: "tính từ",
    meaning:
      "công bằng và sáng suốt: thưởng phạt công minh * xét xử rất công minh",
    example: "thưởng phạt công minh * xét xử rất công minh",
  },
  {
    word: "công lực",
    part_of_speech: "danh từ",
    meaning:
      "sức mạnh đặc biệt từ bên trong con người (do luyện tập công phu mà có) tác động trực tiếp đến đối tượng và làm cho đối tượng có những biến đổi nhất định: phế bỏ toàn bộ công lực",
    example: "phế bỏ toàn bộ công lực",
  },
  {
    word: "công môn",
    part_of_speech: "danh từ",
    meaning: "(cũ) cửa công: chốn công môn",
    example: "chốn công môn",
  },
  {
    word: "công năng",
    part_of_speech: "danh từ",
    meaning: "như chức năng: công năng của máy",
    example: "công năng của máy",
  },
  {
    word: "công mẫu",
    part_of_speech: "danh từ",
    meaning: "(cũ, hiếm) hecta: khu vườn ngót nửa công mẫu",
    example: "khu vườn ngót nửa công mẫu",
  },
  {
    word: "công nghệ",
    part_of_speech: "danh từ",
    meaning:
      "tổng thể nói chung các phương tiện kĩ thuật, các phương pháp tổ chức, quản lí được sử dụng vào quy trình sản xuất để tạo ra các sản phẩm vật chất và dịch vụ: công nghệ khai thác mỏ * công nghệ sản xuất phần mềm",
    example: "công nghệ khai thác mỏ * công nghệ sản xuất phần mềm",
  },
  {
    word: "cống nạp",
    part_of_speech: "động từ",
    meaning: "(cũ, hiếm) cống (nói khái quát): cống nạp vật phẩm",
    example: "cống nạp vật phẩm",
  },
  {
    word: "cống nạp",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đưa ra, nộp (cho kẻ mạnh hơn) để được yên ổn: có gì thì mau cống nạp ra đây!",
    example: "có gì thì mau cống nạp ra đây!",
  },
  {
    word: "công nghệ sinh học",
    part_of_speech: "danh từ",
    meaning:
      "tổng thể nói chung những phương pháp kĩ thuật dùng các bộ phận của cơ thể sống (mô, tế bào, v.v.) và những quá trình sinh học để sản xuất những sản phẩm cần thiết cho nền kinh tế quốc dân: xử lí nước thải bằng công nghệ sinh học",
    example: "xử lí nước thải bằng công nghệ sinh học",
  },
  {
    word: "công nghiệp hoá",
    part_of_speech: "",
    meaning:
      "làm cho tất cả các ngành của nền kinh tế quốc dân và đặc biệt trong công nghiệp trở thành nền sản xuất cơ khí lớn, dẫn tới sự tăng nhanh về trình độ kĩ thuật cho lao động và nâng cao năng suất lao động: quá trình công nghiệp hoá đất nước",
    example: "quá trình công nghiệp hoá đất nước",
  },
  {
    word: "công nghiệp",
    part_of_speech: "danh từ",
    meaning:
      "ngành chủ đạo của nền kinh tế quốc dân hiện đại, bao gồm các xí nghiệp khai thác và chế biến nguyên vật liệu, nhiên liệu (rừng, biển, mỏ, v.v.), chế tạo công cụ lao động và hàng tiêu dùng (máy móc, động cơ, v.v.), chế biến sản phẩm của các ngành nông nghiệp, lâm nghiệp, ngư nghiệp, v.v.: nền công nghiệp tiên tiến * phát triển công nghiệp",
    example: "nền công nghiệp tiên tiến * phát triển công nghiệp",
  },
  {
    word: "công nguyên",
    part_of_speech: "danh từ",
    meaning:
      "(thường viết tắt CN) mốc để tính thời gian theo công lịch (lấy năm Chúa Jesus ra đời theo truyền thuyết làm năm bắt đầu): những năm đầu công nguyên * trước công nguyên",
    example: "những năm đầu công nguyên * trước công nguyên",
  },
  {
    word: "công nhận",
    part_of_speech: "động từ",
    meaning:
      "thừa nhận là đúng với sự thật, với lẽ phải hoặc là hợp lệ: được công nhận là dũng sĩ * phải công nhận giỏi",
    example: "được công nhận là dũng sĩ * phải công nhận giỏi",
  },
  {
    word: "công nhân",
    part_of_speech: "danh từ",
    meaning:
      "người lao động chân tay làm việc ăn lương, trong các nhà máy, xí nghiệp, công trường, v.v.: công nhân nhà máy dệt * đội ngũ công nhân lành nghề",
    example: "công nhân nhà máy dệt * đội ngũ công nhân lành nghề",
  },
  {
    word: "công nhiên",
    part_of_speech: "phụ từ",
    meaning:
      "một cách công khai trước mọi người (nói về việc mà thường không dám làm công khai): công nhiên ăn đút lót * cậy có thế lực nên công nhiên làm càn",
    example: "công nhiên ăn đút lót * cậy có thế lực nên công nhiên làm càn",
  },
  {
    word: "công nông",
    part_of_speech: "danh từ",
    meaning: "công nhân và nông dân (nói gộp): khối liên minh công nông",
    example: "khối liên minh công nông",
  },
  {
    word: "công nông",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) xe công nông (nói tắt): đường cấm công nông và xe thồ",
    example: "đường cấm công nông và xe thồ",
  },
  {
    word: "công nhật",
    part_of_speech: "danh từ",
    meaning: "tiền công lao động từng ngày: lương công nhật",
    example: "lương công nhật",
  },
  {
    word: "công nhật",
    part_of_speech: "danh từ",
    meaning:
      "việc làm mà tiền công được tính theo từng ngày một: làm công nhật",
    example: "làm công nhật",
  },
  {
    word: "công nợ",
    part_of_speech: "danh từ",
    meaning:
      "các khoản nợ của một cá nhân (nói khái quát): thanh toán công nợ * công nợ trả dần",
    example: "thanh toán công nợ * công nợ trả dần",
  },
  {
    word: "công ơn",
    part_of_speech: "danh từ",
    meaning:
      "công lao đáng ghi nhớ và biết ơn: công ơn trời biển * công ơn của cha mẹ",
    example: "công ơn trời biển * công ơn của cha mẹ",
  },
  {
    word: "công phá",
    part_of_speech: "động từ",
    meaning:
      "tiến công mãnh liệt vào một khu vực được phòng ngự kiên cố nào đó: công phá thành trì * dùng hoả lực mạnh công phá đồn giặc",
    example: "công phá thành trì * dùng hoả lực mạnh công phá đồn giặc",
  },
  {
    word: "công phá",
    part_of_speech: "động từ",
    meaning: "phá huỷ mạnh mẽ, làm nổ tung ra: sức công phá của khối thuốc nổ",
    example: "sức công phá của khối thuốc nổ",
  },
  {
    word: "công quĩ",
    part_of_speech: "danh từ",
    meaning:
      "quỹ chung của nhà nước hoặc của một tổ chức: đóng góp vào công quỹ * tiền công quỹ",
    example: "đóng góp vào công quỹ * tiền công quỹ",
  },
  {
    word: "công phẫn",
    part_of_speech: "động từ",
    meaning:
      "(công chúng) phẫn nộ trước hành động đáng lên án: nhân dân thế giới vô cùng công phẫn trước tội ác dã man của bọn phát xít",
    example:
      "nhân dân thế giới vô cùng công phẫn trước tội ác dã man của bọn phát xít",
  },
  {
    word: "công phu",
    part_of_speech: "danh từ",
    meaning:
      "công sức và thì giờ bỏ ra, thường là nhiều, để làm việc gì: công phu học tập * mất nhiều công phu",
    example: "công phu học tập * mất nhiều công phu",
  },
  {
    word: "công phu",
    part_of_speech: "tính từ",
    meaning:
      "rất kĩ lưỡng, độc đáo, mất nhiều công sức: chiếc tủ được chạm trổ rất công phu",
    example: "chiếc tủ được chạm trổ rất công phu",
  },
  {
    word: "cống phẩm",
    part_of_speech: "danh từ",
    meaning: "(cũ) vật đem đi cống nạp: nộp cống phẩm",
    example: "nộp cống phẩm",
  },
  {
    word: "công quỹ",
    part_of_speech: "danh từ",
    meaning:
      "quỹ chung của nhà nước hoặc của một tổ chức: đóng góp vào công quỹ * tiền công quỹ",
    example: "đóng góp vào công quỹ * tiền công quỹ",
  },
  {
    word: "công quả",
    part_of_speech: "danh từ",
    meaning: "như chính quả: tu thành công quả",
    example: "tu thành công quả",
  },
  {
    word: "công quyền",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về bộ máy, cơ quan quyền lực nhà nước: cải tổ bộ máy công quyền",
    example: "cải tổ bộ máy công quyền",
  },
  {
    word: "cổng rả",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) cổng (nói khái quát): cổng rả đóng cẩn thận",
    example: "cổng rả đóng cẩn thận",
  },
  {
    word: "cống rãnh",
    part_of_speech: "danh từ",
    meaning:
      "cống và rãnh, chỉ đường thoát nước bẩn (nói khái quát): khai thông cống rãnh",
    example: "khai thông cống rãnh",
  },
  {
    word: "công sở",
    part_of_speech: "danh từ",
    meaning: "trụ sở của cơ quan nhà nước: làm việc ở công sở",
    example: "làm việc ở công sở",
  },
  {
    word: "công sai",
    part_of_speech: "danh từ",
    meaning:
      "số mà cộng vào mỗi số hạng của một cấp số cộng thì được số hạng liền sau: cấp số cộng 5, 10, 15, 20, 25, 30 có công sai 5",
    example: "cấp số cộng 5, 10, 15, 20, 25, 30 có công sai 5",
  },
  {
    word: "công sai",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người nhà nước thời phong kiến được sai đi xa để làm việc công: viên công sai của triều đình",
    example: "viên công sai của triều đình",
  },
  {
    word: "cộng sinh",
    part_of_speech: "động từ",
    meaning:
      "(sinh vật không cùng một loài) sống chung và cùng làm lợi cho nhau: ở rễ cây họ đậu thường có vi khuẩn cộng sinh tạo thành những nốt sần",
    example:
      "ở rễ cây họ đậu thường có vi khuẩn cộng sinh tạo thành những nốt sần",
  },
  {
    word: "cộng sản",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất của chủ nghĩa cộng sản; theo chủ nghĩa cộng sản: tư tưởng cộng sản * người chiến sĩ cộng sản",
    example: "tư tưởng cộng sản * người chiến sĩ cộng sản",
  },
  {
    word: "cộng sản",
    part_of_speech: "tính từ",
    meaning: "thuộc về đảng cộng sản: đảng viên cộng sản",
    example: "đảng viên cộng sản",
  },
  {
    word: "cộng sản chủ nghĩa",
    part_of_speech: "tính từ",
    meaning:
      "(ý thức, tư tưởng) có tính chất của chủ nghĩa cộng sản: nhân sinh quan cộng sản chủ nghĩa",
    example: "nhân sinh quan cộng sản chủ nghĩa",
  },
  {
    word: "công sự",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi chung các công trình quân sự dùng để chiến đấu và phòng tránh như hầm, hào, hố, v.v.: đào công sự",
    example: "đào công sự",
  },
  {
    word: "công suất",
    part_of_speech: "danh từ",
    meaning:
      "công sản xuất hoặc tiêu thụ trong một đơn vị thời gian: nhà máy điện có công suất 500.000 kilowatt",
    example: "nhà máy điện có công suất 500.000 kilowatt",
  },
  {
    word: "công suất",
    part_of_speech: "danh từ",
    meaning:
      "khả năng của máy móc, thiết bị làm ra một khối lượng sản phẩm nhất định trong một đơn vị thời gian nhất định: sử dụng hết công suất máy móc, thiết bị",
    example: "sử dụng hết công suất máy móc, thiết bị",
  },
  {
    word: "cộng sự",
    part_of_speech: "động từ",
    meaning:
      "cùng làm chung một nhiệm vụ trong một tổ chức: hai người cộng sự với nhau",
    example: "hai người cộng sự với nhau",
  },
  {
    word: "cộng sự",
    part_of_speech: "danh từ",
    meaning:
      "người trực tiếp giúp việc để hoàn thành một nhiệm vụ: đề tài do giáo sư cùng các cộng sự nghiên cứu",
    example: "đề tài do giáo sư cùng các cộng sự nghiên cứu",
  },
  {
    word: "công sức",
    part_of_speech: "danh từ",
    meaning:
      "công lao và sức lực bỏ ra, thường là nhiều, để làm việc gì (nói khái quát): bỏ công sức ra để làm * đóng góp công sức",
    example: "bỏ công sức ra để làm * đóng góp công sức",
  },
  {
    word: "cộng tác",
    part_of_speech: "động từ",
    meaning:
      "cùng góp sức hoàn thành một công việc nhằm một mục đích chung, nhưng có thể không cùng chung một trách nhiệm: cộng tác làm ăn * cộng tác với vài tờ báo",
    example: "cộng tác làm ăn * cộng tác với vài tờ báo",
  },
  {
    word: "công tác",
    part_of_speech: "danh từ",
    meaning:
      "công việc của nhà nước hoặc của đoàn thể: công tác phòng gian * báo cáo công tác",
    example: "công tác phòng gian * báo cáo công tác",
  },
  {
    word: "công tác",
    part_of_speech: "động từ",
    meaning:
      "làm công việc của nhà nước, của đoàn thể: yên tâm công tác * công tác tại bệnh viện",
    example: "yên tâm công tác * công tác tại bệnh viện",
  },
  {
    word: "công tác",
    part_of_speech: "động từ",
    meaning:
      "làm việc tại một nơi khác, xa nơi làm việc thường ngày, trong một thời gian nhất định: đi công tác * chuyến công tác dài ngày",
    example: "đi công tác * chuyến công tác dài ngày",
  },
  {
    word: "công tâm",
    part_of_speech: "",
    meaning:
      "lòng ngay thẳng, chỉ vì việc chung chứ không vì tư lợi hoặc thiên vị: trọng tài xử thiếu công tâm * công tâm mà nói, nó làm thế là đúng",
    example:
      "trọng tài xử thiếu công tâm * công tâm mà nói, nó làm thế là đúng",
  },
  {
    word: "cổng tán",
    part_of_speech: "danh từ",
    meaning:
      "công trình ngầm hoặc lộ thiên để nước tự chảy qua, dùng vào việc lấy nước, tháo nước hoặc điều tiết nước: xây cống thoát nước * nạo vét cống, rãnh",
    example: "xây cống thoát nước * nạo vét cống, rãnh",
  },
  {
    word: "cổng tán",
    part_of_speech: "động từ",
    meaning:
      "(cũ) dâng nộp vật phẩm cho vua chúa hay nước mà mình chịu thần phục, thời phong kiến: cống vật phẩm",
    example: "cống vật phẩm",
  },
  {
    word: "công tác phí",
    part_of_speech: "danh từ",
    meaning: "khoản chi phí cấp cho người đi công tác: thanh toán công tác phí",
    example: "thanh toán công tác phí",
  },
  {
    word: "công tắc",
    part_of_speech: "danh từ",
    meaning:
      "mặt tiếp xúc của các bộ phận hợp thành mạch điện, có tính dẫn điện.",
    example: "bật công tắc đèn",
  },
  {
    word: "cộng tác viên",
    part_of_speech: "danh từ",
    meaning:
      "người cộng tác trong một công việc tập thể: làm cộng tác viên cho một tờ báo tỉnh",
    example: "làm cộng tác viên cho một tờ báo tỉnh",
  },
  {
    word: "công thần",
    part_of_speech: "danh từ",
    meaning:
      "quan có công lớn đối với triều đình thời phong kiến: Nguyễn Trãi là công thần đời Lê",
    example: "Nguyễn Trãi là công thần đời Lê",
  },
  {
    word: "công thần",
    part_of_speech: "tính từ",
    meaning:
      "có tư tưởng dựa vào công lao đóng góp của mình mà sinh ra kiêu ngạo và đòi hỏi đãi ngộ quá đáng: bệnh công thần",
    example: "bệnh công thần",
  },
  {
    word: "công thủ",
    part_of_speech: "danh từ",
    meaning: "công và thủ (nói gộp): võ sĩ có khả năng công thủ toàn diện",
    example: "võ sĩ có khả năng công thủ toàn diện",
  },
  {
    word: "công thự",
    part_of_speech: "danh từ",
    meaning:
      "toà nhà lớn dùng làm công sở: thành phố có nhiều toà công thự hiện đại",
    example: "thành phố có nhiều toà công thự hiện đại",
  },
  {
    word: "công thức hoá học",
    part_of_speech: "danh từ",
    meaning:
      "nhóm kí hiệu hoá học biểu diễn thành phần phân tử của một chất: công thức hoá học của nước là H2O",
    example: "công thức hoá học của nước là H2O",
  },
  {
    word: "công thức",
    part_of_speech: "danh từ",
    meaning:
      "nhóm kí hiệu diễn tả gọn một sự kiện tổng quát, một quy tắc, nguyên lí hoặc khái niệm: S = ab là công thức tính diện tích hình chữ nhật (S là diện tích; a, b là các cạnh)",
    example:
      "S = ab là công thức tính diện tích hình chữ nhật (S là diện tích; a, b là các cạnh)",
  },
  {
    word: "công thức",
    part_of_speech: "danh từ",
    meaning:
      "những phương pháp, quy tắc, v.v. đã được định sẵn, cần và phải làm theo để làm một việc nào đó đạt kết quả mong muốn: công thức pha chế rượu * công thức chế biến thức ăn",
    example: "công thức pha chế rượu * công thức chế biến thức ăn",
  },
  {
    word: "công thức",
    part_of_speech: "danh từ",
    meaning:
      "cách thức được dùng theo thói quen hoặc theo quy ước, trong những dịp hoặc trường hợp nhất định: công thức xã giao * công thức lễ nghi",
    example: "công thức xã giao * công thức lễ nghi",
  },
  {
    word: "công thức",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất rập khuôn, máy móc: lối làm việc quá công thức * tính toán hơi công thức",
    example: "lối làm việc quá công thức * tính toán hơi công thức",
  },
  {
    word: "công thương",
    part_of_speech: "danh từ",
    meaning:
      "công nghiệp và thương nghiệp (nói gộp): giới công thương * ngân hàng công thương",
    example: "giới công thương * ngân hàng công thương",
  },
  {
    word: "công ti",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức kinh doanh do nhiều thành viên cùng góp vốn, cùng chia lợi nhuận hoặc cùng chịu lỗ, tương ứng với phần vốn góp: lập công ti * công ti xuyên quốc gia",
    example: "lập công ti * công ti xuyên quốc gia",
  },
  {
    word: "công tố",
    part_of_speech: "động từ",
    meaning:
      "điều tra, truy tố và buộc tội kẻ phạm pháp trước toà án: vị công tố",
    example: "vị công tố",
  },
  {
    word: "công tơ",
    part_of_speech: "danh từ",
    meaning:
      "khí cụ đo và ghi lượng điện, nước, hơi, v.v. đã dùng hoặc đã đi qua: lắp công tơ điện",
    example: "lắp công tơ điện",
  },
  {
    word: "công toi",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) công mất đi một cách uổng phí, vô ích: mất công toi",
    example: "mất công toi",
  },
  {
    word: "công trạng",
    part_of_speech: "danh từ",
    meaning:
      "công lao to lớn đối với đất nước, đối với dân tộc: lập được nhiều công trạng * không làm nên công trạng gì",
    example: "lập được nhiều công trạng * không làm nên công trạng gì",
  },
  {
    word: "công trái",
    part_of_speech: "danh từ",
    meaning:
      "hình thức nhà nước vay vốn của nhân dân thông qua việc phát hành một loại phiếu đặc biệt ghi nhận khoản vốn vay (trái phiếu), người cho vay được quyền thu lại vốn và hưởng lãi theo quy định.",
    example: "phát hành công trái * mua công trái",
  },
  {
    word: "công trình",
    part_of_speech: "danh từ",
    meaning:
      "tổ hợp xây dựng đòi hỏi phải sử dụng kĩ thuật phức tạp: công trình kiến trúc * công trình đường hầm vượt biển",
    example: "công trình kiến trúc * công trình đường hầm vượt biển",
  },
  {
    word: "công trình",
    part_of_speech: "danh từ",
    meaning:
      "tác phẩm nghệ thuật, khoa học đòi hỏi nhiều công phu: công trình khoa học cấp nhà nước * công trình điêu khắc có giá trị nghệ thuật cao",
    example:
      "công trình khoa học cấp nhà nước * công trình điêu khắc có giá trị nghệ thuật cao",
  },
  {
    word: "công trình",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, hiếm) công phu khó nhọc: "Đã mang nhân ngãi vào mình, Bỏ đi thì tiếc công trình xưa nay." (ca dao)',
    example:
      'Đã mang nhân ngãi vào mình, Bỏ đi thì tiếc công trình xưa nay." (ca dao)',
  },
  {
    word: "công trình phụ",
    part_of_speech: "danh từ",
    meaning:
      "phần của nhà, gồm bếp, nhà vệ sinh, nhà tắm, v.v.: nhà có công trình phụ khép kín",
    example: "nhà có công trình phụ khép kín",
  },
  {
    word: "công trường",
    part_of_speech: "danh từ",
    meaning:
      "nơi tiến hành công việc xây dựng hoặc khai thác, có tập trung đông người và phương tiện: công trường khai thác đá * công trường xây dựng * làm việc ngoài công trường",
    example:
      "công trường khai thác đá * công trường xây dựng * làm việc ngoài công trường",
  },
  {
    word: "công tước",
    part_of_speech: "danh từ",
    meaning: "người có tước công (ở các nước phương Tây): ngài công tước",
    example: "ngài công tước",
  },
  {
    word: "công ty",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức kinh doanh do nhiều thành viên cùng góp vốn, cùng chia lợi nhuận hoặc cùng chịu lỗ, tương ứng với phần vốn góp: lập công ti * công ti xuyên quốc gia",
    example: "lập công ti * công ti xuyên quốc gia",
  },
  {
    word: "công vụ",
    part_of_speech: "danh từ",
    meaning: "việc công: cố ý hành hung người thi hành công vụ",
    example: "cố ý hành hung người thi hành công vụ",
  },
  {
    word: "công việc",
    part_of_speech: "danh từ",
    meaning:
      "việc phải bỏ công sức ra để làm: công việc làm ăn * công việc nhà nông * còn bỡ ngỡ với công việc mới",
    example:
      "công việc làm ăn * công việc nhà nông * còn bỡ ngỡ với công việc mới",
  },
  {
    word: "công văn",
    part_of_speech: "danh từ",
    meaning:
      "giấy tờ trao đổi, giao thiệp về công việc của tổ chức, cơ quan: thảo công văn",
    example: "thảo công văn",
  },
  {
    word: "công ước",
    part_of_speech: "danh từ",
    meaning:
      "điều ước do nhiều nước cùng kí kết để quy định các nguyên tắc, thể lệ cho từng vấn đề trong quan hệ quốc tế: công ước Bern về quyền sở hữu trí tuệ * kí công ước quốc tế",
    example: "công ước Bern về quyền sở hữu trí tuệ * kí công ước quốc tế",
  },
  {
    word: "công xá",
    part_of_speech: "danh từ",
    meaning: "tiền công trả cho người làm (nói khái quát): công xá rẻ mạt",
    example: "công xá rẻ mạt",
  },
  {
    word: "công xã",
    part_of_speech: "danh từ",
    meaning:
      "hình thức tổ chức kinh tế - xã hội cơ bản của xã hội cộng sản nguyên thuỷ, trong đó tư liệu sản xuất và sản phẩm đều là của chung, chưa phân hoá giai cấp, chưa có nhà nước: công xã nguyên thuỷ",
    example: "công xã nguyên thuỷ",
  },
  {
    word: "công-te-nơ",
    part_of_speech: "danh từ",
    meaning:
      "thiết bị có dạng một thùng chứa hình hộp lớn, có dung tích tiêu chuẩn, dùng để đựng hàng hoá chuyên chở đi xa bằng các loại phương tiện vận tải khác nhau: xe chở container * nhập một container linh kiện máy tính",
    example: "xe chở container * nhập một container linh kiện máy tính",
  },
  {
    word: "công-xéc-tô",
    part_of_speech: "danh từ",
    meaning:
      "bản nhạc hoà tấu cho một nhạc khí và dàn nhạc: bản concerto cho violon và dàn nhạc",
    example: "bản concerto cho violon và dàn nhạc",
  },
  {
    word: "cốp",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) hòm nhỏ của xe, thường dùng làm nơi cất, chứa một số đồ vật: cốp xe máy * đồ đạc để trong cốp xe",
    example: "cốp xe máy * đồ đạc để trong cốp xe",
  },
  {
    word: "cốp",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ, hiếm) như cốc: lấy tay cốp cho mấy cái vào đầu",
    example: "lấy tay cốp cho mấy cái vào đầu",
  },
  {
    word: "cốp",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng trầm, gọn và đanh của các vật cứng chạm mạnh vào nhau: cộc đầu đánh cốp vào tường",
    example: "cộc đầu đánh cốp vào tường",
  },
  {
    word: "cốt cách",
    part_of_speech: "danh từ",
    meaning: "(cũ) hình thể, dáng điệu con người: cốt cách quý phái",
    example: "cốt cách quý phái",
  },
  {
    word: "cốt cách",
    part_of_speech: "danh từ",
    meaning:
      'nét đặc sắc về tính cách: cốt cách của gia đình quyền thế * "Bình dẫu phá còn lề cốt cách, Gương dù tan vẫn sạch trần ai." (TTK)',
    example:
      'cốt cách của gia đình quyền thế * "Bình dẫu phá còn lề cốt cách, Gương dù tan vẫn sạch trần ai." (TTK)',
  },
  {
    word: "cốt",
    part_of_speech: "danh từ",
    meaning:
      "xương của người hoặc động vật chết đã lâu còn lại sau khi phần thịt đã bị phân huỷ hết: xếp cốt vào tiểu",
    example: "xếp cốt vào tiểu",
  },
  {
    word: "cốt",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) xương (nói khái quát): lạnh thấu cốt * calcium và phốt pho rất cần cho việc tạo cốt",
    example: "lạnh thấu cốt * calcium và phốt pho rất cần cho việc tạo cốt",
  },
  {
    word: "cốt",
    part_of_speech: "danh từ",
    meaning:
      "phần khung làm chỗ dựa bên trong cho những phần khác, tạo nên sự vững chắc của toàn khối ở một số vật: cốt mũ được đan bằng tre",
    example: "cốt mũ được đan bằng tre",
  },
  {
    word: "cốt",
    part_of_speech: "danh từ",
    meaning:
      "nội dung chính làm thành cái sườn của tác phẩm văn học: truyện viết không có cốt",
    example: "truyện viết không có cốt",
  },
  {
    word: "cốt",
    part_of_speech: "danh từ",
    meaning:
      "phần nước đậm đặc, tinh tuý nhất do vắt, ép, ngâm hoặc nấu lần đầu mà có: nước cốt trầu * nước mắm cốt",
    example: "nước cốt trầu * nước mắm cốt",
  },
  {
    word: "cốt",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) coi là mục đích chính: mặc cốt ấm, không cần đẹp * nói to cốt để mọi người cùng nghe",
    example: "mặc cốt ấm, không cần đẹp * nói to cốt để mọi người cùng nghe",
  },
  {
    word: "cốt",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) đẵn: cốt cây sát gốc",
    example: "cốt cây sát gốc",
  },
  {
    word: "cốt cán",
    part_of_speech: "danh từ",
    meaning:
      "người hoặc bộ phận nòng cốt tạo nên sức mạnh, sự vững chắc trong một tổ chức, một phong trào xã hội, chính trị, văn hoá, v.v.: cán bộ cốt cán",
    example: "cán bộ cốt cán",
  },
  {
    word: "cột",
    part_of_speech: "danh từ",
    meaning:
      "vật làm bằng vật liệu cứng, chắc, thường có hình trụ tròn, hoặc vuông, dựng thẳng đứng và cố định tại một chỗ, dùng để chống đỡ, treo, mắc, v.v.: cây cột điện * cột nhà",
    example: "cây cột điện * cột nhà",
  },
  {
    word: "cột",
    part_of_speech: "danh từ",
    meaning:
      "khối chất lỏng hoặc chất khí tụ lại với nhau thành hình thẳng đứng: cột khói * cột thuỷ ngân trong ống nghiệm",
    example: "cột khói * cột thuỷ ngân trong ống nghiệm",
  },
  {
    word: "cột",
    part_of_speech: "danh từ",
    meaning:
      "phần sắp xếp, trình bày thành từng khoảng dọc trên trang giấy viết, giấy in: chia cột trên trang in * sách từ điển thường in làm hai cột",
    example: "chia cột trên trang in * sách từ điển thường in làm hai cột",
  },
  {
    word: "cột",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) buộc: cột tóc lại cho gọn * cột trâu vào cọc",
    example: "cột tóc lại cho gọn * cột trâu vào cọc",
  },
  {
    word: "cột",
    part_of_speech: "động từ",
    meaning:
      "làm cho bị gắn chặt vào cái gì đó và khiến cho mất đi sự tự do hoạt động: bị cột chặt vào lễ giáo phong kiến",
    example: "bị cột chặt vào lễ giáo phong kiến",
  },
  {
    word: "cốt lõi",
    part_of_speech: "danh từ",
    meaning: "cái quan trọng nhất, chủ yếu nhất: cốt lõi của vấn đề",
    example: "cốt lõi của vấn đề",
  },
  {
    word: "cốt nhục",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) xương thịt; ví người ruột thịt, máu mủ: tình cốt nhục * anh em cốt nhục",
    example: "tình cốt nhục * anh em cốt nhục",
  },
  {
    word: "cốt nhục tử sinh",
    part_of_speech: "",
    meaning:
      'ơn cứu giúp trong cơn hoạn nạn, tựa như chết rồi cứu cho sống lại: "Dám nhờ cốt nhục tử sinh, Còn nhiều kết cỏ ngậm vành về sau." (TKiều)',
    example:
      'Dám nhờ cốt nhục tử sinh, Còn nhiều kết cỏ ngậm vành về sau." (TKiều)',
  },
  {
    word: "cốt sao",
    part_of_speech: "",
    meaning:
      "tổ hợp biểu thị điều sắp nêu ra mới là cái chủ yếu, là mục đích chính cần đạt cho được (còn những cái khác là không quan trọng): làm thế nào thì làm, cốt sao cho tốt là được",
    example: "làm thế nào thì làm, cốt sao cho tốt là được",
  },
  {
    word: "cốt tử",
    part_of_speech: "tính từ",
    meaning: "quan trọng nhất: vấn đề cốt tử * điều cốt tử",
    example: "vấn đề cốt tử * điều cốt tử",
  },
  {
    word: "cột xăng",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ, khẩu ngữ) như cây xăng: xe ghé vô cột xăng để bơm dầu",
    example: "xe ghé vô cột xăng để bơm dầu",
  },
  {
    word: "cốt tuỷ",
    part_of_speech: "danh từ",
    meaning: "tuỷ xương; ví phần cốt yếu bên trong: cốt tuỷ của tác phẩm",
    example: "cốt tuỷ của tác phẩm",
  },
  {
    word: "cột trụ",
    part_of_speech: "danh từ",
    meaning:
      "cột lớn, vững chắc, để chống đỡ vật nặng: cột trụ bê tông chống đỡ cầu",
    example: "cột trụ bê tông chống đỡ cầu",
  },
  {
    word: "cột trụ",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) như trụ cột: phong trào trở thành cột trụ chính cho mọi hoạt động của hội",
    example: "phong trào trở thành cột trụ chính cho mọi hoạt động của hội",
  },
  {
    word: "cột sống",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) cột xương sống (nói tắt): tổn thương cột sống",
    example: "tổn thương cột sống",
  },
  {
    word: "cột thu lôi",
    part_of_speech: "danh từ",
    meaning:
      "cột kim loại tiếp đất, đặt thẳng đứng trên công trình xây dựng để bảo vệ công trình khỏi bị tác động trực tiếp của sét: cột thu lôi của nhà máy",
    example: "cột thu lôi của nhà máy",
  },
  {
    word: "cơ",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận của cơ thể, có khả năng co dãn để làm các cơ quan khác cử động: luyện tập cơ bụng * hiện tượng căng cơ ở bắp chân * sự co bóp của cơ tim",
    example:
      "luyện tập cơ bụng * hiện tượng căng cơ ở bắp chân * sự co bóp của cơ tim",
  },
  {
    word: "cơ",
    part_of_speech: "danh từ",
    meaning: "con bài tú lơ khơ có in hình ( màu đỏ: con át cơ",
    example: "con át cơ",
  },
  {
    word: "cơ",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) lính của triều đình nhà Nguyễn dưới thời Pháp thuộc, chuyên canh gác và phục dịch trong dinh thự quan lại: cai cơ * lính cơ",
    example: "cai cơ * lính cơ",
  },
  {
    word: "cơ",
    part_of_speech: "danh từ",
    meaning:
      "cái làm cho sự vật biến hoá, làm cho sự việc có khả năng phát sinh: năm nay có cơ được mùa * tuỳ cơ mà ứng biến",
    example: "năm nay có cơ được mùa * tuỳ cơ mà ứng biến",
  },
  {
    word: "cơ",
    part_of_speech: "danh từ",
    meaning:
      'sự vận động, biến hoá theo lẽ mầu nhiệm, theo quan niệm duy tâm: "Cơ trời dâu bể đa đoan, Một nhà để chị riêng oan một mình." (TKiều)',
    example:
      'Cơ trời dâu bể đa đoan, Một nhà để chị riêng oan một mình." (TKiều)',
  },
  {
    word: "cơ",
    part_of_speech: "danh từ",
    meaning:
      'khả năng ứng phó linh hoạt trước sự biến hoá của sự vật: "Thấp cơ thua trí đàn bà, Trông vào đau ruột, nói ra ngại lời." (TKiều)',
    example:
      'Thấp cơ thua trí đàn bà, Trông vào đau ruột, nói ra ngại lời." (TKiều)',
  },
  {
    word: "cơ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) cơ học hoặc cơ khí (nói tắt): tốt nghiệp khoa cơ * đồng hồ cơ (chạy theo nguyên lí cơ học; phân biệt với loại chạy bằng năng lượng điện)",
    example:
      "tốt nghiệp khoa cơ * đồng hồ cơ (chạy theo nguyên lí cơ học; phân biệt với loại chạy bằng năng lượng điện)",
  },
  {
    word: "cơ",
    part_of_speech: "trợ từ",
    meaning:
      "(khẩu ngữ) như kia (thường hàm ý thân mật): đông thế cơ à? * bà bế cháu cơ! * anh bảo gì cơ?",
    example: "đông thế cơ à? * bà bế cháu cơ! * anh bảo gì cơ?",
  },
  {
    word: "cốt yếu",
    part_of_speech: "tính từ",
    meaning:
      "như chính yếu: vấn đề cốt yếu * điều cốt yếu nhất là làm sao được yên ổn",
    example: "vấn đề cốt yếu * điều cốt yếu nhất là làm sao được yên ổn",
  },
  {
    word: "cớ",
    part_of_speech: "danh từ",
    meaning:
      "lí do, nguyên nhân trực tiếp của việc làm: lấy cớ ốm để nghỉ học * chẳng có cớ gì cũng gây chuyện!",
    example: "lấy cớ ốm để nghỉ học * chẳng có cớ gì cũng gây chuyện!",
  },
  {
    word: "cờ",
    part_of_speech: "danh từ",
    meaning:
      "vật làm bằng vải, lụa, v.v., có kích cỡ, hình dáng, màu sắc nhất định, nhiều khi có hình tượng trưng, dùng làm hiệu cho một nước, một tổ chức chính trị, xã hội, v.v. hoặc để báo hiệu: phất cờ làm hiệu * cờ đến tay ai người ấy phất (tng)",
    example: "phất cờ làm hiệu * cờ đến tay ai người ấy phất (tng)",
  },
  {
    word: "cờ",
    part_of_speech: "danh từ",
    meaning:
      "cụm hoa đực mọc ra ở ngọn một số cây như ngô, mía, v.v. (thường vươn cao lên trông như lá cờ): ngô trổ cờ",
    example: "ngô trổ cờ",
  },
  {
    word: "cờ",
    part_of_speech: "danh từ",
    meaning:
      "trò chơi dùng những quân (gọi là quân cờ) dàn ra trên một bàn kẻ ô theo những quy tắc nhất định, thường phân thành hai bên đối địch để tranh phần thắng: đánh cờ",
    example: "đánh cờ",
  },
  {
    word: "cỡ",
    part_of_speech: "danh từ",
    meaning:
      "loại, phân theo độ lớn nhỏ: giày dép đủ các cỡ * một ông chủ cỡ lớn",
    example: "giày dép đủ các cỡ * một ông chủ cỡ lớn",
  },
  {
    word: "cỡ",
    part_of_speech: "danh từ",
    meaning:
      "độ lớn được xác định theo một mức độ nhất định: tiếng casset vặn to hết cỡ * cao quá cỡ",
    example: "tiếng casset vặn to hết cỡ * cao quá cỡ",
  },
  {
    word: "cỡ",
    part_of_speech: "danh từ",
    meaning: "khoảng cách dùng làm chuẩn: lấy gang tay làm cỡ để đo",
    example: "lấy gang tay làm cỡ để đo",
  },
  {
    word: "cỡ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) như khoảng: đứa trẻ cỡ 5, 6 tuổi * thu nhập hằng tháng cỡ 2 triệu đồng",
    example: "đứa trẻ cỡ 5, 6 tuổi * thu nhập hằng tháng cỡ 2 triệu đồng",
  },
  {
    word: "cỡ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có cỡ lớn, thuộc loại đáng kể: cán bộ cỡ * giàu có cỡ ở tỉnh",
    example: "cán bộ cỡ * giàu có cỡ ở tỉnh",
  },
  {
    word: "cơ bắp",
    part_of_speech: "danh từ",
    meaning:
      "bắp thịt; cũng dùng để chỉ công việc, hoạt động thiên về sức mạnh chân tay: cơ bắp nổi cuồn cuộn * sức mạnh cơ bắp * lao động cơ bắp",
    example: "cơ bắp nổi cuồn cuộn * sức mạnh cơ bắp * lao động cơ bắp",
  },
  {
    word: "cơ bản",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) cái làm cơ sở cho những cái khác trong toàn bộ hệ thống: đã giải quyết xong về cơ bản",
    example: "đã giải quyết xong về cơ bản",
  },
  {
    word: "cơ bản",
    part_of_speech: "tính từ",
    meaning:
      "có tác dụng làm cơ sở: khoa học cơ bản * những đổi mới cơ bản về kinh tế * quyền cơ bản nhất của con người",
    example:
      "khoa học cơ bản * những đổi mới cơ bản về kinh tế * quyền cơ bản nhất của con người",
  },
  {
    word: "cờ bạc",
    part_of_speech: "danh từ",
    meaning:
      'các trò chơI ăn thua bằng tiền (nói khái quát): sa vào cờ bạc * "Cờ bạc là bác thằng bần, Cửa nhà bán hết tra chân vào cùm." (ca dao)',
    example:
      'sa vào cờ bạc * "Cờ bạc là bác thằng bần, Cửa nhà bán hết tra chân vào cùm." (ca dao)',
  },
  {
    word: "cơ cầu",
    part_of_speech: "tính từ",
    meaning:
      '(cũ, hiếm) nghiệt ngã, hiểm độc: "Phải người ác nghiệp cơ cầu, Hai con quan Trạng rủ nhau ăn mày." (PCCH)',
    example:
      'Phải người ác nghiệp cơ cầu, Hai con quan Trạng rủ nhau ăn mày." (PCCH)',
  },
  {
    word: "cơ cầu",
    part_of_speech: "tính từ",
    meaning:
      '(cũ) khổ cực, thiếu thốn: "Người dại như củ bồ nâu, Đến khi khốn khó cơ cầu phải ăn." (ca dao)',
    example:
      'Người dại như củ bồ nâu, Đến khi khốn khó cơ cầu phải ăn." (ca dao)',
  },
  {
    word: "cơ cấu",
    part_of_speech: "danh từ",
    meaning:
      "nguyên tắc kết hợp và hoạt động của các chi tiết máy trong cùng một chỉnh thể, theo những quy luật nhất định: cơ cấu chuyển động của tay quay - thanh truyền",
    example: "cơ cấu chuyển động của tay quay - thanh truyền",
  },
  {
    word: "cơ cấu",
    part_of_speech: "danh từ",
    meaning:
      "cách tổ chức các thành phần nhằm thực hiện chức năng của chỉnh thể: điều chỉnh cơ cấu đào tạo * phát triển kinh tế theo cơ cấu vùng miền",
    example:
      "điều chỉnh cơ cấu đào tạo * phát triển kinh tế theo cơ cấu vùng miền",
  },
  {
    word: "cơ chế",
    part_of_speech: "danh từ",
    meaning:
      "cách thức tổ chức nội bộ và quy luật vận hành, biến hoá của một hiện tượng: cơ chế quang hợp của cây xanh * xoá bỏ cơ chế bao cấp",
    example: "cơ chế quang hợp của cây xanh * xoá bỏ cơ chế bao cấp",
  },
  {
    word: "cơ chừng",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị ý phỏng đoán dựa vào sự đánh giá tình hình khách quan: ngồi mãi, cơ chừng đã sốt ruột",
    example: "ngồi mãi, cơ chừng đã sốt ruột",
  },
  {
    word: "cơ chừng này",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị ý phỏng đoán về điều không hay có nhiều khả năng xảy ra, khó tránh khỏi (với hàm ý lo lắng): cứ cơ chừng này rồi lại đói cho mà xem!",
    example: "cứ cơ chừng này rồi lại đói cho mà xem!",
  },
  {
    word: "cơ cực",
    part_of_speech: "tính từ",
    meaning:
      "đói khổ, vất vả đến tột cùng: cuộc sống quá cơ cực * cơ cực đủ điều",
    example: "cuộc sống quá cơ cực * cơ cực đủ điều",
  },
  {
    word: "cơ chỉ",
    part_of_speech: "tính từ",
    meaning:
      "biết căn cơ, tính toán chắc chắn, cẩn thận trong việc làm ăn: cơ chỉ làm ăn * chị là người cơ chỉ, hiền lành",
    example: "cơ chỉ làm ăn * chị là người cơ chỉ, hiền lành",
  },
  {
    word: "cơ địa",
    part_of_speech: "danh từ",
    meaning:
      "tính chất cơ thể của mỗi người, về mặt phản ứng lại với những tác động từ bên ngoài: viêm da cơ địa * sự phản ứng thuốc tuỳ theo cơ địa mỗi người",
    example: "viêm da cơ địa * sự phản ứng thuốc tuỳ theo cơ địa mỗi người",
  },
  {
    word: "cơ đê",
    part_of_speech: "danh từ",
    meaning: "đường nhỏ chạy dọc trên mái đê: đắp cơ đê * cơ đê bị vỡ",
    example: "đắp cơ đê * cơ đê bị vỡ",
  },
  {
    word: "cơ duyên",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) duyên may đã được định sẵn, theo quan niệm duy tâm: "Còn nhiều ân ái với nhau, Cơ duyên nào đã hết đâu, vội gì?" (TKiều)',
    example:
      'Còn nhiều ân ái với nhau, Cơ duyên nào đã hết đâu, vội gì?" (TKiều)',
  },
  {
    word: "cơ đốc giáo",
    part_of_speech: "danh từ",
    meaning: "đạo Cơ Đốc: nhà thờ Cơ Đốc giáo * tín đồ Cơ Đốc giáo",
    example: "nhà thờ Cơ Đốc giáo * tín đồ Cơ Đốc giáo",
  },
  {
    word: "cơ đồ",
    part_of_speech: "danh từ",
    meaning:
      'sự nghiệp lớn và vững chắc: "Một tay gây dựng cơ đồ, Bấy lâu bể Sở, sông Ngô tung hoành!" (TKiều)',
    example:
      'Một tay gây dựng cơ đồ, Bấy lâu bể Sở, sông Ngô tung hoành!" (TKiều)',
  },
  {
    word: "cơ động",
    part_of_speech: "động từ",
    meaning:
      "di chuyển lực lượng và binh bị một cách nhanh chóng bằng phương tiện: cơ động bằng máy bay * cơ động bộ binh về đồng bằng",
    example: "cơ động bằng máy bay * cơ động bộ binh về đồng bằng",
  },
  {
    word: "cơ động",
    part_of_speech: "tính từ",
    meaning:
      "có khả năng vận động và chuyển hướng nhanh chóng: lực lượng cơ động",
    example: "lực lượng cơ động",
  },
  {
    word: "cơ hàn",
    part_of_speech: "tính từ",
    meaning:
      '(văn chương) đói rét: "Thuyền than mà đậu bến than, Thương anh vất vả cơ hàn nắng mưa." (ca dao)',
    example:
      'Thuyền than mà đậu bến than, Thương anh vất vả cơ hàn nắng mưa." (ca dao)',
  },
  {
    word: "cơ điện",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) cơ khí và điện (nói gộp): công nhân cơ điện * công ti cơ điện",
    example: "công nhân cơ điện * công ti cơ điện",
  },
  {
    word: "cơ hoành",
    part_of_speech: "danh từ",
    meaning:
      "cơ hình tấm ngăn cách khoang ngực và khoang bụng ở các loài có vú: hiện tượng co thắt cơ hoành",
    example: "hiện tượng co thắt cơ hoành",
  },
  {
    word: "cơ giới hoá",
    part_of_speech: "động từ",
    meaning:
      "sử dụng máy móc thay cho hoặc giảm nhẹ cho lao động chân tay và tăng hiệu suất: cơ giới hoá nông nghiệp",
    example: "cơ giới hoá nông nghiệp",
  },
  {
    word: "cơ giới",
    part_of_speech: "danh từ",
    meaning: "máy móc dùng trong lao động sản xuất (nói khái quát).",
    example: "tiểu đoàn bộ binh có cơ giới yểm hộ",
  },
  {
    word: "cơ giới",
    part_of_speech: "tính từ",
    meaning:
      "được trang bị hoặc hoạt động bằng máy móc: phương tiện cơ giới * đường dành cho xe cơ giới",
    example: "phương tiện cơ giới * đường dành cho xe cơ giới",
  },
  {
    word: "cơ hồ",
    part_of_speech: "phụ từ",
    meaning: "đến mức gần như: hai chân bủn rủn, cơ hồ không đứng vững",
    example: "hai chân bủn rủn, cơ hồ không đứng vững",
  },
  {
    word: "cơ hội",
    part_of_speech: "danh từ",
    meaning:
      "hoàn cảnh thuận lợi gặp được để thực hiện điều mong muốn, dự định: lợi dụng cơ hội * bỏ lỡ một cơ hội tốt",
    example: "lợi dụng cơ hội * bỏ lỡ một cơ hội tốt",
  },
  {
    word: "cơ hội",
    part_of_speech: "tính từ",
    meaning: "cơ hội chủ nghĩa (nói tắt): bọn cơ hội * thái độ cơ hội",
    example: "bọn cơ hội * thái độ cơ hội",
  },
  {
    word: "cơ khí",
    part_of_speech: "danh từ",
    meaning:
      "ngành chế tạo và sửa chữa các loại máy móc, thiết bị: nhà máy cơ khí đóng tàu * kĩ sư cơ khí",
    example: "nhà máy cơ khí đóng tàu * kĩ sư cơ khí",
  },
  {
    word: "cơ học",
    part_of_speech: "danh từ",
    meaning:
      "môn học nghiên cứu sự chuyển động và sự cân bằng của các vật thể: viện cơ học * trung tâm nghiên cứu cơ học",
    example: "viện cơ học * trung tâm nghiên cứu cơ học",
  },
  {
    word: "cơ học",
    part_of_speech: "tính từ",
    meaning: "thuộc về cơ học: tác động của lực cơ học * sức bền cơ học",
    example: "tác động của lực cơ học * sức bền cơ học",
  },
  {
    word: "cơ hữu",
    part_of_speech: "tính từ",
    meaning:
      "có quan hệ không thể tách rời và chịu sự chi phối của một bộ máy tổ chức nào đó: đội ngũ giảng viên cơ hữu",
    example: "đội ngũ giảng viên cơ hữu",
  },
  {
    word: "cơ khí hoá",
    part_of_speech: "động từ",
    meaning:
      "làm cho trở thành có trình độ dùng máy móc trong các mặt hoạt động (thường nói về hoạt động sản xuất): cơ khí hoá nông nghiệp",
    example: "cơ khí hoá nông nghiệp",
  },
  {
    word: "cờ lông công",
    part_of_speech: "danh từ",
    meaning:
      "cờ hiệu của lính trạm chạy công văn khẩn ngày xưa: chạy như cờ lông công",
    example: "chạy như cờ lông công",
  },
  {
    word: "cơ khổ",
    part_of_speech: "tính từ",
    meaning:
      '(cũ) đói khổ: cuộc sống cơ khổ * "Sinh con cơ khổ thương thay, Để cho đói khát đêm ngày xót xa!" (PCCH)',
    example:
      'cuộc sống cơ khổ * "Sinh con cơ khổ thương thay, Để cho đói khát đêm ngày xót xa!" (PCCH)',
  },
  {
    word: "cơ khổ",
    part_of_speech: "cảm từ",
    meaning:
      "tiếng thốt ra biểu lộ sự thông cảm: cơ khổ! hết con ốm, lại vợ ốm",
    example: "cơ khổ! hết con ốm, lại vợ ốm",
  },
  {
    word: "cơ man",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) số lượng rất nhiều, không biết chính xác là bao nhiêu: ngày mùa, nhà cơ man là thóc",
    example: "ngày mùa, nhà cơ man là thóc",
  },
  {
    word: "cơ may",
    part_of_speech: "danh từ",
    meaning:
      "cơ hội, dịp may: để cơ may tuột khỏi tay * bệnh nhân có cơ may được cứu sống",
    example: "để cơ may tuột khỏi tay * bệnh nhân có cơ may được cứu sống",
  },
  {
    word: "cơ mà",
    part_of_speech: "kết từ",
    meaning:
      "(phương ngữ, khẩu ngữ) như nhưng mà: đắt, cơ mà đẹp * làm mệt, cơ mà vui",
    example: "đắt, cơ mà đẹp * làm mệt, cơ mà vui",
  },
  {
    word: "cơ mà",
    part_of_speech: "trợ từ",
    meaning:
      "như kia mà: tôi đã nói trước rồi cơ mà * việc này chính tay anh làm cơ mà!",
    example: "tôi đã nói trước rồi cơ mà * việc này chính tay anh làm cơ mà!",
  },
  {
    word: "cơ mật",
    part_of_speech: "tính từ",
    meaning:
      "hết sức quan trọng và bí mật (thường nói về những việc đại sự của quốc gia): bàn việc cơ mật * tin tức cơ mật",
    example: "bàn việc cơ mật * tin tức cơ mật",
  },
  {
    word: "cơ năng",
    part_of_speech: "danh từ",
    meaning:
      "chức năng của một cơ quan ở sinh vật: phục hồi cơ năng của tuyến giáp",
    example: "phục hồi cơ năng của tuyến giáp",
  },
  {
    word: "cơ năng",
    part_of_speech: "danh từ",
    meaning:
      "năng lượng cơ học, gồm động năng và thế năng: biến điện năng thành cơ năng",
    example: "biến điện năng thành cơ năng",
  },
  {
    word: "cơ ngơi",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ nói chung nhà cửa, ruộng đất và những tài sản khác đã gây dựng được: xây dựng cơ ngơi * một cơ ngơi bề thế",
    example: "xây dựng cơ ngơi * một cơ ngơi bề thế",
  },
  {
    word: "cơ mưu",
    part_of_speech: "danh từ",
    meaning: "như mưu cơ: để lộ cơ mưu * viên tướng giỏi, lắm cơ mưu",
    example: "để lộ cơ mưu * viên tướng giỏi, lắm cơ mưu",
  },
  {
    word: "cơ mầu",
    part_of_speech: "danh từ",
    meaning:
      'tình hình đang có chiều hướng diễn biến không thuận lợi: cơ mầu này rồi lại đói dài * "Bán hàng ăn những chũm cau, Chồng con có biết cơ mầu này chăng?" (ca dao)',
    example:
      'cơ mầu này rồi lại đói dài * "Bán hàng ăn những chũm cau, Chồng con có biết cơ mầu này chăng?" (ca dao)',
  },
  {
    word: "cơ nghiệp",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ tàI sản đã gây dựng được: bán cả cơ nghiệp * con trâu là đầu cơ nghiệp (tng)",
    example: "bán cả cơ nghiệp * con trâu là đầu cơ nghiệp (tng)",
  },
  {
    word: "cơ nghiệp",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) như cơ đồ: dựng lên cơ nghiệp * phát triển cơ nghiệp của tổ tiên",
    example: "dựng lên cơ nghiệp * phát triển cơ nghiệp của tổ tiên",
  },
  {
    word: "cơ quan",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị trong bộ máy nhà nước hoặc đoàn thể, làm những nhiệm vụ về hành chính, sự nghiệp: cơ quan nhà nước * đến cơ quan làm việc",
    example: "cơ quan nhà nước * đến cơ quan làm việc",
  },
  {
    word: "cơ quan",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận của cơ thể, thực hiện một chức năng nhất định: mắt là cơ quan thị giác",
    example: "mắt là cơ quan thị giác",
  },
  {
    word: "cơ nhỡ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) không may gặp cảnh khó khăn, túng thiếu: giúp đỡ nhau lúc cơ nhỡ * gặp khó khăn, cơ nhỡ",
    example: "giúp đỡ nhau lúc cơ nhỡ * gặp khó khăn, cơ nhỡ",
  },
  {
    word: "cơ quan chức năng",
    part_of_speech: "danh từ",
    meaning:
      "cơ quan của nhà nước quản lí từng lĩnh vực hoạt động theo một hệ thống nhất định: phối hợp với các cơ quan chức năng để làm rõ sự việc",
    example: "phối hợp với các cơ quan chức năng để làm rõ sự việc",
  },
  {
    word: "cờ quạt",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) các thứ như cờ, quạt, lọng, v.v., dùng trong nghi lễ đón rước thời phong kiến (nói khái quát): cờ quạt rợp trời",
    example: "cờ quạt rợp trời",
  },
  {
    word: "cơ số",
    part_of_speech: "danh từ",
    meaning:
      "số dùng làm cơ sở để xây dựng một hệ thống số: cơ số đếm thập phân là 10 * cơ số logarithm",
    example: "cơ số đếm thập phân là 10 * cơ số logarithm",
  },
  {
    word: "cơ số",
    part_of_speech: "danh từ",
    meaning:
      "số phải đem nhân với chính nó một số lần để có một luỹ thừa: A là cơ số của luỹ thừa An",
    example: "A là cơ số của luỹ thừa An",
  },
  {
    word: "cơ số",
    part_of_speech: "danh từ",
    meaning:
      "số lượng quy ước dùng làm đơn vị tính cho một loại thiết bị, vật tư kĩ thuật, v.v. được sử dụng cho những nhu cầu thiết yếu: đảm bảo cơ số thuốc",
    example: "đảm bảo cơ số thuốc",
  },
  {
    word: "cơ sở dữ liệu",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp dữ liệu (văn bản, âm thanh, hình ảnh, số liệu, v.v.) của một hay nhiều lĩnh vực ứng dụng, được tổ chức theo một cấu trúc nhất định, sao cho các chương trình máy tính có thể khai thác, nhằm phục vụ nhiều người sử dụng: cơ sở dữ liệu tiếng Việt",
    example: "cơ sở dữ liệu tiếng Việt",
  },
  {
    word: "cơ sở",
    part_of_speech: "danh từ",
    meaning:
      "cái làm nền tảng cho những cái được xây dựng trên đó hoặc dựa trên đó mà tồn tại, phát triển: cơ sở vật chất * lời buộc tội không có cơ sở",
    example: "cơ sở vật chất * lời buộc tội không có cơ sở",
  },
  {
    word: "cơ sở",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị ở cấp dưới cùng, nơi trực tiếp thực hiện các hoạt động như sản xuất, công tác, v.v. của một hệ thống tổ chức, trong quan hệ với các bộ phận lãnh đạo cấp trên: công đoàn cơ sở * đưa cán bộ về hoạt động tại cơ sở",
    example: "công đoàn cơ sở * đưa cán bộ về hoạt động tại cơ sở",
  },
  {
    word: "cơ sở",
    part_of_speech: "danh từ",
    meaning:
      "người hoặc nhóm người làm chỗ dựa cho tổ chức hoạt động, thường là hoạt động bí mật: gây dựng cơ sở",
    example: "gây dựng cơ sở",
  },
  {
    word: "cớ sao",
    part_of_speech: "phụ từ",
    meaning: "vì lí do gì: cớ sao mày lại làm như thế?",
    example: "cớ sao mày lại làm như thế?",
  },
  {
    word: "cơ thắt",
    part_of_speech: "danh từ",
    meaning:
      "cơ hình vòng, viền mép lỗ của một cơ quan trong cơ thể: cơ vòng hậu môn",
    example: "cơ vòng hậu môn",
  },
  {
    word: "cơ trơn",
    part_of_speech: "danh từ",
    meaning:
      "cơ gồm những sợi không có vân, cấu tạo nên phủ tạng: thành ruột được cấu tạo chủ yếu bằng cơ trơn",
    example: "thành ruột được cấu tạo chủ yếu bằng cơ trơn",
  },
  {
    word: "cờ trắng",
    part_of_speech: "danh từ",
    meaning:
      "cờ màu trắng, dùng để báo hiệu sự đầu hàng: kéo cờ trắng xin hàng",
    example: "kéo cờ trắng xin hàng",
  },
  {
    word: "cơ sự",
    part_of_speech: "danh từ",
    meaning:
      "sự tình, sự thể không hay đã xảy ra: không ngờ xảy ra cơ sự này * thoáng nhìn đã hiểu cơ sự",
    example: "không ngờ xảy ra cơ sự này * thoáng nhìn đã hiểu cơ sự",
  },
  {
    word: "cơ thể",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp thống nhất của mọi bộ phận trong một sinh vật: cơ thể động vật * cây là một cơ thể sống",
    example: "cơ thể động vật * cây là một cơ thể sống",
  },
  {
    word: "cơ thể",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ phần vật chất thực hiện chức năng sống của con người: suy nhược cơ thể",
    example: "suy nhược cơ thể",
  },
  {
    word: "cơ vân",
    part_of_speech: "danh từ",
    meaning:
      "xơ gồm những sợi có vân, cấu tạo nên các bắp thịt: cơ bắp tay được cấu tạo chủ yếu bằng cơ vân",
    example: "cơ bắp tay được cấu tạo chủ yếu bằng cơ vân",
  },
  {
    word: "cơ vòng",
    part_of_speech: "danh từ",
    meaning:
      "cơ hình vòng, viền mép lỗ của một cơ quan trong cơ thể: cơ vòng hậu môn",
    example: "cơ vòng hậu môn",
  },
  {
    word: "cờ xí",
    part_of_speech: "danh từ",
    meaning:
      'cờ dùng để đón rước, trang trí trong các dịp lễ lớn (nói khái quát): cờ xí rợp trời * "Giáo gươm cờ xí trùng trùng, Hằng năm mở hội tưng bừng vui thay." (ca dao)',
    example:
      'cờ xí rợp trời * "Giáo gươm cờ xí trùng trùng, Hằng năm mở hội tưng bừng vui thay." (ca dao)',
  },
  {
    word: "cờ vua",
    part_of_speech: "danh từ",
    meaning:
      "cờ có ba mươi hai quân (có nguồn gốc từ ấn Độ; gồm có: vua, hậu, sĩ, tượng, xe, mã, tốt), mỗi loại quân có một cách đi riêng, bên nào đưa vua của đối phương vào thế không được bảo vệ thì sẽ giành phần thắng: giải thi đấu cờ vua quốc tế",
    example: "giải thi đấu cờ vua quốc tế",
  },
  {
    word: "cơ yếu",
    part_of_speech: "tính từ",
    meaning: "quan trọng và tuyệt mật: việc quân cơ yếu * nhân viên cơ yếu",
    example: "việc quân cơ yếu * nhân viên cơ yếu",
  },
  {
    word: "cời",
    part_of_speech: "động từ",
    meaning:
      "dùng que gạt vật vụn (thường là tro, than) ra để khơi thông hoặc để kéo lấy cái nằm bên trong: lấy que cời đống lửa",
    example: "lấy que cời đống lửa",
  },
  {
    word: "cơi",
    part_of_speech: "danh từ",
    meaning:
      'đồ dùng để đựng trầu cau, có dạng như một cái âu nhỏ, bằng kim loại, đáy nông và thường có nắp: cái cơi đồng * "Đàn ông nông nổi giếng khơi, Đàn bà sâu sắc như cơi đựng trầu." (Cdao)',
    example:
      'cái cơi đồng * "Đàn ông nông nổi giếng khơi, Đàn bà sâu sắc như cơi đựng trầu." (Cdao)',
  },
  {
    word: "cơi",
    part_of_speech: "động từ",
    meaning:
      "đắp hoặc xây cho rộng hoặc cho cao thêm ra: chân đê được cơi rộng * căn gác mới được cơi thêm một đoạn",
    example: "chân đê được cơi rộng * căn gác mới được cơi thêm một đoạn",
  },
  {
    word: "cởi",
    part_of_speech: "động từ",
    meaning: "tháo, gỡ chỗ buộc ra: cởi mối lạt * cởi dây giày",
    example: "cởi mối lạt * cởi dây giày",
  },
  {
    word: "cởi",
    part_of_speech: "động từ",
    meaning:
      "tháo, bỏ ra khỏi người cái đang mang, đang mặc: cởi giày * cởi bỏ súng đạn quy hàng",
    example: "cởi giày * cởi bỏ súng đạn quy hàng",
  },
  {
    word: "cởi mở",
    part_of_speech: "động từ",
    meaning: "bày tỏ tâm tình một cách dễ dàng và hồn nhiên: cởi mở tâm tình",
    example: "cởi mở tâm tình",
  },
  {
    word: "cởi mở",
    part_of_speech: "tính từ",
    meaning:
      "gần gũi trong giao tiếp và dễ dàng để cho người khác hiểu biết tâm tình của mình: chuyện trò cởi mở * tính tình cởi mở",
    example: "chuyện trò cởi mở * tính tình cởi mở",
  },
  {
    word: "cơi nới",
    part_of_speech: "động từ",
    meaning:
      "nới cho rộng thêm chút ít diện tích nhà cửa (nói khái quát): tầng hai được cơi nới ra phía ngõ * cơi nới trái phép",
    example: "tầng hai được cơi nới ra phía ngõ * cơi nới trái phép",
  },
  {
    word: "cơm",
    part_of_speech: "danh từ",
    meaning:
      "gạo đem nấu chín, ráo nước, dùng làm món chính trong bữa ăn hằng ngày: nấu một nồi cơm đầy * xới cơm ra bát",
    example: "nấu một nồi cơm đầy * xới cơm ra bát",
  },
  {
    word: "cơm",
    part_of_speech: "danh từ",
    meaning:
      "những thức làm thành một bữa ăn (nói tổng quát): bữa cơm * ăn cơm * làm vài mâm cơm thết bạn bè",
    example: "bữa cơm * ăn cơm * làm vài mâm cơm thết bạn bè",
  },
  {
    word: "cơm",
    part_of_speech: "danh từ",
    meaning: "cùi của một số quả cây: nhãn dày cơm * cạo cơm dừa",
    example: "nhãn dày cơm * cạo cơm dừa",
  },
  {
    word: "cơm",
    part_of_speech: "tính từ",
    meaning: "(thứ quả) có vị nhạt, không chua hoặc chỉ hơi ngọt: khế cơm",
    example: "khế cơm",
  },
  {
    word: "cơm áo",
    part_of_speech: "danh từ",
    meaning:
      "cơm ăn, áo mặc; những thứ cần thiết trong sinh hoạt hằng ngày của con người (nói khái quát): chuyện cơm áo hằng ngày",
    example: "chuyện cơm áo hằng ngày",
  },
  {
    word: "cớm",
    part_of_speech: "tính từ",
    meaning:
      "(cây cối) thiếu ánh mặt trời, không phát triển tốt được: cây bị cớm nắng",
    example: "cây bị cớm nắng",
  },
  {
    word: "cơm bình dân",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) cơm rẻ tiền, bán cho người dân thường: quán cơm bình dân",
    example: "quán cơm bình dân",
  },
  {
    word: "cơm bụi",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) cơm bình dân, thường bán trong hàng quán nhỏ, tạm bợ: quán cơm bụi * đi ăn cơm bụi",
    example: "quán cơm bụi * đi ăn cơm bụi",
  },
  {
    word: "cơm áo gạo tiền",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) như cơm áo (nhưng nghĩa mạnh hơn): đau đầu vì chuyện cơm áo gạo tiền",
    example: "đau đầu vì chuyện cơm áo gạo tiền",
  },
  {
    word: "cơm cháo",
    part_of_speech: "danh từ",
    meaning:
      "cái ăn thường ngày như cơm, cháo, v.v. (nói khái quát): cơm cháo gì chưa? * lo cơm cháo, thuốc thang cho người ốm",
    example: "cơm cháo gì chưa? * lo cơm cháo, thuốc thang cho người ốm",
  },
  {
    word: "cơm cháo",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) kết quả việc làm: chẳng nên cơm cháo gì",
    example: "chẳng nên cơm cháo gì",
  },
  {
    word: "cơm đĩa",
    part_of_speech: "danh từ",
    meaning:
      "cơm và thức ăn đựng thành suất trong một đĩa lớn, để ăn cho nhanh, gọn, thường bán ở quán cơm bình dân: gọi hai suất cơm đĩa",
    example: "gọi hai suất cơm đĩa",
  },
  {
    word: "cơm chim",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) cơm rất ít ỏi, tựa như để cho chim ăn; thường dùng để ví cái tuy quá ít ỏi, chẳng đáng là bao nhưng lại rất cần thiết để nuôi sống: ăn cướp cơm chim",
    example: "ăn cướp cơm chim",
  },
  {
    word: "cơm bữa",
    part_of_speech: "danh từ",
    meaning:
      "cơm ăn mỗi bữa hằng ngày (thường không có gì đặc biệt): cửa hàng bán cơm bữa",
    example: "cửa hàng bán cơm bữa",
  },
  {
    word: "cơm bữa",
    part_of_speech: "danh từ",
    meaning:
      "chuyện thường xuyên xảy ra, không có gì là lạ: chuyện cơm bữa * cãi nhau như cơm bữa",
    example: "chuyện cơm bữa * cãi nhau như cơm bữa",
  },
  {
    word: "cơm gạo",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) cơm và những thứ tối cần thiết dùng để nuôi sống con người (nói khái quát): không có cơm gạo mà ăn * nuôi nó cũng tốn cơm gạo",
    example: "không có cơm gạo mà ăn * nuôi nó cũng tốn cơm gạo",
  },
  {
    word: "cơm nước",
    part_of_speech: "danh từ",
    meaning:
      "cái ăn, cái uống thường ngày (nói khái quát): cơm nước xong xuôi * chưa cơm nước gì!",
    example: "cơm nước xong xuôi * chưa cơm nước gì!",
  },
  {
    word: "cơm rang",
    part_of_speech: "danh từ",
    meaning:
      "cơm để nguội rồi rang lên với dầu hoặc mỡ, có thể cho thêm một số thứ khác như giò, lạp xường, dưa muối, v.v.: cơm rang thập cẩm",
    example: "cơm rang thập cẩm",
  },
  {
    word: "cơn",
    part_of_speech: "danh từ",
    meaning:
      "quá trình diễn ra sự biến đổi nào đó của một hiện tượng tự nhiên hoặc hiện tượng tâm sinh lí, thường là tương đối ngắn: cơn dông * cơn mưa * nổi cơn điên * lên cơn sốt",
    example: "cơn dông * cơn mưa * nổi cơn điên * lên cơn sốt",
  },
  {
    word: "cơn",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian xảy ra điều không may, thường là tương đối ngắn: qua cơn hoạn nạn * cơn khủng hoảng",
    example: "qua cơn hoạn nạn * cơn khủng hoảng",
  },
  {
    word: "cơm rượu",
    part_of_speech: "danh từ",
    meaning:
      "bữa cơm thịnh soạn, tỏ lòng quý trọng đối với ai (nói khái quát): thết đãi cơm rượu",
    example: "thết đãi cơm rượu",
  },
  {
    word: "cơm rượu",
    part_of_speech: "danh từ",
    meaning:
      "cơm ủ men, khi lên men có mùi thơm, vị ngọt, dùng để cất rượu: ủ cơm rượu",
    example: "ủ cơm rượu",
  },
  {
    word: "cơm thầy cơm cô",
    part_of_speech: "",
    meaning:
      'tả cảnh kiếm miếng ăn bằng cách đi ở, hầu hạ cho các gia đình giàu có trong chế độ cũ: "Gáo vàng mà múc giếng tây, Khôn ngoan chẳng kẻo cơm thầy cơm cô." (ca dao)',
    example:
      'Gáo vàng mà múc giếng tây, Khôn ngoan chẳng kẻo cơm thầy cơm cô." (ca dao)',
  },
  {
    word: "cơn cớ",
    part_of_speech: "danh từ",
    meaning:
      "nguyên nhân, lí do trực tiếp: cơn cớ gì mà ủ dột như thế? * không hiểu cơn cớ vì đâu",
    example: "cơn cớ gì mà ủ dột như thế? * không hiểu cơn cớ vì đâu",
  },
  {
    word: "cợt nhả",
    part_of_speech: "động từ",
    meaning:
      "trêu đùa một cách sỗ sàng, không đứng đắn: buông lời cợt nhả * tính hay cợt nhả",
    example: "buông lời cợt nhả * tính hay cợt nhả",
  },
  {
    word: "cờn cỡn",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả dáng nhảy cẫng lên một cách liên tiếp, thể hiện trạng thái tâm lí ở mức thái quá: nhảy cờn cỡn",
    example: "nhảy cờn cỡn",
  },
  {
    word: "crếp",
    part_of_speech: "danh từ",
    meaning:
      "cao su chế thành tấm mềm, thường dùng làm đế giày dép: giày đế crếp",
    example: "giày đế crếp",
  },
  {
    word: "cợt",
    part_of_speech: "động từ",
    meaning:
      '(văn chương, hiếm) đùa, trêu: "Những là cười phấn, cợt son, Đèn khuya chung bóng, trăng tròn sánh vai." (TKiều)',
    example:
      'Những là cười phấn, cợt son, Đèn khuya chung bóng, trăng tròn sánh vai." (TKiều)',
  },
  {
    word: "cơn sốt",
    part_of_speech: "danh từ",
    meaning:
      "quá trình tăng mạnh một cách đột biến, nhất thời về giá cả hoặc nhu cầu nào đó trong xã hội: xi măng đang lên cơn sốt * cơn sốt đất",
    example: "xi măng đang lên cơn sốt * cơn sốt đất",
  },
  {
    word: "cợp",
    part_of_speech: "",
    meaning: "(khẩu ngữ) (tóc) dài, rậm và xù: tóc dài cợp mang tai",
    example: "tóc dài cợp mang tai",
  },
  {
    word: "cu",
    part_of_speech: "danh từ",
    meaning: "(thông tục) dương vật của trẻ con.",
    example: "cu Tí * thằng cu",
  },
  {
    word: "cu",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) đứa con trai còn bé: cu Tí * thằng cu",
    example: "bố cu * anh cu, chị cu",
  },
  {
    word: "cu",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) bồ câu: chuồng cu",
    example: "chuồng cu",
  },
  {
    word: "cù",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) quay: đánh cù",
    example: "đánh cù",
  },
  {
    word: "cù",
    part_of_speech: "động từ",
    meaning:
      "dùng đầu ngón tay vừa gí nhẹ vừa đưa đi đưa lại lên chỗ da thịt dễ bị kích thích để gây cười: bị cù vào nách",
    example: "bị cù vào nách",
  },
  {
    word: "cù",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ, hiếm) gây cười bằng lời nói hoặc cử chỉ: anh hề có tài cù khán giả",
    example: "anh hề có tài cù khán giả",
  },
  {
    word: "cù",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) rủ làm việc gì bằng cách kích thích gợi sự tò mò, ham thích: cù thằng bé đi chơi * cù nhau đi đánh bạc",
    example: "cù thằng bé đi chơi * cù nhau đi đánh bạc",
  },
  {
    word: "cú",
    part_of_speech: "danh từ",
    meaning:
      "chim ăn thịt, thường kiếm mồi vào ban đêm, có mắt lớn ở phía trước đầu: hôi như cú",
    example: "hôi như cú",
  },
  {
    word: "cú",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) đòn đấm, đá hoặc đánh, v.v., thường là nhanh và mạnh: cú đấm * cú sút bóng căng và mạnh",
    example: "cú đấm * cú sút bóng căng và mạnh",
  },
  {
    word: "cú",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) lần xảy ra việc gì một cách nhanh chóng, bất ngờ, có tác động mạnh: bị một cú sốc * cú điện thoại",
    example: "bị một cú sốc * cú điện thoại",
  },
  {
    word: "cú",
    part_of_speech: "danh từ",
    meaning: "(hiếm) câu: văn viết bất thành cú",
    example: "văn viết bất thành cú",
  },
  {
    word: "cú",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) cốc vào đầu: bị cú một cái đau điếng",
    example: "bị cú một cái đau điếng",
  },
  {
    word: "cũ",
    part_of_speech: "tính từ",
    meaning:
      "đã được đem dùng và không còn nguyên, còn mới như trước nữa: sách cũ * xe cũ nhưng còn tốt * ma cũ bắt nạt ma mới (tng)",
    example: "sách cũ * xe cũ nhưng còn tốt * ma cũ bắt nạt ma mới (tng)",
  },
  {
    word: "cũ",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về thời gian đã qua, nay không còn nữa hoặc không thích hợp nữa: nhà xây theo kiểu cũ * sinh hoạt theo nếp cũ * ăn cơm mới, nói chuyện cũ (tng)",
    example:
      "nhà xây theo kiểu cũ * sinh hoạt theo nếp cũ * ăn cơm mới, nói chuyện cũ (tng)",
  },
  {
    word: "cũ",
    part_of_speech: "tính từ",
    meaning:
      "vốn đã có từ lâu hoặc vốn đã quen biết, gắn bó từ trước: bạn cũ * về thăm trường cũ * ngựa quen đường cũ (tng)",
    example: "bạn cũ * về thăm trường cũ * ngựa quen đường cũ (tng)",
  },
  {
    word: "củ bình vôi",
    part_of_speech: "danh từ",
    meaning:
      "bình bằng sành, bụng thường phình to, đít thót, dùng đựng vôi đã tôi để têm trầu.",
    example: "đầu bịt khăn rằn",
  },
  {
    word: "củ",
    part_of_speech: "danh từ",
    meaning:
      "phần thân, rễ hay quả của cây phát triển lớn ra và chứa chất dự trữ, nằm ở dưới đất hoặc sát đất: củ cà rốt * củ sắn * củ su hào * lạc đã ra củ",
    example: "củ cà rốt * củ sắn * củ su hào * lạc đã ra củ",
  },
  {
    word: "cụ",
    part_of_speech: "danh từ",
    meaning: "(Nam cố) người sinh ra ông hoặc bà: ngày giỗ cụ",
    example: "ngày giỗ cụ",
  },
  {
    word: "cụ",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để gọi người già cả với ý tôn kính: cụ ông, cụ bà * xin mời các cụ vào trong nhà!",
    example: "cụ ông, cụ bà * xin mời các cụ vào trong nhà!",
  },
  {
    word: "củ cải",
    part_of_speech: "danh từ",
    meaning:
      "cải hoa màu trắng, rễ phồng thành củ màu trắng, dùng làm thức ăn: dưa cải củ muối xổi",
    example: "dưa cải củ muối xổi",
  },
  {
    word: "cu cậu",
    part_of_speech: "đại từ",
    meaning:
      "(khẩu ngữ) tổ hợp dùng để gọi người con trai đã được nói đến (hàm ý hài hước hoặc thân mật): cu cậu rất mê trò chơi điện tử",
    example: "cu cậu rất mê trò chơi điện tử",
  },
  {
    word: "cụ cựa",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ, hiếm) như cựa quậy: nằm im không cụ cựa",
    example: "nằm im không cụ cựa",
  },
  {
    word: "cu đơ",
    part_of_speech: "danh từ",
    meaning:
      "kẹo làm bằng lạc rang ngào với mật hoặc đường, kẹp giữa hai lớp bánh đa mỏng, ăn giòn, có vị ngọt bùi: kẹo cu đơ",
    example: "kẹo cu đơ",
  },
  {
    word: "cũ kĩ",
    part_of_speech: "tính từ",
    meaning:
      "cũ quá rồi, đã có từ lâu, không còn hợp thời nữa: chiếc xe cũ kĩ * bộ bàn ghế cũ kĩ * quan niệm cũ kĩ",
    example: "chiếc xe cũ kĩ * bộ bàn ghế cũ kĩ * quan niệm cũ kĩ",
  },
  {
    word: "cũ kỹ",
    part_of_speech: "tính từ",
    meaning:
      "cũ quá rồi, đã có từ lâu, không còn hợp thời nữa: chiếc xe cũ kĩ * bộ bàn ghế cũ kĩ * quan niệm cũ kĩ",
    example: "chiếc xe cũ kĩ * bộ bàn ghế cũ kĩ * quan niệm cũ kĩ",
  },
  {
    word: "cù là",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) dầu cù là (nói tắt): hộp cù là",
    example: "hộp cù là",
  },
  {
    word: "củ mài",
    part_of_speech: "danh từ",
    meaning:
      "cây leo cùng họ với củ từ, mọc ở rừng, củ hình trụ chứa nhiều bột, dùng làm thuốc hay làm thức ăn: đói phải ăn củ mài thay cơm",
    example: "đói phải ăn củ mài thay cơm",
  },
  {
    word: "cù lần",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) ngù ngờ, chậm chạp (hàm ý chê hoặc hài hước): người đâu mà cù lần thế không biết!",
    example: "người đâu mà cù lần thế không biết!",
  },
  {
    word: "củ mì",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) sắn: luộc củ mì",
    example: "luộc củ mì",
  },
  {
    word: "cũ mèm",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) cũ đến mức đáng lẽ phải bỏ đi hoặc phải thay thế từ lâu: chiếc áo bông cũ mèm",
    example: "chiếc áo bông cũ mèm",
  },
  {
    word: "cu li",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người lao động làm thuê những việc nặng nhọc, như khuân vác, kéo xe, v.v., dưới thời thực dân (gọi với ý coi khinh): cu li mỏ",
    example: "cu li mỏ",
  },
  {
    word: "cù mì",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) lành, ít nói và hơi chậm chạp: tính tình cù mì",
    example: "tính tình cù mì",
  },
  {
    word: "cù lao",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ) đảo: cù lao Chàm",
    example: "cù lao Chàm",
  },
  {
    word: "cù lao",
    part_of_speech: "danh từ",
    meaning:
      '(Từ cũ, Văn chương) công cha mẹ nuôi con vất vả, nhọc nhằn: "Duyên hội ngộ, đức cù lao, Bên tình bên hiếu, bên nào nặng hơn?" (TKiều)',
    example:
      'Duyên hội ngộ, đức cù lao, Bên tình bên hiếu, bên nào nặng hơn?" (TKiều)',
  },
  {
    word: "củ mỉ",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như cù mì: tính hiền lành củ mỉ",
    example: "tính hiền lành củ mỉ",
  },
  {
    word: "cù nèo",
    part_of_speech: "danh từ",
    meaning:
      "đoạn cây có móc ở một đầu, dùng để móc kéo lấy vật ở cao hay ở xa: lấy cù nèo hái ổi",
    example: "lấy cù nèo hái ổi",
  },
  {
    word: "cù mộc",
    part_of_speech: "danh từ",
    meaning:
      'cây to tán lớn, cành cong xuống cho các loài dây leo bám vào; dùng trong văn học cổ để ví cha mẹ hoặc người vợ cả: "Dò la ướm hỏi sự tình, Rằng ngôi cù mộc còn dành chưa ai." (CC)',
    example: 'Dò la ướm hỏi sự tình, Rằng ngôi cù mộc còn dành chưa ai." (CC)',
  },
  {
    word: "cù nhầy",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) cố ý kéo dài thời gian, dây dưa lằng nhằng, không thực hiện việc mình phải làm đối với người khác: nợ cù nhầy không chịu trả * giở thói cù nhầy",
    example: "nợ cù nhầy không chịu trả * giở thói cù nhầy",
  },
  {
    word: "cù nhằng",
    part_of_speech: "",
    meaning: "(phương ngữ, khẩu ngữ) như cù nhầy: ăn nói cù nhằng",
    example: "ăn nói cù nhằng",
  },
  {
    word: "cũ người mới ta",
    part_of_speech: "",
    meaning:
      'tuy đã là cũ đối với người khác nhưng với mình, lần đầu tiên tiếp xúc, có được, thì vẫn là mới, là hay: "Ra đường thấy cánh hoa rơi, Đôi tay nâng lấy, cũ người mới ta." (ca dao)',
    example:
      'Ra đường thấy cánh hoa rơi, Đôi tay nâng lấy, cũ người mới ta." (ca dao)',
  },
  {
    word: "cù rù",
    part_of_speech: "tính từ",
    meaning:
      "có dáng co ro, thiếu linh lợi, thiếu hoạt bát: dáng điệu cù rù * ngồi cù rù cả ngày ở nhà",
    example: "dáng điệu cù rù * ngồi cù rù cả ngày ở nhà",
  },
  {
    word: "cụ non",
    part_of_speech: "danh từ",
    meaning:
      "người còn ít tuổi nhưng có dáng điệu nói năng, cư xử tỏ vẻ như người già (hàm ý chê): mới tí tuổi mà ăn nói như cụ non!",
    example: "mới tí tuổi mà ăn nói như cụ non!",
  },
  {
    word: "cũ rích",
    part_of_speech: "tính từ",
    meaning:
      "cũ lắm vì đã dùng quá lâu, không còn thích hợp nữa (hàm ý chê): chiếc đài cũ rích * những luận điệu cũ rích",
    example: "chiếc đài cũ rích * những luận điệu cũ rích",
  },
  {
    word: "củ rủ",
    part_of_speech: "tính từ",
    meaning: "như cù rù: ngồi củ rủ một xó",
    example: "ngồi củ rủ một xó",
  },
  {
    word: "cú pháp",
    part_of_speech: "danh từ",
    meaning:
      "cách kết hợp từ thành câu: cú pháp tiếng Việt * phân tích cú pháp",
    example: "cú pháp tiếng Việt * phân tích cú pháp",
  },
  {
    word: "cụ thể hoá",
    part_of_speech: "động từ",
    meaning:
      "làm cho trở thành cụ thể, rõ ràng, dễ hiểu: báo cáo được cụ thể hoá bằng những con số chính xác",
    example: "báo cáo được cụ thể hoá bằng những con số chính xác",
  },
  {
    word: "cụ thể",
    part_of_speech: "tính từ",
    meaning:
      "có hình thể, có tồn tại dưới dạng vật chất mà giác quan con người có thể nhận biết được; phân biệt với trừu tượng: quyển sách, hòn đá là những sự vật cụ thể",
    example: "quyển sách, hòn đá là những sự vật cụ thể",
  },
  {
    word: "cụ thể",
    part_of_speech: "tính từ",
    meaning:
      "(sự vật) có thật trong chỉnh thể của nó, với đầy đủ các mặt và các quan hệ đa dạng của nó; phân biệt với trừu tượng: chân lí bao giờ cũng cụ thể, không trừu tượng",
    example: "chân lí bao giờ cũng cụ thể, không trừu tượng",
  },
  {
    word: "cụ thể",
    part_of_speech: "tính từ",
    meaning:
      "rõ ràng và được xác định riêng biệt, không chung chung, không khái quát: kế hoạch cụ thể * tuỳ tình hình cụ thể mà hành động",
    example: "kế hoạch cụ thể * tuỳ tình hình cụ thể mà hành động",
  },
  {
    word: "của",
    part_of_speech: "danh từ",
    meaning:
      "vật cụ thể và có giá trị do con người làm ra, về mặt thuộc quyền sở hữu của người nào đó: lắm tiền nhiều của * có con nhờ con, có của nhờ của (tng)",
    example: "lắm tiền nhiều của * có con nhờ con, có của nhờ của (tng)",
  },
  {
    word: "của",
    part_of_speech: "danh từ",
    meaning:
      "cái ăn, về mặt có đặc tính riêng nào đó: hảo của ngọt * của không ngon, nhà đông con cũng hết (tng)",
    example: "hảo của ngọt * của không ngon, nhà đông con cũng hết (tng)",
  },
  {
    word: "của",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) đồ vật hoặc người thuộc loại, hạng nào đó (hàm ý coi khinh): ai thèm rước cái của ấy! * mua làm gì cái của này!",
    example: "ai thèm rước cái của ấy! * mua làm gì cái của này!",
  },
  {
    word: "của",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là người hay sự vật có quyền sở hữu hoặc chi phối đối với cái vừa được nói đến: chiếc áo của mẹ * tiền của tôi * tài nguyên của đất nước",
    example: "chiếc áo của mẹ * tiền của tôi * tài nguyên của đất nước",
  },
  {
    word: "của",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là chỉnh thể, trong quan hệ với cái bộ phận vừa được nói đến: cái mũi đỏ của anh hề * bìa của quyển sách * một phần mười của giây",
    example:
      "cái mũi đỏ của anh hề * bìa của quyển sách * một phần mười của giây",
  },
  {
    word: "của",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là người hay sự vật có thuộc tính hoặc hoạt động vừa được nói đến: tình thương con của người mẹ * sức bền của vật liệu",
    example: "tình thương con của người mẹ * sức bền của vật liệu",
  },
  {
    word: "của",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là người hay sự vật có quan hệ nguồn gốc, thân thuộc, tác động qua lại, v.v. với người hay sự vật vừa được nói đến: một thiên tài của dân tộc * nguyên nhân chính của sự việc",
    example: "một thiên tài của dân tộc * nguyên nhân chính của sự việc",
  },
  {
    word: "cua",
    part_of_speech: "danh từ",
    meaning:
      "giáp xác có phần đầu và ngực ẩn trong mai cứng, phần bụng gập dưới mai gọi là yếm, có tám chân, hai càng và thường bò ngang: mò cua bắt ốc",
    example: "mò cua bắt ốc",
  },
  {
    word: "cua",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) khúc ngoặt trên đường đi của xe cộ, tàu bè: đoạn đường cua",
    example: "đoạn đường cua",
  },
  {
    word: "cua",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) vòng xe theo chỗ ngoặt: xe cua sang trái * cua gấp",
    example: "xe cua sang trái * cua gấp",
  },
  {
    word: "cua",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, khẩu ngữ) khoảng thời gian nhất định, tương đối ngắn để hoàn thành một chương trình học tập nào đó: theo học một cua tiếng Anh * dạy theo cua",
    example: "theo học một cua tiếng Anh * dạy theo cua",
  },
  {
    word: "cua",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (kiểu tóc của nam giới) cắt ngắn, không rẽ ngôI: đầu húi cua",
    example: "đầu húi cua",
  },
  {
    word: "của ăn của để",
    part_of_speech: "",
    meaning: "của cải đủ tiêu dùng và còn có dư dật: nhà cũng có của ăn của để",
    example: "nhà cũng có của ăn của để",
  },
  {
    word: "của cải",
    part_of_speech: "danh từ",
    meaning:
      "những thứ có giá trị do con người làm ra hoặc có sẵn trong tự nhiên, nói chung: rừng là nguồn của cải tự nhiên * làm ra nhiều của cải",
    example: "rừng là nguồn của cải tự nhiên * làm ra nhiều của cải",
  },
  {
    word: "của đáng tội",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị sự chuyển ý để nhằm thanh minh hoặc làm rõ thêm cho điều ít nhiều không hay vừa nói đến: của đáng tội, cả hai bên đều có cái sai",
    example: "của đáng tội, cả hai bên đều có cái sai",
  },
  {
    word: "của đau con xót",
    part_of_speech: "",
    meaning:
      "mất của thì đau, cũng như mất con thì xót; tả tâm lí đau xót khi của cải bị tổn hại, mất mát: mất cả đống tiền, ai chẳng của đau con xót",
    example: "mất cả đống tiền, ai chẳng của đau con xót",
  },
  {
    word: "của ít lòng nhiều",
    part_of_speech: "",
    meaning:
      "giá trị về mặt vật chất của cái đem cho hoặc biếu thì không đáng kể nhưng tình cảm thì nhiều, chân thành và thắm thiết: thôi thì của ít lòng nhiều, mong anh nhận cho",
    example: "thôi thì của ít lòng nhiều, mong anh nhận cho",
  },
  {
    word: "của nả",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) như của cải: trong nhà chẳng có của nả gì!",
    example: "trong nhà chẳng có của nả gì!",
  },
  {
    word: "của độc",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) cái đặc biệt hiếm, độc nhất, không đâu có: bộ ấm cổ này là của độc, tôi chưa từng thấy bao giờ",
    example: "bộ ấm cổ này là của độc, tôi chưa từng thấy bao giờ",
  },
  {
    word: "của nợ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) cái thuộc về mình nhưng chỉ đem lại phiền phức, vướng bận mà khó bề dứt bỏ đi được; thường dùng để ví người hư hỏng, chỉ gây phiền muộn cho người thân: nhặt làm gì cái của nợ ấy! * đúng là đồ của nợ!",
    example: "nhặt làm gì cái của nợ ấy! * đúng là đồ của nợ!",
  },
  {
    word: "cục",
    part_of_speech: "danh từ",
    meaning:
      "khối nhỏ và đặc, thường không có hình thù nhất định: cục phấn * bột vón thành cục * mua nhà trả tiền một cục (kng; trả luôn một lần)",
    example:
      "cục phấn * bột vón thành cục * mua nhà trả tiền một cục (kng; trả luôn một lần)",
  },
  {
    word: "cục",
    part_of_speech: "danh từ",
    meaning:
      "cơ quan quản lí một ngành công tác chuyên môn của nhà nước, thường trực tiếp thuộc quyền quản lí của bộ hay tổng cục: cục quản lí xuất nhập cảnh * cục điện ảnh",
    example: "cục quản lí xuất nhập cảnh * cục điện ảnh",
  },
  {
    word: "cục",
    part_of_speech: "tính từ",
    meaning:
      "(tính) dễ nổi cáu và có những phản ứng bằng lời nói, cử chỉ thô bạo, hung tợn: tính hiền nhưng cục",
    example: "tính hiền nhưng cục",
  },
  {
    word: "cục bộ",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) một bộ phận nào đó của toàn bộ tình hình: chỉ thấy cục bộ mà không thấy toàn cục",
    example: "chỉ thấy cục bộ mà không thấy toàn cục",
  },
  {
    word: "cục bộ",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về một bộ phận, một phạm vi nào đó so với toàn thể: ngập úng cục bộ * khó khăn cục bộ",
    example: "ngập úng cục bộ * khó khăn cục bộ",
  },
  {
    word: "cục bộ",
    part_of_speech: "tính từ",
    meaning:
      "(tư tưởng) chỉ chú ý đến bộ phận mình mà không quan tâm đến toàn cục: đầu óc cục bộ * tư tưởng cục bộ địa phương",
    example: "đầu óc cục bộ * tư tưởng cục bộ địa phương",
  },
  {
    word: "cục cằn",
    part_of_speech: "tính từ",
    meaning:
      "dễ cáu bẳn và có những phản ứng bằng lời nói, cử chỉ thô bạo (nói khái quát): tính khí cục cằn * ăn nói cục cằn",
    example: "tính khí cục cằn * ăn nói cục cằn",
  },
  {
    word: "cúc cung",
    part_of_speech: "động từ",
    meaning:
      'cúi mình làm lễ một cách cung kính, tỏ lòng thành: "Nàng vào bái tạ cửu trùng, Trống giong ba dạo, cúc cung ba lần." (PTNH)',
    example:
      'Nàng vào bái tạ cửu trùng, Trống giong ba dạo, cúc cung ba lần." (PTNH)',
  },
  {
    word: "cúc cung",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) cúc cung tận tuỵ (nói tắt): suốt ngày cúc cung phục vụ chủ nhà",
    example: "suốt ngày cúc cung phục vụ chủ nhà",
  },
  {
    word: "cúc cung tận tuỵ",
    part_of_speech: "",
    meaning:
      "dốc hết lòng hết sức làm tròn bổn phận: hết lòng cúc cung tận tuỵ trong công việc",
    example: "hết lòng cúc cung tận tuỵ trong công việc",
  },
  {
    word: "cục diện",
    part_of_speech: "danh từ",
    meaning:
      "tình hình chung của hai hay nhiều bên đối kháng nhau được biểu hiện ra trong một thời gian nhất định: cục diện cuộc chiến đã thay đổi",
    example: "cục diện cuộc chiến đã thay đổi",
  },
  {
    word: "cục mịch",
    part_of_speech: "tính từ",
    meaning:
      "có vẻ bề ngoài thô kệch và nặng nề (thường là biểu hiện của sự chất phác): dáng người cục mịch * quê mùa cục mịch",
    example: "dáng người cục mịch * quê mùa cục mịch",
  },
  {
    word: "cục súc",
    part_of_speech: "tính từ",
    meaning:
      "cục, nóng nảy và có những hành vi thô bạo: ăn nói lỗ mãng, cục súc",
    example: "ăn nói lỗ mãng, cục súc",
  },
  {
    word: "cúc dục",
    part_of_speech: "động từ",
    meaning:
      '(cũ) nuôi nấng dạy dỗ từ thuở bé: "Ơn cha ba năm cúc dục, Nghĩa mẹ chín tháng cưu mang." (ca dao)',
    example: 'Ơn cha ba năm cúc dục, Nghĩa mẹ chín tháng cưu mang." (ca dao)',
  },
  {
    word: "cục tính",
    part_of_speech: "tính từ",
    meaning: "có tính cục: nó là đứa hiền nhưng cục tính",
    example: "nó là đứa hiền nhưng cục tính",
  },
  {
    word: "cục trưởng",
    part_of_speech: "danh từ",
    meaning:
      "người đứng đầu lãnh đạo một cục: cục trưởng cục thuế * cục trưởng cục hải quan",
    example: "cục trưởng cục thuế * cục trưởng cục hải quan",
  },
  {
    word: "cục tác",
    part_of_speech: "động từ",
    meaning:
      "từ mô phỏng tiếng gà mái kêu to sau khi đẻ hoặc khi hoảng sợ: gà đẻ gà cục tác (tng)",
    example: "gà đẻ gà cục tác (tng)",
  },
  {
    word: "củi",
    part_of_speech: "danh từ",
    meaning:
      "thân, cành, gốc, rễ cây dùng làm chất đốt: lên rừng đốn củi * mua mấy bó củi",
    example: "lên rừng đốn củi * mua mấy bó củi",
  },
  {
    word: "cũi",
    part_of_speech: "danh từ",
    meaning:
      "đồ được làm bằng tre, gỗ hay sắt, các mặt có song chắn, dùng để nhốt thú, nhốt người phạm tội thời phong kiến: tháo cũi sổ lồng * nhốt chó vào cũi",
    example: "tháo cũi sổ lồng * nhốt chó vào cũi",
  },
  {
    word: "cũi",
    part_of_speech: "danh từ",
    meaning:
      "đồ được làm bằng tre hay gỗ, có song chắn bốn bên và mặt đáy, dùng để xếp bát đĩa, hoặc để giữ cho trẻ khỏi ngã: em bé men thành cũi tập đi * cũi đựng bát",
    example: "em bé men thành cũi tập đi * cũi đựng bát",
  },
  {
    word: "cùi",
    part_of_speech: "danh từ",
    meaning: "phần dày của vỏ ở một số loại quả: cùi bưởi",
    example: "cùi bưởi",
  },
  {
    word: "cùi",
    part_of_speech: "danh từ",
    meaning: "phần dày bên trong vỏ một số loại quả: cùi dừa",
    example: "cùi dừa",
  },
  {
    word: "cùi",
    part_of_speech: "danh từ",
    meaning:
      "phần dày mọng nước nằm giữa vỏ quả và hạt một số loại quả: cùi vải * nhãn dày cùi",
    example: "cùi vải * nhãn dày cùi",
  },
  {
    word: "cùi",
    part_of_speech: "danh từ",
    meaning: "===== (phương ngữ): cùi bắp",
    example: "cùi bắp",
  },
  {
    word: "cùi",
    part_of_speech: "danh từ",
    meaning: "===== (phương ngữ): bị bệnh cùi",
    example: "bị bệnh cùi",
  },
  {
    word: "cùi",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ): cùi hàng đi chợ",
    example: "cùi hàng đi chợ",
  },
  {
    word: "cúi",
    part_of_speech: "động từ",
    meaning:
      "hạ thấp đầu hoặc thân mình xuống về phía trước: cúi đầu chào * cúi gằm mặt xuống * cúi rạp lưng mà đạp xe",
    example: "cúi đầu chào * cúi gằm mặt xuống * cúi rạp lưng mà đạp xe",
  },
  {
    word: "cùi chỏ",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) cùi tay: thúc cùi chỏ vào ngực",
    example: "thúc cùi chỏ vào ngực",
  },
  {
    word: "củi đóm",
    part_of_speech: "danh từ",
    meaning:
      "củi và đóm; các thứ dùng để đun bếp (nói khái quát): củi đóm ướt hết cả",
    example: "củi đóm ướt hết cả",
  },
  {
    word: "cùi dìa",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ có một đầu để cầm và một đầu lõm, dùng để múc thức ăn; lượng chứa trong một thìa: thìa xúp * thêm hai thìa muối vào canh",
    example: "thìa xúp * thêm hai thìa muối vào canh",
  },
  {
    word: "cùi cụi",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) cặm cụi một cách vất vả: suốt ngày cùi cụi làm việc",
    example: "suốt ngày cùi cụi làm việc",
  },
  {
    word: "củi lụt",
    part_of_speech: "danh từ",
    meaning: "củi theo dòng nước lụt trôi về: bơi xuồng đi vớt củi lụt",
    example: "bơi xuồng đi vớt củi lụt",
  },
  {
    word: "củi lửa",
    part_of_speech: "danh từ",
    meaning:
      "củi và lửa, những thứ cần thiết để đun nấu (nói khái quát): hết sạch củi lửa",
    example: "hết sạch củi lửa",
  },
  {
    word: "củi lửa",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) việc nấu nướng: phụ trách củi lửa * mọi chuyện củi lửa đều một tay chị ấy lo",
    example: "phụ trách củi lửa * mọi chuyện củi lửa đều một tay chị ấy lo",
  },
  {
    word: "củi rả",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) như củi đóm: không còn củi rả mà nấu nướng",
    example: "không còn củi rả mà nấu nướng",
  },
  {
    word: "cùi kén",
    part_of_speech: "danh từ",
    meaning:
      "lớp tơ nõn còn lại sau khi bóc hết áo kén: cùi kén dày có nhiều tơ",
    example: "cùi kén dày có nhiều tơ",
  },
  {
    word: "cùi tay",
    part_of_speech: "danh từ",
    meaning: "phần nhọn ở khuỷu tay khi tay co lại: huých cùi tay vào lưng bạn",
    example: "huých cùi tay vào lưng bạn",
  },
  {
    word: "cúm",
    part_of_speech: "danh từ",
    meaning:
      "bệnh lây dễ thành dịch, do một loại virus gây sốt, viêm mũi, họng, phế quản và đau mỏi: bị cúm",
    example: "bị cúm",
  },
  {
    word: "cum",
    part_of_speech: "danh từ",
    meaning:
      "bó gồm nhiều bông lúa ngắt và buộc chung lại, theo lối gặt của một số dân tộc miền núi: những cum lúa chín vàng trên tay cô gái Thái",
    example: "những cum lúa chín vàng trên tay cô gái Thái",
  },
  {
    word: "cụm cảng",
    part_of_speech: "danh từ",
    meaning:
      "cụm gồm nhiều cảng, về mặt là những công trình có mối liên hệ bổ trợ cho nhau trong việc lưu thông hàng hoá trên một khu vực kinh tế chiến lược: cụm cảng hàng không",
    example: "cụm cảng hàng không",
  },
  {
    word: "cùm cụp",
    part_of_speech: "",
    meaning: "hơi cụp xuống: hai mí mắt cùm cụp",
    example: "hai mí mắt cùm cụp",
  },
  {
    word: "cùm",
    part_of_speech: "danh từ",
    meaning:
      'dụng cụ thường bằng hai tấm gỗ chắc và nặng, có đục sẵn lỗ để cho chân vào, khi ghép lại thì tạo thành ngàm để giữ chặt chân những người bị tù, bị giam tạI chỗ: cùm lim * "Cờ bạc là bác thằng bần, Cửa nhà bán hết tra chân vào cùm." (ca dao)',
    example:
      'cùm lim * "Cờ bạc là bác thằng bần, Cửa nhà bán hết tra chân vào cùm." (ca dao)',
  },
  {
    word: "cùm",
    part_of_speech: "động từ",
    meaning: "khoá chặt chân lại bằng cùm: chân bị cùm chặt",
    example: "chân bị cùm chặt",
  },
  {
    word: "cụm",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp gồm nhiều cây nhỏ hoặc lá, hoa, mọc liền gốc, liền cuống với nhau: cụm cỏ * hoa thơm đánh cả cụm (tng)",
    example: "cụm cỏ * hoa thơm đánh cả cụm (tng)",
  },
  {
    word: "cụm",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp gồm một số đơn vị cùng loại ở gần cạnh nhau, làm thành một đơn vị lớn hơn: cụm dân cư * cụm từ * một cụm khói đen bốc lên",
    example: "cụm dân cư * cụm từ * một cụm khói đen bốc lên",
  },
  {
    word: "cụm",
    part_of_speech: "động từ",
    meaning:
      "tập trung lại từ nhiều chỗ, nhiều nơi khác nhau làm thành một đơn vị lớn hơn: quân địch cụm lại trong đồn để chống cự",
    example: "quân địch cụm lại trong đồn để chống cự",
  },
  {
    word: "cum cúp",
    part_of_speech: "",
    meaning: "hơi cúp xuống: mái tóc ngắn cum cúp",
    example: "mái tóc ngắn cum cúp",
  },
  {
    word: "cụm cứ điểm",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp một số cứ điểm cùng ở trong một khu vực phòng ngự, có sự chỉ huy thống nhất và có thể chi viện lẫn nhau bằng binh lực, hoả lực: tiêu diệt cụm cứ điểm",
    example: "tiêu diệt cụm cứ điểm",
  },
  {
    word: "cùm kẹp",
    part_of_speech: "động từ",
    meaning:
      "cùm chân và kẹp tay; giam giữ và bắt chịu nhục hình (nói khái quát): bị cùm kẹp trong xà lim",
    example: "bị cùm kẹp trong xà lim",
  },
  {
    word: "cụm từ",
    part_of_speech: "danh từ",
    meaning:
      "mức được dùng làm chuẩn, được xác định hoặc giới hạn (thường là theo thói quen): tiêu pha phải có ngữ * chợ có phiên, tiền có ngữ (tng)",
    example: "tiêu pha phải có ngữ * chợ có phiên, tiền có ngữ (tng)",
  },
  {
    word: "cụm từ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) khoảng thời gian ước chừng (thường để so sánh): ngữ này sang năm là hoàn thành",
    example: "ngữ này sang năm là hoàn thành",
  },
  {
    word: "cụm từ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) loại, hạng người hoặc vật (hàm ý coi khinh hoặc chê): ngữ mày thì làm được gì! * mua làm gì cái ngữ ấy!",
    example: "ngữ mày thì làm được gì! * mua làm gì cái ngữ ấy!",
  },
  {
    word: "cụm từ",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị ngữ pháp trung gian giữa từ và câu: ngữ danh từ * ngữ cố định",
    example: "ngữ danh từ * ngữ cố định",
  },
  {
    word: "cụm từ",
    part_of_speech: "danh từ",
    meaning:
      "ngôn ngữ (của một nước nào đó; nói tắt): Việt ngữ * Anh ngữ * Hán ngữ hiện đại * học sinh chuyên ngữ",
    example: "Việt ngữ * Anh ngữ * Hán ngữ hiện đại * học sinh chuyên ngữ",
  },
  {
    word: "cún",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) chó con; cũng thường dùng để gọi trẻ nhỏ, với ý âu yếm: cún con",
    example: "cún con",
  },
  {
    word: "cũn cỡn",
    part_of_speech: "tính từ",
    meaning:
      "ngắn đến mức trông như bị cụt mất một phần (thường nói về quần áo): chiếc váy ngắn cũn cỡn",
    example: "chiếc váy ngắn cũn cỡn",
  },
  {
    word: "cùn",
    part_of_speech: "tính từ",
    meaning: "(lưỡi cắt) trơ mòn, không sắc: dao cùn * lưỡi gươm bị cùn",
    example: "dao cùn * lưỡi gươm bị cùn",
  },
  {
    word: "cùn",
    part_of_speech: "tính từ",
    meaning: "đã mòn đi, cụt đi do dùng nhiều: chổi sể cùn",
    example: "chổi sể cùn",
  },
  {
    word: "cùn",
    part_of_speech: "tính từ",
    meaning:
      "không có gì mới, không có gì hơn, thậm chí còn bị mai một đi: kiến thức cùn dần",
    example: "kiến thức cùn dần",
  },
  {
    word: "cùn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) tỏ ra trơ, lì, không cần biết đến phải trái, hay dở, và phản ứng của người xung quanh: thằng ấy cùn lắm! * cãi cùn",
    example: "thằng ấy cùn lắm! * cãi cùn",
  },
  {
    word: "cùn đời",
    part_of_speech: "tính từ",
    meaning:
      "(thông tục) suốt đời, cho đến hết đời (thường dùng trong câu rủa, hàm ý coi khinh): cùn đời cũng chỉ là anh cu li",
    example: "cùn đời cũng chỉ là anh cu li",
  },
  {
    word: "cúm rúm",
    part_of_speech: "động từ",
    meaning: "co rúm lại vì lạnh hoặc sợ hãi: chân tay cúm rúm vì lạnh",
    example: "chân tay cúm rúm vì lạnh",
  },
  {
    word: "cùn đời mạt kiếp",
    part_of_speech: "",
    meaning:
      "(thông tục) như cùn đời (nhưng nghĩa mạnh hơn): loại người như nó đến cùn đời mạt kiếp vẫn khổ",
    example: "loại người như nó đến cùn đời mạt kiếp vẫn khổ",
  },
  {
    word: "cun cút",
    part_of_speech: "danh từ",
    meaning:
      "chim nhỏ cùng họ với gà, đuôi cộc, chân ngắn, lông màu nâu xám, thường sống ở đồi cỏ, lủi rất nhanh trong bụi cây, cũng được nuôi để lấy thịt, trứng: béo như con cun cút",
    example: "béo như con cun cút",
  },
  {
    word: "cúng",
    part_of_speech: "động từ",
    meaning:
      "dâng lễ vật lên thần thánh hoặc linh hồn người chết, thường có thắp hương, khấn vái, theo tín ngưỡng hoặc phong tục cổ truyền: lễ cúng năm mới * cúng giao thừa",
    example: "lễ cúng năm mới * cúng giao thừa",
  },
  {
    word: "cúng",
    part_of_speech: "động từ",
    meaning:
      "đóng góp tiền của cho một tổ chức, thường là tôn giáo, để làm việc nghĩa, việc phúc đức: cúng ruộng cho nhà chùa * cúng tiền làm phúc",
    example: "cúng ruộng cho nhà chùa * cúng tiền làm phúc",
  },
  {
    word: "cúng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) làm mất tiền của vào tay người khác một cách vô ích: có bao nhiêu cũng cúng vào sòng bạc * cúng tiền cho gái",
    example: "có bao nhiêu cũng cúng vào sòng bạc * cúng tiền cho gái",
  },
  {
    word: "cung",
    part_of_speech: "danh từ",
    meaning:
      "khí giới gồm một thanh cứng uốn cong (gọi là cánh cung), hai đầu nối với nhau bằng sợi dây căng, dùng sức bật của dây để bắn mũi tên đi: giương cung * bắn cung",
    example: "giương cung * bắn cung",
  },
  {
    word: "cung",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ gồm một dây căng trên một cần gỗ dài, dùng để bật cho xơ bông tơi ra: cung bật bông",
    example: "cung bật bông",
  },
  {
    word: "cung",
    part_of_speech: "động từ",
    meaning: "bật cho xơ bông tơi ra bằng cái cung hoặc bằng máy: cung bông",
    example: "cung bông",
  },
  {
    word: "cung",
    part_of_speech: "động từ",
    meaning:
      "(Phương ngữ) co tay thành hình vòng cung: cung tay đấm cái bụp vô gốc cây",
    example: "cung tay đấm cái bụp vô gốc cây",
  },
  {
    word: "cung",
    part_of_speech: "danh từ",
    meaning:
      "(cũng hoàng cung) nhà ở của vua: cung vua phủ chúa * được tuyển vào cung",
    example: "cung vua phủ chúa * được tuyển vào cung",
  },
  {
    word: "cung",
    part_of_speech: "danh từ",
    meaning: "nơi thờ tôn nghiêm nhất trong đền, miếu: cung thờ thánh mẫu",
    example: "cung thờ thánh mẫu",
  },
  {
    word: "cung",
    part_of_speech: "danh từ",
    meaning:
      "toà nhà to đẹp dùng làm nơi tổ chức các hoạt động quần chúng về văn hoá, thể thao: cung văn hoá * cung thiếu nhi * cung thể thao dưới nước",
    example: "cung văn hoá * cung thiếu nhi * cung thể thao dưới nước",
  },
  {
    word: "cung",
    part_of_speech: "danh từ",
    meaning: "ô vuông dùng cho tướng và sĩ trên bàn cờ tướng: tốt nhập cung",
    example: "tốt nhập cung",
  },
  {
    word: "cung",
    part_of_speech: "danh từ",
    meaning:
      "chặng đường đi bộ chừng nửa ngày, hai đầu có trạm nghỉ: đi được nửa cung đường * phu trạm một ngày đi được khoảng hai cung",
    example:
      "đi được nửa cung đường * phu trạm một ngày đi được khoảng hai cung",
  },
  {
    word: "cung",
    part_of_speech: "danh từ",
    meaning:
      "chặng đường chia ra trên một tuyến đường giao thông để tiện cho việc quản lí: cán bộ phụ trách cung đường đoạn từ đèo Ngang đến Hà Tĩnh",
    example: "cán bộ phụ trách cung đường đoạn từ đèo Ngang đến Hà Tĩnh",
  },
  {
    word: "cung",
    part_of_speech: "danh từ",
    meaning:
      "lời khai của bị can trước cơ quan điều tra: lấy cung * bức cung * hỏi cung",
    example: "lấy cung * bức cung * hỏi cung",
  },
  {
    word: "cung",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị để đo khoảng cách giữa hai nốt nhạc: lỗi nhịp cung đàn * hát lạc nhịp sai cung",
    example: "lỗi nhịp cung đàn * hát lạc nhịp sai cung",
  },
  {
    word: "cung",
    part_of_speech: "danh từ",
    meaning:
      'tính cách về giọng điệu của bài ca, bản nhạc cổ truyền: "Trống cơm khéo vỗ nên vông, Đàn cầm khen ai khéo gảy nên cung xang xừ." (Cdao)',
    example:
      'Trống cơm khéo vỗ nên vông, Đàn cầm khen ai khéo gảy nên cung xang xừ." (Cdao)',
  },
  {
    word: "cung",
    part_of_speech: "danh từ",
    meaning: "khoản, mục trong bảng số tử vi: cung công danh",
    example: "cung công danh",
  },
  {
    word: "cung",
    part_of_speech: "động từ",
    meaning:
      "cung cấp hàng hoá, trong quan hệ với tình hình yêu cầu về hàng hoá trên thị trường: cung không kịp cầu * có cầu thì mới có cung",
    example: "cung không kịp cầu * có cầu thì mới có cung",
  },
  {
    word: "cung bậc",
    part_of_speech: "danh từ",
    meaning:
      "bậc âm trong gam (nói khái quát): những cung bậc trầm bổng của đàn bầu",
    example: "những cung bậc trầm bổng của đàn bầu",
  },
  {
    word: "cung bậc",
    part_of_speech: "danh từ",
    meaning:
      "những biểu hiện khác nhau của trạng thái cảm xúc: những cung bậc của tình yêu * cảm nhận từ nhiều cung bậc khác nhau của cuộc sống",
    example:
      "những cung bậc của tình yêu * cảm nhận từ nhiều cung bậc khác nhau của cuộc sống",
  },
  {
    word: "cùng bất đắc dĩ",
    part_of_speech: "",
    meaning:
      "(hiếm) như bất đắc dĩ (nhưng nghĩa mạnh hơn): cùng bất đắc dĩ mới phải làm thế",
    example: "cùng bất đắc dĩ mới phải làm thế",
  },
  {
    word: "củng",
    part_of_speech: "động từ",
    meaning:
      "gõ mạnh vào đầu, vào trán, thường bằng đầu các khớp ngón tay gập lại: bị củng vào trán * củng cho một phát vào đầu",
    example: "bị củng vào trán * củng cho một phát vào đầu",
  },
  {
    word: "cũng",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị ý khẳng định sự giống nhau về hiện tượng, trạng thái, hoạt động, tính chất của trường hợp sắp nêu ra so với những trường hợp vừa được nói đến hay là so với trước kia: nó cũng nghĩ như anh * đêm ấy trời cũng lạnh như đêm nay",
    example: "nó cũng nghĩ như anh * đêm ấy trời cũng lạnh như đêm nay",
  },
  {
    word: "cũng",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị ý khẳng định trường hợp sắp nêu ra giống như mọi trường hợp thông thường khác (thường dùng trong trường hợp mà hoàn cảnh, điều kiện nêu ra là khác thường để làm tăng thêm ý khẳng định): tôi cũng thấy đẹp * kiến tha lâu cũng đầy tổ (tng)",
    example: "tôi cũng thấy đẹp * kiến tha lâu cũng đầy tổ (tng)",
  },
  {
    word: "cũng",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị ý nhận định trường hợp sắp nêu ra có phần giống như những trường hợp tương tự (theo chủ quan của người nói, dùng để làm cho lời nói bớt vẻ khẳng định): nó cũng khá đấy chứ * bài thơ nghe cũng được",
    example: "nó cũng khá đấy chứ * bài thơ nghe cũng được",
  },
  {
    word: "cũng",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị ý khẳng định trường hợp sắp nêu ra đồng thời diễn ra trong cùng một hoàn cảnh với trường hợp vừa được nói đến: được tin ấy, tôi mừng, nhưng cũng thấy hơi lo * lúc mình đi cũng là lúc trời bắt đầu mưa",
    example:
      "được tin ấy, tôi mừng, nhưng cũng thấy hơi lo * lúc mình đi cũng là lúc trời bắt đầu mưa",
  },
  {
    word: "cùng",
    part_of_speech: "danh từ",
    meaning:
      'chỗ hoặc lúc đến đấy là hết giới hạn, không còn khả năng kéo dài hay mở rộng thêm được nữa: đi đến cùng trời * cãi đến cùng * "Sông kia còn có kẻ dò, Lòng người ai dễ mà đo cho cùng." (ca dao)',
    example:
      'đi đến cùng trời * cãi đến cùng * "Sông kia còn có kẻ dò, Lòng người ai dễ mà đo cho cùng." (ca dao)',
  },
  {
    word: "cùng",
    part_of_speech: "tính từ",
    meaning:
      "ở chỗ cuối, đến đấy là hết giới hạn của cái gì: trên cùng * trong cùng * chỉ vài ba hôm là cùng",
    example: "trên cùng * trong cùng * chỉ vài ba hôm là cùng",
  },
  {
    word: "cùng",
    part_of_speech: "tính từ",
    meaning:
      "ở tình trạng lâm vào thế không còn có lối thoát, không còn biết làm sao được nữa: đến bước đường cùng * bị dồn vào thế cùng",
    example: "đến bước đường cùng * bị dồn vào thế cùng",
  },
  {
    word: "cùng",
    part_of_speech: "tính từ",
    meaning:
      "có sự đồng nhất hoặc có chung những điểm giống nhau: anh em cùng cha khác mẹ * có cùng một sở thích",
    example: "anh em cùng cha khác mẹ * có cùng một sở thích",
  },
  {
    word: "cùng",
    part_of_speech: "kết từ",
    meaning:
      'từ biểu thị người hay sự vật sắp nêu ra có mối quan hệ đồng nhất (về hoạt động, tính chất hoặc chức năng) với người hay sự vật vừa được nói đến: nó đến cùng với bạn * "Nàng về nuôi cái cùng con, Để anh đi trẩy nước non Cao Bằng." (ca dao)',
    example:
      'nó đến cùng với bạn * "Nàng về nuôi cái cùng con, Để anh đi trẩy nước non Cao Bằng." (ca dao)',
  },
  {
    word: "cùng",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị người sắp nêu ra là đối tượng mà chủ thể của hoạt động vừa nói nhằm tới (coi là có quan hệ tác động qua lại mật thiết với chủ thể của hoạt động): biết nói cùng ai * mấy lời xin lỗi cùng bạn đọc",
    example: "biết nói cùng ai * mấy lời xin lỗi cùng bạn đọc",
  },
  {
    word: "cúng bái",
    part_of_speech: "động từ",
    meaning: "cúng tổ tiên, thần thánh (nói khái quát): cúng bái ông bà",
    example: "cúng bái ông bà",
  },
  {
    word: "cung cấm",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) cung vua ở, được canh phòng cẩn mật (nói kháI quát): không được tự do ra vào nơi cung cấm",
    example: "không được tự do ra vào nơi cung cấm",
  },
  {
    word: "cúng cáo",
    part_of_speech: "động từ",
    meaning: "cúng vào hôm trước ngày giỗ chính một ngày: cúng cáo tổ tiên",
    example: "cúng cáo tổ tiên",
  },
  {
    word: "cụng",
    part_of_speech: "động từ",
    meaning:
      "đụng vào một vật cứng khi đang di chuyển: đầu cụng vào tường * cụng li",
    example: "đầu cụng vào tường * cụng li",
  },
  {
    word: "cung cách",
    part_of_speech: "danh từ",
    meaning:
      "cách thức tiến hành có thể nhìn thấy được từ bên ngoài: cung cách làm ăn * cung cách giao tiếp",
    example: "cung cách làm ăn * cung cách giao tiếp",
  },
  {
    word: "cung cầu",
    part_of_speech: "động từ",
    meaning:
      "cung cấp và yêu cầu (hàng hoá trên thị trường; nói gộp): quy luật cung cầu * điều chỉnh quan hệ cung cầu",
    example: "quy luật cung cầu * điều chỉnh quan hệ cung cầu",
  },
  {
    word: "cúng cơm",
    part_of_speech: "động từ",
    meaning:
      "cúng người mới chết vào các bữa ăn thường ngày trong vòng năm mươi ngày đầu, theo phong tục cổ truyền.",
    example: "tên cúng cơm * sắp đến ngày cúng cơm bố",
  },
  {
    word: "cung cấp",
    part_of_speech: "động từ",
    meaning:
      "làm cho có thứ cần để sử dụng: cung cấp lương thực * cung cấp nhân lực * cung cấp thông tin",
    example: "cung cấp lương thực * cung cấp nhân lực * cung cấp thông tin",
  },
  {
    word: "cung cấp",
    part_of_speech: "động từ",
    meaning:
      "phân phối vật phẩm tiêu dùng theo tiêu chuẩn định lượng (trong tình hình sản xuất thiếu, không đủ thoả mãn nhu cầu tiêu dùng): bán với giá cung cấp",
    example: "bán với giá cung cấp",
  },
  {
    word: "cung cúc",
    part_of_speech: "tính từ",
    meaning:
      "(dáng đi, chạy) cắm cúi và nhanh, vội: cắm đầu cung cúc đi thẳng * đứa bé cung cúc chạy theo mẹ",
    example: "cắm đầu cung cúc đi thẳng * đứa bé cung cúc chạy theo mẹ",
  },
  {
    word: "củng cố",
    part_of_speech: "động từ",
    meaning:
      "làm cho trở nên vững chắc hơn: củng cố lực lượng * củng cố niềm tin",
    example: "củng cố lực lượng * củng cố niềm tin",
  },
  {
    word: "cúng cấp",
    part_of_speech: "động từ",
    meaning: "cúng tổ tiên, thần thánh (nói khái quát): cúng bái ông bà",
    example: "cúng bái ông bà",
  },
  {
    word: "cùng cực",
    part_of_speech: "danh từ",
    meaning: "mức tột cùng (của cái không hay): đau đớn đến cùng cực",
    example: "đau đớn đến cùng cực",
  },
  {
    word: "cùng cực",
    part_of_speech: "tính từ",
    meaning:
      "nghèo khổ đến mức không còn có thể hơn được nữa: cảnh sống cùng cực * thoát khỏi sự cùng cực",
    example: "cảnh sống cùng cực * thoát khỏi sự cùng cực",
  },
  {
    word: "cung điện",
    part_of_speech: "danh từ",
    meaning: "nhà ở và làm việc của vua chúa: cung điện của nhà vua",
    example: "cung điện của nhà vua",
  },
  {
    word: "cung đình",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) cung điện và triều đình (nói khái quát): lễ hội cung đình * cuộc sống xa hoa nơi cung đình",
    example: "lễ hội cung đình * cuộc sống xa hoa nơi cung đình",
  },
  {
    word: "cúng giỗ",
    part_of_speech: "động từ",
    meaning: "cúng vào ngày giỗ (nói khái quát): lo việc cúng giỗ trong họ",
    example: "lo việc cúng giỗ trong họ",
  },
  {
    word: "cung độ",
    part_of_speech: "danh từ",
    meaning:
      "chặng đường chia ra để tiện cho việc quản lí và sửa chữa cầu đường: một số cung độ đang được sửa chữa",
    example: "một số cung độ đang được sửa chữa",
  },
  {
    word: "cung đốn",
    part_of_speech: "động từ",
    meaning:
      "cung cấp một cách tốn kém các thức ăn, vật dùng, do bị bắt buộc: bọn ác ôn bắt dân làng cung đốn rượu thịt",
    example: "bọn ác ôn bắt dân làng cung đốn rượu thịt",
  },
  {
    word: "cùng hội cùng thuyền",
    part_of_speech: "",
    meaning:
      "ví trường hợp cùng chung một cảnh ngộ như nhau hoặc cùng một bè cánh với nhau: anh em cùng hội cùng thuyền",
    example: "anh em cùng hội cùng thuyền",
  },
  {
    word: "cùng đường",
    part_of_speech: "tính từ",
    meaning:
      "hết đường, đến đó là không còn lối đi nữa: đi cùng đường rồi mà vẫn không tìm thấy",
    example: "đi cùng đường rồi mà vẫn không tìm thấy",
  },
  {
    word: "cùng đường",
    part_of_speech: "tính từ",
    meaning:
      "không còn lối thoát, không còn biết làm sao được nữa (nên thường đành phải làm liều, làm bừa): bị dồn vào chỗ cùng đường * cùng đường mới phải làm thế",
    example: "bị dồn vào chỗ cùng đường * cùng đường mới phải làm thế",
  },
  {
    word: "cùng khổ",
    part_of_speech: "tính từ",
    meaning:
      "nghèo khổ hết sức, đến cùng cực: lớp người cùng khổ * cuộc sống cùng khổ",
    example: "lớp người cùng khổ * cuộc sống cùng khổ",
  },
  {
    word: "cùng kì lí",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) hết cả lí lẽ: cùng kì lí nên phải ngồi im",
    example: "cùng kì lí nên phải ngồi im",
  },
  {
    word: "cung khai",
    part_of_speech: "động từ",
    meaning:
      "khai những gì đã làm, đã biết, khi bị hỏi cung: lời cung khai của tội nhân",
    example: "lời cung khai của tội nhân",
  },
  {
    word: "cụng li",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) chạm cốc: cụng li chúc mừng",
    example: "cụng li chúc mừng",
  },
  {
    word: "cung kính",
    part_of_speech: "tính từ",
    meaning:
      "(cử chỉ) tỏ ra hết sức kính trọng: cung kính lắng nghe * chắp tay chào một cách rất cung kính",
    example: "cung kính lắng nghe * chắp tay chào một cách rất cung kính",
  },
  {
    word: "cũng nên",
    part_of_speech: "",
    meaning:
      '(khẩu ngữ) tổ hợp biểu thị ý phỏng đoán, có phần hơi khẳng định: có khi nó biết rồi cũng nên * "Trai tứ chiếng gái giang hồ, Gặp nhau làm nổi cơ đồ cũng nên." (ca dao)',
    example:
      'có khi nó biết rồi cũng nên * "Trai tứ chiếng gái giang hồ, Gặp nhau làm nổi cơ đồ cũng nên." (ca dao)',
  },
  {
    word: "cùng kỳ lý",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) hết cả lí lẽ: cùng kì lí nên phải ngồi im",
    example: "cùng kì lí nên phải ngồi im",
  },
  {
    word: "cùng kiệt",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như cùng đường.",
    example: "gia sản đã đến lúc cùng kiệt * bị bóc lột đến cùng kiệt sức lực",
  },
  {
    word: "cung nữ",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người con gái phục vụ trong cung vua, thời phong kiến: tuyển cung nữ",
    example: "tuyển cung nữ",
  },
  {
    word: "cung phụng",
    part_of_speech: "động từ",
    meaning:
      "(cũ) cung cấp cho người trên những thứ cần thiết cho đời sống: cung phụng mẹ cha",
    example: "cung phụng mẹ cha",
  },
  {
    word: "cung phụng",
    part_of_speech: "động từ",
    meaning:
      "cung cấp cho kẻ có quyền thế đủ mọi thứ hòng để cầu cạnh: được bọn đàn em cung phụng đủ thứ",
    example: "được bọn đàn em cung phụng đủ thứ",
  },
  {
    word: "cũng quá tội",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị ý thà rằng không làm việc gì đó, đành chấp nhận tình trạng không hay như hiện tại còn hơn là làm (bởi nếu làm thì thậm chí còn khổ hơn): đi chơi mà mưa gió thế này thì cũng quá tội",
    example: "đi chơi mà mưa gió thế này thì cũng quá tội",
  },
  {
    word: "cung quế",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) như cung trăng: "Cũng có kẻ màn loan trướng huệ, Những cậy mình cung quế Hằng Nga." (CH)',
    example:
      'Cũng có kẻ màn loan trướng huệ, Những cậy mình cung quế Hằng Nga." (CH)',
  },
  {
    word: "cung quế",
    part_of_speech: "danh từ",
    meaning:
      'như tiêu phòng: "Trong cung quế âm thầm chiếc bóng, Đêm năm canh trông ngóng lần lần." (CO)',
    example:
      'Trong cung quế âm thầm chiếc bóng, Đêm năm canh trông ngóng lần lần." (CO)',
  },
  {
    word: "cung quăng",
    part_of_speech: "danh từ",
    meaning: "bọ gậy: diệt cung quăng để trừ muỗi",
    example: "diệt cung quăng để trừ muỗi",
  },
  {
    word: "cung thất",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, hiếm) nhà cửa to đẹp, thường là nơi ở của vua chúa: cung thất tráng lệ",
    example: "cung thất tráng lệ",
  },
  {
    word: "cúng tế",
    part_of_speech: "động từ",
    meaning: "cúng bái và tế lễ (nói khái quát): cúng tế thần linh",
    example: "cúng tế thần linh",
  },
  {
    word: "cùng quẫn",
    part_of_speech: "tính từ",
    meaning:
      "nghèo túng và khốn đốn hết sức: cuộc sống cùng quẫn * cảnh nhà cùng quẫn",
    example: "cuộc sống cùng quẫn * cảnh nhà cùng quẫn",
  },
  {
    word: "cùng quẫn",
    part_of_speech: "tính từ",
    meaning:
      "nguy khốn, không có lối thoát: bị dồn vào thế cùng quẫn * cơn cùng quẫn",
    example: "bị dồn vào thế cùng quẫn * cơn cùng quẫn",
  },
  {
    word: "cùng tận",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như tận cùng: nơi cùng tận của trái đất",
    example: "nơi cùng tận của trái đất",
  },
  {
    word: "cung thương",
    part_of_speech: "",
    meaning:
      '(cũ, văn chương) cung và thương, âm thứ nhất và âm thứ hai trong ngũ âm thời cổ của Trung Quốc; dùng để chỉ ngũ âm (cung, thương, dốc, chuỷ, vũ), hoặc âm nhạc nói chung: "Cung thương làu bậc ngũ âm, Nghề riêng ăn đứt hồ cầm một trương." (TKiều)',
    example:
      'Cung thương làu bậc ngũ âm, Nghề riêng ăn đứt hồ cầm một trương." (TKiều)',
  },
  {
    word: "cung trăng",
    part_of_speech: "danh từ",
    meaning:
      "cung điện tưởng tượng ở trên mặt trăng, theo một tích cũ: “Ai lên cho tới cung trăng, Nhắn con vịt nước đừng ăn cá trời.” (ca dao)",
    example:
      "“Ai lên cho tới cung trăng, Nhắn con vịt nước đừng ăn cá trời.” (ca dao)",
  },
  {
    word: "cung tiêu",
    part_of_speech: "động từ",
    meaning:
      "(cũ, hiếm) cung cấp và tiêu thụ (nói gộp): bộ phận cung tiêu của xí nghiệp * hợp tác xã cung tiêu (hợp tác xã mua bán)",
    example:
      "bộ phận cung tiêu của xí nghiệp * hợp tác xã cung tiêu (hợp tác xã mua bán)",
  },
  {
    word: "cùng tột",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như tột cùng: cô đơn cùng tột",
    example: "cô đơn cùng tột",
  },
  {
    word: "cúng tiến",
    part_of_speech: "động từ",
    meaning:
      "dâng lễ vật hoặc đóng góp tiền của cho nhà chùa hoặc tổ chức tôn giáo: cúng tiến nhà chùa một pho tượng đồng",
    example: "cúng tiến nhà chùa một pho tượng đồng",
  },
  {
    word: "cung ứng",
    part_of_speech: "động từ",
    meaning:
      "cung cấp đáp ứng nhu cầu, thường là của sản xuất, hoặc của hành khách: phòng cung ứng vật tư",
    example: "phòng cung ứng vật tư",
  },
  {
    word: "cuốc",
    part_of_speech: "danh từ",
    meaning:
      "chim nhỏ, hơi giống gà, sống ở bờ bụi gần nước, lủi nhanh, có tiếng kêu cuốc cuốc: lủi như cuốc * trông gà hoá cuốc (tng)",
    example: "lủi như cuốc * trông gà hoá cuốc (tng)",
  },
  {
    word: "cuốc",
    part_of_speech: "danh từ",
    meaning:
      "nông cụ gồm một lưỡi sắt tra vuông góc vào cán dài, dùng để bổ, xới đất: vác cuốc ra đồng * chêm cán cuốc",
    example: "vác cuốc ra đồng * chêm cán cuốc",
  },
  {
    word: "cuốc",
    part_of_speech: "động từ",
    meaning: "bổ, xới đất bằng cái cuốc: cuốc đất trồng rau * cày sâu cuốc bẫm",
    example: "cuốc đất trồng rau * cày sâu cuốc bẫm",
  },
  {
    word: "cuốc",
    part_of_speech: "danh từ",
    meaning:
      "(Từ cũ, Khẩu ngữ) quãng đường đi một lần của xe kéo, xe xích lô: chạy một cuốc xe",
    example: "chạy một cuốc xe",
  },
  {
    word: "cuốc",
    part_of_speech: "động từ",
    meaning:
      "(Thông tục) đi bộ nhanh và thẳng một mạch: cuốc thẳng một mạch về nhà",
    example: "cuốc thẳng một mạch về nhà",
  },
  {
    word: "cuộc",
    part_of_speech: "danh từ",
    meaning:
      "việc, tình huống, tình hình diễn ra theo một quá trình và có nhiều người tham gia: người ngoài cuộc * cuộc họp giao ban * cuộc vui chưa tàn",
    example: "người ngoài cuộc * cuộc họp giao ban * cuộc vui chưa tàn",
  },
  {
    word: "cuộc",
    part_of_speech: "động từ",
    meaning:
      "giao hẹn với nhau sẽ tính được thua về điều phỏng đoán đúng hay sai hoặc về điều thách thức nhau: anh có dám cuộc với tôi không?",
    example: "anh có dám cuộc với tôi không?",
  },
  {
    word: "cuộc",
    part_of_speech: "danh từ",
    meaning: "điều cuộc với nhau: chấp nhận thua cuộc * được cuộc",
    example: "chấp nhận thua cuộc * được cuộc",
  },
  {
    word: "cuộc gọi",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian nhất định (tương ứng với số tiền phải trả) trong một lần giao tiếp qua điện thoại: tính tiền cuộc gọi * mỗi ngày nhận được hàng trăm cuộc gọi",
    example: "tính tiền cuộc gọi * mỗi ngày nhận được hàng trăm cuộc gọi",
  },
  {
    word: "cuộc chiến",
    part_of_speech: "danh từ",
    meaning:
      "cuộc chiến tranh hoặc cuộc chiến đấu, đấu tranh (nói tắt): cuộc chiến ngày càng ác liệt * cuộc chiến chống lại căn bệnh thế kỉ",
    example:
      "cuộc chiến ngày càng ác liệt * cuộc chiến chống lại căn bệnh thế kỉ",
  },
  {
    word: "cuộc chiến",
    part_of_speech: "danh từ",
    meaning:
      "cuộc cạnh tranh giữa các thành phần khác nhau có cùng môi trường hoạt động: cuộc chiến giành giật thị trường",
    example: "cuộc chiến giành giật thị trường",
  },
  {
    word: "cuốc bộ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đi bộ một mạch, vẻ vất vả: không có xe, phải cuốc bộ về nhà",
    example: "không có xe, phải cuốc bộ về nhà",
  },
  {
    word: "cuộc thế",
    part_of_speech: "danh từ",
    meaning: "(cũ, văn chương) như thế cuộc: cuộc thế xoay vần",
    example: "cuộc thế xoay vần",
  },
  {
    word: "cuộc đời",
    part_of_speech: "danh từ",
    meaning:
      "quá trình sống của một người, một cá thể sinh vật, nhìn một cách toàn bộ từ lúc sinh ra cho đến lúc chết: cuộc đời và sự nghiệp của nhà thơ * sống một cuộc đời nghèo khổ",
    example: "cuộc đời và sự nghiệp của nhà thơ * sống một cuộc đời nghèo khổ",
  },
  {
    word: "cuộc đời",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ đời sống xã hội với những hoạt động, những sự kiện xảy ra trong đó: xa lánh cuộc đời",
    example: "xa lánh cuộc đời",
  },
  {
    word: "cuộc chơi",
    part_of_speech: "danh từ",
    meaning:
      "lần diễn ra một trò chơi; thường dùng để ví một cuộc đọ sức, đấu trí hết sức căng thẳng giữa các bên, trong một công việc nhất định nào đó: nhảy vào cuộc chơi",
    example: "nhảy vào cuộc chơi",
  },
  {
    word: "cuộc sống",
    part_of_speech: "danh từ",
    meaning:
      "tổng thể nói chung những hoạt động trong đời sống của một con người hay một xã hội: cuộc sống lam lũ * những thăng trầm của cuộc sống",
    example: "cuộc sống lam lũ * những thăng trầm của cuộc sống",
  },
  {
    word: "cuối",
    part_of_speech: "",
    meaning:
      "phần ở gần điểm giới hạn, chỗ hoặc lúc sắp kết thúc: nhà ở cuối phố * đêm cuối năm * theo dõi từ đầu tới cuối bộ phim",
    example: "nhà ở cuối phố * đêm cuối năm * theo dõi từ đầu tới cuối bộ phim",
  },
  {
    word: "cuối cùng",
    part_of_speech: "tính từ",
    meaning:
      "ở chỗ cuối, lúc cuối, sau đấy là hết, là chấm dứt: đọc đến trang cuối cùng * cuối cùng thì nó cũng chịu khai",
    example: "đọc đến trang cuối cùng * cuối cùng thì nó cũng chịu khai",
  },
  {
    word: "cuốn",
    part_of_speech: "động từ",
    meaning:
      "thu gọn vật có hình tấm lại thành hình trụ bằng cách uốn cong một đầu lại và lăn tròn nhiều vòng trên bản thân nó: cuốn chiếc chiếu lại cho gọn * cuốn tròn tờ báo",
    example: "cuốn chiếc chiếu lại cho gọn * cuốn tròn tờ báo",
  },
  {
    word: "cuốn",
    part_of_speech: "động từ",
    meaning:
      "kéo theo và mang đi trên đà chuyển động nhanh và mạnh: bụi cuốn mù mịt * lũ cuốn trôi nhà cửa",
    example: "bụi cuốn mù mịt * lũ cuốn trôi nhà cửa",
  },
  {
    word: "cuốn",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) làm cho chú ý đến mức ham thích mà bị hút theo: cuốn vào câu chuyện * bị cuốn vào dòng xoáy bạo lực",
    example: "cuốn vào câu chuyện * bị cuốn vào dòng xoáy bạo lực",
  },
  {
    word: "cuốn",
    part_of_speech: "danh từ",
    meaning:
      "từ chỉ từng đơn vị sách vở được đóng thành tập, hay từng đơn vị tác phẩm văn học, tác phẩm điện ảnh: cuốn từ điển * in một nghìn cuốn * cuốn tiểu thuyết * cuốn phim truyện",
    example:
      "cuốn từ điển * in một nghìn cuốn * cuốn tiểu thuyết * cuốn phim truyện",
  },
  {
    word: "cuốn",
    part_of_speech: "danh từ",
    meaning:
      "lối xây hình vòng cung vượt qua khoảng trống trong một số chi tiết hoặc là một bộ phận của công trình xây dựng: cổng xây cuốn * cửa cuốn tò vò",
    example: "cổng xây cuốn * cửa cuốn tò vò",
  },
  {
    word: "cuội",
    part_of_speech: "danh từ",
    meaning: "đá cuội (nói tắt): hòn cuội",
    example: "hòn cuội",
  },
  {
    word: "cuội",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ, hiếm) nhảm nhí: hứa cuội cho xong chuyện",
    example: "hứa cuội cho xong chuyện",
  },
  {
    word: "cuốn chiếu",
    part_of_speech: "động từ",
    meaning:
      "làm đến đâu xong đến đấy, và cứ thế làm tiếp cho đến khi kết thúc công việc: đầu tư sản xuất theo kiểu cuốn chiếu",
    example: "đầu tư sản xuất theo kiểu cuốn chiếu",
  },
  {
    word: "cuộn",
    part_of_speech: "động từ",
    meaning:
      "làm cho vật có hình tấm hoặc hình sợi thu thật gọn lại bằng cách lăn hoặc quấn thành nhiều vòng trên bản thân nó: cuộn tấm bạt lại * sợi dây cáp đã được cuộn tròn",
    example: "cuộn tấm bạt lại * sợi dây cáp đã được cuộn tròn",
  },
  {
    word: "cuộn",
    part_of_speech: "động từ",
    meaning:
      "thu gọn thân hình lại: rắn cuộn mình * con mèo nằm cuộn tròn trên ghế",
    example: "rắn cuộn mình * con mèo nằm cuộn tròn trên ghế",
  },
  {
    word: "cuộn",
    part_of_speech: "động từ",
    meaning:
      "chuyển động dồn dập hết lớp này đến lớp khác: khói cuộn lên từng đụn * dòng sông cuộn sóng",
    example: "khói cuộn lên từng đụn * dòng sông cuộn sóng",
  },
  {
    word: "cuộn",
    part_of_speech: "danh từ",
    meaning:
      "từ chỉ từng đơn vị vật hình tấm hoặc hình sợi đã được cuộn lại: cuộn chỉ * một cuộn giấy * bộ phim có mười cuộn",
    example: "cuộn chỉ * một cuộn giấy * bộ phim có mười cuộn",
  },
  {
    word: "cuộn",
    part_of_speech: "danh từ",
    meaning:
      "từng lớp của một vật đang cuộn lên: từng cuộn khói đen bốc lên * cuộn nước xoáy",
    example: "từng cuộn khói đen bốc lên * cuộn nước xoáy",
  },
  {
    word: "cuỗm",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) chiếm lấy và mang đi một cách nhanh gọn: bị cuỗm mất chiếc ví * kẻ trộm cuỗm hết đồ đạc",
    example: "bị cuỗm mất chiếc ví * kẻ trộm cuỗm hết đồ đạc",
  },
  {
    word: "cuốn gói",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) thu nhặt mọi thứ để rời bỏ đi hẳn (hàm ý khinh): cuốn gói chuồn thẳng",
    example: "cuốn gói chuồn thẳng",
  },
  {
    word: "cuốn hút",
    part_of_speech: "động từ",
    meaning:
      "làm cho phải chú ý và bị cuốn theo: bộ phim cuốn hút người xem * giọng kể rất có sức cuốn hút",
    example: "bộ phim cuốn hút người xem * giọng kể rất có sức cuốn hút",
  },
  {
    word: "cuồn cuộn",
    part_of_speech: "động từ",
    meaning:
      "từ gợi tả dáng chuyển động như cuộn lớp này tiếp theo lớp khác, dồn dập và mạnh mẽ: khói cuồn cuộn bốc lên * nước sông cuồn cuộn chảy",
    example: "khói cuồn cuộn bốc lên * nước sông cuồn cuộn chảy",
  },
  {
    word: "cuồn cuộn",
    part_of_speech: "động từ",
    meaning:
      "(cơ bắp, gân) nổi lên từng đoạn như những làn sóng: cơ bắp nổi cuồn cuộn",
    example: "cơ bắp nổi cuồn cuộn",
  },
  {
    word: "cuốn vó",
    part_of_speech: "động từ",
    meaning:
      "(ngựa) co chân chạy rất nhanh; thường dùng trong khẩu ngữ để ví hành động bỏ chạy vội vàng (hàm ý khinh): cuốn vó chạy * bị lật tẩy, tên bịp bợm cuốn vó chuồn thẳng",
    example: "cuốn vó chạy * bị lật tẩy, tên bịp bợm cuốn vó chuồn thẳng",
  },
  {
    word: "cuốn xéo",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) đi hẳn nơi khác ngay lập tức vì bị xua đuổi (hàm ý khinh): cuốn xéo khỏi làng",
    example: "cuốn xéo khỏi làng",
  },
  {
    word: "cuộng",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) cọng của một số loài rau, cỏ: cuộng rau muống * cuộng cỏ khô",
    example: "cuộng rau muống * cuộng cỏ khô",
  },
  {
    word: "cuống",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận của cây, thường hình que, trực tiếp mang lá, hoa hoặc quả: cuống hoa * cuống lá",
    example: "cuống hoa * cuống lá",
  },
  {
    word: "cuống",
    part_of_speech: "danh từ",
    meaning:
      "phần nối liền một số bộ phận trong cơ thể (có hình giống hình cái cuống hoa, cuống lá): cuống đuôi * cuống rốn * cuống phổi",
    example: "cuống đuôi * cuống rốn * cuống phổi",
  },
  {
    word: "cuống",
    part_of_speech: "danh từ",
    meaning: "phần đính thêm vào một số vật, dùng để đeo: cuống huân chương",
    example: "cuống huân chương",
  },
  {
    word: "cuống",
    part_of_speech: "danh từ",
    meaning:
      "phần gốc của vé, phiếu, v.v. giữ lại để đối chiếu, làm bằng: cuống biên lai",
    example: "cuống biên lai",
  },
  {
    word: "cuống",
    part_of_speech: "tính từ",
    meaning:
      "rối lên, thường thể hiện ra bằng những cử chỉ vội vàng, lúng túng do quá lo hoặc quá mừng: mừng cuống cả lên * cuống quá, không biết xử trí ra sao!",
    example: "mừng cuống cả lên * cuống quá, không biết xử trí ra sao!",
  },
  {
    word: "cuồng dại",
    part_of_speech: "tính từ",
    meaning: "điên cuồng và ngu dại: hành động cuồng dại của tên giết người",
    example: "hành động cuồng dại của tên giết người",
  },
  {
    word: "cuống cà kê",
    part_of_speech: "tính từ",
    meaning: "cuống quýt lên (hàm ý hài hước): chưa gì đã cuống cà kê lên",
    example: "chưa gì đã cuống cà kê lên",
  },
  {
    word: "cuồng",
    part_of_speech: "tính từ",
    meaning:
      "không tự kìm giữ được trong hành động, nói năng do thần kinh không bình thường hoặc do lí trí không chế ngự được tình cảm quá mạnh: sợ đến phát cuồng * cuồng lên vì sung sướng",
    example: "sợ đến phát cuồng * cuồng lên vì sung sướng",
  },
  {
    word: "cuồng",
    part_of_speech: "tính từ",
    meaning:
      "có cảm giác bứt rứt khó chịu vì hoạt động bị kìm hãm, chỉ chực có dịp là hoạt động cho thoả: ngồi mãi cũng cuồng cẳng * cuồng chân",
    example: "ngồi mãi cũng cuồng cẳng * cuồng chân",
  },
  {
    word: "cuồng",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) (chân) có cảm giác bứt rứt khó chịu đến mức như không còn điều khiển theo ý muốn được nữa: đạp xe mấy chục cây số, cuồng cả chân",
    example: "đạp xe mấy chục cây số, cuồng cả chân",
  },
  {
    word: "cuồng chiến",
    part_of_speech: "tính từ",
    meaning: "hiếu chiến đến mức như điên cuồng: tên phát xít cuồng chiến",
    example: "tên phát xít cuồng chiến",
  },
  {
    word: "cuồng bạo",
    part_of_speech: "tính từ",
    meaning: "tàn bạo đến mức như điên cuồng: lũ giặc cuồng bạo",
    example: "lũ giặc cuồng bạo",
  },
  {
    word: "cuống cuồng",
    part_of_speech: "tính từ",
    meaning:
      "cuống cả lên, đến mức rối rít, vội vàng, do quá lo lắng, sợ sệt: lo cuống cuồng * chạy cuống cuồng",
    example: "lo cuống cuồng * chạy cuống cuồng",
  },
  {
    word: "cuồng loạn",
    part_of_speech: "tính từ",
    meaning:
      "ở vào trạng trái hoàn toàn buông thả, không tự kìm giữ trong các thú vui vật chất tầm thường, đến mức như điên cuồng: điệu nhảy cuồng loạn",
    example: "điệu nhảy cuồng loạn",
  },
  {
    word: "cuồng dâm",
    part_of_speech: "tính từ",
    meaning: "dâm loạn đến mức như điên cuồng: bệnh cuồng dâm",
    example: "bệnh cuồng dâm",
  },
  {
    word: "cuồng nhiệt",
    part_of_speech: "tính từ",
    meaning:
      "(tình cảm) sôi nổi đến mức không còn chế ngự được nữa: đám đông cổ vũ hết sức cuồng nhiệt * ham muốn cuồng nhiệt",
    example: "đám đông cổ vũ hết sức cuồng nhiệt * ham muốn cuồng nhiệt",
  },
  {
    word: "cuồng nộ",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái căm giận đến mức có những hành động mạnh mẽ, không kìm giữ được: một đám đông cuồng nộ và hung bạo * bão tố nổi cơn cuồng nộ",
    example: "một đám đông cuồng nộ và hung bạo * bão tố nổi cơn cuồng nộ",
  },
  {
    word: "cuồng phong",
    part_of_speech: "danh từ",
    meaning: "(văn chương) cơn gió xoáy dữ dội: trận cuồng phong",
    example: "trận cuồng phong",
  },
  {
    word: "cuống quýt",
    part_of_speech: "tính từ",
    meaning:
      "vội vã, rối rít do đang cuống lên: gọi cuống quýt cả lên * mừng cuống quýt",
    example: "gọi cuống quýt cả lên * mừng cuống quýt",
  },
  {
    word: "cuồng sát",
    part_of_speech: "động từ",
    meaning:
      "giết người một cách điên cuồng và tàn bạo, không còn nhân tính: kẻ cuồng sát",
    example: "kẻ cuồng sát",
  },
  {
    word: "cuống quít",
    part_of_speech: "tính từ",
    meaning:
      "vội vã, rối rít do đang cuống lên: gọi cuống quýt cả lên * mừng cuống quýt",
    example: "gọi cuống quýt cả lên * mừng cuống quýt",
  },
  {
    word: "cuồng vọng",
    part_of_speech: "",
    meaning:
      "ước vọng ngông cuồng: cuồng vọng làm bá chủ một vùng * quá cuồng vọng về tương lai",
    example: "cuồng vọng làm bá chủ một vùng * quá cuồng vọng về tương lai",
  },
  {
    word: "cụp",
    part_of_speech: "động từ",
    meaning:
      "gập, rủ hẳn xuống và quặp vào: mi mắt cụp xuống vì buồn ngủ * con chó cụp đuôi lủi mất",
    example: "mi mắt cụp xuống vì buồn ngủ * con chó cụp đuôi lủi mất",
  },
  {
    word: "cụp",
    part_of_speech: "động từ",
    meaning: "gập lại, không giương lên, giương ra nữa: cụp dù",
    example: "cụp dù",
  },
  {
    word: "cúp",
    part_of_speech: "danh từ",
    meaning:
      "đồ mĩ nghệ dùng làm giải thưởng trong cuộc thi đấu thể thao, thường để trao cho người hoặc đội đoạt chức vô địch: cúp vàng luân lưu * đoạt cúp",
    example: "cúp vàng luân lưu * đoạt cúp",
  },
  {
    word: "cúp",
    part_of_speech: "động từ",
    meaning: "gập hẳn xuống và cong vào trong: con chó cúp đuôi chạy mất",
    example: "con chó cúp đuôi chạy mất",
  },
  {
    word: "cúp",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) cắt, không trả hoặc không cho hưởng (cái lẽ ra được hưởng): tháng này bị cúp lương * cúp nước * cúp máy (tắt máy điện thoại)",
    example: "tháng này bị cúp lương * cúp nước * cúp máy (tắt máy điện thoại)",
  },
  {
    word: "cúp",
    part_of_speech: "động từ",
    meaning: "(Phương ngữ) cắt tóc: tóc cúp ngắn",
    example: "tóc cúp ngắn",
  },
  {
    word: "cúp",
    part_of_speech: "động từ",
    meaning: "(Khẩu ngữ) cắt (bóng): một cú cúp bóng điệu nghệ",
    example: "một cú cúp bóng điệu nghệ",
  },
  {
    word: "cuồng tín",
    part_of_speech: "động từ",
    meaning: "tin theo một cách mãnh liệt và mù quáng: những tín đồ cuồng tín",
    example: "những tín đồ cuồng tín",
  },
  {
    word: "cút",
    part_of_speech: "động từ",
    meaning:
      "đi khỏi nơi nào đó ngay vì bắt buộc, vì bị xua đuổi (hàm ý khinh): cút ngay cho khuất mắt!",
    example: "cút ngay cho khuất mắt!",
  },
  {
    word: "cụt thun lủn",
    part_of_speech: "tính từ",
    meaning:
      "như cụt lủn (nhưng ý mức độ nhiều hơn): buông một câu cụt thun lủn",
    example: "buông một câu cụt thun lủn",
  },
  {
    word: "cụt",
    part_of_speech: "tính từ",
    meaning:
      "mất hẳn một đoạn ở một đầu, làm cho trở nên không trọn vẹn trên chiều dài: cây cụt ngọn * bị cụt một chân",
    example: "cây cụt ngọn * bị cụt một chân",
  },
  {
    word: "cụt",
    part_of_speech: "tính từ",
    meaning:
      "đến đấy thì hết, thì tắc lại, không thông nữa: chạy vào ngõ cụt * đoạn mương cụt",
    example: "chạy vào ngõ cụt * đoạn mương cụt",
  },
  {
    word: "cụt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (vốn liếng) bị mất đi phần lớn, không còn đầy đủ, nguyên vẹn nữa: bị lỗ một chuyến là cụt vốn",
    example: "bị lỗ một chuyến là cụt vốn",
  },
  {
    word: "cụt ngủn",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như cụt lủn: con chó có cái đuôi cụt ngủn",
    example: "con chó có cái đuôi cụt ngủn",
  },
  {
    word: "cứ",
    part_of_speech: "động từ",
    meaning: "dựa theo để hành động hoặc lập luận: cứ theo luật để luận tội",
    example: "cứ theo luật để luận tội",
  },
  {
    word: "cứ",
    part_of_speech: "động từ",
    meaning:
      "dựa vào, lấy đó làm điều kiện tất yếu cho sự việc gì: cứ chủ nhật là được nghỉ * cứ đà này thì chẳng mấy chốc mà giàu",
    example: "cứ chủ nhật là được nghỉ * cứ đà này thì chẳng mấy chốc mà giàu",
  },
  {
    word: "cứ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) căn cứ địa cách mạng ở vùng nông thôn hoặc rừng núi: tạm rút về cứ",
    example: "tạm rút về cứ",
  },
  {
    word: "cứ",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị ý khẳng định dứt khoát về hoạt động, trạng thái nhất định là như thế, bất chấp mọi điều kiện: nó vẫn cứ chứng nào tật ấy * dù thế nào cũng cứ đi",
    example: "nó vẫn cứ chứng nào tật ấy * dù thế nào cũng cứ đi",
  },
  {
    word: "cứ",
    part_of_speech: "trợ từ",
    meaning:
      "(khẩu ngữ) từ biểu thị ý nhấn mạnh thêm về sắc thái khẳng định, bất chấp điều kiện khách quan như thế nào: nói cứ như thật! * cái mặt nó cứ câng câng!",
    example: "nói cứ như thật! * cái mặt nó cứ câng câng!",
  },
  {
    word: "cụt hứng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) mất hẳn hứng thú một cách đột ngột khi đang vui, đang hi vọng: cụt hứng vì bị chặn họng * làm cho cụt hứng",
    example: "cụt hứng vì bị chặn họng * làm cho cụt hứng",
  },
  {
    word: "cử",
    part_of_speech: "động từ",
    meaning:
      "nhấc và nâng vật nặng lên cao quá đầu để thử hoặc để luyện sức mạnh: cử tạ",
    example: "cử tạ",
  },
  {
    word: "cử",
    part_of_speech: "động từ",
    meaning:
      "(Trang trọng) làm cất lên tiếng nhạc một cách trang nghiêm: đội quân nhạc cử quốc ca",
    example: "đội quân nhạc cử quốc ca",
  },
  {
    word: "cử",
    part_of_speech: "động từ",
    meaning:
      "lựa chọn ra để chính thức giao cho giữ một trách nhiệm hoặc làm một việc gì: cử đại biểu đi dự đại hội * được cử làm trưởng phòng",
    example: "cử đại biểu đi dự đại hội * được cử làm trưởng phòng",
  },
  {
    word: "cụt lủn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ngắn, cụt đến mức như thiếu hẳn đi một đoạn: tóc cắt cụt lủn * trả lời cụt lủn",
    example: "tóc cắt cụt lủn * trả lời cụt lủn",
  },
  {
    word: "cự",
    part_of_speech: "động từ",
    meaning: "chống lại bằng sức lực: sức yếu, cự không nổi",
    example: "sức yếu, cự không nổi",
  },
  {
    word: "cự",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) phản ứng gay gắt bằng lời nói để bảo thẳng cho biết là không đồng ý: lên tiếng cự lại * cự cho nó một mẻ",
    example: "lên tiếng cự lại * cự cho nó một mẻ",
  },
  {
    word: "cừ",
    part_of_speech: "danh từ",
    meaning: "ngòi nước, lạch nước: khoi cừ",
    example: "khoi cừ",
  },
  {
    word: "cừ",
    part_of_speech: "danh từ",
    meaning:
      "dãy gồm những tấm gỗ, thép hoặc những thân tre ghép kín, ngăn không cho nước thấm qua hoặc để giữ cho đất đá khỏi sụt lở trôi đi.",
    example: "cắm cừ",
  },
  {
    word: "cừ",
    part_of_speech: "động từ",
    meaning: "đóng, cắm cừ: cừ bờ đê * cừ những chỗ sạt lở",
    example: "cừ bờ đê * cừ những chỗ sạt lở",
  },
  {
    word: "cừ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) giỏi, tài một cách rõ rệt, ai cũng phải công nhận: một tay súng rất cừ",
    example: "một tay súng rất cừ",
  },
  {
    word: "cữ",
    part_of_speech: "danh từ",
    meaning:
      "khoảng cách được xác định để dùng làm chuẩn: căng dây làm cữ * cấy đúng cữ",
    example: "căng dây làm cữ * cấy đúng cữ",
  },
  {
    word: "cữ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) khoảng thời gian xảy ra một hiện tượng thời tiết nào đó trong mỗi đợt: cữ rét cuối năm",
    example: "cữ rét cuối năm",
  },
  {
    word: "cữ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) khoảng thời gian ước chừng: vào cữ này năm ngoái * làm bây giờ, cữ này sang năm là xong",
    example: "vào cữ này năm ngoái * làm bây giờ, cữ này sang năm là xong",
  },
  {
    word: "cữ",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) kiêng: cữ ăn đồ mỡ",
    example: "cữ ăn đồ mỡ",
  },
  {
    word: "cử chỉ",
    part_of_speech: "danh từ",
    meaning:
      "điệu bộ hoặc hành động biểu lộ một thái độ, một trạng thái tinh thần nào đó: cử chỉ âu yếm * để ý từng bước đi, từng cử chỉ",
    example: "cử chỉ âu yếm * để ý từng bước đi, từng cử chỉ",
  },
  {
    word: "cử chỉ",
    part_of_speech: "danh từ",
    meaning: "việc làm biểu lộ một thái độ nào đó: cử chỉ hào hiệp",
    example: "cử chỉ hào hiệp",
  },
  {
    word: "cứ cho là",
    part_of_speech: "",
    meaning:
      'tổ hợp biểu thị điều sắp nêu ra được tạm cho là như thế, không kể thực tế như thế nào, để qua đó có thể rút ra một kết luận nào đó: thôi, cứ cho là 10 cho dễ tính * "Một xã hội viên chức, cứ cho là những viên chức rất mẫn cán, cũng hết sức đáng buồn." (NgKhải; 9)',
    example:
      'thôi, cứ cho là 10 cho dễ tính * "Một xã hội viên chức, cứ cho là những viên chức rất mẫn cán, cũng hết sức đáng buồn." (NgKhải; 9)',
  },
  {
    word: "cử hành",
    part_of_speech: "động từ",
    meaning:
      "tiến hành một cách trang nghiêm: hôn lễ được cử hành trọng thể * cử hành tang lễ",
    example: "hôn lễ được cử hành trọng thể * cử hành tang lễ",
  },
  {
    word: "cư dân",
    part_of_speech: "danh từ",
    meaning:
      "người dân cư trú trong một vùng, một địa bàn cụ thể: cư dân vùng sông nước Nam Bộ",
    example: "cư dân vùng sông nước Nam Bộ",
  },
  {
    word: "cử động",
    part_of_speech: "động từ",
    meaning:
      "tự làm cho một bộ phận nào đó của thân thể chuyển động: cử động chân tay * tay đau nên không được cử động mạnh",
    example: "cử động chân tay * tay đau nên không được cử động mạnh",
  },
  {
    word: "cử động",
    part_of_speech: "danh từ",
    meaning: "sự cử động, lần cử động: cử động của chân, tay khi tập thể dục",
    example: "cử động của chân, tay khi tập thể dục",
  },
  {
    word: "cự li",
    part_of_speech: "danh từ",
    meaning:
      "khoảng cách giữa hai điểm: chạy cự li 100 mét * ngắm bắn ở cự li 200 mét",
    example: "chạy cự li 100 mét * ngắm bắn ở cự li 200 mét",
  },
  {
    word: "cứ liệu",
    part_of_speech: "danh từ",
    meaning:
      "tài liệu dùng làm căn cứ để chứng minh, lập luận: luận án thiếu cứ liệu chính xác",
    example: "luận án thiếu cứ liệu chính xác",
  },
  {
    word: "cừ khôi",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) tài giỏi hơn hẳn mọi người: một tay guitar cừ khôi * chơi bóng rất cừ khôi",
    example: "một tay guitar cừ khôi * chơi bóng rất cừ khôi",
  },
  {
    word: "cự ly",
    part_of_speech: "danh từ",
    meaning:
      "khoảng cách giữa hai điểm: chạy cự li 100 mét * ngắm bắn ở cự li 200 mét",
    example: "chạy cự li 100 mét * ngắm bắn ở cự li 200 mét",
  },
  {
    word: "cứ điểm",
    part_of_speech: "danh từ",
    meaning:
      "vị trí phòng ngự vững chắc có công sự và hoả lực mạnh: tiêu diệt một cứ điểm * cứ điểm Điện Biên Phủ",
    example: "tiêu diệt một cứ điểm * cứ điểm Điện Biên Phủ",
  },
  {
    word: "cự phách",
    part_of_speech: "tính từ",
    meaning:
      "rất tài năng, trội hơn hẳn những người khác: tay trống cự phách * một thương gia cự phách",
    example: "tay trống cự phách * một thương gia cự phách",
  },
  {
    word: "cử nghiệp",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) công việc chuyên đi học để thi cử mong đỗ đạt ra làm quan: lối học cử nghiệp",
    example: "lối học cử nghiệp",
  },
  {
    word: "cử nhân",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) học vị của người đỗ khoa thi hương, trên tú tàI: đỗ cử nhân khoa thi năm Kỉ Dậu",
    example: "đỗ cử nhân khoa thi năm Kỉ Dậu",
  },
  {
    word: "cử nhân",
    part_of_speech: "danh từ",
    meaning:
      "người tốt nghiệp đại học các ngành không phải khoa học ứng dụng hoặc kĩ thuật, ở một số nước: cử nhân toán học * bằng cử nhân",
    example: "cử nhân toán học * bằng cử nhân",
  },
  {
    word: "cử toạ",
    part_of_speech: "danh từ",
    meaning:
      "(trang trọng) toàn thể nói chung những người ngồi nghe hoặc dự một buổi họp, trong quan hệ với diễn giả: cử toạ vỗ tay hoan nghênh",
    example: "cử toạ vỗ tay hoan nghênh",
  },
  {
    word: "cư sĩ",
    part_of_speech: "danh từ",
    meaning: "(cũ) người trí thức thời phong kiến đi ở ẩn: các cư sĩ đời Đường",
    example: "các cư sĩ đời Đường",
  },
  {
    word: "cự phú",
    part_of_speech: "tính từ",
    meaning: "(cũ) rất giàu, giàu sụ: nhà cự phú",
    example: "nhà cự phú",
  },
  {
    word: "cư trú chính trị",
    part_of_speech: "động từ",
    meaning:
      "cư trú hợp pháp tại một nước khác, do bắt buộc phải rời bỏ nước mình vì lí do chính trị: xin cư trú chính trị ở nước ngoài",
    example: "xin cư trú chính trị ở nước ngoài",
  },
  {
    word: "cử tri",
    part_of_speech: "danh từ",
    meaning:
      "người có quyền bỏ phiếu trong cuộc bầu cử các cơ quan quyền lực nhà nước: các cử tri đi bỏ phiếu bầu cử * phiếu cử tri",
    example: "các cử tri đi bỏ phiếu bầu cử * phiếu cử tri",
  },
  {
    word: "cự nự",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) tỏ ý không bằng lòng hoặc không đồng ý bằng những lời phàn nàn khó chịu: biết sai nên im, không cự nự gì nữa",
    example: "biết sai nên im, không cự nự gì nữa",
  },
  {
    word: "cư trú",
    part_of_speech: "động từ",
    meaning:
      "ở thường ngày tại một nơi nào đó: sang cư trú ở nước ngoài * địa bàn cư trú của người Việt cổ",
    example: "sang cư trú ở nước ngoài * địa bàn cư trú của người Việt cổ",
  },
  {
    word: "cử tuyển",
    part_of_speech: "động từ",
    meaning:
      "chọn người theo yêu cầu cụ thể của công việc để cho đi học mà không cần phải thi; phân biệt với thi tuyển: học theo chế độ cử tuyển",
    example: "học theo chế độ cử tuyển",
  },
  {
    word: "cự tuyệt",
    part_of_speech: "động từ",
    meaning:
      "từ chối thẳng thừng, dứt khoát: cự tuyệt lời mời * bị người yêu cự tuyệt",
    example: "cự tuyệt lời mời * bị người yêu cự tuyệt",
  },
  {
    word: "cử tử",
    part_of_speech: "danh từ",
    meaning: "(cũ) như sĩ tử: lối thơ trường ốc của các cử tử",
    example: "lối thơ trường ốc của các cử tử",
  },
  {
    word: "cư xử",
    part_of_speech: "động từ",
    meaning:
      "đối xử trong quan hệ đời sống hằng ngày: biết cách cư xử * cư xử đúng mực * cư xử lịch thiệp",
    example: "biết cách cư xử * cư xử đúng mực * cư xử lịch thiệp",
  },
  {
    word: "cứ việc",
    part_of_speech: "phụ từ",
    meaning:
      '(khẩu ngữ) cứ làm việc gì đó như thường, coi như không có gì tác động, cản trở đến: thích thì cứ việc làm * "Chàng về xin cứ việc về, Đừng nên bẻ lá nguyện thề với ai." (ca dao)',
    example:
      'thích thì cứ việc làm * "Chàng về xin cứ việc về, Đừng nên bẻ lá nguyện thề với ai." (ca dao)',
  },
  {
    word: "cứa",
    part_of_speech: "động từ",
    meaning:
      "làm đứt bằng vật có cạnh sắc, thường bằng cách day đi day lại nhiều lần trên bề mặt: bị thanh nứa cứa vào tay * dao cùn, cứa mãi không đứt",
    example: "bị thanh nứa cứa vào tay * dao cùn, cứa mãi không đứt",
  },
  {
    word: "cửa ải",
    part_of_speech: "danh từ",
    meaning:
      "ải có cửa ngăn, trạm gác và quân đội trấn giữ: binh lính canh giữ cửa ải",
    example: "binh lính canh giữ cửa ải",
  },
  {
    word: "cửa",
    part_of_speech: "danh từ",
    meaning:
      "khoảng trống thông ra ngoài của nơi đã được ngăn kín các phía, thường có lắp bộ phận gọi là cánh cửa để mở ra, đóng vào khi cần thiết: có tiếng gõ cửa * cửa ra vào * cửa tủ mở toang",
    example: "có tiếng gõ cửa * cửa ra vào * cửa tủ mở toang",
  },
  {
    word: "cửa",
    part_of_speech: "danh từ",
    meaning: "lối thông tự nhiên với bên ngoài: cửa hang * cửa rừng",
    example: "cửa hang * cửa rừng",
  },
  {
    word: "cửa",
    part_of_speech: "danh từ",
    meaning:
      "nơi có quan hệ tiếp xúc với bên ngoài, thường có thế lực, trong quan hệ với người có việc cần phải đến: phải qua mấy cửa mới xin được giấy phép * không có cửa làm ăn (kng)",
    example:
      "phải qua mấy cửa mới xin được giấy phép * không có cửa làm ăn (kng)",
  },
  {
    word: "cựa",
    part_of_speech: "động từ",
    meaning:
      "(từ trạng thái không động đậy) cử động khẽ thân mình hoặc bộ phận của thân thể: cựa mình thức giấc * chật không cựa được",
    example: "cựa mình thức giấc * chật không cựa được",
  },
  {
    word: "cựa",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) xoay xở để thoát khỏi một trạng thái không hay nào đó: chứng cớ rành rành, cựa vào đâu được",
    example: "chứng cớ rành rành, cựa vào đâu được",
  },
  {
    word: "cưa",
    part_of_speech: "động từ",
    meaning:
      "xẻ, cắt, làm cho đứt bằng cái cưa: cưa đôi khúc gỗ * cưa ván đóng đò",
    example: "cưa đôi khúc gỗ * cưa ván đóng đò",
  },
  {
    word: "cưa",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) chia: lời lãi cưa đôi * tiền thu được phải cưa cho nó một nửa",
    example: "lời lãi cưa đôi * tiền thu được phải cưa cho nó một nửa",
  },
  {
    word: "cưa",
    part_of_speech: "động từ",
    meaning:
      "(Thông tục) tán tỉnh, làm cho xiêu lòng mà đồng ý nghe theo (thường nói về quan hệ tình cảm): cưa gái",
    example: "cưa gái",
  },
  {
    word: "cư xá",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ, cũ) khu nhà ở tập thể (thường là nhà cao tầng): khu cư xá của nhà máy",
    example: "khu cư xá của nhà máy",
  },
  {
    word: "cửa biển",
    part_of_speech: "danh từ",
    meaning: "nơi sông chảy ra biển.",
    example: "cửa biển Thuận An * cửa biển Hải Phòng",
  },
  {
    word: "cứa cổ",
    part_of_speech: "động từ",
    meaning: "(thông tục) như cắt cổ: bán với giá cứa cổ",
    example: "bán với giá cứa cổ",
  },
  {
    word: "cửa công",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) nơi làm việc của quan lại, trong quan hệ với người dân có việc cần phải đến: "Đã đưa đến trước cửa công, Ngoài thì là lý, song trong là tình." (TKiều)',
    example:
      'Đã đưa đến trước cửa công, Ngoài thì là lý, song trong là tình." (TKiều)',
  },
  {
    word: "cửa hàng",
    part_of_speech: "danh từ",
    meaning:
      "cơ sở kinh doanh thương nghiệp hoặc kinh doanh dịch vụ nhỏ: cửa hàng thời trang * mở cửa hàng bách hoá",
    example: "cửa hàng thời trang * mở cửa hàng bách hoá",
  },
  {
    word: "cửa hàng",
    part_of_speech: "danh từ",
    meaning:
      "gian nhà dùng làm nơi kinh doanh thương nghiệp hoặc dịch vụ: thuê cửa hàng",
    example: "thuê cửa hàng",
  },
  {
    word: "cửa hiệu",
    part_of_speech: "danh từ",
    meaning: "cửa hàng nhỏ, thường là của tư nhân: cửa hiệu cắt tóc",
    example: "cửa hiệu cắt tóc",
  },
  {
    word: "cửa miệng",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) miệng, về mặt thể hiện hành vi nói năng: câu nói cửa miệng * chỉ tử tế ngoài cửa miệng",
    example: "câu nói cửa miệng * chỉ tử tế ngoài cửa miệng",
  },
  {
    word: "cửa khẩu",
    part_of_speech: "danh từ",
    meaning: "chỗ dùng làm nơi ra vào một nước: cửa khẩu biên giới",
    example: "cửa khẩu biên giới",
  },
  {
    word: "cửa khẩu",
    part_of_speech: "danh từ",
    meaning:
      "chỗ đắp chưa xong hoặc mới bị nước phá vỡ của một con đê: hàn cửa khẩu * mở cửa khẩu để thoát lũ",
    example: "hàn cửa khẩu * mở cửa khẩu để thoát lũ",
  },
  {
    word: "cửa nẻo",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) cửa rả: cái chòi trống trơn, không có cửa nẻo gì",
    example: "cái chòi trống trơn, không có cửa nẻo gì",
  },
  {
    word: "cửa mái",
    part_of_speech: "danh từ",
    meaning: "cửa trổ ra ở mái để thông hơi: trộm chui qua lối cửa mái vào nhà",
    example: "trộm chui qua lối cửa mái vào nhà",
  },
  {
    word: "cửa ngõ",
    part_of_speech: "danh từ",
    meaning: "cửa và cổng của ngôi nhà (nói khái quát): canh chừng cửa ngõ",
    example: "canh chừng cửa ngõ",
  },
  {
    word: "cửa ngõ",
    part_of_speech: "danh từ",
    meaning:
      "nơi có vị trí quan trọng trên lối ra vào một vùng: cửa ngõ của thủ đô",
    example: "cửa ngõ của thủ đô",
  },
  {
    word: "cửa nhà",
    part_of_speech: "danh từ",
    meaning:
      'nhà cửa, đồ đạc và nói chung những gì thuộc đời sống riêng của mỗi gia đình (nói khái quát): coi sóc cửa nhà * "Đàn ông rộng miệng thì sang, Đàn bà rộng miệng tan hoang cửa nhà." (ca dao)',
    example:
      'coi sóc cửa nhà * "Đàn ông rộng miệng thì sang, Đàn bà rộng miệng tan hoang cửa nhà." (ca dao)',
  },
  {
    word: "cửa ô",
    part_of_speech: "danh từ",
    meaning:
      "lối ra vào khu vực một kinh thành cổ (thường nói về kinh thành Thăng Long), thời xưa có cổng đóng, mở: cửa ô Quan Chưởng",
    example: "cửa ô Quan Chưởng",
  },
  {
    word: "cửa rả",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) cửa trong nhà (nói khái quát): cửa rả đóng im ỉm",
    example: "cửa rả đóng im ỉm",
  },
  {
    word: "cửa phật",
    part_of_speech: "danh từ",
    meaning:
      "nhà chùa, trong quan hệ với những người theo đạo Phật: nương mình nơi cửa Phật",
    example: "nương mình nơi cửa Phật",
  },
  {
    word: "cửa quan",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) như cửa công: cáo lên cửa quan * khôn ngoan ra cửa quan mới biết (tng)",
    example: "cáo lên cửa quan * khôn ngoan ra cửa quan mới biết (tng)",
  },
  {
    word: "cửa quan",
    part_of_speech: "tính từ",
    meaning:
      "có thái độ trịch thượng, hách dịch trong khi giải quyết công việc vì tự cho rằng mình đang nắm quyền hành trong tay nên người khác phải cần đến mình: thói cửa quyền * thái độ cửa quyền",
    example: "thói cửa quyền * thái độ cửa quyền",
  },
  {
    word: "cựa quậy",
    part_of_speech: "động từ",
    meaning: "cựa liên tiếp, không chịu yên: nằm im, không cựa quậy",
    example: "nằm im, không cựa quậy",
  },
  {
    word: "cửa tử",
    part_of_speech: "danh từ",
    meaning:
      "cửa chết, chỉ nơi nguy hiểm đến tính mạng: vượt qua cửa tử * thoát khỏi cửa tử",
    example: "vượt qua cửa tử * thoát khỏi cửa tử",
  },
  {
    word: "cửa từ bi",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, văn chương) cửa Phật (chỉ tấm lòng từ bi của đức Phật): nương náu cửa từ bi",
    example: "nương náu cửa từ bi",
  },
  {
    word: "cưa xẻ",
    part_of_speech: "động từ",
    meaning:
      "cưa và xẻ gỗ (nói khái quát): để nguyên cây gỗ, không cưa xẻ gì cả",
    example: "để nguyên cây gỗ, không cưa xẻ gì cả",
  },
  {
    word: "cực chẳng đã",
    part_of_speech: "",
    meaning:
      '(khẩu ngữ) như bất đắc dĩ: cực chẳng đã mới phải đi * "Cực chẳng đã, Pha phải bàn với vợ bán nhà để lấy tiền ăn." (NgCHoan; 4)',
    example:
      'cực chẳng đã mới phải đi * "Cực chẳng đã, Pha phải bàn với vợ bán nhà để lấy tiền ăn." (NgCHoan; 4)',
  },
  {
    word: "cực",
    part_of_speech: "danh từ",
    meaning:
      "điểm ở đầu cùng trên một hướng nào đó: mũi Cà Mau ở cực Nam của Tổ quốc * hai cực đối lập của một vấn đề",
    example:
      "mũi Cà Mau ở cực Nam của Tổ quốc * hai cực đối lập của một vấn đề",
  },
  {
    word: "cực",
    part_of_speech: "danh từ",
    meaning:
      "điểm mà ở đó trục tưởng tượng của Trái Đất xuyên qua mặt đất: hai cực bắc, nam của Trái Đất * khí hậu vùng cực",
    example: "hai cực bắc, nam của Trái Đất * khí hậu vùng cực",
  },
  {
    word: "cực",
    part_of_speech: "danh từ",
    meaning: "điện cực hoặc cực từ (nói tắt): cực dương * hai cực của nam châm",
    example: "cực dương * hai cực của nam châm",
  },
  {
    word: "cực",
    part_of_speech: "phụ từ",
    meaning: "cực kì (nói tắt): học cực giỏi * đẹp cực * thích cực",
    example: "học cực giỏi * đẹp cực * thích cực",
  },
  {
    word: "cức bì",
    part_of_speech: "tính từ",
    meaning:
      "phải chịu đựng điều vất vả, khổ nhục: cuộc sống đỡ cực * cực lòng",
    example: "cuộc sống đỡ cực * cực lòng",
  },
  {
    word: "cực điểm",
    part_of_speech: "danh từ",
    meaning:
      "điểm cao nhất của một trạng thái (thường là trạng thái tâm lí): lo sợ đến cực điểm",
    example: "lo sợ đến cực điểm",
  },
  {
    word: "cực đoan",
    part_of_speech: "tính từ",
    meaning:
      "được đẩy tới mức quá đáng, tới cực độ (thường nói về xu hướng, chủ trương, thái độ): nhìn nhận vấn đề một cách quá cực đoan * thái độ cực đoan",
    example: "nhìn nhận vấn đề một cách quá cực đoan * thái độ cực đoan",
  },
  {
    word: "cực đại",
    part_of_speech: "tính từ",
    meaning:
      "lớn nhất, xét tương đối trong một khoảng nào đó; đối lập với cực tiểu: cường độ âm thanh cực đại * tốc độ đạt đến cực đại",
    example: "cường độ âm thanh cực đại * tốc độ đạt đến cực đại",
  },
  {
    word: "cực hình",
    part_of_speech: "danh từ",
    meaning:
      "hình phạt nặng nhất thời xưa, làm cho phải chết một cách cực kì đau đớn.",
    example: "tra tấn bằng đủ mọi cực hình",
  },
  {
    word: "cực độ",
    part_of_speech: "danh từ",
    meaning:
      "mức độ cao nhất của một trạng thái: nỗi đau đớn dâng lên đến cực độ",
    example: "nỗi đau đớn dâng lên đến cực độ",
  },
  {
    word: "cực độ",
    part_of_speech: "phụ từ",
    meaning: "đến mức độ cao nhất: sung sướng cực độ",
    example: "sung sướng cực độ",
  },
  {
    word: "cực kỳ",
    part_of_speech: "phụ từ",
    meaning:
      "đến mức coi như không thể hơn được nữa: vui cực kì * cách pha chế cực kì đơn giản",
    example: "vui cực kì * cách pha chế cực kì đơn giản",
  },
  {
    word: "cực hữu",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất hữu khuynh cực đoan; đối lập với cực tả: các đảng phái cực hữu * những phần tử cực hữu",
    example: "các đảng phái cực hữu * những phần tử cực hữu",
  },
  {
    word: "cực lạc",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) sung sướng, yên vui đến cực độ; thường chỉ thế giới tưởng tượng, nơi đó con người có thể thoát khỏi mọi sự đau khổ, theo quan niệm của đạo Phật: miền thần tiên cực lạc",
    example: "miền thần tiên cực lạc",
  },
  {
    word: "cực kì",
    part_of_speech: "phụ từ",
    meaning:
      "đến mức coi như không thể hơn được nữa: vui cực kì * cách pha chế cực kì đơn giản",
    example: "vui cực kì * cách pha chế cực kì đơn giản",
  },
  {
    word: "cực khổ",
    part_of_speech: "tính từ",
    meaning:
      "cực và khổ (nói khái quát): cuộc sống hết sức cực khổ * chịu vô vàn cực khổ",
    example: "cuộc sống hết sức cực khổ * chịu vô vàn cực khổ",
  },
  {
    word: "cực nhọc",
    part_of_speech: "tính từ",
    meaning: "vất vả nặng nhọc: làm lụng cực nhọc * vất vả cực nhọc",
    example: "làm lụng cực nhọc * vất vả cực nhọc",
  },
  {
    word: "cực tả",
    part_of_speech: "tính từ",
    meaning:
      "có khuynh hướng tả khuynh cực đoan; đối lập với cực hữu: chính đảng cực tả",
    example: "chính đảng cực tả",
  },
  {
    word: "cực nhục",
    part_of_speech: "tính từ",
    meaning:
      'cực khổ và nhục nhã (nói khái quát): cuộc đời cực nhục * "(...) anh em tiện nhân, chỉ vì có chút tài năng, mà phải cực nhục như quân có tội (...)" (NgHTưởng; 4)',
    example:
      'cuộc đời cực nhục * "(...) anh em tiện nhân, chỉ vì có chút tài năng, mà phải cực nhục như quân có tội (...)" (NgHTưởng; 4)',
  },
  {
    word: "cực lực",
    part_of_speech: "phụ từ",
    meaning: "(phản đối) một cách kịch liệt và kiên quyết: cực lực phản đối",
    example: "cực lực phản đối",
  },
  {
    word: "cực tiểu",
    part_of_speech: "tính từ",
    meaning:
      "nhỏ nhất, xét tương đối trong một khoảng nào đó; đối lập với cực đại: giá trị cực tiểu",
    example: "giá trị cực tiểu",
  },
  {
    word: "cực trị",
    part_of_speech: "danh từ",
    meaning: "giá trị cực đại hoặc cực tiểu: tìm cực trị của một hàm số",
    example: "tìm cực trị của một hàm số",
  },
  {
    word: "cực thịnh",
    part_of_speech: "tính từ",
    meaning:
      "ở vào giai đoạn thịnh vượng nhất, phát triển nhất (so với mọi thời kì hoặc giai đoạn khác): thời kì Phật giáo phát triển cực thịnh",
    example: "thời kì Phật giáo phát triển cực thịnh",
  },
  {
    word: "cưng",
    part_of_speech: "động từ",
    meaning:
      "nâng niu, chăm sóc từng li từng tí do hết sức yêu quý: được cha mẹ cưng * con cưng",
    example: "được cha mẹ cưng * con cưng",
  },
  {
    word: "cưng",
    part_of_speech: "đại từ",
    meaning:
      "(phương ngữ) từ dùng để gọi người mà mình yêu quý, thường là còn trẻ, một cách thân thiết: ngoan đi cưng! * đợi anh chút nghe cưng!",
    example: "ngoan đi cưng! * đợi anh chút nghe cưng!",
  },
  {
    word: "cứng cáp",
    part_of_speech: "tính từ",
    meaning:
      "không còn yếu ớt nữa, mà đã trở nên khoẻ và chắc chắn, có khả năng chịu được những tác động bất lợi từ bên ngoài để tiếp tục phát triển: nét chữ cứng cáp * đứa bé trông rất cứng cáp",
    example: "nét chữ cứng cáp * đứa bé trông rất cứng cáp",
  },
  {
    word: "cứng cỏi",
    part_of_speech: "tính từ",
    meaning:
      "(thái độ, ý chí) vững vàng, không vì yếu mà chịu khuất phục, thay đổi thái độ của mình: ăn nói cứng cỏi * lí lẽ rất cứng cỏi",
    example: "ăn nói cứng cỏi * lí lẽ rất cứng cỏi",
  },
  {
    word: "cứng",
    part_of_speech: "tính từ",
    meaning:
      "có khả năng chịu đựng tác dụng của lực cơ học mà không bị biến dạng: thanh gỗ cứng * cứng như thép",
    example: "thanh gỗ cứng * cứng như thép",
  },
  {
    word: "cứng",
    part_of_speech: "tính từ",
    meaning:
      "mạnh mẽ và có khả năng chịu tác động bất lợi từ bên ngoài mà không bị lay chuyển hoặc thay đổi bản chất: bón lân cho lúa cứng cây * lí lẽ rất cứng * cứng bóng vía",
    example: "bón lân cho lúa cứng cây * lí lẽ rất cứng * cứng bóng vía",
  },
  {
    word: "cứng",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) có trình độ, năng lực khá so với yêu cầu: tay nghề thuộc loại cứng * một giáo viên cứng của trường",
    example: "tay nghề thuộc loại cứng * một giáo viên cứng của trường",
  },
  {
    word: "cứng",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) có số lượng, mức độ coi là hơi cao so với yêu cầu hoặc so với mức thông thường: hai lạng cứng * cứng tuổi * giá ấy cứng quá, không mua được",
    example: "hai lạng cứng * cứng tuổi * giá ấy cứng quá, không mua được",
  },
  {
    word: "cứng",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái mất khả năng biến dạng, cử động, vận động: xi măng chết cứng * hồ đông cứng * chân tay tê cứng",
    example: "xi măng chết cứng * hồ đông cứng * chân tay tê cứng",
  },
  {
    word: "cứng",
    part_of_speech: "tính từ",
    meaning:
      "không còn cách nào có thể thay đổi được, đành phải chịu: chịu cứng, không cãi vào đâu được",
    example: "chịu cứng, không cãi vào đâu được",
  },
  {
    word: "cứng",
    part_of_speech: "tính từ",
    meaning:
      "thiếu sự uyển chuyển, sinh động trong cử động, động tác: động tác múa còn cứng * nét vẽ hơi cứng",
    example: "động tác múa còn cứng * nét vẽ hơi cứng",
  },
  {
    word: "cứng",
    part_of_speech: "tính từ",
    meaning:
      "thiếu sự linh hoạt trong cách đối xử, ứng phó do quá nguyên tắc, không thay đổi cho phù hợp với yêu cầu khách quan: cách giải quyết như vậy là hơi cứng",
    example: "cách giải quyết như vậy là hơi cứng",
  },
  {
    word: "cứng",
    part_of_speech: "tính từ",
    meaning:
      "(thức ăn) hơi mặn, không dịu: đậu phụ kho hơi cứng * nước mắm cứng",
    example: "đậu phụ kho hơi cứng * nước mắm cứng",
  },
  {
    word: "cưng chiều",
    part_of_speech: "động từ",
    meaning: "cưng và chiều (nói khái quát): được cha mẹ cưng chiều",
    example: "được cha mẹ cưng chiều",
  },
  {
    word: "cứng cổ",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như cứng đầu: thằng bé rất cứng cổ",
    example: "thằng bé rất cứng cổ",
  },
  {
    word: "cứng còng",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) như cứng quèo: chiếc quần bò cứng còng",
    example: "chiếc quần bò cứng còng",
  },
  {
    word: "cứng cựa",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) cứng rắn, vững vàng, không chịu lép vế hay yếu thế trước cái gì: tinh thần cứng cựa",
    example: "tinh thần cứng cựa",
  },
  {
    word: "cứng đầu",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ngang bướng, không dễ dàng chịu nghe theo người mà mình phải phục tùng: con bé cứng đầu, rất khó bảo",
    example: "con bé cứng đầu, rất khó bảo",
  },
  {
    word: "cứng họng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) không cãi vào đâu được nữa, đành chịu im: cứng họng, không cãi vào đâu được",
    example: "cứng họng, không cãi vào đâu được",
  },
  {
    word: "cứng đờ",
    part_of_speech: "tính từ",
    meaning:
      "cứng lại và thẳng đờ ra, mất hết khả năng cử động: người cứng đờ * lạnh đến cứng đờ tay chân",
    example: "người cứng đờ * lạnh đến cứng đờ tay chân",
  },
  {
    word: "cứng đờ",
    part_of_speech: "tính từ",
    meaning:
      "thiếu sự mềm mại trong các cử động: tay múa cứng đờ * lối làm việc theo những nguyên tắc cứng đờ",
    example: "tay múa cứng đờ * lối làm việc theo những nguyên tắc cứng đờ",
  },
  {
    word: "cứng ngắc",
    part_of_speech: "tính từ",
    meaning:
      "quá cứng, quá rắn, tựa như không làm sao cho vỡ ra được: viên kẹo cứng ngắc * cái bánh mì cứng ngắc",
    example: "viên kẹo cứng ngắc * cái bánh mì cứng ngắc",
  },
  {
    word: "cứng ngắc",
    part_of_speech: "tính từ",
    meaning:
      "cứng lại và không còn cảm giác gì nữa, mất hết khả năng cử động: toàn thân cứng ngắc như bị hoá thạch",
    example: "toàn thân cứng ngắc như bị hoá thạch",
  },
  {
    word: "cứng ngắc",
    part_of_speech: "tính từ",
    meaning: "thiếu sự mềm mại, uyển chuyển: dáng điệu cứng ngắc",
    example: "dáng điệu cứng ngắc",
  },
  {
    word: "cứng nhắc",
    part_of_speech: "tính từ",
    meaning:
      "không được mềm mại, linh hoạt trong các cử động: dáng đi cứng nhắc * tay chân cứng nhắc",
    example: "dáng đi cứng nhắc * tay chân cứng nhắc",
  },
  {
    word: "cứng nhắc",
    part_of_speech: "tính từ",
    meaning:
      'thiếu linh hoạt, không biết tuỳ điều kiện cụ thể khác nhau mà thay đổi cho phù hợp: nguyên tắc cứng nhắc * "Tại các cuộc họp chung họ rất ít nói, hoặc có nói lại toàn những câu cứng nhắc, sách vở (...)" (NgKhải; 30)',
    example:
      'nguyên tắc cứng nhắc * "Tại các cuộc họp chung họ rất ít nói, hoặc có nói lại toàn những câu cứng nhắc, sách vở (...)" (NgKhải; 30)',
  },
  {
    word: "cứng quèo",
    part_of_speech: "tính từ",
    meaning:
      "cứng đến mức trông thô và xấu (nói về cái đáng lẽ phải mềm): múa cứng quèo * cái bánh cứng quèo",
    example: "múa cứng quèo * cái bánh cứng quèo",
  },
  {
    word: "cứng rắn",
    part_of_speech: "tính từ",
    meaning: "cứng và rắn (nói khái quát): thân thể cứng rắn",
    example: "thân thể cứng rắn",
  },
  {
    word: "cứng rắn",
    part_of_speech: "tính từ",
    meaning:
      "không dễ dàng có sự nhân nhượng trong cách đối xử, quyết giữ một mực như đã định: biện pháp cứng rắn * thái độ cứng rắn đối với kẻ thù",
    example: "biện pháp cứng rắn * thái độ cứng rắn đối với kẻ thù",
  },
  {
    word: "cứng quành",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) cứng đến mức như cong queo đi: cái áo cứng quành",
    example: "cái áo cứng quành",
  },
  {
    word: "cước",
    part_of_speech: "danh từ",
    meaning: "sâu lớn sống trên cây, có thể nhả ra một thứ tơ.",
    example: "tóc bạc trắng như cước",
  },
  {
    word: "cước",
    part_of_speech: "danh từ",
    meaning:
      "hiện tượng ngón tay, ngón chân sưng đỏ và ngứa khi bị rét cóng: trời lạnh, tay hay bị cước",
    example: "trời lạnh, tay hay bị cước",
  },
  {
    word: "cước",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) cước phí (nói tắt): giảm giá cước thuê bao điện thoại * tính cước vận chuyển hàng hoá",
    example:
      "giảm giá cước thuê bao điện thoại * tính cước vận chuyển hàng hoá",
  },
  {
    word: "cước phí",
    part_of_speech: "danh từ",
    meaning:
      "khoản chi phí phải trả cho công một số loại dịch vụ: cước phí vận chuyển * cước phí điện thoại",
    example: "cước phí vận chuyển * cước phí điện thoại",
  },
  {
    word: "cước chú",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) lời chú thích thường ghi ở cuối trang hoặc ở cuối tài liệu: xem cước chú ở cuối trang",
    example: "xem cước chú ở cuối trang",
  },
  {
    word: "cược",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) đặt cọc: tiền cược",
    example: "tiền cược",
  },
  {
    word: "cược",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) như cuộc: đánh cược với nhau",
    example: "đánh cược với nhau",
  },
  {
    word: "cưới",
    part_of_speech: "động từ",
    meaning:
      "làm lễ chính thức lấy nhau thành vợ chồng, theo phong tục hoặc lễ nghi: cưới vợ cho con * làm lễ cưới",
    example: "cưới vợ cho con * làm lễ cưới",
  },
  {
    word: "cười",
    part_of_speech: "động từ",
    meaning:
      "cử động môi hoặc miệng, có thể kèm theo tiếng, để tỏ rõ sự vui thích hoặc thái độ, tình cảm nào đó: bật cười * nhếch mép cười khinh bỉ * tiếng cười giòn tan",
    example: "bật cười * nhếch mép cười khinh bỉ * tiếng cười giòn tan",
  },
  {
    word: "cười",
    part_of_speech: "động từ",
    meaning:
      "tỏ ý chê bai bằng những lời nói có kèm theo tiếng cười hoặc có thể gây cười: làm thế người ta cười chết!",
    example: "làm thế người ta cười chết!",
  },
  {
    word: "cưỡi",
    part_of_speech: "động từ",
    meaning:
      "ngồi trên lưng hoặc vai, hai chân thường bỏ sang hai bên: cưỡi ngựa * thuyền cưỡi sóng ra khơi (b)",
    example: "cưỡi ngựa * thuyền cưỡi sóng ra khơi (b)",
  },
  {
    word: "cưỡi",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) ngồi lên một phương tiện giao thông nào đó (thường là loại xe có yên) để đi (hàm ý vui đùa): cưỡi xe máy đi chơi",
    example: "cưỡi xe máy đi chơi",
  },
  {
    word: "cười cợt",
    part_of_speech: "động từ",
    meaning:
      'cười để đùa bỡn hay để chế nhạo: "Khi khoé hạnh, khi nét ngài, Khi ngâm ngợi nguyệt, khi cười cợt hoa." (TKiều)',
    example:
      'Khi khoé hạnh, khi nét ngài, Khi ngâm ngợi nguyệt, khi cười cợt hoa." (TKiều)',
  },
  {
    word: "cưới cheo",
    part_of_speech: "động từ",
    meaning:
      '(khẩu ngữ) như cưới xin: "(...) vợ chồng nhà kia, lúc lấy nhau, bởi quá nghèo nên chẳng cưới cheo gì." (NCao; 28)',
    example:
      '(...) vợ chồng nhà kia, lúc lấy nhau, bởi quá nghèo nên chẳng cưới cheo gì." (NCao; 28)',
  },
  {
    word: "cười duyên",
    part_of_speech: "động từ",
    meaning: "cười mỉm một cách tình tứ để làm duyên: nở nụ cười duyên",
    example: "nở nụ cười duyên",
  },
  {
    word: "cười chê",
    part_of_speech: "động từ",
    meaning: "như chê cười: bị người đời cười chê",
    example: "bị người đời cười chê",
  },
  {
    word: "cưới hỏi",
    part_of_speech: "động từ",
    meaning: "(hiếm) như cưới xin: lo việc cưới hỏi cho con",
    example: "lo việc cưới hỏi cho con",
  },
  {
    word: "cười khẩy",
    part_of_speech: "động từ",
    meaning:
      "cười nhếch mép, phát ra một tiếng ngắn và khẽ, tỏ vẻ khinh thường hoặc mỉa mai: nhếch mép cười khẩy",
    example: "nhếch mép cười khẩy",
  },
  {
    word: "cười ngất",
    part_of_speech: "động từ",
    meaning:
      "cười lớn tiếng thành từng tràng dài như đến hết hơi mới thôi, tỏ vẻ thích chí, khoái trá hết mức: câu chuyện làm mọi người cười ngất",
    example: "câu chuyện làm mọi người cười ngất",
  },
  {
    word: "cười ồ",
    part_of_speech: "động từ",
    meaning:
      "(nhiều người) cười bật lên thành chuỗi dài cùng một lúc, do thích thú đột ngột trước một điều đáng cười, hoặc để trêu chọc mua vui: câu nói khôi hài làm cả bọn cười ồ lên",
    example: "câu nói khôi hài làm cả bọn cười ồ lên",
  },
  {
    word: "cười ra nước mắt",
    part_of_speech: "",
    meaning:
      "gượng cười trong khi đáng lẽ ra phải khóc (vì trong lòng đang đau đớn): câu chuyện cười ra nước mắt",
    example: "câu chuyện cười ra nước mắt",
  },
  {
    word: "cười rộ",
    part_of_speech: "động từ",
    meaning:
      "(nhiều người) cười bật lên những tiếng to thành một chuỗi dài cùng một lúc, do thích thú đột ngột: câu pha trò làm mọi người cất tiếng cười rộ",
    example: "câu pha trò làm mọi người cất tiếng cười rộ",
  },
  {
    word: "cười phá",
    part_of_speech: "động từ",
    meaning:
      "cười bật to lên thành chuỗi dài, do không nhịn được cười hoặc do có sự thích thú một cách đột ngột: khoái chí, cười phá lên",
    example: "khoái chí, cười phá lên",
  },
  {
    word: "cười nụ",
    part_of_speech: "động từ",
    meaning:
      'cười hơi chúm môi lại, không thành tiếng, tỏ ý thích thú một mình hoặc để làm duyên hay để tỏ tình ý một cách kín đáo: "Cùng trong một tiếng tơ đồng, Người ngoài cười nụ, người trong khóc thầm!" (TKiều)',
    example:
      'Cùng trong một tiếng tơ đồng, Người ngoài cười nụ, người trong khóc thầm!" (TKiều)',
  },
  {
    word: "cười trừ",
    part_of_speech: "động từ",
    meaning:
      'cười thay cho câu trả lời, cốt để lảng tránh điều gì đó (thường là không hay đối với mình): "Mẹ ít nói, cũng ít bàn, chỉ cười trừ với những lời cau có của cha tôi." (HCận; 10)',
    example:
      'Mẹ ít nói, cũng ít bàn, chỉ cười trừ với những lời cau có của cha tôi." (HCận; 10)',
  },
  {
    word: "cưới xin",
    part_of_speech: "động từ",
    meaning:
      "tổ chức lễ cưới, theo phong tục, lễ nghi (nói khái quát): lấy nhau có cưới xin hẳn hoi",
    example: "lấy nhau có cưới xin hẳn hoi",
  },
  {
    word: "cương",
    part_of_speech: "danh từ",
    meaning: "dây da buộc vào hàm thiếc để điều khiển ngựa: dây cương",
    example: "dây cương",
  },
  {
    word: "cương",
    part_of_speech: "tính từ",
    meaning:
      "bị căng, bị sưng lên, thường gây cảm giác căng cứng và đau tức, do có máu, mủ hoặc sữa dồn tụ lại: nhọt đang cương mủ",
    example: "nhọt đang cương mủ",
  },
  {
    word: "cương",
    part_of_speech: "tính từ",
    meaning: "(Ít dùng) cứng rắn trong cách đối xử: lúc nhu, lúc cương",
    example: "lúc nhu, lúc cương",
  },
  {
    word: "cường",
    part_of_speech: "tính từ",
    meaning: "(thuỷ triều) đang dâng cao: con nước cường",
    example: "con nước cường",
  },
  {
    word: "cườm",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) cổ tay, cổ chân: đôi cườm tay đầy đặn",
    example: "đôi cườm tay đầy đặn",
  },
  {
    word: "cườm",
    part_of_speech: "danh từ",
    meaning:
      "hạt nhỏ bằng thuỷ tinh, đá, bột, v.v., thường có màu sắc đẹp, xâu thành chuỗi để làm vật trang sức hoặc trang trí: chuỗi hạt cườm",
    example: "chuỗi hạt cườm",
  },
  {
    word: "cườm",
    part_of_speech: "danh từ",
    meaning:
      "vòng lông lốm đốm nhiều màu sắc quanh cổ chim, trông giống như những hạt cườm: con chim cu cổ cườm",
    example: "con chim cu cổ cườm",
  },
  {
    word: "cười vỡ bụng",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) cười to và thành tràng dài mãi không thôi, đến mức như không thể nín nhịn được, trước một việc quá buồn cười: được một phen bữa cười vỡ bụng",
    example: "được một phen bữa cười vỡ bụng",
  },
  {
    word: "cưỡng",
    part_of_speech: "động từ",
    meaning:
      "bắt ép người khác phải làm điều người ta không muốn làm: cưỡng người đi lính * không muốn đi thì thôi, không cưỡng",
    example: "cưỡng người đi lính * không muốn đi thì thôi, không cưỡng",
  },
  {
    word: "cưỡng",
    part_of_speech: "động từ",
    meaning:
      "không tuân theo mà chống lại, làm trái lại điều gì hoặc cái gì đòi hỏi phải làm: cưỡng lời cha mẹ * không cưỡng được số phận",
    example: "cưỡng lời cha mẹ * không cưỡng được số phận",
  },
  {
    word: "cường bạo",
    part_of_speech: "tính từ",
    meaning: "tàn bạo một cách hung hãn: kẻ cường bạo",
    example: "kẻ cường bạo",
  },
  {
    word: "cưỡng bức",
    part_of_speech: "động từ",
    meaning:
      "dùng vũ lực hoặc thủ đoạn dồn người khác vào thế bắt buộc phải làm, dù không muốn cũng không được: bị cưỡng bức đi lính * cưỡng bức lao động",
    example: "bị cưỡng bức đi lính * cưỡng bức lao động",
  },
  {
    word: "cưỡng chế",
    part_of_speech: "động từ",
    meaning:
      "dùng quyền lực nhà nước bắt phải tuân theo: cưỡng chế những hộ gia đình không chấp hành lệnh di dời nhà ở",
    example: "cưỡng chế những hộ gia đình không chấp hành lệnh di dời nhà ở",
  },
  {
    word: "cưỡng dâm",
    part_of_speech: "động từ",
    meaning: "cưỡng ép người phụ nữ phải để cho thoả sự dâm dục: tội cưỡng dâm",
    example: "tội cưỡng dâm",
  },
  {
    word: "cường điệu",
    part_of_speech: "động từ",
    meaning:
      "trình bày trên mức sự thật một mặt nào đó của sự vật, hiện tượng để làm cho người ta chú ý: cường điệu tính cách của nhân vật",
    example: "cường điệu tính cách của nhân vật",
  },
  {
    word: "cưỡng ép",
    part_of_speech: "động từ",
    meaning:
      "bắt ép phải nghe theo, làm theo điều trái ý muốn: cưỡng ép thanh niên đi lính * bị cưỡng ép phải làm",
    example: "cưỡng ép thanh niên đi lính * bị cưỡng ép phải làm",
  },
  {
    word: "cường hào",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) kẻ có quyền thế ở nông thôn thời phong kiến, chuyên áp bức nông dân: bọn cường hào gian ác",
    example: "bọn cường hào gian ác",
  },
  {
    word: "cường độ lao động",
    part_of_speech: "danh từ",
    meaning:
      "mức hao phí về thể lực và trí lực của con người trong quá trình lao động: cường độ lao động cao",
    example: "cường độ lao động cao",
  },
  {
    word: "cường độ",
    part_of_speech: "danh từ",
    meaning: "độ mạnh: cường độ dòng điện * cường độ âm thanh",
    example: "cường độ dòng điện * cường độ âm thanh",
  },
  {
    word: "cưỡng hôn",
    part_of_speech: "động từ",
    meaning:
      "cưỡng ép phải lấy một người nào đó làm chồng hoặc làm vợ: luật pháp nghiêm cấm việc cưỡng hôn",
    example: "luật pháp nghiêm cấm việc cưỡng hôn",
  },
  {
    word: "cưỡng đoạt",
    part_of_speech: "động từ",
    meaning:
      "chiếm đoạt bằng lối cưỡng bức: phạm tội cưỡng đoạt tài sản công dân",
    example: "phạm tội cưỡng đoạt tài sản công dân",
  },
  {
    word: "cương lĩnh",
    part_of_speech: "danh từ",
    meaning:
      "mục tiêu, đường lối và các bước tiến hành trong một thời kì nhất định, được chính thức quy định (của một chính phủ, một chính đảng hoặc một đoàn thể chính trị): cương lĩnh của đảng",
    example: "cương lĩnh của đảng",
  },
  {
    word: "cường lực",
    part_of_speech: "danh từ",
    meaning:
      "sức mạnh, lực tác động rất mạnh: có cường lực * cường lực của thuốc giảm đau",
    example: "có cường lực * cường lực của thuốc giảm đau",
  },
  {
    word: "cường quyền",
    part_of_speech: "danh từ",
    meaning:
      "sức mạnh chiếm ưu thế về quân sự, chính trị hoặc kinh tế, dựa vào để áp bức, xâm lược nước khác: chính nghĩa thắng cường quyền",
    example: "chính nghĩa thắng cường quyền",
  },
  {
    word: "cường tập",
    part_of_speech: "động từ",
    meaning:
      "tập kích có bắn chế áp địch trước khi xung phong; phân biệt với kì tập: đánh cường tập",
    example: "đánh cường tập",
  },
  {
    word: "cương quyết",
    part_of_speech: "tính từ",
    meaning:
      "dứt khoát không thay đổi ý định, lập trường cho dù có gặp phải trở lực gì: cách xử lí thiếu cương quyết * nói thế nào cũng cương quyết không nhận",
    example:
      "cách xử lí thiếu cương quyết * nói thế nào cũng cương quyết không nhận",
  },
  {
    word: "cương nghị",
    part_of_speech: "tính từ",
    meaning: "cương quyết, có nghị lực: vẻ mặt cương nghị",
    example: "vẻ mặt cương nghị",
  },
  {
    word: "cường quốc",
    part_of_speech: "danh từ",
    meaning:
      "nước lớn mạnh có vai trò và ảnh hưởng quan trọng trong quan hệ quốc tế: trở thành một cường quốc về kinh tế * cường quốc quân sự",
    example: "trở thành một cường quốc về kinh tế * cường quốc quân sự",
  },
  {
    word: "cường suất",
    part_of_speech: "danh từ",
    meaning:
      "mức độ thay đổi mực nước trong một khoảng thời gian nhất định: lũ lên với cường suất 10cm một ngày",
    example: "lũ lên với cường suất 10cm một ngày",
  },
  {
    word: "cường thịnh",
    part_of_speech: "tính từ",
    meaning: "giàu mạnh và thịnh vượng: đất nước cường thịnh",
    example: "đất nước cường thịnh",
  },
  {
    word: "cương thường",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) tam cương và ngũ thường (nói tắt); những nguyên tắc đạo đức cơ bản thời phong kiến theo quan điểm nho giáo (nói tổng quát): "Cũng vì tơ vấn nhợ vương, Cho nên lỗi đạo cương thường mẹ cha." (ca dao)',
    example:
      'Cũng vì tơ vấn nhợ vương, Cho nên lỗi đạo cương thường mẹ cha." (ca dao)',
  },
  {
    word: "cường tráng",
    part_of_speech: "tính từ",
    meaning:
      "(thân thể đàn ông) khoẻ mạnh và dồi dào sức lực: thân thể cường tráng",
    example: "thân thể cường tráng",
  },
  {
    word: "cương toả",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương) dây cương và hàm thiếc; ví cái ràng buộc làm mất tự do: thoát khỏi vòng cương toả",
    example: "thoát khỏi vòng cương toả",
  },
  {
    word: "cướp bóc",
    part_of_speech: "động từ",
    meaning: "cướp của cải (nói khái quát): tranh giành, cướp bóc lẫn nhau",
    example: "tranh giành, cướp bóc lẫn nhau",
  },
  {
    word: "cương trực",
    part_of_speech: "tính từ",
    meaning:
      "có tinh thần dám giữ và dám nói lên ý kiến mà mình cho là lẽ phải trong bất cứ hoàn cảnh nào: tính tình cương trực * một con người cương trực, thẳng thắn",
    example: "tính tình cương trực * một con người cương trực, thẳng thắn",
  },
  {
    word: "cương vị",
    part_of_speech: "danh từ",
    meaning:
      "vị trí trong một hệ thống tổ chức, quy định quyền hạn và trách nhiệm cụ thể: phát biểu với cương vị giám đốc",
    example: "phát biểu với cương vị giám đốc",
  },
  {
    word: "cướp cò",
    part_of_speech: "động từ",
    meaning:
      "(cò súng) làm cho đạn phát nổ sớm ngoài ý muốn, trong khi chưa định bắn: súng bị cướp cò",
    example: "súng bị cướp cò",
  },
  {
    word: "cướp biển",
    part_of_speech: "danh từ",
    meaning: "kẻ cướp trên biển: con tàu rơi vào tay bọn cướp biển",
    example: "con tàu rơi vào tay bọn cướp biển",
  },
  {
    word: "cướp",
    part_of_speech: "động từ",
    meaning:
      "lấy cái quý giá của người khác bằng vũ lực hoặc thủ đoạn: khởi nghĩa cướp chính quyền * cướp công của đồng đội * cướp của giết người",
    example:
      "khởi nghĩa cướp chính quyền * cướp công của đồng đội * cướp của giết người",
  },
  {
    word: "cướp",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tranh lấy, giành lấy một cách trắng trợn, ỷ vào một thế hơn nào đó: cướp lời * chiếc xe cướp đường (giành đường trái luật)",
    example: "cướp lời * chiếc xe cướp đường (giành đường trái luật)",
  },
  {
    word: "cướp",
    part_of_speech: "động từ",
    meaning:
      "tác động tai hại làm cho bỗng nhiên mất đi cái quý giá: trận lụt quái ác đã cướp sạch mùa màng * chiến tranh đã cướp đi biết bao sinh mạng",
    example:
      "trận lụt quái ác đã cướp sạch mùa màng * chiến tranh đã cướp đi biết bao sinh mạng",
  },
  {
    word: "cướp",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nắm ngay lấy (thời cơ, cơ hội), không để cho mất đi một cách uổng phí: cướp thời cơ",
    example: "cướp thời cơ",
  },
  {
    word: "cướp",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) kẻ chuyên đi cướp: công an bắt cướp",
    example: "công an bắt cướp",
  },
  {
    word: "cướp đoạt",
    part_of_speech: "động từ",
    meaning:
      "cướp lấy của người khác một cách trắng trợn: hành vi cướp đoạt tài sản công dân",
    example: "hành vi cướp đoạt tài sản công dân",
  },
  {
    word: "cứt ngựa",
    part_of_speech: "danh từ",
    meaning:
      "màu xanh lục hơi vàng úa như màu phân ngựa: chiếc áo màu cứt ngựa",
    example: "chiếc áo màu cứt ngựa",
  },
  {
    word: "cứt sắt",
    part_of_speech: "danh từ",
    meaning:
      'xỉ sắt; thường dùng để ví người keo kiệt, bủn xỉn hết mức (hàm ý khinh): đồ cứt sắt! * "Keo cú người đâu như cứt sắt, Tham lam chuyện thở rặt hơi đồng." (TrTXương; 1)',
    example:
      'đồ cứt sắt! * "Keo cú người đâu như cứt sắt, Tham lam chuyện thở rặt hơi đồng." (TrTXương; 1)',
  },
  {
    word: "cứu",
    part_of_speech: "động từ",
    meaning:
      "làm cho thoát khỏi mối đe doạ sự an toàn hoặc sự sống còn: cứu mạng * đánh giặc cứu nước * trị bệnh cứu người",
    example: "cứu mạng * đánh giặc cứu nước * trị bệnh cứu người",
  },
  {
    word: "cứu",
    part_of_speech: "động từ",
    meaning:
      "chữa bệnh bằng cách đốt nóng các huyệt trên da, theo đông y: kĩ thuật châm và cứu",
    example: "kĩ thuật châm và cứu",
  },
  {
    word: "cứt gián",
    part_of_speech: "danh từ",
    meaning:
      "đòng đòng ở trạng thái mới phát triển (to bằng cái cứt gián): lúa đã có cứt gián * ngô đang độ cứt gián",
    example: "lúa đã có cứt gián * ngô đang độ cứt gián",
  },
  {
    word: "cựu",
    part_of_speech: "tính từ",
    meaning:
      '(cũ, khẩu ngữ) cũ, lâu năm hoặc thuộc thời trước, trong quan hệ đối lập với tân (mới, có sau): "Giả đò bị gậy đi xin, Coi người bạn cựu có nhìn ta không?" (ca dao)',
    example:
      'Giả đò bị gậy đi xin, Coi người bạn cựu có nhìn ta không?" (ca dao)',
  },
  {
    word: "cựu chiến binh",
    part_of_speech: "danh từ",
    meaning:
      "người đã từng tham gia chiến đấu trong một cuộc chiến tranh: hội cựu chiến binh Việt Nam",
    example: "hội cựu chiến binh Việt Nam",
  },
  {
    word: "cừu",
    part_of_speech: "danh từ",
    meaning:
      "thú có guốc cùng họ với dê, mình có lớp lông dày, nuôi để lấy thịt và lấy lông làm len: thịt cừu * xén lông cừu",
    example: "thịt cừu * xén lông cừu",
  },
  {
    word: "cừu",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ thể thao làm bằng gỗ, trông tựa như hình con cừu, thường dùng để tập nhảy: động tác nhảy cừu",
    example: "động tác nhảy cừu",
  },
  {
    word: "cửu chương",
    part_of_speech: "danh từ",
    meaning:
      "bảng kê tất cả các tích số của hai số nguyên từ 2 lần 1 đến 9 lần 10: học thuộc lòng bảng cửu chương",
    example: "học thuộc lòng bảng cửu chương",
  },
  {
    word: "cựu binh",
    part_of_speech: "danh từ",
    meaning:
      "quân nhân lâu năm trong quân đội: đoàn kết giữa cựu binh và tân binh",
    example: "đoàn kết giữa cựu binh và tân binh",
  },
  {
    word: "cừu địch",
    part_of_speech: "",
    meaning:
      "(cũ) như thù địch: đem lòng cừu địch * đối xử với nhau như cừu địch",
    example: "đem lòng cừu địch * đối xử với nhau như cừu địch",
  },
  {
    word: "cứu cánh",
    part_of_speech: "danh từ",
    meaning:
      '(Từ cũ) mục đích cuối cùng: "Tất cả những cái anh đã viết, và sẽ viết sau này, đều theo một cứu cánh, chứ không thể bạ gì viết nấy." (NgCHoan; 11)',
    example:
      'Tất cả những cái anh đã viết, và sẽ viết sau này, đều theo một cứu cánh, chứ không thể bạ gì viết nấy." (NgCHoan; 11)',
  },
  {
    word: "cứu cánh",
    part_of_speech: "danh từ",
    meaning:
      "(Văn chương) cái làm chỗ dựa (về tinh thần hoặc vật chất) có thể cứu giúp cho thoát khỏi tình cảnh không hay nào đó: đứa con là cứu cánh của chị",
    example: "đứa con là cứu cánh của chị",
  },
  {
    word: "cứu chữa",
    part_of_speech: "động từ",
    meaning:
      "chữa cho thoát khỏi cơn nguy kịch: vô phương cứu chữa * bệnh nhân đã được các bác sĩ tận tình cứu chữa",
    example:
      "vô phương cứu chữa * bệnh nhân đã được các bác sĩ tận tình cứu chữa",
  },
  {
    word: "cứu độ",
    part_of_speech: "động từ",
    meaning:
      "cứu giúp cho thoát khỏi bể khổ, theo quan niệm của đạo Phật: cứu độ chúng sinh",
    example: "cứu độ chúng sinh",
  },
  {
    word: "cừu hận",
    part_of_speech: "động từ",
    meaning: "(hiếm) như hận thù: mang lòng cừu hận",
    example: "mang lòng cừu hận",
  },
  {
    word: "cứu hộ",
    part_of_speech: "động từ",
    meaning:
      "(làm nhiệm vụ) cứu giúp người, động vật, phương tiện đang bị nạn: trực thăng cứu hộ * đội cứu hộ",
    example: "trực thăng cứu hộ * đội cứu hộ",
  },
  {
    word: "cứu giúp",
    part_of_speech: "động từ",
    meaning:
      "giúp cho thoát khỏi cảnh nghèo khó, hoạn nạn: trời phật cứu giúp chúng sinh * phát chẩn để cứu giúp dân nghèo",
    example: "trời phật cứu giúp chúng sinh * phát chẩn để cứu giúp dân nghèo",
  },
  {
    word: "cứu mạng",
    part_of_speech: "động từ",
    meaning: "cứu cho thoát chết: ơn cứu mạng",
    example: "ơn cứu mạng",
  },
  {
    word: "cửu nguyên",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, vch, hiếm) như cửu tuyền: "Thương thay trung nghĩa như ai, Sa cơ một phút ra người cửu nguyên." (NĐM)',
    example:
      'Thương thay trung nghĩa như ai, Sa cơ một phút ra người cửu nguyên." (NĐM)',
  },
  {
    word: "cứu hoả",
    part_of_speech: "động từ",
    meaning: "chữa cháy: đội cứu hoả * lính cứu hoả",
    example: "đội cứu hoả * lính cứu hoả",
  },
  {
    word: "cưu mang",
    part_of_speech: "động từ",
    meaning:
      '(cũ, văn chương) mang và giữ gìn cái thai trong bụng: "Ơn cha ba năm cúc dục, Nghĩa mẹ chín tháng cưu mang." (ca dao)',
    example: 'Ơn cha ba năm cúc dục, Nghĩa mẹ chín tháng cưu mang." (ca dao)',
  },
  {
    word: "cưu mang",
    part_of_speech: "động từ",
    meaning:
      "đùm bọc trong lúc gặp khó khăn hoạn nạn: mồ côi, được hàng xóm cưu mang",
    example: "mồ côi, được hàng xóm cưu mang",
  },
  {
    word: "cứu sinh",
    part_of_speech: "động từ",
    meaning:
      "cứu cho thoát khỏi sự nguy hiểm đang đe doạ sự sống: phao cứu sinh * xuồng cứu sinh * mở đường cứu sinh",
    example: "phao cứu sinh * xuồng cứu sinh * mở đường cứu sinh",
  },
  {
    word: "cứu rỗi",
    part_of_speech: "động từ",
    meaning:
      "cứu vớt linh hồn khỏi sa xuống địa ngục, theo quan niệm của một số tôn giáo: cứu rỗi linh hồn",
    example: "cứu rỗi linh hồn",
  },
  {
    word: "cứu tế",
    part_of_speech: "động từ",
    meaning:
      "(tổ chức xã hội) giúp đỡ về vật chất cho người dân khi gặp khó khăn, hoạn nạn: cứu tế cho những gia đình bị lũ lụt * gạo cứu tế",
    example: "cứu tế cho những gia đình bị lũ lụt * gạo cứu tế",
  },
  {
    word: "cựu thần",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) quan to của triều đại trước còn lại, trong quan hệ với triều đại sau: cựu thần của nhà Lê",
    example: "cựu thần của nhà Lê",
  },
  {
    word: "cứu thương",
    part_of_speech: "động từ",
    meaning:
      "cứu chữa tại chỗ cho người bị thương (thường là do chiến tranh): trạm cứu thương * đội cứu thương * xe cứu thương",
    example: "trạm cứu thương * đội cứu thương * xe cứu thương",
  },
  {
    word: "cửu trùng",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) chín tầng trời cao; dùng để chỉ nơi vua ở hoặc để gọi nhà vua với ý tôn kính: "Chàng vào bái tạ cửu trùng, Tạ từ vâng trước sân rồng bước ra." (CC)',
    example:
      'Chàng vào bái tạ cửu trùng, Tạ từ vâng trước sân rồng bước ra." (CC)',
  },
  {
    word: "cựu trào",
    part_of_speech: "danh từ",
    meaning: "thời trước, triều đại trước: quan cựu trào",
    example: "quan cựu trào",
  },
  {
    word: "cựu trào",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) lớp cũ, lâu năm: ông bạn cựu trào",
    example: "ông bạn cựu trào",
  },
  {
    word: "cứu tinh",
    part_of_speech: "danh từ",
    meaning:
      "ngôi sao cứu mạng; dùng để ví người cứu cho thoát khỏi cảnh nguy khốn: vị cứu tinh của dân tộc",
    example: "vị cứu tinh của dân tộc",
  },
  {
    word: "cứu trợ",
    part_of_speech: "động từ",
    meaning: "như cứu giúp: hàng cứu trợ",
    example: "hàng cứu trợ",
  },
  {
    word: "cứu thế",
    part_of_speech: "động từ",
    meaning:
      "cứu người đời thoát khỏi cảnh khổ ải, theo quan niệm của một số tôn giáo: chúa cứu thế",
    example: "chúa cứu thế",
  },
  {
    word: "cửu tuyền",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) chín suối, chỉ âm phủ: "Rày vua gả thiếp về Phiên, Quyết lòng xuống chốn cửu tuyền thấy nhau." (LVT)',
    example:
      'Rày vua gả thiếp về Phiên, Quyết lòng xuống chốn cửu tuyền thấy nhau." (LVT)',
  },
  {
    word: "cứu ứng",
    part_of_speech: "động từ",
    meaning: "(hiếm) như ứng cứu: đem quân đi cứu ứng",
    example: "đem quân đi cứu ứng",
  },
  {
    word: "cứu viện",
    part_of_speech: "động từ",
    meaning:
      "đến giúp sức cho một bộ phận khác đang bị uy hiếp trong chiến đấu: đem quân đi cứu viện",
    example: "đem quân đi cứu viện",
  },
  {
    word: "cửu vạn",
    part_of_speech: "danh từ",
    meaning:
      "con bài trong cỗ bài tổ tôm, có vẽ hình người phu khuân vác; dùng để chỉ người chuyên làm nghề khuân vác thuê hoặc làm những việc nặng nhọc: làm cửu vạn * thuê cửu vạn",
    example: "làm cửu vạn * thuê cửu vạn",
  },
  {
    word: "cứu vớt",
    part_of_speech: "động từ",
    meaning:
      "giúp cho thoát khỏi tình trạng nguy ngập đến mức gần như tuyệt vọng (thường nói về mặt tinh thần): cứu vớt linh hồn",
    example: "cứu vớt linh hồn",
  },
  {
    word: "cybernetic",
    part_of_speech: "danh từ",
    meaning:
      "khoa học nghiên cứu những quy luật tổng quát của các quá trình thu nhận, lưu trữ, truyền dẫn, xử lí và sử dụng thông tin: khoa điều khiển học",
    example: "khoa điều khiển học",
  },
  {
    word: "cứu vãn",
    part_of_speech: "động từ",
    meaning:
      "cứu cho tránh khỏi thất bại, suy vong, cho chuyển biến theo hướng trở lại như trước: cứu vãn tình thế * chuyện đã vỡ lở, không thể cứu vãn được nữa",
    example: "cứu vãn tình thế * chuyện đã vỡ lở, không thể cứu vãn được nữa",
  },
  {
    word: "dà",
    part_of_speech: "tính từ",
    meaning:
      '(màu) nâu đỏ: "Ngó lên chợ Lũng cây đa, Thấy em bán gạo, áo dà khăn xanh." (ca dao)',
    example:
      'Ngó lên chợ Lũng cây đa, Thấy em bán gạo, áo dà khăn xanh." (ca dao)',
  },
  {
    word: "dà",
    part_of_speech: "cảm từ",
    meaning:
      "(khẩu ngữ) như dào: dà! vẽ chuyện * dà! có gì đâu mà làm to chuyện",
    example: "dà! vẽ chuyện * dà! có gì đâu mà làm to chuyện",
  },
  {
    word: "da",
    part_of_speech: "danh từ",
    meaning:
      "lớp mô bọc ngoài cơ thể người và một số động vật: sần sùi như da cóc * ngã bị chợt một mảng da",
    example: "sần sùi như da cóc * ngã bị chợt một mảng da",
  },
  {
    word: "da",
    part_of_speech: "danh từ",
    meaning: "da một số động vật đã thuộc: đôi giày da * bao da đựng súng lục",
    example: "đôi giày da * bao da đựng súng lục",
  },
  {
    word: "dã",
    part_of_speech: "động từ",
    meaning:
      "làm giảm, làm mất tác dụng của chất, thường là có hại, đã hấp thu vào trong cơ thể: ăn chè đậu xanh cho dã rượu",
    example: "ăn chè đậu xanh cho dã rượu",
  },
  {
    word: "dạ",
    part_of_speech: "danh từ",
    meaning:
      "bụng con người, về mặt chức năng làm nơi chứa và làm tiêu hoá thức ăn, hoặc chứa thai: ăn lót dạ * bụng mang dạ chửa * dạ yếu",
    example: "ăn lót dạ * bụng mang dạ chửa * dạ yếu",
  },
  {
    word: "dạ",
    part_of_speech: "danh từ",
    meaning:
      "hàng dệt dày bằng lông cừu, có thể pha thêm loại sợi khác, trên mặt có một lớp tuyết mịn: áo dạ * tấm chăn dạ",
    example: "áo dạ * tấm chăn dạ",
  },
  {
    word: "dạ",
    part_of_speech: "cảm từ",
    meaning:
      "tiếng dùng để đáp lại lời gọi hoặc để mở đầu câu nói một cách lễ phép: dạ, xin cảm ơn chị",
    example: "dạ, xin cảm ơn chị",
  },
  {
    word: "dạ",
    part_of_speech: "cảm từ",
    meaning: "(phương ngữ) vâng: (- đi đường cẩn thận nghe con!) - dạ",
    example: "(- đi đường cẩn thận nghe con!) - dạ",
  },
  {
    word: "dạ",
    part_of_speech: "động từ",
    meaning:
      "đáp lại lời gọi bằng tiếng dạ: dạ một tiếng rõ to * gọi dạ, bảo vâng",
    example: "dạ một tiếng rõ to * gọi dạ, bảo vâng",
  },
  {
    word: "da bát",
    part_of_speech: "danh từ",
    meaning: "màu xanh nhạt như màu men bát sứ: áo màu da bát",
    example: "áo màu da bát",
  },
  {
    word: "da bánh mật",
    part_of_speech: "danh từ",
    meaning:
      "bánh làm bằng bột gạo nếp trộn với mật, có nhân đậu xanh hoặc lạc, thường gói bằng lá chuối khô, hấp chín.",
    example: "da ngăm ngăm bánh mật",
  },
  {
    word: "da bọc xương",
    part_of_speech: "",
    meaning:
      "tả thân hình rất gầy, như không có thịt, chỉ còn da với xương: sau trận ốm nặng, người chỉ còn da bọc xương",
    example: "sau trận ốm nặng, người chỉ còn da bọc xương",
  },
  {
    word: "da chì",
    part_of_speech: "danh từ",
    meaning:
      "nước da xám xanh, hơi tái, như màu chì, vẻ ốm yếu: mặt bủng da chì",
    example: "mặt bủng da chì",
  },
  {
    word: "dã chiến",
    part_of_speech: "động từ",
    meaning:
      "đánh nhau không có chiến tuyến nhất định, chủ yếu là đánh vận động trên địa bàn ngoài thành phố: đụng độ với cảnh sát dã chiến",
    example: "đụng độ với cảnh sát dã chiến",
  },
  {
    word: "dã chiến",
    part_of_speech: "tính từ",
    meaning:
      "chuyên phục vụ cho quân đội đang chiến đấu, không ở cố định một nơi: cầu phao dã chiến * bệnh viện dã chiến",
    example: "cầu phao dã chiến * bệnh viện dã chiến",
  },
  {
    word: "da cam",
    part_of_speech: "danh từ",
    meaning: "màu vàng đỏ như màu vỏ một loại cam khi chín: áo màu da cam",
    example: "áo màu da cam",
  },
  {
    word: "dạ con",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận sinh dục bên trong của phụ nữ hay động vật có vú giống cái, chứa thai trong suốt thời kì thai nghén: chửa ngoài dạ con",
    example: "chửa ngoài dạ con",
  },
  {
    word: "dạ dày cơ",
    part_of_speech: "danh từ",
    meaning:
      "phần dạ dày của các loài chim ăn hạt, vách rất dày, có tác dụng nghiền thức ăn: mề gà",
    example: "mề gà",
  },
  {
    word: "da diết",
    part_of_speech: "tính từ",
    meaning:
      "(tình cảm) thấm thía và day dứt không nguôi: buồn da diết * nỗi nhớ ngày càng da diết",
    example: "buồn da diết * nỗi nhớ ngày càng da diết",
  },
  {
    word: "da dẻ",
    part_of_speech: "danh từ",
    meaning:
      "da người nhìn vẻ bề ngoài (nói khái quát): da dẻ mịn màng * da dẻ hồng hào",
    example: "da dẻ mịn màng * da dẻ hồng hào",
  },
  {
    word: "dạ đài",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) âm phủ: "Dạ đài cách mặt khuất lời, Tưới xin giọt lệ cho người thác oan." (TKiều)',
    example:
      'Dạ đài cách mặt khuất lời, Tưới xin giọt lệ cho người thác oan." (TKiều)',
  },
  {
    word: "da gà",
    part_of_speech: "danh từ",
    meaning:
      "da nổi những nốt mẩn nhỏ như da gà đã nhổ lông, thường vì gặp lạnh hoặc vì sợ đột ngột: rét nổi da gà",
    example: "rét nổi da gà",
  },
  {
    word: "dạ hội",
    part_of_speech: "danh từ",
    meaning: "cuộc vui lớn tổ chức vào buổi tối: đi dự dạ hội * váy dạ hội",
    example: "đi dự dạ hội * váy dạ hội",
  },
  {
    word: "da láng",
    part_of_speech: "danh từ",
    meaning:
      "da thuộc có mặt ngoài được mài và phết một loại chất làm cho bóng láng: sắm được đôi giày da láng",
    example: "sắm được đôi giày da láng",
  },
  {
    word: "da màu",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để gọi chung người da đen, da đỏ và da vàng, phân biệt với người da trắng: một phụ nữ da màu",
    example: "một phụ nữ da màu",
  },
  {
    word: "dạ khúc",
    part_of_speech: "danh từ",
    meaning:
      "tác phẩm âm nhạc cho piano, có nội dung u buồn hay mơ màng, thích hợp cho đêm khuya: bản dạ khúc của nhà soạn nhạc thiên tài Beethoven",
    example: "bản dạ khúc của nhà soạn nhạc thiên tài Beethoven",
  },
  {
    word: "da liễu",
    part_of_speech: "danh từ",
    meaning: "bệnh ngoài da và bệnh hoa liễu (nói khái quát): viện da liễu",
    example: "viện da liễu",
  },
  {
    word: "da lươn",
    part_of_speech: "danh từ",
    meaning:
      "màu men nâu vàng của đồ gốm, giống như màu da con lươn: chén da lươn",
    example: "chén da lươn",
  },
  {
    word: "dã man",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về một giai đoạn phát triển của xã hội loài người thời nguyên thuỷ, khi đời sống con người vẫn còn có những mặt gần với đời sống thú vật, chưa có văn minh, tuy rằng loài người đã biết chăn nuôi và trồng trọt: con người trong thời kì mông muội, dã man",
    example: "con người trong thời kì mông muội, dã man",
  },
  {
    word: "dã man",
    part_of_speech: "tính từ",
    meaning:
      "tàn ác theo lối dã thú, hết sức vô nhân đạo: những đòn tra tấn dã man * bị tàn sát dã màn",
    example: "những đòn tra tấn dã man * bị tàn sát dã màn",
  },
  {
    word: "da mồi tóc sương",
    part_of_speech: "",
    meaning:
      '(văn chương) như tóc bạc da mồi: "Buồng không lần lữa hôm mai, Đầu xanh mấy chốc da mồi tóc sương." (ca dao)',
    example:
      'Buồng không lần lữa hôm mai, Đầu xanh mấy chốc da mồi tóc sương." (ca dao)',
  },
  {
    word: "da mồi",
    part_of_speech: "danh từ",
    meaning:
      'da (thường của người già) lốm đốm những chấm màu nâu nhạt như mai con đồi mồi: "Một ngày một ngả bóng tang, Da mồi sạm mặt, tóc sương điểm đầu." (NĐM)',
    example:
      'Một ngày một ngả bóng tang, Da mồi sạm mặt, tóc sương điểm đầu." (NĐM)',
  },
  {
    word: "da non",
    part_of_speech: "danh từ",
    meaning:
      "da mỏng mới lên lại trên vết thương hoặc mụn nhọt khi sắp lành: vết bỏng ở tay bắt đầu lên da non * vết thương đang kéo da non",
    example: "vết bỏng ở tay bắt đầu lên da non * vết thương đang kéo da non",
  },
  {
    word: "dã nhân",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi thông thường của các động vật linh trưởng, như đười ươi, hắc tinh tinh, v.v.: con dã nhân",
    example: "con dã nhân",
  },
  {
    word: "dã ngoại",
    part_of_speech: "tính từ",
    meaning:
      "(hoạt động của quân đội) ở nơi xa doanh trại, xa địa điểm dân cư, không có công sự vững chắc: cuộc hành quân dã ngoại",
    example: "cuộc hành quân dã ngoại",
  },
  {
    word: "dã ngoại",
    part_of_speech: "tính từ",
    meaning:
      "ở ngoài trời, trong môi trường thiên nhiên và xa nơi đang cư trú: du lịch dã ngoại * buổi sinh hoạt dã ngoại",
    example: "du lịch dã ngoại * buổi sinh hoạt dã ngoại",
  },
  {
    word: "dạ quang",
    part_of_speech: "tính từ",
    meaning: "sáng xanh lên trong bóng tối: đồng hồ dạ quang",
    example: "đồng hồ dạ quang",
  },
  {
    word: "da rạn",
    part_of_speech: "danh từ",
    meaning:
      "mặt ngoài của đồ sành, đồ sứ có những đường nhỏ trông giống như vết nứt, vết rạn (nói về một kiểu men): chiếc bình da rạn",
    example: "chiếc bình da rạn",
  },
  {
    word: "dã sử",
    part_of_speech: "danh từ",
    meaning:
      "lịch sử ghi chép những chuyện lưu truyền trong dân gian, do cá nhân viết (thường có nhiều yếu tố hư cấu); phân biệt với chính sử: truyện dã sử",
    example: "truyện dã sử",
  },
  {
    word: "dã thú",
    part_of_speech: "danh từ",
    meaning: "thú sống hoang dã ở rừng: loài dã thú",
    example: "loài dã thú",
  },
  {
    word: "dạ tiệc",
    part_of_speech: "danh từ",
    meaning:
      "bữa tiệc (thường là lớn và long trọng) được tổ chức vào buổi tối: buổi dạ tiệc",
    example: "buổi dạ tiệc",
  },
  {
    word: "dã tâm",
    part_of_speech: "danh từ",
    meaning:
      "lòng dạ hiểm độc, chuyên mưu việc hại người để hưởng lợi: có dã tâm hại người * biết được cái dã tâm của người dì ghẻ",
    example: "có dã tâm hại người * biết được cái dã tâm của người dì ghẻ",
  },
  {
    word: "da trời",
    part_of_speech: "danh từ",
    meaning:
      "màu xanh nhạt như màu của nền trời không mây: chiếc áo dài màu da trời",
    example: "chiếc áo dài màu da trời",
  },
  {
    word: "dạ xoa",
    part_of_speech: "danh từ",
    meaning: "tên một loài quỷ, mặt mày rất xấu xí: xấu như quỷ dạ xoa",
    example: "xấu như quỷ dạ xoa",
  },
  {
    word: "dai",
    part_of_speech: "tính từ",
    meaning:
      "có khả năng giữ nguyên tính toàn khối khi bị tác động, khó làm cho đứt, cho rời ra từng mảnh: sợi thừng dai * thịt trâu già ăn hơi dai",
    example: "sợi thừng dai * thịt trâu già ăn hơi dai",
  },
  {
    word: "dai",
    part_of_speech: "tính từ",
    meaning:
      "bền, lâu, khó bị huỷ hoại hoặc khó thôi, khó dứt: nhớ dai * nói dai",
    example: "nhớ dai * nói dai",
  },
  {
    word: "dại",
    part_of_speech: "tính từ",
    meaning:
      "chưa có đủ khả năng thích ứng với hoàn cảnh tự nhiên bất lợi, do sức còn non yếu hoặc chưa được từng trải: mạ còn dại, chưa cấy được * dại gió, dại nước * mẹ già con dại",
    example: "mạ còn dại, chưa cấy được * dại gió, dại nước * mẹ già con dại",
  },
  {
    word: "dại",
    part_of_speech: "tính từ",
    meaning:
      'không có đủ khả năng suy xét để ứng phó với hoàn cảnh và tránh những hành động và thái độ không nên: khôn nhà dại chợ (tng) * "Trót vì tay đã nhúng chàm, Dại rồi còn biết khôn làm sao đây?" (TKiều)',
    example:
      'khôn nhà dại chợ (tng) * "Trót vì tay đã nhúng chàm, Dại rồi còn biết khôn làm sao đây?" (TKiều)',
  },
  {
    word: "dại",
    part_of_speech: "tính từ",
    meaning:
      "(bộ phận cơ thể) mất khả năng hoạt động linh hoạt, nhanh nhẹn theo sự điều khiển của trí óc: đau dại cánh tay * đôi mắt dại đờ",
    example: "đau dại cánh tay * đôi mắt dại đờ",
  },
  {
    word: "dại",
    part_of_speech: "tính từ",
    meaning:
      "mắc bệnh tâm thần bị rối loạn: giả điên giả dại * giận quá hoá dại",
    example: "giả điên giả dại * giận quá hoá dại",
  },
  {
    word: "dại",
    part_of_speech: "tính từ",
    meaning:
      "(chó, mèo) mắc chứng bệnh làm tổn thương hệ thần kinh, gây co giật hoặc tê liệt rồi chết: tiêm phòng dại * chó dại cắn càn",
    example: "tiêm phòng dại * chó dại cắn càn",
  },
  {
    word: "dại",
    part_of_speech: "tính từ",
    meaning:
      "(thực vật) không được nuôi trồng, mà sinh trưởng tự do trong thiên nhiên: táo dại * cỏ dại * loài hoa dại",
    example: "táo dại * cỏ dại * loài hoa dại",
  },
  {
    word: "dại",
    part_of_speech: "tính từ",
    meaning:
      "thường xuyên chịu tác động của hiện tượng thiên nhiên do bị phơi ra giữa trời: mấy cánh cửa gỗ mốc thếch vì dại nắng",
    example: "mấy cánh cửa gỗ mốc thếch vì dại nắng",
  },
  {
    word: "dài",
    part_of_speech: "tính từ",
    meaning:
      "có khoảng cách bao nhiêu đó từ đầu này đến đầu kia, theo chiều nằm ngang và thường là có kích thước lớn nhất (gọi là chiều dài) của vật: tấm vải dài 5 mét * đo chiều dài",
    example: "tấm vải dài 5 mét * đo chiều dài",
  },
  {
    word: "dài",
    part_of_speech: "tính từ",
    meaning:
      "có chiều dài lớn hơn mức bình thường hoặc lớn hơn so với những vật khác: đôi đũa dài * đường dài",
    example: "đôi đũa dài * đường dài",
  },
  {
    word: "dài",
    part_of_speech: "tính từ",
    meaning:
      '(hiếm) (hiện tượng) chiếm khoảng thời gian bao nhiêu đó từ lúc bắt đầu cho đến lúc kết thúc: bộ phim dài 2 tiếng * "Sầu đong càng lắc càng đầy, Ba thu dồn lại một ngày dài ghê!" (TKiều)',
    example:
      'bộ phim dài 2 tiếng * "Sầu đong càng lắc càng đầy, Ba thu dồn lại một ngày dài ghê!" (TKiều)',
  },
  {
    word: "dài",
    part_of_speech: "tính từ",
    meaning:
      "(hiện tượng, sự việc) chiếm nhiều thời gian hơn mức bình thường hoặc hơn những hiện tượng, sự việc khác: đợt nắng nóng kéo dài * kế hoạch dài hạn",
    example: "đợt nắng nóng kéo dài * kế hoạch dài hạn",
  },
  {
    word: "dài",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) mãi không thôi: chơi dài * nghỉ dài",
    example: "chơi dài * nghỉ dài",
  },
  {
    word: "dãi",
    part_of_speech: "danh từ",
    meaning: "nước dãi (nói tắt): thèm nhỏ dãi",
    example: "thèm nhỏ dãi",
  },
  {
    word: "dãi",
    part_of_speech: "động từ",
    meaning:
      'phơi cả bề mặt ra ngoài trời để cho nắng, gió, sương... tác động vào: dãi nắng * "Bấy chầy dãi nguyệt, dầu hoa, Mười phần xuân có gầy ba bốn phần." (TKiều)',
    example:
      'dãi nắng * "Bấy chầy dãi nguyệt, dầu hoa, Mười phần xuân có gầy ba bốn phần." (TKiều)',
  },
  {
    word: "dài dài",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) lặp đi lặp lại nhiều lần hoặc dài, lâu, không xác định, không hạn chế về thời gian: thất nghiệp dài dài",
    example: "thất nghiệp dài dài",
  },
  {
    word: "dái",
    part_of_speech: "danh từ",
    meaning: "(thông tục) như bìu dái.",
    example: "dái khoai sọ",
  },
  {
    word: "dái",
    part_of_speech: "danh từ",
    meaning:
      "củ con mọc cạnh củ cái của một số cây, có hình giống bìu dái: dái khoai sọ",
    example: "bò dái * chạy như chó dái (tng)",
  },
  {
    word: "dái",
    part_of_speech: "động từ",
    meaning:
      "(cũ, hiếm) sợ, kiêng nể: khôn cho người ta dái, dại cho người ta thương, dở dở ương ương tổ người ta ghét (tng)",
    example:
      "khôn cho người ta dái, dại cho người ta thương, dở dở ương ương tổ người ta ghét (tng)",
  },
  {
    word: "dải",
    part_of_speech: "danh từ",
    meaning:
      "vật có hình dài và hẹp khổ, bằng hàng dệt, thường dùng để buộc, thắt: dải lụa đào * dải thắt lưng * dải băng trắng",
    example: "dải lụa đào * dải thắt lưng * dải băng trắng",
  },
  {
    word: "dải",
    part_of_speech: "danh từ",
    meaning:
      "khoảng đất hay nước trong thiên nhiên dài, nhưng hẹp: non sông liền một dải * dải ngân hà",
    example: "non sông liền một dải * dải ngân hà",
  },
  {
    word: "dải",
    part_of_speech: "danh từ",
    meaning: "như băng: dải sóng trung",
    example: "dải sóng trung",
  },
  {
    word: "dài dại",
    part_of_speech: "tính từ",
    meaning: "hơi dại, trông không linh hoạt, nhanh nhẹn: đôi mắt dài dại",
    example: "đôi mắt dài dại",
  },
  {
    word: "dài dằng dặc",
    part_of_speech: "tính từ",
    meaning:
      "rất dài, đến mức tưởng như không thấy được điểm tận cùng: người xếp hàng dài dằng dặc * đêm dài dằng dặc",
    example: "người xếp hàng dài dằng dặc * đêm dài dằng dặc",
  },
  {
    word: "dai dẳng",
    part_of_speech: "tính từ",
    meaning:
      "kéo dài rất lâu không chịu chấm dứt, gây cảm giác khó chịu: mưa dai dẳng mãi không dứt * cơn đau dai dẳng",
    example: "mưa dai dẳng mãi không dứt * cơn đau dai dẳng",
  },
  {
    word: "dài dặc",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) rất dài, như không muốn dứt: dòng người dài dặc * chuỗi ngày dài dặc",
    example: "dòng người dài dặc * chuỗi ngày dài dặc",
  },
  {
    word: "dãi dầu",
    part_of_speech: "động từ",
    meaning:
      'chịu đựng, trải qua nhiều mưa nắng, vất vả, gian truân (nói khái quát): dãi dầu mưa nắng * "Canh khuya, thân gái, dặm trường, Phần e đường sá, phần thương dãi dầu!" (TKiều)',
    example:
      'dãi dầu mưa nắng * "Canh khuya, thân gái, dặm trường, Phần e đường sá, phần thương dãi dầu!" (TKiều)',
  },
  {
    word: "dại dột",
    part_of_speech: "tính từ",
    meaning: "dại, thiếu khôn ngoan: làm chuyện dại dột * đừng có dại dột!",
    example: "làm chuyện dại dột * đừng có dại dột!",
  },
  {
    word: "dại gì mà",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) không nên làm việc nào đó, làm là dại: mình dại gì mà chịu khoản vô lí ấy * ai dại gì mà tin hắn!",
    example: "mình dại gì mà chịu khoản vô lí ấy * ai dại gì mà tin hắn!",
  },
  {
    word: "dài dòng",
    part_of_speech: "tính từ",
    meaning:
      "nhiều lời một cách rườm rà, vô ích: kể lể dài dòng * chuyện hay nhưng hơi dài dòng",
    example: "kể lể dài dòng * chuyện hay nhưng hơi dài dòng",
  },
  {
    word: "dài đuỗn",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) dài và thẳng đờ ra: mặt dài đuỗn",
    example: "mặt dài đuỗn",
  },
  {
    word: "dài hạn",
    part_of_speech: "tính từ",
    meaning:
      "có thời hạn tương đối dài; phân biệt với ngắn hạn, trung hạn: đầu tư dài hạn * nợ dài hạn",
    example: "đầu tư dài hạn * nợ dài hạn",
  },
  {
    word: "dại gái",
    part_of_speech: "tính từ",
    meaning:
      "(thông tục) (người đàn ông) mê gái và để cho gái lợi dụng: anh chàng dại gái",
    example: "anh chàng dại gái",
  },
  {
    word: "dài lưng",
    part_of_speech: "tính từ",
    meaning:
      '(khẩu ngữ) có sức khoẻ nhưng lười biếng, không chịu làm việc: "Chồng một vợ một, cứ dài lưng ra mà ăn, bà cho rồi lại có ngày không có cả đến cái bát mẻ mà gặm (...)" (MPTư; 1)',
    example:
      'Chồng một vợ một, cứ dài lưng ra mà ăn, bà cho rồi lại có ngày không có cả đến cái bát mẻ mà gặm (...)" (MPTư; 1)',
  },
  {
    word: "dài hơi",
    part_of_speech: "tính từ",
    meaning:
      "(Ít dùng) cần nhiều công sức để làm liên tục trong thời gian dài: một kế hoạch dài hơi",
    example: "một kế hoạch dài hơi",
  },
  {
    word: "dài lưng tốn vải",
    part_of_speech: "",
    meaning:
      'tả người lười biếng, vụng về, chẳng được tích sự gì: "Ai ơi, chớ lấy học trò, Dài lưng tốn vải ăn no lại nằm!" (ca dao)',
    example:
      'Ai ơi, chớ lấy học trò, Dài lưng tốn vải ăn no lại nằm!" (ca dao)',
  },
  {
    word: "dại khờ",
    part_of_speech: "tính từ",
    meaning: "như khờ dại: đứa trẻ dại khờ",
    example: "đứa trẻ dại khờ",
  },
  {
    word: "dài ngoẵng",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) dài quá, gây cảm giác không cân đối: mặt dài ngoẵng",
    example: "mặt dài ngoẵng",
  },
  {
    word: "dài nghêu",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như dài ngoẵng: đôi chân dài nghêu",
    example: "đôi chân dài nghêu",
  },
  {
    word: "dài mồm",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) lắm lời một cách quá quắt: dài mồm ra cãi",
    example: "dài mồm ra cãi",
  },
  {
    word: "dài nhằng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) dài quá, như không chịu dứt, gây ấn tượng khó chịu: những sợi dây leo dài nhằng * bài báo dài nhằng",
    example: "những sợi dây leo dài nhằng * bài báo dài nhằng",
  },
  {
    word: "dai nhách",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) dai đến mức làm cho chán ngán, khó chịu: miếng thịt trâu dai nhách * nói dai nhách",
    example: "miếng thịt trâu dai nhách * nói dai nhách",
  },
  {
    word: "dải rút",
    part_of_speech: "danh từ",
    meaning:
      "dây luồn vào cạp để buộc quần hoặc váy: quần dải rút * sợi dải rút",
    example: "quần dải rút * sợi dải rút",
  },
  {
    word: "dải phân cách",
    part_of_speech: "danh từ",
    meaning:
      "phần được xây, được dựng lên hoặc được sơn kẻ để phân đường giao thông thành các làn đường riêng biệt: đường rộng nhưng không có dải phân cách ở giữa",
    example: "đường rộng nhưng không có dải phân cách ở giữa",
  },
  {
    word: "dài thòng",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) dài quá mức, như thừa ra: sợi dây dài thòng",
    example: "sợi dây dài thòng",
  },
  {
    word: "dai sức",
    part_of_speech: "tính từ",
    meaning:
      "có sức chịu đựng được lâu, có thể làm được những công việc nặng nhọc trong một thời gian dài: gầy nhưng dai sức",
    example: "gầy nhưng dai sức",
  },
  {
    word: "dài thượt",
    part_of_speech: "tính từ",
    meaning:
      "dài quá mức bình thường, gây cảm giác không gọn: chiếc váy dài thượt",
    example: "chiếc váy dài thượt",
  },
  {
    word: "dám",
    part_of_speech: "động từ",
    meaning:
      'có đủ tự tin để làm việc gì, dù biết là khó khăn, nguy hiểm: dám nghĩ, dám làm * "Cùng nhau đã trót nặng lời, Dẫu thay mái tóc, dám dời lòng tơ!" (TKiều)',
    example:
      'dám nghĩ, dám làm * "Cùng nhau đã trót nặng lời, Dẫu thay mái tóc, dám dời lòng tơ!" (TKiều)',
  },
  {
    word: "dám",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ, Kiểu cách) dám nhận (hàm ý khiêm tốn): (- xin cảm ơn bà!) - không dám! * cháu không dám, cụ quá khen!",
    example: "(- xin cảm ơn bà!) - không dám! * cháu không dám, cụ quá khen!",
  },
  {
    word: "dạm",
    part_of_speech: "động từ",
    meaning:
      "ướm hỏi xem có ưng thuận không (thường nói về việc mua bán): dạm bán nhà",
    example: "dạm bán nhà",
  },
  {
    word: "dạm",
    part_of_speech: "động từ",
    meaning: "ướm hỏi trước khi chính thức làm lễ hỏi vợ: dạm vợ cho con",
    example: "dạm vợ cho con",
  },
  {
    word: "dàm",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng thường đan bằng tre nứa, hình giống cái giỏ, để chụp vào mõm súc vật cho không ăn, không cắn được: dàm chó * dàm ngựa",
    example: "dàm chó * dàm ngựa",
  },
  {
    word: "dàm",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) dây hoặc vòng xỏ vào mũi trâu bò để buộc thừng dắt và điều khiển: trâu tuột dàm",
    example: "trâu tuột dàm",
  },
  {
    word: "dán",
    part_of_speech: "động từ",
    meaning:
      "làm cho dính vào nhau bằng chất kết dính như keo, hồ, v.v.: dán nhãn vở * giấy dán tường",
    example: "dán nhãn vở * giấy dán tường",
  },
  {
    word: "dán",
    part_of_speech: "động từ",
    meaning:
      "áp rất sát, rất chặt vào: dán mũi vào cửa kính * quần áo ướt, dán chặt vào cơ thể",
    example: "dán mũi vào cửa kính * quần áo ướt, dán chặt vào cơ thể",
  },
  {
    word: "dán",
    part_of_speech: "động từ",
    meaning:
      "(mắt) hướng cái nhìn vào một cách chăm chú, không rời: mắt dán vào mục tiêu * ngồi dán mắt lên sân khấu",
    example: "mắt dán vào mục tiêu * ngồi dán mắt lên sân khấu",
  },
  {
    word: "dán",
    part_of_speech: "động từ",
    meaning:
      "đưa văn bản hoặc hình đồ hoạ, v.v. đã được cắt hoặc sao chép từ một vị trí khác vào tài liệu được tạo ra trên máy tính tại vị trí hiện thời của con chạy: dán chèn đoạn văn bản vào khoảng trống",
    example: "dán chèn đoạn văn bản vào khoảng trống",
  },
  {
    word: "dạm hỏi",
    part_of_speech: "động từ",
    meaning: "dạm và hỏi vợ (nói khái quát): đã có người dạm hỏi",
    example: "đã có người dạm hỏi",
  },
  {
    word: "dàn",
    part_of_speech: "động từ",
    meaning:
      "bày ra, xếp ra trên một phạm vi nhất định: đầu tư dàn đều, thiếu trọng tâm * đứng dàn hàng ngang",
    example: "đầu tư dàn đều, thiếu trọng tâm * đứng dàn hàng ngang",
  },
  {
    word: "dàn",
    part_of_speech: "động từ",
    meaning: "dàn dựng (nói tắt): dàn kịch",
    example: "dàn kịch",
  },
  {
    word: "dàn",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp nhiều nhạc khí hoặc nhiều loại giọng khác nhau cùng phối hợp theo một cơ cấu nhất định trong biểu diễn ca nhạc: dàn đồng ca * dàn nhạc giao hưởng",
    example: "dàn đồng ca * dàn nhạc giao hưởng",
  },
  {
    word: "dàn",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp gồm những thiết bị, máy móc được dùng phối hợp với nhau tạo thành một hệ thống, một chỉnh thể: dàn máy vi tính * dàn âm thanh hiện đại",
    example: "dàn máy vi tính * dàn âm thanh hiện đại",
  },
  {
    word: "dãn",
    part_of_speech: "động từ",
    meaning:
      "tăng độ dài hoặc thể tích mà không thay đổi khối lượng: dây chun bị dãn",
    example: "dây chun bị dãn",
  },
  {
    word: "dãn",
    part_of_speech: "động từ",
    meaning:
      "trở lại trạng thái bình thường, không còn co lại, không còn căng thẳng nữa: dãn gân dãn cốt * các nếp nhăn trên mặt dãn ra",
    example: "dãn gân dãn cốt * các nếp nhăn trên mặt dãn ra",
  },
  {
    word: "dãn",
    part_of_speech: "động từ",
    meaning:
      "trở lại trạng thái không còn tập trung lại nữa, mà thưa ra: đám đông đứng dãn ra",
    example: "đám đông đứng dãn ra",
  },
  {
    word: "dãn",
    part_of_speech: "động từ",
    meaning:
      "thải bớt, đuổi bớt (công nhân): thiếu việc làm, xí nghiệp phải dãn thợ",
    example: "thiếu việc làm, xí nghiệp phải dãn thợ",
  },
  {
    word: "dàn bài",
    part_of_speech: "danh từ",
    meaning:
      "trình tự sắp xếp các ý chính của bài để dựa vào đó mà nói hoặc viết: dàn bài tập làm văn",
    example: "dàn bài tập làm văn",
  },
  {
    word: "dan",
    part_of_speech: "động từ",
    meaning:
      '(cũ) cầm, nắm (tay): "Tà tà bóng ngả về tây, Chị em thơ thẩn dan tay ra về." (TKiều)',
    example: 'Tà tà bóng ngả về tây, Chị em thơ thẩn dan tay ra về." (TKiều)',
  },
  {
    word: "dạn",
    part_of_speech: "tính từ",
    meaning:
      '(cũ, hoặc ph) bạo, không rụt rè, không e ngại: "Sượng sùng đánh dạn ra chào, Lạy thôi, nàng mới rỉ trao ân cần." (TKiều)',
    example:
      'Sượng sùng đánh dạn ra chào, Lạy thôi, nàng mới rỉ trao ân cần." (TKiều)',
  },
  {
    word: "dạn",
    part_of_speech: "tính từ",
    meaning:
      "có khả năng tiếp xúc với hiện tượng nguy hiểm, đáng sợ hoặc chịu đựng hiện tượng nguy hại mà không dễ bị tác động, do đã quen: chim dạn người * dạn mưa nắng * thằng bé rất dạn, dám đi đêm một mình",
    example:
      "chim dạn người * dạn mưa nắng * thằng bé rất dạn, dám đi đêm một mình",
  },
  {
    word: "dàn cảnh",
    part_of_speech: "động từ",
    meaning:
      "(cũ) tổ chức và điều khiển việc trình bày tác phẩm nghệ thuật sân khấu hay điện ảnh: dàn cảnh vở cải lương",
    example: "dàn cảnh vở cải lương",
  },
  {
    word: "dạn dày",
    part_of_speech: "tính từ",
    meaning: "như dày dạn: dạn dày chinh chiến",
    example: "dạn dày chinh chiến",
  },
  {
    word: "dạn dĩ",
    part_of_speech: "tính từ",
    meaning:
      "không còn rụt rè, e ngại hoặc sợ hãi nữa (nói khái quát): gương mặt dạn dĩ * ăn nói dạn dĩ",
    example: "gương mặt dạn dĩ * ăn nói dạn dĩ",
  },
  {
    word: "dàn dựng",
    part_of_speech: "động từ",
    meaning:
      "tập để chuẩn bị đưa ra diễn trên sân khấu (nói khái quát): dàn dựng vở kịch mới",
    example: "dàn dựng vở kịch mới",
  },
  {
    word: "dan díu",
    part_of_speech: "động từ",
    meaning:
      '(cũ) (trai gái) có quan hệ yêu đương, gắn bó với nhau: "Miệt mài trong cuộc truy hoan, Càng quen thuộc nết, càng dan díu tình." (TKiều)',
    example:
      'Miệt mài trong cuộc truy hoan, Càng quen thuộc nết, càng dan díu tình." (TKiều)',
  },
  {
    word: "dan díu",
    part_of_speech: "động từ",
    meaning:
      "có quan hệ yêu đương không chính đáng: hai người dan díu với nhau đã lâu",
    example: "hai người dan díu với nhau đã lâu",
  },
  {
    word: "dàn mặt",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) để cho người khác gặp mặt hoặc tiếp xúc trực tiếp: xấu hổ không dám dàn mặt bạn bè",
    example: "xấu hổ không dám dàn mặt bạn bè",
  },
  {
    word: "dàn nhạc",
    part_of_speech: "danh từ",
    meaning:
      "tập thể nhạc công dùng nhiều nhạc khí để hoà tấu: dàn nhạc dân tộc * người chỉ huy dàn nhạc",
    example: "dàn nhạc dân tộc * người chỉ huy dàn nhạc",
  },
  {
    word: "dàn hoà",
    part_of_speech: "động từ",
    meaning:
      "dàn xếp cho được hoà thuận trở lại: biết sai nên tìm cách dàn hoà * đứng ra dàn hoà cho hai bên",
    example: "biết sai nên tìm cách dàn hoà * đứng ra dàn hoà cho hai bên",
  },
  {
    word: "dàn tập",
    part_of_speech: "động từ",
    meaning:
      "dàn dựng và tập luyện trên sân khấu trước khi biểu diễn trước khán giả: Nhà hát chèo đang dàn tập một vở chèo cổ",
    example: "Nhà hát chèo đang dàn tập một vở chèo cổ",
  },
  {
    word: "dáng",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ nói chung những nét đặc trưng của một người nhìn qua bề ngoài, như thân hình, điệu bộ, cử chỉ, v.v.: dáng đi * thằng bé đã ra dáng người lớn * dáng người mảnh mai",
    example: "dáng đi * thằng bé đã ra dáng người lớn * dáng người mảnh mai",
  },
  {
    word: "dàn xếp",
    part_of_speech: "động từ",
    meaning:
      "sắp xếp, bàn bạc, làm cho ổn thoả: đứng ra dàn xếp mọi việc * khéo dàn xếp",
    example: "đứng ra dàn xếp mọi việc * khéo dàn xếp",
  },
  {
    word: "dàn trải",
    part_of_speech: "",
    meaning: "dàn ra trên diện rộng, thiếu tập trung: đầu tư dàn trải",
    example: "đầu tư dàn trải",
  },
  {
    word: "dáng chừng",
    part_of_speech: "",
    meaning:
      'tổ hợp biểu thị ý phỏng đoán một cách dè dặt, dựa trên cái vẻ bề ngoài: "Cô ta dáng chừng cũng đã trông thấy tôi nên khẽ kéo nón xuống che mặt." (NgKhải; 23)',
    example:
      'Cô ta dáng chừng cũng đã trông thấy tôi nên khẽ kéo nón xuống che mặt." (NgKhải; 23)',
  },
  {
    word: "dáng bộ",
    part_of_speech: "danh từ",
    meaning: "như dáng điệu: dáng bộ yểu điệu",
    example: "dáng bộ yểu điệu",
  },
  {
    word: "dàn ý",
    part_of_speech: "danh từ",
    meaning: "như dàn bài: lập dàn ý trước khi viết một bản báo cáo",
    example: "lập dàn ý trước khi viết một bản báo cáo",
  },
  {
    word: "dang",
    part_of_speech: "động từ",
    meaning:
      "mở rộng ra về cả hai phía (thường nói về cánh chim, cánh tay): chim dang cánh bay * dang hai tay lấy thăng bằng",
    example: "chim dang cánh bay * dang hai tay lấy thăng bằng",
  },
  {
    word: "dang",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) tránh ra, lùi sang một bên: dang ra cho người ta vào",
    example: "dang ra cho người ta vào",
  },
  {
    word: "dang",
    part_of_speech: "động từ",
    meaning:
      "phơi trần ngoài nắng: dang nắng * cứ dang đầu trần không chịu đội nón",
    example: "dang nắng * cứ dang đầu trần không chịu đội nón",
  },
  {
    word: "dáng dấp",
    part_of_speech: "danh từ",
    meaning:
      "dáng, vẻ bên ngoài qua những nét chính: dáng dấp nhanh nhẹn * có dáng dấp của một trí thức",
    example: "dáng dấp nhanh nhẹn * có dáng dấp của một trí thức",
  },
  {
    word: "dạng",
    part_of_speech: "danh từ",
    meaning:
      'hình thức tồn tại của một sự vật, hiện tượng, dựa vào đó để phân biệt với một sự vật, hiện tượng khác: thuốc ở dạng bột * "Khen ai khéo đúc chuông chì, Dạng thì có dạng, đánh thì không kêu." (ca dao)',
    example:
      'thuốc ở dạng bột * "Khen ai khéo đúc chuông chì, Dạng thì có dạng, đánh thì không kêu." (ca dao)',
  },
  {
    word: "dạng",
    part_of_speech: "danh từ",
    meaning:
      "phạm trù ngữ pháp của động từ, biểu thị quan hệ giữa chủ thể và khách thể của hành động: dạng chủ động * dạng bị động",
    example: "dạng chủ động * dạng bị động",
  },
  {
    word: "dáng điệu",
    part_of_speech: "danh từ",
    meaning:
      "những nét đặc trưng của một người nhìn qua dáng đi, điệu bộ, cử chỉ (nói khái quát): dáng điệu mệt mỏi * dáng điệu vồn vã, đon đả",
    example: "dáng điệu mệt mỏi * dáng điệu vồn vã, đon đả",
  },
  {
    word: "dang dở",
    part_of_speech: "tính từ",
    meaning: "như dở dang: tình duyên dang dở",
    example: "tình duyên dang dở",
  },
  {
    word: "dàng dênh",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ, hiếm) không khẩn trương, kéo dài mất nhiều thời gian: nhanh lên, cứ dàng dênh mãi thế!",
    example: "nhanh lên, cứ dàng dênh mãi thế!",
  },
  {
    word: "dạng thức",
    part_of_speech: "danh từ",
    meaning:
      "hình thức, kiểu tồn tại của sự vật, hiện tượng: các dạng thức ngữ pháp * dạng thức lưu trữ tập tin",
    example: "các dạng thức ngữ pháp * dạng thức lưu trữ tập tin",
  },
  {
    word: "dảnh",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị cây mạ khi bắt đầu cấy lúa: mạ đanh dảnh",
    example: "mạ đanh dảnh",
  },
  {
    word: "dành",
    part_of_speech: "động từ",
    meaning:
      "giữ lại để sau này dùng: dành tiền mua xe máy * dành lại chút thức ăn cho bữa chiều",
    example: "dành tiền mua xe máy * dành lại chút thức ăn cho bữa chiều",
  },
  {
    word: "dành",
    part_of_speech: "động từ",
    meaning:
      "để riêng cho ai hoặc cho việc gì: lớp học dành cho người khiếm thính * dành nhiều thời gian cho việc học",
    example:
      "lớp học dành cho người khiếm thính * dành nhiều thời gian cho việc học",
  },
  {
    word: "dáng vóc",
    part_of_speech: "danh từ",
    meaning:
      "dáng người, nhìn về mặt thân hình to nhỏ, cao thấp: dáng vóc cao lớn",
    example: "dáng vóc cao lớn",
  },
  {
    word: "danh ca",
    part_of_speech: "danh từ",
    meaning: "nghệ sĩ hát nổi tiếng: danh ca nổi tiếng",
    example: "danh ca nổi tiếng",
  },
  {
    word: "danh bạ",
    part_of_speech: "danh từ",
    meaning:
      "sổ ghi tên người, tên tổ chức theo một nội dung nhất định: danh bạ điện thoại * danh bạ địa chỉ cộng tác viên",
    example: "danh bạ điện thoại * danh bạ địa chỉ cộng tác viên",
  },
  {
    word: "dáng vẻ",
    part_of_speech: "danh từ",
    meaning: "vẻ bề ngoài (nói khái quát): dáng vẻ nho nhã",
    example: "dáng vẻ nho nhã",
  },
  {
    word: "danh",
    part_of_speech: "danh từ",
    meaning: "tên, tên người: xưng danh * điểm danh",
    example: "xưng danh * điểm danh",
  },
  {
    word: "danh",
    part_of_speech: "danh từ",
    meaning:
      "tên, tên người, về mặt được dư luận xã hội biết đến và coi trọng: mang danh đơn vị anh hùng * thói hám danh",
    example: "mang danh đơn vị anh hùng * thói hám danh",
  },
  {
    word: "danh cầm",
    part_of_speech: "danh từ",
    meaning: "nghệ sĩ chơi đàn nổi tiếng: bậc danh cầm",
    example: "bậc danh cầm",
  },
  {
    word: "danh gia",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) gia đình có tiếng tăm trong xã hội: "Vốn dòng họ Hoạn danh gia, Con quan Lại bộ tên là Hoạn thư." (TKiều)',
    example:
      'Vốn dòng họ Hoạn danh gia, Con quan Lại bộ tên là Hoạn thư." (TKiều)',
  },
  {
    word: "dành dụm",
    part_of_speech: "động từ",
    meaning: "gom góp từng ít một để để dành: dành dụm tiền để mua nhà",
    example: "dành dụm tiền để mua nhà",
  },
  {
    word: "danh giá",
    part_of_speech: "danh từ",
    meaning:
      "sự coi trọng của xã hội, thường dựa trên địa vị, giá trị riêng của mỗi con người: danh giá gia đình * có danh giá",
    example: "danh giá gia đình * có danh giá",
  },
  {
    word: "danh giá",
    part_of_speech: "tính từ",
    meaning: "có danh giá: gia đình danh giá",
    example: "gia đình danh giá",
  },
  {
    word: "danh hiệu",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi nêu lên phẩm chất tốt đẹp, cao quý, dành riêng cho cá nhân hay tập thể có nhiều thành tích xuất sắc: danh hiệu chiến sĩ thi đua * danh hiệu nghệ sĩ nhân dân",
    example: "danh hiệu chiến sĩ thi đua * danh hiệu nghệ sĩ nhân dân",
  },
  {
    word: "danh dự",
    part_of_speech: "danh từ",
    meaning:
      "sự coi trọng của dư luận xã hội, dựa trên giá trị tinh thần, đạo đức tốt đẹp: làm mất danh dự * bôi nhọ danh dự * thề danh dự",
    example: "làm mất danh dự * bôi nhọ danh dự * thề danh dự",
  },
  {
    word: "danh dự",
    part_of_speech: "danh từ",
    meaning:
      "cái mang lại sự coi trọng của xã hội, của tập thể dựa trên danh nghĩa (thuần tuý hình thức, không gắn với thực tế): chủ tịch danh dự * ngồi ở hàng ghế danh dự",
    example: "chủ tịch danh dự * ngồi ở hàng ghế danh dự",
  },
  {
    word: "danh hoạ",
    part_of_speech: "danh từ",
    meaning: "hoạ sĩ nổi tiếng: Van Gogh là một danh hoạ nổi tiếng",
    example: "Van Gogh là một danh hoạ nổi tiếng",
  },
  {
    word: "danh ngôn",
    part_of_speech: "danh từ",
    meaning:
      "lời nói hay, có ý nghĩa sâu sắc được người đời truyền tụng: danh ngôn về tình yêu",
    example: "danh ngôn về tình yêu",
  },
  {
    word: "danh nhân",
    part_of_speech: "danh từ",
    meaning:
      "người có danh tiếng và được xã hội công nhận: Chủ tịch Hồ Chí Minh là danh nhân văn hoá thế giới",
    example: "Chủ tịch Hồ Chí Minh là danh nhân văn hoá thế giới",
  },
  {
    word: "danh lợi",
    part_of_speech: "danh từ",
    meaning:
      'tên tuổi, địa vị và lợi ích cá nhân (nói khái quát): bon chen danh lợi * "Cái vòng danh lợi cong cong, Kẻ hòng ra khỏi, người mong nhẩy vào." (ca dao)',
    example:
      'bon chen danh lợi * "Cái vòng danh lợi cong cong, Kẻ hòng ra khỏi, người mong nhẩy vào." (ca dao)',
  },
  {
    word: "danh nghĩa",
    part_of_speech: "danh từ",
    meaning:
      "tư cách, cương vị có được để làm việc nào đó: dùng danh nghĩa chính quyền để đàn áp",
    example: "dùng danh nghĩa chính quyền để đàn áp",
  },
  {
    word: "danh nghĩa",
    part_of_speech: "danh từ",
    meaning:
      "ý nghĩa của tên gọi chỉ thuần tuý hình thức, không có quan hệ hoặc đối lập với nội dung, với thực chất: chỉ là vợ chồng trên danh nghĩa",
    example: "chỉ là vợ chồng trên danh nghĩa",
  },
  {
    word: "danh mục",
    part_of_speech: "danh từ",
    meaning:
      "bản ghi theo phân loại từng mục cụ thể: danh mục hàng hoá * danh mục sách tham khảo",
    example: "danh mục hàng hoá * danh mục sách tham khảo",
  },
  {
    word: "danh ngữ",
    part_of_speech: "danh từ",
    meaning:
      '(ngữ pháp) tổ hợp có quan hệ chính phụ do danh từ làm chính tố: Trong "Quyển sách này rất hay." "Quyển sách này" là một danh ngữ.',
    example:
      'Trong "Quyển sách này rất hay." "Quyển sách này" là một danh ngữ.',
  },
  {
    word: "danh phận",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) danh nghĩa, chức phận và địa vị: không có danh phận gì * làm nên danh phận",
    example: "không có danh phận gì * làm nên danh phận",
  },
  {
    word: "danh pháp",
    part_of_speech: "danh từ",
    meaning:
      "những quy tắc đặt tên trong một ngành khoa học (nói tổng quát): danh pháp hoá học",
    example: "danh pháp hoá học",
  },
  {
    word: "danh số",
    part_of_speech: "danh từ",
    meaning:
      "số có kèm theo tên đơn vị của đại lượng được xét; phân biệt với hư số: ,  * ,  *  là những danh số",
    example: ",  * ,  *  là những danh số",
  },
  {
    word: "danh sĩ",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người trí thức nổi tiếng thời phong kiến: các danh sĩ đời Lê",
    example: "các danh sĩ đời Lê",
  },
  {
    word: "danh sách",
    part_of_speech: "danh từ",
    meaning: "bản ghi tên, bản kê tên: danh sách cử tri * danh sách thí sinh",
    example: "danh sách cử tri * danh sách thí sinh",
  },
  {
    word: "danh thủ",
    part_of_speech: "danh từ",
    meaning:
      "vận động viên giỏi, nổi tiếng: danh thủ môn cờ vua * danh thủ bóng đá",
    example: "danh thủ môn cờ vua * danh thủ bóng đá",
  },
  {
    word: "danh tiết",
    part_of_speech: "danh từ",
    meaning: "danh dự và tiết tháo: giữ tròn danh tiết",
    example: "giữ tròn danh tiết",
  },
  {
    word: "danh tiếng",
    part_of_speech: "danh từ",
    meaning: "tiếng tăm tốt: một hoạ sĩ có danh tiếng * danh tiếng lừng lẫy",
    example: "một hoạ sĩ có danh tiếng * danh tiếng lừng lẫy",
  },
  {
    word: "danh tiếng",
    part_of_speech: "tính từ",
    meaning:
      "có tiếng tăm tốt, được nhiều người biết đến: những nhân vật danh tiếng * trường đại học danh tiếng",
    example: "những nhân vật danh tiếng * trường đại học danh tiếng",
  },
  {
    word: "danh tính",
    part_of_speech: "danh từ",
    meaning:
      "tên và họ; họ tên, lai lịch của một người: xác nhận danh tính nạn nhân",
    example: "xác nhận danh tính nạn nhân",
  },
  {
    word: "danh từ chung",
    part_of_speech: "danh từ",
    meaning:
      "danh từ dùng để gọi tên chung những sự vật thuộc cùng một loại: cây', 'gà', 'bệnh' là những danh từ chung",
    example: "cây', 'gà', 'bệnh' là những danh từ chung",
  },
  {
    word: "danh tướng",
    part_of_speech: "danh từ",
    meaning: "tướng giỏi nổi tiếng: danh tướng Lý Thường Kiệt",
    example: "danh tướng Lý Thường Kiệt",
  },
  {
    word: "danh từ",
    part_of_speech: "danh từ",
    meaning:
      "từ chuyên biểu thị ý nghĩa sự vật, đối tượng (thường làm chủ ngữ trong câu): 'bàn', 'ghế', 'đêm', 'ngày', 'Hà Nội' là những danh từ.",
    example: "'bàn', 'ghế', 'đêm', 'ngày', 'Hà Nội' là những danh từ.",
  },
  {
    word: "danh từ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) từ hoặc tổ hợp từ chuyên dùng để gọi tên sự vật hoặc biểu đạt khái niệm trong các lĩnh vực chuyên môn: danh từ khoa học * danh từ chuyên môn",
    example: "danh từ khoa học * danh từ chuyên môn",
  },
  {
    word: "danh y",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) thầy thuốc giỏi nổi tiếng: Hải Thượng Lãn Ông, Tuệ Tĩnh là những bậc danh y",
    example: "Hải Thượng Lãn Ông, Tuệ Tĩnh là những bậc danh y",
  },
  {
    word: "danh vị",
    part_of_speech: "danh từ",
    meaning: "tên tuổi và địa vị: mưu cầu danh vị",
    example: "mưu cầu danh vị",
  },
  {
    word: "dao",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng để cắt, gồm có lưỡi sắc và chuôi cầm: dao sắc không gọt được chuôi (tng)",
    example: "dao sắc không gọt được chuôi (tng)",
  },
  {
    word: "danh vọng",
    part_of_speech: "danh từ",
    meaning:
      "tiếng tăm và sự trọng vọng của dư luận xã hội: tiền tài danh vọng * chạy theo danh vọng",
    example: "tiền tài danh vọng * chạy theo danh vọng",
  },
  {
    word: "dào",
    part_of_speech: "động từ",
    meaning:
      'dâng lên và tràn đầy: bọt nước dào lên trắng xoá * "Khi ăn ở, lúc ra vào, Càng âu duyên mới, càng dào tình xưa." (TKiều)',
    example:
      'bọt nước dào lên trắng xoá * "Khi ăn ở, lúc ra vào, Càng âu duyên mới, càng dào tình xưa." (TKiều)',
  },
  {
    word: "dào",
    part_of_speech: "cảm từ",
    meaning:
      "(khẩu ngữ) tiếng thốt ra biểu lộ ý phủ nhận, từ chối một cách thân mật: dào, tin gì cái thằng ấy! * dào, chỉ vẽ chuyện!",
    example: "dào, tin gì cái thằng ấy! * dào, chỉ vẽ chuyện!",
  },
  {
    word: "danh từ riêng",
    part_of_speech: "danh từ",
    meaning:
      "danh từ dùng làm tên riêng để gọi tên từng sự vật, đối tượng riêng lẻ: ,  *  là những danh từ riêng",
    example: ",  *  là những danh từ riêng",
  },
  {
    word: "dạo",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian không xác định trong quá khứ hay hiện tại: dạo trước * dạo này trông cô ta khá lắm * bẵng đi một dạo không gặp",
    example:
      "dạo trước * dạo này trông cô ta khá lắm * bẵng đi một dạo không gặp",
  },
  {
    word: "dạo",
    part_of_speech: "động từ",
    meaning:
      'đi thong thả từ chỗ này đến chỗ nọ để nhìn ngắm, giải trí: đi dạo phố * "Nàng thì vội trở buồng thêu, Sinh thì dạo gót sân đào bước ra." (TKiều)',
    example:
      'đi dạo phố * "Nàng thì vội trở buồng thêu, Sinh thì dạo gót sân đào bước ra." (TKiều)',
  },
  {
    word: "dạo",
    part_of_speech: "động từ",
    meaning:
      "gảy đàn, đánh trống hoặc hát một đoạn ngắn để tạo không khí trước khi biểu diễn chính thức: dạo đàn * dạo một hồi trống mở màn",
    example: "dạo đàn * dạo một hồi trống mở màn",
  },
  {
    word: "dạo",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nói để tạo không khí trước khi nói chính thức: vào đề đi, nói dạo mãi!",
    example: "vào đề đi, nói dạo mãi!",
  },
  {
    word: "dao búa",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) dao và búa; dùng chỉ việc đâm thuê chém mướn để kiếm lợi: dân dao búa * nói những lời dao búa",
    example: "dân dao búa * nói những lời dao búa",
  },
  {
    word: "dao cau",
    part_of_speech: "danh từ",
    meaning:
      'dao nhỏ và rất sắc, thường dùng để bổ cau: "Cổ tay em trắng như ngà, Con mắt em liếc như là dao cau." (ca dao)',
    example:
      'Cổ tay em trắng như ngà, Con mắt em liếc như là dao cau." (ca dao)',
  },
  {
    word: "dào dạt",
    part_of_speech: "",
    meaning: "như dạt dào: sóng xô dào dạt * tình yêu dào dạt trong lòng",
    example: "sóng xô dào dạt * tình yêu dào dạt trong lòng",
  },
  {
    word: "dạo đầu",
    part_of_speech: "động từ",
    meaning:
      "dạo mở đầu để dẫn tới phần chính thức của một bản nhạc, một ca khúc: khúc nhạc dạo đầu",
    example: "khúc nhạc dạo đầu",
  },
  {
    word: "dao động",
    part_of_speech: "động từ",
    meaning:
      "chuyển động qua lại hai bên một vị trí cân bằng: con lắc dao động",
    example: "con lắc dao động",
  },
  {
    word: "dao động",
    part_of_speech: "động từ",
    meaning:
      "xê xích trong một giới hạn nào đó: thời hạn dao động từ 1 tuần đến 10 ngày",
    example: "thời hạn dao động từ 1 tuần đến 10 ngày",
  },
  {
    word: "dao động",
    part_of_speech: "động từ",
    meaning:
      "mất thế ổn định về tinh thần, tư tưởng, dẫn đến dễ thay đổi ý kiến: tư tưởng dao động * dao động trước khó khăn",
    example: "tư tưởng dao động * dao động trước khó khăn",
  },
  {
    word: "dao động",
    part_of_speech: "danh từ",
    meaning:
      "những quá trình sau một khoảng thời gian bằng nhau hoặc gần bằng nhau lại lặp lại đúng hoặc gần đúng như cũ (nói tổng quát): dao động điện",
    example: "dao động điện",
  },
  {
    word: "dao kéo",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) dao và kéo; chỉ việc mổ xẻ nói chung: mảnh đạn cắm không sâu nên không cần đến dao kéo",
    example: "mảnh đạn cắm không sâu nên không cần đến dao kéo",
  },
  {
    word: "dào ôi",
    part_of_speech: "cảm từ",
    meaning:
      "(khẩu ngữ) tiếng thốt ra biểu lộ ý không đồng tình, thường với vẻ hơi bực bội: dào ôi, buôn với chả bán!",
    example: "dào ôi, buôn với chả bán!",
  },
  {
    word: "dạo mát",
    part_of_speech: "động từ",
    meaning: "đi dạo để hóng mát: dạo mát quanh hồ",
    example: "dạo mát quanh hồ",
  },
  {
    word: "dạt dào",
    part_of_speech: "",
    meaning:
      "tràn đầy do dâng lên nhiều và liên tục: gió thổi dạt dào trên đồng lúa chín * tình cảm dạt dào",
    example: "gió thổi dạt dào trên đồng lúa chín * tình cảm dạt dào",
  },
  {
    word: "dát",
    part_of_speech: "động từ",
    meaning:
      "làm mỏng kim loại bằng cách đập, cán: dát mỏng miếng đồng * dát vàng thành từng tấm mỏng",
    example: "dát mỏng miếng đồng * dát vàng thành từng tấm mỏng",
  },
  {
    word: "dát",
    part_of_speech: "động từ",
    meaning:
      'gắn thêm từng mảnh trên bề mặt, thường để trang trí: mũ dát ngọc * "Trăng đã leo vượt khỏi rặng nhãn, bóng trăng dát vàng trên mảnh sân gạch." (DHướng; 1)',
    example:
      'mũ dát ngọc * "Trăng đã leo vượt khỏi rặng nhãn, bóng trăng dát vàng trên mảnh sân gạch." (DHướng; 1)',
  },
  {
    word: "dàu",
    part_of_speech: "tính từ",
    meaning: "héo úa, không còn tươi: lá úa hoa dàu * dưa đã dàu",
    example: "lá úa hoa dàu * dưa đã dàu",
  },
  {
    word: "dàu",
    part_of_speech: "tính từ",
    meaning: "buồn phiền, ủ rũ, kém tươi vui: mặt dàu kém tươi * dàu vẻ mặt",
    example: "mặt dàu kém tươi * dàu vẻ mặt",
  },
  {
    word: "dạt",
    part_of_speech: "động từ",
    meaning:
      "bị xô đẩy về một phía, một nơi nào đó: bèo dạt mây trôi * đám người chạy dạt ra hai bên đường",
    example: "bèo dạt mây trôi * đám người chạy dạt ra hai bên đường",
  },
  {
    word: "dạt",
    part_of_speech: "động từ",
    meaning: "dãn thưa ra (thường nói về sợi của hàng dệt): mặt vải đã bị dạt",
    example: "mặt vải đã bị dạt",
  },
  {
    word: "dàu dàu",
    part_of_speech: "tính từ",
    meaning: "héo úa, không còn tươi: lá úa hoa dàu * dưa đã dàu",
    example: "lá úa hoa dàu * dưa đã dàu",
  },
  {
    word: "dàu dàu",
    part_of_speech: "tính từ",
    meaning: "buồn phiền, ủ rũ, kém tươi vui: mặt dàu kém tươi * dàu vẻ mặt",
    example: "mặt dàu kém tươi * dàu vẻ mặt",
  },
  {
    word: "dạy",
    part_of_speech: "động từ",
    meaning:
      "truyền đạt lại tri thức hoặc kĩ năng một cách có phương pháp: cô giáo dạy văn * trường dạy nghề",
    example: "cô giáo dạy văn * trường dạy nghề",
  },
  {
    word: "dạy",
    part_of_speech: "động từ",
    meaning:
      'làm cho biết điều phải trái, biết cách tu dưỡng và đối xử: "Uốn cây từ thuở còn non, Dạy con từ thuở con còn thơ ngây." (ca dao)',
    example:
      'Uốn cây từ thuở còn non, Dạy con từ thuở con còn thơ ngây." (ca dao)',
  },
  {
    word: "dạy",
    part_of_speech: "động từ",
    meaning:
      "tập cho động vật có thói quen biết làm việc gì đó một cách thành thạo, tựa như người: dạy cá voi làm xiếc",
    example: "dạy cá voi làm xiếc",
  },
  {
    word: "dày",
    part_of_speech: "tính từ",
    meaning:
      "(vật hình khối) có khoảng cách bao nhiêu đó giữa hai mặt đối nhau, theo chiều có kích thước nhỏ nhất của vật: quyển sách dày 100 trang",
    example: "quyển sách dày 100 trang",
  },
  {
    word: "dày",
    part_of_speech: "tính từ",
    meaning:
      "có bề dày lớn hơn mức bình thường hoặc lớn hơn so với những vật khác cùng loại: chiếc áo khoác may bằng loại vải rất dày * vỏ quýt dày có móng tay nhọn (tng)",
    example:
      "chiếc áo khoác may bằng loại vải rất dày * vỏ quýt dày có móng tay nhọn (tng)",
  },
  {
    word: "dày",
    part_of_speech: "tính từ",
    meaning:
      "có tương đối nhiều đơn vị hoặc nhiều yếu tố sát vào nhau: mớ tóc dày * cấy dày",
    example: "mớ tóc dày * cấy dày",
  },
  {
    word: "dày",
    part_of_speech: "tính từ",
    meaning:
      "nhiều, do được tích luỹ liên tục trong một quá trình (nói về yếu tố tinh thần): dày công luyện tập * dày kinh nghiệm",
    example: "dày công luyện tập * dày kinh nghiệm",
  },
  {
    word: "dãy",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp gồm những vật cùng loại nối tiếp nhau, cái này cạnh cái kia: dãy nhà * xếp bàn ghế thành bốn dãy * dãy Trường Sơn",
    example: "dãy nhà * xếp bàn ghế thành bốn dãy * dãy Trường Sơn",
  },
  {
    word: "day",
    part_of_speech: "động từ",
    meaning:
      "dùng tay hoặc chân, hay các ngón vừa đè mạnh lên vừa đưa đi đưa lại ở một chỗ: day vào hai bên thái dương * day day gót chân xuống đất",
    example: "day vào hai bên thái dương * day day gót chân xuống đất",
  },
  {
    word: "day",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) xoay, quay: đi rồi còn day lại nhìn",
    example: "đi rồi còn day lại nhìn",
  },
  {
    word: "dày cồm cộp",
    part_of_speech: "tính từ",
    meaning: "như dày cộp (nhưng ý mức độ nhiều hơn): áo vải nâu dày cồm cộp",
    example: "áo vải nâu dày cồm cộp",
  },
  {
    word: "dày dạn",
    part_of_speech: "tính từ",
    meaning:
      "từng trải, chịu đựng nhiều đến mức như đã quen với khó khăn, nguy hiểm: dày dạn gió sương * dày dạn trong chiến đấu * một  người từng trải và dày dạn",
    example:
      "dày dạn gió sương * dày dạn trong chiến đấu * một  người từng trải và dày dạn",
  },
  {
    word: "dạy bảo",
    part_of_speech: "động từ",
    meaning:
      "bảo cho biết điều hay lẽ phải, cho nên người (nói khái quát): nghe lời cha mẹ dạy bảo * thằng bé rất bướng, khó dạy bảo",
    example: "nghe lời cha mẹ dạy bảo * thằng bé rất bướng, khó dạy bảo",
  },
  {
    word: "dạy bảo",
    part_of_speech: "động từ",
    meaning:
      "(cũ, trang trọng) bảo người dưới, nói với người dưới (nói khái quát): dạ, cần gì xin cụ cứ dạy bảo!",
    example: "dạ, cần gì xin cụ cứ dạy bảo!",
  },
  {
    word: "dày cộp",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) dày quá mức, gây cảm giác vướng víu: quyển sách dày cộp * cặp kính cận dày cộp",
    example: "quyển sách dày cộp * cặp kính cận dày cộp",
  },
  {
    word: "dày cui",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) dày và có vẻ thô cứng, gây cảm giác khó chịu: chiếc quần dày cui",
    example: "chiếc quần dày cui",
  },
  {
    word: "dạy dỗ",
    part_of_speech: "động từ",
    meaning:
      "bảo cho biết điều hay lẽ phải một cách ân cần và dịu dàng: dạy dỗ con cái * dạy dỗ cho nên người",
    example: "dạy dỗ con cái * dạy dỗ cho nên người",
  },
  {
    word: "day dứt",
    part_of_speech: "",
    meaning:
      "làm cho bị bứt rứt không yên: nỗi ân hận luôn day dứt trong lòng * nhớ nhung day dứt",
    example: "nỗi ân hận luôn day dứt trong lòng * nhớ nhung day dứt",
  },
  {
    word: "dày đặc",
    part_of_speech: "tính từ",
    meaning:
      "rất dày, rất sít, như không còn kẽ hở: sương mù dày đặc * bóng tối dày đặc",
    example: "sương mù dày đặc * bóng tối dày đặc",
  },
  {
    word: "dày dặn",
    part_of_speech: "tính từ",
    meaning:
      "dày và có vẻ chắc chắn (nói khái quát): chiếc áo bông dày dặn * mái tóc dày dặn",
    example: "chiếc áo bông dày dặn * mái tóc dày dặn",
  },
  {
    word: "dày gió dạn sương",
    part_of_speech: "",
    meaning:
      'dày dạn với gió sương, với gian khổ, vất vả: "Mặt sao dày gió dạn sương, Thân sao bướm chán ong chường bấy thân?" (TKiều)',
    example:
      'Mặt sao dày gió dạn sương, Thân sao bướm chán ong chường bấy thân?" (TKiều)',
  },
  {
    word: "day trở",
    part_of_speech: "động từ",
    meaning:
      "làm hết cách này đến cách khác để giải quyết cho được khó khăn, hoặc để có cho được cái cần có: xoay xở tiền nong * không có anh, thì tôi không biết xoay xở ra làm sao",
    example:
      "xoay xở tiền nong * không có anh, thì tôi không biết xoay xở ra làm sao",
  },
  {
    word: "dăm",
    part_of_speech: "danh từ",
    meaning:
      "mảnh vật liệu nhỏ, thường là tre, gỗ, để chèn cho chặt: dăm tre * dăm cối",
    example: "dăm tre * dăm cối",
  },
  {
    word: "dăm",
    part_of_speech: "danh từ",
    meaning: "mảnh nhỏ vụn: đá dăm * xương dăm",
    example: "đá dăm * xương dăm",
  },
  {
    word: "dăm",
    part_of_speech: "danh từ",
    meaning: "dăm kèn (nói tắt): loại kèn có dăm đơn",
    example: "loại kèn có dăm đơn",
  },
  {
    word: "dăm",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) số ước lượng trên dưới năm: độ dăm người là đủ * từ đây đến đó cũng phải mất dăm hôm",
    example: "độ dăm người là đủ * từ đây đến đó cũng phải mất dăm hôm",
  },
  {
    word: "dạy đời",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nói năng như muốn dạy bảo người ta, do ngạo mạn, tự cho là mình hiểu biết hơn người: lên giọng dạy đời",
    example: "lên giọng dạy đời",
  },
  {
    word: "dạy học",
    part_of_speech: "động từ",
    meaning:
      "dạy văn hoá, theo những chương trình nhất định: dạy học là một nghề cao quý",
    example: "dạy học là một nghề cao quý",
  },
  {
    word: "dặm",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị cũ đo độ dài, bằng 444,44 mét; thường dùng để tượng trưng cho quãng đường dài: sai một li đi một dặm (tng)",
    example: "sai một li đi một dặm (tng)",
  },
  {
    word: "dặm",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị đo độ dài của một số nước, thường là khác nhau ở mỗi nước: một dặm Anh bằng 1.609 mét",
    example: "một dặm Anh bằng 1.609 mét",
  },
  {
    word: "dặm",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) đường phải đi, thường là xa: "Ở đây âm khí nặng nề, Bóng chiều đã ngả, dặm về còn xa." (TKiều)',
    example: 'Ở đây âm khí nặng nề, Bóng chiều đã ngả, dặm về còn xa." (TKiều)',
  },
  {
    word: "dăm bào",
    part_of_speech: "danh từ",
    meaning:
      "những mảnh mỏng, nhỏ và xoăn từ gỗ rơi ra khi bào: đun bằng vỏ bào",
    example: "đun bằng vỏ bào",
  },
  {
    word: "dằm",
    part_of_speech: "danh từ",
    meaning:
      "mảnh gỗ, tre, nứa, v.v. rất nhỏ và nhọn, đâm vào da thịt: bị dằm đâm vào tay đau điếng",
    example: "bị dằm đâm vào tay đau điếng",
  },
  {
    word: "dằm",
    part_of_speech: "danh từ",
    meaning:
      '(phương ngữ) chỗ, về mặt để ngồi, nằm hay đặt vật gì: nằm chưa ấm dằm đã phải dậy * "Một lời thuyền đã êm dằm, Hãy đưa canh thiếp, trước cầm làm ghi." (TKiều)',
    example:
      'nằm chưa ấm dằm đã phải dậy * "Một lời thuyền đã êm dằm, Hãy đưa canh thiếp, trước cầm làm ghi." (TKiều)',
  },
  {
    word: "dăm ba",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) số lượng không nhiều nhưng cũng không ít, chừng độ trên dưới năm hoặc ba bốn gì đó: nói dăm ba câu chuyện * đi dăm ba ngày lại về",
    example: "nói dăm ba câu chuyện * đi dăm ba ngày lại về",
  },
  {
    word: "dăm bảy",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) số ước lượng khoảng từ năm đến bảy: chừng dăm bảy cây số nữa thì đến * đong dăm bảy cân gạo",
    example: "chừng dăm bảy cây số nữa thì đến * đong dăm bảy cân gạo",
  },
  {
    word: "dặm ngàn",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) đường dài phải đi qua rừng, qua núi: "Dặm ngàn nước thẳm, non xa, Nghĩ đâu thân phận con ra thế này!" (TKiều)',
    example:
      'Dặm ngàn nước thẳm, non xa, Nghĩ đâu thân phận con ra thế này!" (TKiều)',
  },
  {
    word: "dặm nghìn da ngựa",
    part_of_speech: "",
    meaning:
      'như da ngựa bọc thây: "Chí làm trai dặm nghìn da ngựa, Gieo Thái Sơn nhẹ tựa hồng mao." (CPN)',
    example:
      'Chí làm trai dặm nghìn da ngựa, Gieo Thái Sơn nhẹ tựa hồng mao." (CPN)',
  },
  {
    word: "dăm cối",
    part_of_speech: "danh từ",
    meaning: "dăm gỗ dùng để đóng vào thớt cối xay.",
    example: "dẻo chân * tuổi cao nhưng vẫn còn dẻo sức",
  },
  {
    word: "dằn",
    part_of_speech: "động từ",
    meaning:
      "đè mạnh xuống và giữ chặt, không cho trỗi dậy, không cho nổi lên: dằn ngửa con lợn ra để trói * dằn cà muối",
    example: "dằn ngửa con lợn ra để trói * dằn cà muối",
  },
  {
    word: "dằn",
    part_of_speech: "động từ",
    meaning:
      "nén giữ tình cảm, cảm xúc, không để cho bộc lộ ra: dằn lòng * cố dằn nỗi đau * không dằn được cơn tức giận",
    example: "dằn lòng * cố dằn nỗi đau * không dằn được cơn tức giận",
  },
  {
    word: "dằn",
    part_of_speech: "động từ",
    meaning:
      'đặt mạnh xuống để tỏ một thái độ nào đó như tức giận, không bằng lòng: "Nhớ ai cơm chẳng buồn ăn, Đã nâng lấy bát lại dằn xuống mâm." (ca dao)',
    example:
      'Nhớ ai cơm chẳng buồn ăn, Đã nâng lấy bát lại dằn xuống mâm." (ca dao)',
  },
  {
    word: "dằn",
    part_of_speech: "động từ",
    meaning:
      "nói nhấn mạnh để tỏ thái độ giận dữ, hàm ý đe doạ: dằn giọng * nói dằn từng tiếng một",
    example: "dằn giọng * nói dằn từng tiếng một",
  },
  {
    word: "dăm bữa nửa tháng",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) khoảng thời gian ước lượng, từ khoảng trên dưới năm ngày đến trên dưới nửa tháng: bệnh đã thuyên giảm, chỉ dăm bữa nửa tháng nữa là khỏi hẳn",
    example: "bệnh đã thuyên giảm, chỉ dăm bữa nửa tháng nữa là khỏi hẳn",
  },
  {
    word: "dặm trường",
    part_of_speech: "danh từ",
    meaning:
      '(văn chương) đường đi dài và xa: thân gái dặm trường * "Vầng trăng ai xẻ làm đôi?, Nửa in gối chiếc, nửa soi dặm trường." (TKiều)',
    example:
      'thân gái dặm trường * "Vầng trăng ai xẻ làm đôi?, Nửa in gối chiếc, nửa soi dặm trường." (TKiều)',
  },
  {
    word: "dằn bụng",
    part_of_speech: "động từ",
    meaning:
      '(phương ngữ, khẩu ngữ) như lót dạ: "Để tôi đi lo cho các ông nồi cháo gà dằn bụng để buổi khuya đi đường." (ĐGiỏi; 4)',
    example:
      'Để tôi đi lo cho các ông nồi cháo gà dằn bụng để buổi khuya đi đường." (ĐGiỏi; 4)',
  },
  {
    word: "dặn",
    part_of_speech: "động từ",
    meaning:
      "bảo cho biết điều cần nhớ để làm: dặn con mấy điều * làm đúng như lời dặn",
    example: "dặn con mấy điều * làm đúng như lời dặn",
  },
  {
    word: "dặn dò",
    part_of_speech: "động từ",
    meaning:
      'dặn cẩn thận, với thái độ rất quan tâm: dặn dò cẩn thận * "Tay cầm bầu rượu nắm nem, Mảng vui quên hết lời em dặn dò." (ca dao)',
    example:
      'dặn dò cẩn thận * "Tay cầm bầu rượu nắm nem, Mảng vui quên hết lời em dặn dò." (ca dao)',
  },
  {
    word: "dằn túi",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bỏ sẵn tiền vào túi để phòng có chuyện gì: phải có ít tiền dằn túi thì mới yên tâm",
    example: "phải có ít tiền dằn túi thì mới yên tâm",
  },
  {
    word: "dằn hắt",
    part_of_speech: "động từ",
    meaning: "(hiếm) dằn dỗi và hắt hủi: tỏ thái độ dằn hắt",
    example: "tỏ thái độ dằn hắt",
  },
  {
    word: "dằn mặt",
    part_of_speech: "động từ",
    meaning:
      "làm cho sợ ngay từ đầu để ngăn ngừa sự chống đối, chống chọi lại về sau: đánh một trận dằn mặt * dằn mặt nhau",
    example: "đánh một trận dằn mặt * dằn mặt nhau",
  },
  {
    word: "dằn dỗi",
    part_of_speech: "động từ",
    meaning:
      "tỏ ý hờn giận bằng những lời nói, cử chỉ vùng vằng, khó chịu: tính hay dằn dỗi",
    example: "tính hay dằn dỗi",
  },
  {
    word: "dằn vặt",
    part_of_speech: "động từ",
    meaning:
      "làm cho phải đau đớn, khổ tâm một cách dai dẳng: bị vợ con dằn vặt * nỗi ân hận dằn vặt suốt đời",
    example: "bị vợ con dằn vặt * nỗi ân hận dằn vặt suốt đời",
  },
  {
    word: "dắt",
    part_of_speech: "động từ",
    meaning:
      "nắm giữ để dẫn đi, đưa đi cùng với mình: dắt nhau đi chơi * cầm dây cương dắt ngựa * xe máy hỏng, phải dắt một đoạn",
    example:
      "dắt nhau đi chơi * cầm dây cương dắt ngựa * xe máy hỏng, phải dắt một đoạn",
  },
  {
    word: "dằng dịt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) như chằng chịt: các cây dây leo quấn vào nhau dằng dịt",
    example: "các cây dây leo quấn vào nhau dằng dịt",
  },
  {
    word: "dằng dai",
    part_of_speech: "tính từ",
    meaning:
      "kéo dài mãi, không chấm dứt được: cuộc tranh chấp dằng dai * chuyện đó vẫn còn dằng dai đến tận bây giờ",
    example:
      "cuộc tranh chấp dằng dai * chuyện đó vẫn còn dằng dai đến tận bây giờ",
  },
  {
    word: "dặt",
    part_of_speech: "động từ",
    meaning: "ấn nhẹ xuống cho sát vào, cho dính vào: dặt thuốc lào",
    example: "dặt thuốc lào",
  },
  {
    word: "dắt dây",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) làm ảnh hưởng, kéo theo, lây lan sang: nợ nần dắt dây * kiện cáo dắt dây, hết người nọ đến người kia",
    example: "nợ nần dắt dây * kiện cáo dắt dây, hết người nọ đến người kia",
  },
  {
    word: "dằng dặc",
    part_of_speech: "tính từ",
    meaning:
      'kéo dài mãi như không có giới hạn: mười năm dằng dặc xa quê * "Khắc giờ đằng đẵng như niên, Mối sầu dằng dặc tựa miền biển xa." (CPN)',
    example:
      'mười năm dằng dặc xa quê * "Khắc giờ đằng đẵng như niên, Mối sầu dằng dặc tựa miền biển xa." (CPN)',
  },
  {
    word: "dặt dẹo",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (thân hình, dáng đi đứng) xiêu vẹo, yếu ớt: đau ốm dặt dẹo * đi đứng dặt dẹo",
    example: "đau ốm dặt dẹo * đi đứng dặt dẹo",
  },
  {
    word: "dặt dẹo",
    part_of_speech: "tính từ",
    meaning:
      "(ở) không có nơi chốn ổn định, nay đây mai đó: ngủ dặt dẹo ở các ghế đá công viên",
    example: "ngủ dặt dẹo ở các ghế đá công viên",
  },
  {
    word: "dắt mối",
    part_of_speech: "động từ",
    meaning:
      'như làm mối: nhờ người dắt mối * "Ấy ai dắt mối tơ mành, Cho thuyền quen bến, cho anh quen nàng." (ca dao).',
    example:
      'nhờ người dắt mối * "Ấy ai dắt mối tơ mành, Cho thuyền quen bến, cho anh quen nàng." (ca dao).',
  },
  {
    word: "dắt dẫn",
    part_of_speech: "động từ",
    meaning: "(hiếm) như dẫn dắt: dắt dẫn làm ăn * dắt dẫn câu chuyện",
    example: "dắt dẫn làm ăn * dắt dẫn câu chuyện",
  },
  {
    word: "dắt díu",
    part_of_speech: "động từ",
    meaning:
      "dắt nhau thành đoàn, thành tốp, trông lôi thôi khổ cực: bọn trẻ dắt díu nhau ra bờ sông * cả nhà dắt díu nhau đi khai hoang",
    example:
      "bọn trẻ dắt díu nhau ra bờ sông * cả nhà dắt díu nhau đi khai hoang",
  },
  {
    word: "dắt mũi",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) điều khiển làm cho phải tuân theo, nghe theo (hàm ý coi khinh): đần quá nên bị vợ dắt mũi",
    example: "đần quá nên bị vợ dắt mũi",
  },
  {
    word: "dắt dìu",
    part_of_speech: "động từ",
    meaning: "như dìu dắt: dắt dìu nhau để cùng tiến bộ",
    example: "dắt dìu nhau để cùng tiến bộ",
  },
  {
    word: "dầm",
    part_of_speech: "động từ",
    meaning:
      'ngâm hoặc chịu thấm ướt trong một thời gian tương đối lâu: dầm mưa dãi nắng * "Anh đi anh nhớ quê nhà, Nhớ canh rau muống nhớ cà dầm tương." (ca dao)',
    example:
      'dầm mưa dãi nắng * "Anh đi anh nhớ quê nhà, Nhớ canh rau muống nhớ cà dầm tương." (ca dao)',
  },
  {
    word: "dầm",
    part_of_speech: "động từ",
    meaning:
      "làm dầm (nói tắt); phân biệt với ải: ruộng dầm * ải thâm hơn dầm ngấu (tng)",
    example: "ruộng dầm * ải thâm hơn dầm ngấu (tng)",
  },
  {
    word: "dặt dìu",
    part_of_speech: "tính từ",
    meaning: "như dìu dặt: tiếng sáo dặt dìu",
    example: "tiếng sáo dặt dìu",
  },
  {
    word: "dặt dìu",
    part_of_speech: "động từ",
    meaning:
      '(cũ) dò hỏi một cách nhẹ nhàng, khéo léo: dặt dìu đôi câu * "Mặn nồng một vẻ một ưa, Bằng lòng, khách mới tuỳ cơ dặt dìu." (TKiều)',
    example:
      'dặt dìu đôi câu * "Mặn nồng một vẻ một ưa, Bằng lòng, khách mới tuỳ cơ dặt dìu." (TKiều)',
  },
  {
    word: "dắt gái",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) (kẻ xấu) đưa phụ nữ tham gia vào các hoạt động mại dâm: ma cô dắt gái",
    example: "ma cô dắt gái",
  },
  {
    word: "dậm",
    part_of_speech: "danh từ",
    meaning:
      "đồ đan bằng tre, miệng rộng hình bán cầu, có cán cầm, dùng để đánh bắt tôm cá: đánh giậm",
    example: "đánh giậm",
  },
  {
    word: "dậm",
    part_of_speech: "động từ",
    meaning:
      "nhấc chân cao rồi nện mạnh xuống: chân giậm thình thịch xuống đất * giậm chân bành bạch",
    example: "chân giậm thình thịch xuống đất * giậm chân bành bạch",
  },
  {
    word: "dấm dẳn",
    part_of_speech: "tính từ",
    meaning:
      "(nói) buông từng tiếng một, tỏ vẻ bực mình, khó chịu: ăn nói dấm dẳn",
    example: "ăn nói dấm dẳn",
  },
  {
    word: "dấm",
    part_of_speech: "danh từ",
    meaning:
      "dung dịch loãng acid acetic trong nước, có vị chua, thường chế từ rượu lên men, dùng làm gia vị..",
    example: "cá nấu giấm",
  },
  {
    word: "dâm dấp",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái hơi thấm ướt: trán dâm dấp mồ hôi * mồ hôi ướt dâm dấp lưng áo",
    example: "trán dâm dấp mồ hôi * mồ hôi ướt dâm dấp lưng áo",
  },
  {
    word: "bạc đầu",
    part_of_speech: "tính từ",
    meaning:
      '(tuổi) già: bạc đầu rồi còn dại * "Trăm năm thề những bạc đầu, Chớ tham phú quý, đi cầu trăng hoa." (ca dao)',
    example:
      'bạc đầu rồi còn dại * "Trăm năm thề những bạc đầu, Chớ tham phú quý, đi cầu trăng hoa." (ca dao)',
  },
  {
    word: "bạc đầu",
    part_of_speech: "tính từ",
    meaning:
      '(một số loài động vật, thực vật, hoặc một số sự vật) có đầu, có ngọn màu trắng: sóng bạc đầu * cỏ bạc đầu * "Vì sương nên núi bạc đầu, Biển lay bởi gió, hoa sầu vì mưa." (ca dao)',
    example:
      'sóng bạc đầu * cỏ bạc đầu * "Vì sương nên núi bạc đầu, Biển lay bởi gió, hoa sầu vì mưa." (ca dao)',
  },
  {
    word: "bác học",
    part_of_speech: "danh từ",
    meaning:
      "người học rộng, hiểu biết sâu về một hoặc nhiều ngành khoa học: nhà bác học",
    example: "nhà bác học",
  },
  {
    word: "bác học",
    part_of_speech: "tính từ",
    meaning:
      "theo lối của nhà bác học, có tính chất khó hiểu, không bình dân: văn chương bác học * dòng âm nhạc bác học",
    example: "văn chương bác học * dòng âm nhạc bác học",
  },
  {
    word: "bạc hà",
    part_of_speech: "danh từ",
    meaning:
      "cây cùng họ với húng dũi, chứa chất thơm, dùng để cất tinh dầu hoặc làm thuốc: dầu bạc hà * kẹo bạc hà",
    example: "dầu bạc hà * kẹo bạc hà",
  },
  {
    word: "bạc đãi",
    part_of_speech: "động từ",
    meaning:
      "đối xử rẻ rúng (với cái lẽ ra phải được coi trọng): bạc đãi người có công",
    example: "bạc đãi người có công",
  },
  {
    word: "bạc má",
    part_of_speech: "tính từ",
    meaning:
      "(dùng trong tên gọi một số loài động vật) có vệt trắng hai bên má, hai bên đầu: khướu bạc má * cá bạc má",
    example: "khướu bạc má * cá bạc má",
  },
  {
    word: "bạc giấy",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) tiền giấy: trong túi còn hai đồng bạc giấy",
    example: "trong túi còn hai đồng bạc giấy",
  },
  {
    word: "bạc màu",
    part_of_speech: "tính từ",
    meaning:
      "(đất) có lớp trên mặt bị rửa trôi nhiều, nghèo dinh dưỡng và đã nhạt màu hoặc chuyển sang màu trắng: cánh đồng bạc màu * cải tạo đất bạc màu",
    example: "cánh đồng bạc màu * cải tạo đất bạc màu",
  },
  {
    word: "bác mẹ",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) cha mẹ (thường dùng nhiều trong ca dao): "Ai lên xứ Lạng cùng anh, Bõ công bác mẹ sinh thành ra em." (ca dao)',
    example:
      'Ai lên xứ Lạng cùng anh, Bõ công bác mẹ sinh thành ra em." (ca dao)',
  },
  {
    word: "bạc nhạc",
    part_of_speech: "",
    meaning:
      "thịt chỉ có màng dai không có nạc (thường là thịt bò, thịt trâu): miếng bạc nhạc",
    example: "miếng bạc nhạc",
  },
  {
    word: "bạc phận",
    part_of_speech: "tính từ",
    meaning:
      '(cũ, văn chương) như bạc mệnh: "Trách hồng nhan vô duyên bạc phận, Duyên nợ ở gần sao không đặng xứng đôi." (ca dao)',
    example:
      'Trách hồng nhan vô duyên bạc phận, Duyên nợ ở gần sao không đặng xứng đôi." (ca dao)',
  },
  {
    word: "bạc phếch",
    part_of_speech: "tính từ",
    meaning:
      "bị phai màu đến mức ngả sang màu trắng đục, trông cũ và xấu: chiếc quần bò bạc phếch",
    example: "chiếc quần bò bạc phếch",
  },
  {
    word: "bạc mệnh",
    part_of_speech: "tính từ",
    meaning:
      '(cũ, văn chương) có số phận mỏng manh, hẩm hiu (thường nói về phụ nữ): hồng nhan bạc mệnh * "Đau đớn thay, phận đàn bà!, Lời rằng bạc mệnh cũng là lời chung." (TKiều)',
    example:
      'hồng nhan bạc mệnh * "Đau đớn thay, phận đàn bà!, Lời rằng bạc mệnh cũng là lời chung." (TKiều)',
  },
  {
    word: "bạc mặt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (mặt mũi) nhợt nhạt, mất đi vẻ tươi tắn, khoẻ khoắn do quá lo lắng hoặc quá vất vả: làm bạc mặt mới đủ sống * chạy cho xong thủ tục giấy tờ cũng đủ bạc mặt!",
    example:
      "làm bạc mặt mới đủ sống * chạy cho xong thủ tục giấy tờ cũng đủ bạc mặt!",
  },
  {
    word: "bạc nhược",
    part_of_speech: "tính từ",
    meaning:
      "quá yếu đuối về tinh thần, không có ý chí đấu tranh, không đủ sức vượt qua khó khăn, trở lực dù là nhỏ: con người bạc nhược * ý chí bạc nhược",
    example: "con người bạc nhược * ý chí bạc nhược",
  },
  {
    word: "bạch",
    part_of_speech: "động từ",
    meaning:
      "(cũ) bày tỏ, nói (với người trên): ăn chưa sạch, bạch chưa thông (tng)",
    example: "ăn chưa sạch, bạch chưa thông (tng)",
  },
  {
    word: "bạch",
    part_of_speech: "động từ",
    meaning: "thưa (chỉ dùng để nói với nhà sư): bạch sư cụ",
    example: "bạch sư cụ",
  },
  {
    word: "bạch",
    part_of_speech: "tính từ",
    meaning:
      "trắng toàn một màu: ngựa bạch * hoa hồng bạch * trời đã sáng bạch",
    example: "ngựa bạch * hoa hồng bạch * trời đã sáng bạch",
  },
  {
    word: "bạc tình",
    part_of_speech: "tính từ",
    meaning:
      'bội bạc trong tình yêu: ăn ở bạc tình * "Bạc tình nổi tiếng lầu xanh, Một tay chôn biết mấy cành phù dung!" (TKiều)',
    example:
      'ăn ở bạc tình * "Bạc tình nổi tiếng lầu xanh, Một tay chôn biết mấy cành phù dung!" (TKiều)',
  },
  {
    word: "bạch bạch",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng phát ra nhỏ, không vang do các vật mềm có mặt phẳng hơi rộng vỗ đập vào nhau: đàn chim vỗ cánh bạch bạch * giậm chân bạch bạch",
    example: "đàn chim vỗ cánh bạch bạch * giậm chân bạch bạch",
  },
  {
    word: "bạc phơ",
    part_of_speech: "tính từ",
    meaning: "(râu, tóc) hoàn toàn bạc trắng: cụ già râu tóc bạc phơ",
    example: "cụ già râu tóc bạc phơ",
  },
  {
    word: "bách bệnh",
    part_of_speech: "danh từ",
    meaning: "trăm bệnh, mọi thứ bệnh, nói chung: thuốc trị bách bệnh",
    example: "thuốc trị bách bệnh",
  },
  {
    word: "bác sĩ",
    part_of_speech: "danh từ",
    meaning:
      "người thầy thuốc tốt nghiệp đại học y khoa: bác sĩ tim mạch * bác sĩ đa khoa * Ho đã lâu thì nên đi khám bác sĩ.",
    example:
      "bác sĩ tim mạch * bác sĩ đa khoa * Ho đã lâu thì nên đi khám bác sĩ.",
  },
  {
    word: "bách bổ",
    part_of_speech: "tính từ",
    meaning: "(thuốc) bổ nhiều mặt, nói chung: cao bách bổ",
    example: "cao bách bổ",
  },
  {
    word: "bách bộ",
    part_of_speech: "động từ",
    meaning: "đi dạo từng bước thong thả: bách bộ quanh bờ hồ",
    example: "bách bộ quanh bờ hồ",
  },
  {
    word: "bách chiến bách thắng",
    part_of_speech: "",
    meaning:
      "trăm trận trăm thắng; đánh trận nào thắng trận ấy, không có đối thủ nào địch nổi: đội quân bách chiến bách thắng",
    example: "đội quân bách chiến bách thắng",
  },
  {
    word: "bách hoá",
    part_of_speech: "danh từ",
    meaning:
      "(buôn bán) các mặt hàng tiêu dùng, chủ yếu là đồ may mặc và đồ dùng thường ngày (nói tổng quát): cửa hàng bách hoá * bán bách hoá",
    example: "cửa hàng bách hoá * bán bách hoá",
  },
  {
    word: "bách khoa thư",
    part_of_speech: "danh từ",
    meaning:
      "từ điển cung cấp các tri thức cơ bản về một hoặc nhiều lĩnh vực: bách khoa thư bệnh học",
    example: "bách khoa thư bệnh học",
  },
  {
    word: "bách khoa",
    part_of_speech: "danh từ",
    meaning:
      "các bộ môn, các ngành khoa học và kĩ thuật (nói tổng quát): kiến thức bách khoa * từ điển bách khoa",
    example: "kiến thức bách khoa * từ điển bách khoa",
  },
  {
    word: "bách phát bách trúng",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) trăm phát trăm trúng; bắn phát nào trúng phát ấy, rất chính xác: bắn rất giỏi, bách phát bách trúng",
    example: "bắn rất giỏi, bách phát bách trúng",
  },
  {
    word: "bạch nhật",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) khoảng thời gian trời sáng rõ, giữa ban ngày: ngủ đến bạch nhật mới dậy",
    example: "ngủ đến bạch nhật mới dậy",
  },
  {
    word: "bách phân",
    part_of_speech: "động từ",
    meaning: "chia làm một trăm phần bằng nhau: tính theo bách phân",
    example: "tính theo bách phân",
  },
  {
    word: "bách phân",
    part_of_speech: "động từ",
    meaning: "(cũ) tính phần trăm: tỉ lệ bách phân",
    example: "tỉ lệ bách phân",
  },
  {
    word: "bai",
    part_of_speech: "động từ",
    meaning: "rão, dãn: dây thừng bị nghiến bai ra * áo phông bị bai cổ",
    example: "dây thừng bị nghiến bai ra * áo phông bị bai cổ",
  },
  {
    word: "bách tính",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) trăm họ; các tầng lớp thường dân (nói tổng quát; phân biệt với tầng lớp quý tộc, quan lại thống trị thời phong kiến): bách tính lầm than",
    example: "bách tính lầm than",
  },
  {
    word: "bài bây",
    part_of_speech: "danh từ",
    meaning:
      'hành động cố ý kéo dài, dây dưa, lằng nhằng nhằm lảng tránh trách nhiệm: "Lão kia có giở bài bây, Chẳng văng vào mặt mà mày lại nghe!" (TKiều)',
    example:
      'Lão kia có giở bài bây, Chẳng văng vào mặt mà mày lại nghe!" (TKiều)',
  },
  {
    word: "bài",
    part_of_speech: "danh từ",
    meaning:
      "công trình sáng tác, biên soạn có nội dung tương đối hoàn chỉnh, có dung lượng vừa phải: bài thơ * bài phát biểu * gửi bài viết đến toà soạn",
    example: "bài thơ * bài phát biểu * gửi bài viết đến toà soạn",
  },
  {
    word: "bài",
    part_of_speech: "danh từ",
    meaning:
      "phần nhỏ tương đối hoàn chỉnh trong chương trình học tập, huấn luyện, giảng dạy: bài lịch sử * tập thể dục theo bài mới * soạn bài lên lớp",
    example: "bài lịch sử * tập thể dục theo bài mới * soạn bài lên lớp",
  },
  {
    word: "bài",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) đầu đề ra cho học sinh theo đó mà viết thành bài: ra bài về nhà * đọc kĩ bài trước khi làm",
    example: "ra bài về nhà * đọc kĩ bài trước khi làm",
  },
  {
    word: "bài",
    part_of_speech: "danh từ",
    meaning:
      "những tấm giấy bồi mỏng, kích thước bằng nhau, có in hình hoặc chữ để làm quân trong một số trò chơi: cỗ bài tam cúc * chia bài * bốc một quân bài",
    example: "cỗ bài tam cúc * chia bài * bốc một quân bài",
  },
  {
    word: "bài",
    part_of_speech: "danh từ",
    meaning:
      "trò chơi dùng các quân bài theo những quy cách nhất định: chơi bài tú lơ khơ * đánh bài",
    example: "chơi bài tú lơ khơ * đánh bài",
  },
  {
    word: "bài",
    part_of_speech: "danh từ",
    meaning:
      'cách xử trí: giả bài làm ngơ * đánh bài lờ * "Ngảnh đi, chợt nói, chợt cười, Cáo say, chàng đã tính bài lảng ra." (TKiều)',
    example:
      'giả bài làm ngơ * đánh bài lờ * "Ngảnh đi, chợt nói, chợt cười, Cáo say, chàng đã tính bài lảng ra." (TKiều)',
  },
  {
    word: "bài",
    part_of_speech: "động từ",
    meaning: "bài tiết (nói tắt): bài phân và nước tiểu",
    example: "bài phân và nước tiểu",
  },
  {
    word: "bài",
    part_of_speech: "động từ",
    meaning: "hoạt động nhằm gạt bỏ: bài hàng lậu",
    example: "bài hàng lậu",
  },
  {
    word: "bái",
    part_of_speech: "động từ",
    meaning: "(Phương ngữ) lạy hoặc vái: chắp tay bái",
    example: "chắp tay bái",
  },
  {
    word: "bai bải",
    part_of_speech: "tính từ",
    meaning:
      '(khẩu ngữ) (nói) không ngớt miệng: cứ bai bải cái mồm * "Gã đã gặng hỏi nhiều lần, người con gái chỉ chối, chối bai bải." (THoài; 33)',
    example:
      'cứ bai bải cái mồm * "Gã đã gặng hỏi nhiều lần, người con gái chỉ chối, chối bai bải." (THoài; 33)',
  },
  {
    word: "bài bạc",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) như cờ bạc: tính ham bài bạc",
    example: "tính ham bài bạc",
  },
  {
    word: "bài bản",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) phương pháp, cách thức tiến hành đúng như trình tự hoặc như những điều đã được hướng dẫn, đã được đúc kết, được xem là hợp lí: làm đúng bài bản",
    example: "làm đúng bài bản",
  },
  {
    word: "bài bản",
    part_of_speech: "tính từ",
    meaning:
      "đúng theo những gì đã được định ra và được xem là hợp lí: được đào tạo rất bài bản * đầu tư tự phát, thiếu bài bản",
    example: "được đào tạo rất bài bản * đầu tư tự phát, thiếu bài bản",
  },
  {
    word: "bãi bể nương dâu",
    part_of_speech: "",
    meaning:
      '(cũ, văn chương) như bể dâu: "Khóc vì nỗi thiết tha sự thế, Ai bày trò bãi bể nương dâu." (CO)',
    example: 'Khóc vì nỗi thiết tha sự thế, Ai bày trò bãi bể nương dâu." (CO)',
  },
  {
    word: "bại",
    part_of_speech: "động từ",
    meaning:
      "(công việc) không đạt được kết quả dự định: chưa biết công việc sẽ thành hay bại",
    example: "chưa biết công việc sẽ thành hay bại",
  },
  {
    word: "bại",
    part_of_speech: "động từ",
    meaning:
      "để cho đối phương giành được phần hơn trong cuộc đọ sức giữa hai bên: người thắng kẻ bại * chuyển bại thành thắng",
    example: "người thắng kẻ bại * chuyển bại thành thắng",
  },
  {
    word: "bại",
    part_of_speech: "tính từ",
    meaning:
      "bị giảm hoặc mất khả năng cử động, do tổn thương thần kinh hoặc cơ: bại cánh tay * bại nửa người",
    example: "bại cánh tay * bại nửa người",
  },
  {
    word: "bại",
    part_of_speech: "tính từ",
    meaning:
      "suy yếu đến mức gần như cạn kiệt (thường nói về sức lực): làm nhiều nên bại sức * khuynh gia bại sản",
    example: "làm nhiều nên bại sức * khuynh gia bại sản",
  },
  {
    word: "bãi",
    part_of_speech: "danh từ",
    meaning:
      "khoảng đất bồi ven sông, ven biển hoặc nổi lên ở giữa dòng nước lớn: bãi phù sa * bãi biển * trồng ngô ngoài bãi giữa sông Hồng",
    example: "bãi phù sa * bãi biển * trồng ngô ngoài bãi giữa sông Hồng",
  },
  {
    word: "bãi",
    part_of_speech: "danh từ",
    meaning:
      "khoảng đất rộng và thường là bằng phẳng, quang đãng, có một đặc điểm riêng nào đó: bãi cỏ * bãi mìn * bãi tha ma * bãi đỗ xe",
    example: "bãi cỏ * bãi mìn * bãi tha ma * bãi đỗ xe",
  },
  {
    word: "bãi",
    part_of_speech: "danh từ",
    meaning:
      "đống chất bẩn, chất thải nhỏ: bãi nước bọt * bãi cốt trầu * bãi phân",
    example: "bãi nước bọt * bãi cốt trầu * bãi phân",
  },
  {
    word: "bãi",
    part_of_speech: "động từ",
    meaning:
      "(cũ) bỏ đi, thôi không dùng hoặc không thi hành nữa: bãi một viên quan * bãi sưu thuế",
    example: "bãi một viên quan * bãi sưu thuế",
  },
  {
    word: "bài bác",
    part_of_speech: "động từ",
    meaning:
      "chê bai nhằm gạt bỏ, phủ nhận: bài bác hủ tục * bài bác hành vi vô nhân đạo",
    example: "bài bác hủ tục * bài bác hành vi vô nhân đạo",
  },
  {
    word: "bãi binh",
    part_of_speech: "động từ",
    meaning: "(cũ) rút quân về, không đánh nhau nữa: bãi binh cầu hoà",
    example: "bãi binh cầu hoà",
  },
  {
    word: "bãi bỏ",
    part_of_speech: "động từ",
    meaning:
      "bỏ đi một cách chính thức, không còn giá trị thi hành nữa: bãi bỏ một đạo luật * lệnh giới nghiêm đã bị bãi bỏ",
    example: "bãi bỏ một đạo luật * lệnh giới nghiêm đã bị bãi bỏ",
  },
  {
    word: "bài bông",
    part_of_speech: "danh từ",
    meaning:
      "điệu múa cổ thường được diễn trong các buổi yến tiệc, đình đám thời trước, người múa (là nữ) xếp thành hàng sáu hoặc bốn, vừa múa vừa hát: múa bài bông",
    example: "múa bài bông",
  },
  {
    word: "bài chòi",
    part_of_speech: "danh từ",
    meaning:
      "lối chơi bài ở miền Nam Trung Bộ ngày trước, người chơi ngồi trong các chòi: đánh bài chòi",
    example: "đánh bài chòi",
  },
  {
    word: "bài chòi",
    part_of_speech: "danh từ",
    meaning:
      "dân ca bắt nguồn từ điệu hô trong cuộc chơi bài chòi: hát bài chòi",
    example: "hát bài chòi",
  },
  {
    word: "bải hoải",
    part_of_speech: "tính từ",
    meaning:
      "mệt mỏi đến mức có cảm giác như các bộ phận của cơ thể rã rời ra: bải hoải chân tay",
    example: "bải hoải chân tay",
  },
  {
    word: "bãi công",
    part_of_speech: "động từ",
    meaning: "(hiếm) như đình công: thợ bãi công đòi tăng lương",
    example: "thợ bãi công đòi tăng lương",
  },
  {
    word: "bại hoại",
    part_of_speech: "tính từ",
    meaning: "(hiếm) đồi bại đến mức mất hết phẩm chất: gia phong bại hoại",
    example: "gia phong bại hoại",
  },
  {
    word: "bải hải",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) (tiếng kêu la) to và thất thanh: la bải hải",
    example: "la bải hải",
  },
  {
    word: "bài học",
    part_of_speech: "danh từ",
    meaning:
      "bài học sinh phải học: bài học lịch sử * nắm vững nội dung bài học",
    example: "bài học lịch sử * nắm vững nội dung bài học",
  },
  {
    word: "bài học",
    part_of_speech: "danh từ",
    meaning:
      "điều có tác dụng giáo dục, kinh nghiệm bổ ích thường được rút ra từ những sai lầm, thất bại: bài học nhớ đời * rút ra bài học kinh nghiệm",
    example: "bài học nhớ đời * rút ra bài học kinh nghiệm",
  },
  {
    word: "bài khoá",
    part_of_speech: "danh từ",
    meaning:
      "bài ngoại ngữ cho học sinh tập đọc và tập vận dụng những quy tắc ngữ pháp được dùng trong đó: đọc bài khoá * dịch bài khoá",
    example: "đọc bài khoá * dịch bài khoá",
  },
  {
    word: "bài làm",
    part_of_speech: "danh từ",
    meaning:
      "bài học sinh làm, trả lời theo đề ra sẵn: chỉ cần viết bài làm, không cần chép đề",
    example: "chỉ cần viết bài làm, không cần chép đề",
  },
  {
    word: "bại liệt",
    part_of_speech: "tính từ",
    meaning:
      "bị giảm nhiều hoặc mất hẳn khả năng cử động, do tổn thương thần kinh hoặc cơ (nói khái quát): bại liệt nửa người * chân bị bại liệt",
    example: "bại liệt nửa người * chân bị bại liệt",
  },
  {
    word: "bại liệt",
    part_of_speech: "danh từ",
    meaning:
      "bệnh lây dễ thành dịch, thường gặp ở trẻ em, do virus làm tổn thương tuỷ sống, khiến một số cơ bị liệt và teo đi, có thể làm chết người: vaccin phòng bại liệt * dịch bại liệt",
    example: "vaccin phòng bại liệt * dịch bại liệt",
  },
  {
    word: "bãi nại",
    part_of_speech: "động từ",
    meaning:
      "thôi, không khiếu nại, kiện cáo nữa: gia đình nạn nhân đã làm đơn xin bãi nại",
    example: "gia đình nạn nhân đã làm đơn xin bãi nại",
  },
  {
    word: "bãi nhiệm",
    part_of_speech: "động từ",
    meaning:
      "(quyết nghị của cơ quan dân cử) bãi bỏ chức vụ (một đại biểu dân cử khi chưa hết nhiệm kì).",
    example: "thủ tướng bị bãi nhiệm",
  },
  {
    word: "bãi miễn",
    part_of_speech: "động từ",
    meaning:
      "(cử tri, cơ quan dân cử) huỷ bỏ tư cách đại biểu (của người đã cử ra trước đây): quyền bãi miễn của cử tri",
    example: "quyền bãi miễn của cử tri",
  },
  {
    word: "bài ngoại",
    part_of_speech: "động từ",
    meaning:
      "chống và gạt bỏ những gì là của nước ngoài: chống xâm lược, nhưng không bài ngoại * tư tưởng bài ngoại",
    example: "chống xâm lược, nhưng không bài ngoại * tư tưởng bài ngoại",
  },
  {
    word: "bài mục",
    part_of_speech: "danh từ",
    meaning:
      "phần tương đối hoàn chỉnh trong toàn bộ chương trình học tập, giảng dạy: bài mục xạ kích",
    example: "bài mục xạ kích",
  },
  {
    word: "bại lộ",
    part_of_speech: "động từ",
    meaning:
      "(việc bí mật) bị có người biết, không còn giấu kín được nữa: mưu mô bị bại lộ",
    example: "mưu mô bị bại lộ",
  },
  {
    word: "bái phục",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) chịu phục với lòng tôn kính: bái phục tài nghệ * chắp tay bái phục",
    example: "bái phục tài nghệ * chắp tay bái phục",
  },
  {
    word: "bại quân",
    part_of_speech: "danh từ",
    meaning: "như bại binh: bại quân tháo chạy",
    example: "bại quân tháo chạy",
  },
  {
    word: "bài tập",
    part_of_speech: "danh từ",
    meaning:
      "bài ra cho học sinh làm để tập vận dụng những điều đã học: làm bài tập đại số * ra bài tập về nhà",
    example: "làm bài tập đại số * ra bài tập về nhà",
  },
  {
    word: "bài tập",
    part_of_speech: "danh từ",
    meaning:
      "nội dung tập luyện về thể dục thể thao, bao gồm một số động tác nhất định: bài tập dưỡng sinh",
    example: "bài tập dưỡng sinh",
  },
  {
    word: "bài tây",
    part_of_speech: "danh từ",
    meaning: "(cũ, khẩu ngữ) cỗ bài tú lơ khơ: bộ bài tây * bói bài tây",
    example: "bộ bài tây * bói bài tây",
  },
  {
    word: "bài thuốc",
    part_of_speech: "danh từ",
    meaning:
      "việc sử dụng các vị thuốc bắc hoặc thuốc nam theo tỉ lệ nhất định để chữa một chứng bệnh cụ thể nào đó: bài thuốc nam * bài thuốc gia truyền",
    example: "bài thuốc nam * bài thuốc gia truyền",
  },
  {
    word: "bài toán",
    part_of_speech: "danh từ",
    meaning:
      "vấn đề cần phải giải quyết, tìm ra đáp số bằng quy tắc, định lí: bài toán hoá học * một bài toán khó",
    example: "bài toán hoá học * một bài toán khó",
  },
  {
    word: "bài tiết",
    part_of_speech: "động từ",
    meaning: "thải ra ngoài cơ thể (những chất thừa): bài tiết mồ hôi",
    example: "bài tiết mồ hôi",
  },
  {
    word: "bài trí",
    part_of_speech: "động từ",
    meaning:
      "sắp đặt cho đẹp mắt theo yêu cầu trang trí: căn phòng bài trí rất sơ sài * bài trí sân khấu",
    example: "căn phòng bài trí rất sơ sài * bài trí sân khấu",
  },
  {
    word: "bại trận",
    part_of_speech: "động từ",
    meaning: "bị đánh bại trên chiến trường: đám tàn quân bại trận",
    example: "đám tàn quân bại trận",
  },
  {
    word: "bái tổ",
    part_of_speech: "động từ",
    meaning:
      "(cũ) làm lễ cúng để tạ ơn tổ tiên sau khi đỗ cao hay được phong chức tước, thời phong kiến: vinh quy bái tổ",
    example: "vinh quy bái tổ",
  },
  {
    word: "bài trừ",
    part_of_speech: "động từ",
    meaning:
      "gạt bỏ, loại trừ ra khỏi đời sống xã hội: bài trừ hủ tục * bài trừ nạn mê tín, dị đoan",
    example: "bài trừ hủ tục * bài trừ nạn mê tín, dị đoan",
  },
  {
    word: "bãi trường",
    part_of_speech: "động từ",
    meaning:
      "(cũ) bị (cơ quan chức năng) bắt buộc phải đóng cửa trường học vì một lí do nào đó: có lệnh bãi trường",
    example: "có lệnh bãi trường",
  },
  {
    word: "bái vật giáo",
    part_of_speech: "danh từ",
    meaning: "hình thức tôn giáo nguyên thuỷ, thờ một số bái vật.",
    example: "bái vật giáo hàng ngoại",
  },
  {
    word: "bái vật",
    part_of_speech: "danh từ",
    meaning:
      "vật (như hòn đá, gốc cây, mũi tên, v.v.) được người nguyên thuỷ tin là có quyền lực siêu nhiên: tục thờ bái vật của người xưa",
    example: "tục thờ bái vật của người xưa",
  },
  {
    word: "bài vở",
    part_of_speech: "danh từ",
    meaning:
      "bài giảng, bài học hoặc bài làm (nói khái quát): chuẩn bị bài vở lên lớp * lo làm bài vở",
    example: "chuẩn bị bài vở lên lớp * lo làm bài vở",
  },
  {
    word: "bài vở",
    part_of_speech: "danh từ",
    meaning: "bài viết nói chung (thường để đăng báo): gửi bài vở về toà soạn",
    example: "gửi bài vở về toà soạn",
  },
  {
    word: "bại vong",
    part_of_speech: "động từ",
    meaning: "bị đánh bại và bị tiêu diệt hoàn toàn: nạn bại vong",
    example: "nạn bại vong",
  },
  {
    word: "bài xích",
    part_of_speech: "động từ",
    meaning:
      "chống đối kịch liệt nhằm gạt bỏ khỏi đời sống xã hội: bài xích hủ tục * phái thủ cựu bài xích những tư tưởng mới",
    example: "bài xích hủ tục * phái thủ cựu bài xích những tư tưởng mới",
  },
  {
    word: "bái xái",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) (thua) liểng xiểng: chạy bái xái",
    example: "chạy bái xái",
  },
  {
    word: "bái yết",
    part_of_speech: "động từ",
    meaning: "(cũ) yết kiến theo lễ nghi: vào triều bái yết vua",
    example: "vào triều bái yết vua",
  },
  {
    word: "bám càng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đi theo, nhờ vào người khác nhằm hưởng lợi (hàm ý chê): đi bám càng",
    example: "đi bám càng",
  },
  {
    word: "bám",
    part_of_speech: "động từ",
    meaning:
      "tự giữ chặt vào hoặc dính chặt vào cho không rời ra khỏi: bám vào cành cây đu người lên * quần áo bám đầy bụi * bám dai như đỉa",
    example:
      "bám vào cành cây đu người lên * quần áo bám đầy bụi * bám dai như đỉa",
  },
  {
    word: "bám",
    part_of_speech: "động từ",
    meaning:
      "không lìa, không rời một chút nào cả: người sau đi bám gót người trước * bám sát để theo dõi",
    example: "người sau đi bám gót người trước * bám sát để theo dõi",
  },
  {
    word: "bám",
    part_of_speech: "động từ",
    meaning:
      "dựa vào để tồn tại, để bấu víu: không chịu lao động, sống bám vào cha mẹ",
    example: "không chịu lao động, sống bám vào cha mẹ",
  },
  {
    word: "bám trụ",
    part_of_speech: "động từ",
    meaning:
      "bám lại, trụ lại ở một nơi nào đó, thường là nơi khó khăn, nguy hiểm, để thực hiện cho bằng được mục đích hay công việc gì: bám trụ trong lòng địch để hoạt động",
    example: "bám trụ trong lòng địch để hoạt động",
  },
  {
    word: "bạn",
    part_of_speech: "danh từ",
    meaning:
      "người quen biết và có quan hệ gần gũi, thân thiện với nhau: đôi bạn thân * chọn bạn mà chơi * bạn học * bạn chiến đấu",
    example: "đôi bạn thân * chọn bạn mà chơi * bạn học * bạn chiến đấu",
  },
  {
    word: "bạn",
    part_of_speech: "danh từ",
    meaning: "người đồng tình, ủng hộ: bạn đồng minh * thêm bạn bớt thù",
    example: "bạn đồng minh * thêm bạn bớt thù",
  },
  {
    word: "bạn",
    part_of_speech: "danh từ",
    meaning: "đơn vị, tổ chức có quan hệ gần gũi: đội bạn * nước bạn",
    example: "đội bạn * nước bạn",
  },
  {
    word: "bạn",
    part_of_speech: "động từ",
    meaning:
      '(Khẩu ngữ) kết bạn (nói tắt): bạn với người tốt * "Thợ cấy bạn với thợ cày, Để cho thợ mạ khóc ngày khóc đêm." (Cdao)',
    example:
      'bạn với người tốt * "Thợ cấy bạn với thợ cày, Để cho thợ mạ khóc ngày khóc đêm." (Cdao)',
  },
  {
    word: "bám víu",
    part_of_speech: "động từ",
    meaning: "(hiếm) như bấu víu: không nơi bám víu",
    example: "không nơi bám víu",
  },
  {
    word: "ban",
    part_of_speech: "danh từ",
    meaning:
      "nốt đỏ bất thường nổi thành từng mảng trên da, thường thấy khi mắc một số bệnh: sốt phát ban",
    example: "sốt phát ban",
  },
  {
    word: "ban",
    part_of_speech: "danh từ",
    meaning:
      "(Từ cũ) hàng quan lại trong triều đình phong kiến, chia theo văn, võ (hoặc tả, hữu) và phân theo hạng bậc: hai ban văn võ",
    example: "hai ban văn võ",
  },
  {
    word: "ban",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức gồm một nhóm người được lập ra để cùng làm một công việc: ban cán sự lớp * ban nhạc * ban giám khảo * ban quản trị",
    example: "ban cán sự lớp * ban nhạc * ban giám khảo * ban quản trị",
  },
  {
    word: "ban",
    part_of_speech: "danh từ",
    meaning:
      "phiên làm việc để bảo đảm công tác liên tục: họp giao ban hàng tuần * trực ban",
    example: "họp giao ban hàng tuần * trực ban",
  },
  {
    word: "ban",
    part_of_speech: "danh từ",
    meaning:
      "(Từ cũ) cấp học hoặc ngành học chuyên về một số môn nhất định trong nhà trường: tốt nghiệp ban văn sử",
    example: "tốt nghiệp ban văn sử",
  },
  {
    word: "ban",
    part_of_speech: "danh từ",
    meaning:
      'khoảng thời gian tương đối ngắn không xác định rõ, thường là một phần nào đó của ngày: đi từ ban sáng * "Cày đồng đang buổi ban trưa, Mồ hôi thánh thót như mưa ruộng cày." (Cdao)',
    example:
      'đi từ ban sáng * "Cày đồng đang buổi ban trưa, Mồ hôi thánh thót như mưa ruộng cày." (Cdao)',
  },
  {
    word: "ban",
    part_of_speech: "động từ",
    meaning: "(Phương ngữ) san cho bằng: ban mô đất",
    example: "ban mô đất",
  },
  {
    word: "ban",
    part_of_speech: "động từ",
    meaning:
      "(cũ (Trang trọng) cho, cấp cho người dưới: ban thưởng * được vua ban cho ruộng đất",
    example: "ban thưởng * được vua ban cho ruộng đất",
  },
  {
    word: "ban",
    part_of_speech: "động từ",
    meaning: "truyền cho mọi người biết: vua ban chiếu chỉ",
    example: "vua ban chiếu chỉ",
  },
  {
    word: "bán",
    part_of_speech: "động từ",
    meaning:
      'đổi hàng hoá để lấy tiền: bán sức lao động * mua rẻ bán đắt * "Cách sông nên phải luỵ đò, Tối trời nên phải luỵ o bán dầu." (ca dao)',
    example:
      'bán sức lao động * mua rẻ bán đắt * "Cách sông nên phải luỵ đò, Tối trời nên phải luỵ o bán dầu." (ca dao)',
  },
  {
    word: "bán",
    part_of_speech: "động từ",
    meaning:
      "trao cho kẻ khác (cái quý giá về tinh thần) để mưu lợi riêng: bè lũ bán nước * bán rẻ lương tâm",
    example: "bè lũ bán nước * bán rẻ lương tâm",
  },
  {
    word: "bạn bầy",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, hiếm) như bạn bè: "Ba sinh đã phỉ mười nguyền, Duyên đôi lứa cũng là duyên bạn bầy." (TKiều)',
    example:
      'Ba sinh đã phỉ mười nguyền, Duyên đôi lứa cũng là duyên bạn bầy." (TKiều)',
  },
  {
    word: "bàn",
    part_of_speech: "danh từ",
    meaning:
      "đồ thường làm bằng gỗ, có mặt phẳng và chân đỡ, dùng để bày đồ đạc hay để làm việc, làm nơi ăn uống, v.v.: bàn học * bàn ăn * tì tay xuống mặt bàn",
    example: "bàn học * bàn ăn * tì tay xuống mặt bàn",
  },
  {
    word: "bàn",
    part_of_speech: "danh từ",
    meaning:
      "lần tính được, thua trong trận đấu bóng: một bàn thắng đẹp * thua hai bàn * có duyên làm bàn",
    example: "một bàn thắng đẹp * thua hai bàn * có duyên làm bàn",
  },
  {
    word: "bàn",
    part_of_speech: "động từ",
    meaning:
      "trao đổi ý kiến về việc gì hoặc vấn đề gì: bàn kế hoạch * bàn chuyện thời sự * chuyện đó thì khỏi phải bàn!",
    example: "bàn kế hoạch * bàn chuyện thời sự * chuyện đó thì khỏi phải bàn!",
  },
  {
    word: "bàn bạc",
    part_of_speech: "động từ",
    meaning: "bàn, trao đổi ý kiến (nói khái quát): bàn bạc công việc",
    example: "bàn bạc công việc",
  },
  {
    word: "ban bệ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) các ban lập ra để làm công việc gì đó (nói khái quát; thường hàm ý chê bai): đủ các ban bệ * lắm ban bệ!",
    example: "đủ các ban bệ * lắm ban bệ!",
  },
  {
    word: "bản án",
    part_of_speech: "danh từ",
    meaning:
      "quyết định bằng văn bản của toà án sau khi xử án: thi hành bản án * bản án tử hình",
    example: "thi hành bản án * bản án tử hình",
  },
  {
    word: "bản",
    part_of_speech: "danh từ",
    meaning:
      "bề ngang (thường nói về vật hình tấm nhỏ): chiếc thắt lưng rộng bản",
    example: "chiếc thắt lưng rộng bản",
  },
  {
    word: "bản",
    part_of_speech: "danh từ",
    meaning:
      "tờ giấy, tập giấy có chữ hoặc hình vẽ mang một nội dung nhất định: bản tin * bản vẽ * bản nháp",
    example: "bản tin * bản vẽ * bản nháp",
  },
  {
    word: "bản",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị những tờ, tập, cuốn có chữ hoặc tranh ảnh, được tạo ra theo một mẫu nhất định: in một vạn bản * đánh máy ba bản",
    example: "in một vạn bản * đánh máy ba bản",
  },
  {
    word: "bạn bè",
    part_of_speech: "danh từ",
    meaning:
      "bạn (nói khái quát): đối xử tốt với bạn bè * hai người là chỗ bạn bè thân thiết",
    example: "đối xử tốt với bạn bè * hai người là chỗ bạn bè thân thiết",
  },
  {
    word: "bạn bè",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) kết bạn: không bạn bè gì với nó! * bạn bè với toàn hạng du đãng",
    example: "không bạn bè gì với nó! * bạn bè với toàn hạng du đãng",
  },
  {
    word: "bán buôn",
    part_of_speech: "động từ",
    meaning:
      "bán với số lượng nhiều cho người kinh doanh trung gian; phân biệt với bán lẻ: giá bán buôn",
    example: "giá bán buôn",
  },
  {
    word: "bán buôn",
    part_of_speech: "động từ",
    meaning:
      '(Từ cũ) như buôn bán: "Thấy nàng mặt phấn tươi son, Mừng thầm được mối bán buôn có lời." (TKiều)',
    example:
      'Thấy nàng mặt phấn tươi son, Mừng thầm được mối bán buôn có lời." (TKiều)',
  },
  {
    word: "ban bố",
    part_of_speech: "động từ",
    meaning:
      "ban hành và công bố để mọi người biết và thực hiện: ban bố lệnh đại xá",
    example: "ban bố lệnh đại xá",
  },
  {
    word: "bàn cãi",
    part_of_speech: "động từ",
    meaning:
      "trao đổi qua lại những ý kiến trái ngược nhau về việc gì, vấn đề gì: bàn cãi cho ra lẽ * quyết định như vậy, không bàn cãi gì nữa",
    example: "bàn cãi cho ra lẽ * quyết định như vậy, không bàn cãi gì nữa",
  },
  {
    word: "bán chác",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bán hàng hoá (nói khái quát; thường hàm ý coi thường): trời mưa, chẳng bán chác được gì!",
    example: "trời mưa, chẳng bán chác được gì!",
  },
  {
    word: "bán cầu",
    part_of_speech: "danh từ",
    meaning: "nửa hình cầu: hình bán cầu",
    example: "hình bán cầu",
  },
  {
    word: "bán chạy",
    part_of_speech: "động từ",
    meaning:
      "bán được nhiều và nhanh, do có nhiều người mua: album nhạc bán chạy nhất trong năm * sách bán chạy",
    example: "album nhạc bán chạy nhất trong năm * sách bán chạy",
  },
  {
    word: "bàn chải",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng để chải, cọ cho sạch, gồm nhiều hàng sợi nhỏ và dai cắm trên một mặt phẳng: bàn chải đánh răng * dùng bàn chải để giặt chiếu",
    example: "bàn chải đánh răng * dùng bàn chải để giặt chiếu",
  },
  {
    word: "bản chính",
    part_of_speech: "danh từ",
    meaning:
      "bản xuất hiện đầu tiên, là cơ sở để sửa chữa hoặc để lập ra các bản sao: bản gốc giấy khai sinh",
    example: "bản gốc giấy khai sinh",
  },
  {
    word: "bạn con dì",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) anh em, chị em con dì con già: anh em bạn con dì",
    example: "anh em bạn con dì",
  },
  {
    word: "bản chất",
    part_of_speech: "danh từ",
    meaning:
      "tổng thể những quan hệ bên trong của sự vật, quyết định tính chất và sự phát triển của sự vật; phân biệt với hiện tượng: phân biệt bản chất với hiện tượng",
    example: "phân biệt bản chất với hiện tượng",
  },
  {
    word: "bản chất",
    part_of_speech: "danh từ",
    meaning: "như bản tính: bản chất hiền lành",
    example: "bản chất hiền lành",
  },
  {
    word: "bàn chông",
    part_of_speech: "danh từ",
    meaning: "tấm gỗ, tre hoặc sắt có cắm chông: làm bàn chông bẫy thú",
    example: "làm bàn chông bẫy thú",
  },
  {
    word: "bán công",
    part_of_speech: "tính từ",
    meaning:
      "(trường học, bệnh viện) nửa quốc lập, nửa dân lập: trường tiểu học bán công",
    example: "trường tiểu học bán công",
  },
  {
    word: "bán chịu",
    part_of_speech: "động từ",
    meaning:
      "bán hàng nhưng chưa lấy tiền ngay, người mua nhận hàng rồi sau một thời gian mới phải trả tiền: không bán chịu",
    example: "không bán chịu",
  },
  {
    word: "bán công khai",
    part_of_speech: "tính từ",
    meaning:
      "(tổ chức, hoạt động) nửa công khai, nửa bí mật: tổ chức hoạt động bán công khai",
    example: "tổ chức hoạt động bán công khai",
  },
  {
    word: "ban công",
    part_of_speech: "danh từ",
    meaning:
      "phần sân gác nhô ra ngoài nhà, xung quanh có lan can, có cửa thông vào phòng: ra ban công hóng mát",
    example: "ra ban công hóng mát",
  },
  {
    word: "bàn cờ",
    part_of_speech: "danh từ",
    meaning: "mặt phẳng hình vuông có kẻ ô để bày quân cờ.",
    example:
      'ruộng bàn cờ * "Phồn hoa thứ nhất Long Thành, Phố giăng mắc cửi, đường quanh bàn cờ." (ca dao)',
  },
  {
    word: "bàn cuốc",
    part_of_speech: "tính từ",
    meaning:
      "(răng, bàn chân) có hình to bè ra và thô, tựa như hình cái bàn cuốc: răng bàn cuốc * chân bàn cuốc",
    example: "răng bàn cuốc * chân bàn cuốc",
  },
  {
    word: "bán dẫn",
    part_of_speech: "tính từ",
    meaning:
      "(máy, thiết bị) dùng transistor thay cho đèn điện tử: đài bán dẫn * linh kiện bán dẫn",
    example: "đài bán dẫn * linh kiện bán dẫn",
  },
  {
    word: "bàn dân thiên hạ",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tất cả mọi người hoặc tất cả mọi nơi: đi khắp bàn dân thiên hạ * nói cho cả bàn dân thiên hạ biết!",
    example: "đi khắp bàn dân thiên hạ * nói cho cả bàn dân thiên hạ biết!",
  },
  {
    word: "bán đấu giá",
    part_of_speech: "động từ",
    meaning:
      "bán bằng hình thức để cho người mua trả giá công khai, ai trả giá cao nhất thì được mua: bán đấu giá quyền sử dụng đất",
    example: "bán đấu giá quyền sử dụng đất",
  },
  {
    word: "bán đảo",
    part_of_speech: "danh từ",
    meaning:
      "vùng đất lớn ba mặt giáp biển, một mặt liền với đại lục: bán đảo Đông Dương",
    example: "bán đảo Đông Dương",
  },
  {
    word: "ban đầu",
    part_of_speech: "danh từ",
    meaning:
      "lúc mới bắt đầu, buổi đầu: ý định ban đầu * ban đầu cũng gặp nhiều khó khăn",
    example: "ý định ban đầu * ban đầu cũng gặp nhiều khó khăn",
  },
  {
    word: "bàn đèn",
    part_of_speech: "danh từ",
    meaning:
      "khay đặt đồ hút thuốc phiện; đồ dùng để hút thuốc phiện (nói khái quát): bàn đèn thuốc phiện",
    example: "bàn đèn thuốc phiện",
  },
  {
    word: "bàn đạp",
    part_of_speech: "danh từ",
    meaning:
      "vòng nhỏ bằng sắt buông từ yên xuống hai bên mình ngựa, để người cưỡi đặt chân vào.",
    example: "bàn đạp máy khâu * bàn đạp xe đạp",
  },
  {
    word: "bàn đạp",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận của máy, của xe trực tiếp chịu sức ấn của bàn chân để tạo chuyển động: bàn đạp máy khâu * bàn đạp xe đạp",
    example: "vùng bàn đạp",
  },
  {
    word: "dầm dề",
    part_of_speech: "tính từ",
    meaning:
      "thấm nước nhiều và ướt khắp cả: nước mắt dầm dề * gặp mưa, người ướt dầm dề",
    example: "nước mắt dầm dề * gặp mưa, người ướt dầm dề",
  },
  {
    word: "dầm dề",
    part_of_speech: "tính từ",
    meaning: "kéo dài liên miên: ốm dầm dề cả tháng * mưa dầm dề",
    example: "ốm dầm dề cả tháng * mưa dầm dề",
  },
  {
    word: "dấm dúi",
    part_of_speech: "tính từ",
    meaning: "lén lút: làm ăn dấm dúi * hai người vẫn dấm dúi đi lại với nhau",
    example: "làm ăn dấm dúi * hai người vẫn dấm dúi đi lại với nhau",
  },
  {
    word: "dâm dục",
    part_of_speech: "tính từ",
    meaning:
      "có tính ham muốn thú nhục dục quá mức hoặc không chính đáng: lòng dâm dục",
    example: "lòng dâm dục",
  },
  {
    word: "dậm doạ",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) như doạ dẫm: nói bằng giọng dậm doạ",
    example: "nói bằng giọng dậm doạ",
  },
  {
    word: "dấm dớ",
    part_of_speech: "",
    meaning: "(khẩu ngữ) như ấm ớ: đúng là cái đồ dấm dớ!",
    example: "đúng là cái đồ dấm dớ!",
  },
  {
    word: "dâm đãng",
    part_of_speech: "tính từ",
    meaning:
      "luôn muốn thoả mãn nhục dục một cách bừa bãi: thói lẳng lơ dâm đãng",
    example: "thói lẳng lơ dâm đãng",
  },
  {
    word: "dấm dứ",
    part_of_speech: "động từ",
    meaning:
      "có cử chỉ như chuẩn bị làm một động tác nào đó: giơ tay lên dấm dứ doạ đánh * dấm dứ mãi không dám vào",
    example: "giơ tay lên dấm dứ doạ đánh * dấm dứ mãi không dám vào",
  },
  {
    word: "dân",
    part_of_speech: "danh từ",
    meaning:
      "người sống trong một khu vực địa lí hoặc hành chính (nói tổng quát): dân giàu nước mạnh * Hà Nội là một thành phố đông dân",
    example: "dân giàu nước mạnh * Hà Nội là một thành phố đông dân",
  },
  {
    word: "dân",
    part_of_speech: "danh từ",
    meaning:
      "người thường thuộc lớp quần chúng đông đảo (nói tổng quát): tình quân dân * lấy dân làm gốc",
    example: "tình quân dân * lấy dân làm gốc",
  },
  {
    word: "dân",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) người thuộc một địa phương, về mặt có những đặc trưng riêng: dân Nam Bộ * dân Hà Nội chính gốc",
    example: "dân Nam Bộ * dân Hà Nội chính gốc",
  },
  {
    word: "dân",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) người cùng nghề nghiệp, hoàn cảnh, v.v. làm thành một tầng lớp riêng (nói tổng quát): dân buôn * dân ngụ cư * dân nghệ sĩ",
    example: "dân buôn * dân ngụ cư * dân nghệ sĩ",
  },
  {
    word: "dâm ô",
    part_of_speech: "tính từ",
    meaning: "dâm dục một cách xấu xa, nhơ nhuốc: kẻ dâm ô",
    example: "kẻ dâm ô",
  },
  {
    word: "dần",
    part_of_speech: "động từ",
    meaning:
      "đập liên tiếp nhiều lần, thường bằng sống dao, cho dập, cho mềm ra: dần miếng thịt bò cho mềm * ruột đau như dần",
    example: "dần miếng thịt bò cho mềm * ruột đau như dần",
  },
  {
    word: "dần",
    part_of_speech: "động từ",
    meaning: "(Khẩu ngữ) đánh đau: bị dần cho một trận",
    example: "bị dần cho một trận",
  },
  {
    word: "dần",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị cách thức diễn ra từ từ từng ít một của quá trình, của sự việc: mưa tạnh dần * trời tối dần * nhích dần từng bước",
    example: "mưa tạnh dần * trời tối dần * nhích dần từng bước",
  },
  {
    word: "dẫn",
    part_of_speech: "động từ",
    meaning:
      "cùng đi để đưa đến nơi nào đó: dẫn con đi chơi * đi trước để dẫn đường",
    example: "dẫn con đi chơi * đi trước để dẫn đường",
  },
  {
    word: "dẫn",
    part_of_speech: "động từ",
    meaning:
      "làm cho di chuyển theo một đường, một hướng nào đó: cầu thủ dẫn bóng * ống dẫn dầu * con đường dẫn ra bờ sông",
    example: "cầu thủ dẫn bóng * ống dẫn dầu * con đường dẫn ra bờ sông",
  },
  {
    word: "dẫn",
    part_of_speech: "động từ",
    meaning:
      "đưa lễ vật đi đến nơi nào đó theo nghi thức nhất định trong các cuộc tế lễ, cưới xin: dẫn lễ vật sang nhà gái",
    example: "dẫn lễ vật sang nhà gái",
  },
  {
    word: "dẫn",
    part_of_speech: "động từ",
    meaning:
      "đưa ra lời nào đó kèm theo sau lời của bản thân mình để làm bằng, để chứng minh: dẫn nhiều thí dụ * sách đã dẫn",
    example: "dẫn nhiều thí dụ * sách đã dẫn",
  },
  {
    word: "dẫn",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) dẫn điểm (nói tắt): đội nhà đang dẫn trước với tỉ số 3 - 2",
    example: "đội nhà đang dẫn trước với tỉ số 3 - 2",
  },
  {
    word: "dấn",
    part_of_speech: "động từ",
    meaning:
      "dồn sức thêm để cố đạt cho được: đạp dấn lên cho nhanh * dấn bước",
    example: "đạp dấn lên cho nhanh * dấn bước",
  },
  {
    word: "dấn",
    part_of_speech: "động từ",
    meaning:
      "tiến mạnh, vươn mạnh tới, bất chấp nguy hiểm: ngày càng dấn sâu vào con đường tội lỗi",
    example: "ngày càng dấn sâu vào con đường tội lỗi",
  },
  {
    word: "dấn",
    part_of_speech: "động từ",
    meaning:
      "(cũng giấn) dùng tay ấn xuống, đè mạnh xuống: dấn đầu xuống mà đánh * dấn quần áo bẩn vào chậu nước",
    example: "dấn đầu xuống mà đánh * dấn quần áo bẩn vào chậu nước",
  },
  {
    word: "dận",
    part_of_speech: "động từ",
    meaning:
      "dùng bàn chân đè mạnh xuống: dận gót giày * chân dận mạnh xuống bàn đạp",
    example: "dận gót giày * chân dận mạnh xuống bàn đạp",
  },
  {
    word: "dận",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ, hiếm) mang (giày dép) ở chân: dận đôi giày tây bóng loáng",
    example: "dận đôi giày tây bóng loáng",
  },
  {
    word: "dân chủ",
    part_of_speech: "danh từ",
    meaning:
      "chế độ dân chủ hoặc quyền dân chủ (nói tắt): nhà nước dân chủ * đấu tranh đòi dân chủ * phát huy dân chủ",
    example: "nhà nước dân chủ * đấu tranh đòi dân chủ * phát huy dân chủ",
  },
  {
    word: "dân chủ",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất của chế độ dân chủ, toàn dân có quyền tham dự việc nước hoặc tự do phát biểu ý kiến về việc nước: quyền tự do dân chủ",
    example: "quyền tự do dân chủ",
  },
  {
    word: "dân chủ",
    part_of_speech: "tính từ",
    meaning:
      "(phương thức công tác) tôn trọng quyền tự do dân chủ, không quan liêu độc đoán: tác phong dân chủ * thảo luận trên tinh thần dân chủ",
    example: "tác phong dân chủ * thảo luận trên tinh thần dân chủ",
  },
  {
    word: "dâm phụ",
    part_of_speech: "danh từ",
    meaning: "(cũ) người đàn bà ngoại tình (ý coi khinh): cặp gian phu dâm phụ",
    example: "cặp gian phu dâm phụ",
  },
  {
    word: "dân ca",
    part_of_speech: "danh từ",
    meaning:
      "bài hát lưu truyền trong dân gian, mang đặc trưng của từng vùng và thường không rõ tác giả: dân ca Nam Bộ * hát dân ca",
    example: "dân ca Nam Bộ * hát dân ca",
  },
  {
    word: "dân chính",
    part_of_speech: "danh từ",
    meaning:
      "công việc hành chính nhằm thực hiện các chính sách, chế độ liên quan đến đời sống của người dân: cơ quan dân chính",
    example: "cơ quan dân chính",
  },
  {
    word: "dân chủ hoá",
    part_of_speech: "động từ",
    meaning:
      "làm cho trở thành có tính chất dân chủ: dân chủ hoá việc quản lí quy hoạch",
    example: "dân chủ hoá việc quản lí quy hoạch",
  },
  {
    word: "dân chơi",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) người biết thưởng thức, sành sỏi trong các thú tiêu khiển nói chung: một dân chơi có tiếng trong giới sưu tầm đồ cổ",
    example: "một dân chơi có tiếng trong giới sưu tầm đồ cổ",
  },
  {
    word: "dân chơi",
    part_of_speech: "danh từ",
    meaning:
      "người ăn chơi, chơi bời sành sỏi nói chung (hàm ý chê): dân chơi thứ thiệt * nơi tụ tập của đám dân chơi",
    example: "dân chơi thứ thiệt * nơi tụ tập của đám dân chơi",
  },
  {
    word: "dẫn chương trình",
    part_of_speech: "động từ",
    meaning:
      "giới thiệu và điều khiển một chương trình biểu diễn nghệ thuật, giao lưu văn hoá, trò chơi, v.v.: dẫn chương trình truyền hình * người dẫn chương trình",
    example: "dẫn chương trình truyền hình * người dẫn chương trình",
  },
  {
    word: "dân chúng",
    part_of_speech: "danh từ",
    meaning: "quần chúng nhân dân (nói tổng quát): được dân chúng hoan nghênh",
    example: "được dân chúng hoan nghênh",
  },
  {
    word: "dân cử",
    part_of_speech: "tính từ",
    meaning: "do nhân dân bầu cử ra: cơ quan dân cử",
    example: "cơ quan dân cử",
  },
  {
    word: "dẫn chứng",
    part_of_speech: "động từ",
    meaning:
      "dẫn thí dụ hoặc tài liệu làm bằng chứng: kể ra một câu chuyện để dẫn chứng",
    example: "kể ra một câu chuyện để dẫn chứng",
  },
  {
    word: "dẫn chứng",
    part_of_speech: "danh từ",
    meaning:
      "tài liệu, sự kiện được đưa ra làm bằng chứng: đưa hàng loạt dẫn chứng để minh hoạ",
    example: "đưa hàng loạt dẫn chứng để minh hoạ",
  },
  {
    word: "dần dà",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị cách thức diễn biến, phát triển dần dần từng bước một (của một quá trình, một sự việc): việc đó để dần dà sẽ tính * trước còn lạ, dần dà rồi cũng quen",
    example: "việc đó để dần dà sẽ tính * trước còn lạ, dần dà rồi cũng quen",
  },
  {
    word: "dân dã",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, hiếm) người dân thôn quê (nói khái quát): "Bẩm rằng: Dân dã chúng tôi, Tấm lòng xin ngỏ, chút lời xin thưa." (NĐM)',
    example:
      'Bẩm rằng: Dân dã chúng tôi, Tấm lòng xin ngỏ, chút lời xin thưa." (NĐM)',
  },
  {
    word: "dân dã",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất mộc mạc, chất phác của người dân quê, của nơi thôn dã: món ăn dân dã",
    example: "món ăn dân dã",
  },
  {
    word: "dẫn đầu",
    part_of_speech: "động từ",
    meaning:
      "đi đầu một đội ngũ, một phong trào hay một cuộc thi đấu: bứt lên, dẫn đầu đoàn đua * đội bóng vẫn dẫn đầu bảng",
    example: "bứt lên, dẫn đầu đoàn đua * đội bóng vẫn dẫn đầu bảng",
  },
  {
    word: "dẫn đầu",
    part_of_speech: "động từ",
    meaning: "đứng đầu một đoàn đại biểu: đoàn đại biểu do thủ tướng dẫn đầu",
    example: "đoàn đại biểu do thủ tướng dẫn đầu",
  },
  {
    word: "dẫn dắt",
    part_of_speech: "động từ",
    meaning:
      "dẫn, chỉ dẫn để đi cho đúng hướng hay để đạt mục tiêu, kế hoạch đã đặt ra: dẫn dắt từng đường đi nước bước * dẫn dắt đội bóng đến thành công",
    example:
      "dẫn dắt từng đường đi nước bước * dẫn dắt đội bóng đến thành công",
  },
  {
    word: "dân cư",
    part_of_speech: "danh từ",
    meaning:
      "cư dân trong một vùng (nói tổng quát): dân cư thưa thớt * khu vực đông dân cư",
    example: "dân cư thưa thớt * khu vực đông dân cư",
  },
  {
    word: "dân doanh",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như tư doanh: phát triển khu vực kinh tế dân doanh",
    example: "phát triển khu vực kinh tế dân doanh",
  },
  {
    word: "dần dần",
    part_of_speech: "phụ từ",
    meaning:
      "như dần dà (nhưng thường chỉ trong một thời gian ngắn): người bệnh dần dần tỉnh lại * dần dần mới hiểu ra",
    example: "người bệnh dần dần tỉnh lại * dần dần mới hiểu ra",
  },
  {
    word: "dân dụng",
    part_of_speech: "tính từ",
    meaning:
      "dùng cho nhu cầu của nhân dân; phân biệt với quân dụng: mặt hàng dân dụng * máy bay dân dụng",
    example: "mặt hàng dân dụng * máy bay dân dụng",
  },
  {
    word: "dẫn điện",
    part_of_speech: "động từ",
    meaning: "để cho dòng điện đi qua: kim loại có tính dẫn điện",
    example: "kim loại có tính dẫn điện",
  },
  {
    word: "dẫn độ",
    part_of_speech: "động từ",
    meaning:
      "đưa người nước ngoài phạm tội tại nước sở tại giao cho cơ quan tư pháp của nước ngoài đó để xét xử theo hiệp ước mà hai nước đã kí: hiệp ước dẫn độ quốc tế",
    example: "hiệp ước dẫn độ quốc tế",
  },
  {
    word: "dẫn giải",
    part_of_speech: "động từ",
    meaning: "chỉ dẫn và giải thích chỗ khó hiểu: dẫn giải dài dòng",
    example: "dẫn giải dài dòng",
  },
  {
    word: "dẫn giải",
    part_of_speech: "động từ",
    meaning: "(hiếm) giải đi: dẫn giải phạm nhân đến nơi giam giữ mới",
    example: "dẫn giải phạm nhân đến nơi giam giữ mới",
  },
  {
    word: "dẫn hoả",
    part_of_speech: "động từ",
    meaning:
      "bắt lửa và truyền lửa cho cháy lan tới mục tiêu đã định: dùng con cúi làm chất dẫn hoả",
    example: "dùng con cúi làm chất dẫn hoả",
  },
  {
    word: "dẫn điểm",
    part_of_speech: "động từ",
    meaning:
      "đạt được số điểm cao hơn đối phương trong quá trình thi đấu tính điểm: đội bóng tỉnh nhà đang dẫn điểm",
    example: "đội bóng tỉnh nhà đang dẫn điểm",
  },
  {
    word: "dân làng",
    part_of_speech: "danh từ",
    meaning:
      "những người cùng làng, cùng xã (nói tổng quát): bà con dân làng * bị dân làng chê cười",
    example: "bà con dân làng * bị dân làng chê cười",
  },
  {
    word: "dân gian",
    part_of_speech: "danh từ",
    meaning:
      "đông đảo những người dân thường trong xã hội: dân gian đói khổ * câu chuyện còn lưu truyền trong dân gian",
    example: "dân gian đói khổ * câu chuyện còn lưu truyền trong dân gian",
  },
  {
    word: "dân gian",
    part_of_speech: "tính từ",
    meaning:
      "được sáng tạo ra và lưu truyền rộng rãi trong nhân dân: bài thuốc dân gian * văn học dân gian",
    example: "bài thuốc dân gian * văn học dân gian",
  },
  {
    word: "dân lập",
    part_of_speech: "tính từ",
    meaning:
      "do dân lập ra; phân biệt với quốc lập, công lập: trường đại học dân lập",
    example: "trường đại học dân lập",
  },
  {
    word: "dân nghèo",
    part_of_speech: "danh từ",
    meaning:
      "người thuộc tầng lớp không có hoặc có ít của cải, tư liệu sản xuất, sống trong cảnh túng thiếu: dân nghèo thành thị",
    example: "dân nghèo thành thị",
  },
  {
    word: "dẫn lưu",
    part_of_speech: "động từ",
    meaning:
      "dẫn cho chảy ra bằng ống nhỏ (từ thường dùng trong ngành y): chích và lấy mủ ra bằng ống dẫn lưu",
    example: "chích và lấy mủ ra bằng ống dẫn lưu",
  },
  {
    word: "dân phố",
    part_of_speech: "danh từ",
    meaning:
      "những người cùng phố, cùng phường (nói tổng quát): bà con dân phố",
    example: "bà con dân phố",
  },
  {
    word: "dân phố",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) tổ dân phố (nói tắt): tổ trưởng dân phố * họp dân phố",
    example: "tổ trưởng dân phố * họp dân phố",
  },
  {
    word: "dân phòng",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức của nhân dân tham gia các công tác giữ gìn an ninh trật tự xã hội như phòng gian, phòng hoả, v.v., ngay tại địa phương mình cư trú: tổ dân phòng * đội ngũ dân phòng của xã",
    example: "tổ dân phòng * đội ngũ dân phòng của xã",
  },
  {
    word: "dẫn nhiệt",
    part_of_speech: "động từ",
    meaning: "để cho nhiệt truyền qua: hệ thống dẫn nhiệt của lò hơi",
    example: "hệ thống dẫn nhiệt của lò hơi",
  },
  {
    word: "dấn mình",
    part_of_speech: "động từ",
    meaning: "như dấn thân: dấn mình vào chốn nguy hiểm",
    example: "dấn mình vào chốn nguy hiểm",
  },
  {
    word: "dân quê",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người dân lao động sống ở nông thôn: một anh dân quê hiền lành, chất phác * công cuộc khai hoá cho dân quê",
    example:
      "một anh dân quê hiền lành, chất phác * công cuộc khai hoá cho dân quê",
  },
  {
    word: "dân số",
    part_of_speech: "danh từ",
    meaning:
      "số dân (trong một nước, một vùng): điều tra dân số * mật độ dân số",
    example: "điều tra dân số * mật độ dân số",
  },
  {
    word: "dẫn rượu",
    part_of_speech: "động từ",
    meaning:
      '(khẩu ngữ) đi quá chậm chạp, như kiểu đi trong khi dẫn rượu: "Ông, một tay cầm ô ngay ngắn, một tay vung vẩy dịp dàng với bước chân dẫn rượu." (TrTiêu; 2)',
    example:
      'Ông, một tay cầm ô ngay ngắn, một tay vung vẩy dịp dàng với bước chân dẫn rượu." (TrTiêu; 2)',
  },
  {
    word: "dân sinh",
    part_of_speech: "danh từ",
    meaning:
      "sinh kế, sinh hoạt của nhân dân: cầu chui dân sinh * nâng cao dân trí để góp phần cải thiện dân sinh",
    example:
      "cầu chui dân sinh * nâng cao dân trí để góp phần cải thiện dân sinh",
  },
  {
    word: "dân quyền",
    part_of_speech: "danh từ",
    meaning: "quyền công dân (nói tổng quát): tôn trọng dân quyền",
    example: "tôn trọng dân quyền",
  },
  {
    word: "dẫn thân",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tự đưa mình đến (thường là chỗ khó khăn, nguy hiểm): tự dẫn thân vào hang cọp",
    example: "tự dẫn thân vào hang cọp",
  },
  {
    word: "dấn thân",
    part_of_speech: "động từ",
    meaning:
      "lao vào hoạt động hay công việc nào đó, bất chấp gian nan, nguy hiểm: dấn thân vào con đường tội lỗi * dấn thân vào vòng nguy hiểm",
    example: "dấn thân vào con đường tội lỗi * dấn thân vào vòng nguy hiểm",
  },
  {
    word: "dân số học",
    part_of_speech: "danh từ",
    meaning: "khoa học thống kê về dân số: các chỉ tiêu dân số học",
    example: "các chỉ tiêu dân số học",
  },
  {
    word: "dân sự",
    part_of_speech: "danh từ",
    meaning: "(cũ, hiếm) các việc có liên quan đến dân, nói chung.",
    example: "vụ án dân sự * bộ luật dân sự",
  },
  {
    word: "dân sự",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về nhân dân, liên quan đến nhân dân; phân biệt với quân sự: cơ quan dân sự * mục tiêu dân sự",
    example: "cơ quan dân sự * mục tiêu dân sự",
  },
  {
    word: "dẫn thuỷ",
    part_of_speech: "động từ",
    meaning: "dẫn nước để tưới tiêu: xây dựng hệ thống dẫn thuỷ",
    example: "xây dựng hệ thống dẫn thuỷ",
  },
  {
    word: "dân tình",
    part_of_speech: "danh từ",
    meaning:
      "tình hình, tình cảnh nhân dân: dân tình khổ cực * đi xem xét dân tình",
    example: "dân tình khổ cực * đi xem xét dân tình",
  },
  {
    word: "dân tộc",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi các cộng đồng người hình thành trong lịch sử ở những giai đoạn phát triển khác nhau: dân tộc Kinh * đoàn kết các dân tộc anh em",
    example: "dân tộc Kinh * đoàn kết các dân tộc anh em",
  },
  {
    word: "dân tộc",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi những cộng đồng người có chung một ngôn ngữ, một lãnh thổ, một nền kinh tế và một truyền thống văn hoá: dân tộc Việt Nam * cuộc đấu tranh giải phóng dân tộc",
    example: "dân tộc Việt Nam * cuộc đấu tranh giải phóng dân tộc",
  },
  {
    word: "dân tộc",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) dân tộc thiểu số (nói tắt): học sinh người dân tộc * đồng bào dân tộc",
    example: "học sinh người dân tộc * đồng bào dân tộc",
  },
  {
    word: "dân tộc đa số",
    part_of_speech: "danh từ",
    meaning:
      "dân tộc chiếm số đông nhất, so với các dân tộc chiếm số ít, trong một nước có nhiều dân tộc: dân tộc Kinh là dân tộc đa số ở Việt Nam",
    example: "dân tộc Kinh là dân tộc đa số ở Việt Nam",
  },
  {
    word: "dân thường",
    part_of_speech: "danh từ",
    meaning:
      "người dân bình thường, không có địa vị, chức vụ gì trong bộ máy chính quyền: thái tử bị truất xuống làm dân thường",
    example: "thái tử bị truất xuống làm dân thường",
  },
  {
    word: "dân tộc học",
    part_of_speech: "danh từ",
    meaning:
      "khoa học nghiên cứu về nguồn gốc, sự phân bố, đặc trưng sinh hoạt vật chất và văn hoá của các dân tộc và về quan hệ văn hoá - lịch sử giữa các dân tộc: giáo trình dân tộc học",
    example: "giáo trình dân tộc học",
  },
  {
    word: "dân tộc chủ thể",
    part_of_speech: "danh từ",
    meaning:
      "dân tộc chiếm số đông nhất, so với các dân tộc chiếm số ít, trong một nước có nhiều dân tộc: dân tộc Kinh là dân tộc đa số ở Việt Nam",
    example: "dân tộc Kinh là dân tộc đa số ở Việt Nam",
  },
  {
    word: "dân tộc hoá",
    part_of_speech: "động từ",
    meaning:
      "làm cho cái hấp thụ được của dân tộc khác trở thành có tinh thần, có màu sắc của dân tộc mình: dân tộc hoá một điệu múa của nước ngoài",
    example: "dân tộc hoá một điệu múa của nước ngoài",
  },
  {
    word: "dân trí",
    part_of_speech: "danh từ",
    meaning:
      "trình độ hiểu biết của nhân dân, nói chung: nâng cao trình độ dân trí",
    example: "nâng cao trình độ dân trí",
  },
  {
    word: "dẫn truyền",
    part_of_speech: "động từ",
    meaning:
      "truyền lan trong một môi trường: sóng xung điện dẫn truyền trong môi trường không khí",
    example: "sóng xung điện dẫn truyền trong môi trường không khí",
  },
  {
    word: "dẫn xuất",
    part_of_speech: "danh từ",
    meaning:
      "chất hoá học chế từ một chất hoá học khác: acid acetic là một dẫn xuất của rượu",
    example: "acid acetic là một dẫn xuất của rượu",
  },
  {
    word: "dẫn xuất",
    part_of_speech: "tính từ",
    meaning:
      "được tạo ra, sinh ra từ một cái khác được coi là gốc: chất dẫn xuất",
    example: "chất dẫn xuất",
  },
  {
    word: "dấn vốn",
    part_of_speech: "danh từ",
    meaning:
      '(khẩu ngữ, hiếm) vốn liếng để buôn bán, làm ăn: "Dấn vốn em chỉ có ba đồng, Nửa để nuôi chồng, nửa để nuôi tôi." (ca dao)',
    example:
      'Dấn vốn em chỉ có ba đồng, Nửa để nuôi chồng, nửa để nuôi tôi." (ca dao)',
  },
  {
    word: "dẫn xác",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) tự mình đi đến một nơi nào đó (hàm ý mỉa mai, khinh bỉ): tự dưng lù lù dẫn xác đến * đi đâu mà giờ mới dẫn xác về?",
    example: "tự dưng lù lù dẫn xác đến * đi đâu mà giờ mới dẫn xác về?",
  },
  {
    word: "dân vận",
    part_of_speech: "động từ",
    meaning:
      "tuyên truyền, vận động nhân dân: công tác dân vận * làm cán bộ dân vận",
    example: "công tác dân vận * làm cán bộ dân vận",
  },
  {
    word: "dân ý",
    part_of_speech: "danh từ",
    meaning:
      "ý dân, ý kiến của nhân dân về một vấn đề chính trị nào đó: trưng cầu dân ý * mở cuộc điều tra dân ý",
    example: "trưng cầu dân ý * mở cuộc điều tra dân ý",
  },
  {
    word: "dâng",
    part_of_speech: "động từ",
    meaning:
      "tăng lên cao (thường nói về mực nước): nước sông dâng cao * phong trào kháng chiến dâng lên khắp nơi",
    example: "nước sông dâng cao * phong trào kháng chiến dâng lên khắp nơi",
  },
  {
    word: "dâng",
    part_of_speech: "động từ",
    meaning:
      "(cảm giác, nỗi niềm) cuộn lên, trào lên: nỗi căm hờn dâng lên trong lòng",
    example: "nỗi căm hờn dâng lên trong lòng",
  },
  {
    word: "dâng",
    part_of_speech: "động từ",
    meaning:
      "đưa lên một cách cung kính: làm lễ dâng hương * dâng lễ vật cúng thần",
    example: "làm lễ dâng hương * dâng lễ vật cúng thần",
  },
  {
    word: "dâng hiến",
    part_of_speech: "động từ",
    meaning: "(hiếm) như hiến dâng: dâng hiến cả tuổi thanh xuân cho tổ quốc",
    example: "dâng hiến cả tuổi thanh xuân cho tổ quốc",
  },
  {
    word: "dấp",
    part_of_speech: "động từ",
    meaning: "làm cho vừa đủ thấm ướt: khăn tay dấp nước nóng",
    example: "khăn tay dấp nước nóng",
  },
  {
    word: "dập",
    part_of_speech: "động từ",
    meaning:
      "làm cho bị đè lấp dưới một lớp mỏng đất, cát: cày dập gốc rạ * xác chết bị dập dưới lớp cát mỏng",
    example: "cày dập gốc rạ * xác chết bị dập dưới lớp cát mỏng",
  },
  {
    word: "dập",
    part_of_speech: "động từ",
    meaning:
      "làm cho tắt, cho tàn, không còn bùng phát và lây lan được nữa: dập lửa * dập tắt đám cháy * ổ dịch đã bị dập",
    example: "dập lửa * dập tắt đám cháy * ổ dịch đã bị dập",
  },
  {
    word: "dập",
    part_of_speech: "động từ",
    meaning:
      'tác động một cách liên tục và mạnh mẽ làm cho phải chịu đựng một sức đè nén nặng nề: "Thân em như trái bần trôi, Gió dập sóng dồi biết tấp vào đâu?" (ca dao)',
    example:
      'Thân em như trái bần trôi, Gió dập sóng dồi biết tấp vào đâu?" (ca dao)',
  },
  {
    word: "dập",
    part_of_speech: "động từ",
    meaning:
      "làm ra sản phẩm theo hình dạng nhất định bằng lực ép trên khuôn định sẵn: máy dập khuy * thiết bị dập vỏ xe ô tô",
    example: "máy dập khuy * thiết bị dập vỏ xe ô tô",
  },
  {
    word: "dập",
    part_of_speech: "động từ",
    meaning:
      "va mạnh hoặc làm cho va mạnh: kéo dập cánh cửa vào * ngã dập mặt xuống đất",
    example: "kéo dập cánh cửa vào * ngã dập mặt xuống đất",
  },
  {
    word: "dấp dính",
    part_of_speech: "tính từ",
    meaning: "(hiếm) hơi dính vì thấm ướt một chút: trán dấp dính mồ hôi",
    example: "trán dấp dính mồ hôi",
  },
  {
    word: "dấp dính",
    part_of_speech: "tính từ",
    meaning:
      "(mắt) gần như díp lại, không mở to hẳn: mắt dấp dính như buồn ngủ",
    example: "mắt dấp dính như buồn ngủ",
  },
  {
    word: "dấp dính",
    part_of_speech: "tính từ",
    meaning:
      "(nói năng) có tiếng nọ như dính vào tiếng kia, không tách bạch rõ ràng: nói dấp dính, rất khó nghe",
    example: "nói dấp dính, rất khó nghe",
  },
  {
    word: "dập dềnh",
    part_of_speech: "động từ",
    meaning:
      "chuyển động lên xuống một cách nhịp nhàng (thường nói về mặt nước hoặc vật nổi trên mặt nước): đám lục bình trôi dập dềnh * chiếc thuyền dập dềnh trên sóng",
    example: "đám lục bình trôi dập dềnh * chiếc thuyền dập dềnh trên sóng",
  },
  {
    word: "dập vùi",
    part_of_speech: "động từ",
    meaning: "(hiếm) như vùi dập: cỏ cây bị bom đạn dập vùi",
    example: "cỏ cây bị bom đạn dập vùi",
  },
  {
    word: "dật sĩ",
    part_of_speech: "danh từ",
    meaning: "(cũ, hiếm) như ẩn sĩ: bậc cao nhân dật sĩ",
    example: "bậc cao nhân dật sĩ",
  },
  {
    word: "dật dờ",
    part_of_speech: "động từ",
    meaning:
      "lay động, ngả nghiêng một cách yếu ớt theo chiều gió, theo dòng nước: vệt khói bay vật vờ * những ngọn tre non vật vờ trước gió",
    example: "vệt khói bay vật vờ * những ngọn tre non vật vờ trước gió",
  },
  {
    word: "dật dờ",
    part_of_speech: "tính từ",
    meaning:
      '(cuộc sống) không ổn định, không chắc chắn, hoàn toàn tuỳ theo sự đưa đẩy của hoàn cảnh: sống vật vờ * "Vật vờ trong áng phồn hoa, Ba mươi sáu động, ai là chủ nhân?" (BC)',
    example:
      'sống vật vờ * "Vật vờ trong áng phồn hoa, Ba mươi sáu động, ai là chủ nhân?" (BC)',
  },
  {
    word: "dập dờn",
    part_of_speech: "",
    meaning:
      "chuyển động lúc lên lúc xuống, lúc ẩn lúc hiện, lúc gần lúc xa nối tiếp nhau liên tiếp và nhịp nhàng: ánh lửa dập dờn trong đêm",
    example: "ánh lửa dập dờn trong đêm",
  },
  {
    word: "dập dìu",
    part_of_speech: "tính từ",
    meaning:
      '(cảnh tượng) nhộn nhịp, đông vui, người qua kẻ lại không ngớt: xe ngựa dập dìu * "Ngày ngày bán lá chợ chiều, Kẻ đi người lại dập dìu cũng vui." (Cdao)',
    example:
      'xe ngựa dập dìu * "Ngày ngày bán lá chợ chiều, Kẻ đi người lại dập dìu cũng vui." (Cdao)',
  },
  {
    word: "dập dìu",
    part_of_speech: "tính từ",
    meaning:
      '(âm thanh) nhịp nhàng, lúc trầm lúc bổng như hoà quyện và nối tiếp nhau không dứt: "Dập dìu tiếng cảnh tiếng tiu, Tiếng ngư trong núi, tiếng tiều ngoài sông." (Cdao)',
    example:
      'Dập dìu tiếng cảnh tiếng tiu, Tiếng ngư trong núi, tiếng tiều ngoài sông." (Cdao)',
  },
  {
    word: "dẩu",
    part_of_speech: "động từ",
    meaning:
      "chìa (môi) ra, thường để biểu thị ý không bằng lòng: dẩu mồm ra chê ít * dẩu môi",
    example: "dẩu mồm ra chê ít * dẩu môi",
  },
  {
    word: "dâu",
    part_of_speech: "danh từ",
    meaning:
      "cây trồng bằng cành, lá hình tim hay chia thành thuỳ, dùng để nuôi tằm, quả tụ thành khối: trồng dâu nuôi tằm",
    example: "trồng dâu nuôi tằm",
  },
  {
    word: "dâu",
    part_of_speech: "danh từ",
    meaning:
      "(cũng dâu rượu) cây bụi thấp, cành có lông tơ, quả có nhiều núm mọng nước, thường dùng để chế rượu: rượu vang dâu * quả dâu",
    example: "rượu vang dâu * quả dâu",
  },
  {
    word: "dâu",
    part_of_speech: "danh từ",
    meaning:
      'người phụ nữ đã lấy chồng, trong quan hệ với cha mẹ chồng, với gia đình và họ hàng nhà chồng: con dâu * chị dâu * "Thân em mười sáu tuổi đầu, Cha mẹ ép gả làm dâu nhà người." (Cdao)',
    example:
      'con dâu * chị dâu * "Thân em mười sáu tuổi đầu, Cha mẹ ép gả làm dâu nhà người." (Cdao)',
  },
  {
    word: "dầu",
    part_of_speech: "danh từ",
    meaning:
      "chất lỏng nhờn, không hoà tan trong nước, nhẹ hơn nước, lấy từ các nguồn thực vật, động vật hay khoáng vật, dùng để ăn, chữa bệnh, thắp đèn, chạy máy, v.v.: tra dầu vào máy * đèn cạn dầu, leo lét",
    example: "tra dầu vào máy * đèn cạn dầu, leo lét",
  },
  {
    word: "dấu ấn",
    part_of_speech: "danh từ",
    meaning:
      "dấu vết để lại do có sự tác động mạnh mẽ về tư tưởng, tinh thần: tác phẩm mang đậm dấu ấn của thời đại",
    example: "tác phẩm mang đậm dấu ấn của thời đại",
  },
  {
    word: "dấu",
    part_of_speech: "danh từ",
    meaning:
      'cái còn lưu lại của sự vật, sự việc đã qua, qua đó có thể nhận ra sự vật, sự việc ấy: dấu vân tay * "Đè chừng ngọn gió lần theo, Dấu giày từng bước in rêu rành rành." (TKiều)',
    example:
      'dấu vân tay * "Đè chừng ngọn gió lần theo, Dấu giày từng bước in rêu rành rành." (TKiều)',
  },
  {
    word: "dấu",
    part_of_speech: "danh từ",
    meaning:
      "cái được định ra theo quy ước (thường bằng kí hiệu) để ghi nhớ hoặc làm hiệu cho biết điều gì: ngắt câu bằng dấu chấm * xe cứu thương có dấu chữ thập đỏ",
    example: "ngắt câu bằng dấu chấm * xe cứu thương có dấu chữ thập đỏ",
  },
  {
    word: "dấu",
    part_of_speech: "danh từ",
    meaning:
      "hình thường có chữ, được in trên giấy tờ để làm bằng, làm tin về một danh nghĩa nào đó: đóng dấu bưu điện * xin dấu xác nhận của cơ quan",
    example: "đóng dấu bưu điện * xin dấu xác nhận của cơ quan",
  },
  {
    word: "dậu",
    part_of_speech: "danh từ",
    meaning:
      "đồ đựng bằng tre nứa đan dày, lòng sâu, có hai quai để xỏ đòn gánh: gánh hai dậu thóc đầy",
    example: "gánh hai dậu thóc đầy",
  },
  {
    word: "dâu bể",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) như bể dâu: "Cơ trời dâu bể đa đoan, Một nhà để chị riêng oan một mình." (TKiều)',
    example:
      'Cơ trời dâu bể đa đoan, Một nhà để chị riêng oan một mình." (TKiều)',
  },
  {
    word: "dẫu",
    part_of_speech: "kết từ",
    meaning:
      '(văn chương) như dù (nhưng nghĩa thường mạnh hơn): dẫu khó cũng không ngại * "Gươm lính sút cán còn trành, Bình hương dẫu bể, miểng sành còn thơm." (ca dao)',
    example:
      'dẫu khó cũng không ngại * "Gươm lính sút cán còn trành, Bình hương dẫu bể, miểng sành còn thơm." (ca dao)',
  },
  {
    word: "dấu chấm",
    part_of_speech: "danh từ",
    meaning:
      "dấu ‘.’ dùng khi viết chữ hoặc để đặt ở cuối câu: chữ  *  có dấu chấm ở trên đầu * sau dấu chấm phải viết hoa",
    example: "chữ  *  có dấu chấm ở trên đầu * sau dấu chấm phải viết hoa",
  },
  {
    word: "dâu con",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) dâu và con (nói khái quát): trọn đạo dâu con",
    example: "trọn đạo dâu con",
  },
  {
    word: "dầu chổi",
    part_of_speech: "danh từ",
    meaning:
      "tinh dầu cất từ cây chổi dùng để xoa bóp, có tác dụng gây nóng, giảm đau: bóp chỗ đau bằng dầu chổi",
    example: "bóp chỗ đau bằng dầu chổi",
  },
  {
    word: "dầu dãi",
    part_of_speech: "động từ",
    meaning: "như dãi dầu: suốt ngày dầu dãi nắng mưa",
    example: "suốt ngày dầu dãi nắng mưa",
  },
  {
    word: "dầu gội",
    part_of_speech: "danh từ",
    meaning:
      "dầu được chế từ các loại hoá chất hoặc dược thảo, dùng để gội đầu, làm sạch da đầu và sạch tóc: dầu gội trị gàu",
    example: "dầu gội trị gàu",
  },
  {
    word: "dầu đèn",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) dầu và đèn dùng để thắp sáng (nói khái quát): sống dầu đèn, chết kèn trống (tng)",
    example: "sống dầu đèn, chết kèn trống (tng)",
  },
  {
    word: "dâu gia",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) như thông gia: làm dâu gia với nhau",
    example: "làm dâu gia với nhau",
  },
  {
    word: "dầu hắc",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) hắc ín: đen như dầu hắc",
    example: "đen như dầu hắc",
  },
  {
    word: "dầu gió",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) dầu dùng để xoa, có tác dụng chữa cảm, giảm đau, thường được chế bằng một số loại tinh dầu: xoa dầu gió",
    example: "xoa dầu gió",
  },
  {
    word: "dấu hỏi",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) chỗ đáng nghi ngờ trong một vấn đề, một sự việc: việc này đã đặt ra nhiều dấu hỏi",
    example: "việc này đã đặt ra nhiều dấu hỏi",
  },
  {
    word: "dầu hôi",
    part_of_speech: "danh từ",
    meaning:
      "dầu cất từ dầu mỏ, màu trong suốt, có mùi hôi, dễ cháy, thường dùng để thắp sáng, làm chất đốt: đèn dầu hoả (thắp bằng dầu hoả)",
    example: "đèn dầu hoả (thắp bằng dầu hoả)",
  },
  {
    word: "dầu khí",
    part_of_speech: "danh từ",
    meaning:
      "dầu mỏ và khí đốt nói chung: khai thác và chế biến dầu khí * ngành công nghiệp dầu khí",
    example: "khai thác và chế biến dầu khí * ngành công nghiệp dầu khí",
  },
  {
    word: "dầu hoả",
    part_of_speech: "danh từ",
    meaning:
      "dầu cất từ dầu mỏ, màu trong suốt, có mùi hôi, dễ cháy, thường dùng để thắp sáng, làm chất đốt: đèn dầu hoả (thắp bằng dầu hoả)",
    example: "đèn dầu hoả (thắp bằng dầu hoả)",
  },
  {
    word: "dấu hiệu",
    part_of_speech: "danh từ",
    meaning:
      "dấu dùng để làm hiệu cho biết điều gì: dấu hiệu liên lạc * nháy đèn pin làm dấu hiệu",
    example: "dấu hiệu liên lạc * nháy đèn pin làm dấu hiệu",
  },
  {
    word: "dấu hiệu",
    part_of_speech: "danh từ",
    meaning:
      "hiện tượng tỏ rõ điều gì: tóc bạc là một dấu hiệu của tuổi già * phát hiện dấu hiệu phạm tội",
    example:
      "tóc bạc là một dấu hiệu của tuổi già * phát hiện dấu hiệu phạm tội",
  },
  {
    word: "dầu lạc",
    part_of_speech: "danh từ",
    meaning:
      "dầu được chiết từ hạt lạc, dùng để làm dầu ăn hoặc thắp sáng: thắp sáng bằng dầu lạc",
    example: "thắp sáng bằng dầu lạc",
  },
  {
    word: "dầu lửa",
    part_of_speech: "danh từ",
    meaning:
      "dầu lấy từ mỏ lên, mùi hắc khó chịu, dùng để chế chất đốt, làm nguyên liệu cho công nghiệp hoá học: ngành công nghiệp khai thác dầu mỏ",
    example: "ngành công nghiệp khai thác dầu mỏ",
  },
  {
    word: "dấu má",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) dấu đóng trên giấy tờ để làm bằng (nói khái quát; hàm ý coi thường): dấu má lem nhem, không rõ ràng * dấu má phức tạp",
    example: "dấu má lem nhem, không rõ ràng * dấu má phức tạp",
  },
  {
    word: "dầu mỏ",
    part_of_speech: "danh từ",
    meaning:
      "dầu lấy từ mỏ lên, mùi hắc khó chịu, dùng để chế chất đốt, làm nguyên liệu cho công nghiệp hoá học: ngành công nghiệp khai thác dầu mỏ",
    example: "ngành công nghiệp khai thác dầu mỏ",
  },
  {
    word: "dầu mỡ",
    part_of_speech: "danh từ",
    meaning:
      "dầu nhờn và mỡ dùng để bôi trơn máy (nói khái quát): tay dính đầy dầu mỡ",
    example: "tay dính đầy dầu mỡ",
  },
  {
    word: "dầu quang",
    part_of_speech: "động từ",
    meaning:
      "quét lên một lớp quang dầu để làm tăng độ bền và vẻ đẹp: quang dầu chiếc nón",
    example: "quang dầu chiếc nón",
  },
  {
    word: "dẫu sao",
    part_of_speech: "",
    meaning: "như dù sao: dẫu sao thì chuyện cũng đã qua rồi!",
    example: "dẫu sao thì chuyện cũng đã qua rồi!",
  },
  {
    word: "dâu rượu",
    part_of_speech: "danh từ",
    meaning:
      "cây trồng bằng cành, lá hình tim hay chia thành thuỳ, dùng để nuôi tằm, quả tụ thành khối: trồng dâu nuôi tằm",
    example: "trồng dâu nuôi tằm",
  },
  {
    word: "dâu rượu",
    part_of_speech: "danh từ",
    meaning:
      "(cũng dâu rượu) cây bụi thấp, cành có lông tơ, quả có nhiều núm mọng nước, thường dùng để chế rượu: rượu vang dâu * quả dâu",
    example: "rượu vang dâu * quả dâu",
  },
  {
    word: "dâu rượu",
    part_of_speech: "danh từ",
    meaning:
      'người phụ nữ đã lấy chồng, trong quan hệ với cha mẹ chồng, với gia đình và họ hàng nhà chồng: con dâu * chị dâu * "Thân em mười sáu tuổi đầu, Cha mẹ ép gả làm dâu nhà người." (Cdao)',
    example:
      'con dâu * chị dâu * "Thân em mười sáu tuổi đầu, Cha mẹ ép gả làm dâu nhà người." (Cdao)',
  },
  {
    word: "dâu tằm",
    part_of_speech: "danh từ",
    meaning:
      "cây trồng bằng cành, lá hình tim hay chia thành thuỳ, dùng để nuôi tằm, quả tụ thành khối: trồng dâu nuôi tằm",
    example: "trồng dâu nuôi tằm",
  },
  {
    word: "dâu tằm",
    part_of_speech: "danh từ",
    meaning:
      "(cũng dâu rượu) cây bụi thấp, cành có lông tơ, quả có nhiều núm mọng nước, thường dùng để chế rượu: rượu vang dâu * quả dâu",
    example: "rượu vang dâu * quả dâu",
  },
  {
    word: "dâu tằm",
    part_of_speech: "danh từ",
    meaning:
      'người phụ nữ đã lấy chồng, trong quan hệ với cha mẹ chồng, với gia đình và họ hàng nhà chồng: con dâu * chị dâu * "Thân em mười sáu tuổi đầu, Cha mẹ ép gả làm dâu nhà người." (Cdao)',
    example:
      'con dâu * chị dâu * "Thân em mười sáu tuổi đầu, Cha mẹ ép gả làm dâu nhà người." (Cdao)',
  },
  {
    word: "dầu thô",
    part_of_speech: "danh từ",
    meaning:
      "dầu mỏ mới được xử lí bước đầu, chưa qua chế biến, tinh lọc: xuất khẩu dầu thô * nhà máy chế biến và xử lí dầu thô",
    example: "xuất khẩu dầu thô * nhà máy chế biến và xử lí dầu thô",
  },
  {
    word: "dấu vết",
    part_of_speech: "danh từ",
    meaning:
      "cái còn để lại do kết quả tác động của hiện tượng đã qua, dựa vào có thể nhận biết được về hiện tượng ấy: tìm dấu vết kẻ gian",
    example: "tìm dấu vết kẻ gian",
  },
  {
    word: "dấu tích",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) cái còn để lại mà qua đó ta có thể biết được về người hoặc sự việc thuộc thời đã qua, thường là thời cổ xưa: phát hiện dấu tích của ngôi đền cổ * hoàn toàn không để lại một dấu tích gì",
    example:
      "phát hiện dấu tích của ngôi đền cổ * hoàn toàn không để lại một dấu tích gì",
  },
  {
    word: "dậy",
    part_of_speech: "động từ",
    meaning:
      "chuyển từ trạng thái ngủ sang trạng thái thức: thức khuya dậy sớm * ngủ say, gọi mãi không dậy",
    example: "thức khuya dậy sớm * ngủ say, gọi mãi không dậy",
  },
  {
    word: "dậy",
    part_of_speech: "động từ",
    meaning:
      "chuyển từ tư thế nằm sang tư thế ngồi, hay từ tư thế nằm hoặc ngồi sang tư thế đứng: lóp ngóp bò dậy * còn mệt nhưng cố gượng dậy * đứng dậy",
    example: "lóp ngóp bò dậy * còn mệt nhưng cố gượng dậy * đứng dậy",
  },
  {
    word: "dậy",
    part_of_speech: "động từ",
    meaning:
      "chuyển từ trạng thái không có những biểu hiện rõ rệt của sự tồn tại sang trạng thái có những biểu hiện rõ rệt (nói về cái gì nổi lên, rực lên, bốc lên, v.v.): mùi hành mỡ dậy lên thơm nức * biển Đông dậy sóng",
    example: "mùi hành mỡ dậy lên thơm nức * biển Đông dậy sóng",
  },
  {
    word: "dấy",
    part_of_speech: "động từ",
    meaning:
      "nổi dậy hoặc làm cho nổi dậy: dấy quân khởi nghĩa * làn sóng đấu tranh dấy lên mạnh mẽ",
    example: "dấy quân khởi nghĩa * làn sóng đấu tranh dấy lên mạnh mẽ",
  },
  {
    word: "dấy",
    part_of_speech: "động từ",
    meaning:
      "(trạng thái, cảm xúc) nổi lên và biểu hiện mạnh mẽ: trong lòng dấy lên bao kỉ niệm",
    example: "trong lòng dấy lên bao kỉ niệm",
  },
  {
    word: "dây",
    part_of_speech: "danh từ",
    meaning:
      "vật hình sợi dùng để buộc, nối, truyền dẫn, v.v.: đàn đứt dây * dây buộc tóc",
    example: "đàn đứt dây * dây buộc tóc",
  },
  {
    word: "dây",
    part_of_speech: "danh từ",
    meaning:
      "thân có dạng hình sợi của một số loại cây leo, cây bò: dây khoai * rút dây động rừng (tng)",
    example: "dây khoai * rút dây động rừng (tng)",
  },
  {
    word: "dây",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp gồm nhiều vật cùng loại nối tiếp nhau thành một hình dài: dây đạn * đốt một dây pháo dài",
    example: "dây đạn * đốt một dây pháo dài",
  },
  {
    word: "dây",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị một chục bát được buộc thành chồng dùng trong mua bán: một dây bát * bán cả dây, không bán lẻ",
    example: "một dây bát * bán cả dây, không bán lẻ",
  },
  {
    word: "dây",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương) mối liên hệ tinh thần gắn bó, ràng buộc với nhau: dây thân ái * dây liên lạc",
    example: "dây thân ái * dây liên lạc",
  },
  {
    word: "dây",
    part_of_speech: "động từ",
    meaning:
      "dính vào chút ít làm cho bị bẩn: mực dây ra sách vở * máu dây đầy tay",
    example: "mực dây ra sách vở * máu dây đầy tay",
  },
  {
    word: "dây",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) dính líu vào, làm cho bị rắc rối, phiền phức: dây vào nó làm gì cho mệt! * không thèm dây!",
    example: "dây vào nó làm gì cho mệt! * không thèm dây!",
  },
  {
    word: "dây",
    part_of_speech: "động từ",
    meaning: "(gà) lây bệnh: gà dây",
    example: "gà dây",
  },
  {
    word: "dây chằng",
    part_of_speech: "danh từ",
    meaning:
      "khối mô liên kết dạng sợi, màu trắng và dai cứng, nối hai khớp xương với nhau ở vùng khớp: dãn dây chằng khớp gối",
    example: "dãn dây chằng khớp gối",
  },
  {
    word: "dây cáp",
    part_of_speech: "danh từ",
    meaning:
      "dây bện gồm nhiều sợi kim loại nhỏ xoắn chặt lại với nhau, chịu được sức kéo lớn: dây cáp cần cẩu * cáp cầu treo",
    example: "dây cáp cần cẩu * cáp cầu treo",
  },
  {
    word: "dây cáp",
    part_of_speech: "danh từ",
    meaning:
      "dây đặc biệt dùng để dẫn điện cao thế hay truyền tín hiệu, thường có vỏ bọc cách điện: cáp điện thoại * đường cáp cao thế * hệ thống cáp truyền hình",
    example: "cáp điện thoại * đường cáp cao thế * hệ thống cáp truyền hình",
  },
  {
    word: "dây chuyền",
    part_of_speech: "danh từ",
    meaning:
      "dây gồm nhiều vòng nhỏ bằng kim loại móc nối vào nhau, thường dùng làm đồ trang sức: mới đánh sợi dây chuyền",
    example: "mới đánh sợi dây chuyền",
  },
  {
    word: "dây chuyền",
    part_of_speech: "danh từ",
    meaning:
      "hình thức tổ chức sản xuất gồm những bộ phận chuyên môn hoá thực hiện các khâu kế tiếp nhau theo một trình tự nhất định: dây chuyền chế biến sữa * phản ứng dây chuyền (phản ứng từ cái nọ lan sang cái kia)",
    example:
      "dây chuyền chế biến sữa * phản ứng dây chuyền (phản ứng từ cái nọ lan sang cái kia)",
  },
  {
    word: "dây cót",
    part_of_speech: "danh từ",
    meaning:
      "lò xo hình xoáy ốc dùng để làm quay một bộ phận trong máy: lên dây cót đồng hồ",
    example: "lên dây cót đồng hồ",
  },
  {
    word: "dây dợ",
    part_of_speech: "danh từ",
    meaning: "dây (nói khái quát; thường hàm ý chê): dây dợ lằng nhằng",
    example: "dây dợ lằng nhằng",
  },
  {
    word: "dây dưa",
    part_of_speech: "động từ",
    meaning:
      "kéo dài lằng nhằng, không dứt điểm: tranh luận dây dưa * dây dưa mãi không chịu trả nợ",
    example: "tranh luận dây dưa * dây dưa mãi không chịu trả nợ",
  },
  {
    word: "dây dưa",
    part_of_speech: "động từ",
    meaning:
      "dính líu vào việc gây rắc rối, phiền phức: việc đó tôi không dây dưa",
    example: "việc đó tôi không dây dưa",
  },
  {
    word: "dậy đất",
    part_of_speech: "tính từ",
    meaning:
      '(âm thanh) vang dội, mạnh mẽ, như làm rung chuyển cả mặt đất: tiếng quân reo dậy đất * "Một nhà hoảng hốt ngẩn ngơ, Tiếng oan dậy đất, án ngờ loà mây." (TKiều)',
    example:
      'tiếng quân reo dậy đất * "Một nhà hoảng hốt ngẩn ngơ, Tiếng oan dậy đất, án ngờ loà mây." (TKiều)',
  },
  {
    word: "dây đất",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) dây nối đất (nói tắt): nối dây đất",
    example: "nối dây đất",
  },
  {
    word: "dậy mùi",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (món ăn) có mùi thơm ngon toả mạnh, hấp dẫn: quả mít dậy mùi thơm nức * phi hành mỡ cho dậy mùi",
    example: "quả mít dậy mùi thơm nức * phi hành mỡ cho dậy mùi",
  },
  {
    word: "dây leo",
    part_of_speech: "danh từ",
    meaning:
      "cây có thân yếu không tự mọc đứng được một mình, mà phải bám vào cây hoặc vật khác bằng cách tự quấn thân xung quanh hoặc nhờ những tua cuốn, như mướp, gấc, v.v.: bầu, bí thuộc loài cây leo",
    example: "bầu, bí thuộc loài cây leo",
  },
  {
    word: "dây nói",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, hoặc kng) điện thoại: "Tôi quay dây nói nhờ cho gọi cái số có biên trên tấm thiếp." (NCao; 23)',
    example:
      'Tôi quay dây nói nhờ cho gọi cái số có biên trên tấm thiếp." (NCao; 23)',
  },
  {
    word: "dây óng",
    part_of_speech: "danh từ",
    meaning:
      "đoạn dây vòng qua cổ trâu, bò để giữ cái ách trên vai: chạc dây óng",
    example: "chạc dây óng",
  },
  {
    word: "dây thép",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) điện báo: "Mỗi lần các cháu phải đổi phủ đổi huyện lại đánh dây thép về quê mời ông bác họ lên chơi (...)" (NgKhải; 9)',
    example:
      'Mỗi lần các cháu phải đổi phủ đổi huyện lại đánh dây thép về quê mời ông bác họ lên chơi (...)" (NgKhải; 9)',
  },
  {
    word: "dậy thì",
    part_of_speech: "",
    meaning:
      "ở độ tuổi cơ thể phát triển mạnh, bắt đầu có khả năng sinh dục: con bé đang độ dậy thì * bước vào tuổi dậy thì",
    example: "con bé đang độ dậy thì * bước vào tuổi dậy thì",
  },
  {
    word: "dây thép gai",
    part_of_speech: "danh từ",
    meaning:
      "dây bằng thép, có mắc những đoạn ngắn nhọn đầu như gai, dùng để rào ngăn, làm vật chướng ngại: hàng rào dây thép gai",
    example: "hàng rào dây thép gai",
  },
  {
    word: "dây tóc",
    part_of_speech: "danh từ",
    meaning: "dây cót trong đồng hồ, nhỏ như sợi tóc: đồng hồ bị rối dây tóc",
    example: "đồng hồ bị rối dây tóc",
  },
  {
    word: "dây tóc",
    part_of_speech: "danh từ",
    meaning:
      "dây kim loại nhỏ như sợi tóc trong bóng điện, khi dòng điện chạy qua thì nóng đỏ lên và phát sáng: bóng đèn bị đứt dây tóc",
    example: "bóng đèn bị đứt dây tóc",
  },
  {
    word: "dè",
    part_of_speech: "động từ",
    meaning:
      "tự hạn chế trong việc chi dùng, chỉ dùng từng ít một: tiêu dè từng đồng * ăn dè",
    example: "tiêu dè từng đồng * ăn dè",
  },
  {
    word: "dè",
    part_of_speech: "động từ",
    meaning:
      "tự hạn chế trong hành động, tránh không đụng đến: nói năng nên dè miệng * chém tre chẳng dè đầu mặt (tng)",
    example: "nói năng nên dè miệng * chém tre chẳng dè đầu mặt (tng)",
  },
  {
    word: "dè",
    part_of_speech: "động từ",
    meaning:
      'đoán biết để liệu trước, phòng trước điều không bình thường hoặc không hay: "Nực cười châu chấu đá xe, Tưởng rằng chấu ngã, ai dè xe nghiêng." (Cdao)',
    example:
      'Nực cười châu chấu đá xe, Tưởng rằng chấu ngã, ai dè xe nghiêng." (Cdao)',
  },
  {
    word: "dây xích",
    part_of_speech: "danh từ",
    meaning:
      "dây kim loại gồm nhiều vòng, nhiều khúc giống nhau, móc nối liên tiếp với nhau: xích xe tăng * xe đạp tuột xích * nối lại các mắt xích",
    example: "xích xe tăng * xe đạp tuột xích * nối lại các mắt xích",
  },
  {
    word: "dây xích",
    part_of_speech: "động từ",
    meaning: "buộc, giữ bằng dây xích: xích con chó lại",
    example: "xích con chó lại",
  },
  {
    word: "dây xích",
    part_of_speech: "động từ",
    meaning:
      "chuyển dịch vị trí trong khoảng rất ngắn: ngồi xích vào * xích lên một chút * xích lại gần nhau",
    example: "ngồi xích vào * xích lên một chút * xích lại gần nhau",
  },
  {
    word: "dẻ",
    part_of_speech: "danh từ",
    meaning:
      "cây gỗ to gồm nhiều loài, mọc ở rừng, lá khía răng, một vài loài có quả (thông thường gọi là hạt) ăn được: rang hạt dẻ",
    example: "rang hạt dẻ",
  },
  {
    word: "dè chừng",
    part_of_speech: "động từ",
    meaning:
      "chú ý, cẩn thận đề phòng vì lo điều không hay có thể xảy ra: dè chừng tai nạn * chưa quen nên phải dè chừng",
    example: "dè chừng tai nạn * chưa quen nên phải dè chừng",
  },
  {
    word: "dè chừng",
    part_of_speech: "động từ",
    meaning:
      "chú ý chi dùng ở mức tối thiểu, phòng khi túng thiếu: ăn dè chừng",
    example: "ăn dè chừng",
  },
  {
    word: "dẽ",
    part_of_speech: "tính từ",
    meaning: "(đất) bị nén xuống thành một lớp rắn trên bề mặt: đất dẽ khó cày",
    example: "đất dẽ khó cày",
  },
  {
    word: "dẽ dàng",
    part_of_speech: "tính từ",
    meaning:
      "(nói năng) nhỏ nhẹ, dịu dàng, nhưng rành rọt: dẽ dàng bảo ban * giọng nói dẽ dàng",
    example: "dẽ dàng bảo ban * giọng nói dẽ dàng",
  },
  {
    word: "dè dặt",
    part_of_speech: "",
    meaning:
      "tỏ ra thận trọng, tự hạn chế ở mức độ thấp trong hành động, do thấy cần phải cân nhắc: chi tiêu dè dặt * nói năng dè dặt * ăn dè dặt từng hạt một",
    example: "chi tiêu dè dặt * nói năng dè dặt * ăn dè dặt từng hạt một",
  },
  {
    word: "dè bỉu",
    part_of_speech: "động từ",
    meaning:
      "chê bai, khinh thường người khác bằng lời nói hoặc thái độ thiếu thiện ý: bị người đời chê bai, dè bỉu",
    example: "bị người đời chê bai, dè bỉu",
  },
  {
    word: "dèn dẹt",
    part_of_speech: "tính từ",
    meaning: "hơi dẹt: miếng thép dèn dẹt to và dài",
    example: "miếng thép dèn dẹt to và dài",
  },
  {
    word: "dém",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) tém: dém màn",
    example: "dém màn",
  },
  {
    word: "dẻo",
    part_of_speech: "tính từ",
    meaning:
      "dễ dập mỏng, dễ uốn cong, v.v. mà không bị vỡ, bị gãy: xôi dẻo * sợi mây dẻo * đồng là một kim loại dẻo * chất dẻo",
    example: "xôi dẻo * sợi mây dẻo * đồng là một kim loại dẻo * chất dẻo",
  },
  {
    word: "dẻo",
    part_of_speech: "tính từ",
    meaning: "mềm mại trong các cử động: múa rất dẻo * tiết mục uốn dẻo",
    example: "múa rất dẻo * tiết mục uốn dẻo",
  },
  {
    word: "dẻo dang",
    part_of_speech: "tính từ",
    meaning: "tỏ ra dẻo, có vẻ dẻo (thường nói về động tác): đôi tay dẻo dang",
    example: "đôi tay dẻo dang",
  },
  {
    word: "dẻo dai",
    part_of_speech: "tính từ",
    meaning:
      "có sức chịu đựng được lâu, có khả năng hoạt động với mức độ không giảm trong một thời gian dài: sức làm việc dẻo dai",
    example: "sức làm việc dẻo dai",
  },
  {
    word: "dẻo mồm",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) khéo nói, giỏi nói (thường hàm ý chê): chỉ được cái dẻo mồm!",
    example: "chỉ được cái dẻo mồm!",
  },
  {
    word: "dè sẻn",
    part_of_speech: "động từ",
    meaning:
      "tự hạn chế ở mức tối thiểu trong việc chi dùng: chi tiêu rất dè sẻn",
    example: "chi tiêu rất dè sẻn",
  },
  {
    word: "dẹp",
    part_of_speech: "động từ",
    meaning:
      "làm cho gọn vào một chỗ để cho hết vướng, hết cản trở: dẹp hết đồ đạc vào một góc * dẹp đường cho xe đi",
    example: "dẹp hết đồ đạc vào một góc * dẹp đường cho xe đi",
  },
  {
    word: "dẹp",
    part_of_speech: "động từ",
    meaning:
      "gác lại hoặc gạt đi, để không còn phải bận tâm: dẹp việc ấy lại, sau hẵng hay",
    example: "dẹp việc ấy lại, sau hẵng hay",
  },
  {
    word: "dẹp",
    part_of_speech: "động từ",
    meaning:
      "xoá bỏ, không còn để cho tồn tại, nhằm đảm bảo trật tự, an ninh: dẹp loạn",
    example: "dẹp loạn",
  },
  {
    word: "dẹp",
    part_of_speech: "tính từ",
    meaning: "có bề dày rất nhỏ như bị ép mỏng lại: cá dẹp mình * hạt thóc dẹp",
    example: "cá dẹp mình * hạt thóc dẹp",
  },
  {
    word: "dép lê",
    part_of_speech: "danh từ",
    meaning: "dép không có quai ở phía sau gót: đôi dép lê đã cũ mòn",
    example: "đôi dép lê đã cũ mòn",
  },
  {
    word: "dẻo quẹo",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) rất dẻo: hạt ngô nếp dẻo quẹo * miệng nói cứ dẻo quẹo",
    example: "hạt ngô nếp dẻo quẹo * miệng nói cứ dẻo quẹo",
  },
  {
    word: "dép",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng để mang ở bàn chân, thường làm bằng nhựa hoặc da, gồm có đế và quai: dép nhựa * chân đi dép",
    example: "dép nhựa * chân đi dép",
  },
  {
    word: "dẹp lép",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) rất dẹp (hàm ý chê): ngực dẹp lép",
    example: "ngực dẹp lép",
  },
  {
    word: "dẹp tiệm",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) (cơ sở sản xuất, kinh doanh) đóng cửa, thôi không tiếp tục làm nữa: kinh doanh không tốt nên phải dẹp tiệm",
    example: "kinh doanh không tốt nên phải dẹp tiệm",
  },
  {
    word: "dẹp tiệm",
    part_of_speech: "động từ",
    meaning:
      "thôi, ngừng hẳn, không tiếp tục hoạt động nữa: các lò luyện thi phải dẹp tiệm",
    example: "các lò luyện thi phải dẹp tiệm",
  },
  {
    word: "dẹt",
    part_of_speech: "tính từ",
    meaning:
      "có dạng hình khối tròn, nhưng không phồng cao, trông như bị ép xuống: thân lươn tròn, dẹt dần về phía đuôi",
    example: "thân lươn tròn, dẹt dần về phía đuôi",
  },
  {
    word: "dê",
    part_of_speech: "danh từ",
    meaning:
      "động vật nhai lại, sừng rỗng và cong quặp về phía sau, cằm có túm lông làm thành râu, nuôi để lấy sữa, lấy thịt: chăn một đàn dê * uống sữa dê",
    example: "chăn một đàn dê * uống sữa dê",
  },
  {
    word: "dê",
    part_of_speech: "tính từ",
    meaning: "(thông tục) (đàn ông) đa dâm: lão ta rất dê",
    example: "lão ta rất dê",
  },
  {
    word: "dễ chịu",
    part_of_speech: "tính từ",
    meaning:
      "có cảm giác hoặc làm cho có cảm giác êm dịu, thoải mái: không khí mát mẻ dễ chịu * thấy trong người dễ chịu",
    example: "không khí mát mẻ dễ chịu * thấy trong người dễ chịu",
  },
  {
    word: "dể",
    part_of_speech: "động từ",
    meaning: "(Từ cũ, Ít dùng) coi thường, không kính nể: kẻ khinh người dể",
    example: "kẻ khinh người dể",
  },
  {
    word: "dể",
    part_of_speech: "động từ",
    meaning: "tung lên liên tiếp nhiều lần: dồi quả bóng * gió dập sóng dồi",
    example: "dồi quả bóng * gió dập sóng dồi",
  },
  {
    word: "dê diếu",
    part_of_speech: "động từ",
    meaning: "(hiếm) như bêu xấu: không nên dê diếu nhau",
    example: "không nên dê diếu nhau",
  },
  {
    word: "dễ bề",
    part_of_speech: "tính từ",
    meaning:
      "có sự dễ dàng cho việc thực hiện một công việc gì: làm thế để dễ bề đối phó",
    example: "làm thế để dễ bề đối phó",
  },
  {
    word: "dễ coi",
    part_of_speech: "tính từ",
    meaning:
      "có dáng vẻ trông được, dễ gây cảm tình: cô ta không đẹp nhưng cũng dễ coi",
    example: "cô ta không đẹp nhưng cũng dễ coi",
  },
  {
    word: "dễ",
    part_of_speech: "tính từ",
    meaning:
      'không đòi hỏi phải có nhiều điều kiện hoặc phải cố gắng nhiều mới có được, làm được hay mới đạt được kết quả: bài toán dễ * dễ như bỡn * "Dò sông dò biển dễ dò, Nào ai lấy thước mà đo lòng người." (ca dao)',
    example:
      'bài toán dễ * dễ như bỡn * "Dò sông dò biển dễ dò, Nào ai lấy thước mà đo lòng người." (ca dao)',
  },
  {
    word: "dễ",
    part_of_speech: "tính từ",
    meaning: "không đòi hỏi nhiều để có thể hài lòng: tính anh ấy dễ",
    example: "tính anh ấy dễ",
  },
  {
    word: "dễ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có nhiều khả năng (là như vậy): việc này dễ phải ba bốn ngày mới xong",
    example: "việc này dễ phải ba bốn ngày mới xong",
  },
  {
    word: "dễ dãi",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra dễ hài lòng, không chặt chẽ trong các đòi hỏi, yêu cầu: tính dễ dãi",
    example: "tính dễ dãi",
  },
  {
    word: "dễ dàng",
    part_of_speech: "tính từ",
    meaning:
      "có vẻ dễ, không đòi hỏi nhiều điều kiện, nhiều công phu: làm ăn dễ dàng * việc ấy quá dễ dàng",
    example: "làm ăn dễ dàng * việc ấy quá dễ dàng",
  },
  {
    word: "dễ dầu",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) như dễ (nhưng thường dùng trong câu có ý phủ định): việc này, không dễ dầu gì mà làm được",
    example: "việc này, không dễ dầu gì mà làm được",
  },
  {
    word: "dễ ợt",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ, khẩu ngữ) rất dễ, quá dễ: bài toán dễ ợt",
    example: "bài toán dễ ợt",
  },
  {
    word: "dễ thở",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (về đời sống) có cảm giác dễ chịu hơn, đỡ khó khăn hơn: đời sống đã dễ thở đôi chút",
    example: "đời sống đã dễ thở đôi chút",
  },
  {
    word: "dễ sợ",
    part_of_speech: "phụ từ",
    meaning:
      "(phương ngữ, khẩu ngữ) đến một mức độ rất cao và gây ấn tượng mạnh mẽ: đẹp dễ sợ * bà ta ghen dễ sợ",
    example: "đẹp dễ sợ * bà ta ghen dễ sợ",
  },
  {
    word: "dễ thương",
    part_of_speech: "tính từ",
    meaning:
      "dễ gây được tình cảm mến thương ở người khác: khuôn mặt dễ thương * giọng nói nghe rất dễ thương",
    example: "khuôn mặt dễ thương * giọng nói nghe rất dễ thương",
  },
  {
    word: "dê-rô",
    part_of_speech: "danh từ",
    meaning:
      "số không: con zero * giá trị zero * tốc độ tăng trưởng cả năm là zero",
    example: "con zero * giá trị zero * tốc độ tăng trưởng cả năm là zero",
  },
  {
    word: "dễ thường",
    part_of_speech: "phụ từ",
    meaning:
      "rất có thể: dễ thường phải mai trời mới tạnh * dễ thường anh ta chưa biết nên mới nói thế",
    example:
      "dễ thường phải mai trời mới tạnh * dễ thường anh ta chưa biết nên mới nói thế",
  },
  {
    word: "dễ thường",
    part_of_speech: "phụ từ",
    meaning: "như chẳng lẽ: dễ thường mẹ lại không thương con hay sao?",
    example: "dễ thường mẹ lại không thương con hay sao?",
  },
  {
    word: "dễ tính",
    part_of_speech: "tính từ",
    meaning:
      "có tính dễ dãi, không đòi hỏi nhiều để có thể hài lòng: một người dễ tính * thị trường ở đây được tiếng là dễ tính",
    example: "một người dễ tính * thị trường ở đây được tiếng là dễ tính",
  },
  {
    word: "dềnh dang",
    part_of_speech: "",
    meaning: "(hiếm) như dềnh dàng: đã muộn lại còn dềnh dang mãi",
    example: "đã muộn lại còn dềnh dang mãi",
  },
  {
    word: "dềnh",
    part_of_speech: "động từ",
    meaning: "(nước) dâng cao và tràn lên: nước sông dềnh lên xăp xắp mặt đê",
    example: "nước sông dềnh lên xăp xắp mặt đê",
  },
  {
    word: "dềnh",
    part_of_speech: "động từ",
    meaning:
      "bị nâng cao lên, tựa như vật nổi lên theo ngọn sóng: gỗ dềnh lên trên mặt nước",
    example: "gỗ dềnh lên trên mặt nước",
  },
  {
    word: "dì",
    part_of_speech: "danh từ",
    meaning:
      "em gái hoặc chị của mẹ (có thể dùng để xưng gọi): sẩy cha còn chú, sẩy mẹ bú dì (tng)",
    example: "sẩy cha còn chú, sẩy mẹ bú dì (tng)",
  },
  {
    word: "dềnh dàng",
    part_of_speech: "tính từ",
    meaning:
      "chậm chạp, không khẩn trương, để mất nhiều thì giờ vào những việc không cần thiết: làm ăn dềnh dàng * đã muộn lại còn dềnh dàng mãi!",
    example: "làm ăn dềnh dàng * đã muộn lại còn dềnh dàng mãi!",
  },
  {
    word: "dềnh dàng",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) to lớn và gây cảm giác cồng kềnh: thân hình cao lớn dềnh dàng",
    example: "thân hình cao lớn dềnh dàng",
  },
  {
    word: "di",
    part_of_speech: "động từ",
    meaning:
      "dùng bàn chân hay bàn tay đè mạnh lên một vật và xát đi xát lại trên vật đó: lấy chân di tàn thuốc lá",
    example: "lấy chân di tàn thuốc lá",
  },
  {
    word: "dệt kim",
    part_of_speech: "động từ",
    meaning:
      "dệt bằng cách dùng một loại kim đặc biệt để lồng sợi vào nhau kết thành tấm: quần áo dệt kim",
    example: "quần áo dệt kim",
  },
  {
    word: "dệt",
    part_of_speech: "động từ",
    meaning:
      "làm cho sợi kết vào với nhau thành tấm theo những quy cách nhất định, để tạo ra vải, chiếu, v.v.: xe tơ dệt lụa * công nhân nhà máy dệt",
    example: "xe tơ dệt lụa * công nhân nhà máy dệt",
  },
  {
    word: "dị",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) (hành vi, cử chỉ) khác thường một cách thái quá, đáng chê: ăn mặc lố lăng, coi dị quá",
    example: "ăn mặc lố lăng, coi dị quá",
  },
  {
    word: "dị",
    part_of_speech: "tính từ",
    meaning: "ngượng, xấu hổ: giành nhau với em mà không biết dị à!",
    example: "giành nhau với em mà không biết dị à!",
  },
  {
    word: "dệt gấm thêu hoa",
    part_of_speech: "",
    meaning:
      '(cũ, văn chương) ví việc tô điểm làm cho đẹp thêm, hay thêm: "Dẫu cho dệt gấm thêu hoa, Vô duyên cũng đến chịu già mà thôi." (ca dao)',
    example:
      'Dẫu cho dệt gấm thêu hoa, Vô duyên cũng đến chịu già mà thôi." (ca dao)',
  },
  {
    word: "di ảnh",
    part_of_speech: "danh từ",
    meaning:
      "(Trang trọng) ảnh (lúc còn sống) của người chết còn để lại: di ảnh của Hồ Chủ tịch",
    example: "di ảnh của Hồ Chủ tịch",
  },
  {
    word: "dị biệt",
    part_of_speech: "",
    meaning:
      "khác hẳn hoặc trái ngược khi so sánh với nhau hoặc so với những cái cùng loại: những nét tương đồng và dị biệt giữa hai nền văn hoá",
    example: "những nét tương đồng và dị biệt giữa hai nền văn hoá",
  },
  {
    word: "dị bản",
    part_of_speech: "danh từ",
    meaning:
      "bản có những chỗ khác với bản được phổ biến rộng rãi của một tác phẩm văn học: các dị bản của Truyện Kiều",
    example: "các dị bản của Truyện Kiều",
  },
  {
    word: "di bản",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) bản viết hoặc in của thời trước còn lưu lại: tìm thấy di bản Truyện Kiều cổ nhất",
    example: "tìm thấy di bản Truyện Kiều cổ nhất",
  },
  {
    word: "di biểu",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) biểu của một đại thần để lại trước khi chết: di biểu của Hoàng Diệu khi Hà Nội thất thủ năm 1882",
    example: "di biểu của Hoàng Diệu khi Hà Nội thất thủ năm 1882",
  },
  {
    word: "di bút",
    part_of_speech: "danh từ",
    meaning:
      "chữ viết của người chết còn để lại trên giấy tờ: di bút của nhà văn",
    example: "di bút của nhà văn",
  },
  {
    word: "di chiếu",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) chiếu của vua để lại trước khi chết: làm theo di chiếu của tiên đế",
    example: "làm theo di chiếu của tiên đế",
  },
  {
    word: "di chứng",
    part_of_speech: "danh từ",
    meaning:
      "chứng tật còn lại lâu dài sau khi đã khỏi bệnh: di chứng viêm màng não * di chứng của chất độc màu da cam",
    example: "di chứng viêm màng não * di chứng của chất độc màu da cam",
  },
  {
    word: "di cảo",
    part_of_speech: "danh từ",
    meaning: "bản thảo tác phẩm của người chết để lại: tập di cảo",
    example: "tập di cảo",
  },
  {
    word: "di chúc",
    part_of_speech: "danh từ",
    meaning: "(trang trọng) lời hoặc bản di chúc: thực hiện di chúc",
    example: "thực hiện di chúc",
  },
  {
    word: "di chỉ",
    part_of_speech: "danh từ",
    meaning:
      "nơi còn có dấu vết cư trú và sinh sống của người xưa: phát hiện những khu di chỉ của thời đại Hùng Vương",
    example: "phát hiện những khu di chỉ của thời đại Hùng Vương",
  },
  {
    word: "di căn",
    part_of_speech: "động từ",
    meaning:
      "(quá trình bệnh lí) truyền sang bộ phận hoặc cơ quan khác của cơ thể ở xa ổ bệnh đầu tiên: ung thư đã đến giai đoạn di căn",
    example: "ung thư đã đến giai đoạn di căn",
  },
  {
    word: "di cốt",
    part_of_speech: "danh từ",
    meaning:
      "xương cốt còn lưu lại của người hoặc động vật chết đã lâu: di cốt của người xưa",
    example: "di cốt của người xưa",
  },
  {
    word: "dí dỏm",
    part_of_speech: "tính từ",
    meaning:
      "có tác dụng gây vui, gây cười một cách nhẹ nhõm và có ý vị: cười một cách dí dỏm * câu pha trò dí dỏm",
    example: "cười một cách dí dỏm * câu pha trò dí dỏm",
  },
  {
    word: "di chuyển",
    part_of_speech: "động từ",
    meaning:
      "dời chỗ, chuyển đi nơi khác (thường nói về cái có quy mô lớn): di chuyển cơ quan đến địa điểm mới * bão di chuyển theo hướng tây",
    example:
      "di chuyển cơ quan đến địa điểm mới * bão di chuyển theo hướng tây",
  },
  {
    word: "dị đoan",
    part_of_speech: "danh từ, tính từ",
    meaning:
      "lòng tin vào điều quái lạ, huyền hoặc, nhảm nhí: mê tín dị đoan * Bà ấy dị đoan lắm.",
    example: "mê tín dị đoan * Bà ấy dị đoan lắm.",
  },
  {
    word: "dị dạng",
    part_of_speech: "",
    meaning: "hình dạng kì lạ, khác thường: thân hình dị dạng",
    example: "thân hình dị dạng",
  },
  {
    word: "di dời",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) chuyển đi, dời chỗ đi nơi khác, nói chung: nhanh chóng di dời dân ra khỏi vùng lũ lụt * toà soạn báo đã di dời đi nơi khác",
    example:
      "nhanh chóng di dời dân ra khỏi vùng lũ lụt * toà soạn báo đã di dời đi nơi khác",
  },
  {
    word: "di cư",
    part_of_speech: "động từ",
    meaning: "dời đến ở một miền hay một nước khác để sinh sống: di cư vào Nam",
    example: "di cư vào Nam",
  },
  {
    word: "di cư",
    part_of_speech: "động từ",
    meaning: "(Ít dùng) như di trú: đàn chim di cư",
    example: "đàn chim di cư",
  },
  {
    word: "di dân",
    part_of_speech: "động từ",
    meaning:
      "đưa dân dời đến vùng khác để sinh sống, để thực hiện những mục đích nhất định nào đó: di dân ra khỏi vùng lòng hồ sông Đà",
    example: "di dân ra khỏi vùng lòng hồ sông Đà",
  },
  {
    word: "di dân",
    part_of_speech: "danh từ",
    meaning: "(hiếm) dân di cư: di dân lập làng sinh sống",
    example: "di dân lập làng sinh sống",
  },
  {
    word: "dì ghẻ",
    part_of_speech: "danh từ",
    meaning:
      "vợ kế của cha, trong quan hệ với con của vợ trước: cảnh dì ghẻ con chồng",
    example: "cảnh dì ghẻ con chồng",
  },
  {
    word: "di duệ",
    part_of_speech: "danh từ",
    meaning: "(cũ) như hậu duệ: di duệ của Nguyễn Trãi",
    example: "di duệ của Nguyễn Trãi",
  },
  {
    word: "dị giáo",
    part_of_speech: "danh từ",
    meaning:
      "tôn giáo khác với tôn giáo của mình (và bị lên án): toà án dị giáo",
    example: "toà án dị giáo",
  },
  {
    word: "di dưỡng",
    part_of_speech: "động từ",
    meaning:
      'bồi bổ, tạo điều kiện cho có được sự phát triển tốt, khắc phục sự suy sút có thể có (thường nói về mặt tinh thần): "Những lúc không có hứng, thì chàng phải nghỉ, phải chơi để di dưỡng tinh thần." (NgCHoan; 11)',
    example:
      'Những lúc không có hứng, thì chàng phải nghỉ, phải chơi để di dưỡng tinh thần." (NgCHoan; 11)',
  },
  {
    word: "di hại",
    part_of_speech: "danh từ",
    meaning: "cái hại về sau: cơn bão lớn đã để lại những di hại nặng nề",
    example: "cơn bão lớn đã để lại những di hại nặng nề",
  },
  {
    word: "di động",
    part_of_speech: "động từ",
    meaning: "chuyển động thay đổi vị trí: mục tiêu di động",
    example: "mục tiêu di động",
  },
  {
    word: "di hài",
    part_of_speech: "danh từ",
    meaning:
      "(Trang trọng) thi hài hoặc hài cốt còn lưu lại: di hài của chủ tịch Hồ Chí Minh",
    example: "di hài của chủ tịch Hồ Chí Minh",
  },
  {
    word: "dị đồng",
    part_of_speech: "tính từ",
    meaning:
      "giống nhau và khác nhau: so sánh những chỗ dị đồng giữa hai văn bản",
    example: "so sánh những chỗ dị đồng giữa hai văn bản",
  },
  {
    word: "dị đồng",
    part_of_speech: "tính từ",
    meaning:
      "không hoàn toàn giống nhau: trao đổi ý kiến dị đồng, bổ sung lẫn cho nhau",
    example: "trao đổi ý kiến dị đồng, bổ sung lẫn cho nhau",
  },
  {
    word: "di hoạ",
    part_of_speech: "danh từ",
    meaning: "tai hoạ còn để lại cho cả đời sau: di hoạ của chiến tranh",
    example: "di hoạ của chiến tranh",
  },
  {
    word: "dị hờm",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) kì quái, khác người đến mức lập dị: mặt mũi dị hợm * ăn mặc dị hợm",
    example: "mặt mũi dị hợm * ăn mặc dị hợm",
  },
  {
    word: "dị hợm",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) kì quái, khác người đến mức lập dị: mặt mũi dị hợm * ăn mặc dị hợm",
    example: "mặt mũi dị hợm * ăn mặc dị hợm",
  },
  {
    word: "di huấn",
    part_of_speech: "danh từ",
    meaning:
      "lời dạy lúc sinh thời hoặc để lại sau khi mất: thực hiện những di huấn của Hồ Chủ tịch",
    example: "thực hiện những di huấn của Hồ Chủ tịch",
  },
  {
    word: "dị kì",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như kì dị: tính nết dị kì",
    example: "tính nết dị kì",
  },
  {
    word: "di lí",
    part_of_speech: "động từ",
    meaning: "chuyển đến nơi khác để xử lí: vụ án đã được di lí lên tỉnh",
    example: "vụ án đã được di lí lên tỉnh",
  },
  {
    word: "dị nghị",
    part_of_speech: "động từ",
    meaning:
      "bàn tán với ý chê trách, phản đối: làng xóm dị nghị, điều ra tiếng vào * những lời dị nghị",
    example: "làng xóm dị nghị, điều ra tiếng vào * những lời dị nghị",
  },
  {
    word: "di lý",
    part_of_speech: "động từ",
    meaning: "chuyển đến nơi khác để xử lí: vụ án đã được di lí lên tỉnh",
    example: "vụ án đã được di lí lên tỉnh",
  },
  {
    word: "dĩ nhiên",
    part_of_speech: "tính từ",
    meaning:
      "theo lẽ thường là vậy, không có gì lạ hoặc khó hiểu: lẽ dĩ nhiên là sẽ như vậy * dĩ nhiên, cha mẹ nào chẳng yêu con",
    example: "lẽ dĩ nhiên là sẽ như vậy * dĩ nhiên, cha mẹ nào chẳng yêu con",
  },
  {
    word: "dị tật",
    part_of_speech: "danh từ",
    meaning:
      "hiện tượng biến đổi bất thường về hình thái hay chức năng của bộ phận nào đó trong cơ thể, khi sinh ra đã có (một chứng bệnh kì quái): dị tật bẩm sinh",
    example: "dị tật bẩm sinh",
  },
  {
    word: "di tản",
    part_of_speech: "động từ",
    meaning:
      "lánh dời đi ở hẳn nơi khác, thường rất xa: di tản về các vùng nông thôn hẻo lánh * di tản ra nước ngoài",
    example: "di tản về các vùng nông thôn hẻo lánh * di tản ra nước ngoài",
  },
  {
    word: "di sản",
    part_of_speech: "danh từ",
    meaning: "tài sản của người chết để lại: được thừa kế một di sản lớn",
    example: "được thừa kế một di sản lớn",
  },
  {
    word: "di sản",
    part_of_speech: "danh từ",
    meaning:
      "tài sản tinh thần hoặc tài sản vật chất do lịch sử để lại hoặc do thiên nhiên tạo ra: bảo vệ di sản văn hoá * di sản phi vật thể",
    example: "bảo vệ di sản văn hoá * di sản phi vật thể",
  },
  {
    word: "di thực",
    part_of_speech: "động từ",
    meaning:
      "đưa một giống cây hoặc một cây giống đến trồng ở một vùng khác: cacao, cao su được di thực và đem trồng ở Tây Nguyên",
    example: "cacao, cao su được di thực và đem trồng ở Tây Nguyên",
  },
  {
    word: "di thực",
    part_of_speech: "động từ",
    meaning: "di cư đến sinh sống ở vùng khác: phải di thực nơi khác",
    example: "phải di thực nơi khác",
  },
  {
    word: "dị thường",
    part_of_speech: "tính từ",
    meaning:
      "khác hẳn với những gì thường thấy, đến mức làm ngạc nhiên: người cao lớn dị thường * câu chuyện dị thường",
    example: "người cao lớn dị thường * câu chuyện dị thường",
  },
  {
    word: "di tích",
    part_of_speech: "danh từ",
    meaning:
      "dấu vết của người hoặc sự việc thời xưa hoặc thời trước đây còn để lại: bảo tồn di tích lịch sử",
    example: "bảo tồn di tích lịch sử",
  },
  {
    word: "di truyền",
    part_of_speech: "động từ",
    meaning:
      "(đặc tính của sinh vật) truyền lại cho thế hệ sau những điểm giống thế hệ trước, về cấu tạo cũng như về lối sống: bệnh di truyền * yếu tố di truyền",
    example: "bệnh di truyền * yếu tố di truyền",
  },
  {
    word: "di trú",
    part_of_speech: "động từ",
    meaning: "(cũ, hiếm) dời đến ở nơi khác: di trú vào Nam",
    example: "di trú vào Nam",
  },
  {
    word: "di trú",
    part_of_speech: "động từ",
    meaning:
      "(hiện tượng một số loài chim, thú) hằng năm chuyển đến sống ở nơi ấm áp, để tránh rét: mùa đông, chim di trú đến phương nam tránh rét",
    example: "mùa đông, chim di trú đến phương nam tránh rét",
  },
  {
    word: "di vật",
    part_of_speech: "danh từ",
    meaning:
      "đồ vật được giữ lại của một thời xa xưa hoặc của người đã mất: tìm thấy nhiều di vật lịch sử * di vật của người quá cố",
    example: "tìm thấy nhiều di vật lịch sử * di vật của người quá cố",
  },
  {
    word: "dị ứng",
    part_of_speech: "",
    meaning:
      "trạng thái mẫn cảm đặc biệt của cơ thể, biểu hiện bằng một phản ứng bất thường và quá mức khi tiếp xúc với một tác nhân nào đó: viêm mũi dị ứng * rất dị ứng với loại trưởng giả học làm sang",
    example: "viêm mũi dị ứng * rất dị ứng với loại trưởng giả học làm sang",
  },
  {
    word: "di truyền học",
    part_of_speech: "danh từ",
    meaning:
      "khoa học nghiên cứu về các hiện tượng và quy luật di truyền: tiến sĩ di truyền học",
    example: "tiến sĩ di truyền học",
  },
  {
    word: "dị vật",
    part_of_speech: "danh từ",
    meaning:
      "vật khác lạ ở ngoài xâm nhập vào cơ thể, gây thương tích, đau đớn: phát hiện dị vật trong khí quản",
    example: "phát hiện dị vật trong khí quản",
  },
  {
    word: "dịch",
    part_of_speech: "danh từ",
    meaning: "chất lỏng trong cơ thể: tràn dịch màng phổi",
    example: "tràn dịch màng phổi",
  },
  {
    word: "dịch",
    part_of_speech: "danh từ",
    meaning:
      "tình trạng bệnh lây lan truyền rộng trong một thời gian: vùng có dịch cúm * tiêm phòng dịch",
    example: "vùng có dịch cúm * tiêm phòng dịch",
  },
  {
    word: "dịch",
    part_of_speech: "động từ",
    meaning:
      "chuyển đổi vị trí trong khoảng rất ngắn: dịch từng bước một * kê dịch cái tủ sang bên phải một chút",
    example: "dịch từng bước một * kê dịch cái tủ sang bên phải một chút",
  },
  {
    word: "dịch",
    part_of_speech: "động từ",
    meaning:
      "chuyển nội dung diễn đạt từ ngôn ngữ (hoặc hệ thống tín hiệu) này sang ngôn ngữ (hoặc hệ thống tín hiệu) khác: dịch từ tiếng Anh ra tiếng Việt * dịch mật mã",
    example: "dịch từ tiếng Anh ra tiếng Việt * dịch mật mã",
  },
  {
    word: "dĩ vãng",
    part_of_speech: "danh từ",
    meaning: "thời đã qua: thời dĩ vãng * chuyện đó đã thuộc về dĩ vãng",
    example: "thời dĩ vãng * chuyện đó đã thuộc về dĩ vãng",
  },
  {
    word: "dịch chuyển",
    part_of_speech: "động từ",
    meaning: "như chuyển dịch: bàn ghế bị dịch chuyển",
    example: "bàn ghế bị dịch chuyển",
  },
  {
    word: "dĩa",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng thường bằng kim loại, có dạng như cái thìa nhưng đầu có răng nhọn, cán dẹt, dùng để lấy thức ăn.",
    example: "dùng nĩa xúc vôi",
  },
  {
    word: "dịch bệnh",
    part_of_speech: "danh từ",
    meaning:
      "bệnh gây thành dịch: đẩy lùi được dịch bệnh * tôm bị dịch bệnh, chết hàng loạt",
    example: "đẩy lùi được dịch bệnh * tôm bị dịch bệnh, chết hàng loạt",
  },
  {
    word: "dích dắc",
    part_of_speech: "danh từ",
    meaning: "đường gấp khúc: đường dích dắc chữ chi",
    example: "đường dích dắc chữ chi",
  },
  {
    word: "dịch tễ",
    part_of_speech: "danh từ",
    meaning: "bệnh dịch (nói khái quát): công tác vệ sinh dịch tễ",
    example: "công tác vệ sinh dịch tễ",
  },
  {
    word: "dịch vụ",
    part_of_speech: "danh từ",
    meaning:
      "công việc phục vụ trực tiếp cho những nhu cầu nhất định của số đông, có tổ chức và được trả công: công ti thương mại và dịch vụ * dịch vụ cầm đồ",
    example: "công ti thương mại và dịch vụ * dịch vụ cầm đồ",
  },
  {
    word: "dịch thuật",
    part_of_speech: "động từ",
    meaning:
      "dịch sách báo, tài liệu (nói khái quát): công tác nghiên cứu, dịch thuật",
    example: "công tác nghiên cứu, dịch thuật",
  },
  {
    word: "diếc",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) cá diếc (nói tắt): tham con diếc, tiếc con rô (tng)",
    example: "tham con diếc, tiếc con rô (tng)",
  },
  {
    word: "diesel",
    part_of_speech: "danh từ",
    meaning:
      "động cơ đốt trong dùng nhiên liệu lỏng (thường là dầu ma dút) phun vào không khí nén và làm cho bốc cháy: động cơ diesel",
    example: "động cơ diesel",
  },
  {
    word: "diêm",
    part_of_speech: "danh từ",
    meaning:
      "que nhỏ, một đầu tẩm hoá chất có khả năng bốc cháy khi cọ xát, dùng để lấy lửa: hộp diêm * que diêm",
    example: "hộp diêm * que diêm",
  },
  {
    word: "diềm",
    part_of_speech: "danh từ",
    meaning:
      "phần trang trí gồm những hình hoặc những đường nét lặp đi lặp lại thành một dải chạy dài theo chiều ngang hoặc viền xung quanh: diềm áo làm bằng lụa hoa",
    example: "diềm áo làm bằng lụa hoa",
  },
  {
    word: "diêm dúa",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất phô trương hình thức, làm đẹp một cách quá cầu kì (thường nói về cách ăn mặc): ăn mặc diêm dúa * chiếc váy rất diêm dúa",
    example: "ăn mặc diêm dúa * chiếc váy rất diêm dúa",
  },
  {
    word: "diễm lệ",
    part_of_speech: "tính từ",
    meaning: "đẹp một cách rực rỡ, lộng lẫy: nhan sắc diễm lệ",
    example: "nhan sắc diễm lệ",
  },
  {
    word: "diễm phúc",
    part_of_speech: "",
    meaning:
      "hạnh phúc tốt đẹp do may mắn mà có: có diễm phúc được gặp tổng thống",
    example: "có diễm phúc được gặp tổng thống",
  },
  {
    word: "diễn",
    part_of_speech: "động từ",
    meaning: "biểu diễn (nói tắt): diễn văn nghệ",
    example: "diễn văn nghệ",
  },
  {
    word: "diễn",
    part_of_speech: "động từ",
    meaning:
      "hoạt động tựa như người thật, việc thật để trình bày cho xem: bắt hung thủ diễn lại hành động giết người",
    example: "bắt hung thủ diễn lại hành động giết người",
  },
  {
    word: "diễn",
    part_of_speech: "động từ",
    meaning: "(Ít dùng) như diễn đạt: bài viết không diễn hết ý của tác giả",
    example: "bài viết không diễn hết ý của tác giả",
  },
  {
    word: "diễn",
    part_of_speech: "động từ",
    meaning:
      "(diễn ra) xảy ra và tiến triển: sự việc diễn ra ngoài dự kiến * cuộc chia tay diễn ra đầy lưu luyến",
    example:
      "sự việc diễn ra ngoài dự kiến * cuộc chia tay diễn ra đầy lưu luyến",
  },
  {
    word: "diện",
    part_of_speech: "động từ",
    meaning:
      "tự làm hoặc làm cho có được một vẻ bên ngoài đẹp đẽ sang trọng, bằng những đồ phục sức: diện quần áo mới",
    example: "diện quần áo mới",
  },
  {
    word: "diện",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có tác dụng làm cho con người có được một vẻ bên ngoài đẹp và sang trọng: ăn mặc diện * đi đâu mà diện thế?",
    example: "ăn mặc diện * đi đâu mà diện thế?",
  },
  {
    word: "diện",
    part_of_speech: "danh từ",
    meaning:
      "một trong những mặt của sự vật, trong phạm vi ấy có sự biểu hiện những thuộc tính hoặc tác động nào đó: diện tiếp xúc giữa hai vật * nghiên cứu ngôn ngữ trên diện đồng đại",
    example:
      "diện tiếp xúc giữa hai vật * nghiên cứu ngôn ngữ trên diện đồng đại",
  },
  {
    word: "diện",
    part_of_speech: "danh từ",
    meaning:
      "phạm vi bao gồm những đối tượng chịu cùng một tác động nhất định như nhau nào đó: ở trong diện được ưu tiên * không còn thuộc diện hộ nghèo",
    example: "ở trong diện được ưu tiên * không còn thuộc diện hộ nghèo",
  },
  {
    word: "diễm tình",
    part_of_speech: "danh từ",
    meaning: "(cũ, văn chương) mối tình đẹp: câu chuyện diễm tình",
    example: "câu chuyện diễm tình",
  },
  {
    word: "diêm vương",
    part_of_speech: "danh từ",
    meaning: "vua âm phủ (theo mê tín): đi gặp Diêm Vương (kng; chết)",
    example: "đi gặp Diêm Vương (kng; chết)",
  },
  {
    word: "diễn ca",
    part_of_speech: "danh từ",
    meaning:
      "thể loại văn vần dùng lời thơ lục bát hoặc song thất lục bát để trình bày một nội dung (thường là nội dung lịch sử):  là tập diễn ca lịch sử Việt Nam",
    example: "là tập diễn ca lịch sử Việt Nam",
  },
  {
    word: "diễn biến",
    part_of_speech: "",
    meaning:
      "diễn ra sự biến đổi: sự việc diễn biến theo chiều hướng xấu * kể lại diễn biến của trận đánh",
    example:
      "sự việc diễn biến theo chiều hướng xấu * kể lại diễn biến của trận đánh",
  },
  {
    word: "diễn đạt",
    part_of_speech: "động từ",
    meaning:
      "tỏ rõ nội dung tư tưởng, tình cảm bằng ngôn ngữ hoặc hình thức nào đó: diễn đạt tư tưởng * một tình cảm khó diễn đạt bằng lời",
    example: "diễn đạt tư tưởng * một tình cảm khó diễn đạt bằng lời",
  },
  {
    word: "diễn cảm",
    part_of_speech: "động từ",
    meaning:
      "đi từ những nguyên lí chung đến những kết luận riêng; trái với quy nạp: phương pháp suy diễn",
    example: "phương pháp suy diễn",
  },
  {
    word: "diễn cảm",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) suy ra điều này điều nọ một cách chủ quan: suy diễn ra đủ chuyện",
    example: "suy diễn ra đủ chuyện",
  },
  {
    word: "diễn đàn",
    part_of_speech: "danh từ",
    meaning:
      "nơi đứng để diễn thuyết, phát biểu trước đông người: lên diễn đàn phát biểu",
    example: "lên diễn đàn phát biểu",
  },
  {
    word: "diễn đàn",
    part_of_speech: "danh từ",
    meaning:
      "nơi để cho nhiều người có thể phát biểu ý kiến một cách công khai và rộng rãi: diễn đàn hợp tác kinh tế châu Á - Thái Bình Dương",
    example: "diễn đàn hợp tác kinh tế châu Á - Thái Bình Dương",
  },
  {
    word: "diễn giảng",
    part_of_speech: "động từ",
    meaning:
      "giảng hoặc khuyên nhủ theo lối trình bày một cách có hệ thống từ đầu đến cuối: diễn giảng điển tích * ham mê cờ bạc, diễn giảng thế nào cũng không được",
    example:
      "diễn giảng điển tích * ham mê cờ bạc, diễn giảng thế nào cũng không được",
  },
  {
    word: "diễn tả",
    part_of_speech: "động từ",
    meaning:
      "dùng ngôn ngữ hoặc cử chỉ, điệu bộ, v.v. làm cho người ta có thể hình dung được rõ một hiện tượng tâm lí nào đó: ánh mắt diễn tả tình cảm * một cảm giác rất lạ, không thể nào diễn tả nổi",
    example:
      "ánh mắt diễn tả tình cảm * một cảm giác rất lạ, không thể nào diễn tả nổi",
  },
  {
    word: "diễn giải",
    part_of_speech: "động từ",
    meaning: "diễn đạt và giải thích: diễn giải vấn đề một cách ngắn gọn",
    example: "diễn giải vấn đề một cách ngắn gọn",
  },
  {
    word: "diện mạo",
    part_of_speech: "danh từ",
    meaning: "bộ mặt, vẻ mặt con người: diện mạo khôi ngô, tuấn tú",
    example: "diện mạo khôi ngô, tuấn tú",
  },
  {
    word: "diễn thuyết",
    part_of_speech: "động từ",
    meaning:
      "nói trước công chúng về một vấn đề gì, thường nhằm mục đích tuyên truyền, thuyết phục: diễn thuyết về tự do tín ngưỡng * nghe diễn thuyết",
    example: "diễn thuyết về tự do tín ngưỡng * nghe diễn thuyết",
  },
  {
    word: "diễn tấu",
    part_of_speech: "động từ",
    meaning: "biểu diễn bằng nhạc cụ: diễn tấu một bản nhạc dân tộc",
    example: "diễn tấu một bản nhạc dân tộc",
  },
  {
    word: "diện tích",
    part_of_speech: "danh từ",
    meaning:
      "số các hình vuông đơn vị có trong một mặt phẳng hay trên một mặt không gian nào đó: tính diện tích hình chữ nhật * đo diện tích cánh đồng",
    example: "tính diện tích hình chữ nhật * đo diện tích cánh đồng",
  },
  {
    word: "diện tích",
    part_of_speech: "danh từ",
    meaning:
      "bề mặt của ruộng đất, về mặt độ rộng: mở rộng diện tích đất trồng trọt * xây hết diện tích, không để sân",
    example:
      "mở rộng diện tích đất trồng trọt * xây hết diện tích, không để sân",
  },
  {
    word: "diễn tập",
    part_of_speech: "động từ",
    meaning:
      "luyện tập tổng hợp, với các tình huống như thật: bộ đội diễn tập thường xuyên * buổi diễn tập của lực lượng phòng cháy chữa cháy",
    example:
      "bộ đội diễn tập thường xuyên * buổi diễn tập của lực lượng phòng cháy chữa cháy",
  },
  {
    word: "diễn tập",
    part_of_speech: "động từ",
    meaning: "diễn để tập dượt, rút kinh nghiệm: diễn tập vở kịch",
    example: "diễn tập vở kịch",
  },
  {
    word: "diễn từ",
    part_of_speech: "danh từ",
    meaning:
      "(trang trọng) lời phát biểu trong dịp long trọng: thủ tướng đọc diễn từ nhậm chức",
    example: "thủ tướng đọc diễn từ nhậm chức",
  },
  {
    word: "diễn nghĩa",
    part_of_speech: "động từ",
    meaning:
      "dựa theo sử hoặc truyền thuyết, viết thành tiểu thuyết theo thể chương hồi (một hình thức tiểu thuyết lịch sử cổ của Trung Quốc): truyện Tam quốc diễn nghĩa",
    example: "truyện Tam quốc diễn nghĩa",
  },
  {
    word: "diễn văn",
    part_of_speech: "danh từ",
    meaning:
      "bài phát biểu tương đối dài đọc trong dịp long trọng: diễn văn khai mạc hội nghị * đọc diễn văn",
    example: "diễn văn khai mạc hội nghị * đọc diễn văn",
  },
  {
    word: "diễn xuất",
    part_of_speech: "động từ",
    meaning:
      "thể hiện hình tượng nhân vật của kịch hoặc truyện phim trong vai mình đóng: tài năng diễn xuất * diễn xuất rất đạt",
    example: "tài năng diễn xuất * diễn xuất rất đạt",
  },
  {
    word: "diễn viên",
    part_of_speech: "danh từ",
    meaning:
      "người diễn xuất hoặc biểu diễn nghệ thuật trên sân khấu hay trên phim ảnh: diễn viên điện ảnh * diễn viên chuyên nghiệp",
    example: "diễn viên điện ảnh * diễn viên chuyên nghiệp",
  },
  {
    word: "diễn xướng",
    part_of_speech: "động từ",
    meaning:
      "trình bày sáng tác dân gian bằng động tác, lời lẽ, âm thanh, nhịp điệu: những hình thức diễn xướng dân gian",
    example: "những hình thức diễn xướng dân gian",
  },
  {
    word: "diệt",
    part_of_speech: "động từ",
    meaning:
      "làm cho không còn tồn tại để không thể tác động được nữa: thuốc diệt chuột * diệt giặc",
    example: "thuốc diệt chuột * diệt giặc",
  },
  {
    word: "diệt chủng",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) làm cho bị mất hẳn nòi giống: loài động vật này đã thoát khỏi nguy cơ bị diệt chủng",
    example: "loài động vật này đã thoát khỏi nguy cơ bị diệt chủng",
  },
  {
    word: "diệt chủng",
    part_of_speech: "động từ",
    meaning:
      "giết người hàng loạt và huỷ hoại các điều kiện sinh sống, làm cho một chủng tộc, một dân tộc bị diệt vong: tội ác diệt chủng",
    example: "tội ác diệt chủng",
  },
  {
    word: "diệt trùng",
    part_of_speech: "động từ",
    meaning: "như sát trùng: thuốc diệt trùng",
    example: "thuốc diệt trùng",
  },
  {
    word: "diệt vong",
    part_of_speech: "động từ",
    meaning:
      "bị tiêu diệt, hoàn toàn không còn tồn tại (nói về hiện tượng xã hội): một bộ tộc có nguy cơ bị diệt vong",
    example: "một bộ tộc có nguy cơ bị diệt vong",
  },
  {
    word: "diễu hành",
    part_of_speech: "động từ",
    meaning:
      "(đoàn người) đi thành hàng ngũ diễu qua trước lễ đài hoặc trên đường phố để biểu dương sức mạnh hoặc để biểu thị thái độ chính trị: đoàn biểu tình diễu hành qua các phố lớn",
    example: "đoàn biểu tình diễu hành qua các phố lớn",
  },
  {
    word: "diệt trừ",
    part_of_speech: "động từ",
    meaning:
      "diệt hết để cho không còn tác hại nữa: diệt trừ mối * diệt trừ tận gốc mầm mống phản loạn",
    example: "diệt trừ mối * diệt trừ tận gốc mầm mống phản loạn",
  },
  {
    word: "diều",
    part_of_speech: "danh từ",
    meaning: "diều hâu (nói tắt): diều tha, quạ mổ (tng)",
    example: "diều tha, quạ mổ (tng)",
  },
  {
    word: "diều",
    part_of_speech: "danh từ",
    meaning:
      "đồ chơi làm bằng một khung tre dán kín giấy có buộc dây dài, khi cầm dây kéo ngược chiều gió thì bay lên cao: thả diều",
    example: "thả diều",
  },
  {
    word: "diều",
    part_of_speech: "danh từ",
    meaning:
      "chỗ phình của thực quản ở một số loài chim, sâu bọ, v.v. để chứa thức ăn: gà ăn no căng diều",
    example: "gà ăn no căng diều",
  },
  {
    word: "diễu binh",
    part_of_speech: "động từ",
    meaning:
      "(lực lượng vũ trang) lần lượt diễu qua trước lễ đài hoặc trên đường phố với hàng ngũ chỉnh tề, động tác thống nhất, để biểu dương sức mạnh: cuộc diễu binh nhân ngày quốc khánh",
    example: "cuộc diễu binh nhân ngày quốc khánh",
  },
  {
    word: "diệu kế",
    part_of_speech: "danh từ",
    meaning: "kế rất hay: quả là một diệu kế",
    example: "quả là một diệu kế",
  },
  {
    word: "diễu",
    part_of_speech: "động từ",
    meaning:
      "đi qua trước mặt để cho nhìn thấy: đoàn đại biểu đang diễu qua lễ đài",
    example: "đoàn đại biểu đang diễu qua lễ đài",
  },
  {
    word: "diệu kì",
    part_of_speech: "tính từ",
    meaning: "như kì diệu: sức mạnh diệu kì",
    example: "sức mạnh diệu kì",
  },
  {
    word: "diệu kỳ",
    part_of_speech: "tính từ",
    meaning: "như kì diệu: sức mạnh diệu kì",
    example: "sức mạnh diệu kì",
  },
  {
    word: "dính",
    part_of_speech: "động từ",
    meaning:
      "bám chặt lấy như được dán vào, gắn vào, khó gỡ, khó tách ra: dầu mỡ dính đầy tay * chân dính bùn * không một xu dính túi",
    example: "dầu mỡ dính đầy tay * chân dính bùn * không một xu dính túi",
  },
  {
    word: "dính",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) có mối quan hệ, liên quan không hay nào đó: không muốn dính vào chuyện rắc rối",
    example: "không muốn dính vào chuyện rắc rối",
  },
  {
    word: "dính",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất dễ dính vào vật khác: hồ này không dính lắm * dính như keo",
    example: "hồ này không dính lắm * dính như keo",
  },
  {
    word: "dinh",
    part_of_speech: "danh từ",
    meaning: "khu nhà dùng làm nơi đóng quân trong thời phong kiến.",
    example: "dinh tổng thống",
  },
  {
    word: "diệu vợi",
    part_of_speech: "tính từ",
    meaning: "xa xôi, cách trở: đường xa xôi diệu vợi",
    example: "đường xa xôi diệu vợi",
  },
  {
    word: "diệu vợi",
    part_of_speech: "tính từ",
    meaning: "khó khăn, phiền phức: công việc diệu vợi",
    example: "công việc diệu vợi",
  },
  {
    word: "dinh cơ",
    part_of_speech: "danh từ",
    meaning:
      "khu nhà ở to lớn, rộng rãi, tạo nên một cơ ngơi vững chắc: dinh cơ bề thế",
    example: "dinh cơ bề thế",
  },
  {
    word: "dìm",
    part_of_speech: "động từ",
    meaning:
      "đè giữ cho thấp xuống hoặc chìm hẳn xuống dưới mặt nước: dìm gỗ xuống ao để ngâm * dìm xuống nước cho chết",
    example: "dìm gỗ xuống ao để ngâm * dìm xuống nước cho chết",
  },
  {
    word: "dìm",
    part_of_speech: "động từ",
    meaning: "làm cho ở vào tình trạng bị đè nén, kìm giữ: cố dìm tình cảm",
    example: "cố dìm tình cảm",
  },
  {
    word: "dìm",
    part_of_speech: "động từ",
    meaning:
      "dùng thủ đoạn làm cho hạ thấp xuống: dìm giá * cố tình dìm cấp dưới",
    example: "dìm giá * cố tình dìm cấp dưới",
  },
  {
    word: "dính dáng",
    part_of_speech: "động từ",
    meaning:
      "có mối liên quan nào đó tới việc không hay: việc đó có dính dáng đến anh đấy",
    example: "việc đó có dính dáng đến anh đấy",
  },
  {
    word: "dính dấp",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) như dính dáng: chuyện của anh, không dính dấp gì tới tôi",
    example: "chuyện của anh, không dính dấp gì tới tôi",
  },
  {
    word: "dinh dưỡng",
    part_of_speech: "danh từ",
    meaning:
      "chất cần thiết cho việc cấu tạo và hoạt động của cơ thể: bảo đảm dinh dưỡng cho trẻ * loại thức ăn giàu dinh dưỡng",
    example: "bảo đảm dinh dưỡng cho trẻ * loại thức ăn giàu dinh dưỡng",
  },
  {
    word: "dính líu",
    part_of_speech: "động từ",
    meaning:
      "liên quan trực tiếp tới, thường là việc rắc rối, không hay: hai việc không dính líu gì tới nhau",
    example: "hai việc không dính líu gì tới nhau",
  },
  {
    word: "diod",
    part_of_speech: "danh từ",
    meaning:
      "đèn điện tử hoặc bóng bán dẫn có hai điện cực (cathod và anod): chỉnh lưu bằng diod",
    example: "chỉnh lưu bằng diod",
  },
  {
    word: "dịp",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ nói chung những điều kiện khách quan có được vào thời gian nào đó, thuận tiện để làm việc gì: gặp dịp thì làm * dịp may hiếm có",
    example: "gặp dịp thì làm * dịp may hiếm có",
  },
  {
    word: "dịp",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian gắn liền với sự việc được nói đến: vào dịp tết * mỗi dịp xuân về",
    example: "vào dịp tết * mỗi dịp xuân về",
  },
  {
    word: "dioxin",
    part_of_speech: "danh từ",
    meaning:
      "chất độc cực mạnh, thể rắn, không màu, rất nguy hiểm đối với cơ thể sống: nhiễm chất độc dioxin",
    example: "nhiễm chất độc dioxin",
  },
  {
    word: "dinh luỹ",
    part_of_speech: "danh từ",
    meaning:
      "nơi tập trung lực lượng chính, chỗ dựa vững chắc (của thế lực phản động): tấn công vào dinh luỹ của các thế lực phản động",
    example: "tấn công vào dinh luỹ của các thế lực phản động",
  },
  {
    word: "díp",
    part_of_speech: "động từ",
    meaning: "(mắt) khép chặt hai mí vào nhau: buồn ngủ díp mắt",
    example: "buồn ngủ díp mắt",
  },
  {
    word: "díu",
    part_of_speech: "động từ",
    meaning:
      "làm cho chập lại với nhau, sát vào nhau: khâu díu chỗ rách lại * bọn trẻ sợ quá, ôm díu lấy nhau",
    example: "khâu díu chỗ rách lại * bọn trẻ sợ quá, ôm díu lấy nhau",
  },
  {
    word: "dìu",
    part_of_speech: "động từ",
    meaning:
      "giúp cho vận động di chuyển được bằng cách để cho dựa vào mình và đưa đi: dìu người ốm vào phòng * ca nô dìu thuyền vào bờ",
    example: "dìu người ốm vào phòng * ca nô dìu thuyền vào bờ",
  },
  {
    word: "dìu",
    part_of_speech: "động từ",
    meaning:
      "giúp đỡ cho tiến lên được theo cùng một hướng với mình: thợ cũ dìu dắt thợ mới",
    example: "thợ cũ dìu dắt thợ mới",
  },
  {
    word: "dịu",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất gây cảm giác dễ chịu, tác động êm nhẹ đến các giác quan hoặc đến tinh thần: ánh sáng dịu * hương hoa bưởi rất dịu",
    example: "ánh sáng dịu * hương hoa bưởi rất dịu",
  },
  {
    word: "dịu",
    part_of_speech: "tính từ",
    meaning:
      "không còn gay gắt nữa, mà đã làm cho có một cảm giác dễ chịu: dịu giọng * những lời an ủi làm dịu bớt nỗi đau",
    example: "dịu giọng * những lời an ủi làm dịu bớt nỗi đau",
  },
  {
    word: "dịu dàng",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra dịu, có tác dụng gây cảm giác dễ chịu, tác động êm nhẹ đến các giác quan hoặc đến tinh thần: ăn nói dịu dàng * tính tình dịu dàng, thuỳ mị",
    example: "ăn nói dịu dàng * tính tình dịu dàng, thuỳ mị",
  },
  {
    word: "dìu dặt",
    part_of_speech: "tính từ",
    meaning:
      "lúc nhanh lúc chậm một cách nhịp nhàng và êm nhẹ (thường nói về âm thanh): tiếng sáo dìu dặt",
    example: "tiếng sáo dìu dặt",
  },
  {
    word: "dịu hiền",
    part_of_speech: "tính từ",
    meaning: "dịu dàng và hiền hậu: người mẹ dịu hiền",
    example: "người mẹ dịu hiền",
  },
  {
    word: "dò",
    part_of_speech: "danh từ",
    meaning:
      "nhánh cây hoa, cây cảnh được trồng riêng (với một số loại cây): dò phong lan * dò thuỷ tiên",
    example: "dò phong lan * dò thuỷ tiên",
  },
  {
    word: "dò",
    part_of_speech: "danh từ",
    meaning:
      'bẫy thường làm bằng dây thòng lọng để bắt chim: "Chim khôn tránh lưới mắc dò, Cá khôn tránh mãi, lững lờ mắc đăng." (Cdao)',
    example:
      'Chim khôn tránh lưới mắc dò, Cá khôn tránh mãi, lững lờ mắc đăng." (Cdao)',
  },
  {
    word: "dò",
    part_of_speech: "động từ",
    meaning:
      "đi một cách thận trọng, từng bước một (do có điều bất lợi nào đó): dò từng bước trong đêm tối",
    example: "dò từng bước trong đêm tối",
  },
  {
    word: "dò",
    part_of_speech: "động từ",
    meaning:
      'tìm biết, tìm hiểu dần dần từng bước một cách mò mẫm: dò tìm manh mối * "Dò sông dò biển dễ dò, Nào ai lấy thước mà đo lòng người." (Cdao)',
    example:
      'dò tìm manh mối * "Dò sông dò biển dễ dò, Nào ai lấy thước mà đo lòng người." (Cdao)',
  },
  {
    word: "dò",
    part_of_speech: "động từ",
    meaning:
      "soát lại một cách cẩn thận bằng cách lần tìm những chỗ sai sót: dò bản đánh máy * dò bài cho con",
    example: "dò bản đánh máy * dò bài cho con",
  },
  {
    word: "dọ",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) dò: dọ bước trong đêm",
    example: "dọ bước trong đêm",
  },
  {
    word: "dìu dịu",
    part_of_speech: "tính từ",
    meaning: "như dịu (ng2, nhưng ý mức độ ít): hương thơm dìu dịu",
    example: "hương thơm dìu dịu",
  },
  {
    word: "dịu ngọt",
    part_of_speech: "tính từ",
    meaning: "dịu dàng và ngọt ngào: dỗ dành bằng những lời dịu ngọt",
    example: "dỗ dành bằng những lời dịu ngọt",
  },
  {
    word: "dó",
    part_of_speech: "danh từ",
    meaning:
      "cây nhỡ, lá hình bầu dục dài, hoa trắng, vỏ cây dùng làm giấy: bức tranh trên giấy dó",
    example: "bức tranh trên giấy dó",
  },
  {
    word: "dò dẫm",
    part_of_speech: "động từ",
    meaning:
      "dò (nói khái quát): bước đi dò dẫm trong bóng tối * dò dẫm mãi cũng tìm được đến nơi",
    example: "bước đi dò dẫm trong bóng tối * dò dẫm mãi cũng tìm được đến nơi",
  },
  {
    word: "dò hỏi",
    part_of_speech: "động từ",
    meaning: "hỏi dần để biết một cách kín đáo: dò hỏi tin tức của người thân",
    example: "dò hỏi tin tức của người thân",
  },
  {
    word: "do dự",
    part_of_speech: "động từ",
    meaning:
      'chưa quyết định được dứt khoát vì có điều còn e ngại: "Tính tình anh sôi nổi, ngay thẳng như ngọn lửa, đã quyết làm việc gì thì không hề do dự (...)" (MVKháng; 13)',
    example:
      'Tính tình anh sôi nổi, ngay thẳng như ngọn lửa, đã quyết làm việc gì thì không hề do dự (...)" (MVKháng; 13)',
  },
  {
    word: "do",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là nguyên nhân của sự việc nói đến: do sơ ý nên hỏng việc * đói kém do mất mùa",
    example: "do sơ ý nên hỏng việc * đói kém do mất mùa",
  },
  {
    word: "do",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là chủ thể hoạt động tạo ra hoặc tác động quyết định đến cái vừa nói đến: việc này do nó gây nên * đại biểu do dân bầu ra",
    example: "việc này do nó gây nên * đại biểu do dân bầu ra",
  },
  {
    word: "dò tìm",
    part_of_speech: "động từ",
    meaning:
      "dò một cách cẩn thận, từng phần, từng chút một để tìm cho ra: dò tìm manh mối * dò tìm những chỗ cộng sai",
    example: "dò tìm manh mối * dò tìm những chỗ cộng sai",
  },
  {
    word: "dò la",
    part_of_speech: "động từ",
    meaning:
      "dò một cách kín đáo bằng cách hỏi gián tiếp, nghe ngóng, v.v.: dò la tin tức * hỏi dò la",
    example: "dò la tin tức * hỏi dò la",
  },
  {
    word: "doạ già doạ non",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) doạ đủ cách, cốt để làm cho người ta sợ: tưởng chỉ doạ già doạ non thế thôi, ai ngờ nó làm thật",
    example: "tưởng chỉ doạ già doạ non thế thôi, ai ngờ nó làm thật",
  },
  {
    word: "do thám",
    part_of_speech: "động từ",
    meaning: "dò xét để thu thập tình hình của đối phương: do thám tình hình",
    example: "do thám tình hình",
  },
  {
    word: "doạ dẫm",
    part_of_speech: "động từ",
    meaning: "doạ (nói khái quát): thái độ doạ dẫm",
    example: "thái độ doạ dẫm",
  },
  {
    word: "doá",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ, khẩu ngữ) tức, giận: chưa nghe hết câu đã doá lên rồi!",
    example: "chưa nghe hết câu đã doá lên rồi!",
  },
  {
    word: "doạ",
    part_of_speech: "động từ",
    meaning:
      "làm cho người khác sợ bằng cách tỏ cho biết có thể sắp có điều không hay xảy đến cho người ấy: doạ ma * doạ sẽ đánh đòn * nói là làm thật, chứ không doạ",
    example: "doạ ma * doạ sẽ đánh đòn * nói là làm thật, chứ không doạ",
  },
  {
    word: "dò xét",
    part_of_speech: "động từ",
    meaning:
      "dò bằng cách quan sát kín đáo: dò xét tình hình * hỏi để dò xét thái độ",
    example: "dò xét tình hình * hỏi để dò xét thái độ",
  },
  {
    word: "doạ nạt",
    part_of_speech: "động từ",
    meaning:
      "doạ, mắng mỏ, làm cho người khác phải sợ mình, phải nghe theo, bằng uy quyền hoặc bằng vẻ dữ tợn: lên giọng doạ nạt * doạ nạt trẻ con",
    example: "lên giọng doạ nạt * doạ nạt trẻ con",
  },
  {
    word: "doãi",
    part_of_speech: "động từ",
    meaning:
      "để cho dài thẳng ra hoặc dang rộng ra (thường nói về tay, chân): đứng doãi chân chèo",
    example: "đứng doãi chân chèo",
  },
  {
    word: "doanh nhân",
    part_of_speech: "danh từ",
    meaning:
      "(trang trọng) người làm nghề kinh doanh: ngày doanh nhân Việt Nam",
    example: "ngày doanh nhân Việt Nam",
  },
  {
    word: "doanh số",
    part_of_speech: "danh từ",
    meaning: "như doanh thu: doanh số trong năm đạt 2 tỉ đồng",
    example: "doanh số trong năm đạt 2 tỉ đồng",
  },
  {
    word: "doãng",
    part_of_speech: "",
    meaning:
      "rộng ra do bị dãn: bít tất bị doãng * cái cổ áo mút mỗi ngày một doãng",
    example: "bít tất bị doãng * cái cổ áo mút mỗi ngày một doãng",
  },
  {
    word: "doanh lợi",
    part_of_speech: "danh từ",
    meaning: "lợi nhuận do việc kinh doanh đưa lại: doanh lợi cao",
    example: "doanh lợi cao",
  },
  {
    word: "doanh nghiệp",
    part_of_speech: "động từ",
    meaning: "làm các công việc kinh doanh: giới doanh nghiệp",
    example: "giới doanh nghiệp",
  },
  {
    word: "doanh nghiệp",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị hoạt động kinh doanh: doanh nghiệp tư nhân * quyết định thành lập doanh nghiệp",
    example: "doanh nghiệp tư nhân * quyết định thành lập doanh nghiệp",
  },
  {
    word: "doanh gia",
    part_of_speech: "danh từ",
    meaning:
      "(trang trọng) nhà doanh nghiệp, nhà kinh doanh lớn, thường có tiếng tăm: giới doanh gia Việt Nam",
    example: "giới doanh gia Việt Nam",
  },
  {
    word: "doanh thu",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ thu nhập nói chung, kể cả vốn lẫn lãi, do việc kinh doanh đưa lại trong một thời kì nhất định hoặc từ một sản phẩm nhất định: doanh thu năm nay cao hơn năm trước * thưởng theo doanh thu",
    example: "doanh thu năm nay cao hơn năm trước * thưởng theo doanh thu",
  },
  {
    word: "doạng",
    part_of_speech: "động từ",
    meaning: "đưa rộng hai chân ra hai bên: ngồi giạng chân * đứng giạng háng",
    example: "ngồi giạng chân * đứng giạng háng",
  },
  {
    word: "dọi",
    part_of_speech: "danh từ",
    meaning:
      "vật nặng buộc vào đầu dưới sợi dây (gọi là dây dọi), dùng để xác định phương thẳng đứng: quả dọi",
    example: "quả dọi",
  },
  {
    word: "dọi",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) làm cho một vật rắn này đập mạnh xuống một vật rắn khác: dọi đồng xu xuống nền gạch * đánh đáo dọi",
    example: "dọi đồng xu xuống nền gạch * đánh đáo dọi",
  },
  {
    word: "dọi",
    part_of_speech: "động từ",
    meaning: "làm cho kín lại chỗ mái bị hở, bị dột: tranh thủ dọi lại mái bếp",
    example: "tranh thủ dọi lại mái bếp",
  },
  {
    word: "dõi",
    part_of_speech: "động từ",
    meaning:
      "chú ý theo sát từng hoạt động, từng diễn biến: mắt dõi theo từng cử chỉ của người lạ",
    example: "mắt dõi theo từng cử chỉ của người lạ",
  },
  {
    word: "dõi",
    part_of_speech: "danh từ",
    meaning:
      "thanh dài để cài ngang cửa suốt từ bên này sang bên kia: đóng dõi chuồng trâu",
    example: "đóng dõi chuồng trâu",
  },
  {
    word: "dóc",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ, khẩu ngữ) khoác lác và bịa đặt cho vui câu chuyện: thằng cha dóc đó, đừng có tin!",
    example: "thằng cha dóc đó, đừng có tin!",
  },
  {
    word: "dọc",
    part_of_speech: "danh từ",
    meaning:
      "cây to cùng họ với bứa, quả hình trứng, có vị chua, ăn được, hạt có dầu: nướng dọc để nấu canh chua",
    example: "nướng dọc để nấu canh chua",
  },
  {
    word: "dọc",
    part_of_speech: "danh từ",
    meaning:
      "cuống lá dài và thẳng của một số loại cây: dọc khoai nước * dọc đu đủ",
    example: "dọc khoai nước * dọc đu đủ",
  },
  {
    word: "dọc",
    part_of_speech: "danh từ",
    meaning:
      "vật có hình giống như cuống: cân treo trên dọc gỗ (đòn thẳng bằng gỗ) * dọc tẩu",
    example: "cân treo trên dọc gỗ (đòn thẳng bằng gỗ) * dọc tẩu",
  },
  {
    word: "dọc",
    part_of_speech: "tính từ",
    meaning:
      "theo chiều dài: nhà ở dọc hai bên quốc lộ * bóng đã ra ngoài đường biên dọc",
    example: "nhà ở dọc hai bên quốc lộ * bóng đã ra ngoài đường biên dọc",
  },
  {
    word: "dọc",
    part_of_speech: "tính từ",
    meaning:
      "theo quan hệ từ trên xuống dưới, trong hệ thống tổ chức: các tổ chức ngành dọc * sự chỉ đạo dọc",
    example: "các tổ chức ngành dọc * sự chỉ đạo dọc",
  },
  {
    word: "dọc",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) tập hợp gồm nhiều cái nối tiếp nhau thành hàng dài: xe hơi đậu một dọc dài * mấy dọc quần áo phơi ngoài sân",
    example: "xe hơi đậu một dọc dài * mấy dọc quần áo phơi ngoài sân",
  },
  {
    word: "dọc ngang",
    part_of_speech: "",
    meaning:
      'như ngang dọc: "Chọc trời, quấy nước, mặc dầu, Dọc ngang nào biết trên đầu có ai?" (TKiều)',
    example:
      'Chọc trời, quấy nước, mặc dầu, Dọc ngang nào biết trên đầu có ai?" (TKiều)',
  },
  {
    word: "doi",
    part_of_speech: "danh từ",
    meaning: "dải phù sa ở dọc sông hay cửa sông: doi cát",
    example: "doi cát",
  },
  {
    word: "dòi",
    part_of_speech: "danh từ",
    meaning: "dạng ấu trùng của ruồi, nhặng: không ưa thì dưa có dòi (tng)",
    example: "không ưa thì dưa có dòi (tng)",
  },
  {
    word: "dòm",
    part_of_speech: "động từ",
    meaning:
      "nhìn và quan sát kĩ để dò xét hoặc để tìm kiếm cái gì: dòm qua khe cửa * ghé mắt dòm vào",
    example: "dòm qua khe cửa * ghé mắt dòm vào",
  },
  {
    word: "dòm",
    part_of_speech: "động từ",
    meaning: "(Phương ngữ) nhìn, trông: dòm trước dòm sau mới đi",
    example: "dòm trước dòm sau mới đi",
  },
  {
    word: "dỏm",
    part_of_speech: "tính từ",
    meaning:
      "làm ra vẻ sang trọng một cách không phải lối, khiến cho trở thành lố bịch, trớ trêu: rởm đời * đạo đức rởm * đài các rởm!",
    example: "rởm đời * đạo đức rởm * đài các rởm!",
  },
  {
    word: "dỏm",
    part_of_speech: "tính từ",
    meaning: "(hàng) giả, kém chất lượng: hàng rởm * mua phải đồ rởm",
    example: "hàng rởm * mua phải đồ rởm",
  },
  {
    word: "dòm ngó",
    part_of_speech: "động từ",
    meaning:
      "để ý quan sát theo dõi nhằm thực hiện ý đồ không tốt: bị kẻ trộm dòm ngó",
    example: "bị kẻ trộm dòm ngó",
  },
  {
    word: "dòm ngó",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) để ý, quan tâm đến người khác giới (thường nói về người con trai đối với người con gái): xinh đẹp nên được nhiều anh dòm ngó",
    example: "xinh đẹp nên được nhiều anh dòm ngó",
  },
  {
    word: "dom",
    part_of_speech: "danh từ",
    meaning: "phần cuối cùng của ruột già, ở sát hậu môn: bệnh lòi dom",
    example: "bệnh lòi dom",
  },
  {
    word: "domino",
    part_of_speech: "danh từ",
    meaning:
      "tấm nhỏ hình chữ nhật, trên mặt chia làm hai nửa, mỗi nửa để trắng hoặc có từ một đến sáu chấm, dùng làm quân trong một số trò chơi: thuyết domino",
    example: "thuyết domino",
  },
  {
    word: "dọn",
    part_of_speech: "động từ",
    meaning:
      "làm cho gọn, sạch, hết vướng bằng cách cất đặt vào một chỗ hoặc đưa đi chỗ khác: dọn nhà cửa * dọn đồ đạc cho gọn lại",
    example: "dọn nhà cửa * dọn đồ đạc cho gọn lại",
  },
  {
    word: "dọn",
    part_of_speech: "động từ",
    meaning:
      "chuyển đồ đạc đến nơi ở mới; dời chỗ ở: dọn nhà đi nơi khác * cả nhà dọn hẳn về quê",
    example: "dọn nhà đi nơi khác * cả nhà dọn hẳn về quê",
  },
  {
    word: "dọn",
    part_of_speech: "động từ",
    meaning:
      "làm cho hết cái vướng, cái trở ngại để thuận lợi cho việc gì: có xe đi trước dọn đường",
    example: "có xe đi trước dọn đường",
  },
  {
    word: "dọn",
    part_of_speech: "động từ",
    meaning:
      "soạn và bày ra để làm việc gì: dọn cơm đãi khách * dọn quán bán hàng",
    example: "dọn cơm đãi khách * dọn quán bán hàng",
  },
  {
    word: "dọn",
    part_of_speech: "tính từ",
    meaning: "(hạt đậu) rắn, không thể nấu cho nhừ được: hạt đậu dọn",
    example: "hạt đậu dọn",
  },
  {
    word: "dọn dẹp",
    part_of_speech: "động từ",
    meaning:
      "sắp xếp lại cho gọn gàng, sạch sẽ (nói khái quát): dọn dẹp, sắp xếp lại đồ đạc * dọn dẹp nhà cửa để đón Tết",
    example: "dọn dẹp, sắp xếp lại đồ đạc * dọn dẹp nhà cửa để đón Tết",
  },
  {
    word: "dòm dỏ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nhìn ngó, để ý quan sát theo dõi vì tò mò, hoặc vì có ý thèm muốn: sai người đến dòm dỏ",
    example: "sai người đến dòm dỏ",
  },
  {
    word: "dọn giọng",
    part_of_speech: "động từ",
    meaning:
      "làm cho hết vướng trước khi nói, hát, v.v. thường bằng cách đẩy hơi bật ra một tiếng ngắn trong cổ: e hèm dọn giọng",
    example: "e hèm dọn giọng",
  },
  {
    word: "dóng",
    part_of_speech: "động từ",
    meaning:
      "làm cho thẳng hàng, cho đúng hướng với cái đã chọn làm mốc: dóng hàng cho thẳng",
    example: "dóng hàng cho thẳng",
  },
  {
    word: "dỏng",
    part_of_speech: "động từ",
    meaning:
      "dựng thẳng lên (thường nói về tai): dỏng tai lên nghe ngóng * con chó dỏng đuôi sủa",
    example: "dỏng tai lên nghe ngóng * con chó dỏng đuôi sủa",
  },
  {
    word: "dong",
    part_of_speech: "danh từ",
    meaning:
      "cây trồng thân cỏ, lá to, cuống lá có đốt, thân ngầm phồng thành củ hình thoi dài, màu trắng, chứa nhiều bột, dùng làm thức ăn: củ dong",
    example: "củ dong",
  },
  {
    word: "dong",
    part_of_speech: "danh từ",
    meaning:
      "cây cùng loại với cây dong nhưng củ không phát triển, lá to và dài, thường dùng để gói bánh: gói bánh bằng lá dong",
    example: "gói bánh bằng lá dong",
  },
  {
    word: "dong",
    part_of_speech: "động từ",
    meaning:
      "đi kèm bên cạnh để trông coi và dẫn đến nơi nào đó: dong tù về trại * dong trâu về chuồng",
    example: "dong tù về trại * dong trâu về chuồng",
  },
  {
    word: "dong",
    part_of_speech: "động từ",
    meaning:
      "đưa lên cao, giơ cao lên đến mức ở xa cũng nhìn thấy: dong buồm ra khơi * trống giục cờ dong",
    example: "dong buồm ra khơi * trống giục cờ dong",
  },
  {
    word: "dõng",
    part_of_speech: "danh từ",
    meaning:
      "(Nam cũng dõng) sức mạnh thể chất và tinh thần trên hẳn mức bình thường, tạo khả năng dám đương đầu với nguy hiểm để làm những việc nên làm: trí dũng có thừa * mỗi người đều có chí, có dũng riêng",
    example: "trí dũng có thừa * mỗi người đều có chí, có dũng riêng",
  },
  {
    word: "dòng",
    part_of_speech: "danh từ",
    meaning:
      "khối chất lỏng đang chảy: dòng nước mắt * dòng sông * nước chảy thành dòng",
    example: "dòng nước mắt * dòng sông * nước chảy thành dòng",
  },
  {
    word: "dòng",
    part_of_speech: "danh từ",
    meaning:
      "chuỗi sự vật, hiện tượng đang chuyển động hoặc đang xảy ra liên tục, nối tiếp nhau: dòng suy nghĩ * dòng người",
    example: "dòng suy nghĩ * dòng người",
  },
  {
    word: "dòng",
    part_of_speech: "danh từ",
    meaning:
      "khoảng để viết hoặc xếp chữ kế tiếp nhau thành hàng: giấy có kẻ dòng * chấm xuống dòng * viết nguệch ngoạc mấy dòng",
    example: "giấy có kẻ dòng * chấm xuống dòng * viết nguệch ngoạc mấy dòng",
  },
  {
    word: "dòng",
    part_of_speech: "danh từ",
    meaning:
      "toàn thể nói chung những người hoặc gia súc cùng huyết thống, làm thành những thế hệ nối tiếp nhau: dòng con quan * có con trai nối dòng",
    example: "dòng con quan * có con trai nối dòng",
  },
  {
    word: "dòng",
    part_of_speech: "danh từ",
    meaning:
      "chi nhánh trong dòng họ, tôn giáo, có sự kế thừa đời này sang đời khác: anh em cùng họ, nhưng khác dòng * dòng đạo gốc",
    example: "anh em cùng họ, nhưng khác dòng * dòng đạo gốc",
  },
  {
    word: "dòng",
    part_of_speech: "danh từ",
    meaning:
      "trào lưu văn hoá, tư tưởng có sự kế thừa và phát triển liên tục: dòng văn học lãng mạn",
    example: "dòng văn học lãng mạn",
  },
  {
    word: "dòng",
    part_of_speech: "động từ",
    meaning:
      "buông cho sợi dây dài dẫn từ đầu này tới đầu kia, để nối với vật ở xa, để lôi, kéo, v.v.: dòng dây gàu xuống giếng * dây mìn được dòng ra thật xa",
    example: "dòng dây gàu xuống giếng * dây mìn được dòng ra thật xa",
  },
  {
    word: "dòng",
    part_of_speech: "động từ",
    meaning: "kéo, dắt đi theo bằng sợi dây dài: dòng thuyền đi ven bờ sông",
    example: "dòng thuyền đi ven bờ sông",
  },
  {
    word: "dọng",
    part_of_speech: "danh từ",
    meaning: "sống của dao, gươm: dọng dao",
    example: "dọng dao",
  },
  {
    word: "dong dải",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) (vóc người) thon, mảnh khảnh: vóc người dong dải",
    example: "vóc người dong dải",
  },
  {
    word: "dõng dạc",
    part_of_speech: "tính từ",
    meaning:
      "mạnh mẽ, rõ ràng và chững chạc: nói dõng dạc từng tiếng một * dõng dạc tuyên bố",
    example: "nói dõng dạc từng tiếng một * dõng dạc tuyên bố",
  },
  {
    word: "dòng điện",
    part_of_speech: "danh từ",
    meaning:
      "chuyển động định hướng của các điện tích: dòng điện không được ổn định",
    example: "dòng điện không được ổn định",
  },
  {
    word: "dong dỏng",
    part_of_speech: "tính từ",
    meaning: "hơi gầy và thon: dáng người dong dỏng * cao dong dỏng",
    example: "dáng người dong dỏng * cao dong dỏng",
  },
  {
    word: "dòng họ",
    part_of_speech: "danh từ",
    meaning:
      "toàn thể nói chung những người cùng huyết thống làm thành các thế hệ nối tiếp nhau: người trong dòng họ",
    example: "người trong dòng họ",
  },
  {
    word: "dòng dõi",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) những người cùng huyết thống làm thành các thế hệ kế tiếp nhau, kế thừa và phát triển những truyền thống chung (nói tổng quát): dòng dõi nhà quan",
    example: "dòng dõi nhà quan",
  },
  {
    word: "doping",
    part_of_speech: "danh từ",
    meaning:
      "chất kích thích nói chung (thường nói về chất kích thích vận động viên dùng trong thi đấu thể thao để nâng cao thành tích, mặc dù có quy định cấm): kiểm tra doping cho kết quả dương tính",
    example: "kiểm tra doping cho kết quả dương tính",
  },
  {
    word: "dỗ dành",
    part_of_speech: "động từ",
    meaning: "dỗ (nói khái quát): mẹ dỗ dành con * âu yếm dỗ dành",
    example: "mẹ dỗ dành con * âu yếm dỗ dành",
  },
  {
    word: "download",
    part_of_speech: "động từ",
    meaning:
      "lấy dữ liệu từ một hệ thống lưu trữ ở xa (như một website, máy chủ, v.v.) về máy tính hoặc các thiết bị điện tử khác để sử dụng; phân biệt với upload: download chương trình nghe nhạc",
    example: "download chương trình nghe nhạc",
  },
  {
    word: "dỗ",
    part_of_speech: "động từ",
    meaning:
      "làm cho bằng lòng, cho nghe theo, làm theo bằng lời nói dịu dàng, khéo léo hoặc sự chiều chuộng: dỗ con * dỗ ngon dỗ ngọt",
    example: "dỗ con * dỗ ngon dỗ ngọt",
  },
  {
    word: "dỗ",
    part_of_speech: "động từ",
    meaning:
      "đưa thẳng lên cao rồi dập một đầu xuống mặt bằng: dỗ chiếu cho sạch bụi * dỗ bó đũa để so",
    example: "dỗ chiếu cho sạch bụi * dỗ bó đũa để so",
  },
  {
    word: "dòng tộc",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như dòng họ (hàm ý kính trọng): quan hệ dòng tộc",
    example: "quan hệ dòng tộc",
  },
  {
    word: "dô",
    part_of_speech: "tính từ",
    meaning:
      "lồi cao lên hoặc nhô ra phía trước hơi quá mức bình thường (thường nói về một số bộ phận cơ thể): trán dô * xương bả vai dô ra",
    example: "trán dô * xương bả vai dô ra",
  },
  {
    word: "dồi",
    part_of_speech: "danh từ",
    meaning:
      "món ăn thường làm bằng ruột lợn hoặc chó, trong có nhồi tiết và gia vị: dồi chó",
    example: "dồi chó",
  },
  {
    word: "dồ",
    part_of_speech: "động từ",
    meaning: "xông tới: chó dồ ra sủa * chiếc xe máy dồ lên lao vụt đi",
    example: "chó dồ ra sủa * chiếc xe máy dồ lên lao vụt đi",
  },
  {
    word: "dốc",
    part_of_speech: "danh từ",
    meaning:
      "đoạn đường cao dần lên hoặc thấp dần xuống: đường núi nhiều dốc * xe bon bon xuống dốc",
    example: "đường núi nhiều dốc * xe bon bon xuống dốc",
  },
  {
    word: "dốc",
    part_of_speech: "tính từ",
    meaning:
      "cao dần lên hoặc thấp dần xuống so với mặt bằng: sườn núi dốc * bờ biển thoai thoải dốc dần xuống",
    example: "sườn núi dốc * bờ biển thoai thoải dốc dần xuống",
  },
  {
    word: "dốc",
    part_of_speech: "động từ",
    meaning:
      "cầm vật đựng chúc đầu miệng xuống để trút thứ đựng ở trong đó ra: dốc chai đổ hết nước",
    example: "dốc chai đổ hết nước",
  },
  {
    word: "dốc",
    part_of_speech: "động từ",
    meaning:
      ". đưa hết tất cả ra để dùng vào việc gì: dốc lòng dốc sức * dốc hết tiền vào cờ bạc",
    example: "dốc lòng dốc sức * dốc hết tiền vào cờ bạc",
  },
  {
    word: "dỗi",
    part_of_speech: "động từ",
    meaning:
      "tỏ thái độ giận, không bằng lòng bằng cách làm như không cần đến nữa, không thiết nữa: dỗi cơm * tính hay dỗi",
    example: "dỗi cơm * tính hay dỗi",
  },
  {
    word: "dô ta",
    part_of_speech: "",
    meaning:
      "tiếng hò tập thể theo nhịp nhằm lấy đà dồn sức cùng đẩy hoặc kéo vật nặng: hò dô ta",
    example: "hò dô ta",
  },
  {
    word: "dốc thoải",
    part_of_speech: "danh từ",
    meaning:
      "mặt phẳng nghiêng thay cho cầu thang ở bên trong hoặc bên ngoài nhà: dốc thoải của tầng hầm để xe",
    example: "dốc thoải của tầng hầm để xe",
  },
  {
    word: "dôi",
    part_of_speech: "tính từ",
    meaning:
      "nhiều hơn mức cần thiết hoặc mức bình thường: cơm nấu hơi dôi * tính đi tính lại vẫn thấy dôi ra mấy người",
    example: "cơm nấu hơi dôi * tính đi tính lại vẫn thấy dôi ra mấy người",
  },
  {
    word: "dôi",
    part_of_speech: "động từ",
    meaning:
      "còn dư ra không phải dùng đến: ăn tiêu tiết kiệm nên vẫn còn dôi một ít tiền",
    example: "ăn tiêu tiết kiệm nên vẫn còn dôi một ít tiền",
  },
  {
    word: "dội",
    part_of_speech: "động từ",
    meaning:
      "đổ từ trên cao xuống nhiều và mạnh: giội nước ào ào * nắng như giội lửa",
    example: "giội nước ào ào * nắng như giội lửa",
  },
  {
    word: "dồi dào",
    part_of_speech: "tính từ",
    meaning:
      "rất nhiều, đến mức cần bao nhiêu cũng có đủ: sức khoẻ dồi dào * tiền bạc dồi dào",
    example: "sức khoẻ dồi dào * tiền bạc dồi dào",
  },
  {
    word: "dối dá",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (làm việc gì) tỏ ra dối, không kĩ: làm dối dá cho xong",
    example: "làm dối dá cho xong",
  },
  {
    word: "dối",
    part_of_speech: "động từ",
    meaning:
      "cho biết sai sự thật nhằm che giấu điều gì: dối trên lừa dưới * tự dối lòng mình",
    example: "dối trên lừa dưới * tự dối lòng mình",
  },
  {
    word: "dối",
    part_of_speech: "tính từ",
    meaning:
      "(làm việc gì) không được kĩ, chưa thật đạt yêu cầu mà cũng đã coi như xong: gạo giã dối nên còn nhiều trấu",
    example: "gạo giã dối nên còn nhiều trấu",
  },
  {
    word: "dôi thừa",
    part_of_speech: "tính từ",
    meaning: "như dôi dư: thanh lí số thiết bị dôi thừa",
    example: "thanh lí số thiết bị dôi thừa",
  },
  {
    word: "dôi dư",
    part_of_speech: "tính từ",
    meaning:
      "thừa ra, không dùng đến (nói khái quát): giải quyết số lao động dôi dư",
    example: "giải quyết số lao động dôi dư",
  },
  {
    word: "dối trá",
    part_of_speech: "tính từ",
    meaning: "giả dối, có ý lừa lọc:  làm ăn dối trá * quen thói dối trá",
    example: "làm ăn dối trá * quen thói dối trá",
  },
  {
    word: "dồn dập",
    part_of_speech: "tính từ",
    meaning:
      "liên tiếp rất nhiều lần trong thời gian tương đối ngắn: trống ngực đập dồn dập * tiến công dồn dập",
    example: "trống ngực đập dồn dập * tiến công dồn dập",
  },
  {
    word: "dồn",
    part_of_speech: "động từ",
    meaning:
      "làm cho tất cả cùng một lúc tập trung về một chỗ: dồn thóc thành đống * dồn hết tâm trí vào công việc",
    example: "dồn thóc thành đống * dồn hết tâm trí vào công việc",
  },
  {
    word: "dồn",
    part_of_speech: "động từ",
    meaning:
      "làm cho ngày càng bị thu hẹp phạm vi khả năng hoạt động đến mức có thể lâm vào chỗ khó khăn, bế tắc: dồn đối thủ vào một góc * bị dồn vào chân tường (dồn vào thế bí)",
    example: "dồn đối thủ vào một góc * bị dồn vào chân tường (dồn vào thế bí)",
  },
  {
    word: "dồn",
    part_of_speech: "động từ",
    meaning:
      "hay t (hoạt động) được tiếp diễn liên tục với nhịp độ ngày càng nhanh hơn: chó sủa dồn * hỏi dồn * tiếng trống dồn",
    example: "chó sủa dồn * hỏi dồn * tiếng trống dồn",
  },
  {
    word: "dồn ép",
    part_of_speech: "động từ",
    meaning:
      "dồn vào chỗ, vào thế khó khăn, bế tắc: bị dồn ép đến bước đường cùng",
    example: "bị dồn ép đến bước đường cùng",
  },
  {
    word: "dồn nén",
    part_of_speech: "động từ",
    meaning:
      "dồn ép vào một phạm vi, một khuôn khổ quá chật hẹp: hơi thở như bị dồn nén trong lồng ngực",
    example: "hơi thở như bị dồn nén trong lồng ngực",
  },
  {
    word: "dồn nén",
    part_of_speech: "động từ",
    meaning:
      "(tình cảm, cảm xúc) chất chứa, dồn lại lâu ngày, chỉ cần có dịp là bung ra: dồn nén cảm xúc * tình cảm bị dồn nén",
    example: "dồn nén cảm xúc * tình cảm bị dồn nén",
  },
  {
    word: "dông dài",
    part_of_speech: "tính từ",
    meaning:
      '(nói, viết) lan man, không đâu vào đâu, làm tốn thì giờ một cách vô ích: ăn nói dông dài * "Lời quê chắp nhặt dông dài, Mua vui cũng được một vài trống canh." (TKiều)',
    example:
      'ăn nói dông dài * "Lời quê chắp nhặt dông dài, Mua vui cũng được một vài trống canh." (TKiều)',
  },
  {
    word: "dông dài",
    part_of_speech: "tính từ",
    meaning: "lông bông, kéo dài thì giờ vô ích: ăn chơi dông dài",
    example: "ăn chơi dông dài",
  },
  {
    word: "dộng",
    part_of_speech: "động từ",
    meaning: "đưa thẳng lên cao rồi dập mạnh một đầu xuống mặt bằng: dộng đũa",
    example: "dộng đũa",
  },
  {
    word: "dộng",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) tống thẳng và mạnh vào: bị dộng báng súng vào lưng",
    example: "bị dộng báng súng vào lưng",
  },
  {
    word: "dông tố",
    part_of_speech: "danh từ",
    meaning:
      "cơn dông có gió to (nói khái quát); thường dùng để ví cảnh gian nan, đầy thử thách, hoặc việc xảy ra dữ dội, mãnh liệt: trời nổi dông tố * cuộc đời đầy dông tố",
    example: "trời nổi dông tố * cuộc đời đầy dông tố",
  },
  {
    word: "dồn tụ",
    part_of_speech: "động từ",
    meaning:
      "dồn lại, tụ lại từ nhiều nơi, nhiều hướng khác nhau: rác rưởi dồn tụ lại thành đống * những đám mây đen dồn tụ nơi chân trời",
    example:
      "rác rưởi dồn tụ lại thành đống * những đám mây đen dồn tụ nơi chân trời",
  },
  {
    word: "dông",
    part_of_speech: "danh từ",
    meaning:
      "(cũng viết giông) biến động mạnh của thời tiết biểu hiện bằng hiện tượng phóng điện giữa các đám mây lớn, thường có gió to, sấm sét, mưa rào, đôi khi có cầu vồng: trời nổi cơn dông * mưa dông",
    example: "trời nổi cơn dông * mưa dông",
  },
  {
    word: "dông",
    part_of_speech: "động từ",
    meaning:
      "(Phương ngữ, Khẩu ngữ) rời nhanh khỏi nơi nào đó: lên xe dông mất * dông thẳng về quê",
    example: "lên xe dông mất * dông thẳng về quê",
  },
  {
    word: "dột",
    part_of_speech: "tính từ",
    meaning:
      '(mái nhà) có chỗ hở khiến nước mưa có thể nhỏ xuống: "Thứ nhất vợ dại trong nhà, Thứ hai nhà dột, thứ ba nợ đòi." (ca dao)',
    example:
      'Thứ nhất vợ dại trong nhà, Thứ hai nhà dột, thứ ba nợ đòi." (ca dao)',
  },
  {
    word: "dốt",
    part_of_speech: "tính từ",
    meaning:
      "kém về trí lực, chậm hiểu, chậm tiếp thu: dốt quá, có thế mà cũng không nghĩ ra!",
    example: "dốt quá, có thế mà cũng không nghĩ ra!",
  },
  {
    word: "dốt",
    part_of_speech: "tính từ",
    meaning:
      "không hiểu biết gì hoặc hiểu biết rất ít (thường nói về trình độ văn hoá): dốt môn toán * dốt hay nói chữ (tng)",
    example: "dốt môn toán * dốt hay nói chữ (tng)",
  },
  {
    word: "dột nát",
    part_of_speech: "tính từ",
    meaning: "hỏng nát và dột nhiều chỗ (nói khái quát): mái nhà dột nát",
    example: "mái nhà dột nát",
  },
  {
    word: "dốt đặc",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) dốt hoàn toàn, không biết một tí gì: dốt đặc về cờ vua",
    example: "dốt đặc về cờ vua",
  },
  {
    word: "dốt nát",
    part_of_speech: "tính từ",
    meaning: "dốt (nói khái quát): đầu óc dốt nát",
    example: "đầu óc dốt nát",
  },
  {
    word: "dỡ",
    part_of_speech: "động từ",
    meaning:
      "lấy rời ra lần lượt từng cái, từng phần, từng lớp, theo thứ tự, thường là từ trên xuống: dỡ hàng trên tàu xuống * dỡ nhà",
    example: "dỡ hàng trên tàu xuống * dỡ nhà",
  },
  {
    word: "dơ",
    part_of_speech: "tính từ",
    meaning: "(Nam) bẩn: chiếc áo bị dơ",
    example: "chiếc áo bị dơ",
  },
  {
    word: "dơ",
    part_of_speech: "tính từ",
    meaning:
      "trơ, không biết hổ thẹn (thường dùng để chê, mắng): người đâu mà dơ thế! * rõ dơ! của người ta mà lại nhận vơ",
    example: "người đâu mà dơ thế! * rõ dơ! của người ta mà lại nhận vơ",
  },
  {
    word: "dở",
    part_of_speech: "tính từ",
    meaning:
      "không hay, không đạt yêu cầu, do đó không gây thích thú, không mang lại kết quả tốt: vở kịch dở * hát rất dở",
    example: "vở kịch dở * hát rất dở",
  },
  {
    word: "dở bữa",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) ăn chưa xong bữa: đang dở bữa thì có việc phải đi",
    example: "đang dở bữa thì có việc phải đi",
  },
  {
    word: "dở bữa",
    part_of_speech: "động từ",
    meaning: "không đúng bữa: dở bữa nên ăn không thấy ngon",
    example: "dở bữa nên ăn không thấy ngon",
  },
  {
    word: "dớ da dớ dẩn",
    part_of_speech: "tính từ",
    meaning: "như dớ dẩn (nhưng ý mức độ nhiều): ăn nói dớ da dớ dẩn",
    example: "ăn nói dớ da dớ dẩn",
  },
  {
    word: "dở chừng",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) (làm việc gì) đang còn làm, chưa xong: làm dở chừng rồi bỏ * nói dở chừng lại thôi",
    example: "làm dở chừng rồi bỏ * nói dở chừng lại thôi",
  },
  {
    word: "dở dang",
    part_of_speech: "tính từ",
    meaning:
      "đang còn chưa xong, chưa trọn (nhưng phải dừng, phải bỏ): học hành dở dang * câu chuyện bỏ dở dang",
    example: "học hành dở dang * câu chuyện bỏ dở dang",
  },
  {
    word: "dơ dáng dạng hình",
    part_of_speech: "",
    meaning:
      "như dơ dáng dại hình: “Người sao khéo khéo là xinh, Nói sao dơ dáng dạng hình mới hay!” (HT)",
    example:
      "“Người sao khéo khéo là xinh, Nói sao dơ dáng dạng hình mới hay!” (HT)",
  },
  {
    word: "dơ dángdại hình",
    part_of_speech: "tính từ",
    meaning:
      'xấu xa, để lộ vẻ trơ trẽn, không biết hổ thẹn: "Lại càng dơ dáng dại hình, Đành thân phận thiếp, ngại danh giá chàng." (TKiều)',
    example:
      'Lại càng dơ dáng dại hình, Đành thân phận thiếp, ngại danh giá chàng." (TKiều)',
  },
  {
    word: "dớ dẩn",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) ngớ ngẩn, ngờ nghệch: chuyện dớ dẩn * ăn nói dớ dẩn",
    example: "chuyện dớ dẩn * ăn nói dớ dẩn",
  },
  {
    word: "dở đục dở trong",
    part_of_speech: "",
    meaning:
      'ví thái độ lập lờ, không rõ ràng, dứt khoát: "Làm chi dở đục dở trong, Lờ lờ nước hến cho lòng tương tư." (ca dao)',
    example:
      'Làm chi dở đục dở trong, Lờ lờ nước hến cho lòng tương tư." (ca dao)',
  },
  {
    word: "dơ dáy",
    part_of_speech: "tính từ",
    meaning: "như bẩn thỉu: quần áo dơ dáy",
    example: "quần áo dơ dáy",
  },
  {
    word: "dở dói",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bày vẽ thêm chuyện, gây phiền phức, lôi thôi: làm giản tiện thôi, giở giói ra làm gì!",
    example: "làm giản tiện thôi, giở giói ra làm gì!",
  },
  {
    word: "dở dói",
    part_of_speech: "động từ",
    meaning:
      "giở trò này, trò kia (nói khái quát): đang yên đang lành sao lại giở giói ra như vậy?",
    example: "đang yên đang lành sao lại giở giói ra như vậy?",
  },
  {
    word: "dở hơi",
    part_of_speech: "tính từ",
    meaning: "có tính khí, tâm thần không được bình thường: đồ dở hơi!",
    example: "đồ dở hơi!",
  },
  {
    word: "dở hơi",
    part_of_speech: "tính từ",
    meaning:
      '(Khẩu ngữ) hơi gàn, biểu hiện bằng những hành vi không như lẽ thường: "Mẹ dở hơi thật. Nhàn nhã, thảnh thơi không muốn lại muốn chui đầu vào địa ngục." (NgKhải; 6)',
    example:
      'Mẹ dở hơi thật. Nhàn nhã, thảnh thơi không muốn lại muốn chui đầu vào địa ngục." (NgKhải; 6)',
  },
  {
    word: "dở ẹc",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ, khẩu ngữ) quá dở, dở hết mức: văn viết dở ẹc!",
    example: "văn viết dở ẹc!",
  },
  {
    word: "dở người",
    part_of_speech: "tính từ",
    meaning:
      "có tính khí, tâm thần không được bình thường, biểu hiện bằng những hành vi ngớ ngẩn: tính lẩm cẩm dở người",
    example: "tính lẩm cẩm dở người",
  },
  {
    word: "dời",
    part_of_speech: "động từ",
    meaning:
      "thay đổi hoặc làm thay đổi chỗ, địa điểm vốn tương đối cố định: dời nhà * dời non lấp biển",
    example: "dời nhà * dời non lấp biển",
  },
  {
    word: "dời đổi",
    part_of_speech: "động từ",
    meaning:
      'thay đổi, không giữ nguyên như cũ: "Việc lứa đôi ngậm ngùi nhiều nỗi, Biết có trọn đời hay dời đổi nay mai?" (ca dao)',
    example:
      'Việc lứa đôi ngậm ngùi nhiều nỗi, Biết có trọn đời hay dời đổi nay mai?" (ca dao)',
  },
  {
    word: "dợn",
    part_of_speech: "động từ",
    meaning:
      "(mặt nước) chuyển động uốn lượn lên xuống rất nhẹ khi bị xao động: mặt hồ dợn sóng * nước xao sóng dợn",
    example: "mặt hồ dợn sóng * nước xao sóng dợn",
  },
  {
    word: "dợn",
    part_of_speech: "danh từ",
    meaning:
      'làn sóng dợn hoặc nói chung những đường nét trông như làn sóng dợn trên một mặt phẳng: dợn vân trên mặt gỗ * "Dừng chân bước xuống ghe buôn, Sóng bao nhiêu dợn, dạ anh buồn bấy nhiêu." (ca dao)',
    example:
      'dợn vân trên mặt gỗ * "Dừng chân bước xuống ghe buôn, Sóng bao nhiêu dợn, dạ anh buồn bấy nhiêu." (ca dao)',
  },
  {
    word: "dợm",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) chực sẵn, chuẩn bị sẵn tư thế để làm việc gì: dợm đứng dậy * mấy lần dợm nói nhưng lại thôi",
    example: "dợm đứng dậy * mấy lần dợm nói nhưng lại thôi",
  },
  {
    word: "dớp",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) việc không may gặp phải, vận rủi: "Dớp nhà gặp bước truân chuyên, Tuy nghèo có một nhưng hiền không hai." (PCCH)',
    example:
      'Dớp nhà gặp bước truân chuyên, Tuy nghèo có một nhưng hiền không hai." (PCCH)',
  },
  {
    word: "dớp",
    part_of_speech: "danh từ",
    meaning:
      "việc không may (thường là tai nạn) lặp lại, có thể nhiều lần, giống như đã từng xảy ra: đoạn đường này có dớp, rất hay xảy ra tai nạn",
    example: "đoạn đường này có dớp, rất hay xảy ra tai nạn",
  },
  {
    word: "dù",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng cầm tay để che mưa nắng, thường dùng cho phụ nữ, giống như cái ô nhưng có màu sắc và nông lòng hơn: che dù",
    example: "che dù",
  },
  {
    word: "dù",
    part_of_speech: "danh từ",
    meaning: "(Nam) ô (để che mưa nắng)",
    example: "thả dù * vận động viên nhảy dù",
  },
  {
    word: "dù",
    part_of_speech: "danh từ",
    meaning:
      "phương tiện khi xoè ra trông giống như cái ô lớn, lợi dụng sức cản của không khí để làm chậm tốc độ rơi của người hay vật từ trên cao xuống: thả dù * vận động viên nhảy dù",
    example: "sư đoàn dù * lính dù",
  },
  {
    word: "dù",
    part_of_speech: "kết từ",
    meaning:
      'từ dùng để khẳng định nhấn mạnh rằng điều nói đến vẫn xảy ra, vẫn đúng ngay cả trong điều kiện không thuận lợi hoặc bất thường đã được nêu trước đó: dù có mưa cũng phải đi * "Dù ai nói ngả nói nghiêng, Lòng ta vẫn vững như kiềng ba chân." (Cdao)',
    example:
      'dù có mưa cũng phải đi * "Dù ai nói ngả nói nghiêng, Lòng ta vẫn vững như kiềng ba chân." (Cdao)',
  },
  {
    word: "dụ",
    part_of_speech: "động từ",
    meaning:
      "làm cho nghĩ là có lợi mà tự đến nơi nào đó hay tự làm việc gì đó, phục vụ cho yêu cầu của mình: dụ hàng * dụ quân địch vào trận địa phục kích",
    example: "dụ hàng * dụ quân địch vào trận địa phục kích",
  },
  {
    word: "du",
    part_of_speech: "động từ",
    meaning: "đẩy một cách nhanh, gọn: du cho ngã ngửa ra",
    example: "du cho ngã ngửa ra",
  },
  {
    word: "dù cho",
    part_of_speech: "kết từ",
    meaning:
      'dù có đến như thế chăng nữa (thì cũng vẫn như vậy, không thay đổi): "Dù cho chờ đợi mấy đông, Đắng cay cũng chịu mặn nồng cũng cam." (ca dao)',
    example:
      'Dù cho chờ đợi mấy đông, Đắng cay cũng chịu mặn nồng cũng cam." (ca dao)',
  },
  {
    word: "du di",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) xê xích, thêm bớt chút ít: giá cả có thể thương lượng, du di tí chút",
    example: "giá cả có thể thương lượng, du di tí chút",
  },
  {
    word: "dụ dỗ",
    part_of_speech: "động từ",
    meaning:
      "làm cho xiêu lòng mà nghe theo, làm theo bằng những lời hứa hẹn về quyền lợi: dụ dỗ trẻ con * dùng lời ngon ngọt để dụ dỗ",
    example: "dụ dỗ trẻ con * dùng lời ngon ngọt để dụ dỗ",
  },
  {
    word: "du côn",
    part_of_speech: "tính từ",
    meaning:
      "rất hung hãn, có tính chất của một kẻ du côn: hành động du côn * tính rất du côn",
    example: "hành động du côn * tính rất du côn",
  },
  {
    word: "du đãng",
    part_of_speech: "động từ",
    meaning:
      "ăn chơi lêu lổng, phóng túng, có tính chất của một kẻ du đãng: những kẻ du đãng * lối sống du đãng",
    example: "những kẻ du đãng * lối sống du đãng",
  },
  {
    word: "du dương",
    part_of_speech: "tính từ",
    meaning:
      "(âm thanh) khi trầm khi bổng và nghe rất êm tai: tiếng nhạc du dương trầm bổng",
    example: "tiếng nhạc du dương trầm bổng",
  },
  {
    word: "du hành vũ trụ",
    part_of_speech: "động từ",
    meaning:
      "bay vào trong không gian vũ trụ để khảo sát trực tiếp các thiên thể và khoảng không gian giữa thiên thể: nhà du hành vũ trụ",
    example: "nhà du hành vũ trụ",
  },
  {
    word: "du học sinh",
    part_of_speech: "danh từ",
    meaning:
      "học sinh, sinh viên đi học ở nước ngoài: gặp mặt các du học sinh đã học tại Nga",
    example: "gặp mặt các du học sinh đã học tại Nga",
  },
  {
    word: "du học",
    part_of_speech: "động từ",
    meaning: "đi học ở nước ngoài: cho con đi du học * sang Mĩ du học",
    example: "cho con đi du học * sang Mĩ du học",
  },
  {
    word: "du khảo",
    part_of_speech: "động từ",
    meaning:
      "đi xa để vừa tham quan, vừa khảo sát, nghiên cứu nói chung: chuyến du khảo của các nhà văn hoá Pháp",
    example: "chuyến du khảo của các nhà văn hoá Pháp",
  },
  {
    word: "du khách",
    part_of_speech: "danh từ",
    meaning: "khách đi chơi xa, khách du lịch: du khách đến tham quan",
    example: "du khách đến tham quan",
  },
  {
    word: "du kích",
    part_of_speech: "danh từ",
    meaning:
      "lực lượng nòng cốt của dân quân, tác chiến linh hoạt bằng lực lượng nhỏ lẻ, kết hợp mọi thứ vũ khí thô sơ và hiện đại, kết hợp đánh tiêu diệt nhỏ với đánh tiêu hao rộng rãi: tham gia du kích",
    example: "tham gia du kích",
  },
  {
    word: "du kích",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (lối hoạt động, làm việc) phân tán, không có kế hoạch cụ thể và lâu dài, không có quy chế chính thức; phân biệt với chính quy: lối làm ăn du kích",
    example: "lối làm ăn du kích",
  },
  {
    word: "dù sao",
    part_of_speech: "kết từ",
    meaning:
      'dù có thế nào thì sự tình cũng cứ hiển nhiên như thế, cũng đã xảy ra rồi: dù sao cũng không nên làm thế * "Dù sao bình đã vỡ rồi, Lấy thân mà trả nợ đời cho xong!" (TKiều)',
    example:
      'dù sao cũng không nên làm thế * "Dù sao bình đã vỡ rồi, Lấy thân mà trả nợ đời cho xong!" (TKiều)',
  },
  {
    word: "du thủ du thực",
    part_of_speech: "",
    meaning: "chơi bời lêu lổng, không có nghề nghiệp: bọn du thủ du thực",
    example: "bọn du thủ du thực",
  },
  {
    word: "du lịch",
    part_of_speech: "động từ",
    meaning:
      "đi chơi đến những nơi xa để hiểu biết thêm về phong cảnh, con người, cuộc sống: khu du lịch sinh thái * hướng dẫn viên du lịch * đi du lịch nước ngoài",
    example:
      "khu du lịch sinh thái * hướng dẫn viên du lịch * đi du lịch nước ngoài",
  },
  {
    word: "du nhập",
    part_of_speech: "động từ",
    meaning:
      "nhập (yếu tố, hiện tượng văn hoá) từ nước ngoài vào: những mốt mới du nhập",
    example: "những mốt mới du nhập",
  },
  {
    word: "du mục",
    part_of_speech: "động từ",
    meaning:
      "chăn nuôi không ở cố định một chỗ, thường đưa bầy gia súc đến nơi có nhiều cỏ và nước uống, sau một thời gian lại chuyển đi nơi khác (một phương thức chăn nuôi): dân du mục * sống du mục",
    example: "dân du mục * sống du mục",
  },
  {
    word: "du ngoạn",
    part_of_speech: "động từ",
    meaning:
      "(cũ) đi chơi ngắm cảnh: đi du ngoạn * chuyến du ngoạn trên sông Đà",
    example: "đi du ngoạn * chuyến du ngoạn trên sông Đà",
  },
  {
    word: "dù rằng",
    part_of_speech: "kết từ",
    meaning:
      'mặc cho điều kiện không phù hợp hoặc thuận lợi, sự việc vẫn cứ diễn ra: "Hoa thơm mất nhị đi rồi, Dù rằng trang điểm cũng người vô duyên." (ca dao)',
    example:
      'Hoa thơm mất nhị đi rồi, Dù rằng trang điểm cũng người vô duyên." (ca dao)',
  },
  {
    word: "du thuyền",
    part_of_speech: "danh từ",
    meaning:
      "tàu, thuyền (thường nhỏ, có đầy đủ tiện nghi) dùng để đi du lịch: đi du thuyền trên sông Hương",
    example: "đi du thuyền trên sông Hương",
  },
  {
    word: "dùa",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) lùa lại, gom lại: dùa thóc lại thành đống",
    example: "dùa thóc lại thành đống",
  },
  {
    word: "dục dặc",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) dùng dằng, lưỡng lự: còn dục dặc, chưa dám quyết * thái độ dục dặc",
    example: "còn dục dặc, chưa dám quyết * thái độ dục dặc",
  },
  {
    word: "dũa",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ bằng thép, có khía dùng để mài vật khác cho sắc hoặc cho nhẵn: cái giũa",
    example: "cái giũa",
  },
  {
    word: "dũa",
    part_of_speech: "động từ",
    meaning: "mài bằng giũa: giũa móng tay",
    example: "giũa móng tay",
  },
  {
    word: "dục tính",
    part_of_speech: "danh từ",
    meaning:
      "sự đòi hỏi sinh lí về quan hệ tính giao: hiểu biết về tính dục * thoả mãn tính dục",
    example: "hiểu biết về tính dục * thoả mãn tính dục",
  },
  {
    word: "dụi",
    part_of_speech: "động từ",
    meaning:
      "làm cho tắt bằng cách gí và day đi day lại đầu đang cháy vào một vật gì: dụi tắt bó đuốc * dụi điếu thuốc xuống đất",
    example: "dụi tắt bó đuốc * dụi điếu thuốc xuống đất",
  },
  {
    word: "dụi",
    part_of_speech: "động từ",
    meaning:
      "đưa bộ phận cơ thể (thường là đầu) cho cọ xát nhẹ vào vật gì: đứa bé dụi đầu vào ngực mẹ",
    example: "đứa bé dụi đầu vào ngực mẹ",
  },
  {
    word: "dụi",
    part_of_speech: "động từ",
    meaning: "xát nhẹ nhiều lần tay hoặc ngón tay lên mi mắt: lấy tay dụi mắt",
    example: "lấy tay dụi mắt",
  },
  {
    word: "dục vọng",
    part_of_speech: "danh từ",
    meaning:
      "sự ham muốn về mặt vật chất (hàm ý chê): thoả mãn dục vọng cá nhân",
    example: "thoả mãn dục vọng cá nhân",
  },
  {
    word: "dùi",
    part_of_speech: "danh từ",
    meaning:
      "thanh tròn, ngắn, thường bằng gỗ, dùng để gõ, đánh vào vật khác cho phát ra tiếng: cầm dùi gõ mõ * đánh trống bỏ dùi (tng)",
    example: "cầm dùi gõ mõ * đánh trống bỏ dùi (tng)",
  },
  {
    word: "dùi",
    part_of_speech: "danh từ",
    meaning:
      'đồ dùng để tạo lỗ thủng, thường bằng sắt, hình que, một đầu nhọn: cái dùi sắt * "Ngựa hươu thay đổi như chơi, Giấu gươm đầu lưỡi thọc dùi trong tay." (TTK)',
    example:
      'cái dùi sắt * "Ngựa hươu thay đổi như chơi, Giấu gươm đầu lưỡi thọc dùi trong tay." (TTK)',
  },
  {
    word: "dùi",
    part_of_speech: "động từ",
    meaning: "tạo lỗ thủng bằng cái dùi: dùi thủng một lỗ trên tấm ván",
    example: "dùi thủng một lỗ trên tấm ván",
  },
  {
    word: "dúi",
    part_of_speech: "động từ",
    meaning:
      "cầm gọn trong tay mà ấn xuống để nhét vào: dúi chiếc áo vào ba lô * dúi tiền vào tay bạn",
    example: "dúi chiếc áo vào ba lô * dúi tiền vào tay bạn",
  },
  {
    word: "dúi",
    part_of_speech: "động từ",
    meaning: "ấn và đẩy mạnh: bị dúi mạnh một cái, ngã lăn ra sàn",
    example: "bị dúi mạnh một cái, ngã lăn ra sàn",
  },
  {
    word: "dúi",
    part_of_speech: "động từ",
    meaning: "làm cho cắm đầu xuống: ngã dúi đầu vào vách hầm",
    example: "ngã dúi đầu vào vách hầm",
  },
  {
    word: "dũi",
    part_of_speech: "động từ",
    meaning:
      "thọc mõm, miệng xuống rồi đẩy ngược lên (để tìm thức ăn): lợn dũi đất",
    example: "lợn dũi đất",
  },
  {
    word: "dúi dụi",
    part_of_speech: "động từ",
    meaning: "từ gợi tả trạng thái bị ngã chúi xuống liên tiếp: ngã dúi dụi",
    example: "ngã dúi dụi",
  },
  {
    word: "dụm",
    part_of_speech: "động từ",
    meaning: "(phương ngữ, khẩu ngữ) tụm, chụm: dụm đầu vào nhau nói nhỏ",
    example: "dụm đầu vào nhau nói nhỏ",
  },
  {
    word: "dùi mài",
    part_of_speech: "động từ",
    meaning:
      '(cũ, văn chương) cố công, kiên nhẫn học tập cho tinh thông: "Ba đông đèn sách dùi mài, Phạm Công nào đã biết ai có tình!" (PCCH)',
    example:
      'Ba đông đèn sách dùi mài, Phạm Công nào đã biết ai có tình!" (PCCH)',
  },
  {
    word: "dúm",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) buộc túm các mép, các góc lại cho kín, cho gọn: dúm miệng túi lại",
    example: "dúm miệng túi lại",
  },
  {
    word: "dùi mài kinh sử",
    part_of_speech: "",
    meaning:
      '(cũ, văn chương) khổ công, kiên nhẫn học tập cho tinh thông để thi cử, thời phong kiến: "Trai thời đọc sách ngâm nga, Dùi mài kinh sử để chờ đại khoa." (ca dao)',
    example:
      'Trai thời đọc sách ngâm nga, Dùi mài kinh sử để chờ đại khoa." (ca dao)',
  },
  {
    word: "dùn",
    part_of_speech: "tính từ",
    meaning:
      '(phương ngữ) chùng, không căng: "Một mai trống lủng khó hàn, Dây dùn khó dứt, người ngoan khó tìm." (ca dao)',
    example:
      'Một mai trống lủng khó hàn, Dây dùn khó dứt, người ngoan khó tìm." (ca dao)',
  },
  {
    word: "dùng",
    part_of_speech: "động từ",
    meaning:
      "lấy làm vật liệu, phương tiện để nhằm tạo ra cái gì, thực hiện việc gì: dùng gỗ đóng bàn ghế * dùng tiếng Anh để giao tiếp * biết cách dùng người",
    example:
      "dùng gỗ đóng bàn ghế * dùng tiếng Anh để giao tiếp * biết cách dùng người",
  },
  {
    word: "dùng",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) ăn uống: mời bác dùng cơm * anh dùng gì? Cà phê hay nước chanh?",
    example: "mời bác dùng cơm * anh dùng gì? Cà phê hay nước chanh?",
  },
  {
    word: "dũng",
    part_of_speech: "danh từ",
    meaning:
      "(Nam cũng dõng) sức mạnh thể chất và tinh thần trên hẳn mức bình thường, tạo khả năng dám đương đầu với nguy hiểm để làm những việc nên làm: trí dũng có thừa * mỗi người đều có chí, có dũng riêng",
    example: "trí dũng có thừa * mỗi người đều có chí, có dũng riêng",
  },
  {
    word: "dụng binh",
    part_of_speech: "động từ",
    meaning: "sử dụng binh lực: phép dụng binh của Trần Hưng Đạo",
    example: "phép dụng binh của Trần Hưng Đạo",
  },
  {
    word: "dũng cảm",
    part_of_speech: "tính từ",
    meaning:
      "có dũng khí, dám đương đầu với khó khăn và nguy hiểm: dũng cảm nhận khuyết điểm",
    example: "dũng cảm nhận khuyết điểm",
  },
  {
    word: "dụng cụ",
    part_of_speech: "danh từ",
    meaning:
      "vật do con người chế tạo ra để giúp làm tăng khả năng, hiệu lực hoặc phạm vi hoạt động của con người: mua sắm dụng cụ học tập * dụng cụ y tế",
    example: "mua sắm dụng cụ học tập * dụng cụ y tế",
  },
  {
    word: "dùng dằng",
    part_of_speech: "động từ",
    meaning:
      'lưỡng lự, chưa quyết định dứt khoát xem nên đi hay nên ở: "Quân tử dùng dằng đi chẳng dứt, Đi thì cũng dở ở không xong." (HXHương; 35)',
    example:
      'Quân tử dùng dằng đi chẳng dứt, Đi thì cũng dở ở không xong." (HXHương; 35)',
  },
  {
    word: "dùng dắng",
    part_of_speech: "động từ",
    meaning: "(hiếm) như dùng dằng: lo ngại nên còn dùng dắng",
    example: "lo ngại nên còn dùng dắng",
  },
  {
    word: "dùng bữa",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) dùng cơm, ăn cơm (thường dùng trong lời mời chào): mời bạn tới nhà dùng bữa",
    example: "mời bạn tới nhà dùng bữa",
  },
  {
    word: "dụng công",
    part_of_speech: "động từ",
    meaning:
      "bỏ ra nhiều công sức để suy nghĩ, tìm tòi trong công việc: dụng công nghiên cứu",
    example: "dụng công nghiên cứu",
  },
  {
    word: "dung dưỡng",
    part_of_speech: "động từ",
    meaning:
      'dung túng và tạo điều kiện để cho dễ dàng phát triển: "Lập nghiêm ai dám đến gần, Bởi quan dung dưỡng nên dân nó lờn." (ca dao)',
    example:
      'Lập nghiêm ai dám đến gần, Bởi quan dung dưỡng nên dân nó lờn." (ca dao)',
  },
  {
    word: "dung dăng",
    part_of_speech: "động từ",
    meaning:
      "nắm tay nhau đung đưa theo nhịp bước đi: bọn trẻ đang dung dăng ở ngoài sân",
    example: "bọn trẻ đang dung dăng ở ngoài sân",
  },
  {
    word: "dung dịch",
    part_of_speech: "danh từ",
    meaning:
      "hỗn hợp có cùng một tính chất của hai hay nhiều chất, trong đó có một hoặc một số chất phân bố với mật độ đồng đều (gọi là được hoà tan) trong môi trường của một số chất khác (gọi là dung môi): dung dịch muối * dung dịch acid loãng",
    example: "dung dịch muối * dung dịch acid loãng",
  },
  {
    word: "dung dị",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như bình dị: lối sống dung dị",
    example: "lối sống dung dị",
  },
  {
    word: "dung hoà",
    part_of_speech: "động từ",
    meaning:
      "làm cho có sự nhân nhượng lẫn nhau để đạt được những điểm chung, trở thành không còn đối lập nhau nữa: biết dung hoà giữa cái cũ và cái mới",
    example: "biết dung hoà giữa cái cũ và cái mới",
  },
  {
    word: "dung nạp",
    part_of_speech: "động từ",
    meaning:
      "nhận cho tồn tại trong phạm vi thuộc quyền tác động của mình: không dung nạp những kẻ đớn hèn",
    example: "không dung nạp những kẻ đớn hèn",
  },
  {
    word: "dung nghi",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) dáng vẻ nghiêm trang, đứng đắn: "Trẫm sinh công chúa nữ nhi, Mày ngài mắt phượng dung nghi ai tầy." (PCCH)',
    example:
      'Trẫm sinh công chúa nữ nhi, Mày ngài mắt phượng dung nghi ai tầy." (PCCH)',
  },
  {
    word: "dũng mãnh",
    part_of_speech: "tính từ",
    meaning: "dũng cảm và mạnh mẽ một cách phi thường: viên tướng dũng mãnh",
    example: "viên tướng dũng mãnh",
  },
  {
    word: "dũng khí",
    part_of_speech: "danh từ",
    meaning:
      "khí phách dám đương đầu với khó khăn, nguy hiểm để làm những việc nên làm: dũng khí của người cách mạng",
    example: "dũng khí của người cách mạng",
  },
  {
    word: "dung mạo",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) dáng điệu và sắc mặt, vẻ bề ngoài nói chung: dung mạo đoan trang",
    example: "dung mạo đoan trang",
  },
  {
    word: "dung lượng",
    part_of_speech: "danh từ",
    meaning:
      "số lượng, nội dung tối đa chứa đựng ở bên trong vật gì: dung lượng của ổ đĩa * bộ tiểu thuyết có dung lượng lớn",
    example: "dung lượng của ổ đĩa * bộ tiểu thuyết có dung lượng lớn",
  },
  {
    word: "dung nhan",
    part_of_speech: "danh từ",
    meaning: "(văn chương) vẻ đẹp của khuôn mặt: dung nhan lộng lẫy",
    example: "dung nhan lộng lẫy",
  },
  {
    word: "dũng sĩ",
    part_of_speech: "danh từ",
    meaning:
      "người có sức mạnh thể chất và tinh thần trên hẳn mức bình thường, dám đương đầu với những sức chống đối, với nguy hiểm để làm những việc nên làm: chiêu mộ dũng sĩ",
    example: "chiêu mộ dũng sĩ",
  },
  {
    word: "dung sai",
    part_of_speech: "danh từ",
    meaning:
      "sai lệch cho phép về kích thước, khối lượng, v.v. trong kĩ thuật: độ dung sai cho phép của kết cấu công trình",
    example: "độ dung sai cho phép của kết cấu công trình",
  },
  {
    word: "dung tha",
    part_of_speech: "động từ",
    meaning:
      "rộng lượng mà tha cho, không trừng trị: một tội ác không thể dung tha",
    example: "một tội ác không thể dung tha",
  },
  {
    word: "dung thứ",
    part_of_speech: "động từ",
    meaning:
      "rộng lượng mà bỏ qua cho, miễn đi cho, không trừng phạt: dung thứ cho kẻ lỗi lầm",
    example: "dung thứ cho kẻ lỗi lầm",
  },
  {
    word: "dụng tâm",
    part_of_speech: "động từ",
    meaning:
      "có ý thức hướng hành động nhằm vào mục đích riêng ẩn kín nào đó (thường là không tốt): dụng tâm hại người",
    example: "dụng tâm hại người",
  },
  {
    word: "dụng tâm",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) để hết tâm trí vào làm việc gì: dụng tâm vào việc đèn sách",
    example: "dụng tâm vào việc đèn sách",
  },
  {
    word: "dụng tâm",
    part_of_speech: "danh từ",
    meaning:
      "ý thức nhằm vào mục đích riêng ẩn kín nào đó trong hành động (nói về việc có quan hệ đến người khác): nói sai với dụng tâm vu cáo",
    example: "nói sai với dụng tâm vu cáo",
  },
  {
    word: "dung tục",
    part_of_speech: "tính từ",
    meaning:
      "tầm thường và thô thiển, không tinh tế, không tế nhị: lời lẽ dung tục",
    example: "lời lẽ dung tục",
  },
  {
    word: "dung túng",
    part_of_speech: "động từ",
    meaning:
      "(người, bộ phận có trách nhiệm, quyền hành) không ngăn chặn hành vi sai trái của người khác, để cho tha hồ làm bậy: dung túng cho tay chân làm càn * dung túng cho kẻ phản nghịch",
    example: "dung túng cho tay chân làm càn * dung túng cho kẻ phản nghịch",
  },
  {
    word: "dung quang",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) vẻ tươi đẹp, sáng sủa của khuôn mặt: "Ông bà trông mặt, cầm tay, Dung quang chẳng khác chi ngày bước ra." (TKiều)',
    example:
      'Ông bà trông mặt, cầm tay, Dung quang chẳng khác chi ngày bước ra." (TKiều)',
  },
  {
    word: "dung thân",
    part_of_speech: "động từ",
    meaning: "có nơi ăn ở để được yên thân: không có chốn dung thân",
    example: "không có chốn dung thân",
  },
  {
    word: "dung tích",
    part_of_speech: "danh từ",
    meaning:
      "lượng tối đa mà vật chứa có thể giữ được, tích được ở bên trong, biểu thị bằng con số: dung tích của thùng là 20 lít",
    example: "dung tích của thùng là 20 lít",
  },
  {
    word: "dụng võ",
    part_of_speech: "động từ",
    meaning: "thi thố tài năng: không có đất dụng võ",
    example: "không có đất dụng võ",
  },
  {
    word: "duộc",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng thường bằng tre hay sắt tây, có cán dài, để đong, múc chất lỏng trong vật đựng có đáy sâu: duộc đong dầu * một duộc nước mắm",
    example: "duộc đong dầu * một duộc nước mắm",
  },
  {
    word: "duộc",
    part_of_speech: "danh từ",
    meaning:
      "(thông tục) hạng người, lũ (hàm ý coi khinh): bọn chúng cùng một duộc với nhau",
    example: "bọn chúng cùng một duộc với nhau",
  },
  {
    word: "dụng ý",
    part_of_speech: "danh từ",
    meaning:
      "ý thức nhằm vào mục đích nào đó trong hành động: xuyên tạc với dụng ý xấu",
    example: "xuyên tạc với dụng ý xấu",
  },
  {
    word: "duốc",
    part_of_speech: "động từ",
    meaning:
      "làm cho cá ở sông ngòi, v.v. say, chết vì bị trúng độc (một phương pháp bắt cá): duốc cá bằng lá độc",
    example: "duốc cá bằng lá độc",
  },
  {
    word: "dút dát",
    part_of_speech: "tính từ",
    meaning:
      "nhát, hay rụt rè, sợ sệt: cô bé nhút nhát * tính nhút nhát nên không dám hỏi",
    example: "cô bé nhút nhát * tính nhút nhát nên không dám hỏi",
  },
  {
    word: "duỗi",
    part_of_speech: "động từ",
    meaning:
      "tự làm cho thẳng ra hết chiều dài một cách tự nhiên (thường nói về vật đang bị co lại): nằm duỗi thẳng người * chân co, chân duỗi",
    example: "nằm duỗi thẳng người * chân co, chân duỗi",
  },
  {
    word: "duỗi",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) buông ra, đẩy ra không muốn nhận về mình để khỏi bị vướng víu, ràng buộc: thấy khó nên duỗi ra",
    example: "thấy khó nên duỗi ra",
  },
  {
    word: "duy",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là phạm vi, đặc điểm hoặc tính chất của cái cá biệt, khác hẳn hay đối lập với cái chung, cái thông thường vừa được nói đến trước đó: tất cả đã đi rồi, duy một người ở lại",
    example: "tất cả đã đi rồi, duy một người ở lại",
  },
  {
    word: "duy nhất",
    part_of_speech: "tính từ",
    meaning:
      "chỉ có một mà thôi, không có hai: đứa con duy nhất * cả lớp chỉ có một điểm mười duy nhất",
    example: "đứa con duy nhất * cả lớp chỉ có một điểm mười duy nhất",
  },
  {
    word: "duy tâm",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về chủ nghĩa duy tâm; đối lập với duy vật: triết học duy tâm",
    example: "triết học duy tâm",
  },
  {
    word: "duy tâm",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) hay tin vào những điều mê tín dị đoan: người không duy tâm * tính rất duy tâm",
    example: "người không duy tâm * tính rất duy tâm",
  },
  {
    word: "duy vật",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về chủ nghĩa duy vật; đối lập với duy tâm: quan điểm duy vật",
    example: "quan điểm duy vật",
  },
  {
    word: "duy tân",
    part_of_speech: "động từ",
    meaning: "cải cách theo cái mới: tư tưởng duy tân * phong trào duy tân",
    example: "tư tưởng duy tân * phong trào duy tân",
  },
  {
    word: "duy tu",
    part_of_speech: "động từ",
    meaning:
      "sửa chữa, tu bổ để duy trì hoạt động (thường nói về máy móc, công trình lớn): duy tu, bảo dưỡng các tuyến đường bộ",
    example: "duy tu, bảo dưỡng các tuyến đường bộ",
  },
  {
    word: "duyên dáng",
    part_of_speech: "tính từ",
    meaning:
      "có những nét có duyên (nói tổng quát): nụ cười duyên dáng * điệu bộ rất duyên dáng",
    example: "nụ cười duyên dáng * điệu bộ rất duyên dáng",
  },
  {
    word: "duy trì",
    part_of_speech: "động từ",
    meaning:
      "giữ cho tiếp tục tồn tại trong tình trạng bình thường: tập thể dục để duy trì sức khoẻ * hoà bình trong khu vực được duy trì",
    example:
      "tập thể dục để duy trì sức khoẻ * hoà bình trong khu vực được duy trì",
  },
  {
    word: "duyên",
    part_of_speech: "danh từ",
    meaning:
      'phần cho là trời định dành cho mỗi người, về khả năng có quan hệ tình cảm (thường là quan hệ nam nữ, vợ chồng) hoà hợp, gắn bó nào đó trong cuộc đời: duyên trời định * "Người đâu gặp gỡ làm chi, Trăm năm biết có duyên gì hay không?" (TKiều)',
    example:
      'duyên trời định * "Người đâu gặp gỡ làm chi, Trăm năm biết có duyên gì hay không?" (TKiều)',
  },
  {
    word: "duyên",
    part_of_speech: "danh từ",
    meaning:
      'sự hài hoà của một số nét tế nhị đáng yêu ở con người, tạo nên vẻ hấp dẫn tự nhiên: nụ cười duyên * "Một thương tóc bỏ đuôi gà, Hai thương ăn nói mặn mà có duyên." (Cdao)',
    example:
      'nụ cười duyên * "Một thương tóc bỏ đuôi gà, Hai thương ăn nói mặn mà có duyên." (Cdao)',
  },
  {
    word: "duyên cớ",
    part_of_speech: "danh từ",
    meaning:
      "nguyên nhân trực tiếp của sự việc (thường là không hay): duyên cớ của sự việc * không hiểu duyên cớ làm sao",
    example: "duyên cớ của sự việc * không hiểu duyên cớ làm sao",
  },
  {
    word: "duyên do",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, hiếm) nguyên nhân, nguồn gốc trực tiếp của sự việc: trình bày duyên do sự việc",
    example: "trình bày duyên do sự việc",
  },
  {
    word: "duyên hải",
    part_of_speech: "danh từ",
    meaning: "ven biển: miền duyên hải",
    example: "miền duyên hải",
  },
  {
    word: "duyên kỳ ngộ",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) mối tình đẹp đẽ đã đến một cách hoàn toàn ngẫu nhiên: "Ngẫm duyên kì ngộ xưa nay, Lứa đôi ai dễ đẹp tày Thôi, Trương." (TKiều)',
    example:
      'Ngẫm duyên kì ngộ xưa nay, Lứa đôi ai dễ đẹp tày Thôi, Trương." (TKiều)',
  },
  {
    word: "duyên kiếp",
    part_of_speech: "danh từ",
    meaning:
      "nhân duyên có từ kiếp trước, theo quan niệm của đạo Phật: duyên kiếp vợ chồng",
    example: "duyên kiếp vợ chồng",
  },
  {
    word: "duyên ưa phận đẹp",
    part_of_speech: "",
    meaning:
      '(văn chương) duyên phận hoà hợp, đẹp lứa vừa đôi: "Dầu xa nhau năm bảy ngày đường, Duyên ưa phận đẹp thì nường cũng theo." (ca dao)',
    example:
      'Dầu xa nhau năm bảy ngày đường, Duyên ưa phận đẹp thì nường cũng theo." (ca dao)',
  },
  {
    word: "duyên nợ",
    part_of_speech: "danh từ",
    meaning:
      'quan hệ tình duyên ràng buộc tựa như nợ nần, được định sẵn từ kiếp trước, theo quan niệm của đạo Phật: có duyên nợ với nhau * "Ví chăng duyên nợ ba sinh, Làm chi đem thói khuynh thành trêu ngươi?" (TKiều)',
    example:
      'có duyên nợ với nhau * "Ví chăng duyên nợ ba sinh, Làm chi đem thói khuynh thành trêu ngươi?" (TKiều)',
  },
  {
    word: "duyên nợ",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương) quan hệ gắn bó tựa như đã được định sẵn, khó dứt bỏ: còn nhiều duyên nợ với văn chương",
    example: "còn nhiều duyên nợ với văn chương",
  },
  {
    word: "duyên kì ngộ",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) mối tình đẹp đẽ đã đến một cách hoàn toàn ngẫu nhiên: "Ngẫm duyên kì ngộ xưa nay, Lứa đôi ai dễ đẹp tày Thôi, Trương." (TKiều)',
    example:
      'Ngẫm duyên kì ngộ xưa nay, Lứa đôi ai dễ đẹp tày Thôi, Trương." (TKiều)',
  },
  {
    word: "duyên nghiệp",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như duyên nợ: có duyên nghiệp với nghề đạo diễn",
    example: "có duyên nghiệp với nghề đạo diễn",
  },
  {
    word: "duyên số",
    part_of_speech: "danh từ",
    meaning: "như duyên phận: duyên số lận đận * lấy nhau do duyên số",
    example: "duyên số lận đận * lấy nhau do duyên số",
  },
  {
    word: "duyên phận",
    part_of_speech: "danh từ",
    meaning: "số phận về tình duyên đã được định từ trước: duyên phận lỡ làng",
    example: "duyên phận lỡ làng",
  },
  {
    word: "duyệt",
    part_of_speech: "động từ",
    meaning:
      "(người hoặc cơ quan có thẩm quyền) xem xét và đồng ý để cho thực hiện, thi hành (bản dự thảo, dự án, v.v.): duyệt dự án * duyệt đơn",
    example: "duyệt dự án * duyệt đơn",
  },
  {
    word: "duyệt",
    part_of_speech: "động từ",
    meaning:
      "kiểm tra đội ngũ của lực lượng vũ trang một cách tượng trưng, trong một nghi lễ (hình thức vinh dự dành riêng cho bậc nguyên thủ): mời thủ tướng nước bạn duyệt đội danh dự",
    example: "mời thủ tướng nước bạn duyệt đội danh dự",
  },
  {
    word: "duyệt y",
    part_of_speech: "động từ",
    meaning: "(trang trọng) duyệt và chuẩn y: đề nghị đã được cấp trên duyệt y",
    example: "đề nghị đã được cấp trên duyệt y",
  },
  {
    word: "dử",
    part_of_speech: "danh từ",
    meaning:
      "(Nam ghèn) chất nhờn do tuyến mi mắt tiết ra, đọng lại ở khoé mắt: mắt sưng đỏ, đầy dử",
    example: "mắt sưng đỏ, đầy dử",
  },
  {
    word: "dữ",
    part_of_speech: "tính từ",
    meaning:
      "(người hoặc vật) có những hành vi, biểu hiện đáng sợ, tỏ ra sẵn sàng làm hại hoặc gây tai hại cho người khác, vật khác: hổ dữ * sóng dữ * bà ta dữ lắm!",
    example: "hổ dữ * sóng dữ * bà ta dữ lắm!",
  },
  {
    word: "dữ",
    part_of_speech: "tính từ",
    meaning:
      "có chứa những điều không hay hoặc có thể mang lại tai hoạ một cách đáng sợ: nhận được tin dữ * việc này lành ít, dữ nhiều",
    example: "nhận được tin dữ * việc này lành ít, dữ nhiều",
  },
  {
    word: "dữ",
    part_of_speech: "tính từ",
    meaning:
      "(Phương ngữ, hoặc kng) (sự việc diễn ra, biểu hiện ra) có cường độ rất mạnh, ở mức độ cao khác thường: gió thổi rất dữ * suy nghĩ dữ lắm",
    example: "gió thổi rất dữ * suy nghĩ dữ lắm",
  },
  {
    word: "dự án",
    part_of_speech: "danh từ",
    meaning:
      "bản dự thảo một văn kiện về luật pháp hay về một kế hoạch cụ thể nào đó: bản dự án quy hoạch thành phố * lập dự án * triển khai dự án trồng rừng",
    example:
      "bản dự án quy hoạch thành phố * lập dự án * triển khai dự án trồng rừng",
  },
  {
    word: "dứ",
    part_of_speech: "động từ",
    meaning:
      "đưa ra cho nhìn thấy cái ham thích để dụ, để nhử: dứ miếng thịt trước mũi con chó",
    example: "dứ miếng thịt trước mũi con chó",
  },
  {
    word: "dứ",
    part_of_speech: "động từ",
    meaning:
      "giơ ra cho nhìn thấy vật dùng để đánh, đâm, v.v. và làm động tác như chực đánh, chực đâm, để hăm doạ: dứ nắm đấm để doạ",
    example: "dứ nắm đấm để doạ",
  },
  {
    word: "dư âm",
    part_of_speech: "danh từ",
    meaning: "phần còn vang của âm thanh đang tắt dần: dư âm của tiếng chuông",
    example: "dư âm của tiếng chuông",
  },
  {
    word: "dư âm",
    part_of_speech: "danh từ",
    meaning:
      "cái còn vọng lại của sự kiện đã từng có tiếng vang: dư âm của chiến tranh",
    example: "dư âm của chiến tranh",
  },
  {
    word: "dư",
    part_of_speech: "tính từ",
    meaning: "có thêm một phần lẻ nữa ngoài số tròn: 13 chia 4 được 3, dư 1",
    example: "13 chia 4 được 3, dư 1",
  },
  {
    word: "dự báo",
    part_of_speech: "động từ",
    meaning:
      "báo trước về tình hình có nhiều khả năng sẽ xảy ra, dựa trên cơ sở những số liệu, thông tin đã có (thường nói về hiện tượng thiên nhiên, xã hội): dự báo thời tiết * dự báo về mức độ gia tăng dân số",
    example: "dự báo thời tiết * dự báo về mức độ gia tăng dân số",
  },
  {
    word: "dự",
    part_of_speech: "động từ",
    meaning:
      "góp phần bằng sự có mặt của mình vào một hoạt động chung: dự mít tinh * khách dự đám cưới * dự buổi chiêu đãi",
    example: "dự mít tinh * khách dự đám cưới * dự buổi chiêu đãi",
  },
  {
    word: "dự bị",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái sẵn sàng có thể thay thế hoặc bổ sung khi cần: cầu thủ dự bị * đại biểu dự bị * lực lượng dự bị cho quân chính quy",
    example:
      "cầu thủ dự bị * đại biểu dự bị * lực lượng dự bị cho quân chính quy",
  },
  {
    word: "dự bị",
    part_of_speech: "tính từ",
    meaning:
      "ở thời kì chuẩn bị thêm cho đầy đủ điều kiện để có thể được công nhận là thành viên chính thức của một tổ chức (thường là một chính đảng): đảng viên dự bị",
    example: "đảng viên dự bị",
  },
  {
    word: "dư ba",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, hiếm) gợn sóng còn lại; thường dùng để ví ảnh hưởng còn lưu lại của một sự kiện lớn đã kết thúc: dư ba của một trào lưu tư tưởng",
    example: "dư ba của một trào lưu tư tưởng",
  },
  {
    word: "dự bị đại học",
    part_of_speech: "danh từ",
    meaning:
      "chương trình học chuẩn bị thêm kiến thức để có thể vào đại học: học sinh trường dự bị đại học",
    example: "học sinh trường dự bị đại học",
  },
  {
    word: "dư dả",
    part_of_speech: "tính từ",
    meaning:
      "có thừa, so với mức cần thiết của đời sống vật chất: tiền bạc dư dả * ăn tiêu dư dả",
    example: "tiền bạc dư dả * ăn tiêu dư dả",
  },
  {
    word: "dự chi",
    part_of_speech: "động từ",
    meaning: "dự tính sẽ chi: dự chi ngân sách năm sau",
    example: "dự chi ngân sách năm sau",
  },
  {
    word: "dữ dằn",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) (dáng vẻ, điệu bộ, v.v.) trông rất dữ, khiến người ta phải sợ: bộ mặt dữ dằn",
    example: "bộ mặt dữ dằn",
  },
  {
    word: "dư chấn",
    part_of_speech: "danh từ",
    meaning:
      "chấn động nhẹ diễn ra tiếp theo sau trận động đất: bị ảnh hưởng của dư chấn",
    example: "bị ảnh hưởng của dư chấn",
  },
  {
    word: "dự cảm",
    part_of_speech: "danh từ",
    meaning:
      "sự cảm biết về điều có nhiều khả năng sẽ xảy ra: tin vào dự cảm của mình",
    example: "tin vào dự cảm của mình",
  },
  {
    word: "dự cảm",
    part_of_speech: "động từ",
    meaning:
      'cảm nhận thấy trước, do linh tính mách bảo: dự cảm có điều không lành sắp xảy ra * "Nó biết là bà nó phật lòng và nó dự cảm được tình cảnh bi đát sẽ dẫn đến?" (MVKháng; 9)',
    example:
      'dự cảm có điều không lành sắp xảy ra * "Nó biết là bà nó phật lòng và nó dự cảm được tình cảnh bi đát sẽ dẫn đến?" (MVKháng; 9)',
  },
  {
    word: "dữ dội",
    part_of_speech: "tính từ",
    meaning:
      "(sự việc diễn ra) hết sức mạnh mẽ và có tác động đáng sợ: sóng đánh dữ dội * giặc bắn phá dữ dội",
    example: "sóng đánh dữ dội * giặc bắn phá dữ dội",
  },
  {
    word: "dư dật",
    part_of_speech: "tính từ",
    meaning: "có thừa, trên mức đầy đủ (nói khái quát): tiền của dư dật",
    example: "tiền của dư dật",
  },
  {
    word: "dự định",
    part_of_speech: "động từ",
    meaning:
      "định sẽ làm việc gì đó nếu không có gì thay đổi: dự định mở trường học tư * dự định ăn tết xong sẽ đi",
    example: "dự định mở trường học tư * dự định ăn tết xong sẽ đi",
  },
  {
    word: "dự định",
    part_of_speech: "danh từ",
    meaning:
      "điều, việc định làm: những dự định về tương lai * có dự định táo bạo",
    example: "những dự định về tương lai * có dự định táo bạo",
  },
  {
    word: "dư địa chí",
    part_of_speech: "danh từ",
    meaning:
      "sách ghi chép về địa lí, lịch sử, phong tục, nhân vật, sản phẩm, v.v., của một địa phương: sách địa chí",
    example: "sách địa chí",
  },
  {
    word: "dự đoán",
    part_of_speech: "động từ",
    meaning:
      "đoán trước tình hình, sự việc nào đó có thể xảy ra: dự đoán giá vàng có thể tăng cao * sự việc diễn ra đúng như đã dự đoán",
    example:
      "dự đoán giá vàng có thể tăng cao * sự việc diễn ra đúng như đã dự đoán",
  },
  {
    word: "dự đoán",
    part_of_speech: "danh từ",
    meaning: "điều, việc đoán trước: đạt được kết quả vượt xa dự đoán",
    example: "đạt được kết quả vượt xa dự đoán",
  },
  {
    word: "dư dứ",
    part_of_speech: "động từ",
    meaning: "dứ liên tiếp để nhử hoặc hăm doạ: dư dứ nắm đấm để doạ",
    example: "dư dứ nắm đấm để doạ",
  },
  {
    word: "dữ đòn",
    part_of_speech: "tính từ",
    meaning: "hay đánh đòn đau: thầy đồ dữ đòn",
    example: "thầy đồ dữ đòn",
  },
  {
    word: "dự khuyết",
    part_of_speech: "tính từ",
    meaning:
      "được bầu ra nhằm bổ sung khi khuyết người chính thức: đại biểu dự khuyết",
    example: "đại biểu dự khuyết",
  },
  {
    word: "dư luận",
    part_of_speech: "danh từ",
    meaning:
      "ý kiến nhận xét, khen chê của số đông đối với việc gì: được dư luận đồng tình * sợ dư luận",
    example: "được dư luận đồng tình * sợ dư luận",
  },
  {
    word: "dự khán",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) có mặt để xem, để theo dõi một hoạt động chung nào đó: các quan chức được mời dự khán lễ khai mạc liên hoan phim",
    example: "các quan chức được mời dự khán lễ khai mạc liên hoan phim",
  },
  {
    word: "dữ kiện",
    part_of_speech: "danh từ",
    meaning:
      "điều coi như đã biết trước, được dựa vào để tìm những cái chưa biết trong bài toán: dựa vào các dữ kiện đã cho để tìm ra đáp số",
    example: "dựa vào các dữ kiện đã cho để tìm ra đáp số",
  },
  {
    word: "dự liệu",
    part_of_speech: "động từ",
    meaning:
      "liệu trước việc có thể xảy ra để ứng phó: mọi việc anh ta đã dự liệu cả rồi",
    example: "mọi việc anh ta đã dự liệu cả rồi",
  },
  {
    word: "dữ liệu",
    part_of_speech: "danh từ",
    meaning:
      "số liệu, tư liệu được dựa vào để giải quyết một vấn đề: dữ liệu điều tra dân số",
    example: "dữ liệu điều tra dân số",
  },
  {
    word: "dự kiến",
    part_of_speech: "động từ",
    meaning:
      "thấy trước điều có nhiều khả năng sẽ xảy ra: dự kiến tiến độ thi công * dự kiến tình hình sẽ rất phức tạp",
    example: "dự kiến tiến độ thi công * dự kiến tình hình sẽ rất phức tạp",
  },
  {
    word: "dự kiến",
    part_of_speech: "động từ",
    meaning:
      "có ý kiến chuẩn bị trước về một việc gì, về cách giải quyết một vấn đề gì: dự kiến các phương án chống bão",
    example: "dự kiến các phương án chống bão",
  },
  {
    word: "dự kiến",
    part_of_speech: "danh từ",
    meaning: "điều đã dự kiến: sự việc xảy ra ngoài dự kiến",
    example: "sự việc xảy ra ngoài dự kiến",
  },
  {
    word: "dự kiến",
    part_of_speech: "danh từ",
    meaning:
      "ý kiến chuẩn bị trước về một việc, hoặc cách thức định trước để giải quyết một vấn đề gì: làm đúng theo dự kiến",
    example: "làm đúng theo dự kiến",
  },
  {
    word: "dự luật",
    part_of_speech: "danh từ",
    meaning: "bản dự thảo một đạo luật: bản dự luật đã được quốc hội thông qua",
    example: "bản dự luật đã được quốc hội thông qua",
  },
  {
    word: "dư lượng",
    part_of_speech: "danh từ",
    meaning:
      "lượng (hoá chất) còn đọng lại do không phân huỷ, không thoát hết đi được, thường gây hại: dư lượng thuốc trừ sâu trong rau quả vượt quá mức cho phép",
    example: "dư lượng thuốc trừ sâu trong rau quả vượt quá mức cho phép",
  },
  {
    word: "dự thu",
    part_of_speech: "động từ",
    meaning: "dự tính sẽ thu: các khoản dự thu ngân sách",
    example: "các khoản dự thu ngân sách",
  },
  {
    word: "dư nợ",
    part_of_speech: "danh từ",
    meaning: "nợ còn lại ở ngân hàng: dư nợ trung và dài hạn tăng",
    example: "dư nợ trung và dài hạn tăng",
  },
  {
    word: "dự phòng",
    part_of_speech: "động từ",
    meaning:
      "chuẩn bị trước để ứng phó, phòng điều không hay có thể xảy ra: quỹ dự phòng thiên tai * thuốc dự phòng khi có dịch",
    example: "quỹ dự phòng thiên tai * thuốc dự phòng khi có dịch",
  },
  {
    word: "dự thầu",
    part_of_speech: "động từ",
    meaning:
      "tham gia vào một cuộc đấu thầu: hồ sơ dự thầu * có đủ điều kiện dự thầu",
    example: "hồ sơ dự thầu * có đủ điều kiện dự thầu",
  },
  {
    word: "dự thính",
    part_of_speech: "động từ",
    meaning:
      "dự (lớp học, hội nghị) chỉ để nghe, không có quyền phát biểu, biểu quyết (vì không có tư cách là một thành viên hay một đại biểu chính thức): đại biểu dự thính * học viên dự thính",
    example: "đại biểu dự thính * học viên dự thính",
  },
  {
    word: "dự toán",
    part_of_speech: "động từ",
    meaning:
      "tính toán trước những khoản thu chi về tài chính: công tác dự toán thu chi",
    example: "công tác dự toán thu chi",
  },
  {
    word: "dự toán",
    part_of_speech: "danh từ",
    meaning: "bản dự toán: lập dự toán * hạn chế các khoản chi ngoài dự toán",
    example: "lập dự toán * hạn chế các khoản chi ngoài dự toán",
  },
  {
    word: "dự thảo",
    part_of_speech: "động từ",
    meaning: "thảo một văn kiện để đưa thông qua: dự thảo nghị quyết",
    example: "dự thảo nghị quyết",
  },
  {
    word: "dự thảo",
    part_of_speech: "danh từ",
    meaning: "bản văn kiện đã được thảo ra: sửa đổi dự thảo Luật doanh nghiệp",
    example: "sửa đổi dự thảo Luật doanh nghiệp",
  },
  {
    word: "dự tính",
    part_of_speech: "động từ",
    meaning:
      "tính toán trước khả năng diễn biến hoặc kết quả có thể có của sự việc hoặc một giai đoạn trong tương lai: dự tính doanh thu năm nay sẽ tăng",
    example: "dự tính doanh thu năm nay sẽ tăng",
  },
  {
    word: "dự tính",
    part_of_speech: "danh từ",
    meaning: "điều dự tính: sự việc xảy ra ngoài dự tính",
    example: "sự việc xảy ra ngoài dự tính",
  },
  {
    word: "dư thừa",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều, quá mức yêu cầu (nói khái quát): dư thừa sức lực * của cải dư thừa",
    example: "dư thừa sức lực * của cải dư thừa",
  },
  {
    word: "dự trữ",
    part_of_speech: "động từ",
    meaning:
      "trữ sẵn để dùng khi cần đến: dự trữ hàng hoá * lương thực dự trữ * lao động dự trữ",
    example: "dự trữ hàng hoá * lương thực dự trữ * lao động dự trữ",
  },
  {
    word: "dự trữ",
    part_of_speech: "danh từ",
    meaning:
      "số lượng, khối lượng đã được trữ sẵn: tăng thêm dự trữ về lương thực",
    example: "tăng thêm dự trữ về lương thực",
  },
  {
    word: "dữ tợn",
    part_of_speech: "tính từ",
    meaning: "rất dữ với vẻ đe doạ, trông đáng sợ: bộ mặt dữ tợn",
    example: "bộ mặt dữ tợn",
  },
  {
    word: "dự trù",
    part_of_speech: "động từ",
    meaning:
      "tính toán trước các điều kiện cần thiết cho một công việc dự định làm: việc này dự trù phải kéo dài đến cuối năm * dự trù kinh phí cho công trình",
    example:
      "việc này dự trù phải kéo dài đến cuối năm * dự trù kinh phí cho công trình",
  },
  {
    word: "dự trù",
    part_of_speech: "danh từ",
    meaning:
      "bản nêu ra các con số tính toán trước cho công việc dự định làm: lập dự trù",
    example: "lập dự trù",
  },
  {
    word: "dự tuyển",
    part_of_speech: "động từ",
    meaning:
      "tham dự vào một cuộc thi hay một cuộc tuyển chọn: hồ sơ xin dự tuyển",
    example: "hồ sơ xin dự tuyển",
  },
  {
    word: "dừa",
    part_of_speech: "danh từ",
    meaning:
      "cây cùng họ với cau, thân cột, lá to hình lông chim mọc thành tàu, quả mọc thành buồng, bên trong chứa nước ngọt, có cùi dùng để ăn hoặc ép lấy dầu: dầu dừa * mứt dừa",
    example: "dầu dừa * mứt dừa",
  },
  {
    word: "dưa",
    part_of_speech: "danh từ",
    meaning: "thức ăn làm bằng một số loại rau muối chua: muối dưa",
    example: "muối dưa",
  },
  {
    word: "dưa",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) rau cải dùng để muối dưa: mua dưa về muối",
    example: "mua dưa về muối",
  },
  {
    word: "dư vị",
    part_of_speech: "danh từ",
    meaning:
      "cảm giác về mùi vị còn lại trong miệng sau khi đã ăn hoặc uống: dư vị của bữa ăn",
    example: "dư vị của bữa ăn",
  },
  {
    word: "dư vị",
    part_of_speech: "danh từ",
    meaning:
      "cảm giác còn lại sau khi đã thưởng thức cái gì hoặc đã trải qua việc gì: dư vị ngọt ngào của tình yêu",
    example: "dư vị ngọt ngào của tình yêu",
  },
  {
    word: "dựa",
    part_of_speech: "động từ",
    meaning:
      "đặt cho sát vào vật gì để có được thế vững: đứng dựa cửa * dựa thang vào tường",
    example: "đứng dựa cửa * dựa thang vào tường",
  },
  {
    word: "dựa",
    part_of_speech: "động từ",
    meaning:
      "nhờ vào ai hoặc cái gì để có được sức mạnh, để hoạt động có hiệu quả: dựa vào sức mình là chính * dựa thế cha làm càn",
    example: "dựa vào sức mình là chính * dựa thế cha làm càn",
  },
  {
    word: "dựa",
    part_of_speech: "động từ",
    meaning:
      "hướng theo cái có sẵn để có được thành công khi làm việc gì: vẽ dựa theo mẫu * dựa vào tình hình thực tế mà định liệu * thầy bói nói dựa (tng)",
    example:
      "vẽ dựa theo mẫu * dựa vào tình hình thực tế mà định liệu * thầy bói nói dựa (tng)",
  },
  {
    word: "dư vang",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như dư âm: trận chiến thắng vẫn để lại dư vang",
    example: "trận chiến thắng vẫn để lại dư vang",
  },
  {
    word: "dựa dẫm",
    part_of_speech: "động từ",
    meaning:
      "dựa vào, dựa theo người khác để làm, để sinh sống (nói khái quát; thường hàm ý chê): dựa dẫm vào nhau mà sống * tính hay dựa dẫm",
    example: "dựa dẫm vào nhau mà sống * tính hay dựa dẫm",
  },
  {
    word: "dưng",
    part_of_speech: "tính từ",
    meaning: "không có gì, không liên quan gì: người dưng",
    example: "người dưng",
  },
  {
    word: "dứng",
    part_of_speech: "danh từ",
    meaning: "cốt vách bằng tre, nứa: cắm dứng làm vách * trát dứng",
    example: "cắm dứng làm vách * trát dứng",
  },
  {
    word: "dừng",
    part_of_speech: "danh từ",
    meaning:
      "thanh bằng tre nứa cài ngang, dọc để trát vách: tai vách mạch dừng (tng)",
    example: "tai vách mạch dừng (tng)",
  },
  {
    word: "dừng",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) quây, che bằng phên, cót, v.v.: căn buồng được dừng bằng tấm cót",
    example: "căn buồng được dừng bằng tấm cót",
  },
  {
    word: "dừng",
    part_of_speech: "động từ",
    meaning:
      "thôi hoặc làm cho thôi vận động, hoạt động: con tàu từ từ dừng lại trên sân ga * dừng bút * dừng câu chuyện giữa chừng",
    example:
      "con tàu từ từ dừng lại trên sân ga * dừng bút * dừng câu chuyện giữa chừng",
  },
  {
    word: "dựng",
    part_of_speech: "động từ",
    meaning:
      "đặt cho đứng thẳng: dựng cột làm nhà * chưa sáng đã bị dựng dậy (bị làm cho thức dậy)",
    example:
      "dựng cột làm nhà * chưa sáng đã bị dựng dậy (bị làm cho thức dậy)",
  },
  {
    word: "dựng",
    part_of_speech: "động từ",
    meaning:
      "tạo nên vật gì đứng thẳng trên mặt nền theo một cấu trúc nhất định: dựng nhà * dựng cổng chào",
    example: "dựng nhà * dựng cổng chào",
  },
  {
    word: "dựng",
    part_of_speech: "động từ",
    meaning:
      "tạo nên bằng cách tổ hợp các yếu tố theo một cấu trúc nhất định (thường nói về công trình nghệ thuật): dựng một vở kịch * dựng chuyện (bịa đặt)",
    example: "dựng một vở kịch * dựng chuyện (bịa đặt)",
  },
  {
    word: "dựng",
    part_of_speech: "động từ",
    meaning:
      "tạo nên và làm cho có được sự tồn tại vững vàng: dựng cơ đồ * các vua Hùng có công dựng nước",
    example: "dựng cơ đồ * các vua Hùng có công dựng nước",
  },
  {
    word: "dựng",
    part_of_speech: "động từ",
    meaning:
      "vẽ hoặc nói rõ cách vẽ một hình phẳng nào đó thoả mãn một số điều kiện cho trước: bài toán dựng hình",
    example: "bài toán dựng hình",
  },
  {
    word: "dửng dưng",
    part_of_speech: "",
    meaning:
      "thờ ơ, tỏ ra không hề quan tâm, không có một cảm xúc gì: vẻ mặt dửng dưng * không thể dửng dưng trước sự đau khổ của người khác",
    example:
      "vẻ mặt dửng dưng * không thể dửng dưng trước sự đau khổ của người khác",
  },
  {
    word: "dựng đứng",
    part_of_speech: "động từ",
    meaning:
      "hoặc t có vị trí vuông góc với mặt đất, như được dựng thẳng lên: vách núi dựng đứng",
    example: "vách núi dựng đứng",
  },
  {
    word: "dựng đứng",
    part_of_speech: "động từ",
    meaning:
      "bịa đặt ra như thật một cách trắng trợn (thường với mục đích xấu): dựng đứng câu chuyện",
    example: "dựng đứng câu chuyện",
  },
  {
    word: "dửng mỡ",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) có cử chỉ đùa bỡn quá trớn, tựa như là thừa dư sức lực mà không biết làm gì (thường dùng để mắng, chửi): ăn lắm rồi rửng mỡ",
    example: "ăn lắm rồi rửng mỡ",
  },
  {
    word: "dựng phim",
    part_of_speech: "động từ",
    meaning:
      "lựa chọn và tập hợp những cảnh đã quay được cho thành một bộ phim hoàn chỉnh: kĩ thuật dựng phim",
    example: "kĩ thuật dựng phim",
  },
  {
    word: "dựng vợ gả chồng",
    part_of_speech: "",
    meaning: "cưới vợ, gả chồng: lo dựng vợ gả chồng cho con cái",
    example: "lo dựng vợ gả chồng cho con cái",
  },
  {
    word: "dựng tóc gáy",
    part_of_speech: "",
    meaning:
      "quá sợ hãi trước việc rùng rợn, khủng khiếp đến mức cảm thấy như tóc gáy dựng đứng cả lên: chuyện rùng rợn quá, nghe mà dựng tóc gáy!",
    example: "chuyện rùng rợn quá, nghe mà dựng tóc gáy!",
  },
  {
    word: "dược",
    part_of_speech: "danh từ",
    meaning:
      "dược học hoặc dược khoa (nói tắt): sinh viên trường dược * tốt nghiệp ngành dược",
    example: "sinh viên trường dược * tốt nghiệp ngành dược",
  },
  {
    word: "dược phẩm",
    part_of_speech: "danh từ",
    meaning: "vật phẩm dùng làm thuốc phòng chữa bệnh: xí nghiệp dược phẩm",
    example: "xí nghiệp dược phẩm",
  },
  {
    word: "dược thảo",
    part_of_speech: "danh từ",
    meaning: "như thảo dược: chữa bệnh bằng các loại dược thảo",
    example: "chữa bệnh bằng các loại dược thảo",
  },
  {
    word: "dược liệu",
    part_of_speech: "danh từ",
    meaning:
      "nguyên liệu để chế thuốc phòng chữa bệnh: khai thác nguồn dược liệu trong nước",
    example: "khai thác nguồn dược liệu trong nước",
  },
  {
    word: "dược tính",
    part_of_speech: "danh từ",
    meaning:
      "tính chất về mặt tác dụng phòng chữa bệnh của một dược liệu, dược phẩm: nghiên cứu dược tính của cây thuốc nam",
    example: "nghiên cứu dược tính của cây thuốc nam",
  },
  {
    word: "dược khoa",
    part_of_speech: "danh từ",
    meaning: "(cũ) như dược học: lấy bằng tiến sĩ dược khoa",
    example: "lấy bằng tiến sĩ dược khoa",
  },
  {
    word: "dưới",
    part_of_speech: "danh từ",
    meaning:
      "phía những vị trí thấp hơn trong không gian so với một vị trí xác định nào đó, hay so với các vị trí khác nói chung: nhà nằm dưới chân núi * dưới miền xuôi * trên bến dưới thuyền",
    example: "nhà nằm dưới chân núi * dưới miền xuôi * trên bến dưới thuyền",
  },
  {
    word: "dưới",
    part_of_speech: "danh từ",
    meaning:
      "phía những vị trí ở sau một vị trí xác định nào đó hay so với các vị trí khác nói chung, trong một trật tự sắp xếp nhất định: ngồi ở hàng ghế dưới * đứng dưới cùng trong danh sách * làng trên xóm dưới",
    example:
      "ngồi ở hàng ghế dưới * đứng dưới cùng trong danh sách * làng trên xóm dưới",
  },
  {
    word: "dưới",
    part_of_speech: "danh từ",
    meaning:
      "phía những vị trí thấp hơn so với một vị trí xác định nào đó hay so với các vị trí khác nói chung trong một hệ thống cấp bậc, thứ bậc: dạy các lớp dưới * cấp dưới * về công tác dưới xã",
    example: "dạy các lớp dưới * cấp dưới * về công tác dưới xã",
  },
  {
    word: "dưới",
    part_of_speech: "danh từ",
    meaning:
      "mức thấp hơn hay số lượng ít hơn một mức, một số lượng xác định nào đó: sức học dưới trung bình * miễn vé cho trẻ dưới 5 tuổi * giá dưới một trăm nghìn đồng",
    example:
      "sức học dưới trung bình * miễn vé cho trẻ dưới 5 tuổi * giá dưới một trăm nghìn đồng",
  },
  {
    word: "dưới",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là đích nhằm tới của một hoạt động theo hướng từ cao đến thấp: lặn xuống dưới nước * rơi xuống dưới đất",
    example: "lặn xuống dưới nước * rơi xuống dưới đất",
  },
  {
    word: "dưới",
    part_of_speech: "kết từ",
    meaning:
      'từ biểu thị điều sắp nêu ra là phạm vi tác động, bao trùm, chi phối của hoạt động hay sự việc được nói đến: đi dưới ánh trăng * dưới chế độ phong kiến * "Thầy Khiển dưới con mắt dân quê có vẻ như là một người tốt bụng và lập dị." (MVKháng; 12)',
    example:
      'đi dưới ánh trăng * dưới chế độ phong kiến * "Thầy Khiển dưới con mắt dân quê có vẻ như là một người tốt bụng và lập dị." (MVKháng; 12)',
  },
  {
    word: "dưỡng bệnh",
    part_of_speech: "động từ",
    meaning:
      "nghỉ ngơi, bồi dưỡng sức khoẻ khi vừa mới khỏi bệnh: xin nghỉ phép để dưỡng bệnh",
    example: "xin nghỉ phép để dưỡng bệnh",
  },
  {
    word: "dướn",
    part_of_speech: "động từ",
    meaning:
      "cố vươn thẳng ra phía trước hay vươn cao lên: chú gà rướn cổ cất tiếng gáy * thằng bé rướn người lên ôm lấy cổ mẹ",
    example:
      "chú gà rướn cổ cất tiếng gáy * thằng bé rướn người lên ôm lấy cổ mẹ",
  },
  {
    word: "dương",
    part_of_speech: "danh từ",
    meaning:
      "một trong hai mặt đối lập lớn (thường quan niệm là mặt khẳng định, tích cực; đối lập với âm là mặt phủ định, tiêu cực) của muôn vật tồn tại trong vũ trụ, theo quan niệm của triết học cổ đại phương Đông (như ngày đối lập với đêm, đàn ông đối lập với đàn bà, sống đối lập với chết, v.v.): cõi dương * chiều dương của một trục",
    example: "cõi dương * chiều dương của một trục",
  },
  {
    word: "dương",
    part_of_speech: "tính từ",
    meaning:
      "(sự kiện) mang tính chất động hay nóng, hoặc (sự vật) thuộc về nam tính, theo quan niệm của đông y: thuốc bổ dương",
    example: "thuốc bổ dương",
  },
  {
    word: "dương",
    part_of_speech: "tính từ",
    meaning: "lớn hơn số không; phân biệt với âm: số dương",
    example: "số dương",
  },
  {
    word: "dương",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) dương liễu (nói tắt): rừng dương chắn cát",
    example: "rừng dương chắn cát",
  },
  {
    word: "dương",
    part_of_speech: "danh từ",
    meaning:
      "Danh từ (Hán việt) Mặt trời: Hoa hướng dương (Hướng về phía mặt trời) * Ánh dương (Ánh mặt trời)",
    example:
      "Hoa hướng dương (Hướng về phía mặt trời) * Ánh dương (Ánh mặt trời)",
  },
  {
    word: "dưỡng",
    part_of_speech: "động từ",
    meaning:
      "ăn uống, nghỉ ngơi để tăng hoặc khôi phục sức khoẻ (nói khái quát): cha sinh mẹ dưỡng * thuốc dưỡng thai * nghỉ dưỡng già",
    example: "cha sinh mẹ dưỡng * thuốc dưỡng thai * nghỉ dưỡng già",
  },
  {
    word: "dường",
    part_of_speech: "danh từ",
    meaning:
      '(cũ hoặc vch) từ dùng để chỉ cái có tính chất, mức độ đại khái như thế: nghĩa nặng dường ấy * "U ơ ra trước hương đài, Tưởng quang cảnh ấy chua cay dường nào!" (ATV)',
    example:
      'nghĩa nặng dường ấy * "U ơ ra trước hương đài, Tưởng quang cảnh ấy chua cay dường nào!" (ATV)',
  },
  {
    word: "dường",
    part_of_speech: "động từ",
    meaning:
      'có tính chất, mức độ tựa như thế: ruột gan dường lửa đốt * "Sóng tình dường đã xiêu xiêu, Xem trong âu yếm có chiều lả lơi." (TKiều)',
    example:
      'ruột gan dường lửa đốt * "Sóng tình dường đã xiêu xiêu, Xem trong âu yếm có chiều lả lơi." (TKiều)',
  },
  {
    word: "dương bản",
    part_of_speech: "danh từ",
    meaning:
      "ảnh chụp hay quay phim trên đó những phần trắng, đen phản ánh đúng những chỗ sáng, tối trên vật; phân biệt với âm bản: phim dương bản",
    example: "phim dương bản",
  },
  {
    word: "dưỡng chất",
    part_of_speech: "danh từ",
    meaning:
      "chất dinh dưỡng: đất không có đủ dưỡng chất cho cây phát triển * bữa ăn có đủ dưỡng chất",
    example:
      "đất không có đủ dưỡng chất cho cây phát triển * bữa ăn có đủ dưỡng chất",
  },
  {
    word: "dưỡng dục",
    part_of_speech: "động từ",
    meaning:
      "(cũ, trang trọng) nuôi nấng và dạy dỗ (thường nói về công ơn cha mẹ): công ơn dưỡng dục của cha mẹ",
    example: "công ơn dưỡng dục của cha mẹ",
  },
  {
    word: "dương gian",
    part_of_speech: "danh từ",
    meaning:
      "cõi dương, nơi con người sinh sống; đối lập với âm phủ: âm phủ và dương gian * sống ở dương gian",
    example: "âm phủ và dương gian * sống ở dương gian",
  },
  {
    word: "dương lịch",
    part_of_speech: "danh từ",
    meaning:
      "lịch tính thời gian theo sự chuyển động của Trái Đất xung quanh Mặt Trời, lấy thời gian Trái Đất đi hết một vòng (365,24219 ngày, lấy số tròn là 365 ngày) là một năm.",
    example: "Tết dương lịch",
  },
  {
    word: "dưỡng lão",
    part_of_speech: "động từ",
    meaning: "nghỉ ngơi lúc về già: về dưỡng lão ở quê nhà",
    example: "về dưỡng lão ở quê nhà",
  },
  {
    word: "dưỡng lão",
    part_of_speech: "động từ",
    meaning:
      "giúp cho duy trì cuộc sống lúc tuổi già: nhà dưỡng lão * tiền dưỡng lão",
    example: "nhà dưỡng lão * tiền dưỡng lão",
  },
  {
    word: "dưỡng liêm",
    part_of_speech: "động từ",
    meaning: "(cũ) giúp người ta giữ được đức tính liêm khiết: tiền dưỡng liêm",
    example: "tiền dưỡng liêm",
  },
  {
    word: "dường như",
    part_of_speech: "",
    meaning:
      "có vẻ như: mặt đăm chiêu, dường như đang nghĩ ngợi * con đường dường như dài vô tận",
    example:
      "mặt đăm chiêu, dường như đang nghĩ ngợi * con đường dường như dài vô tận",
  },
  {
    word: "dương oai",
    part_of_speech: "động từ",
    meaning:
      "phô bày, tỏ rõ uy thế để đe doạ, uy hiếp (thường hàm ý chê): diễu võ dương oai",
    example: "diễu võ dương oai",
  },
  {
    word: "dưỡng sinh",
    part_of_speech: "động từ",
    meaning:
      "giữ gìn, bồi dưỡng sức khoẻ để được sống lâu một cách tích cực (thường bằng phương pháp tập luyện): bài tập dưỡng sinh",
    example: "bài tập dưỡng sinh",
  },
  {
    word: "dưỡng sức",
    part_of_speech: "động từ",
    meaning:
      "nghỉ ngơi hợp lí để giữ gìn và tăng cường sức khoẻ: nghỉ ngơi dưỡng sức",
    example: "nghỉ ngơi dưỡng sức",
  },
  {
    word: "dưỡng thai",
    part_of_speech: "động từ",
    meaning: "giữ gìn và bồi dưỡng để thai phát triển tốt: thuốc dưỡng thai",
    example: "thuốc dưỡng thai",
  },
  {
    word: "dưỡng thương",
    part_of_speech: "động từ",
    meaning:
      "nghỉ ngơi, bồi dưỡng sau khi điều trị vết thương: ở nhà để dưỡng thương",
    example: "ở nhà để dưỡng thương",
  },
  {
    word: "dương tính",
    part_of_speech: "tính từ",
    meaning:
      "(kết quả xét nghiệm) có mầm bệnh đối với một số bệnh nào đó, hoặc có phản ứng đối với một số thuốc đặc biệt nào đó; đối lập với âm tính: xét nghiệm HIV cho kết quả dương tính",
    example: "xét nghiệm HIV cho kết quả dương tính",
  },
  {
    word: "dứt điểm",
    part_of_speech: "động từ",
    meaning:
      "làm cho việc gì đó xong hẳn vào một lúc nhất định: giải quyết dứt điểm các món nợ * việc gì dễ thì phải làm dứt điểm",
    example:
      "giải quyết dứt điểm các món nợ * việc gì dễ thì phải làm dứt điểm",
  },
  {
    word: "dứt điểm",
    part_of_speech: "động từ",
    meaning:
      "kết thúc để ghi điểm hoặc bàn thắng (trong chơi bóng): cú dứt điểm chính xác",
    example: "cú dứt điểm chính xác",
  },
  {
    word: "dứt",
    part_of_speech: "động từ",
    meaning:
      "(cái đang diễn ra thành một quá trình ít nhiều kéo dài) thôi, kết thúc: dứt lời * trị cho dứt bệnh * mưa mãi không dứt",
    example: "dứt lời * trị cho dứt bệnh * mưa mãi không dứt",
  },
  {
    word: "dứt",
    part_of_speech: "động từ",
    meaning:
      'làm cho đứt sự liên hệ, lìa bỏ hẳn cái gắn bó về tình cảm, về tinh thần: dứt tình máu mủ * "Chưa chăn gối, cũng vợ chồng, Lòng nào mà nỡ dứt lòng cho đang?" (TKiều)',
    example:
      'dứt tình máu mủ * "Chưa chăn gối, cũng vợ chồng, Lòng nào mà nỡ dứt lòng cho đang?" (TKiều)',
  },
  {
    word: "dứt khoát",
    part_of_speech: "tính từ",
    meaning:
      "rõ ràng, hoàn toàn không có sự nhập nhằng hoặc lưỡng lự, nửa nọ nửa kia: trả lời dứt khoát * dứt khoát không chịu đi",
    example: "trả lời dứt khoát * dứt khoát không chịu đi",
  },
  {
    word: "đã",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái hoàn toàn hài lòng do nhu cầu sinh lí hoặc tâm lí nào đó đã được đáp ứng đầy đủ: đã khát * ăn chưa đã thèm * cứ cười đi cho đã",
    example: "đã khát * ăn chưa đã thèm * cứ cười đi cho đã",
  },
  {
    word: "đã",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị sự việc, hiện tượng đang nói đến xảy ra trước hiện tại hoặc trước một thời điểm nào đó được xem là mốc, trong quá khứ hoặc tương lai: anh ấy đã đi từ hôm qua * đã hứa thì phải giữ lời",
    example: "anh ấy đã đi từ hôm qua * đã hứa thì phải giữ lời",
  },
  {
    word: "đã",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị việc vừa nói đến cần được hoàn thành trước khi làm một việc khác: làm xong đã rồi hẵng đi * cứ để cho nó nói nốt đã!",
    example: "làm xong đã rồi hẵng đi * cứ để cho nó nói nốt đã!",
  },
  {
    word: "đã",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý nhấn mạnh sắc thái nghi vấn hoặc ý thiên về phủ định trong một số câu có hình thức nghi vấn: thuyết phục chắc gì nó đã nghe? * đã đẹp mặt chưa!",
    example: "thuyết phục chắc gì nó đã nghe? * đã đẹp mặt chưa!",
  },
  {
    word: "đa",
    part_of_speech: "trợ từ",
    meaning:
      "(Phương ngữ, Khẩu ngữ) từ dùng biểu thị ý nhấn mạnh về điều vừa khẳng định, như muốn thuyết phục, nhắc nhở hay cảnh cáo người nghe: khoẻ dữ đa!",
    example: "khoẻ dữ đa!",
  },
  {
    word: "đ",
    part_of_speech: "",
    meaning: "đồng (viết tắt): 100.000đ",
    example: "100.000đ",
  },
  {
    word: "dứt mối lìa tơ",
    part_of_speech: "",
    meaning:
      '(văn chương) dứt bỏ mối tình: "Quản bao tháng đợi năm chờ, Ai ơi! Dứt mối lìa tơ sao đành?" (ca dao)',
    example:
      'Quản bao tháng đợi năm chờ, Ai ơi! Dứt mối lìa tơ sao đành?" (ca dao)',
  },
  {
    word: "đá",
    part_of_speech: "danh từ",
    meaning:
      "chất rắn cấu tạo nên vỏ Trái Đất, thường thành từng tảng, từng hòn: dãy núi đá * tảng đá nằm chắn ngang dòng suối * ném đá giấu tay (tng)",
    example:
      "dãy núi đá * tảng đá nằm chắn ngang dòng suối * ném đá giấu tay (tng)",
  },
  {
    word: "đá",
    part_of_speech: "danh từ",
    meaning: "(Khẩu ngữ) nước đá (nói tắt): cà phê đá * nước chanh đá",
    example: "cà phê đá * nước chanh đá",
  },
  {
    word: "đá",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) keo kiệt, bủn xỉn quá mức: ông ấy đá lắm, không cho ai cái gì bao giờ",
    example: "ông ấy đá lắm, không cho ai cái gì bao giờ",
  },
  {
    word: "đá",
    part_of_speech: "động từ",
    meaning:
      "đưa nhanh chân và hất mạnh nhằm làm cho bị tổn thương hoặc cho văng ra xa: tung một cú đá vào mạng sườn * đá cầu * ngựa non háu đá (tng)",
    example: "tung một cú đá vào mạng sườn * đá cầu * ngựa non háu đá (tng)",
  },
  {
    word: "đá",
    part_of_speech: "động từ",
    meaning:
      "(Phương ngữ) (một số động vật cùng loại) chọi nhau: chơi đá dế * gà đá nhau",
    example: "chơi đá dế * gà đá nhau",
  },
  {
    word: "đá",
    part_of_speech: "động từ",
    meaning:
      "(Thông tục) cắt đứt quan hệ yêu đương một cách ít nhiều thô bạo: bị người yêu đá",
    example: "bị người yêu đá",
  },
  {
    word: "đá",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) xen lẫn vào cái có tính chất hoặc nội dung ít nhiều xa lạ (thường về cách nói năng): đang nói tiếng Việt, chốc chốc lại đá vào một câu tiếng Anh * lối ăn mặc đá tỉnh đá quê",
    example:
      "đang nói tiếng Việt, chốc chốc lại đá vào một câu tiếng Anh * lối ăn mặc đá tỉnh đá quê",
  },
  {
    word: "đà",
    part_of_speech: "danh từ",
    meaning:
      "đoạn gỗ áp dưới để đỡ một thanh khác được vững hơn: thanh đà * gác đà",
    example: "thanh đà * gác đà",
  },
  {
    word: "đà",
    part_of_speech: "danh từ",
    meaning:
      "đoạn ống hoặc thanh tròn luồn dưới một vật nặng để di chuyển vật đó được dễ hơn: gỗ trượt trên đà",
    example: "gỗ trượt trên đà",
  },
  {
    word: "đà",
    part_of_speech: "danh từ",
    meaning:
      "sức hướng tới trước, được tạo ra do sự chuyển động mạnh hoặc sự hoạt động mạnh mẽ theo một hướng nhất định: lấy đà lên dốc * chạy quá đà * nền kinh tế đang trên đà phát triển",
    example:
      "lấy đà lên dốc * chạy quá đà * nền kinh tế đang trên đà phát triển",
  },
  {
    word: "đà",
    part_of_speech: "danh từ",
    meaning: "đà tàu (nói tắt): tàu nằm trên đà",
    example: "tàu nằm trên đà",
  },
  {
    word: "đà",
    part_of_speech: "phụ từ",
    meaning:
      '(văn chương) đã: "Bóng tà như giục cơn buồn, Khách đà lên ngựa, người còn nghé theo." (TKiều)',
    example:
      'Bóng tà như giục cơn buồn, Khách đà lên ngựa, người còn nghé theo." (TKiều)',
  },
  {
    word: "đa biên",
    part_of_speech: "tính từ",
    meaning: "(quan hệ về kinh tế, chính trị) giữa nhiều nước: quan hệ đa biên",
    example: "quan hệ đa biên",
  },
  {
    word: "đả",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đánh cho thật đau, gây tổn thương nhiều: hai bên đả nhau kịch liệt",
    example: "hai bên đả nhau kịch liệt",
  },
  {
    word: "đả",
    part_of_speech: "động từ",
    meaning:
      "đả kích (bằng lời nói, bài viết, tranh ảnh): bài báo đả thói cửa quyền",
    example: "bài báo đả thói cửa quyền",
  },
  {
    word: "đả",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) như đánh: đả một lúc bốn bát cơm đầy * nó lăn ra, đả một giấc đến sáng",
    example: "đả một lúc bốn bát cơm đầy * nó lăn ra, đả một giấc đến sáng",
  },
  {
    word: "đa bào",
    part_of_speech: "tính từ",
    meaning:
      "(sinh vật) có cơ thể gồm nhiều tế bào, mỗi tế bào thực hiện một chức năng khác nhau; phân biệt với đơn bào: động vật đa bào",
    example: "động vật đa bào",
  },
  {
    word: "đa cấp",
    part_of_speech: "tính từ",
    meaning: "nhiều cấp độ: phương thức bán hàng đa cấp",
    example: "phương thức bán hàng đa cấp",
  },
  {
    word: "đa cảm",
    part_of_speech: "tính từ",
    meaning: "dễ cảm xúc, dễ xúc động: tính đa cảm * một con người đa cảm",
    example: "tính đa cảm * một con người đa cảm",
  },
  {
    word: "đa chiều",
    part_of_speech: "tính từ",
    meaning: "nhiều chiều: không gian đa chiều * thông tin đa chiều",
    example: "không gian đa chiều * thông tin đa chiều",
  },
  {
    word: "đa diện",
    part_of_speech: "danh từ",
    meaning:
      "khối giới hạn bởi một mặt khép kín gồm nhiều đa giác: đa diện đều",
    example: "đa diện đều",
  },
  {
    word: "đa diện",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) có tính chất nhiều mặt, nhiều khía cạnh: cái nhìn đa diện * sự phát triển đa diện",
    example: "cái nhìn đa diện * sự phát triển đa diện",
  },
  {
    word: "đa dâm",
    part_of_speech: "tính từ",
    meaning:
      "quá ham muốn về tình dục, thường biểu hiện bằng những hành vi dâm dật: kẻ đa dâm",
    example: "kẻ đa dâm",
  },
  {
    word: "đã đành",
    part_of_speech: "",
    meaning:
      "tổ hợp biểu thị điều vừa nói đến được coi là dĩ nhiên, nhằm bổ sung, nêu ra một điều khác được coi là quan trọng hơn: đã đành là khó, nhưng cũng phải cố gắng chứ! * ông cụ lẩn thẩn đã đành, đến anh cũng lẩn thẩn nốt!",
    example:
      "đã đành là khó, nhưng cũng phải cố gắng chứ! * ông cụ lẩn thẩn đã đành, đến anh cũng lẩn thẩn nốt!",
  },
  {
    word: "đa dạng",
    part_of_speech: "tính từ",
    meaning:
      "nhiều vẻ, nhiều dạng biểu hiện khác nhau: hàng hoá rất đa dạng * phát triển đa dạng các hình thức du lịch",
    example: "hàng hoá rất đa dạng * phát triển đa dạng các hình thức du lịch",
  },
  {
    word: "đa dụng",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều công dụng, nhiều tác dụng khác nhau: dụng cụ nấu bếp đa dụng",
    example: "dụng cụ nấu bếp đa dụng",
  },
  {
    word: "đá dăm",
    part_of_speech: "danh từ",
    meaning:
      "đá được đập nhỏ tương đối đều cạnh, thường dùng để rải làm mặt đường: đường rải đá dăm",
    example: "đường rải đá dăm",
  },
  {
    word: "đa dạng hoá",
    part_of_speech: "động từ",
    meaning:
      "làm cho trở nên đa dạng: đa dạng hoá sản phẩm * thực hiện đa dạng hoá các loại hình giáo dục",
    example:
      "đa dạng hoá sản phẩm * thực hiện đa dạng hoá các loại hình giáo dục",
  },
  {
    word: "đà đao",
    part_of_speech: "danh từ",
    meaning:
      'miếng võ hiểm, giả vờ thua rồi kéo lết đao chạy để đối phương đuổi theo, đợi lúc đối phương sơ hở thì đột nhiên quay lại vung đao chém; thường dùng để chỉ kế độc đánh lừa: "Đà đao sắp sẵn chước dùng, Lạ gì một cốt, một đồng xưa nay!" (TKiều)',
    example:
      'Đà đao sắp sẵn chước dùng, Lạ gì một cốt, một đồng xưa nay!" (TKiều)',
  },
  {
    word: "đả đảo",
    part_of_speech: "động từ",
    meaning:
      "đánh đổ (chỉ dùng trong khẩu hiệu đấu tranh): đả đảo bọn địa chủ cường hào gian ác!",
    example: "đả đảo bọn địa chủ cường hào gian ác!",
  },
  {
    word: "đả đảo",
    part_of_speech: "động từ",
    meaning:
      "(lực lượng quần chúng) biểu thị sự chống đối kịch liệt với tinh thần muốn đánh đổ: lực lượng phản động bị đả đảo kịch liệt",
    example: "lực lượng phản động bị đả đảo kịch liệt",
  },
  {
    word: "đá đít",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) bỏ, thải đi, không quan hệ nữa, không sử dụng nữa (hàm ý khinh bỉ, mỉa mai): bị người yêu đá đít",
    example: "bị người yêu đá đít",
  },
  {
    word: "đả động",
    part_of_speech: "động từ",
    meaning:
      "nói đến, tác động đến vì coi đó là điều cần nói, cần tác động: không ai thèm đả động đến nó!",
    example: "không ai thèm đả động đến nó!",
  },
  {
    word: "đã đời",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) quá hả hê, thoả sức, không còn thèm muốn gì thêm nữa: nhậu một bữa thật đã đời",
    example: "nhậu một bữa thật đã đời",
  },
  {
    word: "đa đoan",
    part_of_speech: "tính từ",
    meaning:
      '(cũ, văn chương) lắm mối, lắm chuyện lôi thôi, rắc rối đến mức khó lường: "Cơ trời dâu bể đa đoan, Một nhà để chị riêng oan một mình." (TKiều)',
    example:
      'Cơ trời dâu bể đa đoan, Một nhà để chị riêng oan một mình." (TKiều)',
  },
  {
    word: "đả đớt",
    part_of_speech: "tính từ",
    meaning:
      "(cách nói) không rõ, không đúng một số âm, thường do nói chưa sõi hoặc do nũng nịu: nói bằng giọng đả đớt",
    example: "nói bằng giọng đả đớt",
  },
  {
    word: "đá đưa",
    part_of_speech: "động từ",
    meaning:
      "(mồm miệng) nói năng khéo léo nhưng không thành thật, chỉ cốt làm vừa lòng người nghe: đá đưa đầu lưỡi",
    example: "đá đưa đầu lưỡi",
  },
  {
    word: "đá đưa",
    part_of_speech: "động từ",
    meaning: "(mắt) đưa đi đưa lại nhanh, vẻ không thành thật: con mắt đá đưa",
    example: "con mắt đá đưa",
  },
  {
    word: "đá hoa",
    part_of_speech: "danh từ",
    meaning:
      "đá có vân đẹp và có nhiều màu sắc khác nhau, thường dùng để ốp lát, trang trí: nền nhà lát đá hoa",
    example: "nền nhà lát đá hoa",
  },
  {
    word: "đá gà đá vịt",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) làm (việc nào đó) một chút cho gọi là có, chứ không thật sự quan tâm: việc gì cũng đá gà đá vịt một chút rồi lại bỏ",
    example: "việc gì cũng đá gà đá vịt một chút rồi lại bỏ",
  },
  {
    word: "đa giác",
    part_of_speech: "danh từ",
    meaning:
      "hình do một đường gấp khúc khép kín tạo thành: đa giác lồi * đa giác đều",
    example: "đa giác lồi * đa giác đều",
  },
  {
    word: "đa hệ",
    part_of_speech: "tính từ",
    meaning:
      "có thể hoạt động được với nhiều hệ thống khác nhau: đầu video đa hệ * phần mềm đa hệ",
    example: "đầu video đa hệ * phần mềm đa hệ",
  },
  {
    word: "đa khoa",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều khoa, có thể khám, điều trị được nhiều bệnh: bệnh viện đa khoa * bác sĩ đa khoa",
    example: "bệnh viện đa khoa * bác sĩ đa khoa",
  },
  {
    word: "đa luồng",
    part_of_speech: "tính từ",
    meaning:
      "có thể thực hiện được nhiều việc khác nhau cùng một lúc trong một ứng dụng; đa nhiệm trong một ứng dụng: hệ điều hành đa luồng",
    example: "hệ điều hành đa luồng",
  },
  {
    word: "đả kích",
    part_of_speech: "động từ",
    meaning:
      "chỉ trích, phản đối gay gắt hoặc dùng hành động chống lại làm cho bị tổn hại: giọng thơ châm biếm, đả kích * đả kích những thói hư tật xấu",
    example: "giọng thơ châm biếm, đả kích * đả kích những thói hư tật xấu",
  },
  {
    word: "đa mang",
    part_of_speech: "động từ",
    meaning:
      'tự vương vào cái khiến phải bận lòng nhiều, khó dứt ra được: trót đa mang thì phải đèo bòng * "Bỗng đâu rút mối tơ mành, Cho duyên quấn quýt, cho tình đa mang." (ca dao)',
    example:
      'trót đa mang thì phải đèo bòng * "Bỗng đâu rút mối tơ mành, Cho duyên quấn quýt, cho tình đa mang." (ca dao)',
  },
  {
    word: "đa nghi",
    part_of_speech: "tính từ",
    meaning: "hay nghi ngờ: tính hay đa nghi",
    example: "tính hay đa nghi",
  },
  {
    word: "đa năng",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều chức năng khác nhau, có thể làm được nhiều việc khác nhau: máy tính đa năng * một kĩ sư đa năng",
    example: "máy tính đa năng * một kĩ sư đa năng",
  },
  {
    word: "đa nghĩa",
    part_of_speech: "tính từ",
    meaning: "(đơn vị ngôn ngữ) có nhiều nghĩa: từ đa nghĩa",
    example: "từ đa nghĩa",
  },
  {
    word: "đa ngôn đa quá",
    part_of_speech: "",
    meaning:
      "(cũ) nói nhiều thì sai nhiều (hàm ý khuyên không nên lắm lời): đa ngôn đa quá, rước vạ vào thân (tng)",
    example: "đa ngôn đa quá, rước vạ vào thân (tng)",
  },
  {
    word: "đa mưu",
    part_of_speech: "tính từ",
    meaning: "lắm mưu kế (để ứng phó): người đa mưu",
    example: "người đa mưu",
  },
  {
    word: "đa ngôn",
    part_of_speech: "",
    meaning: "(nói) nhiều lời và quá mức cần thiết: người đàn bà đa ngôn",
    example: "người đàn bà đa ngôn",
  },
  {
    word: "đa nguyên",
    part_of_speech: "",
    meaning: "thuộc về thuyết đa nguyên..",
    example: "đa nguyên chính trị",
  },
  {
    word: "đa ngữ",
    part_of_speech: "tính từ",
    meaning:
      "(sử dụng) nhiều ngôn ngữ; phân biệt với đơn ngữ, song ngữ: một quốc gia đa ngữ * từ điển đa ngữ",
    example: "một quốc gia đa ngữ * từ điển đa ngữ",
  },
  {
    word: "đá ong",
    part_of_speech: "danh từ",
    meaning:
      "đá màu nâu đỏ, có lỗ như tổ ong, thành phần chủ yếu là oxide sắt và nhôm: tường nhà xây bằng đá ong",
    example: "tường nhà xây bằng đá ong",
  },
  {
    word: "đa phần",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) phần nhiều, phần lớn: số người đến dự đa phần là sinh viên",
    example: "số người đến dự đa phần là sinh viên",
  },
  {
    word: "đả phá",
    part_of_speech: "động từ",
    meaning:
      "chỉ trích một cách gay gắt nhằm phản đối, xoá bỏ cái lạc hậu, thối nát thuộc về đời sống tinh thần: đả phá thói mê tín dị đoan * đả phá mạnh mẽ tư tưởng tiểu tư sản",
    example: "đả phá thói mê tín dị đoan * đả phá mạnh mẽ tư tưởng tiểu tư sản",
  },
  {
    word: "đa phương",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều phía, nhiều bên cùng tham gia hoặc cùng thoả thuận; phân biệt với đơn phương, song phương: hợp tác kinh tế đa phương",
    example: "hợp tác kinh tế đa phương",
  },
  {
    word: "đa phương tiện",
    part_of_speech: "tính từ",
    meaning:
      "sử dụng nhiều phương tiện truyền tải thông tin trong một ứng dụng: thiết bị đa phương tiện * phần mềm đa phương tiện",
    example: "thiết bị đa phương tiện * phần mềm đa phương tiện",
  },
  {
    word: "đá ốp lát",
    part_of_speech: "danh từ",
    meaning:
      "đá tự nhiên có vân hoặc màu sắc đẹp, được tạo thành tấm mỏng và nhẵn bóng, dùng để ốp hoặc lát lên bề mặt công trình xây dựng: mặt ngoài ngôi nhà gắn đá ốp lát",
    example: "mặt ngoài ngôi nhà gắn đá ốp lát",
  },
  {
    word: "đa phương hoá",
    part_of_speech: "động từ",
    meaning:
      "làm cho trở thành đa phương: mở rộng hợp tác quốc tế theo hướng đa phương hoá",
    example: "mở rộng hợp tác quốc tế theo hướng đa phương hoá",
  },
  {
    word: "đá quả bóng",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) ví hành động đẩy việc thuộc thẩm quyền của mình sang cho người khác giải quyết để tránh trách nhiệm: vụ việc bị đá quả bóng hết chỗ này đến chỗ khác, không ai chịu giải quyết",
    example:
      "vụ việc bị đá quả bóng hết chỗ này đến chỗ khác, không ai chịu giải quyết",
  },
  {
    word: "đá quý",
    part_of_speech: "danh từ",
    meaning:
      "đá tự nhiên có giá trị cao (như các loại ngọc, kim cương, v.v.), thường dùng làm đồ trang sức, đồ mĩ nghệ: pho tượng làm bằng đá quý * kinh doanh vàng bạc, đá quý",
    example: "pho tượng làm bằng đá quý * kinh doanh vàng bạc, đá quý",
  },
  {
    word: "đa số",
    part_of_speech: "danh từ",
    meaning:
      "số lượng chiếm một phần tương đối lớn trong một tập hợp, thường là tập hợp người: đa số người dân ở đây sống bằng nghề nông",
    example: "đa số người dân ở đây sống bằng nghề nông",
  },
  {
    word: "đa số",
    part_of_speech: "danh từ",
    meaning:
      "số lượng phiếu bầu cử hoặc biểu quyết về một phía nào đó đạt quá một nửa so với tổng số; phân biệt với thiểu số: đa số tán thành * quyết định theo đa số",
    example: "đa số tán thành * quyết định theo đa số",
  },
  {
    word: "đa sầu",
    part_of_speech: "tính từ",
    meaning: "hay sầu muộn: người đa sầu",
    example: "người đa sầu",
  },
  {
    word: "đa số áp đảo",
    part_of_speech: "danh từ",
    meaning:
      "phần đa số lớn gấp nhiều lần phần thiểu số (nói trong trường hợp có sự đối lập gay gắt): số người ủng hộ chiếm đa số áp đảo",
    example: "số người ủng hộ chiếm đa số áp đảo",
  },
  {
    word: "đa tạ",
    part_of_speech: "động từ",
    meaning: "(cũ, trang trọng) cảm ơn rất nhiều: xin đa tạ lòng tốt của ông!",
    example: "xin đa tạ lòng tốt của ông!",
  },
  {
    word: "đa sự",
    part_of_speech: "tính từ",
    meaning:
      "lắm chuyện, hay làm rắc rối, phiền phức, cả những việc không có quan hệ đến mình: ôi dào, chỉ đa sự, chuyện đã qua lâu rồi!",
    example: "ôi dào, chỉ đa sự, chuyện đã qua lâu rồi!",
  },
  {
    word: "đa tài",
    part_of_speech: "tính từ",
    meaning: "có tài trong nhiều lĩnh vực: một nghệ sĩ đa tài",
    example: "một nghệ sĩ đa tài",
  },
  {
    word: "đa tiết",
    part_of_speech: "tính từ",
    meaning: "(từ) có nhiều âm tiết:  là một từ đa tiết",
    example: "là một từ đa tiết",
  },
  {
    word: "đa thức",
    part_of_speech: "danh từ",
    meaning:
      "biểu thức đại số gồm nhiều đơn thức nối với nhau bằng các dấu cộng hoặc trừ: đa thức bậc ba",
    example: "đa thức bậc ba",
  },
  {
    word: "đả thông",
    part_of_speech: "động từ",
    meaning:
      "thuyết phục, làm cho nhận thức tư tưởng thông suốt và đồng ý: đả thông tư tưởng",
    example: "đả thông tư tưởng",
  },
  {
    word: "đa tình",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều tình cảm, dễ nảy sinh quan hệ tình cảm (thường là về yêu đương): khách đa tình * đôi mắt đa tình",
    example: "khách đa tình * đôi mắt đa tình",
  },
  {
    word: "đa túc",
    part_of_speech: "danh từ",
    meaning:
      "động vật chân đốt có thân dài gồm nhiều đốt, mỗi đốt mang một hay hai đôi chân: rết, cuốn chiếu là những động vật đa túc",
    example: "rết, cuốn chiếu là những động vật đa túc",
  },
  {
    word: "đa truân",
    part_of_speech: "tính từ",
    meaning:
      "(văn chương, hiếm) hay gặp những gian nan, vất vả trên đường đời: hồng nhan đa truân",
    example: "hồng nhan đa truân",
  },
  {
    word: "đa tư lự",
    part_of_speech: "tính từ",
    meaning: "hay nghĩ ngợi, lo lắng nhiều: vẻ mặt đa tư lự",
    example: "vẻ mặt đa tư lự",
  },
  {
    word: "đá vàng",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) đá và vàng; dùng để ví sự bền vững, gắn bó trong quan hệ tình cảm (thường về tình nghĩa vợ chồng): "Đã lòng quân tử đa mang, Một lời, vâng tạc đá vàng thuỷ chung." (TKiều)',
    example:
      'Đã lòng quân tử đa mang, Một lời, vâng tạc đá vàng thuỷ chung." (TKiều)',
  },
  {
    word: "đa xử lí",
    part_of_speech: "danh từ",
    meaning:
      "phương thức làm việc của một máy tính trong đó nhiều bộ xử lí có thể dùng chung bộ nhớ và thực hiện song song nhiều bài toán khác nhau: hệ thống đa xử lí",
    example: "hệ thống đa xử lí",
  },
  {
    word: "đá vôi",
    part_of_speech: "danh từ",
    meaning: "đá dùng để nung vôi: núi đá vôi",
    example: "núi đá vôi",
  },
  {
    word: "đại",
    part_of_speech: "danh từ",
    meaning: "nguyên đại (nói tắt): đại nguyên sinh * đại thái cổ",
    example: "đại nguyên sinh * đại thái cổ",
  },
  {
    word: "đại",
    part_of_speech: "tính từ",
    meaning:
      "to, lớn (về kích thước, mức độ, quy mô, v.v.): lá cờ đại * cây gậy hạng đại",
    example: "lá cờ đại * cây gậy hạng đại",
  },
  {
    word: "đại",
    part_of_speech: "phụ từ",
    meaning:
      "(Khẩu ngữ) đến mức như không thể hơn được nữa: một anh chàng đại ngốc",
    example: "một anh chàng đại ngốc",
  },
  {
    word: "đại",
    part_of_speech: "phụ từ",
    meaning:
      "(Khẩu ngữ) (làm việc gì) ngay, chẳng cần cân nhắc xem nên hay không nên, chỉ cốt cho qua việc (vì nghĩ không còn có cách nào khác): nhảy đại đi * nói đại đi, sợ gì! * cứ nhận đại cho xong chuyện!",
    example: "nhảy đại đi * nói đại đi, sợ gì! * cứ nhận đại cho xong chuyện!",
  },
  {
    word: "đài",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận ở phía ngoài cùng của hoa, gồm những bản thường màu lục: đài sen",
    example: "đài sen",
  },
  {
    word: "đài",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng bằng gỗ tiện, sơn son để bày vật thờ cúng, có hình giống cái đài hoa: đài rượu * đài trầu",
    example: "đài rượu * đài trầu",
  },
  {
    word: "đài",
    part_of_speech: "danh từ",
    meaning: "lần cúng bái hoặc cầu xin: cúng ba đài hương",
    example: "cúng ba đài hương",
  },
  {
    word: "đài",
    part_of_speech: "danh từ",
    meaning:
      "công trình xây dựng trên nền cao, thường không có mái che: đài liệt sĩ * đài tưởng niệm",
    example: "đài liệt sĩ * đài tưởng niệm",
  },
  {
    word: "đài",
    part_of_speech: "danh từ",
    meaning:
      "vị trí thường đặt ở trên cao hoặc cơ sở có trang bị những khí cụ chuyên môn thường đặt ở vị trí cao, để làm nhiệm vụ quan sát, nghiên cứu: đài quan sát khí tượng thuỷ văn",
    example: "đài quan sát khí tượng thuỷ văn",
  },
  {
    word: "đài",
    part_of_speech: "danh từ",
    meaning:
      "đài phát thanh, hoặc đài truyền hình (nói tắt): bản tin phát trên đài phường * đài địa phương",
    example: "bản tin phát trên đài phường * đài địa phương",
  },
  {
    word: "đài",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ): mua một cái đài mới",
    example: "mua một cái đài mới",
  },
  {
    word: "đài",
    part_of_speech: "danh từ",
    meaning:
      '(phương ngữ) bồ đài: "Trách trời, không trách ai đâu, Đài kia ngắn chạc giếng sâu lỡ chừng." (ca dao)',
    example:
      'Trách trời, không trách ai đâu, Đài kia ngắn chạc giếng sâu lỡ chừng." (ca dao)',
  },
  {
    word: "đách",
    part_of_speech: "",
    meaning: "(thông tục, hiếm) như đếch: nó thì biết cái đách gì!",
    example: "nó thì biết cái đách gì!",
  },
  {
    word: "đa xử lý",
    part_of_speech: "danh từ",
    meaning:
      "phương thức làm việc của một máy tính trong đó nhiều bộ xử lí có thể dùng chung bộ nhớ và thực hiện song song nhiều bài toán khác nhau: hệ thống đa xử lí",
    example: "hệ thống đa xử lí",
  },
  {
    word: "đai",
    part_of_speech: "danh từ",
    meaning:
      "vành bao quanh vật gì, thường để giữ cho chặt, cho chắc: thùng gỗ có đai sắt",
    example: "thùng gỗ có đai sắt",
  },
  {
    word: "đai",
    part_of_speech: "danh từ",
    meaning: "vành đeo ngang lưng phía ngoài áo chầu vua.",
    example: "võ sĩ mang đai đen * thi lên đai",
  },
  {
    word: "đai",
    part_of_speech: "danh từ",
    meaning:
      "dây thắt ngang lưng phía ngoài áo của các võ sĩ, có màu quy định riêng cho mỗi đẳng cấp: võ sĩ mang đai đen * thi lên đai",
    example: "đai khí hậu nhiệt đới * đai ôn đới",
  },
  {
    word: "đai",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nói kéo dài và nhiều lần về việc đã xảy ra để tỏ sự không bằng lòng của mình: đai đi đai lại * người ta đã nhận lỗi rồi mà còn cứ đai mãi",
    example: "đai đi đai lại * người ta đã nhận lỗi rồi mà còn cứ đai mãi",
  },
  {
    word: "đãi",
    part_of_speech: "động từ",
    meaning:
      "chao, gạn trong nước để loại bỏ phần không cần dùng và lấy riêng phần cần dùng: đãi gạo * đãi sạch vỏ đỗ * đãi cát tìm vàng (tng)",
    example: "đãi gạo * đãi sạch vỏ đỗ * đãi cát tìm vàng (tng)",
  },
  {
    word: "đãi",
    part_of_speech: "động từ",
    meaning:
      "mời ăn uống hoặc cho tiền, đồ dùng một cách ít nhiều đặc biệt, để tỏ tình cảm tốt với ai: làm cơm đãi bạn * mở tiệc đãi các quan khách",
    example: "làm cơm đãi bạn * mở tiệc đãi các quan khách",
  },
  {
    word: "đại bại",
    part_of_speech: "động từ",
    meaning:
      "thua to, bị đánh bại hoàn toàn (trong chiến đấu): quân giặc đại bại",
    example: "quân giặc đại bại",
  },
  {
    word: "đại bản doanh",
    part_of_speech: "danh từ",
    meaning:
      "nơi tổng chỉ huy quân đội đóng cùng với bộ tham mưu, thời chiến: tiến công vào đại bản doanh của địch",
    example: "tiến công vào đại bản doanh của địch",
  },
  {
    word: "đại bịp",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) lừa đảo, bịp bợm bằng nhiều mánh khoé hết sức xảo quyệt: một tay đại bịp",
    example: "một tay đại bịp",
  },
  {
    word: "đại biểu",
    part_of_speech: "danh từ",
    meaning:
      "người được cử thay mặt cho một tập thể tham gia vào một việc gì: đại biểu quốc hội * cử đại biểu đi dự hội nghị",
    example: "đại biểu quốc hội * cử đại biểu đi dự hội nghị",
  },
  {
    word: "đại biểu",
    part_of_speech: "động từ",
    meaning:
      "(hiếm, trang trọng) thay mặt cho một tập thể (để làm việc gì): đại biểu cho nhân dân lao động",
    example: "đại biểu cho nhân dân lao động",
  },
  {
    word: "đại bộ phận",
    part_of_speech: "danh từ",
    meaning:
      "phần chiếm đa số, phần lớn hơn nhiều so với phần còn lại: người trong làng đại bộ phận là làm ruộng",
    example: "người trong làng đại bộ phận là làm ruộng",
  },
  {
    word: "đãi bôi",
    part_of_speech: "tính từ",
    meaning:
      "tử tế, niềm nở bề ngoài, không thật tình, gian trá: mời đãi bôi * nói đãi bôi",
    example: "mời đãi bôi * nói đãi bôi",
  },
  {
    word: "đài các",
    part_of_speech: "danh từ",
    meaning:
      '(Từ cũ) nền cao và nhà gác; chỉ nơi ở của người giàu sang, quyền quý thời xưa: "Hạt mưa đã lọt miền đài các, Những mừng thầm cá nước duyên may." (CO)',
    example:
      'Hạt mưa đã lọt miền đài các, Những mừng thầm cá nước duyên may." (CO)',
  },
  {
    word: "đài các",
    part_of_speech: "tính từ",
    meaning:
      "có dáng vẻ, điệu bộ của người giàu sang, quyền quý: thói đài các rởm!",
    example: "thói đài các rởm!",
  },
  {
    word: "đại ca",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, khẩu ngữ) từ dùng để gọi người đàn ông được coi là thuộc vào hàng anh cả, đáng được nể trọng.",
    example: "được tôn làm đại ca",
  },
  {
    word: "đại cáo",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) như cáo (nhưng có sắc thái trang trọng hơn): viết một bài đại cáo",
    example: "viết một bài đại cáo",
  },
  {
    word: "đại bợm",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) kẻ bịp bợm, không từ một thủ đoạn, mánh khoé xảo quyệt nào: một gã đại bợm",
    example: "một gã đại bợm",
  },
  {
    word: "đại cao thủ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) cao thủ bậc cao, có khả năng vượt hơn hẳn những người khác trong lĩnh vực nào đó: đại cao thủ võ lâm",
    example: "đại cao thủ võ lâm",
  },
  {
    word: "đại cà sa",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) (lời văn) quá dài dòng: bài diễn văn đại cà sa",
    example: "bài diễn văn đại cà sa",
  },
  {
    word: "đại chúng",
    part_of_speech: "danh từ",
    meaning: "(cũ) quần chúng đông đảo: cuộc sống cực khổ của đại chúng",
    example: "cuộc sống cực khổ của đại chúng",
  },
  {
    word: "đại chúng",
    part_of_speech: "tính từ",
    meaning:
      "của quần chúng đông đảo, dành cho quần chúng đông đảo: các phương tiện thông tin đại chúng",
    example: "các phương tiện thông tin đại chúng",
  },
  {
    word: "đại chúng",
    part_of_speech: "tính từ",
    meaning:
      "phù hợp với trình độ của đông đảo quần chúng: văn hoá đại chúng * tiết mục mang tính văn hoá cao nhưng cũng rất đại chúng",
    example:
      "văn hoá đại chúng * tiết mục mang tính văn hoá cao nhưng cũng rất đại chúng",
  },
  {
    word: "đại cử tri",
    part_of_speech: "danh từ",
    meaning:
      "người (được cử tri bầu hoặc được chỉ định) thay mặt, đại diện cho cử tri để bỏ phiếu ở cuộc bầu cử cấp cao hơn (tại một số nước): tổng thống là do các đại cử tri bầu ra",
    example: "tổng thống là do các đại cử tri bầu ra",
  },
  {
    word: "đại châu",
    part_of_speech: "danh từ",
    meaning: "châu lớn, như châu Á, châu Phi, châu Mĩ: tên lửa vượt đại châu",
    example: "tên lửa vượt đại châu",
  },
  {
    word: "đại công nghiệp",
    part_of_speech: "danh từ",
    meaning: "công nghiệp có quy mô lớn: thời kì đại công nghiệp",
    example: "thời kì đại công nghiệp",
  },
  {
    word: "đại cục",
    part_of_speech: "danh từ",
    meaning: "(hiếm) công cuộc to lớn: được góp sức vào đại cục",
    example: "được góp sức vào đại cục",
  },
  {
    word: "đại chiến",
    part_of_speech: "danh từ",
    meaning:
      "chiến tranh có quy mô rộng lớn trên thế giới: cuộc đại chiến thế giới lần thứ nhất",
    example: "cuộc đại chiến thế giới lần thứ nhất",
  },
  {
    word: "đại cương",
    part_of_speech: "danh từ",
    meaning:
      "những điều chủ yếu (nói tổng quát): đại cương về văn học trung đại",
    example: "đại cương về văn học trung đại",
  },
  {
    word: "đại cương",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất tổng quát: giáo trình ngôn ngữ học đại cương * kiến thức đại cương",
    example: "giáo trình ngôn ngữ học đại cương * kiến thức đại cương",
  },
  {
    word: "đại dương",
    part_of_speech: "danh từ",
    meaning:
      "biển lớn, tiếp giáp với cả một châu hoặc một vùng lớn hơn: tàu vượt đại dương",
    example: "tàu vượt đại dương",
  },
  {
    word: "đại đa số",
    part_of_speech: "danh từ",
    meaning:
      "số rất đông, chiếm phần lớn trong tổng số: trúng cử với đại đa số phiếu bầu",
    example: "trúng cử với đại đa số phiếu bầu",
  },
  {
    word: "đái dầm",
    part_of_speech: "động từ",
    meaning: "đái trong khi ngủ: trẻ con hay đái dầm",
    example: "trẻ con hay đái dầm",
  },
  {
    word: "đại diện",
    part_of_speech: "động từ",
    meaning:
      "thay mặt cho cá nhân hoặc tập thể (làm việc gì): đại diện cho họ nhà trai lên phát biểu * văn phòng đại diện",
    example: "đại diện cho họ nhà trai lên phát biểu * văn phòng đại diện",
  },
  {
    word: "đại diện",
    part_of_speech: "danh từ",
    meaning:
      "người được cử thay mặt cho cá nhân hoặc tập thể đi làm việc gì: cử đại diện đi họp",
    example: "cử đại diện đi họp",
  },
  {
    word: "đại dịch",
    part_of_speech: "danh từ",
    meaning:
      "nạn dịch lớn, lây lan nhanh trên diện rộng, gây tác hại nặng nề mà không có cách nào diệt trừ ngay được: đại dịch AIDS * bệnh cúm gia cầm đã lây lan thành đại dịch",
    example: "đại dịch AIDS * bệnh cúm gia cầm đã lây lan thành đại dịch",
  },
  {
    word: "đãi đằng",
    part_of_speech: "động từ",
    meaning: "(hiếm) đãi ăn uống (nói khái quát): đãi đằng cơm rượu",
    example: "đãi đằng cơm rượu",
  },
  {
    word: "đãi đằng",
    part_of_speech: "động từ",
    meaning:
      '(cũ, hiếm) giãi bày: "Cá buồn cá lội tung tăng, Em buồn em biết đãi đằng cùng ai?" (ca dao)',
    example:
      'Cá buồn cá lội tung tăng, Em buồn em biết đãi đằng cùng ai?" (ca dao)',
  },
  {
    word: "đài đóm",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) đài để nghe (nói khái quát; thường hàm ý coi thường hoặc vui đùa): đài đóm tậm tịt",
    example: "đài đóm tậm tịt",
  },
  {
    word: "đại đoàn kết",
    part_of_speech: "động từ",
    meaning: "đoàn kết hết sức rộng rãi: đại đoàn kết dân tộc",
    example: "đại đoàn kết dân tộc",
  },
  {
    word: "đại đội",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị tổ chức của lực lượng vũ trang, thường gồm ba bốn trung đội, nằm trong biên chế của tiểu đoàn hoặc được tổ chức độc lập: đại đội pháo binh",
    example: "đại đội pháo binh",
  },
  {
    word: "đại để",
    part_of_speech: "phụ từ",
    meaning:
      "nói chung trên những nét lớn: công việc đại để là như vậy * đại để, họ cũng nghĩ như chúng ta",
    example: "công việc đại để là như vậy * đại để, họ cũng nghĩ như chúng ta",
  },
  {
    word: "đại đồng",
    part_of_speech: "tính từ",
    meaning:
      "giống nhau về những nét lớn: chỉ đề cập đến những cái đại đồng, không nhắc đến những cái tiểu dị",
    example:
      "chỉ đề cập đến những cái đại đồng, không nhắc đến những cái tiểu dị",
  },
  {
    word: "đại gian ác",
    part_of_speech: "tính từ",
    meaning: "rất gian giảo và độc ác: bọn địa chủ đại gian ác",
    example: "bọn địa chủ đại gian ác",
  },
  {
    word: "đại gia súc",
    part_of_speech: "danh từ",
    meaning:
      "súc vật nuôi loại lớn, như trâu, bò, ngựa (nói tổng quát): chăn nuôi đại gia súc",
    example: "chăn nuôi đại gia súc",
  },
  {
    word: "đài gương",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) giá để gương soi của phụ nữ; thường dùng để chỉ người phụ nữ đẹp, khuê các thời xưa: "Tiện đây xin một hai điều, Đài gương soi đến dấu bèo cho chăng?" (TKiều)',
    example:
      'Tiện đây xin một hai điều, Đài gương soi đến dấu bèo cho chăng?" (TKiều)',
  },
  {
    word: "đại gia đình",
    part_of_speech: "danh từ",
    meaning:
      "gia đình lớn, gồm cả ông bà, cha mẹ, con cái; thường dùng để ví khối đoàn kết lớn: đại gia đình các dân tộc Việt Nam",
    example: "đại gia đình các dân tộc Việt Nam",
  },
  {
    word: "đại gia",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) nhà sản xuất, nhà kinh doanh lớn hoặc người tài giỏi, có tên tuổi trong một lĩnh vực nào đó: một đại gia về dầu lửa",
    example: "một đại gia về dầu lửa",
  },
  {
    word: "đại học",
    part_of_speech: "danh từ",
    meaning:
      "bậc học trên trung học trong hệ thống giáo dục: giảng đường đại học * tốt nghiệp đại học",
    example: "giảng đường đại học * tốt nghiệp đại học",
  },
  {
    word: "đại hạn",
    part_of_speech: "danh từ",
    meaning:
      "hạn hán lớn và kéo dài: trời đại hạn * đại hạn kéo dài, cây cỏ chết khô",
    example: "trời đại hạn * đại hạn kéo dài, cây cỏ chết khô",
  },
  {
    word: "đại hạn",
    part_of_speech: "danh từ",
    meaning: "hạn lớn, điều không may lớn: gặp phải đại hạn",
    example: "gặp phải đại hạn",
  },
  {
    word: "đại hình",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) tội nặng, có thể phạt từ 5 năm khổ sai trở lên: bị truy tố trước toà đại hình",
    example: "bị truy tố trước toà đại hình",
  },
  {
    word: "đài hoa",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận ở phía ngoài cùng của hoa, gồm những bản thường màu lục: đài sen",
    example: "đài sen",
  },
  {
    word: "đài hoa",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng bằng gỗ tiện, sơn son để bày vật thờ cúng, có hình giống cái đài hoa: đài rượu * đài trầu",
    example: "đài rượu * đài trầu",
  },
  {
    word: "đài hoa",
    part_of_speech: "danh từ",
    meaning: "lần cúng bái hoặc cầu xin: cúng ba đài hương",
    example: "cúng ba đài hương",
  },
  {
    word: "đài hoa",
    part_of_speech: "danh từ",
    meaning:
      "công trình xây dựng trên nền cao, thường không có mái che: đài liệt sĩ * đài tưởng niệm",
    example: "đài liệt sĩ * đài tưởng niệm",
  },
  {
    word: "đài hoa",
    part_of_speech: "danh từ",
    meaning:
      "vị trí thường đặt ở trên cao hoặc cơ sở có trang bị những khí cụ chuyên môn thường đặt ở vị trí cao, để làm nhiệm vụ quan sát, nghiên cứu: đài quan sát khí tượng thuỷ văn",
    example: "đài quan sát khí tượng thuỷ văn",
  },
  {
    word: "đài hoa",
    part_of_speech: "danh từ",
    meaning:
      "đài phát thanh, hoặc đài truyền hình (nói tắt): bản tin phát trên đài phường * đài địa phương",
    example: "bản tin phát trên đài phường * đài địa phương",
  },
  {
    word: "đài hoa",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ): mua một cái đài mới",
    example: "mua một cái đài mới",
  },
  {
    word: "đài hoa",
    part_of_speech: "danh từ",
    meaning:
      '(phương ngữ) bồ đài: "Trách trời, không trách ai đâu, Đài kia ngắn chạc giếng sâu lỡ chừng." (ca dao)',
    example:
      'Trách trời, không trách ai đâu, Đài kia ngắn chạc giếng sâu lỡ chừng." (ca dao)',
  },
  {
    word: "đại hội đồng",
    part_of_speech: "danh từ",
    meaning:
      "cuộc họp đầy đủ nhất của các thành viên trong một tổ chức: chấp hành quyết định của đại hội đồng cổ đông",
    example: "chấp hành quyết định của đại hội đồng cổ đông",
  },
  {
    word: "đại hoạ",
    part_of_speech: "danh từ",
    meaning: "hoạ rất lớn, gây thiệt hại nặng nề: gây đại hoạ",
    example: "gây đại hoạ",
  },
  {
    word: "đài hoá thân",
    part_of_speech: "danh từ",
    meaning:
      "(trang trọng) nơi hoả táng, lò hoả táng: an táng tại đài hoá thân",
    example: "an táng tại đài hoá thân",
  },
  {
    word: "đại hồi",
    part_of_speech: "danh từ",
    meaning: "như hồi: dầu đại hồi",
    example: "dầu đại hồi",
  },
  {
    word: "đại hội",
    part_of_speech: "danh từ",
    meaning:
      "hội nghị định kì của một tổ chức để bàn và quyết định những vấn đề quan trọng nhất: đại hội Đảng lần thứ VI * đại hội cổ đông",
    example: "đại hội Đảng lần thứ VI * đại hội cổ đông",
  },
  {
    word: "đại hội",
    part_of_speech: "danh từ",
    meaning:
      "hội nghị lớn, có quy mô quốc gia hoặc quốc tế, của một ngành hoặc một phong trào: đại hội cháu ngoan Bác Hồ * đại hội thể thao Đông Nam Á",
    example: "đại hội cháu ngoan Bác Hồ * đại hội thể thao Đông Nam Á",
  },
  {
    word: "đại học sĩ",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) chức quan vào hàng lớn nhất trong triều đình phong kiến: hàn lâm viện đại học sĩ",
    example: "hàn lâm viện đại học sĩ",
  },
  {
    word: "đại lãn",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) rất lười biếng (thường dùng để mắng): đồ đại lãn!",
    example: "đồ đại lãn!",
  },
  {
    word: "đại khoa",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) khoa thi lớn tổ chức ở sân chầu vua thời phong kiến, người đỗ được phong học vị từ tiến sĩ trở lên: đỗ đại khoa",
    example: "đỗ đại khoa",
  },
  {
    word: "đại khoa",
    part_of_speech: "danh từ",
    meaning: "người đỗ đại khoa: bậc đại khoa * các vị đại khoa",
    example: "bậc đại khoa * các vị đại khoa",
  },
  {
    word: "đài khí tượng",
    part_of_speech: "danh từ",
    meaning:
      "cơ quan, nơi làm nhiệm vụ quan sát và nghiên cứu khí tượng: đài khí tượng thuỷ văn",
    example: "đài khí tượng thuỷ văn",
  },
  {
    word: "đại khái",
    part_of_speech: "tính từ",
    meaning:
      "chỉ trên những nét lớn, nét khái quát, không đi sâu vào chi tiết, cụ thể: biết đại khái * đại khái câu chuyện chỉ có thế",
    example: "biết đại khái * đại khái câu chuyện chỉ có thế",
  },
  {
    word: "đại khái",
    part_of_speech: "tính từ",
    meaning:
      "(lối làm việc) chỉ chú ý những cái chung chung, thiếu đi sâu vào những cái cụ thể: làm đại khái thôi!",
    example: "làm đại khái thôi!",
  },
  {
    word: "đại lễ",
    part_of_speech: "danh từ",
    meaning: "lễ lớn, được tổ chức trang nghiêm và trịnh trọng: cử hành đại lễ",
    example: "cử hành đại lễ",
  },
  {
    word: "đại lí",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức thương nghiệp đại diện cho một công ti, đảm nhiệm việc giao dịch và giải quyết các công việc cụ thể: đại lí phát hành sách báo",
    example: "đại lí phát hành sách báo",
  },
  {
    word: "đại lược",
    part_of_speech: "tính từ",
    meaning: "rất sơ lược, vắn tắt: nêu những nét đại lược",
    example: "nêu những nét đại lược",
  },
  {
    word: "đại loại",
    part_of_speech: "phụ từ",
    meaning:
      "nói chung trên những nét khái quát: câu chuyện đại loại là như vậy * đại loại chỉ có hai vấn đề cần thảo luận",
    example:
      "câu chuyện đại loại là như vậy * đại loại chỉ có hai vấn đề cần thảo luận",
  },
  {
    word: "đại lượng",
    part_of_speech: "danh từ",
    meaning:
      "cái có thể đo được, tính được bằng cách nào đó (trong vật lí, toán học, v.v.): độ dài, thể tích, khối lượng, nhiệt độ, áp suất đều là những đại lượng",
    example:
      "độ dài, thể tích, khối lượng, nhiệt độ, áp suất đều là những đại lượng",
  },
  {
    word: "đại lượng",
    part_of_speech: "tính từ",
    meaning: "có lòng độ lượng rộng lớn: tấm lòng đại lượng",
    example: "tấm lòng đại lượng",
  },
  {
    word: "đại nạn",
    part_of_speech: "danh từ",
    meaning:
      "nạn rất lớn, mang lại những đau khổ, tổn thất nặng nề: đại nạn hàng giả * trừ đại nạn",
    example: "đại nạn hàng giả * trừ đại nạn",
  },
  {
    word: "đại lý",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức thương nghiệp đại diện cho một công ti, đảm nhiệm việc giao dịch và giải quyết các công việc cụ thể: đại lí phát hành sách báo",
    example: "đại lí phát hành sách báo",
  },
  {
    word: "đại nghĩa",
    part_of_speech: "danh từ",
    meaning:
      'chính nghĩa cao cả: bỏ mình vì đại nghĩa * "Đem đại nghĩa để thắng hung tàn (...)" (BNĐC)',
    example:
      'bỏ mình vì đại nghĩa * "Đem đại nghĩa để thắng hung tàn (...)" (BNĐC)',
  },
  {
    word: "đại náo",
    part_of_speech: "động từ",
    meaning: "(cũ) gây náo động lớn: Tôn Ngộ Không đại náo thiên cung",
    example: "Tôn Ngộ Không đại náo thiên cung",
  },
  {
    word: "đãi ngộ",
    part_of_speech: "động từ",
    meaning:
      "cho hưởng các quyền lợi tương xứng với sự đóng góp: chính sách đãi ngộ đối với thương binh",
    example: "chính sách đãi ngộ đối với thương binh",
  },
  {
    word: "đại phá",
    part_of_speech: "động từ",
    meaning: "(cũ) đánh cho đại bại: Quang Trung đại phá quân Thanh",
    example: "Quang Trung đại phá quân Thanh",
  },
  {
    word: "đại nội",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) khu vực rộng lớn ở trong cung, xung quanh thường có thành cao và hào sâu bao bọc: tham quan đại nội kinh thành Huế",
    example: "tham quan đại nội kinh thành Huế",
  },
  {
    word: "đại quát",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất chung trên những nét lớn cho toàn thể, không đi vào chi tiết: mấy nét đại quát về nội dung Truyện Kiều * cái nhìn đại quát",
    example: "mấy nét đại quát về nội dung Truyện Kiều * cái nhìn đại quát",
  },
  {
    word: "đại phu",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) chức quan tương đối cao ở Trung Quốc thời phong kiến, cấp bậc có sự thay đổi tuỳ theo triều đại: quan đại phu",
    example: "quan đại phu",
  },
  {
    word: "đại quân",
    part_of_speech: "danh từ",
    meaning:
      "đạo quân lớn, là lực lượng chủ lực trong quân đội: đem đại quân đến tiếp ứng",
    example: "đem đại quân đến tiếp ứng",
  },
  {
    word: "đại sứ",
    part_of_speech: "danh từ",
    meaning:
      "đại diện ngoại giao cấp cao nhất có đầy đủ quyền hạn để nhân danh nhà nước mình giao thiệp với nhà nước sở tại: ngài đại sứ",
    example: "ngài đại sứ",
  },
  {
    word: "đại tang",
    part_of_speech: "danh từ",
    meaning: "tang lớn (thường là tang cha, mẹ): nhà có đại tang",
    example: "nhà có đại tang",
  },
  {
    word: "đại sự",
    part_of_speech: "danh từ",
    meaning: "(cũ) việc lớn, việc hệ trọng: mưu việc đại sự * làm đại sự",
    example: "mưu việc đại sự * làm đại sự",
  },
  {
    word: "đại sảnh",
    part_of_speech: "danh từ",
    meaning:
      "phòng rất lớn trong toà nhà, thường dùng làm nơi hội họp, tiếp đãi quan khách: đại sảnh của khách sạn",
    example: "đại sảnh của khách sạn",
  },
  {
    word: "đại tá",
    part_of_speech: "danh từ",
    meaning:
      "bậc quân hàm cao nhất của cấp tá: đại tá công an * đeo quân hàm đại tá",
    example: "đại tá công an * đeo quân hàm đại tá",
  },
  {
    word: "đại tài",
    part_of_speech: "tính từ",
    meaning: "rất tài giỏi, có tài năng lớn: một nhà chính trị đại tài",
    example: "một nhà chính trị đại tài",
  },
  {
    word: "đại thể",
    part_of_speech: "danh từ",
    meaning:
      "những nét lớn của sự việc, sự vật (nói tổng quát): đánh giá về đại thể * giống nhau trên đại thể",
    example: "đánh giá về đại thể * giống nhau trên đại thể",
  },
  {
    word: "đại thể",
    part_of_speech: "phụ từ",
    meaning:
      "nói chung trên những nét lớn: đại thể ý kiến của họ là giống nhau * chuyện đại thể là như vậy",
    example: "đại thể ý kiến của họ là giống nhau * chuyện đại thể là như vậy",
  },
  {
    word: "đại thần",
    part_of_speech: "danh từ",
    meaning: "(cũ) quan to trong triều: Nguyễn Trãi là một đại thần triều Lê",
    example: "Nguyễn Trãi là một đại thần triều Lê",
  },
  {
    word: "đại thánh",
    part_of_speech: "danh từ",
    meaning: "vị thánh lớn: bậc đại thánh",
    example: "bậc đại thánh",
  },
  {
    word: "đài thọ",
    part_of_speech: "động từ",
    meaning: "nhận trả các khoản chi phí cho việc gì: đài thọ cho tiền ăn học",
    example: "đài thọ cho tiền ăn học",
  },
  {
    word: "đại thọ",
    part_of_speech: "tính từ",
    meaning: "có tuổi thọ rất cao, trên thượng thọ: làm lễ mừng đại thọ",
    example: "làm lễ mừng đại thọ",
  },
  {
    word: "đại thắng",
    part_of_speech: "",
    meaning:
      "thắng to, thắng lợi lớn  (trong chiến đấu): đại thắng mùa xuân năm 1975",
    example: "đại thắng mùa xuân năm 1975",
  },
  {
    word: "đại thụ",
    part_of_speech: "danh từ",
    meaning: "cây to, sống lâu đời: cây đại thụ",
    example: "cây đại thụ",
  },
  {
    word: "đài trang",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) nơi trang điểm của phụ nữ; cũng dùng để chỉ nơi ở của phụ nữ: "Mảng tin xiết nỗi kinh hoàng, Băng mình lẻn trước đài trang tự tình." (TKiều)',
    example:
      'Mảng tin xiết nỗi kinh hoàng, Băng mình lẻn trước đài trang tự tình." (TKiều)',
  },
  {
    word: "đại tràng",
    part_of_speech: "danh từ",
    meaning: "ruột già: viêm đại tràng",
    example: "viêm đại tràng",
  },
  {
    word: "đại trào",
    part_of_speech: "danh từ",
    meaning: "(cũ) lễ phục mặc trong các buổi lễ lớn, long trọng: mặc đại trào",
    example: "mặc đại trào",
  },
  {
    word: "đại tiệc",
    part_of_speech: "danh từ",
    meaning: "bữa tiệc lớn: mở đại tiệc",
    example: "mở đại tiệc",
  },
  {
    word: "đại trà",
    part_of_speech: "tính từ",
    meaning:
      "(trồng trọt, chăn nuôi, thu hoạch) trên diện tích rộng, với quy mô lớn: trồng ngô đại trà * nuôi cá đại trà",
    example: "trồng ngô đại trà * nuôi cá đại trà",
  },
  {
    word: "đại trà",
    part_of_speech: "tính từ",
    meaning:
      "rộng khắp, trên quy mô lớn: thử nghiệm trước khi cho áp dụng đại trà * triển khai đại trà",
    example: "thử nghiệm trước khi cho áp dụng đại trà * triển khai đại trà",
  },
  {
    word: "đài truyền hình",
    part_of_speech: "danh từ",
    meaning:
      "nơi làm nhiệm vụ truyền phát đi hình ảnh có kèm âm thanh, bằng sóng radio: trường quay của đài truyền hình",
    example: "trường quay của đài truyền hình",
  },
  {
    word: "đại trượng phu",
    part_of_speech: "danh từ",
    meaning: "(cũ) như trượng phu (nhưng nghĩa mạnh hơn): bậc đại trượng phu",
    example: "bậc đại trượng phu",
  },
  {
    word: "đại tu",
    part_of_speech: "động từ",
    meaning:
      "sửa chữa lớn (thường nói về các loại máy móc, xe cộ): đại tu xe máy",
    example: "đại tu xe máy",
  },
  {
    word: "đại từ",
    part_of_speech: "danh từ",
    meaning:
      "(ngữ pháp) từ dùng để chỉ một đối tượng, một điều đã được nói đến, hay là một đối tượng, một điều nào đó trong hoàn cảnh nói năng nhất định: 'tôi', 'nó', 'đây', 'ấy', 'gì', v.v. là các đại từ trong tiếng Việt.",
    example:
      "'tôi', 'nó', 'đây', 'ấy', 'gì', v.v. là các đại từ trong tiếng Việt.",
  },
  {
    word: "đại tư bản",
    part_of_speech: "danh từ",
    meaning: "người có vốn rất lớn trong kinh doanh: một nhà đại tư bản",
    example: "một nhà đại tư bản",
  },
  {
    word: "đại từ đại bi",
    part_of_speech: "tính từ",
    meaning: "rất từ bi: đức Phật đại từ đại bi",
    example: "đức Phật đại từ đại bi",
  },
  {
    word: "đại xá",
    part_of_speech: "động từ",
    meaning:
      "(cơ quan quyền lực nhà nước tối cao hoặc nguyên thủ quốc gia ra công bố) tha tội cho một loạt người phạm pháp đã hoặc chưa bị truy tố, xét xử: đại xá cho một số tù nhân nhân ngày quốc khánh",
    example: "đại xá cho một số tù nhân nhân ngày quốc khánh",
  },
  {
    word: "đại xá",
    part_of_speech: "động từ",
    meaning:
      "(cũ, trang trọng) tha tội (thường dùng trong đối thoại, khi xin bề trên tha tội cho): con đã biết tội, xin ngài đại xá cho!",
    example: "con đã biết tội, xin ngài đại xá cho!",
  },
  {
    word: "đại vương",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) từ dùng để gọi vua hoặc người có tước vương một cách tôn kính: muôn tâu đại vương",
    example: "muôn tâu đại vương",
  },
  {
    word: "đàm",
    part_of_speech: "động từ",
    meaning: "đàm phán (nói tắt): vừa đánh vừa đàm",
    example: "vừa đánh vừa đàm",
  },
  {
    word: "đại ý",
    part_of_speech: "danh từ",
    meaning:
      "ý chính, có tính chung nhất, tổng quát nhất (nói tổng quát): tìm đại ý của bài văn * đại ý câu chuyện là như thế",
    example: "tìm đại ý của bài văn * đại ý câu chuyện là như thế",
  },
  {
    word: "đạm",
    part_of_speech: "danh từ",
    meaning: "tên gọi thông thường của nitrogen: phân đạm * bón đạm cho cây",
    example: "phân đạm * bón đạm cho cây",
  },
  {
    word: "đạm",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi thông thường của protid: cung cấp đủ lượng đạm cho cơ thể",
    example: "cung cấp đủ lượng đạm cho cơ thể",
  },
  {
    word: "đám",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp gồm có nhiều vật cùng loại không theo một trật tự nhất định nhưng cùng ở vào một chỗ, tạo thành khối liền nhau: đám bụi * đám mây * đám cháy",
    example: "đám bụi * đám mây * đám cháy",
  },
  {
    word: "đám",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng khoảnh, từng đơn vị ruộng đất, thường là nhỏ và không được vuông vắn: đám ruộng đầu làng * đám đất hoang",
    example: "đám ruộng đầu làng * đám đất hoang",
  },
  {
    word: "đám",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp gồm một số đông người tụ họp lại một chỗ để cùng tiến hành việc gì: đám giỗ * đám cưới * ngồi vào đám bạc",
    example: "đám giỗ * đám cưới * ngồi vào đám bạc",
  },
  {
    word: "đám",
    part_of_speech: "danh từ",
    meaning: "đám hội, đám tang (nói tắt): nhà có đám * làng vào đám",
    example: "nhà có đám * làng vào đám",
  },
  {
    word: "đám",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp gồm một số người cùng có chung một nét nào đó: đám bạn cùng lứa * đám trẻ bụi đời",
    example: "đám bạn cùng lứa * đám trẻ bụi đời",
  },
  {
    word: "đám",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) từ dùng để chỉ người nào đó có thể sẽ là đối tượng để xây dựng quan hệ hôn nhân: làm mối cho một đám * có đám nào hỏi thì gả phắt đi cho rồi!",
    example: "làm mối cho một đám * có đám nào hỏi thì gả phắt đi cho rồi!",
  },
  {
    word: "đảm",
    part_of_speech: "tính từ",
    meaning:
      "đảm đang (nói tắt): người phụ nữ đảm * giỏi việc nước, đảm việc nhà",
    example: "người phụ nữ đảm * giỏi việc nước, đảm việc nhà",
  },
  {
    word: "đạm bạc",
    part_of_speech: "tính từ",
    meaning:
      "(ăn uống) chỉ có ở mức đơn giản, tối thiểu, không có những thức ăn ngon, đắt tiền: bữa cơm đạm bạc * sống một cuộc sống đạm bạc",
    example: "bữa cơm đạm bạc * sống một cuộc sống đạm bạc",
  },
  {
    word: "đám cưới",
    part_of_speech: "danh từ",
    meaning:
      "lễ cưới, thường có đông người tham dự: đi dự đám cưới * làm đám cưới",
    example: "đi dự đám cưới * làm đám cưới",
  },
  {
    word: "đảm bảo",
    part_of_speech: "",
    meaning: "như bảo đảm: đời sống được đảm bảo * tôi đảm bảo việc đó là đúng",
    example: "đời sống được đảm bảo * tôi đảm bảo việc đó là đúng",
  },
  {
    word: "đảm đang",
    part_of_speech: "động từ",
    meaning:
      "(cũ) như đảm đương (thường nói về người phụ nữ): đảm đang mọi việc trong gia đình",
    example: "đảm đang mọi việc trong gia đình",
  },
  {
    word: "đảm đang",
    part_of_speech: "tính từ",
    meaning:
      "(người phụ nữ) giỏi giang trong công việc, thường là việc gia đình: người vợ đảm đang",
    example: "người vợ đảm đang",
  },
  {
    word: "đảm đương",
    part_of_speech: "động từ",
    meaning:
      "nhận lấy phần công việc khó khăn, quan trọng, và làm với đầy đủ ý thức trách nhiệm: mọi việc trong nhà đều một tay chị đảm đương",
    example: "mọi việc trong nhà đều một tay chị đảm đương",
  },
  {
    word: "đàm đạo",
    part_of_speech: "động từ",
    meaning:
      "(văn chương) nói chuyện, trao đổi thân mật với nhau: đàm đạo thơ văn",
    example: "đàm đạo thơ văn",
  },
  {
    word: "đam mê",
    part_of_speech: "động từ",
    meaning:
      "ham thích thái quá, đến mức như không còn biết việc gì khác nữa: đam mê tửu sắc",
    example: "đam mê tửu sắc",
  },
  {
    word: "đàm tiếu",
    part_of_speech: "động từ",
    meaning: "bàn tán chê cười: những lời đàm tiếu * bị thiên hạ đàm tiếu",
    example: "những lời đàm tiếu * bị thiên hạ đàm tiếu",
  },
  {
    word: "đảm nhận",
    part_of_speech: "động từ",
    meaning:
      "nhận lấy, nhận làm một công việc nào đó, thường là khó khăn: đảm nhận công việc nội trợ",
    example: "đảm nhận công việc nội trợ",
  },
  {
    word: "đàm thoại",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) nói chuyện với nhau: giảm cước phí đàm thoại quốc tế",
    example: "giảm cước phí đàm thoại quốc tế",
  },
  {
    word: "đàm thoại",
    part_of_speech: "động từ",
    meaning:
      "nói và trả lời trực tiếp giữa giáo viên và học sinh trong giờ học, nhằm gợi mở, kiểm tra, củng cố kiến thức cho học sinh (một phương pháp giảng dạy): phương pháp đàm thoại",
    example: "phương pháp đàm thoại",
  },
  {
    word: "đảm nhiệm",
    part_of_speech: "động từ",
    meaning:
      "nhận lấy công việc hay gánh vác một nhiệm vụ khó khăn: đảm nhiệm chức trưởng phòng",
    example: "đảm nhiệm chức trưởng phòng",
  },
  {
    word: "đàm phán",
    part_of_speech: "động từ",
    meaning:
      "bàn bạc giữa hai hay nhiều bên để thống nhất cách giải quyết những vấn đề có liên quan: cuộc đàm phán hoà bình * ngồi vào bàn đàm phán",
    example: "cuộc đàm phán hoà bình * ngồi vào bàn đàm phán",
  },
  {
    word: "đảm trách",
    part_of_speech: "động từ",
    meaning:
      "đảm nhận và chịu trách nhiệm (về công việc thường là khó khăn, nặng nề): đảm trách việc liên hệ với cộng tác viên",
    example: "đảm trách việc liên hệ với cộng tác viên",
  },
  {
    word: "đàn áp",
    part_of_speech: "động từ",
    meaning:
      "dẹp sự chống đối bằng bạo lực hoặc uy quyền, một cách thô bạo: giặc đàn áp các phong trào yêu nước * cuộc khởi nghĩa bị đàn áp khốc liệt",
    example:
      "giặc đàn áp các phong trào yêu nước * cuộc khởi nghĩa bị đàn áp khốc liệt",
  },
  {
    word: "đàn",
    part_of_speech: "danh từ",
    meaning:
      "nhạc khí thường có dây hoặc bàn phím để phát ra tiếng nhạc: tiếng đàn * gảy đàn",
    example: "tiếng đàn * gảy đàn",
  },
  {
    word: "đàn",
    part_of_speech: "động từ",
    meaning: "làm cho phát ra tiếng nhạc bằng đàn: vừa đàn vừa hát",
    example: "vừa đàn vừa hát",
  },
  {
    word: "đàn",
    part_of_speech: "danh từ",
    meaning:
      "nền đất đắp cao hoặc đài dựng cao để tế lễ: đàn Nam Giao * lập đàn cầu mưa",
    example: "đàn Nam Giao * lập đàn cầu mưa",
  },
  {
    word: "đàn",
    part_of_speech: "danh từ",
    meaning: "đất nung thô có tráng men: đĩa đàn * bát đàn",
    example: "đĩa đàn * bát đàn",
  },
  {
    word: "đàn",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp một số đông động vật cùng loài sinh sống chung hoặc đi chung với nhau, thường là có trật tự: đàn bò đang ung dung gặm cỏ * sẩy đàn tan nghé (tng)",
    example: "đàn bò đang ung dung gặm cỏ * sẩy đàn tan nghé (tng)",
  },
  {
    word: "đàn",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp số đông trẻ con cùng sinh hoạt chung với nhau: đàn trẻ ùa ra sân trường * con đàn cháu đống (tng)",
    example: "đàn trẻ ùa ra sân trường * con đàn cháu đống (tng)",
  },
  {
    word: "đàn",
    part_of_speech: "danh từ",
    meaning:
      "lớp người thuộc thứ bậc nào đó: ra dáng đàn chị * thuộc lớp đàn em",
    example: "ra dáng đàn chị * thuộc lớp đàn em",
  },
  {
    word: "đạn",
    part_of_speech: "danh từ",
    meaning:
      "khối tròn hay nhọn, thường bằng kim loại, được phóng đi bằng súng để sát thương, phá hoại mục tiêu: súng hết đạn * bị trúng đạn",
    example: "súng hết đạn * bị trúng đạn",
  },
  {
    word: "đàn anh",
    part_of_speech: "danh từ",
    meaning:
      "những người thuộc hàng trên, bậc trên, đáng tuổi anh (nói tổng quát): thế hệ đàn anh",
    example: "thế hệ đàn anh",
  },
  {
    word: "đàn anh",
    part_of_speech: "danh từ",
    meaning:
      "người trên, kẻ trên, được coi là có thứ bậc hoặc địa vị cao hơn (nói khái quát): lên giọng đàn anh * bậc đàn anh trong văn giới",
    example: "lên giọng đàn anh * bậc đàn anh trong văn giới",
  },
  {
    word: "đàn bà",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) người thuộc nữ giới, thường đã nhiều tuổi: vắng đàn ông quạnh nhà, vắng đàn bà quạnh bếp (tng)",
    example: "vắng đàn ông quạnh nhà, vắng đàn bà quạnh bếp (tng)",
  },
  {
    word: "đan",
    part_of_speech: "động từ",
    meaning:
      "làm cho vật hình sợi hoặc thanh mỏng luồn qua lại với nhau theo những trật tự nhất định để kết lại thành tấm: đan áo len * đan rổ",
    example: "đan áo len * đan rổ",
  },
  {
    word: "đan cài",
    part_of_speech: "động từ",
    meaning: "xen lẫn vào nhau: những dải màu xanh, đỏ đan cài vào nhau",
    example: "những dải màu xanh, đỏ đan cài vào nhau",
  },
  {
    word: "đan chen",
    part_of_speech: "động từ",
    meaning: "(hiếm) như đan xen: cây cối mọc đan chen vào nhau",
    example: "cây cối mọc đan chen vào nhau",
  },
  {
    word: "đan chéo",
    part_of_speech: "động từ",
    meaning:
      "đan xen, chồng chéo vào nhau một cách lằng nhằng, phức tạp: những luồng đạn đan chéo vào nhau bay tới tấp",
    example: "những luồng đạn đan chéo vào nhau bay tới tấp",
  },
  {
    word: "đạn dược",
    part_of_speech: "danh từ",
    meaning: "đạn và chất nổ (nói khái quát): kiểm tra súng ống, đạn dược",
    example: "kiểm tra súng ống, đạn dược",
  },
  {
    word: "đàn địch",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ, hiếm) chơi nhạc khí (nói khái quát; thường hàm ý chê): suốt ngày chỉ đàn địch, hát xướng!",
    example: "suốt ngày chỉ đàn địch, hát xướng!",
  },
  {
    word: "đàn đúm",
    part_of_speech: "động từ",
    meaning:
      "tụ tập nhau lại để chơi bời (hàm ý chê): đàn đúm với chúng bạn * chơi bời đàn đúm",
    example: "đàn đúm với chúng bạn * chơi bời đàn đúm",
  },
  {
    word: "đạn đạo",
    part_of_speech: "danh từ",
    meaning:
      "(kĩ thuật nghiên cứu) đường đi của viên đạn: nghiên cứu đạn đạo * kĩ thuật đạn đạo",
    example: "nghiên cứu đạn đạo * kĩ thuật đạn đạo",
  },
  {
    word: "đàn em",
    part_of_speech: "danh từ",
    meaning:
      "những người thuộc hàng dưới, đáng tuổi em (nói tổng quát): chăm lo dìu dắt thế hệ đàn em",
    example: "chăm lo dìu dắt thế hệ đàn em",
  },
  {
    word: "đàn em",
    part_of_speech: "danh từ",
    meaning:
      "người được coi là có thứ bậc hoặc địa vị thấp kém hơn (nói khái quát): bọn đàn em * hạng đàn em trong nghề",
    example: "bọn đàn em * hạng đàn em trong nghề",
  },
  {
    word: "đàn hồi",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất tự trở về hình dạng và thể tích ban đầu, sau khi các lực gây ra biến dạng ngừng tác động: cao su có khả năng đàn hồi",
    example: "cao su có khả năng đàn hồi",
  },
  {
    word: "đan lát",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đan các đồ dùng (nói khái quát): học thêu thùa, đan lát",
    example: "học thêu thùa, đan lát",
  },
  {
    word: "đan kết",
    part_of_speech: "động từ",
    meaning:
      "đan và kết lại cho gắn chặt với nhau (nói khái quát): những chùm lá đan kết vào nhau thành vòm rộng",
    example: "những chùm lá đan kết vào nhau thành vòm rộng",
  },
  {
    word: "đàn ông",
    part_of_speech: "danh từ",
    meaning:
      'người thuộc nam giới, thường đã nhiều tuổi: cánh đàn ông * "Đàn ông năm bảy lá gan, Lá ở cùng vợ lá toan cùng người." (ca dao)',
    example:
      'cánh đàn ông * "Đàn ông năm bảy lá gan, Lá ở cùng vợ lá toan cùng người." (ca dao)',
  },
  {
    word: "đàn sáo",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) chơi đàn, thổi sáo (nói khái quát): suốt ngày đàn sáo ca hát",
    example: "suốt ngày đàn sáo ca hát",
  },
  {
    word: "đàn tràng",
    part_of_speech: "danh từ",
    meaning:
      "đàn dựng lên để làm lễ Phật (thường làm lễ giải oan): lập đàn tràng giải oan",
    example: "lập đàn tràng giải oan",
  },
  {
    word: "đang",
    part_of_speech: "động từ",
    meaning:
      '(văn chương) bằng lòng làm một việc mà người có tình cảm không thể làm: "Vì đâu hoa nọ lìa cành, Nợ duyên sao sớm dứt tình cho đang." (ca dao)',
    example:
      'Vì đâu hoa nọ lìa cành, Nợ duyên sao sớm dứt tình cho đang." (ca dao)',
  },
  {
    word: "đang",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị sự việc, hiện tượng đã diễn ra và chưa kết thúc trong thời điểm được xem là thời điểm mốc (ngay khi nói): trời đang mưa to * đang mải suy nghĩ * đang học đại học",
    example: "trời đang mưa to * đang mải suy nghĩ * đang học đại học",
  },
  {
    word: "đảng bộ",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức đảng ở các cấp, các ngành, trên chi bộ hoặc liên chi: đảng bộ nhà trường",
    example: "đảng bộ nhà trường",
  },
  {
    word: "đan xen",
    part_of_speech: "động từ",
    meaning:
      "đan lẫn vào nhau, cái nọ tiếp cái kia: các tiết học và thực hành được bố trí đan xen * đan xen văn hoá",
    example: "các tiết học và thực hành được bố trí đan xen * đan xen văn hoá",
  },
  {
    word: "đảng",
    part_of_speech: "danh từ",
    meaning:
      "nhóm người kết với nhau để cùng thực hiện một mục đích chung nào đó, trong sự đối lập với những nhóm người khác: phân bè kéo đảng",
    example: "phân bè kéo đảng",
  },
  {
    word: "đảng",
    part_of_speech: "danh từ",
    meaning:
      "như chính đảng (thường chỉ một đảng cụ thể): đảng dân chủ * chế độ đa đảng",
    example: "đảng dân chủ * chế độ đa đảng",
  },
  {
    word: "đảng",
    part_of_speech: "danh từ",
    meaning:
      "(thường viết hoa) Đảng Cộng sản Việt Nam (nói tắt): được đứng trong hàng ngũ của Đảng",
    example: "được đứng trong hàng ngũ của Đảng",
  },
  {
    word: "đáng",
    part_of_speech: "động từ",
    meaning:
      "được đánh giá là xứng, là hợp với một giá trị nào đó: việc nhỏ, không đáng lo * ngần ấy thì đáng gì!",
    example: "việc nhỏ, không đáng lo * ngần ấy thì đáng gì!",
  },
  {
    word: "đáng",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) lầy lội, có bùn lầy: cánh đồng trên se, dưới đáng",
    example: "cánh đồng trên se, dưới đáng",
  },
  {
    word: "đàng điếm",
    part_of_speech: "tính từ",
    meaning:
      "(lối sống) lăng nhăng, buông thả, hay trai gái bậy bạ, mất nhân cách: quen thói đàng điếm",
    example: "quen thói đàng điếm",
  },
  {
    word: "đáng đời",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) không có gì là oan ức, bị trừng phạt như vậy cũng là đáng: nhận một bài học đáng đời * đáng đời quân gian ác! * có thế mới đáng đời!",
    example:
      "nhận một bài học đáng đời * đáng đời quân gian ác! * có thế mới đáng đời!",
  },
  {
    word: "đáng giá",
    part_of_speech: "tính từ",
    meaning:
      "có giá trị, được đánh giá cao: trong nhà không có gì đáng giá * đáng giá nghìn vàng",
    example: "trong nhà không có gì đáng giá * đáng giá nghìn vàng",
  },
  {
    word: "đáng lẽ",
    part_of_speech: "phụ từ",
    meaning:
      "theo như lẽ bình thường thì phải như thế này (nhưng thực tế đã xảy ra hoàn toàn khác): việc này đáng lẽ phải xong từ hôm qua rồi mới phải",
    example: "việc này đáng lẽ phải xong từ hôm qua rồi mới phải",
  },
  {
    word: "đàng hoàng",
    part_of_speech: "tính từ",
    meaning:
      "có đời sống vật chất đầy đủ, theo mức yêu cầu chung của xã hội: cuộc sống đàng hoàng * nhà cửa đàng hoàng",
    example: "cuộc sống đàng hoàng * nhà cửa đàng hoàng",
  },
  {
    word: "đàng hoàng",
    part_of_speech: "tính từ",
    meaning:
      "có đầy đủ những biểu hiện về tư cách, tính chất, v.v., để được coi trọng: ăn nói đàng hoàng * con người đàng hoàng",
    example: "ăn nói đàng hoàng * con người đàng hoàng",
  },
  {
    word: "đàng hoàng",
    part_of_speech: "tính từ",
    meaning:
      "đúng đắn, nghiêm túc, không có gì phải giấu giếm, phải sợ sệt: giấy cấp có chữ kí đàng hoàng",
    example: "giấy cấp có chữ kí đàng hoàng",
  },
  {
    word: "đáng lí",
    part_of_speech: "phụ từ",
    meaning:
      "theo đúng lí ra thì phải là thế này (nhưng thực tế đã không như thế): đáng lí bị trượt, nhưng vì khéo chạy chọt nên được vớt",
    example: "đáng lí bị trượt, nhưng vì khéo chạy chọt nên được vớt",
  },
  {
    word: "đáng kể",
    part_of_speech: "tính từ",
    meaning:
      "có số lượng hoặc giá trị ở mức đáng, cần được chú ý đến: kiếm được một khoản tiền đáng kể * thiệt hại không đáng kể",
    example: "kiếm được một khoản tiền đáng kể * thiệt hại không đáng kể",
  },
  {
    word: "đảng phái",
    part_of_speech: "danh từ",
    meaning:
      "các đảng hoặc các phe phái (nói khái quát): các đảng phái chính trị * có óc đảng phái",
    example: "các đảng phái chính trị * có óc đảng phái",
  },
  {
    word: "đáng lý",
    part_of_speech: "phụ từ",
    meaning:
      "theo đúng lí ra thì phải là thế này (nhưng thực tế đã không như thế): đáng lí bị trượt, nhưng vì khéo chạy chọt nên được vớt",
    example: "đáng lí bị trượt, nhưng vì khéo chạy chọt nên được vớt",
  },
  {
    word: "đảng phí",
    part_of_speech: "danh từ",
    meaning:
      "tiền đảng viên đóng cho ngân quỹ của tổ chức đảng theo định kì, thường là hằng tháng: nộp đảng phí",
    example: "nộp đảng phí",
  },
  {
    word: "đảng tịch",
    part_of_speech: "danh từ",
    meaning:
      "sổ ghi danh sách đảng viên; cũng dùng để chỉ tư cách là một đảng viên của đảng: phục hồi đảng tịch",
    example: "phục hồi đảng tịch",
  },
  {
    word: "đang tay",
    part_of_speech: "động từ",
    meaning:
      'tự tay làm những việc mà người có tình cảm không thể làm: đang tay đánh đập trẻ con * "Vàng bền ví quyết chẳng lay, Không gươm mà cũng đang tay nỡ người." (TKiều)',
    example:
      'đang tay đánh đập trẻ con * "Vàng bền ví quyết chẳng lay, Không gươm mà cũng đang tay nỡ người." (TKiều)',
  },
  {
    word: "đáng ra",
    part_of_speech: "",
    meaning:
      "tổ hợp biểu thị ý cho rằng theo đúng như lẽ thường hoặc như bình thường thì phải như thế (nhưng thực tế lại không như thế): đáng ra phải đi hôm nay, nhưng mệt lại thôi * đáng ra anh phải cho tôi biết sớm",
    example:
      "đáng ra phải đi hôm nay, nhưng mệt lại thôi * đáng ra anh phải cho tôi biết sớm",
  },
  {
    word: "đang tâm",
    part_of_speech: "động từ",
    meaning:
      "bằng lòng làm những việc trái với tình cảm, đạo đức của con người: đang tâm từ bỏ con cái * không đang tâm làm việc thất đức",
    example: "đang tâm từ bỏ con cái * không đang tâm làm việc thất đức",
  },
  {
    word: "đàng sá",
    part_of_speech: "danh từ",
    meaning:
      "đường đi lại trên bộ (nói khái quát): đường sá lầy lội * đường sá xa xôi, đi lại không tiện",
    example: "đường sá lầy lội * đường sá xa xôi, đi lại không tiện",
  },
  {
    word: "đãng trí",
    part_of_speech: "động từ",
    meaning:
      "không tập trung chú ý vào công việc, do mải nghĩ về những việc khác hoặc do bệnh lí: đãng trí nên để đâu quên đấy * tính hay đãng trí",
    example: "đãng trí nên để đâu quên đấy * tính hay đãng trí",
  },
  {
    word: "đảng trị",
    part_of_speech: "động từ",
    meaning:
      "(một đảng cầm quyền) thực hiện việc nắm mọi quyền hành trong bộ máy nhà nước (hàm ý chê): chế độ đảng trị",
    example: "chế độ đảng trị",
  },
  {
    word: "đảng uỷ",
    part_of_speech: "danh từ",
    meaning: "ban chấp hành của một đảng bộ: đảng uỷ cơ quan",
    example: "đảng uỷ cơ quan",
  },
  {
    word: "đánh",
    part_of_speech: "động từ",
    meaning:
      "làm cho đau, cho tổn thương bằng tác động của một lực lên cơ thể: đánh cho mấy roi * bị sét đánh * giơ cao đánh khẽ (tng)",
    example: "đánh cho mấy roi * bị sét đánh * giơ cao đánh khẽ (tng)",
  },
  {
    word: "đánh",
    part_of_speech: "động từ",
    meaning:
      "làm cho (kẻ địch) bị tổn thất hoặc huỷ diệt bằng vũ khí, vũ lực: đánh giặc * Ngô Quyền đánh tan quân Nam Hán",
    example: "đánh giặc * Ngô Quyền đánh tan quân Nam Hán",
  },
  {
    word: "đánh",
    part_of_speech: "động từ",
    meaning:
      "gõ vào làm cho phát ra tiếng nhạc hoặc tiếng báo hiệu: đánh cồng * đánh trống khua chiêng (tng)",
    example: "đánh cồng * đánh trống khua chiêng (tng)",
  },
  {
    word: "đánh",
    part_of_speech: "động từ",
    meaning:
      "xát, xoa làm cho bề mặt sạch hoặc đẹp ra: đánh răng * đánh vảy cá * đánh phấn tô son",
    example: "đánh răng * đánh vảy cá * đánh phấn tô son",
  },
  {
    word: "đánh",
    part_of_speech: "động từ",
    meaning:
      "làm cho thành vật có hình dáng nhất định bằng tác động của lực đập vào vật liệu bằng kim loại đã được nung đỏ: đánh con dao * đánh chiếc nhẫn vàng hai chỉ",
    example: "đánh con dao * đánh chiếc nhẫn vàng hai chỉ",
  },
  {
    word: "đánh",
    part_of_speech: "động từ",
    meaning:
      "làm cho có trạng thái nhất định bằng cách khuấy mạnh cho đều: đánh trứng * đánh kem * đánh tiết canh * đánh phèn lọc nước",
    example: "đánh trứng * đánh kem * đánh tiết canh * đánh phèn lọc nước",
  },
  {
    word: "đánh",
    part_of_speech: "động từ",
    meaning:
      "làm cho thành vật có hình dáng hoặc trạng thái nhất định bằng cách quấn, xe hoặc gài chung lại: đánh thừng * đánh tranh lợp nhà",
    example: "đánh thừng * đánh tranh lợp nhà",
  },
  {
    word: "đánh",
    part_of_speech: "động từ",
    meaning:
      "làm cho trở thành có hình dáng hoặc trạng thái nhất định bằng cách đào, vun, xới: đánh luống để trồng khoai * đánh rơm thành đống",
    example: "đánh luống để trồng khoai * đánh rơm thành đống",
  },
  {
    word: "đánh",
    part_of_speech: "động từ",
    meaning:
      "gõ hoặc xát vào làm cho dụng cụ phát huy tác dụng: đánh diêm châm đèn",
    example: "đánh diêm châm đèn",
  },
  {
    word: "đánh",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) đánh máy (nói tắt): bài viết được đánh thành nhiều bản",
    example: "bài viết được đánh thành nhiều bản",
  },
  {
    word: "đánh",
    part_of_speech: "động từ",
    meaning:
      "vung, đưa mạnh tay theo một hướng nào đó: hai tay đánh theo nhịp bước * đánh tay lái cho xe rẽ trái",
    example: "hai tay đánh theo nhịp bước * đánh tay lái cho xe rẽ trái",
  },
  {
    word: "đánh",
    part_of_speech: "động từ",
    meaning:
      "chơi có được thua trong một cuộc chơi thường có dùng đến tay: đánh bóng bàn * đánh cờ tướng",
    example: "đánh bóng bàn * đánh cờ tướng",
  },
  {
    word: "đánh",
    part_of_speech: "động từ",
    meaning:
      "đưa hoặc chuyển quân bài, quả bóng, thường bằng động tác của tay, để đối thủ phải đối phó lại: đánh con bài chủ * đánh nhẹ quả bóng vào góc bàn",
    example: "đánh con bài chủ * đánh nhẹ quả bóng vào góc bàn",
  },
  {
    word: "đánh",
    part_of_speech: "động từ",
    meaning:
      "làm cho súc vật hoặc các phương tiện vận tải di chuyển đến nơi khác dưới sự điều khiển trực tiếp của mình: đánh xe ngựa * đánh xe vào ga ra",
    example: "đánh xe ngựa * đánh xe vào ga ra",
  },
  {
    word: "đánh",
    part_of_speech: "động từ",
    meaning:
      "đào cây cối lên để chuyển đi nơi khác: cái cây to được đánh nguyên cả gốc",
    example: "cái cây to được đánh nguyên cả gốc",
  },
  {
    word: "đánh",
    part_of_speech: "động từ",
    meaning:
      "làm cho nội dung thông tin được truyền đi: đánh điện * đánh thư về cho gia đình",
    example: "đánh điện * đánh thư về cho gia đình",
  },
  {
    word: "đánh",
    part_of_speech: "động từ",
    meaning:
      "làm cho người, động vật phải chịu tác động của một chất độc hại hoặc của tà thuật: đánh thuốc độc * đánh bả chuột",
    example: "đánh thuốc độc * đánh bả chuột",
  },
  {
    word: "đánh",
    part_of_speech: "động từ",
    meaning: "làm cho sa vào lưới, bẫy để bắt: đánh cá * đánh bẫy * đánh chông",
    example: "đánh cá * đánh bẫy * đánh chông",
  },
  {
    word: "đánh",
    part_of_speech: "động từ",
    meaning:
      "làm cho trở thành cái, điều mà lẽ ra không phải như thế: loại một nhưng bị đánh xuống loại hai",
    example: "loại một nhưng bị đánh xuống loại hai",
  },
  {
    word: "đánh",
    part_of_speech: "động từ",
    meaning:
      "từ biểu đạt một hành vi, một hoạt động do sơ suất, không may mà xảy ra: đánh rơi tập tài liệu xuống đất * nhỡ tay đánh vỡ cái bát",
    example: "đánh rơi tập tài liệu xuống đất * nhỡ tay đánh vỡ cái bát",
  },
  {
    word: "đánh",
    part_of_speech: "động từ",
    meaning:
      "diễn ra một hành vi, một hoạt động nào đó một cách có ý thức: đánh lạc hướng * đánh thông tư tưởng",
    example: "đánh lạc hướng * đánh thông tư tưởng",
  },
  {
    word: "đánh",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) diễn ra một hành vi cụ thể thuộc sinh hoạt hằng ngày, như ăn, ngủ, mặc, v.v.: đánh chiếc quần đùi đi giữa phố * đánh liền một lúc bốn bát cơm * đánh một giấc đến sáng",
    example:
      "đánh chiếc quần đùi đi giữa phố * đánh liền một lúc bốn bát cơm * đánh một giấc đến sáng",
  },
  {
    word: "đánh",
    part_of_speech: "động từ",
    meaning:
      "làm cho phải gánh chịu (thường nói về khoản tiền thuế): đánh thuế tiêu thụ đặc biệt",
    example: "đánh thuế tiêu thụ đặc biệt",
  },
  {
    word: "đánh",
    part_of_speech: "động từ",
    meaning:
      "(sự việc) làm phát sinh đột ngột một tiếng động hoặc một trạng thái nào đó: cửa đóng đánh rầm * tiếng roi đập xuống đánh đét một cái",
    example: "cửa đóng đánh rầm * tiếng roi đập xuống đánh đét một cái",
  },
  {
    word: "đánh bạc",
    part_of_speech: "động từ",
    meaning: "chơi các trò chơi may rủi, ăn thua bằng tiền: ham đánh bạc",
    example: "ham đánh bạc",
  },
  {
    word: "đanh",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) đinh: đóng đanh",
    example: "đóng đanh",
  },
  {
    word: "đanh",
    part_of_speech: "tính từ",
    meaning:
      "rắn lại, chắc lại, có khả năng chịu tác động của lực ép mà khó biến dạng: cau đanh hạt * cơ thể ông đanh lại như đá tạc",
    example: "cau đanh hạt * cơ thể ông đanh lại như đá tạc",
  },
  {
    word: "đanh",
    part_of_speech: "tính từ",
    meaning:
      "(âm thanh) rất gọn, vang nhưng không ngân, gây cảm giác của cái gì rắn, chắc: tiếng đạn nổ rất đanh * giọng nói đanh lại, gằn từng tiếng",
    example: "tiếng đạn nổ rất đanh * giọng nói đanh lại, gằn từng tiếng",
  },
  {
    word: "đanh",
    part_of_speech: "tính từ",
    meaning:
      "có vẻ cứng rắn, lạnh lùng, không thể hiện một chút cảm xúc nào: mặt đanh lại",
    example: "mặt đanh lại",
  },
  {
    word: "đảng viên",
    part_of_speech: "danh từ",
    meaning: "người ở trong tổ chức của một chính đảng: đảng viên mới kết nạp",
    example: "đảng viên mới kết nạp",
  },
  {
    word: "đành",
    part_of_speech: "động từ",
    meaning:
      "miễn cưỡng bằng lòng, chấp thuận vì thấy không thể khác được: đuối lí nên đành im * từ chối không được, đành phải nhận",
    example: "đuối lí nên đành im * từ chối không được, đành phải nhận",
  },
  {
    word: "đành",
    part_of_speech: "động từ",
    meaning:
      'bằng lòng làm điều biết là trái với tình cảm, đạo lí: thấy tội nghiệp nên bỏ đi không đành * "Công anh tháng đợi năm chờ, Sao em dứt chỉ lìa tơ cho đành?" (ca dao)',
    example:
      'thấy tội nghiệp nên bỏ đi không đành * "Công anh tháng đợi năm chờ, Sao em dứt chỉ lìa tơ cho đành?" (ca dao)',
  },
  {
    word: "đánh bại",
    part_of_speech: "động từ",
    meaning: "đánh cho thua, cho thất bại hoàn toàn: đánh bại đối thủ",
    example: "đánh bại đối thủ",
  },
  {
    word: "đánh bài",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) dùng mánh khoé để đối phó, để né tránh (thường là khó khăn): đánh bài liều * thấy nguy liền đánh bài chuồn",
    example: "đánh bài liều * thấy nguy liền đánh bài chuồn",
  },
  {
    word: "đánh bạn",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) kết làm bạn: đánh bạn với người tốt",
    example: "đánh bạn với người tốt",
  },
  {
    word: "đánh bạo",
    part_of_speech: "động từ",
    meaning:
      "cố tỏ ra bạo dạn, dám làm những việc thường hay e ngại, rụt rè: đánh bạo ra chào * ngại, nhưng vẫn đánh bạo hỏi",
    example: "đánh bạo ra chào * ngại, nhưng vẫn đánh bạo hỏi",
  },
  {
    word: "đánh bắt",
    part_of_speech: "động từ",
    meaning:
      "đánh và bắt các loại thuỷ sản (nói khái quát): tàu đánh bắt xa bờ",
    example: "tàu đánh bắt xa bờ",
  },
  {
    word: "đánh bật",
    part_of_speech: "động từ",
    meaning:
      "làm cho bật ra khỏi vị trí, bằng sức mạnh: đánh bật các đợt phản kích của địch",
    example: "đánh bật các đợt phản kích của địch",
  },
  {
    word: "đánh bóng",
    part_of_speech: "động từ",
    meaning:
      "tạo nên các hình nổi trên mặt phẳng khi vẽ, bằng cách dùng các độ đậm nhạt khác nhau: dùng bút chì để đánh bóng",
    example: "dùng bút chì để đánh bóng",
  },
  {
    word: "đánh bóng",
    part_of_speech: "động từ",
    meaning:
      "chà xát trên bề mặt (thường có kèm theo chất tạo độ bóng) để làm cho bóng: đánh bóng đồ gỗ * đánh bóng kim loại",
    example: "đánh bóng đồ gỗ * đánh bóng kim loại",
  },
  {
    word: "đánh bạt",
    part_of_speech: "động từ",
    meaning:
      "làm cho bị át hẳn đi, bằng sức mạnh, ưu thế: gió thổi mạnh đánh bạt cả tiếng thét",
    example: "gió thổi mạnh đánh bạt cả tiếng thét",
  },
  {
    word: "đánh bộ",
    part_of_speech: "động từ",
    meaning:
      "(lực lượng quân sự) đánh nhau trên đất liền, dưới đất (không cưỡi ngựa, đi xe, v.v.): diễn tập đánh bộ * lính thuỷ đánh bộ",
    example: "diễn tập đánh bộ * lính thuỷ đánh bộ",
  },
  {
    word: "đánh cá",
    part_of_speech: "động từ",
    meaning:
      "dùng chài lưới hoặc các công cụ khác để đánh bắt tôm, cua, cá, v.v. nói chung: sống bằng nghề đánh cá * thuyền đánh cá",
    example: "sống bằng nghề đánh cá * thuyền đánh cá",
  },
  {
    word: "đánh cá",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) như đánh cuộc: đánh cá xem ai được ai thua",
    example: "đánh cá xem ai được ai thua",
  },
  {
    word: "đánh cắp",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) như ăn cắp: đánh cắp vàng bạc",
    example: "đánh cắp vàng bạc",
  },
  {
    word: "đánh chác",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) như đánh đấm (hàm ý chê): đạn không có thì đánh chác gì!",
    example: "đạn không có thì đánh chác gì!",
  },
  {
    word: "đánh cuộc",
    part_of_speech: "động từ",
    meaning:
      "cuộc với nhau, thường có tính chất ăn thua: đánh cuộc xem đội bóng nào thắng",
    example: "đánh cuộc xem đội bóng nào thắng",
  },
  {
    word: "đanh đá",
    part_of_speech: "tính từ",
    meaning:
      "(người phụ nữ) quá quắt, ghê gớm, không biết điều, không chịu nhịn ai: người đàn bà đanh đá",
    example: "người đàn bà đanh đá",
  },
  {
    word: "đánh chén",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) ăn uống một cách thoải mái: đánh chén một bữa no say",
    example: "đánh chén một bữa no say",
  },
  {
    word: "đánh chén",
    part_of_speech: "động từ",
    meaning: "(hành động) rửa: đánh chén rửa ấm chén",
    example: "đánh chén rửa ấm chén",
  },
  {
    word: "đánh dấu",
    part_of_speech: "động từ",
    meaning:
      "làm một dấu hiệu để dễ nhận ra khi cần: dùng bút đỏ đánh dấu trên bản đồ * cắm cọc đánh dấu",
    example: "dùng bút đỏ đánh dấu trên bản đồ * cắm cọc đánh dấu",
  },
  {
    word: "đánh dấu",
    part_of_speech: "động từ",
    meaning:
      "(việc hoặc sự kiện) mang dấu ấn rõ nét, được coi là mốc làm nổi bật một sự chuyển biến quan trọng sau đó: tác phẩm đánh dấu bước trưởng thành của tác giả",
    example: "tác phẩm đánh dấu bước trưởng thành của tác giả",
  },
  {
    word: "đành đạch",
    part_of_speech: "phụ từ",
    meaning:
      "từ mô phỏng tiếng giãy đập liên tiếp bằng cả toàn thân trên một bề mặt cứng: cá giẫy đành đạch",
    example: "cá giẫy đành đạch",
  },
  {
    word: "đánh đá",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ, hiếm) như đánh đấm: đánh đá thùm thụp",
    example: "đánh đá thùm thụp",
  },
  {
    word: "đánh đập",
    part_of_speech: "động từ",
    meaning: "đánh để hành hạ, trừng phạt (nói khái quát): bị đánh đập dã man",
    example: "bị đánh đập dã man",
  },
  {
    word: "đánh đầu",
    part_of_speech: "động từ",
    meaning: "chơi bóng bằng đầu (trong bóng đá): đánh đầu đưa bóng vào lưới",
    example: "đánh đầu đưa bóng vào lưới",
  },
  {
    word: "đánh đấm",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đánh nhau (nói khái quát; thường hàm ý chê): oắt con thì đánh đấm gì! * chẳng can dự gì vào chuyện đánh đấm",
    example: "oắt con thì đánh đấm gì! * chẳng can dự gì vào chuyện đánh đấm",
  },
  {
    word: "đánh đòn",
    part_of_speech: "động từ",
    meaning: "dùng roi vọt để trừng phạt, răn dạy: hư nên bị mẹ đánh đòn",
    example: "hư nên bị mẹ đánh đòn",
  },
  {
    word: "đánh đố",
    part_of_speech: "động từ",
    meaning:
      "đưa ra để đố, để thử thách hoặc để thách thức: ra đề như thế khác nào đánh đố học sinh",
    example: "ra đề như thế khác nào đánh đố học sinh",
  },
  {
    word: "đánh đổi",
    part_of_speech: "động từ",
    meaning:
      "đem (thường là cái quý giá) ra đổi cho bằng được cái mình cần, mình muốn, bất chấp hơn thiệt: hạnh phúc phải đánh đổi bằng xương máu",
    example: "hạnh phúc phải đánh đổi bằng xương máu",
  },
  {
    word: "đánh động",
    part_of_speech: "động từ",
    meaning:
      "ngầm làm cho biết là đã xảy ra sự việc cần đề phòng, để kịp đối phó: thấy có chuyện, liền đánh động cho đồng bọn",
    example: "thấy có chuyện, liền đánh động cho đồng bọn",
  },
  {
    word: "đánh đổ",
    part_of_speech: "động từ",
    meaning:
      "làm đổ chất lỏng hay vật rời ra khỏi vật chứa, hoặc làm đổ vật đang ở tư thế đứng: đánh đổ cốc nước",
    example: "đánh đổ cốc nước",
  },
  {
    word: "đánh đổ",
    part_of_speech: "động từ",
    meaning:
      "làm cho sụp đổ, cho không còn chỗ đứng: đánh đổ chế độ phong kiến",
    example: "đánh đổ chế độ phong kiến",
  },
  {
    word: "đánh đông dẹp bắc",
    part_of_speech: "",
    meaning:
      'đánh giặc hết nơi này đến nơi khác và lập được nhiều chiến công to lớn: "Làm quan giúp nước phò vương, Đánh đông dẹp bắc như gương để đời." (MPXH)',
    example:
      'Làm quan giúp nước phò vương, Đánh đông dẹp bắc như gương để đời." (MPXH)',
  },
  {
    word: "đánh đồng",
    part_of_speech: "động từ",
    meaning:
      "đánh giá như nhau, không phân biệt những mặt khác nhau về căn bản: đánh đồng người tốt với kẻ xấu",
    example: "đánh đồng người tốt với kẻ xấu",
  },
  {
    word: "đánh đu",
    part_of_speech: "động từ",
    meaning: "như đu (ngI): khỉ đánh đu trên cây",
    example: "khỉ đánh đu trên cây",
  },
  {
    word: "đánh đuổi",
    part_of_speech: "động từ",
    meaning: "đánh và đuổi đi: đánh đuổi giặc ngoại xâm",
    example: "đánh đuổi giặc ngoại xâm",
  },
  {
    word: "đánh đường",
    part_of_speech: "động từ",
    meaning:
      '(khẩu ngữ) tự tìm đường và đi đến một cách vất vả, khó khăn, do xa xôi hoặc có nhiều trở ngại: "Nàng rằng: Quãng vắng đêm trường, Vì hoa, nên phải đánh đường tìm hoa." (TKiều)',
    example:
      'Nàng rằng: Quãng vắng đêm trường, Vì hoa, nên phải đánh đường tìm hoa." (TKiều)',
  },
  {
    word: "đánh đùng",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ, hiếm) như đánh đùng một cái: đang tươi cười, bỗng đánh đùng cau mặt giận",
    example: "đang tươi cười, bỗng đánh đùng cau mặt giận",
  },
  {
    word: "đánh ghen",
    part_of_speech: "động từ",
    meaning:
      'nổi cơn ghen bằng những hành động thô bạo (với đối thủ): đi đánh ghen * "Lạ gì bỉ sắc tư phong, Trời xanh quen thói má hồng đánh ghen." (TKiều)',
    example:
      'đi đánh ghen * "Lạ gì bỉ sắc tư phong, Trời xanh quen thói má hồng đánh ghen." (TKiều)',
  },
  {
    word: "đánh đụng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) chung nhau cùng mổ thịt lợn, bò, v.v. để chia ăn: hai nhà đánh đụng một con chó",
    example: "hai nhà đánh đụng một con chó",
  },
  {
    word: "đánh đùng một cái",
    part_of_speech: "phụ từ",
    meaning:
      '(khẩu ngữ) zđột nhiên, hết sức bất ngờ, không ai nghĩ tới: "Thưa quan, ngày nọ con có tiền đến nộp quan, thì quan không thu cho, bây giờ đánh đùng một cái, quan hỏi, con làm gì có." (NgCHoan; 4)',
    example:
      'Thưa quan, ngày nọ con có tiền đến nộp quan, thì quan không thu cho, bây giờ đánh đùng một cái, quan hỏi, con làm gì có." (NgCHoan; 4)',
  },
  {
    word: "đánh giá",
    part_of_speech: "động từ",
    meaning: "ước tính giá tiền: đánh giá tài sản",
    example: "đánh giá tài sản",
  },
  {
    word: "đánh giá",
    part_of_speech: "động từ",
    meaning:
      "nhận định giá trị: bị đánh giá là không đứng đắn * bài viết được đánh giá cao",
    example: "bị đánh giá là không đứng đắn * bài viết được đánh giá cao",
  },
  {
    word: "đánh giáp lá cà",
    part_of_speech: "động từ",
    meaning:
      "đánh gần bằng báng súng, lưỡi lê, dao găm, gươm giáo, gậy gộc, v.v., hoặc bằng tay không: hai bên xông vào đánh giáp lá cà",
    example: "hai bên xông vào đánh giáp lá cà",
  },
  {
    word: "đánh gục",
    part_of_speech: "động từ",
    meaning:
      "làm cho thất bại hoàn toàn, cho không thể ngóc đầu dậy được nữa: đánh gục một tổ chức phản động * đánh gục đối phương",
    example: "đánh gục một tổ chức phản động * đánh gục đối phương",
  },
  {
    word: "đánh hôi",
    part_of_speech: "động từ",
    meaning:
      "lợi dụng lúc có vụ đánh nhau xông vào đánh người mình vốn ghét từ trước (hàm ý chê): thấy có xô xát, bọn lưu manh nhảy vào đánh hôi",
    example: "thấy có xô xát, bọn lưu manh nhảy vào đánh hôi",
  },
  {
    word: "đành hanh",
    part_of_speech: "tính từ",
    meaning:
      "(trẻ em hoặc phụ nữ trẻ) ngang bướng, luôn đòi cho mình phải được hơn người một cách vô lí: đứa trẻ đành hanh",
    example: "đứa trẻ đành hanh",
  },
  {
    word: "đành hanh",
    part_of_speech: "tính từ",
    meaning:
      "(cũ, hiếm) hay gây những chuyện ngang trái, oái oăm: “Trẻ tạo hoá đành hanh quá ngán, Chết đuối người trên cạn mà chơi.” (CO)",
    example:
      "“Trẻ tạo hoá đành hanh quá ngán, Chết đuối người trên cạn mà chơi.” (CO)",
  },
  {
    word: "đành hanh đành hói",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) như đành hanh (ng1; nhưng ý nhấn mạnh hơn): tính đành hanh đành hói",
    example: "tính đành hanh đành hói",
  },
  {
    word: "đành lòng",
    part_of_speech: "động từ",
    meaning:
      "nén lòng chịu đựng làm việc gì một cách bất đắc dĩ: đành lòng ngồi đợi * đành lòng chấp nhận",
    example: "đành lòng ngồi đợi * đành lòng chấp nhận",
  },
  {
    word: "đành lòng",
    part_of_speech: "động từ",
    meaning:
      "bằng lòng làm điều biết là không có tình người: không đành lòng bỏ bạn lúc hiểm nguy",
    example: "không đành lòng bỏ bạn lúc hiểm nguy",
  },
  {
    word: "đánh hỏng",
    part_of_speech: "động từ",
    meaning:
      "đánh trượt trong kì thi (mặc dù thực tế có thể đỗ): bài thi bị đánh hỏng",
    example: "bài thi bị đánh hỏng",
  },
  {
    word: "đánh hơi",
    part_of_speech: "động từ",
    meaning:
      "(động vật) ngửi mùi mà phân biệt để nhận ra có cái gì, hoặc tìm ra cái đang muốn tìm: chó đánh hơi",
    example: "chó đánh hơi",
  },
  {
    word: "đánh hơi",
    part_of_speech: "động từ",
    meaning:
      "nhận thấy một số dấu hiệu mà đoán ra, phát hiện ra điều gì đó (thường hàm ý khinh): bọn lính đã đánh hơi được người cán bộ nằm vùng * đánh hơi thấy một món hời",
    example:
      "bọn lính đã đánh hơi được người cán bộ nằm vùng * đánh hơi thấy một món hời",
  },
  {
    word: "đánh liều",
    part_of_speech: "động từ",
    meaning:
      "đành chấp nhận phải liều để làm cho được một việc gì (vì không còn cách nào khác): sợ nhưng cũng đánh liều vào * đánh liều ra hỏi",
    example: "sợ nhưng cũng đánh liều vào * đánh liều ra hỏi",
  },
  {
    word: "đánh lận con đen",
    part_of_speech: "",
    meaning:
      'đánh lừa bằng mánh khoé gian giảo, xảo quyệt: "Mập mờ đánh lận con đen, Bao nhiêu cũng bấy nhiêu tiền, mất chi?" (TKiều)',
    example:
      'Mập mờ đánh lận con đen, Bao nhiêu cũng bấy nhiêu tiền, mất chi?" (TKiều)',
  },
  {
    word: "đánh lộn",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) đánh nhau: tụi nhỏ đánh lộn nhau",
    example: "tụi nhỏ đánh lộn nhau",
  },
  {
    word: "đánh lừa",
    part_of_speech: "động từ",
    meaning: "làm cho bị mắc lừa: bày mưu đánh lừa * đánh lừa dư luận",
    example: "bày mưu đánh lừa * đánh lừa dư luận",
  },
  {
    word: "đánh nhịp",
    part_of_speech: "động từ",
    meaning:
      "làm các động tác đều đặn, thường là để phát ra các âm thanh để cho rõ các nhịp của một bản nhạc, bài hát: vừa hát vừa vỗ tay đánh nhịp",
    example: "vừa hát vừa vỗ tay đánh nhịp",
  },
  {
    word: "đánh mùi",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) như đánh hơi: chó đánh mùi",
    example: "chó đánh mùi",
  },
  {
    word: "đánh phá",
    part_of_speech: "động từ",
    meaning:
      "dùng binh lực, hoả lực để phá hoại, huỷ hoại (nói khát quát): giặc đánh phá miền Bắc",
    example: "giặc đánh phá miền Bắc",
  },
  {
    word: "đánh phấn",
    part_of_speech: "động từ",
    meaning: "xoa phấn vào da mặt để trang điểm: mặt đánh phấn",
    example: "mặt đánh phấn",
  },
  {
    word: "đành rành",
    part_of_speech: "tính từ",
    meaning: "(cũ, hoặc ph) như rành rành: chứng cứ đã đành rành",
    example: "chứng cứ đã đành rành",
  },
  {
    word: "đánh máy",
    part_of_speech: "động từ",
    meaning:
      "in chữ trên giấy bằng máy chữ; đánh máy chữ hoặc đánh máy tính (nói tắt): nhân viên đánh máy",
    example: "nhân viên đánh máy",
  },
  {
    word: "đánh nguội",
    part_of_speech: "động từ",
    meaning:
      "đánh lén cầu thủ đối phương trong trường hợp không có tranh chấp bóng (một lỗi nặng trong thi đấu bóng đá): bị thẻ đỏ vì lỗi đánh nguội",
    example: "bị thẻ đỏ vì lỗi đánh nguội",
  },
  {
    word: "đành rằng",
    part_of_speech: "",
    meaning:
      "như đã đành: đành rằng cháu còn bé, nhưng cũng phải theo nội quy của trường",
    example: "đành rằng cháu còn bé, nhưng cũng phải theo nội quy của trường",
  },
  {
    word: "đánh rơi",
    part_of_speech: "động từ",
    meaning:
      'để cho bị rơi hoặc bị mất do vô ý: đánh rơi mất cái ví * "Bồng bồng cõng chồng đi chơi, Đi đến chỗ lội đánh rơi mất chồng." (ca dao)',
    example:
      'đánh rơi mất cái ví * "Bồng bồng cõng chồng đi chơi, Đi đến chỗ lội đánh rơi mất chồng." (ca dao)',
  },
  {
    word: "đánh tháo",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tìm cách làm cho thoát khỏi tình trạng bị giam cầm, bị bao vây (thường hàm ý chê): đánh tháo khỏi trại giam",
    example: "đánh tháo khỏi trại giam",
  },
  {
    word: "đánh tháo",
    part_of_speech: "động từ",
    meaning:
      "làm cho thoát khỏi sự ràng buộc của lời hứa (thường trong việc mua bán): đã đồng ý bán rồi lại đánh tháo",
    example: "đã đồng ý bán rồi lại đánh tháo",
  },
  {
    word: "đánh số",
    part_of_speech: "động từ",
    meaning: "đánh dấu bằng số thứ tự: tập tài liệu có đánh số hẳn hoi",
    example: "tập tài liệu có đánh số hẳn hoi",
  },
  {
    word: "đánh thức",
    part_of_speech: "động từ",
    meaning:
      "làm cho tỉnh giấc, cho thức dậy: để chuông đánh thức * đánh thức lòng yêu nước (b)",
    example: "để chuông đánh thức * đánh thức lòng yêu nước (b)",
  },
  {
    word: "đánh tiếng",
    part_of_speech: "động từ",
    meaning:
      "cất tiếng để báo cho người khác biết là có người: đánh tiếng từ ngoài sân * lặng lẽ đi vào, không dám đánh tiếng",
    example: "đánh tiếng từ ngoài sân * lặng lẽ đi vào, không dám đánh tiếng",
  },
  {
    word: "đánh tiếng",
    part_of_speech: "động từ",
    meaning:
      "làm cho người khác biết được ý mình một cách gián tiếp (thường thông qua một người trung gian): đánh tiếng muốn bán ruộng * nhờ người đánh tiếng mai mối",
    example: "đánh tiếng muốn bán ruộng * nhờ người đánh tiếng mai mối",
  },
  {
    word: "đanh thép",
    part_of_speech: "tính từ",
    meaning:
      "cứng rắn, vững vàng, không gì lay chuyển được (nói về tinh thần): quyết tâm đanh thép * một người đanh thép",
    example: "quyết tâm đanh thép * một người đanh thép",
  },
  {
    word: "đanh thép",
    part_of_speech: "tính từ",
    meaning:
      "(lập luận, lời nói, v.v.) có cơ sở, lí lẽ vững vàng, sắc sảo, không thể bác bỏ được: lập luận đanh thép * lời buộc tội đanh thép",
    example: "lập luận đanh thép * lời buộc tội đanh thép",
  },
  {
    word: "đánh tráo",
    part_of_speech: "động từ",
    meaning:
      "dùng mánh khoé gian lận để thay thế một cách khéo léo: đánh tráo bài thi",
    example: "đánh tráo bài thi",
  },
  {
    word: "đánh tiêu hao",
    part_of_speech: "động từ",
    meaning:
      "tác chiến với mục đích làm hao tổn về sinh lực, vũ khí và các phương tiện chiến đấu khác của đối phương để góp phần tiêu diệt lực lượng lớn hơn sau đó: đánh tiêu hao sinh lực địch",
    example: "đánh tiêu hao sinh lực địch",
  },
  {
    word: "đánh trống lấp",
    part_of_speech: "",
    meaning:
      "nói lớn tiếng hoặc làm ồn lên để cho át đi, để mọi người không còn có thể chú ý đến câu chuyện đang được nói đến: cười đánh trống lấp",
    example: "cười đánh trống lấp",
  },
  {
    word: "đánh trống lảng",
    part_of_speech: "",
    meaning:
      "lảng đi, nói sang chuyện khác để tránh khỏi phải nói đến việc không muốn nói hoặc khó nói: ai mà hỏi đến thì nó tìm cách đánh trống lảng * chỉ khéo đánh trống lảng!",
    example:
      "ai mà hỏi đến thì nó tìm cách đánh trống lảng * chỉ khéo đánh trống lảng!",
  },
  {
    word: "đánh vần",
    part_of_speech: "động từ",
    meaning:
      "đọc từng con chữ rồi ghép lại thành vần, thành tiếng: bé tập đánh vần",
    example: "bé tập đánh vần",
  },
  {
    word: "đánh vận động",
    part_of_speech: "động từ",
    meaning:
      "đem hết sức ra để đối phó lại một cách vất vả: đánh vật với đống quần áo bẩn",
    example: "đánh vật với đống quần áo bẩn",
  },
  {
    word: "đánh võng",
    part_of_speech: "động từ",
    meaning:
      "đánh tay lái sang hai bên, làm cho xe chao nghiêng, đảo qua đảo lại như đưa võng trên đường: cấm đánh võng, lạng lách trên đường phố",
    example: "cấm đánh võng, lạng lách trên đường phố",
  },
  {
    word: "đảo",
    part_of_speech: "danh từ",
    meaning:
      "khoảng, vùng đất rộng có nước bao quanh ở sông, hồ, biển: hòn đảo * đảo Cát Bà",
    example: "hòn đảo * đảo Cát Bà",
  },
  {
    word: "đảo",
    part_of_speech: "động từ",
    meaning:
      "làm đổi ngược vị trí trước sau hoặc trên dưới: đảo vị trí cho nhau * đảo đều nồi cơm cho chín",
    example: "đảo vị trí cho nhau * đảo đều nồi cơm cho chín",
  },
  {
    word: "đảo",
    part_of_speech: "động từ",
    meaning:
      "di chuyển qua lại hoặc lên xuống nhanh thành một vòng, có ý tìm kiếm, xem xét: chiếc máy bay đảo mấy vòng rồi biến mất * mắt đảo liên tục",
    example: "chiếc máy bay đảo mấy vòng rồi biến mất * mắt đảo liên tục",
  },
  {
    word: "đảo",
    part_of_speech: "động từ",
    meaning:
      "mất thế thăng bằng, hết nghiêng sang bên này rồi lại nghiêng sang bên kia: thuyền đảo hẳn đi",
    example: "thuyền đảo hẳn đi",
  },
  {
    word: "đảo",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) đến rồi đi ngay, thường tranh thủ kết hợp khi đang làm việc gì: đi công tác, tranh thủ đảo qua nhà",
    example: "đi công tác, tranh thủ đảo qua nhà",
  },
  {
    word: "đào",
    part_of_speech: "danh từ",
    meaning:
      "cây ăn quả hoặc làm cảnh, cùng họ với lê, mận, hoa màu đỏ hồng, quả hình tim và có lông mượt phủ bên ngoài: quả đào * cành đào ngày Tết",
    example: "quả đào * cành đào ngày Tết",
  },
  {
    word: "đào",
    part_of_speech: "tính từ",
    meaning:
      '(Văn chương) có màu hồng hoặc màu đỏ tươi: má đào * "Thân em như tấm lụa đào, Phất phơ giữa chợ biết vào tay ai?" (Cdao)',
    example:
      'má đào * "Thân em như tấm lụa đào, Phất phơ giữa chợ biết vào tay ai?" (Cdao)',
  },
  {
    word: "đào",
    part_of_speech: "danh từ",
    meaning:
      "(Từ cũ) diễn viên nữ trong các ngành sân khấu, điện ảnh thời trước (dùng với ý không coi trọng): cô đào điện ảnh",
    example: "cô đào điện ảnh",
  },
  {
    word: "đào",
    part_of_speech: "động từ",
    meaning:
      "lấy lên một khối lượng đất đá để tạo thành một khoảng trống sâu xuống hoặc để tìm lấy vật gì ở dưới lòng đất: đào củ mài * ra đào hầm tránh đạn",
    example: "đào củ mài * ra đào hầm tránh đạn",
  },
  {
    word: "đào",
    part_of_speech: "động từ",
    meaning: "(Khẩu ngữ) tìm, kiếm được: đào đâu ra tiền bây giờ?",
    example: "đào đâu ra tiền bây giờ?",
  },
  {
    word: "đáo",
    part_of_speech: "danh từ",
    meaning:
      "trò chơi của trẻ em, ném đồng tiền hoặc vật tương tự vào một cái đích đã được định sẵn (tuỳ theo từng vùng mà có những quy định khác nhau): lỗ đáo * chơi đánh đáo",
    example: "lỗ đáo * chơi đánh đáo",
  },
  {
    word: "đào bới",
    part_of_speech: "động từ",
    meaning:
      "đào và bới để tìm kiếm cái gì (nói khái quát): quanh bờ ao nham nhở vết đào bới",
    example: "quanh bờ ao nham nhở vết đào bới",
  },
  {
    word: "đao",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ) củ đao (nói tắt): bột đao",
    example: "bột đao",
  },
  {
    word: "đao",
    part_of_speech: "danh từ",
    meaning: "dao to, mũi thường cong lên, dùng làm binh khí thời xưa.",
    example: "đao đình",
  },
  {
    word: "đạo",
    part_of_speech: "danh từ",
    meaning:
      "(Từ cũ) từ dùng để chỉ từng đơn vị cánh quân lớn hành động độc lập, thời xưa: đội quân chia làm hai đạo",
    example: "đội quân chia làm hai đạo",
  },
  {
    word: "đạo",
    part_of_speech: "danh từ",
    meaning:
      "(Từ cũ, Trang trọng) từ dùng để chỉ từng đơn vị văn kiện quan trọng của nhà nước: đạo nghị định",
    example: "đạo nghị định",
  },
  {
    word: "đạo",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị vật mà người theo tôn giáo tin là có phép lạ của thần linh: đạo bùa",
    example: "đạo bùa",
  },
  {
    word: "đạo",
    part_of_speech: "danh từ",
    meaning:
      'đường lối, nguyên tắc mà con người có bổn phận giữ gìn và tuân theo trong cuộc sống xã hội (thường theo quan niệm cũ): "Xưa nay trong đạo đàn bà, Chữ Trinh kia cũng có ba bảy đường." (TKiều)',
    example:
      'Xưa nay trong đạo đàn bà, Chữ Trinh kia cũng có ba bảy đường." (TKiều)',
  },
  {
    word: "đạo",
    part_of_speech: "danh từ",
    meaning:
      "(Từ cũ) nội dung học thuật của một học thuyết được tôn sùng: đạo thánh hiền * tầm sư học đạo (tng)",
    example: "đạo thánh hiền * tầm sư học đạo (tng)",
  },
  {
    word: "đạo",
    part_of_speech: "danh từ",
    meaning: "tổ chức tôn giáo: đạo Phật * đạo Thiên Chúa * đạo Hồi",
    example: "đạo Phật * đạo Thiên Chúa * đạo Hồi",
  },
  {
    word: "đạo",
    part_of_speech: "danh từ",
    meaning: "(Khẩu ngữ) đạo Thiên Chúa (nói tắt): nhà thờ đạo * dân theo đạo",
    example: "nhà thờ đạo * dân theo đạo",
  },
  {
    word: "đạo",
    part_of_speech: "động từ",
    meaning:
      "lấy, hoặc căn bản lấy sáng tác của người khác làm thành của mình: đạo văn * đạo thơ * đạo nhạc",
    example: "đạo văn * đạo thơ * đạo nhạc",
  },
  {
    word: "đạo chích",
    part_of_speech: "danh từ",
    meaning: "(cũ, hiếm) kẻ cắp, kẻ trộm: bọn đạo chích",
    example: "bọn đạo chích",
  },
  {
    word: "đảo chính",
    part_of_speech: "động từ",
    meaning:
      "lật đổ chính phủ một cách đột ngột và trái hiến pháp, thường do một phe phái hay một nhóm người vốn là thành viên trong chính phủ đó tiến hành: âm mưu đảo chính * cuộc đảo chính",
    example: "âm mưu đảo chính * cuộc đảo chính",
  },
  {
    word: "đảo chính",
    part_of_speech: "danh từ",
    meaning: "cuộc đảo chính: dập tắt đảo chính",
    example: "dập tắt đảo chính",
  },
  {
    word: "đạo diễn",
    part_of_speech: "động từ",
    meaning:
      "chỉ huy, sắp xếp và hướng dẫn toàn bộ công việc diễn xuất, trong nghệ thuật điện ảnh, sân khấu: đạo diễn một bộ phim truyền hình",
    example: "đạo diễn một bộ phim truyền hình",
  },
  {
    word: "đạo diễn",
    part_of_speech: "danh từ",
    meaning: "người làm việc đạo diễn: giải thưởng dành cho đạo diễn xuất sắc",
    example: "giải thưởng dành cho đạo diễn xuất sắc",
  },
  {
    word: "đạo cụ",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ để biểu diễn của diễn viên hoặc để trang trí trên sân khấu: chuẩn bị đạo cụ cho đêm diễn",
    example: "chuẩn bị đạo cụ cho đêm diễn",
  },
  {
    word: "đáo để",
    part_of_speech: "tính từ",
    meaning:
      "quá quắt trong đối xử, không chịu thua kém, nhường nhịn bất cứ ai: con bé đáo để lắm",
    example: "con bé đáo để lắm",
  },
  {
    word: "đáo để",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) quá chừng, hết sức: xinh đáo để * trông thế nhưng mà ngon đáo để",
    example: "xinh đáo để * trông thế nhưng mà ngon đáo để",
  },
  {
    word: "đảo điên",
    part_of_speech: "tính từ",
    meaning: "làm thay đổi, xáo trộn hoàn toàn: thời thế đảo điên",
    example: "thời thế đảo điên",
  },
  {
    word: "đảo điên",
    part_of_speech: "tính từ",
    meaning:
      "tráo trở, hay lừa đảo, lật lọng: ăn ở đảo điên * con người đảo điên",
    example: "ăn ở đảo điên * con người đảo điên",
  },
  {
    word: "đạo đức",
    part_of_speech: "danh từ",
    meaning:
      "những tiêu chuẩn, nguyên tắc được dư luận xã hội thừa nhận, quy định hành vi, quan hệ của con người đối với nhau và đối với xã hội (nói tổng quát): đạo đức cách mạng * đạo đức nghề nghiệp",
    example: "đạo đức cách mạng * đạo đức nghề nghiệp",
  },
  {
    word: "đạo đức",
    part_of_speech: "danh từ",
    meaning:
      "phẩm chất tốt đẹp của con người do tu dưỡng theo những tiêu chuẩn nhất định mà có: tha hoá đạo đức * một con người thiếu đạo đức",
    example: "tha hoá đạo đức * một con người thiếu đạo đức",
  },
  {
    word: "đao cung",
    part_of_speech: "danh từ",
    meaning:
      'đao và cung, binh khí thời xưa (nói khái quát): "Chàng tuổi trẻ vốn dòng hào kiệt, Xếp bút nghiên theo việc đao cung." (CPN)',
    example:
      'Chàng tuổi trẻ vốn dòng hào kiệt, Xếp bút nghiên theo việc đao cung." (CPN)',
  },
  {
    word: "đào hoa",
    part_of_speech: "tính từ",
    meaning: "(đàn ông) có duyên, được nhiều phụ nữ yêu mến: số đào hoa",
    example: "số đào hoa",
  },
  {
    word: "đạo hạnh",
    part_of_speech: "danh từ",
    meaning:
      "phẩm chất và tư cách tốt đẹp ở con người (thường là người theo tôn giáo nào đó): một nhà nho đạo hạnh",
    example: "một nhà nho đạo hạnh",
  },
  {
    word: "đáo hạn",
    part_of_speech: "động từ",
    meaning: "đến thời hạn phải trả nợ, phải thanh toán: thanh toán nợ đáo hạn",
    example: "thanh toán nợ đáo hạn",
  },
  {
    word: "đạo hiếu",
    part_of_speech: "danh từ",
    meaning:
      "đạo làm con, lấy sự hiếu thảo với cha mẹ làm nguyên tắc phải giữ gìn và tuân theo: giữ tròn đạo hiếu",
    example: "giữ tròn đạo hiếu",
  },
  {
    word: "đảo lộn",
    part_of_speech: "động từ",
    meaning:
      "làm cho thay đổi hoàn toàn, không theo trật tự nào cả: cuộc sống gia đình bị đảo lộn",
    example: "cuộc sống gia đình bị đảo lộn",
  },
  {
    word: "đạo lí",
    part_of_speech: "danh từ",
    meaning:
      "cái lẽ hợp với khuôn phép, đạo đức ở đời: đạo lí làm người * hiểu thấu đạo lí * một hành vi trái với đạo lí",
    example:
      "đạo lí làm người * hiểu thấu đạo lí * một hành vi trái với đạo lí",
  },
  {
    word: "đạo lý",
    part_of_speech: "danh từ",
    meaning:
      "cái lẽ hợp với khuôn phép, đạo đức ở đời: đạo lí làm người * hiểu thấu đạo lí * một hành vi trái với đạo lí",
    example:
      "đạo lí làm người * hiểu thấu đạo lí * một hành vi trái với đạo lí",
  },
  {
    word: "đào lộn hột",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) điều: trồng đào lộn hột",
    example: "trồng đào lộn hột",
  },
  {
    word: "đạo luật",
    part_of_speech: "danh từ",
    meaning:
      "văn bản pháp luật của nhà nước ban hành: đạo luật chống độc quyền",
    example: "đạo luật chống độc quyền",
  },
  {
    word: "đào ngũ",
    part_of_speech: "động từ",
    meaning:
      "(quân nhân) tự ý rời bỏ đơn vị quân đội mà mình đang phục vụ: lính đào ngũ",
    example: "lính đào ngũ",
  },
  {
    word: "đạo nghĩa",
    part_of_speech: "danh từ",
    meaning:
      "điều hợp với đạo đức và lẽ phải ở đời: đạo nghĩa vợ chồng * làm trái đạo nghĩa",
    example: "đạo nghĩa vợ chồng * làm trái đạo nghĩa",
  },
  {
    word: "đạo mạo",
    part_of_speech: "tính từ",
    meaning:
      "có vẻ nghiêm trang, đứng đắn với một phong thái mẫu mực: dáng người đạo mạo * nói năng đạo mạo",
    example: "dáng người đạo mạo * nói năng đạo mạo",
  },
  {
    word: "đào nguyên",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) nơi tiên ở; thường dùng để ví nơi có cảnh đẹp, có người đẹp ở: "Chào mừng đón hỏi dò la, Đào nguyên lạc lối đâu mà đến đây?" (TKiều)',
    example:
      'Chào mừng đón hỏi dò la, Đào nguyên lạc lối đâu mà đến đây?" (TKiều)',
  },
  {
    word: "đảo ngũ",
    part_of_speech: "động từ",
    meaning: "như đào ngũ: lính đảo ngũ",
    example: "lính đảo ngũ",
  },
  {
    word: "đào mỏ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) moi tiền của người khác (thường bằng cách lấy con gái nhà giàu; hàm ý khinh): kẻ đào mỏ",
    example: "kẻ đào mỏ",
  },
  {
    word: "đảo ngược",
    part_of_speech: "động từ",
    meaning: "thay đổi ngược lại hoàn toàn: trật tự bị đảo ngược",
    example: "trật tự bị đảo ngược",
  },
  {
    word: "đáo nợ",
    part_of_speech: "động từ",
    meaning: "như đảo nợ: vay mượn để đáo nợ trái phiếu đến hạn",
    example: "vay mượn để đáo nợ trái phiếu đến hạn",
  },
  {
    word: "đạo pháp",
    part_of_speech: "danh từ",
    meaning: "nguyên tắc của tôn giáo: buổi thuyết giảng về đạo pháp",
    example: "buổi thuyết giảng về đạo pháp",
  },
  {
    word: "đào sâu",
    part_of_speech: "động từ",
    meaning:
      "cố gắng tập trung nghiên cứu, đi vào chiều sâu về mặt nhận thức: vấn đề cần được đào sâu",
    example: "vấn đề cần được đào sâu",
  },
  {
    word: "đào thải",
    part_of_speech: "động từ",
    meaning:
      "loại bỏ ra khỏi môi trường nào đó, do không có tác dụng hoặc do không đáp ứng được các tiêu chuẩn cần thiết: cơ thể đào thải chất độc",
    example: "cơ thể đào thải chất độc",
  },
  {
    word: "đạo tặc",
    part_of_speech: "danh từ",
    meaning: "(cũ) bọn trộm cướp: bọn đạo tặc",
    example: "bọn đạo tặc",
  },
  {
    word: "đảo quốc",
    part_of_speech: "danh từ",
    meaning:
      "quốc gia có lãnh thổ nằm trên những hòn đảo (xung quanh là biển): Singapore là một đảo quốc",
    example: "Singapore là một đảo quốc",
  },
  {
    word: "đào tạo",
    part_of_speech: "động từ",
    meaning:
      "làm cho trở thành người có năng lực, có khả năng làm việc theo những tiêu chuẩn nhất định: đào tạo cán bộ * đào tạo tay nghề",
    example: "đào tạo cán bộ * đào tạo tay nghề",
  },
  {
    word: "đào xới",
    part_of_speech: "động từ",
    meaning: "đào lên, xới lên (nói khái quát): mặt sân bị đào xới lỗ chỗ",
    example: "mặt sân bị đào xới lỗ chỗ",
  },
  {
    word: "đáp",
    part_of_speech: "động từ",
    meaning:
      "hạ xuống và dừng lại ở một vị trí nào đó, không bay nữa: đàn cò đáp xuống cánh đồng * trực thăng đáp đất",
    example: "đàn cò đáp xuống cánh đồng * trực thăng đáp đất",
  },
  {
    word: "đáp",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) ném mạnh và thẳng vào một cái đích nào đó: đáp thẳng quyển sách vào mặt hắn",
    example: "đáp thẳng quyển sách vào mặt hắn",
  },
  {
    word: "đáp",
    part_of_speech: "động từ",
    meaning:
      "đính thêm miếng vật liệu khác và khâu áp sát vào (thường nói về quần áo): đáp thêm một miếng vải vào chỗ ống quần bị rách",
    example: "đáp thêm một miếng vải vào chỗ ống quần bị rách",
  },
  {
    word: "đáp",
    part_of_speech: "động từ",
    meaning:
      "lên một phương tiện vận tải hành khách để đi tới một nơi nào đó: đáp tàu hoả lên Lạng Sơn",
    example: "đáp tàu hoả lên Lạng Sơn",
  },
  {
    word: "đáp",
    part_of_speech: "động từ",
    meaning:
      "như trả lời (ng1): đáp lại câu hỏi của bạn * kẻ hỏi người đáp * ngồi lặng im không đáp",
    example:
      "đáp lại câu hỏi của bạn * kẻ hỏi người đáp * ngồi lặng im không đáp",
  },
  {
    word: "đáp",
    part_of_speech: "động từ",
    meaning:
      "biểu thị bằng hành động, thái độ (thường là đồng tình) trước yêu cầu của người khác: đáp lời kêu gọi",
    example: "đáp lời kêu gọi",
  },
  {
    word: "đáp",
    part_of_speech: "động từ",
    meaning:
      'biểu thị bằng hành động, thái độ tương xứng với việc làm, thái độ (thường là tốt) của người khác đối với mình: mỉm cười chào đáp * "Có những tình yêu không cần đáp lại, thậm chí không cần biết đến." (NgTNTú; 1)',
    example:
      'mỉm cười chào đáp * "Có những tình yêu không cần đáp lại, thậm chí không cần biết đến." (NgTNTú; 1)',
  },
  {
    word: "đạp",
    part_of_speech: "động từ",
    meaning:
      "hoặc d đưa chân mạnh và thẳng tới, cho lòng bàn chân chạm mạnh vào: đạp đổ bức tường * đạp cửa xông vào * đạp cho một đạp",
    example: "đạp đổ bức tường * đạp cửa xông vào * đạp cho một đạp",
  },
  {
    word: "đạp",
    part_of_speech: "động từ",
    meaning:
      "đặt mạnh chân lên, làm cho chịu tác động của sức nặng toàn thân: đạp phải lựu đạn * đầu đội trời, chân đạp đất (tng)",
    example: "đạp phải lựu đạn * đầu đội trời, chân đạp đất (tng)",
  },
  {
    word: "đạp",
    part_of_speech: "động từ",
    meaning:
      "làm cho vật gì chuyển động hoặc khởi động bằng sức ấn của bàn chân: đạp xe đạp * đạp máy khâu",
    example: "đạp xe đạp * đạp máy khâu",
  },
  {
    word: "đạp",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đạp xe đạp (nói tắt): đạp vòng quanh hồ * đạp chầm chậm để ngắm cảnh phố phường",
    example: "đạp vòng quanh hồ * đạp chầm chậm để ngắm cảnh phố phường",
  },
  {
    word: "đáp án",
    part_of_speech: "danh từ",
    meaning:
      "phần giải đáp được chuẩn bị trước cho một vấn đề, thường là cho bài thi, đề thi: trả lời không đúng đáp án",
    example: "trả lời không đúng đáp án",
  },
  {
    word: "đạp bằng",
    part_of_speech: "động từ",
    meaning:
      "ví hành động vượt lên trên, khắc phục tất cả những khó khăn, trở ngại: đạp bằng chông gai tiến lên phía trước",
    example: "đạp bằng chông gai tiến lên phía trước",
  },
  {
    word: "đạp đổ",
    part_of_speech: "động từ",
    meaning: "phá đi, làm cho hỏng, cho sụp đổ: không ăn được thì đạp đổ",
    example: "không ăn được thì đạp đổ",
  },
  {
    word: "đáp từ",
    part_of_speech: "danh từ",
    meaning:
      "(trang trọng) lời đáp lại trong buổi lễ long trọng: đọc diễn văn đáp từ",
    example: "đọc diễn văn đáp từ",
  },
  {
    word: "đáp ứng",
    part_of_speech: "động từ",
    meaning:
      "đáp lại đúng theo như đòi hỏi, yêu cầu: yêu cầu không được đáp ứng",
    example: "yêu cầu không được đáp ứng",
  },
  {
    word: "đát",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) hạn sử dụng ghi trên hàng hoá (thường là hàng tiêu dùng): hàng đã quá đát * chưa hết đát mà đã hỏng",
    example: "hàng đã quá đát * chưa hết đát mà đã hỏng",
  },
  {
    word: "đáp số",
    part_of_speech: "danh từ",
    meaning: "kết quả của một bài toán: tìm không ra đáp số",
    example: "tìm không ra đáp số",
  },
  {
    word: "đạp mái",
    part_of_speech: "động từ",
    meaning: "giao cấu (chỉ nói về con trống đối với con mái): gà đạp mái",
    example: "gà đạp mái",
  },
  {
    word: "đạt",
    part_of_speech: "động từ",
    meaning:
      "đến được đích, thực hiện được mục tiêu đã đề ra: đạt danh hiệu học sinh giỏi * chưa đạt tiêu chuẩn * đạt năng suất cao",
    example:
      "đạt danh hiệu học sinh giỏi * chưa đạt tiêu chuẩn * đạt năng suất cao",
  },
  {
    word: "đạt",
    part_of_speech: "tính từ",
    meaning:
      "đúng với yêu cầu, ở mức tương đối: dùng chữ chưa đạt * bài viết như thế là đạt",
    example: "dùng chữ chưa đạt * bài viết như thế là đạt",
  },
  {
    word: "đạt lí thấu tình",
    part_of_speech: "",
    meaning: "như thấu tình đạt lí: cách giải quyết đạt lí thấu tình",
    example: "cách giải quyết đạt lí thấu tình",
  },
  {
    word: "đau",
    part_of_speech: "",
    meaning:
      "có cảm giác khó chịu ở bộ phận nào đó của cơ thể do bị tổn thương: đau nhói ở tim * đau dạ dày * đau chân do bị ngã",
    example: "đau nhói ở tim * đau dạ dày * đau chân do bị ngã",
  },
  {
    word: "đau",
    part_of_speech: "",
    meaning:
      "(phương ngữ) ốm: đau nặng đã mấy hôm * đói ăn rau, đau uống thuốc (tng)",
    example: "đau nặng đã mấy hôm * đói ăn rau, đau uống thuốc (tng)",
  },
  {
    word: "đau",
    part_of_speech: "",
    meaning:
      'ở trạng thái tinh thần, tình cảm rất khó chịu do bị mất mát hay tổn thương: lòng đau như cắt * "Chiều chiều ra đứng ngõ sau, Ngó về quê mẹ ruột đau chín chiều." (ca dao)',
    example:
      'lòng đau như cắt * "Chiều chiều ra đứng ngõ sau, Ngó về quê mẹ ruột đau chín chiều." (ca dao)',
  },
  {
    word: "đau",
    part_of_speech: "",
    meaning:
      "làm cho đau, cho tổn thương: chuyện đau lòng * miếng ngon nhớ lâu, đòn đau nhớ đời (tng)",
    example: "chuyện đau lòng * miếng ngon nhớ lâu, đòn đau nhớ đời (tng)",
  },
  {
    word: "đau đáu",
    part_of_speech: "tính từ",
    meaning:
      'ở trạng thái không yên lòng do đang có điều phải quan tâm, lo lắng: lo đau đáu * "Trời thăm thẳm xa vời khôn thấu, Nỗi nhớ chàng đau đáu nào xong." (CPN)',
    example:
      'lo đau đáu * "Trời thăm thẳm xa vời khôn thấu, Nỗi nhớ chàng đau đáu nào xong." (CPN)',
  },
  {
    word: "đau đáu",
    part_of_speech: "tính từ",
    meaning:
      "(cách nhìn) chăm chăm, biểu lộ sự quan tâm, mong đợi hay lo lắng không yên: nhìn đau đáu",
    example: "nhìn đau đáu",
  },
  {
    word: "đau buồn",
    part_of_speech: "",
    meaning:
      "có cảm giác đau thương, buồn rầu do gặp phải một mất mát hay tổn thất rất lớn nào đó: tâm trạng đau buồn * gặp chuyện đau buồn",
    example: "tâm trạng đau buồn * gặp chuyện đau buồn",
  },
  {
    word: "đau điếng",
    part_of_speech: "tính từ",
    meaning:
      "đau đến mức lặng đi, mất cảm giác toàn thân trong giây phút do bị tổn thương mạnh và đột ngột: bị cốc một cái đau điếng",
    example: "bị cốc một cái đau điếng",
  },
  {
    word: "đau lòng",
    part_of_speech: "tính từ",
    meaning:
      'đau đớn, xót xa trong lòng: chuyện đau lòng * "Đau lòng tử biệt sinh ly, Thân còn chẳng tiếc, tiếc gì đến duyên!" (TKiều)',
    example:
      'chuyện đau lòng * "Đau lòng tử biệt sinh ly, Thân còn chẳng tiếc, tiếc gì đến duyên!" (TKiều)',
  },
  {
    word: "đau khổ",
    part_of_speech: "tính từ",
    meaning:
      "đau và khổ về tinh thần: gương mặt đau khổ, rầu rĩ * vượt lên mọi đau khổ",
    example: "gương mặt đau khổ, rầu rĩ * vượt lên mọi đau khổ",
  },
  {
    word: "đau đầu",
    part_of_speech: "tính từ",
    meaning:
      "cảm thấy hết sức căng thẳng và khó nghĩ trước một vấn đề nào đó do không biết phải nên xử lí hay giải quyết như thế nào: đau đầu về công việc * đau đầu vì con",
    example: "đau đầu về công việc * đau đầu vì con",
  },
  {
    word: "đau đớn",
    part_of_speech: "tính từ",
    meaning:
      'đau nhiều và kéo dài (nói khái quát): bệnh gây đau đớn kéo dài * "Làm cho cho mệt, cho mê, Làm cho đau đớn, ê chề, cho coi!" (TKiều)',
    example:
      'bệnh gây đau đớn kéo dài * "Làm cho cho mệt, cho mê, Làm cho đau đớn, ê chề, cho coi!" (TKiều)',
  },
  {
    word: "đau đớn",
    part_of_speech: "tính từ",
    meaning: "có tác dụng làm cho đau đớn: những thất bại đau đớn",
    example: "những thất bại đau đớn",
  },
  {
    word: "đau thương",
    part_of_speech: "tính từ",
    meaning:
      "đau đớn xót thương: cảnh tượng đau thương * biến đau thương thành hành động",
    example: "cảnh tượng đau thương * biến đau thương thành hành động",
  },
  {
    word: "đau xót",
    part_of_speech: "tính từ",
    meaning: "đau đớn, xót xa về mặt tinh thần: bài học đau xót",
    example: "bài học đau xót",
  },
  {
    word: "đáy",
    part_of_speech: "danh từ",
    meaning:
      "phần tận cùng, sâu nhất trong lòng một vật chứa: đáy thùng * cất tiền dưới đáy va li * tình cảm xuất phát tự đáy lòng",
    example:
      "đáy thùng * cất tiền dưới đáy va li * tình cảm xuất phát tự đáy lòng",
  },
  {
    word: "đáy",
    part_of_speech: "danh từ",
    meaning: "(Khẩu ngữ) cạnh đáy hoặc mặt đáy (nói tắt): đáy của tam giác",
    example: "đáy của tam giác",
  },
  {
    word: "đáy",
    part_of_speech: "danh từ",
    meaning:
      'lưới đánh cá hình ống to và dài, có cọc để giữ miệng lưới: "Cha chài mẹ lưới con câu, Chàng rể đóng đáy, con dâu ngồi nò." (Cdao)',
    example:
      'Cha chài mẹ lưới con câu, Chàng rể đóng đáy, con dâu ngồi nò." (Cdao)',
  },
  {
    word: "đày ải",
    part_of_speech: "động từ",
    meaning: "(hiếm) đày đi xa (nói khái quát): bị đưa đi đày ải",
    example: "bị đưa đi đày ải",
  },
  {
    word: "đày ải",
    part_of_speech: "động từ",
    meaning: "bắt phải chịu nhiều điều khổ sở, cực nhục: tự đày ải mình",
    example: "tự đày ải mình",
  },
  {
    word: "đau ốm",
    part_of_speech: "động từ",
    meaning: "ốm (nói khái quát): phòng lúc đau ốm * suốt ngày đau ốm",
    example: "phòng lúc đau ốm * suốt ngày đau ốm",
  },
  {
    word: "đau nhói",
    part_of_speech: "tính từ",
    meaning:
      "có cảm giác đau buốt một cách đột ngột tại một vị trí nào đó trên cơ thể: vết thương đau nhói * tim đau nhói",
    example: "vết thương đau nhói * tim đau nhói",
  },
  {
    word: "đày",
    part_of_speech: "động từ",
    meaning:
      "đưa đi giam ở một nơi xa, hẻo lánh (một loại hình phạt): bị địch bắt và đưa đi đày ngoài Côn Đảo * đày đi biệt xứ",
    example: "bị địch bắt và đưa đi đày ngoài Côn Đảo * đày đi biệt xứ",
  },
  {
    word: "đày",
    part_of_speech: "động từ",
    meaning: "(hiếm) bắt phải chịu cảnh khổ sở, cực nhục: như bị trời đày",
    example: "như bị trời đày",
  },
  {
    word: "đau yếu",
    part_of_speech: "động từ",
    meaning: "như đau ốm: người đau yếu luôn",
    example: "người đau yếu luôn",
  },
  {
    word: "đay",
    part_of_speech: "danh từ",
    meaning:
      "cây công nghiệp, lá dài có hai ria ở phía gốc, mép lá có răng cưa, quả tròn, vỏ thân có sợi dùng để dệt bao tải, làm dây buộc: dây đay * sợi đay",
    example: "dây đay * sợi đay",
  },
  {
    word: "đay",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) rau đay (nói tắt): canh đay nấu hến",
    example: "canh đay nấu hến",
  },
  {
    word: "đay",
    part_of_speech: "động từ",
    meaning:
      "nói đi nói lại một chuyện, nội dung không có gì khác trước, nhưng với giọng điệu làm người ta khó chịu, để cho bõ tức: nói đay * có mỗi một chuyện mà cứ đay đi đay lại mãi",
    example: "nói đay * có mỗi một chuyện mà cứ đay đi đay lại mãi",
  },
  {
    word: "đáy biển mò kim",
    part_of_speech: "",
    meaning:
      'như mò kim đáy biển: "Bấy lâu đáy biển mò kim, Là nhiều vàng đá, phải tìm trăng hoa?" (TKiều)',
    example:
      'Bấy lâu đáy biển mò kim, Là nhiều vàng đá, phải tìm trăng hoa?" (TKiều)',
  },
  {
    word: "đặc biệt",
    part_of_speech: "tính từ",
    meaning:
      "khác hẳn những trường hợp thông thường về tính chất, chức năng hoặc mức độ: sự quan tâm đặc biệt * trường hợp đặc biệt",
    example: "sự quan tâm đặc biệt * trường hợp đặc biệt",
  },
  {
    word: "đặc",
    part_of_speech: "tính từ",
    meaning:
      "(hỗn hợp chất lỏng với những chất khác) có thành phần những chất hỗn hợp nhiều hơn bình thường: cơm nấu như cháo đặc * sữa đặc * cà phê pha đặc * cô cho đặc",
    example: "cơm nấu như cháo đặc * sữa đặc * cà phê pha đặc * cô cho đặc",
  },
  {
    word: "đặc",
    part_of_speech: "tính từ",
    meaning:
      "(khoảng không gian) có những cái chứa trong đó nhiều hơn bình thường, đến mức như không thể chứa thêm được nữa: mây đen đặc bầu trời * chữ kín đặc cả trang giấy * cá nổi đặc cả mặt nước",
    example:
      "mây đen đặc bầu trời * chữ kín đặc cả trang giấy * cá nổi đặc cả mặt nước",
  },
  {
    word: "đặc",
    part_of_speech: "tính từ",
    meaning:
      "không có hoặc hầu như không có khoảng trống ở bên trong: quả bí đặc ruột * xe lốp đặc",
    example: "quả bí đặc ruột * xe lốp đặc",
  },
  {
    word: "đặc",
    part_of_speech: "tính từ",
    meaning:
      "thuần tuý, chỉ có hoặc hầu như chỉ có một tính chất nào đó: nói đặc giọng Nam Bộ",
    example: "nói đặc giọng Nam Bộ",
  },
  {
    word: "đặc",
    part_of_speech: "tính từ",
    meaning:
      "ở mức như hoàn toàn, một trăm phần trăm: tai điếc đặc * giọng khản đặc * con giống đặc bố * dốt đặc hơn hay chữ lỏng (tng)",
    example:
      "tai điếc đặc * giọng khản đặc * con giống đặc bố * dốt đặc hơn hay chữ lỏng (tng)",
  },
  {
    word: "đay nghiến",
    part_of_speech: "động từ",
    meaning:
      "nói đi nói lại thiếu sót hay khuyết điểm của người khác với giọng chì chiết, nhằm làm cho người ta phải khổ tâm: giọng đay nghiến * bị dì nghẻ đay nghiến",
    example: "giọng đay nghiến * bị dì nghẻ đay nghiến",
  },
  {
    word: "đày đoạ",
    part_of_speech: "động từ",
    meaning: "bắt phải chịu cảnh đau khổ, cực nhục: tự đày đoạ mình",
    example: "tự đày đoạ mình",
  },
  {
    word: "đặc cách",
    part_of_speech: "động từ",
    meaning:
      "để cho hưởng một quyền lợi đặc biệt nào đó, không cần theo thể thức quy định thông thường: đặc cách cho giảm án",
    example: "đặc cách cho giảm án",
  },
  {
    word: "đặc công",
    part_of_speech: "động từ",
    meaning:
      "đánh theo lối bí mật, bất ngờ, bằng lực lượng và trang bị tinh gọn, tiến công nhanh và mạnh vào những mục tiêu hiểm yếu, đạt hiệu quả chiến đấu cao: đánh đặc công",
    example: "đánh đặc công",
  },
  {
    word: "đặc công",
    part_of_speech: "danh từ",
    meaning:
      "lực lượng tinh nhuệ của quân đội chuyên dùng lối đánh đặc công: chiến sĩ đặc công * binh chủng đặc công",
    example: "chiến sĩ đặc công * binh chủng đặc công",
  },
  {
    word: "đặc chế",
    part_of_speech: "động từ",
    meaning:
      "được chế tạo đặc biệt để dùng riêng cho một công việc hoặc một đối tượng nhất định: loại xăng đặc chế cho máy bay phản lực",
    example: "loại xăng đặc chế cho máy bay phản lực",
  },
  {
    word: "đặc ân",
    part_of_speech: "danh từ",
    meaning: "(trang trọng) ơn đặc biệt: ban đặc ân",
    example: "ban đặc ân",
  },
  {
    word: "đắc chí",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra thích thú vì đã đạt được điều mong muốn: cười đắc chí * tỏ ra rất đắc chí với câu nói dí dỏm của mình",
    example: "cười đắc chí * tỏ ra rất đắc chí với câu nói dí dỏm của mình",
  },
  {
    word: "đắc chí",
    part_of_speech: "tính từ",
    meaning: "(cũ) được thoả mãn như hằng mong muốn: anh hùng đắc chí",
    example: "anh hùng đắc chí",
  },
  {
    word: "đắc cử",
    part_of_speech: "động từ",
    meaning: "được bầu trong một cuộc bầu cử: trúng cử tổng thống",
    example: "trúng cử tổng thống",
  },
  {
    word: "đặc chủng",
    part_of_speech: "tính từ",
    meaning:
      "thuộc chủng loại đặc biệt để dùng vào một mục đích cụ thể nào đó: đơn vị đặc chủng * loại xi măng đặc chủng cho ngành dầu khí",
    example: "đơn vị đặc chủng * loại xi măng đặc chủng cho ngành dầu khí",
  },
  {
    word: "đặc chủng",
    part_of_speech: "tính từ",
    meaning:
      "(động, thực vật) thuộc chủng loại đặc biệt: loài động vật đặc chủng * tăng sản lượng lúa đặc chủng",
    example: "loài động vật đặc chủng * tăng sản lượng lúa đặc chủng",
  },
  {
    word: "đắc đạo",
    part_of_speech: "động từ",
    meaning:
      "đạt tới chỗ cao sâu của đạo (nói về người tu theo đạo Phật): các bậc tu hành đắc đạo",
    example: "các bậc tu hành đắc đạo",
  },
  {
    word: "đắc dụng",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) dùng được vào nhiều việc và được coi trọng: một cán bộ đắc dụng",
    example: "một cán bộ đắc dụng",
  },
  {
    word: "đắc địa",
    part_of_speech: "tính từ",
    meaning:
      "(mồ mả) đặt ở vị trí tốt nên con cháu gặp nhiều may mắn, làm ăn phát đạt, theo thuật phong thuỷ: mộ táng ở chỗ đắc địa",
    example: "mộ táng ở chỗ đắc địa",
  },
  {
    word: "đắc địa",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ở vị trí thích hợp để phát huy được tác dụng mong muốn: dùng từ rất đắc địa",
    example: "dùng từ rất đắc địa",
  },
  {
    word: "đặc điểm",
    part_of_speech: "danh từ",
    meaning:
      "những nét riêng biệt: đặc điểm khí hậu nhiệt đới * không có đặc điểm gì nổi bật",
    example: "đặc điểm khí hậu nhiệt đới * không có đặc điểm gì nổi bật",
  },
  {
    word: "đặc hiệu",
    part_of_speech: "tính từ",
    meaning: "có hiệu quả, tác dụng đặc biệt: thuốc đặc hiệu",
    example: "thuốc đặc hiệu",
  },
  {
    word: "đắc kế",
    part_of_speech: "tính từ",
    meaning: "(cũ, hiếm) như đắc sách: làm như thế không phải là đắc kế",
    example: "làm như thế không phải là đắc kế",
  },
  {
    word: "đặc dụng",
    part_of_speech: "tính từ",
    meaning: "có công dụng đặc biệt: máy móc đặc dụng * xe đặc dụng",
    example: "máy móc đặc dụng * xe đặc dụng",
  },
  {
    word: "đặc hữu",
    part_of_speech: "tính từ",
    meaning:
      "(động thực vật, khoáng vật) có giá trị đặc biệt và rất quý hiếm, chỉ có ở một số nơi: ngan cánh trắng, voọc Hà Tĩnh là những động vật đặc hữu của Việt Nam",
    example:
      "ngan cánh trắng, voọc Hà Tĩnh là những động vật đặc hữu của Việt Nam",
  },
  {
    word: "đặc khu",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị hành chính đặc biệt, có tầm quan trọng riêng về kinh tế, chính trị hoặc quân sự: đặc khu Sài Gòn - Gia Định",
    example: "đặc khu Sài Gòn - Gia Định",
  },
  {
    word: "đặc kịt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) dày đặc, đến mức như không có kẽ hở, như đông đặc lại: cá nổi đặc kịt trên mặt nước * bụi đặc kịt",
    example: "cá nổi đặc kịt trên mặt nước * bụi đặc kịt",
  },
  {
    word: "đặc kỹ",
    part_of_speech: "danh từ",
    meaning:
      "kĩ thuật hoặc kĩ xảo riêng rất đặc biệt, làm cho phải ngạc nhiên, thán phục: biểu diễn đặc kĩ ô tô bay trên không",
    example: "biểu diễn đặc kĩ ô tô bay trên không",
  },
  {
    word: "đặc kĩ",
    part_of_speech: "danh từ",
    meaning:
      "kĩ thuật hoặc kĩ xảo riêng rất đặc biệt, làm cho phải ngạc nhiên, thán phục: biểu diễn đặc kĩ ô tô bay trên không",
    example: "biểu diễn đặc kĩ ô tô bay trên không",
  },
  {
    word: "đặc nhiệm",
    part_of_speech: "động từ",
    meaning:
      "(cũ, hiếm) giao cho một nhiệm vụ đặc biệt: được đặc nhiệm đi công tác",
    example: "được đặc nhiệm đi công tác",
  },
  {
    word: "đặc nhiệm",
    part_of_speech: "tính từ",
    meaning: "có nhiệm vụ đặc biệt: lính đặc nhiệm",
    example: "lính đặc nhiệm",
  },
  {
    word: "đặc mệnh",
    part_of_speech: "động từ",
    meaning:
      "(được nhà nước) giao cho một nhiệm vụ đặc biệt: đại sứ đặc mệnh toàn quyền",
    example: "đại sứ đặc mệnh toàn quyền",
  },
  {
    word: "đặc phái",
    part_of_speech: "động từ",
    meaning: "cử đi làm một nhiệm vụ đặc biệt: đặc phái người vào nội thành",
    example: "đặc phái người vào nội thành",
  },
  {
    word: "đặc phái viên",
    part_of_speech: "danh từ",
    meaning:
      "người được cử đi làm một nhiệm vụ đặc biệt: đặc phái viên điều tra",
    example: "đặc phái viên điều tra",
  },
  {
    word: "đắc lực",
    part_of_speech: "tính từ",
    meaning:
      "(người giúp việc) có năng lực, có khả năng làm tốt công việc được giao: trợ thủ đắc lực * cánh tay đắc lực của giám đốc",
    example: "trợ thủ đắc lực * cánh tay đắc lực của giám đốc",
  },
  {
    word: "đặc sản",
    part_of_speech: "danh từ",
    meaning:
      "sản phẩm đặc biệt của một vùng, một địa phương: món đặc sản * đặc sản của Hưng Yên là nhãn lồng",
    example: "món đặc sản * đặc sản của Hưng Yên là nhãn lồng",
  },
  {
    word: "đặc tả",
    part_of_speech: "động từ",
    meaning:
      "mô tả thật chi tiết một bộ phận đặc biệt tiêu biểu để làm nổi bật bản chất của toàn thể: một đoạn phim đặc tả * đặc tả tính cách nhân vật",
    example: "một đoạn phim đặc tả * đặc tả tính cách nhân vật",
  },
  {
    word: "đắc sách",
    part_of_speech: "tính từ",
    meaning:
      "(cách làm có suy nghĩ, mưu tính) có kế sách hay, có thể mang lại kết quả như mong muốn: làm như vậy mới là đắc sách",
    example: "làm như vậy mới là đắc sách",
  },
  {
    word: "đặc sệt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) đặc đến mức như được cô lại: hồ quấy đặc sệt * cột khói đen đặc sệt",
    example: "hồ quấy đặc sệt * cột khói đen đặc sệt",
  },
  {
    word: "đặc sệt",
    part_of_speech: "tính từ",
    meaning: "như đặc (ng4; nhưng nghĩa mạnh hơn): nói đặc sệt giọng miền Nam",
    example: "nói đặc sệt giọng miền Nam",
  },
  {
    word: "đắc thắng",
    part_of_speech: "động từ",
    meaning:
      "giành được phần thắng: có cơ hội đắc thắng * đắc thắng một cách dễ dàng",
    example: "có cơ hội đắc thắng * đắc thắng một cách dễ dàng",
  },
  {
    word: "đặc sắc",
    part_of_speech: "tính từ",
    meaning:
      "có những nét riêng, tốt, đẹp hơn hẳn mức bình thường: tiết mục văn nghệ đặc sắc",
    example: "tiết mục văn nghệ đặc sắc",
  },
  {
    word: "đặc thù",
    part_of_speech: "danh từ",
    meaning:
      "nét riêng biệt làm cho sự vật này khác với sự vật cùng loại khác: một số đặc thù của công việc * đặc thù dân tộc",
    example: "một số đặc thù của công việc * đặc thù dân tộc",
  },
  {
    word: "đặc thù",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất riêng biệt, khác hẳn với những cái cùng loại: ngành công nghiệp đặc thù",
    example: "ngành công nghiệp đặc thù",
  },
  {
    word: "đặc tài",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như biệt tài: có đặc tài về hội hoạ",
    example: "có đặc tài về hội hoạ",
  },
  {
    word: "đặc trị",
    part_of_speech: "tính từ",
    meaning:
      "(thuốc) có tác dụng đặc biệt để điều trị một loại bệnh nào đó: thuốc đặc trị bệnh ung thư",
    example: "thuốc đặc trị bệnh ung thư",
  },
  {
    word: "đặc trưng",
    part_of_speech: "danh từ",
    meaning:
      "nét riêng biệt và tiêu biểu, được xem là dấu hiệu để phân biệt với những sự vật khác: đặc trưng văn hoá * đặc trưng ngôn ngữ",
    example: "đặc trưng văn hoá * đặc trưng ngôn ngữ",
  },
  {
    word: "đặc trưng",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất riêng biệt và tiêu biểu, làm cho phân biệt được với những sự vật khác: mỗi tộc người có những nét đặc trưng riêng * hoa anh đào là loại hoa đặc trưng cho mùa xuân ở Nhật Bản",
    example:
      "mỗi tộc người có những nét đặc trưng riêng * hoa anh đào là loại hoa đặc trưng cho mùa xuân ở Nhật Bản",
  },
  {
    word: "đặc tính",
    part_of_speech: "danh từ",
    meaning:
      "tính chất riêng, không giống với tính chất các sự vật khác: đặc tính của văn xuôi * hiểu được đặc tính của từng giống cây trồng",
    example:
      "đặc tính của văn xuôi * hiểu được đặc tính của từng giống cây trồng",
  },
  {
    word: "đắm",
    part_of_speech: "động từ",
    meaning:
      "(thuyền, tàu) bị chìm hoàn toàn: đắm thuyền * tàu bị đánh đắm * đắm đò giặt mẹt (tng)",
    example: "đắm thuyền * tàu bị đánh đắm * đắm đò giặt mẹt (tng)",
  },
  {
    word: "đắm",
    part_of_speech: "động từ",
    meaning:
      "bị bao phủ, bao trùm hoàn toàn: đầu óc đắm trong suy nghĩ * đắm mình trong mộng tưởng",
    example: "đầu óc đắm trong suy nghĩ * đắm mình trong mộng tưởng",
  },
  {
    word: "đắc tội",
    part_of_speech: "động từ",
    meaning: "(cũ) có tội lớn, mang tội lớn (với ai): đắc tội với người trên",
    example: "đắc tội với người trên",
  },
  {
    word: "đắc ý",
    part_of_speech: "tính từ",
    meaning:
      "tự thấy hết sức thoả mãn và thích thú vì đã được như ý: nghĩ được câu thơ hay lấy làm đắc ý * cười một cách đắc ý",
    example: "nghĩ được câu thơ hay lấy làm đắc ý * cười một cách đắc ý",
  },
  {
    word: "đặc xá",
    part_of_speech: "động từ",
    meaning:
      "(cơ quan quyền lực nhà nước tối cao hoặc nguyên thủ quốc gia) miễn hoặc giảm hình phạt đối với phạm nhân khi xét thấy cần thiết: lệnh đặc xá * quyết định đặc xá",
    example: "lệnh đặc xá * quyết định đặc xá",
  },
  {
    word: "đằm",
    part_of_speech: "tính từ",
    meaning:
      "êm và đều, không có những biến đổi đột ngột trong quá trình vận động: đường tốt nên xe chạy rất đằm * chân bước êm đằm",
    example: "đường tốt nên xe chạy rất đằm * chân bước êm đằm",
  },
  {
    word: "đằm",
    part_of_speech: "tính từ",
    meaning: "êm và gợi cảm xúc sâu xa, lắng đọng: giọng hát rất đằm",
    example: "giọng hát rất đằm",
  },
  {
    word: "đằm",
    part_of_speech: "tính từ",
    meaning:
      "làm chủ được tình cảm của mình, không để có những phản ứng đột ngột: một người đằm tính",
    example: "một người đằm tính",
  },
  {
    word: "đặc vụ",
    part_of_speech: "danh từ",
    meaning:
      "cơ quan đặc biệt của các tổ chức phản động chuyên làm nhiệm vụ do thám, phá hoại các lực lượng cách mạng.",
    example: "mạng lưới đặc vụ",
  },
  {
    word: "đặc trách",
    part_of_speech: "động từ",
    meaning:
      "chịu trách nhiệm riêng về một công tác nào đó: cố vấn đặc trách * đặc trách công tác đoàn",
    example: "cố vấn đặc trách * đặc trách công tác đoàn",
  },
  {
    word: "đăm chiêu",
    part_of_speech: "tính từ",
    meaning:
      "có vẻ đang phải băn khoăn, bận tâm suy nghĩ: đăm chiêu suy nghĩ * vẻ mặt đăm chiêu",
    example: "đăm chiêu suy nghĩ * vẻ mặt đăm chiêu",
  },
  {
    word: "đăm đắm",
    part_of_speech: "tính từ",
    meaning:
      "có cách nhìn hết sức chăm chú, thường là với vẻ say mê, tha thiết: mắt nhìn đăm đắm",
    example: "mắt nhìn đăm đắm",
  },
  {
    word: "đắm đuối",
    part_of_speech: "động từ",
    meaning:
      "say mê tới mức tình cảm, tâm trí hoàn toàn bị thu hút, không còn biết gì khác nữa: nhìn đắm đuối * cá chuối đắm đuối vì con (tng)",
    example: "nhìn đắm đuối * cá chuối đắm đuối vì con (tng)",
  },
  {
    word: "đắm chìm",
    part_of_speech: "động từ",
    meaning: "như chìm đắm: đắm chìm trong suy tưởng",
    example: "đắm chìm trong suy tưởng",
  },
  {
    word: "đăm đăm",
    part_of_speech: "tính từ",
    meaning:
      'có sự tập trung chú ý hay tập trung suy nghĩ rất cao, hướng về một phía hay một cái gì đó: nhìn đăm đăm vào bóng tối * "Cánh hồng bay bổng tuyệt vời, Đã mòn con mắt phương trời đăm đăm." (TKiều)',
    example:
      'nhìn đăm đăm vào bóng tối * "Cánh hồng bay bổng tuyệt vời, Đã mòn con mắt phương trời đăm đăm." (TKiều)',
  },
  {
    word: "đắm nguyệt say hoa",
    part_of_speech: "",
    meaning:
      'như say hoa đắm nguyệt: "Hương trời đắm nguyệt say hoa, Tây Thi mất vía, Hằng Nga giật mình." (CO)',
    example:
      'Hương trời đắm nguyệt say hoa, Tây Thi mất vía, Hằng Nga giật mình." (CO)',
  },
  {
    word: "đắm say",
    part_of_speech: "động từ",
    meaning: "như say đắm: tình yêu đắm say * đắm say tửu sắc",
    example: "tình yêu đắm say * đắm say tửu sắc",
  },
  {
    word: "đẵn",
    part_of_speech: "động từ",
    meaning: "làm đứt thân cây bằng vật có lưỡi sắc: đẵn cây",
    example: "đẵn cây",
  },
  {
    word: "đẵn",
    part_of_speech: "danh từ",
    meaning: "đoạn thân cây đẵn ra: một đẵn mía",
    example: "một đẵn mía",
  },
  {
    word: "đằm thắm",
    part_of_speech: "tính từ",
    meaning:
      '(tình cảm) nồng nàn và sâu sắc, khó phai nhạt: mối tình đằm thắm * "Mái tây để lạnh hương nguyền, Cho duyên đằm thắm ra duyên bẽ bàng." (TKiều)',
    example:
      'mối tình đằm thắm * "Mái tây để lạnh hương nguyền, Cho duyên đằm thắm ra duyên bẽ bàng." (TKiều)',
  },
  {
    word: "đắn đo",
    part_of_speech: "động từ",
    meaning:
      'so sánh, suy xét giữa nên hay không nên, chưa đi đến quyết định: trả lời không chút đắn đo * "Đắn đo cân sắc cân tài, ép cung cầm nguyệt, thử bài quạt thơ." (TKiều)',
    example:
      'trả lời không chút đắn đo * "Đắn đo cân sắc cân tài, ép cung cầm nguyệt, thử bài quạt thơ." (TKiều)',
  },
  {
    word: "đặng",
    part_of_speech: "động từ",
    meaning:
      "(cũ hoặc ph) đạt đến (nói về thời gian): tuổi đặng đôi mươi * đi đặng hai năm rồi",
    example: "tuổi đặng đôi mươi * đi đặng hai năm rồi",
  },
  {
    word: "đặng",
    part_of_speech: "phụ từ",
    meaning:
      "(Phương ngữ, Ít dùng) như được: cầm lòng chẳng đặng * câu thơ khó, đối không đặng",
    example: "cầm lòng chẳng đặng * câu thơ khó, đối không đặng",
  },
  {
    word: "đắng",
    part_of_speech: "tính từ",
    meaning:
      "có vị làm khó chịu như vị của bồ hòn, mật cá: bồ hòn đắng * miệng đắng * thuốc đắng dã tật (tng)",
    example: "bồ hòn đắng * miệng đắng * thuốc đắng dã tật (tng)",
  },
  {
    word: "đăng",
    part_of_speech: "danh từ",
    meaning:
      "đồ đan bằng tre, hình phên, đặt chắn ngang dòng nước để bắt cá: tham đó bỏ đăng (tng)",
    example: "tham đó bỏ đăng (tng)",
  },
  {
    word: "đăng",
    part_of_speech: "động từ",
    meaning:
      "đưa lên báo chí để in ra: có bài đăng trên báo * đăng tin kịp thời",
    example: "có bài đăng trên báo * đăng tin kịp thời",
  },
  {
    word: "đằng ấy",
    part_of_speech: "đại từ",
    meaning:
      "(khẩu ngữ) từ dùng để gọi bạn một cách thân mật (thường là giữa bạn bè còn ít tuổi): đằng ấy bảo hộ tớ bài toán",
    example: "đằng ấy bảo hộ tớ bài toán",
  },
  {
    word: "đằng",
    part_of_speech: "danh từ",
    meaning:
      "nơi, trong quan hệ đối lập với một nơi khác: đứng ở đằng xa * mặt trời lặn ở đằng tây * đứng nấp đằng sau bức tường",
    example:
      "đứng ở đằng xa * mặt trời lặn ở đằng tây * đứng nấp đằng sau bức tường",
  },
  {
    word: "đằng",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) phía của người hoặc những người nào đó, trong quan hệ đối lập với một phía khác: đằng nhà trai * có họ về đằng ngoại",
    example: "đằng nhà trai * có họ về đằng ngoại",
  },
  {
    word: "đằng",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) loại, trong quan hệ đối lập với một hoặc những loại khác: nhiều loại quá, không biết chọn đằng nào",
    example: "nhiều loại quá, không biết chọn đằng nào",
  },
  {
    word: "đằng",
    part_of_speech: "danh từ",
    meaning:
      "lối, trong quan hệ đối lập với một hoặc những lối khác: đi tắt đằng cánh đồng * nói một đằng, làm một nẻo (tng)",
    example: "đi tắt đằng cánh đồng * nói một đằng, làm một nẻo (tng)",
  },
  {
    word: "đẳng",
    part_of_speech: "đại từ",
    meaning: "(phương ngữ, khẩu ngữ) đằng ấy, phía ấy: để ở đẳng",
    example: "để ở đẳng",
  },
  {
    word: "đẳng",
    part_of_speech: "danh từ",
    meaning: "thứ bậc về trình độ võ thuật: thi lên đẳng * đệ nhất đẳng",
    example: "thi lên đẳng * đệ nhất đẳng",
  },
  {
    word: "đăng bạ",
    part_of_speech: "động từ",
    meaning:
      "đứng ra khai báo với cơ quan quản lí để chính thức được công nhận cho hưởng quyền lợi hay làm nghĩa vụ nào đó: đăng kí kinh doanh * đăng kí hộ khẩu * đăng kí kết hôn * đăng kí nghĩa vụ quân sự",
    example:
      "đăng kí kinh doanh * đăng kí hộ khẩu * đăng kí kết hôn * đăng kí nghĩa vụ quân sự",
  },
  {
    word: "đăng bạ",
    part_of_speech: "danh từ",
    meaning: "giấy chứng nhận đã đăng kí: cấp đăng kí",
    example: "cấp đăng kí",
  },
  {
    word: "đắng cay",
    part_of_speech: "tính từ",
    meaning:
      'như cay đắng: "Gió đưa cây cải về trời, Rau răm ở lại chịu lời đắng cay." (ca dao)',
    example:
      'Gió đưa cây cải về trời, Rau răm ở lại chịu lời đắng cay." (ca dao)',
  },
  {
    word: "đăng bộ",
    part_of_speech: "động từ",
    meaning:
      "đứng ra khai báo với cơ quan quản lí để chính thức được công nhận cho hưởng quyền lợi hay làm nghĩa vụ nào đó: đăng kí kinh doanh * đăng kí hộ khẩu * đăng kí kết hôn * đăng kí nghĩa vụ quân sự",
    example:
      "đăng kí kinh doanh * đăng kí hộ khẩu * đăng kí kết hôn * đăng kí nghĩa vụ quân sự",
  },
  {
    word: "đăng bộ",
    part_of_speech: "danh từ",
    meaning: "giấy chứng nhận đã đăng kí: cấp đăng kí",
    example: "cấp đăng kí",
  },
  {
    word: "đăng cai",
    part_of_speech: "động từ",
    meaning:
      "đứng ra tổ chức (một ngày hội, một hội nghị lớn, v.v.): đăng cai tổ chức thế vận hội",
    example: "đăng cai tổ chức thế vận hội",
  },
  {
    word: "đẳng cấp",
    part_of_speech: "danh từ",
    meaning:
      "tập đoàn người có địa vị xã hội như nhau, được pháp luật thừa nhận, hợp thành thứ bậc tách biệt với các tập đoàn khác trong chế độ nô lệ và phong kiến ở một số nước: phân biệt đẳng cấp",
    example: "phân biệt đẳng cấp",
  },
  {
    word: "đẳng cấp",
    part_of_speech: "danh từ",
    meaning:
      "tập đoàn người có những đặc quyền riêng, khác các tập đoàn khác về thứ bậc trong xã hội nói chung.",
    example: "vận động viên có đẳng cấp cao",
  },
  {
    word: "đăng đàn",
    part_of_speech: "động từ",
    meaning: "(cũ, trang trọng) lên diễn đàn: đăng đàn diễn thuyết",
    example: "đăng đàn diễn thuyết",
  },
  {
    word: "đăng đàn",
    part_of_speech: "động từ",
    meaning: "(trang trọng) lên đài để làm lễ: nhà sư đăng đàn làm lễ",
    example: "nhà sư đăng đàn làm lễ",
  },
  {
    word: "đằng đằng",
    part_of_speech: "danh từ",
    meaning: "nhọt trong tai, gây viêm và chảy mủ tai: lên đằng đằng",
    example: "lên đằng đằng",
  },
  {
    word: "đằng đằng",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) tỏ ra có sức sống mạnh mẽ, như vượt lên: lúa tốt đằng đằng",
    example: "lúa tốt đằng đằng",
  },
  {
    word: "đằng đằng",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra có tinh thần mãnh liệt, như hừng hực bốc lên: vẻ mặt đằng đằng sát khí",
    example: "vẻ mặt đằng đằng sát khí",
  },
  {
    word: "đằng đẵng",
    part_of_speech: "tính từ",
    meaning:
      'dài quá, lâu quá, không biết bao giờ mới hết (thường nói về thời gian): xa nhau đằng đẵng mấy năm trời * "Trời ơi, có thấu tình chăng, Một ngày đằng đẵng xem bằng ba thu!" (ca dao)',
    example:
      'xa nhau đằng đẵng mấy năm trời * "Trời ơi, có thấu tình chăng, Một ngày đằng đẵng xem bằng ba thu!" (ca dao)',
  },
  {
    word: "đắng chằng",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) đắng đến mức cảm giác khó chịu còn lại rất lâu sau khi nếm phải: thuốc đắng chằng * mồm miệng đắng chằng",
    example: "thuốc đắng chằng * mồm miệng đắng chằng",
  },
  {
    word: "đăng đối",
    part_of_speech: "tính từ",
    meaning:
      "(cũ) có sự tương xứng, sự cân xứng với nhau: hai gia đình đăng đối",
    example: "hai gia đình đăng đối",
  },
  {
    word: "đăng đường",
    part_of_speech: "động từ",
    meaning: "(cũ) (toà án thời trước) mở phiên toà xét xử: đăng đường xử án",
    example: "đăng đường xử án",
  },
  {
    word: "đằng hắng",
    part_of_speech: "động từ",
    meaning:
      "phát ra tiếng như tiếng ho khẽ trong cổ họng, thường để chuẩn bị nói hoặc để làm hiệu: đằng hắng để lấy giọng",
    example: "đằng hắng để lấy giọng",
  },
  {
    word: "đăng hoả",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) đèn và lửa; thường dùng để chỉ công sức học tập: "Mười năm đăng hoả bằng năng gắng, Một giáp khôi khoa ắt đã đành." (LTKN)',
    example:
      'Mười năm đăng hoả bằng năng gắng, Một giáp khôi khoa ắt đã đành." (LTKN)',
  },
  {
    word: "đẳng hướng",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất giống nhau theo mọi hướng; phân biệt với dị hướng: không gian đẳng hướng * sự dãn nở đẳng hướng",
    example: "không gian đẳng hướng * sự dãn nở đẳng hướng",
  },
  {
    word: "đăng ký",
    part_of_speech: "động từ",
    meaning:
      "đứng ra khai báo với cơ quan quản lí để chính thức được công nhận cho hưởng quyền lợi hay làm nghĩa vụ nào đó: đăng kí kinh doanh * đăng kí hộ khẩu * đăng kí kết hôn * đăng kí nghĩa vụ quân sự",
    example:
      "đăng kí kinh doanh * đăng kí hộ khẩu * đăng kí kết hôn * đăng kí nghĩa vụ quân sự",
  },
  {
    word: "đăng ký",
    part_of_speech: "danh từ",
    meaning: "giấy chứng nhận đã đăng kí: cấp đăng kí",
    example: "cấp đăng kí",
  },
  {
    word: "đắng ngắt",
    part_of_speech: "tính từ",
    meaning:
      "đắng đến mức cảm thấy vị đắng còn đọng mãi ở miệng: miệng đắng ngắt * mẩu khoai hà đắng ngắt",
    example: "miệng đắng ngắt * mẩu khoai hà đắng ngắt",
  },
  {
    word: "đẳng lập",
    part_of_speech: "tính từ",
    meaning:
      "gồm những yếu tố ngang bằng nhau, không phụ thuộc nhau về quan hệ ngữ pháp: từ ghép đẳng lập * câu ghép đẳng lập * quan hệ đẳng lập",
    example: "từ ghép đẳng lập * câu ghép đẳng lập * quan hệ đẳng lập",
  },
  {
    word: "đăng khoa",
    part_of_speech: "động từ",
    meaning: "(cũ, văn chương) thi đỗ: đăng khoa bảng vàng",
    example: "đăng khoa bảng vàng",
  },
  {
    word: "đằng la",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) loài dây leo; thường dùng để ví thân phận người vợ lẽ: "Thế trong dù lớn hơn ngoài, Trước hàm sư tử gửi người đằng la." (TKiều)',
    example:
      'Thế trong dù lớn hơn ngoài, Trước hàm sư tử gửi người đằng la." (TKiều)',
  },
  {
    word: "đăng kí",
    part_of_speech: "động từ",
    meaning:
      "đứng ra khai báo với cơ quan quản lí để chính thức được công nhận cho hưởng quyền lợi hay làm nghĩa vụ nào đó: đăng kí kinh doanh * đăng kí hộ khẩu * đăng kí kết hôn * đăng kí nghĩa vụ quân sự",
    example:
      "đăng kí kinh doanh * đăng kí hộ khẩu * đăng kí kết hôn * đăng kí nghĩa vụ quân sự",
  },
  {
    word: "đăng kí",
    part_of_speech: "danh từ",
    meaning: "giấy chứng nhận đã đăng kí: cấp đăng kí",
    example: "cấp đăng kí",
  },
  {
    word: "đắng nghét",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) như đắng ngắt: mồm miệng đắng nghét",
    example: "mồm miệng đắng nghét",
  },
  {
    word: "đăng kiểm",
    part_of_speech: "động từ",
    meaning:
      "(cơ quan nhà nước) kiểm tra và xác nhận việc thực hiện các tiêu chuẩn đảm bảo an toàn cho người và hàng hoá trong quá trình vận hành của các phương tiện giao thông: đăng kiểm tàu thuỷ * trạm đăng kiểm ô tô, xe máy",
    example: "đăng kiểm tàu thuỷ * trạm đăng kiểm ô tô, xe máy",
  },
  {
    word: "đăng nhập",
    part_of_speech: "động từ",
    meaning:
      "đăng kí để có thể thâm nhập vào sử dụng một dịch vụ nào đó trên mạng máy tính hoặc mạng Internet: mật khẩu đăng nhập * đăng nhập vào mạng",
    example: "mật khẩu đăng nhập * đăng nhập vào mạng",
  },
  {
    word: "đăng quang",
    part_of_speech: "động từ",
    meaning: "(trang trọng) (cũ, hiếm) lên ngôi vua: lễ đăng quang",
    example: "lễ đăng quang",
  },
  {
    word: "đăng quang",
    part_of_speech: "động từ",
    meaning: "chiếm giữ ngôi vị cao nhất: đăng quang ngôi hoa hậu hoàn vũ",
    example: "đăng quang ngôi hoa hậu hoàn vũ",
  },
  {
    word: "đẳng phương",
    part_of_speech: "tính từ",
    meaning:
      "gồm tất cả các điểm có phương tích bằng nhau đối với hai hay nhiều vòng tròn hoặc mặt cầu: trục đẳng phương * mặt phẳng đẳng phương",
    example: "trục đẳng phương * mặt phẳng đẳng phương",
  },
  {
    word: "đằng thằng",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) ngay thẳng và đàng hoàng: ăn nói có vẻ đằng thằng * cứ đằng thằng mà đi",
    example: "ăn nói có vẻ đằng thằng * cứ đằng thằng mà đi",
  },
  {
    word: "đằng thằng",
    part_of_speech: "tính từ",
    meaning:
      "trong điều kiện giả thiết là bình thường: đằng thằng ra phải làm xong từ lâu rồi",
    example: "đằng thằng ra phải làm xong từ lâu rồi",
  },
  {
    word: "đăng ten",
    part_of_speech: "danh từ",
    meaning: "dải ren dùng làm đường viền trang trí: áo viền đăng ten",
    example: "áo viền đăng ten",
  },
  {
    word: "đăng tải",
    part_of_speech: "động từ",
    meaning:
      "như đăng: tin tức được đăng tải trên các phương tiện thông tin đại chúng",
    example: "tin tức được đăng tải trên các phương tiện thông tin đại chúng",
  },
  {
    word: "đăng trình",
    part_of_speech: "động từ",
    meaning: "(cũ, văn chương) lên đường đi xa: tiễn bạn đăng trình",
    example: "tiễn bạn đăng trình",
  },
  {
    word: "đắp điếm",
    part_of_speech: "động từ",
    meaning: "che, đắp cho kín (nói khái quát): đắp điếm mồ mả",
    example: "đắp điếm mồ mả",
  },
  {
    word: "đắp điếm",
    part_of_speech: "động từ",
    meaning:
      'che chở, giúp đỡ: "Yêu nhau đắp điếm mọi bề, Một trăm chỗ lệch cũng kê cho bằng." (ca dao)',
    example:
      'Yêu nhau đắp điếm mọi bề, Một trăm chỗ lệch cũng kê cho bằng." (ca dao)',
  },
  {
    word: "đắt",
    part_of_speech: "tính từ",
    meaning:
      "(Nam mắc) có giá cao hơn bình thường: cái áo đắt quá * đắt như vàng",
    example: "cái áo đắt quá * đắt như vàng",
  },
  {
    word: "đắt",
    part_of_speech: "tính từ",
    meaning:
      'được nhiều người chuộng, nhiều người mua: đắt khách * "Canh suông khéo nấu thì ngon, Mẹ già khéo tán thì con đắt chồng." (Cdao)',
    example:
      'đắt khách * "Canh suông khéo nấu thì ngon, Mẹ già khéo tán thì con đắt chồng." (Cdao)',
  },
  {
    word: "đắt",
    part_of_speech: "tính từ",
    meaning:
      "(từ ngữ hoặc hình tượng văn học nghệ thuật) có giá trị diễn đạt cao hơn mức bình thường: chữ dùng rất đắt * phim có nhiều hình ảnh rất đắt",
    example: "chữ dùng rất đắt * phim có nhiều hình ảnh rất đắt",
  },
  {
    word: "đắt",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) được chấp nhận, được hoan nghênh vì đạt yêu cầu: có cho không cũng không đắt",
    example: "có cho không cũng không đắt",
  },
  {
    word: "đặt",
    part_of_speech: "động từ",
    meaning:
      "để vào vị trí phù hợp: đặt bom * đặt nhiều hi vọng vào thế hệ trẻ",
    example: "đặt bom * đặt nhiều hi vọng vào thế hệ trẻ",
  },
  {
    word: "đặt",
    part_of_speech: "động từ",
    meaning: "nêu ra với một yêu cầu nào đó: đặt câu hỏi * đặt điều kiện",
    example: "đặt câu hỏi * đặt điều kiện",
  },
  {
    word: "đặt",
    part_of_speech: "động từ",
    meaning: "nghĩ để tạo ra: đặt ví dụ * đặt tên cho con * đặt điều nói xấu",
    example: "đặt ví dụ * đặt tên cho con * đặt điều nói xấu",
  },
  {
    word: "đặt",
    part_of_speech: "động từ",
    meaning:
      "làm cho bắt đầu tồn tại và có hiệu lực: chính thức đặt quan hệ giữa hai nước * đặt cơ sở lí luận * đặt cột mốc",
    example:
      "chính thức đặt quan hệ giữa hai nước * đặt cơ sở lí luận * đặt cột mốc",
  },
  {
    word: "đặt",
    part_of_speech: "động từ",
    meaning:
      "đưa trước yêu cầu, theo thể thức đã định, để đảm bảo việc mua bán, thuê mướn: đặt hàng * đặt mua báo dài hạn",
    example: "đặt hàng * đặt mua báo dài hạn",
  },
  {
    word: "đắp",
    part_of_speech: "động từ",
    meaning: "phủ lên người khi nằm: đắp chăn",
    example: "đắp chăn",
  },
  {
    word: "đắp",
    part_of_speech: "động từ",
    meaning:
      "đặt từng lớp một trên bề mặt để cho dày thêm, cho nổi lên hoặc để thành một hình thù nhất định: đắp đê * đắp đập * đắp tượng * đắp mặt nạ bằng dưa leo",
    example: "đắp đê * đắp đập * đắp tượng * đắp mặt nạ bằng dưa leo",
  },
  {
    word: "đặt chân",
    part_of_speech: "động từ",
    meaning:
      "đến, có mặt thật sự ở một nơi nào đó: một nơi chưa ai đặt chân tới * con người đã đặt chân lên Mặt Trăng",
    example:
      "một nơi chưa ai đặt chân tới * con người đã đặt chân lên Mặt Trăng",
  },
  {
    word: "đắp đổi",
    part_of_speech: "động từ",
    meaning:
      '(hiếm) thay đổi lần lượt và cứ lặp đi lặp lại như thế: "Măng chua nấu với ngạnh nguồn, Sự đời đắp đổi khi buồn khi vui." (ca dao)',
    example:
      'Măng chua nấu với ngạnh nguồn, Sự đời đắp đổi khi buồn khi vui." (ca dao)',
  },
  {
    word: "đắp đổi",
    part_of_speech: "động từ",
    meaning:
      "dùng thứ này thứ khác để sống cho qua ngày trong hoàn cảnh khó khăn thiếu thốn: muối dưa đắp đổi",
    example: "muối dưa đắp đổi",
  },
  {
    word: "đặt cọc",
    part_of_speech: "động từ",
    meaning:
      "ứng trước một số tiền để làm tin: lấy lại tiền đặt cọc * đặt cọc mua nhà",
    example: "lấy lại tiền đặt cọc * đặt cọc mua nhà",
  },
  {
    word: "đặt để",
    part_of_speech: "động từ",
    meaning:
      '(hiếm) như bịa đặt: "Hư không đặt để nên lời, Nàng đà nhớn nhác, rụng rời lắm phen." (TKiều)',
    example:
      'Hư không đặt để nên lời, Nàng đà nhớn nhác, rụng rời lắm phen." (TKiều)',
  },
  {
    word: "đắt đỏ",
    part_of_speech: "tính từ",
    meaning:
      "có giá cao hơn nhiều so với bình thường, thường do khan hiếm: hàng hoá ngày càng đắt đỏ * giá sinh hoạt đắt đỏ",
    example: "hàng hoá ngày càng đắt đỏ * giá sinh hoạt đắt đỏ",
  },
  {
    word: "đắt giá",
    part_of_speech: "tính từ",
    meaning: "có giá trị cao hơn hẳn: cầu thủ đắt giá * bài học đắt giá",
    example: "cầu thủ đắt giá * bài học đắt giá",
  },
  {
    word: "đặt cược",
    part_of_speech: "động từ",
    meaning:
      "đặt tiền hoặc tài sản để cá cược: đặt cược cho đội nhà * đặt cược toàn bộ tài sản vào cuộc đua",
    example: "đặt cược cho đội nhà * đặt cược toàn bộ tài sản vào cuộc đua",
  },
  {
    word: "đắt như tôm tươi",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) được rất nhiều người mua, có bao nhiêu cũng hết ngay; rất đắt hàng: hàng làm ra bán đắt như tôm tươi",
    example: "hàng làm ra bán đắt như tôm tươi",
  },
  {
    word: "đặt điều",
    part_of_speech: "động từ",
    meaning:
      "bịa ra chuyện không tốt về người khác: đặt điều thị phi * đặt điều vu khống",
    example: "đặt điều thị phi * đặt điều vu khống",
  },
  {
    word: "đặt hàng",
    part_of_speech: "động từ",
    meaning:
      "đưa trước yêu cầu để cho nơi sản xuất hoặc nơi bán hàng có thời gian chuẩn bị hàng hoá: sản xuất theo đơn đặt hàng * gửi hàng cho khách theo đơn đặt hàng",
    example:
      "sản xuất theo đơn đặt hàng * gửi hàng cho khách theo đơn đặt hàng",
  },
  {
    word: "đấm",
    part_of_speech: "động từ",
    meaning:
      "đưa nắm tay thẳng tới cho tác động mạnh vào: đấm vào vai bạn * đấm cửa",
    example: "đấm vào vai bạn * đấm cửa",
  },
  {
    word: "đấm",
    part_of_speech: "động từ",
    meaning: "đưa quân tốt trong cờ tướng tiến lên một bước: đấm tốt",
    example: "đấm tốt",
  },
  {
    word: "đâm",
    part_of_speech: "động từ",
    meaning:
      "làm cho bị thủng, bị tổn thương bằng vật có mũi nhọn: bị kim đâm vào ngón tay * dùng lưỡi lê đâm * nén bạc đâm toạc tờ giấy (tng)",
    example:
      "bị kim đâm vào ngón tay * dùng lưỡi lê đâm * nén bạc đâm toạc tờ giấy (tng)",
  },
  {
    word: "đâm",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) giã: đâm bèo",
    example: "đâm bèo",
  },
  {
    word: "đâm",
    part_of_speech: "động từ",
    meaning:
      "di chuyển thẳng đến làm cho chạm mạnh vào: xe đâm vào cột điện * tàu đâm vào vách đá * máy bay đâm đầu xuống biển",
    example:
      "xe đâm vào cột điện * tàu đâm vào vách đá * máy bay đâm đầu xuống biển",
  },
  {
    word: "đâm",
    part_of_speech: "động từ",
    meaning:
      "nói xen vào, cắt ngang lời người khác, thường với ý ngược lại: nói đâm ngang * người ta đang nói chuyện lại đâm ngay vào một câu",
    example:
      "nói đâm ngang * người ta đang nói chuyện lại đâm ngay vào một câu",
  },
  {
    word: "đâm",
    part_of_speech: "động từ",
    meaning: "nhô ra: rẻo đất đâm ra biển",
    example: "rẻo đất đâm ra biển",
  },
  {
    word: "đâm",
    part_of_speech: "động từ",
    meaning:
      "nảy ra, phát triển từ trong cơ thể thực vật: đâm chồi, nảy lộc * đâm rễ * đâm mầm",
    example: "đâm chồi, nảy lộc * đâm rễ * đâm mầm",
  },
  {
    word: "đâm",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) sinh ra, chuyển sang trạng thái khác, thường là xấu đi: đâm cáu * không biết gì lại đâm hay * được chiều quá đâm hư * nhờ nó đâm hỏng việc",
    example:
      "đâm cáu * không biết gì lại đâm hay * được chiều quá đâm hư * nhờ nó đâm hỏng việc",
  },
  {
    word: "đậm",
    part_of_speech: "tính từ",
    meaning:
      "có mùi vị, nồng độ hoặc màu sắc ở mức cao hơn so với mức trung bình, thường gây cảm giác dễ chịu: mực đậm * canh nấu đậm * tô màu chỗ đậm, chỗ nhạt",
    example: "mực đậm * canh nấu đậm * tô màu chỗ đậm, chỗ nhạt",
  },
  {
    word: "đậm",
    part_of_speech: "tính từ",
    meaning:
      'có tình cảm nồng nàn, sâu sắc: "Áo đen ai nhuộm cho mình, Cho duyên mình đậm, cho tình anh thương." (ca dao)',
    example:
      'Áo đen ai nhuộm cho mình, Cho duyên mình đậm, cho tình anh thương." (ca dao)',
  },
  {
    word: "đậm",
    part_of_speech: "tính từ",
    meaning:
      "có khá nhiều, khá rõ tính chất, đặc điểm nào đó: mang đậm chất dân gian * đặc điểm dân tộc khá đậm",
    example: "mang đậm chất dân gian * đặc điểm dân tộc khá đậm",
  },
  {
    word: "đậm",
    part_of_speech: "tính từ",
    meaning: "có đường nét to và nổi rõ hơn bình thường: chữ đậm * tô đậm nét",
    example: "chữ đậm * tô đậm nét",
  },
  {
    word: "đậm",
    part_of_speech: "tính từ",
    meaning:
      "(vóc người) hơi to và có vẻ chắc: người thấp và đậm * dáng hơi đậm",
    example: "người thấp và đậm * dáng hơi đậm",
  },
  {
    word: "đậm",
    part_of_speech: "tính từ",
    meaning:
      "(mức độ thua hoặc thắng trong thi đấu hay trong một trò chơi có tính thắng thua) rất cao: thua đậm * thắng đậm với tỉ số 7-2",
    example: "thua đậm * thắng đậm với tỉ số 7-2",
  },
  {
    word: "đầm ấm",
    part_of_speech: "tính từ",
    meaning:
      "có tác dụng gây cảm giác thân mật, dễ chịu do có quan hệ gần gũi, thương yêu nhau: cảnh gia đình đầm ấm",
    example: "cảnh gia đình đầm ấm",
  },
  {
    word: "đẫm",
    part_of_speech: "",
    meaning:
      "ướt đến mức sũng nước: cây cỏ ướt đẫm sương đêm * khăn đẫm nước * gương mặt đẫm nước mắt",
    example:
      "cây cỏ ướt đẫm sương đêm * khăn đẫm nước * gương mặt đẫm nước mắt",
  },
  {
    word: "đâm bổ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nhào từ trên cao xuống: chiếc máy bay bốc cháy, đâm bổ xuống sông",
    example: "chiếc máy bay bốc cháy, đâm bổ xuống sông",
  },
  {
    word: "đâm bổ",
    part_of_speech: "động từ",
    meaning:
      "lao đi, nhanh, mạnh và có phần vội vã, hấp tấp: mọi người đâm bổ đi tìm",
    example: "mọi người đâm bổ đi tìm",
  },
  {
    word: "đầm đầm",
    part_of_speech: "tính từ",
    meaning:
      '(cũ) như đầm đìa: "Lòng đâu sẵn mối thương tâm, Thoắt nghe, Kiều đã đầm đầm châu sa." (TKiều)',
    example:
      'Lòng đâu sẵn mối thương tâm, Thoắt nghe, Kiều đã đầm đầm châu sa." (TKiều)',
  },
  {
    word: "đậm đà",
    part_of_speech: "tính từ",
    meaning: "có vị đậm và thơm, ngon: hương thơm đậm đà",
    example: "hương thơm đậm đà",
  },
  {
    word: "đậm đà",
    part_of_speech: "tính từ",
    meaning:
      'có tình cảm nồng nàn, sâu sắc và bền lâu: "Mình đi, có nhớ những nhà, Hắt hiu lau xám, đậm đà lòng son." (THữu; 39)',
    example:
      'Mình đi, có nhớ những nhà, Hắt hiu lau xám, đậm đà lòng son." (THữu; 39)',
  },
  {
    word: "đậm đà",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều tính chất, đặc điểm nào đó, gây cảm giác thích thú: món ăn đậm đà hương vị đồng quê * lễ hội mang đậm đà bản sắc dân tộc",
    example:
      "món ăn đậm đà hương vị đồng quê * lễ hội mang đậm đà bản sắc dân tộc",
  },
  {
    word: "đậm đà",
    part_of_speech: "tính từ",
    meaning: "(vóc người) đậm (nói khái quát): vóc người đậm đà",
    example: "vóc người đậm đà",
  },
  {
    word: "đấm đá",
    part_of_speech: "động từ",
    meaning:
      "đánh nhau bằng chân tay (nói khái quát): xông vào nhau đấm đá túi bụi",
    example: "xông vào nhau đấm đá túi bụi",
  },
  {
    word: "đấm đá",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ, hiếm) như đấu đá: kèn cựa, đấm đá nhau",
    example: "kèn cựa, đấm đá nhau",
  },
  {
    word: "đâm đầu",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) lao đầu, chúi đầu vào nơi nào, cái gì đó một cách liều lĩnh hoặc không còn biết đến cái gì khác: đâm đầu vào học * đâm đầu vào tròng",
    example: "đâm đầu vào học * đâm đầu vào tròng",
  },
  {
    word: "đậm đặc",
    part_of_speech: "tính từ",
    meaning: "(nồng độ) đậm ở mức cao: độ đậm đặc của dung dịch * acid đậm đặc",
    example: "độ đậm đặc của dung dịch * acid đậm đặc",
  },
  {
    word: "đâm đơn",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đưa đơn kêu xin việc gì: đâm đơn kiện * đâm đơn khiếu nại * đâm đơn xin về hưu",
    example: "đâm đơn kiện * đâm đơn khiếu nại * đâm đơn xin về hưu",
  },
  {
    word: "đầm đìa",
    part_of_speech: "tính từ",
    meaning: "ướt nhiều đến sũng nước: nước mắt đầm đìa * mồ hôi vã ra đầm đìa",
    example: "nước mắt đầm đìa * mồ hôi vã ra đầm đìa",
  },
  {
    word: "đậm nét",
    part_of_speech: "tính từ",
    meaning:
      "được thể hiện bằng những nét rõ ràng, nổi bật: khắc hoạ đậm nét nhân vật * mang đậm nét văn hoá dân gian",
    example: "khắc hoạ đậm nét nhân vật * mang đậm nét văn hoá dân gian",
  },
  {
    word: "đâm hông",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) chọc tức, thường bằng lời nói: nói đâm hông",
    example: "nói đâm hông",
  },
  {
    word: "đấm mõm",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) cho ăn của hối lộ (hàm ý khinh): đấm mõm quan thầy * phải đấm mõm thì hắn mới chịu để yên",
    example: "đấm mõm quan thầy * phải đấm mõm thì hắn mới chịu để yên",
  },
  {
    word: "đâm ra",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) trở nên, chuyển sang trạng thái khác, thường là theo chiều hướng tiêu cực: thất bại nhiều đâm ra nản * bí thế đâm ra liều",
    example: "thất bại nhiều đâm ra nản * bí thế đâm ra liều",
  },
  {
    word: "đận",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) khoảng thời gian xảy ra việc gì đó, thường là việc không may: đận trước * đận này đau ốm liên miên",
    example: "đận trước * đận này đau ốm liên miên",
  },
  {
    word: "đâm sầm",
    part_of_speech: "động từ",
    meaning:
      "lao nhanh vào, gây ra va chạm mạnh đột ngột: đâm sầm vào gốc cây * chiếc máy bay bốc cháy và đâm sầm xuống biển",
    example:
      "đâm sầm vào gốc cây * chiếc máy bay bốc cháy và đâm sầm xuống biển",
  },
  {
    word: "đâm sầm",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) váy đầm (nói tắt): mặc đầm",
    example: "mặc đầm",
  },
  {
    word: "đâm sầm",
    part_of_speech: "danh từ",
    meaning:
      "vũng to và sâu ở giữa đồng để giữ nước, thường có bùn lầy: đầm sen",
    example: "đầm sen",
  },
  {
    word: "đâm sầm",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ gồm một khối nặng có đáy phẳng, có cán, dùng để nện đất cho chặt: dùng đầm để đầm sân * đầm sắt",
    example: "dùng đầm để đầm sân * đầm sắt",
  },
  {
    word: "đâm sầm",
    part_of_speech: "động từ",
    meaning:
      "làm chặt đất hoặc vật liệu bằng áp lực bề mặt (đầm đất) hoặc bằng chấn động (đầm bê tông): đầm đất * đầm nền nhà",
    example: "đầm đất * đầm nền nhà",
  },
  {
    word: "đâm sầm",
    part_of_speech: "động từ",
    meaning: "ngâm mình lâu trong nước: đầm mình trong nước * lấm như trâu đầm",
    example: "đầm mình trong nước * lấm như trâu đầm",
  },
  {
    word: "đâm sầm",
    part_of_speech: "động từ",
    meaning:
      'thấm ướt nhiều: mồ hôi đầm lưng áo * "Ra về sương xuống đầm vai, Ngoảnh nhìn trở lại bóng ai tờ mờ." (ca dao)',
    example:
      'mồ hôi đầm lưng áo * "Ra về sương xuống đầm vai, Ngoảnh nhìn trở lại bóng ai tờ mờ." (ca dao)',
  },
  {
    word: "đầm phá",
    part_of_speech: "danh từ",
    meaning: "đầm và phá (nói khái quát): bảo vệ vùng đầm phá ven biển",
    example: "bảo vệ vùng đầm phá ven biển",
  },
  {
    word: "đần",
    part_of_speech: "tính từ",
    meaning:
      "kém về khả năng nhận thức và thích ứng: trông mặt có vẻ đần * người đần",
    example: "trông mặt có vẻ đần * người đần",
  },
  {
    word: "đần",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái đờ đẫn, không còn linh hoạt: đần cả người trước bài toán khó * ngồi đần mặt ra",
    example: "đần cả người trước bài toán khó * ngồi đần mặt ra",
  },
  {
    word: "đần",
    part_of_speech: "tính từ",
    meaning:
      "đờ đẫn, mất khả năng hoạt động linh hoạt (nói khái quát): nhận được tin mà đần dại cả người",
    example: "nhận được tin mà đần dại cả người",
  },
  {
    word: "đầm xoè",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) váy xoè: mặc đầm xoè",
    example: "mặc đầm xoè",
  },
  {
    word: "đẩn",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) như đẩy: đẩn xe lên dốc",
    example: "đẩn xe lên dốc",
  },
  {
    word: "đần độn",
    part_of_speech: "tính từ",
    meaning:
      "rất đần, như không có khả năng nhận thức và thích ứng: bộ mặt đần độn * đầu óc đần độn",
    example: "bộ mặt đần độn * đầu óc đần độn",
  },
  {
    word: "đẫn",
    part_of_speech: "tính từ",
    meaning: "béo đến mức căng đầy: cổ tay tròn đẫn * béo đẫn",
    example: "cổ tay tròn đẫn * béo đẫn",
  },
  {
    word: "đập hộp",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (đồ vật, hàng hoá) còn mới nguyên như vừa lấy trong bao bì ra, chưa từng qua sử dụng: hàng đập hộp * chiếc xe đập hộp",
    example: "hàng đập hộp * chiếc xe đập hộp",
  },
  {
    word: "đất",
    part_of_speech: "danh từ",
    meaning:
      "chất rắn ở trên đó người và các loài động vật, thực vật sinh sống; đối lập với trời hoặc với biển, nước: đứng trên mặt đất * chôn sâu dưới đất * đầu đội trời, chân đạp đất (tng)",
    example:
      "đứng trên mặt đất * chôn sâu dưới đất * đầu đội trời, chân đạp đất (tng)",
  },
  {
    word: "đất",
    part_of_speech: "danh từ",
    meaning:
      "chất rắn làm thành lớp trên cùng của bề mặt Trái Đất, gồm những hạt vụn khoáng vật không gắn chặt với nhau và nhiều chất hữu cơ gọi là mùn, trên đó có thể trồng trọt được: đất bồi * cuốc đất trồng rau",
    example: "đất bồi * cuốc đất trồng rau",
  },
  {
    word: "đất",
    part_of_speech: "danh từ",
    meaning:
      "khoảng mặt đất trên đó có thể trồng trọt được: đất canh tác * không một tấc đất cắm dùi * tấc đất tấc vàng",
    example: "đất canh tác * không một tấc đất cắm dùi * tấc đất tấc vàng",
  },
  {
    word: "đất",
    part_of_speech: "danh từ",
    meaning:
      "khoảng mặt đất không phải là ruộng: đất ở * cả đất và ruộng là hai hecta",
    example: "đất ở * cả đất và ruộng là hai hecta",
  },
  {
    word: "đất",
    part_of_speech: "danh từ",
    meaning:
      "vật liệu gồm thành phần chủ yếu là đất (thường là đất sét): nồi đất * nhà tranh vách đất",
    example: "nồi đất * nhà tranh vách đất",
  },
  {
    word: "đất",
    part_of_speech: "danh từ",
    meaning:
      "vùng có người ở, trong quan hệ với cộng đồng người sinh sống ở đó: quê cha đất tổ * đất mẹ",
    example: "quê cha đất tổ * đất mẹ",
  },
  {
    word: "đất",
    part_of_speech: "danh từ",
    meaning:
      "chỗ đất tốt để làm nhà cửa hoặc đặt mồ mả, theo thuật phong thuỷ: thầy địa lí đi tìm đất * được đất * đất dữ",
    example: "thầy địa lí đi tìm đất * được đất * đất dữ",
  },
  {
    word: "đất",
    part_of_speech: "danh từ",
    meaning:
      "nơi thuận lợi cho một hoạt động nào đó: tìm đất hoạt động * không có đất dung thân",
    example: "tìm đất hoạt động * không có đất dung thân",
  },
  {
    word: "đất",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) ghét: người bẩn, kì ra đầy đất",
    example: "người bẩn, kì ra đầy đất",
  },
  {
    word: "đấng",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, hiếm) hạng người (có phẩm chất, địa vị khác nhau): người ba đấng của ba loài (tng)",
    example: "người ba đấng của ba loài (tng)",
  },
  {
    word: "đấng",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để suy tôn cá nhân nào đó đến mức cao nhất do có công lao, sự nghiệp lớn hoặc có những phẩm chất vượt trội: đấng cứu tinh * đấng anh hùng * đấng sinh thành",
    example: "đấng cứu tinh * đấng anh hùng * đấng sinh thành",
  },
  {
    word: "đập",
    part_of_speech: "danh từ",
    meaning:
      "công trình được đắp hay xây dựng bằng đất đá hoặc bê tông để ngăn, chứa hay giữ nước: xây đập ngăn sông",
    example: "xây đập ngăn sông",
  },
  {
    word: "đập",
    part_of_speech: "động từ",
    meaning:
      "đưa nhanh, thường là từ trên xuống, bàn tay hoặc vật nào đó theo bề ngang cho tác động mạnh vào một vật khác: đập tay xuống bàn * đập vỡ cái chai * gà đập cánh phành phạch",
    example: "đập tay xuống bàn * đập vỡ cái chai * gà đập cánh phành phạch",
  },
  {
    word: "đập",
    part_of_speech: "động từ",
    meaning:
      "làm cho tổn thương, cho mất tác dụng bằng sức mạnh: đập đầu vào tường * đập tan cuộc tiến công của địch * dùng lí lẽ đập lại",
    example:
      "đập đầu vào tường * đập tan cuộc tiến công của địch * dùng lí lẽ đập lại",
  },
  {
    word: "đập",
    part_of_speech: "động từ",
    meaning:
      "tác động mạnh vào giác quan, vào ý thức: một cảnh tượng khủng khiếp đập vào mắt",
    example: "một cảnh tượng khủng khiếp đập vào mắt",
  },
  {
    word: "đập",
    part_of_speech: "động từ",
    meaning: "(tim, mạch) vận động co bóp: tim ngừng đập * mạch đập nhanh",
    example: "tim ngừng đập * mạch đập nhanh",
  },
  {
    word: "đập",
    part_of_speech: "động từ",
    meaning:
      '(khẩu ngữ) (khoản tiền) gộp chung vào làm một với một khoản khác: lãi đập vào vốn * "Chị tính cặn kẽ từ tiền gạo củi đến tiền xà phòng, bớt một hào ở khoản này đập vào khoản kia." (BHiển; 5)',
    example:
      'lãi đập vào vốn * "Chị tính cặn kẽ từ tiền gạo củi đến tiền xà phòng, bớt một hào ở khoản này đập vào khoản kia." (BHiển; 5)',
  },
  {
    word: "đất cát",
    part_of_speech: "danh từ",
    meaning:
      "đất có thành phần chủ yếu là những hạt như cát, rời rạc, nên dễ làm, dễ thấm nước: cấy ở ruộng đất cát",
    example: "cấy ở ruộng đất cát",
  },
  {
    word: "đất cát",
    part_of_speech: "danh từ",
    meaning: "như đất đai: đất cát màu mỡ * tranh giành nhà cửa, đất cát",
    example: "đất cát màu mỡ * tranh giành nhà cửa, đất cát",
  },
  {
    word: "đập tan",
    part_of_speech: "động từ",
    meaning:
      "phá vỡ hoàn toàn (thường là bằng sức mạnh): đập tan âm mưu phá hoại của kẻ thù",
    example: "đập tan âm mưu phá hoại của kẻ thù",
  },
  {
    word: "đất dụng võ",
    part_of_speech: "danh từ",
    meaning:
      "nơi có thể thi thố, phát huy được tài năng: anh hùng không có đất dụng võ * tìm đất dụng võ",
    example: "anh hùng không có đất dụng võ * tìm đất dụng võ",
  },
  {
    word: "đất đỏ",
    part_of_speech: "danh từ",
    meaning:
      "đất xốp, màu đỏ nâu, giữ nước kém, thích hợp để trồng cà phê, cao su: vùng đất đỏ cao nguyên",
    example: "vùng đất đỏ cao nguyên",
  },
  {
    word: "đất khách quê người",
    part_of_speech: "",
    meaning:
      "nơi xa quê hương, không có người thân thích: bôn ba nơi đất khách quê người",
    example: "bôn ba nơi đất khách quê người",
  },
  {
    word: "đất đai",
    part_of_speech: "danh từ",
    meaning:
      "đất trồng trọt, sử dụng (nói khái quát): đất đai phì nhiêu * mua bán đất đai, nhà cửa",
    example: "đất đai phì nhiêu * mua bán đất đai, nhà cửa",
  },
  {
    word: "đất đai",
    part_of_speech: "danh từ",
    meaning: "khoảng mặt đất tương đối rộng (nói khái quát): xâm chiếm đất đai",
    example: "xâm chiếm đất đai",
  },
  {
    word: "đất hứa",
    part_of_speech: "danh từ",
    meaning:
      "vùng đất Canaan mà Chúa hứa cho Abraham, ông tổ của người Do Thái, theo Kinh Thánh; thường dùng để chỉ nơi con người mơ tưởng có cuộc sống dễ dàng và sung sướng: miền đất hứa",
    example: "miền đất hứa",
  },
  {
    word: "đất liền",
    part_of_speech: "danh từ",
    meaning:
      "phần mặt đất chỉ tiếp xúc với biển ở một phía, nối liền với nhau thành một vùng rộng lớn: từ ngoài đảo trở về đất liền",
    example: "từ ngoài đảo trở về đất liền",
  },
  {
    word: "đất nước",
    part_of_speech: "danh từ",
    meaning:
      "phần lãnh thổ trong quan hệ với dân tộc làm chủ và sống trên đó: bảo vệ đất nước * lòng yêu quê hương đất nước",
    example: "bảo vệ đất nước * lòng yêu quê hương đất nước",
  },
  {
    word: "đất thấp trời cao",
    part_of_speech: "",
    meaning:
      'ví tình cảnh trớ trêu, người ở địa vị thấp hèn khó có thể giãy bày, kêu oan được lên trên: "Bây giờ đất thấp, trời cao, Ăn làm sao, nói làm sao, bây giờ?" (TKiều)',
    example:
      'Bây giờ đất thấp, trời cao, Ăn làm sao, nói làm sao, bây giờ?" (TKiều)',
  },
  {
    word: "đất thánh",
    part_of_speech: "danh từ",
    meaning:
      "(thường viết hoa) nơi được coi là hết sức thiêng liêng của một tôn giáo; thường là nơi có di hài, di vật của giáo chủ.",
    example: "bảo vệ vùng đất thánh",
  },
  {
    word: "đầu",
    part_of_speech: "danh từ",
    meaning:
      "phần trên cùng của cơ thể người hay phần trước nhất của cơ thể động vật, nơi có bộ óc và nhiều giác quan khác: để đầu trần đi mưa * áo mặc không qua khỏi đầu (tng)",
    example: "để đầu trần đi mưa * áo mặc không qua khỏi đầu (tng)",
  },
  {
    word: "đầu",
    part_of_speech: "danh từ",
    meaning:
      "đầu của con người, được coi là biểu tượng của suy nghĩ, nhận thức: nghĩ đến đau đầu * điên đầu",
    example: "nghĩ đến đau đầu * điên đầu",
  },
  {
    word: "đầu",
    part_of_speech: "danh từ",
    meaning:
      "tóc và phần có tóc mọc ở trên đầu con người: chải đầu * đầu cạo trọc lốc * xoa đầu cháu * đầu hai thứ tóc",
    example: "chải đầu * đầu cạo trọc lốc * xoa đầu cháu * đầu hai thứ tóc",
  },
  {
    word: "đầu",
    part_of_speech: "danh từ",
    meaning:
      "phần trước nhất hoặc phần trên cùng của một số vật: trên đầu giường * để ở đầu tủ",
    example: "trên đầu giường * để ở đầu tủ",
  },
  {
    word: "đầu",
    part_of_speech: "danh từ",
    meaning:
      "phần có điểm xuất phát của một khoảng không gian hoặc thời gian; đối lập với cuối: nhà ở đầu làng * đi từ đầu tỉnh đến cuối tỉnh * những tháng đầu năm * đầu mùa mưa",
    example:
      "nhà ở đầu làng * đi từ đầu tỉnh đến cuối tỉnh * những tháng đầu năm * đầu mùa mưa",
  },
  {
    word: "đầu",
    part_of_speech: "danh từ",
    meaning:
      "phần ở tận cùng, giống nhau, ở hai phía đối lập trên chiều dài của một vật: hai đầu cầu * tìm đầu sợi thừng * trở đầu đũa",
    example: "hai đầu cầu * tìm đầu sợi thừng * trở đầu đũa",
  },
  {
    word: "đầu",
    part_of_speech: "danh từ",
    meaning:
      "vị trí hoặc thời điểm thứ nhất, trên hoặc trước tất cả những vị trí, thời điểm khác: lần đầu * ngồi bàn đầu * lá cờ đầu * điểm danh từ đầu đến cuối",
    example: "lần đầu * ngồi bàn đầu * lá cờ đầu * điểm danh từ đầu đến cuối",
  },
  {
    word: "đầu",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị để tính đổ đồng về người, gia súc, đơn vị diện tích: thu nhập tính===== theo ===== * số đầu gia súc trong trại tăng nhanh",
    example:
      "thu nhập tính===== theo ===== * số đầu gia súc trong trại tăng nhanh",
  },
  {
    word: "đầu",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị máy móc: đầu máy khâu * đầu máy xe lửa",
    example: "đầu máy khâu * đầu máy xe lửa",
  },
  {
    word: "đầu",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) đầu video (nói tắt): đầu đa hệ * đầu kĩ thuật số",
    example: "đầu đa hệ * đầu kĩ thuật số",
  },
  {
    word: "đầu",
    part_of_speech: "động từ",
    meaning: "theo: đầu Phật (đi tu)",
    example: "đầu Phật (đi tu)",
  },
  {
    word: "đấu",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ đong lường, thường bằng gỗ, dùng ở một số địa phương để đong hạt rời: một đấu thóc * lường thưng tráo đấu (tng)",
    example: "một đấu thóc * lường thưng tráo đấu (tng)",
  },
  {
    word: "đấu",
    part_of_speech: "động từ",
    meaning:
      "làm cho những vật có hình thanh, hình sợi nối hoặc===== áp sát vào nhau: đấu dây điện * đấu hai đầu kèo",
    example: "đấu dây điện * đấu hai đầu kèo",
  },
  {
    word: "đấu",
    part_of_speech: "động từ",
    meaning:
      "áp sát vào nhau: hai đứa trẻ ngồi đấu lưng vào nhau * chung lưng đấu cật (tng)",
    example: "hai đứa trẻ ngồi đấu lưng vào nhau * chung lưng đấu cật (tng)",
  },
  {
    word: "đấu",
    part_of_speech: "động từ",
    meaning:
      "gộp nhiều cái cùng loại làm một để có được một tác dụng lớn hơn: hai vợ chồng đấu sức lại làm ăn",
    example: "hai vợ chồng đấu sức lại làm ăn",
  },
  {
    word: "đấu",
    part_of_speech: "động từ",
    meaning:
      "pha trộn nhiều thứ cùng loại nhưng có chất lượng khác nhau, để tạo ra một thứ có chất lượng mới: đấu nước mắm * đấu gói thuốc lào cũ với gói thuốc lào mới",
    example: "đấu nước mắm * đấu gói thuốc lào cũ với gói thuốc lào mới",
  },
  {
    word: "đấu",
    part_of_speech: "động từ",
    meaning:
      "đọ sức hoặc tài để phân hơn, thua: đấu võ * đấu cờ * đấu trí * đấu vật",
    example: "đấu võ * đấu cờ * đấu trí * đấu vật",
  },
  {
    word: "đấu",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đấu tranh phê bình kịch liệt một cá nhân nào đó trước hội nghị: bị đấu vì thái độ vô trách nhiệm",
    example: "bị đấu vì thái độ vô trách nhiệm",
  },
  {
    word: "đầu bạc răng long",
    part_of_speech: "",
    meaning: "tả tuổi đã hoàn toàn về già: sống bên nhau đến đầu bạc răng long",
    example: "sống bên nhau đến đầu bạc răng long",
  },
  {
    word: "đậu",
    part_of_speech: "danh từ",
    meaning:
      "cây nhỏ, có nhiều loài, tràng hoa gồm năm cánh hình bướm, quả dài, chứa một dãy hạt, quả hay hạt dùng làm thức ăn: đi trỉa đậu",
    example: "đi trỉa đậu",
  },
  {
    word: "đậu",
    part_of_speech: "danh từ",
    meaning: "đậu phụ (nói tắt): đậu rán * mua mấy bìa đậu",
    example: "đậu rán * mua mấy bìa đậu",
  },
  {
    word: "đậu",
    part_of_speech: "danh từ",
    meaning: "đậu mùa (nói tắt): lên đậu * chủng đậu",
    example: "lên đậu * chủng đậu",
  },
  {
    word: "đậu",
    part_of_speech: "động từ",
    meaning:
      "(đỗ) ở trạng thái đứng yên một chỗ, tạm thời không di chuyển (thường nói về chim và tàu thuyền): chim đậu trên cành * tàu thuyền đậu san sát trên bến cảng",
    example: "chim đậu trên cành * tàu thuyền đậu san sát trên bến cảng",
  },
  {
    word: "đậu",
    part_of_speech: "động từ",
    meaning:
      "đạt được, giữ lại được kết quả tốt, như hoa kết thành quả, phôi thành hình cái thai, v.v. do có quá trình sinh trưởng tự nhiên thuận lợi: giống xấu, chỉ có mấy hạt đậu * cái thai không đậu * lứa tằm đậu",
    example: "giống xấu, chỉ có mấy hạt đậu * cái thai không đậu * lứa tằm đậu",
  },
  {
    word: "đậu",
    part_of_speech: "động từ",
    meaning: "(hiếm) như đặng: cầm lòng không đậu",
    example: "cầm lòng không đậu",
  },
  {
    word: "đậu",
    part_of_speech: "động từ",
    meaning: "(Nam) đỗ (= vượt qua được kì thi): đậu đại học",
    example: "đậu đại học",
  },
  {
    word: "đậu",
    part_of_speech: "động từ",
    meaning: "chắp hai hay nhiều sợi lại với nhau: đậu tơ * sợi đậu ba",
    example: "đậu tơ * sợi đậu ba",
  },
  {
    word: "đâu",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) đấu: ngồi đâu lưng vào nhau * nhà xây đâu vào nhau",
    example: "ngồi đâu lưng vào nhau * nhà xây đâu vào nhau",
  },
  {
    word: "đâu",
    part_of_speech: "đại từ",
    meaning:
      "từ dùng để chỉ một nơi, một chỗ nào đó không rõ, cần được xác định (thường dùng để hỏi): chợ ở đâu? * hai chị em đã đi những đâu? * hắn trốn ở nơi đâu?",
    example: "chợ ở đâu? * hai chị em đã đi những đâu? * hắn trốn ở nơi đâu?",
  },
  {
    word: "đâu",
    part_of_speech: "đại từ",
    meaning:
      "từ dùng để chỉ một nơi, một chỗ nào đó không nói rõ, vì không thể hoặc không cần nói rõ: nhà ở đâu quanh đây * tiền để đâu trong tủ ấy",
    example: "nhà ở đâu quanh đây * tiền để đâu trong tủ ấy",
  },
  {
    word: "đâu",
    part_of_speech: "đại từ",
    meaning:
      "từ dùng để chỉ chung bất cứ nơi nào: ở đâu cũng thế * mua đâu chả có",
    example: "ở đâu cũng thế * mua đâu chả có",
  },
  {
    word: "đâu",
    part_of_speech: "đại từ",
    meaning:
      "từ dùng để chỉ một khoảng, một điều nào đó biết không được chính xác lắm: đâu như chị ấy sắp đi du học * nghe đâu họ sắp cưới thì phải?",
    example: "đâu như chị ấy sắp đi du học * nghe đâu họ sắp cưới thì phải?",
  },
  {
    word: "đâu",
    part_of_speech: "đại từ",
    meaning:
      "từ dùng để chỉ điều cần được xác định, là nguyên do hoặc kết quả, hay là điểm đạt tới của sự việc nói đến (thường dùng để hỏi): tại đâu? * do đâu? * không biết mọi chuyện rồi sẽ đi đến đâu?",
    example: "tại đâu? * do đâu? * không biết mọi chuyện rồi sẽ đi đến đâu?",
  },
  {
    word: "đâu",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị ý phủ định về điều mà người nói muốn khẳng định dứt khoát là không hề có, không hề xảy ra: đâu có ngờ * hơi đâu mà làm * đào đâu ra tiền bây giờ?",
    example: "đâu có ngờ * hơi đâu mà làm * đào đâu ra tiền bây giờ?",
  },
  {
    word: "đâu",
    part_of_speech: "trợ từ",
    meaning:
      'từ biểu thị ý nhấn mạnh về điều vừa phủ định, như muốn thuyết phục hoặc bác bỏ ý kiến của người đối thoại: tôi có nói thế đâu * "Thật vàng chẳng phải thau đâu, Đừng đem thử lửa mà đau lòng vàng." (ca dao)',
    example:
      'tôi có nói thế đâu * "Thật vàng chẳng phải thau đâu, Đừng đem thử lửa mà đau lòng vàng." (ca dao)',
  },
  {
    word: "đầu bảng",
    part_of_speech: "danh từ",
    meaning:
      "vị trí đứng đầu trong bảng xếp hạng: chiếm ngôi đầu bảng * đỗ đầu bảng",
    example: "chiếm ngôi đầu bảng * đỗ đầu bảng",
  },
  {
    word: "đầu bài",
    part_of_speech: "danh từ",
    meaning:
      "phần đề ra cho học sinh làm: chép sai đầu bài * đọc kĩ đầu bài trước khi làm",
    example: "chép sai đầu bài * đọc kĩ đầu bài trước khi làm",
  },
  {
    word: "đầu bò đầu bướu",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) như đầu bò (nhưng ý nhấn mạnh hơn): thằng đầu bò đầu bướu",
    example: "thằng đầu bò đầu bướu",
  },
  {
    word: "đầu bò",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) chỉ tính ngang ngạnh, bướng bỉnh, rất khó bảo: quân đầu bò",
    example: "quân đầu bò",
  },
  {
    word: "đầu chày đít thớt",
    part_of_speech: "",
    meaning:
      "(thông tục) ví địa vị thấp kém của người chỉ chuyên làm những việc người khác sai bảo, vất vả khó nhọc nhất: bọn đầu chày đít thớt",
    example: "bọn đầu chày đít thớt",
  },
  {
    word: "đầu bếp",
    part_of_speech: "danh từ",
    meaning: "người làm nghề nấu ăn: tuyển đầu bếp",
    example: "tuyển đầu bếp",
  },
  {
    word: "đầu bếp",
    part_of_speech: "danh từ",
    meaning:
      "người nấu ăn chính: làm nhiệm vụ đầu bếp * được phân công làm đầu bếp cho bữa tiệc",
    example: "làm nhiệm vụ đầu bếp * được phân công làm đầu bếp cho bữa tiệc",
  },
  {
    word: "đầu cua tai nheo",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) đầu đuôi sự việc: chưa hiểu đầu cua tai nheo gì đã làm toáng lên",
    example: "chưa hiểu đầu cua tai nheo gì đã làm toáng lên",
  },
  {
    word: "đầu cơ",
    part_of_speech: "động từ",
    meaning:
      "lợi dụng cơ chế tự phát của thị trường để hoạt động mua bán thu lợi nhuận một cách nhanh chóng và dễ dàng: đầu cơ tích trữ * đầu cơ xăng dầu * đầu cơ sắt thép",
    example: "đầu cơ tích trữ * đầu cơ xăng dầu * đầu cơ sắt thép",
  },
  {
    word: "đầu cơ",
    part_of_speech: "động từ",
    meaning: "lợi dụng cơ hội để mưu lợi riêng: đầu cơ chính trị",
    example: "đầu cơ chính trị",
  },
  {
    word: "đầu cuối",
    part_of_speech: "danh từ",
    meaning:
      "thiết bị bao gồm màn hình và bàn phím cho phép người dùng làm việc với máy tính ở xa.",
    example:
      "khách hàng lắp đặt điện thoại được tặng thiết bị đầu cuối * dịch vụ đầu cuối",
  },
  {
    word: "đầu cuối",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) như đầu đuôi: hỏi rõ đầu cuối câu chuyện * chưa hiểu đầu cuối ra sao",
    example: "hỏi rõ đầu cuối câu chuyện * chưa hiểu đầu cuối ra sao",
  },
  {
    word: "đấu đá",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) phê phán, đả kích, tìm mọi cách hạ uy tín của nhau để tranh giành quyền lợi: cán bộ đấu đá, chia rẽ bè phái",
    example: "cán bộ đấu đá, chia rẽ bè phái",
  },
  {
    word: "đấu dịu",
    part_of_speech: "động từ",
    meaning:
      "chuyển từ thái độ chống đối gay gắt sang thái độ ôn hoà hơn: đành phải đấu dịu để giữ hoà khí * biết sai nên đấu dịu ngay",
    example: "đành phải đấu dịu để giữ hoà khí * biết sai nên đấu dịu ngay",
  },
  {
    word: "đâu đâu",
    part_of_speech: "đại từ",
    meaning:
      "(khẩu ngữ) bất cứ ở đâu, khắp nơi: đâu đâu mọi người cũng bàn tán * tiếng tăm lừng lẫy đâu đâu",
    example: "đâu đâu mọi người cũng bàn tán * tiếng tăm lừng lẫy đâu đâu",
  },
  {
    word: "đâu đâu",
    part_of_speech: "đại từ",
    meaning:
      "linh tinh, không có mục đích: ngồi học mà cứ nghĩ đâu đâu * toàn những chuyện đâu đâu",
    example: "ngồi học mà cứ nghĩ đâu đâu * toàn những chuyện đâu đâu",
  },
  {
    word: "đâu đấy",
    part_of_speech: "đại từ",
    meaning:
      "chỗ nào đó, không biết đích xác, nhưng biết là có: sợ có ai nấp ở đâu đấy nghe lỏm * chuyện này hình như mình đã đọc ở đâu đấy rồi",
    example:
      "sợ có ai nấp ở đâu đấy nghe lỏm * chuyện này hình như mình đã đọc ở đâu đấy rồi",
  },
  {
    word: "đâu đấy",
    part_of_speech: "đại từ",
    meaning: "nơi nào cũng như nơi nào, mọi nơi: đâu đấy đều đã sẵn sàng",
    example: "đâu đấy đều đã sẵn sàng",
  },
  {
    word: "đâu đấy",
    part_of_speech: "đại từ",
    meaning:
      "(khẩu ngữ) đâu vào đấy, hoặc đâu ra đấy (nói tắt): làm xong đâu đấy rồi mới đi * mọi việc đã xong xuôi đâu đấy",
    example: "làm xong đâu đấy rồi mới đi * mọi việc đã xong xuôi đâu đấy",
  },
  {
    word: "đâu đây",
    part_of_speech: "đại từ",
    meaning:
      "chỗ nào đó không rõ, nhưng biết là rất gần đây: nhà anh ấy ở đâu đây thôi * mùi hương bưởi thoang thoảng đâu đây",
    example: "nhà anh ấy ở đâu đây thôi * mùi hương bưởi thoang thoảng đâu đây",
  },
  {
    word: "đầu đàn",
    part_of_speech: "danh từ",
    meaning:
      "con vật lớn nhất, khôn nhất, thường dẫn đầu một đàn, một bầy: con chim đầu đàn * voi đầu đàn",
    example: "con chim đầu đàn * voi đầu đàn",
  },
  {
    word: "đầu đàn",
    part_of_speech: "danh từ",
    meaning:
      "người, đơn vị có vai trò, vị trí dẫn đầu trong một nhóm: những nhà nghiên cứu đầu đàn * đơn vị đầu đàn",
    example: "những nhà nghiên cứu đầu đàn * đơn vị đầu đàn",
  },
  {
    word: "đầu đinh",
    part_of_speech: "danh từ",
    meaning: "ổ nhiễm trùng nhỏ, từ lỗ chân lông: nhọt đầu đinh",
    example: "nhọt đầu đinh",
  },
  {
    word: "đầu độc",
    part_of_speech: "động từ",
    meaning:
      "làm cho ăn hoặc uống phải chất độc nhằm giết hại hoặc làm huỷ hoại cơ thể: chết vì bị đầu độc",
    example: "chết vì bị đầu độc",
  },
  {
    word: "đầu độc",
    part_of_speech: "động từ",
    meaning:
      "làm cho nhiễm phải tư tưởng, văn hoá xấu, không lành mạnh, nhằm gây bại hoại về mặt tinh thần: đầu độc bằng sách báo, phim ảnh khiêu dâm",
    example: "đầu độc bằng sách báo, phim ảnh khiêu dâm",
  },
  {
    word: "đầu đề",
    part_of_speech: "danh từ",
    meaning: "như đầu bài.",
    example: "bài báo có đầu đề rất giật gân",
  },
  {
    word: "đầu đề",
    part_of_speech: "danh từ",
    meaning:
      "tên của một bài báo, bài văn, thơ: bài báo có đầu đề rất giật gân",
    example: "đầu đề của cuộc tranh luận * bị đem ra làm đầu đề giễu cợt",
  },
  {
    word: "đầu đuôi xuôi ngược",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) như đầu đuôi: chưa biết đầu đuôi xuôi ngược thế nào đã làm ầm lên",
    example: "chưa biết đầu đuôi xuôi ngược thế nào đã làm ầm lên",
  },
  {
    word: "đầu đuôi",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ sự việc, từ bắt đầu cho đến kết thúc: nói rõ đầu đuôi câu chuyện * kể đầu đuôi sự tình",
    example: "nói rõ đầu đuôi câu chuyện * kể đầu đuôi sự tình",
  },
  {
    word: "đầu đuôi",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) nguyên do của một việc không hay: không hiểu đầu đuôi tại sao * đầu đuôi là tại nó nên mới hỏng việc",
    example:
      "không hiểu đầu đuôi tại sao * đầu đuôi là tại nó nên mới hỏng việc",
  },
  {
    word: "đầu đường xó chợ",
    part_of_speech: "",
    meaning:
      "tả cảnh sống lang thang, không nhà không cửa: lang thang nơi đầu đường xó chợ",
    example: "lang thang nơi đầu đường xó chợ",
  },
  {
    word: "đầu gấu",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) kẻ cầm đầu một bọn lưu manh, chuyên dùng bạo lực để trấn áp: bọn đầu gấu",
    example: "bọn đầu gấu",
  },
  {
    word: "đấu giá",
    part_of_speech: "động từ",
    meaning:
      "bán bằng hình thức để cho người mua trả giá công khai, ai trả giá cao nhất thì được mua: bán đấu giá quyền sử dụng đất",
    example: "bán đấu giá quyền sử dụng đất",
  },
  {
    word: "đầu gối",
    part_of_speech: "danh từ",
    meaning:
      "mặt trước của chỗ ống chân khớp với đùi: bùn ngập đến đầu gối * đói đầu gối phải bò (tng)",
    example: "bùn ngập đến đầu gối * đói đầu gối phải bò (tng)",
  },
  {
    word: "đầu hai thứ tóc",
    part_of_speech: "",
    meaning:
      "tóc đã có nhiều sợi bạc, biểu hiện sự từng trải, già dặn trong cuộc đời: đầu hai thứ tóc mà còn dại!",
    example: "đầu hai thứ tóc mà còn dại!",
  },
  {
    word: "đầu hồi",
    part_of_speech: "danh từ",
    meaning: "phần tường ở hai đầu nhà: phòng đầu hồi của dãy nhà",
    example: "phòng đầu hồi của dãy nhà",
  },
  {
    word: "đầu hàng",
    part_of_speech: "động từ",
    meaning:
      "chịu thua và chịu chấp nhận làm theo ý muốn của đối phương: tướng giặc đã đầu hàng vô điều kiện",
    example: "tướng giặc đã đầu hàng vô điều kiện",
  },
  {
    word: "đầu hàng",
    part_of_speech: "động từ",
    meaning: "chịu bất lực, không cố gắng khắc phục nữa: đầu hàng hoàn cảnh",
    example: "đầu hàng hoàn cảnh",
  },
  {
    word: "đầu hôm",
    part_of_speech: "danh từ",
    meaning: "khoảng thời gian đầu của buổi tối: đi từ sáng đến đầu hôm mới về",
    example: "đi từ sáng đến đầu hôm mới về",
  },
  {
    word: "đấu khẩu",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) tranh cãi nhau kịch liệt: cuộc đấu khẩu",
    example: "cuộc đấu khẩu",
  },
  {
    word: "đậu hũ",
    part_of_speech: "danh từ",
    meaning: "đậu phụ: món tàu hũ nhồi thịt",
    example: "món tàu hũ nhồi thịt",
  },
  {
    word: "đậu hũ",
    part_of_speech: "danh từ",
    meaning: "tào phở: tàu hũ nước gừng",
    example: "tàu hũ nước gừng",
  },
  {
    word: "đầu lọc",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận ở đầu điếu thuốc lá, được làm bằng chất liệu đặc biệt, có tác dụng lọc bớt chất độc hại khi hút: thuốc lá đầu lọc",
    example: "thuốc lá đầu lọc",
  },
  {
    word: "đầu lòng",
    part_of_speech: "tính từ",
    meaning: "(người con) được sinh ra đầu tiên: sinh con gái đầu lòng",
    example: "sinh con gái đầu lòng",
  },
  {
    word: "đấu loại",
    part_of_speech: "động từ",
    meaning:
      "thi đấu thể thao nhằm loại dần những người hoặc đội kém để chọn vào tranh chức vô địch: vòng đấu loại",
    example: "vòng đấu loại",
  },
  {
    word: "đầu lưỡi",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) (lời) thường xuyên được thốt ra: câu nói đầu lưỡi",
    example: "câu nói đầu lưỡi",
  },
  {
    word: "đầu lưỡi",
    part_of_speech: "tính từ",
    meaning:
      "chỉ là ở lời nói, không thật bụng: anh ta chỉ trung thành ở đầu lưỡi",
    example: "anh ta chỉ trung thành ở đầu lưỡi",
  },
  {
    word: "đầu máy",
    part_of_speech: "danh từ",
    meaning:
      "máy có sức kéo mạnh, chạy trên đường ray, dùng để kéo hoặc đẩy đoàn tàu: đầu máy xe lửa",
    example: "đầu máy xe lửa",
  },
  {
    word: "đầu mục từ",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị từ vựng được ghi ở đầu mỗi mục từ, thường in đậm, làm thành một phần của mục từ, phân biệt với phần giải thích hoặc đối dịch trong nội dung mục từ: đếm đầu mục từ",
    example: "đếm đầu mục từ",
  },
  {
    word: "đầu môi chót lưỡi",
    part_of_speech: "",
    meaning:
      "lời nói ngoài cửa miệng, nói rồi bỏ đấy hoặc quên ngay, không thực lòng: những lời đầu môi chót lưỡi",
    example: "những lời đầu môi chót lưỡi",
  },
  {
    word: "đầu mối",
    part_of_speech: "danh từ",
    meaning: "đầu sợi dây: tìm đầu mối cuộn chỉ",
    example: "tìm đầu mối cuộn chỉ",
  },
  {
    word: "đầu mối",
    part_of_speech: "danh từ",
    meaning:
      "nơi từ đó toả ra nhiều đường đi các hướng: đầu mối giao thông * mua hàng từ chợ đầu mối",
    example: "đầu mối giao thông * mua hàng từ chợ đầu mối",
  },
  {
    word: "đầu mối",
    part_of_speech: "danh từ",
    meaning:
      "khâu chính có tác dụng chi phối các khâu khác, từ đó có thể lần ra để tìm hiểu toàn bộ sự việc (thường là rắc rối, phức tạp): nắm mọi đầu mối trong sản xuất * bịt đầu mối * tìm ra đầu mối của vụ án",
    example:
      "nắm mọi đầu mối trong sản xuất * bịt đầu mối * tìm ra đầu mối của vụ án",
  },
  {
    word: "đầu mối",
    part_of_speech: "danh từ",
    meaning:
      "cái từ đó phát triển thành một sự việc nào đó: đầu mối của cuộc xung đột",
    example: "đầu mối của cuộc xung đột",
  },
  {
    word: "đầu mối",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) người làm nhiệm vụ nội ứng, liên lạc của tổ chức hoạt động bí mật: bắt liên lạc với một đầu mối * đầu mối liên lạc của đội du kích",
    example: "bắt liên lạc với một đầu mối * đầu mối liên lạc của đội du kích",
  },
  {
    word: "đầu mẩu",
    part_of_speech: "danh từ",
    meaning:
      "mẩu nhỏ còn lại hoặc được cắt ra ở đầu của một số vật thể: đầu mẩu bút chì * đầu mẩu thuốc lá",
    example: "đầu mẩu bút chì * đầu mẩu thuốc lá",
  },
  {
    word: "đầu mặt",
    part_of_speech: "danh từ",
    meaning: "mắt giữa hai đốt cây: chém tre chẳng dè đầu mặt (tng)",
    example: "chém tre chẳng dè đầu mặt (tng)",
  },
  {
    word: "đầu nậu",
    part_of_speech: "danh từ",
    meaning:
      "kẻ đứng ra bỏ vốn để thầu một công việc nào đó (thường là không lương thiện): đầu nậu sách * các đầu nậu bỏ vốn ra mua gom hàng với giá rẻ",
    example: "đầu nậu sách * các đầu nậu bỏ vốn ra mua gom hàng với giá rẻ",
  },
  {
    word: "đầu não",
    part_of_speech: "danh từ",
    meaning:
      "đầu óc con người; dùng để ví trung tâm điều khiển và lãnh đạo cao nhất trong một cơ cấu tổ chức: cơ quan đầu não * trung tâm đầu não của tỉnh",
    example: "cơ quan đầu não * trung tâm đầu não của tỉnh",
  },
  {
    word: "đầu ngô mình sở",
    part_of_speech: "",
    meaning:
      "tả tình trạng đầu đuôi không ăn khớp, có tính chất chắp vá: mồm lảm nhảm những câu đầu Ngô mình Sở",
    example: "mồm lảm nhảm những câu đầu Ngô mình Sở",
  },
  {
    word: "đầu nước",
    part_of_speech: "danh từ",
    meaning:
      "đầu dòng nước ở chỗ đê vỡ; thường dùng trong khẩu ngữ để chỉ cái thế không thể tránh khỏi một việc không hay nào đó: chết đầu nước * mình mà thi thì trượt đầu nước",
    example: "chết đầu nước * mình mà thi thì trượt đầu nước",
  },
  {
    word: "đầu óc",
    part_of_speech: "danh từ",
    meaning:
      "đầu của con người, coi là biểu trưng của khả năng nhận thức, suy nghĩ: đầu óc non nớt * đầu óc u mê",
    example: "đầu óc non nớt * đầu óc u mê",
  },
  {
    word: "đầu óc",
    part_of_speech: "danh từ",
    meaning:
      "ý thức, tư tưởng chủ đạo ở mỗi người: có đầu óc kinh doanh * đầu óc nhanh nhạy",
    example: "có đầu óc kinh doanh * đầu óc nhanh nhạy",
  },
  {
    word: "đầu phiếu",
    part_of_speech: "động từ",
    meaning: "bỏ phiếu bầu cử hoặc biểu quyết: cuộc đầu phiếu",
    example: "cuộc đầu phiếu",
  },
  {
    word: "đầu quân",
    part_of_speech: "động từ",
    meaning: "(cũ) tòng quân: đầu quân đi đánh giặc",
    example: "đầu quân đi đánh giặc",
  },
  {
    word: "đầu quân",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tình nguyện xin vào làm cho một đơn vị, tổ chức: đầu quân vào công ti * đầu quân cho một đội bóng lớn",
    example: "đầu quân vào công ti * đầu quân cho một đội bóng lớn",
  },
  {
    word: "đấu pháp",
    part_of_speech: "danh từ",
    meaning:
      "cách thức, phương pháp áp dụng (trong thi đấu thể thao): chọn đấu pháp an toàn * thay đổi đấu pháp cho thích hợp",
    example: "chọn đấu pháp an toàn * thay đổi đấu pháp cho thích hợp",
  },
  {
    word: "đậu phộng",
    part_of_speech: "danh từ",
    meaning: "(Nam) lạc: rang đậu phộng * bơ đậu phộng",
    example: "rang đậu phộng * bơ đậu phộng",
  },
  {
    word: "đậu phụ nhự",
    part_of_speech: "động từ",
    meaning:
      "đưa qua đưa lại dưới nước, khi nghiêng bên này khi nghiêng bên kia, thường để rửa, để xúc: chao chân ở cầu ao * chao rổ xúc tôm",
    example: "chao chân ở cầu ao * chao rổ xúc tôm",
  },
  {
    word: "đậu phụ nhự",
    part_of_speech: "động từ",
    meaning:
      "nghiêng nhanh từ bên này sang bên kia, và ngược lạI: chiếc thuyền chao qua chao lại",
    example: "chiếc thuyền chao qua chao lại",
  },
  {
    word: "đậu phụ nhự",
    part_of_speech: "cảm từ",
    meaning:
      "tiếng thốt ra khi xúc động đột ngột: chao, trăng đêm nay mới đẹp làm sao!",
    example: "chao, trăng đêm nay mới đẹp làm sao!",
  },
  {
    word: "đầu rau",
    part_of_speech: "danh từ",
    meaning:
      "khối đất nặn hình hơi khum, gồm ba hòn đặt chụm đầu vào nhau để bắc nồi lên đun: ông đầu rau",
    example: "ông đầu rau",
  },
  {
    word: "đâu ra đấy",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) (sắp đặt, tính toán) có trật tự trước sau rõ ràng, rất rành mạch và kĩ càng, không nhập nhằng, lộn xộn: nói năng đâu ra đấy * tính toán đâu ra đấy",
    example: "nói năng đâu ra đấy * tính toán đâu ra đấy",
  },
  {
    word: "đầu ra",
    part_of_speech: "danh từ",
    meaning:
      "kết quả hoạt động sản xuất, kinh doanh; phân biệt với đầu vào: dự tính tăng trưởng của đầu ra",
    example: "dự tính tăng trưởng của đầu ra",
  },
  {
    word: "đầu sách",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị tên sách được in: đã xuất bản hàng trăm đầu sách",
    example: "đã xuất bản hàng trăm đầu sách",
  },
  {
    word: "đấu sĩ",
    part_of_speech: "danh từ",
    meaning:
      "người (thường giỏi võ) tham gia thi đấu võ hoặc đấu sức mạnh: đấu sĩ đấu bò tót * đấu sĩ quyền Anh",
    example: "đấu sĩ đấu bò tót * đấu sĩ quyền Anh",
  },
  {
    word: "đầu sai",
    part_of_speech: "danh từ",
    meaning:
      "người ở dưới quyền người khác, luôn phải làm việc theo sự sai bảo (hàm ý coi thường): làm đầu sai cho giặc",
    example: "làm đầu sai cho giặc",
  },
  {
    word: "đầu sỏ",
    part_of_speech: "danh từ",
    meaning: "kẻ cầm đầu (hàm ý coi khinh): bắt được tên đầu sỏ",
    example: "bắt được tên đầu sỏ",
  },
  {
    word: "đầu tay",
    part_of_speech: "tính từ",
    meaning:
      "(tác phẩm) được sáng tác đầu tiên của một người nào đó: truyện ngắn đầu tay",
    example: "truyện ngắn đầu tay",
  },
  {
    word: "đầu têu",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) người đầu tiên bày ra một việc không tốt nào đó rồi lôi kéo người khác bắt chước làm theo: bắt được kẻ đầu têu * việc này là do nó đầu têu",
    example: "bắt được kẻ đầu têu * việc này là do nó đầu têu",
  },
  {
    word: "đầu sông ngọn nguồn",
    part_of_speech: "",
    meaning:
      "chỉ nơi xa xôi, heo hút; cũng dùng để chỉ nguyên nhân, nguồn gốc sâu xa của sự việc: tìm hiểu cho rõ đầu sông ngọn nguồn",
    example: "tìm hiểu cho rõ đầu sông ngọn nguồn",
  },
  {
    word: "đầu tàu",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận hăng hái, tích cực, có vai trò hướng dẫn, thúc đẩy các bộ phận khác trong một phong trào, một cuộc vận động: thanh niên là lực lượng đầu tàu",
    example: "thanh niên là lực lượng đầu tàu",
  },
  {
    word: "đầu tắt mặt tối",
    part_of_speech: "",
    meaning:
      "tả tình trạng phải làm lụng vất vả liên miên, hết việc này đến việc khác, không có lúc nào được nghỉ ngơi: suốt ngày đầu tắt mặt tối",
    example: "suốt ngày đầu tắt mặt tối",
  },
  {
    word: "đấu thầu",
    part_of_speech: "",
    meaning:
      "quá trình lựa chọn nhà thầu đáp ứng đủ yêu cầu để kí kết hợp đồng mua hàng hoặc giao làm công trình: đấu thầu công trình * tổ chức đấu thầu * nộp hồ sơ đấu thầu",
    example: "đấu thầu công trình * tổ chức đấu thầu * nộp hồ sơ đấu thầu",
  },
  {
    word: "đầu tiên",
    part_of_speech: "danh từ",
    meaning:
      "lúc đầu (thời điểm sự việc xảy ra trước nhất, so với những sự việc tiếp sau đó): đầu tiên, anh ấy không nhận ra * đầu tiên, họ từ chối, phải thuyết phục mãi mới được",
    example:
      "đầu tiên, anh ấy không nhận ra * đầu tiên, họ từ chối, phải thuyết phục mãi mới được",
  },
  {
    word: "đầu tiên",
    part_of_speech: "tính từ",
    meaning:
      "trước tất cả những người khác, cái khác: lần đầu tiên * bài học đầu tiên * người về đích đầu tiên",
    example: "lần đầu tiên * bài học đầu tiên * người về đích đầu tiên",
  },
  {
    word: "đầu thú",
    part_of_speech: "động từ",
    meaning:
      "tự ra thú tội trước cơ quan chức năng (sau một thời gian lẩn trốn): kẻ sát nhân đã chịu ra đầu thú",
    example: "kẻ sát nhân đã chịu ra đầu thú",
  },
  {
    word: "đấu tranh",
    part_of_speech: "",
    meaning:
      "dùng sức mạnh để chống lại hay diệt trừ hoặc bảo vệ hay giành lấy (nói khái quát): đấu tranh chống áp bức bóc lột * đấu tranh giữa cái thiện và cái ác",
    example:
      "đấu tranh chống áp bức bóc lột * đấu tranh giữa cái thiện và cái ác",
  },
  {
    word: "đấu thủ",
    part_of_speech: "danh từ",
    meaning:
      "người tham gia thi đấu: đấu thủ cờ vua * hai đấu thủ đang thăm dò nhau",
    example: "đấu thủ cờ vua * hai đấu thủ đang thăm dò nhau",
  },
  {
    word: "đấu tố",
    part_of_speech: "động từ",
    meaning:
      "dùng lí lẽ và bằng chứng để vạch tội và đánh đổ trước sự chứng kiến của đông đảo nhân dân (từ thường dùng trong cuộc vận động cải cách ruộng đất trước đây): đấu tố cường hào, địa chủ",
    example: "đấu tố cường hào, địa chủ",
  },
  {
    word: "đầu trò",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) người giữ vai trò chính trong một việc gì đáng chê trách: bắt giữ tên đầu trò gây rối trật tự",
    example: "bắt giữ tên đầu trò gây rối trật tự",
  },
  {
    word: "đấu trường",
    part_of_speech: "danh từ",
    meaning:
      "nơi diễn ra những cuộc đấu: giành chiến thắng trên đấu trường quốc tế",
    example: "giành chiến thắng trên đấu trường quốc tế",
  },
  {
    word: "đầu trộm đuôi cướp",
    part_of_speech: "",
    meaning:
      "chỉ những kẻ chuyên nghề trộm cướp: một bọn toàn những đầu trộm đuôi cướp",
    example: "một bọn toàn những đầu trộm đuôi cướp",
  },
  {
    word: "đầu tư",
    part_of_speech: "động từ",
    meaning:
      "bỏ nhân lực, vật lực, tài lực vào công việc gì sao cho có hiệu quả kinh tế, xã hội: chính sách đầu tư hợp lí * đầu tư phát triển ngành thủ công mĩ nghệ * kêu gọi vốn đầu tư",
    example:
      "chính sách đầu tư hợp lí * đầu tư phát triển ngành thủ công mĩ nghệ * kêu gọi vốn đầu tư",
  },
  {
    word: "đầu tư",
    part_of_speech: "động từ",
    meaning:
      "tập trung nhiều, bỏ nhiều sức lực, thời gian, v.v. vào công việc gì để có thể thu kết quả tốt: đầu tư suy nghĩ * đầu tư nhiều công sức vào việc học tập",
    example: "đầu tư suy nghĩ * đầu tư nhiều công sức vào việc học tập",
  },
  {
    word: "đấu trí",
    part_of_speech: "động từ",
    meaning: "tranh được thua bằng tài trí: cuộc đấu trí căng thẳng",
    example: "cuộc đấu trí căng thẳng",
  },
  {
    word: "đầu tư chiều sâu",
    part_of_speech: "động từ",
    meaning:
      "tập trung đầu tư vào những lĩnh vực cơ bản như khoa học kĩ thuật, trang thiết bị, nguồn nhân lực, v.v. để có tác động thực sự và lâu dài đến quá trình phát triển: mạnh dạn đầu tư chiều sâu, đổi mới công nghệ",
    example: "mạnh dạn đầu tư chiều sâu, đổi mới công nghệ",
  },
  {
    word: "đầu vào",
    part_of_speech: "danh từ",
    meaning:
      "các chi phí về lao động, vật tư, tiền vốn trong hoạt động sản xuất, kinh doanh; phân biệt với đầu ra: chi phí đầu vào * hạch toán đầu vào",
    example: "chi phí đầu vào * hạch toán đầu vào",
  },
  {
    word: "bản địa",
    part_of_speech: "danh từ",
    meaning: "địa phương nơi sở tại: dân bản địa * nền văn hoá bản địa",
    example: "dân bản địa * nền văn hoá bản địa",
  },
  {
    word: "bàn định",
    part_of_speech: "động từ",
    meaning:
      "bàn bạc và quyết định: bàn định về gia đình * bàn định cách làm ăn",
    example: "bàn định về gia đình * bàn định cách làm ăn",
  },
  {
    word: "bán độ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) cố tình dàn xếp tỉ số trận đấu (thường là thua hoặc hoà đối phương) theo thoả thuận trước với người mua độ để ăn tiền (một hình thức gian lận trong thi đấu thể thao): ngăn chặn hành vi bán độ trong thi đấu thể thao",
    example: "ngăn chặn hành vi bán độ trong thi đấu thể thao",
  },
  {
    word: "bạn đọc",
    part_of_speech: "danh từ",
    meaning:
      "người đọc sách báo, trong quan hệ với tác giả, nhà xuất bản, cơ quan báo chí, thư viện: nhận được thư góp ý của độc giả * sách được tái bản theo yêu cầu của độc giả",
    example:
      "nhận được thư góp ý của độc giả * sách được tái bản theo yêu cầu của độc giả",
  },
  {
    word: "bản đồ",
    part_of_speech: "danh từ",
    meaning:
      "bản vẽ thu nhỏ dùng các kí hiệu, các quy ước để mô tả một phần hay toàn bộ tình trạng phân bố của các hiện tượng tự nhiên hoặc xã hội: bản đồ thế giới * bản đồ kinh tế Việt Nam * bản đồ thiên văn",
    example: "bản đồ thế giới * bản đồ kinh tế Việt Nam * bản đồ thiên văn",
  },
  {
    word: "bạn đường",
    part_of_speech: "danh từ",
    meaning: "người cùng đi đường xa: đi xa có bạn đường cũng đỡ mệt",
    example: "đi xa có bạn đường cũng đỡ mệt",
  },
  {
    word: "bán đứng",
    part_of_speech: "động từ",
    meaning:
      "bán (cái quý giá về tinh thần) một cách không ngại ngần thương tiếc, để mưu lợi riêng: bán đứng danh dự * bị bạn bè bán đứng",
    example: "bán đứng danh dự * bị bạn bè bán đứng",
  },
  {
    word: "ban giám hiệu",
    part_of_speech: "danh từ",
    meaning:
      "tập thể những người lãnh đạo một trường học, đứng đầu là hiệu trưởng: ban giám hiệu nhà trường",
    example: "ban giám hiệu nhà trường",
  },
  {
    word: "bàn giấy",
    part_of_speech: "danh từ",
    meaning: "bàn làm việc về giấy tờ.",
    example: "công chức bàn giấy * được làm ở bàn giấy",
  },
  {
    word: "bàn giấy",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) nơi làm việc về sổ sách, giấy tờ ở cơ quan, nhà máy, văn phòng: công chức bàn giấy * được làm ở bàn giấy",
    example: "công việc bàn giấy * lối làm việc quan liêu, bàn giấy",
  },
  {
    word: "bạn đời",
    part_of_speech: "danh từ",
    meaning:
      "người vợ hoặc người chồng, về mặt sống gắn bó với nhau suốt đời: tìm bạn đời * chọn bạn đời",
    example: "tìm bạn đời * chọn bạn đời",
  },
  {
    word: "bàn giao",
    part_of_speech: "động từ",
    meaning:
      "giao lại công việc, tài liệu, tài sản, v.v. chung cho người hoặc cơ quan khác khi hết trách nhiệm: bàn giao công việc * kí biên bản bàn giao",
    example: "bàn giao công việc * kí biên bản bàn giao",
  },
  {
    word: "bản gốc",
    part_of_speech: "danh từ",
    meaning:
      "bản xuất hiện đầu tiên, là cơ sở để sửa chữa hoặc để lập ra các bản sao: bản gốc giấy khai sinh",
    example: "bản gốc giấy khai sinh",
  },
  {
    word: "bạn hàng",
    part_of_speech: "danh từ",
    meaning: "người cùng buôn bán: chị em bạn hàng ở chợ",
    example: "chị em bạn hàng ở chợ",
  },
  {
    word: "ban hành",
    part_of_speech: "động từ",
    meaning:
      "công bố và cho thi hành (văn bản luật, chính sách, v.v.): ban hành hiến pháp * ban hành một điều luật mới",
    example: "ban hành hiến pháp * ban hành một điều luật mới",
  },
  {
    word: "bán hoa",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) (phụ nữ) bán dâm (lối nói tránh): gái bán hoa",
    example: "gái bán hoa",
  },
  {
    word: "bàn hoàn",
    part_of_speech: "động từ",
    meaning:
      '(cũ, văn chương) quấn quýt không rời: "Phu nhân nửa lệ nửa buồn, Đòi công tử lại mẹ con bàn hoàn." (NĐM)',
    example:
      'Phu nhân nửa lệ nửa buồn, Đòi công tử lại mẹ con bàn hoàn." (NĐM)',
  },
  {
    word: "bàn hoàn",
    part_of_speech: "động từ",
    meaning:
      'nghĩ quanh quẩn không dứt: "Nỗi riêng riêng những bàn hoàn, Dầu chong trắng đĩa, lệ tràn thấm khăn." (TKiều)',
    example:
      'Nỗi riêng riêng những bàn hoàn, Dầu chong trắng đĩa, lệ tràn thấm khăn." (TKiều)',
  },
  {
    word: "ban khen",
    part_of_speech: "động từ",
    meaning: "(trang trọng) khen ngợi (người dưới quyền): được vua ban khen",
    example: "được vua ban khen",
  },
  {
    word: "bạn hữu",
    part_of_speech: "danh từ",
    meaning: "bạn (nói khái quát): tình bạn hữu",
    example: "tình bạn hữu",
  },
  {
    word: "bán khai",
    part_of_speech: "tính từ",
    meaning:
      "đã qua trạng thái dã man, nhưng chưa tới trình độ văn minh: một dân tộc bán khai",
    example: "một dân tộc bán khai",
  },
  {
    word: "bàn là",
    part_of_speech: "danh từ",
    meaning:
      "(Nam bàn ủi) đồ dùng có mặt phẳng bằng kim loại có thể làm nóng lên để là quần áo: bàn là điện",
    example: "bàn là điện",
  },
  {
    word: "bán kết",
    part_of_speech: "danh từ",
    meaning:
      "vòng đấu để chọn đội hoặc vận động viên vào chung kết (trong thi đấu thể thao): trận bán kết * được lọt vào bán kết",
    example: "trận bán kết * được lọt vào bán kết",
  },
  {
    word: "bán kính",
    part_of_speech: "danh từ",
    meaning:
      "đoạn thẳng từ tâm đến một điểm trên đường tròn hoặc trên mặt cầu; nửa đường kính: bán kính hình tròn",
    example: "bán kính hình tròn",
  },
  {
    word: "bản làng",
    part_of_speech: "danh từ",
    meaning:
      "xóm làng ở vùng dân tộc thiểu số miền Bắc Việt Nam: bản làng người Dao",
    example: "bản làng người Dao",
  },
  {
    word: "bản lĩnh",
    part_of_speech: "danh từ",
    meaning:
      "tính cách của người có năng lực và tự tin, dám chịu trách nhiệm, không lùi bước trước khó khăn, trở ngại: thiếu bản lĩnh",
    example: "thiếu bản lĩnh",
  },
  {
    word: "bản lĩnh",
    part_of_speech: "tính từ",
    meaning: "(Khẩu ngữ) có bản lĩnh: một con người rất bản lĩnh",
    example: "một con người rất bản lĩnh",
  },
  {
    word: "bản lề",
    part_of_speech: "danh từ",
    meaning:
      "vật gồm hai miếng kim loại xoay quanh một trục chung, dùng để lắp cánh cửa, nắp hòm, v.v.: lắp bản lề vào cửa * bị long bản lề",
    example: "lắp bản lề vào cửa * bị long bản lề",
  },
  {
    word: "bản lề",
    part_of_speech: "danh từ",
    meaning:
      "vị trí nối tiếp, chuyển tiếp quan trọng: giai đoạn bản lề của nền kinh tế Việt Nam",
    example: "giai đoạn bản lề của nền kinh tế Việt Nam",
  },
  {
    word: "bản mạch chủ",
    part_of_speech: "danh từ",
    meaning:
      "bản mạch chính của máy tính, chứa đơn vị xử lí trung tâm, và các thành phần điện tử khác: sản xuất bản mạch chủ",
    example: "sản xuất bản mạch chủ",
  },
  {
    word: "bán lẻ",
    part_of_speech: "động từ",
    meaning:
      "bán từng cái, từng ít một cho người tiêu dùng; phân biệt với bán buôn: giá bán lẻ * cửa hàng bán lẻ",
    example: "giá bán lẻ * cửa hàng bán lẻ",
  },
  {
    word: "bạn lòng",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương) bạn tâm tình; cũng dùng để chỉ người yêu: thương nhớ bạn lòng",
    example: "thương nhớ bạn lòng",
  },
  {
    word: "bàn luận",
    part_of_speech: "động từ",
    meaning:
      "trao đổi về vấn đề nào đó trên cơ sở phân tích lí lẽ: đưa vấn đề ra bàn luận * bàn luận chuyện thời sự",
    example: "đưa vấn đề ra bàn luận * bàn luận chuyện thời sự",
  },
  {
    word: "bàn lùi",
    part_of_speech: "động từ",
    meaning:
      "bàn với ý không muốn làm, không muốn tiến hành, vì ngại khó: chưa chi đã bàn lùi * nhiều ý kiến bàn lùi",
    example: "chưa chi đã bàn lùi * nhiều ý kiến bàn lùi",
  },
  {
    word: "bán mạng",
    part_of_speech: "phụ từ",
    meaning: "(khẩu ngữ) như thục mạng: chạy bán mạng",
    example: "chạy bán mạng",
  },
  {
    word: "bản mặt",
    part_of_speech: "danh từ",
    meaning:
      "bộ mặt cụ thể của một người (hàm ý coi khinh): nhận rõ bản mặt thâm độc",
    example: "nhận rõ bản mặt thâm độc",
  },
  {
    word: "bàn máy",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận máy có dạng mặt bàn để đặt vật đang được gia công, chế tạo: bàn máy khoan * bàn máy khâu",
    example: "bàn máy khoan * bàn máy khâu",
  },
  {
    word: "bàn mảnh",
    part_of_speech: "động từ",
    meaning:
      '(khẩu ngữ) bàn riêng giữa ít người, tách khỏi tập thể (thường không đàng hoàng): "Nào hai bác có chuyện gì bí mật mà bàn mảnh với nhau thế?" (NgĐLạp; 2)',
    example:
      'Nào hai bác có chuyện gì bí mật mà bàn mảnh với nhau thế?" (NgĐLạp; 2)',
  },
  {
    word: "ban mai",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương) buổi sáng, lúc sáng sớm: ánh nắng ban mai * không khí ban mai trong lành",
    example: "ánh nắng ban mai * không khí ban mai trong lành",
  },
  {
    word: "bản mạch",
    part_of_speech: "danh từ",
    meaning: "tấm plastic có gắn sẵn các mạch dẫn điện: bản mạch âm thanh",
    example: "bản mạch âm thanh",
  },
  {
    word: "ban nãy",
    part_of_speech: "danh từ",
    meaning:
      'lúc vừa mới rồi, cách đây chưa lâu: nó vừa đi ban nãy * "(…) hàng loạt bom nổ ầm ầm, chuyển động cả một vùng rừng ban nãy còn lặng phắc như tờ." (ĐGiỏi; 4)',
    example:
      'nó vừa đi ban nãy * "(…) hàng loạt bom nổ ầm ầm, chuyển động cả một vùng rừng ban nãy còn lặng phắc như tờ." (ĐGiỏi; 4)',
  },
  {
    word: "bản năng",
    part_of_speech: "danh từ",
    meaning:
      "hoạt động, hành vi nói chung của một loại động vật (như gà ấp trứng, chim làm tổ) được hình thành trong quá trình tiến hoá và được cố định qua di truyền, có ý nghĩa quan trọng đối với sự sống còn của cá thể và của cả chủng loại: ong gây mật, chim làm tổ là hành động theo bản năng",
    example: "ong gây mật, chim làm tổ là hành động theo bản năng",
  },
  {
    word: "bản năng",
    part_of_speech: "danh từ",
    meaning:
      "phản ứng mà một động vật (trong đó có con người) có một cách bẩm sinh, không có ý thức, đối với thế giới khách quan: bản năng tự vệ",
    example: "bản năng tự vệ",
  },
  {
    word: "ban ngày ban mặt",
    part_of_speech: "",
    meaning:
      'lúc ban ngày sáng sủa (về mặt có thể thấy rất rõ): ăn cướp giữa ban ngày ban mặt * "Để sáng mai, ban ngày ban mặt, nhìn rõ cái mặt ấy xem thế nào!..." (NCao; 13)',
    example:
      'ăn cướp giữa ban ngày ban mặt * "Để sáng mai, ban ngày ban mặt, nhìn rõ cái mặt ấy xem thế nào!..." (NCao; 13)',
  },
  {
    word: "ban ngành",
    part_of_speech: "danh từ",
    meaning:
      "hệ thống tổ chức, cơ quan chuyên môn của nhà nước từ trung ương đến địa phương (nói tổng quát): các cơ quan ban ngành",
    example: "các cơ quan ban ngành",
  },
  {
    word: "ban ngày",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian từ sau khi trời sáng đến trước khi trời tối; phân biệt với ban đêm: việc xảy ra giữa ban ngày * rõ như ban ngày",
    example: "việc xảy ra giữa ban ngày * rõ như ban ngày",
  },
  {
    word: "bán nguyên âm",
    part_of_speech: "danh từ",
    meaning:
      "âm có thể làm chức năng nguyên âm hoặc làm chức năng phụ âm tuỳ vị trí của nó trong âm tiết:  trong  *  là bán nguyên âm",
    example: "trong  *  là bán nguyên âm",
  },
  {
    word: "bản nhạc",
    part_of_speech: "danh từ",
    meaning: "bản ghi bài hát hoặc bài đàn bằng kí hiệu âm nhạc.",
    example: "nghe một bản nhạc",
  },
  {
    word: "bán non",
    part_of_speech: "động từ",
    meaning:
      "bán rẻ trước mùa thu hoạch để nhận tiền trước: hết tiền phải bán non mất mấy sào lúa",
    example: "hết tiền phải bán non mất mấy sào lúa",
  },
  {
    word: "bán nguyệt",
    part_of_speech: "danh từ",
    meaning:
      "(hình) nửa hình tròn (ví như nửa hình mặt trăng): hình bán nguyệt * hồ bán nguyệt",
    example: "hình bán nguyệt * hồ bán nguyệt",
  },
  {
    word: "ban ơn",
    part_of_speech: "động từ",
    meaning:
      "ban ơn huệ cho người dưới (với thái độ của kẻ bề trên): tư tưởng ban ơn * cho với thái độ ban ơn",
    example: "tư tưởng ban ơn * cho với thái độ ban ơn",
  },
  {
    word: "bán phá giá",
    part_of_speech: "động từ",
    meaning:
      "bán hàng hoá với giá thấp hơn giá thị trường, thậm chí chịu lỗ, để tăng khả năng cạnh tranh và chiếm đoạt thị trường: dự thảo luật chống bán phá giá",
    example: "dự thảo luật chống bán phá giá",
  },
  {
    word: "bản quyền",
    part_of_speech: "danh từ",
    meaning:
      "quyền tác giả và quyền sở hữu sản phẩm trí tuệ, được luật pháp quy định: vi phạm bản quyền * phần mềm đã được đăng kí bản quyền",
    example: "vi phạm bản quyền * phần mềm đã được đăng kí bản quyền",
  },
  {
    word: "bàn phím",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận tập hợp các phím trong một số loại đàn như piano, accordeon, đàn ống, v.v..",
    example: "bàn phím máy tính",
  },
  {
    word: "bán rao",
    part_of_speech: "động từ",
    meaning:
      'bán bằng cách rao tên hàng to lên để mời khách; cũng dùng để chỉ việc bán những loại hàng không tốt, không ra gì: đi bán rao báo * "Thật vàng, chẳng phải bán rao, Có mua thời vác tiền vào mà mua." (ca dao)',
    example:
      'đi bán rao báo * "Thật vàng, chẳng phải bán rao, Có mua thời vác tiền vào mà mua." (ca dao)',
  },
  {
    word: "bản sao",
    part_of_speech: "danh từ",
    meaning:
      "văn bản sao lại y nguyên bản gốc: bản sao giấy khai sinh * bản sao bằng tốt nghiệp",
    example: "bản sao giấy khai sinh * bản sao bằng tốt nghiệp",
  },
  {
    word: "bản sắc",
    part_of_speech: "danh từ",
    meaning:
      "những yếu tố tốt đẹp tạo nên một tính chất đặc thù, nói chung: giữ gìn bản sắc dân tộc",
    example: "giữ gìn bản sắc dân tộc",
  },
  {
    word: "bàn soạn",
    part_of_speech: "động từ",
    meaning:
      "bàn bạc để sắp đặt (làm việc gì): bàn soạn công việc * tự ý làm, không bàn soạn với ai",
    example: "bàn soạn công việc * tự ý làm, không bàn soạn với ai",
  },
  {
    word: "bàn ra",
    part_of_speech: "động từ",
    meaning:
      'bàn với ý không tán thành: thấy khó, có nhiều ý kiến bàn ra * "Ô hay, bàn vào chả bàn lại cứ bàn ra!" (ĐVũ; 1)',
    example:
      'thấy khó, có nhiều ý kiến bàn ra * "Ô hay, bàn vào chả bàn lại cứ bàn ra!" (ĐVũ; 1)',
  },
  {
    word: "bàn tay",
    part_of_speech: "danh từ",
    meaning:
      "phần cuối của tay, có các ngón tay, để cầm nắm, sờ mó, lao động; thường được coi là biểu tượng của sự lao động chân tay có tính sáng tạo của con người: nắm chặt trong lòng bàn tay * đi lên từ hai bàn tay trắng",
    example: "nắm chặt trong lòng bàn tay * đi lên từ hai bàn tay trắng",
  },
  {
    word: "bàn tay",
    part_of_speech: "danh từ",
    meaning:
      "bàn tay, coi là biểu tượng của hành động của con người (thường hàm ý chê): có bàn tay kẻ xấu nhúng vào * thoát khỏi bàn tay tử thần",
    example: "có bàn tay kẻ xấu nhúng vào * thoát khỏi bàn tay tử thần",
  },
  {
    word: "bán sơn địa",
    part_of_speech: "danh từ",
    meaning:
      "vùng đất vừa có nhiều núi, vừa có những khoảng đất rộng bằng phẳng: vùng bán sơn địa",
    example: "vùng bán sơn địa",
  },
  {
    word: "bán sống bán chết",
    part_of_speech: "",
    meaning:
      "ở tình trạng đau đớn hoặc vất vả đến mức như sống dở chết dở: bị một trận đòn bán sống bán chết * chạy bán sống bán chết",
    example: "bị một trận đòn bán sống bán chết * chạy bán sống bán chết",
  },
  {
    word: "ban sơ",
    part_of_speech: "danh từ",
    meaning: "(hiếm) ban đầu: thuở ban sơ",
    example: "thuở ban sơ",
  },
  {
    word: "bàn tán",
    part_of_speech: "động từ",
    meaning:
      "bàn luận rộng rãi một cách không có tổ chức và không đi đến kết luận: dư luận bàn tán xôn xao * xì xào bàn tán",
    example: "dư luận bàn tán xôn xao * xì xào bàn tán",
  },
  {
    word: "bàn ra tán vào",
    part_of_speech: "động từ",
    meaning:
      'bàn tán với nhiều ý kiến khác nhau, trái ngược nhau: "Thôi các ông không phải bàn ra tán vào! Nói lắm chỉ nát chuyện!" (VTrPhụng; 4)',
    example:
      'Thôi các ông không phải bàn ra tán vào! Nói lắm chỉ nát chuyện!" (VTrPhụng; 4)',
  },
  {
    word: "bàn tay vàng",
    part_of_speech: "",
    meaning:
      "bàn tay tài giỏi hiếm có, rất thành thục trong việc thực hiện một thao tác lao động hoặc kĩ thuật nhất định: người thợ có đôi bàn tay vàng",
    example: "người thợ có đôi bàn tay vàng",
  },
  {
    word: "bàn thạch",
    part_of_speech: "danh từ",
    meaning: "(hiếm) tảng đá to: vững như bàn thạch",
    example: "vững như bàn thạch",
  },
  {
    word: "bán tháo",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bán với giá thấp hơn hẳn giá thị trường, nhằm thu hồi vốn nhanh: bán tháo lô hàng tồn",
    example: "bán tháo lô hàng tồn",
  },
  {
    word: "bàn thảo",
    part_of_speech: "động từ",
    meaning:
      "bàn bạc, thảo luận (ở cuộc họp, hội nghị, v.v.) để đi đến kết luận, quyết định chung: bàn thảo những vấn đề hai bên cùng quan tâm",
    example: "bàn thảo những vấn đề hai bên cùng quan tâm",
  },
  {
    word: "bán thân",
    part_of_speech: "danh từ",
    meaning: "(tượng, ảnh) nửa người: bức tượng bán thân * ảnh chụp bán thân",
    example: "bức tượng bán thân * ảnh chụp bán thân",
  },
  {
    word: "bản thảo",
    part_of_speech: "danh từ",
    meaning:
      "văn bản được soạn ra để đưa in: tác phẩm còn ở dạng bản thảo * gửi bản thảo sang nhà xuất bản",
    example: "tác phẩm còn ở dạng bản thảo * gửi bản thảo sang nhà xuất bản",
  },
  {
    word: "bản thân",
    part_of_speech: "danh từ",
    meaning:
      "tự, chính cá nhân, hoặc sự việc được nói đến: chính bản thân ông ta nói ra * không làm chủ được bản thân * bản thân sự việc này không có gì quan trọng",
    example:
      "chính bản thân ông ta nói ra * không làm chủ được bản thân * bản thân sự việc này không có gì quan trọng",
  },
  {
    word: "bàn thờ",
    part_of_speech: "danh từ",
    meaning:
      "bàn để thờ cúng (thường bày bài vị, di ảnh, đèn, bát hương, phẩm vật, v.v.): bàn thờ tổ tiên * lập bàn thờ",
    example: "bàn thờ tổ tiên * lập bàn thờ",
  },
  {
    word: "bán tín bán nghi",
    part_of_speech: "",
    meaning:
      'nửa tin nửa ngờ: "Hôm qua đã được tin (...), nhưng lão bán tín bán nghi, đêm về ngẫm nghĩ không ngủ được." (ĐVũ; 1)',
    example:
      'Hôm qua đã được tin (...), nhưng lão bán tín bán nghi, đêm về ngẫm nghĩ không ngủ được." (ĐVũ; 1)',
  },
  {
    word: "bàn tính",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng để làm các phép tính số học, gồm một khung hình chữ nhật có nhiều then ngang xâu những con chạy: cộng bằng bàn tính",
    example: "cộng bằng bàn tính",
  },
  {
    word: "bàn tính",
    part_of_speech: "động từ",
    meaning:
      "bàn bạc và tính toán, cân nhắc các mặt lợi hay hại, nên hay không nên: bàn tính chuyện tương lai * mọi việc được bàn tính xong xuôi",
    example: "bàn tính chuyện tương lai * mọi việc được bàn tính xong xuôi",
  },
  {
    word: "bản tính",
    part_of_speech: "danh từ",
    meaning:
      "tính chất hay cá tính vốn có: bản tính thật thà * bản tính yếu đuối",
    example: "bản tính thật thà * bản tính yếu đuối",
  },
  {
    word: "bán tống",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bán nhanh đi, thường với giá đặc biệt hạ: hàng lỗi phải bán tống đi",
    example: "hàng lỗi phải bán tống đi",
  },
  {
    word: "bán trả góp",
    part_of_speech: "động từ",
    meaning:
      "bán hàng nhưng không lấy đủ tiền ngay mà cho người mua trả dần thành nhiều đợt (một phương thức bán chịu để khuyến khích người mua): xe máy bán trả góp",
    example: "xe máy bán trả góp",
  },
  {
    word: "bạn trăm năm",
    part_of_speech: "danh từ",
    meaning: "vợ hoặc chồng, trong quan hệ gắn bó trọn đời: kết bạn trăm năm",
    example: "kết bạn trăm năm",
  },
  {
    word: "bản vẽ",
    part_of_speech: "danh từ",
    meaning:
      "hình vẽ mô tả hình dạng, cấu tạo, kích thước và điều kiện kĩ thuật của bộ phận máy móc, kết cấu hoặc công trình kĩ thuật: bản vẽ thiết kế móng cầu * đọc bản vẽ",
    example: "bản vẽ thiết kế móng cầu * đọc bản vẽ",
  },
  {
    word: "bán trời không văn tự",
    part_of_speech: "",
    meaning:
      'nói năng khoác lác, hành động ngang tàng, liều lĩnh: "Tấn là con nhà giầu, chơi bời ghê gớm, bán trời không văn tự." (VTrPhụng; 14)',
    example:
      'Tấn là con nhà giầu, chơi bời ghê gớm, bán trời không văn tự." (VTrPhụng; 14)',
  },
  {
    word: "bán trú",
    part_of_speech: "tính từ",
    meaning:
      "(trường học) được tổ chức cho học sinh học và ăn ở tại trường cả ngày, chỉ về nhà vào buổi tối: trường tiểu học bán trú * học sinh bán trú",
    example: "trường tiểu học bán trú * học sinh bán trú",
  },
  {
    word: "bản vị",
    part_of_speech: "danh từ",
    meaning:
      "trọng lượng kim loại quý dùng làm đơn vị tiền tệ cơ sở của một nước.",
    example: "bản vị vàng",
  },
  {
    word: "bản vị",
    part_of_speech: "tính từ",
    meaning:
      "(trong công tác) chỉ quan tâm đến lợi ích của đơn vị mình, không quan tâm đến lợi ích của các đơn vị khác, đến toàn cục: tư tưởng bản vị",
    example: "tư tưởng bản vị",
  },
  {
    word: "bán tự động",
    part_of_speech: "tính từ",
    meaning:
      "(máy móc) có tính chất tự hoạt động một phần sau khi được khởi động, một phần do con người tác động vào: thiết bị bán tự động",
    example: "thiết bị bán tự động",
  },
  {
    word: "bán vợ đợ con",
    part_of_speech: "",
    meaning:
      'cho vợ con đi ở đợ để trang trải nợ nần, do hoàn cảnh túng quẫn đến cùng cực, trong xã hội thời trước: "Nhà trò nó bỏ bùa mê vào nước cho mà uống, rồi lú lấp, u mê đi, rồi về bán vợ đợ con vì chúng nó." (THoài; 12)',
    example:
      'Nhà trò nó bỏ bùa mê vào nước cho mà uống, rồi lú lấp, u mê đi, rồi về bán vợ đợ con vì chúng nó." (THoài; 12)',
  },
  {
    word: "bản xứ",
    part_of_speech: "danh từ",
    meaning:
      "(thuộc địa) nơi sở tại (thường hàm ý coi khinh, theo quan điểm của chủ nghĩa thực dân): người bản xứ",
    example: "người bản xứ",
  },
  {
    word: "bán vũ trang",
    part_of_speech: "tính từ",
    meaning:
      "được vũ trang (thường bằng những vũ khí thô sơ) để vừa chiến đấu vừa sản xuất: lực lượng dân quân bán vũ trang",
    example: "lực lượng dân quân bán vũ trang",
  },
  {
    word: "bán xới",
    part_of_speech: "động từ",
    meaning:
      '(khẩu ngữ) bỏ quê hương, xứ sở mà đi: bán xới đi nơi khác * "Mất trâu của nó thì bà cháu mình đến phải bán xới!" (MPTư; 1)',
    example:
      'bán xới đi nơi khác * "Mất trâu của nó thì bà cháu mình đến phải bán xới!" (MPTư; 1)',
  },
  {
    word: "báng",
    part_of_speech: "danh từ",
    meaning:
      "cây mọc hoang trong rừng ẩm nhiệt đới, cùng họ với dừa, mặt dưới lá hơi trắng, thân cho thứ bột ăn được: bột báng",
    example: "bột báng",
  },
  {
    word: "báng",
    part_of_speech: "danh từ",
    meaning:
      "chứng bụng to do nước ứ trong ổ bụng hay do sưng lá lách: bụng báng",
    example: "bụng báng",
  },
  {
    word: "báng",
    part_of_speech: "danh từ",
    meaning:
      "ống mai, ống bương để đựng nước (phổ biến ở miền núi): vác báng ra suối lấy nước",
    example: "vác báng ra suối lấy nước",
  },
  {
    word: "báng",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận ở cuối khẩu súng cầm tay, thường bằng gỗ, dùng để tì hoặc giữ súng khi bắn: báng súng trường * khẩu tiểu liên báng gập * tì báng súng vào vai",
    example:
      "báng súng trường * khẩu tiểu liên báng gập * tì báng súng vào vai",
  },
  {
    word: "báng",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) húc (nói về súc vật có sừng): hai con trâu báng nhau",
    example: "hai con trâu báng nhau",
  },
  {
    word: "bang",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị hành chính có tư cách quốc gia tự trị ở một số nước theo chế độ liên bang: thống đốc bang",
    example: "thống đốc bang",
  },
  {
    word: "bảng",
    part_of_speech: "danh từ",
    meaning:
      "vật mỏng có mặt phẳng, thường bằng gỗ, dùng để viết hoặc dán những gì cần nêu cho mọi người xem: bảng yết thị * gọi học sinh lên bảng * bảng gỗ",
    example: "bảng yết thị * gọi học sinh lên bảng * bảng gỗ",
  },
  {
    word: "bảng",
    part_of_speech: "danh từ",
    meaning:
      "bản thường có cột và hàng, dùng để kê một nội dung nào đó, theo thứ tự và cách thức nhất định: bảng thống kê * lập bảng danh sách * kẻ bảng",
    example: "bảng thống kê * lập bảng danh sách * kẻ bảng",
  },
  {
    word: "bảng cân đối",
    part_of_speech: "danh từ",
    meaning:
      "bảng trình bày một cách tổng quát hệ thống các chỉ tiêu kinh tế trình bày dưới dạng tổng quát những tỉ lệ chủ yếu và các quan hệ tỉ lệ trong một đơn vị kinh tế: bảng cân đối tài chính * bảng cân đối thu chi ngân sách năm 2005",
    example: "bảng cân đối tài chính * bảng cân đối thu chi ngân sách năm 2005",
  },
  {
    word: "bàng",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) cói: võng bàng",
    example: "võng bàng",
  },
  {
    word: "bảng biểu",
    part_of_speech: "danh từ",
    meaning: "bảng và biểu (nói khái quát): làm quen với cách tạo bảng biểu",
    example: "làm quen với cách tạo bảng biểu",
  },
  {
    word: "bàng bạc",
    part_of_speech: "tính từ",
    meaning:
      'có màu hơi bạc: đám mây bàng bạc  * "(…) trên mặt sông, ánh sao mờ mờ hắt xuống những vệt lăn tăn bàng bạc đẹp đến lạ lùng." (NgHThiệp; 1)',
    example:
      'đám mây bàng bạc  * "(…) trên mặt sông, ánh sao mờ mờ hắt xuống những vệt lăn tăn bàng bạc đẹp đến lạ lùng." (NgHThiệp; 1)',
  },
  {
    word: "bàng bạc",
    part_of_speech: "động từ",
    meaning:
      "(văn chương) tràn ngập, đâu cũng thấy có: khí thế anh hùng bàng bạc khắp non sông",
    example: "khí thế anh hùng bàng bạc khắp non sông",
  },
  {
    word: "bảng cửu chương",
    part_of_speech: "danh từ",
    meaning:
      "bảng kê tất cả các tích số của hai số nguyên từ 2 lần 1 đến 9 lần 10: học thuộc lòng bảng cửu chương",
    example: "học thuộc lòng bảng cửu chương",
  },
  {
    word: "báng bổ",
    part_of_speech: "động từ",
    meaning:
      "chế giễu, bài bác cái mà người khác cho là linh thiêng: báng bổ thần thánh * ăn nói báng bổ",
    example: "báng bổ thần thánh * ăn nói báng bổ",
  },
  {
    word: "bang giao",
    part_of_speech: "động từ",
    meaning:
      "giao thiệp về mặt nhà nước giữa nước này với nước khác: quan hệ bang giao giữa hai nước",
    example: "quan hệ bang giao giữa hai nước",
  },
  {
    word: "bàng hoàng",
    part_of_speech: "tính từ",
    meaning:
      'ngẩn người ra, choáng váng đến mức như không còn ý thức được gì nữa: bàng hoàng trước tin dữ * "Bàng hoàng dở tỉnh dở say, Sảnh đường mảng tiếng đòi ngay lên hầu." (TKiều)',
    example:
      'bàng hoàng trước tin dữ * "Bàng hoàng dở tỉnh dở say, Sảnh đường mảng tiếng đòi ngay lên hầu." (TKiều)',
  },
  {
    word: "bảng chữ cái",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp tất cả các chữ cái có trong một ngôn ngữ, được sắp xếp theo một trật tự nhất định: xếp theo bảng chữ cái tiếng Việt * bảng chữ cái Latin",
    example: "xếp theo bảng chữ cái tiếng Việt * bảng chữ cái Latin",
  },
  {
    word: "bảng hiệu",
    part_of_speech: "danh từ",
    meaning:
      "bảng ghi tên thương hiệu cùng một số thông tin cần thiết nhất, dùng trong quảng cáo và giao dịch: trương bảng hiệu",
    example: "trương bảng hiệu",
  },
  {
    word: "bảng lảng",
    part_of_speech: "tính từ",
    meaning:
      '(ánh sáng) lờ mờ, chập chờn, không rõ nét: "Trời chiều bảng lảng bóng hoàng hôn, Tiếng ốc xa đưa vẳng trống dồn." (BHThQuan; 1)',
    example:
      'Trời chiều bảng lảng bóng hoàng hôn, Tiếng ốc xa đưa vẳng trống dồn." (BHThQuan; 1)',
  },
  {
    word: "bàng quan",
    part_of_speech: "động từ",
    meaning:
      "tự coi mình là người ngoài cuộc, coi là không dính líu đến mình: bàng quan với thời cuộc * thái độ bàng quan, vô trách nhiệm",
    example: "bàng quan với thời cuộc * thái độ bàng quan, vô trách nhiệm",
  },
  {
    word: "bảng tổng sắp",
    part_of_speech: "danh từ",
    meaning:
      "bảng phân loại xếp hạng toàn bộ: đội chủ nhà đứng đầu bảng tổng sắp huy chương",
    example: "đội chủ nhà đứng đầu bảng tổng sắp huy chương",
  },
  {
    word: "bạng nhạng",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) bạc nhạc: miếng thịt bạng nhạng",
    example: "miếng thịt bạng nhạng",
  },
  {
    word: "bảng vàng",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) bảng được dán giấy vàng để yết tên những người đỗ khoa thi hội, thi đình: đậu bảng vàng * chiếm bảng vàng",
    example: "đậu bảng vàng * chiếm bảng vàng",
  },
  {
    word: "bảng vàng",
    part_of_speech: "danh từ",
    meaning:
      "bảng danh dự ghi tên những người hoặc đơn vị có thành tích lớn: bảng vàng thi đua * được ghi tên vào bảng vàng truyền thống của đơn vị",
    example:
      "bảng vàng thi đua * được ghi tên vào bảng vàng truyền thống của đơn vị",
  },
  {
    word: "banh",
    part_of_speech: "danh từ",
    meaning: "(Nam) quả bóng: chơi đá banh",
    example: "chơi đá banh",
  },
  {
    word: "banh",
    part_of_speech: "động từ",
    meaning:
      'mở to hai bên ra: banh mắt nhìn * trời lạnh đừng có banh ngực áo ra * "Nó dùng hai ngón tay banh họng con cá (...)" (ĐGiỏi; 4)',
    example:
      'banh mắt nhìn * trời lạnh đừng có banh ngực áo ra * "Nó dùng hai ngón tay banh họng con cá (...)" (ĐGiỏi; 4)',
  },
  {
    word: "banh",
    part_of_speech: "tính từ",
    meaning: "(Nam) tan tành, vụn nát: ngôi nhà bị bom đạn phá banh",
    example: "ngôi nhà bị bom đạn phá banh",
  },
  {
    word: "bảnh",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (vẻ bên ngoài) sang và đẹp một cách chải chuốt: bảnh trai * diện bảnh * anh chàng trông rất bảnh",
    example: "bảnh trai * diện bảnh * anh chàng trông rất bảnh",
  },
  {
    word: "bảnh",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) cừ, giỏi: làm được như thế thì bảnh thật!",
    example: "làm được như thế thì bảnh thật!",
  },
  {
    word: "bạnh",
    part_of_speech: "tính từ",
    meaning:
      "rộng, to về bề ngang (thường nói về quai hàm): cằm bạnh * cổ to bạnh * quai hàm hơi bạnh",
    example: "cằm bạnh * cổ to bạnh * quai hàm hơi bạnh",
  },
  {
    word: "bạnh",
    part_of_speech: "động từ",
    meaning:
      "lấy gân sức làm cho quai hàm, cổ dãn rộng hoặc phình to ra: con rắn bạnh cổ nuốt mồi * bạnh quai hàm ra",
    example: "con rắn bạnh cổ nuốt mồi * bạnh quai hàm ra",
  },
  {
    word: "bánh",
    part_of_speech: "danh từ",
    meaning:
      "món ăn chín có hình khối nhất định, chế biến bằng bột hoặc gạo, thường có thêm chất ngọt, mặn, béo: nhân bánh * xay bột làm bánh",
    example: "nhân bánh * xay bột làm bánh",
  },
  {
    word: "bánh",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị có hình khối bề ngoài giống như chiếc bánh: bánh xà phòng * bánh pháo * thuốc lào đóng thành bánh",
    example: "bánh xà phòng * bánh pháo * thuốc lào đóng thành bánh",
  },
  {
    word: "bánh",
    part_of_speech: "danh từ",
    meaning: "bánh xe (nói tắt): xe ba bánh * tàu chuyển bánh",
    example: "xe ba bánh * tàu chuyển bánh",
  },
  {
    word: "bảnh bao",
    part_of_speech: "tính từ",
    meaning:
      '(khẩu ngữ) bảnh (nói khái quát; thường chỉ nói về đàn ông): anh ta trông khá bảnh bao * "Quá niên trạc ngoại tứ tuần, Mày râu nhẵn nhụi, áo quần bảnh bao." (TKiều)',
    example:
      'anh ta trông khá bảnh bao * "Quá niên trạc ngoại tứ tuần, Mày râu nhẵn nhụi, áo quần bảnh bao." (TKiều)',
  },
  {
    word: "bành",
    part_of_speech: "danh từ",
    meaning:
      'ghế có lưng tựa và hai tay vịn, đặt lên lưng voi để ngồi: "Ru con con ngủ cho lành, Để mẹ gánh nước rửa bành cho voi." (ca dao)',
    example:
      'Ru con con ngủ cho lành, Để mẹ gánh nước rửa bành cho voi." (ca dao)',
  },
  {
    word: "bành",
    part_of_speech: "tính từ",
    meaning:
      'to, rộng ra về bề ngang: to bành * cằm bành rộng * "Tảng đá chìa mái, nhớp nháp bành ra như cái tai voi." (THoài; 20)',
    example:
      'to bành * cằm bành rộng * "Tảng đá chìa mái, nhớp nháp bành ra như cái tai voi." (THoài; 20)',
  },
  {
    word: "bành bạnh",
    part_of_speech: "tính từ",
    meaning: "quá bạnh, trông thô và rất mất cân đối: cằm bành bạnh",
    example: "cằm bành bạnh",
  },
  {
    word: "bánh bao",
    part_of_speech: "danh từ",
    meaning:
      "bánh làm bằng bột mì ủ men, hấp chín, có nhân mặn hoặc ngọt: bánh bao chay (không có nhân)",
    example: "bánh bao chay (không có nhân)",
  },
  {
    word: "bánh chè",
    part_of_speech: "danh từ",
    meaning:
      "chỗ xương ở đầu gối thân người, có hình tròn, dẹt: xương bánh chè",
    example: "xương bánh chè",
  },
  {
    word: "bảnh choẹ",
    part_of_speech: "tính từ",
    meaning:
      'có vẻ oai vệ, tự đắc (thường nói về tư thế ngồi): "Ghế tréo lọng xanh ngồi bảnh choẹ, Nghĩ rằng đồ thật hoá đồ chơi." (NgKhuyến; 5)',
    example:
      'Ghế tréo lọng xanh ngồi bảnh choẹ, Nghĩ rằng đồ thật hoá đồ chơi." (NgKhuyến; 5)',
  },
  {
    word: "bánh đa",
    part_of_speech: "danh từ",
    meaning:
      "bánh thường làm bằng bột gạo tẻ hay sắn, khoai, v.v. xay ướt, tráng thành tấm mỏng hình tròn, thường có rắc vừng rồi phơi khô, khi ăn thì nướng lên.",
    example: "canh bánh đa cua",
  },
  {
    word: "bánh đúc",
    part_of_speech: "danh từ",
    meaning:
      "bánh nấu bằng bột gạo tẻ hoặc bột ngô quấy với nước vôi trong và hàn the, khi chín đổ ra cho đông thành tảng: quấy bánh đúc * má bánh đúc (má tròn đầy phinh phính)",
    example: "quấy bánh đúc * má bánh đúc (má tròn đầy phinh phính)",
  },
  {
    word: "bảnh mắt",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) mở mắt thức dậy (vào lúc sáng sớm): mới bảnh mắt đã đi * sáng bảnh mắt ra rồi còn ngủ",
    example: "mới bảnh mắt đã đi * sáng bảnh mắt ra rồi còn ngủ",
  },
  {
    word: "bánh lái",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận xoay được dùng để đổi hướng đi của phương tiện vận tải: bánh lái tàu thuỷ",
    example: "bánh lái tàu thuỷ",
  },
  {
    word: "đâu vào đấy",
    part_of_speech: "",
    meaning: "(khẩu ngữ) như đâu ra đấy: mọi việc đã được cắt đặt đâu vào đấy",
    example: "mọi việc đã được cắt đặt đâu vào đấy",
  },
  {
    word: "đâu vào đấy",
    part_of_speech: "",
    meaning:
      "lại như cũ, không có gì thay đổi: vừa mới dọn xong đã lại đâu vào đấy",
    example: "vừa mới dọn xong đã lại đâu vào đấy",
  },
  {
    word: "đầu xanh",
    part_of_speech: "danh từ",
    meaning:
      'tuổi còn trẻ: từ thuở đầu xanh * "Buồng không lần lữa hôm mai, Đầu xanh mấy chốc da mồi tóc sương." (ca dao)',
    example:
      'từ thuở đầu xanh * "Buồng không lần lữa hôm mai, Đầu xanh mấy chốc da mồi tóc sương." (ca dao)',
  },
  {
    word: "đầu video",
    part_of_speech: "danh từ",
    meaning: "máy phát băng hoặc đĩa hình: đầu video đa hệ",
    example: "đầu video đa hệ",
  },
  {
    word: "đấu xảo",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức trưng bày để giới thiệu các sản phẩm và hàng hoá của một địa phương, một ngành, một nước hoặc nhiều nước trong một thời gian nhất định: hội chợ triển lãm * tham gia hội chợ quốc tế",
    example: "hội chợ triển lãm * tham gia hội chợ quốc tế",
  },
  {
    word: "đầy",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái không còn chứa thêm được nữa, thêm vào là tràn ra: thóc đầy bồ * bể đầy, nước tràn cả ra ngoài * ăn ở như bát nước đầy (tng)",
    example:
      "thóc đầy bồ * bể đầy, nước tràn cả ra ngoài * ăn ở như bát nước đầy (tng)",
  },
  {
    word: "đầy",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái có nhiều và khắp cả: trời đầy sao * cơ thể đầy sức sống * chặng đường đầy thử thách",
    example: "trời đầy sao * cơ thể đầy sức sống * chặng đường đầy thử thách",
  },
  {
    word: "đầy",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái có thể tích tối đa, do có đủ các phần hoặc đủ chất cấu tạo: cho ăn đầy bữa * ăn uống đầy đủ, người đã đầy hơn * trăng đầy (không khuyết)",
    example:
      "cho ăn đầy bữa * ăn uống đầy đủ, người đã đầy hơn * trăng đầy (không khuyết)",
  },
  {
    word: "đầy",
    part_of_speech: "tính từ",
    meaning:
      "đủ số lượng một đơn vị: cháu bé sắp đầy tuổi * xa nhà đã đầy một năm",
    example: "cháu bé sắp đầy tuổi * xa nhà đã đầy một năm",
  },
  {
    word: "đầy",
    part_of_speech: "tính từ",
    meaning:
      "(bụng) có cảm giác căng, khó chịu, do ăn không tiêu: bụng đầy, không muốn ăn",
    example: "bụng đầy, không muốn ăn",
  },
  {
    word: "đây",
    part_of_speech: "đại từ",
    meaning:
      "từ dùng để chỉ sự vật, địa điểm ở ngay vị trí người nói đang nói hoặc ở ngay thời điểm nói: đây là anh tôi * đây, anh cầm lấy * ở đây * cách đây ba năm",
    example: "đây là anh tôi * đây, anh cầm lấy * ở đây * cách đây ba năm",
  },
  {
    word: "đây",
    part_of_speech: "đại từ",
    meaning:
      'từ người nói dùng để tự xưng với người đối thoại một cách thân mật, hoặc trịch thượng, sỗ sàng; đối lập với đấy (là từ dùng để gọi người đối thoại): "Miếng trầu là nghĩa tương giao, Muốn cho đây đấy duyên vào hợp duyên." (ca dao)',
    example:
      'Miếng trầu là nghĩa tương giao, Muốn cho đây đấy duyên vào hợp duyên." (ca dao)',
  },
  {
    word: "đây",
    part_of_speech: "trợ từ",
    meaning:
      "(khẩu ngữ) từ biểu thị ý nhấn mạnh về tính chất hiện diện, cụ thể của người, cái, điều vừa được nói đến: đúng chỗ này đây * tôi về đây!",
    example: "đúng chỗ này đây * tôi về đây!",
  },
  {
    word: "đây",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý nhấn mạnh sự băn khoăn của người nói về điều vừa nêu ra như để tự hỏi mình: không biết rồi sẽ ra sao đây? * chắc lại có chuyện rồi đây?",
    example: "không biết rồi sẽ ra sao đây? * chắc lại có chuyện rồi đây?",
  },
  {
    word: "đẫy",
    part_of_speech: "tính từ",
    meaning:
      "có lượng đạt mức tối đa, thoả mãn, đủ yêu cầu: ăn no đẫy bụng * ngủ đẫy mắt * đẫy hạt",
    example: "ăn no đẫy bụng * ngủ đẫy mắt * đẫy hạt",
  },
  {
    word: "đẫy",
    part_of_speech: "tính từ",
    meaning: "(cơ thể) đầy đặn, hơi béo: vóc người đã hơi đẫy ra",
    example: "vóc người đã hơi đẫy ra",
  },
  {
    word: "đậy",
    part_of_speech: "động từ",
    meaning:
      "lấy vật gì úp, trùm lên trên cho kín, thường là để bảo vệ cho khỏi phải chịu một tác động nào đó từ bên ngoài: lấy tờ báo đậy lên trên * đậy vung nồi * tốt đẹp phô ra, xấu xa đậy lại (tng)",
    example:
      "lấy tờ báo đậy lên trên * đậy vung nồi * tốt đẹp phô ra, xấu xa đậy lại (tng)",
  },
  {
    word: "đậy",
    part_of_speech: "động từ",
    meaning: "phải nộp, phải trả thay cho ai đó: trả nợ đậy",
    example: "trả nợ đậy",
  },
  {
    word: "đẩy",
    part_of_speech: "động từ",
    meaning:
      "làm cho chuyển động theo một hướng nào đó bằng một lực tác động thẳng tới: đẩy cửa bước vào * đẩy xe lùi lại * bị đẩy vào tình thế khó xử",
    example: "đẩy cửa bước vào * đẩy xe lùi lại * bị đẩy vào tình thế khó xử",
  },
  {
    word: "đẩy",
    part_of_speech: "động từ",
    meaning:
      "làm cho xa ra, cho cách xa ra: đẩy từ bạn sang thù * đẩy lui cuộc tiến công của kẻ thù * đẩy khó khăn cho bạn",
    example:
      "đẩy từ bạn sang thù * đẩy lui cuộc tiến công của kẻ thù * đẩy khó khăn cho bạn",
  },
  {
    word: "đẩy",
    part_of_speech: "động từ",
    meaning:
      "làm cho phát triển mạnh hơn, tạo thành đà: đẩy năng suất lên cao * đẩy nhanh tốc độ phát triển",
    example: "đẩy năng suất lên cao * đẩy nhanh tốc độ phát triển",
  },
  {
    word: "đầy ắp",
    part_of_speech: "tính từ",
    meaning:
      "đầy đến mức chỉ chực tràn ra ngoài, không thể dồn chứa hoặc chất thêm được nữa: thúng gạo đầy ắp * bể đầy ắp nước * căn phòng đầy ắp tiếng cười",
    example: "thúng gạo đầy ắp * bể đầy ắp nước * căn phòng đầy ắp tiếng cười",
  },
  {
    word: "đẫy đà",
    part_of_speech: "tính từ",
    meaning:
      '(người) to béo, mập mạp: vóc người đẫy đà * "Thoắt trông nhờn nhợt màu da, Ăn chi cao lớn đẫy đà làm sao?" (TKiều)',
    example:
      'vóc người đẫy đà * "Thoắt trông nhờn nhợt màu da, Ăn chi cao lớn đẫy đà làm sao?" (TKiều)',
  },
  {
    word: "đấy",
    part_of_speech: "đại từ",
    meaning:
      "từ dùng để chỉ một sự vật, địa điểm, thời điểm hoặc sự việc đã được xác định, được nói đến, nhưng không ở vào vị trí người nói, hoặc không ở vào lúc đang nói: đấy là dãy nhà tập thể * từ đấy về sau * lúc đấy anh đang ở đâu?",
    example: "đấy là dãy nhà tập thể * từ đấy về sau * lúc đấy anh đang ở đâu?",
  },
  {
    word: "đấy",
    part_of_speech: "đại từ",
    meaning:
      "từ dùng để chỉ một sự vật, địa điểm, thời điểm hoặc sự việc được xác định là có, tuy không biết cụ thể: một ngày nào đấy sẽ gặp lại nhau * có điều gì đấy không ổn",
    example: "một ngày nào đấy sẽ gặp lại nhau * có điều gì đấy không ổn",
  },
  {
    word: "đấy",
    part_of_speech: "đại từ",
    meaning:
      '(Khẩu ngữ) từ người nói dùng để gọi người đối thoại một cách thân mật, hoặc trịch thượng, sỗ sàng; đối lập với đây (là từ người nói dùng để tự xưng): "Mẹ già như chuối chín cây, Sao đấy chẳng liệu cho đây liệu cùng." (Cdao)',
    example:
      'Mẹ già như chuối chín cây, Sao đấy chẳng liệu cho đây liệu cùng." (Cdao)',
  },
  {
    word: "đấy",
    part_of_speech: "trợ từ",
    meaning:
      "(Khẩu ngữ) từ biểu thị ý nhấn mạnh về tính chất xác định, đích xác của điều được nói đến: đẹp rồi đấy * đấy, mọi chuyện chỉ có thế * làm nhanh lên đấy!",
    example: "đẹp rồi đấy * đấy, mọi chuyện chỉ có thế * làm nhanh lên đấy!",
  },
  {
    word: "đậy điệm",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đậy cho kín (nói khái quát): thức ăn được đậy điệm cẩn thận * không cần che giấu, đậy điệm",
    example: "thức ăn được đậy điệm cẩn thận * không cần che giấu, đậy điệm",
  },
  {
    word: "đây đó",
    part_of_speech: "đại từ",
    meaning: "như đó đây: đi chơi đây đó",
    example: "đi chơi đây đó",
  },
  {
    word: "đầy đặn",
    part_of_speech: "tính từ",
    meaning:
      'đầy hết, không có chỗ nào lõm, khuyết: bát cơm đầy đặn * "Vân xem trang trọng khác vời, Khuôn trăng đầy đặn nét ngài nở nang." (TKiều)',
    example:
      'bát cơm đầy đặn * "Vân xem trang trọng khác vời, Khuôn trăng đầy đặn nét ngài nở nang." (TKiều)',
  },
  {
    word: "đầy đặn",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) không để có chút gì thiếu sót, chê trách trong cách xử sự với nhau: ăn ở đầy đặn",
    example: "ăn ở đầy đặn",
  },
  {
    word: "đầy đủ",
    part_of_speech: "tính từ",
    meaning:
      "có đủ tất cả, không thiếu gì so với yêu cầu: nhà có tiện nghi đầy đủ *  mọi người đều đã có mặt đầy đủ",
    example: "nhà có tiện nghi đầy đủ *  mọi người đều đã có mặt đầy đủ",
  },
  {
    word: "đây đẩy",
    part_of_speech: "động từ",
    meaning:
      "từ gợi tả điệu bộ, cử chỉ, lời nói tỏ ra kiên quyết không chịu, không nhận: giãy lên đây đẩy * chối đây đẩy",
    example: "giãy lên đây đẩy * chối đây đẩy",
  },
  {
    word: "đẩy lùi",
    part_of_speech: "động từ",
    meaning:
      "làm cho phải lùi lại, không tiến lên, không phát triển được nữa: đẩy lùi dịch bệnh * đẩy lùi đợt tấn công",
    example: "đẩy lùi dịch bệnh * đẩy lùi đợt tấn công",
  },
  {
    word: "đầy năm",
    part_of_speech: "tính từ",
    meaning:
      "(trẻ sinh ra) tròn một năm (tính theo âm lịch): làm lễ đầy năm cho bé",
    example: "làm lễ đầy năm cho bé",
  },
  {
    word: "đầy rẫy",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều, chỗ nào cũng thấy có (thường nói về cái tiêu cực): cuộc sống đầy rẫy khó khăn",
    example: "cuộc sống đầy rẫy khó khăn",
  },
  {
    word: "đẩy mạnh",
    part_of_speech: "động từ",
    meaning:
      "thúc đẩy cho phát triển nhanh, mạnh lên: đẩy mạnh phong trào thi đua * đẩy mạnh sản xuất",
    example: "đẩy mạnh phong trào thi đua * đẩy mạnh sản xuất",
  },
  {
    word: "đầy tháng",
    part_of_speech: "tính từ",
    meaning: "(trẻ sinh ra) tròn một tháng (tính theo âm lịch): lễ đầy tháng",
    example: "lễ đầy tháng",
  },
  {
    word: "đè",
    part_of_speech: "động từ",
    meaning:
      "làm cho phải chịu đựng sức nặng của một vật đặt lên bên trên: đè tay lên tờ giấy * xe đổ, đè gẫy chân * nỗi lo âu đè nặng trong lòng",
    example:
      "đè tay lên tờ giấy * xe đổ, đè gẫy chân * nỗi lo âu đè nặng trong lòng",
  },
  {
    word: "đè",
    part_of_speech: "động từ",
    meaning:
      "tạo thành nét hoặc lớp ngay bên trên nét hoặc lớp đã có từ trước: tô đè lên các nét vẽ cũ",
    example: "tô đè lên các nét vẽ cũ",
  },
  {
    word: "đè",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) nhằm vào, nhè vào: cứ đè lúc ăn cơm mà mắng",
    example: "cứ đè lúc ăn cơm mà mắng",
  },
  {
    word: "đẻ",
    part_of_speech: "động từ",
    meaning:
      "(phụ nữ hay động vật giống cái) cho thoát con hoặc trứng đã phát triển đầy đủ ra ngoài cơ thể: gà đẻ trứng * đẻ con gái đầu lòng * mang nặng đẻ đau",
    example: "gà đẻ trứng * đẻ con gái đầu lòng * mang nặng đẻ đau",
  },
  {
    word: "đẻ",
    part_of_speech: "động từ",
    meaning: "(người hay động vật) được đẻ ra: anh ta đẻ ở quê",
    example: "anh ta đẻ ở quê",
  },
  {
    word: "đẻ",
    part_of_speech: "động từ",
    meaning:
      "(hiện tượng một số cây) ra thêm nhánh hoặc cây con bên cạnh cây mẹ: lúa đẻ nhánh * bèo đẻ đầy ao",
    example: "lúa đẻ nhánh * bèo đẻ đầy ao",
  },
  {
    word: "đẻ",
    part_of_speech: "động từ",
    meaning:
      "trực tiếp làm nảy sinh ra: lãi mẹ đẻ lãi con * đẻ ra nhiều chuyện rắc rối",
    example: "lãi mẹ đẻ lãi con * đẻ ra nhiều chuyện rắc rối",
  },
  {
    word: "đẻ",
    part_of_speech: "tính từ",
    meaning:
      "có quan hệ dòng máu trực tiếp; phân biệt với nuôi: mẹ đẻ * con nuôi cũng quý như con đẻ",
    example: "mẹ đẻ * con nuôi cũng quý như con đẻ",
  },
  {
    word: "đẻ",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, phương ngữ) mẹ (thường dùng để xưng gọi): thầy đẻ * con đi đây đẻ ạ!",
    example: "thầy đẻ * con đi đây đẻ ạ!",
  },
  {
    word: "đầy vơi",
    part_of_speech: "tính từ",
    meaning:
      'đầy lại vơi, vơi rồi lại đầy, liên tiếp, dồn dập không lúc nào cạn: thương nhớ đầy vơi * "Đầy vơi chúc một chén quỳnh, Vì duyên duyên uống, vì tình tình say." (ca dao)',
    example:
      'thương nhớ đầy vơi * "Đầy vơi chúc một chén quỳnh, Vì duyên duyên uống, vì tình tình say." (ca dao)',
  },
  {
    word: "đe",
    part_of_speech: "danh từ",
    meaning:
      "khối sắt hoặc thép dùng làm bệ để đặt kim loại lên trên mà đập bằng búa: đe thợ rèn * trên đe dưới búa (tng)",
    example: "đe thợ rèn * trên đe dưới búa (tng)",
  },
  {
    word: "đe",
    part_of_speech: "động từ",
    meaning:
      "cho biết trước rằng sẽ làm điều không hay nếu dám trái ý, nhằm làm cho sợ: đe đánh * chưa đỗ ông nghè đã đe hàng tổng (tng)",
    example: "đe đánh * chưa đỗ ông nghè đã đe hàng tổng (tng)",
  },
  {
    word: "đè bẹp",
    part_of_speech: "động từ",
    meaning:
      "dùng sức mạnh trấn áp làm cho thất bại hoàn toàn: đè bẹp cuộc bạo động",
    example: "đè bẹp cuộc bạo động",
  },
  {
    word: "đe nẹt",
    part_of_speech: "động từ",
    meaning:
      "mắng, doạ sẽ trừng phạt nếu dám làm trái ý (nói khái quát): đe nẹt con cái * nói bằng giọng đe nẹt",
    example: "đe nẹt con cái * nói bằng giọng đe nẹt",
  },
  {
    word: "đẻ đái",
    part_of_speech: "động từ",
    meaning: "(thông tục) (phụ nữ) đẻ con (nói khái quát): chưa thấy đẻ đái gì",
    example: "chưa thấy đẻ đái gì",
  },
  {
    word: "đè nén",
    part_of_speech: "động từ",
    meaning:
      "dùng quyền thế, sức mạnh ức hiếp, kìm hãm, không cho tự do: đè nén cấp dưới",
    example: "đè nén cấp dưới",
  },
  {
    word: "đè đầu cưỡi cổ",
    part_of_speech: "",
    meaning:
      "dùng quyền lực, sức mạnh mà chèn ép, đè nén người hèn yếu: bị thiên hạ đè đầu cưỡi cổ",
    example: "bị thiên hạ đè đầu cưỡi cổ",
  },
  {
    word: "đầy tớ",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người đi ở trong xã hội cũ, trong quan hệ với chủ: đi làm đầy tớ cho nhà giàu",
    example: "đi làm đầy tớ cho nhà giàu",
  },
  {
    word: "đe doạ",
    part_of_speech: "động từ",
    meaning:
      "doạ làm cho sợ mà không dám hành động (nói khái quát): lời đe doạ",
    example: "lời đe doạ",
  },
  {
    word: "đe doạ",
    part_of_speech: "động từ",
    meaning:
      "tạo ra nỗi lo sợ về một tai hoạ có thể xảy ra: lũ lụt đe doạ mùa màng",
    example: "lũ lụt đe doạ mùa màng",
  },
  {
    word: "đem",
    part_of_speech: "động từ",
    meaning:
      "mang đi theo hoặc dẫn đi theo cùng với mình: đem hàng ra chợ bán * đem con đi cùng",
    example: "đem hàng ra chợ bán * đem con đi cùng",
  },
  {
    word: "đem",
    part_of_speech: "động từ",
    meaning:
      "đưa ra để làm gì đó: đem thóc ra phơi * đem đàn ra gảy * đem chuyện nhà ra kể",
    example: "đem thóc ra phơi * đem đàn ra gảy * đem chuyện nhà ra kể",
  },
  {
    word: "đem",
    part_of_speech: "động từ",
    meaning:
      "đưa đến, làm cho có được: việc làm không đem lại kết quả * đem đến hạnh phúc cho mọi người",
    example: "việc làm không đem lại kết quả * đem đến hạnh phúc cho mọi người",
  },
  {
    word: "đen",
    part_of_speech: "tính từ",
    meaning:
      "có màu như màu của than, của mực tàu: trời tối đen như mực * mèo đen * tóc đen như gỗ mun",
    example: "trời tối đen như mực * mèo đen * tóc đen như gỗ mun",
  },
  {
    word: "đen",
    part_of_speech: "tính từ",
    meaning:
      "có màu tối, không sáng: nước da đen * mây đen ùn ùn kéo đến * màu giấy hơi đen",
    example: "nước da đen * mây đen ùn ùn kéo đến * màu giấy hơi đen",
  },
  {
    word: "đen",
    part_of_speech: "tính từ",
    meaning:
      "được giữ kín, không công khai cho mọi người biết, thường có tính chất phi pháp: quỹ đen * vé chợ đen * sổ đen",
    example: "quỹ đen * vé chợ đen * sổ đen",
  },
  {
    word: "đen",
    part_of_speech: "tính từ",
    meaning: "không được may mắn, theo quan niệm mê tín: số đen * vận đen",
    example: "số đen * vận đen",
  },
  {
    word: "đen",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) đông đến mức như không có chỗ hở và tạo nên một màu tối: người đứng xem đen đặc * đen nghịt * xúm đen xúm đỏ",
    example: "người đứng xem đen đặc * đen nghịt * xúm đen xúm đỏ",
  },
  {
    word: "đem lòng",
    part_of_speech: "động từ",
    meaning:
      'nảy sinh tình cảm nào đó trong lòng: đem lòng hoài nghi * "Ai xui má đỏ hồng hồng, Để anh nhác thấy đem lòng thương yêu." (ca dao)',
    example:
      'đem lòng hoài nghi * "Ai xui má đỏ hồng hồng, Để anh nhác thấy đem lòng thương yêu." (ca dao)',
  },
  {
    word: "đèn",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng để thắp sáng, soi sáng: thắp đèn * bật đèn * đèn nhà ai nhà ấy rạng (tng)",
    example: "thắp đèn * bật đèn * đèn nhà ai nhà ấy rạng (tng)",
  },
  {
    word: "đèn",
    part_of_speech: "danh từ",
    meaning: "đồ dùng phát ra một ngọn lửa toả nhiệt: đèn cồn * đèn hàn",
    example: "đèn cồn * đèn hàn",
  },
  {
    word: "đẹn",
    part_of_speech: "danh từ",
    meaning:
      "bệnh ở trẻ em mới đẻ, có những lớp mụn trắng nhỏ ở lưỡi, ở lợi, do một loại nấm sinh ra: trẻ nổi đẹn",
    example: "trẻ nổi đẹn",
  },
  {
    word: "đẹn",
    part_of_speech: "tính từ",
    meaning:
      "(trẻ em) gầy đét lại, không lớn được do suy dinh dưỡng: con đẹn, con sài, chớ hoài bỏ đi (tng)",
    example: "con đẹn, con sài, chớ hoài bỏ đi (tng)",
  },
  {
    word: "đen bạc",
    part_of_speech: "tính từ",
    meaning:
      '(cũ) bội bạc, không chung thuỷ: "Lửa tâm càng dập, càng nồng, Trách người đen bạc, ra lòng trăng hoa." (TKiều)',
    example:
      'Lửa tâm càng dập, càng nồng, Trách người đen bạc, ra lòng trăng hoa." (TKiều)',
  },
  {
    word: "đèn biển",
    part_of_speech: "danh từ",
    meaning:
      "đèn pha đặt ở bờ biển, hải đảo để giúp tàu thuyền định hướng đi trong đêm tối: ngọn hải đăng",
    example: "ngọn hải đăng",
  },
  {
    word: "đèm đẹp",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) hơi đẹp: trông cũng đèm đẹp",
    example: "trông cũng đèm đẹp",
  },
  {
    word: "đèn cầy",
    part_of_speech: "danh từ",
    meaning:
      "(Nam đèn cầy) thanh trụ làm bằng sáp, có sợi dây ở giữa (gọi là bấc) dùng đốt để thắp sáng: thắp nến * ngọn nến",
    example: "thắp nến * ngọn nến",
  },
  {
    word: "đèn cầy",
    part_of_speech: "danh từ",
    meaning: "đơn vị cũ đo cường độ sáng: bóng đèn 100 nến",
    example: "bóng đèn 100 nến",
  },
  {
    word: "đen đét",
    part_of_speech: "tính từ",
    meaning:
      "như đét (ngI, nhưng ý liên tiếp): phát đen đét vào lưng * vỗ tay đen đét",
    example: "phát đen đét vào lưng * vỗ tay đen đét",
  },
  {
    word: "đèn đóm",
    part_of_speech: "danh từ",
    meaning:
      '(khẩu ngữ) đồ dùng để thắp sáng (nói khái quát): "Trời đen như mực. Không đèn đóm nào chống lại nổi với mưa, với gió." (NCao; 12)',
    example:
      'Trời đen như mực. Không đèn đóm nào chống lại nổi với mưa, với gió." (NCao; 12)',
  },
  {
    word: "đèn đỏ",
    part_of_speech: "danh từ",
    meaning:
      "đèn lắp trên các tuyến đường giao nhau, có ánh sáng màu đỏ, là tín hiệu báo để các phương tiện giao thông dừng chuyển động: vi phạm vượt đèn đỏ",
    example: "vi phạm vượt đèn đỏ",
  },
  {
    word: "đèn đuốc",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) như đèn đóm: đèn đuốc sáng trưng",
    example: "đèn đuốc sáng trưng",
  },
  {
    word: "đèn cù",
    part_of_speech: "danh từ",
    meaning:
      "đồ chơi hình một cái lồng dán giấy mờ, trong đốt ngọn đèn, hơi nóng của ngọn đèn bốc lên làm cho cái tán ở trên có buộc hình người, vật quay tròn: quay tít như đèn cù",
    example: "quay tít như đèn cù",
  },
  {
    word: "đen đúa",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) đen và có vẻ xấu xí, nhem nhuốc: quần áo đen đúa, bẩn thỉu * nước da đen đúa",
    example: "quần áo đen đúa, bẩn thỉu * nước da đen đúa",
  },
  {
    word: "đen giòn",
    part_of_speech: "tính từ",
    meaning: "(nước da) ngăm đen, trông rắn rỏi và khoẻ mạnh: nước da đen giòn",
    example: "nước da đen giòn",
  },
  {
    word: "đen đủi",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) (hiếm) đen và có vẻ xấu: đôi bàn tay đen đủi",
    example: "đôi bàn tay đen đủi",
  },
  {
    word: "đen đủi",
    part_of_speech: "tính từ",
    meaning:
      "không gặp điều tốt lành, may mắn: một ngày đen đủi * thật là đen đủi!",
    example: "một ngày đen đủi * thật là đen đủi!",
  },
  {
    word: "đen kịt",
    part_of_speech: "tính từ",
    meaning:
      "đen như bị trát thành nhiều lớp dày đặc làm cho tối hẳn lại: lòng thuyền được quét hắc ín đen kịt * bóng đêm đen kịt",
    example: "lòng thuyền được quét hắc ín đen kịt * bóng đêm đen kịt",
  },
  {
    word: "đen láy",
    part_of_speech: "tính từ",
    meaning: "đen ánh lên (thường nói về mắt): cô bé có đôi mắt đen láy",
    example: "cô bé có đôi mắt đen láy",
  },
  {
    word: "đèn kéo quân",
    part_of_speech: "danh từ",
    meaning:
      "đồ chơi hình một cái lồng dán giấy mờ, trong đốt ngọn đèn, hơi nóng của ngọn đèn bốc lên làm cho cái tán ở trên có buộc hình người, vật quay tròn: quay tít như đèn cù",
    example: "quay tít như đèn cù",
  },
  {
    word: "đen nhánh",
    part_of_speech: "tính từ",
    meaning:
      "đen và bóng đến mức có thể phản chiếu được ánh sáng: hàm răng đen nhánh",
    example: "hàm răng đen nhánh",
  },
  {
    word: "đen ngòm",
    part_of_speech: "tính từ",
    meaning:
      "tối đen đến mức như thấy sâu hun hút, gây cảm giác ghê sợ: vực sâu đen ngòm * trời đất đen ngòm",
    example: "vực sâu đen ngòm * trời đất đen ngòm",
  },
  {
    word: "đèn lồng",
    part_of_speech: "danh từ",
    meaning:
      "đèn có khung bọc ngoài như một cái lồng, có dán giấy hoặc lụa màu, dùng để trang trí: treo đèn lồng",
    example: "treo đèn lồng",
  },
  {
    word: "đen nhẻm",
    part_of_speech: "tính từ",
    meaning: "đen vì bị vấy bẩn, trông nhem nhuốc: mặt đen nhẻm bụi than",
    example: "mặt đen nhẻm bụi than",
  },
  {
    word: "đen nhưng nhức",
    part_of_speech: "tính từ",
    meaning:
      'như đen nhức (nhưng ý mức độ cao hơn): "Nhìn em đôi má ửng hồng, Răng đen nhưng nhức mà lòng anh say." (ca dao)',
    example:
      'Nhìn em đôi má ửng hồng, Răng đen nhưng nhức mà lòng anh say." (ca dao)',
  },
  {
    word: "đèn sách",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) đèn và sách; thường được dùng để nói sự học hành: "Học trò đèn sách hôm mai, Ngày sau thi đỗ nên trai mới hào." (ca dao)',
    example:
      'Học trò đèn sách hôm mai, Ngày sau thi đỗ nên trai mới hào." (ca dao)',
  },
  {
    word: "đèn pha",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ chiếu sáng tác dụng xa, trong đó ánh sáng được tập trung trong một góc không gian hẹp nhờ một hệ quang gồm các gương và thấu kính.",
    example: "đèn pha ô tô",
  },
  {
    word: "đen thui",
    part_of_speech: "tính từ",
    meaning:
      "đen đến mức như bị cháy thui: cây cối bị cháy đen thui * mặt đen thui",
    example: "cây cối bị cháy đen thui * mặt đen thui",
  },
  {
    word: "đèn pin",
    part_of_speech: "danh từ",
    meaning: "đèn điện cầm tay, dùng pin làm nguồn điện: bấm đèn pin",
    example: "bấm đèn pin",
  },
  {
    word: "đen sì",
    part_of_speech: "tính từ",
    meaning:
      "đen do có màu tối và như xám xịt lại: bóng đèn bị muội bám đen sì * nước da đen sì",
    example: "bóng đèn bị muội bám đen sì * nước da đen sì",
  },
  {
    word: "đen thủi đen thui",
    part_of_speech: "tính từ",
    meaning:
      'như đen thui (nhưng ý nhấn mạnh hơn): "Cô kia đen thủi đen thui, Phấn đánh vô hồi, đen vẫn hoàn đen." (ca dao)',
    example:
      'Cô kia đen thủi đen thui, Phấn đánh vô hồi, đen vẫn hoàn đen." (ca dao)',
  },
  {
    word: "đen nhức",
    part_of_speech: "tính từ",
    meaning:
      "đen tuyền một màu và ánh bóng lên (thường nói về răng phụ nữ nhuộm đen thời trước): hai hàm răng đen nhức",
    example: "hai hàm răng đen nhức",
  },
  {
    word: "đen tối",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều khó khăn, cực nhục, có cảm giác như không còn lối thoát: cuộc đời đen tối * thời kì đen tối",
    example: "cuộc đời đen tối * thời kì đen tối",
  },
  {
    word: "đen tối",
    part_of_speech: "tính từ",
    meaning: "mờ ám và xấu xa, hiểm độc: âm mưu đen tối * lòng dạ đen tối",
    example: "âm mưu đen tối * lòng dạ đen tối",
  },
  {
    word: "đèn trời",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) ví sự sáng suốt của người bề trên, có quyền thế, có thể soi xét mọi điều uẩn khúc của người dưới: đèn trời soi xét",
    example: "đèn trời soi xét",
  },
  {
    word: "đen trũi",
    part_of_speech: "tính từ",
    meaning: "rất đen và toàn một màu: người đen trũi",
    example: "người đen trũi",
  },
  {
    word: "đeo bám",
    part_of_speech: "động từ",
    meaning:
      "bám sát theo, không rời: đeo bám đối tượng tình nghi * bị nỗi ám ảnh ngày đêm đeo bám",
    example: "đeo bám đối tượng tình nghi * bị nỗi ám ảnh ngày đêm đeo bám",
  },
  {
    word: "đèo bòng",
    part_of_speech: "động từ",
    meaning:
      '(văn chương) mang lấy vào mình cái làm cho vương vấn, bận bịu thêm (thường nói về tình cảm yêu đương): "Vì cam cho quýt đèo bòng, Vì em nhan sắc cho lòng anh say." (ca dao)',
    example:
      'Vì cam cho quýt đèo bòng, Vì em nhan sắc cho lòng anh say." (ca dao)',
  },
  {
    word: "đeo đuổi",
    part_of_speech: "động từ",
    meaning:
      "kiên trì trong hành động nhằm một mục đích nào đó, không rời bỏ, bất kể khó khăn, thất bại: đeo đuổi mối tình đơn phương * đeo đuổi công danh",
    example: "đeo đuổi mối tình đơn phương * đeo đuổi công danh",
  },
  {
    word: "đèo",
    part_of_speech: "danh từ",
    meaning:
      "chỗ thấp và dễ vượt qua nhất trên đường giao thông đi qua các ngọn núi: trèo đèo lội suối",
    example: "trèo đèo lội suối",
  },
  {
    word: "đèo",
    part_of_speech: "động từ",
    meaning: "mang bằng cách đeo ở trên lưng: đèo gùi * lưng đèo con",
    example: "đèo gùi * lưng đèo con",
  },
  {
    word: "đèo",
    part_of_speech: "động từ",
    meaning:
      "mang kèm theo trên xe đạp, xe máy, thường là ở phía sau: đèo con đến trường * đèo thùng hàng sau xe",
    example: "đèo con đến trường * đèo thùng hàng sau xe",
  },
  {
    word: "đèo",
    part_of_speech: "động từ",
    meaning:
      'mang thêm ngoài những thứ đã mang: "Giúp em quan tám tiền cheo, Quan năm tiền cưới lại đèo buồng cau." (Cdao)',
    example:
      'Giúp em quan tám tiền cheo, Quan năm tiền cưới lại đèo buồng cau." (Cdao)',
  },
  {
    word: "đeo đẳng",
    part_of_speech: "động từ",
    meaning:
      'theo đuổi mãi, không dứt bỏ ra được: cái nghèo cứ đeo đẳng mãi * "Mùi tục luỵ dường kia cay đắng, Vui chi mà đeo đẳng trần duyên." (CO)',
    example:
      'cái nghèo cứ đeo đẳng mãi * "Mùi tục luỵ dường kia cay đắng, Vui chi mà đeo đẳng trần duyên." (CO)',
  },
  {
    word: "đẽo",
    part_of_speech: "động từ",
    meaning:
      "dùng dụng cụ có lưỡi sắc để làm đứt rời từng phần nhỏ của một khối rắn như gỗ, đá, nhằm tạo ra vật có hình thù nhất định: đẽo gỗ làm cột * đẽo cối đá * đẽo cày giữa đường (tng)",
    example: "đẽo gỗ làm cột * đẽo cối đá * đẽo cày giữa đường (tng)",
  },
  {
    word: "đẽo",
    part_of_speech: "động từ",
    meaning: "(Khẩu ngữ) bòn lấy dần: quan lại đẽo tiền của dân",
    example: "quan lại đẽo tiền của dân",
  },
  {
    word: "đèo đẽo",
    part_of_speech: "tính từ",
    meaning:
      "mãi không rời, không thôi, làm cho cảm thấy vướng víu, khó chịu: theo mẹ đèo đẽo * bế em đèo đẽo suốt ngày",
    example: "theo mẹ đèo đẽo * bế em đèo đẽo suốt ngày",
  },
  {
    word: "đeo",
    part_of_speech: "động từ",
    meaning:
      "mang vật nào đó (ngoài đồ mặc ra) vào người (thường là đồ dễ tháo, cởi): đeo kính * đeo cặp sách * đeo mặt nạ * đồng hồ đeo tay",
    example: "đeo kính * đeo cặp sách * đeo mặt nạ * đồng hồ đeo tay",
  },
  {
    word: "đeo",
    part_of_speech: "động từ",
    meaning:
      "gắn, cài trên đồ mặc, thường là trên áo: đeo quân hàm * đeo băng tang * đeo huân chương * cổ đeo nơ",
    example: "đeo quân hàm * đeo băng tang * đeo huân chương * cổ đeo nơ",
  },
  {
    word: "đeo",
    part_of_speech: "động từ",
    meaning:
      "(Phương ngữ) bám chặt vào, không rời ra khỏi: đeo lấy cổ chị * quả đeo chi chít trên cành",
    example: "đeo lấy cổ chị * quả đeo chi chít trên cành",
  },
  {
    word: "đeo",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) theo sát, bám sát, không chịu rời ra: bị mật thám đeo sát",
    example: "bị mật thám đeo sát",
  },
  {
    word: "đeo",
    part_of_speech: "động từ",
    meaning:
      "phải mang lấy, phải chịu đựng điều gì trong thời gian dài: đeo nợ vào thân * bị đánh đến đeo tật suốt đời",
    example: "đeo nợ vào thân * bị đánh đến đeo tật suốt đời",
  },
  {
    word: "đẹp",
    part_of_speech: "tính từ",
    meaning:
      "có hình thức hoặc phẩm chất đem lại sự hứng thú đặc biệt, làm cho người ta thích nhìn ngắm hoặc kính nể: chiếc áo đẹp * phong cảnh đẹp * một ngày đẹp trời * đẹp người đẹp nết",
    example:
      "chiếc áo đẹp * phong cảnh đẹp * một ngày đẹp trời * đẹp người đẹp nết",
  },
  {
    word: "đẹp",
    part_of_speech: "tính từ",
    meaning:
      'có sự hài hoà, tương xứng: đẹp đôi * "Ngẫm duyên kỳ ngộ xưa nay, Lứa đôi ai dễ đẹp tày Thôi, Trương." (TKiều)',
    example:
      'đẹp đôi * "Ngẫm duyên kỳ ngộ xưa nay, Lứa đôi ai dễ đẹp tày Thôi, Trương." (TKiều)',
  },
  {
    word: "đẹp",
    part_of_speech: "tính từ",
    meaning: "có cảm giác thích thú: đẹp lòng * đẹp ý",
    example: "đẹp lòng * đẹp ý",
  },
  {
    word: "đẽo gọt",
    part_of_speech: "động từ",
    meaning: "như gọt giũa: đẽo gọt từng câu từng chữ",
    example: "đẽo gọt từng câu từng chữ",
  },
  {
    word: "đẹp duyên",
    part_of_speech: "tính từ",
    meaning:
      "(trai gái) xứng đôi với nhau: “Trai anh hùng, gái thuyền quyên, Phỉ nguyền sánh phượng, đẹp duyên cưỡi rồng.” (TKiều)",
    example:
      "“Trai anh hùng, gái thuyền quyên, Phỉ nguyền sánh phượng, đẹp duyên cưỡi rồng.” (TKiều)",
  },
  {
    word: "đẹp duyên",
    part_of_speech: "động từ",
    meaning: "(trang trọng) như kết duyên: mừng hai bạn đẹp duyên đôi lứa",
    example: "mừng hai bạn đẹp duyên đôi lứa",
  },
  {
    word: "đẹp đôi",
    part_of_speech: "tính từ",
    meaning: "(đôi trai gái) cân xứng với nhau: hai người trông rất đẹp đôi",
    example: "hai người trông rất đẹp đôi",
  },
  {
    word: "đẹp lòng",
    part_of_speech: "tính từ",
    meaning:
      "hoàn toàn vừa ý, vừa lòng, không có điều gì để chê trách: cố gắng làm đẹp lòng khách hàng",
    example: "cố gắng làm đẹp lòng khách hàng",
  },
  {
    word: "đẹp đẽ",
    part_of_speech: "tính từ",
    meaning: "đẹp (nói khái quát): nhà cửa đẹp đẽ * nói những lời đẹp đẽ",
    example: "nhà cửa đẹp đẽ * nói những lời đẹp đẽ",
  },
  {
    word: "đẹp mắt",
    part_of_speech: "tính từ",
    meaning:
      "nhìn thấy đẹp và gây cảm giác thích thú: điệu múa đẹp mắt * pha đi bóng đẹp mắt",
    example: "điệu múa đẹp mắt * pha đi bóng đẹp mắt",
  },
  {
    word: "đét",
    part_of_speech: "tính từ",
    meaning: "gầy và khô quắt lại: người đét như con cá mắm * gầy đét",
    example: "người đét như con cá mắm * gầy đét",
  },
  {
    word: "đét",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng như tiếng của roi quất hay bàn tay đập vào da thịt: vỗ đét vào lưng * tiếng roi vụt vào lưng đánh đét",
    example: "vỗ đét vào lưng * tiếng roi vụt vào lưng đánh đét",
  },
  {
    word: "đét",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) đánh làm phát ra tiếng đét: đét cho mấy roi",
    example: "đét cho mấy roi",
  },
  {
    word: "đẹp mặt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) được vinh dự, có danh giá (thường dùng trong lời nói mỉa): đẹp mặt cả hai bên * đẹp mặt chưa?",
    example: "đẹp mặt cả hai bên * đẹp mặt chưa?",
  },
  {
    word: "đẹt",
    part_of_speech: "động từ",
    meaning: "đánh nhẹ bằng mấy quân bài: chơi tam cúc, ai thua sẽ bị đẹt mũi",
    example: "chơi tam cúc, ai thua sẽ bị đẹt mũi",
  },
  {
    word: "đẹt",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) như còi: đứa bé đẹt quá",
    example: "đứa bé đẹt quá",
  },
  {
    word: "để",
    part_of_speech: "động từ",
    meaning:
      "làm cho ở vào một vị trí nào đó: để quyển sách lên bàn * tiền để trong túi áo * để ngoài tai những lời dị nghị",
    example:
      "để quyển sách lên bàn * tiền để trong túi áo * để ngoài tai những lời dị nghị",
  },
  {
    word: "để",
    part_of_speech: "động từ",
    meaning:
      'làm cho còn lại cái gì đó về sau: vết thương để lại sẹo * "Cây xanh thì lá cũng xanh, Cha mẹ hiền lành để đức cho con." (ca dao)',
    example:
      'vết thương để lại sẹo * "Cây xanh thì lá cũng xanh, Cha mẹ hiền lành để đức cho con." (ca dao)',
  },
  {
    word: "để",
    part_of_speech: "động từ",
    meaning:
      "không có một hành động nào trực tiếp tác động đến một trạng thái nào đó, làm cho trạng thái ấy được giữ nguyên: để quên * nhà cửa để bừa bãi * để công việc ùn lại",
    example: "để quên * nhà cửa để bừa bãi * để công việc ùn lại",
  },
  {
    word: "để",
    part_of_speech: "động từ",
    meaning:
      "không có hành động nào trực tiếp tác động, ảnh hưởng gây ra sự cản trở một sự việc, một quá trình nào đó, làm cho sự việc, quá trình ấy cứ thế diễn ra: để mọi người ngủ thêm một chút * để chờ xem thế nào rồi mới làm * để lộ bí mật * để đấy, mai hẵng hay",
    example:
      "để mọi người ngủ thêm một chút * để chờ xem thế nào rồi mới làm * để lộ bí mật * để đấy, mai hẵng hay",
  },
  {
    word: "để",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nhượng lại vật mình đã mua, với giá phải chăng: để lại cho bạn chiếc xe * để rẻ cho người quen",
    example: "để lại cho bạn chiếc xe * để rẻ cho người quen",
  },
  {
    word: "để",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) li dị (nói về chồng đối với vợ): để vợ",
    example: "để vợ",
  },
  {
    word: "để",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là mục đích hoặc chức năng, công dụng của sự việc hoặc sự vật vừa nói đến: nhà để ở * có đủ điều kiện để làm việc * nói rõ khó khăn để cùng nhau khắc phục",
    example:
      "nhà để ở * có đủ điều kiện để làm việc * nói rõ khó khăn để cùng nhau khắc phục",
  },
  {
    word: "để",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là kết quả tự nhiên và không hay của việc vừa nói đến: nói làm gì để thêm buồn * biết trước để biết đường mà tránh",
    example: "nói làm gì để thêm buồn * biết trước để biết đường mà tránh",
  },
  {
    word: "đẹp trai",
    part_of_speech: "tính từ",
    meaning:
      "(người con trai hay đàn ông còn trẻ) có diện mạo đẹp: vừa giỏi lại vừa đẹp trai",
    example: "vừa giỏi lại vừa đẹp trai",
  },
  {
    word: "đế",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận gắn liền với phần dưới của một số vật, thường to hơn và có tác dụng giữ cho vật đứng vững: đế đèn * đế giày",
    example: "đế đèn * đế giày",
  },
  {
    word: "đế",
    part_of_speech: "động từ",
    meaning: "hoặc d nói xen vào lời diễn viên trên sân khấu chèo: hát đế",
    example: "hát đế",
  },
  {
    word: "đế",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) nói chêm vào, xen vào để châm chọc hoặc để kích động: đế thêm vào một câu",
    example: "đế thêm vào một câu",
  },
  {
    word: "đề",
    part_of_speech: "danh từ",
    meaning:
      "cây to, lá có mũi nhọn dài, hình trám rộng, thường trồng để lấy bóng mát, làm cảnh ở đình chùa: cây đa, cây đề",
    example: "cây đa, cây đề",
  },
  {
    word: "đề",
    part_of_speech: "danh từ",
    meaning:
      "lối chơi cờ bạc, người chơi đặt tiền cho chủ đề để ghi số dự đoán sẽ trùng với hai số cuối của giải độc đắc trong một giải xổ số, nếu đoán đúng thì thắng: chơi lô, chơi đề * tệ nạn đánh đề",
    example: "chơi lô, chơi đề * tệ nạn",
  },
  {
    word: "đề",
    part_of_speech: "động từ",
    meaning:
      "viết thêm vào để cung cấp một số thông tin cần biết về một văn bản: quên đề tên tác giả dưới bài viết * đề rõ ngày tháng viết thư * đề địa chỉ",
    example:
      "quên đề tên tác giả dưới bài viết * đề rõ ngày tháng viết thư * đề địa chỉ",
  },
  {
    word: "đề",
    part_of_speech: "động từ",
    meaning:
      "viết thêm vào để giới thiệu qua về nội dung của tác phẩm hoặc để nêu ý nghĩ, tình cảm của mình: bức tranh có đề thơ * đề lời tặng",
    example: "bức tranh có đề thơ * đề lời tặng",
  },
  {
    word: "đề",
    part_of_speech: "danh từ",
    meaning: "đề bài (nói tắt): đọc kĩ đề trước khi làm * đề văn * ra đề thi",
    example: "đọc kĩ đề trước khi làm * đề văn * ra đề thi",
  },
  {
    word: "đề",
    part_of_speech: "danh từ",
    meaning: "nội dung chính cần trình bày: đi xa đề * viết lạc đề",
    example: "đi xa đề * viết lạc đề",
  },
  {
    word: "đề",
    part_of_speech: "động từ",
    meaning:
      "nêu ra như là cái cần được giải quyết, cần được thực hiện: đề ra yêu cầu * đề ra sáng kiến",
    example: "đề ra yêu cầu * đề ra sáng kiến",
  },
  {
    word: "đề",
    part_of_speech: "động từ",
    meaning:
      "nêu thành cái có ý nghĩa quan trọng: nhiệm vụ đó được đề lên hàng đầu * câu nói được đề thành khẩu hiệu",
    example:
      "nhiệm vụ đó được đề lên hàng đầu * câu nói được đề thành khẩu hiệu",
  },
  {
    word: "đề",
    part_of_speech: "danh từ",
    meaning: "bộ phận có dạng nút ấn dùng để khởi động động cơ: xe bị hỏng đề",
    example: "xe bị hỏng đề",
  },
  {
    word: "đề",
    part_of_speech: "động từ",
    meaning:
      "(cũ đề pa) khởi động động cơ bằng cách ấn vào nút đề: đề máy * đề ga * máy hỏng không đề được",
    example: "đề máy * đề ga * máy hỏng không đề được",
  },
  {
    word: "đê",
    part_of_speech: "danh từ",
    meaning:
      "công trình xây đắp bằng đất đá dọc bờ sông hoặc bờ biển để ngăn không cho nước tràn vào đồng ruộng và khu dân cư: đắp đê phòng lụt * đề phòng vỡ đê",
    example: "đắp đê phòng lụt * đề phòng vỡ đê",
  },
  {
    word: "đệ",
    part_of_speech: "động từ",
    meaning:
      "(cũ, trang trọng) đưa lên cấp trên xem xét với thái độ trịnh trọng: đệ đơn lên cấp trên * đệ đơn xin từ chức",
    example: "đệ đơn lên cấp trên * đệ đơn xin từ chức",
  },
  {
    word: "đề án",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ ý kiến có hệ thống về những công việc nào đó cần làm, được nêu ra để thảo luận, thông qua, xét duyệt: duyệt đề án * đề án quy hoạch thành phố",
    example: "duyệt đề án * đề án quy hoạch thành phố",
  },
  {
    word: "đê bao",
    part_of_speech: "danh từ",
    meaning:
      "đê bao quanh một khu vực, để ngăn không cho nước lũ tràn vào: củng cố hệ thống đê bao",
    example: "củng cố hệ thống đê bao",
  },
  {
    word: "đề bài",
    part_of_speech: "động từ",
    meaning: "như đầu bài: ra đề bài cho học sinh làm",
    example: "ra đề bài cho học sinh làm",
  },
  {
    word: "đề bạt",
    part_of_speech: "động từ",
    meaning:
      "cử giữ một chức vụ cao hơn: đề bạt cán bộ trẻ * được đề bạt làm phó giám đốc",
    example: "đề bạt cán bộ trẻ * được đề bạt làm phó giám đốc",
  },
  {
    word: "để bụng",
    part_of_speech: "động từ",
    meaning:
      "giữ ở trong lòng không nói ra: nghe thì để bụng vậy thôi, đừng nói cho ai * sống để bụng chết mang theo (tng)",
    example:
      "nghe thì để bụng vậy thôi, đừng nói cho ai * sống để bụng chết mang theo (tng)",
  },
  {
    word: "để bụng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) ghi nhớ những sai sót nhỏ của người khác đối với mình một cách cố chấp, khó chịu: tính hay để bụng",
    example: "tính hay để bụng",
  },
  {
    word: "đề can",
    part_of_speech: "danh từ",
    meaning:
      "miếng giấy, vải, v.v. có hình trang trí dùng để dán lên quần áo, đồ vật: dán đề can vào chỗ rách * dán đề can xe máy",
    example: "dán đề can vào chỗ rách * dán đề can xe máy",
  },
  {
    word: "đế chế",
    part_of_speech: "danh từ",
    meaning: "chế độ chính trị của nước có hoàng đế đứng đầu: đế chế La Mã",
    example: "đế chế La Mã",
  },
  {
    word: "đề cao",
    part_of_speech: "động từ",
    meaning:
      "đưa lên vị trí quan trọng để được chú ý một cách thích đáng: đề cao cảnh giác * đề cao tinh thần kỉ luật",
    example: "đề cao cảnh giác * đề cao tinh thần kỉ luật",
  },
  {
    word: "đề cao",
    part_of_speech: "động từ",
    meaning:
      "nêu nổi bật, làm cho được đánh giá cao hơn: đề cao bản sắc văn hoá dân tộc * tự đề cao bản thân",
    example: "đề cao bản sắc văn hoá dân tộc * tự đề cao bản thân",
  },
  {
    word: "đề cập",
    part_of_speech: "động từ",
    meaning:
      "nói đến, đưa ra để được chú ý xem xét, thảo luận: bài báo đề cập đến những vụ việc tham nhũng * ở đây, tôi không đề cập đến chuyện ấy",
    example:
      "bài báo đề cập đến những vụ việc tham nhũng * ở đây, tôi không đề cập đến chuyện ấy",
  },
  {
    word: "để chỏm",
    part_of_speech: "động từ",
    meaning:
      "cạo trọc đầu chỉ để lại một chỏm trên đỉnh (kiểu cắt tóc của các bé trai thời trước): chơi với nhau từ hồi còn để chỏm (hồi còn bé)",
    example: "chơi với nhau từ hồi còn để chỏm (hồi còn bé)",
  },
  {
    word: "đề đóm",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) đề và các trò cờ bạc khác (nói khái quát): ham mê cờ bạc, đề đóm",
    example: "ham mê cờ bạc, đề đóm",
  },
  {
    word: "đề dẫn",
    part_of_speech: "động từ",
    meaning:
      "nêu ra trước có tính chất để hướng dẫn hoặc giải thích cho phần tiếp theo: đọc báo cáo đề dẫn trước hội nghị * viết lời đề dẫn cho cuốn sách sắp in",
    example:
      "đọc báo cáo đề dẫn trước hội nghị * viết lời đề dẫn cho cuốn sách sắp in",
  },
  {
    word: "đề cương",
    part_of_speech: "danh từ",
    meaning:
      "bản ghi những điểm chính, điểm cốt yếu để từ đó phát triển thành một bài viết hay một công trình nghiên cứu: đề cương bài giảng * mới làm xong đề cương",
    example: "đề cương bài giảng * mới làm xong đề cương",
  },
  {
    word: "đề cử",
    part_of_speech: "động từ",
    meaning:
      "giới thiệu ra để chọn mà bầu: đề cử người vào ban chấp hành công đoàn * danh sách những người ứng cử và đề cử",
    example:
      "đề cử người vào ban chấp hành công đoàn * danh sách những người ứng cử và đề cử",
  },
  {
    word: "để dành",
    part_of_speech: "động từ",
    meaning:
      "để lại để dùng vào việc khác hoặc lúc khác: để dành tiền mua nhà * thóc để dành",
    example: "để dành tiền mua nhà * thóc để dành",
  },
  {
    word: "đê điều",
    part_of_speech: "danh từ",
    meaning:
      "đê phòng chống lũ lụt (nói khái quát): bảo vệ đê điều * xây dựng hệ thống đê điều",
    example: "bảo vệ đê điều * xây dựng hệ thống đê điều",
  },
  {
    word: "đề đạt",
    part_of_speech: "động từ",
    meaning:
      "(cấp dưới) trình bày ý kiến, nguyện vọng của mình lên cấp có thẩm quyền giải quyết: đề đạt nguyện vọng lên cấp trên",
    example: "đề đạt nguyện vọng lên cấp trên",
  },
  {
    word: "đê hèn",
    part_of_speech: "tính từ",
    meaning:
      "hèn hạ, thấp kém đến mức đáng khinh bỉ: thủ đoạn đê hèn * hành động đê hèn",
    example: "thủ đoạn đê hèn * hành động đê hèn",
  },
  {
    word: "đế đô",
    part_of_speech: "danh từ",
    meaning: "(cũ) như kinh đô: đế đô Thăng Long",
    example: "đế đô Thăng Long",
  },
  {
    word: "đê kè",
    part_of_speech: "danh từ",
    meaning: "đê và kè phòng chống lũ lụt (nói khái quát): tu bổ đê kè",
    example: "tu bổ đê kè",
  },
  {
    word: "đề huề",
    part_of_speech: "tính từ",
    meaning:
      "đông đủ và vui vẻ, hoà thuận: vợ chồng con cái đề huề * bầu không khí đề huề",
    example: "vợ chồng con cái đề huề * bầu không khí đề huề",
  },
  {
    word: "đề huề",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) như đàng hoàng (ng1): sống rất đề huề * nhà cửa đề huề",
    example: "sống rất đề huề * nhà cửa đề huề",
  },
  {
    word: "đề kháng",
    part_of_speech: "động từ",
    meaning: "chống cự lại sự xâm nhập, sự tiến công: sức đề kháng kém",
    example: "sức đề kháng kém",
  },
  {
    word: "đê mạt",
    part_of_speech: "tính từ",
    meaning:
      "thấp kém đến tột độ về phẩm chất, tư cách: tư tưởng đê mạt * con người đê mạt",
    example: "tư tưởng đê mạt * con người đê mạt",
  },
  {
    word: "đế kinh",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như kinh đô: đất đế kinh",
    example: "đất đế kinh",
  },
  {
    word: "để phần",
    part_of_speech: "động từ",
    meaning:
      "để lại phần món ăn cho người vắng mặt về ăn sau: có gì ngon cũng để phần cho em * cơm để phần",
    example: "có gì ngon cũng để phần cho em * cơm để phần",
  },
  {
    word: "để mắt",
    part_of_speech: "động từ",
    meaning:
      "để ý trông coi, theo dõi: mải chơi, không thèm để mắt đến nhà cửa * để mắt đến con cái",
    example: "mải chơi, không thèm để mắt đến nhà cửa * để mắt đến con cái",
  },
  {
    word: "để mắt",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) để ý, chú ý đến một người khác giới nào đó với nhiều thiện cảm: được nhiều chàng trai để mắt đến",
    example: "được nhiều chàng trai để mắt đến",
  },
  {
    word: "đê mê",
    part_of_speech: "tính từ",
    meaning:
      "có cảm giác say sưa, thích thú đến tê dại, vì sự kích thích, vì sung sướng: đê mê trong giấc mộng * đê mê trong hạnh phúc",
    example: "đê mê trong giấc mộng * đê mê trong hạnh phúc",
  },
  {
    word: "đề pa",
    part_of_speech: "danh từ",
    meaning:
      "cây to, lá có mũi nhọn dài, hình trám rộng, thường trồng để lấy bóng mát, làm cảnh ở đình chùa: cây đa, cây đề",
    example: "cây đa, cây đề",
  },
  {
    word: "đề pa",
    part_of_speech: "danh từ",
    meaning:
      "lối chơi cờ bạc, người chơi đặt tiền cho chủ đề để ghi số dự đoán sẽ trùng với hai số cuối của giải độc đắc trong một giải xổ số, nếu đoán đúng thì thắng: chơi lô, chơi đề * tệ nạn đánh đề",
    example: "chơi lô, chơi đề * tệ nạn",
  },
  {
    word: "đề pa",
    part_of_speech: "động từ",
    meaning:
      "viết thêm vào để cung cấp một số thông tin cần biết về một văn bản: quên đề tên tác giả dưới bài viết * đề rõ ngày tháng viết thư * đề địa chỉ",
    example:
      "quên đề tên tác giả dưới bài viết * đề rõ ngày tháng viết thư * đề địa chỉ",
  },
  {
    word: "đề pa",
    part_of_speech: "động từ",
    meaning:
      "viết thêm vào để giới thiệu qua về nội dung của tác phẩm hoặc để nêu ý nghĩ, tình cảm của mình: bức tranh có đề thơ * đề lời tặng",
    example: "bức tranh có đề thơ * đề lời tặng",
  },
  {
    word: "đề pa",
    part_of_speech: "danh từ",
    meaning: "đề bài (nói tắt): đọc kĩ đề trước khi làm * đề văn * ra đề thi",
    example: "đọc kĩ đề trước khi làm * đề văn * ra đề thi",
  },
  {
    word: "đề pa",
    part_of_speech: "danh từ",
    meaning: "nội dung chính cần trình bày: đi xa đề * viết lạc đề",
    example: "đi xa đề * viết lạc đề",
  },
  {
    word: "đề pa",
    part_of_speech: "động từ",
    meaning:
      "nêu ra như là cái cần được giải quyết, cần được thực hiện: đề ra yêu cầu * đề ra sáng kiến",
    example: "đề ra yêu cầu * đề ra sáng kiến",
  },
  {
    word: "đề pa",
    part_of_speech: "động từ",
    meaning:
      "nêu thành cái có ý nghĩa quan trọng: nhiệm vụ đó được đề lên hàng đầu * câu nói được đề thành khẩu hiệu",
    example:
      "nhiệm vụ đó được đề lên hàng đầu * câu nói được đề thành khẩu hiệu",
  },
  {
    word: "đề pa",
    part_of_speech: "danh từ",
    meaning: "bộ phận có dạng nút ấn dùng để khởi động động cơ: xe bị hỏng đề",
    example: "xe bị hỏng đề",
  },
  {
    word: "đề pa",
    part_of_speech: "động từ",
    meaning:
      "(cũ đề pa) khởi động động cơ bằng cách ấn vào nút đề: đề máy * đề ga * máy hỏng không đề được",
    example: "đề máy * đề ga * máy hỏng không đề được",
  },
  {
    word: "đề mục",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi từng phần lớn trong một bài viết, một công trình nghiên cứu: lưu ý một số đề mục quan trọng * báo cáo tổng kết gồm năm đề mục lớn",
    example:
      "lưu ý một số đề mục quan trọng * báo cáo tổng kết gồm năm đề mục lớn",
  },
  {
    word: "đề nghị",
    part_of_speech: "động từ",
    meaning:
      "đưa ra ý kiến về một việc nào đó để thảo luận, xem xét: đề nghị mọi người phát biểu ý kiến * đề nghị một danh sách khen thưởng",
    example:
      "đề nghị mọi người phát biểu ý kiến * đề nghị một danh sách khen thưởng",
  },
  {
    word: "đề nghị",
    part_of_speech: "động từ",
    meaning:
      "gửi lên cấp có thẩm quyền những yêu cầu và mong được chấp nhận, được giải quyết (thường dùng trong đơn từ): viết đơn đề nghị trợ cấp khó khăn * đề nghị được tăng lương",
    example: "viết đơn đề nghị trợ cấp khó khăn * đề nghị được tăng lương",
  },
  {
    word: "đề nghị",
    part_of_speech: "động từ",
    meaning:
      "từ dùng ở đầu câu để nêu lên một yêu cầu, đòi hỏi phải làm theo: đề nghị giữ trật tự! * đề nghị xuất trình giấy tờ!",
    example: "đề nghị giữ trật tự! * đề nghị xuất trình giấy tờ!",
  },
  {
    word: "đề nghị",
    part_of_speech: "danh từ",
    meaning:
      "điều đề nghị để thảo luận, xem xét: một đề nghị hợp lí * đề nghị không được chấp nhận",
    example: "một đề nghị hợp lí * đề nghị không được chấp nhận",
  },
  {
    word: "đề phòng",
    part_of_speech: "động từ",
    meaning:
      "chuẩn bị trước các phương án để sẵn sàng đối phó, ngăn ngừa hoặc hạn chế những thiệt hại có thể xảy ra: đề phòng hoả hoạn * đề phòng kẻ gian * đi sớm một chút đề phòng xe hỏng",
    example:
      "đề phòng hoả hoạn * đề phòng kẻ gian * đi sớm một chút đề phòng xe hỏng",
  },
  {
    word: "đế quốc",
    part_of_speech: "danh từ",
    meaning: "(Ít dùng) nước quân chủ do hoàng đế đứng đầu: đế quốc La Mã",
    example: "đế quốc La Mã",
  },
  {
    word: "đế quốc",
    part_of_speech: "tính từ",
    meaning: "đế quốc chủ nghĩa (nói tắt): các nước đế quốc",
    example: "các nước đế quốc",
  },
  {
    word: "để tang",
    part_of_speech: "động từ",
    meaning:
      "mang dấu hiệu, thường là ở áo, mũ, đầu để tỏ lòng thương tiếc người mới chết, theo phong tục: để tang ba năm",
    example: "để tang ba năm",
  },
  {
    word: "đề tài",
    part_of_speech: "danh từ",
    meaning:
      "đối tượng để nghiên cứu hoặc miêu tả (trong tác phẩm khoa học hoặc văn học, nghệ thuật): thay đổi đề tài luận án * bộ phim về đề tài chiến tranh",
    example: "thay đổi đề tài luận án * bộ phim về đề tài chiến tranh",
  },
  {
    word: "để tâm",
    part_of_speech: "động từ",
    meaning:
      "để ý quan tâm: để tâm vào học hành * không để tâm đến chuyện của người khác",
    example: "để tâm vào học hành * không để tâm đến chuyện của người khác",
  },
  {
    word: "đê tiện",
    part_of_speech: "tính từ",
    meaning: "thấp kém, nhỏ nhen đến mức đáng khinh bỉ: kẻ đê tiện",
    example: "kẻ đê tiện",
  },
  {
    word: "đệ trình",
    part_of_speech: "động từ",
    meaning:
      "(Trang trọng) đưa lên, gửi lên cấp có thẩm quyền để xem xét: đệ trình báo cáo lên thủ tướng * đệ trình giấy tờ, sổ sách",
    example: "đệ trình báo cáo lên thủ tướng * đệ trình giấy tờ, sổ sách",
  },
  {
    word: "đề từ",
    part_of_speech: "danh từ",
    meaning:
      "câu ngắn gọn, cô đọng dẫn ra ở đầu tác phẩm hoặc chương sách để thể hiện chủ đề tư tưởng của tác phẩm hoặc của chương sách đó: viết lời đề từ",
    example: "viết lời đề từ",
  },
  {
    word: "đế vương",
    part_of_speech: "danh từ",
    meaning: "(Từ cũ) vua (nói khái quát): mộng làm đế vương",
    example: "mộng làm đế vương",
  },
  {
    word: "đế vương",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) (lối sống) cực kì sang trọng (tựa như lối sống của các bậc vua chúa): sống một đời sống đế vương",
    example: "sống một đời sống đế vương",
  },
  {
    word: "đề xuất",
    part_of_speech: "động từ",
    meaning:
      "nêu ra, đưa ra hướng giải quyết để cùng xem xét, quyết định: đề xuất nhiều ý kiến có giá trị",
    example: "đề xuất nhiều ý kiến có giá trị",
  },
  {
    word: "đề tựa",
    part_of_speech: "danh từ",
    meaning:
      "phần viết ở đầu sách để trình bày một số điều cần thiết về cuốn sách đó: viết đề tựa cho cuốn sách",
    example: "viết đề tựa cho cuốn sách",
  },
  {
    word: "để ý",
    part_of_speech: "động từ",
    meaning:
      "có sự xem xét, theo dõi, để tâm trí đến trong một lúc nào đó: để ý đến người lạ mặt * lừa lúc mọi người không để ý, lỉnh đi mất",
    example:
      "để ý đến người lạ mặt * lừa lúc mọi người không để ý, lỉnh đi mất",
  },
  {
    word: "để ý",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) để tâm trí đến một cách ít nhiều thường xuyên: để ý đến con cái",
    example: "để ý đến con cái",
  },
  {
    word: "đề xướng",
    part_of_speech: "động từ",
    meaning:
      "nêu ra đầu tiên và phổ biến, vận động mọi người làm theo: đề xướng ý tưởng nhận dạng tiếng Việt",
    example: "đề xướng ý tưởng nhận dạng tiếng Việt",
  },
  {
    word: "đếch",
    part_of_speech: "phụ từ",
    meaning:
      "(thông tục) từ biểu thị ý phủ định dứt khoát một cách thiếu nhã nhặn: đếch biết * trong nhà đếch còn cái gì",
    example: "đếch biết * trong nhà đếch còn cái gì",
  },
  {
    word: "đếch",
    part_of_speech: "trợ từ",
    meaning:
      "(thông tục) từ biểu thị ý nhấn mạnh về sắc thái phủ định dứt khoát một cách nặng lời: đi làm đếch gì",
    example: "đi làm đếch gì",
  },
  {
    word: "đếm",
    part_of_speech: "động từ",
    meaning:
      "kể lần lượt tên các số, theo trật tự trong dãy số tự nhiên: đếm từ 1 đến 10 * dạy bé tập đếm * đếm ngược",
    example: "đếm từ 1 đến 10 * dạy bé tập đếm * đếm ngược",
  },
  {
    word: "đếm",
    part_of_speech: "động từ",
    meaning:
      "cộng từng đơn vị một, kể từ đơn vị đầu tiên cho đến đơn vị cuối cùng, để xác định có tất cả là bao nhiêu hoặc để xem có đủ không: đếm tiền * đếm số người có mặt * đếm được trên đầu ngón tay (số lượng ít)",
    example:
      "đếm tiền * đếm số người có mặt * đếm được trên đầu ngón tay (số lượng ít)",
  },
  {
    word: "đếm",
    part_of_speech: "động từ",
    meaning:
      "cộng từng đơn vị một, kể từ đơn vị đầu tiên cho đến khi có được số đã định: đếm tiền để trả lại * đếm riêng ra hai trăm nghìn",
    example: "đếm tiền để trả lại * đếm riêng ra hai trăm nghìn",
  },
  {
    word: "đệm",
    part_of_speech: "danh từ",
    meaning:
      "(Nam thường nệm) đồ dùng làm bằng chất liệu mềm, xốp, dùng để lót vào chỗ nằm, ngồi cho êm: giường trải đệm * ghế có bọc đệm * đệm da",
    example: "giường trải đệm * ghế có bọc đệm * đệm da",
  },
  {
    word: "đệm",
    part_of_speech: "danh từ",
    meaning:
      "vật đặt thêm vào ở giữa để cho không còn hở hoặc để giảm bớt cọ xát, va chạm: miếng đệm bằng cao su",
    example: "miếng đệm bằng cao su",
  },
  {
    word: "đệm",
    part_of_speech: "động từ",
    meaning:
      "đặt phụ thêm vào ở giữa để làm cho không còn hở, nhằm giảm bớt cọ xát, va chạm: đệm thêm một miếng xốp * đệm giấy xung quanh cho khỏi vỡ",
    example: "đệm thêm một miếng xốp * đệm giấy xung quanh cho khỏi vỡ",
  },
  {
    word: "đệm",
    part_of_speech: "động từ",
    meaning:
      "thêm vào một hay nhiều tiếng nào đó, nhằm mục đích nhất định: đệm thêm vào một câu",
    example: "đệm thêm vào một câu",
  },
  {
    word: "đệm",
    part_of_speech: "động từ",
    meaning:
      "biểu diễn bằng nhạc khí phụ thêm vào với người biểu diễn chính: đệm đàn piano * hát đệm * hát không có nhạc đệm",
    example: "đệm đàn piano * hát đệm * hát không có nhạc đệm",
  },
  {
    word: "đếm chác",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đếm để biết là bao nhiêu (nói khái quát): chắc là đủ, không phải đếm chác gì cả",
    example: "chắc là đủ, không phải đếm chác gì cả",
  },
  {
    word: "đêm",
    part_of_speech: "danh từ",
    meaning:
      'khoảng thời gian từ tối cho đến sáng: suốt đêm không ngủ được * "Thức lâu mới biết đêm dài, Ở lâu mới biết ai người bạc đen." (Cdao)',
    example:
      'suốt đêm không ngủ được * "Thức lâu mới biết đêm dài, Ở lâu mới biết ai người bạc đen." (Cdao)',
  },
  {
    word: "đêm",
    part_of_speech: "danh từ",
    meaning:
      "lúc khuya, trong khoảng từ sau 9 giờ tối đến trước 1 giờ sáng: mười giờ đêm * ăn đêm * thức đến đêm mới đi ngủ",
    example: "mười giờ đêm * ăn đêm * thức đến đêm mới đi ngủ",
  },
  {
    word: "đêm đêm",
    part_of_speech: "phụ từ",
    meaning:
      'đêm này sang đêm khác, đêm nào cũng vậy: "Đêm đêm ngồi tựa bóng đèn, Than thân với bóng, giải phiền với hoa." (ca dao)',
    example:
      'Đêm đêm ngồi tựa bóng đèn, Than thân với bóng, giải phiền với hoa." (ca dao)',
  },
  {
    word: "đêm hôm",
    part_of_speech: "danh từ",
    meaning:
      "thời gian về đêm, trong quan hệ với hoạt động của con người: đêm hôm còn đi đâu? * đêm hôm khuya khoắt",
    example: "đêm hôm còn đi đâu? * đêm hôm khuya khoắt",
  },
  {
    word: "đêm tối",
    part_of_speech: "danh từ",
    meaning:
      "đêm, nói về mặt tối tăm, không có một chút ánh sáng: mò mẫm trong đêm tối",
    example: "mò mẫm trong đêm tối",
  },
  {
    word: "đêm trường",
    part_of_speech: "danh từ",
    meaning: "(văn chương) đêm dài: thao thức suốt đêm trường",
    example: "thao thức suốt đêm trường",
  },
  {
    word: "đền",
    part_of_speech: "danh từ",
    meaning: "nơi vua ngự ngày trước: quỳ tâu trước sân đền",
    example: "quỳ tâu trước sân đền",
  },
  {
    word: "đền",
    part_of_speech: "danh từ",
    meaning:
      "nơi thờ thần thánh hoặc những nhân vật lịch sử được tôn sùng như thần thánh: đền Hùng * đền Kiếp Bạc * đền Cổ Loa",
    example: "đền Hùng * đền Kiếp Bạc * đền Cổ Loa",
  },
  {
    word: "đền",
    part_of_speech: "động từ",
    meaning:
      "trả lại cho người khác tương xứng với sự tổn thất, thiệt hại mà mình gây ra: đền bằng tiền * mượn rồi đánh mất nên phải mua đền",
    example: "đền bằng tiền * mượn rồi đánh mất nên phải mua đền",
  },
  {
    word: "đền",
    part_of_speech: "động từ",
    meaning:
      "trả lại cho người khác tương xứng với công của người đó đối với mình: đền ơn đáp nghĩa (tng)",
    example: "đền ơn đáp nghĩa (tng)",
  },
  {
    word: "đêm ngày",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) ngày cũng như đêm; liên tục, không ngừng: lo lắng đêm ngày * đèn điện thắp suốt đêm ngày",
    example: "lo lắng đêm ngày * đèn điện thắp suốt đêm ngày",
  },
  {
    word: "đền bồi",
    part_of_speech: "động từ",
    meaning: "(cũ) như đền đáp: đền bồi công ơn của cha mẹ",
    example: "đền bồi công ơn của cha mẹ",
  },
  {
    word: "đếm xỉa",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) cần phải tính đến vì được coi là quan trọng: không ai thèm đếm xỉa đến",
    example: "không ai thèm đếm xỉa đến",
  },
  {
    word: "đến",
    part_of_speech: "động từ",
    meaning:
      "có tại một nơi nào đó sau một quá trình di chuyển từ nơi khác: mẹ đưa bé đến trường * chưa thấy ai đến * tàu đã đến ga",
    example: "mẹ đưa bé đến trường * chưa thấy ai đến * tàu đã đến ga",
  },
  {
    word: "đến",
    part_of_speech: "động từ",
    meaning:
      "bắt đầu hoặc bắt đầu xảy ra vào một lúc nào đó (nói về một khoảng thời gian hoặc một hiện tượng, sự việc cụ thể): mùa hè qua, mùa thu đến * thời cơ đã đến * sự việc đến thật bất ngờ",
    example:
      "mùa hè qua, mùa thu đến * thời cơ đã đến * sự việc đến thật bất ngờ",
  },
  {
    word: "đến",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là hướng hoặc đối tượng cụ thể của hoạt động, tác động được nói đến: đang đi đến trường * nghĩ đến bạn * khoản tiền để dành, chưa dùng đến * ảnh hưởng đến sức khoẻ",
    example:
      "đang đi đến trường * nghĩ đến bạn * khoản tiền để dành, chưa dùng đến * ảnh hưởng đến sức khoẻ",
  },
  {
    word: "đến",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là giới hạn, mức độ của sự việc vừa nói đến: ở lại đến mai * chiến đấu đến hơi thở cuối cùng",
    example: "ở lại đến mai * chiến đấu đến hơi thở cuối cùng",
  },
  {
    word: "đến",
    part_of_speech: "trợ từ",
    meaning:
      "(khẩu ngữ) từ biểu thị ý nhấn mạnh về mức độ cao của một tính chất làm ít nhiều ngạc nhiên: tính nết đến lạ * hoa đến là thơm * mắt bị khói cay đến khó chịu",
    example: "tính nết đến lạ * hoa đến là thơm * mắt bị khói cay đến khó chịu",
  },
  {
    word: "đến",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý nhấn mạnh về tính chất bất thường của một hiện tượng để làm nổi bật mức độ cao của một việc nào đó: bài toán này khó quá, đến mẹ cũng chịu * đồng hồ chậm đến mười phút",
    example:
      "bài toán này khó quá, đến mẹ cũng chịu * đồng hồ chậm đến mười phút",
  },
  {
    word: "đến",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý nhấn mạnh về một hậu quả, kết quả có thể đưa lại, để làm nổi bật mức độ của một tình trạng, tình hình nào đó: lo đến gầy người * tức đến phát điên",
    example: "lo đến gầy người * tức đến phát điên",
  },
  {
    word: "đền bù",
    part_of_speech: "động từ",
    meaning:
      'trả lại đầy đủ, tương xứng với công lao, sự mất mát hoặc sự vất vả: đền bù thiệt hại * lĩnh tiền đền bù * "Tằm có lứa, ruộng có mùa, Chăm làm trời cũng đền bù có khi." (ca dao)',
    example:
      'đền bù thiệt hại * lĩnh tiền đền bù * "Tằm có lứa, ruộng có mùa, Chăm làm trời cũng đền bù có khi." (ca dao)',
  },
  {
    word: "đến nỗi",
    part_of_speech: "",
    meaning:
      "đến mức dẫn đến một điều nào đó không bình thường (nêu ra để nhấn mạnh mức độ cao): sợ đến nỗi chết ngất * xấu đến nỗi ma chê quỷ hờn",
    example: "sợ đến nỗi chết ngất * xấu đến nỗi ma chê quỷ hờn",
  },
  {
    word: "đến nỗi",
    part_of_speech: "",
    meaning:
      "ở vào tình trạng không hay nào đó đến mức đáng lấy làm tiếc, làm buồn: trông bề ngoài cũng không đến nỗi nào * nếu chăm chỉ học hành thì đâu đến nỗi",
    example:
      "trông bề ngoài cũng không đến nỗi nào * nếu chăm chỉ học hành thì đâu đến nỗi",
  },
  {
    word: "đến điều",
    part_of_speech: "tính từ",
    meaning:
      "đủ mọi điều, không còn thiếu điều gì: căn vặn đến điều * con bé đoảng đến điều là đoảng",
    example: "căn vặn đến điều * con bé đoảng đến điều là đoảng",
  },
  {
    word: "đến cùng",
    part_of_speech: "phụ từ",
    meaning:
      "đến tận cùng, cho đến khi đạt được kết quả: quyết tâm đến cùng * giữ bí mật đến cùng",
    example: "quyết tâm đến cùng * giữ bí mật đến cùng",
  },
  {
    word: "đến đầu đến đũa",
    part_of_speech: "",
    meaning: "(khẩu ngữ) như đến nơi đến chốn: làm cho đến đầu đến đũa",
    example: "làm cho đến đầu đến đũa",
  },
  {
    word: "đền đáp",
    part_of_speech: "động từ",
    meaning:
      "tỏ lòng biết ơn bằng việc làm xứng đáng với những gì người khác đã làm cho mình: đền đáp công ơn * đền đáp tình nghĩa",
    example: "đền đáp công ơn * đền đáp tình nghĩa",
  },
  {
    word: "đến nơi",
    part_of_speech: "",
    meaning:
      "(Khẩu ngữ) sắp đến, sắp xảy ra rồi: chết đến nơi mà vẫn còn huênh hoang! * nguy đến nơi rồi!",
    example: "chết đến nơi mà vẫn còn huênh hoang! * nguy đến nơi rồi!",
  },
  {
    word: "đến nơi đến chốn",
    part_of_speech: "",
    meaning:
      "(làm việc gì) rất cẩn thận, đầy đủ, chu đáo: dặn dò đến nơi đến chốn * được học hành đến nơi đến chốn",
    example: "dặn dò đến nơi đến chốn * được học hành đến nơi đến chốn",
  },
  {
    word: "đền mạng",
    part_of_speech: "động từ",
    meaning:
      "phải đền bù hoặc phải chết vì đã gây tội giết người: giết người phải đền mạng",
    example: "giết người phải đền mạng",
  },
  {
    word: "đền ơn đáp nghĩa",
    part_of_speech: "",
    meaning:
      "đền đáp công ơn bằng những việc làm cụ thể (thường đối với người có công với cách mạng): phong trào đền ơn đáp nghĩa * quỹ đền ơn đáp nghĩa",
    example: "phong trào đền ơn đáp nghĩa * quỹ đền ơn đáp nghĩa",
  },
  {
    word: "đền rồng",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) nơi vua ngự; cũng dùng để chỉ nhà vua: “Trạng nguyên liền bước lên lầu, Vội vàng làm lễ gửi tâu đền rồng.” (PCCH)",
    example:
      "“Trạng nguyên liền bước lên lầu, Vội vàng làm lễ gửi tâu đền rồng.” (PCCH)",
  },
  {
    word: "đền tội",
    part_of_speech: "động từ",
    meaning:
      "chịu sự trừng phạt thích đáng, tương xứng với những tội lỗi đã gây ra: kẻ sát nhân đã phải đền tội",
    example: "kẻ sát nhân đã phải đền tội",
  },
  {
    word: "đến tết",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị ý cho rằng phải lâu lắm, chẳng biết đến bao giờ mới đạt được kết quả của hành động, của sự việc vừa nói đến (ngụ ý phàn nàn về một sự quá chậm chạp, chậm trễ): làm chậm thế thì có mà đến Tết! * đến tết cũng không xong",
    example: "làm chậm thế thì có mà đến Tết! * đến tết cũng không xong",
  },
  {
    word: "đệp",
    part_of_speech: "danh từ",
    meaning:
      "giỏ đan bằng tre nứa, có hom hoặc có miệng bằng vải như hình cái miệng túi, dùng để đựng tôm cá, ếch nhái",
    example: "một đệp tiền",
  },
  {
    word: "đểu",
    part_of_speech: "tính từ",
    meaning:
      "(thông tục) xỏ xiên, lừa đảo, bất chấp đạo lí (thường dùng làm tiếng mắng): đồ đểu! * thằng đểu",
    example: "đồ đểu! * thằng đểu",
  },
  {
    word: "đểnh đoảng",
    part_of_speech: "tính từ",
    meaning:
      '(khẩu ngữ) như đoảng: "Trước sao đằm thắm muôn phần, Nay sao đểnh đoảng như cần nấu suông?" (ca dao)',
    example:
      'Trước sao đằm thắm muôn phần, Nay sao đểnh đoảng như cần nấu suông?" (ca dao)',
  },
  {
    word: "đểu cáng",
    part_of_speech: "tính từ",
    meaning: "(thông tục) rất đểu: nói bằng giọng đểu cáng",
    example: "nói bằng giọng đểu cáng",
  },
  {
    word: "đều",
    part_of_speech: "tính từ",
    meaning:
      "có kích thước, số lượng, thành phần, v.v. bằng nhau, như nhau: bông lúa to, hạt đều và chắc * chia thành bốn phần đều nhau * trận đấu kết thúc với tỉ số 2 đều",
    example:
      "bông lúa to, hạt đều và chắc * chia thành bốn phần đều nhau * trận đấu kết thúc với tỉ số 2 đều",
  },
  {
    word: "đều",
    part_of_speech: "tính từ",
    meaning:
      "có tốc độ, nhịp độ hoặc cường độ như nhau, không tăng giảm trong một khoảng thời gian nhất định: đi học đều * đảo đều tay để không bị cháy * tiếng máy chạy đều",
    example: "đi học đều * đảo đều tay để không bị cháy * tiếng máy chạy đều",
  },
  {
    word: "đều",
    part_of_speech: "tính từ",
    meaning:
      "(hình tam giác, đa giác) có tất cả các cạnh bằng nhau và tất cả các góc bằng nhau: tam giác đều * lục giác đều",
    example: "tam giác đều * lục giác đều",
  },
  {
    word: "đều",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị sự giống nhau, sự đồng nhất về hoạt động, trạng thái hoặc tính chất của nhiều đối tượng khác nhau: mọi người đều cảm thấy vui vẻ * cả hai chị em đều học giỏi",
    example: "mọi người đều cảm thấy vui vẻ * cả hai chị em đều học giỏi",
  },
  {
    word: "đều",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị tính đồng nhất về hoạt động, trạng thái hoặc tính chất của cùng một đối tượng, trong những hoàn cảnh khác nhau; lần nào cũng như lần nào: lần nào hỏi cũng đều không trả lời được * mỗi khi có dịp lên Hà Nội, tôi đều ghé thăm anh",
    example:
      "lần nào hỏi cũng đều không trả lời được * mỗi khi có dịp lên Hà Nội, tôi đều ghé thăm anh",
  },
  {
    word: "đểu giả",
    part_of_speech: "tính từ",
    meaning: "(thông tục) như đểu cáng: quân đểu giả!",
    example: "quân đểu giả!",
  },
  {
    word: "đều đặn",
    part_of_speech: "tính từ",
    meaning: "rất đều (nói khái quát): hàm răng đều đặn * gửi thư về đều đặn",
    example: "hàm răng đều đặn * gửi thư về đều đặn",
  },
  {
    word: "đều đặn",
    part_of_speech: "tính từ",
    meaning:
      "có sự cân đối, hài hoà giữa các bộ phận (thường nói về thân thể): thân hình đều đặn",
    example: "thân hình đều đặn",
  },
  {
    word: "đĩ bợm",
    part_of_speech: "tính từ",
    meaning: "có tính hay trai gái bậy bạ: thói đĩ bợm",
    example: "thói đĩ bợm",
  },
  {
    word: "đi",
    part_of_speech: "động từ",
    meaning:
      "(người, động vật) tự di chuyển từ chỗ này đến chỗ khác bằng những bước chân nhấc lên, đặt xuống liên tiếp: bé đang tập đi * chân đi chữ bát * ngựa đi nước kiệu",
    example: "bé đang tập đi * chân đi chữ bát * ngựa đi nước kiệu",
  },
  {
    word: "đi",
    part_of_speech: "động từ",
    meaning:
      "(người) di chuyển đến nơi khác, không kể bằng cách gì, phương tiện gì: đi chợ * đi máy bay * đi du lịch * đi đến nơi về đến chốn",
    example: "đi chợ * đi máy bay * đi du lịch * đi đến nơi về đến chốn",
  },
  {
    word: "đi",
    part_of_speech: "động từ",
    meaning:
      "chết (lối nói kiêng tránh): ông cụ như cố chờ con trai về rồi mới đi",
    example: "ông cụ như cố chờ con trai về rồi mới đi",
  },
  {
    word: "đi",
    part_of_speech: "động từ",
    meaning:
      "di chuyển đến chỗ khác, nơi khác để làm một công việc nào đó: đi ngủ * đi chợ * đi bộ đội * làm đơn đi kiện * chuyến đi biển dài ngày",
    example:
      "đi ngủ * đi chợ * đi bộ đội * làm đơn đi kiện * chuyến đi biển dài ngày",
  },
  {
    word: "đi",
    part_of_speech: "động từ",
    meaning:
      "(phương tiện vận tải) di chuyển trên một bề mặt: xe đi chậm rì rì * ca nô đi nhanh hơn thuyền",
    example: "xe đi chậm rì rì * ca nô đi nhanh hơn thuyền",
  },
  {
    word: "đi",
    part_of_speech: "động từ",
    meaning:
      "từ biểu thị hướng của hoạt động dẫn đến sự thay đổi vị trí: quay mặt đi * nhìn đi chỗ khác * kẻ chạy đi, người chạy lại",
    example: "quay mặt đi * nhìn đi chỗ khác * kẻ chạy đi, người chạy lại",
  },
  {
    word: "đi",
    part_of_speech: "động từ",
    meaning:
      "từ biểu thị hoạt động, quá trình dẫn đến kết quả làm cho không còn nữa, không tồn tại nữa: xoá đi một chữ * việc đó rồi sẽ qua đi * cố tình hiểu khác đi",
    example: "xoá đi một chữ * việc đó rồi sẽ qua đi * cố tình hiểu khác đi",
  },
  {
    word: "đi",
    part_of_speech: "động từ",
    meaning:
      "từ biểu thị kết quả của một quá trình giảm sút, suy giảm: sợ quá, mặt tái đi * ốm lâu, người gầy rộc đi * bệnh tình đã giảm đi nhiều",
    example:
      "sợ quá, mặt tái đi * ốm lâu, người gầy rộc đi * bệnh tình đã giảm đi nhiều",
  },
  {
    word: "đi",
    part_of_speech: "động từ",
    meaning:
      "(Ít dùng) biến mất một cách dần dần, không còn giữ nguyên hương vị như ban đầu: nồi cơm đã đi hơi * trà để lâu nên đã đi hương",
    example: "nồi cơm đã đi hơi * trà để lâu nên đã đi hương",
  },
  {
    word: "đi",
    part_of_speech: "động từ",
    meaning:
      "chuyển vị trí quân cờ để tạo ra thế cờ mới (trong chơi cờ): đi con mã * đi nước cờ cao",
    example: "đi con mã * đi nước cờ cao",
  },
  {
    word: "đi",
    part_of_speech: "động từ",
    meaning:
      "biểu diễn, thực hiện các động tác võ thuật: đi vài đường kiếm * đi một bài quyền",
    example: "đi vài đường kiếm * đi một bài quyền",
  },
  {
    word: "đi",
    part_of_speech: "động từ",
    meaning:
      "làm, hoạt động theo một hướng nào đó: đi chệch khỏi quỹ đạo * đi sâu đi sát quần chúng",
    example: "đi chệch khỏi quỹ đạo * đi sâu đi sát quần chúng",
  },
  {
    word: "đi",
    part_of_speech: "động từ",
    meaning:
      "tiến đến một kết quả nào đó: chẳng đi đến đâu * đi đến thống nhất * đi đến kết luận",
    example: "chẳng đi đến đâu * đi đến thống nhất * đi đến kết luận",
  },
  {
    word: "đi",
    part_of_speech: "động từ",
    meaning:
      "chuyển sang, bước vào một giai đoạn khác: đi vào con đường tội lỗi * công việc đã đi vào nền nếp",
    example: "đi vào con đường tội lỗi * công việc đã đi vào nền nếp",
  },
  {
    word: "đi",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) đem đến tặng nhân dịp lễ tết, hiếu hỉ: đi một câu đối nhân dịp mừng thọ * đi phong bì hai trăm nghìn đồng",
    example:
      "đi một câu đối nhân dịp mừng thọ * đi phong bì hai trăm nghìn đồng",
  },
  {
    word: "đi",
    part_of_speech: "động từ",
    meaning:
      "mang vào chân hoặc tay để che giữ, bảo vệ: chân đi bít tất * đi găng tay",
    example: "chân đi bít tất * đi găng tay",
  },
  {
    word: "đi",
    part_of_speech: "động từ",
    meaning:
      "gắn với nhau, phù hợp với nhau: ghế thấp quá, không đi với bàn * màu quần không đi với màu áo",
    example: "ghế thấp quá, không đi với bàn * màu quần không đi với màu áo",
  },
  {
    word: "đi",
    part_of_speech: "động từ",
    meaning: "đi ngoài (nói tắt): đi kiết * đau bụng, đi lỏng * đi ra máu",
    example: "đi kiết * đau bụng, đi lỏng * đi ra máu",
  },
  {
    word: "đi",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị ý mệnh lệnh hoặc đề nghị, thúc giục: cút đi! * im đi! * chúng mình đi chơi đi! * tranh thủ nghỉ đi cho lại sức",
    example:
      "cút đi! * im đi! * chúng mình đi chơi đi! * tranh thủ nghỉ đi cho lại sức",
  },
  {
    word: "đi",
    part_of_speech: "trợ từ",
    meaning:
      "(Khẩu ngữ) từ biểu thị ý nhấn mạnh về tính chất bất thường hoặc lạ lùng, ngược đời của một sự việc, để tỏ ý không tán thành hoặc không tin: đời nào mẹ lại đi ghét con!",
    example: "đời nào mẹ lại đi ghét con!",
  },
  {
    word: "đi",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý nhấn mạnh về một mức độ rất cao, như đến thế là cùng rồi, không thể hơn được nữa: buồn quá đi mất! * mê tít đi * rõ quá đi rồi, còn thắc mắc gì nữa!",
    example:
      "buồn quá đi mất! * mê tít đi * rõ quá đi rồi, còn thắc mắc gì nữa!",
  },
  {
    word: "đi",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý nhấn mạnh về kết quả đã được tính toán một cách cụ thể: nó về hồi tháng hai, tính đến nay là đi mười tháng",
    example: "nó về hồi tháng hai, tính đến nay là đi mười tháng",
  },
  {
    word: "đi",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý nhấn mạnh vào giả thiết vừa nêu ra, để khẳng định rằng dù với giả thiết ấy cũng không làm thay đổi được nhận định nêu sau đó, nhằm nhấn mạnh tính chất dứt khoát của nhận định này: cứ cho là thế đi thì đã sao? cứ tính tròn là 5 nghìn đi cũng vẫn rẻ",
    example:
      "cứ cho là thế đi thì đã sao? cứ tính tròn là 5 nghìn đi cũng vẫn rẻ",
  },
  {
    word: "đĩ",
    part_of_speech: "danh từ",
    meaning:
      "người phụ nữ làm nghề mại dâm (hàm ý khinh): gái đĩ già mồm (tng)",
    example: "gái đĩ già mồm (tng)",
  },
  {
    word: "đĩ",
    part_of_speech: "danh từ",
    meaning:
      "(Phương ngữ, Khẩu ngữ) đứa con gái còn bé (trong gia đình nông dân): thằng cu, cái đĩ",
    example: "thằng cu, cái đĩ",
  },
  {
    word: "đĩ",
    part_of_speech: "danh từ",
    meaning:
      "(Phương ngữ, Khẩu ngữ) từ dùng để gọi thân mật người nông dân có con đầu lòng là con gái và đang còn bé: chị đĩ có nhà không?",
    example: "chị đĩ có nhà không?",
  },
  {
    word: "đĩ",
    part_of_speech: "tính từ",
    meaning: "(Khẩu ngữ) lẳng lơ: miệng cười rất đĩ",
    example: "miệng cười rất đĩ",
  },
  {
    word: "đi bụi",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đi lang thang, sống buông thả, theo lối sống của những kẻ bụi đời: bỏ nhà đi bụi",
    example: "bỏ nhà đi bụi",
  },
  {
    word: "đì",
    part_of_speech: "động từ",
    meaning: "(thông tục) mắng nặng lời: bị đì cho một trận",
    example: "bị đì cho một trận",
  },
  {
    word: "đì",
    part_of_speech: "động từ",
    meaning: "như trù dập: mãi không được lên lương vì bị cấp trên đì",
    example: "mãi không được lên lương vì bị cấp trên đì",
  },
  {
    word: "đi chăng nữa",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị rằng dù với giả thiết như vừa nói thì cũng không làm thay đổi điều sắp nêu ra, nhằm khẳng định nhấn mạnh điều sắp nêu ra đó: dù khổ mấy đi nữa tôi cũng chịu được",
    example: "dù khổ mấy đi nữa tôi cũng chịu được",
  },
  {
    word: "đi đất",
    part_of_speech: "động từ",
    meaning:
      'đi chân không trên mặt đất, không mang guốc dép: "Rửa chân đi hán, đi hài, Rửa chân đi đất chớ hoài rửa chân." (ca dao)',
    example:
      'Rửa chân đi hán, đi hài, Rửa chân đi đất chớ hoài rửa chân." (ca dao)',
  },
  {
    word: "đi đằng đầu",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị ý khẳng định một cách quả quyết rằng điều giả thiết được nêu trước đó không bao giờ có thể xảy ra: nó mà thi đỗ thì tôi đi đằng đầu",
    example: "nó mà thi đỗ thì tôi đi đằng đầu",
  },
  {
    word: "đi đạo",
    part_of_speech: "động từ",
    meaning: "theo Công giáo: lấy chồng là người đi đạo",
    example: "lấy chồng là người đi đạo",
  },
  {
    word: "đì đoành",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng những tiếng nổ to, không liên tiếp dồn dập, nhưng đanh và vang dội: tiếng súng, tiếng đại bác đì đoành suốt đêm",
    example: "tiếng súng, tiếng đại bác đì đoành suốt đêm",
  },
  {
    word: "đĩ điếm",
    part_of_speech: "danh từ",
    meaning:
      "người phụ nữ làm nghề mại dâm (nói khái quát): nạn cờ bạc, đĩ điếm",
    example: "nạn cờ bạc, đĩ điếm",
  },
  {
    word: "đi đôi",
    part_of_speech: "động từ",
    meaning:
      "tương xứng, đồng bộ với nhau: bộ ghế không đi đôi với bàn * lời nói phải đi đôi với việc làm",
    example: "bộ ghế không đi đôi với bàn * lời nói phải đi đôi với việc làm",
  },
  {
    word: "đi đôi",
    part_of_speech: "động từ",
    meaning:
      "(tiến hành) song song với nhau, có cái này, việc này thì đồng thời có cái kia, việc kia: học đi đôi với hành",
    example: "học đi đôi với hành",
  },
  {
    word: "đì đẹt",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng những tiếng nổ nhỏ, rời rạc, không vang: tiếng pháo đì đẹt",
    example: "tiếng pháo đì đẹt",
  },
  {
    word: "đi đêm",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) trao đổi, thoả thuận ngầm từ trước để thu xếp việc gì có lợi cho cả hai bên: trúng thầu do đi đêm",
    example: "trúng thầu do đi đêm",
  },
  {
    word: "đi đời",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) không còn tồn tại nữa; chết, mất hết (hàm ý nguyền rủa hoặc mỉa mai): đi đời quân gian ác * thế là đi đời cả lũ",
    example: "đi đời quân gian ác * thế là đi đời cả lũ",
  },
  {
    word: "đì đùng",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng những tiếng nổ to, không dồn dập nhưng rất vang: sấm chớp đì đùng",
    example: "sấm chớp đì đùng",
  },
  {
    word: "đi đời nhà ma",
    part_of_speech: "",
    meaning:
      '(thông tục) như đi đời: "Mầu hồ đã mất đi rồi, Thôi thôi vốn liếng đi đời nhà ma!" (TKiều)',
    example:
      'Mầu hồ đã mất đi rồi, Thôi thôi vốn liếng đi đời nhà ma!" (TKiều)',
  },
  {
    word: "đi đứng",
    part_of_speech: "động từ",
    meaning:
      "đi, về mặt để di chuyển (nói khái quát): chân đau, đi đứng có vẻ khó khăn",
    example: "chân đau, đi đứng có vẻ khó khăn",
  },
  {
    word: "đi đứng",
    part_of_speech: "động từ",
    meaning:
      "đi và đứng, về mặt tư thế và các động tác (nói khái quát): đi đứng khệnh khạng",
    example: "đi đứng khệnh khạng",
  },
  {
    word: "đi hoang",
    part_of_speech: "động từ",
    meaning: "bỏ nhà đi lang thang, sống nay đây mai đó: bỏ nhà đi hoang",
    example: "bỏ nhà đi hoang",
  },
  {
    word: "đi hoang",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) (người phụ nữ) đi lang chạ với người đàn ông nào đó mà có thai: làng ngả vạ một ả đi hoang",
    example: "làng ngả vạ một ả đi hoang",
  },
  {
    word: "đi nắng về mưa",
    part_of_speech: "",
    meaning:
      'tả cảnh vất vả, cực nhọc, phải dãi dầu nắng mưa: "Người ta rượu sớm trà trưa, Em nay đi nắng về mưa đã nhiều." (ca dao)',
    example:
      'Người ta rượu sớm trà trưa, Em nay đi nắng về mưa đã nhiều." (ca dao)',
  },
  {
    word: "đi đứt",
    part_of_speech: "động từ",
    meaning:
      '(thông tục) mất hẳn đi, không còn tồn tại nữa: đi đứt mất buổi chiều * "Cái cơ nghiệp một người giầu ở nhà quê có bao nhiêu! Một mình thằng con nuôi phá đã đi đứt ngay một nửa." (NCao; 24)',
    example:
      'đi đứt mất buổi chiều * "Cái cơ nghiệp một người giầu ở nhà quê có bao nhiêu! Một mình thằng con nuôi phá đã đi đứt ngay một nửa." (NCao; 24)',
  },
  {
    word: "đi lại",
    part_of_speech: "động từ",
    meaning:
      "đi lui tới, qua lại nơi này, nơi khác, chỗ này, chỗ khác (nói khái quát): đi lại nhẹ nhàng * tàu thuyền đi lại như mắc cửi",
    example: "đi lại nhẹ nhàng * tàu thuyền đi lại như mắc cửi",
  },
  {
    word: "đi lại",
    part_of_speech: "động từ",
    meaning:
      "thường đến chơi, thăm hỏi, có quan hệ thân mật: hai gia đình vẫn đi lại với nhau",
    example: "hai gia đình vẫn đi lại với nhau",
  },
  {
    word: "đi ngang về tắt",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) có quan hệ nam nữ lén lút, bất chính: quen thói đi ngang về tắt",
    example: "quen thói đi ngang về tắt",
  },
  {
    word: "đi nữa",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị rằng dù với giả thiết như vừa nói thì cũng không làm thay đổi điều sắp nêu ra, nhằm khẳng định nhấn mạnh điều sắp nêu ra đó: dù khổ mấy đi nữa tôi cũng chịu được",
    example: "dù khổ mấy đi nữa tôi cũng chịu được",
  },
  {
    word: "đĩ rạc",
    part_of_speech: "danh từ",
    meaning:
      "(thông tục) kẻ làm đĩ dày dạn, đáng khinh (thường dùng làm tiếng mắng, chửi): đồ đĩ rạc",
    example: "đồ đĩ rạc",
  },
  {
    word: "đi sát",
    part_of_speech: "động từ",
    meaning:
      "tiếp xúc trực tiếp và thường xuyên để hiểu biết đối tượng, tình hình một cách rõ ràng, chính xác: đi sát thực tế * đi sâu đi sát bà con nông dân",
    example: "đi sát thực tế * đi sâu đi sát bà con nông dân",
  },
  {
    word: "đi nghề",
    part_of_speech: "động từ",
    meaning: "đánh cá ở biển: sắm tàu thuyền để đi nghề",
    example: "sắm tàu thuyền để đi nghề",
  },
  {
    word: "đi phép",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) đi nghỉ phép: xin đi phép một tuần",
    example: "xin đi phép một tuần",
  },
  {
    word: "đi sâu",
    part_of_speech: "động từ",
    meaning:
      "đi vào chiều sâu, nắm những cái thuộc về bản chất: đi sâu vào từng vấn đề * đi sâu nghiên cứu",
    example: "đi sâu vào từng vấn đề * đi sâu nghiên cứu",
  },
  {
    word: "đi tắt",
    part_of_speech: "động từ",
    meaning:
      "đi theo đường ngắn nhất, không theo đường sẵn có: đi tắt đường đồng * đi tắt đón đầu",
    example: "đi tắt đường đồng * đi tắt đón đầu",
  },
  {
    word: "đĩ thoã",
    part_of_speech: "tính từ",
    meaning: "có tính lẳng lơ như gái đĩ: hạng người đĩ thoã",
    example: "hạng người đĩ thoã",
  },
  {
    word: "đi tu",
    part_of_speech: "động từ",
    meaning:
      "rời bỏ cuộc sống bình thường để sống cuộc đời tu hành theo một tôn giáo (thường là Phật giáo): cắt tóc đi tu",
    example: "cắt tóc đi tu",
  },
  {
    word: "đi tắt đón đầu",
    part_of_speech: "",
    meaning:
      "đi theo một đường hướng ngắn nhất, không theo tuần tự, để tiến đến nhanh và sớm nhất: đổi mới thiết bị, công nghệ theo hướng đi tắt đón đầu",
    example: "đổi mới thiết bị, công nghệ theo hướng đi tắt đón đầu",
  },
  {
    word: "đi tơ",
    part_of_speech: "động từ",
    meaning: "(súc vật cái) chịu đực để lấy giống: lợn đi tơ",
    example: "lợn đi tơ",
  },
  {
    word: "đi-ê-den",
    part_of_speech: "danh từ",
    meaning:
      "động cơ đốt trong dùng nhiên liệu lỏng (thường là dầu ma dút) phun vào không khí nén và làm cho bốc cháy: động cơ diesel",
    example: "động cơ diesel",
  },
  {
    word: "đi tua",
    part_of_speech: "động từ",
    meaning:
      "đi lần lượt qua từng máy (thường là trong ngành dệt) để kiểm tra, xử lí kịp thời nếu cần, khi máy đang vận hành: thợ dệt đi tua",
    example: "thợ dệt đi tua",
  },
  {
    word: "đìa",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) quá nhiều: nợ đìa",
    example: "nợ đìa",
  },
  {
    word: "đi-ô-xin",
    part_of_speech: "danh từ",
    meaning:
      "chất độc cực mạnh, thể rắn, không màu, rất nguy hiểm đối với cơ thể sống: nhiễm chất độc dioxin",
    example: "nhiễm chất độc dioxin",
  },
  {
    word: "đỉa",
    part_of_speech: "danh từ",
    meaning:
      "giun đốt sống ở nước, chuyên bám vào da người và động vật để hút máu: bám dai như đỉa * giãy như đỉa phải vôi (tng)",
    example: "bám dai như đỉa * giãy như đỉa phải vôi (tng)",
  },
  {
    word: "địa",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) địa lí (ng3; nói tắt): thầy địa",
    example: "thầy địa",
  },
  {
    word: "địa",
    part_of_speech: "danh từ",
    meaning: "địa lí học (nói tắt): sinh viên khoa địa * môn địa",
    example: "sinh viên khoa địa * môn địa",
  },
  {
    word: "địa",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) thổ địa (nói tắt): miếu ông địa",
    example: "miếu ông địa",
  },
  {
    word: "đĩa",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng thường có hình tròn, miệng rộng, lòng nông, thường để đựng thức ăn khô hoặc có ít nước: đơm xôi ra đĩa * đĩa tráng men * đĩa bầu dục",
    example: "đơm xôi ra đĩa * đĩa tráng men * đĩa bầu dục",
  },
  {
    word: "đĩa",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ thể thao hình tròn, dẹt, thường làm bằng gỗ, vành ngoài được viền bằng sắt, có kích thước và trọng lượng quy định, dùng để ném: thi ném đĩa",
    example: "thi ném đĩa",
  },
  {
    word: "đĩa",
    part_of_speech: "danh từ",
    meaning: "vật dẹt và tròn, dùng làm bộ phận quay: đĩa xe đạp * phanh đĩa",
    example: "đĩa xe đạp * phanh đĩa",
  },
  {
    word: "đĩa",
    part_of_speech: "danh từ",
    meaning:
      "vật, thường dẹt và tròn, dùng để ghi âm, ghi hình, ghi dữ liệu, sau đó có thể được dùng để phát ra hoặc đọc lại: đĩa hát * đĩa CD * máy quay đĩa",
    example: "đĩa hát * đĩa CD * máy quay đĩa",
  },
  {
    word: "địa cầu",
    part_of_speech: "danh từ",
    meaning: "(cũ) trái đất: chấn động địa cầu",
    example: "chấn động địa cầu",
  },
  {
    word: "địa cầu",
    part_of_speech: "danh từ",
    meaning: "mô hình Trái Đất: tìm vị trí nước Việt Nam trên quả địa cầu",
    example: "tìm vị trí nước Việt Nam trên quả địa cầu",
  },
  {
    word: "địa bàn",
    part_of_speech: "danh từ",
    meaning:
      "khu vực, phạm vi, trong quan hệ với những hoạt động tiến hành ở đó: mở rộng địa bàn điều tra phá án",
    example: "mở rộng địa bàn điều tra phá án",
  },
  {
    word: "địa chấn",
    part_of_speech: "danh từ",
    meaning:
      "hiện tượng vỏ Trái Đất đột ngột rung động mạnh, thường gây nứt nẻ, trồi sụt: khắc phục hậu quả của trận động đất",
    example: "khắc phục hậu quả của trận động đất",
  },
  {
    word: "địa bạ",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) sổ ghi chép về ruộng đất và quyền sử dụng ruộng đất của chính quyền thời trước: sổ địa bạ",
    example: "sổ địa bạ",
  },
  {
    word: "địa chất",
    part_of_speech: "danh từ",
    meaning:
      "thành phần vật chất được phân thành các lớp trong vỏ Trái Đất và sự cấu tạo, sắp xếp các lớp ấy.",
    example: "ngành địa chất * cán bộ địa chất",
  },
  {
    word: "địa chính",
    part_of_speech: "danh từ",
    meaning:
      "công việc quản lí ruộng đất: sở địa chính * làm công tác địa chính",
    example: "sở địa chính * làm công tác địa chính",
  },
  {
    word: "địa chỉ",
    part_of_speech: "danh từ",
    meaning:
      "những thông tin cụ thể về chỗ ở, nơi làm việc của một người, một cơ quan, v.v.: thư gửi không đề địa chỉ * nhầm địa chỉ",
    example: "thư gửi không đề địa chỉ * nhầm địa chỉ",
  },
  {
    word: "địa cực",
    part_of_speech: "danh từ",
    meaning: "(cũ) cực của Trái Đất: thám hiểm địa cực",
    example: "thám hiểm địa cực",
  },
  {
    word: "địa chí",
    part_of_speech: "danh từ",
    meaning:
      "sách ghi chép về địa lí, lịch sử, phong tục, nhân vật, sản phẩm, v.v., của một địa phương: sách địa chí",
    example: "sách địa chí",
  },
  {
    word: "địa danh",
    part_of_speech: "danh từ",
    meaning:
      "tên đất, tên địa phương (làng, xã, huyện, tỉnh, thành phố, v.v.), tên điểm, vùng kinh tế (khu nông nghiệp, khu công nhiệp, v.v.), tên các quốc gia, châu lục, núi non, sông hồ, vũng vịnh, v.v. ghi lại được trên bản đồ: viết hoa các địa danh * từ điển địa danh",
    example: "viết hoa các địa danh * từ điển địa danh",
  },
  {
    word: "địa đạo",
    part_of_speech: "danh từ",
    meaning:
      "hệ thống đường hầm đào sâu trong lòng đất, dùng để trú ẩn và cơ động chiến đấu: địa đạo Củ Chi * đường địa đạo",
    example: "địa đạo Củ Chi * đường địa đạo",
  },
  {
    word: "đĩa đệm",
    part_of_speech: "danh từ",
    meaning:
      "cấu trúc bằng sụn và sợi, có dạng hình đĩa, nằm ở giữa các đốt sống: bị thoát vị đĩa đệm",
    example: "bị thoát vị đĩa đệm",
  },
  {
    word: "địa dư",
    part_of_speech: "danh từ",
    meaning: "vùng đất đai, địa bàn: thuộc làu địa dư thành phố",
    example: "thuộc làu địa dư thành phố",
  },
  {
    word: "địa dư",
    part_of_speech: "danh từ",
    meaning: "(Từ cũ) địa lí: sách địa dư * giờ học địa dư",
    example: "sách địa dư * giờ học địa dư",
  },
  {
    word: "địa đầu",
    part_of_speech: "danh từ",
    meaning:
      "chỗ bắt đầu hoặc chỗ cuối cùng hết phần đất của một khu vực, một nước, giáp với khu vực khác, nước khác: nơi địa đầu tổ quốc",
    example: "nơi địa đầu tổ quốc",
  },
  {
    word: "địa điểm",
    part_of_speech: "danh từ",
    meaning:
      "nơi cụ thể tiến hành một hoạt động hoặc xảy ra một sự việc nào đó: địa điểm tập kết hàng * địa điểm đóng quân",
    example: "địa điểm tập kết hàng * địa điểm đóng quân",
  },
  {
    word: "địa giới",
    part_of_speech: "danh từ",
    meaning:
      "đường ranh giới phân chia các vùng đất, các khu vực hành chính: xác định địa giới giữa hai nước",
    example: "xác định địa giới giữa hai nước",
  },
  {
    word: "địa hình",
    part_of_speech: "danh từ",
    meaning:
      "bề mặt của một vùng, với sự phân bố của các yếu tố như núi, đồi, đồng bằng, v.v.: địa hình bằng phẳng * khảo sát địa hình",
    example: "địa hình bằng phẳng * khảo sát địa hình",
  },
  {
    word: "địa hạt",
    part_of_speech: "danh từ",
    meaning: "phần đất thuộc phạm vi một đơn vị hành chính: địa hạt Hà Nội",
    example: "địa hạt Hà Nội",
  },
  {
    word: "địa hạt",
    part_of_speech: "danh từ",
    meaning:
      "phạm vi của một lĩnh vực, một ngành khoa học nào đó: địa hạt văn hoá * địa hạt từ vựng học",
    example: "địa hạt văn hoá * địa hạt từ vựng học",
  },
  {
    word: "đĩa hình",
    part_of_speech: "danh từ",
    meaning:
      "đĩa ghi hình và tiếng để có thể phát lại: xem đĩa hình * đầu đọc đĩa hình",
    example: "xem đĩa hình * đầu đọc đĩa hình",
  },
  {
    word: "địa lí",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ hoặc một phần bề mặt tự nhiên của Trái Đất và các hiện tượng tự nhiên, kinh tế, dân cư cùng tình hình phân bố của chúng trên bề mặt đó: điều kiện địa lí * bản đồ địa lí",
    example: "điều kiện địa lí * bản đồ địa lí",
  },
  {
    word: "địa lí",
    part_of_speech: "danh từ",
    meaning: "địa lí học (nói tắt): bộ môn địa lí",
    example: "bộ môn địa lí",
  },
  {
    word: "địa lí",
    part_of_speech: "danh từ",
    meaning:
      "thuật xem hình thế địa lí để chọn đất dựng nhà cửa hay đặt mồ mả, cho rằng việc này ảnh hưởng đến thịnh suy của gia tộc, con cháu, theo quan niệm mê tín: thầy địa lí",
    example: "thầy địa lí",
  },
  {
    word: "địa lôi",
    part_of_speech: "danh từ",
    meaning: "(cũ) mìn dùng để cài, chôn dưới đất: đạp phải địa lôi",
    example: "đạp phải địa lôi",
  },
  {
    word: "địa lý",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ hoặc một phần bề mặt tự nhiên của Trái Đất và các hiện tượng tự nhiên, kinh tế, dân cư cùng tình hình phân bố của chúng trên bề mặt đó: điều kiện địa lí * bản đồ địa lí",
    example: "điều kiện địa lí * bản đồ địa lí",
  },
  {
    word: "địa lý",
    part_of_speech: "danh từ",
    meaning: "địa lí học (nói tắt): bộ môn địa lí",
    example: "bộ môn địa lí",
  },
  {
    word: "địa lý",
    part_of_speech: "danh từ",
    meaning:
      "thuật xem hình thế địa lí để chọn đất dựng nhà cửa hay đặt mồ mả, cho rằng việc này ảnh hưởng đến thịnh suy của gia tộc, con cháu, theo quan niệm mê tín: thầy địa lí",
    example: "thầy địa lí",
  },
  {
    word: "địa lợi",
    part_of_speech: "danh từ",
    meaning:
      "hình thế đất đai có lợi cho việc chiến đấu (một trong ba điều kiện cơ bản, cùng với thiên thời, nhân hoà, để làm nên thắng lợi, theo quan niệm xưa).",
    example:
      'Xã tôi trời cho địa lợi, trên bến dưới thuyền, từ lâu đã hình thành một dẫy phố và một khu chợ buôn bán tấp nập (…)" (MVKháng; 12)',
  },
  {
    word: "địa ốc",
    part_of_speech: "danh từ",
    meaning:
      "nhà cửa và ruộng đất nói chung: kinh doanh địa ốc * thị trường địa ốc biến động mạnh",
    example: "kinh doanh địa ốc * thị trường địa ốc biến động mạnh",
  },
  {
    word: "địa ngục",
    part_of_speech: "danh từ",
    meaning:
      "nơi đày đoạ linh hồn người có tội ở dưới âm phủ, theo quan niệm của một số tôn giáo; đối lập với thiên đường: sa xuống địa ngục * chín tầng địa ngục",
    example: "sa xuống địa ngục * chín tầng địa ngục",
  },
  {
    word: "địa phận",
    part_of_speech: "danh từ",
    meaning:
      "phần đất thuộc về một địa phương, một nước, một đối tượng nào đó: đi hết địa phận tỉnh Hà Tây * đường xe lửa chạy qua địa phận nhiều tỉnh",
    example:
      "đi hết địa phận tỉnh Hà Tây * đường xe lửa chạy qua địa phận nhiều tỉnh",
  },
  {
    word: "địa phương",
    part_of_speech: "danh từ",
    meaning:
      "vùng, khu vực trong quan hệ với những vùng, khu vực khác trong nước hoặc trong quan hệ với trung ương, với cả nước: cách phát âm địa phương * về công tác tại địa phương",
    example: "cách phát âm địa phương * về công tác tại địa phương",
  },
  {
    word: "địa phương",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) địa phương chủ nghĩa (nói tắt): nặng đầu óc địa phương",
    example: "nặng đầu óc địa phương",
  },
  {
    word: "địa phương chủ nghĩa",
    part_of_speech: "tính từ",
    meaning:
      "chỉ quan tâm, chú ý đến lợi ích của địa phương mình, không quan tâm đến lợi ích của các địa phương khác và lợi ích chung của đất nước: tư tưởng địa phương chủ nghĩa",
    example: "tư tưởng địa phương chủ nghĩa",
  },
  {
    word: "địa tầng",
    part_of_speech: "danh từ",
    meaning:
      "tầng lớp đất đá được tạo thành qua thời gian: lượng nước phân bố không đều trong các địa tầng",
    example: "lượng nước phân bố không đều trong các địa tầng",
  },
  {
    word: "địa sinh",
    part_of_speech: "động từ",
    meaning: "phát triển trong đất: rễ là cơ quan địa sinh của cây",
    example: "rễ là cơ quan địa sinh của cây",
  },
  {
    word: "địa tĩnh",
    part_of_speech: "danh từ",
    meaning:
      "vệ tinh nhân tạo của Trái Đất, có quỹ đạo nằm trong mặt phẳng xích đạo, có vận tốc góc bằng vận tốc góc của Trái Đất: phát sóng truyền hình qua vệ tinh địa tĩnh",
    example: "phát sóng truyền hình qua vệ tinh địa tĩnh",
  },
  {
    word: "địa tô",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) phần hoa lợi hoặc khoản tiền mà người mướn ruộng đất sản xuất phải nộp cho chủ sở hữu ruộng đất: tá điền được giảm địa tô",
    example: "tá điền được giảm địa tô",
  },
  {
    word: "địa thế",
    part_of_speech: "danh từ",
    meaning:
      "vị trí, hình thế của một vùng đất so với các vùng xung quanh: địa thế hiểm trở * xem xét địa thế",
    example: "địa thế hiểm trở * xem xét địa thế",
  },
  {
    word: "địa vật lí",
    part_of_speech: "danh từ",
    meaning:
      "hệ các ngành khoa học nghiên cứu cấu trúc bên trong của Trái Đất và các tính chất, các quá trình vật lí xảy ra trong thạch quyển, khí quyển, thuỷ quyển của Trái Đất, trong mối tác dụng qua lại thường xuyên giữa chúng: số liệu khảo sát địa vật lí",
    example: "số liệu khảo sát địa vật lí",
  },
  {
    word: "địa vị",
    part_of_speech: "danh từ",
    meaning:
      "vị trí của cá nhân trong quan hệ xã hội do chức vụ, cấp bậc, quyền lực mà có (về mặt được coi trọng nhiều hay ít): không có địa vị * địa vị cao * tranh giành quyền lực, địa vị",
    example: "không có địa vị * địa vị cao * tranh giành quyền lực, địa vị",
  },
  {
    word: "địa vị",
    part_of_speech: "danh từ",
    meaning:
      "vị trí trong quan hệ xã hội, kinh tế, chính trị do vai trò, tác dụng mà có (về mặt được coi trọng nhiều hay ít): ngành công nghiệp có địa vị quan trọng trong nền kinh tế",
    example: "ngành công nghiệp có địa vị quan trọng trong nền kinh tế",
  },
  {
    word: "địa vị",
    part_of_speech: "danh từ",
    meaning:
      "vị trí, vai trò của cá nhân trong quan hệ xã hội quyết định cách nhìn, cách giải quyết vấn đề: đặt mình vào địa vị người khác để nhận định * ở địa vị anh, tôi sẽ không làm thế!",
    example:
      "đặt mình vào địa vị người khác để nhận định * ở địa vị anh, tôi sẽ không làm thế!",
  },
  {
    word: "địa vị",
    part_of_speech: "tính từ",
    meaning:
      "có tư tưởng ham muốn quyền lực, danh lợi, lúc nào cũng lo giành lấy hoặc lo củng cố vị trí, quyền lực cá nhân: óc địa vị * tư tưởng địa vị",
    example: "óc địa vị * tư tưởng địa vị",
  },
  {
    word: "địa vật lý",
    part_of_speech: "danh từ",
    meaning:
      "hệ các ngành khoa học nghiên cứu cấu trúc bên trong của Trái Đất và các tính chất, các quá trình vật lí xảy ra trong thạch quyển, khí quyển, thuỷ quyển của Trái Đất, trong mối tác dụng qua lại thường xuyên giữa chúng: số liệu khảo sát địa vật lí",
    example: "số liệu khảo sát địa vật lí",
  },
  {
    word: "địa vực",
    part_of_speech: "danh từ",
    meaning:
      "vùng, khu vực, trong quan hệ với cộng đồng người sinh sống ở đó: địa vực cư trú của người Thái",
    example: "địa vực cư trú của người Thái",
  },
  {
    word: "địch",
    part_of_speech: "danh từ",
    meaning: "(Từ cũ) sáo: tiếng địch thổi véo von",
    example: "tiếng địch thổi véo von",
  },
  {
    word: "địch",
    part_of_speech: "danh từ",
    meaning:
      "phía đối lập, có quan hệ chống nhau vì lẽ sống còn: bị địch bắt giam * phân biệt rõ địch, ta * tấn công tiêu diệt địch",
    example:
      "bị địch bắt giam * phân biệt rõ địch, ta * tấn công tiêu diệt địch",
  },
  {
    word: "địch",
    part_of_speech: "động từ",
    meaning:
      "chống lại với tư cách là phía đối lập: lấy ít địch nhiều * sức yếu, địch không nổi",
    example: "lấy ít địch nhiều * sức yếu, địch không nổi",
  },
  {
    word: "đích",
    part_of_speech: "danh từ",
    meaning:
      "chỗ, điểm nhằm vào mà bắn, ném: bắn không trúng đích * mũi tên cắm trúng đích",
    example: "bắn không trúng đích * mũi tên cắm trúng đích",
  },
  {
    word: "đích",
    part_of_speech: "danh từ",
    meaning: "chỗ, điểm nhằm đi tới, đạt tới: vận động viên về đích sớm nhất",
    example: "vận động viên về đích sớm nhất",
  },
  {
    word: "đích",
    part_of_speech: "trợ từ",
    meaning: "(khẩu ngữ) đích thị (nói tắt): quyển sách này đích là của tôi",
    example: "quyển sách này đích là của tôi",
  },
  {
    word: "đích danh",
    part_of_speech: "tính từ",
    meaning:
      "chính xác tên, người hay việc cụ thể nào đó, chứ không phải nói chung chung: chỉ đích danh * mời đích danh giám đốc",
    example: "chỉ đích danh * mời đích danh giám đốc",
  },
  {
    word: "địch hoạ",
    part_of_speech: "danh từ",
    meaning:
      "tai hoạ, tổn thất lớn do quân địch gây ra trong chiến tranh: đấu tranh chống thiên tai, địch hoạ",
    example: "đấu tranh chống thiên tai, địch hoạ",
  },
  {
    word: "đích thị",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý khẳng định chắc chắn rằng đúng là người đó, cái đó, chứ không phải ai khác, cái nào khác: nét chữ này đích thị là của hắn",
    example: "nét chữ này đích thị là của hắn",
  },
  {
    word: "đích đáng",
    part_of_speech: "tính từ",
    meaning:
      "tương xứng hoàn toàn với những gì tốt hay không tốt đã làm ra, gây ra: phần thưởng đích đáng * những nhận xét đích đáng * một bài học đích đáng",
    example:
      "phần thưởng đích đáng * những nhận xét đích đáng * một bài học đích đáng",
  },
  {
    word: "địch cừu",
    part_of_speech: "",
    meaning:
      "(cũ) như thù địch: đem lòng cừu địch * đối xử với nhau như cừu địch",
    example: "đem lòng cừu địch * đối xử với nhau như cừu địch",
  },
  {
    word: "đích thân",
    part_of_speech: "đại từ",
    meaning:
      "(trang trọng) chính bản thân (tự làm một việc nào đó mà bình thường có thể giao cho người khác): đích thân giám đốc đi kiểm tra",
    example: "đích thân giám đốc đi kiểm tra",
  },
  {
    word: "địch hậu",
    part_of_speech: "danh từ",
    meaning:
      "vùng ở sâu trong khu vực quân địch chiếm đóng và kiểm soát: hoạt động ở địch hậu",
    example: "hoạt động ở địch hậu",
  },
  {
    word: "địch thủ",
    part_of_speech: "danh từ",
    meaning: "người đối chọi, đối địch với mình: một địch thủ đáng gờm",
    example: "một địch thủ đáng gờm",
  },
  {
    word: "đích thực",
    part_of_speech: "tính từ",
    meaning:
      "đúng với sự thật: một hoạ sĩ đích thực * giá trị đích thực của cuộc sống",
    example: "một hoạ sĩ đích thực * giá trị đích thực của cuộc sống",
  },
  {
    word: "đích tôn",
    part_of_speech: "danh từ",
    meaning: "cháu trai trưởng bên nội: ông bà đã có cháu đích tôn",
    example: "ông bà đã có cháu đích tôn",
  },
  {
    word: "địch vận",
    part_of_speech: "động từ",
    meaning:
      "tuyên truyền, vận động nhằm lôi kéo người trong quân đội địch về phía mình, làm tan rã hàng ngũ địch: đẩy mạnh công tác địch vận",
    example: "đẩy mạnh công tác địch vận",
  },
  {
    word: "điếc",
    part_of_speech: "tính từ",
    meaning:
      "mất khả năng nghe, do tai bị tật: bị điếc bẩm sinh * cháu bé vừa câm vừa điếc",
    example: "bị điếc bẩm sinh * cháu bé vừa câm vừa điếc",
  },
  {
    word: "điếc",
    part_of_speech: "tính từ",
    meaning:
      "không còn khả năng phát ra tiếng bình thường như những vật cùng loại: lựu đạn điếc * bánh pháo có nhiều quả bị điếc",
    example: "lựu đạn điếc * bánh pháo có nhiều quả bị điếc",
  },
  {
    word: "điếc",
    part_of_speech: "tính từ",
    meaning:
      "không phát triển như bình thường, bị khô và quắt lại (thường nói về quả): cau điếc * đu đủ điếc",
    example: "cau điếc * đu đủ điếc",
  },
  {
    word: "đích xác",
    part_of_speech: "tính từ",
    meaning: "hoàn toàn đúng với sự thật: chứng cứ đích xác",
    example: "chứng cứ đích xác",
  },
  {
    word: "điếc lác",
    part_of_speech: "tính từ",
    meaning: "điếc do tai bị tật (nói khái quát): ông lão già cả, điếc lác",
    example: "ông lão già cả, điếc lác",
  },
  {
    word: "điếm",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) gái điếm (nói tắt): làm điếm",
    example: "làm điếm",
  },
  {
    word: "điếm",
    part_of_speech: "danh từ",
    meaning: "điếm canh (nói tắt): canh điếm",
    example: "canh điếm",
  },
  {
    word: "điểm",
    part_of_speech: "danh từ",
    meaning:
      "hình nhỏ nhất, thường hình tròn, mà mắt có thể nhìn thấy được: chỉ có duy nhất một điểm sáng trong bóng tối * điểm hồng tâm",
    example: "chỉ có duy nhất một điểm sáng trong bóng tối * điểm hồng tâm",
  },
  {
    word: "điểm",
    part_of_speech: "danh từ",
    meaning:
      "đối tượng cơ bản của hình học, mà hình ảnh trực quan là một chấm nhỏ đến mức như không có bề dài, bề rộng, bề dày: qua hai điểm chỉ có thể kẻ được một đường thẳng và chỉ một mà thôi",
    example:
      "qua hai điểm chỉ có thể kẻ được một đường thẳng và chỉ một mà thôi",
  },
  {
    word: "điểm",
    part_of_speech: "danh từ",
    meaning:
      "phần không gian nhỏ nhất có thể hạn định được một cách chính xác, xét về mặt nào đó: đi đến điểm hẹn * điểm xuất phát * điểm du lịch",
    example: "đi đến điểm hẹn * điểm xuất phát * điểm du lịch",
  },
  {
    word: "điểm",
    part_of_speech: "danh từ",
    meaning:
      "phần nhỏ nhất có thể hạn định rõ trong toàn bộ một nội dung: báo cáo gồm năm điểm chính * những điểm quan trọng cần chú ý",
    example: "báo cáo gồm năm điểm chính * những điểm quan trọng cần chú ý",
  },
  {
    word: "điểm",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị quy định được tính bằng con số để đánh giá chất lượng, thành tích học tập, thể thao hoặc lao động: chỉ được có 6 điểm văn * bị đội bạn dẫn điểm trước",
    example: "chỉ được có 6 điểm văn * bị đội bạn dẫn điểm trước",
  },
  {
    word: "điểm",
    part_of_speech: "danh từ",
    meaning:
      "mức có thể xác định một cách rõ ràng của một quá trình phát triển: phong trào đã lên đến điểm cao nhất * điểm mốc * điểm nút",
    example: "phong trào đã lên đến điểm cao nhất * điểm mốc * điểm nút",
  },
  {
    word: "điểm",
    part_of_speech: "danh từ",
    meaning:
      "nhiệt độ ở đó xảy ra một biến đổi vật lí: điểm sôi của nước là 100oC * điểm bão hoà * điểm nóng chảy * điểm đóng băng",
    example:
      "điểm sôi của nước là 100oC * điểm bão hoà * điểm nóng chảy * điểm đóng băng",
  },
  {
    word: "điểm",
    part_of_speech: "động từ",
    meaning:
      "tạo ra điểm khi vẽ: điểm một chấm nhỏ để tạo mắt cho hình con chim",
    example: "điểm một chấm nhỏ để tạo mắt cho hình con chim",
  },
  {
    word: "điểm",
    part_of_speech: "động từ",
    meaning:
      "có xen lẫn và hiện rõ lên một số điểm, một số nét: tóc đã điểm bạc * điểm thêm một vài nét chấm phá",
    example: "tóc đã điểm bạc * điểm thêm một vài nét chấm phá",
  },
  {
    word: "điểm",
    part_of_speech: "động từ",
    meaning:
      "đếm lần lượt từng cá thể để kiểm tra số lượng: điểm từ một đến mười * điểm lại số người có mặt",
    example: "điểm từ một đến mười * điểm lại số người có mặt",
  },
  {
    word: "điểm",
    part_of_speech: "động từ",
    meaning:
      "xem xét từng yếu tố, từng thành viên để đánh giá: điểm mặt các cá nhân xuất sắc * điểm lại tình hình tuần qua",
    example: "điểm mặt các cá nhân xuất sắc * điểm lại tình hình tuần qua",
  },
  {
    word: "điểm",
    part_of_speech: "động từ",
    meaning:
      "(tiếng chuông, trống, v.v.) đánh thong thả từng tiếng một: chuông nhà thờ đã điểm * trống điểm giờ vào lớp",
    example: "chuông nhà thờ đã điểm * trống điểm giờ vào lớp",
  },
  {
    word: "điểm",
    part_of_speech: "động từ",
    meaning:
      "đánh bằng đầu ngón tay ngay vào chỗ hiểm (một đòn hiểm trong quyền thuật): điểm trúng huyệt",
    example: "điểm trúng huyệt",
  },
  {
    word: "điểm chuẩn",
    part_of_speech: "danh từ",
    meaning:
      "mức điểm trúng tuyển của một trường, một khoa: các trường đại học công bố điểm chuẩn * điểm chuẩn tuyển sinh lớp 10",
    example:
      "các trường đại học công bố điểm chuẩn * điểm chuẩn tuyển sinh lớp 10",
  },
  {
    word: "điểm cao",
    part_of_speech: "danh từ",
    meaning:
      "chỗ nhô lên cao hơn hẳn mặt đất, như gò, đồi, núi, v.v., trên một địa hình: địch đã chiếm được điểm cao",
    example: "địch đã chiếm được điểm cao",
  },
  {
    word: "điềm",
    part_of_speech: "danh từ",
    meaning:
      "dấu hiệu báo trước rằng sẽ có việc bất thường xảy ra, thường theo mê tín: điềm gở * điềm lành",
    example: "điềm gở * điềm lành",
  },
  {
    word: "điểm báo",
    part_of_speech: "động từ",
    meaning:
      "tóm lược những tin quan trọng trên các tờ báo, tạp chí và phương tiện thông tin đại chúng ở một thời điểm nào đó (ngày hoặc tuần): mục điểm báo trên truyền hình",
    example: "mục điểm báo trên truyền hình",
  },
  {
    word: "điểm chỉ",
    part_of_speech: "động từ",
    meaning: "(cũ) lăn tay: điểm chỉ vào giấy gán ruộng",
    example: "điểm chỉ vào giấy gán ruộng",
  },
  {
    word: "điểm danh",
    part_of_speech: "động từ",
    meaning:
      "đọc tên để kiểm tra số người có mặt (tại một thời điểm) trong đơn vị: tập trung toàn đơn vị để điểm danh * điểm danh đầu giờ học",
    example: "tập trung toàn đơn vị để điểm danh * điểm danh đầu giờ học",
  },
  {
    word: "điềm đạm",
    part_of_speech: "tính từ",
    meaning:
      "lúc nào cũng từ tốn, nhẹ nhàng, không gắt gỏng, nóng nảy: tính khí điềm đạm * nói năng điềm đạm",
    example: "tính khí điềm đạm * nói năng điềm đạm",
  },
  {
    word: "điểm nhìn",
    part_of_speech: "danh từ",
    meaning:
      "điểm xuất phát khi xem xét, nhận định về một vấn đề: điểm nhìn khác nhau dẫn đến cách đánh giá khác nhau",
    example: "điểm nhìn khác nhau dẫn đến cách đánh giá khác nhau",
  },
  {
    word: "điềm nhiên",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra bình thường, coi như không biết, không cần chú ý đến chuyện gì đang xảy ra: giặc đến nhà vẫn điềm nhiên ngồi uống rượu",
    example: "giặc đến nhà vẫn điềm nhiên ngồi uống rượu",
  },
  {
    word: "điếm nhục",
    part_of_speech: "tính từ",
    meaning: "như nhục nhã: làm điếm nhục tổ tiên",
    example: "làm điếm nhục tổ tiên",
  },
  {
    word: "điểm nóng",
    part_of_speech: "danh từ",
    meaning:
      "nơi diễn ra những xung đột căng thẳng hoặc tập trung mâu thuẫn cao độ cần được giải quyết: vùng Trung Đông đang là điểm nóng",
    example: "vùng Trung Đông đang là điểm nóng",
  },
  {
    word: "điểm nóng",
    part_of_speech: "danh từ",
    meaning:
      "sự việc, vấn đề có tính chất thời sự và cấp thiết, gây được sự chú ý, quan tâm: điểm nóng về thu hút vốn đầu tư * quan tâm đến những điểm nóng của thế giới",
    example:
      "điểm nóng về thu hút vốn đầu tư * quan tâm đến những điểm nóng của thế giới",
  },
  {
    word: "điểm sách",
    part_of_speech: "động từ",
    meaning:
      "giới thiệu cùng với lời đánh giá ngắn gọn và tổng quát về nội dung cũng như hình thức một cuốn sách: mục điểm sách",
    example: "mục điểm sách",
  },
  {
    word: "điểm số",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) số điểm đánh giá, thể hiện chất lượng, thành tích học tập của học sinh: giành điểm số cao",
    example: "giành điểm số cao",
  },
  {
    word: "điểm số",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) kiểm tra số người trong hàng ngũ bằng cách mỗi người lần lượt tự đếm lấy số thứ tự của mình: điểm số từ một đến hết",
    example: "điểm số từ một đến hết",
  },
  {
    word: "điểm tựa",
    part_of_speech: "danh từ",
    meaning:
      "điểm cố định của một đòn bẩy, thông qua đó lực tác động được truyền tới lực cản.",
    example:
      "điểm tựa về tinh thần * xây dựng hậu phương vững mạnh để làm điểm tựa cho tiền tuyến",
  },
  {
    word: "điểm tựa",
    part_of_speech: "danh từ",
    meaning:
      "nơi làm chỗ dựa chính (ví như điểm tựa của đòn bẩy) cho những hoạt động nào đó: điểm tựa về tinh thần * xây dựng hậu phương vững mạnh để làm điểm tựa cho tiền tuyến",
    example: "canh giữ nơi điểm tựa",
  },
  {
    word: "điểm tâm",
    part_of_speech: "động từ",
    meaning: "ăn lót dạ (lối nói lịch sự): bữa điểm tâm * đồ điểm tâm",
    example: "bữa điểm tâm * đồ điểm tâm",
  },
  {
    word: "điểm trang",
    part_of_speech: "động từ",
    meaning:
      '(hiếm) như trang điểm: "Tiểu thư vâng dậy mừng lòng, Sửa sang quần áo, má hồng điểm trang." (LNT)',
    example:
      'Tiểu thư vâng dậy mừng lòng, Sửa sang quần áo, má hồng điểm trang." (LNT)',
  },
  {
    word: "điểm sàn",
    part_of_speech: "danh từ",
    meaning:
      "mức điểm xét tuyển tối thiểu, do cơ quan chức năng quy định, để các trường nhận đơn xét tuyển của thí sinh: công bố điểm sàn của kì thi đại học năm 2006",
    example: "công bố điểm sàn của kì thi đại học năm 2006",
  },
  {
    word: "điềm tĩnh",
    part_of_speech: "tính từ",
    meaning:
      "hoàn toàn bình tĩnh, tỏ ra tự nhiên như thường, không hề bối rối, sợ hãi: nét mặt điềm tĩnh * sợ nhưng vẫn cố giữ vẻ điềm tĩnh",
    example: "nét mặt điềm tĩnh * sợ nhưng vẫn cố giữ vẻ điềm tĩnh",
  },
  {
    word: "điểm xuyết",
    part_of_speech: "động từ",
    meaning:
      "điểm thêm vào nhằm làm cho đẹp hơn: tấm lụa có điểm xuyết những hình lá cây",
    example: "tấm lụa có điểm xuyết những hình lá cây",
  },
  {
    word: "điên",
    part_of_speech: "tính từ",
    meaning:
      "ở tình trạng bệnh lí về tâm thần, mất năng lực tự chủ và năng lực kiềm chế hành vi, thường có những hoạt động quá khích: bệnh điên * phát điên * tức điên lên",
    example: "bệnh điên * phát điên * tức điên lên",
  },
  {
    word: "điện",
    part_of_speech: "danh từ",
    meaning: "lâu đài làm nơi ở và làm việc của vua: điện Diên Hồng",
    example: "điện Diên Hồng",
  },
  {
    word: "điện",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) nơi thờ thần thánh: điện thờ Thánh Mẫu * trên điện thờ nến cắm la liệt",
    example: "điện thờ Thánh Mẫu * trên điện thờ nến cắm la liệt",
  },
  {
    word: "điện",
    part_of_speech: "danh từ",
    meaning:
      "dạng năng lượng có thể biểu hiện bằng tác dụng nhiệt, cơ, hoá, v.v., thường dùng để thắp sáng, chạy máy: máy phát điện * đèn điện * quạt điện",
    example: "máy phát điện * đèn điện * quạt điện",
  },
  {
    word: "điện",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) dòng điện (nói tắt): cắt điện * nối điện",
    example: "cắt điện * nối điện",
  },
  {
    word: "điện",
    part_of_speech: "danh từ",
    meaning: "điện báo (nói tắt): đánh điện * bức điện khẩn",
    example: "đánh điện * bức điện khẩn",
  },
  {
    word: "điện",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) điện thoại (nói tắt): gọi điện * đang nghe điện",
    example: "gọi điện * đang nghe điện",
  },
  {
    word: "điện",
    part_of_speech: "động từ",
    meaning:
      "đánh điện báo hoặc gọi điện thoại: điện ngay về cho gia đình biết tin",
    example: "điện ngay về cho gia đình biết tin",
  },
  {
    word: "điển",
    part_of_speech: "danh từ",
    meaning:
      "điển tích hay điển cố (nói tắt): câu văn được dẫn theo một điển cổ",
    example: "câu văn được dẫn theo một điển cổ",
  },
  {
    word: "điển",
    part_of_speech: "tính từ",
    meaning: "(Khẩu ngữ) như bảnh (ng1): ăn mặc rất điển * điển trai",
    example: "ăn mặc rất điển * điển trai",
  },
  {
    word: "điện ảnh",
    part_of_speech: "danh từ",
    meaning:
      "nghệ thuật phản ánh hiện thực bằng những hình ảnh hoạt động liên tục, được thu vào phim rồi chiếu lên màn ảnh, màn hình: diễn viên điện ảnh * ngôi sao điện ảnh",
    example: "diễn viên điện ảnh * ngôi sao điện ảnh",
  },
  {
    word: "điển cố",
    part_of_speech: "danh từ",
    meaning:
      "sự việc hay câu chữ trong sách đời trước được dẫn lại một cách súc tích trong thơ văn: điển cố văn học",
    example: "điển cố văn học",
  },
  {
    word: "điên cuồng",
    part_of_speech: "tính từ",
    meaning:
      "có hành động, trạng thái như bị mất trí, không tự kiềm chế được, do bị kích thích quá mạnh: giặc bắn phá điên cuồng",
    example: "giặc bắn phá điên cuồng",
  },
  {
    word: "điện báo",
    part_of_speech: "danh từ",
    meaning:
      "phương thức truyền tin bằng hình thức tín hiệu điện: liên lạc bằng điện báo",
    example: "liên lạc bằng điện báo",
  },
  {
    word: "điện báo",
    part_of_speech: "danh từ",
    meaning:
      "giấy ghi lại nội dung được truyền đi bằng tín hiệu điện: nhận điện báo",
    example: "nhận điện báo",
  },
  {
    word: "điền",
    part_of_speech: "động từ",
    meaning:
      "viết vào những chỗ còn trống, còn khuyết: điền vào ô trống * điền đầy đủ các thông tin yêu cầu trong hoá đơn",
    example:
      "điền vào ô trống * điền đầy đủ các thông tin yêu cầu trong hoá đơn",
  },
  {
    word: "điên dại",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái gần như mất hết cảm giác và lí trí của người bình thường: đau đớn đến điên dại * cười như điên dại",
    example: "đau đớn đến điên dại * cười như điên dại",
  },
  {
    word: "điện đàm",
    part_of_speech: "động từ",
    meaning:
      "nói chuyện (thường là chuyện quan trọng) qua điện thoại: buổi điện đàm giữa bộ trưởng bộ ngoại giao hai nước",
    example: "buổi điện đàm giữa bộ trưởng bộ ngoại giao hai nước",
  },
  {
    word: "điền dã",
    part_of_speech: "danh từ",
    meaning: "(cũ) nơi đồng ruộng, nông thôn: từ quan về sống nơi điền dã",
    example: "từ quan về sống nơi điền dã",
  },
  {
    word: "điền dã",
    part_of_speech: "danh từ",
    meaning:
      "vùng xa thành phố, là nơi tiến hành những cuộc điều tra, khảo sát trong nghiên cứu khoa học: đi điền dã * tư liệu điều tra điền dã",
    example: "đi điền dã * tư liệu điều tra điền dã",
  },
  {
    word: "điên đầu",
    part_of_speech: "tính từ",
    meaning:
      "(đầu óc) ở trạng thái căng thẳng, rối bời do bị ức chế hoặc do phải suy nghĩ, tính toán mà vẫn không tìm ra lối thoát: điên đầu vì nợ nần",
    example: "điên đầu vì nợ nần",
  },
  {
    word: "điền địa",
    part_of_speech: "danh từ",
    meaning: "(cũ) ruộng đất: cải cách điền địa",
    example: "cải cách điền địa",
  },
  {
    word: "điện đài",
    part_of_speech: "danh từ",
    meaning: "máy thu phát vô tuyến điện: liên lạc bằng điện đài",
    example: "liên lạc bằng điện đài",
  },
  {
    word: "điên đảo",
    part_of_speech: "tính từ",
    meaning: "như đảo điên (ng1): thời buổi điên đảo",
    example: "thời buổi điên đảo",
  },
  {
    word: "điện đóm",
    part_of_speech: "danh từ",
    meaning:
      "điện, đèn điện để thắp sáng (nói khái quát; thường hàm ý mỉa mai): điện đóm tù mù * nhà cửa tối om, chẳng thấy điện đóm gì",
    example: "điện đóm tù mù * nhà cửa tối om, chẳng thấy điện đóm gì",
  },
  {
    word: "điên điển",
    part_of_speech: "danh từ",
    meaning:
      "cây thuộc họ đậu, thân có lõi xốp màu trắng, hoa màu vàng, thường nở vào tháng tám, sống chủ yếu ở vùng đầm lầy, có nhiều ở Nam Bộ: bông điên điển",
    example: "bông điên điển",
  },
  {
    word: "điển hình",
    part_of_speech: "tính từ",
    meaning:
      "có tính tiêu biểu nhất, biểu hiện tập trung và rõ nhất về bản chất của một nhóm hiện tượng, đối tượng: trường hợp điển hình * chọn thí dụ điển hình",
    example: "trường hợp điển hình * chọn thí dụ điển hình",
  },
  {
    word: "điển hình",
    part_of_speech: "danh từ",
    meaning:
      "hình tượng nghệ thuật vừa có những nét cá biệt sinh động, vừa có tính khái quát cao, phản ánh được những nét tiêu biểu nhất của hiện thực: điển hình văn học",
    example: "điển hình văn học",
  },
  {
    word: "điển hình hoá",
    part_of_speech: "động từ",
    meaning:
      "làm cho có tính chất điển hình, xây dựng những tính cách và hoàn cảnh điển hình trong tác phẩm văn nghệ: phương pháp điển hình hoá trong văn học",
    example: "phương pháp điển hình hoá trong văn học",
  },
  {
    word: "điện lạnh",
    part_of_speech: "danh từ",
    meaning:
      "các thiết bị dùng điện để làm lạnh (như tủ lạnh, máy làm kem, v.v.) nói chung: sửa chữa đồ điện lạnh * chuyên kinh doanh các mặt hàng điện lạnh",
    example: "sửa chữa đồ điện lạnh * chuyên kinh doanh các mặt hàng điện lạnh",
  },
  {
    word: "điện hoa",
    part_of_speech: "danh từ",
    meaning:
      "hoa được chuyển tới địa chỉ cần thiết theo yêu cầu của khách hàng, thông qua dịch vụ bưu điện: gửi điện hoa chúc mừng * dịch vụ điện hoa",
    example: "gửi điện hoa chúc mừng * dịch vụ điện hoa",
  },
  {
    word: "điên khùng",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra như không còn kiểm soát được hành động, lời nói của mình hoặc có những hành động phá phách như người điên, do quá tức giận: hành động điên khùng",
    example: "hành động điên khùng",
  },
  {
    word: "điện khí hoá",
    part_of_speech: "động từ",
    meaning:
      "làm cho điện được dùng rộng rãi trong sản xuất và sinh hoạt: điện khí hoá nông thôn",
    example: "điện khí hoá nông thôn",
  },
  {
    word: "điền kinh",
    part_of_speech: "danh từ",
    meaning:
      "các môn thể thao như đi bộ, chạy, nhảy, ném, v.v. (nói tổng quát): vận động viên điền kinh",
    example: "vận động viên điền kinh",
  },
  {
    word: "điện lưới",
    part_of_speech: "danh từ",
    meaning:
      "điện được sử dụng từ mạng điện công cộng của thành phố hay quốc gia: hệ thống điện lưới quốc gia * mất điện lưới",
    example: "hệ thống điện lưới quốc gia * mất điện lưới",
  },
  {
    word: "điện lực",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như điện năng: sản xuất cáp điện lực",
    example: "sản xuất cáp điện lực",
  },
  {
    word: "điện lực",
    part_of_speech: "danh từ",
    meaning: "cơ quan quản lí về điện: sở điện lực * ngành điện lực",
    example: "sở điện lực * ngành điện lực",
  },
  {
    word: "điển lệ",
    part_of_speech: "danh từ",
    meaning: "(cũ, hiếm) như điển chế: điển lệ về thi cử",
    example: "điển lệ về thi cử",
  },
  {
    word: "điên loạn",
    part_of_speech: "tính từ",
    meaning:
      "có những biểu hiện, hành động hoàn toàn mất trí như đã hoá điên: gào lên như điên loạn * cơn điên loạn",
    example: "gào lên như điên loạn * cơn điên loạn",
  },
  {
    word: "điên loạn",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái rối loạn hoàn toàn như trong cơn điên: điệu nhảy điên loạn",
    example: "điệu nhảy điên loạn",
  },
  {
    word: "điện máy",
    part_of_speech: "danh từ",
    meaning:
      "máy móc, thiết bị, dụng cụ về điện nói chung: cửa hàng điện máy (cửa hàng bán các đồ điện)",
    example: "cửa hàng điện máy (cửa hàng bán các đồ điện)",
  },
  {
    word: "điện não đồ",
    part_of_speech: "danh từ",
    meaning:
      "bản ghi hoạt động của não bằng thiết bị điện chuyên dụng: làm điện não đồ",
    example: "làm điện não đồ",
  },
  {
    word: "điên rồ",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái như hoàn toàn mất hết trí khôn, đến mức không kiềm chế được hành vi của mình: hành động điên rồ * ý nghĩ điên rồ",
    example: "hành động điên rồ * ý nghĩ điên rồ",
  },
  {
    word: "điện quang",
    part_of_speech: "danh từ",
    meaning: "tia X, dùng để chiếu hoặc chụp: chụp điện quang * máy điện quang",
    example: "chụp điện quang * máy điện quang",
  },
  {
    word: "điện tâm đồ",
    part_of_speech: "danh từ",
    meaning: "bản ghi hoạt động của tim bằng máy điện tim: máy điện tâm đồ",
    example: "máy điện tâm đồ",
  },
  {
    word: "điện sinh học",
    part_of_speech: "danh từ",
    meaning:
      "điện phát sinh trong một số cơ thể sinh vật, có khả năng ảnh hưởng đến các sinh vật khác khi tiếp xúc: chữa bệnh bằng điện sinh học",
    example: "chữa bệnh bằng điện sinh học",
  },
  {
    word: "điện thoại",
    part_of_speech: "danh từ",
    meaning:
      "máy truyền tiếng nói từ nơi này đến nơi khác bằng đường dây hoặc bằng sóng vô tuyến điện: nói chuyện qua điện thoại * lắp đặt điện thoại",
    example: "nói chuyện qua điện thoại * lắp đặt điện thoại",
  },
  {
    word: "điện thoại",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) gọi điện thoại (nói tắt): điện thoại về cho mẹ",
    example: "điện thoại về cho mẹ",
  },
  {
    word: "điện thoại viên",
    part_of_speech: "danh từ",
    meaning:
      "nhân viên làm việc ở tổng đài điện thoại: điện thoại viên của tổng đài 1080",
    example: "điện thoại viên của tổng đài 1080",
  },
  {
    word: "điện tín",
    part_of_speech: "danh từ",
    meaning: "công việc thông tin bằng tín hiệu điện.",
    example: "gửi điện tín",
  },
  {
    word: "điển tích",
    part_of_speech: "danh từ",
    meaning:
      "câu chuyện trong sách đời trước được dẫn lại một cách cô đúc trong tác phẩm: giảng nghĩa một điển tích",
    example: "giảng nghĩa một điển tích",
  },
  {
    word: "điên tiết",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) tức giận đến cao độ, thường có những cử chỉ, hành động thô bạo do không kiềm chế nổi: điên tiết, tát cho một phát * chỉ nghe cái giọng của nó đã thấy điên tiết",
    example:
      "điên tiết, tát cho một phát * chỉ nghe cái giọng của nó đã thấy điên tiết",
  },
  {
    word: "điện toán đám mây",
    part_of_speech: "danh từ",
    meaning:
      "phương thức sử dụng máy tính trong đó dữ liệu và phần mềm được lưu trữ hoặc quản lí trên một mạng lưới các máy chủ có kết nối Internet: Máy tính này sử dụng các dịch vụ điện toán đám mây chứ không cài sẵn phần mềm.",
    example:
      "Máy tính này sử dụng các dịch vụ điện toán đám mây chứ không cài sẵn phần mềm.",
  },
  {
    word: "điển trai",
    part_of_speech: "tính từ",
    meaning: "(Khẩu ngữ) như đẹp trai: một anh chàng khá điển trai",
    example: "một anh chàng khá điển trai",
  },
  {
    word: "điện tử",
    part_of_speech: "tính từ",
    meaning:
      "có sử dụng các phương pháp điện tử học hoặc hoạt động theo các nguyên lí của điện tử học: đồng hồ điện tử * máy tính điện tử * đồ chơi điện tử",
    example: "đồng hồ điện tử * máy tính điện tử * đồ chơi điện tử",
  },
  {
    word: "điệp",
    part_of_speech: "danh từ",
    meaning: "(cũ, văn chương) hồ điệp (nói tắt): cánh điệp",
    example: "cánh điệp",
  },
  {
    word: "điệp",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) phượng: bông điệp",
    example: "bông điệp",
  },
  {
    word: "điệp",
    part_of_speech: "động từ",
    meaning:
      "có sự lặp lại về mặt ngôn ngữ: câu thơ sử dụng nhiều từ điệp vần * điệp ý * sử dụng biện pháp điệp ngữ",
    example:
      "câu thơ sử dụng nhiều từ điệp vần * điệp ý * sử dụng biện pháp điệp ngữ",
  },
  {
    word: "điện từ",
    part_of_speech: "danh từ",
    meaning:
      "hiện tượng liên quan giữa từ trường và dòng điện: sóng điện từ (như sóng vô tuyến, tia X, v.v.)",
    example: "sóng điện từ (như sóng vô tuyến, tia X, v.v.)",
  },
  {
    word: "điện văn",
    part_of_speech: "danh từ",
    meaning: "văn bản gửi bằng điện báo: gửi điện văn chúc mừng",
    example: "gửi điện văn chúc mừng",
  },
  {
    word: "điếng",
    part_of_speech: "tính từ",
    meaning:
      "ở vào trạng thái mất cảm giác toàn thân trong một thời gian ngắn do phải chịu một tác động rất mạnh và đột ngột: bị một cái tát đau điếng * điếng người đi vì tin dữ",
    example: "bị một cái tát đau điếng * điếng người đi vì tin dữ",
  },
  {
    word: "điền viên",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, văn chương) ruộng và vườn; thường dùng để tả cuộc sống thảnh thơi ở chốn thôn quê, thoát khỏi sự ràng buộc của công danh: vui thú điền viên",
    example: "vui thú điền viên",
  },
  {
    word: "điệp trùng",
    part_of_speech: "tính từ",
    meaning: "như trùng điệp: rừng núi điệp trùng",
    example: "rừng núi điệp trùng",
  },
  {
    word: "điệp vận",
    part_of_speech: "danh từ",
    meaning: "vần (ở vị trí nhất định) trùng lặp trong thơ: thơ điệp vận",
    example: "thơ điệp vận",
  },
  {
    word: "điệp khúc",
    part_of_speech: "danh từ",
    meaning:
      "câu hay đoạn được lặp lại nhiều lần trong một bài hát, bản nhạc hay bài thơ: hát đoạn điệp khúc",
    example: "hát đoạn điệp khúc",
  },
  {
    word: "điệp khúc",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) hành động, lời nói được lặp lại nhiều lần, thường gây cảm giác nhàm chán, khó chịu: nhắc đi nhắc lại điệp khúc ấy",
    example: "nhắc đi nhắc lại điệp khúc ấy",
  },
  {
    word: "điều",
    part_of_speech: "danh từ",
    meaning:
      "cây ăn quả cùng họ với sấu, phiến lá dày, hình trứng và tròn đầu, quả hình quả thận dính trên một cuống phình to giống như hình quả đào.",
    example:
      'không làm những điều xấu * "Yêu nhau căn dặn đủ điều, Càng say về nết, càng yêu vì tình." (Cdao)',
  },
  {
    word: "điều",
    part_of_speech: "danh từ",
    meaning:
      'từ dùng để chỉ từng đơn vị sự việc: không làm những điều xấu * "Yêu nhau căn dặn đủ điều, Càng say về nết, càng yêu vì tình." (Cdao)',
    example: "nói điều hay, làm việc tốt",
  },
  {
    word: "điều",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị những lời nói: nói điều hay, làm việc tốt",
    example: "bản thoả thuận gồm có 5 điều * căn cứ vào điều 20 của hiến pháp",
  },
  {
    word: "điều",
    part_of_speech: "danh từ",
    meaning:
      "điểm, khoản được trình bày riêng rẽ trong các văn bản có tính chất pháp luật: bản thoả thuận gồm có 5 điều * căn cứ vào điều 20 của hiến pháp",
    example: "bơ đi, ra cái điều không cần",
  },
  {
    word: "điều",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) (người, cấp có thẩm quyền) đưa một bộ phận người hay phương tiện nào đó đến nơi khác để bổ sung, để khắc phục tình trạng quá chênh lệch: điều lên công tác ở miền núi * điều thêm nhân lực",
    example: "điều lên công tác ở miền núi * điều thêm nhân lực",
  },
  {
    word: "điều",
    part_of_speech: "tính từ",
    meaning:
      'có màu đỏ tươi (thường do nhuộm): phẩm điều * "Nhiễu điều phủ lấy giá gương, Người trong một nước thì thương nhau cùng." (Cdao)',
    example:
      'phẩm điều * "Nhiễu điều phủ lấy giá gương, Người trong một nước thì thương nhau cùng." (Cdao)',
  },
  {
    word: "điêu",
    part_of_speech: "tính từ",
    meaning: "có tính hay nói sai sự thật, để lừa dối: nói điêu * tính điêu",
    example: "nói điêu * tính điêu",
  },
  {
    word: "điêu",
    part_of_speech: "tính từ",
    meaning: "gian dối, man trá: cân điêu cho khách hàng",
    example: "cân điêu cho khách hàng",
  },
  {
    word: "điệp viên",
    part_of_speech: "danh từ",
    meaning:
      "nhân viên điệp báo: điệp viên kinh tế * mạng lưới điệp viên dày đặc * lớp đào tạo điệp viên",
    example:
      "điệp viên kinh tế * mạng lưới điệp viên dày đặc * lớp đào tạo điệp viên",
  },
  {
    word: "điệu",
    part_of_speech: "danh từ",
    meaning:
      "đặc điểm bên ngoài về cách đi đứng, nói năng của mỗi người: điệu nói, dáng đi * điệu cười",
    example: "điệu nói, dáng đi * điệu cười",
  },
  {
    word: "điệu",
    part_of_speech: "danh từ",
    meaning:
      "đặc điểm về hình thức diễn ra của một hoạt động: ngồi dậy với một điệu mệt nhọc * mỗi người một điệu cảm, một cách nghĩ riêng",
    example:
      "ngồi dậy với một điệu mệt nhọc * mỗi người một điệu cảm, một cách nghĩ riêng",
  },
  {
    word: "điệu",
    part_of_speech: "danh từ",
    meaning:
      "tính chất của sự kết hợp các âm thanh trầm bổng với nhau để tạo thành ý nhạc hoàn chỉnh của cả một chuỗi âm thanh: bài thơ có vần có điệu * hát sai điệu",
    example: "bài thơ có vần có điệu * hát sai điệu",
  },
  {
    word: "điệu",
    part_of_speech: "danh từ",
    meaning:
      "đặc điểm về hình thức, tính chất, làm phân biệt một kiểu tác phẩm nghệ thuật âm nhạc hoặc múa với những kiểu khác: điệu múa dân gian * điệu nhạc cổ truyền",
    example: "điệu múa dân gian * điệu nhạc cổ truyền",
  },
  {
    word: "điệu",
    part_of_speech: "danh từ",
    meaning: "từ dùng để chỉ từng đơn vị những bài múa: biểu diễn một điệu múa",
    example: "biểu diễn một điệu múa",
  },
  {
    word: "điệu",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) có cử chỉ, điệu bộ, lối nói năng cố làm cho ra duyên dáng, lịch sự, trở thành không tự nhiên, có vẻ kiểu cách: dáng đi rất điệu * con bé điệu lắm!",
    example: "dáng đi rất điệu * con bé điệu lắm!",
  },
  {
    word: "điệu",
    part_of_speech: "động từ",
    meaning:
      "đưa đi, bắt đi bằng cách cưỡng bức: điệu tên trộm lên đồn công an",
    example: "điệu tên trộm lên đồn công an",
  },
  {
    word: "điếu",
    part_of_speech: "danh từ",
    meaning: "vật dùng để hút thuốc lào.",
    example: "vê điếu thuốc lá * điếu xì gà",
  },
  {
    word: "điều binh khiển tướng",
    part_of_speech: "",
    meaning: "điều động và chỉ huy quân sĩ: có tài điều binh khiển tướng",
    example: "có tài điều binh khiển tướng",
  },
  {
    word: "điệu bộ",
    part_of_speech: "danh từ",
    meaning:
      "các cử chỉ, động tác của tay, chân, v.v. nhằm diễn đạt một điều gì (nói tổng quát): điệu bộ khoan thai * vừa hát vừa làm điệu bộ như đang biểu diễn",
    example: "điệu bộ khoan thai * vừa hát vừa làm điệu bộ như đang biểu diễn",
  },
  {
    word: "điệu bộ",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) có các cử chỉ, động tác không tự nhiên, khác với bình thường, để làm duyên, làm dáng: cô bé trông rất điệu bộ",
    example: "cô bé trông rất điệu bộ",
  },
  {
    word: "điều áp",
    part_of_speech: "động từ",
    meaning:
      "giữ ở áp suất không biến đổi trong một thể tích nào đó: van điều áp",
    example: "van điều áp",
  },
  {
    word: "điều chỉnh",
    part_of_speech: "động từ",
    meaning:
      "sửa đổi, sắp xếp lại ít nhiều cho đúng hơn, hợp lí hơn: điều chỉnh mức lương * điều chỉnh giá xăng dầu",
    example: "điều chỉnh mức lương * điều chỉnh giá xăng dầu",
  },
  {
    word: "điều biến",
    part_of_speech: "động từ",
    meaning:
      "quá trình chuyển đổi thông tin dạng số thành sóng âm chứa cùng thông tin đó: modem điều biến",
    example: "modem điều biến",
  },
  {
    word: "điều chuyển",
    part_of_speech: "động từ",
    meaning:
      "đưa đến bổ sung cho nơi khác, nhằm đáp ứng yêu cầu của công việc: điều chuyển công tác * điều chuyển dân cư * điều chuyển vốn",
    example: "điều chuyển công tác * điều chuyển dân cư * điều chuyển vốn",
  },
  {
    word: "điều chế",
    part_of_speech: "động từ",
    meaning:
      "tạo ra chất mới từ những chất đã có sẵn: điều chế hoá chất * điều chế dược phẩm",
    example: "điều chế hoá chất * điều chế dược phẩm",
  },
  {
    word: "điều dưỡng",
    part_of_speech: "động từ",
    meaning:
      "(người bị suy yếu về sức lực, tinh thần hoặc vừa khỏi ốm) ăn uống bồi dưỡng và nghỉ ngơi, có dùng thuốc men khi cần thiết, để hồi phục sức khoẻ, trong một cơ quan y tế: trại điều dưỡng thương binh * nằm điều dưỡng ở quân y viện",
    example: "trại điều dưỡng thương binh * nằm điều dưỡng ở quân y viện",
  },
  {
    word: "điệu đà",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) như điệu đàng: ăn mặc điệu đà * mái tóc tỉa rất điệu đà",
    example: "ăn mặc điệu đà * mái tóc tỉa rất điệu đà",
  },
  {
    word: "điều đình",
    part_of_speech: "động từ",
    meaning:
      "bàn bạc để đạt đến một sự thoả thuận nhằm giải quyết cuộc xung đột hay tranh chấp giữa các bên: hai bên điều đình với nhau * cuộc điều đình",
    example: "hai bên điều đình với nhau * cuộc điều đình",
  },
  {
    word: "điều độ",
    part_of_speech: "động từ",
    meaning:
      "phân phối, điều hoà công việc cho đều đặn, nhịp nhàng: phòng điều độ sản xuất * trung tâm điều độ hệ thống điện",
    example: "phòng điều độ sản xuất * trung tâm điều độ hệ thống điện",
  },
  {
    word: "điều độ",
    part_of_speech: "tính từ",
    meaning:
      "có chừng mực và đều đặn trong các hoạt động: sống rất điều độ * ăn uống thất thường, không điều độ",
    example: "sống rất điều độ * ăn uống thất thường, không điều độ",
  },
  {
    word: "điếu đóm",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) mang điếu và châm đóm; chỉ những việc làm lặt vặt, không quan trọng gì, chỉ để phục vụ cho người khác (hàm ý mỉa mai): làm chân điếu đóm",
    example: "làm chân điếu đóm",
  },
  {
    word: "điều giải",
    part_of_speech: "động từ",
    meaning: "(cũ) như hoà giải: điều giải xích mích giữa hai nhà",
    example: "điều giải xích mích giữa hai nhà",
  },
  {
    word: "điệu đàng",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) có dáng vẻ trông rất điệu: ăn nói rất điệu đàng",
    example: "ăn nói rất điệu đàng",
  },
  {
    word: "điêu đứng",
    part_of_speech: "tính từ",
    meaning:
      "lâm vào cảnh long đong, vất vả do phải đối phó với nhiều khó khăn dồn dập: lâm vào cảnh điêu đứng * bị lũ lụt làm cho điêu đứng",
    example: "lâm vào cảnh điêu đứng * bị lũ lụt làm cho điêu đứng",
  },
  {
    word: "điều động",
    part_of_speech: "động từ",
    meaning:
      "(người, cấp có thẩm quyền) cử, đưa người hoặc phương tiện đến nơi nào đó nhằm đáp ứng yêu cầu của công việc: hành khách đông nên phải điều động thêm xe",
    example: "hành khách đông nên phải điều động thêm xe",
  },
  {
    word: "điều hoà nhiệt độ",
    part_of_speech: "động từ",
    meaning: "như điều hoà không khí: thiết bị điều hoà nhiệt độ",
    example: "thiết bị điều hoà nhiệt độ",
  },
  {
    word: "điều hoà nhiệt độ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) máy điều hoà nhiệt độ (nói tắt): căn phòng có lắp điều hoà nhiệt độ",
    example: "căn phòng có lắp điều hoà nhiệt độ",
  },
  {
    word: "điều hành",
    part_of_speech: "động từ",
    meaning:
      "hướng dẫn cho mọi hoạt động chung diễn ra theo một đường lối, chủ trương nhất định: điều hành công việc * giám đốc điều hành",
    example: "điều hành công việc * giám đốc điều hành",
  },
  {
    word: "điểu học",
    part_of_speech: "danh từ",
    meaning: "ngành khoa học nghiên cứu về các loài chim: nhà điểu học",
    example: "nhà điểu học",
  },
  {
    word: "điều khiển học",
    part_of_speech: "danh từ",
    meaning:
      "khoa học nghiên cứu những quy luật tổng quát của các quá trình thu nhận, lưu trữ, truyền dẫn, xử lí và sử dụng thông tin: khoa điều khiển học",
    example: "khoa điều khiển học",
  },
  {
    word: "điêu khắc",
    part_of_speech: "danh từ",
    meaning:
      "loại hình nghệ thuật thể hiện hoặc gợi tả sự vật trong không gian bằng cách sử dụng những chất liệu như đất, đá, gỗ, kim loại, v.v. để tạo thành những hình thù nhất định: nghệ thuật điêu khắc * tác phẩm điêu khắc trên gỗ",
    example: "nghệ thuật điêu khắc * tác phẩm điêu khắc trên gỗ",
  },
  {
    word: "điêu khắc gia",
    part_of_speech: "danh từ",
    meaning: "(trang trọng) nhà điêu khắc: một điêu khắc gia nổi tiếng",
    example: "một điêu khắc gia nổi tiếng",
  },
  {
    word: "điều khiển",
    part_of_speech: "động từ",
    meaning:
      "làm cho quá trình hoạt động diễn ra đúng quy luật, quy tắc: điều khiển cuộc họp * trọng tài chính điều khiển trận đấu",
    example: "điều khiển cuộc họp * trọng tài chính điều khiển trận đấu",
  },
  {
    word: "điều hoà",
    part_of_speech: "tính từ",
    meaning:
      "có chừng mực và đều đặn về mức độ, cường độ (nói về hiện tượng tự nhiên): mưa nắng điều hoà",
    example: "mưa nắng điều hoà",
  },
  {
    word: "điều hoà",
    part_of_speech: "động từ",
    meaning:
      "làm cho trở thành có chừng mực và đều đặn, không có tình trạng quá chênh lệch: khí huyết điều hoà * điều hoà nhiệt độ",
    example: "khí huyết điều hoà * điều hoà nhiệt độ",
  },
  {
    word: "điều hoà",
    part_of_speech: "động từ",
    meaning:
      "làm cho các mâu thuẫn dịu đi, không còn khả năng dẫn đến xung đột: điều hoà các mối quan hệ kinh tế",
    example: "điều hoà các mối quan hệ kinh tế",
  },
  {
    word: "điều hoà",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) (Bắc) (Nam máy lạnh) máy điều hoà nhiệt độ (nói tắt): phòng nghỉ không có (máy) điều hoà",
    example: "phòng nghỉ không có (máy) điều hoà",
  },
  {
    word: "điều hơn lẽ thiệt",
    part_of_speech: "",
    meaning:
      "điều phải trái, đúng sai, nên hay không nên (cần phân tích, cân nhắc): phân tích điều hơn lẽ thiệt",
    example: "phân tích điều hơn lẽ thiệt",
  },
  {
    word: "điều khoản",
    part_of_speech: "danh từ",
    meaning:
      "điểm, khoản trình bày trong văn bản có tính chất pháp luật để diễn đạt rõ ràng, cụ thể hơn nội dung được quy định (nói khái quát): thực hiện đúng các điều khoản ghi trong hợp đồng",
    example: "thực hiện đúng các điều khoản ghi trong hợp đồng",
  },
  {
    word: "điều kiện",
    part_of_speech: "danh từ",
    meaning:
      "cái cần phải có để cho một cái khác có thể có hoặc có thể xảy ra: tạo điều kiện cho con cái học hành * phản xạ có điều kiện",
    example: "tạo điều kiện cho con cái học hành * phản xạ có điều kiện",
  },
  {
    word: "điều kiện",
    part_of_speech: "danh từ",
    meaning:
      "điều nêu ra như một đòi hỏi trước khi thực hiện một việc nào đó: ra điều kiện * đồng ý với hai điều kiện",
    example: "ra điều kiện * đồng ý với hai điều kiện",
  },
  {
    word: "điều kiện",
    part_of_speech: "danh từ",
    meaning:
      "những gì có thể tác động đến tính chất, sự tồn tại hoặc sự xảy ra của một cái gì đó (nói tổng quát): điều kiện thời tiết * cải thiện điều kiện sống * gặp điều kiện thuận lợi",
    example:
      "điều kiện thời tiết * cải thiện điều kiện sống * gặp điều kiện thuận lợi",
  },
  {
    word: "điều kiện cần",
    part_of_speech: "danh từ",
    meaning:
      "điều kiện mà nếu nó không thoả mãn thì điều khẳng định đã cho chắc chắn là không đúng: đó là điều kiện cần nhưng chưa đủ",
    example: "đó là điều kiện cần nhưng chưa đủ",
  },
  {
    word: "điều kinh",
    part_of_speech: "động từ",
    meaning: "có tác dụng điều hoà kinh nguyệt: thuốc điều kinh",
    example: "thuốc điều kinh",
  },
  {
    word: "điều lệ",
    part_of_speech: "danh từ",
    meaning:
      "văn bản ghi những điều khoản quy định mục đích, nguyên tắc cơ bản về tổ chức và hoạt động của một đoàn thể, một tổ chức: điều lệ Đảng * điều lệ của doanh nghiệp",
    example: "điều lệ Đảng * điều lệ của doanh nghiệp",
  },
  {
    word: "điều lệ",
    part_of_speech: "danh từ",
    meaning:
      "văn bản quy định những nguyên tắc, nền nếp của một số mặt hoạt động, công tác: điều lệ về tuyển dụng lao động * điều lệ trong thi đấu thể thao",
    example: "điều lệ về tuyển dụng lao động * điều lệ trong thi đấu thể thao",
  },
  {
    word: "điêu linh",
    part_of_speech: "tính từ",
    meaning: "khổ sở cùng cực, đến mức xơ xác: tình cảnh điêu linh",
    example: "tình cảnh điêu linh",
  },
  {
    word: "điều lệnh",
    part_of_speech: "danh từ",
    meaning:
      "những điều quy định có tính chất pháp quy về phương pháp chiến đấu và về sinh hoạt của các quân nhân và các đơn vị quân đội (nói tổng quát): chấp hành nghiêm chỉnh điều lệnh",
    example: "chấp hành nghiêm chỉnh điều lệnh",
  },
  {
    word: "điều kiện đủ",
    part_of_speech: "danh từ",
    meaning:
      "điều kiện mà từ đó có thể suy ra điều khẳng định đã cho: điều kiện cần và điều kiện đủ",
    example: "điều kiện cần và điều kiện đủ",
  },
  {
    word: "điều luật",
    part_of_speech: "danh từ",
    meaning:
      "điều khoản trong một văn bản pháp luật: đánh dấu các điều luật có liên quan",
    example: "đánh dấu các điều luật có liên quan",
  },
  {
    word: "điệu này",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp dùng để biểu thị điều sắp nói là một nhận định rút ra từ tình hình thực tế (tình hình này thì..., theo cách này thì...): điệu này không khéo rồi lại mưa to",
    example: "điệu này không khéo rồi lại mưa to",
  },
  {
    word: "điêu luyện",
    part_of_speech: "tính từ",
    meaning:
      "đạt đến trình độ cao, do được trau dồi, luyện tập nhiều (thường nói về nghệ thuật, kĩ thuật): ngòi bút điêu luyện * nét chạm trổ công phu, điêu luyện",
    example: "ngòi bút điêu luyện * nét chạm trổ công phu, điêu luyện",
  },
  {
    word: "điều nghiên",
    part_of_speech: "động từ",
    meaning:
      "điều tra và nghiên cứu (nói gộp): điều nghiên các tình tiết phạm tội",
    example: "điều nghiên các tình tiết phạm tội",
  },
  {
    word: "điệu nghệ",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) giỏi, khéo, đạt đến trình độ điêu luyện: chơi đàn điệu nghệ * lái xe rất điệu nghệ",
    example: "chơi đàn điệu nghệ * lái xe rất điệu nghệ",
  },
  {
    word: "điều phối",
    part_of_speech: "động từ",
    meaning: "điều động và phân phối (nói gộp): điều phối sức lao động",
    example: "điều phối sức lao động",
  },
  {
    word: "điều phối",
    part_of_speech: "động từ",
    meaning:
      "theo dõi và điều khiển tác nghiệp nhằm bảo đảm phối hợp công việc của những khâu riêng lẻ của xí nghiệp và điều chỉnh quá trình sản xuất, nhịp điệu làm việc: điều phối bằng liên lạc điện thoại",
    example: "điều phối bằng liên lạc điện thoại",
  },
  {
    word: "điêu ngoa",
    part_of_speech: "tính từ",
    meaning: "hay nói những điều bịa đặt, dối trá: quen thói điêu ngoa",
    example: "quen thói điêu ngoa",
  },
  {
    word: "điều tiết",
    part_of_speech: "động từ",
    meaning:
      "làm cho công việc, kế hoạch, v.v. được hợp lí, không có tình trạng chênh lệch hoặc mất cân đối: điều tiết sản xuất * điều tiết thị trường",
    example: "điều tiết sản xuất * điều tiết thị trường",
  },
  {
    word: "điều tiếng",
    part_of_speech: "danh từ",
    meaning:
      "những lời bàn tán về những chuyện cho là không hay, không tốt của người nào đó: tránh điều tiếng * có điều tiếng về quan hệ nam nữ",
    example: "tránh điều tiếng * có điều tiếng về quan hệ nam nữ",
  },
  {
    word: "điêu tàn",
    part_of_speech: "tính từ",
    meaning: "xơ xác, tàn tạ: túp nhà lá điêu tàn, xiêu vẹo",
    example: "túp nhà lá điêu tàn, xiêu vẹo",
  },
  {
    word: "điều phối viên",
    part_of_speech: "danh từ",
    meaning: "người phụ trách việc điều phối: điều phối viên Liên Hợp Quốc",
    example: "điều phối viên Liên Hợp Quốc",
  },
  {
    word: "điêu toa",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như điêu ngoa: thói điêu toa",
    example: "thói điêu toa",
  },
  {
    word: "điều tra",
    part_of_speech: "động từ",
    meaning:
      "tìm hiểu, xem xét để biết rõ sự thật: điều tra dân số * điều tra nguyên nhân vụ hoả hoạn",
    example: "điều tra dân số * điều tra nguyên nhân vụ hoả hoạn",
  },
  {
    word: "điều tốc",
    part_of_speech: "động từ",
    meaning: "(thiết bị) điều chỉnh tốc độ theo ý muốn: bộ điều tốc theo cự li",
    example: "bộ điều tốc theo cự li",
  },
  {
    word: "điều trần",
    part_of_speech: "",
    meaning:
      "(cũ) trình lên vua, lên người đứng đầu nhà nước, bản hiến kế hay bản ý kiến về các vấn đề thuộc quốc kế dân sinh.",
    example: "tổng thống điều trần trước quốc hội",
  },
  {
    word: "điêu trác",
    part_of_speech: "tính từ",
    meaning: "(hiếm) dối trá một cách khôn khéo: quen thói điêu trác",
    example: "quen thói điêu trác",
  },
  {
    word: "điều trị",
    part_of_speech: "động từ",
    meaning:
      "chữa bệnh tật, vết thương nói chung: điều trị bệnh bằng thuốc Nam",
    example: "điều trị bệnh bằng thuốc Nam",
  },
  {
    word: "đinh",
    part_of_speech: "danh từ",
    meaning:
      "(Từ cũ) người đàn ông thuộc lứa tuổi phải đóng thuế thân và đi lính thời phong kiến: làng có ba trăm đinh * đóng thuế đinh",
    example: "làng có ba trăm đinh * đóng thuế đinh",
  },
  {
    word: "đinh",
    part_of_speech: "danh từ",
    meaning: "đầu đinh (nói tắt): bị lên đinh",
    example: "bị lên đinh",
  },
  {
    word: "đinh",
    part_of_speech: "danh từ",
    meaning:
      "vật bằng kim loại (hay tre, gỗ) cứng, một đầu nhọn, dùng để đóng, treo, giữ vật này vào vật khác, hoặc ghép các vật với nhau: đinh đóng guốc * giày đinh * chắc như đinh đóng cột",
    example: "đinh đóng guốc * giày đinh * chắc như đinh đóng cột",
  },
  {
    word: "đinh",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) cái được coi là chính yếu, chủ chốt: tiết mục đinh trong chương trình * bài đinh của số báo",
    example: "tiết mục đinh trong chương trình * bài đinh của số báo",
  },
  {
    word: "điều vận",
    part_of_speech: "động từ",
    meaning:
      "điều động và phân phối, sắp xếp hợp lí công việc vận chuyển: điều vận hàng hoá * phòng điều vận",
    example: "điều vận hàng hoá * phòng điều vận",
  },
  {
    word: "đính",
    part_of_speech: "động từ",
    meaning:
      "làm cho một vật nhỏ dính liền vào vật khác bằng cách khâu chỉ hoặc cài kim: đính khuy * đính huân chương trên áo * đính hoa vào mũ",
    example: "đính khuy * đính huân chương trên áo * đính hoa vào mũ",
  },
  {
    word: "đình",
    part_of_speech: "danh từ",
    meaning:
      'nhà công cộng của làng thời trước, được xây dựng để làm nơi thờ thành hoàng và họp việc làng: "Qua đình ngả nón trông đình, Đình bao nhiêu ngói thương mình bấy nhiêu." (ca dao)',
    example:
      'Qua đình ngả nón trông đình, Đình bao nhiêu ngói thương mình bấy nhiêu." (ca dao)',
  },
  {
    word: "đình",
    part_of_speech: "danh từ",
    meaning: "phần ở phía trên trần của màn: mắt nhìn lên đình màn",
    example: "mắt nhìn lên đình màn",
  },
  {
    word: "đình",
    part_of_speech: "động từ",
    meaning: "ngừng lại hoặc làm cho phải ngừng lại: tạm đình việc thi công",
    example: "tạm đình việc thi công",
  },
  {
    word: "định",
    part_of_speech: "động từ",
    meaning:
      "tự đặt ra cho mình việc gì đó sẽ làm trong thời gian sắp tới: định mai sẽ làm * mấy lần định nói nhưng lại thôi",
    example: "định mai sẽ làm * mấy lần định nói nhưng lại thôi",
  },
  {
    word: "định",
    part_of_speech: "động từ",
    meaning:
      "đưa ra một cách chính xác, rõ ràng, sau khi đã có suy nghĩ, tìm hiểu, cân nhắc: định ngày họp * định mức thuế",
    example: "định ngày họp * định mức thuế",
  },
  {
    word: "đĩnh",
    part_of_speech: "danh từ",
    meaning: "(cũ) thoi vàng hoặc bạc, ngày xưa dùng làm tiền tệ: một đĩnh bạc",
    example: "một đĩnh bạc",
  },
  {
    word: "định bụng",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) có ý định làm việc gì: định bụng đến thăm bạn",
    example: "định bụng đến thăm bạn",
  },
  {
    word: "đỉnh",
    part_of_speech: "danh từ",
    meaning:
      "phần trên cùng, cao nhất của một vật thẳng đứng: đỉnh đồi * đỉnh núi",
    example: "đỉnh đồi * đỉnh núi",
  },
  {
    word: "đỉnh",
    part_of_speech: "danh từ",
    meaning:
      "điểm chung của hai hay nhiều cạnh trong một hình: hạ đường cao từ đỉnh A của tam giác * đỉnh của một đa diện",
    example: "hạ đường cao từ đỉnh A của tam giác * đỉnh của một đa diện",
  },
  {
    word: "đỉnh",
    part_of_speech: "danh từ",
    meaning: "điểm chung của các đường sinh trong hình nón.",
    example: "đỉnh của parabol",
  },
  {
    word: "đình bản",
    part_of_speech: "động từ",
    meaning:
      "(xuất bản phẩm) không được in và phát hành nữa: tờ báo đã bị đình bản",
    example: "tờ báo đã bị đình bản",
  },
  {
    word: "đỉnh cao",
    part_of_speech: "",
    meaning:
      "vị trí, mức độ cao nhất trong quá trình phát triển: thể thao đỉnh cao * vươn tới đỉnh cao nghệ thuật",
    example: "thể thao đỉnh cao * vươn tới đỉnh cao nghệ thuật",
  },
  {
    word: "định chế",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ quy định có tính chất pháp lí đối với một vấn đề nhất định: định chế tài chính * hình thành các định chế về tín dụng",
    example: "định chế tài chính * hình thành các định chế về tín dụng",
  },
  {
    word: "đình chỉ",
    part_of_speech: "động từ",
    meaning:
      "ngừng lại hoặc làm cho phải ngừng lại trong một thời gian hay vĩnh viễn: bị đình chỉ thi * đình chỉ công tác",
    example: "bị đình chỉ thi * đình chỉ công tác",
  },
  {
    word: "định chuẩn",
    part_of_speech: "danh từ",
    meaning:
      "điều được quy định thành chuẩn để những đối tượng nhất định theo đó mà thực hiện, tuân theo: định chuẩn tài chính",
    example: "định chuẩn tài chính",
  },
  {
    word: "đính chính",
    part_of_speech: "động từ",
    meaning:
      "sửa lại cho đúng những chỗ in, viết, nói sai: đính chính những chỗ in sai",
    example: "đính chính những chỗ in sai",
  },
  {
    word: "định dạng",
    part_of_speech: "",
    meaning:
      "thiết lập hình mẫu cho việc hiển thị, lưu giữ hoặc in ra các dữ liệu trong máy tính: định dạng lại ổ cứng * thay đổi định dạng của văn bản",
    example: "định dạng lại ổ cứng * thay đổi định dạng của văn bản",
  },
  {
    word: "đình chiến",
    part_of_speech: "động từ",
    meaning:
      "ngừng các hoạt động quân sự theo thoả thuận của các bên tham chiến: hiệp định đình chiến * ra lệnh đình chiến",
    example: "hiệp định đình chiến * ra lệnh đình chiến",
  },
  {
    word: "đình công",
    part_of_speech: "động từ",
    meaning:
      "cùng nhau nghỉ việc (một hình thức đấu tranh nêu yêu sách hoặc kháng nghị của giới công nhân, viên chức): đình công đòi tăng lương, giảm giờ làm",
    example: "đình công đòi tăng lương, giảm giờ làm",
  },
  {
    word: "đỉnh chung",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) vạc đồng và chuông đồng, trước đây vua dùng ghi công cho bề tôi; chỉ sự vinh hoa phú quý: "Trăng mờ có lúc lại trong, Em đây vất vả đỉnh chung có ngày." (ca dao)',
    example:
      'Trăng mờ có lúc lại trong, Em đây vất vả đỉnh chung có ngày." (ca dao)',
  },
  {
    word: "đĩnh đạc",
    part_of_speech: "tính từ",
    meaning:
      "đàng hoàng và đầy vẻ tự tin: đi đứng đĩnh đạc * tác phong đĩnh đạc",
    example: "đi đứng đĩnh đạc * tác phong đĩnh đạc",
  },
  {
    word: "định đoạt",
    part_of_speech: "động từ",
    meaning:
      "quyết định dứt khoát (việc, vấn đề quan trọng), dựa vào quyền hành tuyệt đối của mình: tự định đoạt lấy cuộc sống của mình",
    example: "tự định đoạt lấy cuộc sống của mình",
  },
  {
    word: "định đô",
    part_of_speech: "động từ",
    meaning: "đặt kinh đô tại một nơi nào đó: Lý Thái Tổ định đô ở Thăng Long",
    example: "Lý Thái Tổ định đô ở Thăng Long",
  },
  {
    word: "định đề",
    part_of_speech: "danh từ",
    meaning:
      "mệnh đề được thừa nhận mà không chứng minh, xem như là xuất phát điểm để xây dựng một lí thuyết toán học nào đó: tiên đề Euclide",
    example: "tiên đề Euclide",
  },
  {
    word: "đình đám",
    part_of_speech: "danh từ",
    meaning:
      "hội hè ở nông thôn (nói khái quát; thường hàm ý chê): hội hè đình đám liên miên",
    example: "hội hè đình đám liên miên",
  },
  {
    word: "định cư",
    part_of_speech: "động từ",
    meaning:
      "sống cố định và lâu dài ở một nơi; phân biệt với du cư: sống định cư * đưa gia đình lên định cư ở vùng kinh tế mới",
    example: "sống định cư * đưa gia đình lên định cư ở vùng kinh tế mới",
  },
  {
    word: "đỉnh điểm",
    part_of_speech: "danh từ",
    meaning:
      "điểm cao nhất của một trạng thái, một quá trình diễn biến: mâu thuẫn đã lên đến đỉnh điểm",
    example: "mâu thuẫn đã lên đến đỉnh điểm",
  },
  {
    word: "đình đốn",
    part_of_speech: "động từ",
    meaning:
      "phát triển chậm hẳn lại, thậm chí ngừng không phát triển nữa, do gặp khó khăn (thường nói về các hoạt động kinh tế): sản xuất bị đình đốn",
    example: "sản xuất bị đình đốn",
  },
  {
    word: "định hình",
    part_of_speech: "động từ",
    meaning:
      "trở nên có một hình thái ổn định: thai nhi đã định hình * cơ chế thị trường đã được định hình",
    example: "thai nhi đã định hình * cơ chế thị trường đã được định hình",
  },
  {
    word: "định hình",
    part_of_speech: "động từ",
    meaning:
      "làm cho ảnh đã hiện được bền vững khi đưa ra ánh sáng, bằng các tác dụng hoá học: thuốc định hình",
    example: "thuốc định hình",
  },
  {
    word: "định hướng",
    part_of_speech: "động từ",
    meaning:
      "xác định phương hướng: nhìn xung quanh để định hướng * định hướng nghề nghiệp",
    example: "nhìn xung quanh để định hướng * định hướng nghề nghiệp",
  },
  {
    word: "đính hôn",
    part_of_speech: "động từ",
    meaning: "giao ước sẽ lấy nhau làm vợ chồng: tổ chức lễ đính hôn",
    example: "tổ chức lễ đính hôn",
  },
  {
    word: "định kì",
    part_of_speech: "danh từ",
    meaning:
      "từng khoảng thời gian nhất định sau đó một việc lại xảy ra: báo ra theo định kì * đóng tiền theo định kì",
    example: "báo ra theo định kì * đóng tiền theo định kì",
  },
  {
    word: "định kì",
    part_of_speech: "tính từ",
    meaning: "theo định kì: kiểm tra sức khoẻ định kì * phiên họp định kì",
    example: "kiểm tra sức khoẻ định kì * phiên họp định kì",
  },
  {
    word: "định kỳ",
    part_of_speech: "danh từ",
    meaning:
      "từng khoảng thời gian nhất định sau đó một việc lại xảy ra: báo ra theo định kì * đóng tiền theo định kì",
    example: "báo ra theo định kì * đóng tiền theo định kì",
  },
  {
    word: "định kỳ",
    part_of_speech: "tính từ",
    meaning: "theo định kì: kiểm tra sức khoẻ định kì * phiên họp định kì",
    example: "kiểm tra sức khoẻ định kì * phiên họp định kì",
  },
  {
    word: "định kiến",
    part_of_speech: "",
    meaning:
      "ý nghĩ riêng đã có sẵn, thường là không hay, khó có thể thay đổi được: hai người có định kiến với nhau",
    example: "hai người có định kiến với nhau",
  },
  {
    word: "đình liệu",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) đuốc lớn thắp ở sân để cho sáng, thời trước thường dùng khi có hội họp hoặc làm việc ở ngoài trời: cây đình liệu * đèn đuốc rừng rực như đình liệu",
    example: "cây đình liệu * đèn đuốc rừng rực như đình liệu",
  },
  {
    word: "định liệu",
    part_of_speech: "động từ",
    meaning:
      "nghĩ trước, tính toán, sắp xếp trước cách giải quyết công việc: định liệu công việc",
    example: "định liệu công việc",
  },
  {
    word: "định lượng",
    part_of_speech: "động từ",
    meaning:
      "xác định về mặt số lượng hoặc biến đổi số lượng; phân biệt với định tính: kiểm tra định lượng * định lượng về giá trị tài sản",
    example: "kiểm tra định lượng * định lượng về giá trị tài sản",
  },
  {
    word: "định lượng",
    part_of_speech: "danh từ",
    meaning: "lượng đã quy định: phân phối theo định lượng",
    example: "phân phối theo định lượng",
  },
  {
    word: "định luật",
    part_of_speech: "danh từ",
    meaning:
      "quy luật khách quan được khoa học nhận thức và nêu ra: định luật vạn vật hấp dẫn",
    example: "định luật vạn vật hấp dẫn",
  },
  {
    word: "định mức",
    part_of_speech: "danh từ",
    meaning:
      "mức quy định về lao động, thời gian, vật liệu, v.v. để hoàn thành một công việc hay một lượng sản phẩm: nâng cao định mức lao động * hoàn thành vượt định mức",
    example: "nâng cao định mức lao động * hoàn thành vượt định mức",
  },
  {
    word: "định mệnh",
    part_of_speech: "danh từ",
    meaning:
      "số mệnh của con người, do một lực lượng huyền bí định sẵn, không thể cưỡng lại được, theo quan niệm duy tâm: cưỡng lại định mệnh",
    example: "cưỡng lại định mệnh",
  },
  {
    word: "định ngữ",
    part_of_speech: "danh từ",
    meaning:
      "thành phần phụ trong câu, phụ thuộc về ngữ pháp vào danh từ và có chức năng nêu thuộc tính, đặc trưng của sự vật, hiện tượng, v.v.:  trong  * ,  *  trong  *  đều là định ngữ",
    example: "trong  * ,  *  trong  *  đều là định ngữ",
  },
  {
    word: "định nghĩa",
    part_of_speech: "động từ",
    meaning:
      "dùng từ ngữ làm rõ nghĩa của từ hoặc nội dung của khái niệm: định nghĩa một cách chính xác",
    example: "định nghĩa một cách chính xác",
  },
  {
    word: "đinh ốc",
    part_of_speech: "danh từ",
    meaning:
      "đinh bằng kim loại, một đầu có mũ, đầu kia có ren khớp với ren đai ốc, dùng để cố định các phần tử của máy, của kết cấu: vặn đinh ốc",
    example: "vặn đinh ốc",
  },
  {
    word: "đinh ninh",
    part_of_speech: "động từ",
    meaning:
      '(cũ) nói đi nói lại, dặn đi dặn lại cặn kẽ để cho nhớ kĩ: "Vầng trăng vằng vặc giữa trời, Đinh ninh hai miệng một lời song song." (TKiều)',
    example:
      'Vầng trăng vằng vặc giữa trời, Đinh ninh hai miệng một lời song song." (TKiều)',
  },
  {
    word: "đinh ninh",
    part_of_speech: "động từ",
    meaning:
      "tin chắc hoàn toàn là việc nào đó đã hoặc sắp xảy ra: đinh ninh là sẽ thắng, ai ngờ * cứ đinh ninh là mình đúng",
    example: "đinh ninh là sẽ thắng, ai ngờ * cứ đinh ninh là mình đúng",
  },
  {
    word: "đinh ninh",
    part_of_speech: "tính từ",
    meaning:
      '(cũ, hoặc vch) trước sau vẫn như vậy, không thay đổi: "Trăm năm dạ ở đinh ninh, Nào ai phụ ngãi quên tình mặc ai." (ca dao)',
    example:
      'Trăm năm dạ ở đinh ninh, Nào ai phụ ngãi quên tình mặc ai." (ca dao)',
  },
  {
    word: "đinh tai",
    part_of_speech: "tính từ",
    meaning:
      "có cảm giác thính giác bị rối loạn, do tác động của âm thanh có cường độ quá mạnh: tiếng nổ đinh tai nhức óc",
    example: "tiếng nổ đinh tai nhức óc",
  },
  {
    word: "định tâm",
    part_of_speech: "động từ",
    meaning: "có ý định (trong lòng): định tâm đến giúp",
    example: "định tâm đến giúp",
  },
  {
    word: "định tâm",
    part_of_speech: "động từ",
    meaning:
      "(Ít dùng) làm cho tâm thần được trở về trạng thái yên ổn bình thường, không còn xúc động mạnh nữa: choáng váng nhưng định tâm được ngay",
    example: "choáng váng nhưng định tâm được ngay",
  },
  {
    word: "định thần",
    part_of_speech: "động từ",
    meaning:
      "làm cho tinh thần trở lại trạng thái thăng bằng bình thường: định thần nhìn kĩ lại * hoảng hốt nhưng định thần được ngay",
    example: "định thần nhìn kĩ lại * hoảng hốt nhưng định thần được ngay",
  },
  {
    word: "định thần",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) làm cho tâm thần ở trạng thái hoàn toàn bình lặng, không gợn một chút cảm xúc nào: ngồi định thần như pho tượng",
    example: "ngồi định thần như pho tượng",
  },
  {
    word: "định tội",
    part_of_speech: "động từ",
    meaning: "xác định tội danh đã vi phạm: điều tra kĩ mới định tội",
    example: "điều tra kĩ mới định tội",
  },
  {
    word: "đình trệ",
    part_of_speech: "động từ",
    meaning:
      "lâm vào tình trạng phát triển chậm hẳn lại, không tiến lên được trong suốt một thời gian dài: công việc bị đình trệ",
    example: "công việc bị đình trệ",
  },
  {
    word: "đình trung",
    part_of_speech: "danh từ",
    meaning: "nơi họp việc làng ở đình thời trước: chốn đình trung",
    example: "chốn đình trung",
  },
  {
    word: "đính ước",
    part_of_speech: "động từ",
    meaning: "ước hẹn với nhau: đính ước sẽ gặp nhau vào thượng tuần tháng sau",
    example: "đính ước sẽ gặp nhau vào thượng tuần tháng sau",
  },
  {
    word: "đính ước",
    part_of_speech: "động từ",
    meaning:
      "hứa hẹn với nhau sẽ lấy nhau làm vợ chồng: đôi trai gái đã đính ước với nhau * giữ trọn lời đính ước",
    example: "đôi trai gái đã đính ước với nhau * giữ trọn lời đính ước",
  },
  {
    word: "định xứ",
    part_of_speech: "tính từ",
    meaning:
      "chỉ có trong một số khu vực nhất định: năng lượng định xứ * vùng định xứ",
    example: "năng lượng định xứ * vùng định xứ",
  },
  {
    word: "đíp lôm",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) (tốt nghiệp) cao đẳng tiểu học, thời thuộc Pháp: tốt nghiệp thành chung",
    example: "tốt nghiệp thành chung",
  },
  {
    word: "định vị",
    part_of_speech: "động từ",
    meaning:
      "xác định vị trí tồn tại của một vật thể theo những dấu hiệu xuất phát hay phản xạ từ bản thân nó: máy định vị * nhìn xung quanh để định vị",
    example: "máy định vị * nhìn xung quanh để định vị",
  },
  {
    word: "định vị",
    part_of_speech: "động từ",
    meaning:
      "xác định một vị trí trong bộ nhớ, trong tệp văn bản hoặc trên màn hình máy tính: bảng định vị tập tin * tìm kiếm và định vị các tập tin lưu trên đĩa",
    example:
      "bảng định vị tập tin * tìm kiếm và định vị các tập tin lưu trên đĩa",
  },
  {
    word: "định tính",
    part_of_speech: "động từ",
    meaning:
      "xác định về mặt tính chất hoặc biến đổi tính chất; phân biệt với định lượng: phân tích định tính * khác nhau hoàn toàn về mặt định tính",
    example: "phân tích định tính * khác nhau hoàn toàn về mặt định tính",
  },
  {
    word: "đít",
    part_of_speech: "danh từ",
    meaning:
      "phần ở dưới cùng và đằng sau thân người hoặc động vật, nơi có cửa ruột già thông ra ngoài để thải phân: đặt đít ngồi * hai tay chắp sau đít",
    example: "đặt đít ngồi * hai tay chắp sau đít",
  },
  {
    word: "đít",
    part_of_speech: "danh từ",
    meaning:
      "phần dưới cùng hoặc sau cùng ở mặt ngoài của một số vật: đít chai * đít nồi",
    example: "đít chai * đít nồi",
  },
  {
    word: "đìu hiu",
    part_of_speech: "tính từ",
    meaning:
      'vắng vẻ và buồn bã: phố xá đìu hiu * "Nào thơ nào rượu dập dìu, Trông trăng tựa gió đìu hiu một mình." (TTK)',
    example:
      'phố xá đìu hiu * "Nào thơ nào rượu dập dìu, Trông trăng tựa gió đìu hiu một mình." (TTK)',
  },
  {
    word: "đìu ríu",
    part_of_speech: "động từ",
    meaning:
      "dắt díu nhau đi thành đoàn, trông nhếch nhác, khổ sở: mẹ con đìu ríu nhau đi",
    example: "mẹ con đìu ríu nhau đi",
  },
  {
    word: "đõ",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng để nuôi ong, thường làm bằng một đoạn thân cây rỗng, bịt kín hai đầu, ở giữa có khoét lỗ để ong ra vào làm tổ: đõ ong mật",
    example: "đõ ong mật",
  },
  {
    word: "đò",
    part_of_speech: "danh từ",
    meaning:
      "thuyền nhỏ chở khách trên sông nước theo những tuyến nhất định: chèo đò * qua sông phải luỵ đò (tng)",
    example: "chèo đò * qua sông phải luỵ đò (tng)",
  },
  {
    word: "đọ",
    part_of_speech: "động từ",
    meaning:
      "đặt ở thế trực tiếp đối lập với nhau, để rõ hơn kém, được thua: đọ tài * đọ sức",
    example: "đọ tài * đọ sức",
  },
  {
    word: "địu",
    part_of_speech: "động từ",
    meaning: "mang bằng cái địu: địu con lên rẫy",
    example: "địu con lên rẫy",
  },
  {
    word: "đỏ",
    part_of_speech: "tính từ",
    meaning:
      "có màu như màu của son, của máu: khăn quàng đỏ * cờ đỏ sao vàng * mặt đỏ như gấc",
    example: "khăn quàng đỏ * cờ đỏ sao vàng * mặt đỏ như gấc",
  },
  {
    word: "đỏ",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái hoặc làm cho ở trạng thái cháy (nói về lửa): đèn đã đỏ * lửa đã đỏ lại bỏ thêm rơm (tng)",
    example: "đèn đã đỏ * lửa đã đỏ lại bỏ thêm rơm (tng)",
  },
  {
    word: "đỏ",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về cách mạng vô sản, có tư tưởng vô sản (do coi màu đỏ là biểu tượng của cách mạng vô sản): đội tự vệ đỏ",
    example: "đội tự vệ đỏ",
  },
  {
    word: "đỏ",
    part_of_speech: "tính từ",
    meaning: "có được sự may mắn ngẫu nhiên nào đó: số đỏ * vận đỏ đã đến",
    example: "số đỏ * vận đỏ đã đến",
  },
  {
    word: "đo",
    part_of_speech: "động từ",
    meaning:
      "xác định độ lớn của một đại lượng bằng cách so sánh với một đại lượng cùng loại được chọn làm đơn vị: đo chiều dài * diện tích được đo bằng mét vuông * đo nhiệt độ",
    example: "đo chiều dài * diện tích được đo bằng mét vuông * đo nhiệt độ",
  },
  {
    word: "đo",
    part_of_speech: "động từ",
    meaning:
      'xác định độ lớn của một đại lượng, một vật bằng các dụng cụ đo chính xác: đo đất để chia * đo xem ai cao hơn * "Dò sông dò biển dễ dò, Nào ai lấy thước mà đo lòng người." (Cdao)',
    example:
      'đo đất để chia * đo xem ai cao hơn * "Dò sông dò biển dễ dò, Nào ai lấy thước mà đo lòng người." (Cdao)',
  },
  {
    word: "đo",
    part_of_speech: "động từ",
    meaning:
      "đo để lấy một lượng nhất định của vật tính theo chiều dài: đo 2 mét vải bán cho khách",
    example: "đo 2 mét vải bán cho khách",
  },
  {
    word: "đỏ au",
    part_of_speech: "tính từ",
    meaning:
      "đỏ tươi, trông thích mắt: mái ngói đỏ au * da dẻ đỏ au, khoẻ mạnh",
    example: "mái ngói đỏ au * da dẻ đỏ au, khoẻ mạnh",
  },
  {
    word: "đỏ chói",
    part_of_speech: "tính từ",
    meaning:
      "đỏ tươi quá, đến mức như làm chói mắt: mặt trời đỏ chói * mái ngói còn đỏ chói màu son",
    example: "mặt trời đỏ chói * mái ngói còn đỏ chói màu son",
  },
  {
    word: "đỏ bừng",
    part_of_speech: "tính từ",
    meaning:
      "(da mặt) đỏ lên nhanh trong chốc lát, thường có cảm giác nóng rực do ngượng, thẹn, hoặc do ngồi gần lửa: xấu hổ, hai má đỏ bừng * mặt đỏ bừng",
    example: "xấu hổ, hai má đỏ bừng * mặt đỏ bừng",
  },
  {
    word: "đỏ con mắt",
    part_of_speech: "",
    meaning:
      "tả trạng thái phải mong ngóng, chờ đợi quá lâu, đến mức đỏ cả mắt: mong đỏ con mắt",
    example: "mong đỏ con mắt",
  },
  {
    word: "đỏ chon chót",
    part_of_speech: "tính từ",
    meaning: "như đỏ chót (nhưng ý mức độ cao hơn): môi son đỏ chon chót",
    example: "môi son đỏ chon chót",
  },
  {
    word: "đỏ cạch",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như đỏ quạch: mái tóc đỏ cạch",
    example: "mái tóc đỏ cạch",
  },
  {
    word: "đỏ choé",
    part_of_speech: "tính từ",
    meaning:
      "đỏ tươi, trông loá mắt, thường là không đẹp: mặc một cái áo đỏ choé * cổng sơn đỏ choé",
    example: "mặc một cái áo đỏ choé * cổng sơn đỏ choé",
  },
  {
    word: "đỏ chót",
    part_of_speech: "tính từ",
    meaning:
      "đỏ đến mức không thể hơn được nữa, nhìn thường không thích mắt: môi tô son đỏ chót",
    example: "môi tô son đỏ chót",
  },
  {
    word: "đo đắn",
    part_of_speech: "động từ",
    meaning:
      '(hiếm) như đắn đo: "Ai ơi, trẻ mãi ru mà!, Càng đo đắn lắm càng già mất duyên." (ca dao)',
    example:
      'Ai ơi, trẻ mãi ru mà!, Càng đo đắn lắm càng già mất duyên." (ca dao)',
  },
  {
    word: "đó đây",
    part_of_speech: "đại từ",
    meaning:
      "nơi này đến nơi khác; mọi nơi, khắp nơi: đi khắp đó đây * tin tức đó đây * tiếng tăm lừng lẫy đó đây",
    example: "đi khắp đó đây * tin tức đó đây * tiếng tăm lừng lẫy đó đây",
  },
  {
    word: "đỏ đen",
    part_of_speech: "",
    meaning:
      "may và rủi; thường dùng để chỉ cờ bạc: nướng tiền vào cuộc đỏ đen * ham mê đỏ đen",
    example: "nướng tiền vào cuộc đỏ đen * ham mê đỏ đen",
  },
  {
    word: "đỏ đuôi",
    part_of_speech: "tính từ",
    meaning:
      "(bông lúa) bắt đầu chín, bắt đầu có những hạt vàng ở đầu bông: lúa đã đỏ đuôi",
    example: "lúa đã đỏ đuôi",
  },
  {
    word: "đỏ đèn",
    part_of_speech: "động từ",
    meaning: "thắp đèn, lên đèn (khi trời vừa tối): làng xóm đã đỏ đèn",
    example: "làng xóm đã đỏ đèn",
  },
  {
    word: "đỏ đèn",
    part_of_speech: "danh từ",
    meaning: "lúc chập tối: đi từ mờ sớm đến đỏ đèn mới về",
    example: "đi từ mờ sớm đến đỏ đèn mới về",
  },
  {
    word: "đo đếm",
    part_of_speech: "động từ",
    meaning:
      "xác định xem số lượng là bao nhiêu (nói khái quát): đo đếm thời gian * tình yêu không thể đo đếm",
    example: "đo đếm thời gian * tình yêu không thể đo đếm",
  },
  {
    word: "đỏ đắn",
    part_of_speech: "tính từ",
    meaning: "(da dẻ) hồng hào: nước da đỏ đắn",
    example: "nước da đỏ đắn",
  },
  {
    word: "đỏ đọc",
    part_of_speech: "tính từ",
    meaning:
      "đỏ đến mức độ cao, với vẻ như pha sắc máu, gây cảm giác ghê sợ: đôi mắt đỏ đọc vì thiếu ngủ",
    example: "đôi mắt đỏ đọc vì thiếu ngủ",
  },
  {
    word: "đo đạc",
    part_of_speech: "động từ",
    meaning: "đo và tính toán (nói khái quát): đo đạc ruộng đất",
    example: "đo đạc ruộng đất",
  },
  {
    word: "đò giang",
    part_of_speech: "danh từ",
    meaning:
      'phương tiện đi lại trên sông nước nói chung: "Ước gì quan đắp đường liền, Để ta đi lại khỏi phiền đò giang." (Cdao)',
    example:
      'Ước gì quan đắp đường liền, Để ta đi lại khỏi phiền đò giang." (Cdao)',
  },
  {
    word: "đỏ hoe",
    part_of_speech: "tính từ",
    meaning:
      'có màu đỏ nhạt, nhưng tươi: mắt đỏ hoe * "Ngày đi lúa chửa chia vè, Ngày về lúa đã đỏ hoe đầy đồng." (ca dao)',
    example:
      'mắt đỏ hoe * "Ngày đi lúa chửa chia vè, Ngày về lúa đã đỏ hoe đầy đồng." (ca dao)',
  },
  {
    word: "đỏ hoen hoét",
    part_of_speech: "tính từ",
    meaning: "như đỏ hoét (nhưng ý nhấn mạnh hơn): sơn đỏ hoen hoét",
    example: "sơn đỏ hoen hoét",
  },
  {
    word: "đỏ hoét",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ, hiếm) đỏ đậm, nhưng xấu, khó coi: mặc một cái áo màu đỏ hoét",
    example: "mặc một cái áo màu đỏ hoét",
  },
  {
    word: "đỏ gay",
    part_of_speech: "tính từ",
    meaning:
      "đỏ khắp mặt mũi, do uống rượu, nóng nực hoặc do tức giận điều gì: mặt đỏ gay vì rượu",
    example: "mặt đỏ gay vì rượu",
  },
  {
    word: "đỏ hỏn",
    part_of_speech: "tính từ",
    meaning: "đỏ như màu da của trẻ mới đẻ: đứa bé mới đẻ đỏ hỏn",
    example: "đứa bé mới đẻ đỏ hỏn",
  },
  {
    word: "đỏ kè",
    part_of_speech: "tính từ",
    meaning: "đỏ đục và tối, gây cảm giác không ưa nhìn: mắt đỏ kè",
    example: "mắt đỏ kè",
  },
  {
    word: "đỏ khè",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) đỏ sẫm và tối, nhìn không thích mắt: mái tóc xơ xác, đỏ khè * đất đồi đỏ khè",
    example: "mái tóc xơ xác, đỏ khè * đất đồi đỏ khè",
  },
  {
    word: "đỏ loét",
    part_of_speech: "tính từ",
    meaning:
      "đỏ quá đậm và loang lổ không đều, trông không đẹp mắt: môi ăn trầu đỏ loét",
    example: "môi ăn trầu đỏ loét",
  },
  {
    word: "đỏ lòm",
    part_of_speech: "tính từ",
    meaning:
      "đỏ màu của máu, gây cảm giác ghê sợ hoặc khó chịu: bàn tay đỏ lòm những máu",
    example: "bàn tay đỏ lòm những máu",
  },
  {
    word: "đỏ lửa",
    part_of_speech: "động từ",
    meaning: "nhóm lửa nấu cơm: bếp không đỏ lửa * ngày đỏ lửa ba lần",
    example: "bếp không đỏ lửa * ngày đỏ lửa ba lần",
  },
  {
    word: "đỏ ngầu",
    part_of_speech: "tính từ",
    meaning: "đỏ sẫm và đục: phù sa đỏ ngầu * mắt đỏ ngầu",
    example: "phù sa đỏ ngầu * mắt đỏ ngầu",
  },
  {
    word: "đỏ lừ",
    part_of_speech: "tính từ",
    meaning: "đỏ sẫm và đều khắp: hoàng hôn, mặt trời đỏ lừ",
    example: "hoàng hôn, mặt trời đỏ lừ",
  },
  {
    word: "đo lường",
    part_of_speech: "động từ",
    meaning: "đo (nói khái quát): dụng cụ đo lường * đơn vị đo lường",
    example: "dụng cụ đo lường * đơn vị đo lường",
  },
  {
    word: "đỏ mặt tía tai",
    part_of_speech: "",
    meaning: "đỏ mặt lên vì tức giận hoặc hổ thẹn: tức đến đỏ mặt tía tai",
    example: "tức đến đỏ mặt tía tai",
  },
  {
    word: "đỏ lựng",
    part_of_speech: "tính từ",
    meaning: "đỏ đậm và đều khắp, trông đẹp mắt: quả hồng chín đỏ lựng",
    example: "quả hồng chín đỏ lựng",
  },
  {
    word: "đỏ ối",
    part_of_speech: "tính từ",
    meaning:
      "đỏ đều và khắp cả (thường nói về hoa quả nở rộ, chín rộ): cam chín đỏ ối cả vườn * vừng đông đỏ ối",
    example: "cam chín đỏ ối cả vườn * vừng đông đỏ ối",
  },
  {
    word: "đỏ nhừ",
    part_of_speech: "tính từ",
    meaning:
      "(mặt, tai) đỏ lên khắp, thường vì xấu hổ, ngượng nghịu: đi nắng, mặt đỏ nhừ như quả gấc chín",
    example: "đi nắng, mặt đỏ nhừ như quả gấc chín",
  },
  {
    word: "đỏ quạch",
    part_of_speech: "tính từ",
    meaning:
      "đỏ sẫm lại như có pha lẫn màu xám, gây cảm giác không ưa nhìn: tóc đỏ quạch vì dãi nắng * ngọn đèn dầu đỏ quạch",
    example: "tóc đỏ quạch vì dãi nắng * ngọn đèn dầu đỏ quạch",
  },
  {
    word: "đỏ nọc",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như đỏ đọc: đôi mắt đỏ nọc",
    example: "đôi mắt đỏ nọc",
  },
  {
    word: "đỏ rực",
    part_of_speech: "tính từ",
    meaning:
      "đỏ thắm, tươi và toả sáng ra xung quanh: lò than đỏ rực * mặt trời đỏ rực như hòn lửa",
    example: "lò than đỏ rực * mặt trời đỏ rực như hòn lửa",
  },
  {
    word: "đoá",
    part_of_speech: "danh từ",
    meaning:
      '(trang trọng) từ chỉ riêng từng bông hoa hoặc cái gì sánh được với hoa do vẻ đẹp trọn vẹn của nó: đoá hồng * đoá phù dung * "Tiếc thay! một đoá trà mi, Con ong đã mở đường đi lối về!" (TKiều)',
    example:
      'đoá hồng * đoá phù dung * "Tiếc thay! một đoá trà mi, Con ong đã mở đường đi lối về!" (TKiều)',
  },
  {
    word: "đỏ ửng",
    part_of_speech: "tính từ",
    meaning:
      "đỏ hồng lên, trông dịu, nhẹ, gây cảm giác ưa nhìn: sắc trời đỏ ửng * hai má đỏ ửng vì ngượng",
    example: "sắc trời đỏ ửng * hai má đỏ ửng vì ngượng",
  },
  {
    word: "đoái",
    part_of_speech: "động từ",
    meaning:
      '(cũ, văn chương) ngoái: đoái nhìn * "Đoái trông sự thế nực cười, Như đem trò rối mà chơi khác gì." (QÂTK)',
    example:
      'đoái nhìn * "Đoái trông sự thế nực cười, Như đem trò rối mà chơi khác gì." (QÂTK)',
  },
  {
    word: "đoái",
    part_of_speech: "động từ",
    meaning:
      'nghĩ tới, nhớ tới: "Đoái thương thân phận lỡ làng, Dạy đường phương tiện lòng càng cám ơn." (TT)',
    example:
      'Đoái thương thân phận lỡ làng, Dạy đường phương tiện lòng càng cám ơn." (TT)',
  },
  {
    word: "đoạ đày",
    part_of_speech: "động từ",
    meaning: "như đày đoạ: thân phận bị đọa đày",
    example: "thân phận bị đọa đày",
  },
  {
    word: "đoán",
    part_of_speech: "động từ",
    meaning:
      "dựa trên một số dấu hiệu, đặc điểm đã thấy, đã biết mà tìm cách suy ra điều chủ yếu còn chưa rõ hoặc chưa xảy ra: đoán tuổi * đoán trúng bệnh * đoán mò thế mà đúng",
    example: "đoán tuổi * đoán trúng bệnh * đoán mò thế mà đúng",
  },
  {
    word: "đo ván",
    part_of_speech: "động từ",
    meaning: "bị đánh ngã trên sàn khi đấu võ: hạ đo ván đối thủ",
    example: "hạ đo ván đối thủ",
  },
  {
    word: "đo ván",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bị thua, bị thất bại hoàn toàn một cách nhanh chóng: bị hàng ngoại cho đo ván * hạ đo ván kẻ tình địch",
    example: "bị hàng ngoại cho đo ván * hạ đo ván kẻ tình địch",
  },
  {
    word: "đoài",
    part_of_speech: "danh từ",
    meaning: "tên một quẻ trong bát quái, thường tượng trưng cho hồ, đầm.",
    example:
      'phía đoài * "Thôn Đoài ngồi nhớ thôn Đông, Một người chín nhớ mười mong một người." (NgBính; 15)',
  },
  {
    word: "đoan",
    part_of_speech: "động từ",
    meaning:
      '(Từ cũ, Ít dùng) như cam đoan: "(...) anh có dám đoan với tôi là sự báo cáo của anh nãy giờ đã thiệt chắc chưa?" (AĐức; 6)',
    example:
      '(...) anh có dám đoan với tôi là sự báo cáo của anh nãy giờ đã thiệt chắc chưa?" (AĐức; 6)',
  },
  {
    word: "đoái hoài",
    part_of_speech: "động từ",
    meaning:
      "để ý, quan tâm chăm sóc đến: đi biệt, không đoái hoài gì đến nhà cửa",
    example: "đi biệt, không đoái hoài gì đến nhà cửa",
  },
  {
    word: "đoản",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ, hiếm) ngắn: thanh đoản đao * đoản ngữ",
    example: "thanh đoản đao * đoản ngữ",
  },
  {
    word: "đoản",
    part_of_speech: "tính từ",
    meaning: "đối xử với nhau không có hậu, thiếu chu đáo: ăn ở đoản",
    example: "ăn ở đoản",
  },
  {
    word: "đoản",
    part_of_speech: "danh từ",
    meaning:
      "từng phần ngắn được tách riêng ra từ một vật có chiều dài: cưa khúc gỗ làm hai đoạn * đi một đoạn đường * đoạn đầu của bài thơ",
    example:
      "cưa khúc gỗ làm hai đoạn * đi một đoạn đường * đoạn đầu của bài thơ",
  },
  {
    word: "đoản",
    part_of_speech: "động từ",
    meaning: "(cũ, hiếm) kết thúc, chấm dứt: gặt hái vừa đoạn * đoạn tang",
    example: "gặt hái vừa đoạn * đoạn tang",
  },
  {
    word: "đoản",
    part_of_speech: "động từ",
    meaning: "cắt đứt hẳn quan hệ tình cảm: đoạn tình, đoạn nghĩa",
    example: "đoạn tình, đoạn nghĩa",
  },
  {
    word: "đoản",
    part_of_speech: "động từ",
    meaning:
      "từ biểu thị một hành động hoặc trạng thái vừa chấm dứt để chuyển sang một hành động hoặc trạng thái khác: nói đoạn rồi đi ngay * im lặng một lúc, đoạn chép miệng thở dài",
    example: "nói đoạn rồi đi ngay * im lặng một lúc, đoạn chép miệng thở dài",
  },
  {
    word: "đoàn",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp lâm thời nhiều người hay vật hoạt động có tổ chức: đoàn múa lân * đoàn tàu * đoàn tham quan",
    example: "đoàn múa lân * đoàn tàu * đoàn tham quan",
  },
  {
    word: "đoàn",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp người cùng hoạt động trong một tổ chức chặt chẽ: đoàn thanh niên * đoàn địa chất * đoàn chèo Trung ương",
    example: "đoàn thanh niên * đoàn địa chất * đoàn chèo Trung ương",
  },
  {
    word: "đoàn",
    part_of_speech: "danh từ",
    meaning:
      "(thường viết hoa) Đoàn thanh niên cộng sản Hồ Chí Minh (nói tắt): vào Đoàn * kỉ niệm ngày thành lập Đoàn",
    example: "vào Đoàn * kỉ niệm ngày thành lập Đoàn",
  },
  {
    word: "đoán chừng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đoán phỏng chừng, đại khái, không chắc chắn: đoán chừng anh ta khoảng bốn mươi tuổi",
    example: "đoán chừng anh ta khoảng bốn mươi tuổi",
  },
  {
    word: "đoàn chủ tịch",
    part_of_speech: "danh từ",
    meaning:
      "tập thể những người trong cơ quan thường vụ hay cơ quan dân cử lãnh đạo công tác giữa hai kì đại hội của một số cơ quan, đoàn thể.",
    example: "chủ tịch đoàn đại hội * ngồi ghế chủ tịch đoàn",
  },
  {
    word: "đoản binh",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) đội quân chuyên đánh giáp lá cà: dùng đoản binh đánh tập hậu",
    example: "dùng đoản binh đánh tập hậu",
  },
  {
    word: "đoan chính",
    part_of_speech: "tính từ",
    meaning:
      "(cũ) đứng đắn, ngay thẳng (chỉ nói về phụ nữ): người phụ nữ đoan chính",
    example: "người phụ nữ đoan chính",
  },
  {
    word: "đoạn đầu đài",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) bục cao làm nơi chém đầu người bị tội tử hình: kẻ tội nhân bước lên đoạn đầu đài",
    example: "kẻ tội nhân bước lên đoạn đầu đài",
  },
  {
    word: "đoản kiếm",
    part_of_speech: "danh từ",
    meaning: "gươm ngắn: thanh đoản kiếm",
    example: "thanh đoản kiếm",
  },
  {
    word: "đoản hậu",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ, khẩu ngữ) bạc bẽo, không thuỷ chung: đồ đoản hậu!",
    example: "đồ đoản hậu!",
  },
  {
    word: "đoán định",
    part_of_speech: "động từ",
    meaning:
      "đoán, xác định một cách tương đối chắc chắn, do có căn cứ: diễn biến tình hình rất khó đoán định",
    example: "diễn biến tình hình rất khó đoán định",
  },
  {
    word: "đoàn kết",
    part_of_speech: "động từ",
    meaning:
      "kết thành một khối thống nhất, cùng hoạt động vì một mục đích chung: gây mất đoàn kết * khối đoàn kết công nông",
    example: "gây mất đoàn kết * khối đoàn kết công nông",
  },
  {
    word: "đoản mạch",
    part_of_speech: "động từ",
    meaning:
      "đấu nối tắt hai điểm có điện thế khác nhau của một mạch điện bằng một đoạn dây có điện trở nhỏ, do đó, làm cho dòng điện qua dây có cường độ rất lớn: dây điện cháy vì bị đoản mạch",
    example: "dây điện cháy vì bị đoản mạch",
  },
  {
    word: "đoàn luyện",
    part_of_speech: "động từ",
    meaning: "(cũ, hiếm) như rèn luyện: đoàn luyện tinh thần",
    example: "đoàn luyện tinh thần",
  },
  {
    word: "đoản mệnh",
    part_of_speech: "tính từ",
    meaning: "có tuổi thọ ngắn: tướng người đoản mệnh",
    example: "tướng người đoản mệnh",
  },
  {
    word: "đoản ngữ",
    part_of_speech: "danh từ",
    meaning: "tổ hợp từ có quan hệ chính phụ: ,  *  là những đoản ngữ",
    example: ",  *  là những đoản ngữ",
  },
  {
    word: "đoạn nhiệt",
    part_of_speech: "động từ",
    meaning: "(hiếm) không cho nhiệt truyền qua: vỏ đoạn nhiệt",
    example: "vỏ đoạn nhiệt",
  },
  {
    word: "đoạn tang",
    part_of_speech: "động từ",
    meaning: "hết thời kì để tang: đoạn tang chồng",
    example: "đoạn tang chồng",
  },
  {
    word: "đoàn thể",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức quần chúng gồm những người có chung quyền lợi và nghĩa vụ, hoạt động vì những mục đích chính trị, xã hội nhất định: đoàn thể phụ nữ * đại diện của các cơ quan, đoàn thể",
    example: "đoàn thể phụ nữ * đại diện của các cơ quan, đoàn thể",
  },
  {
    word: "đoàn phí",
    part_of_speech: "danh từ",
    meaning:
      "tiền đoàn viên đóng cho tổ chức đoàn theo định kì, thường là hằng tháng: đóng đoàn phí",
    example: "đóng đoàn phí",
  },
  {
    word: "đoan trang",
    part_of_speech: "tính từ",
    meaning:
      "đứng đắn và nghiêm trang (chỉ nói về phụ nữ): tính tình đoan trang, thuỳ mị",
    example: "tính tình đoan trang, thuỳ mị",
  },
  {
    word: "đoạn thẳng",
    part_of_speech: "danh từ",
    meaning: "phần đường thẳng giới hạn bởi hai điểm: đoạn thẳng AB",
    example: "đoạn thẳng AB",
  },
  {
    word: "đoan trinh",
    part_of_speech: "tính từ",
    meaning: "(cũ, văn chương) đứng đắn và trinh tiết: người phụ nữ đoan trinh",
    example: "người phụ nữ đoan trinh",
  },
  {
    word: "đoàn tụ",
    part_of_speech: "động từ",
    meaning:
      "sum họp lại với nhau sau một thời gian bị li tán: đoàn tụ với gia đình",
    example: "đoàn tụ với gia đình",
  },
  {
    word: "đoàn viên",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) thành viên của một đoàn: đoàn viên đoàn thanh tra * đoàn viên công đoàn",
    example: "đoàn viên đoàn thanh tra * đoàn viên công đoàn",
  },
  {
    word: "đoàn viên",
    part_of_speech: "danh từ",
    meaning:
      "đoàn viên Đoàn thanh niên cộng sản Hồ Chí Minh (nói tắt): họp đoàn viên toàn chi đoàn * sổ đoàn viên",
    example: "họp đoàn viên toàn chi đoàn * sổ đoàn viên",
  },
  {
    word: "đoàn viên",
    part_of_speech: "động từ",
    meaning: "(văn chương) như đoàn tụ: cả nhà đã được đoàn viên",
    example: "cả nhà đã được đoàn viên",
  },
  {
    word: "đoàn trưởng",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như trưởng đoàn: đoàn trưởng đoàn xe",
    example: "đoàn trưởng đoàn xe",
  },
  {
    word: "đoạn trường",
    part_of_speech: "tính từ",
    meaning:
      '(cũ, văn chương) xót xa, đau đớn như đứt từng khúc ruột: nỗi đoạn trường * "Ma đưa lối, quỷ đem đường, Lại tìm những chốn đoạn trường mà đi." (TKiều)',
    example:
      'nỗi đoạn trường * "Ma đưa lối, quỷ đem đường, Lại tìm những chốn đoạn trường mà đi." (TKiều)',
  },
  {
    word: "đoạn tuyệt",
    part_of_speech: "động từ",
    meaning:
      "cắt đứt mọi mối liên hệ, quan hệ gắn bó trước đây: đoạn tuyệt với ma tuý",
    example: "đoạn tuyệt với ma tuý",
  },
  {
    word: "đoảng vị",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) đoảng quá, không được việc gì: con gái con đứa mà đoảng vị thật",
    example: "con gái con đứa mà đoảng vị thật",
  },
  {
    word: "đoạt",
    part_of_speech: "động từ",
    meaning:
      "chiếm, lấy cho được về mình, qua đấu tranh với người khác: đoạt giải nhất * đoạt chức vô địch * đoạt lấy chính quyền",
    example: "đoạt giải nhất * đoạt chức vô địch * đoạt lấy chính quyền",
  },
  {
    word: "đoảng",
    part_of_speech: "tính từ",
    meaning: "(hiếm) nhạt nhẽo, không có mùi vị gì: bát canh đoảng quá",
    example: "bát canh đoảng quá",
  },
  {
    word: "đoảng",
    part_of_speech: "tính từ",
    meaning:
      "chẳng được việc gì cả, do quá vụng về, lơ đễnh: con bé đến là đoảng!",
    example: "con bé đến là đoảng!",
  },
  {
    word: "đọc",
    part_of_speech: "động từ",
    meaning:
      "phát thành lời những điều đã được viết ra theo đúng trình tự: đọc tuyên thệ * đọc thuộc lòng bài thơ * đọc từ đầu đến cuối",
    example: "đọc tuyên thệ * đọc thuộc lòng bài thơ * đọc từ đầu đến cuối",
  },
  {
    word: "đọc",
    part_of_speech: "động từ",
    meaning:
      "tiếp nhận nội dung của một tập hợp kí hiệu bằng cách nhìn vào các kí hiệu: đọc bản thiết kế * đọc bản vẽ",
    example: "đọc bản thiết kế * đọc bản vẽ",
  },
  {
    word: "đọc",
    part_of_speech: "động từ",
    meaning:
      "thu lấy thông tin từ một thiết bị lưu trữ của máy tính (như đĩa từ, đĩa CD, v.v.): đĩa bị lỗi nên không đọc được",
    example: "đĩa bị lỗi nên không đọc được",
  },
  {
    word: "đọc",
    part_of_speech: "động từ",
    meaning:
      "hiểu rõ điều gì bằng cách nhìn vào những biểu hiện bên ngoài: đọc được ý nghĩ của người khác * đọc thấy trong mắt bạn",
    example: "đọc được ý nghĩ của người khác * đọc thấy trong mắt bạn",
  },
  {
    word: "đòi hỏi",
    part_of_speech: "động từ",
    meaning:
      "tỏ rõ yêu cầu, mong muốn ở người khác và muốn người ta phải đáp ứng, làm theo: độc giả đòi hỏi báo chí phải lên tiếng * đòi hỏi phải có sự lí giải thoả đáng",
    example:
      "độc giả đòi hỏi báo chí phải lên tiếng * đòi hỏi phải có sự lí giải thoả đáng",
  },
  {
    word: "đòi hỏi",
    part_of_speech: "động từ",
    meaning:
      "bắt buộc phải có hoặc phải làm, vì cần thiết như vậy: công việc đòi hỏi phải tốn nhiều thời gian và công sức",
    example: "công việc đòi hỏi phải tốn nhiều thời gian và công sức",
  },
  {
    word: "đòi hỏi",
    part_of_speech: "danh từ",
    meaning:
      "điều đòi hỏi: đáp ứng những đòi hỏi chính đáng * xuất phát từ đòi hỏi của thực tế",
    example:
      "đáp ứng những đòi hỏi chính đáng * xuất phát từ đòi hỏi của thực tế",
  },
  {
    word: "đòi",
    part_of_speech: "động từ",
    meaning:
      "nói, báo cho người khác biết là phải trả cái thuộc quyền của mình: đòi nợ * đòi lại quyển sách * đòi tiền công",
    example: "đòi nợ * đòi lại quyển sách * đòi tiền công",
  },
  {
    word: "đòi",
    part_of_speech: "động từ",
    meaning:
      "tỏ cho người khác biết cần phải đáp ứng, thoả mãn điều mong muốn nào đó của mình: bé đòi mẹ bế * đòi tăng lương, giảm giờ làm",
    example: "bé đòi mẹ bế * đòi tăng lương, giảm giờ làm",
  },
  {
    word: "đòi",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) muốn được như người khác (hàm ý mỉa mai): chưa vỡ bụng cứt đã đòi bay bổng (tng)",
    example: "chưa vỡ bụng cứt đã đòi bay bổng (tng)",
  },
  {
    word: "đòi",
    part_of_speech: "tính từ",
    meaning:
      '(cũ) nhiều: "Ngập ngừng thẹn lục, e hồng, Nghĩ lòng, lại xót xa lòng đòi phen." (TKiều)',
    example:
      'Ngập ngừng thẹn lục, e hồng, Nghĩ lòng, lại xót xa lòng đòi phen." (TKiều)',
  },
  {
    word: "đói kém",
    part_of_speech: "tính từ",
    meaning:
      "khan hiếm lương thực đến mức có thể gây ra nạn đói: mất mùa nên xảy ra đói kém",
    example: "mất mùa nên xảy ra đói kém",
  },
  {
    word: "đọi",
    part_of_speech: "danh từ",
    meaning: "(Trung) bát (dùng để ăn): ăn nên đọi nói nên lời (tng)",
    example: "ăn nên đọi nói nên lời (tng)",
  },
  {
    word: "đói",
    part_of_speech: "",
    meaning:
      "có cảm giác cồn cào, khó chịu khi đang thấy cần ăn mà chưa được ăn hoặc chưa được ăn đủ: bụng đói cồn cào * đói đầu gối phải bò (tng)",
    example: "bụng đói cồn cào * đói đầu gối phải bò (tng)",
  },
  {
    word: "đói",
    part_of_speech: "",
    meaning:
      "lâm vào tình trạng thiếu lương thực, nhiều người bị đói: nạn đói * cứu đói * xoá đói giảm nghèo",
    example: "nạn đói * cứu đói * xoá đói giảm nghèo",
  },
  {
    word: "đói",
    part_of_speech: "",
    meaning:
      "thiếu nhiều, do một đòi hỏi tự nhiên, và đang rất cần: đói ngủ * miền núi đói thông tin",
    example: "đói ngủ * miền núi đói thông tin",
  },
  {
    word: "đói meo",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) đói quá, đến mức cảm thấy như không có chút gì trong bụng cả: bụng đói meo",
    example: "bụng đói meo",
  },
  {
    word: "đói khổ",
    part_of_speech: "tính từ",
    meaning: "nghèo đói và khổ cực: cuộc sống đói khổ",
    example: "cuộc sống đói khổ",
  },
  {
    word: "đói khát",
    part_of_speech: "tính từ",
    meaning:
      'nghèo đói, thiếu ăn và khổ cực: dân tình đói khát * "Sinh con cơ khổ thương thay, Để cho đói khát đêm ngày xót xa!" (PCCH)',
    example:
      'dân tình đói khát * "Sinh con cơ khổ thương thay, Để cho đói khát đêm ngày xót xa!" (PCCH)',
  },
  {
    word: "đóm",
    part_of_speech: "danh từ",
    meaning:
      "tre, nứa hoặc gỗ khô chẻ mỏng, dùng để châm lửa: chẻ đóm * theo đóm ăn tàn (tng)",
    example: "chẻ đóm * theo đóm ăn tàn (tng)",
  },
  {
    word: "đỏm",
    part_of_speech: "tính từ",
    meaning: "đẹp do cố ý chải chuốt, tô điểm: hay làm đỏm",
    example: "hay làm đỏm",
  },
  {
    word: "đói rách",
    part_of_speech: "tính từ",
    meaning:
      "ở trong cảnh phải ăn đói, mặc rách (nói khái quát): thà đói rách chứ không chịu luỵ người",
    example: "thà đói rách chứ không chịu luỵ người",
  },
  {
    word: "đom đóm",
    part_of_speech: "danh từ",
    meaning:
      "hiện tượng cảm thấy như có nhiều đốm sáng loé ra trước mắt: cái tát làm nẩy đom đóm mắt",
    example: "cái tát làm nẩy đom đóm mắt",
  },
  {
    word: "đói veo",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) đói rất nhanh, vừa ăn xong đã thấy đói: ăn ba bát cơm mà vẫn thấy đói veo",
    example: "ăn ba bát cơm mà vẫn thấy đói veo",
  },
  {
    word: "đon",
    part_of_speech: "danh từ",
    meaning: "bó nhỏ được buộc gọn lại: đon mạ * đon lá mía",
    example: "đon mạ * đon lá mía",
  },
  {
    word: "đón",
    part_of_speech: "động từ",
    meaning:
      "ở tư thế hoặc có thái độ sẵn sàng tiếp nhận, gặp gỡ: đón quả bóng * đón tin vui",
    example: "đón quả bóng * đón tin vui",
  },
  {
    word: "đón",
    part_of_speech: "động từ",
    meaning:
      "chờ sẵn để gặp ngay khi vừa mới đến hoặc sắp đi qua: ra sân bay đón bạn * ra tận ngõ đón khách * thức đón giao thừa",
    example: "ra sân bay đón bạn * ra tận ngõ đón khách * thức đón giao thừa",
  },
  {
    word: "đón",
    part_of_speech: "động từ",
    meaning:
      "đến gặp để đưa về cùng với mình: đi đón cô dâu * đón con ở nhà trẻ",
    example: "đi đón cô dâu * đón con ở nhà trẻ",
  },
  {
    word: "đỏm dáng",
    part_of_speech: "tính từ",
    meaning: "có vẻ ngoài đẹp một cách chải chuốt: ăn mặc đỏm dáng",
    example: "ăn mặc đỏm dáng",
  },
  {
    word: "đòn",
    part_of_speech: "danh từ",
    meaning:
      "đoạn tre, gỗ chắc, cứng, dùng để kê, tựa hoặc để khiêng, chuyển vật nặng: đòn kê * cái đòn cân * kiếm cái đòn để khiêng",
    example: "đòn kê * cái đòn cân * kiếm cái đòn để khiêng",
  },
  {
    word: "đòn",
    part_of_speech: "danh từ",
    meaning:
      "hình thức đánh vào thân thể nói chung, coi như một hình phạt: bị đòn oan * dữ đòn * đỡ đòn cho em",
    example: "bị đòn oan * dữ đòn * đỡ đòn cho em",
  },
  {
    word: "đòn",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) từ dùng để chỉ từng cái bánh tét: gói mấy đòn bánh tét",
    example: "gói mấy đòn bánh tét",
  },
  {
    word: "đòn",
    part_of_speech: "danh từ",
    meaning:
      "hình thức tác động mạnh và trực tiếp vào đối phương để gây tổn thương, gây thiệt hại, có tính chất một sự trừng phạt: đánh một đòn nặng về kinh tế * giáng trả những đòn ác liệt",
    example: "đánh một đòn nặng về kinh tế * giáng trả những đòn ác liệt",
  },
  {
    word: "đon đả",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra nhanh nhảu, vồn vã khi tiếp xúc với ai: đon đả chào mời khách hàng",
    example: "đon đả chào mời khách hàng",
  },
  {
    word: "đọn",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) lọn: đọn tóc * ngắt mấy đọn rau lang",
    example: "đọn tóc * ngắt mấy đọn rau lang",
  },
  {
    word: "đọn",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) như còi: thằng bé đọn người",
    example: "thằng bé đọn người",
  },
  {
    word: "đòn bẩy",
    part_of_speech: "danh từ",
    meaning:
      "thanh rắn chuyển động được quanh một điểm cố định (gọi là điểm tựa), nhờ đó có thể dùng một lực nhỏ để cân bằng một lực lớn: nguyên tắc đòn bẩy",
    example: "nguyên tắc đòn bẩy",
  },
  {
    word: "đòn bẩy",
    part_of_speech: "danh từ",
    meaning:
      "cái có tác dụng thúc đẩy mạnh mẽ một hoạt động nào đó: đòn bẩy kinh tế",
    example: "đòn bẩy kinh tế",
  },
  {
    word: "đón chào",
    part_of_speech: "động từ",
    meaning: "như chào đón: đón chào năm mới",
    example: "đón chào năm mới",
  },
  {
    word: "đón đưa",
    part_of_speech: "động từ",
    meaning:
      'như đưa đón: "Trăm nơi ngàn chốn đón đưa, Không bằng chốn cũ khi xưa thiệt lòng." (ca dao)',
    example:
      'Trăm nơi ngàn chốn đón đưa, Không bằng chốn cũ khi xưa thiệt lòng." (ca dao)',
  },
  {
    word: "đón đầu",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đón chặn trước ở một nơi nào đó trên đường di chuyển của đối tượng: chạy tắt để đón đầu * bắn đón đầu",
    example: "chạy tắt để đón đầu * bắn đón đầu",
  },
  {
    word: "đón đầu",
    part_of_speech: "động từ",
    meaning:
      "đoán trước được xu thế phát triển của khoa học và công nghệ để có phương hướng hành động kịp thời, đạt hiệu quả cao: phát triển công nghệ theo hướng đón đầu",
    example: "phát triển công nghệ theo hướng đón đầu",
  },
  {
    word: "đón rước",
    part_of_speech: "động từ",
    meaning: "đón tiếp một cách long trọng: đón rước quan lớn * cuộc đón rước",
    example: "đón rước quan lớn * cuộc đón rước",
  },
  {
    word: "đón tiếp",
    part_of_speech: "động từ",
    meaning:
      "đón và tiếp đãi một cách trang trọng: đón tiếp đoàn đại biểu * chuẩn bị đón tiếp khách quý",
    example: "đón tiếp đoàn đại biểu * chuẩn bị đón tiếp khách quý",
  },
  {
    word: "đòn vọt",
    part_of_speech: "danh từ",
    meaning: "đòn đánh bằng roi vọt (nói khái quát): chịu nhiều đòn vọt",
    example: "chịu nhiều đòn vọt",
  },
  {
    word: "đón nhận",
    part_of_speech: "động từ",
    meaning:
      "nhận lấy một cách trân trọng: đón nhận huân chương * đón nhận tin chiến thắng",
    example: "đón nhận huân chương * đón nhận tin chiến thắng",
  },
  {
    word: "đòn gió",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) đòn đánh vào tinh thần bằng những lời doạ nạt: dùng đòn gió để đe doạ đối phương",
    example: "dùng đòn gió để đe doạ đối phương",
  },
  {
    word: "đong",
    part_of_speech: "động từ",
    meaning: "đo thể tích chất lỏng hoặc chất rời: đong rượu * đong gạo",
    example: "đong rượu * đong gạo",
  },
  {
    word: "đong",
    part_of_speech: "động từ",
    meaning:
      "đong để lấy một lượng nhất định của vật tính theo thể tích: đong gạo thổi cơm * đong ba lít rượu ra can",
    example: "đong gạo thổi cơm * đong ba lít rượu ra can",
  },
  {
    word: "đong",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) mua những thứ có thể đong được: đong một yến ngô * đong tạm mấy cân gạo",
    example: "đong một yến ngô * đong tạm mấy cân gạo",
  },
  {
    word: "đòng",
    part_of_speech: "danh từ",
    meaning:
      "cơ quan sinh sản của cây lúa sẽ phát triển thành bông, thành hoa và thành hạt: lúa đã có đòng * bón đón đòng",
    example: "lúa đã có đòng * bón đón đòng",
  },
  {
    word: "đóng",
    part_of_speech: "động từ",
    meaning:
      "làm cho một vật dài, cứng, có đầu nhọn cắm sâu và chắc vào một vật khác bằng cách nện mạnh vào đầu kia: đóng đinh vào tường * đóng cọc",
    example: "đóng đinh vào tường * đóng cọc",
  },
  {
    word: "đóng",
    part_of_speech: "động từ",
    meaning:
      "ghép chặt các bộ phận lại với nhau để tạo thành một vật chắc, có hình dáng, khuôn khổ nhất định: đóng bàn ghế * đóng giày * đóng sách",
    example: "đóng bàn ghế * đóng giày * đóng sách",
  },
  {
    word: "đóng",
    part_of_speech: "động từ",
    meaning:
      "ấn mạnh xuống để in thành dấu: hoá đơn có đóng dấu đỏ * đóng triện",
    example: "hoá đơn có đóng dấu đỏ * đóng triện",
  },
  {
    word: "đóng",
    part_of_speech: "động từ",
    meaning:
      "làm cho kín lại và giữ chặt ở vị trí cố định: đóng cửa * đóng nắp hòm * đóng mạch điện",
    example: "đóng cửa * đóng nắp hòm * đóng mạch điện",
  },
  {
    word: "đóng",
    part_of_speech: "động từ",
    meaning:
      "bố trí nơi ăn ở, sinh hoạt (thường nói về quân đội): đóng quân nơi hải đảo * bộ đội đóng ở làng",
    example: "đóng quân nơi hải đảo * bộ đội đóng ở làng",
  },
  {
    word: "đóng",
    part_of_speech: "động từ",
    meaning:
      "làm cho mọi sự vận động, mọi hoạt động đều phải ngừng hẳn lại: đóng cửa nhà máy * đóng vòi nước * đóng cửa đập",
    example: "đóng cửa nhà máy * đóng vòi nước * đóng cửa đập",
  },
  {
    word: "đóng",
    part_of_speech: "động từ",
    meaning: "không để cho qua lại: đóng biên giới * đóng cửa khẩu",
    example: "đóng biên giới * đóng cửa khẩu",
  },
  {
    word: "đóng",
    part_of_speech: "động từ",
    meaning:
      "kết đọng lại thành cái có trạng thái cố định, có hình dáng không thay đổi: dầu đóng váng trên mặt nước * nước đóng băng * gỉ sắt đóng thành tảng",
    example:
      "dầu đóng váng trên mặt nước * nước đóng băng * gỉ sắt đóng thành tảng",
  },
  {
    word: "đóng",
    part_of_speech: "động từ",
    meaning:
      "cho vào trong vật đựng để bảo quản: đóng rượu vào chai * đóng gói đồ lưu niệm * đóng thùng",
    example: "đóng rượu vào chai * đóng gói đồ lưu niệm * đóng thùng",
  },
  {
    word: "đóng",
    part_of_speech: "động từ",
    meaning:
      "mang vào thân thể bằng cách buộc, mắc thật chắc, thật sít: đóng khố * đóng móng ngựa * đóng ách vào cổ trâu",
    example: "đóng khố * đóng móng ngựa * đóng ách vào cổ trâu",
  },
  {
    word: "đóng",
    part_of_speech: "động từ",
    meaning:
      "thể hiện nhân vật trong kịch bản trên sân khấu hoặc màn ảnh bằng cách hoạt động, nói năng y như thật: đóng vai chính * đóng vai Thị Mầu * đóng phim",
    example: "đóng vai chính * đóng vai Thị Mầu * đóng phim",
  },
  {
    word: "đóng",
    part_of_speech: "động từ",
    meaning:
      "nộp phần mình phải góp theo quy định: đóng học phí * đóng thuế thu nhập",
    example: "đóng học phí * đóng thuế thu nhập",
  },
  {
    word: "đóng dấu",
    part_of_speech: "danh từ",
    meaning:
      "bệnh dịch ở lợn, có triệu chứng đỏ bầm từng đám trên da (trông như hình in của con dấu): dịch lợn đóng dấu",
    example: "dịch lợn đóng dấu",
  },
  {
    word: "đọng",
    part_of_speech: "động từ",
    meaning:
      "(chất lỏng) dồn lại ở một chỗ, do không chảy, không thoát đi được: ao tù nước đọng * sương đêm đọng trên lá cây, ngọn cỏ",
    example: "ao tù nước đọng * sương đêm đọng trên lá cây, ngọn cỏ",
  },
  {
    word: "đọng",
    part_of_speech: "động từ",
    meaning:
      "dồn lại một chỗ do không lưu thông, không chuyển đi được: xử lí chỗ hàng đọng",
    example: "xử lí chỗ hàng đọng",
  },
  {
    word: "đọng",
    part_of_speech: "động từ",
    meaning:
      "(văn chương) được giữ lại, chưa mất đi: nụ cười còn đọng trên môi * đọng lại nhiều kỉ niệm sâu sắc",
    example: "nụ cười còn đọng trên môi * đọng lại nhiều kỉ niệm sâu sắc",
  },
  {
    word: "đóng cửa bảo nhau",
    part_of_speech: "",
    meaning:
      "chỉ khuyết điểm, thiếu sót cho nhau trong nội bộ, tránh làm ầm ĩ, to chuyện để người ngoài biết được: anh em trong nhà phải biết đóng cửa bảo nhau",
    example: "anh em trong nhà phải biết đóng cửa bảo nhau",
  },
  {
    word: "đóng chai",
    part_of_speech: "động từ",
    meaning:
      "cho chất lỏng (đồ uống, nước chấm, v.v.) vào chai với khối lượng, kích thước xác định để thuận tiện cho việc mua bán, chuyên chở: nước khoáng đóng chai",
    example: "nước khoáng đóng chai",
  },
  {
    word: "đóng băng",
    part_of_speech: "động từ",
    meaning:
      "(nước) kết đọng lại thành tảng lớn ở những nơi có khí hậu rất lạnh: nước đóng băng",
    example: "nước đóng băng",
  },
  {
    word: "đóng băng",
    part_of_speech: "động từ",
    meaning:
      "ở trạng thái ngừng hẳn lại, không tiến triển, không hoạt động được do chịu sự tác động nào đó: thị trường nhà đất bị đóng băng * để tiền đóng băng trong ngân hàng",
    example:
      "thị trường nhà đất bị đóng băng * để tiền đóng băng trong ngân hàng",
  },
  {
    word: "đóng cửa",
    part_of_speech: "động từ",
    meaning:
      "ngăn cản, không cho quan hệ về kinh tế, xã hội với bên ngoài: chính sách đóng cửa",
    example: "chính sách đóng cửa",
  },
  {
    word: "đỏng đảnh",
    part_of_speech: "tính từ",
    meaning:
      "có điệu bộ, cử chỉ, cách nói năng làm ra vẻ như không cần biết đến ai, không coi ai ra gì (thường chỉ nói về phụ nữ; hàm ý chê): tính đỏng đảnh * trả lời đỏng đảnh",
    example: "tính đỏng đảnh * trả lời đỏng đảnh",
  },
  {
    word: "đóng đô",
    part_of_speech: "động từ",
    meaning: "đặt kinh đô ở một nơi nào đó.",
    example: "đóng đô ở nhà bạn",
  },
  {
    word: "đóng góp",
    part_of_speech: "động từ",
    meaning:
      "góp tiền của, công sức của mình vào công việc chung (nói khái quát): đóng góp ý kiến * đóng góp công sức, tiền bạc",
    example: "đóng góp ý kiến * đóng góp công sức, tiền bạc",
  },
  {
    word: "đong lường",
    part_of_speech: "động từ",
    meaning: "(hiếm) đong (nói khái quát): đơn vị đong lường",
    example: "đơn vị đong lường",
  },
  {
    word: "đóng hộp",
    part_of_speech: "động từ",
    meaning:
      "cho hàng tiêu dùng (thường là thực phẩm) vào hộp với khối lượng, kích thước xác định để thuận tiện cho việc bảo quản, chuyên chở: cá ngừ đóng hộp * cà muối đóng hộp",
    example: "cá ngừ đóng hộp * cà muối đóng hộp",
  },
  {
    word: "đòng đòng",
    part_of_speech: "danh từ",
    meaning:
      "cơ quan sinh sản của cây lúa sẽ phát triển thành bông, thành hoa và thành hạt: lúa đã có đòng * bón đón đòng",
    example: "lúa đã có đòng * bón đón đòng",
  },
  {
    word: "đóng khung",
    part_of_speech: "động từ",
    meaning:
      "giới hạn, hạn chế trong một phạm vi nhất định: đề thi chỉ đóng khung trong chương trình đã học",
    example: "đề thi chỉ đóng khung trong chương trình đã học",
  },
  {
    word: "đong đưa",
    part_of_speech: "động từ",
    meaning: "đưa qua đưa lại: cành cây đong đưa trước gió * ánh mắt đong đưa",
    example: "cành cây đong đưa trước gió * ánh mắt đong đưa",
  },
  {
    word: "đong đưa",
    part_of_speech: "tính từ",
    meaning:
      "(cũ, hiếm) tráo trở, không thật thà: ăn nói đong đưa * con người đong đưa",
    example: "ăn nói đong đưa * con người đong đưa",
  },
  {
    word: "đóng kịch",
    part_of_speech: "động từ",
    meaning: "diễn một vai trong vở kịch.",
    example: "chỉ khéo đóng kịch!",
  },
  {
    word: "đố",
    part_of_speech: "danh từ",
    meaning:
      "thanh tre hay gỗ đóng ở vách, ở cửa để làm tăng độ cứng, độ chắc: nhà tranh vách đố * giàu nứt đố đổ vách (tng)",
    example: "nhà tranh vách đố * giàu nứt đố đổ vách (tng)",
  },
  {
    word: "đố",
    part_of_speech: "động từ",
    meaning:
      "hỏi xem có đoán được, có trả lời được không, để thử trí thông minh hoặc trí nhớ: chơi đố chữ * ra câu đố",
    example: "chơi đố chữ * ra câu đố",
  },
  {
    word: "đố",
    part_of_speech: "động từ",
    meaning:
      'nói khích người khác thử làm việc gì đó, với ngụ ý cho rằng người ấy không thể làm nổi: không thầy đố mày làm nên (tục ngữ) * "Đố ai quét sạch lá rừng, Để ta khuyên gió, gió đừng rung cây." (ca dao)',
    example:
      'không thầy đố mày làm nên (tục ngữ) * "Đố ai quét sạch lá rừng, Để ta khuyên gió, gió đừng rung cây.',
  },
  {
    word: "đố",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) từ biểu thị ý phủ định tuyệt đối; hoàn toàn không, không hề: nói thế tôi đố có tin! * lần này thì đố có thoát!",
    example: "nói thế tôi đố có tin! * lần này thì đố có thoát!",
  },
  {
    word: "đóng gói",
    part_of_speech: "động từ",
    meaning:
      "cho hàng vào bao bì với khối lượng, kích thước xác định để thuận tiện cho việc mua bán, chuyên chở: hàng đã đóng gói gửi đi * đóng gói sản phẩm",
    example: "hàng đã đóng gói gửi đi * đóng gói sản phẩm",
  },
  {
    word: "đọt",
    part_of_speech: "danh từ",
    meaning: "ngọn thân hay cành cây còn non: đọt ổi * đọt chuối",
    example: "đọt ổi * đọt chuối",
  },
  {
    word: "đọt",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) phần trên cùng của cây cao: leo lên tận đọt dừa",
    example: "leo lên tận đọt dừa",
  },
  {
    word: "độ",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị đo cung, đo góc, bằng 1/360 của đường tròn, hoặc 1/180 của góc bẹt (kí hiệu O): góc 90O là góc vuông",
    example: "góc 90O là góc vuông",
  },
  {
    word: "độ",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị đo trong thang đo nhiệt độ, nồng độ (kí hiệu O), v.v.: sốt 39 O * nước sôi ở 100 O * cồn 90 O",
    example: "sốt 39 O * nước sôi ở 100 O * cồn 90 O",
  },
  {
    word: "độ",
    part_of_speech: "danh từ",
    meaning:
      "mức xác định trong một thang đo, một hệ thống tính toán: độ ẩm của không khí * độ sáng của ảnh * độ chính xác * độ tin cậy",
    example:
      "độ ẩm của không khí * độ sáng của ảnh * độ chính xác * độ tin cậy",
  },
  {
    word: "độ",
    part_of_speech: "danh từ",
    meaning:
      "quãng đường nào đó: mới đi được một độ đường đã mỏi * nhỡ độ đường",
    example: "mới đi được một độ đường đã mỏi * nhỡ độ đường",
  },
  {
    word: "độ",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian nào đó: lúa đương độ con gái * đào nở đúng độ Tết * độ này chị có khoẻ không?",
    example:
      "lúa đương độ con gái * đào nở đúng độ Tết * độ này chị có khoẻ không?",
  },
  {
    word: "độ",
    part_of_speech: "danh từ",
    meaning: "khoảng, chừng: nặng độ 2 cân * độ vài hôm nữa mới xong",
    example: "nặng độ 2 cân * độ vài hôm nữa mới xong",
  },
  {
    word: "độ",
    part_of_speech: "động từ",
    meaning: "(trời, Phật) cứu giúp, theo tôn giáo: Phật độ chúng sinh",
    example: "Phật độ chúng sinh",
  },
  {
    word: "đót",
    part_of_speech: "danh từ",
    meaning:
      "cây thân cỏ cùng họ với lúa, lá to, rộng, cụm hoa dùng làm chổi: chổi đót",
    example: "chổi đót",
  },
  {
    word: "đồ",
    part_of_speech: "danh từ",
    meaning:
      "(Từ cũ) người sống bằng nghề dạy chữ nho thời trước: thầy đồ * ông đồ",
    example: "thầy đồ * ông đồ",
  },
  {
    word: "đồ",
    part_of_speech: "danh từ",
    meaning:
      'người đã lớn tuổi, theo học chữ nho để thi cử: "Chẳng tham ruộng cả ao liền, Tham về cái bút cái nghiên anh đồ." (Cdao)',
    example:
      'Chẳng tham ruộng cả ao liền, Tham về cái bút cái nghiên anh đồ." (Cdao)',
  },
  {
    word: "đồ",
    part_of_speech: "danh từ",
    meaning:
      "vật do con người tạo ra để dùng vào một việc cụ thể nào đó trong đời sống hằng ngày (nói khái quát): đồ ăn thức uống * đồ chơi * đồ gốm * đi chợ mua ít đồ lặt vặt",
    example: "đồ ăn thức uống * đồ chơi * đồ gốm * đi chợ mua ít đồ lặt vặt",
  },
  {
    word: "đồ",
    part_of_speech: "danh từ",
    meaning:
      "loại, hạng người đáng khinh (từ dùng để mắng nhiếc, nguyền rủa): đồ ăn hại! * đồ lòng lang dạ thú!",
    example: "đồ ăn hại! * đồ lòng lang dạ thú!",
  },
  {
    word: "đồ",
    part_of_speech: "động từ",
    meaning:
      "viết hoặc vẽ đè lên những nét đã có sẵn: đồ lại bức tranh cũ * mẹ viết cho bé đồ lại",
    example: "đồ lại bức tranh cũ * mẹ viết cho bé đồ lại",
  },
  {
    word: "đồ",
    part_of_speech: "danh từ",
    meaning:
      "(Từ cũ) hình phạt thời phong kiến, đày đi làm khổ sai: phải tội đồ mười năm",
    example: "phải tội đồ mười năm",
  },
  {
    word: "đồ",
    part_of_speech: "động từ",
    meaning:
      "nấu cho chín bằng sức nóng của hơi nước trong chõ: đồ xôi * đồ đỗ",
    example: "đồ xôi * đồ đỗ",
  },
  {
    word: "đồ",
    part_of_speech: "động từ",
    meaning:
      "(Phương ngữ) đắp hoặc bôi thuốc đông y lên trên: đồ thuốc lên vết thương",
    example: "đồ thuốc lên vết thương",
  },
  {
    word: "đổ",
    part_of_speech: "động từ",
    meaning:
      "ngã nằm xuống, do phải chịu một lực xô đẩy mạnh hoặc do không còn đủ sức để giữ thế đứng: bão làm đổ cột điện * bức tường nghiêng, sắp đổ",
    example: "bão làm đổ cột điện * bức tường nghiêng, sắp đổ",
  },
  {
    word: "đổ",
    part_of_speech: "động từ",
    meaning:
      "không còn đứng vững, không còn tồn tại được trước những tác động bên ngoài: kế hoạch bị đổ * lật đổ ách thống trị * phá đổ cơ nghiệp của tổ tiên",
    example:
      "kế hoạch bị đổ * lật đổ ách thống trị * phá đổ cơ nghiệp của tổ tiên",
  },
  {
    word: "đổ",
    part_of_speech: "động từ",
    meaning:
      "làm cho vật được chứa đựng ra khỏi ngoài vật đựng: đánh đổ cốc nước * đổ gạo vào thùng * đổ dầu vào lửa (tng)",
    example: "đánh đổ cốc nước * đổ gạo vào thùng * đổ dầu vào lửa (tng)",
  },
  {
    word: "đổ",
    part_of_speech: "động từ",
    meaning:
      "tạo vật rắn bằng cách cho chất dẻo hoặc chất nhão vào khuôn và lèn chặt rồi để cho cứng lại: đổ bê tông * đổ móng * đổ gang vào khuôn",
    example: "đổ bê tông * đổ móng * đổ gang vào khuôn",
  },
  {
    word: "đổ",
    part_of_speech: "động từ",
    meaning:
      "thoát hoặc làm cho thoát ra ngoài nhiều trong một khoảng thời gian ngắn: đổ mồ hôi sôi nước mắt * đổ máu * đổ sức ra mới kiếm đủ ăn",
    example: "đổ mồ hôi sôi nước mắt * đổ máu * đổ sức ra mới kiếm đủ ăn",
  },
  {
    word: "đổ",
    part_of_speech: "động từ",
    meaning:
      "dồn nhiều và mạnh về một chỗ: mọi người đổ ra đường * thác đổ ào ào * nước sông đổ ra biển",
    example: "mọi người đổ ra đường * thác đổ ào ào * nước sông đổ ra biển",
  },
  {
    word: "đổ",
    part_of_speech: "động từ",
    meaning:
      "quy cho người khác hoặc cho hoàn cảnh khách quan để trốn tránh trách nhiệm về sai lầm, tội lỗi của mình: đổ trách nhiệm cho người khác * đổ tội cho em * đổ oan",
    example: "đổ trách nhiệm cho người khác * đổ tội cho em * đổ oan",
  },
  {
    word: "đổ",
    part_of_speech: "động từ",
    meaning:
      "chuyển đột ngột sang một trạng thái, tính chất khác hẳn, thường là không hay: mùa đông, trời đổ tối rất nhanh * thằng bé dạo này đổ hư",
    example: "mùa đông, trời đổ tối rất nhanh * thằng bé dạo này đổ hư",
  },
  {
    word: "đổ",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) trở về một phía, một bên nào đó tính từ điểm lấy làm mốc: trông chỉ quãng ba mươi tuổi đổ lại * tính từ Huế đổ ra",
    example: "trông chỉ quãng ba mươi tuổi đổ lại * tính từ Huế đổ ra",
  },
  {
    word: "đỗ",
    part_of_speech: "danh từ",
    meaning:
      "cây nhỏ, có nhiều loài, tràng hoa gồm năm cánh hình bướm, quả dài, chứa một dãy hạt, quả hay hạt dùng làm thức ăn: đi trỉa đậu",
    example: "đi trỉa đậu",
  },
  {
    word: "đỗ",
    part_of_speech: "danh từ",
    meaning: "đậu phụ (nói tắt): đậu rán * mua mấy bìa đậu",
    example: "đậu rán * mua mấy bìa đậu",
  },
  {
    word: "đỗ",
    part_of_speech: "danh từ",
    meaning: "đậu mùa (nói tắt): lên đậu * chủng đậu",
    example: "lên đậu * chủng đậu",
  },
  {
    word: "đỗ",
    part_of_speech: "động từ",
    meaning:
      "(đỗ) ở trạng thái đứng yên một chỗ, tạm thời không di chuyển (thường nói về chim và tàu thuyền): chim đậu trên cành * tàu thuyền đậu san sát trên bến cảng",
    example: "chim đậu trên cành * tàu thuyền đậu san sát trên bến cảng",
  },
  {
    word: "đỗ",
    part_of_speech: "động từ",
    meaning:
      "đạt được, giữ lại được kết quả tốt, như hoa kết thành quả, phôi thành hình cái thai, v.v. do có quá trình sinh trưởng tự nhiên thuận lợi: giống xấu, chỉ có mấy hạt đậu * cái thai không đậu * lứa tằm đậu",
    example: "giống xấu, chỉ có mấy hạt đậu * cái thai không đậu * lứa tằm đậu",
  },
  {
    word: "đỗ",
    part_of_speech: "động từ",
    meaning: "(hiếm) như đặng: cầm lòng không đậu",
    example: "cầm lòng không đậu",
  },
  {
    word: "đỗ",
    part_of_speech: "động từ",
    meaning: "(Nam) đỗ (= vượt qua được kì thi): đậu đại học",
    example: "đậu đại học",
  },
  {
    word: "đỗ",
    part_of_speech: "động từ",
    meaning: "chắp hai hay nhiều sợi lại với nhau: đậu tơ * sợi đậu ba",
    example: "đậu tơ * sợi đậu ba",
  },
  {
    word: "đồ án",
    part_of_speech: "danh từ",
    meaning:
      "bản vẽ thể hiện đầy đủ những số liệu đã tính toán kĩ tạo nên một công trình trong xây dựng, trong kĩ thuật: bảo vệ đồ án tốt nghiệp * đồ án thiết kế",
    example: "bảo vệ đồ án tốt nghiệp * đồ án thiết kế",
  },
  {
    word: "đồ án",
    part_of_speech: "danh từ",
    meaning:
      "bố cục trang trí bằng hoa văn trên một tác phẩm nghệ thuật: đồ án thiết kế đồ sứ",
    example: "đồ án thiết kế đồ sứ",
  },
  {
    word: "đô",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) vạm vỡ: thân hình rất đô",
    example: "thân hình rất đô",
  },
  {
    word: "đô",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) kinh đô (nói tắt): đóng đô * định đô * vua Lý Thái Tổ dời đô về Thăng Long",
    example: "đóng đô * định đô * vua Lý Thái Tổ dời đô về Thăng Long",
  },
  {
    word: "đô",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) đô la (nói tắt): chiếc máy tính trị giá hơn nghìn đô",
    example: "chiếc máy tính trị giá hơn nghìn đô",
  },
  {
    word: "đô",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) liều lượng (thường là chất kích thích) cần thiết đủ để có tác dụng: uống hai chai mới đủ đô * một liều chưa đủ đô",
    example: "uống hai chai mới đủ đô * một liều chưa đủ đô",
  },
  {
    word: "đổ ải",
    part_of_speech: "động từ",
    meaning:
      "tháo nước vào ruộng, sau khi đất đã ải: cung cấp đủ nước trong thời điểm đổ ải",
    example: "cung cấp đủ nước trong thời điểm đổ ải",
  },
  {
    word: "độ ẩm",
    part_of_speech: "danh từ",
    meaning: "độ ẩm không khí (nói tắt): mùa đông, độ ẩm thấp",
    example: "mùa đông, độ ẩm thấp",
  },
  {
    word: "đồ bộ",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) bộ quần áo mặc ở nhà của nữ giới, được may bằng cùng một loại vải, thường là vải mềm: ở nhà mặc đồ bộ",
    example: "ở nhà mặc đồ bộ",
  },
  {
    word: "đổ bể",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) như đổ vỡ: mọi việc đổ bể hết * cuộc hôn nhân bị đổ bể",
    example: "mọi việc đổ bể hết * cuộc hôn nhân bị đổ bể",
  },
  {
    word: "đổ bộ",
    part_of_speech: "động từ",
    meaning:
      "đến vùng đất nào đó của đối phương bằng phương tiện vận tải đường thuỷ hoặc đường không, để tác chiến: lính thuỷ đổ bộ lên đảo * chặn đánh quân đổ bộ",
    example: "lính thuỷ đổ bộ lên đảo * chặn đánh quân đổ bộ",
  },
  {
    word: "đổ bộ",
    part_of_speech: "động từ",
    meaning:
      "đến đất liền sau khi đã vượt biển hoặc qua một khoảng không gian: cơn bão đổ bộ vào các tỉnh miền Trung * tàu vũ trụ đổ bộ lên Mặt Trăng",
    example:
      "cơn bão đổ bộ vào các tỉnh miền Trung * tàu vũ trụ đổ bộ lên Mặt Trăng",
  },
  {
    word: "độ chính xác",
    part_of_speech: "danh từ",
    meaning:
      "mức độ gần đúng đạt được, so với tính chính xác trên lí thuyết: đồng hồ có độ chính xác cao",
    example: "đồng hồ có độ chính xác cao",
  },
  {
    word: "đổ bê tông",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) từ gợi tả lối chơi bóng chậm, chỉ chuyền bằng những đường chuyền ngắn và sệt, lặp đi lặp lại nhiều lần, không tấn công, nhằm làm cho đối phương mệt mỏi: lối đá đổ bê tông",
    example: "lối đá đổ bê tông",
  },
  {
    word: "đồ chừng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đoán chừng, ước chừng: tôi đồ chừng phải một tuần mới xong",
    example: "tôi đồ chừng phải một tuần mới xong",
  },
  {
    word: "đồ chơi",
    part_of_speech: "danh từ",
    meaning:
      "đồ vật dùng vào việc vui chơi, giải trí cho trẻ em (nói khái quát): nặn đồ chơi * em bé ngồi chơi đồ chơi",
    example: "nặn đồ chơi * em bé ngồi chơi đồ chơi",
  },
  {
    word: "đồ dùng",
    part_of_speech: "danh từ",
    meaning:
      "vật do con người tạo ra để dùng trong sinh hoạt, trong hoạt động hằng ngày (nói khái quát): đồ dùng sinh hoạt gia đình * đồ dùng học tập",
    example: "đồ dùng sinh hoạt gia đình * đồ dùng học tập",
  },
  {
    word: "đồ đạc",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng trong gia đình, để phục vụ sinh hoạt (nói khái quát): kê lại đồ đạc * dọn dẹp đồ đạc trong nhà",
    example: "kê lại đồ đạc * dọn dẹp đồ đạc trong nhà",
  },
  {
    word: "đổ dồn",
    part_of_speech: "động từ",
    meaning:
      "hướng cả vào, tập trung cả vào một đối tượng, sự việc nào đó trong cùng một lúc: mọi người đổ dồn ra xem * trách nhiệm đổ dồn lên đầu giám đốc",
    example: "mọi người đổ dồn ra xem * trách nhiệm đổ dồn lên đầu giám đốc",
  },
  {
    word: "đổ dồn",
    part_of_speech: "động từ",
    meaning:
      "(âm thanh) phát ra dồn dập, liên tiếp, thành từng hồi, từng đợt: chuông điện thoại đổ dồn * tiếng trống đổ dồn",
    example: "chuông điện thoại đổ dồn * tiếng trống đổ dồn",
  },
  {
    word: "đỗ đạt",
    part_of_speech: "động từ",
    meaning: "thi đỗ (nói khái quát): con cái học hành đỗ đạt",
    example: "con cái học hành đỗ đạt",
  },
  {
    word: "đồ đệ",
    part_of_speech: "danh từ",
    meaning: "(cũ) học trò: Nhan Uyên là đồ đệ của Khổng Tử * xin làm đồ đệ",
    example: "Nhan Uyên là đồ đệ của Khổng Tử * xin làm đồ đệ",
  },
  {
    word: "đô đốc",
    part_of_speech: "danh từ",
    meaning: "(cũ) chức quan võ cầm đầu một đạo quân thời phong kiến.",
    example: "đô đốc hải quân",
  },
  {
    word: "đổ đom đóm",
    part_of_speech: "động từ",
    meaning:
      "cảm thấy như có nhiều đốm sáng loé ra trước mắt, như khi bị đập mạnh vào mắt: làm đổ đom đóm mà vẫn không đủ ăn",
    example: "làm đổ đom đóm mà vẫn không đủ ăn",
  },
  {
    word: "đổ điêu",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đặt điều quy lỗi cho người khác: lỗi của mình nhưng lại đổ điêu cho người khác",
    example: "lỗi của mình nhưng lại đổ điêu cho người khác",
  },
  {
    word: "đổ đom đóm mắt",
    part_of_speech: "động từ",
    meaning:
      "cảm thấy như có nhiều đốm sáng loé ra trước mắt, như khi bị đập mạnh vào mắt: làm đổ đom đóm mà vẫn không đủ ăn",
    example: "làm đổ đom đóm mà vẫn không đủ ăn",
  },
  {
    word: "đồ hàng",
    part_of_speech: "danh từ",
    meaning: "các thứ hàng để bày bán (nói khái quát): bày đồ hàng",
    example: "bày đồ hàng",
  },
  {
    word: "đồ hàng",
    part_of_speech: "danh từ",
    meaning: "trò chơi mua bán hàng của trẻ nhỏ: chơi đồ hàng",
    example: "chơi đồ hàng",
  },
  {
    word: "đổ đốn",
    part_of_speech: "động từ",
    meaning: "trở nên hư đốn, không được như trước: càng ngày càng đổ đốn",
    example: "càng ngày càng đổ đốn",
  },
  {
    word: "đồ hoạ",
    part_of_speech: "danh từ",
    meaning:
      "nghệ thuật tạo hình dùng nét vẽ, nét khắc hoặc mảng hình để tạo nên các tác phẩm: học ngành đồ hoạ",
    example: "học ngành đồ hoạ",
  },
  {
    word: "đô hội",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) nơi dân cư đông đúc, buôn bán nhộn nhịp: chốn phồn hoa đô hội",
    example: "chốn phồn hoa đô hội",
  },
  {
    word: "đô hộ",
    part_of_speech: "động từ",
    meaning: "thống trị nước phụ thuộc: thoát khỏi ách đô hộ",
    example: "thoát khỏi ách đô hộ",
  },
  {
    word: "đổ đồng",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) hơn bù kém, lấy con số trung bình: tính đổ đồng",
    example: "tính đổ đồng",
  },
  {
    word: "đổ hào quang",
    part_of_speech: "động từ",
    meaning: "như đổ đom đóm (thường hàm ý hài hước): mắt đổ hào quang",
    example: "mắt đổ hào quang",
  },
  {
    word: "độ hồn",
    part_of_speech: "động từ",
    meaning: "(hiếm) như độ vong: độ hồn cho người quá cố",
    example: "độ hồn cho người quá cố",
  },
  {
    word: "đổ hồi",
    part_of_speech: "động từ",
    meaning: "(tiếng động) phát ra từng hồi liên tục và dồn dập: gà gáy đổ hồi",
    example: "gà gáy đổ hồi",
  },
  {
    word: "đồ hộp",
    part_of_speech: "danh từ",
    meaning: "thức ăn đóng hộp (nói khái quát): thích ăn đồ hộp",
    example: "thích ăn đồ hộp",
  },
  {
    word: "đố kỵ",
    part_of_speech: "động từ",
    meaning:
      "cảm thấy khó chịu và đâm ra ghét khi thấy người ta có thể hơn mình: sinh lòng đố kị * tính hay đố kị",
    example: "sinh lòng đố kị * tính hay đố kị",
  },
  {
    word: "đồ mát",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) quần áo mỏng mặc cho mát khi ở nhà: ở nhà mặc đồ mát đặng nằm ngồi cho tiện",
    example: "ở nhà mặc đồ mát đặng nằm ngồi cho tiện",
  },
  {
    word: "đố kị",
    part_of_speech: "động từ",
    meaning:
      "cảm thấy khó chịu và đâm ra ghét khi thấy người ta có thể hơn mình: sinh lòng đố kị * tính hay đố kị",
    example: "sinh lòng đố kị * tính hay đố kị",
  },
  {
    word: "đồ lề",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ dùng thường ngày (nói khái quát): đồ lề của thợ mộc * chuẩn bị đầy đủ đồ lề",
    example: "đồ lề của thợ mộc * chuẩn bị đầy đủ đồ lề",
  },
  {
    word: "đổ nát",
    part_of_speech: "",
    meaning: "sụp đổ và tan nát: căn nhà đổ nát",
    example: "căn nhà đổ nát",
  },
  {
    word: "đổ máu",
    part_of_speech: "động từ",
    meaning:
      "tổn thất về xương máu, sinh mạng con người: tránh đổ máu * không có người đến can thì đã xảy ra đổ máu",
    example: "tránh đổ máu * không có người đến can thì đã xảy ra đổ máu",
  },
  {
    word: "đồ nghề",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ riêng cho một nghề nào đó (nói khái quát): bộ đồ nghề của người thợ xây * sắm sửa đồ nghề",
    example: "bộ đồ nghề của người thợ xây * sắm sửa đồ nghề",
  },
  {
    word: "độ lượng",
    part_of_speech: "danh từ",
    meaning:
      "đức tính dễ cảm thông với người có sai sót, lầm lỡ và dễ tha thứ: người có độ lượng * nụ cười đầy độ lượng",
    example: "người có độ lượng * nụ cười đầy độ lượng",
  },
  {
    word: "độ lượng",
    part_of_speech: "tính từ",
    meaning:
      "có đức tính dễ cảm thông, sẵn sàng tha thứ, bỏ qua những lỗi lầm của người khác: sống rất độ lượng * nghiêm khắc với mình, độ lượng với người",
    example: "sống rất độ lượng * nghiêm khắc với mình, độ lượng với người",
  },
  {
    word: "đổ nhào",
    part_of_speech: "động từ",
    meaning:
      "sụp đổ hoàn toàn, không còn đứng vững, không còn tồn tại được nữa: bức tường đổ nhào * xe đổ nhào xuống ruộng",
    example: "bức tường đổ nhào * xe đổ nhào xuống ruộng",
  },
  {
    word: "độ phân giải",
    part_of_speech: "danh từ",
    meaning:
      "đại lượng đo độ nét của hình ảnh, được biểu thị bằng số điểm ảnh trên mỗi inch: điều chỉnh độ phân giải của màn hình * ti vi có độ phân giải cao",
    example: "điều chỉnh độ phân giải của màn hình * ti vi có độ phân giải cao",
  },
  {
    word: "độ nhật",
    part_of_speech: "động từ",
    meaning: "(cũ) sống lần hồi cho qua ngày: kiếm ăn độ nhật",
    example: "kiếm ăn độ nhật",
  },
  {
    word: "độ phì",
    part_of_speech: "danh từ",
    meaning: "mức độ chất dinh dưỡng nhiều hay ít của đất: độ phì của đất",
    example: "độ phì của đất",
  },
  {
    word: "đồ rau",
    part_of_speech: "danh từ",
    meaning:
      "khối đất nặn hình hơi khum, gồm ba hòn đặt chụm đầu vào nhau để bắc nồi lên đun: ông đầu rau",
    example: "ông đầu rau",
  },
  {
    word: "đổ riệt",
    part_of_speech: "động từ",
    meaning:
      "khăng khăng đổ lỗi, trút trách nhiệm cho ai đó, bất chấp phải trái, đúng sai: làm hỏng rồi đổ riệt cho người khác",
    example: "làm hỏng rồi đổ riệt cho người khác",
  },
  {
    word: "độ sinh",
    part_of_speech: "động từ",
    meaning:
      'cứu vớt chúng sinh, theo đạo Phật: "Độ sinh nhờ đức cao dày, Lập am rồi sẽ rước thầy ở chung." (TKiều)',
    example:
      'Độ sinh nhờ đức cao dày, Lập am rồi sẽ rước thầy ở chung." (TKiều)',
  },
  {
    word: "đồ tể",
    part_of_speech: "danh từ",
    meaning: "(cũ) người làm nghề giết mổ gia súc.",
    example: "tên đồ tể khát máu",
  },
  {
    word: "đô thành",
    part_of_speech: "danh từ",
    meaning: "(cũ) thành phố, dùng làm kinh đô, thủ đô: chốn đô thành",
    example: "chốn đô thành",
  },
  {
    word: "đồ sộ",
    part_of_speech: "tính từ",
    meaning:
      "to lớn hơn mức bình thường rất nhiều: thân hình đồ sộ * được thừa hưởng cả một gia tài đồ sộ",
    example: "thân hình đồ sộ * được thừa hưởng cả một gia tài đồ sộ",
  },
  {
    word: "độ thân",
    part_of_speech: "động từ",
    meaning:
      '(cũ) tự kiếm sống lần hồi cho qua ngày: "Mong manh phận mỏng như tờ, Tìm nơi kiếm chốn nương nhờ độ thân." (ca dao)',
    example:
      'Mong manh phận mỏng như tờ, Tìm nơi kiếm chốn nương nhờ độ thân." (ca dao)',
  },
  {
    word: "đồ tế nhuyễn",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) những vật nhỏ, nhẹ, mềm mại (nói khái quát); dùng để chỉ quần áo và đồ trang sức của phụ nữ: "Đồ tế nhuyễn, của riêng tây, Sạch sành sanh vét cho đầy túi tham." (TKiều)',
    example:
      'Đồ tế nhuyễn, của riêng tây, Sạch sành sanh vét cho đầy túi tham." (TKiều)',
  },
  {
    word: "đô thị hoá",
    part_of_speech: "động từ",
    meaning:
      "(quá trình) tập trung dân cư ngày càng đông vào các đô thị và làm nâng cao vai trò của thành thị đối với sự phát triển của xã hội: đô thị hoá nông thôn",
    example: "đô thị hoá nông thôn",
  },
  {
    word: "đô thị",
    part_of_speech: "danh từ",
    meaning:
      "nơi dân cư đông đúc, là trung tâm thương nghiệp và có thể cả công nghiệp (thành phố, thị xã hoặc thị trấn): phát triển đô thị * mở rộng đô thị",
    example: "phát triển đô thị * mở rộng đô thị",
  },
  {
    word: "độ thế",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) cứu giúp con người thoát khỏi cảnh khổ ải, theo đạo Phật: cứu nhân độ thế",
    example: "cứu nhân độ thế",
  },
  {
    word: "đồ thị",
    part_of_speech: "danh từ",
    meaning:
      "hình vẽ biểu diễn sự biến thiên của một hàm số phụ thuộc vào sự biến thiên của biến số: vẽ đồ thị của hàm số y = ax + b * đồ thị có dạng hình sin",
    example: "vẽ đồ thị của hàm số y = ax + b * đồ thị có dạng hình sin",
  },
  {
    word: "đổ thừa",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) đổ lỗi cho người khác để trốn tránh trách nhiệm: mình làm mình chịu, còn đổ thừa cho ai",
    example: "mình làm mình chịu, còn đổ thừa cho ai",
  },
  {
    word: "độ trì",
    part_of_speech: "động từ",
    meaning: "(cũ) (trời, Phật) cứu vớt và che chở: trời Phật độ trì",
    example: "trời Phật độ trì",
  },
  {
    word: "đổ vỡ",
    part_of_speech: "động từ",
    meaning:
      "(vật giòn) tan ra từng mảnh vì rơi, đổ (nói khái quát): bát đĩa, cốc chén đổ vỡ lung tung",
    example: "bát đĩa, cốc chén đổ vỡ lung tung",
  },
  {
    word: "đổ vỡ",
    part_of_speech: "động từ",
    meaning:
      "tan nát, chia lìa, không còn giữ được nguyên vẹn: cuộc hôn nhân đổ vỡ",
    example: "cuộc hôn nhân đổ vỡ",
  },
  {
    word: "đổ vỡ",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) (chuyện không hay) bị lộ ra làm nhiều người biết, không còn giữ kín được nữa: sự việc đổ vỡ",
    example: "sự việc đổ vỡ",
  },
  {
    word: "đồ vật",
    part_of_speech: "danh từ",
    meaning: "đồ đạc, vật dụng (nói khái quát): các đồ vật đắt tiền",
    example: "các đồ vật đắt tiền",
  },
  {
    word: "đổ vấy",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đổ bừa lỗi cho người khác, để trút trách nhiệm: làm hỏng lại đổ vấy cho người khác",
    example: "làm hỏng lại đổ vấy cho người khác",
  },
  {
    word: "đổ xô",
    part_of_speech: "động từ",
    meaning:
      "kéo tới, kéo nhau đi rất đông, cùng một lúc: mọi người đổ xô về phía bờ sông",
    example: "mọi người đổ xô về phía bờ sông",
  },
  {
    word: "đổ xô",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đua nhau làm một việc gì: thấy rẻ, ai cũng đổ xô đi mua hàng",
    example: "thấy rẻ, ai cũng đổ xô đi mua hàng",
  },
  {
    word: "đốc",
    part_of_speech: "danh từ",
    meaning:
      "phần cuối cùng, đầu mút của cán dao, kiếm, xẻng, v.v.: đốc kiếm * đốc gươm",
    example: "đốc kiếm * đốc gươm",
  },
  {
    word: "đốc",
    part_of_speech: "động từ",
    meaning:
      "thúc giục làm, không để chậm trễ: đốc cho làm thật nhanh * đốc con học hành nghiêm túc",
    example: "đốc cho làm thật nhanh * đốc con học hành nghiêm túc",
  },
  {
    word: "đốc",
    part_of_speech: "tính từ",
    meaning:
      "(ngô) bị thoái hoá, thường biểu hiện trên bông cờ có bắp nhỏ, hoặc dưới bắp lại có cờ: ngô bị đốc",
    example: "ngô bị đốc",
  },
  {
    word: "đô-pinh",
    part_of_speech: "danh từ",
    meaning:
      "chất kích thích nói chung (thường nói về chất kích thích vận động viên dùng trong thi đấu thể thao để nâng cao thành tích, mặc dù có quy định cấm): kiểm tra doping cho kết quả dương tính",
    example: "kiểm tra doping cho kết quả dương tính",
  },
  {
    word: "độc",
    part_of_speech: "tính từ",
    meaning:
      "có ảnh hưởng lớn đến sức khoẻ hoặc có thể làm nguy hại đến tính mạng: thuốc độc * nấm độc * loại rắn có nọc độc * ma thiêng nước độc (tng)",
    example:
      "thuốc độc * nấm độc * loại rắn có nọc độc * ma thiêng nước độc (tng)",
  },
  {
    word: "độc",
    part_of_speech: "tính từ",
    meaning: "hiểm ác, làm hại người: mưu sâu kế độc",
    example: "mưu sâu kế độc",
  },
  {
    word: "độc",
    part_of_speech: "tính từ",
    meaning:
      "(lời nói) có thể mang lại tai hoạ, sự chết chóc, theo quan niệm cũ: thề độc * thốt ra những câu chửi rất độc",
    example: "thề độc * thốt ra những câu chửi rất độc",
  },
  {
    word: "độc",
    part_of_speech: "tính từ",
    meaning:
      "chỉ có một mà thôi: con độc, cháu đàn * dại đàn hơn khôn độc (tng)",
    example: "con độc, cháu đàn * dại đàn hơn khôn độc (tng)",
  },
  {
    word: "độc",
    part_of_speech: "trợ từ",
    meaning:
      "(Khẩu ngữ) từ biểu thị ý nhấn mạnh rằng số lượng chỉ có một hoặc rất ít, không còn có thêm gì khác nữa: trên người mặc độc chiếc quần đùi * cả xóm chỉ có độc một nhà có ti vi",
    example:
      "trên người mặc độc chiếc quần đùi * cả xóm chỉ có độc một nhà có ti vi",
  },
  {
    word: "độc ẩm",
    part_of_speech: "tính từ",
    meaning: "(ấm, chén) chuyên dùng cho một người uống: ấm độc ẩm",
    example: "ấm độc ẩm",
  },
  {
    word: "độc ác",
    part_of_speech: "tính từ",
    meaning:
      "rất ác, thâm hiểm, thậm chí có phần thích thú trước những đau đớn gây cho người khác: thủ đoạn độc ác * tâm địa độc ác",
    example: "thủ đoạn độc ác * tâm địa độc ác",
  },
  {
    word: "độc bình",
    part_of_speech: "danh từ",
    meaning:
      "lọ to, cổ thắt, miệng loe, thường bày một chiếc để cắm hoa: lọ độc bình",
    example: "lọ độc bình",
  },
  {
    word: "độc canh",
    part_of_speech: "động từ",
    meaning:
      "(phương thức canh tác) chỉ trồng một loại cây, không trồng các loại cây khác; phân biệt với đa canh: độc canh cây lúa",
    example: "độc canh cây lúa",
  },
  {
    word: "độc chiêu",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) miếng đòn, thủ đoạn, v.v., có tính chất hiểm, thường chỉ một mình mình có: đòn độc chiêu * tung độc chiêu",
    example: "đòn độc chiêu * tung độc chiêu",
  },
  {
    word: "độc chiếm",
    part_of_speech: "động từ",
    meaning: "chiếm lấy, giành lấy riêng một mình: độc chiếm thị trường",
    example: "độc chiếm thị trường",
  },
  {
    word: "đốc chứng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) như trở chứng: con bé hôm nay lại đốc chứng, không chịu đi học",
    example: "con bé hôm nay lại đốc chứng, không chịu đi học",
  },
  {
    word: "độc đắc",
    part_of_speech: "tính từ",
    meaning: "(giải xổ số) đặc biệt, cao nhất: giải độc đắc * trúng số độc đắc",
    example: "giải độc đắc * trúng số độc đắc",
  },
  {
    word: "độc đạo",
    part_of_speech: "tính từ",
    meaning:
      "chỉ có một con đường, một lối đi dẫn tới đích mà thôi (không còn đường đi, lối đi nào khác): con đường độc đạo",
    example: "con đường độc đạo",
  },
  {
    word: "độc diễn",
    part_of_speech: "động từ",
    meaning: "chỉ biểu diễn hoặc chỉ thực hiện một mình: độc diễn đàn bầu",
    example: "độc diễn đàn bầu",
  },
  {
    word: "độc diễn",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) hoạt động, trình diễn, v.v. một mình, không có cạnh tranh, không có đối thủ: thắng với tỉ số đậm 5-0, trận đấu được coi như màn độc diễn của đội chủ nhà",
    example:
      "thắng với tỉ số đậm 5-0, trận đấu được coi như màn độc diễn của đội chủ nhà",
  },
  {
    word: "độc địa",
    part_of_speech: "tính từ",
    meaning:
      "rất độc, chỉ muốn tai hoạ, đau khổ xảy đến cho người khác: lời nguyền rủa độc địa * mồm miệng độc địa",
    example: "lời nguyền rủa độc địa * mồm miệng độc địa",
  },
  {
    word: "độc địa",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có thể gây những tác hại lớn, đáng nguyền rủa: khí hậu độc địa * thủ đoạn độc địa",
    example: "khí hậu độc địa * thủ đoạn độc địa",
  },
  {
    word: "độc đáo",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất riêng của mình, không phỏng theo những gì đã có xưa nay, không giống, không lẫn với những gì có ở người khác: một ý tưởng hết sức độc đáo * ngôi nhà có kiến trúc độc đáo",
    example: "một ý tưởng hết sức độc đáo * ngôi nhà có kiến trúc độc đáo",
  },
  {
    word: "độc đoán",
    part_of_speech: "tính từ",
    meaning:
      "(lối làm việc, xử sự) dùng quyền của mình mà định đoạt công việc theo ý riêng, bất chấp ý kiến của những người khác: quyết định độc đoán * chuyên quyền, độc đoán",
    example: "quyết định độc đoán * chuyên quyền, độc đoán",
  },
  {
    word: "độc giả",
    part_of_speech: "danh từ",
    meaning:
      "người đọc sách báo, trong quan hệ với tác giả, nhà xuất bản, cơ quan báo chí, thư viện: nhận được thư góp ý của độc giả * sách được tái bản theo yêu cầu của độc giả",
    example:
      "nhận được thư góp ý của độc giả * sách được tái bản theo yêu cầu của độc giả",
  },
  {
    word: "độc dược",
    part_of_speech: "danh từ",
    meaning:
      "thuốc chữa bệnh có dùng chất độc: quản lí chặt chẽ các loại độc dược",
    example: "quản lí chặt chẽ các loại độc dược",
  },
  {
    word: "độc hại",
    part_of_speech: "tính từ",
    meaning:
      "có khả năng làm hại sức khoẻ hoặc tinh thần: hoá chất độc hại * ảnh hưởng độc hại của văn hoá phẩm đồi truỵ",
    example: "hoá chất độc hại * ảnh hưởng độc hại của văn hoá phẩm đồi truỵ",
  },
  {
    word: "đốc học",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) chức quan trông coi việc dạy và học trong một tỉnh lớn, thời trước: quan đốc học",
    example: "quan đốc học",
  },
  {
    word: "độc lập",
    part_of_speech: "tính từ",
    meaning:
      "tự mình tồn tại, hoạt động, không nương tựa hoặc phụ thuộc vào ai, vào cái gì khác: sống độc lập từ bé * suy nghĩ độc lập",
    example: "sống độc lập từ bé * suy nghĩ độc lập",
  },
  {
    word: "độc lập",
    part_of_speech: "tính từ",
    meaning:
      "Độc lập: Đây là từ gốc Hán,độc tức là một, lập là đứng; vậy độc lập tức là đứng một mình, không phụ thuộc vào ai.",
    example: "một đất nước độc lập, tự do",
  },
  {
    word: "độc lập",
    part_of_speech: "danh từ",
    meaning:
      "trạng thái của một nước hoặc một dân tộc có chủ quyền về chính trị, không phụ thuộc vào nước khác hoặc dân tộc khác: nền độc lập dân tộc",
    example: "nền độc lập dân tộc",
  },
  {
    word: "độc mộc",
    part_of_speech: "danh từ",
    meaning:
      "thuyền dài và hẹp, làm bằng một cây gỗ to khoét trũng xuống: thuyền độc mộc",
    example: "thuyền độc mộc",
  },
  {
    word: "độc nhất",
    part_of_speech: "tính từ",
    meaning:
      "chỉ có một, không có người hoặc cái thứ hai: đứa con độc nhất * niềm hi vọng độc nhất",
    example: "đứa con độc nhất * niềm hi vọng độc nhất",
  },
  {
    word: "độc quyền",
    part_of_speech: "danh từ",
    meaning:
      "đặc quyền chiếm giữ một mình: giữ độc quyền cung cấp sản phẩm * ngân hàng nhà nước giữ độc quyền phát hành tiền tệ",
    example:
      "giữ độc quyền cung cấp sản phẩm * ngân hàng nhà nước giữ độc quyền phát hành tiền tệ",
  },
  {
    word: "độc quyền",
    part_of_speech: "tính từ",
    meaning: "có độc quyền: đại lí độc quyền",
    example: "đại lí độc quyền",
  },
  {
    word: "độc tài",
    part_of_speech: "tính từ",
    meaning:
      "(chế độ chính trị) chỉ do một người hay một nhóm người nắm tất cả quyền hành, tự mình quyết định mọi việc, dựa trên bạo lực: chế độ độc tài * kẻ độc tài",
    example: "chế độ độc tài * kẻ độc tài",
  },
  {
    word: "đốc suất",
    part_of_speech: "động từ",
    meaning: "điều khiển và đôn đốc: đốc suất dân công đắp đê",
    example: "đốc suất dân công đắp đê",
  },
  {
    word: "độc thoại",
    part_of_speech: "động từ",
    meaning:
      "nói một mình; phân biệt với đối thoại: đoạn độc thoại trong vở kịch",
    example: "đoạn độc thoại trong vở kịch",
  },
  {
    word: "độc thân",
    part_of_speech: "tính từ",
    meaning:
      "chỉ sống một mình, không lập gia đình: sống độc thân * gần bốn mươi tuổi rồi mà còn độc thân",
    example: "sống độc thân * gần bốn mươi tuổi rồi mà còn độc thân",
  },
  {
    word: "độc thân",
    part_of_speech: "tính từ",
    meaning: "chỉ sống một mình, không sống cùng gia đình: hộ độc thân",
    example: "hộ độc thân",
  },
  {
    word: "độc tấu",
    part_of_speech: "động từ",
    meaning:
      "biểu diễn âm nhạc một mình, thường chỉ dùng một nhạc cụ: độc tấu đàn guitar * độc tấu sáo",
    example: "độc tấu đàn guitar * độc tấu sáo",
  },
  {
    word: "độc tấu",
    part_of_speech: "động từ",
    meaning: "trình diễn bài độc tấu: độc tấu một bài vè",
    example: "độc tấu một bài vè",
  },
  {
    word: "đốc thúc",
    part_of_speech: "động từ",
    meaning:
      "thúc giục, nhắc nhở để công việc không bị gián đoạn hoặc chậm trễ: đốc thúc việc canh phòng * đốc thúc để đẩy nhanh tiến độ",
    example: "đốc thúc việc canh phòng * đốc thúc để đẩy nhanh tiến độ",
  },
  {
    word: "độc thủ",
    part_of_speech: "danh từ",
    meaning: "thủ đoạn, miếng đòn hiểm ác hại người: ngón độc thủ * hạ độc thủ",
    example: "ngón độc thủ * hạ độc thủ",
  },
  {
    word: "độc tính",
    part_of_speech: "danh từ",
    meaning:
      "tính chất độc hại đối với cơ thể: thuốc kháng sinh thường có độc tính cao",
    example: "thuốc kháng sinh thường có độc tính cao",
  },
  {
    word: "độc tôn",
    part_of_speech: "tính từ",
    meaning: "chỉ riêng một mình được tôn sùng: chiếm vị trí độc tôn",
    example: "chiếm vị trí độc tôn",
  },
  {
    word: "đốc tờ",
    part_of_speech: "danh từ",
    meaning: "(cũ, khẩu ngữ) bác sĩ y khoa: mời đốc tờ đến thăm bệnh",
    example: "mời đốc tờ đến thăm bệnh",
  },
  {
    word: "độc tố",
    part_of_speech: "danh từ",
    meaning: "chất độc do vi khuẩn gây bệnh tiết ra: hàm lượng độc tố cao",
    example: "hàm lượng độc tố cao",
  },
  {
    word: "đồi",
    part_of_speech: "danh từ",
    meaning:
      "dạng địa hình lồi, có sườn thoải, thường không cao quá 200 mét: đồi trọc * đồi hoang",
    example: "đồi trọc * đồi hoang",
  },
  {
    word: "đồi bại",
    part_of_speech: "tính từ",
    meaning:
      "xấu xa, hư hỏng đến mức tồi tệ (về mặt đạo đức, tinh thần): tư tưởng đồi bại * lối sống đồi bại",
    example: "tư tưởng đồi bại * lối sống đồi bại",
  },
  {
    word: "đôi",
    part_of_speech: "danh từ",
    meaning: "tập hợp gồm===== hai: một đôi đũa * đôi dép * đôi bạn cùng tiến",
    example: "một đôi đũa * đôi dép * đôi bạn cùng tiến",
  },
  {
    word: "đôi",
    part_of_speech: "danh từ",
    meaning:
      "hai: đôi bên * đi hàng đôi * “Vội về thêm lấy của nhà, Xuyến vàng đôi chiếc, khăn là một vuông.” (TKiều) * đôi khi",
    example:
      "đôi bên * đi hàng đôi * “Vội về thêm lấy của nhà, Xuyến vàng đôi chiếc, khăn là một vuông.” (TKiều) * đôi khi",
  },
  {
    word: "đôi",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) ném: đôi đá",
    example: "đôi đá",
  },
  {
    word: "độc vận",
    part_of_speech: "tính từ",
    meaning: "(văn vần) chỉ dùng một vần trong cả bài: thơ độc vận",
    example: "thơ độc vận",
  },
  {
    word: "đối",
    part_of_speech: "động từ",
    meaning: "chống lại, chọi lại: tên lửa đất đối không",
    example: "tên lửa đất đối không",
  },
  {
    word: "đối",
    part_of_speech: "động từ",
    meaning:
      "(hai vật cùng loại) ở vị trí ngay trước mặt nhau, thành thế cân xứng, tương xứng với nhau: lá mọc đối * ngồi đối mặt nhau * hai cái xe để đối đầu nhau",
    example: "lá mọc đối * ngồi đối mặt nhau * hai cái xe để đối đầu nhau",
  },
  {
    word: "đối",
    part_of_speech: "động từ",
    meaning:
      "(hai từ hoặc hai vế câu) cân xứng với nhau về nội dung, giống nhau về từ loại, trái nhau về thanh điệu bằng trắc và được đặt ở thế trên dưới ứng với nhau thành từng cặp (ở một số điểm quy định trong vế câu) để tạo nên một giá trị tu từ nhất định: đối nhau từng câu từng chữ * câu đối * ra vế đối",
    example: "đối nhau từng câu từng chữ * câu đối * ra vế đối",
  },
  {
    word: "đối",
    part_of_speech: "động từ",
    meaning:
      "xử sự với người, với việc theo những mối quan hệ nhất định: đối tốt với tất cả mọi người * đối nội, đối ngoại",
    example: "đối tốt với tất cả mọi người * đối nội, đối ngoại",
  },
  {
    word: "đỗi",
    part_of_speech: "danh từ",
    meaning: "mức: bực quá đỗi * nét mặt rất đỗi trang nghiêm",
    example: "bực quá đỗi * nét mặt rất đỗi trang nghiêm",
  },
  {
    word: "đỗi",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) bờ ruộng: phát đỗi đắp bờ",
    example: "phát đỗi đắp bờ",
  },
  {
    word: "đỗi",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như nỗi: nếu cậu mà nói sớm thì đâu đến đỗi!",
    example: "nếu cậu mà nói sớm thì đâu đến đỗi!",
  },
  {
    word: "đội",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức chặt chẽ gồm một số người nhất định cùng làm một nhiệm vụ: đội du kích Bắc Sơn * đội kèn * đội tuyển quốc gia",
    example: "đội du kích Bắc Sơn * đội kèn * đội tuyển quốc gia",
  },
  {
    word: "đội",
    part_of_speech: "danh từ",
    meaning:
      "(thường viết hoa) Đội thiếu niên tiền phong Hồ Chí Minh (nói tắt): được kết nạp vào Đội * đi sinh hoạt Đội",
    example: "được kết nạp vào Đội * đi sinh hoạt Đội",
  },
  {
    word: "đội",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) chức vụ trong quân đội thời Pháp thuộc, tương đương tiểu đội trưởng: viên đội khố đỏ",
    example: "viên đội khố đỏ",
  },
  {
    word: "đội",
    part_of_speech: "động từ",
    meaning:
      "mang trên đầu: đội mũ * đội thúng gạo * đầu đội trời, chân đạp đất (tng)",
    example: "đội mũ * đội thúng gạo * đầu đội trời, chân đạp đất (tng)",
  },
  {
    word: "đội",
    part_of_speech: "động từ",
    meaning:
      "đỡ và nâng lên bằng đầu: đội nắp hầm chui lên * đội đá vá trời (tng)",
    example: "đội nắp hầm chui lên * đội đá vá trời (tng)",
  },
  {
    word: "đổi chác",
    part_of_speech: "động từ",
    meaning:
      "đổi cái mình có để lấy cái người khác có (nói khái quát): đổi chác hàng hoá",
    example: "đổi chác hàng hoá",
  },
  {
    word: "đổi",
    part_of_speech: "động từ",
    meaning:
      "đưa cái mình có để lấy cái người khác có, theo thoả thuận giữa hai bên: đổi tiền lẻ * đổi gạo lấy muối * đổi bát mồ hôi lấy miếng cơm (b)",
    example:
      "đổi tiền lẻ * đổi gạo lấy muối * đổi bát mồ hôi lấy miếng cơm (b)",
  },
  {
    word: "đổi",
    part_of_speech: "động từ",
    meaning: "thay bằng cái khác: đổi số điện thoại * đổi tên",
    example: "đổi số điện thoại * đổi tên",
  },
  {
    word: "đổi",
    part_of_speech: "động từ",
    meaning:
      "biến chuyển từ trạng thái, tính chất này sang trạng thái, tính chất khác: tình hình đã đổi khác * đổi tính đổi nết * đổi giận làm lành * trời đổi gió",
    example:
      "tình hình đã đổi khác * đổi tính đổi nết * đổi giận làm lành * trời đổi gió",
  },
  {
    word: "đổi",
    part_of_speech: "động từ",
    meaning: "chuyển đi làm việc ở một nơi khác: đổi công tác",
    example: "đổi công tác",
  },
  {
    word: "đôi chút",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) như chút ít: gầy đi đôi chút * giữa hai người cũng có đôi chút tình cảm",
    example: "gầy đi đôi chút * giữa hai người cũng có đôi chút tình cảm",
  },
  {
    word: "đối chiếu",
    part_of_speech: "động từ",
    meaning:
      "so sánh cái này với cái kia (thường là cái dùng làm chuẩn) để từ những chỗ giống nhau và khác nhau mà biết được rõ hơn về đối tượng: đối chiếu bản dịch với nguyên tác * đối chiếu số liệu ở hai bản với nhau",
    example:
      "đối chiếu bản dịch với nguyên tác * đối chiếu số liệu ở hai bản với nhau",
  },
  {
    word: "đối chất",
    part_of_speech: "động từ",
    meaning:
      "hỏi cùng một lúc các bị can, đương sự hoặc những người làm chứng để so sánh, đối chiếu lời khai của họ: ra toà đối chất",
    example: "ra toà đối chất",
  },
  {
    word: "đối diện",
    part_of_speech: "động từ",
    meaning:
      "ở vị trí quay mặt vào nhau: hai toà nhà xây đối diện nhau * phía đối diện",
    example: "hai toà nhà xây đối diện nhau * phía đối diện",
  },
  {
    word: "đối diện",
    part_of_speech: "động từ",
    meaning: "như đối mặt: đối diện với đói nghèo và bệnh tật",
    example: "đối diện với đói nghèo và bệnh tật",
  },
  {
    word: "đối chọi",
    part_of_speech: "động từ",
    meaning:
      "chống lại nhau một cách trực tiếp và quyết liệt: hai bên đối chọi nhau",
    example: "hai bên đối chọi nhau",
  },
  {
    word: "đối chọi",
    part_of_speech: "động từ",
    meaning:
      "trái ngược nhau, không thể đi đôi với nhau: những màu sắc đối chọi nhau * hai quan điểm đối chọi",
    example: "những màu sắc đối chọi nhau * hai quan điểm đối chọi",
  },
  {
    word: "đổi dời",
    part_of_speech: "động từ",
    meaning:
      "(cũ) như dời đổi: “(...) Thương nhau quyết chẳng đổi dời lòng son.” (ca dao)",
    example: "“(...) Thương nhau quyết chẳng đổi dời lòng son.” (ca dao)",
  },
  {
    word: "đối chứng",
    part_of_speech: "động từ",
    meaning:
      "đối chất với người làm chứng: nếu không nhận, toà sẽ cho đối chứng",
    example: "nếu không nhận, toà sẽ cho đối chứng",
  },
  {
    word: "đối chứng",
    part_of_speech: "danh từ",
    meaning:
      "cây trồng, vật nuôi trong điều kiện bình thường, dùng làm căn cứ để so sánh, đối chiếu với cây trồng, vật nuôi đang thí nghiệm: ruộng đối chứng",
    example: "ruộng đối chứng",
  },
  {
    word: "đôi co",
    part_of_speech: "động từ",
    meaning:
      "cãi qua, cãi lại để giành phần đúng, để phân phải trái: đôi co mất thì giờ * hai người to tiếng đôi co với nhau",
    example: "đôi co mất thì giờ * hai người to tiếng đôi co với nhau",
  },
  {
    word: "đối đáp",
    part_of_speech: "động từ",
    meaning:
      'trả lời lại (nói khái quát): đối đáp đâu ra đấy * "Khôn ngoan đối đáp người ngoài, Gà cùng một mẹ chớ hoài đá nhau." (ca dao)',
    example:
      'đối đáp đâu ra đấy * "Khôn ngoan đối đáp người ngoài, Gà cùng một mẹ chớ hoài đá nhau." (ca dao)',
  },
  {
    word: "đối đãi",
    part_of_speech: "động từ",
    meaning:
      "đối xử với nhau trong sinh hoạt hằng ngày: được đối đãi tử tế * đối đãi với nhau như người nhà",
    example: "được đối đãi tử tế * đối đãi với nhau như người nhà",
  },
  {
    word: "đội giá",
    part_of_speech: "động từ",
    meaning:
      "làm cho giá thành bị đẩy lên cao trên mức bình thường hoặc mức dự tính: giá vật tư tăng đột ngột làm công trình bị đội giá",
    example: "giá vật tư tăng đột ngột làm công trình bị đội giá",
  },
  {
    word: "đối địch",
    part_of_speech: "động từ",
    meaning:
      "chống đối nhau quyết liệt, không thể dung hoà được: các phe phái đối địch nhau * tỏ thái độ đối địch",
    example: "các phe phái đối địch nhau * tỏ thái độ đối địch",
  },
  {
    word: "đổi đời",
    part_of_speech: "động từ",
    meaning:
      "thay đổi hẳn cuộc sống theo chiều hướng đi lên, trở nên sung sướng, giàu có: khát vọng đổi đời * giá đất tăng nhanh, nhiều gia đình được đổi đời",
    example:
      "khát vọng đổi đời * giá đất tăng nhanh, nhiều gia đình được đổi đời",
  },
  {
    word: "đôi hồi",
    part_of_speech: "động từ",
    meaning:
      '(hiếm) giãi bày, trò chuyện với nhau: "Sự đâu chưa kịp đôi hồi, Duyên đâu chưa kịp một lời trao tơ." (TKiều)',
    example:
      'Sự đâu chưa kịp đôi hồi, Duyên đâu chưa kịp một lời trao tơ." (TKiều)',
  },
  {
    word: "đôi hồi",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) cân nhắc, suy tính: đi ngay, không kịp đôi hồi đắn đo gì nữa",
    example: "đi ngay, không kịp đôi hồi đắn đo gì nữa",
  },
  {
    word: "đội hình",
    part_of_speech: "danh từ",
    meaning:
      "hình thức bố trí lực lượng trong trận đánh, trận đấu: chấn chỉnh lại đội hình * ra quân với đội hình 4-4-2 (trong bóng đá)",
    example:
      "chấn chỉnh lại đội hình * ra quân với đội hình 4-4-2 (trong bóng đá)",
  },
  {
    word: "đối kháng",
    part_of_speech: "động từ",
    meaning:
      "đối lập sâu sắc, một mất một còn, không thể dung hoà được với nhau: mâu thuẫn đối kháng * quan hệ đối kháng",
    example: "mâu thuẫn đối kháng * quan hệ đối kháng",
  },
  {
    word: "đối kháng",
    part_of_speech: "động từ",
    meaning:
      "phân định thắng thua bằng cách đối chọi trực tiếp với nhau: thi đấu đối kháng",
    example: "thi đấu đối kháng",
  },
  {
    word: "đối đầu",
    part_of_speech: "động từ",
    meaning:
      "trực tiếp chống lại nhau: đối đầu với kẻ thù * chuyển từ thế đối đầu sang đối thoại",
    example: "đối đầu với kẻ thù * chuyển từ thế đối đầu sang đối thoại",
  },
  {
    word: "đôi khi",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) có những lúc nào đó: đôi khi cũng thấy nhớ nhà * đôi khi cũng phải đi công tác",
    example: "đôi khi cũng thấy nhớ nhà * đôi khi cũng phải đi công tác",
  },
  {
    word: "đôi lứa",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương) đôi vợ chồng trẻ hoặc đôi trai gái yêu nhau: kết thành đôi lứa * tình yêu đôi lứa",
    example: "kết thành đôi lứa * tình yêu đôi lứa",
  },
  {
    word: "đội lốt",
    part_of_speech: "động từ",
    meaning:
      'mang danh nghĩa, hình thức bề ngoài nào đó để che giấu bản chất, hành động xấu xa, tội lỗi: "Gà lôi đội lốt con công, Tưởng rằng mình ngộ đi dông đi dài." (ca dao)',
    example:
      'Gà lôi đội lốt con công, Tưởng rằng mình ngộ đi dông đi dài." (ca dao)',
  },
  {
    word: "đối lập",
    part_of_speech: "động từ",
    meaning:
      "đứng ở phía trái ngược, có quan hệ chống đối nhau: quan điểm đối lập * các phái đối lập",
    example: "quan điểm đối lập * các phái đối lập",
  },
  {
    word: "đổi mới",
    part_of_speech: "động từ",
    meaning:
      "thay đổi hoặc làm cho thay đổi tốt hơn, tiến bộ hơn so với trước, đáp ứng yêu cầu của sự phát triển: đổi mới tư duy * đổi mới cách thức làm việc",
    example: "đổi mới tư duy * đổi mới cách thức làm việc",
  },
  {
    word: "đổi mới",
    part_of_speech: "danh từ",
    meaning:
      "điều thay đổi theo hướng tốt hơn, tiến bộ hơn so với trước: cuộc sống có nhiều đổi mới * nắm bắt những đổi mới về công nghệ",
    example: "cuộc sống có nhiều đổi mới * nắm bắt những đổi mới về công nghệ",
  },
  {
    word: "đối lưu",
    part_of_speech: "động từ",
    meaning:
      "(hiện tượng) truyền nhiệt do sự chuyển dịch vật chất thành dòng trong môi trường lỏng, khí hoặc các chất ở thể tản rời.",
    example: "hàng đối lưu * bán đối lưu",
  },
  {
    word: "đôi mươi",
    part_of_speech: "danh từ",
    meaning:
      "(tuổi) trên dưới hai mươi; thường dùng với ý đang ở độ tuổi đẹp nhất và sung sức nhất: lứa tuổi đôi mươi",
    example: "lứa tuổi đôi mươi",
  },
  {
    word: "đối mặt",
    part_of_speech: "động từ",
    meaning:
      "đứng ngay trước một trở ngại, khó khăn hoặc nguy hiểm nào đó và phải trực tiếp đối phó lại: đối mặt với tử thần * đối mặt với kẻ thù",
    example: "đối mặt với tử thần * đối mặt với kẻ thù",
  },
  {
    word: "đồi mồi",
    part_of_speech: "danh từ",
    meaning:
      "rùa biển, mai có vân đẹp, dùng làm đồ mĩ nghệ: lược đồi mồi * vòng tay làm bằng đồi mồi",
    example: "lược đồi mồi * vòng tay làm bằng đồi mồi",
  },
  {
    word: "đối ngẫu",
    part_of_speech: "động từ",
    meaning:
      "đối nhau về lời và ý theo từng cặp, trong văn biền ngẫu: phép đối ngẫu",
    example: "phép đối ngẫu",
  },
  {
    word: "đối nghịch",
    part_of_speech: "tính từ",
    meaning: "trái ngược lại, chống đối lại nhau: hai quan điểm đối nghịch",
    example: "hai quan điểm đối nghịch",
  },
  {
    word: "đối ngoại",
    part_of_speech: "động từ",
    meaning:
      "đối với nước ngoài, bên ngoài (nói về đường lối, chính sách, sự giao thiệp của nhà nước, của một tổ chức); phân biệt với đối nội: công tác đối ngoại * chính sách đối ngoại",
    example: "công tác đối ngoại * chính sách đối ngoại",
  },
  {
    word: "đội ngũ",
    part_of_speech: "danh từ",
    meaning:
      "khối đông người được tập hợp và tổ chức thành một lực lượng có quy củ: đội ngũ chỉnh tề * chỉnh đốn đội ngũ",
    example: "đội ngũ chỉnh tề * chỉnh đốn đội ngũ",
  },
  {
    word: "đội ngũ",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp một số đông người có cùng chức năng hoặc nghề nghiệp: đội ngũ cán bộ * đội ngũ những cây viết trẻ",
    example: "đội ngũ cán bộ * đội ngũ những cây viết trẻ",
  },
  {
    word: "đối phó",
    part_of_speech: "động từ",
    meaning:
      "có hành động đáp lại tình thế bất lợi để tránh cho mình điều không hay: sẵn sàng đối phó với bão lụt",
    example: "sẵn sàng đối phó với bão lụt",
  },
  {
    word: "đối phó",
    part_of_speech: "động từ",
    meaning:
      "có hành động mang tính né tránh, chỉ cốt cho xong chuyện: trả lời đối phó * làm báo cáo theo kiểu đối phó",
    example: "trả lời đối phó * làm báo cáo theo kiểu đối phó",
  },
  {
    word: "đối nội",
    part_of_speech: "động từ",
    meaning:
      "đối với trong nước, trong nội bộ (nói về đường lối, chính sách của nhà nước, của một tổ chức); phân biệt với đối ngoại: công tác đối nội",
    example: "công tác đối nội",
  },
  {
    word: "đối nhân xử thế",
    part_of_speech: "",
    meaning: "đối xử với mọi người ở đời: biết cách đối nhân xử thế",
    example: "biết cách đối nhân xử thế",
  },
  {
    word: "đội ơn",
    part_of_speech: "động từ",
    meaning:
      "(cũ) mang nặng ơn (thường dùng để biểu thị lòng biết ơn sâu sắc đối với người trên): xin đội ơn ngài đã cứu giúp",
    example: "xin đội ơn ngài đã cứu giúp",
  },
  {
    word: "đối phương",
    part_of_speech: "danh từ",
    meaning:
      "phía chống đối lại mình: lọt vào trận địa mai phục của đối phương",
    example: "lọt vào trận địa mai phục của đối phương",
  },
  {
    word: "đối phương",
    part_of_speech: "danh từ",
    meaning:
      "phía, người đương đầu với mình để tranh được thua (thường trong trò chơi hay trong thi đấu): sút tung lưới đối phương * thăm dò đối phương trước khi đấu thầu",
    example: "sút tung lưới đối phương * thăm dò đối phương trước khi đấu thầu",
  },
  {
    word: "đồi tệ",
    part_of_speech: "tính từ",
    meaning: "(cũ, hiếm) như đồi bại: hành vi xấu xa, đồi tệ",
    example: "hành vi xấu xa, đồi tệ",
  },
  {
    word: "đội sổ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) có tên ở dưới cùng trong danh sách xếp thứ bậc; ở hạng thấp nhất: học kém nên năm nào cũng đội sổ * xếp đội sổ",
    example: "học kém nên năm nào cũng đội sổ * xếp đội sổ",
  },
  {
    word: "đối sánh",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) so sánh giữa hai bên: lực lượng đối sánh giữa hai phe là ngang bằng",
    example: "lực lượng đối sánh giữa hai phe là ngang bằng",
  },
  {
    word: "đối tác",
    part_of_speech: "danh từ",
    meaning:
      "đối tượng hợp tác (trong công việc): tìm đối tác kinh doanh * đối tác đầu tư",
    example: "tìm đối tác kinh doanh * đối tác đầu tư",
  },
  {
    word: "đối sách",
    part_of_speech: "danh từ",
    meaning:
      "cách thức, biện pháp để đối phó: bàn bạc để đưa ra những đối sách hợp lí nhất",
    example: "bàn bạc để đưa ra những đối sách hợp lí nhất",
  },
  {
    word: "đối số",
    part_of_speech: "danh từ",
    meaning:
      "biến số được coi như biến thiên độc lập trong một tương quan hàm số: đối số của hàm số y = cos x là x",
    example: "đối số của hàm số y = cos x là x",
  },
  {
    word: "đồi truỵ",
    part_of_speech: "tính từ",
    meaning: "truỵ lạc và suy đồi: văn hoá phẩm đồi truỵ * lối sống đồi truỵ",
    example: "văn hoá phẩm đồi truỵ * lối sống đồi truỵ",
  },
  {
    word: "đổi thay",
    part_of_speech: "động từ",
    meaning:
      'biến đổi thành khác với trước: thời thế đổi thay * "Lời yêu mỏng mảnh như màu khói, Ai biết lòng anh có đổi thay?" (XQuỳnh; 3)',
    example:
      'thời thế đổi thay * "Lời yêu mỏng mảnh như màu khói, Ai biết lòng anh có đổi thay?" (XQuỳnh; 3)',
  },
  {
    word: "đối thoại",
    part_of_speech: "động từ",
    meaning:
      "nói chuyện qua lại giữa hai hay nhiều người với nhau: cuộc đối thoại tay ba * học thuộc đoạn đối thoại trong kịch bản",
    example: "cuộc đối thoại tay ba * học thuộc đoạn đối thoại trong kịch bản",
  },
  {
    word: "đối thoại",
    part_of_speech: "động từ",
    meaning:
      "bàn bạc, thương lượng trực tiếp giữa hai hay nhiều bên để giải quyết các vấn đề cùng quan tâm: chuyển từ đối đầu sang đối thoại * đối thoại chính trị",
    example: "chuyển từ đối đầu sang đối thoại * đối thoại chính trị",
  },
  {
    word: "đối thủ",
    part_of_speech: "danh từ",
    meaning:
      "người đương đầu với mình để tranh được thua: hạ đo ván đối thủ * không có ai là đối thủ",
    example: "hạ đo ván đối thủ * không có ai là đối thủ",
  },
  {
    word: "đổi trắng thay đen",
    part_of_speech: "",
    meaning:
      'làm đảo lộn trắng đen, phải trái (biến tốt thành xấu, xấu thành tốt): "Trong tay đã sẵn đồng tiền, Dầu lòng đổi trắng thay đen khó gì!" (TKiều)',
    example:
      'Trong tay đã sẵn đồng tiền, Dầu lòng đổi trắng thay đen khó gì!" (TKiều)',
  },
  {
    word: "đội trời đạp đất",
    part_of_speech: "",
    meaning:
      'ví lối sống và hành động hết sức tự do, ngang tàng, không thừa nhận bất cứ một uy quyền nào trên đời: "Đội trời đạp đất ở đời, Họ Từ, tên Hải, vốn người Việt Đông." (TKiều)',
    example:
      'Đội trời đạp đất ở đời, Họ Từ, tên Hải, vốn người Việt Đông." (TKiều)',
  },
  {
    word: "đội tuyển",
    part_of_speech: "danh từ",
    meaning:
      "đội gồm những người xuất sắc nhất được chọn ra để dự thi, thi đấu: đội tuyển bóng đá * đội tuyển học sinh giỏi",
    example: "đội tuyển bóng đá * đội tuyển học sinh giỏi",
  },
  {
    word: "đối ứng",
    part_of_speech: "động từ",
    meaning:
      "tương đương nhau trong một phép biến đổi: hai cạnh đối ứng của tam giác đồng dạng * tài khoản đối ứng",
    example: "hai cạnh đối ứng của tam giác đồng dạng * tài khoản đối ứng",
  },
  {
    word: "đối tượng",
    part_of_speech: "danh từ",
    meaning:
      "người, vật, hiện tượng mà con người tác động tới (trong suy nghĩ, hành động): đối tượng nghiên cứu * đối tượng khảo sát",
    example: "đối tượng nghiên cứu * đối tượng khảo sát",
  },
  {
    word: "đối tượng",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) người đang được tìm hiểu để kết nạp vào một tổ chức: anh ấy đang thuộc diện đối tượng Đảng",
    example: "anh ấy đang thuộc diện đối tượng Đảng",
  },
  {
    word: "đối tượng",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) người đang hoặc định sẽ tìm hiểu trước khi yêu hoặc kết hôn: chọn đối tượng",
    example: "chọn đối tượng",
  },
  {
    word: "đối với",
    part_of_speech: "kết từ",
    meaning:
      "tổ hợp biểu thị người hoặc sự vật, sự việc sắp nêu ra là đối tượng hoặc phạm vi của điều được nói đến: tình cảm đối với quê hương đất nước * biết giữ lễ độ đối với người trên",
    example:
      "tình cảm đối với quê hương đất nước * biết giữ lễ độ đối với người trên",
  },
  {
    word: "đối với",
    part_of_speech: "kết từ",
    meaning:
      "tổ hợp biểu thị người sắp nêu ra là đối tượng có quan hệ trực tiếp với điều được nói đến: đối với ông ta, việc ấy đâu có gì khó",
    example: "đối với ông ta, việc ấy đâu có gì khó",
  },
  {
    word: "đội viên",
    part_of_speech: "danh từ",
    meaning:
      "người ở trong tổ chức của một đội: đội viên đội dân phòng * đội viên gương mẫu * đội viên đội tự vệ",
    example: "đội viên đội dân phòng * đội viên gương mẫu * đội viên đội tự vệ",
  },
  {
    word: "đội viên",
    part_of_speech: "danh từ",
    meaning:
      "đội viên Đội thiếu niên tiền phong Hồ Chí Minh (nói tắt): khăn quàng đội viên * trở thành đội viên",
    example: "khăn quàng đội viên * trở thành đội viên",
  },
  {
    word: "đội viên",
    part_of_speech: "danh từ",
    meaning: "(cũ) như chiến sĩ: đội viên du kích",
    example: "đội viên du kích",
  },
  {
    word: "đội trưởng",
    part_of_speech: "danh từ",
    meaning: "người đứng đầu chỉ huy một đội: đội trưởng đội bóng",
    example: "đội trưởng đội bóng",
  },
  {
    word: "đốm",
    part_of_speech: "danh từ",
    meaning: "chấm sáng nhỏ hiện ra trên nền tối: đốm lửa lập loè",
    example: "đốm lửa lập loè",
  },
  {
    word: "đốm",
    part_of_speech: "danh từ",
    meaning:
      "chấm nhỏ nổi lên trên một nền khác màu: con chó có đốm trắng ở đầu * trên lá có nhiều đốm",
    example: "con chó có đốm trắng ở đầu * trên lá có nhiều đốm",
  },
  {
    word: "đốm",
    part_of_speech: "tính từ",
    meaning:
      "(tóc, lông) có nhiều chấm khác màu xen vào: mái tóc đã đốm bạc * lợn đốm * con chó đốm",
    example: "mái tóc đã đốm bạc * lợn đốm * con chó đốm",
  },
  {
    word: "đội xếp",
    part_of_speech: "danh từ",
    meaning: "(cũ, khẩu ngữ) cảnh sát thời Pháp thuộc: bị đội xếp bắt",
    example: "bị đội xếp bắt",
  },
  {
    word: "đối xử",
    part_of_speech: "động từ",
    meaning:
      "thể hiện thái độ, quan hệ với người nào đó bằng những lời nói, hành động cụ thể: đối xử không công bằng * đối xử chu đáo với bạn bè",
    example: "đối xử không công bằng * đối xử chu đáo với bạn bè",
  },
  {
    word: "đối xứng",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất trùng với chính nó qua một trục, một điểm hoặc một mặt phẳng: điểm A có toạ độ (0; 2) đối xứng với điểm A",
    example: "điểm A có toạ độ (0; 2) đối xứng với điểm A",
  },
  {
    word: "đối xứng",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất của một quan hệ trong đó nếu a quan hệ với b thì b cũng quan hệ với a: quan hệ  *  giữa các số là quan hệ không đối xứng",
    example: "quan hệ  *  giữa các số là quan hệ không đối xứng",
  },
  {
    word: "đồm độp",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng trầm và gọn như tiếng vật nặng, nhỏ và hơi mềm rơi mạnh và liên tiếp xuống đất: mưa rơi đồm độp * vỗ đồm độp vào lưng nhau",
    example: "mưa rơi đồm độp * vỗ đồm độp vào lưng nhau",
  },
  {
    word: "đôm đốp",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng to, đanh và giòn phát ra liên tiếp: tiếng vỗ tay đôm đốp",
    example: "tiếng vỗ tay đôm đốp",
  },
  {
    word: "đốn",
    part_of_speech: "động từ",
    meaning:
      "làm đứt thân cây, cành cây (thường với số lượng nhiều) bằng vật sắc, để lấy gỗ, lấy củi: đốn tre * đốn củi * vào rừng đốn gỗ",
    example: "đốn tre * đốn củi * vào rừng đốn gỗ",
  },
  {
    word: "đốn",
    part_of_speech: "động từ",
    meaning: "chặt bớt cành cho cây ra nhánh mới: ngọn xà cừ bị đốn cụt",
    example: "ngọn xà cừ bị đốn cụt",
  },
  {
    word: "đốn",
    part_of_speech: "tính từ",
    meaning: "(Khẩu ngữ) hư hỏng, tồi tệ: đổ đốn * thằng bé càng ngày càng đốn",
    example: "đổ đốn * thằng bé càng ngày càng đốn",
  },
  {
    word: "đôn",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ, khẩu ngữ) đưa cho cao lên hoặc cho nhiều thêm: đôn cao giá * từ vị trí trưởng phòng được đôn lên làm giám đốc",
    example: "đôn cao giá * từ vị trí trưởng phòng được đôn lên làm giám đốc",
  },
  {
    word: "đồn",
    part_of_speech: "danh từ",
    meaning: "vị trí đóng quân, to hơn bốt: phá đồn địch",
    example: "phá đồn địch",
  },
  {
    word: "đồn",
    part_of_speech: "danh từ",
    meaning:
      "nơi tổ chức cơ sở của công an hay bộ đội đóng và làm việc: đồn công an * đồn biên phòng",
    example: "đồn công an * đồn biên phòng",
  },
  {
    word: "đồn",
    part_of_speech: "động từ",
    meaning:
      "truyền miệng cho nhau làm lan rộng tin không ai biết từ đâu ra: nghe đồn * tung tin đồn nhảm",
    example: "nghe đồn * tung tin đồn nhảm",
  },
  {
    word: "đồn bót",
    part_of_speech: "danh từ",
    meaning:
      "đồn, bốt đóng quân của quân đội thực dân (nói khái quát): tấn công vào các đồn bốt của địch",
    example: "tấn công vào các đồn bốt của địch",
  },
  {
    word: "độn",
    part_of_speech: "động từ",
    meaning:
      "nhồi, lót vào bên trong cho chặt, cho căng: gối độn bông * mặc độn thêm áo vào bên trong cho ấm",
    example: "gối độn bông * mặc độn thêm áo vào bên trong cho ấm",
  },
  {
    word: "độn",
    part_of_speech: "động từ",
    meaning:
      "trộn lẫn thêm lương thực phụ, như ngô, khoai, sắn, v.v., để nấu với cơm: cơm độn ngô",
    example: "cơm độn ngô",
  },
  {
    word: "độn",
    part_of_speech: "danh từ",
    meaning: "vật được làm sẵn để độn vào bên trong: độn tóc * áo có độn vai",
    example: "độn tóc * áo có độn vai",
  },
  {
    word: "độn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) chậm chạp về nhận thức, thiếu trí khôn: ngồi độn mặt ra * người trông thế mà độn",
    example: "ngồi độn mặt ra * người trông thế mà độn",
  },
  {
    word: "đồn bốt",
    part_of_speech: "danh từ",
    meaning:
      "đồn, bốt đóng quân của quân đội thực dân (nói khái quát): tấn công vào các đồn bốt của địch",
    example: "tấn công vào các đồn bốt của địch",
  },
  {
    word: "đôn đốc",
    part_of_speech: "động từ",
    meaning:
      "theo sát để nhắc nhở, làm cho công việc, hoạt động được tiến triển mạnh hơn theo một hướng nhất định nào đó, thường là hướng tốt: đôn đốc mọi người làm việc * kiểm tra đôn đốc con cái học hành",
    example: "đôn đốc mọi người làm việc * kiểm tra đôn đốc con cái học hành",
  },
  {
    word: "đồn điền",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) vùng đất do binh lính hoặc chiêu mộ nông dân khai khẩn, trồng trọt dưới chế độ phong kiến.",
    example: "đồn điền cao su * chủ đồn điền",
  },
  {
    word: "đồn đại",
    part_of_speech: "động từ",
    meaning:
      '(khẩu ngữ) đồn rộng ra, thường là tin không chính xác (nói khái quát): không tin vào lời đồn đại * "Sự lòng ngỏ với băng nhân, Tin sương đồn đại xa gần xôn xao." (TKiều)',
    example:
      'không tin vào lời đồn đại * "Sự lòng ngỏ với băng nhân, Tin sương đồn đại xa gần xôn xao." (TKiều)',
  },
  {
    word: "đôn đáo",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) hoạt động một cách năng nổ, tích cực để thúc đẩy công việc: đôn đáo lo công việc * chạy đôn chạy đáo",
    example: "đôn đáo lo công việc * chạy đôn chạy đáo",
  },
  {
    word: "đốn mạt",
    part_of_speech: "tính từ",
    meaning:
      "hư hỏng, tồi tệ đến mức đáng nguyền rủa: kẻ đốn mạt! * làm trò đốn mạt",
    example: "kẻ đốn mạt! * làm trò đốn mạt",
  },
  {
    word: "đôn hậu",
    part_of_speech: "tính từ",
    meaning: "hiền từ và nhân hậu: nụ cười đôn hậu * vẻ mặt đôn hậu",
    example: "nụ cười đôn hậu * vẻ mặt đôn hậu",
  },
  {
    word: "đồn luỹ",
    part_of_speech: "danh từ",
    meaning:
      "vị trí quân sự có công sự và thành hào vững chắc bảo vệ (nói khái quát): hệ thống đồn luỹ kiên cố",
    example: "hệ thống đồn luỹ kiên cố",
  },
  {
    word: "độn thuỷ",
    part_of_speech: "động từ",
    meaning:
      "giấu quân dưới mặt nước để bất ngờ đánh địch: dùng cách đánh độn thuỷ",
    example: "dùng cách đánh độn thuỷ",
  },
  {
    word: "độn thổ",
    part_of_speech: "động từ",
    meaning:
      "(nhân vật trong truyện thần thoại) chui xuống đất để đi dưới mặt đất: phép độn thổ * ngượng đến muốn độn thổ",
    example: "phép độn thổ * ngượng đến muốn độn thổ",
  },
  {
    word: "độn thổ",
    part_of_speech: "động từ",
    meaning: "giấu quân ở hầm dưới mặt đất để bất ngờ đánh địch: đánh độn thổ",
    example: "đánh độn thổ",
  },
  {
    word: "đồn thổi",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đồn rất nhanh từ miệng người này qua miệng người khác, thường thổi phồng lên quá mức: lời đồn thổi",
    example: "lời đồn thổi",
  },
  {
    word: "đồn trưởng",
    part_of_speech: "danh từ",
    meaning: "sĩ quan chỉ huy một đồn: đồn trưởng đồn biên phòng",
    example: "đồn trưởng đồn biên phòng",
  },
  {
    word: "đông",
    part_of_speech: "danh từ",
    meaning:
      "một trong bốn phương chính, ở về phía mặt trời mọc, đối lập với phương tây: nhà hướng đông * gió mùa đông - bắc * mặt trời mọc đằng đông",
    example: "nhà hướng đông * gió mùa đông - bắc * mặt trời mọc đằng đông",
  },
  {
    word: "đông",
    part_of_speech: "danh từ",
    meaning:
      "(thường viết hoa) những nước thuộc phương Đông, trong quan hệ với các nước thuộc phương Tây: quan hệ Đông - Tây",
    example: "quan hệ Đông - Tây",
  },
  {
    word: "đông",
    part_of_speech: "danh từ",
    meaning:
      "mùa lạnh nhất trong bốn mùa của một năm, sau mùa thu: mùa đông * ngày đông tháng giá * đông qua xuân tới",
    example: "mùa đông * ngày đông tháng giá * đông qua xuân tới",
  },
  {
    word: "đông",
    part_of_speech: "danh từ",
    meaning:
      '(văn chương) năm, thuộc về quá khứ: "Một lời đã được mấy đông, Thuyền quyên sầu một, anh hùng sầu hai." (Cdao)',
    example:
      'Một lời đã được mấy đông, Thuyền quyên sầu một, anh hùng sầu hai." (Cdao)',
  },
  {
    word: "đông",
    part_of_speech: "động từ",
    meaning:
      "chuyển từ trạng thái lỏng sang trạng thái rắn: nước đông lại thành băng * thịt nấu đông * mỡ đông * máu không đông",
    example:
      "nước đông lại thành băng * thịt nấu đông * mỡ đông * máu không đông",
  },
  {
    word: "đông",
    part_of_speech: "tính từ",
    meaning:
      "có rất nhiều người tụ tập lại cùng một lúc, một nơi: người xe rất đông * đất chật người đông * của không ngon, nhà đông con cũng hết (tng)",
    example:
      "người xe rất đông * đất chật người đông * của không ngon, nhà đông con cũng hết (tng)",
  },
  {
    word: "đống",
    part_of_speech: "danh từ",
    meaning:
      "khối nhiều vật để chồng chất lên nhau ở một chỗ: đống rạ * đống gỗ * quần áo để chất đống, không giặt",
    example: "đống rạ * đống gỗ * quần áo để chất đống, không giặt",
  },
  {
    word: "đống",
    part_of_speech: "danh từ",
    meaning:
      "chỗ đất nổi lên cao hơn so với xung quanh: khắp nơi, chỗ nào cũng thấy gò, đống * đống mối (đống nổi cao do mối đùn)",
    example:
      "khắp nơi, chỗ nào cũng thấy gò, đống * đống mối (đống nổi cao do mối đùn)",
  },
  {
    word: "đống",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) số lượng được coi là quá nhiều, tựa như có thể chồng chất lên nhau thành một khối: còn hàng đống việc chưa làm * mất cả đống tiền mới được như thế * con đàn cháu đống",
    example:
      "còn hàng đống việc chưa làm * mất cả đống tiền mới được như thế * con đàn cháu đống",
  },
  {
    word: "đổng",
    part_of_speech: "phụ từ",
    meaning:
      "(lối chửi, lối nói) lớn tiếng, ra vẻ không coi ai ra gì, nhưng lại chỉ ám chỉ vu vơ, không nhằm vào một đối tượng cụ thể nào: nói đổng * tức quá, chửi đổng mấy câu",
    example: "nói đổng * tức quá, chửi đổng mấy câu",
  },
  {
    word: "động",
    part_of_speech: "danh từ",
    meaning:
      "hang rộng ăn sâu vào trong núi: động Hương Tích * núi đá vôi có nhiều động",
    example: "động Hương Tích * núi đá vôi có nhiều động",
  },
  {
    word: "động",
    part_of_speech: "danh từ",
    meaning:
      "xóm của một số dân tộc thiểu số ở miền Bắc Việt Nam: động của người Dao",
    example: "động của người Dao",
  },
  {
    word: "động",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) nơi tụ tập và hoạt động phi pháp của những kẻ chơi bời, mại dâm, nghiện hút, v.v.: động lắc * phá các động mại dâm",
    example: "động lắc * phá các động mại dâm",
  },
  {
    word: "động",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) dải đồi cát rộng và không cao lắm, thường ở vùng ven biển: động cát trắng xoá",
    example: "động cát trắng xoá",
  },
  {
    word: "động",
    part_of_speech: "động từ",
    meaning:
      "xê dịch phần nào vị trí trong không gian: ngồi yên không dám động * gió thổi động cành lá",
    example: "ngồi yên không dám động * gió thổi động cành lá",
  },
  {
    word: "động",
    part_of_speech: "động từ",
    meaning:
      "luôn thay đổi vị trí, hình dáng, trạng thái hoặc tính chất theo thời gian: trạng thái động * công việc có tính chất động",
    example: "trạng thái động * công việc có tính chất động",
  },
  {
    word: "động",
    part_of_speech: "động từ",
    meaning:
      "(hiện tượng thiên nhiên) có những biến đổi mạnh về trạng thái: biển động dữ dội * động rừng * động trời",
    example: "biển động dữ dội * động rừng * động trời",
  },
  {
    word: "động",
    part_of_speech: "động từ",
    meaning:
      "có dấu hiệu không bình thường cho thấy tình hình không yên ổn, cần đề phòng, đối phó: thấy động, tên gian chuồn mất",
    example: "thấy động, tên gian chuồn mất",
  },
  {
    word: "động",
    part_of_speech: "động từ",
    meaning:
      "chạm vào, hoặc có quan hệ tác động trực tiếp: không ai dám nói động đến hắn * việc của tôi, đừng có ai động vào",
    example:
      "không ai dám nói động đến hắn * việc của tôi, đừng có ai động vào",
  },
  {
    word: "động",
    part_of_speech: "động từ",
    meaning: "làm cho hoạt động: nhà văn động bút",
    example: "nhà văn động bút",
  },
  {
    word: "động",
    part_of_speech: "kết từ",
    meaning:
      '(khẩu ngữ) từ biểu thị quan hệ nguyên nhân - hệ quả, cứ có một sự việc, hiện tượng này là xảy ra ngay sự việc, hiện tượng không hay nói liền sau đó: động làm cái gì là cằn nhằn * "Không vào nhà thì thôi, động vào nhà là nhòm. Mụ nhòm xó này một tí, nhòm xó kia một tí, rồi lục." (KLân; 5)',
    example:
      'động làm cái gì là cằn nhằn * "Không vào nhà thì thôi, động vào nhà là nhòm. Mụ nhòm xó này một tí, nhòm xó kia một tí, rồi lục." (KLân; 5)',
  },
  {
    word: "đồng âm",
    part_of_speech: "tính từ",
    meaning:
      "có cùng một vỏ ngữ âm, cùng một âm đọc như nhau: từ đồng âm * hai từ đồng âm nhưng khác nghĩa",
    example: "từ đồng âm * hai từ đồng âm nhưng khác nghĩa",
  },
  {
    word: "đồng",
    part_of_speech: "danh từ",
    meaning:
      "kim loại có màu đỏ, dễ dát mỏng và kéo sợi, dẫn điện và dẫn nhiệt rất tốt, thường dùng để làm dây điện và chế hợp kim; cũng thường dùng để ví cái gì bền vững: lõi dây điện làm bằng đồng * mâm đồng * tượng đúc đồng",
    example: "lõi dây điện làm bằng đồng * mâm đồng * tượng đúc đồng",
  },
  {
    word: "đồng",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ đơn vị tiền tệ: đồng yen Nhật * đổi dollar lấy đồng nhân dân tệ",
    example: "đồng yen Nhật * đổi dollar lấy đồng nhân dân tệ",
  },
  {
    word: "đồng",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị riêng lẻ của tiền tệ bằng kim loại, hình tròn: đồng xu * hai đồng tiền kẽm * một đồng trinh",
    example: "đồng xu * hai đồng tiền kẽm * một đồng trinh",
  },
  {
    word: "đồng",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị tiền tệ cơ bản của Việt Nam: phát hành loại tiền giấy có mệnh giá năm trăm nghìn đồng",
    example: "phát hành loại tiền giấy có mệnh giá năm trăm nghìn đồng",
  },
  {
    word: "đồng",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) tiền bạc nói chung: đồng lương có hạn * trong nhà cũng có đồng ra đồng vào",
    example: "đồng lương có hạn * trong nhà cũng có đồng ra đồng vào",
  },
  {
    word: "đồng",
    part_of_speech: "danh từ",
    meaning: "(Khẩu ngữ) đồng cân (nói tắt): mất cái nhẫn một đồng",
    example: "mất cái nhẫn một đồng",
  },
  {
    word: "đồng",
    part_of_speech: "danh từ",
    meaning:
      "khoảng đất rộng và bằng phẳng để cày cấy, trồng trọt, v.v.: đồng cỏ * đồng lúa * vác cuốc ra đồng",
    example: "đồng cỏ * đồng lúa * vác cuốc ra đồng",
  },
  {
    word: "đồng",
    part_of_speech: "danh từ",
    meaning:
      "người được thần linh hoặc hồn người chết nhập vào để nói ra những điều bí ẩn, theo tín ngưỡng dân gian: ông đồng, bà cốt * cô đồng",
    example: "ông đồng, bà cốt * cô đồng",
  },
  {
    word: "đồng",
    part_of_speech: "tính từ",
    meaning:
      "giống như nhau, không có gì khác nhau: vải đồng màu * mọi người đồng sức, đồng lòng",
    example: "vải đồng màu * mọi người đồng sức, đồng lòng",
  },
  {
    word: "đồng bào",
    part_of_speech: "danh từ",
    meaning:
      "những người cùng một giống nòi, một dân tộc, một tổ quốc với mình (hàm ý có quan hệ thân thiết như ruột thịt): đồng bào trong nước và ngoài nước * đồng bào miền Nam",
    example: "đồng bào trong nước và ngoài nước * đồng bào miền Nam",
  },
  {
    word: "đồng bào",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để gọi nhân dân nói chung, không phải là quân đội hoặc không phải là cán bộ: bảo vệ tính mạng tài sản cho đồng bào",
    example: "bảo vệ tính mạng tài sản cho đồng bào",
  },
  {
    word: "đồng áng",
    part_of_speech: "danh từ",
    meaning:
      "đồng ruộng (thường nói về công việc cày cấy): thạo việc đồng áng * bàn chuyện đồng áng",
    example: "thạo việc đồng áng * bàn chuyện đồng áng",
  },
  {
    word: "đồng bạc",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như đồng tiền: đồng bạc kẽm",
    example: "đồng bạc kẽm",
  },
  {
    word: "đồng bạc",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) đồng (Việt Nam): trong túi chỉ còn mấy đồng bạc",
    example: "trong túi chỉ còn mấy đồng bạc",
  },
  {
    word: "đồng bằng",
    part_of_speech: "danh từ",
    meaning:
      "vùng đất rộng lớn, thấp gần ngang mực nước biển, bằng phẳng hoặc có các điểm cao thấp không chênh lệch nhau nhiều: đồng bằng sông Cửu Long * từ miền núi xuống đồng bằng",
    example: "đồng bằng sông Cửu Long * từ miền núi xuống đồng bằng",
  },
  {
    word: "đồng bọn",
    part_of_speech: "danh từ",
    meaning:
      "những kẻ cùng một nhóm, cùng tham gia làm việc bất lương: không chịu khai ra đồng bọn * tên cầm đầu cùng đồng bọn đã bị tóm gọn",
    example:
      "không chịu khai ra đồng bọn * tên cầm đầu cùng đồng bọn đã bị tóm gọn",
  },
  {
    word: "đồng cảm",
    part_of_speech: "động từ",
    meaning:
      "cùng có chung một mối cảm xúc, cảm nghĩ: cùng cảnh ngộ nên dễ đồng cảm * chia sẻ bằng thái độ đồng cảm",
    example: "cùng cảnh ngộ nên dễ đồng cảm * chia sẻ bằng thái độ đồng cảm",
  },
  {
    word: "đồng bộ",
    part_of_speech: "tính từ",
    meaning:
      "(những chuyển động) cùng chu kì hoặc cùng tốc độ, được tiến hành trong cùng một thời gian, tạo ra một sự phối hợp nhịp nhàng, ăn khớp với nhau: động cơ máy móc chạy không đồng bộ",
    example: "động cơ máy móc chạy không đồng bộ",
  },
  {
    word: "đồng bộ",
    part_of_speech: "tính từ",
    meaning:
      "có sự ăn khớp giữa tất cả các bộ phận hoặc các khâu, tạo nên sự hoạt động nhịp nhàng của chỉnh thể: máy móc được trang bị mới và đồng bộ * phát triển đồng bộ và rộng khắp",
    example:
      "máy móc được trang bị mới và đồng bộ * phát triển đồng bộ và rộng khắp",
  },
  {
    word: "đồng bóng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (tính) hay trở chứng, lúc thế này, lúc thế khác: có tính đồng bóng * càng ngày càng đồng bóng nặng",
    example: "có tính đồng bóng * càng ngày càng đồng bóng nặng",
  },
  {
    word: "đồng ca",
    part_of_speech: "động từ",
    meaning:
      "(nhiều người) cùng hát chung một bài, một bè hay nhiều bè: hát đồng ca * tất cả đồng ca một bài",
    example: "hát đồng ca * tất cả đồng ca một bài",
  },
  {
    word: "đồng ca",
    part_of_speech: "danh từ",
    meaning:
      "nhóm diễn viên hát dùng tiếng đế để hỗ trợ cho diễn viên chính trong kịch hát: dàn đồng ca",
    example: "dàn đồng ca",
  },
  {
    word: "động chạm",
    part_of_speech: "động từ",
    meaning:
      "động đến và có thể gây tổn hại, ảnh hưởng (thường là về mặt tinh thần): động chạm đến danh dự cá nhân",
    example: "động chạm đến danh dự cá nhân",
  },
  {
    word: "đồng chất",
    part_of_speech: "tính từ",
    meaning: "như đồng tính: môi trường đồng chất",
    example: "môi trường đồng chất",
  },
  {
    word: "đồng cân",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị cũ đo khối lượng, bằng 1/10 lạng, tức khoảng 3,78 gram: chiếc nhẫn vàng hai đồng cân",
    example: "chiếc nhẫn vàng hai đồng cân",
  },
  {
    word: "đồng chí",
    part_of_speech: "danh từ",
    meaning:
      "người cùng chí hướng chính trị, trong quan hệ với nhau: tình đồng chí",
    example: "tình đồng chí",
  },
  {
    word: "đồng chí",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng trong xưng hô để gọi một người với tư cách là đảng viên đảng cộng sản, đoàn viên một đoàn thể cách mạng hoặc công dân (có quan hệ công tác) ở một nước xã hội chủ nghĩa: đồng chí bí thư chi bộ * đồng chí trưởng phòng",
    example: "đồng chí bí thư chi bộ * đồng chí trưởng phòng",
  },
  {
    word: "động cơ",
    part_of_speech: "danh từ",
    meaning: "máy biến một dạng năng lượng nào đó thành cơ năng.",
    example: "động cơ học tập đúng đắn * động cơ cá nhân",
  },
  {
    word: "động cỡn",
    part_of_speech: "động từ",
    meaning:
      "(loài thú) có những động tác biểu hiện sinh lí bị kích thích mạnh khi có đòi hỏi về tính dục: lợn động cỡn",
    example: "lợn động cỡn",
  },
  {
    word: "đồng dạng",
    part_of_speech: "tính từ",
    meaning: "có cùng một dạng như nhau: hai tam giác đồng dạng",
    example: "hai tam giác đồng dạng",
  },
  {
    word: "động dạng",
    part_of_speech: "động từ",
    meaning:
      "có hành động, hoạt động nào đó xảy ra một cách khác thường: nghe tiếng chó sủa, nhưng cũng chẳng ai thèm động dạng",
    example: "nghe tiếng chó sủa, nhưng cũng chẳng ai thèm động dạng",
  },
  {
    word: "đông cung",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) cung ở phía đông, nơi thái tử ở; thường dùng để chỉ thái tử: lập đông cung",
    example: "lập đông cung",
  },
  {
    word: "đồng dao",
    part_of_speech: "danh từ",
    meaning:
      "lời hát dân gian truyền miệng của trẻ em, thường kèm một trò chơi nhất định: bài đồng dao",
    example: "bài đồng dao",
  },
  {
    word: "đông du",
    part_of_speech: "động từ",
    meaning:
      "du học ở các nước phía đông (một phong trào ở Việt Nam đầu thế kỉ XX, chủ trương đưa người sang Nhật Bản học chính trị và quân sự để chuẩn bị lật đổ chính quyền thực dân Pháp): phong trào đông du",
    example: "phong trào đông du",
  },
  {
    word: "đồng dục",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như đồng tính: quan hệ đồng dục",
    example: "quan hệ đồng dục",
  },
  {
    word: "đồng đại",
    part_of_speech: "tính từ",
    meaning:
      "thuộc một trạng thái, một giai đoạn trong sự phát triển của ngôn ngữ được tách ra làm đối tượng nghiên cứu; đối lập với lịch đại: ngôn ngữ học đồng đại",
    example: "ngôn ngữ học đồng đại",
  },
  {
    word: "đông dược",
    part_of_speech: "danh từ",
    meaning: "thuốc đông y: chữa bệnh bằng đông dược",
    example: "chữa bệnh bằng đông dược",
  },
  {
    word: "đồng đảng",
    part_of_speech: "danh từ",
    meaning:
      "người cùng bọn với kẻ bất lương: khai ra đồng đảng * bắt được cả thủ phạm lẫn đồng đảng",
    example: "khai ra đồng đảng * bắt được cả thủ phạm lẫn đồng đảng",
  },
  {
    word: "đồng đảng",
    part_of_speech: "tính từ",
    meaning:
      "thuộc cùng một bọn với kẻ bất lương: đồng đảng với lũ kẻ cướp * kẻ đồng đảng",
    example: "đồng đảng với lũ kẻ cướp * kẻ đồng đảng",
  },
  {
    word: "đông đặc",
    part_of_speech: "động từ",
    meaning:
      "đông chặt lại, không còn ở trạng thái lỏng nữa: điểm đông đặc của một chất",
    example: "điểm đông đặc của một chất",
  },
  {
    word: "đông đặc",
    part_of_speech: "tính từ",
    meaning:
      "đông đến mức như không còn có thể chen thêm vào được nữa: người đến xem đông đặc",
    example: "người đến xem đông đặc",
  },
  {
    word: "đồng đẳng",
    part_of_speech: "tính từ",
    meaning: "(cũ) ngang hàng với nhau: đồng đẳng về địa vị",
    example: "đồng đẳng về địa vị",
  },
  {
    word: "đông đảo",
    part_of_speech: "tính từ",
    meaning:
      "có số lượng người rất đông, thuộc nhiều tầng lớp khác nhau: được đông đảo quần chúng đồng tình",
    example: "được đông đảo quần chúng đồng tình",
  },
  {
    word: "động dục",
    part_of_speech: "động từ",
    meaning:
      "(hiện tượng động vật cái) ở thời kì kích động sinh dục (do trứng rụng): bò động dục",
    example: "bò động dục",
  },
  {
    word: "đồng đất",
    part_of_speech: "danh từ",
    meaning:
      "đồng ruộng và đất đai, nơi làm ăn sinh sống về nghề nông )nói khái quát): đồng đất rộng rãi, màu mỡ",
    example: "đồng đất rộng rãi, màu mỡ",
  },
  {
    word: "động đào",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) động có nhiều cây đào; chỉ nơi tiên ở; cảnh tiên: "Xắn tay mở khoá động đào, Rẽ mây trông tỏ lối vào Thiên Thai." (TKiều)',
    example:
      'Xắn tay mở khoá động đào, Rẽ mây trông tỏ lối vào Thiên Thai." (TKiều)',
  },
  {
    word: "đồng điền",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) như đồng ruộng: đồng điền xanh tốt * làng mạc, đồng điền ngập trong nước lũ",
    example: "đồng điền xanh tốt * làng mạc, đồng điền ngập trong nước lũ",
  },
  {
    word: "động đất",
    part_of_speech: "danh từ",
    meaning:
      "hiện tượng vỏ Trái Đất đột ngột rung động mạnh, thường gây nứt nẻ, trồi sụt: khắc phục hậu quả của trận động đất",
    example: "khắc phục hậu quả của trận động đất",
  },
  {
    word: "động đậy",
    part_of_speech: "động từ",
    meaning:
      "(vật sống) chuyển động chút ít (thường trong khi lẽ ra phải ở trạng thái yên): đứng im, không được động đậy! * động đậy tay chân",
    example: "đứng im, không được động đậy! * động đậy tay chân",
  },
  {
    word: "đồng điệu",
    part_of_speech: "tính từ",
    meaning:
      "cùng một nỗi niềm, một cảm nghĩ, một cảnh ngộ như nhau: hai tâm hồn đồng điệu",
    example: "hai tâm hồn đồng điệu",
  },
  {
    word: "đồng đều",
    part_of_speech: "tính từ",
    meaning:
      "đều nhau, ngang nhau, không chênh lệch: trình độ không đồng đều * chia đồng đều cho tất cả mọi người",
    example: "trình độ không đồng đều * chia đồng đều cho tất cả mọi người",
  },
  {
    word: "đồng đội",
    part_of_speech: "danh từ",
    meaning:
      "người cùng đội ngũ chiến đấu hoặc cùng đội thi đấu thể thao: anh em đồng đội * tạo điều kiện cho đồng đội ghi bàn",
    example: "anh em đồng đội * tạo điều kiện cho đồng đội ghi bàn",
  },
  {
    word: "đồng đen",
    part_of_speech: "danh từ",
    meaning:
      "hợp kim đồng và thiếc, màu đen bóng, thường dùng để đúc tượng: pho tượng bằng đồng đen",
    example: "pho tượng bằng đồng đen",
  },
  {
    word: "động đực",
    part_of_speech: "động từ",
    meaning:
      "(hiện tượng động vật cái) ở thời kì động dục, muốn gần con đực để giao phối: lợn nái động đực",
    example: "lợn nái động đực",
  },
  {
    word: "đông đúc",
    part_of_speech: "tính từ",
    meaning: "có rất đông người ăn ở và đi lại: dân cư đông đúc",
    example: "dân cư đông đúc",
  },
  {
    word: "đông đủ",
    part_of_speech: "tính từ",
    meaning: "có đủ mặt tất cả, không thiếu ai: mọi người đã có mặt đông đủ",
    example: "mọi người đã có mặt đông đủ",
  },
  {
    word: "đồng hành",
    part_of_speech: "động từ",
    meaning: "cùng đi đường với nhau: người đồng hành",
    example: "người đồng hành",
  },
  {
    word: "đồng hoá",
    part_of_speech: "động từ",
    meaning:
      "làm thay đổi bản chất cho giống như của mình: chính sách đồng hoá * từ mượn đã được đồng hoá",
    example: "chính sách đồng hoá * từ mượn đã được đồng hoá",
  },
  {
    word: "đồng hoá",
    part_of_speech: "động từ",
    meaning:
      "(quá trình) làm biến đổi những chất lấy từ môi trường thành những chất của cơ thể; phân biệt với dị hoá: hiện tượng đồng hoá * đồng hoá chất đạm",
    example: "hiện tượng đồng hoá * đồng hoá chất đạm",
  },
  {
    word: "đồng hồ",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ đo thời gian dựa trên các hiện tượng tuần hoàn: đồng hồ đeo tay * đứng đợi suốt mấy tiếng đồng hồ",
    example: "đồng hồ đeo tay * đứng đợi suốt mấy tiếng đồng hồ",
  },
  {
    word: "đồng hồ",
    part_of_speech: "danh từ",
    meaning:
      "khí cụ để đo có bề ngoài giống như đồng hồ: đồng hồ đo điện * đồng hồ nước",
    example: "đồng hồ đo điện * đồng hồ nước",
  },
  {
    word: "đồng học",
    part_of_speech: "động từ",
    meaning: "cùng học một thầy, một khoá hoặc một trường: bạn đồng học",
    example: "bạn đồng học",
  },
  {
    word: "đồng hao",
    part_of_speech: "tính từ",
    meaning: "cùng làm rể một gia đình: anh em đồng hao",
    example: "anh em đồng hao",
  },
  {
    word: "đồng hun",
    part_of_speech: "danh từ",
    meaning: "đồng được hun sạm đi, trông như đồng đen: nước da màu đồng hun",
    example: "nước da màu đồng hun",
  },
  {
    word: "đồng huyết",
    part_of_speech: "tính từ",
    meaning:
      "cùng có chung dòng máu về phía bố: tránh tình trạng đồng huyết khi nhân giống đàn gia súc",
    example: "tránh tình trạng đồng huyết khi nhân giống đàn gia súc",
  },
  {
    word: "đồng không mông quạnh",
    part_of_speech: "",
    meaning:
      "tả nơi vắng vẻ, hiu quạnh, giữa đồng ruộng, xa xóm làng, dân cư (nói khái quát): túp lều trơ trọi giữa đồng không mông quạnh",
    example: "túp lều trơ trọi giữa đồng không mông quạnh",
  },
  {
    word: "đồng khởi",
    part_of_speech: "động từ",
    meaning:
      "cùng nhau nổi dậy dùng bạo lực để phá ách kìm kẹp, giành chính quyền (một hình thức khởi nghĩa ở miền Nam Việt Nam trong kháng chiến chống Mĩ): phong trào đồng khởi ở Bến Tre",
    example: "phong trào đồng khởi ở Bến Tre",
  },
  {
    word: "động kinh",
    part_of_speech: "",
    meaning:
      "bệnh thần kinh gây nên những cơn co giật và bất tỉnh, thường lặp đi lặp lại kéo dài: lên cơn động kinh * mắc chứng động kinh",
    example: "lên cơn động kinh * mắc chứng động kinh",
  },
  {
    word: "đồng hương",
    part_of_speech: "tính từ",
    meaning:
      "cùng một quê (nhưng đều đang ở xa): hội đồng hương * hai người đồng hương với nhau",
    example: "hội đồng hương * hai người đồng hương với nhau",
  },
  {
    word: "đồng hương",
    part_of_speech: "danh từ",
    meaning: "người cùng quê hương: gặp mặt đồng hương",
    example: "gặp mặt đồng hương",
  },
  {
    word: "đông lạnh",
    part_of_speech: "tính từ",
    meaning:
      "(thực phẩm tươi sống) được làm lạnh ở nhiệt độ rất thấp để bảo quản: sản xuất tôm đông lạnh",
    example: "sản xuất tôm đông lạnh",
  },
  {
    word: "đồng liêu",
    part_of_speech: "tính từ",
    meaning: "cùng làm quan với nhau: hai người là chỗ đồng liêu",
    example: "hai người là chỗ đồng liêu",
  },
  {
    word: "đổng lí",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) chức danh của người điều khiển công việc hành chính, sự vụ của một cơ quan cao cấp thời trước: làm đổng lí văn phòng",
    example: "làm đổng lí văn phòng",
  },
  {
    word: "đồng loã",
    part_of_speech: "động từ",
    meaning:
      "tham gia cùng với người khác vào một hành động, một việc làm bất lương: đồng loã với nhau để hại người * kẻ đồng loã",
    example: "đồng loã với nhau để hại người * kẻ đồng loã",
  },
  {
    word: "đồng loã",
    part_of_speech: "danh từ",
    meaning:
      "kẻ cùng tham gia làm việc bất lương: cả thủ phạm và đồng loã đều đã bị bắt",
    example: "cả thủ phạm và đồng loã đều đã bị bắt",
  },
  {
    word: "đồng lần",
    part_of_speech: "tính từ",
    meaning:
      "cùng lần lượt như nhau, trước sau rồi ai cũng có, cũng phải làm, phải chịu hoặc phải trải qua: nợ đồng lần * “Ruộng nương là của đồng lần, Trời đất xoay vần kẻ trước người sau.” (ca dao)",
    example:
      "nợ đồng lần * “Ruộng nương là của đồng lần, Trời đất xoay vần kẻ trước người sau.” (ca dao)",
  },
  {
    word: "đồng lòng",
    part_of_speech: "tính từ",
    meaning:
      "cùng một lòng, một ý chí: trên dưới đồng lòng * toàn dân đồng sức đồng lòng đánh giặc",
    example: "trên dưới đồng lòng * toàn dân đồng sức đồng lòng đánh giặc",
  },
  {
    word: "đồng loại",
    part_of_speech: "",
    meaning:
      "(động vật) cùng một loại (thường chỉ loài người với nhau): thương yêu đồng loại * tình đồng loại",
    example: "thương yêu đồng loại * tình đồng loại",
  },
  {
    word: "động lực",
    part_of_speech: "danh từ",
    meaning: "năng lượng làm cho máy móc chuyển động: nguồn động lực",
    example: "nguồn động lực",
  },
  {
    word: "động lực",
    part_of_speech: "danh từ",
    meaning:
      "cái thúc đẩy, làm cho phát triển: xuất khẩu tăng là một động lực chính để thúc đẩy phát triển kinh tế",
    example:
      "xuất khẩu tăng là một động lực chính để thúc đẩy phát triển kinh tế",
  },
  {
    word: "đồng loạt",
    part_of_speech: "tính từ",
    meaning:
      "cùng một loại như nhau cả, không có gì khác, không có sự phân biệt: giá vé đồng loạt * giảm giá đồng loạt",
    example: "giá vé đồng loạt * giảm giá đồng loạt",
  },
  {
    word: "đồng loạt",
    part_of_speech: "phụ từ",
    meaning:
      "trong cùng một lúc: đồng loạt nổi dậy * những cánh tay đồng loạt giơ lên",
    example: "đồng loạt nổi dậy * những cánh tay đồng loạt giơ lên",
  },
  {
    word: "động lòng",
    part_of_speech: "động từ",
    meaning: "cảm thấy thương xót: động lòng thương * động lòng trắc ẩn",
    example: "động lòng thương * động lòng trắc ẩn",
  },
  {
    word: "động lòng",
    part_of_speech: "động từ",
    meaning:
      'cảm thấy bị chạm đến lòng tự ái: mới nói thế mà đã động lòng * "Sấm bên đông, động bên tây, Tuy rằng nói đấy nhưng đây động lòng." (ca dao)',
    example:
      'mới nói thế mà đã động lòng * "Sấm bên đông, động bên tây, Tuy rằng nói đấy nhưng đây động lòng." (ca dao)',
  },
  {
    word: "đồng lương",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) tiền lương của người làm công ăn lương (thường dùng với hàm ý ít ỏi, hạn hẹp): đồng lương ít ỏi",
    example: "đồng lương ít ỏi",
  },
  {
    word: "đồng minh",
    part_of_speech: "danh từ",
    meaning:
      "lực lượng cùng đứng về một phía để phối hợp hành động vì mục đích chung: phe đồng minh * một đồng minh đáng tin cậy",
    example: "phe đồng minh * một đồng minh đáng tin cậy",
  },
  {
    word: "động não",
    part_of_speech: "động từ",
    meaning:
      "vận dụng nhiều đến trí óc, suy nghĩ nhiều và sâu: lười suy nghĩ, không chịu động não",
    example: "lười suy nghĩ, không chịu động não",
  },
  {
    word: "đồng mưu",
    part_of_speech: "động từ",
    meaning:
      "cùng nhau mưu tính làm việc xấu: kẻ đồng mưu * đồng mưu với kẻ xấu để hại người",
    example: "kẻ đồng mưu * đồng mưu với kẻ xấu để hại người",
  },
  {
    word: "động mạch vành",
    part_of_speech: "danh từ",
    meaning:
      "động mạch bao bọc quanh tim cung cấp máu để nuôi cơ tim: co thắt động mạch vành",
    example: "co thắt động mạch vành",
  },
  {
    word: "đồng môn",
    part_of_speech: "tính từ",
    meaning:
      "(cũ) cùng học một thầy, một trường hoặc một môn phái thời phong kiến: bạn đồng môn * anh em đồng môn",
    example: "bạn đồng môn * anh em đồng môn",
  },
  {
    word: "đồng môn",
    part_of_speech: "danh từ",
    meaning: "(cũ) người cùng học: hai người là đồng môn",
    example: "hai người là đồng môn",
  },
  {
    word: "đồng nghĩa",
    part_of_speech: "tính từ",
    meaning: "có nghĩa giống nhau: tìm từ đồng nghĩa * hiện tượng đồng nghĩa",
    example: "tìm từ đồng nghĩa * hiện tượng đồng nghĩa",
  },
  {
    word: "đồng nát",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng hoặc vật liệu lặt vặt đã cũ hoặc hư hỏng, được thu nhặt để đem bán lại (nói khái quát): bán đồng nát * đồ đồng nát",
    example: "bán đồng nát * đồ đồng nát",
  },
  {
    word: "đồng nghiệp",
    part_of_speech: "tính từ",
    meaning: "cùng làm một nghề: bạn đồng nghiệp",
    example: "bạn đồng nghiệp",
  },
  {
    word: "đồng nghiệp",
    part_of_speech: "danh từ",
    meaning: "người làm cùng một nghề: hai người là đồng nghiệp của nhau",
    example: "hai người là đồng nghiệp của nhau",
  },
  {
    word: "đông nghịt",
    part_of_speech: "tính từ",
    meaning:
      "đông đến mức làm chật kín cả một khoảng rộng: người xem đứng đông nghịt",
    example: "người xem đứng đông nghịt",
  },
  {
    word: "động ngữ",
    part_of_speech: "danh từ",
    meaning:
      "tổ hợp từ có quan hệ chính phụ do động từ làm chính tố:  là một động ngữ",
    example: "là một động ngữ",
  },
  {
    word: "đồng ngũ",
    part_of_speech: "tính từ",
    meaning: "cùng chung một đội ngũ, một đơn vị trong quân đội: bạn đồng ngũ",
    example: "bạn đồng ngũ",
  },
  {
    word: "đồng ngũ",
    part_of_speech: "danh từ",
    meaning:
      "người ở cùng đội ngũ, cùng đơn vị trong quân đội: vừa là đồng môn, vừa là đồng ngũ",
    example: "vừa là đồng môn, vừa là đồng ngũ",
  },
  {
    word: "đồng nội",
    part_of_speech: "danh từ",
    meaning:
      '(văn chương) đồng ruộng, đồng quê (nói khái quát): hương hoa đồng nội * "Thân em như hạt mưa sa, Hạt vào đồng nội hạt ra vũng lầy." (ca dao)',
    example:
      'hương hoa đồng nội * "Thân em như hạt mưa sa, Hạt vào đồng nội hạt ra vũng lầy." (ca dao)',
  },
  {
    word: "đồng niên",
    part_of_speech: "tính từ",
    meaning: "(người) cùng một tuổi: bạn đồng niên",
    example: "bạn đồng niên",
  },
  {
    word: "đồng nhất",
    part_of_speech: "tính từ",
    meaning:
      "giống nhau, như nhau hoàn toàn, đến mức có thể coi như là một: hai vấn đề vừa khác biệt lại vừa đồng nhất với nhau",
    example: "hai vấn đề vừa khác biệt lại vừa đồng nhất với nhau",
  },
  {
    word: "đồng nhất",
    part_of_speech: "động từ",
    meaning:
      "làm cho giống nhau, coi như nhau: không thể đồng nhất nghệ thuật với đạo đức",
    example: "không thể đồng nhất nghệ thuật với đạo đức",
  },
  {
    word: "đồng phạm",
    part_of_speech: "danh từ",
    meaning: "kẻ cùng phạm tội với chính phạm: không chịu khai ra đồng phạm",
    example: "không chịu khai ra đồng phạm",
  },
  {
    word: "đồng phẳng",
    part_of_speech: "tính từ",
    meaning: "cùng nằm trên một mặt phẳng: ba vector đồng phẳng",
    example: "ba vector đồng phẳng",
  },
  {
    word: "đông phong",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) gió mùa xuân, thổi từ phương đông tới: "Hiên mai hây hẩy đông phong, Hương đầm áo thuý, hoa lồng trướng thanh." (SKTT)',
    example:
      'Hiên mai hây hẩy đông phong, Hương đầm áo thuý, hoa lồng trướng thanh." (SKTT)',
  },
  {
    word: "đồng phục",
    part_of_speech: "tính từ",
    meaning:
      "(bộ quần áo) cùng một màu, cùng một chất liệu được may cùng một kiểu thống nhất cho những người trong một tổ chức, một ngành nghề nào đó: bộ quần áo đồng phục",
    example: "bộ quần áo đồng phục",
  },
  {
    word: "đồng phục",
    part_of_speech: "danh từ",
    meaning:
      "bộ quần áo được may hàng loạt theo cùng một kiểu, thường có cùng một màu, cùng một chất liệu: học sinh mặc đồng phục đến trường",
    example: "học sinh mặc đồng phục đến trường",
  },
  {
    word: "động phòng",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, trang trọng) phòng riêng của đôi vợ chồng mới cưới: "Đuốc hoa choi chói động phòng, Bây giờ mặc sức dầu lòng giăng hoa." (HTr)',
    example:
      'Đuốc hoa choi chói động phòng, Bây giờ mặc sức dầu lòng giăng hoa." (HTr)',
  },
  {
    word: "động phòng",
    part_of_speech: "động từ",
    meaning: "(cũ, văn chương) động phòng hoa chúc (nói tắt): đêm động phòng",
    example: "đêm động phòng",
  },
  {
    word: "đồng ruộng",
    part_of_speech: "danh từ",
    meaning:
      "khoảng đất rộng để cày cấy, trồng trọt (nói khái quát): đồng ruộng phì nhiêu",
    example: "đồng ruộng phì nhiêu",
  },
  {
    word: "đồng qui",
    part_of_speech: "tính từ",
    meaning:
      "(đường thẳng trong hình học) cùng gặp nhau tại một điểm: đường đồng quy",
    example: "đường đồng quy",
  },
  {
    word: "đồng quê",
    part_of_speech: "danh từ",
    meaning: "đồng ruộng ở nông thôn; thường chỉ nông thôn: hương vị đồng quê",
    example: "hương vị đồng quê",
  },
  {
    word: "đồng quy",
    part_of_speech: "tính từ",
    meaning:
      "(đường thẳng trong hình học) cùng gặp nhau tại một điểm: đường đồng quy",
    example: "đường đồng quy",
  },
  {
    word: "đông sàng",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) giường kê về phía đông; dùng để gọi chàng rể: "Đồn rằng có ả tiểu thư, Đông sàng ngôi ấy bây giờ là ai?" (NĐM)',
    example: 'Đồn rằng có ả tiểu thư, Đông sàng ngôi ấy bây giờ là ai?" (NĐM)',
  },
  {
    word: "đồng sàng",
    part_of_speech: "tính từ",
    meaning:
      "(cũ) cùng nằm một giường; dùng để nói quan hệ của vợ chồng hoặc của bạn bè thân thiết: bạn đồng sàng",
    example: "bạn đồng sàng",
  },
  {
    word: "động rồ",
    part_of_speech: "động từ",
    meaning: "(thông tục) nổi cơn điên, hoá dại: ai động rồ mà mua cái của ấy!",
    example: "ai động rồ mà mua cái của ấy!",
  },
  {
    word: "động tác",
    part_of_speech: "danh từ",
    meaning:
      "sự thay đổi tư thế, vị trí của thân thể hoặc bộ phận thân thể một cách có ý thức và có mục đích rõ ràng: động tác múa * làm động tác giả để lừa đối phương",
    example: "động tác múa * làm động tác giả để lừa đối phương",
  },
  {
    word: "đồng sự",
    part_of_speech: "tính từ",
    meaning:
      "(cũ) cùng làm việc chung với nhau trong một cơ quan (thường là ngang hàng nhau): anh em đồng sự",
    example: "anh em đồng sự",
  },
  {
    word: "động tâm",
    part_of_speech: "động từ",
    meaning: "(hiếm) như động lòng: thấy cảnh tang tóc, ai chẳng động tâm",
    example: "thấy cảnh tang tóc, ai chẳng động tâm",
  },
  {
    word: "đông tây kim cổ",
    part_of_speech: "",
    meaning:
      "từ đông đến tây, từ cổ chí kim; tất cả, khắp mọi nơi, từ xưa đến nay: am hiểu mọi chuyện đông tây kim cổ",
    example: "am hiểu mọi chuyện đông tây kim cổ",
  },
  {
    word: "động thái",
    part_of_speech: "danh từ",
    meaning:
      "biểu hiện biến đổi của một tình trạng theo thời gian, theo sự phát triển: động thái chính trị * thương mại thế giới đang có động thái phát triển",
    example:
      "động thái chính trị * thương mại thế giới đang có động thái phát triển",
  },
  {
    word: "đồng thanh",
    part_of_speech: "phụ từ",
    meaning:
      "cùng (nói, hát) một lúc như nhau: đọc đồng thanh * mọi người cùng đồng thanh trả lời",
    example: "đọc đồng thanh * mọi người cùng đồng thanh trả lời",
  },
  {
    word: "đồng thanh",
    part_of_speech: "phụ từ",
    meaning:
      "cùng tỏ ra hoàn toàn nhất trí như nhau: hội nghị đồng thanh quyết nghị",
    example: "hội nghị đồng thanh quyết nghị",
  },
  {
    word: "đồng tâm",
    part_of_speech: "tính từ",
    meaning: "cùng có chung một tâm: hai đường tròn đồng tâm",
    example: "hai đường tròn đồng tâm",
  },
  {
    word: "đồng tâm",
    part_of_speech: "tính từ",
    meaning:
      '(cũ) như đồng lòng: "Đã nguyền hai chữ  * , Trăm năm thề chẳng ôm cầm thuyền ai." (TKiều)',
    example:
      'Đã nguyền hai chữ  * , Trăm năm thề chẳng ôm cầm thuyền ai." (TKiều)',
  },
  {
    word: "đồng thau",
    part_of_speech: "danh từ",
    meaning:
      "hợp kim đồng với kẽm, màu vàng, dễ dát mỏng, thường dùng để làm một số vật dụng như mâm, chậu rửa mặt: vàng thau lẫn lộn",
    example: "vàng thau lẫn lộn",
  },
  {
    word: "đồng thau",
    part_of_speech: "danh từ",
    meaning:
      "(Nam) chậu (đựng nước); chậu thau: thau rửa mặt * múc một thau nước",
    example: "thau rửa mặt * múc một thau nước",
  },
  {
    word: "đồng thau",
    part_of_speech: "động từ",
    meaning:
      "cọ rửa sạch và xả hết nước cũ trong đồ chứa đựng như chum, vại, bể, v.v. để chứa đựng nước mới: thau bể để hứng nước mưa",
    example: "thau bể để hứng nước mưa",
  },
  {
    word: "đồng thau",
    part_of_speech: "động từ",
    meaning:
      "(Ít dùng) tan ra dễ dàng (thường nói về thức ăn cho vào miệng): viên kẹo thau dần trong miệng",
    example: "viên kẹo thau dần trong miệng",
  },
  {
    word: "đồng thời",
    part_of_speech: "phụ từ",
    meaning:
      "(hai việc xảy ra hoặc hai tính chất tồn tại) cùng trong một thời gian: hào kiệt khắp nơi đồng thời nổi dậy * thực hiện đồng thời hai nhiệm vụ",
    example:
      "hào kiệt khắp nơi đồng thời nổi dậy * thực hiện đồng thời hai nhiệm vụ",
  },
  {
    word: "đồng thuận",
    part_of_speech: "",
    meaning:
      "bằng lòng, đồng tình (về những vấn đề thường là quan trọng): ý kiến được mọi người đồng thuận",
    example: "ý kiến được mọi người đồng thuận",
  },
  {
    word: "đồng tính",
    part_of_speech: "tính từ",
    meaning: "có cùng một tính chất tại mọi điểm: môi trường đồng tính",
    example: "môi trường đồng tính",
  },
  {
    word: "đồng tính",
    part_of_speech: "tính từ",
    meaning:
      "chỉ có ham muốn nhục dục với người cùng giới tính: anh ta là người đồng tính",
    example: "anh ta là người đồng tính",
  },
  {
    word: "đồng tiền",
    part_of_speech: "danh từ",
    meaning: "đơn vị tiền tệ nhỏ nhất ở Việt Nam thời phong kiến.",
    example: "đồng tiền kẽm * má lúm đồng tiền",
  },
  {
    word: "đồng tiền",
    part_of_speech: "danh từ",
    meaning:
      "tiền bằng đồng hoặc kẽm đúc mỏng, hình tròn: đồng tiền kẽm * má lúm đồng tiền",
    example: "đồng tiền Việt Nam * đồng tiền chung châu Âu",
  },
  {
    word: "đồng tiền bát gạo",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tiền bạc, của cải bỏ ra để chi dùng cho việc gì (nói khái quát): được thế cũng đáng đồng tiền bát gạo!",
    example: "được thế cũng đáng đồng tiền bát gạo!",
  },
  {
    word: "đồng tịch đồng sàng",
    part_of_speech: "",
    meaning:
      '(cũ) cùng chung một chiếu, một giường; dùng để chỉ quan hệ vợ chồng: "Nghĩa vợ chồng đồng tịch đồng sàng, Đồng sinh đồng tử, cưu mang đồng lần." (ca dao)',
    example:
      'Nghĩa vợ chồng đồng tịch đồng sàng, Đồng sinh đồng tử, cưu mang đồng lần." (ca dao)',
  },
  {
    word: "đồng tịch đồng sàng",
    part_of_speech: "",
    meaning:
      "tiền bạc, nói về mặt quyền lực của nó: chạy theo đồng tiền * đồng tiền đi trước là đồng tiền khôn (tng)",
    example: "chạy theo đồng tiền * đồng tiền đi trước là đồng tiền khôn (tng)",
  },
  {
    word: "động thổ",
    part_of_speech: "động từ",
    meaning:
      "bắt đầu đào xới đất cát buổi đầu năm (một nghi thức trong nghề nông, có ý cầu mong cả năm làm ăn sẽ được thuận lợi).",
    example: "làm lễ động thổ công trình",
  },
  {
    word: "đồng tình",
    part_of_speech: "",
    meaning:
      "cùng có một ý, một lòng như nhau: gật đầu, tỏ ý đồng tình * không đồng tình với quyết định của trưởng phòng",
    example:
      "gật đầu, tỏ ý đồng tình * không đồng tình với quyết định của trưởng phòng",
  },
  {
    word: "động tình",
    part_of_speech: "động từ",
    meaning:
      'cảm thấy rung động, xúc động trước một cảnh tượng, một sự việc nào đó: "Nghĩa bằng hữu, bậc trung trinh, Thấy hoa mai, bỗng động tình xót ai." (NĐM)',
    example:
      'Nghĩa bằng hữu, bậc trung trinh, Thấy hoa mai, bỗng động tình xót ai." (NĐM)',
  },
  {
    word: "động tình",
    part_of_speech: "động từ",
    meaning: "(thông tục) trỗi dậy lòng ham muốn tình dục: cơn động tình",
    example: "cơn động tình",
  },
  {
    word: "đồng trinh",
    part_of_speech: "tính từ",
    meaning: "(cũ) (con gái) còn trinh tiết: gái đồng trinh",
    example: "gái đồng trinh",
  },
  {
    word: "đồng trinh",
    part_of_speech: "tính từ",
    meaning:
      "(người phụ nữ) đi tu theo Công giáo, giữ trinh tiết thờ Chúa: Đức Mẹ đồng trinh",
    example: "Đức Mẹ đồng trinh",
  },
  {
    word: "động tĩnh",
    part_of_speech: "",
    meaning:
      "có biểu hiện của một hoạt động, một sự việc nào đó bắt đầu xảy ra (có thể buộc phải đối phó): mọi sự vẫn yên, không thấy động tĩnh gì * nghe ngóng động tĩnh bên ngoài",
    example:
      "mọi sự vẫn yên, không thấy động tĩnh gì * nghe ngóng động tĩnh bên ngoài",
  },
  {
    word: "đồng tính luyến ái",
    part_of_speech: "",
    meaning:
      "quan hệ yêu đương, ham muốn tình dục với người cùng giới tính: một cặp đồng tính luyến ái",
    example: "một cặp đồng tính luyến ái",
  },
  {
    word: "động trời",
    part_of_speech: "động từ",
    meaning:
      "(thời tiết) chuyển biến xấu sau một thời kì nắng lâu: động trời nên không đi biển",
    example: "động trời nên không đi biển",
  },
  {
    word: "động trời",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có khả năng gây tác động rất lớn: làm chuyện động trời",
    example: "làm chuyện động trời",
  },
  {
    word: "động từ",
    part_of_speech: "danh từ",
    meaning:
      "từ chuyên biểu thị hành động (như ăn), trạng thái (như tồn tại) hay quá trình (như diễn ra), thường dùng làm vị ngữ trong câu",
    example: "ăn",
  },
  {
    word: "động vật",
    part_of_speech: "danh từ",
    meaning:
      "sinh vật có cảm giác và tự vận động được: người là động vật bậc cao * động vật trên cạn",
    example: "người là động vật bậc cao * động vật trên cạn",
  },
  {
    word: "đồng tử",
    part_of_speech: "danh từ",
    meaning: "con ngươi: bị dãn đồng tử",
    example: "bị dãn đồng tử",
  },
  {
    word: "đồng tử",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) như tiểu đồng: "Vui chân đồng tử năm ba, Khoan khoan gót ngọc nay đà đến chơi." (ca dao)',
    example:
      'Vui chân đồng tử năm ba, Khoan khoan gót ngọc nay đà đến chơi." (ca dao)',
  },
  {
    word: "đồng vốn",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) tiền vốn (nói khái quát): đồng vốn ít ỏi",
    example: "đồng vốn ít ỏi",
  },
  {
    word: "động viên",
    part_of_speech: "động từ",
    meaning:
      "chuyển lực lượng vũ trang sang trạng thái thời chiến: có lệnh động viên toàn quân",
    example: "có lệnh động viên toàn quân",
  },
  {
    word: "động viên",
    part_of_speech: "động từ",
    meaning:
      "huy động đến mức tối đa cho phép vào một công cuộc chung (thường là để phục vụ cho chiến tranh): động viên sức người sức của cho tiền tuyến",
    example: "động viên sức người sức của cho tiền tuyến",
  },
  {
    word: "động viên",
    part_of_speech: "động từ",
    meaning:
      "tác động đến tinh thần làm cho phấn khởi vươn lên mà tích cực hoạt động: động viên con cái cố gắng học tập * động viên mọi người cùng cố gắng",
    example:
      "động viên con cái cố gắng học tập * động viên mọi người cùng cố gắng",
  },
  {
    word: "đồng vị ngữ",
    part_of_speech: "danh từ",
    meaning:
      "thành phần của câu có tác dụng giải thích, thuyết minh thêm cho thành phần đi trước nó, cả hai thành phần được coi như cùng một vị trí ngữ pháp:  thì  *  là đồng vị ngữ của",
    example: "thì  *  là đồng vị ngữ của",
  },
  {
    word: "đồng vọng",
    part_of_speech: "động từ",
    meaning: "(cũ, văn chương) vọng lại từ xa: tiếng sóng biển đồng vọng",
    example: "tiếng sóng biển đồng vọng",
  },
  {
    word: "đông y",
    part_of_speech: "danh từ",
    meaning:
      "nền y học cổ truyền của các nước phương Đông: kết hợp đông y và tây y * bệnh viện đông y",
    example: "kết hợp đông y và tây y * bệnh viện đông y",
  },
  {
    word: "đồng ý",
    part_of_speech: "động từ",
    meaning:
      "có cùng ý kiến, nhất trí với ý kiến đã nêu: không đồng ý gia hạn hợp đồng * đồng ý với quyết định của mọi người",
    example:
      "không đồng ý gia hạn hợp đồng * đồng ý với quyết định của mọi người",
  },
  {
    word: "đốp chát",
    part_of_speech: "động từ",
    meaning: "như bốp chát (nhưng nghĩa mạnh hơn): ăn nói đốp chát",
    example: "ăn nói đốp chát",
  },
  {
    word: "đốp",
    part_of_speech: "danh từ",
    meaning: "(cũ, hiếm) như mõ: thằng đốp * mẹ đốp",
    example: "thằng đốp * mẹ đốp",
  },
  {
    word: "đốp",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng to và giòn, đanh, như tiếng bật nổ mạnh: nổ đánh đốp * cái chai vỡ đốp một cái",
    example: "nổ đánh đốp * cái chai vỡ đốp một cái",
  },
  {
    word: "đốp",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) nói nặng lời thẳng trước mặt, không chút kiêng nể: đốp cho một trận * không vừa ý là đốp luôn",
    example: "đốp cho một trận * không vừa ý là đốp luôn",
  },
  {
    word: "độp",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng trầm và gọn như tiếng vật nặng, nhỏ và hơi mềm rơi mạnh xuống đất: quả cam rơi độp xuống đất * vỗ đánh độp vào vai bạn",
    example: "quả cam rơi độp xuống đất * vỗ đánh độp vào vai bạn",
  },
  {
    word: "độp",
    part_of_speech: "động từ",
    meaning: "(thông tục) như đốp: nói độp vào mặt",
    example: "nói độp vào mặt",
  },
  {
    word: "độp một cái",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) hết sức bất ngờ, đột ngột: độp một cái, đứng phắt dậy bỏ ra về",
    example: "độp một cái, đứng phắt dậy bỏ ra về",
  },
  {
    word: "đốt",
    part_of_speech: "danh từ",
    meaning:
      "những khúc, đoạn giống nhau trên cơ thể một số động vật, thực vật: đốt tre * đốt mía",
    example: "đốt tre * đốt mía",
  },
  {
    word: "đốt",
    part_of_speech: "danh từ",
    meaning:
      "phần giống nhau của một số bộ phận trong cơ thể: đốt xương sống * đốt ngón tay",
    example: "đốt xương sống * đốt ngón tay",
  },
  {
    word: "đốt",
    part_of_speech: "động từ",
    meaning:
      "(côn trùng) dùng vòi hoặc ngòi đâm vào da người hoặc động vật, gây đau, buốt, ngứa: bị kiến lửa đốt * muỗi đốt",
    example: "bị kiến lửa đốt * muỗi đốt",
  },
  {
    word: "đốt",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nói một cách chua cay hay mỉa mai châm chọc: đốt cho mấy câu",
    example: "đốt cho mấy câu",
  },
  {
    word: "đốt",
    part_of_speech: "động từ",
    meaning:
      "làm cho cháy: đốt củi * đốt than * đốt lò gạch * nắng như thiêu như đốt",
    example: "đốt củi * đốt than * đốt lò gạch * nắng như thiêu như đốt",
  },
  {
    word: "đột kích",
    part_of_speech: "động từ",
    meaning:
      "đánh một cách mau lẹ và bất ngờ bằng binh lực, hoả lực: đột kích đồn địch",
    example: "đột kích đồn địch",
  },
  {
    word: "đột kích",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tiến hành một hoạt động nào đó một cách bất ngờ, không có dự định từ trước (thường là trong thời gian ngắn): kiểm tra đột kích",
    example: "kiểm tra đột kích",
  },
  {
    word: "đột biến",
    part_of_speech: "danh từ",
    meaning:
      "sự biến đổi đột ngột của một tính trạng ở cá thể sinh vật do thay đổi cấu trúc di truyền: đột biến gen * đột biến nhiễm sắc thể",
    example: "đột biến gen * đột biến nhiễm sắc thể",
  },
  {
    word: "đột",
    part_of_speech: "động từ",
    meaning:
      "làm thủng lỗ bằng khuôn với một lực ép mạnh và nhanh: đột miếng tôn * đột dây thắt lưng",
    example: "đột miếng tôn * đột dây thắt lưng",
  },
  {
    word: "đột",
    part_of_speech: "động từ",
    meaning: "khâu từng mũi một và có lại mũi: khâu đột cho chắc",
    example: "khâu đột cho chắc",
  },
  {
    word: "đột",
    part_of_speech: "danh từ",
    meaning: "dụng cụ dùng để đột lỗ: cái đột",
    example: "cái đột",
  },
  {
    word: "đột",
    part_of_speech: "phụ từ",
    meaning: "(hiếm) như bỗng: đột nghĩ ra",
    example: "đột nghĩ ra",
  },
  {
    word: "đột khởi",
    part_of_speech: "động từ",
    meaning:
      "nổi lên một cách thình lình: chiến tranh đột khởi * sự hăng hái đột khởi trong lòng",
    example: "chiến tranh đột khởi * sự hăng hái đột khởi trong lòng",
  },
  {
    word: "đột nhiên",
    part_of_speech: "phụ từ",
    meaning:
      "(hành động, quá trình xảy ra) một cách hết sức đột ngột: đang đi đột nhiên đứng lại * giá xi măng đột nhiên tăng vọt",
    example: "đang đi đột nhiên đứng lại * giá xi măng đột nhiên tăng vọt",
  },
  {
    word: "đột ngột",
    part_of_speech: "tính từ",
    meaning:
      "rất bất ngờ, hoàn toàn không có một dấu hiệu gì báo trước: cảm đột ngột * đột ngột về thăm nhà * trời đột ngột đổ mưa",
    example: "cảm đột ngột * đột ngột về thăm nhà * trời đột ngột đổ mưa",
  },
  {
    word: "đột nhập",
    part_of_speech: "động từ",
    meaning:
      "bất ngờ tiến vào bên trong: kẻ gian đột nhập vào nhà * vi trùng đột nhập vào cơ thể",
    example: "kẻ gian đột nhập vào nhà * vi trùng đột nhập vào cơ thể",
  },
  {
    word: "đột nhập",
    part_of_speech: "động từ",
    meaning:
      "từ dùng trong Công giáo, đối lập với đạo, để gọi chung những người không theo Công giáo hoặc những việc ngoài đạo: việc đời, việc đạo",
    example: "việc đời, việc đạo",
  },
  {
    word: "đột nhập",
    part_of_speech: "động từ",
    meaning:
      "khoảng thời gian dài không xác định trong thời gian tồn tại nói chung của loài người: chuyện đời xưa",
    example: "chuyện đời xưa",
  },
  {
    word: "đột nhập",
    part_of_speech: "động từ",
    meaning:
      "lớp người sống thành những thế hệ kế tiếp nhau: truyền từ đời này sang đời khác * ai giàu ba họ, ai khó ba đời (tng)",
    example:
      "truyền từ đời này sang đời khác * ai giàu ba họ, ai khó ba đời (tng)",
  },
  {
    word: "đột nhập",
    part_of_speech: "động từ",
    meaning:
      "thời gian giữ ngôi vua: đời vua Lý Thái Tổ * đời nhà Trần * Nguyễn Trãi là bậc công thần lớn đời Lê",
    example:
      "đời vua Lý Thái Tổ * đời nhà Trần * Nguyễn Trãi là bậc công thần lớn đời Lê",
  },
  {
    word: "đột nhập",
    part_of_speech: "động từ",
    meaning:
      "khoảng thời gian hoạt động của con người trong một lĩnh vực nhất định: đời học sinh * đời lính",
    example: "đời học sinh * đời lính",
  },
  {
    word: "đột nhập",
    part_of_speech: "động từ",
    meaning:
      "lần kết hôn (với người mà nay đã bỏ hoặc đã chết): anh ta đã có một đời vợ",
    example: "anh ta đã có một đời vợ",
  },
  {
    word: "đột nhập",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) thời gian sản xuất, dùng để chỉ kiểu, loại máy móc được sản xuất ở một giai đoạn, một thời điểm, đánh dấu một tiến bộ kĩ thuật nhất định: xe đời 81 * máy móc đời mới",
    example: "xe đời 81 * máy móc đời mới",
  },
  {
    word: "đốt phá",
    part_of_speech: "động từ",
    meaning: "đốt và phá huỷ (nói khái quát): giặc đốt phá làng mạc",
    example: "giặc đốt phá làng mạc",
  },
  {
    word: "đột phá",
    part_of_speech: "động từ",
    meaning:
      "chọc thủng, phá vỡ một số đoạn trong hệ thống phòng ngự của đối phương để mở đường tiến quân: đột phá phòng tuyến địch",
    example: "đột phá phòng tuyến địch",
  },
  {
    word: "đột phá",
    part_of_speech: "động từ",
    meaning:
      "tạo nên những bước chuyển biến mới, mạnh mẽ: bước đột phá của doanh nghiệp * đột phá trong cải cách kinh tế",
    example: "bước đột phá của doanh nghiệp * đột phá trong cải cách kinh tế",
  },
  {
    word: "đột rập",
    part_of_speech: "động từ",
    meaning:
      "tạo ra hàng loạt sản phẩm giống nhau bằng khuôn với lực ép mạnh và nhanh: sản xuất đồ nhôm bằng công nghệ đột rập",
    example: "sản xuất đồ nhôm bằng công nghệ đột rập",
  },
  {
    word: "đột tử",
    part_of_speech: "động từ",
    meaning:
      "(người) chết đột ngột (trong tình trạng sức khoẻ, bệnh tật không có dấu hiệu gì báo trước): bị đột tử do tiêm thuốc quá liều",
    example: "bị đột tử do tiêm thuốc quá liều",
  },
  {
    word: "đơ",
    part_of_speech: "",
    meaning:
      "có cảm giác như cứng ra, mất hẳn khả năng cử động: nằm thẳng đơ * ngồi đơ ra",
    example: "nằm thẳng đơ * ngồi đơ ra",
  },
  {
    word: "đột phá khẩu",
    part_of_speech: "danh từ",
    meaning:
      "nơi, vị trí tuyến phòng ngự của đối phương bị chọc thủng: mở đột phá khẩu cho đồng đội tiến vào",
    example: "mở đột phá khẩu cho đồng đội tiến vào",
  },
  {
    word: "đờ",
    part_of_speech: "tính từ",
    meaning:
      "cứng ra như không còn cảm giác, không còn cử động được nữa: lạnh quá, tay cứng đờ * đứng đờ người * mắt đờ ra vì buồn ngủ",
    example: "lạnh quá, tay cứng đờ * đứng đờ người * mắt đờ ra vì buồn ngủ",
  },
  {
    word: "đột xuất",
    part_of_speech: "tính từ",
    meaning:
      "đặc biệt và bất ngờ, không có trong dự định: có việc đột xuất nên đến muộn * đi công tác đột xuất",
    example: "có việc đột xuất nên đến muộn * đi công tác đột xuất",
  },
  {
    word: "đột xuất",
    part_of_speech: "tính từ",
    meaning:
      "nổi bật, trội hẳn lên ngoài dự tính: thông minh đột xuất * tiến bộ đột xuất",
    example: "thông minh đột xuất * tiến bộ đột xuất",
  },
  {
    word: "đỡ",
    part_of_speech: "động từ",
    meaning:
      "giữ ở phía dưới cho khỏi rơi, khỏi ngã: giá đỡ * làm rơi lọ hoa may mà lại đỡ được * đỡ cho bệnh nhân nằm xuống",
    example:
      "giá đỡ * làm rơi lọ hoa may mà lại đỡ được * đỡ cho bệnh nhân nằm xuống",
  },
  {
    word: "đỡ",
    part_of_speech: "động từ",
    meaning:
      "đưa tay đón nhận cái được trân trọng hoặc vật nặng ở người khác: đỡ lấy món quà * đỡ bao gạo cho mẹ",
    example: "đỡ lấy món quà * đỡ bao gạo cho mẹ",
  },
  {
    word: "đỡ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đỡ đẻ (nói tắt): bà đỡ * sắp sinh rồi mà chưa tìm được người đỡ",
    example: "bà đỡ * sắp sinh rồi mà chưa tìm được người đỡ",
  },
  {
    word: "đỡ",
    part_of_speech: "động từ",
    meaning:
      "đón để ngăn lại cái có thể gây tổn thương, tổn thất cho mình: đỡ quả bóng * đỡ đạn * giơ tay ra đỡ đòn",
    example: "đỡ quả bóng * đỡ đạn * giơ tay ra đỡ đòn",
  },
  {
    word: "đỡ",
    part_of_speech: "động từ",
    meaning:
      "giúp phần nào để giảm bớt khó khăn, lúng túng: được mẹ đỡ tội cho * con bé đã biết làm đỡ việc nhà * nói đỡ lời",
    example: "được mẹ đỡ tội cho * con bé đã biết làm đỡ việc nhà * nói đỡ lời",
  },
  {
    word: "đỡ",
    part_of_speech: "động từ",
    meaning:
      "giảm nhẹ, bớt đi phần nào sự đau đớn, khó khăn, lúng túng: ăn tạm cho đỡ đói * bệnh đã đỡ chút ít * tổ chức đơn giản cho đỡ tốn kém",
    example:
      "ăn tạm cho đỡ đói * bệnh đã đỡ chút ít * tổ chức đơn giản cho đỡ tốn kém",
  },
  {
    word: "đỡ",
    part_of_speech: "phụ từ",
    meaning:
      '(phương ngữ) tạm, trong khi không có cách nào tốt hơn: không có bút bi thì dùng đỡ bút chì * "Thầy thông lo dọn nhà gấp làm chi; ở đỡ đây với vợ chồng tôi được mà." (HBChánh; 4)',
    example:
      'không có bút bi thì dùng đỡ bút chì * "Thầy thông lo dọn nhà gấp làm chi; ở đỡ đây với vợ chồng tôi được mà." (HBChánh; 4)',
  },
  {
    word: "đờ đẫn",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái như mất hết khả năng phản ứng với các kích thích bên ngoài: tiếc của đờ đẫn cả người",
    example: "tiếc của đờ đẫn cả người",
  },
  {
    word: "đớ",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) có cảm giác như lưỡi bị cứng lại, không nói được nữa: đớ lưỡi, không nói được câu nào",
    example: "đớ lưỡi, không nói được câu nào",
  },
  {
    word: "đỡ đần",
    part_of_speech: "động từ",
    meaning:
      'giúp đỡ phần nào để cho bớt khó khăn, vất vả: làm thêm để đỡ đần gia đình * "Anh em như chân như tay, Rách lành đùm bọc, dở hay đỡ đần." (ca dao)',
    example:
      'làm thêm để đỡ đần gia đình * "Anh em như chân như tay, Rách lành đùm bọc, dở hay đỡ đần." (ca dao)',
  },
  {
    word: "đời",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian sống của một sinh vật: mới ba mươi tuổi đời * những ngày cuối đời",
    example: "mới ba mươi tuổi đời * những ngày cuối đời",
  },
  {
    word: "đời",
    part_of_speech: "danh từ",
    meaning:
      "cuộc sống, sự sống của con người: đổi đời * giúp ích cho đời * tinh thần lạc quan, yêu đời",
    example: "đổi đời * giúp ích cho đời * tinh thần lạc quan, yêu đời",
  },
  {
    word: "đời",
    part_of_speech: "danh từ",
    meaning:
      "xã hội loài người, thế gian: mọi sự ở đời * tiếng còn để đời * sống ở trên đời",
    example: "mọi sự ở đời * tiếng còn để đời * sống ở trên đời",
  },
  {
    word: "đới",
    part_of_speech: "danh từ",
    meaning:
      "phần của bề mặt Trái Đất phân chia bởi hai vòng vĩ tuyến chọn lựa: bề mặt Trái Đất được phân thành năm đới",
    example: "bề mặt Trái Đất được phân thành năm đới",
  },
  {
    word: "đỡ đầu",
    part_of_speech: "động từ",
    meaning:
      "nhận trách nhiệm quan tâm, giúp đỡ nhằm bảo đảm cuộc sống hay sự phát triển bình thường: nhận đỡ đầu một em bé mồ côi",
    example: "nhận đỡ đầu một em bé mồ côi",
  },
  {
    word: "đỡ đầu",
    part_of_speech: "động từ",
    meaning:
      "nhận trách nhiệm hướng dẫn một tín đồ Công giáo khi nhập đạo (từ dùng trong Công giáo): cha đỡ đầu",
    example: "cha đỡ đầu",
  },
  {
    word: "đỡ đẻ",
    part_of_speech: "động từ",
    meaning:
      "giúp đỡ việc sinh đẻ, khi thai lọt lòng: đi học lớp đỡ đẻ * làm nghề đỡ đẻ",
    example: "đi học lớp đỡ đẻ * làm nghề đỡ đẻ",
  },
  {
    word: "đợi chờ",
    part_of_speech: "động từ",
    meaning: "như chờ đợi: đợi chờ người thương * uổng công đợi chờ",
    example: "đợi chờ người thương * uổng công đợi chờ",
  },
  {
    word: "đợi",
    part_of_speech: "động từ",
    meaning:
      "chờ ai hoặc cái gì mà biết hoặc tin là sẽ tới, sẽ có, sẽ xảy ra: đứng đợi bạn * đợi tin con * đợi tạnh mưa rồi hãy đi",
    example: "đứng đợi bạn * đợi tin con * đợi tạnh mưa rồi hãy đi",
  },
  {
    word: "đời chót",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) (máy móc) đời cuối cùng, được sản xuất gần đây nhất và thường hiện đại nhất so với những cái cùng loại; phân biệt với đời đầu: xe cub 81 đời chót * máy tính đời chót",
    example: "xe cub 81 đời chót * máy tính đời chót",
  },
  {
    word: "đời đầu",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) (máy móc) đời đầu tiên, được sản xuất trong loạt đầu; phân biệt với đời chót: loạt xe đời đầu hiện nay không còn bán trên thị trường",
    example: "loạt xe đời đầu hiện nay không còn bán trên thị trường",
  },
  {
    word: "đời đời",
    part_of_speech: "",
    meaning:
      "hết đời này tiếp đến đời khác; mãi mãi: đời đời ghi nhớ công ơn các liệt sĩ",
    example: "đời đời ghi nhớ công ơn các liệt sĩ",
  },
  {
    word: "đời mới",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) (máy móc) thế hệ mới, thường được cải tiến hiện đại hơn: đi xe ô tô đời mới * tủ lạnh đời mới",
    example: "đi xe ô tô đời mới * tủ lạnh đời mới",
  },
  {
    word: "đời nào",
    part_of_speech: "",
    meaning:
      "tổ hợp dùng để phủ định dứt khoát điều mà người đối thoại có vẻ nửa tin nửa ngờ, và khẳng định là không thể xảy ra được vì vô lí: đời nào nó chịu làm thế! * việc ấy thì không đời nào!",
    example: "đời nào nó chịu làm thế! * việc ấy thì không đời nào!",
  },
  {
    word: "đời sống",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ những hiện tượng diễn ra ở cơ thể sinh vật trong suốt khoảng thời gian sống (nói tổng quát): theo dõi đời sống của cây lúa * đời sống con người",
    example: "theo dõi đời sống của cây lúa * đời sống con người",
  },
  {
    word: "đời sống",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ nói chung những hoạt động trong một lĩnh vực nào đó của con người, của xã hội: đời sống văn hoá * đời sống tinh thần",
    example: "đời sống văn hoá * đời sống tinh thần",
  },
  {
    word: "đời sống",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ nói chung những điều kiện sinh hoạt của con người, của xã hội: đời sống ngày một khá hơn * cải thiện đời sống",
    example: "đời sống ngày một khá hơn * cải thiện đời sống",
  },
  {
    word: "đời sống",
    part_of_speech: "danh từ",
    meaning:
      "lối sống chung của một tập thể, một xã hội: đời sống đô thị * đám cưới đời sống mới",
    example: "đời sống đô thị * đám cưới đời sống mới",
  },
  {
    word: "đời thuở",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) thời gian không xác định rõ, nhưng xa lắm trong quá khứ, hoặc đôi khi trong tương lai: chuyện đã xảy ra từ đời thuở nào",
    example: "chuyện đã xảy ra từ đời thuở nào",
  },
  {
    word: "đơm",
    part_of_speech: "danh từ",
    meaning:
      "đồ đan bằng tre đặt ở chỗ nước chảy để đón bắt cá: dùng đơm để bắt cá",
    example: "dùng đơm để bắt cá",
  },
  {
    word: "đơm",
    part_of_speech: "động từ",
    meaning: "dùng đơm hoặc lờ để bắt cá: đơm cá",
    example: "đơm cá",
  },
  {
    word: "đơm",
    part_of_speech: "động từ",
    meaning:
      '(Phương ngữ, Khẩu ngữ) bố trí sẵn để lừa bắt hoặc để đón đánh: phục sẵn để đơm địch * "Ngồi buồn xe chỉ ngóng go, Đơm chim chim chạy, đơm cò cò bay." (Cdao)',
    example:
      'phục sẵn để đơm địch * "Ngồi buồn xe chỉ ngóng go, Đơm chim chim chạy, đơm cò cò bay." (Cdao)',
  },
  {
    word: "đơm",
    part_of_speech: "động từ",
    meaning:
      "(hoa, lá) nảy sinh ra từ cơ thể thực vật: đơm hoa kết trái * lúa đã đơm bông",
    example: "đơm hoa kết trái * lúa đã đơm bông",
  },
  {
    word: "đơm",
    part_of_speech: "động từ",
    meaning:
      "lấy thức ăn từ xoong nồi ra bát, đĩa, v.v.: đơm cho một bát thật đầy * đơm xôi ra đĩa",
    example: "đơm cho một bát thật đầy * đơm xôi ra đĩa",
  },
  {
    word: "đơm",
    part_of_speech: "động từ",
    meaning:
      "khâu cho bộ phận phụ (như khuy, dải, v.v.) dính liền vào quần áo: đơm lại cái cúc áo bị đứt * đơm khuy thùa khuyết",
    example: "đơm lại cái cúc áo bị đứt * đơm khuy thùa khuyết",
  },
  {
    word: "đơm đặt",
    part_of_speech: "động từ",
    meaning:
      "thêu dệt, bịa chuyện về người khác với dụng ý xấu: đơm đặt đủ chuyện",
    example: "đơm đặt đủ chuyện",
  },
  {
    word: "đờm",
    part_of_speech: "danh từ",
    meaning:
      "chất nước nhờn có lẫn tạp chất do khí quản và phổi bị bệnh thải ra: khạc ra đờm * thuốc long đờm",
    example: "khạc ra đờm * thuốc long đờm",
  },
  {
    word: "đời thuở nhà ai",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị ý ngạc nhiên, hàm ý chê trách về điều cho là trái với lẽ thường ở đời: đời thuở nhà ai vợ lại đi chửi chồng",
    example: "đời thuở nhà ai vợ lại đi chửi chồng",
  },
  {
    word: "đời thường",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) thuộc về cuộc sống hằng ngày, bình thường, không có gì khác thường hoặc phi thường: sinh hoạt đời thường * chuyện đời thường",
    example: "sinh hoạt đời thường * chuyện đời thường",
  },
  {
    word: "đơn",
    part_of_speech: "danh từ",
    meaning:
      "bệnh nổi mẩn ngứa ngoài da (thường chỉ bệnh nổi mày đay): nổi đơn đầy người",
    example: "nổi đơn đầy người",
  },
  {
    word: "đơn",
    part_of_speech: "danh từ",
    meaning:
      "bản yêu cầu về việc riêng, trình bày chính thức với tổ chức hoặc người có thẩm quyền: nộp đơn xin việc * làm đơn kiện * đơn khiếu nại",
    example: "nộp đơn xin việc * làm đơn kiện * đơn khiếu nại",
  },
  {
    word: "đơn",
    part_of_speech: "danh từ",
    meaning:
      "bản kê những mặt hàng cần mua để gửi cho nơi bán: sản xuất theo đơn đặt hàng",
    example: "sản xuất theo đơn đặt hàng",
  },
  {
    word: "đơn",
    part_of_speech: "danh từ",
    meaning:
      "bản kê thuốc trị bệnh, thường có hướng dẫn cách sử dụng: đơn thuốc * kê đơn bốc thuốc",
    example: "đơn thuốc * kê đơn bốc thuốc",
  },
  {
    word: "đơn",
    part_of_speech: "tính từ",
    meaning:
      "chỉ có một thành phần: giường đơn (giường cho một người nằm) * chăn đơn gối chiếc",
    example: "giường đơn (giường cho một người nằm) * chăn đơn gối chiếc",
  },
  {
    word: "đớn",
    part_of_speech: "tính từ",
    meaning:
      "(thóc, gạo) bị gãy, vỡ nhiều khi giã hoặc xay: gạo đớn * thóc xay bị đớn",
    example: "gạo đớn * thóc xay bị đớn",
  },
  {
    word: "đơn ca",
    part_of_speech: "động từ",
    meaning:
      "hát một người (một hình thức biểu diễn nghệ thuật): tiết mục đơn ca * hát đơn ca",
    example: "tiết mục đơn ca * hát đơn ca",
  },
  {
    word: "đơn bạc",
    part_of_speech: "tính từ",
    meaning: "(hiếm) mỏng manh, ít ỏi: lễ vật đơn bạc",
    example: "lễ vật đơn bạc",
  },
  {
    word: "đơn bạc",
    part_of_speech: "tính từ",
    meaning:
      "không nhớ ơn nghĩa, không giữ được tình nghĩa trọn vẹn: ăn ở đơn bạc * con người đơn bạc",
    example: "ăn ở đơn bạc * con người đơn bạc",
  },
  {
    word: "đơn chiếc",
    part_of_speech: "tính từ",
    meaning: "chỉ có một mình, không có đôi: sống đơn chiếc",
    example: "sống đơn chiếc",
  },
  {
    word: "đơn chiếc",
    part_of_speech: "tính từ",
    meaning:
      "(cảnh gia đình) có rất ít người, không có ai để nương tựa, giúp đỡ nhau: cảnh nhà đơn chiếc",
    example: "cảnh nhà đơn chiếc",
  },
  {
    word: "đơn côi",
    part_of_speech: "tính từ",
    meaning:
      "chỉ có một mình, không có người để nương tựa, bầu bạn: chú bé đơn côi",
    example: "chú bé đơn côi",
  },
  {
    word: "đơn cử",
    part_of_speech: "động từ",
    meaning:
      "nêu riêng ra một vài việc để làm dẫn chứng: đơn cử một vài thí dụ",
    example: "đơn cử một vài thí dụ",
  },
  {
    word: "đơn giản",
    part_of_speech: "tính từ",
    meaning:
      "không có nhiều thành phần hoặc nhiều mặt, không rắc rối: phép tính đơn giản * suy nghĩ đơn giản * tưởng phức tạp hoá ra lại rất đơn giản",
    example:
      "phép tính đơn giản * suy nghĩ đơn giản * tưởng phức tạp hoá ra lại rất đơn giản",
  },
  {
    word: "đơn giản",
    part_of_speech: "động từ",
    meaning:
      "như đơn giản hoá: đơn giản bộ máy hành chính * đơn giản các thủ tục",
    example: "đơn giản bộ máy hành chính * đơn giản các thủ tục",
  },
  {
    word: "đơn giản hoá",
    part_of_speech: "động từ",
    meaning: "làm cho trở nên đơn giản: đơn giản hoá vấn đề",
    example: "đơn giản hoá vấn đề",
  },
  {
    word: "đớn hèn",
    part_of_speech: "tính từ",
    meaning:
      "hèn đến mức không còn giữ được tư cách, phẩm giá, rất đáng khinh: kẻ đớn hèn",
    example: "kẻ đớn hèn",
  },
  {
    word: "đơn điệu",
    part_of_speech: "tính từ",
    meaning:
      "(âm thanh) chỉ có một điệu, một giọng lặp đi lặp lại, gây cảm giác nhàm chán: giọng văn đơn điệu * bản nhạc đơn điệu",
    example: "giọng văn đơn điệu * bản nhạc đơn điệu",
  },
  {
    word: "đơn điệu",
    part_of_speech: "tính từ",
    meaning:
      "ít thay đổi, lặp đi lặp lại cùng một kiểu, gây cảm giác tẻ nhạt và buồn chán: cuộc sống đơn điệu",
    example: "cuộc sống đơn điệu",
  },
  {
    word: "đơn độc",
    part_of_speech: "tính từ",
    meaning:
      "chỉ riêng một mình, tách khỏi quan hệ với đồng loại: sống đơn độc một mình",
    example: "sống đơn độc một mình",
  },
  {
    word: "đơn lập",
    part_of_speech: "tính từ",
    meaning:
      "(loại hình ngôn ngữ) có quan hệ giữa các từ được biểu thị bằng những phương tiện nằm ngoài từ, như trật tự từ, hư từ: ngôn ngữ đơn lập * tiếng Việt là một ngôn ngữ thuộc loại hình đơn lập",
    example:
      "ngôn ngữ đơn lập * tiếng Việt là một ngôn ngữ thuộc loại hình đơn lập",
  },
  {
    word: "đơn sai",
    part_of_speech: "tính từ",
    meaning:
      '(cũ) thiếu trung thực, không giữ đúng như lời: nói đơn sai * "Cửa hàng buôn bán châu Thai, Thực thà có một, đơn sai chẳng hề." (TKiều)',
    example:
      'nói đơn sai * "Cửa hàng buôn bán châu Thai, Thực thà có một, đơn sai chẳng hề." (TKiều)',
  },
  {
    word: "đơn nguyên",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị độc lập của công trình xây dựng, được giới hạn quy ước trên diện tích mặt bằng: khu chung cư có ba đơn nguyên",
    example: "khu chung cư có ba đơn nguyên",
  },
  {
    word: "đơn lẻ",
    part_of_speech: "tính từ",
    meaning:
      "riêng lẻ, không phổ biến: chỉ có một vài hiện tượng đơn lẻ * hoạt động đơn lẻ",
    example: "chỉ có một vài hiện tượng đơn lẻ * hoạt động đơn lẻ",
  },
  {
    word: "đơn lẻ",
    part_of_speech: "tính từ",
    meaning: "lẻ loi, đơn chiếc: sống đơn lẻ",
    example: "sống đơn lẻ",
  },
  {
    word: "đơn nhất",
    part_of_speech: "tính từ",
    meaning: "(hiếm) có cấu tạo chỉ một thành phần: một môi trường đơn nhất",
    example: "một môi trường đơn nhất",
  },
  {
    word: "đơn nhất",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất riêng lẻ, xác định trong không gian và thời gian: quan hệ giữa cái đơn nhất và cái phổ biến",
    example: "quan hệ giữa cái đơn nhất và cái phổ biến",
  },
  {
    word: "đơn phương",
    part_of_speech: "tính từ",
    meaning:
      "riêng một bên, không có sự thoả thuận hoặc sự tham gia của bên kia; phân biệt với đa phương, song phương: tình yêu đơn phương * đơn phương chấm dứt hợp đồng",
    example: "tình yêu đơn phương * đơn phương chấm dứt hợp đồng",
  },
  {
    word: "đơn sơ",
    part_of_speech: "tính từ",
    meaning:
      "đơn giản đến mức sơ sài: nhà cửa đơn sơ * đám cưới được tổ chức rất đơn sơ",
    example: "nhà cửa đơn sơ * đám cưới được tổ chức rất đơn sơ",
  },
  {
    word: "đơn sắc",
    part_of_speech: "tính từ",
    meaning: "(ánh sáng hoặc bức xạ) chỉ có một màu xác định: ánh sáng đơn sắc",
    example: "ánh sáng đơn sắc",
  },
  {
    word: "đơn thuần",
    part_of_speech: "tính từ",
    meaning:
      "hoàn toàn chỉ có một mặt nào đó: quan hệ mua bán đơn thuần * món quà không chỉ mang ý nghĩa vật chất đơn thuần",
    example:
      "quan hệ mua bán đơn thuần * món quà không chỉ mang ý nghĩa vật chất đơn thuần",
  },
  {
    word: "đơn thức",
    part_of_speech: "danh từ",
    meaning:
      "biểu thức đại số chỉ chứa phép nhân và phép luỹ thừa đối với các chữ: (a + b)2 không phải là đơn thức",
    example: "(a + b)2 không phải là đơn thức",
  },
  {
    word: "đơn thân",
    part_of_speech: "tính từ",
    meaning: "chỉ sống một mình, không lập gia đình: sống đơn thân",
    example: "sống đơn thân",
  },
  {
    word: "đơn từ",
    part_of_speech: "danh từ",
    meaning: "đơn yêu cầu (nói khái quát): đơn từ khiếu nại",
    example: "đơn từ khiếu nại",
  },
  {
    word: "đơn tiết",
    part_of_speech: "tính từ",
    meaning: "(từ) chỉ có một âm tiết: ,  * ,  *  là những từ đơn tiết",
    example: ",  * ,  *  là những từ đơn tiết",
  },
  {
    word: "đơn tính",
    part_of_speech: "tính từ",
    meaning:
      "chỉ có một giới tính, đực hoặc cái: cá rô phi đơn tính * hoa đơn tính",
    example: "cá rô phi đơn tính * hoa đơn tính",
  },
  {
    word: "đơn tử",
    part_of_speech: "danh từ",
    meaning: "như đơn nguyên: học thuyết về đơn tử của Leibniz",
    example: "học thuyết về đơn tử của Leibniz",
  },
  {
    word: "đơn vị",
    part_of_speech: "danh từ",
    meaning:
      "yếu tố mà tập hợp làm thành một chỉnh thể, nói trong mối quan hệ với chỉnh thể ấy: đơn vị từ vựng",
    example: "đơn vị từ vựng",
  },
  {
    word: "đơn vị",
    part_of_speech: "danh từ",
    meaning:
      "vật riêng lẻ coi như không có gì khác với những vật riêng lẻ khác trong một tập hợp gồm những vật cùng loại, dùng để đếm, để tính toán: đơn vị sản phẩm",
    example: "đơn vị sản phẩm",
  },
  {
    word: "đơn vị",
    part_of_speech: "danh từ",
    meaning: "đơn vị đo lường (nói tắt): đơn vị cơ bản đo độ dài là mét",
    example: "đơn vị cơ bản đo độ dài là mét",
  },
  {
    word: "đơn vị",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức bộ phận trong một hệ thống tổ chức nào đó: xã, phường là đơn vị hành chính cơ sở",
    example: "xã, phường là đơn vị hành chính cơ sở",
  },
  {
    word: "đơn vị",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận lực lượng vũ trang được biên chế theo quy định: đơn vị pháo cao xạ * bạn cùng đơn vị",
    example: "đơn vị pháo cao xạ * bạn cùng đơn vị",
  },
  {
    word: "đợt",
    part_of_speech: "danh từ",
    meaning:
      "phần nhô ra hoặc nổi lên ít nhiều đều đặn giữa các phần khác kế tiếp nhau: sóng dâng cao hết đợt này đến đợt khác * dãy núi có nhiều đợt",
    example: "sóng dâng cao hết đợt này đến đợt khác * dãy núi có nhiều đợt",
  },
  {
    word: "đợt",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị hiện tượng hoặc sự việc diễn ra thành những lượt kế tiếp nhau một cách ít nhiều đều đặn: hai đợt gió mùa liên tiếp * phát hành công trái đợt hai",
    example: "hai đợt gió mùa liên tiếp * phát hành công trái đợt hai",
  },
  {
    word: "đơn vị học trình",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị xác định khối lượng kiến thức được truyền đạt trong 15 tiết trên giảng đường đại học: xác định số học trình của một môn học",
    example: "xác định số học trình của một môn học",
  },
  {
    word: "đớp",
    part_of_speech: "động từ",
    meaning: "há miệng ngoạm nhanh lấy: cá đớp mồi",
    example: "cá đớp mồi",
  },
  {
    word: "đớp",
    part_of_speech: "động từ",
    meaning: "(thông tục) ăn: đớp đi cho nhanh!",
    example: "đớp đi cho nhanh!",
  },
  {
    word: "đớt",
    part_of_speech: "tính từ",
    meaning:
      "có cách nói không bình thường, không phát âm đúng được một số âm do lưỡi bị tật: bị tật nói đớt từ nhỏ",
    example: "bị tật nói đớt từ nhỏ",
  },
  {
    word: "đu",
    part_of_speech: "động từ",
    meaning:
      "(tay) nắm vào điểm tựa để di động thân thể lơ lửng trong khoảng không: đu người để lên xà * khỉ đu cây",
    example: "đu người để lên xà * khỉ đu cây",
  },
  {
    word: "đu",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ gồm một thanh ngang treo bằng hai sợi dây hoặc bằng hai thân tre để người đứng lên nhún cho đưa đi đưa lại: chơi đu",
    example: "chơi đu",
  },
  {
    word: "đu bay",
    part_of_speech: "danh từ",
    meaning:
      "tiết mục xiếc biểu diễn nhào lộn trên không giữa khoảng cách hai dàn đu đặt ở hai bên sân khấu, cao sát vòm rạp: biểu diễn đu bay * tiết mục đu bay",
    example: "biểu diễn đu bay * tiết mục đu bay",
  },
  {
    word: "đủ",
    part_of_speech: "",
    meaning:
      "có số lượng hoặc mức độ đáp ứng được yêu cầu, không ít hơn, cũng không nhiều hơn: chưa trả đủ số tiền đã vay * đủ sức làm * tiền lương không đủ sống",
    example:
      "chưa trả đủ số tiền đã vay * đủ sức làm * tiền lương không đủ sống",
  },
  {
    word: "đủ",
    part_of_speech: "",
    meaning:
      'có tất cả trong phạm vi có thể có, không thiếu: khách đã đến đủ * đòi đủ thứ * "Gió mùa thu mẹ ru con ngủ, Năm canh chầy, thức đủ năm canh." (ca dao)',
    example:
      'khách đã đến đủ * đòi đủ thứ * "Gió mùa thu mẹ ru con ngủ, Năm canh chầy, thức đủ năm canh." (ca dao)',
  },
  {
    word: "đú đa đú đởn",
    part_of_speech: "",
    meaning: "như đú đởn (nhưng ý nhấn mạnh hơn): suốt ngày chỉ đú đa đú đởn!",
    example: "suốt ngày chỉ đú đa đú đởn!",
  },
  {
    word: "đù đờ",
    part_of_speech: "tính từ",
    meaning:
      "có vẻ chậm chạp, không tinh nhanh trong hành động: trông anh ta có vẻ đù đờ * làm cái gì cũng đù đờ",
    example: "trông anh ta có vẻ đù đờ * làm cái gì cũng đù đờ",
  },
  {
    word: "đú đởn",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đùa cợt không đứng đắn, thường giữa nam và nữ: đú đởn với trai",
    example: "đú đởn với trai",
  },
  {
    word: "đu đưa",
    part_of_speech: "động từ",
    meaning:
      "đưa qua đưa lại một cách nhẹ nhàng trong khoảng không: cành cây đu đưa trước gió",
    example: "cành cây đu đưa trước gió",
  },
  {
    word: "đũa",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng hình que ghép thành từng đôi, để và cơm và gắp thức ăn: so đũa * dùng đũa gắp thức ăn * bé đang tập ăn bằng đũa",
    example: "so đũa * dùng đũa gắp thức ăn * bé đang tập ăn bằng đũa",
  },
  {
    word: "đũa",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) nan hoa: đũa xe đạp",
    example: "đũa xe đạp",
  },
  {
    word: "đùa bỡn",
    part_of_speech: "động từ",
    meaning: "đùa một cách không nghiêm chỉnh: tính hay đùa bỡn",
    example: "tính hay đùa bỡn",
  },
  {
    word: "đu quay",
    part_of_speech: "danh từ",
    meaning:
      "đồ chơi gồm một giàn các thanh vật liệu cứng đan chéo nhau qua một tâm, đầu có gắn chỗ ngồi, quay quanh một trục: chơi đu quay",
    example: "chơi đu quay",
  },
  {
    word: "đùa",
    part_of_speech: "động từ",
    meaning:
      "làm hoặc nói điều gì để cho vui, không phải là thật: nói nửa đùa nửa thật * sóng đùa",
    example: "nói nửa đùa nửa thật * sóng đùa",
  },
  {
    word: "đùa",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) làm cho xáo trộn lên: đùa lại một lượt đất rồi mới gieo mạ",
    example: "đùa lại một lượt đất rồi mới gieo mạ",
  },
  {
    word: "đùa",
    part_of_speech: "động từ",
    meaning:
      "làm cho những vật rời dồn về một phía: khoả nước đùa bèo * gió đùa mái tóc",
    example: "khoả nước đùa bèo * gió đùa mái tóc",
  },
  {
    word: "đua",
    part_of_speech: "động từ",
    meaning:
      "tìm cách giành lấy phần thắng trong cuộc thi có nhiều người tham gia: vận động viên đua xe đạp * giải đua ngựa",
    example: "vận động viên đua xe đạp * giải đua ngựa",
  },
  {
    word: "đua",
    part_of_speech: "động từ",
    meaning:
      "làm theo nhau, không ai chịu kém ai: đua chúng đua bạn * đua nhau ăn diện",
    example: "đua chúng đua bạn * đua nhau ăn diện",
  },
  {
    word: "đua",
    part_of_speech: "động từ",
    meaning:
      "cho nhô ra ngoài: đổ mái đua ra phần đất của tập thể * ban công đua ra ngõ",
    example: "đổ mái đua ra phần đất của tập thể * ban công đua ra ngõ",
  },
  {
    word: "đua ganh",
    part_of_speech: "động từ",
    meaning: "(hiếm) như ganh đua: đua ganh nhau làm ăn * đua ganh với đời",
    example: "đua ganh nhau làm ăn * đua ganh với đời",
  },
  {
    word: "đùa cợt",
    part_of_speech: "động từ",
    meaning:
      "đùa trêu một cách không nghiêm chỉnh, không đứng đắn (nói khát quát): giọng đùa cợt * tính hay đùa cợt",
    example: "giọng đùa cợt * tính hay đùa cợt",
  },
  {
    word: "đua đòi",
    part_of_speech: "động từ",
    meaning:
      "bắt chước trong việc phô trương về hình thức để tỏ ra mình không thua kém ai: đua đòi ăn diện * tính hay đua đòi",
    example: "đua đòi ăn diện * tính hay đua đòi",
  },
  {
    word: "đùa giỡn",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) đùa chơi cho vui (nói khái quát): đùa giỡn nhau * đùa giỡn với số phận",
    example: "đùa giỡn nhau * đùa giỡn với số phận",
  },
  {
    word: "đua chen",
    part_of_speech: "động từ",
    meaning:
      "tìm cách giành nhau phần hơn trong những hoạt động có rất nhiều người tham gia: đua chen danh lợi",
    example: "đua chen danh lợi",
  },
  {
    word: "đùa nghịch",
    part_of_speech: "động từ",
    meaning: "như chơi đùa: bọn trẻ đùa nghịch ngoài sân",
    example: "bọn trẻ đùa nghịch ngoài sân",
  },
  {
    word: "đùa với lửa",
    part_of_speech: "",
    meaning: "như chơi với lửa: đừng có đùa với lửa!",
    example: "đừng có đùa với lửa!",
  },
  {
    word: "đua tranh",
    part_of_speech: "động từ",
    meaning: "ra sức trổ tài để giành phần hơn, phần thắng: đua tranh với đời",
    example: "đua tranh với đời",
  },
  {
    word: "đục ngầu",
    part_of_speech: "tính từ",
    meaning:
      "rất đục, có rất nhiều gợn vẩn nổi lên: dòng sông đục ngầu phù sa * đôi mắt đục ngầu",
    example: "dòng sông đục ngầu phù sa * đôi mắt đục ngầu",
  },
  {
    word: "đục khoét",
    part_of_speech: "động từ",
    meaning:
      "làm cho ruỗng nát, hư hỏng: bị vi trùng lao đục khoét hai lá phổi",
    example: "bị vi trùng lao đục khoét hai lá phổi",
  },
  {
    word: "đục khoét",
    part_of_speech: "động từ",
    meaning:
      "bòn rút của cải, dựa vào quyền thế của mình: quan lại đục khoét của dân",
    example: "quan lại đục khoét của dân",
  },
  {
    word: "đúc kết",
    part_of_speech: "động từ",
    meaning:
      "tổng hợp những điều chi tiết có tính chất chung nhất, trình bày thành những điều khái quát: đúc kết kinh nghiệm",
    example: "đúc kết kinh nghiệm",
  },
  {
    word: "đúc",
    part_of_speech: "động từ",
    meaning:
      "chế tạo bằng cách đổ chất nóng chảy hoặc vật liệu lỏng vào khuôn, rồi để cho rắn cứng lại: bức tượng đúc bằng đồng * đúc gang * hai anh em giống nhau như đúc",
    example:
      "bức tượng đúc bằng đồng * đúc gang * hai anh em giống nhau như đúc",
  },
  {
    word: "đúc",
    part_of_speech: "động từ",
    meaning:
      "tạo ra trên cơ sở chọn lọc và kết hợp thành khối chặt chẽ những phần tinh tuý nhất: kinh nghiệm dân gian được đúc trong ca dao, tục ngữ",
    example: "kinh nghiệm dân gian được đúc trong ca dao, tục ngữ",
  },
  {
    word: "đùi",
    part_of_speech: "danh từ",
    meaning:
      "phần của chi dưới, từ háng đến đầu gối: cái đùi gà * ngồi rung đùi",
    example: "cái đùi gà * ngồi rung đùi",
  },
  {
    word: "đùi",
    part_of_speech: "danh từ",
    meaning: "bộ phận của xe đạp nối bàn đạp với trục giữa: thay đùi xe",
    example: "thay đùi xe",
  },
  {
    word: "đùi",
    part_of_speech: "danh từ",
    meaning: "hàng dệt bằng tơ gốc: quần đũi * yếm đũi",
    example: "quần đũi * yếm đũi",
  },
  {
    word: "đúc rút",
    part_of_speech: "động từ",
    meaning:
      "chọn rút ra từ nhiều yếu tố cái nội dung trọng yếu và tập hợp lại: đúc rút kinh nghiệm sản xuất * đúc rút ra những bài học bổ ích",
    example: "đúc rút kinh nghiệm sản xuất * đúc rút ra những bài học bổ ích",
  },
  {
    word: "đuểnh đoảng",
    part_of_speech: "tính từ",
    meaning:
      '(khẩu ngữ) như đoảng: "Trước sao đằm thắm muôn phần, Nay sao đểnh đoảng như cần nấu suông?" (ca dao)',
    example:
      'Trước sao đằm thắm muôn phần, Nay sao đểnh đoảng như cần nấu suông?" (ca dao)',
  },
  {
    word: "đui mù",
    part_of_speech: "tính từ",
    meaning:
      "mù (nói khái quát): cảnh đui mù * việc xảy ra giữa ban ngày, có đui mù đâu mà không thấy!",
    example:
      "cảnh đui mù * việc xảy ra giữa ban ngày, có đui mù đâu mà không thấy!",
  },
  {
    word: "đui",
    part_of_speech: "tính từ",
    meaning:
      '(Nam) mù: "Tối trời bắt xẩm trông sao, Xẩm thề có thấy ông nào, xẩm đui!" (ca dao)',
    example: "Tối trời bắt xẩm trông sao, Xẩm thề có thấy ông nào, xẩm đui!",
  },
  {
    word: "đũi",
    part_of_speech: "danh từ",
    meaning:
      "giá có nhiều tầng, thường dùng để đặt nong lên trên: đũi tằm này có năm nong",
    example: "đũi tằm này có năm nong",
  },
  {
    word: "đục",
    part_of_speech: "động từ",
    meaning:
      "tạo thành những chỗ lõm hoặc những lỗ trên các vật rắn như gỗ, đá, kim loại bằng tác dụng của sức đập trên cái đục: đục gỗ * đục mộng cửa * đục tượng",
    example: "đục gỗ * đục mộng cửa * đục tượng",
  },
  {
    word: "đục",
    part_of_speech: "động từ",
    meaning:
      "(sâu mọt) làm cho rỗng bên trong bằng cách ăn dần: sâu đục thân * mối đục chân đê * mọt đục gỗ",
    example: "sâu đục thân * mối đục chân đê * mọt đục gỗ",
  },
  {
    word: "đục",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều gợn nhỏ vẩn lên làm cho mờ, không trong: nước đục * mắt kính bị đục * sống đục sao bằng thác trong (tng)",
    example: "nước đục * mắt kính bị đục * sống đục sao bằng thác trong (tng)",
  },
  {
    word: "đục",
    part_of_speech: "tính từ",
    meaning: "(âm thanh) trầm và nặng, không thanh, không trong: giọng đục",
    example: "giọng đục",
  },
  {
    word: "đùm",
    part_of_speech: "động từ",
    meaning:
      "gói tạm và buộc túm lại: đùm xôi bằng lá chuối * lá lành đùm lá rách (tng)",
    example: "đùm xôi bằng lá chuối * lá lành đùm lá rách (tng)",
  },
  {
    word: "đùm",
    part_of_speech: "danh từ",
    meaning: "bọc nhỏ được buộc túm lại: một đùm cơm nếp",
    example: "một đùm cơm nếp",
  },
  {
    word: "đùm bọc",
    part_of_speech: "động từ",
    meaning:
      "giúp đỡ và che chở với tất cả tình thương: đùm bọc nhau lúc khó khăn",
    example: "đùm bọc nhau lúc khó khăn",
  },
  {
    word: "đùm túm",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) gói, bọc lại một cách không gọn gàng, cẩn thận: đùm túm ít quần áo mang theo",
    example: "đùm túm ít quần áo mang theo",
  },
  {
    word: "đụn",
    part_of_speech: "danh từ",
    meaning: "khối vật rời được chất cao lên: đụn cát * đụn rạ",
    example: "đụn cát * đụn rạ",
  },
  {
    word: "đun",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) đẩy cho di chuyển lên phía trước (thường nói về xe cộ): đun xe bò",
    example: "đun xe bò",
  },
  {
    word: "đun",
    part_of_speech: "động từ",
    meaning: "đưa chất đốt vào bếp lửa để nấu nướng: đun củi cho cháy to hơn",
    example: "đun củi cho cháy to hơn",
  },
  {
    word: "đun",
    part_of_speech: "động từ",
    meaning:
      "làm cho nóng, cho sôi, bằng lửa, điện: đun một ấm nước * đun nồi canh lại cho nóng",
    example: "đun một ấm nước * đun nồi canh lại cho nóng",
  },
  {
    word: "đùn đẩy",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đùn cho người khác, không muốn nhận về mình: gặp việc khó là đùn đẩy * đùn đẩy việc nhà cho em",
    example: "gặp việc khó là đùn đẩy * đùn đẩy việc nhà cho em",
  },
  {
    word: "đun đẩy",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) đẩy qua đẩy lại cho nhau, không ai muốn nhận: đun đẩy nhau, không ai trả lời",
    example: "đun đẩy nhau, không ai trả lời",
  },
  {
    word: "đùn",
    part_of_speech: "động từ",
    meaning:
      "đẩy hoặc bị đẩy từ bên trong, bên dưới cho hiện ra: hai mắt đùn ra đầy dử * chuột đào hang, đùn lên từng đống đất",
    example: "hai mắt đùn ra đầy dử * chuột đào hang, đùn lên từng đống đất",
  },
  {
    word: "đùn",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) đẩy cho người khác, do ngại mà không muốn nhận về mình: đùn việc khó cho người khác",
    example: "đùn việc khó cho người khác",
  },
  {
    word: "đùng",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng nổ to, gọn và đanh, như tiếng súng, tiếng pháo: sấm sét đùng đùng * nổ đánh đùng",
    example: "sấm sét đùng đùng * nổ đánh đùng",
  },
  {
    word: "đun nấu",
    part_of_speech: "động từ",
    meaning:
      "đun bếp để nấu nướng (nói khái quát): về đến nhà là đâm đầu vào bếp đun nấu * chỗ đun nấu sạch sẽ",
    example: "về đến nhà là đâm đầu vào bếp đun nấu * chỗ đun nấu sạch sẽ",
  },
  {
    word: "đúng",
    part_of_speech: "tính từ",
    meaning:
      "phù hợp với cái hoặc điều có thật, không khác chút nào: nói đúng sự thật * đánh máy đúng như bản viết tay * sự việc xảy ra đúng như dự đoán",
    example:
      "nói đúng sự thật * đánh máy đúng như bản viết tay * sự việc xảy ra đúng như dự đoán",
  },
  {
    word: "đúng",
    part_of_speech: "tính từ",
    meaning:
      "không hơn không kém, không sai chút nào so với con số hoặc thời gian nêu ra: 3 giờ đúng * vừa đúng một năm * về đúng dịp Tết",
    example: "3 giờ đúng * vừa đúng một năm * về đúng dịp Tết",
  },
  {
    word: "đúng",
    part_of_speech: "tính từ",
    meaning:
      "phù hợp với yêu cầu khách quan, phải thế nào thì như thế ấy: đồng hồ chạy đúng * phải biết phân biệt phải, trái, đúng, sai",
    example: "đồng hồ chạy đúng * phải biết phân biệt phải, trái, đúng, sai",
  },
  {
    word: "đúng",
    part_of_speech: "tính từ",
    meaning:
      "phù hợp với phép tắc, với những điều quy định: đi đúng phần đường quy định * viết đúng chính tả * làm đúng với yêu cầu",
    example:
      "đi đúng phần đường quy định * viết đúng chính tả * làm đúng với yêu cầu",
  },
  {
    word: "đũng",
    part_of_speech: "danh từ",
    meaning: "chỗ nối liền nhau giữa hai ống quần: mặc quần rách đũng",
    example: "mặc quần rách đũng",
  },
  {
    word: "đụng",
    part_of_speech: "động từ",
    meaning:
      "có chỗ sát chạm vào nhau do dời chỗ, chuyển động: hai xe đụng nhau * đụng đầu vào cánh cửa",
    example: "hai xe đụng nhau * đụng đầu vào cánh cửa",
  },
  {
    word: "đụng",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) gặp phải một cách bất ngờ: đụng mưa giữa đường * đụng phải biệt kích",
    example: "đụng mưa giữa đường * đụng phải biệt kích",
  },
  {
    word: "đụng",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ, khẩu ngữ) lấy làm vợ chồng: hai người đụng nhau đã hai năm rồi",
    example: "hai người đụng nhau đã hai năm rồi",
  },
  {
    word: "đụng",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) như động: khó tính, không ai dám đụng đến * câu hỏi đụng đến một vấn đề phức tạp",
    example:
      "khó tính, không ai dám đụng đến * câu hỏi đụng đến một vấn đề phức tạp",
  },
  {
    word: "đụng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) chung nhau, mỗi người một phần, để tổ chức ăn uống: hai nhà đụng một con lợn ăn Tết",
    example: "hai nhà đụng một con lợn ăn Tết",
  },
  {
    word: "đụng chạm",
    part_of_speech: "động từ",
    meaning: "chạm vào (nói khái quát): đụng chạm vào tay nhau",
    example: "đụ",
  },
  {
    word: "đụng chạm",
    part_of_speech: "danh từ",
    meaning:
      "xung đột nhỏ: giữa hai người đã xảy ra đụng chạm * sự đụng chạm giữa mẹ chồng và nàng dâu",
    example:
      "giữa hai người đã xảy ra đụng chạm * sự đụng chạm giữa mẹ chồng và nàng dâu",
  },
  {
    word: "đủng đa đủng đỉnh",
    part_of_speech: "tính từ",
    meaning:
      "rất đủng đỉnh, đến mức chậm chạp, thường gây cảm giác khó chịu: đi đứng thì đủng đa đủng đỉnh",
    example: "đi đứng thì đủng đa đủng đỉnh",
  },
  {
    word: "đúng đắn",
    part_of_speech: "tính từ",
    meaning:
      "phù hợp với thực tế, với quy luật, với lẽ phải và đạo lí: một quyết định đúng đắn * tìm cho mình một hướng đi đúng đắn",
    example: "một quyết định đúng đắn * tìm cho mình một hướng đi đúng đắn",
  },
  {
    word: "đủng đà đủng đỉnh",
    part_of_speech: "tính từ",
    meaning:
      "rất đủng đỉnh, đến mức chậm chạp, thường gây cảm giác khó chịu: đi đứng thì đủng đa đủng đỉnh",
    example: "đi đứng thì đủng đa đủng đỉnh",
  },
  {
    word: "đụng đầu",
    part_of_speech: "động từ",
    meaning:
      "gặp và phải đương đầu, đối phó: hai đối thủ đụng đầu nhau * cuộc đụng đầu sống mái",
    example: "hai đối thủ đụng đầu nhau * cuộc đụng đầu sống mái",
  },
  {
    word: "đùng đoàng",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng nổ lúc to lúc nhỏ phát ra từ nhiều hướng: tiếng đại bác đùng đoàng suốt đêm",
    example: "tiếng đại bác đùng đoàng suốt đêm",
  },
  {
    word: "đủng đỉnh",
    part_of_speech: "tính từ",
    meaning:
      "thong thả, chậm rãi trong từng cử chỉ, từng động tác, tỏ ra không khẩn trương hoặc không vội vã: bước đi đủng đỉnh * nói đủng đỉnh * đủng đỉnh như chĩnh trôi sông (tng)",
    example:
      "bước đi đủng đỉnh * nói đủng đỉnh * đủng đỉnh như chĩnh trôi sông (tng)",
  },
  {
    word: "đụng độ",
    part_of_speech: "động từ",
    meaning:
      "(lực lượng đối địch) gặp và xảy ra giao chiến: xảy ra cuộc đụng độ",
    example: "xảy ra cuộc đụng độ",
  },
  {
    word: "đùng đục",
    part_of_speech: "tính từ",
    meaning: "hơi đục: ngọn đèn phát ra thứ ánh sáng đùng đục",
    example: "ngọn đèn phát ra thứ ánh sáng đùng đục",
  },
  {
    word: "đung đưa",
    part_of_speech: "động từ",
    meaning:
      "đưa đi đưa lại một cách nhẹ nhàng trong khoảng không: tàu lá đung đưa trước gió",
    example: "tàu lá đung đưa trước gió",
  },
  {
    word: "đùng đùng",
    part_of_speech: "phụ từ",
    meaning:
      'một cách mạnh mẽ, dữ dội: lửa cháy đùng đùng * nổi giận đùng đùng * "Sở Khanh quát mắng đùng đùng (...)" (TKiều)',
    example:
      'lửa cháy đùng đùng * nổi giận đùng đùng * "Sở Khanh quát mắng đùng đùng (...)" (TKiều)',
  },
  {
    word: "đùng đùng",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) một cách hết sức đột ngột, không ai có thể ngờ tới: vừa nói động đến đã đùng đùng bỏ đi!",
    example: "vừa nói động đến đã đùng đùng bỏ đi!",
  },
  {
    word: "đúng mức",
    part_of_speech: "tính từ",
    meaning:
      "vừa phải, phù hợp với yêu cầu khách quan, không quá đáng (thường nói về sự đánh giá, khen chê): phê bình đúng mức * đánh giá phải khách quan, đúng mức",
    example: "phê bình đúng mức * đánh giá phải khách quan, đúng mức",
  },
  {
    word: "đùng một cái",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) thình lình, không ai có thể ngờ tới: đang yên đang lành, đùng một cái nó bỏ nhà ra đi",
    example: "đang yên đang lành, đùng một cái nó bỏ nhà ra đi",
  },
  {
    word: "đúng mực",
    part_of_speech: "tính từ",
    meaning:
      "đúng đắn, có chừng mực, theo đúng khuôn phép trong cách cư xử: xử sự rất đúng mực * ăn nói đúng mực",
    example: "xử sự rất đúng mực * ăn nói đúng mực",
  },
  {
    word: "đuốc hoa",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, văn chương) cây đuốc hoặc đèn thắp trong phòng cưới đêm tân hôn; cũng dùng để chỉ ngày cưới, đêm tân hôn: “Dám xin tính rộng toan xa, Bảng vàng treo đã, đuốc hoa vội gì.” (HT). \n\nXem thêm ĐỘNG PHÒNG HOA CHÚC",
    example: "“Dám xin tính rộng toan xa, Bảng vàng treo đã, đuốc hoa vội gì.”",
  },
  {
    word: "đuốc",
    part_of_speech: "danh từ",
    meaning:
      "vật được làm thành bó từ các mảnh tre, nứa, hoặc có chất dễ cháy, dùng để đốt sáng: đốt đuốc đi đêm * cây đuốc",
    example: "đốt đuốc đi đêm * cây đuốc",
  },
  {
    word: "đúng ra",
    part_of_speech: "",
    meaning:
      "đáng lí ra (thì phải như thế này, nhưng thực tế lại không như thế): đúng ra, nó phải bị kỉ luật * đúng ra, tôi không phải làm việc đó",
    example:
      "đúng ra, nó phải bị kỉ luật * đúng ra, tôi không phải làm việc đó",
  },
  {
    word: "đúng ra",
    part_of_speech: "",
    meaning:
      "đúng sự thật là, chính xác là: không nỡ, đúng ra là không dám * tôi đến đó lúc trời tối, đúng ra là gần giữa khuya",
    example:
      "không nỡ, đúng ra là không dám * tôi đến đó lúc trời tối, đúng ra là gần giữa khuya",
  },
  {
    word: "đuối",
    part_of_speech: "tính từ",
    meaning:
      "kém đến mức phải cố gắng lắm thì mới có thể đạt được yêu cầu: sức khoẻ đuối dần * sức học càng ngày càng đuối * đuối lí đành phải im",
    example:
      "sức khoẻ đuối dần * sức học càng ngày càng đuối * đuối lí đành phải im",
  },
  {
    word: "đuối",
    part_of_speech: "tính từ",
    meaning:
      "(cân) thiếu, ít hơn khối lượng thật một chút: cân hơi đuối * chỉ được ba lạng đuối",
    example: "cân hơi đuối * chỉ được ba lạng đuối",
  },
  {
    word: "đuổi",
    part_of_speech: "động từ",
    meaning:
      "theo gấp cho kịp người đi trước: đuổi bắt kẻ gian * cố đuổi cho kịp xe trước",
    example: "đuổi bắt kẻ gian * cố đuổi cho kịp xe trước",
  },
  {
    word: "đuổi",
    part_of_speech: "động từ",
    meaning:
      "bắt phải rời khỏi, không cho ở lại một địa điểm, nơi chốn cụ thể nào đó: đuổi ruồi * bị đuổi học * đuổi đi không cho vào nhà",
    example: "đuổi ruồi * bị đuổi học * đuổi đi không cho vào nhà",
  },
  {
    word: "đuôi",
    part_of_speech: "danh từ",
    meaning:
      "phần của cơ thể nhiều động vật có xương sống, thường nhỏ dần, kéo dài từ cuối cột sống cho đến quá hậu môn: đuôi con rắn * đuôi bò * giấu đầu hở đuôi (tng)",
    example: "đuôi con rắn * đuôi bò * giấu đầu hở đuôi (tng)",
  },
  {
    word: "đuôi",
    part_of_speech: "danh từ",
    meaning:
      "phần cơ thể ở phía sau cùng, đối lập với đầu của một số động vật: cá quẫy đuôi * đuôi tôm",
    example: "cá quẫy đuôi * đuôi tôm",
  },
  {
    word: "đuôi",
    part_of_speech: "danh từ",
    meaning: "túm lông dài ở cuối thân loài chim: đuôi chim * đuôi gà",
    example: "đuôi chim * đuôi gà",
  },
  {
    word: "đuôi",
    part_of_speech: "danh từ",
    meaning:
      "phần cuối, đối lập với phần đầu: đứng phía đuôi thuyền * giải quyết việc gì cũng có đầu có đuôi",
    example: "đứng phía đuôi thuyền * giải quyết việc gì cũng có đầu có đuôi",
  },
  {
    word: "đuôi gà",
    part_of_speech: "danh từ",
    meaning:
      'dải tóc để trần thòng ra phía sau (tựa như đuôi con gà) ở đầu người phụ nữ có tóc cuộn vào trong khăn và vấn thành một cái vòng quanh đầu (một kiểu vấn tóc của phụ nữ thời trước): "Chị kia bới tóc đuôi gà, Nghiêng tai hỏi nhỏ cửa nhà chị đâu?" (ca dao)',
    example:
      'Chị kia bới tóc đuôi gà, Nghiêng tai hỏi nhỏ cửa nhà chị đâu?" (ca dao)',
  },
  {
    word: "đuôi sam",
    part_of_speech: "danh từ",
    meaning:
      "dải tóc tết dài (tựa như đuôi con sam) của phụ nữ, thường buông xuống sau gáy: tết tóc đuôi sam",
    example: "tết tóc đuôi sam",
  },
  {
    word: "đúp",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) như lưu ban: học dốt nên bị đúp",
    example: "học dốt nên bị đúp",
  },
  {
    word: "đúp",
    part_of_speech: "tính từ",
    meaning:
      "ở mức gấp đôi bình thường: vải khổ đúp * giấy đúp * gánh đúp bốn sọt một lúc",
    example: "vải khổ đúp * giấy đúp * gánh đúp bốn sọt một lúc",
  },
  {
    word: "đuỗn",
    part_of_speech: "tính từ",
    meaning:
      "(mặt) ngây ra, đờ ra, với vẻ cứng đờ, trông không đẹp: mặt đuỗn ra",
    example: "mặt đuỗn ra",
  },
  {
    word: "đụt",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) như trú: đứng trong mái hiên đụt mưa",
    example: "đứng trong mái hiên đụt mưa",
  },
  {
    word: "đụt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) kém trí khôn và hèn yếu, dễ dàng chịu lép vế: người đâu mà đụt thế không biết!",
    example: "người đâu mà đụt thế không biết!",
  },
  {
    word: "đuồn đuỗn",
    part_of_speech: "tính từ",
    meaning:
      "có dáng dài, thẳng và cứng đờ, trông không đẹp: mặt dài đuồn đuỗn",
    example: "mặt dài đuồn đuỗn",
  },
  {
    word: "đụp",
    part_of_speech: "động từ",
    meaning:
      "vá, đắp miếng nọ chồng lên miếng kia, thành nhiều lớp, trông xấu: chiếc áo vá chằng vá đụp",
    example: "chiếc áo vá chằng vá đụp",
  },
  {
    word: "đút lót",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) ngầm đưa tiền của cho kẻ có quyền thế để xin xỏ, nhờ cậy: tiền đút lót",
    example: "tiền đút lót",
  },
  {
    word: "đút nút",
    part_of_speech: "động từ",
    meaning:
      "đút vật gì để nút, để bịt lỗ lại, không cho chất lỏng chảy qua hoặc không cho âm thanh truyền qua: lấy bông đút nút lỗ tai",
    example: "lấy bông đút nút lỗ tai",
  },
  {
    word: "đút nút",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) dồn nhét nhiều thứ vào một chỗ: rác rưởi đút nút lại, làm tắc lỗ cống * công việc đút nút lại",
    example: "rác rưởi đút nút lại, làm tắc lỗ cống * công việc đút nút lại",
  },
  {
    word: "đừ",
    part_of_speech: "tính từ",
    meaning:
      "đờ ra, như không còn khả năng cử động, cảm giác nữa, thường do quá mệt mỏi: ngồi đừ ra * mệt đừ người",
    example: "ngồi đừ ra * mệt đừ người",
  },
  {
    word: "đút túi",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) lấy tiền của công làm của riêng: đút túi tiền công quỹ",
    example: "đút túi tiền công quỹ",
  },
  {
    word: "đứ đừ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) như đứ (nhưng nghĩa mạnh hơn): say đứ đừ * điện giật chết ngay đứ đừ * mệt đứ đừ",
    example: "say đứ đừ * điện giật chết ngay đứ đừ * mệt đứ đừ",
  },
  {
    word: "đưa",
    part_of_speech: "động từ",
    meaning:
      "trao, giao trực tiếp cho người khác: đưa cho bạn quyển sách * đưa báo đến tận nhà * đưa xe cho người khác mượn",
    example:
      "đưa cho bạn quyển sách * đưa báo đến tận nhà * đưa xe cho người khác mượn",
  },
  {
    word: "đưa",
    part_of_speech: "động từ",
    meaning:
      "làm cho (thường là những cái trừu tượng) đến được với người khác, cho người khác nhận được: liếc mắt đưa tình",
    example: "liếc mắt đưa tình",
  },
  {
    word: "đưa",
    part_of_speech: "động từ",
    meaning:
      "dẫn dắt, điều khiển, làm cho đi tới một nơi, đạt tới một đích nhất định: đưa con đi chơi * đưa bóng vào lưới * đưa đội tuyển lên đỉnh vinh quang",
    example:
      "đưa con đi chơi * đưa bóng vào lưới * đưa đội tuyển lên đỉnh vinh quang",
  },
  {
    word: "đưa",
    part_of_speech: "động từ",
    meaning:
      "giơ ra để làm một việc gì: đưa tay đỡ lấy món quà * đưa dao ra hăm doạ",
    example: "đưa tay đỡ lấy món quà * đưa dao ra hăm doạ",
  },
  {
    word: "đưa",
    part_of_speech: "động từ",
    meaning:
      "sử dụng làm công cụ để đạt mục đích trong một việc nào đó: đưa tiền ra mua chuộc * đưa tin học vào giảng dạy trong nhà trường",
    example:
      "đưa tiền ra mua chuộc * đưa tin học vào giảng dạy trong nhà trường",
  },
  {
    word: "đưa",
    part_of_speech: "động từ",
    meaning:
      "trình bày cho mọi người biết nhằm mục đích nhất định: các báo đều đồng loạt đưa tin * vụ việc đã được đưa ra ánh sáng",
    example: "các báo đều đồng loạt đưa tin * vụ việc đã được đưa ra ánh sáng",
  },
  {
    word: "đưa",
    part_of_speech: "động từ",
    meaning:
      "cùng đi với ai một đoạn đường trước lúc chia tay: đưa bạn lên đường",
    example: "đưa bạn lên đường",
  },
  {
    word: "đưa",
    part_of_speech: "động từ",
    meaning:
      "dẫn đến, tạo nên một kết quả nhất định: đưa đến thắng lợi * đưa đến sự thay đổi bất ngờ",
    example: "đưa đến thắng lợi * đưa đến sự thay đổi bất ngờ",
  },
  {
    word: "đưa",
    part_of_speech: "động từ",
    meaning:
      'chuyển động hoặc làm cho chuyển động qua lại một cách nhẹ nhàng: đưa võng * "Gió đưa cành trúc la đà, Tiếng chuông Trấn Võ canh gà Thọ Xương." (ca dao)',
    example:
      'đưa võng * "Gió đưa cành trúc la đà, Tiếng chuông Trấn Võ canh gà Thọ Xương." (ca dao)',
  },
  {
    word: "đút",
    part_of_speech: "động từ",
    meaning:
      "cho vào bên trong miệng hoặc bên trong vật có lối thông ra ngoài hẹp, nhỏ: đút cơm cho bé * hai tay đút túi quần * đút quần áo chật một ba lô",
    example:
      "đút cơm cho bé * hai tay đút túi quần * đút quần áo chật một ba lô",
  },
  {
    word: "đút",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) đút lót (nói tắt): đút tiền * ăn của đút",
    example: "đút tiền * ăn của đút",
  },
  {
    word: "đứ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ, hiếm) thẳng cứng ra, như không còn khả năng cử động nữa: chết đứ",
    example: "chết đứ",
  },
  {
    word: "đưa dâu",
    part_of_speech: "động từ",
    meaning: "(nhà gái) đưa cô dâu về nhà chồng: đi đưa dâu",
    example: "đi đưa dâu",
  },
  {
    word: "đứa",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng cá nhân ở vào thời kì còn ít tuổi: đứa trẻ * đứa con gái",
    example: "đứa trẻ * đứa con gái",
  },
  {
    word: "đứa",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) từ dùng để chỉ từng cá nhân người còn trẻ, dưới hoặc ngang hàng, với ý thân mật hoặc coi thường: đứa bạn thân",
    example: "đứa bạn thân",
  },
  {
    word: "đứa",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng cá nhân người thuộc hạng bị coi khinh: đứa tiểu nhân * đứa nào mà hèn thế?",
    example: "đứa tiểu nhân * đứa nào mà hèn thế?",
  },
  {
    word: "đưa đẩy",
    part_of_speech: "động từ",
    meaning:
      "chuyển động hoặc làm cho chuyển động qua lại nhẹ nhàng: gió đưa đẩy những tàu lá chuối * đưa đẩy chiếc chổi trên mặt sân",
    example: "gió đưa đẩy những tàu lá chuối * đưa đẩy chiếc chổi trên mặt sân",
  },
  {
    word: "đưa đẩy",
    part_of_speech: "động từ",
    meaning:
      "nói những lời chỉ nhằm dễ dẫn dắt câu chuyện hoặc để cho câu chuyện diễn ra tự nhiên, chứ thật ra không có ý nghĩa gì về nội dung: nói đưa đẩy * câu văn đưa đẩy * đưa đẩy câu chuyện",
    example: "nói đưa đẩy * câu văn đưa đẩy * đưa đẩy câu chuyện",
  },
  {
    word: "đưa đẩy",
    part_of_speech: "động từ",
    meaning:
      "đưa đến, đẩy đến (thường là một tình cảnh không hay; nói khái quát): bị hoàn cảnh đưa đẩy",
    example: "bị hoàn cảnh đưa đẩy",
  },
  {
    word: "đưa tang",
    part_of_speech: "động từ",
    meaning: "như đưa đám: đi theo sau đoàn xe đưa tang",
    example: "đi theo sau đoàn xe đưa tang",
  },
  {
    word: "đưa mắt",
    part_of_speech: "động từ",
    meaning:
      "liếc mắt để ra hiệu hoặc chuyển cái nhìn về phía khác: đưa mắt nhìn quanh * đưa mắt bảo bạn ngồi yên",
    example: "đưa mắt nhìn quanh * đưa mắt bảo bạn ngồi yên",
  },
  {
    word: "đưa đón",
    part_of_speech: "động từ",
    meaning:
      "đưa và đón (nói khái quát): xe đưa đón công nhân * có một quãng đường, cần gì phải đưa đón",
    example: "xe đưa đón công nhân * có một quãng đường, cần gì phải đưa đón",
  },
  {
    word: "đưa đón",
    part_of_speech: "động từ",
    meaning:
      "nói khéo để lấy lòng, không thật: đưa đón mãi mới nói vào câu chuyện",
    example: "đưa đón mãi mới nói vào câu chuyện",
  },
  {
    word: "đưa tình",
    part_of_speech: "động từ",
    meaning:
      'bày tỏ tình ý với người mình yêu, thường bằng ánh mắt: liếc mắt đưa tình * hát mấy câu đưa tình * "Đưa tình một liếc sóng đào, Dầu lòng vàng đá cũng xiêu lọ người." (BC)',
    example:
      'liếc mắt đưa tình * hát mấy câu đưa tình * "Đưa tình một liếc sóng đào, Dầu lòng vàng đá cũng xiêu lọ người." (BC)',
  },
  {
    word: "đứa ở",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) đầy tớ trong gia đình (hàm ý coi khinh): phải làm lụng như một đứa ở",
    example: "phải làm lụng như một đứa ở",
  },
  {
    word: "đực",
    part_of_speech: "tính từ",
    meaning:
      "(động vật) thuộc về giống có cơ quan sản sinh ra tinh trùng: bò đực * ong đực",
    example: "bò đực * ong đực",
  },
  {
    word: "đực",
    part_of_speech: "tính từ",
    meaning:
      "(hoa) chỉ có nhị đực, không có nhị cái (chỉ có khả năng tạo phấn không có khả năng kết quả hoặc không cho quả): hoa mướp đực * đu đủ đực",
    example: "hoa mướp đực * đu đủ đực",
  },
  {
    word: "đực",
    part_of_speech: "tính từ",
    meaning:
      "(thông tục) ngây ra, đờ ra, không còn biết phải làm gì: ngồi đực mặt ra * đứng đực ra nhìn",
    example: "ngồi đực mặt ra * đứng đực ra nhìn",
  },
  {
    word: "đức",
    part_of_speech: "danh từ",
    meaning:
      "cái biểu hiện tốt đẹp của đạo lí trong tính nết, tư cách, hành động của con người: vừa có tài, vừa có đức",
    example: "vừa có tài, vừa có đức",
  },
  {
    word: "đức",
    part_of_speech: "danh từ",
    meaning: "đức tính (nói tắt): đức khiêm tốn, giản dị * tam tòng, tứ đức",
    example: "đức khiêm tốn, giản dị * tam tòng, tứ đức",
  },
  {
    word: "đức",
    part_of_speech: "danh từ",
    meaning:
      'điều tốt lành do ăn ở có đạo đức để lại cho con cháu đời sau, theo một quan niệm duy tâm: được hưởng đức của ông bà để lại * "Cây xanh thì lá cũng xanh, Cha mẹ hiền lành để đức cho con." (ca dao)',
    example:
      'được hưởng đức của ông bà để lại * "Cây xanh thì lá cũng xanh, Cha mẹ hiền lành để đức cho con." (ca dao)',
  },
  {
    word: "đức",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, thường viết hoa) từ dùng đặt trước danh từ chỉ thần thánh hoặc người có địa vị cao quý trong xã hội phong kiến để tỏ ý tôn kính khi nói đến: Đức Thánh Trần (Trần Hưng Đạo) * Đức Phật Như Lai * Đức vua",
    example: "Đức Thánh Trần (Trần Hưng Đạo) * Đức Phật Như Lai * Đức vua",
  },
  {
    word: "đưa tiễn",
    part_of_speech: "động từ",
    meaning: "như tiễn đưa: đưa tiễn người thân ra mặt trận",
    example: "đưa tiễn người thân ra mặt trận",
  },
  {
    word: "đức cao vọng trọng",
    part_of_speech: "",
    meaning:
      "có đức độ cao, có công lao to lớn, được xã hội trọng vọng: cụ là một người đức cao vọng trọng",
    example: "cụ là một người đức cao vọng trọng",
  },
  {
    word: "đức độ",
    part_of_speech: "",
    meaning:
      "đạo đức và lòng độ lượng: có đức độ * một con người tài hoa đức độ",
    example: "có đức độ * một con người tài hoa đức độ",
  },
  {
    word: "đức tính",
    part_of_speech: "danh từ",
    meaning: "tính tốt, hợp với đạo lí làm người: có đức tính kiên trì",
    example: "có đức tính kiên trì",
  },
  {
    word: "đức dục",
    part_of_speech: "danh từ",
    meaning: "(cũ) sự giáo dục về mặt đạo đức: đề cao đức dục",
    example: "đề cao đức dục",
  },
  {
    word: "đực rựa",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ, thông tục) đàn ông, con trai (hàm ý đùa vui): cả lớp toàn là đực rựa",
    example: "cả lớp toàn là đực rựa",
  },
  {
    word: "đức trị",
    part_of_speech: "danh từ",
    meaning:
      "chủ chương lấy đạo đức làm cơ sở cho việc quản lí nhà nước và điều hành các quan hệ xã hội; phân biệt với pháp trị: xây dựng một nền tảng văn hoá dựa trên pháp trị và đức trị",
    example: "xây dựng một nền tảng văn hoá dựa trên pháp trị và đức trị",
  },
  {
    word: "đức hạnh",
    part_of_speech: "",
    meaning:
      "đạo đức và tính nết tốt (thường chỉ dùng để nói về phụ nữ): có đức hạnh * người đàn bà đức hạnh",
    example: "có đức hạnh * người đàn bà đức hạnh",
  },
  {
    word: "đừng",
    part_of_speech: "động từ",
    meaning:
      "tự ngăn mình không làm việc gì đó, không để cho việc gì đó diễn ra: không đừng được mới phải nói * cây muốn lặng, gió chẳng đừng (tng)",
    example:
      "không đừng được mới phải nói * cây muốn lặng, gió chẳng đừng (tng)",
  },
  {
    word: "đừng",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị ý khuyên ngăn, bảo không nên nói hay làm một việc nào đó: đừng đi, nguy hiểm lắm! * anh đừng nghĩ thế!",
    example: "đừng đi, nguy hiểm lắm! * anh đừng nghĩ thế!",
  },
  {
    word: "đừng",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị ý phủ định đối với điều người nói mong không có, không xảy ra: cầu trời đừng mưa * xin đừng hiểu lầm",
    example: "cầu trời đừng mưa * xin đừng hiểu lầm",
  },
  {
    word: "đứng",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ)",
    example: "đứng máy dệt * đứng một lúc ba máy",
  },
  {
    word: "đứng",
    part_of_speech: "động từ",
    meaning:
      "ở tư thế thân thẳng, chỉ có chân đặt trên mặt nền, chống đỡ toàn thân; phân biệt với nằm, ngồi: đứng lên, ngồi xuống * đứng gác * đứng xếp hàng",
    example: "đứng lên, ngồi xuống * đứng gác * đứng xếp hàng",
  },
  {
    word: "đứng",
    part_of_speech: "động từ",
    meaning:
      "ở vào một vị trí nào đó: người đứng đầu cơ quan * đứng cuối danh sách * đứng trước một thử thách gay go",
    example:
      "người đứng đầu cơ quan * đứng cuối danh sách * đứng trước một thử thách gay go",
  },
  {
    word: "đứng",
    part_of_speech: "động từ",
    meaning:
      "tự đặt mình vào một vị trí, nhận lấy một trách nhiệm nào đó: đứng ra dàn xếp mọi chuyện * đứng mũi chịu sào (tng)",
    example: "đứng ra dàn xếp mọi chuyện * đứng mũi chịu sào (tng)",
  },
  {
    word: "đứng",
    part_of_speech: "động từ",
    meaning:
      "ở trạng thái ngừng chuyển động, phát triển: trời đứng gió * sợ đứng tim * chặn đứng âm mưu của kẻ thù",
    example: "trời đứng gió * sợ đứng tim * chặn đứng âm mưu của kẻ thù",
  },
  {
    word: "đứng",
    part_of_speech: "động từ",
    meaning:
      "tồn tại, không bị đổ: phát triển và đứng vững trên thương trường * chính phủ phản động không đứng được lâu",
    example:
      "phát triển và đứng vững trên thương trường * chính phủ phản động không đứng được lâu",
  },
  {
    word: "đứng",
    part_of_speech: "tính từ",
    meaning: "có vị trí thẳng góc với mặt đất: vách núi dựng đứng",
    example: "vách núi dựng đứng",
  },
  {
    word: "đứng đắn",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra có sự chú ý đúng mức tới những gì cần được coi trọng trong quan hệ đối xử và có ý thức trách nhiệm về thái độ, hành vi của mình: làm ăn đứng đắn * một người đứng đắn, tử tế",
    example: "làm ăn đứng đắn * một người đứng đắn, tử tế",
  },
  {
    word: "đứng đắn",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra đúng mực trong quan hệ nam nữ, không có thái độ, hành vi suồng sã hay mờ ám: thái độ cợt nhả, thiếu đứng đắn",
    example: "thái độ cợt nhả, thiếu đứng đắn",
  },
  {
    word: "đựng",
    part_of_speech: "động từ",
    meaning:
      "chứa vật gì ở bên trong lòng một đồ vật khác: tủ đựng quần áo * thùng đựng nước * túi đựng bài kiểm tra",
    example: "tủ đựng quần áo * thùng đựng nước * túi đựng bài kiểm tra",
  },
  {
    word: "đưng",
    part_of_speech: "danh từ",
    meaning: "cói mọc ở vùng lầy và sâu, lá dùng để lợp nhà: cánh đồng đưng",
    example: "cánh đồng đưng",
  },
  {
    word: "đứng bóng",
    part_of_speech: "",
    meaning:
      '(mặt trời) ở ngay phía trên đỉnh đầu, bóng in trên mặt đất thu lại nhỏ nhất; thường chỉ khoảng thời gian giữa trưa: đi tới đứng bóng mới về * "Gặp em đứng bóng ban trưa, Trách trời vội tối, phân chưa hết lời." (ca dao)',
    example:
      'đi tới đứng bóng mới về * "Gặp em đứng bóng ban trưa, Trách trời vội tối, phân chưa hết lời." (ca dao)',
  },
  {
    word: "đứng lớp",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) giảng dạy trên lớp: phải đứng lớp cả sáng lẫn chiều",
    example: "phải đứng lớp cả sáng lẫn chiều",
  },
  {
    word: "đứng đường",
    part_of_speech: "",
    meaning:
      '(khẩu ngữ) rơi vào cảnh khốn cùng, không nhà không cửa, không nơi nương tựa: "Buồn ngủ lại gặp chiếu manh, Đã làm biếng lại gặp anh đứng đường." (ca dao)',
    example:
      'Buồn ngủ lại gặp chiếu manh, Đã làm biếng lại gặp anh đứng đường." (ca dao)',
  },
  {
    word: "đừng có trách",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị sự cảnh cáo rằng sẽ có điều không hay xảy ra, nếu như dám làm hoặc cứ làm điều vừa được nói đến: nếu để xảy ra việc gì thì đừng có trách!",
    example: "nếu để xảy ra việc gì thì đừng có trách!",
  },
  {
    word: "đứng như trời trồng",
    part_of_speech: "",
    meaning:
      "đứng ngây ra, như bất động, vì bị một tác động mạnh và bất ngờ về tinh thần: nó sững người ra, đứng như trời trồng",
    example: "nó sững người ra, đứng như trời trồng",
  },
  {
    word: "đứng tim",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ở trạng thái xúc động đột ngột hoặc quá hoảng sợ, đến mức cảm thấy như tim ngừng đập: sợ đứng tim",
    example: "sợ đứng tim",
  },
  {
    word: "đứng tuổi",
    part_of_speech: "tính từ",
    meaning:
      "ở tuổi không còn là trẻ nữa, nhưng chưa phải đã là già: đã đứng tuổi mà chưa lập gia đình",
    example: "đã đứng tuổi mà chưa lập gia đình",
  },
  {
    word: "đứng tên",
    part_of_speech: "động từ",
    meaning:
      "có danh nghĩa và tư cách chính thức để là người có quyền về cái gì đó hoặc chịu trách nhiệm về việc làm nào đó trước pháp luật: đứng tên chủ tài khoản * ngôi nhà do người vợ đứng tên",
    example: "đứng tên chủ tài khoản * ngôi nhà do người vợ đứng tên",
  },
  {
    word: "đứng số",
    part_of_speech: "tính từ",
    meaning:
      "ổn định về số phận, không còn phải long đong, vất vả nữa, theo quan niệm duy tâm: chưa đứng số nên còn lận đận",
    example: "chưa đứng số nên còn lận đận",
  },
  {
    word: "được cái",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị điều sắp nêu ra là mặt tốt cơ bản, bù lại cho mặt hạn chế, không được tốt đã nêu ra trước đó: gà nhỏ nhưng được cái béo * được cái con bé cũng chăm chỉ",
    example: "gà nhỏ nhưng được cái béo * được cái con bé cũng chăm chỉ",
  },
  {
    word: "được",
    part_of_speech: "động từ",
    meaning:
      'có một vật nào đó không phải của mình, do tình cờ, may mắn đưa lại: được của rơi * "Em được thì cho anh xin, Hay là em để làm tin trong nhà?" (ca dao)',
    example:
      'được của rơi * "Em được thì cho anh xin, Hay là em để làm tin trong nhà?" (ca dao)',
  },
  {
    word: "được",
    part_of_speech: "động từ",
    meaning:
      "tiếp nhận, hưởng cái gì đó tốt lành đối với mình: được tin vui * được tiếng thơm * được nhận bằng khen * rất được lòng người",
    example:
      "được tin vui * được tiếng thơm * được nhận bằng khen * rất được lòng người",
  },
  {
    word: "được",
    part_of_speech: "động từ",
    meaning:
      "hưởng điều kiện thuận lợi nào đó cho hoạt động, cho sự phát triển: thóc phơi được nắng",
    example: "thóc phơi được nắng",
  },
  {
    word: "được",
    part_of_speech: "động từ",
    meaning:
      "giành được phần hơn trong một hoạt động có phân thắng thua: được cuộc * được kiện",
    example: "được cuộc * được kiện",
  },
  {
    word: "được",
    part_of_speech: "động từ",
    meaning:
      "đạt kết quả của hoạt động: làm cho kì được mới thôi * đòi bằng được",
    example: "làm cho kì được mới thôi * đòi bằng được",
  },
  {
    word: "được",
    part_of_speech: "động từ",
    meaning:
      "có quyền, có nghĩa vụ, có điều kiện để làm việc gì đó: được quyền ứng cử * trẻ em đến tuổi được đi học * không được phép vắng mặt",
    example:
      "được quyền ứng cử * trẻ em đến tuổi được đi học * không được phép vắng mặt",
  },
  {
    word: "được",
    part_of_speech: "động từ",
    meaning:
      "hay t đạt một mức nào đó về số lượng: cháu bé đã được ba tuổi * con lợn này được 80 cân hơi",
    example: "cháu bé đã được ba tuổi * con lợn này được 80 cân hơi",
  },
  {
    word: "được",
    part_of_speech: "động từ",
    meaning:
      "từ biểu thị chủ thể là đối tượng của hoạt động coi là phù hợp với lợi ích hoặc mong muốn của mình: được khen thưởng * được trúng số * bài báo được dư luận hoan nghênh",
    example:
      "được khen thưởng * được trúng số * bài báo được dư luận hoan nghênh",
  },
  {
    word: "được",
    part_of_speech: "tính từ",
    meaning:
      "đạt tiêu chuẩn, đạt yêu cầu, làm cho có thể hài lòng, có thể đồng ý: được cả người lẫn nết * bán được giá * cô gái ấy trông cũng được",
    example: "được cả người lẫn nết * bán được giá * cô gái ấy trông cũng được",
  },
  {
    word: "được",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị việc vừa nói đến đã đạt kết quả: chưa sửa được cái đài * nghĩ mãi mới làm được bài toán * hiểu được vấn đề",
    example:
      "chưa sửa được cái đài * nghĩ mãi mới làm được bài toán * hiểu được vấn đề",
  },
  {
    word: "được",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị điều vừa nói đến là có khả năng thực hiện: việc ấy nó làm được * hoa thiên lí ăn được * đặt chỉ tiêu cao quá, sợ khó thực hiện được",
    example:
      "việc ấy nó làm được * hoa thiên lí ăn được * đặt chỉ tiêu cao quá, sợ khó thực hiện được",
  },
  {
    word: "được",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý nhấn mạnh sự may mắn, thuận lợi: gặp được người tốt * có được một gia đình hạnh phúc",
    example: "gặp được người tốt * có được một gia đình hạnh phúc",
  },
  {
    word: "được",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý giảm nhẹ sự phủ định, làm cho sự phủ định về điều có ý nghĩa tốt, tích cực trở thành bớt nặng nề (thường dùng trong cách nói lịch sự): người không được khoẻ * cô em không được xinh như cô chị",
    example: "người không được khoẻ * cô em không được xinh như cô chị",
  },
  {
    word: "được lòng",
    part_of_speech: "động từ",
    meaning:
      "được sự yêu mến, tin cậy của ai đó: được lòng mọi người * mất lòng trước, được lòng sau (tng)",
    example: "được lòng mọi người * mất lòng trước, được lòng sau (tng)",
  },
  {
    word: "được chăng hay chớ",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) ví thái độ thiếu trách nhiệm, không cố gắng, kết quả ra sao cũng được: làm việc theo kiểu được chăng hay chớ",
    example: "làm việc theo kiểu được chăng hay chớ",
  },
  {
    word: "được mùa",
    part_of_speech: "động từ",
    meaning:
      "thu hoạch trong mùa được nhiều hơn bình thường: được mùa nên cũng đủ ăn",
    example: "được mùa nên cũng đủ ăn",
  },
  {
    word: "được thể",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) đang có được ưu thế nào đó và dựa theo đó mà càng hành động mạnh mẽ hơn, ráo riết hơn: được thể càng làm già",
    example: "được thể càng làm già",
  },
  {
    word: "được giá",
    part_of_speech: "động từ",
    meaning:
      "đạt giá cao, có lợi cho người bán: thóc năm nay bán được giá * được giá thì bán chứ để làm gì!",
    example: "thóc năm nay bán được giá * được giá thì bán chứ để làm gì!",
  },
  {
    word: "được việc",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có khả năng làm nhanh và tốt những việc cụ thể được giao: thằng bé rất được việc",
    example: "thằng bé rất được việc",
  },
  {
    word: "được việc",
    part_of_speech: "tính từ",
    meaning:
      "xong việc, yên việc, không còn phải lôi thôi, mất thì giờ: im đi cho được việc! * thôi, cứ nhận quách đi cho được việc!",
    example: "im đi cho được việc! * thôi, cứ nhận quách đi cho được việc!",
  },
  {
    word: "đượm",
    part_of_speech: "tính từ",
    meaning:
      "(chất đốt) dễ bắt lửa, cháy tốt, đều và lâu: củi cháy rất đượm * bếp đã cháy đượm",
    example: "củi cháy rất đượm * bếp đã cháy đượm",
  },
  {
    word: "đượm",
    part_of_speech: "động từ",
    meaning:
      "thấm sâu, đậm vào bên trong: đượm mồ hôi * bài thơ đượm tình quê hương",
    example: "đượm mồ hôi * bài thơ đượm tình quê hương",
  },
  {
    word: "đượm",
    part_of_speech: "động từ",
    meaning:
      "pha lẫn và như được ẩn giấu, bao hàm bên trong một cái gì: lời khen đượm vẻ mỉa mai * đôi mắt đượm buồn",
    example: "lời khen đượm vẻ mỉa mai * đôi mắt đượm buồn",
  },
  {
    word: "đượm",
    part_of_speech: "động từ",
    meaning:
      '(cũ) được hưởng ân huệ: "Ơn trên tử ấm thê phong, Hiển vinh thiếp cũng đượm chung hương trời." (CPN)',
    example:
      'Ơn trên tử ấm thê phong, Hiển vinh thiếp cũng đượm chung hương trời." (CPN)',
  },
  {
    word: "đượm đà",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) như đậm đà (ng2, 3): lòng yêu nước đượm đà * món ăn đượm đà bản sắc dân tộc",
    example: "lòng yêu nước đượm đà * món ăn đượm đà bản sắc dân tộc",
  },
  {
    word: "đưỡn",
    part_of_speech: "tính từ",
    meaning: "(hiếm) thẳng và cứng đờ: mặt đưỡn ra * ngồi ngay đưỡn",
    example: "mặt đưỡn ra * ngồi ngay đưỡn",
  },
  {
    word: "đường",
    part_of_speech: "danh từ",
    meaning:
      "chất kết tinh có vị ngọt, được chế từ mía hoặc củ cải đường: ngọt như đường * nhà máy đường",
    example: "ngọt như đường * nhà máy đường",
  },
  {
    word: "đường",
    part_of_speech: "tính từ",
    meaning: "(hoa quả) thuộc loại có vị ngọt: cam đường * bưởi đường",
    example: "cam đường * bưởi đường",
  },
  {
    word: "đường",
    part_of_speech: "danh từ",
    meaning:
      "lối đi nhất định được tạo ra để nối liền hai địa điểm, hai nơi: đường đến trường * phá núi mở đường * tìm đường tiến thân",
    example: "đường đến trường * phá núi mở đường * tìm đường tiến thân",
  },
  {
    word: "đường",
    part_of_speech: "danh từ",
    meaning:
      "khoảng không gian phải vượt qua để đi từ một địa điểm này đến một địa điểm khác: đường còn xa * đi đường vòng * đường chim bay",
    example: "đường còn xa * đi đường vòng * đường chim bay",
  },
  {
    word: "đường",
    part_of_speech: "danh từ",
    meaning:
      "cái nối liền hai địa điểm, làm phương tiện truyền đi, chuyển đi cái gì đó: đường ống dẫn dầu * làm lại đường cống * đường thông tin bị gián đoạn",
    example:
      "đường ống dẫn dầu * làm lại đường cống * đường thông tin bị gián đoạn",
  },
  {
    word: "đường",
    part_of_speech: "danh từ",
    meaning:
      '(Khẩu ngữ) miền, trong quan hệ đối lập trong không gian với một miền khác: ở nơi đường rừng * "Mình về với Bác đường xuôi, Thưa giùm Việt Bắc không nguôi nhớ Người." (THữu; 39)',
    example:
      'ở nơi đường rừng * "Mình về với Bác đường xuôi, Thưa giùm Việt Bắc không nguôi nhớ Người." (THữu; 39)',
  },
  {
    word: "đường",
    part_of_speech: "danh từ",
    meaning:
      "hình tạo nên do một điểm chuyển động liên tục: đường thẳng * đường cong * đường gấp khúc",
    example: "đường thẳng * đường cong * đường gấp khúc",
  },
  {
    word: "đường",
    part_of_speech: "danh từ",
    meaning:
      "vạch, vệt do một vật chuyển động tạo ra: đường cày * đường kim mũi chỉ * đường bóng căng và hiểm",
    example: "đường cày * đường kim mũi chỉ * đường bóng căng và hiểm",
  },
  {
    word: "đường",
    part_of_speech: "danh từ",
    meaning:
      "cơ quan có chức năng dẫn vào cơ thể hoặc dẫn ra ngoài những chất nhất định nào đó, nói chung: đường hô hấp * đường tiêu hoá",
    example: "đường hô hấp * đường tiêu hoá",
  },
  {
    word: "đường",
    part_of_speech: "danh từ",
    meaning:
      "cách thức tiến hành hoạt động để đạt đến mục đích: liệu đường mà làm ăn * tìm đường tháo chạy",
    example: "liệu đường mà làm ăn * tìm đường tháo chạy",
  },
  {
    word: "đường",
    part_of_speech: "danh từ",
    meaning:
      "mặt, phương diện nào đó trong đời sống con người: đường con cái muộn màng * thành đạt về đường công danh",
    example: "đường con cái muộn màng * thành đạt về đường công danh",
  },
  {
    word: "đườn",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) (nằm, ngồi) dài và thẳng đờ ra, vẻ mệt nhọc hoặc lười nhác: nằm đườn trên cái ghế dài * ngồi ngay đườn như phỗng",
    example: "nằm đườn trên cái ghế dài * ngồi ngay đườn như phỗng",
  },
  {
    word: "đường bay",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) như đường hàng không: đường bay quốc tế * khai thác đường bay nội địa",
    example: "đường bay quốc tế * khai thác đường bay nội địa",
  },
  {
    word: "đường biển",
    part_of_speech: "danh từ",
    meaning:
      "đường đi của tàu thuỷ trên mặt biển (nói khái quát): vận chuyển theo đường hàng hải",
    example: "vận chuyển theo đường hàng hải",
  },
  {
    word: "đương",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) chống cự với một lực lượng mạnh hơn: thế giặc mạnh khó bề đương nổi",
    example: "thế giặc mạnh khó bề đương nổi",
  },
  {
    word: "đườn đưỡn",
    part_of_speech: "tính từ",
    meaning: "như đưỡn (nhưng ý nhấn mạnh hơn): nằm đườn đưỡn giữa nhà",
    example: "nằm đườn đưỡn giữa nhà",
  },
  {
    word: "đường bệ",
    part_of_speech: "tính từ",
    meaning:
      "có vẻ chững chạc, uy nghi: dáng người đường bệ * bước đi khoan thai, đường bệ",
    example: "dáng người đường bệ * bước đi khoan thai, đường bệ",
  },
  {
    word: "đường biên",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) đường biên giới (nói tắt): chợ đường biên * hàng nhập khẩu qua đường biên",
    example: "chợ đường biên * hàng nhập khẩu qua đường biên",
  },
  {
    word: "đường bộ",
    part_of_speech: "danh từ",
    meaning:
      "đường đi trên đất liền, dùng cho người đi bộ và cho xe cộ: mạng lưới giao thông đường bộ",
    example: "mạng lưới giao thông đường bộ",
  },
  {
    word: "đường cao",
    part_of_speech: "danh từ",
    meaning:
      "đường vuông góc hạ từ đỉnh của một hình tới đáy không chứa đỉnh đó: kẻ đường cao của hình thang",
    example: "kẻ đường cao của hình thang",
  },
  {
    word: "đương chức",
    part_of_speech: "tính từ",
    meaning: "hiện đang giữ chức vụ: một cán bộ đương chức",
    example: "một cán bộ đương chức",
  },
  {
    word: "đường chim bay",
    part_of_speech: "danh từ",
    meaning:
      "đường thẳng, là khoảng cách ngắn nhất giữa hai địa điểm xa nhau: tính theo đường chim bay là 12 kilomet",
    example: "tính theo đường chim bay là 12 kilomet",
  },
  {
    word: "đường dây",
    part_of_speech: "danh từ",
    meaning: "hệ thống dây dẫn: đường dây thông tin * đường dây điện cao thế",
    example: "đường dây thông tin * đường dây điện cao thế",
  },
  {
    word: "đường dây",
    part_of_speech: "danh từ",
    meaning:
      "hệ thống giao thông liên lạc bí mật trong vùng đối phương kiểm soát: bắt liên lạc được với đường dây",
    example: "bắt liên lạc được với đường dây",
  },
  {
    word: "đường dây",
    part_of_speech: "danh từ",
    meaning:
      "hệ thống liên lạc không công khai, chuyên thực hiện những việc phi pháp: đường dây buôn lậu * triệt phá một đường dây mua bán bằng giả",
    example: "đường dây buôn lậu * triệt phá một đường dây mua bán bằng giả",
  },
  {
    word: "đường dây nóng",
    part_of_speech: "danh từ",
    meaning:
      "đường dây điện thoại nóng: thiết lập đường dây nóng cho lực lượng cảnh sát cơ động",
    example: "thiết lập đường dây nóng cho lực lượng cảnh sát cơ động",
  },
  {
    word: "đường cong",
    part_of_speech: "danh từ",
    meaning:
      "đường không phải là đường thẳng, cũng không phải là đường gấp khúc: đồ thị có dạng một đường cong",
    example: "đồ thị có dạng một đường cong",
  },
  {
    word: "đương đại",
    part_of_speech: "tính từ",
    meaning: "thuộc về thời đại hiện nay: nền văn học đương đại",
    example: "nền văn học đương đại",
  },
  {
    word: "đường đi nước bước",
    part_of_speech: "",
    meaning:
      "cách thức, phương pháp tiến hành và giải quyết các công việc theo từng bước cụ thể: chỉ cho từng đường đi nước bước",
    example: "chỉ cho từng đường đi nước bước",
  },
  {
    word: "đương đầu",
    part_of_speech: "động từ",
    meaning:
      "chống chọi, đối phó một cách trực diện (với lực lượng mạnh hơn hẳn hoặc với việc khó khăn, nặng nề): đương đầu với khó khăn, nguy hiểm",
    example: "đương đầu với khó khăn, nguy hiểm",
  },
  {
    word: "đường đất",
    part_of_speech: "danh từ",
    meaning:
      "đường đi, về mặt lối đi hoặc độ dài, bước khó khăn phải vượt qua: đường đất xa xôi * thông thuộc đường đất vùng này",
    example: "đường đất xa xôi * thông thuộc đường đất vùng này",
  },
  {
    word: "đường đột",
    part_of_speech: "tính từ",
    meaning:
      "đột ngột và có phần thiếu nhã nhặn, không lịch sự: hỏi một cách đường đột",
    example: "hỏi một cách đường đột",
  },
  {
    word: "đường được",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) tạm được, không đến nỗi xấu, tồi: chiếc áo trông cũng đường được",
    example: "chiếc áo trông cũng đường được",
  },
  {
    word: "đường hàng hải",
    part_of_speech: "danh từ",
    meaning:
      "đường đi của tàu thuỷ trên mặt biển (nói khái quát): vận chuyển theo đường hàng hải",
    example: "vận chuyển theo đường hàng hải",
  },
  {
    word: "đường đường",
    part_of_speech: "tính từ",
    meaning:
      "đàng hoàng, uy nghiêm, khiến mọi người phải kính trọng: đường đường là một đại gia",
    example: "đường đường là một đại gia",
  },
  {
    word: "đường huyết",
    part_of_speech: "danh từ",
    meaning:
      "lượng đường glucoza trong máu, thường được duy trì trong một giới hạn nhất định: hạ đường huyết",
    example: "hạ đường huyết",
  },
  {
    word: "đường hoàng",
    part_of_speech: "tính từ",
    meaning:
      "có đời sống vật chất đầy đủ, theo mức yêu cầu chung của xã hội: cuộc sống đàng hoàng * nhà cửa đàng hoàng",
    example: "cuộc sống đàng hoàng * nhà cửa đàng hoàng",
  },
  {
    word: "đường hoàng",
    part_of_speech: "tính từ",
    meaning:
      "có đầy đủ những biểu hiện về tư cách, tính chất, v.v., để được coi trọng: ăn nói đàng hoàng * con người đàng hoàng",
    example: "ăn nói đàng hoàng * con người đàng hoàng",
  },
  {
    word: "đường hoàng",
    part_of_speech: "tính từ",
    meaning:
      "đúng đắn, nghiêm túc, không có gì phải giấu giếm, phải sợ sệt: giấy cấp có chữ kí đàng hoàng",
    example: "giấy cấp có chữ kí đàng hoàng",
  },
  {
    word: "đường hàng không",
    part_of_speech: "danh từ",
    meaning:
      "đường bay thường xuyên của các loại máy bay nối liền hai hay nhiều điểm: đường hàng không quốc tế",
    example: "đường hàng không quốc tế",
  },
  {
    word: "đường hướng",
    part_of_speech: "danh từ",
    meaning:
      "đường lối và phương hướng (nói khái quát): đường hướng phát triển kinh tế ở nông thôn",
    example: "đường hướng phát triển kinh tế ở nông thôn",
  },
  {
    word: "đường lối",
    part_of_speech: "danh từ",
    meaning:
      "đường đi lại (nói khái quát): đường lối quanh co * thông thạo đường lối trong làng",
    example: "đường lối quanh co * thông thạo đường lối trong làng",
  },
  {
    word: "đường lối",
    part_of_speech: "danh từ",
    meaning:
      "phương hướng cơ bản có ý nghĩa chỉ đạo lâu dài các hoạt động của nhà nước hoặc của một tổ chức chính trị: đường lối đối nội và đối ngoại * đường lối ngoại giao",
    example: "đường lối đối nội và đối ngoại * đường lối ngoại giao",
  },
  {
    word: "đường không",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) đường hàng không (nói tắt): vận chuyển bằng đường không",
    example: "vận chuyển bằng đường không",
  },
  {
    word: "đường mật",
    part_of_speech: "tính từ",
    meaning:
      "(lời nói) ngọt ngào dễ nghe, nhưng thường với mục đích xấu, nhằm dụ dỗ, lừa phỉnh: dùng lời đường mật để dụ dỗ",
    example: "dùng lời đường mật để dụ dỗ",
  },
  {
    word: "đương kim",
    part_of_speech: "tính từ",
    meaning:
      "đang giữ địa vị, chức vụ đứng đầu hiện nay: đương kim tổng thống * đội đương kim vô địch",
    example: "đương kim tổng thống * đội đương kim vô địch",
  },
  {
    word: "đường máu",
    part_of_speech: "danh từ",
    meaning:
      "đường thoát khỏi vòng nguy hiểm, được mở bằng cách phải chấp nhận hi sinh, đổ máu: mở đường máu",
    example: "mở đường máu",
  },
  {
    word: "đường luật",
    part_of_speech: "danh từ",
    meaning:
      "thể thơ có từ đời nhà Đường ở Trung Quốc, quy định chặt chẽ về thanh, niêm, vần, đối, v.v., áp dụng cho thơ ngũ ngôn, thất ngôn và một số thể phú: thơ Đường luật * bài thơ được viết theo thể Đường luật",
    example: "thơ Đường luật * bài thơ được viết theo thể Đường luật",
  },
  {
    word: "đường ống",
    part_of_speech: "danh từ",
    meaning:
      "hệ thống ống dẫn chất lỏng, chất khí (nói khái quát): lắp đặt đường ống * đường ống cấp thoát nước",
    example: "lắp đặt đường ống * đường ống cấp thoát nước",
  },
  {
    word: "đường mòn",
    part_of_speech: "danh từ",
    meaning:
      "đường do vết chân người đi lại nhiều mà thành (thường ở các vùng rừng, núi): men theo con đường mòn vào rừng",
    example: "men theo con đường mòn vào rừng",
  },
  {
    word: "đường nét",
    part_of_speech: "danh từ",
    meaning:
      "các yếu tố như đường, nét, v.v., tạo thành hình dáng của vật thể (nói khái quát): đường nét chạm trổ tinh xảo",
    example: "đường nét chạm trổ tinh xảo",
  },
  {
    word: "đương nhiệm",
    part_of_speech: "tính từ",
    meaning: "như đương chức: chủ tịch đương nhiệm",
    example: "chủ tịch đương nhiệm",
  },
  {
    word: "đương nhiên",
    part_of_speech: "tính từ",
    meaning:
      "rõ ràng là như vậy, ai cũng thừa nhận: mạnh thắng yếu là lẽ đương nhiên * đương nhiên anh em thì phải bênh nhau",
    example:
      "mạnh thắng yếu là lẽ đương nhiên * đương nhiên anh em thì phải bênh nhau",
  },
  {
    word: "đường ngôi",
    part_of_speech: "danh từ",
    meaning:
      "đường thẳng rẽ từ đỉnh đầu xuống trán, chia tóc thành hai mảng: tóc rẽ đường ngôi lệch",
    example: "tóc rẽ đường ngôi lệch",
  },
  {
    word: "đương quyền",
    part_of_speech: "tính từ",
    meaning: "đang nắm giữ quyền hành: tổng thống đương quyền",
    example: "tổng thống đương quyền",
  },
  {
    word: "đường sá",
    part_of_speech: "danh từ",
    meaning:
      "đường đi lại trên bộ (nói khái quát): đường sá lầy lội * đường sá xa xôi, đi lại không tiện",
    example: "đường sá lầy lội * đường sá xa xôi, đi lại không tiện",
  },
  {
    word: "đường phố",
    part_of_speech: "danh từ",
    meaning: "đường, phố (nói khái quát): đường phố đông đúc",
    example: "đường phố đông đúc",
  },
  {
    word: "đường sắt",
    part_of_speech: "danh từ",
    meaning: "đường tàu hoả chạy (nói khái quát): cải tạo hệ thống đường sắt",
    example: "cải tạo hệ thống đường sắt",
  },
  {
    word: "đường sông",
    part_of_speech: "danh từ",
    meaning:
      "đường giao thông trên sông: vận tải đường sông * cục quản lí đường sông",
    example: "vận tải đường sông * cục quản lí đường sông",
  },
  {
    word: "đương thì",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) đang ở thời kì tuổi trẻ, đầy sức sống (thường nói về con gái): con gái đương thì * đến tuổi đương thì",
    example: "con gái đương thì * đến tuổi đương thì",
  },
  {
    word: "đương thứ",
    part_of_speech: "danh từ",
    meaning: "(cũ) hương chức đang làm việc: bọn đương thứ trong làng",
    example: "bọn đương thứ trong làng",
  },
  {
    word: "đương thứ",
    part_of_speech: "tính từ",
    meaning: "(cũ) như đương chức: lí trưởng đương thứ",
    example: "lí trưởng đương thứ",
  },
  {
    word: "đương sự",
    part_of_speech: "danh từ",
    meaning:
      "người là đối tượng trong một sự việc nào đó được đưa ra giải quyết: có đầy đủ chữ kí của hai bên đương sự",
    example: "có đầy đủ chữ kí của hai bên đương sự",
  },
  {
    word: "đương thời",
    part_of_speech: "danh từ",
    meaning: "thời bấy giờ: người đương thời * xã hội đương thời",
    example: "người đương thời * xã hội đương thời",
  },
  {
    word: "đường xoáy ốc",
    part_of_speech: "danh từ",
    meaning:
      "đường cong trên mặt phẳng được vẽ ra do một điểm vừa quay quanh vừa xa dần một điểm cố định: thông tin trên ổ đĩa cứng được ghi theo một đường xoáy ốc",
    example: "thông tin trên ổ đĩa cứng được ghi theo một đường xoáy ốc",
  },
  {
    word: "đường trường",
    part_of_speech: "danh từ",
    meaning:
      "đường dài, đường xa (thường dùng để nói về mặt khó khăn, vất vả): xe chạy đường trường * đi đường trường vất vả",
    example: "xe chạy đường trường * đi đường trường vất vả",
  },
  {
    word: "đường trường",
    part_of_speech: "danh từ",
    meaning:
      "điệu hát chèo phổ theo thơ lục bát, nét nhạc mềm mại, dùng nhiều tiếng đệm: hát đường trường",
    example: "hát đường trường",
  },
  {
    word: "đường xoắn ốc",
    part_of_speech: "danh từ",
    meaning: "như đường xoáy ốc: mẫu vân tay có đường xoắn ốc",
    example: "mẫu vân tay có đường xoắn ốc",
  },
  {
    word: "đứt",
    part_of_speech: "động từ",
    meaning:
      "rời ra thành từng đoạn do bị kéo mạnh hoặc bị cắt, chặt, v.v.: cắt mãi mới đứt * cưa đứt tấm gỗ * cắt đứt dòng suy nghĩ",
    example: "cắt mãi mới đứt * cưa đứt tấm gỗ * cắt đứt dòng suy nghĩ",
  },
  {
    word: "đứt",
    part_of_speech: "động từ",
    meaning: "bị vật sắc cứa rách da thịt đến chảy máu: bị dao cứa đứt tay",
    example: "bị dao cứa đứt tay",
  },
  {
    word: "đứt",
    part_of_speech: "động từ",
    meaning:
      "mất mối liên lạc, liên hệ hoặc không tiếp tục có quan hệ nữa: liên lạc bị đứt vì chiến tranh * cắt đứt quan hệ * đứt mối tơ duyên",
    example:
      "liên lạc bị đứt vì chiến tranh * cắt đứt quan hệ * đứt mối tơ duyên",
  },
  {
    word: "đứt",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) từ biểu thị ý khẳng định ở mức độ trọn vẹn: bán đứt * quên đứt mất việc ấy",
    example: "bán đứt * quên đứt mất việc ấy",
  },
  {
    word: "đứt đuôi",
    part_of_speech: "tính từ",
    meaning:
      '(khẩu ngữ) hiển nhiên, dứt khoát là như thế, không thể khác được, không có gì phải bàn cãi nữa: thế là chết đứt đuôi rồi! * "Nhà mình lại được cả con trâu, trâu ấy, loại nhất đứt đuôi đi rồi (...)" (ĐVũ; 1)',
    example:
      'thế là chết đứt đuôi rồi! * "Nhà mình lại được cả con trâu, trâu ấy, loại nhất đứt đuôi đi rồi (...)" (ĐVũ; 1)',
  },
  {
    word: "đứt quãng",
    part_of_speech: "động từ",
    meaning:
      "ở tình trạng bị đứt ra thành từng quãng, từng đoạn rời rạc: giọng thì thào, đứt quãng * hơi thở mệt nhọc, đứt quãng",
    example: "giọng thì thào, đứt quãng * hơi thở mệt nhọc, đứt quãng",
  },
  {
    word: "đứt ruột đứt gan",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) như đứt ruột (nhưng nghĩa mạnh hơn): tiếc đứt ruột đứt gan",
    example: "tiếc đứt ruột đứt gan",
  },
  {
    word: "đứt đuôi con nòng nọc",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) như đứt đuôi: như thế là thua đứt đuôi con nòng nọc rồi!",
    example: "như thế là thua đứt đuôi con nòng nọc rồi!",
  },
  {
    word: "đứt bữa",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) ở tình trạng đói kém, bữa có ăn, bữa không: mất mùa làm nhiều gia đình bị đứt bữa",
    example: "mất mùa làm nhiều gia đình bị đứt bữa",
  },
  {
    word: "đứt đoạn",
    part_of_speech: "",
    meaning:
      "ở tình trạng bị ngắt quãng giữa chừng, không liên tục: giọng nói đứt đoạn",
    example: "giọng nói đứt đoạn",
  },
  {
    word: "đứt nối",
    part_of_speech: "",
    meaning:
      'bị ngắt quãng, không liền mạch, không liên tục: những âm thanh đứt nối, rời rạc * "Lại càng ủ dột nét hoa, Sầu tuôn đứt nối, châu sa vắn dài." (TKiều)',
    example:
      'những âm thanh đứt nối, rời rạc * "Lại càng ủ dột nét hoa, Sầu tuôn đứt nối, châu sa vắn dài." (TKiều)',
  },
  {
    word: "đứt gãy",
    part_of_speech: "danh từ",
    meaning:
      "nơi vỏ Trái Đất bị tách làm hai phần, một phần nâng lên, một phần sụt xuống: đứt gãy sông Hồng",
    example: "đứt gãy sông Hồng",
  },
  {
    word: "đứt ruột",
    part_of_speech: "",
    meaning:
      "đau đớn, xót xa tột cùng (đến mức tưởng như đứt từng khúc ruột): tiếc đứt ruột * thương con đứt ruột",
    example: "tiếc đứt ruột * thương con đứt ruột",
  },
  {
    word: "e",
    part_of_speech: "động từ",
    meaning:
      'có phần không yên lòng vì nghĩ rằng có thể có điều ít nhiều không hay, không tốt nào đó xảy ra: việc này e khó thành * "Canh khuya, thân gái, dặm trường, Phần e đường sá, phần thương dãi dầu!" (TKiều)',
    example:
      'việc này e khó thành * "Canh khuya, thân gái, dặm trường, Phần e đường sá, phần thương dãi dầu!" (TKiều)',
  },
  {
    word: "e",
    part_of_speech: "động từ",
    meaning:
      "từ dùng trong đối thoại để biểu thị ý khẳng định dè dặt về điều ít nhiều không hay, không tốt nào đó (lối nói lịch sự): ngần này, e không đủ * nói ở đây, e không tiện",
    example: "ngần này, e không đủ * nói ở đây, e không tiện",
  },
  {
    word: "è",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đưa hết sức lực ra để làm một việc quá nặng: è vai ra gánh * è lưng kéo chiếc xe bò",
    example: "è vai ra gánh * è lưng kéo chiếc xe bò",
  },
  {
    word: "ẹ",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) dơ dáy, bẩn thỉu (ngôn ngữ của trẻ con): tay bé ẹ quá",
    example: "tay bé ẹ quá",
  },
  {
    word: "é",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) húng dổi: bụi rau é * hạt é",
    example: "bụi rau é * hạt é",
  },
  {
    word: "è ạch",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) ì ạch: è ạch lôi chiếc xe qua bãi lầy",
    example: "è ạch lôi chiếc xe qua bãi lầy",
  },
  {
    word: "è cổ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) phải gánh chịu một việc quá cực nhọc, vất vả, hoàn toàn trái với ý muốn: vay mượn nhiều, bây giờ phải è cổ ra mà trả nợ",
    example: "vay mượn nhiều, bây giờ phải è cổ ra mà trả nợ",
  },
  {
    word: "e dè",
    part_of_speech: "động từ",
    meaning:
      "lo ngại, dè dặt vì có phần sợ điều không hay có thể xảy ra cho mình: tính e dè * phê bình thẳng thắn, không e dè",
    example: "tính e dè * phê bình thẳng thắn, không e dè",
  },
  {
    word: "e nể",
    part_of_speech: "động từ",
    meaning: "(hiếm) nể và có ý hơi sợ: nói thẳng thắn, không e nể một ai",
    example: "nói thẳng thắn, không e nể một ai",
  },
  {
    word: "e hèm",
    part_of_speech: "động từ",
    meaning:
      "(tiếng) phát mạnh ra từ trong họng, thường để ra hiệu hoặc lấy giọng trước khi nói, đọc: e hèm một cái rồi cao giọng tuyên bố",
    example: "e hèm một cái rồi cao giọng tuyên bố",
  },
  {
    word: "e ấp",
    part_of_speech: "động từ",
    meaning:
      "ngại ngùng, không mạnh dạn bộc lộ hết tâm tư, tình cảm: thích nhau nhưng còn e ấp * giữa hai người không có gì phải e ấp, giấu giếm",
    example:
      "thích nhau nhưng còn e ấp * giữa hai người không có gì phải e ấp, giấu giếm",
  },
  {
    word: "e ấp",
    part_of_speech: "tính từ",
    meaning:
      "có dáng vẻ bẽn lẽn, thẹn thùng (thường nói về các thiếu nữ): nụ cười e ấp dưới vành nón trắng",
    example: "nụ cười e ấp dưới vành nón trắng",
  },
  {
    word: "e ngại",
    part_of_speech: "động từ",
    meaning:
      "lo, ngại vì sợ có thể xảy ra điều không hay cho mình: có gì cứ nói, không phải e ngại",
    example: "có gì cứ nói, không phải e ngại",
  },
  {
    word: "e sợ",
    part_of_speech: "động từ",
    meaning: "có phần sợ nên ngần ngại: rụt rè e sợ * e sợ nên không dám nói",
    example: "rụt rè e sợ * e sợ nên không dám nói",
  },
  {
    word: "e lệ",
    part_of_speech: "tính từ",
    meaning:
      '(phụ nữ) rụt rè, có ý thẹn khi tiếp xúc với đám đông hoặc với nam giới, khiến cho thêm phần duyên dáng và đáng yêu: "Chàng Vương quen mặt ra chào, Hai Kiều e lệ nép vào dưới hoa." (TKiều)',
    example:
      'Chàng Vương quen mặt ra chào, Hai Kiều e lệ nép vào dưới hoa." (TKiều)',
  },
  {
    word: "e thẹn",
    part_of_speech: "động từ",
    meaning: "ngại ngùng và hay thẹn: cúi đầu e thẹn",
    example: "cúi đầu e thẹn",
  },
  {
    word: "ém",
    part_of_speech: "động từ",
    meaning: "nhét mép chăn, màn xuống để cho kín: ém màn xuống dưới chiếu",
    example: "ém màn xuống dưới chiếu",
  },
  {
    word: "ém",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nép vào hay nén xuống, để cho khỏi lộ ra: ém mình sát vào tường * cố ém tiếng khóc",
    example: "ém mình sát vào tường * cố ém tiếng khóc",
  },
  {
    word: "ém",
    part_of_speech: "động từ",
    meaning:
      "giấu kín, không để lộ cho biết: ém bức thư đi, không cho ai biết * ém quân",
    example: "ém bức thư đi, không cho ai biết * ém quân",
  },
  {
    word: "ém",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) ép cho nhỏ lại hoặc cho dính chặt với nhau: ém chặt một bát cơm * ém thêm thuốc lào vào điếu",
    example: "ém chặt một bát cơm * ém thêm thuốc lào vào điếu",
  },
  {
    word: "em",
    part_of_speech: "danh từ",
    meaning:
      "người cùng một thế hệ trong gia đình, trong họ, nhưng thuộc hàng dưới (sinh sau, là con nhà chú, v.v.), trong quan hệ với anh, chị của mình (có thể dùng để xưng gọi): em gái ruột * em họ * em dâu * chị ngã em nâng (tng)",
    example: "em gái ruột * em họ * em dâu * chị ngã em nâng (tng)",
  },
  {
    word: "em",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ hoặc gọi người còn nhỏ tuổi, hay dùng để gọi người vai em mình một cách thân mật hoặc để tự xưng một cách thân mật với người vai anh, chị mình: em gái nhỏ * các em thiếu nhi",
    example: "em gái nhỏ * các em thiếu nhi",
  },
  {
    word: "em",
    part_of_speech: "danh từ",
    meaning:
      "từ giáo viên dùng để gọi học sinh hoặc học sinh dùng để tự xưng khi nói với giáo viên: thưa cô cho em vào lớp! * em chào thầy!",
    example: "thưa cô cho em vào lớp! * em chào thầy!",
  },
  {
    word: "em",
    part_of_speech: "danh từ",
    meaning:
      'từ người đàn ông dùng để gọi vợ, người yêu, hoặc người phụ nữ dùng để tự xưng khi nói với chồng, người yêu: "Tình anh như nước dâng cao, Tình em như dải lụa đào tẩm hương." (ca dao)',
    example:
      'Tình anh như nước dâng cao, Tình em như dải lụa đào tẩm hương." (ca dao)',
  },
  {
    word: "ém nhẹm",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) giấu thật kín, không để lộ cho ai biết: vụ việc tiêu cực bị ém nhẹm đi",
    example: "vụ việc tiêu cực bị ém nhẹm đi",
  },
  {
    word: "én",
    part_of_speech: "danh từ",
    meaning:
      "chim nhỏ, lông màu đen, cánh dài và nhọn, chân ngắn, bay nhanh, thường gặp nhiều vào mùa xuân: cánh én * rợp trời chim én liệng",
    example: "cánh én * rợp trời chim én liệng",
  },
  {
    word: "eng éc",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng lợn kêu to và kéo dài liên tiếp, nghe chói tai: lợn kêu eng éc",
    example: "lợn kêu eng éc",
  },
  {
    word: "em gái",
    part_of_speech: "danh từ",
    meaning:
      "em ruột, thuộc nữ giới, phân biệt với em họ, em dâu: cô em gái * quý em dâu như em gái",
    example: "cô em gái * quý em dâu như em gái",
  },
  {
    word: "em em",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) suýt soát, không chênh lệch bao nhiêu: hai đứa tuổi cũng em em nhau * mới đó mà cũng em em hai năm rồi",
    example: "hai đứa tuổi cũng em em nhau * mới đó mà cũng em em hai năm rồi",
  },
  {
    word: "em út",
    part_of_speech: "danh từ",
    meaning:
      "người em sau cùng hoặc nhỏ tuổi nhất trong hàng các em trong nhà: là em út trong nhà nên rất được chiều",
    example: "là em út trong nhà nên rất được chiều",
  },
  {
    word: "em út",
    part_of_speech: "danh từ",
    meaning:
      "người thuộc hàng em, trong quan hệ gia đình, họ hàng hoặc được coi như em (nói khái quát): thay bố mẹ dạy bảo em út * coi cô ấy như em út trong nhà",
    example: "thay bố mẹ dạy bảo em út * coi cô ấy như em út trong nhà",
  },
  {
    word: "em út",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) người dưới quyền, là tay chân giúp việc thân tín: bọn em út của tên đầu sỏ",
    example: "bọn em út của tên đầu sỏ",
  },
  {
    word: "eng",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ, khẩu ngữ) anh (chỉ dùng để xưng gọi; hàm ý thân mật): eng ở lại, tui đi trước nghe!",
    example: "eng ở lại, tui đi trước nghe!",
  },
  {
    word: "ẽo à ẽo ợt",
    part_of_speech: "tính từ",
    meaning: "ẽo ợt một cách quá đáng, trông rất khó chịu: giọng ẽo à ẽo ợt",
    example: "giọng ẽo à ẽo ợt",
  },
  {
    word: "ẹo",
    part_of_speech: "động từ",
    meaning:
      "uốn nghiêng sang một bên vì bị đè nặng hoặc để né tránh: bế em ẹo cả xương sườn * gánh nặng làm ẹo cả vai",
    example: "bế em ẹo cả xương sườn * gánh nặng làm ẹo cả vai",
  },
  {
    word: "eo ếch",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) vùng thắt lưng: ôm ngang eo ếch",
    example: "ôm ngang eo ếch",
  },
  {
    word: "eo",
    part_of_speech: "tính từ",
    meaning: "thắt nhỏ dần lại ở quãng giữa: quả bầu eo * lưng eo",
    example: "quả bầu eo * lưng eo",
  },
  {
    word: "eo éo",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng những tiếng nói liên tiếp, nghe chói tai và không rõ, gây cảm giác khó chịu: tiếng gọi nhau eo éo ngoài ngõ * giọng eo éo như đàn bà",
    example: "tiếng gọi nhau eo éo ngoài ngõ * giọng eo éo như đàn bà",
  },
  {
    word: "ẻo lả",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả dáng vẻ yếu ớt như không có sức sống: thân hình ẻo lả * đứa trẻ ẻo lả, da xanh lướt",
    example: "thân hình ẻo lả * đứa trẻ ẻo lả, da xanh lướt",
  },
  {
    word: "ẻo lả",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả dáng vẻ yểu điệu, thướt tha một cách yếu ớt: đi đứng ẻo lả * những tia khói thuốc ẻo lả uốn lượn rồi tan biến",
    example: "đi đứng ẻo lả * những tia khói thuốc ẻo lả uốn lượn rồi tan biến",
  },
  {
    word: "eo hẹp",
    part_of_speech: "tính từ",
    meaning:
      "thiếu, hạn chế, không có nhiều, không được rộng rãi: thời gian eo hẹp * cuộc sống khó khăn, eo hẹp",
    example: "thời gian eo hẹp * cuộc sống khó khăn, eo hẹp",
  },
  {
    word: "ẽo ợt",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả giọng điệu, dáng vẻ uốn éo một cách không tự nhiên, gây cảm giác khó chịu: đi đứng ẽo ợt * giọng nói ẽo ợt",
    example: "đi đứng ẽo ợt * giọng nói ẽo ợt",
  },
  {
    word: "éo le",
    part_of_speech: "tính từ",
    meaning: "(cũ) chênh vênh, không vững: cầu tre khấp khểnh, éo le",
    example: "cầu tre khấp khểnh, éo le",
  },
  {
    word: "éo le",
    part_of_speech: "tính từ",
    meaning:
      'có trắc trở, gặp phải tình cảnh trái với lẽ thường ở đời: cảnh ngộ rất éo le * mối tình éo le, ngang trái * "Trước đèn xem truyện Tây minh, Gẫm cười hai chữ nhân tình éo le." (LVT)',
    example:
      'cảnh ngộ rất éo le * mối tình éo le, ngang trái * "Trước đèn xem truyện Tây minh, Gẫm cười hai chữ nhân tình éo le." (LVT)',
  },
  {
    word: "ép",
    part_of_speech: "động từ",
    meaning:
      "dùng lực tác động lên khắp cả bề mặt để làm cho chặt lại, mỏng đều ra, hoặc để lấy ra chất lỏng: ép dầu * ép mía làm mật * ép thật chặt",
    example: "ép dầu * ép mía làm mật * ép thật chặt",
  },
  {
    word: "ép",
    part_of_speech: "động từ",
    meaning:
      "tác động bằng sức mạnh dồn đối phương về một phía: ép quân địch ra hàng * chơi ép sân * bị ép vào thế bí",
    example: "ép quân địch ra hàng * chơi ép sân * bị ép vào thế bí",
  },
  {
    word: "ép",
    part_of_speech: "động từ",
    meaning:
      "áp thật sát vào: cháu ép đầu vào ngực bà * đứng ép sát vào tường để tránh mưa",
    example: "cháu ép đầu vào ngực bà * đứng ép sát vào tường để tránh mưa",
  },
  {
    word: "ép",
    part_of_speech: "động từ",
    meaning:
      "tác động đến, nhằm làm cho phải miễn cưỡng nghe theo, làm theo: không thích thì thôi, không ai ép * ép dầu ép mỡ, ai nỡ ép duyên (tng)",
    example:
      "không thích thì thôi, không ai ép * ép dầu ép mỡ, ai nỡ ép duyên (tng)",
  },
  {
    word: "ép",
    part_of_speech: "tính từ",
    meaning:
      "không được tự nhiên, không đúng theo lẽ thường, vì thật ra chưa đạt đủ điều kiện, yêu cầu: chín ép * câu thơ ép vần",
    example: "chín ép * câu thơ ép vần",
  },
  {
    word: "eo ôi",
    part_of_speech: "cảm từ",
    meaning:
      "(khẩu ngữ) tiếng thốt ra biểu lộ sự kinh hãi, ghê sợ: eo ôi, khiếp quá!",
    example: "eo ôi, khiếp quá!",
  },
  {
    word: "eo óc",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả những tiếng kêu (thường là tiếng gà gáy) cùng nổi lên đây đó, nghe văng vẳng, không rõ: tiếng gà trưa eo óc",
    example: "tiếng gà trưa eo óc",
  },
  {
    word: "eo óc",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả những tiếng nói nghe khó chịu phát ra một cách dai dẳng: những lời mỉa mai eo óc",
    example: "những lời mỉa mai eo óc",
  },
  {
    word: "ẹp",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ở vào tình trạng ngả hẳn xuống, như bị ép thật sát xuống: nằm ẹp bụng xuống chiếu",
    example: "nằm ẹp bụng xuống chiếu",
  },
  {
    word: "eo sèo",
    part_of_speech: "tính từ",
    meaning:
      'từ mô phỏng tiếng người ồn ào, lộn xộn từ xa vọng lại: "Lặn lội thân cò khi quãng vắng, Eo sèo mặt nước buổi đò đông." (TrTXương; 4)',
    example:
      'Lặn lội thân cò khi quãng vắng, Eo sèo mặt nước buổi đò đông." (TrTXương; 4)',
  },
  {
    word: "eo sèo",
    part_of_speech: "động từ",
    meaning: "kêu ca, phàn nàn một cách khó chịu: bị vợ eo sèo",
    example: "bị vợ eo sèo",
  },
  {
    word: "èo uột",
    part_of_speech: "tính từ",
    meaning: "yếu ớt, bệnh hoạn: con bé sinh thiếu tháng nên èo uột lắm",
    example: "con bé sinh thiếu tháng nên èo uột lắm",
  },
  {
    word: "ép giá",
    part_of_speech: "động từ",
    meaning:
      "gây sức ép làm cho phải bán với giá rẻ: bị tư thương ép giá * các chủ bao tiêu ép giá người sản xuất",
    example: "bị tư thương ép giá * các chủ bao tiêu ép giá người sản xuất",
  },
  {
    word: "ép buộc",
    part_of_speech: "động từ",
    meaning:
      "bắt phải làm điều không muốn hoặc trái với ý muốn: ép buộc phải nhận tội * bị tình thế ép buộc",
    example: "ép buộc phải nhận tội * bị tình thế ép buộc",
  },
  {
    word: "ép lòng",
    part_of_speech: "động từ",
    meaning:
      "đành phải làm việc gì đó hoàn toàn trái với ý muốn của mình: đành ép lòng nói dối * không muốn nhưng cũng ép lòng phải theo",
    example: "đành ép lòng nói dối * không muốn nhưng cũng ép lòng phải theo",
  },
  {
    word: "ép nài",
    part_of_speech: "động từ",
    meaning:
      'như nài ép: "Cũng là lỡ một, lầm hai, Đá vàng sao nỡ ép nài mưa mây!" (TKiều)',
    example: 'Cũng là lỡ một, lầm hai, Đá vàng sao nỡ ép nài mưa mây!" (TKiều)',
  },
  {
    word: "ép xác",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tự ép mình vào một cuộc sống vất vả, khắc khổ: lối sống ép xác",
    example: "lối sống ép xác",
  },
  {
    word: "ép uổng",
    part_of_speech: "động từ",
    meaning:
      'bắt ép theo một bề một cách nghiệt ngã, bất chấp cả việc người ta phải chịu nhiều đau khổ: "Đường đi những lách cùng lau, Cha mẹ tham giàu, ép uổng duyên con." (ca dao)',
    example:
      'Đường đi những lách cùng lau, Cha mẹ tham giàu, ép uổng duyên con." (ca dao)',
  },
  {
    word: "ê",
    part_of_speech: "tính từ",
    meaning:
      "có cảm giác đau, mỏi, tê một cách âm ỉ: ngã một cái ê cả lưng * đau ê ở vai * chua ê cả răng",
    example: "ngã một cái ê cả lưng * đau ê ở vai * chua ê cả răng",
  },
  {
    word: "ê",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ngượng, thấy hổ thẹn vì bị người ta cười chê: thua thì ê lắm * mọi người mà biết thì ê mặt",
    example: "thua thì ê lắm * mọi người mà biết thì ê mặt",
  },
  {
    word: "ê",
    part_of_speech: "cảm từ",
    meaning:
      "(khẩu ngữ) từ dùng để chế nhạo, cho là không biết ngượng, không biết xấu hổ (thường chỉ dùng nói với trẻ con): ê, lớn rồi mà vẫn còn làm nũng mẹ! * ê, ê đồ bắt nạt trẻ con!",
    example: "ê, lớn rồi mà vẫn còn làm nũng mẹ! * ê, ê đồ bắt nạt trẻ con!",
  },
  {
    word: "ê",
    part_of_speech: "cảm từ",
    meaning:
      "(khẩu ngữ) tiếng dùng để gọi ai đó một cách trống không, với ý không coi trọng: ê, đi đâu đấy? * ê, thằng kia, lại đây tao bảo!",
    example: "ê, đi đâu đấy? * ê, thằng kia, lại đây tao bảo!",
  },
  {
    word: "ế",
    part_of_speech: "tính từ",
    meaning:
      "(hàng hoá) bị đọng lại do không có hoặc chỉ ít người mua, ít người yêu cầu: ế hàng * nhà hàng ế khách",
    example: "ế hàng * nhà hàng ế khách",
  },
  {
    word: "ế",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) đã quá tuổi mà không lấy được vợ, hoặc chồng: ế chồng * không lấy người này thì lấy người khác, đã ế đâu mà sợ?",
    example:
      "ế chồng * không lấy người này thì lấy người khác, đã ế đâu mà sợ?",
  },
  {
    word: "ê ẩm",
    part_of_speech: "tính từ",
    meaning: "đau, mỏi khắp cả một cách âm ỉ, kéo dài: đau ê ẩm cả người",
    example: "đau ê ẩm cả người",
  },
  {
    word: "ê a",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả giọng đọc kéo dài, nghe không thật rõ từng tiếng: bé ê a đánh vần * ru con bằng giọng ê a",
    example: "bé ê a đánh vần * ru con bằng giọng ê a",
  },
  {
    word: "ề à",
    part_of_speech: "tính từ",
    meaning:
      "(giọng nói, tiếng khóc) trầm và cố ý kéo dài: ề à kể lể * giọng nói ề à",
    example: "ề à kể lể * giọng nói ề à",
  },
  {
    word: "ế ẩm",
    part_of_speech: "tính từ",
    meaning: "(hàng hoá) ế (nói khái quát): hàng họ ế ẩm",
    example: "hàng họ ế ẩm",
  },
  {
    word: "ê chệ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) xấu hổ, nhục nhã đến mức như không còn dám nhìn mặt ai: người như thế mà đi ăn cắp, rõ ê chệ!",
    example: "người như thế mà đi ăn cắp, rõ ê chệ!",
  },
  {
    word: "ê cu",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) đai ốc: vặn ê cu",
    example: "vặn ê cu",
  },
  {
    word: "ê chề",
    part_of_speech: "tính từ",
    meaning:
      'đau đớn, tủi nhục, chán chường, v.v., đến mức như không còn chịu đựng nổi, không còn thấy thiết gì nữa: nhục nhã ê chề * "Làm cho cho mệt, cho mê, Làm cho đau đớn, ê chề, cho coi!" (TKiều)',
    example:
      'nhục nhã ê chề * "Làm cho cho mệt, cho mê, Làm cho đau đớn, ê chề, cho coi!" (TKiều)',
  },
  {
    word: "ê hề",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) nhiều đến mức thừa thãi, gây cảm giác không dùng vào đâu cho hết được: cỗ bàn ê hề * thịt cá ê hề",
    example: "cỗ bàn ê hề * thịt cá ê hề",
  },
  {
    word: "ê kíp",
    part_of_speech: "danh từ",
    meaning:
      "nhóm người được tổ chức ra để cùng làm một nhiệm vụ chung nào đó: ê kíp lãnh đạo của xí nghiệp * cùng trong một ê kíp lái tàu",
    example: "ê kíp lãnh đạo của xí nghiệp * cùng trong một ê kíp lái tàu",
  },
  {
    word: "ê mặt",
    part_of_speech: "tính từ",
    meaning: "như bẽ mặt: phải nhiều phen ê mặt với bạn bè",
    example: "phải nhiều phen ê mặt với bạn bè",
  },
  {
    word: "êm ả",
    part_of_speech: "tính từ",
    meaning:
      "yên tĩnh, không có sự xao động, gây cảm giác dễ chịu (thường nói về cảnh thiên nhiên): trưa hè êm ả * dòng sông êm ả trôi * trong lòng thốt nhiên êm ả hẳn lại",
    example:
      "trưa hè êm ả * dòng sông êm ả trôi * trong lòng thốt nhiên êm ả hẳn lại",
  },
  {
    word: "ệch",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (nằm) ngay đườn người ra ở chỗ nào đó, trông chướng và khó coi: nằm ệch ngay ở cửa ra vào",
    example: "nằm ệch ngay ở cửa ra vào",
  },
  {
    word: "êm ái",
    part_of_speech: "tính từ",
    meaning:
      "êm, nhẹ, làm cho có cảm giác dễ chịu: bàn tay vuốt ve êm ái * tiếng đàn êm ái, du dương",
    example: "bàn tay vuốt ve êm ái * tiếng đàn êm ái, du dương",
  },
  {
    word: "êm",
    part_of_speech: "tính từ",
    meaning:
      "mềm, dịu, gây cảm giác dễ chịu khi đụng chạm vào: đệm êm * ghế ngồi rất êm",
    example: "đệm êm * ghế ngồi rất êm",
  },
  {
    word: "êm",
    part_of_speech: "tính từ",
    meaning:
      "nhẹ nhàng trong chuyển động, không gây tiếng động đáng kể: xe chạy êm * đi rất êm",
    example: "xe chạy êm * đi rất êm",
  },
  {
    word: "êm",
    part_of_speech: "tính từ",
    meaning:
      "nhẹ nhàng, nghe dễ chịu hoặc dễ bị thuyết phục: giọng hát rất êm * nghe nói cũng êm tai, đồng ý",
    example: "giọng hát rất êm * nghe nói cũng êm tai, đồng ý",
  },
  {
    word: "êm",
    part_of_speech: "tính từ",
    meaning:
      "(thời tiết) không có hiện tượng biến động, không có mưa gió, cũng không nắng to: trời êm, biển lặng * được buổi êm trời",
    example: "trời êm, biển lặng * được buổi êm trời",
  },
  {
    word: "êm",
    part_of_speech: "tính từ",
    meaning:
      "yên ổn, không có gì lôi thôi, rắc rối phải giải quyết: mọi chuyện đều êm cả * trong ấm ngoài êm",
    example: "mọi chuyện đều êm cả * trong ấm ngoài êm",
  },
  {
    word: "ếm",
    part_of_speech: "động từ",
    meaning:
      "dùng phép thuật để ngăn trừ ma quỷ, theo mê tín: ếm quỷ trừ tà * ếm bùa",
    example: "ếm quỷ trừ tà * ếm bùa",
  },
  {
    word: "ếm",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) theo bên cạnh, làm mất đi cái may (trong cờ bạc, buôn bán), theo mê tín: chưa sáng ra đã đến ếm",
    example: "chưa sáng ra đã đến ếm",
  },
  {
    word: "ếm",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) dùng phép thuật để hãm hại, theo mê tín: người ta đồn rằng cô ấy điên là do bị ếm",
    example: "người ta đồn rằng cô ấy điên là do bị ếm",
  },
  {
    word: "êm ấm",
    part_of_speech: "tính từ",
    meaning: "(quan hệ trong gia đình) thuận hoà, tốt đẹp: gia đình êm ấm",
    example: "gia đình êm ấm",
  },
  {
    word: "êm dịu",
    part_of_speech: "tính từ",
    meaning:
      "êm ái và nhẹ nhàng, gây cảm giác dễ chịu: giọng nói êm dịu * màu xanh êm dịu",
    example: "giọng nói êm dịu * màu xanh êm dịu",
  },
  {
    word: "êm ru",
    part_of_speech: "tính từ",
    meaning:
      "rất êm, hầu như không có một tiếng động nào: chiếc xe lướt êm ru trên đường",
    example: "chiếc xe lướt êm ru trên đường",
  },
  {
    word: "êm ru",
    part_of_speech: "tính từ",
    meaning: "nghe rất êm tai: lời nói êm ru * tiếng máy chạy êm ru",
    example: "lời nói êm ru * tiếng máy chạy êm ru",
  },
  {
    word: "êm ru",
    part_of_speech: "tính từ",
    meaning:
      "rất êm, không để xảy ra một sự náo động nào: giải quyết mọi việc êm ru",
    example: "giải quyết mọi việc êm ru",
  },
  {
    word: "êm đềm",
    part_of_speech: "tính từ",
    meaning:
      'yên tĩnh, không có sự xao động, tạo cảm giác yên ổn: dòng sông êm đềm * "Êm đềm trướng rủ màn che, Tường đông ong bướm đi về mặc ai." (TKiều)',
    example:
      'dòng sông êm đềm * "Êm đềm trướng rủ màn che, Tường đông ong bướm đi về mặc ai." (TKiều)',
  },
  {
    word: "êm thấm",
    part_of_speech: "tính từ",
    meaning:
      "(sự việc) được giải quyết suôn sẻ, xong xuôi đâu vào đấy, tránh được xung đột, rắc rối: mọi việc đã được giải quyết êm thấm",
    example: "mọi việc đã được giải quyết êm thấm",
  },
  {
    word: "êm thấm",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) hoà thuận, không hề có xích mích, xung đột: gia đình êm thấm * cố nín nhịn cho êm thấm cửa nhà",
    example: "gia đình êm thấm * cố nín nhịn cho êm thấm cửa nhà",
  },
  {
    word: "êm đẹp",
    part_of_speech: "tính từ",
    meaning:
      "(quan hệ, công việc) được giải quyết tốt đẹp, không xảy ra điều gì không hay: mọi chuyện diễn ra êm đẹp * cho qua để êm đẹp mọi bề",
    example: "mọi chuyện diễn ra êm đẹp * cho qua để êm đẹp mọi bề",
  },
  {
    word: "êm ro",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) êm ru: xe chạy êm ro * máy kêu êm ro",
    example: "xe chạy êm ro * máy kêu êm ro",
  },
  {
    word: "ềnh",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ở tư thế nằm dài thẳng ra, choán nhiều chỗ, trông không đẹp mắt: nằm ềnh ra đất * thằng bé lăn ềnh ra ăn vạ",
    example: "nằm ềnh ra đất * thằng bé lăn ềnh ra ăn vạ",
  },
  {
    word: "êm xuôi",
    part_of_speech: "tính từ",
    meaning:
      "(sự việc diễn ra) yên ổn, thuận lợi, không gặp vướng mắc, trở ngại: mọi việc có vẻ êm xuôi * giải quyết một cách êm xuôi",
    example: "mọi việc có vẻ êm xuôi * giải quyết một cách êm xuôi",
  },
  {
    word: "ềnh ệch",
    part_of_speech: "tính từ",
    meaning: "như ệch (nhưng ý nhấn mạnh hơn): nằm ềnh ệch ra giữa nhà mà ngủ",
    example: "nằm ềnh ệch ra giữa nhà mà ngủ",
  },
  {
    word: "ễnh",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (bụng) to phình và đưa ra phía trước, trông nặng nề và khó coi: chửa ễnh ra * bụng trương ễnh lên",
    example: "chửa ễnh ra * bụng trương ễnh lên",
  },
  {
    word: "êm rơ",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) ở trạng thái không có tiếng động, do im lặng hoàn toàn, không động đậy, không hoạt động: ngồi êm rơ, không nói chi hết",
    example: "ngồi êm rơ, không nói chi hết",
  },
  {
    word: "ềnh ễnh",
    part_of_speech: "tính từ",
    meaning: "như ễnh (nhưng ý mức độ nhiều hơn): bụng chửa ềnh ễnh",
    example: "bụng chửa ềnh ễnh",
  },
  {
    word: "gã",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ người đàn ông nào đó với ý coi thường hoặc không có thiện cảm: gã lái buôn * không ai biết gã từ đâu đến",
    example: "gã lái buôn * không ai biết gã từ đâu đến",
  },
  {
    word: "gạ",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) nói khéo hoặc đưa ra những điều kiện hấp dẫn để người ta bằng lòng làm điều có lợi cho mình: gạ đổi xe * gạ mua ruộng",
    example: "gạ đổi xe * gạ mua ruộng",
  },
  {
    word: "gà",
    part_of_speech: "danh từ",
    meaning:
      "gia cầm nuôi để lấy thịt và trứng, mỏ cứng và nhọn, bay kém, con trống biết gáy: tiếng gà gáy sáng * gà đẻ gà cục tác (tng)",
    example: "tiếng gà gáy sáng * gà đẻ gà cục tác (tng)",
  },
  {
    word: "gà",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) mách cho cách thoát khỏi thế bí: gà bài cho bạn * gà cho một nước cờ",
    example: "gà bài cho bạn * gà cho một nước cờ",
  },
  {
    word: "gá",
    part_of_speech: "động từ",
    meaning:
      "gắn vào, dựa vào một cách tạm bợ: đóng gá vào tường * ở gá một thời gian",
    example: "đóng gá vào tường * ở gá một thời gian",
  },
  {
    word: "gá",
    part_of_speech: "động từ",
    meaning:
      "đặt đúng và giữ chặt vật để chế tạo trên máy: gá thanh sắt lên bàn tiện để tiện",
    example: "gá thanh sắt lên bàn tiện để tiện",
  },
  {
    word: "gá",
    part_of_speech: "động từ",
    meaning:
      "đưa đồ đạc cho người khác tạm giữ làm tin để vay mượn: gá xe lấy tiền đánh bạc",
    example: "gá xe lấy tiền đánh bạc",
  },
  {
    word: "gá",
    part_of_speech: "danh từ",
    meaning: "đồ dùng để gá: bộ gá của máy tiện",
    example: "bộ gá của máy tiện",
  },
  {
    word: "gá",
    part_of_speech: "động từ",
    meaning: "chứa cờ bạc để thu tiền hồ: gá bạc",
    example: "gá bạc",
  },
  {
    word: "ga",
    part_of_speech: "danh từ",
    meaning:
      "công trình kiến trúc làm nơi cho tàu hoả, tàu điện hay máy bay đỗ để hành khách lên xuống hoặc để xếp dỡ hàng hoá: ga hàng không Tân Sơn Nhất * tiếng còi tàu báo hiệu vào ga",
    example: "ga hàng không Tân Sơn Nhất * tiếng còi tàu báo hiệu vào ga",
  },
  {
    word: "ga",
    part_of_speech: "danh từ",
    meaning: "khoảng cách giữa hai ga kế tiếp nhau: còn ba ga nữa mới đến nơi",
    example: "còn ba ga nữa mới đến nơi",
  },
  {
    word: "ga",
    part_of_speech: "danh từ",
    meaning:
      "hỗn hợp xăng và không khí trong máy nổ: tăng ga để vượt dốc * giảm ga",
    example: "tăng ga để vượt dốc * giảm ga",
  },
  {
    word: "ga",
    part_of_speech: "danh từ",
    meaning: "khí hoà tan trong bia, nước giải khát: nước giải khát có ga",
    example: "nước giải khát có ga",
  },
  {
    word: "gạ chuyện",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tìm cách bắt chuyện nhằm một mục đích nào đó có lợi cho mình: mon men đến gần gạ chuyện",
    example: "mon men đến gần gạ chuyện",
  },
  {
    word: "gả",
    part_of_speech: "động từ",
    meaning:
      'bằng lòng cho người con gái do mình nuôi dưỡng lấy ai đó làm chồng: dựng vợ gả chồng * "Có con mà gả chồng gần, Có bát canh cần nó cũng đem cho." (Cdao)',
    example:
      'dựng vợ gả chồng * "Có con mà gả chồng gần, Có bát canh cần nó cũng đem cho." (Cdao)',
  },
  {
    word: "gà ác",
    part_of_speech: "danh từ",
    meaning: "gà nhỏ, lông toàn màu đen, trông như quạ: gà ác tần thuốc bắc",
    example: "gà ác tần thuốc bắc",
  },
  {
    word: "gả bán",
    part_of_speech: "động từ",
    meaning:
      "gả có đủ cheo cưới theo tục lệ cổ truyền: lấy nhau do cha mẹ gả bán",
    example: "lấy nhau do cha mẹ gả bán",
  },
  {
    word: "gạ gẫm",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) gạ (nói khái quát): gạ gẫm để xin tiền * gạ gẫm phụ nữ để lợi dụng",
    example: "gạ gẫm để xin tiền * gạ gẫm phụ nữ để lợi dụng",
  },
  {
    word: "gà gà",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) lim dim mắt ngủ lơ mơ, chưa ngủ hẳn: mắt gà gà * đứa bé đã gà gà ngủ trên tay mẹ",
    example: "mắt gà gà * đứa bé đã gà gà ngủ trên tay mẹ",
  },
  {
    word: "gà gật",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) ngủ lơ mơ, không say, đầu thỉnh thoảng lại gật xuống, do ở tư thế ngồi hoặc đứng: ngủ gà gật * vừa đọc sách vừa gà gật",
    example: "ngủ gà gật * vừa đọc sách vừa gà gật",
  },
  {
    word: "ga lăng",
    part_of_speech: "tính từ",
    meaning:
      "(người đàn ông) tỏ ra lịch sự, đôi khi quá đáng, thiếu tự nhiên, đối với phụ nữ: một chàng trai rất ga lăng",
    example: "một chàng trai rất ga lăng",
  },
  {
    word: "gà mờ",
    part_of_speech: "tính từ",
    meaning: "nhìn không rõ, do mắt bị tật: mắt gà mờ",
    example: "mắt gà mờ",
  },
  {
    word: "gà mờ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) kém khả năng nhận xét, nhận biết, không phát hiện được cả những cái dễ thấy: thằng cha gà mờ! * người đâu mà gà mờ thế không biết",
    example: "thằng cha gà mờ! * người đâu mà gà mờ thế không biết",
  },
  {
    word: "ga ra",
    part_of_speech: "danh từ",
    meaning: "nhà chứa ô tô, có thể kết hợp sửa chữa nhỏ: đánh xe vào ga ra",
    example: "đánh xe vào ga ra",
  },
  {
    word: "gà tồ",
    part_of_speech: "danh từ",
    meaning: "gà to, trụi lông, dáng ngờ nghệch..",
    example: "giọng gà tồ * anh chàng gà tồ ấy thì làm được gì",
  },
  {
    word: "ga-la",
    part_of_speech: "danh từ",
    meaning:
      "buổi hội, ngày hội, có biểu diễn âm nhạc, nghệ thuật, v.v.: đi xem gala cười",
    example: "đi xem gala cười",
  },
  {
    word: "gạc",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như chạc: gạc cây",
    example: "gạc cây",
  },
  {
    word: "gạc",
    part_of_speech: "danh từ",
    meaning: "sừng già phân nhánh của hươu, nai: gạc hươu",
    example: "gạc hươu",
  },
  {
    word: "gác bỏ",
    part_of_speech: "động từ",
    meaning:
      "gạt sang một bên, không để ý tới nữa: gác bỏ chuyện cũ * đầu óc thảnh thơi, gác bỏ mọi toan tính đời thường",
    example:
      "gác bỏ chuyện cũ * đầu óc thảnh thơi, gác bỏ mọi toan tính đời thường",
  },
  {
    word: "gác",
    part_of_speech: "động từ",
    meaning:
      'để, đặt ngang lên trên: gác chân lên ghế * "Kiều từ trở gót trướng hoa, Mặt trời gác núi, chiêng đà thu không." (TKiều)',
    example:
      'gác chân lên ghế * "Kiều từ trở gót trướng hoa, Mặt trời gác núi, chiêng đà thu không." (TKiều)',
  },
  {
    word: "gác",
    part_of_speech: "động từ",
    meaning:
      "tạm để sang một bên, chưa dùng đến hoặc không nghĩ, không nhắc đến nữa: gác việc ấy lại để bàn sau * gác chuyện riêng để lo việc chung",
    example: "gác việc ấy lại để bàn sau * gác chuyện riêng để lo việc chung",
  },
  {
    word: "gác",
    part_of_speech: "danh từ",
    meaning:
      "tầng nhà xây dựng liền lên trên tầng khác: lên gác * phòng của tôi ở gác ba (tầng thứ ba)",
    example: "lên gác * phòng của tôi ở gác ba (tầng thứ ba)",
  },
  {
    word: "gác",
    part_of_speech: "danh từ",
    meaning:
      "nơi cất chứa đồ đạc lặt vặt trong nhà, thường làm bằng những thanh tre, gỗ, v.v. gác trên cao: gác bếp * gác xép",
    example: "gác bếp * gác xép",
  },
  {
    word: "gác",
    part_of_speech: "động từ",
    meaning:
      "trông coi, giữ gìn để bảo đảm an toàn: gác cổng * lính gác * trạm gác",
    example: "gác cổng * lính gác * trạm gác",
  },
  {
    word: "gác xép",
    part_of_speech: "danh từ",
    meaning: "gác lửng nhỏ, thường để chứa đồ đạc: ngủ trên gác xép",
    example: "ngủ trên gác xép",
  },
  {
    word: "gác thượng",
    part_of_speech: "danh từ",
    meaning:
      "tầng gác cao nhất của một ngôi nhà nhiều tầng: gian thờ ở trên gác thượng",
    example: "gian thờ ở trên gác thượng",
  },
  {
    word: "gác thượng",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) như sân thượng: lên gác thượng hóng mát",
    example: "lên gác thượng hóng mát",
  },
  {
    word: "gạch",
    part_of_speech: "danh từ",
    meaning:
      "vật liệu xây dựng, thường làm bằng khối đất nhuyễn đóng khuôn rồi nung lên: đóng gạch * sân lát gạch",
    example: "đóng gạch * sân lát gạch",
  },
  {
    word: "gạch",
    part_of_speech: "danh từ",
    meaning: "khối gan tuỵ màu vàng ở dưới mai cua đồng.: gạch cua",
    example: "gạch cua",
  },
  {
    word: "gạch",
    part_of_speech: "danh từ",
    meaning:
      "phần trứng non màu vàng ở dưới mai cua biển: chắc như cua gạch (tng)",
    example: "chắc như cua gạch (tng)",
  },
  {
    word: "gạch",
    part_of_speech: "động từ",
    meaning:
      "tạo ra một đoạn thẳng khi viết, vẽ: gạch ngang * gạch chéo * gạch đầu dòng",
    example: "gạch ngang * gạch chéo * gạch đầu dòng",
  },
  {
    word: "gạch",
    part_of_speech: "động từ",
    meaning:
      "xoá bỏ bằng cách gạch lên trên cái đã viết: gạch tên trong sổ * gạch bỏ bằng bút chì",
    example: "gạch tên trong sổ * gạch bỏ bằng bút chì",
  },
  {
    word: "gạch",
    part_of_speech: "danh từ",
    meaning: "đoạn thẳng tạo ra khi viết, vẽ: gạch ba bốn gạch",
    example: "gạch ba bốn gạch",
  },
  {
    word: "gạch hoa",
    part_of_speech: "danh từ",
    meaning:
      "gạch tráng men, có hình trang trí, dùng để lát sàn nhà: nền nhà lát gạch hoa",
    example: "nền nhà lát gạch hoa",
  },
  {
    word: "gai",
    part_of_speech: "danh từ",
    meaning:
      "cây thân thảo, gốc hoá gỗ, lá mọc cách hình trái xoan, mép có khía răng, mặt dưới có nhiều lông trắng mềm, lá dùng làm bánh, vỏ thân dùng lấy sợi: bao tải làm bằng sợi dây gai * đan võng gai",
    example: "bao tải làm bằng sợi dây gai * đan võng gai",
  },
  {
    word: "gai",
    part_of_speech: "danh từ",
    meaning:
      "phần cứng, nhọn nhô ra ngoài mặt thân, cành, lá hay quả của một số cây: gai bưởi * gai mít",
    example: "gai bưởi * gai mít",
  },
  {
    word: "gai",
    part_of_speech: "danh từ",
    meaning:
      "những cây cành có nhiều gai, về mặt là trở ngại cho sự đi lại (nói khái quát): bụi cây gai * giẫm lên đám gai mà đi",
    example: "bụi cây gai * giẫm lên đám gai mà đi",
  },
  {
    word: "gai",
    part_of_speech: "danh từ",
    meaning:
      "cái thường xuyên tác động làm vướng mắc, khó chịu, chỉ muốn thoát khỏi hoặc loại bỏ đi: nhổ được cái gai trong mắt",
    example: "nhổ được cái gai trong mắt",
  },
  {
    word: "gai",
    part_of_speech: "danh từ",
    meaning: "gai ốc (nói tắt): rét nổi gai",
    example: "rét nổi gai",
  },
  {
    word: "gai",
    part_of_speech: "tính từ",
    meaning:
      "có cảm giác như ớn lạnh, da nổi gai ốc, khi bị tác động mạnh vào giác quan hoặc hệ thần kinh: gai gai rét * sợ đến gai người",
    example: "gai gai rét * sợ đến gai người",
  },
  {
    word: "gái",
    part_of_speech: "danh từ",
    meaning:
      "người thuộc nữ giới (thường là còn ít tuổi; nói khái quát); phân biệt với trai: con trai, con gái * bác gái * trai tài gái sắc",
    example: "con trai, con gái * bác gái * trai tài gái sắc",
  },
  {
    word: "gái",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) người phụ nữ (hàm ý coi khinh): mang tiền cho gái * mê gái * theo gái",
    example: "mang tiền cho gái * mê gái * theo gái",
  },
  {
    word: "gài",
    part_of_speech: "động từ",
    meaning: "như cài: gài then cửa",
    example: "gài then cửa",
  },
  {
    word: "gãi",
    part_of_speech: "động từ",
    meaning:
      "cào nhẹ lên mặt da bằng móng tay hay một vật cứng nhỏ nhằm làm cho khỏi ngứa: gãi lưng * gãi đúng chỗ ngứa (tng)",
    example: "gãi lưng * gãi đúng chỗ ngứa (tng)",
  },
  {
    word: "gại",
    part_of_speech: "động từ",
    meaning:
      "đưa đi đưa lại vật nhọn hoặc có cạnh sắc cho chạm sướt trên bề mặt của vật khác: gại dao lên trôn bát * gại đầu bút chì xuống nền xi măng",
    example: "gại dao lên trôn bát * gại đầu bút chì xuống nền xi măng",
  },
  {
    word: "gại giọng",
    part_of_speech: "động từ",
    meaning: "đằng hắng thử giọng: gại giọng, rồi kể tiếp",
    example: "gại giọng, rồi kể tiếp",
  },
  {
    word: "gai góc",
    part_of_speech: "danh từ",
    meaning:
      "gai (nói khái quát); thường dùng để ví những khó khăn, trở ngại cần phải vượt qua: bụi cây đầy gai góc * gặp nhiều gai góc trên đường đời",
    example: "bụi cây đầy gai góc * gặp nhiều gai góc trên đường đời",
  },
  {
    word: "gai góc",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) có nhiều khó khăn không dễ vượt qua, không dễ giải quyết: vấn đề quá gai góc",
    example: "vấn đề quá gai góc",
  },
  {
    word: "gai góc",
    part_of_speech: "tính từ",
    meaning:
      "khó tính trong quan hệ, làm cho người khác thấy khó chịu, không muốn gần: tính tình gai góc",
    example: "tính tình gai góc",
  },
  {
    word: "gai ốc",
    part_of_speech: "danh từ",
    meaning:
      "nốt nhỏ nổi lên ở mặt da khi bị lạnh hay quá sợ hãi: lạnh sởn gai ốc",
    example: "lạnh sởn gai ốc",
  },
  {
    word: "gai ngạnh",
    part_of_speech: "tính từ",
    meaning: "ngang bướng, hay gây sự: tính gai ngạnh",
    example: "tính gai ngạnh",
  },
  {
    word: "gái gọi",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) gái mại dâm, thường nhận yêu cầu phục vụ khách qua đường dây đã được tổ chức (thường bằng điện thoại): một tú bà chuyên cung cấp gái gọi cao cấp",
    example: "một tú bà chuyên cung cấp gái gọi cao cấp",
  },
  {
    word: "gai mắt",
    part_of_speech: "tính từ",
    meaning:
      "chướng mắt, nhìn thấy không thể chịu được: ăn mặc thì loè loẹt, đến là gai mắt  * làm những điều trái tai gai mắt",
    example:
      "ăn mặc thì loè loẹt, đến là gai mắt  * làm những điều trái tai gai mắt",
  },
  {
    word: "gala",
    part_of_speech: "danh từ",
    meaning:
      "buổi hội, ngày hội, có biểu diễn âm nhạc, nghệ thuật, v.v.: đi xem gala cười",
    example: "đi xem gala cười",
  },
  {
    word: "gam",
    part_of_speech: "danh từ",
    meaning: "thang bậc của màu sắc: gam màu sáng",
    example: "gam màu sáng",
  },
  {
    word: "gan",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận của bộ máy tiêu hoá có chức năng chính là tiết mật để tiêu hoá chất mỡ: bị suy gan * cháo tim gan",
    example: "bị suy gan * cháo tim gan",
  },
  {
    word: "gan",
    part_of_speech: "danh từ",
    meaning:
      "gan của con người, được coi là biểu tượng của tinh thần, ý chí mạnh mẽ, bền bỉ, dám đương đầu với nguy hiểm, dám chịu đựng: non gan * bền gan vững chí * gan vàng dạ sắt * miệng hùm gan sứa (tng)",
    example:
      "non gan * bền gan vững chí * gan vàng dạ sắt * miệng hùm gan sứa (tng)",
  },
  {
    word: "gan",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra có gan, dám đương đầu với nguy hiểm hoặc dám chịu đựng: con bé gan lắm, bị đòn đau thế mà không khóc",
    example: "con bé gan lắm, bị đòn đau thế mà không khóc",
  },
  {
    word: "gan",
    part_of_speech: "danh từ",
    meaning:
      "phần hơi trũng ở giữa lòng bàn chân hay bàn tay: gan bàn chân * bôi dầu vào gan bàn tay",
    example: "gan bàn chân * bôi dầu vào gan bàn tay",
  },
  {
    word: "gan",
    part_of_speech: "danh từ",
    meaning:
      "phần gắn liền với rễ của cây mạ, do các bẹ lá bọc lấy nhau làm thành: mạ to gan, đanh dảnh",
    example: "mạ to gan, đanh dảnh",
  },
  {
    word: "gan dạ",
    part_of_speech: "tính từ",
    meaning:
      "có tinh thần không lùi bước trước nguy hiểm, không sợ nguy hiểm: một chiến sĩ thông minh, gan dạ",
    example: "một chiến sĩ thông minh, gan dạ",
  },
  {
    word: "gạn",
    part_of_speech: "động từ",
    meaning:
      "lấy riêng cho hết phần chất nước nổi lên trên, sau khi đã để cho các thứ khác lắng xuống: gạn bột * gạn nước vôi trong",
    example: "gạn bột * gạn nước vôi trong",
  },
  {
    word: "gạn",
    part_of_speech: "động từ",
    meaning:
      'hỏi cặn kẽ, hỏi cho đến cùng: gạn tóc tơ * "Bấy lâu mới được một ngày, Dừng chân, gạn chút niềm tây gọi là..." (TKiều)',
    example:
      'gạn tóc tơ * "Bấy lâu mới được một ngày, Dừng chân, gạn chút niềm tây gọi là..." (TKiều)',
  },
  {
    word: "gán",
    part_of_speech: "động từ",
    meaning:
      "đưa hiện vật để trừ nợ: gán xe trừ nợ * làm giấy gán ruộng * gán vợ đợ con",
    example: "gán xe trừ nợ * làm giấy gán ruộng * gán vợ đợ con",
  },
  {
    word: "gán",
    part_of_speech: "động từ",
    meaning:
      "cho là của người nào đó cái mà thực ra người ấy không có: bị gán cho nhiều tật xấu",
    example: "bị gán cho nhiều tật xấu",
  },
  {
    word: "gán",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) ghép đôi trai gái với nhau: gán hai người với nhau",
    example: "gán hai người với nhau",
  },
  {
    word: "gan gà",
    part_of_speech: "danh từ",
    meaning:
      "màu vàng hoặc xám vàng, giống như màu gan của gà (thường nói về đất sét): đất gan gà",
    example: "đất gan gà",
  },
  {
    word: "gàn",
    part_of_speech: "động từ",
    meaning:
      "khuyên đừng làm điều đã định làm: gàn không cho hai bên đánh nhau * đã quyết thì không ai gàn được",
    example: "gàn không cho hai bên đánh nhau * đã quyết thì không ai gàn được",
  },
  {
    word: "gàn",
    part_of_speech: "tính từ",
    meaning:
      "có những suy nghĩ, hành động trái với lẽ thường, mà ai bảo cũng không nghe: tính hơi gàn",
    example: "tính hơi gàn",
  },
  {
    word: "gan góc",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra có tinh thần dám đương đầu với mọi sự nguy hiểm: một chiến sĩ gan góc",
    example: "một chiến sĩ gan góc",
  },
  {
    word: "gàn dở",
    part_of_speech: "tính từ",
    meaning: "gàn đến mức như ngớ ngẩn: tính gàn dở * ăn nói gàn dở",
    example: "tính gàn dở * ăn nói gàn dở",
  },
  {
    word: "gạn đục khơi trong",
    part_of_speech: "",
    meaning:
      'chọn lọc để loại bỏ hết đi cái không hay, cái xấu, giữ lại và phát huy cái hay, cái tốt (nói về những cái có giá trị văn hoá, tinh thần): "Thân tàn, gạn đục khơi trong, Là nhờ quân tử khác lòng người ta." (TKiều)',
    example:
      'Thân tàn, gạn đục khơi trong, Là nhờ quân tử khác lòng người ta." (TKiều)',
  },
  {
    word: "gạn gùng",
    part_of_speech: "động từ",
    meaning:
      '(cũ, hiếm) gạn hỏi hết sức cặn kẽ: "Gạn gùng ngành ngọn cho tường, Lạ lùng, nàng hãy tìm đường nói quanh." (TKiều)',
    example:
      'Gạn gùng ngành ngọn cho tường, Lạ lùng, nàng hãy tìm đường nói quanh." (TKiều)',
  },
  {
    word: "gán ghép",
    part_of_speech: "động từ",
    meaning:
      "gán vào một cách gượng ép: bị gán ghép đủ mọi điều xấu xa tội lỗi",
    example: "bị gán ghép đủ mọi điều xấu xa tội lỗi",
  },
  {
    word: "gán ghép",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) ghép đôi trai gái với nhau để vui đùa: bị bạn bè gán ghép với cô hàng xóm",
    example: "bị bạn bè gán ghép với cô hàng xóm",
  },
  {
    word: "gạn lọc",
    part_of_speech: "động từ",
    meaning:
      "chọn lọc rất kĩ (thường nói về những cái có giá trị tinh thần): gạn lọc lấy những câu ngạn ngữ quý",
    example: "gạn lọc lấy những câu ngạn ngữ quý",
  },
  {
    word: "gan ruột",
    part_of_speech: "danh từ",
    meaning:
      'như ruột gan: "Xa em gan ruột như bào, Chưa vui sum họp cớ nào chia phôi." (ca dao)',
    example:
      'Xa em gan ruột như bào, Chưa vui sum họp cớ nào chia phôi." (ca dao)',
  },
  {
    word: "gan liền tướng quân",
    part_of_speech: "",
    meaning:
      '(văn chương, hiếm) như gan lì tướng quân: "Tử sinh liều giữa trận tiền, Dạn dày cho biết gan liền tướng quân." (TKiều)',
    example:
      'Tử sinh liều giữa trận tiền, Dạn dày cho biết gan liền tướng quân." (TKiều)',
  },
  {
    word: "gan lì",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) gan đến mức như trơ ra, không còn biết sợ là gì: thằng bé gan lì",
    example: "thằng bé gan lì",
  },
  {
    word: "gang",
    part_of_speech: "danh từ",
    meaning:
      'khoảng cách tối đa có được giữa đầu ngón tay cái và đầu ngón tay giữa khi dang thẳng bàn tay, thường dùng làm đơn vị đo độ dài, khoảng bằng 20 centimet: "Đời người có một gang tay, Ai hay ngủ ngày chỉ được nửa gang." (Cdao)',
    example:
      'Đời người có một gang tay, Ai hay ngủ ngày chỉ được nửa gang." (Cdao)',
  },
  {
    word: "gang",
    part_of_speech: "danh từ",
    meaning:
      "hợp kim của sắt với carbon và một số nguyên tố, thường dùng để đúc đồ vật: chảo gang * nấu cơm bằng nồi gang",
    example: "chảo gang * nấu cơm bằng nồi gang",
  },
  {
    word: "gang",
    part_of_speech: "động từ",
    meaning: "(Thông tục) dùng tay banh rộng (mồm) ra: gang mồm nó ra",
    example: "gang mồm nó ra",
  },
  {
    word: "gang tấc",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương) khoảng cách rất ngắn, không đáng kể, tựa như chỉ bằng một gang tay (nói khái quát): cách nhau gang tấc * thoát chết trong gang tấc",
    example: "cách nhau gang tấc * thoát chết trong gang tấc",
  },
  {
    word: "gàng",
    part_of_speech: "danh từ",
    meaning: "dụng cụ để quấn tơ, sợi vào ống: chiếc gàng gỗ hình lục lăng",
    example: "chiếc gàng gỗ hình lục lăng",
  },
  {
    word: "ganh",
    part_of_speech: "động từ",
    meaning:
      "tỏ ra khó chịu khi thấy người ta có phần hơn mình: ganh ăn * hai bên ganh nhau từng tí một",
    example: "ganh ăn * hai bên ganh nhau từng tí một",
  },
  {
    word: "ganh",
    part_of_speech: "động từ",
    meaning:
      "cố hết sức để sao cho được hơn người: ganh sức đua tài * hai người ganh nhau về thành tích học tập",
    example: "ganh sức đua tài * hai người ganh nhau về thành tích học tập",
  },
  {
    word: "gang thép",
    part_of_speech: "tính từ",
    meaning:
      "cứng cỏi, vững vàng đến mức không gì lay chuyển được (tựa như gang và thép): ý chí gang thép",
    example: "ý chí gang thép",
  },
  {
    word: "gangster",
    part_of_speech: "danh từ",
    meaning:
      "kẻ tội phạm có vũ trang chuyên thực hiện các hành vi giết chóc, cướp bóc, thanh toán lẫn nhau, có ở một số nước tư bản: phim gangster (phim có các cảnh đâm chém, giết chóc theo kiểu gangster)",
    example:
      "phim gangster (phim có các cảnh đâm chém, giết chóc theo kiểu gangster)",
  },
  {
    word: "gánh chịu",
    part_of_speech: "động từ",
    meaning:
      "buộc phải nhận lấy điều không hay hoặc thiệt hại về mình: gánh chịu hậu quả * gánh chịu mọi khổ đau",
    example: "gánh chịu hậu quả * gánh chịu mọi khổ đau",
  },
  {
    word: "gảnh",
    part_of_speech: "động từ",
    meaning:
      "đi quân sĩ hay quân tượng trong cờ tướng từ hàng dưới cùng tiến lên một bước theo đường chéo, để vào chính giữa, che mặt tướng: ghểnh tượng * ghểnh sĩ",
    example: "ghểnh tượng * ghểnh sĩ",
  },
  {
    word: "gánh",
    part_of_speech: "động từ",
    meaning:
      "mang chuyển (thường là vật nặng) bằng cách mắc vào hai đầu một cái đòn đặt trên vai: gánh nước * gánh hàng ra chợ",
    example: "gánh nước * gánh hàng ra chợ",
  },
  {
    word: "gánh",
    part_of_speech: "động từ",
    meaning:
      "nhận về mình việc khó khăn phải làm hoặc cái nặng nề phải chịu: gánh trách nhiệm * gánh hạn cho cả nhà",
    example: "gánh trách nhiệm * gánh hạn cho cả nhà",
  },
  {
    word: "gánh",
    part_of_speech: "danh từ",
    meaning:
      "khối lượng một người gánh trong một lần: gánh một gánh khoai nặng * cất gánh lên vai",
    example: "gánh một gánh khoai nặng * cất gánh lên vai",
  },
  {
    word: "gánh",
    part_of_speech: "danh từ",
    meaning:
      "phần việc khó khăn, nặng nề phải chịu trách nhiệm: nặng gánh gia đình",
    example: "nặng gánh gia đình",
  },
  {
    word: "gánh",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) gánh hát (nói tắt): sau buổi diễn, ông bầu tuyên bố rã gánh",
    example: "sau buổi diễn, ông bầu tuyên bố rã gánh",
  },
  {
    word: "ganh ghét",
    part_of_speech: "động từ",
    meaning:
      "thấy người ta hơn mình mà sinh ra ghét: thấy người ta hơn mình là sinh lòng ganh ghét",
    example: "thấy người ta hơn mình là sinh lòng ganh ghét",
  },
  {
    word: "gánh gồng",
    part_of_speech: "",
    meaning:
      "như gồng gánh: “Tha hương cố quốc ngại ngùng, Lấy ai san sẻ gánh gồng đường xa.” (TrTKhải; 4)",
    example:
      "“Tha hương cố quốc ngại ngùng, Lấy ai san sẻ gánh gồng đường xa.” (TrTKhải; 4)",
  },
  {
    word: "ganh đua",
    part_of_speech: "động từ",
    meaning:
      "cố hết sức làm cho mình hơn mọi người trong một hoạt động có nhiều người cùng tham gia, không muốn thấy bất cứ ai hơn hoặc bằng mình: ganh đua với đời",
    example: "ganh đua với đời",
  },
  {
    word: "gánh vác",
    part_of_speech: "động từ",
    meaning:
      'gánh lấy việc khó khăn, nặng nề (nói khái quát): gánh vác nhiều trọng trách * "Ghé vai gánh vác sơn hà, Sao cho tỏ mặt mới là trượng phu." (ca dao)',
    example:
      'gánh vác nhiều trọng trách * "Ghé vai gánh vác sơn hà, Sao cho tỏ mặt mới là trượng phu." (ca dao)',
  },
  {
    word: "gào",
    part_of_speech: "động từ",
    meaning:
      "kêu to và kéo dài tiếng từ trong cổ họng: mèo gào * gào rát cả cổ",
    example: "mèo gào * gào rát cả cổ",
  },
  {
    word: "gào",
    part_of_speech: "động từ",
    meaning:
      "phát ra những âm thanh to và kéo dài, thành từng hồi dài (thường nói về sóng, gió): sóng biển gào lên * tiếng gió vẫn gào lên dữ dội",
    example: "sóng biển gào lên * tiếng gió vẫn gào lên dữ dội",
  },
  {
    word: "gạo",
    part_of_speech: "danh từ",
    meaning:
      "nhân của hạt thóc, đã qua xay giã, dùng làm lương thực: giã gạo * vo gạo thổi cơm * thóc cao gạo kém",
    example: "giã gạo * vo gạo thổi cơm * thóc cao gạo kém",
  },
  {
    word: "gạo",
    part_of_speech: "danh từ",
    meaning:
      "nang ấu trùng của sán, hình hạt gạo, ở thịt lợn hay thịt bò bị bệnh sán: lợn gạo",
    example: "lợn gạo",
  },
  {
    word: "gáo",
    part_of_speech: "danh từ",
    meaning:
      "vật dùng để múc chất lỏng, có cán cầm; cũng dùng để chỉ lượng chất lỏng đựng trong đó: gáo nhựa * xin một gáo nước",
    example: "gáo nhựa * xin một gáo nước",
  },
  {
    word: "ganh tị",
    part_of_speech: "",
    meaning:
      "so tính hơn thiệt và khó chịu khi thấy người ta hơn mình: ganh tị nhau từng tí một",
    example: "ganh tị nhau từng tí một",
  },
  {
    word: "gạo cội",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) rất giỏi, rất có tài nghệ, do đã có thâm niên trong nghề (thường nói về diễn viên và vận động viên thể thao): một diễn viên gạo cội * cán bộ gạo cội của phong trào",
    example: "một diễn viên gạo cội * cán bộ gạo cội của phong trào",
  },
  {
    word: "gạo chợ nước sông",
    part_of_speech: "",
    meaning:
      'tả cảnh sống nghèo túng, bấp bênh, ăn đong từng bữa: "Cũng là gạo chợ nước sông, Đói no xẻ miếng, khốn cùng chia nhau." (ca dao)',
    example:
      'Cũng là gạo chợ nước sông, Đói no xẻ miếng, khốn cùng chia nhau." (ca dao)',
  },
  {
    word: "gạo lức",
    part_of_speech: "danh từ",
    meaning:
      "gạo mới xay ra, chưa giã; phân biệt với gạo giã: nấu cháo gạo lứt",
    example: "nấu cháo gạo lứt",
  },
  {
    word: "gào thét",
    part_of_speech: "động từ",
    meaning:
      "gào rất to để biểu thị một tình cảm nào đó (thường là giận dữ, căm hờn): sóng biển gào thét * nói gần như gào thét",
    example: "sóng biển gào thét * nói gần như gào thét",
  },
  {
    word: "gạt",
    part_of_speech: "động từ",
    meaning:
      "đẩy sang một bên: gạt tàn thuốc * gạt chân chống * đưa tay gạt nước mắt",
    example: "gạt tàn thuốc * gạt chân chống * đưa tay gạt nước mắt",
  },
  {
    word: "gạt",
    part_of_speech: "động từ",
    meaning:
      "dùng vật thẳng đưa ngang miệng đồ đong để đẩy đi phần cao hơn miệng (thường nói về việc đong ngũ cốc): đong hai bơ gạt",
    example: "đong hai bơ gạt",
  },
  {
    word: "gạt",
    part_of_speech: "động từ",
    meaning:
      "loại hẳn đi, coi như không có, không cần biết đến: cứ nhắc đến chuyện ấy là nó lại gạt phắt đi",
    example: "cứ nhắc đến chuyện ấy là nó lại gạt phắt đi",
  },
  {
    word: "gạt",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) gán (nợ): gạt nợ",
    example: "gạt nợ",
  },
  {
    word: "gạt",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) lừa: bị nó gạt mà không biết",
    example: "bị nó gạt mà không biết",
  },
  {
    word: "gạo nước",
    part_of_speech: "danh từ",
    meaning:
      "các thức chủ yếu dùng cho bữa ăn hằng ngày (nói khái quát): chuẩn bị gạo nước ăn Tết",
    example: "chuẩn bị gạo nước ăn Tết",
  },
  {
    word: "gas",
    part_of_speech: "danh từ",
    meaning: "khí đốt: khí gas * nạp gas",
    example: "khí gas * nạp gas",
  },
  {
    word: "gạt gẫm",
    part_of_speech: "động từ",
    meaning: "gạt (nói khái quát); đánh lừa: chuyên gạt gẫm những người nhẹ dạ",
    example: "chuyên gạt gẫm những người nhẹ dạ",
  },
  {
    word: "gau gáu",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như rau ráu: nhai xương gau gáu",
    example: "nhai xương gau gáu",
  },
  {
    word: "gàu",
    part_of_speech: "danh từ",
    meaning: "thịt có lẫn mỡ ở ngực bò: phở gàu",
    example: "phở gàu",
  },
  {
    word: "gàu",
    part_of_speech: "danh từ",
    meaning:
      "chất bẩn màu trắng do chất mỡ từ hạch mồ hôi ở da đầu tiết ra và khô lại: đầu có nhiều gàu * dầu gội trị gàu",
    example: "đầu có nhiều gàu * dầu gội trị gàu",
  },
  {
    word: "gàu",
    part_of_speech: "danh từ",
    meaning: "vật dùng để tát nước hay để múc nước giếng: gàu tát nước",
    example: "gàu tát nước",
  },
  {
    word: "gay",
    part_of_speech: "động từ",
    meaning: "vặn vòng dây để xoắn chặt mái chèo vào cọc chèo: gay chèo",
    example: "gay chèo",
  },
  {
    word: "gay",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có khó khăn rất khó khắc phục: tình hình gay lắm! * đang lúc bận thế này mà ốm thì gay!",
    example: "tình hình gay lắm! * đang lúc bận thế này mà ốm thì gay!",
  },
  {
    word: "gáy",
    part_of_speech: "danh từ",
    meaning: "phần phía sau cổ người: rợn tóc gáy",
    example: "rợn tóc gáy",
  },
  {
    word: "gáy",
    part_of_speech: "danh từ",
    meaning:
      "phần ngoài bìa của quyển sách, chỗ các trang giấy và hai trang bìa được đính lại với nhau: gáy sách",
    example: "gáy sách",
  },
  {
    word: "gáy",
    part_of_speech: "động từ",
    meaning:
      '(gà trống, một số loài chim, và dế) phát ra những tiếng làm thành chuỗi âm thanh cao thấp, liên tiếp, nhịp nhàng: dế gáy * "Mỗi lần nắng mới hắt bên song, Xao xác, gà trưa gáy não nùng." (LTrLư; 6)',
    example:
      'dế gáy * "Mỗi lần nắng mới hắt bên song, Xao xác, gà trưa gáy não nùng." (LTrLư; 6)',
  },
  {
    word: "gãy",
    part_of_speech: "động từ",
    meaning:
      "(vật cứng, dài) bị phân ra thành nhiều phần do tác dụng đột ngột của lực cơ học: cành cây gãy * bị ngã gãy chân * tuổi mười bảy bẻ gãy sừng trâu (tng)",
    example:
      "cành cây gãy * bị ngã gãy chân * tuổi mười bảy bẻ gãy sừng trâu (tng)",
  },
  {
    word: "gãy",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bị thất bại, bị hỏng một cách bất ngờ: buổi biểu diễn bị gãy * bẻ gãy âm mưu của quân phiến loạn",
    example: "buổi biểu diễn bị gãy * bẻ gãy âm mưu của quân phiến loạn",
  },
  {
    word: "gãy",
    part_of_speech: "tính từ",
    meaning:
      "có chỗ gấp khúc, không được thẳng như bình thường: khuôn mặt hơi gãy * chữ viết bị gãy nét",
    example: "khuôn mặt hơi gãy * chữ viết bị gãy nét",
  },
  {
    word: "gay cấn",
    part_of_speech: "",
    meaning:
      "có nhiều trở ngại, vướng mắc đến mức như không vượt qua, không thể giải quyết được: giai đoạn gay cấn * vấn đề gay cấn nhất đã được giải quyết * tình hình rất gay cấn",
    example:
      "giai đoạn gay cấn * vấn đề gay cấn nhất đã được giải quyết * tình hình rất gay cấn",
  },
  {
    word: "gay cấn",
    part_of_speech: "",
    meaning:
      "có nhiều tình tiết lắt léo, giật gân, nhiều xung đột gay gắt gây hấp dẫn, hồi hộp: những pha gay cấn",
    example: "những pha gay cấn",
  },
  {
    word: "gay gắt",
    part_of_speech: "tính từ",
    meaning:
      "ở mức độ cao, gây cảm giác khó chịu hoặc căng thẳng: nắng gay gắt * mâu thuẫn hết sức gay gắt",
    example: "nắng gay gắt * mâu thuẫn hết sức gay gắt",
  },
  {
    word: "gay gắt",
    part_of_speech: "tính từ",
    meaning:
      "không nhẹ nhàng, không nương nhẹ, dù có làm khó chịu hoặc gây căng thẳng: phê bình một cách gay gắt",
    example: "phê bình một cách gay gắt",
  },
  {
    word: "gảy",
    part_of_speech: "động từ",
    meaning:
      "hất đi hoặc hất lên bằng đầu ngón tay hay bằng đầu của một vật hình que: gảy con sâu bám trên cành hoa * gảy bàn tính",
    example: "gảy con sâu bám trên cành hoa * gảy bàn tính",
  },
  {
    word: "gảy",
    part_of_speech: "động từ",
    meaning:
      "làm nẩy dây đàn cho rung lên thành tiếng, bằng động tác gảy liên tiếp: gảy đàn",
    example: "gảy đàn",
  },
  {
    word: "gay go",
    part_of_speech: "tính từ",
    meaning:
      "rất gay, do có khó khăn lớn khó khắc phục, trong khi tình hình lại đang đòi hỏi được giải quyết (nói khái quát): thử thách gay go * tình hình rất gay go",
    example: "thử thách gay go * tình hình rất gay go",
  },
  {
    word: "gãy gọn",
    part_of_speech: "tính từ",
    meaning: "(cách diễn đạt) ngắn gọn và rõ ràng, rành mạch: trả lời gãy gọn",
    example: "trả lời gãy gọn",
  },
  {
    word: "găm",
    part_of_speech: "động từ",
    meaning:
      "làm cho bị mắc vào vật khác bằng một vật nhỏ, dài và nhọn: găm tờ giấy lên vách",
    example: "găm tờ giấy lên vách",
  },
  {
    word: "găm",
    part_of_speech: "động từ",
    meaning:
      "bị mắc sâu vào vật khác sau khi đâm thủng (thường nói về những vật nhọn, sắc cạnh): bị một viên đạn găm vào vai * cỏ may găm đầy gấu quần",
    example: "bị một viên đạn găm vào vai * cỏ may găm đầy gấu quần",
  },
  {
    word: "găm",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) giữ rịt lấy không chịu đưa ra, nhằm mưu lợi riêng: găm tài liệu vào phòng thi * găm hàng lại để chờ tăng giá",
    example: "găm tài liệu vào phòng thi * găm hàng lại để chờ tăng giá",
  },
  {
    word: "gặm",
    part_of_speech: "động từ",
    meaning:
      "cắn dần từng ít một để ăn (thường là vật cứng, khó cắn đứt): gặm xương * đàn bò gặm cỏ",
    example: "gặm xương * đàn bò gặm cỏ",
  },
  {
    word: "gắn",
    part_of_speech: "động từ",
    meaning:
      "làm cho dính chặt vào với nhau bằng một chất dính: gắn xi * gắn phím đàn * gắn lại chiếc bình vỡ",
    example: "gắn xi * gắn phím đàn * gắn lại chiếc bình vỡ",
  },
  {
    word: "gắn",
    part_of_speech: "động từ",
    meaning:
      "làm cho được giữ chặt vào và liền thành một khối với vật khác: thuyền gắn máy * căn phòng có gắn máy điều hoà nhiệt độ",
    example: "thuyền gắn máy * căn phòng có gắn máy điều hoà nhiệt độ",
  },
  {
    word: "gắn",
    part_of_speech: "động từ",
    meaning: "cài, đính: gắn huân chương lên ngực * mũ có gắn ngôi sao",
    example: "gắn huân chương lên ngực * mũ có gắn ngôi sao",
  },
  {
    word: "gắn",
    part_of_speech: "động từ",
    meaning:
      "có quan hệ hoặc làm cho có quan hệ chặt chẽ, không tách rời nhau: tình yêu đã gắn chặt hai người lại với nhau",
    example: "tình yêu đã gắn chặt hai người lại với nhau",
  },
  {
    word: "gằm",
    part_of_speech: "động từ",
    meaning:
      "(mặt) cúi xuống, không dám hoặc không muốn nhìn lên: mặt cúi gằm * xấu hổ nên cứ gằm mặt xuống",
    example: "mặt cúi gằm * xấu hổ nên cứ gằm mặt xuống",
  },
  {
    word: "gãy góc",
    part_of_speech: "tính từ",
    meaning: "có đường nét với những góc cạnh rõ ràng: chữ viết rất gãy góc",
    example: "chữ viết rất gãy góc",
  },
  {
    word: "gãy góc",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) rõ ràng từng điểm, với những ý kiến dứt khoát: bàn cho gãy góc rồi hẵng làm",
    example: "bàn cho gãy góc rồi hẵng làm",
  },
  {
    word: "găm giữ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) giữ lại, găm lại không chịu đưa ra, nhằm mưu lợi riêng: găm giữ hàng chờ lên giá",
    example: "găm giữ hàng chờ lên giá",
  },
  {
    word: "gằn",
    part_of_speech: "động từ",
    meaning:
      "bưng hai tay lắc nhẹ cho những hạt to tròn lăn dồn về một phía trên vật đựng nông, có đáy phẳng như nia, mẹt (để có thể chọn nhặt riêng ra): gằn gạo * gằn đậu xanh",
    example: "gằn gạo * gằn đậu xanh",
  },
  {
    word: "gằn",
    part_of_speech: "động từ",
    meaning:
      "dằn từng tiếng rành rọt (thường để tỏ thái độ bực tức): hỏi gằn từng tiếng",
    example: "hỏi gằn từng tiếng",
  },
  {
    word: "gặm nhấm",
    part_of_speech: "động từ",
    meaning:
      "gặm để huỷ hoại dần dần từng ít một (thường dùng với nghĩa bóng): nỗi buồn gặm nhấm tâm hồn",
    example: "nỗi buồn gặm nhấm tâm hồn",
  },
  {
    word: "găng",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng để mang vào bàn tay, được làm từ nhiều loại chất liệu khác nhau: đeo găng cho khỏi cóng tay",
    example: "đeo găng cho khỏi cóng tay",
  },
  {
    word: "găng",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái có những sự phát triển hoặc những hoạt động được đẩy đến cao độ, tạo nên mâu thuẫn gay gắt: tình hình găng quá * không khí buổi họp đang rất găng",
    example: "tình hình găng quá * không khí buổi họp đang rất găng",
  },
  {
    word: "găng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) không chịu nhân nhượng, khăng khăng giữ ý kiến của mình, gây căng thẳng trong quan hệ: làm găng * thấy chồng găng, nên phải đấu dịu",
    example: "làm găng * thấy chồng găng, nên phải đấu dịu",
  },
  {
    word: "gắn kết",
    part_of_speech: "động từ",
    meaning:
      "gắn chặt với nhau, không thể tách rời: gắn kết với nhau đến trọn đời",
    example: "gắn kết với nhau đến trọn đời",
  },
  {
    word: "găn gắt",
    part_of_speech: "tính từ",
    meaning: "(mùi, vị) hơi gắt: nước mắm găn gắt",
    example: "nước mắm găn gắt",
  },
  {
    word: "gắn bó",
    part_of_speech: "",
    meaning:
      "có quan hệ hoặc làm cho có quan hệ về tinh thần, tình cảm khó tách rời: gắn bó với quê hương * tình cảm gắn bó keo sơn",
    example: "gắn bó với quê hương * tình cảm gắn bó keo sơn",
  },
  {
    word: "găng tay",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng để mang vào bàn tay, được làm từ nhiều loại chất liệu khác nhau: đeo găng cho khỏi cóng tay",
    example: "đeo găng cho khỏi cóng tay",
  },
  {
    word: "găng tay",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái có những sự phát triển hoặc những hoạt động được đẩy đến cao độ, tạo nên mâu thuẫn gay gắt: tình hình găng quá * không khí buổi họp đang rất găng",
    example: "tình hình găng quá * không khí buổi họp đang rất găng",
  },
  {
    word: "găng tay",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) không chịu nhân nhượng, khăng khăng giữ ý kiến của mình, gây căng thẳng trong quan hệ: làm găng * thấy chồng găng, nên phải đấu dịu",
    example: "làm găng * thấy chồng găng, nên phải đấu dịu",
  },
  {
    word: "gặng",
    part_of_speech: "động từ",
    meaning:
      "cố hỏi đi hỏi lại cho bằng được điều người ta không muốn nói: gặng hỏi * gặng mãi nó cũng chỉ nói có một câu ấy",
    example: "gặng hỏi * gặng mãi nó cũng chỉ nói có một câu ấy",
  },
  {
    word: "gắng công",
    part_of_speech: "động từ",
    meaning:
      "bỏ công sức nhiều hơn bình thường để làm: gắng công học tập * gắng công đợi chờ",
    example: "gắng công học tập * gắng công đợi chờ",
  },
  {
    word: "gắng gượng",
    part_of_speech: "động từ",
    meaning:
      "gắng làm một cách khó khăn, vì sức đang yếu hoặc không còn khả năng nữa: mệt nhưng vẫn gắng gượng ngồi dậy * gắng gượng ăn uống cho lại người",
    example:
      "mệt nhưng vẫn gắng gượng ngồi dậy * gắng gượng ăn uống cho lại người",
  },
  {
    word: "gắng",
    part_of_speech: "động từ",
    meaning:
      "đưa sức ra nhiều hơn bình thường để làm: gắng hết sức làm cho xong * gắng học cho thành tài",
    example: "gắng hết sức làm cho xong * gắng học cho thành tài",
  },
  {
    word: "gắng sức",
    part_of_speech: "động từ",
    meaning:
      "đưa sức ra nhiều hơn bình thường để làm việc gì: gắng sức đạp xe lên dốc * gắng sức học cho thành tài",
    example: "gắng sức đạp xe lên dốc * gắng sức học cho thành tài",
  },
  {
    word: "gắp",
    part_of_speech: "động từ",
    meaning:
      "lấy ra bằng cách dùng đũa hoặc dùng cặp kẹp chặt: gắp thức ăn * mổ vết thương để gắp mảnh đạn ra * gắp lửa bỏ tay người (tng)",
    example:
      "gắp thức ăn * mổ vết thương để gắp mảnh đạn ra * gắp lửa bỏ tay người (tng)",
  },
  {
    word: "gắp",
    part_of_speech: "danh từ",
    meaning: "cặp làm bằng tre hay bằng sắt, dùng kẹp cá, thịt để nướng..",
    example: "một gắp chả * gắp vài gắp đã hết đĩa rau",
  },
  {
    word: "găngxtơ",
    part_of_speech: "danh từ",
    meaning:
      "kẻ tội phạm có vũ trang chuyên thực hiện các hành vi giết chóc, cướp bóc, thanh toán lẫn nhau, có ở một số nước tư bản: phim gangster (phim có các cảnh đâm chém, giết chóc theo kiểu gangster)",
    example:
      "phim gangster (phim có các cảnh đâm chém, giết chóc theo kiểu gangster)",
  },
  {
    word: "gặp",
    part_of_speech: "động từ",
    meaning:
      "(từ những hướng khác nhau) cùng có mặt và tiếp xúc với nhau tại một nơi, một địa điểm nào đó: gặp người quen * những tư tưởng lớn gặp nhau (b)",
    example: "gặp người quen * những tư tưởng lớn gặp nhau (b)",
  },
  {
    word: "gặp",
    part_of_speech: "động từ",
    meaning:
      "tiếp xúc hoặc tiếp nhận tác động trực tiếp của một hiện tượng nào đó trong một quá trình hoạt động: gặp trận mưa rào * gặp tai nạn * những lỗi thường gặp khi dịch tiếng Anh",
    example:
      "gặp trận mưa rào * gặp tai nạn * những lỗi thường gặp khi dịch tiếng Anh",
  },
  {
    word: "gặp",
    part_of_speech: "động từ",
    meaning:
      "ở trong một khoảng thời gian hoặc một hoàn cảnh nào đó một cách tình cờ: gặp hôm biển động * gặp năm hạn hán * gặp lúc không có ai",
    example: "gặp hôm biển động * gặp năm hạn hán * gặp lúc không có ai",
  },
  {
    word: "gặp gỡ",
    part_of_speech: "động từ",
    meaning:
      'gặp nhau giữa những người có quan hệ ít nhiều thân mật: cuộc gặp gỡ * "Người đâu gặp gỡ làm chi, Trăm năm biết có duyên gì hay không?" (TKiều)',
    example:
      'cuộc gặp gỡ * "Người đâu gặp gỡ làm chi, Trăm năm biết có duyên gì hay không?" (TKiều)',
  },
  {
    word: "gặp mặt",
    part_of_speech: "động từ",
    meaning:
      "gặp nhau nhân dịp gì giữa những người có cùng một quan hệ nào đó: gặp mặt các học sinh cũ của trường * buổi gặp mặt đầu năm",
    example: "gặp mặt các học sinh cũ của trường * buổi gặp mặt đầu năm",
  },
  {
    word: "gắt",
    part_of_speech: "động từ",
    meaning:
      "nói với giọng điệu, thái độ thiếu bình tĩnh, thiếu ôn hoà, để trút nỗi bực dọc: hơi một tí là gắt * cáu quá, gắt um lên",
    example: "hơi một tí là gắt * cáu quá, gắt um lên",
  },
  {
    word: "gắt",
    part_of_speech: "tính từ",
    meaning:
      "ở mức độ cao một cách ít nhiều không bình thường, tác động khó chịu đến các giác quan: mặn gắt * màu đỏ gắt * trời nắng gắt",
    example: "mặn gắt * màu đỏ gắt * trời nắng gắt",
  },
  {
    word: "gắt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ở một mức độ cao khác thường, gây cảm giác căng thẳng: kiểm tra gắt * phê bình rất gắt",
    example: "kiểm tra gắt * phê bình rất gắt",
  },
  {
    word: "gặt",
    part_of_speech: "động từ",
    meaning: "cắt lúa chín để thu hoạch: gặt lúa * gieo gió gặt bão (tng)",
    example: "gặt lúa * gieo gió gặt bão (tng)",
  },
  {
    word: "gắt gỏng",
    part_of_speech: "động từ",
    meaning: "gắt (nói khái quát): tính hay gắt gỏng * giọng gắt gỏng",
    example: "tính hay gắt gỏng * giọng gắt gỏng",
  },
  {
    word: "gắt gao",
    part_of_speech: "tính từ",
    meaning:
      "rất gắt, với cường độ mạnh, gây cảm giác căng thẳng hay khó chịu (nói khái quát): kiểm duyệt gắt gao * ánh nắng gắt gao * khủng bố gắt gao",
    example: "kiểm duyệt gắt gao * ánh nắng gắt gao * khủng bố gắt gao",
  },
  {
    word: "gặt hái",
    part_of_speech: "động từ",
    meaning: "gặt và thu hoạch mùa màng (nói khái quát): mùa gặt hái",
    example: "mùa gặt hái",
  },
  {
    word: "gặt hái",
    part_of_speech: "động từ",
    meaning:
      "đạt được, thu được kết quả tốt đẹp (sau một thời gian lao động; nói khái quát): gặt hái nhiều thành công * gặt hái được những thành tựu to lớn",
    example: "gặt hái nhiều thành công * gặt hái được những thành tựu to lớn",
  },
  {
    word: "gấc",
    part_of_speech: "danh từ",
    meaning:
      "cây leo thuộc họ bầu bí, quả to, hình trứng nhọn đầu, ngoài mặt có nhiều gai mềm, ruột đỏ, thường dùng để thổi lẫn với xôi: đỏ như gấc * nấu xôi gấc",
    example: "đỏ như gấc * nấu xôi gấc",
  },
  {
    word: "gầm gào",
    part_of_speech: "động từ",
    meaning:
      "gầm lên, gào lên, thường gây tác động đáng sợ: tiếng phản lực gầm gào * sóng biển gầm gào",
    example: "tiếng phản lực gầm gào * sóng biển gầm gào",
  },
  {
    word: "gầm",
    part_of_speech: "danh từ",
    meaning:
      "khoảng trống kể từ mặt nền đến đáy của một số vật xây dựng hoặc kê bên trên: gầm cầu thang * trốn dưới gầm bàn * chó chui gầm chạn (tng)",
    example: "gầm cầu thang * trốn dưới gầm bàn * chó chui gầm chạn (tng)",
  },
  {
    word: "gầm",
    part_of_speech: "động từ",
    meaning:
      "(loài thú) phát ra tiếng kêu vang, mạnh, dữ dội: tiếng hổ gầm trong đêm * voi gầm",
    example: "tiếng hổ gầm trong đêm * voi gầm",
  },
  {
    word: "gầm",
    part_of_speech: "động từ",
    meaning:
      "phát ra tiếng rất to, vang rền, làm rung chuyển xung quanh: gầm lên như con thú dữ * tiếng đại bác gầm lên",
    example: "gầm lên như con thú dữ * tiếng đại bác gầm lên",
  },
  {
    word: "gấm",
    part_of_speech: "danh từ",
    meaning: "hàng dệt bằng tơ nhiều màu, có hình hoa lá: áo gấm",
    example: "áo gấm",
  },
  {
    word: "gầm rít",
    part_of_speech: "động từ",
    meaning:
      "gầm và rít lên thành từng hồi, một cách liên tục và dữ dội, gây cảm giác sợ hãi: máy bay gầm rít trên đầu * tiếng gió gầm rít trên không trung",
    example: "máy bay gầm rít trên đầu * tiếng gió gầm rít trên không trung",
  },
  {
    word: "gầm ghè",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tỏ thái độ thù địch, ở tư thế vừa giữ miếng vừa sẵn sàng gây sự: nhìn nhau gầm ghè * hai bên gầm ghè toan đánh nhau",
    example: "nhìn nhau gầm ghè * hai bên gầm ghè toan đánh nhau",
  },
  {
    word: "gầm gừ",
    part_of_speech: "động từ",
    meaning:
      "(thú vật, thường là chó) phát ra những tiếng kêu giận dữ đang nén trong cổ: con chó gầm gừ chực cắn",
    example: "con chó gầm gừ chực cắn",
  },
  {
    word: "gầm gừ",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) như gầm ghè (nhưng ý nhấn mạnh hơn): nhìn nhau gầm gừ",
    example: "nhìn nhau gầm gừ",
  },
  {
    word: "gấm vóc",
    part_of_speech: "danh từ",
    meaning:
      "(Văn chương) gấm và vóc, hai thứ hàng dệt đẹp và quý; thường dùng để ví vẻ đẹp của thiên nhiên, đất nước: lụa là gấm vóc * non sông gấm vóc",
    example: "lụa là gấm vóc * non sông gấm vóc",
  },
  {
    word: "gầm trời",
    part_of_speech: "danh từ",
    meaning:
      "khoảng không gian bên dưới vòm trời, thường dùng để chỉ cả thế gian: tung hoành khắp cả gầm trời * dưới gầm trời này, không ai độc ác như hắn ta",
    example:
      "tung hoành khắp cả gầm trời * dưới gầm trời này, không ai độc ác như hắn ta",
  },
  {
    word: "gầm rú",
    part_of_speech: "động từ",
    meaning:
      "gầm và rú liên tiếp, dữ dội, gây cảm giác rùng rợn: tiếng máy bay gầm rú trên bầu trời",
    example: "tiếng máy bay gầm rú trên bầu trời",
  },
  {
    word: "bánh mật",
    part_of_speech: "danh từ",
    meaning:
      "bánh làm bằng bột gạo nếp trộn với mật, có nhân đậu xanh hoặc lạc, thường gói bằng lá chuối khô, hấp chín.",
    example: "da ngăm ngăm bánh mật",
  },
  {
    word: "bành tô",
    part_of_speech: "danh từ",
    meaning: "(cũ) măng tô: chiếc áo bành tô cũ",
    example: "chiếc áo bành tô cũ",
  },
  {
    word: "bánh tét",
    part_of_speech: "danh từ",
    meaning:
      "bánh làm từ nguyên liệu giống bánh chưng nhưng gói thành hình trụ to và dài, làm phổ biến ở một số địa phương (miền Trung và miền Nam) vào dịp Tết Nguyên Đán: đòn bánh tét",
    example: "đòn bánh tét",
  },
  {
    word: "bánh tẻ",
    part_of_speech: "tính từ",
    meaning:
      "(cây hoặc bộ phận của cây) không non, nhưng cũng không già: tre bánh tẻ * lá chuối bánh tẻ * lạc bánh tẻ",
    example: "tre bánh tẻ * lá chuối bánh tẻ * lạc bánh tẻ",
  },
  {
    word: "bành trướng",
    part_of_speech: "động từ",
    meaning:
      "mở rộng phạm vi tác động: bành trướng thế lực * bành trướng về kinh tế * chính sách bành trướng của các nước đế quốc",
    example:
      "bành trướng thế lực * bành trướng về kinh tế * chính sách bành trướng của các nước đế quốc",
  },
  {
    word: "bảnh trai",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) đẹp trai: một thanh niên bảnh trai",
    example: "một thanh niên bảnh trai",
  },
  {
    word: "báo",
    part_of_speech: "danh từ",
    meaning:
      "hình thức thông tin tuyên truyền có tính chất đại chúng, được thể hiện qua các ấn phẩm định kì hoặc qua các phương tiện thông tin đại chúng khác (như truyền thanh, truyền hình, Internet), có đưa tin, bài, tranh ảnh, v.v.: bài đăng báo * điểm báo * toà soạn báo",
    example: "bài đăng báo * điểm báo * toà soạn báo",
  },
  {
    word: "báo",
    part_of_speech: "danh từ",
    meaning:
      "hình thức thông tin tuyên truyền có tính chất nội bộ, được thể hiện qua các bài viết, tranh vẽ trực tiếp trên giấy, trên bảng, v.v.: báo bảng * báo tường",
    example: "báo bảng * báo tường",
  },
  {
    word: "báo",
    part_of_speech: "động từ",
    meaning:
      "cho biết việc gì đó đã xảy ra: báo tin cho bạn * giấy báo có bưu phẩm",
    example: "báo tin cho bạn * giấy báo có bưu phẩm",
  },
  {
    word: "báo",
    part_of_speech: "động từ",
    meaning:
      "cho người có trách nhiệm biết về việc xảy ra có thể hại đến trật tự an ninh chung: báo công an * nếu có gì xảy ra, phải báo ngay cho cơ quan hữu trách",
    example:
      "báo công an * nếu có gì xảy ra, phải báo ngay cho cơ quan hữu trách",
  },
  {
    word: "báo",
    part_of_speech: "động từ",
    meaning: "là dấu hiệu cho biết trước: chim én báo xuân về * chim báo bão",
    example: "chim én báo xuân về * chim báo bão",
  },
  {
    word: "bạo",
    part_of_speech: "tính từ",
    meaning:
      "có cử chỉ, hành động tỏ ra là không rụt rè, không e ngại: con bé bạo lắm, không sợ gì cả  * đánh bạo hỏi một câu",
    example: "con bé bạo lắm, không sợ gì cả  * đánh bạo hỏi một câu",
  },
  {
    word: "bào",
    part_of_speech: "động từ",
    meaning: "làm nhẵn mặt gỗ bằng cái bào: bào nhẵn mặt gỗ",
    example: "bào nhẵn mặt gỗ",
  },
  {
    word: "bào",
    part_of_speech: "động từ",
    meaning:
      'xát vào, cọ xát làm cho mòn: mặt đất bị bào mòn * "Em thương anh ruột thắt gan bào, Biết anh có thương em lại chút nào hay không?" (ca dao)',
    example:
      'mặt đất bị bào mòn * "Em thương anh ruột thắt gan bào, Biết anh có thương em lại chút nào hay không?',
  },
  {
    word: "bão",
    part_of_speech: "danh từ",
    meaning:
      "gió xoáy trong phạm vi rộng trong một vùng có áp suất không khí giảm xuống rất thấp, thường phát sinh từ biển khơi, có sức phá hoại dữ dội do gió lớn, mưa to: cơn bão * góp gió thành bão (tng)",
    example: "cơn bão * góp gió thành bão (tng)",
  },
  {
    word: "bão",
    part_of_speech: "danh từ",
    meaning: "chứng đau bụng xuyên ra sau lưng quặn từng cơn: đau bão",
    example: "đau bão",
  },
  {
    word: "bao",
    part_of_speech: "danh từ",
    meaning:
      "đồ đựng hình cái túi to, miệng rộng, có thể khâu, dán hoặc buộc kín lại: mấy bao cát * bao đựng gạo * hàng đã đóng bao",
    example: "mấy bao cát * bao đựng gạo * hàng đã đóng bao",
  },
  {
    word: "bao",
    part_of_speech: "danh từ",
    meaning:
      "vật để đựng hoặc bảo quản một số đồ vật, hàng hoá nhỏ: bao diêm * rút kiếm ra khỏi bao",
    example: "bao diêm * rút kiếm ra khỏi bao",
  },
  {
    word: "bao",
    part_of_speech: "danh từ",
    meaning:
      'dải vải hoặc lụa, may thành hình cái túi dài để thắt ngang lưng, theo cách ăn mặc cũ: "Hỡi cô mà thắt bao xanh, Có về Kim Lũ với anh thì về." (Cdao)',
    example: 'Hỡi cô mà thắt bao xanh, Có về Kim Lũ với anh thì về." (Cdao)',
  },
  {
    word: "bao",
    part_of_speech: "động từ",
    meaning:
      "bọc, vây kín khắp xung quanh: hàng rào bao quanh nhà * các cổ động viên bao kín cầu thủ",
    example: "hàng rào bao quanh nhà * các cổ động viên bao kín cầu thủ",
  },
  {
    word: "bao",
    part_of_speech: "danh từ",
    meaning:
      'mức độ, số lượng hoặc khoảng thời gian nào đó không rõ (thường dùng để hỏi): đường còn bao xa? * tụi nó có bao người? * "Hỏi con Ngọc thỏ đà bao tuổi?, Chớ chị Hằng Nga đã mấy con?" (HXHương; 19)',
    example:
      'đường còn bao xa? * tụi nó có bao người? * "Hỏi con Ngọc thỏ đà bao tuổi?, Chớ chị Hằng Nga đã mấy con?" (HXHương; 19)',
  },
  {
    word: "bao",
    part_of_speech: "danh từ",
    meaning:
      'mức độ hay số lượng nào đó không biết chính xác (nhưng nghĩ là khá nhiều): hạnh phúc xiết bao! * ngần ấy chẳng đáng là bao * "Trải bao thỏ lặn, ác tà, Ấy mồ vô chủ, ai mà viếng thăm." (TKiều)',
    example:
      'hạnh phúc xiết bao! * ngần ấy chẳng đáng là bao * "Trải bao thỏ lặn, ác tà, Ấy mồ vô chủ, ai mà viếng thăm." (TKiều)',
  },
  {
    word: "bao",
    part_of_speech: "động từ",
    meaning:
      "nhận làm toàn bộ việc gì đó thay cho người khác, đơn vị khác: bao toàn bộ việc tiêu thụ sản phẩm",
    example: "bao toàn bộ việc tiêu thụ sản phẩm",
  },
  {
    word: "bao",
    part_of_speech: "động từ",
    meaning:
      "trả thay hoặc cấp toàn bộ khoản tiền cần thiết để chi phí cho việc gì đó (thường là việc ăn uống, vui chơi, v.v.): bao một chầu bia * đem tiền bao gái",
    example: "bao một chầu bia * đem tiền bao gái",
  },
  {
    word: "bảo an",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị vũ trang địa phương có tính chất cảnh sát ở một số nước: lính bảo an",
    example: "lính bảo an",
  },
  {
    word: "bảo",
    part_of_speech: "động từ",
    meaning:
      "nói ra điều gì đó với ai (thường với người ngang hàng hay người dưới): bảo sao nghe vậy * ai bảo mày thế? * có ăn không thì bảo? (ý hăm doạ)",
    example:
      "bảo sao nghe vậy * ai bảo mày thế? * có ăn không thì bảo? (ý hăm doạ)",
  },
  {
    word: "bảo",
    part_of_speech: "động từ",
    meaning:
      "nói cho biết để phải theo đó mà làm: bảo cách làm * gọi dạ, bảo vâng",
    example: "bảo cách làm * gọi dạ, bảo vâng",
  },
  {
    word: "bảo",
    part_of_speech: "động từ",
    meaning:
      "nói cho biết để phải theo đó mà làm: bảo ngọc * quý giáliên kết ngoài",
    example: "bảo ngọc * quý giáliên kết ngoài",
  },
  {
    word: "bạo bệnh",
    part_of_speech: "danh từ",
    meaning: "bệnh hiểm nghèo, phát sinh đột ngột: đã qua đời sau cơn bạo bệnh",
    example: "đã qua đời sau cơn bạo bệnh",
  },
  {
    word: "bảo ban",
    part_of_speech: "động từ",
    meaning:
      '(khẩu ngữ) bảo cho biết điều hay lẽ phải (nói khái quát): bảo ban con cháu trong nhà * chị em bảo ban nhau học hành * "(...) em không hiểu điều gì đến hỏi, các anh ấy đều bảo ban rất cẩn thận." (NgKhải; 16)',
    example:
      'bảo ban con cháu trong nhà * chị em bảo ban nhau học hành * "(...) em không hiểu điều gì đến hỏi, các anh ấy đều bảo ban rất cẩn thận." (NgKhải; 16)',
  },
  {
    word: "báo ảnh",
    part_of_speech: "danh từ",
    meaning:
      "loại hình báo chí trình bày chủ yếu bằng hình ảnh, có lời giải thích và một số bài viết ngắn; phân biệt với báo điện tử, báo hình, báo nói, báo viết: báo ảnh Việt Nam",
    example: "báo ảnh Việt Nam",
  },
  {
    word: "bao bì",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng làm vỏ bọc ở ngoài để đựng, để đóng gói hàng hoá (nói khái quát): sản xuất bao bì * hàng tốt, bao bì, mẫu mã đẹp",
    example: "sản xuất bao bì * hàng tốt, bao bì, mẫu mã đẹp",
  },
  {
    word: "bao biện",
    part_of_speech: "động từ",
    meaning:
      "trực tiếp làm mọi việc, cả những việc lẽ ra phải để cho người khác làm, hoặc cùng làm, thường dẫn đến kết quả không tốt: tác phong bao biện",
    example: "tác phong bao biện",
  },
  {
    word: "báo biểu",
    part_of_speech: "danh từ",
    meaning:
      "bản báo cáo dưới dạng biểu thống kê được tạo ra trên máy tính: xem qua báo biểu trước khi in",
    example: "xem qua báo biểu trước khi in",
  },
  {
    word: "bao bọc",
    part_of_speech: "động từ",
    meaning:
      'bao khắp xung quanh (nói khái quát): lớp không khí dày bao bọc Trái Đất * nhà có tường cao bao bọc * "Cuộc sống trưởng giả no đủ bao bọc lấy tôi." (NgHThiệp; 1)',
    example:
      'lớp không khí dày bao bọc Trái Đất * nhà có tường cao bao bọc * "Cuộc sống trưởng giả no đủ bao bọc lấy tôi." (NgHThiệp; 1)',
  },
  {
    word: "bảo bối",
    part_of_speech: "danh từ",
    meaning:
      "vật báu có phép lạ trong truyện thần thoại hoặc vật quý giá cần được trân trọng, giữ gìn: bảo bối của gia tộc",
    example: "bảo bối của gia tộc",
  },
  {
    word: "báo bổ",
    part_of_speech: "động từ",
    meaning: "(cũ, văn chương) như báo đáp: cố gắng học giỏi để báo bổ cha mẹ",
    example: "cố gắng học giỏi để báo bổ cha mẹ",
  },
  {
    word: "bão bùng",
    part_of_speech: "danh từ",
    meaning:
      '(văn chương) bão (nói khái quát): mưa gió bão bùng * "Bão bùng cành ngọn xơ rơ, Chim không nơi đỗ dật dờ phương nao." (ca dao)',
    example:
      'mưa gió bão bùng * "Bão bùng cành ngọn xơ rơ, Chim không nơi đỗ dật dờ phương nao." (ca dao)',
  },
  {
    word: "báo cáo",
    part_of_speech: "động từ",
    meaning:
      "chính thức trình bày sự việc, tình hình hoặc ý kiến (với cấp trên, hoặc với hội nghị, với quần chúng): báo cáo thành tích * báo cáo công tác",
    example: "báo cáo thành tích * báo cáo công tác",
  },
  {
    word: "báo cáo",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) từ dùng trước một từ xưng gọi để mở đầu khi trình bày với cấp trên (thường dùng trong quân đội): báo cáo thủ trưởng, tất cả đã sẵn sàng!",
    example: "báo cáo thủ trưởng, tất cả đã sẵn sàng!",
  },
  {
    word: "báo cáo",
    part_of_speech: "danh từ",
    meaning:
      "bản trình bày về một vấn đề nào đó: nộp báo cáo hằng tháng * viết báo cáo khoa học",
    example: "nộp báo cáo hằng tháng * viết báo cáo khoa học",
  },
  {
    word: "bào bọt",
    part_of_speech: "tính từ",
    meaning:
      '(phương ngữ) như cồn cào: "Tuy nhiên, thỉnh thoảng chị lại thở dài, nỗi lo cứ bào bọt trong ruột." (NgThi; 8)',
    example:
      'Tuy nhiên, thỉnh thoảng chị lại thở dài, nỗi lo cứ bào bọt trong ruột." (NgThi; 8)',
  },
  {
    word: "bao che",
    part_of_speech: "động từ",
    meaning:
      "che chở, che giấu tội lỗi, khuyết điểm cho người nào đó: phê bình thẳng thắn, không bao che * bao che khuyết điểm cho nhau",
    example:
      "phê bình thẳng thắn, không bao che * bao che khuyết điểm cho nhau",
  },
  {
    word: "bạo chúa",
    part_of_speech: "danh từ",
    meaning: "vua hoặc chúa tàn ác, hung bạo: tên bạo chúa",
    example: "tên bạo chúa",
  },
  {
    word: "bao cấp",
    part_of_speech: "động từ",
    meaning:
      "(cơ quan nhà nước) cấp phát, phân phối, trả công cho cán bộ, nhân viên mà không tính toán hoặc không đòi hỏi hiệu quả kinh tế tương ứng: chế độ bao cấp * cơ chế quản lí kinh tế quan liêu bao cấp",
    example: "chế độ bao cấp * cơ chế quản lí kinh tế quan liêu bao cấp",
  },
  {
    word: "báo chí",
    part_of_speech: "danh từ",
    meaning:
      "các loại hình thông tin tuyên truyền như báo, tạp chí, v.v. (nói khái quát): giới báo chí * tin tức biết được qua báo chí",
    example: "giới báo chí * tin tức biết được qua báo chí",
  },
  {
    word: "bào chữa",
    part_of_speech: "động từ",
    meaning:
      "dùng lí lẽ và chứng cớ để bênh vực cho một đương sự trước toà án: luật sư bào chữa cho bị cáo",
    example: "luật sư bào chữa cho bị cáo",
  },
  {
    word: "bào chữa",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) đưa ra lí do để thanh minh, giải thích cho hành vi sai phạm hoặc cho việc nào đó đang bị lên án: bào chữa cho khuyết điểm của mình",
    example: "bào chữa cho khuyết điểm của mình",
  },
  {
    word: "báo danh",
    part_of_speech: "động từ",
    meaning:
      "báo tên người dự thi ghi trong danh sách, mỗi tên có một mã số tương ứng: thí sinh đã nhận được phiếu báo danh",
    example: "thí sinh đã nhận được phiếu báo danh",
  },
  {
    word: "bạo dạn",
    part_of_speech: "tính từ",
    meaning:
      "bạo, không rụt rè, không sợ sệt (nói khái quát): ăn nói bạo dạn * cử chỉ bạo dạn",
    example: "ăn nói bạo dạn * cử chỉ bạo dạn",
  },
  {
    word: "bao dung",
    part_of_speech: "tính từ",
    meaning:
      "Rộng lòng cảm thông, tha thứ cho lỗi lầm của người khác, thương yêu đối với mọi người: nụ cười bao dung * tấm lòng bao dung",
    example: "nụ cười bao dung * tấm lòng bao dung",
  },
  {
    word: "báo công",
    part_of_speech: "động từ",
    meaning:
      "báo cáo thành tích, công trạng (để được xét khen thưởng): bản báo công",
    example: "bản báo công",
  },
  {
    word: "bảo dưỡng",
    part_of_speech: "động từ",
    meaning:
      "trông nom, giữ gìn, sửa chữa (thiết bị, cầu đường, v.v.) khi cần thiết, giữ ở trạng thái có thể sử dụng bình thường: sửa chữa, bảo dưỡng thiết bị * bảo dưỡng đường bộ * bảo dưỡng xe máy",
    example:
      "sửa chữa, bảo dưỡng thiết bị * bảo dưỡng đường bộ * bảo dưỡng xe máy",
  },
  {
    word: "bảo chứng",
    part_of_speech: "động từ",
    meaning:
      "bảo đảm bằng chứng cớ, bằng thực tế: dùng sổ đỏ để bảo chứng vay tiền",
    example: "dùng sổ đỏ để bảo chứng vay tiền",
  },
  {
    word: "bảo chứng",
    part_of_speech: "danh từ",
    meaning: "vật làm bảo chứng: không có gì làm bảo chứng",
    example: "không có gì làm bảo chứng",
  },
  {
    word: "báo đền",
    part_of_speech: "động từ",
    meaning: "(hiếm) như báo đáp (nhưng nói về công ơn to lớn): báo đền ơn vua",
    example: "báo đền ơn vua",
  },
  {
    word: "báo đáp",
    part_of_speech: "động từ",
    meaning:
      'đền đáp ân nghĩa: báo đáp công ơn cha mẹ * "Nàng rằng: Nhờ cậy uy linh, Hãy xin báo đáp ân tình cho phu." (TKiều)',
    example:
      'báo đáp công ơn cha mẹ * "Nàng rằng: Nhờ cậy uy linh, Hãy xin báo đáp ân tình cho phu." (TKiều)',
  },
  {
    word: "bảo đảm",
    part_of_speech: "động từ",
    meaning:
      "tạo điều kiện để chắc chắn giữ gìn được, hoặc thực hiện được, hoặc có được những gì cần thiết: thu nhập cao, đời sống được bảo đảm * phát huy dân chủ, bảo đảm công bằng xã hội",
    example:
      "thu nhập cao, đời sống được bảo đảm * phát huy dân chủ, bảo đảm công bằng xã hội",
  },
  {
    word: "bảo đảm",
    part_of_speech: "động từ",
    meaning:
      "cam đoan chịu trách nhiệm: nhờ người bảo đảm để vay tiền * thư gửi bảo đảm",
    example: "nhờ người bảo đảm để vay tiền * thư gửi bảo đảm",
  },
  {
    word: "bảo đảm",
    part_of_speech: "động từ",
    meaning: "nhận chịu trách nhiệm làm tốt: bảo đảm hoàn thành tốt nhiệm vụ",
    example: "bảo đảm hoàn thành tốt nhiệm vụ",
  },
  {
    word: "bảo đảm",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) tốt, chắc chắn, không có gì đáng ngại: dây bảo hiểm rất bảo đảm",
    example: "dây bảo hiểm rất bảo đảm",
  },
  {
    word: "bạo động",
    part_of_speech: "động từ",
    meaning:
      "vũ trang nổi dậy nhằm lật đổ chính quyền hoặc chống lại chính quyền: cuộc bạo động",
    example: "cuộc bạo động",
  },
  {
    word: "bạo động",
    part_of_speech: "danh từ",
    meaning:
      "cuộc nổi dậy có vũ trang nhằm lật đổ chính quyền: làm bạo động * bạo động liên tiếp xảy ra ở thành phố này",
    example: "làm bạo động * bạo động liên tiếp xảy ra ở thành phố này",
  },
  {
    word: "bão giông",
    part_of_speech: "danh từ",
    meaning:
      "dông và bão (nói khái quát); thường dùng để ví những gian nan, thử thách, hoặc sự việc xảy ra dữ dội, mãnh liệt: dông bão của cuộc đời * trong nhà đã xảy ra dông bão",
    example: "dông bão của cuộc đời * trong nhà đã xảy ra dông bão",
  },
  {
    word: "báo giá",
    part_of_speech: "động từ",
    meaning:
      "(bên bán hàng hoặc làm dịch vụ) báo bằng văn bản cho khách hàng biết giá cả: bản báo giá",
    example: "bản báo giá",
  },
  {
    word: "báo động",
    part_of_speech: "động từ",
    meaning:
      "(dùng tín hiệu hoặc hiệu lệnh) báo cho mọi người biết có việc nguy cấp đang xảy ra để sẵn sàng ứng phó: kéo còi báo động * tình trạng lãng phí đã đến mức báo động",
    example: "kéo còi báo động * tình trạng lãng phí đã đến mức báo động",
  },
  {
    word: "bạo gan",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có gan làm những việc người khác thường e sợ, e ngại: anh ta bạo gan thật!",
    example: "anh ta bạo gan thật!",
  },
  {
    word: "bao gồm",
    part_of_speech: "động từ",
    meaning:
      "gồm có (trong một pham vi, giới hạn nhất định): giá bán đã bao gồm VAT * bài viết bao gồm ba phần chính",
    example: "giá bán đã bao gồm VAT * bài viết bao gồm ba phần chính",
  },
  {
    word: "bao gói",
    part_of_speech: "động từ",
    meaning: "đóng gói: hàng hoá được bao gói cẩn thận",
    example: "hàng hoá được bao gói cẩn thận",
  },
  {
    word: "bao giờ",
    part_of_speech: "đại từ",
    meaning:
      "khoảng thời gian nào đó, không rõ (thường dùng để hỏi): bao giờ thì đi? * tôi nói thế bao giờ?",
    example: "bao giờ thì đi? * tôi nói thế bao giờ?",
  },
  {
    word: "bao giờ",
    part_of_speech: "đại từ",
    meaning:
      'khoảng thời gian nào đó không rõ hoặc không muốn nói rõ, nhưng với ý đã từ lâu lắm hoặc còn lâu lắm: hết từ bao giờ rồi còn hỏi! * "Bao giờ chạch đẻ ngọn đa, Sáo đẻ dưới nước thì ta lấy mình." (ca dao)',
    example:
      'hết từ bao giờ rồi còn hỏi! * "Bao giờ chạch đẻ ngọn đa, Sáo đẻ dưới nước thì ta lấy mình." (ca dao)',
  },
  {
    word: "bao giờ",
    part_of_speech: "đại từ",
    meaning:
      "bất kì lúc nào, bất kì khoảng thời gian nào: không to tiếng với ai bao giờ * bao giờ xảy ra hẵng hay * bao giờ cũng thế",
    example:
      "không to tiếng với ai bao giờ * bao giờ xảy ra hẵng hay * bao giờ cũng thế",
  },
  {
    word: "báo hại",
    part_of_speech: "động từ",
    meaning: "bám vào, làm cho bị thiệt hại: báo hại cha mẹ!",
    example: "báo hại cha mẹ!",
  },
  {
    word: "bao hàm",
    part_of_speech: "động từ",
    meaning:
      '(nội dung) hàm chứa bên trong: câu thơ bao hàm nhiều ý nghĩa * "Lời nói vô tâm của Quỳnh Hoa chúa thấy bao hàm cả bao nhiêu ý trách móc." (NgHTưởng; 2)',
    example:
      'câu thơ bao hàm nhiều ý nghĩa * "Lời nói vô tâm của Quỳnh Hoa chúa thấy bao hàm cả bao nhiêu ý trách móc." (NgHTưởng; 2)',
  },
  {
    word: "bảo hành",
    part_of_speech: "động từ",
    meaning:
      "(cơ sở sản xuất hoặc bán ra mặt hàng) cam kết sửa chữa miễn phí những lỗi hỏng hóc, nếu có, trong một thời hạn nhất định: máy được bảo hành hai năm * hết thời hạn bảo hành",
    example: "máy được bảo hành hai năm * hết thời hạn bảo hành",
  },
  {
    word: "bạo hành",
    part_of_speech: "danh từ",
    meaning: "hành động bạo lực tàn ác: lên án nạn bạo hành trẻ em",
    example: "lên án nạn bạo hành trẻ em",
  },
  {
    word: "báo hỉ",
    part_of_speech: "động từ",
    meaning:
      "(gia đình sắp có đám cưới) báo tin mừng về việc hôn nhân: giấy báo hỉ",
    example: "giấy báo hỉ",
  },
  {
    word: "bảo hiểm",
    part_of_speech: "động từ",
    meaning:
      "bảo đảm sự an toàn, phòng ngừa tai nạn: mũ bảo hiểm * thắt dây bảo hiểm",
    example: "mũ bảo hiểm * thắt dây bảo hiểm",
  },
  {
    word: "bảo hiểm",
    part_of_speech: "danh từ",
    meaning:
      "sự bảo đảm của cơ quan bảo hiểm chi cho đối tượng tham gia bảo hiểm (có đóng một khoản tiền nhất định theo định kì) một khoản tiền theo quy định khi hết tuổi lao động hoặc khi có tai nạn, rủi ro xảy đến: đóng bảo hiểm * mua bảo hiểm xe máy",
    example: "đóng bảo hiểm * mua bảo hiểm xe máy",
  },
  {
    word: "bảo hiểm y tế",
    part_of_speech: "danh từ",
    meaning:
      "hình thức bảo hiểm mà đối tượng tham gia được hưởng các quyền lợi về chăm sóc sức khoẻ và điều trị bệnh: thẻ bảo hiểm y tế",
    example: "thẻ bảo hiểm y tế",
  },
  {
    word: "bào hao",
    part_of_speech: "động từ",
    meaning:
      '(cũ) xót xa, không yên lòng: "Mẹ cha trong dạ bào hao, Số phải khổ đói, biết bao giờ rồi?" (PCCH)',
    example:
      'Mẹ cha trong dạ bào hao, Số phải khổ đói, biết bao giờ rồi?" (PCCH)',
  },
  {
    word: "bào hao",
    part_of_speech: "động từ",
    meaning: "bắt chước theo, hùa theo: người làm sao, bào hao làm vậy (tng)",
    example: "người làm sao, bào hao làm vậy (tng)",
  },
  {
    word: "báo hiệu",
    part_of_speech: "động từ",
    meaning:
      "báo cho biết bằng hiệu lệnh, tín hiệu: bắn súng báo hiệu * đèn đỏ báo hiệu dừng",
    example: "bắn súng báo hiệu * đèn đỏ báo hiệu dừng",
  },
  {
    word: "báo hiệu",
    part_of_speech: "động từ",
    meaning:
      "(văn chương) (dấu hiệu) báo trước cái sắp đến: chim én báo hiệu xuân về",
    example: "chim én báo hiệu xuân về",
  },
  {
    word: "báo hiếu",
    part_of_speech: "động từ",
    meaning: "đền đáp công ơn cha mẹ: báo hiếu cha mẹ",
    example: "báo hiếu cha mẹ",
  },
  {
    word: "bảo hiểm xã hội",
    part_of_speech: "danh từ",
    meaning:
      "hình thức bảo hiểm cho người lao động mà đối tượng tham gia được hưởng những quyền lợi vật chất khi hết tuổi lao động hoặc khi không làm việc được vì ốm đau, sinh đẻ, bị tai nạn lao động: đóng bảo hiểm xã hội * hưởng trợ cấp bảo hiểm xã hội",
    example: "đóng bảo hiểm xã hội * hưởng trợ cấp bảo hiểm xã hội",
  },
  {
    word: "bảo hoàng",
    part_of_speech: "tính từ",
    meaning:
      "có xu hướng ủng hộ, bảo vệ chế độ quân chủ: phái bảo hoàng * tư tưởng bảo hoàng",
    example: "phái bảo hoàng * tư tưởng bảo hoàng",
  },
  {
    word: "bão hoà",
    part_of_speech: "tính từ",
    meaning:
      "(chất lỏng) ở trạng thái không thể hoà tan thêm được nữa; hoặc (khoảng không gian) ở trạng thái không thể chứa thêm hơi nước được nữa: dung dịch bão hoà * không khí bão hoà hơi nước",
    example: "dung dịch bão hoà * không khí bão hoà hơi nước",
  },
  {
    word: "bão hoà",
    part_of_speech: "tính từ",
    meaning:
      "(đại lượng) ở trạng thái không thể tăng thêm được khi những yếu tố có ảnh hưởng vẫn tăng: dòng điện bão hoà trong đèn hai cực",
    example: "dòng điện bão hoà trong đèn hai cực",
  },
  {
    word: "bão hoà",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ở trạng thái không thể chứa thêm (cái đang nói) được nữa: thị trường đã bão hoà",
    example: "thị trường đã bão hoà",
  },
  {
    word: "bảo lãnh",
    part_of_speech: "động từ",
    meaning:
      "bảo đảm cho (một cá nhân hoặc tổ chức) làm một việc hoặc hưởng một quyền lợi có gắn với nghĩa vụ, chịu trách nhiệm nếu (cá nhân hoặc tổ chức ấy) sau này không thực hiện nghĩa vụ: nhờ bảo lãnh để vay tiền ngân hàng * bảo lãnh cho người thân nhập quốc tịch",
    example:
      "nhờ bảo lãnh để vay tiền ngân hàng * bảo lãnh cho người thân nhập quốc tịch",
  },
  {
    word: "bao la",
    part_of_speech: "tính từ",
    meaning:
      "rộng lớn đến mức như bao trùm lên tất cả: vũ trụ bao la * lòng mẹ bao la * biển rộng bao la",
    example: "vũ trụ bao la * lòng mẹ bao la * biển rộng bao la",
  },
  {
    word: "báo hỷ",
    part_of_speech: "động từ",
    meaning:
      "(gia đình sắp có đám cưới) báo tin mừng về việc hôn nhân: giấy báo hỉ",
    example: "giấy báo hỉ",
  },
  {
    word: "bao lăm",
    part_of_speech: "đại từ",
    meaning:
      '(phương ngữ) bao nhiêu: "Miếng trầu nỏ đáng bao lăm, Ăn rồi nhả bã tiếng tăm để đời." (ca dao)',
    example:
      'Miếng trầu nỏ đáng bao lăm, Ăn rồi nhả bã tiếng tăm để đời." (ca dao)',
  },
  {
    word: "bảo hộ",
    part_of_speech: "động từ",
    meaning: "che chở, không để bị tổn thất: bảo hộ quyền tác giả",
    example: "bảo hộ quyền tác giả",
  },
  {
    word: "bảo hộ",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) cai trị bằng cách dùng bộ máy chính quyền thực dân, đặt lên trên chính quyền bản xứ còn tồn tại về hình thức: chính phủ bảo hộ * chế độ bảo hộ",
    example: "chính phủ bảo hộ * chế độ bảo hộ",
  },
  {
    word: "bảo kê",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bảo vệ (thường cho những hoạt động không lành mạnh): bảo kê cho một sòng bạc",
    example: "bảo kê cho một sòng bạc",
  },
  {
    word: "bảo kê",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) người làm công việc bảo vệ (thường cho những hoạt động không lành mạnh): làm bảo kê ở nhà hàng * thuê bảo kê",
    example: "làm bảo kê ở nhà hàng * thuê bảo kê",
  },
  {
    word: "bảo kiếm",
    part_of_speech: "danh từ",
    meaning: "(cũ) gươm hoặc kiếm quý: thanh bảo kiếm",
    example: "thanh bảo kiếm",
  },
  {
    word: "bao lâu",
    part_of_speech: "đại từ",
    meaning:
      "bao nhiêu lâu, bao nhiêu thời gian: nó đi được bao lâu rồi? * chẳng bao lâu nữa * anh muốn ở bao lâu cũng được",
    example:
      "nó đi được bao lâu rồi? * chẳng bao lâu nữa * anh muốn ở bao lâu cũng được",
  },
  {
    word: "bảo mật",
    part_of_speech: "động từ",
    meaning:
      "giữ bí mật của nhà nước, của tổ chức: thông tin được bảo mật tuyệt đối",
    example: "thông tin được bảo mật tuyệt đối",
  },
  {
    word: "bảo lưu",
    part_of_speech: "động từ",
    meaning:
      "giữ nguyên như cũ (để có thể dùng về sau): bảo lưu kết quả thi * quyền bảo lưu ý kiến",
    example: "bảo lưu kết quả thi * quyền bảo lưu ý kiến",
  },
  {
    word: "bạo lực",
    part_of_speech: "danh từ",
    meaning:
      "sức mạnh dùng để cưỡng bức, trấn áp hoặc lật đổ: dùng bạo lực trấn áp * đấu tranh bằng bạo lực",
    example: "dùng bạo lực trấn áp * đấu tranh bằng bạo lực",
  },
  {
    word: "bạo loạn",
    part_of_speech: "động từ",
    meaning: "nổi loạn: cuộc bạo loạn đẫm máu",
    example: "cuộc bạo loạn đẫm máu",
  },
  {
    word: "bảo mạng",
    part_of_speech: "động từ",
    meaning:
      "lo giữ gìn tính mạng (trong một sự nghiệp đấu tranh vũ trang), sợ phải hi sinh: tư tưởng cầu an, bảo mạng",
    example: "tư tưởng cầu an, bảo mạng",
  },
  {
    word: "bào mòn",
    part_of_speech: "động từ",
    meaning:
      "phá huỷ dần dần từng tí một, làm cho hư hại: kim loại bị bào mòn * đất bị bào mòn",
    example: "kim loại bị bào mòn * đất bị bào mòn",
  },
  {
    word: "bạo mồm",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) dám nói những điều người khác thường e ngại, không muốn nói: con bé rất bạo mồm, gì cũng nói được",
    example: "con bé rất bạo mồm, gì cũng nói được",
  },
  {
    word: "bạo nghịch",
    part_of_speech: "tính từ",
    meaning:
      "ngang ngược phá bỏ kỉ cương, không coi ai ra gì: hành động bạo nghịch",
    example: "hành động bạo nghịch",
  },
  {
    word: "bao mua",
    part_of_speech: "động từ",
    meaning:
      "nhận tiêu thụ toàn bộ một hoặc nhiều sản phẩm làm ra của một cơ sở sản xuất hay của một địa phương: bao mua toàn bộ sản phẩm của nhà máy",
    example: "bao mua toàn bộ sản phẩm của nhà máy",
  },
  {
    word: "bảo nhỏ",
    part_of_speech: "động từ",
    meaning:
      "nói riêng, không để cho người khác biết: ghé miệng vào tai bạn bảo nhỏ * bảo nhỏ cho nhau biết",
    example: "ghé miệng vào tai bạn bảo nhỏ * bảo nhỏ cho nhau biết",
  },
  {
    word: "bạo ngược",
    part_of_speech: "tính từ",
    meaning:
      "(kẻ có quyền thế) tàn ác, ngang ngược, bất chấp công lí, đạo lí: đối xử bạo ngược * hành động bạo ngược",
    example: "đối xử bạo ngược * hành động bạo ngược",
  },
  {
    word: "báo oán",
    part_of_speech: "động từ",
    meaning:
      "(cũ) đáp lại bằng hành động tương xứng kẻ đã gây oán với mình: đền ân báo oán",
    example: "đền ân báo oán",
  },
  {
    word: "bao nhiêu",
    part_of_speech: "đại từ",
    meaning:
      'số lượng không rõ nhiều hay ít (thường dùng để hỏi): cần bao nhiêu thời gian? * bao nhiêu cũng được * "Trăng bao nhiểu tuổi trăng già, Núi bao nhiêu tuổi gọi là núi non?" (ca dao)',
    example:
      'cần bao nhiêu thời gian? * bao nhiêu cũng được * "Trăng bao nhiểu tuổi trăng già, Núi bao nhiêu tuổi gọi là núi non?" (ca dao)',
  },
  {
    word: "bao nhiêu",
    part_of_speech: "đại từ",
    meaning:
      'số lượng hoặc mức độ không biết chính xác, nhưng không phải là ít mà nghĩ là nhiều lắm: bao nhiêu là người * không đáng bao nhiêu * còn bao nhiêu việc chưa làm * "Được giận hờn nhau sung sướng bao nhiêu!" (XDiệu; 16)',
    example:
      'bao nhiêu là người * không đáng bao nhiêu * còn bao nhiêu việc chưa làm * "Được giận hờn nhau sung sướng bao nhiêu!" (XDiệu; 16)',
  },
  {
    word: "báo mộng",
    part_of_speech: "động từ",
    meaning:
      "(thần tiên, người chết) báo trước cho biết trong mộng (việc lành hay dữ sẽ xảy ra), theo tín ngưỡng dân gian: thần linh báo mộng",
    example: "thần linh báo mộng",
  },
  {
    word: "bạo phát",
    part_of_speech: "động từ",
    meaning:
      "phát ra một cách đột ngột và dữ dội trong một thời gian ngắn (thường nói về triệu chứng của bệnh): cơn bệnh bạo phát",
    example: "cơn bệnh bạo phát",
  },
  {
    word: "báo ơn",
    part_of_speech: "động từ",
    meaning:
      'đền đáp công ơn: "Tôi đi phen này báo ơn vua, đền nợ nước, rửa giận cho giang sơn (...)" (NgHTưởng; 1)',
    example:
      'Tôi đi phen này báo ơn vua, đền nợ nước, rửa giận cho giang sơn (...)" (NgHTưởng; 1)',
  },
  {
    word: "bạo phổi",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có gan nói hoặc làm những việc người khác thường e ngại: bạo phổi mới dám làm như thế",
    example: "bạo phổi mới dám làm như thế",
  },
  {
    word: "bao phủ",
    part_of_speech: "động từ",
    meaning:
      "bao bọc và phủ kín ở trên bề mặt: bóng đêm bao phủ * bầu không khí nặng nề bao phủ",
    example: "bóng đêm bao phủ * bầu không khí nặng nề bao phủ",
  },
  {
    word: "bảo quản",
    part_of_speech: "động từ",
    meaning:
      "trông coi, giữ gìn cho khỏi hư hỏng hoặc hao hụt: bảo quản máy móc * bảo quản thực phẩm * kho thóc được bảo quản tốt",
    example:
      "bảo quản máy móc * bảo quản thực phẩm * kho thóc được bảo quản tốt",
  },
  {
    word: "bao quát",
    part_of_speech: "động từ",
    meaning:
      "bao gồm toàn bộ: nội dung bao quát toàn bộ vấn đề * chưa bao quát hết những trường hợp đặc biệt",
    example:
      "nội dung bao quát toàn bộ vấn đề * chưa bao quát hết những trường hợp đặc biệt",
  },
  {
    word: "bao quát",
    part_of_speech: "động từ",
    meaning: "thấy được, nắm được toàn bộ: cái nhìn bao quát",
    example: "cái nhìn bao quát",
  },
  {
    word: "bao sân",
    part_of_speech: "động từ",
    meaning:
      "chạy khắp sân để chơi, lấn sang cả vị trí của những người khác (trong một số môn bóng): lối chơi bao sân",
    example: "lối chơi bao sân",
  },
  {
    word: "bao sân",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) làm hết, chiếm hết, kể cả những phần, những việc lẽ ra phải dành cho người khác: lối làm việc bao sân",
    example: "lối làm việc bao sân",
  },
  {
    word: "bao quản",
    part_of_speech: "động từ",
    meaning:
      '(cũ, văn chương) không quản ngại, không nề hà: bao quản nắng mưa * "Thân lươn bao quản lấm đầu, Tấm lòng trinh bạch từ sau cũng chừa." (TKiều)',
    example:
      'bao quản nắng mưa * "Thân lươn bao quản lấm đầu, Tấm lòng trinh bạch từ sau cũng chừa." (TKiều)',
  },
  {
    word: "bảo sanh",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) hộ sinh: nhà bảo sanh",
    example: "nhà bảo sanh",
  },
  {
    word: "bạo tàn",
    part_of_speech: "tính từ",
    meaning: "như tàn bạo (nhưng ít dùng hơn): nhân nghĩa thắng bạo tàn",
    example: "nhân nghĩa thắng bạo tàn",
  },
  {
    word: "bao tải",
    part_of_speech: "danh từ",
    meaning:
      "bao dệt bằng sợi đay hay dứa gai, thường dùng để đựng lương thực: vác một bao tải thóc",
    example: "vác một bao tải thóc",
  },
  {
    word: "báo tang",
    part_of_speech: "động từ",
    meaning:
      "(gia đình có tang) báo tin buồn về việc có người thân vừa chết: gửi điện báo tang",
    example: "gửi điện báo tang",
  },
  {
    word: "bão táp",
    part_of_speech: "danh từ",
    meaning:
      "bão lớn, dữ dội; thường dùng để ví cảnh gian nan đầy thử thách hoặc việc xảy ra dữ dội, mãnh liệt: phong ba bão táp * bão táp cách mạng",
    example: "phong ba bão táp * bão táp cách mạng",
  },
  {
    word: "bảo tàng",
    part_of_speech: "động từ",
    meaning:
      "thu thập, tàng trữ và bảo quản (tài liệu, hiện vật có ý nghĩa lịch sử thuộc tài sản chung), không để cho mất mát, hư hỏng: công tác bảo tồn, bảo tàng * viện bảo tàng",
    example: "công tác bảo tồn, bảo tàng * viện bảo tàng",
  },
  {
    word: "bảo tàng",
    part_of_speech: "danh từ",
    meaning:
      "nơi tàng trữ, bảo quản và trưng bày những tài liệu, hiện vật có ý nghĩa lịch sử: đến thăm bảo tàng * bảo tàng nghệ thuật",
    example: "đến thăm bảo tàng * bảo tàng nghệ thuật",
  },
  {
    word: "bao thầu",
    part_of_speech: "động từ",
    meaning:
      "nhận thầu toàn bộ một công trình xây dựng hoặc công việc nào đó: bao thầu cung cấp vật liệu xây dựng",
    example: "bao thầu cung cấp vật liệu xây dựng",
  },
  {
    word: "báo thù",
    part_of_speech: "động từ",
    meaning:
      "trả được mối thù, bắt kẻ thù phải chịu sự trừng phạt: báo thù cho cha mẹ",
    example: "báo thù cho cha mẹ",
  },
  {
    word: "bảo thủ",
    part_of_speech: "động từ",
    meaning:
      "(chủ trương) giữ nguyên cái sẵn có, không muốn thay đổi (tuy đang cần có sự thay đổi), không muốn đổi mới: bảo thủ ý kiến * đầu óc bảo thủ * tính rất bảo thủ",
    example: "bảo thủ ý kiến * đầu óc bảo thủ * tính rất bảo thủ",
  },
  {
    word: "bao tay",
    part_of_speech: "danh từ",
    meaning: "vật khâu bằng vải dùng để mang vào tay cho trẻ sơ sinh.",
    example: "đeo bao tay",
  },
  {
    word: "báo thức",
    part_of_speech: "động từ",
    meaning:
      "(tín hiệu) báo cho biết đã đến giờ phải thức dậy: kẻng báo thức * để chuông báo thức",
    example: "kẻng báo thức * để chuông báo thức",
  },
  {
    word: "bao tiêu",
    part_of_speech: "động từ",
    meaning:
      "nhận tiêu thụ toàn bộ hoặc một phần sản phẩm (của một đơn vị sản xuất) theo những điều kiện nhất định: nhận bao tiêu toàn bộ sản phẩm của xí nghiệp",
    example: "nhận bao tiêu toàn bộ sản phẩm của xí nghiệp",
  },
  {
    word: "bảo tồn",
    part_of_speech: "động từ",
    meaning:
      "gìn giữ (cái có ý nghĩa lịch sử thuộc tài sản chung), không để bị mất mát, tổn thất: bảo tồn một di tích lịch sử * bảo tồn nền văn hoá dân tộc * bảo tồn động vật quý hiếm",
    example:
      "bảo tồn một di tích lịch sử * bảo tồn nền văn hoá dân tộc * bảo tồn động vật quý hiếm",
  },
  {
    word: "bảo toàn",
    part_of_speech: "động từ",
    meaning:
      "giữ cho tồn tại nguyên vẹn, không để mất mát, tổn thất: bảo toàn lực lượng * bảo toàn danh dự * định luật bảo toàn và chuyển hoá năng lượng",
    example:
      "bảo toàn lực lượng * bảo toàn danh dự * định luật bảo toàn và chuyển hoá năng lượng",
  },
  {
    word: "bão tố",
    part_of_speech: "danh từ",
    meaning: "như bão táp: cuộc đời đầy bão tố",
    example: "cuộc đời đầy bão tố",
  },
  {
    word: "bảo trợ",
    part_of_speech: "động từ",
    meaning:
      "đỡ đầu và giúp đỡ (cho tổ chức hoặc cá nhân có khó khăn về vật chất trong hoạt động): ban bảo trợ dân quân * quỹ bảo trợ học sinh nghèo vượt khó",
    example: "ban bảo trợ dân quân * quỹ bảo trợ học sinh nghèo vượt khó",
  },
  {
    word: "bảo tồn bảo tàng",
    part_of_speech: "động từ",
    meaning: "bảo tồn và bảo tàng (nói khái quát): công tác bảo tồn bảo tàng",
    example: "công tác bảo tồn bảo tàng",
  },
  {
    word: "bảo trì",
    part_of_speech: "động từ",
    meaning:
      "bảo dưỡng, tu sửa nhằm bảo đảm (cho một hệ thống hoặc một bộ phận của nó) hoạt động tốt, có độ tin cậy cao trong việc sử dụng: sửa chữa, bảo trì lưới điện * bảo trì máy tính",
    example: "sửa chữa, bảo trì lưới điện * bảo trì máy tính",
  },
  {
    word: "bao trùm",
    part_of_speech: "động từ",
    meaning:
      "bao bọc và trùm lên khắp cả một khoảng không gian nhất định nào đó: bóng tối bao trùm vạn vật * khủng hoảng tiền tệ bao trùm lên toàn bộ khu vực",
    example:
      "bóng tối bao trùm vạn vật * khủng hoảng tiền tệ bao trùm lên toàn bộ khu vực",
  },
  {
    word: "bao tử",
    part_of_speech: "danh từ",
    meaning:
      "động vật còn là thai trong bụng mẹ, hoặc quả mới thành hình, còn rất non: lợn bao tử * dưa chuột bao tử * ngô bao tử",
    example: "lợn bao tử * dưa chuột bao tử * ngô bao tử",
  },
  {
    word: "bao tử",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) dạ dày: đau bao tử",
    example: "đau bao tử",
  },
  {
    word: "bảo trọng",
    part_of_speech: "động từ",
    meaning:
      "(cũ, trang trọng) chú ý giữ gìn cho được mạnh khoẻ, an toàn: xin hãy bảo trọng!",
    example: "xin hãy bảo trọng!",
  },
  {
    word: "báo tử",
    part_of_speech: "động từ",
    meaning:
      "(cơ quan chủ quản) báo tin chính thức là (một quân nhân) đã chết trong chiến tranh cho thân nhân biết: giấy báo tử",
    example: "giấy báo tử",
  },
  {
    word: "báo ứng",
    part_of_speech: "động từ",
    meaning:
      'gặp điều lành hay điều dữ, xứng với việc làm thiện hay ác của mình trước đây, theo quan niệm duy tâm: "Ngàn xưa mấy kẻ gian ngay, Xem cơ báo ứng biết tay trời già." (NĐM)',
    example:
      'Ngàn xưa mấy kẻ gian ngay, Xem cơ báo ứng biết tay trời già." (NĐM)',
  },
  {
    word: "bao vây",
    part_of_speech: "động từ",
    meaning:
      "vây khắp các phía không cho thoát ra ngoài, làm cho cô lập: bao vây toán cướp * bị bao vây tứ phía",
    example: "bao vây toán cướp * bị bao vây tứ phía",
  },
  {
    word: "báo vụ",
    part_of_speech: "danh từ",
    meaning: "(cũ) nhiệm vụ nhận và phát điện báo: công tác báo vụ",
    example: "công tác báo vụ",
  },
  {
    word: "bar",
    part_of_speech: "danh từ",
    meaning:
      "quầy bán rượu và đồ giải khát, khách hàng uống đứng hoặc ngồi trên những ghế cao: quán bar * quầy bar",
    example: "quán bar * quầy bar",
  },
  {
    word: "báo yên",
    part_of_speech: "động từ",
    meaning:
      "(tín hiệu hoặc hiệu lệnh) báo cho mọi người biết tình hình đã trở lại bình yên, đã hết tình trạng báo động: còi báo yên",
    example: "còi báo yên",
  },
  {
    word: "bao xa",
    part_of_speech: "tính từ",
    meaning:
      'xa bao nhiêu: từ đây đến đó bao xa?  * "Phút chốc trong tâm tưởng Bính lại hiện ra những hình ảnh không bao xa." (NgHồng; 1)',
    example:
      'từ đây đến đó bao xa?  * "Phút chốc trong tâm tưởng Bính lại hiện ra những hình ảnh không bao xa." (NgHồng; 1)',
  },
  {
    word: "bảo vệ",
    part_of_speech: "động từ",
    meaning:
      "chống lại mọi sự huỷ hoại, xâm phạm để giữ cho được nguyên vẹn: bảo vệ đê điều * phun thuốc bảo vệ thực vật * bảo vệ độc lập, chủ quyền và toàn vẹn lãnh thổ",
    example:
      "bảo vệ đê điều * phun thuốc bảo vệ thực vật * bảo vệ độc lập, chủ quyền và toàn vẹn lãnh thổ",
  },
  {
    word: "bảo vệ",
    part_of_speech: "động từ",
    meaning:
      "bênh vực bằng lí lẽ để giữ vững (ý kiến, quan điểm, v.v.): bảo vệ chân lí * bảo vệ luận án",
    example: "bảo vệ chân lí * bảo vệ luận án",
  },
  {
    word: "bảo vệ",
    part_of_speech: "danh từ",
    meaning:
      "người làm công tác bảo vệ: thuê bảo vệ * làm bảo vệ ở một trường học",
    example: "thuê bảo vệ * làm bảo vệ ở một trường học",
  },
  {
    word: "barie",
    part_of_speech: "danh từ",
    meaning: "rào chắn, rào cản: xe chở gỗ lậu vượt barie",
    example: "xe chở gỗ lậu vượt barie",
  },
  {
    word: "basalt",
    part_of_speech: "danh từ",
    meaning:
      "đá màu đen hay xám sẫm, do chất nóng chảy phun trào từ lòng đất lên trên mặt đất tạo nên: đá basalt",
    example: "đá basalt",
  },
  {
    word: "gân cổ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) vươn cổ ra phía trước làm cho các đường gân ở cổ căng lên và nổi rõ, thường dùng để tả thái độ hết sức bướng bỉnh: gân cổ lên cãi",
    example: "gân cổ lên cãi",
  },
  {
    word: "gân",
    part_of_speech: "danh từ",
    meaning: "dây chằng ở đầu cơ, nối cơ với xương: gân bò * bị bong gân",
    example: "gân bò * bị bong gân",
  },
  {
    word: "gân",
    part_of_speech: "danh từ",
    meaning:
      "tĩnh mạch nổi lên ở dưới da, có thể nhìn thấy: bàn tay nổi gân chằng chịt",
    example: "bàn tay nổi gân chằng chịt",
  },
  {
    word: "gân",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận trông nổi rõ lên ở trên một bề mặt như những đường gân: gân lá * may hai đường gân ở hai bên ống quần",
    example: "gân lá * may hai đường gân ở hai bên ống quần",
  },
  {
    word: "gân cốt",
    part_of_speech: "danh từ",
    meaning:
      "gân và xương; dùng để chỉ thể lực con người: gân cốt dẻo dai * duỗi thẳng ra cho giãn gân cốt",
    example: "gân cốt dẻo dai * duỗi thẳng ra cho giãn gân cốt",
  },
  {
    word: "gần gặn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) gần, không xa (nói khái quát): đường lên thành phố cũng chẳng gần gặn gì",
    example: "đường lên thành phố cũng chẳng gần gặn gì",
  },
  {
    word: "gần cận",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ, hiếm) gần, thường ở bên cạnh (nói khái quát): gần cận với thủ trưởng",
    example: "gần cận với thủ trưởng",
  },
  {
    word: "gần",
    part_of_speech: "tính từ",
    meaning:
      'ở vị trí chỉ cách một khoảng không gian tương đối ngắn: ngồi gần nhau * "Dầu xa nhích lại cho gần, Làm thân con nhện mấy lần vương tơ." (ca dao)',
    example:
      'ngồi gần nhau * "Dầu xa nhích lại cho gần, Làm thân con nhện mấy lần vương tơ." (ca dao)',
  },
  {
    word: "gần",
    part_of_speech: "tính từ",
    meaning:
      "ở vào lúc chỉ cần một khoảng thời gian tương đối ngắn nữa là đến thời điểm nào đó: trời đã gần sáng * gần hết giờ học",
    example: "trời đã gần sáng * gần hết giờ học",
  },
  {
    word: "gần",
    part_of_speech: "tính từ",
    meaning:
      "ở mức chỉ cần một ít nữa thôi là đạt đến số lượng, trạng thái nào đó: nặng gần 40 cân * hoa gần tàn * đi gần như chạy",
    example: "nặng gần 40 cân * hoa gần tàn * đi gần như chạy",
  },
  {
    word: "gần",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái có nhiều điểm giống nhau, phù hợp với nhau: hai từ có nghĩa gần nhau * phát âm gần với chuẩn",
    example: "hai từ có nghĩa gần nhau * phát âm gần với chuẩn",
  },
  {
    word: "gần",
    part_of_speech: "tính từ",
    meaning:
      "có quan hệ huyết thống thân thiết, chỉ cách có ít đời: hai người có họ gần với nhau",
    example: "hai người có họ gần với nhau",
  },
  {
    word: "gần",
    part_of_speech: "tính từ",
    meaning:
      "có điều kiện thường xuyên tiếp xúc, có quan hệ với nhau hàng ngày trong sinh hoạt, công tác: có dịp sống gần với bà con nông dân",
    example: "có dịp sống gần với bà con nông dân",
  },
  {
    word: "gần",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) có quan hệ tốt, thường hiểu rõ tâm tư, tình cảm và cảm thông sâu sắc: tác phong gần quần chúng * một người hiền lành, rất dễ gần",
    example: "tác phong gần quần chúng * một người hiền lành, rất dễ gần",
  },
  {
    word: "gần gũi",
    part_of_speech: "tính từ",
    meaning:
      "gần nhau, về quan hệ tinh thần, tình cảm (nói khái quát): đi làm xa, ít được gần gũi con cái * bạn bè gần gũi",
    example: "đi làm xa, ít được gần gũi con cái * bạn bè gần gũi",
  },
  {
    word: "gần gũi",
    part_of_speech: "động từ",
    meaning:
      "có quan hệ tốt, thường xuyên tiếp xúc, hiểu và cảm thông sâu sắc với người dưới mình: gần gũi với dân",
    example: "gần gũi với dân",
  },
  {
    word: "gân guốc",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) đường gân nổi lên trên mặt da (nói khái quát): bàn tay đầy gân guốc * gân guốc nổi chằng chịt",
    example: "bàn tay đầy gân guốc * gân guốc nổi chằng chịt",
  },
  {
    word: "gân guốc",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều đường gân thớ thịt nổi lên, trông thô, nhưng khoẻ mạnh, rắn chắc: cánh tay gân guốc",
    example: "cánh tay gân guốc",
  },
  {
    word: "gân guốc",
    part_of_speech: "tính từ",
    meaning:
      "(tinh thần) rắn rỏi, cứng cỏi: tính tình gân guốc * thằng cha bướng bỉnh, gân guốc",
    example: "tính tình gân guốc * thằng cha bướng bỉnh, gân guốc",
  },
  {
    word: "gần gụi",
    part_of_speech: "tính từ",
    meaning:
      "gần nhau, về quan hệ tinh thần, tình cảm (nói khái quát): đi làm xa, ít được gần gũi con cái * bạn bè gần gũi",
    example: "đi làm xa, ít được gần gũi con cái * bạn bè gần gũi",
  },
  {
    word: "gần gụi",
    part_of_speech: "động từ",
    meaning:
      "có quan hệ tốt, thường xuyên tiếp xúc, hiểu và cảm thông sâu sắc với người dưới mình: gần gũi với dân",
    example: "gần gũi với dân",
  },
  {
    word: "gấp",
    part_of_speech: "động từ",
    meaning:
      "(Nam thường xếp) làm cho một vật gọn lại thành nhiều lớp, nhiều khúc chồng lên nhau mà khi mở ra vẫn nguyên vẹn như cũ: gấp quần áo * gấp sách lại * gấp thư bỏ vào phong bì",
    example: "gấp quần áo * gấp sách lại * gấp thư bỏ vào phong bì",
  },
  {
    word: "gấp",
    part_of_speech: "động từ",
    meaning:
      "(thường ~ hai, ba, bốn, v.v. lần) có số lượng hoặc mức độ lớn hơn bao nhiêu lần như vậy khi so sánh: sản lượng năm nay cao gấp hai lần năm ngoái * tăng gấp đôi (= gấp hai lần) * tăng giá lên gấp rưỡi (= gấp nửa lần) * tăng gấp bội (= tăng gấp nhiều lần)",
    example:
      "sản lượng năm nay cao gấp hai lần năm ngoái * tăng gấp đôi (= gấp hai lần) * tăng giá lên gấp rưỡi (= gấp nửa lần) * tăng gấp bội (= tăng gấp nhiều lần)",
  },
  {
    word: "gấp",
    part_of_speech: "tính từ",
    meaning:
      "cần phải giải quyết trong một thời gian ngắn, không được để chậm trễ: chuẩn bị hành quân gấp * bức thư cần chuyển gấp",
    example: "chuẩn bị hành quân gấp * bức thư cần chuyển gấp",
  },
  {
    word: "gấp",
    part_of_speech: "tính từ",
    meaning: "có nhịp độ, tốc độ nhanh hơn bình thường: thở gấp * bị đuổi gấp",
    example: "thở gấp * bị đuổi gấp",
  },
  {
    word: "gấp bội",
    part_of_speech: "động từ",
    meaning: "gấp lên nhiều lần: quân địch kéo đến đông gấp bội",
    example: "quân địch kéo đến đông gấp bội",
  },
  {
    word: "gập ghềnh",
    part_of_speech: "tính từ",
    meaning:
      '(đường sá) lồi lõm, không bằng phẳng: đường đất gập ghềnh * "Ví dầu cầu ván đóng đinh, Cầu tre lắt lẻo gập ghềnh khó đi." (ca dao)',
    example:
      'đường đất gập ghềnh * "Ví dầu cầu ván đóng đinh, Cầu tre lắt lẻo gập ghềnh khó đi." (ca dao)',
  },
  {
    word: "gập ghềnh",
    part_of_speech: "tính từ",
    meaning:
      'khi lên cao, khi xuống thấp một cách không đều, không nhịp nhàng: bước chân gập ghềnh * "Đoạn trường thay! Lúc phân kỳ, Vó câu khấp khểnh, bánh xe gập ghềnh." (TKiều)',
    example:
      'bước chân gập ghềnh * "Đoạn trường thay! Lúc phân kỳ, Vó câu khấp khểnh, bánh xe gập ghềnh." (TKiều)',
  },
  {
    word: "gần xa",
    part_of_speech: "tính từ",
    meaning:
      "gần cũng như xa, khắp mọi nơi, mọi chốn: bạn bè gần xa * tiếng thơm lừng lẫy gần xa",
    example: "bạn bè gần xa * tiếng thơm lừng lẫy gần xa",
  },
  {
    word: "gần xa",
    part_of_speech: "tính từ",
    meaning:
      'xa xôi cách trở: "Yêu nhau chẳng quản gần xa, Một ngày chẳng đến thì ba bốn ngày." (ca dao)',
    example:
      'Yêu nhau chẳng quản gần xa, Một ngày chẳng đến thì ba bốn ngày." (ca dao)',
  },
  {
    word: "gần xa",
    part_of_speech: "tính từ",
    meaning: "gần và xa, đủ cả: chuyện gần xa * nghĩ hết gần xa",
    example: "chuyện gần xa * nghĩ hết gần xa",
  },
  {
    word: "gân sức",
    part_of_speech: "danh từ",
    meaning:
      "sức mạnh trong người dồn vào để làm việc gì nặng nhọc: lấy hết gân sức để nâng quả tạ",
    example: "lấy hết gân sức để nâng quả tạ",
  },
  {
    word: "gấp gáp",
    part_of_speech: "tính từ",
    meaning:
      "có nhịp độ, tốc độ nhanh hơn bình thường nhiều: giọng gấp gáp * tiếng bước chân bước gấp gáp",
    example: "giọng gấp gáp * tiếng bước chân bước gấp gáp",
  },
  {
    word: "gập",
    part_of_speech: "động từ",
    meaning:
      "gấp hẳn lại (thường nói về vật cứng): gãy gập xuống * bẻ gập chiếc đũa",
    example: "gãy gập xuống * bẻ gập chiếc đũa",
  },
  {
    word: "gập",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) gấp: gập quyển vở lại * gập thuyền giấy",
    example: "gập quyển vở lại * gập thuyền giấy",
  },
  {
    word: "gấp khúc",
    part_of_speech: "tính từ",
    meaning:
      "(đường) gồm nhiều đoạn thẳng liên tiếp không nằm trên cùng một đường thẳng: đường gấp khúc",
    example: "đường gấp khúc",
  },
  {
    word: "gấp rút",
    part_of_speech: "tính từ",
    meaning:
      "cần được làm hết sức khẩn trương để có thể xong trong khoảng thời gian ngắn nhất: công việc gấp rút * gấp rút chuẩn bị phòng lũ",
    example: "công việc gấp rút * gấp rút chuẩn bị phòng lũ",
  },
  {
    word: "gật",
    part_of_speech: "động từ",
    meaning:
      "cúi đầu xuống rồi ngẩng lên ngay, thường để chào hỏi hay tỏ sự đồng ý: gật đầu chào * gật đầu đồng ý",
    example: "gật đầu chào * gật đầu đồng ý",
  },
  {
    word: "gật",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đồng ý: ông ấy gật là được * hỏi rồi, nhưng nó không chịu gật",
    example: "ông ấy gật là được * hỏi rồi, nhưng nó không chịu gật",
  },
  {
    word: "gật gù",
    part_of_speech: "động từ",
    meaning:
      "gật nhẹ và nhiều lần, tỏ thái độ đồng tình, tán thưởng: đầu gật gù ra vẻ hài lòng * gật gù khen hay",
    example: "đầu gật gù ra vẻ hài lòng * gật gù khen hay",
  },
  {
    word: "gấu",
    part_of_speech: "tính từ",
    meaning:
      "(thông tục) hung dữ và hỗn láo: trông rất gấu * thằng cha gấu lắm!",
    example: "trông rất gấu * thằng cha gấu lắm!",
  },
  {
    word: "gấu",
    part_of_speech: "danh từ",
    meaning:
      "lần vải bẻ gấp lại ở phía dưới cùng ống quần hoặc thân áo: gấu áo * quần dài quá phải lên gấu * giật gấu vá vai (tng)",
    example: "gấu áo * quần dài quá phải lên gấu * giật gấu vá vai (tng)",
  },
  {
    word: "gâu",
    part_of_speech: "động từ",
    meaning:
      "từ mô phỏng tiếng chó sủa: thỉnh thoảng con chó lại gâu lên một tiếng",
    example: "thỉnh thoảng con chó lại gâu lên một tiếng",
  },
  {
    word: "gầu",
    part_of_speech: "danh từ",
    meaning: "thịt có lẫn mỡ ở ngực bò: phở gàu",
    example: "phở gàu",
  },
  {
    word: "gầu",
    part_of_speech: "danh từ",
    meaning:
      "chất bẩn màu trắng do chất mỡ từ hạch mồ hôi ở da đầu tiết ra và khô lại: đầu có nhiều gàu * dầu gội trị gàu",
    example: "đầu có nhiều gàu * dầu gội trị gàu",
  },
  {
    word: "gầu",
    part_of_speech: "danh từ",
    meaning: "vật dùng để tát nước hay để múc nước giếng: gàu tát nước",
    example: "gàu tát nước",
  },
  {
    word: "gật gưỡng",
    part_of_speech: "động từ",
    meaning:
      "(đầu) gật liên tiếp hoặc lắc lư một cách không có ý thức: ngủ gật gưỡng trên xe",
    example: "ngủ gật gưỡng trên xe",
  },
  {
    word: "gẫu",
    part_of_speech: "tính từ",
    meaning:
      "(chuyện trò) không có chủ đích, chỉ cốt vui và cho qua thì giờ: tán gẫu * nói chuyện gẫu",
    example: "tán gẫu * nói chuyện gẫu",
  },
  {
    word: "gầy",
    part_of_speech: "động từ",
    meaning:
      "gây cho thành, cho bắt đầu thật sự tồn tại: gầy vốn làm ăn * gầy giống",
    example: "gầy vốn làm ăn * gầy giống",
  },
  {
    word: "gầy",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) tạo ra cái cơ sở để từ đó làm tiếp cho thành hình: gầy gấu áo len",
    example: "gầy gấu áo len",
  },
  {
    word: "gầy",
    part_of_speech: "tính từ",
    meaning:
      "(cơ thể người và động vật) ở trạng thái có ít mỡ và thịt: người gầy * con ngựa gầy * gầy như con cá mắm",
    example: "người gầy * con ngựa gầy * gầy như con cá mắm",
  },
  {
    word: "gầy",
    part_of_speech: "tính từ",
    meaning:
      "(đất trồng, nước ao) nghèo chất màu, nghèo chất dinh dưỡng: đất gầy",
    example: "đất gầy",
  },
  {
    word: "gây chuyện",
    part_of_speech: "động từ",
    meaning:
      "cố ý làm cho sinh ra chuyện để gây lôi thôi, rắc rối cho người khác: kiếm cớ gây chuyện * gây chuyện đánh nhau",
    example: "kiếm cớ gây chuyện * gây chuyện đánh nhau",
  },
  {
    word: "gậy",
    part_of_speech: "danh từ",
    meaning:
      "đoạn tre, gỗ, v.v. tròn, cầm vừa tay, thường dùng chống khi đi hoặc để đánh: chân yếu phải chống gậy * phang cho một gậy",
    example: "chân yếu phải chống gậy * phang cho một gậy",
  },
  {
    word: "gây",
    part_of_speech: "động từ",
    meaning:
      "làm cho nảy sinh, phát sinh: trồng cây gây rừng * gây vốn làm ăn * gây thù chuốc oán",
    example: "trồng cây gây rừng * gây vốn làm ăn * gây thù chuốc oán",
  },
  {
    word: "gây",
    part_of_speech: "tính từ",
    meaning:
      "có mùi hơi khó ngửi, khó chịu, như của một vài món ăn bằng chất thịt, mỡ: sợ mùi gây của thịt bò",
    example: "sợ mùi gây của thịt bò",
  },
  {
    word: "gầy còm",
    part_of_speech: "động từ",
    meaning:
      "gây cho thành, cho bắt đầu thật sự tồn tại: gầy vốn làm ăn * gầy giống",
    example: "gầy vốn làm ăn * gầy giống",
  },
  {
    word: "gầy còm",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) tạo ra cái cơ sở để từ đó làm tiếp cho thành hình: gầy gấu áo len",
    example: "gầy gấu áo len",
  },
  {
    word: "gầy còm",
    part_of_speech: "tính từ",
    meaning:
      "(cơ thể người và động vật) ở trạng thái có ít mỡ và thịt: người gầy * con ngựa gầy * gầy như con cá mắm",
    example: "người gầy * con ngựa gầy * gầy như con cá mắm",
  },
  {
    word: "gầy còm",
    part_of_speech: "tính từ",
    meaning:
      "(đất trồng, nước ao) nghèo chất màu, nghèo chất dinh dưỡng: đất gầy",
    example: "đất gầy",
  },
  {
    word: "gây chiến",
    part_of_speech: "động từ",
    meaning: "gây ra chiến tranh: đập tan âm mưu gây chiến",
    example: "đập tan âm mưu gây chiến",
  },
  {
    word: "gầy đét",
    part_of_speech: "động từ",
    meaning:
      "gây cho thành, cho bắt đầu thật sự tồn tại: gầy vốn làm ăn * gầy giống",
    example: "gầy vốn làm ăn * gầy giống",
  },
  {
    word: "gầy đét",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) tạo ra cái cơ sở để từ đó làm tiếp cho thành hình: gầy gấu áo len",
    example: "gầy gấu áo len",
  },
  {
    word: "gầy đét",
    part_of_speech: "tính từ",
    meaning:
      "(cơ thể người và động vật) ở trạng thái có ít mỡ và thịt: người gầy * con ngựa gầy * gầy như con cá mắm",
    example: "người gầy * con ngựa gầy * gầy như con cá mắm",
  },
  {
    word: "gầy đét",
    part_of_speech: "tính từ",
    meaning:
      "(đất trồng, nước ao) nghèo chất màu, nghèo chất dinh dưỡng: đất gầy",
    example: "đất gầy",
  },
  {
    word: "gây gấy",
    part_of_speech: "tính từ",
    meaning:
      "có cảm giác hơi ớn, hơi khó chịu trong người (giống như muốn sốt): gây gấy sốt * người gây gấy váng vất",
    example: "gây gấy sốt * người gây gấy váng vất",
  },
  {
    word: "gầy gùa",
    part_of_speech: "động từ",
    meaning:
      "gây cho thành, cho bắt đầu thật sự tồn tại: gầy vốn làm ăn * gầy giống",
    example: "gầy vốn làm ăn * gầy giống",
  },
  {
    word: "gầy gùa",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) tạo ra cái cơ sở để từ đó làm tiếp cho thành hình: gầy gấu áo len",
    example: "gầy gấu áo len",
  },
  {
    word: "gầy gùa",
    part_of_speech: "tính từ",
    meaning:
      "(cơ thể người và động vật) ở trạng thái có ít mỡ và thịt: người gầy * con ngựa gầy * gầy như con cá mắm",
    example: "người gầy * con ngựa gầy * gầy như con cá mắm",
  },
  {
    word: "gầy gùa",
    part_of_speech: "tính từ",
    meaning:
      "(đất trồng, nước ao) nghèo chất màu, nghèo chất dinh dưỡng: đất gầy",
    example: "đất gầy",
  },
  {
    word: "gây dựng",
    part_of_speech: "động từ",
    meaning:
      "tạo ra cái cơ sở để từ đó phát triển lên: gây dựng cơ đồ * gây dựng phong trào",
    example: "gây dựng cơ đồ * gây dựng phong trào",
  },
  {
    word: "gây gổ",
    part_of_speech: "động từ",
    meaning:
      "gây chuyện cãi cọ, xô xát với thái độ hung hăng: gây gổ đánh nhau * tính hay gây gổ",
    example: "gây gổ đánh nhau * tính hay gây gổ",
  },
  {
    word: "gầy gò",
    part_of_speech: "động từ",
    meaning:
      "gây cho thành, cho bắt đầu thật sự tồn tại: gầy vốn làm ăn * gầy giống",
    example: "gầy vốn làm ăn * gầy giống",
  },
  {
    word: "gầy gò",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) tạo ra cái cơ sở để từ đó làm tiếp cho thành hình: gầy gấu áo len",
    example: "gầy gấu áo len",
  },
  {
    word: "gầy gò",
    part_of_speech: "tính từ",
    meaning:
      "(cơ thể người và động vật) ở trạng thái có ít mỡ và thịt: người gầy * con ngựa gầy * gầy như con cá mắm",
    example: "người gầy * con ngựa gầy * gầy như con cá mắm",
  },
  {
    word: "gầy gò",
    part_of_speech: "tính từ",
    meaning:
      "(đất trồng, nước ao) nghèo chất màu, nghèo chất dinh dưỡng: đất gầy",
    example: "đất gầy",
  },
  {
    word: "gây hấn",
    part_of_speech: "động từ",
    meaning:
      "gây xung đột đổ máu nhằm làm nổ ra chiến tranh: hành động gây hấn",
    example: "hành động gây hấn",
  },
  {
    word: "gầy guộc",
    part_of_speech: "động từ",
    meaning:
      "gây cho thành, cho bắt đầu thật sự tồn tại: gầy vốn làm ăn * gầy giống",
    example: "gầy vốn làm ăn * gầy giống",
  },
  {
    word: "gầy guộc",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) tạo ra cái cơ sở để từ đó làm tiếp cho thành hình: gầy gấu áo len",
    example: "gầy gấu áo len",
  },
  {
    word: "gầy guộc",
    part_of_speech: "tính từ",
    meaning:
      "(cơ thể người và động vật) ở trạng thái có ít mỡ và thịt: người gầy * con ngựa gầy * gầy như con cá mắm",
    example: "người gầy * con ngựa gầy * gầy như con cá mắm",
  },
  {
    word: "gầy guộc",
    part_of_speech: "tính từ",
    meaning:
      "(đất trồng, nước ao) nghèo chất màu, nghèo chất dinh dưỡng: đất gầy",
    example: "đất gầy",
  },
  {
    word: "gậy gộc",
    part_of_speech: "danh từ",
    meaning:
      "gậy dùng để đánh (nói khái quát): đánh lộn bằng gậy gộc * dùng gậy gộc làm vũ khí",
    example: "đánh lộn bằng gậy gộc * dùng gậy gộc làm vũ khí",
  },
  {
    word: "gầy mòn",
    part_of_speech: "động từ",
    meaning:
      "gây cho thành, cho bắt đầu thật sự tồn tại: gầy vốn làm ăn * gầy giống",
    example: "gầy vốn làm ăn * gầy giống",
  },
  {
    word: "gầy mòn",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) tạo ra cái cơ sở để từ đó làm tiếp cho thành hình: gầy gấu áo len",
    example: "gầy gấu áo len",
  },
  {
    word: "gầy mòn",
    part_of_speech: "tính từ",
    meaning:
      "(cơ thể người và động vật) ở trạng thái có ít mỡ và thịt: người gầy * con ngựa gầy * gầy như con cá mắm",
    example: "người gầy * con ngựa gầy * gầy như con cá mắm",
  },
  {
    word: "gầy mòn",
    part_of_speech: "tính từ",
    meaning:
      "(đất trồng, nước ao) nghèo chất màu, nghèo chất dinh dưỡng: đất gầy",
    example: "đất gầy",
  },
  {
    word: "gây rối",
    part_of_speech: "động từ",
    meaning:
      "gây mất trật tự nơi công cộng: hành vi gây rối * bắt các đối tượng gây rối * phạm tội gây rối nơi công cộng",
    example:
      "hành vi gây rối * bắt các đối tượng gây rối * phạm tội gây rối nơi công cộng",
  },
  {
    word: "gây mê",
    part_of_speech: "động từ",
    meaning:
      "làm cho cơ thể hoàn toàn mất cảm giác, thường để tiến hành phẫu thuật: tiêm thuốc gây mê * vũ khí gây mê",
    example: "tiêm thuốc gây mê * vũ khí gây mê",
  },
  {
    word: "gây lộn",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) gây chuyện cãi nhau: gây lộn om sòm cả lên",
    example: "gây lộn om sòm cả lên",
  },
  {
    word: "gây tạo",
    part_of_speech: "động từ",
    meaning:
      "gây nên, tạo nên (nói khái quát): kĩ thuật trang trí trên sân khấu gây tạo ấn tượng hiện đại",
    example: "kĩ thuật trang trí trên sân khấu gây tạo ấn tượng hiện đại",
  },
  {
    word: "gấy sốt",
    part_of_speech: "tính từ",
    meaning:
      "có cảm giác ghê ghê khó chịu khi cơ thể muốn lên cơn sốt: cứ về chiều lại gấy sốt",
    example: "cứ về chiều lại gấy sốt",
  },
  {
    word: "gây tê",
    part_of_speech: "động từ",
    meaning:
      "làm cho một phần cơ thể mất cảm giác, thường để tiến hành thủ thuật, phẫu thuật nhỏ: gây tê để nhổ răng",
    example: "gây tê để nhổ răng",
  },
  {
    word: "gầy nhom",
    part_of_speech: "động từ",
    meaning:
      "gây cho thành, cho bắt đầu thật sự tồn tại: gầy vốn làm ăn * gầy giống",
    example: "gầy vốn làm ăn * gầy giống",
  },
  {
    word: "gầy nhom",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) tạo ra cái cơ sở để từ đó làm tiếp cho thành hình: gầy gấu áo len",
    example: "gầy gấu áo len",
  },
  {
    word: "gầy nhom",
    part_of_speech: "tính từ",
    meaning:
      "(cơ thể người và động vật) ở trạng thái có ít mỡ và thịt: người gầy * con ngựa gầy * gầy như con cá mắm",
    example: "người gầy * con ngựa gầy * gầy như con cá mắm",
  },
  {
    word: "gầy nhom",
    part_of_speech: "tính từ",
    meaning:
      "(đất trồng, nước ao) nghèo chất màu, nghèo chất dinh dưỡng: đất gầy",
    example: "đất gầy",
  },
  {
    word: "gây sự",
    part_of_speech: "động từ",
    meaning:
      "gây chuyện cãi nhau hoặc đánh nhau: tính hay gây sự * bới chuyện để gây sự với nhau",
    example: "tính hay gây sự * bới chuyện để gây sự với nhau",
  },
  {
    word: "gầy yếu",
    part_of_speech: "động từ",
    meaning:
      "gây cho thành, cho bắt đầu thật sự tồn tại: gầy vốn làm ăn * gầy giống",
    example: "gầy vốn làm ăn * gầy giống",
  },
  {
    word: "gầy yếu",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) tạo ra cái cơ sở để từ đó làm tiếp cho thành hình: gầy gấu áo len",
    example: "gầy gấu áo len",
  },
  {
    word: "gầy yếu",
    part_of_speech: "tính từ",
    meaning:
      "(cơ thể người và động vật) ở trạng thái có ít mỡ và thịt: người gầy * con ngựa gầy * gầy như con cá mắm",
    example: "người gầy * con ngựa gầy * gầy như con cá mắm",
  },
  {
    word: "gầy yếu",
    part_of_speech: "tính từ",
    meaning:
      "(đất trồng, nước ao) nghèo chất màu, nghèo chất dinh dưỡng: đất gầy",
    example: "đất gầy",
  },
  {
    word: "ghé",
    part_of_speech: "động từ",
    meaning:
      "tạm dừng lại một thời gian ngắn ở nơi nào đó, nhằm mục đích nhất định, trên đường đi: ghé vào quán uống nước * tiện đường, ghé qua nhà",
    example: "ghé vào quán uống nước * tiện đường, ghé qua nhà",
  },
  {
    word: "ghé",
    part_of_speech: "động từ",
    meaning:
      "tạm nhờ vào để làm việc gì cùng với người khác, coi như phụ thêm vào: ngồi ghé vào ghế người khác * ăn ghé",
    example: "ngồi ghé vào ghế người khác * ăn ghé",
  },
  {
    word: "ghé",
    part_of_speech: "động từ",
    meaning:
      "nghiêng về một bên để đặt sát vào hoặc để hướng về: ghé tai nói thầm * Qua cầu ghé nón trông cầu, Cầu bao nhiêu nhịp dạ sầu bấy nhiêu.” (ca dao)",
    example:
      "ghé tai nói thầm * Qua cầu ghé nón trông cầu, Cầu bao nhiêu nhịp dạ sầu bấy nhiêu.” (ca dao)",
  },
  {
    word: "gen",
    part_of_speech: "danh từ",
    meaning:
      "đoạn phân tử AND mang thông tin quy định cấu trúc của một loại protit. Được dùng trong phạm trù di truyền học.: Cậu ấy thừa hưởng gen của cha.",
    example: "Cậu ấy thừa hưởng gen của cha.",
  },
  {
    word: "ghẹ",
    part_of_speech: "động từ",
    meaning:
      "bám vào, nhờ vào để được việc hoặc để có lợi: đi ghẹ xe * ăn ghẹ nhà hàng xóm",
    example: "đi ghẹ xe * ăn ghẹ nhà hàng xóm",
  },
  {
    word: "ghẽ",
    part_of_speech: "động từ",
    meaning:
      "(cũ) chia, rẽ: ghẽ ngang * “Bạc đầu không nỡ đôi đường ghẽ nhau (...)” (CPN)",
    example: "ghẽ ngang * “Bạc đầu không nỡ đôi đường ghẽ nhau (...)” (CPN)",
  },
  {
    word: "ghẻ",
    part_of_speech: "danh từ",
    meaning:
      "bệnh lây ngoài da do một động vật kí sinh rất nhỏ gây ra, làm nổi mụn nhỏ rất ngứa: người bị ghẻ * ngứa ghẻ hờn ghen (tng)",
    example: "người bị ghẻ * ngứa ghẻ hờn ghen (tng)",
  },
  {
    word: "ghẻ",
    part_of_speech: "danh từ",
    meaning: "gút bẩn trong sợi: ghẻ tơ * vải có ghẻ",
    example: "ghẻ tơ * vải có ghẻ",
  },
  {
    word: "ghẻ",
    part_of_speech: "tính từ",
    meaning:
      "có mối quan hệ không phải là ruột thịt nhưng được coi như là mẹ con, cha con, giữa một người và con riêng của chồng mình với người vợ trước, hay là con riêng của vợ mình với người chồng trước: cha ghẻ * mẹ ghẻ",
    example: "cha ghẻ * mẹ ghẻ",
  },
  {
    word: "ghè",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) chum nhỏ: ghè rượu",
    example: "ghè rượu",
  },
  {
    word: "ghè",
    part_of_speech: "động từ",
    meaning:
      "đập vào mép hoặc cạnh vật rắn cho vỡ hoặc mẻ dần: ghè mảnh sành * ghè hòn đá cho tròn",
    example: "ghè mảnh sành * ghè hòn đá cho tròn",
  },
  {
    word: "ghè",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) đập, đánh: ghè cho một trận nên thân",
    example: "ghè cho một trận nên thân",
  },
  {
    word: "ghè",
    part_of_speech: "động từ",
    meaning: "cạy ra: ghè miệng đổ thuốc vào",
    example: "ghè miệng đổ thuốc vào",
  },
  {
    word: "ghé gẩm",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) ghé vào, tạm nhờ vào để làm việc gì (nói khái quát): ăn ghé gẩm nhà hàng xóm",
    example: "ăn ghé gẩm nhà hàng xóm",
  },
  {
    word: "ghẻ lạnh",
    part_of_speech: "động từ",
    meaning:
      "tỏ ra lạnh nhạt đối với người lẽ ra là thân thiết, gần gũi: tỏ thái độ ghẻ lạnh * ghẻ lạnh với con chồng",
    example: "tỏ thái độ ghẻ lạnh * ghẻ lạnh với con chồng",
  },
  {
    word: "ghẻ lở",
    part_of_speech: "danh từ",
    meaning:
      "bệnh ghẻ và bệnh lở làm nổi mụn có mủ (nói khái quát): ghẻ lở mọc đầy thân",
    example: "ghẻ lở mọc đầy thân",
  },
  {
    word: "ghe cộ",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) thuyền bè: ghe cộ tấp nập trên sông",
    example: "ghe cộ tấp nập trên sông",
  },
  {
    word: "ghé lưng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đặt lưng xuống nằm tạm một lúc: ghé lưng một chút cho đỡ mỏi",
    example: "ghé lưng một chút cho đỡ mỏi",
  },
  {
    word: "ghé mắt",
    part_of_speech: "động từ",
    meaning: "nghiêng đầu và đưa mắt nhìn: ghé mắt nhìn qua kẽ hở",
    example: "ghé mắt nhìn qua kẽ hở",
  },
  {
    word: "ghé mắt",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) trông chừng, thỉnh thoảng chú ý đến: nhờ hàng xóm ghé mắt trông nhà giúp",
    example: "nhờ hàng xóm ghé mắt trông nhà giúp",
  },
  {
    word: "ghé vai",
    part_of_speech: "động từ",
    meaning:
      'phụ vào, cùng gánh vác, chia sẻ một phần công việc chung: mọi người ghé vai cùng làm * "Ghé vai gánh đỡ sơn hà, Sao cho tỏ mặt mới là trượng phu." (ca dao)',
    example:
      'mọi người ghé vai cùng làm * "Ghé vai gánh đỡ sơn hà, Sao cho tỏ mặt mới là trượng phu." (ca dao)',
  },
  {
    word: "ghém",
    part_of_speech: "danh từ",
    meaning:
      'rau, quả ăn sống, dùng trong bữa ăn: rau ghém * cà ghém * "Bao giờ rau diếp làm đình, Gỗ lim ăn ghém thì mình lấy ta." (ca dao)',
    example:
      'rau ghém * cà ghém * "Bao giờ rau diếp làm đình, Gỗ lim ăn ghém thì mình lấy ta." (ca dao)',
  },
  {
    word: "ghen",
    part_of_speech: "động từ",
    meaning:
      'khó chịu, bực dọc với người được hưởng cái gì đó (thường là về tinh thần, tình cảm) hơn mình, có được cái mình muốn mà không có: ghen ăn với em * "Nghĩ đời mà ngán cho đời, Tài tình chi lắm cho trời đất ghen!" (TKiều)',
    example:
      'ghen ăn với em * "Nghĩ đời mà ngán cho đời, Tài tình chi lắm cho trời đất ghen!" (TKiều)',
  },
  {
    word: "ghen",
    part_of_speech: "động từ",
    meaning:
      'khó chịu, tức tối, vì biết hoặc ngờ sự thiếu chung thuỷ của vợ, chồng hay người yêu: Ớt nào là ớt chẳng cay, Gái nào là gái chẳng hay ghen chồng?" (Cdao)',
    example:
      'Ớt nào là ớt chẳng cay, Gái nào là gái chẳng hay ghen chồng?" (Cdao)',
  },
  {
    word: "ghèn",
    part_of_speech: "danh từ",
    meaning:
      "(Nam ghèn) chất nhờn do tuyến mi mắt tiết ra, đọng lại ở khoé mắt: mắt sưng đỏ, đầy dử",
    example: "mắt sưng đỏ, đầy dử",
  },
  {
    word: "ghen tị",
    part_of_speech: "động từ",
    meaning:
      "so bì và khó chịu, bực bội khi thấy người khác được hơn mình: tính hay ghen tị * ghen tị với hạnh phúc của bạn",
    example: "tính hay ghen tị * ghen tị với hạnh phúc của bạn",
  },
  {
    word: "ghen ghét",
    part_of_speech: "động từ",
    meaning:
      "do ghen tị mà sinh ra ghét: thấy người ta hơn là sinh lòng ghen ghét * ngấm ngầm ghen ghét lẫn nhau",
    example:
      "thấy người ta hơn là sinh lòng ghen ghét * ngấm ngầm ghen ghét lẫn nhau",
  },
  {
    word: "ghen tuông",
    part_of_speech: "động từ",
    meaning:
      'ghen trong tình yêu nam nữ (nói khái quát): tính hay ghen tuông * "Rằng: Tôi chút dạ đàn bà, Ghen tuông thì cũng người ta thường tình." (TKiều)',
    example:
      'tính hay ghen tuông * "Rằng: Tôi chút dạ đàn bà, Ghen tuông thì cũng người ta thường tình." (TKiều)',
  },
  {
    word: "ghẹo",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) trêu: ghẹo trẻ con * hát ghẹo",
    example: "ghẹo trẻ con * hát ghẹo",
  },
  {
    word: "ghẹo",
    part_of_speech: "động từ",
    meaning:
      'dùng lời nói, cử chỉ chớt nhả để đùa cợt với phụ nữ: ghẹo gái * "Anh đồ tỉnh, anh đồ say, Sao anh ghẹo nguyệt giữa ban ngày?" (HXHương; 36)',
    example:
      'ghẹo gái * "Anh đồ tỉnh, anh đồ say, Sao anh ghẹo nguyệt giữa ban ngày?" (HXHương; 36)',
  },
  {
    word: "ghép",
    part_of_speech: "động từ",
    meaning:
      "đặt liền nhau cho hợp thành một chỉnh thể: ghép vần * chơi trò ghép hình * ghép hai tấm ván làm giường",
    example: "ghép vần * chơi trò ghép hình * ghép hai tấm ván làm giường",
  },
  {
    word: "ghép",
    part_of_speech: "động từ",
    meaning:
      "gắn vào và làm cho một mắt hay một cành cây tươi sống trên một cây khác: ghép cam trên bưởi",
    example: "ghép cam trên bưởi",
  },
  {
    word: "ghép",
    part_of_speech: "động từ",
    meaning:
      "gắn một bộ phận của cơ thể người hoặc động vật lên một chỗ khác của cơ thể đó hoặc lên một cơ thể khác: ghép da * thực hiện một ca ghép thận",
    example: "ghép da * thực hiện một ca ghép thận",
  },
  {
    word: "ghép",
    part_of_speech: "động từ",
    meaning: "khép vào, buộc phải nhận, phải chịu: bị ghép vào tội đánh bạc",
    example: "bị ghép vào tội đánh bạc",
  },
  {
    word: "ghép",
    part_of_speech: "tính từ",
    meaning:
      "do hai hay nhiều thành tố ghép lại với nhau mà thành: từ ghép * câu ghép",
    example: "từ ghép * câu ghép",
  },
  {
    word: "ghen tức",
    part_of_speech: "động từ",
    meaning: "ghen và lấy làm tức tối: ngấm ngầm ghen tức",
    example: "ngấm ngầm ghen tức",
  },
  {
    word: "ghê",
    part_of_speech: "động từ",
    meaning:
      "có cảm giác khó chịu như muốn rùng mình, khi thần kinh bị một kích thích bất thường: ăn chua bị ghê răng * nhìn thấy máu ghê hết cả người",
    example: "ăn chua bị ghê răng * nhìn thấy máu ghê hết cả người",
  },
  {
    word: "ghê",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) có những điểm nào đó ở mức độ khác thường, thường làm cho người ta phải nể sợ: bé người nhưng mà ghê lắm * các cậu này ghê thật, cái gì cũng biết!",
    example:
      "bé người nhưng mà ghê lắm * các cậu này ghê thật, cái gì cũng biết!",
  },
  {
    word: "ghê",
    part_of_speech: "tính từ",
    meaning:
      '(Khẩu ngữ) có những biểu hiện mức độ cao khác thường, tác động mạnh đến cảm giác, đến nhận thức: suy nghĩ rất ghê * "Sầu đong càng lắc càng đầy, Ba thu dồn lại một ngày dài ghê!" (TKiều)',
    example:
      'suy nghĩ rất ghê * "Sầu đong càng lắc càng đầy, Ba thu dồn lại một ngày dài ghê!" (TKiều)',
  },
  {
    word: "ghét cay ghét đắng",
    part_of_speech: "động từ",
    meaning:
      'ghét hết mức: "Quán rằng: Ghét việc tầm phào, Ghét cay ghét đắng ghét vào tới tâm." (LVT)',
    example:
      'Quán rằng: Ghét việc tầm phào, Ghét cay ghét đắng ghét vào tới tâm." (LVT)',
  },
  {
    word: "ghét bỏ",
    part_of_speech: "động từ",
    meaning:
      'ghét tới mức không thèm để ý đến, không ngó ngàng gì đến: bị người thân ghét bỏ * "Ông tơ ghét bỏ chi nhau, Chưa vui sum họp đã sầu chia phôi!" (TKiều)',
    example:
      'bị người thân ghét bỏ * "Ông tơ ghét bỏ chi nhau, Chưa vui sum họp đã sầu chia phôi!" (TKiều)',
  },
  {
    word: "ghép nối",
    part_of_speech: "động từ",
    meaning:
      "ghép và nối các bộ phận khác nhau thành một chỉnh thể để có thể sử dụng được: ghép nối mạch điện",
    example: "ghép nối mạch điện",
  },
  {
    word: "ghế bố",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) giường xếp, khung bằng gỗ hay kim loại nhẹ, mặt bằng vải bố dày và chắc: ngả lưng trên ghế bố",
    example: "ngả lưng trên ghế bố",
  },
  {
    word: "ghế bành",
    part_of_speech: "danh từ",
    meaning:
      "ghế to có lưng tựa và hai tay vịn, giống như bành voi: ngồi lọt thỏm trong cái ghế bành",
    example: "ngồi lọt thỏm trong cái ghế bành",
  },
  {
    word: "ghét",
    part_of_speech: "danh từ",
    meaning: "chất bẩn bám trên da người: người đầy ghét",
    example: "người đầy ghét",
  },
  {
    word: "ghét",
    part_of_speech: "động từ",
    meaning:
      "không ưa thích, muốn tránh hoặc cảm thấy khó chịu khi phải tiếp xúc với một đối tượng nào đó: ghét kẻ giả dối * cái mặt trông đến ghét!",
    example: "ghét kẻ giả dối * cái mặt trông đến ghét!",
  },
  {
    word: "ghế",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng để ngồi: ghế nhựa * ghế đá ở công viên * rời khỏi ghế nhà trường",
    example: "ghế nhựa * ghế đá ở công viên * rời khỏi ghế nhà trường",
  },
  {
    word: "ghế",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ một địa vị, một chức vụ cụ thể nào đó: được cất nhắc vào ghế chủ tịch",
    example: "được cất nhắc vào ghế chủ tịch",
  },
  {
    word: "ghế",
    part_of_speech: "động từ",
    meaning:
      "đảo gạo đang nấu bằng đũa cả, để cho cơm chín đều: lấy đũa ghế cơm",
    example: "lấy đũa ghế cơm",
  },
  {
    word: "ghế",
    part_of_speech: "động từ",
    meaning:
      "cho cơm nguội vào nồi cơm nóng sắp chín và đảo đều, nấu chung với nhau: cơm thừa cất lại để chiều ghế",
    example: "cơm thừa cất lại để chiều ghế",
  },
  {
    word: "ghế",
    part_of_speech: "động từ",
    meaning: "như độn: cơm ghế khoai",
    example: "cơm ghế khoai",
  },
  {
    word: "ghế cứng",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) ghế ngồi trên tàu hoả, bằng gỗ cứng, lắp cố định, không bọc đệm; phân biệt với ghế mềm: toa ghế cứng",
    example: "toa ghế cứng",
  },
  {
    word: "ghế ngồi",
    part_of_speech: "danh từ",
    meaning:
      "ghế cứng hoặc ghế mềm, nói chung; phân biệt với giường nằm: toa ghế ngồi",
    example: "toa ghế ngồi",
  },
  {
    word: "ghê gớm",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ở một mức độ hoặc có những biểu hiện khác thường, đáng cho người ta phải sợ, phải nể: tội ác ghê gớm * một con người ghê gớm * tay địch thủ ghê gớm",
    example: "tội ác ghê gớm * một con người ghê gớm * tay địch thủ ghê gớm",
  },
  {
    word: "ghê gớm",
    part_of_speech: "tính từ",
    meaning:
      "ghê lắm, đến mức rất khác thường: rét ghê gớm * sức cám dỗ ghê gớm của đồng tiền",
    example: "rét ghê gớm * sức cám dỗ ghê gớm của đồng tiền",
  },
  {
    word: "ghê rợn",
    part_of_speech: "",
    meaning:
      "sợ hoặc có tác động làm cho sợ đến rợn người: tiếng cười nghe thật ghê rợn * trận đòn ghê rợn",
    example: "tiếng cười nghe thật ghê rợn * trận đòn ghê rợn",
  },
  {
    word: "ghê tởm",
    part_of_speech: "",
    meaning:
      "có cảm giác hoặc làm cho có cảm giác ghê sợ đến mức không thể chịu được, muốn tránh xa (nói khái quát): ghê tởm con người giả nhân giả nghĩa * một tội ác đáng ghê tởm",
    example: "ghê tởm con người giả nhân giả nghĩa * một tội ác đáng ghê tởm",
  },
  {
    word: "ghế mềm",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) ghế ngồi trên tàu hoả, có bọc đệm, có thể điều chỉnh hơi ngả ra phía sau; phân biệt với ghế cứng: mua hai vé ghế mềm",
    example: "mua hai vé ghế mềm",
  },
  {
    word: "ghê sợ",
    part_of_speech: "",
    meaning:
      "có cảm giác ghê và sợ (nói khái quát): rùng mình ghê sợ * tiếng rú nghe ghê sợ",
    example: "rùng mình ghê sợ * tiếng rú nghe ghê sợ",
  },
  {
    word: "ghếch",
    part_of_speech: "động từ",
    meaning:
      "đặt chếch cho một đầu tựa vào điểm cao: ghếch càng xe lên lề đường * nằm ghếch chân lên cột nhà",
    example: "ghếch càng xe lên lề đường * nằm ghếch chân lên cột nhà",
  },
  {
    word: "ghếch",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đưa hơi chếch lên cao: nòng pháo ghếch cao * ghếch mắt nhìn",
    example: "nòng pháo ghếch cao * ghếch mắt nhìn",
  },
  {
    word: "ghểnh",
    part_of_speech: "động từ",
    meaning:
      "đi quân sĩ hay quân tượng trong cờ tướng từ hàng dưới cùng tiến lên một bước theo đường chéo, để vào chính giữa, che mặt tướng: ghểnh tượng * ghểnh sĩ",
    example: "ghểnh tượng * ghểnh sĩ",
  },
  {
    word: "ghềnh",
    part_of_speech: "danh từ",
    meaning:
      "chỗ dòng sông có đá lởm chởm nằm chắn ngang làm nước dồn lại, chảy xiết: lên thác xuống ghềnh",
    example: "lên thác xuống ghềnh",
  },
  {
    word: "ghệt",
    part_of_speech: "danh từ",
    meaning: "mảnh da hoặc vải bọc ống chân: chân đi ghệt da",
    example: "chân đi ghệt da",
  },
  {
    word: "ghi âm",
    part_of_speech: "động từ",
    meaning:
      "ghi lại âm thanh trên đĩa, trên băng, để phát lại: ghi âm lời khai của nhân chứng",
    example: "ghi âm lời khai của nhân chứng",
  },
  {
    word: "ghệch",
    part_of_speech: "động từ",
    meaning: "(hiếm) như ghếch (ng1): ghệch chân lên mặt bàn",
    example: "ghệch chân lên mặt bàn",
  },
  {
    word: "ghi",
    part_of_speech: "danh từ",
    meaning:
      "thiết bị dùng để chuyển đường chạy của tàu hoả hoặc tàu điện: bẻ ghi",
    example: "bẻ ghi",
  },
  {
    word: "ghi",
    part_of_speech: "động từ",
    meaning:
      "dùng chữ viết hoặc dấu hiệu để lưu giữ một nội dung nào đó, khi nhìn lại có thể biết hoặc nhớ lại nội dung ấy: ghi số điện thoại * ghi tên vào danh sách * tổ quốc ghi công",
    example: "ghi số điện thoại * ghi tên vào danh sách * tổ quốc ghi công",
  },
  {
    word: "ghi",
    part_of_speech: "động từ",
    meaning: "lưu thông tin lên bộ nhớ của máy tính: ghi dữ liệu vào ổ cứng",
    example: "ghi dữ liệu vào ổ cứng",
  },
  {
    word: "ghi",
    part_of_speech: "tính từ",
    meaning: "có màu giữa màu đen và màu trắng: áo màu ghi",
    example: "áo màu ghi",
  },
  {
    word: "ghì",
    part_of_speech: "động từ",
    meaning:
      "dùng sức giữ thật chặt, làm cho không thể di động được: ghì cương ngựa * ghì con vào lòng",
    example: "ghì cương ngựa * ghì con vào lòng",
  },
  {
    word: "ghi bàn",
    part_of_speech: "động từ",
    meaning:
      "tạo ra bàn thắng (trong một số môn bóng): bỏ lỡ một cơ hội ghi bàn",
    example: "bỏ lỡ một cơ hội ghi bàn",
  },
  {
    word: "ghi chú",
    part_of_speech: "",
    meaning:
      "ghi để nói rõ thêm (nói khái quát): các sự kiện được ghi chú ngày tháng rõ ràng",
    example: "các sự kiện được ghi chú ngày tháng rõ ràng",
  },
  {
    word: "ghi chép",
    part_of_speech: "",
    meaning: "viết để ghi lại (nói khái quát): sổ ghi chép * ghi chép cẩn thận",
    example: "sổ ghi chép * ghi chép cẩn thận",
  },
  {
    word: "ghi danh",
    part_of_speech: "động từ",
    meaning: "ghi tên vào danh sách tham dự: ghi danh vào kì thi tuyển chọn",
    example: "ghi danh vào kì thi tuyển chọn",
  },
  {
    word: "ghi danh",
    part_of_speech: "động từ",
    meaning:
      "ghi nhận tên tuổi và công lao, thành tích: bia ghi danh liệt sĩ * được ghi danh trong bảng vàng thành tích của nhà trường",
    example:
      "bia ghi danh liệt sĩ * được ghi danh trong bảng vàng thành tích của nhà trường",
  },
  {
    word: "ghi điểm",
    part_of_speech: "động từ",
    meaning:
      "tạo ra điểm trong thi đấu thể thao hoặc trong một số trò chơi điện tử: đội A ghi điểm liên tiếp",
    example: "đội A ghi điểm liên tiếp",
  },
  {
    word: "ghi lòng tạc dạ",
    part_of_speech: "",
    meaning: "(văn chương) như ghi tạc: công ơn này xin ghi lòng tạc dạ",
    example: "công ơn này xin ghi lòng tạc dạ",
  },
  {
    word: "ghi hình",
    part_of_speech: "động từ",
    meaning:
      "ghi lại hình ảnh trên đĩa, trên băng, để phát lại: ghi hình buổi diễn tập * đĩa ghi hình",
    example: "ghi hình buổi diễn tập * đĩa ghi hình",
  },
  {
    word: "ghi nhớ",
    part_of_speech: "động từ",
    meaning:
      "nhớ mãi trong lòng, trong tâm trí: đánh dấu những chỗ cần ghi nhớ * ghi nhớ công lao của các anh hùng, liệt sĩ",
    example:
      "đánh dấu những chỗ cần ghi nhớ * ghi nhớ công lao của các anh hùng, liệt sĩ",
  },
  {
    word: "ghi tạc",
    part_of_speech: "động từ",
    meaning:
      '(văn chương) khắc sâu vào tâm trí, không bao giờ quên (thường nói về ơn nghĩa): "Trăm năm ghi tạc chữ đồng, Dù ai thêu phượng vẽ rồng mặc ai." (ca dao)',
    example:
      'Trăm năm ghi tạc chữ đồng, Dù ai thêu phượng vẽ rồng mặc ai." (ca dao)',
  },
  {
    word: "ghi xương khắc cốt",
    part_of_speech: "",
    meaning:
      "(văn chương) ghi nhớ sâu sắc, không bao giờ quên: thề ghi xương khắc cốt mối thù này",
    example: "thề ghi xương khắc cốt mối thù này",
  },
  {
    word: "ghi nhận",
    part_of_speech: "động từ",
    meaning:
      "công nhận và ghi nhớ: ghi nhận thành tích * một cố gắng đáng ghi nhận",
    example: "ghi nhận thành tích * một cố gắng đáng ghi nhận",
  },
  {
    word: "ghim",
    part_of_speech: "danh từ",
    meaning: "vật nhỏ bằng kim loại dùng để cài giấy tờ: hộp ghim",
    example: "hộp ghim",
  },
  {
    word: "ghim",
    part_of_speech: "động từ",
    meaning: "cài bằng cái ghim: ghim chứng từ",
    example: "ghim chứng từ",
  },
  {
    word: "ghim",
    part_of_speech: "động từ",
    meaning:
      "như găm (ng2): bị mảnh đạn ghim vào ngực * ghim mảnh giấy lên vách",
    example: "bị mảnh đạn ghim vào ngực * ghim mảnh giấy lên vách",
  },
  {
    word: "ghìm",
    part_of_speech: "động từ",
    meaning:
      "dùng sức kéo lại, giữ chặt lại vật đang trên đà vận động: ghìm ngựa * ghìm bò cho xe chậm lại",
    example: "ghìm ngựa * ghìm bò cho xe chậm lại",
  },
  {
    word: "ghìm",
    part_of_speech: "động từ",
    meaning:
      "dùng lí trí giữ không cho tình cảm bộc lộ: ghìm mình để khỏi nổi giận * cố ghìm tiếng khóc",
    example: "ghìm mình để khỏi nổi giận * cố ghìm tiếng khóc",
  },
  {
    word: "ghịt",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) ghì chặt: trói ghịt vào thân cây",
    example: "trói ghịt vào thân cây",
  },
  {
    word: "ghiền",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) nghiện: ghiền thuốc phiện",
    example: "ghiền thuốc phiện",
  },
  {
    word: "gì",
    part_of_speech: "đại từ",
    meaning:
      "từ dùng để chỉ sự vật, sự việc, hiện tượng nào đó không rõ (thường dùng để hỏi): cái gì đây? * bạn tên là gì? * đã làm được những việc gì? * gì thế?",
    example:
      "cái gì đây? * bạn tên là gì? * đã làm được những việc gì? * gì thế?",
  },
  {
    word: "gì",
    part_of_speech: "đại từ",
    meaning:
      "từ dùng để chỉ sự vật, sự việc, hiện tượng nào đó bất kì: cái gì cũng biết * ăn gì chả được * thích làm gì thì làm",
    example: "cái gì cũng biết * ăn gì chả được * thích làm gì thì làm",
  },
  {
    word: "gì",
    part_of_speech: "đại từ",
    meaning:
      '(Khẩu ngữ) từ dùng để chỉ một hạng, một loại hay một tính chất nào đó, với ý chê bai nhằm phủ định: người gì mà kì lạ! * ăn nói kiểu gì đấy? * "Chồng gì anh, vợ gì tôi, Chẳng qua là cái nợ đời chi đây!" (Cdao)',
    example:
      'người gì mà kì lạ! * ăn nói kiểu gì đấy? * "Chồng gì anh, vợ gì tôi, Chẳng qua là cái nợ đời chi đây!" (Cdao)',
  },
  {
    word: "gì",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị ý phủ định dưới vẻ nghi vấn, người nói làm như muốn hỏi mà không cần câu trả lời, vì đã sẵn có ý bác bỏ ý khẳng định: có gì mà sợ * chuyện đó thì lo gì! * từ đây đến đó có xa gì!",
    example: "có gì mà sợ * chuyện đó thì lo gì! * từ đây đến đó có xa gì!",
  },
  {
    word: "gì",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị nhấn mạnh ý phủ định hoàn toàn: chẳng hiểu gì cả! * không ai ghét bỏ gì anh ta * cô ta chẳng lấy gì làm đẹp!",
    example:
      "chẳng hiểu gì cả! * không ai ghét bỏ gì anh ta * cô ta chẳng lấy gì làm đẹp!",
  },
  {
    word: "gỉ",
    part_of_speech: "danh từ",
    meaning: "chất do kim loại tác dụng với không khí ẩm tạo thành: gỉ sắt",
    example: "gỉ sắt",
  },
  {
    word: "gỉ",
    part_of_speech: "động từ",
    meaning: "bị biến thành gỉ: thép không gỉ * con dao gỉ",
    example: "thép không gỉ * con dao gỉ",
  },
  {
    word: "gì thì gì",
    part_of_speech: "",
    meaning: "(khẩu ngữ) bất cứ như thế nào: gì thì gì cũng phải ăn cái đã!",
    example: "gì thì gì cũng phải ăn cái đã!",
  },
  {
    word: "gí",
    part_of_speech: "động từ",
    meaning: "làm cho chạm sát vào ở một điểm nào đó: gí súng vào đầu",
    example: "gí súng vào đầu",
  },
  {
    word: "gí",
    part_of_speech: "động từ",
    meaning:
      "ép thật sát xuống: nằm gí xuống đất không dám ngóc đầu lên * cái mũ bẹp gí",
    example: "nằm gí xuống đất không dám ngóc đầu lên * cái mũ bẹp gí",
  },
  {
    word: "giạ",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị dân gian để đong hạt rời, thường dùng ở miền Nam Việt Nam, bằng khoảng 35 - 40 lít: vay vài chục giạ lúa",
    example: "vay vài chục giạ lúa",
  },
  {
    word: "già",
    part_of_speech: "tính từ",
    meaning:
      "ở vào tuổi có những hiện tượng sinh lí suy yếu dần, trong giai đoạn cuối của quá trình sống tự nhiên: bệnh người già * về già * con bò già * mèo già hoá cáo (tng)",
    example: "bệnh người già * về già * con bò già * mèo già hoá cáo (tng)",
  },
  {
    word: "già",
    part_of_speech: "tính từ",
    meaning:
      "(người) có vẻ ngoài của người nhiều tuổi hơn nhiều so với độ tuổi: già trước tuổi * chỉ một đêm lo nghĩ, mặt già đi trông thấy",
    example: "già trước tuổi * chỉ một đêm lo nghĩ, mặt già đi trông thấy",
  },
  {
    word: "già",
    part_of_speech: "tính từ",
    meaning:
      "(sản phẩm trồng trọt) ở giai đoạn đã phát triển đầy đủ, sau đó chỉ có chín hoặc tàn lụi đi: rau muống già * qua cau già",
    example: "rau muống già * qua cau già",
  },
  {
    word: "già",
    part_of_speech: "tính từ",
    meaning:
      "có số lượng, mức độ vượt quá mức xác định nào đó một chút: nước còn già nửa bể * đi già nửa ngày thì đến",
    example: "nước còn già nửa bể * đi già nửa ngày thì đến",
  },
  {
    word: "già",
    part_of_speech: "tính từ",
    meaning:
      "(cái cân) không chính xác, báo số ghi khối lượng của vật được cân nhiều hơn khối lượng thật một chút: cân già",
    example: "cân già",
  },
  {
    word: "già",
    part_of_speech: "tính từ",
    meaning:
      "có quá trình tác dụng nào đó để đến quá mức bình thường một chút: thóc phơi chưa được già nắng * nước sôi già",
    example: "thóc phơi chưa được già nắng * nước sôi già",
  },
  {
    word: "già",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra hiểu biết hơn, có trình độ cao hơn mức bình thường về mặt nào đó, do đã từng trải hay do có công phu rèn luyện: một thợ máy già kinh nghiệm * nét vẽ già tay",
    example: "một thợ máy già kinh nghiệm * nét vẽ già tay",
  },
  {
    word: "già",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) (làm việc gì nhằm vào ai) tiếp tục lấn tới, tỏ ra không chút kiêng nể: được thể, càng trêu già * làm già",
    example: "được thể, càng trêu già * làm già",
  },
  {
    word: "già",
    part_of_speech: "danh từ",
    meaning:
      "người cao tuổi (có thể dùng để xưng gọi thân mật giữa người già với người còn rất trẻ): kính già yêu trẻ",
    example: "kính già yêu trẻ",
  },
  {
    word: "già",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ, Ít dùng) chị của mẹ: chị em con dì con già",
    example: "chị em con dì con già",
  },
  {
    word: "giả",
    part_of_speech: "tính từ",
    meaning:
      "không phải thật mà là được làm ra với bề ngoài giống như thật, thường để đánh lừa: tiền giả * buôn bán hàng giả * trồng răng giả * đạo đức giả",
    example: "tiền giả * buôn bán hàng giả * trồng răng giả * đạo đức giả",
  },
  {
    word: "giả",
    part_of_speech: "động từ",
    meaning:
      "làm như thật để người ta tưởng là thật: giả nghèo giả khổ * giả nhân giả nghĩa * giả điên",
    example: "giả nghèo giả khổ * giả nhân giả nghĩa * giả điên",
  },
  {
    word: "gia",
    part_of_speech: "động từ",
    meaning:
      "cho thêm vào, tăng thêm: gia thêm mấy vị vào thang thuốc * gia mắm muối cho vừa",
    example: "gia thêm mấy vị vào thang thuốc * gia mắm muối cho vừa",
  },
  {
    word: "giã",
    part_of_speech: "danh từ",
    meaning:
      "lưới hình túi do tàu thuyền kéo để đánh bắt cá biển và hải sản nói chung: kéo giã * đánh giã (đánh cá bằng giã)",
    example: "kéo giã * đánh giã (đánh cá bằng giã)",
  },
  {
    word: "giã",
    part_of_speech: "danh từ",
    meaning: "thuyền dùng để kéo giã đánh cá: thuyền giã",
    example: "thuyền giã",
  },
  {
    word: "giã",
    part_of_speech: "động từ",
    meaning: "đánh cá và các hải sản khác bằng giã: sống bằng nghề giã",
    example: "sống bằng nghề giã",
  },
  {
    word: "giã",
    part_of_speech: "động từ",
    meaning:
      "làm cho giập, nát hoặc tróc lớp ngoài bằng cách cho vào cối và dùng chày nện xuống liên tiếp: giã bột * giã cua nấu canh * cối giã gạo",
    example: "giã bột * giã cua nấu canh * cối giã gạo",
  },
  {
    word: "giã",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) đánh mạnh và liên tục: pháo giã liên hồi * bị giã cho một trận nên thân",
    example: "pháo giã liên hồi * bị giã cho một trận nên thân",
  },
  {
    word: "giã",
    part_of_speech: "động từ",
    meaning:
      '(Từ cũ) như từ giã: "Ra về giã nước giã non, Giã người giã cảnh kẻo còn nhớ nhung." (Cdao)',
    example:
      'Ra về giã nước giã non, Giã người giã cảnh kẻo còn nhớ nhung." (Cdao)',
  },
  {
    word: "giã",
    part_of_speech: "động từ",
    meaning: "(Từ cũ) (đám hội) kết thúc, bắt đầu tan: giã hội",
    example: "giã hội",
  },
  {
    word: "gia ân",
    part_of_speech: "động từ",
    meaning: "(cũ, văn chương) ban ơn: được vua gia ân cho bổng lộc",
    example: "được vua gia ân cho bổng lộc",
  },
  {
    word: "giá",
    part_of_speech: "danh từ",
    meaning:
      "mầm đậu xanh, đậu tương chưa mọc lá, dùng làm rau ăn: giá xào * ngâm giá",
    example: "giá xào * ngâm giá",
  },
  {
    word: "giá",
    part_of_speech: "danh từ",
    meaning: "đồ dùng để treo, gác hay đỡ vật gì: giá sách * giá vẽ",
    example: "giá sách * giá vẽ",
  },
  {
    word: "giá",
    part_of_speech: "danh từ",
    meaning: "(hiếm) trạng thái: lạnh buốt * trời chưa tan giá",
    example: "lạnh buốt * trời chưa tan giá",
  },
  {
    word: "giá",
    part_of_speech: "tính từ",
    meaning: "lạnh buốt: trời giá * ngày đông tháng giá",
    example: "trời giá * ngày đông tháng giá",
  },
  {
    word: "giá",
    part_of_speech: "danh từ",
    meaning:
      "biểu hiện giá trị bằng tiền: giá năm mươi nghìn đồng * hàng hạ giá * trong nhà không có gì đáng giá",
    example:
      "giá năm mươi nghìn đồng * hàng hạ giá * trong nhà không có gì đáng giá",
  },
  {
    word: "giá",
    part_of_speech: "danh từ",
    meaning:
      "tổng thể nói chung những gì phải bỏ ra, tiêu phí, mất đi (thường là nhiều) cho một việc làm nào đó: phải hoàn thành công việc bằng bất cứ giá nào",
    example: "phải hoàn thành công việc bằng bất cứ giá nào",
  },
  {
    word: "giá",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) giơ cao để đánh: một cái giá bằng ba cái đánh (tng)",
    example: "một cái giá bằng ba cái đánh (tng)",
  },
  {
    word: "giá",
    part_of_speech: "kết từ",
    meaning:
      "từ dùng để nêu một điều kiện có tính giả thiết, thường là thuận lợi: việc này giá biết trước thì hay * giá đi ngay thì kịp",
    example: "việc này giá biết trước thì hay * giá đi ngay thì kịp",
  },
  {
    word: "gia bảo",
    part_of_speech: "danh từ",
    meaning: "vật báu của gia đình từ xưa để lại: của gia bảo",
    example: "của gia bảo",
  },
  {
    word: "giá bìa",
    part_of_speech: "danh từ",
    meaning: "giá sách, được in trên bìa: sách bán đúng giá bìa",
    example: "sách bán đúng giá bìa",
  },
  {
    word: "gia bản",
    part_of_speech: "danh từ",
    meaning: "(cũ) như gia sản: gia bản chẳng có gì",
    example: "gia bản chẳng có gì",
  },
  {
    word: "giá áo túi cơm",
    part_of_speech: "",
    meaning:
      'ví hạng người vô tích sự, không có ích gì cho xã hội: "Phong trần mài một lưỡi gươm, Những loài giá áo, túi cơm sá gì!" (TKiều)',
    example:
      'Phong trần mài một lưỡi gươm, Những loài giá áo, túi cơm sá gì!" (TKiều)',
  },
  {
    word: "giã biệt",
    part_of_speech: "động từ",
    meaning: "(văn chương) như từ giã: giã biệt xóm làng * lời chào giã biệt",
    example: "giã biệt xóm làng * lời chào giã biệt",
  },
  {
    word: "giả bộ",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) như giả vờ: giả bộ ngây thơ * giả bộ như không nhìn thấy",
    example: "giả bộ ngây thơ * giả bộ như không nhìn thấy",
  },
  {
    word: "gia binh",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) gia đình binh lính (nói khái quát): khu gia binh",
    example: "khu gia binh",
  },
  {
    word: "giá cả",
    part_of_speech: "danh từ",
    meaning:
      "giá hàng hoá (nói khái quát): giá cả phù hợp * không có những biến động lớn về giá cả",
    example: "giá cả phù hợp * không có những biến động lớn về giá cả",
  },
  {
    word: "giá buốt",
    part_of_speech: "tính từ",
    meaning:
      "giá lạnh đến mức như thấm sâu vào tận xương: đêm đông giá buốt * giá buốt cả tâm can",
    example: "đêm đông giá buốt * giá buốt cả tâm can",
  },
  {
    word: "già cả",
    part_of_speech: "tính từ",
    meaning: "già, cao tuổi (nói khái quát): cha mẹ đều già cả * người già cả",
    example: "cha mẹ đều già cả * người già cả",
  },
  {
    word: "gia cảnh",
    part_of_speech: "danh từ",
    meaning: "(Từ cũ) hoàn cảnh gia đình: gia cảnh khó khăn",
    example: "gia cảnh khó khăn",
  },
  {
    word: "giả cách",
    part_of_speech: "động từ",
    meaning: "(phương ngữ, hiếm) như giả vờ: ốm giả cách",
    example: "ốm giả cách",
  },
  {
    word: "gia cầm",
    part_of_speech: "danh từ",
    meaning:
      "chim nuôi trong nhà, như gà, vịt, ngan, ngỗng, v.v. (nói khái quát): chăm sóc đàn gia cầm",
    example: "chăm sóc đàn gia cầm",
  },
  {
    word: "giá cạnh tranh",
    part_of_speech: "danh từ",
    meaning:
      "giá bán nhằm bảo vệ, chiếm lĩnh, mở rộng thị trường (thường là giá hạ, giá ưu đãi): bán chào hàng với giá cạnh tranh",
    example: "bán chào hàng với giá cạnh tranh",
  },
  {
    word: "già câng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) già quá so với tuổi, mặt trông như khô cứng đi: mặt già câng",
    example: "mặt già câng",
  },
  {
    word: "già cấc",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ, hiếm) như già câng: tuổi còn ít mà trông mặt đã già cấc",
    example: "tuổi còn ít mà trông mặt đã già cấc",
  },
  {
    word: "gia chánh",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) việc nấu ăn, nội trợ trong gia đình (nói khái quát): có tài nữ công gia chánh",
    example: "có tài nữ công gia chánh",
  },
  {
    word: "giá chợ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) giá hàng hoá trên thị trường: hạch toán theo giá chợ * theo dõi thông tin giá chợ",
    example: "hạch toán theo giá chợ * theo dõi thông tin giá chợ",
  },
  {
    word: "gia chủ",
    part_of_speech: "danh từ",
    meaning: "(cũ) chủ nhà: nâng cốc chúc tụng gia chủ",
    example: "nâng cốc chúc tụng gia chủ",
  },
  {
    word: "gia cố",
    part_of_speech: "động từ",
    meaning:
      "làm cho vững chắc thêm (nói về các công trình xây dựng): sửa chữa và gia cố hệ thống đê kè",
    example: "sửa chữa và gia cố hệ thống đê kè",
  },
  {
    word: "gia công",
    part_of_speech: "động từ",
    meaning:
      "làm thay đổi hình dạng, trạng thái, tính chất, v.v. của vật thể trong quá trình chế tạo sản phẩm: gia công kim loại * gia công các chi tiết máy",
    example: "gia công kim loại * gia công các chi tiết máy",
  },
  {
    word: "gia công",
    part_of_speech: "động từ",
    meaning:
      "nhận nguyên vật liệu để làm ra sản phẩm theo yêu cầu (một hình thức tổ chức sản xuất): nhận hàng gia công về làm * may gia công",
    example: "nhận hàng gia công về làm * may gia công",
  },
  {
    word: "già cỗi",
    part_of_speech: "tính từ",
    meaning:
      "(cây cối, con người) già và cằn cỗi, không còn sức phát triển: gốc cau già cỗi * người già cỗi",
    example: "gốc cau già cỗi * người già cỗi",
  },
  {
    word: "già cỗi",
    part_of_speech: "tính từ",
    meaning:
      "quá già, quá cũ, không còn sức sống, hoặc không còn có tác dụng bao nhiêu: cỗ máy già cỗi * tâm hồn già cỗi (b)",
    example: "cỗ máy già cỗi * tâm hồn già cỗi (b)",
  },
  {
    word: "giả da",
    part_of_speech: "tính từ",
    meaning:
      "(vật liệu) không phải bằng da nhưng có hình thức giống như da thật, dùng để làm một số loại đồ dùng: chiếc cặp giả da * giầy giả da * áo giả da",
    example: "chiếc cặp giả da * giầy giả da * áo giả da",
  },
  {
    word: "gia cư",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) nhà ở của một gia đình, về mặt là tài sản riêng của gia đình đó: lập gia cư",
    example: "lập gia cư",
  },
  {
    word: "gia cường",
    part_of_speech: "động từ",
    meaning: "(hiếm) như gia cố: gia cường chân móng",
    example: "gia cường chân móng",
  },
  {
    word: "già dặn",
    part_of_speech: "tính từ",
    meaning:
      "(người) ở vào tuổi đã phát triển đầy đủ về các mặt: nét mặt già dặn * ít tuổi nhưng trông khá già dặn",
    example: "nét mặt già dặn * ít tuổi nhưng trông khá già dặn",
  },
  {
    word: "già dặn",
    part_of_speech: "tính từ",
    meaning:
      "đã trưởng thành, vững vàng về mọi mặt, do đã từng trải, được rèn luyện nhiều: ăn nói già dặn * già dặn kinh nghiệm",
    example: "ăn nói già dặn * già dặn kinh nghiệm",
  },
  {
    word: "giả danh",
    part_of_speech: "động từ",
    meaning:
      "tự xưng là người khác, danh nghĩa khác để đánh lừa: giả danh làm việc nghĩa để lừa thiên hạ",
    example: "giả danh làm việc nghĩa để lừa thiên hạ",
  },
  {
    word: "giả dạng",
    part_of_speech: "động từ",
    meaning:
      "làm cho có bộ dạng giống kiểu người khác để không bị nhận ra, để làm việc gì được trót lọt: giả dạng dân thường để điều tra",
    example: "giả dạng dân thường để điều tra",
  },
  {
    word: "giả dụ",
    part_of_speech: "",
    meaning:
      "từ dùng để nêu một giả thuyết, thử coi điều nào đó là có thật để xem cái gì có thể xảy ra, nhằm rút ra kết luận, nhận định, đánh giá về điều đang được nói đến: giả dụ sáng mai không về được thì sao? * đấy là tôi giả dụ thế",
    example: "giả dụ sáng mai không về được thì sao? * đấy là tôi giả dụ thế",
  },
  {
    word: "giả dối",
    part_of_speech: "tính từ",
    meaning: "không đúng sự thật: lời tán tụng giả dối * sống giả dối",
    example: "lời tán tụng giả dối * sống giả dối",
  },
  {
    word: "gia đình",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp người cùng sống chung thành một đơn vị nhỏ nhất trong xã hội, gắn bó với nhau bằng quan hệ hôn nhân và dòng máu, thường gồm có vợ chồng, cha mẹ và con cái: xây dựng gia đình * một gia đình hạnh phúc",
    example: "xây dựng gia đình * một gia đình hạnh phúc",
  },
  {
    word: "gia đình",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) gia đình chủ nghĩa (nói tắt): vụ việc được xử lí theo kiểu gia đình",
    example: "vụ việc được xử lí theo kiểu gia đình",
  },
  {
    word: "gia dụng",
    part_of_speech: "tính từ",
    meaning: "chuyên để dùng cho sinh hoạt gia đình: đồ gia dụng",
    example: "đồ gia dụng",
  },
  {
    word: "gia đạo",
    part_of_speech: "danh từ",
    meaning: "lề lối và phép tắc riêng trong một gia đình phong kiến.",
    example: "gia đạo sa sút * hỏi thăm gia đạo",
  },
  {
    word: "gia đình chủ nghĩa",
    part_of_speech: "tính từ",
    meaning:
      "có xu hướng thiên về tình cảm, không chú ý đầy đủ đến tính nguyên tắc của tổ chức trong quan hệ công tác: quản lí theo kiểu gia đình chủ nghĩa",
    example: "quản lí theo kiểu gia đình chủ nghĩa",
  },
  {
    word: "giả định",
    part_of_speech: "",
    meaning:
      "coi điều nào đó như là có thật để lấy đó làm căn cứ: tình huống giả định * đưa ra những giả định trái ngược nhau",
    example: "tình huống giả định * đưa ra những giả định trái ngược nhau",
  },
  {
    word: "gia đình trị",
    part_of_speech: "động từ",
    meaning:
      "chia nhau giữa những người trong cùng một gia đình giành nắm hết mọi quyền hành, mọi cương vị trong bộ máy nhà nước: chế độ độc tài gia đình trị",
    example: "chế độ độc tài gia đình trị",
  },
  {
    word: "gia đình trị",
    part_of_speech: "tính từ",
    meaning:
      "ở tình trạng chưa xong, chưa kết thúc: viết dở bài báo * đang dở câu chuyện thì có khách",
    example: "viết dở bài báo * đang dở câu chuyện thì có khách",
  },
  {
    word: "già đời",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) lâu năm, nhiều kinh nghiệm và sành sỏi: già đời trong nghề đi biển * tay bịp già đời",
    example: "già đời trong nghề đi biển * tay bịp già đời",
  },
  {
    word: "già đời",
    part_of_speech: "tính từ",
    meaning: "suốt đời, cho đến lúc già: già đời vất vả",
    example: "già đời vất vả",
  },
  {
    word: "giã đám",
    part_of_speech: "động từ",
    meaning: "kết thúc đám hội, mọi người chuẩn bị ra về: hội chèo giã đám",
    example: "hội chèo giã đám",
  },
  {
    word: "giả đò",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) như giả vờ: biết rồi còn cứ giả đò",
    example: "biết rồi còn cứ giả đò",
  },
  {
    word: "gia giảm",
    part_of_speech: "động từ",
    meaning:
      "thêm vào hoặc bớt đi một ít cho vừa, cho phù hợp (nói khái quát): gia giảm mắm muối",
    example: "gia giảm mắm muối",
  },
  {
    word: "gia giáo",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) sự giáo dục trong gia đình (thường nói về gia đình phong kiến thời trước): người có gia giáo * gia giáo nghiêm khắc",
    example: "người có gia giáo * gia giáo nghiêm khắc",
  },
  {
    word: "gia giáo",
    part_of_speech: "tính từ",
    meaning:
      "có nền nếp, có giáo dục (thường nói về gia đình phong kiến thời trước): con nhà gia giáo",
    example: "con nhà gia giáo",
  },
  {
    word: "gia hạn",
    part_of_speech: "động từ",
    meaning:
      "kéo dài thêm một thời gian nữa sau khi đã hết hạn hoặc đã hết thời gian có giá trị: gia hạn hợp đồng * gia hạn hộ chiếu",
    example: "gia hạn hợp đồng * gia hạn hộ chiếu",
  },
  {
    word: "già họng",
    part_of_speech: "tính từ",
    meaning: "(thông tục) như già mồm: đã làm sai còn già họng cãi",
    example: "đã làm sai còn già họng cãi",
  },
  {
    word: "gia hình",
    part_of_speech: "động từ",
    meaning:
      '(cũ) bắt phải chịu hình phạt: "Một là cứ phép gia hình, Hai là lại cứ lầu xanh phó về!" (TKiều)',
    example: 'Một là cứ phép gia hình, Hai là lại cứ lầu xanh phó về!" (TKiều)',
  },
  {
    word: "giả hiệu",
    part_of_speech: "tính từ",
    meaning:
      "chỉ trên danh nghĩa chứ thực chất không phải, cốt để đánh lừa: độc lập giả hiệu",
    example: "độc lập giả hiệu",
  },
  {
    word: "gia huấn",
    part_of_speech: "danh từ",
    meaning: "(cũ) sự dạy bảo con cháu trong gia đình: nghe lời gia huấn",
    example: "nghe lời gia huấn",
  },
  {
    word: "già khọm",
    part_of_speech: "tính từ",
    meaning:
      "già lắm, đến mức lưng còng hẳn xuống: mới 60 tuổi mà trông đã già khọm",
    example: "mới 60 tuổi mà trông đã già khọm",
  },
  {
    word: "già khằn",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) già đến mức người như khô tóp đi (hàm ý chê): mặt già khằn",
    example: "mặt già khằn",
  },
  {
    word: "giả lả",
    part_of_speech: "động từ",
    meaning:
      "(Phương ngữ) làm ra bộ vui vẻ để tỏ ý muốn làm giảm bớt sự căng thẳng giữa người khác với mình: giọng giả lả * cười giả lả",
    example: "giọng giả lả * cười giả lả",
  },
  {
    word: "già lam",
    part_of_speech: "danh từ",
    meaning: "(cũ, văn chương) chùa: mến cảnh già lam",
    example: "mến cảnh già lam",
  },
  {
    word: "giá lạnh",
    part_of_speech: "tính từ",
    meaning:
      "rất lạnh, tựa như nước đá (nói khái quát): bàn tay giá lạnh * trời mỗi lúc một giá lạnh * tâm hồn giá lạnh (b)",
    example:
      "bàn tay giá lạnh * trời mỗi lúc một giá lạnh * tâm hồn giá lạnh (b)",
  },
  {
    word: "già lão",
    part_of_speech: "tính từ",
    meaning:
      "cao tuổi, nói về mặt sức lực không còn bao nhiêu (nói khái quát): mới 50 chứ đã già lão gì đâu * chiếc ô tô già lão (b)",
    example: "mới 50 chứ đã già lão gì đâu * chiếc ô tô già lão (b)",
  },
  {
    word: "giả lơ",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) giả vờ như không biết để lảng tránh: trông thấy mà cứ giả lơ",
    example: "trông thấy mà cứ giả lơ",
  },
  {
    word: "giả mạo",
    part_of_speech: "động từ",
    meaning:
      "làm giả để đánh lừa: giả mạo chữ kí * hồ sơ giả mạo * giả mạo người mua để lấy trộm hàng",
    example:
      "giả mạo chữ kí * hồ sơ giả mạo * giả mạo người mua để lấy trộm hàng",
  },
  {
    word: "già mồm",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) nói nhiều và lớn tiếng một cách hàm hồ: già mồm cãi * đã sai lại còn già mồm!",
    example: "già mồm cãi * đã sai lại còn già mồm!",
  },
  {
    word: "giả ngô giả ngọng",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) giả vờ ngây ngô, không biết gì để tránh phải tỏ thái độ thật: biết rồi còn cứ giả ngô giả ngọng",
    example: "biết rồi còn cứ giả ngô giả ngọng",
  },
  {
    word: "giá ngắt",
    part_of_speech: "tính từ",
    meaning: "như lạnh ngắt (nhưng nghĩa mạnh hơn): đôi tay giá ngắt",
    example: "đôi tay giá ngắt",
  },
  {
    word: "giá mà",
    part_of_speech: "kết từ",
    meaning: "(khẩu ngữ) như giá như: giá mà biết trước thì hay biết mấy!",
    example: "giá mà biết trước thì hay biết mấy!",
  },
  {
    word: "gia nghiệp",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, hiếm) sự nghiệp từ đời ông cha để lại, đang được kế tục: "Cánh già được thấy con cháu nối được gia nghiệp, các cụ vui mừng vô hạn." (NgTTố; 3)',
    example:
      'Cánh già được thấy con cháu nối được gia nghiệp, các cụ vui mừng vô hạn." (NgTTố; 3)',
  },
  {
    word: "giả nhân giả nghĩa",
    part_of_speech: "",
    meaning:
      "làm ra vẻ có nhân, có nghĩa để đánh lừa: giả nhân giả nghĩa để lấy lòng mọi người",
    example: "giả nhân giả nghĩa để lấy lòng mọi người",
  },
  {
    word: "già nua",
    part_of_speech: "tính từ",
    meaning:
      "quá già và yếu đuối, chẳng còn sức sống bao nhiêu: già nua tuổi tác * nét mặt già nua",
    example: "già nua tuổi tác * nét mặt già nua",
  },
  {
    word: "giá như",
    part_of_speech: "kết từ",
    meaning:
      "từ dùng để nêu một giả thiết, thường là thuận lợi, trái với thực tế, cho thấy với giả thiết đó thì sự việc xảy ra đã hoặc sẽ khác đi: hôm ấy giá như ở nhà thì gặp * giá như tôi không mắng nó thì đâu đến nỗi",
    example:
      "hôm ấy giá như ở nhà thì gặp * giá như tôi không mắng nó thì đâu đến nỗi",
  },
  {
    word: "gia nhân",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người ở giúp việc trong nhà: truyền gọi gia nhân * bọn gia nhân trong nhà",
    example: "truyền gọi gia nhân * bọn gia nhân trong nhà",
  },
  {
    word: "gia nhập",
    part_of_speech: "động từ",
    meaning:
      "đứng vào hàng ngũ, trở thành thành viên của một tổ chức nào đó: gia nhập quân đội * gia nhập Liên Hợp Quốc",
    example: "gia nhập quân đội * gia nhập Liên Hợp Quốc",
  },
  {
    word: "gia phả",
    part_of_speech: "danh từ",
    meaning:
      "sách ghi chép lai lịch, thân thế và sự nghiệp từng người trong gia tộc, theo thứ tự các đời: quyển gia phả * gia phả dòng họ Nguyễn",
    example: "quyển gia phả * gia phả dòng họ Nguyễn",
  },
  {
    word: "gia pháp",
    part_of_speech: "danh từ",
    meaning: "(cũ) phép tắc trong một gia đình phong kiến: gia pháp rất nghiêm",
    example: "gia pháp rất nghiêm",
  },
  {
    word: "gia quyến",
    part_of_speech: "danh từ",
    meaning:
      "những người thân thích trong gia đình: xin chia buồn cùng gia quyến",
    example: "xin chia buồn cùng gia quyến",
  },
  {
    word: "giá phỏng",
    part_of_speech: "kết từ",
    meaning:
      "(văn chương, hiếm) từ dùng để nêu một giả thiết, thử coi điều nào đó là có thật để xem có thể rút ra kết luận gì: giá phỏng anh ấy bận thì mình có đi không?",
    example: "giá phỏng anh ấy bận thì mình có đi không?",
  },
  {
    word: "gia sản",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ nói chung tài sản của một gia đình: gia sản chẳng có gì * bị tịch thu toàn bộ gia sản",
    example: "gia sản chẳng có gì * bị tịch thu toàn bộ gia sản",
  },
  {
    word: "giá rét",
    part_of_speech: "tính từ",
    meaning: "(khí trời) lạnh và rét (nói khái quát): trời đông giá rét",
    example: "trời đông giá rét",
  },
  {
    word: "giá sinh hoạt",
    part_of_speech: "danh từ",
    meaning:
      "giá cả hàng hoá, dịch vụ, v.v. thiết yếu cho đời sống con người như ăn, mặc, ở, v.v., nói chung: giá sinh hoạt càng ngày càng đắt đỏ",
    example: "giá sinh hoạt càng ngày càng đắt đỏ",
  },
  {
    word: "giá sàn",
    part_of_speech: "danh từ",
    meaning:
      "mức giá tối thiểu được quy định đối với một loại hàng hoá; phân biệt với giá trần: nhiều cổ phiếu bị rơi xuống giá sàn",
    example: "nhiều cổ phiếu bị rơi xuống giá sàn",
  },
  {
    word: "gia phong",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) lối sống, nền nếp riêng của một gia đình: nền nếp gia phong * làm nhục gia phong",
    example: "nền nếp gia phong * làm nhục gia phong",
  },
  {
    word: "gia sự",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) chuyện nhà (thường là những chuyện có tính chất hệ trọng): "Bởi vì gia sự rối bời, Vợ thời sớm goá, con thời thơ ngây." (PCCH)',
    example:
      'Bởi vì gia sự rối bời, Vợ thời sớm goá, con thời thơ ngây." (PCCH)',
  },
  {
    word: "gia sư",
    part_of_speech: "danh từ",
    meaning:
      "thầy dạy riêng cho trẻ em trong một gia đình: thuê gia sư về dạy tại nhà * sinh viên đi làm gia sư",
    example: "thuê gia sư về dạy tại nhà * sinh viên đi làm gia sư",
  },
  {
    word: "giả tảng",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) như giả vờ: giả tảng như không nghe thấy",
    example: "giả tảng như không nghe thấy",
  },
  {
    word: "gia tài",
    part_of_speech: "danh từ",
    meaning:
      "tài sản của người chết để lại cho người thừa kế: thừa hưởng gia tài",
    example: "thừa hưởng gia tài",
  },
  {
    word: "gia tài",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) của cải riêng của một người, một gia đình: gia tài chẳng có gì * gia tài khánh kiệt vì cờ bạc",
    example: "gia tài chẳng có gì * gia tài khánh kiệt vì cờ bạc",
  },
  {
    word: "giả sử",
    part_of_speech: "",
    meaning:
      "từ dùng để nêu một giả thiết, thường là trái với thực tế, lấy đó làm căn cứ suy luận, chứng minh: giả sử chuyện vỡ lở ra thì anh tính sao? * cứ giả sử là không có tôi thì mọi người có làm kịp không?",
    example:
      "giả sử chuyện vỡ lở ra thì anh tính sao? * cứ giả sử là không có tôi thì mọi người có làm kịp không?",
  },
  {
    word: "giả tạo",
    part_of_speech: "tính từ",
    meaning:
      "không thật, vì được tạo ra một cách không tự nhiên: khen thật lòng, không hề giả tạo * phồn vinh giả tạo",
    example: "khen thật lòng, không hề giả tạo * phồn vinh giả tạo",
  },
  {
    word: "gia thất",
    part_of_speech: "danh từ",
    meaning: "(cũ) gia đình, thường nói về mặt mới hợp thành: yên bề gia thất",
    example: "yên bề gia thất",
  },
  {
    word: "già tay",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) quá tay hoặc thẳng tay, không chút nương nhẹ: nêm muối hơi già tay nên bị mặn",
    example: "nêm muối hơi già tay nên bị mặn",
  },
  {
    word: "gia tăng",
    part_of_speech: "động từ",
    meaning: "tăng thêm: dân số gia tăng * chi phí ngày càng gia tăng",
    example: "dân số gia tăng * chi phí ngày càng gia tăng",
  },
  {
    word: "giá thành",
    part_of_speech: "danh từ",
    meaning:
      "biểu hiện thành tiền của toàn bộ chi phí để làm ra một sản phẩm: hạ giá thành sản phẩm * hàng tốt nhưng giá thành cao",
    example: "hạ giá thành sản phẩm * hàng tốt nhưng giá thành cao",
  },
  {
    word: "giả thiết",
    part_of_speech: "",
    meaning:
      "điều cho trước trong một định lí hay một bài toán để căn cứ vào đó mà suy ra kết luận của định lí hay để giải bài toán..",
    example: "một giả thiết thiếu căn cứ * giả thiết là chuyện đó có thật",
  },
  {
    word: "giá thú",
    part_of_speech: "danh từ",
    meaning:
      "việc lấy vợ, lấy chồng, được pháp luật thừa nhận: con ngoài giá thú * lấy nhau nhưng chưa làm giấy giá thú",
    example: "con ngoài giá thú * lấy nhau nhưng chưa làm giấy giá thú",
  },
  {
    word: "gia thế",
    part_of_speech: "danh từ",
    meaning:
      "các thế hệ đời trước trong dòng họ, về mặt có quan hệ đến thân thế và sự nghiệp của một cá nhân nào đó (nói tổng quát): tìm hiểu về gia thế * gia thế cao sang",
    example: "tìm hiểu về gia thế * gia thế cao sang",
  },
  {
    word: "gia thế",
    part_of_speech: "danh từ",
    meaning: "dòng dõi quyền quý: con nhà gia thế * dòng dõi gia thế",
    example: "con nhà gia thế * dòng dõi gia thế",
  },
  {
    word: "giả tỉ",
    part_of_speech: "kết từ",
    meaning: "(cũ, hiếm) như giả sử: giả tỉ trời mưa thì có đi không?",
    example: "giả tỉ trời mưa thì có đi không?",
  },
  {
    word: "gia tiên",
    part_of_speech: "danh từ",
    meaning: "tổ tiên của gia đình: lễ gia tiên * bàn thờ gia tiên",
    example: "lễ gia tiên * bàn thờ gia tiên",
  },
  {
    word: "giả trang",
    part_of_speech: "động từ",
    meaning:
      "thay đổi cách ăn mặc và dáng điệu, giả làm loại người khác: giả trang làm nhà sư",
    example: "giả trang làm nhà sư",
  },
  {
    word: "giả trá",
    part_of_speech: "tính từ",
    meaning: "giả dối để đánh lừa: tình yêu giả trá * con người giả trá",
    example: "tình yêu giả trá * con người giả trá",
  },
  {
    word: "gia tộc",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp gồm nhiều gia đình có cùng một tổ tiên: người trong gia tộc",
    example: "người trong gia tộc",
  },
  {
    word: "giá trị",
    part_of_speech: "danh từ",
    meaning:
      "cái làm cho một vật có ích lợi, có ý nghĩa, là đáng quý về một mặt nào đó: loại thức ăn có giá trị dinh dưỡng cao * giá trị tinh thần",
    example: "loại thức ăn có giá trị dinh dưỡng cao * giá trị tinh thần",
  },
  {
    word: "giá trị",
    part_of_speech: "danh từ",
    meaning: "tác dụng, hiệu lực: hợp đồng đã hết giá trị",
    example: "hợp đồng đã hết giá trị",
  },
  {
    word: "giá trị",
    part_of_speech: "danh từ",
    meaning:
      "lao động xã hội của những người sản xuất hàng hoá kết tinh trong sản phẩm hàng hoá..",
    example: "tìm giá trị của ẩn số x * giá trị biến thiên của hàm số",
  },
  {
    word: "giá trần",
    part_of_speech: "danh từ",
    meaning:
      "mức giá tối đa được quy định đối với một loại hàng hoá hoặc dịch vụ; phân biệt với giá sàn: điều chỉnh giá trần bán lẻ xăng dầu",
    example: "điều chỉnh giá trần bán lẻ xăng dầu",
  },
  {
    word: "gia trang",
    part_of_speech: "danh từ",
    meaning: "(cũ) trang trại của một gia đình: tiễn khách ra khỏi gia trang",
    example: "tiễn khách ra khỏi gia trang",
  },
  {
    word: "giá trị thặng dư",
    part_of_speech: "danh từ",
    meaning:
      "phần giá trị do người lao động tạo ra vượt quá giá trị sức lao động của họ: chiếm hữu giá trị thặng dư",
    example: "chiếm hữu giá trị thặng dư",
  },
  {
    word: "gia trưởng",
    part_of_speech: "tính từ",
    meaning:
      "có tư tưởng tự coi là mình có mọi quyền hành, tự ý quyết định mọi việc, coi thường quyền dân chủ của người khác: đầu óc gia trưởng",
    example: "đầu óc gia trưởng",
  },
  {
    word: "gia tư",
    part_of_speech: "danh từ",
    meaning:
      'như gia sản: "Có nhà viên ngoại họ Vương, Gia tư nghĩ cũng thường thường bực trung." (TKiều)',
    example:
      'Có nhà viên ngoại họ Vương, Gia tư nghĩ cũng thường thường bực trung." (TKiều)',
  },
  {
    word: "gia truyền",
    part_of_speech: "tính từ",
    meaning:
      "do các đời trước truyền lại và thường được trân trọng giữ gìn từ đời này qua đời khác: bài thuốc gia truyền * nghề gốm gia truyền",
    example: "bài thuốc gia truyền * nghề gốm gia truyền",
  },
  {
    word: "giả tưởng",
    part_of_speech: "động từ",
    meaning:
      "có tính chất tưởng tượng, được tạo ra nhờ trí tưởng tượng: phim khoa học giả tưởng",
    example: "phim khoa học giả tưởng",
  },
  {
    word: "giã từ",
    part_of_speech: "động từ",
    meaning: "như từ biệt: giã từ quê hương, lên đường chiến đấu",
    example: "giã từ quê hương, lên đường chiến đấu",
  },
  {
    word: "giác",
    part_of_speech: "động từ",
    meaning:
      "làm cho máu tụ lại một chỗ cho đỡ đau, bằng cách úp sát vào đó một dụng cụ hình chén thắt miệng (bầu giác) hoặc hình ống (ống giác) đã được đốt lửa hoặc nén hơi bên trong (một phương pháp chữa bệnh dân gian): giác hơi * đi giác sắm bầu, đi câu sắm giỏ (tng)",
    example: "giác hơi * đi giác sắm bầu, đi câu sắm giỏ (tng)",
  },
  {
    word: "gia vị",
    part_of_speech: "danh từ",
    meaning:
      "thứ cho thêm vào món ăn để tăng thêm mùi vị, như hành, ớt, hạt tiêu, mì chính, v.v.: món ăn thiếu gia vị",
    example: "món ăn thiếu gia vị",
  },
  {
    word: "gia vị",
    part_of_speech: "danh từ",
    meaning:
      "bột được chế biến sẵn, gồm hỗn hợp một số thứ gia vị thường dùng như muối, mì chính, hạt tiêu, v.v.: gói gia vị * nêm thêm một chút gia vị vào nồi canh",
    example: "gói gia vị * nêm thêm một chút gia vị vào nồi canh",
  },
  {
    word: "giả vờ",
    part_of_speech: "động từ",
    meaning:
      "làm ra vẻ như thế nào đó, nhằm cho người ta tưởng thật là như thế: giả vờ say rượu * khóc giả vờ * nằm im giả vờ ngủ",
    example: "giả vờ say rượu * khóc giả vờ * nằm im giả vờ ngủ",
  },
  {
    word: "già yếu",
    part_of_speech: "tính từ",
    meaning: "(người) già cả ốm yếu (nói khái quát): cha mẹ đã già yếu",
    example: "cha mẹ đã già yếu",
  },
  {
    word: "giác ngộ",
    part_of_speech: "",
    meaning:
      "hiểu ra hoặc làm cho hiểu ra lẽ phải trái (thường nói về mặt chính trị): giác ngộ giáo lí đạo Phật * dân quê đã giác ngộ và tham gia cách mạng",
    example:
      "giác ngộ giáo lí đạo Phật * dân quê đã giác ngộ và tham gia cách mạng",
  },
  {
    word: "giác mạc",
    part_of_speech: "danh từ",
    meaning:
      "phần trong suốt của màng cứng của mắt, ở phía trước con ngươi: viêm giác mạc",
    example: "viêm giác mạc",
  },
  {
    word: "giai âm",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) tin tốt lành, tin vui: "Trong cơ thanh khí tương tầm, Ở đây hoặc có giai âm chăng là?" (TKiều)',
    example:
      'Trong cơ thanh khí tương tầm, Ở đây hoặc có giai âm chăng là?" (TKiều)',
  },
  {
    word: "giải",
    part_of_speech: "danh từ",
    meaning:
      "cái có giá trị tinh thần hoặc vật chất dành riêng cho người hay đơn vị đạt thành tích cao trong một số cuộc đua tranh: trúng giải đặc biệt * giải vô địch cờ vua toàn quốc * treo giải",
    example: "trúng giải đặc biệt * giải vô địch cờ vua toàn quốc * treo giải",
  },
  {
    word: "giải",
    part_of_speech: "động từ",
    meaning:
      "đi kèm theo để đưa đến một nơi nào đó bằng cách cưỡng bức: giải phạm nhân lên công đường",
    example: "giải phạm nhân lên công đường",
  },
  {
    word: "giải",
    part_of_speech: "động từ",
    meaning:
      "làm cho thoát được cái đang trói buộc, hạn chế tự do: giải thế nguy * giải lời thề",
    example: "giải thế nguy * giải lời thề",
  },
  {
    word: "giải",
    part_of_speech: "động từ",
    meaning:
      'làm cho như tan mất đi cái đang làm khó chịu: giải khát * giải sự thắc mắc * "Bao giờ sông Cái có cầu, Em sang em giải mối sầu cho anh." (Cdao)',
    example:
      'giải khát * giải sự thắc mắc * "Bao giờ sông Cái có cầu, Em sang em giải mối sầu cho anh." (Cdao)',
  },
  {
    word: "giải",
    part_of_speech: "động từ",
    meaning:
      "làm cho những rắc rối hoặc bí ẩn được gỡ dần ra để tìm ra đáp số hoặc câu trả lời: không giải được bài toán * giải phương trình * chưa ai giải được câu đố ấy",
    example:
      "không giải được bài toán * giải phương trình * chưa ai giải được câu đố ấy",
  },
  {
    word: "giác quan",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận của cơ thể chuyên tiếp nhận những kích thích từ bên ngoài như ánh sáng, màu sắc, mùi vị, v.v.: năm giác quan là thị giác, thính giác, xúc giác, vị giác, khứu giác",
    example:
      "năm giác quan là thị giác, thính giác, xúc giác, vị giác, khứu giác",
  },
  {
    word: "giãi bày",
    part_of_speech: "động từ",
    meaning:
      "(văn chương) nói hết ra cho người khác rõ điều chứa chất trong lòng: giãi bày tâm sự * viết thư giãi bày tình cảm",
    example: "giãi bày tâm sự * viết thư giãi bày tình cảm",
  },
  {
    word: "giai cấp",
    part_of_speech: "danh từ",
    meaning:
      "tập đoàn người đông đảo có địa vị như nhau trong hệ thống sản xuất, trong quan hệ đối với tư liệu sản xuất, trong tổ chức lao động xã hội, trong sự hưởng thụ và do đó có quyền lợi chung, phân biệt với những tập đoàn người khác: phân chia giai cấp * giai cấp công nhân * đấu tranh giai cấp",
    example: "phân chia giai cấp * giai cấp công nhân * đấu tranh giai cấp",
  },
  {
    word: "giại",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng hình tấm bằng tre nứa hoặc bằng gỗ, đặt ở hiên để che nắng gió: tấm giại",
    example: "tấm giại",
  },
  {
    word: "giải chấp",
    part_of_speech: "động từ",
    meaning:
      "làm cho các điều kiện ràng buộc đối với tài sản đang được thế chấp không còn có hiệu lực nữa: trả nợ để giải chấp nhà * lập hồ sơ giải chấp",
    example: "trả nợ để giải chấp nhà * lập hồ sơ giải chấp",
  },
  {
    word: "giải cấu tương phùng",
    part_of_speech: "",
    meaning:
      '(cũ, văn chương) tình cờ không hẹn mà gặp: "Mới hay giải cấu tương phùng, Biết người biết mặt biết lòng làm sao." (ca dao)',
    example:
      'Mới hay giải cấu tương phùng, Biết người biết mặt biết lòng làm sao." (ca dao)',
  },
  {
    word: "giải cứu",
    part_of_speech: "động từ",
    meaning: "cứu thoát: giải cứu con tin",
    example: "giải cứu con tin",
  },
  {
    word: "giải đông",
    part_of_speech: "động từ",
    meaning:
      "làm cho thực phẩm không còn ở trạng thái bị đông cứng (do được bảo quản ở nhiệt độ thấp): xả đông thực phẩm trước khi chế biến",
    example: "xả đông thực phẩm trước khi chế biến",
  },
  {
    word: "giải đáp",
    part_of_speech: "động từ",
    meaning:
      "trả lời cho vấn đề được đặt ra: giải đáp những thắc mắc của bạn đọc * chưa tìm được lời giải đáp",
    example: "giải đáp những thắc mắc của bạn đọc * chưa tìm được lời giải đáp",
  },
  {
    word: "giai điệu",
    part_of_speech: "danh từ",
    meaning:
      "chuỗi âm thanh có tổ chức hoàn chỉnh cả về hình thức và nội dung: bài hát có giai điệu sâu lắng",
    example: "bài hát có giai điệu sâu lắng",
  },
  {
    word: "giai đoạn",
    part_of_speech: "danh từ",
    meaning:
      "phần thời gian trong một quá trình phát triển dài, phân biệt với những phần thời gian khác bởi những hiện tượng, những đặc điểm riêng: giai đoạn giao thời * ung thư giai đoạn cuối * cuộc kháng chiến được chia làm ba giai đoạn",
    example:
      "giai đoạn giao thời * ung thư giai đoạn cuối * cuộc kháng chiến được chia làm ba giai đoạn",
  },
  {
    word: "giải giáp",
    part_of_speech: "động từ",
    meaning: "tước vũ khí của quân đội thua trận: giải giáp bại binh",
    example: "giải giáp bại binh",
  },
  {
    word: "giải giáp",
    part_of_speech: "động từ",
    meaning: "(cũ, hiếm) hạ vũ khí để đầu hàng: xin giải giáp quy hàng",
    example: "xin giải giáp quy hàng",
  },
  {
    word: "giải độc",
    part_of_speech: "động từ",
    meaning:
      "làm cho chất độc đã nhiễm vào cơ thể không còn gây tác hại nữa: uống thuốc giải độc",
    example: "uống thuốc giải độc",
  },
  {
    word: "giải giới",
    part_of_speech: "động từ",
    meaning:
      "làm cho vũ khí (của một lực lượng vũ trang) không còn có khả năng được sử dụng vào mục đích chiến tranh nữa: giải giới lực lượng dân quân",
    example: "giải giới lực lượng dân quân",
  },
  {
    word: "giải hoà",
    part_of_speech: "động từ",
    meaning: "(hiếm) như hoà giải: làm trung gian giải hoà hai bên",
    example: "làm trung gian giải hoà hai bên",
  },
  {
    word: "giải khuây",
    part_of_speech: "động từ",
    meaning:
      "làm cho khuây khoả, quên đi phần nào nỗi buồn hoặc thương nhớ: đọc sách để giải khuây",
    example: "đọc sách để giải khuây",
  },
  {
    word: "giải khát",
    part_of_speech: "động từ",
    meaning:
      "uống cho khỏi khát, cho hết khát: quán giải khát * pha nước chanh uống giải khát",
    example: "quán giải khát * pha nước chanh uống giải khát",
  },
  {
    word: "giải mã",
    part_of_speech: "động từ",
    meaning:
      "làm cho những kí hiệu đã được mã hoá trở thành hiểu được: chưa giải mã được bức điện mật",
    example: "chưa giải mã được bức điện mật",
  },
  {
    word: "giải lao",
    part_of_speech: "động từ",
    meaning:
      "nghỉ giữa giờ làm việc cho đỡ mệt: giải lao mười lăm phút * làm một mạch, không cần giải lao",
    example: "giải lao mười lăm phút * làm một mạch, không cần giải lao",
  },
  {
    word: "giải nghệ",
    part_of_speech: "động từ",
    meaning: "bỏ hoặc thôi nghề đang làm: tuyên bố giải nghệ",
    example: "tuyên bố giải nghệ",
  },
  {
    word: "giải nghĩa",
    part_of_speech: "động từ",
    meaning: "nói cho rõ nghĩa: giải nghĩa từ Hán Việt",
    example: "giải nghĩa từ Hán Việt",
  },
  {
    word: "giải ngũ",
    part_of_speech: "động từ",
    meaning:
      "ra khỏi quân đội trở về với cuộc sống dân thường: người lính giải ngũ",
    example: "người lính giải ngũ",
  },
  {
    word: "giải nhiệt",
    part_of_speech: "động từ",
    meaning:
      "làm cho cơ thể bớt nóng: thuốc giải nhiệt * uống nước rau má cho giải nhiệt",
    example: "thuốc giải nhiệt * uống nước rau má cho giải nhiệt",
  },
  {
    word: "giải ngân",
    part_of_speech: "động từ",
    meaning:
      "đưa tiền mặt, đưa vốn vào hoạt động, lưu thông hoặc thực hiện dự án: làm chậm tiến độ giải ngân * báo cáo về vấn đề giải ngân",
    example: "làm chậm tiến độ giải ngân * báo cáo về vấn đề giải ngân",
  },
  {
    word: "giai nhân",
    part_of_speech: "danh từ",
    meaning:
      "(Từ cũ, Văn chương) người đàn bà đẹp: tuyệt thế giai nhân * tài tử giai nhân",
    example: "tuyệt thế giai nhân * tài tử giai nhân",
  },
  {
    word: "giải nhiệm",
    part_of_speech: "động từ",
    meaning:
      "đưa ra khỏi cương vị, chức vụ đang giữ: bị giải nhiệm trước khi hết nhiệm kì",
    example: "bị giải nhiệm trước khi hết nhiệm kì",
  },
  {
    word: "giải pháp",
    part_of_speech: "danh từ",
    meaning:
      "phương pháp giải quyết vấn đề: giải pháp hoà bình * tìm giải pháp cứu nguy",
    example: "giải pháp hoà bình * tìm giải pháp cứu nguy",
  },
  {
    word: "giải phóng",
    part_of_speech: "động từ",
    meaning:
      "làm cho được tự do, cho thoát khỏi tình trạng bị nô dịch, chiếm đóng: giải phóng thủ đô * đất nước được hoàn toàn giải phóng",
    example: "giải phóng thủ đô * đất nước được hoàn toàn giải phóng",
  },
  {
    word: "giải phóng",
    part_of_speech: "động từ",
    meaning:
      "làm cho được tự do, cho thoát khỏi địa vị nô lệ hoặc tình trạng bị áp bức, kiềm chế, ràng buộc: giải phóng nô lệ * giải phóng phụ nữ * giải phóng sức lao động",
    example: "giải phóng nô lệ * giải phóng phụ nữ * giải phóng sức lao động",
  },
  {
    word: "giải phóng",
    part_of_speech: "động từ",
    meaning:
      "làm thoát khỏi tình trạng bị vướng mắc, cản trở: giải phóng mặt bằng * thu dọn để giải phóng lối đi",
    example: "giải phóng mặt bằng * thu dọn để giải phóng lối đi",
  },
  {
    word: "giải phóng",
    part_of_speech: "động từ",
    meaning:
      "làm cho thoát ra một chất hay một dạng năng lượng nào đó: nguyên tử giải phóng năng lượng",
    example: "nguyên tử giải phóng năng lượng",
  },
  {
    word: "giải phóng",
    part_of_speech: "danh từ",
    meaning: "(Khẩu ngữ) giải phóng quân (nói tắt): anh giải phóng",
    example: "anh giải phóng",
  },
  {
    word: "giải phẫu",
    part_of_speech: "động từ",
    meaning:
      "mổ để nghiên cứu hoặc chữa bệnh (nói khái quát): bác sĩ giải phẫu * giải phẫu cắt khối u",
    example: "bác sĩ giải phẫu * giải phẫu cắt khối u",
  },
  {
    word: "giải phẫu",
    part_of_speech: "danh từ",
    meaning: "cấu tạo bên trong của cơ thể: đặc điểm về giải phẫu sinh lí",
    example: "đặc điểm về giải phẫu sinh lí",
  },
  {
    word: "giải quyết",
    part_of_speech: "động từ",
    meaning:
      "làm cho đạt được kết quả, không còn là khó khăn, trở ngại nữa: giải quyết nạn thất nghiệp * chưa tìm ra cách giải quyết",
    example: "giải quyết nạn thất nghiệp * chưa tìm ra cách giải quyết",
  },
  {
    word: "giải oan",
    part_of_speech: "động từ",
    meaning: "làm cho hết nỗi oan: lập đàn giải oan",
    example: "lập đàn giải oan",
  },
  {
    word: "giải phiền",
    part_of_speech: "động từ",
    meaning: "như giải sầu: mượn chén rượu giải phiền",
    example: "mượn chén rượu giải phiền",
  },
  {
    word: "giải sầu",
    part_of_speech: "động từ",
    meaning:
      "làm cho vơi, cho quên nỗi buồn rầu trong lòng: mượn rượu để giải sầu",
    example: "mượn rượu để giải sầu",
  },
  {
    word: "giải tán",
    part_of_speech: "động từ",
    meaning:
      "không còn hoặc làm cho không còn tụ họp lại thành đám đông nữa, mỗi người tản đi một nơi: giải tán cuộc biểu tình * mọi người giải tán đi các ngả",
    example: "giải tán cuộc biểu tình * mọi người giải tán đi các ngả",
  },
  {
    word: "giải tán",
    part_of_speech: "động từ",
    meaning:
      "tước bỏ quyền tồn tại của một tổ chức nào đó, không cho phép tiếp tục hoạt động: giải tán một chính đảng * tổng thống ra quyết định giải tán quốc hội",
    example:
      "giải tán một chính đảng * tổng thống ra quyết định giải tán quốc hội",
  },
  {
    word: "giải thích",
    part_of_speech: "động từ",
    meaning:
      "làm cho hiểu rõ: giải thích một số hiện tượng tự nhiên * ra đi không một lời giải thích",
    example:
      "giải thích một số hiện tượng tự nhiên * ra đi không một lời giải thích",
  },
  {
    word: "giải thể",
    part_of_speech: "động từ",
    meaning:
      "không còn hoặc làm cho không còn đủ điều kiện để tồn tại như một chỉnh thể, một tổ chức nữa: giải thể công ti",
    example: "giải thể công ti",
  },
  {
    word: "giai thoại",
    part_of_speech: "danh từ",
    meaning:
      "mẩu chuyện lí thú được lưu truyền rộng, có liên quan ít nhiều tới nhân vật có thật: giai thoại văn học * giai thoại về nhà văn",
    example: "giai thoại văn học * giai thoại về nhà văn",
  },
  {
    word: "giải thưởng",
    part_of_speech: "danh từ",
    meaning:
      "giải cụ thể dành cho người hay đơn vị đạt thành tích cao trong một số cuộc thi hay trong một số trò chơi: đoạt giải thưởng trong cuộc đua * giải thưởng là một chiếc xe máy",
    example:
      "đoạt giải thưởng trong cuộc đua * giải thưởng là một chiếc xe máy",
  },
  {
    word: "giải thưởng",
    part_of_speech: "danh từ",
    meaning:
      "phần thưởng tặng cho các cá nhân hay tập thể có thành tích xuất sắc trong một lĩnh vực hoạt động nào đó, thường được xét trao tặng hằng năm: giải thưởng Nobel về văn học * tác phẩm được giải thưởng Hồ Chí Minh",
    example:
      "giải thưởng Nobel về văn học * tác phẩm được giải thưởng Hồ Chí Minh",
  },
  {
    word: "giải thoát",
    part_of_speech: "động từ",
    meaning:
      "làm cho thoát khỏi sự giam hãm, ràng buộc, bế tắc: giải thoát con tin * giải thoát khỏi nghèo khó",
    example: "giải thoát con tin * giải thoát khỏi nghèo khó",
  },
  {
    word: "giải thoát",
    part_of_speech: "động từ",
    meaning:
      "thoát khỏi mọi điều đau khổ và ràng buộc trên cõi đời, theo quan niệm của đạo Phật: giải thoát linh hồn",
    example: "giải thoát linh hồn",
  },
  {
    word: "giải toả",
    part_of_speech: "động từ",
    meaning:
      "phá thế bao vây, kìm hãm từ bên ngoài: giải toả một cứ điểm quan trọng * cuộc hành quân giải toả",
    example: "giải toả một cứ điểm quan trọng * cuộc hành quân giải toả",
  },
  {
    word: "giải toả",
    part_of_speech: "động từ",
    meaning:
      "làm cho phân tán, cho thoát khỏi tình trạng tập trung hay ứ tắc: giải toả mặt bằng * những khúc mắc trong lòng đã được giải toả (b)",
    example:
      "giải toả mặt bằng * những khúc mắc trong lòng đã được giải toả (b)",
  },
  {
    word: "giải tích",
    part_of_speech: "danh từ",
    meaning:
      "ngành toán học nghiên cứu các hàm số, giới hạn, phép vi phân, tích phân, v.v.: sách giải tích lớp 12",
    example: "sách giải tích lớp 12",
  },
  {
    word: "giải trí",
    part_of_speech: "động từ",
    meaning:
      "làm cho trí óc thảnh thơi bằng cách nghỉ ngơi hoặc tham gia các hoạt động vui chơi: trò chơi giải trí * giải trí bằng sách báo",
    example: "trò chơi giải trí * giải trí bằng sách báo",
  },
  {
    word: "giãi tỏ",
    part_of_speech: "động từ",
    meaning:
      "(văn chương) như giãi bày: giãi tỏ nỗi lòng * giãi tỏ niềm tâm sự",
    example: "giãi tỏ nỗi lòng * giãi tỏ niềm tâm sự",
  },
  {
    word: "giải trình",
    part_of_speech: "động từ",
    meaning:
      "trình bày để giải thích, thuyết minh: giải trình các khoản chi ngoài dự kiến * giải trình phương án xây dựng",
    example:
      "giải trình các khoản chi ngoài dự kiến * giải trình phương án xây dựng",
  },
  {
    word: "giảm",
    part_of_speech: "động từ",
    meaning:
      "trở nên hoặc làm cho trở nên ít đi về số lượng, mức độ: giảm giá * giảm tốc độ * xoá đói giảm nghèo * giảm nhuệ khí",
    example: "giảm giá * giảm tốc độ * xoá đói giảm nghèo * giảm nhuệ khí",
  },
  {
    word: "giam",
    part_of_speech: "động từ",
    meaning:
      "giữ (người bị coi là có tội) ở một nơi nhất định, không cho tự do đi lại, tự do hoạt động: giam tù trong ngục tối * bị tạm giam * trại giam",
    example: "giam tù trong ngục tối * bị tạm giam * trại giam",
  },
  {
    word: "giam",
    part_of_speech: "động từ",
    meaning:
      "giữ tại một chỗ, không cho tự do rời khỏi: bị giam chân ở nhà * sống giam mình trong bốn bức tường",
    example: "bị giam chân ở nhà * sống giam mình trong bốn bức tường",
  },
  {
    word: "giải vây",
    part_of_speech: "động từ",
    meaning: "làm cho thoát khỏi vòng vây: tìm kế giải vây",
    example: "tìm kế giải vây",
  },
  {
    word: "giam cầm",
    part_of_speech: "động từ",
    meaning: "giam trong nhà tù (nói khái quát): giam cầm phạm nhân",
    example: "giam cầm phạm nhân",
  },
  {
    word: "giảm chấn",
    part_of_speech: "động từ",
    meaning:
      "làm mất hoặc làm bớt rung động, bớt xóc: bộ giảm chấn của khung xe máy",
    example: "bộ giảm chấn của khung xe máy",
  },
  {
    word: "giám định",
    part_of_speech: "động từ",
    meaning:
      "xem xét và xác định bằng phương pháp nghiệp vụ để đưa ra kết luận: giám định y khoa * giám định đồ cổ",
    example: "giám định y khoa * giám định đồ cổ",
  },
  {
    word: "giám đốc",
    part_of_speech: "danh từ",
    meaning:
      "người đứng đầu lãnh đạo một cơ quan, xí nghiệp, công ti, v.v.: giám đốc nhà máy * giám đốc Sở Giáo dục",
    example: "giám đốc nhà máy * giám đốc Sở Giáo dục",
  },
  {
    word: "giám hộ",
    part_of_speech: "",
    meaning:
      "người có tư cách pháp nhân, trông nom và bảo vệ quyền lợi của một người chưa thành niên hoặc người mắc một số bệnh dẫn đến không thể nhận thức hoặc làm chủ được hành vi của mình: một người có thể giám hộ cho nhiều người",
    example: "một người có thể giám hộ cho nhiều người",
  },
  {
    word: "giảm giá",
    part_of_speech: "động từ",
    meaning:
      "hạ thấp giá hàng trên thị trường so với trước; trái với tăng giá: hàng giảm giá",
    example: "hàng giảm giá",
  },
  {
    word: "giám hiệu",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) ban giám hiệu (nói tắt): giám hiệu nhà trường ra thông báo mới",
    example: "giám hiệu nhà trường ra thông báo mới",
  },
  {
    word: "giám khảo",
    part_of_speech: "danh từ",
    meaning: "người chấm thi: hội đồng giám khảo * làm giám khảo của cuộc thi",
    example: "hội đồng giám khảo * làm giám khảo của cuộc thi",
  },
  {
    word: "giam lỏng",
    part_of_speech: "động từ",
    meaning:
      "bắt phải ở trong một phạm vi nhất định, không cho tự do hoạt động, đi lại, để dễ theo dõi, kiểm soát: tù giam lỏng",
    example: "tù giam lỏng",
  },
  {
    word: "giam giữ",
    part_of_speech: "động từ",
    meaning: "giam một chỗ, không cho tự do (nói khái quát): giam giữ tù binh",
    example: "giam giữ tù binh",
  },
  {
    word: "giam hãm",
    part_of_speech: "động từ",
    meaning: "(hiếm) như giam giữ.",
    example: "lễ giáo phong kiến đã giam hãm người phụ nữ",
  },
  {
    word: "giám quản",
    part_of_speech: "động từ",
    meaning: "giám sát và quản lí: cục giám quản của Tổng cục hải quan",
    example: "cục giám quản của Tổng cục hải quan",
  },
  {
    word: "giám thị",
    part_of_speech: "động từ",
    meaning:
      "(cũ) luôn luôn nhìn ngó để giám sát: kẻ tình nghi bị giám thị chặt chẽ",
    example: "kẻ tình nghi bị giám thị chặt chẽ",
  },
  {
    word: "giám thị",
    part_of_speech: "danh từ",
    meaning:
      "người coi thi: mỗi phòng thi có hai giám thị * giám thị hành lang",
    example: "mỗi phòng thi có hai giám thị * giám thị hành lang",
  },
  {
    word: "giám sát",
    part_of_speech: "động từ",
    meaning:
      "theo dõi và kiểm tra việc thực hiện những điều đã quy định: giám sát việc thi hành hiệp định * giám sát thi công",
    example: "giám sát việc thi hành hiệp định * giám sát thi công",
  },
  {
    word: "giám sát",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) chức quan thời xưa, trông nom, coi sóc một loại công việc nhất định: làm giám sát ngự sử",
    example: "làm giám sát ngự sử",
  },
  {
    word: "giảm thiểu",
    part_of_speech: "động từ",
    meaning:
      "giảm đến mức thấp nhất (có thể được): giảm thiểu mọi khoản chi phí * giảm thiểu ô nhiễm",
    example: "giảm thiểu mọi khoản chi phí * giảm thiểu ô nhiễm",
  },
  {
    word: "giảm sút",
    part_of_speech: "động từ",
    meaning:
      "trở nên yếu kém dần đi: sức khoẻ ngày càng giảm sút * uy tín bị giảm sút",
    example: "sức khoẻ ngày càng giảm sút * uy tín bị giảm sút",
  },
  {
    word: "giãn",
    part_of_speech: "động từ",
    meaning:
      "tăng độ dài hoặc thể tích mà không thay đổi khối lượng: dây chun bị dãn",
    example: "dây chun bị dãn",
  },
  {
    word: "giãn",
    part_of_speech: "động từ",
    meaning:
      "trở lại trạng thái bình thường, không còn co lại, không còn căng thẳng nữa: dãn gân dãn cốt * các nếp nhăn trên mặt dãn ra",
    example: "dãn gân dãn cốt * các nếp nhăn trên mặt dãn ra",
  },
  {
    word: "giãn",
    part_of_speech: "động từ",
    meaning:
      "trở lại trạng thái không còn tập trung lại nữa, mà thưa ra: đám đông đứng dãn ra",
    example: "đám đông đứng dãn ra",
  },
  {
    word: "giãn",
    part_of_speech: "động từ",
    meaning:
      "thải bớt, đuổi bớt (công nhân): thiếu việc làm, xí nghiệp phải dãn thợ",
    example: "thiếu việc làm, xí nghiệp phải dãn thợ",
  },
  {
    word: "gian ác",
    part_of_speech: "tính từ",
    meaning: "gian giảo và độc ác: bọn địa chủ cường hào gian ác",
    example: "bọn địa chủ cường hào gian ác",
  },
  {
    word: "giàn",
    part_of_speech: "danh từ",
    meaning:
      "vật gồm nhiều thanh tre, nứa đan hay ghép lại với nhau, thường đặt nằm ngang trên cao, dùng cho cây leo: giàn nho * giàn mướp * bắc giàn cho bí",
    example: "giàn nho * giàn mướp * bắc giàn cho bí",
  },
  {
    word: "giàn",
    part_of_speech: "danh từ",
    meaning:
      "vật làm bằng nhiều thanh tre nứa kết với nhau, buộc nằm ngang sát tường vách, dùng để đồ lặt vặt trong nhà: đặt rá rau mới rửa lên giàn bếp",
    example: "đặt rá rau mới rửa lên giàn bếp",
  },
  {
    word: "giàn",
    part_of_speech: "danh từ",
    meaning:
      "vật dựng tạm bằng những tấm ván hoặc thanh tre ghép lại, có thể có nhiều tầng bậc, được kê, buộc vững chắc để làm chỗ đứng hoặc ngồi trên cao: làm việc trên giàn khoan",
    example: "làm việc trên giàn khoan",
  },
  {
    word: "giàn",
    part_of_speech: "danh từ",
    meaning:
      "hệ thống các thanh vật liệu cứng gắn với nhau thành một khối vững chắc, hình mạng lưới, dùng để đỡ vật rất nặng: giàn tên lửa",
    example: "giàn tên lửa",
  },
  {
    word: "giản dị",
    part_of_speech: "tính từ",
    meaning:
      "đơn giản một cách tự nhiên, trong phong cách sống: ăn mặc giản dị * cuộc sống giản dị",
    example: "ăn mặc giản dị * cuộc sống giản dị",
  },
  {
    word: "giản dị",
    part_of_speech: "tính từ",
    meaning: "dễ hiểu, không có gì rắc rối: cách nói giản dị, chân tình",
    example: "cách nói giản dị, chân tình",
  },
  {
    word: "gián cách",
    part_of_speech: "danh từ",
    meaning:
      "khoảng cách theo chiều ngang: dàn hàng ngang theo gián cách một cánh tay * giữ đúng cự li gián cách",
    example:
      "dàn hàng ngang theo gián cách một cánh tay * giữ đúng cự li gián cách",
  },
  {
    word: "gián",
    part_of_speech: "danh từ",
    meaning:
      "bọ thân dẹp, râu dài, cánh mỏng màu nâu, có mùi hôi, sống ở nơi tối và ẩm: quyển sách bị gián nhấm",
    example: "quyển sách bị gián nhấm",
  },
  {
    word: "gian",
    part_of_speech: "danh từ",
    meaning:
      "phần trong nhà giới hạn bằng hàng cột hay bức tường, vách ngăn: nhà ngói năm gian",
    example: "nhà ngói năm gian",
  },
  {
    word: "gian",
    part_of_speech: "danh từ",
    meaning:
      "từ chỉ từng đơn vị nhỏ được ngăn riêng ra tương đối độc lập trong một ngôi nhà: đi vào gian bếp * gian buồng",
    example: "đi vào gian bếp * gian buồng",
  },
  {
    word: "gian",
    part_of_speech: "tính từ",
    meaning:
      "có ý dối trá, lừa lọc để thực hiện hoặc che giấu việc làm bất lương: kẻ gian lẻn vào nhà * trông mặt rất gian * khai gian",
    example: "kẻ gian lẻn vào nhà * trông mặt rất gian * khai gian",
  },
  {
    word: "gian",
    part_of_speech: "danh từ",
    meaning: "kẻ lén lút làm những việc bất lương: giết giặc trừ gian",
    example: "giết giặc trừ gian",
  },
  {
    word: "gian dâm",
    part_of_speech: "động từ",
    meaning:
      "có quan hệ nam nữ về xác thịt bất chính với một người khác: tội gian dâm",
    example: "tội gian dâm",
  },
  {
    word: "giản đơn",
    part_of_speech: "tính từ",
    meaning:
      "như đơn giản (nhưng thường chỉ nói về các hiện tượng của đời sống xã hội): sống rất giản đơn * suy nghĩ còn giản đơn",
    example: "sống rất giản đơn * suy nghĩ còn giản đơn",
  },
  {
    word: "gián điệp",
    part_of_speech: "danh từ",
    meaning:
      "kẻ do địch cài vào để do thám tình hình và phá hoại: hoạt động gián điệp * một tên gián điệp nguy hiểm",
    example: "hoạt động gián điệp * một tên gián điệp nguy hiểm",
  },
  {
    word: "gian dối",
    part_of_speech: "tính từ",
    meaning:
      "có ý lừa lọc, không thật thà ngay thẳng: làm ăn gian dối * con người gian dối",
    example: "làm ăn gian dối * con người gian dối",
  },
  {
    word: "gián đoạn",
    part_of_speech: "động từ",
    meaning:
      "đứt quãng, không liên tục trong không gian, thời gian: công việc bị gián đoạn * tiếng thét làm cho dòng suy nghĩ bị gián đoạn",
    example:
      "công việc bị gián đoạn * tiếng thét làm cho dòng suy nghĩ bị gián đoạn",
  },
  {
    word: "gian hiểm",
    part_of_speech: "tính từ",
    meaning: "gian giảo và thâm hiểm: lòng dạ gian hiểm * mưu mô gian hiểm",
    example: "lòng dạ gian hiểm * mưu mô gian hiểm",
  },
  {
    word: "gian giảo",
    part_of_speech: "tính từ",
    meaning: "dối trá, lừa lọc (nói khái quát): làm ăn trí trá, gian giảo",
    example: "làm ăn trí trá, gian giảo",
  },
  {
    word: "gian giảo",
    part_of_speech: "tính từ",
    meaning: "tỏ ra rất gian: đôi mắt gian giảo * nụ cười gian giảo",
    example: "đôi mắt gian giảo * nụ cười gian giảo",
  },
  {
    word: "giàn giụa",
    part_of_speech: "động từ",
    meaning:
      "(nước mắt) chảy tràn ra nhiều và không cầm giữ nổi: nước mắt giàn giụa",
    example: "nước mắt giàn giụa",
  },
  {
    word: "gian hàng",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị căn nhà nhỏ làm nơi bày hàng bán ở trong chợ hoặc cửa hàng lớn: cả chợ chỉ có mấy gian hàng lụp xụp",
    example: "cả chợ chỉ có mấy gian hàng lụp xụp",
  },
  {
    word: "gian hàng",
    part_of_speech: "danh từ",
    meaning:
      "khu vực bày hàng của từng đơn vị trong hội chợ hoặc triển lãm: gian hàng thực phẩm * gian hàng Việt Nam tại hội chợ quốc tế",
    example: "gian hàng thực phẩm * gian hàng Việt Nam tại hội chợ quốc tế",
  },
  {
    word: "gian khó",
    part_of_speech: "",
    meaning:
      "những nỗi khó khăn gian khổ (nói khái quát): giúp đỡ nhau lúc gian khó * thời buổi gian khó",
    example: "giúp đỡ nhau lúc gian khó * thời buổi gian khó",
  },
  {
    word: "giàn giáo",
    part_of_speech: "danh từ",
    meaning:
      "giàn làm chỗ cho công nhân xây dựng đứng làm việc trên cao hoặc để chống đỡ bên dưới cốp pha: dựng giàn giáo * chuyển vôi vữa lên giàn giáo",
    example: "dựng giàn giáo * chuyển vôi vữa lên giàn giáo",
  },
  {
    word: "gian hùng",
    part_of_speech: "tính từ",
    meaning:
      "có tham vọng lớn và bất chấp mọi thủ đoạn mưu mô để thực hiện tham vọng của mình: kẻ gian hùng * thủ đoạn gian hùng",
    example: "kẻ gian hùng * thủ đoạn gian hùng",
  },
  {
    word: "giàn hoả",
    part_of_speech: "danh từ",
    meaning: "giàn dựng lên để thiêu người: bị đưa lên giàn hoả",
    example: "bị đưa lên giàn hoả",
  },
  {
    word: "giản lược",
    part_of_speech: "tính từ",
    meaning: "(hiếm) đơn giản và sơ lược: trình bày một cách giản lược",
    example: "trình bày một cách giản lược",
  },
  {
    word: "gian lao",
    part_of_speech: "",
    meaning:
      "những nỗi vất vả, khó khăn (nói khái quát): cuộc sống gian lao * chịu nhiều gian lao, vất vả",
    example: "cuộc sống gian lao * chịu nhiều gian lao, vất vả",
  },
  {
    word: "gian lậu",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như gian lận: buôn bán gian lậu",
    example: "buôn bán gian lậu",
  },
  {
    word: "gian lận",
    part_of_speech: "tính từ",
    meaning:
      "có hành vi dối trá, lừa lọc: gian lận trong thi cử * gian lận về tài chính",
    example: "gian lận trong thi cử * gian lận về tài chính",
  },
  {
    word: "gian khổ",
    part_of_speech: "",
    meaning:
      "gian nan, vất vả và khổ cực: chịu đựng gian khổ * cuộc kháng chiến gian khổ",
    example: "chịu đựng gian khổ * cuộc kháng chiến gian khổ",
  },
  {
    word: "gian phi",
    part_of_speech: "danh từ",
    meaning:
      "kẻ gian chuyên làm việc phi pháp: phòng kẻ gian phi * quân gian phi",
    example: "phòng kẻ gian phi * quân gian phi",
  },
  {
    word: "gian phu",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người đàn ông thông dâm với người đàn bà đã có chồng: kẻ gian phu",
    example: "kẻ gian phu",
  },
  {
    word: "gian nan",
    part_of_speech: "",
    meaning:
      "có nhiều khó khăn gian khổ phải vượt qua: tình cảnh gian nan * lửa thử vàng gian nan thử sức (tng)",
    example: "tình cảnh gian nan * lửa thử vàng gian nan thử sức (tng)",
  },
  {
    word: "gian ngoan",
    part_of_speech: "tính từ",
    meaning: "gian giảo với nhiều mánh khoé khôn khéo: kẻ gian ngoan",
    example: "kẻ gian ngoan",
  },
  {
    word: "gian nguy",
    part_of_speech: "",
    meaning: "khó khăn và nguy hiểm: bước đường gian nguy",
    example: "bước đường gian nguy",
  },
  {
    word: "gian tế",
    part_of_speech: "danh từ",
    meaning: "kẻ đi do thám thực hiện mưu gian: bắt được một tên gian tế",
    example: "bắt được một tên gian tế",
  },
  {
    word: "gian tà",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều thủ đoạn gian dối để làm những việc bất chính: kẻ gian tà",
    example: "kẻ gian tà",
  },
  {
    word: "gian thương",
    part_of_speech: "danh từ",
    meaning:
      "kẻ buôn bán gian lận, trốn tránh pháp luật: thông đồng với gian thương để tiêu thụ hàng giả",
    example: "thông đồng với gian thương để tiêu thụ hàng giả",
  },
  {
    word: "giản tiện",
    part_of_speech: "tính từ",
    meaning: "đơn giản và tiện lợi: cách làm giản tiện",
    example: "cách làm giản tiện",
  },
  {
    word: "gian trá",
    part_of_speech: "tính từ",
    meaning:
      "dối trá, lừa đảo để làm việc bất lương: con người gian trá * thủ đoạn gian trá",
    example: "con người gian trá * thủ đoạn gian trá",
  },
  {
    word: "gian truân",
    part_of_speech: "",
    meaning:
      'ở trong cảnh ngộ gặp nhiều nỗi gian nan, vất vả: gặp bước gian truân * "Nghĩ mình mặt nước cánh bèo, Đã nhiều lưu lạc, lại nhiều gian truân." (TKiều)',
    example:
      'gặp bước gian truân * "Nghĩ mình mặt nước cánh bèo, Đã nhiều lưu lạc, lại nhiều gian truân." (TKiều)',
  },
  {
    word: "gián tiếp",
    part_of_speech: "tính từ",
    meaning:
      "không có quan hệ thẳng với đối tượng tiếp xúc mà phải qua khâu trung gian: dùng cách nói gián tiếp * gián tiếp chịu trách nhiệm",
    example: "dùng cách nói gián tiếp * gián tiếp chịu trách nhiệm",
  },
  {
    word: "gián thu",
    part_of_speech: "danh từ",
    meaning:
      "khoản tiền thuế mà người sản xuất và kinh doanh phải nộp, nhưng lại được tính vào giá hàng bán ra để thật ra là người mua phải trả; phân biệt với thuế trực thu: thuế giá trị gia tăng là một loại thuế gián thu",
    example: "thuế giá trị gia tăng là một loại thuế gián thu",
  },
  {
    word: "giản yếu",
    part_of_speech: "tính từ",
    meaning:
      "(cũ) có nội dung đơn giản, chỉ gồm những kiến thức cơ bản nhất: từ điển triết học giản yếu",
    example: "từ điển triết học giản yếu",
  },
  {
    word: "gian tham",
    part_of_speech: "tính từ",
    meaning: "gian giảo và tham lam: thói gian tham",
    example: "thói gian tham",
  },
  {
    word: "gian thần",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) kẻ bề tôi dối vua hại dân, làm hại những người trung nghĩa hoặc có âm mưu cướp đoạt ngôi vua: vạch tội gian thần",
    example: "vạch tội gian thần",
  },
  {
    word: "giản ước",
    part_of_speech: "động từ",
    meaning:
      "lược bỏ những phần có thể lược bỏ để làm cho có hình thức đơn giản hơn: giản ước phân số",
    example: "giản ước phân số",
  },
  {
    word: "gian xảo",
    part_of_speech: "tính từ",
    meaning: "như gian giảo: mánh khoé gian xảo",
    example: "mánh khoé gian xảo",
  },
  {
    word: "giảng",
    part_of_speech: "động từ",
    meaning:
      "trình bày kiến thức cặn kẽ cho người khác hiểu: cô giáo giảng bài * giảng nghĩa * giảng đạo",
    example: "cô giáo giảng bài * giảng nghĩa * giảng đạo",
  },
  {
    word: "giạng",
    part_of_speech: "động từ",
    meaning: "đưa rộng hai chân ra hai bên: ngồi giạng chân * đứng giạng háng",
    example: "ngồi giạng chân * đứng giạng háng",
  },
  {
    word: "giang biên",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) bờ sông, ven sông: "Vì ai cách trở giang biên, Cá sầu không lội, chim phiền không bay." (ca dao)',
    example:
      'Vì ai cách trở giang biên, Cá sầu không lội, chim phiền không bay." (ca dao)',
  },
  {
    word: "giàng",
    part_of_speech: "danh từ",
    meaning: "(cũ, hiếm) cung, ná: bắn giàng * giàng cao su",
    example: "bắn giàng * giàng cao su",
  },
  {
    word: "giàng",
    part_of_speech: "danh từ",
    meaning:
      "(thường viết hoa) thần tối cao, trời (theo cách gọi của một số dân tộc thiểu số ở Tây Nguyên): cúng giàng",
    example: "cúng giàng",
  },
  {
    word: "giáng",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) đánh mạnh từ trên xuống: bị một cú đánh như trời giáng * tai hoạ từ đâu giáng xuống (b)",
    example: "bị một cú đánh như trời giáng * tai hoạ từ đâu giáng xuống (b)",
  },
  {
    word: "giáng",
    part_of_speech: "động từ",
    meaning:
      "(Từ cũ, hoặc kng) hạ xuống cấp bậc, chức vụ thấp hơn: giáng chức * giáng xuống hai cấp",
    example: "giáng chức * giáng xuống hai cấp",
  },
  {
    word: "giáng",
    part_of_speech: "danh từ",
    meaning:
      "dấu '=' đặt trước nốt nhạc để biểu thị nốt nhạc được hạ thấp xuống nửa cung: dấu giáng * fa giáng",
    example: "dấu giáng * fa giáng",
  },
  {
    word: "giảng dạy",
    part_of_speech: "động từ",
    meaning:
      "giảng để truyền thụ tri thức (nói khái quát): đổi mới phương pháp giảng dạy * đồ dùng giảng dạy * cán bộ giảng dạy",
    example:
      "đổi mới phương pháp giảng dạy * đồ dùng giảng dạy * cán bộ giảng dạy",
  },
  {
    word: "giảng dụ",
    part_of_speech: "động từ",
    meaning:
      "(cũ, hiếm) giảng giải cho hiểu mà nghe theo, làm theo: giảng dụ cương thường, lễ nghĩa",
    example: "giảng dụ cương thường, lễ nghĩa",
  },
  {
    word: "giảng giải",
    part_of_speech: "động từ",
    meaning:
      "trình bày, cắt nghĩa cho hiểu thật rõ, cho hiểu tường tận: giảng giải ý nghĩa của câu châm ngôn * giảng giải điều hơn lẽ thiệt",
    example:
      "giảng giải ý nghĩa của câu châm ngôn * giảng giải điều hơn lẽ thiệt",
  },
  {
    word: "giáng hạ",
    part_of_speech: "động từ",
    meaning:
      "(thần linh) từ trên trời hiện xuống, theo tín ngưỡng dân gian: thiên lôi giáng hạ",
    example: "thiên lôi giáng hạ",
  },
  {
    word: "giảng hoà",
    part_of_speech: "động từ",
    meaning:
      "bàn bạc, thoả thuận để đi đến chấm dứt xung đột, chấm dứt tranh chấp: biết thua nên tìm cách giảng hoà",
    example: "biết thua nên tìm cách giảng hoà",
  },
  {
    word: "giáng hoạ",
    part_of_speech: "động từ",
    meaning:
      "(thần linh) bắt chịu tai hoạ, theo tín ngưỡng dân gian: bị trời giáng hoạ",
    example: "bị trời giáng hoạ",
  },
  {
    word: "giang hồ",
    part_of_speech: "danh từ",
    meaning:
      "sông và hồ (nói khái quát); dùng để chỉ cảnh sống nay đây mai đó một cách tự do, phóng túng: kiếp sống giang hồ * lưu lạc giang hồ",
    example: "kiếp sống giang hồ * lưu lạc giang hồ",
  },
  {
    word: "giang hồ",
    part_of_speech: "danh từ",
    meaning:
      "giới tội phạm, chuyên sống bằng nghề trộm cướp, đâm thuê chém mướn, bảo kê, v.v.: một đàn anh trong giới giang hồ * ân oán giang hồ",
    example: "một đàn anh trong giới giang hồ * ân oán giang hồ",
  },
  {
    word: "giáng sinh",
    part_of_speech: "động từ",
    meaning:
      "sinh xuống cõi đời, ra đời (thường nói về chúa Jesus): ngày lễ Chúa giáng sinh",
    example: "ngày lễ Chúa giáng sinh",
  },
  {
    word: "giáng phúc",
    part_of_speech: "động từ",
    meaning:
      "(thần linh) ban phúc cho, theo tín ngưỡng dân gian: cầu xin thần linh giáng phúc",
    example: "cầu xin thần linh giáng phúc",
  },
  {
    word: "giảng nghĩa",
    part_of_speech: "động từ",
    meaning:
      "nói rõ, giảng giải cho rõ ý nghĩa (của từ ngữ, câu văn, bài văn): giảng nghĩa một điển tích cổ",
    example: "giảng nghĩa một điển tích cổ",
  },
  {
    word: "giáng thế",
    part_of_speech: "động từ",
    meaning:
      "(từ trên cõi trời, cõi tiên) xuống cõi trần: Chúa giáng thế * tiên nga giáng thế",
    example: "Chúa giáng thế * tiên nga giáng thế",
  },
  {
    word: "giang sơn",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương) sông núi; thường dùng để chỉ đất đai thuộc chủ quyền của một nước: giang sơn gấm vóc * giang sơn thu về một mối",
    example: "giang sơn gấm vóc * giang sơn thu về một mối",
  },
  {
    word: "giang sơn",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) như cơ nghiệp: "Có con phải khổ vì con, Có chồng phải gánh giang sơn nhà chồng." (ca dao)',
    example:
      'Có con phải khổ vì con, Có chồng phải gánh giang sơn nhà chồng." (ca dao)',
  },
  {
    word: "giảng viên",
    part_of_speech: "danh từ",
    meaning:
      "người làm công tác giảng dạy ở các trường trên bậc phổ thông hoặc ở các lớp đào tạo, huấn luyện: giảng viên đại học",
    example: "giảng viên đại học",
  },
  {
    word: "giành",
    part_of_speech: "động từ",
    meaning:
      "cố dùng sức lực để đạt được, để lấy về được cho mình, không để bị chiếm mất hoặc tiếp tục chiếm mất: giành nhau miếng mồi * đấu tranh giành độc lập * giành giải nhất",
    example: "giành nhau miếng mồi * đấu tranh giành độc lập * giành giải nhất",
  },
  {
    word: "giành",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) tranh (làm việc gì): giành phần nói trước",
    example: "giành phần nói trước",
  },
  {
    word: "giao",
    part_of_speech: "động từ",
    meaning:
      "gặp nhau, cắt nhau ở một điểm, trên hai hướng khác nhau: hai đường thẳng giao nhau",
    example: "hai đường thẳng giao nhau",
  },
  {
    word: "giao",
    part_of_speech: "động từ",
    meaning:
      "đưa cho để nhận lấy và chịu trách nhiệm: giao nhiệm vụ * giao chìa khoá nhà * giao hàng",
    example: "giao nhiệm vụ * giao chìa khoá nhà * giao hàng",
  },
  {
    word: "giao",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) giao kèo, nói rõ trước khi làm việc gì: Tao giao trước là có gì xảy ra thì mày tự chịu.",
    example: "Tao giao trước là có gì xảy ra thì mày tự chịu.",
  },
  {
    word: "giao ban",
    part_of_speech: "động từ",
    meaning:
      "bàn giao nhiệm vụ cho người thuộc phiên làm việc tiếp theo: nhận giao ban * sổ giao ban",
    example: "nhận giao ban * sổ giao ban",
  },
  {
    word: "giao ban",
    part_of_speech: "động từ",
    meaning:
      "(cơ quan, tổ chức) xem xét, đánh giá việc đã làm và bàn việc sắp tới trong từng khoảng thời gian nhất định (thường là hằng tuần): các phòng đang họp giao ban",
    example: "các phòng đang họp giao ban",
  },
  {
    word: "giành giật",
    part_of_speech: "động từ",
    meaning:
      "tranh giành giằng co giữa các bên chống đối nhau: đàn thú giành giật miếng mồi",
    example: "đàn thú giành giật miếng mồi",
  },
  {
    word: "giáo",
    part_of_speech: "danh từ",
    meaning:
      "binh khí thời cổ, cán dài, mũi nhọn bằng sắt, dùng để đâm: mũi giáo * buông giáo đầu hàng",
    example: "mũi giáo * buông giáo đầu hàng",
  },
  {
    word: "giáo",
    part_of_speech: "danh từ",
    meaning:
      "hệ thống các thanh vật liệu cứng bắc lên cao để người đứng xây dựng công trình hoặc để chống đỡ bên dưới cốp pha: bắc giáo * thợ xây đang làm việc trên những tầng giáo",
    example: "bắc giáo * thợ xây đang làm việc trên những tầng giáo",
  },
  {
    word: "giáo",
    part_of_speech: "danh từ",
    meaning: "người làm nghề dạy học: nhà giáo * nghề giáo",
    example: "nhà giáo * nghề giáo",
  },
  {
    word: "giáo",
    part_of_speech: "danh từ",
    meaning:
      "người theo đạo Kitô (nói khái quát); phân biệt với lương: đoàn kết lương giáo",
    example: "đoàn kết lương giáo",
  },
  {
    word: "giáo",
    part_of_speech: "động từ",
    meaning: "quấy cho nhuyễn, cho đặc lại: giáo bột để làm bánh",
    example: "giáo bột để làm bánh",
  },
  {
    word: "giáo",
    part_of_speech: "động từ",
    meaning:
      "cho cơm nhão hoặc hồ vào sợi, vải rồi vò, đạp cho ngấm đều, để sợi được dai hơn: giáo sợi * giáo vải",
    example: "giáo sợi * giáo vải",
  },
  {
    word: "giáo",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) giáo đầu (nói tắt): hát giáo mấy câu",
    example: "hát giáo mấy câu",
  },
  {
    word: "giáo",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) nói gần nói xa về việc định làm để thăm dò sự phản ứng của người nghe: chỉ giáo lên thế thôi, chưa chắc đã dám làm",
    example: "chỉ giáo lên thế thôi, chưa chắc đã dám làm",
  },
  {
    word: "giao bóng",
    part_of_speech: "động từ",
    meaning:
      "đánh, đá quả bóng đầu tiên để mở đầu trận đấu, hiệp đấu: đội A được quyền giao bóng trước",
    example: "đội A được quyền giao bóng trước",
  },
  {
    word: "giao bưu",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) người chuyên làm công việc liên lạc, chuyển giao thư từ, công văn, v.v.: chiến sĩ giao bưu",
    example: "chiến sĩ giao bưu",
  },
  {
    word: "giao ca",
    part_of_speech: "động từ",
    meaning: "bàn giao nhiệm vụ cho ca làm sau: đến giờ chuẩn bị giao ca",
    example: "đến giờ chuẩn bị giao ca",
  },
  {
    word: "giáo án",
    part_of_speech: "danh từ",
    meaning: "bài soạn của giáo viên để lên lớp giảng dạy: chuẩn bị giáo án",
    example: "chuẩn bị giáo án",
  },
  {
    word: "giao cảm",
    part_of_speech: "động từ",
    meaning:
      "cảm thông với nhau, cùng có những cảm xúc tương tự như nhau: có sự giao cảm, đồng điệu giữa hai tâm hồn",
    example: "có sự giao cảm, đồng điệu giữa hai tâm hồn",
  },
  {
    word: "giao chiến",
    part_of_speech: "động từ",
    meaning: "đánh nhau giữa các lực lượng đối địch: hai bên giao chiến",
    example: "hai bên giao chiến",
  },
  {
    word: "giáo chủ",
    part_of_speech: "danh từ",
    meaning:
      "người sáng lập ra một tôn giáo: Thích Ca Mâu Ni là giáo chủ đạo Phật",
    example: "Thích Ca Mâu Ni là giáo chủ đạo Phật",
  },
  {
    word: "giáo chủ",
    part_of_speech: "danh từ",
    meaning:
      "người đứng đầu một tôn giáo hay một giáo phái: giáo chủ đạo Cao Đài * giáo chủ Hồi giáo",
    example: "giáo chủ đạo Cao Đài * giáo chủ Hồi giáo",
  },
  {
    word: "giáo chủ",
    part_of_speech: "danh từ",
    meaning:
      "chức trong giáo hội Công giáo, trên giám mục, dưới giáo hoàng: đức giáo chủ * hồng y giáo chủ",
    example: "đức giáo chủ * hồng y giáo chủ",
  },
  {
    word: "giáo cụ",
    part_of_speech: "danh từ",
    meaning: "đồ dùng dạy học: đầu tư mua sắm giáo cụ",
    example: "đầu tư mua sắm giáo cụ",
  },
  {
    word: "giáo cụ trực quan",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng dạy học để làm cho học sinh thấy một cách cụ thể điều muốn giảng: bản đồ, mô hình, v.v. là những giáo cụ trực quan",
    example: "bản đồ, mô hình, v.v. là những giáo cụ trực quan",
  },
  {
    word: "giao cắt",
    part_of_speech: "động từ",
    meaning:
      "giao nhau, cắt ngang qua nhau: điểm giao cắt giữa đường sắt và đường bộ",
    example: "điểm giao cắt giữa đường sắt và đường bộ",
  },
  {
    word: "giao du",
    part_of_speech: "động từ",
    meaning:
      "đi lại, có quan hệ bạn bè, quen biết với nhau: giao du với nhiều hạng người",
    example: "giao du với nhiều hạng người",
  },
  {
    word: "giao diện",
    part_of_speech: "danh từ",
    meaning:
      "hình thức thể hiện của chương trình máy tính, theo đó người sử dụng có thể tác động tới chương trình, giúp cho việc trao đổi thông tin được thực hiện: giao diện của chương trình",
    example: "giao diện của chương trình",
  },
  {
    word: "giáo dục",
    part_of_speech: "động từ",
    meaning:
      "hoạt động nhằm tác động một cách có hệ thống đến sự phát triển tinh thần, thể chất của một đối tượng nào đó, làm cho đối tượng ấy dần dần có được những phẩm chất và năng lực như yêu cầu đề ra: giáo dục thiếu niên nhi đồng * giáo dục con cái",
    example: "giáo dục thiếu niên nhi đồng * giáo dục con cái",
  },
  {
    word: "giáo dục",
    part_of_speech: "danh từ",
    meaning:
      "hệ thống các biện pháp và cơ quan giảng dạy - giáo dục của một nước: phát triển nền giáo dục * cải cách giáo dục",
    example: "phát triển nền giáo dục * cải cách giáo dục",
  },
  {
    word: "giao duyên",
    part_of_speech: "động từ",
    meaning:
      '(hai bên trai gái) trao đổi tình cảm với nhau trong ngày hội: khúc hát giao duyên * "Vàng tìm vàng làm bạn, Ngọc tìm ngọc giao duyên." (MPXH)',
    example:
      'khúc hát giao duyên * "Vàng tìm vàng làm bạn, Ngọc tìm ngọc giao duyên." (MPXH)',
  },
  {
    word: "giao dịch",
    part_of_speech: "động từ",
    meaning:
      "liên hệ gặp gỡ, tiếp xúc với nhau (thường là về công việc): giao dịch với khách hàng * giao dịch qua điện thoại",
    example: "giao dịch với khách hàng * giao dịch qua điện thoại",
  },
  {
    word: "giao đãi",
    part_of_speech: "",
    meaning:
      "giới thiệu nhân vật và sự kiện để mở đầu, chuẩn bị cho phần chính của một vở kịch: giao đãi dài dòng * nói những lời giao đãi",
    example: "giao đãi dài dòng * nói những lời giao đãi",
  },
  {
    word: "giáo dưỡng",
    part_of_speech: "động từ",
    meaning:
      "trau dồi tri thức cần thiết và bồi dưỡng kĩ năng một cách có hệ thống (cho học sinh)..",
    example: "đưa vào trường giáo dưỡng * hết thời hạn giáo dưỡng",
  },
  {
    word: "giao đấu",
    part_of_speech: "động từ",
    meaning:
      "(hai đối thủ) đọ sức, đọ tài để phân rõ hơn thua: cuộc giao đấu quyết liệt",
    example: "cuộc giao đấu quyết liệt",
  },
  {
    word: "giao đấu",
    part_of_speech: "động từ",
    meaning: "thi đấu thể thao: hai đội bóng bắt đầu ra sân giao đấu",
    example: "hai đội bóng bắt đầu ra sân giao đấu",
  },
  {
    word: "giáo điều",
    part_of_speech: "danh từ",
    meaning:
      "luận điểm cơ bản của một tôn giáo, được các tín đồ tin theo một cách tuyệt đối: tam cương, ngũ thường là giáo điều của đạo nho",
    example: "tam cương, ngũ thường là giáo điều của đạo nho",
  },
  {
    word: "giáo điều",
    part_of_speech: "danh từ",
    meaning:
      "luận điểm được công nhận mà không chứng minh, coi là chân lí bất di bất dịch: lí luận cách mạng không phải là giáo điều",
    example: "lí luận cách mạng không phải là giáo điều",
  },
  {
    word: "giáo điều",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về chủ nghĩa giáo điều, có tính chất của chủ nghĩa giáo điều: bệnh giáo điều",
    example: "bệnh giáo điều",
  },
  {
    word: "giáo đồ",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như tín đồ: giáo đồ Công giáo",
    example: "giáo đồ Công giáo",
  },
  {
    word: "giáo đầu",
    part_of_speech: "động từ",
    meaning:
      "hát hoặc nói mở đầu để chúc tụng người xem và giới thiệu tích truyện trước khi diễn vở ca kịch dân tộc cổ truyền (tuồng, chèo): hát giáo đầu",
    example: "hát giáo đầu",
  },
  {
    word: "giáo đầu",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) mở đầu, dạo đầu (trước khi đi vào phần chính, phần chủ yếu): nói luôn vào vấn đề đi, cứ giáo đầu mãi!",
    example: "nói luôn vào vấn đề đi, cứ giáo đầu mãi!",
  },
  {
    word: "giao hảo",
    part_of_speech: "động từ",
    meaning:
      "có quan hệ tốt với nhau (giữa các nước, các cộng đồng người): giữ gìn mối giao hảo bền vững giữa hai dân tộc",
    example: "giữ gìn mối giao hảo bền vững giữa hai dân tộc",
  },
  {
    word: "giao hẹn",
    part_of_speech: "động từ",
    meaning:
      "nêu rõ điều kiện đặt ra với người nào đó trước khi làm việc gì: giao hẹn sẽ có mặt lúc 10 giờ",
    example: "giao hẹn sẽ có mặt lúc 10 giờ",
  },
  {
    word: "giao hoà",
    part_of_speech: "động từ",
    meaning:
      "(cũ, văn chương) có quan hệ hoà hợp, êm đẹp với nhau: mối giao hoà * hai bên giao hoà với nhau",
    example: "mối giao hoà * hai bên giao hoà với nhau",
  },
  {
    word: "giao hoà",
    part_of_speech: "động từ",
    meaning:
      'ăn ở chung, thành vợ chồng: "Ước gì chàng thiếp giao hoà, Chăn bông, gối đệm, giường ngà, chiếu thau." (ca dao)',
    example:
      'Ước gì chàng thiếp giao hoà, Chăn bông, gối đệm, giường ngà, chiếu thau." (ca dao)',
  },
  {
    word: "giao hoan",
    part_of_speech: "động từ",
    meaning:
      '(văn chương, hiếm) cùng vui với nhau: "Thêm nến giá, nối hương bình, Cùng nhau lại chuốc chén quỳnh giao hoan." (TKiều)',
    example:
      'Thêm nến giá, nối hương bình, Cùng nhau lại chuốc chén quỳnh giao hoan." (TKiều)',
  },
  {
    word: "giao hội",
    part_of_speech: "động từ",
    meaning: "(hiếm) như tụ hội..",
    example: "giao hội mục tiêu",
  },
  {
    word: "giảo hoạt",
    part_of_speech: "tính từ",
    meaning:
      "hay dối trá, lừa lọc người khác một cách khó lường: con người giảo hoạt",
    example: "con người giảo hoạt",
  },
  {
    word: "giáo hội",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức bao gồm toàn thể các thành viên của một tôn giáo, hoạt động theo một nguyên tắc nhất định, có hệ thống tổ chức từ trung ương đến địa phương: giáo hội Phật giáo",
    example: "giáo hội Phật giáo",
  },
  {
    word: "giao kèo",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, hoặc kng) như hợp đồng: kí giao kèo * làm theo đúng giao kèo",
    example: "kí giao kèo * làm theo đúng giao kèo",
  },
  {
    word: "giao kèo",
    part_of_speech: "động từ",
    meaning: "(cũ, hoặc kng) cam kết với nhau: hai bên giao kèo với nhau",
    example: "hai bên giao kèo với nhau",
  },
  {
    word: "giao hưởng",
    part_of_speech: "danh từ",
    meaning:
      "bản hoà tấu lớn, tận dụng sự phong phú đa dạng về hoà thanh, âm sắc, độ vang của nhiều nhạc khí, thường gồm bốn chương tương phản nhưng gắn bó hữu cơ: nhạc giao hưởng * bản giao hưởng của Beethoven",
    example: "nhạc giao hưởng * bản giao hưởng của Beethoven",
  },
  {
    word: "giáo huấn",
    part_of_speech: "",
    meaning: "(trang trọng, hiếm) dạy bảo điều hay lẽ phải: nghe lời giáo huấn",
    example: "nghe lời giáo huấn",
  },
  {
    word: "giáo lí",
    part_of_speech: "danh từ",
    meaning:
      "lí luận, học thuyết của một tôn giáo: giáo lí đạo Phật * nhà sư giảng giáo lí",
    example: "giáo lí đạo Phật * nhà sư giảng giáo lí",
  },
  {
    word: "giao khoán",
    part_of_speech: "động từ",
    meaning:
      "giao việc sản xuất theo phương thức khoán: giao khoán ruộng cho từng hộ nông dân",
    example: "giao khoán ruộng cho từng hộ nông dân",
  },
  {
    word: "giao liên",
    part_of_speech: "",
    meaning:
      "(người) chuyên làm liên lạc và dẫn đường qua vùng địch hoặc gần vùng địch: giao liên dẫn đường cho bộ đội",
    example: "giao liên dẫn đường cho bộ đội",
  },
  {
    word: "giao hữu",
    part_of_speech: "tính từ",
    meaning:
      "(cuộc đấu thể thao) nhằm thắt chặt quan hệ hữu nghị, không nhằm tranh giải: trận bóng đá giao hữu",
    example: "trận bóng đá giao hữu",
  },
  {
    word: "giao lưu",
    part_of_speech: "",
    meaning:
      "có sự tiếp xúc và trao đổi qua lại giữa hai dòng, hai luồng khác nhau: giao lưu văn hoá * buổi giao lưu giữa nhà văn và bạn đọc",
    example: "giao lưu văn hoá * buổi giao lưu giữa nhà văn và bạn đọc",
  },
  {
    word: "giao lộ",
    part_of_speech: "danh từ",
    meaning:
      "chỗ cắt nhau của các đường giao thông trên bộ: tại các giao lộ đều có đèn tín hiệu giao thông",
    example: "tại các giao lộ đều có đèn tín hiệu giao thông",
  },
  {
    word: "giáo khoa",
    part_of_speech: "tính từ",
    meaning: "thuộc về các môn dạy ở trường học: sách giáo khoa",
    example: "sách giáo khoa",
  },
  {
    word: "giao kết",
    part_of_speech: "động từ",
    meaning:
      '(hiếm) như kết giao: "Thà đừng giao kết buổi đầu, Để nay bịn rịn, kẻ sầu người thương." (ca dao)',
    example:
      'Thà đừng giao kết buổi đầu, Để nay bịn rịn, kẻ sầu người thương." (ca dao)',
  },
  {
    word: "giao kết",
    part_of_speech: "động từ",
    meaning: "cam kết thực hiện: giao kết làm đúng hợp đồng",
    example: "giao kết làm đúng hợp đồng",
  },
  {
    word: "giáo lý",
    part_of_speech: "danh từ",
    meaning:
      "lí luận, học thuyết của một tôn giáo: giáo lí đạo Phật * nhà sư giảng giáo lí",
    example: "giáo lí đạo Phật * nhà sư giảng giáo lí",
  },
  {
    word: "giao nhận",
    part_of_speech: "động từ",
    meaning:
      "giao và nhận tài sản, hàng hoá, v.v. giữa hai bên (nói khái quát): làm các thủ tục giao nhận hàng",
    example: "làm các thủ tục giao nhận hàng",
  },
  {
    word: "giáo mác",
    part_of_speech: "danh từ",
    meaning:
      "giáo và mác (nói khái quát); binh khí thời xưa: giáo mác tua tủa * mang cung tên và giáo mác ra trận",
    example: "giáo mác tua tủa * mang cung tên và giáo mác ra trận",
  },
  {
    word: "giáo phái",
    part_of_speech: "danh từ",
    meaning:
      "môn phái của một tôn giáo: giải quyết mâu thuẫn giữa các giáo phái",
    example: "giải quyết mâu thuẫn giữa các giáo phái",
  },
  {
    word: "giáo phẩm",
    part_of_speech: "danh từ",
    meaning: "chức sắc trong một tôn giáo: giáo phẩm Việt Nam",
    example: "giáo phẩm Việt Nam",
  },
  {
    word: "giao phó",
    part_of_speech: "động từ",
    meaning:
      "giao cho cái quan trọng với lòng tin tưởng vào người nhận: giao phó trách nhiệm * giao phó mọi việc trong nhà cho vợ",
    example: "giao phó trách nhiệm * giao phó mọi việc trong nhà cho vợ",
  },
  {
    word: "giảo quyệt",
    part_of_speech: "tính từ",
    meaning: "như xảo quyệt: thủ đoạn giảo quyệt",
    example: "thủ đoạn giảo quyệt",
  },
  {
    word: "giao nộp",
    part_of_speech: "động từ",
    meaning:
      "nộp cho người, cơ quan có trách nhiệm thu giữ: giao nộp sản phẩm * giao nộp vũ khí tàng trữ trái phép cho cơ quan chức năng",
    example:
      "giao nộp sản phẩm * giao nộp vũ khí tàng trữ trái phép cho cơ quan chức năng",
  },
  {
    word: "giao thoa",
    part_of_speech: "động từ",
    meaning:
      "(hiện tượng hai hay nhiều sóng cùng tần số) tăng cường hay làm yếu lẫn nhau khi gặp nhau tại cùng một điểm: hiện tượng giao thoa của ánh sáng * vòng sóng giao thoa",
    example: "hiện tượng giao thoa của ánh sáng * vòng sóng giao thoa",
  },
  {
    word: "giao thiệp",
    part_of_speech: "động từ",
    meaning:
      "tiếp xúc, có quan hệ xã hội với người nào đó (thường là trong công việc làm ăn): ít giao thiệp * biết cách giao thiệp",
    example: "ít giao thiệp * biết cách giao thiệp",
  },
  {
    word: "giáo sư",
    part_of_speech: "danh từ",
    meaning:
      "học hàm cao nhất phong cho cán bộ có trình độ cao trong giảng dạy, nghiên cứu và phát triển khoa học: giáo sư sử học * được phong học hàm giáo sư",
    example: "giáo sư sử học * được phong học hàm giáo sư",
  },
  {
    word: "giáo sư",
    part_of_speech: "danh từ",
    meaning:
      "người được nhận học hàm giáo sư: vị giáo sư * mời giáo sư lên phát biểu",
    example: "vị giáo sư * mời giáo sư lên phát biểu",
  },
  {
    word: "giao thông",
    part_of_speech: "danh từ",
    meaning:
      "việc đi lại từ nơi này đến nơi khác của người và phương tiện chuyên chở: ách tắc giao thông * giao thông đường bộ",
    example: "ách tắc giao thông * giao thông đường bộ",
  },
  {
    word: "giao thông",
    part_of_speech: "danh từ",
    meaning: "(cũ) như liên lạc: làm giao thông",
    example: "làm giao thông",
  },
  {
    word: "giáo thụ",
    part_of_speech: "danh từ",
    meaning: "(cũ) chức quan trông coi việc học trong một phủ: quan giáo thụ",
    example: "quan giáo thụ",
  },
  {
    word: "giao thương",
    part_of_speech: "động từ",
    meaning:
      "giao lưu buôn bán, nói chung: mở rộng quan hệ giao thương với các nước láng giềng",
    example: "mở rộng quan hệ giao thương với các nước láng giềng",
  },
  {
    word: "giao thời",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian chuyển tiếp từ thời kì này sang thời kì khác, là lúc cái mới cái cũ xen lẫn nhau, thường có mâu thuẫn, xung đột, chưa ổn định: buổi giao thời * văn học giao thời",
    example: "buổi giao thời * văn học giao thời",
  },
  {
    word: "giao thừa",
    part_of_speech: "danh từ",
    meaning:
      "lúc năm cũ (âm lịch) qua, năm mới đến, tức 12 giờ đêm ba mươi Tết: đêm giao thừa * thức để đón giao thừa * phong tục cúng giao thừa",
    example: "đêm giao thừa * thức để đón giao thừa * phong tục cúng giao thừa",
  },
  {
    word: "giao thức",
    part_of_speech: "danh từ",
    meaning:
      "cách thức để trao đổi thông tin giữa các máy tính: giao thức trao đổi dữ liệu * giao thức truyền tập tin",
    example: "giao thức trao đổi dữ liệu * giao thức truyền tập tin",
  },
  {
    word: "giao tiếp",
    part_of_speech: "động từ",
    meaning:
      "trao đổi, tiếp xúc với nhau: ngôn ngữ là công cụ giao tiếp * biết cách giao tiếp",
    example: "ngôn ngữ là công cụ giao tiếp * biết cách giao tiếp",
  },
  {
    word: "giao tình",
    part_of_speech: "động từ",
    meaning:
      '(cũ, hiếm) kết bạn, gắn bó với nhau: "Anh em tứ hải giao tình, Tuy rằng bốn bể nhưng sinh một nhà." (ca dao)',
    example:
      'Anh em tứ hải giao tình, Tuy rằng bốn bể nhưng sinh một nhà." (ca dao)',
  },
  {
    word: "giao tuyến",
    part_of_speech: "danh từ",
    meaning:
      "đường gặp nhau của hai hay nhiều mặt: giao tuyến của hai mặt phẳng là một đường thẳng",
    example: "giao tuyến của hai mặt phẳng là một đường thẳng",
  },
  {
    word: "giao tranh",
    part_of_speech: "động từ",
    meaning:
      "(các lực lượng vũ trang) đánh nhau để phân thắng bại: thời kì Trịnh - Nguyễn giao tranh",
    example: "thời kì Trịnh - Nguyễn giao tranh",
  },
  {
    word: "giao tranh",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) thi đấu giữa hai đội thể thao: cuộc giao tranh trên sân cỏ",
    example: "cuộc giao tranh trên sân cỏ",
  },
  {
    word: "giáo trình",
    part_of_speech: "danh từ",
    meaning:
      "hệ thống những bài giảng về một bộ môn khoa học, kĩ thuật, thường dùng cho việc giảng dạy ở bậc đại học: giáo trình triết học * soạn giáo trình",
    example: "giáo trình triết học * soạn giáo trình",
  },
  {
    word: "giáo vụ",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận trông nom việc giảng dạy và học tập trong một trường, một khoa: phòng giáo vụ * làm trợ lí giáo vụ",
    example: "phòng giáo vụ * làm trợ lí giáo vụ",
  },
  {
    word: "giao ước",
    part_of_speech: "",
    meaning:
      'cam kết với nhau về những điều mỗi bên sẽ làm: lời giao ước * "Nghìn năm giao ước kết đôi, Non non nước nước không nguôi lời thề." (TĐà; 7)',
    example:
      'lời giao ước * "Nghìn năm giao ước kết đôi, Non non nước nước không nguôi lời thề." (TĐà; 7)',
  },
  {
    word: "giáo viên",
    part_of_speech: "danh từ",
    meaning:
      "người dạy học ở bậc phổ thông hoặc tương đương: giáo viên tiểu học * giáo viên chủ nhiệm",
    example: "giáo viên tiểu học * giáo viên chủ nhiệm",
  },
  {
    word: "giáp",
    part_of_speech: "danh từ",
    meaning:
      "vỏ cứng bọc ngoài để che chở cơ thể một số động vật như tôm, cua, v.v..",
    example: "cởi giáp quy hàng",
  },
  {
    word: "giáp",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian mười hai năm, là chu kì trở lại của mười hai chi, trong phép đếm năm theo âm lịch cổ truyền: cùng tuổi Mùi nhưng chênh nhau một giáp",
    example: "cùng tuổi Mùi nhưng chênh nhau một giáp",
  },
  {
    word: "giáp",
    part_of_speech: "động từ",
    meaning:
      "sát với nhau, hết phạm vi của cái này là đến ngay phạm vi của cái kia: hai nhà giáp tường nhau * vùng biên giới giáp Lào * những ngày giáp Tết",
    example:
      "hai nhà giáp tường nhau * vùng biên giới giáp Lào * những ngày giáp Tết",
  },
  {
    word: "giáp",
    part_of_speech: "động từ",
    meaning:
      "có các đầu mối gặp nhau, tiếp xúc với nhau: chỗ giáp mối hàn * may giáp vào nhau",
    example: "chỗ giáp mối hàn * may giáp vào nhau",
  },
  {
    word: "giáp chiến",
    part_of_speech: "động từ",
    meaning: "đánh giáp mặt nhau: hai bên xông vào giáp chiến",
    example: "hai bên xông vào giáp chiến",
  },
  {
    word: "giáp giới",
    part_of_speech: "động từ",
    meaning: "có chung một địa giới: chỗ giáp giới giữa hai tỉnh",
    example: "chỗ giáp giới giữa hai tỉnh",
  },
  {
    word: "giáp công",
    part_of_speech: "động từ",
    meaning:
      "đánh thẳng vào mục tiêu từ nhiều phía cùng một lúc: ba mũi giáp công tiêu diệt địch",
    example: "ba mũi giáp công tiêu diệt địch",
  },
  {
    word: "giáp lai",
    part_of_speech: "tính từ",
    meaning:
      "(dấu đóng) ở chỗ tiếp nối giữa hai tờ giấy đóng liền nhau trong sổ sách hoặc tập tài liệu, giấy tờ, v.v. để bảo đảm không bị thay đổi: đóng dấu giáp lai vào ảnh",
    example: "đóng dấu giáp lai vào ảnh",
  },
  {
    word: "giáp hạt",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian lương thực thu hoạch được của vụ cũ đã cạn, nhưng chưa đến vụ thu hoạch mới; thường chỉ lúc đói kém do chưa đến vụ: lúc giáp hạt * đói giáp hạt",
    example: "lúc giáp hạt * đói giáp hạt",
  },
  {
    word: "giáp mặt",
    part_of_speech: "động từ",
    meaning:
      'gặp nhau, tiếp xúc trực tiếp với nhau: tránh giáp mặt nhau * "Tiếng nhạc ngựa lần chen tiếng trống, Giáp mặt rồi phút bỗng chia tay." (CPN)',
    example:
      'tránh giáp mặt nhau * "Tiếng nhạc ngựa lần chen tiếng trống, Giáp mặt rồi phút bỗng chia tay." (CPN)',
  },
  {
    word: "giáp lá cà",
    part_of_speech: "động từ",
    meaning:
      "đánh gần bằng báng súng, lưỡi lê, dao găm, gươm giáo, gậy gộc, v.v., hoặc bằng tay không: hai bên xông vào đánh giáp lá cà",
    example: "hai bên xông vào đánh giáp lá cà",
  },
  {
    word: "giáp trận",
    part_of_speech: "động từ",
    meaning: "ra trận đánh nhau giáp mặt với quân địch: hai bên vừa giáp trận",
    example: "hai bên vừa giáp trận",
  },
  {
    word: "giáp vụ",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian vụ thu hoạch trước đã qua, nhưng chưa đến vụ thu hoạch mới: sắp đến thời điểm giáp vụ",
    example: "sắp đến thời điểm giáp vụ",
  },
  {
    word: "giáp ranh",
    part_of_speech: "tính từ",
    meaning:
      "có chung một ranh giới, ở liền sát nhau: khu vực giáp ranh giữa hai xã * giáp ranh giữa trung du với đồng bằng",
    example:
      "khu vực giáp ranh giữa hai xã * giáp ranh giữa trung du với đồng bằng",
  },
  {
    word: "giát",
    part_of_speech: "danh từ",
    meaning:
      "vật hình tấm làm bằng nhiều thanh tre, gỗ ghép thưa với nhau: giát giường * giường bị gẫy giát",
    example: "giát giường * giường bị gẫy giát",
  },
  {
    word: "giạt",
    part_of_speech: "động từ",
    meaning:
      "bị xô đẩy về một phía, một nơi nào đó: bèo dạt mây trôi * đám người chạy dạt ra hai bên đường",
    example: "bèo dạt mây trôi * đám người chạy dạt ra hai bên đường",
  },
  {
    word: "giạt",
    part_of_speech: "động từ",
    meaning: "dãn thưa ra (thường nói về sợi của hàng dệt): mặt vải đã bị dạt",
    example: "mặt vải đã bị dạt",
  },
  {
    word: "giàu",
    part_of_speech: "tính từ",
    meaning: "có nhiều tiền của: dân giàu nước mạnh * kẻ giàu người nghèo",
    example: "dân giàu nước mạnh * kẻ giàu người nghèo",
  },
  {
    word: "giàu",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều hơn mức bình thường (cái có giá trị về vật chất hoặc tinh thần): thức ăn giàu chất đạm * giàu kinh nghiệm * giàu tình cảm và nghị lực",
    example:
      "thức ăn giàu chất đạm * giàu kinh nghiệm * giàu tình cảm và nghị lực",
  },
  {
    word: "giàu sụ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) rất giàu, có khối lượng tài sản lớn: một nhà buôn giàu sụ",
    example: "một nhà buôn giàu sụ",
  },
  {
    word: "giày",
    part_of_speech: "danh từ",
    meaning:
      "vật để đi ở chân, được làm bằng da, vải hay cao su, có đế, thường che kín cả bàn chân: giày cao gót * giày da * thợ đóng giày",
    example: "giày cao gót * giày da * thợ đóng giày",
  },
  {
    word: "giày",
    part_of_speech: "động từ",
    meaning:
      "giẫm đi giẫm lại nhiều lần cho nát ra: trâu giày lúa * voi giày ngựa xé (tng)",
    example: "trâu giày lúa * voi giày ngựa xé (tng)",
  },
  {
    word: "giàu có",
    part_of_speech: "tính từ",
    meaning: "giàu, có nhiều tiền của (nói khái quát): con nhà giàu có",
    example: "con nhà giàu có",
  },
  {
    word: "giàu mạnh",
    part_of_speech: "tính từ",
    meaning: "giàu có và vững mạnh: xây dựng đất nước ngày càng giàu mạnh",
    example: "xây dựng đất nước ngày càng giàu mạnh",
  },
  {
    word: "giàu sang",
    part_of_speech: "tính từ",
    meaning: "giàu có và sang trọng: cuộc sống giàu sang",
    example: "cuộc sống giàu sang",
  },
  {
    word: "giãy",
    part_of_speech: "động từ",
    meaning:
      "cựa quậy mạnh làm thân mình bật lên, thường vì đau đớn hoặc để cố thoát khỏi sự kìm giữ: con cá giãy đành đạch * đứa bé giãy chân, khóc đòi mẹ",
    example: "con cá giãy đành đạch * đứa bé giãy chân, khóc đòi mẹ",
  },
  {
    word: "giãy",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tỏ ngay thái độ phản ứng, không chịu nhận, không đồng ý: giãy ra không chịu nhận * bảo gì cũng giãy lên!",
    example: "giãy ra không chịu nhận * bảo gì cũng giãy lên!",
  },
  {
    word: "giãy",
    part_of_speech: "tính từ",
    meaning:
      "(cũng rãy, rẫy) (nóng) quá mức, đến nỗi phải rụt ngay lại khi chạm vào: nước nóng giãy * mặt đường bỏng giãy",
    example: "nước nóng giãy * mặt đường bỏng giãy",
  },
  {
    word: "giày đinh",
    part_of_speech: "danh từ",
    meaning:
      "giày da, đế có đóng đinh: tiếng giày định nện cồm cộp xuống đường",
    example: "tiếng giày định nện cồm cộp xuống đường",
  },
  {
    word: "giãy chết",
    part_of_speech: "động từ",
    meaning:
      "giãy giụa mạnh trước khi chết: con cá giãy chết * chủ nghĩa đế quốc đang hồi giãy chết (b)",
    example: "con cá giãy chết * chủ nghĩa đế quốc đang hồi giãy chết (b)",
  },
  {
    word: "giãy giụa",
    part_of_speech: "động từ",
    meaning:
      "giãy mạnh và liên tiếp (nói khái quát): con bé kêu rầm lên, giãy giụa như phải đòn",
    example: "con bé kêu rầm lên, giãy giụa như phải đòn",
  },
  {
    word: "giãy nảy",
    part_of_speech: "động từ",
    meaning:
      "bật mình lên, thường vì đau đớn hoặc sợ hãi đột ngột: bị điện giật, giãy nảy lên",
    example: "bị điện giật, giãy nảy lên",
  },
  {
    word: "giãy nảy",
    part_of_speech: "động từ",
    meaning:
      '(khẩu ngữ) tỏ ngay thái độ không đồng ý bằng những lời lẽ, cử chỉ dứt khoát: "Thằng Quyên quen tính được mẹ nuông chiều, không vừa ý cái gì là nó giãy nảy lên." (NgQSáng; 6)',
    example:
      'Thằng Quyên quen tính được mẹ nuông chiều, không vừa ý cái gì là nó giãy nảy lên." (NgQSáng; 6)',
  },
  {
    word: "giày vò",
    part_of_speech: "động từ",
    meaning:
      "làm cho phải suy nghĩ, phải đau đớn một cách day dứt: bệnh tật giày vò * nỗi ân hận giày vò tâm can",
    example: "bệnh tật giày vò * nỗi ân hận giày vò tâm can",
  },
  {
    word: "giặc",
    part_of_speech: "danh từ",
    meaning:
      "kẻ tổ chức thành lực lượng vũ trang, chuyên đi cướp phá, làm rối loạn an ninh, gây tai hoạ cho cả một vùng, một nước: đánh giặc * giặc ngoại xâm",
    example: "đánh giặc * giặc ngoại xâm",
  },
  {
    word: "giặc",
    part_of_speech: "danh từ",
    meaning:
      "(Từ cũ) người nổi lên dùng bạo lực tìm cách lật đổ những người cầm quyền trong xã hội cũ (theo cách gọi của tầng lớp thống trị): được làm vua, thua làm giặc (tng)",
    example: "được làm vua, thua làm giặc (tng)",
  },
  {
    word: "giặc giã",
    part_of_speech: "danh từ",
    meaning:
      "giặc, về mặt gây ra tình hình rối ren (nói khái quát): giặc giã nổi lên khắp nơi",
    example: "giặc giã nổi lên khắp nơi",
  },
  {
    word: "giày xéo",
    part_of_speech: "động từ",
    meaning:
      "giẫm đạp lên một cách thô bạo, tàn nhẫn: quân giặc giày xéo lên nhau mà chạy * đất nước bị quân thù giày xéo",
    example:
      "quân giặc giày xéo lên nhau mà chạy * đất nước bị quân thù giày xéo",
  },
  {
    word: "giặc lái",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) kẻ lái máy bay đi ném bom gây tội ác trong chiến tranh xâm lược: bắn rơi máy bay, bắt sống tên giặc lái",
    example: "bắn rơi máy bay, bắt sống tên giặc lái",
  },
  {
    word: "giằm",
    part_of_speech: "động từ",
    meaning:
      "làm cho nát nhỏ ra bằng cách dùng vật cứng, như thìa, đũa, v.v. ấn mạnh xuống nhiều lần: giằm khúc cá * giằm tảng cơm cháy * giằm đất",
    example: "giằm khúc cá * giằm tảng cơm cháy * giằm đất",
  },
  {
    word: "giặm",
    part_of_speech: "động từ",
    meaning: "đan, vá thêm vào chỗ nan hỏng: giặm lại chỗ nong rách",
    example: "giặm lại chỗ nong rách",
  },
  {
    word: "giặm",
    part_of_speech: "động từ",
    meaning:
      "thêm vào chỗ còn trống, còn thiếu cho đủ: mạ chết nhiều, phải cấy giặm * cho trẻ ăn giặm",
    example: "mạ chết nhiều, phải cấy giặm * cho trẻ ăn giặm",
  },
  {
    word: "giăng giăng",
    part_of_speech: "động từ",
    meaning:
      "nối tiếp nhau thành hàng, thành dãy, hay trên mọi hướng: sương mù giăng giăng * đèn điện treo giăng giăng",
    example: "sương mù giăng giăng * đèn điện treo giăng giăng",
  },
  {
    word: "giăng",
    part_of_speech: "động từ",
    meaning:
      "làm cho căng thẳng ra theo bề dài hoặc theo mọi hướng trên bề mặt: nhện giăng tơ * giăng dây thép gai * giăng lưới bắt cá",
    example: "nhện giăng tơ * giăng dây thép gai * giăng lưới bắt cá",
  },
  {
    word: "giăng",
    part_of_speech: "động từ",
    meaning: "bủa ra khắp, tựa như giăng lưới: sương giăng đầy trời",
    example: "sương giăng đầy trời",
  },
  {
    word: "giằng",
    part_of_speech: "động từ",
    meaning:
      "nắm chặt và dùng sức giành hoặc giữ lấy: hai đứa trẻ giằng nhau đồ chơi * cố giằng lại nhưng không được",
    example: "hai đứa trẻ giằng nhau đồ chơi * cố giằng lại nhưng không được",
  },
  {
    word: "giằng",
    part_of_speech: "động từ",
    meaning:
      "liên kết các kết cấu trong công trình xây dựng để làm cho vững chắc: các cột nhà giằng với nhau bằng kèo",
    example: "các cột nhà giằng với nhau bằng kèo",
  },
  {
    word: "giằng",
    part_of_speech: "danh từ",
    meaning:
      "thanh vật liệu cứng, chắc, dùng để liên kết các kết cấu của nhà và công trình xây dựng cho thêm vững chắc: đổ giằng bê tông * giằng tường",
    example: "đổ giằng bê tông * giằng tường",
  },
  {
    word: "giằng co",
    part_of_speech: "động từ",
    meaning:
      "giằng đi giằng lại giữa hai bên, không bên nào chịu nhường bên nào: hai người cố sức giằng co chiếc túi",
    example: "hai người cố sức giằng co chiếc túi",
  },
  {
    word: "giằng co",
    part_of_speech: "động từ",
    meaning:
      "ở trong thế hai bên ngang sức, bên nào cũng cố giành phần thắng mà không được: đấu tranh giằng co * cuộc chiến diễn ra giằng co và gay gắt",
    example: "đấu tranh giằng co * cuộc chiến diễn ra giằng co và gay gắt",
  },
  {
    word: "giăng mắc",
    part_of_speech: "động từ",
    meaning:
      "căng ngang dọc như đan vào nhau theo mọi hướng: dây leo giăng mắc chằng chịt",
    example: "dây leo giăng mắc chằng chịt",
  },
  {
    word: "giặt",
    part_of_speech: "động từ",
    meaning:
      "làm sạch quần áo, chăn chiếu, v.v. bằng cách vò, xát, chải, giũ trong nước, thường cùng với xà phòng: giặt quần áo * máy giặt",
    example: "giặt quần áo * máy giặt",
  },
  {
    word: "giằng xé",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) giằng co cấu xé nhau một cách quyết liệt: đàn sói giằng xé con mồi",
    example: "đàn sói giằng xé con mồi",
  },
  {
    word: "giằng xé",
    part_of_speech: "động từ",
    meaning:
      "(có những mâu thuẫn tình cảm khó giải quyết) làm cho đau đớn về tinh thần đến mức như khó chịu đựng nổi: nỗi ân hận giằng xé tâm can",
    example: "nỗi ân hận giằng xé tâm can",
  },
  {
    word: "giấc điệp",
    part_of_speech: "danh từ",
    meaning: "(cũ, văn chương) giấc ngủ ngon, giấc mơ đẹp: giấc điệp mơ màng",
    example: "giấc điệp mơ màng",
  },
  {
    word: "giắt",
    part_of_speech: "động từ",
    meaning:
      "làm cho mắc vào một kẽ hở: giắt dao găm vào thắt lưng * thịt gà giắt kẽ răng * tiền giắt lưng (kng; mang theo người)",
    example:
      "giắt dao găm vào thắt lưng * thịt gà giắt kẽ răng * tiền giắt lưng (kng; mang theo người)",
  },
  {
    word: "giặt giũ",
    part_of_speech: "động từ",
    meaning: "giặt (nói khái quát): giặt giũ quần áo",
    example: "giặt giũ quần áo",
  },
  {
    word: "giấc hoàng lương",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) ví sự vinh hoa, phú quý ở đời chỉ như giấc mộng: "Canh chầy mơ giấc hoàng lương, Tỉnh ra lại thấy muôn nhường như không." (TS)',
    example:
      'Canh chầy mơ giấc hoàng lương, Tỉnh ra lại thấy muôn nhường như không." (TS)',
  },
  {
    word: "giấc ngủ",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian ngủ, về mặt trạng thái ngủ như thế nào, ngon hay không: giấc ngủ chập chờn * làm mất giấc ngủ",
    example: "giấc ngủ chập chờn * làm mất giấc ngủ",
  },
  {
    word: "giấc kê vàng",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) giấc hoàng lương: "Nhớ ra như giấc kê vàng, Như hoa rã cánh, như đàn đứt giây." (ca dao)',
    example: "Nhớ ra như giấc kê vàng, Như hoa rã cánh, như đàn đứt giây.",
  },
  {
    word: "giấc",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng khoảng thời gian ngủ liên tục: chợt tỉnh giấc * ngủ một giấc dài * thức giấc vì tiếng động mạnh",
    example: "chợt tỉnh giấc * ngủ một giấc dài * thức giấc vì tiếng động mạnh",
  },
  {
    word: "giấc",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ tổng thể nói chung những điều nằm mơ thấy trong một giấc ngủ: một giấc mơ đẹp * tỉnh giấc chiêm bao",
    example: "một giấc mơ đẹp * tỉnh giấc chiêm bao",
  },
  {
    word: "giấc",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) khoảng thời gian tương đối ngắn nào đó trong ngày, coi như là một thời điểm: gà gáy đúng giấc * hồi kẻng báo giấc trưa",
    example: "gà gáy đúng giấc * hồi kẻng báo giấc trưa",
  },
  {
    word: "giặt khô",
    part_of_speech: "động từ",
    meaning:
      "làm sạch quần áo, đồ vải bằng chất dung môi, không dùng nước: cửa hiệu giặt khô, là hơi",
    example: "cửa hiệu giặt khô, là hơi",
  },
  {
    word: "giấc hoè",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) giấc ngủ mơ thấy mình được hưởng phú quý: "Tiếng sen sẽ động giấc hoè, Bóng trăng đã xế hoa lê lại gần." (TKiều)',
    example:
      'Tiếng sen sẽ động giấc hoè, Bóng trăng đã xế hoa lê lại gần." (TKiều)',
  },
  {
    word: "giấc nam kha",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) giấc hoè: "Giấc Nam Kha khéo bất bình, Bừng con mắt dậy thấy mình tay không." (CO)',
    example:
      "Giấc Nam Kha khéo bất bình, Bừng con mắt dậy thấy mình tay không.",
  },
  {
    word: "giấc nồng",
    part_of_speech: "danh từ",
    meaning:
      '(văn chương) giấc ngủ ngon: "Vực nàng tạm xuống môn phòng, Hãy còn thiêm thiếp giấc nồng chưa phai." (TKiều)',
    example:
      'Vực nàng tạm xuống môn phòng, Hãy còn thiêm thiếp giấc nồng chưa phai." (TKiều)',
  },
  {
    word: "giậm",
    part_of_speech: "danh từ",
    meaning:
      "đồ đan bằng tre, miệng rộng hình bán cầu, có cán cầm, dùng để đánh bắt tôm cá: đánh giậm",
    example: "đánh giậm",
  },
  {
    word: "giậm",
    part_of_speech: "động từ",
    meaning:
      "nhấc chân cao rồi nện mạnh xuống: chân giậm thình thịch xuống đất * giậm chân bành bạch",
    example: "chân giậm thình thịch xuống đất * giậm chân bành bạch",
  },
  {
    word: "giấm",
    part_of_speech: "danh từ",
    meaning:
      "dung dịch loãng acid acetic trong nước, có vị chua, thường chế từ rượu lên men, dùng làm gia vị..",
    example: "cá nấu giấm",
  },
  {
    word: "giẫm",
    part_of_speech: "động từ",
    meaning: "đặt bàn chân đè mạnh lên: giẫm phải gai * trâu giẫm nát lúa",
    example: "giẫm phải gai * trâu giẫm nát lúa",
  },
  {
    word: "giâm",
    part_of_speech: "động từ",
    meaning:
      "cắm hay vùi xuống đất ẩm một đoạn cành, thân hay rễ, để gây nên một cây mới: giâm cành hoa hồng * giâm sắn",
    example: "giâm cành hoa hồng * giâm sắn",
  },
  {
    word: "giâm",
    part_of_speech: "động từ",
    meaning:
      "cấy tạm mạ hay loại cây con nào đó, khi có điều kiện sẽ nhổ đi cấy lại lần thứ hai: cấy giâm",
    example: "cấy giâm",
  },
  {
    word: "giậm giật",
    part_of_speech: "động từ",
    meaning:
      "cảm thấy có nhu cầu phải hoạt động do một đòi hỏi thôi thúc từ bên trong của cơ thể: chân tay rậm rật muốn chạy nhảy * thấy rậm rật trong người",
    example: "chân tay rậm rật muốn chạy nhảy * thấy rậm rật trong người",
  },
  {
    word: "giấm ớt",
    part_of_speech: "danh từ",
    meaning:
      "giấm và ớt, gia vị nói chung; dùng trong khẩu ngữ để ví cái thêm thắt cho câu chuyện trở nên có ý vị: thêm giấm ớt cho câu chuyện hấp dẫn",
    example: "thêm giấm ớt cho câu chuyện hấp dẫn",
  },
  {
    word: "giẫm chân tại chỗ",
    part_of_speech: "",
    meaning:
      "ví tình trạng tuy có hoạt động, nhưng công việc không tiến triển được chút nào: phong trào vẫn giẫm chân tại chỗ",
    example: "phong trào vẫn giẫm chân tại chỗ",
  },
  {
    word: "giẫm đạp",
    part_of_speech: "động từ",
    meaning: "giẫm lên, đạp lên (nói khái quát): giẫm đạp lên nhau mà chạy",
    example: "giẫm đạp lên nhau mà chạy",
  },
  {
    word: "giẫm đạp",
    part_of_speech: "động từ",
    meaning:
      "có những phần công việc trùng lặp nhau: tổ chức công việc còn chồng chéo, giẫm đạp lên nhau",
    example: "tổ chức công việc còn chồng chéo, giẫm đạp lên nhau",
  },
  {
    word: "giần",
    part_of_speech: "động từ",
    meaning:
      "cầm bằng hai tay cái giần có đựng gạo đã giã và lắc nhẹ qua lại, làm cho cám rơi xuống, để chỉ còn lại những hạt gạo sạch: giần gạo",
    example: "giần gạo",
  },
  {
    word: "giấn",
    part_of_speech: "động từ",
    meaning:
      "dồn sức thêm để cố đạt cho được: đạp dấn lên cho nhanh * dấn bước",
    example: "đạp dấn lên cho nhanh * dấn bước",
  },
  {
    word: "giấn",
    part_of_speech: "động từ",
    meaning:
      "tiến mạnh, vươn mạnh tới, bất chấp nguy hiểm: ngày càng dấn sâu vào con đường tội lỗi",
    example: "ngày càng dấn sâu vào con đường tội lỗi",
  },
  {
    word: "giấn",
    part_of_speech: "động từ",
    meaning:
      "(cũng giấn) dùng tay ấn xuống, đè mạnh xuống: dấn đầu xuống mà đánh * dấn quần áo bẩn vào chậu nước",
    example: "dấn đầu xuống mà đánh * dấn quần áo bẩn vào chậu nước",
  },
  {
    word: "giận dữ",
    part_of_speech: "tính từ",
    meaning:
      "giận lắm, thể hiện rõ qua thái độ, vẻ mặt hoặc trạng thái, khiến người khác phải sợ: cơn giận dữ * mặt hầm hầm giận dữ",
    example: "cơn giận dữ * mặt hầm hầm giận dữ",
  },
  {
    word: "giần giật",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) từ gợi tả những tiếng động to nối tiếp nhau với một nhịp nhanh, mạnh, gấp: gió rần rật * tiếng chân rần rật suốt đêm",
    example: "gió rần rật * tiếng chân rần rật suốt đêm",
  },
  {
    word: "giần giật",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái đang bừng bừng và lan toả ra mạnh mẽ: lửa cháy rần rật * khắp người rần rật niềm vui sướng",
    example: "lửa cháy rần rật * khắp người rần rật niềm vui sướng",
  },
  {
    word: "giận",
    part_of_speech: "động từ",
    meaning:
      "không bằng lòng và bực bội với người có quan hệ gần gũi nào đó, vì người ấy đã làm điều trái với ý mình: nguôi cơn giận * đổi giận làm lành",
    example: "nguôi cơn giận * đổi giận làm lành",
  },
  {
    word: "giận dỗi",
    part_of_speech: "động từ",
    meaning:
      "có điều giận và biểu lộ ra bằng thái độ lạnh nhạt không bình thường để cho người ta biết: giọng giận dỗi * tính hay giận dỗi",
    example: "giọng giận dỗi * tính hay giận dỗi",
  },
  {
    word: "giập",
    part_of_speech: "động từ",
    meaning:
      "(vật tương đối mềm) bị bẹp hoặc nứt ra, do va chạm: quả chuối bị giập * đánh rắn phải đánh giập đầu (tng)",
    example: "quả chuối bị giập * đánh rắn phải đánh giập đầu (tng)",
  },
  {
    word: "giấp",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) giấp cá (nói tắt): rau giấp",
    example: "rau giấp",
  },
  {
    word: "giập giạp",
    part_of_speech: "động từ",
    meaning: "chỉ mới hơi giập một chút: nhai giập giạp rồi nuốt",
    example: "nhai giập giạp rồi nuốt",
  },
  {
    word: "giập giạp",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ, hiếm) (làm việc gì) chỉ mới sơ bộ ở một mức nào đó, chưa kĩ, chưa sâu: mới bàn giập giạp thôi * tính giập giạp mà đã hết mấy triệu",
    example: "mới bàn giập giạp thôi * tính giập giạp mà đã hết mấy triệu",
  },
  {
    word: "giật",
    part_of_speech: "động từ",
    meaning:
      "làm cho rời ra, cho di chuyển một quãng ngắn bằng một động tác nhanh, gọn: giật mũ ra khỏi đầu * giật mặt nạ",
    example: "giật mũ ra khỏi đầu * giật mặt nạ",
  },
  {
    word: "giật",
    part_of_speech: "động từ",
    meaning:
      "(hiện tượng) chuyển động đột ngột một cái rồi trở lại ngay vị trí cũ: con tàu giật mạnh rồi từ từ chuyển bánh * bệnh nhân lên cơn giật",
    example: "con tàu giật mạnh rồi từ từ chuyển bánh * bệnh nhân lên cơn giật",
  },
  {
    word: "giật",
    part_of_speech: "động từ",
    meaning:
      "(hiện tượng) diễn ra đột ngột, mạnh mẽ và rất nhanh gọn: gió giật từng hồi * chớp giật * gọi giật giọng",
    example: "gió giật từng hồi * chớp giật * gọi giật giọng",
  },
  {
    word: "giật",
    part_of_speech: "động từ",
    meaning:
      "lấy về mình bằng động tác đột ngột, mạnh, nhanh, gọn: giật lại quyển sách * giật con dao trên tay tên cướp",
    example: "giật lại quyển sách * giật con dao trên tay tên cướp",
  },
  {
    word: "giật",
    part_of_speech: "động từ",
    meaning:
      "giành lấy được về cho mình bằng sự nỗ lực (thường nói về giải thưởng): giật giải nhất * giật cờ thi đua",
    example: "giật giải nhất * giật cờ thi đua",
  },
  {
    word: "giật",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) vay trong thời hạn rất ngắn: giật tạm ít tiền",
    example: "giật tạm ít tiền",
  },
  {
    word: "giật gân",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (tin tức, sự việc) có tác dụng kích thích mạnh đối với người nghe, người xem (thường hàm ý chê): tin giật gân * phim trinh thám, giật gân",
    example: "tin giật gân * phim trinh thám, giật gân",
  },
  {
    word: "giật dây",
    part_of_speech: "động từ",
    meaning:
      "ngầm sai khiến hoặc xúi giục làm điều sai trái: có kẻ đứng đằng sau giật dây",
    example: "có kẻ đứng đằng sau giật dây",
  },
  {
    word: "giật cục",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) ngừng lại đột ngột như bị kéo ngược lại, giữa lúc đang chuyển động, bình thường: máy chạy giật cục * nói giật cục",
    example: "máy chạy giật cục * nói giật cục",
  },
  {
    word: "giật lửa",
    part_of_speech: "động từ",
    meaning:
      '(khẩu ngữ, hiếm) như giật nóng: "Hôm nay đi giật lửa được mấy đồng, anh cầm lấy bảo nó đi mua một vài đĩa gì tí nữa chén vậy." (NgTuân; 8)',
    example:
      'Hôm nay đi giật lửa được mấy đồng, anh cầm lấy bảo nó đi mua một vài đĩa gì tí nữa chén vậy." (NgTuân; 8)',
  },
  {
    word: "giật nóng",
    part_of_speech: "động từ",
    meaning: "vay gấp vì đang rất cần, rồi trả ngay: giật nóng ít tiền",
    example: "giật nóng ít tiền",
  },
  {
    word: "giật giọng",
    part_of_speech: "tính từ",
    meaning:
      "(tiếng kêu, gọi) giật từng tiếng ngắn, đột ngột, nghe có tính chất thúc bách: gọi giật giọng",
    example: "gọi giật giọng",
  },
  {
    word: "giấu",
    part_of_speech: "động từ",
    meaning:
      "để vào nơi kín đáo nhằm cho người ta không thể thấy, không thể tìm ra được: giấu tiền * giấu lá thư dưới gối",
    example: "giấu tiền * giấu lá thư dưới gối",
  },
  {
    word: "giấu",
    part_of_speech: "động từ",
    meaning:
      "giữ kín, không muốn cho người ta biết: giấu tình cảm thật của mình * giấu tung tích * giấu dốt",
    example: "giấu tình cảm thật của mình * giấu tung tích * giấu dốt",
  },
  {
    word: "giật mình",
    part_of_speech: "động từ",
    meaning:
      "giật nẩy người lên, do thần kinh bị tác động một cách đột ngột: giật mình đánh thót",
    example: "giật mình đánh thót",
  },
  {
    word: "giật mình",
    part_of_speech: "động từ",
    meaning:
      "đột nhiên thấy lo, do tác động của một điều hoàn toàn không ngờ đến hoặc không nghĩ đến: giật mình vì thấy tóc đã điểm bạc * có tật giật mình (tng)",
    example: "giật mình vì thấy tóc đã điểm bạc * có tật giật mình (tng)",
  },
  {
    word: "giật thót",
    part_of_speech: "động từ",
    meaning:
      "giật nẩy mình, vì lo, sợ đột ngột: giật thót người * tiếng hú làm nó giật thót mình",
    example: "giật thót người * tiếng hú làm nó giật thót mình",
  },
  {
    word: "giật nợ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) lấy đi một cách ít nhiều thô bạo tài sản của kẻ khác để trừ nợ: đồ đạc trong nhà bị người ta giật nợ hết cả",
    example: "đồ đạc trong nhà bị người ta giật nợ hết cả",
  },
  {
    word: "giật lùi",
    part_of_speech: "động từ",
    meaning:
      "lùi dần từng bước, từng quãng ngắn: hoảng hốt, giật lùi mấy bước * xe giật lùi để tìm chỗ quay đầu * phú quý giật lùi",
    example:
      "hoảng hốt, giật lùi mấy bước * xe giật lùi để tìm chỗ quay đầu * phú quý giật lùi",
  },
  {
    word: "giậu",
    part_of_speech: "danh từ",
    meaning:
      "tấm tre nứa đan hoặc hàng cây nhỏ và rậm để ngăn sân, vườn: vườn có giậu bao quanh",
    example: "vườn có giậu bao quanh",
  },
  {
    word: "giấu đầu hở đuôi",
    part_of_speech: "",
    meaning:
      '(khẩu ngữ) muốn giấu điều gì đó, nhưng lại vô tình để lộ ra phần nào cho người ta đoán biết được: "Rồng nằm bể cạn phơi râu, Mấy lời anh nói giấu đầu hở đuôi." (ca dao)',
    example:
      'Rồng nằm bể cạn phơi râu, Mấy lời anh nói giấu đầu hở đuôi." (ca dao)',
  },
  {
    word: "giấu giếm",
    part_of_speech: "động từ",
    meaning:
      "giấu, không cho biết việc làm nào đó, thường là không tốt: giấu giếm của cải * nói thật, không giấu giếm",
    example: "giấu giếm của cải * nói thật, không giấu giếm",
  },
  {
    word: "giẫy",
    part_of_speech: "động từ",
    meaning:
      "dùng cuốc hớt sạch đi lớp cỏ hoặc san mặt đất mấp mô cho bằng phẳng: giẫy cỏ * giẫy mả",
    example: "giẫy cỏ * giẫy mả",
  },
  {
    word: "giây",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị cơ bản đo thời gian: một phút bằng 60 giây * chiếc kim đồng hồ nhích từng giây",
    example: "một phút bằng 60 giây * chiếc kim đồng hồ nhích từng giây",
  },
  {
    word: "giây",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian được coi là cực kì ngắn, qua rất nhanh: suy nghĩ chỉ trong một giây * trả lời không chậm một giây",
    example: "suy nghĩ chỉ trong một giây * trả lời không chậm một giây",
  },
  {
    word: "giấy",
    part_of_speech: "danh từ",
    meaning:
      "vật liệu được làm thành tờ để viết vẽ, in ấn hoặc gói bọc, lau chùi, v.v.: giấy ô li * mỏng như tờ giấy * viết được vài trang giấy",
    example: "giấy ô li * mỏng như tờ giấy * viết được vài trang giấy",
  },
  {
    word: "giấy",
    part_of_speech: "danh từ",
    meaning:
      "tờ giấy có chữ viết hoặc in mang một nội dung nhất định và có một giá trị theo quy định: giấy chứng nhận * giấy uỷ nhiệm * nén bạc đâm toạc tờ giấy (tng)",
    example: "giấy chứng nhận * giấy uỷ nhiệm * nén bạc đâm toạc tờ giấy (tng)",
  },
  {
    word: "giấy báo",
    part_of_speech: "danh từ",
    meaning:
      "văn bản của một bên gửi cho bên kia để thông báo về một sự việc nào đó: giấy báo của xã về việc thu hồi đất * giấy báo nhập học",
    example: "giấy báo của xã về việc thu hồi đất * giấy báo nhập học",
  },
  {
    word: "giấy bóng",
    part_of_speech: "danh từ",
    meaning:
      "giấy mỏng bóng láng và trong mờ, thường dùng để đồ lại các hình vẽ (giấy bóng mờ), hoặc trong suốt, thường có nhiều màu, dùng để bao gói, chống ẩm hoặc trang trí: kẹo gói giấy bóng",
    example: "kẹo gói giấy bóng",
  },
  {
    word: "giấy bóng kính",
    part_of_speech: "danh từ",
    meaning: "giấy bóng trong suốt: bó hoa bằng giấy bóng kính",
    example: "bó hoa bằng giấy bóng kính",
  },
  {
    word: "giấy dầu",
    part_of_speech: "danh từ",
    meaning:
      "giấy có phết dầu hoặc ngâm tẩm hắc ín, không thấm nước, dùng để lợp nhà, bao gói, chống ẩm: nhà lợp giấy dầu",
    example: "nhà lợp giấy dầu",
  },
  {
    word: "giấy chứng minh",
    part_of_speech: "danh từ",
    meaning:
      "giấy chứng nhận tên tuổi, năm sinh, quê quán và những đặc điểm về nhân dạng do cơ quan có thẩm quyền cấp cho công dân: làm đơn xin cấp giấy chứng minh",
    example: "làm đơn xin cấp giấy chứng minh",
  },
  {
    word: "giấy dó",
    part_of_speech: "danh từ",
    meaning:
      "giấy làm bằng bột vỏ cây dó, xốp, bền và mịn, thường dùng để viết, vẽ: tranh Đông Hồ vẽ trên giấy dó",
    example: "tranh Đông Hồ vẽ trên giấy dó",
  },
  {
    word: "giây lát",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian rất ngắn, coi như không đáng kể (nói khái quát): đắn đo giây lát * lặng người đi trong giây lát",
    example: "đắn đo giây lát * lặng người đi trong giây lát",
  },
  {
    word: "giấy má",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) giấy (nói khái quát): giấy má bay đầy sân",
    example: "giấy má bay đầy sân",
  },
  {
    word: "giấy má",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ, hiếm) như giấy tờ: chuẩn bị đầy đủ giấy má",
    example: "chuẩn bị đầy đủ giấy má",
  },
  {
    word: "giấy lộn",
    part_of_speech: "danh từ",
    meaning: "giấy các loại đã dùng rồi, bỏ đi: bán giấy lộn * mớ giấy lộn",
    example: "bán giấy lộn * mớ giấy lộn",
  },
  {
    word: "giấy phép",
    part_of_speech: "danh từ",
    meaning:
      "giấy do cơ quan có thẩm quyền cấp, cho phép làm một việc: giấy phép xuất bản * xin giấy phép xây dựng nhà",
    example: "giấy phép xuất bản * xin giấy phép xây dựng nhà",
  },
  {
    word: "giây phút",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian hết sức ngắn, thường gắn liền với sự kiện nào đó (nói khái quát): giây phút biệt li * lặng người đi trong giây phút",
    example: "giây phút biệt li * lặng người đi trong giây phút",
  },
  {
    word: "giấy ráp",
    part_of_speech: "danh từ",
    meaning:
      "giấy có gắn lớp cát sạn nhỏ, dùng để đánh, mài đồ gỗ hoặc kim khí: đánh giấy ráp trước khi sơn",
    example: "đánh giấy ráp trước khi sơn",
  },
  {
    word: "giấy tờ",
    part_of_speech: "danh từ",
    meaning:
      "giấy mang một nội dung và có một giá trị nhất định (nói khái quát): công văn giấy tờ * làm giấy tờ giả * bệnh giấy tờ",
    example: "công văn giấy tờ * làm giấy tờ giả * bệnh giấy tờ",
  },
  {
    word: "giấy trắng mực đen",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) có văn bản làm bằng (không thể chối cãi được): đã giấy trắng mực đen thì chối cãi sao được",
    example: "đã giấy trắng mực đen thì chối cãi sao được",
  },
  {
    word: "gié",
    part_of_speech: "danh từ",
    meaning: "nhánh của cụm hoa kiểu bông kép: gié lúa * trừ sâu cắn gié",
    example: "gié lúa * trừ sâu cắn gié",
  },
  {
    word: "gie",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) chìa ra, nhô ra, thò ra khỏi một chỗ hay vị trí nào đó: cành cây gie ra mặt hồ * mái hiên gie ra sát mặt đường",
    example: "cành cây gie ra mặt hồ * mái hiên gie ra sát mặt đường",
  },
  {
    word: "gièm",
    part_of_speech: "động từ",
    meaning:
      "đặt điều nói xấu nhằm làm cho không còn được tin yêu, tin cậy nữa: nói gièm * gièm nên xấu, khen nên tốt (tng)",
    example: "nói gièm * gièm nên xấu, khen nên tốt (tng)",
  },
  {
    word: "gien",
    part_of_speech: "danh từ",
    meaning:
      "đoạn phân tử AND mang thông tin quy định cấu trúc của một loại protit. Được dùng trong phạm trù di truyền học.: Cậu ấy thừa hưởng gen của cha.",
    example: "Cậu ấy thừa hưởng gen của cha.",
  },
  {
    word: "gièm pha",
    part_of_speech: "động từ",
    meaning:
      'gièm (nói khái quát): "Hỏi vợ thì cưới liền tay, Chớ để lâu ngày lắm kẻ gièm pha." (ca dao)',
    example:
      'Hỏi vợ thì cưới liền tay, Chớ để lâu ngày lắm kẻ gièm pha." (ca dao)',
  },
  {
    word: "giẻ cùi tốt mã",
    part_of_speech: "",
    meaning:
      'ví kẻ chỉ có cái đẹp trau chuốt bề ngoài: "Giẻ cùi tốt mã dài lông, Bên ngoài hào nhoáng bên trong ra gì." (ca dao)',
    example:
      'Giẻ cùi tốt mã dài lông, Bên ngoài hào nhoáng bên trong ra gì." (ca dao)',
  },
  {
    word: "giẻ",
    part_of_speech: "danh từ",
    meaning:
      "cây leo cùng họ với na, lá hình bầu dục, hoa có cánh dài và dày, màu vàng lục, hương thơm: hoa giẻ",
    example: "hoa giẻ",
  },
  {
    word: "giẻ",
    part_of_speech: "danh từ",
    meaning:
      "mảnh vải vụn hoặc quần áo rách thải ra: giẻ rách * giẻ rửa bát * giẻ lau",
    example: "giẻ rách * giẻ rửa bát * giẻ lau",
  },
  {
    word: "gieo",
    part_of_speech: "động từ",
    meaning:
      "rắc hạt giống để cho mọc mầm, lên cây: gieo mạ * gieo ngô * gieo gió gặt bão (tng)",
    example: "gieo mạ * gieo ngô * gieo gió gặt bão (tng)",
  },
  {
    word: "gieo",
    part_of_speech: "động từ",
    meaning:
      "buông đồng tiền hoặc con súc sắc cho rơi xuống, để xem nó nằm như thế nào mà đoán quẻ hoặc tính điểm, tính được thua trong trò chơi: gieo súc sắc chơi cá ngựa * gieo đồng tiền xin âm dương",
    example: "gieo súc sắc chơi cá ngựa * gieo đồng tiền xin âm dương",
  },
  {
    word: "gieo",
    part_of_speech: "động từ",
    meaning:
      "thả cho thân mình buông xuống, rơi xuống một cách tự do: gieo người xuống giường",
    example: "gieo người xuống giường",
  },
  {
    word: "gieo",
    part_of_speech: "động từ",
    meaning:
      "làm cho nảy sinh, phát triển và lan truyền: vi trùng gieo bệnh * gieo tiếng xấu * gieo tai hoạ",
    example: "vi trùng gieo bệnh * gieo tiếng xấu * gieo tai hoạ",
  },
  {
    word: "gieo cấy",
    part_of_speech: "động từ",
    meaning:
      "gieo và cấy để sản xuất lương thực (nói khái quát): gieo cấy lúa hè thu * diện tích gieo cấy",
    example: "gieo cấy lúa hè thu * diện tích gieo cấy",
  },
  {
    word: "gieo vần",
    part_of_speech: "động từ",
    meaning:
      "chọn dùng tiếng có vần phù hợp, theo yêu cầu của luật thơ: gieo vần lưng",
    example: "gieo vần lưng",
  },
  {
    word: "gieo quẻ",
    part_of_speech: "động từ",
    meaning:
      "gieo đồng tiền, xem sấp ngửa để đoán quẻ, theo thuật bói toán: thầy bói gieo quẻ",
    example: "thầy bói gieo quẻ",
  },
  {
    word: "gieo rắc",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) làm cho rơi xuống khắp nơi trên một diện rộng, gây hậu quả tai hại: máy bay địch gieo rắc chất độc hoá học khắp cả khu rừng",
    example: "máy bay địch gieo rắc chất độc hoá học khắp cả khu rừng",
  },
  {
    word: "gieo rắc",
    part_of_speech: "động từ",
    meaning:
      "mang đến và làm cho lan truyền rộng (thường là cái xấu, cái tiêu cực): gieo rắc bệnh tật * gieo rắc nghi ngờ",
    example: "gieo rắc bệnh tật * gieo rắc nghi ngờ",
  },
  {
    word: "giề",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) đám (bèo, cỏ hoặc rác) nổi trên mặt nước: giề lục bình",
    example: "giề lục bình",
  },
  {
    word: "gieo neo",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều khó khăn, trắc trở, phải vất vả mới vượt qua được: đời sống gieo neo, vất vả",
    example: "đời sống gieo neo, vất vả",
  },
  {
    word: "gieo trồng",
    part_of_speech: "động từ",
    meaning:
      "gieo giống và trồng cây trong sản xuất nông nghiệp, (nói khái quát): diện tích gieo trồng * gieo trồng cho kịp thời vụ",
    example: "diện tích gieo trồng * gieo trồng cho kịp thời vụ",
  },
  {
    word: "giếc",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) cá diếc (nói tắt): tham con diếc, tiếc con rô (tng)",
    example: "tham con diếc, tiếc con rô (tng)",
  },
  {
    word: "giếng",
    part_of_speech: "danh từ",
    meaning:
      "hố đào thẳng đứng, sâu vào lòng đất, thường để lấy nước: đào giếng",
    example: "đào giếng",
  },
  {
    word: "giềng",
    part_of_speech: "danh từ",
    meaning: "dây cái của lưới để buộc phao hoặc chì: giềng lưới",
    example: "giềng lưới",
  },
  {
    word: "giêng",
    part_of_speech: "danh từ",
    meaning: "tháng giêng (nói tắt): ra giêng",
    example: "ra giêng",
  },
  {
    word: "giết",
    part_of_speech: "động từ",
    meaning:
      "làm cho bị chết, một cách có chủ ý: giết giặc * can tội giết người",
    example: "giết giặc * can tội giết người",
  },
  {
    word: "giết",
    part_of_speech: "động từ",
    meaning: "làm cho chết để lấy thịt ăn: giết lợn ăn mừng",
    example: "giết lợn ăn mừng",
  },
  {
    word: "giềng mối",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) đầu mối chính (nói khái quát); dùng để chỉ khuôn phép, kỉ cương: giềng mối của đạo đức phong kiến",
    example: "giềng mối của đạo đức phong kiến",
  },
  {
    word: "giêng hai",
    part_of_speech: "danh từ",
    meaning:
      '(khẩu ngữ) tháng giêng và tháng hai âm lịch; đầu năm: "Bao giờ cho đến giêng hai, Cho làng vào đám cho ai xem chèo." (ca dao)',
    example:
      'Bao giờ cho đến giêng hai, Cho làng vào đám cho ai xem chèo." (ca dao)',
  },
  {
    word: "giết chóc",
    part_of_speech: "động từ",
    meaning:
      "làm cho bị chết, một cách có chủ ý: giết giặc * can tội giết người",
    example: "giết giặc * can tội giết người",
  },
  {
    word: "giết chóc",
    part_of_speech: "động từ",
    meaning: "làm cho chết để lấy thịt ăn: giết lợn ăn mừng",
    example: "giết lợn ăn mừng",
  },
  {
    word: "giết mổ",
    part_of_speech: "động từ",
    meaning:
      "làm cho bị chết, một cách có chủ ý: giết giặc * can tội giết người",
    example: "giết giặc * can tội giết người",
  },
  {
    word: "giết mổ",
    part_of_speech: "động từ",
    meaning: "làm cho chết để lấy thịt ăn: giết lợn ăn mừng",
    example: "giết lợn ăn mừng",
  },
  {
    word: "giết hại",
    part_of_speech: "động từ",
    meaning:
      "làm cho bị chết, một cách có chủ ý: giết giặc * can tội giết người",
    example: "giết giặc * can tội giết người",
  },
  {
    word: "giết hại",
    part_of_speech: "động từ",
    meaning: "làm cho chết để lấy thịt ăn: giết lợn ăn mừng",
    example: "giết lợn ăn mừng",
  },
  {
    word: "giết thì giờ",
    part_of_speech: "động từ",
    meaning:
      "làm việc gì đó chỉ cốt cho qua thời gian rỗi rãi: đọc sách để giết thì giờ",
    example: "đọc sách để giết thì giờ",
  },
  {
    word: "giết thịt",
    part_of_speech: "động từ",
    meaning:
      "làm cho bị chết, một cách có chủ ý: giết giặc * can tội giết người",
    example: "giết giặc * can tội giết người",
  },
  {
    word: "giết thịt",
    part_of_speech: "động từ",
    meaning: "làm cho chết để lấy thịt ăn: giết lợn ăn mừng",
    example: "giết lợn ăn mừng",
  },
  {
    word: "giễu",
    part_of_speech: "động từ",
    meaning:
      "nói ra, đưa ra để đùa bỡn, châm chọc hoặc đả kích: bị giễu là hèn nhát * tự giễu mình",
    example: "bị giễu là hèn nhát * tự giễu mình",
  },
  {
    word: "giễu cợt",
    part_of_speech: "động từ",
    meaning:
      "nêu thành trò cười nhằm chế nhạo, đả kích (nói khái quát): giễu cợt thói háo danh",
    example: "giễu cợt thói háo danh",
  },
  {
    word: "giễu cợt",
    part_of_speech: "tính từ",
    meaning: "có tính chất thể hiện sự giễu cợt: nhìn với ánh mắt giễu cợt",
    example: "nhìn với ánh mắt giễu cợt",
  },
  {
    word: "gin",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) chính hiệu, chính gốc: chơi toàn đồ gin * hàng gin 100%",
    example: "chơi toàn đồ gin * hàng gin 100%",
  },
  {
    word: "gin",
    part_of_speech: "tính từ",
    meaning: "còn mới nguyên: hàng vẫn còn gin",
    example: "hàng vẫn còn gin",
  },
  {
    word: "giò",
    part_of_speech: "danh từ",
    meaning:
      "nhánh cây hoa, cây cảnh được trồng riêng (với một số loại cây): dò phong lan * dò thuỷ tiên",
    example: "dò phong lan * dò thuỷ tiên",
  },
  {
    word: "giò",
    part_of_speech: "danh từ",
    meaning:
      'bẫy thường làm bằng dây thòng lọng để bắt chim: "Chim khôn tránh lưới mắc dò, Cá khôn tránh mãi, lững lờ mắc đăng." (Cdao)',
    example:
      'Chim khôn tránh lưới mắc dò, Cá khôn tránh mãi, lững lờ mắc đăng." (Cdao)',
  },
  {
    word: "giò",
    part_of_speech: "động từ",
    meaning:
      "đi một cách thận trọng, từng bước một (do có điều bất lợi nào đó): dò từng bước trong đêm tối",
    example: "dò từng bước trong đêm tối",
  },
  {
    word: "giò",
    part_of_speech: "động từ",
    meaning:
      'tìm biết, tìm hiểu dần dần từng bước một cách mò mẫm: dò tìm manh mối * "Dò sông dò biển dễ dò, Nào ai lấy thước mà đo lòng người." (Cdao)',
    example:
      'dò tìm manh mối * "Dò sông dò biển dễ dò, Nào ai lấy thước mà đo lòng người." (Cdao)',
  },
  {
    word: "giò",
    part_of_speech: "động từ",
    meaning:
      "soát lại một cách cẩn thận bằng cách lần tìm những chỗ sai sót: dò bản đánh máy * dò bài cho con",
    example: "dò bản đánh máy * dò bài cho con",
  },
  {
    word: "giỏ",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng để đựng, thường đan bằng tre, mây, v.v., hình trụ, thành cao, miệng hẹp và có quai xách: bắt cua bỏ giỏ * để cặp ở giỏ xe * giỏ nhà ai quai nhà nấy (tng)",
    example: "bắt cua bỏ giỏ * để cặp ở giỏ xe * giỏ nhà ai quai nhà nấy (tng)",
  },
  {
    word: "gió bãi trăng ngàn",
    part_of_speech: "",
    meaning:
      '(văn chương) tả cảnh sống phong trần, phiêu bạt, nay đây mai đó của khách giang hồ hoặc người chinh chiến: "Xông pha gió bãi trăng ngàn, Tên reo đầu ngựa giáo dan mặt thành." (CPN)',
    example:
      'Xông pha gió bãi trăng ngàn, Tên reo đầu ngựa giáo dan mặt thành." (CPN)',
  },
  {
    word: "gìn",
    part_of_speech: "động từ",
    meaning: "(cũ, văn chương) như giữ: gắng gìn lòng * gìn vàng giữ ngọc",
    example: "gắng gìn lòng * gìn vàng giữ ngọc",
  },
  {
    word: "gìn giữ",
    part_of_speech: "động từ",
    meaning: "như giữ gìn: gìn giữ hạnh phúc",
    example: "gìn giữ hạnh phúc",
  },
  {
    word: "gió",
    part_of_speech: "danh từ",
    meaning:
      "hiện tượng không khí trong khí quyển chuyển động thành luồng từ vùng có áp suất cao đến vùng có áp suất thấp: gió thổi lồng lộng * trời tạnh gió",
    example: "gió thổi lồng lộng * trời tạnh gió",
  },
  {
    word: "gió",
    part_of_speech: "danh từ",
    meaning: "luồng không khí chuyển động được tạo ra bằng quạt: quạt tản gió",
    example: "quạt tản gió",
  },
  {
    word: "gió bắt mưa cầm",
    part_of_speech: "",
    meaning:
      '(văn chương) ví trường hợp có nhiều điều ngăn trở, không thể làm theo ý mình được: "Nàng rằng: Gió bắt, mưa cầm, Đã cam tệ với tri âm bấy chầy." (TKiều)',
    example:
      'Nàng rằng: Gió bắt, mưa cầm, Đã cam tệ với tri âm bấy chầy." (TKiều)',
  },
  {
    word: "gió chướng",
    part_of_speech: "danh từ",
    meaning:
      'Là gió mùa Đông bắc ở miền Nam Việt Nam. "Gió Chướng” là tên gọi địa phương của bà con nông dân ở Nam Bộ đối với gió mùa Đông Bắc và gió tín phong. Khi có gió Chướng mạnh có thể làm cho độ mặn tăng đột biến làm thiệt hại không ít cho sản xuất./.: mùa gió chướng',
    example: "mùa gió chướng",
  },
  {
    word: "gió bụi",
    part_of_speech: "danh từ",
    meaning:
      '(văn chương) gió và bụi trên đường (nói khái quát); thường dùng để ví những nỗi gian nan, vất vả trên đường đời: "Thuở trời đất nổi cơn gió bụi, Khách má hồng nhiều nỗi truân chuyên." (CPN)',
    example:
      'Thuở trời đất nổi cơn gió bụi, Khách má hồng nhiều nỗi truân chuyên." (CPN)',
  },
  {
    word: "gió lùa",
    part_of_speech: "danh từ",
    meaning:
      "luồng gió thổi theo một đường hẹp và dài, thường dễ gây cảm lạnh: đóng cửa để tránh gió lùa",
    example: "đóng cửa để tránh gió lùa",
  },
  {
    word: "gió mát trăng thanh",
    part_of_speech: "danh từ",
    meaning:
      'cảnh thiên nhiên tươi đẹp về ban đêm: "Lần thâu gió mát, trăng thanh, Bỗng đâu có khách biên đình sang chơi." (TKiều)',
    example:
      'Lần thâu gió mát, trăng thanh, Bỗng đâu có khách biên đình sang chơi." (TKiều)',
  },
  {
    word: "gió mây",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) phong vân: "Đã từng tắm gội ơn mưa móc, Cũng phải xênh xang hội gió mây." (NCTrứ; 2)',
    example: "Đã từng tắm gội ơn mưa móc, Cũng phải xênh xang hội gió mây.",
  },
  {
    word: "gió máy",
    part_of_speech: "danh từ",
    meaning:
      "gió, về mặt có thể gây cảm lạnh (nói khái quát): người yếu phải kiêng gió máy",
    example: "người yếu phải kiêng gió máy",
  },
  {
    word: "gió trăng",
    part_of_speech: "danh từ",
    meaning:
      '(hiếm) như trăng gió: chuyện gió trăng * "Lẽ đâu dám thói gió trăng, Mở đường quyến bướm, tìm đường rủ ong?" (SKTT)',
    example:
      'chuyện gió trăng * "Lẽ đâu dám thói gió trăng, Mở đường quyến bướm, tìm đường rủ ong?" (SKTT)',
  },
  {
    word: "gió mùa",
    part_of_speech: "danh từ",
    meaning:
      "gió có hướng và tính chất khác nhau theo mùa trong phạm vi rộng lớn, mùa đông thổi từ đất liền ra biển, mùa hè thổi từ biển vào đất liền: khí hậu nhiệt đới gió mùa",
    example: "khí hậu nhiệt đới gió mùa",
  },
  {
    word: "giòi",
    part_of_speech: "danh từ",
    meaning: "dạng ấu trùng của ruồi, nhặng: không ưa thì dưa có dòi (tng)",
    example: "không ưa thì dưa có dòi (tng)",
  },
  {
    word: "gió táp mưa sa",
    part_of_speech: "",
    meaning:
      '(cũ, văn chương) ví những tai hoạ, khó khăn liên tục, dồn dập tới: "Ai làm gió táp mưa sa, Cho cây anh đổ, cho hoa anh tàn." (ca dao)',
    example:
      'Ai làm gió táp mưa sa, Cho cây anh đổ, cho hoa anh tàn." (ca dao)',
  },
  {
    word: "gioi",
    part_of_speech: "danh từ",
    meaning:
      "(Bắc, cũng gioi) (Nam mận) cây cùng họ với ổi, lá to, hoa trắng, quả mọng hình quả lê, thịt xốp, ăn được",
    example:
      "quật cho vài roi * ăn roi (= bị đánh bằng roi) * Thương cho roi cho vọt",
  },
  {
    word: "giỏi",
    part_of_speech: "tính từ",
    meaning:
      "có trình độ cao, đáng được khâm phục, khen ngợi: đạt danh hiệu học sinh giỏi * hát hay đàn giỏi * giáo viên dạy giỏi",
    example:
      "đạt danh hiệu học sinh giỏi * hát hay đàn giỏi * giáo viên dạy giỏi",
  },
  {
    word: "giỏi",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có gan dám làm điều biết rõ là sẽ không hay cho mình (dùng trong lời mỉa mai, hoặc đe doạ, thách thức): có giỏi thì làm đi! * dám cãi lại cơ à, thằng này giỏi nhỉ!",
    example: "có giỏi thì làm đi! * dám cãi lại cơ à, thằng này giỏi nhỉ!",
  },
  {
    word: "giỏi",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có mức độ cao, cùng lắm là như vậy, khó có thể hơn: đi kiểu này, có giỏi cũng phải mai mới đến * kiếm cả ngày, giỏi lắm chỉ được dăm chục",
    example:
      "đi kiểu này, có giỏi cũng phải mai mới đến * kiếm cả ngày, giỏi lắm chỉ được dăm chục",
  },
  {
    word: "giòn",
    part_of_speech: "tính từ",
    meaning:
      "dễ gãy, dễ vỡ vụn, khi gãy vỡ thường phát ra thành tiếng: gang bền nhưng giòn * cá rán giòn * bánh đa nướng giòn",
    example: "gang bền nhưng giòn * cá rán giòn * bánh đa nướng giòn",
  },
  {
    word: "giòn",
    part_of_speech: "tính từ",
    meaning:
      "(âm thanh) vang, gọn và liên tiếp, nghe vui tai: tiếng cười giòn * pháo nổ giòn",
    example: "tiếng cười giòn * pháo nổ giòn",
  },
  {
    word: "giòn",
    part_of_speech: "tính từ",
    meaning:
      'có vẻ đẹp khoẻ mạnh, dễ ưa (thường nói về phụ nữ): nước da đen giòn * "Ở nhà nhất mẹ nhì con, Ra đường lắm kẻ còn giòn hơn ta." (ca dao)',
    example:
      'nước da đen giòn * "Ở nhà nhất mẹ nhì con, Ra đường lắm kẻ còn giòn hơn ta." (ca dao)',
  },
  {
    word: "giỏi giang",
    part_of_speech: "tính từ",
    meaning:
      "giỏi, tháo vát (nói khái quát): buôn bán giỏi giang * giỏi giang việc đồng áng",
    example: "buôn bán giỏi giang * giỏi giang việc đồng áng",
  },
  {
    word: "giòn giã",
    part_of_speech: "tính từ",
    meaning:
      "(âm thanh) vang lên liên tục thành tràng, nghe vui tai: pháo nổ giòn giã * tiếng cười giòn giã",
    example: "pháo nổ giòn giã * tiếng cười giòn giã",
  },
  {
    word: "giòn giã",
    part_of_speech: "tính từ",
    meaning:
      "(chiến thắng) nhanh, gọn và có tiếng vang: thắng lợi giòn giã * đánh một trận giòn giã",
    example: "thắng lợi giòn giã * đánh một trận giòn giã",
  },
  {
    word: "gion giỏn",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả giọng trẻ con nói nghe đã rõ ràng, rành mạch, có phần láu lỉnh: thằng bé nói gion giỏn cả ngày * cãi mẹ gion giỏn",
    example: "thằng bé nói gion giỏn cả ngày * cãi mẹ gion giỏn",
  },
  {
    word: "giong",
    part_of_speech: "danh từ",
    meaning:
      "cành tre không còn ở trên cây nữa: nhặt củi giong * lấy cành giong làm bờ giậu",
    example: "nhặt củi giong * lấy cành giong làm bờ giậu",
  },
  {
    word: "giọng",
    part_of_speech: "danh từ",
    meaning:
      "độ cao thấp, mạnh yếu của lời nói, tiếng hát: giọng khàn * ca sĩ đang luyện giọng",
    example: "giọng khàn * ca sĩ đang luyện giọng",
  },
  {
    word: "giọng",
    part_of_speech: "danh từ",
    meaning:
      "cách phát âm riêng của một vùng, một địa phương: giọng miền Nam * giả giọng Huế",
    example: "giọng miền Nam * giả giọng Huế",
  },
  {
    word: "giọng",
    part_of_speech: "danh từ",
    meaning:
      "cách biểu thị tình cảm, thái độ thông qua ngôn ngữ: ra giọng ta đây * giọng văn đanh thép",
    example: "ra giọng ta đây * giọng văn đanh thép",
  },
  {
    word: "giọng",
    part_of_speech: "danh từ",
    meaning: "gam đã xác định âm chủ: giọng fa",
    example: "giọng fa",
  },
  {
    word: "giòn tan",
    part_of_speech: "tính từ",
    meaning:
      "(thức ăn) rất giòn, nhai nghe rau ráu: bánh giòn tan * rán giòn tan",
    example: "bánh giòn tan * rán giòn tan",
  },
  {
    word: "giòn tan",
    part_of_speech: "tính từ",
    meaning:
      "(âm thanh) rất giòn, nghe vui tai: cười giòn tan * chuyện trò giòn tan * pháo nổ giòn tan",
    example: "cười giòn tan * chuyện trò giòn tan * pháo nổ giòn tan",
  },
  {
    word: "giỏng",
    part_of_speech: "động từ",
    meaning:
      "dựng thẳng lên (thường nói về tai): dỏng tai lên nghe ngóng * con chó dỏng đuôi sủa",
    example: "dỏng tai lên nghe ngóng * con chó dỏng đuôi sủa",
  },
  {
    word: "gióng",
    part_of_speech: "danh từ",
    meaning:
      "đoạn giữa hai mắt của một số cây có thân thẳng: gióng mía * gióng tre",
    example: "gióng mía * gióng tre",
  },
  {
    word: "gióng",
    part_of_speech: "danh từ",
    meaning:
      '(phương ngữ) quang: "Lên rừng bứt một sợi mây, Đem về thắt gióng cho nàng đi buôn." (ca dao)',
    example:
      'Lên rừng bứt một sợi mây, Đem về thắt gióng cho nàng đi buôn." (ca dao)',
  },
  {
    word: "gióng",
    part_of_speech: "động từ",
    meaning: "đánh mạnh cho kêu to vang lên thành từng hồi: gióng chuông",
    example: "gióng chuông",
  },
  {
    word: "gióng",
    part_of_speech: "động từ",
    meaning:
      "cất cao tiếng, cốt cho người ở phía xa có thể nghe thấy: hỏi gióng theo * đứng ngoài đường gọi gióng vào",
    example: "hỏi gióng theo * đứng ngoài đường gọi gióng vào",
  },
  {
    word: "gióng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nói như để báo trước điều sẽ làm: chuyện ấy anh ta đã gióng từ lâu rồi * gióng trước cả tháng mà chưa thấy làm",
    example:
      "chuyện ấy anh ta đã gióng từ lâu rồi * gióng trước cả tháng mà chưa thấy làm",
  },
  {
    word: "gióng giả",
    part_of_speech: "tính từ",
    meaning:
      "(âm thanh) vang lên liên tục, như kêu gọi, thúc giục: cuốc kêu gióng giả * chuông chùa gióng giả từng hồi",
    example: "cuốc kêu gióng giả * chuông chùa gióng giả từng hồi",
  },
  {
    word: "gióng giả",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nói gióng nhiều lần (mà không thấy làm): gióng giả từ lâu rồi mà chẳng thấy động tĩnh gì",
    example: "gióng giả từ lâu rồi mà chẳng thấy động tĩnh gì",
  },
  {
    word: "giọng lưỡi",
    part_of_speech: "danh từ",
    meaning: "lối nói, lời lẽ xảo trá, không thật: giọng lưỡi con buôn",
    example: "giọng lưỡi con buôn",
  },
  {
    word: "gióng một",
    part_of_speech: "tính từ",
    meaning:
      "(cách nói năng) ngắt thành những tiếng cách quãng, đều đều: nói gióng một * trả lời gióng một",
    example: "nói gióng một * trả lời gióng một",
  },
  {
    word: "giọng điệu",
    part_of_speech: "danh từ",
    meaning:
      "giọng nói, lối nói biểu thị một thái độ nhất định: giọng điệu mỉa mai * giọng điệu chán chường",
    example: "giọng điệu mỉa mai * giọng điệu chán chường",
  },
  {
    word: "giọng điệu",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như ngữ điệu: giọng điệu lên xuống, lúc trầm lúc bổng",
    example: "giọng điệu lên xuống, lúc trầm lúc bổng",
  },
  {
    word: "giọt",
    part_of_speech: "danh từ",
    meaning:
      "lượng rất nhỏ chất lỏng, có dạng hạt: giọt sương * giống nhau như hai giọt nước * mồ hôi nhỏ giọt",
    example: "giọt sương * giống nhau như hai giọt nước * mồ hôi nhỏ giọt",
  },
  {
    word: "giọt",
    part_of_speech: "danh từ",
    meaning:
      "chỗ các giọt nước mưa từ mái nhà chảy xuống: giọt gianh * đứng ở giọt thềm",
    example: "giọt gianh * đứng ở giọt thềm",
  },
  {
    word: "giọt",
    part_of_speech: "động từ",
    meaning:
      "đập, nện mạnh xuống một điểm bằng búa, chày, v.v.: tiếng búa giọt chan chát trên đe",
    example: "tiếng búa giọt chan chát trên đe",
  },
  {
    word: "giọt",
    part_of_speech: "động từ",
    meaning: "(thông tục) đánh mạnh, đánh đau: vừa bị giọt cho một trận",
    example: "vừa bị giọt cho một trận",
  },
  {
    word: "giỗ",
    part_of_speech: "danh từ",
    meaning:
      "lễ tưởng nhớ người đã chết đúng vào ngày chết, hằng năm, thường có cúng lễ theo phong tục: giỗ tổ Hùng Vương * ngày giỗ cha",
    example: "giỗ tổ Hùng Vương * ngày giỗ cha",
  },
  {
    word: "giỗ chạp",
    part_of_speech: "danh từ",
    meaning: "việc cúng giỗ (nói khái quát): những ngày giỗ chạp",
    example: "những ngày giỗ chạp",
  },
  {
    word: "giọt hồng",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) giọt nước mắt đau đớn, sầu thảm, tưởng như nhuốm cả máu: "Nhìn càng lã chã giọt hồng, Rỉ tai, nàng mới giải lòng thấp cao." (TKiều)',
    example:
      'Nhìn càng lã chã giọt hồng, Rỉ tai, nàng mới giải lòng thấp cao." (TKiều)',
  },
  {
    word: "giội",
    part_of_speech: "động từ",
    meaning:
      "đổ từ trên cao xuống nhiều và mạnh: giội nước ào ào * nắng như giội lửa",
    example: "giội nước ào ào * nắng như giội lửa",
  },
  {
    word: "giỗ tết",
    part_of_speech: "danh từ",
    meaning: "ngày giỗ và ngày tết, nói chung: lo việc giỗ tết",
    example: "lo việc giỗ tết",
  },
  {
    word: "giông",
    part_of_speech: "tính từ",
    meaning:
      "có thể sẽ gặp phải điều không hay về sau, do đầu năm hay sáng sớm đã gặp hay làm phải điều coi là gở, theo tín ngưỡng dân gian: ngày mùng một Tết không dám quét nhà sợ giông cả năm",
    example: "ngày mùng một Tết không dám quét nhà sợ giông cả năm",
  },
  {
    word: "giông bão",
    part_of_speech: "danh từ",
    meaning:
      "dông và bão (nói khái quát); thường dùng để ví những gian nan, thử thách, hoặc sự việc xảy ra dữ dội, mãnh liệt: dông bão của cuộc đời * trong nhà đã xảy ra dông bão",
    example: "dông bão của cuộc đời * trong nhà đã xảy ra dông bão",
  },
  {
    word: "giôn giốt",
    part_of_speech: "tính từ",
    meaning: "có vị chua nhẹ, dễ ăn: bưởi chua giôn giốt",
    example: "bưởi chua giôn giốt",
  },
  {
    word: "giồng",
    part_of_speech: "danh từ",
    meaning:
      "dải đất phù sa nổi cao lên, thường ở ven sông: đất giồng * giồng cát",
    example: "đất giồng * giồng cát",
  },
  {
    word: "giống hệt",
    part_of_speech: "tính từ",
    meaning: "giống đến mức tưởng như chỉ là một: hai chiếc cặp giống hệt nhau",
    example: "hai chiếc cặp giống hệt nhau",
  },
  {
    word: "giống",
    part_of_speech: "danh từ",
    meaning:
      "vật dùng để sản xuất ra những vật đồng loại, trong trồng trọt hay chăn nuôi: con giống * nhân giống * để thóc giống",
    example: "con giống * nhân giống * để thóc giống",
  },
  {
    word: "giống",
    part_of_speech: "danh từ",
    meaning:
      "thứ cây trồng thuộc cùng một loài và có những đặc điểm giống nhau về mặt sinh học, sinh thái cũng như về mặt trồng trọt: giống nhãn Hưng Yên * giống lúa ba giăng",
    example: "giống nhãn Hưng Yên * giống lúa ba giăng",
  },
  {
    word: "giống",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ nòi trong động vật nuôi: giống gà tam hoàng * giống lợn lai kinh tế",
    example: "giống gà tam hoàng * giống lợn lai kinh tế",
  },
  {
    word: "giống",
    part_of_speech: "danh từ",
    meaning:
      "từ thông thường chỉ nòi người, các nhóm người lớn, phân biệt với nhau bởi một số đặc điểm di truyền như hình dạng, màu da, v.v.: giống người da trắng",
    example: "giống người da trắng",
  },
  {
    word: "giống",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) hạng, loại người (hàm ý khinh; thường dùng trong lời chửi, mắng): giống ngu đần * cái giống nhà mày không ưa nhẹ!",
    example: "giống ngu đần * cái giống nhà mày không ưa nhẹ!",
  },
  {
    word: "giống",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị phân loại sinh học, dưới họ, trên loài: giống cáo thuộc họ chó",
    example: "giống cáo thuộc họ chó",
  },
  {
    word: "giống",
    part_of_speech: "danh từ",
    meaning: "từ chỉ giới tính của động vật: giống đực * giống cái",
    example: "giống đực * giống cái",
  },
  {
    word: "giống",
    part_of_speech: "danh từ",
    meaning:
      "phạm trù ngữ pháp của danh từ, tính từ, đại từ trong một số ngôn ngữ: danh từ trong tiếng Nga có ba giống: giống cái, giống đực, giống trung",
    example:
      "danh từ trong tiếng Nga có ba giống: giống cái, giống đực, giống trung",
  },
  {
    word: "giống",
    part_of_speech: "tính từ",
    meaning:
      "có những nét chung, những nét tương tự nhau về hình dáng, tính chất hoặc màu sắc, v.v.: con giống cha * mỗi người một ý, chẳng ai giống ai",
    example: "con giống cha * mỗi người một ý, chẳng ai giống ai",
  },
  {
    word: "giông giống",
    part_of_speech: "tính từ",
    meaning: "hơi giống: hai người cũng giông giống nhau",
    example: "hai người cũng giông giống nhau",
  },
  {
    word: "giông tố",
    part_of_speech: "danh từ",
    meaning:
      "cơn dông có gió to (nói khái quát); thường dùng để ví cảnh gian nan, đầy thử thách, hoặc việc xảy ra dữ dội, mãnh liệt: trời nổi dông tố * cuộc đời đầy dông tố",
    example: "trời nổi dông tố * cuộc đời đầy dông tố",
  },
  {
    word: "giở",
    part_of_speech: "động từ",
    meaning:
      "mở một vật đang được gấp hoặc đang gói bọc ra: giở báo ra đọc * giở gói bánh",
    example: "giở báo ra đọc * giở gói bánh",
  },
  {
    word: "giở",
    part_of_speech: "động từ",
    meaning:
      "đưa ra dùng để đối phó lại: giở mọi thủ đoạn * giở mánh khoé để lừa gạt",
    example: "giở mọi thủ đoạn * giở mánh khoé để lừa gạt",
  },
  {
    word: "giơ",
    part_of_speech: "động từ",
    meaning:
      "đưa cao lên hoặc đưa ra phía trước: giơ nắm đấm đe doạ * giơ tay xin hàng",
    example: "giơ nắm đấm đe doạ * giơ tay xin hàng",
  },
  {
    word: "giơ",
    part_of_speech: "động từ",
    meaning: "để lộ cả ra ngoài (cái thường được che kín): gầy giơ xương",
    example: "gầy giơ xương",
  },
  {
    word: "giống nòi",
    part_of_speech: "danh từ",
    meaning:
      "toàn thể nói chung những người có cùng gốc rễ tổ tiên lâu đời, gồm nhiều thế hệ nối tiếp nhau; thường dùng để chỉ dân tộc: cùng chung một giống nòi * vẻ vang giống nòi",
    example: "cùng chung một giống nòi * vẻ vang giống nòi",
  },
  {
    word: "giờ chính thức",
    part_of_speech: "danh từ",
    meaning:
      "giờ được quy định dùng thống nhất cho các địa phương trong một nước: giờ chính thức của Việt Nam sớm hơn giờ quốc tế bảy giờ",
    example: "giờ chính thức của Việt Nam sớm hơn giờ quốc tế bảy giờ",
  },
  {
    word: "giờ",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị đo thời gian, bằng 60 phút, 3.600 giây: một ngày có 24 giờ * chờ suốt mấy giờ đồng hồ",
    example: "một ngày có 24 giờ * chờ suốt mấy giờ đồng hồ",
  },
  {
    word: "giờ",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị đo thời gian theo phép đếm thời gian cổ truyền của Trung Quốc, gọi tên theo mười hai chi: giờ Ngọ (từ 11 giờ đến 13 giờ) * sinh vào giờ dần",
    example: "giờ Ngọ (từ 11 giờ đến 13 giờ) * sinh vào giờ dần",
  },
  {
    word: "giờ",
    part_of_speech: "danh từ",
    meaning:
      "thời điểm chính xác trong ngày, thực tế được xác định dựa theo đồng hồ, và được đánh số từ 1 đến 12 (một nửa ngày đêm) hoặc từ 1 đến 24 (một ngày đêm): bây giờ là 17 giờ (5 giờ chiều) * thức dậy từ 2 giờ sáng",
    example: "bây giờ là 17 giờ (5 giờ chiều) * thức dậy từ 2 giờ sáng",
  },
  {
    word: "giờ",
    part_of_speech: "danh từ",
    meaning:
      "thời điểm trong ngày, về mặt tiến hành một công việc nào đó: xem giờ tàu * muộn giờ học",
    example: "xem giờ tàu * muộn giờ học",
  },
  {
    word: "giờ",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian trong ngày, về mặt được sử dụng vào việc gì đó, hay có đặc điểm gì đó: đang giờ làm việc * giờ cao điểm * nghỉ giữa giờ",
    example: "đang giờ làm việc * giờ cao điểm * nghỉ giữa giờ",
  },
  {
    word: "giờ",
    part_of_speech: "danh từ",
    meaning:
      "thời điểm tốt, xấu, theo tín ngưỡng dân gian: sinh được giờ * xem giờ để xuất hành",
    example: "sinh được giờ * xem giờ để xuất hành",
  },
  {
    word: "giờ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) thời điểm đang nói: từ nãy đến giờ * giờ thì trông anh ta đã khác hẳn * làm đến giờ mới xong",
    example:
      "từ nãy đến giờ * giờ thì trông anh ta đã khác hẳn * làm đến giờ mới xong",
  },
  {
    word: "giở chứng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bỗng nhiên sinh ra tật xấu hoặc thay đổi trạng thái theo chiều hướng xấu: đang đi tự nhiên xe trở chứng, chết máy",
    example: "đang đi tự nhiên xe trở chứng, chết máy",
  },
  {
    word: "giờ g",
    part_of_speech: "danh từ",
    meaning:
      "thời điểm, đã được bí mật ấn định trước, để bắt đầu tiến hành một việc quan trọng nào đó: giờ G đã điểm",
    example: "giờ G đã điểm",
  },
  {
    word: "giờ đây",
    part_of_speech: "đại từ",
    meaning:
      "(khẩu ngữ) lúc này đây, giờ này đây: xa nhau lâu rồi, giờ đây mới gặp * giờ đây mọi việc đã thay đổi",
    example: "xa nhau lâu rồi, giờ đây mới gặp * giờ đây mọi việc đã thay đổi",
  },
  {
    word: "giở giọng",
    part_of_speech: "động từ",
    meaning:
      "dùng lối nói, luận điệu quen thuộc thể hiện thái độ xấu đối với người nào đó: giở giọng gây sự * giở giọng lưu manh",
    example: "giở giọng gây sự * giở giọng lưu manh",
  },
  {
    word: "giở giọng",
    part_of_speech: "động từ",
    meaning:
      "tráo trở, có lối nói, thái độ khác hẳn với trước đó: doạ dẫm mãi không được lại giở giọng nịnh nọt",
    example: "doạ dẫm mãi không được lại giở giọng nịnh nọt",
  },
  {
    word: "giờ hành chính",
    part_of_speech: "danh từ",
    meaning:
      "giờ làm việc hằng ngày, được quy định thống nhất ở các cơ quan hành chính: làm thêm ngoài giờ hành chính",
    example: "làm thêm ngoài giờ hành chính",
  },
  {
    word: "giờ giấc",
    part_of_speech: "danh từ",
    meaning:
      "thời gian nhất định dành cho từng việc khác nhau trong ngày (nói khái quát): làm việc đúng giờ giấc",
    example: "làm việc đúng giờ giấc",
  },
  {
    word: "giở giói",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bày vẽ thêm chuyện, gây phiền phức, lôi thôi: làm giản tiện thôi, giở giói ra làm gì!",
    example: "làm giản tiện thôi, giở giói ra làm gì!",
  },
  {
    word: "giở giói",
    part_of_speech: "động từ",
    meaning:
      "giở trò này, trò kia (nói khái quát): đang yên đang lành sao lại giở giói ra như vậy?",
    example: "đang yên đang lành sao lại giở giói ra như vậy?",
  },
  {
    word: "giờ lâu",
    part_of_speech: "danh từ",
    meaning:
      '(khẩu ngữ) khoảng thời gian khá lâu; một lúc lâu: đứng lặng giờ lâu * "Cò kè bớt một thêm hai, Giờ lâu ngã giá vàng ngoài bốn trăm." (TKiều)',
    example:
      'đứng lặng giờ lâu * "Cò kè bớt một thêm hai, Giờ lâu ngã giá vàng ngoài bốn trăm." (TKiều)',
  },
  {
    word: "giờ khắc",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như giờ phút: những giờ khắc khó quên",
    example: "những giờ khắc khó quên",
  },
  {
    word: "giở quẻ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) thay đổi thái độ hoặc trạng thái đột ngột, theo chiều hướng xấu đi, gây khó khăn, phiền phức: cái máy cũ chạy một lúc lại giở quẻ * đã nhận lời rồi lại giở quẻ từ chối",
    example:
      "cái máy cũ chạy một lúc lại giở quẻ * đã nhận lời rồi lại giở quẻ từ chối",
  },
  {
    word: "giờ hồn",
    part_of_speech: "động từ",
    meaning:
      '(phương ngữ) như liệu hồn: "Mày cứ liệu! Đánh nó rồi bao giờ mẹ nó về nó mách mẹ nó thì lại giờ hồn sớm!" (MPTư; 1)',
    example:
      'Mày cứ liệu! Đánh nó rồi bao giờ mẹ nó về nó mách mẹ nó thì lại giờ hồn sớm!" (MPTư; 1)',
  },
  {
    word: "giờ quốc tế",
    part_of_speech: "danh từ",
    meaning:
      "giờ của kinh tuyến gốc (kinh tuyến đi qua đài thiên văn Greenwich ở ngoại ô London), hiện nay được lấy làm giờ gốc trong tính toán khoa học và thông tin giữa các nước: lúc 0 giờ, giờ quốc tế, thì ở Việt Nam là 7 giờ",
    example: "lúc 0 giờ, giờ quốc tế, thì ở Việt Nam là 7 giờ",
  },
  {
    word: "giờ phút",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian ngắn được tính bằng giờ, bằng phút trong đó có sự việc đáng ghi nhớ nào đó diễn ra: những giờ phút đi vào lịch sử",
    example: "những giờ phút đi vào lịch sử",
  },
  {
    word: "giở trò",
    part_of_speech: "động từ",
    meaning:
      "dùng lối làm quen thuộc thể hiện thái độ xấu đối với người nào đó: giở trò lừa đảo * định giở trò ma cũ bắt nạt ma mới đấy phỏng?",
    example: "giở trò lừa đảo * định giở trò ma cũ bắt nạt ma mới đấy phỏng?",
  },
  {
    word: "giở trò",
    part_of_speech: "động từ",
    meaning:
      "giở lối làm, thái độ xấu, ngược hẳn lại lúc trước: đừng có giở trò * dụ dỗ em không được thì giở trò doạ dẫm",
    example: "đừng có giở trò * dụ dỗ em không được thì giở trò doạ dẫm",
  },
  {
    word: "giới hạn",
    part_of_speech: "danh từ",
    meaning:
      "phạm vi, mức độ nhất định, không thể hoặc không được phép vượt qua: sức lực con người là có giới hạn * vượt quá giới hạn",
    example: "sức lực con người là có giới hạn * vượt quá giới hạn",
  },
  {
    word: "giới hạn",
    part_of_speech: "danh từ",
    meaning:
      "giá trị mà một đại lượng biến thiên trong một quá trình nào đó có thể tiến đến gần bao nhiêu tuỳ ý: vận tốc giới hạn * đại lượng vô cùng lớn không có giới hạn",
    example: "vận tốc giới hạn * đại lượng vô cùng lớn không có giới hạn",
  },
  {
    word: "giới hạn",
    part_of_speech: "động từ",
    meaning:
      "quy định trong một giới hạn: giới hạn đề tài trong một phạm vi cụ thể * giới hạn vấn đề",
    example: "giới hạn đề tài trong một phạm vi cụ thể * giới hạn vấn đề",
  },
  {
    word: "giời",
    part_of_speech: "danh từ",
    meaning:
      "động vật nhiều chân cùng họ với rết, nhưng thân mảnh hơn, tiết chất có thể làm bỏng da người: bị giời leo",
    example: "bị giời leo",
  },
  {
    word: "giới chức",
    part_of_speech: "danh từ",
    meaning:
      "người có chức vụ cao, đại diện cho một ngành, một đơn vị, một địa phương, v.v. nào đó (nói khái quát): giới chức quân sự * nguồn tin do giới chức của công ti cho biết",
    example: "giới chức quân sự * nguồn tin do giới chức của công ti cho biết",
  },
  {
    word: "giới",
    part_of_speech: "danh từ",
    meaning:
      "lớp người trong xã hội được phân theo một đặc điểm chung nào đó, về nghề nghiệp, địa vị xã hội, v.v.: giới báo chí * giới trí thức * giới quân sự",
    example: "giới báo chí * giới trí thức * giới quân sự",
  },
  {
    word: "giới",
    part_of_speech: "danh từ",
    meaning: "đơn vị phân loại sinh học lớn nhất, trên ngành: giới thực vật",
    example: "giới thực vật",
  },
  {
    word: "giới nghiêm",
    part_of_speech: "động từ",
    meaning:
      "nghiêm cấm bằng mệnh lệnh quân sự về việc đi lại, tụ họp, v.v. trong những khu vực và thời gian nhất định: lệnh giới nghiêm",
    example: "lệnh giới nghiêm",
  },
  {
    word: "giới thiệu",
    part_of_speech: "động từ",
    meaning:
      "cho biết một vài điều cần thiết, như họ tên, nghề nghiệp, chức vụ, v.v. về một người nào đó để làm quen với nhau: giới thiệu bạn với gia đình * mọi người lần lượt tự giới thiệu",
    example: "giới thiệu bạn với gia đình * mọi người lần lượt tự giới thiệu",
  },
  {
    word: "giới thiệu",
    part_of_speech: "động từ",
    meaning:
      "cho biết rõ về một người nào đó và đề nghị thu nạp vào tổ chức: giới thiệu vào hội * giới thiệu vào ban chấp hành",
    example: "giới thiệu vào hội * giới thiệu vào ban chấp hành",
  },
  {
    word: "giới thiệu",
    part_of_speech: "động từ",
    meaning:
      "cho biết những đặc điểm cơ bản của một tác phẩm, một sản phẩm hay một sự vật, sự việc mới lạ nào đó: giới thiệu sản phẩm * ở đầu quyển sách có in lời giới thiệu",
    example: "giới thiệu sản phẩm * ở đầu quyển sách có in lời giới thiệu",
  },
  {
    word: "giới tuyến",
    part_of_speech: "danh từ",
    meaning:
      "đường ranh giới giữa hai khu vực: giới tuyến quân sự * bên kia giới tuyến",
    example: "giới tuyến quân sự * bên kia giới tuyến",
  },
  {
    word: "giới tính",
    part_of_speech: "danh từ",
    meaning:
      "những đặc điểm chung phân biệt nam với nữ, giống đực với giống cái: không phân biệt giới tính, tuổi tác",
    example: "không phân biệt giới tính, tuổi tác",
  },
  {
    word: "giũa",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ bằng thép, có khía dùng để mài vật khác cho sắc hoặc cho nhẵn: cái giũa",
    example: "cái giũa",
  },
  {
    word: "giũa",
    part_of_speech: "động từ",
    meaning: "mài bằng giũa: giũa móng tay",
    example: "giũa móng tay",
  },
  {
    word: "giũ",
    part_of_speech: "động từ",
    meaning:
      "rung, lắc mạnh cho rơi nước hay bụi bẩn bám vào ra: giũ chiếu * giũ bụi bám trên quần áo * chim giũ cánh",
    example: "giũ chiếu * giũ bụi bám trên quần áo * chim giũ cánh",
  },
  {
    word: "giũ",
    part_of_speech: "động từ",
    meaning:
      "làm cho sạch đồ giặt bằng cách giũ nhiều lần sau khi nhúng trong nước: quần áo mới vò, chưa giũ * giũ cho sạch xà phòng mới thôi",
    example: "quần áo mới vò, chưa giũ * giũ cho sạch xà phòng mới thôi",
  },
  {
    word: "giỡn",
    part_of_speech: "động từ",
    meaning: "(Phương ngữ) đùa: nói giỡn cho vui",
    example: "nói giỡn cho vui",
  },
  {
    word: "giục",
    part_of_speech: "động từ",
    meaning:
      "tác động bằng lời nói, động tác, cử chỉ để cho làm ngay hoặc làm nhanh hơn việc gì đó: giục làm nhanh * làm gì mà cứ giục toáy lên thế?",
    example: "giục làm nhanh * làm gì mà cứ giục toáy lên thế?",
  },
  {
    word: "giú",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) rấm: giú chuối",
    example: "giú chuối",
  },
  {
    word: "giục giã",
    part_of_speech: "động từ",
    meaning: "giục liên tiếp: gà giục giã gáy sáng * tiếng trống giục giã",
    example: "gà giục giã gáy sáng * tiếng trống giục giã",
  },
  {
    word: "giục giặc",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) dùng dằng, lưỡng lự: còn dục dặc, chưa dám quyết * thái độ dục dặc",
    example: "còn dục dặc, chưa dám quyết * thái độ dục dặc",
  },
  {
    word: "giùm",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) giúp, hộ: nhờ làm giùm * nói giùm một câu",
    example: "nhờ làm giùm * nói giùm một câu",
  },
  {
    word: "giủi",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ giủi) đồ đan bằng tre để xúc bắt tôm, cá: mang nhủi ra ao xúc cá",
    example: "mang nhủi ra ao xúc cá",
  },
  {
    word: "giủi",
    part_of_speech: "động từ",
    meaning: "(phương ngữ giủi) xúc bắt tôm, cá bằng cái nhủi: đi nhủi tôm",
    example: "đi nhủi tôm",
  },
  {
    word: "giủi",
    part_of_speech: "động từ",
    meaning:
      "đưa đầu đẩy tới phía trước, cố khắc phục vật chướng ngại để di chuyển: con dế đùn đất nhủi lên",
    example: "con dế đùn đất nhủi lên",
  },
  {
    word: "giủi",
    part_of_speech: "động từ",
    meaning: "(Nam) chui vào chỗ kín: con chuột nhủi mất * cua nhủi vô hang",
    example: "con chuột nhủi mất * cua nhủi vô hang",
  },
  {
    word: "giủi",
    part_of_speech: "động từ",
    meaning: "(Nam) chúi xuống, chúc xuống: té nhủi",
    example: "té nhủi",
  },
  {
    word: "giun",
    part_of_speech: "danh từ",
    meaning:
      "động vật không xương sống, thân dẹp hoặc tròn, thường có phân đốt..",
    example: "con giun xéo lắm cũng quằn (tng)",
  },
  {
    word: "giun",
    part_of_speech: "danh từ",
    meaning: "giun đất (nói tắt): con giun xéo lắm cũng quằn (tng)",
    example: "tẩy giun * giun chui ống mật",
  },
  {
    word: "giúp đỡ",
    part_of_speech: "động từ",
    meaning:
      "giúp để làm giảm bớt khó khăn hoặc để thực hiện được một công việc nào đó: giúp đỡ nhau học tập * giúp đỡ cả về vật chất lẫn tinh thần",
    example: "giúp đỡ nhau học tập * giúp đỡ cả về vật chất lẫn tinh thần",
  },
  {
    word: "giuộc",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng thường bằng tre hay sắt tây, có cán dài, để đong, múc chất lỏng trong vật đựng có đáy sâu: một giuộc nước mắm",
    example: "một giuộc nước mắm",
  },
  {
    word: "giuộc",
    part_of_speech: "danh từ",
    meaning: "hạng, lũ (hàm ý khinh): bọn chúng cùng một giuộc với nhau",
    example: "bọn chúng cùng một giuộc với nhau",
  },
  {
    word: "giúp",
    part_of_speech: "động từ",
    meaning:
      "làm cho ai việc gì đó, hoặc lấy của mình cái gì đem cho ai đó vì thấy người ấy đang cần: mỗi người giúp một tay * đi giúp đám cưới",
    example: "mỗi người giúp một tay * đi giúp đám cưới",
  },
  {
    word: "giúp",
    part_of_speech: "động từ",
    meaning:
      "có tác dụng tích cực, làm cho việc gì đó được thuận lợi hơn: thời gian sẽ giúp xoa dịu nỗi đau * nghị lực và ý chí đã giúp anh ấy thành công",
    example:
      "thời gian sẽ giúp xoa dịu nỗi đau * nghị lực và ý chí đã giúp anh ấy thành công",
  },
  {
    word: "giữ chân",
    part_of_speech: "động từ",
    meaning:
      'giữ lại, níu kéo không để cho đi: "Cảm thương con hạc ở chùa, Muốn bay da diết, có rùa giữ chân." (ca dao)',
    example:
      'Cảm thương con hạc ở chùa, Muốn bay da diết, có rùa giữ chân." (ca dao)',
  },
  {
    word: "giúp sức",
    part_of_speech: "động từ",
    meaning:
      "góp sức lực để giúp thực hiện một công việc nào đó: tận tâm giúp sức * đi cùng để giúp sức lúc khó khăn",
    example: "tận tâm giúp sức * đi cùng để giúp sức lúc khó khăn",
  },
  {
    word: "giúp việc",
    part_of_speech: "động từ",
    meaning:
      "làm những việc nghiệp vụ trợ giúp cho công việc chính: nhân viên giúp việc * người giúp việc đắc lực",
    example: "nhân viên giúp việc * người giúp việc đắc lực",
  },
  {
    word: "giúp việc",
    part_of_speech: "động từ",
    meaning:
      "làm các công việc phục vụ sinh hoạt cho một gia đình nào đó để lấy công (nói khái quát): nhà có trẻ con, phải thuê người giúp việc",
    example: "nhà có trẻ con, phải thuê người giúp việc",
  },
  {
    word: "giúp ích",
    part_of_speech: "động từ",
    meaning:
      "đem lại những điều có ích: ra sức giúp ích cho nước nhà * điều đó không giúp ích gì cho việc học tập",
    example:
      "ra sức giúp ích cho nước nhà * điều đó không giúp ích gì cho việc học tập",
  },
  {
    word: "giữ",
    part_of_speech: "động từ",
    meaning:
      "làm cho ở nguyên tại vị trí nào đó, không có sự di động, di chuyển, hoặc không rơi, không đổ: giữ thang * giữ không cho về * khư khư như từ giữ oản (tng)",
    example: "giữ thang * giữ không cho về * khư khư như từ giữ oản (tng)",
  },
  {
    word: "giữ",
    part_of_speech: "động từ",
    meaning:
      "làm cho vẫn nguyên như vậy, không thay đổi: giữ lời hứa * vẫn giữ thói quen cũ * giữ mồm giữ miệng",
    example: "giữ lời hứa * vẫn giữ thói quen cũ * giữ mồm giữ miệng",
  },
  {
    word: "giữ",
    part_of_speech: "động từ",
    meaning:
      "trông coi, để ý đến để không bị mất mát, tổn hại: giữ nhà * giữ em cho mẹ đi làm * giữ sức khoẻ",
    example: "giữ nhà * giữ em cho mẹ đi làm * giữ sức khoẻ",
  },
  {
    word: "giữ",
    part_of_speech: "động từ",
    meaning:
      "đảm đương, chịu trách nhiệm: giữ chức trưởng phòng * giữ vai trò lớp trưởng",
    example: "giữ chức trưởng phòng * giữ vai trò lớp trưởng",
  },
  {
    word: "giữ giàng",
    part_of_speech: "động từ",
    meaning:
      '(cũ, văn chương) như giữ gìn: "Đàn ông tính khí loang toàng, Đàn bà con gái giữ giàng nết na." (ca dao)',
    example:
      'Đàn ông tính khí loang toàng, Đàn bà con gái giữ giàng nết na." (ca dao)',
  },
  {
    word: "giữ gìn",
    part_of_speech: "động từ",
    meaning:
      "giữ cho được nguyên vẹn, không bị mất mát, tổn hại (nói khái quát): giữ gìn sức khoẻ * giữ gìn bản sắc văn hoá của dân tộc * giữ gìn nhan sắc",
    example:
      "giữ gìn sức khoẻ * giữ gìn bản sắc văn hoá của dân tộc * giữ gìn nhan sắc",
  },
  {
    word: "giữ gìn",
    part_of_speech: "động từ",
    meaning:
      "giữ ý tứ, thận trọng tránh sơ suất trong lời nói và hành động: nói năng thoải mái, không chút giữ gìn",
    example: "nói năng thoải mái, không chút giữ gìn",
  },
  {
    word: "giữ mình",
    part_of_speech: "động từ",
    meaning:
      "chú ý giữ cho bản thân được an toàn: đi đường nên cẩn thận giữ mình * học vài ngón võ để giữ mình",
    example: "đi đường nên cẩn thận giữ mình * học vài ngón võ để giữ mình",
  },
  {
    word: "giữ mình",
    part_of_speech: "động từ",
    meaning:
      "chú ý để giữ cho vẹn tròn danh dự, không bị sa ngã trước các tác động bên ngoài: giữ mình khỏi bị sa ngã",
    example: "giữ mình khỏi bị sa ngã",
  },
  {
    word: "giữ kẽ",
    part_of_speech: "động từ",
    meaning:
      "giữ gìn từng li từng tí một cách quá mức, trong quan hệ đối xử với nhau: ăn nói giữ kẽ * tính hay giữ kẽ",
    example: "ăn nói giữ kẽ * tính hay giữ kẽ",
  },
  {
    word: "giữ miếng",
    part_of_speech: "động từ",
    meaning:
      "giữ kín các thủ đoạn đối phó trước một đối phương thấy là đáng gờm, cần phải chú ý đề phòng: hai bên còn giữ miếng",
    example: "hai bên còn giữ miếng",
  },
  {
    word: "giữ mồm giữ miệng",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) thận trọng trong nói năng để tránh hậu quả, tai hoạ: ăn nói vô tội vạ, không biết giữ mồm giữ miệng",
    example: "ăn nói vô tội vạ, không biết giữ mồm giữ miệng",
  },
  {
    word: "giữ rịt",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) cố giữ lại với mình, không cho rời ra hoặc không chịu bỏ ra: đứa bé giữ rịt lấy mẹ, không cho đi đâu",
    example: "đứa bé giữ rịt lấy mẹ, không cho đi đâu",
  },
  {
    word: "giữ tiếng",
    part_of_speech: "động từ",
    meaning: "giữ cho khỏi bị mang tiếng: giữ tiếng cho gia đình",
    example: "giữ tiếng cho gia đình",
  },
  {
    word: "giữa",
    part_of_speech: "danh từ",
    meaning:
      "vị trí cách đều hai đầu mút hoặc các điểm ở xung quanh: điểm giữa của đoạn thẳng * giữa hai đầu cầu * đứng giữa sân",
    example: "điểm giữa của đoạn thẳng * giữa hai đầu cầu * đứng giữa sân",
  },
  {
    word: "giữa",
    part_of_speech: "danh từ",
    meaning:
      "thời điểm cách đều thời điểm bắt đầu và thời điểm kết thúc: giữa trưa * giữa năm học * nghỉ giữa giờ",
    example: "giữa trưa * giữa năm học * nghỉ giữa giờ",
  },
  {
    word: "giữa",
    part_of_speech: "danh từ",
    meaning:
      "khoảng chia cách hai vật hay hai thời điểm, hai sự kiện: ngồi giữa hai người bạn",
    example: "ngồi giữa hai người bạn",
  },
  {
    word: "giữa",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là khoảng không gian, thời gian xác định trong đó sự việc được nói đến diễn ra: gặp nhau giữa đường * một miếng giữa làng bằng một sàng xó bếp (tng)",
    example:
      "gặp nhau giữa đường * một miếng giữa làng bằng một sàng xó bếp (tng)",
  },
  {
    word: "giữa",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là những đối tượng có quan hệ với nhau hoặc làm thành phạm vi của sự việc được nói đến: giải quyết mâu thuẫn giữa hai bên * giữa sự sống và cái chết",
    example: "giải quyết mâu thuẫn giữa hai bên * giữa sự sống và cái chết",
  },
  {
    word: "giữ ý",
    part_of_speech: "động từ",
    meaning:
      "giữ gìn ý tứ, thận trọng trong nói năng, cử chỉ, để tránh hiểu lầm hoặc tránh làm phật ý: biết bạn buồn nên giữ ý không hỏi * nói năng phải biết giữ ý",
    example: "biết bạn buồn nên giữ ý không hỏi * nói năng phải biết giữ ý",
  },
  {
    word: "giữ ý giữ tứ",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) như giữ ý: mồm miệng oang oang, chẳng giữ ý giữ tứ gì",
    example: "mồm miệng oang oang, chẳng giữ ý giữ tứ gì",
  },
  {
    word: "giương",
    part_of_speech: "động từ",
    meaning:
      "mở, căng ra hết cỡ và đưa cao lên: thuyền giương buồm ra khơi * giương cao ngọn cờ * giương mắt ra nhìn",
    example:
      "thuyền giương buồm ra khơi * giương cao ngọn cờ * giương mắt ra nhìn",
  },
  {
    word: "giường",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng để nằm ngủ, thường làm bằng gỗ, ở trên trải chiếu hoặc đệm: giường cá nhân * giường đôi",
    example: "giường cá nhân * giường đôi",
  },
  {
    word: "giường",
    part_of_speech: "danh từ",
    meaning: "giường bệnh (nói tắt): các giường trong bệnh viện đã chật cứng",
    example: "các giường trong bệnh viện đã chật cứng",
  },
  {
    word: "giữa đường đứt gánh",
    part_of_speech: "",
    meaning:
      'ví việc đang giữa chừng thì đột ngột phải bỏ, bị tan vỡ (thường nói về tình yêu, hôn nhân): "Giữa đường đứt gánh tương tư, Giao loan chắp mối tơ thừa mặc em." (TKiều)',
    example:
      'Giữa đường đứt gánh tương tư, Giao loan chắp mối tơ thừa mặc em." (TKiều)',
  },
  {
    word: "giữa chừng",
    part_of_speech: "phụ từ",
    meaning:
      "giữa lúc đang làm hoặc đang xảy ra việc gì, còn dở dang, chưa xong: bỏ học giữa chừng * câu chuyện bị cắt ngang giữa chừng",
    example: "bỏ học giữa chừng * câu chuyện bị cắt ngang giữa chừng",
  },
  {
    word: "giường nằm",
    part_of_speech: "danh từ",
    meaning:
      "giường được thiết kế riêng cho hành khách nằm khi đi tàu; phân biệt với ghế ngồi: toa giường nằm",
    example: "toa giường nằm",
  },
  {
    word: "giường mối",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) đầu mối chính (nói khái quát); dùng để chỉ khuôn phép, kỉ cương: giềng mối của đạo đức phong kiến",
    example: "giềng mối của đạo đức phong kiến",
  },
  {
    word: "giương vây",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) phô trương lực lượng hoặc sức mạnh để khoe khoang hoặc để ra oai: cuộc giương vây",
    example: "cuộc giương vây",
  },
  {
    word: "gõ",
    part_of_speech: "động từ",
    meaning:
      "đập nhẹ vào vật cứng bằng ngón tay co lại hoặc bằng một vật cứng nhỏ, cho phát ra thành tiếng: gõ cửa * khua chiêng gõ mõ * gõ vào mạn thuyền",
    example: "gõ cửa * khua chiêng gõ mõ * gõ vào mạn thuyền",
  },
  {
    word: "gõ",
    part_of_speech: "động từ",
    meaning:
      "sửa lại những chỗ méo, móp của dụng cụ bằng kim loại bằng cách đập nhẹ vào: gõ lại cái nồi nhôm bị móp",
    example: "gõ lại cái nồi nhôm bị móp",
  },
  {
    word: "go",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận của khung cửi, của máy dệt, gồm nhiều dây bắt chéo nhau từng đôi một, dùng để luồn và đưa sợi dọc lên xuống trong khi dệt: dàn go",
    example: "dàn go",
  },
  {
    word: "gò",
    part_of_speech: "danh từ",
    meaning:
      "khoảng đất nổi cao lên giữa nơi bằng phẳng: gò Đống Đa * ngôi đền được xây dựng trên một gò đất cao",
    example: "gò Đống Đa * ngôi đền được xây dựng trên một gò đất cao",
  },
  {
    word: "gò",
    part_of_speech: "động từ",
    meaning:
      "làm biến dạng tấm kim loại, thường bằng phương pháp thủ công, để tạo thành vật gì đó: gò thùng * gò lại tấm tôn cho thẳng",
    example: "gò thùng * gò lại tấm tôn cho thẳng",
  },
  {
    word: "gò",
    part_of_speech: "động từ",
    meaning:
      "ép vào một khuôn khổ nhất định: gò từng câu, từng chữ * sống gò mình theo ý của người khác",
    example: "gò từng câu, từng chữ * sống gò mình theo ý của người khác",
  },
  {
    word: "gò",
    part_of_speech: "động từ",
    meaning:
      "kéo mạnh một đầu dây cương, dây thừng và giữ thẳng dây để ghìm ngựa hay gia súc lại hoặc bắt phải đi thẳng theo một hướng nhất định: gò cho ngựa đi chậm lại * gò dây cương",
    example: "gò cho ngựa đi chậm lại * gò dây cương",
  },
  {
    word: "gò",
    part_of_speech: "động từ",
    meaning:
      "tự ép mình vào một tư thế không được tự nhiên, thoải mái, để dễ tập trung sức làm việc gì: gò lưng đạp lên dốc * gò cổ kéo chiếc xe lóc cóc",
    example: "gò lưng đạp lên dốc * gò cổ kéo chiếc xe lóc cóc",
  },
  {
    word: "gõ cửa",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tìm đến để trực tiếp nhờ xin giúp đỡ: đi gõ cửa khắp nơi mà vẫn không xin được việc làm",
    example: "đi gõ cửa khắp nơi mà vẫn không xin được việc làm",
  },
  {
    word: "gò bó",
    part_of_speech: "",
    meaning:
      "ép hoặc ở trạng thái bị kìm giữ trong một khuôn khổ quá chật hẹp hoặc một khuôn phép quá chặt chẽ, khiến cho hoạt động hoặc phát triển bị hạn chế, mất tự nhiên: không chịu được cuộc sống gò bó * lễ giáo phong kiến gò bó con người",
    example:
      "không chịu được cuộc sống gò bó * lễ giáo phong kiến gò bó con người",
  },
  {
    word: "gò ép",
    part_of_speech: "động từ",
    meaning:
      "ép phải vào khuôn khổ, khuôn phép nào đó: không chịu được sự gò ép * câu chữ gò ép, không tự nhiên",
    example: "không chịu được sự gò ép * câu chữ gò ép, không tự nhiên",
  },
  {
    word: "gõ đầu trẻ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) dạy học cho trẻ nhỏ (hàm ý đùa hoặc không coi trọng): làm nghề gõ đầu trẻ",
    example: "làm nghề gõ đầu trẻ",
  },
  {
    word: "goá bụa",
    part_of_speech: "tính từ",
    meaning:
      "goá chồng (hoặc đôi khi, goá vợ), về mặt đời sống cô đơn (nói khái quát): sống cảnh goá bụa",
    example: "sống cảnh goá bụa",
  },
  {
    word: "gò má",
    part_of_speech: "danh từ",
    meaning:
      "chỗ hai bên má ít nhiều nổi cao lên ở bên dưới góc ngoài của mắt: đôi gò má ửng hồng * gò má cao",
    example: "đôi gò má ửng hồng * gò má cao",
  },
  {
    word: "góc bẹt",
    part_of_speech: "danh từ",
    meaning: "góc có hai cạnh lập thành một đường thẳng: góc bẹt là góc 180O",
    example: "góc bẹt là góc 180O",
  },
  {
    word: "góc biển chân trời",
    part_of_speech: "",
    meaning:
      '(văn chương) như chân trời góc biển: "Mênh mông góc biển chân trời, Những người thiên hạ nào người tri âm." (ca dao)',
    example:
      'Mênh mông góc biển chân trời, Những người thiên hạ nào người tri âm." (ca dao)',
  },
  {
    word: "góc cạnh",
    part_of_speech: "danh từ",
    meaning: "như khía cạnh: chú ý đến mọi góc cạnh của vấn đề",
    example: "chú ý đến mọi góc cạnh của vấn đề",
  },
  {
    word: "góc cạnh",
    part_of_speech: "danh từ",
    meaning:
      "hoặc t những đường nét như có góc, có cạnh, nổi lên rất rõ (nói khái quát): những nét kí hoạ đầy góc cạnh * gương mặt góc cạnh",
    example: "những nét kí hoạ đầy góc cạnh * gương mặt góc cạnh",
  },
  {
    word: "goá",
    part_of_speech: "tính từ",
    meaning: "có chồng hay vợ đã chết: goá vợ * mẹ goá con côi",
    example: "goá vợ * mẹ goá con côi",
  },
  {
    word: "góc",
    part_of_speech: "danh từ",
    meaning:
      "khoảng không gian ở chỗ tiếp giáp của hai cạnh và nằm phía trong hai cạnh: góc phố * trồng một cây chuối ở góc vườn",
    example: "góc phố * trồng một cây chuối ở góc vườn",
  },
  {
    word: "góc",
    part_of_speech: "danh từ",
    meaning:
      "phần mặt phẳng giới hạn bởi hai nửa đường thẳng cùng xuất phát từ một điểm: tổng các góc trong một tam giác là 180O",
    example: "tổng các góc trong một tam giác là 180O",
  },
  {
    word: "góc",
    part_of_speech: "danh từ",
    meaning:
      "phần, thường có hình góc và là một phần tư, được chia ra của một số vật: một góc bánh chưng",
    example: "một góc bánh chưng",
  },
  {
    word: "góc độ",
    part_of_speech: "danh từ",
    meaning:
      "chỗ đứng để nhìn nhận, đánh giá sự vật, sự việc: nhìn cuộc chiến dưới nhiều góc độ khác nhau * xem xét sự việc dưới góc độ khoa học",
    example:
      "nhìn cuộc chiến dưới nhiều góc độ khác nhau * xem xét sự việc dưới góc độ khoa học",
  },
  {
    word: "gói ghém",
    part_of_speech: "động từ",
    meaning:
      "gói lại cho gọn (nói khái quát): gói ghém, thu dọn hành lí để lên đường",
    example: "gói ghém, thu dọn hành lí để lên đường",
  },
  {
    word: "gói ghém",
    part_of_speech: "động từ",
    meaning:
      "chứa đựng nội dung muốn nói một cách gọn và đầy đủ: cái nhìn đã gói ghém tất cả những gì muốn nói",
    example: "cái nhìn đã gói ghém tất cả những gì muốn nói",
  },
  {
    word: "gọi",
    part_of_speech: "động từ",
    meaning:
      "kêu tên, phát ra tiếng hoặc tín hiệu để người hay vật nghe mà đáp lại hoặc đi đến: gọi tên * gọi như gọi đò * chim gọi bầy",
    example: "gọi tên * gọi như gọi đò * chim gọi bầy",
  },
  {
    word: "gọi",
    part_of_speech: "động từ",
    meaning:
      "phát ra mệnh lệnh, yêu cầu phải đến nơi nào đó: có giấy gọi nhập ngũ * bị gọi lên gặp quan nha",
    example: "có giấy gọi nhập ngũ * bị gọi lên gặp quan nha",
  },
  {
    word: "gọi",
    part_of_speech: "động từ",
    meaning:
      "đặt tên, bằng một từ nào đó hoặc nêu ra, khi nói năng, bằng một từ biểu thị mối quan hệ nào đó với nhau: cháu gọi bằng thím",
    example: "cháu gọi bằng thím",
  },
  {
    word: "gói",
    part_of_speech: "động từ",
    meaning:
      "bao kín và gọn trong một tấm mỏng như giấy, vải, lá, v.v.: gói bánh chưng * gói đồ * gói một gói xôi",
    example: "gói bánh chưng * gói đồ * gói một gói xôi",
  },
  {
    word: "gói",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) thu gọn lại trong một phạm vi nào đó: cuộc hội thảo gói gọn trong một buổi sáng",
    example: "cuộc hội thảo gói gọn trong một buổi sáng",
  },
  {
    word: "gói",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp những gì được gói chung lại với nhau, làm thành một đơn vị: gói kẹo * gói quà Tết * một miếng khi đói bằng một gói khi no (tng)",
    example:
      "gói kẹo * gói quà Tết * một miếng khi đói bằng một gói khi no (tng)",
  },
  {
    word: "gọi thầu",
    part_of_speech: "động từ",
    meaning: "như mời thầu: gọi thầu trong nước * tổ chức gọi thầu và đấu thầu",
    example: "gọi thầu trong nước * tổ chức gọi thầu và đấu thầu",
  },
  {
    word: "gom nhặt",
    part_of_speech: "động từ",
    meaning:
      "gom lại, thu nhặt lại từ nhiều nơi: gom nhặt từng mẩu sắt vụn * tư liệu được gom nhặt từ nhiều nguồn",
    example: "gom nhặt từng mẩu sắt vụn * tư liệu được gom nhặt từ nhiều nguồn",
  },
  {
    word: "gom",
    part_of_speech: "động từ",
    meaning:
      "dồn hết lại một chỗ để làm việc gì hoặc để cho gọn: gom tiền để mua nhà * gom rác",
    example: "gom tiền để mua nhà * gom rác",
  },
  {
    word: "gọi là",
    part_of_speech: "",
    meaning:
      '(khẩu ngữ) coi như là có, chứ thật ra không có gì đáng kể: ăn một ít gọi là * "Gấm trăm cuốn, bạc nghìn cân, Tạ lòng dễ xứng, báo ân gọi là." (TKiều)',
    example:
      'ăn một ít gọi là * "Gấm trăm cuốn, bạc nghìn cân, Tạ lòng dễ xứng, báo ân gọi là." (TKiều)',
  },
  {
    word: "gọi là",
    part_of_speech: "",
    meaning:
      "gọi như thế, nhưng thực chất thì không phải thế (thường dùng với ý mỉa mai): cái gọi là 'dân chủ', 'tự do' của tư bản",
    example: "cái gọi là 'dân chủ', 'tự do' của tư bản",
  },
  {
    word: "gom góp",
    part_of_speech: "động từ",
    meaning:
      "tập hợp lại dần dần và từ nhiều nguồn: gom góp tiền bạc * gom góp từng ít một",
    example: "gom góp tiền bạc * gom góp từng ít một",
  },
  {
    word: "gói thầu",
    part_of_speech: "danh từ",
    meaning:
      "từng phần của dự án, từng hạng mục công trình được đem ra đấu thầu: dự án được thực hiện thông qua 20 gói thầu",
    example: "dự án được thực hiện thông qua 20 gói thầu",
  },
  {
    word: "gom nhóp",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) như góp nhặt: gom nhóp đồ đạc",
    example: "gom nhóp đồ đạc",
  },
  {
    word: "gọn",
    part_of_speech: "tính từ",
    meaning:
      "chiếm ít chỗ và có trật tự hợp lí: gấp gọn quần áo vào trong tủ * búi tóc lại cho gọn",
    example: "gấp gọn quần áo vào trong tủ * búi tóc lại cho gọn",
  },
  {
    word: "gọn",
    part_of_speech: "tính từ",
    meaning:
      "có sự cân đối, gây cảm giác không có gì thừa: người gọn và chắc * dáng người nhỏ gọn",
    example: "người gọn và chắc * dáng người nhỏ gọn",
  },
  {
    word: "gọn",
    part_of_speech: "tính từ",
    meaning:
      "(làm việc gì) xong trọn mà không mất nhiều thì giờ: chỉ làm trong một buổi là gọn hết * tiêu diệt gọn cả đồn giặc",
    example: "chỉ làm trong một buổi là gọn hết * tiêu diệt gọn cả đồn giặc",
  },
  {
    word: "gọn",
    part_of_speech: "tính từ",
    meaning: "(âm thanh) không ngân, không kéo dài: tiếng nổ đanh và gọn",
    example: "tiếng nổ đanh và gọn",
  },
  {
    word: "gọn hơ",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ, khẩu ngữ) (làm việc gì) rất gọn, không mất nhiều công sức, thì giờ: mọi việc trong nhà, nó làm gọn hơ",
    example: "mọi việc trong nhà, nó làm gọn hơ",
  },
  {
    word: "gon",
    part_of_speech: "danh từ",
    meaning: "cỏ dùng để dệt chiếu, đan buồm: chiếu gon",
    example: "chiếu gon",
  },
  {
    word: "gọn nhẹ",
    part_of_speech: "tính từ",
    meaning:
      "gọn, chỉ gồm những thứ cần thiết và không cồng kềnh, không cầu kì: đồ đạc gọn nhẹ * đám cưới được tổ chức đơn giản, gọn nhẹ",
    example: "đồ đạc gọn nhẹ * đám cưới được tổ chức đơn giản, gọn nhẹ",
  },
  {
    word: "gọn nhẹ",
    part_of_speech: "tính từ",
    meaning: "(tổ chức) có ít bộ phận không cần thiết: bộ máy gọn nhẹ",
    example: "bộ máy gọn nhẹ",
  },
  {
    word: "gọn gàng",
    part_of_speech: "tính từ",
    meaning:
      "rất gọn, không có gì vướng víu (nói khái quát): nhà cửa gọn gàng * ăn mặc gọn gàng",
    example: "nhà cửa gọn gàng * ăn mặc gọn gàng",
  },
  {
    word: "gọn ghẽ",
    part_of_speech: "tính từ",
    meaning:
      "rất gọn, trông thích mắt (nói khái quát): chăn màn gấp gọn ghẽ * ăn mặc gọn ghẽ",
    example: "chăn màn gấp gọn ghẽ * ăn mặc gọn ghẽ",
  },
  {
    word: "gọn lỏn",
    part_of_speech: "tính từ",
    meaning:
      "vừa vặn, có thể nằm rất gọn (vào một chỗ nào đấy): nằm gọn lỏn trong lòng mẹ",
    example: "nằm gọn lỏn trong lòng mẹ",
  },
  {
    word: "gọn lỏn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (âm thanh) quá ngắn, quá gọn, gây cảm giác thiếu, cụt: nói gọn lỏn * đáp một câu gọn lỏn",
    example: "nói gọn lỏn * đáp một câu gọn lỏn",
  },
  {
    word: "gòn gọn",
    part_of_speech: "tính từ",
    meaning: "hơi gọn: thu xếp đồ đạc cho gòn gọn vào",
    example: "thu xếp đồ đạc cho gòn gọn vào",
  },
  {
    word: "gọn mắt",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) có vẻ gọn, nhìn thấy thích mắt: căn phòng rất gọn mắt",
    example: "căn phòng rất gọn mắt",
  },
  {
    word: "gọng",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận dùng làm khung của một số vật, thường cứng và dài, có thể giương lên cụp xuống: kính trắng gọng vàng * gọng ô * gọng kìm",
    example: "kính trắng gọng vàng * gọng ô * gọng kìm",
  },
  {
    word: "gọng",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ) càng xe: gọng xe mạ kền bóng loáng",
    example: "gọng xe mạ kền bóng loáng",
  },
  {
    word: "gọng kìm",
    part_of_speech: "danh từ",
    meaning:
      "hai càng của cái kìm; dùng để chỉ hai mũi hoặc hai cánh quân cùng tiến công từ một hướng, tạo thành thế bao vây kẹp quân đối phương vào giữa: chiến thuật gọng kìm",
    example: "chiến thuật gọng kìm",
  },
  {
    word: "goòng",
    part_of_speech: "danh từ",
    meaning:
      "xe nhỏ có bánh sắt chạy trên đường ray, thường dùng ở công trường, hầm mỏ, nhà máy: đường goòng",
    example: "đường goòng",
  },
  {
    word: "góp",
    part_of_speech: "động từ",
    meaning:
      "đưa phần riêng của mình vào để cùng với những phần của những người khác tạo thành cái chung hoặc làm việc chung: góp tiền * góp gạo thổi cơm chung * góp sức vào công cuộc kháng chiến kiến quốc",
    example:
      "góp tiền * góp gạo thổi cơm chung * góp sức vào công cuộc kháng chiến kiến quốc",
  },
  {
    word: "gót",
    part_of_speech: "danh từ",
    meaning:
      'phần sau cùng của bàn chân: gót chân * nhón gót * "Kiều từ trở gót trướng hoa, Mặt trời gác núi, chiêng đà thu không." (TKiều)',
    example:
      'gót chân * nhón gót * "Kiều từ trở gót trướng hoa, Mặt trời gác núi, chiêng đà thu không." (TKiều)',
  },
  {
    word: "gót",
    part_of_speech: "danh từ",
    meaning:
      "phần sau cùng của giày hoặc guốc, dép: guốc cao gót * nện mạnh gót giày trên cầu thang",
    example: "guốc cao gót * nện mạnh gót giày trên cầu thang",
  },
  {
    word: "góp mặt",
    part_of_speech: "động từ",
    meaning:
      "có mặt để cùng tham dự vào một hoạt động chung nào đó: đến góp mặt cho vui",
    example: "đến góp mặt cho vui",
  },
  {
    word: "góp nhặt",
    part_of_speech: "động từ",
    meaning: "tập hợp, gom góp lại dần dần từng ít một: góp nhặt từng đồng",
    example: "góp nhặt từng đồng",
  },
  {
    word: "góp ý",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) góp ý kiến: góp ý phê bình * góp ý một cách chân tình",
    example: "góp ý phê bình * góp ý một cách chân tình",
  },
  {
    word: "góp phần",
    part_of_speech: "động từ",
    meaning:
      "góp một phần, giúp một phần vào việc chung: góp phần xây dựng đất nước",
    example: "góp phần xây dựng đất nước",
  },
  {
    word: "gọt dũa",
    part_of_speech: "động từ",
    meaning:
      "sửa đổi cẩn thận từng chi tiết nhỏ để làm cho hay, cho đẹp hơn: gọt giũa từng câu, từng chữ",
    example: "gọt giũa từng câu, từng chữ",
  },
  {
    word: "gọt",
    part_of_speech: "động từ",
    meaning: "cắt bỏ lớp mỏng bao bên ngoài: gọt hoa quả * gọt khoai",
    example: "gọt hoa quả * gọt khoai",
  },
  {
    word: "gọt",
    part_of_speech: "động từ",
    meaning:
      "cắt bỏ từng ít một nhằm cho phần còn lại là vật có hình thù nhất định: gọt bút chì",
    example: "gọt bút chì",
  },
  {
    word: "gọt",
    part_of_speech: "động từ",
    meaning: "(thông tục) cạo trọc: gọt tóc * gọt đầu bôi vôi",
    example: "gọt tóc * gọt đầu bôi vôi",
  },
  {
    word: "gọt giũa",
    part_of_speech: "động từ",
    meaning:
      "sửa đổi cẩn thận từng chi tiết nhỏ để làm cho hay, cho đẹp hơn: gọt giũa từng câu, từng chữ",
    example: "gọt giũa từng câu, từng chữ",
  },
  {
    word: "gọt đẽo",
    part_of_speech: "động từ",
    meaning: "như đẽo gọt: gọt đẽo bức tượng gỗ",
    example: "gọt đẽo bức tượng gỗ",
  },
  {
    word: "gót sắt",
    part_of_speech: "danh từ",
    meaning:
      "gót giày có đóng móng sắt; thường dùng với sắc thái văn chương để ví sự thống trị tàn bạo: đất nước bị giày xéo dưới gót sắt của kẻ thù",
    example: "đất nước bị giày xéo dưới gót sắt của kẻ thù",
  },
  {
    word: "gót sen",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) gót chân, bước đi của người phụ nữ đẹp: "Tiếng vàng vội gọi con hầu, Gót sen nhè nhẹ dạo mau về nhà." (HT)',
    example:
      'Tiếng vàng vội gọi con hầu, Gót sen nhè nhẹ dạo mau về nhà." (HT)',
  },
  {
    word: "gót đầu",
    part_of_speech: "danh từ",
    meaning: "(cũ, văn chương) đầu đuôi câu chuyện: kể hết gót đầu",
    example: "kể hết gót đầu",
  },
  {
    word: "gô",
    part_of_speech: "động từ",
    meaning: "trói chặt: gô cổ tên cướp lại",
    example: "gô cổ tên cướp lại",
  },
  {
    word: "gồ",
    part_of_speech: "tính từ",
    meaning:
      "nổi cao lên một cách không bình thường: vầng trán gồ cao * mặt đê gồ lên ở giữa",
    example: "vầng trán gồ cao * mặt đê gồ lên ở giữa",
  },
  {
    word: "gồ ghề",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều chỗ nhô cao lên một cách không đều trên bề mặt: đoạn đường đá gồ ghề * mặt gồ ghề những xương",
    example: "đoạn đường đá gồ ghề * mặt gồ ghề những xương",
  },
  {
    word: "gỗ",
    part_of_speech: "danh từ",
    meaning:
      "phần rắn nằm dưới vỏ của thân và cành một số cây, dùng làm vật liệu xây dựng, nguyên liệu làm giấy, v.v.: năm gian nhà gỗ * tượng làm bằng gỗ mít",
    example: "năm gian nhà gỗ * tượng làm bằng gỗ mít",
  },
  {
    word: "gộ",
    part_of_speech: "động từ",
    meaning: "như tác: tiếng nai gộ giữa rừng",
    example: "tiếng nai gộ giữa rừng",
  },
  {
    word: "gốc gác",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) gốc, nơi sinh ra (nói khái quát): không ai biết gốc gác hắn ở đâu",
    example: "không ai biết gốc gác hắn ở đâu",
  },
  {
    word: "gộc",
    part_of_speech: "danh từ",
    meaning:
      "phần gốc và rễ còn lại của cây đã già cỗi sau khi bị chặt đi: gộc tre * củi gộc",
    example: "gộc tre * củi gộc",
  },
  {
    word: "gộc",
    part_of_speech: "tính từ",
    meaning: "(Khẩu ngữ) thuộc loại to, lớn quá cỡ: người to gộc",
    example: "người to gộc",
  },
  {
    word: "gốc",
    part_of_speech: "danh từ",
    meaning: "đoạn dưới của thân cây ở sát đất: cây bị bật gốc",
    example: "cây bị bật gốc",
  },
  {
    word: "gốc",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị cây trồng: đánh mấy gốc cam * trồng hàng nghìn gốc bạch đàn",
    example: "đánh mấy gốc cam * trồng hàng nghìn gốc bạch đàn",
  },
  {
    word: "gốc",
    part_of_speech: "danh từ",
    meaning:
      "cái, nơi từ đó sinh ra, tạo ra những cái được nói đến nào đó: bản thảo gốc * diệt tận gốc * người Mĩ gốc Việt",
    example: "bản thảo gốc * diệt tận gốc * người Mĩ gốc Việt",
  },
  {
    word: "gốc",
    part_of_speech: "danh từ",
    meaning:
      "khoản tiền cho vay, về mặt phân biệt với lãi đẻ ra: trả cả gốc lẫn lãi",
    example: "trả cả gốc lẫn lãi",
  },
  {
    word: "gốc",
    part_of_speech: "danh từ",
    meaning:
      "nhóm nguyên tử trong phân tử của một hợp chất, không biến đổi trong các phản ứng hoá học và tác dụng như một nguyên tử: gốc acid",
    example: "gốc acid",
  },
  {
    word: "gốc tích",
    part_of_speech: "danh từ",
    meaning:
      "nguồn gốc, lai lịch: biết rõ gốc tích * hỏi đến ngọn nguồn, gốc tích",
    example: "biết rõ gốc tích * hỏi đến ngọn nguồn, gốc tích",
  },
  {
    word: "gối",
    part_of_speech: "danh từ",
    meaning:
      "đầu gối (nói tắt): chồn chân mỏi gối * quỳ gối khom lưng * ngồi bó gối",
    example: "chồn chân mỏi gối * quỳ gối khom lưng * ngồi bó gối",
  },
  {
    word: "gối",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng để kê đầu khi nằm: gối bông * thêu gối * tháo vỏ gối ra để giặt",
    example: "gối bông * thêu gối * tháo vỏ gối ra để giặt",
  },
  {
    word: "gối",
    part_of_speech: "động từ",
    meaning:
      "kê đầu lên một vật cho cao hơn khi nằm: đầu gối lên quyển sách * gối đầu lên tay mẹ",
    example: "đầu gối lên quyển sách * gối đầu lên tay mẹ",
  },
  {
    word: "gối",
    part_of_speech: "động từ",
    meaning:
      "gác một đầu lên một vật khác: xây gối vào nhau * rầm gối lên đầu tường",
    example: "xây gối vào nhau * rầm gối lên đầu tường",
  },
  {
    word: "gối",
    part_of_speech: "động từ",
    meaning:
      "(làm việc gì) tiếp theo một việc trước đó, ngay từ khi việc này hãy còn chưa kết thúc: công việc gối lên nhau * trồng gối vụ",
    example: "công việc gối lên nhau * trồng gối vụ",
  },
  {
    word: "gốc rễ",
    part_of_speech: "danh từ",
    meaning:
      "gốc và rễ; dùng để chỉ nguồn gốc hoặc nguyên nhân sâu xa của sự việc, vấn đề (nói khái quát): tìm đến gốc rễ của sự việc",
    example: "tìm đến gốc rễ của sự việc",
  },
  {
    word: "gôm",
    part_of_speech: "danh từ",
    meaning:
      "chất keo chế từ nhựa cây, dùng trong nhiều ngành công nghiệp thực phẩm, dược phẩm, giấy, v.v..",
    example: "đầu chải gôm bóng mượt",
  },
  {
    word: "gội",
    part_of_speech: "động từ",
    meaning:
      "làm cho sạch đầu tóc bằng nước, thường cùng với các chất làm sạch: gội đầu bằng nước bồ kết * dầu gội đầu",
    example: "gội đầu bằng nước bồ kết * dầu gội đầu",
  },
  {
    word: "gồi",
    part_of_speech: "danh từ",
    meaning: "cọ, lá thường dùng để lợp nhà: nhà lợp bằng lá gồi",
    example: "nhà lợp bằng lá gồi",
  },
  {
    word: "gồi",
    part_of_speech: "danh từ",
    meaning: "nắm lúa được gộp lại sau một hai lần cắt: gồi lúa",
    example: "gồi lúa",
  },
  {
    word: "gối vụ",
    part_of_speech: "động từ",
    meaning:
      "trồng tiếp ngay một vụ cây khác trên cùng một diện tích đang trồng vụ cây sắp sửa được thu hoạch: thâm canh gối vụ",
    example: "thâm canh gối vụ",
  },
  {
    word: "gối đầu",
    part_of_speech: "động từ",
    meaning: "gác một đầu lên chỗ khác, vật khác: con đò gối đầu lên bãi",
    example: "con đò gối đầu lên bãi",
  },
  {
    word: "gối đầu",
    part_of_speech: "động từ",
    meaning:
      "gối sang thời gian tiếp theo: trồng gối đầu các loại cây ngắn ngày",
    example: "trồng gối đầu các loại cây ngắn ngày",
  },
  {
    word: "gồng",
    part_of_speech: "động từ",
    meaning: "dồn sức làm cho các bắp thịt nổi lên và rắn lại: gồng người lên",
    example: "gồng người lên",
  },
  {
    word: "gồng",
    part_of_speech: "danh từ",
    meaning:
      "thuật lên gồng, cho là có thể làm cho đánh vào người không biết đau, thậm chí chém không đứt: tên này lợi hại lắm, nó có gồng đấy!",
    example: "tên này lợi hại lắm, nó có gồng đấy!",
  },
  {
    word: "gốm",
    part_of_speech: "danh từ",
    meaning:
      "sản phẩm làm từ đất sét và hỗn hợp đất sét nung, như đồ đất nung, sành, sứ, v.v.: bình gốm * thích sưu tầm đồ gốm * nghề gốm",
    example: "bình gốm * thích sưu tầm đồ gốm * nghề gốm",
  },
  {
    word: "gông",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ thời trước làm bằng một khung gỗ có then đóng mở, dùng để bắt phạm nhân có án nặng đeo vào cổ: cổ mang gông",
    example: "cổ mang gông",
  },
  {
    word: "gông",
    part_of_speech: "động từ",
    meaning: "đóng gông vào cổ: không nộp thì gông cổ nó lại",
    example: "không nộp thì gông cổ nó lại",
  },
  {
    word: "gồm",
    part_of_speech: "động từ",
    meaning:
      "có tất cả như là những bộ phận hợp thành: bức vẽ chỉ gồm hai màu xanh và trắng * cả tuyển tập gồm 20 truyện ngắn",
    example:
      "bức vẽ chỉ gồm hai màu xanh và trắng * cả tuyển tập gồm 20 truyện ngắn",
  },
  {
    word: "gồng gánh",
    part_of_speech: "động từ",
    meaning:
      "mang chuyển đồ đạc bằng quang gánh (nói khái quát): gồng gánh hàng đi chợ",
    example: "gồng gánh hàng đi chợ",
  },
  {
    word: "gồng gánh",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như quang gánh: gồng gánh, thúng mủng ngổn ngang",
    example: "gồng gánh, thúng mủng ngổn ngang",
  },
  {
    word: "gông cùm",
    part_of_speech: "danh từ",
    meaning:
      "gông và cùm (nói khái quát); dùng để chỉ ách áp bức nặng nề: đập tan gông cùm nô lệ",
    example: "đập tan gông cùm nô lệ",
  },
  {
    word: "gộp",
    part_of_speech: "động từ",
    meaning:
      "nhập chung lại: tính gộp cả hai người * gộp tất cả tiền lại cũng không đủ",
    example: "tính gộp cả hai người * gộp tất cả tiền lại cũng không đủ",
  },
  {
    word: "gột",
    part_of_speech: "động từ",
    meaning:
      "dùng nước làm cho sạch chỗ bẩn nào đó trên quần áo, vải vóc: gột bùn ở ống quần",
    example: "gột bùn ở ống quần",
  },
  {
    word: "gột",
    part_of_speech: "động từ",
    meaning: "(cũ, hiếm) quấy: có bột mới gột nên hồ (tng)",
    example: "có bột mới gột nên hồ (tng)",
  },
  {
    word: "gột rửa",
    part_of_speech: "động từ",
    meaning:
      'làm cho sạch, cho mất đi những tàn tích, ảnh hưởng xấu: "Bên trời góc biển bơ vơ, Tấm son gột rửa bao giờ cho phai." (TKiều)',
    example:
      'Bên trời góc biển bơ vơ, Tấm son gột rửa bao giờ cho phai." (TKiều)',
  },
  {
    word: "gờ",
    part_of_speech: "danh từ",
    meaning:
      "đường nổi lên trên bề mặt hoặc ven theo cạnh của một số vật: gờ tường * gờ bàn * gờ cánh cửa",
    example: "gờ tường * gờ bàn * gờ cánh cửa",
  },
  {
    word: "gỡ gạc",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tìm cách gỡ lại được phần nào hay phần ấy (nói khái quát): cố gỡ gạc mà không được",
    example: "cố gỡ gạc mà không được",
  },
  {
    word: "gở",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất không hay, không may, báo trước điều chẳng lành, theo quan niệm dân gian: điềm gở * gở mồm gở miệng * hay nói gở",
    example: "điềm gở * gở mồm gở miệng * hay nói gở",
  },
  {
    word: "gỡ rối",
    part_of_speech: "động từ",
    meaning:
      "làm cho hết tình trạng bị xáo trộn, không yên ổn, không bình thường: gỡ rối tơ lòng",
    example: "gỡ rối tơ lòng",
  },
  {
    word: "gỡ",
    part_of_speech: "động từ",
    meaning: "tách các sợi ra cho hết rối: gỡ tóc rối * đứt nối, rối gỡ (tng)",
    example: "gỡ tóc rối * đứt nối, rối gỡ (tng)",
  },
  {
    word: "gỡ",
    part_of_speech: "động từ",
    meaning:
      "tháo rời ra khỏi cái mà vật nào đó dính vào, mắc vào: gỡ mìn * gỡ xương",
    example: "gỡ mìn * gỡ xương",
  },
  {
    word: "gỡ",
    part_of_speech: "động từ",
    meaning: "làm cho thoát ra khỏi tình trạng khó khăn, rắc rối: gỡ thế bí",
    example: "gỡ thế bí",
  },
  {
    word: "gỡ",
    part_of_speech: "động từ",
    meaning:
      "lấy lại phần nào bù vào chỗ đã bỏ ra, đã bị thua thiệt: gỡ lại một bàn * cố tìm cách để gỡ lại vốn",
    example: "gỡ lại một bàn * cố tìm cách để gỡ lại vốn",
  },
  {
    word: "gợi",
    part_of_speech: "động từ",
    meaning:
      "làm nảy sinh hoặc làm nhớ đến qua một sự liên tưởng nào đó: gợi trí tò mò * cảnh vật gợi hứng làm thơ * tiếng ve gợi sầu",
    example: "gợi trí tò mò * cảnh vật gợi hứng làm thơ * tiếng ve gợi sầu",
  },
  {
    word: "gợi cảm",
    part_of_speech: "tính từ",
    meaning:
      "có tác dụng gợi tình cảm, làm rung động lòng người: bài văn gợi cảm * giọng nói rất gợi cảm",
    example: "bài văn gợi cảm * giọng nói rất gợi cảm",
  },
  {
    word: "gỡ tội",
    part_of_speech: "động từ",
    meaning:
      "dùng lí lẽ hoặc bằng chứng để làm nhẹ tội hay thoát tội: tìm lời kêu oan để gỡ tội",
    example: "tìm lời kêu oan để gỡ tội",
  },
  {
    word: "gợi mở",
    part_of_speech: "động từ",
    meaning:
      "gợi ra, làm nảy sinh những suy nghĩ, ý tưởng: câu hỏi có tính chất gợi mở",
    example: "câu hỏi có tính chất gợi mở",
  },
  {
    word: "gợi chuyện",
    part_of_speech: "động từ",
    meaning:
      "gợi ra để người đối thoại nói chuyện này chuyện khác: gợi chuyện để tìm hiểu",
    example: "gợi chuyện để tìm hiểu",
  },
  {
    word: "gợi tình",
    part_of_speech: "",
    meaning: "khêu gợi những ham muốn tình dục: đôi mắt gợi tình",
    example: "đôi mắt gợi tình",
  },
  {
    word: "gợi tả",
    part_of_speech: "động từ",
    meaning:
      "gợi lên bằng hình tượng cho có thể hình dung được: bài thơ gợi tả cảnh đẹp của mùa thu",
    example: "bài thơ gợi tả cảnh đẹp của mùa thu",
  },
  {
    word: "gớm ghiếc",
    part_of_speech: "tính từ",
    meaning: "trông ghê sợ, ghê tởm: bộ mặt gớm ghiếc",
    example: "bộ mặt gớm ghiếc",
  },
  {
    word: "gợi ý",
    part_of_speech: "động từ",
    meaning:
      "gợi ra để tự suy nghĩ, tự có ý kiến hoặc tự giải quyết một việc nào đó: gợi ý cho con bài toán khó * gợi ý một cách khéo léo * câu hỏi mang tính gợi ý",
    example:
      "gợi ý cho con bài toán khó * gợi ý một cách khéo léo * câu hỏi mang tính gợi ý",
  },
  {
    word: "gớm",
    part_of_speech: "động từ",
    meaning:
      "có cảm giác như ghê tởm, không muốn tiếp xúc: máu ra lênh láng, trông gớm quá!",
    example: "máu ra lênh láng, trông gớm quá!",
  },
  {
    word: "gớm",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (người) có những gì đó ở mức độ khác thường, khiến người ta phải dè chừng: mụ ấy là gớm lắm * cô nàng cũng vào loại gớm",
    example: "mụ ấy là gớm lắm * cô nàng cũng vào loại gớm",
  },
  {
    word: "gớm",
    part_of_speech: "tính từ",
    meaning:
      "ở mức độ cao khác thường (thường hàm ý mỉa mai): vẽ đẹp gớm * khéo nịnh gớm!",
    example: "vẽ đẹp gớm * khéo nịnh gớm!",
  },
  {
    word: "gớm",
    part_of_speech: "cảm từ",
    meaning: "từ biểu thị ý trách móc nhẹ: gớm, mồm với chả miệng!",
    example: "gớm, mồm với chả miệng!",
  },
  {
    word: "gờm",
    part_of_speech: "động từ",
    meaning:
      "e sợ, có ý muốn tránh đi và luôn để ý đề phòng, đối phó: đối thủ đáng gờm",
    example: "đối thủ đáng gờm",
  },
  {
    word: "gợn",
    part_of_speech: "động từ",
    meaning:
      "nổi lên thành như những vệt, những nếp nhăn nhỏ trên bề mặt phẳng: nền trời trong vắt không gợn một tí mây",
    example: "nền trời trong vắt không gợn một tí mây",
  },
  {
    word: "gợn",
    part_of_speech: "động từ",
    meaning:
      "thoáng có những nét tình cảm, cảm xúc nào đó: lòng thư thái, không gợn chút lo âu * vẻ mặt thoáng gợn chút bối rối",
    example:
      "lòng thư thái, không gợn chút lo âu * vẻ mặt thoáng gợn chút bối rối",
  },
  {
    word: "gợn",
    part_of_speech: "danh từ",
    meaning:
      "cái nổi lên như những nếp nhăn hoặc những vệt nhỏ làm mất đi phần nào sự bằng phẳng, sự trong suốt: chiếc bình gốm có gợn",
    example: "chiếc bình gốm có gợn",
  },
  {
    word: "gờn gợn",
    part_of_speech: "",
    meaning:
      'không được nhẵn, được phẳng, còn có những vết hơi gợn lên trên bề mặt phẳng: mặt giấy hơi gờn gợn * "Gió đông gờn gợn sóng tình, Dưới trăng lộng lẫy một cành mẫu đơn." (HT)',
    example:
      'mặt giấy hơi gờn gợn * "Gió đông gờn gợn sóng tình, Dưới trăng lộng lẫy một cành mẫu đơn." (HT)',
  },
  {
    word: "gợt",
    part_of_speech: "động từ",
    meaning: "gạt nhẹ lấy đi cái trên bề mặt: gợt lớp váng",
    example: "gợt lớp váng",
  },
  {
    word: "granito",
    part_of_speech: "danh từ",
    meaning:
      "vật liệu nhân tạo làm bằng xi măng và đá hạt có màu, một mặt được mài nhẵn, dùng để trát các bề mặt công trình xây dựng: cầu thang làm bằng granito",
    example: "cầu thang làm bằng granito",
  },
  {
    word: "gụ",
    part_of_speech: "danh từ",
    meaning:
      "cây to ở rừng cùng họ với cây vang, cho gỗ quý màu nâu sẫm, có vân đen: gỗ gụ * sập gụ",
    example: "gỗ gụ * sập gụ",
  },
  {
    word: "gụ",
    part_of_speech: "tính từ",
    meaning:
      "có màu trung gian giữa màu đỏ và màu đen, giống như màu gỗ gụ: vải gụ",
    example: "vải gụ",
  },
  {
    word: "gu",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) ý thích riêng trong lối sống (nói khái quát): hai người rất hợp gu",
    example: "hai người rất hợp gu",
  },
  {
    word: "gùn",
    part_of_speech: "danh từ",
    meaning: "đầu mối của sợi hiện lên trên mặt hàng dệt: lụa nhiều gùn",
    example: "lụa nhiều gùn",
  },
  {
    word: "gùi",
    part_of_speech: "danh từ",
    meaning:
      "đồ đan bằng mây, tre, dùng ở một số địa phương miền núi để mang đồ đạc trên lưng: vai đeo gùi * một gùi lúa nặng",
    example: "vai đeo gùi * một gùi lúa nặng",
  },
  {
    word: "gùi",
    part_of_speech: "động từ",
    meaning: "mang đi trên lưng bằng gùi: gùi gạo * gùi hàng ra chợ bán",
    example: "gùi gạo * gùi hàng ra chợ bán",
  },
  {
    word: "gù",
    part_of_speech: "động từ",
    meaning:
      "(chim cu, bồ câu) kêu tiếng trầm và nhẹ (thường khi con đực, con mái đến gần nhau): chim gù",
    example: "chim gù",
  },
  {
    word: "gù",
    part_of_speech: "tính từ",
    meaning: "(lưng) cong thành tật hoặc có bướu: gù lưng * dáng đi hơi gù",
    example: "gù lưng * dáng đi hơi gù",
  },
  {
    word: "gục",
    part_of_speech: "động từ",
    meaning:
      "gập hẳn đầu xuống: mệt quá gục đầu xuống bàn * gục vào lòng mẹ khóc nức nở",
    example: "mệt quá gục đầu xuống bàn * gục vào lòng mẹ khóc nức nở",
  },
  {
    word: "gục",
    part_of_speech: "động từ",
    meaning: "gãy gập xuống: cành cây bị gục xuống * xe đạp bị gục khung",
    example: "cành cây bị gục xuống * xe đạp bị gục khung",
  },
  {
    word: "gục",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) mất hết sức, không thể gắng gượng được nữa: bị gục vì làm quá sức",
    example: "bị gục vì làm quá sức",
  },
  {
    word: "gục gặc",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) gật gật (đầu): đầu gục gặc tỏ vẻ đồng ý * không nói gì, chỉ gục gặc đầu",
    example: "đầu gục gặc tỏ vẻ đồng ý * không nói gì, chỉ gục gặc đầu",
  },
  {
    word: "guốc",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng để mang ở bàn chân khi đi lại, thường làm bằng gỗ và có quai: guốc mộc * guốc cao gót",
    example: "guốc mộc * guốc cao gót",
  },
  {
    word: "guốc",
    part_of_speech: "danh từ",
    meaning:
      "móng chân của một số loài thú, như trâu, bò, ngựa, v.v.: thú chân guốc",
    example: "thú chân guốc",
  },
  {
    word: "guốc",
    part_of_speech: "danh từ",
    meaning:
      "miếng gỗ hình giống chiếc guốc, dùng để chêm, giữ, v.v. ở trong một số đồ vật: guốc điếu * guốc chèo * guốc võng bị mài mòn",
    example: "guốc điếu * guốc chèo * guốc võng bị mài mòn",
  },
  {
    word: "guộn",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) cuộn: guộn tròn chiếc áo lại",
    example: "guộn tròn chiếc áo lại",
  },
  {
    word: "guồng máy",
    part_of_speech: "danh từ",
    meaning:
      "cơ cấu tổ chức, về mặt có sự hoạt động đồng bộ để thực hiện một nhiệm vụ chung nào đó: guồng máy chính trị * guồng máy hành chính",
    example: "guồng máy chính trị * guồng máy hành chính",
  },
  {
    word: "gút",
    part_of_speech: "danh từ",
    meaning: "như gùn: mặt vải có nhiều gút",
    example: "mặt vải có nhiều gút",
  },
  {
    word: "gút",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) nút: dây bị thắt gút",
    example: "dây bị thắt gút",
  },
  {
    word: "gút",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) đúc rút lại, tóm lại: gút lại câu chuyện",
    example: "gút lại câu chuyện",
  },
  {
    word: "gửi",
    part_of_speech: "động từ",
    meaning:
      "chuyển đến người khác, nơi khác qua khâu trung gian: gửi điện khẩn * gửi quà * gửi bưu phẩm, bưu kiện",
    example: "gửi điện khẩn * gửi quà * gửi bưu phẩm, bưu kiện",
  },
  {
    word: "gửi",
    part_of_speech: "động từ",
    meaning:
      "làm cho đến ở nơi nào đó để làm việc gì đó: gửi cán bộ sang nước ngoài học tập",
    example: "gửi cán bộ sang nước ngoài học tập",
  },
  {
    word: "gửi",
    part_of_speech: "động từ",
    meaning:
      "giao cái của mình cho người khác giữ, nhờ họ trông coi, bảo quản: gửi con vào nhà trẻ * gửi nhà cho hàng xóm * gửi tiền ở ngân hàng",
    example:
      "gửi con vào nhà trẻ * gửi nhà cho hàng xóm * gửi tiền ở ngân hàng",
  },
  {
    word: "gửi",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đưa lại, trả lại (lối nói lịch sự): xin gửi lại chị món tiền tôi mượn mấy hôm trước",
    example: "xin gửi lại chị món tiền tôi mượn mấy hôm trước",
  },
  {
    word: "gửi",
    part_of_speech: "động từ",
    meaning:
      "(sống, sinh sống) tạm nhờ vào, dựa vào người khác: ăn gửi nằm nhờ",
    example: "ăn gửi nằm nhờ",
  },
  {
    word: "gửi rể",
    part_of_speech: "động từ",
    meaning: "đến sống với gia đình bên vợ sau khi cưới: tục gửi rể",
    example: "tục gửi rể",
  },
  {
    word: "guồng",
    part_of_speech: "danh từ",
    meaning: "dụng cụ gồm một cái khung tròn để cuốn sợi, chỉ: quay guồng chỉ",
    example: "quay guồng chỉ",
  },
  {
    word: "guồng",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ quay bằng sức nước hay sức người đạp, dùng để đưa nước liên tục từ chỗ thấp lên chỗ cao: đạp guồng nước * bà con tự làm guồng để lấy nước",
    example: "đạp guồng nước * bà con tự làm guồng để lấy nước",
  },
  {
    word: "guồng",
    part_of_speech: "động từ",
    meaning: "cuốn sợi, chỉ bằng cái guồng: ngồi guồng sợi * tơ mới guồng",
    example: "ngồi guồng sợi * tơ mới guồng",
  },
  {
    word: "guồng",
    part_of_speech: "động từ",
    meaning: "đạp guồng đưa nước từ thấp lên cao: đang guồng nước ngoài suối",
    example: "đang guồng nước ngoài suối",
  },
  {
    word: "gửi gắm",
    part_of_speech: "động từ",
    meaning:
      "giao cho người khác hay đặt vào ở đâu đó cái quý giá của mình với sự tin tưởng và tình cảm tha thiết: gửi gắm cuộc đời",
    example: "gửi gắm cuộc đời",
  },
  {
    word: "gửi trứng cho ác",
    part_of_speech: "",
    meaning:
      "ví việc làm dại dột, tự gây nguy hiểm, đem gửi gắm cho người không tốt cái mà chính kẻ đó đang muốn chiếm đoạt: gửi tiền cho nó thì khác nào gửi trứng cho ác!",
    example: "gửi tiền cho nó thì khác nào gửi trứng cho ác!",
  },
  {
    word: "gườm",
    part_of_speech: "động từ",
    meaning:
      "nhìn thẳng không chớp với vẻ giận dữ, đe doạ: hai bên gườm nhau * đưa mắt gườm con",
    example: "hai bên gườm nhau * đưa mắt gườm con",
  },
  {
    word: "gượng",
    part_of_speech: "động từ",
    meaning:
      "gắng chịu đựng để làm việc gì khi thật ra không còn đủ sức: gượng dậy * chân đau nhưng vẫn gượng đi",
    example: "gượng dậy * chân đau nhưng vẫn gượng đi",
  },
  {
    word: "gượng",
    part_of_speech: "tính từ",
    meaning:
      'cố làm cho ra vẻ tự nhiên, bình thường, khi đang có tâm trạng buồn hoặc không thích: cười gượng * "Sầu đông trong héo, ngoài tươi, Vui là vui gượng, cười là cười khuây." (Cdao)',
    example:
      'cười gượng * "Sầu đông trong héo, ngoài tươi, Vui là vui gượng, cười là cười khuây." (Cdao)',
  },
  {
    word: "gượng",
    part_of_speech: "tính từ",
    meaning:
      "(cách diễn đạt) cố làm cho có một tính chất nào đó, nhưng không tự nhiên: lời văn còn gượng",
    example: "lời văn còn gượng",
  },
  {
    word: "gương",
    part_of_speech: "danh từ",
    meaning:
      "vật thường bằng thuỷ tinh, có một mặt nhẵn bóng phản xạ ánh sáng tốt, dùng để tạo ảnh của các vật: soi gương * mặt hồ phẳng như gương",
    example: "soi gương * mặt hồ phẳng như gương",
  },
  {
    word: "gương",
    part_of_speech: "danh từ",
    meaning:
      "cái được coi là tốt hoặc xấu để noi theo hoặc để rút kinh nghiệm: gương người tốt, việc tốt",
    example: "gương người tốt, việc tốt",
  },
  {
    word: "gương",
    part_of_speech: "danh từ",
    meaning:
      "bề mặt luôn luôn chuyển dịch trong tiến trình khai thác mỏ, tại đó tiến hành đào đá hoặc khoáng sản: gương lò * gương tầng ở mỏ lộ thiên",
    example: "gương lò * gương tầng ở mỏ lộ thiên",
  },
  {
    word: "gượm",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) khoan đã, chờ một lát đã: gượm đã, làm gì mà vội thế? * gượm nào",
    example: "gượm đã, làm gì mà vội thế? * gượm nào",
  },
  {
    word: "gượng gạo",
    part_of_speech: "tính từ",
    meaning: "tỏ ra gượng, không tự nhiên: nụ cười gượng gạo",
    example: "nụ cười gượng gạo",
  },
  {
    word: "gượng ép",
    part_of_speech: "tính từ",
    meaning:
      "không được tự nhiên vì đã cố làm, cố thực hiện cho được khi chưa có đủ cơ sở, có đủ điều kiện: cách lí giải có phần gượng ép * kết luận gượng ép",
    example: "cách lí giải có phần gượng ép * kết luận gượng ép",
  },
  {
    word: "gương mặt",
    part_of_speech: "danh từ",
    meaning:
      "khuôn mặt với những nét biểu hiện tâm hồn, tính cách, v.v. của mỗi người: gương mặt thanh thoát",
    example: "gương mặt thanh thoát",
  },
  {
    word: "gương mẫu",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) người được coi là tấm gương, là mẫu mực để những người khác noi theo: "Đảng viên, đoàn viên thanh niên và cán bộ công đoàn phải làm gương mẫu trong mọi công việc." (HChMinh; 5)',
    example:
      'Đảng viên, đoàn viên thanh niên và cán bộ công đoàn phải làm gương mẫu trong mọi công việc." (HChMinh; 5)',
  },
  {
    word: "gương mẫu",
    part_of_speech: "danh từ",
    meaning:
      "(có tác dụng) làm gương cho mọi người noi theo: cán bộ phải gương mẫu * một viên chức gương mẫu",
    example: "cán bộ phải gương mẫu * một viên chức gương mẫu",
  },
  {
    word: "gương nga",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) mặt trăng: "Gương nga chênh chếch dòm song, Vàng gieo ngấn nước, cây lồng bóng sân." (TKiều)',
    example:
      'Gương nga chênh chếch dòm song, Vàng gieo ngấn nước, cây lồng bóng sân." (TKiều)',
  },
  {
    word: "gương sen",
    part_of_speech: "danh từ",
    meaning: "đế hoa hình phễu chứa các quả (thường gọi là hạt) của cây sen..",
    example: "bình tưới đã bị hỏng gương sen",
  },
  {
    word: "gương tày liếp",
    part_of_speech: "danh từ",
    meaning:
      'gương lớn về thất bại, sai lầm, nêu ra để thấy mà tránh: "Nói người chẳng ngẫm đến ta, Cái gương tày liếp để mà soi chung." (ca dao)',
    example:
      'Nói người chẳng ngẫm đến ta, Cái gương tày liếp để mà soi chung." (ca dao)',
  },
  {
    word: "gượng nhẹ",
    part_of_speech: "tính từ",
    meaning:
      "(làm việc, nói năng) cố lựa cách sao cho nhẹ nhàng, tránh động chạm mạnh: đồ dễ vỡ, phải cầm gượng nhẹ * gượng nhẹ đặt đứa bé đang ngủ xuống giường",
    example:
      "đồ dễ vỡ, phải cầm gượng nhẹ * gượng nhẹ đặt đứa bé đang ngủ xuống giường",
  },
  {
    word: "gượng nhẹ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) chống chế nhằm thanh minh, giải thích cho khuyết điểm của mình: chỉ giỏi bao biện! * cố bao biện cho sai lầm của mình",
    example: "chỉ giỏi bao biện! * cố bao biện cho sai lầm của mình",
  },
  {
    word: "gương vỡ lại lành",
    part_of_speech: "",
    meaning:
      'ví cảnh sum họp, đoàn tụ, sau một thời gian có sự tan vỡ, chia li (thường là giữa vợ chồng, người yêu): "Bây giờ gương vỡ lại lành, Khuôn thiêng lừa lọc đã dành có nơi." (TKiều)',
    example:
      'Bây giờ gương vỡ lại lành, Khuôn thiêng lừa lọc đã dành có nơi." (TKiều)',
  },
  {
    word: "h",
    part_of_speech: "",
    meaning: "kí hiệu của giờ (A: hour): 17h (5 giờ chiều)",
    example: "17h (5 giờ chiều)",
  },
  {
    word: "hả",
    part_of_speech: "động từ",
    meaning:
      "mất đi cái chất, cái vị vốn có do kết quả của quá trình bay hơi: phơi cho hả đất * rượu hả hơi",
    example: "phơi cho hả đất * rượu hả hơi",
  },
  {
    word: "hả",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái cảm thấy được thoả mãn, được đầy đủ như ý muốn: mắng một trận cho hả",
    example: "mắng một trận cho hả",
  },
  {
    word: "hả",
    part_of_speech: "trợ từ",
    meaning:
      "(Khẩu ngữ) từ biểu thị ý hỏi, thường là của người trên đối với người dưới, có ý nghiêm nghị hoặc gắt gỏng: định cãi hả? * điếc hả? * mày có muốn ăn đòn không hả?",
    example: "định cãi hả? * điếc hả? * mày có muốn ăn đòn không hả?",
  },
  {
    word: "hả",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý hỏi với sắc thái thân mật, nhằm xác định thêm điều mình đang nghi vấn: chơi vui chứ hả? * thế hả? * sao lại đến nông nỗi này hả con?",
    example: "chơi vui chứ hả? * thế hả? * sao lại đến nông nỗi này hả con?",
  },
  {
    word: "ha",
    part_of_speech: "cảm từ",
    meaning:
      "tiếng reo biểu lộ sự vui mừng, phấn khởi: ha! thích quá! * ha! má đã về!",
    example: "ha! thích quá! * ha! má đã về!",
  },
  {
    word: "hà",
    part_of_speech: "tính từ",
    meaning: "bị hà đục: chiếc thuyền hà * vào lỗ hà ra lỗ hổng (tng)",
    example: "chiếc thuyền hà * vào lỗ hà ra lỗ hổng (tng)",
  },
  {
    word: "hà",
    part_of_speech: "tính từ",
    meaning: "(chân) bị hà ăn: chân hà * ngựa hà",
    example: "chân hà * ngựa hà",
  },
  {
    word: "hà",
    part_of_speech: "danh từ",
    meaning:
      "khoảng cách ở giữa, chia bàn cờ tướng thành hai bên: tốt qua hà * sang hà",
    example: "tốt qua hà * sang hà",
  },
  {
    word: "hà",
    part_of_speech: "động từ",
    meaning: "mở rộng miệng và thở mạnh ra: hà khói thuốc",
    example: "hà khói thuốc",
  },
  {
    word: "hạ",
    part_of_speech: "danh từ",
    meaning:
      "mùa nóng nhất trong năm, sau mùa xuân, trước mùa thu: trời bắt đầu vào hạ * phượng nở hoa vào mùa hạ",
    example: "trời bắt đầu vào hạ * phượng nở hoa vào mùa hạ",
  },
  {
    word: "hạ",
    part_of_speech: "động từ",
    meaning:
      "làm cho chuyển từ vị trí trên cao xuống dưới thấp: hạ cánh buồm * hạ cây nêu * hạ bức tranh xuống",
    example: "hạ cánh buồm * hạ cây nêu * hạ bức tranh xuống",
  },
  {
    word: "hạ",
    part_of_speech: "động từ",
    meaning:
      "giảm cường độ, số lượng, v.v. xuống mức thấp hơn: hạ giá * hạ một bậc lương * hạ giọng * hạ tiêu chuẩn",
    example: "hạ giá * hạ một bậc lương * hạ giọng * hạ tiêu chuẩn",
  },
  {
    word: "hạ",
    part_of_speech: "động từ",
    meaning:
      "kẻ từ một điểm một đường thẳng vuông góc với một đường thẳng hay một mặt phẳng cho trước: hạ đường cao",
    example: "hạ đường cao",
  },
  {
    word: "hạ",
    part_of_speech: "động từ",
    meaning:
      "đánh ngã, đánh bại: hạ đo ván đối thủ * cờ chưa đánh được hai ván đã bị hạ",
    example: "hạ đo ván đối thủ * cờ chưa đánh được hai ván đã bị hạ",
  },
  {
    word: "hạ",
    part_of_speech: "động từ",
    meaning: "đánh chiếm được: hạ đồn địch * hạ thành",
    example: "hạ đồn địch * hạ thành",
  },
  {
    word: "hạ",
    part_of_speech: "động từ",
    meaning:
      "đưa ra một cách chính thức cái cần phải thực hiện: vua hạ chỉ * hạ lệnh * hạ quyết tâm",
    example: "vua hạ chỉ * hạ lệnh * hạ quyết tâm",
  },
  {
    word: "hạ",
    part_of_speech: "tính từ",
    meaning:
      "ở phía dưới, phía sau; đối lập với thượng: thôn hạ * quyển hạ * thượng vàng hạ cám (tng)",
    example: "thôn hạ * quyển hạ * thượng vàng hạ cám (tng)",
  },
  {
    word: "há",
    part_of_speech: "động từ",
    meaning:
      "(miệng) mở to ra: há mồm ra ngáp * giày há mõm * há miệng mắc quai (tng)",
    example: "há mồm ra ngáp * giày há mõm * há miệng mắc quai (tng)",
  },
  {
    word: "há",
    part_of_speech: "trợ từ",
    meaning:
      "(cũ, văn chương) từ biểu thị ý như muốn hỏi, nhưng thật ra là để khẳng định rằng không có lẽ nào lại như thế: há có bấy nhiêu?",
    example: "há có bấy nhiêu?",
  },
  {
    word: "hạ áp",
    part_of_speech: "tính từ",
    meaning: "có áp suất nhỏ: bơm hạ áp * đèn hạ áp",
    example: "bơm hạ áp * đèn hạ áp",
  },
  {
    word: "hà bá",
    part_of_speech: "danh từ",
    meaning: "thần sông, theo quan niệm cũ: bị hà bá bắt",
    example: "bị hà bá bắt",
  },
  {
    word: "hạ bút",
    part_of_speech: "động từ",
    meaning:
      'đặt bút viết: "Quỳ loay hoay mãi trước tờ giấy viết cho các bạn, không biết hạ bút ra sao." (ĐĐThu; 2)',
    example:
      'Quỳ loay hoay mãi trước tờ giấy viết cho các bạn, không biết hạ bút ra sao." (ĐĐThu; 2)',
  },
  {
    word: "hạ bệ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) lật đổ khỏi địa vị (lớn và có quyền thế): bị cấp dưới hạ bệ",
    example: "bị cấp dưới hạ bệ",
  },
  {
    word: "hạ bạc",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) làm nghề đánh cá ở sông, hồ: dân hạ bạc",
    example: "dân hạ bạc",
  },
  {
    word: "hạ bạn",
    part_of_speech: "danh từ",
    meaning: "vùng đồng bằng ở gần cửa sông hoặc ven biển: miền hạ bạn",
    example: "miền hạ bạn",
  },
  {
    word: "hạ cấp",
    part_of_speech: "danh từ",
    meaning: "loại thấp kém: dục vọng hạ cấp",
    example: "dục vọng hạ cấp",
  },
  {
    word: "hạ cánh",
    part_of_speech: "động từ",
    meaning:
      "(máy bay từ trên không) đỗ xuống: máy bay được lệnh hạ cánh khẩn cấp",
    example: "máy bay được lệnh hạ cánh khẩn cấp",
  },
  {
    word: "hạ đẳng",
    part_of_speech: "tính từ",
    meaning:
      "thuộc bậc thấp trong quá trình tiến hoá của sinh vật: động vật hạ đẳng",
    example: "động vật hạ đẳng",
  },
  {
    word: "hạ đẳng",
    part_of_speech: "tính từ",
    meaning: "thấp kém, không ra gì: trò chơi hạ đẳng",
    example: "trò chơi hạ đẳng",
  },
  {
    word: "hạ cố",
    part_of_speech: "động từ",
    meaning:
      "(cũ, hoặc kc) nhìn đến, để ý đến (người bề dưới hoặc coi như bề dưới) mà làm việc gì: khi nào rỗi rãi, mời ngài hạ cố đến chơi",
    example: "khi nào rỗi rãi, mời ngài hạ cố đến chơi",
  },
  {
    word: "hả dạ",
    part_of_speech: "",
    meaning:
      "(Khẩu ngữ) cảm thấy thoả mãn, hài lòng vì được như ý muốn: nghe được câu này cũng hả dạ",
    example: "nghe được câu này cũng hả dạ",
  },
  {
    word: "hạ điền",
    part_of_speech: "danh từ",
    meaning:
      "lễ cúng thần nông vào đầu vụ cấy, theo phong tục thời trước: làm lễ hạ điền",
    example: "làm lễ hạ điền",
  },
  {
    word: "ha ha",
    part_of_speech: "tính từ",
    meaning: "từ gợi tả tiếng cười to một cách thoải mái: cười ha ha",
    example: "cười ha ha",
  },
  {
    word: "hả giận",
    part_of_speech: "động từ",
    meaning:
      "hết cảm thấy tức giận, trút được nỗi tức giận, do kết quả của một tác động nào đó đem lại: nói cho hả giận",
    example: "nói cho hả giận",
  },
  {
    word: "hạ giáng",
    part_of_speech: "động từ",
    meaning: "(hiếm) như giáng hạ: tiên ông hạ giáng",
    example: "tiên ông hạ giáng",
  },
  {
    word: "ha hả",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả tiếng cười to, có vẻ rất khoái chí: khoái chí cười ha hả * bật cười ha hả",
    example: "khoái chí cười ha hả * bật cười ha hả",
  },
  {
    word: "hạ giới",
    part_of_speech: "danh từ",
    meaning:
      "thế giới của người trần trên mặt đất; đối lập với thượng giới: người hạ giới * nàng tiên bị đày xuống hạ giới",
    example: "người hạ giới * nàng tiên bị đày xuống hạ giới",
  },
  {
    word: "hạ hồi phân giải",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) sau này sẽ hay, sẽ rõ: đúng sai thế nào để hạ hồi phân giải",
    example: "đúng sai thế nào để hạ hồi phân giải",
  },
  {
    word: "hà cớ",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) vì sao, vì nguyên cớ gì: hà cớ gì mà anh lại mắng tôi?",
    example: "hà cớ gì mà anh lại mắng tôi?",
  },
  {
    word: "hả hê",
    part_of_speech: "",
    meaning:
      "vui sướng vì cảm thấy được hoàn toàn như ý muốn: được khen, trong lòng hả hê lắm * cười hả hê",
    example: "được khen, trong lòng hả hê lắm * cười hả hê",
  },
  {
    word: "hà hiếp",
    part_of_speech: "động từ",
    meaning:
      "dùng quyền thế và sức mạnh để lấn át, đè nén một cách cay nghiệt: quân giặc hà hiếp dân lành",
    example: "quân giặc hà hiếp dân lành",
  },
  {
    word: "hà hơi",
    part_of_speech: "động từ",
    meaning:
      "mở rộng miệng và thở mạnh hơi ra: sơ cứu tại chỗ bằng cách hà hơi thổi ngạt * hà hơi cho hai bàn tay ấm lên",
    example:
      "sơ cứu tại chỗ bằng cách hà hơi thổi ngạt * hà hơi cho hai bàn tay ấm lên",
  },
  {
    word: "hà khắc",
    part_of_speech: "tính từ",
    meaning: "khe khắt, ác nghiệt: chính sách cai trị hà khắc",
    example: "chính sách cai trị hà khắc",
  },
  {
    word: "há hốc",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) (miệng) há ra rất to: mồm há hốc ra vì kinh sợ",
    example: "mồm há hốc ra vì kinh sợ",
  },
  {
    word: "hạ huyền",
    part_of_speech: "danh từ",
    meaning:
      "thời gian vào khoảng đầu tuần cuối cùng của tháng âm lịch, mặt trăng đã khuyết thành hình bán nguyệt (thường là ngày 22 hoặc 23 âm lịch); phân biệt với thượng huyền: trăng hạ huyền",
    example: "trăng hạ huyền",
  },
  {
    word: "hà lạm",
    part_of_speech: "động từ",
    meaning:
      "(cũ) (kẻ có chức quyền) lợi dụng việc công để vơ vét, chiếm đoạt của cải: hà lạm công quỹ",
    example: "hà lạm công quỹ",
  },
  {
    word: "hạ lệnh",
    part_of_speech: "động từ",
    meaning:
      "ra lệnh, truyền lệnh xuống cho cấp dưới thi hành: hạ lệnh tiến công * hạ lệnh cho quân sĩ rút lui",
    example: "hạ lệnh tiến công * hạ lệnh cho quân sĩ rút lui",
  },
  {
    word: "hả lòng",
    part_of_speech: "",
    meaning: "(khẩu ngữ) như hả dạ: con cái đỗ đạt, cha mẹ được hả lòng",
    example: "con cái đỗ đạt, cha mẹ được hả lòng",
  },
  {
    word: "hạ lưu",
    part_of_speech: "danh từ",
    meaning:
      "đoạn sông ở gần cửa sông, thường kể cả vùng phụ cận; phân biệt với thượng lưu, trung lưu: vùng hạ lưu sông Hồng",
    example: "vùng hạ lưu sông Hồng",
  },
  {
    word: "hạ lưu",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) tầng lớp bị coi là thấp kém trong xã hội, theo quan niệm cũ (hàm ý coi khinh); phân biệt với thượng lưu, trung lưu: con nhà hạ lưu * giai cấp hạ lưu",
    example: "con nhà hạ lưu * giai cấp hạ lưu",
  },
  {
    word: "hạ màn",
    part_of_speech: "động từ",
    meaning:
      "kéo màn che kín sân khấu khi kết thúc một hồi hoặc toàn bộ vở kịch: vở kịch sắp đến hồi hạ màn",
    example: "vở kịch sắp đến hồi hạ màn",
  },
  {
    word: "hạ nguồn",
    part_of_speech: "danh từ",
    meaning:
      "đoạn cuối nguồn của một con sông; phân biệt với thượng nguồn: hạ nguồn sông Mekong",
    example: "hạ nguồn sông Mekong",
  },
  {
    word: "hạ mình",
    part_of_speech: "động từ",
    meaning:
      "tự đặt mình xuống địa vị thấp, hoặc tự hạ thấp phẩm giá của mình để làm một việc gì: hạ mình cầu cạnh * không chịu hạ mình lạy lục ai",
    example: "hạ mình cầu cạnh * không chịu hạ mình lạy lục ai",
  },
  {
    word: "hà rầm",
    part_of_speech: "phụ từ",
    meaning: "(phương ngữ) luôn luôn, kéo dài một cách liên tục: nợ hà rầm",
    example: "nợ hà rầm",
  },
  {
    word: "hà rầm",
    part_of_speech: "phụ từ",
    meaning:
      "đủ thứ linh tinh, không thành hẳn ra một cái gì cụ thể: làm đủ thứ việc hà rầm",
    example: "làm đủ thứ việc hà rầm",
  },
  {
    word: "hạ nhục",
    part_of_speech: "động từ",
    meaning:
      "làm cho bị nhục nhã, bị tổn hại nặng nề đến danh dự: bị hạ nhục trước đám đông",
    example: "bị hạ nhục trước đám đông",
  },
  {
    word: "hạ sát",
    part_of_speech: "động từ",
    meaning: "giết người để trừng trị hoặc trả thù: hạ sát địch thủ",
    example: "hạ sát địch thủ",
  },
  {
    word: "hạ sách",
    part_of_speech: "danh từ",
    meaning:
      "phương kế được coi là không hay nhất trong các phương kế; đối lập với thượng sách: hạ sách mới phải dùng đến kế ấy",
    example: "hạ sách mới phải dùng đến kế ấy",
  },
  {
    word: "hạ sơn",
    part_of_speech: "động từ",
    meaning:
      "(người sống trên núi) xuống núi, không tiếp tục ở trên đó nữa: nhiều dân tộc thiểu số đã hạ sơn và định cư ở vùng này",
    example: "nhiều dân tộc thiểu số đã hạ sơn và định cư ở vùng này",
  },
  {
    word: "hạ thọ",
    part_of_speech: "danh từ",
    meaning:
      "lễ mừng sống được đến sáu mươi tuổi (ngày trước sáu mươi tuổi đã được coi là thọ): mừng hạ thọ * làm lễ hạ thọ",
    example: "mừng hạ thọ * làm lễ hạ thọ",
  },
  {
    word: "hà tất",
    part_of_speech: "phụ từ",
    meaning:
      "(trang trọng) chẳng cần, chẳng cần gì: chỗ anh em, hà tất phải khách sáo",
    example: "chỗ anh em, hà tất phải khách sáo",
  },
  {
    word: "hà tằn hà tiện",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) hết sức tằn tiện: lương ít, phải hà tằn hà tiện lắm mới đủ",
    example: "lương ít, phải hà tằn hà tiện lắm mới đủ",
  },
  {
    word: "hạ thủ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) giết chết bằng vũ khí: tên tướng cướp bị tay chân hạ thủ",
    example: "tên tướng cướp bị tay chân hạ thủ",
  },
  {
    word: "hạ thổ",
    part_of_speech: "động từ",
    meaning: "chôn hoặc đặt xuống đất: hạ thổ vò rượu nếp",
    example: "hạ thổ vò rượu nếp",
  },
  {
    word: "hạ thế",
    part_of_speech: "tính từ",
    meaning:
      "(điện) có hiệu thế thấp (có thể dùng trực tiếp); phân biệt với cao thế: đường dây hạ thế",
    example: "đường dây hạ thế",
  },
  {
    word: "hà thủ ô",
    part_of_speech: "danh từ",
    meaning:
      "cây leo cùng họ với rau răm, lá hình tim, mọc cách, hoa nhỏ màu trắng mọc thành chùm, củ to, ruột màu đỏ, dùng làm thuốc: rượu hà thủ ô",
    example: "rượu hà thủ ô",
  },
  {
    word: "hà thủ ô đỏ",
    part_of_speech: "danh từ",
    meaning:
      "cây leo cùng họ với rau răm, lá hình tim, mọc cách, hoa nhỏ màu trắng mọc thành chùm, củ to, ruột màu đỏ, dùng làm thuốc: rượu hà thủ ô",
    example: "rượu hà thủ ô",
  },
  {
    word: "hạ thuỷ",
    part_of_speech: "động từ",
    meaning:
      "đưa tàu thuyền xuống nước sau khi đóng mới hoặc sửa chữa xong: lễ hạ thuỷ",
    example: "lễ hạ thuỷ",
  },
  {
    word: "hạ tuần",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian mười ngày cuối tháng; phân biệt với thượng tuần, trung tuần: hạ tuần tháng 9",
    example: "hạ tuần tháng 9",
  },
  {
    word: "hạ tiện",
    part_of_speech: "tính từ",
    meaning: "(cũ, hiếm) như đê tiện: phường hạ tiện",
    example: "phường hạ tiện",
  },
  {
    word: "hà tiện",
    part_of_speech: "tính từ",
    meaning:
      "không dám tiêu pha gì, chỉ muốn dành dụm, nhiều khi đến quá mức thành bủn xỉn: có tính hà tiện * thằng cha hà tiện lắm!",
    example: "có tính hà tiện * thằng cha hà tiện lắm!",
  },
  {
    word: "hách",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như hách dịch: nói bằng một giọng rất hách",
    example: "nói bằng một giọng rất hách",
  },
  {
    word: "hách",
    part_of_speech: "tính từ",
    meaning: "có vẻ oai: diện bộ cánh trông rất hách",
    example: "diện bộ cánh trông rất hách",
  },
  {
    word: "hách dịch",
    part_of_speech: "tính từ",
    meaning:
      "có thái độ ra oai, nạt nộ, hạch sách người khác, do cậy mình có quyền thế: giọng hách dịch * thái độ hách dịch",
    example: "giọng hách dịch * thái độ hách dịch",
  },
  {
    word: "hạc",
    part_of_speech: "danh từ",
    meaning:
      'chim lớn, chân rất cao, cổ và mỏ dài, thường dùng tượng trưng cho sự sống lâu: "Cảm thương con hạc ở chùa, Muốn bay da diết, có rùa giữ chân." (ca dao)',
    example:
      'Cảm thương con hạc ở chùa, Muốn bay da diết, có rùa giữ chân." (ca dao)',
  },
  {
    word: "hạch",
    part_of_speech: "danh từ",
    meaning: "chỗ phình to trên mạch bạch huyết, thường vô hại.",
    example: "nổi hạch ở cổ",
  },
  {
    word: "hạch",
    part_of_speech: "động từ",
    meaning: "hỏi vặn, bắt bẻ, cố ý gây khó dễ: hạch đủ điều",
    example: "hạch đủ điều",
  },
  {
    word: "hạch",
    part_of_speech: "động từ",
    meaning: "đòi hỏi một cách trịch thượng: lí trưởng hạch tiền của dân",
    example: "lí trưởng hạch tiền của dân",
  },
  {
    word: "hạch hỏi",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) hỏi vặn đủ điều để bắt phải nói (nói khái quát): hạch hỏi đủ mọi điều",
    example: "hạch hỏi đủ mọi điều",
  },
  {
    word: "hạch sách",
    part_of_speech: "động từ",
    meaning:
      "bắt bẻ, đòi hỏi quá đáng để làm khó dễ: lên giọng hạch sách * hạch sách thứ nọ thứ kia",
    example: "lên giọng hạch sách * hạch sách thứ nọ thứ kia",
  },
  {
    word: "hài",
    part_of_speech: "danh từ",
    meaning:
      "(Từ cũ) loại giày thời xưa, thường có mũi cong và phía ngoài có thêu hình: đôi hài vạn dặm",
    example: "đôi hài vạn dặm",
  },
  {
    word: "hài",
    part_of_speech: "động từ",
    meaning: "(Phương ngữ) kể rõ ra, vạch rõ ra: hài ra từng tội",
    example: "hài ra từng tội",
  },
  {
    word: "hài",
    part_of_speech: "tính từ",
    meaning:
      "có những yếu tố gây cười: phim hài * bộ mặt hắn trông rất hài * diễn viên chuyên diễn vai hài",
    example:
      "phim hài * bộ mặt hắn trông rất hài * diễn viên chuyên diễn vai hài",
  },
  {
    word: "hai",
    part_of_speech: "danh từ",
    meaning:
      "số (ghi bằng 2) liền sau số một trong dãy số tự nhiên: một trăm linh hai * ba vạn hai (ba mươi hai nghìn) * đứng thứ hai",
    example:
      "một trăm linh hai * ba vạn hai (ba mươi hai nghìn) * đứng thứ hai",
  },
  {
    word: "hai",
    part_of_speech: "danh từ",
    meaning:
      "(Phương ngữ) (thường viết hoa) người lớn tuổi hơn cả, đứng đầu trong hàng những người cùng một thế hệ trong gia đình: anh Hai * chị Hai",
    example: "anh Hai * chị Hai",
  },
  {
    word: "hạch toán",
    part_of_speech: "động từ",
    meaning:
      "ghi chép thực trạng và sự biến đổi của các yếu tố sản xuất về các mặt số lượng và chất lượng: hạch toán kinh doanh * hạch toán lại các khoản thu chi từ đầu năm",
    example:
      "hạch toán kinh doanh * hạch toán lại các khoản thu chi từ đầu năm",
  },
  {
    word: "hái",
    part_of_speech: "danh từ",
    meaning:
      "nông cụ gồm một lưỡi thép có răng cưa gắn vào một thanh gỗ hay tre có móc dài, dùng để gặt lúa: rèn một lưỡi a bằng ba lưỡi hái (tng)",
    example: "rèn một lưỡi a bằng ba lưỡi hái (tng)",
  },
  {
    word: "hái",
    part_of_speech: "động từ",
    meaning:
      "dùng tay làm cho hoa, quả, lá, cành đứt lìa khỏi cây để lấy về: hái rau * hái hoa * hái ra tiền (b)",
    example: "hái rau * hái hoa * hái ra tiền (b)",
  },
  {
    word: "hãi",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) sợ: con chó trông hãi lắm * thấy gì cũng hãi",
    example: "con chó trông hãi lắm * thấy gì cũng hãi",
  },
  {
    word: "hại",
    part_of_speech: "danh từ",
    meaning:
      "cái gây tổn thất, tổn thương: diệt trừ mối hại lớn * hút thuốc lá có hại cho sức khoẻ",
    example: "diệt trừ mối hại lớn * hút thuốc lá có hại cho sức khoẻ",
  },
  {
    word: "hại",
    part_of_speech: "tính từ",
    meaning:
      "bị tổn thất, tổn thương: hút thuốc lá có hại cho sức khoẻ * vợ dại không hại bằng đũa vênh (tng)",
    example:
      "hút thuốc lá có hại cho sức khoẻ * vợ dại không hại bằng đũa vênh (tng)",
  },
  {
    word: "hại",
    part_of_speech: "động từ",
    meaning:
      "làm tổn thất, tổn thương: sâu bệnh hại mùa màng * rắp tâm hại người",
    example: "sâu bệnh hại mùa màng * rắp tâm hại người",
  },
  {
    word: "hải chiến",
    part_of_speech: "động từ",
    meaning: "chiến đấu bằng tàu thuyền, ở trên biển: trận hải chiến",
    example: "trận hải chiến",
  },
  {
    word: "hải dương học",
    part_of_speech: "danh từ",
    meaning:
      "khoa học nghiên cứu về biển và các hiện tượng địa chất, khí tượng, vật lí, hoá học, sinh học, v.v. của biển: viện nghiên cứu hải dương học * nhà hải dương học",
    example: "viện nghiên cứu hải dương học * nhà hải dương học",
  },
  {
    word: "hải dương",
    part_of_speech: "danh từ",
    meaning: "biển và đại dương (nói khái quát): tàu thám hiểm hải dương",
    example: "tàu thám hiểm hải dương",
  },
  {
    word: "hải đăng",
    part_of_speech: "danh từ",
    meaning:
      "đèn pha đặt ở bờ biển, hải đảo để giúp tàu thuyền định hướng đi trong đêm tối: ngọn hải đăng",
    example: "ngọn hải đăng",
  },
  {
    word: "hải đội",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị chiến thuật cơ sở trong hải quân, gồm các tàu chiến đấu cùng loại từ tàu cấp hai trở xuống (nhỏ hơn hải đoàn): hải đội tàu ngư lôi",
    example: "hải đội tàu ngư lôi",
  },
  {
    word: "hải đoàn",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi chung các đơn vị hải quân cấp lữ đoàn hoặc sư đoàn gồm các tàu chiến cùng loại hoặc khác loại (lớn hơn hải đội): hải đoàn tự vệ * hải đoàn trưởng",
    example: "hải đoàn tự vệ * hải đoàn trưởng",
  },
  {
    word: "hải giới",
    part_of_speech: "danh từ",
    meaning:
      "đường phân giới trên biển của mỗi nước: con tàu đã vượt qua hải giới của nước ta",
    example: "con tàu đã vượt qua hải giới của nước ta",
  },
  {
    word: "hài hoà",
    part_of_speech: "tính từ",
    meaning:
      "có sự kết hợp cân đối giữa các yếu tố, các thành phần, gây được ấn tượng về cái đẹp, cái hoàn hảo: màu sắc hài hoà * cách bài trí thiếu hài hoà",
    example: "màu sắc hài hoà * cách bài trí thiếu hài hoà",
  },
  {
    word: "hãi hùng",
    part_of_speech: "",
    meaning:
      'sợ hãi hết sức: giấc mơ hãi hùng * "Một mình khôn biết làm sao, Dặm rừng bước thấp bước cao hãi hùng." (TKiều)',
    example:
      'giấc mơ hãi hùng * "Một mình khôn biết làm sao, Dặm rừng bước thấp bước cao hãi hùng." (TKiều)',
  },
  {
    word: "hài hước",
    part_of_speech: "",
    meaning: "vui đùa, gây cười: câu chuyện hài hước * vẻ mặt nom rất hài hước",
    example: "câu chuyện hài hước * vẻ mặt nom rất hài hước",
  },
  {
    word: "hải hà",
    part_of_speech: "danh từ",
    meaning:
      '(văn chương) biển và sông (nói khái quát); thường dùng để ví lòng bao dung, độ lượng rộng lớn: mở lượng hải hà * "Làm người độ lượng hải hà, Đại nhân chí khí vậy mà dung nhơn." (MPXH)',
    example:
      'mở lượng hải hà * "Làm người độ lượng hải hà, Đại nhân chí khí vậy mà dung nhơn." (MPXH)',
  },
  {
    word: "hải lí",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị đo độ dài trên mặt biển, bằng 1,852 kilomet: tàu đã đi được khoảng 200 hải lí",
    example: "tàu đã đi được khoảng 200 hải lí",
  },
  {
    word: "hài kịch",
    part_of_speech: "danh từ",
    meaning:
      "kịch dùng hình thức gây cười để chế giễu, phê phán hoặc đả kích những thói xấu, những biểu hiện tiêu cực trong xã hội: biểu diễn hài kịch",
    example: "biểu diễn hài kịch",
  },
  {
    word: "hai lòng",
    part_of_speech: "tính từ",
    meaning:
      "không thuỷ chung, không trung thành, trước sau không như một: ăn ở hai lòng",
    example: "ăn ở hai lòng",
  },
  {
    word: "hái lượm",
    part_of_speech: "động từ",
    meaning:
      "thu lượm những hoa quả sẵn có trong thiên nhiên để sinh sống (một hình thái kinh tế nguyên thuỷ): người nguyên thuỷ sống bằng săn bắt, hái lượm",
    example: "người nguyên thuỷ sống bằng săn bắt, hái lượm",
  },
  {
    word: "hài lòng",
    part_of_speech: "động từ",
    meaning:
      "cảm thấy hợp ý vì đáp ứng được đầy đủ những đòi hỏi đã đặt ra: hài lòng với kết quả thi * chưa hài lòng về con cái",
    example: "hài lòng với kết quả thi * chưa hài lòng về con cái",
  },
  {
    word: "hải lý",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị đo độ dài trên mặt biển, bằng 1,852 kilomet: tàu đã đi được khoảng 200 hải lí",
    example: "tàu đã đi được khoảng 200 hải lí",
  },
  {
    word: "hai năm rõ mười",
    part_of_speech: "",
    meaning:
      "rõ rành rành, không còn nghi ngờ gì nữa hoặc không còn chối cãi được nữa: việc đã hai năm rõ mười lại còn chối",
    example: "việc đã hai năm rõ mười lại còn chối",
  },
  {
    word: "hải ngoại",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) nước ngoài (nói khái quát): bôn ba nơi hải ngoại * ra hải ngoại học tập",
    example: "bôn ba nơi hải ngoại * ra hải ngoại học tập",
  },
  {
    word: "hải mã",
    part_of_speech: "danh từ",
    meaning:
      "(cũng hải mã) cá biển đầu giống đầu ngựa, thân dài có nhiều đốt, đuôi thon nhỏ và cong, có thể dùng làm thuốc.",
    example: "chơi cá ngựa",
  },
  {
    word: "hải mã",
    part_of_speech: "động từ",
    meaning:
      "đánh cuộc ăn tiền trong các cuộc đua ngựa: hai người cá ngựa với nhau",
    example: "hai người cá ngựa với nhau",
  },
  {
    word: "hải quân",
    part_of_speech: "danh từ",
    meaning:
      "quân chủng hoạt động trên biển và đại dương: căn cứ hải quân * lực lượng hải quân * lính hải quân",
    example: "căn cứ hải quân * lực lượng hải quân * lính hải quân",
  },
  {
    word: "hại nhân nhân hại",
    part_of_speech: "",
    meaning:
      'làm hại người thì tất sẽ bị người làm hại lại: "Nàng rằng: Lồng lộng trời cao, Hại nhân, nhân hại, sự nào tại ta." (TKiều)',
    example:
      'Nàng rằng: Lồng lộng trời cao, Hại nhân, nhân hại, sự nào tại ta." (TKiều)',
  },
  {
    word: "hải phận quốc tế",
    part_of_speech: "danh từ",
    meaning:
      "vùng biển nằm ngoài hải phận của một nước và không thuộc quyền quản lí của bất cứ quốc gia nào, nơi tàu thuyền được tự do đi lại với điều kiện phải tôn trọng những quy định chung của luật hàng hải quốc tế: tàu đã đi qua hải phận quốc tế",
    example: "tàu đã đi qua hải phận quốc tế",
  },
  {
    word: "hải quan",
    part_of_speech: "danh từ",
    meaning:
      "việc kiểm soát và đánh thuế đối với hàng hoá xuất nhập cảnh: thuế hải quan * thủ tục hải quan",
    example: "thuế hải quan * thủ tục hải quan",
  },
  {
    word: "hải quan",
    part_of_speech: "danh từ",
    meaning:
      "cơ quan làm công tác kiểm soát, đánh thuế hàng hoá xuất nhập cảnh: nộp đầy đủ giấy tờ cho hải quan * hải quan cửa khẩu Nội Bài",
    example: "nộp đầy đủ giấy tờ cho hải quan * hải quan cửa khẩu Nội Bài",
  },
  {
    word: "hải phận",
    part_of_speech: "danh từ",
    meaning:
      "vùng biển ven bờ, có chiều rộng quy định (thường không vượt quá 12 hải lí), thuộc chủ quyền của một nước ven biển: bảo vệ chủ quyền lãnh hải tổ quốc",
    example: "bảo vệ chủ quyền lãnh hải tổ quốc",
  },
  {
    word: "hài nhi",
    part_of_speech: "danh từ",
    meaning:
      "(Từ cũ, Kiểu cách) trẻ mới sinh, ở độ tuổi đang còn bú: đứa hài nhi",
    example: "đứa hài nhi",
  },
  {
    word: "hái ra tiền",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) kiếm được nhiều tiền một cách dễ dàng: làm nghề ấy cũng hái ra tiền",
    example: "làm nghề ấy cũng hái ra tiền",
  },
  {
    word: "hải sản",
    part_of_speech: "danh từ",
    meaning:
      "sản phẩm thực vật, động vật khai thác từ biển (nói khái quát): bào ngư là hải sản quý",
    example: "bào ngư là hải sản quý",
  },
  {
    word: "hải tặc",
    part_of_speech: "danh từ",
    meaning: "cướp biển: bị hải tặc cướp tàu",
    example: "bị hải tặc cướp tàu",
  },
  {
    word: "hai thân",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) song thân: "Đến nhà vừa thấy tin nhà, Hai thân còn dở tiệc hoa chưa về." (TKiều)',
    example: "Đến nhà vừa thấy tin nhà, Hai thân còn dở tiệc hoa chưa về.",
  },
  {
    word: "hải thuyền",
    part_of_speech: "danh từ",
    meaning: "thuyền chiến hoạt động trên biển: chặn đánh hải thuyền của địch",
    example: "chặn đánh hải thuyền của địch",
  },
  {
    word: "hài thanh",
    part_of_speech: "động từ",
    meaning:
      "kết hợp âm thanh theo những quy tắc nhất định sao cho hài hoà, êm tai: luật hài thanh",
    example: "luật hài thanh",
  },
  {
    word: "hải văn",
    part_of_speech: "danh từ",
    meaning:
      "khoa học nghiên cứu các quy luật vận động của nước ở biển và đại dương: ngành hải văn",
    example: "ngành hải văn",
  },
  {
    word: "hải trình",
    part_of_speech: "danh từ",
    meaning: "(hiếm) hành trình theo đường biển: hải trình đến đảo Phú Quốc",
    example: "hải trình đến đảo Phú Quốc",
  },
  {
    word: "hải vị",
    part_of_speech: "danh từ",
    meaning: "thức ăn quý, chế biến từ các sản phẩm lấy ở biển: sơn hào hải vị",
    example: "sơn hào hải vị",
  },
  {
    word: "hàm",
    part_of_speech: "danh từ",
    meaning:
      "phần xương ở vùng miệng, có chức năng cắn, giữ và nhai thức ăn: hàm răng * hất hàm",
    example: "hàm răng * hất hàm",
  },
  {
    word: "hàm",
    part_of_speech: "danh từ",
    meaning: "Hàm cấp: phong hàm đại tá",
    example: "phong hàm đại tá",
  },
  {
    word: "hàm",
    part_of_speech: "danh từ",
    meaning:
      "biến mà giá trị của nó được xác định khi đã biết giá trị của một hay nhiều biến khác: hàm tuyến tính * hàm lượng giác",
    example: "hàm tuyến tính * hàm lượng giác",
  },
  {
    word: "hàm",
    part_of_speech: "động từ",
    meaning:
      "có chứa đựng một nội dung ý nghĩa nào đó ở bên trong, chứ không diễn đạt trực tiếp: Câu nói hàm nhiều ý nghĩa sâu sắc.",
    example: "Câu nói hàm nhiều ý nghĩa sâu sắc.",
  },
  {
    word: "hám",
    part_of_speech: "động từ",
    meaning: "ham, muốn đến mức bất chấp tất cả: hám tiền * hám của",
    example: "hám tiền * hám của",
  },
  {
    word: "hàm ẩn",
    part_of_speech: "động từ",
    meaning:
      "ẩn chứa một nội dung nào đó ở sâu bên trong: bức thư hàm ẩn một lời trách cứ * cái nhìn hàm ẩn sự cảm thông sâu sắc",
    example:
      "bức thư hàm ẩn một lời trách cứ * cái nhìn hàm ẩn sự cảm thông sâu sắc",
  },
  {
    word: "ham",
    part_of_speech: "động từ",
    meaning:
      "(đôi khi tiêu cực) thích đến mức hầu như lúc nào cũng nghĩ đến: ham học * ham ăn * một đứa trẻ ham chơi",
    example: "ham học * ham ăn * một đứa trẻ ham chơi",
  },
  {
    word: "hãm",
    part_of_speech: "động từ",
    meaning:
      "cho nước sôi vào chè hay dược liệu và giữ hơi nóng một lúc để lấy nước cốt đặc: hãm một ấm trà * hãm chè xanh",
    example: "hãm một ấm trà * hãm chè xanh",
  },
  {
    word: "hãm",
    part_of_speech: "động từ",
    meaning:
      "làm cho giảm bớt hoặc ngừng vận động, hoạt động, phát triển: hãm phanh cho xe chạy chậm lại * hãm tiết canh",
    example: "hãm phanh cho xe chạy chậm lại * hãm tiết canh",
  },
  {
    word: "hãm",
    part_of_speech: "động từ",
    meaning:
      "làm cho (đối phương) lâm vào thế không thể tự do hoạt động, hành động: hãm thành * bị địch hãm lại trong thành phố",
    example: "hãm thành * bị địch hãm lại trong thành phố",
  },
  {
    word: "hãm",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có tác dụng đem lại vận rủi, làm cho gặp điều không may: thằng cha trông hãm lắm!",
    example: "thằng cha trông hãm lắm!",
  },
  {
    word: "ham chuộng",
    part_of_speech: "động từ",
    meaning:
      "ưa thích hơn những cái khác: ham chuộng thể thao * một diễn viên được khán giả hết sức ham chuộng",
    example:
      "ham chuộng thể thao * một diễn viên được khán giả hết sức ham chuộng",
  },
  {
    word: "hãm hại",
    part_of_speech: "động từ",
    meaning:
      "dùng mưu kế, thủ đoạn để làm hại: bị kẻ xấu vu oan hãm hại * ngấm ngầm hãm hại",
    example: "bị kẻ xấu vu oan hãm hại * ngấm ngầm hãm hại",
  },
  {
    word: "hàm hồ",
    part_of_speech: "tính từ",
    meaning:
      "(cách nói năng) thiếu căn cứ, không cân nhắc đúng sai, bạ đâu nói đấy: ăn nói hàm hồ",
    example: "ăn nói hàm hồ",
  },
  {
    word: "hàm cấp",
    part_of_speech: "danh từ",
    meaning:
      "cấp bậc và chức vị nói lên quyền hạn và vinh dự của cán bộ trong quân đội và trong một số ngành (như ngoại giao): hưởng lương theo hàm cấp",
    example: "hưởng lương theo hàm cấp",
  },
  {
    word: "hàm ếch",
    part_of_speech: "danh từ",
    meaning:
      "thành trên của khoang miệng, ngăn miệng với lỗ mũi, có hình giống như miệng con ếch há ra: phẫu thuật vá hàm ếch * cháu bé bị hở hàm ếch",
    example: "phẫu thuật vá hàm ếch * cháu bé bị hở hàm ếch",
  },
  {
    word: "hàm ếch",
    part_of_speech: "danh từ",
    meaning: "có hình giống miệng con ếch há ra: hầm hàm ếch * giày hàm ếch",
    example: "hầm hàm ếch * giày hàm ếch",
  },
  {
    word: "hàm ếch",
    part_of_speech: "danh từ",
    meaning:
      "phần đào khoét sâu vào vách công sự: công sự hàm ếch * khoét hàm ếch",
    example: "công sự hàm ếch * khoét hàm ếch",
  },
  {
    word: "hám lợi",
    part_of_speech: "động từ",
    meaning:
      "ham muốn lợi lộc đến mức mù quáng: vì hám lợi mà làm việc sai trái",
    example: "vì hám lợi mà làm việc sai trái",
  },
  {
    word: "hàm chứa",
    part_of_speech: "động từ",
    meaning:
      "chứa đựng một nội dung nào đó ở bên trong, không diễn đạt trực tiếp: nụ cười hàm chứa vẻ mỉa mai * mỗi lời cô ấy nói đều hàm chứa ẩn ý",
    example:
      "nụ cười hàm chứa vẻ mỉa mai * mỗi lời cô ấy nói đều hàm chứa ẩn ý",
  },
  {
    word: "ham hố",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) ham một cách quá mức (hàm ý chê): ham hố quyền chức",
    example: "ham hố quyền chức",
  },
  {
    word: "hãm hiếp",
    part_of_speech: "động từ",
    meaning: "hiếp dâm (nói khái quát): hãm hiếp phụ nữ",
    example: "hãm hiếp phụ nữ",
  },
  {
    word: "hám danh",
    part_of_speech: "động từ",
    meaning: "ham muốn danh vọng đến mức mù quáng: thói hám danh",
    example: "thói hám danh",
  },
  {
    word: "hàm ngôn",
    part_of_speech: "danh từ",
    meaning:
      "điều người nói không diễn đạt trực tiếp, người nghe phải tự suy ra để hiểu; phân biệt với hiển ngôn: câu nói đầy hàm ngôn * phân biệt hàm ngôn với hiển ngôn",
    example: "câu nói đầy hàm ngôn * phân biệt hàm ngôn với hiển ngôn",
  },
  {
    word: "hàm lượng",
    part_of_speech: "danh từ",
    meaning:
      "lượng của một chất chứa trong một hỗn hợp hoặc trong một chất nào đó, tính bằng phần trăm (%): thức ăn có hàm lượng vitamin cao * kiểm tra hàm lượng chì trong xăng",
    example:
      "thức ăn có hàm lượng vitamin cao * kiểm tra hàm lượng chì trong xăng",
  },
  {
    word: "hàm số",
    part_of_speech: "danh từ",
    meaning:
      "hàm mà giá trị của biến là các số: hàm số y = ax + b * hàm số bậc hai * vẽ đồ thị hàm số",
    example: "hàm số y = ax + b * hàm số bậc hai * vẽ đồ thị hàm số",
  },
  {
    word: "ham mê",
    part_of_speech: "động từ",
    meaning:
      "ưa thích tới mức mải mê theo đuổi, không thiết đến những cái khác: ham mê đọc sách * ham mê cờ bạc",
    example: "ham mê đọc sách * ham mê cờ bạc",
  },
  {
    word: "hàm nghĩa",
    part_of_speech: "động từ",
    meaning:
      "chứa đựng một nội dung ý nghĩa nào đó ở bên trong, chứ không diễn đạt trực tiếp: câu nói ấy không hàm nghĩa một điều gì",
    example: "câu nói ấy không hàm nghĩa một điều gì",
  },
  {
    word: "hàm nghĩa",
    part_of_speech: "danh từ",
    meaning:
      "ý nghĩa được chứa đựng ở bên trong, không diễn đạt ra trực tiếp: khái niệm  *  mang một hàm nghĩa rất sâu xa",
    example: "khái niệm  *  mang một hàm nghĩa rất sâu xa",
  },
  {
    word: "hàm oan",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) phải mang nỗi oan ức mà không thể thanh minh, giãi bày được: bị hàm oan",
    example: "bị hàm oan",
  },
  {
    word: "ham muốn",
    part_of_speech: "động từ",
    meaning:
      "mong muốn cao độ, ham muốn một cách tha thiết: ham muốn hiểu biết",
    example: "ham muốn hiểu biết",
  },
  {
    word: "hàm ơn",
    part_of_speech: "động từ",
    meaning: "chịu mang ơn: chúng tôi hàm ơn anh",
    example: "chúng tôi hàm ơn anh",
  },
  {
    word: "hàm răng",
    part_of_speech: "danh từ",
    meaning: "toàn bộ phần răng mọc quanh hàm: hàm răng trắng và đều tăm tắp",
    example: "hàm răng trắng và đều tăm tắp",
  },
  {
    word: "hàm súc",
    part_of_speech: "tính từ",
    meaning:
      "(hình thức diễn đạt) cô đọng và chứa đựng bên trong nhiều ý sâu sắc: câu thơ rất hàm súc * văn viết hàm súc",
    example: "câu thơ rất hàm súc * văn viết hàm súc",
  },
  {
    word: "hãm tài",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có tác dụng đem lại vận rủi, làm cho hao tài: trông người đã thấy hãm tài * bộ mặt hãm tài",
    example: "trông người đã thấy hãm tài * bộ mặt hãm tài",
  },
  {
    word: "ham thích",
    part_of_speech: "",
    meaning: "thích lắm và muốn có được (nói khái quát): ham thích văn chương",
    example: "ham thích văn chương",
  },
  {
    word: "hàm thụ",
    part_of_speech: "tính từ",
    meaning:
      "(hình thức dạy hoặc học) theo lối gửi giáo trình và bài vở qua bưu điện: hàm thụ đại học",
    example: "hàm thụ đại học",
  },
  {
    word: "hàm ý",
    part_of_speech: "động từ",
    meaning:
      "chứa đựng một ý nào đó ngầm ở bên trong: câu nói hàm ý trêu chọc * lời khen hàm ý xỏ xiên",
    example: "câu nói hàm ý trêu chọc * lời khen hàm ý xỏ xiên",
  },
  {
    word: "hàm ý",
    part_of_speech: "danh từ",
    meaning:
      "ý được chứa đựng ở bên trong, không diễn đạt ra trực tiếp: câu nói chứa nhiều hàm ý * một cái nhìn đầy hàm ý",
    example: "câu nói chứa nhiều hàm ý * một cái nhìn đầy hàm ý",
  },
  {
    word: "hàm tiếu",
    part_of_speech: "động từ",
    meaning: "(hiếm) chúm chím cười: nụ cười hàm tiếu * đoá hoa hàm tiếu",
    example: "nụ cười hàm tiếu * đoá hoa hàm tiếu",
  },
  {
    word: "han",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái bắt đầu bị gỉ, làm cho lớp bên ngoài đổi màu: cái thau đồng đã bắt đầu bị han",
    example: "cái thau đồng đã bắt đầu bị han",
  },
  {
    word: "hạn",
    part_of_speech: "danh từ",
    meaning:
      "tình trạng thiếu nước do nắng lâu, không mưa gây ra: trời hạn * chống hạn cho lúa * trăng quầng thì hạn, trăng tán thì mưa (tng)",
    example:
      "trời hạn * chống hạn cho lúa * trăng quầng thì hạn, trăng tán thì mưa (tng)",
  },
  {
    word: "hạn",
    part_of_speech: "danh từ",
    meaning:
      "thời gian quy định cho một công việc nào đó: quá hạn đã ba hôm * hết hạn bảo hành",
    example: "quá hạn đã ba hôm * hết hạn bảo hành",
  },
  {
    word: "hạn",
    part_of_speech: "động từ",
    meaning:
      "quy định thời gian cho một công việc nào đó: hạn cho ba ngày phải làm xong",
    example: "hạn cho ba ngày phải làm xong",
  },
  {
    word: "hạn",
    part_of_speech: "danh từ",
    meaning:
      "điều không may lớn, tai nạn gặp phải do số phận đã định sẵn, theo quan niệm dân gian: gặp hạn * làm lễ giải hạn",
    example: "gặp hạn * làm lễ giải hạn",
  },
  {
    word: "hán",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) loại giày của những nhà quyền quý thời xưa: "Rửa chân đi hán, đi hài, Rửa chân đi đất chớ hoài rửa chân." (ca dao)',
    example:
      'Rửa chân đi hán, đi hài, Rửa chân đi đất chớ hoài rửa chân." (ca dao)',
  },
  {
    word: "hàn",
    part_of_speech: "động từ",
    meaning:
      "nối liền hai bộ phận kim loại với nhau bằng cách làm cho nóng chảy: hàn hai ống thép * hàn cửa sắt",
    example: "hàn hai ống thép * hàn cửa sắt",
  },
  {
    word: "hàn",
    part_of_speech: "động từ",
    meaning:
      "làm cho liền kín lại chỗ bị vỡ, bị nứt, thủng: hàn ống nước * hàn chiếc răng sâu * hàn con đê",
    example: "hàn ống nước * hàn chiếc răng sâu * hàn con đê",
  },
  {
    word: "hàn",
    part_of_speech: "tính từ",
    meaning:
      '(Ít dùng) lạnh: "Bệnh trần đòi đoạn tân toan, Lửa cơ đốt ruột, dao hàn cắt da." (CO)',
    example:
      'Bệnh trần đòi đoạn tân toan, Lửa cơ đốt ruột, dao hàn cắt da." (CO)',
  },
  {
    word: "hàn",
    part_of_speech: "tính từ",
    meaning:
      "(cơ thể) ở tạng lạnh, với những biểu hiện như: sợ rét, chân tay lạnh, tiểu tiện nhiều, v.v. (theo cách nói của đông y): máu hàn",
    example: "máu hàn",
  },
  {
    word: "hạn chế",
    part_of_speech: "",
    meaning:
      "giữ lại, ngăn lại trong một giới hạn nhất định, không thể hoặc không để cho vượt qua: hạn chế chi tiêu * trình độ còn hạn chế * tầm nhìn còn rất hạn chế",
    example:
      "hạn chế chi tiêu * trình độ còn hạn chế * tầm nhìn còn rất hạn chế",
  },
  {
    word: "han gỉ",
    part_of_speech: "tính từ",
    meaning: "ở trạng thái bị gỉ (nói khái quát): cửa sắt bị han gỉ",
    example: "cửa sắt bị han gỉ",
  },
  {
    word: "hạn dùng",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) hạn sử dụng của hàng hoá: thực phẩm đã quá hạn dùng * sản phẩm có hạn dùng là 12 tháng",
    example: "thực phẩm đã quá hạn dùng * sản phẩm có hạn dùng là 12 tháng",
  },
  {
    word: "hạn định",
    part_of_speech: "động từ",
    meaning:
      "định trước một giới hạn, một chừng mực: hạn định thời gian hoàn thành công trình",
    example: "hạn định thời gian hoàn thành công trình",
  },
  {
    word: "hàn gắn",
    part_of_speech: "động từ",
    meaning:
      "làm cho lành lại, liền lại như lúc đầu (nói khái quát; thường dùng với nghĩa bóng): hàn gắn hạnh phúc gia đình * hàn gắn vết thương chiến tranh",
    example: "hàn gắn hạnh phúc gia đình * hàn gắn vết thương chiến tranh",
  },
  {
    word: "hạn hẹp",
    part_of_speech: "tính từ",
    meaning:
      "có phạm vi, mức độ bị hạn chế, không đủ để đáp ứng yêu cầu: hiểu biết còn hạn hẹp * đồng lương hạn hẹp * nguồn kinh phí hạn hẹp",
    example:
      "hiểu biết còn hạn hẹp * đồng lương hạn hẹp * nguồn kinh phí hạn hẹp",
  },
  {
    word: "hạn hán",
    part_of_speech: "danh từ",
    meaning: "hạn, nắng hạn (nói khái quát): hạn hán kéo dài",
    example: "hạn hán kéo dài",
  },
  {
    word: "hàn huyên",
    part_of_speech: "động từ",
    meaning:
      "trò chuyện, hỏi han tâm tình khi gặp lại nhau sau một thời gian xa cách: trò chuyện hàn huyên * lâu ngày mới gặp, hàn huyên với nhau cả buổi",
    example:
      "trò chuyện hàn huyên * lâu ngày mới gặp, hàn huyên với nhau cả buổi",
  },
  {
    word: "hãn hữu",
    part_of_speech: "tính từ",
    meaning:
      "hiếm có, ít thấy: một trường hợp hãn hữu * hãn hữu lắm hai người mới nói chuyện với nhau",
    example:
      "một trường hợp hãn hữu * hãn hữu lắm hai người mới nói chuyện với nhau",
  },
  {
    word: "hàn lâm",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có tính chất trừu tượng, khó hiểu (như theo lối văn của một số viện sĩ hàn lâm): lối viết mang tính hàn lâm",
    example: "lối viết mang tính hàn lâm",
  },
  {
    word: "hạn mức",
    part_of_speech: "danh từ",
    meaning:
      "mức quy định, không được vượt quá: hạn mức đầu tư * hạn mức xuất khẩu",
    example: "hạn mức đầu tư * hạn mức xuất khẩu",
  },
  {
    word: "hạn ngạch",
    part_of_speech: "danh từ",
    meaning:
      "mức định ra từ trước để phân loại các công trình xây dựng hay một số đối tượng khác: xếp lương theo hạn ngạch * công trình trên hạn ngạch",
    example: "xếp lương theo hạn ngạch * công trình trên hạn ngạch",
  },
  {
    word: "hạn ngạch",
    part_of_speech: "danh từ",
    meaning: "như quota: giao chỉ tiêu hạn ngạch xuất khẩu cho địa phương",
    example: "giao chỉ tiêu hạn ngạch xuất khẩu cho địa phương",
  },
  {
    word: "hàn ôn",
    part_of_speech: "động từ",
    meaning:
      '(cũ, hiếm) như hàn huyên: "Tiệc rồi giãi chuyện hàn ôn, Gấm chen vẻ quý, rượu ngon giọng tình." (NĐM)',
    example:
      'Tiệc rồi giãi chuyện hàn ôn, Gấm chen vẻ quý, rượu ngon giọng tình." (NĐM)',
  },
  {
    word: "hãng",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức sản xuất hàng hoá, kinh doanh lớn: hãng buôn * hãng phim truyền hình",
    example: "hãng buôn * hãng phim truyền hình",
  },
  {
    word: "hạng",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp người hoặc vật cùng loại, được xếp theo sự đánh giá cao thấp, lớn nhỏ, tốt xấu khác nhau: di tích lịch sử đã xếp hạng * huân chương kháng chiến hạng nhất * hạng người không ra gì",
    example:
      "di tích lịch sử đã xếp hạng * huân chương kháng chiến hạng nhất * hạng người không ra gì",
  },
  {
    word: "hạn vận",
    part_of_speech: "danh từ",
    meaning: "(cũ, hiếm) như vận hạn: hạn vận đã hết",
    example: "hạn vận đã hết",
  },
  {
    word: "hàn vi",
    part_of_speech: "tính từ",
    meaning:
      '(cũ) nghèo và không có địa vị gì trong xã hội (thường nói về một đoạn đời đã qua, đối lập với sự thành đạt, vinh hiển hiện nay): "Quen nhau từ thuở hàn vi, Bây giờ sang trọng sá chi thân hèn." (ca dao)',
    example:
      'Quen nhau từ thuở hàn vi, Bây giờ sang trọng sá chi thân hèn." (ca dao)',
  },
  {
    word: "hàng",
    part_of_speech: "danh từ",
    meaning: "sản phẩm để bán: khách đến mua hàng * phương thức hàng đổi hàng",
    example: "khách đến mua hàng * phương thức hàng đổi hàng",
  },
  {
    word: "hàng",
    part_of_speech: "danh từ",
    meaning:
      "nơi bán hàng nhỏ của tư nhân, chuyên bán một loại hàng nào đó: hàng nước * hàng quần áo * hàng thịt nguýt hàng cá (tng)",
    example: "hàng nước * hàng quần áo * hàng thịt nguýt hàng cá (tng)",
  },
  {
    word: "hàng",
    part_of_speech: "danh từ",
    meaning: "đồ may mặc (nói khái quát): hàng hè * hàng len * hàng kaki",
    example: "hàng hè * hàng len * hàng kaki",
  },
  {
    word: "hàng",
    part_of_speech: "danh từ",
    meaning: "đồ dệt mỏng bằng tơ (nói khái quát): áo lụa quần hàng",
    example: "áo lụa quần hàng",
  },
  {
    word: "hàng",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp người hoặc vật nối tiếp nhau thành một dãy dài, thường theo một khoảng cách đều đặn: giăng dây để cấy cho thẳng hàng * xe đậu thành hàng dài * hai hàng nước mắt",
    example:
      "giăng dây để cấy cho thẳng hàng * xe đậu thành hàng dài * hai hàng nước mắt",
  },
  {
    word: "hàng",
    part_of_speech: "danh từ",
    meaning: "bậc, xếp theo địa vị, vị trí: chữ số hàng trăm * hàng quan văn",
    example: "chữ số hàng trăm * hàng quan văn",
  },
  {
    word: "hàng",
    part_of_speech: "danh từ",
    meaning:
      "(Ít dùng) tập hợp người sinh sống trong cùng một đơn vị hành chính trong quan hệ đối với nhau: chưa đỗ ông nghè đã đe hàng tổng (tng)",
    example: "chưa đỗ ông nghè đã đe hàng tổng (tng)",
  },
  {
    word: "hàng",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị số lượng nhiều nhưng không xác định, đơn vị tính là điều được nói đến: hàng đống công việc * đợi hàng tháng trời * mất hàng chục triệu",
    example: "hàng đống công việc * đợi hàng tháng trời * mất hàng chục triệu",
  },
  {
    word: "hàng",
    part_of_speech: "động từ",
    meaning:
      "chịu thua, hạ vũ khí và tự đặt mình thuộc quyền của đối phương: cởi giáp ra hàng * kéo cờ trắng xin hàng",
    example: "cởi giáp ra hàng * kéo cờ trắng xin hàng",
  },
  {
    word: "hàng",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) tự nhận là bất lực, không làm nổi: việc khó quá, xin hàng! * chuyện ấy thì tôi hàng thôi!",
    example: "việc khó quá, xin hàng! * chuyện ấy thì tôi hàng thôi!",
  },
  {
    word: "hang",
    part_of_speech: "danh từ",
    meaning:
      "khoảng trống sâu tự nhiên hay được đào vào trong đất, trong đá: hang chuột * hang hùm * hang đá",
    example: "hang chuột * hang hùm * hang đá",
  },
  {
    word: "hang",
    part_of_speech: "danh từ",
    meaning:
      "chỗ rỗng trong mô cơ thể động vật, do hiện tượng tế bào bị hoại tử tạo ra: phổi rỗng thành hang",
    example: "phổi rỗng thành hang",
  },
  {
    word: "háng",
    part_of_speech: "danh từ",
    meaning:
      "phần cơ thể ở chỗ tiếp giáp của mặt trong đùi với bụng dưới: ngồi giạng háng",
    example: "ngồi giạng háng",
  },
  {
    word: "hàng chiến lược",
    part_of_speech: "danh từ",
    meaning:
      "hàng có ý nghĩa quan trọng đặc biệt về kinh tế hoặc quân sự: cà phê là hàng chiến lược của nước ta",
    example: "cà phê là hàng chiến lược của nước ta",
  },
  {
    word: "hang cùng ngõ hẻm",
    part_of_speech: "",
    meaning:
      "nơi khuất nẻo, vắng vẻ, ít người qua lại (nói khái quát): lùng sục khắp hang cùng ngõ hẻm",
    example: "lùng sục khắp hang cùng ngõ hẻm",
  },
  {
    word: "hàng hải",
    part_of_speech: "danh từ",
    meaning: "kĩ thuật điều khiển tàu biển: kĩ sư hàng hải",
    example: "kĩ sư hàng hải",
  },
  {
    word: "hàng hải",
    part_of_speech: "danh từ",
    meaning: "vận tải đường biển: làm việc trong ngành hàng hải",
    example: "làm việc trong ngành hàng hải",
  },
  {
    word: "hàng họ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) hàng để buôn bán, kinh doanh (nói khái quát): hàng họ ế ẩm",
    example: "hàng họ ế ẩm",
  },
  {
    word: "hàng đầu",
    part_of_speech: "danh từ",
    meaning:
      "ở vị trí phía trước nhất; thường dùng để chỉ vị trí hoặc tác dụng quan trọng nhất: học tập là nhiệm vụ hàng đầu * phát triển kinh tế là vấn đề được đặt lên hàng đầu",
    example:
      "học tập là nhiệm vụ hàng đầu * phát triển kinh tế là vấn đề được đặt lên hàng đầu",
  },
  {
    word: "hang hốc",
    part_of_speech: "danh từ",
    meaning:
      "hang tự nhiên (nói khái quát): núi có nhiều hang hốc * loài rắn sống trong các hang hốc",
    example: "núi có nhiều hang hốc * loài rắn sống trong các hang hốc",
  },
  {
    word: "hàng hoá",
    part_of_speech: "danh từ",
    meaning:
      "sản phẩm do lao động làm ra được mua bán trên thị trường, nói chung: trao đổi hàng hoá * cửa hàng có đủ loại hàng hoá",
    example: "trao đổi hàng hoá * cửa hàng có đủ loại hàng hoá",
  },
  {
    word: "hàng hiệu",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng (thường là quần áo, dày dép, v.v.) chính hiệu, được sản xuất ở những hãng có tên tuổi lớn: ưa dùng hàng hiệu",
    example: "ưa dùng hàng hiệu",
  },
  {
    word: "hàng chợ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) hàng chất lượng thấp, giá tương đối rẻ (thường bày bán nhiều ở ngoài chợ): quần áo hàng chợ",
    example: "quần áo hàng chợ",
  },
  {
    word: "hang hùm",
    part_of_speech: "danh từ",
    meaning:
      "hang của hổ; dùng để ví nơi nguy hiểm: tự dưng lại chui vào hang hùm * thoát khỏi hang hùm",
    example: "tự dưng lại chui vào hang hùm * thoát khỏi hang hùm",
  },
  {
    word: "hàng khô",
    part_of_speech: "danh từ",
    meaning:
      "các thứ hàng thực phẩm khô, để được lâu ngày (như lạc, vừng, miến, hạt tiêu, v.v.), nói chung: sạp hàng khô * các hộ kinh doanh hàng khô",
    example: "sạp hàng khô * các hộ kinh doanh hàng khô",
  },
  {
    word: "hang ổ",
    part_of_speech: "danh từ",
    meaning:
      "hang của muông thú (nói khái quát); thường dùng để chỉ nơi tụ tập, ẩn náu của bọn trộm cướp, bọn người nguy hiểm: vào tận hang ổ của bọn cướp",
    example: "vào tận hang ổ của bọn cướp",
  },
  {
    word: "hàng lối",
    part_of_speech: "danh từ",
    meaning:
      "hàng đã được sắp xếp một cách có trật tự, có tổ chức (nói khái quát): trồng cây theo hàng lối * người chen chúc lộn xộn, không ra hàng lối",
    example:
      "trồng cây theo hàng lối * người chen chúc lộn xộn, không ra hàng lối",
  },
  {
    word: "hàng không",
    part_of_speech: "danh từ",
    meaning: "kĩ thuật điều khiển máy bay.",
    example: "ngành hàng không dân dụng * vận chuyển theo đường hàng không",
  },
  {
    word: "hàng ngũ",
    part_of_speech: "danh từ",
    meaning:
      "tập thể người được sắp xếp theo đội hình nhất định hoặc được tổ chức chặt chẽ: hàng ngũ chỉnh tề * được đứng trong hàng ngũ của Đảng",
    example: "hàng ngũ chỉnh tề * được đứng trong hàng ngũ của Đảng",
  },
  {
    word: "hàng quán",
    part_of_speech: "danh từ",
    meaning:
      "quán nhỏ hai bên đường (nói khái quát): hàng quán mọc lên la liệt",
    example: "hàng quán mọc lên la liệt",
  },
  {
    word: "hạng mục",
    part_of_speech: "danh từ",
    meaning:
      "công trình nhỏ, riêng lẻ, nằm trong một tổ hợp công trình lớn: toàn bộ công trình gồm năm hạng mục chính",
    example: "toàn bộ công trình gồm năm hạng mục chính",
  },
  {
    word: "hạng mục",
    part_of_speech: "danh từ",
    meaning:
      "phần, mục đã được quy định thành loại, hạng nhất định để tính toán: hạng mục kinh doanh * hạng mục thuế quan",
    example: "hạng mục kinh doanh * hạng mục thuế quan",
  },
  {
    word: "hàng mã",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) đồ có phẩm chất kém, chóng hỏng: chiếc xe hàng mã * mua làm gì cái đồ hàng mã ấy!",
    example: "chiếc xe hàng mã * mua làm gì cái đồ hàng mã ấy!",
  },
  {
    word: "hàng loạt",
    part_of_speech: "danh từ",
    meaning:
      "số lượng lớn có trong cùng một lúc: sản xuất hàng loạt * vũ khí giết người hàng loạt",
    example: "sản xuất hàng loạt * vũ khí giết người hàng loạt",
  },
  {
    word: "hạng ngạch",
    part_of_speech: "danh từ",
    meaning:
      "mức vốn đầu tư cho một công trình xây dựng, phản ánh được tầm cỡ của công trình đó.",
    example: "tiêu chuẩn hoá từng hạng ngạch cán bộ",
  },
  {
    word: "hàng rào",
    part_of_speech: "danh từ",
    meaning:
      "dãy tre, nứa, v.v. hoặc dãy cây trồng được ken dày, bao quanh một khu vực để che chắn, bảo vệ: hàng rào dây thép gai * ngôi nhà có hàng rào bao bọc",
    example: "hàng rào dây thép gai * ngôi nhà có hàng rào bao bọc",
  },
  {
    word: "hàng xách",
    part_of_speech: "danh từ",
    meaning:
      "nghề buôn bằng cách đứng giữa trao hàng để kiếm lãi, không phải bỏ vốn ra: buôn hàng xách",
    example: "buôn hàng xách",
  },
  {
    word: "hàng tiêu dùng",
    part_of_speech: "danh từ",
    meaning: "hàng dùng cho sinh hoạt, nói chung: sản xuất hàng tiêu dùng",
    example: "sản xuất hàng tiêu dùng",
  },
  {
    word: "hàng thần",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) kẻ đã hàng phục chịu làm tôi cho vua, làm quan cho một triều đình phong kiến: "Bó thân về với triều đình, Hàng thần lơ láo, phận mình ra đâu?" (TKiều)',
    example:
      'Bó thân về với triều đình, Hàng thần lơ láo, phận mình ra đâu?" (TKiều)',
  },
  {
    word: "hàng xáo",
    part_of_speech: "danh từ",
    meaning:
      "nghề chuyên đong thóc về xay giã, kiếm lãi bằng cách bán gạo và thu các sản phẩm phụ như tấm, cám: làm hàng xáo",
    example: "làm hàng xáo",
  },
  {
    word: "hàng thùng",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) đồ dùng đã cũ (thường là hàng may mặc), được nhập từ nước ngoài về theo từng kiện: quần áo hàng thùng",
    example: "quần áo hàng thùng",
  },
  {
    word: "hàng xóm",
    part_of_speech: "danh từ",
    meaning:
      "người ở cùng một xóm, trong quan hệ với nhau: bà con hàng xóm * đi vắng, nhờ hàng xóm trông nhà hộ",
    example: "bà con hàng xóm * đi vắng, nhờ hàng xóm trông nhà hộ",
  },
  {
    word: "hàng xén",
    part_of_speech: "danh từ",
    meaning:
      "hàng tạp hoá nhỏ, bán ở vỉa hè, ở chợ: gánh hàng xén * bán hàng xén",
    example: "gánh hàng xén * bán hàng xén",
  },
  {
    word: "hành chính",
    part_of_speech: "tính từ",
    meaning:
      "thuộc phạm vi chỉ đạo, quản lí việc chấp hành luật pháp, chính sách của nhà nước: khối cơ quan hành chính * làm việc theo giờ hành chính",
    example: "khối cơ quan hành chính * làm việc theo giờ hành chính",
  },
  {
    word: "hành chính",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về những công việc sự vụ, như văn thư, tổ chức, kế toán, v.v. trong cơ quan nhà nước: công tác hành chính * cán bộ hành chính",
    example: "công tác hành chính * cán bộ hành chính",
  },
  {
    word: "hành chính",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất giấy tờ, mệnh lệnh: xử phạt hành chính * biện pháp hành chính",
    example: "xử phạt hành chính * biện pháp hành chính",
  },
  {
    word: "hành dinh",
    part_of_speech: "danh từ",
    meaning:
      "dinh tướng chỉ huy đóng khi đưa quân đi đánh trận: đột nhập vào tận hành dinh của địch",
    example: "đột nhập vào tận hành dinh của địch",
  },
  {
    word: "hàng xứ",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người ở nơi khác, xa lạ, không quen biết: vợ chồng mà coi nhau như hàng xứ!",
    example: "vợ chồng mà coi nhau như hàng xứ!",
  },
  {
    word: "hành chức",
    part_of_speech: "động từ",
    meaning:
      "đảm nhận một chức năng cụ thể trong một tổ chức hoặc một hệ thống: hành chức đô đốc * từ hành chức trong câu",
    example: "hành chức đô đốc * từ hành chức trong câu",
  },
  {
    word: "hanh",
    part_of_speech: "tính từ",
    meaning:
      "(thời tiết) khô và hơi lạnh, thường làm nẻ da: nắng hanh * thời tiết hanh khô",
    example: "nắng hanh * thời tiết hanh khô",
  },
  {
    word: "hạnh",
    part_of_speech: "danh từ",
    meaning:
      'nết tốt của người phụ nữ: "Thương vì hạnh, trọng vì tài, Thúc ông thôi cũng dẹp lời phong ba." (TKiều)',
    example:
      'Thương vì hạnh, trọng vì tài, Thúc ông thôi cũng dẹp lời phong ba." (TKiều)',
  },
  {
    word: "hành binh",
    part_of_speech: "động từ",
    meaning: "(cũ) như hành quân: cuộc hành binh",
    example: "cuộc hành binh",
  },
  {
    word: "hành",
    part_of_speech: "động từ",
    meaning: "làm cho phải khổ sở: bị trời hành * cơn đau hành suốt đêm",
    example: "bị trời hành * cơn đau hành suốt đêm",
  },
  {
    word: "hành",
    part_of_speech: "động từ",
    meaning: "thực hành (nói tắt): học phải đi đôi với hành",
    example: "học phải đi đôi với hành",
  },
  {
    word: "hãnh diện",
    part_of_speech: "động từ",
    meaning:
      "cảm thấy hài lòng về điều mình cho là hơn người khác và sung sướng để lộ ra ngoài: hãnh diện với làng xóm * hãnh diện vì con cái đỗ đạt",
    example: "hãnh diện với làng xóm * hãnh diện vì con cái đỗ đạt",
  },
  {
    word: "hành đạo",
    part_of_speech: "động từ",
    meaning:
      "làm những việc thuộc bổn phận của người tu hành đối với một tôn giáo: nhà sư đi hành đạo",
    example: "nhà sư đi hành đạo",
  },
  {
    word: "hành hạ",
    part_of_speech: "động từ",
    meaning:
      "làm cho phải đau đớn, khổ sở: bị chủ hành hạ, đánh đập * cơn đói hành hạ",
    example: "bị chủ hành hạ, đánh đập * cơn đói hành hạ",
  },
  {
    word: "hành hình",
    part_of_speech: "động từ",
    meaning: "thi hành án tử hình: đem tội phạm ra hành hình",
    example: "đem tội phạm ra hành hình",
  },
  {
    word: "hành động",
    part_of_speech: "danh từ",
    meaning:
      "việc làm cụ thể của con người nhằm một mục đích nhất định: một hành động dũng cảm * biến đau thương thành hành động * Hành động xấu xa, bần tiện",
    example:
      "một hành động dũng cảm * biến đau thương thành hành động * Hành động xấu xa, bần tiện",
  },
  {
    word: "hành động",
    part_of_speech: "động từ",
    meaning:
      "làm những việc cụ thể nào đó, ít nhiều quan trọng, một cách có ý thức, có mục đích: chưa kịp hành động * cân nhắc kĩ trước khi hành động",
    example: "chưa kịp hành động * cân nhắc kĩ trước khi hành động",
  },
  {
    word: "hanh hao",
    part_of_speech: "tính từ",
    meaning: "hanh (nói khái quát): thời tiết hanh hao rất khó chịu",
    example: "thời tiết hanh hao rất khó chịu",
  },
  {
    word: "hành hung",
    part_of_speech: "động từ",
    meaning:
      "làm những điều thô bạo, xâm phạm một cách trái phép đến người khác, như đánh đập, phá phách, v.v.: can tội hành hung người thi hành công vụ * giở thói hành hung",
    example: "can tội hành hung người thi hành công vụ * giở thói hành hung",
  },
  {
    word: "hành khất",
    part_of_speech: "động từ",
    meaning: "(trang trọng) như ăn mày (ng1): người hành khất",
    example: "người hành khất",
  },
  {
    word: "hành hương",
    part_of_speech: "động từ",
    meaning:
      "(người sùng đạo) đi đến những nơi xa xôi được coi là linh thiêng, như đền, chùa, để cúng bái cho thoả sự ngưỡng vọng: các tín đồ hành hương về đất thánh",
    example: "các tín đồ hành hương về đất thánh",
  },
  {
    word: "hành lạc",
    part_of_speech: "động từ",
    meaning:
      "tiêu khiển bằng những thú vui tầm thường, không lành mạnh: cuộc hành lạc",
    example: "cuộc hành lạc",
  },
  {
    word: "hành khách",
    part_of_speech: "danh từ",
    meaning:
      "người đi lại trên các phương tiện giao thông nói chung: hành khách đang hối hả lên tàu",
    example: "hành khách đang hối hả lên tàu",
  },
  {
    word: "hành lang",
    part_of_speech: "danh từ",
    meaning:
      "lối đi chạy dài trong nhà, trước các dãy phòng: đi dọc theo hành lang * đứng ngoài hành lang nói chuyện",
    example: "đi dọc theo hành lang * đứng ngoài hành lang nói chuyện",
  },
  {
    word: "hành lang",
    part_of_speech: "danh từ",
    meaning: "lối đi có mái che để nối hai ngôi nhà lớn.",
    example: "hành lang giao thông * hành lang lưới điện",
  },
  {
    word: "hành lang pháp lí",
    part_of_speech: "danh từ",
    meaning:
      "khoảng, phạm vi xác định được pháp luật cho phép và bảo vệ: tạo một hành lang pháp lí ổn định để thu hút đầu tư",
    example: "tạo một hành lang pháp lí ổn định để thu hút đầu tư",
  },
  {
    word: "hành lí",
    part_of_speech: "danh từ",
    meaning:
      "đồ mang theo khi đi xa: chuẩn bị hành lí để đi công tác * xách hành lí",
    example: "chuẩn bị hành lí để đi công tác * xách hành lí",
  },
  {
    word: "hành lang pháp lý",
    part_of_speech: "danh từ",
    meaning:
      "khoảng, phạm vi xác định được pháp luật cho phép và bảo vệ: tạo một hành lang pháp lí ổn định để thu hút đầu tư",
    example: "tạo một hành lang pháp lí ổn định để thu hút đầu tư",
  },
  {
    word: "hạnh kiểm",
    part_of_speech: "danh từ",
    meaning:
      "phẩm chất, đạo đức của một người biểu hiện qua việc làm, qua cách đối xử với mọi người: bị xếp loại hạnh kiểm trung bình",
    example: "bị xếp loại hạnh kiểm trung bình",
  },
  {
    word: "hành lý",
    part_of_speech: "danh từ",
    meaning:
      "đồ mang theo khi đi xa: chuẩn bị hành lí để đi công tác * xách hành lí",
    example: "chuẩn bị hành lí để đi công tác * xách hành lí",
  },
  {
    word: "hành nghề",
    part_of_speech: "động từ",
    meaning:
      "làm công việc thuộc về nghề nghiệp của mình để sinh sống (chỉ nói về một số nghề nghiệp): giấy phép hành nghề * cấm hành nghề mê tín dị đoan",
    example: "giấy phép hành nghề * cấm hành nghề mê tín dị đoan",
  },
  {
    word: "hạnh nhân",
    part_of_speech: "danh từ",
    meaning:
      "mô bạch huyết ở họng người, tròn và to bằng đầu ngón tay: sưng amygdala * cắt amygdala",
    example: "sưng amygdala * cắt amygdala",
  },
  {
    word: "hạnh phúc",
    part_of_speech: "danh từ",
    meaning:
      "trạng thái sung sướng vì cảm thấy hoàn toàn đạt được ý nguyện: vì hạnh phúc của trẻ thơ * hưởng hạnh phúc * vẻ mặt tràn trề hạnh phúc",
    example:
      "vì hạnh phúc của trẻ thơ * hưởng hạnh phúc * vẻ mặt tràn trề hạnh phúc",
  },
  {
    word: "hạnh phúc",
    part_of_speech: "tính từ",
    meaning:
      "có được trạng thái sung sướng vì cảm thấy đã đạt được ý nguyện: năm tháng hạnh phúc * hai người sống rất hạnh phúc",
    example: "năm tháng hạnh phúc * hai người sống rất hạnh phúc",
  },
  {
    word: "hành quân",
    part_of_speech: "động từ",
    meaning:
      "(đơn vị quân đội) di chuyển từ nơi này đến nơi khác theo đội hình và mục đích nhất định: hành quân ra mặt trận",
    example: "hành quân ra mặt trận",
  },
  {
    word: "hành pháp",
    part_of_speech: "động từ",
    meaning:
      "(cơ quan chức năng) thi hành pháp luật, trong quan hệ với lập pháp: cơ quan hành pháp",
    example: "cơ quan hành pháp",
  },
  {
    word: "hanh thông",
    part_of_speech: "tính từ",
    meaning: "(cũ) thuận lợi và may mắn: tài vận hanh thông",
    example: "tài vận hanh thông",
  },
  {
    word: "hành tá tràng",
    part_of_speech: "danh từ",
    meaning:
      "phần phình to ở nơi ruột non tiếp sau dạ dày, có hình giống như củ hành: bị loét hành tá tràng",
    example: "bị loét hành tá tràng",
  },
  {
    word: "hãnh tiến",
    part_of_speech: "tính từ",
    meaning:
      "(người) đột nhiên chỉ nhờ may mắn mà có được địa vị cao hoặc trở nên giàu có chứ không phải bằng tài năng và thực lực của mình (hàm ý chê): những kẻ hãnh tiến",
    example: "những kẻ hãnh tiến",
  },
  {
    word: "hành tinh",
    part_of_speech: "danh từ",
    meaning:
      "thiên thể không tự phát ra ánh sáng, quay xung quanh Mặt Trời hoặc một ngôi sao: Trái Đất là một hành tinh nằm trong Hệ Mặt Trời",
    example: "Trái Đất là một hành tinh nằm trong Hệ Mặt Trời",
  },
  {
    word: "hành tung",
    part_of_speech: "danh từ",
    meaning:
      "dấu vết về những hành vi của một người nào đó: che giấu hành tung * để lộ hành tung",
    example: "che giấu hành tung * để lộ hành tung",
  },
  {
    word: "hành trình",
    part_of_speech: "danh từ",
    meaning: "chuyến đi xa và dài ngày: cuộc hành trình trên biển",
    example: "cuộc hành trình trên biển",
  },
  {
    word: "hành trang",
    part_of_speech: "danh từ",
    meaning: "(trang trọng) như hành lí: thu xếp hành trang lên đường",
    example: "thu xếp hành trang lên đường",
  },
  {
    word: "hành tinh nhân tạo",
    part_of_speech: "danh từ",
    meaning:
      "vật thể do con người chế tạo, được phóng lên với tốc độ cao để thoát khỏi sức hút của Trái Đất, trở thành như một hành tinh chuyển động xung quanh Mặt Trời: phóng thành công hành tinh nhân tạo vào Hệ Mặt Trời",
    example: "phóng thành công hành tinh nhân tạo vào Hệ Mặt Trời",
  },
  {
    word: "hành tội",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) như hành hạ: hành tội vợ con",
    example: "hành tội vợ con",
  },
  {
    word: "hành tội",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) có quan hệ yêu đương bất chính (nói về người đã có gia đình): giám đốc lòng thòng với cô thư kí",
    example: "giám đốc lòng thòng với cô thư kí",
  },
  {
    word: "hành xác",
    part_of_speech: "động từ",
    meaning:
      "tự hành hạ thân xác, sống khổ hạnh, theo phép tu hành của một số dòng đạo: nhịn ăn nhịn uống để hành xác",
    example: "nhịn ăn nhịn uống để hành xác",
  },
  {
    word: "hành vi",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ những phản ứng, cách cư xử biểu hiện ra ngoài của một người trong một hoàn cảnh cụ thể: hành vi lừa đảo * một hành vi khó hiểu",
    example: "hành vi lừa đảo * một hành vi khó hiểu",
  },
  {
    word: "hào",
    part_of_speech: "danh từ",
    meaning:
      "rãnh rộng và sâu dùng làm vật chướng ngại, công sự chiến đấu, hoặc để đi lại, vận chuyển được an toàn: đào hào * thành cao hào sâu",
    example: "đào hào * thành cao hào sâu",
  },
  {
    word: "hào",
    part_of_speech: "tính từ",
    meaning:
      '(Từ cũ, Văn chương) tài giỏi hơn người: "Học trò đèn sách hôm mai, Ngày sau thi đỗ nên trai mới hào." (Cdao)',
    example:
      'Học trò đèn sách hôm mai, Ngày sau thi đỗ nên trai mới hào." (Cdao)',
  },
  {
    word: "hảo",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) ưa thích và muốn được ăn một món ăn nào đó: anh ấy hảo món canh chua * tính hảo ngọt",
    example: "anh ấy hảo món canh chua * tính hảo ngọt",
  },
  {
    word: "hảo",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) ưa thích và muốn được ăn một món ăn nào đó: anh ấy hảo món canh chua * tính hảo ngọt",
    example: "anh ấy hảo món canh chua * tính hảo ngọt",
  },
  {
    word: "hành văn",
    part_of_speech: "",
    meaning: "viết văn, về mặt đặt câu, dùng từ: lối hành văn mộc mạc",
    example: "lối hành văn mộc mạc",
  },
  {
    word: "hão",
    part_of_speech: "tính từ",
    meaning:
      "không được việc gì cả vì không thiết thực, không có cơ sở thực tế: sĩ diện hão * hứa hão",
    example: "sĩ diện hão * hứa hão",
  },
  {
    word: "hào chiến đấu",
    part_of_speech: "danh từ",
    meaning: "hào để ẩn nấp, che chắn khi tác chiến: đào chiến hào",
    example: "đào chiến hào",
  },
  {
    word: "hào chỉ",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, khẩu ngữ) đồng hào (dùng với hàm ý là ít ỏi): "Hai người vừa đi đường vừa gắt gỏng nhau về nỗi hiện nay chỉ còn vẻn vẹn có sáu hào chỉ." (NgCHoan; 4)',
    example:
      'Hai người vừa đi đường vừa gắt gỏng nhau về nỗi hiện nay chỉ còn vẻn vẹn có sáu hào chỉ." (NgCHoan; 4)',
  },
  {
    word: "háo danh",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có tư tưởng ham danh vọng, tiếng tăm: giễu cợt thói háo danh",
    example: "giễu cợt thói háo danh",
  },
  {
    word: "hao",
    part_of_speech: "động từ",
    meaning:
      "bị giảm mất đi một phần về số lượng, do một nguyên nhân nào đó: dầu bị hao nhiều do bay hơi * cân hao",
    example: "dầu bị hao nhiều do bay hơi * cân hao",
  },
  {
    word: "hao",
    part_of_speech: "động từ",
    meaning:
      "tốn nhiều hơn so với mức bình thường, mức cần thiết: hao người tốn của * mạ nhỏ nên cấy rất hao",
    example: "hao người tốn của * mạ nhỏ nên cấy rất hao",
  },
  {
    word: "hảo hạng",
    part_of_speech: "tính từ",
    meaning:
      "(loại hàng) thuộc hạng rất tốt: cà phê hảo hạng * nước mắm hảo hạng",
    example: "cà phê hảo hạng * nước mắm hảo hạng",
  },
  {
    word: "háo",
    part_of_speech: "động từ",
    meaning:
      "ham, thích đến mức như không còn nghĩ gì khác (thường hàm ý chê): háo của * háo sắc",
    example: "háo của * háo sắc",
  },
  {
    word: "háo",
    part_of_speech: "tính từ",
    meaning:
      "có cảm giác trong người khô khan, cơ thể thiếu nước, thèm, muốn ăn uống các chất tươi mát: háo nước * sau cơn sốt, người rất háo",
    example: "háo nước * sau cơn sốt, người rất háo",
  },
  {
    word: "hao hao",
    part_of_speech: "tính từ",
    meaning:
      "có những nét bên ngoài phảng phất giống nhau: trông hao hao giống một tài tử điện ảnh",
    example: "trông hao hao giống một tài tử điện ảnh",
  },
  {
    word: "hảo hán",
    part_of_speech: "danh từ",
    meaning:
      "(Từ cũ) người đàn ông dũng cảm, sẵn sàng ra tay can thiệp bênh vực người yếu trong xã hội cũ: một trang hảo hán",
    example: "một trang hảo hán",
  },
  {
    word: "hào hển",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) hổn hển: thở hào hển",
    example: "thở hào hển",
  },
  {
    word: "hào hoa",
    part_of_speech: "tính từ",
    meaning:
      'rộng rãi và lịch sự trong cách cư xử, giao thiệp: chàng công tử hào hoa * "Phong tư tài mạo tót vời, Vào trong thanh nhã, ra ngoài hào hoa." (TKiều)',
    example:
      'chàng công tử hào hoa * "Phong tư tài mạo tót vời, Vào trong thanh nhã, ra ngoài hào hoa." (TKiều)',
  },
  {
    word: "hào hiệp",
    part_of_speech: "tính từ",
    meaning:
      "có tinh thần cao thượng, rộng rãi, hết lòng vì người khác, không tính toán thiệt hơn: cử chỉ hào hiệp * tấm lòng hào hiệp",
    example: "cử chỉ hào hiệp * tấm lòng hào hiệp",
  },
  {
    word: "hào hùng",
    part_of_speech: "tính từ",
    meaning:
      "có khí thế mạnh mẽ và sôi nổi: lời văn hào hùng * khí phách hào hùng của dân tộc",
    example: "lời văn hào hùng * khí phách hào hùng của dân tộc",
  },
  {
    word: "hao hớt",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) hao dần đi, so với lúc đầu: thóc bị hao hớt do rơi vãi",
    example: "thóc bị hao hớt do rơi vãi",
  },
  {
    word: "hao hụt",
    part_of_speech: "động từ",
    meaning:
      "bị thiếu đi, mất đi một phần (nói khái quát): quân số hao hụt * ngân sách hao hụt do khủng hoảng kinh tế",
    example: "quân số hao hụt * ngân sách hao hụt do khủng hoảng kinh tế",
  },
  {
    word: "hão huyền",
    part_of_speech: "tính từ",
    meaning:
      "hoàn toàn không có cơ sở thực tế, không thể có thật hoặc không thể thành sự thật: mơ mộng hão huyền * một hi vọng quá hão huyền",
    example: "mơ mộng hão huyền * một hi vọng quá hão huyền",
  },
  {
    word: "hào hứng",
    part_of_speech: "",
    meaning:
      "tỏ ra phấn khởi, hăng hái vì cảm thấy ham thích: hào hứng kể chuyện * không hào hứng đón nhận",
    example: "hào hứng kể chuyện * không hào hứng đón nhận",
  },
  {
    word: "hao kiệt",
    part_of_speech: "động từ",
    meaning:
      "bị tiêu hao nhiều đến mức như cạn kiệt: hao kiệt sức lực * nguồn tài nguyên bị hao kiệt",
    example: "hao kiệt sức lực * nguồn tài nguyên bị hao kiệt",
  },
  {
    word: "hào khí",
    part_of_speech: "danh từ",
    meaning: "(Trang trọng) chí khí mạnh mẽ, hào hùng: hào khí đấu tranh",
    example: "hào khí đấu tranh",
  },
  {
    word: "háo hức",
    part_of_speech: "tính từ",
    meaning:
      "phấn chấn nghĩ đến và nóng lòng chờ đợi một điều hay, điều vui biết là sắp tới: háo hức chờ đợi * háo hức đi xem hội",
    example: "háo hức chờ đợi * háo hức đi xem hội",
  },
  {
    word: "hào kiệt",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) người có tài cao, chí lớn, hơn hẳn người thường: "Chàng tuổi trẻ vốn dòng hào kiệt, Xếp bút nghiên theo việc đao cung." (CPN)',
    example:
      'Chàng tuổi trẻ vốn dòng hào kiệt, Xếp bút nghiên theo việc đao cung." (CPN)',
  },
  {
    word: "háo nước",
    part_of_speech: "tính từ",
    meaning: "có đặc tính dễ bị nước làm ướt: những chất háo nước",
    example: "những chất háo nước",
  },
  {
    word: "hao mòn",
    part_of_speech: "động từ",
    meaning:
      'bị giảm sút dần từng ít một về chất lượng, giá trị ban đầu trong quá trình hoạt động, sử dụng: hao mòn máy móc * tinh lực hao mòn * "Ruột tằm, ngày một héo hon, Tuyết sương ngày một hao mòn hình ve." (TKiều)',
    example:
      'hao mòn máy móc * tinh lực hao mòn * "Ruột tằm, ngày một héo hon, Tuyết sương ngày một hao mòn hình ve." (TKiều)',
  },
  {
    word: "hào lí",
    part_of_speech: "danh từ",
    meaning:
      "(Từ cũ) kẻ có quyền thế, có chức vị ở trong làng xã thời phong kiến, như cường hào, lí dịch (nói khái quát): bọn hào lí trong làng",
    example: "bọn hào lí trong làng",
  },
  {
    word: "hào sảng",
    part_of_speech: "tính từ",
    meaning: "thanh thoát, rộng rãi, không gò bó: lời văn hào sảng",
    example: "lời văn hào sảng",
  },
  {
    word: "hào phóng",
    part_of_speech: "tính từ",
    meaning:
      "rộng rãi trong chi tiêu, trong quan hệ đối xử với mọi người: tính hào phóng * rất hào phóng với bạn bè",
    example: "tính hào phóng * rất hào phóng với bạn bè",
  },
  {
    word: "hào phú",
    part_of_speech: "",
    meaning: "(cũ) giàu có và có thế lực: nhà hào phú",
    example: "nhà hào phú",
  },
  {
    word: "hao sút",
    part_of_speech: "tính từ",
    meaning:
      "(cơ thể) bị sút đi trông thấy: ốm lâu ngày, người hao sút trông thấy",
    example: "ốm lâu ngày, người hao sút trông thấy",
  },
  {
    word: "hao phí",
    part_of_speech: "động từ",
    meaning:
      "dùng mất nhiều một cách không cần thiết: hao phí nguyên liệu * hao phí thời gian và sức lực một cách vô ích",
    example:
      "hao phí nguyên liệu * hao phí thời gian và sức lực một cách vô ích",
  },
  {
    word: "hao phí",
    part_of_speech: "danh từ",
    meaning:
      "lượng sức lực bỏ ra trong một quá trình hoạt động sản xuất nào đó: hao phí lao động ít nhưng kết quả thu được lại cao",
    example: "hao phí lao động ít nhưng kết quả thu được lại cao",
  },
  {
    word: "hào nhoáng",
    part_of_speech: "tính từ",
    meaning:
      "có vẻ đẹp bóng bẩy bề ngoài, thường mang tính chất phô trương: nước sơn hào nhoáng * lời lẽ khoa trương, hào nhoáng",
    example: "nước sơn hào nhoáng * lời lẽ khoa trương, hào nhoáng",
  },
  {
    word: "hào quang",
    part_of_speech: "danh từ",
    meaning: "ánh sáng rực rỡ, chiếu toả ra xung quanh: ánh hào quang",
    example: "ánh hào quang",
  },
  {
    word: "háo sắc",
    part_of_speech: "tính từ",
    meaning: "có tính ham mê gái đẹp: kẻ háo sắc",
    example: "kẻ háo sắc",
  },
  {
    word: "hảo tâm",
    part_of_speech: "danh từ",
    meaning: "lòng tốt: người có hảo tâm",
    example: "người có hảo tâm",
  },
  {
    word: "hảo tâm",
    part_of_speech: "tính từ",
    meaning:
      "có lòng tốt, sẵn sàng giúp đỡ người khác về tiền của: con người hảo tâm",
    example: "con người hảo tâm",
  },
  {
    word: "háp",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) như táp: cây bị háp nắng",
    example: "cây bị háp nắng",
  },
  {
    word: "hào trưởng",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người có quyền lực lớn nhất trong một địa phương ở nông thôn thời phong kiến: con nhà hào trưởng",
    example: "con nhà hào trưởng",
  },
  {
    word: "hát",
    part_of_speech: "động từ",
    meaning:
      "(miệng) phát ra âm thanh theo những giai điệu, nhịp điệu nhất định để biểu hiện tư tưởng tình cảm: cất tiếng hát * ngồi buồn hát nghêu ngao",
    example: "cất tiếng hát * ngồi buồn hát nghêu ngao",
  },
  {
    word: "hạt",
    part_of_speech: "danh từ",
    meaning:
      "(Nam hột) bộ phận nằm trong quả, do noãn cầu của bầu hoa biến thành, nảy mầm thì cho cây con: hạt bí * hạt cải * gieo hạt đỗ",
    example: "hạt bí * hạt cải * gieo hạt đỗ",
  },
  {
    word: "hạt",
    part_of_speech: "danh từ",
    meaning: "(Nam hột) quả khô của một số cây lương thực: hạt lúa * hạt ngô",
    example: "hạt lúa * hạt ngô",
  },
  {
    word: "hạt",
    part_of_speech: "danh từ",
    meaning:
      "(Nam hột) vật có hình giống như hạt gạo, hạt ngô: hạt ngọc trai * hạt sạn * bị hạt bụi bay vào mắt",
    example: "hạt ngọc trai * hạt sạn * bị hạt bụi bay vào mắt",
  },
  {
    word: "hạt",
    part_of_speech: "danh từ",
    meaning:
      "lượng nhỏ chất lỏng có hình giống như hạt gạo, hạt ngô: hạt sương * hạt mưa",
    example: "hạt sương * hạt mưa",
  },
  {
    word: "hạt",
    part_of_speech: "danh từ",
    meaning: "(Từ cũ) đơn vị hành chính thời trước, lớn hơn phủ, huyện.",
    example: "hạt kiểm lâm",
  },
  {
    word: "hao tổn",
    part_of_speech: "động từ",
    meaning:
      "dùng mất quá nhiều vào một việc gì một cách đáng tiếc: hao tổn tiền của * hao tổn sức lực",
    example: "hao tổn tiền của * hao tổn sức lực",
  },
  {
    word: "hạt cơ bản",
    part_of_speech: "danh từ",
    meaning:
      "phần tử vật chất cực nhỏ, bé hơn hạt nhân nguyên tử, mà với kiến thức hiện thời người ta chưa biết đến cấu trúc bên trong: electron, proton, neutron, v.v. được coi là những hạt cơ bản",
    example: "electron, proton, neutron, v.v. được coi là những hạt cơ bản",
  },
  {
    word: "hát bội",
    part_of_speech: "danh từ",
    meaning:
      "(cũng hát bội) kịch hát dân tộc cổ truyền, mang tính chất tượng trưng và ước lệ, lời viết theo các thể văn vần cổ, thường chuyên về đề tài lịch sử: vở tuồng * hát tuồng * đi xem tuồng",
    example: "vở tuồng * hát tuồng * đi xem tuồng",
  },
  {
    word: "hát bội",
    part_of_speech: "danh từ",
    meaning:
      'hạng người cùng có một đặc điểm chung nào đó (hàm ý coi thường): tuồng ô hợp * "Bởi vì cha mẹ không thương, Cố lòng ép uổng lấy tuồng vũ phu." (ca dao)',
    example:
      'tuồng ô hợp * "Bởi vì cha mẹ không thương, Cố lòng ép uổng lấy tuồng vũ phu.',
  },
  {
    word: "hát bội",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) vẻ bề ngoài: xem tuồng mọi việc đã ổn",
    example: "xem tuồng mọi việc đã ổn",
  },
  {
    word: "hát dạo",
    part_of_speech: "động từ",
    meaning:
      "hát một đoạn ngắn để ướm thử hay tự giới thiệu mình, hoặc để tạo không khí trước khi biểu diễn chính thức.",
    example: "gánh hát dạo",
  },
  {
    word: "hát hỏng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) như hát hò (thường hàm ý chê): không chịu làm việc, cứ hát hỏng cả ngày",
    example: "không chịu làm việc, cứ hát hỏng cả ngày",
  },
  {
    word: "hạt dẻ",
    part_of_speech: "danh từ",
    meaning:
      "màu nâu sẫm, giống như màu vỏ của hạt dẻ: mắt màu hạt dẻ * nhuộm tóc màu hạt dẻ",
    example: "mắt màu hạt dẻ * nhuộm tóc màu hạt dẻ",
  },
  {
    word: "hạt kín",
    part_of_speech: "danh từ",
    meaning:
      "ngành thực vật bậc cao, gồm những cây có hạt nằm kín trong quả, có hoa, thân, rễ phát triển đa dạng; phân biệt với hạt trần: cây đậu, cây cam là những cây hạt kín",
    example: "cây đậu, cây cam là những cây hạt kín",
  },
  {
    word: "hát hò",
    part_of_speech: "động từ",
    meaning: "hát (nói khái quát): không biết hát hò gì",
    example: "không biết hát hò gì",
  },
  {
    word: "hạt giống",
    part_of_speech: "danh từ",
    meaning:
      "hạt dùng để gây giống; còn dùng để ví người còn trẻ có rất nhiều triển vọng, hoặc đang được đào tạo, bồi dưỡng cho tương lai: cây vợt hạt giống * chọn các đội hạt giống để chia bảng thi đấu",
    example: "cây vợt hạt giống * chọn các đội hạt giống để chia bảng thi đấu",
  },
  {
    word: "hạt nhân",
    part_of_speech: "danh từ",
    meaning:
      "phần trung tâm của nguyên tử, nơi tập trung hầu hết khối lượng của nguyên tử đó, mang điện tích dương.",
    example: "hạt nhân của phong trào * gia đình là hạt nhân của xã hội",
  },
  {
    word: "hát nói",
    part_of_speech: "danh từ",
    meaning: "thể ca trù khi biểu diễn kết hợp cả ngâm, hát và nói.",
    example: "đọc bài hát nói",
  },
  {
    word: "hạt trần",
    part_of_speech: "danh từ",
    meaning:
      "ngành thực vật gồm những cây có hạt lộ trần ra ngoài, không nằm kín trong quả, sinh sản bằng hạt, chưa có hoa và quả; phân biệt với hạt kín: cây thông, cây tuế là những cây hạt trần",
    example: "cây thông, cây tuế là những cây hạt trần",
  },
  {
    word: "hát tuồng",
    part_of_speech: "danh từ",
    meaning:
      "(cũng hát bội) kịch hát dân tộc cổ truyền, mang tính chất tượng trưng và ước lệ, lời viết theo các thể văn vần cổ, thường chuyên về đề tài lịch sử: vở tuồng * hát tuồng * đi xem tuồng",
    example: "vở tuồng * hát tuồng * đi xem tuồng",
  },
  {
    word: "hát tuồng",
    part_of_speech: "danh từ",
    meaning:
      'hạng người cùng có một đặc điểm chung nào đó (hàm ý coi thường): tuồng ô hợp * "Bởi vì cha mẹ không thương, Cố lòng ép uổng lấy tuồng vũ phu." (ca dao)',
    example:
      'tuồng ô hợp * "Bởi vì cha mẹ không thương, Cố lòng ép uổng lấy tuồng vũ phu.',
  },
  {
    word: "hát tuồng",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) vẻ bề ngoài: xem tuồng mọi việc đã ổn",
    example: "xem tuồng mọi việc đã ổn",
  },
  {
    word: "hát ru",
    part_of_speech: "danh từ",
    meaning:
      "điệu hát dân gian êm ái, thiết tha, ru cho trẻ ngủ, đồng thời biểu lộ tình cảm, tâm sự một cách nhẹ nhàng: khúc hát ru",
    example: "khúc hát ru",
  },
  {
    word: "hát rong",
    part_of_speech: "động từ",
    meaning: "đi hát nơi này nơi khác để xin tiền kiếm sống: đám hát rong",
    example: "đám hát rong",
  },
  {
    word: "hát văn",
    part_of_speech: "danh từ",
    meaning:
      "lối hát cổ truyền, có làn điệu phong phú, dùng để ca tụng thần thánh trong khi cúng bái, lên đồng: hát chầu văn * điệu chầu văn",
    example: "hát chầu văn * điệu chầu văn",
  },
  {
    word: "hát văn",
    part_of_speech: "động từ",
    meaning:
      "hát có đàn hoà theo, để ca tụng thần thánh khi cúng bái, lên đồng, theo lối hát cổ truyền: xem chầu văn trong phủ thánh",
    example: "xem chầu văn trong phủ thánh",
  },
  {
    word: "hau háu",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả vẻ nhìn tập trung, không chớp, tỏ rõ sự thèm muốn: bọn trẻ hau háu nhìn vào mâm cỗ * cặp mắt hau háu",
    example: "bọn trẻ hau háu nhìn vào mâm cỗ * cặp mắt hau háu",
  },
  {
    word: "hattrick",
    part_of_speech: "danh từ",
    meaning:
      "ba điểm, ba bàn thắng, v.v. được ghi bởi cùng một cầu thủ trong một trận đấu thể thao hoặc trò chơi: lập hattrick",
    example: "lập hattrick",
  },
  {
    word: "hát xướng",
    part_of_speech: "động từ",
    meaning: "(cũ) ca hát: theo nghề hát xướng",
    example: "theo nghề hát xướng",
  },
  {
    word: "háu",
    part_of_speech: "động từ",
    meaning:
      "thích đến mức luôn luôn lộ vẻ nôn nóng, muốn đòi hỏi được đáp ứng ngay, không tự kiềm chế được (hàm ý chê): háu ăn * con thú háu mồi * ngựa non háu đá (tng)",
    example: "háu ăn * con thú háu mồi * ngựa non háu đá (tng)",
  },
  {
    word: "hay",
    part_of_speech: "động từ",
    meaning:
      'biết là có điều nào đó đã xảy ra: hay tin * "Trông ra ngọn cỏ lá cây, Thấy hiu hiu gió thì hay chị về." (TKiều)',
    example:
      'hay tin * "Trông ra ngọn cỏ lá cây, Thấy hiu hiu gió thì hay chị về." (TKiều)',
  },
  {
    word: "hay",
    part_of_speech: "động từ",
    meaning:
      "tính liệu cách xử lí (nói về việc trong tương lai): chuyện đó để sau hẵng hay",
    example: "chuyện đó để sau hẵng hay",
  },
  {
    word: "hay",
    part_of_speech: "tính từ",
    meaning:
      "được đánh giá là có tác dụng gây được hứng thú hoặc cảm xúc tốt đẹp, dễ chịu: hát rất hay * bộ phim hay * văn hay chữ tốt * lời hay ý đẹp * nói hay lắm!",
    example:
      "hát rất hay * bộ phim hay * văn hay chữ tốt * lời hay ý đẹp * nói hay lắm!",
  },
  {
    word: "hay",
    part_of_speech: "tính từ",
    meaning:
      "được đánh giá cao, là đạt yêu cầu, có tác dụng mang lại hiệu quả như mong muốn: ngựa hay * một sáng kiến hay * vị thuốc hay",
    example: "ngựa hay * một sáng kiến hay * vị thuốc hay",
  },
  {
    word: "hay",
    part_of_speech: "tính từ",
    meaning:
      "có tác dụng đem lại sự tốt lành: nói điều hay, làm việc tốt * lời hay lẽ phải * gặp chuyện không hay",
    example:
      "nói điều hay, làm việc tốt * lời hay lẽ phải * gặp chuyện không hay",
  },
  {
    word: "hay",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) có dáng vẻ dễ ưa, gây được thiện cảm hoặc sự thích thú: cô bé có đôi mắt nhìn rất hay",
    example: "cô bé có đôi mắt nhìn rất hay",
  },
  {
    word: "hay",
    part_of_speech: "phụ từ",
    meaning:
      "một cách thường xuyên: hay về quê * hay đi chơi * hay đọc sách khuya",
    example: "hay về quê * hay đi chơi * hay đọc sách khuya",
  },
  {
    word: "hay",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị quan hệ tuyển chọn giữa hai điều được nói đến, có điều này thì không có điều kia, và ngược lại: không biết nên đi hay ở * em còn nhớ hay em đã quên? * có biết hay không?",
    example:
      "không biết nên đi hay ở * em còn nhớ hay em đã quên? * có biết hay không?",
  },
  {
    word: "hãy",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị sự tiếp diễn của một trạng thái, chưa có sự biến đổi, chưa chuyển sang trạng thái khác: mới đi xa về, người hãy còn mệt * trời hãy còn mưa",
    example: "mới đi xa về, người hãy còn mệt * trời hãy còn mưa",
  },
  {
    word: "hãy",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị tính chất tạm thời của một việc làm trong khi chưa có gì khác, chưa có gì thay đổi: thì hãy biết như thế đã * hãy cứ nghỉ đi đã",
    example: "thì hãy biết như thế đã * hãy cứ nghỉ đi đã",
  },
  {
    word: "hãy",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị ý yêu cầu có tính chất mệnh lệnh hoặc thuyết phục, động viên nên làm việc gì đó, nên có thái độ nào đó: hãy đợi đấy! * hãy bình tĩnh lại * ăn cơm xong hãy về",
    example: "hãy đợi đấy! * hãy bình tĩnh lại * ăn cơm xong hãy về",
  },
  {
    word: "háu đói",
    part_of_speech: "động từ",
    meaning:
      "có tính không chịu được đói, hễ đói là lộ vẻ nôn nóng muốn được ăn ngay: đứa trẻ háu đói",
    example: "đứa trẻ háu đói",
  },
  {
    word: "háy",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) đưa mắt nhìn nghiêng và nháy khẽ một cái để tỏ ý gì đó: con bé háy ba nó một cái rồi chạy mất",
    example: "con bé háy ba nó một cái rồi chạy mất",
  },
  {
    word: "hay biết",
    part_of_speech: "động từ",
    meaning: "biết là có điều nào đó đã xảy ra: không ai hay biết gì",
    example: "không ai hay biết gì",
  },
  {
    word: "hay hay",
    part_of_speech: "tính từ",
    meaning:
      "có vẻ là lạ và dễ ưa, gây được thiện cảm hoặc sự hứng thú: đứa bé bụ bẫm trông hay hay",
    example: "đứa bé bụ bẫm trông hay hay",
  },
  {
    word: "hay chữ",
    part_of_speech: "tính từ",
    meaning:
      'giỏi về văn chương, chữ nghĩa: "Muốn sang thì bắc cầu kiều, Muốn con hay chữ thì yêu lấy thầy." (ca dao)',
    example:
      'Muốn sang thì bắc cầu kiều, Muốn con hay chữ thì yêu lấy thầy." (ca dao)',
  },
  {
    word: "hay ho",
    part_of_speech: "tính từ",
    meaning:
      "hay (nói khái quát; thường dùng với hàm ý phủ định, mỉa mai): chẳng có gì là hay ho cả!",
    example: "chẳng có gì là hay ho cả!",
  },
  {
    word: "hắc ín",
    part_of_speech: "danh từ",
    meaning:
      "chất lỏng sánh, màu đen, là sản phẩm phụ khi chưng cất than đá hoặc dầu mỏ, thường dùng để quét làm lớp chống ẩm, rải đường, chống mối, mọt, v.v.: tường quét hắc ín đen bóng",
    example: "tường quét hắc ín đen bóng",
  },
  {
    word: "hay hớm",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) như hay ho (nhưng nhấn mạnh ý phủ định, mỉa mai): hay hớm gì mà kể!",
    example: "hay hớm gì mà kể!",
  },
  {
    word: "hắc ám",
    part_of_speech: "tính từ",
    meaning:
      "đen tối (thường dùng với nghĩa bóng): thời kì hắc ám * âm mưu hắc ám",
    example: "thời kì hắc ám * âm mưu hắc ám",
  },
  {
    word: "hắc búa",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ, hiếm) như hóc búa: bài toán hắc búa",
    example: "bài toán hắc búa",
  },
  {
    word: "hay là",
    part_of_speech: "kết từ",
    meaning: "như hay: chọn cái này hay là cái kia? * đi hay là ở",
    example: "chọn cái này hay là cái kia? * đi hay là ở",
  },
  {
    word: "hay là",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là một khả năng mà người nói thấy chưa thể khẳng định, đang còn hồ nghi: không thấy nó đến lớp, hay là nó bị ốm?",
    example: "không thấy nó đến lớp, hay là nó bị ốm?",
  },
  {
    word: "hay là",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là một giải pháp người nói thấy là nên thực hiện, nhưng không khẳng định mà muốn được biết ý kiến của người đối thoại: hay là để mai hẵng đi? * việc khó quá, hay là ta không nhận nữa",
    example: "hay là để mai hẵng đi? * việc khó quá, hay là ta không nhận nữa",
  },
  {
    word: "hắc",
    part_of_speech: "tính từ",
    meaning:
      "có mùi xông mạnh lên mũi, gây cảm giác khó chịu: mùi dầu xoa thơm hắc",
    example: "mùi dầu xoa thơm hắc",
  },
  {
    word: "hắc",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) tỏ ra nghiêm, đến mức có thể cứng nhắc trong việc giữ nguyên tắc, làm người dưới quyền phải nể sợ một cách khó chịu: ông ấy hắc lắm!",
    example: "ông ấy hắc lắm!",
  },
  {
    word: "hắc",
    part_of_speech: "tính từ",
    meaning: "có vẻ oai: mặc bộ quân phục vào trông cũng hắc ra trò",
    example: "mặc bộ quân phục vào trông cũng hắc ra trò",
  },
  {
    word: "hẳm",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) hõm sâu xuống: vực hẳm",
    example: "vực hẳm",
  },
  {
    word: "hăm",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) hai mươi: hăm mấy tuổi rồi? * một trăm hăm bốn (một trăm hai mươi bốn)",
    example: "hăm mấy tuổi rồi? * một trăm hăm bốn (một trăm hai mươi bốn)",
  },
  {
    word: "hăm",
    part_of_speech: "động từ",
    meaning: "(Phương ngữ) đe, doạ: hăm giết người",
    example: "hăm giết người",
  },
  {
    word: "hăm",
    part_of_speech: "tính từ",
    meaning:
      "(chỗ mặt da bị gấp nếp trên cơ thể trẻ em, như bẹn, cổ) ở trạng thái tấy đỏ vì bẩn: bôi phấn rôm cho bé để chống hăm",
    example: "bôi phấn rôm cho bé để chống hăm",
  },
  {
    word: "hắc xì dầu",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) nghiêm khắc đến mức khắt khe, tỏ ra oai (hàm ý đùa, hài hước): tay trưởng phòng hắc xì dầu lắm",
    example: "tay trưởng phòng hắc xì dầu lắm",
  },
  {
    word: "hặm hụi",
    part_of_speech: "",
    meaning: "(hiếm) như cặm cụi: hặm hụi mãi không chữa được cái xe",
    example: "hặm hụi mãi không chữa được cái xe",
  },
  {
    word: "hăm he",
    part_of_speech: "động từ",
    meaning:
      "doạ dẫm cho người ta sợ mà phải nghe theo, làm theo: giở giọng hăm he",
    example: "giở giọng hăm he",
  },
  {
    word: "hăm he",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) như lăm le: hăm he gây chuyện",
    example: "hăm he gây chuyện",
  },
  {
    word: "hăm doạ",
    part_of_speech: "động từ",
    meaning:
      "doạ sẽ gây tai hoạ nếu không chịu nghe theo, làm theo (nói khái quát): giơ nắm đấm hăm doạ",
    example: "giơ nắm đấm hăm doạ",
  },
  {
    word: "hăm hở",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra hăng hái, phấn khích tham gia vào một công việc chung nào đó với tất cả lòng nhiệt tình: hăm hở bắt tay vào công việc * hăm hở lên đường",
    example: "hăm hở bắt tay vào công việc * hăm hở lên đường",
  },
  {
    word: "hắn",
    part_of_speech: "đại từ",
    meaning:
      "(khẩu ngữ) từ dùng để chỉ người ở ngôi thứ ba, với hàm ý coi thường hoặc thân mật: tôi đến nhưng hắn đã đi rồi",
    example: "tôi đến nhưng hắn đã đi rồi",
  },
  {
    word: "hằm hừ",
    part_of_speech: "động từ",
    meaning: "(phương ngữ, cũ) như hầm hè: hai gã đàn ông hằm hừ nhìn nhau",
    example: "hai gã đàn ông hằm hừ nhìn nhau",
  },
  {
    word: "hẳn",
    part_of_speech: "tính từ",
    meaning:
      "chắc chắn là như vậy, không có gì phải nghi ngờ: việc này không hẳn là thế * điều đó thì đã hẳn",
    example: "việc này không hẳn là thế * điều đó thì đã hẳn",
  },
  {
    word: "hẳn",
    part_of_speech: "tính từ",
    meaning:
      'hoàn toàn, dứt khoát, không còn ở trạng thái nửa nọ, nửa kia: bệnh chưa khỏi hẳn * con tàu đã bị chìm hẳn * "Trời bắt đầu tối, rồi tối hẳn. Sương mù xuống trắng xoá." (NgKhải; 21)',
    example:
      'bệnh chưa khỏi hẳn * con tàu đã bị chìm hẳn * "Trời bắt đầu tối, rồi tối hẳn. Sương mù xuống trắng xoá." (NgKhải; 21)',
  },
  {
    word: "hẳn",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị ý chỉ mức độ trọn vẹn, không phải chỉ một phần nào mà thôi: thuê hẳn một chiếc ô tô * nghỉ hẳn hai ngày",
    example: "thuê hẳn một chiếc ô tô * nghỉ hẳn hai ngày",
  },
  {
    word: "hẳn",
    part_of_speech: "trợ từ",
    meaning:
      "(khẩu ngữ) từ biểu thị ý như muốn hỏi về điều mà thật ra mình đã khẳng định: hẳn anh cũng biết việc ấy? * thế cậu tưởng dễ lắm đấy hẳn?",
    example: "hẳn anh cũng biết việc ấy? * thế cậu tưởng dễ lắm đấy hẳn?",
  },
  {
    word: "hằn",
    part_of_speech: "động từ",
    meaning:
      "để lại những dấu vết nổi rõ, in sâu trên bề mặt: nếp nhăn hằn trên trán * kỉ niệm hằn sâu trong trí nhớ",
    example: "nếp nhăn hằn trên trán * kỉ niệm hằn sâu trong trí nhớ",
  },
  {
    word: "hằn",
    part_of_speech: "danh từ",
    meaning:
      "dấu, vết in sâu của vật đã từng đi qua, đã từng đè lên để lại: nếp hằn trên trán",
    example: "nếp hằn trên trán",
  },
  {
    word: "hằn học",
    part_of_speech: "động từ",
    meaning:
      "tỏ ra ganh ghét, tức tối, muốn gây chuyện do bị thua kém mà không cam chịu: tỏ vẻ hằn học, khó chịu * nói bằng giọng hằn học",
    example: "tỏ vẻ hằn học, khó chịu * nói bằng giọng hằn học",
  },
  {
    word: "hẳn hoi",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có được đầy đủ các yêu cầu, theo đúng tiêu chuẩn như thường đòi hỏi: nói có chứng cớ hẳn hoi * lấy nhau có cưới xin hẳn hoi",
    example: "nói có chứng cớ hẳn hoi * lấy nhau có cưới xin hẳn hoi",
  },
  {
    word: "hẳn hoi",
    part_of_speech: "tính từ",
    meaning: "thật sự, rõ ràng: chính mắt tôi trông thấy hẳn hoi",
    example: "chính mắt tôi trông thấy hẳn hoi",
  },
  {
    word: "hăng",
    part_of_speech: "tính từ",
    meaning:
      "(mùi) có nồng độ cao, xông lên mũi, gây cảm giác khó chịu: có mùi hăng và ngai ngái của đất mới",
    example: "có mùi hăng và ngai ngái của đất mới",
  },
  {
    word: "hăng",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái tinh thần được kích thích, biểu lộ ra bằng hành động sôi nổi, mạnh mẽ: quân ta càng đánh càng hăng * làm việc rất hăng * cổ vũ rất hăng",
    example: "quân ta càng đánh càng hăng * làm việc rất hăng * cổ vũ rất hăng",
  },
  {
    word: "hẳn nhiên",
    part_of_speech: "tính từ",
    meaning:
      "rõ ràng là như vậy, không còn có gì phải nghi ngờ: chuyện liên quan đến anh, hẳn nhiên là anh phải biết",
    example: "chuyện liên quan đến anh, hẳn nhiên là anh phải biết",
  },
  {
    word: "hằng bất đẳng thức",
    part_of_speech: "danh từ",
    meaning:
      "bất đẳng thức đúng với mọi trị số gán cho các chữ trong đó: a2 + 1 > 0 là một hằng bất đẳng thức",
    example: "a2 + 1 > 0 là một hằng bất đẳng thức",
  },
  {
    word: "hằng",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị tính liên tục của một hoạt động (thường là hoạt động tâm lí - tình cảm) diễn ra trong suốt cả thời gian dài: điều hằng mơ ước * anh là người mà tôi hằng quý mến",
    example: "điều hằng mơ ước * anh là người mà tôi hằng quý mến",
  },
  {
    word: "hằng",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị tính lặp đi lặp lại một cách định kì theo từng đơn vị thời gian được nói đến: lễ hội hằng năm * báo cáo hằng tháng * hằng ngày hai người vẫn gặp nhau",
    example:
      "lễ hội hằng năm * báo cáo hằng tháng * hằng ngày hai người vẫn gặp nhau",
  },
  {
    word: "hằng hà",
    part_of_speech: "tính từ",
    meaning:
      "(văn chương) hằng hà sa số (nói tắt): mặt sông hằng hà những đốm sáng lấp lánh",
    example: "mặt sông hằng hà những đốm sáng lấp lánh",
  },
  {
    word: "hẵng",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) từ biểu thị ý thuyết phục chỉ nên làm việc nào đó sau khi xong một việc khác hoặc chờ cho qua một thời gian nhất định: tạt qua nhà đã rồi hẵng đi! * để ăn xong hẵng nói! * thôi về đi, mai hẵng hay",
    example:
      "tạt qua nhà đã rồi hẵng đi! * để ăn xong hẵng nói! * thôi về đi, mai hẵng hay",
  },
  {
    word: "hẵng",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị ý thuyết phục nên làm hoặc nên chấp nhận việc gì đó trước, còn tiếp đến những gì thì sau sẽ hay: chuyện ấy hẵng cứ biết vậy đã",
    example: "chuyện ấy hẵng cứ biết vậy đã",
  },
  {
    word: "hẵng",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) từ biểu thị việc nói đến cần được hoàn thành trước khi làm những việc khác: cứ chờ hẵng! * vào trong nhà hẵng!",
    example: "cứ chờ hẵng! * vào trong nhà hẵng!",
  },
  {
    word: "hăng hái",
    part_of_speech: "tính từ",
    meaning:
      "không nề hà, có lòng nhiệt tình và thái độ tích cực trong công việc: hăng hái lao động và học tập * hăng hái tham gia cách mạng",
    example: "hăng hái lao động và học tập * hăng hái tham gia cách mạng",
  },
  {
    word: "hắng giọng",
    part_of_speech: "động từ",
    meaning:
      "phát ra tiếng ngắn từ trong cổ, thường để lấy giọng trước khi nói hoặc để làm hiệu: hắng giọng mấy cái rồi mới nói",
    example: "hắng giọng mấy cái rồi mới nói",
  },
  {
    word: "hăng hắc",
    part_of_speech: "tính từ",
    meaning: "có mùi hơi hắc: mùi cỏ tranh ngai ngái, hăng hắc",
    example: "mùi cỏ tranh ngai ngái, hăng hắc",
  },
  {
    word: "hăng máu",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) quá hăng, tới mức không kiềm chế, không tự chủ được: lúc hăng máu lên, chẳng biết sợ là gì",
    example: "lúc hăng máu lên, chẳng biết sợ là gì",
  },
  {
    word: "hằng hà sa số",
    part_of_speech: "",
    meaning:
      "nhiều không đếm xuể (ví như cát sông Hằng ở ấn Độ): hàng hoá thì hằng hà sa số",
    example: "hàng hoá thì hằng hà sa số",
  },
  {
    word: "hằng nga",
    part_of_speech: "danh từ",
    meaning:
      'tiên nữ trên cung trăng, theo thần thoại; thường dùng trong văn chương để chỉ mặt trăng: "Tỏ Hằng Nga bấy nước non, Vừng còn vành vạnh, tiết còn khăng khăng." (TNNL)',
    example:
      'Tỏ Hằng Nga bấy nước non, Vừng còn vành vạnh, tiết còn khăng khăng." (TNNL)',
  },
  {
    word: "hăng tiết",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như hăng máu: bị thua lại càng hăng tiết",
    example: "bị thua lại càng hăng tiết",
  },
  {
    word: "hăng say",
    part_of_speech: "tính từ",
    meaning:
      "hăng hái và say mê: hăng say học tập * làm việc một cách hăng say",
    example: "hăng say học tập * làm việc một cách hăng say",
  },
  {
    word: "hắt",
    part_of_speech: "động từ",
    meaning:
      "làm cho chất lỏng hoặc vật gì rời xa khỏi vật đựng bằng động tác đưa ngang nhanh và mạnh: hắt cốc nước * hắt từng xẻng đất vào gốc cây",
    example: "hắt cốc nước * hắt từng xẻng đất vào gốc cây",
  },
  {
    word: "hắt",
    part_of_speech: "động từ",
    meaning:
      "(luồng nước hoặc ánh sáng, âm thanh) bị đổi chiều do tác động của gió hay vật cản: nắng hắt vào nhà * mưa hắt vào mặt",
    example: "nắng hắt vào nhà * mưa hắt vào mặt",
  },
  {
    word: "hắt hủi",
    part_of_speech: "động từ",
    meaning: "tỏ thái độ ghẻ lạnh, ghét bỏ: bị bạn bè hắt hủi",
    example: "bị bạn bè hắt hủi",
  },
  {
    word: "hắt hiu",
    part_of_speech: "tính từ",
    meaning: "như hiu hắt: gió thổi hắt hiu * ánh đèn hắt hiu",
    example: "gió thổi hắt hiu * ánh đèn hắt hiu",
  },
  {
    word: "hâm",
    part_of_speech: "động từ",
    meaning: "đun cho nóng lại những món ăn đã nguội: hâm lại nồi canh",
    example: "hâm lại nồi canh",
  },
  {
    word: "hâm",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) có tính khí không được bình thường, biểu hiện bằng những lối nói năng, những hành vi ít nhiều gàn dở, ngớ ngẩn: càng ngày càng hâm * tính hơi hâm hâm",
    example: "càng ngày càng hâm * tính hơi hâm hâm",
  },
  {
    word: "hẩm",
    part_of_speech: "tính từ",
    meaning:
      "(thóc, gạo) bị mục, bị mất chất, vì để lâu ngày, không còn ngon nữa: gạo hẩm * cơm hẩm",
    example: "gạo hẩm * cơm hẩm",
  },
  {
    word: "hẩm",
    part_of_speech: "tính từ",
    meaning: "(văn chương) (số phận) chịu thua kém: người đàn bà hẩm phận",
    example: "người đàn bà hẩm phận",
  },
  {
    word: "hâm hẩm",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ, hiếm) hơi nóng: nồi canh vẫn còn hâm hẩm",
    example: "nồi canh vẫn còn hâm hẩm",
  },
  {
    word: "hậm hà hậm hực",
    part_of_speech: "động từ",
    meaning:
      "như hậm hực (nhưng ý mức độ nhiều hơn): bị mắng oan nên hậm hà hậm hực mãi",
    example: "bị mắng oan nên hậm hà hậm hực mãi",
  },
  {
    word: "hầm",
    part_of_speech: "danh từ",
    meaning:
      "khoảng trống đào sâu trong lòng đất, thường có nắp, dùng làm nơi trú ẩn hoặc cất giấu: hầm cá nhân * nguỵ trang nắp hầm cẩn thận",
    example: "hầm cá nhân * nguỵ trang nắp hầm cẩn thận",
  },
  {
    word: "hầm",
    part_of_speech: "động từ",
    meaning:
      "nấu, nung trong lò, trong nồi đậy kín, cho chín nhừ: hầm xương * chân giò hầm * hầm gà",
    example: "hầm xương * chân giò hầm * hầm gà",
  },
  {
    word: "hầm hào",
    part_of_speech: "danh từ",
    meaning:
      "hầm, hào, được đào, đắp để làm công sự chiến đấu và phòng tránh (nói khái quát): sửa sang lại hầm hào, công sự",
    example: "sửa sang lại hầm hào, công sự",
  },
  {
    word: "hầm hầm",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả vẻ mặt bực bội, tức giận lắm mà không nói năng gì: mặt hầm hầm giận dữ",
    example: "mặt hầm hầm giận dữ",
  },
  {
    word: "hẩm hiu",
    part_of_speech: "tính từ",
    meaning: "hẩm (nói khái quát): số phận hẩm hiu",
    example: "số phận hẩm hiu",
  },
  {
    word: "hầm hè",
    part_of_speech: "động từ",
    meaning:
      "có thái độ, vẻ mặt tức giận, chỉ chực sinh sự, gây gổ: hai bên hầm hè nhau * mặt hầm hè",
    example: "hai bên hầm hè nhau * mặt hầm hè",
  },
  {
    word: "hậm hoẹ",
    part_of_speech: "động từ",
    meaning:
      "làm ra vẻ doạ nạt: nó chỉ hậm hoẹ thế thôi chứ chẳng làm gì ai bao giờ",
    example: "nó chỉ hậm hoẹ thế thôi chứ chẳng làm gì ai bao giờ",
  },
  {
    word: "hầm hập",
    part_of_speech: "tính từ",
    meaning:
      "(hơi nóng) ở trạng thái bốc mạnh và kéo dài, gây cảm giác khó chịu: căn phòng nóng hầm hập",
    example: "căn phòng nóng hầm hập",
  },
  {
    word: "hầm hập",
    part_of_speech: "tính từ",
    meaning:
      "có khí thế sôi sục mạnh mẽ: khí thế hầm hập của những ngày trước tổng khởi nghĩa",
    example: "khí thế hầm hập của những ngày trước tổng khởi nghĩa",
  },
  {
    word: "hâm hấp",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái nhiệt độ cao hơn bình thường một chút: mặt đường nhựa còn hâm hấp cái nắng ban ngày * trán hâm hấp sốt",
    example: "mặt đường nhựa còn hâm hấp cái nắng ban ngày * trán hâm hấp sốt",
  },
  {
    word: "hâm hấp",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) hơi hâm: tính hâm hấp, gàn dở",
    example: "tính hâm hấp, gàn dở",
  },
  {
    word: "hầm hố",
    part_of_speech: "danh từ",
    meaning:
      "hầm, hố, được đào để làm chỗ ẩn tránh bom đạn (nói khái quát): đào sẵn hầm hố để tránh máy bay",
    example: "đào sẵn hầm hố để tránh máy bay",
  },
  {
    word: "hầm hố",
    part_of_speech: "tính từ",
    meaning:
      "(thông tục) (quần áo, trang phục) có kiểu dáng to và thô kệch, góc cạnh, gây ấn tượng mạnh: bộ quần áo trông rất hầm hố",
    example: "bộ quần áo trông rất hầm hố",
  },
  {
    word: "hậm hụi",
    part_of_speech: "",
    meaning: "(khẩu ngữ) như cặm cụi: hậm hụi gọt đẽo cả buổi",
    example: "hậm hụi gọt đẽo cả buổi",
  },
  {
    word: "hấm hứ",
    part_of_speech: "động từ",
    meaning:
      "phát ra những tiếng giọng mũi, thường để tỏ thái độ không bằng lòng: suốt ngày hấm hứ, lườm nguýt nhau",
    example: "suốt ngày hấm hứ, lườm nguýt nhau",
  },
  {
    word: "hậm hực",
    part_of_speech: "động từ",
    meaning:
      "có điều bực tức, khó chịu trong lòng mà không thể nói ra, không thể làm gì được: không nói được nên hậm hực mãi",
    example: "không nói được nên hậm hực mãi",
  },
  {
    word: "hâm mộ",
    part_of_speech: "động từ",
    meaning:
      "yêu thích và mến phục: hâm mộ bóng đá * fan hâm mộ * một ca sĩ được nhiều người hâm mộ",
    example: "hâm mộ bóng đá * fan hâm mộ * một ca sĩ được nhiều người hâm mộ",
  },
  {
    word: "hầm tàu",
    part_of_speech: "danh từ",
    meaning:
      "khoang trong thân tàu thuỷ, nằm dưới boong dưới, dùng để đặt máy tàu, xếp hàng hoá và các thức dự trữ, v.v.: chui xuống hầm tàu",
    example: "chui xuống hầm tàu",
  },
  {
    word: "hâm nóng",
    part_of_speech: "động từ",
    meaning:
      "làm bùng lên trở lại một cách sôi động và mạnh mẽ hơn: hâm nóng bầu nhiệt huyết * bầu không khí chiến tranh đang bị hâm nóng",
    example:
      "hâm nóng bầu nhiệt huyết * bầu không khí chiến tranh đang bị hâm nóng",
  },
  {
    word: "hầm trú ẩn",
    part_of_speech: "danh từ",
    meaning: "hầm đào để ẩn tránh các loại bom đạn: đào hầm trú ẩn trong vườn",
    example: "đào hầm trú ẩn trong vườn",
  },
  {
    word: "hầm hừ",
    part_of_speech: "động từ",
    meaning: "(hiếm) như hầm hè: hầm hừ như chực đánh nhau",
    example: "hầm hừ như chực đánh nhau",
  },
  {
    word: "hận",
    part_of_speech: "động từ",
    meaning:
      "căm giận, oán hờn sâu sắc đối với kẻ đã làm hại mình: hận kẻ bạc tình",
    example: "hận kẻ bạc tình",
  },
  {
    word: "hận",
    part_of_speech: "động từ",
    meaning:
      "buồn day dứt vì đã không làm được như mong muốn: chỉ hận một điều là không về kịp",
    example: "chỉ hận một điều là không về kịp",
  },
  {
    word: "hận",
    part_of_speech: "danh từ",
    meaning:
      "lòng căm giận, oán hờn sâu sắc: nuốt hận * ôm hận trong lòng * rửa hận",
    example: "nuốt hận * ôm hận trong lòng * rửa hận",
  },
  {
    word: "hận",
    part_of_speech: "danh từ",
    meaning:
      "nỗi day dứt vì đã không làm được như mong muốn: nếu không về kịp  thì mang hận suốt đời",
    example: "nếu không về kịp  thì mang hận suốt đời",
  },
  {
    word: "hận thù",
    part_of_speech: "",
    meaning:
      "căm giận, oán hờn sâu sắc đến mức luôn nghĩ đến việc phải trả thù: lòng đầy hận thù * xoá bỏ hận thù",
    example: "lòng đầy hận thù * xoá bỏ hận thù",
  },
  {
    word: "hân hoan",
    part_of_speech: "tính từ",
    meaning:
      "vui mừng, biểu lộ rõ trên nét mặt, cử chỉ: hân hoan chào đón * nét mặt đầy vẻ hân hoan",
    example: "hân hoan chào đón * nét mặt đầy vẻ hân hoan",
  },
  {
    word: "hân hạnh",
    part_of_speech: "tính từ",
    meaning:
      "(trang trọng) may mắn và lấy làm vui mừng (vì được quan hệ tiếp xúc với ai đó): hân hạnh được đón tiếp",
    example: "hân hạnh được đón tiếp",
  },
  {
    word: "hẫng",
    part_of_speech: "tính từ",
    meaning:
      "bị hụt và đột ngột rơi vào khoảng không: bị hẫng chân như bước hụt",
    example: "bị hẫng chân như bước hụt",
  },
  {
    word: "hẫng",
    part_of_speech: "tính từ",
    meaning:
      "có cảm giác bị mất đi hứng thú một cách đột ngột: bị hẫng vì câu hỏi bất ngờ",
    example: "bị hẫng vì câu hỏi bất ngờ",
  },
  {
    word: "hẫng",
    part_of_speech: "tính từ",
    meaning:
      "bị cụt, thiếu đi một cách đột ngột: bài văn viết hơi bị hẫng * kiến thức bị hẫng",
    example: "bài văn viết hơi bị hẫng * kiến thức bị hẫng",
  },
  {
    word: "hấp",
    part_of_speech: "động từ",
    meaning:
      "làm cho chín thức ăn bằng hơi nóng của nước: hấp bánh * cá hấp * hấp cách thuỷ",
    example: "hấp bánh * cá hấp * hấp cách thuỷ",
  },
  {
    word: "hấp",
    part_of_speech: "động từ",
    meaning: "diệt vi trùng bằng hơi nóng: hấp bông băng",
    example: "hấp bông băng",
  },
  {
    word: "hấp",
    part_of_speech: "động từ",
    meaning:
      "làm cho thuốc nhuộm thấm vào len, lụa, vải, hoặc chất dưỡng thấm vào tóc bằng hơi nóng.",
    example: "mở dịch vụ hấp, tẩy đồ len, dạ",
  },
  {
    word: "hấp",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) hơi dở người: càng nói càng thấy hấp",
    example: "càng nói càng thấy hấp",
  },
  {
    word: "hập",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) (hơi nóng) ở trạng thái bốc mạnh, gây cảm giác khó chịu: căn phòng nóng hập",
    example: "căn phòng nóng hập",
  },
  {
    word: "hẫng hụt",
    part_of_speech: "tính từ",
    meaning: "như hụt hẫng: cảm thấy hẫng hụt khi tiễn bạn ra đi",
    example: "cảm thấy hẫng hụt khi tiễn bạn ra đi",
  },
  {
    word: "hấp dẫn",
    part_of_speech: "động từ",
    meaning:
      "(hiện tượng các vật có khối lượng) hút nhau: định luật vạn vật hấp dẫn",
    example: "định luật vạn vật hấp dẫn",
  },
  {
    word: "hấp dẫn",
    part_of_speech: "động từ",
    meaning:
      "hoặc t có sức lôi cuốn, làm cho người ta ham thích: bộ phim hấp dẫn người xem * cô gái có khuôn mặt khá hấp dẫn",
    example: "bộ phim hấp dẫn người xem * cô gái có khuôn mặt khá hấp dẫn",
  },
  {
    word: "hấp háy",
    part_of_speech: "động từ",
    meaning:
      "(mắt) mở ra nhắm lại liên tiếp nhiều lần, vì không mở hẳn được, thường do bị chói sáng: chói quá, hai mắt cứ hấp háy",
    example: "chói quá, hai mắt cứ hấp háy",
  },
  {
    word: "hấp háy",
    part_of_speech: "động từ",
    meaning:
      "(mắt) mở không to, nhắm lại rồi lại mở liên tiếp, để biểu lộ tình cảm: mắt hấp háy vẻ tinh nghịch",
    example: "mắt hấp háy vẻ tinh nghịch",
  },
  {
    word: "hấp him",
    part_of_speech: "",
    meaning:
      "(mắt) ở trạng thái nửa nhắm nửa mở, không mở được to hẳn ra: mắt hấp him buồn ngủ",
    example: "mắt hấp him buồn ngủ",
  },
  {
    word: "hấp hối",
    part_of_speech: "động từ",
    meaning: "ở trạng thái sắp chết, sắp tắt thở: người bệnh đang hấp hối",
    example: "người bệnh đang hấp hối",
  },
  {
    word: "hấp hơi",
    part_of_speech: "động từ",
    meaning:
      "không thoáng, không thoát hơi, do bị che, đậy kín: cơm bị hấp hơi, thiu hết * căn phòng hấp hơi, nóng hầm hập",
    example: "cơm bị hấp hơi, thiu hết * căn phòng hấp hơi, nóng hầm hập",
  },
  {
    word: "hấp hem",
    part_of_speech: "",
    meaning: "(hiếm) như hấp him: mắt hấp hem",
    example: "mắt hấp hem",
  },
  {
    word: "hấp tấp",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra vội vì muốn cho nhanh, cho kịp nên thường hành động thiếu cân nhắc: hấp tấp chạy theo * hấp tấp nên bị sai một con tính * đừng có hấp tấp!",
    example:
      "hấp tấp chạy theo * hấp tấp nên bị sai một con tính * đừng có hấp tấp!",
  },
  {
    word: "hất",
    part_of_speech: "động từ",
    meaning:
      "đưa chếch (bộ phận thân thể) lên một cách nhanh, dứt khoát: hất hàm hỏi * hất mũi giày lên * hất đầu ra hiệu",
    example: "hất hàm hỏi * hất mũi giày lên * hất đầu ra hiệu",
  },
  {
    word: "hất",
    part_of_speech: "động từ",
    meaning:
      "làm cho chuyển đi chỗ khác bằng một động tác nhanh và gọn: hất nhẹ từng xẻng đất * hất mớ tóc ra sau",
    example: "hất nhẹ từng xẻng đất * hất mớ tóc ra sau",
  },
  {
    word: "hậu",
    part_of_speech: "tính từ",
    meaning:
      "ở phía sau; đối lập với tiền: đi theo lối cổng hậu * dép quai hậu * tiền hậu bất nhất",
    example: "đi theo lối cổng hậu * dép quai hậu * tiền hậu bất nhất",
  },
  {
    word: "hậu",
    part_of_speech: "tính từ",
    meaning:
      "cao hơn mức bình thường (thường về mặt vật chất, trong sự đối xử) để tỏ sự coi trọng: đối đãi rất hậu * thưởng hậu",
    example: "đối đãi rất hậu * thưởng hậu",
  },
  {
    word: "hất cẳng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đánh bật khỏi một vị trí, một địa vị nào đó để chiếm lấy (hàm ý coi thường): Nhật hất cẳng Pháp ở chiến trường Đông Dương",
    example: "Nhật hất cẳng Pháp ở chiến trường Đông Dương",
  },
  {
    word: "hẩu",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) tốt với nhau trong quan hệ riêng, nhưng có tính chất bè cánh, thiên lệch: hẩu với nhau * đám bạn hẩu",
    example: "hẩu với nhau * đám bạn hẩu",
  },
  {
    word: "hẩu",
    part_of_speech: "tính từ",
    meaning: "(chất đất) có nhiều mùn: chân ruộng hẩu * đất hẩu",
    example: "chân ruộng hẩu * đất hẩu",
  },
  {
    word: "hậu bị",
    part_of_speech: "tính từ",
    meaning:
      "có sẵn để có thể bổ sung ngay khi cần: lực lượng hậu bị * cánh quân hậu bị",
    example: "lực lượng hậu bị * cánh quân hậu bị",
  },
  {
    word: "hầu bao",
    part_of_speech: "danh từ",
    meaning:
      "túi người thời trước thường dùng luồn vào thắt lưng, để đựng tiền: cởi hầu bao lấy tiền",
    example: "cởi hầu bao lấy tiền",
  },
  {
    word: "hầu",
    part_of_speech: "danh từ",
    meaning:
      "(Từ cũ) tước thứ hai, sau tước công, trước tước bá, trong bậc thang chức tước hàng quan lại thời phong kiến: phong tước hầu",
    example: "phong tước hầu",
  },
  {
    word: "hầu",
    part_of_speech: "động từ",
    meaning:
      "thường xuyên ở bên cạnh để cho người trên sai bảo: lính hầu * cứ bày ra như thế thì không ai hầu được!",
    example: "lính hầu * cứ bày ra như thế thì không ai hầu được!",
  },
  {
    word: "hầu",
    part_of_speech: "động từ",
    meaning:
      "đến trước mặt quan hoặc ra trước toà án để nghe lời phán bảo, xét xử: ra hầu toà * hầu kiện * lí trưởng vào hầu quan",
    example: "ra hầu toà * hầu kiện * lí trưởng vào hầu quan",
  },
  {
    word: "hầu",
    part_of_speech: "động từ",
    meaning:
      "(Kiểu cách) làm việc gì đó chỉ nhằm làm vui lòng người khác (là bề trên hoặc coi như bề trên): chơi hầu cụ mấy ván cờ * ngồi hầu chuyện bà lớn",
    example: "chơi hầu cụ mấy ván cờ * ngồi hầu chuyện bà lớn",
  },
  {
    word: "hầu",
    part_of_speech: "danh từ",
    meaning:
      "(Từ cũ) người con gái đi ở, hầu hạ trong gia đình nhà quyền quý thời phong kiến: con hầu",
    example: "con hầu",
  },
  {
    word: "hầu",
    part_of_speech: "danh từ",
    meaning:
      'nàng hầu (nói tắt): "Công nữ quỳ xuống tâu lên, Chẳng đặng chính thất tôi xin làm hầu." (MPXH)',
    example:
      'Công nữ quỳ xuống tâu lên, Chẳng đặng chính thất tôi xin làm hầu." (MPXH)',
  },
  {
    word: "hầu",
    part_of_speech: "động từ",
    meaning:
      '(Văn chương) mong và cố thực hiện được điều biết là rất khó: "Làm chi thắc mắc thêm sầu, Chim còn đón gió, rồng hầu đợi mưa." (PT)',
    example:
      'Làm chi thắc mắc thêm sầu, Chim còn đón gió, rồng hầu đợi mưa." (PT)',
  },
  {
    word: "hầu",
    part_of_speech: "phụ từ",
    meaning:
      "(Từ cũ, hoặc id) từ biểu thị mức gần là như thế: đêm đã hầu tàn * nắng mãi, cây cỏ hầu chết khô",
    example: "đêm đã hầu tàn * nắng mãi, cây cỏ hầu chết khô",
  },
  {
    word: "hấp thu",
    part_of_speech: "động từ",
    meaning:
      "(hiện tượng chất rắn hay chất lỏng) thu hút các khí, hơi và chất hoà tan: hấp thu ánh sáng * cơ thể hấp thu các chất dinh dưỡng",
    example: "hấp thu ánh sáng * cơ thể hấp thu các chất dinh dưỡng",
  },
  {
    word: "hấp thu",
    part_of_speech: "động từ",
    meaning:
      "thu nhận và chịu ảnh hưởng sâu sắc (nói về tư tưởng, văn hoá): hấp thu kiến thức",
    example: "hấp thu kiến thức",
  },
  {
    word: "hấp thụ",
    part_of_speech: "động từ",
    meaning:
      "(hiện tượng chất rắn hay chất lỏng) thu hút các khí, hơi và chất hoà tan: hấp thu ánh sáng * cơ thể hấp thu các chất dinh dưỡng",
    example: "hấp thu ánh sáng * cơ thể hấp thu các chất dinh dưỡng",
  },
  {
    word: "hấp thụ",
    part_of_speech: "động từ",
    meaning:
      "thu nhận và chịu ảnh hưởng sâu sắc (nói về tư tưởng, văn hoá): hấp thu kiến thức",
    example: "hấp thu kiến thức",
  },
  {
    word: "hậu bối",
    part_of_speech: "danh từ",
    meaning:
      "người thuộc lớp sau, thế hệ sau, trong quan hệ với người lớp trước, gọi là tiền bối (hàm ý khiêm tốn): lớp hậu bối",
    example: "lớp hậu bối",
  },
  {
    word: "hậu bối",
    part_of_speech: "danh từ",
    meaning: "nhọt bọc lớn mọc ở sống lưng: lên hậu bối",
    example: "lên hậu bối",
  },
  {
    word: "hậu cần",
    part_of_speech: "danh từ",
    meaning:
      "việc bảo đảm vật chất, kĩ thuật, y tế, quân trang, quân dụng cho lực lượng vũ trang: phụ trách hậu cần của đơn vị * giữ kho hậu cần",
    example: "phụ trách hậu cần của đơn vị * giữ kho hậu cần",
  },
  {
    word: "hầu cận",
    part_of_speech: "động từ",
    meaning:
      "theo hầu bên cạnh người có chức vị, thường được coi là người thân tín: hầu cận vua * lính hầu cận",
    example: "hầu cận vua * lính hầu cận",
  },
  {
    word: "hậu cung",
    part_of_speech: "danh từ",
    meaning: "cung ở phía sau trong cung vua, là nơi ở của các phi tần.",
    example: "pho tượng được đặt ở hậu cung",
  },
  {
    word: "hậu đãi",
    part_of_speech: "động từ",
    meaning: "đãi rất hậu: làm tốt sẽ được hậu đãi",
    example: "làm tốt sẽ được hậu đãi",
  },
  {
    word: "hầu hạ",
    part_of_speech: "động từ",
    meaning:
      "làm mọi việc phục vụ sinh hoạt hằng ngày cho chủ, cho người trên: hầu hạ mẹ già * có người hầu hạ",
    example: "hầu hạ mẹ già * có người hầu hạ",
  },
  {
    word: "hậu duệ",
    part_of_speech: "danh từ",
    meaning:
      "(trang trọng) con cháu đời sau của người đã mất: Nguyễn Thiện Thuật là hậu duệ của Nguyễn Trãi",
    example: "Nguyễn Thiện Thuật là hậu duệ của Nguyễn Trãi",
  },
  {
    word: "hậu đài",
    part_of_speech: "danh từ",
    meaning: "(cũ) như hậu trường: diễn viên đứng phía sau hậu đài",
    example: "diễn viên đứng phía sau hậu đài",
  },
  {
    word: "hậu hĩ",
    part_of_speech: "tính từ",
    meaning: "rất hậu (nói khái quát): lễ vật hậu hĩ * tiền thù lao rất hậu hĩ",
    example: "lễ vật hậu hĩ * tiền thù lao rất hậu hĩ",
  },
  {
    word: "hậu đậu",
    part_of_speech: "tính từ",
    meaning: "lóng ngóng, vụng về, hay làm đổ vỡ: con bé hậu đậu lắm!",
    example: "con bé hậu đậu lắm!",
  },
  {
    word: "hậu chiến",
    part_of_speech: "tính từ",
    meaning: "thuộc về sau chiến tranh: công tác hậu chiến * thời hậu chiến",
    example: "công tác hậu chiến * thời hậu chiến",
  },
  {
    word: "hầu hết",
    part_of_speech: "",
    meaning:
      "hầu như tất cả (mọi người, mọi vật): ý kiến được hầu hết mọi người tán thành",
    example: "ý kiến được hầu hết mọi người tán thành",
  },
  {
    word: "hậu hĩnh",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như hậu hĩ: tiền công hậu hĩnh",
    example: "tiền công hậu hĩnh",
  },
  {
    word: "hậu hoạ",
    part_of_speech: "danh từ",
    meaning: "tai hoạ về sau: nhổ cỏ phải nhổ tận gốc để trừ hậu hoạ",
    example: "nhổ cỏ phải nhổ tận gốc để trừ hậu hoạ",
  },
  {
    word: "hầu khắp",
    part_of_speech: "",
    meaning:
      "hầu như khắp cả (mọi nơi, mọi chỗ): đi hầu khắp các miền của đất nước",
    example: "đi hầu khắp các miền của đất nước",
  },
  {
    word: "hậu kì",
    part_of_speech: "danh từ",
    meaning:
      "giai đoạn cuối của một thời kì lịch sử hay một chế độ chính trị - xã hội: hậu kì đồ đá cũ",
    example: "hậu kì đồ đá cũ",
  },
  {
    word: "hậu kì",
    part_of_speech: "danh từ",
    meaning:
      "giai đoạn chỉnh sửa cuối cùng để hoàn chỉnh một bộ phim: phần hậu kì của bộ phim được thực hiện ở nước ngoài",
    example: "phần hậu kì của bộ phim được thực hiện ở nước ngoài",
  },
  {
    word: "hầu như",
    part_of_speech: "phụ từ",
    meaning: "gần như là, thực tế là: ngôi nhà hầu như không có gì thay đổi",
    example: "ngôi nhà hầu như không có gì thay đổi",
  },
  {
    word: "hậu mãi",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về thời gian sau khi hàng đã được mua về: dịch vụ hậu mãi chu đáo",
    example: "dịch vụ hậu mãi chu đáo",
  },
  {
    word: "hậu phương",
    part_of_speech: "danh từ",
    meaning:
      "vùng ở phía sau mặt trận, có nhiệm vụ đáp ứng, chi viện cho tiền tuyến; đối lập với tiền phương: xây dựng hậu phương vững chắc",
    example: "xây dựng hậu phương vững chắc",
  },
  {
    word: "hầu phòng",
    part_of_speech: "danh từ",
    meaning: "như bồi phòng: làm hầu phòng trong khách sạn",
    example: "làm hầu phòng trong khách sạn",
  },
  {
    word: "hậu phẫu",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về sau khi phẫu thuật: bệnh nhân đã được chuyển về phòng hậu phẫu",
    example: "bệnh nhân đã được chuyển về phòng hậu phẫu",
  },
  {
    word: "hậu sinh",
    part_of_speech: "danh từ",
    meaning:
      "người sinh sau, trong quan hệ với những người thuộc lớp trước: lớp hậu sinh",
    example: "lớp hậu sinh",
  },
  {
    word: "hậu quả",
    part_of_speech: "danh từ",
    meaning:
      "kết quả không hay, có ảnh hưởng về sau: khắc phục hậu quả của cơn bão * gây hậu quả nghiêm trọng",
    example: "khắc phục hậu quả của cơn bão * gây hậu quả nghiêm trọng",
  },
  {
    word: "hậu sự",
    part_of_speech: "danh từ",
    meaning:
      "những việc sau khi chết, như chôn cất, ma chay, v.v.: cắt cử người lo việc hậu sự",
    example: "cắt cử người lo việc hậu sự",
  },
  {
    word: "hậu sự",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) áo quan được đóng sẵn từ khi còn sống: chuẩn bị sẵn một cỗ hậu sự",
    example: "chuẩn bị sẵn một cỗ hậu sự",
  },
  {
    word: "hậu thế",
    part_of_speech: "danh từ",
    meaning: "(văn chương) đời sau: tiếng thơm lưu truyền hậu thế",
    example: "tiếng thơm lưu truyền hậu thế",
  },
  {
    word: "hậu tạ",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) trả ơn sau khi nhận được sự giúp đỡ một cách chu đáo, xứng đáng, bằng tiền bạc, vật chất: gia đình xin cảm ơn và hậu tạ",
    example: "gia đình xin cảm ơn và hậu tạ",
  },
  {
    word: "hậu tố",
    part_of_speech: "danh từ",
    meaning:
      "phụ tố đứng sau căn tố: hậu tố cấu tạo danh từ *  là một hậu tố trong tiếng Anh",
    example: "hậu tố cấu tạo danh từ *  là một hậu tố trong tiếng Anh",
  },
  {
    word: "hậu thuẫn",
    part_of_speech: "",
    meaning:
      "lực lượng ủng hộ, giúp đỡ, làm chỗ dựa ở phía sau: miền Bắc làm hậu thuẫn cho miền Nam * được nhà nước hậu thuẫn về tài chính",
    example:
      "miền Bắc làm hậu thuẫn cho miền Nam * được nhà nước hậu thuẫn về tài chính",
  },
  {
    word: "hậu vận",
    part_of_speech: "danh từ",
    meaning:
      "số phận, vận mệnh về phần sau cuộc đời con người; phân biệt với tiền vận: hậu vận được an nhàn",
    example: "hậu vận được an nhàn",
  },
  {
    word: "hậu trường",
    part_of_speech: "danh từ",
    meaning: "phía bên trong, đằng sau sân khấu.",
    example: "có ảnh hưởng lớn trong hậu trường chính trị",
  },
  {
    word: "hậu tuyến",
    part_of_speech: "danh từ",
    meaning:
      "tuyến sau, nơi ở phía sau mặt trận, không trực tiếp đánh nhau với địch; đối lập với tiền tuyến: đưa thương binh về hậu tuyến",
    example: "đưa thương binh về hậu tuyến",
  },
  {
    word: "hây",
    part_of_speech: "tính từ",
    meaning:
      "(màu đỏ hoặc vàng) tươi sáng, trông có sức hấp dẫn: lúa chín vàng hây * má đã đỏ hây",
    example: "lúa chín vàng hây * má đã đỏ hây",
  },
  {
    word: "hậu vệ",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận đi ở phía cuối đội hình, có nhiệm vụ bảo vệ, bảo đảm an toàn phía sau.",
    example: "hàng hậu vệ * đá ở vị trí hậu vệ",
  },
  {
    word: "hậu vệ",
    part_of_speech: "danh từ",
    meaning: "tuyến sau của một đội bóng: hàng hậu vệ * đá ở vị trí hậu vệ",
    example: "thay hậu vệ",
  },
  {
    word: "hẩy",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) (dùng tay hay chân) hất xa ra bằng động tác nhanh và gọn: hẩy ngã * bị hẩy từ phía sau",
    example: "hẩy ngã * bị hẩy từ phía sau",
  },
  {
    word: "hè",
    part_of_speech: "danh từ",
    meaning:
      "mùa hạ, về mặt là mùa nóng bức nhất trong năm: trời đã vào hè * nắng hè",
    example: "trời đã vào hè * nắng hè",
  },
  {
    word: "hè",
    part_of_speech: "danh từ",
    meaning: "dải nền ở trước hoặc quanh nhà: ngồi hóng mát ngoài hè",
    example: "ngồi hóng mát ngoài hè",
  },
  {
    word: "hè",
    part_of_speech: "danh từ",
    meaning:
      "phần chạy dọc hai bên đường phố, cao hơn mặt đường, dành cho người đi bộ: hè đường * hè phố",
    example: "hè đường * hè phố",
  },
  {
    word: "hè",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) cùng cất tiếng to để bảo nhau cùng ra sức làm ngay một việc gì: hè nhau ra khiêng * hè nhau làm cho nhanh",
    example: "hè nhau ra khiêng * hè nhau làm cho nhanh",
  },
  {
    word: "hè",
    part_of_speech: "trợ từ",
    meaning: "(phương ngữ) như nào: ta đi hè! * nghỉ tay một chút đã hè!",
    example: "ta đi hè! * nghỉ tay một chút đã hè!",
  },
  {
    word: "hè",
    part_of_speech: "trợ từ",
    meaning: "như nhỉ: thằng nhỏ dễ thương hè! * đẹp ghê hè! * đông quá hè!",
    example: "thằng nhỏ dễ thương hè! * đẹp ghê hè! * đông quá hè!",
  },
  {
    word: "hẹ",
    part_of_speech: "danh từ",
    meaning:
      "cây cùng họ với hành, lá mỏng, nhỏ và dài, thường dùng để ăn hoặc làm thuốc: rối như canh hẹ",
    example: "rối như canh hẹ",
  },
  {
    word: "hây hây",
    part_of_speech: "tính từ",
    meaning: "như hây hẩy: gió thổi hây hây",
    example: "gió thổi hây hây",
  },
  {
    word: "hây hẩy",
    part_of_speech: "tính từ",
    meaning:
      "(gió thổi) nhẹ, mát, thành từng làn ngắn: chiều hè hây hẩy gió nam",
    example: "chiều hè hây hẩy gió nam",
  },
  {
    word: "hè hụi",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) làm việc gì một cách chăm chú nhưng có vẻ nặng nhọc, vất vả: một mình hè hụi vác mấy bao lúa",
    example: "một mình hè hụi vác mấy bao lúa",
  },
  {
    word: "hé",
    part_of_speech: "động từ",
    meaning:
      "mở ra một khoảng nhỏ, vừa đủ để làm gì hoặc cho một yêu cầu nào đó: hé cửa ra nhìn * hé môi cười",
    example: "hé cửa ra nhìn * hé môi cười",
  },
  {
    word: "hé",
    part_of_speech: "động từ",
    meaning:
      "cho thấy, cho biết một phần nhỏ nào đó: hé lên một tia hi vọng * giấu kín, không dám hé ra với ai",
    example: "hé lên một tia hi vọng * giấu kín, không dám hé ra với ai",
  },
  {
    word: "hé răng",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) mở miệng ra nói: không dám hé răng",
    example: "không dám hé răng",
  },
  {
    word: "hẻm",
    part_of_speech: "danh từ",
    meaning: "lối đi hẹp, hai bên có vách núi cao: hẻm núi * hẻm đá",
    example: "hẻm núi * hẻm đá",
  },
  {
    word: "hẻm",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) ngõ hẻm (nói tắt): nhà ở trong hẻm",
    example: "nhà ở trong hẻm",
  },
  {
    word: "hẻm",
    part_of_speech: "tính từ",
    meaning:
      "(đường, ngõ) nhỏ và hẹp, hai bên thường có tường vách, khó đi: hang cùng ngõ hẻm * con đường hẻm",
    example: "hang cùng ngõ hẻm * con đường hẻm",
  },
  {
    word: "hèm",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) bã rượu: nuôi lợn bằng hèm",
    example: "nuôi lợn bằng hèm",
  },
  {
    word: "hèm",
    part_of_speech: "danh từ",
    meaning:
      "trò diễn lại sự tích của vị thần thờ trong làng, được coi là một nghi thức trước khi vào đám.",
    example:
      'Người Xá có hèm sợ núi cho nên hay làm nhà tránh xuống bờ suối." (THoài; 20)',
  },
  {
    word: "hèm",
    part_of_speech: "động từ",
    meaning: "như e hèm: hèm một tiếng trong cổ họng",
    example: "hèm một tiếng trong cổ họng",
  },
  {
    word: "hèm hẹp",
    part_of_speech: "tính từ",
    meaning: "hơi hẹp: căn phòng có vẻ hơi hèm hẹp",
    example: "căn phòng có vẻ hơi hèm hẹp",
  },
  {
    word: "hèn",
    part_of_speech: "tính từ",
    meaning:
      "rất kém bản lĩnh, thường do nhút nhát sợ sệt, đến mức đáng khinh: đánh lén là hèn * đồ hèn! (tiếng chửi mắng)",
    example: "đánh lén là hèn * đồ hèn! (tiếng chửi mắng)",
  },
  {
    word: "hèn",
    part_of_speech: "tính từ",
    meaning:
      "ở địa vị thấp kém trong xã hội và bị coi thường, thường vì nghèo, vì yếu thế: phận hèn * không phân biệt sang hèn",
    example: "phận hèn * không phân biệt sang hèn",
  },
  {
    word: "hèn",
    part_of_speech: "tính từ",
    meaning:
      'kém, chẳng ra gì về khả năng: tài hèn sức mọn * "(...) Hùm thiêng khi đã sa cơ cũng hèn!" (TKiều)',
    example:
      'tài hèn sức mọn * "(...) Hùm thiêng khi đã sa cơ cũng hèn!" (TKiều)',
  },
  {
    word: "hen",
    part_of_speech: "danh từ",
    meaning:
      "bệnh ở đường hô hấp, gây những cơn khó thở do co thắt phế quản: lên cơn hen * điều trị bệnh hen",
    example: "lên cơn hen * điều trị bệnh hen",
  },
  {
    word: "hén",
    part_of_speech: "trợ từ",
    meaning:
      "(phương ngữ) từ biểu thị ý như muốn hỏi, nhằm tranh thủ sự đồng tình của người nghe: con nhỏ dạo này coi lớn quá hén? * như vầy là xong hén! * cô Hai đi hén!",
    example:
      "con nhỏ dạo này coi lớn quá hén? * như vầy là xong hén! * cô Hai đi hén!",
  },
  {
    word: "hèn gì",
    part_of_speech: "kết từ",
    meaning:
      "tổ hợp biểu thị điều vừa nói đến là cái lẽ giải thích làm cho điều sắp nêu ra không đáng phải ngạc nhiên nữa: hấp tấp như thế, hèn nào chẳng hỏng việc",
    example: "hấp tấp như thế, hèn nào chẳng hỏng việc",
  },
  {
    word: "hẹn",
    part_of_speech: "động từ",
    meaning:
      'nói, thỏa thuận với ai rằng sẽ hoặc cùng làm việc gì trong một thời gian cụ thể sắp tới: hẹn gặp mặt * "Tình cờ, chẳng hẹn mà nên, Mạt cưa mướp đắng, đôi bên một phường." (TKiều)',
    example:
      'hẹn gặp mặt * "Tình cờ, chẳng hẹn mà nên, Mạt cưa mướp đắng, đôi bên một phường." (TKiều)',
  },
  {
    word: "hẹn",
    part_of_speech: "danh từ",
    meaning: "điều hẹn, lời hẹn: không đúng hẹn * lỡ hẹn * đang có hẹn",
    example: "không đúng hẹn * lỡ hẹn * đang có hẹn",
  },
  {
    word: "hèn chi",
    part_of_speech: "kết từ",
    meaning:
      "tổ hợp biểu thị điều vừa nói đến là cái lẽ giải thích làm cho điều sắp nêu ra không đáng phải ngạc nhiên nữa: hấp tấp như thế, hèn nào chẳng hỏng việc",
    example: "hấp tấp như thế, hèn nào chẳng hỏng việc",
  },
  {
    word: "hẹn hò",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) hẹn (nói khái quát; thường hàm ý chê): hẹn hò gì mà đến giờ vẫn chưa đến",
    example: "hẹn hò gì mà đến giờ vẫn chưa đến",
  },
  {
    word: "hẹn hò",
    part_of_speech: "động từ",
    meaning:
      '(hai bên trai gái) hẹn gặp nhau hoặc hẹn điều gì đó với nhau: "Đôi ta đã trót hẹn hò, Đẹp duyên cứ lấy chớ lo bạc tiền." (ca dao)',
    example:
      'Đôi ta đã trót hẹn hò, Đẹp duyên cứ lấy chớ lo bạc tiền." (ca dao)',
  },
  {
    word: "hèn hạ",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra thấp kém về bản lĩnh và nhân cách đến mức đáng khinh: tâm địa hèn hạ * con người hèn hạ",
    example: "tâm địa hèn hạ * con người hèn hạ",
  },
  {
    word: "hèn hạ",
    part_of_speech: "tính từ",
    meaning:
      "thấp kém về địa vị xã hội hoặc về giá trị tinh thần, thường bị coi thường, coi khinh: con nhà hèn hạ * giai cấp hèn hạ",
    example: "con nhà hèn hạ * giai cấp hèn hạ",
  },
  {
    word: "hèn mạt",
    part_of_speech: "tính từ",
    meaning:
      "thấp kém về nhân cách đến mức đáng khinh bỉ: sống hèn mạt * thủ đoạn hèn mạt, bỉ ổi",
    example: "sống hèn mạt * thủ đoạn hèn mạt, bỉ ổi",
  },
  {
    word: "hèn mọn",
    part_of_speech: "tính từ",
    meaning: "thấp kém và nhỏ mọn đến mức không đáng kể: thân phận hèn mọn",
    example: "thân phận hèn mọn",
  },
  {
    word: "hèn nhát",
    part_of_speech: "tính từ",
    meaning:
      "hèn và nhát (nói khái quát): kẻ hèn nhát * đồ hèn nhát, dám làm mà không dám chịu",
    example: "kẻ hèn nhát * đồ hèn nhát, dám làm mà không dám chịu",
  },
  {
    word: "hèn nào",
    part_of_speech: "kết từ",
    meaning:
      "tổ hợp biểu thị điều vừa nói đến là cái lẽ giải thích làm cho điều sắp nêu ra không đáng phải ngạc nhiên nữa: hấp tấp như thế, hèn nào chẳng hỏng việc",
    example: "hấp tấp như thế, hèn nào chẳng hỏng việc",
  },
  {
    word: "hèn kém",
    part_of_speech: "tính từ",
    meaning:
      "có khả năng và địa vị xã hội thấp, dưới mức bình thường: con nhà hèn kém",
    example: "con nhà hèn kém",
  },
  {
    word: "hẹn ước",
    part_of_speech: "động từ",
    meaning:
      '(văn chương) hẹn với nhau (nói về việc quan trọng): giữ lời hẹn ước * "Trăm năm hẹn ước một lời, Dầu cho biển cạn, non dời chẳng quên." (ca dao)',
    example:
      'giữ lời hẹn ước * "Trăm năm hẹn ước một lời, Dầu cho biển cạn, non dời chẳng quên." (ca dao)',
  },
  {
    word: "hèn yếu",
    part_of_speech: "tính từ",
    meaning:
      "kém cỏi cả về thể chất lẫn tinh thần, không đủ sức và khả năng để làm việc gì: kẻ tiểu nhân hèn yếu",
    example: "kẻ tiểu nhân hèn yếu",
  },
  {
    word: "hèo",
    part_of_speech: "danh từ",
    meaning:
      "cây thuộc họ dừa, thân thẳng và nhỏ như cây song, có nhiều đốt, thường dùng làm gậy.",
    example: "phết cho mấy hèo",
  },
  {
    word: "hen suyễn",
    part_of_speech: "danh từ",
    meaning: "hen (nói khái quát): lên cơn hen suyễn",
    example: "lên cơn hen suyễn",
  },
  {
    word: "heo",
    part_of_speech: "danh từ",
    meaning:
      "loài động vật có da màu hồng, đen hoặc nâu, chân ngắn có guốc, mũi rộng, đuôi xoắn. Lợn có thể được nuôi lấy thịt hoặc sống hoang dại trong rừng: thịt lợn * Thằng ấy ăn như lợn ý (= ăn rất nhiều)!",
    example: "thịt lợn * Thằng ấy ăn như lợn ý (= ăn rất nhiều)!",
  },
  {
    word: "héo don",
    part_of_speech: "tính từ",
    meaning:
      'héo quắt lại, không còn sức sống: bông hoa héo don * "(...) Thương ai nên mới lòng vàng héo don." (ca dao)',
    example:
      'bông hoa héo don * "(...) Thương ai nên mới lòng vàng héo don." (ca dao)',
  },
  {
    word: "héo",
    part_of_speech: "",
    meaning:
      "(cỏ cây, hoa lá) mềm rũ ra và tóp lại vì thiếu nước, vì nắng nóng: hoa héo * chợ trưa dưa héo (tng)",
    example: "hoa héo * chợ trưa dưa héo (tng)",
  },
  {
    word: "héo",
    part_of_speech: "",
    meaning:
      'ủ rũ, không tươi, không còn sức sống: mặt héo dàu dàu * "Sinh thì gan héo, ruột đầy, Nỗi lòng, càng nghĩ càng cay đắng lòng." (TKiều)',
    example:
      'mặt héo dàu dàu * "Sinh thì gan héo, ruột đầy, Nỗi lòng, càng nghĩ càng cay đắng lòng." (TKiều)',
  },
  {
    word: "héo",
    part_of_speech: "",
    meaning: "(Trang trọng) (người già yếu) chết: cha già, mẹ héo",
    example: "cha già, mẹ héo",
  },
  {
    word: "héo hắt",
    part_of_speech: "tính từ",
    meaning:
      "mất hết vẻ tươi, như bị khô kiệt sức sống: nụ cười héo hắt * người mỗi ngày một héo hắt",
    example: "nụ cười héo hắt * người mỗi ngày một héo hắt",
  },
  {
    word: "heo heo",
    part_of_speech: "tính từ",
    meaning:
      '(gió thổi) nhè nhẹ từng đợt ngắn và hơi se lạnh: "Bầm ơi có rét không bầm!, Heo heo gió núi, lâm thâm mưa phùn." (THữu; 7)',
    example:
      'Bầm ơi có rét không bầm!, Heo heo gió núi, lâm thâm mưa phùn." (THữu; 7)',
  },
  {
    word: "hẻo",
    part_of_speech: "tính từ",
    meaning: "(Phương ngữ, Khẩu ngữ) rất ít, thiếu, kém: hẻo vốn",
    example: "hẻo vốn",
  },
  {
    word: "heo hắt",
    part_of_speech: "tính từ",
    meaning: "như hiu hắt: hơi may heo hắt",
    example: "hơi may heo hắt",
  },
  {
    word: "heo héo",
    part_of_speech: "tính từ",
    meaning: "hơi héo: bông hoa đã heo héo",
    example: "bông hoa đã heo héo",
  },
  {
    word: "héo hon",
    part_of_speech: "tính từ",
    meaning:
      'mất dần đến hết vẻ tươi tắn, như bị cạn kiệt sức sống từ bên trong: "Ruột tằm, ngày một héo hon, Tuyết sương ngày một hao mòn hình ve." (TKiều)',
    example:
      'Ruột tằm, ngày một héo hon, Tuyết sương ngày một hao mòn hình ve." (TKiều)',
  },
  {
    word: "hẻo lánh",
    part_of_speech: "tính từ",
    meaning:
      "khuất nẻo và ít người qua lại: một làng quê hẻo lánh * sống ở một nơi hẻo lánh",
    example: "một làng quê hẻo lánh * sống ở một nơi hẻo lánh",
  },
  {
    word: "heo hút",
    part_of_speech: "tính từ",
    meaning:
      "(nơi) vắng và khuất, thiếu bóng người, gây cảm giác buồn, cô đơn: con đường rừng heo hút, không một bóng người",
    example: "con đường rừng heo hút, không một bóng người",
  },
  {
    word: "héo mòn",
    part_of_speech: "động từ",
    meaning: "héo hon và mòn mỏi: cơ thể ngày một héo mòn",
    example: "cơ thể ngày một héo mòn",
  },
  {
    word: "hẹp bụng",
    part_of_speech: "tính từ",
    meaning: "thiếu độ lượng trong cách đối xử, ăn ở: con người hẹp bụng",
    example: "con người hẹp bụng",
  },
  {
    word: "heo may",
    part_of_speech: "danh từ",
    meaning: "gió heo may (nói tắt): trời trở heo may",
    example: "trời trở heo may",
  },
  {
    word: "hẹp",
    part_of_speech: "tính từ",
    meaning:
      "có kích thước dưới mức trung bình hoặc mức yêu cầu, đặc biệt về bề ngang: lối đi hẹp * vải khổ hẹp * đất hẹp, người đông",
    example: "lối đi hẹp * vải khổ hẹp * đất hẹp, người đông",
  },
  {
    word: "hẹp",
    part_of_speech: "tính từ",
    meaning:
      "có phạm vi bị hạn chế trong một lĩnh vực, một bộ phận nào đó: lĩnh vực chuyên môn hẹp * phạm vi kiến thức còn hẹp * nói theo nghĩa hẹp",
    example:
      "lĩnh vực chuyên môn hẹp * phạm vi kiến thức còn hẹp * nói theo nghĩa hẹp",
  },
  {
    word: "hẹp",
    part_of_speech: "tính từ",
    meaning:
      "không rộng rãi và độ lượng trong cách đối xử, ăn ở: ăn ở hẹp với hàng xóm",
    example: "ăn ở hẹp với hàng xóm",
  },
  {
    word: "hẹp hòi",
    part_of_speech: "tính từ",
    meaning:
      'không rộng rãi, hay xét nét trong cách nhìn, cách đối xử, chỉ biết có mình hoặc bộ phận của mình: tư tưởng hẹp hòi * "Lượng xuân dù quyết hẹp hòi, Công đeo đuổi chẳng thiệt thòi lắm ru!" (TKiều)',
    example:
      'tư tưởng hẹp hòi * "Lượng xuân dù quyết hẹp hòi, Công đeo đuổi chẳng thiệt thòi lắm ru!" (TKiều)',
  },
  {
    word: "hét",
    part_of_speech: "động từ",
    meaning:
      "phát ra những tiếng rất to, hết sức mình, từ trong cổ họng: sướng quá, hét ầm lên * còi tàu hét vang",
    example: "sướng quá, hét ầm lên * còi tàu hét vang",
  },
  {
    word: "hễ",
    part_of_speech: "kết từ",
    meaning:
      'từ biểu thị vế điều kiện trong quan hệ giữa điều kiện và hệ quả, cứ mỗi khi có sự việc, hiện tượng này (thì tất yếu có sự việc, hiện tượng kia): hễ mưa là ngập * cứ hễ hỏi đến là gắt * "Mụ càng tô lục chuốt hồng, Máu tham hễ thấy hơi đồng thì mê." (TKiều)',
    example:
      'hễ mưa là ngập * cứ hễ hỏi đến là gắt * "Mụ càng tô lục chuốt hồng, Máu tham hễ thấy hơi đồng thì mê." (TKiều)',
  },
  {
    word: "hét lác",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) lớn tiếng trách mắng, nạt nộ (nói khái quát): suốt ngày hét lác con cái",
    example: "suốt ngày hét lác con cái",
  },
  {
    word: "hề",
    part_of_speech: "danh từ",
    meaning:
      "vai hài, chuyên biểu diễn để giễu cợt hoặc pha trò trên sân khấu, làm vui cho khán giả: hề chèo * diễn viên chuyên đóng các vai hề",
    example: "hề chèo * diễn viên chuyên đóng các vai hề",
  },
  {
    word: "hề",
    part_of_speech: "động từ",
    meaning:
      "có quan hệ trực tiếp làm chịu ảnh hưởng, chịu tác động: nhà bị cháy nhưng không ai hề gì",
    example: "nhà bị cháy nhưng không ai hề gì",
  },
  {
    word: "hề",
    part_of_speech: "trợ từ",
    meaning:
      "từ dùng để khẳng định ý phủ định về sự việc không bao giờ xảy ra hoặc để xảy ra: việc đó tôi không hề hay biết * chưa hề đến đó",
    example: "việc đó tôi không hề hay biết * chưa hề đến đó",
  },
  {
    word: "hê",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) vứt đi, ném tất cả đi một cách không thương tiếc: tức quá, hê cả mâm bát ra sân",
    example: "tức quá, hê cả mâm bát ra sân",
  },
  {
    word: "hệ",
    part_of_speech: "danh từ",
    meaning: "hệ thống (nói tắt): hệ tuần hoàn * hệ tiêu hoá * hệ tư tưởng",
    example: "hệ tuần hoàn * hệ tiêu hoá * hệ tư tưởng",
  },
  {
    word: "hề đồng",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) người đầy tớ trai còn nhỏ tuổi: "Hề đồng theo bốn năm thằng, Thơ ninh ních túi, rượu lưng lửng bầu." (NĐM)',
    example:
      'Hề đồng theo bốn năm thằng, Thơ ninh ních túi, rượu lưng lửng bầu." (NĐM)',
  },
  {
    word: "hề đồng",
    part_of_speech: "danh từ",
    meaning:
      "nhân vật đầy tớ, đồng thời là vai hề, trong tuồng, chèo, truyện cổ: đóng vai hề đồng",
    example: "đóng vai hề đồng",
  },
  {
    word: "hệ điều hành",
    part_of_speech: "danh từ",
    meaning:
      "phần mềm điều khiển chủ đạo để đưa một máy tính vào hoạt động, có tác dụng quản lí các chức năng bên trong của máy tính, và cung cấp những phương tiện để kiểm soát các hoạt động của nó: hệ điều hành Windows",
    example: "hệ điều hành Windows",
  },
  {
    word: "hể hả",
    part_of_speech: "",
    meaning:
      "vui vẻ biểu lộ ra bên ngoài vì được như ý: cười hể hả * trong lòng vô cùng hể hả",
    example: "cười hể hả * trong lòng vô cùng hể hả",
  },
  {
    word: "hệ luỵ",
    part_of_speech: "",
    meaning:
      "(hiếm) mối quan hệ ràng buộc và thường gây nên những nỗi phiền luỵ: giải thoát mình khỏi những hệ luỵ của cuộc đời",
    example: "giải thoát mình khỏi những hệ luỵ của cuộc đời",
  },
  {
    word: "hề hề",
    part_of_speech: "tính từ",
    meaning: "từ gợi tả tiếng cười với vẻ hiền lành, thật thà: cười hề hề",
    example: "cười hề hề",
  },
  {
    word: "hề hấn",
    part_of_speech: "động từ",
    meaning: "hề (nói khái quát): bị tai nạn nhưng người không hề hấn gì",
    example: "bị tai nạn nhưng người không hề hấn gì",
  },
  {
    word: "hệ miễn dịch",
    part_of_speech: "danh từ",
    meaning:
      "hệ thống các cơ quan có khả năng giúp cơ thể đề kháng được với một số bệnh: hệ miễn dịch của cơ thể * suy yếu hệ miễn dịch",
    example: "hệ miễn dịch của cơ thể * suy yếu hệ miễn dịch",
  },
  {
    word: "hệ quả",
    part_of_speech: "danh từ",
    meaning:
      "kết quả trực tiếp sinh ra từ sự việc nào đó (thường là việc không hay), trong quan hệ với sự việc ấy: một hệ quả tất yếu",
    example: "một hệ quả tất yếu",
  },
  {
    word: "hệ miễn nhiễm",
    part_of_speech: "danh từ",
    meaning:
      "hệ thống các cơ quan có khả năng giúp cơ thể đề kháng được với một số bệnh: hệ miễn dịch của cơ thể * suy yếu hệ miễn dịch",
    example: "hệ miễn dịch của cơ thể * suy yếu hệ miễn dịch",
  },
  {
    word: "hệ sinh thái",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp gồm các loài sinh vật (động vật, thực vật, vi sinh vật) cùng sinh sống trong một môi trường nhất định, về mặt các mối quan hệ tương tác giữa các loài sinh vật với nhau và với môi trường: tìm hiểu về hệ sinh thái rừng ngập mặn * hệ sinh thái nông nghiệp",
    example:
      "tìm hiểu về hệ sinh thái rừng ngập mặn * hệ sinh thái nông nghiệp",
  },
  {
    word: "hệ thống",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp nhiều yếu tố, đơn vị cùng loại hoặc cùng chức năng, có quan hệ hoặc liên hệ với nhau chặt chẽ, làm thành một thể thống nhất: hệ thống đèn giao thông * hệ thống tuần hoàn * hệ thống kiểm tra chất lượng sản phẩm",
    example:
      "hệ thống đèn giao thông * hệ thống tuần hoàn * hệ thống kiểm tra chất lượng sản phẩm",
  },
  {
    word: "hệ thống",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp những tư tưởng, nguyên tắc, quy tắc liên kết với nhau một cách logic, làm thành một thể thống nhất: hệ thống chính trị * hệ thống các phạm trù ngữ pháp",
    example: "hệ thống chính trị * hệ thống các phạm trù ngữ pháp",
  },
  {
    word: "hệ thống",
    part_of_speech: "danh từ",
    meaning:
      "phương pháp, cách thức phân loại, sắp xếp sao cho có trật tự logic: hệ thống phân loại thực vật",
    example: "hệ thống phân loại thực vật",
  },
  {
    word: "hệ thống",
    part_of_speech: "danh từ",
    meaning:
      "tính chất có trình tự, có quan hệ logic giữa các yếu tố: kiến thức thiếu hệ thống * sai lầm có hệ thống",
    example: "kiến thức thiếu hệ thống * sai lầm có hệ thống",
  },
  {
    word: "hệ thống",
    part_of_speech: "động từ",
    meaning: "hệ thống hoá (nói tắt): hệ thống lại toàn bộ những phần đã học",
    example: "hệ thống lại toàn bộ những phần đã học",
  },
  {
    word: "hệ số",
    part_of_speech: "danh từ",
    meaning:
      "số lượng nhân một số lượng khác: trong 4xy, 4 là hệ số của xy * tính lương theo hệ số",
    example: "trong 4xy, 4 là hệ số của xy * tính lương theo hệ số",
  },
  {
    word: "hệ số",
    part_of_speech: "danh từ",
    meaning:
      "số không thay đổi đối với một chất đã cho, dùng như một số nhân để đo sự thay đổi ở một tính chất nào đó của chất trong những điều kiện nhất định: hệ số dãn nở * hệ số an toàn",
    example: "hệ số dãn nở * hệ số an toàn",
  },
  {
    word: "hệ số",
    part_of_speech: "danh từ",
    meaning:
      "số được dùng để nhân với điểm của một môn thi, tuỳ theo tầm quan trọng của môn đó: môn năng khiếu có hệ số 2",
    example: "môn năng khiếu có hệ số 2",
  },
  {
    word: "hệ tộc",
    part_of_speech: "danh từ",
    meaning:
      "thứ tự liên hệ giữa các đời trong một dòng họ: mối quan hệ theo hệ tộc",
    example: "mối quan hệ theo hệ tộc",
  },
  {
    word: "hệ thống hoá",
    part_of_speech: "động từ",
    meaning:
      "làm cho trở nên có hệ thống: hệ thống hoá các vấn đề có liên quan",
    example: "hệ thống hoá các vấn đề có liên quan",
  },
  {
    word: "hệ trọng",
    part_of_speech: "tính từ",
    meaning:
      "có tác dụng và ảnh hưởng rất lớn; rất quan trọng: hôn nhân là việc hệ trọng * không có chuyện gì hệ trọng",
    example: "hôn nhân là việc hệ trọng * không có chuyện gì hệ trọng",
  },
  {
    word: "hếch",
    part_of_speech: "tính từ",
    meaning:
      "chếch lên phía trên (thường do ngắn và thiếu hụt đi một phần so với bình thường): mũi hếch * một bên vạt áo bị hếch * ống quần xắn hếch lên",
    example: "mũi hếch * một bên vạt áo bị hếch * ống quần xắn hếch lên",
  },
  {
    word: "hếch",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đưa chếch lên và hướng tới phía trước (thường nói về mắt, mặt): hếch mắt lên nhìn",
    example: "hếch mắt lên nhìn",
  },
  {
    word: "hên",
    part_of_speech: "",
    meaning: "(Phương ngữ) may, gặp vận đỏ: số hắn hên lắm! * gặp hên",
    example: "số hắn hên lắm! * gặp hên",
  },
  {
    word: "hệ tư tưởng",
    part_of_speech: "danh từ",
    meaning:
      "hệ thống tư tưởng và quan điểm, thường phản ánh quyền lợi cơ bản khác nhau của các giai cấp, các tầng lớp xã hội: hệ tư tưởng Hồ Chí Minh",
    example: "hệ tư tưởng Hồ Chí Minh",
  },
  {
    word: "hệch",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ, hiếm) há rộng quá mức, trông xấu (hàm ý chê): hệch mồm ra cười",
    example: "hệch mồm ra cười",
  },
  {
    word: "hểnh",
    part_of_speech: "danh từ",
    meaning:
      'tên gọi một con quái vật do dân gian bịa ra, thường là để doạ trẻ em: "Dạy con, con chẳng nghe lời, Con nghe ông hểnh đi đời nhà con." (ca dao)',
    example:
      'Dạy con, con chẳng nghe lời, Con nghe ông hểnh đi đời nhà con." (ca dao)',
  },
  {
    word: "hến",
    part_of_speech: "danh từ",
    meaning:
      "động vật cùng loại với trai nhưng cỡ nhỏ, vỏ cứng, hình tròn, sống ở đáy sông hồ, thịt ăn được: nấu canh hến * câm như hến",
    example: "nấu canh hến * câm như hến",
  },
  {
    word: "hênh hếch",
    part_of_speech: "tính từ",
    meaning: "hơi hếch: mũi hơi hênh hếch",
    example: "mũi hơi hênh hếch",
  },
  {
    word: "hềnh hệch",
    part_of_speech: "phụ từ",
    meaning:
      "(cách cười) to tiếng, rộng miệng, biểu lộ sự thích thú một cách tự nhiên: cười hềnh hệch",
    example: "cười hềnh hệch",
  },
  {
    word: "hết",
    part_of_speech: "động từ",
    meaning:
      "không còn nữa, sau một quá trình tiêu hao, mất dần: hết tiền * hết hạn sử dụng * súng hết đạn",
    example: "hết tiền * hết hạn sử dụng * súng hết đạn",
  },
  {
    word: "hết",
    part_of_speech: "động từ",
    meaning:
      "đạt đến mức trọn cả, không còn gì nữa trong phạm vi được nói đến: chưa nói hết câu * hết lòng vì bạn * cố gắng hết sức * lấy hết can đảm mới dám nói",
    example:
      "chưa nói hết câu * hết lòng vì bạn * cố gắng hết sức * lấy hết can đảm mới dám nói",
  },
  {
    word: "hết",
    part_of_speech: "động từ",
    meaning:
      "mất đi một khoản, một lượng (vào một việc nào đó): tiêu hết năm mươi nghìn * đi hết nửa ngày đường",
    example: "tiêu hết năm mươi nghìn * đi hết nửa ngày đường",
  },
  {
    word: "hết",
    part_of_speech: "phụ từ",
    meaning:
      'từ biểu thị ý kết thúc, không còn tiếp tục, tiếp diễn hay tồn tại một hoạt động, trạng thái, tính chất nào đó: trời hết mưa * hết giận * "Còn duyên kẻ đón người đưa, Hết duyên đi sớm về trưa mặc lòng." (ca dao)',
    example:
      'trời hết mưa * hết giận * "Còn duyên kẻ đón người đưa, Hết duyên đi sớm về trưa mặc lòng." (ca dao)',
  },
  {
    word: "hết",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý nhấn mạnh về phạm vi không hạn chế của điều vừa phủ định: không có đi đâu hết! * chẳng làm sao hết! * không còn gì nữa hết!",
    example:
      "không có đi đâu hết! * chẳng làm sao hết! * không còn gì nữa hết!",
  },
  {
    word: "hết dạ",
    part_of_speech: "",
    meaning: "như hết lòng: hết dạ yêu thương",
    example: "hết dạ yêu thương",
  },
  {
    word: "hết biết",
    part_of_speech: "",
    meaning:
      "(phương ngữ, khẩu ngữ) không thể hiểu nổi, không thể làm gì được: bệnh tình của cô ta kì hết biết!",
    example: "bệnh tình của cô ta kì hết biết!",
  },
  {
    word: "hệt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) giống đến mức trông không khác một chút nào: thằng bé hệt như cha nó",
    example: "thằng bé hệt như cha nó",
  },
  {
    word: "hết chỗ nói",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) hết mức, không còn có thể hơn được nữa: dại hết chỗ nói * mừng hết chỗ nói",
    example: "dại hết chỗ nói * mừng hết chỗ nói",
  },
  {
    word: "hết hồn",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) sợ quá, đến mức mất hết tinh thần, mất hết hồn vía: sợ hết hồn",
    example: "sợ hết hồn",
  },
  {
    word: "hết đất",
    part_of_speech: "",
    meaning:
      '(khẩu ngữ) chỉ đến thế là cao nhất, không thể hơn được nữa: "Đong chịu thì chỉ có đong đến năm hào là hết đất. Ai bán cho mình hơn?" (NCao; 30)',
    example:
      'Đong chịu thì chỉ có đong đến năm hào là hết đất. Ai bán cho mình hơn?" (NCao; 30)',
  },
  {
    word: "hết hồn hết vía",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) như hết hồn (nhưng ý nhấn mạnh hơn): bị một phen hết hồn hết vía",
    example: "bị một phen hết hồn hết vía",
  },
  {
    word: "hết đời",
    part_of_speech: "động từ",
    meaning: "(thông tục) chết một cách đáng đời: hết đời tên bạo chúa",
    example: "hết đời tên bạo chúa",
  },
  {
    word: "hết hơi",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) không còn chút hơi sức nào (vì mệt quá): chạy hết hơi vẫn không kịp * việc này có xong thì cũng hết hơi!",
    example: "chạy hết hơi vẫn không kịp * việc này có xong thì cũng hết hơi!",
  },
  {
    word: "hết lời",
    part_of_speech: "",
    meaning:
      "nói đủ mọi lí lẽ, đủ mọi khía cạnh để thuyết phục: khen hết lời * hết lời khuyên can",
    example: "khen hết lời * hết lời khuyên can",
  },
  {
    word: "hết mực",
    part_of_speech: "phụ từ",
    meaning:
      "đến mức cao nhất, không thể hơn được nữa: hết mực yêu thương con cái * hết mực giản dị",
    example: "hết mực yêu thương con cái * hết mực giản dị",
  },
  {
    word: "hết lẽ",
    part_of_speech: "",
    meaning:
      "(nói) hết mọi lí, mọi lẽ, thường để thuyết phục: khuyên giải hết lẽ * viện hết lẽ để từ chối",
    example: "khuyên giải hết lẽ * viện hết lẽ để từ chối",
  },
  {
    word: "hết mức",
    part_of_speech: "phụ từ",
    meaning: "như hết mực: cưng chiều con hết mức",
    example: "cưng chiều con hết mức",
  },
  {
    word: "hết lòng",
    part_of_speech: "",
    meaning:
      "(làm việc gì) với tất cả khả năng và sự nhiệt tình: hết lòng phụng dưỡng mẹ già * hết lòng vì dân vì nước",
    example: "hết lòng phụng dưỡng mẹ già * hết lòng vì dân vì nước",
  },
  {
    word: "hết mình",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) (làm việc gì) hết sức mình, bằng tất cả khả năng của mình: làm việc hết mình * hết mình vì bạn bè",
    example: "làm việc hết mình * hết mình vì bạn bè",
  },
  {
    word: "hết nhẵn",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) hết tất cả, như bị vét đến không còn một tí nào: hết nhẵn cả tiền * nồi cơm đã hết nhẵn",
    example: "hết nhẵn cả tiền * nồi cơm đã hết nhẵn",
  },
  {
    word: "hết nổi",
    part_of_speech: "phụ từ",
    meaning:
      "(phương ngữ, khẩu ngữ) đến mức không thể tiếp tục hoặc không thể chịu đựng hơn được nữa: sốt ruột, chịu hết nổi",
    example: "sốt ruột, chịu hết nổi",
  },
  {
    word: "hết sảy",
    part_of_speech: "phụ từ",
    meaning: "(phương ngữ, khẩu ngữ) như hết ý: đẹp hết sảy",
    example: "đẹp hết sảy",
  },
  {
    word: "hết nước hết cái",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) (làm việc gì) đến cùng rồi, không thể làm hơn được nữa: nói hết nước hết cái mà vẫn không chịu nghe",
    example: "nói hết nước hết cái mà vẫn không chịu nghe",
  },
  {
    word: "hết vía",
    part_of_speech: "động từ",
    meaning: "như hết hồn: sợ hết vía",
    example: "sợ hết vía",
  },
  {
    word: "hết sức",
    part_of_speech: "phụ từ",
    meaning:
      "đến mức cao nhất, không thể hơn được nữa: công việc hết sức khó khăn * phải hết sức thận trọng",
    example: "công việc hết sức khó khăn * phải hết sức thận trọng",
  },
  {
    word: "hết nước",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) đủ hết mọi cách, mọi khả năng, không thể có cách nào khác nữa: nói hết nước mà nó vẫn không chịu * nghĩ hết nước mà vẫn chưa ra",
    example: "nói hết nước mà nó vẫn không chịu * nghĩ hết nước mà vẫn chưa ra",
  },
  {
    word: "hết nước",
    part_of_speech: "phụ từ",
    meaning: "quá lắm, không còn có thể hơn được nữa: thật là độc ác hết nước",
    example: "thật là độc ác hết nước",
  },
  {
    word: "hết sẩy",
    part_of_speech: "phụ từ",
    meaning: "(phương ngữ, khẩu ngữ) như hết ý: đẹp hết sảy",
    example: "đẹp hết sảy",
  },
  {
    word: "hết thảy",
    part_of_speech: "đại từ",
    meaning:
      "tất cả, không trừ một ai hoặc một bộ phận nào: hết thảy mọi người * đồ đạc đã bị bán đi hết thảy",
    example: "hết thảy mọi người * đồ đạc đã bị bán đi hết thảy",
  },
  {
    word: "hết ý",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) đến mức không thể hơn được nữa, không thể chê điểm nào được nữa: ngon hết ý * được chiều chuộng hết ý",
    example: "ngon hết ý * được chiều chuộng hết ý",
  },
  {
    word: "hỉ",
    part_of_speech: "động từ",
    meaning:
      "thở hắt mạnh ra đằng mũi để đẩy nước mũi hoặc chất bẩn trong mũi ra ngoài: hỉ mũi",
    example: "hỉ mũi",
  },
  {
    word: "hỉ",
    part_of_speech: "danh từ",
    meaning:
      "việc vui, mừng (thường là việc cưới xin): việc hiếu, việc hỉ * giấy báo hỉ",
    example: "việc hiếu, việc hỉ * giấy báo hỉ",
  },
  {
    word: "hỉ",
    part_of_speech: "trợ từ",
    meaning: "(Phương ngữ) như hả (ng2): ai đó hỉ? * răng mi biết hỉ?",
    example: "ai đó hỉ? * răng mi biết hỉ?",
  },
  {
    word: "hỉ",
    part_of_speech: "trợ từ",
    meaning: "như nhỉ: sao lại như thế hỉ?",
    example: "sao lại như thế hỉ?",
  },
  {
    word: "hì",
    part_of_speech: "tính từ",
    meaning: "từ mô phỏng tiếng cười phát ra đằng mũi: cười hì hì",
    example: "cười hì hì",
  },
  {
    word: "hí",
    part_of_speech: "động từ",
    meaning: "(ngựa) kêu: tiếng ngựa hí",
    example: "tiếng ngựa hí",
  },
  {
    word: "hỉ hả",
    part_of_speech: "",
    meaning: "như hể hả: vui sướng hỉ hả",
    example: "vui sướng hỉ hả",
  },
  {
    word: "hí hoạ",
    part_of_speech: "danh từ",
    meaning: "tranh hài hước hoặc châm biếm: chuyên vẽ hí hoạ * bức hí hoạ",
    example: "chuyên vẽ hí hoạ * bức hí hoạ",
  },
  {
    word: "hí hởn",
    part_of_speech: "",
    meaning: "(phương ngữ): hí hởn mừng thầm",
    example: "hí hởn mừng thầm",
  },
  {
    word: "hi hóp",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) (thở) vẻ mệt nhọc, yếu ớt như sắp hết hơi: mệt quá, thở hi hóp",
    example: "mệt quá, thở hi hóp",
  },
  {
    word: "hí hoáy",
    part_of_speech: "động từ",
    meaning:
      "từ gợi tả dáng vẻ chăm chú làm việc gì luôn tay: hí hoáy ghi chép * hí hoáy chêm lại cái cuốc",
    example: "hí hoáy ghi chép * hí hoáy chêm lại cái cuốc",
  },
  {
    word: "hi hi",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) từ mô phỏng tiếng cười hoặc tiếng khóc nhỏ, liên tiếp: khóc hi hi",
    example: "khóc hi hi",
  },
  {
    word: "hì hụi",
    part_of_speech: "động từ",
    meaning:
      "từ gợi tả dáng vẻ cặm cụi làm việc gì một cách khó nhọc, kiên nhẫn: hì hụi đào xới",
    example: "hì hụi đào xới",
  },
  {
    word: "hì hục",
    part_of_speech: "",
    meaning:
      "từ gợi tả dáng vẻ cặm cụi làm việc gì một cách vất vả: hì hục tô đi vẽ lại * làm hì hục từ sáng đến chiều",
    example: "hì hục tô đi vẽ lại * làm hì hục từ sáng đến chiều",
  },
  {
    word: "hí húi",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) từ gợi tả dáng vẻ hơi cúi xuống, chăm chú làm việc gì: hí húi ghi chép * hí húi cả buổi với chiếc xe đạp hỏng",
    example: "hí húi ghi chép * hí húi cả buổi với chiếc xe đạp hỏng",
  },
  {
    word: "hí hửng",
    part_of_speech: "",
    meaning:
      '(vẻ mặt) vui sướng, thích thú quá mức trước việc đã làm được hoặc tin rằng sẽ làm được: "Nạ dòng vớ được trai tơ, Đêm nằm hí hửng như mơ được vàng." (ca dao)',
    example:
      'Nạ dòng vớ được trai tơ, Đêm nằm hí hửng như mơ được vàng." (ca dao)',
  },
  {
    word: "hì hụp",
    part_of_speech: "động từ",
    meaning: "lặn xuống rồi lại ngoi lên nhiều lần: hì hụp dưới ao",
    example: "hì hụp dưới ao",
  },
  {
    word: "hỉ mũi chưa sạch",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) như vắt mũi chưa sạch: hỉ mũi chưa sạch mà dám lên mặt dạy đời!",
    example: "hỉ mũi chưa sạch mà dám lên mặt dạy đời!",
  },
  {
    word: "hi sinh",
    part_of_speech: "động từ",
    meaning:
      "tự nguyện nhận về mình sự thiệt thòi, mất mát lớn lao nào đó, vì một cái gì cao đẹp: hi sinh lợi ích cá nhân * hi sinh cả tuổi xuân cho đất nước",
    example: "hi sinh lợi ích cá nhân * hi sinh cả tuổi xuân cho đất nước",
  },
  {
    word: "hi sinh",
    part_of_speech: "động từ",
    meaning:
      "chết vì đất nước, vì nghĩa vụ và lí tưởng cao đẹp: hi sinh ngoài chiến trường",
    example: "hi sinh ngoài chiến trường",
  },
  {
    word: "hi sinh",
    part_of_speech: "danh từ",
    meaning: "sự hi sinh: chấp nhận mọi hi sinh",
    example: "chấp nhận mọi hi sinh",
  },
  {
    word: "hi hữu",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) hiếm có, hiếm thấy: một trường hợp hi hữu * hi hữu lắm mới có chuyện đó xảy ra",
    example: "một trường hợp hi hữu * hi hữu lắm mới có chuyện đó xảy ra",
  },
  {
    word: "hi vọng",
    part_of_speech: "động từ",
    meaning:
      "tin tưởng và mong chờ điều tốt đẹp đến: hi vọng có ngày gặp lại * hi vọng nhiều ở thế hệ trẻ",
    example: "hi vọng có ngày gặp lại * hi vọng nhiều ở thế hệ trẻ",
  },
  {
    word: "hi vọng",
    part_of_speech: "danh từ",
    meaning: "niềm hi vọng: nuôi hi vọng * lòng tràn trề hi vọng",
    example: "nuôi hi vọng * lòng tràn trề hi vọng",
  },
  {
    word: "hỉ xả",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) quên mình đi một cách vui vẻ, theo quan niệm của đạo Phật: lòng từ bi hỉ xả",
    example: "lòng từ bi hỉ xả",
  },
  {
    word: "hỉ xả",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) vui lòng bỏ qua, vui lòng tha thứ: cháu nó đã biết lỗi, mong bác hỉ xả cho",
    example: "cháu nó đã biết lỗi, mong bác hỉ xả cho",
  },
  {
    word: "hích",
    part_of_speech: "động từ",
    meaning:
      "áp sát một bộ phận cơ thể vào, rồi dùng sức hất hoặc đẩy mạnh: hích nhẹ khuỷu tay vào sườn bạn * bọn trẻ hích nhau, tranh lên trước",
    example:
      "hích nhẹ khuỷu tay vào sườn bạn * bọn trẻ hích nhau, tranh lên trước",
  },
  {
    word: "hích",
    part_of_speech: "động từ",
    meaning: "(hiếm) như khích: hích cho hai bên cãi nhau",
    example: "hích cho hai bên cãi nhau",
  },
  {
    word: "hịch",
    part_of_speech: "danh từ",
    meaning:
      "lời kêu gọi tướng sĩ hay nhân dân đứng dậy đấu tranh vì mục đích thiêng liêng, như chống ngoại xâm bảo vệ tổ quốc: bài  *  của Trần Hưng Đạo",
    example: "bài  *  của Trần Hưng Đạo",
  },
  {
    word: "hiềm",
    part_of_speech: "động từ",
    meaning:
      'còn có điều đáng phàn nàn, không được như ý: "Đôi ta như vợ với chồng, Chỉ hiềm một nỗi ông Tơ Hồng chưa xe." (ca dao)',
    example:
      'Đôi ta như vợ với chồng, Chỉ hiềm một nỗi ông Tơ Hồng chưa xe." (ca dao)',
  },
  {
    word: "hi-fi",
    part_of_speech: "danh từ",
    meaning:
      "(A: high-fidelity, viết tắt) thiết bị để phát lại âm thanh (qua thiết bị nghe nhìn) có độ trung thực cao, không làm méo mó âm thanh gốc: dàn âm thanh hi-fi",
    example: "dàn âm thanh hi-fi",
  },
  {
    word: "hiếm",
    part_of_speech: "tính từ",
    meaning:
      'rất ít có, rất ít xảy ra: dịp may hiếm có * rất hiếm khi ở nhà * "Nổi danh tài sắc một thì, Xôn xao ngoài cửa hiếm gì yến anh." (TKiều)',
    example:
      'dịp may hiếm có * rất hiếm khi ở nhà * "Nổi danh tài sắc một thì, Xôn xao ngoài cửa hiếm gì yến anh." (TKiều)',
  },
  {
    word: "hiểm hoạ",
    part_of_speech: "danh từ",
    meaning:
      "tai hoạ lớn, gây nguy hại sâu sắc đối với đời sống của con người: hiểm hoạ chiến tranh",
    example: "hiểm hoạ chiến tranh",
  },
  {
    word: "hiểm độc",
    part_of_speech: "tính từ",
    meaning: "ác một cách thâm độc: tâm địa hiểm độc",
    example: "tâm địa hiểm độc",
  },
  {
    word: "hiếm hoi",
    part_of_speech: "tính từ",
    meaning:
      "(người lập gia đình đã lâu) hiếm con hoặc mãi chưa có con: vợ chồng hiếm hoi chỉ có một mụn con",
    example: "vợ chồng hiếm hoi chỉ có một mụn con",
  },
  {
    word: "hiếm hoi",
    part_of_speech: "tính từ",
    meaning: "hiếm có: giọt mưa hiếm hoi giữa những ngày hạn",
    example: "giọt mưa hiếm hoi giữa những ngày hạn",
  },
  {
    word: "hiểm",
    part_of_speech: "tính từ",
    meaning:
      "có địa hình dễ gây tai nạn cho người đi lại: đường hiểm * hang sâu núi hiểm",
    example: "đường hiểm * hang sâu núi hiểm",
  },
  {
    word: "hiểm",
    part_of_speech: "tính từ",
    meaning:
      "ở vị trí mà nếu bị tổn thương thì dễ ảnh hưởng nghiêm trọng một cách khó lường đến toàn bộ, toàn cục: đánh trúng chỗ hiểm",
    example: "đánh trúng chỗ hiểm",
  },
  {
    word: "hiểm",
    part_of_speech: "tính từ",
    meaning:
      "thường gây nguy hại một cách khó lường: cửa thoát hiểm * ngón đòn hiểm",
    example: "cửa thoát hiểm * ngón đòn hiểm",
  },
  {
    word: "hiểm ác",
    part_of_speech: "tính từ",
    meaning: "như ác hiểm: ngón đòn hiểm ác",
    example: "ngón đòn hiểm ác",
  },
  {
    word: "hiểm hóc",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều yếu tố lắt léo, phức tạp, dễ gây ra những khó khăn trở ngại không lường hết được: hỏi những câu hiểm hóc",
    example: "hỏi những câu hiểm hóc",
  },
  {
    word: "hiểm hóc",
    part_of_speech: "tính từ",
    meaning: "(hiếm) có nhiều âm mưu, thủ đoạn khó lường: tâm địa hiểm hóc",
    example: "tâm địa hiểm hóc",
  },
  {
    word: "hiếm muộn",
    part_of_speech: "tính từ",
    meaning:
      "(người lập gia đình đã lâu) khó có con hoặc muộn có con: cảnh hiếm muộn",
    example: "cảnh hiếm muộn",
  },
  {
    word: "hiềm khích",
    part_of_speech: "",
    meaning:
      "thù ghét nhau một cách sâu sắc: hai bên hiềm khích nhau * gây ra hiềm khích",
    example: "hai bên hiềm khích nhau * gây ra hiềm khích",
  },
  {
    word: "hiểm nghèo",
    part_of_speech: "tính từ",
    meaning:
      "rất nguy hiểm, khó lòng thoát khỏi tai hoạ: căn bệnh hiểm nghèo * qua cơn hiểm nghèo",
    example: "căn bệnh hiểm nghèo * qua cơn hiểm nghèo",
  },
  {
    word: "hiềm nghi",
    part_of_speech: "động từ",
    meaning: "nghi ngờ: xoá bỏ mối hiềm nghi",
    example: "xoá bỏ mối hiềm nghi",
  },
  {
    word: "hiềm oán",
    part_of_speech: "động từ",
    meaning: "(cũ, hiếm) như oán: có lòng hiềm oán",
    example: "có lòng hiềm oán",
  },
  {
    word: "hiểm sâu",
    part_of_speech: "tính từ",
    meaning: "như thâm hiểm: lòng dạ hiểm sâu",
    example: "lòng dạ hiểm sâu",
  },
  {
    word: "hiềm thù",
    part_of_speech: "",
    meaning:
      "thù hằn lâu ngày, sâu sắc: hai người hiềm thù nhau * gây hiềm thù giữa các dân tộc",
    example: "hai người hiềm thù nhau * gây hiềm thù giữa các dân tộc",
  },
  {
    word: "hiểm yếu",
    part_of_speech: "tính từ",
    meaning:
      "ở vị trí hết sức quan trọng, có tầm ảnh hưởng, chi phối đối với toàn bộ, toàn cục: trục giao thông hiểm yếu",
    example: "trục giao thông hiểm yếu",
  },
  {
    word: "hiểm nguy",
    part_of_speech: "tính từ",
    meaning: "như nguy hiểm: thoát vòng hiểm nguy",
    example: "thoát vòng hiểm nguy",
  },
  {
    word: "hiểm trở",
    part_of_speech: "tính từ",
    meaning:
      "có địa hình không thuận lợi cho việc đi lại, dễ xảy ra tai nạn: đường đi hiểm trở",
    example: "đường đi hiểm trở",
  },
  {
    word: "hiên",
    part_of_speech: "danh từ",
    meaning:
      'dải nền có mái che, ở trước hoặc quanh nhà: "Nỉ non đêm ngắn tình dài, Ngoài hiên thỏ đã non đoài ngậm gương." (TKiều)',
    example:
      'Nỉ non đêm ngắn tình dài, Ngoài hiên thỏ đã non đoài ngậm gương." (TKiều)',
  },
  {
    word: "hiền",
    part_of_speech: "tính từ",
    meaning:
      "không dữ, không có những hành động, những tác động gây hại cho người khác, gây cảm giác dễ chịu, không phải ngại, phải sợ khi tiếp xúc: tính chị ấy rất hiền * hiền như bụt * ở hiền gặp lành (tng)",
    example: "tính chị ấy rất hiền * hiền như bụt * ở hiền gặp lành (tng)",
  },
  {
    word: "hiền",
    part_of_speech: "tính từ",
    meaning:
      "tốt, ăn ở phải đạo, hết lòng làm tròn bổn phận của mình đối với người khác: dâu hiền * bạn hiền",
    example: "dâu hiền * bạn hiền",
  },
  {
    word: "hiền",
    part_of_speech: "tính từ",
    meaning:
      "hoặc d (cũ) có đức lớn, tài cao, theo quan niệm thời trước: chiêu hiền đãi sĩ * biết trọng người hiền",
    example: "chiêu hiền đãi sĩ * biết trọng người hiền",
  },
  {
    word: "hiến",
    part_of_speech: "động từ",
    meaning:
      "cho, dâng thứ quý giá của mình một cách tự nguyện: hiến máu nhân đạo * hiến mình cho sự nghiệp cách mạng",
    example: "hiến máu nhân đạo * hiến mình cho sự nghiệp cách mạng",
  },
  {
    word: "hiến chương",
    part_of_speech: "danh từ",
    meaning:
      "điều kí kết giữa nhiều nước, quy định những nguyên tắc và thể lệ chung trong quan hệ quốc tế: hiến chương Liên Hợp Quốc",
    example: "hiến chương Liên Hợp Quốc",
  },
  {
    word: "hiện",
    part_of_speech: "danh từ",
    meaning:
      "thời điểm người nói đang nói: hiện anh ấy đang đi vắng * hiện sách đã có bán tại các nhà sách",
    example: "hiện anh ấy đang đi vắng * hiện sách đã có bán tại các nhà sách",
  },
  {
    word: "hiện",
    part_of_speech: "động từ",
    meaning:
      "trở nên có thể nhìn thấy được: mặt trăng lúc ẩn lúc hiện * kỉ niệm cũ như hiện ra trước mắt",
    example: "mặt trăng lúc ẩn lúc hiện * kỉ niệm cũ như hiện ra trước mắt",
  },
  {
    word: "hiến dâng",
    part_of_speech: "động từ",
    meaning:
      "dâng thứ quý giá của mình một cách cung kính, trân trọng: hiến dâng cuộc đời cho sự nghiệp giải phóng dân tộc",
    example: "hiến dâng cuộc đời cho sự nghiệp giải phóng dân tộc",
  },
  {
    word: "hiện ảnh",
    part_of_speech: "động từ",
    meaning:
      "(ma quỷ, thần linh) hiện ra cho thấy, theo mê tín: ma quỷ hiện hình",
    example: "ma quỷ hiện hình",
  },
  {
    word: "hiện ảnh",
    part_of_speech: "động từ",
    meaning:
      "làm cho ảnh hiện rõ trên phim hay giấy ảnh bằng cách xử lí các dung dịch hoá chất trong quá trình tráng phim: thuốc hiện hình",
    example: "thuốc hiện hình",
  },
  {
    word: "hiến binh",
    part_of_speech: "danh từ",
    meaning: "cảnh sát vũ trang trong quân đội của một số nước: đội hiến binh",
    example: "đội hiến binh",
  },
  {
    word: "hiện diện",
    part_of_speech: "động từ",
    meaning: "(trang trọng) có mặt: cuộc họp có sự hiện diện của thủ tướng",
    example: "cuộc họp có sự hiện diện của thủ tướng",
  },
  {
    word: "hiển đạt",
    part_of_speech: "động từ",
    meaning:
      "(cũ, văn chương) làm nên công danh, sự nghiệp, có địa vị xã hội cao: công danh hiển đạt",
    example: "công danh hiển đạt",
  },
  {
    word: "hiện đại hoá",
    part_of_speech: "động từ",
    meaning: "làm cho mang tính chất của thời đại mới: hiện đại hoá vở chèo cổ",
    example: "hiện đại hoá vở chèo cổ",
  },
  {
    word: "hiện đại hoá",
    part_of_speech: "động từ",
    meaning:
      "làm cho trở thành có đầy đủ mọi trang bị, thiết bị của nền công nghiệp hiện đại: công nghiệp hoá, hiện đại hoá đất nước * hiện đại hoá nông thôn",
    example: "công nghiệp hoá, hiện đại hoá đất nước * hiện đại hoá nông thôn",
  },
  {
    word: "hiền dịu",
    part_of_speech: "tính từ",
    meaning: "như dịu hiền: một cô gái hiền dịu * ánh mắt hiền dịu",
    example: "một cô gái hiền dịu * ánh mắt hiền dịu",
  },
  {
    word: "hiện đại",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về thời đại ngày nay: nền văn học hiện đại * giai đoạn cận hiện đại và hiện đại",
    example: "nền văn học hiện đại * giai đoạn cận hiện đại và hiện đại",
  },
  {
    word: "hiện đại",
    part_of_speech: "tính từ",
    meaning:
      "có áp dụng những phát minh, những thành tựu mới nhất của khoa học, kĩ thuật; đối lập với cổ điển: máy móc hiện đại * toà nhà sang trọng và hiện đại",
    example: "máy móc hiện đại * toà nhà sang trọng và hiện đại",
  },
  {
    word: "hiền đức",
    part_of_speech: "tính từ",
    meaning:
      "phúc hậu, hay thương người (thường dùng để nói về người phụ nữ): người phụ nữ hiền đức",
    example: "người phụ nữ hiền đức",
  },
  {
    word: "hiện giờ",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) thời gian hiện đang nói: hiện giờ mọi người đang bận",
    example: "hiện giờ mọi người đang bận",
  },
  {
    word: "hiền hậu",
    part_of_speech: "tính từ",
    meaning:
      "hiền lành và nhân hậu: khuôn mặt hiền hậu * tính tình hiền hậu, nết na",
    example: "khuôn mặt hiền hậu * tính tình hiền hậu, nết na",
  },
  {
    word: "hiện hành",
    part_of_speech: "tính từ",
    meaning:
      "đang được thi hành, đang có hiệu lực: quy định hiện hành * xử lí theo pháp luật hiện hành",
    example: "quy định hiện hành * xử lí theo pháp luật hiện hành",
  },
  {
    word: "hiện hành",
    part_of_speech: "tính từ",
    meaning: "(hiếm) đang được lưu hành: bản dịch hiện hành",
    example: "bản dịch hiện hành",
  },
  {
    word: "hiển hiện",
    part_of_speech: "động từ",
    meaning:
      "hiện ra rõ ràng trước mắt: kí ức tuổi thơ hiển hiện trước mắt anh",
    example: "kí ức tuổi thơ hiển hiện trước mắt anh",
  },
  {
    word: "hiển hách",
    part_of_speech: "tính từ",
    meaning: "rực rỡ và lừng lẫy: chiến công hiển hách * uy quyền hiển hách",
    example: "chiến công hiển hách * uy quyền hiển hách",
  },
  {
    word: "hiền hoà",
    part_of_speech: "tính từ",
    meaning:
      "hiền lành và ôn hoà (nói khái quát): tính khí hiền hoà * thiên nhiên ở đây rất mực hiền hoà",
    example: "tính khí hiền hoà * thiên nhiên ở đây rất mực hiền hoà",
  },
  {
    word: "hiện hình",
    part_of_speech: "động từ",
    meaning:
      "(ma quỷ, thần linh) hiện ra cho thấy, theo mê tín: ma quỷ hiện hình",
    example: "ma quỷ hiện hình",
  },
  {
    word: "hiện hình",
    part_of_speech: "động từ",
    meaning:
      "làm cho ảnh hiện rõ trên phim hay giấy ảnh bằng cách xử lí các dung dịch hoá chất trong quá trình tráng phim: thuốc hiện hình",
    example: "thuốc hiện hình",
  },
  {
    word: "hiện hữu",
    part_of_speech: "động từ",
    meaning: "đang có, đang tồn tại: tài sản hiện hữu",
    example: "tài sản hiện hữu",
  },
  {
    word: "hiền khô",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) rất hiền, biểu lộ rõ trên nét mặt một cách chân thật: nụ cười hiền khô * nét mặt hiền khô",
    example: "nụ cười hiền khô * nét mặt hiền khô",
  },
  {
    word: "hiến kế",
    part_of_speech: "động từ",
    meaning:
      "đưa ra kế sách hay để giúp cho người bề trên có cách giải quyết việc lớn nào đó: Nguyễn Trãi hiến kế giúp Lê Lợi dẹp giặc",
    example: "Nguyễn Trãi hiến kế giúp Lê Lợi dẹp giặc",
  },
  {
    word: "hiển linh",
    part_of_speech: "động từ",
    meaning:
      "(thần thánh) hiện ra một cách linh thiêng, theo quan niệm của người xưa: thần làng hiển linh",
    example: "thần làng hiển linh",
  },
  {
    word: "hiên ngang",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra đàng hoàng, tự tin, không chịu cúi đầu khuất phục trước những sự đe doạ: khí phách hiên ngang * tư thế hiên ngang",
    example: "khí phách hiên ngang * tư thế hiên ngang",
  },
  {
    word: "hiền lương",
    part_of_speech: "tính từ",
    meaning: "(cũ) hiền lành và lương thiện: con người hiền lương",
    example: "con người hiền lương",
  },
  {
    word: "hiện kim",
    part_of_speech: "danh từ",
    meaning: "tiền đang lưu hành: thanh toán bằng hiện kim",
    example: "thanh toán bằng hiện kim",
  },
  {
    word: "hiền lành",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra rất hiền và tốt bụng, không hề có những hành động gây hại cho bất kì ai: ăn ở hiền lành * tính tình hiền lành",
    example: "ăn ở hiền lành * tính tình hiền lành",
  },
  {
    word: "hiện nay",
    part_of_speech: "danh từ",
    meaning:
      "thời gian hiện tại: hiện nay ông ấy đã nghỉ hưu * tình hình hiện nay đã đổi khác",
    example: "hiện nay ông ấy đã nghỉ hưu * tình hình hiện nay đã đổi khác",
  },
  {
    word: "hiển nhiên",
    part_of_speech: "tính từ",
    meaning:
      "quá rõ ràng, không còn gì để nghi ngờ: sự thật hiển nhiên * chứng cớ hiển nhiên",
    example: "sự thật hiển nhiên * chứng cớ hiển nhiên",
  },
  {
    word: "hiền thảo",
    part_of_speech: "tính từ",
    meaning:
      "(người phụ nữ) tốt, ăn ở phải đạo với cha mẹ, với người bậc trên trong gia đình: người con dâu hiền thảo",
    example: "người con dâu hiền thảo",
  },
  {
    word: "hiện tại",
    part_of_speech: "danh từ",
    meaning:
      "thời gian đang diễn ra; đối lập với quá khứ và tương lai: bằng lòng với cuộc sống hiện tại * hiện tại anh ta vẫn làm việc ở xưởng in",
    example:
      "bằng lòng với cuộc sống hiện tại * hiện tại anh ta vẫn làm việc ở xưởng in",
  },
  {
    word: "hiền tài",
    part_of_speech: "",
    meaning:
      "(người) có đức, có tài vượt trội: hiền tài là nguyên khí của quốc gia",
    example: "hiền tài là nguyên khí của quốc gia",
  },
  {
    word: "hiện thân",
    part_of_speech: "động từ",
    meaning:
      "(thần linh) hiện ra thành người hoặc động vật cụ thể, theo tín ngưỡng tôn giáo: Bồ Tát hiện thân thành ông lão ăn xin",
    example: "Bồ Tát hiện thân thành ông lão ăn xin",
  },
  {
    word: "hiện thân",
    part_of_speech: "danh từ",
    meaning:
      "người hoặc động vật cụ thể mà thần linh qua đó hiện ra: con rùa là hiện thân của thần biển",
    example: "con rùa là hiện thân của thần biển",
  },
  {
    word: "hiện thân",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương) người được coi là biểu hiện cụ thể của một điều gì: hiện thân của lòng bác ái",
    example: "hiện thân của lòng bác ái",
  },
  {
    word: "hiển thị",
    part_of_speech: "động từ",
    meaning:
      "làm cho hiện rõ ra, bày ra cho thấy (thường nói về việc ghi kết quả xử lí thông tin lên màn hình máy tính): đoạn văn bản hiển thị trên màn hình",
    example: "đoạn văn bản hiển thị trên màn hình",
  },
  {
    word: "bát âm",
    part_of_speech: "danh từ",
    meaning:
      "âm nhạc cổ truyền sử dụng trong dàn nhạc tám loại nhạc khí làm bằng những vật liệu khác nhau: nhạc bát âm ~phường bát âm",
    example: "nhạc bát âm ~phường bát âm",
  },
  {
    word: "bạt",
    part_of_speech: "danh từ",
    meaning:
      "tấm vải hoặc nhựa dày cứng và thô, thường dùng để che mưa nắng: căng bạt làm lều * vải bạt",
    example: "căng bạt làm lều * vải bạt",
  },
  {
    word: "bạt",
    part_of_speech: "động từ",
    meaning: "san cho mất đi, cho bằng: bạt đồi để làm đường",
    example: "bạt đồi để làm đường",
  },
  {
    word: "bạt",
    part_of_speech: "động từ",
    meaning:
      "làm cho bị dạt đi nơi khác: con thuyền bị sóng đánh bạt đi * giặc giã, mỗi người bạt đi một nơi",
    example:
      "con thuyền bị sóng đánh bạt đi * giặc giã, mỗi người bạt đi một nơi",
  },
  {
    word: "bát",
    part_of_speech: "danh từ",
    meaning:
      "(Nam chén) đồ dùng có dạng bán cầu để đựng cơm, canh, nước uống, v.v.: bát sứ * Hôm nay ai rửa bát? * múc một bát canh * Nhà sạch thì mát, bát sạch ngon cơm. (tục ngữ)",
    example:
      "bát sứ * Hôm nay ai rửa bát? * múc một bát canh * Nhà sạch thì mát, bát sạch ngon cơm.",
  },
  {
    word: "bát",
    part_of_speech: "danh từ",
    meaning:
      "số tiền những người chơi họ góp lại trong mỗi lượt góp: chơi một lúc hai bát họ",
    example: "chơi một lúc hai bát họ",
  },
  {
    word: "bát đàn",
    part_of_speech: "danh từ",
    meaning:
      'bát nông lòng, làm bằng đất nung thô có tráng men, dùng ở thời trước: "Có bát sứ tình phụ bát đàn, Nâng niu bát sứ vỡ tan có ngày." (ca dao)',
    example:
      'Có bát sứ tình phụ bát đàn, Nâng niu bát sứ vỡ tan có ngày." (ca dao)',
  },
  {
    word: "bạt hơi",
    part_of_speech: "tính từ",
    meaning: "khó thở vì gió tạt mạnh: xe chạy nhanh nên bị bạt hơi",
    example: "xe chạy nhanh nên bị bạt hơi",
  },
  {
    word: "bát giác",
    part_of_speech: "danh từ",
    meaning: "đa giác có tám cạnh: hình bát giác * lầu bát giác",
    example: "hình bát giác * lầu bát giác",
  },
  {
    word: "bạt mạng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) liều lĩnh, bất chấp tất cả: ăn chơi bạt mạng * phóng xe bạt mạng",
    example: "ăn chơi bạt mạng * phóng xe bạt mạng",
  },
  {
    word: "bát nháo",
    part_of_speech: "tính từ",
    meaning: "(Khẩu ngữ) hết sức lộn xộn, lung tung: ăn nói bát nháo",
    example: "ăn nói bát nháo",
  },
  {
    word: "bạt ngàn",
    part_of_speech: "tính từ",
    meaning:
      "nhiều vô kể và trải ra trên một vùng rất rộng: rừng núi bạt ngàn * một đồi chè bạt ngàn đến hút tầm mắt",
    example: "rừng núi bạt ngàn * một đồi chè bạt ngàn đến hút tầm mắt",
  },
  {
    word: "bát kết",
    part_of_speech: "danh từ",
    meaning: "(cũ, khẩu ngữ) giày bát kết (nói tắt): chân đi một đôi bát kết",
    example: "chân đi một đôi bát kết",
  },
  {
    word: "bát phẩm",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) phẩm trật thứ tám (trong thang cấp bậc quan lại): quan bát phẩm",
    example: "quan bát phẩm",
  },
  {
    word: "bát ô tô",
    part_of_speech: "danh từ",
    meaning: "bát to, sâu lòng: một bát ô tô canh",
    example: "một bát ô tô canh",
  },
  {
    word: "bát nháo chi khươn",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) bừa bãi, lộn xộn, không ra thể thống gì: đồ bát nháo chi khươn!",
    example: "đồ bát nháo chi khươn!",
  },
  {
    word: "bát ngát",
    part_of_speech: "tính từ",
    meaning:
      'rộng lớn đến mức tầm mắt không sao bao quát hết được: cánh đồng bát ngát * "Bốn bề bát ngát xa trông, Cát vàng cồn nọ, bụi hồng dặm kia." (TKiều)',
    example:
      'cánh đồng bát ngát * "Bốn bề bát ngát xa trông, Cát vàng cồn nọ, bụi hồng dặm kia." (TKiều)',
  },
  {
    word: "bạt tai",
    part_of_speech: "",
    meaning: "tát vào mang tai: cho mấy cái bạt tai",
    example: "cho mấy cái bạt tai",
  },
  {
    word: "bát phố",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ, hiếm) đi rong chơi trên đường phố: đi bát phố * chơi bời bát phố",
    example: "đi bát phố * chơi bời bát phố",
  },
  {
    word: "bát sách",
    part_of_speech: "danh từ",
    meaning:
      "tên một con bài tổ tôm trên có ghi hai chữ Hán bát 八 và sách 索; thường dùng trong khẩu ngữ để ví người gàn dở (ý hài hước): gàn bát sách",
    example: "gàn bát sách",
  },
  {
    word: "bát tiên",
    part_of_speech: "danh từ",
    meaning:
      'tám vị tiên trong thần thoại Trung Quốc thời cổ, ngày trước thường được dùng làm đề tài để vẽ tranh dân gian, hình ảnh được vẽ, thêu, khắc để trang trí: khăn bát tiên * "Buồng riêng, sửa chốn thanh nhàn, Đặt giường thất bảo, vây màn bát tiên." (TKiều)',
    example:
      'khăn bát tiên * "Buồng riêng, sửa chốn thanh nhàn, Đặt giường thất bảo, vây màn bát tiên." (TKiều)',
  },
  {
    word: "bạt vía",
    part_of_speech: "động từ",
    meaning: "sợ hãi đến mức như mất cả hồn vía: sợ bạt vía",
    example: "sợ bạt vía",
  },
  {
    word: "bạt tử",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như bạt mạng: ăn chơi bạt tử",
    example: "ăn chơi bạt tử",
  },
  {
    word: "bàu bạu",
    part_of_speech: "tính từ",
    meaning: "(vẻ mặt) hơi nặng, vì có điều giận dỗi: mặt bàu bạu",
    example: "mặt bàu bạu",
  },
  {
    word: "bàu",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ) đầm nhỏ: bàu sen * trong bàu mọc đầy lau sậy",
    example: "bàu sen * trong bàu mọc đầy lau sậy",
  },
  {
    word: "báu",
    part_of_speech: "tính từ",
    meaning: "quý giá: của báu * gươm báu * hạng ấy thì báu gì!",
    example: "của báu * gươm báu * hạng ấy thì báu gì!",
  },
  {
    word: "bảy",
    part_of_speech: "danh từ",
    meaning:
      "số (ghi bằng 7) liền sau số sáu trong dãy số tự nhiên: học lớp bảy * cao một mét bảy (một mét bảy mươi phân) * một tuần có bảy ngày",
    example:
      "học lớp bảy * cao một mét bảy (một mét bảy mươi phân) * một tuần có bảy ngày",
  },
  {
    word: "bay",
    part_of_speech: "động từ",
    meaning:
      "di chuyển ở trên không: chim vỗ cánh bay đi * máy bay bay qua bầu trời * khói trắng bay là là trên mái tranh",
    example:
      "chim vỗ cánh bay đi * máy bay bay qua bầu trời * khói trắng bay là là trên mái tranh",
  },
  {
    word: "bay",
    part_of_speech: "động từ",
    meaning:
      'chuyển động theo, cuốn theo làn gió: cờ bay phấp phới * "Yêu nhau cởi áo cho nhau, Về nhà mẹ hỏi qua cầu gió bay." (Cdao)',
    example:
      'cờ bay phấp phới * "Yêu nhau cởi áo cho nhau, Về nhà mẹ hỏi qua cầu gió bay." (Cdao)',
  },
  {
    word: "bay",
    part_of_speech: "động từ",
    meaning: "di chuyển rất nhanh: đạn bay rào rào * phóng bay về nhà",
    example: "đạn bay rào rào * phóng bay về nhà",
  },
  {
    word: "bay",
    part_of_speech: "động từ",
    meaning:
      "biến mất, phai mất đi, không còn giữ nguyên màu sắc, hương vị như ban đầu: rượu đã bay hơi * nốt đậu đang bay * bức vẽ đã bay màu * tiền cất trong tủ không cánh mà bay",
    example:
      "rượu đã bay hơi * nốt đậu đang bay * bức vẽ đã bay màu * tiền cất trong tủ không cánh mà bay",
  },
  {
    word: "bay",
    part_of_speech: "phụ từ",
    meaning:
      "(Khẩu ngữ) từ biểu thị hành động diễn ra rất nhanh và dễ dàng (thường là khó khăn đối với người khác): cãi bay đi * đánh bay cả nồi cơm",
    example: "cãi bay đi * đánh bay cả nồi cơm",
  },
  {
    word: "bay",
    part_of_speech: "đại từ",
    meaning: "(Phương ngữ, Khẩu ngữ) chúng mày: quân bay * tụi bay",
    example: "quân bay * tụi bay",
  },
  {
    word: "bay biến",
    part_of_speech: "động từ",
    meaning:
      "mất rất nhanh và không để lại một dấu vết gì: nỗi phiền muộn bỗng dưng bay biến hết",
    example: "nỗi phiền muộn bỗng dưng bay biến hết",
  },
  {
    word: "bay biến",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) (chối cãi) một cách rất nhanh và dễ dàng, tựa như không hề có gì cả: chối bay biến * cãi bay cãi biến",
    example: "chối bay biến * cãi bay cãi biến",
  },
  {
    word: "bày",
    part_of_speech: "động từ",
    meaning:
      "để làm sao cho mọi người dễ thấy nhất hoặc cho đẹp: bày hàng ra bán * tủ bày đồ",
    example: "bày hàng ra bán * tủ bày đồ",
  },
  {
    word: "bày",
    part_of_speech: "động từ",
    meaning:
      "hiện rõ ra, lộ rõ ra ngoài, rất dễ nhìn thấy: cảnh tượng bày ra trước mắt",
    example: "cảnh tượng bày ra trước mắt",
  },
  {
    word: "bày",
    part_of_speech: "động từ",
    meaning:
      "sắp đặt để tạo ra cho có: bày việc cho làm * thua keo này bày keo khác (tng)",
    example: "bày việc cho làm * thua keo này bày keo khác (tng)",
  },
  {
    word: "bày",
    part_of_speech: "động từ",
    meaning:
      "chỉ bảo cho biết cách làm, cách giải quyết: bày mưu * bày cách làm ăn",
    example: "bày mưu * bày cách làm ăn",
  },
  {
    word: "báu vật",
    part_of_speech: "danh từ",
    meaning: "vật quý và có giá trị: truy tìm báu vật",
    example: "truy tìm báu vật",
  },
  {
    word: "bay bướm",
    part_of_speech: "tính từ",
    meaning:
      "có hình thức trau chuốt, bóng bẩy, hơi kiểu cách: câu văn bay bướm * lời lẽ bay bướm",
    example: "câu văn bay bướm * lời lẽ bay bướm",
  },
  {
    word: "bày đặt",
    part_of_speech: "động từ",
    meaning:
      'đặt ra cái không cần thiết: bày đặt ra nhiều thứ lễ nghi * "Anh ấy chỉ bày đặt ra công việc cho thêm vất vả, chẳng năm nào là anh ấy không nghĩ ra thứ nọ thứ kia." (KhHưng; 2)',
    example:
      'bày đặt ra nhiều thứ lễ nghi * "Anh ấy chỉ bày đặt ra công việc cho thêm vất vả, chẳng năm nào là anh ấy không nghĩ ra thứ nọ thứ kia." (KhHưng; 2)',
  },
  {
    word: "bày đặt",
    part_of_speech: "động từ",
    meaning: "(Ít dùng) như bịa đặt: bày đặt tin nhảm",
    example: "bày đặt tin nhảm",
  },
  {
    word: "bay bổng",
    part_of_speech: "động từ",
    meaning:
      'bay cao lên không trung: cánh diều bay bổng giữa trời cao * "Cánh hồng bay bổng tuyệt vời, Đã mòn con mắt phương trời đăm đăm." (TKiều)',
    example:
      'cánh diều bay bổng giữa trời cao * "Cánh hồng bay bổng tuyệt vời, Đã mòn con mắt phương trời đăm đăm." (TKiều)',
  },
  {
    word: "bày biện",
    part_of_speech: "động từ",
    meaning:
      "sắp đặt đồ đạc một cách hợp lí, đẹp mắt: bày biện đồ đạc * căn phòng bày biện sơ sài",
    example: "bày biện đồ đạc * căn phòng bày biện sơ sài",
  },
  {
    word: "bày biện",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) bày thêm ra, đặt thêm ra những cái không cần thiết để phô trương: bày biện làm gì nhiều cho tốn kém",
    example: "bày biện làm gì nhiều cho tốn kém",
  },
  {
    word: "bay hơi",
    part_of_speech: "động từ",
    meaning: "(chất lỏng) chuyển thành hơi ở lớp bề mặt: nước bay hơi",
    example: "nước bay hơi",
  },
  {
    word: "bày tỏ",
    part_of_speech: "động từ",
    meaning:
      "nói ra cho người khác rõ tình cảm, ý kiến của mình: bày tỏ nỗi lòng * bày tỏ lòng biết ơn",
    example: "bày tỏ nỗi lòng * bày tỏ lòng biết ơn",
  },
  {
    word: "bay lượn",
    part_of_speech: "động từ",
    meaning:
      "bay và lượn trên không (nói khái quát): máy bay bay lượn trên bầu trời",
    example: "máy bay bay lượn trên bầu trời",
  },
  {
    word: "bày vẽ",
    part_of_speech: "động từ",
    meaning:
      "đặt ra cái không thiết thực hoặc không thật cần thiết: không thích bày vẽ lôi thôi",
    example: "không thích bày vẽ lôi thôi",
  },
  {
    word: "bày vẽ",
    part_of_speech: "động từ",
    meaning:
      "bày (nói khái quát): bày vẽ cách làm ăn * bày vẽ cho nhau điều khôn lẽ phải",
    example: "bày vẽ cách làm ăn * bày vẽ cho nhau điều khôn lẽ phải",
  },
  {
    word: "bay nhảy",
    part_of_speech: "động từ",
    meaning:
      "đi đây đi đó, tham gia công việc này, công việc nọ theo ý thích, không chịu ở yên một chỗ: tính thích bay nhảy",
    example: "tính thích bay nhảy",
  },
  {
    word: "bắc bậc",
    part_of_speech: "tính từ",
    meaning:
      'có thái độ tỏ ra ta đây hơn người: "Em đừng bắc bậc thấp cao, Bèo sông khó kiếm bèo ao khó gì." (ca dao)',
    example:
      'Em đừng bắc bậc thấp cao, Bèo sông khó kiếm bèo ao khó gì." (ca dao)',
  },
  {
    word: "bắc",
    part_of_speech: "động từ",
    meaning: "gieo (mạ): bắc mạ",
    example: "bắc mạ",
  },
  {
    word: "bắc",
    part_of_speech: "danh từ",
    meaning:
      'một trong bốn phương chính, khi nhìn hướng đó thì thấy mặt trời mọc ở phía tay phải: nhà hướng bắc * gió bắc * "Tìm em như thể tìm chim, Chim ăn bể bắc đi tìm bể đông." (ca dao)',
    example:
      'nhà hướng bắc * gió bắc * "Tìm em như thể tìm chim, Chim ăn bể bắc đi tìm bể đông." (ca dao)',
  },
  {
    word: "bắc",
    part_of_speech: "danh từ",
    meaning:
      "(viết hoa) miền phía bắc của nước Việt Nam, trong quan hệ với miền phía nam (miền Nam): nói giọng Bắc * vào Nam ra Bắc",
    example: "nói giọng Bắc * vào Nam ra Bắc",
  },
  {
    word: "bắc",
    part_of_speech: "động từ",
    meaning:
      'đặt, gác (một vật gì) qua một khoảng cách hay để vượt qua một khoảng cách (làm cho không còn ngăn cách nữa): bắc cầu  * "Chiếu mây ta chẳng thèm ngồi, Ta bắc ghế đẩu ta ngồi cho cao." (ca dao)',
    example:
      'bắc cầu  * "Chiếu mây ta chẳng thèm ngồi, Ta bắc ghế đẩu ta ngồi cho cao." (ca dao)',
  },
  {
    word: "bắc",
    part_of_speech: "động từ",
    meaning:
      "đặt vào vị trí để sử dụng: bắc nồi lên bếp * bắc ống nhòm * bắc loa tay mà gọi",
    example: "bắc nồi lên bếp * bắc ống nhòm * bắc loa tay mà gọi",
  },
  {
    word: "bày vai",
    part_of_speech: "tính từ",
    meaning:
      '(phương ngữ) (người) cùng hàng với nhau trong quan hệ thứ bậc hoặc tuổi tác: anh em bày vai * "Bày vai có ả Mã Kiều, Xót nàng, ra mới đánh liều chịu đoan." (TKiều)',
    example:
      'anh em bày vai * "Bày vai có ả Mã Kiều, Xót nàng, ra mới đánh liều chịu đoan." (TKiều)',
  },
  {
    word: "bắc cầu",
    part_of_speech: "động từ",
    meaning:
      "nối tiếp vào giữa để cho hai khoảng thời gian liền mạch, không bị gián đoạn: nghỉ bắc cầu (thêm một ngày giữa hai ngày nghỉ chính thức)",
    example: "nghỉ bắc cầu (thêm một ngày giữa hai ngày nghỉ chính thức)",
  },
  {
    word: "bắc cầu",
    part_of_speech: "động từ",
    meaning:
      "(quan hệ) có tính chất: nếu A có quan hệ ấy với B, B có quan hệ ấy với C, thì A cũng có quan hệ ấy với C: quan hệ bé hơn giữa các số có tính chất bắc cầu",
    example: "quan hệ bé hơn giữa các số có tính chất bắc cầu",
  },
  {
    word: "bắc cực",
    part_of_speech: "danh từ",
    meaning: "cực phía bắc của Trái Đất: khí hậu miền Bắc Cực * gấu Bắc Cực",
    example: "khí hậu miền Bắc Cực * gấu Bắc Cực",
  },
  {
    word: "bắc nam",
    part_of_speech: "danh từ",
    meaning:
      'phương bắc và phương nam; thường dùng (viết hoa) để nói về sự phân li xa cách giữa những người thân: Bắc Nam đôi ngả * "Yêu nhau chẳng lấy được nhau, Bắc Nam cách biệt ngậm sầu đôi nơi." (ca dao)',
    example:
      'Bắc Nam đôi ngả * "Yêu nhau chẳng lấy được nhau, Bắc Nam cách biệt ngậm sầu đôi nơi." (ca dao)',
  },
  {
    word: "băm vằm",
    part_of_speech: "động từ",
    meaning:
      "băm nát ra (thường dùng trong lời chửi mắng): tội đáng băm vằm! * cái đồ chết băm chết vằm!",
    example: "tội đáng băm vằm! * cái đồ chết băm chết vằm!",
  },
  {
    word: "bặm",
    part_of_speech: "động từ",
    meaning:
      "ngậm chặt môi lại do phải gắng hết sức ra để làm việc gì: bặm miệng lại * bặm môi suy nghĩ",
    example: "bặm miệng lại * bặm môi suy nghĩ",
  },
  {
    word: "băm",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) ba mươi: tuổi đã băm mấy? * Hà Nội băm sáu phố phường",
    example: "tuổi đã băm mấy? * Hà Nội băm sáu phố phường",
  },
  {
    word: "băm",
    part_of_speech: "động từ",
    meaning:
      "chặt liên tiếp và nhanh tay cho nát nhỏ ra: băm rau lợn * băm thịt làm chả",
    example: "băm rau lợn * băm thịt làm chả",
  },
  {
    word: "băm",
    part_of_speech: "động từ",
    meaning:
      '(ngựa) chạy bước ngắn và nhanh: "Tiếng vó ngựa băm ròn rã trên mặt đường hanh khô nỏ, nhịp với tiếng nhạc đồng sang sảng." (KLân; 8)',
    example:
      'Tiếng vó ngựa băm ròn rã trên mặt đường hanh khô nỏ, nhịp với tiếng nhạc đồng sang sảng." (KLân; 8)',
  },
  {
    word: "bặm trợn",
    part_of_speech: "tính từ",
    meaning:
      '(phương ngữ, khẩu ngữ) có vẻ dữ tợn, hung hăng, thường biểu lộ ra mặt như bặm miệng, trợn mắt, v.v.: "Trương Rỗ rất xấc láo, bặm trợn, gặp chuyện gì trái ý là gã hầm hè đe nẹt (...)" (NgKiên; 15)',
    example:
      'Trương Rỗ rất xấc láo, bặm trợn, gặp chuyện gì trái ý là gã hầm hè đe nẹt (...)" (NgKiên; 15)',
  },
  {
    word: "băm bổ",
    part_of_speech: "động từ",
    meaning:
      "làm việc gì đó một cách cắm cúi, mải miết, bằng những động tác nhanh: băm bổ cuốc đất * băm băm bổ bổ chạy thẳng về",
    example: "băm bổ cuốc đất * băm băm bổ bổ chạy thẳng về",
  },
  {
    word: "băm bổ",
    part_of_speech: "động từ",
    meaning: "nói dằn mạnh từng tiếng một, tỏ vẻ tức giận: nói băm bổ",
    example: "nói băm bổ",
  },
  {
    word: "bắn",
    part_of_speech: "động từ",
    meaning:
      "phóng tên, đạn, v.v. bằng lực đẩy của khí giới (như cung, súng, v.v.): nhanh như tên bắn * bắn một phát súng * bắn pháo hoa",
    example: "nhanh như tên bắn * bắn một phát súng * bắn pháo hoa",
  },
  {
    word: "bắn",
    part_of_speech: "động từ",
    meaning:
      "làm chuyển dời vật nặng bằng cách bẩy mạnh lên: dùng đòn bẩy bắn cột nhà * bắn tảng đá sang một bên",
    example: "dùng đòn bẩy bắn cột nhà * bắn tảng đá sang một bên",
  },
  {
    word: "bắn",
    part_of_speech: "động từ",
    meaning:
      "bật mạnh ra do phải chịu một tác động mạnh và đột ngột: nước bắn tung toé * giật bắn người lên * lấy chân hất bắn hòn sỏi ra xa",
    example:
      "nước bắn tung toé * giật bắn người lên * lấy chân hất bắn hòn sỏi ra xa",
  },
  {
    word: "bắn",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) chuyển (món nợ, khoản tiền, v.v.) sang phần của người khác, nơi khác: bắn nợ sang người khác * bắn một khoản chi sang tháng sau",
    example: "bắn nợ sang người khác * bắn một khoản chi sang tháng sau",
  },
  {
    word: "bắn",
    part_of_speech: "động từ",
    meaning: "đưa tin cho ai đó một cách kín đáo: bắn tin cho nhau",
    example: "bắn tin cho nhau",
  },
  {
    word: "bắn",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) hút thuốc (thường là thuốc lào, thuốc phiện): bắn một bi thuốc phiện * bắn một mồi thuốc lào rõ kêu",
    example: "bắn một bi thuốc phiện * bắn một mồi thuốc lào rõ kêu",
  },
  {
    word: "bẳn",
    part_of_speech: "động từ",
    meaning:
      "bực tức một cách vô lí, vô lối: đã không chịu nhận lỗi lại còn phát bẳn",
    example: "đã không chịu nhận lỗi lại còn phát bẳn",
  },
  {
    word: "bắn chác",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bắn (nói khái quát; hàm ý coi thường): súng ống thế này thì bắn chác gì",
    example: "súng ống thế này thì bắn chác gì",
  },
  {
    word: "bằn bặt",
    part_of_speech: "tính từ",
    meaning: "như bặt (nhưng ý mức độ nhiều hơn): đi bằn bặt mấy năm trời",
    example: "đi bằn bặt mấy năm trời",
  },
  {
    word: "bắn tiếng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) ngỏ ý qua người trung gian: bắn tiếng muốn gặp * bắn tiếng là đã đồng ý",
    example: "bắn tiếng muốn gặp * bắn tiếng là đã đồng ý",
  },
  {
    word: "băn khoăn",
    part_of_speech: "tính từ",
    meaning:
      'không yên lòng vì đang có những điều bắt buộc phải nghĩ ngợi, cân nhắc: lòng băn khoăn, lo lắng * "Nói xong, Huệ tự thấy băn khoăn, không hiểu câu nói đó định ám chỉ ai (...)" (NgĐLạp; 2)',
    example:
      'lòng băn khoăn, lo lắng * "Nói xong, Huệ tự thấy băn khoăn, không hiểu câu nói đó định ám chỉ ai (...)" (NgĐLạp; 2)',
  },
  {
    word: "bẳn gắt",
    part_of_speech: "động từ",
    meaning:
      "gắt một cách vô lí (nói khái quát): bận quá dễ sinh bẳn gắt * tính hay bẳn gắt",
    example: "bận quá dễ sinh bẳn gắt * tính hay bẳn gắt",
  },
  {
    word: "bẳn tính",
    part_of_speech: "tính từ",
    meaning: "có tính hay cáu gắt: mệt mỏi đâm ra bẳn tính",
    example: "mệt mỏi đâm ra bẳn tính",
  },
  {
    word: "bắn mìn",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) nổ mìn: bắn mìn lấy đá",
    example: "bắn mìn lấy đá",
  },
  {
    word: "bẵng",
    part_of_speech: "tính từ",
    meaning:
      "im bặt, vắng bặt, hoàn toàn không có tin tức, động tĩnh gì: bẵng tin * bẵng đi một thời gian không gặp",
    example: "bẵng tin * bẵng đi một thời gian không gặp",
  },
  {
    word: "bẵng",
    part_of_speech: "tính từ",
    meaning:
      "ở tình trạng hoàn toàn không nghĩ đến, không để ý gì đến nữa: quên bẵng * cây đàn bị bỏ bẵng, không ai động tới",
    example: "quên bẵng * cây đàn bị bỏ bẵng, không ai động tới",
  },
  {
    word: "bằng",
    part_of_speech: "danh từ",
    meaning:
      'thứ chim lớn bay rất cao và xa, theo truyền thuyết; thường dùng trong văn học cổ để ví người anh hùng có cơ hội vẫy vùng: "Cánh bằng khi gặp gió xa, Tung mây chưa biết lên đà đến đâu." (NĐM)',
    example:
      'Cánh bằng khi gặp gió xa, Tung mây chưa biết lên đà đến đâu." (NĐM)',
  },
  {
    word: "bằng",
    part_of_speech: "danh từ",
    meaning: "(cũ) vật hoặc việc dựa vào làm tin: lấy giấy biên nhận làm bằng",
    example: "lấy giấy biên nhận làm bằng",
  },
  {
    word: "bằng",
    part_of_speech: "danh từ",
    meaning:
      "giấy chứng nhận năng lực, trình độ, thành tích: bằng tốt nghiệp đại học * bằng lái xe",
    example: "bằng tốt nghiệp đại học * bằng lái xe",
  },
  {
    word: "bằng",
    part_of_speech: "tính từ",
    meaning:
      "không hơn, không kém: cao bằng nhau * chia thành hai phần bằng nhau",
    example: "cao bằng nhau * chia thành hai phần bằng nhau",
  },
  {
    word: "bằng",
    part_of_speech: "tính từ",
    meaning:
      'không kém (so với cái tiêu biểu được nêu ra): bằng chị bằng em * khoẻ không ai bằng * "Của cao bằng núi bằng non, Không bằng sớm vợ, sớm con lúc này." (ca dao)',
    example:
      'bằng chị bằng em * khoẻ không ai bằng * "Của cao bằng núi bằng non, Không bằng sớm vợ, sớm con lúc này." (ca dao)',
  },
  {
    word: "bằng",
    part_of_speech: "tính từ",
    meaning:
      'có bề mặt là một mặt phẳng, không gồ ghề, không lồi lõm, giống như mặt nước yên lặng: đất bằng * san bằng đồn giặc * "Yêu nhau vạn sự chẳng nề, Một trăm chỗ lệch cũng kê cho bằng." (ca dao)',
    example:
      'đất bằng * san bằng đồn giặc * "Yêu nhau vạn sự chẳng nề, Một trăm chỗ lệch cũng kê cho bằng." (ca dao)',
  },
  {
    word: "bằng",
    part_of_speech: "tính từ",
    meaning:
      "có phần ở đầu cùng là một mặt bằng, không nhọn, không lồi lõm: máy bay cánh bằng * châu chấu bằng đầu",
    example: "máy bay cánh bằng * châu chấu bằng đầu",
  },
  {
    word: "bằng",
    part_of_speech: "tính từ",
    meaning:
      "(âm tiết) có thanh ngang hoặc thanh huyền; phân biệt với trắc:  là những tiếng bằng * vần bằng * thanh bằng",
    example: "là những tiếng bằng * vần bằng * thanh bằng",
  },
  {
    word: "bằng",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là chất liệu, vật liệu cấu tạo của sự vật vừa được nói đến: bàn bằng gỗ * quần áo bằng vải lụa * mái nhà lợp bằng tôn",
    example: "bàn bằng gỗ * quần áo bằng vải lụa * mái nhà lợp bằng tôn",
  },
  {
    word: "bằng",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là phương tiện, phương pháp của hoạt động được nói đến: đi bằng tàu hoả * làm bằng tay * nói bằng một giọng bông đùa",
    example: "đi bằng tàu hoả * làm bằng tay * nói bằng một giọng bông đùa",
  },
  {
    word: "bằng",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là yêu cầu mà hành động vừa được nói đến nhất thiết phải đạt tới: đọc bằng hết mới thôi * làm cho bằng xong mới nghỉ * dù đắt cũng phải mua cho bằng được!",
    example:
      "đọc bằng hết mới thôi * làm cho bằng xong mới nghỉ * dù đắt cũng phải mua cho bằng được!",
  },
  {
    word: "băng bó",
    part_of_speech: "động từ",
    meaning: "băng cho kín vết thương (nói khái quát): băng bó vết thương",
    example: "băng bó vết thương",
  },
  {
    word: "bằng bặn",
    part_of_speech: "tính từ",
    meaning:
      "phẳng và đều đặn: mái lợp bằng bặn * hàng rào được cắt xén rất bằng bặn",
    example: "mái lợp bằng bặn * hàng rào được cắt xén rất bằng bặn",
  },
  {
    word: "băng",
    part_of_speech: "danh từ",
    meaning:
      "nước đông cứng trong thiên nhiên ở nơi có khí hậu lạnh: nước đóng băng * tan băng",
    example: "nước đóng băng * tan băng",
  },
  {
    word: "băng",
    part_of_speech: "danh từ",
    meaning:
      "nhóm trộm cướp có kẻ cầm đầu: băng cướp * bắt gọn cả băng buôn lậu",
    example: "băng cướp * bắt gọn cả băng buôn lậu",
  },
  {
    word: "băng",
    part_of_speech: "danh từ",
    meaning:
      "đoạn vải hoặc giấy, v.v. dài và hẹp, dùng vào việc gì nhất định: đeo băng đội trưởng * cắt băng khánh thành * băng tang",
    example: "đeo băng đội trưởng * cắt băng khánh thành * băng tang",
  },
  {
    word: "băng",
    part_of_speech: "danh từ",
    meaning:
      "băng vải đã được tiệt trùng dùng để làm kín vết thương, hoặc nói chung tất cả những thứ cần thiết để che giữ cho vết thương: thay băng * tháo băng",
    example: "thay băng * tháo băng",
  },
  {
    word: "băng",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) ruy băng (nói tắt): thay băng máy chữ",
    example: "thay băng máy chữ",
  },
  {
    word: "băng",
    part_of_speech: "danh từ",
    meaning: "băng từ (nói tắt): thu tiếng vào băng * mở băng nghe nhạc",
    example: "thu tiếng vào băng * mở băng nghe nhạc",
  },
  {
    word: "băng",
    part_of_speech: "danh từ",
    meaning:
      "khoảng tần số hoặc bước sóng tương đối xác định: băng sóng trung * máy thu ba băng",
    example: "băng sóng trung * máy thu ba băng",
  },
  {
    word: "băng",
    part_of_speech: "động từ",
    meaning: "làm kín vết thương bằng băng: băng kín vết thương",
    example: "băng kín vết thương",
  },
  {
    word: "băng",
    part_of_speech: "danh từ",
    meaning: "băng đạn (nói tắt): lắp đạn vào băng * lia một băng tiểu liên",
    example: "lắp đạn vào băng * lia một băng tiểu liên",
  },
  {
    word: "băng",
    part_of_speech: "động từ",
    meaning:
      'di chuyển nhanh qua, bất chấp trở ngại: vượt suối băng rừng * băng mình qua lửa đạn * "Cửa ngoài vội rủ rèm the, Xăm xăm băng lối vườn khuya một mình." (TKiều)',
    example:
      'vượt suối băng rừng * băng mình qua lửa đạn * "Cửa ngoài vội rủ rèm the, Xăm xăm băng lối vườn khuya một mình." (TKiều)',
  },
  {
    word: "băng",
    part_of_speech: "động từ",
    meaning:
      "nhanh và thẳng một mạch theo đà: bị lũ cuốn băng đi * chạy băng ra ngoài",
    example: "bị lũ cuốn băng đi * chạy băng ra ngoài",
  },
  {
    word: "băng",
    part_of_speech: "động từ",
    meaning:
      "hoàn toàn như thế trên khắp phạm vi được nói đến: bãi đất đã bị ngập băng",
    example: "bãi đất đã bị ngập băng",
  },
  {
    word: "băng",
    part_of_speech: "động từ",
    meaning:
      "trạng thái ở yên một chỗ, không hoạt động, không phát triển được: tiền đóng băng trong ngân hàng * thị trường nhà đất đã có dấu hiệu tan băng",
    example:
      "tiền đóng băng trong ngân hàng * thị trường nhà đất đã có dấu hiệu tan băng",
  },
  {
    word: "bằng cớ",
    part_of_speech: "danh từ",
    meaning:
      "vật hoặc hành động cụ thể chứng tỏ (việc sai trái, sai phạm đang nói đến) là có thật: bằng cớ rành rành không thể chối cãi",
    example: "bằng cớ rành rành không thể chối cãi",
  },
  {
    word: "bằng cấp",
    part_of_speech: "danh từ",
    meaning:
      "văn bằng cấp cho người học hành đã thi đỗ (nói khái quát): bệnh hám danh, sính bằng cấp",
    example: "bệnh hám danh, sính bằng cấp",
  },
  {
    word: "băng chuyền",
    part_of_speech: "danh từ",
    meaning:
      "băng hoặc dải chuyển động liên tục trên trục lăn, thường dùng để chuyển dịch hàng hoá, hành lí: hệ thống băng chuyền ở sân bay",
    example: "hệ thống băng chuyền ở sân bay",
  },
  {
    word: "bằng chứng",
    part_of_speech: "danh từ",
    meaning:
      "cái dùng để chứng minh tính chân thật (của một cái khác): một bằng chứng đầy sức thuyết phục * đưa ra các bằng chứng để chứng minh",
    example:
      "một bằng chứng đầy sức thuyết phục * đưa ra các bằng chứng để chứng minh",
  },
  {
    word: "băng ca",
    part_of_speech: "danh từ",
    meaning:
      "cáng (để khiêng người ốm hoặc bị thương): đặt nạn nhân vào băng ca * khiêng băng ca",
    example: "đặt nạn nhân vào băng ca * khiêng băng ca",
  },
  {
    word: "bằng cứ",
    part_of_speech: "danh từ",
    meaning:
      "vật hoặc hành động cụ thể chứng tỏ (việc sai trái, sai phạm đang nói đến) là có thật: bằng cớ rành rành không thể chối cãi",
    example: "bằng cớ rành rành không thể chối cãi",
  },
  {
    word: "băng đạn",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận bằng vải hoặc bằng kim loại dùng để kẹp đạn và tiếp đạn vào súng khi bắn; cũng dùng để chỉ số lượng đạn lắp đầy một băng đạn: thay băng đạn * bắn hết một băng đạn",
    example: "thay băng đạn * bắn hết một băng đạn",
  },
  {
    word: "băng giá",
    part_of_speech: "danh từ",
    meaning: "nước đông lại vì trời quá lạnh: tan băng giá * miền băng giá",
    example: "tan băng giá * miền băng giá",
  },
  {
    word: "băng giá",
    part_of_speech: "tính từ",
    meaning:
      "lạnh đến mức như xung quanh có băng giá: màn đêm băng giá * nét mặt băng giá, không một chút cảm xúc",
    example: "màn đêm băng giá * nét mặt băng giá, không một chút cảm xúc",
  },
  {
    word: "băng đảng",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức băng nhóm lớn, thường có vũ trang: băng đảng buôn lậu ma tuý",
    example: "băng đảng buôn lậu ma tuý",
  },
  {
    word: "băng dính",
    part_of_speech: "danh từ",
    meaning:
      "băng vải, nhựa,... được phết lớp chất dính thường ở một mặt, dùng để băng hoặc dán: cuộn băng dính * băng dính hai mặt * băng dính y tế (băng dính dùng trong y tế)",
    example:
      "cuộn băng dính * băng dính hai mặt * băng dính y tế (băng dính dùng trong y tế)",
  },
  {
    word: "băng đăng",
    part_of_speech: "danh từ",
    meaning:
      "nghệ thuật điêu khắc trên băng, khi trưng bày có kết hợp với thắp đèn, tạo nên vẻ đẹp lung linh, kì ảo: triển lãm băng đăng * lễ hội băng đăng",
    example: "triển lãm băng đăng * lễ hội băng đăng",
  },
  {
    word: "băng hình",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) như băng video: cửa hàng cho thuê băng hình",
    example: "cửa hàng cho thuê băng hình",
  },
  {
    word: "băng hà",
    part_of_speech: "động từ",
    meaning: "(cũ, trang trọng) (vua) chết: nhà vua đã băng hà",
    example: "nhà vua đã băng hà",
  },
  {
    word: "băng huyết",
    part_of_speech: "danh từ",
    meaning:
      "hiện tượng bệnh lí (ở phụ nữ) máu ra rất nhiều từ dạ con một cách bất thường (khi sinh nở hoặc bị sảy thai), có thể gây tử vong: sẩy thai bị băng huyết",
    example: "sẩy thai bị băng huyết",
  },
  {
    word: "bằng hữu",
    part_of_speech: "danh từ",
    meaning: "(cũ) bạn bè: tình bằng hữu",
    example: "tình bằng hữu",
  },
  {
    word: "băng hoại",
    part_of_speech: "tính từ",
    meaning:
      "hư hỏng, đổ nát, mất đi những gì tốt đẹp nhất về mặt tinh thần: băng hoại đạo đức * lối sống truỵ lạc làm băng hoại thuần phong mĩ tục",
    example:
      "băng hoại đạo đức * lối sống truỵ lạc làm băng hoại thuần phong mĩ tục",
  },
  {
    word: "băng keo",
    part_of_speech: "danh từ",
    meaning:
      "băng vải, nhựa,... được phết lớp chất dính thường ở một mặt, dùng để băng hoặc dán: cuộn băng dính * băng dính hai mặt * băng dính y tế (băng dính dùng trong y tế)",
    example:
      "cuộn băng dính * băng dính hai mặt * băng dính y tế (băng dính dùng trong y tế)",
  },
  {
    word: "bằng không",
    part_of_speech: "kết từ",
    meaning:
      "tổ hợp thường dùng ở vế sau của câu, biểu thị giả thiết thử phủ định điều kiện vừa được nói đến với ý nếu không như vậy thì..., nhằm nhấn mạnh vào tính bắt buộc của điều kiện đã nêu: đã làm thì phải ra làm, bằng không thì thôi * được thì tốt, bằng không cũng không sao",
    example:
      "đã làm thì phải ra làm, bằng không thì thôi * được thì tốt, bằng không cũng không sao",
  },
  {
    word: "bằng không",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) không có gì, coi như vô ích: nói với nó thì cũng bằng không * bao công sức đổ vào đấy, giờ cũng bằng không",
    example:
      "nói với nó thì cũng bằng không * bao công sức đổ vào đấy, giờ cũng bằng không",
  },
  {
    word: "bằng lặng",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như phẳng lặng: mặt nước bằng lặng * cuộc đời bằng lặng",
    example: "mặt nước bằng lặng * cuộc đời bằng lặng",
  },
  {
    word: "bằng lòng",
    part_of_speech: "động từ",
    meaning:
      'cảm thấy vừa ý, cho là ổn, là được: bằng lòng với kết quả đạt được * "Mặn nồng một vẻ một ưa, Bằng lòng, khách mới tuỳ cơ dặt dìu.” (TKiều)',
    example:
      'bằng lòng với kết quả đạt được * "Mặn nồng một vẻ một ưa, Bằng lòng, khách mới tuỳ cơ dặt dìu.” (TKiều)',
  },
  {
    word: "bằng lòng",
    part_of_speech: "động từ",
    meaning:
      "đồng ý với điều người khác yêu cầu hoặc đề nghị: đắt nhưng vẫn bằng lòng mua * không bằng lòng với việc làm của bạn * hai bên bằng lòng lấy nhau",
    example:
      "đắt nhưng vẫn bằng lòng mua * không bằng lòng với việc làm của bạn * hai bên bằng lòng lấy nhau",
  },
  {
    word: "bắng nhắng",
    part_of_speech: "động từ",
    meaning:
      "cố làm rối rít, ồn ào để tỏ vẻ ta đây quan trọng hoặc tài giỏi: tính hay bắng nhắng",
    example: "tính hay bắng nhắng",
  },
  {
    word: "băng nhóm",
    part_of_speech: "danh từ",
    meaning:
      "nhóm trộm cướp, buôn lậu có kẻ cầm đầu (nói khái quát): băng nhóm tội phạm * bắt giữ một băng nhóm buôn lậu",
    example: "băng nhóm tội phạm * bắt giữ một băng nhóm buôn lậu",
  },
  {
    word: "bằng phẳng",
    part_of_speech: "tính từ",
    meaning:
      "có bề mặt không gồ ghề, không lồi lõm: phiến đá bằng phẳng * địa hình tương đối bằng phẳng",
    example: "phiến đá bằng phẳng * địa hình tương đối bằng phẳng",
  },
  {
    word: "bằng phẳng",
    part_of_speech: "tính từ",
    meaning: "suôn sẻ, bình yên, ít có sự xáo động: cuộc đời bằng phẳng",
    example: "cuộc đời bằng phẳng",
  },
  {
    word: "băng nhân",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) người làm mối trong việc hôn nhân: "Sự lòng ngỏ với băng nhân, Tin sương đồn đại xa gần xôn xao." (TKiều)',
    example:
      'Sự lòng ngỏ với băng nhân, Tin sương đồn đại xa gần xôn xao." (TKiều)',
  },
  {
    word: "băng tải",
    part_of_speech: "danh từ",
    meaning:
      "băng hoặc dải chuyển động liên tục trên trục lăn, thường dùng để chuyển dịch hàng hoá, hành lí: hệ thống băng chuyền ở sân bay",
    example: "hệ thống băng chuyền ở sân bay",
  },
  {
    word: "bằng thừa",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) không ích lợi gì, không có tác dụng gì: hư thế thì học giỏi cũng bằng thừa * nó đang nóng, có nói cũng bằng thừa",
    example:
      "hư thế thì học giỏi cũng bằng thừa * nó đang nóng, có nói cũng bằng thừa",
  },
  {
    word: "bằng trắc",
    part_of_speech: "danh từ",
    meaning: "vần bằng và vần trắc: luật bằng trắc",
    example: "luật bằng trắc",
  },
  {
    word: "bằng vai",
    part_of_speech: "tính từ",
    meaning:
      "ngang hàng với nhau về quan hệ thứ bậc trong họ hàng: anh em là những người bằng vai nhau",
    example: "anh em là những người bằng vai nhau",
  },
  {
    word: "băng video",
    part_of_speech: "danh từ",
    meaning:
      "băng từ dùng ghi hình, thường đồng thời với ghi âm, để sau đó phát lại: xem băng video",
    example: "xem băng video",
  },
  {
    word: "bắp",
    part_of_speech: "danh từ",
    meaning:
      "vật có hình thuôn ở một hay hai đầu, phần giữa tròn và phình ra: bắp ngô * bắp chuối * bắp cày bằng gỗ",
    example: "bắp ngô * bắp chuối * bắp cày bằng gỗ",
  },
  {
    word: "bắp",
    part_of_speech: "danh từ",
    meaning: "bắp thịt (nói tắt): cánh tay nổi bắp * thịt bắp",
    example: "cánh tay nổi bắp * thịt bắp",
  },
  {
    word: "bắp",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ) ngô: chè bắp",
    example: "chè bắp",
  },
  {
    word: "bắp chân",
    part_of_speech: "danh từ",
    meaning:
      "bắp thịt ở phía sau ống chân: nước ngập đến bắp chân * quần xắn ngang bắp chân",
    example: "nước ngập đến bắp chân * quần xắn ngang bắp chân",
  },
  {
    word: "bắp cơ",
    part_of_speech: "danh từ",
    meaning:
      "cơ hình bắp, giữa phình to, hai đầu thuôn nhỏ: bắp thịt nổi cuồn cuộn * tiêm vào bắp thịt",
    example: "bắp thịt nổi cuồn cuộn * tiêm vào bắp thịt",
  },
  {
    word: "bắp chuối",
    part_of_speech: "danh từ",
    meaning:
      "phần hoa chuối hình bắp còn lại sau khi đã sinh buồng chuối, có thể dùng làm rau ăn: nộm bắp chuối * thái bắp chuối ăn ghém",
    example: "nộm bắp chuối * thái bắp chuối ăn ghém",
  },
  {
    word: "bắp chuối",
    part_of_speech: "danh từ",
    meaning:
      "trạng thái bị sưng tấy ở các cơ chân tay, trông giống hình cái bắp chuối: sưng bắp chuối",
    example: "sưng bắp chuối",
  },
  {
    word: "bắp chuối",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) bắp chân: quần xắn lên tận bắp chuối",
    example: "quần xắn lên tận bắp chuối",
  },
  {
    word: "bắt",
    part_of_speech: "động từ",
    meaning:
      "nắm lấy, giữ lại, không để cho hoạt động tự do: bắt kẻ gian * bắt sâu cho lá * mèo bắt chuột * thả con săn sắt, bắt con cá rô (tng)",
    example:
      "bắt kẻ gian * bắt sâu cho lá * mèo bắt chuột * thả con săn sắt, bắt con cá rô (tng)",
  },
  {
    word: "bắt",
    part_of_speech: "động từ",
    meaning:
      "tiếp nhận, thu lấy cái từ nơi khác đến: bắt gọn quả bóng trong tay * bắt được của rơi * bắt sóng đài truyền hình",
    example:
      "bắt gọn quả bóng trong tay * bắt được của rơi * bắt sóng đài truyền hình",
  },
  {
    word: "bắt",
    part_of_speech: "động từ",
    meaning:
      "bám chặt hoặc để cho bám chặt lấy và tác động trực tiếp vào: da bắt nắng * vải ít bắt bụi * lửa bắt vào mái tranh",
    example: "da bắt nắng * vải ít bắt bụi * lửa bắt vào mái tranh",
  },
  {
    word: "bắt",
    part_of_speech: "động từ",
    meaning:
      "phát hiện, chỉ ra sai phạm và làm cho phải chịu trách nhiệm: bắt lỗi việt vị * bắt được quả tang",
    example: "bắt lỗi việt vị * bắt được quả tang",
  },
  {
    word: "bắt",
    part_of_speech: "động từ",
    meaning:
      'khiến phải làm việc gì, không cho phép làm khác đi: bắt phải làm * điều đó bắt anh ta phải suy nghĩ * "Bắt phong trần, phải phong trần, Cho thanh cao, mới được phần thanh cao." (TKiều)',
    example:
      'bắt phải làm * điều đó bắt anh ta phải suy nghĩ * "Bắt phong trần, phải phong trần, Cho thanh cao, mới được phần thanh cao." (TKiều)',
  },
  {
    word: "bắt",
    part_of_speech: "động từ",
    meaning:
      "làm cho gắn, cho khớp vào nhau để giữ chặt: bắt đinh ốc * các thanh xà được bắt chặt với nhau bằng bu lông",
    example: "bắt đinh ốc * các thanh xà được bắt chặt với nhau bằng bu lông",
  },
  {
    word: "bắt",
    part_of_speech: "động từ",
    meaning:
      "nối thêm vào một hệ thống đã có sẵn: bắt liên lạc * bắt điện vào nhà * bắt vòi nước",
    example: "bắt liên lạc * bắt điện vào nhà * bắt vòi nước",
  },
  {
    word: "bắp tay",
    part_of_speech: "danh từ",
    meaning: "bắp thịt ở cánh tay: bắp tay rắn chắc",
    example: "bắp tay rắn chắc",
  },
  {
    word: "bắp đùi",
    part_of_speech: "danh từ",
    meaning:
      "phần bắp thịt ở đùi, phía bên ngoài, từ hông đến đầu gối: đôi bắp đùi chắc nịch",
    example: "đôi bắp đùi chắc nịch",
  },
  {
    word: "bắp thịt",
    part_of_speech: "danh từ",
    meaning:
      "cơ hình bắp, giữa phình to, hai đầu thuôn nhỏ: bắp thịt nổi cuồn cuộn * tiêm vào bắp thịt",
    example: "bắp thịt nổi cuồn cuộn * tiêm vào bắp thịt",
  },
  {
    word: "bặt",
    part_of_speech: "tính từ",
    meaning:
      'không để lại dư âm hay tin tức gì: bặt tin nhau * vắng bặt bóng người * "Tiếng côn trùng tỉ tê tận những chỗ mông lung nào, lâu lâu hốt nhiên nín bặt đi một lúc (...)" (ĐGiỏi; 4)',
    example:
      'bặt tin nhau * vắng bặt bóng người * "Tiếng côn trùng tỉ tê tận những chỗ mông lung nào, lâu lâu hốt nhiên nín bặt đi một lúc (...)" (ĐGiỏi; 4)',
  },
  {
    word: "bắt bánh",
    part_of_speech: "động từ",
    meaning:
      "nắm vào bánh xe và dùng sức làm cho xe chuyển động: bắt bánh cho xe lên dốc",
    example: "bắt bánh cho xe lên dốc",
  },
  {
    word: "bắt bẻ",
    part_of_speech: "động từ",
    meaning:
      "vạch ra những chỗ thiếu sót hoặc sơ hở để chê trách và bắt phải nhận: không ai bắt bẻ vào đâu được * bắt bẻ từng lời nói",
    example: "không ai bắt bẻ vào đâu được * bắt bẻ từng lời nói",
  },
  {
    word: "bắt bớ",
    part_of_speech: "động từ",
    meaning:
      "bắt giữ người (nói khái quát; thường hàm ý không đồng tình): bắt bớ người vô tội",
    example: "bắt bớ người vô tội",
  },
  {
    word: "bắt bí",
    part_of_speech: "động từ",
    meaning:
      'lợi dụng tình thế khó khăn của người khác mà bắt người ta phải chấp nhận những điều kiện không hợp lí của mình: "(...) chúng nó tự đặt giá mà mua thóc của người nhà quê, thường bắt bí mua rẻ, mình không bán cho nó cũng không bán cho ai được (...)" (PhQuỳnh; 2)',
    example:
      '(...) chúng nó tự đặt giá mà mua thóc của người nhà quê, thường bắt bí mua rẻ, mình không bán cho nó cũng không bán cho ai được (...)" (PhQuỳnh; 2)',
  },
  {
    word: "bắt bồ",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ, khẩu ngữ) có quan hệ yêu đương (thường là không đứng đắn): bắt bồ với một vị giám đốc",
    example: "bắt bồ với một vị giám đốc",
  },
  {
    word: "bắt buộc",
    part_of_speech: "động từ",
    meaning:
      'buộc phải làm, phải chấp nhận: điều kiện bắt buộc * "Em tự nguyện săn sóc đến anh ấy chứ có ai bắt buộc em đâu." (NgKhải; 16)',
    example:
      'điều kiện bắt buộc * "Em tự nguyện săn sóc đến anh ấy chứ có ai bắt buộc em đâu." (NgKhải; 16)',
  },
  {
    word: "bắt chân chữ ngũ",
    part_of_speech: "",
    meaning:
      "(kiểu ngồi, nằm) gấp hai chân lại, chân nọ vắt ngang lên đầu gối chân kia (như hình chữ ngũ 五 của tiếng Hán): nằm bắt chân chữ ngũ",
    example: "nằm bắt chân chữ ngũ",
  },
  {
    word: "bắt chẹt",
    part_of_speech: "động từ",
    meaning:
      "như bắt bí (nhưng nghĩa mạnh hơn): biết khó khăn nên bắt chẹt nhau",
    example: "biết khó khăn nên bắt chẹt nhau",
  },
  {
    word: "bắt chước",
    part_of_speech: "động từ",
    meaning:
      "làm theo kiểu của người khác một cách máy móc: bắt chước cách làm của người khác * bắt chước giọng miền Nam",
    example: "bắt chước cách làm của người khác * bắt chước giọng miền Nam",
  },
  {
    word: "bắt đầu",
    part_of_speech: "động từ",
    meaning:
      "bước vào giai đoạn đầu của một công việc, một quá trình, một trạng thái: một ngày mới bắt đầu * trẻ bắt đầu tập đi * thời tiết đã bắt đầu ấm dần lên",
    example:
      "một ngày mới bắt đầu * trẻ bắt đầu tập đi * thời tiết đã bắt đầu ấm dần lên",
  },
  {
    word: "bắt chợt",
    part_of_speech: "động từ",
    meaning:
      'thấy được, bắt gặp được một cách bất thình lình (điều người ta không muốn để lộ cho ai biết): bắt chợt việc làm lén lút của bạn  * "Đức thường bắt chợt những khoé mắt nàng nhìn Tịnh, ngượng nghịu e dè như có lỗi." (ĐĐThu; 1)',
    example:
      'bắt chợt việc làm lén lút của bạn  * "Đức thường bắt chợt những khoé mắt nàng nhìn Tịnh, ngượng nghịu e dè như có lỗi." (ĐĐThu; 1)',
  },
  {
    word: "bắt đầu từ",
    part_of_speech: "",
    meaning:
      "tổ hợp biểu thị điều sắp nêu ra là khởi điểm hoặc khởi nguồn của sự việc, hành động hay quá trình: sự việc bắt đầu từ anh ta * bắt đầu từ ngày mai chúng ta sẽ tiến hành",
    example:
      "sự việc bắt đầu từ anh ta * bắt đầu từ ngày mai chúng ta sẽ tiến hành",
  },
  {
    word: "bắt cóc",
    part_of_speech: "động từ",
    meaning:
      "bắt người một cách đột ngột rồi đem giấu đi (nhằm thực hiện một âm mưu nào đó): bắt cóc để tống tiền * bị bắt cóc làm con tin",
    example: "bắt cóc để tống tiền * bị bắt cóc làm con tin",
  },
  {
    word: "bắt đền",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bắt phải đền, phải bồi thường vì đã làm cho bị thiệt hại: mất cái nào, bắt đền cái ấy * anh làm hỏng của em rồi, bắt đền anh đấy!",
    example:
      "mất cái nào, bắt đền cái ấy * anh làm hỏng của em rồi, bắt đền anh đấy!",
  },
  {
    word: "bắt chuyện",
    part_of_speech: "động từ",
    meaning:
      "bắt đầu trò chuyện để làm quen: tính cởi mở, dễ bắt chuyện * bắt chuyện làm quen",
    example: "tính cởi mở, dễ bắt chuyện * bắt chuyện làm quen",
  },
  {
    word: "bắt chuyện",
    part_of_speech: "động từ",
    meaning:
      "tiếp lời người khác để trò chuyện: không thích bắt chuyện với người lạ * dù nó có nói cũng không ai thèm bắt chuyện",
    example:
      "không thích bắt chuyện với người lạ * dù nó có nói cũng không ai thèm bắt chuyện",
  },
  {
    word: "bắt giọng",
    part_of_speech: "động từ",
    meaning:
      "hát trước một đoạn ngắn để cho nhiều người hát theo: bắt giọng cho cả lớp hát",
    example: "bắt giọng cho cả lớp hát",
  },
  {
    word: "bắt ép",
    part_of_speech: "động từ",
    meaning:
      "ép phải làm, phải chấp nhận: thích thì làm, không ai bắt ép * bị bắt ép phải theo",
    example: "thích thì làm, không ai bắt ép * bị bắt ép phải theo",
  },
  {
    word: "bắt khoan bắt nhặt",
    part_of_speech: "",
    meaning:
      'tìm mọi cách bắt bẻ từng li từng tí một cách khắt khe: "Bắt khoan bắt nhặt đến lời, Bắt quỳ tận mặt, bắt mời tận tay." (TKiều)',
    example:
      'Bắt khoan bắt nhặt đến lời, Bắt quỳ tận mặt, bắt mời tận tay." (TKiều)',
  },
  {
    word: "bắt giữ",
    part_of_speech: "động từ",
    meaning: "bắt và giữ lại, giam lại: bắt giữ hàng lậu",
    example: "bắt giữ hàng lậu",
  },
  {
    word: "bắt mắt",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) thu hút, gây được ấn tượng tốt đẹp ngay từ đầu nhờ hình thức bên ngoài: màu sắc và kiểu dáng bắt mắt * cách trang trí rất bắt mắt",
    example: "màu sắc và kiểu dáng bắt mắt * cách trang trí rất bắt mắt",
  },
  {
    word: "bắt gặp",
    part_of_speech: "động từ",
    meaning:
      'gặp, thấy một cách tình cờ, ngẫu nhiên: "Tình cờ bắt gặp nàng đây, Hỏi rằng duyên ấy tình này làm sao?" (ca dao)',
    example:
      'Tình cờ bắt gặp nàng đây, Hỏi rằng duyên ấy tình này làm sao?" (ca dao)',
  },
  {
    word: "bắt mạch",
    part_of_speech: "động từ",
    meaning:
      "ấn nhẹ đầu ngón tay lên chỗ có động mạch (thường ở cổ tay) để biết nhịp và cường độ mạch đập mà chẩn đoán hay theo dõi bệnh: thầy thuốc bắt mạch kê đơn",
    example: "thầy thuốc bắt mạch kê đơn",
  },
  {
    word: "bắt ne bắt nét",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bắt lỗi từng li từng tí để đưa vào khuôn phép: hơi một tí là bắt ne bắt nét",
    example: "hơi một tí là bắt ne bắt nét",
  },
  {
    word: "bắt mối",
    part_of_speech: "động từ",
    meaning: "tìm và liên lạc để lập quan hệ: bắt mối làm ăn",
    example: "bắt mối làm ăn",
  },
  {
    word: "bắt nguồn",
    part_of_speech: "động từ",
    meaning:
      "(sông ngòi) bắt đầu chảy thành dòng nước: sông Hồng bắt nguồn từ tỉnh Vân Nam của Trung Quốc",
    example: "sông Hồng bắt nguồn từ tỉnh Vân Nam của Trung Quốc",
  },
  {
    word: "bắt nguồn",
    part_of_speech: "động từ",
    meaning: "bắt đầu sinh ra: văn học bắt nguồn từ cuộc sống",
    example: "văn học bắt nguồn từ cuộc sống",
  },
  {
    word: "bắt nạt",
    part_of_speech: "động từ",
    meaning:
      "cậy quyền thế, sức mạnh mà doạ dẫm làm cho phải sợ: bắt nạt trẻ con * cậy khoẻ bắt nạt yếu * ma cũ bắt nạt ma mới (tng)",
    example:
      "bắt nạt trẻ con * cậy khoẻ bắt nạt yếu * ma cũ bắt nạt ma mới (tng)",
  },
  {
    word: "bắt nọn",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) làm như đã biết rồi để người nghe chột dạ mà phải nói ra những điều muốn giấu: bắt nọn nhau",
    example: "bắt nọn nhau",
  },
  {
    word: "bắt nhịp",
    part_of_speech: "động từ",
    meaning:
      "điều khiển nhịp cho nhiều người hát hoặc biểu diễn nhạc khí: bắt nhịp cho cả lớp hát",
    example: "bắt nhịp cho cả lớp hát",
  },
  {
    word: "bắt nhịp",
    part_of_speech: "động từ",
    meaning:
      "hoà theo cùng một nhịp: bắt nhịp vào cuộc sống mới * không bắt nhịp được với cơ chế thị trường",
    example:
      "bắt nhịp vào cuộc sống mới * không bắt nhịp được với cơ chế thị trường",
  },
  {
    word: "bắt nhạy",
    part_of_speech: "động từ",
    meaning:
      "nắm rõ và đáp ứng kịp thời, chính xác trước sự thay đổi của tình hình: doanh nghiệp biết bắt nhạy với thị trường",
    example: "doanh nghiệp biết bắt nhạy với thị trường",
  },
  {
    word: "bắt nợ",
    part_of_speech: "động từ",
    meaning:
      "lấy đồ đạc để trừ nợ hoặc để buộc phải nhanh chóng trả nợ: lấy đồ đạc trong nhà để bắt nợ",
    example: "lấy đồ đạc trong nhà để bắt nợ",
  },
  {
    word: "bắt rễ",
    part_of_speech: "động từ",
    meaning:
      "(rễ cây) đâm ra và ăn vào đất: mạ đã bắt rễ * chân như bắt rễ xuống đất",
    example: "mạ đã bắt rễ * chân như bắt rễ xuống đất",
  },
  {
    word: "bắt rễ",
    part_of_speech: "động từ",
    meaning:
      "bắt nguồn, dựa vào làm cơ sở: nghệ thuật bắt rễ từ hiện thực cuộc sống",
    example: "nghệ thuật bắt rễ từ hiện thực cuộc sống",
  },
  {
    word: "bắt rễ",
    part_of_speech: "động từ",
    meaning:
      "chọn người làm nòng cốt để xây dựng tổ chức, lãnh đạo quần chúng: được bắt rễ làm cốt cán",
    example: "được bắt rễ làm cốt cán",
  },
  {
    word: "bắt thăm",
    part_of_speech: "động từ",
    meaning:
      "nhận, chọn thăm để quyết định ai được, ai không, ai trước, ai sau, v.v.: bắt thăm trúng thưởng * bắt thăm xem ai phải đi",
    example: "bắt thăm trúng thưởng * bắt thăm xem ai phải đi",
  },
  {
    word: "bặt tăm",
    part_of_speech: "động từ",
    meaning: "như biệt tăm: đi bặt tăm, không có tin tức gì",
    example: "đi bặt tăm, không có tin tức gì",
  },
  {
    word: "bặt thiệp",
    part_of_speech: "tính từ",
    meaning:
      "lịch sự, khéo léo, thông thạo trong cách giao thiệp: một con người bặt thiệp",
    example: "một con người bặt thiệp",
  },
  {
    word: "bắt thóp",
    part_of_speech: "động từ",
    meaning:
      'biết rõ điểm yếu hay chỗ sơ hở để có thể lợi dụng: "Ông lý nhà ta biết thóp anh chồng non mặt, nên đến loè anh ta đủ thứ." (NCao; 28)',
    example:
      'Ông lý nhà ta biết thóp anh chồng non mặt, nên đến loè anh ta đủ thứ." (NCao; 28)',
  },
  {
    word: "bắt tội",
    part_of_speech: "động từ",
    meaning:
      "bắt phải chịu hình phạt, chịu tội: thương tình nên không nỡ bắt tội * làm điều ác sẽ bị trời bắt tội",
    example:
      "thương tình nên không nỡ bắt tội * làm điều ác sẽ bị trời bắt tội",
  },
  {
    word: "bắt tội",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) làm cho phải chịu tội tình, khổ sở: bắt tội thằng bé phải đi mưa",
    example: "bắt tội thằng bé phải đi mưa",
  },
  {
    word: "bắt tay",
    part_of_speech: "động từ",
    meaning:
      "nắm bàn tay người khác để chào hay để biểu lộ tình cảm: bắt tay chào tạm biệt * bắt tay chúc mừng",
    example: "bắt tay chào tạm biệt * bắt tay chúc mừng",
  },
  {
    word: "bắt tay",
    part_of_speech: "động từ",
    meaning: "đặt quan hệ hợp tác để cùng làm việc gì: không bắt tay với giặc",
    example: "không bắt tay với giặc",
  },
  {
    word: "bắt tay",
    part_of_speech: "động từ",
    meaning:
      "bắt đầu tiến hành công việc gì: dọn dẹp xong là bắt tay vào làm bếp",
    example: "dọn dẹp xong là bắt tay vào làm bếp",
  },
  {
    word: "bắt tréo",
    part_of_speech: "động từ",
    meaning:
      'gác cái nọ ngang qua cái kia theo hình chữ X: bắt tréo hai tay * "Bây giờ anh đang ngồi bắt tréo kheo, hất hàm lên, nghênh trời." (NCao; 4)',
    example:
      'bắt tréo hai tay * "Bây giờ anh đang ngồi bắt tréo kheo, hất hàm lên, nghênh trời." (NCao; 4)',
  },
  {
    word: "bắt vạ",
    part_of_speech: "động từ",
    meaning:
      "bắt phải nộp phạt vì đã làm điều trái với tục lệ hay quy ước của làng xã thời trước: chửa hoang, bị làng bắt vạ",
    example: "chửa hoang, bị làng bắt vạ",
  },
  {
    word: "bấc",
    part_of_speech: "danh từ",
    meaning:
      "cây thân cỏ mọc thành cụm ở ven đầm hồ, thân có lõi xốp và nhẹ: nhẹ như bấc",
    example: "nhẹ như bấc",
  },
  {
    word: "bấc",
    part_of_speech: "danh từ",
    meaning:
      'lõi của cây bấc hoặc đoạn vải, sợi dùng làm vật dẫn dầu để đun hoặc thắp sáng: khêu bấc đèn * "Đêm qua rót đĩa dầu đầy, Bấc non không cháy oan mày dầu ơi." (ca dao)',
    example:
      'khêu bấc đèn * "Đêm qua rót đĩa dầu đầy, Bấc non không cháy oan mày dầu ơi." (ca dao)',
  },
  {
    word: "bấc",
    part_of_speech: "danh từ",
    meaning:
      "lõi xốp và nhẹ của một số cây: bấc sậy * mía bị bấc (ruột bị khô nước, trở nên xốp)",
    example: "bấc sậy * mía bị bấc (ruột bị khô nước, trở nên xốp)",
  },
  {
    word: "bấc",
    part_of_speech: "danh từ",
    meaning:
      '(phía) bắc: hơi bấc se lạnh * "Bây giờ chớp bấc mưa đông, Anh em sắm sửa vào trong khoang thuyền!" (ca dao)',
    example:
      'hơi bấc se lạnh * "Bây giờ chớp bấc mưa đông, Anh em sắm sửa vào trong khoang thuyền!" (ca dao)',
  },
  {
    word: "bậc",
    part_of_speech: "danh từ",
    meaning:
      "chỗ đặt chân để bước lên xuống: bước lên bậc cửa * leo lên các bậc đá * bậc thang",
    example: "bước lên bậc cửa * leo lên các bậc đá * bậc thang",
  },
  {
    word: "bậc",
    part_of_speech: "danh từ",
    meaning:
      "thứ, hạng xếp theo trình độ cao thấp, trên dưới: công nhân bậc bốn * tài giỏi bậc nhất thiên hạ",
    example: "công nhân bậc bốn * tài giỏi bậc nhất thiên hạ",
  },
  {
    word: "bậc",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ người thuộc hàng đáng tôn kính: bậc cha mẹ * bậc anh hùng * các bậc tiền bối",
    example: "bậc cha mẹ * bậc anh hùng * các bậc tiền bối",
  },
  {
    word: "bậc",
    part_of_speech: "danh từ",
    meaning:
      "cấp học được phân theo những tiêu chí nhất định của một hệ thống giáo dục: bậc tiểu học * bậc đại học",
    example: "bậc tiểu học * bậc đại học",
  },
  {
    word: "hiền thục",
    part_of_speech: "tính từ",
    meaning: "(người phụ nữ) hiền hậu và dịu dàng: người phụ nữ hiền thục",
    example: "người phụ nữ hiền thục",
  },
  {
    word: "hiện thực",
    part_of_speech: "",
    meaning:
      "cái có thật, tồn tại trong thực tế: ước mơ đã trở thành hiện thực * tác phẩm có giá trị hiện thực",
    example: "ước mơ đã trở thành hiện thực * tác phẩm có giá trị hiện thực",
  },
  {
    word: "hiền triết",
    part_of_speech: "danh từ",
    meaning:
      "người có kiến thức và những hiểu biết cao sâu, được người đời tôn sùng: nhà hiền triết",
    example: "nhà hiền triết",
  },
  {
    word: "hiện trạng",
    part_of_speech: "danh từ",
    meaning:
      "tình trạng hiện nay: hiện trạng, sức khoẻ của anh ta vẫn rất xấu * kiểm tra hiện trạng máy móc",
    example:
      "hiện trạng, sức khoẻ của anh ta vẫn rất xấu * kiểm tra hiện trạng máy móc",
  },
  {
    word: "hiện tình",
    part_of_speech: "danh từ",
    meaning:
      "tình hình thực tại: hiện tình thế giặc đang mạnh * tìm hiểu rõ hiện tình rồi mới quyết định",
    example:
      "hiện tình thế giặc đang mạnh * tìm hiểu rõ hiện tình rồi mới quyết định",
  },
  {
    word: "hiện thời",
    part_of_speech: "danh từ",
    meaning: "như hiện nay: hoàn cảnh hiện thời * công việc hiện thời",
    example: "hoàn cảnh hiện thời * công việc hiện thời",
  },
  {
    word: "hiện thời",
    part_of_speech: "danh từ",
    meaning: "(hiếm) thời nay: gặp mặt những nhà thơ nổi tiếng hiện thời",
    example: "gặp mặt những nhà thơ nổi tiếng hiện thời",
  },
  {
    word: "hiền từ",
    part_of_speech: "tính từ",
    meaning: "hiền và có lòng thương người: cụ già hiền từ * ánh mắt hiền từ",
    example: "cụ già hiền từ * ánh mắt hiền từ",
  },
  {
    word: "hiện tượng",
    part_of_speech: "danh từ",
    meaning:
      "cái xảy ra trong không gian, thời gian mà người ta nhận thấy: mưa là một hiện tượng tự nhiên * đấu tranh giai cấp là một hiện tượng xã hội * có hiện tượng bão",
    example:
      "mưa là một hiện tượng tự nhiên * đấu tranh giai cấp là một hiện tượng xã hội * có hiện tượng bão",
  },
  {
    word: "hiện tượng",
    part_of_speech: "danh từ",
    meaning:
      "hình thức biểu hiện ra bên ngoài của sự vật mà giác quan thu nhận được một cách trực tiếp; phân biệt với bản chất: phân biệt giữa hiện tượng và bản chất",
    example: "phân biệt giữa hiện tượng và bản chất",
  },
  {
    word: "hiện trường",
    part_of_speech: "danh từ",
    meaning:
      "nơi xảy ra sự việc hay hoạt động nào đó: giữ nguyên hiện trường * kiểm tra hiện trường",
    example: "giữ nguyên hiện trường * kiểm tra hiện trường",
  },
  {
    word: "hiện vật",
    part_of_speech: "danh từ",
    meaning:
      "vật có thực, phân biệt với tiền bạc tương ứng: trả lương bằng hiện vật",
    example: "trả lương bằng hiện vật",
  },
  {
    word: "hiện vật",
    part_of_speech: "danh từ",
    meaning:
      "vật có thực, thường dùng để làm bằng cớ, để chứng minh: không được sờ vào hiện vật * tìm thấy nhiều hiện vật quý",
    example: "không được sờ vào hiện vật * tìm thấy nhiều hiện vật quý",
  },
  {
    word: "hiếng",
    part_of_speech: "tính từ",
    meaning: "(mắt) nhìn lệch về một bên, do bị tật: mắt bị hiếng",
    example: "mắt bị hiếng",
  },
  {
    word: "hiếng",
    part_of_speech: "động từ",
    meaning: "ngước (mắt) nhìn lệch về một bên: hiếng mắt nhìn",
    example: "hiếng mắt nhìn",
  },
  {
    word: "hiển vinh",
    part_of_speech: "tính từ",
    meaning:
      '(cũ, văn chương) vẻ vang, rạng rỡ vì làm nên việc lớn, có danh vọng: "Trạng nguyên dẹp giặc đã bình, Kiệu vàng tán bạc hiển vinh về nhà." (LVT)',
    example:
      'Trạng nguyên dẹp giặc đã bình, Kiệu vàng tán bạc hiển vinh về nhà." (LVT)',
  },
  {
    word: "hiêng hiếng",
    part_of_speech: "tính từ",
    meaning: "hơi hiếng: cặp mắt hơi hiêng hiếng",
    example: "cặp mắt hơi hiêng hiếng",
  },
  {
    word: "hiếp",
    part_of_speech: "động từ",
    meaning:
      'dùng sức mạnh hoặc quyền thế bắt người khác phải chịu thua thiệt mà không dám làm gì: ỷ mạnh hiếp yếu * "Khinh người hèn, cậy mình sang, Lấy điều thần thế, toan đường hiếp ai." (NĐM)',
    example:
      'ỷ mạnh hiếp yếu * "Khinh người hèn, cậy mình sang, Lấy điều thần thế, toan đường hiếp ai." (NĐM)',
  },
  {
    word: "hiệp",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng khoảng thời gian nhất định trong một trận đấu, được chia ra theo quy định: mỗi hiệp bóng đá kéo dài 45 phút * trận đấu đang ở hiệp đấu thứ năm",
    example:
      "mỗi hiệp bóng đá kéo dài 45 phút * trận đấu đang ở hiệp đấu thứ năm",
  },
  {
    word: "hiệp",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng khoảng thời gian diễn ra một hoạt động sôi nổi, ở giữa có nghỉ: trở dậy lúc gà gáy hiệp nhất",
    example: "trở dậy lúc gà gáy hiệp nhất",
  },
  {
    word: "hiếp đáp",
    part_of_speech: "động từ",
    meaning:
      "hiếp, bắt người khác phải chịu thua thiệt (nói khái quát): bị bọn xấu hiếp đáp",
    example: "bị bọn xấu hiếp đáp",
  },
  {
    word: "hiệp định",
    part_of_speech: "danh từ",
    meaning:
      "điều ước loại thông dụng nhất do hai hay nhiều nước kí kết để giải quyết những vấn đề chính trị, kinh tế, quân sự, văn hoá, v.v., tầm quan trọng dưới hiệp ước: hiệp định Genever * hiệp định Paris năm 1973",
    example: "hiệp định Genever * hiệp định Paris năm 1973",
  },
  {
    word: "hiệp đồng",
    part_of_speech: "động từ",
    meaning:
      "phối hợp hành động trong chiến đấu: phương án hiệp đồng * hiệp đồng chiến đấu",
    example: "phương án hiệp đồng * hiệp đồng chiến đấu",
  },
  {
    word: "hiệp định khung",
    part_of_speech: "danh từ",
    meaning:
      "hiệp định có tính chất nguyên tắc chung về một vấn đề lớn, thường được kí kết giữa hai chính phủ, dựa vào đó có thể có những kí kết về những vấn đề cụ thể: kí kết hiệp định khung về hợp tác kinh tế",
    example: "kí kết hiệp định khung về hợp tác kinh tế",
  },
  {
    word: "hiệp định sơ bộ",
    part_of_speech: "danh từ",
    meaning:
      "hiệp định tạm thời để đi tới hiệp định chính thức: hiệp định sơ bộ 6-3-1946 giữa Pháp và Việt Nam",
    example: "hiệp định sơ bộ 6-3-1946 giữa Pháp và Việt Nam",
  },
  {
    word: "hiệp khách",
    part_of_speech: "danh từ",
    meaning: "(cũ) như hiệp sĩ: hiệp khách giang hồ",
    example: "hiệp khách giang hồ",
  },
  {
    word: "hiệp lực",
    part_of_speech: "động từ",
    meaning:
      "cùng góp sức vào để làm một việc gì: hiệp lực với nhau để cùng đối phó * đồng tâm hiệp lực",
    example: "hiệp lực với nhau để cùng đối phó * đồng tâm hiệp lực",
  },
  {
    word: "hiệp hội",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức quần chúng gồm nhiều tổ chức nhỏ hơn, có tính chất như một hội: hiệp hội chè Việt Nam * chủ tịch hiệp hội",
    example: "hiệp hội chè Việt Nam * chủ tịch hiệp hội",
  },
  {
    word: "hiệp sĩ",
    part_of_speech: "danh từ",
    meaning:
      "người có sức mạnh và lòng hào hiệp, hay bênh vực kẻ yếu, cứu giúp người hoạn nạn (một loại nhân vật lí tưởng trong tiểu thuyết cũ): trang phục của các hiệp sĩ thời Trung Cổ * một trang hiệp sĩ",
    example: "trang phục của các hiệp sĩ thời Trung Cổ * một trang hiệp sĩ",
  },
  {
    word: "hiệp thương",
    part_of_speech: "động từ",
    meaning:
      "họp thương lượng về những vấn đề chính trị, kinh tế có liên quan chung tới các bên: hội nghị hiệp thương",
    example: "hội nghị hiệp thương",
  },
  {
    word: "hiệp tác",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) (người, đơn vị sản xuất) cùng phối hợp tham gia vào một quá trình lao động hay vào nhiều quá trình lao động khác nhau, để bổ sung cho nhau làm ra một sản phẩm hay hoàn thành một công việc nhất định: hiệp tác lao động",
    example: "hiệp tác lao động",
  },
  {
    word: "hiệp vần",
    part_of_speech: "động từ",
    meaning: "làm cho câu thơ có vần với nhau: đọc chệch đi cho hiệp vận",
    example: "đọc chệch đi cho hiệp vận",
  },
  {
    word: "hiểu biết",
    part_of_speech: "động từ",
    meaning:
      "biết rõ, hiểu thấu: hiểu biết sâu về chuyên môn * không hiểu biết về pháp luật",
    example: "hiểu biết sâu về chuyên môn * không hiểu biết về pháp luật",
  },
  {
    word: "hiểu biết",
    part_of_speech: "động từ",
    meaning:
      "biết và có thái độ cảm thông với người khác: còn ít hiểu biết về bạn bè",
    example: "còn ít hiểu biết về bạn bè",
  },
  {
    word: "hiểu biết",
    part_of_speech: "danh từ",
    meaning:
      "điều hiểu biết: dựa vào hiểu biết của mình để đánh giá * vốn hiểu biết còn hạn chế",
    example:
      "dựa vào hiểu biết của mình để đánh giá * vốn hiểu biết còn hạn chế",
  },
  {
    word: "hiếu",
    part_of_speech: "danh từ",
    meaning:
      "lòng kính yêu và biết ơn đối với cha mẹ: đạo hiếu * một người con có hiếu * giữ tròn chữ hiếu",
    example: "đạo hiếu * một người con có hiếu * giữ tròn chữ hiếu",
  },
  {
    word: "hiếu",
    part_of_speech: "danh từ",
    meaning:
      "việc tang lễ của cha mẹ, của người hàng trên trong gia đình nói chung: việc hiếu, việc hỉ",
    example: "việc hiếu, việc hỉ",
  },
  {
    word: "hiếu",
    part_of_speech: "tính từ",
    meaning: "có lòng kính yêu, hết lòng chăm sóc cha mẹ: người con hiếu",
    example: "người con hiếu",
  },
  {
    word: "hiệp ước",
    part_of_speech: "danh từ",
    meaning:
      "điều ước loại quan trọng nhất do hai hay nhiều nước kí kết, trong đó ghi rõ những điều cam kết của các bên về những vấn đề chính trị, quân sự, kinh tế, văn hoá: kí hiệp ước * hiệp ước thương mại quốc tế",
    example: "kí hiệp ước * hiệp ước thương mại quốc tế",
  },
  {
    word: "hiệp vận",
    part_of_speech: "động từ",
    meaning: "làm cho câu thơ có vần với nhau: đọc chệch đi cho hiệp vận",
    example: "đọc chệch đi cho hiệp vận",
  },
  {
    word: "hiếu chiến",
    part_of_speech: "tính từ",
    meaning:
      "có thái độ thích gây chiến tranh, chủ trương giải quyết mọi sự xung đột, mọi mâu thuẫn bằng chiến tranh: chính sách hiếu chiến * những kẻ hiếu chiến",
    example: "chính sách hiếu chiến * những kẻ hiếu chiến",
  },
  {
    word: "hiểu",
    part_of_speech: "động từ",
    meaning:
      "nhận ra ý nghĩa, bản chất, lí lẽ của cái gì, bằng sự vận dụng trí tuệ: hiểu bài học * vấn đề cũng dễ hiểu * hiểu sai đầu bài",
    example: "hiểu bài học * vấn đề cũng dễ hiểu * hiểu sai đầu bài",
  },
  {
    word: "hiểu",
    part_of_speech: "động từ",
    meaning:
      "biết được ý nghĩ, tình cảm, quan điểm của người khác: hiểu được lòng nhau * không hiểu ý bạn",
    example: "hiểu được lòng nhau * không hiểu ý bạn",
  },
  {
    word: "hiệu chỉnh",
    part_of_speech: "động từ",
    meaning:
      "chỉnh sửa những sai sót của máy móc, thiết bị nhằm đạt một độ chính xác và độ tin cậy cần thiết: hiệu chỉnh động cơ",
    example: "hiệu chỉnh động cơ",
  },
  {
    word: "hiệu",
    part_of_speech: "danh từ",
    meaning: "cửa hiệu (nói tắt): mở hiệu ảnh * hiệu cắt tóc * hiệu cầm đồ",
    example: "mở hiệu ảnh * hiệu cắt tóc * hiệu cầm đồ",
  },
  {
    word: "hiệu",
    part_of_speech: "danh từ",
    meaning:
      "cái có thể nhận biết trực tiếp và dễ dàng, dùng để thông báo cho biết điều gì theo quy ước: treo đèn hiệu * đốt pháo hiệu",
    example: "treo đèn hiệu * đốt pháo hiệu",
  },
  {
    word: "hiệu",
    part_of_speech: "danh từ",
    meaning:
      "cái có thể nhìn thấy và phân biệt dễ dàng, dùng để biểu thị một loại sự vật nào đó theo quy định: cờ hiệu * số hiệu xe",
    example: "cờ hiệu * số hiệu xe",
  },
  {
    word: "hiệu",
    part_of_speech: "danh từ",
    meaning:
      "tên hiệu (nói tắt): Nguyễn Du, tên chữ là Tố Như hiệu là Thanh Hiên",
    example: "Nguyễn Du, tên chữ là Tố Như hiệu là Thanh Hiên",
  },
  {
    word: "hiếu đễ",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) có hiếu với cha mẹ và hoà thuận với các anh chị trong gia đình: con người hiếu đễ",
    example: "con người hiếu đễ",
  },
  {
    word: "hiệu dụng",
    part_of_speech: "danh từ",
    meaning:
      "hiệu quả và tác dụng (nói khái quát): phương pháp mới đã bắt đầu có hiệu dụng * tính hiệu dụng của sáng chế",
    example:
      "phương pháp mới đã bắt đầu có hiệu dụng * tính hiệu dụng của sáng chế",
  },
  {
    word: "hiếu danh",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có tư tưởng ham danh vọng, tiếng tăm: giễu cợt thói háo danh",
    example: "giễu cợt thói háo danh",
  },
  {
    word: "hiếu hạnh",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như hiếu thảo: người con dâu hiếu hạnh",
    example: "người con dâu hiếu hạnh",
  },
  {
    word: "hiệu đính",
    part_of_speech: "động từ",
    meaning:
      "xem xét, đối chiếu và chữa lại văn bản cho đúng: hiệu đính lại các bản dịch",
    example: "hiệu đính lại các bản dịch",
  },
  {
    word: "hiếu học",
    part_of_speech: "tính từ",
    meaning:
      "có thái độ ham học, chịu khó học: một người hiếu học * anh ta vốn là người thông minh, hiếu học",
    example: "một người hiếu học * anh ta vốn là người thông minh, hiếu học",
  },
  {
    word: "hiệu ích",
    part_of_speech: "danh từ",
    meaning:
      "hiệu quả và lợi ích (nói khái quát): hiệu ích kinh tế * biến tiềm năng thành hiệu ích",
    example: "hiệu ích kinh tế * biến tiềm năng thành hiệu ích",
  },
  {
    word: "hiếu hỉ",
    part_of_speech: "danh từ",
    meaning: "việc ma chay và việc cưới xin (nói khái quát): lo việc hiếu hỉ",
    example: "lo việc hiếu hỉ",
  },
  {
    word: "hiệu lệnh",
    part_of_speech: "danh từ",
    meaning:
      "lệnh được phát ra bằng một hình thức cụ thể nào đó: thổi một hồi còi làm hiệu lệnh xuất phát",
    example: "thổi một hồi còi làm hiệu lệnh xuất phát",
  },
  {
    word: "hiếu hỷ",
    part_of_speech: "danh từ",
    meaning: "việc ma chay và việc cưới xin (nói khái quát): lo việc hiếu hỉ",
    example: "lo việc hiếu hỉ",
  },
  {
    word: "hiếu khách",
    part_of_speech: "tính từ",
    meaning: "có thái độ mến khách: tỏ lòng hiếu khách",
    example: "tỏ lòng hiếu khách",
  },
  {
    word: "hiếu động",
    part_of_speech: "tính từ",
    meaning:
      "có bản tính ưa hoạt động, không chịu ngồi yên (thường dùng với trẻ nhỏ, là con trai): một đứa trẻ hiếu động * hiếu động từ bé",
    example: "một đứa trẻ hiếu động * hiếu động từ bé",
  },
  {
    word: "hiếu kì",
    part_of_speech: "tính từ",
    meaning:
      "có tính hay tò mò, ham thích tìm hiểu những điều mới lạ: làm thoả mãn tính hiếu kì * cậu bé hiếu kì * những cặp mắt hiếu kì",
    example:
      "làm thoả mãn tính hiếu kì * cậu bé hiếu kì * những cặp mắt hiếu kì",
  },
  {
    word: "hiếu kỳ",
    part_of_speech: "tính từ",
    meaning:
      "có tính hay tò mò, ham thích tìm hiểu những điều mới lạ: làm thoả mãn tính hiếu kì * cậu bé hiếu kì * những cặp mắt hiếu kì",
    example:
      "làm thoả mãn tính hiếu kì * cậu bé hiếu kì * những cặp mắt hiếu kì",
  },
  {
    word: "hiệu quả",
    part_of_speech: "danh từ",
    meaning:
      "kết quả thực của việc làm mang lại: nâng cao hiệu quả lao động * làm việc không có hiệu quả",
    example: "nâng cao hiệu quả lao động * làm việc không có hiệu quả",
  },
  {
    word: "hiệu số",
    part_of_speech: "danh từ",
    meaning:
      "kết quả của phép trừ một số cho một số khác: 5 là hiệu số của 9 trừ 4",
    example: "5 là hiệu số của 9 trừ 4",
  },
  {
    word: "hiệu lực",
    part_of_speech: "danh từ",
    meaning:
      "tác dụng thực tế, đúng như yêu cầu: lời nói của ông ta rất có hiệu lực",
    example: "lời nói của ông ta rất có hiệu lực",
  },
  {
    word: "hiệu lực",
    part_of_speech: "danh từ",
    meaning:
      "thời hiệu thi hành: hợp đồng có hiệu lực từ ngày kí * quyết định đã hết hiệu lực",
    example: "hợp đồng có hiệu lực từ ngày kí * quyết định đã hết hiệu lực",
  },
  {
    word: "hiệu năng",
    part_of_speech: "danh từ",
    meaning:
      "khả năng có thể mang lại kết quả khi dùng đến: hiệu năng của máy tính",
    example: "hiệu năng của máy tính",
  },
  {
    word: "hiệu nghiệm",
    part_of_speech: "tính từ",
    meaning:
      "có hiệu quả, có hiệu lực một cách rõ rệt: một phương pháp hiệu nghiệm * liều thuốc rất hiệu nghiệm",
    example: "một phương pháp hiệu nghiệm * liều thuốc rất hiệu nghiệm",
  },
  {
    word: "hiếu nghĩa",
    part_of_speech: "tính từ",
    meaning:
      "có hiếu với cha mẹ, có tình nghĩa thuỷ chung với những người mình mang ơn: một người hiếu nghĩa",
    example: "một người hiếu nghĩa",
  },
  {
    word: "hiếu sinh",
    part_of_speech: "tính từ",
    meaning:
      "có lòng quý trọng sinh mệnh, tránh những hành động gây hại đến sự sống của muôn loài: mở đường hiếu sinh * lòng hiếu sinh",
    example: "mở đường hiếu sinh * lòng hiếu sinh",
  },
  {
    word: "hiếu sắc",
    part_of_speech: "tính từ",
    meaning: "có tính ham mê gái đẹp: kẻ háo sắc",
    example: "kẻ háo sắc",
  },
  {
    word: "hiệu suất",
    part_of_speech: "danh từ",
    meaning:
      "kết quả lao động biểu hiện bằng khối lượng công việc làm được trong một thời gian nhất định: nâng cao hiệu suất làm việc",
    example: "nâng cao hiệu suất làm việc",
  },
  {
    word: "hiệu suất",
    part_of_speech: "danh từ",
    meaning:
      "đại lượng đặc trưng cho mức sử dụng năng lượng hữu ích của một máy hay một hệ thống nào đó, bằng tỉ số năng lượng hữu ích với tổng năng lượng mà máy hay hệ thống đó nhận được: hiệu suất của nhà máy nhiệt điện này là 50%",
    example: "hiệu suất của nhà máy nhiệt điện này là 50%",
  },
  {
    word: "hiếu thắng",
    part_of_speech: "tính từ",
    meaning:
      "có tính lúc nào cũng muốn thắng, muốn hơn người: bệnh hiếu thắng * có tính hiếu thắng",
    example: "bệnh hiếu thắng * có tính hiếu thắng",
  },
  {
    word: "hiếu sự",
    part_of_speech: "tính từ",
    meaning:
      "có tính hay sinh sự, gây chuyện phiền phức, lôi thôi: những kẻ hiếu sự",
    example: "những kẻ hiếu sự",
  },
  {
    word: "hiếu thuận",
    part_of_speech: "tính từ",
    meaning: "có lòng kính yêu và biết nghe lời cha mẹ: hiếu thuận với mẹ già",
    example: "hiếu thuận với mẹ già",
  },
  {
    word: "hiếu thảo",
    part_of_speech: "tính từ",
    meaning:
      "có lòng kính yêu cha mẹ: người con hiếu thảo * tấm lòng hiếu thảo",
    example: "người con hiếu thảo * tấm lòng hiếu thảo",
  },
  {
    word: "hĩm",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ, cũ, khẩu ngữ) đứa con gái còn bé (theo cách gọi của nông dân): thằng cu, cái hĩm",
    example: "thằng cu, cái hĩm",
  },
  {
    word: "hĩm",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để gọi thân mật người nông dân có con gái đầu lòng còn bé: chị hĩm có nhà không?",
    example: "chị hĩm có nhà không?",
  },
  {
    word: "hiệu ứng nhà kính",
    part_of_speech: "danh từ",
    meaning:
      "hiệu ứng xảy ra đối với vật thể được bao bọc bởi một chất liệu cho phép sóng điện từ mang nhiệt vào đi qua dễ dàng hơn sóng điện từ mang nhiệt từ vật ra, vì vậy nhiệt độ của vật sẽ tăng dần lên cho đến khi đạt cân bằng: hiệu ứng nhà kính khiến cho nhiệt độ của Trái Đất tăng lên",
    example: "hiệu ứng nhà kính khiến cho nhiệt độ của Trái Đất tăng lên",
  },
  {
    word: "hiệu triệu",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) kêu gọi quần chúng đông đảo làm một việc gì có ý nghĩa chính trị cấp bách: hiệu triệu dân chúng khởi nghĩa",
    example: "hiệu triệu dân chúng khởi nghĩa",
  },
  {
    word: "hiệu triệu",
    part_of_speech: "danh từ",
    meaning: "lời hiệu triệu: ra hiệu triệu",
    example: "ra hiệu triệu",
  },
  {
    word: "hiệu ứng lồng kính",
    part_of_speech: "danh từ",
    meaning:
      "hiệu ứng xảy ra đối với vật thể được bao bọc bởi một chất liệu cho phép sóng điện từ mang nhiệt vào đi qua dễ dàng hơn sóng điện từ mang nhiệt từ vật ra, vì vậy nhiệt độ của vật sẽ tăng dần lên cho đến khi đạt cân bằng: hiệu ứng nhà kính khiến cho nhiệt độ của Trái Đất tăng lên",
    example: "hiệu ứng nhà kính khiến cho nhiệt độ của Trái Đất tăng lên",
  },
  {
    word: "him him",
    part_of_speech: "tính từ",
    meaning:
      "(mắt) ở trạng thái không mở to được, trông gần như nhắm: cặp mắt him him",
    example: "cặp mắt him him",
  },
  {
    word: "hỉnh",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) phổng (mũi): được khen, sướng hỉnh mũi",
    example: "được khen, sướng hỉnh mũi",
  },
  {
    word: "hin",
    part_of_speech: "tính từ",
    meaning: "(hiếm) rất nhỏ và hẹp: mũi bé hin * lỗ kim nhỏ hin * bé hin hin",
    example: "mũi bé hin * lỗ kim nhỏ hin * bé hin hin",
  },
  {
    word: "him híp",
    part_of_speech: "tính từ",
    meaning: "hơi híp: ngủ nhiều, mắt him híp",
    example: "ngủ nhiều, mắt him híp",
  },
  {
    word: "hình ảnh",
    part_of_speech: "danh từ",
    meaning:
      "hình người, vật, cảnh tượng thu được bằng khí cụ quang học (như máy ảnh), hoặc để lại ấn tượng nhất định và tái hiện được trong trí: hình ảnh quê hương * hình ảnh mẹ lại hiện lên trong tâm trí",
    example: "hình ảnh quê hương * hình ảnh mẹ lại hiện lên trong tâm trí",
  },
  {
    word: "hình ảnh",
    part_of_speech: "danh từ",
    meaning:
      "khả năng gợi tả sinh động trong cách diễn đạt: lối diễn đạt có hình ảnh * dùng nhiều từ ngữ giàu hình ảnh",
    example: "lối diễn đạt có hình ảnh * dùng nhiều từ ngữ giàu hình ảnh",
  },
  {
    word: "hình bóng",
    part_of_speech: "danh từ",
    meaning: "hình ảnh không rõ nét: hình bóng tuổi thơ",
    example: "hình bóng tuổi thơ",
  },
  {
    word: "hình",
    part_of_speech: "danh từ",
    meaning:
      "toàn thể nói chung những đường nét giới hạn của một vật trong không gian, giúp phân biệt được rõ vật đó với xung quanh: trăng non hình lưỡi liềm * cắt thành hình ngôi sao * thân nhau như hình với bóng",
    example:
      "trăng non hình lưỡi liềm * cắt thành hình ngôi sao * thân nhau như hình với bóng",
  },
  {
    word: "hình",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) ảnh: tấm hình * chụp hình",
    example: "tấm hình * chụp hình",
  },
  {
    word: "hình",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp điểm trên mặt phẳng hay trong không gian: hình chữ nhật * hình không gian * hình ellips",
    example: "hình chữ nhật * hình không gian * hình ellips",
  },
  {
    word: "hình",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) hình học (nói tắt): môn hình * tiết hình",
    example: "môn hình * tiết hình",
  },
  {
    word: "hình bầu dục",
    part_of_speech: "danh từ",
    meaning:
      "hình trông giống như hình quả trứng gà: đĩa hình bầu dục * hồ nước xây theo hình bầu dục",
    example: "đĩa hình bầu dục * hồ nước xây theo hình bầu dục",
  },
  {
    word: "hình dáng",
    part_of_speech: "danh từ",
    meaning:
      "hình của một vật làm thành vẻ riêng bên ngoài của nó: hình dáng tiều tuỵ * hình dáng ngôi nhà",
    example: "hình dáng tiều tuỵ * hình dáng ngôi nhà",
  },
  {
    word: "hình dạng",
    part_of_speech: "danh từ",
    meaning:
      "hình của một vật, phân biệt nó với những vật khác loại: thay đổi hình dạng * hình dạng kì dị",
    example: "thay đổi hình dạng * hình dạng kì dị",
  },
  {
    word: "hình dong",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, cũng hình dong) hình thức bên ngoài của con người: "Một chàng vừa trạc thanh xuân, Hình dung chải chuốt, áo khăn dịu dàng." (TKiều)',
    example:
      "Một chàng vừa trạc thanh xuân, Hình dung chải chuốt, áo khăn dịu dàng.",
  },
  {
    word: "hình dong",
    part_of_speech: "động từ",
    meaning:
      "tưởng tượng ra trong trí một cách khá rõ nét: hình dung lại nét mặt của người bạn cũ * không hình dung nổi sự việc",
    example:
      "hình dung lại nét mặt của người bạn cũ * không hình dung nổi sự việc",
  },
  {
    word: "hình dung",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, cũng hình dong) hình thức bên ngoài của con người: "Một chàng vừa trạc thanh xuân, Hình dung chải chuốt, áo khăn dịu dàng." (TKiều)',
    example:
      "Một chàng vừa trạc thanh xuân, Hình dung chải chuốt, áo khăn dịu dàng.",
  },
  {
    word: "hình dung",
    part_of_speech: "động từ",
    meaning:
      "tưởng tượng ra trong trí một cách khá rõ nét: hình dung lại nét mặt của người bạn cũ * không hình dung nổi sự việc",
    example:
      "hình dung lại nét mặt của người bạn cũ * không hình dung nổi sự việc",
  },
  {
    word: "hinh hích",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng cười nhẹ và dài, có vẻ rất khoái chí, thoải mái: cười hinh hích",
    example: "cười hinh hích",
  },
  {
    word: "hình nhân",
    part_of_speech: "danh từ",
    meaning:
      "hình người bằng giấy, dùng để cúng rồi đốt đi, theo mê tín: đốt hình nhân * hình nhân thế mạng",
    example: "đốt hình nhân * hình nhân thế mạng",
  },
  {
    word: "hình như",
    part_of_speech: "",
    meaning:
      "tổ hợp biểu thị ý phỏng đoán một cách dè dặt, dựa trên những gì trực tiếp cảm thấy được: trông quen quen, hình như đã gặp ở đâu rồi * hình như anh ấy bị ốm",
    example:
      "trông quen quen, hình như đã gặp ở đâu rồi * hình như anh ấy bị ốm",
  },
  {
    word: "hình mẫu",
    part_of_speech: "danh từ",
    meaning:
      "cái dùng làm mẫu để phỏng theo, noi theo: đưa ra hình mẫu loại máy tính bỏ túi * làm theo đúng hình mẫu",
    example: "đưa ra hình mẫu loại máy tính bỏ túi * làm theo đúng hình mẫu",
  },
  {
    word: "hình nộm",
    part_of_speech: "danh từ",
    meaning:
      "hình người giả, thường được làm vật để tượng trưng, thay thế cho một kẻ xấu: đốt hình nộm",
    example: "đốt hình nộm",
  },
  {
    word: "hình phạt",
    part_of_speech: "danh từ",
    meaning:
      "hình thức trừng trị tương xứng dành cho kẻ phạm tội: khung hình phạt",
    example: "khung hình phạt",
  },
  {
    word: "hình thái",
    part_of_speech: "danh từ",
    meaning:
      "toàn thể nói chung những gì thuộc về cái bên ngoài, có thể quan sát được của sự vật: hình thái địa lí * hình thái kinh tế - xã hội",
    example: "hình thái địa lí * hình thái kinh tế - xã hội",
  },
  {
    word: "hình thái",
    part_of_speech: "danh từ",
    meaning: "hình thức biểu hiện ra: văn nghệ là một hình thái ý thức xã hội",
    example: "văn nghệ là một hình thái ý thức xã hội",
  },
  {
    word: "hình sự",
    part_of_speech: "danh từ",
    meaning:
      "việc trừng trị những tội xâm phạm nghiêm trọng đến an ninh quốc gia, trật tự xã hội (nói khái quát): bộ luật hình sự * án hình sự * tội phạm hình sự",
    example: "bộ luật hình sự * án hình sự * tội phạm hình sự",
  },
  {
    word: "hình thành",
    part_of_speech: "động từ",
    meaning:
      "nảy sinh và bắt đầu tồn tại như một thực thể: một nếp sống mới đang dần được hình thành",
    example: "một nếp sống mới đang dần được hình thành",
  },
  {
    word: "hình thể",
    part_of_speech: "danh từ",
    meaning:
      "toàn thể nói chung những đường nét bên ngoài: tập luyện để có hình thể đẹp",
    example: "tập luyện để có hình thể đẹp",
  },
  {
    word: "hình thế",
    part_of_speech: "danh từ",
    meaning:
      "hình dáng mặt đất: hình thế non sông * chọn chỗ có hình thế đẹp để xây nhà",
    example: "hình thế non sông * chọn chỗ có hình thế đẹp để xây nhà",
  },
  {
    word: "hình thế",
    part_of_speech: "danh từ",
    meaning:
      "tình hình chính trị hoặc quân sự có những nét đặc biệt nào đó: hình thế chiến tranh",
    example: "hình thế chiến tranh",
  },
  {
    word: "hình thù",
    part_of_speech: "danh từ",
    meaning:
      "hình dạng cụ thể và riêng biệt: hình thù kì dị * bức tượng trông chẳng ra hình thù gì",
    example: "hình thù kì dị * bức tượng trông chẳng ra hình thù gì",
  },
  {
    word: "hình trạng",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như hình dạng: hình trạng chữ viết * thay đổi hình trạng",
    example: "hình trạng chữ viết * thay đổi hình trạng",
  },
  {
    word: "hình thức",
    part_of_speech: "danh từ",
    meaning:
      "toàn thể nói chung những gì làm thành bề ngoài của sự vật, chứa đựng hoặc biểu hiện nội dung: coi trọng hình thức * hình thức đẹp làm tôn nội dung",
    example: "coi trọng hình thức * hình thức đẹp làm tôn nội dung",
  },
  {
    word: "hình thức",
    part_of_speech: "danh từ",
    meaning:
      "cách thể hiện, cách tiến hành một hoạt động nhằm một mục đích cụ thể: hình thức quảng cáo hấp dẫn * các hình thức kỉ luật",
    example: "hình thức quảng cáo hấp dẫn * các hình thức kỉ luật",
  },
  {
    word: "hình thức",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất hình thức, chỉ có trên danh nghĩa, không có cái thực bên trong: lối làm việc hình thức",
    example: "lối làm việc hình thức",
  },
  {
    word: "hình thức",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) hình thức chủ nghĩa (nói tắt): bệnh hình thức",
    example: "bệnh hình thức",
  },
  {
    word: "hình tượng",
    part_of_speech: "danh từ",
    meaning:
      "sự phản ánh hiện thực một cách khái quát bằng nghệ thuật dưới hình thức những hiện tượng cụ thể, sinh động, điển hình, nhận thức trực tiếp bằng cảm tính: hình tượng văn học",
    example: "hình tượng văn học",
  },
  {
    word: "hình vóc",
    part_of_speech: "danh từ",
    meaning:
      "hình dáng bên ngoài của một con người, về mặt to nhỏ, cao thấp: hình vóc nhỏ nhắn",
    example: "hình vóc nhỏ nhắn",
  },
  {
    word: "híp",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái hai mi mắt gần như bị khép lại, không mở to ra được: mắt híp",
    example: "mắt híp",
  },
  {
    word: "hip hop",
    part_of_speech: "danh từ",
    meaning:
      "thể loại nhạc hiện đại mà lời thường được thể hiện bằng cách nói và có nhịp đều đều, được khởi nguồn từ thanh niên Mĩ gốc Phi từ những năm 1980: nhạc hip hop",
    example: "nhạc hip hop",
  },
  {
    word: "hip hop",
    part_of_speech: "danh từ",
    meaning:
      "văn hoá, sinh hoạt của thanh niên Mĩ gốc Phi và những người yêu thích nhạc hip hop, thể hiện qua hội hoạ, khiêu vũ, trang phục, v.v.: ăn mặc kiểu hip hop * dân chơi hip hop",
    example: "ăn mặc kiểu hip hop * dân chơi hip hop",
  },
  {
    word: "híp-pi",
    part_of_speech: "danh từ",
    meaning:
      "người thanh niên có lối ăn mặc, sinh hoạt cố làm cho ra vẻ khác đời, ra vẻ coi thường các nền nếp, phong tục, tập quán xã hội (một trào lưu thường thấy ở các nước phương Tây những năm 60 của thế kỉ XX): dân hippy",
    example: "dân hippy",
  },
  {
    word: "hít",
    part_of_speech: "động từ",
    meaning:
      "làm cho không khí qua mũi vào cơ thể, bằng cách thở sâu vào: hít phải hơi độc * hít khí trời",
    example: "hít phải hơi độc * hít khí trời",
  },
  {
    word: "hippy",
    part_of_speech: "danh từ",
    meaning:
      "người thanh niên có lối ăn mặc, sinh hoạt cố làm cho ra vẻ khác đời, ra vẻ coi thường các nền nếp, phong tục, tập quán xã hội (một trào lưu thường thấy ở các nước phương Tây những năm 60 của thế kỉ XX): dân hippy",
    example: "dân hippy",
  },
  {
    word: "hít hà",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) xuýt xoa: hít hà khen ngon",
    example: "hít hà khen ngon",
  },
  {
    word: "hiu hiu",
    part_of_speech: "tính từ",
    meaning: "(gió thổi) rất nhẹ, lay động khẽ và yếu ớt: gió thổi hiu hiu",
    example: "gió thổi hiu hiu",
  },
  {
    word: "hiu hiu",
    part_of_speech: "tính từ",
    meaning:
      'ở trạng thái êm nhẹ, vận động yếu ớt, hoặc có sắc thái mờ nhạt, gây cảm giác buồn man mác, vắng lặng: cảnh vật hiu hiu, vắng vẻ * "Êm êm chiều ngẩn ngơ chiều, Lòng không sao cả, hiu hiu khẽ buồn..." (XDiệu; 4)',
    example:
      'cảnh vật hiu hiu, vắng vẻ * "Êm êm chiều ngẩn ngơ chiều, Lòng không sao cả, hiu hiu khẽ buồn..." (XDiệu; 4)',
  },
  {
    word: "hiu hắt",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái yếu ớt, mong manh, gây cảm giác buồn vắng, cô đơn, cảm giác của cái sắp lụi tàn: hơi may hiu hắt * ngọn đèn hiu hắt * buồn hiu hắt",
    example: "hơi may hiu hắt * ngọn đèn hiu hắt * buồn hiu hắt",
  },
  {
    word: "hiu quạnh",
    part_of_speech: "tính từ",
    meaning:
      "vắng lặng và trống trải, gây cảm giác buồn, cô đơn: bến sông hiu quạnh * căn nhà hiu quạnh",
    example: "bến sông hiu quạnh * căn nhà hiu quạnh",
  },
  {
    word: "ho",
    part_of_speech: "động từ",
    meaning:
      "bật mạnh hơi từ trong phổi, trong cổ ra thành tiếng, do đường hô hấp bị kích thích: ho sặc sụa * cơn ho * thuốc ho",
    example: "ho sặc sụa * cơn ho * thuốc ho",
  },
  {
    word: "hò",
    part_of_speech: "danh từ",
    meaning:
      'đường mép chạy từ giữa cổ đến nách áo phía bên phải ở thân trước áo dài: "Thương trò may áo cho trò, Thiếu đinh thiếu vạt thiếu hò thiếu bâu." (Cdao)',
    example:
      'Thương trò may áo cho trò, Thiếu đinh thiếu vạt thiếu hò thiếu bâu." (Cdao)',
  },
  {
    word: "hò",
    part_of_speech: "danh từ",
    meaning:
      "một loại dân ca trong lao động có đoạn nhiều người cùng hoạ theo để hưởng ứng: hò giã gạo * hò kéo pháo",
    example: "hò giã gạo * hò kéo pháo",
  },
  {
    word: "hò",
    part_of_speech: "động từ",
    meaning: "cất lên câu hò, bài hò: hò một câu",
    example: "hò một câu",
  },
  {
    word: "hò",
    part_of_speech: "động từ",
    meaning:
      "cất tiếng cao to và dài để gọi ai hoặc để rủ nhau cùng làm việc gì: hò nhau đuổi trộm * hò như hò đò mà không chịu dậy!",
    example: "hò nhau đuổi trộm * hò như hò đò mà không chịu dậy!",
  },
  {
    word: "họ",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp gồm những người có cùng một tổ tiên, một dòng máu: con cháu họ Trần * anh em trong họ * thấy người sang bắt quàng làm họ (tng)",
    example:
      "con cháu họ Trần * anh em trong họ * thấy người sang bắt quàng làm họ (tng)",
  },
  {
    word: "họ",
    part_of_speech: "danh từ",
    meaning:
      "tiếng đặt trước tên riêng, dùng chung cho những người cùng một họ để phân biệt với họ khác: ghi rõ họ tên * cùng mang họ Phạm, nhưng không phải anh em",
    example: "ghi rõ họ tên * cùng mang họ Phạm, nhưng không phải anh em",
  },
  {
    word: "họ",
    part_of_speech: "danh từ",
    meaning:
      "quan hệ họ hàng, nhưng không phải ruột thịt: em họ * bác họ * ông chú họ (em trai họ của cha)",
    example: "em họ * bác họ * ông chú họ (em trai họ của cha)",
  },
  {
    word: "họ",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị phân loại sinh học, dưới bộ, trên giống: họ ba ba thuộc bộ rùa",
    example: "họ ba ba thuộc bộ rùa",
  },
  {
    word: "họ",
    part_of_speech: "danh từ",
    meaning:
      "hình thức vay lẫn nhau bằng cách góp tiền theo định kì, để lần lượt cho từng người nhận: chơi họ * đóng họ",
    example: "chơi họ * đóng họ",
  },
  {
    word: "họ",
    part_of_speech: "đại từ",
    meaning:
      "từ dùng để chỉ người ở ngôi thứ ba, số nhiều: không biết họ là ai * họ đến rồi lại đi ngay",
    example: "không biết họ là ai * họ đến rồi lại đi ngay",
  },
  {
    word: "hó háy",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) đưa mắt nhìn nghiêng rất nhanh và nhiều lần: bọn trẻ hó háy nhìn trộm ông khách lạ",
    example: "bọn trẻ hó háy nhìn trộm ông khách lạ",
  },
  {
    word: "họ hàng",
    part_of_speech: "danh từ",
    meaning:
      "những người có quan hệ huyết thống, trong quan hệ với nhau (nói tổng quát): hai người có họ hàng với nhau * quan hệ họ hàng",
    example: "hai người có họ hàng với nhau * quan hệ họ hàng",
  },
  {
    word: "họ hàng",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) những thứ có quan hệ chủng loại hoặc quan hệ nguồn gốc với nhau (nói tổng quát): trúc, vầu, luồng, nứa đều thuộc họ hàng nhà tre",
    example: "trúc, vầu, luồng, nứa đều thuộc họ hàng nhà tre",
  },
  {
    word: "ho gà",
    part_of_speech: "danh từ",
    meaning:
      "bệnh ho ở trẻ em, dễ lây và kéo dài ngày, gây những cơn ho rũ rượi từng hồi và có tiếng rít: tiêm phòng ho gà",
    example: "tiêm phòng ho gà",
  },
  {
    word: "ho he",
    part_of_speech: "động từ",
    meaning:
      "tỏ ra có ý muốn chống lại, bằng lời nói hoặc cử chỉ: sợ, không dám ho he",
    example: "sợ, không dám ho he",
  },
  {
    word: "hó hé",
    part_of_speech: "động từ",
    meaning: "như ho he: tất cả đều im lặng, không ai dám hó hé gì",
    example: "tất cả đều im lặng, không ai dám hó hé gì",
  },
  {
    word: "hó hé",
    part_of_speech: "động từ",
    meaning:
      "nói lộ ra điều cần phải giữ kín mà mình được biết: không được hó hé với ai",
    example: "không được hó hé với ai",
  },
  {
    word: "ho hen",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) ho nhiều và kéo dài (nói khái quát): ho hen vì thuốc lá",
    example: "ho hen vì thuốc lá",
  },
  {
    word: "hò hẹn",
    part_of_speech: "động từ",
    meaning: "như hẹn hò (ng2): đến nơi hò hẹn",
    example: "đến nơi hò hẹn",
  },
  {
    word: "hò hét",
    part_of_speech: "động từ",
    meaning:
      "hét to và ầm ĩ (nói khái quát): hò hét om sòm * lũ trẻ hò hét inh ỏi",
    example: "hò hét om sòm * lũ trẻ hò hét inh ỏi",
  },
  {
    word: "hò la",
    part_of_speech: "động từ",
    meaning:
      "(nhiều người) la lên cùng một lúc ầm ĩ và kéo dài để cổ vũ hoặc phản đối: tiếng hò la vang rừng * hò la cổ vũ cho đội nhà",
    example: "tiếng hò la vang rừng * hò la cổ vũ cho đội nhà",
  },
  {
    word: "họ mạc",
    part_of_speech: "danh từ",
    meaning: "bà con họ hàng: anh em họ mạc",
    example: "anh em họ mạc",
  },
  {
    word: "ho lao",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) lao phổi: mắc bệnh ho lao",
    example: "mắc bệnh ho lao",
  },
  {
    word: "họ tộc",
    part_of_speech: "danh từ",
    meaning:
      "toàn thể nói chung những người có cùng một dòng họ: người trong họ tộc",
    example: "người trong họ tộc",
  },
  {
    word: "hoà",
    part_of_speech: "động từ",
    meaning: "làm cho tan ra trong chất lỏng: hoà mực * hoà nước muối",
    example: "hoà mực * hoà nước muối",
  },
  {
    word: "hoà",
    part_of_speech: "động từ",
    meaning:
      "lẫn vào nhau, đến mức không còn thấy có sự phân biệt: hoà chung lời ca * mồ hôi hoà lẫn nước mắt",
    example: "hoà chung lời ca * mồ hôi hoà lẫn nước mắt",
  },
  {
    word: "hoà",
    part_of_speech: "động từ",
    meaning: "thôi, không tiến hành chiến tranh chống nhau nữa: phái chủ hoà",
    example: "phái chủ hoà",
  },
  {
    word: "hoà",
    part_of_speech: "tính từ",
    meaning:
      "(kết quả trận đấu) không bên nào thắng, không bên nào thua: hai đội hoà nhau * kết thúc hiệp một, hai đội hoà 1 đều",
    example: "hai đội hoà nhau * kết thúc hiệp một, hai đội hoà 1 đều",
  },
  {
    word: "hoà",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái không có mâu thuẫn, không có xung đột trong quan hệ với nhau: xử hoà * làm hoà với nhau",
    example: "xử hoà * làm hoà với nhau",
  },
  {
    word: "hoả",
    part_of_speech: "danh từ",
    meaning: "lửa: giàn hoả * phóng hoả * cứu hoả",
    example: "giàn hoả * phóng hoả * cứu hoả",
  },
  {
    word: "hoả",
    part_of_speech: "danh từ",
    meaning:
      "hiện tượng thân nhiệt lên quá cao khiến cho sốt li bì, mê sảng, miệng khô, khát nước, v.v. (theo cách nói của đông y): bốc hoả lên đầu",
    example: "bốc hoả lên đầu",
  },
  {
    word: "hò reo",
    part_of_speech: "động từ",
    meaning:
      "(nhiều người) reo lên cùng một lúc bằng những tiếng kéo dài để thúc giục động viên, hoặc để biểu lộ sự vui mừng, phấn khởi: lũ trẻ hò reo ầm ĩ",
    example: "lũ trẻ hò reo ầm ĩ",
  },
  {
    word: "hoa",
    part_of_speech: "danh từ",
    meaning:
      "cơ quan sinh sản hữu tính của cây hạt kín, thường có màu sắc và hương thơm: hoa bưởi * ra hoa kết trái * đẹp như hoa",
    example: "hoa bưởi * ra hoa kết trái * đẹp như hoa",
  },
  {
    word: "hoa",
    part_of_speech: "danh từ",
    meaning:
      "(Nam thường bông) cây trồng để lấy hoa làm cảnh: trồng mấy luống hoa * chậu hoa * bồn hoa",
    example: "trồng mấy luống hoa * chậu hoa * bồn hoa",
  },
  {
    word: "hoa",
    part_of_speech: "danh từ",
    meaning:
      "(Nam thường bông) vật có hình đẹp, tựa như bông hoa: hoa lửa * hoa điểm mười * hoa tuyết * pháo hoa",
    example: "hoa lửa * hoa điểm mười * hoa tuyết * pháo hoa",
  },
  {
    word: "hoa",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) đơn vị đo khối lượng, bằng một phần mười lạng (ngày trước được đánh dấu hoa thị trên cán cân): ba lạng hai hoa",
    example: "ba lạng hai hoa",
  },
  {
    word: "hoa",
    part_of_speech: "danh từ",
    meaning:
      "(Nam thường bông) hình hoa trang trí trên các vật: áo hoa * chiếu hoa",
    example: "áo hoa * chiếu hoa",
  },
  {
    word: "hoa",
    part_of_speech: "danh từ",
    meaning:
      "dạng chữ đặc biệt, to hơn chữ thường, thường ở chữ cái đầu câu và đầu danh từ riêng: đầu câu phải viết hoa * chữ A hoa",
    example: "đầu câu phải viết hoa * chữ A hoa",
  },
  {
    word: "hoa",
    part_of_speech: "động từ",
    meaning: "như khoa: hoa tay ra hiệu",
    example: "hoa tay ra hiệu",
  },
  {
    word: "hoa",
    part_of_speech: "tính từ",
    meaning:
      "(mắt) ở trạng thái nhìn thấy mọi vật xung quanh lờ mờ và như chao đảo trước mặt, do quá mệt mỏi hoặc do thị giác bị kích thích mạnh và đột ngột: đói hoa cả mắt",
    example: "đói hoa cả mắt",
  },
  {
    word: "hoà âm",
    part_of_speech: "danh từ",
    meaning:
      "sự cấu tạo và liên kết hợp âm để nâng cao nội dung của giai điệu: bản nhạc có hoà âm phức tạp",
    example: "bản nhạc có hoà âm phức tạp",
  },
  {
    word: "hoạ",
    part_of_speech: "danh từ",
    meaning:
      "điều không may mang lại những đau khổ, tổn thất lớn: rước hoạ vào thân * hoạ mất nước",
    example: "rước hoạ vào thân * hoạ mất nước",
  },
  {
    word: "hoạ",
    part_of_speech: "danh từ",
    meaning:
      "điều trong thực tế rất khó xảy ra, đến mức chỉ được xem như là một giả thiết: nó mà đỗ đại học thì có hoạ là trời sập * nói thế hoạ có trời hiểu",
    example:
      "nó mà đỗ đại học thì có hoạ là trời sập * nói thế hoạ có trời hiểu",
  },
  {
    word: "hoạ",
    part_of_speech: "động từ",
    meaning:
      "theo vần thơ hoặc theo nhịp đàn mà ứng đối lại một cách phù hợp: hoạ thơ * hoạ đàn",
    example: "hoạ thơ * hoạ đàn",
  },
  {
    word: "hoạ",
    part_of_speech: "động từ",
    meaning:
      "hoà chung vào cùng một nhịp: một người xướng có muôn tiếng hoạ theo",
    example: "một người xướng có muôn tiếng hoạ theo",
  },
  {
    word: "hoạ",
    part_of_speech: "động từ",
    meaning: "(Ít dùng) vẽ (tranh): hoạ một bức tranh phong cảnh",
    example: "hoạ một bức tranh phong cảnh",
  },
  {
    word: "hoạ",
    part_of_speech: "danh từ",
    meaning: "(Khẩu ngữ) hội hoạ (nói tắt): ngành hoạ * giới hoạ * khoa hoạ",
    example: "ngành hoạ * giới hoạ * khoa hoạ",
  },
  {
    word: "hoá",
    part_of_speech: "danh từ",
    meaning: "hoá học (nói tắt): ngành hoá * học giỏi môn hoá",
    example: "ngành hoá * học giỏi môn hoá",
  },
  {
    word: "hoá",
    part_of_speech: "động từ",
    meaning:
      "thay đổi thành cái khác: nhộng đã hoá thành ngài * mèo già hoá cáo (tng)",
    example: "nhộng đã hoá thành ngài * mèo già hoá cáo (tng)",
  },
  {
    word: "hoá",
    part_of_speech: "động từ",
    meaning:
      "chuyển sang trạng thái khác, thường là xấu, không tốt: chiều quá hoá hư * hoá điên, hoá dại * sướng quá hoá rồ (kng)",
    example: "chiều quá hoá hư * hoá điên, hoá dại * sướng quá hoá rồ (kng)",
  },
  {
    word: "hoá",
    part_of_speech: "động từ",
    meaning:
      "từ biểu thị điều sắp nói đến là điều bỗng nhiên nhận thức ra, có phần bất ngờ, trái với điều trước kia tưởng: tưởng dễ mà lại hoá khó * như thế lại hoá hay",
    example: "tưởng dễ mà lại hoá khó * như thế lại hoá hay",
  },
  {
    word: "hoá",
    part_of_speech: "động từ",
    meaning:
      "trở thành thần, thánh, Phật, chứ không chết đi, theo quan niệm tôn giáo, tín ngưỡng dân gian: dẹp xong giặc Ân, ông Gióng hoá lên trời",
    example: "dẹp xong giặc Ân, ông Gióng hoá lên trời",
  },
  {
    word: "hoá",
    part_of_speech: "động từ",
    meaning:
      "đốt vàng mã để cho trở thành đồ dùng của linh hồn người chết ở dưới âm phủ, theo tín ngưỡng dân gian: hoá vàng",
    example: "hoá vàng",
  },
  {
    word: "hoá",
    part_of_speech: "tính từ",
    meaning:
      "(ruộng đất) ở tình trạng bỏ không lâu ngày không trồng trọt: ruộng đất bị bỏ hoá",
    example: "ruộng đất bị bỏ hoá",
  },
  {
    word: "hoà bình",
    part_of_speech: "danh từ",
    meaning:
      "tình trạng yên ổn, không có chiến tranh: đấu tranh vì hoà bình và độc lập dân tộc",
    example: "đấu tranh vì hoà bình và độc lập dân tộc",
  },
  {
    word: "hoà bình",
    part_of_speech: "tính từ",
    meaning:
      "không dùng đến vũ lực, không để xảy ra chiến tranh: giải quyết bằng phương pháp hoà bình * chung sống hoà bình",
    example: "giải quyết bằng phương pháp hoà bình * chung sống hoà bình",
  },
  {
    word: "hoạ chăng",
    part_of_speech: "",
    meaning:
      "tổ hợp biểu thị ý khẳng định không chắc chắn về điều đang hi vọng có thể xảy ra: chỉ có anh hoạ chăng mới giúp được nó",
    example: "chỉ có anh hoạ chăng mới giúp được nó",
  },
  {
    word: "hoà cả làng",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) không còn kể ai phải, ai trái, ai đúng, ai sai, tất cả đều như nhau: làm thế thì hoà cả làng!",
    example: "làm thế thì hoà cả làng!",
  },
  {
    word: "hoá công",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) ông trời, tạo hoá: "Phũ phàng chi bấy Hoá công!, Ngày xanh mòn mỏi, má hồng phôi pha." (TKiều)',
    example:
      'Phũ phàng chi bấy Hoá công!, Ngày xanh mòn mỏi, má hồng phôi pha." (TKiều)',
  },
  {
    word: "hoa chúc",
    part_of_speech: "danh từ",
    meaning: "(cũ, văn chương) đuốc hoa: đợi ngày hoa chúc",
    example: "đợi ngày hoa chúc",
  },
  {
    word: "hoá chất",
    part_of_speech: "danh từ",
    meaning:
      "hợp chất có thành phần phân tử xác định: nhà máy sản xuất hoá chất",
    example: "nhà máy sản xuất hoá chất",
  },
  {
    word: "hoả công",
    part_of_speech: "",
    meaning:
      "dùng lửa để đánh trận (một chiến thuật thời xưa): đánh hoả công * dùng hoả công diệt đồn địch",
    example: "đánh hoả công * dùng hoả công diệt đồn địch",
  },
  {
    word: "hoá dầu",
    part_of_speech: "danh từ",
    meaning:
      "ngành hoá học chuyên nghiên cứu và sản xuất chế biến những nguyên liệu lấy từ sản phẩm khai thác dầu mỏ: công nghiệp hoá dầu * đầu tư và phát triển ngành hoá dầu",
    example: "công nghiệp hoá dầu * đầu tư và phát triển ngành hoá dầu",
  },
  {
    word: "hoà dịu",
    part_of_speech: "tính từ",
    meaning:
      "bớt căng thẳng, mâu thuẫn lắng dịu dần, phần nào có sự thân thiện (thường nói về quan hệ ngoại giao): xu thế hoà dịu * quan hệ hoà dịu trở lại",
    example: "xu thế hoà dịu * quan hệ hoà dịu trở lại",
  },
  {
    word: "hoà đàm",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) đàm phán về việc chấm dứt chiến tranh, lập lại hoà bình: tiến trình hoà đàm giữa hai nước",
    example: "tiến trình hoà đàm giữa hai nước",
  },
  {
    word: "hoa đăng",
    part_of_speech: "danh từ",
    meaning: "đèn thắp sáng và đẹp như hoa trong đêm: đêm hội hoa đăng",
    example: "đêm hội hoa đăng",
  },
  {
    word: "hoà đồng",
    part_of_speech: "động từ",
    meaning:
      "cùng hoà chung với nhau, làm cho không có sự cách biệt: không hoà đồng với bạn bè trong lớp * sống hoà đồng với mọi người",
    example:
      "không hoà đồng với bạn bè trong lớp * sống hoà đồng với mọi người",
  },
  {
    word: "hoà đồng",
    part_of_speech: "danh từ",
    meaning:
      "Tên của một trang Blog, trên Yahoo 360 plus: http://vn.myblog.yahoo.com/Yen-Lac",
    example: "http://vn.myblog.yahoo.com/Yen-Lac",
  },
  {
    word: "hoạ đồ",
    part_of_speech: "danh từ",
    meaning:
      '(hiếm) bức vẽ cảnh vật, sông núi: "Đường vô xứ Nghệ quanh quanh, Non xanh nước biếc như tranh hoạ đồ." (ca dao)',
    example:
      'Đường vô xứ Nghệ quanh quanh, Non xanh nước biếc như tranh hoạ đồ." (ca dao)',
  },
  {
    word: "hoạ gia",
    part_of_speech: "danh từ",
    meaning:
      "(trang trọng) hoạ sĩ lớn, có tên tuổi (thường dùng nói về người thời trước): các hoạ gia đời Lý",
    example: "các hoạ gia đời Lý",
  },
  {
    word: "hoá đơn",
    part_of_speech: "danh từ",
    meaning:
      "chứng từ ghi tên người mua, tên hàng cùng với giá tiền đã bán để làm bằng: thanh toán theo hoá đơn * hoá đơn tiền điện",
    example: "thanh toán theo hoá đơn * hoá đơn tiền điện",
  },
  {
    word: "hoà hảo",
    part_of_speech: "tính từ",
    meaning:
      "(cũ) (các bên từng đối địch nhau) có quan hệ thân thiện, tốt đẹp với nhau: tình hoà hảo giữa hai nước",
    example: "tình hoà hảo giữa hai nước",
  },
  {
    word: "hoá giải",
    part_of_speech: "động từ",
    meaning: "làm tiêu tan đi, làm cho mất tác dụng: hoá giải lời nguyền",
    example: "hoá giải lời nguyền",
  },
  {
    word: "hoà giải",
    part_of_speech: "động từ",
    meaning:
      "thuyết phục, giúp cho ổn thoả tình trạng xung đột, mâu thuẫn giữa các bên: dùng biện pháp hoà giải * trung gian hoà giải",
    example: "dùng biện pháp hoà giải * trung gian hoà giải",
  },
  {
    word: "hoa hậu",
    part_of_speech: "danh từ",
    meaning:
      "danh hiệu dành cho người con gái chiếm giải nhất trong một cuộc thi người đẹp có quy mô lớn (một nước, một khu vực, hoặc toàn thế giới): hoa hậu thế giới * đoạt danh hiệu hoa hậu toàn quốc",
    example: "hoa hậu thế giới * đoạt danh hiệu hoa hậu toàn quốc",
  },
  {
    word: "hoà hiếu",
    part_of_speech: "tính từ",
    meaning:
      "có quan hệ ngoại giao hoà bình và thân thiện với nhau: giữ vững tình hoà hiếu giữa hai nước",
    example: "giữ vững tình hoà hiếu giữa hai nước",
  },
  {
    word: "hoa hiên",
    part_of_speech: "danh từ",
    meaning:
      "cây thân cỏ cùng họ với hành tỏi, hoa to hình phễu màu vàng sẫm, dùng để ăn và làm thuốc.",
    example: "dải lụa màu hoa hiên",
  },
  {
    word: "hoả hoạn",
    part_of_speech: "danh từ",
    meaning: "nạn cháy: xảy ra hoả hoạn * đề phòng hoả hoạn",
    example: "xảy ra hoả hoạn * đề phòng hoả hoạn",
  },
  {
    word: "hoạ hoằn",
    part_of_speech: "tính từ",
    meaning: "rất hiếm: hoạ hoằn lắm hai người mới gặp nhau",
    example: "hoạ hoằn lắm hai người mới gặp nhau",
  },
  {
    word: "hoà hoãn",
    part_of_speech: "động từ",
    meaning:
      "làm cho các mâu thuẫn đối kháng tạm thời không phát triển và quan hệ bớt căng thẳng: xu thế hoà hoãn * chính sách hoà hoãn",
    example: "xu thế hoà hoãn * chính sách hoà hoãn",
  },
  {
    word: "hoa hoè hoa sói",
    part_of_speech: "",
    meaning:
      "có vẻ cầu kì, loè loẹt trong cách trang sức, tô điểm: ăn mặc hoa hoè hoa sói",
    example: "ăn mặc hoa hoè hoa sói",
  },
  {
    word: "hoa hoè",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) hoa hoè hoa sói (nói tắt): ăn mặc hoa hoè * lối văn chương hoa hoè",
    example: "ăn mặc hoa hoè * lối văn chương hoa hoè",
  },
  {
    word: "hoa hoét",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) hoa (nói khái quát; hàm ý chê, mỉa mai): hoa hoét cắm đầy nhà",
    example: "hoa hoét cắm đầy nhà",
  },
  {
    word: "hoa hoét",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) có tính phô trương, hình thức: lối bày biện hoa hoét",
    example: "lối bày biện hoa hoét",
  },
  {
    word: "hoa hồng",
    part_of_speech: "danh từ",
    meaning:
      "tiền tính theo tỉ lệ nhất định, trả cho người làm trung gian, môi giới trong việc giao dịch, mua bán: bán hàng ăn hoa hồng",
    example: "bán hàng ăn hoa hồng",
  },
  {
    word: "hoà hợp",
    part_of_speech: "động từ",
    meaning:
      "hợp lại thành một thể thống nhất, hài hoà với nhau: vợ chồng hoà hợp * hoà hợp dân tộc",
    example: "vợ chồng hoà hợp * hoà hợp dân tộc",
  },
  {
    word: "hoa lá",
    part_of_speech: "danh từ",
    meaning:
      "hoa và lá dùng để trang trí (nói khái quát): ngày tết mà nhà chẳng có hoa lá gì",
    example: "ngày tết mà nhà chẳng có hoa lá gì",
  },
  {
    word: "hoa lá",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất hình thức, trang trí màu mè, phô trương bề ngoài: nói những lời hoa lá * toàn những chuyện hoa lá tầm phào!",
    example: "nói những lời hoa lá * toàn những chuyện hoa lá tầm phào!",
  },
  {
    word: "hoà kết",
    part_of_speech: "động từ",
    meaning:
      "kết hợp, hoà lẫn với nhau: sự hoà kết giữa hai nền văn hoá Đông - Tây * ngôn ngữ hoà kết",
    example: "sự hoà kết giữa hai nền văn hoá Đông - Tây * ngôn ngữ hoà kết",
  },
  {
    word: "hoa khôi",
    part_of_speech: "danh từ",
    meaning:
      "ví người con gái chiếm giải nhất trong một cuộc thi người đẹp có quy mô nhỏ: đoạt danh hiệu hoa khôi trong cuộc thi người đẹp phía Bắc",
    example: "đoạt danh hiệu hoa khôi trong cuộc thi người đẹp phía Bắc",
  },
  {
    word: "hoa khôi",
    part_of_speech: "danh từ",
    meaning:
      "ví người phụ nữ được coi là đẹp nhất trong một vùng, một lĩnh vực: hoa khôi của lớp * hoa khôi làng báo",
    example: "hoa khôi của lớp * hoa khôi làng báo",
  },
  {
    word: "hoà khí",
    part_of_speech: "danh từ",
    meaning:
      "không khí hoà thuận, không có mâu thuẫn: giữ hoà khí trong gia đình",
    example: "giữ hoà khí trong gia đình",
  },
  {
    word: "hoà khí",
    part_of_speech: "danh từ",
    meaning:
      "sự hỗn hợp không khí với chất đốt lỏng làm thành một hỗn hợp cháy: bộ chế hoà khí",
    example: "bộ chế hoà khí",
  },
  {
    word: "hoá kiếp",
    part_of_speech: "động từ",
    meaning:
      "hoá thành người khác hoặc vật khác, để sống một kiếp khác, theo thuyết luân hồi của đạo Phật: Lý Thông đã bị hoá kiếp thành bọ hung",
    example: "Lý Thông đã bị hoá kiếp thành bọ hung",
  },
  {
    word: "hoá kiếp",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) giết để ăn thịt hoặc để trừng trị: hoá kiếp cho con gà * hoá kiếp tên phản bội",
    example: "hoá kiếp cho con gà * hoá kiếp tên phản bội",
  },
  {
    word: "hoa lan",
    part_of_speech: "danh từ",
    meaning:
      "cây cảnh, có nhiều loại, thân cỏ, lá thường dài và hẹp, hoa đẹp thường có hương thơm: nhành lan tím",
    example: "nhành lan tím",
  },
  {
    word: "hoa lan",
    part_of_speech: "động từ",
    meaning:
      "mở rộng dần phạm vi ra trên một bề mặt: cỏ mọc lan ra khắp vườn * lửa cháy lan sang nhà hàng xóm * tiếng đồn lan xa",
    example:
      "cỏ mọc lan ra khắp vườn * lửa cháy lan sang nhà hàng xóm * tiếng đồn lan xa",
  },
  {
    word: "hoa lá cành",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như hoa lá: ăn nói hoa lá cành",
    example: "ăn nói hoa lá cành",
  },
  {
    word: "hoa lệ",
    part_of_speech: "tính từ",
    meaning:
      "(cảnh vật) đẹp một cách lộng lẫy: thành phố hoa lệ * ngôn từ rất hoa lệ",
    example: "thành phố hoa lệ * ngôn từ rất hoa lệ",
  },
  {
    word: "hoả lực",
    part_of_speech: "danh từ",
    meaning:
      "sức mạnh gây sát thương và phá hoại của bom đạn, chất nổ, chất cháy dùng trong chiến đấu (nói khái quát): hoả lực phòng không * dùng hoả lực để tiêu diệt địch",
    example: "hoả lực phòng không * dùng hoả lực để tiêu diệt địch",
  },
  {
    word: "hoả lò",
    part_of_speech: "danh từ",
    meaning: "lò than nhỏ để đun nấu, để sưởi: bỏ thêm than vào hoả lò",
    example: "bỏ thêm than vào hoả lò",
  },
  {
    word: "hoả mai",
    part_of_speech: "danh từ",
    meaning: "súng thời xưa, bắn bằng cách châm ngòi lửa: súng hoả mai",
    example: "súng hoả mai",
  },
  {
    word: "hoa lợi",
    part_of_speech: "danh từ",
    meaning:
      "toàn thể nói chung những gì thu hoạch được trên đất trồng trọt: thu hoạch hoa lợi",
    example: "thu hoạch hoa lợi",
  },
  {
    word: "hoa màu",
    part_of_speech: "danh từ",
    meaning:
      "cây trồng trên cạn (trừ lúa ra, như ngô, khoai, đậu, vừng, v.v.), dùng làm lương thực và thực phẩm, hoặc làm thức ăn chăn nuôi (nói khái quát): trồng hoa màu * tăng diện tích hoa màu",
    example: "trồng hoa màu * tăng diện tích hoa màu",
  },
  {
    word: "hoà mạng",
    part_of_speech: "động từ",
    meaning:
      "nhập vào với hệ thống mạng lưới điện hoặc mạng lưới thông tin chung: hoà mạng lưới điện quốc gia * hoà mạng Internet",
    example: "hoà mạng lưới điện quốc gia * hoà mạng Internet",
  },
  {
    word: "hoạ may",
    part_of_speech: "",
    meaning:
      "tổ hợp biểu thị ý hi vọng không biết chừng có thể xảy ra điều đang mong ước: cứ đến, hoạ may anh ta có nhà",
    example: "cứ đến, hoạ may anh ta có nhà",
  },
  {
    word: "hoà mình",
    part_of_speech: "động từ",
    meaning:
      "sống hoà hợp với mọi người, không có sự tách biệt về vật chất cũng như về tình cảm: sống hoà mình với thiên nhiên * hoà mình với quần chúng",
    example: "sống hoà mình với thiên nhiên * hoà mình với quần chúng",
  },
  {
    word: "hoa mĩ",
    part_of_speech: "tính từ",
    meaning:
      "được gọt giũa, trau chuốt nhiều để có cái vẻ đẹp phô trương bề ngoài: đường nét chạm trổ hoa mĩ * nói những lời hoa mĩ",
    example: "đường nét chạm trổ hoa mĩ * nói những lời hoa mĩ",
  },
  {
    word: "hoà mục",
    part_of_speech: "tính từ",
    meaning: "(cũ) như hoà thuận: anh em hoà mục",
    example: "anh em hoà mục",
  },
  {
    word: "hoa mỹ",
    part_of_speech: "tính từ",
    meaning:
      "được gọt giũa, trau chuốt nhiều để có cái vẻ đẹp phô trương bề ngoài: đường nét chạm trổ hoa mĩ * nói những lời hoa mĩ",
    example: "đường nét chạm trổ hoa mĩ * nói những lời hoa mĩ",
  },
  {
    word: "hoả mù",
    part_of_speech: "danh từ",
    meaning:
      "khói lửa tung ra để làm cho đối phương khó phát hiện được mục tiêu.",
    example: "tung hoả mù để loè thiên hạ",
  },
  {
    word: "hoá năng",
    part_of_speech: "danh từ",
    meaning:
      "năng lượng sinh ra từ phản ứng hoá học: biến đổi hoá năng thành điện năng",
    example: "biến đổi hoá năng thành điện năng",
  },
  {
    word: "hoá nghiệm",
    part_of_speech: "động từ",
    meaning:
      "tiến hành những thí nghiệm hoá học: phòng hoá nghiệm * kiểm tra mẫu hoá nghiệm",
    example: "phòng hoá nghiệm * kiểm tra mẫu hoá nghiệm",
  },
  {
    word: "hoà nhã",
    part_of_speech: "tính từ",
    meaning:
      "có thái độ ôn hoà và nhã nhặn: nói năng hoà nhã * hoà nhã với mọi người",
    example: "nói năng hoà nhã * hoà nhã với mọi người",
  },
  {
    word: "hoà nhập",
    part_of_speech: "động từ",
    meaning:
      "cùng tham gia, cùng hoà chung vào để không có sự tách biệt: hoà nhập với môi trường mới * hoà nhập chứ không hoà tan",
    example: "hoà nhập với môi trường mới * hoà nhập chứ không hoà tan",
  },
  {
    word: "hoà nhạc",
    part_of_speech: "động từ",
    meaning:
      "cùng biểu diễn âm nhạc với nhiều nhạc khí trong một dàn nhạc: chương trình hoà nhạc * nghe hoà nhạc",
    example: "chương trình hoà nhạc * nghe hoà nhạc",
  },
  {
    word: "hoá nhi",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) tạo hoá (hàm ý trách móc, coi như đứa trẻ oái oăm): "Hoá nhi thăm thẳm nghìn trùng, Nhắc cân phúc tội, rút vòng vần xoay." (NĐM)',
    example:
      'Hoá nhi thăm thẳm nghìn trùng, Nhắc cân phúc tội, rút vòng vần xoay." (NĐM)',
  },
  {
    word: "hoa niên",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) tuổi trẻ, được coi là tuổi tươi đẹp nhất trong đời người: tuổi hoa niên",
    example: "tuổi hoa niên",
  },
  {
    word: "hoá phép",
    part_of_speech: "động từ",
    meaning:
      "biến hoá hoặc làm cho biến hoá bằng phép mầu nhiệm: Bụt hoá phép thành ông lão ăn mày",
    example: "Bụt hoá phép thành ông lão ăn mày",
  },
  {
    word: "hoà quyện",
    part_of_speech: "động từ",
    meaning:
      "hoà lẫn vào nhau, như quyện lại làm một (nói khái quát): tiếng đàn, tiếng sáo hoà quyện với nhau * sự hoà quyện giữa hai tâm hồn",
    example:
      "tiếng đàn, tiếng sáo hoà quyện với nhau * sự hoà quyện giữa hai tâm hồn",
  },
  {
    word: "hoá phẩm",
    part_of_speech: "danh từ",
    meaning: "sản phẩm hoá học: chế hoá phẩm",
    example: "chế hoá phẩm",
  },
  {
    word: "hoà nhịp",
    part_of_speech: "động từ",
    meaning: "hoà cùng một nhịp: cả hội trường đều hoà nhịp hát theo",
    example: "cả hội trường đều hoà nhịp hát theo",
  },
  {
    word: "hoa quả",
    part_of_speech: "danh từ",
    meaning:
      "quả cây dùng để ăn (nói khái quát): lẵng hoa quả * cửa hàng kinh doanh hoa quả",
    example: "lẵng hoa quả * cửa hàng kinh doanh hoa quả",
  },
  {
    word: "hoá ra",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị điều sắp nêu là điều bỗng nhiên nhận thức ra, có phần bất ngờ, trái với điều trước kia vẫn tưởng: hoá ra mọi chuyện không phải như vậy * bài toán tưởng khó hoá ra lại rất dễ",
    example:
      "hoá ra mọi chuyện không phải như vậy * bài toán tưởng khó hoá ra lại rất dễ",
  },
  {
    word: "hoa nguyệt",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) trăng hoa: "Anh đánh thì tôi chịu đòn, Tính tôi hoa nguyệt mười con chẳng chừa." (ca dao)',
    example:
      'Anh đánh thì tôi chịu đòn, Tính tôi hoa nguyệt mười con chẳng chừa." (ca dao)',
  },
  {
    word: "hoa râm",
    part_of_speech: "tính từ",
    meaning:
      '(tóc) bạc lốm đốm: tóc hoa râm * "Những là đắp nhớ, đổi sầu, Tuyết sương nhuốm nửa mái đầu hoa râm." (TKiều)',
    example:
      'tóc hoa râm * "Những là đắp nhớ, đổi sầu, Tuyết sương nhuốm nửa mái đầu hoa râm." (TKiều)',
  },
  {
    word: "hoá sinh",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về, có tính chất những phản ứng hoá học xảy ra trong cơ thể sinh vật: quá trình hoá sinh trong cơ thể thực vật",
    example: "quá trình hoá sinh trong cơ thể thực vật",
  },
  {
    word: "hoạ sĩ",
    part_of_speech: "danh từ",
    meaning:
      "người chuyên vẽ tranh nghệ thuật, có trình độ và đã được mọi người công nhận: ước mơ trở thành hoạ sĩ",
    example: "ước mơ trở thành hoạ sĩ",
  },
  {
    word: "hoà tan",
    part_of_speech: "động từ",
    meaning:
      "làm cho các phân tử của một (hay một số) chất tách rời nhau ra để hỗn hợp với các phân tử của một chất lỏng, tạo thành một hỗn hợp đồng tính (gọi là dung dịch): hoà tan muối trong nước",
    example: "hoà tan muối trong nước",
  },
  {
    word: "hoà tan",
    part_of_speech: "động từ",
    meaning:
      "tan ra và hoà lẫn vào nhau, không còn có sự phân biệt được nữa: hoà nhập chứ không hoà tan",
    example: "hoà nhập chứ không hoà tan",
  },
  {
    word: "hoa tai",
    part_of_speech: "danh từ",
    meaning: "đồ nữ trang đeo ở tai, thường có hình hoa: đôi hoa tai bằng vàng",
    example: "đôi hoa tai bằng vàng",
  },
  {
    word: "hoa tay",
    part_of_speech: "danh từ",
    meaning:
      "đường vân xoáy tròn ở đầu ngón tay (nói khái quát); được coi là dấu hiệu biểu thị sự khéo tay bẩm sinh: người thợ có hoa tay",
    example: "người thợ có hoa tay",
  },
  {
    word: "hoả táng",
    part_of_speech: "động từ",
    meaning:
      "xử lí thi thể người chết bằng cách thiêu thành tro theo nghi lễ: thi thể đã được hoả táng * lễ hoả táng",
    example: "thi thể đã được hoả táng * lễ hoả táng",
  },
  {
    word: "hoá thạch",
    part_of_speech: "danh từ",
    meaning:
      "di tích hoá đá của cổ sinh vật để lại ở các tầng đất đá: mẫu hoá thạch * phát hiện ra hoá thạch của loài khủng long",
    example: "mẫu hoá thạch * phát hiện ra hoá thạch của loài khủng long",
  },
  {
    word: "hoá thân",
    part_of_speech: "động từ",
    meaning:
      "biến thành một người hoặc vật cụ thể khác nào đó: Bồ Tát hoá thân thành bà lão mù * người nghệ sĩ đã hoá thân vào vai diễn",
    example:
      "Bồ Tát hoá thân thành bà lão mù * người nghệ sĩ đã hoá thân vào vai diễn",
  },
  {
    word: "hoa thị",
    part_of_speech: "danh từ",
    meaning:
      "hình giống như bông hoa nhiều cánh (*), dùng để đánh dấu hoặc trang trí: đánh dấu hoa thị",
    example: "đánh dấu hoa thị",
  },
  {
    word: "hoà tấu",
    part_of_speech: "động từ",
    meaning: "cùng biểu diễn một bản nhạc: tiết mục hoà tấu * bản hoà tấu",
    example: "tiết mục hoà tấu * bản hoà tấu",
  },
  {
    word: "hoả thiêu",
    part_of_speech: "động từ",
    meaning:
      "thiêu cháy bằng lửa (chỉ nói về người): bị đưa lên giàn hoả thiêu",
    example: "bị đưa lên giàn hoả thiêu",
  },
  {
    word: "hoà thuận",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái sống chung êm ấm không có xích mích, không có mâu thuẫn (thường nói về quan hệ gia đình): gia đình hoà thuận * anh em hoà thuận",
    example: "gia đình hoà thuận * anh em hoà thuận",
  },
  {
    word: "hoạ tiết",
    part_of_speech: "danh từ",
    meaning:
      "hình vẽ đã được cách điệu hoá, dùng để trang trí: trên mặt trống đồng có nhiều hoạ tiết rất tinh vi",
    example: "trên mặt trống đồng có nhiều hoạ tiết rất tinh vi",
  },
  {
    word: "hoa tiêu",
    part_of_speech: "danh từ",
    meaning:
      "người am hiểu tình hình, điều kiện đường thuỷ hoặc đường không, giúp cho việc điều khiển tàu bè, máy bay hoạt động được an toàn: có hoa tiêu dẫn đường * tàu hoa tiêu",
    example: "có hoa tiêu dẫn đường * tàu hoa tiêu",
  },
  {
    word: "hoa tigôn",
    part_of_speech: "danh từ",
    meaning:
      "cây bụi thân leo, cành non có hai ba tua cuốn ở tận cùng, lá hình bầu dục nhọn, hoa thường có màu trắng hoặc hồng nhạt, trồng làm cảnh: giàn hoa tigôn",
    example: "giàn hoa tigôn",
  },
  {
    word: "hoả tuyến",
    part_of_speech: "danh từ",
    meaning:
      "tuyến chiến đấu nằm trong tầm đạn của đối phương: dân công hoả tuyến",
    example: "dân công hoả tuyến",
  },
  {
    word: "hoà ước",
    part_of_speech: "danh từ",
    meaning:
      "điều ước do hai hay nhiều nước kí kết để lập lại hoà bình, giải quyết những hậu quả của chiến tranh: kí hoà ước",
    example: "kí hoà ước",
  },
  {
    word: "hoả tốc",
    part_of_speech: "tính từ",
    meaning:
      "rất gấp, không được phép chậm trễ: lệnh hoả tốc * hành quân hoả tốc * thư hoả tốc",
    example: "lệnh hoả tốc * hành quân hoả tốc * thư hoả tốc",
  },
  {
    word: "hoa viên",
    part_of_speech: "danh từ",
    meaning: "(cũ) vườn hoa: đi bách bộ trong hoa viên",
    example: "đi bách bộ trong hoa viên",
  },
  {
    word: "hoá trang",
    part_of_speech: "động từ",
    meaning:
      "(diễn viên) tô vẽ mặt mũi và thay đổi cách ăn mặc cho hợp với yêu cầu nghệ thuật của vai diễn: nghệ thuật hoá trang của diễn viên tuồng",
    example: "nghệ thuật hoá trang của diễn viên tuồng",
  },
  {
    word: "hoá trang",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) như cải trang: tên mật thám hoá trang thành người đi buôn để dò la tin tức",
    example: "tên mật thám hoá trang thành người đi buôn để dò la tin tức",
  },
  {
    word: "hoa văn",
    part_of_speech: "danh từ",
    meaning:
      "hình trang trí được vẽ, chạm, khắc trên các đồ vật (nói khái quát): trên trống đồng có nhiều hoa văn",
    example: "trên trống đồng có nhiều hoa văn",
  },
  {
    word: "hoại",
    part_of_speech: "động từ",
    meaning:
      "(chất hữu cơ) thối rữa dần đi: lá hoại ra thành mùn * hố xí tự hoại",
    example: "lá hoại ra thành mùn * hố xí tự hoại",
  },
  {
    word: "hoác",
    part_of_speech: "tính từ",
    meaning:
      "(khoảng trống mở ra) rộng quá cỡ: miệng cười rộng hoác * hở huếch hở hoác * trống hoác",
    example: "miệng cười rộng hoác * hở huếch hở hoác * trống hoác",
  },
  {
    word: "hoai",
    part_of_speech: "tính từ",
    meaning:
      "(phân) đã mất mùi hôi và biến thành mùn, rất tốt cho cây cối: ủ phân cho hoai",
    example: "ủ phân cho hoai",
  },
  {
    word: "hoà vốn",
    part_of_speech: "tính từ",
    meaning:
      "vừa đủ vốn, không lãi cũng không lỗ trong việc mua bán, kinh doanh: bán hoà vốn * tính lại cũng chỉ hoà vốn",
    example: "bán hoà vốn * tính lại cũng chỉ hoà vốn",
  },
  {
    word: "hoạch định",
    part_of_speech: "động từ",
    meaning:
      "vạch rõ, định rõ: hoạch định đường biên giới quốc gia * mọi việc đã được hoạch định sẵn",
    example:
      "hoạch định đường biên giới quốc gia * mọi việc đã được hoạch định sẵn",
  },
  {
    word: "hoài bão",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) ấp ủ trong lòng ý muốn làm những điều lớn lao và tốt đẹp: sống an phận, không hoài bão điều gì",
    example: "sống an phận, không hoài bão điều gì",
  },
  {
    word: "hoài bão",
    part_of_speech: "danh từ",
    meaning:
      "điều lớn lao và tốt đẹp ấp ủ trong lòng dự định muốn làm: ấp ủ nhiều hoài bão * nuôi hoài bão",
    example: "ấp ủ nhiều hoài bão * nuôi hoài bão",
  },
  {
    word: "hoả xa",
    part_of_speech: "danh từ",
    meaning: "(cũ) xe lửa: nhân viên hoả xa",
    example: "nhân viên hoả xa",
  },
  {
    word: "hoài",
    part_of_speech: "động từ",
    meaning:
      'để mất đi một cách hoàn toàn vô ích do đem dùng vào việc không đáng hoặc không mang lại một kết quả nào cả: hoài tiền đi mua cái thứ đó * "Hoài hơi mà đấm bị bông, Đấm được bên nọ, nó phồng bên kia." (Cdao)',
    example:
      'hoài tiền đi mua cái thứ đó * "Hoài hơi mà đấm bị bông, Đấm được bên nọ, nó phồng bên kia." (Cdao)',
  },
  {
    word: "hoài",
    part_of_speech: "phụ từ",
    meaning:
      'mãi không thôi, mãi không chịu dứt: nói hoài mà nó đâu có chuyển * "Áo đen không lẽ đen hoài, Mưa lâu cũng nhạt, nắng hoài cũng phai." (Cdao)',
    example:
      'nói hoài mà nó đâu có chuyển * "Áo đen không lẽ đen hoài, Mưa lâu cũng nhạt, nắng hoài cũng phai." (Cdao)',
  },
  {
    word: "hoài của",
    part_of_speech: "cảm từ",
    meaning:
      "(khẩu ngữ) tiếng thốt ra tỏ ý tiếc một dịp may bị bỏ lỡ hoặc một cái gì bị bỏ phí đi: còn tốt thế mà bỏ đi, rõ hoài của! * hoài của mà mua cái ngữ ấy!",
    example: "còn tốt thế mà bỏ đi, rõ hoài của! * hoài của mà mua cái ngữ ấy!",
  },
  {
    word: "hoài cảm",
    part_of_speech: "động từ",
    meaning:
      "(văn chương) nhớ đến và xúc động trong lòng (về những gì đã qua): câu thơ hoài cảm * phút giây hoài cảm",
    example: "câu thơ hoài cảm * phút giây hoài cảm",
  },
  {
    word: "hoài cảm",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương) niềm thương nhớ và xúc động: những hoài cảm cứ vấn vương trong lòng",
    example: "những hoài cảm cứ vấn vương trong lòng",
  },
  {
    word: "hoài nghi",
    part_of_speech: "động từ",
    meaning:
      "không tin hẳn, khiến có thể dẫn tới nghi ngờ, phủ định: tỏ vẻ hoài nghi * nhìn bằng ánh mắt hoài nghi",
    example: "tỏ vẻ hoài nghi * nhìn bằng ánh mắt hoài nghi",
  },
  {
    word: "hoài nghi",
    part_of_speech: "danh từ",
    meaning:
      "điều vẫn còn nghi hoặc, khiến cho không thể tin hẳn được: xoá bỏ mọi hoài nghi * gieo rắc hoài nghi để gây chia rẽ",
    example: "xoá bỏ mọi hoài nghi * gieo rắc hoài nghi để gây chia rẽ",
  },
  {
    word: "hoại sinh",
    part_of_speech: "",
    meaning:
      "(thực vật) sống nhờ những chất hữu cơ đang thối rữa: loại nấm hoại sinh mọc trên các thân gỗ mục",
    example: "loại nấm hoại sinh mọc trên các thân gỗ mục",
  },
  {
    word: "hoài cổ",
    part_of_speech: "động từ",
    meaning:
      "nhớ tiếc cái đã thuộc về một thời xa xưa: người già thường hay hoài cổ",
    example: "người già thường hay hoài cổ",
  },
  {
    word: "hoài phí",
    part_of_speech: "động từ",
    meaning: "(hiếm) như phí hoài: để hoài phí tuổi xuân * hoài phí tiền của",
    example: "để hoài phí tuổi xuân * hoài phí tiền của",
  },
  {
    word: "hoại thư",
    part_of_speech: "tính từ",
    meaning:
      "bị chết và phân rã một bộ phận trên cơ thể sống do thiếu hay bị ngưng cung cấp máu: một vết loét hoại thư",
    example: "một vết loét hoại thư",
  },
  {
    word: "hoài niệm",
    part_of_speech: "động từ",
    meaning:
      "(văn chương) nhớ về, nghĩ về những gì đã qua: hoài niệm về quá khứ",
    example: "hoài niệm về quá khứ",
  },
  {
    word: "hoại tử",
    part_of_speech: "",
    meaning:
      "(tế bào hoặc nhóm tế bào) chết bên cạnh các tế bào còn sống: vết thương đã bị hoại tử",
    example: "vết thương đã bị hoại tử",
  },
  {
    word: "hoàn",
    part_of_speech: "danh từ",
    meaning: "thuốc đông y ở dạng viên tròn: thuốc hoàn * cao đơn hoàn tán",
    example: "thuốc hoàn * cao đơn hoàn tán",
  },
  {
    word: "hoàn",
    part_of_speech: "động từ",
    meaning:
      "trả lại vật mình đã mượn, đã lấy: hoàn lại vốn * viện trợ không hoàn lại * hoàn lại khoản tiền tạm ứng",
    example:
      "hoàn lại vốn * viện trợ không hoàn lại * hoàn lại khoản tiền tạm ứng",
  },
  {
    word: "hoãn",
    part_of_speech: "danh từ",
    meaning: "đồ trang sức đeo tai của phụ nữ thời trước: tai đeo hoãn",
    example: "tai đeo hoãn",
  },
  {
    word: "hoãn",
    part_of_speech: "động từ",
    meaning:
      "chuyển thời điểm định làm việc gì đó sang thời điểm khác, muộn hơn: hoãn chuyến đi đến tuần sau * nhà gái xin hoãn cưới",
    example: "hoãn chuyến đi đến tuần sau * nhà gái xin hoãn cưới",
  },
  {
    word: "hoài vọng",
    part_of_speech: "động từ",
    meaning:
      "mong ước, trông chờ tha thiết điều biết là cao xa, khó đạt được: hoài vọng một xã hội công bằng",
    example: "hoài vọng một xã hội công bằng",
  },
  {
    word: "hoài vọng",
    part_of_speech: "danh từ",
    meaning:
      "điều mong ước cao xa khó đạt được: không có hoài vọng * chỉ sống bằng hoài vọng",
    example: "không có hoài vọng * chỉ sống bằng hoài vọng",
  },
  {
    word: "hoàn cầu",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) toàn thế giới: chiến thắng làm chấn động hoàn cầu * đi khắp hoàn cầu",
    example: "chiến thắng làm chấn động hoàn cầu * đi khắp hoàn cầu",
  },
  {
    word: "hoàn cảnh",
    part_of_speech: "danh từ",
    meaning:
      "toàn thể nói chung những nhân tố khách quan có tác động đến con người hay sự vật, hiện tượng nào đó: hoàn cảnh khó khăn * bị hoàn cảnh xô đẩy",
    example: "hoàn cảnh khó khăn * bị hoàn cảnh xô đẩy",
  },
  {
    word: "hoãn binh",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) kéo dài thời gian để nghĩ cách, tìm cách đối phó: tìm cách hoãn binh * xin hoãn binh để có thời gian suy nghĩ",
    example: "tìm cách hoãn binh * xin hoãn binh để có thời gian suy nghĩ",
  },
  {
    word: "hoàn công",
    part_of_speech: "động từ",
    meaning:
      "hoàn thành công trình xây dựng: công trình đã hoàn công vào tháng trước * biên bản kiểm tra hoàn công",
    example:
      "công trình đã hoàn công vào tháng trước * biên bản kiểm tra hoàn công",
  },
  {
    word: "hoàn chỉnh",
    part_of_speech: "tính từ",
    meaning:
      "có đầy đủ tất cả các bộ phận cấu thành cần thiết: một bộ máy hoàn chỉnh",
    example: "một bộ máy hoàn chỉnh",
  },
  {
    word: "hoàn chỉnh",
    part_of_speech: "động từ",
    meaning:
      "làm cho trở thành hoàn chỉnh: hoàn chỉnh hệ thống quản lí * đang hoàn chỉnh dần bản đồ án tốt nghiệp",
    example:
      "hoàn chỉnh hệ thống quản lí * đang hoàn chỉnh dần bản đồ án tốt nghiệp",
  },
  {
    word: "hoán dụ",
    part_of_speech: "danh từ",
    meaning:
      "biện pháp dùng tên gọi của sự vật này để chỉ sự vật khác, như lấy tên gọi cái toàn thể để chỉ cái bộ phận, lấy tên gọi cái chứa đựng để chỉ cái được chứa đựng, hoặc ngược lại, v.v.: sử dụng biện pháp hoán dụ * phân biệt giữa hoán dụ và ẩn dụ",
    example: "sử dụng biện pháp hoán dụ * phân biệt giữa hoán dụ và ẩn dụ",
  },
  {
    word: "hoan hỉ",
    part_of_speech: "tính từ",
    meaning:
      "vui mừng, sung sướng biểu lộ rõ ra trên nét mặt, cử chỉ, lời nói: nét mặt hoan hỉ * hoan hỉ trong lòng",
    example: "nét mặt hoan hỉ * hoan hỉ trong lòng",
  },
  {
    word: "hoàn hảo",
    part_of_speech: "tính từ",
    meaning: "tốt hoàn toàn: một tác phẩm hoàn hảo * không ai là hoàn hảo",
    example: "một tác phẩm hoàn hảo * không ai là hoàn hảo",
  },
  {
    word: "hoan hỷ",
    part_of_speech: "tính từ",
    meaning:
      "vui mừng, sung sướng biểu lộ rõ ra trên nét mặt, cử chỉ, lời nói: nét mặt hoan hỉ * hoan hỉ trong lòng",
    example: "nét mặt hoan hỉ * hoan hỉ trong lòng",
  },
  {
    word: "hoán đổi",
    part_of_speech: "động từ",
    meaning:
      "đổi, chuyển đổi vị trí, vai trò hoặc mục đích sử dụng, v.v. (nói khái quát): hoán đổi nhà cho nhau",
    example: "hoán đổi nhà cho nhau",
  },
  {
    word: "hoán đổi",
    part_of_speech: "động từ",
    meaning:
      "(kĩ thuật) chuyển đổi các chương trình đang được kích hoạt với đĩa cứng, để dành bộ nhớ cho chúng hoạt động được hiệu quả nhất: hoán đổi dữ liệu giữa bộ nhớ ảo và bộ nhớ vật lí",
    example: "hoán đổi dữ liệu giữa bộ nhớ ảo và bộ nhớ vật lí",
  },
  {
    word: "hoàn hồn",
    part_of_speech: "động từ",
    meaning:
      "hồi lại, trở lại trạng thái tinh thần bình thường sau khi khiếp sợ vì một chấn động mạnh về tâm lí: sợ quá, mãi mới hoàn hồn",
    example: "sợ quá, mãi mới hoàn hồn",
  },
  {
    word: "hoan hô",
    part_of_speech: "động từ",
    meaning:
      "tán thưởng bằng lời hoặc bằng cách vỗ tay, v.v.: vỗ tay hoan hô * hoan hô chú bộ đội",
    example: "vỗ tay hoan hô * hoan hô chú bộ đội",
  },
  {
    word: "hoàn lương",
    part_of_speech: "động từ",
    meaning:
      "trở lại cuộc đời làm ăn lương thiện (sau một quãng thời gian lầm lỡ): một tên cướp đã hoàn lương",
    example: "một tên cướp đã hoàn lương",
  },
  {
    word: "hoan lạc",
    part_of_speech: "tính từ",
    meaning: "(văn chương) rất vui sướng: niềm hoan lạc",
    example: "niềm hoan lạc",
  },
  {
    word: "hoan lạc",
    part_of_speech: "danh từ",
    meaning: "(cũ) như khoái lạc: thú hoan lạc",
    example: "thú hoan lạc",
  },
  {
    word: "hoàn mĩ",
    part_of_speech: "tính từ",
    meaning: "đẹp đến mức không chê được một điểm nào: vẻ đẹp hoàn mĩ",
    example: "vẻ đẹp hoàn mĩ",
  },
  {
    word: "hoan nghênh",
    part_of_speech: "động từ",
    meaning:
      "đón chào hoặc tiếp nhận với thái độ hết sức vui vẻ: hoan nghênh đoàn đại biểu * ý kiến được nhiều người hoan nghênh",
    example: "hoan nghênh đoàn đại biểu * ý kiến được nhiều người hoan nghênh",
  },
  {
    word: "hoàn lưu",
    part_of_speech: "động từ",
    meaning:
      "(nước hoặc chất khí) chuyển động thành vòng tròn: khí quyển hoàn lưu",
    example: "khí quyển hoàn lưu",
  },
  {
    word: "hoàn lưu",
    part_of_speech: "danh từ",
    meaning:
      "dòng nước hoặc khối không khí chuyển động thành vòng tròn: hoàn lưu của cơn bão",
    example: "hoàn lưu của cơn bão",
  },
  {
    word: "hoạn nạn",
    part_of_speech: "danh từ",
    meaning: "sự việc không may, gây đau khổ lớn cho con người: gặp hoạn nạn",
    example: "gặp hoạn nạn",
  },
  {
    word: "hoạn nạn",
    part_of_speech: "tính từ",
    meaning:
      '(Ít dùng) ở hoàn cảnh không may, chịu nhiều đau khổ: qua cơn hoạn nạn * "Khi vui thì vỗ tay vào, Đến khi hoạn nạn thì nào thấy ai." (Cdao)',
    example:
      'qua cơn hoạn nạn * "Khi vui thì vỗ tay vào, Đến khi hoạn nạn thì nào thấy ai." (Cdao)',
  },
  {
    word: "hoàn mỹ",
    part_of_speech: "tính từ",
    meaning: "đẹp đến mức không chê được một điểm nào: vẻ đẹp hoàn mĩ",
    example: "vẻ đẹp hoàn mĩ",
  },
  {
    word: "hoàn tất",
    part_of_speech: "động từ",
    meaning:
      "làm xong hoàn toàn: hoàn tất sổ sách kế toán * vẫn chưa hoàn tất công việc",
    example: "hoàn tất sổ sách kế toán * vẫn chưa hoàn tất công việc",
  },
  {
    word: "hoàn thành",
    part_of_speech: "động từ",
    meaning:
      "làm xong một cách đầy đủ: hoàn thành nhiệm vụ được giao * công trình được hoàn thành đúng kế hoạch",
    example:
      "hoàn thành nhiệm vụ được giao * công trình được hoàn thành đúng kế hoạch",
  },
  {
    word: "hoàn nguyên",
    part_of_speech: "động từ",
    meaning: "làm cho trở lại như cũ: phục chế hoàn nguyên một bức tranh cổ",
    example: "phục chế hoàn nguyên một bức tranh cổ",
  },
  {
    word: "hoàn thiện",
    part_of_speech: "tính từ",
    meaning:
      "tốt và đầy đủ đến mức thấy không cần phải làm gì thêm nữa: kĩ thuật đã đạt đến mức hoàn thiện * ước mơ một xã hội hoàn thiện",
    example:
      "kĩ thuật đã đạt đến mức hoàn thiện * ước mơ một xã hội hoàn thiện",
  },
  {
    word: "hoàn thiện",
    part_of_speech: "động từ",
    meaning:
      "làm cho trở thành hoàn thiện: tự hoàn thiện bản thân * công trình đang ở giai đoạn hoàn thiện",
    example: "tự hoàn thiện bản thân * công trình đang ở giai đoạn hoàn thiện",
  },
  {
    word: "hoàn trả",
    part_of_speech: "động từ",
    meaning:
      "trả lại một cách đầy đủ và nguyên vẹn những gì đã mượn, đã lấy: hoàn trả số tiến đã vay",
    example: "hoàn trả số tiến đã vay",
  },
  {
    word: "hoàn toàn",
    part_of_speech: "tính từ",
    meaning:
      "trọn vẹn, đầy đủ về mọi mặt: thắng lợi hoàn toàn * mọi việc không hoàn toàn như ý muốn * thất vọng hoàn toàn",
    example:
      "thắng lợi hoàn toàn * mọi việc không hoàn toàn như ý muốn * thất vọng hoàn toàn",
  },
  {
    word: "hoán vị",
    part_of_speech: "động từ",
    meaning: "đổi vị trí: hoán vị hai số cho nhau",
    example: "hoán vị hai số cho nhau",
  },
  {
    word: "hoán vị",
    part_of_speech: "danh từ",
    meaning:
      "kết quả của phép hoán vị: 312 và 213 là hai hoán vị của ba số 1, 2, 3",
    example: "312 và 213 là hai hoán vị của ba số 1, 2, 3",
  },
  {
    word: "hoán vị",
    part_of_speech: "động từ",
    meaning:
      "cắt bỏ tinh hoàn hay buồng trứng, làm cho mất khả năng sinh sản: hoạn lợn * quan hoạn",
    example: "hoạn lợn * quan hoạn",
  },
  {
    word: "hoàn vũ",
    part_of_speech: "danh từ",
    meaning: "(hiếm) toàn vũ trụ: hoa hậu hoàn vũ",
    example: "hoa hậu hoàn vũ",
  },
  {
    word: "hoảng",
    part_of_speech: "",
    meaning:
      "ở trạng thái mất tự chủ đột ngột, do bị tác động của một sự đe doạ, một sự cố bất ngờ: hoảng quá, vứt cả giày dép mà chạy * phát hoảng lên",
    example: "hoảng quá, vứt cả giày dép mà chạy * phát hoảng lên",
  },
  {
    word: "hoang",
    part_of_speech: "tính từ",
    meaning:
      "(nơi) không được con người sử dụng, trông nom đến: ruộng hoang * nhà để hoang * nấm mồ hoang",
    example: "ruộng hoang * nhà để hoang * nấm mồ hoang",
  },
  {
    word: "hoang",
    part_of_speech: "tính từ",
    meaning:
      "(cây cối, động vật) không được con người nuôi trồng như những trường hợp bình thường khác: cây mọc hoang * chó hoang",
    example: "cây mọc hoang * chó hoang",
  },
  {
    word: "hoang",
    part_of_speech: "tính từ",
    meaning:
      "lang thang, không có nơi chốn nhất định: bỏ nhà đi hoang * chó chạy hoang",
    example: "bỏ nhà đi hoang * chó chạy hoang",
  },
  {
    word: "hoang",
    part_of_speech: "tính từ",
    meaning:
      "ngoài hôn nhân hợp pháp một cách vụng trộm: chửa hoang * con hoang",
    example: "chửa hoang * con hoang",
  },
  {
    word: "hoang",
    part_of_speech: "tính từ",
    meaning:
      "rộng rãi quá mức trong việc ăn tiêu: tiêu hoang * bà ấy rất hoang",
    example: "tiêu hoang * bà ấy rất hoang",
  },
  {
    word: "hoang",
    part_of_speech: "tính từ",
    meaning: "(Phương ngữ) nghịch ngợm: thằng nhỏ hoang lắm",
    example: "thằng nhỏ hoang lắm",
  },
  {
    word: "hoàng",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) hoàng tử, hoàng thân nói chung: sướng như ông hoàng",
    example: "sướng như ông hoàng",
  },
  {
    word: "hoàng",
    part_of_speech: "tính từ",
    meaning: "(Nghĩa cổ) màu vàng: hoàng long, hoàng kỳ ..",
    example: "hoàng long, hoàng kỳ ..",
  },
  {
    word: "hoang báo",
    part_of_speech: "động từ",
    meaning: "(cũ) báo điều không có thật: hoang báo tin giặc dữ",
    example: "hoang báo tin giặc dữ",
  },
  {
    word: "hoãn xung",
    part_of_speech: "",
    meaning:
      "(khu vực) có tác dụng làm hoà hoãn sự xung đột giữa hai thế lực lớn đối lập, do vị trí nằm giữa hai thế lực ấy: khu hoãn xung * nước hoãn xung",
    example: "khu hoãn xung * nước hoãn xung",
  },
  {
    word: "hoang dại",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất tự nhiên, không có những tác động, những ảnh hưởng của con người: cây mọc hoang dại * tiếng cười hoang dại",
    example: "cây mọc hoang dại * tiếng cười hoang dại",
  },
  {
    word: "hoàng cung",
    part_of_speech: "danh từ",
    meaning:
      "khí giới gồm một thanh cứng uốn cong (gọi là cánh cung), hai đầu nối với nhau bằng sợi dây căng, dùng sức bật của dây để bắn mũi tên đi: giương cung * bắn cung",
    example: "giương cung * bắn cung",
  },
  {
    word: "hoàng cung",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ gồm một dây căng trên một cần gỗ dài, dùng để bật cho xơ bông tơi ra: cung bật bông",
    example: "cung bật bông",
  },
  {
    word: "hoàng cung",
    part_of_speech: "động từ",
    meaning: "bật cho xơ bông tơi ra bằng cái cung hoặc bằng máy: cung bông",
    example: "cung bông",
  },
  {
    word: "hoàng cung",
    part_of_speech: "động từ",
    meaning:
      "(Phương ngữ) co tay thành hình vòng cung: cung tay đấm cái bụp vô gốc cây",
    example: "cung tay đấm cái bụp vô gốc cây",
  },
  {
    word: "hoàng cung",
    part_of_speech: "danh từ",
    meaning:
      "(cũng hoàng cung) nhà ở của vua: cung vua phủ chúa * được tuyển vào cung",
    example: "cung vua phủ chúa * được tuyển vào cung",
  },
  {
    word: "hoàng cung",
    part_of_speech: "danh từ",
    meaning: "nơi thờ tôn nghiêm nhất trong đền, miếu: cung thờ thánh mẫu",
    example: "cung thờ thánh mẫu",
  },
  {
    word: "hoàng cung",
    part_of_speech: "danh từ",
    meaning:
      "toà nhà to đẹp dùng làm nơi tổ chức các hoạt động quần chúng về văn hoá, thể thao: cung văn hoá * cung thiếu nhi * cung thể thao dưới nước",
    example: "cung văn hoá * cung thiếu nhi * cung thể thao dưới nước",
  },
  {
    word: "hoàng cung",
    part_of_speech: "danh từ",
    meaning: "ô vuông dùng cho tướng và sĩ trên bàn cờ tướng: tốt nhập cung",
    example: "tốt nhập cung",
  },
  {
    word: "hoàng cung",
    part_of_speech: "danh từ",
    meaning:
      "chặng đường đi bộ chừng nửa ngày, hai đầu có trạm nghỉ: đi được nửa cung đường * phu trạm một ngày đi được khoảng hai cung",
    example:
      "đi được nửa cung đường * phu trạm một ngày đi được khoảng hai cung",
  },
  {
    word: "hoàng cung",
    part_of_speech: "danh từ",
    meaning:
      "chặng đường chia ra trên một tuyến đường giao thông để tiện cho việc quản lí: cán bộ phụ trách cung đường đoạn từ đèo Ngang đến Hà Tĩnh",
    example: "cán bộ phụ trách cung đường đoạn từ đèo Ngang đến Hà Tĩnh",
  },
  {
    word: "hoàng cung",
    part_of_speech: "danh từ",
    meaning:
      "lời khai của bị can trước cơ quan điều tra: lấy cung * bức cung * hỏi cung",
    example: "lấy cung * bức cung * hỏi cung",
  },
  {
    word: "hoàng cung",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị để đo khoảng cách giữa hai nốt nhạc: lỗi nhịp cung đàn * hát lạc nhịp sai cung",
    example: "lỗi nhịp cung đàn * hát lạc nhịp sai cung",
  },
  {
    word: "hoàng cung",
    part_of_speech: "danh từ",
    meaning:
      'tính cách về giọng điệu của bài ca, bản nhạc cổ truyền: "Trống cơm khéo vỗ nên vông, Đàn cầm khen ai khéo gảy nên cung xang xừ." (Cdao)',
    example:
      'Trống cơm khéo vỗ nên vông, Đàn cầm khen ai khéo gảy nên cung xang xừ." (Cdao)',
  },
  {
    word: "hoàng cung",
    part_of_speech: "danh từ",
    meaning: "khoản, mục trong bảng số tử vi: cung công danh",
    example: "cung công danh",
  },
  {
    word: "hoàng cung",
    part_of_speech: "động từ",
    meaning:
      "cung cấp hàng hoá, trong quan hệ với tình hình yêu cầu về hàng hoá trên thị trường: cung không kịp cầu * có cầu thì mới có cung",
    example: "cung không kịp cầu * có cầu thì mới có cung",
  },
  {
    word: "hoang dã",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất tự nhiên của núi rừng, xa đời sống của xã hội loài người: động vật hoang dã",
    example: "động vật hoang dã",
  },
  {
    word: "hoang đảo",
    part_of_speech: "danh từ",
    meaning: "đảo hoang, không có người ở: thuyền dạt vào một hoang đảo",
    example: "thuyền dạt vào một hoang đảo",
  },
  {
    word: "hoàng đạo",
    part_of_speech: "danh từ",
    meaning: "quỹ đạo chuyển động biểu kiến của Mặt Trời trên nền sao.",
    example: "ngày hoàng đạo * chọn giờ hoàng đạo để khởi hành",
  },
  {
    word: "hoàng gia",
    part_of_speech: "danh từ",
    meaning: "như hoàng tộc: nối nghiệp hoàng gia",
    example: "nối nghiệp hoàng gia",
  },
  {
    word: "hoang đường",
    part_of_speech: "tính từ",
    meaning:
      "không có thật và không tin được, do có nhiều yếu tố tưởng tượng và phóng đại quá mức: chuyện hoang đường * câu chuyện được thêu dệt bằng nhiều tình tiết hoang đường",
    example:
      "chuyện hoang đường * câu chuyện được thêu dệt bằng nhiều tình tiết hoang đường",
  },
  {
    word: "hoang đàng",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) có lối sống buông tuồng, đàng điếm, hư hỏng: ăn chơi hoang đàng",
    example: "ăn chơi hoang đàng",
  },
  {
    word: "hoàng hôn",
    part_of_speech: "danh từ",
    meaning:
      "lúc mặt trời mới lặn, ánh sáng yếu ớt và mờ dần: hoàng hôn buông xuống * buổi hoàng hôn của cuộc đời (b)",
    example: "hoàng hôn buông xuống * buổi hoàng hôn của cuộc đời (b)",
  },
  {
    word: "hoang hoác",
    part_of_speech: "tính từ",
    meaning: "như hoác (nhưng ý mức độ nhiều hơn): hở hoang hoác",
    example: "hở hoang hoác",
  },
  {
    word: "hoang hoá",
    part_of_speech: "tính từ",
    meaning:
      "(ruộng đất) bị bỏ hoang lâu ngày: đất hoang hoá * ruộng bị bỏ hoang hoá",
    example: "đất hoang hoá * ruộng bị bỏ hoang hoá",
  },
  {
    word: "hoảng hồn",
    part_of_speech: "",
    meaning:
      "hoảng sợ đến mức mất cả tinh thần, hồn vía: bị một phen hoảng hồn",
    example: "bị một phen hoảng hồn",
  },
  {
    word: "hoàng kim",
    part_of_speech: "danh từ",
    meaning:
      "vàng; dùng để ví sự phồn thịnh nhất, đẹp nhất của một nền văn minh, một thời đại, một thời kì (thường là đã qua): thời kì hoàng kim của đế chế La Mã",
    example: "thời kì hoàng kim của đế chế La Mã",
  },
  {
    word: "hoang lạnh",
    part_of_speech: "tính từ",
    meaning: "hoang vắng và lạnh lẽo: ngôi nhà hoang lạnh như vô chủ",
    example: "ngôi nhà hoang lạnh như vô chủ",
  },
  {
    word: "hoảng hốt",
    part_of_speech: "",
    meaning:
      "hoảng, biểu hiện ra trong cử chỉ, lời nói, v.v.: giọng hoảng hốt * giật mình hoảng hốt",
    example: "giọng hoảng hốt * giật mình hoảng hốt",
  },
  {
    word: "hoảng loạn",
    part_of_speech: "động từ",
    meaning:
      "hoảng tới mức có những biểu hiện mất trí: tâm thần hoảng loạn * ánh mắt hoảng loạn",
    example: "tâm thần hoảng loạn * ánh mắt hoảng loạn",
  },
  {
    word: "hoang liêu",
    part_of_speech: "tính từ",
    meaning: "(hiếm) hoang vắng và hiu quạnh: cảnh hoang liêu",
    example: "cảnh hoang liêu",
  },
  {
    word: "hoàng phái",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như hoàng tộc: người trong hoàng phái",
    example: "người trong hoàng phái",
  },
  {
    word: "hoang mang",
    part_of_speech: "động từ",
    meaning:
      "ở trạng thái luôn thấy bất ổn khiến cho lo lắng, dao động, không biết tin theo cái gì và nên xử trí ra sao: tâm trí hoang mang * trong lòng cực kì hoang mang",
    example: "tâm trí hoang mang * trong lòng cực kì hoang mang",
  },
  {
    word: "hoang phế",
    part_of_speech: "tính từ",
    meaning:
      "ở tình trạng bị bỏ hoang lâu ngày, không được sử dụng: khai khẩn đất hoang phế * ngôi chùa hoang phế",
    example: "khai khẩn đất hoang phế * ngôi chùa hoang phế",
  },
  {
    word: "hoang tàn",
    part_of_speech: "tính từ",
    meaning: "hoang vắng và tiêu điều, đổ nát: làng xóm hoang tàn sau trận bom",
    example: "làng xóm hoang tàn sau trận bom",
  },
  {
    word: "hoang sơ",
    part_of_speech: "tính từ",
    meaning:
      "rất hoang dại, như ở thời sơ khai, nguyên thuỷ: rừng núi hoang sơ * bãi biển còn giữ nguyên vẻ hoang sơ",
    example: "rừng núi hoang sơ * bãi biển còn giữ nguyên vẻ hoang sơ",
  },
  {
    word: "hoàng thành",
    part_of_speech: "danh từ",
    meaning:
      "nơi vua ở và triều đình làm việc, có thành bao bọc: hoàng thành Thăng Long",
    example: "hoàng thành Thăng Long",
  },
  {
    word: "hoảng sợ",
    part_of_speech: "",
    meaning:
      "ở trạng thái mất tự chủ đột ngột do sợ hãi trước sự đe doạ bất ngờ: tiếng quát làm đứa bé hoảng sợ, khóc thét lên",
    example: "tiếng quát làm đứa bé hoảng sợ, khóc thét lên",
  },
  {
    word: "hoang phí",
    part_of_speech: "",
    meaning:
      "hoang, tiêu dùng rộng rãi, quá mức cần thiết, gây lãng phí: tiêu xài hoang phí",
    example: "tiêu xài hoang phí",
  },
  {
    word: "hoàng thượng",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) từ dùng để gọi vua, theo cách gọi tôn kính: muôn tâu hoàng thượng",
    example: "muôn tâu hoàng thượng",
  },
  {
    word: "hoàng trùng",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) châu chấu, về mặt làm hại mùa màng: lúa bị hoàng trùng ăn hại",
    example: "lúa bị hoàng trùng ăn hại",
  },
  {
    word: "hoang toàng",
    part_of_speech: "tính từ",
    meaning:
      "hoang phí một cách bừa bãi: tiêu pha hoang toàng * tính hoang toàng",
    example: "tiêu pha hoang toàng * tính hoang toàng",
  },
  {
    word: "hoang tưởng",
    part_of_speech: "động từ",
    meaning:
      "tưởng tượng ra những điều hoàn toàn vô căn cứ, không thể có trong thực tế: thần kinh hoang tưởng * mắc bệnh hoang tưởng",
    example: "thần kinh hoang tưởng * mắc bệnh hoang tưởng",
  },
  {
    word: "hoang vắng",
    part_of_speech: "tính từ",
    meaning: "không có bóng người, như bị bỏ hoang: khu rừng hoang vắng",
    example: "khu rừng hoang vắng",
  },
  {
    word: "hoang vu",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái bỏ không, cây cỏ mọc tự nhiên, chưa hề có tác động của con người: đồi núi hoang vu",
    example: "đồi núi hoang vu",
  },
  {
    word: "hoàng yến",
    part_of_speech: "danh từ",
    meaning:
      "chim nhỏ cùng họ với bạch yến, lông màu vàng nhạt, nuôi làm cảnh.",
    example: "cái khăn màu hoàng yến",
  },
  {
    word: "hoành cách mô",
    part_of_speech: "danh từ",
    meaning:
      "cơ hình tấm ngăn cách khoang ngực và khoang bụng ở các loài có vú: hiện tượng co thắt cơ hoành",
    example: "hiện tượng co thắt cơ hoành",
  },
  {
    word: "hoành hành",
    part_of_speech: "động từ",
    meaning:
      "làm nhiều điều ngang ngược một cách tuỳ ý trên phạm vi rộng lớn: giặc giã hoành hành khắp nơi * dịch bệnh hoành hành",
    example: "giặc giã hoành hành khắp nơi * dịch bệnh hoành hành",
  },
  {
    word: "hoành",
    part_of_speech: "danh từ",
    meaning: "hoành phi (nói tắt): giữa nhà treo một bức hoành sơn son",
    example: "giữa nhà treo một bức hoành sơn son",
  },
  {
    word: "hoạnh hoẹ",
    part_of_speech: "động từ",
    meaning:
      "bắt bẻ điều này điều nọ để ra oai, làm khó dễ cho người khác: hoạnh hoẹ đủ điều",
    example: "hoạnh hoẹ đủ điều",
  },
  {
    word: "hoành thánh",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) mằn thắn: mì hoành thánh",
    example: "mì hoành thánh",
  },
  {
    word: "hoành phi",
    part_of_speech: "danh từ",
    meaning:
      "biển gỗ lớn có khắc chữ Hán, thường treo ngang giữa gian nhà để thờ hoặc trang trí: phía trên bàn thờ có treo một bức hoành phi",
    example: "phía trên bàn thờ có treo một bức hoành phi",
  },
  {
    word: "hoạt",
    part_of_speech: "tính từ",
    meaning:
      "(nét vẽ, lời văn) thanh thoát, lưu loát: nét chữ hoạt * văn viết rất hoạt",
    example: "nét chữ hoạt * văn viết rất hoạt",
  },
  {
    word: "hoạt bát",
    part_of_speech: "tính từ",
    meaning:
      "lanh lợi trong nói năng, ứng đáp, nhanh nhẹn trong cử chỉ, động tác: nói năng hoạt bát * dáng điệu nhanh nhẹn, hoạt bát",
    example: "nói năng hoạt bát * dáng điệu nhanh nhẹn, hoạt bát",
  },
  {
    word: "hoạt động",
    part_of_speech: "động từ",
    meaning:
      "vận động, cử động, thường là nhằm một mục đích nào đó: lúc nào cũng hoạt động, không chịu ngồi yên * tính ưa hoạt động",
    example: "lúc nào cũng hoạt động, không chịu ngồi yên * tính ưa hoạt động",
  },
  {
    word: "hoạt động",
    part_of_speech: "động từ",
    meaning:
      "thực hiện một chức năng nào đó trong một chỉnh thể: tìm hiểu hoạt động của hệ tuần hoàn * máy móc ngừng hoạt động",
    example: "tìm hiểu hoạt động của hệ tuần hoàn * máy móc ngừng hoạt động",
  },
  {
    word: "hoạt động",
    part_of_speech: "động từ",
    meaning:
      "hoặc d  tiến hành những việc làm có quan hệ chặt chẽ với nhau nhằm một mục đích chung, trong một lĩnh vực nhất định: hoạt động văn nghệ * tham gia các hoạt động xã hội",
    example: "hoạt động văn nghệ * tham gia các hoạt động xã hội",
  },
  {
    word: "hoạt động",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) hoạt động cách mạng (nói tắt): hoạt động bí mật trong lòng địch * thoát li đi hoạt động từ khi mới 14 tuổi",
    example:
      "hoạt động bí mật trong lòng địch * thoát li đi hoạt động từ khi mới 14 tuổi",
  },
  {
    word: "hoạt động",
    part_of_speech: "động từ",
    meaning:
      "hoặc d (nguyên nhân, hiện tượng tự nhiên) tạo ra một tác dụng nào đó: thông báo về hoạt động của cơn bão * thu hẹp phạm vi hoạt động của vi khuẩn",
    example:
      "thông báo về hoạt động của cơn bão * thu hẹp phạm vi hoạt động của vi khuẩn",
  },
  {
    word: "hoạt động",
    part_of_speech: "tính từ",
    meaning:
      'có nhiều biểu hiện hoạt động sôi nổi: "Cả doanh trại im ắng bỗng hoạt động hẳn lên: tiếng còi trực ban, tiếng hát, tiếng cười rúc rích." (XCang; 1)',
    example:
      'Cả doanh trại im ắng bỗng hoạt động hẳn lên: tiếng còi trực ban, tiếng hát, tiếng cười rúc rích." (XCang; 1)',
  },
  {
    word: "hoạt cảnh",
    part_of_speech: "danh từ",
    meaning:
      "hình thức nghệ thuật sân khấu ngắn, nhẹ, phản ánh một cảnh sinh hoạt xã hội: hoạt cảnh ngày mùa",
    example: "hoạt cảnh ngày mùa",
  },
  {
    word: "hoành tráng",
    part_of_speech: "tính từ",
    meaning:
      "(tác phẩm nghệ thuật như tranh, tượng, v.v.) có quy mô đồ sộ nhằm thể hiện những đề tài lớn: một tác phẩm nghệ thuật hoành tráng",
    example: "một tác phẩm nghệ thuật hoành tráng",
  },
  {
    word: "hoạt hoá",
    part_of_speech: "động từ",
    meaning:
      "làm gia tăng thêm khả năng hoạt động về mặt hoá học: than hoạt hoá",
    example: "than hoạt hoá",
  },
  {
    word: "hoạt huyết",
    part_of_speech: "động từ",
    meaning:
      "làm cho máu (trong cơ thể) lưu thông tốt: thuốc hoạt huyết dưỡng não",
    example: "thuốc hoạt huyết dưỡng não",
  },
  {
    word: "hoạt tính",
    part_of_speech: "tính từ",
    meaning:
      "có tác dụng cụ thể nào đó, thường là chữa bệnh: than hoạt tính * bùn hoạt tính",
    example: "than hoạt tính * bùn hoạt tính",
  },
  {
    word: "hoáy",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái lõm xuống thành lỗ tròn sâu và hẹp dần: đôi mắt trũng hoáy * vết thương sâu hoáy",
    example: "đôi mắt trũng hoáy * vết thương sâu hoáy",
  },
  {
    word: "hoắng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có những cử chỉ, hành động làm ồn ào, ầm ĩ để tỏ vẻ quan trọng: chạy hoắng lên * chưa chi đã làm hoắng lên!",
    example: "chạy hoắng lên * chưa chi đã làm hoắng lên!",
  },
  {
    word: "hoặc giả",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là một giả thiết về một khả năng mà người nói cho là có thể có, để qua đó tự rút ra (hoặc để người nghe rút ra) một kết luận nào đó: hoặc giả nó bận nên đến muộn * chẳng ai quan tâm, hoặc giả có quan tâm thì cũng rất hời hợt",
    example:
      "hoặc giả nó bận nên đến muộn * chẳng ai quan tâm, hoặc giả có quan tâm thì cũng rất hời hợt",
  },
  {
    word: "hóc",
    part_of_speech: "tính từ",
    meaning: "bị mắc xương trong cổ họng: hóc xương cá",
    example: "hóc xương cá",
  },
  {
    word: "hóc",
    part_of_speech: "tính từ",
    meaning:
      "(khí cụ có cấu tạo phức tạp) không thể hoạt động bình thường được do bị vướng mắc ở một bộ phận bên trong: khoá bị hóc * súng hóc đạn * hóc máy",
    example: "khoá bị hóc * súng hóc đạn * hóc máy",
  },
  {
    word: "hóc",
    part_of_speech: "tính từ",
    meaning: "(Khẩu ngữ) hóc búa (nói tắt): câu hỏi hóc quá!",
    example: "câu hỏi hóc quá!",
  },
  {
    word: "hoặc",
    part_of_speech: "động từ",
    meaning: "(cũ, hiếm) như mê hoặc: làm hoặc lòng người",
    example: "làm hoặc lòng người",
  },
  {
    word: "hoặc",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị quan hệ giữa nhiều (thường là hai) khả năng khác nhau, không khả năng này thì khả năng kia, ít nhất có một khả năng được thực hiện: chiều nay hoặc sáng mai sẽ có * hoặc anh hoặc tôi, một người phải ở lại",
    example:
      "chiều nay hoặc sáng mai sẽ có * hoặc anh hoặc tôi, một người phải ở lại",
  },
  {
    word: "học",
    part_of_speech: "động từ",
    meaning:
      "thu nhận kiến thức, luyện tập kĩ năng do người khác truyền lại: học nghề * học đàn * đi một ngày đàng học một sàng khôn (tng)",
    example: "học nghề * học đàn * đi một ngày đàng học một sàng khôn (tng)",
  },
  {
    word: "học",
    part_of_speech: "động từ",
    meaning:
      "đọc đi đọc lại, nghiền ngẫm cho nhớ: học sinh học bài * học thuộc lòng",
    example: "học sinh học bài * học thuộc lòng",
  },
  {
    word: "học",
    part_of_speech: "động từ",
    meaning:
      '(Phương ngữ) mách, kể lại chuyện gì, hoặc chuyện của ai: "Mỗi buổi (...) ra chợ ngồi bán, nếu trong nhà có bàn tính việc gì thì nó học lại với chị hết." (HBChánh; 4)',
    example:
      'Mỗi buổi (...) ra chợ ngồi bán, nếu trong nhà có bàn tính việc gì thì nó học lại với chị hết." (HBChánh; 4)',
  },
  {
    word: "hoắm",
    part_of_speech: "tính từ",
    meaning:
      "hõm sâu xuống hoặc sâu hút vào bên trong: bờ sông bị lở, hoắm sâu xuống",
    example: "bờ sông bị lở, hoắm sâu xuống",
  },
  {
    word: "học bổng",
    part_of_speech: "danh từ",
    meaning:
      "tiền trợ cấp ăn học mà nhà nước hay một tổ chức nào đó dành cho những học sinh, sinh viên đạt thành tích cao trong học tập: cấp học bổng cho học sinh nghèo * xin học bổng đi du học",
    example: "cấp học bổng cho học sinh nghèo * xin học bổng đi du học",
  },
  {
    word: "hóc búa",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều yếu tố rắc rối, phức tạp, rất khó trả lời, rất khó giải quyết: vấn đề hóc búa * một bài toán hóc búa",
    example: "vấn đề hóc búa * một bài toán hóc búa",
  },
  {
    word: "học giả",
    part_of_speech: "danh từ",
    meaning:
      "người chuyên làm công tác nghiên cứu và có tri thức khoa học sâu rộng: một học giả nổi tiếng",
    example: "một học giả nổi tiếng",
  },
  {
    word: "học đòi",
    part_of_speech: "động từ",
    meaning:
      "bắt chước làm theo những việc không hay một cách thiếu suy nghĩ: học đòi chơi sang * học đòi xa hoa",
    example: "học đòi chơi sang * học đòi xa hoa",
  },
  {
    word: "hóc hách",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tỏ thái độ muốn chống lại: không ai dám ho he, hóc hách gì",
    example: "không ai dám ho he, hóc hách gì",
  },
  {
    word: "học hỏi",
    part_of_speech: "động từ",
    meaning:
      "tìm tòi, hỏi han để học tập: tính ham học hỏi * có tinh thần học hỏi",
    example: "tính ham học hỏi * có tinh thần học hỏi",
  },
  {
    word: "học hàm",
    part_of_speech: "danh từ",
    meaning:
      "cấp bậc của người nghiên cứu, giảng dạy ở bậc đại học, ở các viện nghiên cứu: học hàm giáo sư, phó giáo sư",
    example: "học hàm giáo sư, phó giáo sư",
  },
  {
    word: "học kì",
    part_of_speech: "danh từ",
    meaning: "phần của năm học: họp sơ kết học kì I * ôn thi học kì",
    example: "họp sơ kết học kì I * ôn thi học kì",
  },
  {
    word: "học hành",
    part_of_speech: "động từ",
    meaning:
      "học tập và thực hành (nói khát quát): chăm lo việc học hành của con cái * học hành ngày càng tiến bộ",
    example: "chăm lo việc học hành của con cái * học hành ngày càng tiến bộ",
  },
  {
    word: "học đường",
    part_of_speech: "danh từ",
    meaning: "trường học: chốn học đường * câu chuyện học đường",
    example: "chốn học đường * câu chuyện học đường",
  },
  {
    word: "học kỳ",
    part_of_speech: "danh từ",
    meaning: "phần của năm học: họp sơ kết học kì I * ôn thi học kì",
    example: "họp sơ kết học kì I * ôn thi học kì",
  },
  {
    word: "học lỏm",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) học bằng cách nghe hoặc xem người khác làm rồi tự học, tự làm theo chứ không có ai trực tiếp chỉ bảo: học lỏm được mấy câu tiếng Anh",
    example: "học lỏm được mấy câu tiếng Anh",
  },
  {
    word: "học mót",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) học lại của người khác từng ít một, không có hệ thống: học mót được mấy bài thuốc nam",
    example: "học mót được mấy bài thuốc nam",
  },
  {
    word: "học phí",
    part_of_speech: "danh từ",
    meaning:
      "tiền học sinh phải đóng cho nhà trường theo định kì: là con thương binh nên được giảm học phí",
    example: "là con thương binh nên được giảm học phí",
  },
  {
    word: "học lực",
    part_of_speech: "danh từ",
    meaning: "sức học: học lực khá * chia nhóm theo học lực",
    example: "học lực khá * chia nhóm theo học lực",
  },
  {
    word: "học sinh",
    part_of_speech: "danh từ",
    meaning: "người học ở bậc phổ thông: học sinh tiểu học * thời học sinh",
    example: "học sinh tiểu học * thời học sinh",
  },
  {
    word: "học phiệt",
    part_of_speech: "danh từ",
    meaning:
      "học giả có thế lực chuyên tìm cách đàn áp những tư tưởng học thuật khác mình nhằm nắm quyền chi phối hoặc giữ độc quyền về học thuật: tư tưởng học phiệt",
    example: "tư tưởng học phiệt",
  },
  {
    word: "học phẩm",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) đồ dùng cần thiết cho việc học tập của học sinh, như giấy bút, phấn, bảng đen, v.v. (nói khái quát): cửa hàng kinh doanh học phẩm",
    example: "cửa hàng kinh doanh học phẩm",
  },
  {
    word: "học phái",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) nhóm học giả cùng theo một xu hướng học thuật riêng: đứng đầu một học phái * các học phái đối lập",
    example: "đứng đầu một học phái * các học phái đối lập",
  },
  {
    word: "học thức",
    part_of_speech: "danh từ",
    meaning:
      "tri thức do học tập mà có: trình độ học thức cao * một người có học thức",
    example: "trình độ học thức cao * một người có học thức",
  },
  {
    word: "học trình",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị xác định khối lượng kiến thức được truyền đạt trong 15 tiết trên giảng đường đại học: xác định số học trình của một môn học",
    example: "xác định số học trình của một môn học",
  },
  {
    word: "học vấn",
    part_of_speech: "danh từ",
    meaning:
      "những hiểu biết, tri thức nhờ học tập mà có: kiểm tra trình độ học vấn * có học vấn cao",
    example: "kiểm tra trình độ học vấn * có học vấn cao",
  },
  {
    word: "học tập",
    part_of_speech: "động từ",
    meaning:
      "học và luyện tập để hiểu biết, để có kĩ năng, có tri thức: kết quả học tập * siêng năng học tập",
    example: "kết quả học tập * siêng năng học tập",
  },
  {
    word: "học tập",
    part_of_speech: "động từ",
    meaning: "làm theo gương tốt: học tập lẫn nhau * học tập kinh nghiệm",
    example: "học tập lẫn nhau * học tập kinh nghiệm",
  },
  {
    word: "học thuyết",
    part_of_speech: "danh từ",
    meaning:
      "toàn thể nói chung những quan niệm có hệ thống dùng để lí giải các hiện tượng và hướng hoạt động của con người trong một lĩnh vực nhất định nào đó: học thuyết giá trị thặng dư của Marx * học thuyết của Khổng Tử",
    example: "học thuyết giá trị thặng dư của Marx * học thuyết của Khổng Tử",
  },
  {
    word: "học vị",
    part_of_speech: "danh từ",
    meaning:
      "danh vị cấp cho người có trình độ học vấn nhất định, đã trải qua và tốt nghiệp khoá học trên đại học: nhận học vị thạc sĩ * học vị tiến sĩ toán học",
    example: "nhận học vị thạc sĩ * học vị tiến sĩ toán học",
  },
  {
    word: "học vẹt",
    part_of_speech: "động từ",
    meaning:
      "học thuộc lòng từng câu, từng chữ, nhưng không hiểu gì, giống như con vẹt học nói: tránh thói học vẹt",
    example: "tránh thói học vẹt",
  },
  {
    word: "học viên",
    part_of_speech: "danh từ",
    meaning:
      "người (thường là lớn tuổi) học ở những trường lớp không thuộc hệ thống giáo dục phổ thông hay đại học: học viên cao học * học viên của trung tâm dạy nghề",
    example: "học viên cao học * học viên của trung tâm dạy nghề",
  },
  {
    word: "học thuật",
    part_of_speech: "danh từ",
    meaning:
      "tri thức khoa học có được do học tập, nghiên cứu (nói khái quát): giá trị học thuật * quan điểm học thuật * trao đổi những vấn đề về học thuật",
    example:
      "giá trị học thuật * quan điểm học thuật * trao đổi những vấn đề về học thuật",
  },
  {
    word: "học viện",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi của một số trường tương đương trường đại học hoặc cơ quan nghiên cứu khoa học tương đương viện: học viện quân y * học viện quốc phòng",
    example: "học viện quân y * học viện quốc phòng",
  },
  {
    word: "học việc",
    part_of_speech: "động từ",
    meaning: "tập làm để học nghề trực tiếp tại nơi làm việc: thợ học việc",
    example: "thợ học việc",
  },
  {
    word: "học trò",
    part_of_speech: "danh từ",
    meaning:
      '(khẩu ngữ) học sinh: tuổi học trò * "Học trò đèn sách hôm mai, Ngày sau thi đỗ nên trai mới hào." (ca dao)',
    example:
      'tuổi học trò * "Học trò đèn sách hôm mai, Ngày sau thi đỗ nên trai mới hào." (ca dao)',
  },
  {
    word: "học trò",
    part_of_speech: "danh từ",
    meaning:
      "người kế tục học thuyết của một người khác hoặc được người khác trực tiếp giáo dục và rèn luyện: Viện Pasteur ở Hà Nội do Yersin, học trò của Pasteur xây dựng",
    example: "Viện Pasteur ở Hà Nội do Yersin, học trò của Pasteur xây dựng",
  },
  {
    word: "hoen rỉ",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái bị gỉ ăn loang ra nhiều chỗ: cánh cổng sắt đã hoen gỉ",
    example: "cánh cổng sắt đã hoen gỉ",
  },
  {
    word: "hoen gỉ",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái bị gỉ ăn loang ra nhiều chỗ: cánh cổng sắt đã hoen gỉ",
    example: "cánh cổng sắt đã hoen gỉ",
  },
  {
    word: "hoen",
    part_of_speech: "",
    meaning:
      "bẩn từng chỗ do bị chất gì đó thấm vào và loang ra: dầu mỡ làm hoen quần áo * mực hoen đầy cặp sách * gỉ sắt hoen ra tay",
    example:
      "dầu mỡ làm hoen quần áo * mực hoen đầy cặp sách * gỉ sắt hoen ra tay",
  },
  {
    word: "học xá",
    part_of_speech: "danh từ",
    meaning:
      "trường học lớn, có nơi ăn ở cho học sinh: khu học xá dành cho sinh viên nước ngoài",
    example: "khu học xá dành cho sinh viên nước ngoài",
  },
  {
    word: "hoe",
    part_of_speech: "tính từ",
    meaning:
      "có màu đỏ nhạt hay vàng nhạt, nhưng tươi và ánh lên: tóc vàng hoe * mắt hoe đỏ",
    example: "tóc vàng hoe * mắt hoe đỏ",
  },
  {
    word: "hoe",
    part_of_speech: "động từ",
    meaning: "phát ra ánh sáng vàng nhạt: nắng hoe lên một chút yếu ớt",
    example: "nắng hoe lên một chút yếu ớt",
  },
  {
    word: "hoen ố",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái có nhiều vết bẩn loang ra, khó gột rửa: quyển sách bị hoen ố vì nước mưa",
    example: "quyển sách bị hoen ố vì nước mưa",
  },
  {
    word: "hỏi dò",
    part_of_speech: "động từ",
    meaning:
      "hỏi dần dần từng người, từng việc để tìm manh mối điều cần biết: hỏi dò tung tích",
    example: "hỏi dò tung tích",
  },
  {
    word: "hoi",
    part_of_speech: "tính từ",
    meaning: "có mùi gây gây khó ngửi: thịt để lâu bị hoi",
    example: "thịt để lâu bị hoi",
  },
  {
    word: "hoe hoe",
    part_of_speech: "tính từ",
    meaning: "hơi hoe: mắt hoe hoe đỏ * đồng lúa đã bắt đầu hoe hoe",
    example: "mắt hoe hoe đỏ * đồng lúa đã bắt đầu hoe hoe",
  },
  {
    word: "hỏi đáp",
    part_of_speech: "động từ",
    meaning:
      "hỏi và trả lời (nói khái quát): các dịch vụ hỏi đáp * chuyên mục  *  trên truyền hình",
    example: "các dịch vụ hỏi đáp * chuyên mục  *  trên truyền hình",
  },
  {
    word: "hỏi thăm",
    part_of_speech: "động từ",
    meaning:
      "hỏi để biết tình hình, tin tức hoặc để được chỉ dẫn điều cần biết: hỏi thăm sức khoẻ * khách lạ hỏi thăm đường * hỏi thăm tin nhà",
    example: "hỏi thăm sức khoẻ * khách lạ hỏi thăm đường * hỏi thăm tin nhà",
  },
  {
    word: "hói",
    part_of_speech: "danh từ",
    meaning:
      "nhánh sông con, nhỏ, hẹp, được đào hoặc do tự nhiên hình thành để dẫn nước, tiêu nước: đào hói dẫn nước vào ruộng",
    example: "đào hói dẫn nước vào ruộng",
  },
  {
    word: "hói",
    part_of_speech: "danh từ",
    meaning:
      "hõm đất hình thành do nước biển xoáy mạnh ăn sâu vào đất liền ở các vịnh: thuyền đậu trong hói",
    example: "thuyền đậu trong hói",
  },
  {
    word: "hói",
    part_of_speech: "tính từ",
    meaning:
      "bị rụng nhiều hoặc gần hết tóc, làm vùng trên trán và đỉnh đầu trơn nhẵn: cái trán hói * người đàn ông đầu hói",
    example: "cái trán hói * người đàn ông đầu hói",
  },
  {
    word: "hỏi",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi một thanh điệu của tiếng Việt, được kí hiệu bằng dấu B: phân biệt hỏi, ngã",
    example: "phân biệt hỏi, ngã",
  },
  {
    word: "hỏi",
    part_of_speech: "động từ",
    meaning:
      "nói ra điều mình muốn người ta cho mình biết với yêu cầu được trả lời: hỏi lại đề bài * hỏi thi * hỏi ý kiến * đi hỏi già, về nhà hỏi trẻ (tng)",
    example:
      "hỏi lại đề bài * hỏi thi * hỏi ý kiến * đi hỏi già, về nhà hỏi trẻ (tng)",
  },
  {
    word: "hỏi",
    part_of_speech: "động từ",
    meaning:
      "nói ra điều mình đòi hỏi hoặc mong muốn ở người ta với yêu cầu được đáp ứng: hỏi mượn quyển sách * khách hỏi mua nhà * hỏi giấy tờ",
    example: "hỏi mượn quyển sách * khách hỏi mua nhà * hỏi giấy tờ",
  },
  {
    word: "hỏi",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) hỏi vợ (nói tắt): xem ngày để làm lễ hỏi * mới hỏi, chưa cưới",
    example: "xem ngày để làm lễ hỏi * mới hỏi, chưa cưới",
  },
  {
    word: "hỏi",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) chào hỏi (nói tắt): gặp người quen phải hỏi * đi hỏi về chào",
    example: "gặp người quen phải hỏi * đi hỏi về chào",
  },
  {
    word: "hỏi han",
    part_of_speech: "động từ",
    meaning: "hỏi để biết (nói khái quát): hỏi han tin tức * hỏi han tình hình",
    example: "hỏi han tin tức * hỏi han tình hình",
  },
  {
    word: "hỏi han",
    part_of_speech: "động từ",
    meaning:
      "hỏi để bày tỏ sự quan tâm, chăm sóc: hỏi han sức khoẻ * đi cả ngày, không hỏi han gì đến con cái",
    example: "hỏi han sức khoẻ * đi cả ngày, không hỏi han gì đến con cái",
  },
  {
    word: "hỏi nhỏ",
    part_of_speech: "động từ",
    meaning: "hỏi riêng, không để cho người khác biết: ghé tai hỏi nhỏ",
    example: "ghé tai hỏi nhỏ",
  },
  {
    word: "hỏi vặn",
    part_of_speech: "động từ",
    meaning:
      "hỏi cặn kẽ, dùng lí lẽ bắt bẻ hết điều này đến điều khác, khiến người ta khó trả lời: luống cuống vì bị hỏi vặn",
    example: "luống cuống vì bị hỏi vặn",
  },
  {
    word: "hom",
    part_of_speech: "danh từ",
    meaning: "đoạn thân cây dùng để giâm thành cây mới: hom sắn",
    example: "hom sắn",
  },
  {
    word: "hom",
    part_of_speech: "danh từ",
    meaning: "lông cứng ở đầu hạt thóc: thóc có hom",
    example: "thóc có hom",
  },
  {
    word: "hom",
    part_of_speech: "danh từ",
    meaning: "xương cá hoặc xơ rất nhỏ: hom cá * hom cau",
    example: "hom cá * hom cau",
  },
  {
    word: "hom",
    part_of_speech: "danh từ",
    meaning:
      'bộ phận đậy miệng lờ, đó, có hình nón thủng ở chóp, để tôm cá không trở ra được khi đã vào: cái hom giỏ * "Chớ nghe lời phỉnh tiếng phờ, Thò tay vào lờ mắc kẹt cái hom." (Cdao)',
    example:
      'cái hom giỏ * "Chớ nghe lời phỉnh tiếng phờ, Thò tay vào lờ mắc kẹt cái hom." (Cdao)',
  },
  {
    word: "hòm",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng để đựng có dạng hình hộp, thường bằng gỗ hay sắt mỏng, có nắp đậy kín và thường có khoá: hòm quần áo * hòm đạn * hòm thư * cất tiền vào trong hòm",
    example: "hòm quần áo * hòm đạn * hòm thư * cất tiền vào trong hòm",
  },
  {
    word: "hóm",
    part_of_speech: "tính từ",
    meaning:
      "tinh và nhanh nhạy trong nhận xét, đối đáp, biết cách đùa vui ý nhị và đúng lúc: kể chuyện rất hóm * cậu bé nói chuyện hóm quá!",
    example: "kể chuyện rất hóm * cậu bé nói chuyện hóm quá!",
  },
  {
    word: "hõm",
    part_of_speech: "tính từ",
    meaning:
      "lõm sâu xuống hoặc sâu vào trong: mắt hõm sâu vì thiếu ngủ * gầy hõm đi như người mới ốm dậy",
    example: "mắt hõm sâu vì thiếu ngủ * gầy hõm đi như người mới ốm dậy",
  },
  {
    word: "hỏm",
    part_of_speech: "tính từ",
    meaning: "lõm vào và hẹp: hang sâu hỏm",
    example: "hang sâu hỏm",
  },
  {
    word: "hỏm",
    part_of_speech: "danh từ",
    meaning: "chỗ lõm sâu vào: hỏm đá",
    example: "hỏm đá",
  },
  {
    word: "hom hem",
    part_of_speech: "tính từ",
    meaning:
      "gầy ốm, suy giảm thể lực đến mức trông già hẳn đi: mặt mũi hom hem * người đã hom hem",
    example: "mặt mũi hom hem * người đã hom hem",
  },
  {
    word: "hóm hỉnh",
    part_of_speech: "tính từ",
    meaning: "hóm (nói khái quát): cười hóm hỉnh * câu pha trò rất hóm hỉnh",
    example: "cười hóm hỉnh * câu pha trò rất hóm hỉnh",
  },
  {
    word: "hòm hòm",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) tạm ổn, tạm xong, tạm đủ, phần còn lại là không đáng kể: công việc đã hòm hòm * tiền nong chuẩn bị cũng hòm hòm",
    example: "công việc đã hòm hòm * tiền nong chuẩn bị cũng hòm hòm",
  },
  {
    word: "hòm thư",
    part_of_speech: "danh từ",
    meaning: "thùng để bỏ thư.",
    example: "mã số hòm thư của đơn vị",
  },
  {
    word: "hòm xiểng",
    part_of_speech: "danh từ",
    meaning: "hòm đựng quần áo, đồ đạc (nói khái quát): sắp xếp hòm xiểng",
    example: "sắp xếp hòm xiểng",
  },
  {
    word: "hòn",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị những vật nhỏ, gọn, thường là hình tròn: hòn bi * hòn than * hòn đất ném đi, hòn chì ném lại (tng)",
    example: "hòn bi * hòn than * hòn đất ném đi, hòn chì ném lại (tng)",
  },
  {
    word: "hòn",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị những núi, đảo đứng riêng một mình: hòn đảo * hòn núi",
    example: "hòn đảo * hòn núi",
  },
  {
    word: "hòng",
    part_of_speech: "động từ",
    meaning:
      'muốn và cố thực hiện được điều biết là rất khó, thậm chí không thể thực hiện: đừng hòng che mắt được nó * "Cái vòng danh lợi cong cong, Kẻ hòng ra khỏi, người mong nhẩy vào." (Cdao)',
    example:
      'đừng hòng che mắt được nó * "Cái vòng danh lợi cong cong, Kẻ hòng ra khỏi, người mong nhẩy vào." (Cdao)',
  },
  {
    word: "họng",
    part_of_speech: "danh từ",
    meaning:
      "khoang rỗng trong cổ, ở phía sau miệng, thông với thực quản và khí quản: bị viêm họng * nói rát cổ bỏng họng",
    example: "bị viêm họng * nói rát cổ bỏng họng",
  },
  {
    word: "họng",
    part_of_speech: "danh từ",
    meaning:
      "(Thông tục) họng của con người, được coi là biểu tượng của sự phát ngôn (hàm ý khinh): bắt nó phải câm họng lại * cứng họng không nói được gì",
    example: "bắt nó phải câm họng lại * cứng họng không nói được gì",
  },
  {
    word: "họng",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận thông từ trong lòng của một số vật với bên ngoài: họng súng * họng cối xay",
    example: "họng súng * họng cối xay",
  },
  {
    word: "hỏng",
    part_of_speech: "tính từ",
    meaning:
      "(Nam thường hư) ở tình trạng không thể dùng được nữa: xe hỏng máy * phá hỏng * một bên mắt bị hỏng",
    example: "xe hỏng máy * phá hỏng * một bên mắt bị hỏng",
  },
  {
    word: "hỏng",
    part_of_speech: "tính từ",
    meaning:
      "không thành, không mang lại kết quả như ý muốn: thi hỏng * làm hỏng việc",
    example: "thi hỏng * làm hỏng việc",
  },
  {
    word: "hỏng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) trở thành sút kém về mặt phẩm chất, đạo đức: được nuông chiều quá đâm hỏng * thằng ấy thì hỏng thật rồi!",
    example: "được nuông chiều quá đâm hỏng * thằng ấy thì hỏng thật rồi!",
  },
  {
    word: "hóng",
    part_of_speech: "động từ",
    meaning: "chờ sẵn để đón lấy: hóng gió * ngồi hóng mát",
    example: "hóng gió * ngồi hóng mát",
  },
  {
    word: "hóng",
    part_of_speech: "động từ",
    meaning: "chờ sẵn để đón nghe: nghe hóng * ngồi hóng chuyện",
    example: "nghe hóng * ngồi hóng chuyện",
  },
  {
    word: "hóng",
    part_of_speech: "động từ",
    meaning: "hướng về phía nào đó, có ý chờ đón: hóng tin * chó sủa hóng",
    example: "hóng tin * chó sủa hóng",
  },
  {
    word: "hong hóng",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả vẻ hết sức mong đợi và luôn luôn chờ sẵn để đón nhận cái gì đang tới: hong hóng chờ đợi",
    example: "hong hóng chờ đợi",
  },
  {
    word: "hỏng hóc",
    part_of_speech: "động từ",
    meaning:
      "(máy móc, thiết bị) mất toàn bộ hay một phần khả năng làm việc, do một bộ phận hay một chi tiết máy nào đó không làm được chức năng của nó: tu sửa các bộ phận hỏng hóc * máy móc quá cũ, hay hỏng hóc",
    example: "tu sửa các bộ phận hỏng hóc * máy móc quá cũ, hay hỏng hóc",
  },
  {
    word: "hong",
    part_of_speech: "động từ",
    meaning:
      "làm cho khô đi bằng cách để ở chỗ thoáng gió hoặc chỗ gần lửa hay có ánh nắng dịu: hong quần áo * hong tay trên bếp * đứng trước gió để hong tóc",
    example: "hong quần áo * hong tay trên bếp * đứng trước gió để hong tóc",
  },
  {
    word: "hóng hớt",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) hóng nghe chuyện của người khác (nói khái quát; hàm ý chê): tính hay hóng hớt * quen thói hóng hớt",
    example: "tính hay hóng hớt * quen thói hóng hớt",
  },
  {
    word: "hooligan",
    part_of_speech: "danh từ",
    meaning:
      "kẻ hay gây náo động và có hành vi bạo lực, côn đồ nơi công cộng, thường tụ họp thành nhóm: hooligan bóng đá",
    example: "hooligan bóng đá",
  },
  {
    word: "họp hành",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) họp bàn công việc chung (nói khái quát; thường hàm ý chê): họp hành liên miên * lúc nào cũng họp với hành",
    example: "họp hành liên miên * lúc nào cũng họp với hành",
  },
  {
    word: "hóp",
    part_of_speech: "tính từ",
    meaning: "(má) lõm vào: gầy quá, má hóp vào",
    example: "gầy quá, má hóp vào",
  },
  {
    word: "họp mặt",
    part_of_speech: "động từ",
    meaning:
      "họp nhau lại một nơi để gặp gỡ thân mật: họp mặt cựu chiến binh * buổi họp mặt nhân dịp đầu xuân",
    example: "họp mặt cựu chiến binh * buổi họp mặt nhân dịp đầu xuân",
  },
  {
    word: "hót",
    part_of_speech: "động từ",
    meaning:
      "(chim, vượn) kêu thành chuỗi những tiếng cao trong và như có làn điệu: chim hót líu lo * vượn hót",
    example: "chim hót líu lo * vượn hót",
  },
  {
    word: "hót",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) nói cho biết để tâng công, để nịnh: hót với cấp trên * khéo hót",
    example: "hót với cấp trên * khéo hót",
  },
  {
    word: "hót",
    part_of_speech: "động từ",
    meaning:
      "lấy mang đi những vật rời, vụn (thường là bị thải hoặc bị rơi vãi) cho sạch: hót rác * hót mùn * hót thóc rơi vãi",
    example: "hót rác * hót mùn * hót thóc rơi vãi",
  },
  {
    word: "họp",
    part_of_speech: "động từ",
    meaning:
      "tập trung lại một nơi để cùng nhau làm một việc gì: họp chợ * họp gia đình * họp giao ban",
    example: "họp chợ * họp gia đình * họp giao ban",
  },
  {
    word: "họp báo",
    part_of_speech: "động từ",
    meaning:
      "họp với các nhà báo được mời đến để công bố, tuyên bố điều gì quan trọng: tổ chức họp báo * họp báo để giới thiệu sản phẩm mới",
    example: "tổ chức họp báo * họp báo để giới thiệu sản phẩm mới",
  },
  {
    word: "hồ",
    part_of_speech: "danh từ",
    meaning:
      "nơi đất trũng chứa nước, thường là nước ngọt, tương đối rộng và sâu, nằm trong đất liền: hồ Hoàn Kiếm nằm ở trung tâm Hà Nội",
    example: "hồ Hoàn Kiếm nằm ở trung tâm Hà Nội",
  },
  {
    word: "hồ",
    part_of_speech: "danh từ",
    meaning: "nhạc khí hai dây kéo bằng vĩ, tiếng trầm.",
    example: "trộn hồ * làm phụ hồ (phụ việc cho thợ hồ)",
  },
  {
    word: "hồ",
    part_of_speech: "danh từ",
    meaning: "cháo loãng nấu bằng gạo hoặc bột: ăn hồ",
    example: "ăn hồ",
  },
  {
    word: "hồ",
    part_of_speech: "danh từ",
    meaning:
      "chất dính quấy bằng bột và nước, dùng để dán: quấy hồ * có bột mới gột nên hồ (tng)",
    example: "quấy hồ * có bột mới gột nên hồ (tng)",
  },
  {
    word: "hồ",
    part_of_speech: "động từ",
    meaning:
      "làm cho sợi dệt hoặc vải thấm đều một lớp nước có pha chất bột hoặc keo: áo trắng hồ lơ",
    example: "áo trắng hồ lơ",
  },
  {
    word: "hồ",
    part_of_speech: "danh từ",
    meaning: "tiền người đánh bạc nộp cho chủ sòng: chứa bạc để thu tiền hồ",
    example: "chứa bạc để thu tiền hồ",
  },
  {
    word: "hồ",
    part_of_speech: "phụ từ",
    meaning: "(Từ cũ) như hầu: đêm đã hồ tàn",
    example: "đêm đã hồ tàn",
  },
  {
    word: "hô",
    part_of_speech: "động từ",
    meaning:
      "cất tiếng cao, to, ngắn gọn để ra lệnh, thúc giục hoặc biểu thị yêu cầu, quyết tâm, v.v.: đoàn người vừa đi vừa hô khẩu hiệu * hô xung phong",
    example: "đoàn người vừa đi vừa hô khẩu hiệu * hô xung phong",
  },
  {
    word: "hô",
    part_of_speech: "tính từ",
    meaning: "(răng cửa) nhô ra: răng bị hô",
    example: "răng bị hô",
  },
  {
    word: "hổ",
    part_of_speech: "động từ",
    meaning:
      '(cũ) tủi thẹn, tự cảm thấy mình xấu, kém cỏi: xấu chàng hổ ai (tng) * "Hổ sinh ra phận thơ đào, Công cha nghĩa mẹ kiếp nào trả xong." (TKiều)',
    example:
      'xấu chàng hổ ai (tng) * "Hổ sinh ra phận thơ đào, Công cha nghĩa mẹ kiếp nào trả xong." (TKiều)',
  },
  {
    word: "hố",
    part_of_speech: "danh từ",
    meaning:
      "chỗ lõm sâu xuống, to và rộng (thường được đào ở mặt đất): hố bom * đào hố trồng cây * giữa hai người có một hố sâu ngăn cách (b)",
    example:
      "hố bom * đào hố trồng cây * giữa hai người có một hố sâu ngăn cách (b)",
  },
  {
    word: "hố",
    part_of_speech: "tính từ",
    meaning:
      "(thông tục) ở vào tình thế do sơ suất mà bị thiệt: bị hố với bọn bạn",
    example: "bị hố với bọn bạn",
  },
  {
    word: "hộ",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị để quản lí dân số, gồm những người cùng ăn ở chung với nhau: hai hộ ở cạnh nhau * xã có gần một nghìn hộ * hộ độc thân",
    example: "hai hộ ở cạnh nhau * xã có gần một nghìn hộ * hộ độc thân",
  },
  {
    word: "hộ",
    part_of_speech: "động từ",
    meaning:
      "làm thay cho ai việc gì đó: nhờ chị giảng hộ bài toán * trông nhà hộ",
    example: "nhờ chị giảng hộ bài toán * trông nhà hộ",
  },
  {
    word: "hồ cầm",
    part_of_speech: "danh từ",
    meaning:
      'nhạc khí cổ một dây, cần phím trơn, bầu cộng hưởng làm bằng gáo dừa: "Cung thương làu bậc ngũ âm, Nghề riêng ăn đứt hồ cầm một trương." (TKiều)',
    example:
      'Cung thương làu bậc ngũ âm, Nghề riêng ăn đứt hồ cầm một trương." (TKiều)',
  },
  {
    word: "hổ cốt",
    part_of_speech: "danh từ",
    meaning: "xương hổ dùng làm thuốc: cao hổ cốt * rượu hổ cốt",
    example: "cao hổ cốt * rượu hổ cốt",
  },
  {
    word: "hộ chiếu",
    part_of_speech: "danh từ",
    meaning:
      "giấy chứng minh do cơ quan nhà nước, thường là cơ quan quản lí xuất nhập cảnh, cấp cho công dân khi ra nước ngoài: làm hộ chiếu để đi du học",
    example: "làm hộ chiếu để đi du học",
  },
  {
    word: "hồ dễ",
    part_of_speech: "phụ từ",
    meaning:
      '(văn chương) đâu có dễ gì: "Một năm được mấy tháng xuân, Gái kia hồ dễ mấy lần đưa dâu." (ca dao)',
    example:
      'Một năm được mấy tháng xuân, Gái kia hồ dễ mấy lần đưa dâu." (ca dao)',
  },
  {
    word: "hổ danh",
    part_of_speech: "động từ",
    meaning:
      "bị tổn hại tên tuổi, danh tiếng: ăn nói xấc xược, thật hổ danh con nhà có học * không hổ danh là con nhà võ",
    example:
      "ăn nói xấc xược, thật hổ danh con nhà có học * không hổ danh là con nhà võ",
  },
  {
    word: "hộ giá",
    part_of_speech: "động từ",
    meaning: "đi theo vua để làm nhiệm vụ bảo vệ: đoàn xe hộ giá",
    example: "đoàn xe hộ giá",
  },
  {
    word: "hố ga",
    part_of_speech: "danh từ",
    meaning:
      "hố được đào, xây dọc theo đường nước thải để cho các chất cặn, bã lắng xuống, nước chảy thoát đi: làm vệ sinh hố ga * nắp hố ga bị vỡ",
    example: "làm vệ sinh hố ga * nắp hố ga bị vỡ",
  },
  {
    word: "hồ hải",
    part_of_speech: "danh từ",
    meaning: "(cũ, văn chương) hồ và biển; dùng để ví chí khí lớn: chí hồ hải",
    example: "chí hồ hải",
  },
  {
    word: "hồ đồ",
    part_of_speech: "tính từ",
    meaning:
      "vội vàng, không phân biệt rõ ràng, lẫn lộn giữa đúng và sai trong nhận thức hoặc trong ý kiến: ăn nói hồ đồ * kết luận hồ đồ",
    example: "ăn nói hồ đồ * kết luận hồ đồ",
  },
  {
    word: "hô hào",
    part_of_speech: "động từ",
    meaning:
      "kêu gọi mọi người cùng tham gia làm việc gì: hô hào đổi mới * hô hào quyên góp ủng hộ đồng bào lũ lụt",
    example: "hô hào đổi mới * hô hào quyên góp ủng hộ đồng bào lũ lụt",
  },
  {
    word: "hộ đê",
    part_of_speech: "động từ",
    meaning: "bảo vệ đê để phòng lũ lụt: phu hộ đê",
    example: "phu hộ đê",
  },
  {
    word: "hô hấp",
    part_of_speech: "danh từ",
    meaning:
      "quá trình lấy oxygen từ bên ngoài vào cơ thể và thải khí carbonic ra ngoài của sinh vật: hệ hô hấp * cá hô hấp bằng mang * viêm đường hô hấp",
    example: "hệ hô hấp * cá hô hấp bằng mang * viêm đường hô hấp",
  },
  {
    word: "hô hoán",
    part_of_speech: "động từ",
    meaning:
      "kêu to lên cho mọi người biết: hô hoán mọi người bắt thằng ăn trộm",
    example: "hô hoán mọi người bắt thằng ăn trộm",
  },
  {
    word: "hồ hởi",
    part_of_speech: "tính từ",
    meaning:
      "vui và phấn khởi, biểu lộ rõ ra bên ngoài: thái độ hồ hởi * giọng hồ hởi * khuôn mặt toát lên vẻ hồ hởi",
    example: "thái độ hồ hởi * giọng hồ hởi * khuôn mặt toát lên vẻ hồ hởi",
  },
  {
    word: "hô hố",
    part_of_speech: "tính từ",
    meaning: "từ mô phỏng tiếng cười to và thô lỗ: cười hô hố",
    example: "cười hô hố",
  },
  {
    word: "hộ khẩu",
    part_of_speech: "danh từ",
    meaning: "người ở trong một hộ: xin nhập hộ khẩu * hộ khẩu thường trú",
    example: "xin nhập hộ khẩu * hộ khẩu thường trú",
  },
  {
    word: "hộ khẩu",
    part_of_speech: "danh từ",
    meaning: "sổ hộ khẩu (nói tắt): không có tên trong hộ khẩu",
    example: "không có tên trong hộ khẩu",
  },
  {
    word: "hổ lốn",
    part_of_speech: "tính từ",
    meaning:
      "gồm nhiều thứ, nhiều loại trộn lẫn với nhau một cách lộn xộn: món ăn hổ lốn * một mớ kiến thức hổ lốn",
    example: "món ăn hổ lốn * một mớ kiến thức hổ lốn",
  },
  {
    word: "hồ li",
    part_of_speech: "danh từ",
    meaning: "(cũ) con cáo: bầy hồ li",
    example: "bầy hồ li",
  },
  {
    word: "hộ mạng",
    part_of_speech: "động từ",
    meaning:
      "bảo vệ tính mạng, giữ gìn cho tính mạng được an toàn khi gặp nguy hiểm, theo quan niệm cũ: bùa hộ mệnh * thần hộ mệnh",
    example: "bùa hộ mệnh * thần hộ mệnh",
  },
  {
    word: "hổ ngươi",
    part_of_speech: "tính từ",
    meaning:
      '(cũ, hiếm) xấu hổ, tự lấy làm thẹn: "Hoa tàn hoa héo không tươi, Đoái nhìn bạn cũ, hổ ngươi mười phần." (ca dao)',
    example:
      'Hoa tàn hoa héo không tươi, Đoái nhìn bạn cũ, hổ ngươi mười phần." (ca dao)',
  },
  {
    word: "hộ mệnh",
    part_of_speech: "động từ",
    meaning:
      "bảo vệ tính mạng, giữ gìn cho tính mạng được an toàn khi gặp nguy hiểm, theo quan niệm cũ: bùa hộ mệnh * thần hộ mệnh",
    example: "bùa hộ mệnh * thần hộ mệnh",
  },
  {
    word: "hộ pháp",
    part_of_speech: "danh từ",
    meaning:
      "thần bảo vệ đạo Phật, thường được xây hay đắp thành tượng lớn (ông Thiện và ông ác) ở hai bên cửa chính của chùa: tay khoẻ như tay hộ pháp",
    example: "tay khoẻ như tay hộ pháp",
  },
  {
    word: "hổ phách",
    part_of_speech: "danh từ",
    meaning:
      "nhựa thông lâu ngày kết rắn lại, có màu vàng nâu, trong suốt, dùng làm đồ trang sức: chiếc vòng hổ phách",
    example: "chiếc vòng hổ phách",
  },
  {
    word: "hồ nghi",
    part_of_speech: "động từ",
    meaning:
      'cảm thấy có điều không rõ ràng, nên còn nghi ngờ, không tin là đúng sự thật: trong bụng hồ nghi * "Nửa mừng nửa lại hồ nghi, Biết rằng bạn có yêu vì hay không?" (ca dao)',
    example:
      'trong bụng hồ nghi * "Nửa mừng nửa lại hồ nghi, Biết rằng bạn có yêu vì hay không?" (ca dao)',
  },
  {
    word: "hổ nhục",
    part_of_speech: "tính từ",
    meaning: "hổ thẹn và nhục nhã: không biết hổ nhục!",
    example: "không biết hổ nhục!",
  },
  {
    word: "hồ quang",
    part_of_speech: "danh từ",
    meaning:
      "dạng phóng điện tự duy trì qua chất khí, trong đó hiệu điện thế giữa hai điện cực tương đối thấp nhưng dòng phóng điện có cường độ lớn, tạo ra plasma nhiệt độ cao và ánh sáng chói: lò hồ quang",
    example: "lò hồ quang",
  },
  {
    word: "hổ phù",
    part_of_speech: "danh từ",
    meaning:
      "phù hiệu, ấn tín của các quan võ thời xưa, có khắc hình đầu con hổ, phân làm hai nửa, một nửa lưu tại triều đình, một nửa giao cho tướng cầm quân.",
    example: "mặt trước của đình có chạm hình hổ phù",
  },
  {
    word: "hộ sinh",
    part_of_speech: "động từ",
    meaning:
      "giúp đỡ và chăm sóc cho người đẻ, cho trẻ sơ sinh: nhà hộ sinh * cô hộ sinh",
    example: "nhà hộ sinh * cô hộ sinh",
  },
  {
    word: "hổ thẹn",
    part_of_speech: "tính từ",
    meaning:
      "tự cảm thấy mình xấu xa, không xứng đáng (nói khái quát): không hổ thẹn với cha ông",
    example: "không hổ thẹn với cha ông",
  },
  {
    word: "hồ thỉ",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) cung và tên; thường dùng để chỉ chí khí người con trai: "Sá chi mặt nước cánh bèo, Nam nhi hồ thỉ quyết liều mới gan." (ca dao)',
    example:
      'Sá chi mặt nước cánh bèo, Nam nhi hồ thỉ quyết liều mới gan." (ca dao)',
  },
  {
    word: "hồ sơ",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp tài liệu có liên quan với nhau về một người, một sự việc hay một vấn đề: hồ sơ học sinh * nghiên cứu hồ sơ của tên tội phạm * hồ sơ vụ án",
    example: "hồ sơ học sinh * nghiên cứu hồ sơ của tên tội phạm * hồ sơ vụ án",
  },
  {
    word: "hộ thân",
    part_of_speech: "động từ",
    meaning: "(hiếm) như phòng thân: tìm một cây gậy làm khí giới hộ thân",
    example: "tìm một cây gậy làm khí giới hộ thân",
  },
  {
    word: "hồ thuỷ",
    part_of_speech: "tính từ",
    meaning: "có màu xanh nhạt như màu nước hồ: chiếc áo lụa hồ thuỷ",
    example: "chiếc áo lụa hồ thuỷ",
  },
  {
    word: "hộ tịch",
    part_of_speech: "danh từ",
    meaning:
      "sổ của cơ quan chính quyền nhà nước có thẩm quyền xác nhận các sự kiện trong đời sống của một người (như sinh, tử, kết hôn, li hôn, v.v...) thuộc địa phương mình quản lí: sổ hộ tịch * đi đăng kí hộ tịch",
    example: "sổ hộ tịch * đi đăng kí hộ tịch",
  },
  {
    word: "hỗ trợ",
    part_of_speech: "động từ",
    meaning:
      "giúp đỡ lẫn nhau, giúp đỡ thêm vào: hỗ trợ những gia đình có hoàn cảnh khó khăn",
    example: "hỗ trợ những gia đình có hoàn cảnh khó khăn",
  },
  {
    word: "hỗ tương",
    part_of_speech: "tính từ",
    meaning: "(cũ, hiếm) như tương hỗ: những đãi ngộ mang tính hỗ tương",
    example: "những đãi ngộ mang tính hỗ tương",
  },
  {
    word: "hộ vệ",
    part_of_speech: "động từ",
    meaning: "theo bên cạnh để bảo vệ: lính hộ vệ * có người đi theo hộ vệ",
    example: "lính hộ vệ * có người đi theo hộ vệ",
  },
  {
    word: "hộ tống",
    part_of_speech: "động từ",
    meaning: "đi theo để bảo vệ: đoàn xe hộ tống * đi hộ tống",
    example: "đoàn xe hộ tống * đi hộ tống",
  },
  {
    word: "hốc",
    part_of_speech: "danh từ",
    meaning:
      "chỗ lõm ăn sâu vào trong thân cây, vách đá, v.v. hoặc đào sâu xuống dưới đất: hốc cây * hốc đá * hai hốc mắt sâu hoắm",
    example: "hốc cây * hốc đá * hai hốc mắt sâu hoắm",
  },
  {
    word: "hốc",
    part_of_speech: "động từ",
    meaning:
      "(lợn) ăn vục cả mõm vào, ngoạm từng miếng to: lợn hốc mõm vào chậu cám",
    example: "lợn hốc mõm vào chậu cám",
  },
  {
    word: "hốc",
    part_of_speech: "động từ",
    meaning: "(Thông tục) ăn: hốc cho lắm vào rồi lại kêu đau bụng",
    example: "hốc cho lắm vào rồi lại kêu đau bụng",
  },
  {
    word: "hốc hác",
    part_of_speech: "tính từ",
    meaning:
      "gầy gò và trông có vẻ phờ phạc, mệt mỏi (nói khái quát): mặt mũi hốc hác * thức liền hai đêm, người hốc hác hẳn đi",
    example: "mặt mũi hốc hác * thức liền hai đêm, người hốc hác hẳn đi",
  },
  {
    word: "hồi",
    part_of_speech: "danh từ",
    meaning:
      "cây to, quả gồm có nhiều múi khô cứng xếp thành hình sao, mỗi múi chứa một hạt, khi chín có màu nâu, mùi thơm, dùng để cất lấy tinh dầu hoặc làm gia vị: dầu hồi * rừng hồi xứ Lạng",
    example: "dầu hồi * rừng hồi xứ Lạng",
  },
  {
    word: "hồi",
    part_of_speech: "danh từ",
    meaning: "mặt tường đầu nhà: đứng ở đầu hồi",
    example: "đứng ở đầu hồi",
  },
  {
    word: "hồi",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị quá trình diễn ra liên tục của một hoạt động, trong khoảng thời gian tương đối ngắn: kéo một hồi còi dài * hồi trống * gió rít lên từng hồi",
    example: "kéo một hồi còi dài * hồi trống * gió rít lên từng hồi",
  },
  {
    word: "hồi",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian tương đối ngắn, là thời điểm đã (hoặc đôi khi đang) diễn ra một sự việc nào đó: hồi trước * hồi còn nhỏ * im lặng một hồi rồi mới nói",
    example: "hồi trước * hồi còn nhỏ * im lặng một hồi rồi mới nói",
  },
  {
    word: "hồi",
    part_of_speech: "danh từ",
    meaning:
      "phần của vở kịch dài, tình tiết gói gọn trong một khoảng thời gian nhất định: đang ở hồi thứ hai của vở kịch",
    example: "đang ở hồi thứ hai của vở kịch",
  },
  {
    word: "hồi",
    part_of_speech: "danh từ",
    meaning:
      "từng phần nhỏ trong một thể loại tiểu thuyết thời trước, thường có tiêu đề khái quát nội dung: truyện có hai mươi hồi",
    example: "truyện có hai mươi hồi",
  },
  {
    word: "hồi",
    part_of_speech: "động từ",
    meaning: "quay trở về: vua hồi cung * hồi hương",
    example: "vua hồi cung * hồi hương",
  },
  {
    word: "hồi",
    part_of_speech: "động từ",
    meaning:
      "trở lại với trạng thái ban đầu: khoa hồi sức * thần sắc vẫn chưa hồi lại được * cây cối như hồi lại sau trận mưa",
    example:
      "khoa hồi sức * thần sắc vẫn chưa hồi lại được * cây cối như hồi lại sau trận mưa",
  },
  {
    word: "hổi",
    part_of_speech: "đại từ",
    meaning: "(phương ngữ, khẩu ngữ) hồi ấy: từ hổi đến giờ",
    example: "từ hổi đến giờ",
  },
  {
    word: "hối",
    part_of_speech: "động từ",
    meaning:
      "cảm thấy tiếc và băn khoăn, day dứt vì đã trót làm điều lầm lỗi: đã trót rồi có hối cũng không kịp",
    example: "đã trót rồi có hối cũng không kịp",
  },
  {
    word: "hối",
    part_of_speech: "động từ",
    meaning: "(Phương ngữ) giục: hối con đi mau cho kịp",
    example: "hối con đi mau cho kịp",
  },
  {
    word: "hối",
    part_of_speech: "tính từ",
    meaning: "(Phương ngữ) nhanh cho kịp: đi hối lên kẻo trễ tàu",
    example: "đi hối lên kẻo trễ tàu",
  },
  {
    word: "hôi",
    part_of_speech: "động từ",
    meaning: "mót (cá): đi hôi cá",
    example: "đi hôi cá",
  },
  {
    word: "hôi",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) lợi dụng nhân lúc có sự lộn xộn để đánh người hay lấy của: hôi của * thấy người ta đánh cũng nhảy vào đánh hôi",
    example: "hôi của * thấy người ta đánh cũng nhảy vào đánh hôi",
  },
  {
    word: "hôi",
    part_of_speech: "tính từ",
    meaning:
      'có mùi khó ngửi như mùi bọ xít, chuột chù: người hôi như cú * "Chuột chù chê khỉ rằng hôi (...)" (ca dao)',
    example: 'người hôi như cú * "Chuột chù chê khỉ rằng hôi (...)" (ca dao)',
  },
  {
    word: "hộc tốc",
    part_of_speech: "phụ từ",
    meaning:
      "hết sức vội vã, cốt cho càng nhanh càng tốt, bất kể mọi cái khác: làm hộc tốc * nghe tin dữ, vội hộc tốc về ngay",
    example: "làm hộc tốc * nghe tin dữ, vội hộc tốc về ngay",
  },
  {
    word: "hội",
    part_of_speech: "danh từ",
    meaning:
      "cuộc vui tổ chức chung cho đông đảo người tham dự, theo phong tục hoặc nhân dịp đặc biệt: làng vào hội * hội chọi trâu ở Đồ Sơn * lòng vui như mở hội",
    example: "làng vào hội * hội chọi trâu ở Đồ Sơn * lòng vui như mở hội",
  },
  {
    word: "hội",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức quần chúng rộng rãi của những người cùng chung một nghề nghiệp hoặc có chung một hoạt động: hội nhà văn * hội phụ huynh học sinh",
    example: "hội nhà văn * hội phụ huynh học sinh",
  },
  {
    word: "hội",
    part_of_speech: "động từ",
    meaning:
      "tập hợp các yếu tố, điều kiện (để làm việc gì): không hội đủ điều kiện * hội được đủ các phẩm chất cần có",
    example: "không hội đủ điều kiện * hội được đủ các phẩm chất cần có",
  },
  {
    word: "hồi âm",
    part_of_speech: "",
    meaning: "(trang trọng) trả lời thư: thư gửi đi nhưng không thấy hồi âm",
    example: "thư gửi đi nhưng không thấy hồi âm",
  },
  {
    word: "hộc",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ đong lường dùng để đong chất hạt rời thời xưa, thường làm bằng gỗ, có dung tích khoảng 10 lít: mấy trăm hộc thóc",
    example: "mấy trăm hộc thóc",
  },
  {
    word: "hộc",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ) ngăn kéo: hộc tủ * tìm trong hộc bàn",
    example: "hộc tủ * tìm trong hộc bàn",
  },
  {
    word: "hộc",
    part_of_speech: "động từ",
    meaning:
      "từ trong cuống họng vọt mạnh ra một cách đột ngột, qua đường mũi, miệng: hộc cơm ra ngoài * bị đánh hộc máu mồm",
    example: "hộc cơm ra ngoài * bị đánh hộc máu mồm",
  },
  {
    word: "hộc",
    part_of_speech: "động từ",
    meaning:
      "phát ra tiếng kêu ngắn, đột ngột, của luồng hơi mạnh từ trong cuống họng bật ra qua mũi, miệng: con lợn hộc lên",
    example: "con lợn hộc lên",
  },
  {
    word: "hối cải",
    part_of_speech: "động từ",
    meaning:
      "hối hận về tội lỗi của mình và tỏ ra muốn sửa chữa: ăn năn hối cải * hối cải về những sai lầm của mình",
    example: "ăn năn hối cải * hối cải về những sai lầm của mình",
  },
  {
    word: "hội báo",
    part_of_speech: "động từ",
    meaning:
      "(cũ) thông báo cho nhau biết, một cách nhanh, gọn tình hình diễn biến của sự việc, theo nền nếp quy định: ban chỉ huy hội báo về tình hình chiến dịch",
    example: "ban chỉ huy hội báo về tình hình chiến dịch",
  },
  {
    word: "hội chẩn",
    part_of_speech: "động từ",
    meaning:
      "họp để trao đổi ý kiến trong một tập thể bác sĩ để chẩn đoán bệnh của bệnh nhân: họp hội chẩn * hội chẩn để quyết định có phẫu thuật hay không",
    example: "họp hội chẩn * hội chẩn để quyết định có phẫu thuật hay không",
  },
  {
    word: "hội chợ",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức trưng bày để giới thiệu các sản phẩm và hàng hoá của một địa phương, một ngành, một nước hoặc nhiều nước trong một thời gian nhất định: hội chợ triển lãm * tham gia hội chợ quốc tế",
    example: "hội chợ triển lãm * tham gia hội chợ quốc tế",
  },
  {
    word: "hội chữ thập đỏ",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức quốc tế có chức năng và nhiệm vụ cứu giúp nạn nhân chiến tranh và các nạn nhân phải chịu ảnh hưởng của thiên tai: hội chữ thập đỏ Việt Nam",
    example: "hội chữ thập đỏ Việt Nam",
  },
  {
    word: "hồi cố",
    part_of_speech: "động từ",
    meaning:
      "hồi tưởng lại những cái trong thời kì xa xưa: hồi cố lại những trận thắng hào hùng của cha ông ta",
    example: "hồi cố lại những trận thắng hào hùng của cha ông ta",
  },
  {
    word: "hội diễn",
    part_of_speech: "danh từ",
    meaning:
      "cuộc trình diễn chung nhiều tiết mục văn nghệ của ngành nghệ thuật sân khấu nhằm trao đổi kinh nghiệm, đánh giá phong trào: hội diễn văn nghệ quần chúng",
    example: "hội diễn văn nghệ quần chúng",
  },
  {
    word: "hồi cư",
    part_of_speech: "động từ",
    meaning:
      "trở về nơi ở cũ, sau thời gian tản cư: đưa gia đình hồi cư ngay sau ngày hoà bình",
    example: "đưa gia đình hồi cư ngay sau ngày hoà bình",
  },
  {
    word: "hội chứng",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp các triệu chứng cùng xuất hiện của bệnh: hội chứng viêm màng não * hội chứng suy giảm miễn dịch mắc phải",
    example: "hội chứng viêm màng não * hội chứng suy giảm miễn dịch mắc phải",
  },
  {
    word: "hội chứng",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) tập hợp các hiện tượng, sự kiện (thường là không tốt) cùng xuất hiện ở nhiều người, nhiều nơi của một tình trạng, một vấn đề xã hội: hội chứng li hôn",
    example: "hội chứng li hôn",
  },
  {
    word: "hối đoái",
    part_of_speech: "danh từ",
    meaning:
      "việc đổi tiền tệ của một nước lấy tiền tệ của một nước khác: tỉ giá hối đoái",
    example: "tỉ giá hối đoái",
  },
  {
    word: "hồi đáp",
    part_of_speech: "động từ",
    meaning: "trả lời lại: nhận được thư hồi đáp",
    example: "nhận được thư hồi đáp",
  },
  {
    word: "hội đoàn",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức đoàn thể của những người có cùng một hoạt động hoặc có cùng một công tác chuyên môn: hội đoàn từ thiện",
    example: "hội đoàn từ thiện",
  },
  {
    word: "hội đàm",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) họp bàn, trao đổi với nhau về những vấn đề chính trị quan trọng (thường là những vấn đề quan hệ ngoại giao, quan hệ quốc tế) giữa các bên: cuộc hội đàm giữa hai thủ tướng của hai nước",
    example: "cuộc hội đàm giữa hai thủ tướng của hai nước",
  },
  {
    word: "hội đồng",
    part_of_speech: "danh từ",
    meaning:
      "tập thể những người được chỉ định hoặc được bầu ra để họp bàn và quyết định những công việc nhất định nào đó: hội đồng giám khảo * lập hội đồng kỉ luật",
    example: "hội đồng giám khảo * lập hội đồng kỉ luật",
  },
  {
    word: "hội đồng quản trị",
    part_of_speech: "danh từ",
    meaning:
      "hội đồng được bầu ra để quản lí, điều hành công việc của một tổ chức kinh doanh: họp hội đồng quản trị của công ti",
    example: "họp hội đồng quản trị của công ti",
  },
  {
    word: "hôi hám",
    part_of_speech: "tính từ",
    meaning: "hôi (nói khái quát): căn phòng ẩm thấp, hôi hám",
    example: "căn phòng ẩm thấp, hôi hám",
  },
  {
    word: "hối hả",
    part_of_speech: "tính từ",
    meaning:
      "(làm việc gì) vội vã, tất bật vì sợ không kịp, không để ý gì đến xung quanh: hối hả đạp xe về nhà * nhịp sống hối hả",
    example: "hối hả đạp xe về nhà * nhịp sống hối hả",
  },
  {
    word: "hối hận",
    part_of_speech: "động từ",
    meaning:
      "lấy làm tiếc và cảm thấy đau khổ day dứt khi nhận ra điều lầm lỗi của mình: hối hận vì đã nói quá lời * không có điều gì phải hối hận",
    example: "hối hận vì đã nói quá lời * không có điều gì phải hối hận",
  },
  {
    word: "hội giảng",
    part_of_speech: "danh từ",
    meaning:
      "hội thi giảng dạy của các giáo viên nhằm đánh giá trình độ và trao đổi kinh nghiệm: hội giảng giáo viên toàn quốc",
    example: "hội giảng giáo viên toàn quốc",
  },
  {
    word: "hội hè",
    part_of_speech: "danh từ",
    meaning: "hội (nói khái quát): hội hè đình đám",
    example: "hội hè đình đám",
  },
  {
    word: "hội hoạ",
    part_of_speech: "danh từ",
    meaning:
      "nghệ thuật dùng đường nét, màu sắc để phản ánh thế giới hình thể lên trên mặt phẳng: triển lãm hội hoạ * niềm đam mê hội hoạ",
    example: "triển lãm hội hoạ * niềm đam mê hội hoạ",
  },
  {
    word: "hội đồng nhân dân",
    part_of_speech: "danh từ",
    meaning:
      "cơ quan quyền lực nhà nước ở địa phương, do nhân dân bầu cử ra: bầu cử hội đồng nhân dân các cấp",
    example: "bầu cử hội đồng nhân dân các cấp",
  },
  {
    word: "hội họp",
    part_of_speech: "động từ",
    meaning:
      "họp nhau lại để bàn công việc chung (nói khái quát): đình làng là nơi hội họp chung của làng",
    example: "đình làng là nơi hội họp chung của làng",
  },
  {
    word: "hội kiến",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) (các nhân vật quan trọng) gặp nhau theo lịch đã xếp từ trước để thảo luận, bàn định về những vấn đề quan trọng: cuộc hội kiến giữa hai vị tổng thống của hai nước",
    example: "cuộc hội kiến giữa hai vị tổng thống của hai nước",
  },
  {
    word: "hối hôn",
    part_of_speech: "động từ",
    meaning:
      "huỷ bỏ giao ước sẽ lấy nhau làm vợ chồng: gia đình nhà gái xin thoái hôn",
    example: "gia đình nhà gái xin thoái hôn",
  },
  {
    word: "hồi hộp",
    part_of_speech: "động từ",
    meaning:
      "ở trong trạng thái trái tim đập dồn dập: thiếu máu nên hay hồi hộp * tim đập hồi hộp",
    example: "thiếu máu nên hay hồi hộp * tim đập hồi hộp",
  },
  {
    word: "hồi hộp",
    part_of_speech: "động từ",
    meaning:
      "ở trong trạng thái lòng luôn bồi hồi, lo lắng không yên trước cái gì sắp đến mà mình đang hết sức quan tâm: hồi hộp bước vào phòng thi * hồi hộp chờ đợi",
    example: "hồi hộp bước vào phòng thi * hồi hộp chờ đợi",
  },
  {
    word: "hồi hương",
    part_of_speech: "danh từ",
    meaning: "(cây) hồi: hoa hồi hương",
    example: "hoa hồi hương",
  },
  {
    word: "hồi hương",
    part_of_speech: "động từ",
    meaning:
      "trở về hoặc để cho trở về quê hương, xứ sở sau nhiều năm sinh sống ở nơi xa, ở nước ngoài: Việt kiều hồi hương",
    example: "Việt kiều hồi hương",
  },
  {
    word: "hối lỗi",
    part_of_speech: "động từ",
    meaning:
      "tự nhận ra được lỗi lầm và tỏ ra đau xót, day dứt về lỗi lầm ấy: ăn năn hối lỗi * biết hối lỗi",
    example: "ăn năn hối lỗi * biết hối lỗi",
  },
  {
    word: "hối lộ",
    part_of_speech: "động từ",
    meaning:
      "đưa tiền của cho người có quyền hành để nhờ làm việc có lợi cho mình, bằng hành vi lạm dụng chức vụ, làm sai pháp luật: hối lộ quan trên * nhận hối lộ * ăn hối lộ",
    example: "hối lộ quan trên * nhận hối lộ * ăn hối lộ",
  },
  {
    word: "hồi môn",
    part_of_speech: "danh từ",
    meaning:
      "tiền của mà người con gái có hoặc được cha mẹ cho để mang theo khi về nhà chồng: của hồi môn",
    example: "của hồi môn",
  },
  {
    word: "hội ngộ",
    part_of_speech: "động từ",
    meaning:
      '(văn chương) gặp nhau (thường là không có hẹn trước, giữa những người thân thiết): mong sẽ có dịp hội ngộ * "Duyên hội ngộ, đức cù lao, Bên tình bên hiếu bên nào nặng hơn?" (TKiều)',
    example:
      'mong sẽ có dịp hội ngộ * "Duyên hội ngộ, đức cù lao, Bên tình bên hiếu bên nào nặng hơn?" (TKiều)',
  },
  {
    word: "hội nhập",
    part_of_speech: "động từ",
    meaning:
      "tham gia vào một cộng đồng để cùng hoạt động và phát triển với cộng đồng ấy (thường nói về quan hệ giữa các dân tộc, các quốc gia): hội nhập quốc tế * hội nhập kinh tế với các nước trong khu vực",
    example: "hội nhập quốc tế * hội nhập kinh tế với các nước trong khu vực",
  },
  {
    word: "hội nghị",
    part_of_speech: "danh từ",
    meaning:
      "cuộc họp được tổ chức với quy mô lớn, có nhiều người dự, để bàn bạc hoặc giải quyết một công việc có tính chất chung nào đó: hội nghị Diên Hồng * hội nghị thượng đỉnh các nước nói tiếng Pháp",
    example:
      "hội nghị Diên Hồng * hội nghị thượng đỉnh các nước nói tiếng Pháp",
  },
  {
    word: "hồi quang",
    part_of_speech: "danh từ",
    meaning:
      "ánh sáng phản chiếu lại; thường dùng để chỉ hình ảnh còn lại của những sự kiện đã qua: hồi quang của chiến thắng",
    example: "hồi quang của chiến thắng",
  },
  {
    word: "hồi phục",
    part_of_speech: "động từ",
    meaning:
      "trở lại hoặc làm cho trở lại được như cũ sau một thời kì bị sút kém: sức khoẻ dần dần hồi phục * nền kinh tế đã hồi phục lại sau khủng hoảng",
    example:
      "sức khoẻ dần dần hồi phục * nền kinh tế đã hồi phục lại sau khủng hoảng",
  },
  {
    word: "hôi rình",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có mùi hôi bốc lên mạnh đến mức không chịu được: đầu tóc hôi rình * mùi quần áo ẩm ướt hôi rình",
    example: "đầu tóc hôi rình * mùi quần áo ẩm ướt hôi rình",
  },
  {
    word: "hội sở",
    part_of_speech: "danh từ",
    meaning:
      "nơi làm việc và giao dịch của một cơ quan, một tổ chức: hội sở của ngân hàng * làm việc tại hội sở",
    example: "hội sở của ngân hàng * làm việc tại hội sở",
  },
  {
    word: "hôi tanh",
    part_of_speech: "tính từ",
    meaning:
      'hôi và tanh (nói khái quát); thường dùng để nói cái xấu xa nhơ nhuốc đáng ghê tởm: quét sạch loài hôi tanh * "Tuồng chi là giống hôi tanh, Thân nghìn vàng để ô danh má hồng." (TKiều)',
    example:
      'quét sạch loài hôi tanh * "Tuồng chi là giống hôi tanh, Thân nghìn vàng để ô danh má hồng." (TKiều)',
  },
  {
    word: "hồi sinh",
    part_of_speech: "động từ",
    meaning:
      "sống hoặc làm cho sống trở lại: cây cỏ như được hồi sinh sau cơn mưa",
    example: "cây cỏ như được hồi sinh sau cơn mưa",
  },
  {
    word: "hồi tâm",
    part_of_speech: "động từ",
    meaning:
      "trở lại trạng thái tỉnh táo và có thể bình tĩnh suy nghĩ: hồi tâm nghĩ lại * hồi tâm tĩnh trí",
    example: "hồi tâm nghĩ lại * hồi tâm tĩnh trí",
  },
  {
    word: "hồi sức",
    part_of_speech: "động từ",
    meaning:
      "phục hồi sự hô hấp và sự tuần hoàn bị suy sụp do mất nhiều máu hoặc sau khi mổ: khoa hồi sức cấp cứu * chuyển bệnh nhân về phòng hồi sức",
    example: "khoa hồi sức cấp cứu * chuyển bệnh nhân về phòng hồi sức",
  },
  {
    word: "hôi thối",
    part_of_speech: "tính từ",
    meaning:
      "có mùi hôi, thối và bẩn (nói khái quát): một mùi hôi thối xông lên nồng nặc",
    example: "một mùi hôi thối xông lên nồng nặc",
  },
  {
    word: "hội thảo",
    part_of_speech: "",
    meaning:
      "họp rộng rãi để thảo luận, bày tỏ, trao đổi ý kiến về một vấn đề chung: hội thảo khoa học",
    example: "hội thảo khoa học",
  },
  {
    word: "hội thoại",
    part_of_speech: "động từ",
    meaning:
      "sử dụng một ngôn ngữ để nói chuyện với nhau: đọc bài hội thoại tiếng Anh * hội thoại bằng tiếng Nga",
    example: "đọc bài hội thoại tiếng Anh * hội thoại bằng tiếng Nga",
  },
  {
    word: "hối thúc",
    part_of_speech: "động từ",
    meaning: "thúc giục, không cho chậm trễ: hối thúc thợ làm nhanh cho kịp",
    example: "hối thúc thợ làm nhanh cho kịp",
  },
  {
    word: "hồi tỉnh",
    part_of_speech: "động từ",
    meaning:
      "tỉnh lại sau cơn mê, ngất, v.v.: bệnh nhân đã hồi tỉnh * ngất đi một lúc mới hồi tỉnh",
    example: "bệnh nhân đã hồi tỉnh * ngất đi một lúc mới hồi tỉnh",
  },
  {
    word: "hội trường",
    part_of_speech: "danh từ",
    meaning:
      "phòng lớn dùng để làm nơi hội họp: hội trường Ba Đình * trang trí hội trường để họp tổng kết",
    example: "hội trường Ba Đình * trang trí hội trường để họp tổng kết",
  },
  {
    word: "hối tiếc",
    part_of_speech: "động từ",
    meaning:
      "hối hận và lấy làm tiếc: hối tiếc vì đã để mất cơ hội * không có gì phải hối tiếc",
    example: "hối tiếc vì đã để mất cơ hội * không có gì phải hối tiếc",
  },
  {
    word: "hội viên",
    part_of_speech: "danh từ",
    meaning:
      "thành viên của một hội: hội viên hội cựu chiến binh * hội viên hội văn học nghệ thuật",
    example: "hội viên hội cựu chiến binh * hội viên hội văn học nghệ thuật",
  },
  {
    word: "hội trưởng",
    part_of_speech: "danh từ",
    meaning:
      "người đứng đầu lãnh đạo một hội: hội trưởng hội phụ huynh học sinh",
    example: "hội trưởng hội phụ huynh học sinh",
  },
  {
    word: "hồi ức",
    part_of_speech: "động từ",
    meaning:
      "nhớ lại điều bản thân đã trải qua một cách có chủ định: hồi ức lại những tháng năm xưa * hồi ức về chiến tranh",
    example: "hồi ức lại những tháng năm xưa * hồi ức về chiến tranh",
  },
  {
    word: "hồi ức",
    part_of_speech: "danh từ",
    meaning: "những điều nhớ lại: hồi ức tuổi thơ * những hồi ức chiến tranh",
    example: "hồi ức tuổi thơ * những hồi ức chiến tranh",
  },
  {
    word: "hồi tưởng",
    part_of_speech: "động từ",
    meaning:
      "nhớ lại, làm sống lại trong tâm trí sự việc nào đó đã qua: hồi tưởng lại thời thơ ấu",
    example: "hồi tưởng lại thời thơ ấu",
  },
  {
    word: "hồi xuân",
    part_of_speech: "động từ",
    meaning:
      "trở lại hoặc làm cho trở lại tươi đẹp, dồi dào sức sống, tựa như trở lại mùa xuân: cảnh vật hồi xuân",
    example: "cảnh vật hồi xuân",
  },
  {
    word: "hồi xuân",
    part_of_speech: "động từ",
    meaning:
      "(phụ nữ ở vào tuổi khoảng bốn mươi - năm mươi) trở lại trẻ trung, tươi đẹp, tựa như trở lại tuổi thanh xuân: đang độ hồi xuân",
    example: "đang độ hồi xuân",
  },
  {
    word: "hồi văn",
    part_of_speech: "danh từ",
    meaning:
      "hình thức trang trí cổ thể hiện bằng những đường nét gấp khúc lặp lại và nối tiếp nhau thành đường diềm chạy dài: chiếu dệt hồi văn",
    example: "chiếu dệt hồi văn",
  },
  {
    word: "hội tụ",
    part_of_speech: "động từ",
    meaning:
      "(tia sáng) gặp nhau ở cùng một điểm: kính hội tụ * chùm ánh sáng hội tụ ở tiêu điểm của gương lõm",
    example: "kính hội tụ * chùm ánh sáng hội tụ ở tiêu điểm của gương lõm",
  },
  {
    word: "hội tụ",
    part_of_speech: "động từ",
    meaning:
      "(văn chương) như tụ hội: hội tụ đủ các yếu tố * nhân tài khắp nơi hội tụ về đây",
    example: "hội tụ đủ các yếu tố * nhân tài khắp nơi hội tụ về đây",
  },
  {
    word: "hội ý",
    part_of_speech: "động từ",
    meaning:
      "trao đổi ý kiến một cách nhanh, gọn (thường là trong một nhóm người), để thống nhất hành động: xin được hội ý trước khi trả lời * cuộc hội ý chớp nhoáng",
    example: "xin được hội ý trước khi trả lời * cuộc hội ý chớp nhoáng",
  },
  {
    word: "hôligân",
    part_of_speech: "danh từ",
    meaning:
      "kẻ hay gây náo động và có hành vi bạo lực, côn đồ nơi công cộng, thường tụ họp thành nhóm: hooligan bóng đá",
    example: "hooligan bóng đá",
  },
  {
    word: "hôm",
    part_of_speech: "danh từ",
    meaning: "thời gian buổi tối: đêm hôm * ăn bữa hôm, lo bữa mai (tng)",
    example: "đêm hôm * ăn bữa hôm, lo bữa mai (tng)",
  },
  {
    word: "hôm",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian thuộc về một ngày: xin nghỉ một hôm * chỉ mấy hôm nữa là hoàn thành công việc",
    example: "xin nghỉ một hôm * chỉ mấy hôm nữa là hoàn thành công việc",
  },
  {
    word: "hôm kia",
    part_of_speech: "danh từ",
    meaning:
      "ngày liền trước ngày hôm qua, cách hôm nay một ngày: anh ấy đi từ hôm kia * mới bắt đầu làm từ hôm kia",
    example: "anh ấy đi từ hôm kia * mới bắt đầu làm từ hôm kia",
  },
  {
    word: "hổm",
    part_of_speech: "đại từ",
    meaning: "(Phương ngữ, Khẩu ngữ) hôm ấy: bữa hổm",
    example: "bữa hổm",
  },
  {
    word: "hôm sớm",
    part_of_speech: "danh từ",
    meaning:
      'buổi tối và buổi sáng, cả ngày lẫn đêm; chỉ sự thường xuyên, luôn luôn: tảo tần hôm sớm * "Không ai hôm sớm bạn cùng, Nương mai mai gãy, dựa tùng tùng xiêu." (ca dao)',
    example:
      'tảo tần hôm sớm * "Không ai hôm sớm bạn cùng, Nương mai mai gãy, dựa tùng tùng xiêu." (ca dao)',
  },
  {
    word: "hôm mai",
    part_of_speech: "danh từ",
    meaning:
      '(văn chương) như hôm sớm: "Học trò đèn sách hôm mai, Ngày sau thi đỗ nên trai mới hào." (ca dao)',
    example:
      'Học trò đèn sách hôm mai, Ngày sau thi đỗ nên trai mới hào." (ca dao)',
  },
  {
    word: "hổm rày",
    part_of_speech: "đại từ",
    meaning:
      '(phương ngữ) từ hôm ấy đến nay: "Sở dĩ mấy bữa nay tôi đi thay là vì hổm rày ba sắp nhỏ lo phát cỏ ruộng (...)" (AĐức; 14)',
    example:
      'Sở dĩ mấy bữa nay tôi đi thay là vì hổm rày ba sắp nhỏ lo phát cỏ ruộng (...)" (AĐức; 14)',
  },
  {
    word: "hôm nay",
    part_of_speech: "danh từ",
    meaning:
      "ngày hiện tại, khi đang nói: hôm nay là thứ sáu * việc hôm nay chớ để ngày mai",
    example: "hôm nay là thứ sáu * việc hôm nay chớ để ngày mai",
  },
  {
    word: "hôm qua",
    part_of_speech: "danh từ",
    meaning: "ngày liền trước ngày hôm nay: vừa nói hôm qua, hôm nay đã quên",
    example: "vừa nói hôm qua, hôm nay đã quên",
  },
  {
    word: "hôn",
    part_of_speech: "động từ",
    meaning:
      "(Nam thường nói hun) áp môi hoặc mũi vào để tỏ lòng yêu thương, quý mến: hôn lên trán con * hôn nhẹ vào má * nụ hôn",
    example: "hôn lên trán con * hôn nhẹ vào má * nụ hôn",
  },
  {
    word: "hôn",
    part_of_speech: "phụ từ",
    meaning: "(Nam, khẩu ngữ) không (dùng tạo câu hỏi): ở trỏng có gì mới hôn?",
    example: "ở trỏng có gì mới hôn?",
  },
  {
    word: "hỗn",
    part_of_speech: "tính từ",
    meaning:
      "không giữ đúng khuôn phép, không giữ lễ độ đối với người trên: nói hỗn * thằng bé hỗn lắm!",
    example: "nói hỗn * thằng bé hỗn lắm!",
  },
  {
    word: "hồn",
    part_of_speech: "danh từ",
    meaning:
      "thực thể tinh thần mà tôn giáo và triết học duy tâm cho là độc lập với thể xác, khi nhập vào thể xác thì tạo ra sự sống và tâm lí của con người: gọi hồn * ngẩn ngơ như người mất hồn * hiện hồn",
    example: "gọi hồn * ngẩn ngơ như người mất hồn * hiện hồn",
  },
  {
    word: "hồn",
    part_of_speech: "danh từ",
    meaning:
      "tư tưởng và tình cảm của con người, nói chung: bức tranh rất có hồn * bài viết không có hồn",
    example: "bức tranh rất có hồn * bài viết không có hồn",
  },
  {
    word: "hồn",
    part_of_speech: "danh từ",
    meaning:
      "tinh thần của con người, về mặt chịu một tác động mạnh từ bên ngoài: hoảng hồn * liệu hồn * mãi vẫn chưa lại hồn",
    example: "hoảng hồn * liệu hồn * mãi vẫn chưa lại hồn",
  },
  {
    word: "hỗn danh",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) tên đặt thêm, ghép liền với tên thật khi gọi để vui đùa, gắn với một đặc điểm riêng (thường là không hay) của người được đặt tên: vì Tú quá mập nên có hỗn danh là Tú Mập",
    example: "vì Tú quá mập nên có hỗn danh là Tú Mập",
  },
  {
    word: "hỗn độn",
    part_of_speech: "tính từ",
    meaning:
      "ở vào tình trạng có nhiều thành phần lẫn lộn vào nhau, đến mức không thể phân định được rõ ràng: đống sách vở hỗn độn * mớ âm thanh hỗn độn",
    example: "đống sách vở hỗn độn * mớ âm thanh hỗn độn",
  },
  {
    word: "hồn hậu",
    part_of_speech: "tính từ",
    meaning:
      "hiền từ, chất phác, biểu hiện bản chất tốt đẹp của người chỉ muốn có, muốn làm những điều tốt lành cho người khác: tính tình hồn hậu * nụ cười hồn hậu",
    example: "tính tình hồn hậu * nụ cười hồn hậu",
  },
  {
    word: "hỗn hào",
    part_of_speech: "tính từ",
    meaning: "hỗn (nói khái quát): ăn nói hỗn hào",
    example: "ăn nói hỗn hào",
  },
  {
    word: "hôn hít",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) hôn (nói khái quát): hôn hít vào mặt đứa trẻ",
    example: "hôn hít vào mặt đứa trẻ",
  },
  {
    word: "hổn hển",
    part_of_speech: "tính từ",
    meaning:
      "có nhịp thở dồn dập, ngắn hơi do tim đập mạnh và gấp: giọng hổn hển, gấp gáp * thở hổn hển",
    example: "giọng hổn hển, gấp gáp * thở hổn hển",
  },
  {
    word: "hôn mê",
    part_of_speech: "động từ",
    meaning:
      "ở trạng thái bất tỉnh, mất tri giác, cảm giác, giống như ngủ say, do bệnh nặng: bệnh nhân đang ở trong tình trạng hôn mê",
    example: "bệnh nhân đang ở trong tình trạng hôn mê",
  },
  {
    word: "hôn mê",
    part_of_speech: "động từ",
    meaning: "(hiếm) ở trạng thái mê muội, mất sáng suốt: đầu óc hôn mê",
    example: "đầu óc hôn mê",
  },
  {
    word: "hỗn hợp",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp gồm nhiều chất trộn lẫn với nhau mà mỗi chất giữ nguyên được tính chất vật lí, hoá học của mình: xác định thành phần của hỗn hợp",
    example: "xác định thành phần của hỗn hợp",
  },
  {
    word: "hỗn hợp",
    part_of_speech: "tính từ",
    meaning:
      "gồm có nhiều thành phần, trong đó mỗi thành phần vẫn giữ được tính chất riêng của mình: cám hỗn hợp",
    example: "cám hỗn hợp",
  },
  {
    word: "hỗn láo",
    part_of_speech: "",
    meaning:
      "hỗn và vô lễ, tỏ ra khinh thường người khác, không kể thứ bậc, tuổi tác: ăn nói hỗn láo * thằng bé hỗn láo quá!",
    example: "ăn nói hỗn láo * thằng bé hỗn láo quá!",
  },
  {
    word: "hồn nhiên",
    part_of_speech: "tính từ",
    meaning:
      "biểu hiện có bản tính gần với tự nhiên, có sự đơn giản, chân thật, trong trắng, nhiều khi ngây thơ trong tình cảm, trong sự suy nghĩ, trong tâm hồn: gương mặt hồn nhiên * cười rất hồn nhiên",
    example: "gương mặt hồn nhiên * cười rất hồn nhiên",
  },
  {
    word: "hỗn loạn",
    part_of_speech: "tính từ",
    meaning:
      "ở vào tình trạng hoàn toàn không có trật tự, không có tổ chức, không chịu một sự điều khiển chung nào cả: tình hình đang rất hỗn loạn",
    example: "tình hình đang rất hỗn loạn",
  },
  {
    word: "hỗn quân",
    part_of_speech: "danh từ",
    meaning:
      "binh lính ở tình trạng lộn xộn, hoảng loạn, không còn có sự chỉ huy, điều khiển nào nữa: đám hỗn quân đè lên nhau mà chạy",
    example: "đám hỗn quân đè lên nhau mà chạy",
  },
  {
    word: "hôn nhân",
    part_of_speech: "danh từ",
    meaning:
      "việc kết hôn giữa nam và nữ: tính chuyện hôn nhân * luật hôn nhân và gia đình",
    example: "tính chuyện hôn nhân * luật hôn nhân và gia đình",
  },
  {
    word: "hôn lễ",
    part_of_speech: "danh từ",
    meaning: "(trang trọng) lễ cưới: cử hành hôn lễ",
    example: "cử hành hôn lễ",
  },
  {
    word: "hôn quân",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) vua ngu muội, say đắm trong những thú vui tầm thường, không biết lo việc nước: hôn quân, bạo chúa",
    example: "hôn quân, bạo chúa",
  },
  {
    word: "hồn phách",
    part_of_speech: "danh từ",
    meaning:
      'như hồn vía: "Vân Tiên vừa ấm chân tay, Ngẩn ngơ hồn phách như say mới rồi." (LVT)',
    example:
      'Vân Tiên vừa ấm chân tay, Ngẩn ngơ hồn phách như say mới rồi." (LVT)',
  },
  {
    word: "hôn phối",
    part_of_speech: "động từ",
    meaning: "(cũ) lấy nhau thành vợ chồng: lễ hôn phối",
    example: "lễ hôn phối",
  },
  {
    word: "hôn phối",
    part_of_speech: "động từ",
    meaning: ". (hiếm) như giao phối: mùa hôn phối",
    example: "mùa hôn phối",
  },
  {
    word: "hỗn số",
    part_of_speech: "danh từ",
    meaning: "số hợp bởi một số nguyên và một phân số: O là một hỗn số",
    example: "O là một hỗn số",
  },
  {
    word: "hỗn tạp",
    part_of_speech: "tính từ",
    meaning:
      "không thuần nhất, gồm có nhiều thứ rất khác nhau lẫn lộn vào với nhau: đám đông hỗn tạp có đủ hạng người * cuộc sống ồn ào, hỗn tạp",
    example: "đám đông hỗn tạp có đủ hạng người * cuộc sống ồn ào, hỗn tạp",
  },
  {
    word: "hồn thơ",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương) nguồn cảm hứng, cảm xúc của nhà thơ: hồn thơ lai láng",
    example: "hồn thơ lai láng",
  },
  {
    word: "hồn vía",
    part_of_speech: "danh từ",
    meaning:
      "hồn và vía, coi như yếu tố sức sống tinh thần của con người: sợ hết hồn vía ~đang học mà hồn vía như để trên mây",
    example: "sợ hết hồn vía ~đang học mà hồn vía như để trên mây",
  },
  {
    word: "hôn thú",
    part_of_speech: "danh từ",
    meaning: "(cũ) giá thú: giấy hôn thú * lấy nhau có hôn thú",
    example: "giấy hôn thú * lấy nhau có hôn thú",
  },
  {
    word: "hỗn xược",
    part_of_speech: "",
    meaning:
      "hỗn đến mức tỏ ra xấc xược, vô lễ đối với người trên: thái độ hỗn xược * ăn nói hỗn xược",
    example: "thái độ hỗn xược * ăn nói hỗn xược",
  },
  {
    word: "hổng",
    part_of_speech: "tính từ",
    meaning:
      "ở vào tình trạng không được che kín, khiến cho lộ rõ những cái bên trong, đằng sau: mái nhà hổng một lỗ to * kiến thức bị hổng",
    example: "mái nhà hổng một lỗ to * kiến thức bị hổng",
  },
  {
    word: "hổng",
    part_of_speech: "tính từ",
    meaning: "(Ít dùng) như rỗng: đục hổng thân cây",
    example: "đục hổng thân cây",
  },
  {
    word: "hổng",
    part_of_speech: "phụ từ",
    meaning: "(Phương ngữ, Khẩu ngữ) không: hổng biết",
    example: "hổng biết",
  },
  {
    word: "hông",
    part_of_speech: "danh từ",
    meaning: "vùng hai bên của bụng dưới, ngang với xương chậu.",
    example: "hông nhà * nhà ở ngay bên hông chợ * đâm vào hông xe",
  },
  {
    word: "hông",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) chõ to: cái hông xôi",
    example: "cái hông xôi",
  },
  {
    word: "hông",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) đồ bằng nồi hông: hông xôi",
    example: "hông xôi",
  },
  {
    word: "hông",
    part_of_speech: "phụ từ",
    meaning:
      "(phương ngữ, khẩu ngữ) không: phải hông? * nghe hông? * chuyện có đúng như vậy hông?",
    example: "phải hông? * nghe hông? * chuyện có đúng như vậy hông?",
  },
  {
    word: "hồng",
    part_of_speech: "danh từ",
    meaning:
      "cây cảnh cỡ nhỏ, cùng họ với đào, mận, thân có gai, lá kép có răng, hoa có nhiều màu và gồm nhiều cánh, có hương thơm: bông hồng",
    example: "bông hồng",
  },
  {
    word: "hồng",
    part_of_speech: "tính từ",
    meaning:
      "(Văn chương) đỏ, có màu đỏ: ngọn cờ hồng * ánh lửa hồng * một trái tim hồng",
    example: "ngọn cờ hồng * ánh lửa hồng * một trái tim hồng",
  },
  {
    word: "hồng",
    part_of_speech: "tính từ",
    meaning:
      'có màu đỏ nhạt và tươi: hai má ửng hồng * "Thân em như chẹn lúa đòng đòng, Phất phơ dưới ngọn nắng hồng buổi mai." (Cdao)',
    example:
      'hai má ửng hồng * "Thân em như chẹn lúa đòng đòng, Phất phơ dưới ngọn nắng hồng buổi mai." (Cdao)',
  },
  {
    word: "hồng điều",
    part_of_speech: "tính từ",
    meaning: "(giấy, lụa) có màu đỏ tươi: viết câu đối trên giấy hồng điều",
    example: "viết câu đối trên giấy hồng điều",
  },
  {
    word: "hồng đào",
    part_of_speech: "tính từ",
    meaning: "có màu đỏ hồng như màu da của quả đào chín: rượu hồng đào",
    example: "rượu hồng đào",
  },
  {
    word: "hồng đơn",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như hồng điều: gói bằng giấy hồng đơn",
    example: "gói bằng giấy hồng đơn",
  },
  {
    word: "hống hách",
    part_of_speech: "",
    meaning:
      "ra oai để tỏ rõ quyền hành của mình, muốn cho người khác phải sợ: lên mặt hống hách * thái độ hống hách",
    example: "lên mặt hống hách * thái độ hống hách",
  },
  {
    word: "hồng hộc",
    part_of_speech: "phụ từ",
    meaning:
      "(thở) mạnh và dồn dập từng hồi, qua đằng miệng, do phải dùng sức quá nhiều và lâu: chạy được một đoạn đã thở hồng hộc",
    example: "chạy được một đoạn đã thở hồng hộc",
  },
  {
    word: "hồng lâu",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) lầu hồng: "Hồng lâu còn khoá then sương, Thâm khuê còn rấm mùi hương khuynh thành." (CO)',
    example:
      'Hồng lâu còn khoá then sương, Thâm khuê còn rấm mùi hương khuynh thành." (CO)',
  },
  {
    word: "hồng lâu",
    part_of_speech: "danh từ",
    meaning: "nơi ở của ả đào, ca kĩ thời phong kiến: xóm hồng lâu",
    example: "xóm hồng lâu",
  },
  {
    word: "hồng hào",
    part_of_speech: "tính từ",
    meaning:
      "(nước da) có màu đỏ hồng, đẹp, thể hiện trạng thái sức khoẻ tốt: da dẻ hồng hào * gương mặt hồng hào",
    example: "da dẻ hồng hào * gương mặt hồng hào",
  },
  {
    word: "hồng hoang",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về một thời xa xưa, khi trời đất còn hỗn mang, hoang sơ: thuở hồng hoang",
    example: "thuở hồng hoang",
  },
  {
    word: "hồng nhan",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) gương mặt có đôi má hồng; dùng để chỉ người con gái đẹp: phận hồng nhan * "Kiếp hồng nhan có mong manh, Nửa chừng xuân, thoắt gãy cành thiên hương!" (TKiều)',
    example:
      'phận hồng nhan * "Kiếp hồng nhan có mong manh, Nửa chừng xuân, thoắt gãy cành thiên hương!" (TKiều)',
  },
  {
    word: "hồng mao",
    part_of_speech: "danh từ",
    meaning: "chỏm tóc để ở giữa đầu của trẻ em trai thời xưa: tóc để hồng mao",
    example: "tóc để hồng mao",
  },
  {
    word: "hồng ngọc",
    part_of_speech: "danh từ",
    meaning:
      "đá quý màu hồng, trong suốt, thường dùng làm đồ trang sức, làm chân kính đồng hồ: đá hồng ngọc * mặt dây chuyền làm bằng hồng ngọc",
    example: "đá hồng ngọc * mặt dây chuyền làm bằng hồng ngọc",
  },
  {
    word: "hồng ngoại",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về bức xạ không trông thấy được, thường phát ra rất nhiều từ các vật nóng trước khi phát ra ánh sáng đỏ: tia hồng ngoại",
    example: "tia hồng ngoại",
  },
  {
    word: "hồng quân",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) trời, tạo hoá: "Hồng quân với khách hồng quần, Đã xoay đến thế còn vần chưa tha." (TKiều)',
    example:
      'Hồng quân với khách hồng quần, Đã xoay đến thế còn vần chưa tha." (TKiều)',
  },
  {
    word: "hồng quân",
    part_of_speech: "danh từ",
    meaning:
      "quân đội cách mạng (vô sản) ở một số nước xã hội chủ nghĩa: hồng quân Liên Xô",
    example: "hồng quân Liên Xô",
  },
  {
    word: "hồng phúc",
    part_of_speech: "danh từ",
    meaning: "(cũ, hiếm) phúc lớn: nhờ hồng phúc tổ tiên",
    example: "nhờ hồng phúc tổ tiên",
  },
  {
    word: "hồng quần",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) váy đỏ; dùng để chỉ người con gái trẻ đẹp thời phong kiến: "Phong lưu rất mực hồng quần, Xuân xanh xấp xỉ tới tuần cập kê." (TKiều)',
    example:
      'Phong lưu rất mực hồng quần, Xuân xanh xấp xỉ tới tuần cập kê." (TKiều)',
  },
  {
    word: "hồng thuỷ",
    part_of_speech: "danh từ",
    meaning: "(cũ) lụt lớn: trận hồng thuỷ",
    example: "trận hồng thuỷ",
  },
  {
    word: "hồng tâm",
    part_of_speech: "danh từ",
    meaning: "điểm tròn ở giữa bia để làm đích tập bắn: bắn trúng hồng tâm",
    example: "bắn trúng hồng tâm",
  },
  {
    word: "hồng thập tự",
    part_of_speech: "danh từ",
    meaning: "(cũ) chữ thập đỏ: xe hồng thập tự (xe cứu thương)",
    example: "xe hồng thập tự (xe cứu thương)",
  },
  {
    word: "hồng trần",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) bụi hồng: "Đùng đùng gió giật mây vần, Một xe trong cõi hồng trần như bay." (TKiều)',
    example:
      'Đùng đùng gió giật mây vần, Một xe trong cõi hồng trần như bay." (TKiều)',
  },
  {
    word: "hộp",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng có hình khối, kích thước nhỏ, làm bằng giấy, gỗ, nhựa hay kim loại, dùng để chứa đựng: hộp chè * chiếc hộp giấy * thực phẩm đóng hộp",
    example: "hộp chè * chiếc hộp giấy * thực phẩm đóng hộp",
  },
  {
    word: "hộp đen",
    part_of_speech: "danh từ",
    meaning:
      "thiết bị điện tử đặt trên tàu, máy bay, tự động ghi và lưu trữ các thông tin về tàu, máy bay trong chuyến đi, đặc biệt được dùng để tìm hiểu nguyên nhân khi tai nạn xảy ra: chưa tìm được hộp đen của chiếc máy bay rơi",
    example: "chưa tìm được hộp đen của chiếc máy bay rơi",
  },
  {
    word: "hộp thư",
    part_of_speech: "danh từ",
    meaning: "(ng1).",
    example: "hộp thư truyền hình * hộp thư ý kiến bạn đọc",
  },
  {
    word: "hột",
    part_of_speech: "danh từ",
    meaning: "(Nam) hạt: hột xoàn * mưa nặng hột * muối hột * hột xoài",
    example: "hột xoàn * mưa nặng hột * muối hột * hột xoài",
  },
  {
    word: "hột",
    part_of_speech: "danh từ",
    meaning: "trứng (gà, vịt): hột gà * hột vịt lộn",
    example: "hột gà * hột vịt lộn",
  },
  {
    word: "hốt",
    part_of_speech: "động từ",
    meaning: "như hót: hốt rác",
    example: "hốt rác",
  },
  {
    word: "hốt",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) thu về cho mình nhiều, nhanh mà tốn ít công sức: hốt của * nghề ấy hốt bạc",
    example: "hốt của * nghề ấy hốt bạc",
  },
  {
    word: "hốt",
    part_of_speech: "động từ",
    meaning: "(Thông tục) bắt gọn, tóm gọn: hốt trọn cả một sòng bạc",
    example: "hốt trọn cả một sòng bạc",
  },
  {
    word: "hốt",
    part_of_speech: "động từ",
    meaning: "(Phương ngữ) bốc (thuốc): hốt thuốc",
    example: "hốt thuốc",
  },
  {
    word: "hốt",
    part_of_speech: "động từ",
    meaning: "(Phương ngữ) hoảng: chưa chi đã hốt lên",
    example: "chưa chi đã hốt lên",
  },
  {
    word: "hốt hoảng",
    part_of_speech: "",
    meaning: "như hoảng hốt: hốt hoảng bỏ chạy",
    example: "hốt hoảng bỏ chạy",
  },
  {
    word: "hốt nhiên",
    part_of_speech: "phụ từ",
    meaning: "(phương ngữ) bỗng nhiên: đang nói hốt nhiên nín bặt",
    example: "đang nói hốt nhiên nín bặt",
  },
  {
    word: "hơ",
    part_of_speech: "động từ",
    meaning:
      "đưa vào gần lửa, gần nơi toả nhiệt cho khô, cho nóng lên: hơ tay trên bếp lửa cho đỡ cóng * hơ quần áo",
    example: "hơ tay trên bếp lửa cho đỡ cóng * hơ quần áo",
  },
  {
    word: "hớ",
    part_of_speech: "tính từ",
    meaning:
      "sơ suất để lộ chỗ yếu của mình (thường là trong nói năng): nói hớ một câu * trả lời hớ",
    example: "nói hớ một câu * trả lời hớ",
  },
  {
    word: "hớ",
    part_of_speech: "tính từ",
    meaning:
      "sơ suất trong mua bán, kinh doanh, khiến mình bị thua thiệt: bán xong rồi mới biết là hớ * bị mua hớ",
    example: "bán xong rồi mới biết là hớ * bị mua hớ",
  },
  {
    word: "hở hang",
    part_of_speech: "tính từ",
    meaning:
      "hở, không được kín, thường trong cách ăn mặc (nói khái quát; hàm ý chê): ăn mặc rất hở hang",
    example: "ăn mặc rất hở hang",
  },
  {
    word: "hớ hênh",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra không cẩn thận, không giữ gìn: ăn mặc hớ hênh * ngồi hớ hênh * câu nói hớ hênh",
    example: "ăn mặc hớ hênh * ngồi hớ hênh * câu nói hớ hênh",
  },
  {
    word: "hở",
    part_of_speech: "tính từ",
    meaning:
      "để lộ ra cho bên ngoài có thể thấy được: áo hở vai * nói nửa kín nửa hở * trùm chăn kín mít, không hở chỗ nào",
    example:
      "áo hở vai * nói nửa kín nửa hở * trùm chăn kín mít, không hở chỗ nào",
  },
  {
    word: "hở",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) không giữ kín, mà để lộ cho người ta biết: không hở chuyện ấy ra với ai",
    example: "không hở chuyện ấy ra với ai",
  },
  {
    word: "hở",
    part_of_speech: "trợ từ",
    meaning:
      "(Khẩu ngữ) như hả (ng2, nhưng nghĩa thân mật hơn): không đi hở? * có chuyện gì thế hở con? * sao lại đến nông nỗi này, hở giời?",
    example:
      "không đi hở? * có chuyện gì thế hở con? * sao lại đến nông nỗi này, hở giời?",
  },
  {
    word: "hơ hải",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả dáng vẻ vội vàng, hoảng sợ lộ rõ ở nét mặt, bộ dạng: mặt mày hớt hải * hớt hải chạy về",
    example: "mặt mày hớt hải * hớt hải chạy về",
  },
  {
    word: "hờ",
    part_of_speech: "động từ",
    meaning:
      "khóc và kể lể bằng giọng thảm thiết (thường là khóc người chết): hờ chồng",
    example: "hờ chồng",
  },
  {
    word: "hờ",
    part_of_speech: "tính từ",
    meaning:
      "(làm việc gì) chỉ vừa đến mức để có được cái vẻ như đã làm, chứ không làm hẳn hoi, thật sự: cửa khép hờ * buộc hờ sợi dây * mắt nhắm hờ",
    example: "cửa khép hờ * buộc hờ sợi dây * mắt nhắm hờ",
  },
  {
    word: "hờ",
    part_of_speech: "tính từ",
    meaning:
      "chỉ có cái vẻ bên ngoài hoặc trên danh nghĩa, chứ thật sự không phải: vợ chồng hờ * đứa con hờ",
    example: "vợ chồng hờ * đứa con hờ",
  },
  {
    word: "hơ hớ",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) đang rất trẻ, đầy sức sống, sức hấp dẫn: con gái hơ hớ",
    example: "con gái hơ hớ",
  },
  {
    word: "hơ hớ",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng cười thoải mái, vui vẻ không cần che đậy, giữ gìn: cười hơ hớ",
    example: "cười hơ hớ",
  },
  {
    word: "hơ hỏng",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) sơ ý, không cẩn thận: chỉ hơ hỏng một chút là hỏng việc",
    example: "chỉ hơ hỏng một chút là hỏng việc",
  },
  {
    word: "hởi dạ",
    part_of_speech: "",
    meaning: "cảm thấy vui vì được như ý, thoả mãn: được khen, ai cũng hởi dạ",
    example: "được khen, ai cũng hởi dạ",
  },
  {
    word: "hờ hững",
    part_of_speech: "tính từ",
    meaning:
      "(làm việc gì) chỉ là làm hờ, làm lấy có, không có sự chú ý: trả lời hờ hững * cầm tờ báo hờ hững trên tay",
    example: "trả lời hờ hững * cầm tờ báo hờ hững trên tay",
  },
  {
    word: "hờ hững",
    part_of_speech: "tính từ",
    meaning:
      'thờ ơ, lạnh nhạt trong quan hệ tình cảm, không chút để ý đến: hờ hững với bạn bè * "Trách lòng hờ hững với lòng, Lửa hương chốc để lạnh lùng bấy lâu!" (TKiều)',
    example:
      'hờ hững với bạn bè * "Trách lòng hờ hững với lòng, Lửa hương chốc để lạnh lùng bấy lâu!" (TKiều)',
  },
  {
    word: "hơi đâu mà",
    part_of_speech: "",
    meaning:
      '(khẩu ngữ) tổ hợp biểu thị điều sắp nêu ra là việc làm chỉ phí công vô ích (hàm ý không nên làm): "Cơm ăn mỗi bữa một lưng, Hơi đâu mà giận người dưng thêm phiền." (ca dao)',
    example:
      'Cơm ăn mỗi bữa một lưng, Hơi đâu mà giận người dưng thêm phiền." (ca dao)',
  },
  {
    word: "hơi",
    part_of_speech: "danh từ",
    meaning:
      "chất ở trạng thái khí và ở nhiệt độ thấp hơn nhiệt độ tới hạn: nước bốc hơi * hơi nước * hơi sương",
    example: "nước bốc hơi * hơi nước * hơi sương",
  },
  {
    word: "hơi",
    part_of_speech: "danh từ",
    meaning: "chất khí nói chung: hơi gas * bụng đầy hơi * xe hết hơi",
    example: "hơi gas * bụng đầy hơi * xe hết hơi",
  },
  {
    word: "hơi",
    part_of_speech: "danh từ",
    meaning: "làn gió thổi rất nhẹ: hơi may hiu hắt",
    example: "hơi may hiu hắt",
  },
  {
    word: "hơi",
    part_of_speech: "danh từ",
    meaning:
      "lượng không khí hít vào, thở ra trong một nhịp thở; thường được coi là biểu tượng của khả năng, sức lực cụ thể của con người: hít một hơi thật dài * khóc hết hơi * chiến đấu đến hơi thở cuối cùng",
    example:
      "hít một hơi thật dài * khóc hết hơi * chiến đấu đến hơi thở cuối cùng",
  },
  {
    word: "hơi",
    part_of_speech: "danh từ",
    meaning:
      "quá trình liên tục làm một việc gì từ đầu đến cuối, không nghỉ gián đoạn: chạy thẳng một hơi * công việc dài hơi",
    example: "chạy thẳng một hơi * công việc dài hơi",
  },
  {
    word: "hơi",
    part_of_speech: "danh từ",
    meaning:
      "mùi đặc trưng của một vật, một người: chè đã hả hơi * bé bện hơi mẹ * quen hơi bén tiếng",
    example: "chè đã hả hơi * bé bện hơi mẹ * quen hơi bén tiếng",
  },
  {
    word: "hơi",
    part_of_speech: "danh từ",
    meaning:
      "khối lượng gia súc khi còn sống (phân biệt với khối lượng gia súc khi đã giết thịt, không kể lông và lòng): cân hơi",
    example: "cân hơi",
  },
  {
    word: "hơi",
    part_of_speech: "phụ từ",
    meaning:
      "chỉ có một chút, một phần nào thôi: tai hơi nghễnh ngãng * nhà hơi xa trường học * hơi hơi đói",
    example: "tai hơi nghễnh ngãng * nhà hơi xa trường học * hơi hơi đói",
  },
  {
    word: "hỡi",
    part_of_speech: "cảm từ",
    meaning:
      '(văn chương) từ biểu thị ý gọi người ngang hàng trở xuống một cách thân mật hoặc kêu gọi số đông một cách trang trọng: hỡi đồng bào! * "Hỡi cô tát nước bên đàng, Sao cô múc ánh trăng vàng đổ đi?" (ca dao)',
    example:
      'hỡi đồng bào! * "Hỡi cô tát nước bên đàng, Sao cô múc ánh trăng vàng đổ đi?" (ca dao)',
  },
  {
    word: "hỡi",
    part_of_speech: "cảm từ",
    meaning:
      'từ dùng để biểu thị ý than thở: trời đất hỡi! * "Sốt gan riêng giận trời già, Lòng này ai tỏ cho ta hỡi lòng!" (TKiều)',
    example:
      'trời đất hỡi! * "Sốt gan riêng giận trời già, Lòng này ai tỏ cho ta hỡi lòng!" (TKiều)',
  },
  {
    word: "hợi",
    part_of_speech: "danh từ",
    meaning:
      "(thường viết hoa) kí hiệu cuối cùng trong địa chi (lấy lợn làm tượng trưng; sau tuất), dùng trong phép đếm thời gian cổ truyền của Trung Quốc và một số nước châu á, trong đó có Việt Nam: giờ Hợi (từ 9 giờ tối đến 11 giờ đêm) * tuổi Hợi (sinh vào một năm Hợi)",
    example:
      "giờ Hợi (từ 9 giờ tối đến 11 giờ đêm) * tuổi Hợi (sinh vào một năm Hợi)",
  },
  {
    word: "hợi",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) ghét đóng thành vảy ở ngoài da: chân cẳng đóng hờm",
    example: "chân cẳng đóng hờm",
  },
  {
    word: "hợi",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) chực sẵn để có thể hành động ngay: hờm sẵn ở cổng",
    example: "hờm sẵn ở cổng",
  },
  {
    word: "hợi",
    part_of_speech: "động từ",
    meaning:
      "lên mặt với người khác vì tự cho là mình hơn hẳn, thường là về tiền của (hàm ý chê, mỉa mai): chưa giàu đã hợm * lên mặt hợm đời",
    example: "chưa giàu đã hợm * lên mặt hợm đời",
  },
  {
    word: "hời hợt",
    part_of_speech: "tính từ",
    meaning:
      "chỉ lướt qua ở bên ngoài, không đi sâu: nhận thức vấn đề rất hời hợt * suy nghĩ hời hợt",
    example: "nhận thức vấn đề rất hời hợt * suy nghĩ hời hợt",
  },
  {
    word: "hời hợt",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra hờ hững, không mặn mà, sâu sắc: tình cảm hời hợt * cái bắt tay hời hợt",
    example: "tình cảm hời hợt * cái bắt tay hời hợt",
  },
  {
    word: "hời",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có lợi nhiều về mặt giá cả, trong việc mua bán: vớ được món hời * trả giá rất hời",
    example: "vớ được món hời * trả giá rất hời",
  },
  {
    word: "hơi hướng",
    part_of_speech: "danh từ",
    meaning:
      "hơi, mùi đặc trưng (nói khái quát; thường nói về cái hơi thoảng qua, còn giữ lại được ở những người, vật quen thuộc): vẫn còn hơi hướng của người đã khuất",
    example: "vẫn còn hơi hướng của người đã khuất",
  },
  {
    word: "hơi hướng",
    part_of_speech: "danh từ",
    meaning: "cái vẻ phảng phất: câu chuyện có hơi hướng thần thoại",
    example: "câu chuyện có hơi hướng thần thoại",
  },
  {
    word: "hơi ngạt",
    part_of_speech: "danh từ",
    meaning: "hơi độc gây ngạt thở: hít phải hơi ngạt",
    example: "hít phải hơi ngạt",
  },
  {
    word: "hỡi ôi",
    part_of_speech: "cảm từ",
    meaning:
      "(văn chương) tiếng than, biểu lộ ý thương xót: hỡi ôi, cũng một kiếp người!",
    example: "hỡi ôi, cũng một kiếp người!",
  },
  {
    word: "hợm hĩnh",
    part_of_speech: "động từ",
    meaning: "hợm (nói khái quát): nói với giọng hợm hĩnh",
    example: "nói với giọng hợm hĩnh",
  },
  {
    word: "hỡi ơi",
    part_of_speech: "cảm từ",
    meaning:
      '(văn chương) như hỡi ôi: "Hỡi ơi! Bướm trắng tơ vàng, Mau về mà chịu tang nàng đi thôi." (NgBính; 12)',
    example:
      'Hỡi ơi! Bướm trắng tơ vàng, Mau về mà chịu tang nàng đi thôi." (NgBính; 12)',
  },
  {
    word: "hờn",
    part_of_speech: "động từ",
    meaning:
      "có điều không bằng lòng với người có quan hệ thân thiết, nhưng không nói ra mà tỏ bằng thái độ, hành động cốt cho người ấy biết (thường nói về trẻ em hoặc phụ nữ): bé hờn không ăn cơm * tủi phận hờn duyên",
    example: "bé hờn không ăn cơm * tủi phận hờn duyên",
  },
  {
    word: "hờn",
    part_of_speech: "danh từ",
    meaning: "nỗi uất ức, căm hận sâu sắc: rửa hờn * ngậm tủi nuốt hờn",
    example: "rửa hờn * ngậm tủi nuốt hờn",
  },
  {
    word: "hơi sức",
    part_of_speech: "danh từ",
    meaning:
      "sức lực trong con người (nói khái quát): già rồi, hơi sức không bằng trai tráng * hơi sức đâu mà giải thích với nó",
    example:
      "già rồi, hơi sức không bằng trai tráng * hơi sức đâu mà giải thích với nó",
  },
  {
    word: "hợm mình",
    part_of_speech: "động từ",
    meaning:
      "lên mặt, tự cho là mình hơn hẳn những người khác: đừng có hợm mình!",
    example: "đừng có hợm mình!",
  },
  {
    word: "hơn",
    part_of_speech: "tính từ",
    meaning:
      "ở mức cao trên cái so sánh: bức tranh này đẹp hơn * dạo này trông khoẻ hơn * tôi hơn nó hai tuổi",
    example:
      "bức tranh này đẹp hơn * dạo này trông khoẻ hơn * tôi hơn nó hai tuổi",
  },
  {
    word: "hơn",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều điều lợi so với trường hợp khác: giành lấy phần hơn về mình",
    example: "giành lấy phần hơn về mình",
  },
  {
    word: "hơn",
    part_of_speech: "tính từ",
    meaning:
      "(thóc gạo) rẻ, giá hạ so với bình thường: ngày dưng thóc kém, ngày mùa thóc hơn",
    example: "ngày dưng thóc kém, ngày mùa thóc hơn",
  },
  {
    word: "hơn",
    part_of_speech: "tính từ",
    meaning:
      "ở mức vượt quá số lượng hoặc thời gian nói đến, nhưng không nhiều: đã ba giờ hơn * hơn một tháng rồi * hơn mười người",
    example: "đã ba giờ hơn * hơn một tháng rồi * hơn mười người",
  },
  {
    word: "hờn dỗi",
    part_of_speech: "động từ",
    meaning:
      "có điều không bằng lòng và biểu lộ ra bằng thái độ làm như không cần đến nữa, không thiết nữa: tính hay hờn dỗi",
    example: "tính hay hờn dỗi",
  },
  {
    word: "hớn hở",
    part_of_speech: "tính từ",
    meaning:
      "(nét mặt) tươi tỉnh, lộ rõ vẻ vui mừng: tươi cười hớn hở * nét mặt hớn hở",
    example: "tươi cười hớn hở * nét mặt hớn hở",
  },
  {
    word: "hơn bù kém",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) lấy con số trung bình, tính bình quân: hơn bù kém, mỗi ngày hắn kiếm được dăm chục",
    example: "hơn bù kém, mỗi ngày hắn kiếm được dăm chục",
  },
  {
    word: "hờn giận",
    part_of_speech: "động từ",
    meaning:
      "giận không nói ra, nhưng vẫn tỏ bằng thái độ cho người khác biết: vẻ mặt hờn giận",
    example: "vẻ mặt hờn giận",
  },
  {
    word: "hơn hớn",
    part_of_speech: "tính từ",
    meaning:
      "có sắc thái rất tươi, biểu hiện tràn đầy sức sống: lúa con gái hơn hớn xanh tươi * tuổi xuân hơn hớn",
    example: "lúa con gái hơn hớn xanh tươi * tuổi xuân hơn hớn",
  },
  {
    word: "hờn mát",
    part_of_speech: "động từ",
    meaning:
      "tỏ thái độ hờn, giận một cách nhẹ nhàng, đủ để người ta biết: tính hay hờn mát",
    example: "tính hay hờn mát",
  },
  {
    word: "hơn thiệt",
    part_of_speech: "tính từ",
    meaning: "như thiệt hơn: suy bì hơn thiệt * phân điều hơn thiệt",
    example: "suy bì hơn thiệt * phân điều hơn thiệt",
  },
  {
    word: "hơn nữa",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nói là thêm một điều quan trọng bổ sung cho điều vừa nói đến, thường để giải thích, thanh minh hoặc phản bác một điều khác: đường thì xa, hơn nữa trời lại mưa nên đành nghỉ lại",
    example: "đường thì xa, hơn nữa trời lại mưa nên đành nghỉ lại",
  },
  {
    word: "hờn trách",
    part_of_speech: "động từ",
    meaning:
      "hờn giận và tỏ ý trách cứ: hờn trách người yêu * nói bằng giọng hờn trách",
    example: "hờn trách người yêu * nói bằng giọng hờn trách",
  },
  {
    word: "hờn tủi",
    part_of_speech: "động từ",
    meaning: "như tủi hờn: giọt nước mắt hờn tủi",
    example: "giọt nước mắt hờn tủi",
  },
  {
    word: "hớp",
    part_of_speech: "động từ",
    meaning:
      "mở miệng để đưa vào một ít chất nước rồi ngậm ngay lại: hớp một ngụm rượu * hớp một hớp nước",
    example: "hớp một ngụm rượu * hớp một hớp nước",
  },
  {
    word: "hớp",
    part_of_speech: "danh từ",
    meaning:
      "lượng chất nước có thể đưa vào miệng mỗi lần hớp: uống từng hớp rượu nhỏ",
    example: "uống từng hớp rượu nhỏ",
  },
  {
    word: "hợp cẩn",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) lễ hai vợ chồng uống chung một chén rượu trong đêm tân hôn, theo phong tục thời trước: lễ hợp cẩn",
    example: "lễ hợp cẩn",
  },
  {
    word: "hờn oán",
    part_of_speech: "động từ",
    meaning: "hờn giận và oán trách: hờn oán con người phụ bạc",
    example: "hờn oán con người phụ bạc",
  },
  {
    word: "hợp doanh",
    part_of_speech: "động từ",
    meaning: "chung vốn cùng kinh doanh với nhau: công ti hợp doanh",
    example: "công ti hợp doanh",
  },
  {
    word: "hợp",
    part_of_speech: "động từ",
    meaning:
      "gộp chung lại thành một cái lớn hơn: hợp nhau lại thành một khối * cả ba con sông đều hợp về đây",
    example: "hợp nhau lại thành một khối * cả ba con sông đều hợp về đây",
  },
  {
    word: "hợp",
    part_of_speech: "tính từ",
    meaning:
      "đúng với những yêu cầu, đòi hỏi của ai, của cái gì đó: món ăn không hợp khẩu vị * xin được việc làm hợp với chuyên môn",
    example: "món ăn không hợp khẩu vị * xin được việc làm hợp với chuyên môn",
  },
  {
    word: "hợp",
    part_of_speech: "tính từ",
    meaning:
      "có những tính chất, những yêu cầu căn bản giống nhau, đi đôi được với nhau, không có yếu tố mâu thuẫn: hai người ấy có vẻ hợp tính nhau * chọn màu áo hợp với nước da",
    example: "hai người ấy có vẻ hợp tính nhau * chọn màu áo hợp với nước da",
  },
  {
    word: "hợp khẩu",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) hợp với khẩu vị: ăn đồ Tây không hợp khẩu",
    example: "ăn đồ Tây không hợp khẩu",
  },
  {
    word: "hợp đồng",
    part_of_speech: "danh từ",
    meaning:
      "sự thoả thuận, giao ước giữa hai hay nhiều bên quy định các quyền lợi, nghĩa vụ của các bên tham gia, thường được viết thành văn bản: hợp đồng lao động * hợp đồng thuê nhà * Các bên tiến hành kí hợp đồng. đồng giao kèo",
    example:
      "hợp đồng lao động * hợp đồng thuê nhà * Các bên tiến hành kí hợp đồng.",
  },
  {
    word: "hợp đồng",
    part_of_speech: "động từ",
    meaning: "hiệp đồng: hợp đồng tác chiến",
    example: "hợp đồng tác chiến",
  },
  {
    word: "hợp kim",
    part_of_speech: "danh từ",
    meaning:
      "chất mang tính chất kim loại có ít nhất từ hai nguyên tố trở lên, trong đó nguyên tố chủ yếu là kim loại: gang là một hợp kim của sắt với carbon * hợp kim nhôm",
    example: "gang là một hợp kim của sắt với carbon * hợp kim nhôm",
  },
  {
    word: "hợp lí",
    part_of_speech: "tính từ",
    meaning:
      "đúng lẽ phải, phù hợp với logic: giải quyết vấn đề hợp tình, hợp lí * nói nghe cũng có vẻ hợp lí * bố trí công tác không hợp lí",
    example:
      "giải quyết vấn đề hợp tình, hợp lí * nói nghe cũng có vẻ hợp lí * bố trí công tác không hợp lí",
  },
  {
    word: "hớp hồn",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) làm cho bị choáng ngợp và say mê vì vẻ đẹp hoặc sự hấp dẫn: bị hớp hồn trước vẻ đẹp lộng lẫy, kiêu sa",
    example: "bị hớp hồn trước vẻ đẹp lộng lẫy, kiêu sa",
  },
  {
    word: "hợp hiến",
    part_of_speech: "tính từ",
    meaning: "đúng với những quy định của hiến pháp: chính phủ hợp hiến",
    example: "chính phủ hợp hiến",
  },
  {
    word: "hợp lệ",
    part_of_speech: "tính từ",
    meaning:
      "đúng theo thể thức quy định: không đủ chứng từ hợp lệ * giấy tờ không hợp lệ",
    example: "không đủ chứng từ hợp lệ * giấy tờ không hợp lệ",
  },
  {
    word: "hợp lí hoá",
    part_of_speech: "động từ",
    meaning: "làm cho trở nên hợp lí: hợp lí hoá sản xuất",
    example: "hợp lí hoá sản xuất",
  },
  {
    word: "hợp lực",
    part_of_speech: "động từ",
    meaning:
      "chung sức nhau lại để cùng làm việc gì: hai nước hợp lực chống kẻ thù chung",
    example: "hai nước hợp lực chống kẻ thù chung",
  },
  {
    word: "hợp lưu",
    part_of_speech: "động từ",
    meaning:
      "(sông, suối) nhập vào nhau làm thành một dòng: sông Đà hợp lưu với sông Hồng * chỗ hợp lưu của hai con sông",
    example: "sông Đà hợp lưu với sông Hồng * chỗ hợp lưu của hai con sông",
  },
  {
    word: "hợp lý",
    part_of_speech: "tính từ",
    meaning:
      "đúng lẽ phải, phù hợp với logic: giải quyết vấn đề hợp tình, hợp lí * nói nghe cũng có vẻ hợp lí * bố trí công tác không hợp lí",
    example:
      "giải quyết vấn đề hợp tình, hợp lí * nói nghe cũng có vẻ hợp lí * bố trí công tác không hợp lí",
  },
  {
    word: "hợp pháp",
    part_of_speech: "tính từ",
    meaning: "đúng theo pháp luật: quyền lợi hợp pháp * thu nhập bất hợp pháp",
    example: "quyền lợi hợp pháp * thu nhập bất hợp pháp",
  },
  {
    word: "hợp lý hoá",
    part_of_speech: "động từ",
    meaning: "làm cho trở nên hợp lí: hợp lí hoá sản xuất",
    example: "hợp lí hoá sản xuất",
  },
  {
    word: "hợp pháp hoá",
    part_of_speech: "động từ",
    meaning: "làm cho trở nên hợp pháp: hợp pháp hoá giấy tờ",
    example: "hợp pháp hoá giấy tờ",
  },
  {
    word: "hợp số",
    part_of_speech: "danh từ",
    meaning:
      "số tự nhiên có ít nhất một ước số khác 1 và chính nó; phân biệt với số nguyên tố: 36 là hợp số (các ước số của nó là 1; 2; 3; 4; 6; 9; 12; 18; 36)",
    example: "36 là hợp số (các ước số của nó là 1; 2; 3; 4; 6; 9; 12; 18; 36)",
  },
  {
    word: "hợp tác",
    part_of_speech: "động từ",
    meaning:
      "cùng chung sức giúp đỡ lẫn nhau trong một công việc, một lĩnh vực nào đó, nhằm một mục đích chung: hợp tác về kinh tế * hợp tác lao động",
    example: "hợp tác về kinh tế * hợp tác lao động",
  },
  {
    word: "hợp tác",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) hợp tác xã (nói tắt): vào hợp tác * tham gia hợp tác * xã viên trong hợp tác",
    example: "vào hợp tác * tham gia hợp tác * xã viên trong hợp tác",
  },
  {
    word: "hợp tác hoá",
    part_of_speech: "động từ",
    meaning:
      "làm cho sản xuất từ cá thể trở thành tập thể, bằng cách vận động, tổ chức cho những người lao động cá thể tham gia các hợp tác xã: hợp tác hoá nông nghiệp",
    example: "hợp tác hoá nông nghiệp",
  },
  {
    word: "hợp nhất",
    part_of_speech: "động từ",
    meaning:
      "hợp lại, gộp lại thành một tổ chức duy nhất: hợp nhất hai công ti thành một tập đoàn lớn",
    example: "hợp nhất hai công ti thành một tập đoàn lớn",
  },
  {
    word: "hợp tan",
    part_of_speech: "động từ",
    meaning:
      '(văn chương) gặp nhau và xa nhau; chỉ cảnh trắc trở, khó khăn: "Hoa trôi nước chảy xuôi dòng, Xót thân chìm nổi, đau lòng hợp tan!" (TKiều)',
    example:
      'Hoa trôi nước chảy xuôi dòng, Xót thân chìm nổi, đau lòng hợp tan!" (TKiều)',
  },
  {
    word: "hợp tác xã",
    part_of_speech: "danh từ",
    meaning:
      "cơ sở sản xuất, kinh doanh thuộc chế độ sở hữu tập thể, do các thành viên tổ chức và trực tiếp quản lí: hợp tác xã mua bán * hợp tác xã cơ khí",
    example: "hợp tác xã mua bán * hợp tác xã cơ khí",
  },
  {
    word: "hợp thời",
    part_of_speech: "tính từ",
    meaning:
      "đúng lúc, phù hợp với yêu cầu khách quan vào một thời điểm nhất định: một chủ trương hợp thời * tư tưởng rất hợp thời",
    example: "một chủ trương hợp thời * tư tưởng rất hợp thời",
  },
  {
    word: "hợp phần",
    part_of_speech: "danh từ",
    meaning:
      "thành phần hợp thành của một hợp chất: oxygen và hydrogen là hai hợp phần của nước",
    example: "oxygen và hydrogen là hai hợp phần của nước",
  },
  {
    word: "hợp tấu",
    part_of_speech: "danh từ",
    meaning: "bản nhạc do nhiều người cùng biểu diễn: bản hợp tấu",
    example: "bản hợp tấu",
  },
  {
    word: "hợp thức",
    part_of_speech: "động từ",
    meaning: "đúng theo thể thức quy định: giấy tờ không hợp thức",
    example: "giấy tờ không hợp thức",
  },
  {
    word: "hợp thành",
    part_of_speech: "động từ",
    meaning:
      "(nhiều loại, nhiều bộ phận) hợp chung lại với nhau để tạo nên một cái lớn: các bộ phận hợp thành * được hợp thành từ nhiều đối tượng",
    example: "các bộ phận hợp thành * được hợp thành từ nhiều đối tượng",
  },
  {
    word: "hợp tình hợp lí",
    part_of_speech: "",
    meaning:
      "thoả đáng cả về mặt tình cảm lẫn về mặt lí lẽ: cách giải quyết hợp tình hợp lí",
    example: "cách giải quyết hợp tình hợp lí",
  },
  {
    word: "hợp tuyển",
    part_of_speech: "danh từ",
    meaning:
      "sách gồm nhiều tác phẩm của nhiều tác giả được lựa chọn và tập hợp lại theo một chủ đề hoặc một mục đích nhất định: hợp tuyển văn học Việt Nam giai đoạn 1930-1945",
    example: "hợp tuyển văn học Việt Nam giai đoạn 1930-1945",
  },
  {
    word: "hợp thức hoá",
    part_of_speech: "động từ",
    meaning:
      "làm cho trở nên hợp thức: hợp thức hoá giấy tờ * hợp thức hoá mối quan hệ",
    example: "hợp thức hoá giấy tờ * hợp thức hoá mối quan hệ",
  },
  {
    word: "hợp tình hợp lý",
    part_of_speech: "",
    meaning:
      "thoả đáng cả về mặt tình cảm lẫn về mặt lí lẽ: cách giải quyết hợp tình hợp lí",
    example: "cách giải quyết hợp tình hợp lí",
  },
  {
    word: "hợp xướng",
    part_of_speech: "danh từ",
    meaning:
      "hình thức biểu diễn thanh nhạc bằng lối hát nhiều giọng, nhiều bè: dàn hợp xướng",
    example: "dàn hợp xướng",
  },
  {
    word: "hớt lẻo",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nói chuyện riêng của ai đó mà mình vừa nghe được cho những người khác biết, tuy chuyện chẳng dính dáng gì đến mình (hàm ý coi thường): có tính hay ngồi lê, hớt lẻo",
    example: "có tính hay ngồi lê, hớt lẻo",
  },
  {
    word: "hợp ý",
    part_of_speech: "tính từ",
    meaning:
      "đúng với ý muốn của người nào đó: một quyết định hợp ý dân * cậu nói rất hợp ý tôi",
    example: "một quyết định hợp ý dân * cậu nói rất hợp ý tôi",
  },
  {
    word: "hợp ý",
    part_of_speech: "tính từ",
    meaning: "cùng có chung một ý như nhau: hai người rất hợp ý nhau",
    example: "hai người rất hợp ý nhau",
  },
  {
    word: "hớt tóc",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) cắt tóc (thường bằng tông đơ): đi hớt tóc * tiệm hớt tóc",
    example: "đi hớt tóc * tiệm hớt tóc",
  },
  {
    word: "hớt hải",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả dáng vẻ vội vàng, hoảng sợ lộ rõ ở nét mặt, bộ dạng: mặt mày hớt hải * hớt hải chạy về",
    example: "mặt mày hớt hải * hớt hải chạy về",
  },
  {
    word: "hớt",
    part_of_speech: "động từ",
    meaning:
      "lấy đi một lớp mỏng ở trên cùng, ngoài cùng: hớt bèo * hớt bỏ lớp váng nổi bên trên * cơm hớt",
    example: "hớt bèo * hớt bỏ lớp váng nổi bên trên * cơm hớt",
  },
  {
    word: "hớt",
    part_of_speech: "động từ",
    meaning:
      "lấy về cho mình cái đáng lẽ thuộc của người khác, khi người ta chưa kịp biết, chưa kịp lấy: bị hớt tay trên * hớt công của bạn",
    example: "bị hớt tay trên * hớt công của bạn",
  },
  {
    word: "hớt",
    part_of_speech: "động từ",
    meaning:
      "nói trước đi điều người khác định nói, muốn nói: hớt lời * đang ở đâu tự nhiên chen vào nói hớt",
    example: "hớt lời * đang ở đâu tự nhiên chen vào nói hớt",
  },
  {
    word: "hũ",
    part_of_speech: "danh từ",
    meaning:
      "đồ gốm loại nhỏ, miệng tròn, bé, giữa phình ra, thót dần về phía đáy, dùng để chứa đựng: hũ tương * hũ gạo * tối như hũ nút",
    example: "hũ tương * hũ gạo * tối như hũ nút",
  },
  {
    word: "hú",
    part_of_speech: "động từ",
    meaning:
      "cất tiếng to, vang, kéo dài để làm hiệu gọi nhau: chim kêu vượn hú",
    example: "chim kêu vượn hú",
  },
  {
    word: "hú",
    part_of_speech: "động từ",
    meaning:
      "phát ra tiếng to, dài, giống như tiếng hú: còi tàu hú vang * gió hú từng hồi trên mái nhà",
    example: "còi tàu hú vang * gió hú từng hồi trên mái nhà",
  },
  {
    word: "hù",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) doạ: hù trẻ con * bị bọn bạn hù cho một trận",
    example: "hù trẻ con * bị bọn bạn hù cho một trận",
  },
  {
    word: "hủ",
    part_of_speech: "tính từ",
    meaning: "(cũ, id, khẩu ngữ) hủ lậu (nói tắt): ông đồ hủ",
    example: "ông đồ hủ",
  },
  {
    word: "hụ",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) hú (thường nói về tiếng còi): xe cứu hoả hụ còi inh ỏi",
    example: "xe cứu hoả hụ còi inh ỏi",
  },
  {
    word: "hủ hỉ",
    part_of_speech: "động từ",
    meaning:
      "(Phương ngữ) chung sống với nhau đầm ấm, sớm tối có nhau, vui buồn có nhau: hủ hỉ với mẹ già",
    example: "hủ hỉ với mẹ già",
  },
  {
    word: "hù doạ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) doạ, làm cho sợ: hù doạ trẻ con * tung tin thất thiệt để hù doạ * không tin lời hù doạ",
    example:
      "hù doạ trẻ con * tung tin thất thiệt để hù doạ * không tin lời hù doạ",
  },
  {
    word: "hủ bại",
    part_of_speech: "tính từ",
    meaning: "lạc hậu và đồi bại: tư tưởng hủ bại * thành kiến hủ bại",
    example: "tư tưởng hủ bại * thành kiến hủ bại",
  },
  {
    word: "hú hồn hú vía",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) như hú vía (nhưng ý nhấn mạnh hơn): bị một phen hú hồn hú vía",
    example: "bị một phen hú hồn hú vía",
  },
  {
    word: "hú hí",
    part_of_speech: "động từ",
    meaning: "vui đùa âu yếm, chuyện trò nhỏ to với nhau: hú hí với vợ con",
    example: "hú hí với vợ con",
  },
  {
    word: "hú hoạ",
    part_of_speech: "tính từ",
    meaning:
      "chỉ trông vào yếu tố ngẫu nhiên, may ra thì trúng, thì được, chứ không có một cơ sở nào: bắn hú hoạ thế mà lại trúng * đoán hú hoạ * trả lời hú hoạ",
    example: "bắn hú hoạ thế mà lại trúng * đoán hú hoạ * trả lời hú hoạ",
  },
  {
    word: "hú hồn",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ, hiếm) như hú vía: sợ hú hồn",
    example: "sợ hú hồn",
  },
  {
    word: "hú hồn",
    part_of_speech: "động từ",
    meaning:
      "hú, gọi cho hồn trở về, làm cho tỉnh lại, theo quan niệm mê tín: hú hồn cho người bị ngất tỉnh lại",
    example: "hú hồn cho người bị ngất tỉnh lại",
  },
  {
    word: "hu hu",
    part_of_speech: "tính từ",
    meaning: "từ gợi tả tiếng khóc to, liên tiếp: khóc hu hu",
    example: "khóc hu hu",
  },
  {
    word: "hủ hoá",
    part_of_speech: "động từ",
    meaning:
      "có quan hệ nam nữ về xác thịt một cách bất chính: phạm tội hủ hoá",
    example: "phạm tội hủ hoá",
  },
  {
    word: "hủ lậu",
    part_of_speech: "tính từ",
    meaning:
      "quá lạc hậu, lỗi thời: đầu óc hủ lậu * bài trừ những tập tục hủ lậu",
    example: "đầu óc hủ lậu * bài trừ những tập tục hủ lậu",
  },
  {
    word: "hủ tục",
    part_of_speech: "danh từ",
    meaning: "phong tục đã lạc hậu, đã lỗi thời: xoá bỏ những hủ tục",
    example: "xoá bỏ những hủ tục",
  },
  {
    word: "huân chương",
    part_of_speech: "danh từ",
    meaning:
      "vật làm bằng kim loại, có cuống để có thể đeo trước ngực, dùng làm dấu hiệu cho phần thưởng cao quý do nhà nước đặt ra để tặng thưởng những người có công lao, thành tích đặc biệt xuất sắc (trong một lĩnh vực hoạt động nào đó): huân chương kháng chiến hạng nhất * tặng thưởng huân chương",
    example: "huân chương kháng chiến hạng nhất * tặng thưởng huân chương",
  },
  {
    word: "huấn luyện",
    part_of_speech: "động từ",
    meaning:
      "giảng dạy và hướng dẫn luyện tập: tham gia khoá huấn luyện quân sự * trung tâm huấn luyện thể thao",
    example: "tham gia khoá huấn luyện quân sự * trung tâm huấn luyện thể thao",
  },
  {
    word: "hua",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) dòi có ở trong tương hay trong nước mắm: trong tương có hua",
    example: "trong tương có hua",
  },
  {
    word: "hùa",
    part_of_speech: "động từ",
    meaning:
      "làm theo người khác việc gì đó, thường là không tốt, do đồng tình một cách vội vàng, thiếu suy nghĩ: chẳng rõ đầu đuôi ra sao cũng hùa vào chửi theo",
    example: "chẳng rõ đầu đuôi ra sao cũng hùa vào chửi theo",
  },
  {
    word: "hùa",
    part_of_speech: "động từ",
    meaning:
      "theo nhau làm việc gì một cách ồ ạt: hùa nhau đẩy cho chiếc xe nổ máy",
    example: "hùa nhau đẩy cho chiếc xe nổ máy",
  },
  {
    word: "hùa",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) bè, phe: vào hùa * về hùa với nhau để chèn ép người khác",
    example: "vào hùa * về hùa với nhau để chèn ép người khác",
  },
  {
    word: "hú vía",
    part_of_speech: "động từ",
    meaning:
      "sợ hoảng hồn trước một nguy hiểm bất ngờ (nhưng nay đã thoát khỏi): bị một phen hú vía * sợ hú vía",
    example: "bị một phen hú vía * sợ hú vía",
  },
  {
    word: "hú vía",
    part_of_speech: "cảm từ",
    meaning:
      "tiếng thốt ra biểu lộ sự mừng rỡ vì đã may mắn thoát khỏi mối nguy hiểm, lo sợ: suýt nữa thì ăn đạn, thật hú vía!",
    example: "suýt nữa thì ăn đạn, thật hú vía!",
  },
  {
    word: "hú tim",
    part_of_speech: "danh từ",
    meaning: "trò chơi đi trốn, đi tìm của trẻ em: chơi trò ú tim",
    example: "chơi trò ú tim",
  },
  {
    word: "huấn luyện viên",
    part_of_speech: "danh từ",
    meaning: "người làm công tác huấn luyện: huấn luyện viên bóng đá",
    example: "huấn luyện viên bóng đá",
  },
  {
    word: "huấn thị",
    part_of_speech: "",
    meaning:
      "(trang trọng) giảng giải, chỉ bảo cho người dưới về một vấn đề gì, nhân một dịp gì: xin huấn thị của cấp trên",
    example: "xin huấn thị của cấp trên",
  },
  {
    word: "hục",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) xông vào làm việc gì một cách vội vã, không cân nhắc, suy tính kĩ lưỡng: chưa đọc kĩ đề bài đã hục đầu vào làm",
    example: "chưa đọc kĩ đề bài đã hục đầu vào làm",
  },
  {
    word: "huề",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) hoà: xử huề * huề cả làng",
    example: "xử huề * huề cả làng",
  },
  {
    word: "húc",
    part_of_speech: "động từ",
    meaning:
      "đâm mạnh đầu (hoặc sừng) vào: hai con dê húc nhau * húc đầu vào cột điện",
    example: "hai con dê húc nhau * húc đầu vào cột điện",
  },
  {
    word: "húc",
    part_of_speech: "động từ",
    meaning:
      "đâm mạnh vào trên đường di chuyển (thường nói về tàu xe): hai chiếc ô tô húc đầu vào nhau",
    example: "hai chiếc ô tô húc đầu vào nhau",
  },
  {
    word: "húc",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) vấp phải trở lực khó vượt qua: húc phải một vấn đề hóc búa * húc phải một bài toán khó",
    example: "húc phải một vấn đề hóc búa * húc phải một bài toán khó",
  },
  {
    word: "hục hặc",
    part_of_speech: "động từ",
    meaning:
      "cãi cọ, tỏ thái độ bực tức cả trong những chuyện lặt vặt, do có mâu thuẫn với nhau: vợ chồng hục hặc nhau",
    example: "vợ chồng hục hặc nhau",
  },
  {
    word: "huê tình",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) quan hệ trai gái lẳng lơ, ngoài khuôn phép: chuyện huê tình * "Gặp lúc trăng thanh gió mát, Thú vui nào bằng thú hát huê tình." (ca dao)',
    example:
      'chuyện huê tình * "Gặp lúc trăng thanh gió mát, Thú vui nào bằng thú hát huê tình." (ca dao)',
  },
  {
    word: "huếch hoác",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) rộng huếch, trống huếch (nói khái quát): nhà cửa huếch hoác * trống huếch trống hoác",
    example: "nhà cửa huếch hoác * trống huếch trống hoác",
  },
  {
    word: "hủi",
    part_of_speech: "danh từ",
    meaning: "bệnh phong: bị hủi * con hủi",
    example: "bị hủi * con hủi",
  },
  {
    word: "hụi",
    part_of_speech: "danh từ",
    meaning: "(Khẩu ngữ) như họ: chơi hụi * đóng hụi",
    example: "chơi hụi * đóng hụi",
  },
  {
    word: "hùi hụi",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) từ mô phỏng những tiếng trầm và nặng nối tiếp nhau: rên hùi hụi",
    example: "rên hùi hụi",
  },
  {
    word: "hùi hụi",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) từ dùng để miêu tả vẻ ngẩn ngơ, xuýt xoa vì tiếc: tiếc tiền hùi hụi",
    example: "tiếc tiền hùi hụi",
  },
  {
    word: "húi",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) cắt tóc: đầu húi trọc lóc * đi húi tóc ngoài tiệm",
    example: "đầu húi trọc lóc * đi húi tóc ngoài tiệm",
  },
  {
    word: "hùm",
    part_of_speech: "danh từ",
    meaning: "(Khẩu ngữ) hổ: khoẻ như hùm * hang hùm",
    example: "khoẻ như hùm * hang hùm",
  },
  {
    word: "hụm",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) ngụm: uống một hụm nước",
    example: "uống một hụm nước",
  },
  {
    word: "huênh hoang",
    part_of_speech: "",
    meaning:
      "có những lời lẽ khoe khoang quá đáng, tỏ ra tự đánh giá mình quá cao: lời lẽ huênh hoang * tuyên bố một cách huênh hoang",
    example: "lời lẽ huênh hoang * tuyên bố một cách huênh hoang",
  },
  {
    word: "hum húp",
    part_of_speech: "tính từ",
    meaning: "hơi sưng phồng lên: mắt hum húp",
    example: "mắt hum húp",
  },
  {
    word: "hùn",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) góp chung lại để cùng làm việc gì: hùn vốn kinh doanh * cùng hùn sức để khênh tấm bê tông",
    example: "hùn vốn kinh doanh * cùng hùn sức để khênh tấm bê tông",
  },
  {
    word: "hun",
    part_of_speech: "động từ",
    meaning:
      "đốt cho khói và hơi nóng tác động trực tiếp vào: hun chuột * hun muỗi * thịt hun khói",
    example: "hun chuột * hun muỗi * thịt hun khói",
  },
  {
    word: "hun",
    part_of_speech: "động từ",
    meaning:
      "(văn chương) làm cho yếu tố tình cảm, tinh thần nóng lên, bùng lên mạnh mẽ: hun sôi bầu máu nóng của tuổi trẻ",
    example: "hun sôi bầu máu nóng của tuổi trẻ",
  },
  {
    word: "hun hút",
    part_of_speech: "tính từ",
    meaning:
      "như hút (nhưng ý mức độ nhiều hơn): vực sâu hun hút * hành lang dài hun hút",
    example: "vực sâu hun hút * hành lang dài hun hút",
  },
  {
    word: "hun hút",
    part_of_speech: "tính từ",
    meaning:
      "(gió) mạnh, như xoáy sâu thành luồng, liên tiếp: gió bấc thổi hun hút",
    example: "gió bấc thổi hun hút",
  },
  {
    word: "hung",
    part_of_speech: "tính từ",
    meaning: "có màu giữa màu đỏ và màu vàng: tóc nhuộm màu hung",
    example: "tóc nhuộm màu hung",
  },
  {
    word: "hung",
    part_of_speech: "tính từ",
    meaning:
      "sẵn sàng có những hành động thô bạo, dữ tợn mà không tự kiềm chế nổi: tính nó rất hung * nổi hung",
    example: "tính nó rất hung * nổi hung",
  },
  {
    word: "hung",
    part_of_speech: "phụ từ",
    meaning: "(Phương ngữ, Khẩu ngữ) lắm, quá: mệt hung * chợ đông hung",
    example: "mệt hung * chợ đông hung",
  },
  {
    word: "hun đúc",
    part_of_speech: "động từ",
    meaning:
      "(văn chương) tạo nên qua quá trình rèn luyện, thử thách: hun đúc chí khí đấu tranh * hun đúc bản lĩnh và tài năng",
    example: "hun đúc chí khí đấu tranh * hun đúc bản lĩnh và tài năng",
  },
  {
    word: "hùn vào",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) góp thêm ý kiến đồng tình để cho nên việc: nói hùn vào * mọi người đều hùn vào cho hai người thành đôi lứa",
    example: "nói hùn vào * mọi người đều hùn vào cho hai người thành đôi lứa",
  },
  {
    word: "hùn hạp",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) hùn lại, hợp lại (nói khái quát): hùn hạp vốn để cùng làm ăn",
    example: "hùn hạp vốn để cùng làm ăn",
  },
  {
    word: "hùng",
    part_of_speech: "tính từ",
    meaning: "có khí thế mạnh mẽ: người hùng * binh hùng tướng mạnh",
    example: "người hùng * binh hùng tướng mạnh",
  },
  {
    word: "hung ác",
    part_of_speech: "tính từ",
    meaning: "dữ tợn và tàn ác: tên cướp khét tiếng hung ác * kẻ thù hung ác",
    example: "tên cướp khét tiếng hung ác * kẻ thù hung ác",
  },
  {
    word: "hung bạo",
    part_of_speech: "tính từ",
    meaning:
      "hung ác và sẵn sàng gây tai hoạ, bất chấp cả đạo lí: kẻ thù hung bạo * bản tính hung bạo",
    example: "kẻ thù hung bạo * bản tính hung bạo",
  },
  {
    word: "hùng cường",
    part_of_speech: "tính từ",
    meaning: "(cũ) hùng mạnh: xây dựng đất nước hùng cường",
    example: "xây dựng đất nước hùng cường",
  },
  {
    word: "hùng biện",
    part_of_speech: "động từ",
    meaning:
      "nói hay, lập luận chặt chẽ, có sức thuyết phục mạnh mẽ đối với người nghe: có tài hùng biện",
    example: "có tài hùng biện",
  },
  {
    word: "hùng dũng",
    part_of_speech: "tính từ",
    meaning:
      "mạnh mẽ và hiên ngang, đầy khí thế: bước đi hùng dũng * dáng điệu trông thật hùng dũng",
    example: "bước đi hùng dũng * dáng điệu trông thật hùng dũng",
  },
  {
    word: "hung dữ",
    part_of_speech: "tính từ",
    meaning:
      "sẵn sàng gây tai hoạ một cách đáng sợ: vẻ mặt hung dữ * mùa nước lũ, dòng sông trở nên hung dữ",
    example: "vẻ mặt hung dữ * mùa nước lũ, dòng sông trở nên hung dữ",
  },
  {
    word: "hùng cứ",
    part_of_speech: "động từ",
    meaning:
      "(cũ) chiếm giữ một vùng với thế mạnh: mỗi người hùng cứ một phương",
    example: "mỗi người hùng cứ một phương",
  },
  {
    word: "hung đồ",
    part_of_speech: "danh từ",
    meaning:
      "kẻ dám làm, sẵn sàng làm điều tàn ác, như cướp bóc, giết người, cưỡng hiếp: bọn hung đồ * dáng vẻ hung đồ",
    example: "bọn hung đồ * dáng vẻ hung đồ",
  },
  {
    word: "húng hắng",
    part_of_speech: "tính từ",
    meaning: "(ho) nhẹ, từng tiếng ngắn, nhỏ và thưa: húng hắng ho",
    example: "húng hắng ho",
  },
  {
    word: "hung hăng",
    part_of_speech: "tính từ",
    meaning:
      'có dáng vẻ sẵn sàng có những hành động thô bạo chống lại người khác: điệu bộ hung hăng * "Hung hăng chẳng hỏi, chẳng tra, Đang tay vùi liễu, dập hoa tơi bời." (TKiều)',
    example:
      'điệu bộ hung hăng * "Hung hăng chẳng hỏi, chẳng tra, Đang tay vùi liễu, dập hoa tơi bời." (TKiều)',
  },
  {
    word: "hung hiểm",
    part_of_speech: "động từ",
    meaning: "hiểm độc tới mức đáng sợ: lòng dạ hung hiểm",
    example: "lòng dạ hung hiểm",
  },
  {
    word: "hung hãn",
    part_of_speech: "tính từ",
    meaning:
      "sẵn sàng dùng sức mạnh thô bạo một cách không kiềm chế để gây tai hoạ: tên tướng cướp hung hãn",
    example: "tên tướng cướp hung hãn",
  },
  {
    word: "hùng hậu",
    part_of_speech: "tính từ",
    meaning: "mạnh mẽ và đầy đủ ở mọi mặt, mọi phương diện: lực lượng hùng hậu",
    example: "lực lượng hùng hậu",
  },
  {
    word: "hùng hục",
    part_of_speech: "tính từ",
    meaning:
      "(làm việc gì) dốc toàn bộ sức ra để làm nhưng thiếu suy nghĩ, tính toán: hùng hục đào bới * chúi đầu vào làm hùng hục",
    example: "hùng hục đào bới * chúi đầu vào làm hùng hục",
  },
  {
    word: "hùng hổ",
    part_of_speech: "tính từ",
    meaning: "hung hăng, dữ tợn, như muốn ra tay ngay: dáng điệu hùng hổ",
    example: "dáng điệu hùng hổ",
  },
  {
    word: "hùng hồn",
    part_of_speech: "tính từ",
    meaning:
      "mạnh mẽ, đầy sức lôi cuốn và thuyết phục: một bài diễn văn hùng hồn * hùng hồn tuyên bố",
    example: "một bài diễn văn hùng hồn * hùng hồn tuyên bố",
  },
  {
    word: "hùng hùng hổ hổ",
    part_of_speech: "tính từ",
    meaning:
      "rất hung hăng và đầy vẻ dữ tợn, trông đáng sợ: hùng hùng hổ hổ xông vào nhà người ta đe doạ",
    example: "hùng hùng hổ hổ xông vào nhà người ta đe doạ",
  },
  {
    word: "hung khí",
    part_of_speech: "danh từ",
    meaning: "khí giới dùng để giết người: tên cướp dùng hung khí để đe doạ",
    example: "tên cướp dùng hung khí để đe doạ",
  },
  {
    word: "hung tàn",
    part_of_speech: "tính từ",
    meaning:
      "hung hăng và tàn bạo đến mức bất chấp cả nhân nghĩa, đạo lí: thói hung tàn * tên tướng giặc khét tiếng hung tàn",
    example: "thói hung tàn * tên tướng giặc khét tiếng hung tàn",
  },
  {
    word: "hùng khí",
    part_of_speech: "danh từ",
    meaning: "(văn chương) khí thế mạnh mẽ, hào hùng: hùng khí của tuổi trẻ",
    example: "hùng khí của tuổi trẻ",
  },
  {
    word: "hùng mạnh",
    part_of_speech: "tính từ",
    meaning: "có đầy đủ sức mạnh: đất nước hùng mạnh",
    example: "đất nước hùng mạnh",
  },
  {
    word: "hung tợn",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) rất hung dữ: con lợn lòi hung tợn * mặt mày hung tợn",
    example: "con lợn lòi hung tợn * mặt mày hung tợn",
  },
  {
    word: "hùng tráng",
    part_of_speech: "tính từ",
    meaning:
      "(văn chương) mạnh mẽ và gây được ấn tượng của cái đẹp: cảnh vật hùng tráng * tiếng nhạc hùng tráng",
    example: "cảnh vật hùng tráng * tiếng nhạc hùng tráng",
  },
  {
    word: "hùng vĩ",
    part_of_speech: "tính từ",
    meaning:
      "rộng lớn và gây được ấn tượng của cái mạnh, cái đẹp (thường nói về cảnh vật): núi non hùng vĩ * lâu đài có quy mô hùng vĩ",
    example: "núi non hùng vĩ * lâu đài có quy mô hùng vĩ",
  },
  {
    word: "hung tinh",
    part_of_speech: "danh từ",
    meaning:
      "ngôi sao xấu, có thể gây ra tai hoạ cho con người, theo chiêm tinh học: hung tinh chiếu mệnh",
    example: "hung tinh chiếu mệnh",
  },
  {
    word: "huống gì",
    part_of_speech: "kết từ",
    meaning:
      "tổ hợp biểu thị ý với đối tượng sắp nêu thì việc đang nói đến càng có khả năng xảy ra, nó là tất yếu: người dưng còn giúp được huống gì bạn bè",
    example: "người dưng còn giúp được huống gì bạn bè",
  },
  {
    word: "huống",
    part_of_speech: "kết từ",
    meaning:
      '(cũ, văn chương) như huống gì: "Mai mưa, trưa nắng, chiều nồm, Trời còn luân chuyển huống mồm thế gian." (ca dao)',
    example:
      'Mai mưa, trưa nắng, chiều nồm, Trời còn luân chuyển huống mồm thế gian." (ca dao)',
  },
  {
    word: "hung thủ",
    part_of_speech: "danh từ",
    meaning:
      "kẻ phạm tội giết người hoặc đánh người trọng thương: hung thủ giết người * đã bắt được hung thủ",
    example: "hung thủ giết người * đã bắt được hung thủ",
  },
  {
    word: "húp híp",
    part_of_speech: "",
    meaning:
      "phồng to lên, mọng lên, do bị sưng hoặc quá béo: béo húp híp * mắt sưng húp híp",
    example: "béo húp híp * mắt sưng húp híp",
  },
  {
    word: "huống hồ",
    part_of_speech: "kết từ",
    meaning:
      "(văn chương) như huống gì: chuyện lớn còn bỏ qua được, huống hồ một chuyện cỏn con",
    example: "chuyện lớn còn bỏ qua được, huống hồ một chuyện cỏn con",
  },
  {
    word: "hút chích",
    part_of_speech: "động từ",
    meaning:
      "hút thuốc phiện và chích ma tuý (nói khái quát): tụ tập nhau để hút chích ma tuý",
    example: "tụ tập nhau để hút chích ma tuý",
  },
  {
    word: "hụp",
    part_of_speech: "động từ",
    meaning:
      "tự làm cho chìm hẳn đầu xuống dưới mặt nước một lúc: lặn hụp mãi mới chịu lên bờ",
    example: "lặn hụp mãi mới chịu lên bờ",
  },
  {
    word: "hụt",
    part_of_speech: "tính từ",
    meaning:
      "thiếu một phần, không đạt đủ mức cụ thể về số lượng, kích thước, khoảng cách như đã dự tính hoặc đã tưởng: bước hụt chân * vải cắt bị hụt",
    example: "bước hụt chân * vải cắt bị hụt",
  },
  {
    word: "hụt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) không thực hiện được việc tưởng đã làm được, vì bị thất bại bất ngờ ở bước cuối cùng: bắt hụt kẻ trộm * hụt mất chuyến tàu * cô vợ hụt",
    example: "bắt hụt kẻ trộm * hụt mất chuyến tàu * cô vợ hụt",
  },
  {
    word: "húp",
    part_of_speech: "động từ",
    meaning:
      'đưa thức ăn lỏng vào mồm bằng cách kề môi vào miệng vật đựng và hút mạnh dần từng ít một: húp cháo * "Râu tôm nấu với ruột bầu, Chồng chan vợ húp gật đầu khen ngon." (ca dao)',
    example:
      'húp cháo * "Râu tôm nấu với ruột bầu, Chồng chan vợ húp gật đầu khen ngon." (ca dao)',
  },
  {
    word: "húp",
    part_of_speech: "tính từ",
    meaning:
      "(bộ phận của cơ thể) phồng to và mọng lên một cách không bình thường, gây cảm giác nặng nề, khó chịu: khóc nhiều, húp cả mắt * mặt mũi húp to",
    example: "khóc nhiều, húp cả mắt * mặt mũi húp to",
  },
  {
    word: "huơ",
    part_of_speech: "động từ",
    meaning:
      "giơ lên và đưa qua đưa lại liên tiếp, thường để ra hiệu: huơ tay tạm biệt * vừa nói vừa huơ tay, huơ chân",
    example: "huơ tay tạm biệt * vừa nói vừa huơ tay, huơ chân",
  },
  {
    word: "hút",
    part_of_speech: "danh từ",
    meaning:
      "dấu vết còn lại có dạng một lỗ sâu của vật đã đi thẳng và rất sâu vào trong: hút bom * hút nước",
    example: "hút bom * hút nước",
  },
  {
    word: "hút",
    part_of_speech: "danh từ",
    meaning:
      "dấu vết, hình bóng còn thoáng lưu lại khi người hoặc vật sắp đi khuất hẳn: mất hút * bước theo hút cái bóng người đi trước",
    example: "mất hút * bước theo hút cái bóng người đi trước",
  },
  {
    word: "hút",
    part_of_speech: "tính từ",
    meaning:
      "(sâu, xa) đến mức không thể nhìn thấy được cho đến tận cùng: xa hút tầm mắt * hành lang sâu hút",
    example: "xa hút tầm mắt * hành lang sâu hút",
  },
  {
    word: "hút",
    part_of_speech: "động từ",
    meaning:
      "làm cho chất lỏng, chất khí chuyển chỗ về phía nào đó bằng cách tạo ra ở đó một khoảng chân không: bơm hút nước * hệ thống hút gió",
    example: "bơm hút nước * hệ thống hút gió",
  },
  {
    word: "hút",
    part_of_speech: "động từ",
    meaning:
      "hít vào trong miệng: hút thuốc lá * ong hút mật * hút thuốc lào sòng sọc",
    example: "hút thuốc lá * ong hút mật * hút thuốc lào sòng sọc",
  },
  {
    word: "hút",
    part_of_speech: "động từ",
    meaning:
      "làm cho di chuyển về phía mình bằng tác động của một lực trong bản thân: nam châm hút sắt",
    example: "nam châm hút sắt",
  },
  {
    word: "hút",
    part_of_speech: "động từ",
    meaning:
      "làm cho chất lỏng, chất khí ở môi trường xung quanh thấm vào trong mình: bông hút nước * máy hút bụi",
    example: "bông hút nước * máy hút bụi",
  },
  {
    word: "hút",
    part_of_speech: "động từ",
    meaning:
      "lôi cuốn, làm cho dồn cả sức lực, tinh thần vào: màn ảo thuật như hút lấy người xem * bị hút mất hồn",
    example: "màn ảo thuật như hút lấy người xem * bị hút mất hồn",
  },
  {
    word: "hút",
    part_of_speech: "phụ từ",
    meaning: "(Ít dùng) như suýt: mấy lần hút chết",
    example: "mấy lần hút chết",
  },
  {
    word: "hút hồn",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) lôi cuốn, làm cho say mê đến mức như bị thu hút toàn bộ tâm trí: sắc đẹp của cô đã hút hồn không ít các chàng trai",
    example: "sắc đẹp của cô đã hút hồn không ít các chàng trai",
  },
  {
    word: "hút hít",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) hút và hít ma tuý (nói khái quát): sa vào hút hít * xoá bỏ tụ điểm hút hít ma tuý",
    example: "sa vào hút hít * xoá bỏ tụ điểm hút hít ma tuý",
  },
  {
    word: "hụt hẫng",
    part_of_speech: "tính từ",
    meaning:
      "có cảm giác bị thiếu mất đi một cái gì (thường là trong lĩnh vực tình cảm) một cách đột ngột: bị hụt hẫng về tình cảm * tiễn bạn đi rồi, trong lòng cảm thấy hụt hẫng",
    example:
      "bị hụt hẫng về tình cảm * tiễn bạn đi rồi, trong lòng cảm thấy hụt hẫng",
  },
  {
    word: "hụt hẫng",
    part_of_speech: "tính từ",
    meaning: "bị thiếu hẳn, hụt hẳn: hụt hẫng về lực lượng",
    example: "hụt hẫng về lực lượng",
  },
  {
    word: "hút xách",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) hút thuốc phiện (nói khái quát; hàm ý chê hoặc coi khinh): chơi bời hút xách",
    example: "chơi bời hút xách",
  },
  {
    word: "huỷ",
    part_of_speech: "động từ",
    meaning:
      "làm cho không còn tồn tại hoặc không còn giá trị nữa: đơn phương huỷ hợp đồng * huỷ hôn ước",
    example: "đơn phương huỷ hợp đồng * huỷ hôn ước",
  },
  {
    word: "hút máu hút mủ",
    part_of_speech: "",
    meaning:
      "ví hành động bòn rút, bóc lột người khác một cách tàn nhẫn: địa chủ hút máu hút mủ của nông dân",
    example: "địa chủ hút máu hút mủ của nông dân",
  },
  {
    word: "huy động",
    part_of_speech: "động từ",
    meaning:
      "điều một số đông, một số lớn nhân lực, vật lực vào một công việc gì: huy động vốn * huy động toàn bộ lực lượng vào trận đánh",
    example: "huy động vốn * huy động toàn bộ lực lượng vào trận đánh",
  },
  {
    word: "huý",
    part_of_speech: "danh từ",
    meaning: "tên huý (nói tắt): Đinh Tiên Hoàng, huý là Đinh Bộ Lĩnh",
    example: "Đinh Tiên Hoàng, huý là Đinh Bộ Lĩnh",
  },
  {
    word: "huỷ diệt",
    part_of_speech: "động từ",
    meaning:
      "diệt hoàn toàn, làm cho không còn tồn tại trên một phạm vi rộng: giặc rải chất độc để huỷ diệt cây cối",
    example: "giặc rải chất độc để huỷ diệt cây cối",
  },
  {
    word: "huy hiệu",
    part_of_speech: "danh từ",
    meaning:
      "vật làm bằng kim loại dùng làm dấu hiệu tượng trưng cho một tổ chức hoặc để kỉ niệm một phong trào, một sự kiện lịch sử hay một nhân vật nổi tiếng: huy hiệu Đoàn thanh niên",
    example: "huy hiệu Đoàn thanh niên",
  },
  {
    word: "huỷ bỏ",
    part_of_speech: "động từ",
    meaning:
      "huỷ đi, bỏ đi, coi là không còn giá trị: huỷ bỏ kế hoạch * tuyên bố huỷ bỏ bản án * huỷ bỏ hôn ước",
    example: "huỷ bỏ kế hoạch * tuyên bố huỷ bỏ bản án * huỷ bỏ hôn ước",
  },
  {
    word: "huy chương",
    part_of_speech: "danh từ",
    meaning:
      "vật làm bằng kim loại, dùng làm dấu hiệu cho phần thưởng do nhà nước hay tổ chức xã hội đặt ra để tặng thưởng những người có thành tích, công trạng: đoạt huy chương vàng môn cờ vua toàn quốc",
    example: "đoạt huy chương vàng môn cờ vua toàn quốc",
  },
  {
    word: "huỵch toẹt",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nói toẹt ra, không cần giữ gìn, ý tứ gì cả: có gì thì cứ nói huỵch toẹt ra, không phải bóng gió",
    example: "có gì thì cứ nói huỵch toẹt ra, không phải bóng gió",
  },
  {
    word: "huỷ hoại",
    part_of_speech: "động từ",
    meaning:
      "làm cho tan nát, hư hỏng: trận bão đã huỷ hoại gần hết mùa màng * tự huỷ hoại đời mình",
    example: "trận bão đã huỷ hoại gần hết mùa màng * tự huỷ hoại đời mình",
  },
  {
    word: "huy hoàng",
    part_of_speech: "tính từ",
    meaning:
      'có vẻ đẹp chói lọi, rực rỡ: tương lai huy hoàng * "Thà một phút huy hoàng rồi chợt tối, Còn hơn buồn le lói suốt trăm năm." (XDiệu; 7)',
    example:
      'tương lai huy hoàng * "Thà một phút huy hoàng rồi chợt tối, Còn hơn buồn le lói suốt trăm năm." (XDiệu; 7)',
  },
  {
    word: "huỵch",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng động to, trầm và gọn do một hoạt động mạnh nào đó gây ra: ngã đánh huỵnh xuống đất",
    example: "ngã đánh huỵnh xuống đất",
  },
  {
    word: "huyền",
    part_of_speech: "danh từ",
    meaning: "đá có màu đen nhánh, dùng làm đồ trang sức: chuỗi hạt huyền",
    example: "chuỗi hạt huyền",
  },
  {
    word: "huyền",
    part_of_speech: "tính từ",
    meaning: "có màu đen như hạt huyền: đôi mắt huyền",
    example: "đôi mắt huyền",
  },
  {
    word: "huý kị",
    part_of_speech: "động từ",
    meaning: "kiêng tránh một cách bắt buộc: phạm vào điều huý kị",
    example: "phạm vào điều huý kị",
  },
  {
    word: "huyền ảo",
    part_of_speech: "tính từ",
    meaning:
      "có vẻ đẹp kì lạ và bí ẩn, vừa như thực vừa như hư, tạo sức cuốn hút mạnh mẽ: cảnh vật huyền ảo qua màn sương",
    example: "cảnh vật huyền ảo qua màn sương",
  },
  {
    word: "huyền bí",
    part_of_speech: "tính từ",
    meaning:
      "bí ẩn và có vẻ mầu nhiệm, khó hiểu, khó nắm bắt: câu chuyện huyền bí * sức mạnh huyền bí",
    example: "câu chuyện huyền bí * sức mạnh huyền bí",
  },
  {
    word: "huyền diệu",
    part_of_speech: "tính từ",
    meaning:
      "rất kì lạ, có cái gì đó cao sâu, tác động mạnh đến tâm hồn, mà con người không hiểu biết hết được: phép Phật huyền diệu",
    example: "phép Phật huyền diệu",
  },
  {
    word: "huyên đường",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) người mẹ (ví với nhà có trồng cỏ huyên, một loài cỏ sống lâu): "Đờn kêu mười bảy năm trường, Chồng Nam vợ Bắc, huyên đường tám mươi." (TKCT)',
    example:
      'Đờn kêu mười bảy năm trường, Chồng Nam vợ Bắc, huyên đường tám mươi." (TKCT)',
  },
  {
    word: "huyễn hoặc",
    part_of_speech: "động từ",
    meaning:
      "làm cho mất sáng suốt, lầm lẫn, tin vào những điều không có thật hoặc có tính chất mê tín: tự huyễn hoặc mình * dùng những chuyện kì bí để huyễn hoặc người khác",
    example:
      "tự huyễn hoặc mình * dùng những chuyện kì bí để huyễn hoặc người khác",
  },
  {
    word: "huyền hoặc",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất không có thật và mang vẻ huyền bí: câu chuyện huyền hoặc",
    example: "câu chuyện huyền hoặc",
  },
  {
    word: "huyền hoặc",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) làm cho tin một cách mê muội vào những điều không có thật: bị huyền hoặc bởi những học thuyết thần bí",
    example: "bị huyền hoặc bởi những học thuyết thần bí",
  },
  {
    word: "huyên náo",
    part_of_speech: "tính từ",
    meaning:
      "ồn ào, hỗn loạn, do có việc bất thường xảy ra: đường phố huyên náo",
    example: "đường phố huyên náo",
  },
  {
    word: "huyền nhiệm",
    part_of_speech: "tính từ",
    meaning: "huyền bí và mầu nhiệm: phép màu huyền nhiệm",
    example: "phép màu huyền nhiệm",
  },
  {
    word: "huyện thị",
    part_of_speech: "danh từ",
    meaning: "huyện và thị xã (nói gộp): các huyện thị nội tỉnh",
    example: "các huyện thị nội tỉnh",
  },
  {
    word: "huyền phù",
    part_of_speech: "danh từ",
    meaning:
      "hệ những hạt rất nhỏ lơ lửng trong một chất lỏng: hệ huyền phù trong nước thải công nghiệp",
    example: "hệ huyền phù trong nước thải công nghiệp",
  },
  {
    word: "huyên thuyên",
    part_of_speech: "",
    meaning:
      "(nói năng) nhiều lời và lan man, chưa hết chuyện này đã sang chuyện kia: cười nói huyên thuyên * huyên thuyên đủ các thứ chuyện",
    example: "cười nói huyên thuyên * huyên thuyên đủ các thứ chuyện",
  },
  {
    word: "huyền thoại",
    part_of_speech: "danh từ",
    meaning:
      "câu chuyện không có thật, mang vẻ thần bí, kì lạ, hoàn toàn do tưởng tượng: câu chuyện huyền thoại",
    example: "câu chuyện huyền thoại",
  },
  {
    word: "huyền tích",
    part_of_speech: "danh từ",
    meaning:
      "tích truyện mang đậm tính huyền thoại, thường gắn với những yếu tố lịch sử: huyền tích rùa vàng * huyền tích một vùng đất",
    example: "huyền tích rùa vàng * huyền tích một vùng đất",
  },
  {
    word: "huyết",
    part_of_speech: "danh từ",
    meaning: "máu (thường chỉ nói về máu người): thuốc bổ huyết * bị thổ huyết",
    example: "thuốc bổ huyết * bị thổ huyết",
  },
  {
    word: "huyễn tưởng",
    part_of_speech: "",
    meaning:
      "tưởng tượng ra và tin vào những điều không có thật hoặc không có cơ sở thực tế: mắc bệnh huyễn tưởng * mải mê trong ý nghĩ huyễn tưởng",
    example: "mắc bệnh huyễn tưởng * mải mê trong ý nghĩ huyễn tưởng",
  },
  {
    word: "huyệt",
    part_of_speech: "danh từ",
    meaning:
      "điểm trọng yếu ở mặt ngoài cơ thể người, nơi khí huyết kinh lạc tập trung, thường là nơi để châm cứu, bấm hoặc day vào đó để chữa bệnh, theo đông y: phương pháp bấm huyệt chữa bệnh",
    example: "phương pháp bấm huyệt chữa bệnh",
  },
  {
    word: "huyệt",
    part_of_speech: "danh từ",
    meaning: "chỗ hiểm trên cơ thể người: điểm huyệt",
    example: "điểm huyệt",
  },
  {
    word: "huyết áp",
    part_of_speech: "danh từ",
    meaning:
      "áp suất của máu trên các thành động mạch: đo huyết áp * huyết áp là 80/120",
    example: "đo huyết áp * huyết áp là 80/120",
  },
  {
    word: "huyết hệ",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như huyết thống: người cùng huyết hệ",
    example: "người cùng huyết hệ",
  },
  {
    word: "huyết mạch",
    part_of_speech: "danh từ",
    meaning:
      "mạch máu (thường dùng cho người hoặc chỉ dùng với nghĩa bóng): con đường huyết mạch",
    example: "con đường huyết mạch",
  },
  {
    word: "huyết chiến",
    part_of_speech: "động từ",
    meaning:
      "đánh nhau ác liệt, đổ máu nhiều trên chiến trường: trận huyết chiến",
    example: "trận huyết chiến",
  },
  {
    word: "huyết học",
    part_of_speech: "danh từ",
    meaning: "bộ môn y học nghiên cứu về máu: khoa huyết học",
    example: "khoa huyết học",
  },
  {
    word: "huyết khí",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như khí huyết: huyết khí không lưu thông",
    example: "huyết khí không lưu thông",
  },
  {
    word: "huyết quản",
    part_of_speech: "danh từ",
    meaning:
      "mạch máu (thường dùng cho người): máu trong huyết quản như sôi lên vì giận dữ",
    example: "máu trong huyết quản như sôi lên vì giận dữ",
  },
  {
    word: "huyết tộc",
    part_of_speech: "danh từ",
    meaning: "quan hệ họ hàng cùng dòng máu: cấm hôn nhân huyết tộc",
    example: "cấm hôn nhân huyết tộc",
  },
  {
    word: "huyết thống",
    part_of_speech: "danh từ",
    meaning:
      "dòng họ, về mặt quan hệ máu mủ giữa các thành viên với nhau: quan hệ huyết thống",
    example: "quan hệ huyết thống",
  },
  {
    word: "huyết thanh",
    part_of_speech: "danh từ",
    meaning: "chất dịch màu vàng nhạt còn lại sau khi máu đông.",
    example: "truyền huyết thanh",
  },
  {
    word: "huỳnh huỵch",
    part_of_speech: "tính từ",
    meaning:
      "như huỵch (nhưng ý liên tiếp): đấm đá nhau huỳnh huỵch * tiếng chân người chạy huỳnh huỵch",
    example: "đấm đá nhau huỳnh huỵch * tiếng chân người chạy huỳnh huỵch",
  },
  {
    word: "huýt",
    part_of_speech: "động từ",
    meaning:
      "chúm môi tròn lại, thổi hơi ra cho kêu thành tiếng: chúm môi, huýt một điệu sáo mồm",
    example: "chúm môi, huýt một điệu sáo mồm",
  },
  {
    word: "huýt",
    part_of_speech: "động từ",
    meaning: "thổi còi: huýt còi",
    example: "huýt còi",
  },
  {
    word: "huỳnh quang",
    part_of_speech: "danh từ",
    meaning:
      "hiện tượng một số chất lỏng hoặc tinh thể phát ánh sáng trông thấy được khi được chiếu sáng bằng tia tử ngoại, tia X hoặc tia gamma: đèn huỳnh quang",
    example: "đèn huỳnh quang",
  },
  {
    word: "huýt gió",
    part_of_speech: "động từ",
    meaning: "như huýt sáo: chúm miệng huýt gió",
    example: "chúm miệng huýt gió",
  },
  {
    word: "hừ",
    part_of_speech: "cảm từ",
    meaning:
      "(khẩu ngữ) tiếng giọng mũi thốt ra ở đầu hoặc cuối câu nói, biểu lộ sự bực tức, khó chịu: hừ, ông mà bắt được thì mày chết với ông!",
    example: "hừ, ông mà bắt được thì mày chết với ông!",
  },
  {
    word: "hứ",
    part_of_speech: "cảm từ",
    meaning:
      "(khẩu ngữ) tiếng giọng mũi thốt ra, biểu lộ sự ngạc nhiên, hoặc bất bình, phản đối: hứ, tưởng báu lắm đấy!",
    example: "hứ, tưởng báu lắm đấy!",
  },
  {
    word: "hư",
    part_of_speech: "tính từ",
    meaning:
      "(Nam) (đồ vật) hỏng, không dùng được nữa: chiếc đài đã bị hư * xe hư không đi được",
    example: "chiếc đài đã bị hư * xe hư không đi được",
  },
  {
    word: "hư",
    part_of_speech: "tính từ",
    meaning:
      '(thanh thiếu niên, trẻ em) có những tính xấu, tật xấu khó sửa: thằng bé dạo này sinh hư * "Cá không ăn muối cá ươn, Con cưỡng cha mẹ trăm đường con hư." (Cdao)',
    example:
      'thằng bé dạo này sinh hư * "Cá không ăn muối cá ươn, Con cưỡng cha mẹ trăm đường con hư." (Cdao)',
  },
  {
    word: "hư",
    part_of_speech: "tính từ",
    meaning:
      "không có, giả: không rõ thực hư * cảnh vật mờ ảo, như thực như hư",
    example: "không rõ thực hư * cảnh vật mờ ảo, như thực như hư",
  },
  {
    word: "huýt sáo",
    part_of_speech: "động từ",
    meaning:
      "chúm môi tròn lại, thổi hơi ra cho kêu thành tiếng như tiếng sáo: huýt sáo theo tiếng nhạc",
    example: "huýt sáo theo tiếng nhạc",
  },
  {
    word: "hư ảo",
    part_of_speech: "tính từ",
    meaning:
      "không có thực, chỉ có trong tưởng tượng: màn sương hư ảo * câu chuyện vừa hư ảo, vừa rất thật",
    example: "màn sương hư ảo * câu chuyện vừa hư ảo, vừa rất thật",
  },
  {
    word: "hư cấu",
    part_of_speech: "động từ",
    meaning:
      "tạo ra bằng tưởng tượng (thường do yêu cầu của sáng tác văn học - nghệ thuật): nghệ thuật hư cấu trong truyện cổ tích Việt Nam",
    example: "nghệ thuật hư cấu trong truyện cổ tích Việt Nam",
  },
  {
    word: "hư đốn",
    part_of_speech: "tính từ",
    meaning:
      "(thiếu niên, thanh niên) có phẩm chất, đạo đức kém, xấu đến mức nghiêm trọng: đồ hư đốn!",
    example: "đồ hư đốn!",
  },
  {
    word: "hử",
    part_of_speech: "trợ từ",
    meaning: "(khẩu ngữ) như hả: sao thế hử? * lại còn cãi hử?",
    example: "sao thế hử? * lại còn cãi hử?",
  },
  {
    word: "hư hại",
    part_of_speech: "tính từ",
    meaning: "bị hỏng và thiệt hại: trận bão làm hư hại mùa màng",
    example: "trận bão làm hư hại mùa màng",
  },
  {
    word: "hư hỏng",
    part_of_speech: "tính từ",
    meaning:
      "hỏng, không dùng được nữa (nói khái quát): nhà cửa dột nát, hư hỏng",
    example: "nhà cửa dột nát, hư hỏng",
  },
  {
    word: "hư hỏng",
    part_of_speech: "tính từ",
    meaning:
      "hư, có nhiều tính xấu, tật xấu (nói khái quát): những đứa trẻ hư hỏng",
    example: "những đứa trẻ hư hỏng",
  },
  {
    word: "hư nhược",
    part_of_speech: "động từ",
    meaning: "(cũ) như suy nhược: cơ thể hư nhược",
    example: "cơ thể hư nhược",
  },
  {
    word: "hư hao",
    part_of_speech: "tính từ",
    meaning: "bị hỏng và hao hụt đi: kho thóc bị hư hao vì chuột ăn",
    example: "kho thóc bị hư hao vì chuột ăn",
  },
  {
    word: "hư hư thực thực",
    part_of_speech: "",
    meaning:
      "không rõ ràng, thực hư lẫn lộn, khiến cho có cảm giác như mơ hồ, hoặc không biết đúng hay sai: câu chuyện hư hư thực thực",
    example: "câu chuyện hư hư thực thực",
  },
  {
    word: "hư danh",
    part_of_speech: "danh từ",
    meaning: "danh hão, không có thực: chuộng hư danh * chạy theo hư danh",
    example: "chuộng hư danh * chạy theo hư danh",
  },
  {
    word: "hừ hừ",
    part_of_speech: "tính từ",
    meaning: "từ mô phỏng tiếng rên mạnh, phát ra trầm và liên tục: rên hừ hừ",
    example: "rên hừ hừ",
  },
  {
    word: "hư không",
    part_of_speech: "tính từ",
    meaning:
      "hoàn toàn không có thật, không có gì cả: cõi hư không * những âm thanh be bé, mơ hồ, gần như hư không",
    example: "cõi hư không * những âm thanh be bé, mơ hồ, gần như hư không",
  },
  {
    word: "hư số",
    part_of_speech: "danh từ",
    meaning:
      "số không kèm theo tên của đơn vị đo lường hoặc tên vật; phân biệt với danh số: ,  * ,  *  là những hư số",
    example: ",  * ,  *  là những hư số",
  },
  {
    word: "hư thân",
    part_of_speech: "tính từ",
    meaning: "hư hỏng về đạo đức, lối sống: đứa trẻ hư thân * hư thân mất nết",
    example: "đứa trẻ hư thân * hư thân mất nết",
  },
  {
    word: "hứa",
    part_of_speech: "động từ",
    meaning:
      'nhận lời với ai đó một cách chắc chắn là sẽ làm việc gì đó: lời hứa * tự hứa với lòng mình * "Một lời đã hứa tào khang, Trăm năm ghi tạc nghĩa chàng, chàng ơi!" (Cdao)',
    example:
      'lời hứa * tự hứa với lòng mình * "Một lời đã hứa tào khang, Trăm năm ghi tạc nghĩa chàng, chàng ơi!" (Cdao)',
  },
  {
    word: "hư văn",
    part_of_speech: "danh từ",
    meaning: "văn chương phù phiếm, không thiết thực: không chuộng hư văn",
    example: "không chuộng hư văn",
  },
  {
    word: "hứa hôn",
    part_of_speech: "động từ",
    meaning: "hẹn ước sẽ kết hôn hoặc cho phép kết hôn: hai người đã hứa hôn",
    example: "hai người đã hứa hôn",
  },
  {
    word: "hư từ",
    part_of_speech: "danh từ",
    meaning:
      "từ không có chức năng định danh, không có khả năng độc lập làm thành phần câu, được dùng để biểu thị quan hệ ngữ pháp giữa các thực từ; phân biệt với thực từ: đã, đang, sẽ... là những hư từ",
    example: "đã, đang, sẽ... là những hư từ",
  },
  {
    word: "hư vinh",
    part_of_speech: "danh từ",
    meaning: "vinh dự hão: hám hư vinh",
    example: "hám hư vinh",
  },
  {
    word: "hư vô",
    part_of_speech: "",
    meaning:
      "có mà như không, thực mà như hư, đạo Lão dùng để chỉ bản thể của cái gọi là đạo, cơ sở vật chất đầu tiên của vũ trụ, đồng thời cũng là quy luật của giới tự nhiên, có ở khắp nơi, nhưng không có hình tượng để thấy được.",
    example: "cõi hư vô",
  },
  {
    word: "hứa hão",
    part_of_speech: "động từ",
    meaning: "hứa điều biết là không thực tế và sẽ không làm: toàn hứa hão!",
    example: "toàn hứa hão!",
  },
  {
    word: "hứng",
    part_of_speech: "danh từ",
    meaning:
      "cảm giác thích thú thấy trong người mình đang có một sức thôi thúc làm cái gì đó (thường là việc lao động sáng tạo) ° ‘Con cò mà đi ăn đêm...’ là câu hứng trong bài ca dao: tạo hứng * không có hứng làm việc",
    example: "tạo hứng * không có hứng làm việc",
  },
  {
    word: "hứng",
    part_of_speech: "danh từ",
    meaning:
      "phương thức biểu hiện của thơ ca, dùng hiện tượng xung quanh để gợi cảm xúc, tạo mối liên tưởng đến việc miêu tả sự vật hoặc bộc lộ tâm tình: ‘Con cò mà đi ăn đêm...’ là câu hứng trong bài ca dao",
    example: "‘Con cò mà đi ăn đêm...’ là câu hứng trong bài ca dao",
  },
  {
    word: "hứng",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái tâm lí thích thú, thấy thôi thúc muốn làm việc gì đó: hứng lên thì làm",
    example: "hứng lên thì làm",
  },
  {
    word: "hứng",
    part_of_speech: "động từ",
    meaning:
      'đón đỡ lấy, giữ lấy vật đang rơi xuống: hứng nước * "Giơ tay anh hứng sương trời, Rửa sao cho sạch những lời thị phi." (ca dao)',
    example:
      'hứng nước * "Giơ tay anh hứng sương trời, Rửa sao cho sạch những lời thị phi." (ca dao)',
  },
  {
    word: "hứng",
    part_of_speech: "động từ",
    meaning:
      "nhận lấy về mình một cách bị động cái từ đâu đến: hứng hậu quả * hứng lấy phần khó nhọc về mình",
    example: "hứng hậu quả * hứng lấy phần khó nhọc về mình",
  },
  {
    word: "hừm",
    part_of_speech: "cảm từ",
    meaning:
      "(khẩu ngữ) tiếng thốt ra ở đầu câu nói, biểu lộ sự bực tức hoặc đe doạ: hừm, cứ đợi đấy! * không nói gì, chỉ hừm một tiếng",
    example: "hừm, cứ đợi đấy! * không nói gì, chỉ hừm một tiếng",
  },
  {
    word: "hực",
    part_of_speech: "tính từ",
    meaning:
      "(lửa cháy, hơi nóng) bốc cao và mạnh: hơi nóng từ mặt đất hực lên",
    example: "hơi nóng từ mặt đất hực lên",
  },
  {
    word: "hửng",
    part_of_speech: "động từ",
    meaning: "(trời) bắt đầu hơi sáng lên: trời đã hửng sáng * hửng nắng",
    example: "trời đã hửng sáng * hửng nắng",
  },
  {
    word: "hứa hẹn",
    part_of_speech: "động từ",
    meaning:
      "hứa và hẹn (nói khái quát): hứa hẹn đủ điều * hai người đã hứa hẹn với nhau",
    example: "hứa hẹn đủ điều * hai người đã hứa hẹn với nhau",
  },
  {
    word: "hứa hẹn",
    part_of_speech: "động từ",
    meaning:
      "cho thấy trước, báo hiệu trước===== triển vọng tốt đẹp: hứa hẹn một vụ mùa bội thu * hứa hẹn một tương lai tươi sáng",
    example: "hứa hẹn một vụ mùa bội thu * hứa hẹn một tương lai tươi sáng",
  },
  {
    word: "hứa hẹn",
    part_of_speech: "danh từ",
    meaning: "triển vọng tốt đẹp: tương lai đầy hứa hẹn",
    example: "tương lai đầy hứa hẹn",
  },
  {
    word: "hứng chịu",
    part_of_speech: "động từ",
    meaning:
      "buộc phải nhận về phần mình điều không may, không tốt lành: hứng chịu tai hoạ * hứng chịu hậu quả",
    example: "hứng chịu tai hoạ * hứng chịu hậu quả",
  },
  {
    word: "hừng hực",
    part_of_speech: "tính từ",
    meaning:
      "bốc lên và toả ra mạnh mẽ: lửa cháy hừng hực * hừng hực khí thế * cơ thể hừng hực sức sống",
    example: "lửa cháy hừng hực * hừng hực khí thế * cơ thể hừng hực sức sống",
  },
  {
    word: "hững hờ",
    part_of_speech: "tính từ",
    meaning: "như hờ hững: hững hờ với danh lợi",
    example: "hững hờ với danh lợi",
  },
  {
    word: "hứng khởi",
    part_of_speech: "tính từ",
    meaning: "ở trạng thái có niềm vui làm nức lòng: lòng đầy hứng khởi",
    example: "lòng đầy hứng khởi",
  },
  {
    word: "hứng gió",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) hóng gió: ra bờ sông hứng gió",
    example: "ra bờ sông hứng gió",
  },
  {
    word: "hưng thịnh",
    part_of_speech: "tính từ",
    meaning:
      "phát đạt, thịnh vượng: cảnh nhà đang lúc hưng thịnh * thời kì hưng thịnh của triều Lý",
    example: "cảnh nhà đang lúc hưng thịnh * thời kì hưng thịnh của triều Lý",
  },
  {
    word: "hứng thú",
    part_of_speech: "danh từ",
    meaning:
      "sự ham thích: bộ phim gây được hứng thú cho người xem * mất hết cả hứng thú",
    example: "bộ phim gây được hứng thú cho người xem * mất hết cả hứng thú",
  },
  {
    word: "hứng thú",
    part_of_speech: "tính từ",
    meaning:
      "cảm thấy hào hứng, thích thú: hứng thú với quyển truyện mới * việc phải làm chứ chẳng hứng thú gì!",
    example:
      "hứng thú với quyển truyện mới * việc phải làm chứ chẳng hứng thú gì!",
  },
  {
    word: "hưng phấn",
    part_of_speech: "động từ",
    meaning:
      "(hệ thần kinh) đang ở trạng thái tăng cường hoạt động do có yếu tố kích thích: trạng thái hưng phấn * ức chế hưng phấn",
    example: "trạng thái hưng phấn * ức chế hưng phấn",
  },
  {
    word: "hưng hửng",
    part_of_speech: "động từ",
    meaning: "hửng lên chút ít: trời đã hưng hửng sáng",
    example: "trời đã hưng hửng sáng",
  },
  {
    word: "hượm",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) khoan đã, chờ một lát đã: gượm đã, làm gì mà vội thế? * gượm nào",
    example: "gượm đã, làm gì mà vội thế? * gượm nào",
  },
  {
    word: "hưng vượng",
    part_of_speech: "tính từ",
    meaning:
      "phát đạt, thịnh vượng: cảnh nhà đang lúc hưng thịnh * thời kì hưng thịnh của triều Lý",
    example: "cảnh nhà đang lúc hưng thịnh * thời kì hưng thịnh của triều Lý",
  },
  {
    word: "hưng vong",
    part_of_speech: "động từ",
    meaning:
      "ở trong quá trình thịnh vượng lên, rồi tiếp đó suy tàn, suy vong: sự hưng vong của một quốc gia",
    example: "sự hưng vong của một quốc gia",
  },
  {
    word: "hưởng",
    part_of_speech: "động từ",
    meaning:
      "có được cho mình, có được để sử dụng (cái do người khác hoặc xã hội mang lại, đưa đến): được hưởng quyền lợi * hưởng thành quả lao động",
    example: "được hưởng quyền lợi * hưởng thành quả lao động",
  },
  {
    word: "hườm",
    part_of_speech: "danh từ",
    meaning: "chỗ hoắm sâu: hườm núi",
    example: "hườm núi",
  },
  {
    word: "hườm",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) (quả cây) mới chín tới, da hơi đỏ hoặc chưa vàng, chưa đỏ đều, vàng đều: chuối chín hườm * đu đủ mới hườm, chưa chín",
    example: "chuối chín hườm * đu đủ mới hườm, chưa chín",
  },
  {
    word: "hương",
    part_of_speech: "danh từ",
    meaning:
      "mùi thơm của hoa: hương hoa thơm ngát * bông hoa hữu sắc nhưng vô hương",
    example: "hương hoa thơm ngát * bông hoa hữu sắc nhưng vô hương",
  },
  {
    word: "hương",
    part_of_speech: "danh từ",
    meaning:
      "vật phẩm làm bằng nguyên liệu có tinh dầu, khi đốt toả khói thơm, thường dùng trong việc cúng lễ: thắp hương * đốt một nén hương",
    example: "thắp hương * đốt một nén hương",
  },
  {
    word: "hương",
    part_of_speech: "danh từ",
    meaning:
      "hương vị riêng: chè đã mất hương * không khí tràn ngập hương xuân",
    example: "chè đã mất hương * không khí tràn ngập hương xuân",
  },
  {
    word: "hương ẩm",
    part_of_speech: "động từ",
    meaning:
      "(cũ) cùng nhau ăn uống, sau các cuộc tế lễ ở nông thôn, theo tục lệ thời trước: tục hương ẩm",
    example: "tục hương ẩm",
  },
  {
    word: "hướng",
    part_of_speech: "danh từ",
    meaning:
      "một trong những phía chính của không gian: nhà hướng nam * ăn trông nồi, ngồi trông hướng (tng)",
    example: "nhà hướng nam * ăn trông nồi, ngồi trông hướng (tng)",
  },
  {
    word: "hướng",
    part_of_speech: "danh từ",
    meaning:
      "con đường thẳng về một phía nhất định nào đó: hướng đi * gió đổi hướng * con tàu đi đúng hướng",
    example: "hướng đi * gió đổi hướng * con tàu đi đúng hướng",
  },
  {
    word: "hướng",
    part_of_speech: "động từ",
    meaning:
      "quay về hoặc làm cho quay về một phía nhất định nào đó: mắt hướng lên lá cờ tổ quốc * hướng mọi người tới vấn đề chính",
    example: "mắt hướng lên lá cờ tổ quốc * hướng mọi người tới vấn đề chính",
  },
  {
    word: "hương dõng",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) lính địa phương ở làng xã thời phong kiến, thực dân: thành lập đội hương dõng",
    example: "thành lập đội hương dõng",
  },
  {
    word: "hướng dẫn",
    part_of_speech: "động từ",
    meaning:
      "chỉ bảo, dẫn dắt cho biết phương hướng và cách thức tiến hành một hoạt động nào đó: bảng hướng dẫn tra cứu sách * hướng dẫn làm bài tập",
    example: "bảng hướng dẫn tra cứu sách * hướng dẫn làm bài tập",
  },
  {
    word: "hướng dẫn viên",
    part_of_speech: "danh từ",
    meaning: "người làm nhiệm vụ hướng dẫn: hướng dẫn viên du lịch",
    example: "hướng dẫn viên du lịch",
  },
  {
    word: "hưởng dương",
    part_of_speech: "động từ",
    meaning:
      "(Trang trọng) đã được sống trên cõi đời (thường nói về người chết trẻ): ông cụ đã ra đi, hưởng dương 80 tuổi",
    example: "ông cụ đã ra đi, hưởng dương 80 tuổi",
  },
  {
    word: "hướng đạo",
    part_of_speech: "động từ",
    meaning:
      "(cũ) đi trước dẫn đường cho người khác theo: người hướng đạo * đóng vai trò hướng đạo trong cuộc khởi nghĩa",
    example: "người hướng đạo * đóng vai trò hướng đạo trong cuộc khởi nghĩa",
  },
  {
    word: "hướng đạo",
    part_of_speech: "danh từ",
    meaning: "(cũ) người dẫn đường: hướng đạo của đoàn thám hiểm",
    example: "hướng đạo của đoàn thám hiểm",
  },
  {
    word: "hương khói",
    part_of_speech: "danh từ",
    meaning:
      "hương và khói; dùng để chỉ việc thờ cúng (nói khái quát): lo việc hương khói * hương khói phụng thờ",
    example: "lo việc hương khói * hương khói phụng thờ",
  },
  {
    word: "hương hoa",
    part_of_speech: "danh từ",
    meaning:
      "đồ cúng lễ, như hương, hoa, v.v. (nói khái quát): dâng hương hoa lễ Phật",
    example: "dâng hương hoa lễ Phật",
  },
  {
    word: "hương hoả",
    part_of_speech: "danh từ",
    meaning: "việc thờ cúng tổ tiên: chăm lo việc hương hoả",
    example: "chăm lo việc hương hoả",
  },
  {
    word: "hương hoả",
    part_of_speech: "danh từ",
    meaning:
      "phần gia tài dành riêng cho việc cúng lễ tổ tiên: đất hương hoả * được ăn hương hoả",
    example: "đất hương hoả * được ăn hương hoả",
  },
  {
    word: "hưởng lạc",
    part_of_speech: "động từ",
    meaning:
      "hưởng thú vui vật chất tầm thường, không lành mạnh: lối sống hưởng lạc * ăn chơi hưởng lạc",
    example: "lối sống hưởng lạc * ăn chơi hưởng lạc",
  },
  {
    word: "hương hồn",
    part_of_speech: "danh từ",
    meaning:
      "(trang trọng) linh hồn người đã chết: kính cẩn nghiêng mình trước hương hồn người đã khuất",
    example: "kính cẩn nghiêng mình trước hương hồn người đã khuất",
  },
  {
    word: "hương lửa",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) tình cảm thắm thiết, nồng nàn giữa vợ và chồng: ba sinh hương lửa * "Nửa năm hương lửa đương nồng, Trượng phu thoắt đã động lòng bốn phương." (TKiều)',
    example:
      'ba sinh hương lửa * "Nửa năm hương lửa đương nồng, Trượng phu thoắt đã động lòng bốn phương." (TKiều)',
  },
  {
    word: "hương lộ",
    part_of_speech: "danh từ",
    meaning:
      "đường giao thông giữa các làng xã, nói chung; phân biệt với tỉnh lộ, quốc lộ: nâng cấp hương lộ",
    example: "nâng cấp hương lộ",
  },
  {
    word: "hương liệu",
    part_of_speech: "danh từ",
    meaning:
      "chất thơm dùng làm nguyên liệu chế tạo mĩ phẩm, dược liệu, v.v.: trầm là loại hương liệu quý",
    example: "trầm là loại hương liệu quý",
  },
  {
    word: "hướng nghiệp",
    part_of_speech: "động từ",
    meaning:
      "thi hành những biện pháp nhằm bảo đảm sự phân bố tối ưu (có chú ý tới năng khiếu, năng lực, thể lực) người dân theo ngành và loại lao động.",
    example: "hướng nghiệp cho thanh niên",
  },
  {
    word: "hướng ngoại",
    part_of_speech: "động từ",
    meaning:
      "hướng ra bên ngoài bản thân mình; đối lập với hướng nội: xu thế hướng ngoại * tính hướng ngoại",
    example: "xu thế hướng ngoại * tính hướng ngoại",
  },
  {
    word: "hướng ngoại",
    part_of_speech: "động từ",
    meaning:
      "hướng ra nước ngoài, coi trọng việc quan hệ, buôn bán với nước ngoài hơn trong nước: thị trường hướng ngoại * nền kinh tế mở và hướng ngoại",
    example: "thị trường hướng ngoại * nền kinh tế mở và hướng ngoại",
  },
  {
    word: "hương nguyền",
    part_of_speech: "danh từ",
    meaning:
      'nén hương thắp lúc thề nguyền: "Mái tây để lạnh hương nguyền, Cho duyên đằm thắm ra duyên bẽ bàng." (TKiều)',
    example:
      'Mái tây để lạnh hương nguyền, Cho duyên đằm thắm ra duyên bẽ bàng." (TKiều)',
  },
  {
    word: "hướng nội",
    part_of_speech: "động từ",
    meaning:
      "hướng vào bên trong của bản thân mình; đối lập với hướng ngoại: sống hướng nội",
    example: "sống hướng nội",
  },
  {
    word: "hướng nội",
    part_of_speech: "động từ",
    meaning:
      "hướng vào trong nước, coi trọng việc phát triển trong nước hơn việc quan hệ, buôn bán với nước ngoài: chính sách hướng nội * kêu gọi các nhà đầu tư hướng nội",
    example: "chính sách hướng nội * kêu gọi các nhà đầu tư hướng nội",
  },
  {
    word: "hương sắc",
    part_of_speech: "danh từ",
    meaning: "(hiếm) hương vị đặc sắc riêng: hương sắc đồng quê",
    example: "hương sắc đồng quê",
  },
  {
    word: "hướng tâm",
    part_of_speech: "động từ",
    meaning: "hướng vào tâm của vòng tròn: lực hướng tâm * gia tốc hướng tâm",
    example: "lực hướng tâm * gia tốc hướng tâm",
  },
  {
    word: "hương sư",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) thầy giáo trường làng thời Pháp thuộc: bổ hương sư về dạy học",
    example: "bổ hương sư về dạy học",
  },
  {
    word: "hương quan",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) quê hương, trong quan hệ với người đi xa: "Sầu li biệt chảy đầy hai mắt, Bóng hương quan xa khuất dặm ngàn." (TDLH)',
    example:
      'Sầu li biệt chảy đầy hai mắt, Bóng hương quan xa khuất dặm ngàn." (TDLH)',
  },
  {
    word: "hưởng thọ",
    part_of_speech: "động từ",
    meaning:
      "(Trang trọng) đã được thọ (bao nhiêu tuổi trước khi mất): cụ vừa mất, hưởng thọ 80 tuổi",
    example: "cụ vừa mất, hưởng thọ 80 tuổi",
  },
  {
    word: "hương thôn",
    part_of_speech: "danh từ",
    meaning: "(cũ) làng xóm, thôn quê: những hủ tục ở chốn hương thôn",
    example: "những hủ tục ở chốn hương thôn",
  },
  {
    word: "hướng thiện",
    part_of_speech: "động từ",
    meaning:
      "hướng đến điều thiện: có lòng hướng thiện * tính hướng thiện của tôn giáo",
    example: "có lòng hướng thiện * tính hướng thiện của tôn giáo",
  },
  {
    word: "hưởng thụ",
    part_of_speech: "động từ",
    meaning:
      "hưởng của xã hội, trong quan hệ với cống hiến: chưa làm đã đòi hưởng thụ * lối sống hưởng thụ",
    example: "chưa làm đã đòi hưởng thụ * lối sống hưởng thụ",
  },
  {
    word: "hưởng ứng",
    part_of_speech: "động từ",
    meaning:
      "đáp lại và tỏ sự đồng tình ủng hộ bằng hành động: hưởng ứng lời kêu gọi * hưởng ứng phong trào",
    example: "hưởng ứng lời kêu gọi * hưởng ứng phong trào",
  },
  {
    word: "hương vị",
    part_of_speech: "danh từ",
    meaning: "mùi vị thơm: chén trà đậm đà hương vị",
    example: "chén trà đậm đà hương vị",
  },
  {
    word: "hương vị",
    part_of_speech: "danh từ",
    meaning:
      "nét đặc trưng của sự vật mang lại cho con người một cảm giác dễ chịu: hương vị ngày Tết",
    example: "hương vị ngày Tết",
  },
  {
    word: "hương ước",
    part_of_speech: "danh từ",
    meaning: "luật lệ ở làng xã, do dân làng đặt ra: lập hương ước",
    example: "lập hương ước",
  },
  {
    word: "hữu",
    part_of_speech: "danh từ",
    meaning:
      "bên phải, trong quan hệ đối lập với tả là bên trái: hai bên tả hữu * tả xung hữu đột (tng)",
    example: "hai bên tả hữu * tả xung hữu đột (tng)",
  },
  {
    word: "hữu",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận thiên về bảo thủ, thoả hiệp hay phản cách mạng trong nghị viện hoặc trong các tổ chức chính trị ở một số nước, trong quan hệ đối lập với tả là bộ phận thiên về tiến bộ, về cách mạng: cánh hữu của một đảng",
    example: "cánh hữu của một đảng",
  },
  {
    word: "hữu",
    part_of_speech: "danh từ",
    meaning:
      'yếu tố gốc Hán dùng ghép trước để cấu tạo tính từ, với nghĩa là "có", như: hữu hạn, hữu lí, hữu tình, v.v.; đối lập với vô.',
    example: "hữu hạn, hữu lí, hữu tình",
  },
  {
    word: "hưu",
    part_of_speech: "động từ",
    meaning:
      "hưu trí (nói tắt): về hưu * sắp đến tuổi nghỉ hưu * đi lĩnh lương hưu",
    example: "về hưu * sắp đến tuổi nghỉ hưu * đi lĩnh lương hưu",
  },
  {
    word: "hữu dụng",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) dùng được, làm được việc, không phải là vô ích: vật hữu dụng * con người hữu dụng",
    example: "vật hữu dụng * con người hữu dụng",
  },
  {
    word: "hữu dũng vô mưu",
    part_of_speech: "",
    meaning:
      "chỉ có sức mạnh, cốt cậy vào sức mạnh, không có mưu trí gì: một viên tướng hữu dũng vô mưu",
    example: "một viên tướng hữu dũng vô mưu",
  },
  {
    word: "hữu cơ",
    part_of_speech: "tính từ",
    meaning:
      "thuộc giới sinh vật mang đặc thù của những vật có cơ quan thực hiện chức năng sống: thế giới hữu cơ",
    example: "thế giới hữu cơ",
  },
  {
    word: "hữu cơ",
    part_of_speech: "tính từ",
    meaning:
      "có quan hệ không thể tách rời nhau để tồn tại hoặc hoạt động: sự gắn bó hữu cơ * mối quan hệ hữu cơ",
    example: "sự gắn bó hữu cơ * mối quan hệ hữu cơ",
  },
  {
    word: "hữu hảo",
    part_of_speech: "tính từ",
    meaning: "(cũ) như hữu nghị: quan hệ hữu hảo",
    example: "quan hệ hữu hảo",
  },
  {
    word: "hữu hạn",
    part_of_speech: "tính từ",
    meaning: "có giới hạn nhất định, có hạn: sức người là hữu hạn",
    example: "sức người là hữu hạn",
  },
  {
    word: "hữu hiệu",
    part_of_speech: "tính từ",
    meaning:
      "có hiệu quả, có hiệu lực: giải pháp hữu hiệu * phương thuốc hữu hiệu",
    example: "giải pháp hữu hiệu * phương thuốc hữu hiệu",
  },
  {
    word: "hữu ích",
    part_of_speech: "tính từ",
    meaning: "có ích lợi: trở thành một con người hữu ích",
    example: "trở thành một con người hữu ích",
  },
  {
    word: "hữu hình",
    part_of_speech: "tính từ",
    meaning: "có hình thể rõ ràng: vật thể hữu hình * thế giới hữu hình",
    example: "vật thể hữu hình * thế giới hữu hình",
  },
  {
    word: "hữu quan",
    part_of_speech: "tính từ",
    meaning:
      "có liên quan đến, có dính dáng đến sự việc, vấn đề được nói đến: các bên hữu quan * cơ quan hữu quan",
    example: "các bên hữu quan * cơ quan hữu quan",
  },
  {
    word: "hữu nghị",
    part_of_speech: "tính từ",
    meaning:
      "thân thiện, có tính chất bè bạn (thường nói về quan hệ giữa các nước): thắt chặt mối quan hệ hữu nghị giữa hai nước * chuyến thăm hữu nghị",
    example:
      "thắt chặt mối quan hệ hữu nghị giữa hai nước * chuyến thăm hữu nghị",
  },
  {
    word: "hữu sinh",
    part_of_speech: "tính từ",
    meaning: "có sự sống: thế giới hữu sinh",
    example: "thế giới hữu sinh",
  },
  {
    word: "hữu ngạn",
    part_of_speech: "danh từ",
    meaning:
      "bờ bên phải của sông, nhìn theo hướng nước chảy từ nguồn xuống; đối lập với tả ngạn: nhà bên phía hữu ngạn sông Hồng",
    example: "nhà bên phía hữu ngạn sông Hồng",
  },
  {
    word: "hữu thanh",
    part_of_speech: "tính từ",
    meaning:
      "có sự tham gia của dây thanh trong quá trình phát âm phụ âm (các dây thanh rung lên đều đặn khi phát âm); phân biệt với vô thanh: b, đ, m, n, trong tiếng Việt là những phụ âm hữu thanh trong tiếng Việt",
    example:
      "b, đ, m, n, trong tiếng Việt là những phụ âm hữu thanh trong tiếng Việt",
  },
  {
    word: "hữu khuynh",
    part_of_speech: "tính từ",
    meaning:
      "có khuynh hướng chính trị thiên về bảo thủ, thoả hiệp, không triệt để cách mạng; đối lập với tả khuynh: tư tưởng hữu khuynh",
    example: "tư tưởng hữu khuynh",
  },
  {
    word: "hữu tỉ",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi chung các số nguyên và các phân số (dương, âm hoặc bằng không): các số 1, -5, L, 0 là những số hữu tỉ",
    example: "các số 1, -5, L, 0 là những số hữu tỉ",
  },
  {
    word: "hữu tuyến",
    part_of_speech: "danh từ",
    meaning:
      "phương thức truyền tín hiệu đi xa bằng đường dây; phân biệt với vô tuyến: mạng thông tin hữu tuyến",
    example: "mạng thông tin hữu tuyến",
  },
  {
    word: "hưu trí",
    part_of_speech: "động từ",
    meaning:
      "nghỉ làm việc có hưởng tiền cấp định kì, khi đã phục vụ đủ thời gian theo quy định: đã đến tuổi hưu trí * cán bộ hưu trí * sổ hưu trí",
    example: "đã đến tuổi hưu trí * cán bộ hưu trí * sổ hưu trí",
  },
  {
    word: "hữu tình",
    part_of_speech: "tính từ",
    meaning: "(cảnh vật) có sức hấp dẫn, gợi cảm: cảnh sơn thuỷ hữu tình",
    example: "cảnh sơn thuỷ hữu tình",
  },
  {
    word: "hữu tình",
    part_of_speech: "tính từ",
    meaning:
      'có tình ý, chứa đựng nhiều tình cảm: lời nói hữu tình * "Hữu tình chi bấy Ngưu lang, Tấm lòng Chức Nữ vì chàng mà nghiêng." (LVT)',
    example:
      'lời nói hữu tình * "Hữu tình chi bấy Ngưu lang, Tấm lòng Chức Nữ vì chàng mà nghiêng." (LVT)',
  },
  {
    word: "hữu tỷ",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi chung các số nguyên và các phân số (dương, âm hoặc bằng không): các số 1, -5, L, 0 là những số hữu tỉ",
    example: "các số 1, -5, L, 0 là những số hữu tỉ",
  },
  {
    word: "hữu trách",
    part_of_speech: "tính từ",
    meaning:
      "có trách nhiệm đối với sự việc, vấn đề có liên quan: cơ quan hữu trách",
    example: "cơ quan hữu trách",
  },
  {
    word: "hy hữu",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) hiếm có, hiếm thấy: một trường hợp hi hữu * hi hữu lắm mới có chuyện đó xảy ra",
    example: "một trường hợp hi hữu * hi hữu lắm mới có chuyện đó xảy ra",
  },
  {
    word: "hý",
    part_of_speech: "động từ",
    meaning: "(ngựa) kêu: tiếng ngựa hí",
    example: "tiếng ngựa hí",
  },
  {
    word: "hỷ",
    part_of_speech: "động từ",
    meaning:
      "thở hắt mạnh ra đằng mũi để đẩy nước mũi hoặc chất bẩn trong mũi ra ngoài: hỉ mũi",
    example: "hỉ mũi",
  },
  {
    word: "hỷ",
    part_of_speech: "danh từ",
    meaning:
      "việc vui, mừng (thường là việc cưới xin): việc hiếu, việc hỉ * giấy báo hỉ",
    example: "việc hiếu, việc hỉ * giấy báo hỉ",
  },
  {
    word: "hỷ",
    part_of_speech: "trợ từ",
    meaning: "(Phương ngữ) như hả (ng2): ai đó hỉ? * răng mi biết hỉ?",
    example: "ai đó hỉ? * răng mi biết hỉ?",
  },
  {
    word: "hỷ",
    part_of_speech: "trợ từ",
    meaning: "như nhỉ: sao lại như thế hỉ?",
    example: "sao lại như thế hỉ?",
  },
  {
    word: "hy sinh",
    part_of_speech: "động từ",
    meaning:
      "tự nguyện nhận về mình sự thiệt thòi, mất mát lớn lao nào đó, vì một cái gì cao đẹp: hi sinh lợi ích cá nhân * hi sinh cả tuổi xuân cho đất nước",
    example: "hi sinh lợi ích cá nhân * hi sinh cả tuổi xuân cho đất nước",
  },
  {
    word: "hy sinh",
    part_of_speech: "động từ",
    meaning:
      "chết vì đất nước, vì nghĩa vụ và lí tưởng cao đẹp: hi sinh ngoài chiến trường",
    example: "hi sinh ngoài chiến trường",
  },
  {
    word: "hy sinh",
    part_of_speech: "danh từ",
    meaning: "sự hi sinh: chấp nhận mọi hi sinh",
    example: "chấp nhận mọi hi sinh",
  },
  {
    word: "hữu ý",
    part_of_speech: "tính từ",
    meaning:
      "(việc làm, lời nói) có chủ ý, có ý định hẳn hoi: chuyện đó xảy ra không biết do vô tình hay hữu ý",
    example: "chuyện đó xảy ra không biết do vô tình hay hữu ý",
  },
  {
    word: "hy vọng",
    part_of_speech: "động từ",
    meaning:
      "tin tưởng và mong chờ điều tốt đẹp đến: hi vọng có ngày gặp lại * hi vọng nhiều ở thế hệ trẻ",
    example: "hi vọng có ngày gặp lại * hi vọng nhiều ở thế hệ trẻ",
  },
  {
    word: "hy vọng",
    part_of_speech: "danh từ",
    meaning: "niềm hi vọng: nuôi hi vọng * lòng tràn trề hi vọng",
    example: "nuôi hi vọng * lòng tràn trề hi vọng",
  },
  {
    word: "hỷ xả",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) quên mình đi một cách vui vẻ, theo quan niệm của đạo Phật: lòng từ bi hỉ xả",
    example: "lòng từ bi hỉ xả",
  },
  {
    word: "hỷ xả",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) vui lòng bỏ qua, vui lòng tha thứ: cháu nó đã biết lỗi, mong bác hỉ xả cho",
    example: "cháu nó đã biết lỗi, mong bác hỉ xả cho",
  },
  {
    word: "ì",
    part_of_speech: "động từ",
    meaning:
      "ở nguyên tại chỗ, không hề nhúc nhích, mặc dù bị đẩy hoặc kéo mạnh: cái xe cứ ì ra, không chịu di chuyển",
    example: "cái xe cứ ì ra, không chịu di chuyển",
  },
  {
    word: "ì",
    part_of_speech: "động từ",
    meaning:
      "giữ nguyên trạng thái, thái độ, không hề thay đổi, kể cả khi có tác động mạnh từ bên ngoài: nằm ì một chỗ * ai nói gì cũng ì ra",
    example: "nằm ì một chỗ * ai nói gì cũng ì ra",
  },
  {
    word: "ị",
    part_of_speech: "tính từ",
    meaning:
      "béo đến mức thịt như chảy xệ xuống (hàm ý chê): béo ị * người càng ngày càng ị ra",
    example: "béo ị * người càng ngày càng ị ra",
  },
  {
    word: "ỉ eo",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả những âm thanh nhỏ và kéo dài, gây cảm giác sốt ruột, khó chịu: ỉ eo xin tiền * khóc ỉ eo",
    example: "ỉ eo xin tiền * khóc ỉ eo",
  },
  {
    word: "ì ầm",
    part_of_speech: "động từ",
    meaning:
      "từ mô phỏng tiếng động trầm và kéo dài, lúc to lúc nhỏ không đều nhau từ xa vọng lại: sóng biển ì ầm * súng nổ ì ầm suốt ngày",
    example: "sóng biển ì ầm * súng nổ ì ầm suốt ngày",
  },
  {
    word: "ì ạch",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng thở ngắt quãng, nặng nề và khó nhọc: vừa làm vừa thở ì ạch",
    example: "vừa làm vừa thở ì ạch",
  },
  {
    word: "ì ạch",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả dáng vẻ khó nhọc, nặng nề trong hoạt động, chuyển động, thường do phải mang vác nặng: chiếc xe ì ạch bò lên dốc",
    example: "chiếc xe ì ạch bò lên dốc",
  },
  {
    word: "í ới",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng nhiều người gọi nhau ồn ào, nghe không rõ lắm: gọi nhau í ới",
    example: "gọi nhau í ới",
  },
  {
    word: "i tờ",
    part_of_speech: "danh từ",
    meaning:
      "chữ i và chữ t (những chữ đầu tiên dạy cho người bắt đầu học chữ, theo cách dạy của bình dân học vụ); thường dùng để chỉ những bài học chữ quốc ngữ đầu tiên: học i tờ * dạy lớp i tờ",
    example: "học i tờ * dạy lớp i tờ",
  },
  {
    word: "i tờ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có trình độ hiểu biết còn rất hạn chế, có thể nói là chưa biết gì: trình độ i tờ",
    example: "trình độ i tờ",
  },
  {
    word: "ì oạp",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng nước vỗ mạnh và liên tiếp vào vật cứng, âm thanh lúc to lúc nhỏ%: sóng vỗ ì oạp",
    example: "sóng vỗ ì oạp",
  },
  {
    word: "i-nốc",
    part_of_speech: "danh từ",
    meaning: "(Khẩu ngữ) thép không gỉ: đồng hồ vỏ inox",
    example: "đồng hồ vỏ inox",
  },
  {
    word: "ỉ ê",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả tiếng khóc nhỏ, dai dẳng và ỉ eo một cách khó chịu (thường nói về trẻ con): thằng bé đói sữa khóc ỉ ê suốt ngày",
    example: "thằng bé đói sữa khóc ỉ ê suốt ngày",
  },
  {
    word: "ì xèo",
    part_of_speech: "động từ",
    meaning:
      "bàn tán nhỏ to qua lại: hàng xóm ì xèo * những lời thắc mắc ì xèo",
    example: "hàng xóm ì xèo * những lời thắc mắc ì xèo",
  },
  {
    word: "ì xèo",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) phô trương, ồn ào quá mức: một đám cưới rình rang, ì xèo * ăn nhậu ì xèo",
    example: "một đám cưới rình rang, ì xèo * ăn nhậu ì xèo",
  },
  {
    word: "ỉa",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) thải phân ra ngoài cơ thể qua hậu môn: đi ỉa",
    example: "đi ỉa",
  },
  {
    word: "ích mẫu",
    part_of_speech: "danh từ",
    meaning:
      "cây thân cỏ cùng họ với bạc hà, lá hình chân vịt mọc đối, hoa màu đỏ hay tím, thân, lá và quả dùng làm thuốc: cao ích mẫu",
    example: "cao ích mẫu",
  },
  {
    word: "ích kỷ",
    part_of_speech: "tính từ",
    meaning:
      "chỉ nghĩ đến, chỉ vì lợi cho riêng mình mà không biết đến người khác: tính rất ích kỉ * con người ích kỉ",
    example: "tính rất ích kỉ * con người ích kỉ",
  },
  {
    word: "ích kỉ",
    part_of_speech: "tính từ",
    meaning:
      "chỉ nghĩ đến, chỉ vì lợi cho riêng mình mà không biết đến người khác: tính rất ích kỉ * con người ích kỉ",
    example: "tính rất ích kỉ * con người ích kỉ",
  },
  {
    word: "ích",
    part_of_speech: "",
    meaning:
      "cái có lợi, có tác dụng, hiệu quả tốt: loài chim có ích * sống có ích * việc đã lỡ rồi, có tiếc cũng không ích gì!",
    example:
      "loài chim có ích * sống có ích * việc đã lỡ rồi, có tiếc cũng không ích gì!",
  },
  {
    word: "ích lợi",
    part_of_speech: "",
    meaning:
      "điều có ích, có lợi (nói khái quát): ích lợi của sự học * việc làm đó, chẳng ích lợi gì!",
    example: "ích lợi của sự học * việc làm đó, chẳng ích lợi gì!",
  },
  {
    word: "im ả",
    part_of_speech: "tính từ",
    meaning: "ở trạng thái yên tĩnh, đem lại cảm giác dễ chịu: trưa hè im ả",
    example: "trưa hè im ả",
  },
  {
    word: "im bặt",
    part_of_speech: "tính từ",
    meaning:
      "im hẳn một cách đột ngột: tiếng súng im bặt * tiếng ồn ào bỗng dưng im bặt",
    example: "tiếng súng im bặt * tiếng ồn ào bỗng dưng im bặt",
  },
  {
    word: "im lặng",
    part_of_speech: "",
    meaning: "im, không nói, không phát ra tiếng động: im lặng quan sát",
    example: "im lặng quan sát",
  },
  {
    word: "im lặng",
    part_of_speech: "",
    meaning:
      "không có một hành động hay phản ứng gì trước sự việc đáng lẽ phải tỏ thái độ, phải có phản ứng: không thể im lặng trước hành vi ngang ngược",
    example: "không thể im lặng trước hành vi ngang ngược",
  },
  {
    word: "im",
    part_of_speech: "",
    meaning:
      "ở trạng thái không có biểu hiện của hoạt động, không có sự di động, di chuyển: đứng im * nằm im, không động đậy * trời im gió",
    example: "đứng im * nằm im, không động đậy * trời im gió",
  },
  {
    word: "im",
    part_of_speech: "",
    meaning:
      "ở trạng thái không có tiếng động phát ra: thằng bé đã im, không khóc nữa * lớp học im phăng phắc",
    example: "thằng bé đã im, không khóc nữa * lớp học im phăng phắc",
  },
  {
    word: "im ỉm",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái hoàn toàn không có tiếng động phát ra,tựa như không có một biểu hiện nào của hoạt động: cửa đóng im ỉm * im ỉm như miệng hến",
    example: "cửa đóng im ỉm * im ỉm như miệng hến",
  },
  {
    word: "ỉm",
    part_of_speech: "động từ",
    meaning:
      "giấu đi, không để lộ ra, không cho ai biết, khiến cho người ta tưởng là không có chuyện gì xảy ra: ỉm thư * ỉm đơn khiếu nại * ỉm chuyện",
    example: "ỉm thư * ỉm đơn khiếu nại * ỉm chuyện",
  },
  {
    word: "im lìm",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái hoàn toàn không có tiếng động, tựa như không có biểu hiện gì của sự sống: ngồi im lìm như pho tượng * tứ bề vắng vẻ, im lìm",
    example: "ngồi im lìm như pho tượng * tứ bề vắng vẻ, im lìm",
  },
  {
    word: "im ắng",
    part_of_speech: "tính từ",
    meaning: "như yên ắng: bốn bề im ắng",
    example: "bốn bề im ắng",
  },
  {
    word: "im phắc",
    part_of_speech: "tính từ",
    meaning:
      "lặng im, không một tiếng nói, không một tiếng động: cả khán phòng im phắc lắng nghe",
    example: "cả khán phòng im phắc lắng nghe",
  },
  {
    word: "im phăng phắc",
    part_of_speech: "tính từ",
    meaning: "hoàn toàn im lặng, không có một tiếng động: bốn bề im phăng phắc",
    example: "bốn bề im phăng phắc",
  },
  {
    word: "in",
    part_of_speech: "động từ",
    meaning:
      "tạo ra nhiều bản bằng các phương pháp, công nghệ khác nhau: khắc bản in * vải in hoa * giống như in (b)",
    example: "khắc bản in * vải in hoa * giống như in (b)",
  },
  {
    word: "in",
    part_of_speech: "động từ",
    meaning:
      "hằn sâu, đến mức khó có thể phai mờ trong tâm trí%: nhớ như in * in sâu kỉ niệm",
    example: "nhớ như in * in sâu kỉ niệm",
  },
  {
    word: "im re",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) im lặng, không dám có thái độ hoặc phản ứng gì: bị quát một tiếng thì im re * ngồi im re",
    example: "bị quát một tiếng thì im re * ngồi im re",
  },
  {
    word: "im thít",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) im lặng hoàn toàn, không nói năng, không để có một tiếng động nào phát ra cả (thường do sợ hoặc do đuối lí): sợ quá, ngồi im thít",
    example: "sợ quá, ngồi im thít",
  },
  {
    word: "in ấn",
    part_of_speech: "động từ",
    meaning: "in (nói khái quát): in ấn sách báo * công nghệ in ấn",
    example: "in ấn sách báo * công nghệ in ấn",
  },
  {
    word: "in ít",
    part_of_speech: "tính từ",
    meaning: "hơi ít: có ngần này thì hơi in ít",
    example: "có ngần này thì hơi in ít",
  },
  {
    word: "im thin thít",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) như im thít (nhưng ý nhấn mạnh hơn): nằm im thin thít, không dám cử động",
    example: "nằm im thin thít, không dám cử động",
  },
  {
    word: "ỉn",
    part_of_speech: "động từ",
    meaning:
      "từ mô phỏng tiếng lợn kêu nhỏ khi đòi ăn: con lợn đói cứ chốc chốc lại ỉn lên một tiếng",
    example: "con lợn đói cứ chốc chốc lại ỉn lên một tiếng",
  },
  {
    word: "in hệt",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) giống hệt nhau, giống như in: hai bức tranh in hệt nhau",
    example: "hai bức tranh in hệt nhau",
  },
  {
    word: "in ỉn",
    part_of_speech: "động từ",
    meaning: "như ỉn (nhưng với ý liên tiếp): con lợn kêu in ỉn",
    example: "con lợn kêu in ỉn",
  },
  {
    word: "ìn ịt",
    part_of_speech: "động từ",
    meaning: "như ịt (nhưng với ý liên tiếp): tiếng lợn ìn ịt trong chuồng",
    example: "tiếng lợn ìn ịt trong chuồng",
  },
  {
    word: "in như",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) giống hệt như: hai đứa in như nhau, từ vóc dáng đến tính tình",
    example: "hai đứa in như nhau, từ vóc dáng đến tính tình",
  },
  {
    word: "inch",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị đo độ dài của nước Anh và các nước nói tiếng Anh, bằng 2,54cm: ti vi 21 inch",
    example: "ti vi 21 inch",
  },
  {
    word: "inh",
    part_of_speech: "tính từ",
    meaning:
      '(âm thanh) vang và to đến mức chói tai, gây cảm giác khó chịu: thấy động, đàn chó sủa inh lên * "Khắp làng đồn inh lên rằng anh Tại bây giờ giầu sang lắm." (THoài; 24)',
    example:
      'thấy động, đàn chó sủa inh lên * "Khắp làng đồn inh lên rằng anh Tại bây giờ giầu sang lắm." (THoài; 24)',
  },
  {
    word: "inh",
    part_of_speech: "tính từ",
    meaning: "(mùi khai, thối) xông lên mạnh và toả rộng ra: thối inh cả nhà",
    example: "thối inh cả nhà",
  },
  {
    word: "ình oàng",
    part_of_speech: "động từ",
    meaning:
      "từ mô phỏng tiếng động liên tiếp, to và rền: tiếng sấm ình oàng * đại bác ình oàng suốt đêm",
    example: "tiếng sấm ình oàng * đại bác ình oàng suốt đêm",
  },
  {
    word: "inh tai nhức óc",
    part_of_speech: "",
    meaning:
      "(tiếng động) vang to, ầm ĩ, tác động mạnh vào thính giác đến mức không chịu được, làm choáng váng: tiếng búa nện inh tai nhức óc",
    example: "tiếng búa nện inh tai nhức óc",
  },
  {
    word: "inh ỏi",
    part_of_speech: "tính từ",
    meaning:
      "(tiếng kêu, réo) vang to, lộn xộn và chói tai: bóp còi inh ỏi * la hét inh ỏi * khóc inh ỏi",
    example: "bóp còi inh ỏi * la hét inh ỏi * khóc inh ỏi",
  },
  {
    word: "inox",
    part_of_speech: "danh từ",
    meaning: "(Khẩu ngữ) thép không gỉ: đồng hồ vỏ inox",
    example: "đồng hồ vỏ inox",
  },
  {
    word: "inh tai",
    part_of_speech: "tính từ",
    meaning:
      "(âm thanh) vang và to, gây cảm giác chói tai, khó chịu: tiếng nổ inh tai",
    example: "tiếng nổ inh tai",
  },
  {
    word: "ít",
    part_of_speech: "tính từ",
    meaning:
      "có số lượng nhỏ hoặc ở mức thấp: chỉ còn một ít * ít nói * ít tiếp xúc với bên ngoài * của ít lòng nhiều (tng)",
    example:
      "chỉ còn một ít * ít nói * ít tiếp xúc với bên ngoài * của ít lòng nhiều (tng)",
  },
  {
    word: "iso",
    part_of_speech: "danh từ",
    meaning:
      "(A: International Standardization Organization, viết tắt) tên gọi tắt tổ chức tiêu chuẩn hoá quốc tế; thường dùng để chỉ hệ thống tiêu chuẩn quốc tế về quản lí công nghệ, làm căn cứ cho các tổ chức, doanh nghiệp xây dựng hệ thống quản lí chất lượng của mình: bộ tiêu chuẩn ISO 9000 * sản phẩm đã được cấp chứng chỉ ISO 9002",
    example: "bộ tiêu chuẩn ISO 9000 * sản phẩm đã được cấp chứng chỉ ISO 9002",
  },
  {
    word: "ít nhất",
    part_of_speech: "",
    meaning:
      "với mức thấp nhất thì cũng phải là như thế: việc này, ít nhất phải một tuần mới xong",
    example: "việc này, ít nhất phải một tuần mới xong",
  },
  {
    word: "ít nữa",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) một thời gian không lâu nữa, sắp tới: ít nữa rồi ai cũng biết * ít nữa nghỉ hè sẽ cho con cái đi nghỉ một chuyến",
    example:
      "ít nữa rồi ai cũng biết * ít nữa nghỉ hè sẽ cho con cái đi nghỉ một chuyến",
  },
  {
    word: "ít lâu",
    part_of_speech: "danh từ",
    meaning:
      'một thời gian không lâu: mới về cách đây ít lâu * "Đành lòng chờ đó ít lâu, Chầy chăng là một năm sau, vội gì!" (TKiều)',
    example:
      'mới về cách đây ít lâu * "Đành lòng chờ đó ít lâu, Chầy chăng là một năm sau, vội gì!" (TKiều)',
  },
  {
    word: "ít ỏi",
    part_of_speech: "tính từ",
    meaning: "ít, không đáng kể: tiền lương ít ỏi * vốn hiểu biết còn ít ỏi",
    example: "tiền lương ít ỏi * vốn hiểu biết còn ít ỏi",
  },
  {
    word: "ỉu",
    part_of_speech: "tính từ",
    meaning:
      "mềm đi, không giòn, do bị ẩm, bị thấm nước: ỉu như bánh đa nhúng nước",
    example: "ỉu như bánh đa nhúng nước",
  },
  {
    word: "ỉu",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) trở nên trầm lặng, không còn vui vẻ, hăng hái nữa, do có điều không vừa ý: bị điểm kém nên cu cậu ỉu lắm * buồn ỉu mặt",
    example: "bị điểm kém nên cu cậu ỉu lắm * buồn ỉu mặt",
  },
  {
    word: "ít ra",
    part_of_speech: "",
    meaning:
      "như ít nhất (nhưng ý khẳng định nhẹ hơn): bài này ít ra cũng phải được 8 điểm",
    example: "bài này ít ra cũng phải được 8 điểm",
  },
  {
    word: "ít nhiều",
    part_of_speech: "tính từ",
    meaning:
      "ở mức độ nào đó, chẳng nhiều thì ít, nhưng là có: thay đổi ít nhiều * việc đó cũng có ít nhiều hi vọng",
    example: "thay đổi ít nhiều * việc đó cũng có ít nhiều hi vọng",
  },
  {
    word: "iu ỉu",
    part_of_speech: "tính từ",
    meaning: "hơi ỉu: iu ỉu như bánh đa thấm nước * mặt iu ỉu buồn",
    example: "iu ỉu như bánh đa thấm nước * mặt iu ỉu buồn",
  },
  {
    word: "ỉu xìu",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) ỉu đến mức xẹp hẳn xuống, rũ hẳn xuống, không thể tươi lên được: bánh đa ỉu xìu * giọng ỉu xìu xìu * mặt ỉu xìu",
    example: "bánh đa ỉu xìu * giọng ỉu xìu xìu * mặt ỉu xìu",
  },
  {
    word: "kaki",
    part_of_speech: "danh từ",
    meaning:
      "vải dày dệt bằng sợi xe, thường có màu vàng sẫm, hay dùng để may âu phục: vải kaki * quần kaki",
    example: "vải kaki * quần kaki",
  },
  {
    word: "karate",
    part_of_speech: "danh từ",
    meaning:
      "môn võ truyền thống của Nhật Bản, dùng để tự vệ bằng tay không, chủ yếu dùng cạnh bàn tay đánh vào những chỗ hiểm trên cơ thể đối thủ: võ sĩ karate",
    example: "võ sĩ karate",
  },
  {
    word: "karaoke",
    part_of_speech: "danh từ",
    meaning:
      "lối hát hoà theo nhạc đệm, dựa vào thiết bị nghe nhìn vừa nghe được nhạc vừa có thể xem phụ đề ghi lời của bài hát trên màn hình (một hình thức giải trí): hát karaoke * quán karaoke",
    example: "hát karaoke * quán karaoke",
  },
  {
    word: "ke",
    part_of_speech: "tính từ",
    meaning: "(Phương ngữ, Khẩu ngữ) bủn xỉn, keo kiệt: tính nó ke lắm",
    example: "tính nó ke lắm",
  },
  {
    word: "kẻ",
    part_of_speech: "danh từ",
    meaning:
      "người hoặc những người như thế nào đó, nhưng không nói cụ thể là ai: kẻ bị hại * ăn quả nhớ kẻ trồng cây (tng)",
    example: "kẻ bị hại * ăn quả nhớ kẻ trồng cây (tng)",
  },
  {
    word: "kẻ",
    part_of_speech: "danh từ",
    meaning:
      "người hoặc những người như thế nào đó, không nói cụ thể là ai, nhưng hàm ý coi thường, coi khinh: kẻ cướp * kẻ vô ơn bạc nghĩa",
    example: "kẻ cướp * kẻ vô ơn bạc nghĩa",
  },
  {
    word: "kẻ",
    part_of_speech: "danh từ",
    meaning:
      "người hoặc những người như thế này, nói trong quan hệ đối lập nào đó với người hoặc những người như thế kia: kẻ ra người vào tấp nập",
    example: "kẻ ra người vào tấp nập",
  },
  {
    word: "kẻ",
    part_of_speech: "danh từ",
    meaning:
      '(Từ cũ) đơn vị dân cư, thường là nơi thành thị hoặc nơi có chợ búa: kẻ chợ * "Đồn rằng Kẻ Lạng vui thay, Đi ba bốn ngày kể đã lắm công." (Cdao)',
    example:
      'kẻ chợ * "Đồn rằng Kẻ Lạng vui thay, Đi ba bốn ngày kể đã lắm công." (Cdao)',
  },
  {
    word: "kẻ",
    part_of_speech: "động từ",
    meaning:
      "tạo nên đường hoặc nét thẳng trên một bề mặt bằng cách vạch theo mép của thước hoặc của một vật thẳng nói chung: giấy có kẻ ô * kẻ hai đường thẳng song song",
    example: "giấy có kẻ ô * kẻ hai đường thẳng song song",
  },
  {
    word: "kẻ",
    part_of_speech: "động từ",
    meaning:
      "tạo nên những đường nét đẹp bằng cách tô vẽ cẩn thận, tỉ mỉ: kẻ biển quảng cáo * kẻ lông mày",
    example: "kẻ biển quảng cáo * kẻ lông mày",
  },
  {
    word: "ké",
    part_of_speech: "danh từ",
    meaning: "người già, theo cách gọi của một số dân tộc miền núi: ông ké",
    example: "ông ké",
  },
  {
    word: "ké",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) nhờ để làm việc gì cùng với người khác, coi như phụ thêm vào: ngồi ké bên cạnh * xem ké tờ báo",
    example: "ngồi ké bên cạnh * xem ké tờ báo",
  },
  {
    word: "kẽ",
    part_of_speech: "danh từ",
    meaning:
      "chỗ tiếp giáp không khít nhau làm thành khoảng trống nhỏ: kẽ răng * tia nắng chiếu qua kẽ lá",
    example: "kẽ răng * tia nắng chiếu qua kẽ lá",
  },
  {
    word: "kẻ cả",
    part_of_speech: "danh từ",
    meaning:
      "người ở địa vị cao hơn tất cả những người khác (thường hàm ý chê): kẻ cả trong làng",
    example: "kẻ cả trong làng",
  },
  {
    word: "kẻ cả",
    part_of_speech: "danh từ",
    meaning:
      "huênh hoang, tỏ vẻ ta đây hơn người: nói bằng giọng kẻ cả và dạy đời",
    example: "nói bằng giọng kẻ cả và dạy đời",
  },
  {
    word: "kẹ",
    part_of_speech: "tính từ",
    meaning:
      "(hạt, quả cây) phát triển không đầy đủ, không có thịt, rỗng bên trong: hạt lạc kẹ * thóc kẹ",
    example: "hạt lạc kẹ * thóc kẹ",
  },
  {
    word: "kè",
    part_of_speech: "động từ",
    meaning:
      "đắp thêm, tạo thêm một lớp bằng vật liệu chắc ốp sát vào thành, vào chân để giữ cho khỏi sụt lở, xói mòn: chân tháp được kè bằng đá hộc * kè chân đê",
    example: "chân tháp được kè bằng đá hộc * kè chân đê",
  },
  {
    word: "kè",
    part_of_speech: "danh từ",
    meaning:
      "công trình thường xây bằng đá ở bờ biển, bờ sông để chống xói lở hoặc để ngăn các nhánh sông nhằm tăng lưu lượng nước ở dòng chính: kiểm tra hệ thống đê, kè trước mùa lũ * bờ ao được xây kè",
    example: "kiểm tra hệ thống đê, kè trước mùa lũ * bờ ao được xây kè",
  },
  {
    word: "kè",
    part_of_speech: "động từ",
    meaning: "(Ít dùng) theo sát bên cạnh để dẫn hoặc dìu đi: đi kè bên cạnh",
    example: "đi kè bên cạnh",
  },
  {
    word: "kẻ bắc người nam",
    part_of_speech: "",
    meaning:
      '(văn chương) tả tình trạng xa cách, chia lìa nhau, mỗi người một nơi: "Nghĩ rằng kẻ bắc người nam, Chắc còn thoa ấy, để làm duyên sau." (NĐM)',
    example:
      'Nghĩ rằng kẻ bắc người nam, Chắc còn thoa ấy, để làm duyên sau." (NĐM)',
  },
  {
    word: "kẻ cắp",
    part_of_speech: "danh từ",
    meaning: "kẻ chuyên đi ăn cắp: bị kẻ cắp móc túi",
    example: "bị kẻ cắp móc túi",
  },
  {
    word: "ké né",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) có những cử chỉ quá giữ gìn, khép nép trước mặt người nào đó, do e sợ hoặc kính nể: con bé đứng ké né bên mép giường",
    example: "con bé đứng ké né bên mép giường",
  },
  {
    word: "kè kè",
    part_of_speech: "động từ",
    meaning:
      "ở ngay sát bên cạnh, không lúc nào rời ra: lúc nào cũng kè kè chai rượu * kè kè đi theo",
    example: "lúc nào cũng kè kè chai rượu * kè kè đi theo",
  },
  {
    word: "kè kè",
    part_of_speech: "động từ",
    meaning:
      'luôn luôn ở bên cạnh: "Tay mang túi bạc kè kè, Nói quấy nói quá, người nghe ầm ầm." (ca dao)',
    example:
      'Tay mang túi bạc kè kè, Nói quấy nói quá, người nghe ầm ầm." (ca dao)',
  },
  {
    word: "kẻ ở người đi",
    part_of_speech: "",
    meaning:
      'tả cảnh chia tay, kẻ ra đi, người ở lại: "Đau lòng kẻ ở người đi, Lệ rơi thấm đá, tơ chia rũ tằm." (TKiều)',
    example: 'Đau lòng kẻ ở người đi, Lệ rơi thấm đá, tơ chia rũ tằm." (TKiều)',
  },
  {
    word: "kẻ cướp",
    part_of_speech: "danh từ",
    meaning: "kẻ chuyên đi ăn cướp: bọn kẻ cướp * gặp kẻ cướp giữa đường",
    example: "bọn kẻ cướp * gặp kẻ cướp giữa đường",
  },
  {
    word: "kè nhè",
    part_of_speech: "",
    meaning:
      "nói bằng giọng trầm và kéo dài dai dẳng, thường để đòi bằng được điều mình muốn, khiến cho người nghe cảm thấy bực bội, khó chịu: thằng bé kè nhè đòi cho bằng được",
    example: "thằng bé kè nhè đòi cho bằng được",
  },
  {
    word: "kẻ gian",
    part_of_speech: "danh từ",
    meaning:
      "kẻ chuyên làm những việc bất chính, bất lương như trộm cắp, lừa đảo, phá hoại, vv: đề phòng kẻ gian",
    example: "đề phòng kẻ gian",
  },
  {
    word: "kẻ chợ",
    part_of_speech: "danh từ",
    meaning: "(cũ) nơi đô thị (thường dùng để chỉ kinh đô cũ): dân kẻ chợ",
    example: "dân kẻ chợ",
  },
  {
    word: "kẻ thù",
    part_of_speech: "danh từ",
    meaning: "kẻ có quan hệ thù địch: kẻ thù xâm lược * coi nhau như kẻ thù",
    example: "kẻ thù xâm lược * coi nhau như kẻ thù",
  },
  {
    word: "kẽm",
    part_of_speech: "danh từ",
    meaning:
      "kim loại màu trắng hơi xanh, ít gỉ: mái lợp kẽm * tôn tráng kẽm * tiền kẽm",
    example: "mái lợp kẽm * tôn tráng kẽm * tiền kẽm",
  },
  {
    word: "kẽm",
    part_of_speech: "danh từ",
    meaning:
      'khe nước tự nhiên hẹp và sâu ở giữa hai dốc núi: "Hai bên thì núi, giữa thì sông, Có phải đây là kẽm Trống không?" (HXHương; 20)',
    example:
      'Hai bên thì núi, giữa thì sông, Có phải đây là kẽm Trống không?" (HXHương; 20)',
  },
  {
    word: "kem",
    part_of_speech: "danh từ",
    meaning:
      "chất béo nổi thành váng, thành lớp trên bề mặt của sữa, dùng để làm bơ.",
    example: "đánh kem * bánh ngọt nhân kem",
  },
  {
    word: "kem",
    part_of_speech: "danh từ",
    meaning:
      "thức ăn làm bằng sữa, trứng, đường đánh lẫn với nhau cho đặc sánh lại: đánh kem * bánh ngọt nhân kem",
    example: "kem cốc * kem đậu xanh * mua mấy que kem",
  },
  {
    word: "kem",
    part_of_speech: "danh từ",
    meaning:
      "thức ăn làm bằng sữa, trứng, đường, vv đánh lẫn với nhau rồi cho đông trong máy lạnh: kem cốc * kem đậu xanh * mua mấy que kem",
    example: "kem dưỡng da * kem chống nắng * kem đánh răng",
  },
  {
    word: "kem",
    part_of_speech: "danh từ",
    meaning:
      "quỷ giữ hồn người chết hay người sắp chết, theo mê tín: tục cúng kem",
    example: "tục cúng kem",
  },
  {
    word: "kéc",
    part_of_speech: "danh từ",
    meaning:
      'loài chim vẹt lớn: "Ai đem con kéc vô vườn, Để cho con kéc ăn buồng chuối tiêu." (ca dao)',
    example:
      'Ai đem con kéc vô vườn, Để cho con kéc ăn buồng chuối tiêu." (ca dao)',
  },
  {
    word: "kém cạnh",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) như thua kém: không chịu kém cạnh ai",
    example: "không chịu kém cạnh ai",
  },
  {
    word: "kém",
    part_of_speech: "tính từ",
    meaning:
      "ở mức thấp so với cái đưa ra để so sánh: sản lượng lúa năm nay kém năm ngoái * cô em kém cô chị năm tuổi",
    example: "sản lượng lúa năm nay kém năm ngoái * cô em kém cô chị năm tuổi",
  },
  {
    word: "kém",
    part_of_speech: "tính từ",
    meaning:
      "ở trình độ hoặc khả năng thấp hơn so với cái trung bình: học lực kém * mắt kém * khả năng tiếp thu hơi kém",
    example: "học lực kém * mắt kém * khả năng tiếp thu hơi kém",
  },
  {
    word: "kém",
    part_of_speech: "tính từ",
    meaning:
      "ở mức thấp hơn, giảm sút so với bình thường: dạo này ăn ngủ đều kém * mặt kém vui * học càng ngày càng kém",
    example: "dạo này ăn ngủ đều kém * mặt kém vui * học càng ngày càng kém",
  },
  {
    word: "kém",
    part_of_speech: "tính từ",
    meaning:
      "còn thiếu bao nhiêu đó mới đủ số tròn được nói đến: sáu giờ kém hai mươi phút * kém hai tuổi nữa là tròn bảy mươi",
    example: "sáu giờ kém hai mươi phút * kém hai tuổi nữa là tròn bảy mươi",
  },
  {
    word: "kém",
    part_of_speech: "tính từ",
    meaning:
      "(giá thóc, gạo) đắt, cao so với mức bình thường: thóc cao gạo kém",
    example: "thóc cao gạo kém",
  },
  {
    word: "kẻ trộm",
    part_of_speech: "danh từ",
    meaning: "kẻ chuyên đi ăn trộm: bị kẻ trộm lẻn vào nhà",
    example: "bị kẻ trộm lẻn vào nhà",
  },
  {
    word: "kèm",
    part_of_speech: "động từ",
    meaning:
      "cùng tồn tại, cùng đi theo với cái chính, cái chủ yếu: gió lốc kèm mưa to * hoá đơn gửi kèm theo hàng",
    example: "gió lốc kèm mưa to * hoá đơn gửi kèm theo hàng",
  },
  {
    word: "kèm",
    part_of_speech: "động từ",
    meaning:
      "theo bên cạnh để khống chế: đi kèm * bị cầu thủ của đội bạn kèm chặt",
    example: "đi kèm * bị cầu thủ của đội bạn kèm chặt",
  },
  {
    word: "kèm",
    part_of_speech: "động từ",
    meaning: "gần gũi để giúp đỡ, chỉ bảo thêm: thợ cũ kèm thợ mới",
    example: "thợ cũ kèm thợ mới",
  },
  {
    word: "kèm cặp",
    part_of_speech: "động từ",
    meaning:
      "quan tâm, theo sát bên cạnh để chỉ bảo, dìu dắt: kèm cặp con cái * được anh em bạn bè bảo ban, kèm cặp",
    example: "kèm cặp con cái * được anh em bạn bè bảo ban, kèm cặp",
  },
  {
    word: "kém hèn",
    part_of_speech: "tính từ",
    meaning: "(cũ) như hèn kém: địa vị kém hèn",
    example: "địa vị kém hèn",
  },
  {
    word: "kém cỏi",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) kém (nói khái quát): sức học kém cỏi * tài nghệ kém cỏi",
    example: "sức học kém cỏi * tài nghệ kém cỏi",
  },
  {
    word: "kèm nhèm",
    part_of_speech: "tính từ",
    meaning: "(mắt) có dính nhiều dử, trông không rõ: mắt mũi kèm nhèm",
    example: "mắt mũi kèm nhèm",
  },
  {
    word: "kén",
    part_of_speech: "danh từ",
    meaning:
      "tổ bằng tơ của một số loài sâu bướm dệt ra để ẩn lúc hoá nhộng: tằm làm kén",
    example: "tằm làm kén",
  },
  {
    word: "kén",
    part_of_speech: "danh từ",
    meaning:
      "bọc sinh sản có vỏ cứng do một số loài sâu bọ tạo ra: kén sán * sâu đã làm kén",
    example: "kén sán * sâu đã làm kén",
  },
  {
    word: "kén",
    part_of_speech: "động từ",
    meaning:
      "tìm chọn kĩ theo tiêu chuẩn nhất định: kén rể * cấy lúa phải kén mạ, nuôi cá phải kén giống (tng)",
    example: "kén rể * cấy lúa phải kén mạ, nuôi cá phải kén giống (tng)",
  },
  {
    word: "kén",
    part_of_speech: "động từ",
    meaning:
      "có những đòi hỏi riêng về tiêu chuẩn, thường cao hơn nhiều so với bình thường trong việc lựa chọn (hàm ý khó tính): kén ăn * già kén kẹn hom (tng)",
    example: "kén ăn * già kén kẹn hom (tng)",
  },
  {
    word: "ken",
    part_of_speech: "động từ",
    meaning:
      "bít lại, đệm thêm vào để làm cho kín những khe, những chỗ hở: ken lại bờ giậu * ken sơn vào mộng giường",
    example: "ken lại bờ giậu * ken sơn vào mộng giường",
  },
  {
    word: "ken",
    part_of_speech: "tính từ",
    meaning:
      "sát vào nhau, đến mức như không thấy một khe hở nào: cành và lá cây ken đặc * dòng người đông ken",
    example: "cành và lá cây ken đặc * dòng người đông ken",
  },
  {
    word: "kèn",
    part_of_speech: "danh từ",
    meaning:
      "nhạc khí tạo tiếng nhạc bằng cách dùng hơi thổi làm rung các dăm hoặc làm rung cột không khí trong các ống: thổi kèn * cây kèn đồng",
    example: "thổi kèn * cây kèn đồng",
  },
  {
    word: "kèn",
    part_of_speech: "danh từ",
    meaning: "tổ sâu có hình ống, trẻ em thường lấy để làm kèn: kèn sâu",
    example: "kèn sâu",
  },
  {
    word: "kén chọn",
    part_of_speech: "động từ",
    meaning:
      'tìm chọn rất kĩ (nói khái quát): kén chọn người tài * "Yêu nhau thì lấy được nhau, Sao còn kén chọn vàng thau làm gì." (ca dao)',
    example:
      'kén chọn người tài * "Yêu nhau thì lấy được nhau, Sao còn kén chọn vàng thau làm gì." (ca dao)',
  },
  {
    word: "kèn kẹt",
    part_of_speech: "tính từ",
    meaning: "như kẹt (nhưng ý liên tiếp): nghiến răng kèn kẹt",
    example: "nghiến răng kèn kẹt",
  },
  {
    word: "ken két",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng hai vật cứng xiết mạnh vào nhau, nghe hơi chói và ghê tai: nghiến răng ken két",
    example: "nghiến răng ken két",
  },
  {
    word: "kèn trống",
    part_of_speech: "danh từ",
    meaning:
      "những loại nhạc khí như kèn, trống, v.v. thường dùng trong các dịp ma chay, đình đám (nói khái quát): sống dầu đèn chết kèn trống (tng)",
    example: "sống dầu đèn chết kèn trống (tng)",
  },
  {
    word: "kèn cựa",
    part_of_speech: "động từ",
    meaning:
      "ghen tức với người khác về địa vị, quyền lợi và thường tìm cách dìm họ để giành phần hơn cho mình: kèn cựa nhau về địa vị",
    example: "kèn cựa nhau về địa vị",
  },
  {
    word: "kẻo",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là cần tránh hoặc muốn tránh, bằng cách phải thực hiện điều vừa nói đến (nếu không thì sẽ gặp điều không hay): vào nhà đi kẻo gió * đi ngay kẻo muộn",
    example: "vào nhà đi kẻo gió * đi ngay kẻo muộn",
  },
  {
    word: "kéo",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ dùng để cắt gồm có hai lưỡi thép chéo nhau, gắn với nhau bằng một đinh chốt: dùng kéo để cắt vải",
    example: "dùng kéo để cắt vải",
  },
  {
    word: "kéo",
    part_of_speech: "động từ",
    meaning:
      "làm cho di chuyển hoặc làm cho căng thẳng ra, bằng tác động của một lực truyền qua một điểm nối: kéo chăn đắp cho con * ngựa kéo xe * kéo cờ trắng xin hàng",
    example: "kéo chăn đắp cho con * ngựa kéo xe * kéo cờ trắng xin hàng",
  },
  {
    word: "kéo",
    part_of_speech: "động từ",
    meaning:
      "di chuyển hoặc làm cho di chuyển với số lượng nhiều, nối tiếp nhau theo cùng một hướng: mây đen kéo đầy trời * mọi người kéo đến ngày một đông",
    example: "mây đen kéo đầy trời * mọi người kéo đến ngày một đông",
  },
  {
    word: "kéo",
    part_of_speech: "động từ",
    meaning:
      "tập hợp nhau lại thành nhóm (thường để làm việc xấu): kéo bè kéo đảng",
    example: "kéo bè kéo đảng",
  },
  {
    word: "kéo",
    part_of_speech: "động từ",
    meaning:
      "làm cho phát ra tiếng nhạc hoặc tiếng báo hiệu, bằng động tác kéo hoặc giống như kéo: kéo đàn violon * kéo một hồi chuông báo động",
    example: "kéo đàn violon * kéo một hồi chuông báo động",
  },
  {
    word: "kéo",
    part_of_speech: "động từ",
    meaning:
      "làm cho thành vật có hình dáng nhất định (thường mảnh và dài), bằng động tác kéo hoặc giống như kéo: kéo sợi * kéo chiếc nhẫn vàng tây",
    example: "kéo sợi * kéo chiếc nhẫn vàng tây",
  },
  {
    word: "kéo",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) tác động đến, làm cho tăng cao lên hoặc hạ thấp xuống: giá đô tăng cũng kéo giá vàng tăng theo",
    example: "giá đô tăng cũng kéo giá vàng tăng theo",
  },
  {
    word: "kéo",
    part_of_speech: "động từ",
    meaning:
      "hình thành và hiện ra nối tiếp nhau: vết thương đang kéo da non * mắt bị kéo màng",
    example: "vết thương đang kéo da non * mắt bị kéo màng",
  },
  {
    word: "kéo",
    part_of_speech: "động từ",
    meaning:
      "trải ra, diễn ra liên tục trên một khoảng không gian hay thời gian dài: pháo sáng kéo thành một vệt dài * cuộc họp kéo dài hơn dự kiến",
    example: "pháo sáng kéo thành một vệt dài * cuộc họp kéo dài hơn dự kiến",
  },
  {
    word: "keo bẩn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) keo kiệt và xấu bụng một cách bẩn thỉu, đáng ghét: tính keo bẩn",
    example: "tính keo bẩn",
  },
  {
    word: "kẹo",
    part_of_speech: "danh từ",
    meaning:
      "đồ ăn ở dạng viên hoặc thỏi, làm bằng đường, mật, thường có thêm các chất béo, chất thơm: nấu kẹo * viên kẹo * kẹo lạc",
    example: "nấu kẹo * viên kẹo * kẹo lạc",
  },
  {
    word: "kéo bè kéo cánh",
    part_of_speech: "",
    meaning:
      "tập hợp lại với nhau thành bè cánh, gây mất đoàn kết: kéo bè kéo cánh để hại nhau",
    example: "kéo bè kéo cánh để hại nhau",
  },
  {
    word: "keo",
    part_of_speech: "danh từ",
    meaning:
      "chất dính dùng để dán, gắn, được pha chế hoặc được lấy từ nhựa cây: keo dán * keo da trâu * dính như keo",
    example: "keo dán * keo da trâu * dính như keo",
  },
  {
    word: "keo",
    part_of_speech: "động từ",
    meaning:
      "trở nên đặc và dính, hoặc quánh lại với nhau: nhựa cây đã keo lại",
    example: "nhựa cây đã keo lại",
  },
  {
    word: "keo",
    part_of_speech: "danh từ",
    meaning:
      "lần tranh giành được thua bằng sức lực (thường nói trong đấu vật): vật nhau ba keo bất phân thắng bại * thua keo này bày keo khác (tng)",
    example:
      "vật nhau ba keo bất phân thắng bại * thua keo này bày keo khác (tng)",
  },
  {
    word: "keo",
    part_of_speech: "tính từ",
    meaning: "(Khẩu ngữ) keo kiệt (nói tắt): ông ta keo lắm!",
    example: "ông ta keo lắm!",
  },
  {
    word: "kẻng",
    part_of_speech: "danh từ",
    meaning:
      "vật bằng kim loại, dùng đánh ra tiếng để báo hiệu: đánh kẻng báo động",
    example: "đánh kẻng báo động",
  },
  {
    word: "kẻng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) đẹp một cách bảnh bao, trau chuốt (thường nói về nam giới): kẻng trai",
    example: "kẻng trai",
  },
  {
    word: "kéo bộ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ, hiếm) như cuốc bộ: nhỡ xe nên phải kéo bộ gần chục cây số",
    example: "nhỡ xe nên phải kéo bộ gần chục cây số",
  },
  {
    word: "kéo co",
    part_of_speech: "danh từ",
    meaning:
      "trò chơi tập thể, người chơi chia làm hai tốp, mỗi tốp nắm một đầu sợi dây, bên nào kéo được về phía mình là thắng: chơi kéo co * thi kéo co",
    example: "chơi kéo co * thi kéo co",
  },
  {
    word: "kèo nhèo",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nói điều mình không vừa ý một cách dai dẳng, khiến cho người nghe cảm thấy khó chịu, bực bội: chỉ có thế mà cứ kèo nhèo mãi!",
    example: "chỉ có thế mà cứ kèo nhèo mãi!",
  },
  {
    word: "kéo gỗ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) ngáy to, vang và đều trong khi ngủ: chưa đặt lưng đã kéo gỗ * thằng cha kéo gỗ suốt đêm",
    example: "chưa đặt lưng đã kéo gỗ * thằng cha kéo gỗ suốt đêm",
  },
  {
    word: "kẻo mà",
    part_of_speech: "kết từ",
    meaning:
      'kẻo không khỏi xảy ra điều gì đó đang muốn tránh: "Chàng buông vạt áo em ra, Để em đi chợ kẻo mà chợ trưa." (ca dao)',
    example:
      'Chàng buông vạt áo em ra, Để em đi chợ kẻo mà chợ trưa." (ca dao)',
  },
  {
    word: "kèo nài",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) kì kèo và nài nỉ: kèo nài cho bằng được mới thôi",
    example: "kèo nài cho bằng được mới thôi",
  },
  {
    word: "kèo nèo",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) cù nèo: vác kèo nèo đi chọc xoài",
    example: "vác kèo nèo đi chọc xoài",
  },
  {
    word: "kèo nèo",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nài nỉ một cách dai dẳng cho kì đạt được điều mình muốn: tính hay kèo nèo * kèo nèo mãi cũng không được",
    example: "tính hay kèo nèo * kèo nèo mãi cũng không được",
  },
  {
    word: "kéo lại",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bù vào chỗ thiếu hụt, khiếm khuyết: khuôn mặt thì không đẹp nhưng được cặp mắt kéo lại",
    example: "khuôn mặt thì không đẹp nhưng được cặp mắt kéo lại",
  },
  {
    word: "keo kiệt",
    part_of_speech: "tính từ",
    meaning:
      "hà tiện tới mức quá quắt, chỉ biết bo bo giữ của: con người keo kiệt",
    example: "con người keo kiệt",
  },
  {
    word: "kẻo rồi",
    part_of_speech: "kết từ",
    meaning:
      "kẻo có thể xảy ra điều gì đó không hay: cố gắng mà học, kẻo rồi lại thua chúng thua bạn",
    example: "cố gắng mà học, kẻo rồi lại thua chúng thua bạn",
  },
  {
    word: "keo sơn",
    part_of_speech: "danh từ",
    meaning:
      'chất kết dính, như keo và sơn; dùng để ví sự gắn bó khăng khít trong quan hệ với nhau: "Trăm năm kết sợi chỉ mành, ái ân gắn bó chung tình keo sơn." (ca dao)',
    example:
      'Trăm năm kết sợi chỉ mành, ái ân gắn bó chung tình keo sơn." (ca dao)',
  },
  {
    word: "kẽo kẹt",
    part_of_speech: "động từ",
    meaning:
      "từ mô phỏng những tiếng trầm bổng, dài ngắn vang lên đều đều như tiếng của hai vật bằng tre, gỗ cọ xiết vào nhau: tiếng võng kẽo kẹt",
    example: "tiếng võng kẽo kẹt",
  },
  {
    word: "kéo theo",
    part_of_speech: "động từ",
    meaning:
      "làm cho xảy ra tiếp theo ngay sau đó như một điều tất yếu: kinh tế phát triển sẽ kéo theo sự phát triển các lĩnh vực khác của xã hội",
    example:
      "kinh tế phát triển sẽ kéo theo sự phát triển các lĩnh vực khác của xã hội",
  },
  {
    word: "kẻo nữa",
    part_of_speech: "kết từ",
    meaning:
      "kẻo sẽ xảy ra điều gì đó không thuận lợi, không muốn thế: đi đi, kẻo nữa không kịp",
    example: "đi đi, kẻo nữa không kịp",
  },
  {
    word: "kẹp",
    part_of_speech: "động từ",
    meaning:
      "giữ chặt lấy ở giữa bằng cách ép mạnh lại từ hai phía: kẹp quyển vở vào nách * kẹp vào giữa hai ngón tay",
    example: "kẹp quyển vở vào nách * kẹp vào giữa hai ngón tay",
  },
  {
    word: "kẹp",
    part_of_speech: "động từ",
    meaning: "(hiếm) như kẹt: súng kẹp đạn",
    example: "súng kẹp đạn",
  },
  {
    word: "kẹp",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng gồm hai thanh hoặc hai mảnh cứng để kẹp và giữ chặt đồ vật: kẹp tóc * kẹp tài liệu * cái kẹp quần áo",
    example: "kẹp tóc * kẹp tài liệu * cái kẹp quần áo",
  },
  {
    word: "kẹt",
    part_of_speech: "động từ",
    meaning:
      "bị giữ lại, mắc lại, không đi qua, đi ra được: bị kẹt xe * kẹt giữa dòng người",
    example: "bị kẹt xe * kẹt giữa dòng người",
  },
  {
    word: "kẹt",
    part_of_speech: "động từ",
    meaning:
      "(Nam) gặp khó khăn, khó xử, khó giải quyết: không mượn được tiền thì kẹt lắm * kẹt tiền (= thiếu tiền)",
    example: "không mượn được tiền thì kẹt lắm * kẹt tiền",
  },
  {
    word: "kẹt",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng phát ra nghe đanh như tiếng của hai vật cứng cọ xát mạnh vào nhau: có tiếng kẹt cửa",
    example: "có tiếng kẹt cửa",
  },
  {
    word: "keo xỉn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) keo kiệt và bủn xỉn (nói khái quát): quen thói keo xỉn",
    example: "quen thói keo xỉn",
  },
  {
    word: "két",
    part_of_speech: "danh từ",
    meaning:
      "tủ sắt kiên cố, chuyên dùng để cất giữ tiền của: két bạc * thụt két",
    example: "két bạc * thụt két",
  },
  {
    word: "két",
    part_of_speech: "danh từ",
    meaning:
      "hòm gỗ hoặc nhựa, thường có đai, dùng để chứa hàng hoá khi chuyên chở: két đạn * mua một két bia",
    example: "két đạn * mua một két bia",
  },
  {
    word: "két",
    part_of_speech: "danh từ",
    meaning:
      "thùng lớn hoặc bể để chứa nước, xăng dầu, thường được đặt trên đầu xe hay trên tầng cao của các ngôi nhà: két nước * két xăng",
    example: "két nước * két xăng",
  },
  {
    word: "két",
    part_of_speech: "tính từ",
    meaning:
      "khô quánh và dính bết vào thành một lớp khó tẩy rửa: máu khô két lại * nhựa cây bám két vào quần áo",
    example: "máu khô két lại * nhựa cây bám két vào quần áo",
  },
  {
    word: "kép",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) nghệ nhân nam trong các ngành kịch hát dân tộc: kép hát * "Chào rồi lại hỏi mau mau, Kép kia đã sánh với đào nào chưa?" (ca dao)',
    example:
      'kép hát * "Chào rồi lại hỏi mau mau, Kép kia đã sánh với đào nào chưa?" (ca dao)',
  },
  {
    word: "kép",
    part_of_speech: "tính từ",
    meaning:
      "có cấu tạo gồm hai thành phần đi liền nhau: xà kép * dấu ngoặc kép * áo đơn, áo kép",
    example: "xà kép * dấu ngoặc kép * áo đơn, áo kép",
  },
  {
    word: "kê",
    part_of_speech: "động từ",
    meaning:
      "đệm thêm một vật cứng ở dưới để cho vật được đặt ở trên khỏi lệch hay cao lên: kê đầu lên quyển sách * kê chân bàn cho cao thêm",
    example: "kê đầu lên quyển sách * kê chân bàn cho cao thêm",
  },
  {
    word: "kê",
    part_of_speech: "động từ",
    meaning:
      "đặt đồ đạc trong nhà vào vị trí cố định: giường kê sát tường * giữa nhà kê một chiếc bàn",
    example: "giường kê sát tường * giữa nhà kê một chiếc bàn",
  },
  {
    word: "kê",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nói đệm thêm vào để chế giễu hay đùa vui: thỉnh thoảng lại kê vào một câu nghe rất khó chịu",
    example: "thỉnh thoảng lại kê vào một câu nghe rất khó chịu",
  },
  {
    word: "kê",
    part_of_speech: "động từ",
    meaning:
      "viết ra theo thứ tự lần lượt từng tên, từng món để ghi nhớ hoặc thông báo: kê đơn thuốc * kê danh sách khách mời",
    example: "kê đơn thuốc * kê danh sách khách mời",
  },
  {
    word: "kể",
    part_of_speech: "động từ",
    meaning:
      "nói lại một cách có đầu có đuôi cho người khác nghe: kể lại những điều mắt thấy tai nghe * nghe bà kể chuyện đời xưa",
    example: "kể lại những điều mắt thấy tai nghe * nghe bà kể chuyện đời xưa",
  },
  {
    word: "kể",
    part_of_speech: "động từ",
    meaning:
      "nói ra lần lượt từng điều để cho người khác biết rõ: kể công * kể tên từng người",
    example: "kể công * kể tên từng người",
  },
  {
    word: "kể",
    part_of_speech: "động từ",
    meaning:
      "tính đến, để ý đến, coi là có ý nghĩa, là đáng quan tâm: làm việc không kể ngày đêm * tình yêu không kể sang hèn",
    example: "làm việc không kể ngày đêm * tình yêu không kể sang hèn",
  },
  {
    word: "kể",
    part_of_speech: "động từ",
    meaning:
      "tính ra: đông quá, kể phải đến cả nghìn người * mình đến đây kể cũng hơn ba năm rồi",
    example:
      "đông quá, kể phải đến cả nghìn người * mình đến đây kể cũng hơn ba năm rồi",
  },
  {
    word: "kể",
    part_of_speech: "động từ",
    meaning:
      "coi là, coi như là: làm được như vậy, kể cũng là giỏi * việc này kể như xong",
    example: "làm được như vậy, kể cũng là giỏi * việc này kể như xong",
  },
  {
    word: "kể",
    part_of_speech: "động từ",
    meaning:
      "hay tr từ biểu thị ý khẳng định về điều nghĩ thấy có lẽ đúng như thế: cô ta kể cũng đẹp * nó nói kể cũng có lí",
    example: "cô ta kể cũng đẹp * nó nói kể cũng có lí",
  },
  {
    word: "kề",
    part_of_speech: "động từ",
    meaning:
      "ở vào hoặc làm cho ở vào vị trí rất gần, không còn hoặc coi như không còn khoảng cách nữa: ngồi kề bên nhau * gươm kề cổ * kề vai sát cánh",
    example: "ngồi kề bên nhau * gươm kề cổ * kề vai sát cánh",
  },
  {
    word: "kế",
    part_of_speech: "danh từ",
    meaning:
      "cách khôn khéo nghĩ ra để giải quyết, ứng phó với một vấn đề hay tình huống khó khăn nào đó: tìm kế hoãn binh * tính kế sinh nhai * trăm phương ngàn kế",
    example: "tìm kế hoãn binh * tính kế sinh nhai * trăm phương ngàn kế",
  },
  {
    word: "kế",
    part_of_speech: "động từ",
    meaning:
      "tiếp theo, nối liền theo ngay sau khi một hoạt động, một quá trình khác vừa kết thúc: mùa nọ kế mùa kia * sáng dậy phải tập thể dục, kế đó mới làm gì thì làm",
    example:
      "mùa nọ kế mùa kia * sáng dậy phải tập thể dục, kế đó mới làm gì thì làm",
  },
  {
    word: "kế",
    part_of_speech: "tính từ",
    meaning:
      "ở vị trí liền ngay bên cạnh: người ngồi kế bên * nhà ở kế đường tàu",
    example: "người ngồi kế bên * nhà ở kế đường tàu",
  },
  {
    word: "kê biên",
    part_of_speech: "động từ",
    meaning:
      "kê danh mục tài sản có liên quan đến hành vi tội phạm để chờ xử lí theo pháp luật: ngôi nhà bị kê biên * niêm phong và kê biên tang vật",
    example: "ngôi nhà bị kê biên * niêm phong và kê biên tang vật",
  },
  {
    word: "kệ",
    part_of_speech: "danh từ",
    meaning: "giá nhỏ để sách hoặc đồ dùng: kệ sách * kệ giầy dép",
    example: "kệ sách * kệ giầy dép",
  },
  {
    word: "kệ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) để cho tuỳ ý, không tác động đến, coi như không biết gì đến: nó muốn làm gì, kệ nó * mưa thì kệ mưa, cứ đi",
    example: "nó muốn làm gì, kệ nó * mưa thì kệ mưa, cứ đi",
  },
  {
    word: "kế cận",
    part_of_speech: "tính từ",
    meaning: "ở gần ngay bên cạnh: nhà kế cận * miền kế cận",
    example: "nhà kế cận * miền kế cận",
  },
  {
    word: "kế cận",
    part_of_speech: "tính từ",
    meaning:
      "ở vị trí liền ngay sau lớp người trước, có thể sẽ thay thế lớp người trước: đội ngũ cán bộ kế cận * tìm người kế cận",
    example: "đội ngũ cán bộ kế cận * tìm người kế cận",
  },
  {
    word: "kề cận",
    part_of_speech: "tính từ",
    meaning:
      "rất gần, ở ngay sát bên cạnh: kề cận với hiểm nguy * ngồi kề cận bên nhau",
    example: "kề cận với hiểm nguy * ngồi kề cận bên nhau",
  },
  {
    word: "kể cả",
    part_of_speech: "",
    meaning: "tính gộp vào: hai chúng tôi, kể cả anh nữa là ba người",
    example: "hai chúng tôi, kể cả anh nữa là ba người",
  },
  {
    word: "kể cả",
    part_of_speech: "",
    meaning:
      "tổ hợp biểu thị cái, điều sắp nêu ra cũng không phải là ngoại lệ; không loại trừ: thế nào tôi cũng đến, kể cả trời mưa",
    example: "thế nào tôi cũng đến, kể cả trời mưa",
  },
  {
    word: "kề cà",
    part_of_speech: "động từ",
    meaning:
      "tỏ ra rề rà, chậm chạp, để mất nhiều thời gian vào những việc không quan trọng, không cần thiết: ngồi uống rượu kề cà * giọng nói kề cà",
    example: "ngồi uống rượu kề cà * giọng nói kề cà",
  },
  {
    word: "kế chân",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) thay người khác ở một cương vị, chức vụ nào đó: trưởng phòng kế chân giám đốc",
    example: "trưởng phòng kế chân giám đốc",
  },
  {
    word: "kế hoạch hoá",
    part_of_speech: "động từ",
    meaning:
      "làm cho phát triển một cách có kế hoạch (thường là trên quy mô lớn): thực hiện kế hoạch hoá gia đình",
    example: "thực hiện kế hoạch hoá gia đình",
  },
  {
    word: "kê khai",
    part_of_speech: "động từ",
    meaning:
      "khai rõ từng khoản một cách đầy đủ theo yêu cầu, theo quy định nào đó: kê khai hàng hoá để làm thủ tục nộp thuế * kê khai tài sản",
    example: "kê khai hàng hoá để làm thủ tục nộp thuế * kê khai tài sản",
  },
  {
    word: "kế hoạch",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ những điều vạch ra một cách có hệ thống và cụ thể về cách thức, trình tự, thời hạn tiến hành những công việc dự định làm trong một thời gian nhất định, với mục tiêu nhất định: bàn kế hoạch đầu tư * sản xuất vượt kế hoạch * lên kế hoạch tác chiến",
    example:
      "bàn kế hoạch đầu tư * sản xuất vượt kế hoạch * lên kế hoạch tác chiến",
  },
  {
    word: "kê kích",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) kê khai (khoản nào đó) cao hơn so với thực tế: kê kích chi phí để trốn thuế",
    example: "kê kích chi phí để trốn thuế",
  },
  {
    word: "kê kích",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nói chêm vào để đùa vui, chế giễu hoặc chọc tức: kê kích lẫn nhau",
    example: "kê kích lẫn nhau",
  },
  {
    word: "kế nhiệm",
    part_of_speech: "động từ",
    meaning:
      "làm thay chức vụ, cương vị của người trước đó: bàn giao công tác cho người kế nhiệm * giám đốc kế nhiệm",
    example: "bàn giao công tác cho người kế nhiệm * giám đốc kế nhiệm",
  },
  {
    word: "kế tiếp",
    part_of_speech: "động từ",
    meaning:
      "tiếp theo, nối liền theo: thế hệ kế tiếp * đồi núi trùng điệp, kế tiếp nhau",
    example: "thế hệ kế tiếp * đồi núi trùng điệp, kế tiếp nhau",
  },
  {
    word: "kế nghiệp",
    part_of_speech: "động từ",
    meaning: "tiếp tục sự nghiệp: tìm người kế nghiệp xứng đáng",
    example: "tìm người kế nghiệp xứng đáng",
  },
  {
    word: "kể ra",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị ý khẳng định về điều qua suy nghĩ thấy có lẽ đúng như thế: bài đó kể ra cũng khó * kể ra thì mình nên giúp nó",
    example: "bài đó kể ra cũng khó * kể ra thì mình nên giúp nó",
  },
  {
    word: "kế sách",
    part_of_speech: "danh từ",
    meaning: "phương sách, mưu kế lớn: bàn kế sách để chống giặc",
    example: "bàn kế sách để chống giặc",
  },
  {
    word: "kề miệng lỗ",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) như gần đất xa trời: sắp kề miệng lỗ rồi còn chơi trống bỏi",
    example: "sắp kề miệng lỗ rồi còn chơi trống bỏi",
  },
  {
    word: "kệ thây",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) như mặc kệ (thường dùng với hàm ý coi khinh): nó thích làm gì, kệ thây nó!",
    example: "nó thích làm gì, kệ thây nó!",
  },
  {
    word: "kế thừa",
    part_of_speech: "động từ",
    meaning:
      "thừa hưởng, giữ gìn và tiếp tục phát huy (cái có giá trị tinh thần): kế thừa cơ nghiệp * kế thừa và phát huy truyền thống tốt đẹp của cha ông",
    example:
      "kế thừa cơ nghiệp * kế thừa và phát huy truyền thống tốt đẹp của cha ông",
  },
  {
    word: "kế toán",
    part_of_speech: "động từ",
    meaning:
      "tính toán và ghi chép tình hình biến động tài sản, tình hình thu chi trong một đơn vị, tổ chức: tuyển kế toán",
    example: "tuyển kế toán",
  },
  {
    word: "kế toán",
    part_of_speech: "danh từ",
    meaning:
      "người chuyên làm công tác kế toán: công ti đang cần tuyển một kế toán mới",
    example: "công ti đang cần tuyển một kế toán mới",
  },
  {
    word: "kể lể",
    part_of_speech: "động từ",
    meaning:
      "kể lại chuyện của mình hoặc có liên quan đến mình một cách tỉ mỉ, dài dòng để mong có sự chú ý, sự cảm thông: kể lể nguồn cơn * kể lể dài dòng",
    example: "kể lể nguồn cơn * kể lể dài dòng",
  },
  {
    word: "kế vị",
    part_of_speech: "động từ",
    meaning:
      "nối ngôi vua: vua Quang Trung mất, con cả là Quang Toản lên kế vị",
    example: "vua Quang Trung mất, con cả là Quang Toản lên kế vị",
  },
  {
    word: "kếch",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) to, lớn quá cỡ: ăn no kếch bụng",
    example: "ăn no kếch bụng",
  },
  {
    word: "kế tục",
    part_of_speech: "động từ",
    meaning:
      "làm tiếp, thực hiện tiếp phần công việc người trước đã làm: kế tục sự nghiệp cách mạng của Hồ Chủ tịch * người kế tục",
    example: "kế tục sự nghiệp cách mạng của Hồ Chủ tịch * người kế tục",
  },
  {
    word: "kệch",
    part_of_speech: "động từ",
    meaning: "(hiếm) như cạch: kệch đến già",
    example: "kệch đến già",
  },
  {
    word: "kệch",
    part_of_speech: "tính từ",
    meaning: "có vẻ thô, trông không hợp mắt: chiếc va li to kệch",
    example: "chiếc va li to kệch",
  },
  {
    word: "kệ xác",
    part_of_speech: "động từ",
    meaning: "(thông tục) như kệ thây: kệ xác mày, muốn đi đâu thì đi!",
    example: "kệ xác mày, muốn đi đâu thì đi!",
  },
  {
    word: "kếch xù",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) to lớn quá mức thường: chiếc áo bông kếch xù * được thừa hưởng một gia tài kếch xù",
    example: "chiếc áo bông kếch xù * được thừa hưởng một gia tài kếch xù",
  },
  {
    word: "kệch cỡm",
    part_of_speech: "tính từ",
    meaning:
      "(cách ăn mặc, nói năng) thô, không phù hợp đến mức khó coi, khó nghe: lối ăn mặc kệch cỡm * câu chào hỏi kệch cỡm",
    example: "lối ăn mặc kệch cỡm * câu chào hỏi kệch cỡm",
  },
  {
    word: "kềm",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ bằng kim loại có hai mỏ và hai càng bắt chéo để kẹp chặt: kìm điện * dùng kìm để nhổ đinh",
    example: "kìm điện * dùng kìm để nhổ đinh",
  },
  {
    word: "kềm",
    part_of_speech: "động từ",
    meaning:
      "tác động nhằm làm cho tốc độ vận động chậm lại, cường độ hoạt động yếu đi, hoặc làm cho phải ngừng lại, không diễn ra: kìm ngựa cho đi chậm lại * không kìm được cơn xúc động",
    example: "kìm ngựa cho đi chậm lại * không kìm được cơn xúc động",
  },
  {
    word: "kên",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) đan: kên tấm phên",
    example: "kên tấm phên",
  },
  {
    word: "kền",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi thông thường của nickel: chiếc xe mới sơn, nước kền còn bóng nhoáng",
    example: "chiếc xe mới sơn, nước kền còn bóng nhoáng",
  },
  {
    word: "kênh",
    part_of_speech: "danh từ",
    meaning:
      "công trình dẫn nước được đào, đắp trên mặt đất, phục vụ cho thuỷ lợi, giao thông: con kênh * dòng kênh",
    example: "con kênh * dòng kênh",
  },
  {
    word: "kênh",
    part_of_speech: "danh từ",
    meaning: "đường thông tin liên lạc chiếm một khoảng tần số nhất định.",
    example: "tạo thêm nhiều kênh để huy động vốn",
  },
  {
    word: "kênh",
    part_of_speech: "động từ",
    meaning:
      "nâng một bên, một đầu vật nặng cho cao lên một chút: kênh một đầu tủ lên để lùa chổi vào quét",
    example: "kênh một đầu tủ lên để lùa chổi vào quét",
  },
  {
    word: "kênh",
    part_of_speech: "tính từ",
    meaning:
      "có vị trí lệch đi, không cân, không ăn khớp: nắp vung đậy bị kênh * tủ kê bị kênh",
    example: "nắp vung đậy bị kênh * tủ kê bị kênh",
  },
  {
    word: "kễnh",
    part_of_speech: "tính từ",
    meaning: "(thông tục) to kềnh: ăn no kễnh bụng",
    example: "ăn no kễnh bụng",
  },
  {
    word: "kệnh",
    part_of_speech: "tính từ",
    meaning:
      "có một phần nổi cao lên, gây vướng víu, do có vật gì bên trong hoặc ở dưới: có cái gì kệnh lên dưới gối",
    example: "có cái gì kệnh lên dưới gối",
  },
  {
    word: "kềnh",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) to hơn rất nhiều so với đồng loại: tôm kềnh * con kiến kềnh * chấy kềnh",
    example: "tôm kềnh * con kiến kềnh * chấy kềnh",
  },
  {
    word: "kềnh",
    part_of_speech: "tính từ",
    meaning: "hay p (to) quá cỡ, khó coi: chữ viết to kềnh * no kềnh",
    example: "chữ viết to kềnh * no kềnh",
  },
  {
    word: "kềnh",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nằm thẳng ra hay lật ngửa ra: nằm kềnh ra giường * ngã kềnh ra đất * đổ kềnh",
    example: "nằm kềnh ra giường * ngã kềnh ra đất * đổ kềnh",
  },
  {
    word: "kềnh kệch",
    part_of_speech: "tính từ",
    meaning:
      "có vẻ bề ngoài trông hơi thô, không thanh, không nhã: đôi bàn tay to kềnh kệch",
    example: "đôi bàn tay to kềnh kệch",
  },
  {
    word: "kênh rạch",
    part_of_speech: "danh từ",
    meaning: "kênh và rạch (nói khái quát): hệ thống kênh rạch chằng chịt",
    example: "hệ thống kênh rạch chằng chịt",
  },
  {
    word: "kênh truyền hình",
    part_of_speech: "danh từ",
    meaning:
      "dải tần số radio dùng để phát các chương trình truyền hình: kênh truyền hình địa phương",
    example: "kênh truyền hình địa phương",
  },
  {
    word: "kềnh kệnh",
    part_of_speech: "tính từ",
    meaning: "như kệnh (nhưng ý mức độ ít): chiếc cặp kềnh kệnh bên sườn",
    example: "chiếc cặp kềnh kệnh bên sườn",
  },
  {
    word: "kênh kiệu",
    part_of_speech: "động từ",
    meaning: "làm cao để tỏ vẻ hơn người: thái độ kênh kiệu * tỏ vẻ kênh kiệu",
    example: "thái độ kênh kiệu * tỏ vẻ kênh kiệu",
  },
  {
    word: "kềnh càng",
    part_of_speech: "tính từ",
    meaning:
      "choán nhiều chỗ, không gọn, làm cản trở sự hoạt động di chuyển: đồ đạc để kềnh càng * bụng chửa kềnh càng",
    example: "đồ đạc để kềnh càng * bụng chửa kềnh càng",
  },
  {
    word: "kết",
    part_of_speech: "động từ",
    meaning:
      "đan, bện: kết thừng * cổng chào kết bằng lá dừa * kết tóc xe tơ (tng)",
    example: "kết thừng * cổng chào kết bằng lá dừa * kết tóc xe tơ (tng)",
  },
  {
    word: "kết",
    part_of_speech: "động từ",
    meaning:
      "tập hợp lại và làm cho gắn chặt với nhau thành một khối: chặt tre kết bè * kết bè lại với nhau",
    example: "chặt tre kết bè * kết bè lại với nhau",
  },
  {
    word: "kết",
    part_of_speech: "động từ",
    meaning:
      "gắn bó với nhau bằng quan hệ tình cảm thân thiết: kết bạn * kết tình anh em",
    example: "kết bạn * kết tình anh em",
  },
  {
    word: "kết",
    part_of_speech: "động từ",
    meaning: "dính bết vào nhau: nhựa cây kết đặc lại",
    example: "nhựa cây kết đặc lại",
  },
  {
    word: "kết",
    part_of_speech: "động từ",
    meaning: "phát triển thành quả, củ, từ hoa hay rễ: đơm hoa kết trái",
    example: "đơm hoa kết trái",
  },
  {
    word: "kết",
    part_of_speech: "động từ",
    meaning:
      "(phần mộ tổ tiên) được đặt nơi mạch đất tốt (theo thuật phong thuỷ), nên đưa lại nhiều may mắn cho con cháu, theo quan niệm dân gian: ngôi mộ kết",
    example: "ngôi mộ kết",
  },
  {
    word: "kết",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) kết thúc hoặc kết luận (nói tắt): phần kết bài * viết dở đoạn kết",
    example: "phần kết bài * viết dở đoạn kết",
  },
  {
    word: "kết",
    part_of_speech: "động từ",
    meaning:
      "(quân bài) làm thành đôi hoặc bộ ba, thắng ở cuối ván bài (trong một số trò chơi đánh bài): bài kết * kết tốt đen",
    example: "bài kết * kết tốt đen",
  },
  {
    word: "kêpi",
    part_of_speech: "danh từ",
    meaning:
      "mũ vải có viền cứng, đáy bằng và rộng, phía trước có lưỡi trai ngắn, thường được trang bị đi kèm với đồng phục cho các lực lượng vũ trang như công an, quân đội và một số lực lượng khác: mũ kêpi",
    example: "mũ kêpi",
  },
  {
    word: "kết cấu",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp các cấu kiện riêng rẽ của công trình xây dựng hay máy móc kết hợp lại, làm thành một thể có chức năng thống nhất: kết cấu bê tông * kết cấu giàn khoan",
    example: "kết cấu bê tông * kết cấu giàn khoan",
  },
  {
    word: "kết cấu",
    part_of_speech: "danh từ",
    meaning:
      "sự phân chia và bố trí các phần, các chương mục theo một hệ thống nhất định để thể hiện nội dung của tác phẩm: bài viết có kết cấu chặt chẽ",
    example: "bài viết có kết cấu chặt chẽ",
  },
  {
    word: "kết án",
    part_of_speech: "động từ",
    meaning:
      "(toà án) tuyên bố về tội trạng và hình phạt: bị kết án chung thân vì tội tham nhũng",
    example: "bị kết án chung thân vì tội tham nhũng",
  },
  {
    word: "kết án",
    part_of_speech: "động từ",
    meaning:
      "lên án, nói rõ công khai về tội lỗi hoặc hành vi sai trái của ai đó: kết án thói hư tật xấu",
    example: "kết án thói hư tật xấu",
  },
  {
    word: "kết cuộc",
    part_of_speech: "danh từ",
    meaning: "(cũ, hiếm) như kết cục: một kết cuộc bi thảm",
    example: "một kết cuộc bi thảm",
  },
  {
    word: "kết cục",
    part_of_speech: "danh từ",
    meaning:
      "kết quả cuối cùng của một sự việc: kết cục là xôi hỏng bỏng không * kết cục của một câu chuyện",
    example: "kết cục là xôi hỏng bỏng không * kết cục của một câu chuyện",
  },
  {
    word: "kết bạn",
    part_of_speech: "động từ",
    meaning:
      "gắn bó với nhau thành bạn thân: hai người kết bạn với nhau đã lâu",
    example: "hai người kết bạn với nhau đã lâu",
  },
  {
    word: "kết bạn",
    part_of_speech: "động từ",
    meaning:
      "(cũ) như kết duyên: trai gái thời nay được tự do kết bạn với nhau",
    example: "trai gái thời nay được tự do kết bạn với nhau",
  },
  {
    word: "kết dính",
    part_of_speech: "động từ",
    meaning:
      "(hiện tượng) hút lẫn nhau giữa các hạt của cùng một chất, làm cho các hạt ấy kết thành một vật thể: chất kết dính * khả năng kết dính của xi măng",
    example: "chất kết dính * khả năng kết dính của xi măng",
  },
  {
    word: "kết cỏ ngậm vành",
    part_of_speech: "",
    meaning:
      '(cũ, văn chương) nguyện báo đáp ơn sâu: "Dám nhờ cốt nhục tử sinh, Còn nhiều kết cỏ ngậm vành về sau." (TKiều)',
    example:
      'Dám nhờ cốt nhục tử sinh, Còn nhiều kết cỏ ngậm vành về sau." (TKiều)',
  },
  {
    word: "kết duyên",
    part_of_speech: "động từ",
    meaning: "(trang trọng) lấy nhau làm vợ chồng: kết duyên vợ chồng",
    example: "kết duyên vợ chồng",
  },
  {
    word: "kết duyên châu trần",
    part_of_speech: "",
    meaning:
      '(cũ, văn chương) như kết duyên: "Chợ Dóng một tháng sáu phiên, Bắt cô hàng xén kết duyên Châu Trần." (ca dao)',
    example:
      'Chợ Dóng một tháng sáu phiên, Bắt cô hàng xén kết duyên Châu Trần." (ca dao)',
  },
  {
    word: "kết đoàn",
    part_of_speech: "động từ",
    meaning: "(cũ) như đoàn kết: bài ca kết đoàn",
    example: "bài ca kết đoàn",
  },
  {
    word: "kết giao",
    part_of_speech: "động từ",
    meaning: "(cũ, trang trọng) như kết bạn: kết giao với bọn người xấu",
    example: "kết giao với bọn người xấu",
  },
  {
    word: "kết luận",
    part_of_speech: "động từ",
    meaning:
      "đưa ra ý cuối cùng được rút ra từ những sự kiện hay lập luận nhất định: có đủ bằng chứng mới có thể kết luận * không nên kết luận vội vàng",
    example:
      "có đủ bằng chứng mới có thể kết luận * không nên kết luận vội vàng",
  },
  {
    word: "kết luận",
    part_of_speech: "danh từ",
    meaning:
      "ý kiến được xem là kết quả của một lập luận: chưa có kết luận rõ ràng",
    example: "chưa có kết luận rõ ràng",
  },
  {
    word: "kết luận",
    part_of_speech: "danh từ",
    meaning:
      "phần kết thúc của một văn bản: bài tập làm văn còn thiếu phần kết luận",
    example: "bài tập làm văn còn thiếu phần kết luận",
  },
  {
    word: "kết hôn",
    part_of_speech: "động từ",
    meaning:
      "chính thức lấy nhau làm vợ chồng: giấy đăng kí kết hôn * làm lễ kết hôn",
    example: "giấy đăng kí kết hôn * làm lễ kết hôn",
  },
  {
    word: "kết hợp",
    part_of_speech: "động từ",
    meaning:
      "gắn với nhau để bổ sung, hỗ trợ cho nhau: học phải kết hợp với hành * kết hợp đấu tranh chính trị với đấu tranh vũ trang",
    example:
      "học phải kết hợp với hành * kết hợp đấu tranh chính trị với đấu tranh vũ trang",
  },
  {
    word: "kết hợp",
    part_of_speech: "động từ",
    meaning:
      "làm thêm một việc gì nhân tiện khi đang làm việc chính: đi công tác, kết hợp về thăm bạn cũ * việc này để khi nào có cơ hội thì kết hợp làm luôn",
    example:
      "đi công tác, kết hợp về thăm bạn cũ * việc này để khi nào có cơ hội thì kết hợp làm luôn",
  },
  {
    word: "kết mạc",
    part_of_speech: "danh từ",
    meaning:
      "màng nhầy phủ lên giác mạc nối cầu mắt với mí mắt đồng thời tạo thành mặt trong của hai mí mắt: viêm kết mạc",
    example: "viêm kết mạc",
  },
  {
    word: "kết nạp",
    part_of_speech: "động từ",
    meaning:
      "chính thức công nhận là thành viên của một tổ chức, một đoàn thể: kết nạp đội viên * lễ kết nạp đoàn viên mới",
    example: "kết nạp đội viên * lễ kết nạp đoàn viên mới",
  },
  {
    word: "kết nghĩa",
    part_of_speech: "động từ",
    meaning:
      'công nhận và vun đắp mối quan hệ tình nghĩa thân thiết, gắn bó giữa hai bên: chị em kết nghĩa * "Bao giờ cho đá mọc mầm, Thời ta kết nghĩa tri âm với mình." (ca dao)',
    example:
      'chị em kết nghĩa * "Bao giờ cho đá mọc mầm, Thời ta kết nghĩa tri âm với mình." (ca dao)',
  },
  {
    word: "kết nối",
    part_of_speech: "động từ",
    meaning:
      "làm cho các phần đang tách rời nối liền lại, gắn liền lại với nhau: kết nối Internet * kết nối thông tin * kết nối tình anh em",
    example: "kết nối Internet * kết nối thông tin * kết nối tình anh em",
  },
  {
    word: "kết quả",
    part_of_speech: "danh từ",
    meaning:
      "cái đạt được, thu được trong một công việc hoặc một quá trình tiến triển của sự vật: kết quả học tập * việc làm không có kết quả",
    example: "kết quả học tập * việc làm không có kết quả",
  },
  {
    word: "kết quả",
    part_of_speech: "danh từ",
    meaning:
      "cái do một hay nhiều hiện tượng khác (gọi là nguyên nhân) gây ra, tạo ra, trong quan hệ với những hiện tượng ấy: quan hệ giữa nguyên nhân và kết quả",
    example: "quan hệ giữa nguyên nhân và kết quả",
  },
  {
    word: "kết nguyền",
    part_of_speech: "động từ",
    meaning:
      '(cũ, văn chương) nguyện cùng kết nghĩa với nhau: kết nguyền phu thê * "Trời xui mai trúc một cành, Trời xui lan huệ yến anh kết nguyền." (MPXH)',
    example:
      'kết nguyền phu thê * "Trời xui mai trúc một cành, Trời xui lan huệ yến anh kết nguyền." (MPXH)',
  },
  {
    word: "kết liễu",
    part_of_speech: "động từ",
    meaning:
      "làm cho vĩnh viễn mất đi, chấm dứt hoàn toàn sự sống: kết liễu cuộc đời",
    example: "kết liễu cuộc đời",
  },
  {
    word: "kết thân",
    part_of_speech: "động từ",
    meaning: "(cũ, hiếm) như kết bạn: hai người kết thân với nhau đã lâu",
    example: "hai người kết thân với nhau đã lâu",
  },
  {
    word: "kết thúc",
    part_of_speech: "động từ",
    meaning:
      "hết hẳn, ngừng hoàn toàn sau một quá trình hoạt động, diễn biến nào đó: mùa mưa sắp kết thúc * bộ phim kết thúc có hậu",
    example: "mùa mưa sắp kết thúc * bộ phim kết thúc có hậu",
  },
  {
    word: "kết thúc",
    part_of_speech: "động từ",
    meaning:
      "làm những việc cần thiết để cho đi đến chấm dứt một quá trình hoạt động, diễn biến nào đó: buổi lễ kết thúc năm học * kết thúc hội nghị",
    example: "buổi lễ kết thúc năm học * kết thúc hội nghị",
  },
  {
    word: "kết tóc",
    part_of_speech: "động từ",
    meaning:
      '(cũ, văn chương) bện tóc lại thành bím, thành dải; thường dùng để nói việc kết duyên: "Cho chàng vào lễ tơ hồng, Ả, anh kết tóc phỉ lòng ước ao." (CC)',
    example: 'Cho chàng vào lễ tơ hồng, Ả, anh kết tóc phỉ lòng ước ao." (CC)',
  },
  {
    word: "kết tóc xe tơ",
    part_of_speech: "",
    meaning:
      '(văn chương) kết duyên vợ chồng: "Thương nàng, nàng cứ làm ngơ, Bao giờ kết tóc xe tơ hỡi nàng." (ca dao)',
    example:
      'Thương nàng, nàng cứ làm ngơ, Bao giờ kết tóc xe tơ hỡi nàng." (ca dao)',
  },
  {
    word: "kết tinh",
    part_of_speech: "động từ",
    meaning:
      "(quá trình) hình thành tinh thể từ trạng thái lỏng: ruộng muối bắt đầu kết tinh",
    example: "ruộng muối bắt đầu kết tinh",
  },
  {
    word: "kết tinh",
    part_of_speech: "động từ",
    meaning:
      "được chắt lọc và cô đúc từ những gì được coi là tinh tuý, là tốt đẹp nhất: văn hoá Việt được kết tinh từ truyền thống nghìn năm văn hiến",
    example: "văn hoá Việt được kết tinh từ truyền thống nghìn năm văn hiến",
  },
  {
    word: "kết tinh",
    part_of_speech: "danh từ",
    meaning: "chất tồn tại dưới dạng tinh thể: kết tinh của muối",
    example: "kết tinh của muối",
  },
  {
    word: "kết tụ",
    part_of_speech: "động từ",
    meaning: "(quá trình) hình thành tinh thể từ trạng thái khí.",
    example: "mây kết tụ thành đám * trống đồng đã kết tụ tinh hoa của dân tộc",
  },
  {
    word: "kết tủa",
    part_of_speech: "danh từ",
    meaning: "chất rắn có được do kết tủa: phản ứng thu được kết tủa",
    example: "phản ứng thu được kết tủa",
  },
  {
    word: "kết ước",
    part_of_speech: "",
    meaning: "(cũ, hiếm) như giao ước: hai nhà đã kết ước làm thông gia",
    example: "hai nhà đã kết ước làm thông gia",
  },
  {
    word: "kết tội",
    part_of_speech: "động từ",
    meaning: "khép vào tội, xác định khung hình phạt: bị toà kết tội tử hình",
    example: "bị toà kết tội tử hình",
  },
  {
    word: "kêu ca",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nói ra điều buồn bực, chê trách để tỏ thái độ không bằng lòng (nói khái quát): khổ thì chịu, chứ không kêu ca * tính hay kêu ca",
    example: "khổ thì chịu, chứ không kêu ca * tính hay kêu ca",
  },
  {
    word: "kêu cầu",
    part_of_speech: "động từ",
    meaning:
      "cầu xin thần thánh hoặc người trên phù hộ, cứu giúp: kêu cầu trời Phật phù hộ",
    example: "kêu cầu trời Phật phù hộ",
  },
  {
    word: "kều",
    part_of_speech: "động từ",
    meaning: "như khều (ng1): lấy que kều quả bóng trong gầm giường",
    example: "lấy que kều quả bóng trong gầm giường",
  },
  {
    word: "kêu",
    part_of_speech: "động từ",
    meaning:
      '(động vật) phát ra âm thanh tự nhiên có tính chất bản năng: lợn kêu * "Chiều chiều chim vịt kêu chiều, Bâng khuâng nhớ bạn chín chiều ruột đau." (ca dao)',
    example:
      'lợn kêu * "Chiều chiều chim vịt kêu chiều, Bâng khuâng nhớ bạn chín chiều ruột đau." (ca dao)',
  },
  {
    word: "kêu",
    part_of_speech: "động từ",
    meaning:
      "phát ra âm thanh do có sự cọ xát, va chạm hoặc rung động: tiếng võng kêu kẽo kẹt",
    example: "tiếng võng kêu kẽo kẹt",
  },
  {
    word: "kêu",
    part_of_speech: "động từ",
    meaning:
      "bật ra, thốt ra tiếng hoặc lời do bị kích thích: kêu đau * kêu cứu * kêu lên cho mọi người cùng biết",
    example: "kêu đau * kêu cứu * kêu lên cho mọi người cùng biết",
  },
  {
    word: "kêu",
    part_of_speech: "động từ",
    meaning:
      "nói ra nỗi buồn bực, không vừa ý về điều gì: kêu khổ * hơi khó khăn một tí đã kêu * kêu đắt",
    example: "kêu khổ * hơi khó khăn một tí đã kêu * kêu đắt",
  },
  {
    word: "kêu",
    part_of_speech: "động từ",
    meaning: "cầu xin, khiếu nại: kêu oan",
    example: "kêu oan",
  },
  {
    word: "kêu",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) gọi để người khác đến với mình: kêu con về ăn cơm * kêu tên từ ngoài ngõ",
    example: "kêu con về ăn cơm * kêu tên từ ngoài ngõ",
  },
  {
    word: "kêu",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) gọi bằng: tôi kêu ông ấy là bác",
    example: "tôi kêu ông ấy là bác",
  },
  {
    word: "kêu",
    part_of_speech: "tính từ",
    meaning: "có âm thanh to, vang: pháo nổ rất kêu * chuông kêu",
    example: "pháo nổ rất kêu * chuông kêu",
  },
  {
    word: "kêu",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (lời văn, từ ngữ) nghe có vẻ hay, hấp dẫn (nhưng thường không có nội dung sâu sắc): văn viết rất kêu * tên nghe kêu quá * thích dùng những chữ thật kêu",
    example:
      "văn viết rất kêu * tên nghe kêu quá * thích dùng những chữ thật kêu",
  },
  {
    word: "kêu van",
    part_of_speech: "động từ",
    meaning:
      "kêu xin, van nài bằng những lời thống thiết: kêu van xin tha tội * dù bị đòn roi cũng không chịu kêu van",
    example: "kêu van xin tha tội * dù bị đòn roi cũng không chịu kêu van",
  },
  {
    word: "kêu trời",
    part_of_speech: "động từ",
    meaning:
      "kêu than với trời đất khi gặp chuyện không may: kêu trời không thấu * giậm chân kêu trời",
    example: "kêu trời không thấu * giậm chân kêu trời",
  },
  {
    word: "kêu gọi",
    part_of_speech: "động từ",
    meaning:
      "lên tiếng yêu cầu, động viên mọi người làm việc gì (thường là việc quan trọng): kêu gọi toàn dân đánh giặc * kêu gọi bảo vệ rừng",
    example: "kêu gọi toàn dân đánh giặc * kêu gọi bảo vệ rừng",
  },
  {
    word: "kêu la",
    part_of_speech: "động từ",
    meaning: "kêu to lên (nói khái quát): kêu la thảm thiết",
    example: "kêu la thảm thiết",
  },
  {
    word: "kêu nài",
    part_of_speech: "động từ",
    meaning:
      'kêu ca, nài nỉ nhiều: "Mèo lành ai nỡ cắt tai, Gái hư chồng để kêu nài ai thương." (ca dao)',
    example:
      'Mèo lành ai nỡ cắt tai, Gái hư chồng để kêu nài ai thương." (ca dao)',
  },
  {
    word: "kêu gào",
    part_of_speech: "động từ",
    meaning: "gào to vì đau đớn hay phẫn uất: kêu gào đến khản cổ",
    example: "kêu gào đến khản cổ",
  },
  {
    word: "kêu gào",
    part_of_speech: "động từ",
    meaning: "lên tiếng ầm ĩ để kêu: dân chúng kêu gào vì bị quan lại ức hiếp",
    example: "dân chúng kêu gào vì bị quan lại ức hiếp",
  },
  {
    word: "khá",
    part_of_speech: "tính từ",
    meaning:
      "ở mức độ, trình độ trên trung bình chút ít: xếp loại khá * học sinh khá * thành tích ở mức độ khá",
    example: "xếp loại khá * học sinh khá * thành tích ở mức độ khá",
  },
  {
    word: "khá",
    part_of_speech: "tính từ",
    meaning:
      "ở mức cao tương đối, so với cái đưa ra để so sánh: sức khoẻ đã khá hơn trước * con bé học khá hơn bạn nó",
    example: "sức khoẻ đã khá hơn trước * con bé học khá hơn bạn nó",
  },
  {
    word: "khá",
    part_of_speech: "phụ từ",
    meaning:
      "ở mức độ cao một cách tương đối: công việc khá vất vả * tốn khá nhiều thời gian",
    example: "công việc khá vất vả * tốn khá nhiều thời gian",
  },
  {
    word: "khả ái",
    part_of_speech: "tính từ",
    meaning:
      "đẹp một cách dịu dàng, trang nhã, giành được thiện cảm của người khác (thường nói về vẻ đẹp của người con gái): nụ cười khả ái * gương mặt khả ái",
    example: "nụ cười khả ái * gương mặt khả ái",
  },
  {
    word: "khả biến",
    part_of_speech: "tính từ",
    meaning:
      "có thể biến đổi, có thể phát triển; phân biệt với bất biến: tư bản khả biến * chi phí khả biến",
    example: "tư bản khả biến * chi phí khả biến",
  },
  {
    word: "khà",
    part_of_speech: "động từ",
    meaning:
      "từ mô phỏng tiếng luồng hơi bật từ trong cổ họng ra, vẻ thích thú, khoan khoái: nhấp ngụm nước trà xong, khà một tiếng",
    example: "nhấp ngụm nước trà xong, khà một tiếng",
  },
  {
    word: "khả dĩ",
    part_of_speech: "phụ từ",
    meaning:
      'có thể, có khả năng: "Tôi sục tìm trong bè xem có vật nào khả dĩ dùng làm bơi chèo được." (THoài; 8)',
    example:
      'Tôi sục tìm trong bè xem có vật nào khả dĩ dùng làm bơi chèo được." (THoài; 8)',
  },
  {
    word: "khả dĩ",
    part_of_speech: "phụ từ",
    meaning:
      "hoặc t tạm được, có thể chấp nhận được: một ý kiến nghe có vẻ khả dĩ * nói thế khả dĩ còn nghe được",
    example: "một ý kiến nghe có vẻ khả dĩ * nói thế khả dĩ còn nghe được",
  },
  {
    word: "khả dụng",
    part_of_speech: "tính từ",
    meaning:
      "có khả năng sử dụng, ứng dụng được: nguồn nguyên liệu khả dụng * tính khả dụng của các hệ điều hành máy tính",
    example:
      "nguồn nguyên liệu khả dụng * tính khả dụng của các hệ điều hành máy tính",
  },
  {
    word: "khá giả",
    part_of_speech: "tính từ",
    meaning:
      "ở mức có tương đối đầy đủ những gì thuộc về yêu cầu của đời sống vật chất, ăn tiêu dư dả: con nhà khá giả",
    example: "con nhà khá giả",
  },
  {
    word: "kha khá",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) như khá (nhưng ý mức độ ít): góp được một số vốn kha khá",
    example: "góp được một số vốn kha khá",
  },
  {
    word: "khá khẩm",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) khá, thường về mặt vật chất (nói khái quát): hàng họ khá khẩm * nhà ấy dạo này cũng khá khẩm",
    example: "hàng họ khá khẩm * nhà ấy dạo này cũng khá khẩm",
  },
  {
    word: "khả nghi",
    part_of_speech: "tính từ",
    meaning: "đáng ngờ, khó có thể tin: dấu hiệu khả nghi",
    example: "dấu hiệu khả nghi",
  },
  {
    word: "khạc",
    part_of_speech: "động từ",
    meaning:
      "bật mạnh hơi để đẩy vật đang vướng trong cổ họng ra ngoài: khạc đờm * khẩu đại bác liên tục khạc lửa",
    example: "khạc đờm * khẩu đại bác liên tục khạc lửa",
  },
  {
    word: "khác biệt",
    part_of_speech: "",
    meaning:
      "khác nhau, có những nét riêng làm cho có thể phân biệt với nhau: có sự khác biệt giữa thành thị và nông thôn",
    example: "có sự khác biệt giữa thành thị và nông thôn",
  },
  {
    word: "khả năng",
    part_of_speech: "danh từ",
    meaning:
      "cái có thể xuất hiện, có thể xảy ra trong điều kiện nhất định: cơn bão có khả năng sẽ suy yếu dần * tình hình chiến sự có khả năng thay đổi",
    example:
      "cơn bão có khả năng sẽ suy yếu dần * tình hình chiến sự có khả năng thay đổi",
  },
  {
    word: "khả năng",
    part_of_speech: "danh từ",
    meaning:
      "cái vốn có về vật chất hoặc tinh thần để có thể làm được việc gì: không còn khả năng sinh nở * yêu cầu vượt quá khả năng cho phép",
    example: "không còn khả năng sinh nở * yêu cầu vượt quá khả năng cho phép",
  },
  {
    word: "khả kính",
    part_of_speech: "tính từ",
    meaning: "đáng kính trọng: vị giáo sư khả kính * một con người khả kính",
    example: "vị giáo sư khả kính * một con người khả kính",
  },
  {
    word: "khả quan",
    part_of_speech: "tính từ",
    meaning:
      "tương đối tốt đẹp và có khả năng ngày càng tốt đẹp, có thể yên tâm được: kết quả khả quan * bệnh tình đã có vẻ khả quan hơn",
    example: "kết quả khả quan * bệnh tình đã có vẻ khả quan hơn",
  },
  {
    word: "khả ố",
    part_of_speech: "tính từ",
    meaning: "xấu xa, thô lỗ đến mức thấy ghê tởm: bộ mặt khả ố * cười khả ố",
    example: "bộ mặt khả ố * cười khả ố",
  },
  {
    word: "khả thi",
    part_of_speech: "tính từ",
    meaning:
      "có khả năng thực hiện được: dự án có tính khả thi * một giải pháp khả thi",
    example: "dự án có tính khả thi * một giải pháp khả thi",
  },
  {
    word: "khác",
    part_of_speech: "tính từ",
    meaning:
      "không có những nét chung, những nét tương tự nên có thể phân biệt được với nhau khi so sánh: là chị em nhưng khuôn mặt khác hẳn nhau * tính mỗi người mỗi khác",
    example:
      "là chị em nhưng khuôn mặt khác hẳn nhau * tính mỗi người mỗi khác",
  },
  {
    word: "khác",
    part_of_speech: "tính từ",
    meaning:
      "không phải là cái đã biết, đã nói đến, tuy là cùng loại: lấy hộ tôi cái bát khác * để dịp khác * đi chỗ khác chơi",
    example: "lấy hộ tôi cái bát khác * để dịp khác * đi chỗ khác chơi",
  },
  {
    word: "khác gì",
    part_of_speech: "",
    meaning:
      'không có gì khác; giống như: "Có chồng mà chẳng có con, Khác gì hoa nở trên non một mình." (ca dao)',
    example:
      'Có chồng mà chẳng có con, Khác gì hoa nở trên non một mình." (ca dao)',
  },
  {
    word: "khách hàng",
    part_of_speech: "danh từ",
    meaning:
      "đối tượng mua hàng hoặc sử dụng dịch vụ, trong quan hệ với đối tượng bán hàng hoặc cung cấp dịch vụ: khách hàng là thượng đế * dịch vụ chăm sóc khách hàng",
    example: "khách hàng là thượng đế * dịch vụ chăm sóc khách hàng",
  },
  {
    word: "khách khí",
    part_of_speech: "tính từ",
    meaning:
      "có vẻ như là khách, tỏ ra giữ gìn, dè dặt, không tự nhiên, thoải mái trong việc làm, cách cư xử: ăn nói khách khí * là bạn bè nên không phải khách khí",
    example: "ăn nói khách khí * là bạn bè nên không phải khách khí",
  },
  {
    word: "khách",
    part_of_speech: "danh từ",
    meaning:
      "người từ nơi khác đến, trong quan hệ với chủ nhà, với người đón tiếp: tiếp khách * dẫn khách đi tham quan * nhà có khách",
    example: "tiếp khách * dẫn khách đi tham quan * nhà có khách",
  },
  {
    word: "khách",
    part_of_speech: "danh từ",
    meaning:
      "người đến để mua bán, giao dịch, trong quan hệ với cửa hiệu, cửa hàng, v.v.: quảng cáo để thu hút khách * khách đến mua hàng",
    example: "quảng cáo để thu hút khách * khách đến mua hàng",
  },
  {
    word: "khách",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) hành khách (nói tắt): khách đi tàu * taxi đang chở khách",
    example: "khách đi tàu * taxi đang chở khách",
  },
  {
    word: "khách",
    part_of_speech: "danh từ",
    meaning:
      '(Từ cũ, Văn chương) người có tài, sắc được xã hội hâm mộ: khách văn chương * "Mười lăm năm bấy nhiêu lần, Làm gương cho khách hồng quần thử soi!" (TKiều)',
    example:
      'khách văn chương * "Mười lăm năm bấy nhiêu lần, Làm gương cho khách hồng quần thử soi!" (TKiều)',
  },
  {
    word: "khác thường",
    part_of_speech: "tính từ",
    meaning:
      "không giống với bình thường, với điều thường thấy: thái độ khác thường * có những biểu hiện khác thường",
    example: "thái độ khác thường * có những biểu hiện khác thường",
  },
  {
    word: "khách khứa",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) khách đến thăm (nói khái quát): khách khứa đến đầy nhà * khách khứa tấp nập",
    example: "khách khứa đến đầy nhà * khách khứa tấp nập",
  },
  {
    word: "khách quan",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về khách quan, không thuộc về chủ quan: điều kiện khách quan * thực tế khách quan",
    example: "điều kiện khách quan * thực tế khách quan",
  },
  {
    word: "khách quan",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất xuất phát từ thực tế, biểu hiện thực tế một cách trung thực, không thiên lệch: đánh giá thiếu khách quan",
    example: "đánh giá thiếu khách quan",
  },
  {
    word: "khách quan chủ nghĩa",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất của chủ nghĩa khách quan, theo chủ nghĩa khách quan: quan điểm khách quan chủ nghĩa",
    example: "quan điểm khách quan chủ nghĩa",
  },
  {
    word: "khác nào",
    part_of_speech: "",
    meaning:
      'giống như, không có gì phân biệt: "Thân em đi lấy chồng chung, Khác nào như cái bung xung chịu đòn!" (ca dao)',
    example:
      'Thân em đi lấy chồng chung, Khác nào như cái bung xung chịu đòn!" (ca dao)',
  },
  {
    word: "khách sáo",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất xã giao, lịch sự bề ngoài, thiếu thân mật, đôi khi không thật lòng: cư xử khách sáo * chỗ anh em, không nên khách sáo",
    example: "cư xử khách sáo * chỗ anh em, không nên khách sáo",
  },
  {
    word: "khách sạn",
    part_of_speech: "danh từ",
    meaning:
      "nhà xây thành nhiều phòng với mục đích cho khách thuê, có đủ tiện nghi phục vụ việc ăn ở của khách trọ: khách sạn năm sao (khách sạn đạt tiêu chuẩn cao nhất)",
    example: "khách sạn năm sao (khách sạn đạt tiêu chuẩn cao nhất)",
  },
  {
    word: "khách thể",
    part_of_speech: "danh từ",
    meaning:
      "thế giới bên ngoài, độc lập với ý thức của con người, về mặt là đối tượng nhận thức của con người, với tư cách là chủ thể: sự phản ánh của khách thể vào ý thức",
    example: "sự phản ánh của khách thể vào ý thức",
  },
  {
    word: "khái",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) khái tính (nói tắt): tính anh ấy rất khái, không chịu nhờ vả ai",
    example: "tính anh ấy rất khái, không chịu nhờ vả ai",
  },
  {
    word: "khai báo",
    part_of_speech: "động từ",
    meaning:
      "khai với nhà chức trách những việc có liên quan đến mình hay những việc mình biết: khai báo thành khẩn * khai báo hộ khẩu",
    example: "khai báo thành khẩn * khai báo hộ khẩu",
  },
  {
    word: "khai báo",
    part_of_speech: "động từ",
    meaning:
      "(thành phần của một ngôn ngữ dùng để) đưa vào một hay nhiều tên gọi trong một chương trình máy tính và chỉ cách hiểu về (những) tên gọi đó: khai báo mật khẩu để truy cập máy tính",
    example: "khai báo mật khẩu để truy cập máy tính",
  },
  {
    word: "khai căn",
    part_of_speech: "động từ",
    meaning:
      "tìm căn của một biểu thức hoặc một số: phép khai căn * khai căn bậc ba của biểu thức",
    example: "phép khai căn * khai căn bậc ba của biểu thức",
  },
  {
    word: "khai chiến",
    part_of_speech: "động từ",
    meaning:
      "bắt đầu đánh nhau, mở đầu cuộc chiến tranh: hai nước bắt đầu khai chiến",
    example: "hai nước bắt đầu khai chiến",
  },
  {
    word: "khai",
    part_of_speech: "động từ",
    meaning:
      "mở rộng ra, gạt bỏ những vật chắn, vật cản trở để cho thông lối thoát: khai cống rãnh",
    example: "khai cống rãnh",
  },
  {
    word: "khai",
    part_of_speech: "động từ",
    meaning:
      "mở ra, làm cho bắt đầu tồn tại hoặc hoạt động: tiếng trống khai hội * ngày khai trường",
    example: "tiếng trống khai hội * ngày khai trường",
  },
  {
    word: "khai",
    part_of_speech: "động từ",
    meaning: "(Khẩu ngữ) khai thác (nói tắt): khai mỏ",
    example: "khai mỏ",
  },
  {
    word: "khai",
    part_of_speech: "động từ",
    meaning:
      "nói hoặc viết ra theo yêu cầu của một tổ chức nào đó, cho biết rõ điều cần biết về mình hoặc điều mình biết: khai lí lịch * khai hồ sơ thuế * khai man (khai không đúng sự thật)",
    example:
      "khai lí lịch * khai hồ sơ thuế * khai man (khai không đúng sự thật)",
  },
  {
    word: "khai",
    part_of_speech: "động từ",
    meaning:
      "tiết lộ ra điều bí mật khi bị tra hỏi: tên cướp đã khai ra đồng bọn * lấy lời khai",
    example: "tên cướp đã khai ra đồng bọn * lấy lời khai",
  },
  {
    word: "khai",
    part_of_speech: "tính từ",
    meaning: "có mùi như mùi nước tiểu: khí ammoniac có mùi khai",
    example: "khí ammoniac có mùi khai",
  },
  {
    word: "khai bút",
    part_of_speech: "động từ",
    meaning:
      "cầm bút viết hoặc vẽ lần đầu tiên vào dịp đầu năm, theo tục xưa: khai bút đầu xuân",
    example: "khai bút đầu xuân",
  },
  {
    word: "khai giảng",
    part_of_speech: "động từ",
    meaning:
      "bắt đầu, mở đầu một năm học, khoá học: khai giảng lớp huấn luyện quân sự * học sinh dự lễ khai giảng",
    example: "khai giảng lớp huấn luyện quân sự * học sinh dự lễ khai giảng",
  },
  {
    word: "khai cuộc",
    part_of_speech: "động từ",
    meaning:
      "bắt đầu (cuộc vui, cuộc thi đấu, hội diễn, v.v.): khai cuộc diễn võ",
    example: "khai cuộc diễn võ",
  },
  {
    word: "khai hấn",
    part_of_speech: "động từ",
    meaning: "(cũ) như gây hấn: quân giặc đang tìm cách khai hấn",
    example: "quân giặc đang tìm cách khai hấn",
  },
  {
    word: "khai hạ",
    part_of_speech: "động từ",
    meaning:
      "(cũ) làm lễ hạ nêu sau những ngày Tết, thường vào ngày mồng bảy tháng giêng âm lịch, theo tục xưa: ngày khai hạ",
    example: "ngày khai hạ",
  },
  {
    word: "khai hoả",
    part_of_speech: "động từ",
    meaning: "bắt đầu nổ súng: đến giờ khai hoả",
    example: "đến giờ khai hoả",
  },
  {
    word: "khai hoa",
    part_of_speech: "động từ",
    meaning:
      "(văn chương) nở hoa; thường dùng để nói về việc sinh nở của phụ nữ: mãn nguyệt khai hoa",
    example: "mãn nguyệt khai hoa",
  },
  {
    word: "khải hoàn",
    part_of_speech: "động từ",
    meaning: "(Từ cũ, Văn chương) thắng trận trở về: ca khúc khải hoàn",
    example: "ca khúc khải hoàn",
  },
  {
    word: "khai hoá",
    part_of_speech: "động từ",
    meaning:
      "(cũ) mở mang văn hoá cho một dân tộc lạc hậu (từ thường dùng để tô vẽ, bao biện cho những chiêu bài của chủ nghĩa thực dân): khai hoá thuộc địa * nhà khai hoá",
    example: "khai hoá thuộc địa * nhà khai hoá",
  },
  {
    word: "khai khẩn",
    part_of_speech: "động từ",
    meaning:
      "làm cho đất hoang trở thành đất trồng trọt (nói khái quát): khai khẩn đất hoang * khai khẩn đất để làm ruộng",
    example: "khai khẩn đất hoang * khai khẩn đất để làm ruộng",
  },
  {
    word: "khai khẩn",
    part_of_speech: "động từ",
    meaning:
      "(Từ cũ, Ít dùng) như khai thác (ng1): khai khẩn tài nguyên thiên nhiên",
    example: "khai khẩn tài nguyên thiên nhiên",
  },
  {
    word: "khai hoang",
    part_of_speech: "động từ",
    meaning:
      "khai phá vùng đất hoang: công cuộc khai hoang lấn biển * đi khai hoang",
    example: "công cuộc khai hoang lấn biển * đi khai hoang",
  },
  {
    word: "khai hội",
    part_of_speech: "động từ",
    meaning:
      "bắt đầu mở hội: lễ hội chùa Hương thường khai hội vào ngày mùng sáu tháng giêng",
    example: "lễ hội chùa Hương thường khai hội vào ngày mùng sáu tháng giêng",
  },
  {
    word: "khai khoáng",
    part_of_speech: "động từ",
    meaning:
      "khai thác tài nguyên, khoáng sản ở trong lòng đất: công nghệ khai khoáng * thiết bị khai khoáng",
    example: "công nghệ khai khoáng * thiết bị khai khoáng",
  },
  {
    word: "khái luận",
    part_of_speech: "",
    meaning:
      "bản văn trình bày hoặc bàn luận những nội dung khái quát nhất của một bộ môn khoa học, của một vấn đề: khái luận triết học",
    example: "khái luận triết học",
  },
  {
    word: "khái lược",
    part_of_speech: "",
    meaning:
      "(cũ, hiếm) chỉ gồm những nét tóm tắt, có tính chất khái quát, sơ lược về một nội dung nào đó: khái lược những nét chính",
    example: "khái lược những nét chính",
  },
  {
    word: "khai mạc",
    part_of_speech: "động từ",
    meaning:
      "mở đầu, bắt đầu (hội nghị, cuộc biểu diễn, cuộc triển lãm, v.v.): đọc diễn văn khai mạc * lễ khai mạc",
    example: "đọc diễn văn khai mạc * lễ khai mạc",
  },
  {
    word: "khai phá",
    part_of_speech: "động từ",
    meaning:
      "làm cho vùng đất hoang vu hoặc những tài nguyên đang còn tiềm ẩn trở thành sử dụng được: khai phá đất hoang * khai phá dữ liệu (tìm kiếm thông tin có ích trong kho dữ liệu)",
    example:
      "khai phá đất hoang * khai phá dữ liệu (tìm kiếm thông tin có ích trong kho dữ liệu)",
  },
  {
    word: "khái quát",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất chung cho một loạt sự vật, hiện tượng: đặc điểm khái quát * cách nhìn khái quát",
    example: "đặc điểm khái quát * cách nhìn khái quát",
  },
  {
    word: "khái niệm",
    part_of_speech: "danh từ",
    meaning:
      "ý nghĩ phản ánh ở dạng khái quát các sự vật và hiện tượng của hiện thực và những mối liên hệ giữa chúng: khái niệm khoa học * khái niệm giai cấp",
    example: "khái niệm khoa học * khái niệm giai cấp",
  },
  {
    word: "khái niệm",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) sự hình dung đại khái, sự hiểu biết còn đơn giản, sơ lược về một sự vật, hiện tượng, vấn đề nào đó: tôi không có khái niệm gì về chuyện ấy",
    example: "tôi không có khái niệm gì về chuyện ấy",
  },
  {
    word: "khai mào",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) mở đầu câu chuyện: khai mào câu chuyện",
    example: "khai mào câu chuyện",
  },
  {
    word: "khai quang",
    part_of_speech: "động từ",
    meaning:
      "làm cho vùng đất có cây cối rậm rạp trở thành quang đãng, để có thể sử dụng vào một mục đích cụ thể nào đó: khai quang bụi rậm",
    example: "khai quang bụi rậm",
  },
  {
    word: "khái quát hoá",
    part_of_speech: "động từ",
    meaning:
      "thực hiện hoạt động tư duy để khái quát: khái quát hoá toàn bộ vấn đề",
    example: "khái quát hoá toàn bộ vấn đề",
  },
  {
    word: "khai quật",
    part_of_speech: "động từ",
    meaning:
      "đào bới để tìm ra, lấy lên cái chôn vùi trong lòng đất: khai quật một ngôi mộ cổ",
    example: "khai quật một ngôi mộ cổ",
  },
  {
    word: "khai quốc công thần",
    part_of_speech: "",
    meaning:
      "(cũ) người có công lớn trong việc xây dựng một quốc gia hoặc một triều đại: Nguyễn Trãi là bậc khai quốc công thần đời Lê",
    example: "Nguyễn Trãi là bậc khai quốc công thần đời Lê",
  },
  {
    word: "khai sinh",
    part_of_speech: "động từ",
    meaning:
      "khai báo những thông tin cần thiết về mặt thủ tục hành chính cho đứa trẻ mới sinh: đi khai sinh cho con * làm thủ tục khai sinh cho cháu * giấy khai sinh",
    example:
      "đi khai sinh cho con * làm thủ tục khai sinh cho cháu * giấy khai sinh",
  },
  {
    word: "khai thác",
    part_of_speech: "động từ",
    meaning:
      "tiến hành hoạt động để thu lấy những nguồn lợi sẵn có trong thiên nhiên: khai thác khoáng sản * khai thác than * có kế hoạch khai thác gỗ hợp lí",
    example:
      "khai thác khoáng sản * khai thác than * có kế hoạch khai thác gỗ hợp lí",
  },
  {
    word: "khai thác",
    part_of_speech: "động từ",
    meaning:
      "phát hiện và sử dụng những cái có ích còn ẩn giấu hoặc chưa được tận dụng: khai thác thị trường trong nước * khai thác nguồn tư liệu quý",
    example: "khai thác thị trường trong nước * khai thác nguồn tư liệu quý",
  },
  {
    word: "khai thác",
    part_of_speech: "động từ",
    meaning:
      "tra xét, dò hỏi để biết được những bí mật của đối phương: khai thác tù binh",
    example: "khai thác tù binh",
  },
  {
    word: "khai sáng",
    part_of_speech: "động từ",
    meaning:
      "(cũ) sáng lập nên một sự nghiệp lớn: Lý Công Uẩn là người khai sáng cơ nghiệp nhà Lý",
    example: "Lý Công Uẩn là người khai sáng cơ nghiệp nhà Lý",
  },
  {
    word: "khai thông",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) làm cho thông, cho không còn bị cản trở, tắc nghẽn nữa: khai thông cống rãnh * khai thông tuyến vận tải đường sông",
    example: "khai thông cống rãnh * khai thông tuyến vận tải đường sông",
  },
  {
    word: "khai thông",
    part_of_speech: "động từ",
    meaning: "(cũ) làm cho mở mang trí óc: khai thông dân trí",
    example: "khai thông dân trí",
  },
  {
    word: "khai thiên lập địa",
    part_of_speech: "",
    meaning:
      "lúc mới bắt đầu có trời đất, theo truyền thuyết; thường dùng để chỉ thời kì xa xưa nhất: có từ thuở khai thiên lập địa",
    example: "có từ thuở khai thiên lập địa",
  },
  {
    word: "khai triển",
    part_of_speech: "động từ",
    meaning: "(hiếm) như triển khai: khai triển công tác giải phóng mặt bằng",
    example: "khai triển công tác giải phóng mặt bằng",
  },
  {
    word: "khai triển",
    part_of_speech: "động từ",
    meaning:
      "mở rộng một biểu thức thành một tổng nhiều số hạng: khai triển (a - b)2 thành a2 - 2ab + b2",
    example: "khai triển (a - b)2 thành a2 - 2ab + b2",
  },
  {
    word: "khai triển",
    part_of_speech: "động từ",
    meaning:
      "trải ra trên một mặt phẳng: khai triển mặt bên của hình nón sẽ được hình quạt",
    example: "khai triển mặt bên của hình nón sẽ được hình quạt",
  },
  {
    word: "khai trừ",
    part_of_speech: "động từ",
    meaning:
      "đưa ra khỏi tổ chức, không công nhận là một thành viên nữa: bị khai trừ ra khỏi Đảng",
    example: "bị khai trừ ra khỏi Đảng",
  },
  {
    word: "khái tính",
    part_of_speech: "tính từ",
    meaning:
      "có tính không muốn, không chịu nhờ vả, phiền luỵ ai: người rất khái tính",
    example: "người rất khái tính",
  },
  {
    word: "khai quốc",
    part_of_speech: "động từ",
    meaning:
      "(cũ) dựng nước hoặc lập nên một triều đại: Vua Hùng có công khai quốc",
    example: "Vua Hùng có công khai quốc",
  },
  {
    word: "khai trường",
    part_of_speech: "động từ",
    meaning: "bắt đầu một năm học ở nhà trường: tiếng trống khai trường",
    example: "tiếng trống khai trường",
  },
  {
    word: "khai trường",
    part_of_speech: "danh từ",
    meaning:
      "khu vực trung tâm của công trường khai thác mỏ: khai trường lộ thiên của mỏ than",
    example: "khai trường lộ thiên của mỏ than",
  },
  {
    word: "khai vị",
    part_of_speech: "động từ",
    meaning:
      "(rượu, món ăn) được dùng vào đầu bữa ăn, có tác dụng kích thích khẩu vị làm cho ăn ngon miệng: rượu khai vị * món khai vị",
    example: "rượu khai vị * món khai vị",
  },
  {
    word: "khai tử",
    part_of_speech: "động từ",
    meaning:
      "khai báo những thông tin cần thiết về mặt thủ tục hành chính về người mới chết: giấy khai tử",
    example: "giấy khai tử",
  },
  {
    word: "khai trương",
    part_of_speech: "động từ",
    meaning: "bắt đầu hoạt động sản xuất, kinh doanh: lễ khai trương cửa hàng",
    example: "lễ khai trương cửa hàng",
  },
  {
    word: "khảm",
    part_of_speech: "động từ",
    meaning:
      "gắn các mảnh cứng, thường có màu sắc đẹp, óng ánh, lên đồ vật theo hình đã đục sẵn, để trang trí: tranh khảm trai * tủ khảm xà cừ",
    example: "tranh khảm trai * tủ khảm xà cừ",
  },
  {
    word: "khảm",
    part_of_speech: "động từ",
    meaning: "(Phương ngữ) chèo, chống đưa thuyền đi: khảm thuyền qua sông",
    example: "khảm thuyền qua sông",
  },
  {
    word: "kham",
    part_of_speech: "động từ",
    meaning:
      "chịu đựng được (công việc quá với sức lực của mình): việc đó lớn quá, mình tôi không kham nổi",
    example: "việc đó lớn quá, mình tôi không kham nổi",
  },
  {
    word: "khám",
    part_of_speech: "danh từ",
    meaning:
      "vật làm bằng gỗ, giống như cái tủ nhỏ không có cánh, dùng để đặt bài vị, đồ thờ, thường được gác hay treo cao: khám thờ",
    example: "khám thờ",
  },
  {
    word: "khám",
    part_of_speech: "danh từ",
    meaning: "nhà giam: bị nhốt vào trong khám",
    example: "bị nhốt vào trong khám",
  },
  {
    word: "khám",
    part_of_speech: "động từ",
    meaning:
      "lục soát, kiểm tra kĩ để tìm tang chứng của tội lỗi, của hành động phạm pháp: lệnh khám nhà * khám hành lí",
    example: "lệnh khám nhà * khám hành lí",
  },
  {
    word: "khám",
    part_of_speech: "động từ",
    meaning:
      "xem xét để biết tình trạng sức khoẻ, để biết bệnh trạng trong cơ thể: khám sức khoẻ * phòng khám nội",
    example: "khám sức khoẻ * phòng khám nội",
  },
  {
    word: "khám nghiệm",
    part_of_speech: "động từ",
    meaning:
      "xem xét, xác định thương tích, vv, bằng những phương pháp khoa học, khi thấy có nghi vấn: khám nghiệm tử thi * khám nghiệm hiện trường",
    example: "khám nghiệm tử thi * khám nghiệm hiện trường",
  },
  {
    word: "khám phá",
    part_of_speech: "động từ",
    meaning:
      "tìm ra, phát hiện ra cái còn ẩn giấu, cái bí mật: đoàn thám hiểm khám phá hang động",
    example: "đoàn thám hiểm khám phá hang động",
  },
  {
    word: "kham khổ",
    part_of_speech: "tính từ",
    meaning:
      "thiếu thốn, cơ cực trong cuộc sống (thường nói về mặt ăn uống): ăn uống hết sức kham khổ * chịu được kham khổ",
    example: "ăn uống hết sức kham khổ * chịu được kham khổ",
  },
  {
    word: "khám xét",
    part_of_speech: "động từ",
    meaning:
      "khám để tìm cái đang che giấu hoặc tìm tang chứng của hành động phạm pháp (nói khái quát): khám xét nhà",
    example: "khám xét nhà",
  },
  {
    word: "khàn",
    part_of_speech: "tính từ",
    meaning:
      "(tiếng, giọng) trầm và rè, không thanh, không gọn: giọng khàn * khàn như vịt đực",
    example: "giọng khàn * khàn như vịt đực",
  },
  {
    word: "khán đài",
    part_of_speech: "danh từ",
    meaning:
      "nơi có bệ cao để xem biểu diễn thi đấu: khán đài của sân vận động",
    example: "khán đài của sân vận động",
  },
  {
    word: "khan",
    part_of_speech: "tính từ",
    meaning:
      "thiếu hay không có lượng nước cần thiết: cánh đồng khan nước * bừa khan * ăn khan",
    example: "cánh đồng khan nước * bừa khan * ăn khan",
  },
  {
    word: "khan",
    part_of_speech: "tính từ",
    meaning: "không ngậm nước: muối khan",
    example: "muối khan",
  },
  {
    word: "khan",
    part_of_speech: "tính từ",
    meaning:
      "thiếu cái được coi là cần thiết hay cái thường kèm theo: uống rượu khan một mình * ho khan * nói khan nói vã (tng)",
    example: "uống rượu khan một mình * ho khan * nói khan nói vã (tng)",
  },
  {
    word: "khan",
    part_of_speech: "tính từ",
    meaning:
      "thiếu hẳn so với yêu cầu của thị trường: hàng hóa dạo này khan quá * khan tiền mặt",
    example: "hàng hóa dạo này khan quá * khan tiền mặt",
  },
  {
    word: "khan",
    part_of_speech: "tính từ",
    meaning: "như khản: nói khan cả cổ",
    example: "nói khan cả cổ",
  },
  {
    word: "khản",
    part_of_speech: "tính từ",
    meaning:
      "(giọng) bị rè, bị lạc đi, không rõ âm, rõ tiếng: nói nhiều, khản cả tiếng * gào đến khản cả cổ",
    example: "nói nhiều, khản cả tiếng * gào đến khản cả cổ",
  },
  {
    word: "khản đặc",
    part_of_speech: "tính từ",
    meaning: "bị khản nặng, nói gần như không ra tiếng: giọng khản đặc",
    example: "giọng khản đặc",
  },
  {
    word: "khán giả",
    part_of_speech: "danh từ",
    meaning:
      "người xem biểu diễn nghệ thuật, võ thuật, thi đấu thể thao, vv (nói khái quát): đáp ứng sự hâm mộ của khán giả * khán giả xem truyền hình",
    example: "đáp ứng sự hâm mộ của khán giả * khán giả xem truyền hình",
  },
  {
    word: "khan hiếm",
    part_of_speech: "tính từ",
    meaning:
      "khan, khó tìm thấy hoặc có quá ít so với nhu cầu (nói khái quát): hàng hoá khan hiếm * nước nôi khan hiếm",
    example: "hàng hoá khan hiếm * nước nôi khan hiếm",
  },
  {
    word: "khán phòng",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, hoặc trtr) phòng dành cho khán giả, thính giả thưởng thức âm nhạc, nghệ thuật: nghe hoà nhạc trong khán phòng",
    example: "nghe hoà nhạc trong khán phòng",
  },
  {
    word: "kháng",
    part_of_speech: "động từ",
    meaning: "chống lại: kháng lại lệnh trên * kháng thuốc * thuốc kháng viêm",
    example: "kháng lại lệnh trên * kháng thuốc * thuốc kháng viêm",
  },
  {
    word: "kháng án",
    part_of_speech: "động từ",
    meaning:
      "chống lại bản án của toà án để yêu cầu được xét xử lại: toà án bác đơn kháng án",
    example: "toà án bác đơn kháng án",
  },
  {
    word: "khảng khái",
    part_of_speech: "tính từ",
    meaning:
      "có khí phách cứng cỏi và kiên cường, không chịu khuất phục: cất lời khảng khái * một con người khảng khái",
    example: "cất lời khảng khái * một con người khảng khái",
  },
  {
    word: "khảng khái",
    part_of_speech: "tính từ",
    meaning: "có tính chất cao thượng, vì nghĩa lớn: sự giúp đỡ khảng khái",
    example: "sự giúp đỡ khảng khái",
  },
  {
    word: "kháng cáo",
    part_of_speech: "động từ",
    meaning:
      "chống án lên toà án cấp trên, yêu cầu xét xử lại: quyền kháng cáo * làm đơn kháng cáo",
    example: "quyền kháng cáo * làm đơn kháng cáo",
  },
  {
    word: "kháng chiến",
    part_of_speech: "",
    meaning:
      "chiến đấu chống quân xâm lược: toàn dân kháng chiến * kháng chiến thắng lợi",
    example: "toàn dân kháng chiến * kháng chiến thắng lợi",
  },
  {
    word: "kháng cự",
    part_of_speech: "động từ",
    meaning:
      "chống lại để tự vệ: tên trộm kháng cự, hòng tẩu thoát * đứng chịu trận, không kháng cự",
    example:
      "tên trộm kháng cự, hòng tẩu thoát * đứng chịu trận, không kháng cự",
  },
  {
    word: "khang khác",
    part_of_speech: "tính từ",
    meaning: "hơi khác một chút: thấy trong người hơi khang khác",
    example: "thấy trong người hơi khang khác",
  },
  {
    word: "khạng nạng",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả dáng đi giạng rộng hai chân, vẻ chậm chạp, khó khăn: dáng đi khạng nạng * bụng to, đi đứng khạng nạng",
    example: "dáng đi khạng nạng * bụng to, đi đứng khạng nạng",
  },
  {
    word: "kháng nghị",
    part_of_speech: "",
    meaning:
      "(trang trọng) bày tỏ ý kiến phản đối bằng văn bản chính thức: kháng nghị lên cơ quan cấp trên",
    example: "kháng nghị lên cơ quan cấp trên",
  },
  {
    word: "kháng sinh",
    part_of_speech: "danh từ",
    meaning:
      "chất lấy từ nấm mốc, vi khuẩn thực vật, có tác dụng kháng sinh: tiêm kháng sinh liều cao * uống kháng sinh",
    example: "tiêm kháng sinh liều cao * uống kháng sinh",
  },
  {
    word: "khang trang",
    part_of_speech: "tính từ",
    meaning: "rộng rãi và thoáng đẹp: nhà cửa khang trang",
    example: "nhà cửa khang trang",
  },
  {
    word: "kháng viêm",
    part_of_speech: "động từ",
    meaning:
      "chống viêm nhiễm (nói về tác dụng của thuốc): thuốc kháng viêm đường ruột",
    example: "thuốc kháng viêm đường ruột",
  },
  {
    word: "kháng nguyên",
    part_of_speech: "danh từ",
    meaning:
      "chất lạ xâm nhập vào cơ thể (như vi khuẩn, chất độc hoá học, vv): phát hiện kháng nguyên gây bệnh ở người",
    example: "phát hiện kháng nguyên gây bệnh ở người",
  },
  {
    word: "khang kháng",
    part_of_speech: "tính từ",
    meaning:
      "(dưa, cà muối) bắt đầu có dấu hiệu bị hỏng, có mùi hơi nồng: dưa muối lâu nên đã có mùi khang kháng",
    example: "dưa muối lâu nên đã có mùi khang kháng",
  },
  {
    word: "khanh",
    part_of_speech: "danh từ",
    meaning: "(cũ) (hiếm) chức quan to thời phong kiến: làm khanh, làm tướng",
    example: "làm khanh, làm tướng",
  },
  {
    word: "khanh",
    part_of_speech: "danh từ",
    meaning:
      "từ vua, hoàng hậu dùng để gọi bề tôi thân cận, một cách thân mật: các khanh bình thân",
    example: "các khanh bình thân",
  },
  {
    word: "khanh khách",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả tiếng cười giòn và to phát ra liên tiếp, với vẻ khoái trá, thích thú: thích chí, cười khanh khách",
    example: "thích chí, cười khanh khách",
  },
  {
    word: "khánh thành",
    part_of_speech: "động từ",
    meaning:
      "mừng việc hoàn thành một công trình xây dựng: cắt băng khánh thành * khánh thành nhà mới",
    example: "cắt băng khánh thành * khánh thành nhà mới",
  },
  {
    word: "khánh kiệt",
    part_of_speech: "động từ",
    meaning:
      "hết sạch của cải, tài sản, do lâm vào bước khó khăn: gia tài khánh kiệt vì cờ bạc",
    example: "gia tài khánh kiệt vì cờ bạc",
  },
  {
    word: "khảnh",
    part_of_speech: "tính từ",
    meaning: "khó tính trong ăn uống, thường hay kén chọn thức ăn: khảnh ăn",
    example: "khảnh ăn",
  },
  {
    word: "khánh",
    part_of_speech: "danh từ",
    meaning:
      "đồ trang sức, thường bằng kim loại quý, hình cái khánh nhỏ, có dây để đeo ở cổ: cổ đeo khánh ngọc",
    example: "cổ đeo khánh ngọc",
  },
  {
    word: "khảo",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) truy hỏi gắt gao, kể cả đe doạ, tra tấn để bắt phải nói, phải khai ra: khảo cho đến cùng * “Nghĩ đà bưng kín miệng bình, Nào ai có khảo mà mình lại xưng?” (TKiều)",
    example:
      "khảo cho đến cùng * “Nghĩ đà bưng kín miệng bình, Nào ai có khảo mà mình lại xưng?” (TKiều)",
  },
  {
    word: "khảo",
    part_of_speech: "động từ",
    meaning: "đánh, gõ cho đau: khảo cho mấy cái vào đầu",
    example: "khảo cho mấy cái vào đầu",
  },
  {
    word: "khảo",
    part_of_speech: "động từ",
    meaning:
      "tìm biết bằng cách so sánh, đối chiếu kĩ các tài liệu, các bằng chứng: khảo lại các văn bản * đi khảo giá hàng",
    example: "khảo lại các văn bản * đi khảo giá hàng",
  },
  {
    word: "khánh tiết",
    part_of_speech: "danh từ",
    meaning:
      "(trang trọng) lễ mừng, lễ tiết lớn (nói khái quát): ngày khánh tiết",
    example: "ngày khánh tiết",
  },
  {
    word: "khao",
    part_of_speech: "động từ",
    meaning:
      "mở tiệc ăn uống, thết đãi đông người nhân dịp có việc vui mừng: mổ bò ăn khao * khao bạn bè nhân dịp được lên chức",
    example: "mổ bò ăn khao * khao bạn bè nhân dịp được lên chức",
  },
  {
    word: "khao",
    part_of_speech: "động từ",
    meaning:
      "thết đãi để khen ngợi, động viên những người vừa lập công lao, thành tích: mở tiệc khao quân * khao các chiến sĩ một đêm văn nghệ",
    example: "mở tiệc khao quân * khao các chiến sĩ một đêm văn nghệ",
  },
  {
    word: "khao",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đãi, nhân lúc vui vẻ: khao các bạn một tối xem hát * khao nhau một chầu phở",
    example: "khao các bạn một tối xem hát * khao nhau một chầu phở",
  },
  {
    word: "khao",
    part_of_speech: "động từ",
    meaning: "bẩy, cuốc cho than, đá rơi từ trên cao xuống: khao than",
    example: "khao than",
  },
  {
    word: "kháo",
    part_of_speech: "động từ",
    meaning:
      "bàn tán, kể cho nhau nghe chuyện của ai đó thường để cho vui chuyện, không nhằm mục đích gì: kháo chuyện * mọi người kháo nhau rằng anh ta vừa trúng lớn",
    example: "kháo chuyện * mọi người kháo nhau rằng anh ta vừa trúng lớn",
  },
  {
    word: "khảo cổ",
    part_of_speech: "danh từ",
    meaning: "khảo cổ học (nói tắt): tài liệu khảo cổ * làm công tác khảo cổ",
    example: "tài liệu khảo cổ * làm công tác khảo cổ",
  },
  {
    word: "khảo đính",
    part_of_speech: "động từ",
    meaning:
      "tra cứu, xem xét để sửa lại cho đúng: khảo đính tác phẩm văn học cổ",
    example: "khảo đính tác phẩm văn học cổ",
  },
  {
    word: "khảo dị",
    part_of_speech: "động từ",
    meaning:
      "nghiên cứu đối chiếu những chỗ khác nhau trong các văn bản khác nhau của cùng một tác phẩm cổ: khảo dị các văn bản nôm của Truyện Kiều",
    example: "khảo dị các văn bản nôm của Truyện Kiều",
  },
  {
    word: "khảo cứu",
    part_of_speech: "động từ",
    meaning:
      "tìm hiểu bằng cách nghiên cứu, đối chiếu các sách vở, tài liệu cũ: khảo cứu về đạo Phật * khảo cứu về Truyện Kiều",
    example: "khảo cứu về đạo Phật * khảo cứu về Truyện Kiều",
  },
  {
    word: "khao khao",
    part_of_speech: "tính từ",
    meaning:
      "(giọng nói) không trong, không thật rõ âm thanh, thường là do bị khô cổ, hoặc do quá yếu mệt: giọng khao khao",
    example: "giọng khao khao",
  },
  {
    word: "khảo hạch",
    part_of_speech: "động từ",
    meaning:
      "(cũ) thi để kiểm tra chất lượng, trình độ: thi khảo hạch để chọn cán bộ",
    example: "thi khảo hạch để chọn cán bộ",
  },
  {
    word: "khào khào",
    part_of_speech: "tính từ",
    meaning:
      "(giọng nói) khàn và yếu, nghe không rõ: giọng khào khào * nói khào khào",
    example: "giọng khào khào * nói khào khào",
  },
  {
    word: "khao khát",
    part_of_speech: "động từ",
    meaning:
      "mong muốn rất tha thiết: khao khát tình cảm * khao khát một cuộc sống hạnh phúc",
    example: "khao khát tình cảm * khao khát một cuộc sống hạnh phúc",
  },
  {
    word: "khảo luận",
    part_of_speech: "động từ",
    meaning:
      "nghiên cứu và bàn luận sâu về một vấn đề gì, thường ở dạng một chuyên luận, một cuốn sách: khảo luận về văn học dân gian Việt Nam",
    example: "khảo luận về văn học dân gian Việt Nam",
  },
  {
    word: "khảo sát",
    part_of_speech: "động từ",
    meaning:
      "xem xét một cách cụ thể để tìm hiểu: cán bộ khảo sát * đi khảo sát thị trường * khảo sát kinh nghiệm",
    example: "cán bộ khảo sát * đi khảo sát thị trường * khảo sát kinh nghiệm",
  },
  {
    word: "khảo nghiệm",
    part_of_speech: "động từ",
    meaning:
      "xem xét và đánh giá qua ứng dụng, thử thách trong thực tế: khảo nghiệm giống lúa mới",
    example: "khảo nghiệm giống lúa mới",
  },
  {
    word: "khao vọng",
    part_of_speech: "động từ",
    meaning:
      "(cũ) nộp tiền và làm cỗ mời dân làng nhân dịp đỗ đạt hoặc thăng chức, theo tục lệ thời trước: nộp tiền khao vọng",
    example: "nộp tiền khao vọng",
  },
  {
    word: "khao quân",
    part_of_speech: "động từ",
    meaning:
      "cho quân sĩ ăn uống đặc biệt để thưởng công sau chiến thắng: mở tiệc khao quân",
    example: "mở tiệc khao quân",
  },
  {
    word: "khạp",
    part_of_speech: "danh từ",
    meaning: "đồ gốm hình trụ, miệng rộng, có nắp đậy, dùng để đựng: khạp nước",
    example: "khạp nước",
  },
  {
    word: "khát",
    part_of_speech: "động từ",
    meaning:
      "có cảm giác cần uống nước: khát khô cổ họng * con bạc khát nước (b)",
    example: "khát khô cổ họng * con bạc khát nước (b)",
  },
  {
    word: "khát",
    part_of_speech: "động từ",
    meaning:
      "(Ít dùng) ở trong tình trạng quá thiếu nên thiết tha muốn có: khát tình cảm * khát tin tức của thế giới bên ngoài",
    example: "khát tình cảm * khát tin tức của thế giới bên ngoài",
  },
  {
    word: "kháp",
    part_of_speech: "động từ",
    meaning: "ráp cho ăn khớp: kháp mộng tủ",
    example: "kháp mộng tủ",
  },
  {
    word: "kháp",
    part_of_speech: "động từ",
    meaning:
      "so sánh, đối chiếu để xem có nhất trí, có phù hợp hay không: kháp hai văn bản lại với nhau",
    example: "kháp hai văn bản lại với nhau",
  },
  {
    word: "kháp",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) gặp, giáp mặt: kháp mặt nhau",
    example: "kháp mặt nhau",
  },
  {
    word: "khát vọng",
    part_of_speech: "",
    meaning:
      "mong muốn những điều lớn lao, tốt đẹp với một sức thôi thúc mạnh mẽ: khát vọng hoà bình * khát vọng làm giàu",
    example: "khát vọng hoà bình * khát vọng làm giàu",
  },
  {
    word: "kháu",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) xinh xắn, trông đáng yêu (thường nói về trẻ con hoặc người con gái còn rất trẻ ): cô bé trông rất kháu",
    example: "cô bé trông rất kháu",
  },
  {
    word: "khát khao",
    part_of_speech: "động từ",
    meaning: "như khao khát: khát khao tình cảm",
    example: "khát khao tình cảm",
  },
  {
    word: "khay",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng có mặt đáy phẳng, thành xung quanh thấp, dùng để bày xếp ấm chén, đựng đồ vật nhỏ: khay trà * khay ấm chén * khay trầu",
    example: "khay trà * khay ấm chén * khay trầu",
  },
  {
    word: "kháy",
    part_of_speech: "động từ",
    meaning: "dùng lời lẽ bóng gió để khích bác, trêu tức: hỏi kháy * nói kháy",
    example: "hỏi kháy * nói kháy",
  },
  {
    word: "khau kháu",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như rau ráu: nhai bánh đa khau kháu",
    example: "nhai bánh đa khau kháu",
  },
  {
    word: "khát máu",
    part_of_speech: "tính từ",
    meaning:
      "dã man, tàn bạo, thích hành hạ, giết chóc, gây đổ máu: tên sát nhân khát máu",
    example: "tên sát nhân khát máu",
  },
  {
    word: "khắc",
    part_of_speech: "danh từ",
    meaning: "(cũ, hiếm) một phần tư giờ.",
    example:
      'Hôm nay sum họp trúc mai, Tình chung một khắc, nghĩa dài trăm năm." (ca dao)',
  },
  {
    word: "khắc",
    part_of_speech: "danh từ",
    meaning:
      'khoảng thời gian ngắn: "Hôm nay sum họp trúc mai, Tình chung một khắc, nghĩa dài trăm năm." (ca dao)',
    example:
      'Đêm năm canh lòng sầu lai láng, Ngày sáu khắc chưa cạn chén thề." (ca dao)',
  },
  {
    word: "khắc",
    part_of_speech: "động từ",
    meaning:
      "tạo hình nét trên bề mặt vật liệu cứng bằng dụng cụ cứng và sắc: khắc dấu * tranh khắc gỗ * khắc chữ vào bia đá",
    example: "khắc dấu * tranh khắc gỗ * khắc chữ vào bia đá",
  },
  {
    word: "khắc",
    part_of_speech: "động từ",
    meaning:
      "ghi lại, giữ lại lâu không phai mờ trong tâm trí: khắc sâu mối tình * kỉ niệm khắc sâu trong tâm trí",
    example: "khắc sâu mối tình * kỉ niệm khắc sâu trong tâm trí",
  },
  {
    word: "khắc",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị tính tất yếu của sự việc, tự nó xảy ra, không cần có sự can thiệp nào từ bên ngoài: việc tôi, tôi khắc phải lo * đâu khắc có đó",
    example: "việc tôi, tôi khắc phải lo * đâu khắc có đó",
  },
  {
    word: "khắc khoải",
    part_of_speech: "tính từ",
    meaning:
      "có tâm trạng bồn chồn lo lắng không yên, kéo dài một cách day dứt: khắc khoải đợi chờ * tâm trạng lo âu khắc khoải",
    example: "khắc khoải đợi chờ * tâm trạng lo âu khắc khoải",
  },
  {
    word: "kháu khỉnh",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) kháu (nói khái quát): mặt mũi kháu khỉnh",
    example: "mặt mũi kháu khỉnh",
  },
  {
    word: "khắc hoạ",
    part_of_speech: "động từ",
    meaning:
      "miêu tả bằng lời văn một cách đậm nét, rõ ràng, khiến cho nổi bật lên như chạm, vẽ: khắc hoạ tính cách nhân vật",
    example: "khắc hoạ tính cách nhân vật",
  },
  {
    word: "khắc ghi",
    part_of_speech: "động từ",
    meaning: "ghi nhớ sâu sắc ở trong lòng: công ơn này xin khắc ghi vào dạ",
    example: "công ơn này xin khắc ghi vào dạ",
  },
  {
    word: "khặc khè",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng thở trầm đục, ngắt quãng, dài ngắn khác nhau phát ra với vẻ khó khăn, do cơ thể ở tình trạng ốm yếu: thở khặc khè",
    example: "thở khặc khè",
  },
  {
    word: "khặc khặc",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng trầm đục bật ra ngắt quãng, lặp đi lặp lại như tiếng ho mạnh, liên tiếp bị bật ra sau khi đã cố nén trong cổ họng: cười khặc khặc * cây đại liên khặc khặc nhả đạn",
    example: "cười khặc khặc * cây đại liên khặc khặc nhả đạn",
  },
  {
    word: "khắc kỷ",
    part_of_speech: "động từ",
    meaning:
      "kiềm chế mọi ham muốn, gò mình theo một khuôn đạo đức khổ hạnh: một con người khắc kỉ",
    example: "một con người khắc kỉ",
  },
  {
    word: "khắc kỉ",
    part_of_speech: "động từ",
    meaning:
      "kiềm chế mọi ham muốn, gò mình theo một khuôn đạo đức khổ hạnh: một con người khắc kỉ",
    example: "một con người khắc kỉ",
  },
  {
    word: "khặc khừ",
    part_of_speech: "tính từ",
    meaning:
      "có những biểu hiện uể oải, mệt mỏi, do trong người không được khoẻ: ốm đau khặc khừ",
    example: "ốm đau khặc khừ",
  },
  {
    word: "khắc khổ",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra phải chịu đựng nhiều khổ cực, chịu hạn chế nhiều nhu cầu trong cuộc sống, sinh hoạt: vẻ mặt khắc khổ",
    example: "vẻ mặt khắc khổ",
  },
  {
    word: "khẳm",
    part_of_speech: "tính từ",
    meaning:
      '(thuyền) ở tình trạng chở đầy, nặng hết sức, không thể hơn được nữa: "Chở bao nhiêu đạo thuyền không khẳm, Đâm mấy thằng gian bút chẳng tà." (DTHM)',
    example:
      'Chở bao nhiêu đạo thuyền không khẳm, Đâm mấy thằng gian bút chẳng tà." (DTHM)',
  },
  {
    word: "khẳm",
    part_of_speech: "tính từ",
    meaning: "như khắm: khẳm như mùi chuột chết",
    example: "khẳm như mùi chuột chết",
  },
  {
    word: "khăm",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ác ngầm, hay gây điều tai hại, oái oăm, khó xử cho người khác, thường bằng những mưu mẹo hoặc thủ đoạn kín đáo: chơi khăm * tính lão ấy rất khăm",
    example: "chơi khăm * tính lão ấy rất khăm",
  },
  {
    word: "khắc nghiệt",
    part_of_speech: "tính từ",
    meaning:
      "khắt khe đến mức nghiệt ngã: đối xử khắc nghiệt * bà dì ghẻ khắc nghiệt",
    example: "đối xử khắc nghiệt * bà dì ghẻ khắc nghiệt",
  },
  {
    word: "khắc nghiệt",
    part_of_speech: "tính từ",
    meaning:
      "khó khăn, gay gắt đến mức khó chịu đựng nổi: khí hậu khắc nghiệt * những thử thách khắc nghiệt",
    example: "khí hậu khắc nghiệt * những thử thách khắc nghiệt",
  },
  {
    word: "khắm",
    part_of_speech: "tính từ",
    meaning:
      "có mùi thối nồng nặc, khó chịu như mùi của động vật chết: nước mắm để lâu đã có mùi khắm",
    example: "nước mắm để lâu đã có mùi khắm",
  },
  {
    word: "khắc tinh",
    part_of_speech: "danh từ",
    meaning:
      "đối tượng có khả năng đem lại điều bất lợi hoặc có thể diệt trừ đối phương, nói trong mối quan hệ với đối phương: mèo là khắc tinh của chuột",
    example: "mèo là khắc tinh của chuột",
  },
  {
    word: "khắc phục",
    part_of_speech: "động từ",
    meaning:
      "vượt qua được những khó khăn trở ngại: khắc phục khó khăn * khắc phục mọi trở ngại để hoàn thành nhiệm vụ",
    example:
      "khắc phục khó khăn * khắc phục mọi trở ngại để hoàn thành nhiệm vụ",
  },
  {
    word: "khắc phục",
    part_of_speech: "động từ",
    meaning:
      "làm cho cái có tác dụng không hay dần dần không còn nữa: khắc phục hậu quả của lũ lụt * khắc phục bệnh quan liêu",
    example: "khắc phục hậu quả của lũ lụt * khắc phục bệnh quan liêu",
  },
  {
    word: "khăm khẳm",
    part_of_speech: "tính từ",
    meaning: "như khăm khắm: mùi cóc chết khăm khẳm",
    example: "mùi cóc chết khăm khẳm",
  },
  {
    word: "khắm lặm",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) khắm lắm, đến mức khó mà chịu được: mùi xác chết bốc lên khắm lặm",
    example: "mùi xác chết bốc lên khắm lặm",
  },
  {
    word: "khăm khắm",
    part_of_speech: "tính từ",
    meaning: "như khắm (nhưng ý mức độ ít): khăm khắm như mùi chuột chết",
    example: "khăm khắm như mùi chuột chết",
  },
  {
    word: "khăn",
    part_of_speech: "danh từ",
    meaning:
      "hàng dệt, thường có hình dài hoặc hình vuông, dùng để rửa mặt, chít đầu, quàng cổ, trải bàn, lau chùi, v.v.: khăn mặt * cổ quàng khăn",
    example: "khăn mặt * cổ quàng khăn",
  },
  {
    word: "khắn",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) khớp, gắn chặt: dính khắn vào tường",
    example: "dính khắn vào tường",
  },
  {
    word: "khăn áo",
    part_of_speech: "danh từ",
    meaning:
      "khăn và áo; trang phục (thường là trang phục thời trước; nói khái quát): khăn áo chỉnh tề",
    example: "khăn áo chỉnh tề",
  },
  {
    word: "khăn đóng",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) khăn xếp: khăn đóng áo dài",
    example: "khăn đóng áo dài",
  },
  {
    word: "khăn gói",
    part_of_speech: "danh từ",
    meaning:
      "bọc đựng quần áo, đồ dùng để mang theo khi đi xa: khăn gói về quê",
    example: "khăn gói về quê",
  },
  {
    word: "khẳn",
    part_of_speech: "tính từ",
    meaning: "có mùi rất khó ngửi, khắm, nặng và gắt: mùi thối khẳn",
    example: "mùi thối khẳn",
  },
  {
    word: "khăn gói quả mướp",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) như khăn gói gió đưa: nhận được tin là khăn gói quả mướp lên đường ngay",
    example: "nhận được tin là khăn gói quả mướp lên đường ngay",
  },
  {
    word: "khăn xếp",
    part_of_speech: "danh từ",
    meaning:
      "khăn đội đầu của đàn ông thời trước, thường màu đen, được đóng sẵn thành nếp xếp vòng tròn, không che kín đỉnh đầu: khăn xếp áo dài",
    example: "khăn xếp áo dài",
  },
  {
    word: "khăng",
    part_of_speech: "danh từ",
    meaning:
      "trò chơi của trẻ em, dùng một đoạn cây tròn dài đánh cho đoạn cây tròn ngắn văng đi xa để tính điểm: chơi khăng * đánh khăng",
    example: "chơi khăng * đánh khăng",
  },
  {
    word: "khằng khặc",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) từ mô phỏng tiếng cười hay tiếng ho, tiếng kêu như bị tắc trong họng rồi lại bật ra nhiều lần liên tiếp: cười khằng khặc * ho khằng khặc",
    example: "cười khằng khặc * ho khằng khặc",
  },
  {
    word: "khẳng định",
    part_of_speech: "động từ",
    meaning:
      "thừa nhận một cách chắc chắn là có, là đúng: chưa có chứng cứ nên không dám khẳng định * tôi khẳng định rằng công việc sẽ thành",
    example:
      "chưa có chứng cứ nên không dám khẳng định * tôi khẳng định rằng công việc sẽ thành",
  },
  {
    word: "khăng khăng",
    part_of_speech: "phụ từ",
    meaning:
      'cứ giữ ý kiến, dứt khoát không chịu thay đổi ý: khăng khăng từ chối * "Thuyền về có nhớ bến chăng, Bến thì một dạ khăng khăng đợi thuyền." (Cdao)',
    example:
      'khăng khăng từ chối * "Thuyền về có nhớ bến chăng, Bến thì một dạ khăng khăng đợi thuyền." (Cdao)',
  },
  {
    word: "khẳng kheo",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như khẳng khiu: đôi chân khẳng kheo",
    example: "đôi chân khẳng kheo",
  },
  {
    word: "khẳng khiu",
    part_of_speech: "tính từ",
    meaning:
      'gầy đến mức như khô cằn: chân tay khẳng khiu * "Đất xấu trồng cây khẳng khiu, Những người thô tục nói điều phàm phu." (ca dao)',
    example:
      'chân tay khẳng khiu * "Đất xấu trồng cây khẳng khiu, Những người thô tục nói điều phàm phu." (ca dao)',
  },
  {
    word: "khăng khít",
    part_of_speech: "tính từ",
    meaning:
      "có quan hệ gắn bó chặt chẽ với nhau, không thể tách rời: cuộc tình duyên khăng khít * gắn bó khăng khít",
    example: "cuộc tình duyên khăng khít * gắn bó khăng khít",
  },
  {
    word: "khắt khe",
    part_of_speech: "tính từ",
    meaning:
      'quá nghiêm khắc, chặt chẽ trong các đòi hỏi, đến mức có thể hẹp hòi, cố chấp trong sự đối xử, đánh giá: đối xử khắt khe * "Những nghe nói đã thẹn thùng, Nước đời lắm nỗi lạ lùng khắt khe!" (TKiều)',
    example:
      'đối xử khắt khe * "Những nghe nói đã thẹn thùng, Nước đời lắm nỗi lạ lùng khắt khe!" (TKiều)',
  },
  {
    word: "khắp",
    part_of_speech: "tính từ",
    meaning:
      "đủ hết tất cả, không sót, không trừ một nơi nào hoặc một ai: chào hỏi khắp lượt * đã tìm khắp mọi nơi * khắp bốn phương trời",
    example: "chào hỏi khắp lượt * đã tìm khắp mọi nơi * khắp bốn phương trời",
  },
  {
    word: "khấc",
    part_of_speech: "danh từ",
    meaning:
      "chỗ cắt gọt sâu vào bề mặt vật cứng để đánh dấu hoặc để mắc giữ cái gì: cán cân mờ hết cả khấc",
    example: "cán cân mờ hết cả khấc",
  },
  {
    word: "khâm phục",
    part_of_speech: "động từ",
    meaning:
      "đặc biệt kính trọng, do đánh giá rất cao về mặt nào đó: những thành tích đáng khâm phục * khâm phục tinh thần dũng cảm",
    example: "những thành tích đáng khâm phục * khâm phục tinh thần dũng cảm",
  },
  {
    word: "khấm khá",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (mức sống, mức thu nhập) ít nhiều khá hơn trước và đã đạt mức trên trung bình: cuộc sống ngày càng khấm khá * làm ăn khấm khá",
    example: "cuộc sống ngày càng khấm khá * làm ăn khấm khá",
  },
  {
    word: "khâm liệm",
    part_of_speech: "động từ",
    meaning: "(trang trọng) như liệm: khâm liệm thi thể",
    example: "khâm liệm thi thể",
  },
  {
    word: "khấn",
    part_of_speech: "động từ",
    meaning:
      "nói lẩm bẩm một cách cung kính để cầu xin (thần Phật, tổ tiên) điều gì: cầu trời khấn Phật",
    example: "cầu trời khấn Phật",
  },
  {
    word: "khâm sai",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) chức quan được vua phái đi làm một nhiệm vụ đặc biệt và quan trọng: khâm sai đại thần",
    example: "khâm sai đại thần",
  },
  {
    word: "khẩn hoang",
    part_of_speech: "động từ",
    meaning:
      "khai phá vùng đất hoang sử dụng được vào sản xuất: công cuộc khẩn hoang",
    example: "công cuộc khẩn hoang",
  },
  {
    word: "khẩn",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất cần kíp, không thể trì hoãn (thường nói về việc công): điện khẩn * công văn khẩn * triệu tập khẩn",
    example: "điện khẩn * công văn khẩn * triệu tập khẩn",
  },
  {
    word: "khấn khứa",
    part_of_speech: "động từ",
    meaning: "khấn (nói khái quát): lầm rầm khấn khứa",
    example: "lầm rầm khấn khứa",
  },
  {
    word: "khẩn cầu",
    part_of_speech: "động từ",
    meaning: "như cầu khẩn: nhìn bằng ánh mắt khẩn cầu",
    example: "nhìn bằng ánh mắt khẩn cầu",
  },
  {
    word: "khẩn cấp",
    part_of_speech: "tính từ",
    meaning:
      "phải được tiến hành, được giải quyết ngay, không chậm trễ: nhiệm vụ khẩn cấp * máy bay buộc phải hạ cánh khẩn cấp",
    example: "nhiệm vụ khẩn cấp * máy bay buộc phải hạ cánh khẩn cấp",
  },
  {
    word: "khẩn cấp",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất nghiêm trọng, đòi hỏi phải có ngay những biện pháp tích cực để đối phó, không cho phép chậm trễ: tình thế khẩn cấp * tin bão khẩn cấp",
    example: "tình thế khẩn cấp * tin bão khẩn cấp",
  },
  {
    word: "khẩn nài",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) nài xin một cách khẩn khoản: khẩn nài xin tha thứ * nói bằng giọng khẩn nài",
    example: "khẩn nài xin tha thứ * nói bằng giọng khẩn nài",
  },
  {
    word: "khẩn trương",
    part_of_speech: "tính từ",
    meaning:
      "cần được tiến hành, được giải quyết một cách tích cực trong thời gian gấp, không thể chậm trễ: nhiệm vụ khẩn trương * khẩn trương đưa người bệnh đến bệnh viện",
    example: "nhiệm vụ khẩn trương * khẩn trương đưa người bệnh đến bệnh viện",
  },
  {
    word: "khẩn trương",
    part_of_speech: "tính từ",
    meaning:
      "căng thẳng, có những yêu cầu cần được giải quyết ngay, không thể chậm trễ: tình hình chiến sự hết sức khẩn trương",
    example: "tình hình chiến sự hết sức khẩn trương",
  },
  {
    word: "khẩn trương",
    part_of_speech: "tính từ",
    meaning:
      "hoặc đg (làm việc gì) hết sức tranh thủ thời gian, tập trung sự chú ý và sức lực, nhằm mau chóng đạt kết quả: khẩn trương thu hoạch hoa màu trước mùa lũ * làm việc khẩn trương",
    example:
      "khẩn trương thu hoạch hoa màu trước mùa lũ * làm việc khẩn trương",
  },
  {
    word: "khẩn khoản",
    part_of_speech: "",
    meaning:
      "nài nỉ một cách tha thiết để người khác chấp nhận yêu cầu của mình: khẩn khoản nài xin * nói bằng giọng khẩn khoản",
    example: "khẩn khoản nài xin * nói bằng giọng khẩn khoản",
  },
  {
    word: "khẩn thiết",
    part_of_speech: "tính từ",
    meaning: "tha thiết và cấp bách: nhu cầu khẩn thiết * việc khẩn thiết",
    example: "nhu cầu khẩn thiết * việc khẩn thiết",
  },
  {
    word: "khẩn thiết",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất rất tha thiết, yêu cầu có ngay sự đáp ứng: lời đề nghị khẩn thiết * kêu nài khẩn thiết",
    example: "lời đề nghị khẩn thiết * kêu nài khẩn thiết",
  },
  {
    word: "khấp kha khấp khểnh",
    part_of_speech: "tính từ",
    meaning:
      "như khấp khểnh (nhưng ý liên tiếp và mức độ nhiều): răng mọc khấp kha khấp khểnh",
    example: "răng mọc khấp kha khấp khểnh",
  },
  {
    word: "khấp khểnh",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều chỗ lô nhô, khiến cho không đều đặn, không bằng phẳng hoặc không khớp nhau: hàm răng khấp khểnh * đoạn đường rải đá khấp khểnh",
    example: "hàm răng khấp khểnh * đoạn đường rải đá khấp khểnh",
  },
  {
    word: "khấn vái",
    part_of_speech: "động từ",
    meaning:
      "vừa khấn vừa chắp tay lạy, vái: khấn vái trời Phật * lầm rầm khấn vái",
    example: "khấn vái trời Phật * lầm rầm khấn vái",
  },
  {
    word: "khấp khởi",
    part_of_speech: "động từ",
    meaning:
      "tỏ ra vui mừng rộn rã trong lòng một cách kín đáo: khấp khởi mừng thầm",
    example: "khấp khởi mừng thầm",
  },
  {
    word: "khất",
    part_of_speech: "động từ",
    meaning:
      "xin được hoãn lại một thời gian, đến một lúc khác sẽ trả, sẽ làm: khất nợ * chưa làm được nên phải khất đến tháng sau",
    example: "khất nợ * chưa làm được nên phải khất đến tháng sau",
  },
  {
    word: "khập khiễng",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả dáng đi bên cao, bên thấp, không đều, không cân bằng: chân đau nên phải đi khập khiễng",
    example: "chân đau nên phải đi khập khiễng",
  },
  {
    word: "khật khừ",
    part_of_speech: "tính từ",
    meaning: "như khặc khừ: ốm khật khừ",
    example: "ốm khật khừ",
  },
  {
    word: "khật khưỡng",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả dáng đi không vững, lúc nghiêng bên này, lúc ngả bên kia: say rượu, bước đi khật khưỡng",
    example: "say rượu, bước đi khật khưỡng",
  },
  {
    word: "khất lần",
    part_of_speech: "động từ",
    meaning:
      "khất hết lần này đến lần khác mà vẫn không thực hiện được đúng như đã hứa, đã hẹn: lần nào đến đòi hắn cũng khất lần",
    example: "lần nào đến đòi hắn cũng khất lần",
  },
  {
    word: "khâu",
    part_of_speech: "danh từ",
    meaning:
      "vòng kim loại bịt chặt đầu chuôi của một số dụng cụ: khâu dao bằng đồng",
    example: "khâu dao bằng đồng",
  },
  {
    word: "khâu",
    part_of_speech: "danh từ",
    meaning:
      "từng yếu tố, từng bộ phận của một hệ thống: khâu trung gian * khâu then chốt * một khâu quan trọng trong dây chuyền sản xuất",
    example:
      "khâu trung gian * khâu then chốt * một khâu quan trọng trong dây chuyền sản xuất",
  },
  {
    word: "khâu",
    part_of_speech: "động từ",
    meaning:
      "dùng kim chỉ để ghép liền các mảnh, thường là vải, da, lại: khâu nón * khâu lại chỗ rách * khâu vết mổ",
    example: "khâu nón * khâu lại chỗ rách * khâu vết mổ",
  },
  {
    word: "khất thực",
    part_of_speech: "động từ",
    meaning: "(người tu hành) đi xin ăn: nhà sư đi khất thực",
    example: "nhà sư đi khất thực",
  },
  {
    word: "khẩu chiến",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tranh cãi hoặc cãi cọ nhau một cách gay gắt: cuộc khẩu chiến",
    example: "cuộc khẩu chiến",
  },
  {
    word: "khẩu cung",
    part_of_speech: "danh từ",
    meaning:
      "lời khai của bị can, được thể hiện bằng lời nói: lấy khẩu cung * ghi lại khẩu cung",
    example: "lấy khẩu cung * ghi lại khẩu cung",
  },
  {
    word: "khấu",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ, hiếm) trừ bớt: khấu bớt tiền lương",
    example: "khấu bớt tiền lương",
  },
  {
    word: "khẩu",
    part_of_speech: "danh từ",
    meaning: "miệng, về mặt dùng để ăn uống: món khoái khẩu",
    example: "món khoái khẩu",
  },
  {
    word: "khấu đầu",
    part_of_speech: "động từ",
    meaning:
      '(cũ) cúi đầu xuống một cách cung kính (một kiểu lễ thời xưa): "Hai bên mười vị tướng quân, Đặt gươm, cổi giáp, trước sân khấu đầu." (TKiều)',
    example:
      'Hai bên mười vị tướng quân, Đặt gươm, cổi giáp, trước sân khấu đầu." (TKiều)',
  },
  {
    word: "khấu đuôi",
    part_of_speech: "danh từ",
    meaning: "phần ở gốc đuôi của súc vật: khấu đuôi lợn",
    example: "khấu đuôi lợn",
  },
  {
    word: "khấu hao",
    part_of_speech: "động từ",
    meaning:
      "tính vào giá thành sản phẩm lượng giá trị tương đương với giá trị hao mòn của tài sản cố định, nhằm tạo ra nguồn vốn để sửa chữa hoặc mua sắm tài sản cố định mới: tính tỉ lệ khấu hao máy móc * hết thời gian khấu hao",
    example: "tính tỉ lệ khấu hao máy móc * hết thời gian khấu hao",
  },
  {
    word: "khấu đầu khấu đuôi",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) trừ đầu trừ đuôi, gần như chẳng còn lại bao nhiêu: tiền lương bị khấu đầu khấu đuôi gần hết",
    example: "tiền lương bị khấu đầu khấu đuôi gần hết",
  },
  {
    word: "khẩu hiệu",
    part_of_speech: "danh từ",
    meaning:
      "câu ngắn gọn mang nội dung tuyên truyền cổ động để tập hợp quần chúng, để tỏ quyết tâm hoặc để đấu tranh: hô khẩu hiệu",
    example: "hô khẩu hiệu",
  },
  {
    word: "khẩu ngữ",
    part_of_speech: "danh từ",
    meaning:
      "ngôn ngữ nói thông thường, dùng trong cuộc sống hằng ngày, có đặc điểm phong cách đối lập với phong cách viết: từ khẩu ngữ * cách xưng hô khẩu ngữ",
    example: "từ khẩu ngữ * cách xưng hô khẩu ngữ",
  },
  {
    word: "khẩu lệnh",
    part_of_speech: "danh từ",
    meaning: "lệnh hô trong chiến đấu hoặc trong luyện tập: hô khẩu lệnh",
    example: "hô khẩu lệnh",
  },
  {
    word: "khẩu phần",
    part_of_speech: "danh từ",
    meaning:
      "phần thức ăn mỗi bữa hoặc mỗi ngày của người hay súc vật nuôi: tăng khẩu phần ăn của bò sữa",
    example: "tăng khẩu phần ăn của bò sữa",
  },
  {
    word: "khẩu khí",
    part_of_speech: "danh từ",
    meaning:
      "khí phách của con người toát ra qua lời nói, cách nói: khẩu khí khinh bạc",
    example: "khẩu khí khinh bạc",
  },
  {
    word: "khẩu thiệt vô bằng",
    part_of_speech: "",
    meaning:
      'lời nói ra ở miệng không để lại bằng chứng gì: "Thế gian khẩu thiệt vô bằng, Không mà nói có mần răng đặng chừ." (ca dao)',
    example:
      'Thế gian khẩu thiệt vô bằng, Không mà nói có mần răng đặng chừ." (ca dao)',
  },
  {
    word: "khẩu trang",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng làm bằng vải, có nhiều lớp hoặc có lót lớp ngăn cách để đeo che miệng và mũi nhằm ngăn giữ bụi bặm, chất độc hoặc chống rét: đeo khẩu trang chống bụi * khẩu trang phòng bệnh",
    example: "đeo khẩu trang chống bụi * khẩu trang phòng bệnh",
  },
  {
    word: "khâu vá",
    part_of_speech: "động từ",
    meaning:
      "khâu và vá đồ bằng vải (nói khái quát): khâu vá quần áo * vụng khâu vá",
    example: "khâu vá quần áo * vụng khâu vá",
  },
  {
    word: "khâu vắt",
    part_of_speech: "động từ",
    meaning:
      "khâu ghim dọc theo mép vải từng mũi chỉ theo đường chữ chi, để đính mép vải vào mảnh vải: khâu vắt gấu quần",
    example: "khâu vắt gấu quần",
  },
  {
    word: "khẽ",
    part_of_speech: "tính từ",
    meaning:
      "(cách thức hoặc mức độ hoạt động) rất nhỏ, rất nhẹ, không gây ra tiếng ồn, tiếng động lớn: đi nhẹ nói khẽ * khẽ cau mày * khẽ mở cánh cửa",
    example: "đi nhẹ nói khẽ * khẽ cau mày * khẽ mở cánh cửa",
  },
  {
    word: "khấu trừ",
    part_of_speech: "động từ",
    meaning:
      "trừ bớt đi một phần để bù vào một khoản nào đó: tiền tạm ứng khấu trừ vào lương",
    example: "tiền tạm ứng khấu trừ vào lương",
  },
  {
    word: "khé",
    part_of_speech: "tính từ",
    meaning:
      "(vị chua hay ngọt) đậm gắt đến mức gây cảm giác khó chịu ở cổ và khó nuốt: chua khé * nước chanh pha ngọt khé",
    example: "chua khé * nước chanh pha ngọt khé",
  },
  {
    word: "khe",
    part_of_speech: "danh từ",
    meaning:
      "khoảng hở dài và hẹp, giữa hai phần tiếp giáp không khít nhau: khe núi * nhòm qua khe cửa",
    example: "khe núi * nhòm qua khe cửa",
  },
  {
    word: "khe",
    part_of_speech: "danh từ",
    meaning:
      "đường nước hẹp chảy giữa hai vách núi hoặc sườn dốc, có thể khô cạn theo mùa: khe suối",
    example: "khe suối",
  },
  {
    word: "khẽ khàng",
    part_of_speech: "tính từ",
    meaning: "rất khẽ, rất nhẹ nhàng: đi lại khẽ khàng",
    example: "đi lại khẽ khàng",
  },
  {
    word: "khe khẽ",
    part_of_speech: "tính từ",
    meaning: "như khẽ (nhưng ý nhấn mạnh): hát khe khẽ * khe khẽ gật đầu",
    example: "hát khe khẽ * khe khẽ gật đầu",
  },
  {
    word: "khẩu vị",
    part_of_speech: "danh từ",
    meaning: "sở thích về ăn uống của từng người: món ăn hợp khẩu vị",
    example: "món ăn hợp khẩu vị",
  },
  {
    word: "khẻ",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) ghè: khẻ bể viên ngói",
    example: "khẻ bể viên ngói",
  },
  {
    word: "khe khé",
    part_of_speech: "tính từ",
    meaning: "có vị hơi khé: khế chua khe khé",
    example: "khế chua khe khé",
  },
  {
    word: "khẹc",
    part_of_speech: "danh từ",
    meaning: "(thông tục) khỉ (tiếng mắng): đồ con khẹc!",
    example: "đồ con khẹc!",
  },
  {
    word: "khe khắt",
    part_of_speech: "tính từ",
    meaning: "như khắt khe: những giáo điều khe khắt * đối xử khe khắt",
    example: "những giáo điều khe khắt * đối xử khe khắt",
  },
  {
    word: "khẽ khọt",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) như thẽ thọt: nói bằng giọng khẽ khọt",
    example: "nói bằng giọng khẽ khọt",
  },
  {
    word: "khem khổ",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như kham khổ: ăn uống khem khổ",
    example: "ăn uống khem khổ",
  },
  {
    word: "khen thưởng",
    part_of_speech: "động từ",
    meaning:
      "khen và thưởng một cách chính thức vì có thành tích nào đó (nói khái quát): khen thưởng những cá nhân có thành tích xuất sắc",
    example: "khen thưởng những cá nhân có thành tích xuất sắc",
  },
  {
    word: "khen ngợi",
    part_of_speech: "động từ",
    meaning: "khen (nói khái quát): ai cũng tấm tắc khen ngợi",
    example: "ai cũng tấm tắc khen ngợi",
  },
  {
    word: "khen khét",
    part_of_speech: "tính từ",
    meaning: "như khét (nhưng ý mức độ ít): mùi khói khen khét",
    example: "mùi khói khen khét",
  },
  {
    word: "khen tặng",
    part_of_speech: "động từ",
    meaning: "khen và tỏ ý khích lệ: những lời khen tặng * khen tặng huy hiệu",
    example: "những lời khen tặng * khen tặng huy hiệu",
  },
  {
    word: "khen",
    part_of_speech: "động từ",
    meaning:
      "nói lên sự đánh giá tốt với ý vừa lòng: giấy khen * vỗ tay khen hay",
    example: "giấy khen * vỗ tay khen hay",
  },
  {
    word: "khéo",
    part_of_speech: "tính từ",
    meaning:
      'biết làm những động tác thích hợp trong lao động để tạo ra những sản phẩm đẹp, tinh tế: khéo tay * "Rượu ngon chẳng nệ be sành, Áo rách khéo vá hơn lành vụng may." (ca dao)',
    example:
      'khéo tay * "Rượu ngon chẳng nệ be sành, Áo rách khéo vá hơn lành vụng may." (ca dao)',
  },
  {
    word: "khéo",
    part_of_speech: "tính từ",
    meaning:
      "biết sắp xếp công việc, thời gian một cách thích hợp để đạt được kết quả như mong muốn: khéo thu xếp * khéo ăn thì no, khéo co thì ấm (tng)",
    example: "khéo thu xếp * khéo ăn thì no, khéo co thì ấm (tng)",
  },
  {
    word: "khéo",
    part_of_speech: "tính từ",
    meaning:
      "biết có những cử chỉ, hành động, lời lẽ thích hợp làm người khác vừa lòng, để đạt được kết quả như mong muốn trong quan hệ đối xử: tìm cách đuổi khéo * lựa lời nói khéo * ăn ở khéo nên được lòng mọi người",
    example:
      "tìm cách đuổi khéo * lựa lời nói khéo * ăn ở khéo nên được lòng mọi người",
  },
  {
    word: "khéo",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) tốt, hợp, tựa như là đã định làm, đã sắp đặt đúng từ trước: áo mặc vừa khéo * làm xong thì cũng vừa khéo hết giờ",
    example: "áo mặc vừa khéo * làm xong thì cũng vừa khéo hết giờ",
  },
  {
    word: "khéo",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) đẹp, xinh: trăng mười sáu khéo hơn trăng rằm * diện vào trông cũng khéo * miệng cười rõ khéo",
    example:
      "trăng mười sáu khéo hơn trăng rằm * diện vào trông cũng khéo * miệng cười rõ khéo",
  },
  {
    word: "khéo",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) không khéo (nói tắt): mặc phong phanh thế, khéo lại ốm mất thôi",
    example: "mặc phong phanh thế, khéo lại ốm mất thôi",
  },
  {
    word: "khéo",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị ý nhắc nhở phải coi chừng, tránh điều không hay có thể xảy ra: khéo vỡ cốc đấy! * nói nhỏ chứ, khéo lộ hết cả bây giờ",
    example: "khéo vỡ cốc đấy! * nói nhỏ chứ, khéo lộ hết cả bây giờ",
  },
  {
    word: "kheo",
    part_of_speech: "danh từ",
    meaning:
      "chỗ phía sau đầu gối, nơi đùi nối với cẳng chân: bùn dính lên tận khoeo",
    example: "bùn dính lên tận khoeo",
  },
  {
    word: "kheo khéo",
    part_of_speech: "tính từ",
    meaning:
      "như khéo (nhưng ý mức độ ít): nói cho kheo khéo một chút * đường trơn, đi kheo khéo kẻo ngã!",
    example: "nói cho kheo khéo một chút * đường trơn, đi kheo khéo kẻo ngã!",
  },
  {
    word: "khéo léo",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra khéo trong cách làm hoặc cách đối xử (nói khái quát): bàn tay khéo léo * ăn nói khéo léo * khéo léo khuyên can",
    example: "bàn tay khéo léo * ăn nói khéo léo * khéo léo khuyên can",
  },
  {
    word: "kheo khư",
    part_of_speech: "tính từ",
    meaning: "từ gợi tả dáng người gầy còm, ốm yếu: gầy kheo khư",
    example: "gầy kheo khư",
  },
  {
    word: "khép kín",
    part_of_speech: "tính từ",
    meaning:
      "làm thành một vòng liên tục giữa các khâu, các phần trong một quy trình, một phạm vi: sản xuất trên một dây chuyền khép kín * căn hộ khép kín (có khu bếp, khu vệ sinh ở bên trong)",
    example:
      "sản xuất trên một dây chuyền khép kín * căn hộ khép kín (có khu bếp, khu vệ sinh ở bên trong)",
  },
  {
    word: "khéo mồm",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) khéo ăn nói, thường biết lựa lời, có khi không thật lòng, để làm vừa lòng người khác: chỉ được cái khéo mồm!",
    example: "chỉ được cái khéo mồm!",
  },
  {
    word: "khéo tay",
    part_of_speech: "tính từ",
    meaning:
      "có khả năng làm tốt những việc đòi hỏi sự khéo léo tinh tế của đôi tay: khéo tay hay làm * người thợ khéo tay",
    example: "khéo tay hay làm * người thợ khéo tay",
  },
  {
    word: "khép nép",
    part_of_speech: "tính từ",
    meaning:
      "có điệu bộ như muốn thu nhỏ người lại để tránh sự chú ý, sự đụng chạm, hoặc để tỏ vẻ ngại ngùng hay kính cẩn: dáng điệu khép nép",
    example: "dáng điệu khép nép",
  },
  {
    word: "khép",
    part_of_speech: "động từ",
    meaning:
      "làm cho kín lại, cho không còn hở hoặc mở nữa bằng cách chuyển dịch một bộ phận nào đó: khép cửa lại * hai mắt khép hờ * khép chặt cõi lòng (b)",
    example: "khép cửa lại * hai mắt khép hờ * khép chặt cõi lòng (b)",
  },
  {
    word: "khép",
    part_of_speech: "động từ",
    meaning:
      "buộc phải nhận, phải chịu, không cho thoát khỏi: khép vào tội phản quốc * khép mình vào khuôn khổ",
    example: "khép vào tội phản quốc * khép mình vào khuôn khổ",
  },
  {
    word: "khét lẹt",
    part_of_speech: "tính từ",
    meaning: "khét đến mức không thể ngửi được: mùi cao su cháy khét lẹt",
    example: "mùi cao su cháy khét lẹt",
  },
  {
    word: "khê đọng",
    part_of_speech: "động từ",
    meaning:
      "(hàng hoá) tồn kho lâu ngày không tiêu thụ được: hàng khê đọng chất đầy trong kho",
    example: "hàng khê đọng chất đầy trong kho",
  },
  {
    word: "khét",
    part_of_speech: "tính từ",
    meaning:
      "có mùi như mùi của vải hay lông, tóc, vv cháy: mùi vải cháy khét * quần áo khét mùi thuốc súng",
    example: "mùi vải cháy khét * quần áo khét mùi thuốc súng",
  },
  {
    word: "khề khà",
    part_of_speech: "tính từ",
    meaning:
      "(giọng nói, cách nói) chậm và kéo dài ra, giống như người uống rượu đang ngà ngà say: giọng khề khà * khề khà giảng giải",
    example: "giọng khề khà * khề khà giảng giải",
  },
  {
    word: "khê",
    part_of_speech: "tính từ",
    meaning:
      '(cơm, cháo) bị cháy quá, gây ra mùi nồng khét, khó chịu: trên nhão dưới khê * "Chồng giận thì vợ bớt lời, Cơm sôi nhỏ lửa một đời không khê." (Cdao)',
    example:
      'trên nhão dưới khê * "Chồng giận thì vợ bớt lời, Cơm sôi nhỏ lửa một đời không khê." (Cdao)',
  },
  {
    word: "khê",
    part_of_speech: "tính từ",
    meaning:
      "(tiếng, giọng) bị rè và lạc hẳn đi, do nói nhiều hoặc cổ họng bị khô, vướng: giọng khê đặc",
    example: "giọng khê đặc",
  },
  {
    word: "khê",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) (tiền bạc, vốn liếng) bị đọng lại, không luân chuyển sinh lợi được: tiền khê vốn đọng",
    example: "tiền khê vốn đọng",
  },
  {
    word: "khét tiếng",
    part_of_speech: "tính từ",
    meaning:
      "có tiếng đồn xa, thường là tiếng xấu, đến mức ai cũng biết: tên tướng giặc khét tiếng hung ác",
    example: "tên tướng giặc khét tiếng hung ác",
  },
  {
    word: "khệ nệ",
    part_of_speech: "tính từ",
    meaning:
      "có dáng đi chậm chạp và nặng nề như đang phải mang vác nặng: tay xách khệ nệ hai chiếc giỏ nặng * người to béo, bước đi khệ nệ",
    example:
      "tay xách khệ nệ hai chiếc giỏ nặng * người to béo, bước đi khệ nệ",
  },
  {
    word: "khế ước",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) giấy giao kèo về việc mua bán, thuê, vay, vv: làm khế ước bán nhà",
    example: "làm khế ước bán nhà",
  },
  {
    word: "khềnh",
    part_of_speech: "",
    meaning: "(khẩu ngữ, hiếm) như kềnh: nằm khềnh ra giường",
    example: "nằm khềnh ra giường",
  },
  {
    word: "khểnh",
    part_of_speech: "tính từ",
    meaning:
      "(răng) có chỗ nhô cao lên hoặc nhô ra chút ít, làm cho trở nên không đều, không khớp: cô bé có cái răng khểnh",
    example: "cô bé có cái răng khểnh",
  },
  {
    word: "khêu",
    part_of_speech: "động từ",
    meaning:
      "dùng vật có đầu nhọn làm cho phần đầu của vật nào đó nhô ra khỏi chỗ bị giữ chặt: khêu ốc * khêu cái dằm ở tay * khêu bấc đèn",
    example: "khêu ốc * khêu cái dằm ở tay * khêu bấc đèn",
  },
  {
    word: "khêu",
    part_of_speech: "động từ",
    meaning:
      "làm dậy lên yếu tố tinh thần, tình cảm nào đó đang ở trạng thái chìm lắng: cảnh vật làm khêu mối sầu",
    example: "cảnh vật làm khêu mối sầu",
  },
  {
    word: "khệnh khạng",
    part_of_speech: "tính từ",
    meaning:
      "có dáng đi hơi giạng chân, vẻ khó khăn, chậm chạp: bước đi khệnh khạng",
    example: "bước đi khệnh khạng",
  },
  {
    word: "khệnh khạng",
    part_of_speech: "tính từ",
    meaning:
      "làm ra vẻ quan trọng bằng dáng điệu, cử chỉ chậm chạp, dềnh dàng, bắt người khác phải chờ đợi: cứ khệnh khạng như ông tướng ấy!",
    example: "cứ khệnh khạng như ông tướng ấy!",
  },
  {
    word: "khênh",
    part_of_speech: "động từ",
    meaning:
      "nâng và chuyển vật nặng hoặc cồng kềnh bằng sức của hai hay nhiều người hợp lại: khiêng giường * nhờ người khiêng hộ cái tủ",
    example: "khiêng giường * nhờ người khiêng hộ cái tủ",
  },
  {
    word: "khều",
    part_of_speech: "động từ",
    meaning:
      "dùng que, sào hoặc chân cho mắc vào một vật, rồi đưa, kéo vật đó về phía mình: lấy que khều ổi * khều quả bóng vào bờ",
    example: "lấy que khều ổi * khều quả bóng vào bờ",
  },
  {
    word: "khều",
    part_of_speech: "động từ",
    meaning: "như cời: khều củ khoai trong tro nóng ra",
    example: "khều củ khoai trong tro nóng ra",
  },
  {
    word: "khều",
    part_of_speech: "động từ",
    meaning:
      "chạm tay vào người khác để ngầm ra hiệu: khều nhau ra một chỗ để bàn bạc",
    example: "khều nhau ra một chỗ để bàn bạc",
  },
  {
    word: "khi",
    part_of_speech: "danh từ",
    meaning:
      "thời điểm nào đó không xác định gắn với một sự việc cụ thể: nó vừa đi khi nãy * làm như mọi khi * một miếng khi đói bằng một gói khi no (tng)",
    example:
      "nó vừa đi khi nãy * làm như mọi khi * một miếng khi đói bằng một gói khi no (tng)",
  },
  {
    word: "khí",
    part_of_speech: "danh từ",
    meaning:
      "trạng thái của vật chất có thể lan ra chứa đầy vật chứa, có thể tích và hình dạng hoàn toàn tuỳ thuộc vào vật chứa: khí carbonic * khí hydrogen",
    example: "khí carbonic * khí hydrogen",
  },
  {
    word: "khí",
    part_of_speech: "danh từ",
    meaning:
      "không khí tự nhiên xung quanh, về mặt tác động đến cơ thể, giác quan của con người: khí lạnh * ở nơi thoáng khí * đi dạo để hít khí trời",
    example: "khí lạnh * ở nơi thoáng khí * đi dạo để hít khí trời",
  },
  {
    word: "khí",
    part_of_speech: "phụ từ",
    meaning:
      "(Khẩu ngữ) từ biểu thị mức độ ít của một tính chất mà người nói nghĩ là không hay lắm: bây giờ mới đến, kể cũng khí chậm * tôi hỏi khí không phải, bác chắc không phải người ở đây?",
    example:
      "bây giờ mới đến, kể cũng khí chậm * tôi hỏi khí không phải, bác chắc không phải người ở đây?",
  },
  {
    word: "khêu gợi",
    part_of_speech: "động từ",
    meaning:
      "khơi lên trong con người một tình cảm, tinh thần nào đó, vốn đã có tiềm tàng: khêu gợi trí tò mò * cảnh vật khêu gợi kỉ niệm xưa",
    example: "khêu gợi trí tò mò * cảnh vật khêu gợi kỉ niệm xưa",
  },
  {
    word: "khêu gợi",
    part_of_speech: "tính từ",
    meaning:
      "có tác dụng kích thích làm dậy lên những ham muốn, thường là ham muốn xác thịt: ăn mặc rất khêu gợi * bức ảnh đầy khêu gợi",
    example: "ăn mặc rất khêu gợi * bức ảnh đầy khêu gợi",
  },
  {
    word: "khí chất",
    part_of_speech: "danh từ",
    meaning:
      "đặc điểm của cá nhân thể hiện ở cường độ, nhịp độ các hoạt động tâm lí: khí chất nóng nảy",
    example: "khí chất nóng nảy",
  },
  {
    word: "khỉ",
    part_of_speech: "danh từ",
    meaning: "loài linh trưởng cỡ nhỏ, leo trèo rất giỏi.",
    example: "rõ khỉ! * lịch sự cái con khỉ! * thôi đi khỉ ạ!",
  },
  {
    word: "khí công",
    part_of_speech: "danh từ",
    meaning:
      "phương pháp rèn luyện thân thể chủ yếu bằng cách luyện thở: luyện khí công",
    example: "luyện khí công",
  },
  {
    word: "khí cốt",
    part_of_speech: "danh từ",
    meaning: "(cũ, hiếm) như cốt cách: giang hồ khí cốt",
    example: "giang hồ khí cốt",
  },
  {
    word: "khí cụ",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ dùng trong kĩ thuật, thường có cấu tạo phức tạp: khí cụ đo điện",
    example: "khí cụ đo điện",
  },
  {
    word: "khí cụ",
    part_of_speech: "danh từ",
    meaning: "(cũ) dụng cụ, công cụ: khí cụ đi rừng",
    example: "khí cụ đi rừng",
  },
  {
    word: "khí giới",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) đồ dùng để gây sát thương: tước khí giới * mở xưởng đúc khí giới",
    example: "tước khí giới * mở xưởng đúc khí giới",
  },
  {
    word: "khỉ gió",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) (con) cu li.",
    example: "khỉ gió cái nhà ông này!",
  },
  {
    word: "khỉ ho cò gáy",
    part_of_speech: "",
    meaning:
      "chỉ nơi hẻo lánh, xa xôi, rất ít người qua lại: vùng đất khỉ ho cò gáy",
    example: "vùng đất khỉ ho cò gáy",
  },
  {
    word: "khí hậu",
    part_of_speech: "danh từ",
    meaning:
      "tình hình chung về quy luật diễn biến của thời tiết ở một vùng, một miền: khí hậu nắng nóng * nước ta nằm trong vùng khí hậu nhiệt đới gió mùa",
    example:
      "khí hậu nắng nóng * nước ta nằm trong vùng khí hậu nhiệt đới gió mùa",
  },
  {
    word: "khí huyết",
    part_of_speech: "danh từ",
    meaning:
      "hơi sức và máu, về mặt tạo nên sức sống của con người, theo y học cổ truyền: khí huyết lưu thông",
    example: "khí huyết lưu thông",
  },
  {
    word: "khí huyết",
    part_of_speech: "danh từ",
    meaning: "(cũ, hiếm) dòng máu, dòng họ: anh em cùng khí huyết",
    example: "anh em cùng khí huyết",
  },
  {
    word: "khí lực",
    part_of_speech: "danh từ",
    meaning: "sức mạnh thể chất và tinh thần của con người: khí lực dồi dào",
    example: "khí lực dồi dào",
  },
  {
    word: "khi hồi",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) khi nãy, lúc nãy: nó vừa đi khi hồi",
    example: "nó vừa đi khi hồi",
  },
  {
    word: "khí nhạc",
    part_of_speech: "danh từ",
    meaning:
      "âm nhạc do nhạc khí phát ra; phân biệt với thanh nhạc: giảng viên khoa khí nhạc",
    example: "giảng viên khoa khí nhạc",
  },
  {
    word: "khí nhạc",
    part_of_speech: "danh từ",
    meaning:
      "nhạc sáng tác cho một loại nhạc khí hoặc cho một dàn nhạc: bản khí nhạc dành cho sáo trúc",
    example: "bản khí nhạc dành cho sáo trúc",
  },
  {
    word: "khí khái",
    part_of_speech: "tính từ",
    meaning:
      "có chí khí mạnh mẽ, cứng cỏi, không chịu khuất phục: tính tình ngay thẳng, khí khái * có khí khái của kẻ anh hùng",
    example: "tính tình ngay thẳng, khí khái * có khí khái của kẻ anh hùng",
  },
  {
    word: "khí khái",
    part_of_speech: "tính từ",
    meaning:
      "có lòng tự trọng, không muốn phiền luỵ, nhờ vả ai: nghèo nhưng rất khí khái",
    example: "nghèo nhưng rất khí khái",
  },
  {
    word: "khi không",
    part_of_speech: "phụ từ",
    meaning:
      "(phương ngữ, hiếm) bỗng dưng, không ai rõ lí do gì: khi không mà lại đuổi người ta như thế?",
    example: "khi không mà lại đuổi người ta như thế?",
  },
  {
    word: "khí quyển",
    part_of_speech: "danh từ",
    meaning:
      "lớp không khí bao quanh Trái Đất, hoặc một thiên thể: bảo vệ bầu khí quyển",
    example: "bảo vệ bầu khí quyển",
  },
  {
    word: "khi quân",
    part_of_speech: "động từ",
    meaning:
      "(cũ) lừa dối, coi thường vua: phạm tội khi quân * khi quân phạm thượng",
    example: "phạm tội khi quân * khi quân phạm thượng",
  },
  {
    word: "khí phách",
    part_of_speech: "danh từ",
    meaning:
      "sức mạnh tinh thần được biểu hiện cụ thể bằng hành động: khí phách anh hùng * một con người có khí phách",
    example: "khí phách anh hùng * một con người có khí phách",
  },
  {
    word: "khí quan",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) bộ phận trong cơ thể sinh vật đảm nhiệm một chức năng nhất định nào đó: tim là một khí quan của bộ máy tuần hoàn",
    example: "tim là một khí quan của bộ máy tuần hoàn",
  },
  {
    word: "khí tài",
    part_of_speech: "danh từ",
    meaning:
      "các khí cụ, thiết bị, máy móc dùng trong quân đội để phục vụ chiến đấu nhưng không có tác dụng trực tiếp tiêu diệt địch (nói tổng quát): quân đội được trang bị các loại vũ khí, khí tài hiện đại",
    example: "quân đội được trang bị các loại vũ khí, khí tài hiện đại",
  },
  {
    word: "khí thải",
    part_of_speech: "danh từ",
    meaning:
      "khí độc hại sinh ra trong quá trình sản xuất và sinh hoạt: hạn chế khí thải công nghiệp",
    example: "hạn chế khí thải công nghiệp",
  },
  {
    word: "khí thế",
    part_of_speech: "",
    meaning:
      "sức mạnh tinh thần đang dâng lên như không có gì cản nổi: bừng bừng khí thế * hừng hực khí thế xông trận",
    example: "bừng bừng khí thế * hừng hực khí thế xông trận",
  },
  {
    word: "khí sắc",
    part_of_speech: "danh từ",
    meaning:
      "vẻ ngoài, thường là trên mặt, biểu hiện thần sắc và sức khoẻ của con người: ốm lâu ngày, mặt thiếu khí sắc",
    example: "ốm lâu ngày, mặt thiếu khí sắc",
  },
  {
    word: "khí tiết",
    part_of_speech: "danh từ",
    meaning:
      "chí khí kiên cường trong việc bảo vệ giá trị và danh dự của mình: giữ tròn khí tiết * một con người có khí tiết",
    example: "giữ tròn khí tiết * một con người có khí tiết",
  },
  {
    word: "khí tượng",
    part_of_speech: "danh từ",
    meaning:
      "những hiện tượng xảy ra trong khí quyển, như mưa, gió, sấm, sét, vv (nói tổng quát).",
    example: "nha khí tượng",
  },
  {
    word: "khía",
    part_of_speech: "động từ",
    meaning:
      "tạo thành đường đứt nhỏ trên bề mặt bằng vật có cạnh sắc: lá mía khía vào tay * dùng dao khía dọc theo thân cá * những câu cạnh khoé như khía vào da thịt (b)",
    example:
      "lá mía khía vào tay * dùng dao khía dọc theo thân cá * những câu cạnh khoé như khía vào da thịt (b)",
  },
  {
    word: "khía",
    part_of_speech: "danh từ",
    meaning: "đường rãnh nhỏ rạch trên bề mặt một vật: rạch cho mấy khía",
    example: "rạch cho mấy khía",
  },
  {
    word: "khí tượng thuỷ văn",
    part_of_speech: "danh từ",
    meaning:
      "khí tượng và thuỷ văn (nói gộp); thường dùng để gọi cơ quan nghiên cứu về khí tượng và thuỷ văn: tổng cục khí tượng thuỷ văn",
    example: "tổng cục khí tượng thuỷ văn",
  },
  {
    word: "khịa",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ, hiếm) như bịa: khịa chuyện",
    example: "khịa chuyện",
  },
  {
    word: "khiếm nhã",
    part_of_speech: "tính từ",
    meaning:
      "thiếu nhã nhặn, thiếu lịch sự trong cách xử sự, giao tiếp: thái độ khiếm nhã * tỏ ra là người rất khiếm nhã",
    example: "thái độ khiếm nhã * tỏ ra là người rất khiếm nhã",
  },
  {
    word: "khích bác",
    part_of_speech: "động từ",
    meaning: "nói khích, nhằm trêu tức (nói khái quát): khích bác nhau",
    example: "khích bác nhau",
  },
  {
    word: "khía cạnh",
    part_of_speech: "danh từ",
    meaning:
      "phần hay mặt nhìn tách riêng ra khỏi những phần khác, mặt khác của sự vật, sự việc: đề cập tới tất cả các khía cạnh",
    example: "đề cập tới tất cả các khía cạnh",
  },
  {
    word: "khí vị",
    part_of_speech: "danh từ",
    meaning:
      "cái vẻ riêng người ta cảm thụ được (thường để nói về thơ văn): khí vị của mùa xuân",
    example: "khí vị của mùa xuân",
  },
  {
    word: "khiếm khuyết",
    part_of_speech: "",
    meaning:
      "(trang trọng) thiếu sót: còn nhiều khiếm khuyết * chiếc bình hoàn hảo, không một chút khiếm khuyết",
    example:
      "còn nhiều khiếm khuyết * chiếc bình hoàn hảo, không một chút khiếm khuyết",
  },
  {
    word: "khích lệ",
    part_of_speech: "động từ",
    meaning:
      "tác động đến tinh thần làm cho hăng hái, hứng khởi thêm lên: kết quả đáng khích lệ * khích lệ bạn cố gắng",
    example: "kết quả đáng khích lệ * khích lệ bạn cố gắng",
  },
  {
    word: "khích",
    part_of_speech: "động từ",
    meaning:
      "nói chạm đến lòng tự ái, tự trọng để gây tác động đến tinh thần nhằm làm cho hăng lên mà làm việc gì: nói khích * khích cho hai bên đánh nhau",
    example: "nói khích * khích cho hai bên đánh nhau",
  },
  {
    word: "khích động",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) như kích động: dùng nghĩa khí để khích động lòng người * tính dễ bị khích động",
    example: "dùng nghĩa khí để khích động lòng người * tính dễ bị khích động",
  },
  {
    word: "khiêm nhường",
    part_of_speech: "tính từ",
    meaning:
      "khiêm tốn và nhường nhịn trong quan hệ đối xử, không khoe khoang, không tranh giành: tính khiêm nhường * khiêm nhường với mọi người",
    example: "tính khiêm nhường * khiêm nhường với mọi người",
  },
  {
    word: "khiêm tốn",
    part_of_speech: "tính từ",
    meaning:
      "có ý thức và thái độ đúng mức trong việc đánh giá bản thân, không tự đề cao, không kiêu căng, tự phụ: lời nói khiêm tốn * sống khiêm tốn và hoà nhã với mọi người",
    example: "lời nói khiêm tốn * sống khiêm tốn và hoà nhã với mọi người",
  },
  {
    word: "khiêm tốn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ít ỏi, nhỏ bé (thường dùng với ý nhún nhường hoặc hài hước): đồng lương khiêm tốn * chiều cao khiêm tốn",
    example: "đồng lương khiêm tốn * chiều cao khiêm tốn",
  },
  {
    word: "khiến",
    part_of_speech: "động từ",
    meaning:
      "làm cho phải vận động, hoạt động theo ý muốn của mình: mệt đến mức không khiến được chân tay * duyên trời khiến",
    example: "mệt đến mức không khiến được chân tay * duyên trời khiến",
  },
  {
    word: "khiến",
    part_of_speech: "động từ",
    meaning:
      'tác động đến, gây phản ứng tâm lí, tình cảm nào đó: tiếng động khiến mọi người tỉnh giấc * "Bốn dây như khóc, như than, Khiến người trên tiệc cũng tan nát lòng!" (TKiều)',
    example:
      'tiếng động khiến mọi người tỉnh giấc * "Bốn dây như khóc, như than, Khiến người trên tiệc cũng tan nát lòng!" (TKiều)',
  },
  {
    word: "khiến",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bảo làm việc gì, vì cần đến: việc của tôi, không khiến ai động vào * ăn có mời, làm có khiến (tng)",
    example:
      "việc của tôi, không khiến ai động vào * ăn có mời, làm có khiến (tng)",
  },
  {
    word: "khiếp",
    part_of_speech: "động từ",
    meaning:
      "sợ đến mức mất hết tinh thần: sợ chết khiếp * chỉ nghe nói thôi cũng đã thấy khiếp",
    example: "sợ chết khiếp * chỉ nghe nói thôi cũng đã thấy khiếp",
  },
  {
    word: "khiếp",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ở mức độ cao một cách khác thường, tác động rất mạnh tới tâm lí người nói: đông khiếp * lo khiếp đi được * anh ấy làm việc khiếp lắm!",
    example: "đông khiếp * lo khiếp đi được * anh ấy làm việc khiếp lắm!",
  },
  {
    word: "khiếm thị",
    part_of_speech: "tính từ",
    meaning:
      "có khiếm khuyết bẩm sinh về thị giác, mất khả năng nhìn hoặc chỉ nhìn được rất kém: dạy học cho trẻ khiếm thị",
    example: "dạy học cho trẻ khiếm thị",
  },
  {
    word: "khiêng",
    part_of_speech: "động từ",
    meaning:
      "nâng và chuyển vật nặng hoặc cồng kềnh bằng sức của hai hay nhiều người hợp lại: khiêng giường * nhờ người khiêng hộ cái tủ",
    example: "khiêng giường * nhờ người khiêng hộ cái tủ",
  },
  {
    word: "khiên cưỡng",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất gò ép, thiếu tự nhiên: trả lời một cách khiên cưỡng * cách lập luận khiên cưỡng",
    example: "trả lời một cách khiên cưỡng * cách lập luận khiên cưỡng",
  },
  {
    word: "khiển trách",
    part_of_speech: "động từ",
    meaning:
      "phê phán nghiêm khắc khuyết điểm của cấp dưới (một hình thức kỉ luật nhẹ hơn cảnh cáo): bị khiển trách vì thiếu tinh thần trách nhiệm",
    example: "bị khiển trách vì thiếu tinh thần trách nhiệm",
  },
  {
    word: "khiêng vác",
    part_of_speech: "động từ",
    meaning:
      "chuyển đồ đạc một cách vất vả bằng sức của vai và tay, như khiêng và vác (nói khái quát): khiêng vác hàng hoá * khiêng vác đồ đạc vào nhà",
    example: "khiêng vác hàng hoá * khiêng vác đồ đạc vào nhà",
  },
  {
    word: "khiếp đảm",
    part_of_speech: "động từ",
    meaning:
      "sợ đến mức có cảm giác như rụng rời chân tay, mất hết hồn vía: tiếng rú khiếp đảm",
    example: "tiếng rú khiếp đảm",
  },
  {
    word: "khiếu",
    part_of_speech: "danh từ",
    meaning:
      "khả năng đặc biệt có tính chất bẩm sinh đối với một loại hoạt động nào đó: có khiếu hài hước * khiếu thẩm mĩ",
    example: "có khiếu hài hước * khiếu thẩm mĩ",
  },
  {
    word: "khiêu chiến",
    part_of_speech: "động từ",
    meaning:
      "cố tình gây sự làm cho đối phương tức tối, không chịu được phải ra đánh: cho quân đến khiêu chiến * gửi thư khiêu chiến",
    example: "cho quân đến khiêu chiến * gửi thư khiêu chiến",
  },
  {
    word: "khiếp nhược",
    part_of_speech: "tính từ",
    meaning:
      "sợ đến mức mất tinh thần và trở nên hèn nhát: khiếp nhược trước kẻ thù",
    example: "khiếp nhược trước kẻ thù",
  },
  {
    word: "khiếp sợ",
    part_of_speech: "",
    meaning: "khiếp và sợ, mất hết tinh thần: rùng mình khiếp sợ",
    example: "rùng mình khiếp sợ",
  },
  {
    word: "khiêu hấn",
    part_of_speech: "động từ",
    meaning: "(cũ) như gây hấn: hành động khiêu hấn",
    example: "hành động khiêu hấn",
  },
  {
    word: "khiêu dâm",
    part_of_speech: "động từ",
    meaning:
      "khêu gợi, gây kích thích sự ham muốn về xác thịt: sách báo khiêu dâm * tàng trữ tranh ảnh khiêu dâm",
    example: "sách báo khiêu dâm * tàng trữ tranh ảnh khiêu dâm",
  },
  {
    word: "khiêu khích",
    part_of_speech: "động từ",
    meaning:
      "cố tình làm cho tức tối mà phải có hành động đáp trả: hành động khiêu khích * nói bằng giọng khiêu khích",
    example: "hành động khiêu khích * nói bằng giọng khiêu khích",
  },
  {
    word: "khiếu nại",
    part_of_speech: "động từ",
    meaning:
      "đề nghị cơ quan có thẩm quyền xem xét một việc làm mà mình không đồng ý, cho là trái phép hay không hợp lí: đơn khiếu nại * khiếu nại lên các cấp có thẩm quyền",
    example: "đơn khiếu nại * khiếu nại lên các cấp có thẩm quyền",
  },
  {
    word: "khiếp vía",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) khiếp sợ đến mức như không còn hồn vía nữa: khiếp vía bỏ chạy * bị một phen khiếp vía",
    example: "khiếp vía bỏ chạy * bị một phen khiếp vía",
  },
  {
    word: "khiêu vũ",
    part_of_speech: "động từ",
    meaning:
      "làm những động tác phối hợp nhịp nhàng giữa tay, chân, cơ thể theo điệu nhạc và thường thành từng đôi nam nữ một, trong những buổi vui chung: theo học một lớp khiêu vũ * mời bạn đi khiêu vũ",
    example: "theo học một lớp khiêu vũ * mời bạn đi khiêu vũ",
  },
  {
    word: "khinh",
    part_of_speech: "động từ",
    meaning:
      "cho là không có giá trị gì, không đáng coi trọng: tư tưởng trọng nam khinh nữ * kẻ đáng khinh",
    example: "tư tưởng trọng nam khinh nữ * kẻ đáng khinh",
  },
  {
    word: "khinh",
    part_of_speech: "động từ",
    meaning:
      "cho là không có gì quan trọng đáng phải bận tâm: chủ quan khinh địch * qua đò khinh sóng (tng)",
    example: "chủ quan khinh địch * qua đò khinh sóng (tng)",
  },
  {
    word: "khiếu kiện",
    part_of_speech: "động từ",
    meaning:
      "khiếu nại, kiện cáo (nói khái quát): giải quyết dứt điểm các đơn khiếu kiện * bị khiếu kiện vì ăn hối lộ",
    example:
      "giải quyết dứt điểm các đơn khiếu kiện * bị khiếu kiện vì ăn hối lộ",
  },
  {
    word: "khiếu tố",
    part_of_speech: "động từ",
    meaning:
      "tố cáo và khiếu nại (nói khái quát): đơn thư khiếu tố tồn đọng quá nhiều",
    example: "đơn thư khiếu tố tồn đọng quá nhiều",
  },
  {
    word: "khin khít",
    part_of_speech: "tính từ",
    meaning: "hơi khít, không còn khe hở nữa: cửa đóng hơi khin khít",
    example: "cửa đóng hơi khin khít",
  },
  {
    word: "khìn khịt",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng thở hoặc tiếng nói ngắn và trầm, như bị tắc trong mũi: giọng khìn khịt như bị nghẹt mũi",
    example: "giọng khìn khịt như bị nghẹt mũi",
  },
  {
    word: "khinh bỉ",
    part_of_speech: "động từ",
    meaning:
      "khinh tới mức thậm tệ, vì cho là hết sức xấu xa, bỉ ổi: khinh bỉ kẻ xu nịnh * bĩu môi khinh bỉ",
    example: "khinh bỉ kẻ xu nịnh * bĩu môi khinh bỉ",
  },
  {
    word: "khinh khích",
    part_of_speech: "tính từ",
    meaning: "như khúc khích: cười khinh khích",
    example: "cười khinh khích",
  },
  {
    word: "khinh binh",
    part_of_speech: "danh từ",
    meaning:
      "quân được biên chế và trang bị gọn nhẹ để dễ cơ động trong khi tác chiến: đơn vị khinh binh",
    example: "đơn vị khinh binh",
  },
  {
    word: "khinh bạc",
    part_of_speech: "tính từ",
    meaning:
      "chẳng coi ra gì, không có biểu hiện chút tình cảm nào: thái độ khinh bạc",
    example: "thái độ khinh bạc",
  },
  {
    word: "khinh khỉnh",
    part_of_speech: "tính từ",
    meaning:
      "tỏ vẻ lạnh nhạt, không thèm để ý đến người mình đang tiếp xúc: giọng khinh khỉnh * thái độ khinh khỉnh",
    example: "giọng khinh khỉnh * thái độ khinh khỉnh",
  },
  {
    word: "khinh mạn",
    part_of_speech: "động từ",
    meaning:
      "khinh thường, ngạo mạn: nhìn bằng ánh mắt khinh mạn * tỏ thái độ khinh mạn",
    example: "nhìn bằng ánh mắt khinh mạn * tỏ thái độ khinh mạn",
  },
  {
    word: "khinh nhờn",
    part_of_speech: "động từ",
    meaning:
      "coi thường, không còn kính nể gì đối với người trên, đối với cái cần tôn trọng: khinh nhờn phép nước",
    example: "khinh nhờn phép nước",
  },
  {
    word: "khinh suất",
    part_of_speech: "tính từ",
    meaning:
      "thiếu thận trọng, không chú ý đầy đủ, do coi thường: nhiệm vụ quan trọng, không dám khinh suất",
    example: "nhiệm vụ quan trọng, không dám khinh suất",
  },
  {
    word: "khinh miệt",
    part_of_speech: "động từ",
    meaning:
      "khinh đến mức không coi ra gì, không thèm đếm xỉa đến: không hề có ý khinh miệt phụ nữ",
    example: "không hề có ý khinh miệt phụ nữ",
  },
  {
    word: "khinh khi",
    part_of_speech: "động từ",
    meaning: "coi thường, xem nhẹ, không coi ra gì: thái độ khinh khi",
    example: "thái độ khinh khi",
  },
  {
    word: "khịt",
    part_of_speech: "động từ",
    meaning:
      "thở ra hoặc hít mạnh bằng mũi làm bật thành tiếng: khịt mũi * con chó khịt khịt mấy tiếng đánh hơi",
    example: "khịt mũi * con chó khịt khịt mấy tiếng đánh hơi",
  },
  {
    word: "khinh quân",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như khinh binh: đội khinh quân",
    example: "đội khinh quân",
  },
  {
    word: "khinh thị",
    part_of_speech: "động từ",
    meaning:
      "(cũ) coi thường, cho là không đáng để chú ý đến: thái độ khinh thị",
    example: "thái độ khinh thị",
  },
  {
    word: "khinh thường",
    part_of_speech: "động từ",
    meaning:
      "có thái độ xem thường, cho là không có tác dụng, không có ý nghĩa gì: khinh thường đối thủ",
    example: "khinh thường đối thủ",
  },
  {
    word: "khít khao",
    part_of_speech: "tính từ",
    meaning:
      "rất khít, không có chỗ nào thừa hoặc thiếu (thường nói về cách sắp xếp công việc, thời gian): thời gian rất khít khao",
    example: "thời gian rất khít khao",
  },
  {
    word: "khinh rẻ",
    part_of_speech: "động từ",
    meaning: "khinh và coi rẻ quá mức: bị người đời khinh rẻ",
    example: "bị người đời khinh rẻ",
  },
  {
    word: "khít",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái liền sát vào với nhau, không để còn có khe hở: tủ đóng khít mộng",
    example: "tủ đóng khít mộng",
  },
  {
    word: "khít",
    part_of_speech: "tính từ",
    meaning:
      "hoàn toàn đúng với kích cỡ, với giới hạn, không có chỗ nào, chút nào thừa hoặc thiếu: áo mặc vừa khít * kế hoạch thực hiện vừa khít",
    example: "áo mặc vừa khít * kế hoạch thực hiện vừa khít",
  },
  {
    word: "khít",
    part_of_speech: "tính từ",
    meaning: "(Phương ngữ) kề bên, sát ngay bên cạnh: hai nhà khít nhau",
    example: "hai nhà khít nhau",
  },
  {
    word: "khít khìn khịt",
    part_of_speech: "tính từ",
    meaning:
      "như khít khịt (nhưng ý nhấn mạnh hơn): đồ đạc trong phòng kê khít khìn khịt * mộng lắp khít khìn khịt",
    example: "đồ đạc trong phòng kê khít khìn khịt * mộng lắp khít khìn khịt",
  },
  {
    word: "khít rịt",
    part_of_speech: "tính từ",
    meaning: "rất khít, không có chỗ hở: hàm răng khít rịt",
    example: "hàm răng khít rịt",
  },
  {
    word: "kho bạc",
    part_of_speech: "danh từ",
    meaning: "cơ quan quản lí tiền của nhà nước: nộp thuế vào kho bạc",
    example: "nộp thuế vào kho bạc",
  },
  {
    word: "khíu",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) khâu, đính tạm hai mép vào nhau để làm liền chỗ rách: khíu chỗ màn thủng",
    example: "khíu chỗ màn thủng",
  },
  {
    word: "khít khịt",
    part_of_speech: "tính từ",
    meaning:
      "rất khít, không còn chỗ hở, không thừa không thiếu: vung đậy vừa khít khịt với nồi",
    example: "vung đậy vừa khít khịt với nồi",
  },
  {
    word: "kho",
    part_of_speech: "danh từ",
    meaning:
      "chỗ tập trung cất giữ của cải, sản phẩm, hàng hoá hoặc nguyên vật liệu: kho thóc * kho quân nhu * chuyển hàng vào kho",
    example: "kho thóc * kho quân nhu * chuyển hàng vào kho",
  },
  {
    word: "kho",
    part_of_speech: "danh từ",
    meaning:
      "khối lượng lớn do tập trung tích góp lại: kho tài nguyên * kho truyện cổ Việt Nam",
    example: "kho tài nguyên * kho truyện cổ Việt Nam",
  },
  {
    word: "kho",
    part_of_speech: "động từ",
    meaning:
      "nấu kĩ thức ăn mặn cho ngấm các gia vị: kho cá * thịt kho với củ cải",
    example: "kho cá * thịt kho với củ cải",
  },
  {
    word: "kho bãi",
    part_of_speech: "danh từ",
    meaning:
      "kho và bãi rộng dùng để làm nơi chứa và bảo quản hàng hoá, xe cộ (nói khái quát): chuẩn bị kho bãi * quản lí kho bãi",
    example: "chuẩn bị kho bãi * quản lí kho bãi",
  },
  {
    word: "khó coi",
    part_of_speech: "tính từ",
    meaning:
      "có dáng vẻ không đẹp, không nhã, không gây được thiện cảm: điệu bộ khó coi * bộ quần áo trông khó coi lắm",
    example: "điệu bộ khó coi * bộ quần áo trông khó coi lắm",
  },
  {
    word: "khó chịu",
    part_of_speech: "tính từ",
    meaning:
      "có cảm giác hoặc làm cho có cảm giác không thoải mái, vì cơ thể hoặc tinh thần phải chịu đựng một điều gì đó không hay, không hợp, không thích: thời tiết nóng ẩm rất khó chịu * thấy trong người hơi khó chịu",
    example: "thời tiết nóng ẩm rất khó chịu * thấy trong người hơi khó chịu",
  },
  {
    word: "khó",
    part_of_speech: "tính từ",
    meaning:
      "đòi hỏi phải có nhiều điều kiện hoặc phải cố gắng nhiều, vất vả nhiều mới có được, mới làm được: bài toán khó * đường khó đi * vấn đề khó giải quyết",
    example: "bài toán khó * đường khó đi * vấn đề khó giải quyết",
  },
  {
    word: "khó",
    part_of_speech: "tính từ",
    meaning:
      "(tính người) đòi hỏi nhiều để có thể hài lòng: khó tính * càng về già tính nết càng khó",
    example: "khó tính * càng về già tính nết càng khó",
  },
  {
    word: "khó",
    part_of_speech: "tính từ",
    meaning:
      "ở trong tình trạng thiếu thốn, nghèo nàn: tiền vào nhà khó như gió vào nhà trống (tng)",
    example: "tiền vào nhà khó như gió vào nhà trống (tng)",
  },
  {
    word: "khó gặm",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) không dễ gì làm được: việc này xem chừng cũng khó gặm",
    example: "việc này xem chừng cũng khó gặm",
  },
  {
    word: "khó dễ",
    part_of_speech: "tính từ",
    meaning:
      "khó khăn, trở ngại do cố tình gây ra cho người khác: kiếm cớ gây khó dễ * làm khó dễ",
    example: "kiếm cớ gây khó dễ * làm khó dễ",
  },
  {
    word: "khó khăn",
    part_of_speech: "",
    meaning:
      "khó, có nhiều trở ngại hoặc thiếu thốn (nói khái quát): cuộc sống khó khăn * công việc còn nhiều khó khăn",
    example: "cuộc sống khó khăn * công việc còn nhiều khó khăn",
  },
  {
    word: "khò khè",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng thở không đều, ngắt quãng, như có vật cản làm cho bị vướng, không thông trong cổ họng: thở khò khè",
    example: "thở khò khè",
  },
  {
    word: "khó lòng",
    part_of_speech: "tính từ",
    meaning:
      "khó mà có thể (thường dùng với hàm ý phủ định): khó lòng mà tin được nó * học hành như thế thì khó lòng mà đỗ",
    example: "khó lòng mà tin được nó * học hành như thế thì khó lòng mà đỗ",
  },
  {
    word: "khó đăm đăm",
    part_of_speech: "tính từ",
    meaning:
      "(vẻ mặt) tỏ ra cau có, khó chịu, thường do đang có điều phải lo lắng, suy nghĩ hay vì có sự bực dọc không nói ra được: mặt khó đăm đăm",
    example: "mặt khó đăm đăm",
  },
  {
    word: "kho quỹ",
    part_of_speech: "danh từ",
    meaning:
      "công tác quản lí và theo dõi hoạt động của quỹ tiền mặt tại ngân hàng, kho bạc (nói khái quát): quản lí kho quỹ",
    example: "quản lí kho quỹ",
  },
  {
    word: "khó ở",
    part_of_speech: "tính từ",
    meaning:
      "có cảm giác không được khoẻ, có vẻ như sắp ốm: thấy trong người khó ở",
    example: "thấy trong người khó ở",
  },
  {
    word: "khó nhọc",
    part_of_speech: "tính từ",
    meaning:
      'vất vả, mất nhiều công sức vào việc gì: công lao khó nhọc * "Rủ nhau đi cấy đi cày, Bây giờ khó nhọc, có ngày phong lưu." (ca dao)',
    example:
      'công lao khó nhọc * "Rủ nhau đi cấy đi cày, Bây giờ khó nhọc, có ngày phong lưu." (ca dao)',
  },
  {
    word: "kho tàng",
    part_of_speech: "danh từ",
    meaning:
      "kho cất giữ của cải vật chất, vv (nói khái quát): bảo vệ kho tàng, bến bãi",
    example: "bảo vệ kho tàng, bến bãi",
  },
  {
    word: "kho tàng",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ tài sản tinh thần quý giá: kho tàng văn học dân gian * kho tàng văn hoá cổ",
    example: "kho tàng văn học dân gian * kho tàng văn hoá cổ",
  },
  {
    word: "kho tàu",
    part_of_speech: "động từ",
    meaning:
      "(thịt) kho kĩ với đường, gia vị và nước hàng cho có màu, thơm và ngọt đậm: thịt kho tàu",
    example: "thịt kho tàu",
  },
  {
    word: "bẫm",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) khoẻ: cho trâu ăn bẫm * bẫm sức * cày sâu cuốc bẫm",
    example: "cho trâu ăn bẫm * bẫm sức * cày sâu cuốc bẫm",
  },
  {
    word: "bẫm",
    part_of_speech: "tính từ",
    meaning:
      "(thông tục) dễ có được món lợi lớn: tự dưng được món bẫm * vớ bẫm",
    example: "tự dưng được món bẫm * vớ bẫm",
  },
  {
    word: "bấm",
    part_of_speech: "động từ",
    meaning:
      "ấn đầu ngón tay hoặc móng tay, hay đầu ngón chân xuống vật gì: bấm chuông * bấm móng tay vào quả cây * đường trơn, phải bấm móng chân mà đi",
    example:
      "bấm chuông * bấm móng tay vào quả cây * đường trơn, phải bấm móng chân mà đi",
  },
  {
    word: "bấm",
    part_of_speech: "động từ",
    meaning:
      'ấn ngón tay một cách kín đáo vào người khác để ngầm ra hiệu: bấm nhau cười * "Con Thuỷ vừa hỏi vừa bấm nhẹ tay tôi, ra hiệu cứ để yên." (AĐức; 20)',
    example:
      'bấm nhau cười * "Con Thuỷ vừa hỏi vừa bấm nhẹ tay tôi, ra hiệu cứ để yên." (AĐức; 20)',
  },
  {
    word: "bấm",
    part_of_speech: "động từ",
    meaning:
      "tính, đếm ngày, giờ bằng đồng hồ hay bằng cách đặt đầu ngón tay cái lên các đốt ngón tay: bấm ngón tay tính ngày * trọng tài bấm đồng hồ",
    example: "bấm ngón tay tính ngày * trọng tài bấm đồng hồ",
  },
  {
    word: "bẩm báo",
    part_of_speech: "động từ",
    meaning:
      "(Từ cũ) thưa, trình cho (cấp trên) biết: bẩm báo sai sự thật * không cần phải bẩm báo gì hết!",
    example: "bẩm báo sai sự thật * không cần phải bẩm báo gì hết!",
  },
  {
    word: "bẩm",
    part_of_speech: "động từ",
    meaning: "(cũ) thưa, trình: bẩm ngài * có việc phải bẩm quan",
    example: "bẩm ngài * có việc phải bẩm quan",
  },
  {
    word: "bậm bạch",
    part_of_speech: "tính từ",
    meaning:
      "(đi, chạy) có vẻ nặng nề, khó khăn: chiếc xe bậm bạch bò lên dốc * chạy bậm bạch",
    example: "chiếc xe bậm bạch bò lên dốc * chạy bậm bạch",
  },
  {
    word: "bầm",
    part_of_speech: "danh từ",
    meaning:
      '(phương ngữ) mẹ (chỉ dùng để xưng gọi, ở một số vùng miền Bắc): "Bầm ơi, sớm sớm chiều chiều, Thương con, bầm chớ lo nhiều bầm nghe!" (THữu; 7)',
    example:
      'Bầm ơi, sớm sớm chiều chiều, Thương con, bầm chớ lo nhiều bầm nghe!" (THữu; 7)',
  },
  {
    word: "bầm",
    part_of_speech: "tính từ",
    meaning:
      'thâm tím và hơi đen: mặt tím bầm * áo nâu bầm * "Cái mắt thì ngầu lên, hai chân thì đi lảo đảo, cái môi bầm lại mà run bần bật." (NCao; 3)',
    example:
      'mặt tím bầm * áo nâu bầm * "Cái mắt thì ngầu lên, hai chân thì đi lảo đảo, cái môi bầm lại mà run bần bật." (NCao; 3)',
  },
  {
    word: "bậm",
    part_of_speech: "tính từ",
    meaning:
      "(cây hoặc bộ phận của cây) to bề ngang và mọng nước, trông có vẻ khoẻ mạnh: mầm cây rất bậm",
    example: "mầm cây rất bậm",
  },
  {
    word: "bấm chí",
    part_of_speech: "động từ",
    meaning:
      "bấm nhau để đùa nghịch hay để ngầm ra hiệu (nói khái quát): suốt ngày bấm chí nhau",
    example: "suốt ngày bấm chí nhau",
  },
  {
    word: "bấm bụng",
    part_of_speech: "động từ",
    meaning:
      "cố nén chịu, không để lộ ra cho ai biết: bấm bụng nhịn cười * tức cũng phải bấm bụng mà chịu",
    example: "bấm bụng nhịn cười * tức cũng phải bấm bụng mà chịu",
  },
  {
    word: "bầm giập",
    part_of_speech: "tính từ",
    meaning: "trải qua nhiều đau đớn, tủi nhục: cuộc đời bầm giập",
    example: "cuộc đời bầm giập",
  },
  {
    word: "bẩm chất",
    part_of_speech: "danh từ",
    meaning:
      "đặc tính riêng của mỗi người, do tự nhiên mà có: bẩm chất thông minh",
    example: "bẩm chất thông minh",
  },
  {
    word: "bấm đốt",
    part_of_speech: "động từ",
    meaning:
      "đặt đầu ngón tay cái lần lượt vào đốt những ngón tay khác để tính: bấm đốt ngón tay để đếm",
    example: "bấm đốt ngón tay để đếm",
  },
  {
    word: "bấm giờ",
    part_of_speech: "động từ",
    meaning:
      "xác định chính xác trên đồng hồ thời điểm bắt đầu hoặc kết thúc của một việc gì: trọng tài bấm giờ thi đấu",
    example: "trọng tài bấm giờ thi đấu",
  },
  {
    word: "bấm giờ",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) tính ngày giờ lành dữ, tốt xấu, theo thuật bói toán: bấm giờ đi đón dâu",
    example: "bấm giờ đi đón dâu",
  },
  {
    word: "bấm ra sữa",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) (vẻ mặt) còn non dại, ngây thơ (hàm ý coi thường): mặt bấm ra sữa",
    example: "mặt bấm ra sữa",
  },
  {
    word: "bẩm tính",
    part_of_speech: "danh từ",
    meaning:
      "những đặc điểm tâm lí mà con người vốn có, do tự nhiên: bẩm tính hiền lành * bẩm tính thông minh",
    example: "bẩm tính hiền lành * bẩm tính thông minh",
  },
  {
    word: "bậm trợn",
    part_of_speech: "tính từ",
    meaning:
      '(phương ngữ, khẩu ngữ) có vẻ dữ tợn, hung hăng, thường biểu lộ ra mặt như bặm miệng, trợn mắt, v.v.: "Trương Rỗ rất xấc láo, bặm trợn, gặp chuyện gì trái ý là gã hầm hè đe nẹt (...)" (NgKiên; 15)',
    example:
      'Trương Rỗ rất xấc láo, bặm trợn, gặp chuyện gì trái ý là gã hầm hè đe nẹt (...)" (NgKiên; 15)',
  },
  {
    word: "bần",
    part_of_speech: "tính từ",
    meaning:
      '(cũ) nghèo: người có tướng bần * "Xưa nay tạo hoá xoay vần, Hết bần lại phú, chẳng cần gì đâu." (ca dao)',
    example:
      'người có tướng bần * "Xưa nay tạo hoá xoay vần, Hết bần lại phú, chẳng cần gì đâu." (ca dao)',
  },
  {
    word: "bấn",
    part_of_speech: "tính từ",
    meaning:
      "có khó khăn trong công việc do thiếu người, thiếu tiền bạc hoặc thì giờ, mà không biết giải quyết ra sao: nhà bấn người * dạo này bấn quá, không biết xoay xở vào đâu!",
    example: "nhà bấn người * dạo này bấn quá, không biết xoay xở vào đâu!",
  },
  {
    word: "bấn",
    part_of_speech: "tính từ",
    meaning:
      "rối bời, cuống quýt, không biết xử trí ra sao trước công việc dồn dập: lo bấn người * cả nhà, ai cũng bấn lên vì nhiều việc",
    example: "lo bấn người * cả nhà, ai cũng bấn lên vì nhiều việc",
  },
  {
    word: "bận",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) lần, lượt: hết bận này đến bận khác * bận sau đừng làm vậy! * quá tam ba bận",
    example:
      "hết bận này đến bận khác * bận sau đừng làm vậy! * quá tam ba bận",
  },
  {
    word: "bận",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) mặc: bận đồ tây",
    example: "bận đồ tây",
  },
  {
    word: "bận",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái đang phải làm việc gì đó nên không thể làm việc nào khác: đang bận học * bận việc đồng áng * bận tối mắt tối mũi",
    example: "đang bận học * bận việc đồng áng * bận tối mắt tối mũi",
  },
  {
    word: "bận",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (sự việc) có liên quan và làm cho phải lo nghĩ đến: chuyện người ta bận gì đến mình?",
    example: "chuyện người ta bận gì đến mình?",
  },
  {
    word: "bẩm sinh",
    part_of_speech: "tính từ",
    meaning:
      "(đặc điểm) vốn có từ lúc sinh ra: dị tật bẩm sinh * năng khiếu bẩm sinh",
    example: "dị tật bẩm sinh * năng khiếu bẩm sinh",
  },
  {
    word: "bẩn",
    part_of_speech: "tính từ",
    meaning:
      "(Nam thường dơ) có nhiều bụi bặm, rác rưởi, cáu ghét hoặc bị hoen ố: nước bẩn * quần áo bị dây bẩn",
    example: "nước bẩn * quần áo bị dây bẩn",
  },
  {
    word: "bẩn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) xấu xa, tồi tệ đến mức đáng khinh: bẩn tính * chơi bẩn với bạn bè",
    example: "bẩn tính * chơi bẩn với bạn bè",
  },
  {
    word: "bần bật",
    part_of_speech: "tính từ",
    meaning:
      '(run, rung) mạnh, giật nẩy lên liên tiếp: sợ quá, chân tay run lên bần bật * "Gió bên ngoài bần bật như muốn xé tung phên cửa." (DThXQuý; 1)',
    example:
      'sợ quá, chân tay run lên bần bật * "Gió bên ngoài bần bật như muốn xé tung phên cửa." (DThXQuý; 1)',
  },
  {
    word: "bấn bít",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) không biết xử trí ra sao do có quá nhiều công việc cần phải làm một lúc: mùa màng bấn bít",
    example: "mùa màng bấn bít",
  },
  {
    word: "bận bịu",
    part_of_speech: "",
    meaning:
      "bận việc (nói khái quát): công việc bận bịu * cả ngày bận bịu với con cái, nhà cửa",
    example: "công việc bận bịu * cả ngày bận bịu với con cái, nhà cửa",
  },
  {
    word: "bấn bíu",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như bấn (ng2; nói khái quát): công việc bấn bíu",
    example: "công việc bấn bíu",
  },
  {
    word: "bần cùng",
    part_of_speech: "tính từ",
    meaning:
      "nghèo khổ đến cùng cực: cảnh sống bần cùng * cứu giúp kẻ bần cùng",
    example: "cảnh sống bần cùng * cứu giúp kẻ bần cùng",
  },
  {
    word: "bần cùng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (làm việc gì) ở vào thế cùng, thế bí, không có cách nào khác: bần cùng lắm tôi mới phải nhờ đến anh * đó cũng chỉ là chuyện bần cùng!",
    example:
      "bần cùng lắm tôi mới phải nhờ đến anh * đó cũng chỉ là chuyện bần cùng!",
  },
  {
    word: "bấn loạn",
    part_of_speech: "",
    meaning:
      "bị rối loạn, không tự chủ được, không biết xử trí thế nào: tinh thần bấn loạn * tâm trí bấn loạn",
    example: "tinh thần bấn loạn * tâm trí bấn loạn",
  },
  {
    word: "bận lòng",
    part_of_speech: "tính từ",
    meaning:
      'phải nghĩ ngợi đến, phải phiền lòng: con hư làm bận lòng cha mẹ * "Đã quyết không mong sum họp mãi, Bận lòng chi nữa lúc chia phôi?" (ThLữ; 3)',
    example:
      'con hư làm bận lòng cha mẹ * "Đã quyết không mong sum họp mãi, Bận lòng chi nữa lúc chia phôi?" (ThLữ; 3)',
  },
  {
    word: "bần hàn",
    part_of_speech: "tính từ",
    meaning: "nghèo khổ và đói rét: cuộc sống bần hàn",
    example: "cuộc sống bần hàn",
  },
  {
    word: "bận mọn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (phụ nữ) bận bịu con mọn: bận mọn cả ngày, không đi đâu được",
    example: "bận mọn cả ngày, không đi đâu được",
  },
  {
    word: "bận rộn",
    part_of_speech: "tính từ",
    meaning:
      "bận nhiều việc một lúc, việc nọ tiếp liền việc kia: công việc bận rộn * ngày mùa bận rộn * không khí bận rộn",
    example: "công việc bận rộn * ngày mùa bận rộn * không khí bận rộn",
  },
  {
    word: "bần tiện",
    part_of_speech: "tính từ",
    meaning:
      "không rộng rãi, có những tính toán về tiền nong một cách nhỏ nhen, đáng khinh: tính bần tiện * đồ bần tiện! (tiếng mắng chửi)",
    example: "tính bần tiện * đồ bần tiện! (tiếng mắng chửi)",
  },
  {
    word: "bận tâm",
    part_of_speech: "tính từ",
    meaning:
      "phải để tâm lo lắng, suy nghĩ đến: bận tâm đến chuyện con cái * chuyện nhỏ, không đáng phải bận tâm",
    example: "bận tâm đến chuyện con cái * chuyện nhỏ, không đáng phải bận tâm",
  },
  {
    word: "bần thần",
    part_of_speech: "tính từ",
    meaning:
      "kém vẻ linh hoạt vì mệt mỏi hoặc vì đang có điều băn khoăn, lo nghĩ: nét mặt bần thần * bần thần cả người",
    example: "nét mặt bần thần * bần thần cả người",
  },
  {
    word: "bẩn thỉu",
    part_of_speech: "tính từ",
    meaning:
      "bẩn (nói khái quát): nhà cửa bẩn thỉu * ăn bẩn ăn thỉu * mưu đồ bẩn thỉu",
    example: "nhà cửa bẩn thỉu * ăn bẩn ăn thỉu * mưu đồ bẩn thỉu",
  },
  {
    word: "bâng lâng",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái bâng khuâng, vấn vương và cảm thấy nhẹ nhàng, dễ chịu: cảm giác bâng lâng * bâng lâng cả người",
    example: "cảm giác bâng lâng * bâng lâng cả người",
  },
  {
    word: "bấp ba bấp bênh",
    part_of_speech: "tính từ",
    meaning: "như bấp bênh (nhưng ý mức độ nhiều): đời sống bấp ba bấp bênh",
    example: "đời sống bấp ba bấp bênh",
  },
  {
    word: "bâng khuâng",
    part_of_speech: "tính từ",
    meaning:
      'có những cảm xúc luyến tiếc, nhớ thương xen lẫn nhau, gây ra trạng thái như hơi ngẩn ngơ: lòng dạ bâng khuâng * "Bâng khuâng nhớ cảnh, nhớ người, Nhớ nơi kỳ ngộ, vội dời chân đi." (TKiều)',
    example:
      'lòng dạ bâng khuâng * "Bâng khuâng nhớ cảnh, nhớ người, Nhớ nơi kỳ ngộ, vội dời chân đi." (TKiều)',
  },
  {
    word: "bâng quơ",
    part_of_speech: "tính từ",
    meaning:
      "vu vơ, không nhằm trực tiếp vào một đối tượng, một mục đích nào rõ ràng: nói bâng quơ vài câu * suy nghĩ bâng quơ * mắt nhìn bâng quơ",
    example: "nói bâng quơ vài câu * suy nghĩ bâng quơ * mắt nhìn bâng quơ",
  },
  {
    word: "bập",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) bẹ: bập dừa * bập chuối",
    example: "bập dừa * bập chuối",
  },
  {
    word: "bập",
    part_of_speech: "động từ",
    meaning:
      "bổ hoặc chém mạnh cho ngập sâu: lưỡi cuốc bập mạnh xuống đất * chém bập một nhát vào thân chuối",
    example: "lưỡi cuốc bập mạnh xuống đất * chém bập một nhát vào thân chuối",
  },
  {
    word: "bập",
    part_of_speech: "động từ",
    meaning:
      "kẹp lấy, ngậm lấy một cách rất nhanh: chiếc còng số 8 bập vào cổ tay tên cướp",
    example: "chiếc còng số 8 bập vào cổ tay tên cướp",
  },
  {
    word: "bập",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) dính sâu, mắc sâu vào một cách nhanh chóng (thường là chuyện không hay): bập vào cờ bạc, rượu chè",
    example: "bập vào cờ bạc, rượu chè",
  },
  {
    word: "bập",
    part_of_speech: "động từ",
    meaning:
      "bặm môi lại và hít mạnh vào để lấy hơi thuốc khi hút thuốc: bập một hơi thuốc dài",
    example: "bập một hơi thuốc dài",
  },
  {
    word: "bập bênh",
    part_of_speech: "danh từ",
    meaning:
      "đồ chơi của trẻ em gồm một tấm ván đặt trên một cái trục ở giữa, cho trẻ ngồi ở hai đầu để nhún lên nhún xuống: chơi cầu trượt, bập bênh",
    example: "chơi cầu trượt, bập bênh",
  },
  {
    word: "bập bẹ",
    part_of_speech: "động từ",
    meaning:
      "nói hoặc đọc một cách khó khăn và chưa rõ ràng, thường vì mới học nói, mới biết một ít: trẻ bập bẹ tập nói * bập bẹ được vài chữ tiếng Anh",
    example: "trẻ bập bẹ tập nói * bập bẹ được vài chữ tiếng Anh",
  },
  {
    word: "bấp bênh",
    part_of_speech: "tính từ",
    meaning:
      "dễ mất thăng bằng, dễ nghiêng lệch vì không có chỗ tựa vững chắc: tấm ván kê bấp bênh",
    example: "tấm ván kê bấp bênh",
  },
  {
    word: "bấp bênh",
    part_of_speech: "tính từ",
    meaning:
      "không ổn định, không chắc chắn, dễ thay đổi thất thường vì không có cơ sở vững chắc: cuộc sống bấp bênh * công việc bấp bênh, không ổn định",
    example: "cuộc sống bấp bênh * công việc bấp bênh, không ổn định",
  },
  {
    word: "bấp bênh",
    part_of_speech: "tính từ",
    meaning:
      "dễ nghiêng ngả, dễ dao động: lập trường bấp bênh * tư tưởng bấp bênh",
    example: "lập trường bấp bênh * tư tưởng bấp bênh",
  },
  {
    word: "bập bõm",
    part_of_speech: "phụ từ",
    meaning:
      '(nhớ, nghe, biết) một cách không chắc chắn và không đầy đủ, chỗ được chỗ không: nghe bập bõm * biết bập bõm vài câu tiếng Anh * "(...) chữ in khó nhận mặt chữ, ông đọc nó cứ bập bõm, câu được, câu chăng (...)" (KLân; 5)',
    example:
      'nghe bập bõm * biết bập bõm vài câu tiếng Anh * "(...) chữ in khó nhận mặt chữ, ông đọc nó cứ bập bõm, câu được, câu chăng (...)" (KLân; 5)',
  },
  {
    word: "bập bồng",
    part_of_speech: "động từ",
    meaning: "(hiếm) như bập bềnh: thuyền bập bồng trên mặt biển",
    example: "thuyền bập bồng trên mặt biển",
  },
  {
    word: "bập bềnh",
    part_of_speech: "động từ",
    meaning:
      'từ gợi tả dáng chuyển động lên xuống, nhấp nhô theo làn sóng: thuyền bập bềnh trên sông * bè nứa nổi bập bềnh * "Sóng lăn tăn, làm giạt chiếc lá vàng bập bềnh." (NgCHoan; 8)',
    example:
      'thuyền bập bềnh trên sông * bè nứa nổi bập bềnh * "Sóng lăn tăn, làm giạt chiếc lá vàng bập bềnh." (NgCHoan; 8)',
  },
  {
    word: "bập bùng",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả ánh lửa cháy không đều, khi bốc cao, khi hạ thấp: lửa cháy bập bùng * ánh đuốc bập bùng",
    example: "lửa cháy bập bùng * ánh đuốc bập bùng",
  },
  {
    word: "bập bùng",
    part_of_speech: "tính từ",
    meaning:
      "(tiếng trống, tiếng đàn) khi lên cao khi hạ thấp một cách nhịp nhàng: tiếng đàn guitar bập bùng",
    example: "tiếng đàn guitar bập bùng",
  },
  {
    word: "bập bỗng",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) khi lên, khi xuống, thay đổi thất thường: mùa màng bập bỗng",
    example: "mùa màng bập bỗng",
  },
  {
    word: "bật",
    part_of_speech: "động từ",
    meaning:
      "làm nẩy mạnh (dây căng hoặc dây co dãn được): bật dây cao su * bật dây đàn",
    example: "bật dây cao su * bật dây đàn",
  },
  {
    word: "bật",
    part_of_speech: "động từ",
    meaning:
      "nẩy lên hoặc văng mạnh ra (do chịu tác động của một lực nào đó): bão làm bật gốc cây * ngồi bật dậy",
    example: "bão làm bật gốc cây * ngồi bật dậy",
  },
  {
    word: "bật",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) làm cho bung mạnh ra: bật nắp chai bia",
    example: "bật nắp chai bia",
  },
  {
    word: "bật",
    part_of_speech: "động từ",
    meaning:
      "nảy mạnh, vọt mạnh ra từ bên trong: cây bật chồi non * ngã bật máu tươi",
    example: "cây bật chồi non * ngã bật máu tươi",
  },
  {
    word: "bật",
    part_of_speech: "động từ",
    meaning:
      "phát ra, nảy ra đột ngột: ôm mặt bật khóc * đang khóc bỗng dưng bật cười * trong đầu bật ra một ý nghĩ",
    example:
      "ôm mặt bật khóc * đang khóc bỗng dưng bật cười * trong đầu bật ra một ý nghĩ",
  },
  {
    word: "bật",
    part_of_speech: "động từ",
    meaning:
      "làm cho máy móc, thiết bị chuyển sang trạng thái hoạt động: bật đài to quá * đặt chế độ tự động bật máy",
    example: "bật đài to quá * đặt chế độ tự động bật máy",
  },
  {
    word: "bật",
    part_of_speech: "động từ",
    meaning:
      "làm cho nảy lửa, bừng sáng các dụng cụ lấy lửa, lấy ánh sáng: bật đèn lên * bật bật lửa",
    example: "bật đèn lên * bật bật lửa",
  },
  {
    word: "bật",
    part_of_speech: "động từ",
    meaning:
      "làm nổi rõ hẳn lên: chiếc áo đen làm nổi bật nước da trắng hồng * nêu bật vấn đề",
    example: "chiếc áo đen làm nổi bật nước da trắng hồng * nêu bật vấn đề",
  },
  {
    word: "bất",
    part_of_speech: "danh từ",
    meaning:
      "bài gồm ba mươi sáu quân, chơi theo lối rút may rủi để tính điểm đến mười (quá mười thì bị loại, gọi là bị bất): đánh bất * rút bất",
    example: "đánh bất * rút bất",
  },
  {
    word: "bất an",
    part_of_speech: "tính từ",
    meaning:
      "không yên ổn: tình hình bất an * ngọc thể bất an * thấy trong lòng bất an",
    example: "tình hình bất an * ngọc thể bất an * thấy trong lòng bất an",
  },
  {
    word: "bất bình",
    part_of_speech: "tính từ",
    meaning: "(cũ)",
    example:
      "bất bình trước thái độ hách dịch, cửa quyền * tỏ thái độ bất bình",
  },
  {
    word: "bất cập",
    part_of_speech: "tính từ",
    meaning: "(Ít dùng) không kịp: phải suy nghĩ cho kĩ, không thì hối bất cập",
    example: "phải suy nghĩ cho kĩ, không thì hối bất cập",
  },
  {
    word: "bất cập",
    part_of_speech: "tính từ",
    meaning:
      "không đạt yêu cầu, không đủ mức cần thiết: ý đồ thì lớn, nhưng tài năng thì bất cập",
    example: "ý đồ thì lớn, nhưng tài năng thì bất cập",
  },
  {
    word: "bất cập",
    part_of_speech: "danh từ",
    meaning:
      "điều chưa phù hợp, chưa đủ mức cần thiết: cách giải quyết còn nhiều vấn đề bấp cập * khắc phục những bất cập",
    example:
      "cách giải quyết còn nhiều vấn đề bấp cập * khắc phục những bất cập",
  },
  {
    word: "bất chấp",
    part_of_speech: "động từ",
    meaning:
      'không kể tới, không đếm xỉa tới: bất chấp mọi hiểm nguy * bất chấp dư luận * "Tôi bất chấp cả đạn bắn vèo vèo bên tai, xách mác đứng dậy chạy đi." (ĐGiỏi; 4)',
    example:
      'bất chấp mọi hiểm nguy * bất chấp dư luận * "Tôi bất chấp cả đạn bắn vèo vèo bên tai, xách mác đứng dậy chạy đi." (ĐGiỏi; 4)',
  },
  {
    word: "bất bằng",
    part_of_speech: "tính từ",
    meaning:
      '(hiếm) trái lẽ công bằng, trái với công lí: "Anh hùng tiếng đã gọi rằng, Giữa đường dẫu thấy bất bằng mà tha!" (TKiều)',
    example:
      'Anh hùng tiếng đã gọi rằng, Giữa đường dẫu thấy bất bằng mà tha!" (TKiều)',
  },
  {
    word: "bất biến",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái không hề thay đổi, không phát triển; phân biệt với khả biến: không có hiện tượng thiên nhiên cũng như xã hội nào là bất biến * nhất thành bất biến (tng)",
    example:
      "không có hiện tượng thiên nhiên cũng như xã hội nào là bất biến * nhất thành bất biến (tng)",
  },
  {
    word: "bất cần",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tỏ ra không cần để ý gì đến, thế nào cũng mặc: tỏ vẻ bất cần * tính bất cần",
    example: "tỏ vẻ bất cần * tính bất cần",
  },
  {
    word: "bất cẩn",
    part_of_speech: "tính từ",
    meaning: "không cẩn thận, vô ý: canh phòng bất cẩn",
    example: "canh phòng bất cẩn",
  },
  {
    word: "bất chính",
    part_of_speech: "tính từ",
    meaning:
      "không chính đáng, trái với đạo đức, trái pháp luật: thu nhập bất chính * quan hệ nam nữ bất chính * có hành vi bất chính",
    example:
      "thu nhập bất chính * quan hệ nam nữ bất chính * có hành vi bất chính",
  },
  {
    word: "bất chợt",
    part_of_speech: "phụ từ",
    meaning:
      "như chợt (nhưng nghĩa mạnh hơn): bất chợt nảy ra một sáng kiến * cơn mưa bất chợt",
    example: "bất chợt nảy ra một sáng kiến * cơn mưa bất chợt",
  },
  {
    word: "bất công",
    part_of_speech: "tính từ",
    meaning: "không công bằng: đối xử bất công",
    example: "đối xử bất công",
  },
  {
    word: "bất diệt",
    part_of_speech: "tính từ",
    meaning:
      "(trang trọng) (cái có giá trị tinh thần) không bao giờ mất được, còn mãi mãi: niềm tin bất diệt * tinh thần bất diệt",
    example: "niềm tin bất diệt * tinh thần bất diệt",
  },
  {
    word: "bất cứ",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị ý không loại trừ trường hợp nào cả, trong mọi trường hợp: không tiếp bất cứ ai * chuyện đó thì bất cứ lúc nào cũng có thể xảy ra",
    example:
      "không tiếp bất cứ ai * chuyện đó thì bất cứ lúc nào cũng có thể xảy ra",
  },
  {
    word: "bất đắc dĩ",
    part_of_speech: "",
    meaning:
      "(làm việc gì) ở trong cái thế không muốn chút nào mà vẫn phải làm: việc bất đắc dĩ * từ chối không tiện, bất đắc dĩ phải nhận",
    example: "việc bất đắc dĩ * từ chối không tiện, bất đắc dĩ phải nhận",
  },
  {
    word: "bất đắc chí",
    part_of_speech: "tính từ",
    meaning: "(cũ) không được thoả chí bình sinh: một nhà nho bất đắc chí",
    example: "một nhà nho bất đắc chí",
  },
  {
    word: "bất di bất dịch",
    part_of_speech: "",
    meaning:
      "(cái có giá trị tinh thần) không bao giờ thay đổi, mãi mãi vẫn như thế: một chân lí bất di bất dịch",
    example: "một chân lí bất di bất dịch",
  },
  {
    word: "bất giác",
    part_of_speech: "phụ từ",
    meaning:
      "(hiếm) thình lình, chợt xảy ra ngoài ý định: bất giác buông tiếng thở dài * nghĩ đến đó, bất giác lo sợ",
    example: "bất giác buông tiếng thở dài * nghĩ đến đó, bất giác lo sợ",
  },
  {
    word: "bất đồng",
    part_of_speech: "tính từ",
    meaning:
      "(ngôn ngữ hoặc tư tưởng) khác nhau: ý kiến bất đồng * bất đồng về quan điểm",
    example: "ý kiến bất đồng * bất đồng về quan điểm",
  },
  {
    word: "bật đèn xanh",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) ngầm ra hiệu cho phép làm một việc gì đó (thường là sai trái): thủ trưởng bật đèn xanh cho nhân viên nhận hối lộ",
    example: "thủ trưởng bật đèn xanh cho nhân viên nhận hối lộ",
  },
  {
    word: "bất động sản",
    part_of_speech: "danh từ",
    meaning:
      "tài sản không chuyển dời đi được, như ruộng đất, nhà cửa, v.v.; phân biệt với động sản: kinh doanh bất động sản",
    example: "kinh doanh bất động sản",
  },
  {
    word: "bất định",
    part_of_speech: "tính từ",
    meaning:
      "không nhất định, không chắc chắn: khắc phục rủi ro, hạn chế độ bất định trong kinh doanh",
    example: "khắc phục rủi ro, hạn chế độ bất định trong kinh doanh",
  },
  {
    word: "bất định",
    part_of_speech: "tính từ",
    meaning:
      "(trạng thái tâm lí, nhận thức) mơ hồ, không có gì rõ rệt: tâm thần bất định",
    example: "tâm thần bất định",
  },
  {
    word: "bất động",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái cơ thể không cử động: bệnh nhân nằm bất động trên giường * ngồi bất động",
    example: "bệnh nhân nằm bất động trên giường * ngồi bất động",
  },
  {
    word: "bất đồ",
    part_of_speech: "phụ từ",
    meaning:
      "(sự việc xảy đến) thình lình, không liệu trước được: trời đang nắng, bất đồ lại đổ mưa",
    example: "trời đang nắng, bất đồ lại đổ mưa",
  },
  {
    word: "bất hạnh",
    part_of_speech: "tính từ",
    meaning:
      "không may gặp phải điều rủi ro, làm cho đau khổ: đứa trẻ bất hạnh * cuộc đời bất hạnh",
    example: "đứa trẻ bất hạnh * cuộc đời bất hạnh",
  },
  {
    word: "bất hạnh",
    part_of_speech: "tính từ",
    meaning: "(người) không may mà chết: kẻ bất hạnh",
    example: "kẻ bất hạnh",
  },
  {
    word: "bất hoà",
    part_of_speech: "tính từ",
    meaning: "không hoà thuận với nhau: không khí bất hoà",
    example: "không khí bất hoà",
  },
  {
    word: "bất hiếu",
    part_of_speech: "tính từ",
    meaning:
      "(thái độ đối với cha mẹ) tệ bạc, đối xử không phải đạo: đứa con bất hiếu * ăn ở bất hiếu",
    example: "đứa con bất hiếu * ăn ở bất hiếu",
  },
  {
    word: "bất hảo",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (con người, việc làm) không tốt: phần tử bất hảo * thành tích bất hảo",
    example: "phần tử bất hảo * thành tích bất hảo",
  },
  {
    word: "bất hợp lí",
    part_of_speech: "tính từ",
    meaning:
      "không hợp lí: một chính sách bất hợp lí * những điều bất hợp lí trong dự thảo kế hoạch",
    example:
      "một chính sách bất hợp lí * những điều bất hợp lí trong dự thảo kế hoạch",
  },
  {
    word: "bất hợp pháp",
    part_of_speech: "tính từ",
    meaning: "trái với pháp luật: làm ăn bất hợp pháp",
    example: "làm ăn bất hợp pháp",
  },
  {
    word: "bất hủ",
    part_of_speech: "tính từ",
    meaning: "không bao giờ mất, mà mãi mãi có giá trị: một áng văn bất hủ",
    example: "một áng văn bất hủ",
  },
  {
    word: "bất hợp tác",
    part_of_speech: "tính từ",
    meaning: "không hợp tác: thái độ bất hợp tác * chủ trương bất hợp tác",
    example: "thái độ bất hợp tác * chủ trương bất hợp tác",
  },
  {
    word: "bất hợp lý",
    part_of_speech: "tính từ",
    meaning:
      "không hợp lí: một chính sách bất hợp lí * những điều bất hợp lí trong dự thảo kế hoạch",
    example:
      "một chính sách bất hợp lí * những điều bất hợp lí trong dự thảo kế hoạch",
  },
  {
    word: "bất khả kháng",
    part_of_speech: "tính từ",
    meaning:
      "không thể, không có khả năng chống lại được: lí do bất khả kháng * ở vào tình thế bất khả kháng",
    example: "lí do bất khả kháng * ở vào tình thế bất khả kháng",
  },
  {
    word: "bất kể",
    part_of_speech: "phụ từ",
    meaning:
      'từ biểu thị ý không có sự một phân biệt, lựa chọn nào, không loại trừ một trường hợp cụ thể nào: bất kể ai cũng phải tuân thủ pháp luật * làm việc bất kể đêm ngày * "Hắn thâu tô rất nặng, đánh đập tá điền bất kể sống chết." (ĐGiỏi; 1)',
    example:
      'bất kể ai cũng phải tuân thủ pháp luật * làm việc bất kể đêm ngày * "Hắn thâu tô rất nặng, đánh đập tá điền bất kể sống chết." (ĐGiỏi; 1)',
  },
  {
    word: "bất khả xâm phạm",
    part_of_speech: "",
    meaning:
      "không ai được phép xâm phạm (theo luật pháp): quyền dân tộc bất khả xâm phạm",
    example: "quyền dân tộc bất khả xâm phạm",
  },
  {
    word: "bất hợp lệ",
    part_of_speech: "tính từ",
    meaning: "không hợp lệ: phiếu bầu bất hợp lệ",
    example: "phiếu bầu bất hợp lệ",
  },
  {
    word: "bất khả thi",
    part_of_speech: "tính từ",
    meaning:
      "không thể, không có khả năng thực hiện được: một kế hoạch bất khả thi",
    example: "một kế hoạch bất khả thi",
  },
  {
    word: "bất kham",
    part_of_speech: "tính từ",
    meaning:
      "(ngựa) dữ, không dễ dàng chịu để cho điều khiển: con ngựa bất kham",
    example: "con ngựa bất kham",
  },
  {
    word: "bất kính",
    part_of_speech: "tính từ",
    meaning: "thiếu sự tôn kính (như phải có): bất kính với người trên",
    example: "bất kính với người trên",
  },
  {
    word: "bất khuất",
    part_of_speech: "tính từ",
    meaning:
      "không chịu khuất phục: tinh thần bất khuất * đấu tranh bất khuất * người chiến sĩ kiên cường, bất khuất",
    example:
      "tinh thần bất khuất * đấu tranh bất khuất * người chiến sĩ kiên cường, bất khuất",
  },
  {
    word: "bất lợi",
    part_of_speech: "tính từ",
    meaning:
      "khôngcó lợi, không thuận lợi: thời tiết bất lợi * điều kiện bất lợi",
    example: "thời tiết bất lợi * điều kiện bất lợi",
  },
  {
    word: "bất kì",
    part_of_speech: "tính từ",
    meaning:
      "không có điều kiện nào kèm theo: kẻ một đường thẳng bất kì * lấy một câu thơ bất kì trong Truyện Kiều",
    example:
      "kẻ một đường thẳng bất kì * lấy một câu thơ bất kì trong Truyện Kiều",
  },
  {
    word: "bất kì",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị ý không loại trừ trường hợp nào cả, trong mọi trường hợp: bất kì ai thấy cảnh ấy cũng động lòng * phải hoàn thành bằng bất kì giá nào",
    example:
      "bất kì ai thấy cảnh ấy cũng động lòng * phải hoàn thành bằng bất kì giá nào",
  },
  {
    word: "bất luận",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị ý không loại trừ trường hợp nào cả: bất luận thế nào cũng phải đi * bất luận là ai cũng đều phải tuân theo pháp luật",
    example:
      "bất luận thế nào cũng phải đi * bất luận là ai cũng đều phải tuân theo pháp luật",
  },
  {
    word: "bất lực",
    part_of_speech: "tính từ",
    meaning:
      "không đủ sức lực, điều kiện để làm việc gì: bất lực trước hoàn cảnh  * đành khoanh tay chịu bất lực",
    example: "bất lực trước hoàn cảnh  * đành khoanh tay chịu bất lực",
  },
  {
    word: "bất kỳ",
    part_of_speech: "tính từ",
    meaning:
      "không có điều kiện nào kèm theo: kẻ một đường thẳng bất kì * lấy một câu thơ bất kì trong Truyện Kiều",
    example:
      "kẻ một đường thẳng bất kì * lấy một câu thơ bất kì trong Truyện Kiều",
  },
  {
    word: "bất kỳ",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị ý không loại trừ trường hợp nào cả, trong mọi trường hợp: bất kì ai thấy cảnh ấy cũng động lòng * phải hoàn thành bằng bất kì giá nào",
    example:
      "bất kì ai thấy cảnh ấy cũng động lòng * phải hoàn thành bằng bất kì giá nào",
  },
  {
    word: "bất mãn",
    part_of_speech: "động từ",
    meaning:
      "phản ứng bằng thái độ bất hợp tác hoặc thờ ơ do không được thoả mãn điều gì đó: quân sĩ bất mãn sinh biến",
    example: "quân sĩ bất mãn sinh biến",
  },
  {
    word: "bất mãn",
    part_of_speech: "tính từ",
    meaning:
      "(tâm trạng, thái độ) không bằng lòng do không được thoả mãn điều gì đó mà tự nghĩ là mình đáng được hưởng: một nhà nho bất mãn với thời cuộc * thái độ bất mãn",
    example: "một nhà nho bất mãn với thời cuộc * thái độ bất mãn",
  },
  {
    word: "bật mí",
    part_of_speech: "động từ",
    meaning:
      "(bí mật nói lái) (khẩu ngữ) gợi ý hoặc nói lộ ra điều bí mật: bật mí bí quyết thành công * bật mí đời tư của ngôi sao",
    example: "bật mí bí quyết thành công * bật mí đời tư của ngôi sao",
  },
  {
    word: "bất minh",
    part_of_speech: "tính từ",
    meaning:
      "không rõ ràng, có chỗ đáng nghi ngờ: quan hệ bất minh * đồng tiền bất minh",
    example: "quan hệ bất minh * đồng tiền bất minh",
  },
  {
    word: "bất nghĩa",
    part_of_speech: "tính từ",
    meaning:
      'trái với đạo đức và lẽ phải: ăn ở bất nghĩa * "Lời ngay, đông mặt trong ngoài, Kẻ chê bất nghĩa, người cười vô lương!" (TKiều)',
    example:
      'ăn ở bất nghĩa * "Lời ngay, đông mặt trong ngoài, Kẻ chê bất nghĩa, người cười vô lương!" (TKiều)',
  },
  {
    word: "bất lương",
    part_of_speech: "tính từ",
    meaning: "không lương thiện: người bất lương",
    example: "người bất lương",
  },
  {
    word: "bất nhẫn",
    part_of_speech: "tính từ",
    meaning: "hơi tàn nhẫn: nói quá nặng lời kể cũng bất nhẫn",
    example: "nói quá nặng lời kể cũng bất nhẫn",
  },
  {
    word: "bất nhân",
    part_of_speech: "tính từ",
    meaning:
      "không có tình người (thường dùng làm tiếng rủa): lòng dạ bất nhân * đồ bất nhân! * ăn ở bất nhân",
    example: "lòng dạ bất nhân * đồ bất nhân! * ăn ở bất nhân",
  },
  {
    word: "bất nhã",
    part_of_speech: "tính từ",
    meaning:
      "(cách đối xử, nói năng) không nhã nhặn, có phần thiếu lịch sự: thái độ bất nhã * lời nói bất nhã * cử chỉ bất nhã",
    example: "thái độ bất nhã * lời nói bất nhã * cử chỉ bất nhã",
  },
  {
    word: "bất nhất",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) khác nhau, không giống nhau, không thống nhất: tiền hậu bất nhất",
    example: "tiền hậu bất nhất",
  },
  {
    word: "bất ngờ",
    part_of_speech: "tính từ",
    meaning:
      "(sự việc) không ngờ tới, xảy ra ngoài dự tính: cuộc gặp gỡ bất ngờ * sự việc xảy ra hết sức bất ngờ",
    example: "cuộc gặp gỡ bất ngờ * sự việc xảy ra hết sức bất ngờ",
  },
  {
    word: "bất nhược",
    part_of_speech: "kết từ",
    meaning:
      "(hiếm) từ biểu thị ý thất vọng và nghĩ rằng giá làm như điều sắp nói, thường không hay bằng, nhưng trong hoàn cảnh cụ thể này thì dầu sao cũng vẫn còn hơn (việc làm không mang lại hiệu quả mong đợi vừa qua): chờ xe lâu quá, bất nhược đi bộ",
    example: "chờ xe lâu quá, bất nhược đi bộ",
  },
  {
    word: "bất ổn định",
    part_of_speech: "tính từ",
    meaning:
      "ở trong trạng thái có những biến động không bình thường: tình trạng bất ổn định về tài chính",
    example: "tình trạng bất ổn định về tài chính",
  },
  {
    word: "bất phân thắng bại",
    part_of_speech: "",
    meaning:
      "không phân định được bên nào được, bên nào thua, các bên đều ngang tài ngang sức nhau: trận đọ sức bất phân thắng bại",
    example: "trận đọ sức bất phân thắng bại",
  },
  {
    word: "bất quá",
    part_of_speech: "phụ từ",
    meaning:
      "(mức độ) cùng lắm cũng chỉ: việc này bất quá một tuần là xong * lương tháng bất quá cũng chỉ hơn một triệu đồng",
    example:
      "việc này bất quá một tuần là xong * lương tháng bất quá cũng chỉ hơn một triệu đồng",
  },
  {
    word: "bất ổn",
    part_of_speech: "tính từ",
    meaning:
      "ở trong trạng thái không yên ổn (do có vấn đề khó khăn cần phải giải quyết): tình hình bất ổn * có điều gì đó bất ổn",
    example: "tình hình bất ổn * có điều gì đó bất ổn",
  },
  {
    word: "bất tài",
    part_of_speech: "tính từ",
    meaning:
      "không có tài năng (thường dùng để nói khiêm tốn về mình): kẻ bất tài",
    example: "kẻ bất tài",
  },
  {
    word: "bất tất",
    part_of_speech: "phụ từ",
    meaning: "không tất yếu, không cần thiết: việc nhỏ, bất tất phải bàn",
    example: "việc nhỏ, bất tất phải bàn",
  },
  {
    word: "bất tận",
    part_of_speech: "tính từ",
    meaning:
      'nhiều đến mức như không bao giờ hết: kho tàng ca dao bất tận * niềm vui bất tận * "Đêm ngắn tũn, ngày lại dài tưởng như bất tận." (BBThi; 4)',
    example:
      'kho tàng ca dao bất tận * niềm vui bất tận * "Đêm ngắn tũn, ngày lại dài tưởng như bất tận." (BBThi; 4)',
  },
  {
    word: "bất thành cú",
    part_of_speech: "",
    meaning:
      "(văn chương) không thành câu văn, lủng củng, thậm chí sai ngữ pháp: văn viết bất thành cú",
    example: "văn viết bất thành cú",
  },
  {
    word: "bất thường",
    part_of_speech: "tính từ",
    meaning: "không phải thường lệ: cuộc họp bất thường * khoản chi bất thường",
    example: "cuộc họp bất thường * khoản chi bất thường",
  },
  {
    word: "bất thường",
    part_of_speech: "tính từ",
    meaning:
      "(tính tình hoặc thời tiết) dễ thay đổi, hay thay đổi đột ngột: thời tiết bất thường * tính khí bất thường",
    example: "thời tiết bất thường * tính khí bất thường",
  },
  {
    word: "bất thành",
    part_of_speech: "động từ",
    meaning:
      'không thành: việc bất thành * "Tiếc công xe sợi chỉ mành, Nối ba bốn lần chẳng đặng, bất thành thì thôi." (ca dao)',
    example:
      'việc bất thành * "Tiếc công xe sợi chỉ mành, Nối ba bốn lần chẳng đặng, bất thành thì thôi." (ca dao)',
  },
  {
    word: "bất thần",
    part_of_speech: "tính từ",
    meaning:
      "(sự việc) không dè trước được, xảy đến bất thình lình: cái chết bất thần * khẩu súng nhả đạn bất thần",
    example: "cái chết bất thần * khẩu súng nhả đạn bất thần",
  },
  {
    word: "bất thần",
    part_of_speech: "phụ từ",
    meaning:
      'như đột nhiên: bất thần trời đổ mưa * "Tôi thong thả đứng dậy rồi bất thần quay phắt lại (...)" (ĐGiỏi; 4)',
    example:
      'bất thần trời đổ mưa * "Tôi thong thả đứng dậy rồi bất thần quay phắt lại (...)" (ĐGiỏi; 4)',
  },
  {
    word: "bất tín nhiệm",
    part_of_speech: "",
    meaning:
      "không tín nhiệm, không tin dùng (người nào đó): bỏ phiếu bất tín nhiệm",
    example: "bỏ phiếu bất tín nhiệm",
  },
  {
    word: "bất thành văn",
    part_of_speech: "",
    meaning:
      "không được ghi lại bằng chữ viết, thành văn bản: quy định bất thành văn * luật bất thành văn",
    example: "quy định bất thành văn * luật bất thành văn",
  },
  {
    word: "bất trị",
    part_of_speech: "tính từ",
    meaning:
      "rất ngang ngạnh, rất khó dạy bảo, khó đưa vào khuôn phép: đứa con bất trị",
    example: "đứa con bất trị",
  },
  {
    word: "bất thình lình",
    part_of_speech: "phụ từ",
    meaning:
      "như thình lình (nhưng nghĩa mạnh hơn): đến bất thình lình, không hề báo trước",
    example: "đến bất thình lình, không hề báo trước",
  },
  {
    word: "bất trắc",
    part_of_speech: "",
    meaning:
      "(sự việc không hay) không liệu trước được: chuyện bất trắc * phòng khi bất trắc",
    example: "chuyện bất trắc * phòng khi bất trắc",
  },
  {
    word: "bất tiện",
    part_of_speech: "tính từ",
    meaning: "không thuận tiện: đường sá xa xôi, đi lại rất bất tiện",
    example: "đường sá xa xôi, đi lại rất bất tiện",
  },
  {
    word: "bất tiện",
    part_of_speech: "tính từ",
    meaning:
      'không tiện, không thích hợp: nói ở đây, e có điều bất tiện * "(...) họ toàn là đàn bà cả mà mình vào đánh tháo thì thật là bất tiện quá." (NgĐLạp; 2)',
    example:
      'nói ở đây, e có điều bất tiện * "(...) họ toàn là đàn bà cả mà mình vào đánh tháo thì thật là bất tiện quá." (NgĐLạp; 2)',
  },
  {
    word: "bất tỉnh",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái thần kinh cảm giác bị ức chế đột ngột, mê man không biết gì: bị thương nặng, nằm bất tỉnh * nghe tin sét đánh, ngã lăn ra bất tỉnh",
    example:
      "bị thương nặng, nằm bất tỉnh * nghe tin sét đánh, ngã lăn ra bất tỉnh",
  },
  {
    word: "bầu",
    part_of_speech: "danh từ",
    meaning:
      'cây leo bằng tua cuốn, lá mềm rộng và có lông mịn, quả tròn, dài, có loại thắt eo ở giữa, dùng làm rau ăn: "Bầu ơi thương lấy bí cùng, Tuy rằng khác giống nhưng chung một giàn." (ca dao)',
    example:
      'Bầu ơi thương lấy bí cùng, Tuy rằng khác giống nhưng chung một giàn." (ca dao)',
  },
  {
    word: "bầu",
    part_of_speech: "danh từ",
    meaning:
      'đồ đựng làm bằng vỏ quả bầu nậm già đã phơi khô hoặc đồ đựng hay vật nói chung có hình giống như hình quả bầu nậm: bầu đèn * bầu vú * "Chân hề, dong ruổi dặm tràng, Đứa đeo thơ túi, đứa mang rượu bầu." (NĐM)',
    example:
      'bầu đèn * bầu vú * "Chân hề, dong ruổi dặm tràng, Đứa đeo thơ túi, đứa mang rượu bầu." (NĐM)',
  },
  {
    word: "bầu",
    part_of_speech: "danh từ",
    meaning: "phần phình to ở phía dưới của nhuỵ hoa, bên trong chứa noãn.",
    example: "trồng cây bằng cách đánh bầu",
  },
  {
    word: "bầu",
    part_of_speech: "danh từ",
    meaning:
      "khối đất bọc quanh rễ khi bứng cây lên để đem đi trồng nơi khác: trồng cây bằng cách đánh bầu",
    example: "mang bầu * đang có bầu",
  },
  {
    word: "bầu",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) bụng mang thai: mang bầu * đang có bầu",
    example: "bầu máu nóng * dốc bầu tâm sự",
  },
  {
    word: "bầu",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) người làm chủ hoặc đỡ đầu một gánh hát, một đội thể thao, một ca sĩ, v.v.: bầu cải lương * trở thành bầu của đội bóng",
    example: "bầu cải lương * trở thành bầu của đội bóng",
  },
  {
    word: "bầu",
    part_of_speech: "động từ",
    meaning:
      "chọn bằng cách bỏ phiếu hoặc biểu quyết để giao cho làm đại biểu, làm một chức vụ hoặc hưởng một vinh dự: bầu đại biểu quốc hội * bầu tổng thống * được bầu là ca sĩ có giọng ca hay nhất",
    example:
      "bầu đại biểu quốc hội * bầu tổng thống * được bầu là ca sĩ có giọng ca hay nhất",
  },
  {
    word: "bầu",
    part_of_speech: "tính từ",
    meaning: "tròn phình ra và đầy đặn: đôi má bầu",
    example: "đôi má bầu",
  },
  {
    word: "bậu",
    part_of_speech: "động từ",
    meaning: "đậu vào, bám vào: ruồi bậu * muỗi bậu vào màn",
    example: "ruồi bậu * muỗi bậu vào màn",
  },
  {
    word: "bậu",
    part_of_speech: "đại từ",
    meaning:
      '(phương ngữ) từ người con trai dùng để gọi vợ hay người yêu, khi nói với vợ, với người yêu, tỏ ý thân thiết: "Tìm bậu, bậu đã lấy chồng, Bậu thương như thế, mặn nồng làm sao?" (ca dao)',
    example:
      'Tìm bậu, bậu đã lấy chồng, Bậu thương như thế, mặn nồng làm sao?" (ca dao)',
  },
  {
    word: "bầu bán",
    part_of_speech: "động từ",
    meaning:
      "bầu (nói khái quát; thường hàm ý mỉa mai hoặc chê bai): bầu bán gì, chỉ là trò dân chủ giả tạo",
    example: "bầu bán gì, chỉ là trò dân chủ giả tạo",
  },
  {
    word: "bất tử",
    part_of_speech: "tính từ",
    meaning: "(hiếm) không chết: trường sinh bất tử",
    example: "trường sinh bất tử",
  },
  {
    word: "bất tử",
    part_of_speech: "tính từ",
    meaning:
      "(trang trọng) (người đã chết, cái có giá trị tinh thần) mãi mãi còn sống trong trí nhớ, trong tình cảm của người đời: một áng văn bất tử * những anh hùng đã trở thành bất tử",
    example: "một áng văn bất tử * những anh hùng đã trở thành bất tử",
  },
  {
    word: "bất tử",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ, thông tục) như bạt mạng: ăn nói bất tử * chạy xe bất tử, có ngày chết không kịp ngáp",
    example: "ăn nói bất tử * chạy xe bất tử, có ngày chết không kịp ngáp",
  },
  {
    word: "bất tử",
    part_of_speech: "phụ từ",
    meaning: "(Nam) như bất thình lình: sao về bất tử vậy mầy?",
    example: "sao về bất tử vậy mầy?",
  },
  {
    word: "bấu",
    part_of_speech: "động từ",
    meaning:
      "bám chặt bằng các đầu ngón tay quặp lại để cho khỏi rơi, khỏi ngã: tay bấu vào các gờ đá leo lên * không biết bấu vào đâu để sống (b)",
    example:
      "tay bấu vào các gờ đá leo lên * không biết bấu vào đâu để sống (b)",
  },
  {
    word: "bấu",
    part_of_speech: "động từ",
    meaning:
      "dùng các đầu ngón tay quặp chặt da thịt vào giữa rồi giật ra, làm cho đau: bấu má * bấu vào bắp thịt",
    example: "bấu má * bấu vào bắp thịt",
  },
  {
    word: "bâu",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ) túi áo: may áo bốn bâu",
    example: "may áo bốn bâu",
  },
  {
    word: "bâu",
    part_of_speech: "động từ",
    meaning:
      "đậu, bám xúm xít vào: kiến bâu * máu chảy đến đâu, ruồi bâu đến đó (tng)",
    example: "kiến bâu * máu chảy đến đâu, ruồi bâu đến đó (tng)",
  },
  {
    word: "bâu",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) xúm lại và vây lấy, không chịu rời (thường hàm ý coi khinh): bọn trẻ bâu lấy chiếc xe mới * đám người hiếu kì bâu lấy xem",
    example: "bọn trẻ bâu lấy chiếc xe mới * đám người hiếu kì bâu lấy xem",
  },
  {
    word: "bật tường",
    part_of_speech: "động từ",
    meaning:
      "(lối đá đang trong thế tiến công của môn bóng đá) phối hợp những đường chuyền ngắn, nhanh và trực tiếp giữa các cầu thủ: chọn lối đá bật tường, chọc khe",
    example: "chọn lối đá bật tường, chọc khe",
  },
  {
    word: "bầu bĩnh",
    part_of_speech: "tính từ",
    meaning:
      "bầu, trông đáng yêu (chỉ nói về mặt): đôi má bầu bĩnh * em bé có gương mặt bầu bĩnh",
    example: "đôi má bầu bĩnh * em bé có gương mặt bầu bĩnh",
  },
  {
    word: "bầu bạn",
    part_of_speech: "danh từ",
    meaning: "bạn (nói khái quát): kết làm bầu bạn",
    example: "kết làm bầu bạn",
  },
  {
    word: "bầu bạn",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) kết bạn, làm bạn: ngày đêm bầu bạn với đèn sách * sống lẻ loi, không có ai bầu bạn",
    example: "ngày đêm bầu bạn với đèn sách * sống lẻ loi, không có ai bầu bạn",
  },
  {
    word: "bầu chọn",
    part_of_speech: "động từ",
    meaning:
      "chọn ra theo ý kiến của số đông (nói khái quát): bỏ phiếu bầu chọn chủ tịch * được bầu chọn là cầu thủ xuất sắc nhất giải",
    example:
      "bỏ phiếu bầu chọn chủ tịch * được bầu chọn là cầu thủ xuất sắc nhất giải",
  },
  {
    word: "bầu cử",
    part_of_speech: "động từ",
    meaning:
      "bầu cơ quan đại biểu, người đại diện (nói khái quát): bầu cử quốc hội * bầu cử tổng thống * quyền bầu cử",
    example: "bầu cử quốc hội * bầu cử tổng thống * quyền bầu cử",
  },
  {
    word: "bầu đàn thê tử",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) đoàn đông người trong gia đình (gồm cả vợ con, v.v.): đi đâu cũng kéo cả bầu đoàn thê tử",
    example: "đi đâu cũng kéo cả bầu đoàn thê tử",
  },
  {
    word: "bầu không khí",
    part_of_speech: "danh từ",
    meaning:
      "tinh thần chung bao trùm trong một hoàn cảnh nào đó: bầu không khí nặng nề * sống trong bầu không khí đầm ấm của gia đình",
    example:
      "bầu không khí nặng nề * sống trong bầu không khí đầm ấm của gia đình",
  },
  {
    word: "bầu đoàn thê tử",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) đoàn đông người trong gia đình (gồm cả vợ con, v.v.): đi đâu cũng kéo cả bầu đoàn thê tử",
    example: "đi đâu cũng kéo cả bầu đoàn thê tử",
  },
  {
    word: "bầu đoàn",
    part_of_speech: "danh từ",
    meaning:
      'đoàn đông người đi theo một người nào đó; đoàn tuỳ tùng (thường hàm ý coi thường): "Cách non bóng đã hầu tà, Bầu đoàn Lý tướng lân la mới về." (CC)',
    example: 'Cách non bóng đã hầu tà, Bầu đoàn Lý tướng lân la mới về." (CC)',
  },
  {
    word: "bầu dục",
    part_of_speech: "danh từ",
    meaning:
      "thận của một số thú nuôi để ăn thịt: bầu dục lợn * cháo bầu dục (cháo nấu với bầu dục)",
    example: "bầu dục lợn * cháo bầu dục (cháo nấu với bầu dục)",
  },
  {
    word: "bầu dục",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) hình bầu dục (nói tắt): chiếc gương bầu dục",
    example: "chiếc gương bầu dục",
  },
  {
    word: "bầu rượu túi thơ",
    part_of_speech: "",
    meaning:
      'tả phong thái ung dung, nhàn nhã của nhà thơ thời trước (bên mình luôn có bầu đựng rượu và túi đựng thơ): "Thảnh thơi bầu rượu túi thơ, Ngón cầm khiển hứng, nước cờ giải mê." (MĐMK)',
    example:
      'Thảnh thơi bầu rượu túi thơ, Ngón cầm khiển hứng, nước cờ giải mê." (MĐMK)',
  },
  {
    word: "bấu véo",
    part_of_speech: "động từ",
    meaning: "như cấu véo: bấu véo nhau suốt ngày",
    example: "bấu véo nhau suốt ngày",
  },
  {
    word: "bấu véo",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) xà xẻo của người khác một cách sỗ sàng: bấu véo của công",
    example: "bấu véo của công",
  },
  {
    word: "bấu víu",
    part_of_speech: "động từ",
    meaning:
      "bấu vào để bám cho khỏi rơi, khỏi ngã (nói khái quát): bấu víu vào cành cây leo lên",
    example: "bấu víu vào cành cây leo lên",
  },
  {
    word: "bấu víu",
    part_of_speech: "động từ",
    meaning:
      "nương tựa, dựa vào trong lúc khó khăn, ngặt nghèo: bơ vơ không nơi bấu víu",
    example: "bơ vơ không nơi bấu víu",
  },
  {
    word: "bây",
    part_of_speech: "động từ",
    meaning: "===== (phương ngữ): quần áo bị bây mực",
    example: "quần áo bị bây mực",
  },
  {
    word: "bây",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) (làm việc gì) biết là sai trái, là bậy, mà vẫn làm một cách trâng tráo: đã trái lại còn cãi bây",
    example: "đã trái lại còn cãi bây",
  },
  {
    word: "bầy",
    part_of_speech: "danh từ",
    meaning:
      'đám đông động vật cùng loài sống với nhau hoặc tạm thời tập hợp tại một chỗ: bầy sói * bầy thú dữ * "Chim xa bầy thương cây nhớ cội, Người xa người tội lắm người ơi." (Cdao)',
    example:
      'bầy sói * bầy thú dữ * "Chim xa bầy thương cây nhớ cội, Người xa người tội lắm người ơi." (Cdao)',
  },
  {
    word: "bầy",
    part_of_speech: "danh từ",
    meaning:
      "đám đông người có chung một tính chất nào đó: bầy con thơ * bọn du côn kéo đến cả bầy",
    example: "bầy con thơ * bọn du côn kéo đến cả bầy",
  },
  {
    word: "bậu xậu",
    part_of_speech: "danh từ",
    meaning:
      "bọn tay chân theo sau để nhằm kiếm chút lợi (hàm ý coi khinh): một lũ bậu xậu theo sau kiếm chác",
    example: "một lũ bậu xậu theo sau kiếm chác",
  },
  {
    word: "bầu trời",
    part_of_speech: "danh từ",
    meaning:
      "khoảng không gian ta nhìn thấy được, như một hình vòm úp trên mặt đất: mây đen phủ kín bầu trời * bầu trời đầy sao",
    example: "mây đen phủ kín bầu trời * bầu trời đầy sao",
  },
  {
    word: "bấy",
    part_of_speech: "tính từ",
    meaning: "còn quá non, quá yếu: tre bấy * cua bấy",
    example: "tre bấy * cua bấy",
  },
  {
    word: "bấy",
    part_of_speech: "tính từ",
    meaning:
      "mềm nhũn đến mức động đến thì nát ra, rã ra: quả chuối chín bấy * nát bấy như tương",
    example: "quả chuối chín bấy * nát bấy như tương",
  },
  {
    word: "bấy",
    part_of_speech: "đại từ",
    meaning:
      'từ dùng để chỉ số lượng hoặc khoảng thời gian đã nói đến: "Biết nhau từ bấy đến giờ, Đã cho bướm đậu thì chừa sâu ra." (ca dao)',
    example:
      'Biết nhau từ bấy đến giờ, Đã cho bướm đậu thì chừa sâu ra." (ca dao)',
  },
  {
    word: "bấy",
    part_of_speech: "đại từ",
    meaning:
      '(cũ, văn chương) từ dùng để chỉ mức độ nhiều như đã biết: "Khóc than chi xiết sự tình, Khéo vô duyên bấy là mình với ta." (TKiều)',
    example:
      'Khóc than chi xiết sự tình, Khéo vô duyên bấy là mình với ta." (TKiều)',
  },
  {
    word: "bậy",
    part_of_speech: "tính từ",
    meaning:
      "sai trái, càn rỡ, không kể gì lề lối, khuôn phép: nói bậy * vẽ bậy lên tường * ỷ thế làm bậy",
    example: "nói bậy * vẽ bậy lên tường * ỷ thế làm bậy",
  },
  {
    word: "bậy bạ",
    part_of_speech: "tính từ",
    meaning:
      "bậy (nói khái quát): ăn uống bậy bạ * làm trò bậy bạ * viết bậy viết bạ lên tường",
    example: "ăn uống bậy bạ * làm trò bậy bạ * viết bậy viết bạ lên tường",
  },
  {
    word: "bẫy",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ thô sơ để lừa bắt, giết loài vật hoặc kẻ địch: cắm bẫy chông * gài bẫy * chim sa vào bẫy",
    example: "cắm bẫy chông * gài bẫy * chim sa vào bẫy",
  },
  {
    word: "bẫy",
    part_of_speech: "danh từ",
    meaning: "cái bố trí sẵn để lừa cho người ta mắc vào: tên cướp bị sa bẫy",
    example: "tên cướp bị sa bẫy",
  },
  {
    word: "bẫy",
    part_of_speech: "động từ",
    meaning: "bắt hoặc tiêu diệt bằng bẫy: đi bẫy chim * bẫy heo rừng",
    example: "đi bẫy chim * bẫy heo rừng",
  },
  {
    word: "bẫy",
    part_of_speech: "động từ",
    meaning: "lừa cho mắc mưu để làm hại: bẫy người vào tròng",
    example: "bẫy người vào tròng",
  },
  {
    word: "bẩy",
    part_of_speech: "động từ",
    meaning:
      "nâng vật nặng lên bằng cách đặt một đầu đòn vào phía dưới, tì đòn vào một điểm tựa, rồi dùng một lực tác động xuống đầu kia của đòn: bẩy hòn đá",
    example: "bẩy hòn đá",
  },
  {
    word: "bây chừ",
    part_of_speech: "đại từ",
    meaning:
      '(phương ngữ) bây giờ: "Chàng ơi, chớ bực sầu tư, Khi xưa có mẹ, bây chừ có em." (ca dao)',
    example:
      'Chàng ơi, chớ bực sầu tư, Khi xưa có mẹ, bây chừ có em." (ca dao)',
  },
  {
    word: "bây giờ",
    part_of_speech: "đại từ",
    meaning:
      'khoảng thời gian hiện đang nói: bây giờ là mười giờ * trước khác, bây giờ khác * "Bây giờ đất thấp, trời cao, Ăn làm sao, nói làm sao, bây giờ?" (TKiều)',
    example:
      'bây giờ là mười giờ * trước khác, bây giờ khác * "Bây giờ đất thấp, trời cao, Ăn làm sao, nói làm sao, bây giờ?" (TKiều)',
  },
  {
    word: "bấy chầy",
    part_of_speech: "đại từ",
    meaning:
      '(cũ, văn chương) bao lâu nay: "Bấy chầy dãi nguyệt, dầu hoa, Mười phần xuân có gầy ba bốn phần." (TKiều)',
    example:
      'Bấy chầy dãi nguyệt, dầu hoa, Mười phần xuân có gầy ba bốn phần." (TKiều)',
  },
  {
    word: "bấy giờ",
    part_of_speech: "đại từ",
    meaning:
      "khoảng thời gian được xác định, được nói đến, trong quá khứ hoặc trong tương lai; khi ấy, lúc đó: bấy giờ các con còn bé lắm * khi nào xảy ra, bấy giờ sẽ hay",
    example: "bấy giờ các con còn bé lắm * khi nào xảy ra, bấy giờ sẽ hay",
  },
  {
    word: "bấy chừ",
    part_of_speech: "đại từ",
    meaning: "(cũ, hoặc ph) bấy giờ: bấy chừ là năm 1945",
    example: "bấy chừ là năm 1945",
  },
  {
    word: "bầy hầy",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) bẩn thỉu và luộm thuộm: nhà cửa bầy hầy * quần áo bầy hầy",
    example: "nhà cửa bầy hầy * quần áo bầy hầy",
  },
  {
    word: "bẫy cò ke",
    part_of_speech: "danh từ",
    meaning:
      "bẫy được làm rất sơ sài, thời trước dùng để bắt chó: bợm già mắc bẫy cò ke (tng)",
    example: "bợm già mắc bẫy cò ke (tng)",
  },
  {
    word: "khó tính",
    part_of_speech: "tính từ",
    meaning:
      "có tính không dễ dãi trong quan hệ tiếp xúc, không dễ bằng lòng với bất kì ai hoặc điều gì: người già thường hay khó tính * bà ấy khó tính lắm!",
    example: "người già thường hay khó tính * bà ấy khó tính lắm!",
  },
  {
    word: "khoá",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng bằng kim loại để đóng chặt cửa, tủ, hòm, vv, không cho người khác mở: bị kẻ gian cắt khoá * khoá dây * cửa chưa lắp khoá",
    example: "bị kẻ gian cắt khoá * khoá dây * cửa chưa lắp khoá",
  },
  {
    word: "khoá",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng bằng kim loại, bằng nhựa để cài giữ thắt lưng, quai dép, miệng túi, vv, không cho bật ra: khoá thắt lưng * túi xách bị hỏng khoá",
    example: "khoá thắt lưng * túi xách bị hỏng khoá",
  },
  {
    word: "khoá",
    part_of_speech: "danh từ",
    meaning: "toàn bộ những quy tắc của một mật mã: nhớ kĩ khoá mật mã",
    example: "nhớ kĩ khoá mật mã",
  },
  {
    word: "khoá",
    part_of_speech: "danh từ",
    meaning:
      "kí hiệu ở đầu khuông nhạc để chỉ tên nốt làm mốc gọi tên các nốt khác: khoá sol",
    example: "khoá sol",
  },
  {
    word: "khoá",
    part_of_speech: "động từ",
    meaning:
      "đóng chặt, giữ chặt bằng cái khoá: khoá cổ xe máy * khoá tủ cẩn thận * nhà khoá cửa, mọi người đi vắng cả",
    example:
      "khoá cổ xe máy * khoá tủ cẩn thận * nhà khoá cửa, mọi người đi vắng cả",
  },
  {
    word: "khoá",
    part_of_speech: "động từ",
    meaning:
      "làm cho một bộ phận cơ thể của người khác bị giữ chặt lại không cử động được: khoá chặt hai tay sau lưng",
    example: "khoá chặt hai tay sau lưng",
  },
  {
    word: "khoá",
    part_of_speech: "động từ",
    meaning:
      "làm cho lối đi, lối thoát bị chặn lại: khoá vòi nước * khoá vòng vây",
    example: "khoá vòi nước * khoá vòng vây",
  },
  {
    word: "khoá",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) thời gian ấn định cho một nhiệm kì làm chức dịch hoặc đi lính thời phong kiến, thực dân: lính mãn khoá * làm lí trưởng liền hai khoá",
    example: "lính mãn khoá * làm lí trưởng liền hai khoá",
  },
  {
    word: "khoá",
    part_of_speech: "danh từ",
    meaning:
      "thời gian ấn định cho một nhiệm kì công tác hay cho việc hoàn thành một chương trình học tập: kì họp Quốc hội khoá XII * khoá huấn luyện * hai người học cùng một khoá",
    example:
      "kì họp Quốc hội khoá XII * khoá huấn luyện * hai người học cùng một khoá",
  },
  {
    word: "khoá",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) khoá sinh (gọi tắt): thầy khoá * "Cười như anh khoá hỏng thi, Khóc như cô gái sắp đi lấy chồng." (ca dao)',
    example:
      'thầy khoá * "Cười như anh khoá hỏng thi, Khóc như cô gái sắp đi lấy chồng." (ca dao)',
  },
  {
    word: "kho tộ",
    part_of_speech: "động từ",
    meaning:
      "(cá) kho thật kĩ bằng nồi đất, thường kèm với thịt mỡ và nhiều thứ gia vị, ăn có vị đậm và béo: cá trê kho tộ",
    example: "cá trê kho tộ",
  },
  {
    word: "khoa",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận của trường đại học chuyên giảng dạy một ngành khoa học, hay của bệnh viện đa khoa chuyên điều trị theo phương pháp của một bộ môn y học: sinh viên khoa văn * bệnh nhân được chuyển sang khoa nội",
    example: "sinh viên khoa văn * bệnh nhân được chuyển sang khoa nội",
  },
  {
    word: "khoa",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) tài đặc biệt về một hoạt động nào đó, hàm ý châm biếm hoặc mỉa mai: giỏi về khoa hùng biện * có khoa nói",
    example: "giỏi về khoa hùng biện * có khoa nói",
  },
  {
    word: "khoa",
    part_of_speech: "danh từ",
    meaning: "(Từ cũ) kì thi thời phong kiến: triều đình mở khoa thi",
    example: "triều đình mở khoa thi",
  },
  {
    word: "khoa",
    part_of_speech: "động từ",
    meaning:
      "dùng tay hay vật cầm ở tay giơ lên và đưa đi đưa lại thành vòng phía trước mặt: khoa bó đuốc * vừa nói vừa khoa tay",
    example: "khoa bó đuốc * vừa nói vừa khoa tay",
  },
  {
    word: "khoả",
    part_of_speech: "động từ",
    meaning:
      "nhúng xuống mặt nước rồi đưa đi đưa lại: khoả chân cho sạch * mái chèo khoả nước",
    example: "khoả chân cho sạch * mái chèo khoả nước",
  },
  {
    word: "khoả",
    part_of_speech: "động từ",
    meaning:
      "đưa qua đưa lại, làm cho trải rộng đều ra trên bề mặt: khoả thóc cho đều",
    example: "khoả thóc cho đều",
  },
  {
    word: "khoa bảng",
    part_of_speech: "danh từ",
    meaning: "(cũ) việc thi cử, đỗ đạt thời phong kiến: theo đòi khoa bảng",
    example: "theo đòi khoa bảng",
  },
  {
    word: "khoa bảng",
    part_of_speech: "danh từ",
    meaning:
      "người đỗ đạt trong các khoa thi thời phong kiến (nói khái quát): con nhà khoa bảng",
    example: "con nhà khoa bảng",
  },
  {
    word: "khoa cử",
    part_of_speech: "danh từ",
    meaning: "(cũ) việc thi cử thời phong kiến: theo đòi khoa cử",
    example: "theo đòi khoa cử",
  },
  {
    word: "khoa giáo",
    part_of_speech: "danh từ",
    meaning:
      "khoa học và giáo dục (nói tắt): ban khoa giáo Đài truyền hình Việt Nam",
    example: "ban khoa giáo Đài truyền hình Việt Nam",
  },
  {
    word: "khoa học",
    part_of_speech: "danh từ",
    meaning:
      "hệ thống tri thức tích luỹ trong quá trình lịch sử và được thực tiễn chứng minh, phản ánh những quy luật khách quan của thế giới bên ngoài cũng như của hoạt động tinh thần của con người, giúp con người có khả năng cải tạo thế giới hiện thực.",
    example: "khoa học quân sự",
  },
  {
    word: "khoa học",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất của khoa học; thuộc về khoa học: hội nghị khoa học * nghiên cứu khoa học",
    example: "hội nghị khoa học * nghiên cứu khoa học",
  },
  {
    word: "khoa học",
    part_of_speech: "tính từ",
    meaning:
      "phù hợp với những đòi hỏi của khoa học: khách quan, chính xác, có hệ thống, vv: tác phong khoa học * bố trí công việc rất khoa học",
    example: "tác phong khoa học * bố trí công việc rất khoa học",
  },
  {
    word: "khoa học viễn tưởng",
    part_of_speech: "danh từ",
    meaning:
      "sự miêu tả bằng hình thức nghệ thuật sự phát triển khoa học dự đoán trong tương lai, thường có tính chất li kì: phim khoa học viễn tưởng",
    example: "phim khoa học viễn tưởng",
  },
  {
    word: "khoa mục",
    part_of_speech: "danh từ",
    meaning:
      "môn học trong chương trình huấn luyện quân sự: hoàn thành khoa mục bắn súng",
    example: "hoàn thành khoa mục bắn súng",
  },
  {
    word: "khoa mục",
    part_of_speech: "danh từ",
    meaning: "(cũ) như khoa bảng: đường khoa mục",
    example: "đường khoa mục",
  },
  {
    word: "khoả lấp",
    part_of_speech: "động từ",
    meaning:
      "làm che lấp đi bằng một sự việc khác để đánh lạc sự chú ý: khoả lấp miệng hang * dùng công việc để khoả lấp ưu phiền",
    example: "khoả lấp miệng hang * dùng công việc để khoả lấp ưu phiền",
  },
  {
    word: "khoá sinh",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người học chữ nho đã đỗ kì thi sát hạch ở địa phương, thời phong kiến: đỗ khoá sinh * chàng khoá sinh",
    example: "đỗ khoá sinh * chàng khoá sinh",
  },
  {
    word: "khoá số",
    part_of_speech: "danh từ",
    meaning:
      "khoá có mặt chữ số hoặc chữ cái, chỉ đóng mở được khi để các chữ theo đúng một thứ tự nhất định đã được đặt sẵn từ trước: va li có khoá số",
    example: "va li có khoá số",
  },
  {
    word: "khoá luận",
    part_of_speech: "danh từ",
    meaning:
      "công trình nghiên cứu của sinh viên sau một khoá học hoặc một đợt thực tập: làm khoá luận tốt nghiệp",
    example: "làm khoá luận tốt nghiệp",
  },
  {
    word: "khoá sổ",
    part_of_speech: "động từ",
    meaning:
      "thôi không ghi tiếp một khoản nào nữa vào sổ sách, vì đã hết thời hạn quy định: đến kì khoá sổ * ngân hàng đã khoá sổ",
    example: "đến kì khoá sổ * ngân hàng đã khoá sổ",
  },
  {
    word: "khoả thân",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái để lộ toàn bộ thân hình nhằm phô bày vẻ đẹp: vẽ tranh khoả thân * tượng hình người khoả thân",
    example: "vẽ tranh khoả thân * tượng hình người khoả thân",
  },
  {
    word: "khoa trương",
    part_of_speech: "động từ",
    meaning:
      "cố ý phô bày để làm cho người ta tưởng rằng mình có những mặt hay, tốt, mạnh, quá mức có thật: khoa trương thanh thế * lối quảng cáo khoa trương",
    example: "khoa trương thanh thế * lối quảng cáo khoa trương",
  },
  {
    word: "khoa trương",
    part_of_speech: "động từ",
    meaning:
      "cường điệu hoặc phóng đại quá sự thật để đạt hiệu quả nghệ thuật cần thiết: bút pháp ước lệ, khoa trương",
    example: "bút pháp ước lệ, khoa trương",
  },
  {
    word: "khoa trường",
    part_of_speech: "danh từ",
    meaning: "(cũ) trường thi thời phong kiến: chốn khoa trường",
    example: "chốn khoa trường",
  },
  {
    word: "khoa trường",
    part_of_speech: "danh từ",
    meaning: "như khoa bảng (ng1): theo đòi khoa trường",
    example: "theo đòi khoa trường",
  },
  {
    word: "khoác áo",
    part_of_speech: "động từ",
    meaning:
      "mang trang phục của một đơn vị hoặc tổ chức và trở thành người của đơn vị hoặc tổ chức đó: khoác áo đội tuyển quốc gia * 20 năm khoác áo lính",
    example: "khoác áo đội tuyển quốc gia * 20 năm khoác áo lính",
  },
  {
    word: "khoác áo",
    part_of_speech: "động từ",
    meaning: "như đội lốt: khoác áo nhà tu để lừa người",
    example: "khoác áo nhà tu để lừa người",
  },
  {
    word: "khoái",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) có cảm giác thích thú, được thoả mãn ở mức độ cao: nghe khoái lỗ tai * không khoái của ngọt",
    example: "nghe khoái lỗ tai * không khoái của ngọt",
  },
  {
    word: "khoác lác",
    part_of_speech: "động từ",
    meaning: "nói khoác, nói phét (nói khái quát): tính hay khoác lác",
    example: "tính hay khoác lác",
  },
  {
    word: "khoái cảm",
    part_of_speech: "danh từ",
    meaning: "cảm giác thích thú, thoả mãn ở mức cao: khoái cảm xác thịt",
    example: "khoái cảm xác thịt",
  },
  {
    word: "khoai",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi chung các loài cây có củ chứa tinh bột ăn được, như khoai tây, khoai lang, khoai riềng, vv.",
    example: "nồi khoai luộc",
  },
  {
    word: "khoái chí",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) thích thú vì được như ý muốn: khoái chí, cười khúc khích",
    example: "khoái chí, cười khúc khích",
  },
  {
    word: "khoác",
    part_of_speech: "động từ",
    meaning:
      "vòng cánh tay qua cánh tay hay qua vai người khác: khoác tay nhau đi chơi * vừa đi vừa khoác vai nhau",
    example: "khoác tay nhau đi chơi * vừa đi vừa khoác vai nhau",
  },
  {
    word: "khoác",
    part_of_speech: "động từ",
    meaning:
      "mang vào thân mình vật to có dây đeo bằng cách làm cho mắc vào vai hay cánh tay: khoác ba lô trên lưng * súng khoác ngang hông",
    example: "khoác ba lô trên lưng * súng khoác ngang hông",
  },
  {
    word: "khoác",
    part_of_speech: "động từ",
    meaning:
      "phủ trùm lên qua vai: khoác tấm vải mưa * khoác chiếc áo choàng dài",
    example: "khoác tấm vải mưa * khoác chiếc áo choàng dài",
  },
  {
    word: "khoái khẩu",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có cảm giác ngon miệng, thích thú và thoả mãn khi ăn: món ăn khoái khẩu",
    example: "món ăn khoái khẩu",
  },
  {
    word: "khoai khoái",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) hơi khoái: mới nghe thì cũng thấy khoai khoái",
    example: "mới nghe thì cũng thấy khoai khoái",
  },
  {
    word: "khoái lạc",
    part_of_speech: "",
    meaning:
      "có cảm giác thoả mãn, thích thú về hưởng thụ vật chất: những giây phút khoái lạc * hưởng khoái lạc",
    example: "những giây phút khoái lạc * hưởng khoái lạc",
  },
  {
    word: "khoái trá",
    part_of_speech: "tính từ",
    meaning:
      "có cảm giác rất thích thú, thường biểu hiện rõ ra ở bề ngoài: cười khoái trá",
    example: "cười khoái trá",
  },
  {
    word: "khoản",
    part_of_speech: "danh từ",
    meaning:
      "mục trong một văn bản có tính chất pháp lí: bản hợp đồng gồm có bảy khoản * điều năm, khoản hai của bộ luật có nêu rõ",
    example:
      "bản hợp đồng gồm có bảy khoản * điều năm, khoản hai của bộ luật có nêu rõ",
  },
  {
    word: "khoản",
    part_of_speech: "danh từ",
    meaning:
      "từng phần thu nhập hoặc chi tiêu: khoản nợ * khoản phụ thu * tính các khoản chi phí",
    example: "khoản nợ * khoản phụ thu * tính các khoản chi phí",
  },
  {
    word: "khoản",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) từng phần, từng cái, từng việc, vv cụ thể: không bỏ được cái khoản rượu * về khoản hát thì tôi chịu thua",
    example: "không bỏ được cái khoản rượu * về khoản hát thì tôi chịu thua",
  },
  {
    word: "khoan dung",
    part_of_speech: "động từ",
    meaning:
      "rộng lòng tha thứ cho người có lỗi lầm: ánh mắt khoan dung * tấm lòng khoan dung",
    example: "ánh mắt khoan dung * tấm lòng khoan dung",
  },
  {
    word: "khoan hồng",
    part_of_speech: "động từ",
    meaning:
      "đối xử rộng lượng với kẻ có tội khi biết ăn năn hối lỗi: chính sách khoan hồng",
    example: "chính sách khoan hồng",
  },
  {
    word: "khoán",
    part_of_speech: "danh từ",
    meaning: "(cũ) tờ giao ước để làm bằng: điểm chỉ vào tờ khoán",
    example: "điểm chỉ vào tờ khoán",
  },
  {
    word: "khoán",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) khoản phải nộp cho làng, coi như tiền phạt, khi làm điều gì trái với lệ làng, theo tục lệ ngày trước ở nông thôn: nộp khoán * ra đình ăn khoán",
    example: "nộp khoán * ra đình ăn khoán",
  },
  {
    word: "khoán",
    part_of_speech: "động từ",
    meaning:
      "giao việc và trả công theo kết quả hoàn thành: nhận làm khoán, không làm công nhật * trả lương khoán",
    example: "nhận làm khoán, không làm công nhật * trả lương khoán",
  },
  {
    word: "khoán",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) giao hết công việc thuộc trách nhiệm của mình cho người khác làm thay để khỏi phải bận tâm lo liệu: khoán tất cả mọi việc trong gia đình cho người con trưởng",
    example: "khoán tất cả mọi việc trong gia đình cho người con trưởng",
  },
  {
    word: "khoan",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ có mũi nhọn bằng kim loại để tạo lỗ bằng cách xoáy sâu dần: mũi khoan * máy khoan",
    example: "mũi khoan * máy khoan",
  },
  {
    word: "khoan",
    part_of_speech: "động từ",
    meaning:
      "dùng khoan xoáy sâu vào tạo thành lỗ: khoan giếng * khoan thủng một lỗ * khoan bê tông",
    example: "khoan giếng * khoan thủng một lỗ * khoan bê tông",
  },
  {
    word: "khoan",
    part_of_speech: "động từ",
    meaning:
      "thong thả đừng vội, đừng thực hiện ngay việc đang định làm (thường dùng trong lời khuyên ngăn): khoan, đợi tôi một tí * việc ấy hẵng khoan đã!",
    example: "khoan, đợi tôi một tí * việc ấy hẵng khoan đã!",
  },
  {
    word: "khoan",
    part_of_speech: "tính từ",
    meaning:
      "có nhịp độ âm thanh thưa, cách quãng rộng: tiếng khoan tiếng nhặt",
    example: "tiếng khoan tiếng nhặt",
  },
  {
    word: "khoản đãi",
    part_of_speech: "động từ",
    meaning:
      "đãi một cách hậu hĩ, thường là bày tiệc ăn uống, để tỏ lòng quý mến: mở tiệc khoản đãi",
    example: "mở tiệc khoản đãi",
  },
  {
    word: "khoan nhượng",
    part_of_speech: "động từ",
    meaning:
      "không kiên quyết trong đấu tranh, chịu nhường bước để cho đối phương lấn tới: đấu tranh không khoan nhượng",
    example: "đấu tranh không khoan nhượng",
  },
  {
    word: "khoan khoái",
    part_of_speech: "tính từ",
    meaning:
      "có cảm giác rất thoải mái, dễ chịu: tinh thần khoan khoái * thấy khoan khoái trong lòng",
    example: "tinh thần khoan khoái * thấy khoan khoái trong lòng",
  },
  {
    word: "khoan hoà",
    part_of_speech: "tính từ",
    meaning:
      "(cũ) hiền hậu và độ lượng: tính khoan hoà, nhân hậu * ăn nói khoan hoà",
    example: "tính khoan hoà, nhân hậu * ăn nói khoan hoà",
  },
  {
    word: "khoán trắng",
    part_of_speech: "động từ",
    meaning:
      "giao phó toàn bộ công việc thuộc phạm vi trách nhiệm của mình cho người khác mà không ngó ngàng, quan tâm gì đến nữa: khoán trắng toàn bộ công việc cho phó giám đốc",
    example: "khoán trắng toàn bộ công việc cho phó giám đốc",
  },
  {
    word: "khoan thứ",
    part_of_speech: "động từ",
    meaning: "(cũ) rộng lòng tha thứ: khoan thứ cho kẻ biết hối cải",
    example: "khoan thứ cho kẻ biết hối cải",
  },
  {
    word: "khoảng",
    part_of_speech: "danh từ",
    meaning:
      "phần không gian hoặc thời gian được giới hạn một cách đại khái: khoảng đất trống * khoảng trời trong xanh",
    example: "khoảng đất trống * khoảng trời trong xanh",
  },
  {
    word: "khoảng",
    part_of_speech: "danh từ",
    meaning:
      "thời điểm, độ dài thời gian hay không gian theo ước lượng: bây giờ vào khoảng 3 giờ * ông ấy khoảng sáu mươi tuổi",
    example: "bây giờ vào khoảng 3 giờ * ông ấy khoảng sáu mươi tuổi",
  },
  {
    word: "khoan thai",
    part_of_speech: "tính từ",
    meaning:
      "có dáng điệu thong thả, không vội vã: bước đi khoan thai * điệu bộ khoan thai",
    example: "bước đi khoan thai * điệu bộ khoan thai",
  },
  {
    word: "khoang",
    part_of_speech: "danh từ",
    meaning:
      "khoảng không gian rộng trong lòng tàu, thuyền, sà lan, thường dùng để chứa, chở: hàng hoá xếp đầy khoang thuyền",
    example: "hàng hoá xếp đầy khoang thuyền",
  },
  {
    word: "khoang",
    part_of_speech: "danh từ",
    meaning: "khoảng rỗng trong cơ thể sinh vật: khoang bụng * khoang ngực",
    example: "khoang bụng * khoang ngực",
  },
  {
    word: "khoang",
    part_of_speech: "danh từ",
    meaning:
      "vệt màu khác với màu lông chính ở vòng quanh cổ, đuôi hoặc thân động vật: quạ khoang * chó khoang",
    example: "quạ khoang * chó khoang",
  },
  {
    word: "khoáng đãng",
    part_of_speech: "tính từ",
    meaning: "rộng rãi và quang đãng: vùng trời khoáng đãng",
    example: "vùng trời khoáng đãng",
  },
  {
    word: "khoảng cách",
    part_of_speech: "danh từ",
    meaning:
      "độ dài của đoạn thẳng nối hai điểm đã cho hoặc của đoạn thẳng ngắn nhất nối hai tập hợp điểm đã cho.",
    example: "khoảng cách giữa hai dãy nhà * giữa hai người vẫn có khoảng cách",
  },
  {
    word: "khoáng đạt",
    part_of_speech: "tính từ",
    meaning:
      "rộng rãi và thanh thoát, không gò bó, không hạn hẹp: con người khoáng đạt",
    example: "con người khoáng đạt",
  },
  {
    word: "khoảng âm",
    part_of_speech: "danh từ",
    meaning:
      "phần không gian hoặc thời gian tương đối ngắn được xác định giữa hai điểm hoặc hai thời điểm: đi cách nhau một quãng * quãng đường phía trước * đọc ngắt quãng",
    example: "đi cách nhau một quãng * quãng đường phía trước * đọc ngắt quãng",
  },
  {
    word: "khoảng âm",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) phần không gian hoặc thời gian tương đối ngắn được xác định một cách đại khái: quãng đời niên thiếu * đứa bé quãng ba bốn tuổi",
    example: "quãng đời niên thiếu * đứa bé quãng ba bốn tuổi",
  },
  {
    word: "khoảng không",
    part_of_speech: "danh từ",
    meaning:
      "vùng không gian từ mặt đất trở lên, về mặt không bị giới hạn bởi các vật: khoảng không vũ trụ",
    example: "khoảng không vũ trụ",
  },
  {
    word: "khoảnh khắc",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian hết sức ngắn: khoảnh khắc giao thời * việc đó chỉ diễn ra trong khoảnh khắc",
    example: "khoảnh khắc giao thời * việc đó chỉ diễn ra trong khoảnh khắc",
  },
  {
    word: "khoảnh",
    part_of_speech: "danh từ",
    meaning:
      "phần đất đai, không gian có giới hạn rõ ràng: khoảnh trời riêng * khoảnh đất",
    example: "khoảnh trời riêng * khoảnh đất",
  },
  {
    word: "khoảnh",
    part_of_speech: "tính từ",
    meaning: "(cũ, khẩu ngữ) làm cao, tỏ ra kiêu ngạo: tính ông ấy rất khoảnh",
    example: "tính ông ấy rất khoảnh",
  },
  {
    word: "khoằm",
    part_of_speech: "tính từ",
    meaning: "hơi cong và quặp vào: mũi khoằm",
    example: "mũi khoằm",
  },
  {
    word: "khoát",
    part_of_speech: "động từ",
    meaning:
      "vung tay về một hướng, thường để ra hiệu: khoát tay ra hiệu bảo thôi",
    example: "khoát tay ra hiệu bảo thôi",
  },
  {
    word: "khoát",
    part_of_speech: "động từ",
    meaning:
      "làm động tác đưa tay để làm tung lên một ít nước: khoát nước rửa tay * khoát mái chèo",
    example: "khoát nước rửa tay * khoát mái chèo",
  },
  {
    word: "khoát",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) vén (mành, rèm, v.v.): khoát rèm bước ra",
    example: "khoát rèm bước ra",
  },
  {
    word: "khoáy",
    part_of_speech: "danh từ",
    meaning:
      "chỗ tóc hoặc lông thú mọc ngược chiều gặp nhau, làm thành hình xoáy ốc hoặc hình một vệt dài: khoáy trâu",
    example: "khoáy trâu",
  },
  {
    word: "khoanh tay",
    part_of_speech: "động từ",
    meaning:
      "không làm gì, không tác động gì vì không muốn can dự vào hoặc vì bất lực trước sự việc xảy ra: không chịu khoanh tay chờ chết * bất lực, đành khoanh tay đứng nhìn",
    example:
      "không chịu khoanh tay chờ chết * bất lực, đành khoanh tay đứng nhìn",
  },
  {
    word: "khoanh",
    part_of_speech: "danh từ",
    meaning:
      "vật thường là hình sợi, hình thanh mỏng, được cuộn hoặc uốn cong thành hình vòng tròn: khoanh thừng * một khoanh dây thép",
    example: "khoanh thừng * một khoanh dây thép",
  },
  {
    word: "khoanh",
    part_of_speech: "danh từ",
    meaning:
      "vật có hình một khối tròn dẹt được cắt ra từ một khối hình trụ: khoanh sắn dây * khoanh giò",
    example: "khoanh sắn dây * khoanh giò",
  },
  {
    word: "khoanh",
    part_of_speech: "động từ",
    meaning:
      "làm thành hình vòng tròn hoặc vòng cung: con mèo nằm khoanh tròn ở góc bếp * khoanh những chữ viết sai",
    example: "con mèo nằm khoanh tròn ở góc bếp * khoanh những chữ viết sai",
  },
  {
    word: "khoanh",
    part_of_speech: "động từ",
    meaning:
      "vạch giới hạn để hạn định phạm vi: khoanh rõ các điểm cần lưu ý * khoanh vùng công tác",
    example: "khoanh rõ các điểm cần lưu ý * khoanh vùng công tác",
  },
  {
    word: "khoăm",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như khoằm: dao khoăm mũi",
    example: "dao khoăm mũi",
  },
  {
    word: "khoặm",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như khoằm (nhưng nghĩa mạnh hơn): mũi khoặm",
    example: "mũi khoặm",
  },
  {
    word: "khoặm",
    part_of_speech: "tính từ",
    meaning: "(nét mặt) cau có một cách giận dữ: khoặm mặt lại",
    example: "khoặm mặt lại",
  },
  {
    word: "khoằm khoặm",
    part_of_speech: "tính từ",
    meaning: "như khoằm (nhưng ý mức độ nhiều hơn): mũi khoằm khoặm như mỏ quạ",
    example: "mũi khoằm khoặm như mỏ quạ",
  },
  {
    word: "khoằm khoặm",
    part_of_speech: "tính từ",
    meaning: "như khoặm (ng2; nhưng ý mức độ nhiều hơn): đôi mắt khoằm khoặm",
    example: "đôi mắt khoằm khoặm",
  },
  {
    word: "khóc",
    part_of_speech: "động từ",
    meaning:
      "chảy nước mắt do đau đớn, khó chịu hay xúc động mạnh: bé khóc đòi mẹ * mừng đến phát khóc",
    example: "bé khóc đòi mẹ * mừng đến phát khóc",
  },
  {
    word: "khóc",
    part_of_speech: "động từ",
    meaning:
      "tỏ lòng thương tiếc đối với người thân thiết, ruột thịt đã chết: bài thơ khóc bạn",
    example: "bài thơ khóc bạn",
  },
  {
    word: "khóc dở mếu dở",
    part_of_speech: "",
    meaning:
      "lâm vào một tình trạng oái oăm, không biết phải làm thế nào: rơi vào hoàn cảnh khóc dở mếu dở",
    example: "rơi vào hoàn cảnh khóc dở mếu dở",
  },
  {
    word: "khóc than",
    part_of_speech: "động từ",
    meaning:
      'khóc và thốt ra những lời than vãn, kể lể đau xót: "Khóc than kể hết niềm tây, Chàng ôi, biết nỗi nước này cho chưa?" (TKiều)',
    example:
      'Khóc than kể hết niềm tây, Chàng ôi, biết nỗi nước này cho chưa?" (TKiều)',
  },
  {
    word: "khoắng",
    part_of_speech: "động từ",
    meaning:
      "cho vật cứng ngập sâu vào rồi quấy đảo khắp các chỗ: khoắng cho tan đường trong cốc nước",
    example: "khoắng cho tan đường trong cốc nước",
  },
  {
    word: "khoắng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) lấy trộm nhiều thứ một cách nhanh, gọn: bị kẻ trộm khoắng hết đồ đạc",
    example: "bị kẻ trộm khoắng hết đồ đạc",
  },
  {
    word: "khoé",
    part_of_speech: "danh từ",
    meaning:
      "chỗ tiếp giáp nhau của hai vành môi, hai mí mắt, góc mở ở mép hoặc ở đuôi mắt: chân mày khoé mắt * khoé miệng",
    example: "chân mày khoé mắt * khoé miệng",
  },
  {
    word: "khóc lóc",
    part_of_speech: "động từ",
    meaning: "khóc nhiều (nói khái quát): khóc lóc thảm thiết",
    example: "khóc lóc thảm thiết",
  },
  {
    word: "khoé hạnh",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) khoé miệng cười tươi và duyên dáng (của người phụ nữ): "Khi khoé hạnh, khi nét ngài, Khi ngâm ngợi nguyệt, khi cười cợt hoa." (TKiều)',
    example:
      'Khi khoé hạnh, khi nét ngài, Khi ngâm ngợi nguyệt, khi cười cợt hoa." (TKiều)',
  },
  {
    word: "khoe",
    part_of_speech: "động từ",
    meaning:
      "cố ý làm cho người ta thấy, biết cái tốt đẹp, cái hay của mình, thường là bằng lời nói: bé khoe với mẹ điểm 10 * trăm hoa khoe sắc",
    example: "bé khoe với mẹ điểm 10 * trăm hoa khoe sắc",
  },
  {
    word: "khoẻ",
    part_of_speech: "tính từ",
    meaning:
      "có sức lực cơ thể trên mức bình thường: làm việc khoẻ * yếu trâu còn hơn khoẻ bò (tng)",
    example: "làm việc khoẻ * yếu trâu còn hơn khoẻ bò (tng)",
  },
  {
    word: "khoẻ",
    part_of_speech: "tính từ",
    meaning:
      "(cơ thể) ở trạng thái tốt, không ốm đau, không có bệnh tật gì: khoẻ hơn dạo trước * trông có vẻ khoẻ ra",
    example: "khoẻ hơn dạo trước * trông có vẻ khoẻ ra",
  },
  {
    word: "khoẻ",
    part_of_speech: "tính từ",
    meaning:
      "hay đg (khẩu ngữ) khỏi bệnh, không còn ốm đau nữa: cố ăn uống bồi dưỡng cho chóng khoẻ",
    example: "cố ăn uống bồi dưỡng cho chóng khoẻ",
  },
  {
    word: "khoẻ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ở trạng thái cảm thấy khoan khoái, dễ chịu: thi xong khoẻ cả người",
    example: "thi xong khoẻ cả người",
  },
  {
    word: "khoẻ",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) nhiều vượt xa bình thường: ăn khoẻ * chỉ khoẻ đi chơi",
    example: "ăn khoẻ * chỉ khoẻ đi chơi",
  },
  {
    word: "khoẻ khoắn",
    part_of_speech: "tính từ",
    meaning:
      "khoẻ, có vẻ dồi dào sức lực: thân hình khoẻ khoắn * nghỉ vài hôm cho người thật khoẻ khoắn",
    example: "thân hình khoẻ khoắn * nghỉ vài hôm cho người thật khoẻ khoắn",
  },
  {
    word: "khoẻ khoắn",
    part_of_speech: "tính từ",
    meaning:
      "cảm thấy trong người khoan khoái, dễ chịu: sau giấc ngủ, trong người khoẻ khoắn ra",
    example: "sau giấc ngủ, trong người khoẻ khoắn ra",
  },
  {
    word: "khoẻ khoắn",
    part_of_speech: "tính từ",
    meaning:
      'không vất vả, không phải tốn sức nhiều: "(...) mở trường tư mà dạy học như thầy, lương hướng hơn giáo làng mà được thong thả, khoẻ khoắn." (HBChánh; 4)',
    example:
      '(...) mở trường tư mà dạy học như thầy, lương hướng hơn giáo làng mà được thong thả, khoẻ khoắn." (HBChánh; 4)',
  },
  {
    word: "khoẻ re",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ, khẩu ngữ) có cảm giác thoải mái và nhẹ nhàng, không phải mất nhiều công sức: người cứ khoẻ re",
    example: "người cứ khoẻ re",
  },
  {
    word: "khoe khoang",
    part_of_speech: "động từ",
    meaning:
      "khoe (nói khái quát; hàm ý chê): thái độ khoe khoang * tính hay khoe khoang",
    example: "thái độ khoe khoang * tính hay khoe khoang",
  },
  {
    word: "khoẻ mạnh",
    part_of_speech: "tính từ",
    meaning:
      "có sức khoẻ tốt, không ốm yếu, không bệnh tật: một thanh niên khoẻ mạnh",
    example: "một thanh niên khoẻ mạnh",
  },
  {
    word: "khoeo",
    part_of_speech: "danh từ",
    meaning:
      "chỗ phía sau đầu gối, nơi đùi nối với cẳng chân: bùn dính lên tận khoeo",
    example: "bùn dính lên tận khoeo",
  },
  {
    word: "khoe mẽ",
    part_of_speech: "động từ",
    meaning: "khoe khoang, phô bày cái hình thức bề ngoài: thích khoe mẽ",
    example: "thích khoe mẽ",
  },
  {
    word: "khoèo",
    part_of_speech: "động từ",
    meaning:
      "dùng vật dài có móc ở một đầu, hoặc dùng chân, tay móc vào một vật nào đó rồi kéo về phía mình: khoèo trái bưởi trên cây",
    example: "khoèo trái bưởi trên cây",
  },
  {
    word: "khoèo",
    part_of_speech: "tính từ",
    meaning:
      "(chân tay) ở trạng thái co lại, hơi quắp lại một cách không bình thường: khoèo chân * cánh tay bên trái bị khoèo",
    example: "khoèo chân * cánh tay bên trái bị khoèo",
  },
  {
    word: "khoét",
    part_of_speech: "động từ",
    meaning:
      "làm đứt rời dần từng ít một để tạo thành lỗ rỗng ở bên trong, bằng vật sắc nhọn: sâu khoét rỗng thân cây * chuột khoét vách",
    example: "sâu khoét rỗng thân cây * chuột khoét vách",
  },
  {
    word: "khoét",
    part_of_speech: "động từ",
    meaning:
      "làm cho sâu thêm: khoét sâu mâu thuẫn giữa hai bên * khoét thêm nỗi đau",
    example: "khoét sâu mâu thuẫn giữa hai bên * khoét thêm nỗi đau",
  },
  {
    word: "khoen",
    part_of_speech: "danh từ",
    meaning:
      "vòng nhỏ, thường làm bằng kim loại, để giữ chặt hoặc để móc vào vật khác: cánh cửa có khoen làm bằng sắt * khoen lựu đạn",
    example: "cánh cửa có khoen làm bằng sắt * khoen lựu đạn",
  },
  {
    word: "khoen",
    part_of_speech: "danh từ",
    meaning: "(hiếm) vùng xung quanh mắt: hai khoen mắt đen bầm",
    example: "hai khoen mắt đen bầm",
  },
  {
    word: "khói hương",
    part_of_speech: "danh từ",
    meaning: "như hương khói: khói hương nghi ngút",
    example: "khói hương nghi ngút",
  },
  {
    word: "khói",
    part_of_speech: "danh từ",
    meaning:
      "chất khí có màu trắng đục hoặc đen xám bốc lên từ vật đang cháy: khói bếp * khói thuốc lá * khói lam chiều",
    example: "khói bếp * khói thuốc lá * khói lam chiều",
  },
  {
    word: "khói",
    part_of_speech: "danh từ",
    meaning:
      "hơi bốc lên từ chất lỏng hoặc vật đốt ở nhiệt độ cao: nồi cháo bốc khói nghi ngút",
    example: "nồi cháo bốc khói nghi ngút",
  },
  {
    word: "khỏi",
    part_of_speech: "động từ",
    meaning:
      'ra ngoài, không còn ở trong phạm vi, giới hạn nào đó nữa: thoát khỏi vòng vây * "Cái vòng danh lợi cong cong, Kẻ hòng ra khỏi, người mong nhẩy vào." (Cdao)',
    example:
      'thoát khỏi vòng vây * "Cái vòng danh lợi cong cong, Kẻ hòng ra khỏi, người mong nhẩy vào." (Cdao)',
  },
  {
    word: "khỏi",
    part_of_speech: "động từ",
    meaning:
      "qua được rồi, không còn ở trong tình trạng, trạng thái không hay hoặc trong sự đe doạ nào đó nữa: vẫn chưa khỏi bệnh * tai qua nạn khỏi",
    example: "vẫn chưa khỏi bệnh * tai qua nạn khỏi",
  },
  {
    word: "khỏi",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) từ biểu thị ý phủ định sự cần thiết hoặc sự tất yếu của một sự việc hoặc một trạng thái tâm lí nào đó: anh khỏi phải lo * khỏi cần dài dòng",
    example: "anh khỏi phải lo * khỏi cần dài dòng",
  },
  {
    word: "khói lửa",
    part_of_speech: "danh từ",
    meaning:
      "khói và lửa; thường dùng để chỉ chiến tranh: khói lửa ngút trời * xông pha nơi chiến trường khói lửa",
    example: "khói lửa ngút trời * xông pha nơi chiến trường khói lửa",
  },
  {
    word: "khỏi phải nói",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) không có gì phải nói thêm nữa vì rất rõ ràng, ai cũng biết: thằng ấy thì khỏi phải nói, hư phải biết * sức khoẻ của anh ta thì khỏi phải nói, cứ là như vâm",
    example:
      "thằng ấy thì khỏi phải nói, hư phải biết * sức khoẻ của anh ta thì khỏi phải nói, cứ là như vâm",
  },
  {
    word: "khom",
    part_of_speech: "động từ",
    meaning: "cúi cong lưng xuống: khom lưng cấy lúa",
    example: "khom lưng cấy lúa",
  },
  {
    word: "khói sương",
    part_of_speech: "danh từ",
    meaning: "như sương khói: khói sương mù mịt",
    example: "khói sương mù mịt",
  },
  {
    word: "khòm",
    part_of_speech: "tính từ",
    meaning: "(lưng) ở trạng thái cong hẳn xuống: bà cụ lưng khòm",
    example: "bà cụ lưng khòm",
  },
  {
    word: "khóm",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp một số cây hay một số vật cùng loại đứng chụm vào nhau: khóm tre * khóm hoa quỳnh * khóm nhà lá ven sông",
    example: "khóm tre * khóm hoa quỳnh * khóm nhà lá ven sông",
  },
  {
    word: "khóm",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) dứa: trái khóm",
    example: "trái khóm",
  },
  {
    word: "khọm",
    part_of_speech: "tính từ",
    meaning: "(hiếm) bị khòm lưng xuống do tuổi già: già khọm * khọm lưng",
    example: "già khọm * khọm lưng",
  },
  {
    word: "khổ ải",
    part_of_speech: "",
    meaning:
      "khổ nhiều nỗi, nhiều bề (nói khái quát): cuộc sống khổ ải * vượt qua mọi khổ ải",
    example: "cuộc sống khổ ải * vượt qua mọi khổ ải",
  },
  {
    word: "khố",
    part_of_speech: "danh từ",
    meaning:
      "mảnh vải dài và hẹp, dùng để che giữ bộ phận sinh dục (lối trang phục của đàn ông thời xưa, ngày nay vẫn còn ở một số dân tộc ít người): đóng khố",
    example: "đóng khố",
  },
  {
    word: "khố",
    part_of_speech: "danh từ",
    meaning:
      '(Từ cũ) dải thắt lưng: "Ba năm mua được cái khố sồi, Thắt được nửa tháng, ra đuôi thằn lằn." (Cdao)',
    example:
      'Ba năm mua được cái khố sồi, Thắt được nửa tháng, ra đuôi thằn lằn." (Cdao)',
  },
  {
    word: "khô",
    part_of_speech: "tính từ",
    meaning:
      "ở tình trạng đã hết kiệt nước và trở nên cứng, giòn: củi khô * lá khô * rơm khô * cá khô * cỏ khô",
    example: "củi khô * lá khô * rơm khô * cá khô * cỏ khô",
  },
  {
    word: "khô",
    part_of_speech: "tính từ",
    meaning:
      "(vật có chứa nước hay vốn ẩm ướt) ở tình trạng đã hết hay gần hết nước: vệt máu đã khô * thóc vẫn còn ẩm, chưa khô",
    example: "vệt máu đã khô * thóc vẫn còn ẩm, chưa khô",
  },
  {
    word: "khô",
    part_of_speech: "tính từ",
    meaning:
      "ở tình trạng chứa nước hay có độ ẩm dưới mức bình thường: da khô * quýt ngọt nhưng khô * trời khô và lạnh",
    example: "da khô * quýt ngọt nhưng khô * trời khô và lạnh",
  },
  {
    word: "khô",
    part_of_speech: "tính từ",
    meaning:
      "ở tình trạng không có nước, khác với tình trạng có nước bình thường: ruộng khô vì hạn * bể khô hết nước",
    example: "ruộng khô vì hạn * bể khô hết nước",
  },
  {
    word: "khô",
    part_of_speech: "tính từ",
    meaning: "(âm thanh) gọn và đanh: tiếng lên đạn nghe khô",
    example: "tiếng lên đạn nghe khô",
  },
  {
    word: "khô",
    part_of_speech: "tính từ",
    meaning:
      "không thấy có biểu hiện của tình cảm, nên không hấp dẫn, không gây được hứng thú: văn viết khô, thiếu cảm xúc * con gái mà tính tình khô như ngói",
    example: "văn viết khô, thiếu cảm xúc * con gái mà tính tình khô như ngói",
  },
  {
    word: "khô",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) thịt, cá phơi hoặc sấy khô để cất giữ lâu: khô mực * khô nai",
    example: "khô mực * khô nai",
  },
  {
    word: "khô",
    part_of_speech: "danh từ",
    meaning: "bã của nguyên liệu sau khi đã ép lấy dầu: khô đậu tương",
    example: "khô đậu tương",
  },
  {
    word: "khô cằn",
    part_of_speech: "tính từ",
    meaning:
      "(đất trồng) cằn cỗi, ít màu, vì không được chăm sóc, tưới bón (nói khái quát): đất đai khô cằn * vùng đồi núi khô cằn",
    example: "đất đai khô cằn * vùng đồi núi khô cằn",
  },
  {
    word: "khô cằn",
    part_of_speech: "tính từ",
    meaning:
      "ở tình trạng mất hết, không còn sự phát triển tình cảm, cảm xúc hay thể chất: khuôn mặt khô cằn",
    example: "khuôn mặt khô cằn",
  },
  {
    word: "khổ",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận của khung cửi hoặc của máy dệt, có nhiều khe răng cách đều nhau, dùng để dàn sợi dọc theo chiều rộng và dập sợi ngang vào.",
    example: "vải hẹp khổ * in trên giấy khổ rộng",
  },
  {
    word: "khổ",
    part_of_speech: "danh từ",
    meaning:
      "bề rộng của hàng dệt hoặc của vật hình tấm sản xuất hàng loạt: vải hẹp khổ * in trên giấy khổ rộng",
    example: "khổ người tầm thước * chiếc áo rộng quá khổ",
  },
  {
    word: "khổ",
    part_of_speech: "danh từ",
    meaning:
      "nét nhịp điệu được tổ chức theo yêu cầu riêng để đệm cho một điệu hát: khổ trống * khổ phách",
    example: "khổ trống * khổ phách",
  },
  {
    word: "khổ",
    part_of_speech: "danh từ",
    meaning:
      "đoạn ngắn được ngắt ra trong một bài văn vần: bài thơ gồm có bốn khổ",
    example: "bài thơ gồm có bốn khổ",
  },
  {
    word: "khổ",
    part_of_speech: "tính từ",
    meaning:
      'quá khó khăn, thiếu thốn về vật chất hoặc vất vả về thể xác hay bị giày vò, đau đớn về tinh thần: sống khổ * "Có con phải khổ vì con, Có chồng phải gánh giang sơn nhà chồng." (Cdao)',
    example:
      'sống khổ * "Có con phải khổ vì con, Có chồng phải gánh giang sơn nhà chồng." (Cdao)',
  },
  {
    word: "khổ",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) từ dùng như một cảm từ, biểu thị ý than thở, thương hại hoặc bực tức: khổ! tí tuổi đầu đã phải làm lụng vất vả!",
    example: "khổ! tí tuổi đầu đã phải làm lụng vất vả!",
  },
  {
    word: "khọt khẹt",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng phát ra nghe rè và không đều như do bị nghẹt: tiếng loa khọt khẹt * người ốm nên hơi thở khọt khẹt",
    example: "tiếng loa khọt khẹt * người ốm nên hơi thở khọt khẹt",
  },
  {
    word: "khổ chủ",
    part_of_speech: "danh từ",
    meaning:
      "người bị nạn, người phải chịu nỗi khổ đang được nói đến: bồi thường cho khổ chủ",
    example: "bồi thường cho khổ chủ",
  },
  {
    word: "khổ cực",
    part_of_speech: "tính từ",
    meaning:
      "như cực khổ: dân tình khổ cực * cuộc sống khổ cực * chịu biết bao nhiêu là khổ cực",
    example:
      "dân tình khổ cực * cuộc sống khổ cực * chịu biết bao nhiêu là khổ cực",
  },
  {
    word: "khổ công",
    part_of_speech: "tính từ",
    meaning:
      "vất vả, phải bỏ ra quá nhiều sức lực, tâm trí vào công việc nào đó: khổ công rèn luyện",
    example: "khổ công rèn luyện",
  },
  {
    word: "khô cứng",
    part_of_speech: "tính từ",
    meaning:
      "khô khan và cứng nhắc, không có chút biểu hiện tình cảm nào: một con người khô cứng * ông ta làm việc chỉ căn cứ vào mớ hồ sơ khô cứng",
    example:
      "một con người khô cứng * ông ta làm việc chỉ căn cứ vào mớ hồ sơ khô cứng",
  },
  {
    word: "khố dây",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) khố và dây để buộc; dùng để chỉ hạng người khốn khổ, cùng cực với ý coi thường: bọn khố dây",
    example: "bọn khố dây",
  },
  {
    word: "khổ hạnh",
    part_of_speech: "tính từ",
    meaning:
      "có lối sống khắc khổ, theo phép tu hành của một số tôn giáo, hoặc theo một số quan niệm sống: lối sống khổ hạnh",
    example: "lối sống khổ hạnh",
  },
  {
    word: "khô đét",
    part_of_speech: "tính từ",
    meaning: "khô quắt, đến mức teo cứng hẳn lại: cá phơi khô đét",
    example: "cá phơi khô đét",
  },
  {
    word: "khô đét",
    part_of_speech: "tính từ",
    meaning:
      "gầy đến mức như quắt lại, chỉ còn da bọc xương: bàn tay khô đét * thân hình khô đét",
    example: "bàn tay khô đét * thân hình khô đét",
  },
  {
    word: "khô hạn",
    part_of_speech: "tính từ",
    meaning: "khô do hạn hán (nói khái quát): thời tiết khô hạn",
    example: "thời tiết khô hạn",
  },
  {
    word: "khố đỏ",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) lính người Việt Nam phục vụ trong quân đội Pháp ở thuộc địa, thời Pháp thuộc (quấn xà cạp màu đỏ): lính khố đỏ",
    example: "lính khố đỏ",
  },
  {
    word: "khô hanh",
    part_of_speech: "tính từ",
    meaning: "(khí hậu) khô và hanh (nói khái quát): trời khô hanh",
    example: "trời khô hanh",
  },
  {
    word: "khô héo",
    part_of_speech: "tính từ",
    meaning:
      "(cây cối) khô cạn nhựa sống và héo đi: nắng hạn kéo dài làm cỏ cây khô héo",
    example: "nắng hạn kéo dài làm cỏ cây khô héo",
  },
  {
    word: "khô héo",
    part_of_speech: "tính từ",
    meaning: "héo hon, không còn sức sống: cơ thể khô héo * khô héo ruột gan",
    example: "cơ thể khô héo * khô héo ruột gan",
  },
  {
    word: "khô khan",
    part_of_speech: "tính từ",
    meaning:
      "khô, không có nước hoặc chất nước (nói khái quát): cổ họng khô khan",
    example: "cổ họng khô khan",
  },
  {
    word: "khô khan",
    part_of_speech: "tính từ",
    meaning:
      "khô, không có biểu hiện của tình cảm, không hấp dẫn (nói khái quát): những bài giảng khô khan * nét mặt lạnh lùng, khô khan",
    example: "những bài giảng khô khan * nét mặt lạnh lùng, khô khan",
  },
  {
    word: "khô kiệt",
    part_of_speech: "tính từ",
    meaning:
      "khô đến mức như đã bị vắt, bị phơi cho kiệt nước: hạn hán làm đồng ruộng khô kiệt",
    example: "hạn hán làm đồng ruộng khô kiệt",
  },
  {
    word: "khô kiệt",
    part_of_speech: "tính từ",
    meaning:
      "hoàn toàn không còn sức sống: khí lực khô kiệt * tấm thân nhỏ bé, khô kiệt",
    example: "khí lực khô kiệt * tấm thân nhỏ bé, khô kiệt",
  },
  {
    word: "khô khốc",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) khô đến mức như trơ ra, như cứng lại: mồm miệng nhạt thếch, khô khốc * đồng ruộng khô khốc vì thiếu nước",
    example:
      "mồm miệng nhạt thếch, khô khốc * đồng ruộng khô khốc vì thiếu nước",
  },
  {
    word: "khô khốc",
    part_of_speech: "tính từ",
    meaning:
      "(âm thanh) nghe khô đến mức không thấy có chút biểu hiện cảm xúc nào: tiếng nổ đanh, khô khốc * tiếng cười khô khốc",
    example: "tiếng nổ đanh, khô khốc * tiếng cười khô khốc",
  },
  {
    word: "khô khát",
    part_of_speech: "tính từ",
    meaning: "rất khát nước (nói khái quát): cổ họng khô khát",
    example: "cổ họng khô khát",
  },
  {
    word: "khổ luyện",
    part_of_speech: "động từ",
    meaning:
      "dày công luyện tập một cách vất vả với quyết tâm cao, vượt qua mọi khó khăn, gian khổ: kiên tâm khổ luyện * có khổ luyện thì mới thành tài",
    example: "kiên tâm khổ luyện * có khổ luyện thì mới thành tài",
  },
  {
    word: "khổ một nỗi",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) như khốn nỗi (nhưng ý nhấn mạnh hơn): làm được, nhưng khổ một nỗi không có nguyên liệu",
    example: "làm được, nhưng khổ một nỗi không có nguyên liệu",
  },
  {
    word: "khô lạnh",
    part_of_speech: "tính từ",
    meaning:
      "(khí hậu) khô và lạnh (nói khái quát): thời tiết ở miền Bắc thường khô lạnh vào mùa đông",
    example: "thời tiết ở miền Bắc thường khô lạnh vào mùa đông",
  },
  {
    word: "khô lạnh",
    part_of_speech: "tính từ",
    meaning:
      "(âm thanh, vẻ mặt) khô đến mức hoàn toàn không thấy biểu hiện cảm xúc, tình cảm nào: ánh mắt khô lạnh * nói gằn lên từng tiếng nghe rất khô lạnh",
    example: "ánh mắt khô lạnh * nói gằn lên từng tiếng nghe rất khô lạnh",
  },
  {
    word: "khổ nhục",
    part_of_speech: "tính từ",
    meaning: "khổ và nhục (nói khái quát): sống khổ nhục",
    example: "sống khổ nhục",
  },
  {
    word: "khổ não",
    part_of_speech: "tính từ",
    meaning: "đau khổ và sầu não: vẻ mặt khổ não",
    example: "vẻ mặt khổ não",
  },
  {
    word: "khổ nhục kế",
    part_of_speech: "danh từ",
    meaning:
      "kế chịu khổ cực và nhục nhã nhất thời để đánh lừa đối phương: dùng khổ nhục kế để lừa địch",
    example: "dùng khổ nhục kế để lừa địch",
  },
  {
    word: "khổ qua",
    part_of_speech: "danh từ",
    meaning:
      '(Nam) mướp đắng: "Đói lòng ăn trái khổ qua, Nuốt vô thì đắng, nhả ra bạn cười." (ca dao)',
    example: "Đói lòng ăn trái khổ qua, Nuốt vô thì đắng, nhả ra bạn cười.",
  },
  {
    word: "khố rách",
    part_of_speech: "",
    meaning: "(khẩu ngữ) khố rách áo ôm (nói tắt): hạng khố rách",
    example: "hạng khố rách",
  },
  {
    word: "khô rang",
    part_of_speech: "tính từ",
    meaning: "khô đến mức như đã bị rang lên: quần áo phơi nắng, khô rang",
    example: "quần áo phơi nắng, khô rang",
  },
  {
    word: "khô ráo",
    part_of_speech: "tính từ",
    meaning:
      "hoàn toàn khô, không ẩm, không ướt (nói khái quát): nắng lên, đường sá khô ráo",
    example: "nắng lên, đường sá khô ráo",
  },
  {
    word: "khô róc",
    part_of_speech: "tính từ",
    meaning: "khô đến mức như không còn một giọt nước nào: bình rượu khô róc",
    example: "bình rượu khô róc",
  },
  {
    word: "khổ sai",
    part_of_speech: "động từ",
    meaning:
      "(cũ) bị bắt buộc làm những việc hết sức nặng nhọc (một hình thức trừng phạt đối với các phạm nhân thời trước): tù khổ sai * bị kết án mười năm khổ sai",
    example: "tù khổ sai * bị kết án mười năm khổ sai",
  },
  {
    word: "khổ sở",
    part_of_speech: "tính từ",
    meaning: "đau đớn và cực khổ: cuộc sống khổ sở",
    example: "cuộc sống khổ sở",
  },
  {
    word: "khổ tâm",
    part_of_speech: "tính từ",
    meaning:
      "đau lòng, day dứt nhiều trong lòng: khổ tâm vì để cha mẹ vất vả * nỗi khổ tâm",
    example: "khổ tâm vì để cha mẹ vất vả * nỗi khổ tâm",
  },
  {
    word: "khổ thân",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) khổ cho cái thân (từ biểu thị ý thương hại, thông cảm): đi làm gì cho khổ thân!",
    example: "đi làm gì cho khổ thân!",
  },
  {
    word: "khố tải",
    part_of_speech: "danh từ",
    meaning:
      "bao dệt bằng sợi đay hay dứa gai, thường dùng để đựng lương thực: vác một bao tải thóc",
    example: "vác một bao tải thóc",
  },
  {
    word: "khối",
    part_of_speech: "danh từ",
    meaning:
      "lượng tương đối lớn của một chất rắn hoặc chất nhão, làm thành một đơn vị, không có hình thù nhất định hoặc không xét về mặt hình thù: nước đóng băng thành khối * khối u * khối óc",
    example: "nước đóng băng thành khối * khối u * khối óc",
  },
  {
    word: "khối",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp nhiều yếu tố, thường cùng một loại, liên kết lại thành một thể thống nhất: khối liên minh công nông * xây dựng khối đại đoàn kết toàn dân",
    example: "khối liên minh công nông * xây dựng khối đại đoàn kết toàn dân",
  },
  {
    word: "khối",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) số lượng nhiều đến mức như không đếm xuể: còn khối việc phải làm * đẹp trai, có khối người theo đuổi",
    example: "còn khối việc phải làm * đẹp trai, có khối người theo đuổi",
  },
  {
    word: "khối",
    part_of_speech: "danh từ",
    meaning:
      "phần không gian giới hạn bởi một mặt khép kín: khối trụ * khối chóp",
    example: "khối trụ * khối chóp",
  },
  {
    word: "khối",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng ghép sau danh từ tên đơn vị đo độ dài, để tạo thành những tên đơn vị đo thể tích: đơn vị đo thể tích là mét khối (m3)",
    example: "đơn vị đo thể tích là mét khối (m3)",
  },
  {
    word: "khối",
    part_of_speech: "trợ từ",
    meaning:
      "(Thông tục) từ biểu thị ý phủ định được nhấn mạnh, như muốn phản bác lại ý của người đối thoại: học như thế thì có mà đỗ khối!",
    example: "học như thế thì có mà đỗ khối!",
  },
  {
    word: "khôi hài",
    part_of_speech: "tính từ",
    meaning:
      "có tác dụng làm cho cảm thấy thú vị, buồn cười: câu nói khôi hài * chuyện khôi hài",
    example: "câu nói khôi hài * chuyện khôi hài",
  },
  {
    word: "khối lượng",
    part_of_speech: "danh từ",
    meaning: "đại lượng đặc trưng cho quán tính và tính hấp dẫn của một vật.",
    example: "khối lượng công việc * một khối lượng tác phẩm đồ sộ",
  },
  {
    word: "khốc liệt",
    part_of_speech: "tính từ",
    meaning:
      "có tác hại lớn và dữ dội đến mức đáng sợ: sức tàn phá khốc liệt của trận bão * cuộc chiến khốc liệt",
    example: "sức tàn phá khốc liệt của trận bão * cuộc chiến khốc liệt",
  },
  {
    word: "khôi ngô",
    part_of_speech: "tính từ",
    meaning:
      "(vẻ mặt) sáng sủa, thông minh (thường nói về nam giới còn trẻ tuổi): một chàng trai khôi ngô * nét mặt khôi ngô, tuấn tú",
    example: "một chàng trai khôi ngô * nét mặt khôi ngô, tuấn tú",
  },
  {
    word: "khôi phục",
    part_of_speech: "động từ",
    meaning:
      "làm cho có lại được hay trở lại được như trước: khôi phục lòng tin * khôi phục làng nghề truyền thống",
    example: "khôi phục lòng tin * khôi phục làng nghề truyền thống",
  },
  {
    word: "khôi vĩ",
    part_of_speech: "tính từ",
    meaning:
      "(cũ, hiếm) (dáng người) cao lớn và khoẻ mạnh, đẹp (chỉ nói về đàn ông): tướng mạo khôi vĩ",
    example: "tướng mạo khôi vĩ",
  },
  {
    word: "khối phố",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp dân cư trong một khu phố: bà con khối phố * tham gia sinh hoạt khối phố",
    example: "bà con khối phố * tham gia sinh hoạt khối phố",
  },
  {
    word: "khối u",
    part_of_speech: "danh từ",
    meaning:
      "khối do các tế bào phát triển không bình thường nổi lên thành cục: phẫu thuật cắt bỏ khối u",
    example: "phẫu thuật cắt bỏ khối u",
  },
  {
    word: "khôn",
    part_of_speech: "tính từ",
    meaning:
      'có khả năng suy xét để xử sự một cách có lợi nhất, tránh được những việc làm và thái độ không nên có: con chó rất khôn * "Trót vì tay đã nhúng chàm, Dại rồi còn biết khôn làm sao đây?" (TKiều)',
    example:
      'con chó rất khôn * "Trót vì tay đã nhúng chàm, Dại rồi còn biết khôn làm sao đây?" (TKiều)',
  },
  {
    word: "khôn",
    part_of_speech: "phụ từ",
    meaning:
      '(Văn chương, Ít dùng) không thể, khó mà: "Giọt châu lã chã khôn cầm, Cúi đầu chàng những gạt thầm giọt Tương." (TKiều)',
    example:
      'Giọt châu lã chã khôn cầm, Cúi đầu chàng những gạt thầm giọt Tương." (TKiều)',
  },
  {
    word: "khốn cùng",
    part_of_speech: "tính từ",
    meaning:
      'gian nan quẫn bách đến mức cùng cực: gặp lúc khốn cùng * "Khó khăn tôi rắp cậy ông, Ai ngờ ông lại khốn cùng hơn tôi!" (ca dao)',
    example:
      'gặp lúc khốn cùng * "Khó khăn tôi rắp cậy ông, Ai ngờ ông lại khốn cùng hơn tôi!" (ca dao)',
  },
  {
    word: "khôn cùng",
    part_of_speech: "tính từ",
    meaning:
      "(văn chương) rất rộng, rất lớn, như không có giới hạn: vũ trụ  khôn cùng * một sức mạnh khôn cùng",
    example: "vũ trụ  khôn cùng * một sức mạnh khôn cùng",
  },
  {
    word: "khôn cùng",
    part_of_speech: "phụ từ",
    meaning:
      "(văn chương) đến mức độ rất cao, khó có thể diễn tả hết được: quý giá khôn cùng * thương xót khôn cùng",
    example: "quý giá khôn cùng * thương xót khôn cùng",
  },
  {
    word: "khôn khéo",
    part_of_speech: "tính từ",
    meaning: "khôn ngoan và khéo léo: lời lẽ khôn khéo * cư xử khôn khéo",
    example: "lời lẽ khôn khéo * cư xử khôn khéo",
  },
  {
    word: "khôn hồn",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp dùng trong câu răn đe, hàm ý sẽ gặp điều không hay nếu không nghe theo lời: khôn hồn thì im ngay!",
    example: "khôn hồn thì im ngay!",
  },
  {
    word: "khốn",
    part_of_speech: "tính từ",
    meaning:
      "bị lâm vào tình trạng khó khăn, có thể nguy hiểm: cẩn thận kẻo ngã thì khốn! * biết thì để bụng, đừng có bép xép mà vạ miệng thì khốn",
    example:
      "cẩn thận kẻo ngã thì khốn! * biết thì để bụng, đừng có bép xép mà vạ miệng thì khốn",
  },
  {
    word: "khốn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) hèn hạ, đáng khinh bỉ (thường dùng làm tiếng chửi): đồ khốn! * thằng khốn!",
    example: "đồ khốn! * thằng khốn!",
  },
  {
    word: "khốn khổ",
    part_of_speech: "tính từ",
    meaning: "rất khổ sở: những người khốn khổ * lâm vào tình cảnh khốn khổ",
    example: "những người khốn khổ * lâm vào tình cảnh khốn khổ",
  },
  {
    word: "khốn khổ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) từ dùng để biểu thị ý phàn nàn, than thở: khốn khổ, nào tôi có giấu anh điều gì!",
    example: "khốn khổ, nào tôi có giấu anh điều gì!",
  },
  {
    word: "khốn đốn",
    part_of_speech: "tính từ",
    meaning:
      "ở vào, lâm vào tình cảnh khó khăn, phải đối phó rất vất vả: khốn đốn vì nạn lụt * lâm vào cảnh khốn đốn",
    example: "khốn đốn vì nạn lụt * lâm vào cảnh khốn đốn",
  },
  {
    word: "khốn kiếp",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) đáng ghét, đáng nguyền rủa (thường dùng làm tiếng chửi): đồ khốn kiếp! * quân khốn kiếp!",
    example: "đồ khốn kiếp! * quân khốn kiếp!",
  },
  {
    word: "khốn khó",
    part_of_speech: "tính từ",
    meaning: "nghèo túng, khó khăn: ở vào cảnh khốn khó * khốn khó trăm đường",
    example: "ở vào cảnh khốn khó * khốn khó trăm đường",
  },
  {
    word: "khôn lớn",
    part_of_speech: "tính từ",
    meaning:
      "lớn và khôn hơn lên, đã có thể vững vàng, tự lập được (nói khái quát): con cái đã khôn lớn",
    example: "con cái đã khôn lớn",
  },
  {
    word: "khôn lỏi",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) khôn vặt, luôn tìm cách giành lợi riêng cho mình một cách ích kỉ: chỉ được cái khôn lỏi!",
    example: "chỉ được cái khôn lỏi!",
  },
  {
    word: "khốn nạn",
    part_of_speech: "tính từ",
    meaning:
      '(Từ cũ) khốn khổ đến mức thảm hại, đáng thương: cảnh đời khốn nạn * "Ta thương mình lắm mình ôi, Cá chết về mồi khốn nạn đôi ta." (Cdao)',
    example:
      'cảnh đời khốn nạn * "Ta thương mình lắm mình ôi, Cá chết về mồi khốn nạn đôi ta." (Cdao)',
  },
  {
    word: "khốn nạn",
    part_of_speech: "tính từ",
    meaning:
      "hèn mạt, không còn chút nhân cách, đáng khinh bỉ, nguyền rủa: đồ khốn nạn! * thằng ấy khốn nạn lắm",
    example: "đồ khốn nạn! * thằng ấy khốn nạn lắm",
  },
  {
    word: "khốn quẫn",
    part_of_speech: "tính từ",
    meaning:
      "nghèo khổ đến mức quẫn bách: bị sa vào cảnh khốn quẫn * tình thế rất là khốn quẫn",
    example: "bị sa vào cảnh khốn quẫn * tình thế rất là khốn quẫn",
  },
  {
    word: "khôn ngoan",
    part_of_speech: "tính từ",
    meaning:
      'khôn trong cách xử sự, biết tránh cho mình những điều không hay: cách ứng xử khôn ngoan * "Khôn ngoan đối đáp người ngoài, Gà cùng một mẹ chớ hoài đá nhau." (ca dao)',
    example:
      'cách ứng xử khôn ngoan * "Khôn ngoan đối đáp người ngoài, Gà cùng một mẹ chớ hoài đá nhau." (ca dao)',
  },
  {
    word: "khốn nỗi",
    part_of_speech: "",
    meaning:
      "tổ hợp biểu thị điều sắp nêu ra là trở ngại khiến điều vừa nói đến không thực hiện được: muốn đi chơi nhưng khốn nỗi không có tiền",
    example: "muốn đi chơi nhưng khốn nỗi không có tiền",
  },
  {
    word: "khôn nguôi",
    part_of_speech: "",
    meaning:
      'khó nguôi ngoai, khó dứt được tình cảm hoặc thôi suy nghĩ về một cái gì: nỗi day dứt khôn nguôi * "Xa anh đã ba năm chầy, Tấm lòng thương nhớ đêm ngày khôn nguôi." (Cdao)',
    example:
      'nỗi day dứt khôn nguôi * "Xa anh đã ba năm chầy, Tấm lòng thương nhớ đêm ngày khôn nguôi." (Cdao)',
  },
  {
    word: "khôn lường",
    part_of_speech: "",
    meaning:
      "khó mà tính trước, biết trước được, thường là điều không hay: biến hoá khôn lường * gian khổ khôn lường",
    example: "biến hoá khôn lường * gian khổ khôn lường",
  },
  {
    word: "khôn xiết",
    part_of_speech: "phụ từ",
    meaning:
      '(văn chương) đến mức độ rất cao, khó mà kể xiết: vui mừng khôn xiết * "Khóc than khôn xiết sự tình, Khéo vô duyên bấy là mình với ta!" (TKiều)',
    example:
      'vui mừng khôn xiết * "Khóc than khôn xiết sự tình, Khéo vô duyên bấy là mình với ta!" (TKiều)',
  },
  {
    word: "khống",
    part_of_speech: "tính từ",
    meaning:
      "không có trong thực tế, nhưng được tính, được xem như có thật: khai khống * lập chứng từ khống",
    example: "khai khống * lập chứng từ khống",
  },
  {
    word: "không",
    part_of_speech: "danh từ",
    meaning:
      "khoảng không gian ở trên cao, trên đầu mọi người: bay lượn trên không * vận tải đường không",
    example: "bay lượn trên không * vận tải đường không",
  },
  {
    word: "không",
    part_of_speech: "danh từ",
    meaning:
      "cái không có hình dạng, con người không ý thức được, theo quan niệm của đạo Phật (nói khái quát); đối lập với sắc: quan niệm sắc sắc, không không của đạo Phật",
    example: "quan niệm sắc sắc, không không của đạo Phật",
  },
  {
    word: "không",
    part_of_speech: "danh từ",
    meaning:
      "số (ghi bằng 0), thường dùng làm khởi điểm để chia độ, để tính giờ, vv: thắng hai không * tính từ 0 giờ ngày 21 tháng 12",
    example: "thắng hai không * tính từ 0 giờ ngày 21 tháng 12",
  },
  {
    word: "không",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái hoàn toàn không có những gì thường thấy có: cái hộp không * vườn không nhà trống * nhà bỏ không",
    example: "cái hộp không * vườn không nhà trống * nhà bỏ không",
  },
  {
    word: "không",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái hoàn toàn rỗi rãi, không có việc gì làm hoặc không chịu làm việc gì: chỉ độc ngồi không * ăn không ngồi rồi (tng)",
    example: "chỉ độc ngồi không * ăn không ngồi rồi (tng)",
  },
  {
    word: "không",
    part_of_speech: "tính từ",
    meaning:
      'ở trạng thái hoàn toàn không có thêm những gì khác như thường thấy hoặc như đáng lẽ phải có: ăn cơm không * làm công không * "Nước lã mà vã nên hồ, Tay không mà nổi cơ đồ mới ngoan." (Cdao)',
    example:
      'ăn cơm không * làm công không * "Nước lã mà vã nên hồ, Tay không mà nổi cơ đồ mới ngoan." (Cdao)',
  },
  {
    word: "không",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái hoàn toàn không kèm theo một điều kiện gì: cho không * tự nhiên mất không một khoản",
    example: "cho không * tự nhiên mất không một khoản",
  },
  {
    word: "không",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) ở mức độ gây cảm giác như là không có gì cả: cái thùng nhẹ không * việc dễ không",
    example: "cái thùng nhẹ không * việc dễ không",
  },
  {
    word: "không",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị ý phủ định đối với điều được nêu ra sau đó: đường vắng, không một bóng người * trong người không được khoẻ * không ai giàu ba họ, không ai khó ba đời (tng)",
    example:
      "đường vắng, không một bóng người * trong người không được khoẻ * không ai giàu ba họ, không ai khó ba đời (tng)",
  },
  {
    word: "không",
    part_of_speech: "phụ từ",
    meaning:
      "(Khẩu ngữ) từ dùng như một kết từ, có nghĩa như nếu không thì...; biểu thị điều sắp nói là khó tránh khỏi nếu như điều vừa nói đến không được thực hiện: học đi, không là thi trượt đấy * dậy đi, không muộn bây giờ",
    example: "học đi, không là thi trượt đấy * dậy đi, không muộn bây giờ",
  },
  {
    word: "không",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị ý hỏi về điều có hay không có, phải hay không phải: dạo này có bận lắm không? * chị có khoẻ không? * anh có đi hay không đấy?",
    example:
      "dạo này có bận lắm không? * chị có khoẻ không? * anh có đi hay không đấy?",
  },
  {
    word: "không biết chừng",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị ý phỏng đoán một cách dè dặt, chưa dám khẳng định dứt khoát: có thể chiều nay nó về cũng không biết chừng",
    example: "có thể chiều nay nó về cũng không biết chừng",
  },
  {
    word: "khôn thiêng",
    part_of_speech: "tính từ",
    meaning:
      "như linh thiêng (dùng trong lời khấn người chết): hồn anh có khôn thiêng, xin về chứng giám cho chúng tôi",
    example: "hồn anh có khôn thiêng, xin về chứng giám cho chúng tôi",
  },
  {
    word: "không cánh mà bay",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) bỗng dưng mất đi lúc nào không ai biết, cũng không biết ai lấy: chiếc xe đạp đã không cánh mà bay",
    example: "chiếc xe đạp đã không cánh mà bay",
  },
  {
    word: "không bờ bến",
    part_of_speech: "",
    meaning:
      "rộng lớn đến mức cảm thấy như không có giới hạn (nói về tinh thần, tình cảm): sự hi sinh không bờ bến * tình yêu thương không bờ bến",
    example: "sự hi sinh không bờ bến * tình yêu thương không bờ bến",
  },
  {
    word: "khống chỉ",
    part_of_speech: "tính từ",
    meaning:
      "(giấy tờ) có chữ kí và đóng dấu sẵn, nhưng còn để trống, chưa đề nội dung: giấy giới thiệu khống chỉ",
    example: "giấy giới thiệu khống chỉ",
  },
  {
    word: "khống chế",
    part_of_speech: "động từ",
    meaning:
      "nắm quyền kiểm soát, chi phối, không để cho tự do hoạt động: khống chế đối phương bằng hoả lực mạnh * khống chế thị trường trong nước",
    example:
      "khống chế đối phương bằng hoả lực mạnh * khống chế thị trường trong nước",
  },
  {
    word: "khống chế",
    part_of_speech: "động từ",
    meaning:
      "giữ trong một giới hạn hoặc mức độ đã quy định, không cho vượt qua: khống chế mức chi tiêu * khống chế số lượng người tham gia",
    example: "khống chế mức chi tiêu * khống chế số lượng người tham gia",
  },
  {
    word: "không đâu",
    part_of_speech: "tính từ",
    meaning:
      "vu vơ, không có nghĩa lí, không có dính dáng gì cả: toàn nói những chuyện không đâu",
    example: "toàn nói những chuyện không đâu",
  },
  {
    word: "không chừng",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) như không biết chừng: cụ đã yếu lắm, không chừng chỉ tối nay là đi * có khi ông ta được thăng chức cũng không chừng",
    example:
      "cụ đã yếu lắm, không chừng chỉ tối nay là đi * có khi ông ta được thăng chức cũng không chừng",
  },
  {
    word: "không dưng",
    part_of_speech: "phụ từ",
    meaning: "(hiếm) như bỗng dưng: đang vui vẻ, không dưng lại giận dỗi",
    example: "đang vui vẻ, không dưng lại giận dỗi",
  },
  {
    word: "không dưng",
    part_of_speech: "phụ từ",
    meaning:
      'không phải là vô cớ (dùng để biểu thị điều sắp nêu ra là có một nguyên do nào đó): không dưng mà người ta lại động đến mình? * "Có làm thì mới có ăn, Không dưng ai dễ đem phần đến cho." (ca dao)',
    example:
      'không dưng mà người ta lại động đến mình? * "Có làm thì mới có ăn, Không dưng ai dễ đem phần đến cho." (ca dao)',
  },
  {
    word: "không chiến",
    part_of_speech: "động từ",
    meaning:
      "chiến đấu bằng máy bay ở trên không: trận không chiến trên bầu trời Hà Nội năm 1972",
    example: "trận không chiến trên bầu trời Hà Nội năm 1972",
  },
  {
    word: "không đội trời chung",
    part_of_speech: "",
    meaning:
      "(quan hệ) một mất một còn, không thể cùng chung sống được: kẻ thù không đội trời chung",
    example: "kẻ thù không đội trời chung",
  },
  {
    word: "không ít thì nhiều",
    part_of_speech: "",
    meaning:
      "hoặc ít hoặc nhiều, thế nào cũng có: ai cũng đóng góp, không ít thì nhiều",
    example: "ai cũng đóng góp, không ít thì nhiều",
  },
  {
    word: "không gian",
    part_of_speech: "danh từ",
    meaning:
      "hình thức tồn tại cơ bản của vật chất (cùng với thời gian), trong đó các vật thể có độ dài và độ lớn khác nhau, cái nọ ở cách cái kia: vật chất vận động trong không gian và thời gian * không gian ba chiều",
    example:
      "vật chất vận động trong không gian và thời gian * không gian ba chiều",
  },
  {
    word: "không gian",
    part_of_speech: "danh từ",
    meaning:
      "khoảng không bao trùm mọi vật xung quanh con người: không gian tĩnh mịch * những đám mây lơ lửng trên không gian",
    example: "không gian tĩnh mịch * những đám mây lơ lửng trên không gian",
  },
  {
    word: "không kèn không trống",
    part_of_speech: "",
    meaning:
      "ví làm việc gì một cách âm thầm, không ai biết đến mà cũng không muốn cho người ta biết (thường hàm ý châm biếm): rút lui không kèn không trống",
    example: "rút lui không kèn không trống",
  },
  {
    word: "không đầu không đũa",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) (chuyện) không có đầu đuôi gì cả: chuyện kể không đầu không đũa",
    example: "chuyện kể không đầu không đũa",
  },
  {
    word: "không khí",
    part_of_speech: "danh từ",
    meaning:
      "hỗn hợp khí bao quanh Trái Đất, chủ yếu gồm nitrogen và oxygen, rất cần thiết cho sự sống của người và sinh vật: càng lên cao không khí càng loãng * hít thở bầu không khí trong lành",
    example:
      "càng lên cao không khí càng loãng * hít thở bầu không khí trong lành",
  },
  {
    word: "không khí",
    part_of_speech: "danh từ",
    meaning:
      "trạng thái tinh thần chung toát ra từ một hoàn cảnh, một môi trường hoạt động của con người: không khí cuộc họp hết sức căng thẳng",
    example: "không khí cuộc họp hết sức căng thẳng",
  },
  {
    word: "không kích",
    part_of_speech: "động từ",
    meaning: "đánh bằng hoả lực không quân: trận không kích",
    example: "trận không kích",
  },
  {
    word: "khổng lồ",
    part_of_speech: "tính từ",
    meaning:
      "có kích thước, quy mô, khối lượng lớn gấp nhiều lần so với bình thường: người khổng lồ * nguồn lợi khổng lồ * một khối lượng công việc khổng lồ",
    example:
      "người khổng lồ * nguồn lợi khổng lồ * một khối lượng công việc khổng lồ",
  },
  {
    word: "không lẽ",
    part_of_speech: "phụ từ",
    meaning:
      'không có lí nào (cho nên nghĩ là không thể nào như thế được): việc này không lẽ mình lại chịu thua? * "Áo đen không lẽ đen hoài, Mưa lâu cũng nhạt, nắng hoài cũng phai." (ca dao)',
    example:
      'việc này không lẽ mình lại chịu thua? * "Áo đen không lẽ đen hoài, Mưa lâu cũng nhạt, nắng hoài cũng phai." (ca dao)',
  },
  {
    word: "không khéo",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) từ biểu thị ý phỏng đoán một cách không khẳng định lắm: không khéo thì hỏng hết * thôi vào nhà đi, không khéo lại cảm đấy!",
    example:
      "không khéo thì hỏng hết * thôi vào nhà đi, không khéo lại cảm đấy!",
  },
  {
    word: "không những",
    part_of_speech: "kết từ",
    meaning:
      "tổ hợp biểu thị điều sắp nêu ra chỉ mới là một phần, một mặt của sự việc, để nhằm nhấn mạnh về cái phần khác, mặt khác sẽ nêu tiếp liền sau đó: cô ấy không những đẹp mà còn rất thông minh",
    example: "cô ấy không những đẹp mà còn rất thông minh",
  },
  {
    word: "không lưu",
    part_of_speech: "danh từ",
    meaning:
      "việc giao thông, đi lại trên không, nói chung: trung tâm kiểm soát không lưu * tuyến không lưu quốc tế",
    example: "trung tâm kiểm soát không lưu * tuyến không lưu quốc tế",
  },
  {
    word: "không quân",
    part_of_speech: "danh từ",
    meaning: "quân chủng hoạt động trên không: lực lượng không quân",
    example: "lực lượng không quân",
  },
  {
    word: "không mấy khi",
    part_of_speech: "",
    meaning: "(khẩu ngữ) như chẳng mấy khi: hai người không mấy khi gặp nhau",
    example: "hai người không mấy khi gặp nhau",
  },
  {
    word: "không tài nào",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) khó có thể, không thể nào làm được việc nói đến: không tài nào nhớ nổi * bài toán khó, không tài nào làm được",
    example: "không tài nào nhớ nổi * bài toán khó, không tài nào làm được",
  },
  {
    word: "không phận",
    part_of_speech: "danh từ",
    meaning:
      "phạm vi trên không thuộc chủ quyền của một nước: vùng trời tổ quốc * canh giữ vùng trời",
    example: "vùng trời tổ quốc * canh giữ vùng trời",
  },
  {
    word: "không tặc",
    part_of_speech: "danh từ",
    meaning:
      "kẻ cướp máy bay (thường đang bay trên không): khống chế không tặc, giải thoát con tin",
    example: "khống chế không tặc, giải thoát con tin",
  },
  {
    word: "không nói không rằng",
    part_of_speech: "",
    meaning:
      "lẳng lặng, không nói một lời nào: Nó không nói không rằng bỏ nhà đi biền biệt.",
    example: "Nó không nói không rằng bỏ nhà đi biền biệt.",
  },
  {
    word: "không thể",
    part_of_speech: "phụ từ",
    meaning:
      "không có, không đủ khả năng hoặc điều kiện làm việc gì; đối lập với có thể: bài toán khó quá, không thể làm nổi * chân đau không thể đi được * bận việc nên không thể đến được",
    example:
      "bài toán khó quá, không thể làm nổi * chân đau không thể đi được * bận việc nên không thể đến được",
  },
  {
    word: "không thể",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị ý phủ định về khả năng khách quan xảy ra sự việc nào đó; đối lập với có thể: không thể như vậy được * việc ấy không thể xảy ra",
    example: "không thể như vậy được * việc ấy không thể xảy ra",
  },
  {
    word: "không vận",
    part_of_speech: "động từ",
    meaning:
      "vận tải bằng đường hàng không: lập đường không vận để tiếp tế cho vùng bị bão lũ",
    example: "lập đường không vận để tiếp tế cho vùng bị bão lũ",
  },
  {
    word: "khờ dại",
    part_of_speech: "tính từ",
    meaning: "kém trí khôn, kém tinh nhanh (nói khái quát): con người khờ dại",
    example: "con người khờ dại",
  },
  {
    word: "không trung",
    part_of_speech: "danh từ",
    meaning:
      "khoảng không gian ở trên cao, phía trên những vật ở mặt đất: lơ lửng giữa không trung * bay vút lên không trung",
    example: "lơ lửng giữa không trung * bay vút lên không trung",
  },
  {
    word: "không tưởng",
    part_of_speech: "tính từ",
    meaning:
      "(tư tưởng, học thuyết) không có cơ sở thực tế, không thể thực hiện được: những ước mơ không tưởng",
    example: "những ước mơ không tưởng",
  },
  {
    word: "khớ",
    part_of_speech: "tính từ",
    meaning: "(thông tục) như khá (ng1): con bé trông cũng khớ ra phết",
    example: "con bé trông cũng khớ ra phết",
  },
  {
    word: "khờ",
    part_of_speech: "tính từ",
    meaning:
      "kém về trí khôn và sự tinh nhanh, không đủ khả năng suy xét để ứng phó với hoàn cảnh, để biết làm những gì nên làm: con bé khờ lắm!",
    example: "con bé khờ lắm!",
  },
  {
    word: "khơ khớ",
    part_of_speech: "tính từ",
    meaning: "(thông tục) như kha khá: khoản thu nhập khơ khớ",
    example: "khoản thu nhập khơ khớ",
  },
  {
    word: "khơ khớ",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả tiếng cười to và giòn tỏ vẻ thoả mãn, thích thú: cười khơ khớ",
    example: "cười khơ khớ",
  },
  {
    word: "khờ khạo",
    part_of_speech: "tính từ",
    meaning: "khờ (nói khái quát): nó còn khờ khạo, mong anh em cứ chỉ bảo",
    example: "nó còn khờ khạo, mong anh em cứ chỉ bảo",
  },
  {
    word: "khởi",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) bắt đầu, mở đầu một công việc gì: từ lúc khởi xây cho đến lúc hoàn tất cũng mất gần năm trời",
    example: "từ lúc khởi xây cho đến lúc hoàn tất cũng mất gần năm trời",
  },
  {
    word: "khơi",
    part_of_speech: "danh từ",
    meaning:
      "vùng biển ở xa bờ; phân biệt với lộng: đoàn thuyền đánh cá ra khơi",
    example: "đoàn thuyền đánh cá ra khơi",
  },
  {
    word: "khơi",
    part_of_speech: "tính từ",
    meaning:
      '(cũ, văn chương) xa: "Ngất chừng biển thẳm non khơi, Đường xa bao nả, tình dài bấy nhiêu!" (BC)',
    example:
      'Ngất chừng biển thẳm non khơi, Đường xa bao nả, tình dài bấy nhiêu!" (BC)',
  },
  {
    word: "khơi",
    part_of_speech: "động từ",
    meaning:
      "làm cho thông, cho thoát bằng cách nạo vét tới tận đáy để lấy đi những vật làm nghẽn, tắc: khơi thông rãnh thoát nước * khơi mương",
    example: "khơi thông rãnh thoát nước * khơi mương",
  },
  {
    word: "khơi",
    part_of_speech: "động từ",
    meaning: "(hiếm) như cời: khơi cho bếp cháy to lên",
    example: "khơi cho bếp cháy to lên",
  },
  {
    word: "khơi",
    part_of_speech: "động từ",
    meaning:
      "gợi ra cái đang ở trạng thái chìm lắng: khơi lại nỗi đau * khơi nguồn cảm hứng",
    example: "khơi lại nỗi đau * khơi nguồn cảm hứng",
  },
  {
    word: "khởi binh",
    part_of_speech: "động từ",
    meaning: "(cũ) đem quân đi đánh: Nguyễn Huệ khởi binh đánh dẹp quân Thanh",
    example: "Nguyễn Huệ khởi binh đánh dẹp quân Thanh",
  },
  {
    word: "khởi công",
    part_of_speech: "động từ",
    meaning:
      "bắt đầu xây dựng công trình, thường là có quy mô lớn: khởi công xây dựng nhà máy",
    example: "khởi công xây dựng nhà máy",
  },
  {
    word: "khới",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) khoét, cắn từng ít một: củ khoai bị chuột khới",
    example: "củ khoai bị chuột khới",
  },
  {
    word: "khới",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) khêu ra (hàm ý chê): khới cho to chuyện",
    example: "khới cho to chuyện",
  },
  {
    word: "khởi động",
    part_of_speech: "động từ",
    meaning:
      "bắt đầu hoặc làm cho bắt đầu chạy hay hoạt động (nói về máy móc, thiết bị): khởi động máy tính * khởi động động cơ xe",
    example: "khởi động máy tính * khởi động động cơ xe",
  },
  {
    word: "khởi động",
    part_of_speech: "động từ",
    meaning:
      "làm những động tác nhẹ nhàng để cho các bộ phận cơ thể làm quen trước khi vận động căng thẳng, trong hoạt động thể dục thể thao: vận động viên khởi động trước khi vào đường đua * tập vài động tác khởi động",
    example:
      "vận động viên khởi động trước khi vào đường đua * tập vài động tác khởi động",
  },
  {
    word: "khởi điểm",
    part_of_speech: "danh từ",
    meaning: "điểm bắt đầu, điểm xuất phát: lương khởi điểm",
    example: "lương khởi điểm",
  },
  {
    word: "khởi đầu",
    part_of_speech: "động từ",
    meaning:
      "bước vào giai đoạn đầu, bắt đầu (công việc, quá trình, trạng thái tương đối kéo dài): bước khởi đầu * vạn sự khởi đầu nan",
    example: "bước khởi đầu * vạn sự khởi đầu nan",
  },
  {
    word: "khơi gợi",
    part_of_speech: "động từ",
    meaning:
      "làm nảy sinh ra cái vốn có sẵn: khơi gợi trí tưởng tượng của trẻ * câu nói đã khơi gợi lại vết thương lòng",
    example:
      "khơi gợi trí tưởng tượng của trẻ * câu nói đã khơi gợi lại vết thương lòng",
  },
  {
    word: "khơi khơi",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (làm việc gì) công khai, ngang nhiên: sách giả được bày bán khơi khơi ngoài vỉa hè",
    example: "sách giả được bày bán khơi khơi ngoài vỉa hè",
  },
  {
    word: "khơi khơi",
    part_of_speech: "tính từ",
    meaning:
      "(làm việc gì) hời hợt, qua loa, không thật sự chú tâm: làm khơi khơi như thế thì chẳng có kết quả gì đâu",
    example: "làm khơi khơi như thế thì chẳng có kết quả gì đâu",
  },
  {
    word: "khởi hành",
    part_of_speech: "động từ",
    meaning:
      "bắt đầu đi, bắt đầu cuộc hành trình: khởi hành lúc sáu giờ * sắp đến giờ tàu khởi hành",
    example: "khởi hành lúc sáu giờ * sắp đến giờ tàu khởi hành",
  },
  {
    word: "khởi kiện",
    part_of_speech: "động từ",
    meaning:
      "đứng ra đưa đơn kiện (trong một vụ án): thời hiệu khởi kiện * làm đơn khởi kiện",
    example: "thời hiệu khởi kiện * làm đơn khởi kiện",
  },
  {
    word: "khởi nghiệp",
    part_of_speech: "động từ",
    meaning: "bắt đầu sự nghiệp: khởi nghiệp với hai bàn tay trắng",
    example: "khởi nghiệp với hai bàn tay trắng",
  },
  {
    word: "khởi nguyên",
    part_of_speech: "",
    meaning:
      "(hiếm) nơi phát sinh, nơi bắt đầu: khởi nguyên của phong trào * sông Hồng khởi nguyên từ Vân Nam, Trung Quốc",
    example:
      "khởi nguyên của phong trào * sông Hồng khởi nguyên từ Vân Nam, Trung Quốc",
  },
  {
    word: "khởi nghĩa",
    part_of_speech: "động từ",
    meaning:
      "nổi dậy dùng bạo lực lật đổ ách thống trị để giành chính quyền: phất cờ khởi nghĩa",
    example: "phất cờ khởi nghĩa",
  },
  {
    word: "khởi nghĩa",
    part_of_speech: "danh từ",
    meaning: "cuộc khởi nghĩa: ý nghĩa lịch sử của khởi nghĩa Yên Bái",
    example: "ý nghĩa lịch sử của khởi nghĩa Yên Bái",
  },
  {
    word: "khởi nguồn",
    part_of_speech: "",
    meaning:
      "bắt nguồn, bắt đầu sinh ra (một công việc, quá trình): Phật giáo khởi nguồn từ Ấn Độ",
    example: "Phật giáo khởi nguồn từ Ấn Độ",
  },
  {
    word: "khởi phát",
    part_of_speech: "động từ",
    meaning:
      "bắt đầu phát sinh (thường dùng để nói về bệnh tật): bệnh khởi phát đột ngột và tiến triển rất nhanh",
    example: "bệnh khởi phát đột ngột và tiến triển rất nhanh",
  },
  {
    word: "khởi tố",
    part_of_speech: "động từ",
    meaning: "bắt đầu đưa ra xem xét để xử theo luật pháp: khởi tố vụ án",
    example: "khởi tố vụ án",
  },
  {
    word: "khởi xướng",
    part_of_speech: "động từ",
    meaning:
      "nêu ra đầu tiên và được mọi người hưởng ứng, làm theo: người khởi xướng ra phong trào thơ mới",
    example: "người khởi xướng ra phong trào thơ mới",
  },
  {
    word: "khởi thuỷ",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) bắt đầu một quá trình nào đó, thường là lâu dài: Phật giáo khởi thuỷ từ ấn Độ",
    example: "Phật giáo khởi thuỷ từ ấn Độ",
  },
  {
    word: "khởi thảo",
    part_of_speech: "động từ",
    meaning:
      "bắt đầu viết ra thành văn bản để thảo luận, sửa chữa, thông qua: khởi thảo kế hoạch",
    example: "khởi thảo kế hoạch",
  },
  {
    word: "khởi sắc",
    part_of_speech: "",
    meaning:
      "(văn chương) có được sắc thái mới, có vẻ hưng thịnh lên: đời sống ở nông thôn đã bắt đầu khởi sắc",
    example: "đời sống ở nông thôn đã bắt đầu khởi sắc",
  },
  {
    word: "khởi sự",
    part_of_speech: "động từ",
    meaning:
      "bắt đầu hành động để thực hiện theo kế hoạch (một việc quan trọng, thường có liên quan đến an ninh chính trị và trật tự xã hội): định ngày khởi sự * trước giờ khởi sự",
    example: "định ngày khởi sự * trước giờ khởi sự",
  },
  {
    word: "khớp",
    part_of_speech: "danh từ",
    meaning:
      "nơi tiếp xúc hai đầu xương, làm cho cử động được: bị sai khớp tay * đau khớp",
    example: "bị sai khớp tay * đau khớp",
  },
  {
    word: "khớp",
    part_of_speech: "danh từ",
    meaning:
      "chỗ tiếp xúc hoặc chỗ nối hai vật chuyển động được với nhau: khớp bản lề * khớp trục",
    example: "khớp bản lề * khớp trục",
  },
  {
    word: "khớp",
    part_of_speech: "danh từ",
    meaning:
      "chỗ có khấc làm cho hai bộ phận của một vật chế tạo được ghép chặt vào nhau, gắn vào nhau: đặt không đúng khớp",
    example: "đặt không đúng khớp",
  },
  {
    word: "khớp",
    part_of_speech: "động từ",
    meaning:
      "hoặc t có vị trí khít vào với nhau và ăn chặt vào nhau: hai bánh răng không khớp với nhau",
    example: "hai bánh răng không khớp với nhau",
  },
  {
    word: "khớp",
    part_of_speech: "động từ",
    meaning:
      "ghép với nhau các bộ phận rời theo vị trí nhất định của chúng để hợp lại thành chỉnh thể: khớp hai mảnh gương lại * khớp những trang sách bị rách theo đúng thứ tự",
    example:
      "khớp hai mảnh gương lại * khớp những trang sách bị rách theo đúng thứ tự",
  },
  {
    word: "khớp",
    part_of_speech: "động từ",
    meaning:
      "ghép lại hoặc đặt liền bên nhau để đối chiếu xem có phù hợp với nhau không: khớp phách thi * khớp lại lời khai",
    example: "khớp phách thi * khớp lại lời khai",
  },
  {
    word: "khớp",
    part_of_speech: "động từ",
    meaning:
      "hoặc t có sự nhất trí, không có sai lệch, mâu thuẫn giữa các bộ phận với nhau: tiền chi ra khớp với sổ sách * lời khai có nhiều mâu thuẫn, không khớp nhau",
    example:
      "tiền chi ra khớp với sổ sách * lời khai có nhiều mâu thuẫn, không khớp nhau",
  },
  {
    word: "khởi tranh",
    part_of_speech: "động từ",
    meaning:
      "bắt đầu diễn ra thi đấu, tranh giải (thể thao): giải bóng đá ngoại hạng Anh đã bắt đầu khởi tranh",
    example: "giải bóng đá ngoại hạng Anh đã bắt đầu khởi tranh",
  },
  {
    word: "khu biệt",
    part_of_speech: "",
    meaning:
      "làm phân biệt rõ với những cái khác trong sự phân loại: đặc điểm khu biệt * những nét khu biệt chính giữa nguyên âm và phụ âm",
    example:
      "đặc điểm khu biệt * những nét khu biệt chính giữa nguyên âm và phụ âm",
  },
  {
    word: "khu đô thị",
    part_of_speech: "danh từ",
    meaning:
      "khu vực được quy hoạch theo mô hình đô thị thu nhỏ, gồm có hạ tầng cơ sở hiện đại, các công trình công cộng, dịch vụ thương mại, văn hoá và nhà ở cao cấp: xây dựng khu đô thị mới",
    example: "xây dựng khu đô thị mới",
  },
  {
    word: "khu",
    part_of_speech: "danh từ",
    meaning:
      "vùng được giới hạn, với những đặc điểm hoặc chức năng riêng, khác với xung quanh: khu rừng * khu công nghiệp cao * khu tập thể quân đội",
    example: "khu rừng * khu công nghiệp cao * khu tập thể quân đội",
  },
  {
    word: "khu",
    part_of_speech: "danh từ",
    meaning:
      "(Từ cũ) đơn vị hành chính đặc biệt, thường gồm nhiều tỉnh hoặc tương đương với tỉnh: cán bộ cấp khu * khu Bốn",
    example: "cán bộ cấp khu * khu Bốn",
  },
  {
    word: "khu",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ) đít: chổng khu",
    example: "chổng khu",
  },
  {
    word: "khu chế xuất",
    part_of_speech: "danh từ",
    meaning:
      "khu vực dành riêng chuyên sản xuất hàng hoá xuất khẩu hoặc thực hiện các dịch vụ cho sản xuất hàng hoá xuất khẩu: khu chế xuất Tân Thuận",
    example: "khu chế xuất Tân Thuận",
  },
  {
    word: "khu công nghiệp",
    part_of_speech: "danh từ",
    meaning:
      "khu vực dành riêng chuyên sản xuất các mặt hàng công nghiệp: xây dựng khu công nghiệp",
    example: "xây dựng khu công nghiệp",
  },
  {
    word: "khù khờ",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) tỏ ra khờ và chậm: thằng bé rất khù khờ",
    example: "thằng bé rất khù khờ",
  },
  {
    word: "khú",
    part_of_speech: "tính từ",
    meaning: "(dưa muối) bị thâm lại và có mùi: dưa bị khú",
    example: "dưa bị khú",
  },
  {
    word: "khú",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có mùi hôi vì bẩn do lâu không tắm giặt: quần áo để khú ra mà vẫn không chịu giặt",
    example: "quần áo để khú ra mà vẫn không chịu giặt",
  },
  {
    word: "khu đệm",
    part_of_speech: "danh từ",
    meaning:
      "khu nằm giữa hai khu vực có đặc điểm quá khác nhau hoặc có tính chất mâu thuẫn với nhau: khu đệm giữa vùng giới tuyến quân sự",
    example: "khu đệm giữa vùng giới tuyến quân sự",
  },
  {
    word: "khu trú",
    part_of_speech: "động từ",
    meaning:
      "chỉ ở trong một phạm vi, một vùng nhất định: vi khuẩn gây bệnh khu trú ở những vùng nhất định trong cơ thể",
    example: "vi khuẩn gây bệnh khu trú ở những vùng nhất định trong cơ thể",
  },
  {
    word: "khù khụ",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng ho nặng và liên tiếp, như tiếng ho của các cụ già: ho khù khụ cả đêm",
    example: "ho khù khụ cả đêm",
  },
  {
    word: "khu phố",
    part_of_speech: "danh từ",
    meaning: "phố, đường phố nói chung: cả khu phố nhớn nhác vì mất điện",
    example: "cả khu phố nhớn nhác vì mất điện",
  },
  {
    word: "khua chân múa tay",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ, hiếm) như hoa chân múa tay: vừa nói vừa khua chân múa tay",
    example: "vừa nói vừa khua chân múa tay",
  },
  {
    word: "khu xử",
    part_of_speech: "động từ",
    meaning:
      '(cũ) đứng ở giữa để dàn xếp, phân xử: biết cách khu xử * "Cụ đốc khu xử như vậy, thật hợp tình hợp lý, anh em học trò kính phục là phải." (NgTTố; 3)',
    example:
      'biết cách khu xử * "Cụ đốc khu xử như vậy, thật hợp tình hợp lý, anh em học trò kính phục là phải." (NgTTố; 3)',
  },
  {
    word: "khu vực",
    part_of_speech: "danh từ",
    meaning:
      "phần đất đai, trời biển có giới hạn rõ ràng, được vạch ra dựa trên những tính chất, đặc điểm chung nào đó về địa lí, về khí hậu, vv: khu vực Đông Nam Á * khu vực đồng bằng * các nước trong khu vực",
    example: "khu vực Đông Nam Á * khu vực đồng bằng * các nước trong khu vực",
  },
  {
    word: "khu vực",
    part_of_speech: "danh từ",
    meaning:
      "lĩnh vực có phạm vi rõ ràng, xác định theo những tính chất, đặc điểm chung nào đó: khu vực quân sự * khu vực sản xuất hàng xuất khẩu * khu vực cấm",
    example: "khu vực quân sự * khu vực sản xuất hàng xuất khẩu * khu vực cấm",
  },
  {
    word: "khua",
    part_of_speech: "danh từ",
    meaning:
      'vành tròn đan bằng đay hoặc bằng tre gắn vào lòng nón để giữ cho chắc khi đội (thường có ở loại nón không có chóp): "Tròng trành như nón không khua, Như thuyền không lái, như chùa không sư." (ca dao)',
    example:
      'Tròng trành như nón không khua, Như thuyền không lái, như chùa không sư." (ca dao)',
  },
  {
    word: "khua",
    part_of_speech: "động từ",
    meaning:
      "đưa qua đưa lại liên tiếp theo những hướng khác nhau để xua, gạt: khua mạng nhện * bà lão mù đang khua gậy dò đường",
    example: "khua mạng nhện * bà lão mù đang khua gậy dò đường",
  },
  {
    word: "khua",
    part_of_speech: "động từ",
    meaning:
      "làm cho động, cho kêu lên bằng động tác đánh, gõ, đập liên tiếp: mái chèo khua nước * khua chuông gõ mõ",
    example: "mái chèo khua nước * khua chuông gõ mõ",
  },
  {
    word: "khua",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) làm cho thức dậy bằng tiếng ồn hoặc một tác động nào đó liên tiếp: đang ngủ ngon thì bị mọi người khua dậy",
    example: "đang ngủ ngon thì bị mọi người khua dậy",
  },
  {
    word: "khua khoắng",
    part_of_speech: "động từ",
    meaning: "khua (nói khái quát): chân tay khua khoắng",
    example: "chân tay khua khoắng",
  },
  {
    word: "khua khoắng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) khoắng (đồ đạc; nói khái quát): bị trộm vào nhà khua khoắng",
    example: "bị trộm vào nhà khua khoắng",
  },
  {
    word: "khuân vác",
    part_of_speech: "động từ",
    meaning:
      "mang chuyển những vật nặng bằng sức của hai tay, lưng hay vai (nói khái quát): công nhân khuân vác ở bến tàu",
    example: "công nhân khuân vác ở bến tàu",
  },
  {
    word: "khuân",
    part_of_speech: "động từ",
    meaning: "khiêng vác (đồ vật nặng): khuân đồ đạc chất lên xe",
    example: "khuân đồ đạc chất lên xe",
  },
  {
    word: "khuất",
    part_of_speech: "",
    meaning:
      "ở vào phía bị che lấp, không nhìn thấy được: ngồi ở góc khuất * mặt trời khuất sau dãy núi * biến đi cho khuất mắt!",
    example:
      "ngồi ở góc khuất * mặt trời khuất sau dãy núi * biến đi cho khuất mắt!",
  },
  {
    word: "khuất",
    part_of_speech: "",
    meaning:
      "ở vào phía bị che chắn, cho nên nằm ngoài phạm vi tác động: đứng ở chỗ khuất gió * nơi ẩm uớt, quanh năm khuất ánh mặt trời",
    example: "đứng ở chỗ khuất gió * nơi ẩm uớt, quanh năm khuất ánh mặt trời",
  },
  {
    word: "khuẩn",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) vi khuẩn (nói tắt): bệnh nhiễm khuẩn * thuốc diệt khuẩn",
    example: "bệnh nhiễm khuẩn * thuốc diệt khuẩn",
  },
  {
    word: "khuẩn",
    part_of_speech: "danh từ",
    meaning:
      "(trang trọng, văn chương) đã chết rồi: giữ gìn kỉ vật của người đã khuất",
    example: "giữ gìn kỉ vật của người đã khuất",
  },
  {
    word: "khuất phục",
    part_of_speech: "động từ",
    meaning:
      "chịu hoặc làm cho phải chịu tuân theo sự chi phối của một thế lực nào đó: không chịu khuất phục kẻ thù",
    example: "không chịu khuất phục kẻ thù",
  },
  {
    word: "khuất nẻo",
    part_of_speech: "tính từ",
    meaning: "ở vào chỗ khuất và đi lại khó khăn: sống ở nơi khuất nẻo",
    example: "sống ở nơi khuất nẻo",
  },
  {
    word: "khuất bóng",
    part_of_speech: "",
    meaning: "(văn chương, trang trọng) đã chết: ông cụ đã khuất bóng",
    example: "ông cụ đã khuất bóng",
  },
  {
    word: "khuất khúc",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều đoạn quanh co, gấp khúc nhau: con ngõ khuất khúc và nhỏ hẹp",
    example: "con ngõ khuất khúc và nhỏ hẹp",
  },
  {
    word: "khuấy đảo",
    part_of_speech: "động từ",
    meaning:
      "làm cho ở vào trạng thái bị xáo trộn hoàn toàn, trở nên thay đổi hẳn so với trước: liên tục có các pha đi bóng làm khuấy đảo hàng phòng ngự đối phương",
    example:
      "liên tục có các pha đi bóng làm khuấy đảo hàng phòng ngự đối phương",
  },
  {
    word: "khuấy",
    part_of_speech: "động từ",
    meaning:
      "như quấy (ng1): dùng thìa khuấy sữa * khuấy cho tan hết đường trong cốc",
    example: "dùng thìa khuấy sữa * khuấy cho tan hết đường trong cốc",
  },
  {
    word: "khuấy",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) như quấy (ng2): khuấy bột cho bé * khuấy một ít hồ để dán",
    example: "khuấy bột cho bé * khuấy một ít hồ để dán",
  },
  {
    word: "khuấy",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) làm cho dậy lên, sôi động hẳn lên: dư luận bị khuấy lên một dạo rồi lại thôi * tìm cách khuấy phong trào lên",
    example:
      "dư luận bị khuấy lên một dạo rồi lại thôi * tìm cách khuấy phong trào lên",
  },
  {
    word: "khúc",
    part_of_speech: "danh từ",
    meaning:
      "phần có độ dài nhất định của một vật được tách riêng ra hoặc coi như tách riêng để thành một đơn vị riêng: cưa gỗ thành từng khúc * khúc đê mới đắp * sông có khúc người có lúc (tng)",
    example:
      "cưa gỗ thành từng khúc * khúc đê mới đắp * sông có khúc người có lúc (tng)",
  },
  {
    word: "khúc",
    part_of_speech: "danh từ",
    meaning:
      "bài thơ, bài ca hay bài nhạc ngắn: ca khúc khải hoàn * khúc tình ca * khúc ca trù",
    example: "ca khúc khải hoàn * khúc tình ca * khúc ca trù",
  },
  {
    word: "khuây",
    part_of_speech: "động từ",
    meaning:
      'nguôi đi, vợi đi nỗi buồn đau, thương nhớ: tạm khuây nỗi nhớ * "Sầu đông trong héo ngoài tươi, Vui là vui gượng, cười là cười khuây." (ca dao)',
    example:
      'tạm khuây nỗi nhớ * "Sầu đông trong héo ngoài tươi, Vui là vui gượng, cười là cười khuây." (ca dao)',
  },
  {
    word: "khuấy động",
    part_of_speech: "động từ",
    meaning:
      "làm cho không còn ở trạng thái tĩnh, mà trở nên sôi động: khuấy động phong trào",
    example: "khuấy động phong trào",
  },
  {
    word: "khuất tất",
    part_of_speech: "tính từ",
    meaning: "không đường hoàng, không rõ ràng: không làm điều gì khuất tất",
    example: "không làm điều gì khuất tất",
  },
  {
    word: "khuây khoả",
    part_of_speech: "động từ",
    meaning: "khuây (nói khái quát): đi chơi cho khuây khoả",
    example: "đi chơi cho khuây khoả",
  },
  {
    word: "khuất núi",
    part_of_speech: "tính từ",
    meaning:
      "(trang trọng) đã chết (thường chỉ nói người cao tuổi): ông bà đã khuất núi",
    example: "ông bà đã khuất núi",
  },
  {
    word: "khục",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng như tiếng kêu của khớp xương bị bẻ gập: bẻ khục * cành cây gãy đánh khục một cái",
    example: "bẻ khục * cành cây gãy đánh khục một cái",
  },
  {
    word: "khúc khuỷu",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều đoạn gấp khúc ngắn nối nhau liên tiếp: bờ biển khúc khuỷu * đường đất khúc khuỷu gồ ghề",
    example: "bờ biển khúc khuỷu * đường đất khúc khuỷu gồ ghề",
  },
  {
    word: "khúc nhôi",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, văn chương) nỗi niềm, sự tình thầm kín, khó nói ra: giãi bày khúc nhôi",
    example: "giãi bày khúc nhôi",
  },
  {
    word: "khúc nhôi",
    part_of_speech: "danh từ",
    meaning:
      "đầu đuôi câu chuyện, sự việc: kể rõ khúc nhôi * tìm hiểu cho rõ khúc nhôi của sự việc",
    example: "kể rõ khúc nhôi * tìm hiểu cho rõ khúc nhôi của sự việc",
  },
  {
    word: "khuê các",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, văn chương) nơi ở của phụ nữ; cũng dùng để chỉ người phụ nữ quý tộc, sang trọng thời trước: con nhà khuê các",
    example: "con nhà khuê các",
  },
  {
    word: "khúc xạ",
    part_of_speech: "",
    meaning:
      "(tia sáng) đổi phương truyền khi đi từ một môi trường này sang một môi trường khác: máy đo khúc xạ * sự khúc xạ ánh sáng",
    example: "máy đo khúc xạ * sự khúc xạ ánh sáng",
  },
  {
    word: "khúc chiết",
    part_of_speech: "tính từ",
    meaning:
      "(cách diễn đạt) có từng đoạn, từng ý, rành mạch và gãy gọn: lời văn khúc chiết * đọc rõ ràng, khúc chiết",
    example: "lời văn khúc chiết * đọc rõ ràng, khúc chiết",
  },
  {
    word: "khúc khích",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả tiếng cười nhỏ và liên tiếp, biểu lộ sự thích thú: che miệng cười khúc khích",
    example: "che miệng cười khúc khích",
  },
  {
    word: "khuếch đại",
    part_of_speech: "động từ",
    meaning:
      "làm tăng lên, làm to ra gấp nhiều lần: máy khuếch đại âm thanh * việc có thế mà cứ khuếch đại lên",
    example: "máy khuếch đại âm thanh * việc có thế mà cứ khuếch đại lên",
  },
  {
    word: "khuếch đại",
    part_of_speech: "động từ",
    meaning:
      "làm tăng hiệu thế hay công suất điện bằng một mạch điện dùng đèn điện tử hoặc bóng bán dẫn: đèn khuếch đại điện tử",
    example: "đèn khuếch đại điện tử",
  },
  {
    word: "khúc mắc",
    part_of_speech: "",
    meaning:
      "có điều vướng mắc khó nói ra, khó giải quyết: đang có chuyện khúc mắc * giải quyết những khúc mắc",
    example: "đang có chuyện khúc mắc * giải quyết những khúc mắc",
  },
  {
    word: "khuê phòng",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) như buồng khuê: "Chút đau đớn khuê phòng gối lẻ, Bỗng vì đâu chia rẽ mối tơ." (TTK)',
    example:
      'Chút đau đớn khuê phòng gối lẻ, Bỗng vì đâu chia rẽ mối tơ." (TTK)',
  },
  {
    word: "khum",
    part_of_speech: "động từ",
    meaning:
      "uốn cong vồng lên hoặc lõm xuống, như hình mu rùa: khum bàn tay lại để vốc nước",
    example: "khum bàn tay lại để vốc nước",
  },
  {
    word: "khum",
    part_of_speech: "tính từ",
    meaning:
      "có hình uốn cong lên hoặc lõm xuống như hình mu rùa: mái nhà sàn ở đầu hồi uốn khum hình mu rùa",
    example: "mái nhà sàn ở đầu hồi uốn khum hình mu rùa",
  },
  {
    word: "khuếch khoác",
    part_of_speech: "",
    meaning: "(hiếm) như khoác lác: ăn nói khuếch khoác",
    example: "ăn nói khuếch khoác",
  },
  {
    word: "khui",
    part_of_speech: "động từ",
    meaning:
      "mở (đồ đựng được đóng kín) ra bằng dụng cụ: khui chai rượu * khui nắp bia * khui thùng hàng",
    example: "khui chai rượu * khui nắp bia * khui thùng hàng",
  },
  {
    word: "khui",
    part_of_speech: "động từ",
    meaning:
      "làm cho phơi bày rõ ra cái vốn được giữ kín, giấu kín: vụ việc bị khui ra ánh sáng",
    example: "vụ việc bị khui ra ánh sáng",
  },
  {
    word: "khuếch tán",
    part_of_speech: "động từ",
    meaning:
      "(chất khí) chuyển động lan ra do không đồng đều về mật độ hay nhiệt độ: hương thơm khuếch tán trong không khí",
    example: "hương thơm khuếch tán trong không khí",
  },
  {
    word: "khuếch tán",
    part_of_speech: "động từ",
    meaning:
      "(ánh sáng) toả ra mọi phương: ánh sáng khuếch tán khắp gian phòng",
    example: "ánh sáng khuếch tán khắp gian phòng",
  },
  {
    word: "khuếch trương",
    part_of_speech: "động từ",
    meaning:
      "mở rộng thêm, phát triển thêm ra: khuếch trương lực lượng * khuếch trương thanh thế",
    example: "khuếch trương lực lượng * khuếch trương thanh thế",
  },
  {
    word: "khúm núm",
    part_of_speech: "động từ",
    meaning:
      "có điệu bộ co ro như cúi đầu, chắp tay, khom lưng, vv tự hạ mình để tỏ ra cung kính, lễ phép trước một người nào đó: thái độ khúm núm * dáng điệu khúm núm, sợ sệt",
    example: "thái độ khúm núm * dáng điệu khúm núm, sợ sệt",
  },
  {
    word: "khung",
    part_of_speech: "danh từ",
    meaning:
      "vật cứng có hình dạng nhất định dùng làm cái bao quanh các phía để lắp đặt cố định lên đó một vật khác: khung ảnh * khung thêu",
    example: "khung ảnh * khung thêu",
  },
  {
    word: "khung",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận chính để lắp đặt cố định hoặc xây dựng trên đó các bộ phận khác: khung xe đạp * dựng khung nhà",
    example: "khung xe đạp * dựng khung nhà",
  },
  {
    word: "khung",
    part_of_speech: "danh từ",
    meaning:
      "phạm vi được giới hạn chặt chẽ: khung trời * khung thuế suất * khung hình phạt",
    example: "khung trời * khung thuế suất * khung hình phạt",
  },
  {
    word: "khùng",
    part_of_speech: "tính từ",
    meaning:
      "bực tức tới mức có phản ứng mạnh, không tự chủ được: tự nhiên nổi khùng * tức quá, phát khùng lên",
    example: "tự nhiên nổi khùng * tức quá, phát khùng lên",
  },
  {
    word: "khùng",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) hơi điên: thằng khùng",
    example: "thằng khùng",
  },
  {
    word: "khủng bố",
    part_of_speech: "động từ",
    meaning:
      "dùng uy lực hoặc bạo lực (thường rất tàn bạo) làm cho phải khiếp sợ để hòng khuất phục: khủng bố tinh thần * bọn khủng bố",
    example: "khủng bố tinh thần * bọn khủng bố",
  },
  {
    word: "khung cảnh",
    part_of_speech: "danh từ",
    meaning:
      "toàn cảnh, nơi sự kiện diễn ra: khung cảnh nông thôn ngày mùa * sống trong khung cảnh hoà bình",
    example: "khung cảnh nông thôn ngày mùa * sống trong khung cảnh hoà bình",
  },
  {
    word: "khung giá",
    part_of_speech: "danh từ",
    meaning:
      "các mức giá, giữa mức tối thiểu và mức tối đa có thể áp dụng đối với một loại mặt hàng nào đó: khung giá đất đền bù",
    example: "khung giá đất đền bù",
  },
  {
    word: "khủng hoảng",
    part_of_speech: "",
    meaning:
      "tình trạng rối loạn, mất thăng bằng nghiêm trọng do có nhiều mâu thuẫn không được hoặc chưa được giải quyết: khủng hoảng kinh tế * tinh thần bị khủng hoảng",
    example: "khủng hoảng kinh tế * tinh thần bị khủng hoảng",
  },
  {
    word: "khủng hoảng",
    part_of_speech: "",
    meaning:
      "tình trạng thiếu hụt gây ra mất thăng bằng nghiêm trọng: khủng hoảng nhân công * khủng hoảng năng lượng",
    example: "khủng hoảng nhân công * khủng hoảng năng lượng",
  },
  {
    word: "khụng khiệng",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả dáng bộ cố làm ra vẻ oai vệ, trông giả tạo, khó coi: dáng đi khụng khiệng",
    example: "dáng đi khụng khiệng",
  },
  {
    word: "khúng khắng",
    part_of_speech: "tính từ",
    meaning: "như húng hắng: khúng khắng ho",
    example: "khúng khắng ho",
  },
  {
    word: "khùng khục",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng như tiếng cười, tiếng ho mạnh, liên tiếp bị bật ra sau khi đã cố nén trong cổ họng: phát ra tiếng cười khùng khục từ trong cổ họng",
    example: "phát ra tiếng cười khùng khục từ trong cổ họng",
  },
  {
    word: "khuôn dạng",
    part_of_speech: "danh từ",
    meaning:
      "cách bố trí dữ liệu theo một dạng thức nhất định (theo một hình thức, một kiểu tồn tại): văn bản không hiển thị được do không hợp khuôn dạng",
    example: "văn bản không hiển thị được do không hợp khuôn dạng",
  },
  {
    word: "khủng khỉnh",
    part_of_speech: "động từ",
    meaning:
      'như ngủng nghỉnh: "Xưa kia ăn những của chồng, Kiếm được một đồng khủng khỉnh ăn riêng." (ca dao)',
    example:
      'Xưa kia ăn những của chồng, Kiếm được một đồng khủng khỉnh ăn riêng." (ca dao)',
  },
  {
    word: "khủng khiếp",
    part_of_speech: "",
    meaning:
      "hoảng sợ hoặc làm cho hoảng sợ ở mức rất cao: tai hoạ khủng khiếp * căn bệnh khủng khiếp",
    example: "tai hoạ khủng khiếp * căn bệnh khủng khiếp",
  },
  {
    word: "khủng khiếp",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) ở mức độ cao, tới mức dường như không chịu đựng được: phóng xe nhanh khủng khiếp * xấu khủng khiếp",
    example: "phóng xe nhanh khủng khiếp * xấu khủng khiếp",
  },
  {
    word: "khuôn khổ",
    part_of_speech: "danh từ",
    meaning:
      "hình dạng và kích thước (nói khái quát): bức tranh có khuôn khổ vừa phải * khuôn khổ của cuốn sách",
    example: "bức tranh có khuôn khổ vừa phải * khuôn khổ của cuốn sách",
  },
  {
    word: "khuôn khổ",
    part_of_speech: "danh từ",
    meaning:
      "khoảng được giới hạn hay được quy ước chặt chẽ, thường phải tuân theo: khép mình trong khuôn khổ lễ giáo * đưa vào khuôn khổ",
    example: "khép mình trong khuôn khổ lễ giáo * đưa vào khuôn khổ",
  },
  {
    word: "khuôn mặt",
    part_of_speech: "danh từ",
    meaning: "dáng vẻ mặt người: khuôn mặt trái xoan",
    example: "khuôn mặt trái xoan",
  },
  {
    word: "khuôn",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ tạo hình để tạo ra những vật có một hình dạng nhất định giống hệt nhau: khuôn bánh * giống nhau như đúc một khuôn * rót vàng vào khuôn",
    example: "khuôn bánh * giống nhau như đúc một khuôn * rót vàng vào khuôn",
  },
  {
    word: "khuôn",
    part_of_speech: "danh từ",
    meaning:
      "hình dáng với những đặc trưng cho một kiểu nào đó (thường nói về mặt hoặc một vài bộ phận khác của cơ thể): khuôn ngực nở nang",
    example: "khuôn ngực nở nang",
  },
  {
    word: "khuôn",
    part_of_speech: "động từ",
    meaning:
      "giới hạn trong khuôn khổ nhất định: sống khuôn mình, khép kín * mái tóc ngắn khuôn lấy gương mặt",
    example: "sống khuôn mình, khép kín * mái tóc ngắn khuôn lấy gương mặt",
  },
  {
    word: "khuôn mẫu",
    part_of_speech: "danh từ",
    meaning:
      "khuôn, mẫu (nói khái quát): làm theo khuôn mẫu cho sẵn * khuôn mẫu người phụ nữ truyền thống",
    example: "làm theo khuôn mẫu cho sẵn * khuôn mẫu người phụ nữ truyền thống",
  },
  {
    word: "khuôn thiêng",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) trời, coi như cái khuôn lớn đúc nên muôn vật trong vũ trụ, theo quan niệm thời xưa: "Khuôn thiêng dù phụ tấc thành, Cũng liều bỏ quá xuân xanh một đời." (TKiều)',
    example:
      'Khuôn thiêng dù phụ tấc thành, Cũng liều bỏ quá xuân xanh một đời." (TKiều)',
  },
  {
    word: "khuôn thức",
    part_of_speech: "danh từ",
    meaning:
      "hình thức thể hiện được dùng làm khuôn mẫu: quy định nhiều loại khuôn thức cho cùng một văn bản",
    example: "quy định nhiều loại khuôn thức cho cùng một văn bản",
  },
  {
    word: "khuôn xanh",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) như khuôn thiêng: "Nghĩ mình phận mỏng cánh chuồn, Khuôn xanh biết có vuông tròn mà hay?" (TKiều)',
    example:
      'Nghĩ mình phận mỏng cánh chuồn, Khuôn xanh biết có vuông tròn mà hay?" (TKiều)',
  },
  {
    word: "khuôn sáo",
    part_of_speech: "danh từ",
    meaning:
      "cái đã được nhiều người dùng lặp đi lặp lại nhiều lần, trở thành máy móc, nhàm chán (thường nói về lối diễn đạt): lối hành văn khuôn sáo * lời nói khuôn sáo",
    example: "lối hành văn khuôn sáo * lời nói khuôn sáo",
  },
  {
    word: "khuôn phép",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ nói chung những phép tắc, chuẩn mực cần phải theo trong quan hệ xã hội, gia đình: ăn ở cho đúng khuôn phép * không chịu theo khuôn phép",
    example: "ăn ở cho đúng khuôn phép * không chịu theo khuôn phép",
  },
  {
    word: "khuông",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp năm đường kẻ song song cách đều nhau để ghi nốt và dấu nhạc: kẻ khuông nhạc",
    example: "kẻ khuông nhạc",
  },
  {
    word: "khuông",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ)",
    example: "khuông ảnh",
  },
  {
    word: "khuỵ",
    part_of_speech: "động từ",
    meaning:
      "gập chân lại, không đứng thẳng nữa: khuỵu chân lấy đà * hơi khuỵu gối xuống để chào",
    example: "khuỵu chân lấy đà * hơi khuỵu gối xuống để chào",
  },
  {
    word: "khuỵ",
    part_of_speech: "động từ",
    meaning:
      "(cũng khuỵ) gập hẳn chân xuống, không đứng thẳng lên được nữa, do bị trượt ngã hoặc do không còn sức: ngã khuỵu",
    example: "ngã khuỵu",
  },
  {
    word: "khuya",
    part_of_speech: "tính từ",
    meaning:
      'muộn về đêm: thức khuya dậy sớm * "Anh buồn có chốn thở than, Em buồn như ngọn đèn tàn thắp khuya." (ca dao)',
    example:
      'thức khuya dậy sớm * "Anh buồn có chốn thở than, Em buồn như ngọn đèn tàn thắp khuya." (ca dao)',
  },
  {
    word: "khuya",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian từ nửa đêm đến gần sáng: một giờ khuya * đi từ mờ sáng đến khuya mới về",
    example: "một giờ khuya * đi từ mờ sáng đến khuya mới về",
  },
  {
    word: "khuya sớm",
    part_of_speech: "danh từ",
    meaning:
      'như sớm khuya: "Nước lên xấp xỉ cây bần, Anh thấy em khuya sớm tảo tần, anh thương." (ca dao)',
    example:
      'Nước lên xấp xỉ cây bần, Anh thấy em khuya sớm tảo tần, anh thương." (ca dao)',
  },
  {
    word: "khuya khoắt",
    part_of_speech: "tính từ",
    meaning: "khuya (nói khái quát): đêm hôm khuya khoắt",
    example: "đêm hôm khuya khoắt",
  },
  {
    word: "khụt khịt",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng thở ra hít vào qua đường mũi do mũi bị tắc hay bị ngạt: thở khụt khịt",
    example: "thở khụt khịt",
  },
  {
    word: "khuyên",
    part_of_speech: "động từ",
    meaning:
      "vẽ khuyên tròn (thường để phê khen hay bài làm văn chữ nho ngày xưa): khuyên một vòng đỏ * khuyên những câu văn hay",
    example: "khuyên một vòng đỏ * khuyên những câu văn hay",
  },
  {
    word: "khuyên",
    part_of_speech: "động từ",
    meaning:
      "nói với thái độ ân cần cho người khác biết điều mình cho là người đó nên làm: khuyên con nên cố gắng",
    example: "khuyên con nên cố gắng",
  },
  {
    word: "khuơ",
    part_of_speech: "động từ",
    meaning: "(phương ngữ): khuơ gậy tìm lối đi",
    example: "khuơ gậy tìm lối đi",
  },
  {
    word: "khuy",
    part_of_speech: "danh từ",
    meaning:
      "vật nhỏ làm bằng nhựa, kim loại, thuỷ tinh, xương, vv, thường có hình tròn, dùng đính vào quần áo để cài: đơm khuy * cài khuy * áo mất một cái khuy",
    example: "đơm khuy * cài khuy * áo mất một cái khuy",
  },
  {
    word: "khuyên bảo",
    part_of_speech: "động từ",
    meaning:
      "bảo với thái độ ân cần cho biết điều hay lẽ phải, điều nên làm hoặc không nên làm (nói khái quát): lựa lời khuyên bảo",
    example: "lựa lời khuyên bảo",
  },
  {
    word: "khuyên can",
    part_of_speech: "động từ",
    meaning:
      'lựa lời bảo cho biết là không nên làm, để tránh phạm sai lầm: "Vội vàng, kẻ giữ người coi, Nhỏ to, nàng lại tìm lời khuyên can." (TKiều)',
    example:
      'Vội vàng, kẻ giữ người coi, Nhỏ to, nàng lại tìm lời khuyên can." (TKiều)',
  },
  {
    word: "khuyến cáo",
    part_of_speech: "",
    meaning:
      "đưa ra lời khuyên (thường là công khai và cho số đông): khuyến cáo không nên dùng thuốc lá",
    example: "khuyến cáo không nên dùng thuốc lá",
  },
  {
    word: "khuyên dỗ",
    part_of_speech: "động từ",
    meaning:
      "khuyên bảo bằng những lời dỗ dành nhẹ nhàng: khuyên dỗ con học hành",
    example: "khuyên dỗ con học hành",
  },
  {
    word: "khuyên giáo",
    part_of_speech: "động từ",
    meaning:
      "quyên góp tiền của để làm những công việc về đạo Phật: khuyên giáo để đúc tượng",
    example: "khuyên giáo để đúc tượng",
  },
  {
    word: "khuyến khích",
    part_of_speech: "động từ",
    meaning:
      "tác động đến tinh thần để gây phấn khởi, tin tưởng mà cố gắng hơn: khuyến khích các em học tập * giải khuyến khích",
    example: "khuyến khích các em học tập * giải khuyến khích",
  },
  {
    word: "khuyến khích",
    part_of_speech: "động từ",
    meaning:
      "tạo điều kiện thuận lợi để phát triển mạnh mẽ hơn: khuyến khích phát triển các ngành nghề thủ công mĩ nghệ",
    example: "khuyến khích phát triển các ngành nghề thủ công mĩ nghệ",
  },
  {
    word: "khuyến học",
    part_of_speech: "động từ",
    meaning:
      "khuyến khích và giúp đỡ việc học tập: hội khuyến học * lập quỹ khuyến học",
    example: "hội khuyến học * lập quỹ khuyến học",
  },
  {
    word: "khuyên giải",
    part_of_speech: "động từ",
    meaning:
      'lựa lời nói cho hiểu lẽ mà nguôi buồn, nguôi giận: lựa lời khuyên giải * "Dỗ dành khuyên giải trăm chiều, Lửa phiền càng dập, càng khêu mối phiền." (TKiều)',
    example:
      'lựa lời khuyên giải * "Dỗ dành khuyên giải trăm chiều, Lửa phiền càng dập, càng khêu mối phiền." (TKiều)',
  },
  {
    word: "khuyến lâm",
    part_of_speech: "động từ",
    meaning:
      "khuyến khích, hỗ trợ phát triển lâm nghiệp: có chính sách khuyến lâm, khuyến ngư",
    example: "có chính sách khuyến lâm, khuyến ngư",
  },
  {
    word: "khuyên lơn",
    part_of_speech: "động từ",
    meaning:
      "khuyên bảo, dỗ dành bằng những lời lẽ dịu dàng, tha thiết: khuyên lơn mãi nó mới chịu nghe",
    example: "khuyên lơn mãi nó mới chịu nghe",
  },
  {
    word: "khuyến ngư",
    part_of_speech: "động từ",
    meaning:
      "khuyến khích, hỗ trợ phát triển ngư nghiệp: trung tâm khuyến ngư của tỉnh * có chính sách khuyến ngư hợp lí",
    example: "trung tâm khuyến ngư của tỉnh * có chính sách khuyến ngư hợp lí",
  },
  {
    word: "khuyên nhủ",
    part_of_speech: "động từ",
    meaning:
      "khuyên bảo bằng những lời lẽ dịu dàng: ân cần khuyên nhủ * cô giáo khuyên nhủ học trò",
    example: "ân cần khuyên nhủ * cô giáo khuyên nhủ học trò",
  },
  {
    word: "khuyên răn",
    part_of_speech: "động từ",
    meaning: "khuyên nhủ và răn đe (nói khái quát): khuyên răn con cái",
    example: "khuyên răn con cái",
  },
  {
    word: "khuyết",
    part_of_speech: "danh từ",
    meaning: "lỗ hoặc vòng để cài khuy trên quần áo: thùa khuyết * bấm khuyết",
    example: "thùa khuyết * bấm khuyết",
  },
  {
    word: "khuyết",
    part_of_speech: "danh từ",
    meaning:
      "không đầy đủ vì thiếu mất một phần, một bộ phận: vầng trăng khuyết * còn khuyết một chân trong ban lãnh đạo",
    example: "vầng trăng khuyết * còn khuyết một chân trong ban lãnh đạo",
  },
  {
    word: "khuyết",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) khuyết điểm (nói tắt): có cả ưu lẫn khuyết",
    example: "có cả ưu lẫn khuyết",
  },
  {
    word: "khuyến nghị",
    part_of_speech: "",
    meaning:
      "đưa ra lời khuyên, lời đề nghị với thái độ trân trọng: khuyến nghị với các cơ quan chức năng",
    example: "khuyến nghị với các cơ quan chức năng",
  },
  {
    word: "khuyến nông",
    part_of_speech: "động từ",
    meaning:
      "khuyến khích, hỗ trợ phát triển nông nghiệp: chính sách khuyến nông * làm công tác khuyến nông",
    example: "chính sách khuyến nông * làm công tác khuyến nông",
  },
  {
    word: "khuyến nông",
    part_of_speech: "động từ",
    meaning:
      "có tác dụng tạo điều kiện thuận lợi cho sản xuất nông nghiệp: con đê khuyến nông",
    example: "con đê khuyến nông",
  },
  {
    word: "khuyến tài",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) khuyến khích và bồi dưỡng người có tài năng: công tác khuyến học, khuyến tài",
    example: "công tác khuyến học, khuyến tài",
  },
  {
    word: "khuyết danh",
    part_of_speech: "tính từ",
    meaning:
      "không có tên tác giả, không biết tác giả là ai: truyện Nôm khuyết danh * tác phẩm khuyết danh",
    example: "truyện Nôm khuyết danh * tác phẩm khuyết danh",
  },
  {
    word: "khuyến thiện",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) khuyến khích làm việc thiện, việc lành: phát động phong trào nhằm mục đích khuyến thiện",
    example: "phát động phong trào nhằm mục đích khuyến thiện",
  },
  {
    word: "khuyết tật",
    part_of_speech: "danh từ",
    meaning:
      "sai sót vốn có trên sản phẩm ngay sau khi chế tạo, gia công xong: khắc phục một số khuyết tật trên sản phẩm gốm mới ra lò",
    example: "khắc phục một số khuyết tật trên sản phẩm gốm mới ra lò",
  },
  {
    word: "khuyết tật",
    part_of_speech: "danh từ",
    meaning: "tật bẩm sinh: trẻ khuyết tật",
    example: "trẻ khuyết tật",
  },
  {
    word: "khuyết điểm",
    part_of_speech: "danh từ",
    meaning:
      "điều thiếu sót, điều sai trong hành động, suy nghĩ hoặc tư cách: mắc khuyết điểm * khuyết điểm của nó là chủ quan",
    example: "mắc khuyết điểm * khuyết điểm của nó là chủ quan",
  },
  {
    word: "khuỳnh",
    part_of_speech: "động từ",
    meaning:
      "(tay, chân) vòng rộng ra và gập cong lại: khuỳnh tay chống nạnh * đứng khuỳnh chân như xuống tấn",
    example: "khuỳnh tay chống nạnh * đứng khuỳnh chân như xuống tấn",
  },
  {
    word: "khuyết thiếu",
    part_of_speech: "",
    meaning:
      "thiếu, chưa trọn vẹn, chưa đầy đủ (nói khái quát): khắc phục điểm khuyết thiếu ở mỗi cá nhân",
    example: "khắc phục điểm khuyết thiếu ở mỗi cá nhân",
  },
  {
    word: "khuynh đảo",
    part_of_speech: "động từ",
    meaning:
      "làm cho lung lay, nghiêng ngả: bọn tư sản khuynh đảo lẫn nhau * làm khuynh đảo tình thế",
    example: "bọn tư sản khuynh đảo lẫn nhau * làm khuynh đảo tình thế",
  },
  {
    word: "khuỷnh",
    part_of_speech: "danh từ",
    meaning: "khoảnh nhỏ hoặc khúc đường nhỏ: một khuỷnh đất bên bờ sông",
    example: "một khuỷnh đất bên bờ sông",
  },
  {
    word: "khuynh hướng",
    part_of_speech: "danh từ",
    meaning:
      "sự thiên về một phía nào đó trong hoạt động, trong quá trình phát triển: khuynh hướng cải lương * khuynh hướng phát triển của nền kinh tế thị trường",
    example:
      "khuynh hướng cải lương * khuynh hướng phát triển của nền kinh tế thị trường",
  },
  {
    word: "khuynh thành",
    part_of_speech: "động từ",
    meaning:
      '(cũ, văn chương) như khuynh quốc khuynh thành: "Nàng đà có sắc khuynh thành, Lại thêm rất bực tài tình hào hoa." (LVT)',
    example:
      'Nàng đà có sắc khuynh thành, Lại thêm rất bực tài tình hào hoa." (LVT)',
  },
  {
    word: "khuỷu",
    part_of_speech: "danh từ",
    meaning:
      "chỗ lồi ra của khớp xương giữa cánh tay và cẳng tay: xắn áo đến tận khuỷu * trói giật cánh khuỷu",
    example: "xắn áo đến tận khuỷu * trói giật cánh khuỷu",
  },
  {
    word: "khuỷu",
    part_of_speech: "danh từ",
    meaning: "chỗ uốn cong, gần như gấp khúc lại: khuỷu sông",
    example: "khuỷu sông",
  },
  {
    word: "khuýp",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) khép chặt lại: khuýp chặt hai chân lại",
    example: "khuýp chặt hai chân lại",
  },
  {
    word: "khuýp",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như khớp (ng4): đối chiếu các số liệu, thấy rất khuýp",
    example: "đối chiếu các số liệu, thấy rất khuýp",
  },
  {
    word: "khuỵu",
    part_of_speech: "động từ",
    meaning:
      "gập chân lại, không đứng thẳng nữa: khuỵu chân lấy đà * hơi khuỵu gối xuống để chào",
    example: "khuỵu chân lấy đà * hơi khuỵu gối xuống để chào",
  },
  {
    word: "khuỵu",
    part_of_speech: "động từ",
    meaning:
      "(cũng khuỵ) gập hẳn chân xuống, không đứng thẳng lên được nữa, do bị trượt ngã hoặc do không còn sức: ngã khuỵu",
    example: "ngã khuỵu",
  },
  {
    word: "khừ khừ",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng những tiếng rên trầm, đục từ trong cổ họng của người ốm: rét quá, rên khừ khừ suốt đêm",
    example: "rét quá, rên khừ khừ suốt đêm",
  },
  {
    word: "khư khư",
    part_of_speech: "",
    meaning:
      "từ gợi tả vẻ một mực giữ chặt lấy, không chịu rời ra, không muốn cho ai động đến: ôm khư khư cái bọc * khư khư với lề lối cũ * khư khư như từ giữ oản (tng)",
    example:
      "ôm khư khư cái bọc * khư khư với lề lối cũ * khư khư như từ giữ oản (tng)",
  },
  {
    word: "khử",
    part_of_speech: "động từ",
    meaning: "làm cho mất đi để loại bỏ tác dụng: khử chua cho đất",
    example: "khử chua cho đất",
  },
  {
    word: "khử",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) giết kẻ coi là nguy hiểm: khử tên ác ôn khét tiếng",
    example: "khử tên ác ôn khét tiếng",
  },
  {
    word: "khử",
    part_of_speech: "động từ",
    meaning:
      "làm giảm hoá trị của một nguyên tố bằng cách thêm electron vào nguyên tố đó: phản ứng oxy hoá khử",
    example: "phản ứng oxy hoá khử",
  },
  {
    word: "khứ hồi",
    part_of_speech: "phụ từ",
    meaning:
      "cả đi lẫn về trên cùng một đường, cùng một phương thức: vé máy bay khứ hồi * chuyển động khứ hồi",
    example: "vé máy bay khứ hồi * chuyển động khứ hồi",
  },
  {
    word: "khử trùng",
    part_of_speech: "động từ",
    meaning:
      "trừ bỏ vi trùng: khử trùng dụng cụ y tế * luộc bình sữa để khử trùng",
    example: "khử trùng dụng cụ y tế * luộc bình sữa để khử trùng",
  },
  {
    word: "khứa",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) cứa: lấy dao khứa một vạch để đánh dấu",
    example: "lấy dao khứa một vạch để đánh dấu",
  },
  {
    word: "khứa",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) khúc hoặc khoanh cá được cứa ra, cắt ra: mua một khứa cá",
    example: "mua một khứa cá",
  },
  {
    word: "khước",
    part_of_speech: "danh từ",
    meaning:
      "điều tốt lành, phúc lành do vật nào đó mang lại, theo quan niệm dân gian: ăn lộc để lấy khước",
    example: "ăn lộc để lấy khước",
  },
  {
    word: "khựng",
    part_of_speech: "động từ",
    meaning:
      "ngừng lại một cách đột ngột do phải chịu một tác động hoàn toàn bất ngờ: xe đang đi thì chết máy, khựng lại giữa đường",
    example: "xe đang đi thì chết máy, khựng lại giữa đường",
  },
  {
    word: "khước từ",
    part_of_speech: "động từ",
    meaning: "từ chối không nhận: khước từ sự giúp đỡ",
    example: "khước từ sự giúp đỡ",
  },
  {
    word: "khượt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có vẻ mệt mỏi, chán nản đến mức không còn muốn cử động chân tay: nằm khượt ra giường * thở dài khượt",
    example: "nằm khượt ra giường * thở dài khượt",
  },
  {
    word: "khứu giác",
    part_of_speech: "danh từ",
    meaning: "cảm giác nhận biết được các mùi: mũi là cơ quan khứu giác",
    example: "mũi là cơ quan khứu giác",
  },
  {
    word: "khướt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) mệt lắm, vất vả lắm: còn khướt mới xong * gánh đầy được bể nước cũng đủ khướt",
    example: "còn khướt mới xong * gánh đầy được bể nước cũng đủ khướt",
  },
  {
    word: "khướt",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) từ biểu thị mức độ rất cao của một tính chất: còn xa khướt * uống rượu say khướt",
    example: "còn xa khướt * uống rượu say khướt",
  },
  {
    word: "khướu",
    part_of_speech: "danh từ",
    meaning:
      "chim cỡ bằng chim sáo, lông đen, cánh ngắn, đuôi dài, hay hót: hót như khướu",
    example: "hót như khướu",
  },
  {
    word: "ki",
    part_of_speech: "danh từ",
    meaning:
      'đồ dùng có hình giống như cái gàu sòng, thường đan bằng tre, để xúc và chuyển đất đá: "Ngẫm xem thế sự mà rầu, ở giữa đòn gánh, hai đầu đôi ki." (ca dao)',
    example:
      'Ngẫm xem thế sự mà rầu, ở giữa đòn gánh, hai đầu đôi ki." (ca dao)',
  },
  {
    word: "ki",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) ki bo (nói tắt): khiếp, người đâu mà ki thế!",
    example: "khiếp, người đâu mà ki thế!",
  },
  {
    word: "kỉ",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị thời gian địa chất, bậc dưới của đại, dài từ hàng triệu đến hàng chục triệu năm: kỉ băng hà * loài người xuất hiện từ đầu kỉ đệ tứ, cách đây khoảng một triệu năm",
    example:
      "kỉ băng hà * loài người xuất hiện từ đầu kỉ đệ tứ, cách đây khoảng một triệu năm",
  },
  {
    word: "kí",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ, khẩu ngữ) kilogram (nói tắt): mua một kí cam * vài kí gạo nếp",
    example: "mua một kí cam * vài kí gạo nếp",
  },
  {
    word: "kí",
    part_of_speech: "danh từ",
    meaning:
      "thể văn tự sự viết về người thật, việc thật, có tính chất thời sự, trung thành với hiện thực đến mức cao nhất: bài kí",
    example: "bài kí",
  },
  {
    word: "kí",
    part_of_speech: "động từ",
    meaning:
      "kí tên (nói tắt): kí vào biên bản nộp phạt * nhận tiền nhưng chưa kí",
    example: "kí vào biên bản nộp phạt * nhận tiền nhưng chưa kí",
  },
  {
    word: "kí",
    part_of_speech: "động từ",
    meaning:
      "(người có đủ quyền hạn) kí tên mình vào một văn kiện để làm cho nó có giá trị pháp lí, có hiệu lực: kí hoà ước * kí quyết định cho thôi việc * văn bản có hiệu lực từ ngày kí",
    example:
      "kí hoà ước * kí quyết định cho thôi việc * văn bản có hiệu lực từ ngày kí",
  },
  {
    word: "kĩ",
    part_of_speech: "tính từ",
    meaning:
      "(làm việc gì) có sự chú ý đầy đủ đến từng chi tiết nhỏ, không hoặc rất ít để có sai sót: đọc kĩ đề bài trước khi làm * suy nghĩ kĩ trước khi nói * quyển sách được biên tập rất kĩ",
    example:
      "đọc kĩ đề bài trước khi làm * suy nghĩ kĩ trước khi nói * quyển sách được biên tập rất kĩ",
  },
  {
    word: "kĩ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (làm việc gì) một cách công phu hoặc với thời gian lâu để có hiệu quả cao hơn: giấu cho thật kĩ * nhai kĩ no lâu, cày sâu tốt lúa (tng)",
    example: "giấu cho thật kĩ * nhai kĩ no lâu, cày sâu tốt lúa (tng)",
  },
  {
    word: "kị",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) giỗ: nhà có kị",
    example: "nhà có kị",
  },
  {
    word: "kị",
    part_of_speech: "động từ",
    meaning:
      "có những yếu tố hoàn toàn không hợp nhau, đến mức không thể cùng tồn tại, cái này tiếp xúc với cái kia thì tất sẽ gây tác hại: hai thứ thuốc này kị nhau * xăng kị lửa",
    example: "hai thứ thuốc này kị nhau * xăng kị lửa",
  },
  {
    word: "kị",
    part_of_speech: "động từ",
    meaning:
      "hết sức tránh mặt nhau vì hoàn toàn không hợp, hoặc tránh không làm vì hoàn toàn không nên: hai người kị nhau như mặt trăng với mặt trời",
    example: "hai người kị nhau như mặt trăng với mặt trời",
  },
  {
    word: "kị",
    part_of_speech: "động từ",
    meaning:
      "tránh không nói đến hoặc không làm gì phạm đến, vì cho là linh thiêng, theo tôn giáo, tín ngưỡng: kị huý * kị gọi tên cúng cơm người khác",
    example: "kị huý * kị gọi tên cúng cơm người khác",
  },
  {
    word: "kì ảo",
    part_of_speech: "tính từ",
    meaning:
      "có vẻ đẹp kì lạ, tựa như chỉ có trong tưởng tượng, không có thật: ánh sáng kì ảo * vẻ đẹp lung linh kì ảo",
    example: "ánh sáng kì ảo * vẻ đẹp lung linh kì ảo",
  },
  {
    word: "kì bí",
    part_of_speech: "tính từ",
    meaning: "kì lạ và bí ẩn đến mức khó hiểu: những hang động đầy vẻ kì bí",
    example: "những hang động đầy vẻ kì bí",
  },
  {
    word: "kì",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) vây cá: cá giương kì",
    example: "cá giương kì",
  },
  {
    word: "kì",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian nhất định xảy ra tương đối đều đặn của một hiện tượng tự nhiên nào đó hoặc thực hiện tương đối đều đặn một việc nào đó theo quy định: một năm học gồm có hai kì * sáu tháng họp một kì * kì thi đại học",
    example:
      "một năm học gồm có hai kì * sáu tháng họp một kì * kì thi đại học",
  },
  {
    word: "kì",
    part_of_speech: "động từ",
    meaning:
      "dùng tay hoặc vật nào đó xát qua xát lại nhiều lần làm cho sạch lớp bẩn bám ngoài da: kì lưng * kì cho sạch ghét",
    example: "kì lưng * kì cho sạch ghét",
  },
  {
    word: "kì",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) lạ đến mức làm người ta phải ngạc nhiên: câu chuyện nghe có vẻ rất kì * tính cô ta hơi kì",
    example: "câu chuyện nghe có vẻ rất kì * tính cô ta hơi kì",
  },
  {
    word: "kì",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là kết quả nhằm đạt cho được mới thôi của việc vừa nói đến: làm cho kì xong mới thôi * đòi cho kì được",
    example: "làm cho kì xong mới thôi * đòi cho kì được",
  },
  {
    word: "kị binh",
    part_of_speech: "danh từ",
    meaning: "binh chủng chuyên cưỡi ngựa để chiến đấu: đội kị binh",
    example: "đội kị binh",
  },
  {
    word: "kí chủ",
    part_of_speech: "danh từ",
    meaning:
      "sinh vật mang các loài kí sinh: bọ chét sống kí sinh trên một số vật chủ như mèo, chó, v.v",
    example: "bọ chét sống kí sinh trên một số vật chủ như mèo, chó, v.v",
  },
  {
    word: "ki bo",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) rất bủn xỉn, chỉ biết bo bo giữ của: đồ ki bo! * ông ta giàu nhưng ki bo lắm",
    example: "đồ ki bo! * ông ta giàu nhưng ki bo lắm",
  },
  {
    word: "kì cạch",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả tiếng phát ra nghe trầm, không đều nhưng liên tiếp do các vật cứng va chạm nhau trong hoạt động lao động thủ công: tiếng đập sắt kì cạch",
    example: "tiếng đập sắt kì cạch",
  },
  {
    word: "kì cạch",
    part_of_speech: "động từ",
    meaning:
      "làm việc gì, thường là lao động chân tay, hí hoáy trong thời gian khá lâu: kì cạch chữa chiếc xe đạp hỏng",
    example: "kì cạch chữa chiếc xe đạp hỏng",
  },
  {
    word: "kì cọ",
    part_of_speech: "động từ",
    meaning:
      "làm cho sạch lớp bẩn bám ở ngoài da, ở mặt ngoài, bằng cách xát đi xát lại: kì cọ tay chân * kì cọ nồi niêu, bát đĩa",
    example: "kì cọ tay chân * kì cọ nồi niêu, bát đĩa",
  },
  {
    word: "kí cả hai tay",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) hoàn toàn tán thành một cách vui vẻ: được như vậy thì tôi xin kí cả hai tay",
    example: "được như vậy thì tôi xin kí cả hai tay",
  },
  {
    word: "kĩ càng",
    part_of_speech: "tính từ",
    meaning:
      "kĩ (nói khái quát): chọn lựa kĩ càng * kiểm tra lại một cách kĩ càng",
    example: "chọn lựa kĩ càng * kiểm tra lại một cách kĩ càng",
  },
  {
    word: "kì công",
    part_of_speech: "danh từ",
    meaning:
      "công lao, sự nghiệp hoặc thành tựu lớn, hiếm có: chiến thắng Bạch Đằng là kì công vang dội của ông cha ta",
    example: "chiến thắng Bạch Đằng là kì công vang dội của ông cha ta",
  },
  {
    word: "kì công",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (làm việc gì) đòi hỏi phải bỏ vào nhiều công sức một cách đặc biệt, khác thường: những chiếc gối thêu rất kì công * phải kì công lắm mới tạc được bức tượng này",
    example:
      "những chiếc gối thêu rất kì công * phải kì công lắm mới tạc được bức tượng này",
  },
  {
    word: "kỉ cương",
    part_of_speech: "danh từ",
    meaning:
      "những phép tắc làm nên trật tự của một xã hội (nói tổng quát): giữ vững kỉ cương * kỉ cương phép nước",
    example: "giữ vững kỉ cương * kỉ cương phép nước",
  },
  {
    word: "ki cóp",
    part_of_speech: "động từ",
    meaning:
      "gom góp từng tí một để dồn lại thành món lớn: ki cóp được một số vốn kha khá",
    example: "ki cóp được một số vốn kha khá",
  },
  {
    word: "kí cược",
    part_of_speech: "động từ",
    meaning: "(cũ) như đặt cọc: kí cược trước tiền mua nhà",
    example: "kí cược trước tiền mua nhà",
  },
  {
    word: "kì đài",
    part_of_speech: "danh từ",
    meaning: "đài cao có cột cờ: lá cờ tổ quốc phấp phới trên kì đài",
    example: "lá cờ tổ quốc phấp phới trên kì đài",
  },
  {
    word: "kì cục",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bỏ nhiều thì giờ và công phu làm việc gì một cách vất vả: kì cục nhờ người dắt mối * kì cục tháo lắp suốt cả buổi",
    example: "kì cục nhờ người dắt mối * kì cục tháo lắp suốt cả buổi",
  },
  {
    word: "kì cục",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) khác với những gì thường thấy, đến mức như vô lí, khó hiểu: tính nết kì cục * nói năng rất kì cục",
    example: "tính nết kì cục * nói năng rất kì cục",
  },
  {
    word: "kì cùng",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) đến tận cùng mới thôi, không bỏ dở nửa chừng: phản đối kì cùng * chống cự cho đến kì cùng",
    example: "phản đối kì cùng * chống cự cho đến kì cùng",
  },
  {
    word: "kì dị",
    part_of_speech: "tính từ",
    meaning:
      "khác hẳn với những gì thường thấy, đến mức lạ lùng: hình thù kì dị",
    example: "hình thù kì dị",
  },
  {
    word: "kì diệu",
    part_of_speech: "tính từ",
    meaning:
      "có cái gì vừa rất lạ lùng như không cắt nghĩa nổi, vừa làm cho người ta phải ca ngợi, phải khâm phục: một phát minh kì diệu * khả năng kì diệu của khoa học",
    example: "một phát minh kì diệu * khả năng kì diệu của khoa học",
  },
  {
    word: "kí gửi",
    part_of_speech: "động từ",
    meaning:
      "gửi hàng cho một cửa hàng để nhờ bán, theo những thoả thuận nhất định: sách kí gửi * cửa hàng mua bán, kí gửi",
    example: "sách kí gửi * cửa hàng mua bán, kí gửi",
  },
  {
    word: "kì cựu",
    part_of_speech: "",
    meaning:
      "lâu năm trong nghề: nhà ngoại giao kì cựu * một tay kì cựu trong làng báo",
    example: "nhà ngoại giao kì cựu * một tay kì cựu trong làng báo",
  },
  {
    word: "kí hoạ",
    part_of_speech: "danh từ",
    meaning:
      "tranh vẽ ghi nhanh, phác hoạ những nét cơ bản nhất của sự vật: bức kí hoạ",
    example: "bức kí hoạ",
  },
  {
    word: "kí hoạ",
    part_of_speech: "động từ",
    meaning: "vẽ ghi nhanh: kí hoạ phong cảnh làng quê * kí hoạ chân dung",
    example: "kí hoạ phong cảnh làng quê * kí hoạ chân dung",
  },
  {
    word: "kì kèo",
    part_of_speech: "động từ",
    meaning:
      "nói đi nói lại nhiều lần để phàn nàn hay đòi cho bằng được điều gì: kì kèo xin cho bằng được * tính  hay kì kèo * mua bán kì kèo",
    example: "kì kèo xin cho bằng được * tính  hay kì kèo * mua bán kì kèo",
  },
  {
    word: "kí hiệu",
    part_of_speech: "danh từ",
    meaning:
      "dấu hiệu vật chất đơn giản, do quan hệ tự nhiên hoặc do quy ước, được coi như thay cho một thực tế phức tạp hơn: chữ viết là một loại kí hiệu",
    example: "chữ viết là một loại kí hiệu",
  },
  {
    word: "kí hiệu",
    part_of_speech: "động từ",
    meaning: "biểu thị bằng kí hiệu: kí hiệu bằng dấu hoa thị",
    example: "kí hiệu bằng dấu hoa thị",
  },
  {
    word: "kí kết",
    part_of_speech: "động từ",
    meaning:
      "cùng nhau kí vào một văn bản để chính thức công nhận những điều hai bên đã thoả thuận: kí kết hiệp định * kí kết hợp đồng lao động",
    example: "kí kết hiệp định * kí kết hợp đồng lao động",
  },
  {
    word: "kì hạn",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian quy định cho một công việc gì: gửi tiết kiệm theo kì hạn 3 tháng * đã hết kì hạn nộp hồ sơ",
    example: "gửi tiết kiệm theo kì hạn 3 tháng * đã hết kì hạn nộp hồ sơ",
  },
  {
    word: "kị khí",
    part_of_speech: "tính từ",
    meaning:
      "(sinh vật hoặc quá trình sinh học) chỉ sống và hoạt động, tác động được trong môi trường không có không khí; phân biệt với háo khí: sinh vật yếm khí * xử lí rác bằng công nghệ ủ yếm khí",
    example: "sinh vật yếm khí * xử lí rác bằng công nghệ ủ yếm khí",
  },
  {
    word: "kì hào",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người có địa vị và quyền thế ở làng xã thời phong kiến: bọn kì hào trong làng",
    example: "bọn kì hào trong làng",
  },
  {
    word: "kì khôi",
    part_of_speech: "tính từ",
    meaning:
      "lạ và ngộ nghĩnh đến buồn cười: tính nết kì khôi * ăn mặc rất kì khôi",
    example: "tính nết kì khôi * ăn mặc rất kì khôi",
  },
  {
    word: "kì lạ",
    part_of_speech: "tính từ",
    meaning:
      "rất lạ, tới mức không thể ngờ được: một phong tục kì lạ * giấc mơ kì lạ * đẹp một cách kì lạ",
    example: "một phong tục kì lạ * giấc mơ kì lạ * đẹp một cách kì lạ",
  },
  {
    word: "kỉ luật",
    part_of_speech: "danh từ",
    meaning:
      "tổng thể những quy định có tính chất bắt buộc đối với hoạt động của các thành viên trong một tổ chức, để bảo đảm tính chặt chẽ của tổ chức: kỉ luật sắt * giữ kỉ luật trong lớp * một con người vô kỉ luật",
    example: "kỉ luật sắt * giữ kỉ luật trong lớp * một con người vô kỉ luật",
  },
  {
    word: "kỉ luật",
    part_of_speech: "danh từ",
    meaning:
      "hoặc đg hình thức phạt đối với người vi phạm kỉ luật: bị kỉ luật * thi hành kỉ luật * chịu hình thức kỉ luật cao nhất",
    example: "bị kỉ luật * thi hành kỉ luật * chịu hình thức kỉ luật cao nhất",
  },
  {
    word: "kỉ lục",
    part_of_speech: "danh từ",
    meaning:
      "thành tích được chính thức thừa nhận là cao nhất, trong thi đấu thể thao: lập kỉ lục mới * phá kỉ lục thế giới về nhảy xa",
    example: "lập kỉ lục mới * phá kỉ lục thế giới về nhảy xa",
  },
  {
    word: "kỉ lục",
    part_of_speech: "danh từ",
    meaning:
      "mức thành tích cao nhất, từ trước tới nay chưa ai đạt được, làm được: năng suất lao động đạt kỉ lục",
    example: "năng suất lao động đạt kỉ lục",
  },
  {
    word: "kĩ năng",
    part_of_speech: "danh từ",
    meaning:
      "khả năng vận dụng những kiến thức đã thu nhận được trong một lĩnh vực nào đó áp dụng vào thực tế: kĩ năng giao tiếp * nâng cao kĩ năng thi đấu của các vận động viên",
    example:
      "kĩ năng giao tiếp * nâng cao kĩ năng thi đấu của các vận động viên",
  },
  {
    word: "kĩ lưỡng",
    part_of_speech: "tính từ",
    meaning:
      "kĩ, cẩn thận, không để cho có sai sót (nói khái quát): suy nghĩ một cách kĩ lưỡng * xem xét kĩ lưỡng",
    example: "suy nghĩ một cách kĩ lưỡng * xem xét kĩ lưỡng",
  },
  {
    word: "kí lô",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ, khẩu ngữ) kilogram: một kí lô đường * mua hai kí lô gạo",
    example: "một kí lô đường * mua hai kí lô gạo",
  },
  {
    word: "kì ngộ",
    part_of_speech: "động từ",
    meaning:
      '(cũ, văn chương) gặp gỡ một cách may mắn kì lạ: "Ngẫm duyên kì ngộ xưa nay, Lứa đôi ai dễ đẹp tày Thôi, Trương." (TKiều)',
    example:
      'Ngẫm duyên kì ngộ xưa nay, Lứa đôi ai dễ đẹp tày Thôi, Trương." (TKiều)',
  },
  {
    word: "kỉ nguyên",
    part_of_speech: "danh từ",
    meaning:
      "thời kì lịch sử được mở đầu bằng một sự kiện trọng đại, có ý nghĩa quyết định chiều hướng phát triển về sau của xã hội hay của một lĩnh vực nào đó: kỉ nguyên độc lập tự do * kỉ nguyên của công nghệ thông tin",
    example: "kỉ nguyên độc lập tự do * kỉ nguyên của công nghệ thông tin",
  },
  {
    word: "kị nước",
    part_of_speech: "tính từ",
    meaning:
      "(chất) có đặc tính không bị nước làm ướt, không thấm nước: bảo vệ vật liệu bằng lớp bọc kị nước",
    example: "bảo vệ vật liệu bằng lớp bọc kị nước",
  },
  {
    word: "kỉ niệm",
    part_of_speech: "danh từ",
    meaning:
      "cái hiện lại trong trí óc về những sự việc đáng ghi nhớ đã qua: kỉ niệm thời thanh niên * ôn lại những kỉ niệm cũ * mối tình đầu chỉ còn là kỉ niệm",
    example:
      "kỉ niệm thời thanh niên * ôn lại những kỉ niệm cũ * mối tình đầu chỉ còn là kỉ niệm",
  },
  {
    word: "kỉ niệm",
    part_of_speech: "danh từ",
    meaning: "vật gợi lại kỉ niệm: chụp một tấm ảnh làm kỉ niệm",
    example: "chụp một tấm ảnh làm kỉ niệm",
  },
  {
    word: "kỉ niệm",
    part_of_speech: "động từ",
    meaning:
      "gợi lại cho nhớ những sự việc đáng ghi nhớ: dựng đài kỉ niệm * lễ kỉ niệm 50 năm ngày quốc khánh",
    example: "dựng đài kỉ niệm * lễ kỉ niệm 50 năm ngày quốc khánh",
  },
  {
    word: "kỉ niệm",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) cho, tặng để làm kỉ niệm: kỉ niệm bạn quyển sổ tay",
    example: "kỉ niệm bạn quyển sổ tay",
  },
  {
    word: "ki ốt",
    part_of_speech: "danh từ",
    meaning:
      "quầy nhỏ bán báo, kẹo, thuốc lá, hoa, vv ở nơi công cộng: hai bên đường mọc lên rất nhiều ki ốt * xây ki ốt để cho thuê",
    example: "hai bên đường mọc lên rất nhiều ki ốt * xây ki ốt để cho thuê",
  },
  {
    word: "kì quái",
    part_of_speech: "tính từ",
    meaning:
      "đặc biệt lạ lùng, chưa bao giờ thấy: hình thù kì quái * chuyện kì quái",
    example: "hình thù kì quái * chuyện kì quái",
  },
  {
    word: "kì quan",
    part_of_speech: "danh từ",
    meaning:
      "công trình kiến trúc hoặc cảnh vật đẹp đến mức kì lạ hiếm thấy: kì quan thế giới * vịnh Hạ Long là một kì quan ở Việt Nam",
    example: "kì quan thế giới * vịnh Hạ Long là một kì quan ở Việt Nam",
  },
  {
    word: "kì phùng địch thủ",
    part_of_speech: "",
    meaning:
      "địch thủ mạnh, ngang tài, ngang sức: cuộc chạm trán của hai kì phùng địch thủ",
    example: "cuộc chạm trán của hai kì phùng địch thủ",
  },
  {
    word: "kì quặc",
    part_of_speech: "tính từ",
    meaning:
      "kì lạ đến mức trái hẳn lẽ thường, khó hiểu: mắc một căn bệnh kì quặc * tính nết kì quặc",
    example: "mắc một căn bệnh kì quặc * tính nết kì quặc",
  },
  {
    word: "kị rơ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) không hợp nhau trong cách thức, phong cách nên thường có những khó khăn nhất định khi tiếp xúc với nhau: hai cầu thủ vốn kị rơ nên rất khó đá với nhau",
    example: "hai cầu thủ vốn kị rơ nên rất khó đá với nhau",
  },
  {
    word: "kí sinh",
    part_of_speech: "động từ",
    meaning:
      "(sinh vật) sống trên cơ thể các sinh vật khác, bằng cách hút chất dinh dưỡng từ cơ thể các sinh vật ấy: động vật kí sinh * nấm là loài thực vật kí sinh",
    example: "động vật kí sinh * nấm là loài thực vật kí sinh",
  },
  {
    word: "kí sinh trùng",
    part_of_speech: "danh từ",
    meaning:
      "động vật bậc thấp kí sinh trong cơ thể người hay động vật khác trong một giai đoạn của chu kì sống: bệnh do một loại kí sinh trùng gây ra",
    example: "bệnh do một loại kí sinh trùng gây ra",
  },
  {
    word: "kì tài",
    part_of_speech: "",
    meaning: "tài năng đặc biệt, rất hiếm thấy: bậc kì tài trong thiên hạ",
    example: "bậc kì tài trong thiên hạ",
  },
  {
    word: "kĩ sư",
    part_of_speech: "danh từ",
    meaning:
      "người đã tốt nghiệp đại học các ngành kĩ thuật: kĩ sư xây dựng * kĩ sư chế tạo máy",
    example: "kĩ sư xây dựng * kĩ sư chế tạo máy",
  },
  {
    word: "kí tắt",
    part_of_speech: "động từ",
    meaning:
      "kí để ghi nhận sự thoả thuận giữa các bên trước khi kí chính thức: văn bản hiệp định đã được kí tắt",
    example: "văn bản hiệp định đã được kí tắt",
  },
  {
    word: "kí tên",
    part_of_speech: "động từ",
    meaning:
      "tự ghi tên mình bằng một kiểu riêng và không đổi, để xác nhận tính chính xác của một văn bản hoặc để nhận chịu trách nhiệm về một văn bản: kí tên vào đơn xin việc * bức thư không kí tên",
    example: "kí tên vào đơn xin việc * bức thư không kí tên",
  },
  {
    word: "kĩ thuật viên",
    part_of_speech: "danh từ",
    meaning:
      "người làm công việc kĩ thuật trong một nhà máy, xí nghiệp hoặc cơ quan, tổ chức: kĩ thuật viên máy tính * kĩ thuật viên rà phá bom mìn",
    example: "kĩ thuật viên máy tính * kĩ thuật viên rà phá bom mìn",
  },
  {
    word: "kì thị",
    part_of_speech: "động từ",
    meaning:
      "phân biệt đối xử do có thành kiến: kì thị chủng tộc * nhìn với con mắt kì thị",
    example: "kì thị chủng tộc * nhìn với con mắt kì thị",
  },
  {
    word: "kí thác",
    part_of_speech: "động từ",
    meaning:
      "(văn chương) gửi gắm nỗi niềm, tâm sự, v.v.: kí thác tâm sự trong bài thơ",
    example: "kí thác tâm sự trong bài thơ",
  },
  {
    word: "kĩ thuật",
    part_of_speech: "danh từ",
    meaning:
      "tổng thể nói chung những phương tiện và tư liệu hoạt động của con người, được tạo ra để thực hiện quá trình sản xuất và phục vụ các nhu cầu phi sản xuất của xã hội: kĩ thuật quân sự *  thiết bị kĩ thuật hiện đại",
    example: "kĩ thuật quân sự *  thiết bị kĩ thuật hiện đại",
  },
  {
    word: "kĩ thuật",
    part_of_speech: "danh từ",
    meaning:
      "tổng thể nói chung những phương pháp, phương thức sử dụng trong một lĩnh vực hoạt động nào đó của con người: kĩ thuật cấy lúa * kĩ thuật cắt, tỉa cành",
    example: "kĩ thuật cấy lúa * kĩ thuật cắt, tỉa cành",
  },
  {
    word: "kĩ thuật",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) tỏ ra có trình độ kĩ thuật cao: cầu thủ đi bóng rất kĩ thuật * một giọng hát có kĩ thuật",
    example: "cầu thủ đi bóng rất kĩ thuật * một giọng hát có kĩ thuật",
  },
  {
    word: "kì tích",
    part_of_speech: "danh từ",
    meaning: "thành tích lớn lao phi thường: lập được một kì tích",
    example: "lập được một kì tích",
  },
  {
    word: "kĩ thuật số",
    part_of_speech: "danh từ",
    meaning:
      "kĩ thuật biểu diễn, xử lí thông tin dưới dạng số nhị phân (số 0 và 1): máy ảnh kĩ thuật số",
    example: "máy ảnh kĩ thuật số",
  },
  {
    word: "kì thú",
    part_of_speech: "tính từ",
    meaning:
      "có tác dụng gây hứng thú đặc biệt: cảnh tượng thiên nhiên kì thú * cuộc phiêu lưu kì thú",
    example: "cảnh tượng thiên nhiên kì thú * cuộc phiêu lưu kì thú",
  },
  {
    word: "kì thực",
    part_of_speech: "kết từ",
    meaning:
      "(khẩu ngữ) từ biểu thị điều sắp nêu ra mới chính là sự thật: mọi việc tưởng như đơn giản, kì thực lại rất rắc rối * kì thực tôi chưa hiểu kĩ về nó",
    example:
      "mọi việc tưởng như đơn giản, kì thực lại rất rắc rối * kì thực tôi chưa hiểu kĩ về nó",
  },
  {
    word: "kì tình",
    part_of_speech: "kết từ",
    meaning: "(hiếm) như kì thực: giả vờ đọc sách, kì tình vẫn lắng nghe",
    example: "giả vờ đọc sách, kì tình vẫn lắng nghe",
  },
  {
    word: "kĩ tính",
    part_of_speech: "tính từ",
    meaning:
      "có thói quen thận trọng và kĩ lưỡng một cách quá đáng: ông ta rất kĩ tính",
    example: "ông ta rất kĩ tính",
  },
  {
    word: "kí túc xá",
    part_of_speech: "danh từ",
    meaning:
      "nơi ăn ở tập thể của học sinh, sinh viên: kí túc xá của sinh viên * đi bộ từ kí túc xá lên giảng đường",
    example: "kí túc xá của sinh viên * đi bộ từ kí túc xá lên giảng đường",
  },
  {
    word: "kí túc",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) kí túc xá (nói tắt): chuyển sang khu kí túc mới * sinh viên nội trú trong kí túc",
    example: "chuyển sang khu kí túc mới * sinh viên nội trú trong kí túc",
  },
  {
    word: "kí ức",
    part_of_speech: "danh từ",
    meaning: "như trí nhớ: hình ảnh người thầy đã in sâu trong kí ức",
    example: "hình ảnh người thầy đã in sâu trong kí ức",
  },
  {
    word: "kí ức",
    part_of_speech: "danh từ",
    meaning:
      "hình ảnh, sự việc đã qua, được trí nhớ ghi lại và gợi lên: kí ức tuổi thơ",
    example: "kí ức tuổi thơ",
  },
  {
    word: "kĩ xảo",
    part_of_speech: "danh từ",
    meaning:
      "kĩ năng đạt đến mức thuần thục: luyện tập nhiều lần đến mức thành kĩ xảo * tay nghề đạt trình độ kĩ xảo",
    example:
      "luyện tập nhiều lần đến mức thành kĩ xảo * tay nghề đạt trình độ kĩ xảo",
  },
  {
    word: "kĩ xảo",
    part_of_speech: "danh từ",
    meaning:
      "kĩ thuật đặc biệt (ở trình độ cao) có thể đánh lừa được thị giác: kĩ xảo điện ảnh * bộ phim sử dụng nhiều kĩ xảo máy tính",
    example: "kĩ xảo điện ảnh * bộ phim sử dụng nhiều kĩ xảo máy tính",
  },
  {
    word: "kì vĩ",
    part_of_speech: "tính từ",
    meaning:
      "hết sức lớn lao, hết sức đồ sộ: núi non kì vĩ * một công trình kiến trúc kì vĩ",
    example: "núi non kì vĩ * một công trình kiến trúc kì vĩ",
  },
  {
    word: "kỉ vật",
    part_of_speech: "danh từ",
    meaning:
      "(trang trọng) vật được giữ lại làm kỉ niệm: trao kỉ vật cho nhau * giữ lại những kỉ vật của người đã khuất",
    example: "trao kỉ vật cho nhau * giữ lại những kỉ vật của người đã khuất",
  },
  {
    word: "kí vãng",
    part_of_speech: "danh từ",
    meaning: "(cũ, vch, hiếm) như dĩ vãng: câu chuyện đã trở thành kí vãng",
    example: "câu chuyện đã trở thành kí vãng",
  },
  {
    word: "kì vọng",
    part_of_speech: "động từ",
    meaning:
      "đặt nhiều tin tưởng, hi vọng vào người nào đó: cha mẹ nào cũng kì vọng ở con cái",
    example: "cha mẹ nào cũng kì vọng ở con cái",
  },
  {
    word: "kì vọng",
    part_of_speech: "danh từ",
    meaning:
      "điều mong mỏi, hi vọng ở ai, ở cái gì: đặt nhiều kì vọng ở con cái",
    example: "đặt nhiều kì vọng ở con cái",
  },
  {
    word: "kỉ yếu",
    part_of_speech: "danh từ",
    meaning:
      "tập tài liệu ghi lại những điều cốt yếu: đọc kỉ yếu * tập kỉ yếu của hội nghị",
    example: "đọc kỉ yếu * tập kỉ yếu của hội nghị",
  },
  {
    word: "kia",
    part_of_speech: "đại từ",
    meaning:
      "từ dùng để chỉ một sự vật, địa điểm, hiện tượng ở xa vị trí của người nói, nhưng trong phạm vi có thể nhìn thấy cụ thể: ngoài kia nắng rất đẹp * đây là chị tôi còn kia là em tôi",
    example: "ngoài kia nắng rất đẹp * đây là chị tôi còn kia là em tôi",
  },
  {
    word: "kia",
    part_of_speech: "đại từ",
    meaning:
      "từ dùng để chỉ một thời điểm nào đó không xác định, nhưng coi như là có thể hình dung được cụ thể: xưa kia * trước kia, vùng này là một khu đất hoang",
    example: "xưa kia * trước kia, vùng này là một khu đất hoang",
  },
  {
    word: "kia",
    part_of_speech: "đại từ",
    meaning:
      "từ dùng để chỉ một người, một cái khác, trong quan hệ đối lập với người, cái đã được nói đến: không người này thì người kia * kể lể hết chuyện nọ tới chuyện kia",
    example:
      "không người này thì người kia * kể lể hết chuyện nọ tới chuyện kia",
  },
  {
    word: "kia",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) ngày kia (nói tắt): không mai thì kia, thế nào anh ta cũng đến",
    example: "không mai thì kia, thế nào anh ta cũng đến",
  },
  {
    word: "kia",
    part_of_speech: "trợ từ",
    meaning:
      "(khẩu ngữ) từ biểu thị ý nhấn mạnh cho người đối thoại chú ý đến điều vừa được nói đến, ý như muốn bảo rằng: như thế đấy, chứ không phải khác đâu: không, tôi cần anh làm việc này kia * đi từ 8 giờ sáng kia đấy",
    example: "không, tôi cần anh làm việc này kia * đi từ 8 giờ sáng kia đấy",
  },
  {
    word: "kia",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý hơi ngạc nhiên về điều nêu ra như để hỏi vặn lại cho rõ ràng: ai kia ạ? * phải sang tuần sau mới hết kia!",
    example: "ai kia ạ? * phải sang tuần sau mới hết kia!",
  },
  {
    word: "kia mà",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị nhấn mạnh ý ngạc nhiên về một ý kiến hoặc hành động cho là không đúng, trái lẽ, không chấp nhận được của người đối thoại, nêu ra như để hỏi vặn lại nhằm phản bác: việc này tôi đã làm rồi kia mà! * khi nãy nó còn vui lắm kia mà!",
    example: "việc này tôi đã làm rồi kia mà! * khi nãy nó còn vui lắm kia mà!",
  },
  {
    word: "kích",
    part_of_speech: "danh từ",
    meaning:
      "chỗ nối liền thân áo trước với thân áo sau ở dưới nách: áo may hơi chật kích",
    example: "áo may hơi chật kích",
  },
  {
    word: "kích",
    part_of_speech: "tính từ",
    meaning:
      "(áo, quần) hơi chật, do may không vừa: áo may bị kích * quần may hơi kích đùi",
    example: "áo may bị kích * quần may hơi kích đùi",
  },
  {
    word: "kích",
    part_of_speech: "động từ",
    meaning:
      "nâng vật nặng lên cao dần, từng ít một, bằng dụng cụ: kích ô tô lên để thay lốp",
    example: "kích ô tô lên để thay lốp",
  },
  {
    word: "kích",
    part_of_speech: "danh từ",
    meaning: "dụng cụ chuyên dùng để kích: loại kích 20 tấn",
    example: "loại kích 20 tấn",
  },
  {
    word: "kích",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) đánh bằng hoả lực pháo: pháo địch đang kích tới tấp",
    example: "pháo địch đang kích tới tấp",
  },
  {
    word: "kích",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nói chạm đến lòng tự ái của ai để người đó bực tức mà làm việc gì theo ý mình: bị bạn kích * kích nhau uống rượu",
    example: "bị bạn kích * kích nhau uống rượu",
  },
  {
    word: "kịch bản",
    part_of_speech: "danh từ",
    meaning:
      "vở kịch ở dạng văn bản (được viết ra): viết kịch bản * thiếu kịch bản hay",
    example: "viết kịch bản * thiếu kịch bản hay",
  },
  {
    word: "kìa",
    part_of_speech: "đại từ",
    meaning:
      "(khẩu ngữ) từ dùng để chỉ một nơi ở xa vị trí người nói, nhưng có thể nhìn thấy cụ thể, rõ ràng, nêu lên để gợi sự chú ý của người đối thoại: kìa, anh ấy đã về * xem kìa * đi đi, muộn rồi kìa * ở bên kia kìa",
    example:
      "kìa, anh ấy đã về * xem kìa * đi đi, muộn rồi kìa * ở bên kia kìa",
  },
  {
    word: "kịch",
    part_of_speech: "danh từ",
    meaning:
      "nghệ thuật dùng sân khấu trình bày hành động và đối thoại của các nhân vật, để phản ánh những vấn đề, những xung đột trong đời sống xã hội: diễn kịch * sân khấu kịch nói",
    example: "diễn kịch * sân khấu kịch nói",
  },
  {
    word: "kịch bản phim",
    part_of_speech: "danh từ",
    meaning:
      "thể loại văn học được dùng làm tài liệu để dựng thành phim: cuộc thi viết kịch bản phim",
    example: "cuộc thi viết kịch bản phim",
  },
  {
    word: "kích cầu",
    part_of_speech: "động từ",
    meaning:
      "kích thích nhu cầu tiêu dùng, tiêu thụ hàng hoá nhằm phát triển sản xuất: các biện pháp kích cầu * giảm giá để kích cầu",
    example: "các biện pháp kích cầu * giảm giá để kích cầu",
  },
  {
    word: "kịch chiến",
    part_of_speech: "động từ",
    meaning: "chiến đấu dữ dội, kịch liệt: trận kịch chiến",
    example: "trận kịch chiến",
  },
  {
    word: "kịch câm",
    part_of_speech: "danh từ",
    meaning: "kịch chỉ dùng điệu bộ, không dùng lời nói: diễn viên kịch câm",
    example: "diễn viên kịch câm",
  },
  {
    word: "kịch cọt",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) kịch (nói khái quát; hàm ý chê): kịch cọt chẳng ra cái gì, phí cả thời gian",
    example: "kịch cọt chẳng ra cái gì, phí cả thời gian",
  },
  {
    word: "kích cỡ",
    part_of_speech: "danh từ",
    meaning:
      "kích thước và số đo, phân theo lớn nhỏ (nói khái quát): quần áo, giày dép được bày bán với đủ các kích cỡ",
    example: "quần áo, giày dép được bày bán với đủ các kích cỡ",
  },
  {
    word: "kích dục",
    part_of_speech: "động từ",
    meaning:
      "kích thích hoặc có tác dụng kích thích sự ham muốn tình dục: thuốc kích dục",
    example: "thuốc kích dục",
  },
  {
    word: "kích động",
    part_of_speech: "",
    meaning:
      "tác động mạnh đến tinh thần gây ra những xúc động mãnh liệt: dễ bị kích động * đám người ồn ào đầy kích động",
    example: "dễ bị kích động * đám người ồn ào đầy kích động",
  },
  {
    word: "kích giá",
    part_of_speech: "động từ",
    meaning:
      "nâng giá sản phẩm nào đó để giải quyết những vấn đề kinh tế nhất định: kích giá ngoại tệ * kích giá mặt hàng nông sản",
    example: "kích giá ngoại tệ * kích giá mặt hàng nông sản",
  },
  {
    word: "kích hoạt",
    part_of_speech: "động từ",
    meaning: "(hiếm) kích thích, làm cho hoạt động: kích hoạt thị trường",
    example: "kích hoạt thị trường",
  },
  {
    word: "kích hoạt",
    part_of_speech: "động từ",
    meaning:
      "đưa một đối tượng, sự vật hay chương trình vào trạng thái hoạt động trong máy tính: kích hoạt chương trình máy tính",
    example: "kích hoạt chương trình máy tính",
  },
  {
    word: "kịch liệt",
    part_of_speech: "tính từ",
    meaning:
      "mạnh mẽ và quyết liệt: kịch liệt phản đối * cãi nhau một trận kịch liệt",
    example: "kịch liệt phản đối * cãi nhau một trận kịch liệt",
  },
  {
    word: "kịch phát",
    part_of_speech: "động từ",
    meaning: "(hiếm) phát sinh ra thình lình và mạnh mẽ: cơn đau kịch phát",
    example: "cơn đau kịch phát",
  },
  {
    word: "kích thước",
    part_of_speech: "danh từ",
    meaning:
      "toàn thể nói chung những đại lượng xác định độ lớn của một vật, như chiều dài, chiều rộng, chiều cao, vv: đo sai kích thước * may theo kích thước của bộ quần áo mẫu",
    example: "đo sai kích thước * may theo kích thước của bộ quần áo mẫu",
  },
  {
    word: "kích thích",
    part_of_speech: "",
    meaning:
      "tác động vào giác quan hoặc hệ thần kinh: thần kinh bị kích thích mạnh * mùi thơm kích thích các giác quan",
    example: "thần kinh bị kích thích mạnh * mùi thơm kích thích các giác quan",
  },
  {
    word: "kích thích",
    part_of_speech: "",
    meaning:
      "có tác dụng thúc đẩy làm cho hoạt động mạnh hơn: kích thích sự sinh trưởng của cây trồng * kích thích sức mua trên thị trường",
    example:
      "kích thích sự sinh trưởng của cây trồng * kích thích sức mua trên thị trường",
  },
  {
    word: "kích ứng",
    part_of_speech: "động từ",
    meaning:
      "kích thích sự phản ứng khác thường của cơ thể: loại kem này không gây kích ứng da",
    example: "loại kem này không gây kích ứng da",
  },
  {
    word: "kiếm",
    part_of_speech: "danh từ",
    meaning:
      "binh khí có cán ngắn, lưỡi dài và sắc, đầu nhọn, thường dùng để đâm: đấu kiếm * thanh kiếm",
    example: "đấu kiếm * thanh kiếm",
  },
  {
    word: "kiếm",
    part_of_speech: "động từ",
    meaning:
      "làm cách nào đó cho có được: kiếm cớ thoái thác * kiếm tiền * xoay đủ nghề để kiếm sống",
    example: "kiếm cớ thoái thác * kiếm tiền * xoay đủ nghề để kiếm sống",
  },
  {
    word: "kiếm",
    part_of_speech: "động từ",
    meaning: "(Phương ngữ) tìm: kiếm trẻ lạc",
    example: "kiếm trẻ lạc",
  },
  {
    word: "kiểm",
    part_of_speech: "động từ",
    meaning:
      "đếm để xem xét, đánh giá, thống kê lại về mặt số lượng: kiểm lại tiền * kiểm quân số * ban kiểm phiếu",
    example: "kiểm lại tiền * kiểm quân số * ban kiểm phiếu",
  },
  {
    word: "kiểm",
    part_of_speech: "động từ",
    meaning:
      "soát lại, xem xét lần lượt từng cái, từng yếu tố để biết, để đánh giá: kiểm hàng trước khi nhập kho",
    example: "kiểm hàng trước khi nhập kho",
  },
  {
    word: "kiểm",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) kiểm tra (nói tắt): kiểm gác * kiểm kho trước khi đóng cửa",
    example: "kiểm gác * kiểm kho trước khi đóng cửa",
  },
  {
    word: "kiêm",
    part_of_speech: "động từ",
    meaning:
      "gánh thêm việc, giữ thêm chức vụ ngoài việc và chức vụ đã có: phó giám đốc kiêm chủ tịch công đoàn",
    example: "phó giám đốc kiêm chủ tịch công đoàn",
  },
  {
    word: "kịch tính",
    part_of_speech: "danh từ",
    meaning:
      "tính chất kịch, phản ánh một cách tập trung nhất những mâu thuẫn, những xung đột đang vận động của đời sống: những xung đột đầy kịch tính * đoạn phim chứa nhiều kịch tính",
    example: "những xung đột đầy kịch tính * đoạn phim chứa nhiều kịch tính",
  },
  {
    word: "kiệm",
    part_of_speech: "động từ",
    meaning: "tiết kiệm (nói tắt): cần phải đi đôi với kiệm",
    example: "cần phải đi đôi với kiệm",
  },
  {
    word: "kiềm",
    part_of_speech: "tính từ",
    meaning: "có tính chất của một base: môi trường kiềm",
    example: "môi trường kiềm",
  },
  {
    word: "kiểm duyệt",
    part_of_speech: "động từ",
    meaning:
      "kiểm soát sách báo, tranh ảnh, tài liệu, v.v. về mặt tư tưởng và chất lượng trước khi cho phép lưu hành: kiểm duyệt bản thảo trước khi in",
    example: "kiểm duyệt bản thảo trước khi in",
  },
  {
    word: "kiếm ăn",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tìm cách, tìm việc làm để sinh sống: kiếm ăn bằng nghề chạy xe ôm",
    example: "kiếm ăn bằng nghề chạy xe ôm",
  },
  {
    word: "kiếm chác",
    part_of_speech: "động từ",
    meaning:
      "kiếm lợi bằng những việc làm không chính đáng: kiếm chác lợi lộc * chẳng kiếm chác được gì",
    example: "kiếm chác lợi lộc * chẳng kiếm chác được gì",
  },
  {
    word: "kiểm chứng",
    part_of_speech: "động từ",
    meaning:
      "kiểm nghiệm và chứng minh: nguồn tin chưa được kiểm chứng * kiểm chứng bằng thí nghiệm",
    example: "nguồn tin chưa được kiểm chứng * kiểm chứng bằng thí nghiệm",
  },
  {
    word: "kiềm chế",
    part_of_speech: "động từ",
    meaning:
      "giữ ở một chừng mực nhất định không cho tự do hoạt động, tự do phát triển: giận quá, không kiềm chế được",
    example: "giận quá, không kiềm chế được",
  },
  {
    word: "kiếm chuyện",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) kiếm cớ để gây chuyện rắc rối, lôi thôi: kiếm chuyện gây sự",
    example: "kiếm chuyện gây sự",
  },
  {
    word: "kiểm điểm",
    part_of_speech: "động từ",
    meaning:
      "xem xét đánh giá lại từng cái hoặc từng việc một cách cụ thể để có được một nhận định chung: kiểm điểm công tác trong 6 tháng đầu năm",
    example: "kiểm điểm công tác trong 6 tháng đầu năm",
  },
  {
    word: "kiểm điểm",
    part_of_speech: "động từ",
    meaning:
      "nêu ra, phê phán những sai lầm, khuyết điểm: phải viết bản kiểm điểm * tự kiểm điểm trước cuộc họp",
    example: "phải viết bản kiểm điểm * tự kiểm điểm trước cuộc họp",
  },
  {
    word: "kiểm dịch",
    part_of_speech: "động từ",
    meaning:
      "xem xét để phát hiện và ngăn chặn bệnh dịch: trạm kiểm dịch * gia cầm đã qua kiểm dịch",
    example: "trạm kiểm dịch * gia cầm đã qua kiểm dịch",
  },
  {
    word: "kiểm định",
    part_of_speech: "động từ",
    meaning:
      "kiểm tra để xác định giá trị và đánh giá chất lượng: kiểm định hàng hoá * kiểm định chất lượng",
    example: "kiểm định hàng hoá * kiểm định chất lượng",
  },
  {
    word: "kiểm kê",
    part_of_speech: "động từ",
    meaning:
      "kiểm lại từng cái, từng món để xác định số lượng hiện có và tình trạng chất lượng: kiểm kê tài sản * kiểm kê lại hàng hoá trong kho",
    example: "kiểm kê tài sản * kiểm kê lại hàng hoá trong kho",
  },
  {
    word: "kiểm hoá",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) kiểm tra hàng hoá (thường là hàng xuất nhập khẩu) để xác định chất lượng, chủng loại: làm công tác kiểm hoá * cán bộ hải quan đang làm thủ tục kiểm hoá",
    example:
      "làm công tác kiểm hoá * cán bộ hải quan đang làm thủ tục kiểm hoá",
  },
  {
    word: "kiểm đếm",
    part_of_speech: "động từ",
    meaning:
      "đếm và kiểm tra, xem xét (nói khái quát): kiểm đếm hàng hoá trước khi nhập kho",
    example: "kiểm đếm hàng hoá trước khi nhập kho",
  },
  {
    word: "kiếm hiệp",
    part_of_speech: "danh từ",
    meaning:
      "võ sĩ thời xưa, giỏi đánh kiếm, hay làm việc nghĩa hiệp: truyện kiếm hiệp * mê phim kiếm hiệp",
    example: "truyện kiếm hiệp * mê phim kiếm hiệp",
  },
  {
    word: "kiểm lâm",
    part_of_speech: "động từ",
    meaning:
      "kiểm soát việc chấp hành pháp luật trong việc khai thác và bảo vệ rừng: ngành kiểm lâm * công tác kiểm lâm",
    example: "ngành kiểm lâm * công tác kiểm lâm",
  },
  {
    word: "kiểm lâm",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức trong ngành lâm nghiệp có chức năng quản lí, bảo vệ rừng theo quy định của pháp luật: chi cục kiểm lâm",
    example: "chi cục kiểm lâm",
  },
  {
    word: "kiểm nghiệm",
    part_of_speech: "động từ",
    meaning:
      "kiểm tra bằng thực nghiệm, bằng thực tế để đánh giá chất lượng: giống lúa mới đã được kiểm nghiệm qua thực tế",
    example: "giống lúa mới đã được kiểm nghiệm qua thực tế",
  },
  {
    word: "kiệm lời",
    part_of_speech: "tính từ",
    meaning:
      "rất ít lời, chỉ nói những điều thật cần thiết: con bé có vẻ kiệm lời quá * càng có tuổi anh ấy càng kiệm lời",
    example: "con bé có vẻ kiệm lời quá * càng có tuổi anh ấy càng kiệm lời",
  },
  {
    word: "kiểm ngân",
    part_of_speech: "động từ",
    meaning:
      "kiểm tra các khoản thu chi trên thực tế, so sánh với các khoản được ghi trong ngân sách.",
    example: "nhân viên kiểm ngân * làm công tác kiểm ngân",
  },
  {
    word: "kiểm phẩm",
    part_of_speech: "động từ",
    meaning:
      "kiểm tra chất lượng sản phẩm: hàng hoá trước khi xuất xưởng phải qua khâu kiểm phẩm",
    example: "hàng hoá trước khi xuất xưởng phải qua khâu kiểm phẩm",
  },
  {
    word: "kiêm nhiệm",
    part_of_speech: "động từ",
    meaning:
      "kiêm thêm việc, kiêm thêm chức vụ: làm công tác kiêm nhiệm * kiêm nhiệm một lúc ba nhiệm vụ",
    example: "làm công tác kiêm nhiệm * kiêm nhiệm một lúc ba nhiệm vụ",
  },
  {
    word: "kiểm nhận",
    part_of_speech: "động từ",
    meaning: "xác nhận sau khi đã kiểm tra: kiểm nhận hàng hoá nhập kho",
    example: "kiểm nhận hàng hoá nhập kho",
  },
  {
    word: "kiểm ngư",
    part_of_speech: "động từ",
    meaning:
      "kiểm soát việc chấp hành pháp luật trong khai thác và bảo vệ nguồn thuỷ, hải sản: trạm kiểm ngư * cán bộ kiểm ngư",
    example: "trạm kiểm ngư * cán bộ kiểm ngư",
  },
  {
    word: "kiểm soát",
    part_of_speech: "động từ",
    meaning:
      "xem xét để phát hiện, ngăn chặn những gì trái với quy định: trạm kiểm soát * kiểm soát hàng hoá",
    example: "trạm kiểm soát * kiểm soát hàng hoá",
  },
  {
    word: "kiểm soát",
    part_of_speech: "động từ",
    meaning:
      "đặt trong phạm vi quyền hành của đối tượng nào đó: chiếc máy bay đã ngoài tầm kiểm soát",
    example: "chiếc máy bay đã ngoài tầm kiểm soát",
  },
  {
    word: "kiểm thảo",
    part_of_speech: "động từ",
    meaning:
      "(cũ) kiểm điểm hoặc tự kiểm điểm sai lầm, khuyết điểm: tự kiểm thảo về thái độ thiếu trách nhiệm của bản thân",
    example: "tự kiểm thảo về thái độ thiếu trách nhiệm của bản thân",
  },
  {
    word: "kiềm toả",
    part_of_speech: "động từ",
    meaning:
      "giam hãm, kìm giữ trong một phạm vi chật hẹp, không cho tự do hoạt động: thoát khỏi vòng kiềm toả * giặc bị quân ta kiềm toả",
    example: "thoát khỏi vòng kiềm toả * giặc bị quân ta kiềm toả",
  },
  {
    word: "kiểm thử",
    part_of_speech: "động từ",
    meaning:
      "cho hoạt động như trong thực tế để kiểm tra: kiểm thử việc lắp đặt mạng",
    example: "kiểm thử việc lắp đặt mạng",
  },
  {
    word: "kiến",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi chung các loài bọ cánh màng, lưng eo, cánh không phát triển, thường sống thành đàn: đông như kiến * kiến tha lâu cũng đầy tổ (tng)",
    example: "đông như kiến * kiến tha lâu cũng đầy tổ (tng)",
  },
  {
    word: "kiểm tra",
    part_of_speech: "động từ",
    meaning:
      "xem xét tình hình thực tế để đánh giá, nhận xét: kiểm tra học kì * kiểm tra giấy tờ tuỳ thân",
    example: "kiểm tra học kì * kiểm tra giấy tờ tuỳ thân",
  },
  {
    word: "kiện",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị hàng hoá, đồ vật đã được đóng gói để tiện chuyên chở, giao nhận: một kiện sách * đóng hàng thành từng kiện",
    example: "một kiện sách * đóng hàng thành từng kiện",
  },
  {
    word: "kiện",
    part_of_speech: "động từ",
    meaning:
      "yêu cầu cơ quan chức năng xét xử việc người khác đã làm thiệt hại đến mình: gửi đơn kiện * con kiến kiện củ khoai (tng)",
    example: "gửi đơn kiện * con kiến kiện củ khoai (tng)",
  },
  {
    word: "kiến cỏ",
    part_of_speech: "danh từ",
    meaning: "kiến nhỏ, thường sống trong cỏ, rác: đông như kiến cỏ",
    example: "đông như kiến cỏ",
  },
  {
    word: "kiên cường",
    part_of_speech: "tính từ",
    meaning:
      "có khả năng giữ vững ý chí, tinh thần, không khuất phục trước khó khăn, nguy hiểm: cuộc đấu tranh kiên cường",
    example: "cuộc đấu tranh kiên cường",
  },
  {
    word: "kiện cáo",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) kiện (nói khái quát): kiện cáo om sòm",
    example: "kiện cáo om sòm",
  },
  {
    word: "kiên định",
    part_of_speech: "",
    meaning:
      "giữ vững ý định, ý chí, không dao động trước mọi khó khăn, trở lực: thái độ kiên định * lập trường kiên định",
    example: "thái độ kiên định * lập trường kiên định",
  },
  {
    word: "kiên gan",
    part_of_speech: "tính từ",
    meaning:
      "có khả năng chịu đựng thử thách, trước khó khăn, nguy hiểm vẫn giữ vững ý chí: kiên gan chờ đợi",
    example: "kiên gan chờ đợi",
  },
  {
    word: "kiên cố",
    part_of_speech: "tính từ",
    meaning:
      "rất chắc chắn và bền vững, khó có thể phá vỡ: ngôi nhà xây rất kiên cố * chọc vỡ một tuyến phòng thủ kiên cố",
    example: "ngôi nhà xây rất kiên cố * chọc vỡ một tuyến phòng thủ kiên cố",
  },
  {
    word: "kiến giải",
    part_of_speech: "danh từ",
    meaning:
      "nhận thức và cách nhìn đối với sự vật: đưa ra một kiến giải mới * kiến giải về kinh tế",
    example: "đưa ra một kiến giải mới * kiến giải về kinh tế",
  },
  {
    word: "kiến giả nhất phận",
    part_of_speech: "",
    meaning:
      "(anh em trong gia đình) phận ai người nấy lo: anh em kiến giả nhất phận, thân ai nấy lo",
    example: "anh em kiến giả nhất phận, thân ai nấy lo",
  },
  {
    word: "kiến nghị",
    part_of_speech: "động từ",
    meaning:
      "nêu ý kiến đề nghị về một việc chung với cơ quan có thẩm quyền: kiến nghị về việc dạy thêm * kiến nghị lên ban giám đốc",
    example: "kiến nghị về việc dạy thêm * kiến nghị lên ban giám đốc",
  },
  {
    word: "kiến nghị",
    part_of_speech: "danh từ",
    meaning: "điều kiến nghị: gửi kiến nghị lên cấp trên",
    example: "gửi kiến nghị lên cấp trên",
  },
  {
    word: "kiên nhẫn",
    part_of_speech: "tính từ",
    meaning:
      "có khả năng tiếp tục làm việc đã định một cách bền bỉ, không nản lòng, mặc dù thời gian kéo dài, kết quả còn chưa thấy: thử thách lòng kiên nhẫn * kiên nhẫn chờ đợi",
    example: "thử thách lòng kiên nhẫn * kiên nhẫn chờ đợi",
  },
  {
    word: "kiên nghị",
    part_of_speech: "tính từ",
    meaning:
      "có đầy đủ nghị lực và quyết tâm để không lùi bước trước khó khăn, thử thách: tính cách kiên nghị * giọng nói kiên nghị",
    example: "tính cách kiên nghị * giọng nói kiên nghị",
  },
  {
    word: "kiến lập",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) lập ra, xây dựng nên (thường nói về những cái quan trọng, có quy mô): kiến lập thị trường * kiến lập một mô hình sản xuất mới",
    example: "kiến lập thị trường * kiến lập một mô hình sản xuất mới",
  },
  {
    word: "kiến quốc",
    part_of_speech: "động từ",
    meaning: "(cũ) xây dựng đất nước: kháng chiến kiến quốc",
    example: "kháng chiến kiến quốc",
  },
  {
    word: "kiên tâm",
    part_of_speech: "tính từ",
    meaning: "bền lòng, không nản chí: kiên tâm chờ đợi",
    example: "kiên tâm chờ đợi",
  },
  {
    word: "kiến tạo",
    part_of_speech: "động từ",
    meaning: "xây dựng nên: kiến tạo nền hoà bình",
    example: "kiến tạo nền hoà bình",
  },
  {
    word: "kiến tạo",
    part_of_speech: "danh từ",
    meaning: "kiến trúc của một phần hoặc toàn bộ vỏ Trái Đất.",
    example: "kĩ sư kiến tạo",
  },
  {
    word: "kiện toàn",
    part_of_speech: "động từ",
    meaning:
      "làm cho có đầy đủ các bộ phận về mặt tổ chức để có thể hoạt động bình thường: kiện toàn bộ máy lãnh đạo",
    example: "kiện toàn bộ máy lãnh đạo",
  },
  {
    word: "kiến thức",
    part_of_speech: "danh từ",
    meaning:
      "những điều hiểu biết có được do từng trải, hoặc do học tập (nói tổng quát): truyền thụ kiến thức * kiến thức địa lí",
    example: "truyền thụ kiến thức * kiến thức địa lí",
  },
  {
    word: "kiến thiết",
    part_of_speech: "động từ",
    meaning: "xây dựng theo quy mô lớn: kiến thiết thủ đô",
    example: "kiến thiết thủ đô",
  },
  {
    word: "kiên trì",
    part_of_speech: "",
    meaning:
      "không thay đổi ý định, ý chí để làm việc gì đó đến cùng, mặc dù gặp khó khăn, trở lực: thử thách lòng kiên trì * kiên trì theo đuổi mục tiêu",
    example: "thử thách lòng kiên trì * kiên trì theo đuổi mục tiêu",
  },
  {
    word: "kiên quyết",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra hết sức cứng rắn, quyết làm bằng được điều đã định, dù khó khăn trở ngại đến mấy cũng không thay đổi: thái độ kiên quyết * dù bị tra tấn vẫn kiên quyết không khai",
    example: "thái độ kiên quyết * dù bị tra tấn vẫn kiên quyết không khai",
  },
  {
    word: "kiến tập",
    part_of_speech: "động từ",
    meaning:
      "(giáo sinh) dự lớp trong một trường học để học tập, rút kinh nghiệm giảng dạy: giáo sinh đi kiến tập",
    example: "giáo sinh đi kiến tập",
  },
  {
    word: "kiên trinh",
    part_of_speech: "tính từ",
    meaning:
      "có tinh thần giữ vững trinh tiết, giữ vững lòng chung thuỷ, không chịu để bị làm ô nhục; hoặc nói chung có tinh thần giữ vững lòng trung thành, trước sau như một: người con gái kiên trinh * giữ lòng kiên trinh",
    example: "người con gái kiên trinh * giữ lòng kiên trinh",
  },
  {
    word: "kiến trúc",
    part_of_speech: "động từ",
    meaning:
      "xây dựng các công trình, thường là nhà cửa, theo những kiểu mẫu mang tính chất nghệ thuật: toà nhà được kiến trúc theo lối hiện đại",
    example: "toà nhà được kiến trúc theo lối hiện đại",
  },
  {
    word: "kiến trúc",
    part_of_speech: "danh từ",
    meaning:
      "nghệ thuật thiết kế, trang trí nhà cửa: ngôi nhà có kiến trúc độc đáo * học ngành kiến trúc",
    example: "ngôi nhà có kiến trúc độc đáo * học ngành kiến trúc",
  },
  {
    word: "kiến trúc",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như cấu trúc: hệ thống móng cầu có kiến trúc vĩnh cửu",
    example: "hệ thống móng cầu có kiến trúc vĩnh cửu",
  },
  {
    word: "kiện tướng",
    part_of_speech: "danh từ",
    meaning:
      "danh hiệu dành cho người có thành tích xuất sắc, đạt được tiêu chuẩn hoặc kỉ lục đặc biệt trong một lĩnh vực hoạt động nào đó: kiện tướng cờ vua * kiện tướng bơi lội",
    example: "kiện tướng cờ vua * kiện tướng bơi lội",
  },
  {
    word: "kiện tụng",
    part_of_speech: "động từ",
    meaning: "như kiện cáo: kiện tụng lôi thôi",
    example: "kiện tụng lôi thôi",
  },
  {
    word: "kiếng",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) kính: đeo kiếng",
    example: "đeo kiếng",
  },
  {
    word: "kiếng",
    part_of_speech: "danh từ",
    meaning: "gương: kiếng soi mặt",
    example: "kiếng soi mặt",
  },
  {
    word: "kiến trúc sư",
    part_of_speech: "danh từ",
    meaning: "người tốt nghiệp đại học ngành kiến trúc: kiến trúc sư xây dựng",
    example: "kiến trúc sư xây dựng",
  },
  {
    word: "kiểng",
    part_of_speech: "danh từ",
    meaning:
      "nhạc khí gõ bằng đồng, hình cái đĩa có núm nhỏ ở giữa, treo trên giá gỗ, có thể dùng để đánh báo hiệu: hồi kiểng đổi gác",
    example: "hồi kiểng đổi gác",
  },
  {
    word: "kiểng",
    part_of_speech: "danh từ",
    meaning: "(Nam) cảnh3: chậu kiểng * cá kiểng",
    example: "chậu kiểng * cá kiểng",
  },
  {
    word: "kiêng dè",
    part_of_speech: "động từ",
    meaning:
      "e dè, không dám, không muốn động đến vì nể sợ hay e ngại có điều gì không hay xảy ra: ăn nói phải biết kiêng dè",
    example: "ăn nói phải biết kiêng dè",
  },
  {
    word: "kiễng",
    part_of_speech: "động từ",
    meaning:
      "tự nâng cao người thẳng lên trên đầu mũi bàn chân, gót chân không chạm mặt nền: kiễng chân lên dòm * kiễng gót",
    example: "kiễng chân lên dòm * kiễng gót",
  },
  {
    word: "kiêng cữ",
    part_of_speech: "động từ",
    meaning:
      "kiêng (nói khái quát; thường nói về người ốm hoặc mới đẻ xong): mới đẻ xong, phải kiêng cho cẩn thận",
    example: "mới đẻ xong, phải kiêng cho cẩn thận",
  },
  {
    word: "kiềng",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng bằng sắt, thường có hình vòng cung và có ba chân, dùng để đặt nồi lên khi nấu: bếp kiềng",
    example: "bếp kiềng",
  },
  {
    word: "kiềng",
    part_of_speech: "danh từ",
    meaning:
      "vật trang sức hình vòng tròn, thường bằng vàng hay bạc, phụ nữ hoặc trẻ em dùng đeo ở cổ: cổ đeo kiềng bạc",
    example: "cổ đeo kiềng bạc",
  },
  {
    word: "kiềng",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) tránh không muốn có quan hệ với người nào đó vì kiêng sợ hoặc vì khinh ghét: kiềng mặt nhau * lần sau thì kiềng ra, không chơi với nó nữa!",
    example: "kiềng mặt nhau * lần sau thì kiềng ra, không chơi với nó nữa!",
  },
  {
    word: "kiêng",
    part_of_speech: "động từ",
    meaning:
      "tránh không ăn, không dùng những thức ăn nào đó hoặc không làm những việc nào đó, vì có hại hoặc cho là có hại đối với sức khoẻ: kiêng thuốc lá * ăn kiêng * kiêng ra gió",
    example: "kiêng thuốc lá * ăn kiêng * kiêng ra gió",
  },
  {
    word: "kiêng",
    part_of_speech: "động từ",
    meaning:
      "tránh điều gì, cái gì, vì sợ có điều không hay, theo tôn giáo, tín ngưỡng: kiêng đi ngày lẻ * có thờ có thiêng, có kiêng có lành (tng)",
    example: "kiêng đi ngày lẻ * có thờ có thiêng, có kiêng có lành (tng)",
  },
  {
    word: "kiêng",
    part_of_speech: "động từ",
    meaning:
      "tránh động chạm đến, vì nể sợ: đến thánh thần nó cũng chẳng kiêng",
    example: "đến thánh thần nó cũng chẳng kiêng",
  },
  {
    word: "kiêng kị",
    part_of_speech: "động từ",
    meaning:
      "kiêng (nói khái quát; thường nói về phong tục, tín ngưỡng hoặc điều mê tín): phạm phải điều kiêng kị",
    example: "phạm phải điều kiêng kị",
  },
  {
    word: "kiêng kị",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nể sợ, giữ gìn: nói năng bạt mạng, chẳng kiêng kị điều gì",
    example: "nói năng bạt mạng, chẳng kiêng kị điều gì",
  },
  {
    word: "kiêng khem",
    part_of_speech: "động từ",
    meaning:
      "kiêng, sợ ảnh hưởng đến sức khoẻ (nói khái quát; thường nói về việc ăn uống): mới đẻ nên phải kiêng khem kĩ",
    example: "mới đẻ nên phải kiêng khem kĩ",
  },
  {
    word: "kiêng kỵ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tỏ ý trách móc, không vừa lòng bằng cách nói đi nói lại nhiều lời một cách khó chịu: những lời ỉ eo oán trách * ỉ eo trách móc chồng con",
    example: "những lời ỉ eo oán trách * ỉ eo trách móc chồng con",
  },
  {
    word: "kiêng sợ",
    part_of_speech: "động từ",
    meaning:
      "tránh, không dám động đến vì sợ: góp ý thẳng thắn, chẳng kiêng sợ gì ai",
    example: "góp ý thẳng thắn, chẳng kiêng sợ gì ai",
  },
  {
    word: "kiêng nể",
    part_of_speech: "động từ",
    meaning: "không dám động đến vì kính nể: không kiêng nể ai bao giờ",
    example: "không kiêng nể ai bao giờ",
  },
  {
    word: "kiết",
    part_of_speech: "danh từ",
    meaning: "kiết lị (nói tắt): bị đi kiết",
    example: "bị đi kiết",
  },
  {
    word: "kiết",
    part_of_speech: "tính từ",
    meaning: "nghèo túng đến cùng cực: ông đồ kiết",
    example: "ông đồ kiết",
  },
  {
    word: "kiết",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) kiệt, keo kiệt: ông ấy kiết lắm, đố có cho ai cái gì bao giờ!",
    example: "ông ấy kiết lắm, đố có cho ai cái gì bao giờ!",
  },
  {
    word: "kiệt",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) ngõ hẻm, ngõ cụt hoặc đường nhánh nhỏ, hẹp ở đô thị: đi vào đường kiệt * nhà ở trong kiệt",
    example: "đi vào đường kiệt * nhà ở trong kiệt",
  },
  {
    word: "kiệt",
    part_of_speech: "động từ",
    meaning:
      "hết sạch, không còn tí gì: rừng bị phá kiệt * vắt cho kiệt nước * sức cùng lực kiệt",
    example: "rừng bị phá kiệt * vắt cho kiệt nước * sức cùng lực kiệt",
  },
  {
    word: "kiệt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ, hiếm) như keo kiệt: anh ta nhiều tiền nhưng kiệt * tính rất kiệt",
    example: "anh ta nhiều tiền nhưng kiệt * tính rất kiệt",
  },
  {
    word: "kiếp",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian sống của một con người từ lúc sinh ra cho đến lúc chết: kiếp người * vợ chồng ăn đời ở kiếp với nhau",
    example: "kiếp người * vợ chồng ăn đời ở kiếp với nhau",
  },
  {
    word: "kiếp",
    part_of_speech: "danh từ",
    meaning:
      "thân phận của con người, coi như một định mệnh, một sự đầy ải: kiếp nô lệ * kiếp phong trần",
    example: "kiếp nô lệ * kiếp phong trần",
  },
  {
    word: "kiếp",
    part_of_speech: "danh từ",
    meaning:
      "(Phật) đời sống của con người, chết đi lại có một đời sống khác, trong một thể xác khác, trước và sau có quan hệ nhân quả với nhau, theo thuyết luân hồi: duyên nợ từ kiếp trước * kiếp sau",
    example: "duyên nợ từ kiếp trước * kiếp sau",
  },
  {
    word: "kiệt lực",
    part_of_speech: "tính từ",
    meaning: "như kiệt sức: làm đến kiệt lực",
    example: "làm đến kiệt lực",
  },
  {
    word: "kiệt cùng",
    part_of_speech: "tính từ",
    meaning:
      '(hiếm) như cùng kiệt (nhưng ý nhấn mạnh hơn): "Khó khăn tôi sắp cậy ông, Ai ngờ ông lại kiệt cùng hơn tôi!" (ca dao)',
    example:
      'Khó khăn tôi sắp cậy ông, Ai ngờ ông lại kiệt cùng hơn tôi!" (ca dao)',
  },
  {
    word: "kiệt tác",
    part_of_speech: "danh từ",
    meaning:
      "tác phẩm nghệ thuật hết sức đặc sắc: Truyện Kiều là một kiệt tác của Nguyễn Du * kiệt tác nghệ thuật",
    example: "Truyện Kiều là một kiệt tác của Nguyễn Du * kiệt tác nghệ thuật",
  },
  {
    word: "kiệt tác",
    part_of_speech: "tính từ",
    meaning: "đặc sắc và đạt tới đỉnh cao của nghệ thuật: một áng thơ kiệt tác",
    example: "một áng thơ kiệt tác",
  },
  {
    word: "kiêu",
    part_of_speech: "tính từ",
    meaning: "(cũ, hiếm) cao: cổ kiêu ba ngấn",
    example: "cổ kiêu ba ngấn",
  },
  {
    word: "kiêu",
    part_of_speech: "tính từ",
    meaning:
      "tự cho mình là hơn người: biết mình đẹp nên cũng hơi kiêu * vừa mới có tí tiền đã kiêu",
    example: "biết mình đẹp nên cũng hơi kiêu * vừa mới có tí tiền đã kiêu",
  },
  {
    word: "kiết xác",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) nghèo túng đến cùng cực (hàm ý coi khinh): nghèo kiết xác",
    example: "nghèo kiết xác",
  },
  {
    word: "kiệt quệ",
    part_of_speech: "tính từ",
    meaning:
      "suy sút tới mức tột cùng: lâm vào tình cảnh kiệt quệ * nền kinh tế kiệt quệ",
    example: "lâm vào tình cảnh kiệt quệ * nền kinh tế kiệt quệ",
  },
  {
    word: "kiệt sức",
    part_of_speech: "tính từ",
    meaning: "hết sức lực, không còn sức nữa: làm việc nhiều nên kiệt sức",
    example: "làm việc nhiều nên kiệt sức",
  },
  {
    word: "kiệu",
    part_of_speech: "danh từ",
    meaning:
      "cây thuộc họ hành tỏi, thân màu trắng, củ thường dùng để muối dưa, làm gia vị hay thức ăn: củ kiệu * muối kiệu",
    example: "củ kiệu * muối kiệu",
  },
  {
    word: "kiệu",
    part_of_speech: "danh từ",
    meaning:
      "phương tiện thời trước dùng để khiêng người đi đường, gồm một ghế ngồi có mui che ở trên: kiệu rồng * phu khiêng kiệu",
    example: "kiệu rồng * phu khiêng kiệu",
  },
  {
    word: "kiệu",
    part_of_speech: "động từ",
    meaning: "khiêng đi bằng kiệu.",
    example: "kiệu con trên vai",
  },
  {
    word: "kiếu",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) tỏ lời xin lỗi để ra về, để không dự hoặc không nhận lời mời: tối nay tôi bận, nên xin kiếu",
    example: "tối nay tôi bận, nên xin kiếu",
  },
  {
    word: "kiều",
    part_of_speech: "động từ",
    meaning:
      "cầu thần linh hoặc vong hồn nhập vào khi ngồi đồng: kiều thánh * kiều vong",
    example: "kiều thánh * kiều vong",
  },
  {
    word: "kiêu bạc",
    part_of_speech: "",
    meaning: "kiêu ngạo với vẻ khinh bạc: giọng kiêu bạc * nhân tâm kiêu bạc",
    example: "giọng kiêu bạc * nhân tâm kiêu bạc",
  },
  {
    word: "kiệt xuất",
    part_of_speech: "tính từ",
    meaning:
      "vượt trội hẳn lên về giá trị, tài năng so với bình thường: một tác phẩm kiệt xuất * vị lãnh tụ kiệt xuất",
    example: "một tác phẩm kiệt xuất * vị lãnh tụ kiệt xuất",
  },
  {
    word: "kiêu căng",
    part_of_speech: "",
    meaning:
      "tự cho mình hơn người nên xem thường người khác một cách lộ liễu, khiến người ta khó chịu: thái độ kiêu căng * vẻ mặt rất kiêu căng",
    example: "thái độ kiêu căng * vẻ mặt rất kiêu căng",
  },
  {
    word: "kiêu binh",
    part_of_speech: "danh từ",
    meaning:
      "binh lính kiêu căng, ỷ vào công lao mà làm càn, bất chấp kỉ luật: kiêu binh nổi loạn",
    example: "kiêu binh nổi loạn",
  },
  {
    word: "kiểu",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ nói chung những đặc trưng riêng của một loại, một lớp sự vật nào đó, phân biệt nó với các loại, các lớp khác: ngôi nhà kiến trúc theo kiểu cổ",
    example: "ngôi nhà kiến trúc theo kiểu cổ",
  },
  {
    word: "kiêu hãnh",
    part_of_speech: "động từ",
    meaning:
      "tự hào về giá trị của mình, về những cái mình có: lòng kiêu hãnh * kiêu hãnh vì có người con ưu tú",
    example: "lòng kiêu hãnh * kiêu hãnh vì có người con ưu tú",
  },
  {
    word: "kiểu dáng",
    part_of_speech: "danh từ",
    meaning:
      "hình dáng bên ngoài được làm theo một mẫu, một kiểu, phân biệt với các kiểu khác (nói khái quát): kiểu dáng trang nhã * kiểu dáng thanh lịch",
    example: "kiểu dáng trang nhã * kiểu dáng thanh lịch",
  },
  {
    word: "kiều bào",
    part_of_speech: "danh từ",
    meaning:
      "từ người trong nước dùng để gọi đồng bào của mình đang sinh sống ở nước ngoài: kiều bào về quê hương ăn Tết",
    example: "kiều bào về quê hương ăn Tết",
  },
  {
    word: "kiểu cách",
    part_of_speech: "danh từ",
    meaning: "kiểu (nói khái quát): ăn mặc theo đúng kiểu cách nhà binh",
    example: "ăn mặc theo đúng kiểu cách nhà binh",
  },
  {
    word: "kiểu cách",
    part_of_speech: "tính từ",
    meaning:
      "có vẻ cố làm cho ra trang trọng, lịch sự, không hợp với bản thân hoặc với hoàn cảnh: điệu bộ hơi kiểu cách * ăn nói kiểu cách",
    example: "điệu bộ hơi kiểu cách * ăn nói kiểu cách",
  },
  {
    word: "kiều diễm",
    part_of_speech: "tính từ",
    meaning:
      "(người phụ nữ) có vẻ đẹp lộng lẫy, khiến người ta phải trầm trồ, thán phục: vẻ đẹp kiều diễm * nhan sắc kiều diễm",
    example: "vẻ đẹp kiều diễm * nhan sắc kiều diễm",
  },
  {
    word: "kiêu dũng",
    part_of_speech: "tính từ",
    meaning: "(văn chương, hiếm) như dũng mãnh: viên tướng kiêu dũng",
    example: "viên tướng kiêu dũng",
  },
  {
    word: "kiều dân",
    part_of_speech: "danh từ",
    meaning:
      "người dân của nước này cư trú ở một nước khác: kiều dân Pháp ở Hà Nội",
    example: "kiều dân Pháp ở Hà Nội",
  },
  {
    word: "kiều hối",
    part_of_speech: "danh từ",
    meaning:
      "chứng từ tín dụng và thanh toán bằng ngoại tệ, dùng với Việt kiều đang ở nước ngoài: lượng kiều hối thường tăng cao vào dịp Tết",
    example: "lượng kiều hối thường tăng cao vào dịp Tết",
  },
  {
    word: "kiêu kì",
    part_of_speech: "",
    meaning:
      "làm ra vẻ hơn người, trở thành có vẻ khác người một cách giả tạo: tính hơi kiêu kì * vẻ mặt hết sức kiêu kì",
    example: "tính hơi kiêu kì * vẻ mặt hết sức kiêu kì",
  },
  {
    word: "kiêu hùng",
    part_of_speech: "tính từ",
    meaning: "(văn chương, hiếm) như hùng dũng: khí phách kiêu hùng",
    example: "khí phách kiêu hùng",
  },
  {
    word: "kiểu mẫu",
    part_of_speech: "danh từ",
    meaning:
      "mẫu cụ thể theo đó có thể tạo ra hàng loạt những cái khác cùng một kiểu giống như vậy: may đúng theo kiểu mẫu",
    example: "may đúng theo kiểu mẫu",
  },
  {
    word: "kiểu mẫu",
    part_of_speech: "tính từ",
    meaning:
      "có đầy đủ nhất những đặc trưng tốt đẹp, có thể làm mẫu để những cái khác, người khác noi theo: gia đình văn hoá kiểu mẫu * một thanh niên kiểu mẫu",
    example: "gia đình văn hoá kiểu mẫu * một thanh niên kiểu mẫu",
  },
  {
    word: "kiếu từ",
    part_of_speech: "động từ",
    meaning: "(cũ, hiếm) như cáo từ: xin kiếu từ",
    example: "xin kiếu từ",
  },
  {
    word: "kiêu ngạo",
    part_of_speech: "",
    meaning:
      "tự cho là mình hơn người, sinh ra coi thường những người khác: tính kiêu ngạo * cậy thần thế mà sinh kiêu ngạo",
    example: "tính kiêu ngạo * cậy thần thế mà sinh kiêu ngạo",
  },
  {
    word: "kiêu sa",
    part_of_speech: "tính từ",
    meaning:
      "(người phụ nữ) đẹp một cách sang trọng và tỏ ra kiêu hãnh: vẻ đẹp kiêu sa",
    example: "vẻ đẹp kiêu sa",
  },
  {
    word: "kiêu kỳ",
    part_of_speech: "",
    meaning:
      "làm ra vẻ hơn người, trở thành có vẻ khác người một cách giả tạo: tính hơi kiêu kì * vẻ mặt hết sức kiêu kì",
    example: "tính hơi kiêu kì * vẻ mặt hết sức kiêu kì",
  },
  {
    word: "kìm",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ bằng kim loại có hai mỏ và hai càng bắt chéo để kẹp chặt: kìm điện * dùng kìm để nhổ đinh",
    example: "kìm điện * dùng kìm để nhổ đinh",
  },
  {
    word: "kìm",
    part_of_speech: "động từ",
    meaning:
      "tác động nhằm làm cho tốc độ vận động chậm lại, cường độ hoạt động yếu đi, hoặc làm cho phải ngừng lại, không diễn ra: kìm ngựa cho đi chậm lại * không kìm được cơn xúc động",
    example: "kìm ngựa cho đi chậm lại * không kìm được cơn xúc động",
  },
  {
    word: "kim cổ",
    part_of_speech: "danh từ",
    meaning:
      'xưa và nay: "Mái tây còn để tiếng đời, Treo gương kim cổ cho người soi chung." (BC)',
    example:
      'Mái tây còn để tiếng đời, Treo gương kim cổ cho người soi chung." (BC)',
  },
  {
    word: "kim",
    part_of_speech: "danh từ",
    meaning:
      "kim loại (nói tắt): nguyên tố phi kim * bạc, vàng, đồng, v.v. đều là loại kim",
    example: "nguyên tố phi kim * bạc, vàng, đồng, v.v. đều là loại kim",
  },
  {
    word: "kim",
    part_of_speech: "danh từ",
    meaning:
      "vật làm bằng một đoạn thép nhỏ, một đầu có mũi nhọn, một đầu có lỗ để xâu: xâu kim * xe chỉ luồn kim * có công mài sắt có ngày nên kim (tng)",
    example:
      "xâu kim * xe chỉ luồn kim * có công mài sắt có ngày nên kim (tng)",
  },
  {
    word: "kim",
    part_of_speech: "danh từ",
    meaning:
      "vật nhỏ có hình dài và một đầu nhọn giống cái kim: kim đồng hồ * kim tiêm",
    example: "kim đồng hồ * kim tiêm",
  },
  {
    word: "kim",
    part_of_speech: "tính từ",
    meaning: "(giọng) cao và thanh: giọng kim",
    example: "giọng kim",
  },
  {
    word: "kim",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về thời nay, trong quan hệ với cổ (thuộc về thời xưa): từ cổ chí kim * văn kim, văn cổ",
    example: "từ cổ chí kim * văn kim, văn cổ",
  },
  {
    word: "kim đan",
    part_of_speech: "danh từ",
    meaning:
      "(Nam, cũ kim đơn) thuốc tiên, được luyện rất lâu và công phu, uống vào sẽ được trường sinh bất tử, theo trí tưởng tượng của người xưa: luyện kim đan",
    example: "luyện kim đan",
  },
  {
    word: "kim cương",
    part_of_speech: "danh từ",
    meaning:
      "carbon ở dạng tinh thể óng ánh, rất cứng, dùng để cắt kính, làm đồ trang sức: mặt nhẫn đính kim cương",
    example: "mặt nhẫn đính kim cương",
  },
  {
    word: "kim đồng",
    part_of_speech: "danh từ",
    meaning:
      "trẻ em nam theo hầu các vị tiên trong truyện thần thoại: kim đồng ngọc nữ",
    example: "kim đồng ngọc nữ",
  },
  {
    word: "kìm giữ",
    part_of_speech: "động từ",
    meaning:
      "kìm lại, không để cho tự do vận động, hoạt động, hoặc không để cho diễn ra, bộc lộ ra: kìm giữ tình cảm * kìm giữ sự xúc động",
    example: "kìm giữ tình cảm * kìm giữ sự xúc động",
  },
  {
    word: "kìm hãm",
    part_of_speech: "động từ",
    meaning:
      "kìm lại không cho phát triển: nền kinh tế bị kìm hãm * sức mạnh không gì kìm hãm nổi",
    example: "nền kinh tế bị kìm hãm * sức mạnh không gì kìm hãm nổi",
  },
  {
    word: "kim đơn",
    part_of_speech: "danh từ",
    meaning:
      "(Nam, cũ kim đơn) thuốc tiên, được luyện rất lâu và công phu, uống vào sẽ được trường sinh bất tử, theo trí tưởng tượng của người xưa: luyện kim đan",
    example: "luyện kim đan",
  },
  {
    word: "kim hoàn",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) vòng vàng: "Thề xưa, giở đến kim hoàn, Của xưa, lại giở đến đàn với hương." (TKiều)',
    example:
      'Thề xưa, giở đến kim hoàn, Của xưa, lại giở đến đàn với hương." (TKiều)',
  },
  {
    word: "kim hoàn",
    part_of_speech: "danh từ",
    meaning:
      "đồ trang sức bằng vàng bạc (nói khái quát): hiệu kim hoàn * thợ kim hoàn",
    example: "hiệu kim hoàn * thợ kim hoàn",
  },
  {
    word: "kìm kẹp",
    part_of_speech: "động từ",
    meaning: "đè nén, áp bức một cách nghiệt ngã: sống trong vòng kìm kẹp",
    example: "sống trong vòng kìm kẹp",
  },
  {
    word: "kim khí",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng, khí cụ làm bằng kim loại (nói khái quát): cửa hàng kim khí * vật liệu kim khí",
    example: "cửa hàng kim khí * vật liệu kim khí",
  },
  {
    word: "kim môn",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, văn chương) cửa nhà quyền quý; cũng dùng để chỉ bậc văn nhân tài giỏi: “Nàng rằng: Trộm liếc dung quang, Chẳng sân ngọc bội thì phường kim môn.” (TKiều)",
    example:
      "“Nàng rằng: Trộm liếc dung quang, Chẳng sân ngọc bội thì phường kim môn.” (TKiều)",
  },
  {
    word: "kìm nén",
    part_of_speech: "động từ",
    meaning:
      "cố kìm giữ lại, không để cho bộc lộ ra ngoài: kìm nén tiếng khóc * không thể kìm nén nỗi xúc động",
    example: "kìm nén tiếng khóc * không thể kìm nén nỗi xúc động",
  },
  {
    word: "kim nhũ",
    part_of_speech: "danh từ",
    meaning:
      "bột có màu vàng óng ánh, thường được pha với sơn, dùng để trang trí hoặc tô vẽ: thiếp mời có rắc kim nhũ",
    example: "thiếp mời có rắc kim nhũ",
  },
  {
    word: "kim ngạch",
    part_of_speech: "danh từ",
    meaning:
      "quy định về mặt giá trị thể hiện bằng tiền tệ đối với hàng hoá xuất nhập khẩu của một nước hay một khu vực trong một thời kì nhất định: kim ngạch xuất khẩu",
    example: "kim ngạch xuất khẩu",
  },
  {
    word: "kim ô",
    part_of_speech: "danh từ",
    meaning:
      '(Từ cũ, Văn chương) ác vàng; chỉ mặt trời: "Tạ ơn ra khỏi phòng đào, Vừng kim ô đã mọc cao hơn lầu." (PT)',
    example: 'Tạ ơn ra khỏi phòng đào, Vừng kim ô đã mọc cao hơn lầu." (PT)',
  },
  {
    word: "kín",
    part_of_speech: "động từ",
    meaning: "(Phương ngữ) lấy, gánh (nước): ra sông kín nước",
    example: "ra sông kín nước",
  },
  {
    word: "kín",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái ngăn cách làm cho không có gì có thể lọt qua được: ngồi ở chỗ kín gió * kín như bưng * vết thương đã kín miệng",
    example: "ngồi ở chỗ kín gió * kín như bưng * vết thương đã kín miệng",
  },
  {
    word: "kín",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái không còn chỗ nào trống để có thể chen gì thêm vào được nữa: sao kín trời * bèo nở kín mặt ao * người xem ngồi kín cả gian phòng",
    example:
      "sao kín trời * bèo nở kín mặt ao * người xem ngồi kín cả gian phòng",
  },
  {
    word: "kín",
    part_of_speech: "tính từ",
    meaning:
      "không để lộ ra cho bên ngoài có thể thấy được: lấp kín miệng hầm * cất kín trong tủ * bịt kín lỗ thủng",
    example: "lấp kín miệng hầm * cất kín trong tủ * bịt kín lỗ thủng",
  },
  {
    word: "kín",
    part_of_speech: "tính từ",
    meaning: "không để lộ ra cho người ngoài biết: bỏ phiếu kín * họp hội kín",
    example: "bỏ phiếu kín * họp hội kín",
  },
  {
    word: "kín",
    part_of_speech: "tính từ",
    meaning:
      "không để cho có chỗ nào sơ hở khiến đối phương có thể lợi dụng được: miếng võ kín * nước cờ kín",
    example: "miếng võ kín * nước cờ kín",
  },
  {
    word: "kim tuyến",
    part_of_speech: "danh từ",
    meaning:
      "sợi kim loại dát mỏng, mảnh như sợi chỉ, màu óng ánh, thường dùng để trang trí: sợi kim tuyến * thêu kim tuyến",
    example: "sợi kim tuyến * thêu kim tuyến",
  },
  {
    word: "kín cổng cao tường",
    part_of_speech: "",
    meaning:
      'có tường xây cao và cổng kín, bảo vệ chắc chắn và ngăn cách với bên ngoài: "Thâm nghiêm kín cổng cao tường, Cạn dòng lá thắm, dứt đường chim xanh." (TKiều)',
    example:
      'Thâm nghiêm kín cổng cao tường, Cạn dòng lá thắm, dứt đường chim xanh." (TKiều)',
  },
  {
    word: "kìn kìn",
    part_of_speech: "phụ từ",
    meaning:
      "một cách liên tiếp không ngớt, với số lượng rất đông, rất nhiều: dòng người kìn kìn đi trẩy hội",
    example: "dòng người kìn kìn đi trẩy hội",
  },
  {
    word: "kín đáo",
    part_of_speech: "tính từ",
    meaning:
      "kín để có thể tránh được những tác động, những điều không có lợi từ bên ngoài: cất ở một chỗ kín đáo * kín đáo quan sát",
    example: "cất ở một chỗ kín đáo * kín đáo quan sát",
  },
  {
    word: "kín đáo",
    part_of_speech: "tính từ",
    meaning:
      "không để cho những suy nghĩ, tình cảm của mình có những biểu hiện làm người ngoài dễ thấy được: một cô gái kín đáo * nụ cười kín đáo",
    example: "một cô gái kín đáo * nụ cười kín đáo",
  },
  {
    word: "kín nhẽ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (nói năng, cư xử) không để sơ hở, không để có thể bắt bẻ, chê trách được: ăn nói rất kín nhẽ",
    example: "ăn nói rất kín nhẽ",
  },
  {
    word: "kin kít",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng vật cứng cọ xát mạnh vào nhau phát ra liên tiếp, nghe đanh, rít và chói tai: tiếng bánh xe rít lên kin kít",
    example: "tiếng bánh xe rít lên kin kít",
  },
  {
    word: "kín mít",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) rất kín, không có một chỗ hở nào: trùm chăn kín mít * nhà đóng cửa kín mít",
    example: "trùm chăn kín mít * nhà đóng cửa kín mít",
  },
  {
    word: "kìn kịt",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như kịt (nhưng ý nhấn mạnh hơn): người đông kìn kịt",
    example: "người đông kìn kịt",
  },
  {
    word: "kín tiếng",
    part_of_speech: "tính từ",
    meaning:
      "không lên tiếng, không để cho biết, cho chú ý đến mình: cô ấy rất kín tiếng, không muốn ai biết chuyện riêng của mình",
    example: "cô ấy rất kín tiếng, không muốn ai biết chuyện riêng của mình",
  },
  {
    word: "kín như bưng",
    part_of_speech: "",
    meaning:
      "rất kín, do được che đậy, giữ gìn không để lộ ra chút nào: căn phòng kín như bưng",
    example: "căn phòng kín như bưng",
  },
  {
    word: "kính",
    part_of_speech: "danh từ",
    meaning:
      "thuỷ tinh hình tấm, được sử dụng vào nhiều việc khác nhau: tủ kính * nhà kính * cửa có lắp kính",
    example: "tủ kính * nhà kính * cửa có lắp kính",
  },
  {
    word: "kính",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng để đeo bảo vệ mắt hoặc để nhìn được rõ hơn, gồm một khung gọng có lắp hai miếng kính nhỏ: đeo kính bảo hộ lao động * kính cận * kính lão",
    example: "đeo kính bảo hộ lao động * kính cận * kính lão",
  },
  {
    word: "kính",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ quang học có bộ phận chủ yếu là một thấu kính hoặc hệ thống thấu kính: kính hiển vi * kính hội tụ * kính lúp",
    example: "kính hiển vi * kính hội tụ * kính lúp",
  },
  {
    word: "kính",
    part_of_speech: "động từ",
    meaning:
      "có thái độ rất coi trọng đối với người trên: kính thầy yêu bạn * thờ mẹ kính cha",
    example: "kính thầy yêu bạn * thờ mẹ kính cha",
  },
  {
    word: "kính",
    part_of_speech: "động từ",
    meaning:
      "từ dùng để biểu thị thái độ coi trọng, sự lễ độ đối với người đọc, người nghe, nhiều khi chỉ có tính chất hình thức, xã giao: kính thưa các vị đại biểu * kính thư",
    example: "kính thưa các vị đại biểu * kính thư",
  },
  {
    word: "kính",
    part_of_speech: "động từ",
    meaning:
      '(Phương ngữ, hoặc kc) dâng biếu thức ăn, vật dùng: "Ai về tôi gửi buồng cau, Buồng trước kính mẹ, buồng sau kính thầy." (Cdao)',
    example:
      'Ai về tôi gửi buồng cau, Buồng trước kính mẹ, buồng sau kính thầy." (Cdao)',
  },
  {
    word: "kinh",
    part_of_speech: "danh từ",
    meaning: "(Khẩu ngữ) kinh nguyệt (nói tắt): đang có kinh * tắt kinh",
    example: "đang có kinh * tắt kinh",
  },
  {
    word: "kinh",
    part_of_speech: "danh từ",
    meaning:
      "sách do các nhà triết học Trung Quốc thời cổ viết, những lời trong đó dùng làm khuôn phép dưới chế độ phong kiến: Kinh Thi * Kinh Dịch * học thuộc ngũ kinh",
    example: "Kinh Thi * Kinh Dịch * học thuộc ngũ kinh",
  },
  {
    word: "kinh",
    part_of_speech: "danh từ",
    meaning:
      "sách giáo lí của một tôn giáo: kinh Phật * tụng kinh * kinh Cựu Ước",
    example: "kinh Phật * tụng kinh * kinh Cựu Ước",
  },
  {
    word: "kinh",
    part_of_speech: "danh từ",
    meaning: "động kinh (nói tắt): thằng bé lên kinh * mắc chứng kinh",
    example: "thằng bé lên kinh * mắc chứng kinh",
  },
  {
    word: "kinh",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) có cảm giác rùng mình vì sợ khi nhìn thấy hoặc cảm giác thấy: thấy máu thì kinh * mũi dãi bầy nhầy, trông kinh lắm!",
    example: "thấy máu thì kinh * mũi dãi bầy nhầy, trông kinh lắm!",
  },
  {
    word: "kinh",
    part_of_speech: "tính từ",
    meaning: "(Khẩu ngữ) có tác dụng làm cho kinh: nắng kinh người",
    example: "nắng kinh người",
  },
  {
    word: "kinh",
    part_of_speech: "tính từ",
    meaning:
      "ở mức độ cao một cách quá mức, tác động mạnh đến tâm lí người nói: xấu kinh! * đẹp kinh! * con bé ấy giỏi kinh!",
    example: "xấu kinh! * đẹp kinh! * con bé ấy giỏi kinh!",
  },
  {
    word: "kình",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) chày kình (nói tắt): "Buồn tanh trăng ngọn gió cành, Dịp chầy dạ khách tiếng kình đêm thu." (HT)',
    example:
      'Buồn tanh trăng ngọn gió cành, Dịp chầy dạ khách tiếng kình đêm thu." (HT)',
  },
  {
    word: "kinh doanh",
    part_of_speech: "động từ",
    meaning:
      "tổ chức việc sản xuất, buôn bán, dịch vụ nhằm mục đích sinh lợi: có đầu óc kinh doanh * kinh doanh vật liệu xây dựng",
    example: "có đầu óc kinh doanh * kinh doanh vật liệu xây dựng",
  },
  {
    word: "kinh đô",
    part_of_speech: "danh từ",
    meaning: "(cũ) nơi nhà vua đóng đô: kinh đô Huế * kinh đô Hoa Lư",
    example: "kinh đô Huế * kinh đô Hoa Lư",
  },
  {
    word: "kinh dị",
    part_of_speech: "tính từ",
    meaning:
      "kinh hãi hoặc làm cho kinh hãi bởi điều gì quá lạ lùng: phim kinh dị * những giấc mơ kinh dị",
    example: "phim kinh dị * những giấc mơ kinh dị",
  },
  {
    word: "kính cẩn",
    part_of_speech: "tính từ",
    meaning:
      "tỏ rõ sự kính trọng bằng điệu bộ, cử chỉ, nét mặt rất nghiêm trang: kính cẩn nghiêng mình trước hương hồn các liệt sĩ * vẻ mặt hết sức kính cẩn",
    example:
      "kính cẩn nghiêng mình trước hương hồn các liệt sĩ * vẻ mặt hết sức kính cẩn",
  },
  {
    word: "kình địch",
    part_of_speech: "động từ",
    meaning:
      "chống đối nhau một cách quyết liệt, không ai chịu ai: hai người kình địch với nhau",
    example: "hai người kình địch với nhau",
  },
  {
    word: "kình địch",
    part_of_speech: "danh từ",
    meaning: "(hiếm) kẻ kình địch, đối thủ mạnh: một kình địch lợi hại",
    example: "một kình địch lợi hại",
  },
  {
    word: "kinh điển",
    part_of_speech: "tính từ",
    meaning:
      "có giá trị mẫu mực, tiêu biểu cho một học thuyết, một chủ nghĩa: một tác phẩm kinh điển",
    example: "một tác phẩm kinh điển",
  },
  {
    word: "kinh độ",
    part_of_speech: "danh từ",
    meaning:
      "khoảng cách tính bằng độ cung kể từ kinh tuyến gốc đến một kinh tuyến nào đó, theo một trong hai chiều, về hướng đông hay về hướng tây: kinh độ của Hà Nội là 105O51",
    example: "kinh độ của Hà Nội là 105O51",
  },
  {
    word: "kinh hãi",
    part_of_speech: "động từ",
    meaning:
      "kinh sợ hãi hùng: giật mình kinh hãi * “Nghe thôi kinh hãi xiết đâu, Đàn bà thế ấy, thấy âu một người!” (TKiều)",
    example:
      "giật mình kinh hãi * “Nghe thôi kinh hãi xiết đâu, Đàn bà thế ấy, thấy âu một người!” (TKiều)",
  },
  {
    word: "kính hiển vi",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ quang học gồm một hệ thống thấu kính hội tụ, dùng để tạo ảnh phóng đại của những vật rất nhỏ, không thể nhìn thấy bằng mắt thường: dùng kính hiển vi để quan sát tế bào nấm",
    example: "dùng kính hiển vi để quan sát tế bào nấm",
  },
  {
    word: "kinh hoàng",
    part_of_speech: "động từ",
    meaning: "kinh sợ đến mức sững sờ, mất tự chủ: ánh mắt kinh hoàng",
    example: "ánh mắt kinh hoàng",
  },
  {
    word: "kinh động",
    part_of_speech: "động từ",
    meaning:
      "gây ra sự sợ hãi vì tiếng động, tiếng vang lớn: tiếng nổ lớn làm tất cả mọi người đều kinh động",
    example: "tiếng nổ lớn làm tất cả mọi người đều kinh động",
  },
  {
    word: "kinh hoảng",
    part_of_speech: "động từ",
    meaning: "kinh sợ, hoảng hốt: tiếng nổ lớn làm mọi người kinh hoảng",
    example: "tiếng nổ lớn làm mọi người kinh hoảng",
  },
  {
    word: "kinh kì",
    part_of_speech: "danh từ",
    meaning: "(cũ) kinh đô: đất kinh kì",
    example: "đất kinh kì",
  },
  {
    word: "kinh khủng",
    part_of_speech: "động từ",
    meaning: "như khủng khiếp: người đông kinh khủng * thật là kinh khủng!",
    example: "người đông kinh khủng * thật là kinh khủng!",
  },
  {
    word: "kinh kệ",
    part_of_speech: "danh từ",
    meaning:
      "sách kinh của đạo Phật (nói khái quát): nhà sư giảng giải kinh kệ",
    example: "nhà sư giảng giải kinh kệ",
  },
  {
    word: "kinh hồn",
    part_of_speech: "động từ",
    meaning:
      "hoảng sợ đến mất hết tinh thần: sợ kinh hồn * tiếng rú nghe kinh hồn",
    example: "sợ kinh hồn * tiếng rú nghe kinh hồn",
  },
  {
    word: "kinh lí",
    part_of_speech: "động từ",
    meaning:
      "(cũ) (quan chức, viên chức cao cấp trong chế độ cũ) đi kiểm tra xem xét tình hình ở các địa phương: ngài thống đốc đi kinh lí * quan kinh lí",
    example: "ngài thống đốc đi kinh lí * quan kinh lí",
  },
  {
    word: "kinh luân",
    part_of_speech: "",
    meaning: "(cũ) tổ chức, xếp đặt về mặt chính trị: có tài kinh luân",
    example: "có tài kinh luân",
  },
  {
    word: "kính nể",
    part_of_speech: "động từ",
    meaning:
      "coi trọng, do thừa nhận có những điểm hơn mình: được mọi người kính nể * một tài năng đáng kính nể",
    example: "được mọi người kính nể * một tài năng đáng kính nể",
  },
  {
    word: "kính mến",
    part_of_speech: "động từ",
    meaning: "kính trọng và quý mến: kính mến cha mẹ * tỏ lòng kính mến",
    example: "kính mến cha mẹ * tỏ lòng kính mến",
  },
  {
    word: "kinh ngạc",
    part_of_speech: "động từ",
    meaning:
      "hết sức ngạc nhiên, sửng sốt trước điều hoàn toàn không ngờ: tròn mắt kinh ngạc * cảnh tượng kì lạ làm mọi người hết sức kinh ngạc",
    example:
      "tròn mắt kinh ngạc * cảnh tượng kì lạ làm mọi người hết sức kinh ngạc",
  },
  {
    word: "kình ngạc",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) cá voi và cá sấu, hai loài động vật lớn và dữ sống ở nước; dùng để chỉ giặc ngoại xâm hung ác: "Ngất trời, sát khí mơ màng, Đầy sông kình ngạc, chật đường giáp binh." (TKiều)',
    example:
      'Ngất trời, sát khí mơ màng, Đầy sông kình ngạc, chật đường giáp binh." (TKiều)',
  },
  {
    word: "kinh nghiệm",
    part_of_speech: "danh từ",
    meaning:
      "điều hiểu biết có được do tiếp xúc với thực tế, do từng trải: thiếu kinh nghiệm quản lí * rút kinh nghiệm cho lần sau",
    example: "thiếu kinh nghiệm quản lí * rút kinh nghiệm cho lần sau",
  },
  {
    word: "kinh nghĩa",
    part_of_speech: "danh từ",
    meaning: "nghĩa của các câu trong sách kinh thời cổ Trung Quốc.",
    example: "văn chương kinh nghĩa",
  },
  {
    word: "kinh nguyệt",
    part_of_speech: "danh từ",
    meaning:
      "hiện tượng ra máu có chu kì, khoảng mỗi tháng một lần, từ dạ con của người phụ nữ đang ở tuổi có khả năng sinh đẻ: có kinh nguyệt * rối loạn kinh nguyệt",
    example: "có kinh nguyệt * rối loạn kinh nguyệt",
  },
  {
    word: "kinh niên",
    part_of_speech: "tính từ",
    meaning:
      "(bệnh hoặc tình trạng xấu) kéo dài nhiều năm: hen suyễn kinh niên * bệnh kinh niên",
    example: "hen suyễn kinh niên * bệnh kinh niên",
  },
  {
    word: "kinh phí",
    part_of_speech: "danh từ",
    meaning:
      "khoản ngân sách mà cơ quan nhà nước cấp cho các đơn vị trực thuộc để chi vào các hoạt động kinh tế, văn hoá, giáo dục, y tế, vv: chờ kinh phí từ trên rót xuống * tăng kinh phí cho ngành giáo dục",
    example:
      "chờ kinh phí từ trên rót xuống * tăng kinh phí cho ngành giáo dục",
  },
  {
    word: "kính phục",
    part_of_speech: "động từ",
    meaning:
      "kính trọng, do đánh giá cao giá trị của người hoặc của sự việc nào đó: tỏ lòng kính phục * tài đức của ông ấy được mọi người kính phục",
    example: "tỏ lòng kính phục * tài đức của ông ấy được mọi người kính phục",
  },
  {
    word: "kinh qua",
    part_of_speech: "động từ",
    meaning: "(văn chương) trải qua: kinh qua nhiều năm chiến tranh",
    example: "kinh qua nhiều năm chiến tranh",
  },
  {
    word: "kinh rợn",
    part_of_speech: "",
    meaning: "như ghê rợn: cảnh tượng hãi hùng, kinh rợn",
    example: "cảnh tượng hãi hùng, kinh rợn",
  },
  {
    word: "kinh phong",
    part_of_speech: "danh từ",
    meaning: "bệnh thần kinh của trẻ con: mắc chứng kinh phong",
    example: "mắc chứng kinh phong",
  },
  {
    word: "kinh sử",
    part_of_speech: "danh từ",
    meaning:
      "các sách kinh, sử, vv mà người đi thi thời phong kiến phải học thuộc (nói tổng quát): dùi mài kinh sử",
    example: "dùi mài kinh sử",
  },
  {
    word: "kinh tế",
    part_of_speech: "danh từ",
    meaning:
      "tổng thể nói chung các hoạt động sản xuất và tái sản xuất của cải vật chất cho con người và xã hội: chính sách kinh tế nhiều thành phần * các ngành kinh tế mũi nhọn",
    example: "chính sách kinh tế nhiều thành phần * các ngành kinh tế mũi nhọn",
  },
  {
    word: "kinh tế",
    part_of_speech: "tính từ",
    meaning:
      "có tác dụng mang lại hiệu quả tương đối lớn so với sức người, sức của và thời gian bỏ ra tương đối không nhiều: cách làm ăn kinh tế",
    example: "cách làm ăn kinh tế",
  },
  {
    word: "kinh sợ",
    part_of_speech: "động từ",
    meaning: "sợ hãi đến mức chỉ muốn lánh xa: rùng mình kinh sợ",
    example: "rùng mình kinh sợ",
  },
  {
    word: "kinh tế học",
    part_of_speech: "danh từ",
    meaning:
      "khoa học nghiên cứu về quan hệ sản xuất, về các quy luật chi phối quá trình sản xuất, phân phối và trao đổi của cải vật chất trong xã hội con người ở các giai đoạn phát triển lịch sử khác nhau của nó: nhà kinh tế học lỗi lạc",
    example: "nhà kinh tế học lỗi lạc",
  },
  {
    word: "kinh tế tri thức",
    part_of_speech: "",
    meaning:
      "nền kinh tế dựa trên cơ sở đặt tri thức lên hàng đầu, tri thức vừa là sản phẩm, vừa là nguyên liệu có hàm lượng cao nhất so với các nguyên liệu vật chất khác: tập trung phát triển nền kinh tế tri thức",
    example: "tập trung phát triển nền kinh tế tri thức",
  },
  {
    word: "kinh thành",
    part_of_speech: "danh từ",
    meaning: "(cũ) thành xây để bảo vệ kinh đô thời xưa.",
    example: "kinh thành Thăng Long",
  },
  {
    word: "kinh tế thị trường",
    part_of_speech: "",
    meaning:
      "kinh tế hàng hoá trong đó sản xuất chỉ hoàn toàn theo yêu cầu của thị trường: thời buổi kinh tế thị trường",
    example: "thời buổi kinh tế thị trường",
  },
  {
    word: "kinh thiên động địa",
    part_of_speech: "",
    meaning: "long trời lở đất: làm những việc kinh thiên động địa",
    example: "làm những việc kinh thiên động địa",
  },
  {
    word: "kinh tởm",
    part_of_speech: "",
    meaning:
      "kinh hãi và ghê sợ đến mức không thể chịu được (nói khái quát): trông cái mặt hắn mà kinh tởm",
    example: "trông cái mặt hắn mà kinh tởm",
  },
  {
    word: "kính trọng",
    part_of_speech: "động từ",
    meaning: "coi trọng, do thừa nhận có giá trị cao: kính trọng thầy cô",
    example: "kính trọng thầy cô",
  },
  {
    word: "kính yêu",
    part_of_speech: "động từ",
    meaning: "kính trọng và yêu quý: kính yêu cha mẹ",
    example: "kính yêu cha mẹ",
  },
  {
    word: "kinh viện",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất của chủ nghĩa kinh viện, dựa trên những biện luận trừu tượng, tách rời thực tế: lối suy nghĩ và lập luận hết sức kinh viện",
    example: "lối suy nghĩ và lập luận hết sức kinh viện",
  },
  {
    word: "kíp",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận gây nổ của lựu đạn, mìn, bộc phá, vv: tháo kíp bom nổ chậm",
    example: "tháo kíp bom nổ chậm",
  },
  {
    word: "kíp",
    part_of_speech: "danh từ",
    meaning: "(cũ) ca: đã đến giờ đổi kíp",
    example: "đã đến giờ đổi kíp",
  },
  {
    word: "kíp",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) nhóm người được tổ chức ra để cùng làm với nhau một nhiệm vụ lao động, sản xuất cụ thể: hai người ở cùng một kíp * kíp thợ",
    example: "hai người ở cùng một kíp * kíp thợ",
  },
  {
    word: "kíp",
    part_of_speech: "tính từ",
    meaning:
      '(cũ) gấp đến mức phải làm ngay, không thể để chậm trễ: việc kíp phải làm ngay * "Liêu Dương cách trở sơn khê, Xuân đường kíp gọi Sinh về hộ tang." (TKiều)',
    example:
      'việc kíp phải làm ngay * "Liêu Dương cách trở sơn khê, Xuân đường kíp gọi Sinh về hộ tang." (TKiều)',
  },
  {
    word: "kịp",
    part_of_speech: "tính từ",
    meaning:
      "có đủ thì giờ để làm một việc gì trước khi không còn điều kiện để làm hoặc hết thời hạn làm: không kịp giờ tàu * may mà về kịp",
    example: "không kịp giờ tàu * may mà về kịp",
  },
  {
    word: "kịp",
    part_of_speech: "tính từ",
    meaning:
      "đạt đến mức, đến trình độ ngang hàng hoặc tương ứng với yêu cầu, không còn để bị thua kém, lạc hậu: đuổi kịp chiếc xe trước * tiến kịp các nước phát triển",
    example: "đuổi kịp chiếc xe trước * tiến kịp các nước phát triển",
  },
  {
    word: "kịt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) rất kín, đến mức như hoàn toàn không thể chen thêm gì vào được nữa: người ngồi đông kịt * bóng đêm đặc kịt",
    example: "người ngồi đông kịt * bóng đêm đặc kịt",
  },
  {
    word: "kịp thời",
    part_of_speech: "tính từ",
    meaning:
      "đúng lúc, không để chậm trễ: người bệnh được cấp cứu kịp thời * yêu cầu phải giải quyết kịp thời",
    example:
      "người bệnh được cấp cứu kịp thời * yêu cầu phải giải quyết kịp thời",
  },
  {
    word: "kĩu kịt",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng trầm bổng nhịp nhàng như tiếng đôi quang cọ vào đòn gánh khi gánh nặng: quảy gánh kĩu kịt",
    example: "quảy gánh kĩu kịt",
  },
  {
    word: "kỳ",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) vây cá: cá giương kì",
    example: "cá giương kì",
  },
  {
    word: "kỳ",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian nhất định xảy ra tương đối đều đặn của một hiện tượng tự nhiên nào đó hoặc thực hiện tương đối đều đặn một việc nào đó theo quy định: một năm học gồm có hai kì * sáu tháng họp một kì * kì thi đại học",
    example:
      "một năm học gồm có hai kì * sáu tháng họp một kì * kì thi đại học",
  },
  {
    word: "kỳ",
    part_of_speech: "động từ",
    meaning:
      "dùng tay hoặc vật nào đó xát qua xát lại nhiều lần làm cho sạch lớp bẩn bám ngoài da: kì lưng * kì cho sạch ghét",
    example: "kì lưng * kì cho sạch ghét",
  },
  {
    word: "kỳ",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) lạ đến mức làm người ta phải ngạc nhiên: câu chuyện nghe có vẻ rất kì * tính cô ta hơi kì",
    example: "câu chuyện nghe có vẻ rất kì * tính cô ta hơi kì",
  },
  {
    word: "kỳ",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là kết quả nhằm đạt cho được mới thôi của việc vừa nói đến: làm cho kì xong mới thôi * đòi cho kì được",
    example: "làm cho kì xong mới thôi * đòi cho kì được",
  },
  {
    word: "ký",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ, khẩu ngữ) kilogram (nói tắt): mua một kí cam * vài kí gạo nếp",
    example: "mua một kí cam * vài kí gạo nếp",
  },
  {
    word: "ký",
    part_of_speech: "danh từ",
    meaning:
      "thể văn tự sự viết về người thật, việc thật, có tính chất thời sự, trung thành với hiện thực đến mức cao nhất: bài kí",
    example: "bài kí",
  },
  {
    word: "ký",
    part_of_speech: "động từ",
    meaning:
      "kí tên (nói tắt): kí vào biên bản nộp phạt * nhận tiền nhưng chưa kí",
    example: "kí vào biên bản nộp phạt * nhận tiền nhưng chưa kí",
  },
  {
    word: "ký",
    part_of_speech: "động từ",
    meaning:
      "(người có đủ quyền hạn) kí tên mình vào một văn kiện để làm cho nó có giá trị pháp lí, có hiệu lực: kí hoà ước * kí quyết định cho thôi việc * văn bản có hiệu lực từ ngày kí",
    example:
      "kí hoà ước * kí quyết định cho thôi việc * văn bản có hiệu lực từ ngày kí",
  },
  {
    word: "kỵ",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) giỗ: nhà có kị",
    example: "nhà có kị",
  },
  {
    word: "kỵ",
    part_of_speech: "động từ",
    meaning:
      "có những yếu tố hoàn toàn không hợp nhau, đến mức không thể cùng tồn tại, cái này tiếp xúc với cái kia thì tất sẽ gây tác hại: hai thứ thuốc này kị nhau * xăng kị lửa",
    example: "hai thứ thuốc này kị nhau * xăng kị lửa",
  },
  {
    word: "kỵ",
    part_of_speech: "động từ",
    meaning:
      "hết sức tránh mặt nhau vì hoàn toàn không hợp, hoặc tránh không làm vì hoàn toàn không nên: hai người kị nhau như mặt trăng với mặt trời",
    example: "hai người kị nhau như mặt trăng với mặt trời",
  },
  {
    word: "kỵ",
    part_of_speech: "động từ",
    meaning:
      "tránh không nói đến hoặc không làm gì phạm đến, vì cho là linh thiêng, theo tôn giáo, tín ngưỡng: kị huý * kị gọi tên cúng cơm người khác",
    example: "kị huý * kị gọi tên cúng cơm người khác",
  },
  {
    word: "kỳ ảo",
    part_of_speech: "tính từ",
    meaning:
      "có vẻ đẹp kì lạ, tựa như chỉ có trong tưởng tượng, không có thật: ánh sáng kì ảo * vẻ đẹp lung linh kì ảo",
    example: "ánh sáng kì ảo * vẻ đẹp lung linh kì ảo",
  },
  {
    word: "kỳ bí",
    part_of_speech: "tính từ",
    meaning: "kì lạ và bí ẩn đến mức khó hiểu: những hang động đầy vẻ kì bí",
    example: "những hang động đầy vẻ kì bí",
  },
  {
    word: "kỷ",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị thời gian địa chất, bậc dưới của đại, dài từ hàng triệu đến hàng chục triệu năm: kỉ băng hà * loài người xuất hiện từ đầu kỉ đệ tứ, cách đây khoảng một triệu năm",
    example:
      "kỉ băng hà * loài người xuất hiện từ đầu kỉ đệ tứ, cách đây khoảng một triệu năm",
  },
  {
    word: "kỹ",
    part_of_speech: "tính từ",
    meaning:
      "(làm việc gì) có sự chú ý đầy đủ đến từng chi tiết nhỏ, không hoặc rất ít để có sai sót: đọc kĩ đề bài trước khi làm * suy nghĩ kĩ trước khi nói * quyển sách được biên tập rất kĩ",
    example:
      "đọc kĩ đề bài trước khi làm * suy nghĩ kĩ trước khi nói * quyển sách được biên tập rất kĩ",
  },
  {
    word: "kỹ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (làm việc gì) một cách công phu hoặc với thời gian lâu để có hiệu quả cao hơn: giấu cho thật kĩ * nhai kĩ no lâu, cày sâu tốt lúa (tng)",
    example: "giấu cho thật kĩ * nhai kĩ no lâu, cày sâu tốt lúa (tng)",
  },
  {
    word: "kỵ binh",
    part_of_speech: "danh từ",
    meaning: "binh chủng chuyên cưỡi ngựa để chiến đấu: đội kị binh",
    example: "đội kị binh",
  },
  {
    word: "kỹ càng",
    part_of_speech: "tính từ",
    meaning:
      "kĩ (nói khái quát): chọn lựa kĩ càng * kiểm tra lại một cách kĩ càng",
    example: "chọn lựa kĩ càng * kiểm tra lại một cách kĩ càng",
  },
  {
    word: "kỳ công",
    part_of_speech: "danh từ",
    meaning:
      "công lao, sự nghiệp hoặc thành tựu lớn, hiếm có: chiến thắng Bạch Đằng là kì công vang dội của ông cha ta",
    example: "chiến thắng Bạch Đằng là kì công vang dội của ông cha ta",
  },
  {
    word: "kỳ công",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (làm việc gì) đòi hỏi phải bỏ vào nhiều công sức một cách đặc biệt, khác thường: những chiếc gối thêu rất kì công * phải kì công lắm mới tạc được bức tượng này",
    example:
      "những chiếc gối thêu rất kì công * phải kì công lắm mới tạc được bức tượng này",
  },
  {
    word: "kỳ cùng",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) đến tận cùng mới thôi, không bỏ dở nửa chừng: phản đối kì cùng * chống cự cho đến kì cùng",
    example: "phản đối kì cùng * chống cự cho đến kì cùng",
  },
  {
    word: "kỳ cục",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bỏ nhiều thì giờ và công phu làm việc gì một cách vất vả: kì cục nhờ người dắt mối * kì cục tháo lắp suốt cả buổi",
    example: "kì cục nhờ người dắt mối * kì cục tháo lắp suốt cả buổi",
  },
  {
    word: "kỳ cục",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) khác với những gì thường thấy, đến mức như vô lí, khó hiểu: tính nết kì cục * nói năng rất kì cục",
    example: "tính nết kì cục * nói năng rất kì cục",
  },
  {
    word: "ký cược",
    part_of_speech: "động từ",
    meaning: "(cũ) như đặt cọc: kí cược trước tiền mua nhà",
    example: "kí cược trước tiền mua nhà",
  },
  {
    word: "ký chủ",
    part_of_speech: "danh từ",
    meaning:
      "sinh vật mang các loài kí sinh: bọ chét sống kí sinh trên một số vật chủ như mèo, chó, v.v",
    example: "bọ chét sống kí sinh trên một số vật chủ như mèo, chó, v.v",
  },
  {
    word: "ký cả hai tay",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) hoàn toàn tán thành một cách vui vẻ: được như vậy thì tôi xin kí cả hai tay",
    example: "được như vậy thì tôi xin kí cả hai tay",
  },
  {
    word: "kỷ cương",
    part_of_speech: "danh từ",
    meaning:
      "những phép tắc làm nên trật tự của một xã hội (nói tổng quát): giữ vững kỉ cương * kỉ cương phép nước",
    example: "giữ vững kỉ cương * kỉ cương phép nước",
  },
  {
    word: "kỳ cựu",
    part_of_speech: "",
    meaning:
      "lâu năm trong nghề: nhà ngoại giao kì cựu * một tay kì cựu trong làng báo",
    example: "nhà ngoại giao kì cựu * một tay kì cựu trong làng báo",
  },
  {
    word: "kỳ dị",
    part_of_speech: "tính từ",
    meaning:
      "khác hẳn với những gì thường thấy, đến mức lạ lùng: hình thù kì dị",
    example: "hình thù kì dị",
  },
  {
    word: "kỳ diệu",
    part_of_speech: "tính từ",
    meaning:
      "có cái gì vừa rất lạ lùng như không cắt nghĩa nổi, vừa làm cho người ta phải ca ngợi, phải khâm phục: một phát minh kì diệu * khả năng kì diệu của khoa học",
    example: "một phát minh kì diệu * khả năng kì diệu của khoa học",
  },
  {
    word: "ký gửi",
    part_of_speech: "động từ",
    meaning:
      "gửi hàng cho một cửa hàng để nhờ bán, theo những thoả thuận nhất định: sách kí gửi * cửa hàng mua bán, kí gửi",
    example: "sách kí gửi * cửa hàng mua bán, kí gửi",
  },
  {
    word: "kỳ đài",
    part_of_speech: "danh từ",
    meaning: "đài cao có cột cờ: lá cờ tổ quốc phấp phới trên kì đài",
    example: "lá cờ tổ quốc phấp phới trên kì đài",
  },
  {
    word: "kỳ hạn",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian quy định cho một công việc gì: gửi tiết kiệm theo kì hạn 3 tháng * đã hết kì hạn nộp hồ sơ",
    example: "gửi tiết kiệm theo kì hạn 3 tháng * đã hết kì hạn nộp hồ sơ",
  },
  {
    word: "ký hiệu",
    part_of_speech: "danh từ",
    meaning:
      "dấu hiệu vật chất đơn giản, do quan hệ tự nhiên hoặc do quy ước, được coi như thay cho một thực tế phức tạp hơn: chữ viết là một loại kí hiệu",
    example: "chữ viết là một loại kí hiệu",
  },
  {
    word: "ký hiệu",
    part_of_speech: "động từ",
    meaning: "biểu thị bằng kí hiệu: kí hiệu bằng dấu hoa thị",
    example: "kí hiệu bằng dấu hoa thị",
  },
  {
    word: "ký kết",
    part_of_speech: "động từ",
    meaning:
      "cùng nhau kí vào một văn bản để chính thức công nhận những điều hai bên đã thoả thuận: kí kết hiệp định * kí kết hợp đồng lao động",
    example: "kí kết hiệp định * kí kết hợp đồng lao động",
  },
  {
    word: "ký hoạ",
    part_of_speech: "danh từ",
    meaning:
      "tranh vẽ ghi nhanh, phác hoạ những nét cơ bản nhất của sự vật: bức kí hoạ",
    example: "bức kí hoạ",
  },
  {
    word: "ký hoạ",
    part_of_speech: "động từ",
    meaning: "vẽ ghi nhanh: kí hoạ phong cảnh làng quê * kí hoạ chân dung",
    example: "kí hoạ phong cảnh làng quê * kí hoạ chân dung",
  },
  {
    word: "kỳ lạ",
    part_of_speech: "tính từ",
    meaning:
      "rất lạ, tới mức không thể ngờ được: một phong tục kì lạ * giấc mơ kì lạ * đẹp một cách kì lạ",
    example: "một phong tục kì lạ * giấc mơ kì lạ * đẹp một cách kì lạ",
  },
  {
    word: "kỳ khôi",
    part_of_speech: "tính từ",
    meaning:
      "lạ và ngộ nghĩnh đến buồn cười: tính nết kì khôi * ăn mặc rất kì khôi",
    example: "tính nết kì khôi * ăn mặc rất kì khôi",
  },
  {
    word: "kỳ kèo",
    part_of_speech: "động từ",
    meaning:
      "nói đi nói lại nhiều lần để phàn nàn hay đòi cho bằng được điều gì: kì kèo xin cho bằng được * tính  hay kì kèo * mua bán kì kèo",
    example: "kì kèo xin cho bằng được * tính  hay kì kèo * mua bán kì kèo",
  },
  {
    word: "kỷ luật",
    part_of_speech: "danh từ",
    meaning:
      "tổng thể những quy định có tính chất bắt buộc đối với hoạt động của các thành viên trong một tổ chức, để bảo đảm tính chặt chẽ của tổ chức: kỉ luật sắt * giữ kỉ luật trong lớp * một con người vô kỉ luật",
    example: "kỉ luật sắt * giữ kỉ luật trong lớp * một con người vô kỉ luật",
  },
  {
    word: "kỷ luật",
    part_of_speech: "danh từ",
    meaning:
      "hoặc đg hình thức phạt đối với người vi phạm kỉ luật: bị kỉ luật * thi hành kỉ luật * chịu hình thức kỉ luật cao nhất",
    example: "bị kỉ luật * thi hành kỉ luật * chịu hình thức kỉ luật cao nhất",
  },
  {
    word: "kỹ lưỡng",
    part_of_speech: "tính từ",
    meaning:
      "kĩ, cẩn thận, không để cho có sai sót (nói khái quát): suy nghĩ một cách kĩ lưỡng * xem xét kĩ lưỡng",
    example: "suy nghĩ một cách kĩ lưỡng * xem xét kĩ lưỡng",
  },
  {
    word: "kỹ năng",
    part_of_speech: "danh từ",
    meaning:
      "khả năng vận dụng những kiến thức đã thu nhận được trong một lĩnh vực nào đó áp dụng vào thực tế: kĩ năng giao tiếp * nâng cao kĩ năng thi đấu của các vận động viên",
    example:
      "kĩ năng giao tiếp * nâng cao kĩ năng thi đấu của các vận động viên",
  },
  {
    word: "kỵ khí",
    part_of_speech: "tính từ",
    meaning:
      "(sinh vật hoặc quá trình sinh học) chỉ sống và hoạt động, tác động được trong môi trường không có không khí; phân biệt với háo khí: sinh vật yếm khí * xử lí rác bằng công nghệ ủ yếm khí",
    example: "sinh vật yếm khí * xử lí rác bằng công nghệ ủ yếm khí",
  },
  {
    word: "kỷ lục",
    part_of_speech: "danh từ",
    meaning:
      "thành tích được chính thức thừa nhận là cao nhất, trong thi đấu thể thao: lập kỉ lục mới * phá kỉ lục thế giới về nhảy xa",
    example: "lập kỉ lục mới * phá kỉ lục thế giới về nhảy xa",
  },
  {
    word: "kỷ lục",
    part_of_speech: "danh từ",
    meaning:
      "mức thành tích cao nhất, từ trước tới nay chưa ai đạt được, làm được: năng suất lao động đạt kỉ lục",
    example: "năng suất lao động đạt kỉ lục",
  },
  {
    word: "kỷ nguyên",
    part_of_speech: "danh từ",
    meaning:
      "thời kì lịch sử được mở đầu bằng một sự kiện trọng đại, có ý nghĩa quyết định chiều hướng phát triển về sau của xã hội hay của một lĩnh vực nào đó: kỉ nguyên độc lập tự do * kỉ nguyên của công nghệ thông tin",
    example: "kỉ nguyên độc lập tự do * kỉ nguyên của công nghệ thông tin",
  },
  {
    word: "kỷ niệm",
    part_of_speech: "danh từ",
    meaning:
      "cái hiện lại trong trí óc về những sự việc đáng ghi nhớ đã qua: kỉ niệm thời thanh niên * ôn lại những kỉ niệm cũ * mối tình đầu chỉ còn là kỉ niệm",
    example:
      "kỉ niệm thời thanh niên * ôn lại những kỉ niệm cũ * mối tình đầu chỉ còn là kỉ niệm",
  },
  {
    word: "kỷ niệm",
    part_of_speech: "danh từ",
    meaning: "vật gợi lại kỉ niệm: chụp một tấm ảnh làm kỉ niệm",
    example: "chụp một tấm ảnh làm kỉ niệm",
  },
  {
    word: "kỷ niệm",
    part_of_speech: "động từ",
    meaning:
      "gợi lại cho nhớ những sự việc đáng ghi nhớ: dựng đài kỉ niệm * lễ kỉ niệm 50 năm ngày quốc khánh",
    example: "dựng đài kỉ niệm * lễ kỉ niệm 50 năm ngày quốc khánh",
  },
  {
    word: "kỷ niệm",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) cho, tặng để làm kỉ niệm: kỉ niệm bạn quyển sổ tay",
    example: "kỉ niệm bạn quyển sổ tay",
  },
  {
    word: "kỵ nước",
    part_of_speech: "tính từ",
    meaning:
      "(chất) có đặc tính không bị nước làm ướt, không thấm nước: bảo vệ vật liệu bằng lớp bọc kị nước",
    example: "bảo vệ vật liệu bằng lớp bọc kị nước",
  },
  {
    word: "kỳ quặc",
    part_of_speech: "tính từ",
    meaning:
      "kì lạ đến mức trái hẳn lẽ thường, khó hiểu: mắc một căn bệnh kì quặc * tính nết kì quặc",
    example: "mắc một căn bệnh kì quặc * tính nết kì quặc",
  },
  {
    word: "kỳ quan",
    part_of_speech: "danh từ",
    meaning:
      "công trình kiến trúc hoặc cảnh vật đẹp đến mức kì lạ hiếm thấy: kì quan thế giới * vịnh Hạ Long là một kì quan ở Việt Nam",
    example: "kì quan thế giới * vịnh Hạ Long là một kì quan ở Việt Nam",
  },
  {
    word: "kỳ quái",
    part_of_speech: "tính từ",
    meaning:
      "đặc biệt lạ lùng, chưa bao giờ thấy: hình thù kì quái * chuyện kì quái",
    example: "hình thù kì quái * chuyện kì quái",
  },
  {
    word: "kỵ rơ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) không hợp nhau trong cách thức, phong cách nên thường có những khó khăn nhất định khi tiếp xúc với nhau: hai cầu thủ vốn kị rơ nên rất khó đá với nhau",
    example: "hai cầu thủ vốn kị rơ nên rất khó đá với nhau",
  },
  {
    word: "kỳ phùng địch thủ",
    part_of_speech: "",
    meaning:
      "địch thủ mạnh, ngang tài, ngang sức: cuộc chạm trán của hai kì phùng địch thủ",
    example: "cuộc chạm trán của hai kì phùng địch thủ",
  },
  {
    word: "ký sinh trùng",
    part_of_speech: "danh từ",
    meaning:
      "động vật bậc thấp kí sinh trong cơ thể người hay động vật khác trong một giai đoạn của chu kì sống: bệnh do một loại kí sinh trùng gây ra",
    example: "bệnh do một loại kí sinh trùng gây ra",
  },
  {
    word: "ký sinh",
    part_of_speech: "động từ",
    meaning:
      "(sinh vật) sống trên cơ thể các sinh vật khác, bằng cách hút chất dinh dưỡng từ cơ thể các sinh vật ấy: động vật kí sinh * nấm là loài thực vật kí sinh",
    example: "động vật kí sinh * nấm là loài thực vật kí sinh",
  },
  {
    word: "kỹ sư",
    part_of_speech: "danh từ",
    meaning:
      "người đã tốt nghiệp đại học các ngành kĩ thuật: kĩ sư xây dựng * kĩ sư chế tạo máy",
    example: "kĩ sư xây dựng * kĩ sư chế tạo máy",
  },
  {
    word: "kỳ tài",
    part_of_speech: "",
    meaning: "tài năng đặc biệt, rất hiếm thấy: bậc kì tài trong thiên hạ",
    example: "bậc kì tài trong thiên hạ",
  },
  {
    word: "ký thác",
    part_of_speech: "động từ",
    meaning:
      "(văn chương) gửi gắm nỗi niềm, tâm sự, v.v.: kí thác tâm sự trong bài thơ",
    example: "kí thác tâm sự trong bài thơ",
  },
  {
    word: "ký tên",
    part_of_speech: "động từ",
    meaning:
      "tự ghi tên mình bằng một kiểu riêng và không đổi, để xác nhận tính chính xác của một văn bản hoặc để nhận chịu trách nhiệm về một văn bản: kí tên vào đơn xin việc * bức thư không kí tên",
    example: "kí tên vào đơn xin việc * bức thư không kí tên",
  },
  {
    word: "kỳ thị",
    part_of_speech: "động từ",
    meaning:
      "phân biệt đối xử do có thành kiến: kì thị chủng tộc * nhìn với con mắt kì thị",
    example: "kì thị chủng tộc * nhìn với con mắt kì thị",
  },
  {
    word: "kỹ thuật",
    part_of_speech: "danh từ",
    meaning:
      "tổng thể nói chung những phương tiện và tư liệu hoạt động của con người, được tạo ra để thực hiện quá trình sản xuất và phục vụ các nhu cầu phi sản xuất của xã hội: kĩ thuật quân sự *  thiết bị kĩ thuật hiện đại",
    example: "kĩ thuật quân sự *  thiết bị kĩ thuật hiện đại",
  },
  {
    word: "kỹ thuật",
    part_of_speech: "danh từ",
    meaning:
      "tổng thể nói chung những phương pháp, phương thức sử dụng trong một lĩnh vực hoạt động nào đó của con người: kĩ thuật cấy lúa * kĩ thuật cắt, tỉa cành",
    example: "kĩ thuật cấy lúa * kĩ thuật cắt, tỉa cành",
  },
  {
    word: "kỹ thuật",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) tỏ ra có trình độ kĩ thuật cao: cầu thủ đi bóng rất kĩ thuật * một giọng hát có kĩ thuật",
    example: "cầu thủ đi bóng rất kĩ thuật * một giọng hát có kĩ thuật",
  },
  {
    word: "ký tắt",
    part_of_speech: "động từ",
    meaning:
      "kí để ghi nhận sự thoả thuận giữa các bên trước khi kí chính thức: văn bản hiệp định đã được kí tắt",
    example: "văn bản hiệp định đã được kí tắt",
  },
  {
    word: "kỳ thú",
    part_of_speech: "tính từ",
    meaning:
      "có tác dụng gây hứng thú đặc biệt: cảnh tượng thiên nhiên kì thú * cuộc phiêu lưu kì thú",
    example: "cảnh tượng thiên nhiên kì thú * cuộc phiêu lưu kì thú",
  },
  {
    word: "kỳ thực",
    part_of_speech: "kết từ",
    meaning:
      "(khẩu ngữ) từ biểu thị điều sắp nêu ra mới chính là sự thật: mọi việc tưởng như đơn giản, kì thực lại rất rắc rối * kì thực tôi chưa hiểu kĩ về nó",
    example:
      "mọi việc tưởng như đơn giản, kì thực lại rất rắc rối * kì thực tôi chưa hiểu kĩ về nó",
  },
  {
    word: "kỹ thuật viên",
    part_of_speech: "danh từ",
    meaning:
      "người làm công việc kĩ thuật trong một nhà máy, xí nghiệp hoặc cơ quan, tổ chức: kĩ thuật viên máy tính * kĩ thuật viên rà phá bom mìn",
    example: "kĩ thuật viên máy tính * kĩ thuật viên rà phá bom mìn",
  },
  {
    word: "kỹ thuật số",
    part_of_speech: "danh từ",
    meaning:
      "kĩ thuật biểu diễn, xử lí thông tin dưới dạng số nhị phân (số 0 và 1): máy ảnh kĩ thuật số",
    example: "máy ảnh kĩ thuật số",
  },
  {
    word: "ký túc xá",
    part_of_speech: "danh từ",
    meaning:
      "nơi ăn ở tập thể của học sinh, sinh viên: kí túc xá của sinh viên * đi bộ từ kí túc xá lên giảng đường",
    example: "kí túc xá của sinh viên * đi bộ từ kí túc xá lên giảng đường",
  },
  {
    word: "ký túc",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) kí túc xá (nói tắt): chuyển sang khu kí túc mới * sinh viên nội trú trong kí túc",
    example: "chuyển sang khu kí túc mới * sinh viên nội trú trong kí túc",
  },
  {
    word: "ký ức",
    part_of_speech: "danh từ",
    meaning: "như trí nhớ: hình ảnh người thầy đã in sâu trong kí ức",
    example: "hình ảnh người thầy đã in sâu trong kí ức",
  },
  {
    word: "ký ức",
    part_of_speech: "danh từ",
    meaning:
      "hình ảnh, sự việc đã qua, được trí nhớ ghi lại và gợi lên: kí ức tuổi thơ",
    example: "kí ức tuổi thơ",
  },
  {
    word: "kỳ tình",
    part_of_speech: "kết từ",
    meaning: "(hiếm) như kì thực: giả vờ đọc sách, kì tình vẫn lắng nghe",
    example: "giả vờ đọc sách, kì tình vẫn lắng nghe",
  },
  {
    word: "kỹ tính",
    part_of_speech: "tính từ",
    meaning:
      "có thói quen thận trọng và kĩ lưỡng một cách quá đáng: ông ta rất kĩ tính",
    example: "ông ta rất kĩ tính",
  },
  {
    word: "kỳ tích",
    part_of_speech: "danh từ",
    meaning: "thành tích lớn lao phi thường: lập được một kì tích",
    example: "lập được một kì tích",
  },
  {
    word: "kỷ vật",
    part_of_speech: "danh từ",
    meaning:
      "(trang trọng) vật được giữ lại làm kỉ niệm: trao kỉ vật cho nhau * giữ lại những kỉ vật của người đã khuất",
    example: "trao kỉ vật cho nhau * giữ lại những kỉ vật của người đã khuất",
  },
  {
    word: "kỳ vọng",
    part_of_speech: "động từ",
    meaning:
      "đặt nhiều tin tưởng, hi vọng vào người nào đó: cha mẹ nào cũng kì vọng ở con cái",
    example: "cha mẹ nào cũng kì vọng ở con cái",
  },
  {
    word: "kỳ vọng",
    part_of_speech: "danh từ",
    meaning:
      "điều mong mỏi, hi vọng ở ai, ở cái gì: đặt nhiều kì vọng ở con cái",
    example: "đặt nhiều kì vọng ở con cái",
  },
  {
    word: "kỳ vĩ",
    part_of_speech: "tính từ",
    meaning:
      "hết sức lớn lao, hết sức đồ sộ: núi non kì vĩ * một công trình kiến trúc kì vĩ",
    example: "núi non kì vĩ * một công trình kiến trúc kì vĩ",
  },
  {
    word: "kỹ xảo",
    part_of_speech: "danh từ",
    meaning:
      "kĩ năng đạt đến mức thuần thục: luyện tập nhiều lần đến mức thành kĩ xảo * tay nghề đạt trình độ kĩ xảo",
    example:
      "luyện tập nhiều lần đến mức thành kĩ xảo * tay nghề đạt trình độ kĩ xảo",
  },
  {
    word: "kỹ xảo",
    part_of_speech: "danh từ",
    meaning:
      "kĩ thuật đặc biệt (ở trình độ cao) có thể đánh lừa được thị giác: kĩ xảo điện ảnh * bộ phim sử dụng nhiều kĩ xảo máy tính",
    example: "kĩ xảo điện ảnh * bộ phim sử dụng nhiều kĩ xảo máy tính",
  },
  {
    word: "là",
    part_of_speech: "danh từ",
    meaning:
      'hàng dệt bằng tơ nõn, thưa và mỏng, thường được nhuộm đen (được dùng ở thời trước): quần là áo lượt * "Vội về thêm lấy của nhà, Xuyến vàng đôi chiếc khăn là một vuông." (TKiều)',
    example:
      'quần là áo lượt * "Vội về thêm lấy của nhà, Xuyến vàng đôi chiếc khăn là một vuông." (TKiều)',
  },
  {
    word: "là",
    part_of_speech: "động từ",
    meaning:
      "di chuyển từ trên cao xuống và lướt sát gần một mặt phẳng như mặt nước, mặt đất: máy bay là xuống thấp * cành liễu là gần mặt nước",
    example: "máy bay là xuống thấp * cành liễu là gần mặt nước",
  },
  {
    word: "là",
    part_of_speech: "động từ",
    meaning:
      "(Nam ủi) làm cho đồ bằng vải, lụa phẳng và có nếp bằng cách dùng bàn là đã được làm nóng đưa đi đưa lại trên bề mặt: là quần áo cho khỏi nhăn * áo còn nguyên nếp là",
    example: "là quần áo cho khỏi nhăn * áo còn nguyên nếp là",
  },
  {
    word: "là",
    part_of_speech: "động từ",
    meaning:
      "động từ đặc biệt, biểu thị quan hệ giữa phần nêu đối tượng với phần chỉ ra nội dung nhận thức hay giải thích, nêu đặc trưng về đối tượng đó: Hà Nội là thủ đô nước Việt Nam * anh ấy là giáo viên * hôm nay là chủ nhật * hai lần hai là bốn",
    example:
      "Hà Nội là thủ đô nước Việt Nam * anh ấy là giáo viên * hôm nay là chủ nhật * hai lần hai là bốn",
  },
  {
    word: "là",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là nội dung của điều vừa nói đến: tưởng là chuyện đã êm * biết là sai nhưng vẫn cố tình",
    example: "tưởng là chuyện đã êm * biết là sai nhưng vẫn cố tình",
  },
  {
    word: "là",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là tất yếu xảy ra mỗi khi có điều vừa nói đến: hễ nói là làm * hơi trái ý một tí là vùng vằng",
    example: "hễ nói là làm * hơi trái ý một tí là vùng vằng",
  },
  {
    word: "là",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý nhấn mạnh sắc thái khẳng định: quyển sách ấy là của tôi * anh nói như vậy là nó không nghe đâu",
    example: "quyển sách ấy là của tôi * anh nói như vậy là nó không nghe đâu",
  },
  {
    word: "là",
    part_of_speech: "trợ từ",
    meaning:
      "(Khẩu ngữ) từ dùng đệm làm cho lời nói có sắc thái tự nhiên hoặc có sắc thái nhận định chủ quan của người nói: bộ phim rất là hay * hai người chẳng khác nhau là mấy * từng ấy có đáng là bao!",
    example:
      "bộ phim rất là hay * hai người chẳng khác nhau là mấy * từng ấy có đáng là bao!",
  },
  {
    word: "là",
    part_of_speech: "trợ từ",
    meaning:
      "(Khẩu ngữ) từ dùng tổ hợp với hình thức lặp của một từ khác để biểu thị ý nhấn mạnh sắc thái khẳng định về một mức độ, một trạng thái tác động đến người nói: toàn thấy người là người * tay nhoe nhoét những mực là mực * xa nhau cũng thấy nhơ nhớ là!",
    example:
      "toàn thấy người là người * tay nhoe nhoét những mực là mực * xa nhau cũng thấy nhơ nhớ là!",
  },
  {
    word: "lả",
    part_of_speech: "động từ",
    meaning:
      '(cây cối) bị ngả rủ xuống, không đủ sức đứng thẳng: lúa lả xuống mặt ruộng * "Hải đường lả ngọn đông lân, Giọt sương gieo nặng, cành xuân la đà." (TKiều)',
    example:
      'lúa lả xuống mặt ruộng * "Hải đường lả ngọn đông lân, Giọt sương gieo nặng, cành xuân la đà." (TKiều)',
  },
  {
    word: "lả",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái bị kiệt sức đến mức người như rũ xuống, không làm gì nổi nữa: mệt lả người * đói lả",
    example: "mệt lả người * đói lả",
  },
  {
    word: "lả",
    part_of_speech: "phụ từ",
    meaning:
      '(bay) lúc lên cao lúc xuống thấp, chao liệng một cách mềm mại: "Cái cò bay lả bay la, Bay từ cửa phủ bay ra cánh đồng." (Cdao)',
    example: 'Cái cò bay lả bay la, Bay từ cửa phủ bay ra cánh đồng." (Cdao)',
  },
  {
    word: "lá",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận của cây, mọc ra ở cành hoặc thân và thường có hình dẹt, màu lục, giữ vai trò chủ yếu trong việc tạo ra chất hữu cơ nuôi cây: lá dong * tằm ăn lá dâu * vạch lá tìm sâu (tng)",
    example: "lá dong * tằm ăn lá dâu * vạch lá tìm sâu (tng)",
  },
  {
    word: "lá",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị vật có hình tấm mảnh nhẹ hoặc giống như hình cái lá: lá thư * lá bài tú lơ khơ * lá cờ tổ quốc * lá phổi",
    example: "lá thư * lá bài tú lơ khơ * lá cờ tổ quốc * lá phổi",
  },
  {
    word: "kỷ yếu",
    part_of_speech: "danh từ",
    meaning:
      "tập tài liệu ghi lại những điều cốt yếu: đọc kỉ yếu * tập kỉ yếu của hội nghị",
    example: "đọc kỉ yếu * tập kỉ yếu của hội nghị",
  },
  {
    word: "la",
    part_of_speech: "động từ",
    meaning:
      "phát ra những lời với tiếng rất to, do bị đau hay hoảng sợ, bực tức, hoặc nhằm cho mọi người có thể nghe thấy: sợ quá, la thất thanh * la rầm lên phản đối * la trời la đất",
    example: "sợ quá, la thất thanh * la rầm lên phản đối * la trời la đất",
  },
  {
    word: "la",
    part_of_speech: "động từ",
    meaning: "(Phương ngữ) mắng: bị mẹ la",
    example: "bị mẹ la",
  },
  {
    word: "la",
    part_of_speech: "tính từ",
    meaning:
      "ở vị trí rất thấp, gần sát mặt đất: cành bổng, cành la * gần bay la, xa bay bổng (tng)",
    example: "cành bổng, cành la * gần bay la, xa bay bổng (tng)",
  },
  {
    word: "lạ",
    part_of_speech: "tính từ",
    meaning:
      "chưa từng được thấy, được biết đến: người lạ * miền đất lạ * của ngon vật lạ * trước lạ sau quen",
    example: "người lạ * miền đất lạ * của ngon vật lạ * trước lạ sau quen",
  },
  {
    word: "lạ",
    part_of_speech: "tính từ",
    meaning:
      "khác thường, rất hiếm thấy: chuyện lạ có thật * phép lạ * hiện tượng lạ",
    example: "chuyện lạ có thật * phép lạ * hiện tượng lạ",
  },
  {
    word: "lạ",
    part_of_speech: "tính từ",
    meaning:
      "đáng ngạc nhiên, khó hiểu: ánh mắt nhìn rất lạ * nói gì lạ vậy! * không lấy gì làm lạ",
    example: "ánh mắt nhìn rất lạ * nói gì lạ vậy! * không lấy gì làm lạ",
  },
  {
    word: "lạ",
    part_of_speech: "động từ",
    meaning:
      "lấy làm ngạc nhiên, khó hiểu (về điều gì hay người nào đó): anh còn lạ gì tính nó! * chuyện ấy có ai lạ đâu",
    example: "anh còn lạ gì tính nó! * chuyện ấy có ai lạ đâu",
  },
  {
    word: "lạ",
    part_of_speech: "phụ từ",
    meaning:
      "đến mức độ cao khác thường, đáng ngạc nhiên: mùa đông mà ấm áp lạ * trong người khó chịu lạ",
    example: "mùa đông mà ấm áp lạ * trong người khó chịu lạ",
  },
  {
    word: "lã chã",
    part_of_speech: "động từ",
    meaning:
      '(nước mắt, mồ hôi) chảy ra nhiều và nhỏ xuống thành giọt nối tiếp nhau không dứt: mồ hôi lã chã trên mặt * "Giọt châu lã chã khôn cầm, Cúi đầu chàng những gạt thầm giọt Tương." (TKiều)',
    example:
      'mồ hôi lã chã trên mặt * "Giọt châu lã chã khôn cầm, Cúi đầu chàng những gạt thầm giọt Tương." (TKiều)',
  },
  {
    word: "la cà",
    part_of_speech: "động từ",
    meaning:
      "đi, ghé chỗ này chỗ khác mà không có mục đích gì rõ ràng: la cà quán xá * hay la cà dọc đường",
    example: "la cà quán xá * hay la cà dọc đường",
  },
  {
    word: "lá chắn",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi chung vật dùng để che đỡ cho tên, gươm, giáo khỏi trúng người trong chiến trận thời xưa, như khiên, mộc, v.v..",
    example: "khẩu pháo bị thủng lá chắn",
  },
  {
    word: "lá chắn",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận hình tấm gắn ở một số vũ khí hay máy móc để che chắn, bảo vệ: khẩu pháo bị thủng lá chắn",
    example: "dãy núi làm lá chắn cho căn cứ",
  },
  {
    word: "lá cải",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) ví tờ báo tồi, viết nhảm nhí, không có giá trị: báo lá cải",
    example: "báo lá cải",
  },
  {
    word: "lá chét",
    part_of_speech: "danh từ",
    meaning: "bản nhỏ hình lá ở trong một lá kép: lá hoa hồng có ba lá chét",
    example: "lá hoa hồng có ba lá chét",
  },
  {
    word: "lá cờ đầu",
    part_of_speech: "danh từ",
    meaning:
      "người hay đơn vị tiên tiến có tác dụng nêu gương, dẫn đầu phong trào: đơn vị lá cờ đầu",
    example: "đơn vị lá cờ đầu",
  },
  {
    word: "là đà",
    part_of_speech: "động từ",
    meaning: "như la đà (ng1): cành liễu là đà trên mặt hồ",
    example: "cành liễu là đà trên mặt hồ",
  },
  {
    word: "la đà",
    part_of_speech: "động từ",
    meaning:
      'sà xuống thấp và đưa đi đưa lại một cách nhẹ nhàng, lả lướt: sương là đà trên mặt nước * "Gió đưa cành trúc la đà, Tiếng chuông Trấn Võ canh gà Thọ Xương." (ca dao)',
    example:
      'sương là đà trên mặt nước * "Gió đưa cành trúc la đà, Tiếng chuông Trấn Võ canh gà Thọ Xương." (ca dao)',
  },
  {
    word: "la đà",
    part_of_speech: "động từ",
    meaning:
      'lảo đảo, choáng váng vì say (rượu, bia): ngồi la đà uống rượu * "Trèo lên quán dốc cây đa, Gặp chị bán rượu la đà say sưa." (ca dao)',
    example:
      'ngồi la đà uống rượu * "Trèo lên quán dốc cây đa, Gặp chị bán rượu la đà say sưa." (ca dao)',
  },
  {
    word: "lạ đời",
    part_of_speech: "tính từ",
    meaning:
      '(sự việc, hành động) lạ, chưa từng thấy trên đời: chuyện lạ đời * "Chước đâu có chước lạ đời!, Người đâu mà lại có người tinh ma!" (TKiều)',
    example:
      'chuyện lạ đời * "Chước đâu có chước lạ đời!, Người đâu mà lại có người tinh ma!" (TKiều)',
  },
  {
    word: "lạ hoắc",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) lạ lắm, chưa từng quen, chưa từng biết: gương mặt lạ hoắc",
    example: "gương mặt lạ hoắc",
  },
  {
    word: "la hét",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) hét rất to (nói khái quát): bọn trẻ la hét ầm ĩ * luôn miệng la hét con cái",
    example: "bọn trẻ la hét ầm ĩ * luôn miệng la hét con cái",
  },
  {
    word: "lá kép",
    part_of_speech: "danh từ",
    meaning:
      "lá có cuống phân nhánh, mỗi nhánh mang một lá chét: đậu, lạc là cây có lá kép",
    example: "đậu, lạc là cây có lá kép",
  },
  {
    word: "là là",
    part_of_speech: "động từ",
    meaning:
      "ở trạng thái bay hoặc chuyển động theo chiều ngang sát với bề mặt một vật khác: khói bay là là mặt đất",
    example: "khói bay là là mặt đất",
  },
  {
    word: "la làng",
    part_of_speech: "động từ",
    meaning: "la thật to để kêu cứu làng xóm: vừa ăn cướp vừa la làng (tng)",
    example: "vừa ăn cướp vừa la làng (tng)",
  },
  {
    word: "là lạ",
    part_of_speech: "tính từ",
    meaning:
      "hơi lạ: hương thơm là lạ * một cảm giác là lạ chợt dâng lên trong lòng",
    example: "hương thơm là lạ * một cảm giác là lạ chợt dâng lên trong lòng",
  },
  {
    word: "lạ kì",
    part_of_speech: "tính từ",
    meaning:
      'như kì lạ: "Thế gian sao khéo lạ kì, Đàng ta đi tới, mắc gì đón ngăn." (ca dao)',
    example:
      'Thế gian sao khéo lạ kì, Đàng ta đi tới, mắc gì đón ngăn." (ca dao)',
  },
  {
    word: "lá lẩu",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) lá các loại cây đã rụng hoặc được hái dùng (nói khái quát): lá lẩu rụng đầy sân * hái lá lẩu về nấu nước xông",
    example: "lá lẩu rụng đầy sân * hái lá lẩu về nấu nước xông",
  },
  {
    word: "lạ lẫm",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) cảm thấy rất lạ do chưa từng thấy, chưa từng gặp: những gương mặt lạ lẫm * mới đến nên trông cái gì cũng lạ lẫm",
    example: "những gương mặt lạ lẫm * mới đến nên trông cái gì cũng lạ lẫm",
  },
  {
    word: "lạ lẫm",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) lạ, lấy làm ngạc nhiên: tính nó tôi còn lạ lẫm gì!",
    example: "tính nó tôi còn lạ lẫm gì!",
  },
  {
    word: "lá lốt",
    part_of_speech: "danh từ",
    meaning:
      "cây gần với trầu không, mọc dại hoặc trồng ở những chỗ ẩm có bóng mát, lá có mùi thơm hắc, dùng làm gia vị: chả lá lốt",
    example: "chả lá lốt",
  },
  {
    word: "la liếm",
    part_of_speech: "động từ",
    meaning:
      "liếm hết chỗ này đến chỗ kia: con chó la liếm trong bếp * ngọn lửa la liếm vào mái tranh",
    example: "con chó la liếm trong bếp * ngọn lửa la liếm vào mái tranh",
  },
  {
    word: "la lối",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) kêu la, làm cho ầm ĩ cả lên: la lối om sòm",
    example: "la lối om sòm",
  },
  {
    word: "la lối",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) mắng mỏ to tiếng: suốt ngày la lối con cái",
    example: "suốt ngày la lối con cái",
  },
  {
    word: "lả lướt",
    part_of_speech: "tính từ",
    meaning:
      "(chuyển động) mềm mại, uyển chuyển với vẻ yếu ớt: ngọn cây lả lướt trong gió * bước đi lả lướt",
    example: "ngọn cây lả lướt trong gió * bước đi lả lướt",
  },
  {
    word: "là lượt",
    part_of_speech: "danh từ",
    meaning:
      "hàng dệt bằng tơ, như là, lượt, v.v. (nói khái quát): gấm vóc là lượt",
    example: "gấm vóc là lượt",
  },
  {
    word: "là lượt",
    part_of_speech: "tính từ",
    meaning:
      "(ăn mặc) sang, diện (thường hàm ý chê): ăn mặc là lượt * là lượt là vợ thông lại, nhễ nhại là vợ học trò (tng)",
    example:
      "ăn mặc là lượt * là lượt là vợ thông lại, nhễ nhại là vợ học trò (tng)",
  },
  {
    word: "lạ lùng",
    part_of_speech: "tính từ",
    meaning:
      'lạ lắm, thấy khó hiểu, hoặc làm cho phải ngạc nhiên: câu chuyện lạ lùng * tính khí lạ lùng * "Những nghe nói đã thẹn thùng, Nước đời lắm nỗi lạ lùng khắt khe!" (TKiều)',
    example:
      'câu chuyện lạ lùng * tính khí lạ lùng * "Những nghe nói đã thẹn thùng, Nước đời lắm nỗi lạ lùng khắt khe!" (TKiều)',
  },
  {
    word: "lạ lùng",
    part_of_speech: "phụ từ",
    meaning:
      "đến mức cảm thấy rất lạ, rất đáng ngạc nhiên: đôi mắt sáng lạ lùng * lòng trống trải lạ lùng",
    example: "đôi mắt sáng lạ lùng * lòng trống trải lạ lùng",
  },
  {
    word: "lả lơi",
    part_of_speech: "tính từ",
    meaning:
      'có những cử chỉ, lời nói tỏ ra hơi quá thân mật, thiếu đứng đắn trong quan hệ nam nữ (thường nói về nữ đối với nam): cười nói lả lơi * con mắt lả lơi * "Sóng tình dường đã xiêu xiêu, Xem trong âu yếm có chiều lả lơi." (TKiều)',
    example:
      'cười nói lả lơi * con mắt lả lơi * "Sóng tình dường đã xiêu xiêu, Xem trong âu yếm có chiều lả lơi." (TKiều)',
  },
  {
    word: "lạ mắt",
    part_of_speech: "tính từ",
    meaning:
      "chưa trông thấy bao giờ nên có cảm giác lạ: chiếc xe trông rất lạ mắt * lối ăn mặc lạ mắt",
    example: "chiếc xe trông rất lạ mắt * lối ăn mặc lạ mắt",
  },
  {
    word: "la liệt",
    part_of_speech: "tính từ",
    meaning:
      "(giăng ra, bày ra) rất nhiều và ở khắp mọi chỗ, thường không theo hàng lối, thứ tự nào cả: hàng hoá bày la liệt",
    example: "hàng hoá bày la liệt",
  },
  {
    word: "lá mặt",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) lá dùng để gói bên ngoài bánh cho đẹp; thường dùng để ví cách cư xử, đối đãi chỉ có tính chất xã giao bề ngoài, không thật lòng: cư xử lá mặt * ăn ở lá mặt",
    example: "cư xử lá mặt * ăn ở lá mặt",
  },
  {
    word: "lá mặt lá trái",
    part_of_speech: "",
    meaning:
      "lật lọng, tráo trở, dễ trở mặt, không trung thực: con người lá mặt lá trái",
    example: "con người lá mặt lá trái",
  },
  {
    word: "lạ mặt",
    part_of_speech: "tính từ",
    meaning: "lạ, không quen biết, không rõ tung tích: kẻ lạ mặt",
    example: "kẻ lạ mặt",
  },
  {
    word: "lá mầm",
    part_of_speech: "danh từ",
    meaning: "lá của cây mầm trong hạt: cây hai lá mầm",
    example: "cây hai lá mầm",
  },
  {
    word: "lạ miệng",
    part_of_speech: "tính từ",
    meaning:
      "không thường được ăn hoặc lần đầu được ăn, cho nên có cảm giác lạ, dễ thấy thích, thấy ngon: lạ miệng nên ăn được nhiều",
    example: "lạ miệng nên ăn được nhiều",
  },
  {
    word: "lạ nhà",
    part_of_speech: "tính từ",
    meaning: "không quen nhà, không quen chỗ: không ngủ được vì lạ nhà",
    example: "không ngủ được vì lạ nhà",
  },
  {
    word: "lá mía",
    part_of_speech: "danh từ",
    meaning:
      "phần xương sụn mỏng, ngăn khoang mũi ra làm hai: ngã bị dập lá mía",
    example: "ngã bị dập lá mía",
  },
  {
    word: "lạ nước lạ cái",
    part_of_speech: "",
    meaning:
      "bỡ ngỡ, chưa quen trước cảnh lạ, người lạ, vì vừa mới đến: mới đến nên còn lạ nước lạ cái",
    example: "mới đến nên còn lạ nước lạ cái",
  },
  {
    word: "la rầy",
    part_of_speech: "động từ",
    meaning:
      '(hiếm) như rầy la: "Đi đường quên hết đường xa, Tới lui quên sợ mẹ cha la rầy." (ca dao)',
    example:
      'Đi đường quên hết đường xa, Tới lui quên sợ mẹ cha la rầy." (ca dao)',
  },
  {
    word: "la ó",
    part_of_speech: "động từ",
    meaning:
      "(số đông người) kêu la ầm ĩ để tỏ thái độ (thường là phản đối): la ó ầm ĩ * cầu thủ chơi xấu bị khán giả la ó",
    example: "la ó ầm ĩ * cầu thủ chơi xấu bị khán giả la ó",
  },
  {
    word: "lả tả",
    part_of_speech: "động từ",
    meaning:
      "từ gợi tả trạng thái rơi xuống rải rác và liên tiếp của các vật nhẹ và mỏng: lá vàng rơi lả tả * cánh hoa rụng lả tả",
    example: "lá vàng rơi lả tả * cánh hoa rụng lả tả",
  },
  {
    word: "lá thắm",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) lá đỏ; chỉ sự mối lái nhân duyên cho nên vợ nên chồng: "Thâm nghiêm kín cổng cao tường, Cạn dòng lá thắm, dứt đường chim xanh." (TKiều)',
    example:
      'Thâm nghiêm kín cổng cao tường, Cạn dòng lá thắm, dứt đường chim xanh." (TKiều)',
  },
  {
    word: "lạ tai",
    part_of_speech: "tính từ",
    meaning:
      "chưa từng được nghe hoặc không nghe quen, nên cảm thấy lạ: điệu nhạc nghe rất lạ tai * cách xưng hô khá lạ tai",
    example: "điệu nhạc nghe rất lạ tai * cách xưng hô khá lạ tai",
  },
  {
    word: "la trời",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) kêu trời: hơi khổ một tí đã la trời",
    example: "hơi khổ một tí đã la trời",
  },
  {
    word: "lạ thường",
    part_of_speech: "phụ từ",
    meaning:
      "ở mức độ cao, đến mức thấy khác thường, thấy ngạc nhiên: đẹp lạ thường * to lớn lạ thường",
    example: "đẹp lạ thường * to lớn lạ thường",
  },
  {
    word: "la-de",
    part_of_speech: "danh từ",
    meaning:
      "(A: Light Amplification by Stimulated Emission of Radiation, viết tắt) dụng cụ phát các sóng điện từ đơn sắc dựa vào bức xạ cảm ứng: tia laser * máy in laser",
    example: "tia laser * máy in laser",
  },
  {
    word: "lác",
    part_of_speech: "danh từ",
    meaning: "cỏ lác (nói tắt): năn, lác mọc đầy ruộng",
    example: "năn, lác mọc đầy ruộng",
  },
  {
    word: "lác",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ) cói: chiếu lác",
    example: "chiếu lác",
  },
  {
    word: "lác",
    part_of_speech: "tính từ",
    meaning: "(mắt) có trung tâm hai con ngươi không cân đối: mắt lác",
    example: "mắt lác",
  },
  {
    word: "lạc",
    part_of_speech: "danh từ",
    meaning:
      "(Nam đậu phộng) cây thuộc họ đậu, thân bò hay thân đứng, lá kép có bốn lá chét, quả mọc cắm xuống đất, hạt dùng để ăn hay ép dầu: bóc vỏ lạc * kẹo lạc",
    example: "bóc vỏ lạc * kẹo lạc",
  },
  {
    word: "lạc",
    part_of_speech: "động từ",
    meaning:
      "không theo được đúng đường, đúng hướng phải đi: bị lạc đường * đi lạc * đánh lạc hướng * nói lạc sang chuyện khác",
    example:
      "bị lạc đường * đi lạc * đánh lạc hướng * nói lạc sang chuyện khác",
  },
  {
    word: "lạc",
    part_of_speech: "động từ",
    meaning:
      'bị tách lìa ra khỏi mà không tìm được đường về lại: con lạc mẹ * lạc đơn vị * "Một mình ngơ ngẩn đường mây, Khác nào chiếc nhạn lạc bầy kêu sương." (LVT)',
    example:
      'con lạc mẹ * lạc đơn vị * "Một mình ngơ ngẩn đường mây, Khác nào chiếc nhạn lạc bầy kêu sương." (LVT)',
  },
  {
    word: "lạc",
    part_of_speech: "động từ",
    meaning:
      "bị mất đi, vì ở đâu đó mà chưa tìm thấy: mẹ lạc con * lạc đâu mất quyển sách",
    example: "mẹ lạc con * lạc đâu mất quyển sách",
  },
  {
    word: "lạc",
    part_of_speech: "động từ",
    meaning:
      "(giọng nói, mắt nhìn) trở thành khác hẳn đi, không bình thường, do bị kích động hoặc quá xúc động: gọi đến lạc cả giọng * đôi mắt lạc đi vì sợ hãi",
    example: "gọi đến lạc cả giọng * đôi mắt lạc đi vì sợ hãi",
  },
  {
    word: "lạc đề",
    part_of_speech: "tính từ",
    meaning:
      "sai, chệch yêu cầu về nội dung, không theo đúng chủ đề: bài làm bị lạc đề * hỏi một câu lạc đề",
    example: "bài làm bị lạc đề * hỏi một câu lạc đề",
  },
  {
    word: "labo",
    part_of_speech: "danh từ",
    meaning: "phòng thí nghiệm: labo sinh hoá * labo huyết học",
    example: "labo sinh hoá * labo huyết học",
  },
  {
    word: "lạc khoản",
    part_of_speech: "danh từ",
    meaning:
      "dòng chữ nhỏ ghi ngày tháng và tên người vẽ tranh, đi câu đối, dựng bia, v.v., thường là ở góc phía dưới: đề lạc khoản",
    example: "đề lạc khoản",
  },
  {
    word: "lác đác",
    part_of_speech: "tính từ",
    meaning:
      "thưa và rải rác, mỗi chỗ, mỗi lần một ít: mưa lác đác rơi * sao mọc lác đác * chợ có lác đác mấy người",
    example: "mưa lác đác rơi * sao mọc lác đác * chợ có lác đác mấy người",
  },
  {
    word: "lạc hậu",
    part_of_speech: "tính từ",
    meaning:
      "bị tụt lại phía sau, không theo kịp đà tiến bộ, đà phát triển chung: nền kinh tế lạc hậu * tư tưởng lạc hậu",
    example: "nền kinh tế lạc hậu * tư tưởng lạc hậu",
  },
  {
    word: "lạc hậu",
    part_of_speech: "tính từ",
    meaning:
      "đã trở nên cũ, không còn thích hợp với hoàn cảnh, yêu cầu, điều kiện mới: máy móc cũ kĩ, lạc hậu * tin ấy đã lạc hậu rồi!",
    example: "máy móc cũ kĩ, lạc hậu * tin ấy đã lạc hậu rồi!",
  },
  {
    word: "lạc lõng",
    part_of_speech: "",
    meaning:
      "bị tản mát đi mỗi người một ngả, tất cả đều lạc nhau: lạc lõng mỗi người một ngả",
    example: "lạc lõng mỗi người một ngả",
  },
  {
    word: "lạc lõng",
    part_of_speech: "",
    meaning:
      "bơ vơ, lẻ loi một mình, do bị ở vào một hoàn cảnh hoàn toàn xa lạ: lạc lõng nơi đất khách quê người",
    example: "lạc lõng nơi đất khách quê người",
  },
  {
    word: "lạc lõng",
    part_of_speech: "",
    meaning:
      "không ăn nhập, không hoà hợp được với xung quanh, với toàn thể: một câu hỏi lạc lõng * lối sống lạc lõng",
    example: "một câu hỏi lạc lõng * lối sống lạc lõng",
  },
  {
    word: "lạc loài",
    part_of_speech: "tính từ",
    meaning:
      'bơ vơ, không có chỗ dựa, do bị sống tách khỏi thân thích, đồng loại: kiếp sống lạc loài * "Khói mù nghi ngút ngàn khơi, Con chim bạt gió lạc loài kêu thương." (CPN)',
    example:
      'kiếp sống lạc loài * "Khói mù nghi ngút ngàn khơi, Con chim bạt gió lạc loài kêu thương." (CPN)',
  },
  {
    word: "lạc điệu",
    part_of_speech: "tính từ",
    meaning: "sai, chệch ra khỏi điệu của bài hát, bản nhạc: hát lạc điệu",
    example: "hát lạc điệu",
  },
  {
    word: "lạc điệu",
    part_of_speech: "tính từ",
    meaning:
      "không ăn khớp, không phù hợp với hoàn cảnh, không khí chung: kiểu tóc đã lạc điệu * pha một câu đùa lạc điệu",
    example: "kiểu tóc đã lạc điệu * pha một câu đùa lạc điệu",
  },
  {
    word: "lác mắt",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) thấy hết sức ngạc nhiên và thán phục: diện bộ ấy vào thì thiên hạ có mà lác mắt!",
    example: "diện bộ ấy vào thì thiên hạ có mà lác mắt!",
  },
  {
    word: "lạc quan",
    part_of_speech: "tính từ",
    meaning:
      "có cách nhìn, thái độ tin tưởng ở tương lai tốt đẹp: tư tưởng lạc quan * có cái nhìn lạc quan * sống lạc quan yêu đời",
    example: "tư tưởng lạc quan * có cái nhìn lạc quan * sống lạc quan yêu đời",
  },
  {
    word: "lạc quan",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có nhiều triển vọng tốt đẹp, đáng tin tưởng: tình hình rất lạc quan",
    example: "tình hình rất lạc quan",
  },
  {
    word: "lạc thú",
    part_of_speech: "danh từ",
    meaning: "thú vui (thường nói về những thú vật chất): tận hưởng lạc thú",
    example: "tận hưởng lạc thú",
  },
  {
    word: "lạc nghiệp",
    part_of_speech: "tính từ",
    meaning: "vui vẻ làm ăn: có an cư thì mới lạc nghiệp",
    example: "có an cư thì mới lạc nghiệp",
  },
  {
    word: "lạch",
    part_of_speech: "danh từ",
    meaning:
      "đường nước chảy hẹp, nông, ít dốc, thông ra sông, hồ: khơi con lạch",
    example: "khơi con lạch",
  },
  {
    word: "lạch",
    part_of_speech: "danh từ",
    meaning:
      'chỗ sâu nhất trong dòng sông: "Lên non mới biết non cao, Lội sông mới biết lạch nào cạn sâu." (ca dao)',
    example:
      'Lên non mới biết non cao, Lội sông mới biết lạch nào cạn sâu." (ca dao)',
  },
  {
    word: "lách",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) lá lách (nói tắt): bị giập lách",
    example: "bị giập lách",
  },
  {
    word: "lách",
    part_of_speech: "danh từ",
    meaning:
      'cỏ thân ba cạnh, thường mọc ở chỗ có nước: "Đường đi những lách cùng lau, Cha mẹ tham giàu, ép uổng duyên con." (ca dao)',
    example:
      'Đường đi những lách cùng lau, Cha mẹ tham giàu, ép uổng duyên con." (ca dao)',
  },
  {
    word: "lách",
    part_of_speech: "động từ",
    meaning:
      "đưa mình qua chỗ chật hẹp hoặc nơi đông đúc một cách khéo léo, nhanh nhẹn: lách mình qua khe đá * lách qua đám đông",
    example: "lách mình qua khe đá * lách qua đám đông",
  },
  {
    word: "lách",
    part_of_speech: "động từ",
    meaning:
      "lựa chiều để khéo léo, nhẹ nhàng đưa lọt qua, đưa sâu vào một chỗ hẹp: lách lưỡi dao vào bụng cá",
    example: "lách lưỡi dao vào bụng cá",
  },
  {
    word: "lạch cạch",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng những tiếng gọn và trầm của vật cứng va đập vào nhau: lạch cạch mở khoá cửa * bát đũa khua lạch cạch",
    example: "lạch cạch mở khoá cửa * bát đũa khua lạch cạch",
  },
  {
    word: "lách cách",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng những tiếng đanh, gọn, và không đều của các vật cứng, nhỏ va chạm vào nhau: tiếng thoi gieo lách cách * bát đũa chạm nhau kêu lách cách",
    example: "tiếng thoi gieo lách cách * bát đũa chạm nhau kêu lách cách",
  },
  {
    word: "lạch bạch",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng những tiếng giống như tiếng bàn chân bước đi nặng nề, chậm chạp trên đất mềm: lạch bạch như vịt bầu * tiếng chân giẫm lạch bạch",
    example: "lạch bạch như vịt bầu * tiếng chân giẫm lạch bạch",
  },
  {
    word: "lạch đạch",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như lạch bạch: chạy lạch đạch",
    example: "chạy lạch đạch",
  },
  {
    word: "lách chách",
    part_of_speech: "tính từ",
    meaning: "thấp bé như dáng trẻ con: dáng người lách chách",
    example: "dáng người lách chách",
  },
  {
    word: "lách chách",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng phát ra nhỏ nhẹ, gióng một như tiếng nước vỗ nhẹ hay tiếng chim kêu: tiếng chim non lách chách trong vòm lá",
    example: "tiếng chim non lách chách trong vòm lá",
  },
  {
    word: "lách nhách",
    part_of_speech: "tính từ",
    meaning: "như lách chách: chó sủa lách nhách",
    example: "chó sủa lách nhách",
  },
  {
    word: "lãi",
    part_of_speech: "động từ",
    meaning:
      "thu vượt chi sau một quá trình kinh doanh hay sản xuất: buôn hàng này rất lãi * trồng hoa lãi hơn trồng lúa * buôn một lãi mười",
    example:
      "buôn hàng này rất lãi * trồng hoa lãi hơn trồng lúa * buôn một lãi mười",
  },
  {
    word: "lãi",
    part_of_speech: "danh từ",
    meaning:
      "khoản tiền người vay nợ phải trả thêm cho người chủ nợ ngoài số tiền đã vay: cho vay lấy lãi * vay nặng lãi (phải trả lãi cao)",
    example: "cho vay lấy lãi * vay nặng lãi (phải trả lãi cao)",
  },
  {
    word: "lạch xạch",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng những tiếng động nhỏ, trầm, như tiếng của các vật bé và cứng xô đụng nhẹ vào nhau: đạp máy khâu lạch xạch",
    example: "đạp máy khâu lạch xạch",
  },
  {
    word: "lạch tạch",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng những tiếng giống như tiếng pháo nổ nhỏ, liên tiếp: pháo nổ lạch tạch * ngón tay gõ lạch tạch vào ống nứa",
    example: "pháo nổ lạch tạch * ngón tay gõ lạch tạch vào ống nứa",
  },
  {
    word: "lai",
    part_of_speech: "danh từ",
    meaning: "(Nam) gấu (quần, áo): lai quần",
    example: "lai quần",
  },
  {
    word: "lai",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) phân: chiếc nhẫn vàng năm lai * một li một lai cũng không cho",
    example: "chiếc nhẫn vàng năm lai * một li một lai cũng không cho",
  },
  {
    word: "lai",
    part_of_speech: "động từ",
    meaning:
      "lai giống (nói tắt): cho lừa lai với ngựa * lai các giống ngô * cam lai bưởi",
    example: "cho lừa lai với ngựa * lai các giống ngô * cam lai bưởi",
  },
  {
    word: "lai",
    part_of_speech: "động từ",
    meaning:
      "(Trung) đèo bằng xe đạp, xe máy: lai con đi học * lai một tải hàng * lai bằng xe đạp",
    example: "lai con đi học * lai một tải hàng * lai bằng xe đạp",
  },
  {
    word: "lai",
    part_of_speech: "động từ",
    meaning:
      "(phương tiện vận tải đường thuỷ) đưa đi kèm theo: ca nô lai phà cập bến",
    example: "ca nô lai phà cập bến",
  },
  {
    word: "lai",
    part_of_speech: "tính từ",
    meaning:
      "được sinh ra từ cha mẹ thuộc dân tộc khác nhau, hay được tạo ra bằng lai giống: la là con lai giữa lừa với ngựa * ngô lai * đứa con lai",
    example: "la là con lai giữa lừa với ngựa * ngô lai * đứa con lai",
  },
  {
    word: "lai",
    part_of_speech: "tính từ",
    meaning:
      "pha tạp do vay mượn, bắt chước của nước ngoài một cách sống sượng, chắp vá: kiểu văn lai",
    example: "kiểu văn lai",
  },
  {
    word: "lách tách",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng những tiếng phát ra nhỏ, gọn và liên tiếp, như tiếng nổ của muối rang: than nổ lách tách trong lò",
    example: "than nổ lách tách trong lò",
  },
  {
    word: "lái",
    part_of_speech: "động từ",
    meaning:
      "điều khiển các phương tiện vận tải, một số máy móc cho đi đúng hướng: lái đò * lái ô tô * lái thuyền vào bến",
    example: "lái đò * lái ô tô * lái thuyền vào bến",
  },
  {
    word: "lái",
    part_of_speech: "động từ",
    meaning:
      "khéo léo làm cho một hoạt động nào đó đi vào hướng mình muốn: lái mọi người vào chủ đề chính * lái câu chuyện sang hướng khác",
    example: "lái mọi người vào chủ đề chính * lái câu chuyện sang hướng khác",
  },
  {
    word: "lái",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận của các phương tiện vận tải hoặc một số máy móc dùng để lái: cầm lái * bẻ lái",
    example: "cầm lái * bẻ lái",
  },
  {
    word: "lái",
    part_of_speech: "danh từ",
    meaning:
      '(Khẩu ngữ) lái xe, lái đò (nói tắt): bác lái * "Đã mấy lần sông trôi, trôi mãi, Mấy lần cô lái mỏi mòn trông." (NgBính; 5)',
    example:
      'bác lái * "Đã mấy lần sông trôi, trôi mãi, Mấy lần cô lái mỏi mòn trông." (NgBính; 5)',
  },
  {
    word: "lái",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) người chuyên nghề buôn chuyến một loại hàng hoá nhất định: lái trâu * lái lợn * lái gỗ",
    example: "lái trâu * lái lợn * lái gỗ",
  },
  {
    word: "lai dắt",
    part_of_speech: "động từ",
    meaning:
      "(tàu chuyên dụng) kéo và dẫn đường cho tàu khác di chuyển an toàn trên sông biển khi có sự cố, tai nạn hoặc gặp trở ngại về luồng lạch: lai dắt tàu cập cảng",
    example: "lai dắt tàu cập cảng",
  },
  {
    word: "lại",
    part_of_speech: "danh từ",
    meaning:
      "(Từ cũ, Ít dùng) tên gọi chung viên chức sơ cấp chuyên làm công việc bàn giấy trong bộ máy nhà nước phong kiến: quan tham, lại nhũng (tng)",
    example: "quan tham, lại nhũng (tng)",
  },
  {
    word: "lại",
    part_of_speech: "động từ",
    meaning:
      "di chuyển ngược chiều với sự di chuyển vừa nói đến trước đó: kẻ đi người lại * đánh kẻ chạy đi, chứ ai đánh người chạy lại",
    example: "kẻ đi người lại * đánh kẻ chạy đi, chứ ai đánh người chạy lại",
  },
  {
    word: "lại",
    part_of_speech: "động từ",
    meaning:
      "di chuyển trong phạm vi gần, đến chỗ của mình, của người thân quen hoặc những nơi xung quanh mình: con lại đây với mẹ! * mời cụ lại nhà * anh ngồi đây, tôi lại đằng này có chút việc",
    example:
      "con lại đây với mẹ! * mời cụ lại nhà * anh ngồi đây, tôi lại đằng này có chút việc",
  },
  {
    word: "lại",
    part_of_speech: "động từ",
    meaning:
      "từ biểu thị sự lặp, sự tái diễn của một hoạt động vì lí do nào đó thấy là cần thiết: đập đi xây lại * điều đó cần phải suy nghĩ lại * đoạn này nên viết lại",
    example:
      "đập đi xây lại * điều đó cần phải suy nghĩ lại * đoạn này nên viết lại",
  },
  {
    word: "lại",
    part_of_speech: "động từ",
    meaning:
      "từ dùng phối hợp với đi trước đó để biểu thị sự lặp, sự tái diễn nhiều lần của cùng một hành động, một hiện tượng hay của hai hành động, hai hiện tượng ngược nhau nhưng thuộc cùng một phạm trù: đọc đi đọc lại mà vẫn chưa hiểu * hỏi đi, hỏi lại cặn kẽ * mấy lần chết đi sống lại",
    example:
      "đọc đi đọc lại mà vẫn chưa hiểu * hỏi đi, hỏi lại cặn kẽ * mấy lần chết đi sống lại",
  },
  {
    word: "lại",
    part_of_speech: "động từ",
    meaning:
      "từ biểu thị tính chất ngược chiều của hoạt động so với một hoạt động khác trước đó (đã nói hoặc đã biết): bán lại cái xe * trả lại tiền thừa * cãi lại",
    example: "bán lại cái xe * trả lại tiền thừa * cãi lại",
  },
  {
    word: "lại",
    part_of_speech: "động từ",
    meaning:
      "từ biểu thị tính chất ngược chiều của một hoạt động hay một quá trình hướng về cái ở đằng sau, cái đã qua, cái ban đầu: xe lùi lại * nhớ lại chuyện cũ * người như trẻ lại",
    example: "xe lùi lại * nhớ lại chuyện cũ * người như trẻ lại",
  },
  {
    word: "lại",
    part_of_speech: "động từ",
    meaning:
      "từ biểu thị hướng của hoạt động nhằm quy tụ về một chỗ hoặc thu nhỏ, thu hẹp phạm vi của hoạt động hay quá trình: dồn lại thành một đống * xích lại gần nhau * nằm co người lại",
    example: "dồn lại thành một đống * xích lại gần nhau * nằm co người lại",
  },
  {
    word: "lại",
    part_of_speech: "động từ",
    meaning:
      "từ biểu thị hướng của hoạt động nhằm kìm giữ, kìm hãm, không để cho mở rộng, vận động, phát triển: gói quần áo lại * níu lại, không cho đi * tạm gác việc này lại",
    example: "gói quần áo lại * níu lại, không cho đi * tạm gác việc này lại",
  },
  {
    word: "lại",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) từ biểu thị khả năng đối phó được, đối phó có hiệu quả: đánh không lại",
    example: "đánh không lại",
  },
  {
    word: "lại",
    part_of_speech: "động từ",
    meaning:
      "trở ngược về trạng thái cũ, như trước khi có sự biến đổi: ăn cho lại sức * ốm giờ vẫn chưa lại người",
    example: "ăn cho lại sức * ốm giờ vẫn chưa lại người",
  },
  {
    word: "lại",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị tính chất lặp, tái diễn hay tiếp nối của một hoạt động, một hiện tượng: trời lại mưa * bệnh cũ lại tái phát * đâu lại vào đấy cả",
    example: "trời lại mưa * bệnh cũ lại tái phát * đâu lại vào đấy cả",
  },
  {
    word: "lại",
    part_of_speech: "phụ từ",
    meaning:
      'từ biểu thị hoạt động, tính chất trái với lẽ thường của sự việc, hiện tượng: đã không biết lại còn cãi * sao lại nghĩ thế? * "Hoa tàn mà lại thêm tươi, Trăng tàn mà lại hơn mười rằm xưa." (TKiều)',
    example:
      'đã không biết lại còn cãi * sao lại nghĩ thế? * "Hoa tàn mà lại thêm tươi, Trăng tàn mà lại hơn mười rằm xưa." (TKiều)',
  },
  {
    word: "lai căng",
    part_of_speech: "tính từ",
    meaning:
      "có pha tạp nhiều yếu tố ngoại lai sống sượng, trở nên lố lăng: văn hoá lai căng * loại trừ mầm mống lai căng",
    example: "văn hoá lai căng * loại trừ mầm mống lai căng",
  },
  {
    word: "lái buôn",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người chuyên nghề buôn bán lớn và buôn bán đường dài: gã lái buôn",
    example: "gã lái buôn",
  },
  {
    word: "lại gan",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) hả giận: phải cho nó một trận thì mới lại gan",
    example: "phải cho nó một trận thì mới lại gan",
  },
  {
    word: "lái đò",
    part_of_speech: "danh từ",
    meaning:
      "người chuyên nghề đưa đò, chuyên chở khách và hàng hoá trên sông: người lái đò",
    example: "người lái đò",
  },
  {
    word: "lài",
    part_of_speech: "tính từ",
    meaning:
      '(phương ngữ) thoai thoải: "Anh đây như thể lão chài, Vực sâu anh thả lưới, bãi lài anh buông câu." (ca dao)',
    example:
      'Anh đây như thể lão chài, Vực sâu anh thả lưới, bãi lài anh buông câu." (ca dao)',
  },
  {
    word: "lai giống",
    part_of_speech: "động từ",
    meaning:
      "cho con đực và con cái khác giống giao phối với nhau, hoặc ghép giống cây này trên giống cây khác, hay là dùng biện pháp thụ tinh, giao phấn nhân tạo nhằm tạo ra một giống mới: lai giống bò",
    example: "lai giống bò",
  },
  {
    word: "lại hồn",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) trở lại trạng thái tinh thần bình thường sau cơn hoảng sợ hay ốm nặng kéo dài: ốm một trận thập tử nhất sinh, giờ vẫn chưa lại hồn",
    example: "ốm một trận thập tử nhất sinh, giờ vẫn chưa lại hồn",
  },
  {
    word: "lại gạo",
    part_of_speech: "động từ",
    meaning:
      "trở lại khô cứng như lúc gạo chưa nấu chín (thường nói về các loại bánh làm bằng gạo nếp): bánh chưng để lâu đã lại gạo",
    example: "bánh chưng để lâu đã lại gạo",
  },
  {
    word: "lai láng",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) tràn đầy khắp cả, như đâu đâu cũng có: nước lai láng khắp cánh đồng",
    example: "nước lai láng khắp cánh đồng",
  },
  {
    word: "lai láng",
    part_of_speech: "tính từ",
    meaning:
      '(tình cảm) chứa chan, tràn ngập: hồn thơ lai láng * "Tình xưa lai láng khôn hàn, Thong dong lại hỏi ngón đàn ngày xưa." (TKiều)',
    example:
      'hồn thơ lai láng * "Tình xưa lai láng khôn hàn, Thong dong lại hỏi ngón đàn ngày xưa." (TKiều)',
  },
  {
    word: "lai lịch",
    part_of_speech: "danh từ",
    meaning:
      "nguồn gốc và bước đường đã trải qua: tìm hiểu lai lịch của đối phương * lai lịch không rõ ràng",
    example: "tìm hiểu lai lịch của đối phương * lai lịch không rõ ràng",
  },
  {
    word: "lãi lờ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) như lời lãi: chuyến hàng này, lãi lờ chẳng đáng là bao",
    example: "chuyến hàng này, lãi lờ chẳng đáng là bao",
  },
  {
    word: "lai kinh tế",
    part_of_speech: "động từ",
    meaning:
      "lai giống để lấy con, nuôi đạt hiệu quả kinh tế cao hơn so với giống thuần: lợn lai kinh tế",
    example: "lợn lai kinh tế",
  },
  {
    word: "lại mặt",
    part_of_speech: "động từ",
    meaning:
      "(vợ chồng mới cưới) đưa nhau về thăm nhà vợ ngay sau hôm đón dâu, theo tục lệ cưới xin cổ truyền: lễ lại mặt",
    example: "lễ lại mặt",
  },
  {
    word: "lại mũi",
    part_of_speech: "động từ",
    meaning:
      "(khâu) lùi trở lại một chút so với mũi trước rồi mới nhích lên thành mũi mới (để cho chắc): khâu lại mũi",
    example: "khâu lại mũi",
  },
  {
    word: "lai nhai",
    part_of_speech: "tính từ",
    meaning:
      "chậm chạp, kéo dài mãi mà không xong, gây cảm giác khó chịu: nói lai nhai * làm lai nhai cả tháng trời",
    example: "nói lai nhai * làm lai nhai cả tháng trời",
  },
  {
    word: "lại người",
    part_of_speech: "động từ",
    meaning:
      "trở lại trạng thái cơ thể bình thường sau thời gian bị mất sức: cố gắng ăn uống, nghỉ ngơi cho lại người",
    example: "cố gắng ăn uống, nghỉ ngơi cho lại người",
  },
  {
    word: "lải nhải",
    part_of_speech: "động từ",
    meaning:
      "nói đi nói lại mãi, nghe nhàm chán, khó chịu: cứ lải nhải mãi một chuyện * nói lải nhải",
    example: "cứ lải nhải mãi một chuyện * nói lải nhải",
  },
  {
    word: "lài nhài",
    part_of_speech: "động từ",
    meaning: "(hiếm) như lải nhải: nói lài nhài",
    example: "nói lài nhài",
  },
  {
    word: "lai rai",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái đều đều ít một và kéo dài ra, chứ không tập trung vào một thời gian nhất định: lúa chín lai rai * mưa lai rai mãi không dứt * ốm lai rai cả tháng trời",
    example:
      "lúa chín lai rai * mưa lai rai mãi không dứt * ốm lai rai cả tháng trời",
  },
  {
    word: "lai vãng",
    part_of_speech: "động từ",
    meaning:
      'qua lại, lui tới: "Hơn nửa tháng nay hắn có lai vãng gì đến nhà này đâu!" (KLân; 6)',
    example: 'Hơn nửa tháng nay hắn có lai vãng gì đến nhà này đâu!" (KLân; 6)',
  },
  {
    word: "lai sinh",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) kiếp sau, theo thuyết luân hồi của đạo Phật: "Muôn vàn tạ chút hậu tình, Ơn này may có lai sinh là còn." (HT)',
    example: 'Muôn vàn tạ chút hậu tình, Ơn này may có lai sinh là còn." (HT)',
  },
  {
    word: "lai tạo",
    part_of_speech: "động từ",
    meaning:
      "tạo ra bằng cách lai giống: lai tạo giống lúa mới * lai tạo đàn bò * lai tạo giống để nâng cao năng suất",
    example:
      "lai tạo giống lúa mới * lai tạo đàn bò * lai tạo giống để nâng cao năng suất",
  },
  {
    word: "lãi suất",
    part_of_speech: "danh từ",
    meaning:
      "tỉ lệ phần trăm giữa lãi so với vốn: lãi suất cho vay * tính theo lãi suất ngân hàng * cho vay với lãi suất cao",
    example:
      "lãi suất cho vay * tính theo lãi suất ngân hàng * cho vay với lãi suất cao",
  },
  {
    word: "lai tạp",
    part_of_speech: "động từ",
    meaning:
      "pha lẫn nhiều yếu tố ngoại lai, không thuần nhất: nói bằng giọng Bắc lai tạp",
    example: "nói bằng giọng Bắc lai tạp",
  },
  {
    word: "lái xe",
    part_of_speech: "danh từ",
    meaning: "người làm nghề lái ô tô: tuyển lái xe cho cơ quan",
    example: "tuyển lái xe cho cơ quan",
  },
  {
    word: "làm ăn",
    part_of_speech: "động từ",
    meaning:
      "làm việc, lao động để sinh sống (nói khái quát): vay vốn làm ăn * làm ăn phát đạt * đi làm ăn xa",
    example: "vay vốn làm ăn * làm ăn phát đạt * đi làm ăn xa",
  },
  {
    word: "làm ăn",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) xử lí công việc cụ thể (nói khái quát): cung cách làm ăn * làm ăn cẩn thận * làm ăn vô nguyên tắc",
    example: "cung cách làm ăn * làm ăn cẩn thận * làm ăn vô nguyên tắc",
  },
  {
    word: "lam",
    part_of_speech: "động từ",
    meaning:
      "(cơm) nấu bằng ống nứa hay ống vầu thay cho nồi (một cách nấu cơm ở một số vùng dân tộc thiểu số): lam cơm",
    example: "lam cơm",
  },
  {
    word: "lam",
    part_of_speech: "tính từ",
    meaning:
      "có màu xanh đậm hơn màu da trời: khói lam chiều * sương lam * khoảng trời màu lam sẫm",
    example: "khói lam chiều * sương lam * khoảng trời màu lam sẫm",
  },
  {
    word: "lạm",
    part_of_speech: "động từ",
    meaning:
      "vượt quá phạm vi, giới hạn được quy định, cho phép: tiêu lạm tiền công quỹ",
    example: "tiêu lạm tiền công quỹ",
  },
  {
    word: "làm bàn",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tạo ra bàn thắng, trong môn bóng đá: cây làm bàn của đội tuyển * tạo cơ hội cho đồng đội làm bàn",
    example: "cây làm bàn của đội tuyển * tạo cơ hội cho đồng đội làm bàn",
  },
  {
    word: "làm",
    part_of_speech: "động từ",
    meaning:
      "dùng công sức tạo ra cái trước đó không có: chim làm tổ * làm nhà mới * làm đơn * làm thơ",
    example: "chim làm tổ * làm nhà mới * làm đơn * làm thơ",
  },
  {
    word: "làm",
    part_of_speech: "động từ",
    meaning:
      "dùng công sức vào những việc, những nghề nhất định nào đó để sinh sống, nói chung: làm ruộng * làm giáo viên * tay làm hàm nhai (tng)",
    example: "làm ruộng * làm giáo viên * tay làm hàm nhai (tng)",
  },
  {
    word: "làm",
    part_of_speech: "động từ",
    meaning:
      "dùng công sức vào những việc khác nhau, nhằm một mục đích nhất định nào đó: việc đáng làm * dám nghĩ dám làm * đói ăn vụng, túng làm càn (tng)",
    example:
      "việc đáng làm * dám nghĩ dám làm * đói ăn vụng, túng làm càn (tng)",
  },
  {
    word: "làm",
    part_of_speech: "động từ",
    meaning:
      "tổ chức, tiến hành một việc có tính chất trọng thể: làm lễ khánh thành * làm ma * làm giỗ",
    example: "làm lễ khánh thành * làm ma * làm giỗ",
  },
  {
    word: "làm",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) thực hiện một hành vi thuộc sinh hoạt hằng ngày, như ăn uống, nghỉ ngơi, giải trí, mà nội dung cụ thể tuỳ theo nghĩa của bổ ngữ đứng sau: làm chén nước cho ấm bụng * làm một giấc đến sáng * làm vài ván cờ",
    example:
      "làm chén nước cho ấm bụng * làm một giấc đến sáng * làm vài ván cờ",
  },
  {
    word: "làm",
    part_of_speech: "động từ",
    meaning:
      "làm những việc thuộc nhiệm vụ hoặc quyền hạn gắn với một tư cách, địa vị, chức vụ nào đó, nói chung: làm mẹ * phận làm con * bị bắt cóc làm con tin",
    example: "làm mẹ * phận làm con * bị bắt cóc làm con tin",
  },
  {
    word: "làm",
    part_of_speech: "động từ",
    meaning:
      "có tác dụng hoặc dùng như là, coi như là: cây trồng làm cảnh * chiếm làm của riêng * lấy công làm lãi",
    example: "cây trồng làm cảnh * chiếm làm của riêng * lấy công làm lãi",
  },
  {
    word: "làm",
    part_of_speech: "động từ",
    meaning:
      "từ biểu đạt một hành vi, một hoạt động là nguyên nhân trực tiếp gây ra hoặc do sơ suất, không may mà xảy ra: làm mất tài liệu * bão làm đổ cây * làm vui lòng khách * làm khó dễ",
    example:
      "làm mất tài liệu * bão làm đổ cây * làm vui lòng khách * làm khó dễ",
  },
  {
    word: "làm",
    part_of_speech: "động từ",
    meaning:
      "tự tạo cho mình một dáng vẻ như thế nào đó trong một hoàn cảnh ứng xử cụ thể: làm ra vẻ thông thạo * làm như không quen biết * ngoảnh mặt làm ngơ",
    example:
      "làm ra vẻ thông thạo * làm như không quen biết * ngoảnh mặt làm ngơ",
  },
  {
    word: "làm",
    part_of_speech: "động từ",
    meaning:
      "từ biểu thị kết quả, đơn thuần về mặt số lượng, của một hoạt động phân hay gộp: cắt cái bánh làm tư * gộp hai mã cân làm một * chia làm nhiều đợt",
    example:
      "cắt cái bánh làm tư * gộp hai mã cân làm một * chia làm nhiều đợt",
  },
  {
    word: "làm",
    part_of_speech: "động từ",
    meaning:
      "giết và loại bỏ những phần không dùng được để sử dụng thành thực phẩm: làm cá phải nhớ bỏ mang * làm gà đãi khách",
    example: "làm cá phải nhớ bỏ mang * làm gà đãi khách",
  },
  {
    word: "lại sức",
    part_of_speech: "động từ",
    meaning:
      "trở lại trạng thái sức khoẻ bình thường sau thời gian bị mất sức, bị yếu đi: ngủ một giấc cho lại sức",
    example: "ngủ một giấc cho lại sức",
  },
  {
    word: "làm bạn",
    part_of_speech: "động từ",
    meaning: "kết thành bạn với nhau: làm bạn với đèn sách",
    example: "làm bạn với đèn sách",
  },
  {
    word: "làm bạn",
    part_of_speech: "động từ",
    meaning: "lấy nhau làm vợ chồng: hai người làm bạn với nhau đã được 5 năm",
    example: "hai người làm bạn với nhau đã được 5 năm",
  },
  {
    word: "làm bằng",
    part_of_speech: "động từ",
    meaning:
      "làm chứng cớ, làm căn cứ để chứng minh tính xác thực của lời nói: có đủ giấy tờ làm bằng",
    example: "có đủ giấy tờ làm bằng",
  },
  {
    word: "làm bé",
    part_of_speech: "động từ",
    meaning:
      '(cũ, hoặc ph) như làm lẽ: "Đói lòng ăn trái thanh yên, Tội chi làm bé, nằm riêng một mình." (ca dao)',
    example:
      'Đói lòng ăn trái thanh yên, Tội chi làm bé, nằm riêng một mình." (ca dao)',
  },
  {
    word: "làm bộ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) làm cho ra vẻ khác người, hơn người bằng dáng điệu, cử chỉ, thái độ không được tự nhiên: làm bộ ta đây * vừa được khen đã vênh mặt làm bộ",
    example: "làm bộ ta đây * vừa được khen đã vênh mặt làm bộ",
  },
  {
    word: "làm bộ",
    part_of_speech: "động từ",
    meaning:
      "làm cho ra vẻ như thật: làm bộ xấu hổ * làm bộ như không thèm để ý",
    example: "làm bộ xấu hổ * làm bộ như không thèm để ý",
  },
  {
    word: "làm biếng",
    part_of_speech: "",
    meaning:
      "(phương ngữ) tỏ ra lười biếng (trước một việc cụ thể nào đó): làm biếng không chịu học",
    example: "làm biếng không chịu học",
  },
  {
    word: "làm bếp",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nấu nướng, chuẩn bị cho bữa ăn: dọn dẹp xong là bắt tay làm bếp",
    example: "dọn dẹp xong là bắt tay làm bếp",
  },
  {
    word: "làm chi",
    part_of_speech: "",
    meaning: "(phương ngữ) như làm gì: chuyện đó nhắc lại làm chi!",
    example: "chuyện đó nhắc lại làm chi!",
  },
  {
    word: "lam chướng",
    part_of_speech: "danh từ",
    meaning: "(cũ) như chướng khí: vùng đất có lam chướng",
    example: "vùng đất có lam chướng",
  },
  {
    word: "làm chay",
    part_of_speech: "động từ",
    meaning:
      "làm lễ cúng để cầu cho linh hồn người chết được siêu thoát: làm chay cho mẹ",
    example: "làm chay cho mẹ",
  },
  {
    word: "làm chủ",
    part_of_speech: "động từ",
    meaning: "có quyền sở hữu đối với tài sản nào đó: làm chủ hiệu buôn lớn",
    example: "làm chủ hiệu buôn lớn",
  },
  {
    word: "làm chủ",
    part_of_speech: "động từ",
    meaning:
      "có quyền hoặc khả năng quản lí, điều khiển, chi phối theo ý của mình: làm chủ tình thế * không làm chủ được tốc độ * phát huy tinh thần làm chủ",
    example:
      "làm chủ tình thế * không làm chủ được tốc độ * phát huy tinh thần làm chủ",
  },
  {
    word: "làm bộ làm tịch",
    part_of_speech: "",
    meaning:
      "như làm bộ (ng1; nhưng nghĩa mạnh hơn): hơi một tí là làm bộ làm tịch",
    example: "hơi một tí là làm bộ làm tịch",
  },
  {
    word: "làm cao",
    part_of_speech: "động từ",
    meaning:
      "làm ra vẻ có giá trị cao nên không cần đến: làm cao không bán * thích nhưng vẫn tỏ vẻ làm cao",
    example: "làm cao không bán * thích nhưng vẫn tỏ vẻ làm cao",
  },
  {
    word: "làm chứng",
    part_of_speech: "động từ",
    meaning:
      "(người không phải là đương sự) đứng ra xác nhận những điều mình đã chứng kiến: người làm chứng",
    example: "người làm chứng",
  },
  {
    word: "làm cỏ",
    part_of_speech: "động từ",
    meaning:
      "làm cho sạch cỏ dại (ở ruộng, vườn): làm cỏ lúa * làm cỏ vườn * thứ nhất làm cỏ, thứ nhì bỏ phân (tng)",
    example:
      "làm cỏ lúa * làm cỏ vườn * thứ nhất làm cỏ, thứ nhì bỏ phân (tng)",
  },
  {
    word: "làm cỏ",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) tiêu diệt sạch: giặc định làm cỏ cả làng",
    example: "giặc định làm cỏ cả làng",
  },
  {
    word: "làm công",
    part_of_speech: "động từ",
    meaning: "làm việc để lấy tiền công: làm công ăn lương * người làm công",
    example: "làm công ăn lương * người làm công",
  },
  {
    word: "làm dáng",
    part_of_speech: "động từ",
    meaning:
      "làm cho hình thức bên ngoài trở nên đẹp hơn (bằng trang điểm, chải chuốt hay điệu bộ): tính thích làm dáng",
    example: "tính thích làm dáng",
  },
  {
    word: "làm duyên",
    part_of_speech: "động từ",
    meaning:
      "làm cho mình trở nên duyên dáng bằng cử chỉ, lời nói tế nhị, kín đáo: nở một nụ cười làm duyên",
    example: "nở một nụ cười làm duyên",
  },
  {
    word: "làm dấu",
    part_of_speech: "động từ",
    meaning: "đánh dấu để cho nhớ: cắm cọc làm dấu",
    example: "cắm cọc làm dấu",
  },
  {
    word: "làm dấu",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) làm dấu thánh (nói tắt): đưa tay lên ngực lên trán làm dấu",
    example: "đưa tay lên ngực lên trán làm dấu",
  },
  {
    word: "lạm dụng",
    part_of_speech: "động từ",
    meaning:
      "sử dụng quá mức hoặc quá giới hạn đã được quy định: lạm dụng quyền hành * lạm dụng lòng tốt của người khác",
    example: "lạm dụng quyền hành * lạm dụng lòng tốt của người khác",
  },
  {
    word: "làm dữ",
    part_of_speech: "động từ",
    meaning:
      "làm ầm lên để buộc phải theo ý mình, mặc dù có thể không đáng phải như vậy: được thể càng làm dữ",
    example: "được thể càng làm dữ",
  },
  {
    word: "làm đầu",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) uốn tóc: hiệu làm đầu",
    example: "hiệu làm đầu",
  },
  {
    word: "làm đẹp",
    part_of_speech: "động từ",
    meaning:
      "làm cho hình thức trở nên đẹp bằng cách trang điểm hoặc bằng các biện pháp kĩ thuật đặc biệt: nghệ thuật làm đẹp * dịch vụ làm đẹp",
    example: "nghệ thuật làm đẹp * dịch vụ làm đẹp",
  },
  {
    word: "làm đỏm",
    part_of_speech: "động từ",
    meaning:
      "làm dáng một cách quá đáng, trông không tự nhiên: con gái là chúa làm đỏm",
    example: "con gái là chúa làm đỏm",
  },
  {
    word: "làm gì",
    part_of_speech: "",
    meaning:
      "tổ hợp biểu thị ý cho rằng điều vừa nói đến là chẳng có tác dụng, chẳng ích lợi gì (hàm ý không nên làm, hoặc là có cũng vô ích): nghĩ làm gì cho thêm mệt * chuyện đó thì nói làm gì!",
    example: "nghĩ làm gì cho thêm mệt * chuyện đó thì nói làm gì!",
  },
  {
    word: "làm gì",
    part_of_speech: "",
    meaning:
      "tổ hợp biểu thị ý phủ định, cho là không thể có điều sắp nêu ra: làm gì có chuyện đó! * ăn mãi một món, làm gì chẳng chán!",
    example: "làm gì có chuyện đó! * ăn mãi một món, làm gì chẳng chán!",
  },
  {
    word: "làm gì",
    part_of_speech: "",
    meaning:
      "dùng để hỏi mục đích: Mày cần nhiều tiền (để) làm gì? * Ăn sung mặc sướng để làm gì khi gia đình không hạnh phúc?",
    example:
      "Mày cần nhiều tiền (để) làm gì? * Ăn sung mặc sướng để làm gì khi gia đình không hạnh phúc?",
  },
  {
    word: "làm đồng",
    part_of_speech: "động từ",
    meaning: "làm công việc đồng áng (nói khái quát): đi làm đồng",
    example: "đi làm đồng",
  },
  {
    word: "làm khó",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) gây khó khăn, trở ngại: làm khó cho nhau",
    example: "làm khó cho nhau",
  },
  {
    word: "làm già",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) (Nam thường làm tới) tỏ ra càng không kiêng nể, càng làm lấn tới khi thấy có được ưu thế nào đó: được thể làm già",
    example: "được thể làm già",
  },
  {
    word: "làm hàng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) chuẩn bị, làm ra hàng (thường là hàng ăn) để đem bán: phải dậy sớm để làm hàng",
    example: "phải dậy sớm để làm hàng",
  },
  {
    word: "làm giá",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) định giá cả hàng hoá sau khi đã tính toán kĩ mọi bề: bộ phận làm giá * hai bên đã làm giá từ trước",
    example: "bộ phận làm giá * hai bên đã làm giá từ trước",
  },
  {
    word: "làm giá",
    part_of_speech: "động từ",
    meaning:
      "làm cho giá hàng tăng lên quá cao hay hạ xuống quá thấp so với giá trị thực bằng mánh lới, thủ đoạn để trục lợi: câu kết với nhau làm giá để thao túng thị trường",
    example: "câu kết với nhau làm giá để thao túng thị trường",
  },
  {
    word: "làm giàu",
    part_of_speech: "động từ",
    meaning:
      "làm cho trở nên có nhiều của cải, tiền bạc: học cách làm giàu * có chí làm quan, có gan làm giàu (tng)",
    example: "học cách làm giàu * có chí làm quan, có gan làm giàu (tng)",
  },
  {
    word: "làm giàu",
    part_of_speech: "động từ",
    meaning:
      "làm cho trở nên phong phú, dồi dào: làm giàu vốn kiến thức * làm giàu ngôn ngữ",
    example: "làm giàu vốn kiến thức * làm giàu ngôn ngữ",
  },
  {
    word: "làm khách",
    part_of_speech: "động từ",
    meaning:
      "tỏ ra rụt rè, thiếu tự nhiên khi ăn, uống ở nhà người khác, nên thường ăn ít vì giữ ý: cứ ăn uống tự nhiên, không phải làm khách",
    example: "cứ ăn uống tự nhiên, không phải làm khách",
  },
  {
    word: "làm gương",
    part_of_speech: "động từ",
    meaning:
      "làm cái để cho người khác trông vào mà noi theo hoặc tránh khỏi: ông bà, cha mẹ làm gương cho con cháu * trị để làm gương",
    example: "ông bà, cha mẹ làm gương cho con cháu * trị để làm gương",
  },
  {
    word: "làm không công",
    part_of_speech: "",
    meaning:
      "làm mà không được trả công: làm không công trong thời gian thử việc",
    example: "làm không công trong thời gian thử việc",
  },
  {
    word: "lam làm",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) làm luôn chân luôn tay, hết việc này đến việc khác một cách siêng năng, cần cù (nói khái quát): chịu khó lam làm",
    example: "chịu khó lam làm",
  },
  {
    word: "làm lành",
    part_of_speech: "động từ",
    meaning:
      "làm cho quan hệ trở lại thân thiết như cũ, sau khi giận dỗi: nuốt giận làm lành * biết sai nên phải làm lành",
    example: "nuốt giận làm lành * biết sai nên phải làm lành",
  },
  {
    word: "làm loạn",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) gây rối làm mất trật tự hoặc an ninh chung: dấy quân làm loạn",
    example: "dấy quân làm loạn",
  },
  {
    word: "lam lũ",
    part_of_speech: "tính từ",
    meaning: "(Từ cũ) rách rưới: quần áo lam lũ",
    example: "quần áo lam lũ",
  },
  {
    word: "lam lũ",
    part_of_speech: "tính từ",
    meaning: "vất vả, cực nhọc: cuộc sống lam lũ",
    example: "cuộc sống lam lũ",
  },
  {
    word: "làm luật",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đưa hoặc bắt phải đưa hối lộ cho nhà chức trách hoặc kẻ có quyền thế theo một quy ước ngầm, để được bỏ qua hành vi vi phạm pháp luật (như buôn lậu, trốn thuế, v.v.) hoặc để được dễ bề làm ăn: con buôn làm luật với cán bộ thuế",
    example: "con buôn làm luật với cán bộ thuế",
  },
  {
    word: "làm lụng",
    part_of_speech: "động từ",
    meaning:
      "làm công việc lao động (nói khái quát): chăm chỉ làm lụng * suốt ngày làm lụng vất vả * không chịu làm lụng gì",
    example:
      "chăm chỉ làm lụng * suốt ngày làm lụng vất vả * không chịu làm lụng gì",
  },
  {
    word: "làm lẽ",
    part_of_speech: "động từ",
    meaning: "làm vợ lẽ: đem thân làm lẽ",
    example: "đem thân làm lẽ",
  },
  {
    word: "làm lơ",
    part_of_speech: "động từ",
    meaning:
      'cố ý lơ đi, làm như không nhìn thấy, không nghe thấy, không hay biết gì cả: "Hai tay cầm nắm lạt bẻ cò, Lòng anh thương da diết, sao em giả đò làm lơ?" (Cdao)',
    example:
      'Hai tay cầm nắm lạt bẻ cò, Lòng anh thương da diết, sao em giả đò làm lơ?" (Cdao)',
  },
  {
    word: "làm mai",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) như làm mối: cậy người làm mai",
    example: "cậy người làm mai",
  },
  {
    word: "làm lông",
    part_of_speech: "động từ",
    meaning: "làm sạch lông để sử dụng thành thực phẩm: làm lông con gà",
    example: "làm lông con gà",
  },
  {
    word: "làm mối",
    part_of_speech: "động từ",
    meaning:
      "làm trung gian giới thiệu cho hai bên làm quen với nhau để xây dựng quan hệ hôn nhân hoặc buôn bán: làm mối cho hai người lấy nhau",
    example: "làm mối cho hai người lấy nhau",
  },
  {
    word: "làm ma",
    part_of_speech: "động từ",
    meaning: "làm lễ tiễn đưa người chết, theo phong tục: làm ma cho mẹ",
    example: "làm ma cho mẹ",
  },
  {
    word: "làm mình làm mẩy",
    part_of_speech: "",
    meaning:
      "tỏ thái độ giận dỗi với người thân để phản đối hoặc đòi kì được phải chiều theo ý mình: hơi một tí là làm mình làm mẩy",
    example: "hơi một tí là làm mình làm mẩy",
  },
  {
    word: "làm ngơ",
    part_of_speech: "động từ",
    meaning:
      "ngơ đi, làm như không biết gì cả: ngoảnh mặt làm ngơ * biết sai nhưng vẫn làm ngơ",
    example: "ngoảnh mặt làm ngơ * biết sai nhưng vẫn làm ngơ",
  },
  {
    word: "làm nên",
    part_of_speech: "động từ",
    meaning:
      "thành đạt, có được sự nghiệp: thằng bé thông minh, sau này ắt hẳn làm nên * không thầy đố mày làm nên (tng)",
    example:
      "thằng bé thông minh, sau này ắt hẳn làm nên * không thầy đố mày làm nên (tng)",
  },
  {
    word: "lảm nhảm",
    part_of_speech: "động từ",
    meaning:
      "nói luôn mồm nhưng không đâu vào đâu cả, không rõ muốn nói gì (thường do mê sảng, quẫn trí): nói lảm nhảm * rượu vào lại lảm nhảm một mình",
    example: "nói lảm nhảm * rượu vào lại lảm nhảm một mình",
  },
  {
    word: "làm nũng",
    part_of_speech: "động từ",
    meaning:
      "làm ra vẻ hờn dỗi không bằng lòng, để đòi được chiều chuộng, yêu thương hơn: nhõng nhẽo làm nũng mẹ * làm nũng chồng",
    example: "nhõng nhẽo làm nũng mẹ * làm nũng chồng",
  },
  {
    word: "lam nham",
    part_of_speech: "tính từ",
    meaning:
      "nham nhở, không gọn, không sạch, trông bẩn mắt: tóc cắt lam nham * viết lam nham trong vở",
    example: "tóc cắt lam nham * viết lam nham trong vở",
  },
  {
    word: "làm mướn",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) làm thuê: đi làm mướn",
    example: "đi làm mướn",
  },
  {
    word: "làm nhục",
    part_of_speech: "động từ",
    meaning:
      "làm tổn hại đến danh dự, nhân phẩm: làm nhục gia phong * làm nhục phụ nữ",
    example: "làm nhục gia phong * làm nhục phụ nữ",
  },
  {
    word: "làm ơn",
    part_of_speech: "động từ",
    meaning:
      'làm điều tốt, giúp cho người khác qua được khó khăn: "Vân Tiên nghe nói liền cười, Làm ơn há dễ trông người trả ơn?" (LVT)',
    example:
      'Vân Tiên nghe nói liền cười, Làm ơn há dễ trông người trả ơn?" (LVT)',
  },
  {
    word: "làm ơn",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) tổ hợp dùng để tỏ thái độ lịch sự, lễ độ khi nói ra điều cần phải nhờ, phải hỏi hoặc yêu cầu: làm ơn cho tôi mượn cái bút * anh làm ơn cho hỏi",
    example: "làm ơn cho tôi mượn cái bút * anh làm ơn cho hỏi",
  },
  {
    word: "lạm phát",
    part_of_speech: "",
    meaning:
      "phát hành số lượng tiền vượt quá mức nhu cầu lưu thông hàng hoá, làm cho đồng tiền mất giá: nạn lạm phát",
    example: "nạn lạm phát",
  },
  {
    word: "làm phản",
    part_of_speech: "động từ",
    meaning:
      "quay ra hoạt động chống lại (người, tổ chức mà mình đã theo): âm mưu làm phản * bị khép vào tội làm phản",
    example: "âm mưu làm phản * bị khép vào tội làm phản",
  },
  {
    word: "làm phách",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) lên mặt làm cao, lên mặt ra oai: chỉ giỏi làm phách! * lên mặt làm phách",
    example: "chỉ giỏi làm phách! * lên mặt làm phách",
  },
  {
    word: "làm phúc",
    part_of_speech: "động từ",
    meaning:
      "làm điều tốt lành để cứu giúp người khác (thường được coi là phúc đức để lại cho con cháu về sau): chữa bệnh làm phúc * nhón tay làm phúc",
    example: "chữa bệnh làm phúc * nhón tay làm phúc",
  },
  {
    word: "làm quà",
    part_of_speech: "động từ",
    meaning:
      "dùng làm vật tặng, biếu khi mới tới hoặc đi xa mới về: mua tấm áo làm quà biếu mẹ",
    example: "mua tấm áo làm quà biếu mẹ",
  },
  {
    word: "làm quà",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) (việc làm) chỉ cốt để cho vui, để làm vui lòng người khác: kiếm chuyện làm quà",
    example: "kiếm chuyện làm quà",
  },
  {
    word: "làm phiền",
    part_of_speech: "động từ",
    meaning:
      "gây phiền hà cho người khác, làm cho phải bận tâm: không muốn làm phiền ai * bị người khác làm phiền",
    example: "không muốn làm phiền ai * bị người khác làm phiền",
  },
  {
    word: "làm quen",
    part_of_speech: "động từ",
    meaning:
      "tìm cách để quen với người chưa quen biết: hỏi chuyện làm quen * mới gặp chưa kịp làm quen",
    example: "hỏi chuyện làm quen * mới gặp chưa kịp làm quen",
  },
  {
    word: "làm quen",
    part_of_speech: "động từ",
    meaning:
      "bắt đầu tiếp xúc để biết, để sử dụng: bước đầu làm quen với công việc * làm quen với máy móc hiện đại",
    example: "bước đầu làm quen với công việc * làm quen với máy móc hiện đại",
  },
  {
    word: "lạm quyền",
    part_of_speech: "động từ",
    meaning:
      "làm những việc vượt quá quyền hạn của mình: tố cáo hành vi lạm quyền của giám đốc",
    example: "tố cáo hành vi lạm quyền của giám đốc",
  },
  {
    word: "làm ruộng",
    part_of_speech: "động từ",
    meaning:
      "làm những việc lao động như cày, cấy, v.v. để tạo ra sản phẩm nông nghiệp (nói khái quát): sống bằng nghề làm ruộng * về quê làm ruộng",
    example: "sống bằng nghề làm ruộng * về quê làm ruộng",
  },
  {
    word: "làm reo",
    part_of_speech: "động từ",
    meaning:
      "(cũ) đấu tranh có tổ chức bằng cách nghỉ việc, ngừng việc: phu phen làm reo, nghỉ việc",
    example: "phu phen làm reo, nghỉ việc",
  },
  {
    word: "làm phép",
    part_of_speech: "động từ",
    meaning:
      "làm những động tác để thực hiện phép lạ (trong tôn giáo hay trong việc mê tín): thầy phù thuỷ làm phép trừ tà",
    example: "thầy phù thuỷ làm phép trừ tà",
  },
  {
    word: "làm phép",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) (làm việc gì) làm gọi là, có tính chất hình thức, để được xem là có làm: ăn một ít làm phép",
    example: "ăn một ít làm phép",
  },
  {
    word: "làm thinh",
    part_of_speech: "động từ",
    meaning:
      "cố ý im lặng, không nói năng hay tỏ thái độ gì: làm thinh không nói",
    example: "làm thinh không nói",
  },
  {
    word: "lạm thu",
    part_of_speech: "động từ",
    meaning:
      "thu quá mức quy định (thường để chiếm làm của riêng): tuỳ tiện đặt ra các loại phí, lệ phí để lạm thu hàng ngàn tỉ đồng",
    example:
      "tuỳ tiện đặt ra các loại phí, lệ phí để lạm thu hàng ngàn tỉ đồng",
  },
  {
    word: "làm sao",
    part_of_speech: "",
    meaning:
      "vì lẽ gì, tại sao: làm sao lại xảy ra chuyện ấy? * làm sao mà khóc?",
    example: "làm sao lại xảy ra chuyện ấy? * làm sao mà khóc?",
  },
  {
    word: "làm sao",
    part_of_speech: "",
    meaning:
      "bị có chuyện gì đó không may: nhà cháy nhưng không ai làm sao * chỉ nhức đầu hay có làm sao nữa không?",
    example:
      "nhà cháy nhưng không ai làm sao * chỉ nhức đầu hay có làm sao nữa không?",
  },
  {
    word: "làm sao",
    part_of_speech: "",
    meaning:
      "tỏ ra có gì đó không hay, không bình thường, nhưng không rõ: trông nó rờn rợn làm sao ấy!",
    example: "trông nó rờn rợn làm sao ấy!",
  },
  {
    word: "làm sao",
    part_of_speech: "",
    meaning:
      "như thế nào đó, cách thế nào đó (mới được): học tập làm sao cho tốt * chuyện đó làm sao mà biết được * muốn ra làm sao thì ra",
    example:
      "học tập làm sao cho tốt * chuyện đó làm sao mà biết được * muốn ra làm sao thì ra",
  },
  {
    word: "làm sao",
    part_of_speech: "",
    meaning:
      "biết bao, biết chừng nào: đẹp làm sao! * hoa mới thơm làm sao! * thật là quý hoá làm sao!",
    example: "đẹp làm sao! * hoa mới thơm làm sao! * thật là quý hoá làm sao!",
  },
  {
    word: "làm thuê",
    part_of_speech: "động từ",
    meaning:
      "làm việc cho người khác để lấy tiền công (một cách kiếm sống): người lao động làm thuê * làm thuê cho địa chủ",
    example: "người lao động làm thuê * làm thuê cho địa chủ",
  },
  {
    word: "làm tàng",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) làm ra vẻ ngang tàng, không coi ai ra gì: đừng có làm tàng!",
    example: "đừng có làm tàng!",
  },
  {
    word: "làm thịt",
    part_of_speech: "động từ",
    meaning: "giết con vật để lấy thịt ăn: bắt con gà làm thịt * làm thịt lợn",
    example: "bắt con gà làm thịt * làm thịt lợn",
  },
  {
    word: "làm thịt",
    part_of_speech: "động từ",
    meaning:
      '(thông tục) giết chết, tiêu diệt: "(...) tôi còn nợ lung tung, chúng nó đòi, chỉ khất lần. Bây giờ mà chúng nó trông thấy tôi có tiền chơi xóc đĩa thì chúng nó làm thịt mất." (NCao; 29)',
    example:
      '(...) tôi còn nợ lung tung, chúng nó đòi, chỉ khất lần. Bây giờ mà chúng nó trông thấy tôi có tiền chơi xóc đĩa thì chúng nó làm thịt mất." (NCao; 29)',
  },
  {
    word: "làm thân",
    part_of_speech: "động từ",
    meaning:
      "làm quen và trở thành thân thiết, gần gũi với nhau: tìm cách làm thân",
    example: "tìm cách làm thân",
  },
  {
    word: "lạm sát",
    part_of_speech: "động từ",
    meaning:
      "giết thịt gia súc bừa bãi, nhiều quá mức cho phép: chống nạn lạm sát trâu bò",
    example: "chống nạn lạm sát trâu bò",
  },
  {
    word: "làm tiền",
    part_of_speech: "động từ",
    meaning: "kiếm tiền bằng thủ đoạn, bằng việc làm bất chính: gái làm tiền",
    example: "gái làm tiền",
  },
  {
    word: "làm tới",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) hành động lấn tới càng mạnh mẽ hơn, ráo riết hơn (do có được ưu thế nào đó): càng nhân nhượng, chúng nó càng làm tới",
    example: "càng nhân nhượng, chúng nó càng làm tới",
  },
  {
    word: "làm tin",
    part_of_speech: "động từ",
    meaning: "làm vật bảo đảm để cho người ta tin: vật làm tin",
    example: "vật làm tin",
  },
  {
    word: "làm tội",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) làm khổ: thân làm tội đời * rượu chè, làm tội vợ con",
    example: "thân làm tội đời * rượu chè, làm tội vợ con",
  },
  {
    word: "làm trò",
    part_of_speech: "động từ",
    meaning:
      "làm điệu bộ, cử chỉ có tác dụng gây cười: vẽ mặt làm trò * chú khỉ làm trò * làm trò ảo thuật",
    example: "vẽ mặt làm trò * chú khỉ làm trò * làm trò ảo thuật",
  },
  {
    word: "làm tròn",
    part_of_speech: "động từ",
    meaning:
      "lấy một số tròn xấp xỉ nó: làm tròn số * 9 điểm rưỡi làm tròn thành 10 điểm",
    example: "làm tròn số * 9 điểm rưỡi làm tròn thành 10 điểm",
  },
  {
    word: "làm tròn",
    part_of_speech: "động từ",
    meaning:
      "thực hiện đầy đủ, trọn vẹn (trách nhiệm, bổn phận): làm tròn bổn phận * làm tròn nhiệm vụ được giao",
    example: "làm tròn bổn phận * làm tròn nhiệm vụ được giao",
  },
  {
    word: "làm vậy",
    part_of_speech: "",
    meaning: "(hiếm) như thế, như vậy: sao lại âu sầu làm vậy?",
    example: "sao lại âu sầu làm vậy?",
  },
  {
    word: "làm vườn",
    part_of_speech: "động từ",
    meaning:
      "làm những việc như chăm nom trồng trọt cây cỏ ở vườn: người làm vườn * công việc làm vườn",
    example: "người làm vườn * công việc làm vườn",
  },
  {
    word: "làm xiếc",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) ví lối làm (việc gì) bằng những động tác, biện pháp hết sức nhanh và khéo léo, tài tình nhằm biến hoá để che giấu sự việc, hành vi sai trái của mình: làm xiếc trên báo cáo quyết toán",
    example: "làm xiếc trên báo cáo quyết toán",
  },
  {
    word: "làm vì",
    part_of_speech: "động từ",
    meaning:
      "giữ một chức vụ quan trọng chỉ trên danh nghĩa, chứ thực tế không có quyền hành hoặc tác dụng gì: vua ngồi làm vì, mọi quyền hành đều trong tay chúa * giám đốc làm vì",
    example:
      "vua ngồi làm vì, mọi quyền hành đều trong tay chúa * giám đốc làm vì",
  },
  {
    word: "làm việc",
    part_of_speech: "động từ",
    meaning:
      "hoạt động liên tục nhằm đạt một kết quả có ích: làm việc không kể ngày đêm * sống và làm việc theo gương Bác Hồ",
    example: "làm việc không kể ngày đêm * sống và làm việc theo gương Bác Hồ",
  },
  {
    word: "làm việc",
    part_of_speech: "động từ",
    meaning:
      "làm những công việc thuộc một nghề nghiệp nào đó: làm việc ở một công ti lớn * làm việc trong ngành ngân hàng",
    example: "làm việc ở một công ti lớn * làm việc trong ngành ngân hàng",
  },
  {
    word: "làm việc",
    part_of_speech: "động từ",
    meaning:
      "tiến hành giải quyết công việc cụ thể với người nào đó: buổi làm việc giữa giám đốc và nhà báo * mai tôi sẽ làm việc với anh",
    example:
      "buổi làm việc giữa giám đốc và nhà báo * mai tôi sẽ làm việc với anh",
  },
  {
    word: "làm việc",
    part_of_speech: "động từ",
    meaning:
      "hoạt động, thực hiện chức năng cụ thể: vận hành cho máy làm việc * bộ óc phải làm việc căng thẳng",
    example: "vận hành cho máy làm việc * bộ óc phải làm việc căng thẳng",
  },
  {
    word: "lán",
    part_of_speech: "danh từ",
    meaning:
      "nhà dựng tạm, sơ sài, thường bằng tre nứa: chặt cây làm lán * mái lán",
    example: "chặt cây làm lán * mái lán",
  },
  {
    word: "lan can",
    part_of_speech: "danh từ",
    meaning:
      "hàng rào thấp có tay vịn, thường đặt ở hiên, ban công, hai bên thành cầu, v.v., giữ cho người khỏi ngã ra ngoài: ra lan can hóng gió",
    example: "ra lan can hóng gió",
  },
  {
    word: "làn",
    part_of_speech: "danh từ",
    meaning:
      "đồ đựng có quai xách, được đan bằng mây, cói, tre hoặc làm bằng nhựa, đáy phẳng, miệng rộng: chiếc làn nhựa * xách làn đi chợ * một làn thức ăn",
    example: "chiếc làn nhựa * xách làn đi chợ * một làn thức ăn",
  },
  {
    word: "làn",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ từng đơn vị những vật cùng loại di chuyển nối tiếp nhau liên tục và đều đặn, tạo thành như một lớp dài rộng, có bề mặt phẳng: làn khói * làn gió * làn nước trong xanh * băng qua làn đạn",
    example: "làn khói * làn gió * làn nước trong xanh * băng qua làn đạn",
  },
  {
    word: "làn",
    part_of_speech: "danh từ",
    meaning: "lớp mỏng, nhẵn ở mặt ngoài: làn da rám nắng * làn tóc đen huyền",
    example: "làn da rám nắng * làn tóc đen huyền",
  },
  {
    word: "làn điệu",
    part_of_speech: "danh từ",
    meaning:
      "điệu hát dân ca, về mặt có nhịp điệu riêng, rõ ràng: làn điệu dân ca Nam Bộ * làn điệu quan họ",
    example: "làn điệu dân ca Nam Bộ * làn điệu quan họ",
  },
  {
    word: "làn đường",
    part_of_speech: "danh từ",
    meaning:
      "phần đường giao thông được ngăn bởi dải phân cách, dành riêng cho từng loại xe hoặc cho các làn xe chạy theo một chiều nhất định: làn đường dành cho xe thô sơ * đường được mở rộng với bốn làn đường",
    example:
      "làn đường dành cho xe thô sơ * đường được mở rộng với bốn làn đường",
  },
  {
    word: "lãn công",
    part_of_speech: "động từ",
    meaning:
      "cố tình cùng nhau làm việc cầm chừng, chây ì (một hình thức đấu tranh đòi quyền lợi của công nhân): lãn công đòi tăng lương * tổ chức lãn công, biểu tình",
    example: "lãn công đòi tăng lương * tổ chức lãn công, biểu tình",
  },
  {
    word: "lan",
    part_of_speech: "danh từ",
    meaning:
      "cây cảnh, có nhiều loại, thân cỏ, lá thường dài và hẹp, hoa đẹp thường có hương thơm: nhành lan tím",
    example: "nhành lan tím",
  },
  {
    word: "lan",
    part_of_speech: "động từ",
    meaning:
      "mở rộng dần phạm vi ra trên một bề mặt: cỏ mọc lan ra khắp vườn * lửa cháy lan sang nhà hàng xóm * tiếng đồn lan xa",
    example:
      "cỏ mọc lan ra khắp vườn * lửa cháy lan sang nhà hàng xóm * tiếng đồn lan xa",
  },
  {
    word: "lan man",
    part_of_speech: "tính từ",
    meaning:
      "(nói, viết, suy nghĩ) kéo dài, hết cái này đến cái khác một cách không mạch lạc và không có hệ thống: nghĩ ngợi lan man * trình bày lan man, không đi sâu vào vấn đề",
    example: "nghĩ ngợi lan man * trình bày lan man, không đi sâu vào vấn đề",
  },
  {
    word: "lan tràn",
    part_of_speech: "động từ",
    meaning:
      "lan nhanh và mạnh trên phạm vi rộng: bệnh dịch lan tràn * hàng lậu vẫn lan tràn trên thị trường",
    example: "bệnh dịch lan tràn * hàng lậu vẫn lan tràn trên thị trường",
  },
  {
    word: "làn thảm",
    part_of_speech: "danh từ",
    meaning: "điệu hát giọng rất buồn thảm trong chèo: hát điệu làn thảm",
    example: "hát điệu làn thảm",
  },
  {
    word: "làn sóng",
    part_of_speech: "danh từ",
    meaning:
      "sóng xô nối tiếp nhau tạo thành từng lớp có bề mặt hình uốn lượn: những làn sóng xô vào cồn đá * tóc uốn kiểu làn sóng * làn sóng đấu tranh (b)",
    example:
      "những làn sóng xô vào cồn đá * tóc uốn kiểu làn sóng * làn sóng đấu tranh (b)",
  },
  {
    word: "làn sóng",
    part_of_speech: "danh từ",
    meaning:
      "bước sóng vô tuyến điện: làn sóng đài phát thanh * phát trên làn sóng ngắn",
    example: "làn sóng đài phát thanh * phát trên làn sóng ngắn",
  },
  {
    word: "lãng",
    part_of_speech: "động từ",
    meaning:
      "quên, không để ý đến trong chốc lát: nhãng đi một cái là hỏng việc",
    example: "nhãng đi một cái là hỏng việc",
  },
  {
    word: "lang",
    part_of_speech: "danh từ",
    meaning: "(Khẩu ngữ) thầy lang (gọi tắt): ông lang",
    example: "ông lang",
  },
  {
    word: "lang",
    part_of_speech: "danh từ",
    meaning:
      '(Từ cũ, Văn chương) từ người phụ nữ dùng để gọi chồng, người yêu hoặc người con trai còn trẻ: tình lang * "Ôi Kim lang! hỡi Kim lang, Thôi thôi, thiếp đã phụ chàng từ đây." (TKiều)',
    example:
      'tình lang * "Ôi Kim lang! hỡi Kim lang, Thôi thôi, thiếp đã phụ chàng từ đây." (TKiều)',
  },
  {
    word: "lang",
    part_of_speech: "danh từ",
    meaning:
      "(Ít dùng) chó sói; dùng để ví kẻ độc ác, tàn bạo, mất hết tính người: lòng lang dạ thú",
    example: "lòng lang dạ thú",
  },
  {
    word: "lang",
    part_of_speech: "danh từ",
    meaning: "(Khẩu ngữ) khoai lang (nói tắt): củ lang * rau lang",
    example: "củ lang * rau lang",
  },
  {
    word: "lang",
    part_of_speech: "tính từ",
    meaning:
      "có từng đám trắng loang lổ trên bộ lông hoặc ngoài da: bò lang * con lợn bị lang ở cổ",
    example: "bò lang * con lợn bị lang ở cổ",
  },
  {
    word: "lang",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) bạ đâu (đẻ, ngủ) đấy, không đúng ổ hay không đúng nơi, không phải ở nhà của mình: gà đẻ lang * ngủ lang nhà hàng xóm",
    example: "gà đẻ lang * ngủ lang nhà hàng xóm",
  },
  {
    word: "lan truyền",
    part_of_speech: "động từ",
    meaning:
      "truyền ra, lan rộng ra khắp nơi: dịch bệnh lan truyền * tin đồn lan truyền khắp vùng * hơi ấm lan truyền khắp cơ thể",
    example:
      "dịch bệnh lan truyền * tin đồn lan truyền khắp vùng * hơi ấm lan truyền khắp cơ thể",
  },
  {
    word: "lan toả",
    part_of_speech: "động từ",
    meaning:
      "lan ra, toả rộng ra khắp xung quanh: hương thơm lan toả * hơi ấm lan toả khắp căn phòng",
    example: "hương thơm lan toả * hơi ấm lan toả khắp căn phòng",
  },
  {
    word: "lạng",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị cũ đo khối lượng, bằng 1/16 cân ta, tức khoảng 37,8 gram: kẻ tám lạng, người nửa cân (tng)",
    example: "kẻ tám lạng, người nửa cân (tng)",
  },
  {
    word: "lạng",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi thông thường của 100 gram: mua 2 lạng thịt * 1 cân là bằng 10 lạng",
    example: "mua 2 lạng thịt * 1 cân là bằng 10 lạng",
  },
  {
    word: "lạng",
    part_of_speech: "động từ",
    meaning:
      "đưa ngang lưỡi dao vào để cắt lấy những lớp mỏng: lạng bớt mỡ * lạng thịt ra khỏi xương",
    example: "lạng bớt mỡ * lạng thịt ra khỏi xương",
  },
  {
    word: "lạng",
    part_of_speech: "động từ",
    meaning: "xẻ thành những tấm mỏng: súc gỗ được lạng thành từng tấm mỏng",
    example: "súc gỗ được lạng thành từng tấm mỏng",
  },
  {
    word: "lạng",
    part_of_speech: "động từ",
    meaning:
      "nghiêng sang một bên, mất thăng bằng trong giây lát: xe lạng sang một bên đường * người lạng đi, chực ngã",
    example: "xe lạng sang một bên đường * người lạng đi, chực ngã",
  },
  {
    word: "láng",
    part_of_speech: "động từ",
    meaning: "làm cho===== nhẵn bóng: mặt sân láng xi măng * trơn như láng mỡ",
    example: "mặt sân láng xi măng * trơn như láng mỡ",
  },
  {
    word: "láng",
    part_of_speech: "động từ",
    meaning:
      "(nước, ánh nắng, v.v.) chảy, phủ đều lên khắp bề mặt một lớp mỏng: nước láng đều mặt ruộng",
    example: "nước láng đều mặt ruộng",
  },
  {
    word: "láng",
    part_of_speech: "tính từ",
    meaning:
      "nhẵn bóng: da đen láng * bào cho láng mặt gỗ * đầu chải dầu láng mượt",
    example: "da đen láng * bào cho láng mặt gỗ * đầu chải dầu láng mượt",
  },
  {
    word: "láng",
    part_of_speech: "danh từ",
    meaning: "vải có mặt bóng: áo may bằng láng hoa",
    example: "áo may bằng láng hoa",
  },
  {
    word: "làng",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị dân cư nhỏ nhất ở nông thôn vùng đồng bằng và trung du Việt Nam, thường có đời sống riêng về nhiều mặt: luỹ tre làng * học trường làng * phép vua thua lệ làng (tng)",
    example: "luỹ tre làng * học trường làng * phép vua thua lệ làng (tng)",
  },
  {
    word: "làng",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) những người cùng một nghề, một việc nào đó (nói tổng quát): làng báo * làng văn * khách làng chơi",
    example: "làng báo * làng văn * khách làng chơi",
  },
  {
    word: "lang bang",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như lông bông: sống lang bang",
    example: "sống lang bang",
  },
  {
    word: "lảng",
    part_of_speech: "động từ",
    meaning:
      'bỏ đi, tránh đi chỗ khác một cách lặng lẽ, không muốn cho người khác nhận thấy: lảng đi mất * "Ngảnh đi, chợt nói, chợt cười, Cáo say, chàng đã tính bài lảng ra." (TKiều)',
    example:
      'lảng đi mất * "Ngảnh đi, chợt nói, chợt cười, Cáo say, chàng đã tính bài lảng ra." (TKiều)',
  },
  {
    word: "lảng",
    part_of_speech: "động từ",
    meaning:
      "chuyển sang chuyện khác, nhằm tránh vấn đề nào đó: đuối lí bèn lảng chuyện",
    example: "đuối lí bèn lảng chuyện",
  },
  {
    word: "lảng",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) nghễnh ngãng: già rồi nên tai bị lảng",
    example: "già rồi nên tai bị lảng",
  },
  {
    word: "lang bạt kỳ hồ",
    part_of_speech: "",
    meaning:
      '(cũ) như lang bạt (nhưng mức độ mạnh hơn): "Trách thân lang bạt kì hồ, Buồm xiêu vì gió trăng mờ vì mây." (ca dao)',
    example:
      'Trách thân lang bạt kì hồ, Buồm xiêu vì gió trăng mờ vì mây." (ca dao)',
  },
  {
    word: "lang bạt",
    part_of_speech: "động từ",
    meaning:
      "sống lang thang nay đây mai đó: cuộc đời lang bạt * trở về quê sau mười năm lang bạt",
    example: "cuộc đời lang bạt * trở về quê sau mười năm lang bạt",
  },
  {
    word: "lang ben",
    part_of_speech: "danh từ",
    meaning:
      "bệnh ngoài da do một thứ nấm làm cho da trắng từng đám trông loang lổ: lưng nổi lang ben",
    example: "lưng nổi lang ben",
  },
  {
    word: "lang bạt kì hồ",
    part_of_speech: "",
    meaning:
      '(cũ) như lang bạt (nhưng mức độ mạnh hơn): "Trách thân lang bạt kì hồ, Buồm xiêu vì gió trăng mờ vì mây." (ca dao)',
    example:
      'Trách thân lang bạt kì hồ, Buồm xiêu vì gió trăng mờ vì mây." (ca dao)',
  },
  {
    word: "láng cháng",
    part_of_speech: "động từ",
    meaning:
      "dừng, ghé mỗi chỗ một ít, không có mục đích rõ ràng, không làm việc gì hẳn hoi: đến láng cháng một lúc rồi về",
    example: "đến láng cháng một lúc rồi về",
  },
  {
    word: "lãng du",
    part_of_speech: "động từ",
    meaning:
      "(văn chương) đi chơi xa nay đây mai đó, không có mục đích: khách lãng du",
    example: "khách lãng du",
  },
  {
    word: "làng chơi",
    part_of_speech: "danh từ",
    meaning:
      'những người chuyên chơi bời tìm hưởng thú vui xác thịt (nói tổng quát): khách làng chơi * "Lầu xanh có mụ Tú bà, Làng chơi đã trở về già hết duyên." (TKiều)',
    example:
      'khách làng chơi * "Lầu xanh có mụ Tú bà, Làng chơi đã trở về già hết duyên." (TKiều)',
  },
  {
    word: "láng coóng",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ, khẩu ngữ) bóng láng lên, trông như còn mới tinh: chiếc xe máy láng coóng",
    example: "chiếc xe máy láng coóng",
  },
  {
    word: "láng bóng",
    part_of_speech: "tính từ",
    meaning:
      "nhẵn tới mức phản chiếu được ánh sáng: giày da láng bóng * đầu chải dầu láng bóng",
    example: "giày da láng bóng * đầu chải dầu láng bóng",
  },
  {
    word: "lang chạ",
    part_of_speech: "động từ",
    meaning: "chung đụng bừa bãi, bậy bạ: hạng người lang chạ",
    example: "hạng người lang chạ",
  },
  {
    word: "lãng đãng",
    part_of_speech: "",
    meaning:
      '(văn chương) ở trạng thái di động chậm chạp, nhẹ nhàng, khi ẩn khi hiện, khi gần khi xa, mờ mờ ảo ảo: sương lãng đãng trên mặt sông * "Gió cuốn buồm dong lá phất phơ, Thuyền lan lãng đãng giữa doành tơ." (LTKN)',
    example:
      'sương lãng đãng trên mặt sông * "Gió cuốn buồm dong lá phất phơ, Thuyền lan lãng đãng giữa doành tơ." (LTKN)',
  },
  {
    word: "lạng lách",
    part_of_speech: "động từ",
    meaning:
      "(đi xe) luồn lách, lạng bên nọ bên kia với tốc độ cao để vượt lên: đi xe lạng lách",
    example: "đi xe lạng lách",
  },
  {
    word: "láng giềng",
    part_of_speech: "danh từ",
    meaning:
      "người ở nhà bên cạnh, trong quan hệ với nhau: hàng xóm láng giềng * bán anh em xa, mua láng giềng gần (tng)",
    example: "hàng xóm láng giềng * bán anh em xa, mua láng giềng gần (tng)",
  },
  {
    word: "láng giềng",
    part_of_speech: "danh từ",
    meaning:
      "nước ở ngay bên cạnh, trong quan hệ với nhau: các nước láng giềng",
    example: "các nước láng giềng",
  },
  {
    word: "làng nghề",
    part_of_speech: "danh từ",
    meaning:
      "làng chuyên làm một nghề thủ công truyền thống: làng nghề dệt lụa * khôi phục làng nghề truyền thống",
    example: "làng nghề dệt lụa * khôi phục làng nghề truyền thống",
  },
  {
    word: "lang lảng",
    part_of_speech: "động từ",
    meaning: "lảng dần, có ý muốn tránh đi: thằng bé lang lảng bỏ đi nơi khác",
    example: "thằng bé lang lảng bỏ đi nơi khác",
  },
  {
    word: "láng máng",
    part_of_speech: "tính từ",
    meaning:
      "(nhận thức, tiếp thu) chỉ được từng phần, từng mẩu rời rạc, không đầy đủ, rõ ràng: nhớ láng máng được mấy câu thơ * nghe láng máng",
    example: "nhớ láng máng được mấy câu thơ * nghe láng máng",
  },
  {
    word: "làng mạc",
    part_of_speech: "danh từ",
    meaning:
      "làng, về mặt là đơn vị dân cư ở nông thôn (nói khái quát): thôn xóm làng mạc",
    example: "thôn xóm làng mạc",
  },
  {
    word: "làng nhàng",
    part_of_speech: "tính từ",
    meaning: "có vóc người mảnh, hơi gầy: vóc người làng nhàng",
    example: "vóc người làng nhàng",
  },
  {
    word: "làng nhàng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) thuộc vào loại tạm coi là trung bình, không có gì nổi trội: sức học làng nhàng * làm ăn làng nhàng",
    example: "sức học làng nhàng * làm ăn làng nhàng",
  },
  {
    word: "lãng mạn",
    part_of_speech: "tính từ",
    meaning:
      "thuộc chủ nghĩa lãng mạn, có tính chất của chủ nghĩa lãng mạn: tiểu thuyết lãng mạn",
    example: "tiểu thuyết lãng mạn",
  },
  {
    word: "lãng mạn",
    part_of_speech: "tính từ",
    meaning:
      "có tư tưởng lí tưởng hoá hiện thực và nuôi nhiều ước mơ về tương lai xa xôi: tư tưởng lãng mạn cách mạng",
    example: "tư tưởng lãng mạn cách mạng",
  },
  {
    word: "lãng mạn",
    part_of_speech: "tính từ",
    meaning:
      "có suy nghĩ hay hành động không thiết thực, thường nhằm thoả mãn những ước muốn, tình cảm cá nhân không lành mạnh: đầu óc lãng mạn * yêu đương lãng mạn",
    example: "đầu óc lãng mạn * yêu đương lãng mạn",
  },
  {
    word: "lãng nhách",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ, khẩu ngữ) như lãng xẹt: chuyện kể nghe lãng nhách",
    example: "chuyện kể nghe lãng nhách",
  },
  {
    word: "lang quân",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) từ phụ nữ dùng để gọi chồng: "Trót lời nặng với lang quân, Mượn con em nó Thuý Vân thay lời." (TKiều)',
    example:
      'Trót lời nặng với lang quân, Mượn con em nó Thuý Vân thay lời." (TKiều)',
  },
  {
    word: "lãng phí",
    part_of_speech: "động từ",
    meaning:
      "làm tốn kém, hao tổn một cách vô ích: lãng phí tiền bạc * lãng phí thì giờ * tiêu xài lãng phí",
    example: "lãng phí tiền bạc * lãng phí thì giờ * tiêu xài lãng phí",
  },
  {
    word: "làng nước",
    part_of_speech: "danh từ",
    meaning:
      "những người cùng làng, trong quan hệ với nhau (nói tổng quát): bà con làng nước * động một tí là kêu làng nước",
    example: "bà con làng nước * động một tí là kêu làng nước",
  },
  {
    word: "lãng quên",
    part_of_speech: "động từ",
    meaning: "quên mất đi không chú ý đến nữa: một tác phẩm bị lãng quên",
    example: "một tác phẩm bị lãng quên",
  },
  {
    word: "lãng tử",
    part_of_speech: "danh từ",
    meaning:
      "(văn chương) người (đàn ông) thích cuộc sống phóng túng, lang thang nay đây mai đó: chàng lãng tử",
    example: "chàng lãng tử",
  },
  {
    word: "lang sói",
    part_of_speech: "danh từ",
    meaning:
      "chó sói (nói khái quát); dùng để ví những kẻ độc ác, tàn bạo, mất hết tính người: lũ lang sói",
    example: "lũ lang sói",
  },
  {
    word: "lảng tránh",
    part_of_speech: "động từ",
    meaning:
      "tránh đi, không muốn gặp hoặc không muốn đả động đến: lảng tránh mọi người * lảng tránh cái nhìn của bạn",
    example: "lảng tránh mọi người * lảng tránh cái nhìn của bạn",
  },
  {
    word: "lảng vảng",
    part_of_speech: "động từ",
    meaning:
      "đi lại quanh quẩn nhiều lần: lảng vảng ngoài ngõ * hình ảnh cô gái cứ lảng vảng trong óc hắn",
    example: "lảng vảng ngoài ngõ * hình ảnh cô gái cứ lảng vảng trong óc hắn",
  },
  {
    word: "lang thang",
    part_of_speech: "động từ",
    meaning:
      "đến chỗ này rồi lại bỏ đi chỗ khác, không dừng lại ở một chỗ nào nhất định: lang thang đây đó * sống lang thang, vất vưởng ngoài đường phố",
    example: "lang thang đây đó * sống lang thang, vất vưởng ngoài đường phố",
  },
  {
    word: "lanh",
    part_of_speech: "danh từ",
    meaning:
      "cây thân cỏ vùng ôn đới, trồng lấy sợi dệt vải và lấy hạt ép dầu: sợi lanh * bộ quần áo bằng vải lanh",
    example: "sợi lanh * bộ quần áo bằng vải lanh",
  },
  {
    word: "lanh",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) nhanh",
    example: "cặp mắt sáng và lanh",
  },
  {
    word: "lãng xẹt",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ, khẩu ngữ) rất vô duyên, rất chán và tẻ nhạt: vở kịch lãng xẹt * hỏi một câu lãng xẹt",
    example: "vở kịch lãng xẹt * hỏi một câu lãng xẹt",
  },
  {
    word: "làng xóm",
    part_of_speech: "danh từ",
    meaning:
      "làng và xóm, về mặt là khối dân cư ở nông thôn với đời sống riêng của nó (nói khái quát): làng xóm thưa thớt",
    example: "làng xóm thưa thớt",
  },
  {
    word: "lành",
    part_of_speech: "tính từ",
    meaning:
      "còn nguyên vẹn, không có những chỗ bị tách ra, bị sứt mẻ, hay thương tổn gì: áo lành * lợn lành chữa thành lợn què (tng)",
    example: "áo lành * lợn lành chữa thành lợn què (tng)",
  },
  {
    word: "lành",
    part_of_speech: "tính từ",
    meaning:
      "không có khả năng làm hại đến người, vật khác, không có tác dụng mang lại tai hoạ: thằng bé rất lành tính * chuyện chẳng lành * tiếng lành đồn xa, tiếng dữ đồn xa (tng)",
    example:
      "thằng bé rất lành tính * chuyện chẳng lành * tiếng lành đồn xa, tiếng dữ đồn xa (tng)",
  },
  {
    word: "lành",
    part_of_speech: "tính từ",
    meaning:
      "không có khả năng làm hại đến sức khoẻ: thời tiết lành * thức ăn lành",
    example: "thời tiết lành * thức ăn lành",
  },
  {
    word: "lành",
    part_of_speech: "tính từ",
    meaning:
      "có khả năng mau khỏi khi bị bệnh: da lành nên vết thương chóng khỏi",
    example: "da lành nên vết thương chóng khỏi",
  },
  {
    word: "lành",
    part_of_speech: "động từ",
    meaning: "khỏi (bệnh): vết thương sắp lành * bệnh chưa lành hẳn",
    example: "vết thương sắp lành * bệnh chưa lành hẳn",
  },
  {
    word: "lãnh cảm",
    part_of_speech: "tính từ",
    meaning:
      "không có cảm giác hứng thú (thường nói về tình dục): chứng lãnh cảm * bị lãnh cảm",
    example: "chứng lãnh cảm * bị lãnh cảm",
  },
  {
    word: "lánh",
    part_of_speech: "động từ",
    meaning:
      'tránh đi nơi khác để không phải gặp người nào hay cái gì đó coi là không hay cho mình: lánh mình đi nơi khác * "Nàng từ lánh gót vườn hoa, Dường gần rừng tía, dường xa bụi hồng." (TKiều)',
    example:
      'lánh mình đi nơi khác * "Nàng từ lánh gót vườn hoa, Dường gần rừng tía, dường xa bụi hồng." (TKiều)',
  },
  {
    word: "lạnh",
    part_of_speech: "tính từ",
    meaning:
      "có nhiệt độ thấp hơn nhiều so với mức được coi là trung bình, gây cảm giác khó chịu: trời se lạnh * nước lạnh * không khí lạnh tràn về * môi hở răng lạnh (tng)",
    example:
      "trời se lạnh * nước lạnh * không khí lạnh tràn về * môi hở răng lạnh (tng)",
  },
  {
    word: "lạnh",
    part_of_speech: "tính từ",
    meaning:
      "có cảm giác lạnh hoặc cảm giác tương tự (thường do sợ hãi): bàn tay lạnh ngắt * mặc thêm áo cho đỡ lạnh * ánh trăng sáng lạnh",
    example:
      "bàn tay lạnh ngắt * mặc thêm áo cho đỡ lạnh * ánh trăng sáng lạnh",
  },
  {
    word: "lạnh",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra không có chút tình cảm gì trong quan hệ người với người: cái nhìn rất lạnh * giọng nói cứ lạnh như không * làm mặt lạnh",
    example: "cái nhìn rất lạnh * giọng nói cứ lạnh như không * làm mặt lạnh",
  },
  {
    word: "lạnh",
    part_of_speech: "tính từ",
    meaning: "(màu) thiên về xanh, gợi cảm giác lạnh lẽo: dùng gam màu lạnh",
    example: "dùng gam màu lạnh",
  },
  {
    word: "lanh chanh",
    part_of_speech: "tính từ",
    meaning:
      "có dáng điệu hấp tấp, vội vã, muốn tỏ ra nhanh nhảu: tính hay lanh chanh",
    example: "tính hay lanh chanh",
  },
  {
    word: "lành chanh",
    part_of_speech: "tính từ",
    meaning:
      "có vẻ thích tranh giành, gây gổ: quen thói lành chanh * tính lành chanh",
    example: "quen thói lành chanh * tính lành chanh",
  },
  {
    word: "lãnh cung",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) nơi trong cung cấm dành riêng để giam cầm những vương phi bị phế truất hoặc bị coi là có tội với vua: bị đẩy vào lãnh cung",
    example: "bị đẩy vào lãnh cung",
  },
  {
    word: "lãnh đạo",
    part_of_speech: "động từ",
    meaning:
      "đề ra chủ trương, đường lối và tổ chức thực hiện: lãnh đạo một công ti * họp ban lãnh đạo",
    example: "lãnh đạo một công ti * họp ban lãnh đạo",
  },
  {
    word: "lãnh đạo",
    part_of_speech: "danh từ",
    meaning:
      "người hoặc cơ quan đề ra và tổ chức thực hiện chủ trương, đường lối: xin ý kiến lãnh đạo * đội ngũ lãnh đạo công ti",
    example: "xin ý kiến lãnh đạo * đội ngũ lãnh đạo công ti",
  },
  {
    word: "lãnh đạm",
    part_of_speech: "tính từ",
    meaning:
      "không có biểu hiện tình cảm, tỏ ra không muốn quan tâm đến: thái độ lãnh đạm",
    example: "thái độ lãnh đạm",
  },
  {
    word: "lãnh hải",
    part_of_speech: "danh từ",
    meaning:
      "vùng biển ven bờ, có chiều rộng quy định (thường không vượt quá 12 hải lí), thuộc chủ quyền của một nước ven biển: bảo vệ chủ quyền lãnh hải tổ quốc",
    example: "bảo vệ chủ quyền lãnh hải tổ quốc",
  },
  {
    word: "lạnh giá",
    part_of_speech: "tính từ",
    meaning:
      "rất lạnh, tựa như nước đá (nói khái quát): mùa đông lạnh giá * bàn tay lạnh giá * cõi lòng lạnh giá (b)",
    example: "mùa đông lạnh giá * bàn tay lạnh giá * cõi lòng lạnh giá (b)",
  },
  {
    word: "lạnh gáy",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) sợ tới mức cảm thấy ớn lạnh ở gáy: trông thấy cảnh tượng ấy cũng đủ lạnh gáy",
    example: "trông thấy cảnh tượng ấy cũng đủ lạnh gáy",
  },
  {
    word: "lành lặn",
    part_of_speech: "tính từ",
    meaning:
      "còn lành nguyên, không bị rách, bị sứt mẻ hoặc thương tật (nói khái quát): quần áo lành lặn * bị thương nhưng tay chân vẫn còn lành lặn",
    example: "quần áo lành lặn * bị thương nhưng tay chân vẫn còn lành lặn",
  },
  {
    word: "lanh lảnh",
    part_of_speech: "tính từ",
    meaning:
      '(âm thanh) cao và trong, với nhịp độ mau: cười lanh lảnh * "Đàn bà lanh lảnh tiếng đồng, Một là sát chồng, hai là hại con." (ca dao)',
    example:
      'cười lanh lảnh * "Đàn bà lanh lảnh tiếng đồng, Một là sát chồng, hai là hại con." (ca dao)',
  },
  {
    word: "lãnh đủ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) hứng trọn những điều không hay về mình: vụ việc đổ bể, một mình hắn lãnh đủ",
    example: "vụ việc đổ bể, một mình hắn lãnh đủ",
  },
  {
    word: "lành lạnh",
    part_of_speech: "tính từ",
    meaning: "hơi lạnh: tiết trời lành lạnh",
    example: "tiết trời lành lạnh",
  },
  {
    word: "lanh lẹ",
    part_of_speech: "tính từ",
    meaning: "mau lẹ: lanh lẹ đứng dậy * phản ứng lanh lẹ",
    example: "lanh lẹ đứng dậy * phản ứng lanh lẹ",
  },
  {
    word: "lảnh lói",
    part_of_speech: "tính từ",
    meaning:
      "(âm thanh) cao và vang, nghe chói tai: tiếng còi tàu rít lên lảnh lói",
    example: "tiếng còi tàu rít lên lảnh lói",
  },
  {
    word: "lạnh lẽo",
    part_of_speech: "tính từ",
    meaning:
      "lạnh đến mức cảm nhận thấy rất rõ: đêm đông lạnh lẽo * hang đá lạnh lẽo",
    example: "đêm đông lạnh lẽo * hang đá lạnh lẽo",
  },
  {
    word: "lạnh lẽo",
    part_of_speech: "tính từ",
    meaning:
      "có cảm giác hay gây cảm giác lạnh, do thiếu hẳn hơi ấm của con người: căn phòng lạnh lẽo * ánh trăng lạnh lẽo",
    example: "căn phòng lạnh lẽo * ánh trăng lạnh lẽo",
  },
  {
    word: "lánh lót",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như lảnh lót: chim hót lánh lót",
    example: "chim hót lánh lót",
  },
  {
    word: "lảnh lót",
    part_of_speech: "tính từ",
    meaning:
      "(âm thanh) cao, trong và âm vang, thường nghe vui tai: chim hót lảnh lót * giọng nói lảnh lót",
    example: "chim hót lảnh lót * giọng nói lảnh lót",
  },
  {
    word: "lánh nạn",
    part_of_speech: "động từ",
    meaning:
      "lánh đi nơi khác để tránh tai hoạ do chiến tranh hoặc thiên tai gây ra: tìm đường lánh nạn",
    example: "tìm đường lánh nạn",
  },
  {
    word: "lánh mặt",
    part_of_speech: "động từ",
    meaning:
      "tránh không gặp hoặc không để cho gặp: xấu hổ nên lánh mặt bạn bè",
    example: "xấu hổ nên lánh mặt bạn bè",
  },
  {
    word: "lanh lợi",
    part_of_speech: "tính từ",
    meaning: "nhanh nhẹn, sắc sảo: cặp mắt lanh lợi * thông minh lanh lợi",
    example: "cặp mắt lanh lợi * thông minh lanh lợi",
  },
  {
    word: "lành mạnh",
    part_of_speech: "tính từ",
    meaning:
      "không có những mặt, những biểu hiện xấu: nếp sống lành mạnh * cạnh tranh lành mạnh",
    example: "nếp sống lành mạnh * cạnh tranh lành mạnh",
  },
  {
    word: "lánh né",
    part_of_speech: "động từ",
    meaning:
      "lánh đi để tránh gặp phải những chuyện không hay (nói khái quát): lánh né trách nhiệm",
    example: "lánh né trách nhiệm",
  },
  {
    word: "lạnh ngắt",
    part_of_speech: "tính từ",
    meaning:
      'lạnh đến mức có cảm giác như không có một chút hơi ấm nào: bàn tay lạnh ngắt * "Phòng tiêu lạnh ngắt như đồng (...)" (CO)',
    example: 'bàn tay lạnh ngắt * "Phòng tiêu lạnh ngắt như đồng (...)" (CO)',
  },
  {
    word: "lạnh lùng",
    part_of_speech: "tính từ",
    meaning:
      '(hiếm) lạnh, làm tác động mạnh đến tâm hồn, tình cảm: đêm tối lạnh lùng * "Chém cha cái kiếp lấy chồng chung, Kẻ đắp chăn bông kẻ lạnh lùng." (HXHương; 25)',
    example:
      'đêm tối lạnh lùng * "Chém cha cái kiếp lấy chồng chung, Kẻ đắp chăn bông kẻ lạnh lùng." (HXHương; 25)',
  },
  {
    word: "lạnh lùng",
    part_of_speech: "tính từ",
    meaning:
      "không hề biểu hiện một chút tình cảm trong quan hệ tiếp xúc với người, với việc: vẻ mặt lạnh lùng * giọng nói lạnh lùng",
    example: "vẻ mặt lạnh lùng * giọng nói lạnh lùng",
  },
  {
    word: "lành nghề",
    part_of_speech: "tính từ",
    meaning: "giỏi tay nghề, thành thạo công việc chuyên môn: thợ lành nghề",
    example: "thợ lành nghề",
  },
  {
    word: "lãnh sự",
    part_of_speech: "danh từ",
    meaning:
      "chức vụ của cán bộ ngoại giao, dưới đại sứ, phụ trách việc bảo hộ kiều dân, tài sản nước mình ở nước ngoài.",
    example: "toà lãnh sự",
  },
  {
    word: "lãnh thổ",
    part_of_speech: "danh từ",
    meaning: "đất đai thuộc chủ quyền của một nước: bảo vệ chủ quyền lãnh thổ",
    example: "bảo vệ chủ quyền lãnh thổ",
  },
  {
    word: "lạnh như tiền",
    part_of_speech: "",
    meaning:
      'hết sức lạnh lùng, không có lấy một chút biểu hiện của cảm xúc: mặt lạnh như tiền * "Mười năm lòng lạnh như tiền, Tim đi hết máu, cái duyên không về." (NgBính; 11)',
    example:
      'mặt lạnh như tiền * "Mười năm lòng lạnh như tiền, Tim đi hết máu, cái duyên không về." (NgBính; 11)',
  },
  {
    word: "lạnh nhạt",
    part_of_speech: "tính từ",
    meaning:
      "lạnh, không có biểu hiện tình cảm thân mật, gần gũi trong sự tiếp xúc (nói khái quát): đón tiếp lạnh nhạt * trả lời lạnh nhạt",
    example: "đón tiếp lạnh nhạt * trả lời lạnh nhạt",
  },
  {
    word: "lành tính",
    part_of_speech: "tính từ",
    meaning:
      "(bệnh) không có tính chất nguy hiểm: virus lành tính * u lành tính",
    example: "virus lành tính * u lành tính",
  },
  {
    word: "lạnh toát",
    part_of_speech: "tính từ",
    meaning:
      "lạnh đến mức có cảm giác như có thể toả hết hơi lạnh ra xung quanh: tường đá lạnh toát * toàn thân người bệnh đã lạnh toát",
    example: "tường đá lạnh toát * toàn thân người bệnh đã lạnh toát",
  },
  {
    word: "lạnh tanh",
    part_of_speech: "tính từ",
    meaning:
      "rất lạnh, không thấy có một chút tình cảm, hơi ấm hoặc một chút biểu hiện nào của hoạt động con người: nhà cửa lạnh tanh * vẻ mặt lạnh tanh",
    example: "nhà cửa lạnh tanh * vẻ mặt lạnh tanh",
  },
  {
    word: "lãnh tụ",
    part_of_speech: "danh từ",
    meaning:
      "người được tôn làm người lãnh đạo một phong trào đấu tranh, một chính đảng, một nước: lãnh tụ Hồ Chí Minh",
    example: "lãnh tụ Hồ Chí Minh",
  },
  {
    word: "lao",
    part_of_speech: "danh từ",
    meaning:
      "bệnh lây do trực khuẩn Koch gây ra, thường phá hoại phổi hoặc các bộ phận khác như hạch, xương, v.v.: mắc bệnh lao * bị lao phổi * tiêm phòng lao",
    example: "mắc bệnh lao * bị lao phổi * tiêm phòng lao",
  },
  {
    word: "lao",
    part_of_speech: "danh từ",
    meaning:
      "binh khí thời xưa hình cái gậy dài, một đầu thường bịt mũi sắc nhọn bằng kim loại: ngọn lao * đâm lao thì phải theo lao (tng)",
    example: "ngọn lao * đâm lao thì phải theo lao (tng)",
  },
  {
    word: "lao",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ thể thao, hình cái lao, dùng để tập phóng đi xa: môn phóng lao",
    example: "môn phóng lao",
  },
  {
    word: "lao",
    part_of_speech: "động từ",
    meaning: "phóng mạnh một vật dài: lao cây sào * mũi tên lao vun vút",
    example: "lao cây sào * mũi tên lao vun vút",
  },
  {
    word: "lao",
    part_of_speech: "động từ",
    meaning:
      "di chuyển rất nhanh, rất mạnh thẳng về phía trước: chiếc xe lao xuống dốc * chạy lao về phía trước",
    example: "chiếc xe lao xuống dốc * chạy lao về phía trước",
  },
  {
    word: "lao",
    part_of_speech: "động từ",
    meaning:
      "dốc toàn bộ sức lực, tâm trí vào việc gì: lao vào học * lao vào cờ bạc, rượu chè * tự lao đầu vào chỗ chết",
    example: "lao vào học * lao vào cờ bạc, rượu chè * tự lao đầu vào chỗ chết",
  },
  {
    word: "lao",
    part_of_speech: "động từ",
    meaning: "đưa rầm cầu ra đặt lên mố và trụ: lao cầu",
    example: "lao cầu",
  },
  {
    word: "láo",
    part_of_speech: "tính từ",
    meaning:
      "vô lễ, không kể gì đến khuôn phép trong quan hệ đối với người trên: nói chuyện láo * láo như ranh! * thằng bé láo lắm!",
    example: "nói chuyện láo * láo như ranh! * thằng bé láo lắm!",
  },
  {
    word: "láo",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) sai, bậy, không kể gì đến khuôn phép, sự thật: tán láo cho vui * báo cáo láo * đồ nói láo (= nói dối)",
    example: "tán láo cho vui * báo cáo láo * đồ nói láo",
  },
  {
    word: "lão bộc",
    part_of_speech: "danh từ",
    meaning: "(cũ) người đầy tớ già thời trước: người lão bộc già nua",
    example: "người lão bộc già nua",
  },
  {
    word: "lão",
    part_of_speech: "danh từ",
    meaning:
      "người già (khoảng bảy mươi tuổi trở lên; có thể dùng để xưng gọi một cách thân mật): ông lão, bà lão * lên lão * để lão kể cho các cháu nghe",
    example: "ông lão, bà lão * lên lão * để lão kể cho các cháu nghe",
  },
  {
    word: "lão",
    part_of_speech: "danh từ",
    meaning:
      "người đàn ông thuộc lớp già hoặc đứng tuổi (hàm ý coi thường): lão thầy bói * lão địa chủ",
    example: "lão thầy bói * lão địa chủ",
  },
  {
    word: "lào",
    part_of_speech: "danh từ",
    meaning: "(Ít dùng) cái đo giá trị: lấy đồng tiền làm lào",
    example: "lấy đồng tiền làm lào",
  },
  {
    word: "lao đao",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) bị choáng váng, chao đảo, mất thăng bằng: người lao đao, chực ngã",
    example: "người lao đao, chực ngã",
  },
  {
    word: "lao đao",
    part_of_speech: "tính từ",
    meaning:
      'ở trong cảnh phải ứng phó vất vả với khó khăn từ nhiều phía: cuộc sống lao đao * "Xiết bao ăn tuyết nằm sương, Màn trời chiếu đất dặm trường lao đao." (LVT)',
    example:
      'cuộc sống lao đao * "Xiết bao ăn tuyết nằm sương, Màn trời chiếu đất dặm trường lao đao." (LVT)',
  },
  {
    word: "lao dịch",
    part_of_speech: "danh từ",
    meaning: "(cũ) việc lao động nặng nhọc, lao động cưỡng bức: làm lao dịch",
    example: "làm lao dịch",
  },
  {
    word: "lảo đảo",
    part_of_speech: "động từ",
    meaning:
      "(người) ngả nghiêng, muốn ngã, muốn đổ, do mất thăng bằng: say rượu, bước đi lảo đảo",
    example: "say rượu, bước đi lảo đảo",
  },
  {
    word: "lão hoá",
    part_of_speech: "động từ",
    meaning:
      "(bộ phận cơ thể người) biến đổi theo hướng suy yếu dần ở giai đoạn cuối của quá trình sống tự nhiên: lão hoá các khớp xương * bộ não bị lão hoá",
    example: "lão hoá các khớp xương * bộ não bị lão hoá",
  },
  {
    word: "lão hoá",
    part_of_speech: "động từ",
    meaning:
      "(cao su, chất dẻo, v.v.) thoái hoá và trở thành mềm dính hoặc giòn cứng: chiếc lốp lâu ngày đã lão hoá",
    example: "chiếc lốp lâu ngày đã lão hoá",
  },
  {
    word: "lao động",
    part_of_speech: "động từ",
    meaning:
      "hoạt động có mục đích của con người nhằm tạo ra các loại sản phẩm vật chất và tinh thần cho xã hội: lao động chân tay * lao động trí óc * lười lao động",
    example: "lao động chân tay * lao động trí óc * lười lao động",
  },
  {
    word: "lao động",
    part_of_speech: "danh từ",
    meaning:
      "việc làm cụ thể hoặc sức người bỏ ra để tạo ra sản phẩm: trả lương theo lao động * nâng cao năng suất lao động",
    example: "trả lương theo lao động * nâng cao năng suất lao động",
  },
  {
    word: "lao động",
    part_of_speech: "danh từ",
    meaning:
      "người bỏ công sức ra để làm việc gì (thường nói về làm việc chân tay): nhà có hai lao động chính * giai cấp lao động",
    example: "nhà có hai lao động chính * giai cấp lao động",
  },
  {
    word: "lao khổ",
    part_of_speech: "tính từ",
    meaning: "(cũ) vất vả, cực nhọc: nếm đủ mùi lao khổ",
    example: "nếm đủ mùi lao khổ",
  },
  {
    word: "lão khoa",
    part_of_speech: "danh từ",
    meaning:
      "bộ môn y học chuyên chẩn đoán, điều trị các rối loạn xảy ra trong giai đoạn tuổi già và quy trình chăm sóc người cao tuổi: chuyên gia về lão khoa",
    example: "chuyên gia về lão khoa",
  },
  {
    word: "láo lếu",
    part_of_speech: "tính từ",
    meaning: "như lếu láo: ăn nói láo lếu * đồ láo lếu! (tiếng mắng chửi)",
    example: "ăn nói láo lếu * đồ láo lếu! (tiếng mắng chửi)",
  },
  {
    word: "láo liên",
    part_of_speech: "",
    meaning:
      "(mắt) đảo qua đảo lại liên tục, nhìn với vẻ dò xét, tìm kiếm: đôi mắt láo liên",
    example: "đôi mắt láo liên",
  },
  {
    word: "lao lí",
    part_of_speech: "danh từ",
    meaning: "(cũ) nơi tù tội, giam cầm nói chung: rơi vào vòng lao lí",
    example: "rơi vào vòng lao lí",
  },
  {
    word: "lão làng",
    part_of_speech: "",
    meaning:
      "người cao tuổi, làm việc lâu năm, nhiều kinh nghiệm, thường được kính nể: một lão làng trong làng báo * người trinh sát lão làng",
    example: "một lão làng trong làng báo * người trinh sát lão làng",
  },
  {
    word: "lão luyện",
    part_of_speech: "tính từ",
    meaning:
      "thành thạo, có nhiều kinh nghiệm (trong nghề nghiệp, trong chuyên môn): một cây bút lão luyện * tay nghề vào loại lão luyện",
    example: "một cây bút lão luyện * tay nghề vào loại lão luyện",
  },
  {
    word: "lao lực",
    part_of_speech: "động từ",
    meaning: "(cũ) lao động thể lực nặng nhọc: phải lao tâm lao lực",
    example: "phải lao tâm lao lực",
  },
  {
    word: "lao lực",
    part_of_speech: "động từ",
    meaning:
      "bị hao tổn sức lực quá nhiều do lao động quá sức: chết vì bị lao lực",
    example: "chết vì bị lao lực",
  },
  {
    word: "lao lung",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, văn chương) ngục tù, nơi giam hãm, làm mất tự do nói chung: cảnh lao lung * chốn lao lung",
    example: "cảnh lao lung * chốn lao lung",
  },
  {
    word: "lao lung",
    part_of_speech: "tính từ",
    meaning:
      "khổ cực nhiều bề trong sự bó buộc cả về vật chất lẫn tinh thần: cảnh sống lao lung",
    example: "cảnh sống lao lung",
  },
  {
    word: "lao nhao",
    part_of_speech: "động từ",
    meaning:
      "lên tiếng cùng một lúc một cách ồn ào, lộn xộn: mọi người lao nhao chen lấn xô đẩy nhau lên tàu",
    example: "mọi người lao nhao chen lấn xô đẩy nhau lên tàu",
  },
  {
    word: "lào phào",
    part_of_speech: "tính từ",
    meaning: "như lào thào: giọng nói lào phào",
    example: "giọng nói lào phào",
  },
  {
    word: "láo nháo",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) lộn xộn, lung tung nhiều thứ, không theo trật tự nào: hành khách đứng ngồi láo nháo * làm ăn láo nháo * canh láo nháo",
    example: "hành khách đứng ngồi láo nháo * làm ăn láo nháo * canh láo nháo",
  },
  {
    word: "lão phu",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) từ người đàn ông trí thức già thời phong kiến dùng để tự xưng một cách khiêm tốn: lão phu già cả, xin miễn chấp",
    example: "lão phu già cả, xin miễn chấp",
  },
  {
    word: "láo quáo",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như lào quào: quét láo quáo mấy cái rồi bỏ",
    example: "quét láo quáo mấy cái rồi bỏ",
  },
  {
    word: "lào rào",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng ồn nhỏ, thành từng đợt liên tiếp như tiếng gió thổi hoặc mưa rơi nhẹ: gió thổi lào rào * tiếng mưa lào rào rơi ngoài hiên",
    example: "gió thổi lào rào * tiếng mưa lào rào rơi ngoài hiên",
  },
  {
    word: "lão suy",
    part_of_speech: "",
    meaning: "suy yếu do tuổi già: hiện tượng lão suy",
    example: "hiện tượng lão suy",
  },
  {
    word: "lào thào",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng nói nhỏ, lẫn trong hơi thở yếu ớt, nghe như thoảng qua: giọng nói lào thào",
    example: "giọng nói lào thào",
  },
  {
    word: "lão thành",
    part_of_speech: "tính từ",
    meaning:
      "già và từng trải, giàu kinh nghiệm: bậc lão thành * nhà giáo lão thành * cán bộ lão thành cách mạng",
    example: "bậc lão thành * nhà giáo lão thành * cán bộ lão thành cách mạng",
  },
  {
    word: "láo toét",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) rất láo: ăn nói láo toét * đồ láo toét! (tiếng mắng chửi)",
    example: "ăn nói láo toét * đồ láo toét! (tiếng mắng chửi)",
  },
  {
    word: "lào quào",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) qua quýt, đại khái, cốt cho xong: quét lào quào mấy nhát chổi * làm ăn lào quào",
    example: "quét lào quào mấy nhát chổi * làm ăn lào quào",
  },
  {
    word: "lao tù",
    part_of_speech: "danh từ",
    meaning: "(cũ) nhà lao (nói khái quát): chốn lao tù",
    example: "chốn lao tù",
  },
  {
    word: "lão tướng",
    part_of_speech: "danh từ",
    meaning: "vị tướng già: vị lão tướng",
    example: "vị lão tướng",
  },
  {
    word: "lao xao",
    part_of_speech: "động từ",
    meaning:
      'có nhiều âm thanh hoặc tiếng động nhỏ rộn lên xen lẫn vào nhau, nghe không rõ, không đều: tiếng lá rừng lao xao * "Trước thầy sau tớ lao xao, Nhà băng đưa mối, rước vào lầu trang." (TKiều)',
    example:
      'tiếng lá rừng lao xao * "Trước thầy sau tớ lao xao, Nhà băng đưa mối, rước vào lầu trang." (TKiều)',
  },
  {
    word: "lạo xạo",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng cát sỏi hay tiếng của vật tương tự cọ xát vào nhau hoặc bị nghiến: đá sỏi lạo xạo dưới chân",
    example: "đá sỏi lạo xạo dưới chân",
  },
  {
    word: "lào xào",
    part_of_speech: "",
    meaning:
      "từ mô phỏng tiếng động khẽ như của lá khô chạm vào nhau, liên tiếp: tiếng nói chuyện lào xào",
    example: "tiếng nói chuyện lào xào",
  },
  {
    word: "láo xược",
    part_of_speech: "tính từ",
    meaning:
      "vô lễ, xúc phạm đến người khác: ăn nói láo xược * thái độ láo xược",
    example: "ăn nói láo xược * thái độ láo xược",
  },
  {
    word: "laser",
    part_of_speech: "danh từ",
    meaning:
      "(A: Light Amplification by Stimulated Emission of Radiation, viết tắt) dụng cụ phát các sóng điện từ đơn sắc dựa vào bức xạ cảm ứng: tia laser * máy in laser",
    example: "tia laser * máy in laser",
  },
  {
    word: "lát",
    part_of_speech: "danh từ",
    meaning:
      "cây gỗ to cùng họ với xoan, gốc có bành lớn, lá kép lông chim, hoa màu vàng nhạt, gỗ có vân đẹp, thuộc loại gỗ quý: gỗ lát",
    example: "gỗ lát",
  },
  {
    word: "lát",
    part_of_speech: "danh từ",
    meaning:
      "miếng mỏng được thái hoặc cắt ra: lát bánh mì * lát khoai lang * sắn thái lát",
    example: "lát bánh mì * lát khoai lang * sắn thái lát",
  },
  {
    word: "lát",
    part_of_speech: "danh từ",
    meaning: "khoảng thời gian rất ngắn: im lặng một lát * lát nữa sẽ đi",
    example: "im lặng một lát * lát nữa sẽ đi",
  },
  {
    word: "lát",
    part_of_speech: "động từ",
    meaning:
      "xếp và gắn gạch hoặc ván gỗ, v.v. thành mặt phẳng: lát đường * gỗ lát nền * nền nhà lát gạch hoa",
    example: "lát đường * gỗ lát nền * nền nhà lát gạch hoa",
  },
  {
    word: "lạt",
    part_of_speech: "danh từ",
    meaning: "dây buộc bằng tre, mây, v.v. chẻ mỏng: chẻ lạt buộc bánh chưng",
    example: "chẻ lạt buộc bánh chưng",
  },
  {
    word: "latin",
    part_of_speech: "tính từ",
    meaning:
      "(tiếng nói, chữ viết) của người La Mã xưa: tiếng Latin * chữ cái Latin",
    example: "tiếng Latin * chữ cái Latin",
  },
  {
    word: "lau",
    part_of_speech: "danh từ",
    meaning:
      "cây cùng loài với mía, mọc hoang thành bụi, thân cao và xốp, hoa trắng tụ thành bông: bông lau",
    example: "bông lau",
  },
  {
    word: "lau",
    part_of_speech: "động từ",
    meaning:
      'làm cho khô, cho sạch bằng cách đưa nhẹ một vật mềm trên bề mặt: lau mồ hôi * lau bảng * "Vì ai nước mắt sụt sùi, Khăn lau không ráo, áo chùi không khô." (ca dao)',
    example:
      'lau mồ hôi * lau bảng * "Vì ai nước mắt sụt sùi, Khăn lau không ráo, áo chùi không khô." (ca dao)',
  },
  {
    word: "láu",
    part_of_speech: "tính từ",
    meaning:
      "tinh nhanh và khôn khéo trong việc ứng phó với các tình huống trong đời sống hằng ngày: thằng bé đến là láu",
    example: "thằng bé đến là láu",
  },
  {
    word: "lạt sạt",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng nhỏ và trầm, đều đều liên tiếp như tiếng các vật thô cứng và mỏng cọ xát nhẹ vào nhau: tiếng gió thổi lạt sạt trong đám lá rậm",
    example: "tiếng gió thổi lạt sạt trong đám lá rậm",
  },
  {
    word: "làu",
    part_of_speech: "tính từ",
    meaning:
      'có thể đọc thuộc lòng thật trơn tru, không chút vấp váp: thuộc làu bài thơ * "Cung thương làu bậc ngũ âm, Nghề riêng ăn đứt hồ cầm một trương." (TKiều)',
    example:
      'thuộc làu bài thơ * "Cung thương làu bậc ngũ âm, Nghề riêng ăn đứt hồ cầm một trương." (TKiều)',
  },
  {
    word: "làu",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) rất sạch, không có một gợn bẩn: sạch làu bóng giặc",
    example: "sạch làu bóng giặc",
  },
  {
    word: "làu bàu",
    part_of_speech: "động từ",
    meaning: "nói nhỏ trong miệng tỏ vẻ bực dọc, khó chịu: làu bàu trong miệng",
    example: "làu bàu trong miệng",
  },
  {
    word: "láu cá",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) láu và có nhiều mẹo vặt: giở trò láu cá * thằng bé rất láu cá",
    example: "giở trò láu cá * thằng bé rất láu cá",
  },
  {
    word: "lảu bảu",
    part_of_speech: "động từ",
    meaning:
      "như làu bàu (nhưng nghĩa mạnh hơn): miệng lảu bảu điều gì nghe không rõ",
    example: "miệng lảu bảu điều gì nghe không rõ",
  },
  {
    word: "lau lách",
    part_of_speech: "danh từ",
    meaning:
      'lau và lách (nói khái quát): "Bến Tầm Dương canh khuya đưa khách, Quạnh hơi thu lau lách đìu hiu." (TBH)',
    example:
      'Bến Tầm Dương canh khuya đưa khách, Quạnh hơi thu lau lách đìu hiu." (TBH)',
  },
  {
    word: "lau chau",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra nhanh nhảu nhưng hấp tấp, thiếu suy nghĩ: tính hay lau chau * chưa nghe xong đã lau chau phản đối * lau chau đòi đi trước",
    example:
      "tính hay lau chau * chưa nghe xong đã lau chau phản đối * lau chau đòi đi trước",
  },
  {
    word: "lạu bạu",
    part_of_speech: "động từ",
    meaning: "như làu bàu (nhưng nghĩa mạnh hơn): lạu bạu chửi",
    example: "lạu bạu chửi",
  },
  {
    word: "lau chùi",
    part_of_speech: "động từ",
    meaning: "lau và chùi (nói khái quát): bàn ghế được lau chùi sạch sẽ",
    example: "bàn ghế được lau chùi sạch sẽ",
  },
  {
    word: "láu lỉnh",
    part_of_speech: "tính từ",
    meaning:
      "có vẻ tinh nhanh, khôn và tinh nghịch: vẻ mặt láu lỉnh * cười láu lỉnh",
    example: "vẻ mặt láu lỉnh * cười láu lỉnh",
  },
  {
    word: "lau láu",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (nói, đọc) nhanh, luôn mồm, không vấp váp: đọc lau láu * nói tiếng Anh lau láu",
    example: "đọc lau láu * nói tiếng Anh lau láu",
  },
  {
    word: "làu nhàu",
    part_of_speech: "động từ",
    meaning: "như làu bàu: tính hay làu nhàu",
    example: "tính hay làu nhàu",
  },
  {
    word: "láu táu",
    part_of_speech: "tính từ",
    meaning:
      "nhanh nhảu mà thiếu chín chắn: mồm miệng láu táu * láu táu trả lời ngay",
    example: "mồm miệng láu táu * láu táu trả lời ngay",
  },
  {
    word: "lau nhau",
    part_of_speech: "tính từ",
    meaning:
      "nhỏ bé sàn sàn hoặc có phẩm chất tầm thường như nhau, làm thành một đàn, một lũ: bốn con chó lau nhau * một lũ trẻ con nhau nhau",
    example: "bốn con chó lau nhau * một lũ trẻ con nhau nhau",
  },
  {
    word: "lay",
    part_of_speech: "động từ",
    meaning:
      'lắc qua lắc lại làm cho không còn giữ được thế ổn định ở một vị trí: gió lay cây * "Trải bao nhiêu sự nguy nan, Vợ chồng họ Thạch lòng vàng chẳng lay." (TS)',
    example:
      'gió lay cây * "Trải bao nhiêu sự nguy nan, Vợ chồng họ Thạch lòng vàng chẳng lay." (TS)',
  },
  {
    word: "lạy",
    part_of_speech: "",
    meaning:
      "chắp tay, quỳ gối và cúi gập người để tỏ lòng cung kính, theo lễ nghi: chắp tay lạy lia lịa * lạy ba lạy",
    example: "chắp tay lạy lia lịa * lạy ba lạy",
  },
  {
    word: "lạy",
    part_of_speech: "",
    meaning:
      "(Từ cũ) từ dùng trước từ chỉ người đối thoại khi mở đầu lời nói, để tỏ thái độ cung kính hoặc ý cầu xin khẩn thiết: lạy cụ ạ! * lạy trời đừng mưa",
    example: "lạy cụ ạ! * lạy trời đừng mưa",
  },
  {
    word: "láy",
    part_of_speech: "động từ",
    meaning:
      "lặp lại (âm, tiếng, v.v.) để tạo một kết quả nhất định trong diễn đạt: láy đi láy lại mãi một câu",
    example: "láy đi láy lại mãi một câu",
  },
  {
    word: "lay động",
    part_of_speech: "động từ",
    meaning:
      "chuyển động hoặc làm cho chuyển động nhẹ qua lại ở một vị trí nhất định: mặt nước khẽ lay động * gió hiu hiu lay động các tàu chuối",
    example: "mặt nước khẽ lay động * gió hiu hiu lay động các tàu chuối",
  },
  {
    word: "lạy lục",
    part_of_speech: "động từ",
    meaning:
      "hạ mình cầu xin một cách khốn khổ, nhục nhã: phải lạy lục khắp nơi mà vẫn không được",
    example: "phải lạy lục khắp nơi mà vẫn không được",
  },
  {
    word: "lay lắt",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái không được dùng tới, không được chú ý tới trong thời gian dài: đồ đạc vứt lay lắt mỗi thứ một nơi",
    example: "đồ đạc vứt lay lắt mỗi thứ một nơi",
  },
  {
    word: "lay láy",
    part_of_speech: "tính từ",
    meaning:
      "(đen) sẫm và ánh lên, trông đẹp và sinh động (thường nói về mắt): đôi mắt ánh lên lay láy",
    example: "đôi mắt ánh lên lay láy",
  },
  {
    word: "lay chuyển",
    part_of_speech: "động từ",
    meaning:
      "làm cho không còn giữ được nguyên vị trí, trạng thái ổn định (thường nói về ý chí, tình cảm): khóm tre bị bão lay chuyển * chí đã quyết, khó có gì lay chuyển được",
    example:
      "khóm tre bị bão lay chuyển * chí đã quyết, khó có gì lay chuyển được",
  },
  {
    word: "lay phay",
    part_of_speech: "tính từ",
    meaning: "(mưa) ở trạng thái bay lất phất: mưa bụi lay phay",
    example: "mưa bụi lay phay",
  },
  {
    word: "lay nhay",
    part_of_speech: "",
    meaning: "(phương ngữ) lây nhây: làm lay nhay cả tháng trời không xong",
    example: "làm lay nhay cả tháng trời không xong",
  },
  {
    word: "lay trời chuyển đất",
    part_of_speech: "",
    meaning: "(hiếm) như long trời lở đất: cuộc cách mạng lay trời chuyển đất",
    example: "cuộc cách mạng lay trời chuyển đất",
  },
  {
    word: "lắc",
    part_of_speech: "danh từ",
    meaning:
      "vòng trang sức bằng vàng, bạc, thường đeo ở cổ tay hoặc cổ chân: cổ tay đeo lắc bạc",
    example: "cổ tay đeo lắc bạc",
  },
  {
    word: "lắc",
    part_of_speech: "động từ",
    meaning:
      "chuyển động hoặc làm cho chuyển động qua lại nhiều lần trong khoảng cách ngắn: chiếc xe lắc mạnh * thuyền gặp sóng lớn, lắc qua lắc lại * lắc chai nước",
    example:
      "chiếc xe lắc mạnh * thuyền gặp sóng lớn, lắc qua lắc lại * lắc chai nước",
  },
  {
    word: "lắc",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) lắc đầu (nói tắt): hỏi gì cũng lắc * nói gì cũng ừ hữ, không gật cũng không lắc",
    example: "hỏi gì cũng lắc * nói gì cũng ừ hữ, không gật cũng không lắc",
  },
  {
    word: "lạy tạ",
    part_of_speech: "động từ",
    meaning:
      'lạy để tạ ơn: "Nghe lời sửa áo cài trâm, Khấu đầu lạy tạ cao thâm nghìn trùng." (TKiều)',
    example:
      'Nghe lời sửa áo cài trâm, Khấu đầu lạy tạ cao thâm nghìn trùng." (TKiều)',
  },
  {
    word: "lắc cắc",
    part_of_speech: "tính từ",
    meaning:
      'từ mô phỏng những tiếng ngắn, gọn và không vang, như tiếng dùi gõ liên tiếp vào tang trống: "Gió giật sườn non khua lắc cắc, Sóng dồn mặt nước vỗ long bong." (HXHương; 20)',
    example:
      'Gió giật sườn non khua lắc cắc, Sóng dồn mặt nước vỗ long bong." (HXHương; 20)',
  },
  {
    word: "lắc đầu",
    part_of_speech: "động từ",
    meaning:
      "đưa đầu qua lại vài cái tỏ ý không bằng lòng, không đồng ý: lắc đầu ngao ngán",
    example: "lắc đầu ngao ngán",
  },
  {
    word: "lắm",
    part_of_speech: "tính từ",
    meaning:
      "có số lượng được đánh giá là lớn: lắm tiền nhiều của * nói lắm mỏi mồm * lắm thầy thối ma (tng)",
    example: "lắm tiền nhiều của * nói lắm mỏi mồm * lắm thầy thối ma (tng)",
  },
  {
    word: "lắm",
    part_of_speech: "phụ từ",
    meaning:
      "đến mức độ được đánh giá là cao: đẹp lắm * thằng bé thông minh lắm * bỏ đi thì phí lắm",
    example: "đẹp lắm * thằng bé thông minh lắm * bỏ đi thì phí lắm",
  },
  {
    word: "lắc lư",
    part_of_speech: "động từ",
    meaning:
      "nghiêng qua nghiêng lại đều đều: con tàu lắc lư theo sóng * đầu lắc lư",
    example: "con tàu lắc lư theo sóng * đầu lắc lư",
  },
  {
    word: "lặc lè",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả dáng đi nặng nề khó nhọc vì quá béo hoặc phải mang vác quá nặng: xách lặc lè hai chiếc va li lớn * con gấu bước đi lặc lè",
    example: "xách lặc lè hai chiếc va li lớn * con gấu bước đi lặc lè",
  },
  {
    word: "lắc đầu lè lưỡi",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tỏ vẻ kinh ngạc, hoặc thán phục: sức khoẻ của anh ta, ai cũng phải lắc đầu lè lưỡi",
    example: "sức khoẻ của anh ta, ai cũng phải lắc đầu lè lưỡi",
  },
  {
    word: "lăm",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) năm (chỉ dùng để đếm, sau số hàng chục): mười lăm * hăm lăm (hai mươi lăm) * bốn lăm",
    example: "mười lăm * hăm lăm (hai mươi lăm) * bốn lăm",
  },
  {
    word: "lắc rắc",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả tiếng mưa rơi thưa thớt: tiếng mưa lắc rắc trên mái tôn",
    example: "tiếng mưa lắc rắc trên mái tôn",
  },
  {
    word: "lắc rắc",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng động nhẹ, giòn và thưa phát ra liên tiếp: tiếng cành khô gãy lắc rắc",
    example: "tiếng cành khô gãy lắc rắc",
  },
  {
    word: "lắm điều",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) hay nói nhiều và tỏ ra ngoa ngoắt về những chuyện đáng ra không có gì phải nói hoặc không cần nói nhiều: người phụ nữ lắm điều",
    example: "người phụ nữ lắm điều",
  },
  {
    word: "lắm chuyện",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) hay bày vẽ hoặc tham gia vào những việc không liên quan đến mình, gây phiền phức, rắc rối: chỉ được cái lắm chuyện! * rõ lắm chuyện!",
    example: "chỉ được cái lắm chuyện! * rõ lắm chuyện!",
  },
  {
    word: "lăm lăm",
    part_of_speech: "tính từ",
    meaning:
      "ở thế sẵn sàng và rất chăm chú, đợi có thời cơ là hành động ngay: chỉ lăm lăm chực chạy * lăm lăm cái gậy trong tay",
    example: "chỉ lăm lăm chực chạy * lăm lăm cái gậy trong tay",
  },
  {
    word: "lăm le",
    part_of_speech: "động từ",
    meaning:
      "có ý định và sẵn sàng, chỉ chờ có cơ hội là làm ngay: chỉ lăm le chực chạy * lăm le chức trưởng phòng",
    example: "chỉ lăm le chực chạy * lăm le chức trưởng phòng",
  },
  {
    word: "lắm mồm",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) hay nói nhiều và to tiếng một cách ồn ào: chỉ được cái lắm mồm!",
    example: "chỉ được cái lắm mồm!",
  },
  {
    word: "lăm tăm",
    part_of_speech: "tính từ",
    meaning: "có nhiều tăm nhỏ nổi liên tiếp trên mặt nước: nước sủi lăm tăm",
    example: "nước sủi lăm tăm",
  },
  {
    word: "lẳn",
    part_of_speech: "tính từ",
    meaning:
      "săn chắc lại như được cuộn chặt: người béo lẳn * đôi vai tròn lẳn * bắp thịt nở nang, lẳn từng múi",
    example:
      "người béo lẳn * đôi vai tròn lẳn * bắp thịt nở nang, lẳn từng múi",
  },
  {
    word: "lẳn",
    part_of_speech: "tính từ",
    meaning:
      "(quần áo) siết rất chặt vào người: áo lẳn lấy thân người * quần bó lẳn",
    example: "áo lẳn lấy thân người * quần bó lẳn",
  },
  {
    word: "lẳn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) trốn biệt đi, không còn thấy tăm hơi đâu nữa: lặn một hơi mất tăm",
    example: "lặn một hơi mất tăm",
  },
  {
    word: "lăn",
    part_of_speech: "động từ",
    meaning:
      "di chuyển hoặc làm cho di chuyển bằng cách quay vòng toàn khối trên mặt nền: xe từ từ lăn bánh * giọt nước mắt lăn trên gò má * lăn khúc gỗ xuống dốc",
    example:
      "xe từ từ lăn bánh * giọt nước mắt lăn trên gò má * lăn khúc gỗ xuống dốc",
  },
  {
    word: "lăn",
    part_of_speech: "động từ",
    meaning:
      "nằm vật xuống một cách đột ngột: ngã lăn ra bất tỉnh * lăn ra đất ăn vạ",
    example: "ngã lăn ra bất tỉnh * lăn ra đất ăn vạ",
  },
  {
    word: "lằn",
    part_of_speech: "danh từ",
    meaning:
      "vệt dài in hoặc nổi lên trên bề mặt một vật do tác động nào đó: lằn trói * bị đánh đến nổi lằn",
    example: "lằn trói * bị đánh đến nổi lằn",
  },
  {
    word: "lằn",
    part_of_speech: "động từ",
    meaning:
      "được in sâu hoặc nổi lên thành lằn bằng tác động nào đó: mặt đường lằn dấu bánh xe * vết roi lằn rõ trên lưng",
    example: "mặt đường lằn dấu bánh xe * vết roi lằn rõ trên lưng",
  },
  {
    word: "lắm thầy thối ma",
    part_of_speech: "",
    meaning:
      "ví tình trạng làm việc gì mà có quá nhiều người góp ý kiến thì dễ không thống nhất, sinh rắc rối, hỏng việc.",
    example: "biết khó khăn nhưng vẫn lăn vào",
  },
  {
    word: "lặn",
    part_of_speech: "động từ",
    meaning: "tự làm cho mình chìm hẳn xuống dưới mặt nước: lặn xuống đáy biển",
    example: "lặn xuống đáy biển",
  },
  {
    word: "lặn",
    part_of_speech: "động từ",
    meaning:
      "biến đi như lẩn mất vào chiều sâu, không còn thấy hiện ra trên bề mặt: mụn lặn * nốt sởi đã lặn",
    example: "mụn lặn * nốt sởi đã lặn",
  },
  {
    word: "lặn",
    part_of_speech: "động từ",
    meaning:
      '(mặt trời, mặt trăng) khuất mất đi phía dưới đường chân trời: mặt trời lặn * "Trải bao thỏ lặn, ác tà, Ấy mồ vô chủ, ai mà viếng thăm!" (TKiều)',
    example:
      'mặt trời lặn * "Trải bao thỏ lặn, ác tà, Ấy mồ vô chủ, ai mà viếng thăm!" (TKiều)',
  },
  {
    word: "lăn cù",
    part_of_speech: "động từ",
    meaning: "(phương ngữ, khẩu ngữ) lăn tròn nhiều vòng: té lăn cù",
    example: "té lăn cù",
  },
  {
    word: "lăn chiêng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đổ, ngã lăn quay ra: đá cái giỏ lăn chiêng * ngã lăn chiêng",
    example: "đá cái giỏ lăn chiêng * ngã lăn chiêng",
  },
  {
    word: "lăn đùng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) ngã lăn ra đột ngột: hơi một tí là lăn đùng ra đất ăn vạ",
    example: "hơi một tí là lăn đùng ra đất ăn vạ",
  },
  {
    word: "lặn lội",
    part_of_speech: "động từ",
    meaning:
      'làm việc vất vả nơi ruộng đồng, sông nước: cả ngày lặn lội ở ngoài đồng * "Con cò lặn lội bờ sông, Gánh gạo đưa chồng tiếng khóc nỉ non." (ca dao)',
    example:
      'cả ngày lặn lội ở ngoài đồng * "Con cò lặn lội bờ sông, Gánh gạo đưa chồng tiếng khóc nỉ non." (ca dao)',
  },
  {
    word: "lặn lội",
    part_of_speech: "động từ",
    meaning: "vượt quãng đường xa, khó khăn, vất vả: lặn lội từ Nam ra Bắc",
    example: "lặn lội từ Nam ra Bắc",
  },
  {
    word: "lăn lộn",
    part_of_speech: "động từ",
    meaning: "lăn bên nọ lật bên kia nhiều lần: đau bụng lăn lộn",
    example: "đau bụng lăn lộn",
  },
  {
    word: "lăn lộn",
    part_of_speech: "động từ",
    meaning:
      "lao vào để làm, để vật lộn với khó khăn, vất vả: lăn lộn khắp các chiến trường * lăn lộn trên thương trường",
    example: "lăn lộn khắp các chiến trường * lăn lộn trên thương trường",
  },
  {
    word: "lăn kềnh",
    part_of_speech: "động từ",
    meaning: "nằm đổ ngửa ra: lăn kềnh ra phản",
    example: "lăn kềnh ra phản",
  },
  {
    word: "lăn queo",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) ngã lăn tròn ở tư thế co người lại: ngã lăn queo xuống đất",
    example: "ngã lăn queo xuống đất",
  },
  {
    word: "lăn quay",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) ngã, nằm lăn ra, không động đậy: ngã lăn quay * lăn quay ra ngủ",
    example: "ngã lăn quay * lăn quay ra ngủ",
  },
  {
    word: "lăn lưng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đem hết sức ra làm một việc gì, không kể vất vả, nặng nhọc: suốt ngày lăn lưng ra làm",
    example: "suốt ngày lăn lưng ra làm",
  },
  {
    word: "lăn lóc",
    part_of_speech: "động từ",
    meaning:
      "lăn đi lung tung hoặc lăn qua lật lại nhiều vòng: viên sỏi lăn lóc trên đường * ôm bụng cười lăn lóc",
    example: "viên sỏi lăn lóc trên đường * ôm bụng cười lăn lóc",
  },
  {
    word: "lăn lóc",
    part_of_speech: "động từ",
    meaning:
      "ở vào vị trí không đúng chỗ và vào tình trạng không được quan tâm tới: sách vở vứt lăn lóc dưới sàn",
    example: "sách vở vứt lăn lóc dưới sàn",
  },
  {
    word: "lăn tăn",
    part_of_speech: "tính từ",
    meaning: "nhỏ, đều, có nhiều và chen sát nhau: mụn lăn tăn * mưa lăn tăn",
    example: "mụn lăn tăn * mưa lăn tăn",
  },
  {
    word: "lăn tăn",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều gợn nước nhỏ hay tăm nhỏ nổi lên liên tiếp và chen sát nhau trên bề mặt: nước sôi lăn tăn * sóng nước lăn tăn",
    example: "nước sôi lăn tăn * sóng nước lăn tăn",
  },
  {
    word: "lăn tăn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) còn có những điều hơi băn khoăn, chưa thật yên tâm, thoải mái: giải quyết như thế là được rồi, còn lăn tăn gì nữa!",
    example: "giải quyết như thế là được rồi, còn lăn tăn gì nữa!",
  },
  {
    word: "lăn tay",
    part_of_speech: "động từ",
    meaning:
      "in vân đầu ngón tay vào giấy tờ để làm bằng chứng: lăn tay vào tờ khế ước",
    example: "lăn tay vào tờ khế ước",
  },
  {
    word: "lăn xả",
    part_of_speech: "động từ",
    meaning:
      "lao vào một cách kiên quyết, bất kể khó khăn, nguy hiểm: lăn xả vào đánh * lăn xả vào đám cháy để cứu người",
    example: "lăn xả vào đánh * lăn xả vào đám cháy để cứu người",
  },
  {
    word: "lắng",
    part_of_speech: "động từ",
    meaning: "chìm đọng lại ở đáy: nước lắng cặn * bột lắng xuống đáy thùng",
    example: "nước lắng cặn * bột lắng xuống đáy thùng",
  },
  {
    word: "lắng",
    part_of_speech: "động từ",
    meaning:
      "trở lại trạng thái tĩnh, không còn những biểu hiện sôi nổi mạnh mẽ lúc đầu: âm thanh ồn ã chợt lắng xuống * phong trào đang tạm lắng",
    example: "âm thanh ồn ã chợt lắng xuống * phong trào đang tạm lắng",
  },
  {
    word: "lắng dịu",
    part_of_speech: "tính từ",
    meaning:
      "dịu lại, lắng xuống, không còn căng thẳng, gay gắt nữa: nỗi đau lắng dịu dần * mâu thuẫn giữa hai người đã lắng dịu",
    example: "nỗi đau lắng dịu dần * mâu thuẫn giữa hai người đã lắng dịu",
  },
  {
    word: "lặng câm",
    part_of_speech: "",
    meaning: "im lặng, không nói một lời: ngồi lặng câm không nói",
    example: "ngồi lặng câm không nói",
  },
  {
    word: "lẳng",
    part_of_speech: "động từ",
    meaning:
      "lăng mạnh đi: lẳng hòn đá ra vườn * điên tiết, lẳng cả mâm bát ra sân",
    example: "lẳng hòn đá ra vườn * điên tiết, lẳng cả mâm bát ra sân",
  },
  {
    word: "lẳng",
    part_of_speech: "tính từ",
    meaning: "có biểu hiện khêu gợi: cái cười lẳng * cặp mắt đến là lẳng!",
    example: "cái cười lẳng * cặp mắt đến là lẳng!",
  },
  {
    word: "lăng băng",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như lông bông: sống lăng băng nay đây mai đó",
    example: "sống lăng băng nay đây mai đó",
  },
  {
    word: "lẵng",
    part_of_speech: "danh từ",
    meaning:
      "đồ đựng đan bằng mây hoặc tre, có quai xách, đáy thường hẹp, miệng rộng, thường dùng để đựng hoa: lẵng hoa * lẵng hoa quả",
    example: "lẵng hoa * lẵng hoa quả",
  },
  {
    word: "lăng",
    part_of_speech: "danh từ",
    meaning:
      "công trình xây dựng thường có quy mô lớn, làm nơi cất giữ di hài của vua chúa hoặc của vĩ nhân: lăng Tự Đức * vào lăng viếng Bác",
    example: "lăng Tự Đức * vào lăng viếng Bác",
  },
  {
    word: "lăng",
    part_of_speech: "động từ",
    meaning:
      "làm cho văng mạnh đi xa bằng sức vung ngang của cánh tay: lăng lựu đạn * lăng mạnh hòn đá ra giữa sông",
    example: "lăng lựu đạn * lăng mạnh hòn đá ra giữa sông",
  },
  {
    word: "lăng",
    part_of_speech: "động từ",
    meaning:
      "đưa mạnh thân người hoặc tay, chân theo chiều ngang trong tư thế duỗi thẳng: lăng người qua xà",
    example: "lăng người qua xà",
  },
  {
    word: "lặng",
    part_of_speech: "",
    meaning:
      "ở trạng thái yên, tĩnh, không động: trời lặng gió * biển lặng * nín lặng không nói một lời",
    example: "trời lặng gió * biển lặng * nín lặng không nói một lời",
  },
  {
    word: "lặng",
    part_of_speech: "",
    meaning:
      ". ở vào trạng thái trở nên không nói năng, cử động gì được do chịu tác động tâm lí, tình cảm đột ngột: sung sướng đến lặng người * ngồi chết lặng hàng giờ",
    example: "sung sướng đến lặng người * ngồi chết lặng hàng giờ",
  },
  {
    word: "lắng đọng",
    part_of_speech: "động từ",
    meaning: "lắng dần xuống và đọng lại: phù sa lắng đọng",
    example: "phù sa lắng đọng",
  },
  {
    word: "lắng đọng",
    part_of_speech: "động từ",
    meaning:
      "lưu lại, lắng lại trong chiều sâu tình cảm: hình ảnh lắng đọng trong tâm tưởng",
    example: "hình ảnh lắng đọng trong tâm tưởng",
  },
  {
    word: "lặng lẽ",
    part_of_speech: "tính từ",
    meaning:
      "im lặng, không lên tiếng, không có tiếng động, tiếng ồn: lặng lẽ khóc * sống lặng lẽ như một chiếc bóng * dòng sông lặng lẽ trôi",
    example:
      "lặng lẽ khóc * sống lặng lẽ như một chiếc bóng * dòng sông lặng lẽ trôi",
  },
  {
    word: "lắng đắng",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) có vướng mắc không dễ dứt ngay, giải quyết ngay được: lắng đắng mãi không ra đi được",
    example: "lắng đắng mãi không ra đi được",
  },
  {
    word: "lặng im",
    part_of_speech: "",
    meaning:
      "không phát ra một tiếng nói, một âm thanh nào cả: lặng im suy nghĩ * không gian lặng im, không một tiếng động",
    example: "lặng im suy nghĩ * không gian lặng im, không một tiếng động",
  },
  {
    word: "lăng kính",
    part_of_speech: "danh từ",
    meaning:
      "khối thuỷ tinh hoặc tinh thể trong suốt hình lăng trụ ba mặt, có tính chất làm lệch các tia sáng và phân tích một chùm sáng thành quang phổ.",
    example: "nhìn cuộc đời qua lăng kính màu hồng",
  },
  {
    word: "lẳng lơ",
    part_of_speech: "tính từ",
    meaning:
      'có biểu hiện tỏ ra khêu gợi, thiếu đứng đắn trong quan hệ tiếp xúc nam nữ: cặp mắt lẳng lơ * "Chỉ đâu mà buộc ngang trời, Thuốc đâu mà chữa con người lẳng lơ." (ca dao)',
    example:
      'cặp mắt lẳng lơ * "Chỉ đâu mà buộc ngang trời, Thuốc đâu mà chữa con người lẳng lơ." (ca dao)',
  },
  {
    word: "lẳng lặng",
    part_of_speech: "phụ từ",
    meaning:
      "một cách lặng lẽ, không nói một tiếng: lẳng lặng bỏ đi * lẳng lặng ngồi suy nghĩ",
    example: "lẳng lặng bỏ đi * lẳng lặng ngồi suy nghĩ",
  },
  {
    word: "lăng loàn",
    part_of_speech: "động từ",
    meaning:
      "có hành vi hỗn xược xúc phạm người trên, không chịu phục tùng khuôn phép, bất chấp đạo đức, luân lí (thường nói về phụ nữ trong quan hệ gia đình): ăn nói lăng loàn * người vợ lăng loàn",
    example: "ăn nói lăng loàn * người vợ lăng loàn",
  },
  {
    word: "lăng líu",
    part_of_speech: "tính từ",
    meaning:
      '(phương ngữ) như líu lo: "Chim quyên lăng líu cành dâu, Đêm nằm thăm thẳm canh thâu nhớ chàng." (ca dao)',
    example:
      'Chim quyên lăng líu cành dâu, Đêm nằm thăm thẳm canh thâu nhớ chàng." (ca dao)',
  },
  {
    word: "lẳng khẳng",
    part_of_speech: "tính từ",
    meaning:
      "cao và gầy đến mức như trông rõ những ống xương: người lẳng khẳng như que củi * thân hình lẳng khẳng",
    example: "người lẳng khẳng như que củi * thân hình lẳng khẳng",
  },
  {
    word: "lặng lờ",
    part_of_speech: "tính từ",
    meaning:
      "(chuyển động) êm nhẹ, từ từ, chậm chạp và lặng lẽ, đến mức như không có một chút tiếng động nào: dòng nước lặng lờ trôi",
    example: "dòng nước lặng lờ trôi",
  },
  {
    word: "lăng mạ",
    part_of_speech: "động từ",
    meaning:
      "nói ra những lời xúc phạm nặng nề đến danh dự: bị lăng mạ trước đám đông * có hành vi lăng mạ người khác",
    example: "bị lăng mạ trước đám đông * có hành vi lăng mạ người khác",
  },
  {
    word: "lặng ngắt",
    part_of_speech: "tính từ",
    meaning:
      'im lặng hoàn toàn, tuyệt đối: bốn bề lặng ngắt * "Buồng không lặng ngắt như tờ, Dấu xe ngựa đã rêu lờ mờ xanh." (TKiều)',
    example:
      'bốn bề lặng ngắt * "Buồng không lặng ngắt như tờ, Dấu xe ngựa đã rêu lờ mờ xanh." (TKiều)',
  },
  {
    word: "lăng miếu",
    part_of_speech: "danh từ",
    meaning:
      "mồ mả và đền thờ vua chúa (nói khái quát): lăng miếu của các vị vua nhà Nguyễn * tu bổ đình chùa, lăng miếu",
    example: "lăng miếu của các vị vua nhà Nguyễn * tu bổ đình chùa, lăng miếu",
  },
  {
    word: "lăng mộ",
    part_of_speech: "danh từ",
    meaning:
      "(trang trọng) phần mộ của vua chúa thời xưa, hoặc của một số chí sĩ, lãnh tụ cách mạng được tôn sùng: xây lăng mộ * bảo vệ các lăng mộ cổ",
    example: "xây lăng mộ * bảo vệ các lăng mộ cổ",
  },
  {
    word: "lẵng nhẵng",
    part_of_speech: "tính từ",
    meaning:
      "ở tình trạng không chịu rời ra, dứt ra, làm vướng víu mãi: lẵng nhẵng chạy theo sau",
    example: "lẵng nhẵng chạy theo sau",
  },
  {
    word: "lặng phắc",
    part_of_speech: "",
    meaning:
      "im lặng hoàn toàn, đến mức như không có bất cứ sự hoạt động nào: không gian lặng phắc",
    example: "không gian lặng phắc",
  },
  {
    word: "lăng nhăng",
    part_of_speech: "tính từ",
    meaning:
      "đủ các thứ bất kì, tuỳ tiện và chẳng có giá trị gì: viết lăng nhăng trên giấy * hỏi lăng nhăng đủ chuyện",
    example: "viết lăng nhăng trên giấy * hỏi lăng nhăng đủ chuyện",
  },
  {
    word: "lăng nhăng",
    part_of_speech: "động từ",
    meaning:
      "có quan hệ trai gái bừa bãi, không đứng đắn: bồ bịch lăng nhăng * lăng nhăng hết người này đến người khác",
    example: "bồ bịch lăng nhăng * lăng",
  },
  {
    word: "lắng nghe",
    part_of_speech: "động từ",
    meaning:
      "tập trung sức nghe để thu nhận cho rõ âm thanh: lắng nghe thầy giáo giảng",
    example: "lắng nghe thầy giáo giảng",
  },
  {
    word: "lăng nhục",
    part_of_speech: "động từ",
    meaning:
      "xúc phạm nặng nề đến danh dự, làm cho phải nhục nhã, xấu hổ: bị lăng nhục trước đám đông",
    example: "bị lăng nhục trước đám đông",
  },
  {
    word: "lằng nhằng",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái dính vào nhau, kéo theo nhau, khó tách riêng ra từng cái một: dây dợ dính lằng nhằng * chớp giật lằng nhằng",
    example: "dây dợ dính lằng nhằng * chớp giật lằng nhằng",
  },
  {
    word: "lằng nhằng",
    part_of_speech: "tính từ",
    meaning:
      "ở tình trạng kéo dài mãi, không dứt hẳn, không xong hẳn: làm ăn lằng nhằng * đau ốm lằng nhằng * kể chuyện lằng nhằng, dây cà ra dây muống",
    example:
      "làm ăn lằng nhằng * đau ốm lằng nhằng * kể chuyện lằng nhằng, dây cà ra dây muống",
  },
  {
    word: "lằng nhằng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) không ra sao cả, không đáng kể: mua mấy thứ lằng nhằng * buôn bán lằng nhằng",
    example: "mua mấy thứ lằng nhằng * buôn bán lằng nhằng",
  },
  {
    word: "lăng nhăng lít nhít",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) lăng nhăng đủ thứ, chẳng ra làm sao: viết lăng nhăng lít nhít",
    example: "viết lăng nhăng lít nhít",
  },
  {
    word: "lăng quăng",
    part_of_speech: "danh từ",
    meaning: "ấu trùng muỗi, sống ở dưới nước: diệt bọ gậy",
    example: "diệt bọ gậy",
  },
  {
    word: "lắng tai",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) như lắng nghe: tiếng thì thầm rất nhỏ, phải lắng tai mới nghe thấy",
    example: "tiếng thì thầm rất nhỏ, phải lắng tai mới nghe thấy",
  },
  {
    word: "lặng thầm",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như thầm lặng: sự dâng hiến lặng thầm",
    example: "sự dâng hiến lặng thầm",
  },
  {
    word: "lặng tờ",
    part_of_speech: "tính từ",
    meaning: "yên, tĩnh hoàn toàn, không có một chút động: mặt sông lặng tờ",
    example: "mặt sông lặng tờ",
  },
  {
    word: "lăng tẩm",
    part_of_speech: "danh từ",
    meaning:
      "lăng của vua chúa và các công trình xây dựng trong khu vực (nói khái quát): các lăng tẩm ở Huế",
    example: "các lăng tẩm ở Huế",
  },
  {
    word: "lăng trụ",
    part_of_speech: "danh từ",
    meaning:
      "đa diện có hai mặt đáy song song với nhau, còn các mặt bên đều là những hình bình hành: hình lăng trụ",
    example: "hình lăng trụ",
  },
  {
    word: "lặng thinh",
    part_of_speech: "động từ",
    meaning:
      "im lặng không nói gì, không lên tiếng: lặng thinh không đáp * ngồi lặng thinh suy nghĩ",
    example: "lặng thinh không đáp * ngồi lặng thinh suy nghĩ",
  },
  {
    word: "lăng trì",
    part_of_speech: "động từ",
    meaning:
      "cắt tay chân, xẻo từng miếng thịt cho chết dần (một hình phạt dã man thời phong kiến): xử lăng trì * tử tội bị đem ra lăng trì",
    example: "xử lăng trì * tử tội bị đem ra lăng trì",
  },
  {
    word: "lăng xăng",
    part_of_speech: "động từ",
    meaning:
      "tỏ ra vội vã, rối rít với vẻ quan trọng: lăng xăng đi trước * điệu bộ lăng xăng",
    example: "lăng xăng đi trước * điệu bộ lăng xăng",
  },
  {
    word: "lăng xê",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đưa ra, giới thiệu ra trước công chúng, nhằm làm cho nổi bật để giới thiệu, thu hút sự chú ý của mọi người: báo chí lăng xê một ca sĩ mới * công nghệ lăng xê",
    example: "báo chí lăng xê một ca sĩ mới * công nghệ lăng xê",
  },
  {
    word: "lặng yên",
    part_of_speech: "tính từ",
    meaning: "như yên lặng: lặng yên suy nghĩ",
    example: "lặng yên suy nghĩ",
  },
  {
    word: "lắp bắp",
    part_of_speech: "động từ",
    meaning:
      "(miệng) mấp máy phát ra những tiếng rời rạc và lắp lại, không nên lời, nên câu: nói lắp bắp * lắp bắp mãi không nên lời",
    example: "nói lắp bắp * lắp bắp mãi không nên lời",
  },
  {
    word: "lặp",
    part_of_speech: "động từ",
    meaning:
      "nhắc lại, tái diễn lại giống y như cái đã có trước: bài viết có nhiều ý lặp * lặp đi lặp lại mãi một câu * lịch sử không lặp lại",
    example:
      "bài viết có nhiều ý lặp * lặp đi lặp lại mãi một câu * lịch sử không lặp lại",
  },
  {
    word: "lắp",
    part_of_speech: "động từ",
    meaning:
      "làm cho từng bộ phận rời được đặt đúng vị trí của nó để tất cả các bộ phận hợp lại tạo nên vật hoàn chỉnh, có công dụng: lắp máy * lắp cửa vào khung * súng không lắp đạn",
    example: "lắp máy * lắp cửa vào khung * súng không lắp đạn",
  },
  {
    word: "lắp",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) như lặp (nhưng thường ít dùng hơn): lắp lại câu nói của bạn",
    example: "lắp lại câu nói của bạn",
  },
  {
    word: "lắp đặt",
    part_of_speech: "động từ",
    meaning:
      "lắp ráp các bộ phận thành hệ thống để đưa vào hoạt động: lắp đặt đường ống nước * lắp đặt điện thoại",
    example: "lắp đặt đường ống nước * lắp đặt điện thoại",
  },
  {
    word: "lắp ghép",
    part_of_speech: "động từ",
    meaning:
      "ghép các bộ phận lớn đã làm sẵn lại với nhau thành một bộ phận hoàn chỉnh (thường trong xây dựng): nhà lắp ghép * vật liệu lắp ghép",
    example: "nhà lắp ghép * vật liệu lắp ghép",
  },
  {
    word: "lắt lay",
    part_of_speech: "",
    meaning: "như lay lắt: sống lắt lay",
    example: "sống lắt lay",
  },
  {
    word: "lắp xắp",
    part_of_speech: "tính từ",
    meaning:
      "(nước) xấp xỉ vừa tới một mức xác định nào đó: nước lắp xắp mắt cá chân",
    example: "nước lắp xắp mắt cá chân",
  },
  {
    word: "lắt léo",
    part_of_speech: "tính từ",
    meaning:
      "quanh co, ngoắt ngoéo: đường đi lắt léo * sự đời lắt léo * lưỡi không xương nhiều đường lắt léo (tng)",
    example:
      "đường đi lắt léo * sự đời lắt léo * lưỡi không xương nhiều đường lắt léo (tng)",
  },
  {
    word: "lắp ráp",
    part_of_speech: "động từ",
    meaning:
      "lắp các bộ phận rời của máy với nhau hoặc đặt các bộ phận máy vào đúng chỗ để có thể hoạt động được: lắp ráp xe máy * phân xưởng lắp ráp",
    example: "lắp ráp xe máy * phân xưởng lắp ráp",
  },
  {
    word: "lắt lẻo",
    part_of_speech: "tính từ",
    meaning:
      'ở trạng thái đung đưa trên cao do không được cố định chắc vào điểm tựa: ngồi lắt lẻo trên cành cây * "Ví dầu cầu ván đóng đinh, Cầu tre lắt lẻo gập ghềnh khó đi." (ca dao)',
    example:
      'ngồi lắt lẻo trên cành cây * "Ví dầu cầu ván đóng đinh, Cầu tre lắt lẻo gập ghềnh khó đi." (ca dao)',
  },
  {
    word: "lắt nhắt",
    part_of_speech: "tính từ",
    meaning:
      "quá nhỏ bé, vụn vặt: lũ chuột lắt nhắt * ăn lắt nhắt từng tí một * toàn những việc lắt nhắt",
    example:
      "lũ chuột lắt nhắt * ăn lắt nhắt từng tí một * toàn những việc lắt nhắt",
  },
  {
    word: "lặt vặt",
    part_of_speech: "tính từ",
    meaning: "nhỏ nhặt, không đáng kể: sắm sửa vài thứ lặt vặt * việc lặt vặt",
    example: "sắm sửa vài thứ lặt vặt * việc lặt vặt",
  },
  {
    word: "lấc láo",
    part_of_speech: "động từ",
    meaning: "nhìn đảo quanh, vẻ dò la, gian giảo: mắt lấc láo nhìn quanh",
    example: "mắt lấc láo nhìn quanh",
  },
  {
    word: "lấc cấc",
    part_of_speech: "tính từ",
    meaning: "tỏ ra ngông nghênh và xấc xược: vẻ mặt lấc cấc * thái độ lấc cấc",
    example: "vẻ mặt lấc cấc * thái độ lấc cấc",
  },
  {
    word: "lấc xấc",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như lấc cấc: thái độ lấc xấc",
    example: "thái độ lấc xấc",
  },
  {
    word: "lâm",
    part_of_speech: "động từ",
    meaning:
      "gặp phải, ở vào tình thế không hay cho mình: lâm trọng bệnh * lâm vào cảnh túng quẫn",
    example: "lâm trọng bệnh * lâm vào cảnh túng quẫn",
  },
  {
    word: "lẫm",
    part_of_speech: "danh từ",
    meaning: "nơi được quây kín và có mái che, dùng để chứa thóc: lẫm thóc",
    example: "lẫm thóc",
  },
  {
    word: "lầm",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ) bùn: lội ao vớt lầm",
    example: "lội ao vớt lầm",
  },
  {
    word: "lầm",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều bùn hay bụi cuộn lên làm đục, làm bẩn: nước ao đục lầm lên * con đường đất bụi lầm",
    example: "nước ao đục lầm lên * con đường đất bụi lầm",
  },
  {
    word: "lầm",
    part_of_speech: "tính từ",
    meaning:
      "bị phủ lên một lớp dày bùn đất, bụi bặm: con đường lầm bùn đất * quần áo lầm bụi",
    example: "con đường lầm bùn đất * quần áo lầm bụi",
  },
  {
    word: "lầm",
    part_of_speech: "động từ",
    meaning:
      "nhận thức cái nọ ra cái kia, do sơ ý hay không biết: hiểu lầm nhau * vào lầm nhà * mua lầm hàng giả",
    example: "hiểu lầm nhau * vào lầm nhà * mua lầm hàng giả",
  },
  {
    word: "lấm",
    part_of_speech: "danh từ",
    meaning:
      "đất ở ruộng đã được cày bừa thành bùn nhão, thuận tiện cho việc gieo cấy: giữ lấm để chuẩn bị cấy",
    example: "giữ lấm để chuẩn bị cấy",
  },
  {
    word: "lấm",
    part_of_speech: "tính từ",
    meaning: "bị dây bùn, đất: quần áo lấm đất * chân lấm tay bùn",
    example: "quần áo lấm đất * chân lấm tay bùn",
  },
  {
    word: "lẩm",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) ăn lén lút: được mùa thì chê cơm hẩm, mất mùa thì lẩm cơm thiu (tng)",
    example: "được mùa thì chê cơm hẩm, mất mùa thì lẩm cơm thiu (tng)",
  },
  {
    word: "lầm bầm",
    part_of_speech: "động từ",
    meaning: "như lẩm bẩm: vừa đi vừa lầm bầm trong miệng * lầm bầm chửi",
    example: "vừa đi vừa lầm bầm trong miệng * lầm bầm chửi",
  },
  {
    word: "lẩm bẩm",
    part_of_speech: "động từ",
    meaning:
      "nói nhỏ trong miệng với giọng đều đều, cốt chỉ để mình nghe hoặc là tự nói với mình: miệng lẩm bẩm tính * nói lẩm bẩm một mình",
    example: "miệng lẩm bẩm tính * nói lẩm bẩm một mình",
  },
  {
    word: "lâm bồn",
    part_of_speech: "động từ",
    meaning: "(cũ, trang trọng) (phụ nữ) đẻ: sản phụ lúc lâm bồn",
    example: "sản phụ lúc lâm bồn",
  },
  {
    word: "lâm bệnh",
    part_of_speech: "động từ",
    meaning: "(trang trọng) mắc bệnh: đã qua đời sau một thời gian lâm bệnh",
    example: "đã qua đời sau một thời gian lâm bệnh",
  },
  {
    word: "lẩm cẩm",
    part_of_speech: "tính từ",
    meaning:
      "hơi lẫn, có những lời nói, việc làm không đúng lúc, đúng chỗ (thường nói về người già): chưa già đã sinh lẩm cẩm * nghĩ ngợi lẩm cẩm",
    example: "chưa già đã sinh lẩm cẩm * nghĩ ngợi lẩm cẩm",
  },
  {
    word: "lẫm chẫm",
    part_of_speech: "tính từ",
    meaning:
      "(dáng đi) có những bước ngắn không đều và chưa vững, thường do mới tập đi: bé đang lẫm chẫm tập đi",
    example: "bé đang lẫm chẫm tập đi",
  },
  {
    word: "lâm chung",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) sắp tắt thở, sắp chết: phút lâm chung * lời dặn dò lúc lâm chung",
    example: "phút lâm chung * lời dặn dò lúc lâm chung",
  },
  {
    word: "lấm chấm",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều chấm nhỏ rải rác trên bề mặt: quần áo lấm chấm bùn đất * mặt lấm chấm mụn",
    example: "quần áo lấm chấm bùn đất * mặt lấm chấm mụn",
  },
  {
    word: "lầm đường lạc lối",
    part_of_speech: "",
    meaning: "như lầm đường (nhưng ý nhấn mạnh): kẻ lầm đường lạc lối",
    example: "kẻ lầm đường lạc lối",
  },
  {
    word: "lầm lạc",
    part_of_speech: "động từ",
    meaning:
      "phạm lỗi lầm do đã không nhận ra lẽ phải: thoát khỏi con đường lầm lạc",
    example: "thoát khỏi con đường lầm lạc",
  },
  {
    word: "lâm học",
    part_of_speech: "danh từ",
    meaning: "khoa học về rừng: cán bộ lâm học",
    example: "cán bộ lâm học",
  },
  {
    word: "lầm đường",
    part_of_speech: "động từ",
    meaning:
      "đi vào con đường sai trái, tội lỗi do lầm lạc (thường nói về chính trị): sẵn lòng tha thứ cho những người lầm đường",
    example: "sẵn lòng tha thứ cho những người lầm đường",
  },
  {
    word: "lấm láp",
    part_of_speech: "tính từ",
    meaning:
      'lấm (nói khái quát): mình mẩy lấm láp * "Hoa sen mọc bãi cát lầm, Tuy rằng lấm láp vẫn mầm hoa sen." (ca dao)',
    example:
      'mình mẩy lấm láp * "Hoa sen mọc bãi cát lầm, Tuy rằng lấm láp vẫn mầm hoa sen." (ca dao)',
  },
  {
    word: "lầm lẫn",
    part_of_speech: "động từ",
    meaning:
      "như nhầm lẫn: lầm lẫn sổ sách * việc này tôi đã kiểm tra kĩ, không thể lầm lẫn được",
    example:
      "lầm lẫn sổ sách * việc này tôi đã kiểm tra kĩ, không thể lầm lẫn được",
  },
  {
    word: "lầm lầm",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả vẻ mặt nặng nề, biểu lộ sự tức tối, giận dữ mà không nói ra: lầm lầm nét mặt * mặt lúc nào cũng lầm lầm",
    example: "lầm lầm nét mặt * mặt lúc nào cũng lầm lầm",
  },
  {
    word: "lầm lì",
    part_of_speech: "tính từ",
    meaning:
      "ít nói ít cười, tỏ ra không muốn bộc lộ tâm tư, tình cảm ra ngoài, như có điều không vừa ý: mặt lầm lì * lầm lì chẳng nói chẳng rằng",
    example: "mặt lầm lì * lầm lì chẳng nói chẳng rằng",
  },
  {
    word: "lẫm liệt",
    part_of_speech: "tính từ",
    meaning:
      "có dáng hiên ngang, vẻ oai nghiêm đáng kính phục: oai phong lẫm liệt",
    example: "oai phong lẫm liệt",
  },
  {
    word: "lâm li",
    part_of_speech: "tính từ",
    meaning: "buồn thảm, gây thương cảm: tiếng hát nghe lâm li, não nuột",
    example: "tiếng hát nghe lâm li, não nuột",
  },
  {
    word: "lấm lem",
    part_of_speech: "tính từ",
    meaning: "bị dính bẩn nhiều chỗ: tay lấm lem dầu mỡ",
    example: "tay lấm lem dầu mỡ",
  },
  {
    word: "lấm lét",
    part_of_speech: "tính từ",
    meaning:
      "không dám nhìn thẳng mà cứ liếc trộm để dò xét: lấm lét nhìn trộm * đứa bé lấm lét nhìn mẹ sợ hãi",
    example: "lấm lét nhìn trộm * đứa bé lấm lét nhìn mẹ sợ hãi",
  },
  {
    word: "lầm lỡ",
    part_of_speech: "",
    meaning:
      "phạm sai lầm do thiếu thận trọng: cuộc đời lầm lỡ * sửa chữa lầm lỡ",
    example: "cuộc đời lầm lỡ * sửa chữa lầm lỡ",
  },
  {
    word: "lầm lũi",
    part_of_speech: "tính từ",
    meaning:
      "(dáng vẻ) lặng lẽ, với vẻ âm thầm chịu đựng: lầm lũi bước đi * sống lầm lũi và cô độc",
    example: "lầm lũi bước đi * sống lầm lũi và cô độc",
  },
  {
    word: "lâm luật",
    part_of_speech: "danh từ",
    meaning: "luật bảo vệ và phát triển rừng: vi phạm lâm luật",
    example: "vi phạm lâm luật",
  },
  {
    word: "lầm lội",
    part_of_speech: "tính từ",
    meaning: "như lầy lội: đường sá lầm lội",
    example: "đường sá lầm lội",
  },
  {
    word: "lầm lụi",
    part_of_speech: "tính từ",
    meaning: "vất vả, cơ cực, tối tăm: cuộc sống lầm lụi",
    example: "cuộc sống lầm lụi",
  },
  {
    word: "lầm lụi",
    part_of_speech: "phụ từ",
    meaning:
      "(làm việc gì) một cách âm thầm, lặng lẽ với vẻ cam chịu: lầm lụi làm việc * lầm lụi bước đi",
    example: "lầm lụi làm việc * lầm lụi bước đi",
  },
  {
    word: "lầm lỗi",
    part_of_speech: "danh từ",
    meaning: "như lỗi lầm: sửa chữa lầm lỗi",
    example: "sửa chữa lầm lỗi",
  },
  {
    word: "lầm lỗi",
    part_of_speech: "động từ",
    meaning:
      'phạm sai lầm, khuyết điểm tương đối lớn: một con người lầm lỗi * "Trách duyên, lại giận trăng già, Xe tơ lầm lỗi hoá ra chỉ mành." (ca dao)',
    example:
      'một con người lầm lỗi * "Trách duyên, lại giận trăng già, Xe tơ lầm lỗi hoá ra chỉ mành." (ca dao)',
  },
  {
    word: "lâm nguy",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) gặp nguy hiểm: tổ quốc lâm nguy * phải lúc lâm nguy",
    example: "tổ quốc lâm nguy * phải lúc lâm nguy",
  },
  {
    word: "lẩm nhẩm",
    part_of_speech: "động từ",
    meaning:
      "nói khẽ trong miệng, gần như không thành tiếng: lẩm nhẩm tính toán * hát lẩm nhẩm theo nhạc",
    example: "lẩm nhẩm tính toán * hát lẩm nhẩm theo nhạc",
  },
  {
    word: "lâm nạn",
    part_of_speech: "động từ",
    meaning: "(trang trọng) mắc nạn: lâm nạn giữa đường",
    example: "lâm nạn giữa đường",
  },
  {
    word: "lâm ly",
    part_of_speech: "tính từ",
    meaning: "buồn thảm, gây thương cảm: tiếng hát nghe lâm li, não nuột",
    example: "tiếng hát nghe lâm li, não nuột",
  },
  {
    word: "lâm sản",
    part_of_speech: "danh từ",
    meaning:
      "sản phẩm thu được từ rừng (nói khái quát): khai thác lâm sản quý * thu mua lâm sản",
    example: "khai thác lâm sản quý * thu mua lâm sản",
  },
  {
    word: "lầm rầm",
    part_of_speech: "tính từ",
    meaning:
      'từ mô phỏng tiếng nói nhỏ, thấp và đều đều, nghe không rõ lời: lầm rầm nói chuyện * "Lầm rầm khấn vái nhỏ to, Sụp ngồi và gật trước mồ bước ra." (TKiều)',
    example:
      'lầm rầm nói chuyện * "Lầm rầm khấn vái nhỏ to, Sụp ngồi và gật trước mồ bước ra." (TKiều)',
  },
  {
    word: "lâm phần",
    part_of_speech: "danh từ",
    meaning:
      "khoảnh rừng thuần nhất về mặt loại hình, khác biệt với các khoảnh rừng bên cạnh: tổng diện tích lâm phần của tỉnh",
    example: "tổng diện tích lâm phần của tỉnh",
  },
  {
    word: "lâm râm",
    part_of_speech: "tính từ",
    meaning: "(mưa) nhỏ hạt và kéo dài, không thành cơn: mưa lâm râm",
    example: "mưa lâm râm",
  },
  {
    word: "lâm râm",
    part_of_speech: "tính từ",
    meaning: "(đau) âm ỉ và kéo dài, không thành cơn: đau bụng lâm râm",
    example: "đau bụng lâm râm",
  },
  {
    word: "lâm râm",
    part_of_speech: "tính từ",
    meaning:
      'như lầm rầm: "Lâm râm khấn vái Phật, Trời, Xin cho cha mẹ sống đời nuôi con." (ca dao)',
    example:
      'Lâm râm khấn vái Phật, Trời, Xin cho cha mẹ sống đời nuôi con." (ca dao)',
  },
  {
    word: "lâm sàng",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về những gì trực tiếp quan sát được ở người ốm đang ở trên giường bệnh: triệu chứng lâm sàng * chẩn đoán lâm sàng * chết lâm sàng",
    example: "triệu chứng lâm sàng * chẩn đoán lâm sàng * chết lâm sàng",
  },
  {
    word: "lâm sinh",
    part_of_speech: "danh từ",
    meaning:
      "quy trình và kĩ thuật tạo rừng, tái sinh và phát triển rừng: kĩ sư lâm sinh * dự án lâm sinh",
    example: "kĩ sư lâm sinh * dự án lâm sinh",
  },
  {
    word: "lâm tặc",
    part_of_speech: "danh từ",
    meaning: "kẻ phá hoại rừng để khai thác gỗ bất hợp pháp: truy bắt lâm tặc",
    example: "truy bắt lâm tặc",
  },
  {
    word: "lầm than",
    part_of_speech: "tính từ",
    meaning: "vất vả, cơ cực vì bị áp bức bóc lột: cảnh lầm than",
    example: "cảnh lầm than",
  },
  {
    word: "lấm tấm",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều hạt, nhiều điểm nhỏ và đều trên bề mặt: trán lấm tấm mồ hôi * mưa lấm tấm rắc xuống mặt sân",
    example: "trán lấm tấm mồ hôi * mưa lấm tấm rắc xuống mặt sân",
  },
  {
    word: "lâm sự",
    part_of_speech: "động từ",
    meaning:
      "gặp sự việc, đứng trước sự việc cần phải ứng phó, giải quyết: bình tĩnh khi lâm sự",
    example: "bình tĩnh khi lâm sự",
  },
  {
    word: "lâm trận",
    part_of_speech: "động từ",
    meaning: "vào trận đánh: lúc lâm trận",
    example: "lúc lâm trận",
  },
  {
    word: "lâm tuyền",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, văn chương) rừng và suối (nói khái quát); là nơi tĩnh mịch, thanh tao, trái với cảnh phồn hoa nơi đô hội: chốn lâm tuyền * vui thú lâm tuyền",
    example: "chốn lâm tuyền * vui thú lâm tuyền",
  },
  {
    word: "lâm trường",
    part_of_speech: "danh từ",
    meaning:
      "cơ sở sản xuất chuyên gây trồng và khai thác rừng: lâm trường cà phê * công nhân lâm trường",
    example: "lâm trường cà phê * công nhân lâm trường",
  },
  {
    word: "lân",
    part_of_speech: "danh từ",
    meaning:
      "kì lân (nói tắt): múa lân * bộ tứ linh gồm long, lân, quy, phượng",
    example: "múa lân * bộ tứ linh gồm long, lân, quy, phượng",
  },
  {
    word: "lân",
    part_of_speech: "danh từ",
    meaning: "tên thường gọi của phốt pho: phân lân * bón lân",
    example: "phân lân * bón lân",
  },
  {
    word: "lân",
    part_of_speech: "động từ",
    meaning:
      "ăn sang, vượt sang phạm vi khác, ngoài phạm vi đã định: ngồi lân sang chỗ của người khác * tiêu lân vào vốn * được đằng chân lân đằng đầu (tng)",
    example:
      "ngồi lân sang chỗ của người khác * tiêu lân vào vốn * được đằng chân lân đằng đầu (tng)",
  },
  {
    word: "lâm thâm",
    part_of_speech: "tính từ",
    meaning:
      '(mưa) nhỏ, mau hạt và kéo dài, thường vào mùa đông: "Bầm ơi có rét không bầm!, Heo heo gió núi, lâm thâm mưa phùn." (THữu; 7)',
    example:
      'Bầm ơi có rét không bầm!, Heo heo gió núi, lâm thâm mưa phùn." (THữu; 7)',
  },
  {
    word: "lâm thời",
    part_of_speech: "tính từ",
    meaning:
      "tạm trong một thời gian, chưa chính thức: chính phủ lâm thời * uỷ ban kháng chiến lâm thời",
    example: "chính phủ lâm thời * uỷ ban kháng chiến lâm thời",
  },
  {
    word: "lần",
    part_of_speech: "danh từ",
    meaning:
      "trường hợp hoặc thời điểm xảy ra một sự kiện, hiện tượng lặp đi lặp lại hoặc coi như có thể lặp lại nào đó: gặp nhau đôi lần * phiên họp lần trước * xin nhắc lại một lần nữa",
    example:
      "gặp nhau đôi lần * phiên họp lần trước * xin nhắc lại một lần nữa",
  },
  {
    word: "lần",
    part_of_speech: "danh từ",
    meaning:
      "lớp có thể có nhiều những vật ngăn cách bên trong với bên ngoài: ướt mấy lần áo * qua mấy lần cửa",
    example: "ướt mấy lần áo * qua mấy lần cửa",
  },
  {
    word: "lần",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng sau một danh từ số lượng xác định để chỉ rằng đó là số nhân hay là số chia, khi nói về sự tăng, giảm: hai lần hai là bốn * sản lượng tăng gấp ba lần năm ngoái",
    example: "hai lần hai là bốn * sản lượng tăng gấp ba lần năm ngoái",
  },
  {
    word: "lần",
    part_of_speech: "động từ",
    meaning:
      "sờ nắn dần từng cái, từng phần một: tay lần tràng hạt * lần túi tìm chìa khoá",
    example: "tay lần tràng hạt * lần túi tìm chìa khoá",
  },
  {
    word: "lần",
    part_of_speech: "động từ",
    meaning:
      "dò dần từng bước một: đứa bé bám giường lần đi * đi lần trong bóng tối",
    example: "đứa bé bám giường lần đi * đi lần trong bóng tối",
  },
  {
    word: "lần",
    part_of_speech: "động từ",
    meaning:
      "tìm bằng cách dò dần, chắp nối dần các sự kiện lại: không lần ra đầu mối * chẳng biết đường nào mà lần",
    example: "không lần ra đầu mối * chẳng biết đường nào mà lần",
  },
  {
    word: "lẫn",
    part_of_speech: "động từ",
    meaning:
      "nhận nhầm cái nọ ra cái kia, do không phân biệt được sự khác nhau: lẫn cô chị với cô em * cầm lẫn mũ của người khác",
    example: "lẫn cô chị với cô em * cầm lẫn mũ của người khác",
  },
  {
    word: "lẫn",
    part_of_speech: "động từ",
    meaning:
      "ở vào tình trạng không nhận đúng sự vật, hiện tượng, do trí nhớ bị giảm sút: nói lẫn * già rồi nên bị lẫn",
    example: "nói lẫn * già rồi nên bị lẫn",
  },
  {
    word: "lẫn",
    part_of_speech: "động từ",
    meaning:
      "xen vào giữa những thứ khác khiến khó tách biệt cái nọ với cái kia: gạo lẫn nhiều thóc * thịt nạc có lẫn ít mỡ * đi lẫn vào đám đông",
    example: "gạo lẫn nhiều thóc * thịt nạc có lẫn ít mỡ * đi lẫn vào đám đông",
  },
  {
    word: "lẫn",
    part_of_speech: "phụ từ",
    meaning:
      "từ dùng phối hợp với nhau để biểu thị tác động qua lại, hai chiều: giúp đỡ lẫn nhau * học hỏi kinh nghiệm lẫn nhau * chửi bới lẫn nhau",
    example:
      "giúp đỡ lẫn nhau * học hỏi kinh nghiệm lẫn nhau * chửi bới lẫn nhau",
  },
  {
    word: "lẫn",
    part_of_speech: "kết từ",
    meaning:
      "cùng với, và: làm cả ngày lẫn đêm * giúp đỡ cả vật chất lẫn tinh thần * mất cả chì lẫn chài",
    example:
      "làm cả ngày lẫn đêm * giúp đỡ cả vật chất lẫn tinh thần * mất cả chì lẫn chài",
  },
  {
    word: "lận",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ, khẩu ngữ) nhét, giấu kĩ trong người để mang theo: lận tiền trong người * lận trái lựu đạn ở lưng quần",
    example: "lận tiền trong người * lận trái lựu đạn ở lưng quần",
  },
  {
    word: "lận",
    part_of_speech: "trợ từ",
    meaning:
      "(phương ngữ) từ biểu thị ý nhấn mạnh hoặc ý muốn hỏi, với vẻ hơi ngạc nhiên; kia, kia à: nó đi từ hôm qua lận * trời, đẹp như vậy lận sao?",
    example: "nó đi từ hôm qua lận * trời, đẹp như vậy lận sao?",
  },
  {
    word: "lân bang",
    part_of_speech: "danh từ",
    meaning: "(cũ, hiếm) nước láng giềng: nước lân bang",
    example: "nước lân bang",
  },
  {
    word: "lẩn",
    part_of_speech: "động từ",
    meaning:
      "bỏ đi nơi khác một cách rất nhanh, nhân lúc không ai để ý: vừa ở đây đã lẩn đi đâu mất * lẩn như chạch",
    example: "vừa ở đây đã lẩn đi đâu mất * lẩn như chạch",
  },
  {
    word: "lẩn",
    part_of_speech: "động từ",
    meaning:
      "ở lẫn vào những cái khác khiến cho khó nhận ra, khó nhìn thấy: lẩn vào đám đông * mặt trăng lẩn trong đám mây đen",
    example: "lẩn vào đám đông * mặt trăng lẩn trong đám mây đen",
  },
  {
    word: "lấn",
    part_of_speech: "động từ",
    meaning:
      "mở rộng dần phạm vi, chiếm dần sang phạm vi của cái khác: đắp đê lấn biển * được thể càng lấn tới * lấn sâu vào con đường cờ bạc",
    example:
      "đắp đê lấn biển * được thể càng lấn tới * lấn sâu vào con đường cờ bạc",
  },
  {
    word: "lấn",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) xô đẩy để chen vào, để vượt lên: người quá đông, không lấn vào được * mọi người xô nhau lấn tới trước",
    example:
      "người quá đông, không lấn vào được * mọi người xô nhau lấn tới trước",
  },
  {
    word: "lấn bấn",
    part_of_speech: "tính từ",
    meaning:
      "lúng túng vì vướng víu, bận bịu quá nhiều: lấn bấn việc nhà * trong lòng lấn bấn",
    example: "lấn bấn việc nhà * trong lòng lấn bấn",
  },
  {
    word: "lấn át",
    part_of_speech: "động từ",
    meaning:
      "lấn đến mức át đi, làm cho ở vào thế yếu hơn: để vợ lấn át * to mồm lấn át cả người khác",
    example: "để vợ lấn át * to mồm lấn át cả người khác",
  },
  {
    word: "lân cận",
    part_of_speech: "tính từ",
    meaning:
      "(nơi) ở gần bên cạnh: làng lân cận * thành phố và các tỉnh lân cận",
    example: "làng lân cận * thành phố và các tỉnh lân cận",
  },
  {
    word: "lận đận",
    part_of_speech: "tính từ",
    meaning:
      "vất vả, chật vật, không thoát lên được vì gặp phải nhiều trắc trở, khó khăn: tình duyên lận đận * lận đận về đường thi cử",
    example: "tình duyên lận đận * lận đận về đường thi cử",
  },
  {
    word: "lấn cấn",
    part_of_speech: "tính từ",
    meaning:
      "có điều vướng mắc phải bận tâm suy nghĩ: còn lấn cấn về việc gia đình",
    example: "còn lấn cấn về việc gia đình",
  },
  {
    word: "lần chần",
    part_of_speech: "động từ",
    meaning:
      "kéo dài thời gian, do còn đắn đo, chưa quyết định được dứt khoát làm hay không làm việc gì: lần chần chưa muốn đi * đã muộn lại còn lần chần!",
    example: "lần chần chưa muốn đi * đã muộn lại còn lần chần!",
  },
  {
    word: "lần chần",
    part_of_speech: "tính từ",
    meaning: "như lừng khừng: đứng lần chần, nửa muốn đi nửa muốn ở",
    example: "đứng lần chần, nửa muốn đi nửa muốn ở",
  },
  {
    word: "lẫn cẫn",
    part_of_speech: "tính từ",
    meaning: "hay quên, hay lẫn do tuổi già: già rồi nên sinh lẫn cẫn",
    example: "già rồi nên sinh lẫn cẫn",
  },
  {
    word: "lấn chiếm",
    part_of_speech: "động từ",
    meaning:
      "chiếm đất đai dần từng bước: lấn chiếm lòng đường * lấn chiếm vùng đất biên giới",
    example: "lấn chiếm lòng đường * lấn chiếm vùng đất biên giới",
  },
  {
    word: "lần hồi",
    part_of_speech: "phụ từ",
    meaning:
      "dần dà cho qua ngày tháng: sống lần hồi * lần hồi rau cháo nuôi nhau",
    example: "sống lần hồi * lần hồi rau cháo nuôi nhau",
  },
  {
    word: "lẩn khuất",
    part_of_speech: "động từ",
    meaning:
      "lẩn vào nơi kín đáo hoặc nơi có vật che phủ, làm cho bị khuất đi, khó thấy: toán cướp lẩn khuất trong rừng",
    example: "toán cướp lẩn khuất trong rừng",
  },
  {
    word: "lần khần",
    part_of_speech: "động từ",
    meaning: "như lần chần: còn lần khần chưa quyết định",
    example: "còn lần khần chưa quyết định",
  },
  {
    word: "lẫn lộn",
    part_of_speech: "động từ",
    meaning:
      "lẫn vào với nhau, không còn phân biệt được nữa: trộn lẫn lộn hai loại gạo * buồn vui lẫn lộn",
    example: "trộn lẫn lộn hai loại gạo * buồn vui lẫn lộn",
  },
  {
    word: "lẫn lộn",
    part_of_speech: "động từ",
    meaning:
      "nhận thức nhầm cái nọ với cái kia, không phân biệt được hai cái khác hẳn nhau, đối lập nhau: lẫn lộn bạn thù * già rồi nên đầu óc đã bắt đầu lẫn lộn",
    example: "lẫn lộn bạn thù * già rồi nên đầu óc đã bắt đầu lẫn lộn",
  },
  {
    word: "lẩn lút",
    part_of_speech: "động từ",
    meaning: "lẩn trốn lúc chỗ này, lúc chỗ khác: sống lẩn lút trong rừng",
    example: "sống lẩn lút trong rừng",
  },
  {
    word: "lần khân",
    part_of_speech: "động từ",
    meaning: "kéo dài thời gian để dây dưa: lần khân mãi không chịu trả nợ",
    example: "lần khân mãi không chịu trả nợ",
  },
  {
    word: "lần lần",
    part_of_speech: "phụ từ",
    meaning:
      '(cũ, hoặc ph) dần dần: "Lần lần tháng trọn ngày qua, Nỗi gần, nào biết đường xa thế này?" (TKiều)',
    example:
      'Lần lần tháng trọn ngày qua, Nỗi gần, nào biết đường xa thế này?" (TKiều)',
  },
  {
    word: "lần lượt",
    part_of_speech: "phụ từ",
    meaning:
      "(làm việc gì) theo thứ tự trước sau cho đến hết: trả lời lần lượt từng câu hỏi * xếp hàng lần lượt",
    example: "trả lời lần lượt từng câu hỏi * xếp hàng lần lượt",
  },
  {
    word: "lấn lướt",
    part_of_speech: "động từ",
    meaning:
      "dựa vào sức mạnh mà chèn ép, mà át đi: cỏ dại lấn lướt mạ * bị vợ lấn lướt * cấp trên lấn lướt cấp dưới",
    example: "cỏ dại lấn lướt mạ * bị vợ lấn lướt * cấp trên lấn lướt cấp dưới",
  },
  {
    word: "lần lữa",
    part_of_speech: "động từ",
    meaning:
      'kéo dài thời gian để trì hoãn: chưa có tiền trả nên khất lần lữa * "Những là lần lữa nắng mưa, Kiếp phong trần biết bao giờ mới thôi?" (TKiều)',
    example:
      'chưa có tiền trả nên khất lần lữa * "Những là lần lữa nắng mưa, Kiếp phong trần biết bao giờ mới thôi?" (TKiều)',
  },
  {
    word: "lẩn mẩn",
    part_of_speech: "tính từ",
    meaning:
      "(làm việc gì) từng tí một một cách tỉ mỉ: lẩn mẩn tô từng nét chữ",
    example: "lẩn mẩn tô từng nét chữ",
  },
  {
    word: "lân la",
    part_of_speech: "động từ",
    meaning:
      'tìm cách tiếp cận dần dần từng bước, tạo ra một quan hệ tiếp xúc gần gũi, nhằm thực hiện mục đích nhất định: lân la dò hỏi * "Sớm đào, tối mận, lân la, Trước còn trăng gió, sau ra đá vàng." (TKiều)',
    example:
      'lân la dò hỏi * "Sớm đào, tối mận, lân la, Trước còn trăng gió, sau ra đá vàng." (TKiều)',
  },
  {
    word: "lân quang",
    part_of_speech: "danh từ",
    meaning:
      "ánh sáng xanh tự phát ra ở một số chất (không do cháy hoặc nóng lên), giống ánh sáng của lân tinh khi cháy, chỉ thấy được trong bóng tối: đom đóm có lân quang",
    example: "đom đóm có lân quang",
  },
  {
    word: "lẩn quất",
    part_of_speech: "",
    meaning: "ẩn nấp loanh quanh đâu đó: kẻ gian còn lẩn quất đâu đây",
    example: "kẻ gian còn lẩn quất đâu đây",
  },
  {
    word: "lấn sân",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) dồn về phía sân đối phương tạo thành thế áp đảo (trong một số môn thể thao như bóng đá, bóng rổ, v.v.): đá lấn sân * đội chủ nhà chơi có phần lấn sân hơn",
    example: "đá lấn sân * đội chủ nhà chơi có phần lấn sân hơn",
  },
  {
    word: "lấn sân",
    part_of_speech: "động từ",
    meaning:
      "lấn sang phạm vi hoạt động của người khác, cái khác: hàng ngoại lấn sân hàng nội",
    example: "hàng ngoại lấn sân hàng nội",
  },
  {
    word: "lần mò",
    part_of_speech: "động từ",
    meaning:
      "dò dẫm tìm kiếm dần dần một cách khó khăn vất vả: tay lần mò tìm công tắc đèn * lần mò mãi mới tìm được lối ra",
    example: "tay lần mò tìm công tắc đèn * lần mò mãi mới tìm được lối ra",
  },
  {
    word: "lẩn thẩn",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra không còn sáng suốt, có những ý nghĩ, lời nói hay việc làm ít nhiều ngớ ngẩn: ăn nói lẩn thẩn * suy nghĩ lẩn thẩn",
    example: "ăn nói lẩn thẩn * suy nghĩ lẩn thẩn",
  },
  {
    word: "lân tinh",
    part_of_speech: "danh từ",
    meaning: "chất lân; phốt pho: ánh lân tinh",
    example: "ánh lân tinh",
  },
  {
    word: "lần thần",
    part_of_speech: "tính từ",
    meaning:
      "kém vẻ linh hoạt, trông có vẻ đờ đẫn, không nhanh nhẹn: vẻ mặt lần thần",
    example: "vẻ mặt lần thần",
  },
  {
    word: "lẩn tránh",
    part_of_speech: "động từ",
    meaning:
      "cố tránh đi để khỏi phải gặp, hay khỏi phải liên luỵ: lẩn tránh pháp luật * lẩn tránh cái nhìn soi mói * xấu hổ nên lẩn tránh bạn bè",
    example:
      "lẩn tránh pháp luật * lẩn tránh cái nhìn soi mói * xấu hổ nên lẩn tránh bạn bè",
  },
  {
    word: "lâng lâng",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái nhẹ nhõm, khoan khoái, rất dễ chịu: tâm hồn lâng lâng * lòng lâng lâng vui sướng",
    example: "tâm hồn lâng lâng * lòng lâng lâng vui sướng",
  },
  {
    word: "lẩn trốn",
    part_of_speech: "động từ",
    meaning:
      "trốn vào nơi nào đó kín đáo (hàm ý chê): lẩn trốn trong rừng * tên tội phạm đang lẩn trốn đâu đây",
    example: "lẩn trốn trong rừng * tên tội phạm đang lẩn trốn đâu đây",
  },
  {
    word: "lấp",
    part_of_speech: "động từ",
    meaning:
      "làm cho đầy, cho kín chỗ trũng, chỗ trống: lấp các ao tù * lấp kín cửa hang * hát lấp chỗ trống",
    example: "lấp các ao tù * lấp kín cửa hang * hát lấp chỗ trống",
  },
  {
    word: "lấp",
    part_of_speech: "động từ",
    meaning:
      "làm cho khuất đi, không còn nhìn thấy được nữa: cỏ mọc lấp cả lối đi * vành mũ rộng làm lấp nửa mặt",
    example: "cỏ mọc lấp cả lối đi * vành mũ rộng làm lấp nửa mặt",
  },
  {
    word: "lấp",
    part_of_speech: "động từ",
    meaning:
      "làm cho bị át đi không còn nghe thấy, nhận thấy nữa: tiếng sóng biển lấp tiếng thét",
    example: "tiếng sóng biển lấp tiếng thét",
  },
  {
    word: "lập cập",
    part_of_speech: "tính từ",
    meaning:
      "(run) mạnh và liên tiếp, không sao kìm giữ được: rét run lập cập * hai hàm răng va vào nhau lập cập",
    example: "rét run lập cập * hai hàm răng va vào nhau lập cập",
  },
  {
    word: "lập cập",
    part_of_speech: "tính từ",
    meaning:
      "vội vã một cách khó nhọc, vì mất bình tĩnh: lập cập ra mở cửa * lập cập thu dọn đồ đạc",
    example: "lập cập ra mở cửa * lập cập thu dọn đồ đạc",
  },
  {
    word: "lập bập",
    part_of_speech: "động từ",
    meaning:
      "(môi hay răng) đập liên tiếp vào nhau, thường vì rét hoặc vì sợ hãi: lập bập mãi mới nói được một câu",
    example: "lập bập mãi mới nói được một câu",
  },
  {
    word: "lẩn vẩn",
    part_of_speech: "động từ",
    meaning: "(hiếm) như lởn vởn: kẻ gian lẩn vẩn quanh ngôi nhà",
    example: "kẻ gian lẩn vẩn quanh ngôi nhà",
  },
  {
    word: "lập",
    part_of_speech: "động từ",
    meaning:
      "tạo ra, xây dựng nên (cái thường là quan trọng, có ý nghĩa lớn): lập biên bản * thời kì lập nước * chưa lập gia đình * lập kỉ lục thế giới",
    example:
      "lập biên bản * thời kì lập nước * chưa lập gia đình * lập kỉ lục thế giới",
  },
  {
    word: "lập",
    part_of_speech: "động từ",
    meaning:
      "đặt lên một cương vị quan trọng nào đó (thường nói về vua chúa): được lập lên làm vua * lập hoàng hậu",
    example: "được lập lên làm vua * lập hoàng hậu",
  },
  {
    word: "lập cà lập cập",
    part_of_speech: "tính từ",
    meaning:
      "như lập cập (nhưng ý mức độ nhiều): sợ quá, chân tay lập cà lập cập",
    example: "sợ quá, chân tay lập cà lập cập",
  },
  {
    word: "lập công",
    part_of_speech: "động từ",
    meaning:
      "lập được chiến công, thành tích lớn: giết giặc lập công * lập công chuộc tội",
    example: "giết giặc lập công * lập công chuộc tội",
  },
  {
    word: "lấp lánh",
    part_of_speech: "",
    meaning:
      "có ánh sáng phản chiếu không liên tục, nhưng đều đặn, vẻ sinh động: mắt sáng lấp lánh * viên kim cương lấp lánh",
    example: "mắt sáng lấp lánh * viên kim cương lấp lánh",
  },
  {
    word: "lập hiến",
    part_of_speech: "động từ",
    meaning:
      "định ra hiến pháp: quốc hội là cơ quan duy nhất có quyền lập hiến",
    example: "quốc hội là cơ quan duy nhất có quyền lập hiến",
  },
  {
    word: "lập dị",
    part_of_speech: "tính từ",
    meaning:
      "(cách sống) có vẻ khác người một cách cố ý, cốt để mọi người để ý đến mình: lối sống lập dị * tư tưởng lập dị * tính cách lập dị",
    example: "lối sống lập dị * tư tưởng lập dị * tính cách lập dị",
  },
  {
    word: "lập là",
    part_of_speech: "danh từ",
    meaning:
      "chảo nhỏ, lòng nông và bằng, có cán cầm, dùng để xào rán thức ăn: dùng lập là rán trứng",
    example: "dùng lập là rán trứng",
  },
  {
    word: "lập kế",
    part_of_speech: "động từ",
    meaning: "(cũ, hiếm) như lập mưu: lập kế báo thù",
    example: "lập kế báo thù",
  },
  {
    word: "lấp láy",
    part_of_speech: "động từ",
    meaning: "(phương ngữ)",
    example: "từ lấp láy * được dùng ở dạng lấp láy",
  },
  {
    word: "lấp loé",
    part_of_speech: "",
    meaning:
      "(ánh sáng) phát ra lúc sáng lúc tối, lúc gần lúc xa: vệt đèn pin lấp loé * những tàu lá dừa rung lên lấp loé dưới trăng",
    example:
      "vệt đèn pin lấp loé * những tàu lá dừa rung lên lấp loé dưới trăng",
  },
  {
    word: "lấp ló",
    part_of_speech: "động từ",
    meaning:
      'ló ra rồi khuất đi, khi ẩn khi hiện liên tiếp: đứng lấp ló ở ngoài cổng * "Bóng gương lấp ló trong mành, Cỏ cây cũng muốn nổi tình mây mưa." (CO)',
    example:
      'đứng lấp ló ở ngoài cổng * "Bóng gương lấp ló trong mành, Cỏ cây cũng muốn nổi tình mây mưa." (CO)',
  },
  {
    word: "lấp liếm",
    part_of_speech: "động từ",
    meaning:
      "nói át đi, hòng che lấp điều sai trái, tội lỗi của mình để tránh trách nhiệm: cãi lấp liếm",
    example: "cãi lấp liếm",
  },
  {
    word: "lấp loá",
    part_of_speech: "",
    meaning:
      "có ánh sáng phản chiếu, lúc loá lên, lúc không: mặt sông lấp loá ánh trăng",
    example: "mặt sông lấp loá ánh trăng",
  },
  {
    word: "lập loè",
    part_of_speech: "",
    meaning:
      'có ánh sáng nhỏ phát ra, khi loé lên khi mờ đi, lúc ẩn lúc hiện, liên tiếp: đom đóm lập loè * "Dưới trăng quyên đã gọi hè, Đầu tường lửa lựu lập loè đâm bông." (TKiều)',
    example:
      'đom đóm lập loè * "Dưới trăng quyên đã gọi hè, Đầu tường lửa lựu lập loè đâm bông." (TKiều)',
  },
  {
    word: "lập lờ",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái nửa nổi nửa chìm, lúc ẩn lúc hiện trong nước: gỗ trôi lập lờ",
    example: "gỗ trôi lập lờ",
  },
  {
    word: "lập lờ",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất hai mặt, không rõ ràng, dứt khoát, nhằm lẩn tránh hoặc che giấu điều gì: thái độ lập lờ * nói lập lờ nước đôi",
    example: "thái độ lập lờ * nói lập lờ nước đôi",
  },
  {
    word: "lấp loáng",
    part_of_speech: "",
    meaning:
      "(ánh sáng) chiếu thành vệt lúc ngắn lúc dài, khi có khi không, liên tiếp: ánh đèn lấp loáng trên đường đê",
    example: "ánh đèn lấp loáng trên đường đê",
  },
  {
    word: "lấp lửng",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất mập mờ không rõ ràng một cách cố ý, để cho muốn hiểu thế nào cũng được: trả lời lấp lửng * nói lấp lửng, nước đôi",
    example: "trả lời lấp lửng * nói lấp lửng, nước đôi",
  },
  {
    word: "lập luận",
    part_of_speech: "",
    meaning:
      "sắp xếp lí lẽ một cách có hệ thống để trình bày, nhằm chứng minh cho một kết luận về một vấn đề: lập luận thiếu chặt chẽ * chưa biết cách lập luận",
    example: "lập luận thiếu chặt chẽ * chưa biết cách lập luận",
  },
  {
    word: "lập mưu",
    part_of_speech: "động từ",
    meaning: "đặt ra mưu kế: lập mưu làm phản",
    example: "lập mưu làm phản",
  },
  {
    word: "lập pháp",
    part_of_speech: "động từ",
    meaning: "định ra pháp luật: cơ quan lập pháp",
    example: "cơ quan lập pháp",
  },
  {
    word: "lập nghiêm",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) làm ra vẻ nghiêm nghị, nghiêm trang: hơi mỉm cười rồi lập nghiêm lại ngay",
    example: "hơi mỉm cười rồi lập nghiêm lại ngay",
  },
  {
    word: "lập phương",
    part_of_speech: "danh từ",
    meaning: "hình lập phương (nói tắt).",
    example: "8 là lập phương của 2",
  },
  {
    word: "lập trình",
    part_of_speech: "động từ",
    meaning:
      "thiết kế giải pháp, cấu trúc dữ liệu, viết chương trình và kiểm thử chương trình cho máy tính: nhân viên lập trình",
    example: "nhân viên lập trình",
  },
  {
    word: "lập thân",
    part_of_speech: "động từ",
    meaning:
      "tạo lấy cuộc sống và sự nghiệp riêng: có chí lập thân * cố học cho giỏi để lập thân",
    example: "có chí lập thân * cố học cho giỏi để lập thân",
  },
  {
    word: "lập nghiệp",
    part_of_speech: "động từ",
    meaning:
      "gây dựng cơ nghiệp: đến vùng kinh tế mới lập nghiệp * sinh cơ lập nghiệp",
    example: "đến vùng kinh tế mới lập nghiệp * sinh cơ lập nghiệp",
  },
  {
    word: "lập trình viên",
    part_of_speech: "danh từ",
    meaning: "người chuyên lập trình cho máy tính: đào tạo lập trình viên",
    example: "đào tạo lập trình viên",
  },
  {
    word: "lập trường",
    part_of_speech: "danh từ",
    meaning:
      "chỗ đứng và thái độ khi nhận thức và xử lí vấn đề: giữ vững lập trường * không thay đổi lập trường chính trị",
    example: "giữ vững lập trường * không thay đổi lập trường chính trị",
  },
  {
    word: "lập tức",
    part_of_speech: "phụ từ",
    meaning:
      "liền ngay sau đó, không chần chừ, không chậm trễ: thấy động, lập tức chuồn mất * đang nói lập tức im bặt",
    example: "thấy động, lập tức chuồn mất * đang nói lập tức im bặt",
  },
  {
    word: "lật bật",
    part_of_speech: "động từ",
    meaning:
      "bật lên, nẩy lên liên tiếp do run rẩy quá mức: chân tay run lật bật",
    example: "chân tay run lật bật",
  },
  {
    word: "lật bật",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) (dáng đi) hấp tấp, bằng những bước ngắn, tựa như bật lên, nẩy lên: lật bật chạy ra mở cổng * dáng đi lật bật",
    example: "lật bật chạy ra mở cổng * dáng đi lật bật",
  },
  {
    word: "lật lọng",
    part_of_speech: "động từ",
    meaning:
      "phản lại một cách trắng trợn điều đã hứa, đã cam kết: quen thói lật lọng",
    example: "quen thói lật lọng",
  },
  {
    word: "lật",
    part_of_speech: "động từ",
    meaning:
      "trở một vật để thay đổi mặt của nó: lật từng trang sách * lật ngửa bàn tay * thuyền bị lật",
    example: "lật từng trang sách * lật ngửa bàn tay * thuyền bị lật",
  },
  {
    word: "lật đật",
    part_of_speech: "tính từ",
    meaning:
      "có dáng vẻ vội vã, tất tả, như lúc nào cũng sợ không kịp: lật đật chạy ra mở cửa",
    example: "lật đật chạy ra mở cửa",
  },
  {
    word: "lật đật",
    part_of_speech: "danh từ",
    meaning:
      "đồ chơi hình người có đáy tròn gắn vật nặng, hễ cứ đặt nằm là tự bật dậy: con lật đật",
    example: "con lật đật",
  },
  {
    word: "lật mặt",
    part_of_speech: "động từ",
    meaning: "(hiếm) như trở mặt: kẻ hay lật mặt",
    example: "kẻ hay lật mặt",
  },
  {
    word: "lất phất",
    part_of_speech: "",
    meaning:
      "(vật mỏng, nhẹ) bay lật qua lật lại nhẹ nhàng khi có gió: mấy sợi tóc lất phất trước trán * tà áo bay lất phất",
    example: "mấy sợi tóc lất phất trước trán * tà áo bay lất phất",
  },
  {
    word: "lất phất",
    part_of_speech: "",
    meaning:
      "(hạt mưa bụi) rơi rất nhẹ và tựa như bay nghiêng theo chiều gió: trời lất phất mưa bay",
    example: "trời lất phất mưa bay",
  },
  {
    word: "lật đổ",
    part_of_speech: "động từ",
    meaning: "làm cho sụp đổ bằng bạo lực: lật đổ ách thống trị",
    example: "lật đổ ách thống trị",
  },
  {
    word: "lật ngược",
    part_of_speech: "động từ",
    meaning: "như lật (ng2): thế cờ bị lật ngược",
    example: "thế cờ bị lật ngược",
  },
  {
    word: "lật phật",
    part_of_speech: "tính từ",
    meaning: "như phần phật (nhưng nghĩa nhẹ hơn): tàu lá chuối rung lật phật",
    example: "tàu lá chuối rung lật phật",
  },
  {
    word: "lật tẩy",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) vạch rõ bộ mặt gian dối hoặc mưu đồ xấu xa đang được che giấu: hành vi dối trá đã bị lật tẩy",
    example: "hành vi dối trá đã bị lật tẩy",
  },
  {
    word: "lẩu",
    part_of_speech: "danh từ",
    meaning:
      "món ăn gồm nhiều thứ thịt, tôm, cá, rau, v.v. thả vào nồi nước dùng đang sôi để ăn nóng: lẩu cá * lẩu bò * ăn lẩu",
    example: "lẩu cá * lẩu bò * ăn lẩu",
  },
  {
    word: "lẩu",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng để nấu món lẩu, có bộ phận đun cho nước sôi liên tục: lẩu than * nồi lẩu điện",
    example: "lẩu than * nồi lẩu điện",
  },
  {
    word: "lầu",
    part_of_speech: "danh từ",
    meaning: "===== (phương ngữ): lên lầu * phòng ngủ ở lầu hai",
    example: "lên lầu * phòng ngủ ở lầu hai",
  },
  {
    word: "lâu dài",
    part_of_speech: "tính từ",
    meaning:
      "trong một khoảng thời gian dài: làm ăn lâu dài * cuộc kháng chiến lâu dài * tính chuyện lâu dài",
    example: "làm ăn lâu dài * cuộc kháng chiến lâu dài * tính chuyện lâu dài",
  },
  {
    word: "lậu",
    part_of_speech: "danh từ",
    meaning:
      "bệnh hoa liễu dễ lây do một loại cầu khuẩn gây ra, khi tiểu tiện bị đau buốt và nước tiểu thường có màu trắng đục: mắc bệnh lậu",
    example: "mắc bệnh lậu",
  },
  {
    word: "lậu",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất trái phép, lén lút (thường nói về hàng hoá hay việc buôn bán): hàng nhập lậu * nấu rượu lậu * sách in lậu",
    example: "hàng nhập lậu * nấu rượu lậu * sách in lậu",
  },
  {
    word: "lầu bầu",
    part_of_speech: "động từ",
    meaning: "nói nhỏ trong miệng tỏ vẻ bực dọc, khó chịu: làu bàu trong miệng",
    example: "làu bàu trong miệng",
  },
  {
    word: "lẩu bẩu",
    part_of_speech: "động từ",
    meaning:
      "như làu bàu (nhưng nghĩa mạnh hơn): miệng lảu bảu điều gì nghe không rõ",
    example: "miệng lảu bảu điều gì nghe không rõ",
  },
  {
    word: "lâu bền",
    part_of_speech: "tính từ",
    meaning: "lâu dài và bền vững: mối quan hệ lâu bền",
    example: "mối quan hệ lâu bền",
  },
  {
    word: "lâu",
    part_of_speech: "tính từ",
    meaning:
      "(quá trình, hoạt động) có thời gian kéo dài, hoặc đòi hỏi một thời gian được coi là dài mới kết thúc: đợi một lúc lâu * của bền nên dùng được lâu * miếng ngon nhớ lâu, đòn đau nhớ đời (tng)",
    example:
      "đợi một lúc lâu * của bền nên dùng được lâu * miếng ngon nhớ lâu, đòn đau nhớ đời (tng)",
  },
  {
    word: "lâu",
    part_of_speech: "tính từ",
    meaning:
      "ở vào một thời điểm được coi là xa với thời điểm đang nói: chuyện xảy ra chưa lâu * hai người đã lâu không gặp nhau * làm thế này thì còn lâu mới xong",
    example:
      "chuyện xảy ra chưa lâu * hai người đã lâu không gặp nhau * làm thế này thì còn lâu mới xong",
  },
  {
    word: "lâu đài",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) nhà có quy mô to lớn, cao rộng, đẹp và sang trọng: toà lâu đài",
    example: "toà lâu đài",
  },
  {
    word: "lâu đời",
    part_of_speech: "tính từ",
    meaning:
      "trải qua nhiều đời: kinh nghiệm lâu đời * truyền thống văn hoá lâu đời * nhà làm nghề dệt vải lâu đời",
    example:
      "kinh nghiệm lâu đời * truyền thống văn hoá lâu đời * nhà làm nghề dệt vải lâu đời",
  },
  {
    word: "lâu la",
    part_of_speech: "danh từ",
    meaning:
      "bọn tay chân của tướng cướp hoặc của kẻ đầu sỏ gian ác (nói khái quát): bắt gọn cả tướng cướp lẫn bọn lâu la",
    example: "bắt gọn cả tướng cướp lẫn bọn lâu la",
  },
  {
    word: "lâu la",
    part_of_speech: "tính từ",
    meaning: "(Khẩu ngữ) lâu (nói khái quát): làm cái gì cũng lâu la",
    example: "làm cái gì cũng lâu la",
  },
  {
    word: "lâu nhâu",
    part_of_speech: "động từ",
    meaning:
      "xúm đông vào, gây mất trật tự: lũ trẻ lâu nhâu quanh chiếc xe mới",
    example: "lũ trẻ lâu nhâu quanh chiếc xe mới",
  },
  {
    word: "lâu lâu",
    part_of_speech: "phụ từ",
    meaning:
      "thỉnh thoảng, cứ cách một thời gian hơi lâu: công tác ở xa, lâu lâu mới được về thăm nhà",
    example: "công tác ở xa, lâu lâu mới được về thăm nhà",
  },
  {
    word: "lâu hoắc",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) lâu lắm, lâu quá: chờ lâu hoắc",
    example: "chờ lâu hoắc",
  },
  {
    word: "lâu lắc",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) lâu quá: bắt người ta chờ lâu lắc!",
    example: "bắt người ta chờ lâu lắc!",
  },
  {
    word: "lâu nay",
    part_of_speech: "danh từ",
    meaning:
      'khoảng thời gian từ khá lâu cho đến nay: đi đâu mà lâu nay không gặp? * "Được rày tái thế tương phùng, Khát khao đã thoả tấm lòng lâu nay!" (TKiều)',
    example:
      'đi đâu mà lâu nay không gặp? * "Được rày tái thế tương phùng, Khát khao đã thoả tấm lòng lâu nay!" (TKiều)',
  },
  {
    word: "lầu hồng",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) nơi ở của phụ nữ quyền quý thời phong kiến: "Thiếp danh đưa đến lầu hồng, Hai bên cùng liếc, hai lòng cùng ưa." (TKiều)',
    example:
      'Thiếp danh đưa đến lầu hồng, Hai bên cùng liếc, hai lòng cùng ưa." (TKiều)',
  },
  {
    word: "lầu xanh",
    part_of_speech: "danh từ",
    meaning:
      '(Từ cũ, Văn chương) nhà chứa gái điếm: gái lầu xanh * "Lầu xanh có mụ Tú bà, Làng chơi đã trở về già hết duyên." (TKiều)',
    example:
      'gái lầu xanh * "Lầu xanh có mụ Tú bà, Làng chơi đã trở về già hết duyên." (TKiều)',
  },
  {
    word: "lây",
    part_of_speech: "động từ",
    meaning:
      "(bệnh) truyền từ cơ thể này sang cơ thể khác: bệnh lây qua đường hô hấp * bị lây bệnh",
    example: "bệnh lây qua đường hô hấp * bị lây bệnh",
  },
  {
    word: "lây",
    part_of_speech: "động từ",
    meaning:
      'có chung tình trạng, trạng thái tâm lí tình cảm với người khác do có quan hệ gần gũi: bị vạ lây * "Chị dù thịt nát xương mòn, Ngậm cười chín suối, hãy còn thơm lây." (TKiều)',
    example:
      'bị vạ lây * "Chị dù thịt nát xương mòn, Ngậm cười chín suối, hãy còn thơm lây." (TKiều)',
  },
  {
    word: "lẫy",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận của nỏ hay bẫy dùng tạo sức bật để phóng tên hay để sập bẫy: lẫy nỏ * bật lẫy",
    example: "lẫy nỏ * bật lẫy",
  },
  {
    word: "lẫy",
    part_of_speech: "động từ",
    meaning:
      "(trẻ nhỏ) tự lật được người, chuyển từ nằm ngửa sang nằm sấp: bé đang tập lẫy",
    example: "bé đang tập lẫy",
  },
  {
    word: "lẫy",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) dỗi: nói lẫy * giận lẫy",
    example: "nói lẫy * giận lẫy",
  },
  {
    word: "lẫy",
    part_of_speech: "tính từ",
    meaning: "(răng mọc) lệch, nhô một phần ra khỏi hàng: chiếc răng mọc lẫy",
    example: "chiếc răng mọc lẫy",
  },
  {
    word: "lầy",
    part_of_speech: "danh từ",
    meaning:
      "đất bùn nhão thường xuyên ngập nước: vượt qua bãi lầy * xe bị mắc lầy",
    example: "vượt qua bãi lầy * xe bị mắc lầy",
  },
  {
    word: "lầy",
    part_of_speech: "tính từ",
    meaning: "có nhiều bùn trơn, bẩn: mưa nhiều, đường lầy và trơn",
    example: "mưa nhiều, đường lầy và trơn",
  },
  {
    word: "lẩy",
    part_of_speech: "động từ",
    meaning:
      "tách ra, lấy rời ra từng cái những vật dính liền thành cụm: lẩy từng hạt ngô * lẩy ra một viên đạn trong băng",
    example: "lẩy từng hạt ngô * lẩy ra một viên đạn trong băng",
  },
  {
    word: "lẩy",
    part_of_speech: "động từ",
    meaning:
      "gảy mạnh, kéo mạnh bằng ngón tay rồi buông ra ngay: tay lẩy phím đàn * lẩy cò súng",
    example: "tay lẩy phím đàn * lẩy cò súng",
  },
  {
    word: "lẩy",
    part_of_speech: "động từ",
    meaning:
      "chọn rút ra một vài câu, đoạn trong một tác phẩm thơ để phỏng theo mà diễn đạt ý: lẩy Kiều * lẩy một câu chèo cổ",
    example: "lẩy Kiều * lẩy một câu chèo cổ",
  },
  {
    word: "lầu trang",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) phòng riêng của phụ nữ quyền quý thời xưa ngồi trang điểm (thường ở trên lầu): "Vội vàng lá rụng, hoa rơi, Chàng về thư viện, nàng rời lầu trang." (TKiều)',
    example:
      'Vội vàng lá rụng, hoa rơi, Chàng về thư viện, nàng rời lầu trang." (TKiều)',
  },
  {
    word: "lẩy bẩy",
    part_of_speech: "động từ",
    meaning:
      "(chân tay) run rẩy một cách yếu đuối: sợ quá, chân tay run lẩy bẩy",
    example: "sợ quá, chân tay run lẩy bẩy",
  },
  {
    word: "lấy có",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) (làm việc gì) chỉ cốt tỏ ra là có làm, không kể đến kết quả ra sao: phê bình lấy có * làm lấy có, không cần kĩ",
    example: "phê bình lấy có * làm lấy có, không cần kĩ",
  },
  {
    word: "lấy",
    part_of_speech: "động từ",
    meaning:
      "đưa cái của mình hoặc cái đã sẵn có ở đâu đó để làm việc gì: lấy gạo thổi cơm * lấy chổi quét nhà * lấy áo mặc thêm kẻo lạnh",
    example: "lấy gạo thổi cơm * lấy chổi quét nhà * lấy áo mặc thêm kẻo lạnh",
  },
  {
    word: "lấy",
    part_of_speech: "động từ",
    meaning:
      "làm cho mình có được cái vốn có hoặc có thể có ở đâu đó để sử dụng: đi lấy tin viết bài * lấy thí dụ trong Truyện Kiều * lấy ý kiến",
    example: "đi lấy tin viết bài * lấy thí dụ trong Truyện Kiều * lấy ý kiến",
  },
  {
    word: "lấy",
    part_of_speech: "động từ",
    meaning:
      "làm cho trở thành của mình cái vốn là của người khác: lấy bút của bạn * lấy của công làm của riêng * lấy đồn địch",
    example: "lấy bút của bạn * lấy của công làm của riêng * lấy đồn địch",
  },
  {
    word: "lấy",
    part_of_speech: "động từ",
    meaning:
      "làm cho mình có được cái tạo ra bằng một hoạt động nào đó: ra sông lấy nước * nuôi gà lấy trứng * cho vay lấy lãi",
    example: "ra sông lấy nước * nuôi gà lấy trứng * cho vay lấy lãi",
  },
  {
    word: "lấy",
    part_of_speech: "động từ",
    meaning:
      "tự tạo ra ở mình: chạy lấy đà * nghỉ lấy sức * lấy giọng cất tiếng hát",
    example: "chạy lấy đà * nghỉ lấy sức * lấy giọng cất tiếng hát",
  },
  {
    word: "lấy",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đòi giá tiền bao nhiêu đó để bán: cái áo này chị lấy bao nhiêu? * anh mua đi, tôi lấy rẻ cho",
    example: "cái áo này chị lấy bao nhiêu? * anh mua đi, tôi lấy rẻ cho",
  },
  {
    word: "lấy",
    part_of_speech: "động từ",
    meaning:
      "dùng để làm cái gì hoặc làm việc gì đó: lấy công làm lãi * lấy mét làm đơn vị * lấy cớ ốm để nghỉ",
    example: "lấy công làm lãi * lấy mét làm đơn vị * lấy cớ ốm để nghỉ",
  },
  {
    word: "lấy",
    part_of_speech: "động từ",
    meaning:
      "làm cho có được sự chính xác, bằng đo, tính, chỉnh lí: lấy số đo * lấy lại giờ cho đồng hồ",
    example: "lấy số đo * lấy lại giờ cho đồng hồ",
  },
  {
    word: "lấy",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) kết hôn, thành vợ thành chồng: lấy chồng * hai người đã lấy nhau * lấy vợ cho con",
    example: "lấy chồng * hai người đã lấy nhau * lấy vợ cho con",
  },
  {
    word: "lấy",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị hướng của hành động nhằm mang lại kết quả cho chủ thể: bắt lấy quả bóng * chiếm lấy làm của riêng * nắm lấy thời cơ",
    example: "bắt lấy quả bóng * chiếm lấy làm của riêng * nắm lấy thời cơ",
  },
  {
    word: "lấy",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị cách thức hành động tự mình tạo ra, không nhờ vào người khác hoặc không phải do người khác làm sẵn: trẻ đã biết mặc lấy quần áo * tự lái xe lấy",
    example: "trẻ đã biết mặc lấy quần áo * tự lái xe lấy",
  },
  {
    word: "lấy",
    part_of_speech: "trợ từ",
    meaning:
      "từ dùng để nhấn mạnh mức tối thiểu, không yêu cầu hơn: làm lấy lệ * cố ăn lấy lưng bát cho lại sức * mong có lấy một vài ngày nghỉ",
    example:
      "làm lấy lệ * cố ăn lấy lưng bát cho lại sức * mong có lấy một vài ngày nghỉ",
  },
  {
    word: "lấy giọng",
    part_of_speech: "động từ",
    meaning:
      "cất giọng hoặc dạo thử tiếng đàn trước để chuẩn bị hát cho đúng giọng: đằng hắng mấy cái để lấy giọng * đàn lấy giọng",
    example: "đằng hắng mấy cái để lấy giọng * đàn lấy giọng",
  },
  {
    word: "lấy giọng",
    part_of_speech: "động từ",
    meaning:
      "tạo cho giọng nói có vẻ phù hợp với một thái độ cần có nào đó: lấy giọng ôn tồn để chỉ bảo * cố lấy giọng thật bình tĩnh",
    example: "lấy giọng ôn tồn để chỉ bảo * cố lấy giọng thật bình tĩnh",
  },
  {
    word: "lấy công làm lãi",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) không lời lãi là bao, chỉ cốt kiếm chút tiền công để duy trì cuộc sống (chỉ đủ bù công sức lao động đã bỏ ra): buôn bán lặt vặt, chỉ lấy công làm lãi",
    example: "buôn bán lặt vặt, chỉ lấy công làm lãi",
  },
  {
    word: "lấy làm",
    part_of_speech: "động từ",
    meaning:
      "tự cảm thấy như thế nào đó trước một sự việc gì: lấy làm ân hận * hơi lấy làm lạ",
    example: "lấy làm ân hận * hơi lấy làm lạ",
  },
  {
    word: "lây lan",
    part_of_speech: "động từ",
    meaning: "lây và lan rộng ra (nói khái quát): dịch bệnh lây lan khắp vùng",
    example: "dịch bệnh lây lan khắp vùng",
  },
  {
    word: "lấy được",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) (làm việc gì) chỉ cốt cho được, bất chấp thế nào: đòi lấy được * gân cổ lên cãi lấy được",
    example: "đòi lấy được * gân cổ lên cãi lấy được",
  },
  {
    word: "lấy lòng",
    part_of_speech: "động từ",
    meaning:
      "cốt để làm vừa lòng, để tranh thủ cảm tình: cười lấy lòng * nói nịnh một câu lấy lòng",
    example: "cười lấy lòng * nói nịnh một câu lấy lòng",
  },
  {
    word: "lẫy lừng",
    part_of_speech: "",
    meaning: "như lừng lẫy: chiến công lẫy lừng",
    example: "chiến công lẫy lừng",
  },
  {
    word: "lầy lội",
    part_of_speech: "tính từ",
    meaning: "(đường sá) có nhiều bùn lầy: đường sá lầy lội",
    example: "đường sá lầy lội",
  },
  {
    word: "lấy lệ",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) (làm việc gì) chỉ cốt cho phải phép, không có sự quan tâm: mời lấy lệ * ăn lấy lệ",
    example: "mời lấy lệ * ăn lấy lệ",
  },
  {
    word: "lấy nê",
    part_of_speech: "động từ",
    meaning:
      "vin vào một điều kiện khách quan nào đó, coi như là lí do chính đáng để làm điều đáng trách: lấy nê con nhỏ để vắng mặt",
    example: "lấy nê con nhỏ để vắng mặt",
  },
  {
    word: "lầy lụa",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như nhầy nhụa: đường trơn lầy lụa",
    example: "đường trơn lầy lụa",
  },
  {
    word: "lầy nhầy",
    part_of_speech: "tính từ",
    meaning:
      "dính lằng nhằng và bẩn nhớp nháp, gây cảm giác ghê, tởm: mũi dãi lầy nhầy",
    example: "mũi dãi lầy nhầy",
  },
  {
    word: "lây nhây",
    part_of_speech: "",
    meaning:
      "dai dẳng, kéo dài mãi không chịu dứt: mưa lây nhây hàng tháng trời * việc để lây nhây mãi không giải quyết",
    example:
      "mưa lây nhây hàng tháng trời * việc để lây nhây mãi không giải quyết",
  },
  {
    word: "lây rây",
    part_of_speech: "tính từ",
    meaning: "(mưa) nhỏ hạt như rắc bụi: trời vẫn mưa lây rây",
    example: "trời vẫn mưa lây rây",
  },
  {
    word: "lấy rồi",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) (làm việc gì) chỉ cốt cho xong, cho gọi là đã làm, không kể kết quả thế nào: làm lấy rồi",
    example: "làm lấy rồi",
  },
  {
    word: "lây nhiễm",
    part_of_speech: "động từ",
    meaning:
      "nhiễm bệnh do bị lây từ người khác: bị lây nhiễm HIV * lây nhiễm các thói hư tật xấu (b)",
    example: "bị lây nhiễm HIV * lây nhiễm các thói hư tật xấu (b)",
  },
  {
    word: "lây truyền",
    part_of_speech: "động từ",
    meaning:
      "(bệnh) lây từ người này sang người khác: bệnh lao chủ yếu lây truyền qua đường hô hấp",
    example: "bệnh lao chủ yếu lây truyền qua đường hô hấp",
  },
  {
    word: "le",
    part_of_speech: "danh từ",
    meaning:
      "cây thuộc họ lúa, mọc ở rừng, thân nhỏ và cứng, có hình dạng giống cây trúc: măng le * bụi le",
    example: "măng le * bụi le",
  },
  {
    word: "le",
    part_of_speech: "động từ",
    meaning: "(Phương ngữ) như lè: le lưỡi",
    example: "le lưỡi",
  },
  {
    word: "le",
    part_of_speech: "phụ từ",
    meaning:
      '(Ít dùng) như lè: xanh le * "Trèo lên cây khế chua le, Vợ thì muốn lấy, chồng e mất tiền." (Cdao)',
    example:
      'xanh le * "Trèo lên cây khế chua le, Vợ thì muốn lấy, chồng e mất tiền." (Cdao)',
  },
  {
    word: "lẽ",
    part_of_speech: "danh từ",
    meaning:
      "điều thường thấy ở đời, được coi là hợp với quy luật, với đạo lí: điều đó trái với lẽ thường * sống sao cho phải lẽ",
    example: "điều đó trái với lẽ thường * sống sao cho phải lẽ",
  },
  {
    word: "lẽ",
    part_of_speech: "danh từ",
    meaning:
      "điều được coi là lí do giải thích, là nguyên nhân của sự việc: chậm vì nhiều lẽ * làm cho ra lẽ * nói đã cạn lẽ",
    example: "chậm vì nhiều lẽ * làm cho ra lẽ * nói đã cạn lẽ",
  },
  {
    word: "lẽ",
    part_of_speech: "danh từ",
    meaning: "vợ lẽ (nói tắt): làm lẽ * chết trẻ còn hơn lấy lẽ (tng)",
    example: "làm lẽ * chết trẻ còn hơn lấy lẽ (tng)",
  },
  {
    word: "lè",
    part_of_speech: "động từ",
    meaning: "đưa lưỡi ra ngoài miệng: lè lưỡi liếm * đắt lè lưỡi (quá đắt)",
    example: "lè lưỡi liếm * đắt lè lưỡi (quá đắt)",
  },
  {
    word: "lè",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) nhè: nuốt không được phải lè ra",
    example: "nuốt không được phải lè ra",
  },
  {
    word: "lè",
    part_of_speech: "phụ từ",
    meaning:
      "đến mức độ quá lắm, tác động gay gắt đến các giác quan: sai lè ra còn cãi * xanh lè",
    example: "sai lè ra còn cãi * xanh lè",
  },
  {
    word: "lẻ",
    part_of_speech: "danh từ",
    meaning: "lượng bằng một phần mười của đấu: một đấu hai lẻ gạo",
    example: "một đấu hai lẻ gạo",
  },
  {
    word: "lẻ",
    part_of_speech: "danh từ",
    meaning: "lượng nhỏ, trong quan hệ với chỉnh thể, toàn thể: vài lẻ củi",
    example: "vài lẻ củi",
  },
  {
    word: "lẻ",
    part_of_speech: "tính từ",
    meaning:
      "(số nguyên) không chia hết cho 2; phân biệt với chẵn: 1, 3, 5 là những số lẻ * kiêng đi ngày lẻ",
    example: "1, 3, 5 là những số lẻ * kiêng đi ngày lẻ",
  },
  {
    word: "lẻ",
    part_of_speech: "tính từ",
    meaning: "(phép chia) không chia hết, còn dư: phép chia lẻ",
    example: "phép chia lẻ",
  },
  {
    word: "lẻ",
    part_of_speech: "tính từ",
    meaning:
      "có số dư ngoài số tròn (từ hàng chục trở lên): một trăm lẻ ba * một nghìn lẻ một câu chuyện",
    example: "một trăm lẻ ba * một nghìn lẻ một câu chuyện",
  },
  {
    word: "lẻ",
    part_of_speech: "tính từ",
    meaning:
      "có phần dư ngoài đơn vị được nói đến: từ đó đến nay đã hai mươi năm có lẻ",
    example: "từ đó đến nay đã hai mươi năm có lẻ",
  },
  {
    word: "lẻ",
    part_of_speech: "tính từ",
    meaning:
      "riêng ra một mình, tách rời ra một mình: đi lẻ từng người một * xóm lẻ * chim lẻ bầy",
    example: "đi lẻ từng người một * xóm lẻ * chim lẻ bầy",
  },
  {
    word: "lẻ",
    part_of_speech: "tính từ",
    meaning:
      "riêng từng cái, từng số lượng nhỏ: mua lẻ từng cái một * có tài lẻ * chỉ còn mấy đồng lẻ",
    example: "mua lẻ từng cái một * có tài lẻ * chỉ còn mấy đồng lẻ",
  },
  {
    word: "lẹ",
    part_of_speech: "tính từ",
    meaning:
      "(Phương ngữ) nhanh: lấy xe đi cho lẹ * hắn di chuyển đến lẹ * nói lẹ lẹ lên!",
    example: "lấy xe đi cho lẹ * hắn di chuyển đến lẹ * nói lẹ lẹ lên!",
  },
  {
    word: "lé",
    part_of_speech: "tính từ",
    meaning:
      "(mắt nhìn) chếch về một phía, mi hơi khép lại (thường có vẻ sợ hãi hay gian xảo): lé một mắt nhìn * lé mắt nhìn ra ngoài sân",
    example: "lé một mắt nhìn * lé mắt nhìn ra ngoài sân",
  },
  {
    word: "lé",
    part_of_speech: "tính từ",
    meaning: "(Phương ngữ) lác: bị lé mắt",
    example: "bị lé mắt",
  },
  {
    word: "lè lẹ",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) lẹ hơn một chút (thường hàm ý thúc giục): đi lè lẹ lên!",
    example: "đi lè lẹ lên!",
  },
  {
    word: "lẹ làng",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) nhanh nhẹn và nhẹ nhàng: di chuyển lẹ làng",
    example: "di chuyển lẹ làng",
  },
  {
    word: "le lé",
    part_of_speech: "tính từ",
    meaning: "(mắt) hơi lé: mắt hơi le lé",
    example: "mắt hơi le lé",
  },
  {
    word: "le lói",
    part_of_speech: "động từ",
    meaning:
      "phát ra ánh sáng rất yếu ớt: có ánh đèn le lói phía đằng xa * còn le lói chút hi vọng (b)",
    example: "có ánh đèn le lói phía đằng xa * còn le lói chút hi vọng (b)",
  },
  {
    word: "lẽ mọn",
    part_of_speech: "danh từ",
    meaning: "vợ lẽ, chịu phận hèn (nói khái quát): phận lẽ mọn",
    example: "phận lẽ mọn",
  },
  {
    word: "lẻ loi",
    part_of_speech: "tính từ",
    meaning:
      "chỉ có một mình, tách khỏi quan hệ với đồng loại: một ngôi sao lẻ loi trên bầu trời",
    example: "một ngôi sao lẻ loi trên bầu trời",
  },
  {
    word: "lẻ loi",
    part_of_speech: "tính từ",
    meaning:
      'cô đơn, không có ai bên cạnh: sống lẻ loi * "Chim bay nó cũng có đôi, Uổng thân con gái lẻ loi một mình." (ca dao)',
    example:
      'sống lẻ loi * "Chim bay nó cũng có đôi, Uổng thân con gái lẻ loi một mình." (ca dao)',
  },
  {
    word: "lè nhè",
    part_of_speech: "",
    meaning:
      "nói giọng trầm và kéo dài, nghe không rõ tiếng, gây cảm giác khó chịu (thường là khi say rượu): say rượu, giọng nói lè nhè",
    example: "say rượu, giọng nói lè nhè",
  },
  {
    word: "lẽ nào",
    part_of_speech: "",
    meaning:
      "tổ hợp dùng để biểu thị ý phủ định có phần dè dặt về điều cho là vô lí: lẽ nào lại có chuyện ấy? * không lẽ nào tôi lại hợp tác với hắn",
    example: "lẽ nào lại có chuyện ấy? * không lẽ nào tôi lại hợp tác với hắn",
  },
  {
    word: "lẽ phải",
    part_of_speech: "danh từ",
    meaning:
      "điều được coi là phải, là hợp đạo lí: nhận ra lẽ phải * làm theo lẽ phải",
    example: "nhận ra lẽ phải * làm theo lẽ phải",
  },
  {
    word: "le te",
    part_of_speech: "tính từ",
    meaning: "rất thấp và bé nhỏ: trúc mọc le te * lều quán le te",
    example: "trúc mọc le te * lều quán le te",
  },
  {
    word: "le te",
    part_of_speech: "tính từ",
    meaning:
      "mau mắn, nhanh nhảu: le te mách mẹ * nói chưa dứt câu lại le te chạy đi chỗ khác",
    example: "le te mách mẹ * nói chưa dứt câu lại le te chạy đi chỗ khác",
  },
  {
    word: "le te",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng gà gáy nghe cao, trong và ngắn: tiếng gà gáy le te",
    example: "tiếng gà gáy le te",
  },
  {
    word: "lẽ ra",
    part_of_speech: "",
    meaning:
      "tổ hợp biểu thị ý cho rằng đúng lí ra thì phải thế này, chứ không phải như là đã xảy ra trong thực tế: việc này lẽ ra phải xong từ hôm qua rồi",
    example: "việc này lẽ ra phải xong từ hôm qua rồi",
  },
  {
    word: "lẻm",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) ăn rất nhanh và gọn một cách ngon lành: lẻm gọn cái bánh",
    example: "lẻm gọn cái bánh",
  },
  {
    word: "lem",
    part_of_speech: "tính từ",
    meaning: "có vết bẩn ở mặt ngoài: bôi lem cả mặt * tường lem than bụi",
    example: "bôi lem cả mặt * tường lem than bụi",
  },
  {
    word: "lẹm",
    part_of_speech: "tính từ",
    meaning:
      "có chỗ bị lõm, bị khuyết vào, không đầy đặn như bình thường: cằm hơi lẹm * miếng ván bị lẹm một góc",
    example: "cằm hơi lẹm * miếng ván bị lẹm một góc",
  },
  {
    word: "lẻ tẻ",
    part_of_speech: "tính từ",
    meaning:
      "thưa thớt và rời rạc từng ít một, không tập trung, không đều khắp: mọi người lẻ tẻ ra về * lúa chín lẻ tẻ",
    example: "mọi người lẻ tẻ ra về * lúa chín lẻ tẻ",
  },
  {
    word: "lém",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) (lửa) cháy không to ngọn nhưng lan ra nhanh: lá cờ bị cháy lém một góc",
    example: "lá cờ bị cháy lém một góc",
  },
  {
    word: "lém",
    part_of_speech: "tính từ",
    meaning:
      "(nói) nhiều, nhanh, và tỏ ra tinh khôn (thường hàm ý chê nhẹ nhàng): thằng bé rất lém * lém như cuội * chỉ được cái lém!",
    example: "thằng bé rất lém * lém như cuội * chỉ được cái lém!",
  },
  {
    word: "lè tè",
    part_of_speech: "tính từ",
    meaning:
      "thấp đến mức gần như sát đất: người lè tè như cái nấm * mô đất thấp lè tè",
    example: "người lè tè như cái nấm * mô đất thấp lè tè",
  },
  {
    word: "lem lém",
    part_of_speech: "động từ",
    meaning:
      "(lửa) cháy mạnh và lan toả ra rất nhanh: mái gianh bén lửa, cháy lem lém",
    example: "mái gianh bén lửa, cháy lem lém",
  },
  {
    word: "lem lém",
    part_of_speech: "tính từ",
    meaning:
      "(nói) nhiều lời và nhanh, miệng liến thoắng (thường hàm ý chê): cứ lem lém cái mồm!",
    example: "cứ lem lém cái mồm!",
  },
  {
    word: "lém lỉnh",
    part_of_speech: "tính từ",
    meaning: "lém (nói khái quát): ăn nói lém lỉnh * cái miệng lém lỉnh",
    example: "ăn nói lém lỉnh * cái miệng lém lỉnh",
  },
  {
    word: "lem lẻm",
    part_of_speech: "tính từ",
    meaning:
      "(nói, cãi) liến thoắng và không kể gì đến đúng sai, đến phản ứng của những người xung quanh: cãi lem lẻm * cứ lem lẻm cái mồm!",
    example: "cãi lem lẻm * cứ lem lẻm cái mồm!",
  },
  {
    word: "lèm bèm",
    part_of_speech: "",
    meaning:
      "(Khẩu ngữ) (nói năng) không đàng hoàng, chững chạc, hay chú trọng đến những điều nhỏ nhen, vụn vặt: tính hay lèm bèm * hơi một tí lại lèm bèm * nói lèm bèm cả ngày",
    example: "tính hay lèm bèm * hơi một tí lại lèm bèm * nói lèm bèm cả ngày",
  },
  {
    word: "lem nhem",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều vết bẩn nham nhở ở nhiều chỗ: tẩy xoá lem nhem * mặt mũi lem nhem * quần áo lem nhem bùn đất",
    example: "tẩy xoá lem nhem * mặt mũi lem nhem * quần áo lem nhem bùn đất",
  },
  {
    word: "lem nhem",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) không được cẩn thận, chu đáo, có tính chất cẩu thả, thiếu nền nếp: ăn mặc lem nhem * làm ăn lem nhem",
    example: "ăn mặc lem nhem * làm ăn lem nhem",
  },
  {
    word: "lèm nhèm",
    part_of_speech: "tính từ",
    meaning: "như kèm nhèm: mắt mũi lèm nhèm",
    example: "mắt mũi lèm nhèm",
  },
  {
    word: "lèm nhèm",
    part_of_speech: "tính từ",
    meaning:
      "(chữ viết) không được sạch sẽ, rõ ràng: chữ viết lèm nhèm * bài viết gạch xoá lèm nhèm",
    example: "chữ viết lèm nhèm * bài viết gạch xoá lèm nhèm",
  },
  {
    word: "lèm nhèm",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) không được minh bạch: không thèm làm những chuyện lèm nhèm",
    example: "không thèm làm những chuyện lèm nhèm",
  },
  {
    word: "lèm nhèm",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) kém, tồi, không ra gì: làm ăn lèm nhèm * suốt đời làm gã công chức lèm nhèm",
    example: "làm ăn lèm nhèm * suốt đời làm gã công chức lèm nhèm",
  },
  {
    word: "lem luốc",
    part_of_speech: "tính từ",
    meaning: "như nhem nhuốc: mặt mũi lem luốc",
    example: "mặt mũi lem luốc",
  },
  {
    word: "len",
    part_of_speech: "danh từ",
    meaning:
      "sợi chế ra từ lông một số động vật, thường từ lông cừu, dùng để đan, dệt đồ giữ ấm: đan áo len * khăn len * chăn len",
    example: "đan áo len * khăn len * chăn len",
  },
  {
    word: "len",
    part_of_speech: "động từ",
    meaning:
      "chen, lách mình vào: len qua đám đông * chật không có chỗ len chân",
    example: "len qua đám đông * chật không có chỗ len chân",
  },
  {
    word: "len dạ",
    part_of_speech: "danh từ",
    meaning: "len và dạ (nói khái quát): hàng len dạ",
    example: "hàng len dạ",
  },
  {
    word: "lén",
    part_of_speech: "phụ từ",
    meaning:
      "(làm việc gì) một cách bí mật sao cho những người khác không thấy, không biết (thường hàm ý chê): đánh lén * nhìn lén * nghe lén chuyện của người khác",
    example: "đánh lén * nhìn lén * nghe lén chuyện của người khác",
  },
  {
    word: "lén",
    part_of_speech: "động từ",
    meaning:
      '(cũ) như lẻn: "Nàng đương dở việc nào hay, Cửa ngoài đã hé cánh mây lén vào." (BC)',
    example:
      'Nàng đương dở việc nào hay, Cửa ngoài đã hé cánh mây lén vào." (BC)',
  },
  {
    word: "lẻn",
    part_of_speech: "động từ",
    meaning:
      'bỏ đi một cách kín đáo không để người khác biết: "Thừa cơ lẻn bước ra đi, Ba mươi sáu chước, chước gì là hơn?" (TKiều)',
    example:
      'Thừa cơ lẻn bước ra đi, Ba mươi sáu chước, chước gì là hơn?" (TKiều)',
  },
  {
    word: "lèn",
    part_of_speech: "danh từ",
    meaning: "núi đá có vách cao dựng đứng: lèn đá",
    example: "lèn đá",
  },
  {
    word: "lèn",
    part_of_speech: "động từ",
    meaning:
      "cố nhét thêm vào mặc dù đã chặt, đã chật: một bát cơm lèn chặt * chật không lèn vào đâu được",
    example: "một bát cơm lèn chặt * chật không lèn vào đâu được",
  },
  {
    word: "len gai",
    part_of_speech: "danh từ",
    meaning: "len có sợi thô và cứng: áo đan bằng sợi len gai",
    example: "áo đan bằng sợi len gai",
  },
  {
    word: "len lỏi",
    part_of_speech: "động từ",
    meaning:
      "len, lách một cách vất vả (nói khái quát): len lỏi qua đám đông * đi len lỏi trong rừng",
    example: "len lỏi qua đám đông * đi len lỏi trong rừng",
  },
  {
    word: "len lén",
    part_of_speech: "phụ từ",
    meaning:
      "(làm việc gì) một cách nhẹ nhàng, kín đáo vì không muốn để người khác biết: len lén theo sau * mắt nhìn len lén",
    example: "len lén theo sau * mắt nhìn len lén",
  },
  {
    word: "lén lút",
    part_of_speech: "tính từ",
    meaning:
      "vụng trộm, giấu giếm, không để lộ ra: buôn bán lén lút * quan hệ lén lút với người đã có gia đình",
    example: "buôn bán lén lút * quan hệ lén lút với người đã có gia đình",
  },
  {
    word: "len lách",
    part_of_speech: "động từ",
    meaning:
      "chen lách qua chỗ này sang chỗ nọ để cố tìm lối vượt lên: len lách qua những khe đá",
    example: "len lách qua những khe đá",
  },
  {
    word: "len lét",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả bộ dạng khép nép, sợ sệt, né tránh, không dám nhìn thẳng: mắt len lét sợ hãi * đứng len lét đằng sau người khác",
    example: "mắt len lét sợ hãi * đứng len lét đằng sau người khác",
  },
  {
    word: "lẻn lút",
    part_of_speech: "động từ",
    meaning: "lẩn trốn không để cho ai thấy: sống lẻn lút trong rừng",
    example: "sống lẻn lút trong rừng",
  },
  {
    word: "lẻo",
    part_of_speech: "động từ",
    meaning: "(Phương ngữ) xẻo: lẻo một miếng thịt",
    example: "lẻo một miếng thịt",
  },
  {
    word: "lẻo",
    part_of_speech: "tính từ",
    meaning:
      "nhanh miệng, liến thoắng, tỏ ra không thật, không sâu sắc: lẻo mép * lẻo mồm",
    example: "lẻo mép * lẻo mồm",
  },
  {
    word: "léng phéng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có quan hệ không nghiêm túc, không đứng đắn (thường trong quan hệ nam nữ): hai người léng phéng với nhau",
    example: "hai người léng phéng với nhau",
  },
  {
    word: "lèo",
    part_of_speech: "danh từ",
    meaning:
      "dây buộc từ cánh buồm đến chỗ lái để điều khiển buồm hứng gió: gió lên, buồm căng hết lèo * thả lèo * dây lèo",
    example: "gió lên, buồm căng hết lèo * thả lèo * dây lèo",
  },
  {
    word: "lèo",
    part_of_speech: "danh từ",
    meaning:
      "dây buộc ở giữa cái diều để cho cân hai cánh: diều bị lệch lèo, không lên được",
    example: "diều bị lệch lèo, không lên được",
  },
  {
    word: "lèo",
    part_of_speech: "danh từ",
    meaning:
      'diềm gỗ ở tủ, sập, giường, v.v. có chạm trổ để trang trí: lèo tủ * "Giường lèo mà trải chiếu mây, Làm trai hai vợ như dây buộc mình." (Cdao)',
    example:
      'lèo tủ * "Giường lèo mà trải chiếu mây, Làm trai hai vợ như dây buộc mình." (Cdao)',
  },
  {
    word: "lèo",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) móc nối thêm vào như liền một mạch: viết xong còn lèo thêm một đoạn * hát bài nọ lèo sang bài kia",
    example: "viết xong còn lèo thêm một đoạn * hát bài nọ lèo sang bài kia",
  },
  {
    word: "leng reng",
    part_of_speech: "tính từ",
    meaning: "như leng keng: chuông kêu leng reng",
    example: "chuông kêu leng reng",
  },
  {
    word: "lẻng xẻng",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng những vật nhỏ, mỏng bằng kim loại va chạm vào nhau: mấy đồng xu va vào nhau kêu lẻng xẻng",
    example: "mấy đồng xu va vào nhau kêu lẻng xẻng",
  },
  {
    word: "leng keng",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng đồ vật bằng kim khí chạm vào nhau hay chạm vào vật cứng khác liên tiếp: tiếng kẻng leng keng * chuông tàu điện leng keng",
    example: "tiếng kẻng leng keng * chuông tàu điện leng keng",
  },
  {
    word: "léo",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ, Ít dùng) ngồi lên, leo lên chỗ không phải dành cho mình: léo lên ghế đại biểu",
    example: "léo lên ghế đại biểu",
  },
  {
    word: "leo",
    part_of_speech: "động từ",
    meaning:
      'di chuyển toàn thân lên cao bằng cách bám vào vật khác và bằng cử động của chân tay: leo cây * leo cột mỡ * "Con kiến mày leo cành đa, Leo phải cành cộc leo ra leo vào." (Cdao)',
    example:
      'leo cây * leo cột mỡ * "Con kiến mày leo cành đa, Leo phải cành cộc leo ra leo vào." (Cdao)',
  },
  {
    word: "leo",
    part_of_speech: "động từ",
    meaning:
      "đi lên vị trí cao hơn: leo núi * leo cầu thang * chân bẩn lại leo lên giường * leo đến chức giám đốc (b)",
    example:
      "leo núi * leo cầu thang * chân bẩn lại leo lên giường * leo đến chức giám đốc (b)",
  },
  {
    word: "leo",
    part_of_speech: "động từ",
    meaning:
      "(một số loại cây) bám vào vật khác mà bò lên: bắc giàn cho trầu leo * giậu đổ bìm leo (tng)",
    example: "bắc giàn cho trầu leo * giậu đổ bìm leo (tng)",
  },
  {
    word: "lẹo",
    part_of_speech: "danh từ",
    meaning: "(Nam) chắp: mắt mọc lẹo",
    example: "mắt mọc lẹo",
  },
  {
    word: "lẹo",
    part_of_speech: "tính từ",
    meaning:
      "(Phương ngữ) (quả cây) bị dính liền với nhau từ khi sinh ra: chuối lẹo",
    example: "chuối lẹo",
  },
  {
    word: "lẹo",
    part_of_speech: "tính từ",
    meaning:
      "đành phải chịu nhường, chịu thua vì ở vào thế yếu hơn: yếu nhưng không chịu nước lép * chịu lép một bề",
    example: "yếu nhưng không chịu nước lép * chịu lép một bề",
  },
  {
    word: "leo khoeo",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như lẻo khoẻo: người gầy leo kheo",
    example: "người gầy leo kheo",
  },
  {
    word: "lẽo đẽo",
    part_of_speech: "phụ từ",
    meaning:
      "cứ bám lấy theo sau một cách chậm chạp, từng bước không rời: đứa bé lẽo đẽo theo mẹ * đạp xe lẽo đẽo theo sau",
    example: "đứa bé lẽo đẽo theo mẹ * đạp xe lẽo đẽo theo sau",
  },
  {
    word: "lẽo",
    part_of_speech: "tính từ",
    meaning:
      "không thẳng, khi chẻ hay cắt: củi lẽo thớ khó chẻ * miếng vải bị cắt lẽo",
    example: "củi lẽo thớ khó chẻ * miếng vải bị cắt lẽo",
  },
  {
    word: "léo hánh",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) bén mảng: không dám léo hánh tới gần",
    example: "không dám léo hánh tới gần",
  },
  {
    word: "lèo khoèo",
    part_of_speech: "tính từ",
    meaning: "(hiếm) nhỏ và gầy, trông yếu ớt: tay chân lèo khoèo",
    example: "tay chân lèo khoèo",
  },
  {
    word: "leo kheo",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như lẻo khoẻo: người gầy leo kheo",
    example: "người gầy leo kheo",
  },
  {
    word: "lèo lá",
    part_of_speech: "tính từ",
    meaning: "quá khôn khéo đến mức tráo trở, lật lọng: con người lèo lá",
    example: "con người lèo lá",
  },
  {
    word: "leo heo",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như lèo tèo: phố xá leo heo mấy nóc nhà",
    example: "phố xá leo heo mấy nóc nhà",
  },
  {
    word: "lẻo khoẻo",
    part_of_speech: "tính từ",
    meaning: "gầy gò, trông ốm yếu: thân hình lẻo khoẻo",
    example: "thân hình lẻo khoẻo",
  },
  {
    word: "lèo lái",
    part_of_speech: "danh từ",
    meaning:
      "dây lèo và tay lái; dùng để chỉ các bộ phận chính để điều khiển con thuyền (nói khái quát): sửa sang lèo lái",
    example: "sửa sang lèo lái",
  },
  {
    word: "lèo lái",
    part_of_speech: "động từ",
    meaning:
      "điều khiển con thuyền một cách khéo léo (nói khái quát): lèo lái con thuyền",
    example: "lèo lái con thuyền",
  },
  {
    word: "lèo lái",
    part_of_speech: "động từ",
    meaning:
      "điều khiển khéo léo để vượt qua các khó khăn: lèo lái đất nước vượt qua cơn khủng hoảng kinh tế",
    example: "lèo lái đất nước vượt qua cơn khủng hoảng kinh tế",
  },
  {
    word: "leo lẻo",
    part_of_speech: "tính từ",
    meaning:
      "(nói) nhiều và nhanh một cách liến thoắng với vẻ trơn tru nhưng không thật: chối leo lẻo * cứ leo lẻo cái mồm!",
    example: "chối leo lẻo * cứ leo lẻo cái mồm!",
  },
  {
    word: "leo lẻo",
    part_of_speech: "phụ từ",
    meaning:
      "(trong) đến mức nhìn suốt qua được, không hề gợn vẩn: nước xanh leo lẻo",
    example: "nước xanh leo lẻo",
  },
  {
    word: "leo lét",
    part_of_speech: "tính từ",
    meaning:
      "(ngọn lửa, tia sáng) nhỏ, chập chờn, yếu ớt như sắp tắt: ngọn đèn dầu leo lét",
    example: "ngọn đèn dầu leo lét",
  },
  {
    word: "leo lắt",
    part_of_speech: "tính từ",
    meaning: "như leo lét (nhưng ít dùng hơn): ngọn nến cháy leo lắt",
    example: "ngọn nến cháy leo lắt",
  },
  {
    word: "léo nhéo",
    part_of_speech: "động từ",
    meaning:
      "từ gợi tả tiếng gọi nhau hỗn độn liên tiếp từ xa, nghe to nhưng không rõ, gây cảm giác khó chịu: bọn trẻ léo nhéo gọi nhau",
    example: "bọn trẻ léo nhéo gọi nhau",
  },
  {
    word: "leo trèo",
    part_of_speech: "động từ",
    meaning: "leo và trèo (nói khái quát): trẻ thích leo trèo",
    example: "trẻ thích leo trèo",
  },
  {
    word: "lèo nhèo",
    part_of_speech: "tính từ",
    meaning: "mềm nhão, dính vào nhau thành một mớ: thịt bụng lèo nhèo",
    example: "thịt bụng lèo nhèo",
  },
  {
    word: "lèo nhèo",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nói dai dẳng để van nài, đến mức khó chịu: lèo nhèo đòi cho bằng được * nói lèo nhèo mãi",
    example: "lèo nhèo đòi cho bằng được * nói lèo nhèo mãi",
  },
  {
    word: "lèo tèo",
    part_of_speech: "tính từ",
    meaning:
      "ít ỏi, thưa thớt, gây cảm giác buồn tẻ, nghèo nàn: cả xóm có lèo tèo mấy nóc nhà * chợ chỉ còn lèo tèo vài ba người",
    example: "cả xóm có lèo tèo mấy nóc nhà * chợ chỉ còn lèo tèo vài ba người",
  },
  {
    word: "leo thang",
    part_of_speech: "động từ",
    meaning:
      "nâng mức độ lên từng bước một, bước sau cao hơn bước trước: giá cả ngày một leo thang * chiến tranh leo thang",
    example: "giá cả ngày một leo thang * chiến tranh leo thang",
  },
  {
    word: "lép",
    part_of_speech: "tính từ",
    meaning:
      "(hạt) nhỏ và không căng do phát triển không đầy đủ: thóc lép * hạt lạc lép",
    example: "thóc lép * hạt lạc lép",
  },
  {
    word: "lép",
    part_of_speech: "tính từ",
    meaning:
      "bị dẹp hoặc xẹp xuống, không căng phồng, vì không có gì bên trong: bụng đói lép * ngực lép * túi lép",
    example: "bụng đói lép * ngực lép * túi lép",
  },
  {
    word: "lép",
    part_of_speech: "tính từ",
    meaning:
      "(pháo, đạn) hỏng, không nổ được: pháo lép, không nổ được * lựu đạn lép * bom lép",
    example: "pháo lép, không nổ được * lựu đạn lép * bom lép",
  },
  {
    word: "léo xéo",
    part_of_speech: "động từ",
    meaning:
      "từ gợi tả tiếng nói, tiếng gọi nghe thấy được từ xa: có tiếng léo xéo ngoài đường",
    example: "có tiếng léo xéo ngoài đường",
  },
  {
    word: "lẹp kẹp",
    part_of_speech: "tính từ",
    meaning: "từ gợi tả tiếng guốc dép đi trên nền gạch: tiếng lê dép lẹp kẹp",
    example: "tiếng lê dép lẹp kẹp",
  },
  {
    word: "lề",
    part_of_speech: "danh từ",
    meaning:
      "dây xe bằng giấy bản để đóng vở viết chữ nho ngày trước: xe lề * giấy rách phải giữ lấy lề (tng)",
    example: "xe lề * giấy rách phải giữ lấy lề (tng)",
  },
  {
    word: "lề",
    part_of_speech: "danh từ",
    meaning:
      "khoảng giấy trắng được chừa ra ở bên trái hoặc bên phải trang giấy viết hoặc in: lề sách * viết phải chừa lề * viết nhận xét ở ngoài lề",
    example: "lề sách * viết phải chừa lề * viết nhận xét ở ngoài lề",
  },
  {
    word: "lề",
    part_of_speech: "danh từ",
    meaning: "lề đường (nói tắt): đi trên lề * sách bày bán trên lề phố",
    example: "đi trên lề * sách bày bán trên lề phố",
  },
  {
    word: "lề",
    part_of_speech: "danh từ",
    meaning:
      "phần bên ngoài, trong quan hệ đối lập với cái chính, cái bên trong: những chuyện bên lề sân cỏ * gạt ra ngoài lề",
    example: "những chuyện bên lề sân cỏ * gạt ra ngoài lề",
  },
  {
    word: "lề",
    part_of_speech: "danh từ",
    meaning:
      "(Từ cũ, Ít dùng) thói quen đã thành nếp, thành lệ: đất có lề, quê có thói (tng)",
    example: "đất có lề, quê có thói (tng)",
  },
  {
    word: "lép kẹp",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) lép đến mức thấy như hoàn toàn không có gì ở trong: chiếc ba lô lép kẹp * bụng lép kẹp",
    example: "chiếc ba lô lép kẹp * bụng lép kẹp",
  },
  {
    word: "lép nhép",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng những tiếng nhỏ, không đều nhau, như tiếng chất dính và ướt liên tiếp bám vào rồi nhả ra khỏi vật cứng: mồm nhai lép nhép * tiếng bùn lép nhép ở dưới chân",
    example: "mồm nhai lép nhép * tiếng bùn lép nhép ở dưới chân",
  },
  {
    word: "lễ",
    part_of_speech: "danh từ",
    meaning:
      "những nghi thức tiến hành nhằm đánh dấu hoặc kỉ niệm một sự việc, sự kiện có ý nghĩa nào đó (nói tổng quát): lễ ăn hỏi * lễ giáng sinh * cử hành lễ cưới * làm lễ chào cờ",
    example: "lễ ăn hỏi * lễ giáng sinh * cử hành lễ cưới * làm lễ chào cờ",
  },
  {
    word: "lễ",
    part_of_speech: "danh từ",
    meaning:
      "những thứ đem biếu tặng hay dùng để cúng, dâng (nói tổng quát): sắm lễ hỏi vợ cho con * lễ bạc lòng thành",
    example: "sắm lễ hỏi vợ cho con * lễ bạc lòng thành",
  },
  {
    word: "lễ",
    part_of_speech: "danh từ",
    meaning:
      "những phép tắc thuộc đạo lí phải theo cho đúng khi đối xử, tiếp xúc với người khác, thường là với người trên (nói tổng quát): giữ lễ với thầy cô * tiên học lễ, hậu học văn (tng)",
    example: "giữ lễ với thầy cô * tiên học lễ, hậu học văn (tng)",
  },
  {
    word: "lễ",
    part_of_speech: "động từ",
    meaning:
      "hoặc d vái, lạy để tỏ lòng cung kính, theo phong tục cũ: lễ ba lễ * vào chùa lễ Phật",
    example: "lễ ba lễ * vào chùa lễ Phật",
  },
  {
    word: "lễ",
    part_of_speech: "động từ",
    meaning:
      "tham dự các nghi thức tôn giáo để tỏ lòng cung kính với Chúa, Phật: đi lễ chùa * đi lễ nhà thờ",
    example: "đi lễ chùa * đi lễ nhà thờ",
  },
  {
    word: "lẹt đẹt",
    part_of_speech: "tính từ",
    meaning:
      "quá chậm chạp, kém cỏi, không theo kịp người khác: làm ăn lẹt đẹt",
    example: "làm ăn lẹt đẹt",
  },
  {
    word: "lẹt đẹt",
    part_of_speech: "tính từ",
    meaning: "từ mô phỏng những tiếng nổ nhỏ, rời rạc: pháo nổ lẹt đẹt",
    example: "pháo nổ lẹt đẹt",
  },
  {
    word: "lép xẹp",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như lép kẹp: chiếc túi lép xẹp * bụng đói lép xẹp",
    example: "chiếc túi lép xẹp * bụng đói lép xẹp",
  },
  {
    word: "lép vế",
    part_of_speech: "tính từ",
    meaning:
      "chịu lép, chịu bị lấn át, chèn ép vì ở vào thế yếu: yếu thế nên đành chịu lép vế",
    example: "yếu thế nên đành chịu lép vế",
  },
  {
    word: "lép bép",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng những tiếng nổ nhỏ liên tiếp không đều nhau: củi nổ lép bép",
    example: "củi nổ lép bép",
  },
  {
    word: "lép bép",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) nói luôn miệng: mồm miệng lép bép suốt ngày",
    example: "mồm miệng lép bép suốt ngày",
  },
  {
    word: "lệ",
    part_of_speech: "danh từ",
    meaning:
      '(Văn chương) nước mắt: giọt lệ * mắt ứa lệ * "Nỗi riêng, riêng những bàn hoàn, Dầu chong trắng đĩa, lệ tràn thấm khăn." (TKiều)',
    example:
      'giọt lệ * mắt ứa lệ * "Nỗi riêng, riêng những bàn hoàn, Dầu chong trắng đĩa, lệ tràn thấm khăn." (TKiều)',
  },
  {
    word: "lệ",
    part_of_speech: "danh từ",
    meaning:
      "điều quy định có từ lâu đã trở thành nền nếp, mọi người cứ theo thế mà làm: bỏ lệ cũ * bài thi không hợp lệ",
    example: "bỏ lệ cũ * bài thi không hợp lệ",
  },
  {
    word: "lệ",
    part_of_speech: "danh từ",
    meaning:
      "điều được lặp đi lặp lại nhiều lần, tự nhiên đã thành thói quen: theo lệ thường * thói quen đã thành lệ",
    example: "theo lệ thường * thói quen đã thành lệ",
  },
  {
    word: "lệ",
    part_of_speech: "danh từ",
    meaning:
      "điều làm theo lệ thường (chỉ cốt cho có mà thôi): làm cho có lệ * tổ chức cho đủ lệ",
    example: "làm cho có lệ * tổ chức cho đủ lệ",
  },
  {
    word: "lê",
    part_of_speech: "danh từ",
    meaning: "lưỡi lê (nói tắt)",
    example: "đâm lê",
  },
  {
    word: "lê",
    part_of_speech: "động từ",
    meaning:
      "di chuyển bằng cách kéo gần như sát mặt đất: chân đau phải lê từng bước * kéo lê cái cuốc * giặc lê máy chém đi khắp nơi",
    example:
      "chân đau phải lê từng bước * kéo lê cái cuốc * giặc lê máy chém đi khắp nơi",
  },
  {
    word: "lê",
    part_of_speech: "động từ",
    meaning:
      "di chuyển bằng cách nằm nghiêng hoặc ngồi nghiêng, dùng sức của khuỷu tay và chân đẩy người đi: bộ đội tập lăn, lê, bò, toài",
    example: "bộ đội tập lăn, lê, bò, toài",
  },
  {
    word: "lễ bái",
    part_of_speech: "động từ",
    meaning: "như cúng bái: lễ bái tổ tiên",
    example: "lễ bái tổ tiên",
  },
  {
    word: "lê dân",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) những người dân thường (nói tổng quát; hàm ý coi thường, theo quan niệm cũ): lê dân trăm họ",
    example: "lê dân trăm họ",
  },
  {
    word: "lễ độ",
    part_of_speech: "danh từ",
    meaning:
      "thái độ được coi là đúng mực, tỏ ra biết coi trọng người khác khi tiếp xúc (nói khái quát): giữ lễ độ với người trên * ăn nói thiếu lễ độ",
    example: "giữ lễ độ với người trên * ăn nói thiếu lễ độ",
  },
  {
    word: "lễ độ",
    part_of_speech: "tính từ",
    meaning:
      "có thái độ được coi là đúng mực trong cư xử, tiếp xúc với người khác: cư xử rất lễ độ * ăn nói lễ độ",
    example: "cư xử rất lễ độ * ăn nói lễ độ",
  },
  {
    word: "lễ bạc lòng thành",
    part_of_speech: "",
    meaning:
      'đồ biếu, vật lễ tuy ít ỏi, sơ sài nhưng tấm lòng thì chân thành (thường dùng với ý khiêm tốn): "Kiều tương lễ bạc lòng thành, Lập đàn cáo tạ thần linh ba ngày." (TNNL)',
    example:
      'Kiều tương lễ bạc lòng thành, Lập đàn cáo tạ thần linh ba ngày." (TNNL)',
  },
  {
    word: "lệ bộ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) những thứ cần thiết phải có theo lệ thường (nói tổng quát): sắm đủ lệ bộ cho cô dâu",
    example: "sắm đủ lệ bộ cho cô dâu",
  },
  {
    word: "lê dương",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) lính đánh thuê người nước ngoài gia nhập quân đội viễn chinh Pháp: lính lê dương",
    example: "lính lê dương",
  },
  {
    word: "lễ giáo",
    part_of_speech: "danh từ",
    meaning:
      "những điều giáo dục về khuôn phép sống, theo tư tưởng nho giáo (nói tổng quát): bị trói buộc trong vòng lễ giáo phong kiến",
    example: "bị trói buộc trong vòng lễ giáo phong kiến",
  },
  {
    word: "lề đường",
    part_of_speech: "danh từ",
    meaning:
      "phần mép hai bên đường có tác dụng bảo vệ mặt đường, thường dành cho người đi bộ: đi bộ bên lề đường",
    example: "đi bộ bên lề đường",
  },
  {
    word: "lễ đài",
    part_of_speech: "danh từ",
    meaning:
      "nơi được dựng cao lên để làm chỗ đứng danh dự cho những người chủ trì và quan khách trong một cuộc lễ lớn có đông đảo quần chúng tham gia: đoàn đại biểu tiến ra lễ đài",
    example: "đoàn đại biểu tiến ra lễ đài",
  },
  {
    word: "lễ lạt",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) các cuộc lễ (nói khái quát): những ngày lễ lạt",
    example: "những ngày lễ lạt",
  },
  {
    word: "lễ lạt",
    part_of_speech: "danh từ",
    meaning: "lễ vật (nói khái quát): sắm sửa lễ lạt",
    example: "sắm sửa lễ lạt",
  },
  {
    word: "lễ lạt",
    part_of_speech: "động từ",
    meaning: "(cũ) biếu xén, hối lộ: chuẩn bị đồ để lễ lạt quan trên",
    example: "chuẩn bị đồ để lễ lạt quan trên",
  },
  {
    word: "lê la",
    part_of_speech: "động từ",
    meaning:
      "(trẻ em) lê hết chỗ này đến chỗ khác (nói khái quát): đứa trẻ lê la ngoài sân",
    example: "đứa trẻ lê la ngoài sân",
  },
  {
    word: "lê la",
    part_of_speech: "động từ",
    meaning:
      "đi hết chỗ này đến chỗ khác, bạ chỗ nào cũng ngồi vào mà không có chủ định gì cả: lê la quán xá * bạ chỗ nào cũng lê la nói chuyện",
    example: "lê la quán xá * bạ chỗ nào cũng lê la nói chuyện",
  },
  {
    word: "lệ làng",
    part_of_speech: "danh từ",
    meaning:
      "tục lệ của làng mà mọi người trong làng phải tuân theo: phép vua thua lệ làng (tng)",
    example: "phép vua thua lệ làng (tng)",
  },
  {
    word: "lễ hội",
    part_of_speech: "danh từ",
    meaning:
      "cuộc vui chung có tổ chức, có các hoạt động lễ nghi mang tính văn hoá truyền thống",
    example: "lễ hội đền Hùng * lễ hội Ka tê",
  },
  {
    word: "lề luật",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như luật lệ: giữ lề luật * bất chấp mọi lề luật",
    example: "giữ lề luật * bất chấp mọi lề luật",
  },
  {
    word: "lề lối",
    part_of_speech: "danh từ",
    meaning: "cách thức đã trở thành thói quen: làm theo lề lối cũ",
    example: "làm theo lề lối cũ",
  },
  {
    word: "lễ mễ",
    part_of_speech: "tính từ",
    meaning:
      "có dáng đi chậm chạp và nặng nề do phải ôm, bê vật nặng và cồng kềnh: cậu bé lễ mễ ôm một chồng sách",
    example: "cậu bé lễ mễ ôm một chồng sách",
  },
  {
    word: "lệ luật",
    part_of_speech: "danh từ",
    meaning: "(cũ, hiếm) như luật lệ: tuân theo lệ luật",
    example: "tuân theo lệ luật",
  },
  {
    word: "lê lết",
    part_of_speech: "động từ",
    meaning:
      "không nhấc nổi thân mình, phải nằm bẹp một chỗ hoặc lê đi từng bước khó nhọc: chân đau, phải lê lết từng bước * ốm lê lết cả tháng trời",
    example: "chân đau, phải lê lết từng bước * ốm lê lết cả tháng trời",
  },
  {
    word: "lê lết",
    part_of_speech: "động từ",
    meaning: "(hiếm) như lê la (ng1): đứa bé bò lê lết khắp nhà",
    example: "đứa bé bò lê lết khắp nhà",
  },
  {
    word: "lễ phép",
    part_of_speech: "danh từ",
    meaning:
      "thái độ được coi là đúng mực đối với người trên, tỏ ra có lòng kính trọng: biết giữ lễ phép * ăn nói thiếu lễ phép với người trên",
    example: "biết giữ lễ phép * ăn nói thiếu lễ phép với người trên",
  },
  {
    word: "lễ phép",
    part_of_speech: "tính từ",
    meaning:
      "có thái độ được coi là đúng mực, tỏ ra biết kính trọng người trên: cách cư xử rất lễ phép * khoanh tay lễ phép chào",
    example: "cách cư xử rất lễ phép * khoanh tay lễ phép chào",
  },
  {
    word: "lễ nghi",
    part_of_speech: "danh từ",
    meaning:
      "nghi thức và trình tự tiến hành của một cuộc lễ: am hiểu lễ nghi * đám cưới cử hành theo đúng lễ nghi",
    example: "am hiểu lễ nghi * đám cưới cử hành theo đúng lễ nghi",
  },
  {
    word: "lề mề",
    part_of_speech: "tính từ",
    meaning:
      "chậm chạp, không khẩn trương, để kéo dài công việc: đi đứng lề mề * tác phong lề mề, chậm chạp * anh là chúa lề mề!",
    example: "đi đứng lề mề * tác phong lề mề, chậm chạp * anh là chúa lề mề!",
  },
  {
    word: "lệ phí",
    part_of_speech: "danh từ",
    meaning:
      "khoản tiền do nhà nước quy định phải nộp cho cơ quan, đơn vị, v.v. khi làm một thủ tục giấy tờ hay sử dụng một quyền lợi nào đó: lệ phí thi * lệ phí qua cầu * nộp lệ phí trước bạ",
    example: "lệ phí thi * lệ phí qua cầu * nộp lệ phí trước bạ",
  },
  {
    word: "lễ nghĩa",
    part_of_speech: "danh từ",
    meaning:
      "những phép tắc phải theo để cư xử trong gia đình, xã hội sao cho phải đạo người trên kẻ dưới, theo tư tưởng nho giáo (nói tổng quát): giữ đúng phép tắc, lễ nghĩa * phú quý sinh lễ nghĩa",
    example: "giữ đúng phép tắc, lễ nghĩa * phú quý sinh lễ nghĩa",
  },
  {
    word: "lê thê",
    part_of_speech: "tính từ",
    meaning:
      "dài quá mức, như không biết đến đâu mới dứt: váy áo lê thê * ngày dài lê thê",
    example: "váy áo lê thê * ngày dài lê thê",
  },
  {
    word: "lễ phục",
    part_of_speech: "danh từ",
    meaning: "quần áo mặc trong những buổi lễ long trọng: mặc lễ phục",
    example: "mặc lễ phục",
  },
  {
    word: "lễ tân",
    part_of_speech: "danh từ",
    meaning:
      "việc tiếp xúc, giao thiệp trong quan hệ đối ngoại theo những thể thức nhất định: nghi thức lễ tân * ban lễ tân",
    example: "nghi thức lễ tân * ban lễ tân",
  },
  {
    word: "lễ tân",
    part_of_speech: "danh từ",
    meaning: "nhân viên lễ tân: làm lễ tân ở khách sạn",
    example: "làm lễ tân ở khách sạn",
  },
  {
    word: "lệ thuộc",
    part_of_speech: "động từ",
    meaning:
      "phụ thuộc tới mức mất tự chủ, mất quyền chủ động: lệ thuộc về kinh tế * sống lệ thuộc vào cha mẹ",
    example: "lệ thuộc về kinh tế * sống lệ thuộc vào cha mẹ",
  },
  {
    word: "lề thói",
    part_of_speech: "danh từ",
    meaning:
      "thói quen xã hội từ lâu đã thành nếp: sống theo lề thói cũ * loại bỏ lề thói cổ hủ, lạc hậu",
    example: "sống theo lề thói cũ * loại bỏ lề thói cổ hủ, lạc hậu",
  },
  {
    word: "lễ tiết",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) những quy định, trong nội bộ một số tổ chức, về tư thế, cử chỉ, cách nói năng trong sự tiếp xúc giữa những người thuộc các cấp khác nhau (nói khái quát): chào theo lễ tiết quân nhân",
    example: "chào theo lễ tiết quân nhân",
  },
  {
    word: "lếch thếch",
    part_of_speech: "tính từ",
    meaning:
      "lôi thôi, trông bệ rạc, khổ sở: quần áo lếch thếch * cả gia đình lếch thếch kéo nhau đi",
    example: "quần áo lếch thếch * cả gia đình lếch thếch kéo nhau đi",
  },
  {
    word: "lếch tha lếch thếch",
    part_of_speech: "tính từ",
    meaning:
      "quá lếch thếch, trông rất tồi tàn, bệ rạc: ăn mặc lếch tha lếch thếch",
    example: "ăn mặc lếch tha lếch thếch",
  },
  {
    word: "lễ vật",
    part_of_speech: "danh từ",
    meaning: "vật dùng để biếu tặng hay cúng tế: lễ vật cầu hôn * dâng lễ vật",
    example: "lễ vật cầu hôn * dâng lễ vật",
  },
  {
    word: "lệch lạc",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) lệch, không ngay ngắn, không cân: bức tranh treo lệch lạc * đội mũ lệch lạc",
    example: "bức tranh treo lệch lạc * đội mũ lệch lạc",
  },
  {
    word: "lệch lạc",
    part_of_speech: "tính từ",
    meaning:
      "sai lệch, không đúng: cái nhìn lệch lạc * tư tưởng lệch lạc * suy nghĩ lệch lạc",
    example: "cái nhìn lệch lạc * tư tưởng lệch lạc * suy nghĩ lệch lạc",
  },
  {
    word: "lên án",
    part_of_speech: "động từ",
    meaning:
      "nêu rõ tội lỗi và phê phán, buộc tội: dư luận lên án cuộc chiến tranh phi nghĩa",
    example: "dư luận lên án cuộc chiến tranh phi nghĩa",
  },
  {
    word: "lên",
    part_of_speech: "động từ",
    meaning:
      "di chuyển đến một vị trí ở phía trên hoặc ở phía trước: lên núi * mặt trời lên cao * học sinh lên bảng",
    example: "lên núi * mặt trời lên cao * học sinh lên bảng",
  },
  {
    word: "lên",
    part_of_speech: "động từ",
    meaning:
      "tăng số lượng hay đạt một mức, một cấp cao hơn: nước sông lên to * hàng lên giá * lên chức",
    example: "nước sông lên to * hàng lên giá * lên chức",
  },
  {
    word: "lên",
    part_of_speech: "động từ",
    meaning:
      "(trẻ con) đạt mức tuổi bao nhiêu đó (từ mười trở xuống): bé đã lên hai * mồ côi mẹ từ khi lên chín",
    example: "bé đã lên hai * mồ côi mẹ từ khi lên chín",
  },
  {
    word: "lên",
    part_of_speech: "động từ",
    meaning:
      "phát triển đến chỗ dần dần hình thành và hiện ra cụ thể trên bề mặt hay bên ngoài: mặt lên mụn * vết thương lên da non * lúa lên đòng * (khẩu ngữ) Ăn cẩn thận, coi chừng kiến lên (= xuất hiện)!",
    example:
      "mặt lên mụn * vết thương lên da non * lúa lên đòng * (khẩu ngữ) Ăn cẩn thận, coi chừng kiến lên (= xuất hiện)!",
  },
  {
    word: "lên",
    part_of_speech: "động từ",
    meaning:
      "làm cho hình thành ở dạng hoàn chỉnh hoặc ở vào trạng thái có thể phát huy đầy đủ tác dụng: lên kế hoạch * lên danh sách * đàn đã lên dây",
    example: "lên kế hoạch * lên danh sách * đàn đã lên dây",
  },
  {
    word: "lên",
    part_of_speech: "động từ",
    meaning:
      "từ biểu thị hướng di chuyển đến một vị trí cao hơn hay ở phía trước: đứng lên * bay lên trời cao * vượt lên trước",
    example: "đứng lên * bay lên trời cao * vượt lên trước",
  },
  {
    word: "lên",
    part_of_speech: "động từ",
    meaning:
      "từ biểu thị phạm vi hoạt động, tác động ở mặt trên của sự vật: tranh treo lên tường * không giẫm lên cỏ * vụ việc đã được đưa lên báo",
    example:
      "tranh treo lên tường * không giẫm lên cỏ * vụ việc đã được đưa lên báo",
  },
  {
    word: "lên",
    part_of_speech: "động từ",
    meaning:
      "từ biểu thị hướng phát triển của hoạt động, tính chất từ ít đến nhiều, từ không đến có: lớn lên * lửa bùng lên * thét lên * tức phát điên lên * đỏ bừng mặt lên",
    example:
      "lớn lên * lửa bùng lên * thét lên * tức phát điên lên * đỏ bừng mặt lên",
  },
  {
    word: "lên",
    part_of_speech: "phụ từ",
    meaning:
      "từ biểu thị ý thúc giục, động viên: hãy cố lên! * làm nhanh lên! * đi nhanh lên chứ!",
    example: "hãy cố lên! * làm nhanh lên! * đi nhanh lên chứ!",
  },
  {
    word: "lệch",
    part_of_speech: "tính từ",
    meaning:
      "không đúng với hướng thẳng làm chuẩn mà sai chệch đi về một bên, một phía: viết lệch dòng * đường kẻ bị lệch * lái cho xe đi lệch về phía trái",
    example:
      "viết lệch dòng * đường kẻ bị lệch * lái cho xe đi lệch về phía trái",
  },
  {
    word: "lệch",
    part_of_speech: "tính từ",
    meaning:
      'không cân, không ngang bằng nhau giữa hai bên, hai phía: đôi đũa lệch * đội mũ lệch * "Yêu nhau vạn sự chẳng nề, Một trăm chỗ lệch cũng kê cho bằng." (ca dao)',
    example:
      'đôi đũa lệch * đội mũ lệch * "Yêu nhau vạn sự chẳng nề, Một trăm chỗ lệch cũng kê cho bằng." (ca dao)',
  },
  {
    word: "lệch",
    part_of_speech: "tính từ",
    meaning:
      "không được đúng đắn, thiên về một phía, một mặt: hiểu lệch vấn đề * phát triển lệch * học lệch",
    example: "hiểu lệch vấn đề * phát triển lệch * học lệch",
  },
  {
    word: "lên cơn",
    part_of_speech: "động từ",
    meaning:
      "có triệu chứng cơn bệnh bắt đầu và đang phát triển: lên cơn sốt * lên cơn co giật",
    example: "lên cơn sốt * lên cơn co giật",
  },
  {
    word: "lên cân",
    part_of_speech: "động từ",
    meaning:
      "(cơ thể) cân được nặng hơn trước; tăng cân: ăn uống điều độ, người đã lên cân",
    example: "ăn uống điều độ, người đã lên cân",
  },
  {
    word: "lên đạn",
    part_of_speech: "động từ",
    meaning: "đưa đạn vào nòng súng để sẵn sàng bắn: súng đã lên đạn",
    example: "súng đã lên đạn",
  },
  {
    word: "lên đời",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) thay đổi hẳn so với trước về điều kiện, khả năng hoặc đời sống vật chất: xe máy lên đời * được lên đời nhờ trúng số",
    example: "xe máy lên đời * được lên đời nhờ trúng số",
  },
  {
    word: "lên dây",
    part_of_speech: "động từ",
    meaning:
      "vặn cho dây đàn, dây cót căng theo yêu cầu: lên dây cót * đàn đã lên dây",
    example: "lên dây cót * đàn đã lên dây",
  },
  {
    word: "lên đèn",
    part_of_speech: "động từ",
    meaning: "thắp đèn, bật đèn vào lúc chập tối: thành phố đã lên đèn",
    example: "thành phố đã lên đèn",
  },
  {
    word: "lên đồng",
    part_of_speech: "động từ",
    meaning:
      "ở vào trạng thái phần hồn thoát ra khỏi phần xác, thần thánh hay vong hồn nhập vào để phán bảo, theo tín ngưỡng dân gian: lảo đảo như người lên đồng",
    example: "lảo đảo như người lên đồng",
  },
  {
    word: "lên khuôn",
    part_of_speech: "động từ",
    meaning: "sắp xếp bài báo vào vị trí trên khuôn in: báo đã lên khuôn",
    example: "báo đã lên khuôn",
  },
  {
    word: "lên gân",
    part_of_speech: "động từ",
    meaning:
      "tự làm cho gân căng ra, cơ bắp rắn lại, thường nhằm dồn sức làm gì đó.",
    example: "giọng nói hơi lên gân",
  },
  {
    word: "lên đường",
    part_of_speech: "động từ",
    meaning:
      "bắt đầu rời nơi đang ở để đi xa: lên đường nhập ngũ * chúc lên đường bình an!",
    example: "lên đường nhập ngũ * chúc lên đường bình an!",
  },
  {
    word: "lên giọng",
    part_of_speech: "động từ",
    meaning:
      "nói giọng như bề trên (hàm ý chê): lên giọng dạy đời * lên giọng đàn anh",
    example: "lên giọng dạy đời * lên giọng đàn anh",
  },
  {
    word: "lên men",
    part_of_speech: "động từ",
    meaning:
      "phản ứng hoá học do men tác dụng lên chất hữu cơ: rượu đã lên men",
    example: "rượu đã lên men",
  },
  {
    word: "lên mặt",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tỏ ra kiêu căng coi thường người khác: lên mặt dạy đời * chưa gì đã lên mặt!",
    example: "lên mặt dạy đời * chưa gì đã lên mặt!",
  },
  {
    word: "lên lớp",
    part_of_speech: "động từ",
    meaning:
      "giảng dạy hay học tập trên lớp: sắp đến giờ lên lớp * chuẩn bị kĩ giáo án trước khi lên lớp",
    example: "sắp đến giờ lên lớp * chuẩn bị kĩ giáo án trước khi lên lớp",
  },
  {
    word: "lên lớp",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) nói như kiểu người bề trên dạy bảo: chưa chi đã giở giọng lên lớp! * bị lên lớp cho một trận",
    example: "chưa chi đã giở giọng lên lớp! * bị lên lớp cho một trận",
  },
  {
    word: "lên nước",
    part_of_speech: "động từ",
    meaning:
      "có bề mặt trở nên nhẵn và bóng loáng do cọ xát nhiều (thường nói về đồ gỗ): mặt sàn lên nước bóng loáng",
    example: "mặt sàn lên nước bóng loáng",
  },
  {
    word: "lên nước",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tỏ ra kiêu ngạo cậy thế lấn át người khác: được thể càng lên nước",
    example: "được thể càng lên nước",
  },
  {
    word: "lên ngôi",
    part_of_speech: "động từ",
    meaning: "lên làm vua: làm lễ lên ngôi * lên ngôi hoàng đế",
    example: "làm lễ lên ngôi * lên ngôi hoàng đế",
  },
  {
    word: "lên ngôi",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) chiếm vị trí hàng đầu, được ham chuộng, ưa thích: một ca sĩ trẻ mới lên ngôi * mốt mới lên ngôi",
    example: "một ca sĩ trẻ mới lên ngôi * mốt mới lên ngôi",
  },
  {
    word: "lên lão",
    part_of_speech: "động từ",
    meaning:
      "(cũ) (người dân ở nông thôn) đến tuổi lão nhiêu (sáu mươi tuổi), được miễn lao dịch, thời phong kiến, thực dân.",
    example: "lên lão tám mươi",
  },
  {
    word: "lên râu",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) tỏ ra hãnh diện, kiêu căng: vừa được khen đã vội lên râu",
    example: "vừa được khen đã vội lên râu",
  },
  {
    word: "lên tay",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có tiến bộ rõ rệt về tay nghề, nghiệp vụ: càng vẽ càng lên tay * dạo này cậu ấy viết rất lên tay",
    example: "càng vẽ càng lên tay * dạo này cậu ấy viết rất lên tay",
  },
  {
    word: "lên sởi",
    part_of_speech: "động từ",
    meaning: "mắc bệnh sởi: bé bị lên sởi",
    example: "bé bị lên sởi",
  },
  {
    word: "lên thác xuống ghềnh",
    part_of_speech: "",
    meaning:
      '(văn chương) ví cảnh gian truân vất vả, nguy nan: "Quản chi lên thác xuống ghềnh, Cũng toan sống thác với tình cho xong." (TKiều)',
    example:
      'Quản chi lên thác xuống ghềnh, Cũng toan sống thác với tình cho xong." (TKiều)',
  },
  {
    word: "lệnh bà",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, trang trọng) từ dùng để gọi vợ hoặc mẹ của vua, biểu thị ý kính trọng (khi nói với người ấy hoặc với một người thứ ba): muôn tâu lệnh bà",
    example: "muôn tâu lệnh bà",
  },
  {
    word: "lệnh",
    part_of_speech: "danh từ",
    meaning:
      "điều cấp trên truyền xuống cho cấp dưới phải thi hành: tuân lệnh * ra lệnh * nhận lệnh đi công tác",
    example: "tuân lệnh * ra lệnh * nhận lệnh đi công tác",
  },
  {
    word: "lệnh",
    part_of_speech: "danh từ",
    meaning:
      "văn bản pháp quy, do chủ tịch nước ban hành: kí lệnh ân xá * lệnh tổng động viên",
    example: "kí lệnh ân xá * lệnh tổng động viên",
  },
  {
    word: "lệnh",
    part_of_speech: "danh từ",
    meaning:
      "giấy cho phép làm một việc gì: xuất trình lệnh khám nhà * có lệnh bắt giam",
    example: "xuất trình lệnh khám nhà * có lệnh bắt giam",
  },
  {
    word: "lệnh",
    part_of_speech: "danh từ",
    meaning:
      "thanh la dùng để báo hiệu lệnh: đánh lệnh * nói oang oang như lệnh vỡ * lệnh ông không bằng cồng bà (tng)",
    example:
      "đánh lệnh * nói oang oang như lệnh vỡ * lệnh ông không bằng cồng bà (tng)",
  },
  {
    word: "lệnh",
    part_of_speech: "danh từ",
    meaning:
      "tín hiệu báo cho máy tính biết cần phải thực hiện một nhiệm vụ, một thao tác nào đó: lệnh copy",
    example: "lệnh copy",
  },
  {
    word: "lệnh",
    part_of_speech: "danh từ",
    meaning: "vật dùng để báo hiệu lệnh: phất cờ lệnh",
    example: "phất cờ lệnh",
  },
  {
    word: "lệnh",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) ra lệnh: lệnh cho đơn vị sẵn sàng chiến đấu",
    example: "lệnh cho đơn vị sẵn sàng chiến đấu",
  },
  {
    word: "lềnh bềnh",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái nổi hẳn lên trên mặt nước và trôi nhẹ nhàng theo làn sóng: quả bóng nổi lềnh bềnh * rác rưởi trôi lềnh bềnh trên sông",
    example: "quả bóng nổi lềnh bềnh * rác rưởi trôi lềnh bềnh trên sông",
  },
  {
    word: "lên tiếng",
    part_of_speech: "động từ",
    meaning: "cất tiếng nói: lên tiếng hỏi",
    example: "lên tiếng hỏi",
  },
  {
    word: "lên tiếng",
    part_of_speech: "động từ",
    meaning:
      "phát biểu ý kiến để biểu thị thái độ về một vấn đề nào đó: lên tiếng phản đối * nếu có vấn đề gì, chúng tôi sẽ lên tiếng",
    example: "lên tiếng phản đối * nếu có vấn đề gì, chúng tôi sẽ lên tiếng",
  },
  {
    word: "lênh đênh",
    part_of_speech: "",
    meaning:
      "trôi bập bềnh trên mặt nước, không có hướng, có đích nhất định: bèo trôi lênh đênh * chiếc bè gỗ lênh đênh trên dòng nước",
    example: "bèo trôi lênh đênh * chiếc bè gỗ lênh đênh trên dòng nước",
  },
  {
    word: "lênh đênh",
    part_of_speech: "",
    meaning:
      "trôi nổi nay đây mai đó, không có hướng nhất định, không có chỗ nương tựa: ba chìm bảy nổi chín lênh đênh * cuộc đời lênh đênh, chìm nổi",
    example: "ba chìm bảy nổi chín lênh đênh * cuộc đời lênh đênh, chìm nổi",
  },
  {
    word: "lênh khênh",
    part_of_speech: "tính từ",
    meaning:
      "cao quá mức, gây ấn tượng không cân đối, dễ đổ, dễ ngã: chiếc tủ lênh khênh * người cao lênh khênh",
    example: "chiếc tủ lênh khênh * người cao lênh khênh",
  },
  {
    word: "lênh láng",
    part_of_speech: "động từ",
    meaning:
      "(chất lỏng) tràn khắp ra trên bề mặt rộng: nước chảy lênh láng khắp sân * mực đổ lênh láng ra bàn",
    example: "nước chảy lênh láng khắp sân * mực đổ lênh láng ra bàn",
  },
  {
    word: "lềnh phềnh",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái nổi vật vờ trên mặt nước, gây cảm giác nhơ bẩn: cỏ rác lềnh phềnh trên mặt ao * cá chết nổi lềnh phềnh",
    example: "cỏ rác lềnh phềnh trên mặt ao * cá chết nổi lềnh phềnh",
  },
  {
    word: "lết bết",
    part_of_speech: "tính từ",
    meaning:
      "(vật mang trên người) dài sát mặt đất và tựa như kéo lết khi di chuyển: quần dài lết bết",
    example: "quần dài lết bết",
  },
  {
    word: "lết bết",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra đuối sức, vận động, hoạt động rất khó khăn, chậm chạp: ốm lết bết * mệt quá, bước đi lết bết",
    example: "ốm lết bết * mệt quá, bước đi lết bết",
  },
  {
    word: "lệt sệt",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả tiếng giày dép hay vật gì tương tự kéo lê trên mặt nền: kéo lệt sệt cái mo cau",
    example: "kéo lệt sệt cái mo cau",
  },
  {
    word: "lết",
    part_of_speech: "động từ",
    meaning:
      "di chuyển một cách khó khăn, chậm chạp bằng cách kéo lê chân hoặc phần dưới cơ thể trên mặt nền: chân bị đau phải lết từng bước * bò lết",
    example: "chân bị đau phải lết từng bước * bò lết",
  },
  {
    word: "lêu",
    part_of_speech: "cảm từ",
    meaning:
      "tiếng dùng để chế giễu làm cho trẻ em thấy xấu hổ: lêu lêu, cái đồ tham ăn!",
    example: "lêu lêu, cái đồ tham ăn!",
  },
  {
    word: "lếu",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ, hiếm) như láo: nói lếu * làm lếu",
    example: "nói lếu * làm lếu",
  },
  {
    word: "lều",
    part_of_speech: "danh từ",
    meaning:
      "nhà nhỏ, gồm một hoặc hai mái che sơ sài: lều chăn vịt * lều bạt * một túp lều tranh hai trái tim vàng",
    example: "lều chăn vịt * lều bạt * một túp lều tranh hai trái tim vàng",
  },
  {
    word: "lều bều",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái nổi lềnh bềnh trên mặt nước, trông bẩn mắt: rác rưởi lều bều trên mặt sông",
    example: "rác rưởi lều bều trên mặt sông",
  },
  {
    word: "lêu bêu",
    part_of_speech: "",
    meaning: "(hiếm) như lêu têu: đi lêu bêu cả ngày",
    example: "đi lêu bêu cả ngày",
  },
  {
    word: "lều chõng",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) lều và chõng của thí sinh thời phong kiến mang theo vào trường thi để có chỗ ngồi làm bài; dùng để tả cảnh đi thi thời phong kiến: lều chõng đi thi",
    example: "lều chõng đi thi",
  },
  {
    word: "lếu láo",
    part_of_speech: "tính từ",
    meaning:
      "láo, không kể gì đến khuôn phép (nói khái quát): ăn nói lếu láo * thằng bé rất lếu láo!",
    example: "ăn nói lếu láo * thằng bé rất lếu láo!",
  },
  {
    word: "lếu láo",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (làm việc gì) qua loa cho xong, cho có: làm lếu láo cho xong việc * vẽ mấy nét lếu láo",
    example: "làm lếu láo cho xong việc * vẽ mấy nét lếu láo",
  },
  {
    word: "lêu đêu",
    part_of_speech: "tính từ",
    meaning:
      "cao một cách khác thường, đến mức mất cân đối so với bề ngang: cao lêu đêu",
    example: "cao lêu đêu",
  },
  {
    word: "lêu lổng",
    part_of_speech: "",
    meaning: "chỉ rong chơi, không chịu học hành, làm lụng: chơi bời lêu lổng",
    example: "chơi bời lêu lổng",
  },
  {
    word: "lều khều",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như lêu nghêu: cao lều khều * tay chân dài lều khều",
    example: "cao lều khều * tay chân dài lều khều",
  },
  {
    word: "lêu nghêu",
    part_of_speech: "tính từ",
    meaning:
      "cao hoặc dài quá cỡ, trông mất hẳn cân đối: người lêu nghêu * cái chòi cao lêu nghêu",
    example: "người lêu nghêu * cái chòi cao lêu nghêu",
  },
  {
    word: "lều nghều",
    part_of_speech: "tính từ",
    meaning: "như lêu nghêu: người cao lều nghều * sào dài lều nghều",
    example: "người cao lều nghều * sào dài lều nghều",
  },
  {
    word: "lều nghều",
    part_of_speech: "tính từ",
    meaning:
      "(tay, chân) quá dài và gầy gò, khiến cử động vụng về, chậm chạp: tay dài lều nghều như tay vượn",
    example: "tay dài lều nghều như tay vượn",
  },
  {
    word: "lều phều",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như lều bều: mặt ao nổi váng lều phều",
    example: "mặt ao nổi váng lều phều",
  },
  {
    word: "lì",
    part_of_speech: "tính từ",
    meaning:
      "đã thành nhẵn, phẳng đến mức không thể hơn được nữa: bãi cỏ phẳng lì * hòn đá nhẵn lì * đầm cho lì đất",
    example: "bãi cỏ phẳng lì * hòn đá nhẵn lì * đầm cho lì đất",
  },
  {
    word: "lì",
    part_of_speech: "tính từ",
    meaning:
      "đã quá quen với một tác động nào đó đến mức có khả năng chịu đựng, dù có tác động đến mấy cũng vẫn coi như không, không hề có một biểu hiện phản ứng nào cả: bị đánh nhiều đâm lì đòn * thằng bé rất lì",
    example: "bị đánh nhiều đâm lì đòn * thằng bé rất lì",
  },
  {
    word: "lì",
    part_of_speech: "tính từ",
    meaning:
      "ở trong một trạng thái cứ thế không thay đổi, bất chấp mọi tác động bên ngoài: ngồi lì một chỗ * ở lì trong nhà không chịu đi đâu",
    example: "ngồi lì một chỗ * ở lì trong nhà không chịu đi đâu",
  },
  {
    word: "li bì",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái mê man kéo dài, không còn biết gì cả: sốt li bì * ngủ li bì",
    example: "sốt li bì * ngủ li bì",
  },
  {
    word: "li bì",
    part_of_speech: "tính từ",
    meaning:
      "(Ít dùng) ở tình trạng kéo dài như không bao giờ dứt: uống rượu li bì * thất nghiệp li bì",
    example: "uống rượu li bì * thất nghiệp li bì",
  },
  {
    word: "lêu têu",
    part_of_speech: "",
    meaning:
      "rong chơi hết nơi này đến nơi khác, không có cuộc sống đứng đắn: suốt ngày lêu têu ngoài phố",
    example: "suốt ngày lêu têu ngoài phố",
  },
  {
    word: "li",
    part_of_speech: "danh từ",
    meaning:
      "cốc thuỷ tinh hoặc pha lê nhỏ hay có chân đứng, dùng để uống rượu: nhấp một li rượu * cạn li * nâng li",
    example: "nhấp một li rượu * cạn li * nâng li",
  },
  {
    word: "li",
    part_of_speech: "danh từ",
    meaning: "(Nam) cốc: uống một li nước chanh * mua một li trà đá",
    example: "uống một li nước chanh * mua một li trà đá",
  },
  {
    word: "li",
    part_of_speech: "danh từ",
    meaning: "nếp may gấp lại của quần, áo: áo may có chiết li * li quần",
    example: "áo may có chiết li * li quần",
  },
  {
    word: "li",
    part_of_speech: "danh từ",
    meaning: "vết gấp tạo dáng trên quần áo: quần là li thẳng tắp",
    example: "quần là li thẳng tắp",
  },
  {
    word: "li",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị cũ đo khối lượng, bằng một phần mười phân hay một phần nghìn lạng, tức bằng khoảng 0,0378 gram.",
    example: "pháo 105 li",
  },
  {
    word: "li",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị cũ đo độ dài, bằng một phần nghìn thước mộc hoặc thước đo vải, tức bằng khoảng 0,000425 mét (li mộc) hoặc 0,000645 mét (li vải).",
    example: "để ý từng li từng tí * sai một li đi một dặm (tng)",
  },
  {
    word: "lị",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) kiết lị (nói tắt): ăn uống thiếu vệ sinh dễ sinh ra đi lị",
    example: "ăn uống thiếu vệ sinh dễ sinh ra đi lị",
  },
  {
    word: "li biệt",
    part_of_speech: "động từ",
    meaning: "(văn chương) như biệt li: cảnh li biệt",
    example: "cảnh li biệt",
  },
  {
    word: "li dị",
    part_of_speech: "động từ",
    meaning: "như li hôn: làm đơn li dị * hai vợ chồng đã li dị nhau",
    example: "làm đơn li dị * hai vợ chồng đã li dị nhau",
  },
  {
    word: "lí giải",
    part_of_speech: "động từ",
    meaning:
      "hiểu rõ, chỉ rõ ra cái lẽ của sự vật, sự việc: sự việc khó lí giải * lí giải sự hình thành và tồn tại của sự sống",
    example:
      "sự việc khó lí giải * lí giải sự hình thành và tồn tại của sự sống",
  },
  {
    word: "lí do",
    part_of_speech: "danh từ",
    meaning:
      "điều làm căn cứ được dùng để giải thích một việc nào đó: nghỉ học có lí do * viện đủ lí do để từ chối * tuyên bố lí do cuộc họp",
    example:
      "nghỉ học có lí do * viện đủ lí do để từ chối * tuyên bố lí do cuộc họp",
  },
  {
    word: "li gián",
    part_of_speech: "động từ",
    meaning:
      "gây chia rẽ trong nội bộ đối phương: dùng kế li gián * tung tin xấu để li gián hai người",
    example: "dùng kế li gián * tung tin xấu để li gián hai người",
  },
  {
    word: "li hôn",
    part_of_speech: "động từ",
    meaning:
      "(vợ chồng) bỏ nhau một cách hợp pháp: đơn li hôn * ra toà xin li hôn",
    example: "đơn li hôn * ra toà xin li hôn",
  },
  {
    word: "li kì",
    part_of_speech: "tính từ",
    meaning:
      "có những tình tiết lạ lùng, hấp dẫn, khêu gợi tính hiếu kì: câu chuyện li kì * một vụ án li kì, lắt léo",
    example: "câu chuyện li kì * một vụ án li kì, lắt léo",
  },
  {
    word: "li khai",
    part_of_speech: "động từ",
    meaning:
      "tách mình ra khỏi, lìa bỏ khỏi một tổ chức hay những tư tưởng, quan điểm chính trị nào đó: các phần tử li khai * một nước nhỏ li khai khỏi liên bang",
    example: "các phần tử li khai * một nước nhỏ li khai khỏi liên bang",
  },
  {
    word: "lí liệu pháp",
    part_of_speech: "danh từ",
    meaning:
      "phương pháp phòng chữa bệnh bằng cách sử dụng các yếu tố vật lí như: ánh sáng, nhiệt, điện, và dùng xoa bóp, thể dục, v.v.: chữa bệnh bằng vật lí trí liệu",
    example: "chữa bệnh bằng vật lí trí liệu",
  },
  {
    word: "lí lắc",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) có vẻ lí láu, nhí nhảnh: con bé cười nói lí lắc suốt ngày",
    example: "con bé cười nói lí lắc suốt ngày",
  },
  {
    word: "lí lẽ",
    part_of_speech: "danh từ",
    meaning:
      "điều nêu ra làm căn cứ để quyết định đúng sai, phải trái (nói khái quát): không đủ lí lẽ để bác bỏ lập luận đó",
    example: "không đủ lí lẽ để bác bỏ lập luận đó",
  },
  {
    word: "lí lịch",
    part_of_speech: "danh từ",
    meaning:
      "lai lịch và nói chung những điều cần biết về quá khứ của một người hay vật nào đó (nói tổng quát): bản lí lịch * thẩm tra lí lịch",
    example: "bản lí lịch * thẩm tra lí lịch",
  },
  {
    word: "lì lợm",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra lì và ngang bướng một cách đáng ghét, đáng gờm: bộ mặt lì lợm",
    example: "bộ mặt lì lợm",
  },
  {
    word: "lí luận",
    part_of_speech: "danh từ",
    meaning:
      "hệ thống những tư tưởng được khái quát từ kinh nghiệm thực tiễn, có tác dụng chỉ đạo thực tiễn: lí luận đi đôi với thực tiễn",
    example: "lí luận đi đôi với thực tiễn",
  },
  {
    word: "lí luận",
    part_of_speech: "danh từ",
    meaning:
      "những kiến thức được khái quát và hệ thống hoá trong một lĩnh vực nào đó (nói tổng quát): lí luận văn học * lí luận quân sự",
    example: "lí luận văn học * lí luận quân sự",
  },
  {
    word: "lí luận",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nói lí luận, giải thích bằng lí luận (thường hàm ý chê): chỉ giỏi lí luận",
    example: "chỉ giỏi lí luận",
  },
  {
    word: "lí nhí",
    part_of_speech: "tính từ",
    meaning:
      "(tiếng nói) bé quá, khẽ quá, nghe không rõ: nói lí nhí trong miệng * trả lời lí nhí",
    example: "nói lí nhí trong miệng * trả lời lí nhí",
  },
  {
    word: "lí nhí",
    part_of_speech: "tính từ",
    meaning:
      "nhỏ quá, trông không rõ, chỉ thấy như những dấu chấm: chữ viết lí nhí, rất khó đọc",
    example: "chữ viết lí nhí, rất khó đọc",
  },
  {
    word: "li loạn",
    part_of_speech: "",
    meaning:
      "(cũ) như loạn li: cảnh chiến tranh li loạn * sống trong thời buổi li loạn",
    example: "cảnh chiến tranh li loạn * sống trong thời buổi li loạn",
  },
  {
    word: "lí nha lí nhí",
    part_of_speech: "tính từ",
    meaning:
      "quá lí nhí, đến mức rất khó nghe, khó thấy: chữ viết lí nha lí nhí",
    example: "chữ viết lí nha lí nhí",
  },
  {
    word: "lí số",
    part_of_speech: "danh từ",
    meaning:
      "các môn học của nhà nho xưa khảo sát lẽ biến hoá và việc bói toán (nói tổng quát); thường chỉ việc bói toán: đoán lí số",
    example: "đoán lí số",
  },
  {
    word: "li tâm",
    part_of_speech: "động từ",
    meaning: "hướng từ tâm của vòng tròn ra ngoài: lực li tâm",
    example: "lực li tâm",
  },
  {
    word: "lí sự cùn",
    part_of_speech: "tính từ",
    meaning:
      "(cũ, hiếm) rất vụ lợi trong quan hệ với mọi người, làm việc gì, với ai cũng tính toán về tiền nong, sao cho có lợi cho mình: con người lí tài",
    example: "con người lí tài",
  },
  {
    word: "li thân",
    part_of_speech: "động từ",
    meaning:
      "(vợ chồng) không còn có quan hệ tình cảm và tình dục, do bất hoà: vợ chồng sống li thân",
    example: "vợ chồng sống li thân",
  },
  {
    word: "lí sự",
    part_of_speech: "danh từ",
    meaning: "lí lẽ đưa ra chỉ cốt để tranh cãi: giở lí sự ra tranh cãi",
    example: "giở lí sự ra tranh cãi",
  },
  {
    word: "lí sự",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nói lí, nói lẽ, chỉ cốt để cãi: tính hay lí sự * chỉ giỏi lí sự",
    example: "tính hay lí sự * chỉ giỏi lí sự",
  },
  {
    word: "li tán",
    part_of_speech: "động từ",
    meaning: "rời xa nhau, phân tán mỗi người một ngả: cảnh gia đình li tán",
    example: "cảnh gia đình li tán",
  },
  {
    word: "lí thú",
    part_of_speech: "tính từ",
    meaning:
      "có tác dụng làm cho người ta thấy thú vị và có ý nghĩa: trò chơi lí thú * câu chuyện thật lí thú",
    example: "trò chơi lí thú * câu chuyện thật lí thú",
  },
  {
    word: "lí thuyết",
    part_of_speech: "danh từ",
    meaning:
      "kiến thức về lí luận (nói khái quát): lí thuyết phải gắn liền với thực tế * lí thuyết suông * thi lí thuyết",
    example:
      "lí thuyết phải gắn liền với thực tế * lí thuyết suông * thi lí thuyết",
  },
  {
    word: "lí thuyết",
    part_of_speech: "danh từ",
    meaning:
      "công trình xây dựng có hệ thống của trí tuệ, có tính chất giả thuyết và tổng hợp, nhằm giải thích một loại hiện tượng nào đó: lí thuyết về vụ nổ lớn của vũ trụ * lí thuyết lượng tử * lí thuyết tương đối",
    example:
      "lí thuyết về vụ nổ lớn của vũ trụ * lí thuyết lượng tử * lí thuyết tương đối",
  },
  {
    word: "lí tí",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như li ti: có những chấm sáng lí tí phía đằng xa",
    example: "có những chấm sáng lí tí phía đằng xa",
  },
  {
    word: "li ti",
    part_of_speech: "tính từ",
    meaning:
      "nhỏ đến mức trông chỉ như những chấm, những hạt vụn: hạt cát nhỏ li ti * chữ viết li ti",
    example: "hạt cát nhỏ li ti * chữ viết li ti",
  },
  {
    word: "lí tính",
    part_of_speech: "danh từ",
    meaning:
      "giai đoạn cao của nhận thức, dựa trên sự suy luận để nắm bản chất và quy luật của sự vật; phân biệt với cảm tính: nhận thức lí tính",
    example: "nhận thức lí tính",
  },
  {
    word: "lí trí",
    part_of_speech: "danh từ",
    meaning:
      "khả năng nhận thức sự vật bằng suy luận, khác với cảm giác, tình cảm: rèn luyện lí trí * sống có lí trí * hành động theo lí trí",
    example: "rèn luyện lí trí * sống có lí trí * hành động theo lí trí",
  },
  {
    word: "lí tưởng",
    part_of_speech: "danh từ",
    meaning:
      "mục đích cao nhất, tốt đẹp nhất mà người ta muốn đạt tới: sống có lí tưởng * hi sinh cho một lí tưởng cao đẹp",
    example: "sống có lí tưởng * hi sinh cho một lí tưởng cao đẹp",
  },
  {
    word: "lí tưởng",
    part_of_speech: "tính từ",
    meaning:
      "hoàn hảo, tốt đẹp như được hình dung hoặc như trên lí thuyết: một hình mẫu lí tưởng * con người lí tưởng * độ bền lí tưởng",
    example: "một hình mẫu lí tưởng * con người lí tưởng * độ bền lí tưởng",
  },
  {
    word: "lí tưởng hoá",
    part_of_speech: "động từ",
    meaning:
      "làm cho trở nên hoàn hảo, tốt đẹp như trong tưởng tượng, trong khi sự thật không hoặc chưa được như vậy: lí tưởng hoá cuộc sống",
    example: "lí tưởng hoá cuộc sống",
  },
  {
    word: "lìa",
    part_of_speech: "động từ",
    meaning:
      "rời ra khỏi cái mà mình vốn gắn chặt vào: lá lìa cành * chim lìa đàn * lìa đời (chết)",
    example: "lá lìa cành * chim lìa đàn * lìa đời (chết)",
  },
  {
    word: "lì xì",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) mừng tuổi (bằng tiền): tiền lì xì",
    example: "tiền lì xì",
  },
  {
    word: "lì xì",
    part_of_speech: "tính từ",
    meaning:
      "lầm lì, kém hoạt bát: ngồi lì xì chẳng nói chẳng rằng * vẻ mặt lì xì",
    example: "ngồi lì xì chẳng nói chẳng rằng * vẻ mặt lì xì",
  },
  {
    word: "lì xì",
    part_of_speech: "danh từ",
    meaning:
      "điệu hát dân gian ngắn, gọn, tính nhạc phong phú và rõ nét, chịu nhiều ảnh hưởng của nhạc đàn: lí con sáo * điệu lí * hát lí",
    example: "lí con sáo * điệu lí * hát lí",
  },
  {
    word: "lì xì",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) vật lí học (nói tắt): thầy giáo dạy lí * học kém về môn lí",
    example: "thầy giáo dạy lí * học kém về môn lí",
  },
  {
    word: "lì xì",
    part_of_speech: "danh từ",
    meaning:
      "điều được coi là hợp lẽ phải: nói có lí * giở lí ra tranh cãi * đuối lí nên đành im",
    example: "nói có lí * giở lí ra tranh cãi * đuối lí nên đành im",
  },
  {
    word: "lì xì",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) lí do, lẽ: chả có lí gì để làm như vậy",
    example: "chả có lí gì để làm như vậy",
  },
  {
    word: "lia",
    part_of_speech: "động từ",
    meaning:
      "ném hoặc đưa ngang thật nhanh: lia mảnh sành * lia một băng đạn * lia mắt nhìn xung quanh phòng",
    example: "lia mảnh sành * lia một băng đạn * lia mắt nhìn xung quanh phòng",
  },
  {
    word: "lìa bỏ",
    part_of_speech: "động từ",
    meaning: "lìa, rời khỏi cái mà mình vốn gắn bó, nâng niu: lìa bỏ cõi đời",
    example: "lìa bỏ cõi đời",
  },
  {
    word: "lia lịa",
    part_of_speech: "phụ từ",
    meaning:
      "(cử chỉ, động tác) rất nhanh và liên tiếp, không ngừng nghỉ trong khoảng thời gian rất ngắn: gật đầu lia lịa * chớp mắt lia lịa",
    example: "gật đầu lia lịa * chớp mắt lia lịa",
  },
  {
    word: "lia chia",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) lu bù, liên tục, hết cái này đến cái khác: họp hành lia chia * khách khứa lia chia",
    example: "họp hành lia chia * khách khứa lia chia",
  },
  {
    word: "lịch",
    part_of_speech: "danh từ",
    meaning:
      "cách chia thời gian thành năm, tháng, ngày: lịch dương * tính theo lịch âm * lịch quốc tế (công lịch)",
    example: "lịch dương * tính theo lịch âm * lịch quốc tế (công lịch)",
  },
  {
    word: "lịch",
    part_of_speech: "danh từ",
    meaning:
      "bản hoặc cuốn sách, giấy ghi ngày, tháng trong một hoặc nhiều năm: quyển lịch * lịch để bàn * bóc từng tờ lịch",
    example: "quyển lịch * lịch để bàn * bóc từng tờ lịch",
  },
  {
    word: "lịch",
    part_of_speech: "danh từ",
    meaning:
      "bản ghi ngày giờ nào sẽ làm công việc gì theo dự kiến của kế hoạch: lịch thi đấu bóng đá * lịch làm việc",
    example: "lịch thi đấu bóng đá * lịch làm việc",
  },
  {
    word: "lịch bịch",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng những tiếng trầm liên tiếp, không đều, như tiếng của vật nặng rơi xuống đất: dừa rụng lịch bịch * tiếng chân bước lịch bịch",
    example: "dừa rụng lịch bịch * tiếng chân bước lịch bịch",
  },
  {
    word: "lích chích",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng kêu nhỏ, trong và đều của gà con hay chim non: tiếng chim lích chích trong vòm lá",
    example: "tiếng chim lích chích trong vòm lá",
  },
  {
    word: "lịch đại",
    part_of_speech: "tính từ",
    meaning:
      "theo quan điểm tách riêng các hiện tượng ngôn ngữ, xét trong sự diễn biến, phát triển theo thời gian, làm đối tượng nghiên cứu; đối lập với đồng đại: ngôn ngữ học lịch đại",
    example: "ngôn ngữ học lịch đại",
  },
  {
    word: "lịch duyệt",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều hiểu biết và kinh nghiệm trong xử thế do đã từng trải: một con người lịch duyệt",
    example: "một con người lịch duyệt",
  },
  {
    word: "lịch kịch",
    part_of_speech: "",
    meaning:
      "từ mô phỏng tiếng động mạnh, trầm như tiếng của các vật nặng và cứng va chạm vào nhau liên tiếp: tiếng mở cửa lịch kịch",
    example: "tiếng mở cửa lịch kịch",
  },
  {
    word: "lịch lãm",
    part_of_speech: "tính từ",
    meaning:
      "có hiểu biết rộng do đã từng trải, được đi nhiều, tiếp xúc nhiều: thông minh lịch lãm * một chàng trai hào hoa, lịch lãm",
    example: "thông minh lịch lãm * một chàng trai hào hoa, lịch lãm",
  },
  {
    word: "lịch phịch",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả dáng đi nặng nề, khó khăn do quá to béo: chạy lịch phịch * người to béo, bước đi lịch phịch",
    example: "chạy lịch phịch * người to béo, bước đi lịch phịch",
  },
  {
    word: "lịch sử",
    part_of_speech: "danh từ",
    meaning:
      "quá trình phát sinh, phát triển đã qua hay cho đến tiêu vong của một hiện tượng, một sự vật nào đó diễn ra theo thứ tự thời gian: lịch sử thế giới cổ đại * lịch sử của giải Nobel * đề thi lịch sử",
    example:
      "lịch sử thế giới cổ đại * lịch sử của giải Nobel * đề thi lịch sử",
  },
  {
    word: "lịch sử",
    part_of_speech: "tính từ",
    meaning:
      "thuộc về lịch sử của các quốc gia, dân tộc, có tính chất, ý nghĩa quan trọng trong lịch sử: sự kiện lịch sử * bước ngoặt lịch sử * sứ mạng lịch sử",
    example: "sự kiện lịch sử * bước ngoặt lịch sử * sứ mạng lịch sử",
  },
  {
    word: "lịch sự",
    part_of_speech: "tính từ",
    meaning:
      "có thái độ nhã nhặn, lễ độ trong xã giao, phù hợp với quan niệm và phép tắc chung của xã hội: ăn nói lịch sự * cách cư xử thiếu lịch sự",
    example: "ăn nói lịch sự * cách cư xử thiếu lịch sự",
  },
  {
    word: "lịch sự",
    part_of_speech: "tính từ",
    meaning:
      "đẹp một cách sang trọng và thanh nhã: ăn mặc lịch sự * một nhà hàng lịch sự",
    example: "ăn mặc lịch sự * một nhà hàng lịch sự",
  },
  {
    word: "lịch thiệp",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra biết cách giao thiệp, làm vừa lòng người tiếp xúc với mình: cách cư xử lịch thiệp",
    example: "cách cư xử lịch thiệp",
  },
  {
    word: "lích kích",
    part_of_speech: "tính từ",
    meaning:
      "(đồ đạc mang theo) có lắm thứ khác nhau, không gọn nhẹ, dễ va chạm nhau: đồ đạc lích kích",
    example: "đồ đạc lích kích",
  },
  {
    word: "lích kích",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (việc làm) có lắm khâu phiền phức: nấu nướng lích kích",
    example: "nấu nướng lích kích",
  },
  {
    word: "lịch trình",
    part_of_speech: "danh từ",
    meaning:
      "chặng đường sẽ hoặc đã đi qua, theo từng thời điểm, từng giai đoạn: lịch trình của chuyến bay * lịch trình tiến hoá của nhân loại",
    example: "lịch trình của chuyến bay * lịch trình tiến hoá của nhân loại",
  },
  {
    word: "liếc",
    part_of_speech: "động từ",
    meaning:
      "đưa mắt nhìn chếch và nhanh sang một bên: liếc mắt nhìn trộm * chỉ liếc qua, chứ không nhìn kĩ",
    example: "liếc mắt nhìn trộm * chỉ liếc qua, chứ không nhìn kĩ",
  },
  {
    word: "liếc",
    part_of_speech: "động từ",
    meaning:
      "làm cho lưỡi dao sắc hơn bằng cách đưa nghiêng rất nhanh lần lượt hai mặt lưỡi dao sát trên bề mặt đá mài hay một vật cứng nào đó: liếc dao vào thành vại",
    example: "liếc dao vào thành vại",
  },
  {
    word: "liệm",
    part_of_speech: "động từ",
    meaning: "bọc xác người chết để cho vào quan tài: vải liệm",
    example: "vải liệm",
  },
  {
    word: "liếm",
    part_of_speech: "động từ",
    meaning:
      "áp sát đầu lưỡi, đưa qua đưa lại trên bề mặt vật gì: thè lưỡi liếm * mèo liếm đĩa",
    example: "thè lưỡi liếm * mèo liếm đĩa",
  },
  {
    word: "liếm gót",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) xu nịnh, bợ đỡ một cách hèn hạ: liếm gót kẻ có quyền thế",
    example: "liếm gót kẻ có quyền thế",
  },
  {
    word: "liêm chính",
    part_of_speech: "tính từ",
    meaning: "(Ít dùng) ngay thẳng và trong sạch: một ông quan liêm chính",
    example: "một ông quan liêm chính",
  },
  {
    word: "liêm khiết",
    part_of_speech: "tính từ",
    meaning:
      "(người có quyền, chức trách) có phẩm chất trong sạch, không tham ô, không nhận tiền của hối lộ: sống liêm khiết",
    example: "sống liêm khiết",
  },
  {
    word: "liếm láp",
    part_of_speech: "động từ",
    meaning:
      'liếm (nói khái quát; thường hàm ý chê): "Đi ra đường soi gương đánh sáp, Về đến nhà liếm láp nồi niêu." (ca dao)',
    example:
      'Đi ra đường soi gương đánh sáp, Về đến nhà liếm láp nồi niêu." (ca dao)',
  },
  {
    word: "liêm phóng",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) tên gọi cơ quan mật thám thời Pháp thuộc: ti liêm phóng * sở liêm phóng",
    example: "ti liêm phóng * sở liêm phóng",
  },
  {
    word: "liễn",
    part_of_speech: "danh từ",
    meaning:
      "đồ đựng thức ăn bằng sành hoặc sứ, miệng tròn rộng, có nắp đậy: liễn cơm",
    example: "liễn cơm",
  },
  {
    word: "liễn",
    part_of_speech: "danh từ",
    meaning:
      "dải vải hoặc giấy, hoặc tấm gỗ dài dùng từng đôi một để viết, để khắc câu đối treo song song với nhau: đi mừng đôi liễn",
    example: "đi mừng đôi liễn",
  },
  {
    word: "liêm sỉ",
    part_of_speech: "danh từ",
    meaning:
      "bản tính trong sạch, biết tránh không làm những việc gây tiếng xấu cho mình: một người không có liêm sỉ",
    example: "một người không có liêm sỉ",
  },
  {
    word: "liến",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) nhanh và trơn tru quá mức trong nói năng đối đáp: con bé nói rất liến * nói liến đi",
    example: "con bé nói rất liến * nói liến đi",
  },
  {
    word: "liên bang",
    part_of_speech: "danh từ",
    meaning:
      "quốc gia gồm nhiều nước, nhiều khu tự trị (trong đó các thành viên có thể có hiến pháp và các cơ quan lập pháp, hành pháp, tư pháp riêng) được hợp nhất dưới một chính quyền trung ương, có chung một hiến pháp, một quốc tịch, một đơn vị tiền tệ, v.v.: Mĩ là một nước liên bang * liên bang Nga * chế độ liên bang",
    example: "Mĩ là một nước liên bang * liên bang Nga * chế độ liên bang",
  },
  {
    word: "liền",
    part_of_speech: "tính từ",
    meaning:
      "kề ngay nhau, ở sát cạnh nhau, không có sự cách biệt: nhà liền vách * hai việc đi liền với nhau * vết thương đã liền da",
    example:
      "nhà liền vách * hai việc đi liền với nhau * vết thương đã liền da",
  },
  {
    word: "liền",
    part_of_speech: "phụ từ",
    meaning:
      "một cách không ngừng, không có sự gián đoạn: thắng liền ba trận * đọc liền một mạch cho đến hết * nhiều đêm liền không ngủ",
    example:
      "thắng liền ba trận * đọc liền một mạch cho đến hết * nhiều đêm liền không ngủ",
  },
  {
    word: "liền",
    part_of_speech: "phụ từ",
    meaning:
      "ngay lập tức: uống hết chỗ thuốc này là bệnh khỏi liền * nhận được tin liền đi ngay",
    example:
      "uống hết chỗ thuốc này là bệnh khỏi liền * nhận được tin liền đi ngay",
  },
  {
    word: "bấy lâu",
    part_of_speech: "đại từ",
    meaning:
      'khoảng thời gian dài từ lúc đã nói đến cho tới bây giờ; bao lâu nay: ao ước bấy lâu nay * "Bấy lâu nghe tiếng má đào, Mắt xanh chẳng để ai vào, có không?" (TKiều)',
    example:
      'ao ước bấy lâu nay * "Bấy lâu nghe tiếng má đào, Mắt xanh chẳng để ai vào, có không?" (TKiều)',
  },
  {
    word: "bây nhiêu",
    part_of_speech: "đại từ",
    meaning:
      "số lượng đã xác định cụ thể hiện đang nói đến; ngần này, từng này: chỉ có bây nhiêu tiền thôi * tưởng nhiều chứ bây nhiêu thì nhằm nhò gì!",
    example:
      "chỉ có bây nhiêu tiền thôi * tưởng nhiều chứ bây nhiêu thì nhằm nhò gì!",
  },
  {
    word: "bấy nay",
    part_of_speech: "đại từ",
    meaning:
      'khoảng thời gian từ lúc đã nói đến cho tới ngày nay: hoài bão bấy nay hằng ấp ủ * "Xót nàng còn chút song thân, Bấy nay kẻ Việt người Tần cách xa." (TKiều)',
    example:
      'hoài bão bấy nay hằng ấp ủ * "Xót nàng còn chút song thân, Bấy nay kẻ Việt người Tần cách xa." (TKiều)',
  },
  {
    word: "bầy nhầy",
    part_of_speech: "tính từ",
    meaning:
      "nhơn nhớt và dinh dính, gây cảm giác kinh tởm: đờm dãi bầy nhầy * một bãi bầy nhầy cà chua nát bét",
    example: "đờm dãi bầy nhầy * một bãi bầy nhầy cà chua nát bét",
  },
  {
    word: "bầy nhầy",
    part_of_speech: "tính từ",
    meaning:
      "(thịt) mềm nhão và bùng nhùng, thường rất dai, khó làm cho đứt: miếng thịt bụng bầy nhầy",
    example: "miếng thịt bụng bầy nhầy",
  },
  {
    word: "bầy nhầy",
    part_of_speech: "tính từ",
    meaning:
      '(khẩu ngữ) nhùng nhằng, không dứt khoát: ăn nói bầy nhầy * "Đem tiền mua lấy cái say, Hơi men dở giọng bầy nhầy bên tai." (ca dao)',
    example:
      'ăn nói bầy nhầy * "Đem tiền mua lấy cái say, Hơi men dở giọng bầy nhầy bên tai." (ca dao)',
  },
  {
    word: "bấy nhiêu",
    part_of_speech: "đại từ",
    meaning:
      'số lượng đã nói đến; ngần ấy: "Ai ơi đừng bỏ ruộng hoang, Bao nhiêu tấc đất tấc vàng bấy nhiêu." (ca dao)',
    example:
      'Ai ơi đừng bỏ ruộng hoang, Bao nhiêu tấc đất tấc vàng bấy nhiêu." (ca dao)',
  },
  {
    word: "bầy trẻ",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ, khẩu ngữ) bọn trẻ trong nhà (cha mẹ dùng để gọi con cái một cách thân mật): bầy trẻ nhà tôi * má bầy trẻ đã về đó hả?",
    example: "bầy trẻ nhà tôi * má bầy trẻ đã về đó hả?",
  },
  {
    word: "bè",
    part_of_speech: "danh từ",
    meaning:
      'khối hình tấm gồm nhiều thân cây (tre, nứa, gỗ, v.v.) được kết lại với nhau, tạo thành vật nổi để chuyển đi hoặc dùng làm phương tiện vận chuyển trên sông nước: bè gỗ lim * ghép tre thành bè * "Lòng anh như mảng bè trôi, Chỉ về một bến, chỉ xuôi một chiều." (NgBính; 8)',
    example:
      'bè gỗ lim * ghép tre thành bè * "Lòng anh như mảng bè trôi, Chỉ về một bến, chỉ xuôi một chiều." (NgBính; 8)',
  },
  {
    word: "bè",
    part_of_speech: "danh từ",
    meaning: "đám lớn các cây cỏ kết lại, nổi trên mặt nước: thả bè rau muống",
    example: "thả bè rau muống",
  },
  {
    word: "bè",
    part_of_speech: "danh từ",
    meaning:
      "nhóm người kết với nhau, thường để làm việc không chính đáng: kết bè kết đảng * về bè với bọn xấu làm bậy",
    example: "kết bè kết đảng * về bè với bọn xấu làm bậy",
  },
  {
    word: "bè",
    part_of_speech: "danh từ",
    meaning:
      "phần nhạc dùng cho một hoặc nhiều nhạc khí cùng loại trong dàn nhạc, hay cho một hoặc nhiều giọng cùng loại trong dàn hợp xướng: biểu diễn một bản nhạc ba bè",
    example: "biểu diễn một bản nhạc ba bè",
  },
  {
    word: "bè",
    part_of_speech: "tính từ",
    meaning:
      "có bề ngang rất rộng (thường nói về thân thể hoặc bộ phận của thân thể): cằm vuông bè * bàn chân to và bè ra * dáng người hơi bè",
    example: "cằm vuông bè * bàn chân to và bè ra * dáng người hơi bè",
  },
  {
    word: "bẻ",
    part_of_speech: "động từ",
    meaning:
      "gập lại làm cho gãy: bẻ chiếc đũa làm đôi * bẻ ngô * mười bảy bẻ gẫy sừng trâu (tng)",
    example: "bẻ chiếc đũa làm đôi * bẻ ngô * mười bảy bẻ gẫy sừng trâu (tng)",
  },
  {
    word: "bẻ",
    part_of_speech: "động từ",
    meaning:
      "gập lại làm cho đổi sang hướng khác: bẻ cổ áo * một đầu thanh sắt bị bẻ gập xuống * hai tay bị bẻ quặt ra sau",
    example:
      "bẻ cổ áo * một đầu thanh sắt bị bẻ gập xuống * hai tay bị bẻ quặt ra sau",
  },
  {
    word: "bẻ",
    part_of_speech: "động từ",
    meaning: "nói vặn lại để bác đi: nói có lí không ai bẻ được",
    example: "nói có lí không ai bẻ được",
  },
  {
    word: "bẽ",
    part_of_speech: "tính từ",
    meaning:
      '(Khẩu ngữ) thẹn, ngượng, vì cảm thấy bị người ta cười chê: "Trinh hơi bẽ, hai má nóng bừng. Nàng nghẹn ngào chỉ muốn oà lên khóc (...)" (ThLam; 3)',
    example:
      'Trinh hơi bẽ, hai má nóng bừng. Nàng nghẹn ngào chỉ muốn oà lên khóc (...)" (ThLam; 3)',
  },
  {
    word: "be",
    part_of_speech: "danh từ",
    meaning:
      'đồ đựng rượu có bầu tròn, cổ dài, thường bằng sành hay sứ: "Rượu ngon chẳng nệ be sành, Áo rách khéo vá hơn lành vụng may." (Cdao)',
    example:
      'Rượu ngon chẳng nệ be sành, Áo rách khéo vá hơn lành vụng may." (Cdao)',
  },
  {
    word: "be",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ) mạn thuyền, tàu: be thuyền",
    example: "be thuyền",
  },
  {
    word: "be",
    part_of_speech: "động từ",
    meaning:
      'đắp đất thành bờ, để ngăn nước: be con chạch * "Công anh đắp đập be bờ, Để cho người khác đem lờ đến đơm." (Cdao)',
    example:
      'be con chạch * "Công anh đắp đập be bờ, Để cho người khác đem lờ đến đơm." (Cdao)',
  },
  {
    word: "be",
    part_of_speech: "động từ",
    meaning:
      "dùng bàn tay hoặc vật gì tạo ra bờ cao trên miệng đấu, miệng thùng để đong cho đầy thêm: lấy tay be miệng đấu khi đong",
    example: "lấy tay be miệng đấu khi đong",
  },
  {
    word: "be",
    part_of_speech: "động từ",
    meaning: "(Khẩu ngữ) kêu ầm lên: động một tí là mụ lại be lên",
    example: "động một tí là mụ lại be lên",
  },
  {
    word: "be",
    part_of_speech: "tính từ",
    meaning:
      "(màu) gần như màu cà phê sữa nhạt: cái áo màu be * tường sơn màu be",
    example: "cái áo màu be * tường sơn màu be",
  },
  {
    word: "bé",
    part_of_speech: "tính từ",
    meaning:
      "có kích thước hoặc thể tích không đáng kể, hoặc kém hơn so với nhiều cái cùng loại: chữ bé như con kiến * bàn tay bé xíu * cá lớn nuốt cá bé (tng)",
    example: "chữ bé như con kiến * bàn tay bé xíu * cá lớn nuốt cá bé (tng)",
  },
  {
    word: "bé",
    part_of_speech: "tính từ",
    meaning: "rất ít tuổi, còn non trẻ: thuở bé * được cưng chiều từ bé",
    example: "thuở bé * được cưng chiều từ bé",
  },
  {
    word: "bé",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (âm thanh) rất khẽ, phải chú ý mới nghe thấy: nói bé quá, nghe không rõ * bé cái mồm thôi!",
    example: "nói bé quá, nghe không rõ * bé cái mồm thôi!",
  },
  {
    word: "bé",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để gọi hoặc chỉ em nhỏ một cách âu yếm: bé lại đây với mẹ nào!",
    example: "bé lại đây với mẹ nào!",
  },
  {
    word: "bẹ",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận xoà rộng ra ở gốc lá của một số loại cây, thường ôm lấy thân cây: bẹ ngô * bẹ cau * bẹ chuối",
    example: "bẹ ngô * bẹ cau * bẹ chuối",
  },
  {
    word: "bẹ",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) ngô: cháo bẹ rau măng",
    example: "cháo bẹ rau măng",
  },
  {
    word: "bẽ bàng",
    part_of_speech: "tính từ",
    meaning:
      '(Văn chương) hổ thẹn và buồn tủi vì cảm thấy bị người ta chê cười: "Bẽ bàng mây sớm đèn khuya, Nửa tình, nửa cảnh như chia tấm lòng." (TKiều)',
    example:
      'Bẽ bàng mây sớm đèn khuya, Nửa tình, nửa cảnh như chia tấm lòng." (TKiều)',
  },
  {
    word: "bè bạn",
    part_of_speech: "danh từ",
    meaning: "như bạn bè: tình bè bạn",
    example: "tình bè bạn",
  },
  {
    word: "bẻ bai",
    part_of_speech: "động từ",
    meaning:
      "vừa chê bai, vừa bắt bẻ từng tí một: hơi một tí là bẻ bai * bẻ bai lẫn nhau",
    example: "hơi một tí là bẻ bai * bẻ bai lẫn nhau",
  },
  {
    word: "bẻ bai",
    part_of_speech: "tính từ",
    meaning:
      '(cũ, văn chương) du dương, réo rắt: "Bẻ bai, rủ rỉ tiếng tơ, Trầm bay nhạt khói, gió đưa lay rèm." (TKiều)',
    example:
      'Bẻ bai, rủ rỉ tiếng tơ, Trầm bay nhạt khói, gió đưa lay rèm." (TKiều)',
  },
  {
    word: "be bé",
    part_of_speech: "tính từ",
    meaning:
      '(kích thước, âm thanh) hơi bé: túp lều be bé * "Những âm thanh chỉ be bé, mơ hồ, gần như hư không." (THoài; 35)',
    example:
      'túp lều be bé * "Những âm thanh chỉ be bé, mơ hồ, gần như hư không." (THoài; 35)',
  },
  {
    word: "be be",
    part_of_speech: "động từ",
    meaning: "từ mô phỏng tiếng dê, cừu kêu: con dê kêu be be",
    example: "con dê kêu be be",
  },
  {
    word: "bè cánh",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp gồm những người kết với nhau, thường để làm những việc không chính đáng (nói khái quát): kéo bè cánh để trù dập người khác * cùng bè cánh với nhau",
    example: "kéo bè cánh để trù dập người khác * cùng bè cánh với nhau",
  },
  {
    word: "bé bỏng",
    part_of_speech: "tính từ",
    meaning:
      "bé và non, yếu (nói khái quát): chú chim non bé bỏng * đôi bàn tay bé bỏng",
    example: "chú chim non bé bỏng * đôi bàn tay bé bỏng",
  },
  {
    word: "bè bè",
    part_of_speech: "tính từ",
    meaning:
      "có bề ngang rộng quá mức bình thường, làm mất cân đối, trông rất khó coi: mặt to bè bè * tấm lưng bè bè",
    example: "mặt to bè bè * tấm lưng bè bè",
  },
  {
    word: "bé dại",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như nhỏ dại: con còn bé dại",
    example: "con còn bé dại",
  },
  {
    word: "be bét",
    part_of_speech: "tính từ",
    meaning:
      "bị giập nát đến mức không còn hình thù gì nữa: ruộng lúa bị giẫm be bét * quả chuối nát be nát bét",
    example: "ruộng lúa bị giẫm be bét * quả chuối nát be nát bét",
  },
  {
    word: "be bét",
    part_of_speech: "tính từ",
    meaning:
      "(tình trạng sai sót, hư hỏng) nhiều và tồi tệ hết sức: rượu chè be bét * tính sai be bét * sự việc be bét hết cả",
    example: "rượu chè be bét * tính sai be bét * sự việc be bét hết cả",
  },
  {
    word: "be bét",
    part_of_speech: "tính từ",
    meaning: "như bê bết: chân tay lấm bùn be bét * mặt mũi be bét những máu",
    example: "chân tay lấm bùn be bét * mặt mũi be bét những máu",
  },
  {
    word: "bẻ cò",
    part_of_speech: "động từ",
    meaning:
      'bẻ gập lại thành từng khúc để ghi số đếm (mỗi khúc là một lần): "Hai tay cầm nắm lạt bẻ cò, Lòng anh thương da diết, sao em giả đò làm lơ?" (ca dao)',
    example:
      'Hai tay cầm nắm lạt bẻ cò, Lòng anh thương da diết, sao em giả đò làm lơ?" (ca dao)',
  },
  {
    word: "bẻ hành bẻ tỏi",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tìm cách vặn vẹo, bắt bẻ hết điều này đến điều khác, gây phiền phức, khó chịu: hơi một tí là bẻ hành bẻ tỏi!",
    example: "hơi một tí là bẻ hành bẻ tỏi!",
  },
  {
    word: "bè đảng",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức gồm những người liên kết với nhau để tranh giành quyền lợi, ảnh hưởng (nói khái quát): kéo thành bè đảng",
    example: "kéo thành bè đảng",
  },
  {
    word: "bé con",
    part_of_speech: "danh từ",
    meaning: "đứa bé, đứa trẻ: bé con của mẹ! * thằng bé con",
    example: "bé con của mẹ! * thằng bé con",
  },
  {
    word: "bé con",
    part_of_speech: "tính từ",
    meaning:
      'bé, nhỏ: mảnh giấy bé con * "Nghĩa ngầm phục đầu óc bé con của cái Hạnh hay nghĩ ra những điều bất ngờ." (DHướng; 1)',
    example:
      'mảnh giấy bé con * "Nghĩa ngầm phục đầu óc bé con của cái Hạnh hay nghĩ ra những điều bất ngờ." (DHướng; 1)',
  },
  {
    word: "bé hạt tiêu",
    part_of_speech: "",
    meaning:
      'bé nhỏ, nhưng tinh khôn, già dặn: "Bé nhưng mà bé hạt tiêu, Bé cay bé đắng bé xiêu lòng người." (ca dao)',
    example:
      'Bé nhưng mà bé hạt tiêu, Bé cay bé đắng bé xiêu lòng người." (ca dao)',
  },
  {
    word: "bé hoẻn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) bé, nhỏ đến mức coi như không đáng kể: mảnh sân bé hoẻn",
    example: "mảnh sân bé hoẻn",
  },
  {
    word: "bẻ khục",
    part_of_speech: "động từ",
    meaning:
      "bẻ gập các đốt xương cho kêu thành tiếng, để cho đỡ mỏi: bẻ khục năm ngón tay",
    example: "bẻ khục năm ngón tay",
  },
  {
    word: "bé nhỏ",
    part_of_speech: "tính từ",
    meaning:
      "bé (nói khái quát): đôi bàn tay bé nhỏ, xinh xắn * niềm vui bé nhỏ",
    example: "đôi bàn tay bé nhỏ, xinh xắn * niềm vui bé nhỏ",
  },
  {
    word: "bẻ khoá",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) dùng kĩ thuật lập trình làm cho mã số hoặc mật khẩu của người khác mất tác dụng bảo vệ: chương trình đã bị bẻ khoá và sao chép lậu",
    example: "chương trình đã bị bẻ khoá và sao chép lậu",
  },
  {
    word: "bé mọn",
    part_of_speech: "tính từ",
    meaning: "bé nhỏ và thấp kém: vật bé mọn * bụng dạ bé mọn(b)",
    example: "vật bé mọn * bụng dạ bé mọn(b)",
  },
  {
    word: "bè lũ",
    part_of_speech: "danh từ",
    meaning:
      "lũ người kết với nhau để làm những việc xấu xa (nói khái quát): bè lũ tay sai bán nước",
    example: "bè lũ tay sai bán nước",
  },
  {
    word: "bẹ mèo",
    part_of_speech: "danh từ",
    meaning: "bẹ (cau, chuối) còn non: cây cau mới có bẹ mèo",
    example: "cây cau mới có bẹ mèo",
  },
  {
    word: "bè phái",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp gồm những người vì quyền lợi riêng hoặc quan điểm hẹp hòi mà kết với nhau, gây chia rẽ trong nội bộ tổ chức: chia thành nhiều bè phái * năm bè bảy phái",
    example: "chia thành nhiều bè phái * năm bè bảy phái",
  },
  {
    word: "bè phái",
    part_of_speech: "tính từ",
    meaning:
      "có xu hướng gây chia rẽ trong nội bộ tổ chức: tư tưởng bè phái * óc bè phái",
    example: "tư tưởng bè phái * óc bè phái",
  },
  {
    word: "bẽ mặt",
    part_of_speech: "tính từ",
    meaning:
      "cảm thấy bị mất thể diện trước người khác, không còn mặt mũi nào nữa: mắng cho bẽ mặt * bị bẽ mặt một phen",
    example: "mắng cho bẽ mặt * bị bẽ mặt một phen",
  },
  {
    word: "bé xé ra to",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) (điều, chuyện) không đáng kể nhưng lại làm thành to, thành nghiêm trọng: chuyện bé xé ra to",
    example: "chuyện bé xé ra to",
  },
  {
    word: "bẹn",
    part_of_speech: "danh từ",
    meaning: "chỗ nếp gấp giữa đùi và bụng dưới: quần xắn đến tận bẹn",
    example: "quần xắn đến tận bẹn",
  },
  {
    word: "bén",
    part_of_speech: "động từ",
    meaning: "chạm tới: chân bước không bén đất",
    example: "chân bước không bén đất",
  },
  {
    word: "bén",
    part_of_speech: "động từ",
    meaning:
      "bắt đầu tác động hay chịu tác động: củi bén lửa * lửa gần rơm lâu ngày cũng bén (tng)",
    example: "củi bén lửa * lửa gần rơm lâu ngày cũng bén (tng)",
  },
  {
    word: "bén",
    part_of_speech: "động từ",
    meaning: "(cây trồng) bắt đầu bám vào đất: mạ đã bén rễ",
    example: "mạ đã bén rễ",
  },
  {
    word: "bén",
    part_of_speech: "động từ",
    meaning:
      'bắt đầu quen, bắt đầu gắn bó: con bén hơi mẹ * bén duyên * "Trót vì cầm đã bén dây, Chẳng trăm năm cũng một ngày duyên ta." (TKiều)',
    example:
      'con bén hơi mẹ * bén duyên * "Trót vì cầm đã bén dây, Chẳng trăm năm cũng một ngày duyên ta." (TKiều)',
  },
  {
    word: "bén",
    part_of_speech: "tính từ",
    meaning: "(Phương ngữ) sắc: bén như dao cau",
    example: "bén như dao cau",
  },
  {
    word: "bèn",
    part_of_speech: "phụ từ",
    meaning:
      "(làm việc gì) liền ngay sau một trạng thái, một sự việc nào đó, nhằm đáp ứng hay thoả mãn điều gì: giận quá, bèn đứng dậy bỏ đi * thấy ưng ý bèn mua ngay",
    example: "giận quá, bèn đứng dậy bỏ đi * thấy ưng ý bèn mua ngay",
  },
  {
    word: "bèn bẹt",
    part_of_speech: "tính từ",
    meaning:
      '(hình khối, âm thanh) hơi bẹt: khuôn mặt trông hơi bèn bẹt * "Anh vừa quát vừa vỗ tay xuống hè bèn bẹt." (NCao; 4)',
    example:
      'khuôn mặt trông hơi bèn bẹt * "Anh vừa quát vừa vỗ tay xuống hè bèn bẹt." (NCao; 4)',
  },
  {
    word: "bén mảng",
    part_of_speech: "động từ",
    meaning:
      '(Khẩu ngữ) lại gần nơi không phải là nơi để cho mình đến: không dám bén mảng tới nữa * "Bận sau mà còn bén mảng đến trêu con ông thì toi mạng sớm!" (THoài; 34)',
    example:
      'không dám bén mảng tới nữa * "Bận sau mà còn bén mảng đến trêu con ông thì toi mạng sớm!" (THoài; 34)',
  },
  {
    word: "bẻm mép",
    part_of_speech: "tính từ",
    meaning:
      "khéo miệng và nói nhiều, thường không thật (hàm ý chê): thằng cha bẻm mép lắm * chỉ được cái bẻm mép! (tiếng trách mắng)",
    example: "thằng cha bẻm mép lắm * chỉ được cái bẻm mép! (tiếng trách mắng)",
  },
  {
    word: "bén gót",
    part_of_speech: "động từ",
    meaning: "(hiếm) theo sát phía sau, không rời: bị địch đuổi bén gót",
    example: "bị địch đuổi bén gót",
  },
  {
    word: "bén gót",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) theo kịp, sánh kịp: mày làm sao mà bén gót nó được!",
    example: "mày làm sao mà bén gót nó được!",
  },
  {
    word: "bẽn lẽn",
    part_of_speech: "tính từ",
    meaning:
      "có dáng điệu rụt rè, thiếu tự nhiên vì e thẹn hoặc vì chưa quen: vẻ mặt bẽn lẽn * bẽn lẽn như cô dâu mới về nhà chồng",
    example: "vẻ mặt bẽn lẽn * bẽn lẽn như cô dâu mới về nhà chồng",
  },
  {
    word: "bèo",
    part_of_speech: "danh từ",
    meaning:
      "cây sống nổi trên mặt nước, có nhiều loài khác nhau, thường dùng làm thức ăn cho lợn hoặc làm phân xanh: vớt bèo * thả bèo",
    example: "vớt bèo * thả bèo",
  },
  {
    word: "bèo",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) quá rẻ, ví như bèo: năm nay trúng mùa lúa nhưng giá lại bèo quá!",
    example: "năm nay trúng mùa lúa nhưng giá lại bèo quá!",
  },
  {
    word: "béng",
    part_of_speech: "phụ từ",
    meaning:
      "(thông tục) (làm việc gì) ngay lập tức, nhanh và gọn, cốt cho xong: làm béng đi cho yên * nhận béng cho xong",
    example: "làm béng đi cho yên * nhận béng cho xong",
  },
  {
    word: "béng",
    part_of_speech: "phụ từ",
    meaning:
      '(mất, quên) một cách rất nhanh và không còn lại một chút gì: mất béng cái đồng hồ * "Ở nhà đã hỏi đường cẩn thận rồi, nhưng đến một ngã ba, lại quên béng mất, không biết phải rẽ lối nào." (NCao; 8)',
    example:
      'mất béng cái đồng hồ * "Ở nhà đã hỏi đường cẩn thận rồi, nhưng đến một ngã ba, lại quên béng mất, không biết phải rẽ lối nào." (NCao; 8)',
  },
  {
    word: "bèo bọt",
    part_of_speech: "danh từ",
    meaning:
      'bèo và bọt (nói khái quát); ví thân phận người phụ nữ hèn mọn, không nơi nương tựa: "Rộng thương nội cỏ hoa hèn, Chút thân bèo bọt dám phiền mai sau!" (TKiều)',
    example:
      'Rộng thương nội cỏ hoa hèn, Chút thân bèo bọt dám phiền mai sau!" (TKiều)',
  },
  {
    word: "bèo bọt",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) rất rẻ mạt, ví như bèo như bọt: công cán bèo bọt",
    example: "công cán bèo bọt",
  },
  {
    word: "béo",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) véo: béo vào má",
    example: "béo vào má",
  },
  {
    word: "béo",
    part_of_speech: "tính từ",
    meaning:
      "(cơ thể người, động vật) có nhiều mỡ: con lợn béo * càng ngày càng béo ra * béo như con cun cút",
    example: "con lợn béo * càng ngày càng béo ra * béo như con cun cút",
  },
  {
    word: "béo",
    part_of_speech: "tính từ",
    meaning: "có tính chất của mỡ, của dầu thực vật: chất béo",
    example: "chất béo",
  },
  {
    word: "béo",
    part_of_speech: "tính từ",
    meaning:
      "(thức ăn) có nhiều chất béo: phở chan nhiều nước béo * mùi thức ăn béo ngậy",
    example: "phở chan nhiều nước béo * mùi thức ăn béo ngậy",
  },
  {
    word: "béo",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) (đất) màu mỡ: đất béo",
    example: "đất béo",
  },
  {
    word: "béo",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) đem lại nhiều lợi ích (cho đối tượng không xứng đáng): chỉ béo bọn con buôn * đục nước béo cò (tng)",
    example: "chỉ béo bọn con buôn * đục nước béo cò (tng)",
  },
  {
    word: "bén ngót",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) sắc ngọt: con dao cau bén ngót",
    example: "con dao cau bén ngót",
  },
  {
    word: "beo",
    part_of_speech: "động từ",
    meaning: "(phương ngữ): beo một cái thật đau",
    example: "beo một cái thật đau",
  },
  {
    word: "beo",
    part_of_speech: "tính từ",
    meaning: "gầy tóp lại và nhăn nhúm: bụng ỏng, đít beo",
    example: "bụng ỏng, đít beo",
  },
  {
    word: "bẹo",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) véo: bẹo má * bẹo một cái rõ đau",
    example: "bẹo má * bẹo một cái rõ đau",
  },
  {
    word: "béo bở",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) dễ mang lại nhiều lợi, dễ sinh lợi: miếng mồi béo bở",
    example: "miếng mồi béo bở",
  },
  {
    word: "bẻo lẻo",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) nhanh mồm, nhanh miệng và thích nói nhiều (hàm ý chê): suốt ngày chỉ bẻo lẻo cái mồm",
    example: "suốt ngày chỉ bẻo lẻo cái mồm",
  },
  {
    word: "bèo mây",
    part_of_speech: "",
    meaning:
      '(cũ, văn chương) (thân phận người phụ nữ) lênh đênh, trôi nổi vô định, không nơi nương tựa (như cánh bèo trôi dạt trên mặt nước, đám mây lửng lơ trên bầu trời): "Lênh đênh chút phận bèo mây, Duyên kia đã vậy thân này nương đâu?" (ATV)',
    example:
      'Lênh đênh chút phận bèo mây, Duyên kia đã vậy thân này nương đâu?" (ATV)',
  },
  {
    word: "béo mỡ",
    part_of_speech: "tính từ",
    meaning:
      "(thông tục) hay đùa bỡn quá đáng, tựa như là thừa sức lực mà chẳng biết làm gì: chúng mày béo mỡ hay sao mà đùa khiếp thế!",
    example: "chúng mày béo mỡ hay sao mà đùa khiếp thế!",
  },
  {
    word: "bèo hợp mây tan",
    part_of_speech: "",
    meaning:
      '(văn chương) ví sự gặp gỡ hay biệt li không biết trước được (tựa như bèo và mây, hợp đấy rồi lại tan ngay đấy): "Rồi đây bèo hợp mây tan, Biết đâu hạc nội, mây ngàn là đâu?" (TKiều)',
    example:
      'Rồi đây bèo hợp mây tan, Biết đâu hạc nội, mây ngàn là đâu?" (TKiều)',
  },
  {
    word: "bèo nhèo",
    part_of_speech: "tính từ",
    meaning: "(thịt) mềm nhão và nhăn nheo: miếng thịt bèo nhèo",
    example: "miếng thịt bèo nhèo",
  },
  {
    word: "béo múp",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) béo đến mức căng tròn: con lợn béo múp * bàn tay béo múp",
    example: "con lợn béo múp * bàn tay béo múp",
  },
  {
    word: "béo núc",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) béo đến mức căng tròn, trông như đầy những thịt: con bò béo núc",
    example: "con bò béo núc",
  },
  {
    word: "béo quay",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) béo đến mức trông như tròn xoay ra: con lợn béo quay * người càng ngày càng béo quay ra",
    example: "con lợn béo quay * người càng ngày càng béo quay ra",
  },
  {
    word: "béo nung núc",
    part_of_speech: "tính từ",
    meaning: "như béo núc (nhưng ý nhấn mạnh hơn): người béo nung núc",
    example: "người béo nung núc",
  },
  {
    word: "béo tốt",
    part_of_speech: "tính từ",
    meaning: "béo và khoẻ (nói khái quát): người béo tốt, khoẻ mạnh",
    example: "người béo tốt, khoẻ mạnh",
  },
  {
    word: "bèo trôi sóng vỗ",
    part_of_speech: "",
    meaning:
      '(văn chương) ví cảnh (người phụ nữ) lưu lạc, bị đoạ đày khổ sở (tựa như cánh bèo trôi dạt trên dòng nước bị sóng dồi lúc chìm, lúc nổi): "Từ con lưu lạc quê người, Bèo trôi sóng vỗ, chốc mười lăm năm." (TKiều)',
    example:
      'Từ con lưu lạc quê người, Bèo trôi sóng vỗ, chốc mười lăm năm." (TKiều)',
  },
  {
    word: "bét",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ở bậc thấp nhất về thứ hạng trong sự phân loại, đánh giá: đứng bét lớp * vé hạng bét * bài thi này, bét ra cũng phải được tám điểm",
    example:
      "đứng bét lớp * vé hạng bét * bài thi này, bét ra cũng phải được tám điểm",
  },
  {
    word: "bét",
    part_of_speech: "tính từ",
    meaning:
      "(tình trạng sai sót, hư hỏng) ở mức rất tồi tệ: tính sai bét * hỏng bét * tưởng đủ, ai ngờ thiếu bét",
    example: "tính sai bét * hỏng bét * tưởng đủ, ai ngờ thiếu bét",
  },
  {
    word: "bẹp",
    part_of_speech: "tính từ",
    meaning:
      "(vật có hình khối) bị dẹp xuống, thể tích nhỏ hẳn đi do tác động của lực ép: quả bóng hết hơi, bẹp dí * cái nón bị giẫm bẹp * vo tròn bóp bẹp (tng)",
    example:
      "quả bóng hết hơi, bẹp dí * cái nón bị giẫm bẹp * vo tròn bóp bẹp (tng)",
  },
  {
    word: "bẹp",
    part_of_speech: "tính từ",
    meaning:
      "ở tình trạng mất hết khả năng vận động, tiến triển, tựa như bị ép chặt vào một nơi: bị ốm, nằm bẹp ở nhà",
    example: "bị ốm, nằm bẹp ở nhà",
  },
  {
    word: "bét be",
    part_of_speech: "tính từ",
    meaning:
      'như be bét: sai bét be * "Thôi thôi sự đã chán phè, Vườn hành gà bới bét be ra rồi." (ca dao)',
    example:
      'sai bét be * "Thôi thôi sự đã chán phè, Vườn hành gà bới bét be ra rồi." (ca dao)',
  },
  {
    word: "bét tĩ",
    part_of_speech: "tính từ",
    meaning:
      "(thông tục) bét nhất, kém nhất (hàm ý khinh): thua bét tĩ * hạng bét tĩ",
    example: "thua bét tĩ * hạng bét tĩ",
  },
  {
    word: "bét nhè",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) quá say, đến mức như không còn biết gì nữa: say bét nhè * uống một trận bét nhè",
    example: "say bét nhè * uống một trận bét nhè",
  },
  {
    word: "bép xép",
    part_of_speech: "động từ",
    meaning:
      "hay nói ra những điều cần giữ kín mà mình nghe được: có tật bép xép * đừng có bép xép!",
    example: "có tật bép xép * đừng có bép xép!",
  },
  {
    word: "bê",
    part_of_speech: "danh từ",
    meaning: "bò con: thịt bê",
    example: "thịt bê",
  },
  {
    word: "bê",
    part_of_speech: "động từ",
    meaning:
      "mang (thường là vật nặng) bằng hai tay đưa ra phía trước, thường không nhấc cao: bê mâm bát * bê bàn ghế ra sân",
    example: "bê mâm bát * bê bàn ghế ra sân",
  },
  {
    word: "bê",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đưa nguyên cái có sẵn vào trong nội dung của bài viết, tác phẩm hay của bất kì công việc gì một cách sống sượng: bê khẩu hiệu vào thơ",
    example: "bê khẩu hiệu vào thơ",
  },
  {
    word: "bẹt",
    part_of_speech: "tính từ",
    meaning:
      "(hình khối) có bề mặt rộng, không dày, trông như bị ép xuống: giày mũi bẹt * đập cho bẹt ra * đầu bẹt như đầu cá trê",
    example: "giày mũi bẹt * đập cho bẹt ra * đầu bẹt như đầu cá trê",
  },
  {
    word: "bẹt",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng như tiếng của vật dẹp mình rơi mạnh xuống đất: đám vữa rơi bẹt xuống nền * ném bẹt đồng xu xuống đất",
    example: "đám vữa rơi bẹt xuống nền * ném bẹt đồng xu xuống đất",
  },
  {
    word: "bế",
    part_of_speech: "động từ",
    meaning:
      "mang người, động vật bằng cách dùng tay đỡ và giữ cho sát vào người: bế em * bế mèo trên tay",
    example: "bế em * bế mèo trên tay",
  },
  {
    word: "bể",
    part_of_speech: "danh từ",
    meaning:
      '(nhất là Bắc) biển: "Tìm em như thể tìm chim, Chim ăn bể bắc đi tìm bể đông." (ca dao)',
    example: "Tìm em như thể tìm chim, Chim ăn bể bắc đi tìm bể đông.",
  },
  {
    word: "bể",
    part_of_speech: "danh từ",
    meaning:
      "vật có thể tích lớn để chứa chất lỏng, thường được xây dựng hoặc làm bằng kim loại: bể xăng * bể cá vàng * bể đựng nước",
    example: "bể xăng * bể cá vàng * bể đựng nước",
  },
  {
    word: "bể",
    part_of_speech: "động từ",
    meaning: "(Nam) vỡ: té bể đầu",
    example: "té bể đầu",
  },
  {
    word: "bề",
    part_of_speech: "danh từ",
    meaning:
      "khoảng cách giữa hai cạnh, hai mặt hoặc hai đầu đối nhau của một hình, một vật, tạo nên giới hạn của hình hoặc vật ấy: bề cao * bề dài * bề rộng * một đất nước có bề dày lịch sử (b)",
    example: "bề cao * bề dài * bề rộng * một đất nước có bề dày lịch sử (b)",
  },
  {
    word: "bề",
    part_of_speech: "danh từ",
    meaning:
      "một trong các phía xung quanh, giới hạn phạm vi của một vật: nhà hình ống, ba bề xây tường kín mít",
    example: "nhà hình ống, ba bề xây tường kín mít",
  },
  {
    word: "bề",
    part_of_speech: "danh từ",
    meaning:
      'khía cạnh, phương diện của sự việc: cực khổ trăm bề * dễ bề làm ăn * liệu bề khuyên bảo nhau * "Kiều càng sắc sảo mặn mà, So bề tài sắc, lại là phần hơn." (TKiều)',
    example:
      'cực khổ trăm bề * dễ bề làm ăn * liệu bề khuyên bảo nhau * "Kiều càng sắc sảo mặn mà, So bề tài sắc, lại là phần hơn." (TKiều)',
  },
  {
    word: "bệ",
    part_of_speech: "danh từ",
    meaning:
      "chỗ được xây, đắp hoặc kê cho cao lên để làm nơi đặt vật gì: bệ bắn * bức tượng đặt trên bệ đá",
    example: "bệ bắn * bức tượng đặt trên bệ đá",
  },
  {
    word: "bệ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) như bê (nhưng nghĩa mạnh hơn): bệ nguyên cả đoạn văn của người khác vào bài viết của mình",
    example: "bệ nguyên cả đoạn văn của người khác vào bài viết của mình",
  },
  {
    word: "bễ",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ có ống để thụt không khí vào lò cho lửa cháy: thở như kéo bễ * ống bễ",
    example: "thở như kéo bễ * ống bễ",
  },
  {
    word: "bể dâu",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) bãi biển biến thành ruộng dâu; dùng để ví sự thay đổi lớn của cuộc đời: "Trải qua một cuộc bể dâu, Những điều trông thấy mà đau đớn lòng." (TKiều)',
    example:
      'Trải qua một cuộc bể dâu, Những điều trông thấy mà đau đớn lòng." (TKiều)',
  },
  {
    word: "bề bộn",
    part_of_speech: "tính từ",
    meaning: "nhiều thứ và lộn xộn: nhà cửa bề bộn * công việc khá bề bộn",
    example: "nhà cửa bề bộn * công việc khá bề bộn",
  },
  {
    word: "bê bối",
    part_of_speech: "tính từ",
    meaning:
      "ở vào hoàn cảnh khó khăn lúng túng về nhiều mặt, khó giải quyết, thu xếp cho ổn thoả: công việc bê bối * hoàn cảnh gia đình khá bê bối",
    example: "công việc bê bối * hoàn cảnh gia đình khá bê bối",
  },
  {
    word: "bê bối",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều điều rắc rối và xấu xa, khó giải quyết cho êm đẹp: tay này bê bối lắm! * vụ việc bê bối",
    example: "tay này bê bối lắm! * vụ việc bê bối",
  },
  {
    word: "bề bề",
    part_of_speech: "tính từ",
    meaning:
      "nhiều lắm, cái nọ tiếp liền cái kia: công việc bề bề * ruộng bề bề không bằng một nghề trong tay (tng)",
    example:
      "công việc bề bề * ruộng bề bề không bằng một nghề trong tay (tng)",
  },
  {
    word: "bế bồng",
    part_of_speech: "động từ",
    meaning:
      "bế trẻ em (nói khái quát): bồng bế con cái * cùng quẫn, phải bồng bế nhau đi ăn mày",
    example: "bồng bế con cái * cùng quẫn, phải bồng bế nhau đi ăn mày",
  },
  {
    word: "bê bết",
    part_of_speech: "tính từ",
    meaning:
      "bị dây dính nhiều và chỗ nào cũng có: quần áo bê bết dầu mỡ * máu me bê bết * bùn đất lấm bê lấm bết",
    example: "quần áo bê bết dầu mỡ * máu me bê bết * bùn đất lấm bê lấm bết",
  },
  {
    word: "bê bết",
    part_of_speech: "tính từ",
    meaning:
      "ở tình trạng yếu kém đến mức tồi tệ, không tiến lên được: công việc bê bết * bị một trận ốm bê bết",
    example: "công việc bê bết * bị một trận ốm bê bết",
  },
  {
    word: "bê bết",
    part_of_speech: "tính từ",
    meaning: "bệ rạc hết sức: rượu chè bê bết",
    example: "rượu chè bê bết",
  },
  {
    word: "bề dưới",
    part_of_speech: "danh từ",
    meaning:
      "địa vị cấp dưới, về mặt phải phục tùng cấp trên: bề dưới phục tùng bề trên",
    example: "bề dưới phục tùng bề trên",
  },
  {
    word: "bề mặt",
    part_of_speech: "danh từ",
    meaning:
      "phần giới hạn của một hình hoặc mặt ngoài tạo nên giới hạn của một vật: bề mặt trái đất * phủ một lớp sơn trên bề mặt gỗ",
    example: "bề mặt trái đất * phủ một lớp sơn trên bề mặt gỗ",
  },
  {
    word: "bế mạc",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) (hội nghị, triển lãm, v.v.) kết thúc: hội nghị đã bế mạc * lễ bế mạc",
    example: "hội nghị đã bế mạc * lễ bế mạc",
  },
  {
    word: "bể khổ",
    part_of_speech: "danh từ",
    meaning:
      'cuộc sống ở đời, coi như đầy nỗi khổ, theo quan niệm của đạo Phật: đời là bể khổ * "Nghĩ thân phù thế mà đau, Bọt trong bể khổ, bèo đầu bến mê." (CO)',
    example:
      'đời là bể khổ * "Nghĩ thân phù thế mà đau, Bọt trong bể khổ, bèo đầu bến mê." (CO)',
  },
  {
    word: "bề ngoài",
    part_of_speech: "danh từ",
    meaning:
      'vẻ biểu hiện ra bên ngoài, khác với thực chất: sức mạnh bề ngoài * "Bề ngoài thơn thớt nói cười, Mà trong nham hiểm giết người không dao." (TKiều)',
    example:
      'sức mạnh bề ngoài * "Bề ngoài thơn thớt nói cười, Mà trong nham hiểm giết người không dao." (TKiều)',
  },
  {
    word: "bệ hạ",
    part_of_speech: "danh từ",
    meaning: "(cũ) từ dùng để tôn xưng vua thời phong kiến: muôn tâu bệ hạ",
    example: "muôn tâu bệ hạ",
  },
  {
    word: "bệ phóng",
    part_of_speech: "danh từ",
    meaning:
      "thiết bị để đặt và phóng tên lửa hoặc bom, đạn, v.v.: tên lửa đã được đưa vào bệ phóng",
    example: "tên lửa đã được đưa vào bệ phóng",
  },
  {
    word: "bề nào cũng",
    part_of_speech: "",
    meaning:
      'dù sao cũng: "Chồng thím ấy chết thì, bề nào cũng là chết rồi, còn người ta chưa chết mà nỡ để người ta chết luôn sao." (AĐức; 20)',
    example:
      'Chồng thím ấy chết thì, bề nào cũng là chết rồi, còn người ta chưa chết mà nỡ để người ta chết luôn sao." (AĐức; 20)',
  },
  {
    word: "bế giảng",
    part_of_speech: "động từ",
    meaning: "kết thúc một khoá học, một năm học: lễ bế giảng",
    example: "lễ bế giảng",
  },
  {
    word: "bệ rồng",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) bệ đặt ngai cho vua ngồi; cũng dùng để chỉ vua: "Phạm Công tâu trước bệ rồng, Đội ơn thánh thượng đoái lòng cỏ cây." (PCCH)',
    example:
      'Phạm Công tâu trước bệ rồng, Đội ơn thánh thượng đoái lòng cỏ cây." (PCCH)',
  },
  {
    word: "bể sâu sóng cả",
    part_of_speech: "",
    meaning:
      'ví nơi vô cùng nguy hiểm: "Lỡ làng chút phận thuyền quyên, Bể sâu, sóng cả có tuyền được vay?" (TKiều)',
    example:
      'Lỡ làng chút phận thuyền quyên, Bể sâu, sóng cả có tuyền được vay?" (TKiều)',
  },
  {
    word: "bê tha",
    part_of_speech: "động từ",
    meaning: "ham mê chơi bời bậy bạ đến mức mất cả nhân cách: bê tha cờ bạc",
    example: "bê tha cờ bạc",
  },
  {
    word: "bê tha",
    part_of_speech: "tính từ",
    meaning: "bệ rạc, tồi tàn: sống vất vưởng bê tha",
    example: "sống vất vưởng bê tha",
  },
  {
    word: "bệ rạc",
    part_of_speech: "tính từ",
    meaning:
      "lôi thôi, tồi tệ đến mức ảnh hưởng tới nhân cách: nhà ở bệ rạc * sống bệ rạc",
    example: "nhà ở bệ rạc * sống bệ rạc",
  },
  {
    word: "bể sở sông ngô",
    part_of_speech: "",
    meaning:
      'nơi này nơi khác; khắp mọi nơi: "Một tay gây dựng cơ đồ, Bấy lâu bể Sở, sông Ngô tung hoành!" (TKiều)',
    example:
      'Một tay gây dựng cơ đồ, Bấy lâu bể Sở, sông Ngô tung hoành!" (TKiều)',
  },
  {
    word: "bề thế",
    part_of_speech: "danh từ",
    meaning: "quy mô, phạm vi rộng lớn: bề thế của nhà máy",
    example: "bề thế của nhà máy",
  },
  {
    word: "bề thế",
    part_of_speech: "tính từ",
    meaning: "có bề thế: gia đình bề thế * toà nhà trông rất bề thế",
    example: "gia đình bề thế * toà nhà trông rất bề thế",
  },
  {
    word: "bế tắc",
    part_of_speech: "tính từ",
    meaning:
      "(quá trình hoạt động hoặc tiến triển) bị ngừng hẳn lại, vì gặp trở ngại lớn, không có lối thoát: công việc bế tắc * lâm vào tình trạng bế tắc",
    example: "công việc bế tắc * lâm vào tình trạng bế tắc",
  },
  {
    word: "bề tôi",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người ở cương vị làm tôi, trong quan hệ với vua, chúa: một bề tôi trung thành",
    example: "một bề tôi trung thành",
  },
  {
    word: "bê trễ",
    part_of_speech: "động từ",
    meaning:
      "để công việc ứ đọng, chậm trễ lại, do không quan tâm chu đáo: công việc bê trễ",
    example: "công việc bê trễ",
  },
  {
    word: "bê tông",
    part_of_speech: "danh từ",
    meaning:
      "vật liệu xây dựng chế tạo từ hỗn hợp xi măng, cát, đá và nước, đúc vào khuôn: máy trộn bê tông * đổ bê tông",
    example: "máy trộn bê tông * đổ bê tông",
  },
  {
    word: "bề trên",
    part_of_speech: "danh từ",
    meaning:
      "địa vị cấp trên, về mặt có uy quyền đối với cấp dưới: lên giọng bề trên * người bề trên",
    example: "lên giọng bề trên * người bề trên",
  },
  {
    word: "bề trên",
    part_of_speech: "danh từ",
    meaning:
      "(thường viết hoa) chúa Trời, theo cách gọi tôn kính của người theo đạo Cơ Đốc: nhờ ơn Bề Trên",
    example: "nhờ ơn Bề Trên",
  },
  {
    word: "bệch bạc",
    part_of_speech: "tính từ",
    meaning:
      "bệch (thường nói về màu da; nói khái quát): người ốm, da dẻ bệch bạc",
    example: "người ốm, da dẻ bệch bạc",
  },
  {
    word: "bệ vệ",
    part_of_speech: "tính từ",
    meaning:
      "có bộ dạng oai nghiêm (thường chỉ nói về đàn ông): đi đứng bệ vệ * dáng người to béo, bệ vệ",
    example: "đi đứng bệ vệ * dáng người to béo, bệ vệ",
  },
  {
    word: "bệch",
    part_of_speech: "tính từ",
    meaning:
      "(màu sắc) bị phai, bị nhạt đi và ngả sang màu trắng nhợt: trắng bệch * mặt tái bệch",
    example: "trắng bệch * mặt tái bệch",
  },
  {
    word: "bên",
    part_of_speech: "danh từ",
    meaning:
      'một trong hai nơi đối với nhau (phải hoặc trái, trên hoặc dưới, trong hoặc ngoài): hai bên đường * mâu thuẫn xảy ra từ bên trong * "Hàn gia ở mé tây thiên, Dưới dòng nước chảy, bên trên có cầu." (TKiều)',
    example:
      'hai bên đường * mâu thuẫn xảy ra từ bên trong * "Hàn gia ở mé tây thiên, Dưới dòng nước chảy, bên trên có cầu." (TKiều)',
  },
  {
    word: "bên",
    part_of_speech: "danh từ",
    meaning:
      "phía của người hoặc tập thể những người nào đó, trong quan hệ với người hoặc tập thể những người ở phía khác: họ hàng hai bên nội, ngoại * bên địch * đứng ở giữa, không thiên vị bên nào",
    example:
      "họ hàng hai bên nội, ngoại * bên địch * đứng ở giữa, không thiên vị bên nào",
  },
  {
    word: "bên",
    part_of_speech: "danh từ",
    meaning:
      "mặt, phương diện, trong quan hệ với mặt khác, phương diện khác: bên tình bên hiếu",
    example: "bên tình bên hiếu",
  },
  {
    word: "bên",
    part_of_speech: "danh từ",
    meaning:
      "nơi sát cạnh, nơi gần kề: làng bên * đứng bên cửa sổ * sống bên cạnh người thân",
    example: "làng bên * đứng bên cửa sổ * sống bên cạnh người thân",
  },
  {
    word: "bên",
    part_of_speech: "danh từ",
    meaning:
      "(cạnh, mặt) không phải là đáy hoặc không thuộc về đáy của một hình: cạnh bên * mặt bên của một lăng trụ",
    example: "cạnh bên * mặt bên của một lăng trụ",
  },
  {
    word: "bển",
    part_of_speech: "đại từ",
    meaning: "(phương ngữ, khẩu ngữ) bên ấy: qua bển chơi * ở bển",
    example: "qua bển chơi * ở bển",
  },
  {
    word: "bện",
    part_of_speech: "động từ",
    meaning:
      "kết nhiều sợi nhỏ làm cho xoắn chặt vào nhau thành sợi to hoặc thành đồ dùng: bện chổi * bện thảm * sợi dây bện bằng da trâu",
    example: "bện chổi * bện thảm * sợi dây bện bằng da trâu",
  },
  {
    word: "bện",
    part_of_speech: "động từ",
    meaning: "quấn và dính chặt vào: rơm bện vào bánh xe * con bện mẹ",
    example: "rơm bện vào bánh xe * con bện mẹ",
  },
  {
    word: "bến bờ",
    part_of_speech: "danh từ",
    meaning:
      "bờ và bến, nơi giới hạn, tiếp giáp giữa nơi sông nước với đất liền (nói khái quát): biển cả mênh mông, không thấy đâu là bờ bến * tình yêu không bờ bến",
    example:
      "biển cả mênh mông, không thấy đâu là bờ bến * tình yêu không bờ bến",
  },
  {
    word: "bến bãi",
    part_of_speech: "danh từ",
    meaning:
      "bến (ng2; nói khái quát): thu phí cầu đường, bến bãi * kiểm tra các kho tàng, bến bãi",
    example: "thu phí cầu đường, bến bãi * kiểm tra các kho tàng, bến bãi",
  },
  {
    word: "bến",
    part_of_speech: "danh từ",
    meaning:
      "chỗ bờ sông, thường có bậc lên xuống, để tắm giặt, lấy nước: ra bến gánh nước",
    example: "ra bến gánh nước",
  },
  {
    word: "bến",
    part_of_speech: "danh từ",
    meaning:
      'nơi quy định cho tàu thuyền, xe cộ dừng lại để hành khách lên xuống, xếp dỡ hàng hoá: bến đò * xe đã vào bến * "Thuyền ơi có nhớ bến chăng, Bến thì một dạ khăng khăng đợi thuyền." (Cdao)',
    example:
      'bến đò * xe đã vào bến * "Thuyền ơi có nhớ bến chăng, Bến thì một dạ khăng khăng đợi thuyền." (Cdao)',
  },
  {
    word: "bền",
    part_of_speech: "tính từ",
    meaning:
      "có khả năng giữ nguyên trạng thái được lâu, dùng được lâu: sợi chỉ bền * vải bền màu * độ bền của bê tông * của bền tại người (tng)",
    example:
      "sợi chỉ bền * vải bền màu * độ bền của bê tông * của bền tại người (tng)",
  },
  {
    word: "bền",
    part_of_speech: "tính từ",
    meaning:
      'có thể giữ nguyên được lâu, không biến đổi, không suy yếu, dù có tác động bất lợi từ bên ngoài: sợ lòng không bền * hạnh phúc bền lâu * "Làm trai chí ở cho bền, Đừng lo muộn vợ, chớ phiền muộn con." (Cdao)',
    example:
      'sợ lòng không bền * hạnh phúc bền lâu * "Làm trai chí ở cho bền, Đừng lo muộn vợ, chớ phiền muộn con." (Cdao)',
  },
  {
    word: "bền bỉ",
    part_of_speech: "tính từ",
    meaning:
      "có khả năng chịu đựng gian khổ, khó nhọc được lâu dài để theo đuổi mục đích đến cùng: sức chịu đựng bền bỉ * bền bỉ chiến đấu",
    example: "sức chịu đựng bền bỉ * bền bỉ chiến đấu",
  },
  {
    word: "bền chí",
    part_of_speech: "tính từ",
    meaning:
      "không thay đổi ý chí, không nao núng trước mọi khó khăn, trở ngại: bền chí theo đuổi sự nghiệp * kiên gan bền chí",
    example: "bền chí theo đuổi sự nghiệp * kiên gan bền chí",
  },
  {
    word: "bền chặt",
    part_of_speech: "tính từ",
    meaning:
      "chặt chẽ và bền lâu, khó tách rời, khó phá vỡ: tình nghĩa bền chặt * mối quan hệ ngày thêm bền chặt",
    example: "tình nghĩa bền chặt * mối quan hệ ngày thêm bền chặt",
  },
  {
    word: "bền gan",
    part_of_speech: "tính từ",
    meaning:
      "có khả năng chịu đựng các thử thách, không nao núng trước khó khăn, nguy hiểm: bền gan chiến đấu * vững trí, bền gan",
    example: "bền gan chiến đấu * vững trí, bền gan",
  },
  {
    word: "bến xe",
    part_of_speech: "danh từ",
    meaning:
      "bến quy định cho xe đỗ để đón trả khách hoặc bốc dỡ hàng hoá: bến xe liên tỉnh",
    example: "bến xe liên tỉnh",
  },
  {
    word: "bền lòng",
    part_of_speech: "tính từ",
    meaning:
      "luôn giữ vững được tinh thần, ý chí, trước sau không thay đổi: bền lòng chờ đợi",
    example: "bền lòng chờ đợi",
  },
  {
    word: "bênh",
    part_of_speech: "động từ",
    meaning:
      "làm cho vật nặng được nâng chếch lên: dùng đòn bênh hòn đá * bênh một đầu giường lên",
    example: "dùng đòn bênh hòn đá * bênh một đầu giường lên",
  },
  {
    word: "bênh",
    part_of_speech: "động từ",
    meaning: "chếch lên vì mất cân bằng: một đầu ghế băng bênh lên",
    example: "một đầu ghế băng bênh lên",
  },
  {
    word: "bênh",
    part_of_speech: "động từ",
    meaning:
      "đứng về cùng phía để che chở hoặc chống chế: bênh nhau chầm chập * bênh con ra mặt",
    example: "bênh nhau chầm chập * bênh con ra mặt",
  },
  {
    word: "bền vững",
    part_of_speech: "tính từ",
    meaning:
      "vững chắc và bền lâu: mối quan hệ bền vững * sự phát triển không bền vững",
    example: "mối quan hệ bền vững * sự phát triển không bền vững",
  },
  {
    word: "bến nước",
    part_of_speech: "danh từ",
    meaning:
      'bến sông để thuyền bè đậu hoặc dùng làm nơi để tắm giặt, lấy nước: cây đa bến nước * "Mười hai bến nước lênh đênh, Biết đâu trong đục nương mình gửi thân." (ca dao)',
    example:
      'cây đa bến nước * "Mười hai bến nước lênh đênh, Biết đâu trong đục nương mình gửi thân." (ca dao)',
  },
  {
    word: "bệnh",
    part_of_speech: "danh từ",
    meaning:
      "trạng thái cơ thể hoặc bộ phận cơ thể hoạt động không được bình thường: lúa bị bệnh rầy nâu * bệnh tim * buồn rầu quá mà sinh bệnh",
    example: "lúa bị bệnh rầy nâu * bệnh tim * buồn rầu quá mà sinh bệnh",
  },
  {
    word: "bệnh",
    part_of_speech: "danh từ",
    meaning:
      "trạng thái hư hỏng bộ phận làm cho máy móc hoạt động không bình thường: chiếc máy tính bị bệnh hay treo",
    example: "chiếc máy tính bị bệnh hay treo",
  },
  {
    word: "bệnh",
    part_of_speech: "danh từ",
    meaning:
      "thói xấu làm cho có những hành động đáng chê trách hoặc gây hại: bệnh sính nói chữ * bệnh quan liêu * mắc bệnh chạy theo thành tích",
    example:
      "bệnh sính nói chữ * bệnh quan liêu * mắc bệnh chạy theo thành tích",
  },
  {
    word: "bệnh",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) ốm: đang bệnh, không đi chơi được",
    example: "đang bệnh, không đi chơi được",
  },
  {
    word: "bềnh",
    part_of_speech: "động từ",
    meaning:
      "nổi hẳn lên trên mặt nước: chiếc phao bềnh lên * đám bọt biển bềnh lên trên mặt sóng",
    example: "chiếc phao bềnh lên * đám bọt biển bềnh lên trên mặt sóng",
  },
  {
    word: "bệnh án",
    part_of_speech: "danh từ",
    meaning:
      "hồ sơ của một bệnh nhân tại cơ sở điều trị, ghi quá trình phát triển của bệnh, sự chẩn đoán, phương pháp và quá trình điều trị, v.v.: xem bệnh án",
    example: "xem bệnh án",
  },
  {
    word: "bềnh bệch",
    part_of_speech: "tính từ",
    meaning:
      'hơi bệch: nước da bềnh bệch * "Mặt đầm chìm trong một mầu bềnh bệch như nước luộc cá." (HNhu; 3)',
    example:
      'nước da bềnh bệch * "Mặt đầm chìm trong một mầu bềnh bệch như nước luộc cá." (HNhu; 3)',
  },
  {
    word: "bệnh dịch",
    part_of_speech: "danh từ",
    meaning:
      "bệnh gây thành dịch: đẩy lùi được dịch bệnh * tôm bị dịch bệnh, chết hàng loạt",
    example: "đẩy lùi được dịch bệnh * tôm bị dịch bệnh, chết hàng loạt",
  },
  {
    word: "bềnh bồng",
    part_of_speech: "động từ",
    meaning: "như bồng bềnh: chiếc phao nổi bềnh bồng",
    example: "chiếc phao nổi bềnh bồng",
  },
  {
    word: "bệnh lí",
    part_of_speech: "danh từ",
    meaning: "bệnh lí học (nói tắt).",
    example: "hiện tượng bệnh lí * theo dõi bệnh lí",
  },
  {
    word: "bệnh hoạn",
    part_of_speech: "tính từ",
    meaning: "ở trạng thái có bệnh thường kéo dài: màu da bệnh hoạn",
    example: "màu da bệnh hoạn",
  },
  {
    word: "bệnh hoạn",
    part_of_speech: "tính từ",
    meaning:
      "(tư tưởng, tình cảm) không được bình thường, không lành mạnh: con người bệnh hoạn * đầu óc bệnh hoạn * lối suy nghĩ bệnh hoạn",
    example: "con người bệnh hoạn * đầu óc bệnh hoạn * lối suy nghĩ bệnh hoạn",
  },
  {
    word: "bệnh lý",
    part_of_speech: "danh từ",
    meaning: "bệnh lí học (nói tắt).",
    example: "hiện tượng bệnh lí * theo dõi bệnh lí",
  },
  {
    word: "bệnh nghề nghiệp",
    part_of_speech: "danh từ",
    meaning:
      "bệnh phát sinh do tác động của điều kiện lao động có hại: mắc bệnh nghề nghiệp",
    example: "mắc bệnh nghề nghiệp",
  },
  {
    word: "bệnh sĩ",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) bệnh sĩ diện: mắc bệnh sĩ",
    example: "mắc bệnh sĩ",
  },
  {
    word: "bệnh nhân",
    part_of_speech: "danh từ",
    meaning:
      "người bệnh đang được điều trị, trong quan hệ với cơ sở điều trị và với thầy thuốc: bệnh nhân điều trị nội trú * bệnh nhân cấp cứu",
    example: "bệnh nhân điều trị nội trú * bệnh nhân cấp cứu",
  },
  {
    word: "bệnh tật",
    part_of_speech: "",
    meaning:
      "bệnh và tật (nói khái quát): người khoẻ mạnh, không có bệnh tật gì",
    example: "người khoẻ mạnh, không có bệnh tật gì",
  },
  {
    word: "bệnh trạng",
    part_of_speech: "danh từ",
    meaning: "trạng thái bệnh: bệnh trạng khá trầm trọng",
    example: "bệnh trạng khá trầm trọng",
  },
  {
    word: "bệnh tưởng",
    part_of_speech: "danh từ",
    meaning:
      "trạng thái tinh thần lo lắng do bị ám ảnh là mình đã mắc một bệnh nào đó, kì thật không phải: mắc bệnh tưởng",
    example: "mắc bệnh tưởng",
  },
  {
    word: "bếp núc",
    part_of_speech: "danh từ",
    meaning:
      "bếp (nói khái quát); cũng dùng để chỉ công việc nấu ăn: bếp núc gọn gàng, sạch sẽ * thạo việc bếp núc",
    example: "bếp núc gọn gàng, sạch sẽ * thạo việc bếp núc",
  },
  {
    word: "bếp núc",
    part_of_speech: "danh từ",
    meaning:
      "những công việc chuẩn bị ở phía sau, thường là vất vả nhưng ít ai nhìn thấy, để phục vụ cho một công việc nào đó: lo việc bếp núc ở toà soạn",
    example: "lo việc bếp núc ở toà soạn",
  },
  {
    word: "bênh vực",
    part_of_speech: "động từ",
    meaning:
      "đứng về cùng phía để chống lại sự công kích, sự xâm phạm nhằm che chở, bảo vệ: bênh vực lẽ phải * được luật pháp bênh vực",
    example: "bênh vực lẽ phải * được luật pháp bênh vực",
  },
  {
    word: "bệnh viện",
    part_of_speech: "danh từ",
    meaning:
      "cơ sở khám bệnh và nhận người ốm đau nằm điều trị: bệnh viện đa khoa * bệnh viện nhi",
    example: "bệnh viện đa khoa * bệnh viện nhi",
  },
  {
    word: "bệnh tình",
    part_of_speech: "danh từ",
    meaning:
      "tình hình chuyển biến của bệnh: theo dõi bệnh tình * bệnh tình ngày thêm trầm trọng",
    example: "theo dõi bệnh tình * bệnh tình ngày thêm trầm trọng",
  },
  {
    word: "bết",
    part_of_speech: "động từ",
    meaning:
      "dính sát vào, dính thành lớp: tóc bết mồ hôi * giày bết bùn đất * quần áo ướt dính bết vào da thịt",
    example:
      "tóc bết mồ hôi * giày bết bùn đất * quần áo ướt dính bết vào da thịt",
  },
  {
    word: "bết",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ, khẩu ngữ) mệt quá sức: mới đi bộ được một đoạn đã bết",
    example: "mới đi bộ được một đoạn đã bết",
  },
  {
    word: "bết",
    part_of_speech: "tính từ",
    meaning: "kém, tồi: nhà máy này làm ăn bết lắm",
    example: "nhà máy này làm ăn bết lắm",
  },
  {
    word: "bếp nước",
    part_of_speech: "danh từ",
    meaning: "như bếp núc: dọn dẹp bếp nước",
    example: "dọn dẹp bếp nước",
  },
  {
    word: "bêu",
    part_of_speech: "động từ",
    meaning:
      "bày ra trước đông đảo mọi người cho ai cũng thấy, nhằm đe doạ hoặc làm nhục: bêu đầu giữa chợ * bị dong đi bêu khắp xóm",
    example: "bêu đầu giữa chợ * bị dong đi bêu khắp xóm",
  },
  {
    word: "bêu",
    part_of_speech: "động từ",
    meaning: "như bêu xấu: tự bêu mình trước thiên hạ",
    example: "tự bêu mình trước thiên hạ",
  },
  {
    word: "bêu",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) đáng xấu hổ: dân làng biết thì thật là bêu quá! * rõ bêu cái mặt!",
    example: "dân làng biết thì thật là bêu quá! * rõ bêu cái mặt!",
  },
  {
    word: "bệt",
    part_of_speech: "động từ",
    meaning: "(phương ngữ): tóc bệt mồ hôi",
    example: "tóc bệt mồ hôi",
  },
  {
    word: "bệt",
    part_of_speech: "phụ từ",
    meaning:
      '(ngồi hoặc nằm) sát xuống đất, xuống sàn, không kê lót gì ở dưới: ngồi bệt xuống thềm * "Chấm đánh bệt ngay xuống hè, không chạy vào nhà (...)" (ĐVũ; 1)',
    example:
      'ngồi bệt xuống thềm * "Chấm đánh bệt ngay xuống hè, không chạy vào nhà (...)" (ĐVũ; 1)',
  },
  {
    word: "bếp",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ để đun nấu: bếp gas (đun bằng gas) * nhóm bếp nấu cơm * đặt ấm nước lên bếp",
    example: "bếp gas (đun bằng gas) * nhóm bếp nấu cơm * đặt ấm nước lên bếp",
  },
  {
    word: "bếp",
    part_of_speech: "danh từ",
    meaning:
      "gian nhà làm nơi đặt bếp để nấu ăn: ăn cơm trong bếp * gác trên nóc bếp",
    example: "ăn cơm trong bếp * gác trên nóc bếp",
  },
  {
    word: "bệu",
    part_of_speech: "tính từ",
    meaning: "béo nhưng da thịt nhão, không chắc, trông không khoẻ: béo bệu",
    example: "béo bệu",
  },
  {
    word: "liên bộ",
    part_of_speech: "danh từ",
    meaning:
      "hai hay nhiều bộ phối hợp với nhau (cùng làm việc gì): cuộc họp liên bộ * thông tư liên bộ y tế - tài chính",
    example: "cuộc họp liên bộ * thông tư liên bộ y tế - tài chính",
  },
  {
    word: "liên chi hồ điệp",
    part_of_speech: "",
    meaning: "liên tiếp, nối tiếp nhau không dứt: nói liên chi hồ điệp",
    example: "nói liên chi hồ điệp",
  },
  {
    word: "liên chi",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức gồm một số chi bộ hay chi đoàn hợp thành: ban chấp hành liên chi * bí thư liên chi",
    example: "ban chấp hành liên chi * bí thư liên chi",
  },
  {
    word: "liên can",
    part_of_speech: "động từ",
    meaning:
      "dính dáng vào vụ phạm pháp ở mức không nghiêm trọng: lên án kẻ gây tội ác và các phần tử liên can * có liên can vào một vụ án mạng",
    example:
      "lên án kẻ gây tội ác và các phần tử liên can * có liên can vào một vụ án mạng",
  },
  {
    word: "liên can",
    part_of_speech: "động từ",
    meaning:
      "có dính dáng đến (ai, việc nào đó): hai vấn đề có liên can đến nhau",
    example: "hai vấn đề có liên can đến nhau",
  },
  {
    word: "liên đội",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức thiếu niên gồm nhiều đội hoặc chi đội hợp thành: liên đội trưởng * liên đội tự vệ",
    example: "liên đội trưởng * liên đội tự vệ",
  },
  {
    word: "liên đoàn",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức gồm nhiều đoàn thể, nhiều tổ chức nhỏ (thường cùng hoạt động trong một lĩnh vực) hợp thành: liên đoàn lao động * liên đoàn bóng đá",
    example: "liên đoàn lao động * liên đoàn bóng đá",
  },
  {
    word: "liên doanh",
    part_of_speech: "động từ",
    meaning:
      "liên kết để cùng hợp tác trong kinh doanh, giữa hai bên hay nhiều bên: xí nghiệp liên doanh * công ti liên doanh với nước ngoài",
    example: "xí nghiệp liên doanh * công ti liên doanh với nước ngoài",
  },
  {
    word: "liên danh",
    part_of_speech: "",
    meaning:
      "tập thể gồm hai hay nhiều người cùng chung một danh sách để làm một việc gì: liên danh ứng cử viên * nhà thầu liên danh với nước ngoài",
    example: "liên danh ứng cử viên * nhà thầu liên danh với nước ngoài",
  },
  {
    word: "liên đới",
    part_of_speech: "tính từ",
    meaning:
      "có sự ràng buộc lẫn nhau về mặt trách nhiệm, nghĩa vụ: trách nhiệm liên đới * quan hệ liên đới",
    example: "trách nhiệm liên đới * quan hệ liên đới",
  },
  {
    word: "liên hoan",
    part_of_speech: "",
    meaning:
      "cuộc vui chung nhân dịp gì có đông người cùng tham gia: liên hoan văn nghệ * liên hoan mừng chiến thắng * ăn liên hoan",
    example: "liên hoan văn nghệ * liên hoan mừng chiến thắng * ăn liên hoan",
  },
  {
    word: "liên hoàn",
    part_of_speech: "tính từ",
    meaning:
      "có các phần, các bộ phận riêng rẽ nhưng được liên kết nối tiếp nhau tạo thành một chuỗi thống nhất: máy gặt đập liên hoàn * xây dựng mô hình kinh tế liên hoàn",
    example: "máy gặt đập liên hoàn * xây dựng mô hình kinh tế liên hoàn",
  },
  {
    word: "liên hồi",
    part_of_speech: "tính từ",
    meaning:
      "không dứt, hết hồi này đến hồi khác kế tiếp nhau: trống đánh liên hồi * nói liên hồi",
    example: "trống đánh liên hồi * nói liên hồi",
  },
  {
    word: "liên hiệp",
    part_of_speech: "",
    meaning:
      "kết hợp những tổ chức hay thành phần xã hội khác nhau vào một tổ chức, nhằm thực hiện mục đích chung nào đó: khối liên hiệp châu âu * hội liên hiệp phụ nữ",
    example: "khối liên hiệp châu âu * hội liên hiệp phụ nữ",
  },
  {
    word: "liên hoan phim",
    part_of_speech: "danh từ",
    meaning: "festival điện ảnh: liên hoan phim quốc tế",
    example: "liên hoan phim quốc tế",
  },
  {
    word: "liên hệ",
    part_of_speech: "động từ",
    meaning:
      "tiếp xúc, trao đổi để đặt hoặc giữ quan hệ với nhau: liên hệ qua điện thoại * đi liên hệ công tác",
    example: "liên hệ qua điện thoại * đi liên hệ công tác",
  },
  {
    word: "liên hệ",
    part_of_speech: "động từ",
    meaning:
      "(sự vật, sự việc) có quan hệ làm cho ít nhiều tác động đến nhau: lí luận phải liên hệ với thực tế * việc tôi làm, không liên hệ gì đến ai",
    example:
      "lí luận phải liên hệ với thực tế * việc tôi làm, không liên hệ gì đến ai",
  },
  {
    word: "liên hệ",
    part_of_speech: "động từ",
    meaning:
      "(từ sự việc, hiện tượng này) nghĩ đến sự việc, hiện tượng khác dựa trên những mối quan hệ nhất định: nghe chuyện người, liên hệ đến chuyện mình",
    example: "nghe chuyện người, liên hệ đến chuyện mình",
  },
  {
    word: "liên hồi kỳ trận",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) (sự việc, hành động diễn ra) liên tiếp dồn dập, hết đợt này đến đợt khác: súng bắn liên hồi kì trận * gió giật liên hồi kì trận",
    example: "súng bắn liên hồi kì trận * gió giật liên hồi kì trận",
  },
  {
    word: "liên hồi kì trận",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) (sự việc, hành động diễn ra) liên tiếp dồn dập, hết đợt này đến đợt khác: súng bắn liên hồi kì trận * gió giật liên hồi kì trận",
    example: "súng bắn liên hồi kì trận * gió giật liên hồi kì trận",
  },
  {
    word: "liên kết",
    part_of_speech: "động từ",
    meaning:
      "kết lại với nhau từ nhiều thành phần hoặc tổ chức riêng rẽ: hai người liên kết với nhau để làm ăn * phong trào các nước không liên kết",
    example:
      "hai người liên kết với nhau để làm ăn * phong trào các nước không liên kết",
  },
  {
    word: "liên hợp",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ, cũ) như liên hiệp: chính phủ liên hợp * uỷ ban liên hợp",
    example: "chính phủ liên hợp * uỷ ban liên hợp",
  },
  {
    word: "liên liến",
    part_of_speech: "tính từ",
    meaning:
      "rất nhanh và liên tiếp không ngừng (thường trong nói năng, đối đáp): tay nhặt thóc liên liến * miệng nói liên liến",
    example: "tay nhặt thóc liên liến * miệng nói liên liến",
  },
  {
    word: "liên khu",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị hành chính gồm nhiều tỉnh trong thời kì Kháng chiến chống Pháp: liên khu Việt Bắc * liên khu Năm * tư lệnh liên khu",
    example: "liên khu Việt Bắc * liên khu Năm * tư lệnh liên khu",
  },
  {
    word: "liên lạc",
    part_of_speech: "danh từ",
    meaning:
      "người chuyên làm công tác đưa tin, đưa mệnh lệnh, v.v., từ nơi này đến nơi khác: chú bé liên lạc * làm liên lạc ở đại đội",
    example: "chú bé liên lạc * làm liên lạc ở đại đội",
  },
  {
    word: "liền liền",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) nhanh và liền một mạch không ngớt: chớp mắt liền liền * nói liền liền",
    example: "chớp mắt liền liền * nói liền liền",
  },
  {
    word: "liến láu",
    part_of_speech: "tính từ",
    meaning: "nhanh và tỏ ra tinh khôn, láu lỉnh (nói khái quát): nói liến láu",
    example: "nói liến láu",
  },
  {
    word: "liên luỵ",
    part_of_speech: "động từ",
    meaning:
      "phải chịu tội vạ lây: việc này chắc không tránh khỏi liên luỵ * làm liên luỵ đến gia đình",
    example:
      "việc này chắc không tránh khỏi liên luỵ * làm liên luỵ đến gia đình",
  },
  {
    word: "liên minh",
    part_of_speech: "động từ",
    meaning:
      "liên kết với nhau thành một khối để phối hợp hành động vì mục đích chung: hai bên liên minh lại với nhau",
    example: "hai bên liên minh lại với nhau",
  },
  {
    word: "liên minh",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) khối liên kết các lực lượng nhằm phối hợp hành động vì mục đích chung: khối liên minh công nông * liên minh quân sự",
    example: "khối liên minh công nông * liên minh quân sự",
  },
  {
    word: "liên ngành",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp gồm nhiều ngành có liên quan với nhau: thông tư liên ngành * vấn đề nghiên cứu có tính chất liên ngành",
    example: "thông tư liên ngành * vấn đề nghiên cứu có tính chất liên ngành",
  },
  {
    word: "liên quan",
    part_of_speech: "động từ",
    meaning:
      "có mối quan hệ nào đó với nhau: hai vấn đề có liên quan mật thiết với nhau * việc đó chẳng liên quan gì tới tôi",
    example:
      "hai vấn đề có liên quan mật thiết với nhau * việc đó chẳng liên quan gì tới tôi",
  },
  {
    word: "liền tay",
    part_of_speech: "phụ từ",
    meaning: "(làm việc gì) luôn một mạch, không nghỉ tay: quạt liền tay",
    example: "quạt liền tay",
  },
  {
    word: "liền tay",
    part_of_speech: "phụ từ",
    meaning:
      '(khẩu ngữ) ngay tức khắc: "Cưới vợ thì cưới liền tay, Chớ để lâu ngày lắm kẻ gièm pha." (ca dao)',
    example:
      'Cưới vợ thì cưới liền tay, Chớ để lâu ngày lắm kẻ gièm pha." (ca dao)',
  },
  {
    word: "liên miên",
    part_of_speech: "tính từ",
    meaning:
      "ở tình trạng nối tiếp nhau không dứt, cái này chưa xong đã tiếp tới cái kia: đau ốm liên miên * suy nghĩ liên miên * đi công tác liên miên",
    example: "đau ốm liên miên * suy nghĩ liên miên * đi công tác liên miên",
  },
  {
    word: "liên quân",
    part_of_speech: "danh từ",
    meaning:
      "đội quân gồm nhiều đơn vị thuộc quân đội các nước khác nhau hợp thành: liên quân Anh - Mĩ",
    example: "liên quân Anh - Mĩ",
  },
  {
    word: "liên thanh",
    part_of_speech: "tính từ",
    meaning:
      "liên tiếp có nhiều tiếng phát ra nối tiếp nhau thành từng tràng: trống đánh liên thanh * tù và rúc liên thanh",
    example: "trống đánh liên thanh * tù và rúc liên thanh",
  },
  {
    word: "liên thanh",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) súng liên thanh (nói tắt): khẩu liên thanh",
    example: "khẩu liên thanh",
  },
  {
    word: "liên thông",
    part_of_speech: "động từ",
    meaning:
      "nối liền với nhau giữa nhiều thành phần hoặc bộ phận riêng rẽ: các hang động liên thông với nhau",
    example: "các hang động liên thông với nhau",
  },
  {
    word: "liến thoắng",
    part_of_speech: "tính từ",
    meaning:
      "(nói năng) nhiều và quá nhanh, không chịu ngớt miệng: nói liến thoắng * mồm mép liến thoắng",
    example: "nói liến thoắng * mồm mép liến thoắng",
  },
  {
    word: "liến thoắng",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) rất nhanh, với những động tác lặp đi lặp lại không ngớt: tay viết liến thoắng",
    example: "tay viết liến thoắng",
  },
  {
    word: "liên tịch",
    part_of_speech: "tính từ",
    meaning:
      "(hội nghị, cuộc họp) có nhiều thành phần đại biểu cho các tổ chức khác nhau cùng tham dự: thông tư liên tịch * cuộc họp liên tịch",
    example: "thông tư liên tịch * cuộc họp liên tịch",
  },
  {
    word: "liền tù tì",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) (làm việc gì) liền luôn một mạch, không hề có ngắt quãng: đọc liền tù tì từ đầu đến cuối * ăn liền tù tì năm bát cơm",
    example: "đọc liền tù tì từ đầu đến cuối * ăn liền tù tì năm bát cơm",
  },
  {
    word: "liên tiếp",
    part_of_speech: "tính từ",
    meaning:
      "tiếp liền nhau, hết cái này đến cái khác: những tràng pháo tay liên tiếp * thắng liên tiếp mấy trận liền",
    example: "những tràng pháo tay liên tiếp * thắng liên tiếp mấy trận liền",
  },
  {
    word: "liểng xiểng",
    part_of_speech: "tính từ",
    meaning:
      "ở vào tình trạng bị đánh bại, bị thua lỗ nặng nề, liên tiếp đến mức khó có thể gượng lại được: bị đánh bất ngờ, quân giặc thua liểng xiểng * lỗ liểng xiểng",
    example: "bị đánh bất ngờ, quân giặc thua liểng xiểng * lỗ liểng xiểng",
  },
  {
    word: "liên từ",
    part_of_speech: "danh từ",
    meaning:
      'kết từ dùng để biểu thị quan hệ cú pháp giữa hai từ hoặc ngữ có cùng một chức năng trong câu, hay giữa hai câu hoặc phân câu:  "và", "nhưng", "hoặc" là một số liên từ trong tiếng Việt.',
    example: 'và", "nhưng", "hoặc" là một số liên từ trong tiếng Việt.',
  },
  {
    word: "liệng",
    part_of_speech: "động từ",
    meaning:
      "nghiêng cánh bay theo đường vòng: rợp trời chim én liệng * máy bay liệng mấy vòng",
    example: "rợp trời chim én liệng * máy bay liệng mấy vòng",
  },
  {
    word: "liệng",
    part_of_speech: "động từ",
    meaning:
      "ném bằng cách lia cho bay là là mặt nước, mặt đất: liệng mảnh sành * liệng quân bài * liệng đá trên mặt hồ",
    example: "liệng mảnh sành * liệng quân bài * liệng đá trên mặt hồ",
  },
  {
    word: "liệng",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) ném, quẳng đi, vứt bỏ đi: liệng lựu đạn * liệng vô sọt rác",
    example: "liệng lựu đạn * liệng vô sọt rác",
  },
  {
    word: "liên vận",
    part_of_speech: "danh từ",
    meaning:
      "hình thức vận chuyển kết hợp các phương tiện vận tải tiếp nhau trên một tuyến đường, hoặc sử dụng cùng một phương tiện vận tải đường sắt đi qua hai hay nhiều nước liền nhau: tàu khách liên vận quốc tế * tàu liên vận Hà Nội - Bắc Kinh",
    example: "tàu khách liên vận quốc tế * tàu liên vận Hà Nội - Bắc Kinh",
  },
  {
    word: "liếp",
    part_of_speech: "danh từ",
    meaning:
      "tấm đan dày bằng tre, nứa, dùng để che chắn trong nhà: cửa liếp * ghé mắt nhìn qua khe liếp",
    example: "cửa liếp * ghé mắt nhìn qua khe liếp",
  },
  {
    word: "liếp",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) luống: trồng mấy liếp rau",
    example: "trồng mấy liếp rau",
  },
  {
    word: "liên tục",
    part_of_speech: "tính từ",
    meaning:
      "tiếp nối nhau thành một quá trình không bị gián đoạn: liên tục phát triển * quần áo thay đổi liên tục",
    example: "liên tục phát triển * quần áo thay đổi liên tục",
  },
  {
    word: "liệt dương",
    part_of_speech: "tính từ",
    meaning:
      "(dương vật) không thể cương cứng nên mất khả năng giao hợp: điều trị chứng liệt dương",
    example: "điều trị chứng liệt dương",
  },
  {
    word: "liên tưởng",
    part_of_speech: "động từ",
    meaning:
      "nghĩ tới sự việc, hiện tượng nào đó có liên quan nhân sự việc, hiện tượng đang diễn ra: nghe tiếng pháo mà liên tưởng đến ngày Tết",
    example: "nghe tiếng pháo mà liên tưởng đến ngày Tết",
  },
  {
    word: "liếp nhiếp",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng kêu yếu ớt không đều như tiếng của gà con: gà con kêu liếp nhiếp",
    example: "gà con kêu liếp nhiếp",
  },
  {
    word: "liệt",
    part_of_speech: "động từ",
    meaning:
      "xếp vào loại, vào hạng nào đó sau khi đã đánh giá, kết luận: rùa được liệt vào hàng tứ linh * sản phẩm bị liệt vào loại kém",
    example: "rùa được liệt vào hàng tứ linh * sản phẩm bị liệt vào loại kém",
  },
  {
    word: "liệt",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái bị mất hẳn hoặc giảm khả năng hoạt động của một bộ phận nào đó của cơ thể: bị liệt cánh tay phải * liệt nửa người",
    example: "bị liệt cánh tay phải * liệt nửa người",
  },
  {
    word: "liệt",
    part_of_speech: "tính từ",
    meaning: "(đau ốm) kiệt sức không dậy được: bị ốm, nằm liệt cả tháng",
    example: "bị ốm, nằm liệt cả tháng",
  },
  {
    word: "liệt",
    part_of_speech: "tính từ",
    meaning:
      "(máy móc) mất khả năng hoạt động do hỏng hóc: súng liệt cò * xe bị liệt máy",
    example: "súng liệt cò * xe bị liệt máy",
  },
  {
    word: "liệt giường",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (đau ốm) kiệt sức đến mức không dậy nổi: ốm liệt giường * nằm liệt giường",
    example: "ốm liệt giường * nằm liệt giường",
  },
  {
    word: "liệt sĩ",
    part_of_speech: "danh từ",
    meaning:
      "người đã hi sinh trong khi làm nhiệm vụ: nghiêng mình tưởng niệm linh hồn các liệt sĩ * nghĩa trang liệt sĩ",
    example:
      "nghiêng mình tưởng niệm linh hồn các liệt sĩ * nghĩa trang liệt sĩ",
  },
  {
    word: "liệt kê",
    part_of_speech: "động từ",
    meaning:
      "kê ra từng khoản, từng thứ có thứ tự: liệt kê tài sản * bản liệt kê các khoản chi phí trong tháng",
    example: "liệt kê tài sản * bản liệt kê các khoản chi phí trong tháng",
  },
  {
    word: "liệt nữ",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người phụ nữ có khí tiết hoặc có khí phách anh hùng: bà Trưng, bà Triệu là những bậc liệt nữ",
    example: "bà Trưng, bà Triệu là những bậc liệt nữ",
  },
  {
    word: "liễu bồ",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) như bồ liễu: "Hãy xin hết kiếp liễu bồ, Sông Tiền đường sẽ hẹn hò về sau." (TKiều)',
    example:
      'Hãy xin hết kiếp liễu bồ, Sông Tiền đường sẽ hẹn hò về sau." (TKiều)',
  },
  {
    word: "liễu",
    part_of_speech: "danh từ",
    meaning:
      "cây nhỡ, cành mềm rủ xuống, lá hình ngọn giáo có răng cưa nhỏ, thường trồng làm cảnh ở ven hồ: lá liễu",
    example: "lá liễu",
  },
  {
    word: "liễu",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) cây liễu; dùng để ví người phụ nữ (hàm ý mảnh dẻ, yếu ớt): vóc liễu hao gầy * "Nặng lòng xót liễu, vì hoa, Trẻ thơ đã biết đâu mà dám thưa!" (TKiều)',
    example:
      'vóc liễu hao gầy * "Nặng lòng xót liễu, vì hoa, Trẻ thơ đã biết đâu mà dám thưa!" (TKiều)',
  },
  {
    word: "liệu cái thần hồn",
    part_of_speech: "",
    meaning: "(khẩu ngữ) như liệu thần hồn: cứ liệu cái thần hồn đấy!",
    example: "cứ liệu cái thần hồn đấy!",
  },
  {
    word: "liệu chừng",
    part_of_speech: "động từ",
    meaning:
      "tính toán khả năng một cách đại khái: liệu chừng có làm được không?",
    example: "liệu chừng có làm được không?",
  },
  {
    word: "liệu chừng",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) như liệu hồn: cứ liệu chừng đấy!",
    example: "cứ liệu chừng đấy!",
  },
  {
    word: "liệu",
    part_of_speech: "động từ",
    meaning:
      'tính toán đại khái các điều kiện và khả năng để nghĩ cách sao cho tốt nhất: liệu lời khuyên giải * "Liệu mà xa chạy cao bay, ái ân ta có ngần này mà thôi!" (TKiều)',
    example:
      'liệu lời khuyên giải * "Liệu mà xa chạy cao bay, ái ân ta có ngần này mà thôi!" (TKiều)',
  },
  {
    word: "liệu",
    part_of_speech: "động từ",
    meaning:
      "tìm cách này cách khác sao cho làm được hoặc có được cái cần thiết: việc đó tôi đã liệu đâu vào đấy rồi",
    example: "việc đó tôi đã liệu đâu vào đấy rồi",
  },
  {
    word: "liệu",
    part_of_speech: "động từ",
    meaning:
      "tính toán đại khái xem có khả năng hay không: anh liệu xem, có kịp không? * liệu đêm nay trời có tạnh mưa không?",
    example:
      "anh liệu xem, có kịp không? * liệu đêm nay trời có tạnh mưa không?",
  },
  {
    word: "liều",
    part_of_speech: "danh từ",
    meaning:
      "lượng cần thiết vừa đủ cho một lần dùng theo quy định (thường nói về thuốc chữa bệnh): liều thuốc an thần * uống theo đúng liều quy định",
    example: "liều thuốc an thần * uống theo đúng liều quy định",
  },
  {
    word: "liều",
    part_of_speech: "danh từ",
    meaning:
      'hành động táo bạo, bất chấp nguy hiểm hoặc hậu quả biết là có thể tai hại: liều chết cứu bạn * không biết nhưng vẫn nói liều * "Cũng liều nhắm mắt đưa chân, Mà xem con Tạo xoay vần đến đâu!" (TKiều)',
    example:
      'liều chết cứu bạn * không biết nhưng vẫn nói liều * "Cũng liều nhắm mắt đưa chân, Mà xem con Tạo xoay vần đến đâu!" (TKiều)',
  },
  {
    word: "liều liệu",
    part_of_speech: "động từ",
    meaning:
      "liệu dần đi (thường dùng trong lời khuyên bảo, thuyết phục hoặc cảnh cáo nhẹ nhàng): việc này liều liệu mà lo đi là vừa * cứ liều liệu đấy!",
    example: "việc này liều liệu mà lo đi là vừa * cứ liều liệu đấy!",
  },
  {
    word: "liệu hồn",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tổ hợp biểu thị ý cảnh cáo hay đe nẹt: làm không xong thì cứ liệu hồn!",
    example: "làm không xong thì cứ liệu hồn!",
  },
  {
    word: "liều lĩnh",
    part_of_speech: "tính từ",
    meaning:
      "(làm việc gì) bất chấp nguy hiểm hoặc hậu quả tai hại có thể xảy ra: hành động liều lĩnh * nảy ra một ý định liều lĩnh",
    example: "hành động liều lĩnh * nảy ra một ý định liều lĩnh",
  },
  {
    word: "liều mạng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) liều, dù biết là nguy hiểm đến tính mạng, vì cho là không còn cách nào khác: liều mạng xông vào đám cháy",
    example: "liều mạng xông vào đám cháy",
  },
  {
    word: "liều mình",
    part_of_speech: "động từ",
    meaning:
      "liều, không sợ thiệt đến thân mình, không sợ phải hi sinh tính mạng: liều mình cứu người bị nạn",
    example: "liều mình cứu người bị nạn",
  },
  {
    word: "liều mình",
    part_of_speech: "động từ",
    meaning:
      "tự tìm đến cái chết để giữ trọn tiết nghĩa hoặc để giải thoát bản thân mình: liều mình để giữ tròn danh tiết",
    example: "liều mình để giữ tròn danh tiết",
  },
  {
    word: "liệu trình",
    part_of_speech: "danh từ",
    meaning:
      "quá trình điều trị bệnh, theo những quy định chặt chẽ về cách thức, thời gian và liều lượng sử dụng thuốc: uống thuốc đúng liệu trình",
    example: "uống thuốc đúng liệu trình",
  },
  {
    word: "liệu thần hồn",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) như liệu hồn (nhưng ý nhấn mạnh hơn): cứ liệu thần hồn đấy con ạ!",
    example: "cứ liệu thần hồn đấy con ạ!",
  },
  {
    word: "liêu xiêu",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái ngả nghiêng, xiêu lệch như muốn đổ, muốn ngã: đi liêu xiêu như say rượu * ngôi nhà lá liêu xiêu trước gió",
    example: "đi liêu xiêu như say rượu * ngôi nhà lá liêu xiêu trước gió",
  },
  {
    word: "liều lượng",
    part_of_speech: "danh từ",
    meaning:
      "liều dùng để đạt hiệu quả mong muốn (nói khái quát): uống thuốc theo đúng liều lượng",
    example: "uống thuốc theo đúng liều lượng",
  },
  {
    word: "liệu pháp",
    part_of_speech: "danh từ",
    meaning:
      "cách chữa bệnh: liệu pháp châm cứu * chữa bệnh bằng liệu pháp tâm lí",
    example: "liệu pháp châm cứu * chữa bệnh bằng liệu pháp tâm lí",
  },
  {
    word: "lim dim",
    part_of_speech: "động từ",
    meaning: "(mắt) nhắm chưa khít, còn hơi hé mở: lim dim đôi mắt",
    example: "lim dim đôi mắt",
  },
  {
    word: "lim",
    part_of_speech: "danh từ",
    meaning:
      "cây lấy gỗ thường mọc ở rừng, thân tròn, lá kép lông chim, hoa nhỏ, gỗ màu nâu sẫm, rất rắn, được coi là một trong bốn loại gỗ tốt nhất (đinh, lim, sến, táu) dùng trong xây dựng: gỗ lim",
    example: "gỗ lim",
  },
  {
    word: "linh",
    part_of_speech: "tính từ",
    meaning:
      'như thiêng: "Suối vàng hồn mẹ có linh, Chứng cho con trẻ lòng thành ngày nay." (LVT)',
    example:
      'Suối vàng hồn mẹ có linh, Chứng cho con trẻ lòng thành ngày nay." (LVT)',
  },
  {
    word: "linh",
    part_of_speech: "tính từ",
    meaning:
      "có số lẻ dưới mười tiếp liền sau số hàng trăm: một trăm linh tám (108) * một nghìn không trăm linh hai (1002)",
    example: "một trăm linh tám (108) * một nghìn không trăm linh hai (1002)",
  },
  {
    word: "lịm",
    part_of_speech: "phụ từ",
    meaning:
      "có mức độ cao, thường đem lại cảm giác thích thú, dễ chịu: nước mát lịm * ngọt lịm * mặt tím lịm",
    example: "nước mát lịm * ngọt lịm * mặt tím lịm",
  },
  {
    word: "lĩnh",
    part_of_speech: "danh từ",
    meaning:
      'hàng dệt bằng tơ nõn, mặt bóng mịn, các sợi dọc phủ kín sợi ngang: dệt lĩnh * "Ra đường quần lĩnh áo the, Về nhà không có con me mà cày." (Cdao)',
    example:
      'dệt lĩnh * "Ra đường quần lĩnh áo the, Về nhà không có con me mà cày." (Cdao)',
  },
  {
    word: "lĩnh",
    part_of_speech: "động từ",
    meaning: "nhận lấy cái được ban cho, phát cho: lĩnh thưởng * lĩnh lương",
    example: "lĩnh thưởng * lĩnh lương",
  },
  {
    word: "lình",
    part_of_speech: "danh từ",
    meaning:
      "dùi nhọn của người lên đồng dùng để xiên qua má làm phép: xiên lình",
    example: "xiên lình",
  },
  {
    word: "lính",
    part_of_speech: "danh từ",
    meaning:
      "người trong quân đội nói chung: đi lính * cuộc đời người lính * một nhà thơ mặc áo lính",
    example: "đi lính * cuộc đời người lính * một nhà thơ mặc áo lính",
  },
  {
    word: "lính",
    part_of_speech: "danh từ",
    meaning:
      "người trong quân đội ở cấp thấp nhất, không phải là cấp chỉ huy: lính trơn * làm chân lính quèn * lính cảnh sát",
    example: "lính trơn * làm chân lính quèn * lính cảnh sát",
  },
  {
    word: "lính",
    part_of_speech: "danh từ",
    meaning: "loại quân: lính chủ lực * lính xe tăng * lính thuỷ",
    example: "lính chủ lực * lính xe tăng * lính thuỷ",
  },
  {
    word: "lỉnh",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) bỏ đi nơi khác một cách kín đáo: lỉnh đi chơi",
    example: "lỉnh đi chơi",
  },
  {
    word: "linh cảm",
    part_of_speech: "động từ",
    meaning:
      "cảm nhận thấy trước bằng linh tính: linh cảm sắp có chuyện chẳng lành",
    example: "linh cảm sắp có chuyện chẳng lành",
  },
  {
    word: "linh diệu",
    part_of_speech: "tính từ",
    meaning:
      "rất đúng, rất hiệu nghiệm, đến mức kì diệu: một bài thuốc rất linh diệu",
    example: "một bài thuốc rất linh diệu",
  },
  {
    word: "lĩnh canh",
    part_of_speech: "động từ",
    meaning:
      "(cũ) nhận ruộng của người khác để trồng trọt với điều kiện phải nộp tô: cấy lĩnh canh",
    example: "cấy lĩnh canh",
  },
  {
    word: "linh cữu",
    part_of_speech: "danh từ",
    meaning:
      "(trang trọng) quan tài trong có thi hài, chưa an táng: túc trực bên linh cữu * đưa linh cữu đến nơi an táng",
    example: "túc trực bên linh cữu * đưa linh cữu đến nơi an táng",
  },
  {
    word: "linh dược",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, hiếm) thuốc quý, chữa bệnh rất hiệu nghiệm: bào chế linh dược",
    example: "bào chế linh dược",
  },
  {
    word: "lính chiến",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) lính trực tiếp chiến đấu: đời lính chiến",
    example: "đời lính chiến",
  },
  {
    word: "linh đan",
    part_of_speech: "danh từ",
    meaning: "(cũ) như kim đan: luyện linh đan",
    example: "luyện linh đan",
  },
  {
    word: "lính đánh thuê",
    part_of_speech: "danh từ",
    meaning:
      "lính đi đánh thay cho quân đội của một nước khác: tuyển mộ lính đánh thuê",
    example: "tuyển mộ lính đánh thuê",
  },
  {
    word: "linh hoạt",
    part_of_speech: "tính từ",
    meaning:
      "linh lợi và hoạt bát: cặp mắt linh hoạt * tác phong linh hoạt * đầu óc rất linh hoạt",
    example: "cặp mắt linh hoạt * tác phong linh hoạt * đầu óc rất linh hoạt",
  },
  {
    word: "linh hoạt",
    part_of_speech: "tính từ",
    meaning:
      "nhanh, nhạy trong việc xử trí, ứng phó cho phù hợp với tình hình thực tế, không cứng nhắc tuân theo nguyên tắc: chính sách mềm dẻo, linh hoạt * ứng biến linh hoạt",
    example: "chính sách mềm dẻo, linh hoạt * ứng biến linh hoạt",
  },
  {
    word: "linh đình",
    part_of_speech: "tính từ",
    meaning:
      "(hội hè, cỗ bàn) được tổ chức rất to và sang trọng, với nhiều hình thức có tính chất phô trương: ăn uống linh đình * đám cưới được tổ chức rất linh đình",
    example: "ăn uống linh đình * đám cưới được tổ chức rất linh đình",
  },
  {
    word: "linh động",
    part_of_speech: "tính từ",
    meaning: "(cũ, hiếm) có vẻ sống động: bức tranh rất linh động",
    example: "bức tranh rất linh động",
  },
  {
    word: "linh động",
    part_of_speech: "tính từ",
    meaning:
      "có cách xử lí mềm dẻo, không máy móc, cứng nhắc, mà có sự thay đổi chút ít cho phù hợp với yêu cầu, điều kiện thực tế: một con người thiếu linh động * phong cách làm việc mềm dẻo và linh động",
    example:
      "một con người thiếu linh động * phong cách làm việc mềm dẻo và linh động",
  },
  {
    word: "linh giác",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như linh cảm: linh giác mách bảo",
    example: "linh giác mách bảo",
  },
  {
    word: "lĩnh giáo",
    part_of_speech: "động từ",
    meaning:
      "(cũ, trang trọng) nhận sự chỉ bảo, dạy dỗ (nói một cách khiêm tốn): lời dạy của cụ, cháu xin lĩnh giáo",
    example: "lời dạy của cụ, cháu xin lĩnh giáo",
  },
  {
    word: "linh khí",
    part_of_speech: "danh từ",
    meaning:
      "khí thiêng: núi ấy có linh khí nên đã dựng chùa ở đó * linh khí núi sông",
    example: "núi ấy có linh khí nên đã dựng chùa ở đó * linh khí núi sông",
  },
  {
    word: "lĩnh hội",
    part_of_speech: "động từ",
    meaning:
      "tiếp thu và hiểu được một cách thấu đáo: lĩnh hội kiến thức * lĩnh hội được tư tưởng của tác phẩm",
    example: "lĩnh hội kiến thức * lĩnh hội được tư tưởng của tác phẩm",
  },
  {
    word: "lỉnh kỉnh",
    part_of_speech: "tính từ",
    meaning:
      "(đồ đạc) linh tinh nhiều thứ khác nhau và để lộn xộn, không được sắp xếp gọn gàng: mang theo đủ thứ lỉnh kỉnh * đồ đạc chất lỉnh kỉnh trong xe",
    example: "mang theo đủ thứ lỉnh kỉnh * đồ đạc chất lỉnh kỉnh trong xe",
  },
  {
    word: "lỉnh kỉnh",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có nhiều việc lặt vặt khác nhau khiến phải bận rộn liên tục, không thể làm xong một cách nhanh gọn được: lỉnh kỉnh mãi cũng chưa xong",
    example: "lỉnh kỉnh mãi cũng chưa xong",
  },
  {
    word: "linh kiện",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận có thể tháo lắp, thay thế được trong máy móc, thiết bị: linh kiện máy tính * thay linh kiện",
    example: "linh kiện máy tính * thay linh kiện",
  },
  {
    word: "linh hồn",
    part_of_speech: "danh từ",
    meaning:
      "(trang trọng) hồn người chết: cầu chúc cho linh hồn ông được thanh thản nơi chín suối",
    example: "cầu chúc cho linh hồn ông được thanh thản nơi chín suối",
  },
  {
    word: "linh hồn",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) tâm hồn hay tinh thần của con người: trấn tĩnh linh hồn * hình ảnh cô gái đã chiếm cả linh hồn chàng",
    example: "trấn tĩnh linh hồn * hình ảnh cô gái đã chiếm cả linh hồn chàng",
  },
  {
    word: "linh hồn",
    part_of_speech: "danh từ",
    meaning:
      "người hoặc cái giữ vai trò chủ đạo, mang lại sức sống, sức mạnh cho một tập thể: anh ấy là linh hồn của đội bóng",
    example: "anh ấy là linh hồn của đội bóng",
  },
  {
    word: "linh lợi",
    part_of_speech: "tính từ",
    meaning: "nhanh nhẹn, sắc sảo: cặp mắt lanh lợi * thông minh lanh lợi",
    example: "cặp mắt lanh lợi * thông minh lanh lợi",
  },
  {
    word: "linh nghiệm",
    part_of_speech: "tính từ",
    meaning:
      "rất hiệu nghiệm, đúng như dự đoán: một phương thuốc linh nghiệm * lời tiên đoán rất linh nghiệm",
    example: "một phương thuốc linh nghiệm * lời tiên đoán rất linh nghiệm",
  },
  {
    word: "linh thiêng",
    part_of_speech: "tính từ",
    meaning: "thiêng (nói khái quát): ngôi chùa rất linh thiêng",
    example: "ngôi chùa rất linh thiêng",
  },
  {
    word: "linh ta linh tinh",
    part_of_speech: "tính từ",
    meaning:
      "rất linh tinh, ít có giá trị, ý nghĩa: ăn nói linh ta linh tinh * mua toàn những thứ linh ta linh tinh",
    example: "ăn nói linh ta linh tinh * mua toàn những thứ linh ta linh tinh",
  },
  {
    word: "linh sàng",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) giường thờ người mới chết, theo phong tục xưa: "Vật mình lăn trước linh sàng, Khúc oan kể lể, nỗi thương ngậm ngùi." (NĐM)',
    example:
      'Vật mình lăn trước linh sàng, Khúc oan kể lể, nỗi thương ngậm ngùi." (NĐM)',
  },
  {
    word: "linh tinh",
    part_of_speech: "tính từ",
    meaning:
      "nhiều nhưng lặt vặt, không đáng kể, ít có giá trị: mua mấy thứ linh tinh * toàn những việc linh tinh",
    example: "mua mấy thứ linh tinh * toàn những việc linh tinh",
  },
  {
    word: "linh tinh",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có tính chất tuỳ tiện, không đúng nơi đúng chỗ: nói linh tinh * suy đoán linh tinh",
    example: "nói linh tinh * suy đoán linh tinh",
  },
  {
    word: "linh tính",
    part_of_speech: "",
    meaning:
      "khả năng biết trước hoặc cảm thấy trước một biến cố nào đó xảy ra có liên quan mật thiết đến bản thân mình mà không dựa vào một phương tiện thông tin bình thường nào: linh tính mách bảo * linh tính có điều không lành sắp xảy ra",
    example: "linh tính mách bảo * linh tính có điều không lành sắp xảy ra",
  },
  {
    word: "lính tráng",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) như binh lính: cánh lính tráng * cùng cảnh lính tráng với nhau",
    example: "cánh lính tráng * cùng cảnh lính tráng với nhau",
  },
  {
    word: "lĩnh vực",
    part_of_speech: "danh từ",
    meaning:
      "phạm vi hoạt động, nghiên cứu phân biệt với các phạm vi hoạt động, nghiên cứu khác: lĩnh vực chính trị * phát huy quyền làm chủ trên mọi lĩnh vực",
    example: "lĩnh vực chính trị * phát huy quyền làm chủ trên mọi lĩnh vực",
  },
  {
    word: "lình xình",
    part_of_speech: "tính từ",
    meaning: "rắc rối, lôi thôi, khó giải quyết: dính vào những vụ lình xình",
    example: "dính vào những vụ lình xình",
  },
  {
    word: "lình xình",
    part_of_speech: "tính từ",
    meaning: "lề mề, lằng nhằng: lình xình mãi không chịu đi",
    example: "lình xình mãi không chịu đi",
  },
  {
    word: "linh trưởng",
    part_of_speech: "danh từ",
    meaning:
      "động vật bậc cao gần với người, có bộ não phát triển, biết leo trèo, tay dài, bàn tay bàn chân có thể cầm nắm được, như khỉ, vượn, v.v.: loài linh trưởng * động vật linh trưởng",
    example: "loài linh trưởng * động vật linh trưởng",
  },
  {
    word: "líp",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận của máy móc gồm hai vành tròn kim loại lồng vào nhau, chỉ quay tự do được theo một chiều: thay líp xe đạp",
    example: "thay líp xe đạp",
  },
  {
    word: "lít",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị đo dung tích, bằng 1 decimet khối: một lít dầu * chai nửa lít",
    example: "một lít dầu * chai nửa lít",
  },
  {
    word: "lít nhít",
    part_of_speech: "tính từ",
    meaning:
      "vừa nhỏ, vừa nhiều và gần sít nhau: chữ bé lít nhít * bọn trẻ con lít nhít",
    example: "chữ bé lít nhít * bọn trẻ con lít nhít",
  },
  {
    word: "líu la líu lô",
    part_of_speech: "tính từ",
    meaning:
      "như líu lô (nhưng ý liên tiếp và mức độ nhiều hơn): tiếng trẻ líu la líu lô",
    example: "tiếng trẻ líu la líu lô",
  },
  {
    word: "líu díu",
    part_of_speech: "tính từ",
    meaning:
      "vừa nhỏ vừa như dính quyện vào nhau thành một chuỗi khó phân biệt rạch ròi, khó nhận ra (thường nói về âm thanh, chữ viết): chữ viết líu ríu * đứa trẻ líu ríu nói với mẹ",
    example: "chữ viết líu ríu * đứa trẻ líu ríu nói với mẹ",
  },
  {
    word: "líu díu",
    part_of_speech: "tính từ",
    meaning:
      "có vẻ như dính quyện vào mà di chuyển theo: sợ quá, chân tay líu ríu * bọn trẻ líu ríu đi bên mẹ",
    example: "sợ quá, chân tay líu ríu * bọn trẻ líu ríu đi bên mẹ",
  },
  {
    word: "líu",
    part_of_speech: "động từ",
    meaning:
      "(lưỡi) bị co rút đột ngột khiến cho không nói được hoặc nói không thành âm, không rõ tiếng: sợ quá, líu cả lưỡi",
    example: "sợ quá, líu cả lưỡi",
  },
  {
    word: "liu điu",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như riu riu: bếp lửa liu điu",
    example: "bếp lửa liu điu",
  },
  {
    word: "liu điu",
    part_of_speech: "tính từ",
    meaning: ".  như riu riu: lửa cháy liu riu * sắc thuốc nên để lửa liu riu",
    example: "lửa cháy liu riu * sắc thuốc nên để lửa liu riu",
  },
  {
    word: "líu lo",
    part_of_speech: "tính từ",
    meaning:
      "(tiếng hót, tiếng nói) có nhiều âm thanh cao và trong ríu vào nhau nghe vui tai: chim hót líu lo * miệng hát líu lo",
    example: "chim hót líu lo * miệng hát líu lo",
  },
  {
    word: "líu lô",
    part_of_speech: "tính từ",
    meaning:
      "(tiếng nói) có nhiều âm thanh cao và trong, nhưng nghe không được rành rẽ, như ríu vào nhau: nói líu lô",
    example: "nói líu lô",
  },
  {
    word: "lọ",
    part_of_speech: "danh từ",
    meaning:
      "đồ đựng bằng thuỷ tinh hoặc sành, sứ, v.v., cổ thấp, đáy thường rộng hơn miệng: lọ hoa * lọ mực * lọ độc bình * đo lọ nước mắm đếm củ dưa hành (tng)",
    example:
      "lọ hoa * lọ mực * lọ độc bình * đo lọ nước mắm đếm củ dưa hành (tng)",
  },
  {
    word: "líu tíu",
    part_of_speech: "tính từ",
    meaning:
      "có vẻ rối rít, vội vàng với cái vui bất ngờ, khiến cho hoạt động trở nên dồn dập, không được bình thường, tự nhiên: miệng líu tíu kể chuyện",
    example: "miệng líu tíu kể chuyện",
  },
  {
    word: "líu nhíu",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) như líu ríu (ng1): chữ líu nhíu khó đọc * giọng líu nhíu như chim",
    example: "chữ líu nhíu khó đọc * giọng líu nhíu như chim",
  },
  {
    word: "ló",
    part_of_speech: "động từ",
    meaning:
      "để lộ một phần nhỏ (thường là cao nhất) ra khỏi vật che khuất: ló đầu qua cửa sổ * mặt trời ló lên sau rặng tre",
    example: "ló đầu qua cửa sổ * mặt trời ló lên sau rặng tre",
  },
  {
    word: "líu ríu",
    part_of_speech: "tính từ",
    meaning:
      "vừa nhỏ vừa như dính quyện vào nhau thành một chuỗi khó phân biệt rạch ròi, khó nhận ra (thường nói về âm thanh, chữ viết): chữ viết líu ríu * đứa trẻ líu ríu nói với mẹ",
    example: "chữ viết líu ríu * đứa trẻ líu ríu nói với mẹ",
  },
  {
    word: "líu ríu",
    part_of_speech: "tính từ",
    meaning:
      "có vẻ như dính quyện vào mà di chuyển theo: sợ quá, chân tay líu ríu * bọn trẻ líu ríu đi bên mẹ",
    example: "sợ quá, chân tay líu ríu * bọn trẻ líu ríu đi bên mẹ",
  },
  {
    word: "lò",
    part_of_speech: "danh từ",
    meaning:
      "khoảng trống nhân tạo trong lòng đất, dùng để thông gió hoặc khai thác khoáng sản: công nhân xuống lò * vào lò khai thác than * bị sập lò",
    example: "công nhân xuống lò * vào lò khai thác than * bị sập lò",
  },
  {
    word: "lò",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ, thiết bị dùng tạo nên nhiệt độ cao để nung nóng, nấu hay sưởi ấm: lò bánh mì * nhóm lò bung ngô * gang đã ra lò * lò lửa chiến tranh (b)",
    example:
      "lò bánh mì * nhóm lò bung ngô * gang đã ra lò * lò lửa chiến tranh (b)",
  },
  {
    word: "lò",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) nơi dạy và luyện môn võ hoặc môn vật: lò vật * lò võ",
    example: "lò vật * lò võ",
  },
  {
    word: "lò",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) nơi chuyên sản xuất một mặt hàng hoặc để làm một việc nào đó: lò giết mổ gia súc * lò sản xuất bánh kẹo",
    example: "lò giết mổ gia súc * lò sản xuất bánh kẹo",
  },
  {
    word: "lò",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) nơi chuyên bồi dưỡng kiến thức hoặc rèn luyện, đào tạo con người về lĩnh vực chuyên môn nào đó: lò luyện thi * lò đào tạo cán bộ",
    example: "lò luyện thi * lò đào tạo cán bộ",
  },
  {
    word: "lò",
    part_of_speech: "danh từ",
    meaning:
      "(thông tục) nhóm người cùng họ hàng, nguồn gốc hay phe cánh (hàm ý khinh): thách cả lò nhà nó!",
    example: "thách cả lò nhà nó!",
  },
  {
    word: "lo",
    part_of_speech: "động từ",
    meaning:
      "ở trong trạng thái phải bận tâm, không yên lòng về việc gì đó vì cho rằng có thể xảy ra điều không hay: đi đêm hôm thế này, tôi thấy lo lắm * chuyện chẳng đáng lo * lo ngay ngáy",
    example:
      "đi đêm hôm thế này, tôi thấy lo lắm * chuyện chẳng đáng lo * lo ngay ngáy",
  },
  {
    word: "lo",
    part_of_speech: "động từ",
    meaning:
      "suy tính, định liệu, chuẩn bị điều kiện, biện pháp để có thể làm tốt việc gì đó thuộc về trách nhiệm của mình: chuyện đó để tôi lo * tính hay lo xa * một người lo bằng kho người làm (tng)",
    example:
      "chuyện đó để tôi lo * tính hay lo xa * một người lo bằng kho người làm (tng)",
  },
  {
    word: "lo",
    part_of_speech: "động từ",
    meaning:
      "để cả tâm trí và sức lực vào nhằm làm tốt hoặc thực hiện cho được một công việc cụ thể nào đó: mải lo làm ăn * lo việc nước * lo chạy chữa thuốc thang",
    example: "mải lo làm ăn * lo việc nước * lo chạy chữa thuốc thang",
  },
  {
    word: "lo",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) lo lót: lo thầy kiện * phải lo mất mấy cây vàng mới êm",
    example: "lo thầy kiện * phải lo mất mấy cây vàng mới êm",
  },
  {
    word: "lõ",
    part_of_speech: "tính từ",
    meaning:
      "(đầu xương hoặc mũi) cao gồ hẳn lên: mũi lõ * người gầy, lõ cả xương sống",
    example: "mũi lõ * người gầy, lõ cả xương sống",
  },
  {
    word: "lo âu",
    part_of_speech: "động từ",
    meaning:
      "lo đến mức thường xuyên và sâu sắc: ánh mắt đầy lo âu * lòng thấp thỏm lo âu",
    example: "ánh mắt đầy lo âu * lòng thấp thỏm lo âu",
  },
  {
    word: "ló dạng",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ, khẩu ngữ) bắt đầu hiện ra, vừa đủ để nhìn thấy hoặc nhận biết được: mặt trời còn chưa ló dạng",
    example: "mặt trời còn chưa ló dạng",
  },
  {
    word: "lo buồn",
    part_of_speech: "động từ",
    meaning: "buồn rầu lo nghĩ: tâm trạng lo buồn * lo buồn quá mà sinh bệnh",
    example: "tâm trạng lo buồn * lo buồn quá mà sinh bệnh",
  },
  {
    word: "lò dò",
    part_of_speech: "động từ",
    meaning:
      "đi lần từng bước ngắn một cách chậm chạp, như thể vừa đi vừa dò đường: bé mới lò dò tập đi",
    example: "bé mới lò dò tập đi",
  },
  {
    word: "lò dò",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) lần mò tìm đến: ở đâu cũng lò dò tìm đến",
    example: "ở đâu cũng lò dò tìm đến",
  },
  {
    word: "lò cò",
    part_of_speech: "động từ",
    meaning:
      "nhảy bằng một chân từng quãng ngắn một, chân kia co lên: chân đau phải nhảy lò cò",
    example: "chân đau phải nhảy lò cò",
  },
  {
    word: "lọ lem",
    part_of_speech: "tính từ",
    meaning: "có nhiều vết nhọ, trông lem luốc: mặt mũi lọ lem",
    example: "mặt mũi lọ lem",
  },
  {
    word: "lo lắng",
    part_of_speech: "động từ",
    meaning:
      "ở trong trạng thái rất không yên lòng và phải để hết tâm sức vào cho công việc gì: vẻ mặt đầy lo lắng * trong lòng lo lắng không yên",
    example: "vẻ mặt đầy lo lắng * trong lòng lo lắng không yên",
  },
  {
    word: "lo lót",
    part_of_speech: "động từ",
    meaning: "tìm cách hối lộ cho được việc: lo lót quan trên",
    example: "lo lót quan trên",
  },
  {
    word: "lò mò",
    part_of_speech: "động từ",
    meaning:
      "đi lại hoặc làm việc mò mẫm, khó khăn trong bóng tối: trời tối vẫn lò mò giặt giũ",
    example: "trời tối vẫn lò mò giặt giũ",
  },
  {
    word: "lò mò",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đi đến nơi nào đó một cách rón rén, thận trọng với vẻ không đàng hoàng: nửa đêm mới dám lò mò về",
    example: "nửa đêm mới dám lò mò về",
  },
  {
    word: "lo liệu",
    part_of_speech: "động từ",
    meaning:
      "tìm cách thu xếp, sắp đặt, chuẩn bị sẵn để đáp ứng với yêu cầu của công việc: lo liệu việc nhà * mọi việc đều do một tay bà lo liệu",
    example: "lo liệu việc nhà * mọi việc đều do một tay bà lo liệu",
  },
  {
    word: "lọ mọ",
    part_of_speech: "",
    meaning:
      "(đi lại, làm việc) chậm chạp vì không dễ dàng, nhưng chịu khó, kiên trì: xa thế mà cũng lọ mọ tìm đến * cả ngày lọ mọ cơm nước, giặt giũ",
    example: "xa thế mà cũng lọ mọ tìm đến * cả ngày lọ mọ cơm nước, giặt giũ",
  },
  {
    word: "ló mặt",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) có mặt ở một nơi nào đó và chịu sự tác động: xấu hổ, không dám ló mặt ra đường",
    example: "xấu hổ, không dám ló mặt ra đường",
  },
  {
    word: "lo ngại",
    part_of_speech: "động từ",
    meaning:
      "lo lắng và e ngại: bệnh tình không đáng lo ngại * lo ngại cho hoàn cảnh éo le của bạn",
    example:
      "bệnh tình không đáng lo ngại * lo ngại cho hoàn cảnh éo le của bạn",
  },
  {
    word: "lo nghĩ",
    part_of_speech: "động từ",
    meaning:
      "lo lắng và nghĩ ngợi: lòng băn khoăn lo nghĩ * không phải lo nghĩ gì",
    example: "lòng băn khoăn lo nghĩ * không phải lo nghĩ gì",
  },
  {
    word: "lọ nghẹ",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) nhọ nồi: mặt dính đầy lọ nghẹ",
    example: "mặt dính đầy lọ nghẹ",
  },
  {
    word: "lo phiền",
    part_of_speech: "động từ",
    meaning:
      'buồn phiền lo nghĩ: trút bỏ nỗi lo phiền * "Năm canh con khóc cả năm, Ôm con mẹ chịu khổ tâm lo phiền." (ca dao)',
    example:
      'trút bỏ nỗi lo phiền * "Năm canh con khóc cả năm, Ôm con mẹ chịu khổ tâm lo phiền." (ca dao)',
  },
  {
    word: "lo sốt vó",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) lo đến mức cuống lên, đứng ngồi không yên: hơi một tí đã lo sốt vó lên!",
    example: "hơi một tí đã lo sốt vó lên!",
  },
  {
    word: "lo sợ",
    part_of_speech: "động từ",
    meaning:
      'lo lắng và có phần sợ hãi: lòng nơm nớp lo sợ * "Xuân huyên lo sợ xiết bao, Quá ra khi đến thế nào mà hay!" (TKiều)',
    example:
      'lòng nơm nớp lo sợ * "Xuân huyên lo sợ xiết bao, Quá ra khi đến thế nào mà hay!" (TKiều)',
  },
  {
    word: "lo toan",
    part_of_speech: "động từ",
    meaning:
      "lo liệu công việc với tinh thần trách nhiệm cao: lo toan công việc * một người biết lo toan",
    example: "lo toan công việc * một người biết lo toan",
  },
  {
    word: "lo tính",
    part_of_speech: "động từ",
    meaning:
      "lo liệu, tính toán: lo tính công việc * chỉ biết lo tính cho bản thân",
    example: "lo tính công việc * chỉ biết lo tính cho bản thân",
  },
  {
    word: "lò sưởi",
    part_of_speech: "danh từ",
    meaning: "lò được đốt nóng để sưởi ấm: đốt lò sưởi",
    example: "đốt lò sưởi",
  },
  {
    word: "lò xo",
    part_of_speech: "danh từ",
    meaning:
      "vật thường bằng thép, được uốn thành nhiều vòng xoắn, có sức đàn hồi, dùng để giữ những vật khác (thường là những chi tiết máy) nào đó ở vị trí cần có: đệm lò xo * ngồi bật dậy như cái lò xo",
    example: "đệm lò xo * ngồi bật dậy như cái lò xo",
  },
  {
    word: "loa",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ hình phễu, có tác dụng định hướng làm âm đi xa hơn và nghe rõ hơn: nói loa * loa phát thanh * bắc loa tay để gọi",
    example: "nói loa * loa phát thanh * bắc loa tay để gọi",
  },
  {
    word: "loa",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ biến các dao động điện thành dao động âm và phát to ra: dàn nhạc được trang bị loại loa công suất lớn",
    example: "dàn nhạc được trang bị loại loa công suất lớn",
  },
  {
    word: "loa",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) truyền tin cho mọi người biết, thường bằng loa: loa lại cho mọi người cùng biết",
    example: "loa lại cho mọi người cùng biết",
  },
  {
    word: "loa",
    part_of_speech: "tính từ",
    meaning: "có hình loe ra tựa cái loa: bát loa",
    example: "bát loa",
  },
  {
    word: "lo xa",
    part_of_speech: "động từ",
    meaning:
      "suy tính để đề phòng trước việc bất trắc sau này có thể xảy ra: tính hay lo xa * người biết lo xa",
    example: "tính hay lo xa * người biết lo xa",
  },
  {
    word: "loá",
    part_of_speech: "động từ",
    meaning:
      "bị rối loạn thị giác do tác động của ánh sáng có cường độ quá mạnh: đèn pha chiếu vào làm mắt bị loá",
    example: "đèn pha chiếu vào làm mắt bị loá",
  },
  {
    word: "loá",
    part_of_speech: "tính từ",
    meaning:
      "(ánh sáng) có cường độ mạnh, khiến cho bị rối loạn thị giác: ánh chớp sáng loá * nắng loá",
    example: "ánh chớp sáng loá * nắng loá",
  },
  {
    word: "loà",
    part_of_speech: "tính từ",
    meaning:
      "(mắt) không còn khả năng nhìn rõ, chỉ có thể nhìn thấy mọi vật lờ mờ: mắt bị loà",
    example: "mắt bị loà",
  },
  {
    word: "loà",
    part_of_speech: "tính từ",
    meaning:
      "(gương) không còn phản chiếu được rõ nét, soi chỉ thấy hình ảnh mờ mờ: gương loà",
    example: "gương loà",
  },
  {
    word: "loà",
    part_of_speech: "tính từ",
    meaning:
      "có độ sáng quá mức bình thường, đến mức như làm chói mắt, không nhìn được rõ nét: ánh nắng chói loà * gươm tuốt sáng loà",
    example: "ánh nắng chói loà * gươm tuốt sáng loà",
  },
  {
    word: "loã lồ",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái hoàn toàn không có thứ gì che thân (thường nói về người lớn; hàm ý xem thường): thân thể gần như loã lồ",
    example: "thân thể gần như loã lồ",
  },
  {
    word: "loa loá",
    part_of_speech: "tính từ",
    meaning:
      "hơi bị loá do bị ánh sáng chiếu mạnh và liên tiếp: vệt sáng loa loá",
    example: "vệt sáng loa loá",
  },
  {
    word: "loà nhoà",
    part_of_speech: "tính từ",
    meaning:
      "nhoà đi, lờ mờ, không rõ nét: bóng núi loà nhoà ẩn hiện trong sương",
    example: "bóng núi loà nhoà ẩn hiện trong sương",
  },
  {
    word: "loả toả",
    part_of_speech: "",
    meaning:
      "buông rủ hay rơi xuống không đều, mỗi cái một hướng, trông không gọn: lá khô rơi loả toả * dải khăn đào loả toả xuống tận gấu váy",
    example: "lá khô rơi loả toả * dải khăn đào loả toả xuống tận gấu váy",
  },
  {
    word: "loá mắt",
    part_of_speech: "động từ",
    meaning:
      "bị choáng ngợp trước sức cám dỗ, khiến cho mất cả sáng suốt, tỉnh táo: loá mắt vì tiền",
    example: "loá mắt vì tiền",
  },
  {
    word: "loạc choạc",
    part_of_speech: "tính từ",
    meaning:
      "(tổ chức, hoạt động) không ăn nhịp, ăn khớp với nhau giữa các bộ phận: hàng ngũ loạc choạc * tổ chức còn loạc choạc",
    example: "hàng ngũ loạc choạc * tổ chức còn loạc choạc",
  },
  {
    word: "loã xoã",
    part_of_speech: "động từ",
    meaning:
      "(tóc) xoã xuống và toả ra không đều, không gọn: mái tóc mềm bay loã xoã",
    example: "mái tóc mềm bay loã xoã",
  },
  {
    word: "loà xoà",
    part_of_speech: "động từ",
    meaning:
      "(vật mềm dài) buông xuống và toả ra không đều, không gọn: cành lá loà xoà * tóc rủ loà xoà xuống trán",
    example: "cành lá loà xoà * tóc rủ loà xoà xuống trán",
  },
  {
    word: "loã thể",
    part_of_speech: "tính từ",
    meaning: "(cũ) như khoả thân: hoạ sĩ chuyên vẽ tranh loã thể",
    example: "hoạ sĩ chuyên vẽ tranh loã thể",
  },
  {
    word: "loài",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị phân loại sinh học, chỉ những nhóm thuộc cùng một giống: loài thú * loài bò sát * loài hoa * loài người",
    example: "loài thú * loài bò sát * loài hoa * loài người",
  },
  {
    word: "loài",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) loại người có cùng một bản chất xấu xa như nhau: loài tà gian * cùng một loài đầu trộm đuôi cướp",
    example: "loài tà gian * cùng một loài đầu trộm đuôi cướp",
  },
  {
    word: "loại",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp người, vật hoặc hiện tượng có chung những đặc trưng nào đó (phân biệt với những người, vật hoặc hiện tượng khác): chọn loại vải tốt * có đủ các loại sách * học vào loại giỏi",
    example: "chọn loại vải tốt * có đủ các loại sách * học vào loại giỏi",
  },
  {
    word: "loại",
    part_of_speech: "động từ",
    meaning:
      "lọc bỏ ra những cái xấu, những cái không đạt yêu cầu hoặc không sử dụng được: chọn hạt mẩy, loại hạt lép * sức khoẻ yếu nên bị loại * giấy loại",
    example:
      "chọn hạt mẩy, loại hạt lép * sức khoẻ yếu nên bị loại * giấy loại",
  },
  {
    word: "loại",
    part_of_speech: "động từ",
    meaning:
      "đưa ra khỏi vì bị thua trong thi đấu, trong chiến đấu: vòng đấu loại * loại trực tiếp * bị loại khỏi vòng chiến đấu",
    example: "vòng đấu loại * loại trực tiếp * bị loại khỏi vòng chiến đấu",
  },
  {
    word: "loai choai",
    part_of_speech: "động từ",
    meaning: "(hiếm) như choai choai.",
    example: "ông lão loai choai trên sàn chòi",
  },
  {
    word: "loại bỏ",
    part_of_speech: "động từ",
    meaning:
      "loại khỏi, bỏ đi vì không còn giá trị nữa (nói khái quát): loại bỏ hàng quá đát * loại bỏ lề thói cổ hủ",
    example: "loại bỏ hàng quá đát * loại bỏ lề thói cổ hủ",
  },
  {
    word: "loại biệt",
    part_of_speech: "tính từ",
    meaning: "có tác dụng phân biệt về loại: đặc trưng loại biệt",
    example: "đặc trưng loại biệt",
  },
  {
    word: "loại hình",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp sự vật, hiện tượng cùng có chung những đặc trưng cơ bản nào đó: loại hình nghệ thuật * đa dạng hoá các loại hình đào tạo",
    example: "loại hình nghệ thuật * đa dạng hoá các loại hình đào tạo",
  },
  {
    word: "loại trừ",
    part_of_speech: "động từ",
    meaning:
      "loại bỏ, làm cho mất đi, hết đi (cái xấu, cái đối lập): phát huy cái tốt, loại trừ cái xấu * loại trừ mầm mống dịch bệnh",
    example: "phát huy cái tốt, loại trừ cái xấu * loại trừ mầm mống dịch bệnh",
  },
  {
    word: "loại trừ",
    part_of_speech: "động từ",
    meaning:
      "gạt riêng ra, không kể đến: không loại trừ tình huống xấu có thể xảy ra",
    example: "không loại trừ tình huống xấu có thể xảy ra",
  },
  {
    word: "loài người",
    part_of_speech: "danh từ",
    meaning:
      "tổng thể những người trên Trái Đất nói chung: xã hội loài người * lịch sử loài người",
    example: "xã hội loài người * lịch sử loài người",
  },
  {
    word: "loan",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) chim phượng mái: "Cất lên một tiếng linh đình, Cho loan sánh phượng, cho mình sánh ta." (ca dao)',
    example:
      'Cất lên một tiếng linh đình, Cho loan sánh phượng, cho mình sánh ta." (ca dao)',
  },
  {
    word: "loại suy",
    part_of_speech: "động từ",
    meaning:
      "suy luận để loại bỏ dần các trường hợp và đưa ra kết luận về một sự lựa chọn hợp lí nhất: phương pháp loại suy",
    example: "phương pháp loại suy",
  },
  {
    word: "loại hình học",
    part_of_speech: "danh từ",
    meaning:
      "khoa học nghiên cứu về các loại hình nhằm giúp cho việc phân loại một thực tại phức tạp: loại hình học ngôn ngữ",
    example: "loại hình học ngôn ngữ",
  },
  {
    word: "loạn",
    part_of_speech: "danh từ",
    meaning:
      "sự chống đối bằng bạo lực nhằm làm mất trật tự và an ninh xã hội: đất nước có loạn * dẹp trừ mầm loạn",
    example: "đất nước có loạn * dẹp trừ mầm loạn",
  },
  {
    word: "loạn",
    part_of_speech: "tính từ",
    meaning: "ở tình trạng có loạn: trai thời loạn, gái thời bình (tng)",
    example: "trai thời loạn, gái thời bình (tng)",
  },
  {
    word: "loạn",
    part_of_speech: "tính từ",
    meaning:
      "ở tình trạng lộn xộn, không theo một trật tự hoặc nền nếp bình thường nào cả: tim đập loạn nhịp * đầu óc cứ loạn lên * tiếng la hét, cười đùa loạn cả xóm",
    example:
      "tim đập loạn nhịp * đầu óc cứ loạn lên * tiếng la hét, cười đùa loạn cả xóm",
  },
  {
    word: "loan báo",
    part_of_speech: "động từ",
    meaning:
      "báo tin cho mọi người biết một cách rộng rãi: loan báo tin thắng trận",
    example: "loan báo tin thắng trận",
  },
  {
    word: "loạn lạc",
    part_of_speech: "danh từ",
    meaning:
      "tình trạng xã hội lộn xộn, không còn có trật tự, an ninh do có loạn: dẹp yên loạn lạc * sống ở thời loạn lạc",
    example: "dẹp yên loạn lạc * sống ở thời loạn lạc",
  },
  {
    word: "loạn đả",
    part_of_speech: "động từ",
    meaning: "đánh nhau loạn xị: vụ loạn đả",
    example: "vụ loạn đả",
  },
  {
    word: "loạn li",
    part_of_speech: "",
    meaning:
      "tình trạng xã hội có loạn, gây ra những cảnh gia đình li tán: cảnh loạn li",
    example: "cảnh loạn li",
  },
  {
    word: "loan giá",
    part_of_speech: "danh từ",
    meaning: "(cũ): loan giá hồi cung",
    example: "loan giá hồi cung",
  },
  {
    word: "loạn ngôn",
    part_of_speech: "động từ",
    meaning:
      "nói năng bừa bãi, không kể gì phải trái, hay dở: ăn nói loạn ngôn",
    example: "ăn nói loạn ngôn",
  },
  {
    word: "loạn ly",
    part_of_speech: "",
    meaning:
      "tình trạng xã hội có loạn, gây ra những cảnh gia đình li tán: cảnh loạn li",
    example: "cảnh loạn li",
  },
  {
    word: "loan phượng",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) chim phượng trống (phượng) và chim phượng mái (loan); dùng để tượng trưng cho cặp vợ chồng đẹp đôi: "Mừng cho loan phượng nên đôi, Tấm thân vinh hiển nhờ tài trượng phu." (PT)',
    example:
      'Mừng cho loan phượng nên đôi, Tấm thân vinh hiển nhờ tài trượng phu." (PT)',
  },
  {
    word: "loan phòng",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) phòng ngủ của vợ chồng (thường có tấm màn thêu chim loan): "Mình em vò võ loan phòng, Lẻ loi gối chiếc lạnh lùng chăn loan." (ca dao)',
    example:
      'Mình em vò võ loan phòng, Lẻ loi gối chiếc lạnh lùng chăn loan." (ca dao)',
  },
  {
    word: "loạn thị",
    part_of_speech: "tính từ",
    meaning:
      "(mắt) không nhìn rõ được như nhau ở các hướng, do bị tật: bị loạn thị bẩm sinh * đeo kính loạn thị",
    example: "bị loạn thị bẩm sinh * đeo kính loạn thị",
  },
  {
    word: "loạn quân",
    part_of_speech: "danh từ",
    meaning:
      "quân lính bị rối loạn, không còn giữ được kỉ luật và sự chỉ huy thống nhất (thường do thua trận): đám loạn quân",
    example: "đám loạn quân",
  },
  {
    word: "loạn sắc",
    part_of_speech: "tính từ",
    meaning:
      "(mắt) không phân biệt được một số màu, đặc biệt là màu đỏ và xanh, do bị tật: bị bệnh loạn sắc",
    example: "bị bệnh loạn sắc",
  },
  {
    word: "loạn xạ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ở tình trạng loạn hết cả lên, không theo một trật tự hoặc một phương hướng nhất định nào cả: tim đập loạn xạ * chạy loạn xạ * súng bắn loạn xạ",
    example: "tim đập loạn xạ * chạy loạn xạ * súng bắn loạn xạ",
  },
  {
    word: "loạn xị",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ở tình trạng rất rối loạn, lung tung, không theo một trật tự nào cả: cãi nhau loạn xị * tiếng máy bay gầm rú loạn xị",
    example: "cãi nhau loạn xị * tiếng máy bay gầm rú loạn xị",
  },
  {
    word: "loạn trí",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái thần kinh bị rối loạn, dẫn đến mất trí khôn: suy nghĩ nhiều đâm ra loạn trí",
    example: "suy nghĩ nhiều đâm ra loạn trí",
  },
  {
    word: "loãng",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều nước ít cái hoặc có độ đậm đặc thấp: cháo loãng * nước muối pha loãng * acid loãng",
    example: "cháo loãng * nước muối pha loãng * acid loãng",
  },
  {
    word: "loang",
    part_of_speech: "động từ",
    meaning:
      "lan rộng dần ra: dầu loang trên mặt nước * vệt tóc bạc ngày càng loang rộng * cỏ loang trùm lối đi",
    example:
      "dầu loang trên mặt nước * vệt tóc bạc ngày càng loang rộng * cỏ loang trùm lối đi",
  },
  {
    word: "loang",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều mảng màu sắc xen lẫn nhau, trải ra không đều trên bề mặt: lợn loang * bò lông loang",
    example: "lợn loang * bò lông loang",
  },
  {
    word: "loáng",
    part_of_speech: "động từ",
    meaning:
      "chiếu sáng lướt nhanh trên bề mặt: lưỡi thép loáng lên trong ánh nắng",
    example: "lưỡi thép loáng lên trong ánh nắng",
  },
  {
    word: "loáng",
    part_of_speech: "tính từ",
    meaning:
      "sáng, bóng đến mức phản chiếu được ánh sáng gần như mặt gương: lưỡi lê sáng loáng",
    example: "lưỡi lê sáng loáng",
  },
  {
    word: "loáng",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian rất ngắn, qua rất nhanh: làm một loáng là xong * vừa ở đây mà loáng cái đã biến đâu mất!",
    example: "làm một loáng là xong * vừa ở đây mà loáng cái đã biến đâu mất!",
  },
  {
    word: "loang lổ",
    part_of_speech: "tính từ",
    meaning:
      "có những mảng màu hoặc vết bẩn xen vào nhau một cách lộn xộn, trông xấu: tường tróc sơn loang lổ",
    example: "tường tróc sơn loang lổ",
  },
  {
    word: "loạng quạng",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái không chủ động giữ được thế thăng bằng, do không xác định được hướng di chuyển: người mệt, bước đi loạng quạng * tay lái loạng quạng",
    example: "người mệt, bước đi loạng quạng * tay lái loạng quạng",
  },
  {
    word: "loang loáng",
    part_of_speech: "",
    meaning:
      "chiếu sáng hoặc được chiếu sáng lướt nhanh trên bề mặt một cách liên tiếp, tạo thành những vệt sáng không đều: ánh đèn pin quét loang loáng",
    example: "ánh đèn pin quét loang loáng",
  },
  {
    word: "loang toàng",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như buông tuồng: lối sống loang toàng",
    example: "lối sống loang toàng",
  },
  {
    word: "loạng choạng",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái không vững, không giữ được thế thăng bằng, chỉ chực ngã: chân bước loạng choạng * chiếc xe loạng choạng, chực đổ",
    example: "chân bước loạng choạng * chiếc xe loạng choạng, chực đổ",
  },
  {
    word: "loáng quáng",
    part_of_speech: "tính từ",
    meaning:
      "vội vàng, lập cập, khiến cho động tác trở nên vụng về, thiếu chính xác: loáng quáng thế nào lại đánh vỡ cái bát",
    example: "loáng quáng thế nào lại đánh vỡ cái bát",
  },
  {
    word: "loàng xoàng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) xoàng, không có gì đáng nói, đáng kể: làm ăn loàng xoàng * cúm loàng xoàng",
    example: "làm ăn loàng xoàng * cúm loàng xoàng",
  },
  {
    word: "loáng thoáng",
    part_of_speech: "tính từ",
    meaning:
      "ít và phân bố không đều, chỗ có chỗ không, lúc có lúc không: bầu trời điểm loáng thoáng mấy vì sao * đường phố loáng thoáng bóng người",
    example:
      "bầu trời điểm loáng thoáng mấy vì sao * đường phố loáng thoáng bóng người",
  },
  {
    word: "loáng thoáng",
    part_of_speech: "tính từ",
    meaning:
      "không rõ ràng, cụ thể, chỉ ghi nhận được một vài nét thoáng qua: nghe loáng thoáng * nhớ loáng thoáng",
    example: "nghe loáng thoáng * nhớ loáng thoáng",
  },
  {
    word: "loảng xoảng",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng phát ra đanh và vang xa như tiếng của những vật bằng kim loại, sành, sứ va chạm mạnh vào nhau: xô chậu va vào nhau loảng xoảng",
    example: "xô chậu va vào nhau loảng xoảng",
  },
  {
    word: "loãng toẹt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) rất loãng, đến mức tựa như chỉ có nước không: cháo nấu loãng toẹt",
    example: "cháo nấu loãng toẹt",
  },
  {
    word: "loạt soạt",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng động như của lá khô hoặc vải cứng cọ xát vào nhau: tiếng giấy loạt soạt * chân giẫm lên lá khô loạt soạt",
    example: "tiếng giấy loạt soạt * chân giẫm lên lá khô loạt soạt",
  },
  {
    word: "loạt",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp gồm nhiều vật cùng loại xuất hiện cùng một lúc: bắn loạt đạn đầu tiên * pháo nổ đều loạt * một loạt các mặt hàng cùng lên giá",
    example:
      "bắn loạt đạn đầu tiên * pháo nổ đều loạt * một loạt các mặt hàng cùng lên giá",
  },
  {
    word: "loãng xương",
    part_of_speech: "danh từ",
    meaning:
      "hiện tượng xương bị lão hoá do thiếu lượng canxi cần thiết ở người cao tuổi, xương trở nên dễ gãy: bổ sung calcium để phòng chứng loãng xương",
    example: "bổ sung calcium để phòng chứng loãng xương",
  },
  {
    word: "loanh quanh",
    part_of_speech: "",
    meaning:
      "di chuyển, hoạt động theo một đường vòng trở đi trở lại, trong một phạm vi nhất định: đi loanh quanh trong vườn * gà con loanh quanh bên chân mẹ",
    example: "đi loanh quanh trong vườn * gà con loanh quanh bên chân mẹ",
  },
  {
    word: "loanh quanh",
    part_of_speech: "",
    meaning:
      "nói xa xôi, vòng vèo, chứ không đi thẳng vào cái chính, cái trọng tâm: nói loanh quanh * không nói thẳng, chỉ rào đón loanh quanh",
    example: "nói loanh quanh * không nói thẳng, chỉ rào đón loanh quanh",
  },
  {
    word: "loằng ngoằng",
    part_of_speech: "tính từ",
    meaning:
      "có hình giống như những đường ngoằn ngoèo chồng chéo hay rối vào nhau: chữ viết loằng ngoằng * chớp rạch loằng ngoằng trên nền trời",
    example: "chữ viết loằng ngoằng * chớp rạch loằng ngoằng trên nền trời",
  },
  {
    word: "loăn xoăn",
    part_of_speech: "tính từ",
    meaning:
      "(tóc hay sợi nhỏ) quăn, xoắn thành nhiều vòng nhiều lớp liên tiếp: búp tóc loăn xoăn",
    example: "búp tóc loăn xoăn",
  },
  {
    word: "loăng quăng",
    part_of_speech: "tính từ",
    meaning:
      "(đi hoặc nghĩ) lung tung, từ chỗ này đến chỗ khác, từ chuyện này sang chuyện khác, không có định hướng hoặc mục đích gì rõ ràng: chạy loăng quăng khắp sân * ngồi học nhưng trong đầu nghĩ loăng quăng chuyện khác",
    example:
      "chạy loăng quăng khắp sân * ngồi học nhưng trong đầu nghĩ loăng quăng chuyện khác",
  },
  {
    word: "loay hoay",
    part_of_speech: "động từ",
    meaning:
      "từ gợi tả dáng vẻ cặm cụi thử đi thử lại hết cách này đến cách khác để cố làm cho được: loay hoay mãi vẫn không mở được cửa * loay hoay với cái xe hỏng",
    example: "loay hoay mãi vẫn không mở được cửa * loay hoay với cái xe hỏng",
  },
  {
    word: "loắt choắt",
    part_of_speech: "tính từ",
    meaning: "(vóc dáng) bé nhỏ quá mức: người bé loắt choắt",
    example: "người bé loắt choắt",
  },
  {
    word: "lóc cóc",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng những tiếng vang, thanh và gọn phát ra đều đều như tiếng gõ vào vật cứng: tiếng mõ lóc cóc",
    example: "tiếng mõ lóc cóc",
  },
  {
    word: "lóc cóc",
    part_of_speech: "phụ từ",
    meaning:
      "(dáng đi, chạy) một cách vất vả, với vẻ cô đơn, đáng thương: lóc cóc đi bộ hàng chục cây số * lóc cóc đạp xe lên tỉnh",
    example: "lóc cóc đi bộ hàng chục cây số * lóc cóc đạp xe lên tỉnh",
  },
  {
    word: "lọc",
    part_of_speech: "động từ",
    meaning:
      "làm sạch chất lỏng, chất khí bằng cách cho qua một lớp hay một dụng cụ có tác dụng giữ chất rắn hoặc cặn bẩn lại: lọc bột làm bánh * lọc nước * thuốc lá có đầu lọc",
    example: "lọc bột làm bánh * lọc nước * thuốc lá có đầu lọc",
  },
  {
    word: "lọc",
    part_of_speech: "động từ",
    meaning:
      "tách riêng ra để lấy cái phù hợp với yêu cầu: lọc mỡ ra khỏi thịt * lọc thóc giống",
    example: "lọc mỡ ra khỏi thịt * lọc thóc giống",
  },
  {
    word: "lọc lừa",
    part_of_speech: "động từ",
    meaning: "(hiếm) như lừa lọc: một kẻ lọc lừa, xảo trá",
    example: "một kẻ lọc lừa, xảo trá",
  },
  {
    word: "lóc",
    part_of_speech: "động từ",
    meaning:
      "(cá) len lách ngược dòng nước để vượt lên (khi có mưa rào): cá rô lóc",
    example: "cá rô lóc",
  },
  {
    word: "lóc",
    part_of_speech: "động từ",
    meaning:
      "tách lấy riêng ra lớp da thịt dính vào xương bằng vật có lưỡi sắc: lóc lấy phần thịt của con cá",
    example: "lóc lấy phần thịt của con cá",
  },
  {
    word: "lọc lõi",
    part_of_speech: "tính từ",
    meaning:
      "từng trải và khôn ngoan, có đủ kinh nghiệm, biết đủ mọi mánh khoé (thường hàm ý chê): một tay buôn lọc lõi",
    example: "một tay buôn lọc lõi",
  },
  {
    word: "lọc cọc",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng những tiếng trầm phát ra lúc nhỏ lúc to không đều như tiếng khua, gõ xuống mặt đất, đá cứng: vó ngựa khua lọc cọc * chống gậy lọc cọc",
    example: "vó ngựa khua lọc cọc * chống gậy lọc cọc",
  },
  {
    word: "lọc cọc",
    part_of_speech: "phụ từ",
    meaning: "như lóc cóc: lọc cọc chạy theo mẹ",
    example: "lọc cọc chạy theo mẹ",
  },
  {
    word: "lóc ngóc",
    part_of_speech: "động từ",
    meaning:
      "từ gợi tả dáng vẻ cố ngóc đầu lên (để làm việc gì): đang còn ốm nhưng vẫn lóc ngóc ngồi dậy",
    example: "đang còn ốm nhưng vẫn lóc ngóc ngồi dậy",
  },
  {
    word: "lóc xóc",
    part_of_speech: "tính từ",
    meaning: "như lọc xọc: tiếng băng đạn lóc xóc trong bao da",
    example: "tiếng băng đạn lóc xóc trong bao da",
  },
  {
    word: "lóc nhóc",
    part_of_speech: "tính từ",
    meaning:
      "đông, nhiều, thuộc cùng một lứa, một loại nhỏ như nhau và chen chúc nhau: đàn con lóc nhóc * một lứa lợn lóc nhóc",
    example: "đàn con lóc nhóc * một lứa lợn lóc nhóc",
  },
  {
    word: "loe loé",
    part_of_speech: "động từ",
    meaning:
      "(ánh sáng) hơi loé lên rồi vụt tắt ngay liên tiếp: đèn máy ảnh chớp loe loé",
    example: "đèn máy ảnh chớp loe loé",
  },
  {
    word: "loe",
    part_of_speech: "động từ",
    meaning:
      'toả sáng ra một cách yếu ớt: nắng chiều loe lên rồi tắt hẳn * "Buồn trông gương sớm đèn khuya, Gương mờ nước thuỷ, đèn loe lửa phiền." (BNT)',
    example:
      'nắng chiều loe lên rồi tắt hẳn * "Buồn trông gương sớm đèn khuya, Gương mờ nước thuỷ, đèn loe lửa phiền." (BNT)',
  },
  {
    word: "loe",
    part_of_speech: "tính từ",
    meaning:
      "(vật hình ống) có hình dáng rộng dần ra về phía miệng: chiếc kèn loe miệng * quần ống loe",
    example: "chiếc kèn loe miệng * quần ống loe",
  },
  {
    word: "lọc xọc",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng phát ra nhỏ và trầm đều như tiếng của các vật cứng nhỏ bị xóc, bị lắc liên tiếp trong vật đựng: xe lọc xọc trên đường đá * rít điếu cày lọc xọc",
    example: "xe lọc xọc trên đường đá * rít điếu cày lọc xọc",
  },
  {
    word: "loè bịp",
    part_of_speech: "động từ",
    meaning: "khoe khoang dối trá để đánh lừa: loè bịp thiên hạ",
    example: "loè bịp thiên hạ",
  },
  {
    word: "loé",
    part_of_speech: "động từ",
    meaning:
      "phát sáng mạnh đột ngột rồi vụt tắt: ánh đèn pin chốc chốc lại loé sáng * chớp loé liên hồi",
    example: "ánh đèn pin chốc chốc lại loé sáng * chớp loé liên hồi",
  },
  {
    word: "loé",
    part_of_speech: "động từ",
    meaning:
      "vụt hiện ra đột ngột như một tia sáng: loé lên một ý tưởng mới * mắt loé lên niềm vui sướng",
    example: "loé lên một ý tưởng mới * mắt loé lên niềm vui sướng",
  },
  {
    word: "loè xoè",
    part_of_speech: "động từ",
    meaning:
      "buông dài xuống và xoè rộng ra, gây cảm giác vướng bận, không gọn: váy áo loè xoè",
    example: "váy áo loè xoè",
  },
  {
    word: "loe loét",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như nhoe nhoét: môi tô son loe loét",
    example: "môi tô son loe loét",
  },
  {
    word: "loét",
    part_of_speech: "động từ",
    meaning:
      "(da thịt) bị huỷ hoại dần dần làm lộ ra tổ chức ở lớp dưới: vết đau bị loét ra * loét dạ dày",
    example: "vết đau bị loét ra * loét dạ dày",
  },
  {
    word: "loè loẹt",
    part_of_speech: "tính từ",
    meaning:
      "có quá nhiều màu sắc sặc sỡ làm mất vẻ đẹp giản dị, tự nhiên: phấn son loè loẹt * ăn mặc loè loẹt",
    example: "phấn son loè loẹt * ăn mặc loè loẹt",
  },
  {
    word: "loẹt quẹt",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng như tiếng guốc dép đi lê trên nền cứng: tiếng chổi loẹt quẹt ngoài sân",
    example: "tiếng chổi loẹt quẹt ngoài sân",
  },
  {
    word: "loè",
    part_of_speech: "động từ",
    meaning:
      "phát sáng đột ngột và toả sáng ra mạnh mẽ: lửa loè lên rồi tắt * mắt loè đom đóm * ánh chớp loè đỏ",
    example: "lửa loè lên rồi tắt * mắt loè đom đóm * ánh chớp loè đỏ",
  },
  {
    word: "loè",
    part_of_speech: "động từ",
    meaning: "khoe khoang để đánh lừa: chưa chi đã muốn loè nhau",
    example: "chưa chi đã muốn loè nhau",
  },
  {
    word: "loè nhoè",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) nhoè đi, chỉ trông thấy lờ mờ, không rõ nét: cảnh vật loè nhoè trước mắt",
    example: "cảnh vật loè nhoè trước mắt",
  },
  {
    word: "logarithm",
    part_of_speech: "danh từ",
    meaning:
      "số mũ của luỹ thừa mà phải nâng một số dương cố định (gọi là cơ số) lên để được số cho trước: logarithm thập phân",
    example: "logarithm thập phân",
  },
  {
    word: "logic",
    part_of_speech: "danh từ",
    meaning: "logic học (nói tắt): logic hình thức * logic toán học",
    example: "logic hình thức * logic toán học",
  },
  {
    word: "logic",
    part_of_speech: "danh từ",
    meaning:
      "trật tự chặt chẽ, tất yếu giữa các hiện tượng: logic của cuộc sống * suy luận theo logic trẻ thơ",
    example: "logic của cuộc sống * suy luận theo logic trẻ thơ",
  },
  {
    word: "logic",
    part_of_speech: "danh từ",
    meaning:
      "sự gắn bó chặt chẽ giữa các ý, cách suy luận chặt chẽ: suy luận thiếu logic",
    example: "suy luận thiếu logic",
  },
  {
    word: "logic",
    part_of_speech: "tính từ",
    meaning: "đúng với quy luật logic: cách suy luận rất logic",
    example: "cách suy luận rất logic",
  },
  {
    word: "logic",
    part_of_speech: "tính từ",
    meaning:
      "hợp với logic, giữa các hiện tượng có mối quan hệ chặt chẽ, tất yếu: sự việc diễn ra rất logic",
    example: "sự việc diễn ra rất logic",
  },
  {
    word: "loi",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) thoi: loi cho một cái đau điếng",
    example: "loi cho một cái đau điếng",
  },
  {
    word: "logo",
    part_of_speech: "danh từ",
    meaning:
      "hình vẽ riêng, dùng làm hình ảnh tượng trưng cho một công ti, một tổ chức: trên sản phẩm có in logo của công ti",
    example: "trên sản phẩm có in logo của công ti",
  },
  {
    word: "lói",
    part_of_speech: "danh từ",
    meaning: "(Khẩu ngữ) pháo làm bằng thuốc nổ nhồi vào ống dài: đốt lói",
    example: "đốt lói",
  },
  {
    word: "lói",
    part_of_speech: "tính từ",
    meaning: "(Từ cũ, hoặc ph) như nhói: vết thương thỉnh thoảng lại lói lên",
    example: "vết thương thỉnh thoảng lại lói lên",
  },
  {
    word: "lói",
    part_of_speech: "động từ",
    meaning: "(Phương ngữ) gãy: ngã lọi chân * bị đánh lọi xương",
    example: "ngã lọi chân * bị đánh lọi xương",
  },
  {
    word: "lòi",
    part_of_speech: "động từ",
    meaning:
      "nhô hẳn ra ngoài lớp bao bọc: tất thủng, lòi cả ngón chân * bị đâm lòi ruột * cái kim trong bọc lâu ngày cũng phải lòi ra (tng)",
    example:
      "tất thủng, lòi cả ngón chân * bị đâm lòi ruột * cái kim trong bọc lâu ngày cũng phải lòi ra (tng)",
  },
  {
    word: "lòi",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) để lộ ra cái muốn giấu (thường là cái xấu, đáng chê): lòi cái bộ mặt đểu cáng",
    example: "lòi cái bộ mặt đểu cáng",
  },
  {
    word: "lõi",
    part_of_speech: "danh từ",
    meaning:
      "phần gỗ già ở giữa thân cây, sẫm màu và cứng hơn phần dác ở phía ngoài: gỗ lõi * lõi dầu hơn dác gụ (tng)",
    example: "gỗ lõi * lõi dầu hơn dác gụ (tng)",
  },
  {
    word: "lõi",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận ở giữa, thường rắn chắc, làm chỗ dựa cho bộ phận bao quanh, trong một số vật: lõi ngô * lõi dây điện * hiểu được cái lõi của vấn đề",
    example: "lõi ngô * lõi dây điện * hiểu được cái lõi của vấn đề",
  },
  {
    word: "lỏi",
    part_of_speech: "danh từ",
    meaning: "(thông tục) ranh con: thằng lỏi con",
    example: "thằng lỏi con",
  },
  {
    word: "lỏi",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) không đồng đều, còn có nhiều chỗ làm dối, chưa đạt hoặc còn để sót lại nhiều cái xấu, kém: cày lỏi * xấu đều hơn tốt lỏi (tng)",
    example: "cày lỏi * xấu đều hơn tốt lỏi (tng)",
  },
  {
    word: "loi choi",
    part_of_speech: "",
    meaning: "nhảy nhót luôn chân, không chịu đứng yên: nhảy loi choi",
    example: "nhảy loi choi",
  },
  {
    word: "lòi đuôi",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) để lộ ra cái xấu, cái nhược điểm đang muốn giấu một cách gián tiếp: dốt lòi đuôi ra",
    example: "dốt lòi đuôi ra",
  },
  {
    word: "loi nhoi",
    part_of_speech: "động từ",
    meaning:
      "(động vật nhỏ) chen chúc nhau nhoi lên: dòi bọ loi nhoi * đàn cá con loi nhoi lên mặt nước",
    example: "dòi bọ loi nhoi * đàn cá con loi nhoi lên mặt nước",
  },
  {
    word: "lõi đời",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) thành thạo, có nhiều kinh nghiệm, biết nhiều mánh khoé ở đời (thường hàm ý chê): khôn lõi đời * lõi đời trong nghề lừa lọc",
    example: "khôn lõi đời * lõi đời trong nghề lừa lọc",
  },
  {
    word: "loi ngoi lóp ngóp",
    part_of_speech: "tính từ",
    meaning: "(ướt) đầm đìa: từ đầu đến chân ướt loi ngoi lóp ngóp",
    example: "từ đầu đến chân ướt loi ngoi lóp ngóp",
  },
  {
    word: "loi ngoi",
    part_of_speech: "động từ",
    meaning:
      "cố ngoi lên khỏi mặt nước bằng những cử động yếu ớt liên tiếp: đang loi ngoi dưới nước * loi ngoi một lúc rồi chìm hẳn",
    example: "đang loi ngoi dưới nước * loi ngoi một lúc rồi chìm hẳn",
  },
  {
    word: "lõm",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái thụt vào phía trong hay phía dưới thành một khoảng trống hình lòng chảo: má lõm * thức đêm, mắt lõm sâu * địa hình chỗ lồi chỗ lõm * đi buôn bị lõm (b)",
    example:
      "má lõm * thức đêm, mắt lõm sâu * địa hình chỗ lồi chỗ lõm * đi buôn bị lõm (b)",
  },
  {
    word: "lõm",
    part_of_speech: "tính từ",
    meaning: "(góc) lớn hơn 180o và bé hơn 360o: đa giác có hai góc lõm",
    example: "đa giác có hai góc lõm",
  },
  {
    word: "lõm",
    part_of_speech: "tính từ",
    meaning: "(đa giác) có ít nhất một góc lõm: đa giác lõm",
    example: "đa giác lõm",
  },
  {
    word: "lõm",
    part_of_speech: "danh từ",
    meaning: "chỗ bị lõm xuống: nấp vào lõm đất * sờ tay vào lõm má",
    example: "nấp vào lõm đất * sờ tay vào lõm má",
  },
  {
    word: "loi thoi",
    part_of_speech: "tính từ",
    meaning:
      'lơ thơ và cao thấp không đều: "Sông Tần một dải xanh xanh, Loi thoi bờ liễu mấy cành Dương-quan." (TKiều)',
    example:
      'Sông Tần một dải xanh xanh, Loi thoi bờ liễu mấy cành Dương-quan." (TKiều)',
  },
  {
    word: "lõm bõm",
    part_of_speech: "",
    meaning:
      "từ mô phỏng tiếng chân lội nước hay tiếng những vật nhỏ rơi không đều xuống nước: tiếng lội nước lõm bõm",
    example: "tiếng lội nước lõm bõm",
  },
  {
    word: "lõm bõm",
    part_of_speech: "",
    meaning:
      "(nhận thức, tiếp thu) ít ỏi, không được trọn vẹn, chỗ được chỗ mất: nhớ lõm bõm được mấy câu thơ",
    example: "nhớ lõm bõm được mấy câu thơ",
  },
  {
    word: "lom khom",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả tư thế còng lưng xuống để làm việc gì: lom khom cấy lúa * cúi lom khom",
    example: "lom khom cấy lúa * cúi lom khom",
  },
  {
    word: "lòm khòm",
    part_of_speech: "tính từ",
    meaning: "như lom khom: lòm khòm bước đi",
    example: "lòm khòm bước đi",
  },
  {
    word: "lọm cọm",
    part_of_speech: "tính từ",
    meaning:
      "cặm cụi một cách vất vả (thường nói về người già yếu): lụm cụm quét tước, nấu nướng * cả ngày lụm cụm bên khung cửi",
    example: "lụm cụm quét tước, nấu nướng * cả ngày lụm cụm bên khung cửi",
  },
  {
    word: "lon",
    part_of_speech: "danh từ",
    meaning:
      "hộp đựng sữa hoặc nước giải khát, thường bằng kim loại: bia lon * lon nước ngọt",
    example: "bia lon * lon nước ngọt",
  },
  {
    word: "lon",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ) bơ: đong mấy lon gạo nếp * nấu ba lon gạo",
    example: "đong mấy lon gạo nếp * nấu ba lon gạo",
  },
  {
    word: "lon",
    part_of_speech: "danh từ",
    meaning: "vại nhỏ, chậu nhỏ bằng sành: lon nước gạo * nén một lon cà",
    example: "lon nước gạo * nén một lon cà",
  },
  {
    word: "lon",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) phù hiệu quân hàm (của quân đội một số nước): đeo lon đại uý",
    example: "đeo lon đại uý",
  },
  {
    word: "lóm thóm",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) có dáng vẻ rụt rè, sợ sệt: dáng bộ lóm thóm",
    example: "dáng bộ lóm thóm",
  },
  {
    word: "lom lom",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) chằm chằm: ngó lom lom vô mặt nhau",
    example: "ngó lom lom vô mặt nhau",
  },
  {
    word: "lọn",
    part_of_speech: "danh từ",
    meaning: "nắm, mớ (thường có dạng sợi): lọn tóc * mua một lọn nhang",
    example: "lọn tóc * mua một lọn nhang",
  },
  {
    word: "lọm khọm",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả dáng vẻ đi lại khó nhọc của người già yếu, do lưng đã còng xuống: già lọm khọm * cụ già lọm khọm chống gậy bước từng bước",
    example: "già lọm khọm * cụ già lọm khọm chống gậy bước từng bước",
  },
  {
    word: "lòn",
    part_of_speech: "động từ",
    meaning:
      "đi hoặc làm cho đi qua những chỗ hở nhỏ, hẹp để từ bên này xuyên sang bên kia: xe chỉ luồn kim * trăng luồn đám mây",
    example: "xe chỉ luồn kim * trăng luồn đám mây",
  },
  {
    word: "lòn",
    part_of_speech: "động từ",
    meaning:
      "len lỏi để đi lọt qua nơi nguy hiểm: luồn vào trận địa của địch * luồn khỏi vòng vây",
    example: "luồn vào trận địa của địch * luồn khỏi vòng vây",
  },
  {
    word: "lòn",
    part_of_speech: "động từ",
    meaning:
      "lọt hoặc đưa lọt vào một cách khéo léo, bí mật: luồn người vào tổ chức địch",
    example: "luồn người vào tổ chức địch",
  },
  {
    word: "lòn",
    part_of_speech: "động từ",
    meaning:
      'hạ mình, nịnh nọt để cầu cạnh: luồn trên nạt dưới * "Tính bài lót đó luồn đây, Có ba trăm lạng, việc này mới xuôi." (TKiều)',
    example:
      'luồn trên nạt dưới * "Tính bài lót đó luồn đây, Có ba trăm lạng, việc này mới xuôi." (TKiều)',
  },
  {
    word: "lọng",
    part_of_speech: "danh từ",
    meaning:
      'vật dùng để che, gần giống cái dù nhưng lớn hơn, thường dùng cho vua quan thời trước hoặc trong các đám rước thánh thần: "Làm nên quan thấp quan cao, Làm nên lọng tía võng đào nghênh ngang." (ca dao)',
    example:
      'Làm nên quan thấp quan cao, Làm nên lọng tía võng đào nghênh ngang." (ca dao)',
  },
  {
    word: "lỏn lẻn",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) (nói, cười) nhỏ nhẹ với vẻ bẽn lẽn một cách đáng yêu: cười lỏn lẻn",
    example: "cười lỏn lẻn",
  },
  {
    word: "lon ton",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả dáng đi, chạy (thường là của trẻ em) với những bước ngắn, nhanh nhẹn, vẻ hồ hởi: bước chân lon ton * em bé lon ton chạy theo mẹ",
    example: "bước chân lon ton * em bé lon ton chạy theo mẹ",
  },
  {
    word: "lóng",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) gióng: lóng tre",
    example: "lóng tre",
  },
  {
    word: "lóng",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) gạn riêng ra phần nước trong: lóng nước * lóng bột",
    example: "lóng nước * lóng bột",
  },
  {
    word: "long",
    part_of_speech: "động từ",
    meaning:
      'rời ra, bong ra, không còn gắn chặt với nhau như trước nữa: cau long hạt * răng long * "Ai làm cái quạt long nhài, Cầu ô long nhịp, cửa cài long then." (ca dao)',
    example:
      'cau long hạt * răng long * "Ai làm cái quạt long nhài, Cầu ô long nhịp, cửa cài long then." (ca dao)',
  },
  {
    word: "long",
    part_of_speech: "động từ",
    meaning:
      "(mắt) mở to, sáng lên, biểu lộ sự giận dữ cao độ: mắt long lên sòng sọc",
    example: "mắt long lên sòng sọc",
  },
  {
    word: "lon xon",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như lon ton: chạy lon xon",
    example: "chạy lon xon",
  },
  {
    word: "long bong",
    part_of_speech: "tính từ",
    meaning:
      'từ mô phỏng âm thanh nhẹ nhưng âm vang phát ra liên tục và đều đều như tiếng nước vỗ nhẹ vào vật khác: "Gió giật sườn non khua lắc cắc, Sóng dồn mặt nước vỗ long bong." (HXHương; 20)',
    example:
      'Gió giật sườn non khua lắc cắc, Sóng dồn mặt nước vỗ long bong." (HXHương; 20)',
  },
  {
    word: "lòng",
    part_of_speech: "danh từ",
    meaning:
      "những bộ phận trong bụng của con vật giết thịt, dùng làm thức ăn (nói tổng quát): cỗ lòng lợn",
    example: "cỗ lòng lợn",
  },
  {
    word: "lòng",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) ruột lợn, dùng làm thức ăn: lòng già * mua đoạn lòng non",
    example: "lòng già * mua đoạn lòng non",
  },
  {
    word: "lòng",
    part_of_speech: "danh từ",
    meaning:
      'bụng của con người, về mặt là bộ phận chứa đựng nói chung: trẻ mới lọt lòng * "Đói lòng ăn nửa trái sim, Uống lưng bát nước đi tìm người thương." (Cdao)',
    example:
      'trẻ mới lọt lòng * "Đói lòng ăn nửa trái sim, Uống lưng bát nước đi tìm người thương." (Cdao)',
  },
  {
    word: "lòng",
    part_of_speech: "danh từ",
    meaning:
      "bụng của con người, coi là biểu tượng của ý chí, tinh thần hay ý nghĩ, tình cảm sâu kín: có lòng tốt * chung lòng gắng sức",
    example: "có lòng tốt * chung lòng gắng sức",
  },
  {
    word: "lòng",
    part_of_speech: "danh từ",
    meaning:
      "phần ở giữa hay ở trong một số vật, có khả năng chứa đựng hay che chở: ôm con vào lòng * bát sâu lòng * lòng sông * ở sâu trong lòng đất",
    example:
      "ôm con vào lòng * bát sâu lòng * lòng sông * ở sâu trong lòng đất",
  },
  {
    word: "lỏng",
    part_of_speech: "tính từ",
    meaning:
      "(vật chất) ở trạng thái có thể chảy được, có thể tích nhất định và có hình dạng tuỳ thuộc vào vật chứa: chất lỏng * thuỷ ngân là kim loại lỏng * tồn tại ở thể lỏng",
    example: "chất lỏng * thuỷ ngân là kim loại lỏng * tồn tại ở thể lỏng",
  },
  {
    word: "lỏng",
    part_of_speech: "tính từ",
    meaning: "(Phương ngữ) loãng: cháo lỏng",
    example: "cháo lỏng",
  },
  {
    word: "lỏng",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái không được siết chặt với nhau khiến cho dễ rời, dễ tháo gỡ: tóc búi lỏng * dây buộc lỏng * xe đạp lỏng ốc",
    example: "tóc búi lỏng * dây buộc lỏng * xe đạp lỏng ốc",
  },
  {
    word: "lỏng",
    part_of_speech: "tính từ",
    meaning:
      "không chặt chẽ, không nghiêm ngặt trong việc theo dõi, kiểm tra: buông lỏng kỉ luật",
    example: "buông lỏng kỉ luật",
  },
  {
    word: "lõng",
    part_of_speech: "danh từ",
    meaning:
      "lối đi quen của thú rừng: lần theo lõng để bắt thú * dồn cho thú chạy đúng lõng",
    example: "lần theo lõng để bắt thú * dồn cho thú chạy đúng lõng",
  },
  {
    word: "lõng",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) lối đi lại quen thuộc: đón lõng đường bay của địch",
    example: "đón lõng đường bay của địch",
  },
  {
    word: "lỏng chỏng",
    part_of_speech: "tính từ",
    meaning: "như lổng chổng: rổ rá vứt lỏng chỏng",
    example: "rổ rá vứt lỏng chỏng",
  },
  {
    word: "lỏng chỏng",
    part_of_speech: "tính từ",
    meaning:
      "chỉ có rất ít và mỗi thứ một nơi, gây cảm giác thưa thớt, trơ trọi: đầu lỏng chỏng ba cái tóc",
    example: "đầu lỏng chỏng ba cái tóc",
  },
  {
    word: "lõng bõng",
    part_of_speech: "tính từ",
    meaning:
      "loãng đến mức như chỉ thấy có nước, ít thấy cái: niêu cháo lõng bõng * bát canh lõng bõng toàn nước",
    example: "niêu cháo lõng bõng * bát canh lõng bõng toàn nước",
  },
  {
    word: "lóng cóng",
    part_of_speech: "tính từ",
    meaning:
      "(chân tay) ở trạng thái cử động vụng về, khó khăn, như bị tê cứng lại: chân tay lóng cóng",
    example: "chân tay lóng cóng",
  },
  {
    word: "lòng chim dạ cá",
    part_of_speech: "",
    meaning: "ví tâm địa phản phúc, ăn ở hai lòng: con người lòng chim dạ cá",
    example: "con người lòng chim dạ cá",
  },
  {
    word: "lòng dạ",
    part_of_speech: "danh từ",
    meaning:
      "bụng của con người, coi là biểu tượng của những ý nghĩ, tình cảm sâu kín (nói khái quát): lòng dạ độc ác * không còn lòng dạ nào mà nghĩ đến chuyện đó",
    example: "lòng dạ độc ác * không còn lòng dạ nào mà nghĩ đến chuyện đó",
  },
  {
    word: "lòng đỏ",
    part_of_speech: "danh từ",
    meaning: "bộ phận giữa quả trứng, màu đỏ vàng: lòng đỏ trứng gà",
    example: "lòng đỏ trứng gà",
  },
  {
    word: "lòng đào",
    part_of_speech: "tính từ",
    meaning:
      "(trứng hoặc thịt luộc) có màu hồng nhạt bên trong do vừa chín tới: trứng lòng đào * thịt luộc lòng đào",
    example: "trứng lòng đào * thịt luộc lòng đào",
  },
  {
    word: "long đong",
    part_of_speech: "tính từ",
    meaning:
      'vất vả, khó nhọc, không được yên ổn vì gặp phải nhiều điều trắc trở, không may: "Đã sinh ra số long đong, Còn mang lấy kiếp má hồng được sao?" (TKiều)',
    example:
      'Đã sinh ra số long đong, Còn mang lấy kiếp má hồng được sao?" (TKiều)',
  },
  {
    word: "long đình",
    part_of_speech: "danh từ",
    meaning: "kiệu có mui dành cho vua đi hoặc để rước thần: rước long đình",
    example: "rước long đình",
  },
  {
    word: "lòng đường",
    part_of_speech: "danh từ",
    meaning:
      "phần mặt đường giữa hai mép, hai vỉa hè, dành cho xe cộ: không đi bộ dưới lòng đường",
    example: "không đi bộ dưới lòng đường",
  },
  {
    word: "lòng khòng",
    part_of_speech: "tính từ",
    meaning:
      "dài, khẳng khiu và hơi cong, trông yếu đuối, vụng về: cao lòng khòng * tay chân lòng khòng",
    example: "cao lòng khòng * tay chân lòng khòng",
  },
  {
    word: "lòng lang dạ thú",
    part_of_speech: "",
    meaning:
      "ví tâm địa độc ác, mất hết tính người (tựa như lòng dạ của thú dữ): đồ lòng lang dạ thú!",
    example: "đồ lòng lang dạ thú!",
  },
  {
    word: "lóng lánh",
    part_of_speech: "",
    meaning:
      "(vật trong suốt) có ánh sáng phản chiếu, tựa như mặt nước dưới ánh trăng, không liên tục nhưng đều đặn, vẻ sinh động, đẹp mắt: viên kim cương lóng lánh * mắt sáng lóng lánh",
    example: "viên kim cương lóng lánh * mắt sáng lóng lánh",
  },
  {
    word: "lỏng lẻo",
    part_of_speech: "tính từ",
    meaning:
      "lỏng, dễ tuột, dễ rời ra (nói khái quát): dây buộc lỏng lẻo * tóc búi lỏng lẻo * siết chặt những con ốc còn lỏng lẻo",
    example:
      "dây buộc lỏng lẻo * tóc búi lỏng lẻo * siết chặt những con ốc còn lỏng lẻo",
  },
  {
    word: "lỏng lẻo",
    part_of_speech: "tính từ",
    meaning:
      "thiếu chặt chẽ, thiếu nghiêm ngặt trong sự tổ chức: quản lí lỏng lẻo * bố cục lỏng lẻo, không chặt chẽ",
    example: "quản lí lỏng lẻo * bố cục lỏng lẻo, không chặt chẽ",
  },
  {
    word: "long lanh",
    part_of_speech: "tính từ",
    meaning:
      "có ánh sáng phản chiếu trên vật trong suốt, tạo vẻ trong sáng, sinh động: mắt sáng long lanh * sương đọng long lanh trên lá",
    example: "mắt sáng long lanh * sương đọng long lanh trên lá",
  },
  {
    word: "lỏng khỏng",
    part_of_speech: "tính từ",
    meaning: "cao và gầy, trông yếu ớt: người cao lỏng khỏng",
    example: "người cao lỏng khỏng",
  },
  {
    word: "long não",
    part_of_speech: "danh từ",
    meaning:
      "cây to cao, lá hình trứng, vò ra có mùi thơm, lá và gỗ dùng cất tinh dầu: dầu long não",
    example: "dầu long não",
  },
  {
    word: "long não",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, phương ngữ) băng phiến (thời trước chế bằng dầu long não): bột long não",
    example: "bột long não",
  },
  {
    word: "long mạch",
    part_of_speech: "danh từ",
    meaning:
      "mạch đất tốt, quyết định vận mệnh con người, theo thuật phong thuỷ: tìm long mạch * sợ động long mạch",
    example: "tìm long mạch * sợ động long mạch",
  },
  {
    word: "lóng ngóng",
    part_of_speech: "tính từ",
    meaning:
      "(tay chân) lúng túng, cử động vụng về như không còn tự điều khiển được: chân tay lóng ngóng * lóng ngóng mãi không mở được nắp hộp",
    example: "chân tay lóng ngóng * lóng ngóng mãi không mở được nắp hộp",
  },
  {
    word: "lóng ngóng",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như lóng nhóng: bọn trẻ lóng ngóng chờ mẹ về",
    example: "bọn trẻ lóng ngóng chờ mẹ về",
  },
  {
    word: "long nhan",
    part_of_speech: "danh từ",
    meaning: "(cũ, trang trọng) mặt vua: ngắm long nhan",
    example: "ngắm long nhan",
  },
  {
    word: "long nhong",
    part_of_speech: "",
    meaning: "(hiếm) như nhong nhong: suốt ngày long nhong ngoài đường",
    example: "suốt ngày long nhong ngoài đường",
  },
  {
    word: "lòng son dạ sắt",
    part_of_speech: "",
    meaning:
      'lòng trung thành, kiên trinh, trước sau như một: "Lòng son dạ sắt càng thêm, Lòng đà trăng gió ai tìm thấy ai." (ca dao)',
    example:
      'Lòng son dạ sắt càng thêm, Lòng đà trăng gió ai tìm thấy ai." (ca dao)',
  },
  {
    word: "lóng nhóng",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái không biết làm gì, để thời gian qua đi một cách vô ích trong sự chờ đợi: đứng lóng nhóng chờ xe",
    example: "đứng lóng nhóng chờ xe",
  },
  {
    word: "lòng trắng",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận có màu trắng trong suốt bao quanh lòng đỏ trứng: lòng trắng trứng",
    example: "lòng trắng trứng",
  },
  {
    word: "long trọng",
    part_of_speech: "tính từ",
    meaning:
      "có đầy đủ nghi thức và không khí trang nghiêm: tiếp đón long trọng * thết đãi long trọng * giờ phút long trọng của cuộc đời",
    example:
      "tiếp đón long trọng * thết đãi long trọng * giờ phút long trọng của cuộc đời",
  },
  {
    word: "lòng thành",
    part_of_speech: "danh từ",
    meaning:
      'tấm lòng chân thành: lễ bạc lòng thành * "Suối vàng hồn mẹ có linh, Chứng cho con trẻ lòng thành ngày nay." (LVT)',
    example:
      'lễ bạc lòng thành * "Suối vàng hồn mẹ có linh, Chứng cho con trẻ lòng thành ngày nay." (LVT)',
  },
  {
    word: "lòng sông",
    part_of_speech: "danh từ",
    meaning:
      "phần trũng xuống giữa hai bờ sông, nơi thường xuyên có nước: nạo vét lòng sông",
    example: "nạo vét lòng sông",
  },
  {
    word: "lòng thòng",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả trạng thái rủ, treo hoặc buông thả từ trên xuống, trông như thừa ra, không gọn: dây dợ lòng thòng",
    example: "dây dợ lòng thòng",
  },
  {
    word: "lòng thòng",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) dài quá mức, như thừa ra: câu văn lòng thòng",
    example: "câu văn lòng thòng",
  },
  {
    word: "long tong",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng những tiếng nhỏ và hơi ngân vang phát ra liên tiếp, đều đặn giống như tiếng những giọt nước rơi nối tiếp nhau trên tấm kim loại mỏng: nước nhỏ long tong xuống chậu * trống đánh long tong",
    example: "nước nhỏ long tong xuống chậu * trống đánh long tong",
  },
  {
    word: "long tong",
    part_of_speech: "tính từ",
    meaning: "(đi, chạy) nhanh và có vẻ vội vã: em bé long tong chạy theo mẹ",
    example: "em bé long tong chạy theo mẹ",
  },
  {
    word: "long trời lở đất",
    part_of_speech: "",
    meaning:
      "ví hiện tượng, sự kiện có tác động lớn vang dội khắp nơi, làm đảo lộn trật tự cũ: cuộc cách mạng long trời lở đất",
    example: "cuộc cách mạng long trời lở đất",
  },
  {
    word: "lọp",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) dụng cụ nhử bắt cá, đan bằng tre, có hom, để mồi bên trong rồi đặt dưới đáy nước: đặt lọp bắt cá",
    example: "đặt lọp bắt cá",
  },
  {
    word: "loong toong",
    part_of_speech: "danh từ",
    meaning:
      "nhân viên chạy giấy và làm việc vặt ở các công sở thời Pháp thuộc; cũng dùng để chỉ người làm những việc lặt vặt hoặc để cho người khác sai vặt: làm chân loong toong",
    example: "làm chân loong toong",
  },
  {
    word: "lóp",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như hóp: gầy lóp má",
    example: "gầy lóp má",
  },
  {
    word: "lòng vòng",
    part_of_speech: "tính từ",
    meaning:
      "(di chuyển, nói) vòng qua vòng lại theo nhiều lần: nói lòng vòng  * đi lòng vòng mãi mới đến",
    example: "nói lòng vòng  * đi lòng vòng mãi mới đến",
  },
  {
    word: "long vân",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, văn chương) rồng mây; dùng để chỉ cơ hội tốt đẹp để lập công danh: gặp hội long vân",
    example: "gặp hội long vân",
  },
  {
    word: "lóp ngóp",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả tư thế cố ngoi từ dưới nước hoặc dưới đất lên một cách khó khăn, mệt nhọc: lóp ngóp bò lên bờ",
    example: "lóp ngóp bò lên bờ",
  },
  {
    word: "lọt lưới",
    part_of_speech: "động từ",
    meaning: "thoát khỏi vòng vây bắt: tên cướp đã lọt lưới",
    example: "tên cướp đã lọt lưới",
  },
  {
    word: "lót lòng",
    part_of_speech: "động từ",
    meaning: "(hiếm) như lót dạ: ăn mấy miếng lót lòng",
    example: "ăn mấy miếng lót lòng",
  },
  {
    word: "lọt",
    part_of_speech: "động từ",
    meaning:
      "qua được chỗ hở, chỗ trống nhỏ để vào bên trong: ánh đèn lọt qua khe liếp * lỗ nhỏ, chui không lọt * để cơ hội lọt vào tay người khác",
    example:
      "ánh đèn lọt qua khe liếp * lỗ nhỏ, chui không lọt * để cơ hội lọt vào tay người khác",
  },
  {
    word: "lọt",
    part_of_speech: "động từ",
    meaning:
      "đưa được, cho được hẳn vào bên trong một vật có lòng hẹp: cho lọt qua cổ chai * bản làng nằm lọt giữa các vách núi",
    example: "cho lọt qua cổ chai * bản làng nằm lọt giữa các vách núi",
  },
  {
    word: "lọt",
    part_of_speech: "động từ",
    meaning:
      "qua được chỗ khó khăn, thường bằng mưu mẹo, tài trí: lọt qua những tuyến hào của địch * lọt vào vòng chung kết * đầu xuôi đuôi lọt (tng)",
    example:
      "lọt qua những tuyến hào của địch * lọt vào vòng chung kết * đầu xuôi đuôi lọt (tng)",
  },
  {
    word: "lọt",
    part_of_speech: "động từ",
    meaning: "lộ ra ngoài, mặc dầu được giữ bí mật: chuyện kín lọt ra ngoài",
    example: "chuyện kín lọt ra ngoài",
  },
  {
    word: "lọt",
    part_of_speech: "động từ",
    meaning:
      "rơi vào chỗ nguy hiểm đã được bố trí sẵn: bị lọt vào ổ phục kích của địch * tên cướp bị lọt vào bẫy",
    example: "bị lọt vào ổ phục kích của địch * tên cướp bị lọt vào bẫy",
  },
  {
    word: "lót",
    part_of_speech: "động từ",
    meaning:
      "đặt thành một lớp thêm vào ở phía dưới hay phía trong vật gì đó, thường để cho được êm, ấm, cho sạch hoặc lâu hỏng: lót rơm cho gà đẻ * rế lót nồi * phấn lót",
    example: "lót rơm cho gà đẻ * rế lót nồi * phấn lót",
  },
  {
    word: "lót",
    part_of_speech: "động từ",
    meaning:
      "đệm vào giữa những âm, những tiếng khác: tên người phụ nữ thường có lót chữ",
    example: "tên người phụ nữ thường có lót chữ",
  },
  {
    word: "lót",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) lót ổ (nói tắt): lót quân",
    example: "lót quân",
  },
  {
    word: "lót",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đút lót (nói tắt): lót tiền cho quan trên để chạy tội * ăn của lót",
    example: "lót tiền cho quan trên để chạy tội * ăn của lót",
  },
  {
    word: "lót",
    part_of_speech: "danh từ",
    meaning: "lần vải phía trong của áo kép, áo bông: mua vải làm lót",
    example: "mua vải làm lót",
  },
  {
    word: "lót",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) tã: thay lót cho bé",
    example: "thay lót cho bé",
  },
  {
    word: "lọt lòng",
    part_of_speech: "động từ",
    meaning:
      "mới ra khỏi bụng mẹ, vừa mới được sinh ra (thường chỉ nói về người): mồ côi từ khi lọt lòng",
    example: "mồ côi từ khi lọt lòng",
  },
  {
    word: "lót dạ",
    part_of_speech: "động từ",
    meaning:
      "ăn chút ít (thường vào buổi sáng) cho đỡ đói: ăn lót dạ * lót dạ cái bánh mì",
    example: "ăn lót dạ * lót dạ cái bánh mì",
  },
  {
    word: "lót ổ",
    part_of_speech: "động từ",
    meaning:
      '(phương ngữ, khẩu ngữ) (chim) làm tổ: "Chim khôn lót ổ lựa nhành, Gái khôn tìm chỗ trai lành kết duyên." (ca dao)',
    example:
      'Chim khôn lót ổ lựa nhành, Gái khôn tìm chỗ trai lành kết duyên." (ca dao)',
  },
  {
    word: "lót ổ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) (gia súc) chết khi mới đẻ (còn ở trong ổ): lứa lợn bị lót ổ mất mấy con",
    example: "lứa lợn bị lót ổ mất mấy con",
  },
  {
    word: "lọt tai",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (lời nói) dễ nghe, vì hợp với ý người nghe: giải thích như thế khó lọt tai lắm! * nói không lọt cái lỗ tai (kng)",
    example:
      "giải thích như thế khó lọt tai lắm! * nói không lọt cái lỗ tai (kng)",
  },
  {
    word: "lọt sàng xuống nia",
    part_of_speech: "",
    meaning:
      "ví sự việc người này thiệt thì người kia được, không mất mát đi đâu (giữa hai người có quan hệ thân thích): em ăn thì anh nhịn, lọt sàng xuống nia, đi đâu mà thiệt!",
    example: "em ăn thì anh nhịn, lọt sàng xuống nia, đi đâu mà thiệt!",
  },
  {
    word: "lót tay",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đút lót món tiền nhỏ: có món tiền lót tay là xong tuốt!",
    example: "có món tiền lót tay là xong tuốt!",
  },
  {
    word: "lồ",
    part_of_speech: "danh từ",
    meaning:
      "đồ đựng đan bằng mây, tre, giống cái bồ, nhưng thưa mắt: cho cau vào lồ * thồ hai lồ hàng",
    example: "cho cau vào lồ * thồ hai lồ hàng",
  },
  {
    word: "lô",
    part_of_speech: "danh từ",
    meaning:
      "khu vực, bộ phận tương đối lớn và hoàn chỉnh được chia ra để tiện sử dụng, xử lí: lô hàng * đất chia thành từng lô * dẫn nước vào từng lô ruộng",
    example: "lô hàng * đất chia thành từng lô * dẫn nước vào từng lô ruộng",
  },
  {
    word: "lô",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) số lượng không xác định, được coi là nhiều và được kể như là một tập hợp: mua một lô báo về đọc * đưa ra hàng lô lí do để nguỵ biện",
    example: "mua một lô báo về đọc * đưa ra hàng lô lí do để nguỵ biện",
  },
  {
    word: "lô",
    part_of_speech: "danh từ",
    meaning: "(Khẩu ngữ) rulô (nói tắt): lăn lô mực",
    example: "lăn lô mực",
  },
  {
    word: "lô",
    part_of_speech: "danh từ",
    meaning:
      "vật hình trụ rỗng, thường bằng nhựa, dùng cuộn tóc để giữ nếp: tóc cuốn lô",
    example: "tóc cuốn lô",
  },
  {
    word: "lố bịch",
    part_of_speech: "tính từ",
    meaning:
      "lố đến mức trơ trẽn, đáng cười chê: bộ mặt lố bịch * câu nói thật lố bịch",
    example: "bộ mặt lố bịch * câu nói thật lố bịch",
  },
  {
    word: "lỗ",
    part_of_speech: "danh từ",
    meaning:
      "khoảng trống nhỏ thông từ bên này sang bên kia của một vật: xâu chỉ qua lỗ kim * vách bị thủng mấy lỗ",
    example: "xâu chỉ qua lỗ kim * vách bị thủng mấy lỗ",
  },
  {
    word: "lỗ",
    part_of_speech: "danh từ",
    meaning:
      "chỗ lõm nhỏ và sâu trên một bề mặt: khoan một lỗ trên tường * lấp lỗ châu mai",
    example: "khoan một lỗ trên tường * lấp lỗ châu mai",
  },
  {
    word: "lỗ",
    part_of_speech: "động từ",
    meaning:
      "thu không đủ bù chi trong buôn bán kinh doanh: buôn chuyến này bị lỗ * lời ăn lỗ chịu * kết quả kinh doanh quý này vẫn lỗ",
    example:
      "buôn chuyến này bị lỗ * lời ăn lỗ chịu * kết quả kinh doanh quý này vẫn lỗ",
  },
  {
    word: "lỗ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) bị thiệt, bị thua thiệt: tham bữa giỗ, lỗ bữa cày (tng)",
    example: "tham bữa giỗ, lỗ bữa cày (tng)",
  },
  {
    word: "lọt thỏm",
    part_of_speech: "động từ",
    meaning:
      "lọt hẳn vào giữa một cách dễ dàng hoặc bị che lấp giữa những cái khác lớn hơn gấp bội: tiếng hét lọt thỏm trong tiếng gầm rú của biển",
    example: "tiếng hét lọt thỏm trong tiếng gầm rú của biển",
  },
  {
    word: "lố",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) tá: một lố khăn tay",
    example: "một lố khăn tay",
  },
  {
    word: "lố",
    part_of_speech: "tính từ",
    meaning:
      "không hợp với lẽ thường của người đời đến mức đáng chế nhạo: ăn mặc trông rất lố",
    example: "ăn mặc trông rất lố",
  },
  {
    word: "lỗ chân lông",
    part_of_speech: "danh từ",
    meaning:
      "lỗ rất nhỏ ngoài da, chỗ chân lông, nơi mồ hôi tiết ra: bị viêm lỗ chân lông",
    example: "bị viêm lỗ chân lông",
  },
  {
    word: "lỗ châu mai",
    part_of_speech: "danh từ",
    meaning:
      "lỗ ở thành công sự để bắn súng từ trong công sự ra ngoài: Phan Đình Giót đã lấy thân mình lấp lỗ châu mai",
    example: "Phan Đình Giót đã lấy thân mình lấp lỗ châu mai",
  },
  {
    word: "lộ",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) đường lớn: con lộ",
    example: "con lộ",
  },
  {
    word: "lộ",
    part_of_speech: "động từ",
    meaning:
      "để cho người ngoài thấy được, biết được, nhận ra được cái trước bị che giấu: cười để lộ hàm răng trắng * lộ vẻ ngạc nhiên * lộ chân tướng",
    example: "cười để lộ hàm răng trắng * lộ vẻ ngạc nhiên * lộ chân tướng",
  },
  {
    word: "lỗ chỗ",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều lỗ nhỏ, nhiều vết thủng hoặc nhiều vết sáng tối không đều rải ra trên bề mặt: tường lỗ chỗ vết đinh",
    example: "tường lỗ chỗ vết đinh",
  },
  {
    word: "lỗ chỗ",
    part_of_speech: "tính từ",
    meaning:
      "có mỗi chỗ một ít và xen lẫn vào nhau, không đều: lúa lỗ chỗ trổ bông",
    example: "lúa lỗ chỗ trổ bông",
  },
  {
    word: "lỗ đáo",
    part_of_speech: "danh từ",
    meaning:
      "lỗ khoét dưới đất để đánh đáo; thường dùng để ví mắt trũng sâu một cách khác thường: đôi mắt lỗ đáo",
    example: "đôi mắt lỗ đáo",
  },
  {
    word: "lô cốt",
    part_of_speech: "danh từ",
    meaning:
      "công sự xây đắp thành khối vững chắc, dùng để phòng ngự, cố thủ một nơi nào đó: đánh sập lô cốt của địch",
    example: "đánh sập lô cốt của địch",
  },
  {
    word: "lỗ đen",
    part_of_speech: "danh từ",
    meaning:
      "vùng không gian - thời gian trong vũ trụ có trường hấp dẫn cực mạnh khiến không có vật gì, kể cả ánh sáng, có thể thoát ra khỏi: nghiên cứu các lỗ đen",
    example: "nghiên cứu các lỗ đen",
  },
  {
    word: "lộ hầu",
    part_of_speech: "tính từ",
    meaning: "có cuống họng lồi ra, nhô ra quá mức bình thường: cổ lộ hầu",
    example: "cổ lộ hầu",
  },
  {
    word: "lỗ lã",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) lỗ (nói khái quát): buôn bán cho vui chứ lỗ lã gì",
    example: "buôn bán cho vui chứ lỗ lã gì",
  },
  {
    word: "lỗ hổng",
    part_of_speech: "danh từ",
    meaning: "chỗ trống do thiếu hụt cần phải được bù đắp: lỗ hổng kiến thức",
    example: "lỗ hổng kiến thức",
  },
  {
    word: "lộ giới",
    part_of_speech: "danh từ",
    meaning: "đường phân cách phạm vi của đường giao thông: cắm mốc lộ giới",
    example: "cắm mốc lộ giới",
  },
  {
    word: "lổ đổ",
    part_of_speech: "tính từ",
    meaning:
      "không thuần một màu mà rải rác có những đốm, những vệt khác màu trên bề mặt: lá xanh, lá vàng lổ đổ trên cây",
    example: "lá xanh, lá vàng lổ đổ trên cây",
  },
  {
    word: "lổ đổ",
    part_of_speech: "tính từ",
    meaning:
      "không cùng một lúc, một nơi mà rải rác từng ít một: mọi người lổ đổ kéo đến mỗi lúc một đông * lúa chín lổ đổ",
    example: "mọi người lổ đổ kéo đến mỗi lúc một đông * lúa chín lổ đổ",
  },
  {
    word: "lỗ lãi",
    part_of_speech: "danh từ",
    meaning: "các khoản lỗ và lãi (nói khái quát): hạch toán các khoản lỗ lãi",
    example: "hạch toán các khoản lỗ lãi",
  },
  {
    word: "lố lỉnh",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như lố bịch: hành vi lố lỉnh",
    example: "hành vi lố lỉnh",
  },
  {
    word: "lỗ mỗ",
    part_of_speech: "tính từ",
    meaning:
      "(nghe, hiểu) lơ mơ, chỗ có chỗ không: nghe lỗ mỗ câu được câu chăng * hiểu lỗ mỗ",
    example: "nghe lỗ mỗ câu được câu chăng * hiểu lỗ mỗ",
  },
  {
    word: "lỗ mỗ",
    part_of_speech: "tính từ",
    meaning:
      '(nói năng) quá tự nhiên, không có ý tứ, có phần như thô lỗ: "Tính cháu lỗ mỗ, lòng cháu cứ thẳng như ruột ngựa, chẳng ác độc đâu." (MVKháng; 3)',
    example:
      'Tính cháu lỗ mỗ, lòng cháu cứ thẳng như ruột ngựa, chẳng ác độc đâu." (MVKháng; 3)',
  },
  {
    word: "lỗ mãng",
    part_of_speech: "tính từ",
    meaning: "thô lỗ và mất lịch sự: ăn nói lỗ mãng",
    example: "ăn nói lỗ mãng",
  },
  {
    word: "lồ lộ",
    part_of_speech: "",
    meaning:
      "lộ ra, phô bày ra rất rõ: vừng trăng to lồ lộ * sự sung sướng, hớn hở lồ lộ trong ánh mắt",
    example: "vừng trăng to lồ lộ * sự sung sướng, hớn hở lồ lộ trong ánh mắt",
  },
  {
    word: "lô lốc",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) số lượng nhiều, những cái, những thứ cùng loại hoặc có liên quan với nhau, được coi như một tập hợp (thường hàm ý coi khinh): đi đâu cũng đem theo một lô lốc bộ hạ",
    example: "đi đâu cũng đem theo một lô lốc bộ hạ",
  },
  {
    word: "lố lăng",
    part_of_speech: "tính từ",
    meaning:
      "lố lắm, đến mức làm chướng tai gai mắt: ăn mặc lố lăng * toàn làm những trò lố lăng",
    example: "ăn mặc lố lăng * toàn làm những trò lố lăng",
  },
  {
    word: "lộ liễu",
    part_of_speech: "tính từ",
    meaning:
      "lộ rõ ra, khiến người ngoài dễ dàng nhận thấy trong khi đáng lẽ phải kín đáo: ăn mặc lộ liễu * tâng bốc một cách quá lộ liễu",
    example: "ăn mặc lộ liễu * tâng bốc một cách quá lộ liễu",
  },
  {
    word: "lô nhô",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả cảnh có nhiều người hay nhiều vật trồi lên thụt xuống, cao thấp không đều: mặt đường lô nhô những đá",
    example: "mặt đường lô nhô những đá",
  },
  {
    word: "lố nhố",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả cảnh có nhiều người hay vật cao thấp không đều, gây ấn tượng lộn xộn, thiếu trật tự: những nóc nhà cao thấp lố nhố",
    example: "những nóc nhà cao thấp lố nhố",
  },
  {
    word: "lộ trình",
    part_of_speech: "danh từ",
    meaning:
      "tuyến đường, chặng đường dự kiến phải đi qua: đi đúng lộ trình * có lũ nên phải thay đổi lộ trình * lộ trình hội nhập kinh tế khu vực",
    example:
      "đi đúng lộ trình * có lũ nên phải thay đổi lộ trình * lộ trình hội nhập kinh tế khu vực",
  },
  {
    word: "lỗ vốn",
    part_of_speech: "động từ",
    meaning: "bị lỗ, bị thâm vào vốn: đi buôn bị lỗ vốn",
    example: "đi buôn bị lỗ vốn",
  },
  {
    word: "lộ phí",
    part_of_speech: "danh từ",
    meaning: "tiền dành cho việc chi tiêu lúc đi đường xa: lộ phí đi đường",
    example: "lộ phí đi đường",
  },
  {
    word: "lộ tẩy",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) (cái xấu đang được che giấu kĩ) lộ rõ ra, bị phơi trần ra: mưu mô bị lộ tẩy",
    example: "mưu mô bị lộ tẩy",
  },
  {
    word: "lộ thiên",
    part_of_speech: "tính từ",
    meaning:
      "ở ngoài trời, không ở ngầm trong lòng đất hay không có gì che đậy: mỏ lộ thiên",
    example: "mỏ lộ thiên",
  },
  {
    word: "lộ xỉ",
    part_of_speech: "tính từ",
    meaning: "(răng) mọc chìa hẳn ra, khi cười hở cả lợi: cười lộ xỉ",
    example: "cười lộ xỉ",
  },
  {
    word: "lồ ô",
    part_of_speech: "danh từ",
    meaning: "tre to mọc ở rừng, thân thẳng, có thành mỏng: rừng lồ ô",
    example: "rừng lồ ô",
  },
  {
    word: "lốc",
    part_of_speech: "danh từ",
    meaning: "gió lốc (nói tắt): cơn lốc",
    example: "cơn lốc",
  },
  {
    word: "lốc",
    part_of_speech: "danh từ",
    meaning: "lúa lốc (nói tắt): ruộng lốc * gạo lốc",
    example: "ruộng lốc * gạo lốc",
  },
  {
    word: "lô xích xông",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ, khẩu ngữ) số lượng rất nhiều, được coi như một tập hợp (thường hàm ý coi khinh): mua một lô xích xông quần áo",
    example: "mua một lô xích xông quần áo",
  },
  {
    word: "lộc",
    part_of_speech: "danh từ",
    meaning: "chồi lá non: cây trổ lộc",
    example: "cây trổ lộc",
  },
  {
    word: "lộc",
    part_of_speech: "danh từ",
    meaning:
      "của trời hay các đấng thiêng liêng ban cho, theo quan niệm xưa: hưởng lộc trời * thánh ban lộc",
    example: "hưởng lộc trời * thánh ban lộc",
  },
  {
    word: "lô-gô",
    part_of_speech: "danh từ",
    meaning:
      "hình vẽ riêng, dùng làm hình ảnh tượng trưng cho một công ti, một tổ chức: trên sản phẩm có in logo của công ti",
    example: "trên sản phẩm có in logo của công ti",
  },
  {
    word: "lô xô",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả cảnh có nhiều vật nổi lên thành những hình có chỏm nhọn cao thấp không đều và nối tiếp nhau: núi đá lô xô * sóng biển lô xô",
    example: "núi đá lô xô * sóng biển lô xô",
  },
  {
    word: "lô-gích",
    part_of_speech: "danh từ",
    meaning: "logic học (nói tắt): logic hình thức * logic toán học",
    example: "logic hình thức * logic toán học",
  },
  {
    word: "lô-gích",
    part_of_speech: "danh từ",
    meaning:
      "trật tự chặt chẽ, tất yếu giữa các hiện tượng: logic của cuộc sống * suy luận theo logic trẻ thơ",
    example: "logic của cuộc sống * suy luận theo logic trẻ thơ",
  },
  {
    word: "lô-gích",
    part_of_speech: "danh từ",
    meaning:
      "sự gắn bó chặt chẽ giữa các ý, cách suy luận chặt chẽ: suy luận thiếu logic",
    example: "suy luận thiếu logic",
  },
  {
    word: "lô-gích",
    part_of_speech: "tính từ",
    meaning: "đúng với quy luật logic: cách suy luận rất logic",
    example: "cách suy luận rất logic",
  },
  {
    word: "lô-gích",
    part_of_speech: "tính từ",
    meaning:
      "hợp với logic, giữa các hiện tượng có mối quan hệ chặt chẽ, tất yếu: sự việc diễn ra rất logic",
    example: "sự việc diễn ra rất logic",
  },
  {
    word: "lộc cộc",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng khô, trầm của vật cứng liên tiếp khua, nện trên mặt nền: tiếng gậy khua lộc cộc * xe bò lộc cộc tiến tới",
    example: "tiếng gậy khua lộc cộc * xe bò lộc cộc tiến tới",
  },
  {
    word: "lốc lịch",
    part_of_speech: "danh từ",
    meaning:
      "khối giấy gồm các tờ lịch của một năm, mỗi tờ ghi một ngày: mua một lốc lịch",
    example: "mua một lốc lịch",
  },
  {
    word: "lốc cốc",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng như tiếng mõ kêu đều đều liên tiếp: tiếng mõ khua lốc cốc",
    example: "tiếng mõ khua lốc cốc",
  },
  {
    word: "lốc nhốc",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) từ gợi tả trạng thái đông đúc và lôi thôi, tập trung vào một chỗ, chen chúc nhau lộn xộn: một đàn năm sáu đứa trẻ lốc nhốc",
    example: "một đàn năm sáu đứa trẻ lốc nhốc",
  },
  {
    word: "lốc thốc",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như lếch thếch: ăn mặc lốc thốc",
    example: "ăn mặc lốc thốc",
  },
  {
    word: "lôi",
    part_of_speech: "động từ",
    meaning:
      "nắm lấy và kéo mạnh, cho phải di chuyển cùng với mình hoặc về phía mình: cầm tay lôi đi xềnh xệch * ì ạch lôi xe qua vũng lầy * lôi kẻ xấu về nhà (b)",
    example:
      "cầm tay lôi đi xềnh xệch * ì ạch lôi xe qua vũng lầy * lôi kẻ xấu về nhà (b)",
  },
  {
    word: "lôi",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đưa ra từ chỗ kín: lôi quần áo rét ra giặt * để đâu nó cũng lôi ra được * lôi vụ việc ra ánh sáng",
    example:
      "lôi quần áo rét ra giặt * để đâu nó cũng lôi ra được * lôi vụ việc ra ánh sáng",
  },
  {
    word: "lội",
    part_of_speech: "động từ",
    meaning:
      "đi qua chỗ ngập nước nhưng không sâu lắm: lội qua suối * tiếng lội nước bì bõm",
    example: "lội qua suối * tiếng lội nước bì bõm",
  },
  {
    word: "lội",
    part_of_speech: "động từ",
    meaning:
      "(cũ, hoặc ph) bơi: có phúc đẻ con biết lội, có tội đẻ con hay trèo (tng)",
    example: "có phúc đẻ con biết lội, có tội đẻ con hay trèo (tng)",
  },
  {
    word: "lội",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ, hiếm) (đường sá) có nhiều nước và bùn, không khô ráo: mưa to, đường khá lội",
    example: "mưa to, đường khá lội",
  },
  {
    word: "lộc xộc",
    part_of_speech: "động từ",
    meaning: "như xồng xộc: lộc xộc vào nhà",
    example: "lộc xộc vào nhà",
  },
  {
    word: "lộc xộc",
    part_of_speech: "động từ",
    meaning: "như xộc xệch: quần áo lộc xộc",
    example: "quần áo lộc xộc",
  },
  {
    word: "lỗi",
    part_of_speech: "danh từ",
    meaning:
      "chỗ sai sót do không thực hiện đúng quy tắc: mắc lỗi chính tả * trọng tài bắt lỗi việt vị",
    example: "mắc lỗi chính tả * trọng tài bắt lỗi việt vị",
  },
  {
    word: "lỗi",
    part_of_speech: "danh từ",
    meaning:
      "điều sai sót, không nên, không phải trong cách cư xử, trong hành động: phạm lỗi * có lỗi với bạn bè * mình làm mình chịu, không đổ lỗi cho ai",
    example:
      "phạm lỗi * có lỗi với bạn bè * mình làm mình chịu, không đổ lỗi cho ai",
  },
  {
    word: "lỗi",
    part_of_speech: "tính từ",
    meaning:
      "có chỗ sai sót về mặt kĩ thuật: đan lỗi * hát lỗi nhịp * hàng lỗi phải bán hạ giá",
    example: "đan lỗi * hát lỗi nhịp * hàng lỗi phải bán hạ giá",
  },
  {
    word: "lỗi",
    part_of_speech: "tính từ",
    meaning:
      'có điều sai, trái, không theo đúng đạo lí: lỗi hẹn * lỗi đạo làm con * "Kiều nhi phận mỏng như tờ, Một lời đã lỗi tóc tơ với chàng!" (TKiều)',
    example:
      'lỗi hẹn * lỗi đạo làm con * "Kiều nhi phận mỏng như tờ, Một lời đã lỗi tóc tơ với chàng!" (TKiều)',
  },
  {
    word: "lộc ngộc",
    part_of_speech: "tính từ",
    meaning: "cao lớn quá khổ nhưng vụng về, khờ dại: người cao lớn lộc ngộc",
    example: "người cao lớn lộc ngộc",
  },
  {
    word: "lối",
    part_of_speech: "danh từ",
    meaning:
      "khoảng đất hẹp dùng để ra vào một nơi nào đó, để đi lại từ nơi này đến nơi khác: tìm lối vào hang * ra lối cửa sau * cỏ lan kín lối đi",
    example: "tìm lối vào hang * ra lối cửa sau * cỏ lan kín lối đi",
  },
  {
    word: "lối",
    part_of_speech: "danh từ",
    meaning:
      "hình thức diễn ra của hoạt động đã trở thành ổn định, mang đặc điểm riêng: lối sống buông thả * chiều không phải lối",
    example: "lối sống buông thả * chiều không phải lối",
  },
  {
    word: "lối",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) chừng, khoảng chừng: lúc đó lối ba giờ sáng * từ đây đến đó lối bốn cây số",
    example: "lúc đó lối ba giờ sáng * từ đây đến đó lối bốn cây số",
  },
  {
    word: "lồi",
    part_of_speech: "tính từ",
    meaning:
      "gồ lên, nhô ra thành khối vòng cung hay tròn: mắt lồi * rốn lồi * mô đất lồi lên giữa bãi",
    example: "mắt lồi * rốn lồi * mô đất lồi lên giữa bãi",
  },
  {
    word: "lồi",
    part_of_speech: "tính từ",
    meaning: "(góc) bé hơn 180o: góc lồi",
    example: "góc lồi",
  },
  {
    word: "lồi",
    part_of_speech: "tính từ",
    meaning:
      "(đa giác) nằm về một phía của bất kì đường thẳng nào chứa một cạnh của nó: đa giác lồi",
    example: "đa giác lồi",
  },
  {
    word: "lội bộ",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ, khẩu ngữ) đi bộ (hàm ý khó nhọc, vất vả): xe hỏng phải lội bộ về nhà",
    example: "xe hỏng phải lội bộ về nhà",
  },
  {
    word: "lỗi lạc",
    part_of_speech: "tính từ",
    meaning: "tài giỏi khác thường: tài ba lỗi lạc * một nhà chính trị lỗi lạc",
    example: "tài ba lỗi lạc * một nhà chính trị lỗi lạc",
  },
  {
    word: "lôi đình",
    part_of_speech: "danh từ",
    meaning: "sấm và sét; dùng để ví cơn giận lớn: nổi trận lôi đình",
    example: "nổi trận lôi đình",
  },
  {
    word: "lôi kéo",
    part_of_speech: "động từ",
    meaning:
      "bằng mọi cách làm cho nghe theo và đứng về phía mình, đi theo mình: bị lôi kéo vào con đường cờ bạc",
    example: "bị lôi kéo vào con đường cờ bạc",
  },
  {
    word: "lối thoát",
    part_of_speech: "danh từ",
    meaning:
      "cách thức và biện pháp giải quyết để thoát ra khỏi tình trạng bế tắc hoặc nguy nan: bế tắc, không tìm ra lối thoát",
    example: "bế tắc, không tìm ra lối thoát",
  },
  {
    word: "lồi lõm",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều chỗ lồi chỗ lõm không đều trên một bề mặt (thường nói về địa hình): mặt đường lồi lõm",
    example: "mặt đường lồi lõm",
  },
  {
    word: "lôi cuốn",
    part_of_speech: "động từ",
    meaning:
      "làm cho có thiện cảm, ham thích đến mức bị cuốn theo: sách hay, lôi cuốn được nhiều độc giả * giọng nói có sức lôi cuốn",
    example:
      "sách hay, lôi cuốn được nhiều độc giả * giọng nói có sức lôi cuốn",
  },
  {
    word: "lỗi lầm",
    part_of_speech: "danh từ",
    meaning:
      "lỗi, khuyết điểm tương đối lớn (nói khái quát): chuộc lại lỗi lầm * sửa chữa lỗi lầm",
    example: "chuộc lại lỗi lầm * sửa chữa lỗi lầm",
  },
  {
    word: "lôi thôi lếch thếch",
    part_of_speech: "tính từ",
    meaning:
      "rất lôi thôi, đến mức nhếch nhác, bệ rạc: quần áo lôi thôi lếch thếch",
    example: "quần áo lôi thôi lếch thếch",
  },
  {
    word: "lôi thôi",
    part_of_speech: "tính từ",
    meaning:
      "không gọn gàng, thường trong cách ăn mặc: ăn mặc lôi thôi * lôi thôi như cá trôi sổ ruột",
    example: "ăn mặc lôi thôi * lôi thôi như cá trôi sổ ruột",
  },
  {
    word: "lôi thôi",
    part_of_speech: "tính từ",
    meaning:
      'dài dòng và rắc rối trong cách diễn đạt: văn viết còn lôi thôi * "Sự tình kể lể lôi thôi, Ngoài muôn ngàn dặm, trong mười mấy năm." (NĐM)',
    example:
      'văn viết còn lôi thôi * "Sự tình kể lể lôi thôi, Ngoài muôn ngàn dặm, trong mười mấy năm." (NĐM)',
  },
  {
    word: "lôi thôi",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) rắc rối, gây ra nhiều chuyện phiền phức: kiện cáo lôi thôi * đừng có lôi thôi!",
    example: "kiện cáo lôi thôi * đừng có lôi thôi!",
  },
  {
    word: "lỗi thời",
    part_of_speech: "tính từ",
    meaning:
      "đã trở thành lạc hậu, không còn thích hợp với thời nay nữa: bộ quần áo đã lỗi thời * tư tưởng lỗi thời",
    example: "bộ quần áo đã lỗi thời * tư tưởng lỗi thời",
  },
  {
    word: "lộm cộm",
    part_of_speech: "tính từ",
    meaning:
      "hơi cộm lên ở nhiều chỗ, không đều: sỏi đá lộm cộm dưới lưng * chiếc túi lộm cộm vì nhiều thứ",
    example: "sỏi đá lộm cộm dưới lưng * chiếc túi lộm cộm vì nhiều thứ",
  },
  {
    word: "lối xóm",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) hàng xóm láng giềng với nhau: bà con lối xóm",
    example: "bà con lối xóm",
  },
  {
    word: "lôm côm",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) không ra đâu vào đâu, chỗ được chỗ không và không ổn định: ăn nói lôm côm * bản dịch lôm côm, thiếu chính xác",
    example: "ăn nói lôm côm * bản dịch lôm côm, thiếu chính xác",
  },
  {
    word: "lôm nhôm",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) ở trạng thái còn dở dang, chắp vá và không theo một trật tự nào cả: đào bới lôm nhôm",
    example: "đào bới lôm nhôm",
  },
  {
    word: "lổm ngổm",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả dáng bò nhô cao hẳn thân lên, không có trật tự, không ra hàng lối: cua bò lổm ngổm",
    example: "cua bò lổm ngổm",
  },
  {
    word: "lổm nhổm",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái lộn xộn, chỗ cao chỗ thấp không đều: đường rải đá lổm nhổm",
    example: "đường rải đá lổm nhổm",
  },
  {
    word: "lồm cồm",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả dáng chống cả hai chân hai tay để bò hoặc nhổm người dậy: ngã rồi lại lồm cồm ngồi dậy",
    example: "ngã rồi lại lồm cồm ngồi dậy",
  },
  {
    word: "lốm đốm",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều đốm, nhiều chấm to nhỏ, màu sắc không đều, rải rác trên bề mặt: tóc lốm đốm bạc * nền trời lốm đốm sao",
    example: "tóc lốm đốm bạc * nền trời lốm đốm sao",
  },
  {
    word: "lộn ẩu",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) lẫn lộn lung tung, không còn thấy có một thứ tự nào: đánh lộn ẩu * sách vở, quần áo vứt lộn ẩu",
    example: "đánh lộn ẩu * sách vở, quần áo vứt lộn ẩu",
  },
  {
    word: "lộn",
    part_of_speech: "động từ",
    meaning:
      "lật mặt trong ra ngoài, mặt ngoài vào trong hoặc đảo ngược vị trí dưới lên trên, trên xuống dưới: lộn trái quần áo ra phơi * cầm lộn ngược * lộn một vòng trên không",
    example:
      "lộn trái quần áo ra phơi * cầm lộn ngược * lộn một vòng trên không",
  },
  {
    word: "lộn",
    part_of_speech: "động từ",
    meaning:
      "quay ngược trở lại với hướng đang đi: đi được một đoạn rồi lại phải lộn lại",
    example: "đi được một đoạn rồi lại phải lộn lại",
  },
  {
    word: "lộn",
    part_of_speech: "động từ",
    meaning:
      "(động vật) biến đổi hình dạng, cấu tạo, trở thành khác hẳn đi, trong quá trình sinh trưởng: nhộng lộn thành bướm",
    example: "nhộng lộn thành bướm",
  },
  {
    word: "lộn",
    part_of_speech: "động từ",
    meaning:
      "(Nam) lẫn, nhầm: đổ lộn hai loại gạo * đi lộn đường * cầm lộn cái mũ * chép lộn một đoạn",
    example: "đổ lộn hai loại gạo *",
  },
  {
    word: "lộn bậy",
    part_of_speech: "tính từ",
    meaning:
      "lung tung, bừa bãi, không kể gì trật tự: chửi bới lộn bậy * viết lộn bậy vào vở * đồ đạc vứt lộn bậy",
    example: "chửi bới lộn bậy * viết lộn bậy vào vở * đồ đạc vứt lộn bậy",
  },
  {
    word: "lộn lạo",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) như lẫn lộn (ng1): quần áo để lộn lạo",
    example: "quần áo để lộn lạo",
  },
  {
    word: "lộn lạo",
    part_of_speech: "động từ",
    meaning: "cảm thấy nôn nao, khó chịu trong dạ: say xe, ruột gan lộn lạo",
    example: "say xe, ruột gan lộn lạo",
  },
  {
    word: "lộn máu",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) như lộn tiết: tức lộn máu * chỉ nghe nó nói cũng đủ lộn máu lên rồi!",
    example: "tức lộn máu * chỉ nghe nó nói cũng đủ lộn máu lên rồi!",
  },
  {
    word: "lộn mửa",
    part_of_speech: "động từ",
    meaning: "có cảm giác kinh tởm đến mức muốn nôn mửa: mùi tanh đến lộn mửa",
    example: "mùi tanh đến lộn mửa",
  },
  {
    word: "lộn nhèo",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) lộn xộn không còn một chút thứ tự nào, đến mức lẫn lộn cả những cái trái ngược nhau: tốt xấu lộn nhèo",
    example: "tốt xấu lộn nhèo",
  },
  {
    word: "lộn nhào",
    part_of_speech: "động từ",
    meaning:
      "(ngã) lộn đầu xuống: ngã lộn nhào xuống đất * máy bay bị lộn nhào",
    example: "ngã lộn nhào xuống đất * máy bay bị lộn nhào",
  },
  {
    word: "lộn chồng",
    part_of_speech: "động từ",
    meaning:
      '(khẩu ngữ) bỏ chồng một cách không đàng hoàng, không chính đáng: "Con này chẳng phải thiện nhân, Chẳng phường trốn chúa, thì quân lộn chồng." (TKiều)',
    example:
      'Con này chẳng phải thiện nhân, Chẳng phường trốn chúa, thì quân lộn chồng." (TKiều)',
  },
  {
    word: "lổn ngổn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) nhiều và hơi ngổn ngang: chai lọ lổn ngổn dưới sàn * sách vở, bút mực lổn ngổn trên bàn",
    example: "chai lọ lổn ngổn dưới sàn * sách vở, bút mực lổn ngổn trên bàn",
  },
  {
    word: "lốn nhốn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) hơi nhốn nháo, ồn ào, hơi mất trật tự: đám người lốn nhốn ngoài đường",
    example: "đám người lốn nhốn ngoài đường",
  },
  {
    word: "lổn nhổn",
    part_of_speech: "tính từ",
    meaning:
      "có những khối tròn nhỏ và cứng lẫn vào làm vướng víu, khó chịu: đống gạch vụn lổn nhổn * bột lổn nhổn những cục",
    example: "đống gạch vụn lổn nhổn * bột lổn nhổn những cục",
  },
  {
    word: "lộn ruột",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tức giận đến mức tưởng như ruột lộn cả lên, không thể chịu nổi nữa: tức lộn ruột",
    example: "tức lộn ruột",
  },
  {
    word: "lộn phèo",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) (ngã, đổ) lộn đầu xuống: ngã lộn phèo * đứa bé lộn phèo xuống đất",
    example: "ngã lộn phèo * đứa bé lộn phèo xuống đất",
  },
  {
    word: "lộn phèo",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) lẫn lộn lung tung cả: sách vở, giấy má để lộn phèo",
    example: "sách vở, giấy má để lộn phèo",
  },
  {
    word: "lộn sòng",
    part_of_speech: "động từ",
    meaning:
      "tráo vào làm cho không còn phân biệt được thật giả, phải trái, tốt xấu: tốt xấu lộn sòng * đánh lộn sòng hàng thật với hàng giả",
    example: "tốt xấu lộn sòng * đánh lộn sòng hàng thật với hàng giả",
  },
  {
    word: "lộn tùng phèo",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) như lộn phèo (nhưng nghĩa mạnh hơn và hàm ý hài hước): ngã lộn tùng phèo * cãi nhau lộn tùng phèo",
    example: "ngã lộn tùng phèo * cãi nhau lộn tùng phèo",
  },
  {
    word: "lộn tiết",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) tức giận cao độ, tưởng như máu sôi lên: chỉ nghĩ đến đó là cũng đủ lộn tiết!",
    example: "chỉ nghĩ đến đó là cũng đủ lộn tiết!",
  },
  {
    word: "lộn xộn",
    part_of_speech: "tính từ",
    meaning:
      "không có trật tự, không theo một trình tự nào: giấy má vứt lộn xộn * hàng ngũ lộn xộn",
    example: "giấy má vứt lộn xộn * hàng ngũ lộn xộn",
  },
  {
    word: "lộn xà lộn xộn",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) rất lộn xộn: sách vở, giấy má để lộn xà lộn xộn",
    example: "sách vở, giấy má để lộn xà lộn xộn",
  },
  {
    word: "lông",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận thường có hình sợi, mọc ở ngoài da cầm thú hay da người, có tác dụng bảo vệ cơ thể: lông chân * lông cừu * đủ lông đủ cánh",
    example: "lông chân * lông cừu * đủ lông đủ cánh",
  },
  {
    word: "lông",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận hình lông trên bề mặt một số vật: lá mơ lông * vải sổ lông",
    example: "lá mơ lông * vải sổ lông",
  },
  {
    word: "lồng",
    part_of_speech: "danh từ",
    meaning:
      "đồ thường đan thưa bằng tre nứa hoặc đóng bằng gỗ, dùng để nhốt chim, gà, v.v.: nhốt gà vào lồng * chim sổ lồng",
    example: "nhốt gà vào lồng * chim sổ lồng",
  },
  {
    word: "lồng",
    part_of_speech: "động từ",
    meaning:
      "cho một vật vào bên trong một vật khác sao cho thật khớp để cùng làm thành một chỉnh thể: lồng bông vào ruột gối * lồng ảnh vào khung * cắt hai chữ lồng vào nhau",
    example:
      "lồng bông vào ruột gối * lồng ảnh vào khung * cắt hai chữ lồng vào nhau",
  },
  {
    word: "lồng",
    part_of_speech: "động từ",
    meaning:
      "(con thú) chạy cất cao vó lên với một sức hăng đột ngột rất khó kìm giữ, do quá hoảng sợ: trâu lồng * ngựa chạy lồng lên",
    example: "trâu lồng * ngựa chạy lồng lên",
  },
  {
    word: "lồng",
    part_of_speech: "động từ",
    meaning:
      "bộc lộ phản ứng quá mạnh do bị tác động, kích thích cao độ mà không kiềm chế được: động một tí là ghen lồng lên * tức lồng lên",
    example: "động một tí là ghen lồng lên * tức lồng lên",
  },
  {
    word: "lồng bồng",
    part_of_speech: "tính từ",
    meaning:
      "(vật xốp, nhẹ) bồng cao lên, không được nén chặt xuống: thúng bông lồng bồng * mớ tóc lồng bồng trước gió",
    example: "thúng bông lồng bồng * mớ tóc lồng bồng trước gió",
  },
  {
    word: "lộng",
    part_of_speech: "danh từ",
    meaning:
      "vùng biển gần bờ; phân biệt với khơi: đánh cá lộng * ra khơi vào lộng",
    example: "đánh cá lộng * ra khơi vào lộng",
  },
  {
    word: "lộng",
    part_of_speech: "tính từ",
    meaning:
      "(gió thổi) mạnh ở nơi trống trải: gió lộng * gió bấc thổi lộng từng hồi",
    example: "gió lộng * gió bấc thổi lộng từng hồi",
  },
  {
    word: "lộng",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) làm quá phạm vi, khuôn phép một cách ngang nhiên, không kiêng nể gì: lóng rày tụi mật thám mần lộng lắm",
    example: "lóng rày tụi mật thám mần lộng lắm",
  },
  {
    word: "lồng bàn",
    part_of_speech: "danh từ",
    meaning:
      "vật có hình thúng, thường đan bằng tre hay làm bằng nhựa, dùng để đậy thức ăn trên mâm, bàn: mâm cơm đậy lồng bàn",
    example: "mâm cơm đậy lồng bàn",
  },
  {
    word: "lông bông",
    part_of_speech: "tính từ",
    meaning:
      "lang thang hết chỗ này đến chỗ kia, nay đây mai đó, không có chủ đích rõ ràng: sống lông bông * suốt ngày chỉ rong chơi lông bông",
    example: "sống lông bông * suốt ngày chỉ rong chơi lông bông",
  },
  {
    word: "lông bông",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) thiếu nghiêm túc, không đâu vào đâu cả: ăn nói lông bông",
    example: "ăn nói lông bông",
  },
  {
    word: "lồng ghép",
    part_of_speech: "động từ",
    meaning:
      "nối vào, ghép vào cho khớp với nhau để làm thành một chỉnh thể: lồng ghép nội dung pháp luật trong môn giáo dục công dân",
    example: "lồng ghép nội dung pháp luật trong môn giáo dục công dân",
  },
  {
    word: "lộng hành",
    part_of_speech: "động từ",
    meaning:
      "lợi dụng thế lực, quyền uy mà hành động càn rỡ một cách ngang nhiên, tuỳ tiện, bất chấp kỉ cương: băng nhóm xã hội đen ngày càng lộng hành",
    example: "băng nhóm xã hội đen ngày càng lộng hành",
  },
  {
    word: "lổng chổng",
    part_of_speech: "tính từ",
    meaning:
      "ở tình trạng ngổn ngang, lộn xộn, mỗi thứ nằm một kiểu, không ra hàng lối gì cả: bàn ghế đổ lổng chổng * guốc dép vứt lổng chổng ngoài sân",
    example: "bàn ghế đổ lổng chổng * guốc dép vứt lổng chổng ngoài sân",
  },
  {
    word: "lồng cồng",
    part_of_speech: "tính từ",
    meaning:
      '(khẩu ngữ) cồng kềnh, không gọn: hành lí lồng cồng * "Lồng cồng như mẹ chồng xới xôi, Bát đầy thì ít, bát vơi thì nhiều." (ca dao)',
    example:
      'hành lí lồng cồng * "Lồng cồng như mẹ chồng xới xôi, Bát đầy thì ít, bát vơi thì nhiều." (ca dao)',
  },
  {
    word: "lộng gió",
    part_of_speech: "tính từ",
    meaning:
      "(nơi) có gió thổi mạnh do cao hoặc trống trải: đồi cao lộng gió * tâm hồn lộng gió (b)",
    example: "đồi cao lộng gió * tâm hồn lộng gió (b)",
  },
  {
    word: "lồng hổng",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) (trẻ con) hỗn láo, hay vòi vĩnh do quá nuông chiều: đứa trẻ lồng hổng",
    example: "đứa trẻ lồng hổng",
  },
  {
    word: "lông hồng",
    part_of_speech: "danh từ",
    meaning:
      "lông chim hồng; thường dùng trong văn học cổ để ví cái chết xem rất nhẹ: coi cái chết nhẹ tựa lông hồng",
    example: "coi cái chết nhẹ tựa lông hồng",
  },
  {
    word: "lông lá",
    part_of_speech: "danh từ",
    meaning:
      "lông mọc dài và rậm (nói khái quát): lông lá đầy mình * chân tay đầy lông lá",
    example: "lông lá đầy mình * chân tay đầy lông lá",
  },
  {
    word: "lồng kính",
    part_of_speech: "danh từ",
    meaning:
      "thiết bị y tế bằng kính có dạng như chiếc lồng, dùng để nuôi dưỡng trẻ sơ sinh trong trường hợp phải cách li với môi trường bên ngoài: sinh thiếu tháng nên phải nuôi trong lồng kính",
    example: "sinh thiếu tháng nên phải nuôi trong lồng kính",
  },
  {
    word: "lộng lẫy",
    part_of_speech: "tính từ",
    meaning: "đẹp rực rỡ và sang trọng: trang phục lộng lẫy * sắc đẹp lộng lẫy",
    example: "trang phục lộng lẫy * sắc đẹp lộng lẫy",
  },
  {
    word: "lồng lộng",
    part_of_speech: "tính từ",
    meaning: "(gió thổi) rất mạnh ở nơi trống trải: gió thổi lồng lộng",
    example: "gió thổi lồng lộng",
  },
  {
    word: "lồng lộng",
    part_of_speech: "tính từ",
    meaning:
      "(khoảng không gian) cao rộng và thoáng đãng, đến mức cảm thấy như vô cùng tận: trời cao lồng lộng * lưới trời lồng lộng",
    example: "trời cao lồng lộng * lưới trời lồng lộng",
  },
  {
    word: "lông lốc",
    part_of_speech: "tính từ",
    meaning: "trọc lông lốc (nói tắt): đầu lông lốc như cái bình vôi",
    example: "đầu lông lốc như cái bình vôi",
  },
  {
    word: "lông lốc",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) (tự lăn) nhiều vòng theo đà: vỏ lon lăn lông lốc dưới sàn * ngã quay lông lốc",
    example: "vỏ lon lăn lông lốc dưới sàn * ngã quay lông lốc",
  },
  {
    word: "lông lốc",
    part_of_speech: "phụ từ",
    meaning:
      "(béo, tròn) đến mức như có thể lăn được: béo quay lông lốc * người tròn lông lốc",
    example: "béo quay lông lốc * người tròn lông lốc",
  },
  {
    word: "lông mày",
    part_of_speech: "danh từ",
    meaning:
      "đám lông mọc thành hàng dài ở phía trên mắt người: lông mày lá liễu * nhíu đôi lông mày * kẻ lông mày",
    example: "lông mày lá liễu * nhíu đôi lông mày * kẻ lông mày",
  },
  {
    word: "lông măng",
    part_of_speech: "danh từ",
    meaning: "lông non của chim chưa mọc xoè dài ra ngoài da.",
    example: "má đầy lông măng",
  },
  {
    word: "lông mi",
    part_of_speech: "danh từ",
    meaning: "lông mọc trên bờ mí mắt: hàng lông mi cong vút",
    example: "hàng lông mi cong vút",
  },
  {
    word: "lồng lộn",
    part_of_speech: "",
    meaning:
      "có những biểu hiện hung hăng đến mức như điên cuồng, vì quá tức giận nên không kìm giữ được: tức lồng lộn * máy bay địch lồng lộn trên bầu trời * ghen lồng lộn",
    example:
      "tức lồng lộn * máy bay địch lồng lộn trên bầu trời * ghen lồng lộn",
  },
  {
    word: "lộng ngữ",
    part_of_speech: "",
    meaning: "(cũ, hiếm) chơi chữ: lối nói lộng ngữ trong văn học dân gian",
    example: "lối nói lộng ngữ trong văn học dân gian",
  },
  {
    word: "lồng ngực",
    part_of_speech: "danh từ",
    meaning:
      "khoang cơ thể giới hạn bởi các xương sườn: thấy đau tức ở lồng ngực",
    example: "thấy đau tức ở lồng ngực",
  },
  {
    word: "lộng quyền",
    part_of_speech: "động từ",
    meaning:
      "làm việc ngang ngược vượt quyền hạn của mình, lấn át cả quyền hạn của người cấp trên: kẻ gian thần lộng quyền",
    example: "kẻ gian thần lộng quyền",
  },
  {
    word: "lộng óc",
    part_of_speech: "động từ",
    meaning:
      "làm cho nhức óc, choáng óc: gió thổi lộng óc * tiếng nổ làm lộng óc",
    example: "gió thổi lộng óc * tiếng nổ làm lộng óc",
  },
  {
    word: "lông nhông",
    part_of_speech: "tính từ",
    meaning:
      "(đi, chạy) có vẻ nhởn nhơ, không được việc gì: suốt ngày lông nhông ngoài đường * chạy lông nhông",
    example: "suốt ngày lông nhông ngoài đường * chạy lông nhông",
  },
  {
    word: "lông quặm",
    part_of_speech: "danh từ",
    meaning:
      "lông mi quặp vào tròng mắt làm loét giác mạc (biến chứng của bệnh đau mắt hột): mổ lông quặm",
    example: "mổ lông quặm",
  },
  {
    word: "lông tơ",
    part_of_speech: "danh từ",
    meaning: "lông chim, đầu có nhiều sợi mảnh và mềm.",
    example: "má đầy lông tơ",
  },
  {
    word: "lồng tiếng",
    part_of_speech: "động từ",
    meaning:
      "tạo tiếng nói cho nhân vật trong phim, sau khi phim đã quay xong phần cơ bản: diễn viên lồng tiếng * kĩ thuật lồng tiếng",
    example: "diễn viên lồng tiếng * kĩ thuật lồng tiếng",
  },
  {
    word: "lộp bộp",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng những tiếng trầm và nặng như tiếng của vật nặng đập xuống mặt đất nghe thưa và không đều: mưa rơi lộp bộp",
    example: "mưa rơi lộp bộp",
  },
  {
    word: "lốp bốp",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng những tiếng phát ra to và giòn nghe thưa và không đều như tiếng bật nổ mạnh: tre nứa cháy nổ lốp bốp",
    example: "tre nứa cháy nổ lốp bốp",
  },
  {
    word: "lốp bốp",
    part_of_speech: "tính từ",
    meaning:
      "(nói năng) không cân nhắc, nghĩ gì nói nấy một cách thẳng thừng: ăn nói lốp bốp",
    example: "ăn nói lốp bốp",
  },
  {
    word: "lốp cốp",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng những tiếng khô, gọn của vật cứng va mạnh vào nhau liên tiếp, nhưng nghe thưa và không đều: rét quá, hai hàm răng va vào nhau lốp cốp",
    example: "rét quá, hai hàm răng va vào nhau lốp cốp",
  },
  {
    word: "lốp",
    part_of_speech: "danh từ",
    meaning:
      "(Nam thường vỏ) vành cao su bọc ngoài săm của bánh một số loại xe, tiếp xúc trực tiếp với mặt đường: lốp xe đạp * xe bị nổ lốp",
    example: "lốp xe đạp * xe bị nổ lốp",
  },
  {
    word: "lốp",
    part_of_speech: "tính từ",
    meaning:
      "(lúa) lớn quá nhanh, có thân cao, lá dài nhưng lép hạt: lúa bị lốp * tốt quá hoá lốp (tng)",
    example: "lúa bị lốp * tốt quá hoá lốp (tng)",
  },
  {
    word: "lộp cộp",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng những tiếng ngắn, gọn và trầm như tiếng của vật cứng nện liên tiếp trên mặt nền cứng: tiếng guốc khua lộp cộp * móng ngựa đập lộp cộp xuống nền gạch",
    example: "tiếng guốc khua lộp cộp * móng ngựa đập lộp cộp xuống nền gạch",
  },
  {
    word: "lốp đốp",
    part_of_speech: "tính từ",
    meaning:
      '(hiếm) như lốp bốp: "Đêm qua lốp đốp mưa rào, Hạt rơi xuống giếng, hạt vào vườn hoa." (ca dao)',
    example:
      'Đêm qua lốp đốp mưa rào, Hạt rơi xuống giếng, hạt vào vườn hoa." (ca dao)',
  },
  {
    word: "lột tả",
    part_of_speech: "động từ",
    meaning:
      "thể hiện được hết, đầy đủ bằng phương tiện nghệ thuật cái có tính chất trừu tượng, khó hình dung: lột tả tâm trạng nhân vật * bản dịch chưa lột tả hết tinh thần chủ đạo của nguyên tác",
    example:
      "lột tả tâm trạng nhân vật * bản dịch chưa lột tả hết tinh thần chủ đạo của nguyên tác",
  },
  {
    word: "lộp độp",
    part_of_speech: "tính từ",
    meaning: "như lộp bộp: cam rụng lộp độp",
    example: "cam rụng lộp độp",
  },
  {
    word: "lốt",
    part_of_speech: "danh từ",
    meaning: "xác bọc ngoài của một số động vật: rắn thay lốt",
    example: "rắn thay lốt",
  },
  {
    word: "lốt",
    part_of_speech: "danh từ",
    meaning:
      "vỏ ngoài, hình thức bên ngoài để che giấu con người thật, nhằm đánh lừa: kẻ gian đội lốt nhà tu * hình dạng ăn mày chỉ là cái lốt bên ngoài của hắn",
    example:
      "kẻ gian đội lốt nhà tu * hình dạng ăn mày chỉ là cái lốt bên ngoài của hắn",
  },
  {
    word: "lốt",
    part_of_speech: "danh từ",
    meaning: "dấu hằn còn để lại: lốt rắn bò trên bùn * vết chém còn hằn lốt",
    example: "lốt rắn bò trên bùn * vết chém còn hằn lốt",
  },
  {
    word: "lỡ",
    part_of_speech: "động từ",
    meaning:
      "do sơ suất làm xảy ra điều không hay khiến phải lấy làm tiếc, làm ân hận: lỡ tay, làm vỡ cái bình quý * lỡ mồm nói dại * chuyện đã lỡ rồi",
    example: "lỡ tay, làm vỡ cái bình quý * lỡ mồm nói dại * chuyện đã lỡ rồi",
  },
  {
    word: "lỡ",
    part_of_speech: "động từ",
    meaning:
      "(Bắc cũng nhỡ) để cho điều kiện khách quan làm việc tốt nào đó qua mất đi một cách đáng tiếc: bị lỡ tàu * lỡ hẹn * bỏ lỡ cơ hội",
    example: "bị lỡ tàu * lỡ hẹn * bỏ lỡ cơ hội",
  },
  {
    word: "lột xác",
    part_of_speech: "động từ",
    meaning:
      "như lột (ng3): ve lột xác * diện mạo văn học như vừa được lột xác (b)",
    example: "ve lột xác * diện mạo văn học như vừa được lột xác (b)",
  },
  {
    word: "lột",
    part_of_speech: "động từ",
    meaning:
      "lấy đi toàn bộ phần vỏ, lớp mỏng bọc ngoài: lột da thú để nhồi bông * tôm càng lột vỏ * lột vỏ chuối",
    example: "lột da thú để nhồi bông * tôm càng lột vỏ * lột vỏ chuối",
  },
  {
    word: "lột",
    part_of_speech: "động từ",
    meaning:
      "lấy đi một cách ít nhiều thô bạo cái kẻ khác đang mặc, đang mang trên người: lột áo * bị lột hết tiền",
    example: "lột áo * bị lột hết tiền",
  },
  {
    word: "lột",
    part_of_speech: "động từ",
    meaning:
      "trút bỏ lớp vỏ, lớp da bên ngoài để thay vỏ, thay da (nói về một số động vật, vào những mùa hay vào những giai đoạn nhất định): rắn lột da * bấy như cua lột * hai cha con giống nhau như lột",
    example: "rắn lột da * bấy như cua lột * hai cha con giống nhau như lột",
  },
  {
    word: "lột",
    part_of_speech: "động từ",
    meaning:
      "làm cho thấy rõ được cái thuộc về bản chất, bản sắc, nhưng ẩn kín: bản dịch đã lột được tinh thần của tác giả * lột mặt kẻ giả nhân giả nghĩa",
    example:
      "bản dịch đã lột được tinh thần của tác giả * lột mặt kẻ giả nhân giả nghĩa",
  },
  {
    word: "lơ",
    part_of_speech: "danh từ",
    meaning:
      "nước có hoà một loại hoá chất tạo thành dung dịch có màu xanh rất nhạt, thường dùng để nhúng quần áo trắng sau khi giặt cho có màu đẹp hơn: áo hồ lơ",
    example: "áo hồ lơ",
  },
  {
    word: "lơ",
    part_of_speech: "động từ",
    meaning:
      "làm cho quần áo trắng có màu xanh nhạt bằng cách nhúng vào nước lơ: lơ quần áo",
    example: "lơ quần áo",
  },
  {
    word: "lơ",
    part_of_speech: "tính từ",
    meaning: "có màu xanh nhạt như màu nước lơ: trời lơ * chiếc áo xanh lơ",
    example: "trời lơ * chiếc áo xanh lơ",
  },
  {
    word: "lơ",
    part_of_speech: "danh từ",
    meaning: "(Khẩu ngữ) lơ xe (nói tắt): đi lơ * làm lơ",
    example: "đi lơ * làm lơ",
  },
  {
    word: "lơ",
    part_of_speech: "động từ",
    meaning:
      'làm ra vẻ không nhìn thấy, không nghe thấy, coi như không hay biết gì: lơ đi như không biết * "Thò tay mà ngắt ngọn ngò, Thương em đứt ruột giả đò ngó lơ." (Cdao)',
    example:
      'lơ đi như không biết * "Thò tay mà ngắt ngọn ngò, Thương em đứt ruột giả đò ngó lơ." (Cdao)',
  },
  {
    word: "lột trần",
    part_of_speech: "động từ",
    meaning: "như bóc trần: lột trần bộ mặt của kẻ bán nước",
    example: "lột trần bộ mặt của kẻ bán nước",
  },
  {
    word: "lợ",
    part_of_speech: "tính từ",
    meaning:
      "có vị không ra mặn cũng không ra ngọt, khó nuốt: nước lợ * ngọt lợ * nước chấm pha hơi lợ",
    example: "nước lợ * ngọt lợ * nước chấm pha hơi lợ",
  },
  {
    word: "lở",
    part_of_speech: "động từ",
    meaning:
      'nứt vỡ ra và sụt đổ xuống: miệng ăn núi lở (tng) * "Con sông kia bên lở bên bồi, Bên lở thì đục bên bồi thì trong." (ca dao)',
    example:
      'miệng ăn núi lở (tng) * "Con sông kia bên lở bên bồi, Bên lở thì đục bên bồi thì trong." (ca dao)',
  },
  {
    word: "lở",
    part_of_speech: "động từ",
    meaning:
      "lên mụn có nước và mủ, vỡ ra và lan rộng, gây đau đớn ngứa ngáy khó chịu: lở đầy người * lợn bị lở mồm long móng",
    example: "lở đầy người * lợn bị lở mồm long móng",
  },
  {
    word: "lỡ bước",
    part_of_speech: "động từ",
    meaning:
      "(cũ, hiếm) gặp bước đường không may trong cuộc đời: bị sa cơ lỡ bước * giúp đỡ kẻ lỡ bước",
    example: "bị sa cơ lỡ bước * giúp đỡ kẻ lỡ bước",
  },
  {
    word: "lỡ duyên",
    part_of_speech: "động từ",
    meaning: "lỡ làng về tình duyên: trái kiếp lỡ duyên",
    example: "trái kiếp lỡ duyên",
  },
  {
    word: "lờ",
    part_of_speech: "danh từ",
    meaning:
      "đồ đan bằng tre nứa, miệng có hom, dùng đặt ở chỗ nước đứng để nhử bắt tôm cá: đặt lờ bắt cá",
    example: "đặt lờ bắt cá",
  },
  {
    word: "lờ",
    part_of_speech: "động từ",
    meaning:
      "làm ra vẻ không để ý, không biết hay cố ý không nhớ: lờ chuyện cũ * lờ đi nhưng không biết gì",
    example: "lờ chuyện cũ * lờ đi nhưng không biết gì",
  },
  {
    word: "lờ",
    part_of_speech: "tính từ",
    meaning:
      'bị vẩn, bị mờ, không còn sáng, trong: nước đục lờ * "Có gì mà oán mà ngờ, Mực đen giấy trắng, trăng lờ vì mây." (ca dao)',
    example:
      'nước đục lờ * "Có gì mà oán mà ngờ, Mực đen giấy trắng, trăng lờ vì mây." (ca dao)',
  },
  {
    word: "lớ",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) (giọng nói) không đúng âm, có nhiều yếu tố bị pha tiếng: nói lớ tiếng miền Nam",
    example: "nói lớ tiếng miền Nam",
  },
  {
    word: "lỡ dở",
    part_of_speech: "tính từ",
    meaning: "dở dang, chưa trọn vẹn: học hành lỡ dở * tình duyên lỡ dở",
    example: "học hành lỡ dở * tình duyên lỡ dở",
  },
  {
    word: "lỡ cỡ",
    part_of_speech: "tính từ",
    meaning:
      "không đúng cỡ nào cả, dùng vào việc gì cũng không thích hợp: đôi giày lỡ cỡ * mảnh vải lỡ cỡ, may một áo thì thừa mà hai áo thì thiếu",
    example:
      "đôi giày lỡ cỡ * mảnh vải lỡ cỡ, may một áo thì thừa mà hai áo thì thiếu",
  },
  {
    word: "lỡ cỡ",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ, khẩu ngữ) ở vào khoảng giữa chừng, không đúng vào dịp nào cả: tuổi lỡ cỡ",
    example: "tuổi lỡ cỡ",
  },
  {
    word: "lờ đờ",
    part_of_speech: "tính từ",
    meaning:
      "rất chậm chạp, thiếu tinh nhanh, thiếu sống động: mắt lờ đờ vì buồn ngủ * dòng nước chảy lờ đờ",
    example: "mắt lờ đờ vì buồn ngủ * dòng nước chảy lờ đờ",
  },
  {
    word: "lơ đãng",
    part_of_speech: "tính từ",
    meaning:
      "thiếu tập trung chú ý vào việc trước mắt do mải nghĩ về những việc nào khác hoặc do hay quên: mắt nhìn lơ đãng",
    example: "mắt nhìn lơ đãng",
  },
  {
    word: "lỡ đường",
    part_of_speech: "động từ",
    meaning:
      "phải dừng lại trên đường đi xa do gặp trắc trở: khách lỡ đường * bị lỡ đường nên phải tìm chỗ trọ",
    example: "khách lỡ đường * bị lỡ đường nên phải tìm chỗ trọ",
  },
  {
    word: "lơ láo",
    part_of_speech: "tính từ",
    meaning:
      "có vẻ ngỡ ngàng, lạc lõng khi cảm thấy xung quanh xa lạ với mình: lơ láo nhìn xung quanh * đi lơ láo ngoài đường",
    example: "lơ láo nhìn xung quanh * đi lơ láo ngoài đường",
  },
  {
    word: "lờ khờ",
    part_of_speech: "tính từ",
    meaning: "(hiếm) khờ khạo, kém tinh khôn: thằng bé lờ khờ quá!",
    example: "thằng bé lờ khờ quá!",
  },
  {
    word: "lỡ làng",
    part_of_speech: "tính từ",
    meaning:
      'dở dang không thành, không đạt do bị trắc trở (thường về chuyện tình duyên): duyên phận lỡ làng * "Phận sao phận bạc như vôi!, Đã đành nước chảy hoa trôi lỡ làng." (TKiều)',
    example:
      'duyên phận lỡ làng * "Phận sao phận bạc như vôi!, Đã đành nước chảy hoa trôi lỡ làng." (TKiều)',
  },
  {
    word: "lơ là",
    part_of_speech: "động từ",
    meaning:
      "tỏ ra không chú ý, không để tâm đến công việc thuộc phận sự của mình: lơ là việc học tập * lơ là nhiệm vụ",
    example: "lơ là việc học tập * lơ là nhiệm vụ",
  },
  {
    word: "lờ lãi",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) như lời lãi: buôn bán nhỏ nên lờ lãi chẳng là bao",
    example: "buôn bán nhỏ nên lờ lãi chẳng là bao",
  },
  {
    word: "lở láy",
    part_of_speech: "động từ",
    meaning: "(hiếm) bị lở (nói khái quát): bị lở láy đầy người",
    example: "bị lở láy đầy người",
  },
  {
    word: "lờ lợ",
    part_of_speech: "tính từ",
    meaning: "hơi lợ: bát canh hơi lờ lợ",
    example: "bát canh hơi lờ lợ",
  },
  {
    word: "lở loét",
    part_of_speech: "",
    meaning:
      "(mụn nhọt, vết thương) phá rộng ra, lan rộng ra: chân tay lở loét * vết thương nhiễm trùng gây lở loét",
    example: "chân tay lở loét * vết thương nhiễm trùng gây lở loét",
  },
  {
    word: "lở lói",
    part_of_speech: "động từ",
    meaning:
      "lở sâu nhiều chỗ làm cho bề mặt nham nhở (nói khái quát): lở lói đầy mình * mặt đường bị lở lói",
    example: "lở lói đầy mình * mặt đường bị lở lói",
  },
  {
    word: "lơ lửng",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái di động nhẹ ở khoảng giữa lưng chừng, không dính bám vào đâu: khói lơ lửng trên không * quả bóng bay lơ lửng",
    example: "khói lơ lửng trên không * quả bóng bay lơ lửng",
  },
  {
    word: "lơ lửng",
    part_of_speech: "tính từ",
    meaning: "như lửng lơ (ng2): trả lời lơ lửng",
    example: "trả lời lơ lửng",
  },
  {
    word: "lờ lững",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như lững lờ: con thuyền lờ lững giữa dòng kênh",
    example: "con thuyền lờ lững giữa dòng kênh",
  },
  {
    word: "lơ ngơ",
    part_of_speech: "tính từ",
    meaning:
      "ngơ ngác, kém linh hoạt vì lạ lẫm hoặc không biết phải làm gì: đi lơ ngơ ngoài đường phố",
    example: "đi lơ ngơ ngoài đường phố",
  },
  {
    word: "lơ lớ",
    part_of_speech: "tính từ",
    meaning: "(giọng nói) hơi lớ: giọng lơ lớ miền Nam",
    example: "giọng lơ lớ miền Nam",
  },
  {
    word: "lờ mờ",
    part_of_speech: "tính từ",
    meaning:
      "(ánh sáng) rất mờ, đến mức không nhìn thấy rõ nét: ánh trăng soi lờ mờ * bóng người lờ mờ trong sương",
    example: "ánh trăng soi lờ mờ * bóng người lờ mờ trong sương",
  },
  {
    word: "lờ mờ",
    part_of_speech: "tính từ",
    meaning:
      "(nhận thức) không rõ ràng, không rành mạch: lờ mờ đoán ra * lờ mờ nhận thấy có điều chẳng lành",
    example: "lờ mờ đoán ra * lờ mờ nhận thấy có điều chẳng lành",
  },
  {
    word: "lỡ lời",
    part_of_speech: "động từ",
    meaning:
      "lỡ nói ra điều không nên nói: biết mình lỡ lời nên lái sang chuyện khác * cháu nó lỡ lời, mong anh bỏ quá cho!",
    example:
      "biết mình lỡ lời nên lái sang chuyện khác * cháu nó lỡ lời, mong anh bỏ quá cho!",
  },
  {
    word: "lơ mơ",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái nửa tỉnh nửa mê, nửa thức nửa ngủ: ngủ lơ mơ * còn lơ mơ, chưa tỉnh hẳn",
    example: "ngủ lơ mơ * còn lơ mơ, chưa tỉnh hẳn",
  },
  {
    word: "lơ mơ",
    part_of_speech: "tính từ",
    meaning:
      "(nhận thức) không có gì rõ ràng, nửa như biết, nửa như không: lơ mơ về chính trị * nhớ lơ mơ",
    example: "lơ mơ về chính trị * nhớ lơ mơ",
  },
  {
    word: "lơ mơ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) không thật sự đi vào việc, thiếu sự chú ý, nửa như làm nửa như không: việc này không thể lơ mơ được!",
    example: "việc này không thể lơ mơ được!",
  },
  {
    word: "lơ phơ",
    part_of_speech: "tính từ",
    meaning: "như lơ thơ: chòm râu lơ phơ",
    example: "chòm râu lơ phơ",
  },
  {
    word: "lở sơn",
    part_of_speech: "động từ",
    meaning:
      "lở do bị dị ứng với nhựa cây sơn làm cho mặt sưng phù, ngứa ngáy, nổi mụn: mặt bị lở sơn",
    example: "mặt bị lở sơn",
  },
  {
    word: "lờ ngờ",
    part_of_speech: "tính từ",
    meaning:
      "vụng về và chậm chạp, kém tinh khôn: trông nó lờ ngờ thế thì làm ăn gì!",
    example: "trông nó lờ ngờ thế thì làm ăn gì!",
  },
  {
    word: "lớ ngớ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) lộ vẻ vụng về, ngớ ngẩn do còn bỡ ngỡ, lạ lẫm: mới ở quê ra nên còn lớ ngớ * đi lớ ngớ ở ngoài đường",
    example: "mới ở quê ra nên còn lớ ngớ * đi lớ ngớ ở ngoài đường",
  },
  {
    word: "lớ quớ",
    part_of_speech: "tính từ",
    meaning:
      "(làm việc gì) có cử động vụng về, động tác lúng túng, thiếu chính xác: tay chân lớ quớ",
    example: "tay chân lớ quớ",
  },
  {
    word: "lờ phờ",
    part_of_speech: "tính từ",
    meaning: "thiếu năng động, uể oải, rã rời: chân tay lờ phờ",
    example: "chân tay lờ phờ",
  },
  {
    word: "lỡ thì",
    part_of_speech: "tính từ",
    meaning: "quá tuổi lấy chồng mà vẫn chưa có chồng: gái lỡ thì",
    example: "gái lỡ thì",
  },
  {
    word: "lơ thơ",
    part_of_speech: "tính từ",
    meaning:
      'thưa thớt, mỗi nơi một ít: cỏ mọc lơ thơ * "Lơ thơ tơ liễu buông mành, Con oanh học nói trên cành mỉa mai." (TKiều)',
    example:
      'cỏ mọc lơ thơ * "Lơ thơ tơ liễu buông mành, Con oanh học nói trên cành mỉa mai." (TKiều)',
  },
  {
    word: "lơ tơ mơ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) như lơ mơ (nhưng ý mức độ nhiều hơn): hết li này thế nào chả lơ tơ mơ * hiểu lơ tơ mơ * làm ăn lơ tơ mơ",
    example:
      "hết li này thế nào chả lơ tơ mơ * hiểu lơ tơ mơ * làm ăn lơ tơ mơ",
  },
  {
    word: "lờ tịt",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) lờ hẳn đi, thản nhiên như không biết gì: đến kì trả nợ nhưng cứ lờ tịt đi",
    example: "đến kì trả nợ nhưng cứ lờ tịt đi",
  },
  {
    word: "lở tở",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như lả tả: đất đá rơi lở tở",
    example: "đất đá rơi lở tở",
  },
  {
    word: "lơ vơ",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như vẩn vơ: một ý tưởng lơ vơ",
    example: "một ý tưởng lơ vơ",
  },
  {
    word: "lờ vờ",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) (làm việc gì) không thật sự chuyên chú hoặc chỉ qua quýt, lấy lệ cho xong: làm ăn lờ vờ",
    example: "làm ăn lờ vờ",
  },
  {
    word: "lơ xe",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) người phụ cho tài xế xe khách, thường làm những việc như soát vé, thu tiền, xếp chỗ, v.v.: làm lơ xe",
    example: "làm lơ xe",
  },
  {
    word: "lời",
    part_of_speech: "danh từ",
    meaning:
      "chuỗi âm thanh phát ra trong khi nói mang một nội dung trọn vẹn nhất định: lời xin lỗi * xin được nói vài lời * không cần phải nhiều lời",
    example: "lời xin lỗi * xin được nói vài lời * không cần phải nhiều lời",
  },
  {
    word: "lời",
    part_of_speech: "danh từ",
    meaning:
      "nội dung điều nói hoặc viết ra nhằm mục đích nhất định: vâng lời cha mẹ * lựa lời khuyên nhủ * nhạc không lời",
    example: "vâng lời cha mẹ * lựa lời khuyên nhủ * nhạc không lời",
  },
  {
    word: "lời",
    part_of_speech: "danh từ",
    meaning: "như lãi: buôn bán kiếm lời",
    example: "buôn bán kiếm lời",
  },
  {
    word: "lớ xớ",
    part_of_speech: "động từ",
    meaning:
      "lảng vảng, quanh quẩn ở nơi không cần thiết đến mình, không có việc gì phải đến đó: đứng lớ xớ ngoài hiên",
    example: "đứng lớ xớ ngoài hiên",
  },
  {
    word: "lơi",
    part_of_speech: "động từ",
    meaning:
      "(cầm, nắm) không thật chặt, thật chắc, để cho vật cầm có thể dễ dàng rời khỏi tay: lơi tay súng * lơi tay là sợi dây sẽ tuột",
    example: "lơi tay súng * lơi tay là sợi dây sẽ tuột",
  },
  {
    word: "lơi",
    part_of_speech: "động từ",
    meaning:
      "không giữ được sự liên tục một cách nghiêm ngặt, có lúc ngừng, nghỉ hoặc không chú ý: công việc túi bụi, không lúc nào được lơi tay * buông lơi quản lí",
    example:
      "công việc túi bụi, không lúc nào được lơi tay * buông lơi quản lí",
  },
  {
    word: "lơi",
    part_of_speech: "động từ",
    meaning:
      "không giữ, mà để rủ xuống, buông xuống một cách tự nhiên: tóc bỏ lơi",
    example: "tóc bỏ lơi",
  },
  {
    word: "lơi",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) dôi, thừa: nấu lơi cơm để sáng mai ăn",
    example: "nấu lơi cơm để sáng mai ăn",
  },
  {
    word: "lơi",
    part_of_speech: "tính từ",
    meaning:
      '(xe, buộc) không săn, không chặt: chỉ xe lơi * "Thường thường phải đạo thì thôi, Đừng săn mà đứt, đừng lơi mà chùng." (ca dao)',
    example:
      'chỉ xe lơi * "Thường thường phải đạo thì thôi, Đừng săn mà đứt, đừng lơi mà chùng." (ca dao)',
  },
  {
    word: "lợi",
    part_of_speech: "danh từ",
    meaning:
      "phần thịt bao giữ xung quanh chân răng: cười hở lợi * nghiến răng nghiến lợi * có răng răng nhai, không răng thì lợi gặm (tng)",
    example:
      "cười hở lợi * nghiến răng nghiến lợi * có răng răng nhai, không răng thì lợi gặm (tng)",
  },
  {
    word: "lợi",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ, Ít dùng) mép, bờ: bước xuống lợi nước",
    example: "bước xuống lợi nước",
  },
  {
    word: "lợi",
    part_of_speech: "danh từ",
    meaning:
      "cái có ích mà con người thu được nhiều hơn những gì mà con người phải bỏ ra: hai bên cùng có lợi * hưởng lợi * làm việc thiện không cầu lợi",
    example: "hai bên cùng có lợi * hưởng lợi * làm việc thiện không cầu lợi",
  },
  {
    word: "lợi",
    part_of_speech: "tính từ",
    meaning:
      "có lợi, mang lại cho con người nhiều hơn là con người phải bỏ ra: điều này lợi cho công việc",
    example: "điều này lợi cho công việc",
  },
  {
    word: "lợi",
    part_of_speech: "tính từ",
    meaning:
      "ít tốn hơn: lựa chiều để cắt cho lợi vải * sắp xếp sao cho lợi chỗ",
    example: "lựa chiều để cắt cho lợi vải * sắp xếp sao cho lợi chỗ",
  },
  {
    word: "lời ăn tiếng nói",
    part_of_speech: "",
    meaning:
      "cách nói năng trong giao thiệp hàng ngày (nói khái quát): dạy bảo từ lời ăn tiếng nói",
    example: "dạy bảo từ lời ăn tiếng nói",
  },
  {
    word: "lợi danh",
    part_of_speech: "danh từ",
    meaning:
      '(hiếm) như danh lợi: "Cánh buồm bể hoạn mênh mang, Cái phong ba khéo cợt phường lợi danh." (CO)',
    example:
      'Cánh buồm bể hoạn mênh mang, Cái phong ba khéo cợt phường lợi danh." (CO)',
  },
  {
    word: "lợi dụng",
    part_of_speech: "động từ",
    meaning:
      "dựa vào điều kiện thuận lợi nào đó để làm việc gì (sẽ dễ thành công): lợi dụng thời cơ",
    example: "lợi dụng thời cơ",
  },
  {
    word: "lợi dụng",
    part_of_speech: "động từ",
    meaning:
      "dựa vào điều kiện thuận lợi nào đó để mưu lợi riêng không chính đáng: lợi dụng lòng tốt của người khác * lợi dụng uy tín để lừa bịp",
    example: "lợi dụng lòng tốt của người khác * lợi dụng uy tín để lừa bịp",
  },
  {
    word: "lời đường mật",
    part_of_speech: "",
    meaning:
      "lời nói ngọt ngào nhằm mục đích dụ dỗ, lừa phỉnh: nghe lời đường mật * dùng lời đường mật để dụ dỗ",
    example: "nghe lời đường mật * dùng lời đường mật để dụ dỗ",
  },
  {
    word: "lời giải",
    part_of_speech: "danh từ",
    meaning:
      "phần trình bày cách tìm ra đáp số hoặc cách chứng minh phần kết luận của một bài toán: lời giải của bài toán đố",
    example: "lời giải của bài toán đố",
  },
  {
    word: "lời giải",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) lời giải thích hoặc cách thức giải quyết hợp lí đối với một vấn đề, một công việc: vấn đề chưa tìm ra lời giải",
    example: "vấn đề chưa tìm ra lời giải",
  },
  {
    word: "lợi hại",
    part_of_speech: "danh từ",
    meaning:
      "mặt lợi và mặt hại của một việc gì, trong quan hệ so sánh với nhau (nói khái quát): tính toán các mặt lợi hại * phân tích lợi hại của dự án",
    example: "tính toán các mặt lợi hại * phân tích lợi hại của dự án",
  },
  {
    word: "lợi hại",
    part_of_speech: "tính từ",
    meaning:
      "quan trọng vì có tác dụng lớn, có thể gây tổn thất đáng sợ cho đối phương: vũ khí lợi hại * một đối thủ lợi hại",
    example: "vũ khí lợi hại * một đối thủ lợi hại",
  },
  {
    word: "lợi ích",
    part_of_speech: "danh từ",
    meaning:
      "điều có ích, có lợi cho một đối tượng nào đó, trong mối quan hệ với đối tượng ấy (nói khái quát): lợi ích vật chất * đặt lợi ích của tập thể lên trên lợi ích cá nhân",
    example:
      "lợi ích vật chất * đặt lợi ích của tập thể lên trên lợi ích cá nhân",
  },
  {
    word: "lợi ích",
    part_of_speech: "danh từ",
    meaning: "như ích lợi: lợi ích của việc trồng cây",
    example: "lợi ích của việc trồng cây",
  },
  {
    word: "lời lãi",
    part_of_speech: "",
    meaning:
      "lãi do buôn bán, làm ăn (nói khái quát): buôn chung, lời lãi chia đôi * hàng chững nên chẳng lời lãi mấy",
    example: "buôn chung, lời lãi chia đôi * hàng chững nên chẳng lời lãi mấy",
  },
  {
    word: "lợi điểm",
    part_of_speech: "danh từ",
    meaning: "điểm có lợi, chỗ lợi: phương pháp mới có nhiều lợi điểm",
    example: "phương pháp mới có nhiều lợi điểm",
  },
  {
    word: "lợi khí",
    part_of_speech: "danh từ",
    meaning:
      "công cụ, phương tiện có hiệu lực để tiến hành một việc nào đó: báo chí là lợi khí tuyên truyền * bị mất lợi khí",
    example: "báo chí là lợi khí tuyên truyền * bị mất lợi khí",
  },
  {
    word: "lơi lỏng",
    part_of_speech: "động từ",
    meaning:
      "buông lỏng, không chặt chẽ, nghiêm ngặt như vốn có hoặc như quy định: quản lí lơi lỏng * lơi lỏng trong việc dạy dỗ con cái",
    example: "quản lí lơi lỏng * lơi lỏng trong việc dạy dỗ con cái",
  },
  {
    word: "lơi là",
    part_of_speech: "động từ",
    meaning: "(hiếm) như lơ là: canh gác lơi là * lơi là công việc",
    example: "canh gác lơi là * lơi là công việc",
  },
  {
    word: "lời lẽ",
    part_of_speech: "danh từ",
    meaning:
      "lời nói, về mặt nội dung và cách diễn đạt (nói khái quát): lời lẽ ngon ngọt * dùng lời lẽ để khuyên can",
    example: "lời lẽ ngon ngọt * dùng lời lẽ để khuyên can",
  },
  {
    word: "lợi lộc",
    part_of_speech: "danh từ",
    meaning:
      "món lợi (nói khái quát; thường hàm ý chê): kiếm chác lợi lộc * việc đó chẳng mang lại lợi lộc gì!",
    example: "kiếm chác lợi lộc * việc đó chẳng mang lại lợi lộc gì!",
  },
  {
    word: "lời lỗ",
    part_of_speech: "danh từ",
    meaning: "các khoản lỗ và lãi (nói khái quát): hạch toán các khoản lỗ lãi",
    example: "hạch toán các khoản lỗ lãi",
  },
  {
    word: "lời nói",
    part_of_speech: "danh từ",
    meaning:
      "những lời con người nói ra trong một hoàn cảnh giao tiếp cụ thể (nói tổng quát): nghe lời nói phải * lời nói dịu dàng * lời nói không đi đôi với việc làm",
    example:
      "nghe lời nói phải * lời nói dịu dàng * lời nói không đi đôi với việc làm",
  },
  {
    word: "lời nói",
    part_of_speech: "danh từ",
    meaning:
      "sản phẩm cụ thể của hoạt động ngôn ngữ, trong quan hệ đối lập với ngôn ngữ: mối quan hệ giữa ngôn ngữ và lời nói",
    example: "mối quan hệ giữa ngôn ngữ và lời nói",
  },
  {
    word: "lợi nhuận",
    part_of_speech: "danh từ",
    meaning:
      "khoản tiền chênh lệch do thu nhập vượt chi phí sau một quá trình sản xuất, kinh doanh (thường nói về những tổ chức kinh doanh lớn): kinh doanh có lợi nhuận * chạy theo lợi nhuận",
    example: "kinh doanh có lợi nhuận * chạy theo lợi nhuận",
  },
  {
    word: "lợi suất",
    part_of_speech: "danh từ",
    meaning:
      "tỉ lệ phần trăm của giá trị thặng dư so với toàn bộ tư bản bỏ vào sản xuất: lợi suất trái phiếu",
    example: "lợi suất trái phiếu",
  },
  {
    word: "lợi thế",
    part_of_speech: "danh từ",
    meaning:
      "thế có lợi hơn người khác, hơn đối phương: lợi thế về nhân lực * được hưởng lợi thế * chiếm lợi thế",
    example: "lợi thế về nhân lực * được hưởng lợi thế * chiếm lợi thế",
  },
  {
    word: "lời tựa",
    part_of_speech: "danh từ",
    meaning:
      "phần viết ở đầu sách để trình bày một số điều cần thiết về cuốn sách đó: viết đề tựa cho cuốn sách",
    example: "viết đề tựa cho cuốn sách",
  },
  {
    word: "lợm",
    part_of_speech: "tính từ",
    meaning:
      'có cảm giác bị kích thích làm cho thấy buồn nôn, kinh tởm: mùi tanh lợm * "Miếng cao lương phong lưu nhưng lợm, Mùi hoắc lê thanh đạm mà ngon." (CO)',
    example:
      'mùi tanh lợm * "Miếng cao lương phong lưu nhưng lợm, Mùi hoắc lê thanh đạm mà ngon." (CO)',
  },
  {
    word: "lời văn",
    part_of_speech: "danh từ",
    meaning:
      "hình thức diễn đạt bằng ngôn ngữ được viết thành văn: lời văn rườm rà",
    example: "lời văn rườm rà",
  },
  {
    word: "lợi tiểu",
    part_of_speech: "tính từ",
    meaning:
      "có tác dụng làm cho tiểu tiện được dễ dàng: nước râu ngô có tác dụng lợi tiểu",
    example: "nước râu ngô có tác dụng lợi tiểu",
  },
  {
    word: "lởm chởm",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều đầu nhọn, cứng nhô lên hoặc đâm ra, không đều: mỏm đá lởm chởm * râu ria mọc lởm chởm",
    example: "mỏm đá lởm chởm * râu ria mọc lởm chởm",
  },
  {
    word: "lợi tức",
    part_of_speech: "danh từ",
    meaning:
      "tiền lãi thu được từ việc sản xuất kinh doanh hoặc từ khoản tiền cho vay, gửi ngân hàng: lợi tức cổ phần * thuế lợi tức * được hưởng lợi tức hằng năm",
    example: "lợi tức cổ phần * thuế lợi tức * được hưởng lợi tức hằng năm",
  },
  {
    word: "lỡm",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) xỏ ngầm, làm cho người ta mắc lừa để đùa cợt hoặc chế giễu: bị mắc lỡm * làm gì mà lỡm nhau thế?",
    example: "bị mắc lỡm * làm gì mà lỡm nhau thế?",
  },
  {
    word: "lởm cha lởm chởm",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) rất lởm chởm, gây cảm giác hơi ghê sợ: tường cắm lởm cha lởm chởm mảnh sành",
    example: "tường cắm lởm cha lởm chởm mảnh sành",
  },
  {
    word: "lợm giọng",
    part_of_speech: "tính từ",
    meaning:
      "có cảm giác lợm trong cổ họng, muốn buồn nôn: mùi tanh đến lợm giọng",
    example: "mùi tanh đến lợm giọng",
  },
  {
    word: "lớn",
    part_of_speech: "tính từ",
    meaning:
      "có kích thước, số lượng, phạm vi, quy mô hoặc giá trị, ý nghĩa đáng kể hay hơn hẳn so với phần nhiều những cái khác cùng loại: con đường lớn * gió lớn * làm ăn lớn * người có chí lớn",
    example: "con đường lớn * gió lớn * làm ăn lớn * người có chí lớn",
  },
  {
    word: "lớn",
    part_of_speech: "tính từ",
    meaning:
      "(âm thanh) có cường độ mạnh, vang xa, nghe rõ hơn bình thường: cất tiếng cười lớn * lớn tiếng quát * tiếng nổ lớn",
    example: "cất tiếng cười lớn * lớn tiếng quát * tiếng nổ lớn",
  },
  {
    word: "lớn",
    part_of_speech: "tính từ",
    meaning:
      "(người, sinh vật) ở vào giai đoạn đã phát triển tương đối đầy đủ, không còn non yếu: cá lớn * cây dừa lớn * lớn rồi còn làm nũng mẹ",
    example: "cá lớn * cây dừa lớn * lớn rồi còn làm nũng mẹ",
  },
  {
    word: "lớn",
    part_of_speech: "tính từ",
    meaning:
      "(người) có chức vị cao trong chế độ phong kiến: quan lớn * bà lớn",
    example: "quan lớn * bà lớn",
  },
  {
    word: "lớn",
    part_of_speech: "động từ",
    meaning:
      "(người, sinh vật) phát triển, tăng lên về hình vóc, kích thước, trọng lượng, v.v.: đang tuổi lớn * lớn nhanh như thổi",
    example: "đang tuổi lớn * lớn nhanh như thổi",
  },
  {
    word: "lờm lợm",
    part_of_speech: "tính từ",
    meaning: "có cảm giác hơi lợm: mùi tanh lờm lợm",
    example: "mùi tanh lờm lợm",
  },
  {
    word: "lởm khởm",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ở tình trạng không tốt, không hay vì gồm nhiều cái, nhiều loại tốt xấu lẫn lộn, không đều, không ra đâu vào đâu: máy móc lởm khởm * ăn nói lởm khởm",
    example: "máy móc lởm khởm * ăn nói lởm khởm",
  },
  {
    word: "lờn",
    part_of_speech: "động từ",
    meaning:
      "không giữ được thái độ đúng mực, lễ phép như ban đầu, do coi thường sau nhiều lần tiếp xúc dễ dãi: dễ quá để bọn trẻ nó nhờn * coi nhờn phép nước",
    example: "dễ quá để bọn trẻ nó nhờn * coi nhờn phép nước",
  },
  {
    word: "lờn",
    part_of_speech: "động từ",
    meaning:
      "trơ ra, không còn chịu tác động nữa do đã quá quen, quá nhàm: cơ thể đã nhờn kháng sinh",
    example: "cơ thể đã nhờn kháng sinh",
  },
  {
    word: "lờn",
    part_of_speech: "tính từ",
    meaning:
      "trơn và láng vì có chất dầu, mỡ: cái chảo nhờn mỡ * dầu mỡ nhờn tay * được một bữa nhờn môi (kng)",
    example: "cái chảo nhờn mỡ * dầu mỡ nhờn tay * được một bữa nhờn môi (kng)",
  },
  {
    word: "lợn",
    part_of_speech: "danh từ",
    meaning:
      "loài động vật có da màu hồng, đen hoặc nâu, chân ngắn có guốc, mũi rộng, đuôi xoắn. Lợn có thể được nuôi lấy thịt hoặc sống hoang dại trong rừng: thịt lợn * Thằng ấy ăn như lợn ý (= ăn rất nhiều)!",
    example: "thịt lợn * Thằng ấy ăn như lợn ý (= ăn rất nhiều)!",
  },
  {
    word: "lờm xờm",
    part_of_speech: "tính từ",
    meaning:
      "có nhiều sợi, nhiều lớp dài ngắn không đều và hơi xù lên, trông không gọn: tóc tai lờm xờm * mái rạ lờm xờm",
    example: "tóc tai lờm xờm * mái rạ lờm xờm",
  },
  {
    word: "lớn bổng",
    part_of_speech: "động từ",
    meaning: "lớn nhanh, vượt hẳn lên: mới đó mà cu cậu đã lớn bổng rồi",
    example: "mới đó mà cu cậu đã lớn bổng rồi",
  },
  {
    word: "lớn bồng",
    part_of_speech: "động từ",
    meaning:
      "lớn lên nhanh trông thấy (thường nói về các em thiếu niên): thằng bé lớn bồng lên",
    example: "thằng bé lớn bồng lên",
  },
  {
    word: "lợn cợn",
    part_of_speech: "tính từ",
    meaning:
      "(chất lỏng) có lẫn những hạt hay cặn nhỏ làm cho không trong hoặc không mịn, không nhuyễn: bột còn lợn cợn",
    example: "bột còn lợn cợn",
  },
  {
    word: "lớn lao",
    part_of_speech: "tính từ",
    meaning:
      "(văn chương) to lớn (về giá trị tinh thần hay về ý nghĩa, tác dụng): những cống hiến lớn lao * trách nhiệm lớn lao * sự kiện có ý nghĩa lớn lao",
    example:
      "những cống hiến lớn lao * trách nhiệm lớn lao * sự kiện có ý nghĩa lớn lao",
  },
  {
    word: "lớn mạnh",
    part_of_speech: "động từ",
    meaning:
      "phát triển trở thành lực lượng mạnh mẽ: tổ chức ngày càng lớn mạnh * nền kinh tế lớn mạnh",
    example: "tổ chức ngày càng lớn mạnh * nền kinh tế lớn mạnh",
  },
  {
    word: "lớn khôn",
    part_of_speech: "tính từ",
    meaning: "như khôn lớn: con cái đã lớn khôn",
    example: "con cái đã lớn khôn",
  },
  {
    word: "lớn phổng",
    part_of_speech: "động từ",
    meaning:
      "lớn nhanh khác thường, phổng phao trông thấy: cô bé đã lớn phổng lên trông thấy",
    example: "cô bé đã lớn phổng lên trông thấy",
  },
  {
    word: "lớn tiếng",
    part_of_speech: "tính từ",
    meaning:
      "(phát biểu ý kiến) công khai bằng những lời lẽ mạnh mẽ, kiên quyết: lớn tiếng lên án hành vi vô nhân đạo",
    example: "lớn tiếng lên án hành vi vô nhân đạo",
  },
  {
    word: "lớn tuổi",
    part_of_speech: "tính từ",
    meaning:
      "tương đối nhiều tuổi, không còn trẻ (nhưng cũng chưa già): một nhà văn lớn tuổi",
    example: "một nhà văn lớn tuổi",
  },
  {
    word: "lởn vởn",
    part_of_speech: "động từ",
    meaning:
      "quanh quẩn mãi không rời, khi gần khi xa, lúc ẩn lúc hiện: đi lởn vởn ngoài ngõ * khói lởn vởn trên rặng tre",
    example: "đi lởn vởn ngoài ngõ * khói lởn vởn trên rặng tre",
  },
  {
    word: "lớn tướng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) rất lớn, hơn hẳn mức bình thường: con cái đã lớn tướng cả rồi * lớn tướng rồi chứ còn bé bỏng gì nữa!",
    example:
      "con cái đã lớn tướng cả rồi * lớn tướng rồi chứ còn bé bỏng gì nữa!",
  },
  {
    word: "lơn tơn",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) có dáng vẻ nhởn nhơ, hí hửng: hay lơn tơn ngoài đường",
    example: "hay lơn tơn ngoài đường",
  },
  {
    word: "lợp",
    part_of_speech: "động từ",
    meaning:
      "làm cho được phủ kín bên trên bằng một lớp vật liệu thích hợp: nhà lợp rạ * lợp mui xe * ô lợp bằng vải",
    example: "nhà lợp rạ * lợp mui xe * ô lợp bằng vải",
  },
  {
    word: "lớp nhớp",
    part_of_speech: "tính từ",
    meaning:
      "dinh dính và bẩn, gây cảm giác khó chịu: tay lớp nhớp mồ hôi * đường đất lớp nhớp những bùn",
    example: "tay lớp nhớp mồ hôi * đường đất lớp nhớp những bùn",
  },
  {
    word: "lớp học",
    part_of_speech: "danh từ",
    meaning:
      "phòng dùng làm nơi học tập và giảng dạy: giáo viên vào lớp học * lớp học im phăng phắc",
    example: "giáo viên vào lớp học * lớp học im phăng phắc",
  },
  {
    word: "lớp lang",
    part_of_speech: "danh từ",
    meaning:
      "thứ tự trước sau giữa các phần (nói khái quát): trình bày có lớp lang",
    example: "trình bày có lớp lang",
  },
  {
    word: "lũ",
    part_of_speech: "danh từ",
    meaning:
      "nước dâng cao ở vùng nguồn, dồn vào dòng sông trong một thời gian tương đối ngắn, do mưa hoặc tuyết tan gây ra: mùa lũ * lũ đổ về các sông",
    example: "mùa lũ * lũ đổ về các sông",
  },
  {
    word: "lũ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) tập hợp một số động vật cùng loài lâm thời tụ họp lại tương đối đông, không thành tổ chức: lũ trẻ * lũ chuột * kết bè kéo lũ",
    example: "lũ trẻ * lũ chuột * kết bè kéo lũ",
  },
  {
    word: "lũ",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp đông người có chung một đặc điểm hay cùng tham gia một hoạt động nào đó (thường hàm ý coi khinh hoặc thân mật): lũ giặc * một lũ ăn hại! * đi chơi cùng lũ bạn * lũ làng",
    example: "lũ giặc * một lũ ăn hại! * đi chơi cùng lũ bạn * lũ làng",
  },
  {
    word: "lu",
    part_of_speech: "danh từ",
    meaning: "đồ đựng bằng gốm, hình dáng giống chum nhưng nhỏ hơn: lu nước",
    example: "lu nước",
  },
  {
    word: "lu",
    part_of_speech: "danh từ",
    meaning:
      "quả lăn bằng gang rất nặng, dùng để làm cho đất đá trên mặt nền được nén chặt và bằng phẳng: quả lu",
    example: "quả lu",
  },
  {
    word: "lu",
    part_of_speech: "tính từ",
    meaning:
      '(Phương ngữ) mờ, không sáng rõ: "Trăng lu vì bởi áng mây, Đôi ta cách trở vì dây tơ hồng." (Cdao)',
    example: 'Trăng lu vì bởi áng mây, Đôi ta cách trở vì dây tơ hồng." (Cdao)',
  },
  {
    word: "lớp",
    part_of_speech: "danh từ",
    meaning:
      "phần vật chất phủ đều bên ngoài một vật thể: quét một lớp sơn * gọt lớp vỏ ngoài * chiếc lọ bị phủ một lớp bụi",
    example:
      "quét một lớp sơn * gọt lớp vỏ ngoài * chiếc lọ bị phủ một lớp bụi",
  },
  {
    word: "lớp",
    part_of_speech: "danh từ",
    meaning:
      "phần của vật thể được cấu tạo theo kiểu phần này tiếp theo phần kia từ trên xuống dưới hay từ trong ra ngoài: áo may hai lớp * xếp từng lớp lá * sóng xô từng lớp vào bờ",
    example: "áo may hai lớp * xếp từng lớp lá * sóng xô từng lớp vào bờ",
  },
  {
    word: "lớp",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp người cùng một lứa tuổi hay cùng có chung những đặc trưng xã hội nào đó: lớp trẻ * hiểu rõ tâm lí của lớp thanh niên * thành phần trung nông lớp trên",
    example:
      "lớp trẻ * hiểu rõ tâm lí của lớp thanh niên * thành phần trung nông lớp trên",
  },
  {
    word: "lớp",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp người cùng học một năm học ở nhà trường hay cùng theo chung một khoá huấn luyện, đào tạo: bạn cùng lớp * khối 6 chia làm 5 lớp",
    example: "bạn cùng lớp * khối 6 chia làm 5 lớp",
  },
  {
    word: "lớp",
    part_of_speech: "danh từ",
    meaning:
      "chương trình học từng năm học hay từng khoá huấn luyện, đào tạo: học sinh lớp 6 * mở lớp dạy thêm * lớp đào tạo cán bộ",
    example: "học sinh lớp 6 * mở lớp dạy thêm * lớp đào tạo cán bộ",
  },
  {
    word: "lớp",
    part_of_speech: "danh từ",
    meaning:
      "lớp học (nói tắt): cô giáo vào lớp * đến lớp đúng giờ * ngồi cuối lớp",
    example: "cô giáo vào lớp * đến lớp đúng giờ * ngồi cuối lớp",
  },
  {
    word: "lớp",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị phân loại sinh học, dưới ngành, trên bộ: lớp bò sát * lớp thú * lớp chim",
    example: "lớp bò sát * lớp thú * lớp chim",
  },
  {
    word: "lớp",
    part_of_speech: "danh từ",
    meaning:
      "đoạn ngắn trong kịch nói, lấy việc ra hay vào của nhân vật làm chuẩn.",
    example:
      "lớp này thời tiết khá lạnh * công việc làm ăn có dễ chịu hơn lớp trước",
  },
  {
    word: "lợt",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ)",
    example:
      'Chữ tình càng tưởng càng thâm, Muốn pha khó lợt muốn dầm khôn phai." (LVT)',
  },
  {
    word: "lú",
    part_of_speech: "danh từ",
    meaning: "lối chơi cờ bạc thời trước, đặt tiền vào bốn cửa: đánh lú",
    example: "đánh lú",
  },
  {
    word: "lú",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) nhú lên hoặc ló ra: cây lú mầm",
    example: "cây lú mầm",
  },
  {
    word: "lú",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) ở trạng thái trí tuệ kém, hầu như không có hoặc không còn trí nhớ, trí khôn: bị bùa mê thuốc lú * nó lú nhưng chú nó khôn (tng)",
    example: "bị bùa mê thuốc lú * nó lú nhưng chú nó khôn (tng)",
  },
  {
    word: "lù đù",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả dáng vẻ ngờ nghệch, chậm chạp, không lanh lợi: dáng lù đù, chậm chạp",
    example: "dáng lù đù, chậm chạp",
  },
  {
    word: "lớt phớt",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái làm thành một lớp phủ rất thưa, rất mỏng: má lớt phớt hồng * trời lớt phớt mưa",
    example: "má lớt phớt hồng * trời lớt phớt mưa",
  },
  {
    word: "lớt phớt",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) hời hợt bề ngoài, không đi vào thực chất, vào chiều sâu: học hành lớt phớt * làm ăn lớt phớt",
    example: "học hành lớt phớt * làm ăn lớt phớt",
  },
  {
    word: "lu bù",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ở mức độ không thấy có bất cứ một cái gì làm giới hạn cả: họp hành lu bù * rượu chè lu bù",
    example: "họp hành lu bù * rượu chè lu bù",
  },
  {
    word: "lù khù",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả dáng vẻ chậm chạp, không nhanh nhẹn, hoạt bát: người lù khù, ngờ nghệch",
    example: "người lù khù, ngờ nghệch",
  },
  {
    word: "lủ khủ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) nhiều và như được bày ra la liệt: xung quanh lủ khủ những hũ gạo khạp mắm",
    example: "xung quanh lủ khủ những hũ gạo khạp mắm",
  },
  {
    word: "lũ lĩ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) tập hợp với số lượng tương đối đông (nói khái quát): đi đâu cũng kéo cả lũ lĩ",
    example: "đi đâu cũng kéo cả lũ lĩ",
  },
  {
    word: "lũ lĩ",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) với số lượng người rất đông, như thành cả một đoàn: bọn trẻ lũ lĩ kéo nhau ra sân bóng",
    example: "bọn trẻ lũ lĩ kéo nhau ra sân bóng",
  },
  {
    word: "lú lẫn",
    part_of_speech: "",
    meaning:
      "ở trạng thái trí tuệ suy kém, hay quên, hay lẫn: đầu óc lú lẫn, để đâu cũng không biết * già rồi nên sinh lú lẫn",
    example: "đầu óc lú lẫn, để đâu cũng không biết * già rồi nên sinh lú lẫn",
  },
  {
    word: "lú lấp",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) ở vào trạng thái mất đi trí nhớ, trí khôn trong một lúc nào đó: say đến lú lấp",
    example: "say đến lú lấp",
  },
  {
    word: "lu loa",
    part_of_speech: "động từ",
    meaning:
      "cố tình làm ầm ĩ lên một cách quá mức việc liên quan tới mình để ăn vạ hoặc để tranh thủ sự đồng tình (hàm ý chê): khóc lu loa * hơi một tí là lu loa lên",
    example: "khóc lu loa * hơi một tí là lu loa lên",
  },
  {
    word: "lụ khụ",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả dáng vẻ người già, chậm chạp và yếu đuối, biểu hiện không còn sức sống bao nhiêu: già lụ khụ * mới có 50 tuổi mà lụ khụ hơn cả người 80 mươi",
    example: "già lụ khụ * mới có 50 tuổi mà lụ khụ hơn cả người 80 mươi",
  },
  {
    word: "lù lù",
    part_of_speech: "tính từ",
    meaning:
      "lớn và sừng sững ngay trước mặt, làm vướng mắt tựa như không nhìn cũng cứ phải thấy: lù lù một đống gạch giữa sân * chiếc xe tăng lù lù tiến vào",
    example: "lù lù một đống gạch giữa sân * chiếc xe tăng lù lù tiến vào",
  },
  {
    word: "lu mờ",
    part_of_speech: "",
    meaning:
      "mờ đi, ánh sáng chỉ còn yếu ớt, đến mức không thấy rõ nữa: ngọn đèn lu mờ dần",
    example: "ngọn đèn lu mờ dần",
  },
  {
    word: "lu mờ",
    part_of_speech: "",
    meaning:
      "mờ nhạt, không còn nổi bật, tiêu biểu nữa: vai trò của anh ta đã bị lu mờ",
    example: "vai trò của anh ta đã bị lu mờ",
  },
  {
    word: "lũ lụt",
    part_of_speech: "danh từ",
    meaning: "lũ và lụt (nói khái quát): quyên tiền ủng hộ đồng bào bị lũ lụt",
    example: "quyên tiền ủng hộ đồng bào bị lũ lụt",
  },
  {
    word: "lũ lượt",
    part_of_speech: "phụ từ",
    meaning:
      "thành từng đoàn nối tiếp nhau không ngớt: mọi người lũ lượt kéo nhau đi xem hội",
    example: "mọi người lũ lượt kéo nhau đi xem hội",
  },
  {
    word: "lù mù",
    part_of_speech: "tính từ",
    meaning:
      "có ánh sáng yếu ớt đến mức trông dở sáng dở tối: ngọn đèn dầu lù mù",
    example: "ngọn đèn dầu lù mù",
  },
  {
    word: "lù rù",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả dáng vẻ chậm chạp, lờ đờ như người đau yếu: ngồi lù rù một chỗ * đi đứng lù rù",
    example: "ngồi lù rù một chỗ * đi đứng lù rù",
  },
  {
    word: "lùa",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ bằng sắt có những lỗ tròn nhỏ để kéo kim loại (thường là vàng, bạc) thành sợi: bàn lùa",
    example: "bàn lùa",
  },
  {
    word: "lùa",
    part_of_speech: "động từ",
    meaning:
      "dồn lại thành đàn và bắt phải di chuyển về một hướng, một nơi nhất định: lùa đàn trâu ra đồng * lùa vịt lên bờ",
    example: "lùa đàn trâu ra đồng * lùa vịt lên bờ",
  },
  {
    word: "lùa",
    part_of_speech: "động từ",
    meaning:
      "luồn vào hay luồn qua nơi có chỗ trống hẹp: gió lùa qua khe cửa * lùa bàn tay vào mái tóc * lùa chổi vào gầm giường",
    example:
      "gió lùa qua khe cửa * lùa bàn tay vào mái tóc * lùa chổi vào gầm giường",
  },
  {
    word: "lùa",
    part_of_speech: "động từ",
    meaning:
      "và nhanh vào miệng (thường là món ăn có nước) và nuốt vội, cốt ăn cho xong bữa: lùa vội mấy miếng cơm rồi đi",
    example: "lùa vội mấy miếng cơm rồi đi",
  },
  {
    word: "lùa",
    part_of_speech: "động từ",
    meaning: "dùng cào cỏ sục bùn ở ruộng lúa nước: chiêm lùa mùa cuốc (tng)",
    example: "chiêm lùa mùa cuốc (tng)",
  },
  {
    word: "lú nhú",
    part_of_speech: "động từ",
    meaning:
      "mới nhú ra hàng loạt với độ dài ngắn, cao thấp không đều nhau: ngô đã mọc lú nhú * mặt lú nhú những sợi lông tơ",
    example: "ngô đã mọc lú nhú * mặt lú nhú những sợi lông tơ",
  },
  {
    word: "lù xù",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có nhiều sợi lông, tóc dựng lên và rối vào nhau: tóc tai lù xù * lông lá lù xù",
    example: "tóc tai lù xù * lông lá lù xù",
  },
  {
    word: "lù xù",
    part_of_speech: "tính từ",
    meaning: "to quá, trông không gọn: khăn len lù xù quấn quanh cổ",
    example: "khăn len lù xù quấn quanh cổ",
  },
  {
    word: "lù xù",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ, khẩu ngữ) sành sỏi, lõi đời: tay bịp lũa",
    example: "tay bịp lũa",
  },
  {
    word: "lua",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) như lùa: lua vội lưng cơm",
    example: "lua vội lưng cơm",
  },
  {
    word: "lụa",
    part_of_speech: "danh từ",
    meaning:
      "hàng dệt bằng tơ, mỏng, mềm và mịn: vải lụa * dệt lụa * tranh lụa * người đẹp vì lụa, lúa tốt vì phân (tng)",
    example:
      "vải lụa * dệt lụa * tranh lụa * người đẹp vì lụa, lúa tốt vì phân (tng)",
  },
  {
    word: "lụa",
    part_of_speech: "tính từ",
    meaning:
      "(lớp, bề mặt) mềm, mỏng và mịn như lụa: bóc lớp vỏ lụa ở hạt lạc * giò lụa",
    example: "bóc lớp vỏ lụa ở hạt lạc * giò lụa",
  },
  {
    word: "lũa",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) rữa nát: chuối chín lũa * gỗ lũa (chỉ còn trơ lại phần lõi cứng)",
    example: "chuối chín lũa * gỗ lũa (chỉ còn trơ lại phần lõi cứng)",
  },
  {
    word: "lúa",
    part_of_speech: "danh từ",
    meaning:
      "cây lương thực, thân cỏ rỗng, hoa lưỡng tính, không có bao hoa, quả có vỏ trấu bao ngoài (gọi là hạt thóc): cấy lúa * gặt lúa * lúa mùa",
    example: "cấy lúa * gặt lúa * lúa mùa",
  },
  {
    word: "lúa",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) thóc: lúa đầy bồ * cối xay lúa * một giạ lúa",
    example: "lúa đầy bồ * cối xay lúa * một giạ lúa",
  },
  {
    word: "lụa là",
    part_of_speech: "danh từ",
    meaning: "hàng dệt bằng tơ (nói khái quát): lụa là, gấm vóc",
    example: "lụa là, gấm vóc",
  },
  {
    word: "lúa má",
    part_of_speech: "danh từ",
    meaning:
      "lúa, về mặt đang được gieo trồng, chăm sóc (nói khái quát): lúa má xanh tốt ~hạn hán, lúa má chết khô",
    example: "lúa má xanh tốt ~hạn hán, lúa má chết khô",
  },
  {
    word: "lúa nước",
    part_of_speech: "danh từ",
    meaning:
      "lúa trồng ở ruộng nước nói chung, được coi là một phương thức canh tác đặc trưng: trồng lúa nước * nền văn minh lúa nước",
    example: "trồng lúa nước * nền văn minh lúa nước",
  },
  {
    word: "luận",
    part_of_speech: "danh từ",
    meaning: "(cũ) bài tập làm văn: viết bài luận",
    example: "viết bài luận",
  },
  {
    word: "luận",
    part_of_speech: "động từ",
    meaning:
      "(cũ) bàn về vấn đề gì, có phân tích lí lẽ: luận việc thời sự * luận văn chương",
    example: "luận việc thời sự * luận văn chương",
  },
  {
    word: "luận",
    part_of_speech: "động từ",
    meaning: "dựa vào lí lẽ, ý nghĩa mà suy ra: chữ viết quá mờ, rất khó luận",
    example: "chữ viết quá mờ, rất khó luận",
  },
  {
    word: "lủa tủa",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như tua tủa: râu mọc lủa tủa",
    example: "râu mọc lủa tủa",
  },
  {
    word: "lua tua",
    part_of_speech: "tính từ",
    meaning:
      "(vật hình sợi) rủ xuống và xoè ra lung tung với độ dài ngắn không đều: đốc kiếm lua tua mấy sợi tơ đỏ",
    example: "đốc kiếm lua tua mấy sợi tơ đỏ",
  },
  {
    word: "luận án",
    part_of_speech: "danh từ",
    meaning:
      "công trình nghiên cứu của nghiên cứu sinh trình bày trước hội đồng khoa học để được công nhận học vị trên đại học: bảo vệ luận án tiến sĩ",
    example: "bảo vệ luận án tiến sĩ",
  },
  {
    word: "luận chứng",
    part_of_speech: "danh từ",
    meaning:
      "chứng cớ thực tế dùng làm cơ sở cho lập luận: luận chứng kinh tế * trình bày những luận chứng của dự án",
    example: "luận chứng kinh tế * trình bày những luận chứng của dự án",
  },
  {
    word: "luận bàn",
    part_of_speech: "động từ",
    meaning:
      "(cũ) như bàn luận (nhưng thường nói về việc quan trọng): luận bàn chuyện thời sự * luận bàn việc nước",
    example: "luận bàn chuyện thời sự * luận bàn việc nước",
  },
  {
    word: "luân canh",
    part_of_speech: "động từ",
    meaning:
      "trồng thay đổi nhiều loại cây khác nhau trên một diện tích đất vào mỗi năm, mỗi mùa (một phương pháp canh tác): luân canh giữa lúa và màu * trồng luân canh",
    example: "luân canh giữa lúa và màu * trồng luân canh",
  },
  {
    word: "luận cương",
    part_of_speech: "danh từ",
    meaning:
      "đề cương về những vấn đề đường lối và nhiệm vụ chính trị cơ bản: luận cương chính trị",
    example: "luận cương chính trị",
  },
  {
    word: "luận cứ",
    part_of_speech: "danh từ",
    meaning: "phán đoán dùng để chứng minh cho luận đề: luận cứ khoa học",
    example: "luận cứ khoa học",
  },
  {
    word: "luận cứ",
    part_of_speech: "danh từ",
    meaning: "căn cứ (thường bằng sự thật) của lập luận: có luận cứ đầy đủ",
    example: "có luận cứ đầy đủ",
  },
  {
    word: "luân chuyển",
    part_of_speech: "động từ",
    meaning:
      "lần lượt tiếp nối hay chuyển đổi cho nhau thành một hay nhiều vòng: bốn mùa luân chuyển * luân chuyển hàng hoá * luân chuyển vốn",
    example: "bốn mùa luân chuyển * luân chuyển hàng hoá * luân chuyển vốn",
  },
  {
    word: "luận điểm",
    part_of_speech: "danh từ",
    meaning:
      "ý kiến, quan điểm có tính chất lí luận: khủng hoảng tài chính được lí giải với nhiều luận điểm khác nhau",
    example: "khủng hoảng tài chính được lí giải với nhiều luận điểm khác nhau",
  },
  {
    word: "luận đề",
    part_of_speech: "danh từ",
    meaning:
      "mệnh đề hay thuyết coi là đúng và đưa ra để bảo vệ bằng luận cứ: luận đề về sự hình thành vũ trụ",
    example: "luận đề về sự hình thành vũ trụ",
  },
  {
    word: "luận điệu",
    part_of_speech: "danh từ",
    meaning:
      "ý kiến, lí lẽ đưa ra để đánh lừa: luận điệu vu khống * đưa ra những luận điệu giả dối",
    example: "luận điệu vu khống * đưa ra những luận điệu giả dối",
  },
  {
    word: "luận đoán",
    part_of_speech: "danh từ",
    meaning:
      "điều đoán trước dựa vào suy luận: những luận đoán có tính khoa học",
    example: "những luận đoán có tính khoa học",
  },
  {
    word: "luân hồi",
    part_of_speech: "động từ",
    meaning:
      "(Phật) chết ở kiếp này rồi lại sinh ra ở kiếp khác, cứ quay vòng mãi mãi như vậy: kiếp luân hồi * vòng luân hồi",
    example: "kiếp luân hồi * vòng luân hồi",
  },
  {
    word: "luân lưu",
    part_of_speech: "động từ",
    meaning: "chuyển lần lượt: tặng cờ luân lưu * đá luân lưu 11 mét",
    example: "tặng cờ luân lưu * đá luân lưu 11 mét",
  },
  {
    word: "luân lí",
    part_of_speech: "danh từ",
    meaning:
      "những quy tắc về quan hệ đạo đức giữa người với người trong xã hội (nói tổng quát): luân lí gia đình",
    example: "luân lí gia đình",
  },
  {
    word: "luân lí",
    part_of_speech: "danh từ",
    meaning: "(cũ) đạo đức: môn học luân lí",
    example: "môn học luân lí",
  },
  {
    word: "luân lý",
    part_of_speech: "danh từ",
    meaning:
      "những quy tắc về quan hệ đạo đức giữa người với người trong xã hội (nói tổng quát): luân lí gia đình",
    example: "luân lí gia đình",
  },
  {
    word: "luân lý",
    part_of_speech: "danh từ",
    meaning: "(cũ) đạo đức: môn học luân lí",
    example: "môn học luân lí",
  },
  {
    word: "luấn quấn",
    part_of_speech: "động từ",
    meaning: "(hiếm) quấn lấy không muốn rời: suốt ngày luấn quấn với con cái",
    example: "suốt ngày luấn quấn với con cái",
  },
  {
    word: "luẩn quẩn",
    part_of_speech: "động từ",
    meaning:
      "loanh quanh mãi không thoát ra khỏi một vị trí hoặc tình trạng nào đó: chơi luẩn quẩn ở gần nhà",
    example: "chơi luẩn quẩn ở gần nhà",
  },
  {
    word: "luẩn quẩn",
    part_of_speech: "động từ",
    meaning:
      "(suy nghĩ, tính toán) trở đi rồi trở lại, vẫn không sao tìm ra được lối thoát: suy nghĩ luẩn quẩn * thoát khỏi vòng luẩn quẩn",
    example: "suy nghĩ luẩn quẩn * thoát khỏi vòng luẩn quẩn",
  },
  {
    word: "luân phiên",
    part_of_speech: "động từ",
    meaning: "lần lượt thay phiên cho nhau: nghỉ luân phiên",
    example: "nghỉ luân phiên",
  },
  {
    word: "luận văn",
    part_of_speech: "danh từ",
    meaning:
      "công trình nghiên cứu của sinh viên, được trình bày trước hội đồng chấm thi để được công nhận tốt nghiệp đại học.",
    example: "làm bài luận văn",
  },
  {
    word: "luân thường",
    part_of_speech: "danh từ",
    meaning:
      "những phép tắc đối xử hợp đạo đức trong gia đình, ngoài xã hội, theo tư tưởng của nho giáo (nói tổng quát): giữ đạo luân thường * hành vi trái với luân thường đạo lí",
    example: "giữ đạo luân thường * hành vi trái với luân thường đạo lí",
  },
  {
    word: "luận tội",
    part_of_speech: "động từ",
    meaning: "xem xét, cân nhắc để xét tội: công tố viên luận tội",
    example: "công tố viên luận tội",
  },
  {
    word: "luật chơi",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) luật được quy định cụ thể hoặc được hiểu ngầm giữa đôi bên hoặc giữa những người trong cuộc: nắm vững luật chơi",
    example: "nắm vững luật chơi",
  },
  {
    word: "luật",
    part_of_speech: "danh từ",
    meaning: "quy luật (nói tắt): luật cung cầu * luật tiến hoá",
    example: "luật cung cầu * luật tiến hoá",
  },
  {
    word: "luật",
    part_of_speech: "danh từ",
    meaning:
      "những điều quy định riêng buộc mọi người phải tuân theo trong một loạt hoạt động nào đó (nói tổng quát): cầu thủ phạm luật * luật chơi * luật thơ Đường",
    example: "cầu thủ phạm luật * luật chơi * luật thơ Đường",
  },
  {
    word: "luật",
    part_of_speech: "danh từ",
    meaning: "pháp luật (nói tắt): tuân thủ luật của nhà nước",
    example: "tuân thủ luật của nhà nước",
  },
  {
    word: "luật",
    part_of_speech: "danh từ",
    meaning:
      "văn bản do cơ quan quyền lực nhà nước tối cao ban hành, quy định những phép tắc trong quan hệ xã hội, buộc mọi người phải tuân theo: ban hành luật đất đai * luật hôn nhân gia đình",
    example: "ban hành luật đất đai * luật hôn nhân gia đình",
  },
  {
    word: "luật định",
    part_of_speech: "động từ",
    meaning:
      "điều được quy định cụ thể trong một văn bản pháp luật: xét xử theo đúng luật định",
    example: "xét xử theo đúng luật định",
  },
  {
    word: "luật khoa",
    part_of_speech: "danh từ",
    meaning: "khoa luật học: sinh viên luật khoa",
    example: "sinh viên luật khoa",
  },
  {
    word: "luật lệ",
    part_of_speech: "danh từ",
    meaning:
      "pháp luật và những điều đã thành lệ mà mọi người trong xã hội phải tuân theo (nói khái quát): chấp hành luật lệ giao thông",
    example: "chấp hành luật lệ giao thông",
  },
  {
    word: "luật pháp",
    part_of_speech: "danh từ",
    meaning:
      "những quy phạm hành vi do nhà nước ban hành mà mọi người dân buộc phải tuân theo, nhằm điều chỉnh các quan hệ xã hội và bảo vệ trật tự xã hội (nói tổng quát): tuân thủ pháp luật * vi phạm pháp luật",
    example: "tuân thủ pháp luật * vi phạm pháp luật",
  },
  {
    word: "luật sư",
    part_of_speech: "danh từ",
    meaning:
      "người chuyên bào chữa cho đương sự trước toà án theo pháp luật hoặc làm cố vấn về pháp luật, nói chung: luật sư bào chữa * văn phòng luật sư",
    example: "luật sư bào chữa * văn phòng luật sư",
  },
  {
    word: "lục",
    part_of_speech: "động từ",
    meaning:
      "lật và đảo cả lên để tìm kiếm: lục túi * lục nồi tìm cái ăn * lục tìm trong trí nhớ",
    example: "lục túi * lục nồi tìm cái ăn * lục tìm trong trí nhớ",
  },
  {
    word: "lục",
    part_of_speech: "tính từ",
    meaning:
      "có màu xanh sẫm, giữa màu lam và màu vàng: màu lục * xanh lục * áo lục",
    example: "màu lục * xanh lục * áo lục",
  },
  {
    word: "luật rừng",
    part_of_speech: "danh từ",
    meaning:
      "luật mạnh được yếu thua, theo kiểu đấu tranh sinh tồn trong thế giới loài vật: xử theo luật rừng",
    example: "xử theo luật rừng",
  },
  {
    word: "luật tục",
    part_of_speech: "danh từ",
    meaning:
      "phong tục, tập quán chuyển hoá thành luật lệ, thành quy ước chung của một cộng đồng người nhất định: tôn trọng luật tục của các dân tộc ít người",
    example: "tôn trọng luật tục của các dân tộc ít người",
  },
  {
    word: "lục bát",
    part_of_speech: "danh từ",
    meaning:
      "thể văn vần mỗi cặp gồm một câu sáu tiếng và một câu tám tiếng, liên tiếp nhau: Truyện Kiều viết theo thể lục bát * ngâm mấy câu lục bát",
    example: "Truyện Kiều viết theo thể lục bát * ngâm mấy câu lục bát",
  },
  {
    word: "lúc",
    part_of_speech: "danh từ",
    meaning:
      "khoảng thời gian ngắn không xác định, thường có thể tính bằng phút: nghỉ một lúc rồi hẵng làm * lặng im một lúc lâu",
    example: "nghỉ một lúc rồi hẵng làm * lặng im một lúc lâu",
  },
  {
    word: "lúc",
    part_of_speech: "danh từ",
    meaning:
      "thời điểm không xác định, thường là trong phạm vi một ngày đêm: vừa đi lúc nãy * dậy từ lúc nửa đêm * về rất đúng lúc",
    example: "vừa đi lúc nãy * dậy từ lúc nửa đêm * về rất đúng lúc",
  },
  {
    word: "lúc",
    part_of_speech: "danh từ",
    meaning:
      "thời điểm gắn với một sự kiện, một hoạt động nhất định: lúc còn ấu thơ * đang lúc khó khăn * lúc chia tay * sông có khúc, người có lúc (tng)",
    example:
      "lúc còn ấu thơ * đang lúc khó khăn * lúc chia tay * sông có khúc, người có lúc (tng)",
  },
  {
    word: "lục bình",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) bèo lục bình: đám lục bình",
    example: "đám lục bình",
  },
  {
    word: "lục bình",
    part_of_speech: "danh từ",
    meaning: "(cũ, hiếm) độc bình: lọ lục bình * chiếc lục bình cổ",
    example: "lọ lục bình * chiếc lục bình cổ",
  },
  {
    word: "lục bục",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng những tiếng như tiếng nổ nhỏ, âm và gọn kế tiếp nhau: cháo sôi lục bục * tiếng máy nổ lục bục",
    example: "cháo sôi lục bục * tiếng máy nổ lục bục",
  },
  {
    word: "lục đục",
    part_of_speech: "động từ",
    meaning:
      "cặm cụi làm những công việc như thu dọn, sắp xếp, v.v., có thể gây ra những tiếng động trầm, đục của các đồ vật va chạm vào nhau: lục đục chuẩn bị cơm nước * mọi người đã lục đục thức dậy",
    example: "lục đục chuẩn bị cơm nước * mọi người đã lục đục thức dậy",
  },
  {
    word: "lục đục",
    part_of_speech: "động từ",
    meaning:
      "có sự va chạm, sinh ra bất hoà, xung đột trong nội bộ: nội bộ lục đục * vợ chồng lục đục với nhau",
    example: "nội bộ lục đục * vợ chồng lục đục với nhau",
  },
  {
    word: "lúc cúc",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ, hoặc kng) từ gợi tả dáng đi, chạy (thường của trẻ con) với những bước ngắn và nhanh: em bé lúc cúc chạy",
    example: "em bé lúc cúc chạy",
  },
  {
    word: "lục cục",
    part_of_speech: "",
    meaning:
      "từ mô phỏng những tiếng như tiếng của nhiều vật cứng đập vào nhau không đều: có tiếng lục cục trong buồng",
    example: "có tiếng lục cục trong buồng",
  },
  {
    word: "lục lạc",
    part_of_speech: "danh từ",
    meaning:
      "chuông con đeo thành chuỗi, khi rung phát ra tiếng nhạc: đứa bé đeo lục lạc ở chân * lục lạc ngựa",
    example: "đứa bé đeo lục lạc ở chân * lục lạc ngựa",
  },
  {
    word: "lục giác",
    part_of_speech: "danh từ",
    meaning: "đa giác có sáu cạnh: hình lục giác",
    example: "hình lục giác",
  },
  {
    word: "lục lạo",
    part_of_speech: "động từ",
    meaning:
      "lục tìm kĩ lưỡng mọi chỗ, mọi nơi (nói khái quát): lục lạo tìm giấy tờ * bọn giặc đang lục lạo khắp nơi",
    example: "lục lạo tìm giấy tờ * bọn giặc đang lục lạo khắp nơi",
  },
  {
    word: "lục địa",
    part_of_speech: "danh từ",
    meaning:
      "phần đất liền rộng lớn xung quanh có biển bao bọc; phân biệt với biển: bão từ ngoài khơi đổ bộ vào lục địa",
    example: "bão từ ngoài khơi đổ bộ vào lục địa",
  },
  {
    word: "lúc lắc",
    part_of_speech: "động từ",
    meaning:
      "lắc qua lắc lại: lúc lắc quả chuông * chiếc xe lúc lắc trên đường",
    example: "lúc lắc quả chuông * chiếc xe lúc lắc trên đường",
  },
  {
    word: "lục lăng",
    part_of_speech: "danh từ",
    meaning: "(cũ) lục giác: hình lục lăng",
    example: "hình lục lăng",
  },
  {
    word: "lúc lỉu",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) sai trĩu xuống: cây lúc lỉu những quả là quả",
    example: "cây lúc lỉu những quả là quả",
  },
  {
    word: "lục lâm",
    part_of_speech: "danh từ",
    meaning: "(cũ) kẻ cướp sống trong rừng: bọn lục lâm",
    example: "bọn lục lâm",
  },
  {
    word: "lục lọi",
    part_of_speech: "động từ",
    meaning:
      "lục tìm kĩ lưỡng, tỉ mỉ (nói khái quát): lục lọi các ngăn kéo * cố lục lọi trong trí nhớ",
    example: "lục lọi các ngăn kéo * cố lục lọi trong trí nhớ",
  },
  {
    word: "lúc nào",
    part_of_speech: "đại từ",
    meaning:
      "thời điểm nào đó không rõ, thường dùng để hỏi: đi từ lúc nào? * lúc nào thì xong?",
    example: "đi từ lúc nào? * lúc nào thì xong?",
  },
  {
    word: "lúc nào",
    part_of_speech: "đại từ",
    meaning:
      "thời điểm nào đó không muốn nói rõ ra, hoặc là bất kì thời điểm nào: lúc nào cũng được * quần áo lúc nào cũng sạch sẽ",
    example: "lúc nào cũng được * quần áo lúc nào cũng sạch sẽ",
  },
  {
    word: "lúc nhúc",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả cảnh đông và lộn xộn, tập trung vào một chỗ, chen chúc nhau mà di động không ngừng: tằm lúc nhúc trên nong",
    example: "tằm lúc nhúc trên nong",
  },
  {
    word: "lục quân",
    part_of_speech: "danh từ",
    meaning: "quân chủng hoạt động trên bộ: trường lục quân",
    example: "trường lục quân",
  },
  {
    word: "lục soạn",
    part_of_speech: "danh từ",
    meaning:
      'lụa trơn, mỏng, thời trước thường dùng: "Cái ô lục soạn cầm tay, Cái khăn xếp nếp, cái dây lưng điều." (ca dao)',
    example:
      'Cái ô lục soạn cầm tay, Cái khăn xếp nếp, cái dây lưng điều." (ca dao)',
  },
  {
    word: "lục sục",
    part_of_speech: "động từ",
    meaning: "như lục đục (ngI): lũ chuột lục sục trong thùng gạo",
    example: "lũ chuột lục sục trong thùng gạo",
  },
  {
    word: "lục tục",
    part_of_speech: "phụ từ",
    meaning:
      "(làm việc gì) tiếp theo nhau một cách tự nhiên, hết người này đến người khác, không phải theo trật tự sắp xếp trước: bốn giờ sáng đã lục tục dậy * mọi người đã lục tục ra về",
    example: "bốn giờ sáng đã lục tục dậy * mọi người đã lục tục ra về",
  },
  {
    word: "lục soát",
    part_of_speech: "động từ",
    meaning:
      "lục tìm kĩ để khám xét, kiểm tra: bị lục soát khắp người * có lệnh lục soát nhà",
    example: "bị lục soát khắp người * có lệnh lục soát nhà",
  },
  {
    word: "lục vấn",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) hỏi vặn để truy cho ra lẽ: công tố viên lục vấn bị cáo * hỏi như lục vấn người ta",
    example: "công tố viên lục vấn bị cáo * hỏi như lục vấn người ta",
  },
  {
    word: "lủi",
    part_of_speech: "động từ",
    meaning:
      "(loài vật) chui luồn vào chỗ rậm, chỗ khuất để trốn: lủi như cuốc * con chó bị đánh, cúp đuôi lủi vào gầm giường",
    example: "lủi như cuốc * con chó bị đánh, cúp đuôi lủi vào gầm giường",
  },
  {
    word: "lủi",
    part_of_speech: "động từ",
    meaning:
      "(Thông tục) rời bỏ đi nơi khác một cách rất nhanh và lặng lẽ, kín đáo (thường là để trốn): lủi vào nhà trong * chỉ mắt trước mắt sau là lủi mất",
    example: "lủi vào nhà trong * chỉ mắt trước mắt sau là lủi mất",
  },
  {
    word: "lục súc",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, hiếm) tên gọi chung sáu loài vật nuôi ở nhà: ngựa, bò, dê, gà, chó, lợn; cũng dùng để chỉ loài thú vật nói chung: đồ lục súc!",
    example: "đồ lục súc!",
  },
  {
    word: "lụi",
    part_of_speech: "động từ",
    meaning:
      "(cây, cỏ) ngừng sinh trưởng, héo úa dần rồi chết: giàn trầu bị lụi * rét quá, cây lụi dần",
    example: "giàn trầu bị lụi * rét quá, cây lụi dần",
  },
  {
    word: "lụi",
    part_of_speech: "động từ",
    meaning:
      "(lửa cháy) yếu dần, tàn dần: than đã lụi * đống lửa đương lụi dần",
    example: "than đã lụi * đống lửa đương lụi dần",
  },
  {
    word: "lụi",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) xiên: lụi thịt để nướng * tôm lụi",
    example: "lụi thịt để nướng * tôm lụi",
  },
  {
    word: "lui cui",
    part_of_speech: "",
    meaning: "(phương ngữ) lúi húi: lui cui dưới bếp",
    example: "lui cui dưới bếp",
  },
  {
    word: "lùi",
    part_of_speech: "động từ",
    meaning:
      "di chuyển ngược lại về phía sau trong khi vẫn giữ nguyên tư thế như đang tiến về phía trước: cho xe lùi lại * khó khăn cũng không lùi * chuyện đó đã lùi dần vào dĩ vãng",
    example:
      "cho xe lùi lại * khó khăn cũng không lùi * chuyện đó đã lùi dần vào dĩ vãng",
  },
  {
    word: "lùi",
    part_of_speech: "động từ",
    meaning:
      "để cho xảy ra chậm hơn so với thời điểm đã định: để lùi lại mấy ngày * lùi cuộc họp lại đến cuối tuần",
    example: "để lùi lại mấy ngày * lùi cuộc họp lại đến cuối tuần",
  },
  {
    word: "lùi",
    part_of_speech: "động từ",
    meaning:
      'nướng bằng cách vùi vào tro nóng: ngọt như mía lùi * "Thương nhau, chia củ sắn lùi, Bát cơm sẻ nửa, chăn sui đắp cùng." (THữu; 39)',
    example:
      'ngọt như mía lùi * "Thương nhau, chia củ sắn lùi, Bát cơm sẻ nửa, chăn sui đắp cùng." (THữu; 39)',
  },
  {
    word: "lui",
    part_of_speech: "động từ",
    meaning:
      "không tiến tới nữa mà di chuyển ngược trở lại phía sau, hướng trở về nơi xuất phát: bị thua nên phải lui quân * lui về quê ở ẩn",
    example: "bị thua nên phải lui quân * lui về quê ở ẩn",
  },
  {
    word: "lui",
    part_of_speech: "động từ",
    meaning:
      "từ biểu thị hướng của hoạt động ngược trở lại phía sau, phía xuất phát hoặc về một thời điểm đã qua: bị té lui * ngó lui lại đằng sau * nghĩ lui về dĩ vãng",
    example: "bị té lui * ngó lui lại đằng sau * nghĩ lui về dĩ vãng",
  },
  {
    word: "lui",
    part_of_speech: "động từ",
    meaning:
      "(cơn bệnh, cơn giận) giảm đi, hướng trở lại trạng thái bình thường: lui cơn sốt",
    example: "lui cơn sốt",
  },
  {
    word: "lui",
    part_of_speech: "động từ",
    meaning: "(hiếm) như lùi: để lui lại vài hôm",
    example: "để lui lại vài hôm",
  },
  {
    word: "lúi húi",
    part_of_speech: "",
    meaning:
      "chăm chú, luôn tay làm một việc nào đó, không để ý gì đến xung quanh: suốt ngày lúi húi trong bếp * lúi húi tìm tòi vật gì đó trong tủ",
    example: "suốt ngày lúi húi trong bếp * lúi húi tìm tòi vật gì đó trong tủ",
  },
  {
    word: "lui lủi",
    part_of_speech: "phụ từ",
    meaning:
      "(bước đi) một cách âm thầm lặng lẽ như muốn lẩn tránh: lui lủi đi ra",
    example: "lui lủi đi ra",
  },
  {
    word: "lùi bước",
    part_of_speech: "động từ",
    meaning:
      "không tiếp tục tiến lên mà lùi lại, chịu thua, chịu khuất phục: không lùi bước trước khó khăn",
    example: "không lùi bước trước khó khăn",
  },
  {
    word: "lui tới",
    part_of_speech: "động từ",
    meaning:
      "đến thăm, đến ở chơi (nói khái quát): chẳng ai lui tới chốn này * năng lui tới thăm hỏi nhau",
    example: "chẳng ai lui tới chốn này * năng lui tới thăm hỏi nhau",
  },
  {
    word: "lụi hụi",
    part_of_speech: "động từ",
    meaning: "như lúi húi: lụi hụi nấu nướng * lụi hụi ghi chép cả buổi",
    example: "lụi hụi nấu nướng * lụi hụi ghi chép cả buổi",
  },
  {
    word: "lụi cụi",
    part_of_speech: "động từ",
    meaning:
      "cặm cụi làm việc gì một cách kiên trì, chịu khó: lụi cụi dưới bếp * cả buổi ngồi lụi cụi hết cắt lại dán",
    example: "lụi cụi dưới bếp * cả buổi ngồi lụi cụi hết cắt lại dán",
  },
  {
    word: "lủi thủi",
    part_of_speech: "",
    meaning:
      "một cách âm thầm, lặng lẽ, với vẻ cô đơn, đáng thương: em bé lủi thủi chơi một mình * lủi thủi ra về",
    example: "em bé lủi thủi chơi một mình * lủi thủi ra về",
  },
  {
    word: "lùi lũi",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) lầm lì, cắm cúi, mải miết, không chú ý gì đến xung quanh: bước lùi lũi theo sau",
    example: "bước lùi lũi theo sau",
  },
  {
    word: "lùi lụi",
    part_of_speech: "phụ từ",
    meaning: "(khẩu ngữ, hiếm) như lùi lũi: lùi lụi bước đi",
    example: "lùi lụi bước đi",
  },
  {
    word: "lùi xùi",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ, hiếm) như lúi xùi: ăn ở lùi xùi",
    example: "ăn ở lùi xùi",
  },
  {
    word: "lúi xùi",
    part_of_speech: "tính từ",
    meaning:
      "luộm thuộm, không được đàng hoàng, có vẻ xuề xoà, chỉ cốt cho xong, cho qua: nhà cửa lúi xùi * quần áo lúi xùi",
    example: "nhà cửa lúi xùi * quần áo lúi xùi",
  },
  {
    word: "lúm",
    part_of_speech: "tính từ",
    meaning: "hơi lõm vào: má lúm xuống đồng tiền xinh xắn",
    example: "má lúm xuống đồng tiền xinh xắn",
  },
  {
    word: "lùm",
    part_of_speech: "danh từ",
    meaning:
      "đám cành lá rậm rạp của nhiều cây kết vào nhau thành vòm rộng: ngồi nghỉ dưới lùm cây * lùm dứa dại",
    example: "ngồi nghỉ dưới lùm cây * lùm dứa dại",
  },
  {
    word: "lùm",
    part_of_speech: "danh từ",
    meaning: "đống lớn có hình giống như lùm cây: rơm đánh thành lùm",
    example: "rơm đánh thành lùm",
  },
  {
    word: "lùm",
    part_of_speech: "tính từ",
    meaning:
      "vồng lên thành một khối vòng cung: đĩa xôi đơm đầy lùm * bụng đã to lùm lên",
    example: "đĩa xôi đơm đầy lùm * bụng đã to lùm lên",
  },
  {
    word: "lụm cụm",
    part_of_speech: "tính từ",
    meaning:
      "cặm cụi một cách vất vả (thường nói về người già yếu): lụm cụm quét tước, nấu nướng * cả ngày lụm cụm bên khung cửi",
    example: "lụm cụm quét tước, nấu nướng * cả ngày lụm cụm bên khung cửi",
  },
  {
    word: "lủm",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) ăn gọn cả miếng: lủm cả miếng bánh",
    example: "lủm cả miếng bánh",
  },
  {
    word: "lũm",
    part_of_speech: "danh từ",
    meaning: "chỗ hơi lõm: nước đọng trên lũm đất",
    example: "nước đọng trên lũm đất",
  },
  {
    word: "lúm đồng tiền",
    part_of_speech: "",
    meaning:
      "chỗ hơi lõm hiện ra ở má, ở khoé môi, trông rất duyên: má lúm đồng tiền * khi cười, hai lúm đồng tiền in rõ trên đôi má",
    example: "má lúm đồng tiền * khi cười, hai lúm đồng tiền in rõ trên đôi má",
  },
  {
    word: "lùn",
    part_of_speech: "tính từ",
    meaning:
      "thấp hơn hẳn mức bình thường, không cân đối với bề ngang: dáng người hơi lùn * cao chê ngỏng, thấp chê lùn (tng)",
    example: "dáng người hơi lùn * cao chê ngỏng, thấp chê lùn (tng)",
  },
  {
    word: "lùn",
    part_of_speech: "tính từ",
    meaning:
      "(thực vật) thuộc giống có chiều cao của thân dưới hẳn mức bình thường trong loại: chuối lùn * cau lùn * dừa lùn",
    example: "chuối lùn * cau lùn * dừa lùn",
  },
  {
    word: "lũn",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) nhũn: chuối chín lũn",
    example: "chuối chín lũn",
  },
  {
    word: "lún",
    part_of_speech: "động từ",
    meaning:
      "sụt dần xuống do nền không chịu được sức đè nặng bên trên: đường bị lún",
    example: "đường bị lún",
  },
  {
    word: "lún",
    part_of_speech: "động từ",
    meaning: "(Phương ngữ, Khẩu ngữ) như nhún (ng2): yếu thế nên đành chịu lún",
    example: "yếu thế nên đành chịu lún",
  },
  {
    word: "lũn cũn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ngắn hoặc thấp đến mức khó coi: thấp lũn cũn * quần áo ngắn lũn cũn",
    example: "thấp lũn cũn * quần áo ngắn lũn cũn",
  },
  {
    word: "lũn cũn",
    part_of_speech: "tính từ",
    meaning:
      "(dáng đi) có những bước ngắn và nhanh như bước đi của trẻ con: đứa bé chạy lũn cũn theo sau",
    example: "đứa bé chạy lũn cũn theo sau",
  },
  {
    word: "lụn",
    part_of_speech: "động từ",
    meaning: "như lụi (ng2): ngọn nến lụn dần",
    example: "ngọn nến lụn dần",
  },
  {
    word: "lụn bại",
    part_of_speech: "động từ",
    meaning:
      "lâm vào tình trạng kiệt quệ và suy sụp không thể cứu vãn được: cơ nghiệp bị lụn bại",
    example: "cơ nghiệp bị lụn bại",
  },
  {
    word: "lủn củn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ, hiếm) như lũn cũn (ng1): người thấp lủn củn * nếp nhà tranh lủn củn",
    example: "người thấp lủn củn * nếp nhà tranh lủn củn",
  },
  {
    word: "lùn tè",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) lùn đến mức khó coi: người lùn tè như cây nấm",
    example: "người lùn tè như cây nấm",
  },
  {
    word: "lùn tịt",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) lùn đến mức như gần sát đất: người lùn tịt",
    example: "người lùn tịt",
  },
  {
    word: "lủn mủn",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như tủn mủn: tính toán lủn mủn",
    example: "tính toán lủn mủn",
  },
  {
    word: "lủng",
    part_of_speech: "tính từ",
    meaning: "(Nam) thủng: đâm cho lủng",
    example: "đâm cho lủng",
  },
  {
    word: "lún phún",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả trạng thái râu, cỏ mọc thưa, ngắn và không đều: cằm lún phún râu",
    example: "cằm lún phún râu",
  },
  {
    word: "lún phún",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả trạng thái mưa rơi từng hạt nhỏ, nhẹ, thưa thớt và không đều: trời lún phún mưa xuân",
    example: "trời lún phún mưa xuân",
  },
  {
    word: "lụn vụn",
    part_of_speech: "tính từ",
    meaning: "nhỏ vụn không đáng kể: đống gạch ngói lụn vụn",
    example: "đống gạch ngói lụn vụn",
  },
  {
    word: "lung",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ) đầm, bàu: lung sen",
    example: "lung sen",
  },
  {
    word: "lung bung",
    part_of_speech: "tính từ",
    meaning: "lung tung, không rõ ràng, không ổn định: công việc còn lung bung",
    example: "công việc còn lung bung",
  },
  {
    word: "lúng búng",
    part_of_speech: "động từ",
    meaning:
      "ngậm vật gì trong miệng, làm cho vướng không há ra được: miệng lúng búng đầy cơm",
    example: "miệng lúng búng đầy cơm",
  },
  {
    word: "lúng búng",
    part_of_speech: "động từ",
    meaning:
      "nói không rõ tiếng như đang ngậm cái gì trong miệng: lúng búng như ngậm hột thị * miệng lúng búng câu gì không rõ",
    example: "lúng búng như ngậm hột thị * miệng lúng búng câu gì không rõ",
  },
  {
    word: "lũng",
    part_of_speech: "danh từ",
    meaning:
      "dạng địa hình lõm tương đối rộng, xung quanh có sườn dốc bao bọc, thường gặp ở miền núi đá vôi: lũng núi",
    example: "lũng núi",
  },
  {
    word: "lùng",
    part_of_speech: "động từ",
    meaning:
      "tìm kiếm cho kì được bằng mọi cách, ở khắp mọi nơi: lùng khắp các hiệu sách mới mua được * có ý lùng chiếc ấm quý",
    example: "lùng khắp các hiệu sách mới mua được * có ý lùng chiếc ấm quý",
  },
  {
    word: "lùng",
    part_of_speech: "động từ",
    meaning:
      "tìm tòi, sục sạo để bắt cho kì được: dẫn chó săn đi lùng * bị địch lùng ráo riết",
    example: "dẫn chó săn đi lùng * bị địch lùng ráo riết",
  },
  {
    word: "lùng bùng",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như lùng nhùng: đống chăn màn lùng bùng",
    example: "đống chăn màn lùng bùng",
  },
  {
    word: "lùng bùng",
    part_of_speech: "tính từ",
    meaning:
      "có cảm giác như có những tiếng ù ù trong tai, tựa như trong tai đầy nước: tai lùng bùng * một mớ âm thanh lùng bùng",
    example: "tai lùng bùng * một mớ âm thanh lùng bùng",
  },
  {
    word: "lũng đoạn",
    part_of_speech: "động từ",
    meaning:
      "tập trung vào trong tay mình mọi đặc quyền để từ đó khống chế và kiểm soát hoạt động sản xuất hoặc kinh doanh: độc quyền lũng đoạn",
    example: "độc quyền lũng đoạn",
  },
  {
    word: "lũng đoạn",
    part_of_speech: "động từ",
    meaning:
      "chi phối, thao túng nhằm gây rối loạn để giành lợi riêng: đầu cơ để lũng đoạn thị trường * tư thương lũng đoạn",
    example: "đầu cơ để lũng đoạn thị trường * tư thương lũng đoạn",
  },
  {
    word: "lung lay",
    part_of_speech: "động từ",
    meaning:
      "nghiêng hoặc làm cho nghiêng bên này ngả bên kia, không còn giữ nguyên được thế đứng: gió lung lay cành lá * lung lay cái cọc * răng bị lung lay",
    example: "gió lung lay cành lá * lung lay cái cọc * răng bị lung lay",
  },
  {
    word: "lủng củng",
    part_of_speech: "tính từ",
    meaning:
      "(đồ đạc) lộn xộn, không có trật tự, ngăn nắp, dễ đụng chạm vào nhau: hành lí lủng củng * trong bếp treo lủng củng soong nồi",
    example: "hành lí lủng củng * trong bếp treo lủng củng soong nồi",
  },
  {
    word: "lủng củng",
    part_of_speech: "tính từ",
    meaning:
      "(câu văn) trúc trắc, không mạch lạc, các ý không ăn nhập với nhau làm cho khó hiểu: văn viết lủng củng * câu cú lủng củng",
    example: "văn viết lủng củng * câu cú lủng củng",
  },
  {
    word: "lủng củng",
    part_of_speech: "tính từ",
    meaning:
      "ở tình trạng có nhiều sự va chạm với nhau, sinh ra không đoàn kết: nội bộ lủng củng * anh chị em trong nhà lủng củng",
    example: "nội bộ lủng củng * anh chị em trong nhà lủng củng",
  },
  {
    word: "lung lạc",
    part_of_speech: "động từ",
    meaning:
      "tác động đến tinh thần làm cho nao núng mà phải chịu khuất phục: bị lung lạc tinh thần",
    example: "bị lung lạc tinh thần",
  },
  {
    word: "lúng liếng",
    part_of_speech: "động từ",
    meaning:
      "nghiêng qua nghiêng lại rất nhanh, đến mức chao đảo mạnh: con xuồng lúng liếng",
    example: "con xuồng lúng liếng",
  },
  {
    word: "lúng liếng",
    part_of_speech: "động từ",
    meaning:
      "(mắt) đưa qua đưa lại, liếc qua liếc lại, vẻ sinh động và sắc sảo: cười lúng liếng đôi mắt",
    example: "cười lúng liếng đôi mắt",
  },
  {
    word: "lung liêng",
    part_of_speech: "động từ",
    meaning:
      "lay động, chao qua đảo lại: chiếc cầu treo lung liêng theo chiều gió",
    example: "chiếc cầu treo lung liêng theo chiều gió",
  },
  {
    word: "lủng lẳng",
    part_of_speech: "tính từ",
    meaning:
      "chỉ được giữ dính vào vật khác ở một điểm, còn toàn khối được buông xuống và có thể đung đưa dễ dàng trong khoảng không: chiếc túi treo lủng lẳng ở ghi đông xe đạp",
    example: "chiếc túi treo lủng lẳng ở ghi đông xe đạp",
  },
  {
    word: "lùng nhùng",
    part_of_speech: "tính từ",
    meaning:
      "có bề mặt mềm nhũn, dễ lún xuống hoặc phồng lên, nhưng lại khó nén chặt: đất lùng nhùng * nhọt bọc lùng nhùng",
    example: "đất lùng nhùng * nhọt bọc lùng nhùng",
  },
  {
    word: "lùng nhùng",
    part_of_speech: "tính từ",
    meaning:
      "rối và vướng vào với nhau, khó dồn nén, khó tháo gỡ: bộ quần áo dài lùng nhùng",
    example: "bộ quần áo dài lùng nhùng",
  },
  {
    word: "lúng ta lúng túng",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra rất lúng túng, không biết nên xử trí, hành động ra sao: chân tay lúng ta lúng túng",
    example: "chân tay lúng ta lúng túng",
  },
  {
    word: "lụng thà lụng thụng",
    part_of_speech: "tính từ",
    meaning: "rất lụng thụng, trông không gọn: váy áo lụng thà lụng thụng",
    example: "váy áo lụng thà lụng thụng",
  },
  {
    word: "lủng liểng",
    part_of_speech: "tính từ",
    meaning:
      "lủng lẳng và đung đưa như muốn rơi: chùm quả chín lủng liểng trên cành",
    example: "chùm quả chín lủng liểng trên cành",
  },
  {
    word: "lung ta lung tung",
    part_of_speech: "tính từ",
    meaning:
      "rất lung tung, hoàn toàn không có chút trận tự, ngăn nắp nào cả: sách vở vứt lung ta lung tung",
    example: "sách vở vứt lung ta lung tung",
  },
  {
    word: "lung linh",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả vẻ lay động, rung rinh của cái có thể phản chiếu ánh sáng: sao sáng lung linh * ánh nến lung linh",
    example: "sao sáng lung linh * ánh nến lung linh",
  },
  {
    word: "lùng sục",
    part_of_speech: "động từ",
    meaning:
      "sục tìm khắp cả để lùng cho kì được: con chó lùng sục kiếm ăn * bọn địch lùng sục khắp các ngóc ngách",
    example: "con chó lùng sục kiếm ăn * bọn địch lùng sục khắp các ngóc ngách",
  },
  {
    word: "lùng thùng",
    part_of_speech: "tính từ",
    meaning: "(quần áo) quá rộng, trông không gọn: áo rộng lùng thùng",
    example: "áo rộng lùng thùng",
  },
  {
    word: "lụng thụng",
    part_of_speech: "tính từ",
    meaning: "(quần áo) dài và rộng quá so với khổ người: áo dài lụng thụng",
    example: "áo dài lụng thụng",
  },
  {
    word: "lung tung",
    part_of_speech: "tính từ",
    meaning:
      "hoàn toàn không có một trật tự nào cả: giấy má bay lung tung trên sàn * quần áo để lung tung",
    example: "giấy má bay lung tung trên sàn * quần áo để lung tung",
  },
  {
    word: "lung tung",
    part_of_speech: "tính từ",
    meaning:
      "hoàn toàn không có một định hướng nào cả: chạy lung tung * vẽ lung tung * ăn nói lung tung",
    example: "chạy lung tung * vẽ lung tung * ăn nói lung tung",
  },
  {
    word: "lung tung beng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) lung tung đến mức đảo lộn và rối loạn hết cả lên: đồ đạc vứt lung tung beng * cãi nhau lung tung beng",
    example: "đồ đạc vứt lung tung beng * cãi nhau lung tung beng",
  },
  {
    word: "lúng túng",
    part_of_speech: "tính từ",
    meaning:
      "không làm chủ được tình hình nên không biết hành động, xử trí như thế nào: trả lời lúng túng * còn lúng túng trong khâu tổ chức",
    example: "trả lời lúng túng * còn lúng túng trong khâu tổ chức",
  },
  {
    word: "lùng tùng",
    part_of_speech: "tính từ",
    meaning:
      "từ mô phỏng tiếng trống đánh liên tục thành từng chặp từ xa vọng lại: đánh trống lùng tùng",
    example: "đánh trống lùng tùng",
  },
  {
    word: "luôn",
    part_of_speech: "phụ từ",
    meaning:
      "một cách liên tục do được lặp lại nhiều lần hoặc liên tiếp không bị ngắt quãng: đến thăm nhau luôn * làm luôn tay * đau ốm luôn",
    example: "đến thăm nhau luôn * làm luôn tay * đau ốm luôn",
  },
  {
    word: "luôn",
    part_of_speech: "phụ từ",
    meaning:
      "(làm việc gì) một mạch không ngừng, không có sự ngắt quãng giữ chừng: thắng luôn mấy trận * tiện tay làm luôn * ăn luôn một chặp bốn bát * trả luôn cả gốc lẫn lãi",
    example:
      "thắng luôn mấy trận * tiện tay làm luôn * ăn luôn một chặp bốn bát * trả luôn cả gốc lẫn lãi",
  },
  {
    word: "luôn",
    part_of_speech: "phụ từ",
    meaning:
      "ngay tức thời (sau sự việc có liên quan): không cần nghĩ, trả lời luôn * ăn luôn cho nóng * nhận được tin thì đi luôn",
    example:
      "không cần nghĩ, trả lời luôn * ăn luôn cho nóng * nhận được tin thì đi luôn",
  },
  {
    word: "luôn",
    part_of_speech: "phụ từ",
    meaning:
      "không phải chỉ có tính chất nhất thời, trong một thời gian, mà suốt từ đó về sau là như thế: mượn rồi lấy luôn * bỏ làng đi luôn không về * ở luôn đây cho tiện",
    example:
      "mượn rồi lấy luôn * bỏ làng đi luôn không về * ở luôn đây cho tiện",
  },
  {
    word: "luộc",
    part_of_speech: "động từ",
    meaning:
      "làm chín thực phẩm bằng cách đun trong nước: luộc thịt * luộc bánh chưng * rau muống luộc",
    example: "luộc thịt * luộc bánh chưng * rau muống luộc",
  },
  {
    word: "luộc",
    part_of_speech: "động từ",
    meaning:
      "cho vào trong nước rồi đun sôi nhằm một tác dụng nhất định nào đó: luộc kim tiêm * luộc bình trước khi pha sữa",
    example: "luộc kim tiêm * luộc bình trước khi pha sữa",
  },
  {
    word: "luộc",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) làm cho có vẻ ngoài đổi khác hoặc tăng giá lên để bán lại nhằm kiếm lời một cách bất chính: một đầu nậu chuyên luộc sách * luộc chiếc xe cũ",
    example: "một đầu nậu chuyên luộc sách * luộc chiếc xe cũ",
  },
  {
    word: "luộm thuộm",
    part_of_speech: "tính từ",
    meaning:
      "không gọn gàng, ngăn nắp, không theo đúng phép tắc: quần áo luộm thuộm * nhà cửa luộm thuộm",
    example: "quần áo luộm thuộm * nhà cửa luộm thuộm",
  },
  {
    word: "luồn",
    part_of_speech: "động từ",
    meaning:
      "đi hoặc làm cho đi qua những chỗ hở nhỏ, hẹp để từ bên này xuyên sang bên kia: xe chỉ luồn kim * trăng luồn đám mây",
    example: "xe chỉ luồn kim * trăng luồn đám mây",
  },
  {
    word: "luồn",
    part_of_speech: "động từ",
    meaning:
      "len lỏi để đi lọt qua nơi nguy hiểm: luồn vào trận địa của địch * luồn khỏi vòng vây",
    example: "luồn vào trận địa của địch * luồn khỏi vòng vây",
  },
  {
    word: "luồn",
    part_of_speech: "động từ",
    meaning:
      "lọt hoặc đưa lọt vào một cách khéo léo, bí mật: luồn người vào tổ chức địch",
    example: "luồn người vào tổ chức địch",
  },
  {
    word: "luồn",
    part_of_speech: "động từ",
    meaning:
      'hạ mình, nịnh nọt để cầu cạnh: luồn trên nạt dưới * "Tính bài lót đó luồn đây, Có ba trăm lạng, việc này mới xuôi." (TKiều)',
    example:
      'luồn trên nạt dưới * "Tính bài lót đó luồn đây, Có ba trăm lạng, việc này mới xuôi." (TKiều)',
  },
  {
    word: "luôm nhuôm",
    part_of_speech: "tính từ",
    meaning:
      "không cùng một thứ, không đều nhau, trông lộn xộn, không đẹp mắt: mảnh vườn trồng luôm nhuôm đủ thứ",
    example: "mảnh vườn trồng luôm nhuôm đủ thứ",
  },
  {
    word: "luồn cúi",
    part_of_speech: "động từ",
    meaning:
      'hạ mình cầu cạnh một cách đê hèn (nói khái quát): luồn cúi kẻ có quyền thế * "(...) Đem thân luồn cúi vào vòng lợi danh." (ca dao)',
    example:
      'luồn cúi kẻ có quyền thế * "(...) Đem thân luồn cúi vào vòng lợi danh." (ca dao)',
  },
  {
    word: "luôn luôn",
    part_of_speech: "phụ từ",
    meaning:
      "một cách thường xuyên, từ trước tới nay lúc nào cũng thế: cuộc sống luôn luôn thay đổi",
    example: "cuộc sống luôn luôn thay đổi",
  },
  {
    word: "luồn lót",
    part_of_speech: "động từ",
    meaning: "(hiếm) như lo lót: luồn lót, chạy chọt khắp nơi",
    example: "luồn lót, chạy chọt khắp nơi",
  },
  {
    word: "luồn lách",
    part_of_speech: "động từ",
    meaning:
      "len lỏi khôn khéo qua những chỗ chật hẹp, khó khăn: luồn lách qua những bụi cây * luồn lách những kẽ hở của pháp luật",
    example:
      "luồn lách qua những bụi cây * luồn lách những kẽ hở của pháp luật",
  },
  {
    word: "luồn luỵ",
    part_of_speech: "động từ",
    meaning:
      "(cũ) luồn cúi, quỵ luỵ để mong cầu xin được việc gì: không chịu luồn luỵ ai",
    example: "không chịu luồn luỵ ai",
  },
  {
    word: "luống",
    part_of_speech: "danh từ",
    meaning:
      "khoảng đất dài được vun cao lên để trồng trọt: đánh luống trồng hoa * luống rau * cày ốp luống",
    example: "đánh luống trồng hoa * luống rau * cày ốp luống",
  },
  {
    word: "luống",
    part_of_speech: "phụ từ",
    meaning:
      '(cũ, văn chương) từ biểu thị mức độ nhiều, không phải chỉ một lần, mà là nhiều lần, luôn luôn diễn ra không dứt (thường nói về trạng thái tâm lí, tình cảm): luống trông * "Tưởng người dưới nguyệt chén đồng, Tin sương luống những rày trông mai chờ." (TKiều)',
    example:
      'luống trông * "Tưởng người dưới nguyệt chén đồng, Tin sương luống những rày trông mai chờ." (TKiều)',
  },
  {
    word: "luôn thể",
    part_of_speech: "phụ từ",
    meaning:
      "luôn cùng một lúc cho tiện, khi đang có điều kiện: ngồi xuống ăn luôn thể cho vui",
    example: "ngồi xuống ăn luôn thể cho vui",
  },
  {
    word: "luồn lỏi",
    part_of_speech: "động từ",
    meaning:
      "luồn qua, luồn vào một cách vất vả, khôn khéo (nói khái quát): luồn lỏi qua những khe đá * phải luồn lỏi để cầu cạnh",
    example: "luồn lỏi qua những khe đá * phải luồn lỏi để cầu cạnh",
  },
  {
    word: "luồn lọt",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) luồn cúi, quỵ luỵ, chỉ cốt đạt mục đích danh lợi: tìm cách luồn lọt * luồn lọt mãi mới xin được chân phó phòng",
    example: "tìm cách luồn lọt * luồn lọt mãi mới xin được chân phó phòng",
  },
  {
    word: "luôn tiện",
    part_of_speech: "phụ từ",
    meaning: "như tiện thể: bà ra chợ luôn tiện mua hộ tôi bó rau muống",
    example: "bà ra chợ luôn tiện mua hộ tôi bó rau muống",
  },
  {
    word: "luồng",
    part_of_speech: "danh từ",
    meaning:
      "dòng di chuyển theo một chiều nhất định: luồng ánh sáng * luồng điện * gió thổi thành từng luồng",
    example: "luồng ánh sáng * luồng điện * gió thổi thành từng luồng",
  },
  {
    word: "luồng",
    part_of_speech: "danh từ",
    meaning:
      "đường vận động liên tục theo một chiều nhất định của những vật cùng loại chuyển động nối tiếp nhau không ngừng: luồng cá * phân luồng giao thông * xuồng chạy bị chệch luồng",
    example: "luồng cá * phân luồng giao thông * xuồng chạy bị chệch luồng",
  },
  {
    word: "luồng",
    part_of_speech: "danh từ",
    meaning:
      "dòng tư tưởng, văn hoá lan truyền theo một hướng nhất định: luồng văn hoá mới * luồng tư tưởng",
    example: "luồng văn hoá mới * luồng tư tưởng",
  },
  {
    word: "luống tuổi",
    part_of_speech: "tính từ",
    meaning:
      "ở tuổi đã khá nhiều, nhưng chưa phải là già: người phụ nữ luống tuổi",
    example: "người phụ nữ luống tuổi",
  },
  {
    word: "luông tuồng",
    part_of_speech: "tính từ",
    meaning: "như buông tuồng: lối sống luông tuồng",
    example: "lối sống luông tuồng",
  },
  {
    word: "luống cuống",
    part_of_speech: "tính từ",
    meaning:
      "ở vào trạng thái mất bình tĩnh, thiếu tự chủ đến mức không biết xử sự, đối phó ra sao (thường thể hiện bằng những cử chỉ, hành động vụng về, không tự nhiên): mừng quá, tay chân luống cuống * trả lời luống cuống",
    example: "mừng quá, tay chân luống cuống * trả lời luống cuống",
  },
  {
    word: "luồng lạch",
    part_of_speech: "danh từ",
    meaning:
      "dòng nước sâu ở sông, biển có thể đảm bảo an toàn cho tàu thuyền qua lại (nói khái quát): thông thuộc từng luồng lạch trên khúc sông * khai thông các luồng lạch",
    example:
      "thông thuộc từng luồng lạch trên khúc sông * khai thông các luồng lạch",
  },
  {
    word: "lụp bụp",
    part_of_speech: "tính từ",
    meaning: "từ mô phỏng tiếng nổ liên tiếp, nhỏ và trầm: ngô rang nổ lụp bụp",
    example: "ngô rang nổ lụp bụp",
  },
  {
    word: "lúp",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) kính lúp (nói tắt): soi lúp xem chữ",
    example: "soi lúp xem chữ",
  },
  {
    word: "lụp chụp",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) quá vội vàng, hấp tấp nên vụng về, không chu đáo: nói năng lụp chụp * chuẩn bị lụp chụp",
    example: "nói năng lụp chụp * chuẩn bị lụp chụp",
  },
  {
    word: "lút",
    part_of_speech: "động từ",
    meaning:
      "phủ ngập cả, che kín cả: cỏ lác mọc lút đầu người * bùn lút sâu đến đầu gối * công việc lút đầu lút cổ (b)",
    example:
      "cỏ lác mọc lút đầu người * bùn lút sâu đến đầu gối * công việc lút đầu lút cổ (b)",
  },
  {
    word: "lút",
    part_of_speech: "động từ",
    meaning:
      "ở sâu hẳn vào bên trong, không nhìn thấy đâu nữa: cái kim lút sâu trong bọc * thò lút cánh tay vào trong hũ",
    example: "cái kim lút sâu trong bọc * thò lút cánh tay vào trong hũ",
  },
  {
    word: "lúp xúp",
    part_of_speech: "tính từ",
    meaning:
      "gồm nhiều cái có dáng khum khum ở liền nhau, thấp và sàn sàn như nhau: những mái tranh lúp xúp * nhiều bụi cây mọc lúp xúp",
    example: "những mái tranh lúp xúp * nhiều bụi cây mọc lúp xúp",
  },
  {
    word: "lúp xúp",
    part_of_speech: "tính từ",
    meaning:
      "(dáng đi, chạy) mau và với những bước ngắn: chạy lúp xúp, vội vàng",
    example: "chạy lúp xúp, vội vàng",
  },
  {
    word: "lụt",
    part_of_speech: "động từ",
    meaning: "(bấc đèn) đã cháy cụt đi: đèn lụt bấc",
    example: "đèn lụt bấc",
  },
  {
    word: "lụt",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) cùn: dao lụt * lưỡi câu lụt",
    example: "dao lụt * lưỡi câu lụt",
  },
  {
    word: "lụp xụp",
    part_of_speech: "tính từ",
    meaning:
      "(nhà cửa) thấp bé, tồi tàn và xấu xí: túp lều tranh lụp xụp * gian nhà lụp xụp, ẩm thấp",
    example: "túp lều tranh lụp xụp * gian nhà lụp xụp, ẩm thấp",
  },
  {
    word: "lụt cụt",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả dáng đi hoặc chạy vội vã với những bước rất ngắn, trông vất vả: chạy lụt cụt",
    example: "chạy lụt cụt",
  },
  {
    word: "lút cút",
    part_of_speech: "tính từ",
    meaning: "như lúc cúc: lút cút chạy theo sau",
    example: "lút cút chạy theo sau",
  },
  {
    word: "luỹ tiến",
    part_of_speech: "tính từ",
    meaning:
      "(đại lượng) tăng dần dần từng mức theo một quy tắc nhất định: thuế suất luỹ tiến * chịu phạt luỹ tiến",
    example: "thuế suất luỹ tiến * chịu phạt luỹ tiến",
  },
  {
    word: "luyến",
    part_of_speech: "động từ",
    meaning:
      "chuyển liên tục từ âm của một nốt nhạc này sang âm của một nốt nhạc khác khi hát hay biểu diễn âm nhạc: hát luyến giọng",
    example: "hát luyến giọng",
  },
  {
    word: "luỵ",
    part_of_speech: "danh từ",
    meaning: "(Từ cũ, Văn chương) nước mắt: giọt luỵ * rơi luỵ",
    example: "giọt luỵ * rơi luỵ",
  },
  {
    word: "luỵ",
    part_of_speech: "động từ",
    meaning:
      'nhẫn nhục chiều theo ý người khác để được việc mình đang cần: không chịu luỵ ai * "Cách sông nên phải luỵ đò, Tối trời nên phải luỵ o bán dầu." (Cdao)',
    example:
      'không chịu luỵ ai * "Cách sông nên phải luỵ đò, Tối trời nên phải luỵ o bán dầu." (Cdao)',
  },
  {
    word: "luỵ",
    part_of_speech: "động từ",
    meaning:
      'phải chịu hoặc làm cho phải chịu khốn khổ lây vì việc làm của người khác: sợ luỵ đến gia đình * mang luỵ vào thân * "Vì ta cho luỵ đến người, Cát lầm ngọc trắng, thiệt đời xuân xanh." (TKiều)',
    example:
      'sợ luỵ đến gia đình * mang luỵ vào thân * "Vì ta cho luỵ đến người, Cát lầm ngọc trắng, thiệt đời xuân xanh." (TKiều)',
  },
  {
    word: "lụt lội",
    part_of_speech: "danh từ",
    meaning:
      "lụt và gây ra ngập nước, lầy lội (nói khái quát): phòng chống lụt lội * mưa lớn gây ra lụt lội",
    example: "phòng chống lụt lội * mưa lớn gây ra lụt lội",
  },
  {
    word: "lụt lội",
    part_of_speech: "tính từ",
    meaning:
      "bị ngập nước và lầy lội (do lụt): đường sá lụt lội * đê vỡ làm lụt lội cả vùng",
    example: "đường sá lụt lội * đê vỡ làm lụt lội cả vùng",
  },
  {
    word: "luỹ thừa",
    part_of_speech: "danh từ",
    meaning:
      "tích của một số hay của một biểu thức với chính nó một số lần: 8 là luỹ thừa bậc 3 của 2 * hai luỹ thừa cùng bậc",
    example: "8 là luỹ thừa bậc 3 của 2 * hai luỹ thừa cùng bậc",
  },
  {
    word: "luỹ",
    part_of_speech: "danh từ",
    meaning:
      "công trình bảo vệ một vị trí, thường đắp bằng đất: đắp luỹ * thành cao, luỹ sâu",
    example: "đắp luỹ * thành cao, luỹ sâu",
  },
  {
    word: "luỹ",
    part_of_speech: "danh từ",
    meaning: "hàng cây trồng rất dày để làm hàng rào: luỹ tre xanh",
    example: "luỹ tre xanh",
  },
  {
    word: "luyện",
    part_of_speech: "động từ",
    meaning:
      "chế biến cho tốt hơn qua tác dụng của nhiệt độ cao: luyện gang * lò luyện sắt",
    example: "luyện gang * lò luyện sắt",
  },
  {
    word: "luyện",
    part_of_speech: "động từ",
    meaning:
      "nhào, trộn kĩ cho thật dẻo, thật nhuyễn để sử dụng được: luyện đất nặn lọ * luyện vôi cát với xi măng",
    example: "luyện đất nặn lọ * luyện vôi cát với xi măng",
  },
  {
    word: "luyện",
    part_of_speech: "động từ",
    meaning:
      "tập đi tập lại nhiều lần để nâng cao dần khả năng hoặc kĩ năng: luyện viết chính tả * luyện phát âm tiếng Anh * luyện tay nghề",
    example: "luyện viết chính tả * luyện phát âm tiếng Anh * luyện tay nghề",
  },
  {
    word: "luyện kim",
    part_of_speech: "động từ",
    meaning: "luyện ra kim loại và hợp kim: lò luyện kim",
    example: "lò luyện kim",
  },
  {
    word: "luyện tập",
    part_of_speech: "động từ",
    meaning:
      "làm đi làm lại nhiều lần theo một nội dung để cho thành thạo (nói khái quát): bài luyện tập toán * luyện tập thể thao * luyện tập binh mã",
    example: "bài luyện tập toán * luyện tập thể thao * luyện tập binh mã",
  },
  {
    word: "luyến ái",
    part_of_speech: "động từ",
    meaning: "(cũ) yêu đương: đem lòng luyến ái * tự do luyến ái",
    example: "đem lòng luyến ái * tự do luyến ái",
  },
  {
    word: "luyến láy",
    part_of_speech: "",
    meaning: "luyến và láy (nói khái quát): bài hát có nhiều chỗ luyến láy",
    example: "bài hát có nhiều chỗ luyến láy",
  },
  {
    word: "luyên thuyên",
    part_of_speech: "",
    meaning:
      "(nói năng) nhiều lời và lan man, chưa hết chuyện này đã sang chuyện kia: cười nói huyên thuyên * huyên thuyên đủ các thứ chuyện",
    example: "cười nói huyên thuyên * huyên thuyên đủ các thứ chuyện",
  },
  {
    word: "luyến tiếc",
    part_of_speech: "động từ",
    meaning:
      "nuối tiếc và nhớ mãi, không dứt bỏ được mối tình cảm với cái đã mất: luyến tiếc tuổi xuân * nhìn bằng ánh mắt luyến tiếc",
    example: "luyến tiếc tuổi xuân * nhìn bằng ánh mắt luyến tiếc",
  },
  {
    word: "luýnh quýnh",
    part_of_speech: "tính từ",
    meaning:
      "lúng túng, vụng về do mất bình tĩnh đến không tự chủ được: tay chân luýnh quýnh",
    example: "tay chân luýnh quýnh",
  },
  {
    word: "lừ",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) lờ: thả lừ",
    example: "thả lừ",
  },
  {
    word: "lừ",
    part_of_speech: "động từ",
    meaning:
      "đưa mắt nhìn ngang không chớp vào người nào đó để tỏ ý không bằng lòng, đe doạ, ngăn cấm: lừ mắt bảo im",
    example: "lừ mắt bảo im",
  },
  {
    word: "lử",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái không còn đủ sức, người như rã rời: đói lử * lử người vì nắng",
    example: "đói lử * lử người vì nắng",
  },
  {
    word: "lữ đoàn",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị tổ chức của lực lượng vũ trang, lớn hơn trung đoàn, nhỏ hơn sư đoàn: lữ đoàn tăng",
    example: "lữ đoàn tăng",
  },
  {
    word: "lư",
    part_of_speech: "danh từ",
    meaning: "đỉnh nhỏ để đốt trầm, hương: cái lư đồng",
    example: "cái lư đồng",
  },
  {
    word: "lừ đừ",
    part_of_speech: "tính từ",
    meaning:
      "chậm chạp, nặng nề, không linh hoạt: mệt lừ đừ cả người * nước chảy lừ đừ",
    example: "mệt lừ đừ cả người * nước chảy lừ đừ",
  },
  {
    word: "lữ",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị tổ chức của lực lượng vũ trang, lớn hơn trung đoàn, nhỏ hơn sư đoàn: lữ đoàn tăng",
    example: "lữ đoàn tăng",
  },
  {
    word: "lữ hành",
    part_of_speech: "động từ",
    meaning: "(cũ, hiếm) đi đường xa: du lịch lữ hành * khách lữ hành",
    example: "du lịch lữ hành * khách lữ hành",
  },
  {
    word: "lử đử",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như lừ đừ: mệt quá, nằm lử đử",
    example: "mệt quá, nằm lử đử",
  },
  {
    word: "lử khử",
    part_of_speech: "tính từ",
    meaning:
      "có dáng điệu chậm chạp, mệt mỏi, ủ rũ của người ốm: ốm lử khử * dáng điệu lử khử",
    example: "ốm lử khử * dáng điệu lử khử",
  },
  {
    word: "lữ khách",
    part_of_speech: "danh từ",
    meaning: "(cũ) khách đi đường xa: người lữ khách",
    example: "người lữ khách",
  },
  {
    word: "lừ lừ",
    part_of_speech: "tính từ",
    meaning:
      "(mắt) có cái nhìn chiếu thẳng, tỏ vẻ bực bội, giận dữ, không chút thiện cảm: mắt cứ lừ lừ, trông thật đáng sợ",
    example: "mắt cứ lừ lừ, trông thật đáng sợ",
  },
  {
    word: "lừ lừ",
    part_of_speech: "tính từ",
    meaning:
      "(di chuyển) chậm chạp và lặng lẽ: lừ lừ tiến vào * dòng nước lừ lừ trôi * lừ lừ như ông từ vào đền (tng)",
    example:
      "lừ lừ tiến vào * dòng nước lừ lừ trôi * lừ lừ như ông từ vào đền (tng)",
  },
  {
    word: "lừ thừ",
    part_of_speech: "tính từ",
    meaning: "chậm chạp, uể oải: lừ thừ đứng dậy",
    example: "lừ thừ đứng dậy",
  },
  {
    word: "lữ quán",
    part_of_speech: "danh từ",
    meaning: "(cũ) quán trọ: nghỉ chân ở một lữ quán",
    example: "nghỉ chân ở một lữ quán",
  },
  {
    word: "lữ thứ",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) chỗ tạm nghỉ lại của người đi đường xa; thường dùng để chỉ nơi đất khách, quê người: "Kẻ chốn chương đài, người lữ thứ, Lấy ai mà kể nỗi hàn ôn?" (BHThQuan; 1)',
    example:
      'Kẻ chốn chương đài, người lữ thứ, Lấy ai mà kể nỗi hàn ôn?" (BHThQuan; 1)',
  },
  {
    word: "lựa",
    part_of_speech: "động từ",
    meaning:
      "lấy ra cái đáp ứng theo yêu cầu, trên cơ sở so sánh với những cái cùng loại: lựa hạt giống * lựa những quả trứng mới",
    example: "lựa hạt giống * lựa những quả trứng mới",
  },
  {
    word: "lựa",
    part_of_speech: "động từ",
    meaning:
      'chọn chiều, hướng, lối, sao cho việc làm đạt kết quả tốt nhất: lựa lời khuyên giải * "Những e lại luỵ đến nàng, Đánh liều mới sẽ lựa đường hỏi tra." (TKiều)',
    example:
      'lựa lời khuyên giải * "Những e lại luỵ đến nàng, Đánh liều mới sẽ lựa đường hỏi tra." (TKiều)',
  },
  {
    word: "lựa",
    part_of_speech: "kết từ",
    meaning:
      '(Từ cũ, Ít dùng) như lọ: "Sau con cũng rõ lẽ này, Lựa là con phải hỏi thầy làm chi." (LVT)',
    example: 'Sau con cũng rõ lẽ này, Lựa là con phải hỏi thầy làm chi." (LVT)',
  },
  {
    word: "lừa",
    part_of_speech: "danh từ",
    meaning:
      "thú cùng họ với ngựa, nhưng nhỏ hơn, tai dài, nuôi để kéo xe, thồ hàng: da lừa * thân lừa ưa nặng (tng)",
    example: "da lừa * thân lừa ưa nặng (tng)",
  },
  {
    word: "lừa",
    part_of_speech: "động từ",
    meaning:
      "làm cho người khác bị lầm bằng cách nói dối hoặc dùng mưu mẹo: mắc lừa * bị kẻ gian lừa * lừa người vào tròng",
    example: "mắc lừa * bị kẻ gian lừa * lừa người vào tròng",
  },
  {
    word: "lừa",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) ru, dỗ khéo léo cho trẻ nhỏ yên lòng là có mình ở bên cạnh mà ngủ, để rồi đi làm việc khác: lừa cho em ngủ để nấu nướng, dọn dẹp",
    example: "lừa cho em ngủ để nấu nướng, dọn dẹp",
  },
  {
    word: "lừa",
    part_of_speech: "động từ",
    meaning:
      "lựa thời cơ, cơ hội thuận tiện mà làm việc gì: lừa lúc không ai để ý, trốn mất * lừa dịp quân địch yếu để tấn công",
    example:
      "lừa lúc không ai để ý, trốn mất * lừa dịp quân địch yếu để tấn công",
  },
  {
    word: "lừa",
    part_of_speech: "động từ",
    meaning:
      "dùng lưỡi đưa qua đưa lại, tách lấy riêng ra khỏi những cái khác đang ngậm trong miệng: ăn cá lừa xương",
    example: "ăn cá lừa xương",
  },
  {
    word: "lửa",
    part_of_speech: "danh từ",
    meaning:
      "nhiệt và ánh sáng phát sinh đồng thời từ vật đang cháy: đánh diêm lấy lửa * tính nóng như lửa * lửa gần rơm lâu ngày cũng bén (tng)",
    example:
      "đánh diêm lấy lửa * tính nóng như lửa * lửa gần rơm lâu ngày cũng bén (tng)",
  },
  {
    word: "lửa",
    part_of_speech: "danh từ",
    meaning:
      'trạng thái tinh thần, tình cảm sôi sục, mạnh mẽ (ví như có ngọn lửa đang bốc lên trong người): lửa tình * "Sự đời đã tắt lửa lòng, Còn chen vào chốn bụi hồng làm chi!" (TKiều)',
    example:
      'lửa tình * "Sự đời đã tắt lửa lòng, Còn chen vào chốn bụi hồng làm chi!" (TKiều)',
  },
  {
    word: "lửa binh",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) như binh lửa: "Đêm ngày luống những âm thầm, Lửa binh đâu đã ầm ầm một phương!" (TKiều)',
    example:
      'Đêm ngày luống những âm thầm, Lửa binh đâu đã ầm ầm một phương!" (TKiều)',
  },
  {
    word: "lừa bịp",
    part_of_speech: "động từ",
    meaning:
      "lừa bằng mánh khoé xảo trá để che giấu sự thật (nói khái quát): giở trò lừa bịp * thủ đoạn lừa bịp",
    example: "giở trò lừa bịp * thủ đoạn lừa bịp",
  },
  {
    word: "lứa",
    part_of_speech: "danh từ",
    meaning:
      "tập hợp những con vật, trứng hay những bộ phận của cây như quả, lá, v.v. cùng loại sinh trưởng trong cùng một thời kì: lứa lợn mười con * hái lứa chè đầu tiên * cá mè một lứa (tng)",
    example: "lứa lợn mười con * hái lứa chè đầu tiên * cá mè một lứa (tng)",
  },
  {
    word: "lứa",
    part_of_speech: "danh từ",
    meaning:
      "độ sinh trưởng vừa đạt yêu cầu để có thể thu hoạch hàng loạt (nói về sản phẩm trồng trọt): rau đã đến lứa * cau già quá lứa",
    example: "rau đã đến lứa * cau già quá lứa",
  },
  {
    word: "lứa",
    part_of_speech: "danh từ",
    meaning:
      "lớp người cùng một cỡ tuổi với nhau: bạn cùng lứa * lứa tuổi mười tám, đôi mươi",
    example: "bạn cùng lứa * lứa tuổi mười tám, đôi mươi",
  },
  {
    word: "lựa chọn",
    part_of_speech: "động từ",
    meaning:
      "chọn giữa nhiều cái cùng loại (nói khái quát): lựa chọn người kế nghiệp * lựa chọn công việc phù hợp",
    example: "lựa chọn người kế nghiệp * lựa chọn công việc phù hợp",
  },
  {
    word: "lừa dối",
    part_of_speech: "động từ",
    meaning:
      "lừa bằng thủ đoạn nói dối (nói khái quát): lừa dối bạn bè * tự lừa dối lòng mình",
    example: "lừa dối bạn bè * tự lừa dối lòng mình",
  },
  {
    word: "lửa đạn",
    part_of_speech: "danh từ",
    meaning:
      "cảnh chiến tranh, nói về mặt nguy hiểm chết chóc: xông pha nơi lửa đạn",
    example: "xông pha nơi lửa đạn",
  },
  {
    word: "lừa đảo",
    part_of_speech: "động từ",
    meaning:
      "lừa bằng thủ đoạn xảo trá để chiếm lấy của cải, tài sản: kẻ lừa đảo * giở trò lừa đảo",
    example: "kẻ lừa đảo * giở trò lừa đảo",
  },
  {
    word: "lứa đôi",
    part_of_speech: "danh từ",
    meaning:
      '(văn chương) cặp trai gái, vợ chồng trẻ xứng đôi với nhau: hạnh phúc lứa đôi * "Xưa nay duyên nợ lứa đôi, Khi nên chẳng lựa cầu Trời mới nên." (ca dao)',
    example:
      'hạnh phúc lứa đôi * "Xưa nay duyên nợ lứa đôi, Khi nên chẳng lựa cầu Trời mới nên." (ca dao)',
  },
  {
    word: "lừa gạt",
    part_of_speech: "động từ",
    meaning: "đánh lừa để mưu lợi: bị kẻ xấu lừa gạt * lừa gạt phụ nữ",
    example: "bị kẻ xấu lừa gạt * lừa gạt phụ nữ",
  },
  {
    word: "lửa hương",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) như hương lửa: "Trách lòng hờ hững với lòng, Lửa hương chốc để lạnh lùng bấy lâu!" (TKiều)',
    example:
      'Trách lòng hờ hững với lòng, Lửa hương chốc để lạnh lùng bấy lâu!" (TKiều)',
  },
  {
    word: "lửa hương",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như hương khói: lửa hương nghi ngút",
    example: "lửa hương nghi ngút",
  },
  {
    word: "lừa lọc",
    part_of_speech: "động từ",
    meaning:
      "lừa người bằng mánh khoé xảo trá (nói khái quát): mưu mô lừa lọc * thủ đoạn lừa lọc",
    example: "mưu mô lừa lọc * thủ đoạn lừa lọc",
  },
  {
    word: "lừa mị",
    part_of_speech: "động từ",
    meaning:
      "như lừa phỉnh: lừa mị trẻ con * nhiều hình thức quảng cáo lừa mị người tiêu dùng",
    example:
      "lừa mị trẻ con * nhiều hình thức quảng cáo lừa mị người tiêu dùng",
  },
  {
    word: "lừa phỉnh",
    part_of_speech: "động từ",
    meaning: "phỉnh nịnh để đánh lừa: lừa phỉnh phụ nữ * buông lời lừa phỉnh",
    example: "lừa phỉnh phụ nữ * buông lời lừa phỉnh",
  },
  {
    word: "lửa trại",
    part_of_speech: "danh từ",
    meaning:
      "hình thức vui liên hoan tổ chức về đêm xung quanh đống lửa ở nơi cắm trại: đêm lửa trại",
    example: "đêm lửa trại",
  },
  {
    word: "lừa thầy phản bạn",
    part_of_speech: "",
    meaning:
      "lừa lọc, tráo trở với ngay người đã tin cậy mình hoặc có ân nghĩa với mình; hoàn toàn không có đạo đức, không thể tin cậy được: kẻ lừa thầy phản bạn",
    example: "kẻ lừa thầy phản bạn",
  },
  {
    word: "lưa thưa",
    part_of_speech: "tính từ",
    meaning: "như lơ thơ: cỏ mọc lưa thưa * chòm râu lưa thưa",
    example: "cỏ mọc lưa thưa * chòm râu lưa thưa",
  },
  {
    word: "lực bất tòng tâm",
    part_of_speech: "",
    meaning:
      "khả năng không đủ để thực hiện điều mong muốn: dù đã rất cố gắng, nhưng lực bất tòng tâm",
    example: "dù đã rất cố gắng, nhưng lực bất tòng tâm",
  },
  {
    word: "lực điền",
    part_of_speech: "danh từ",
    meaning: "(cũ) người nông dân khoẻ mạnh: người đàn ông lực điền",
    example: "người đàn ông lực điền",
  },
  {
    word: "lực lượng",
    part_of_speech: "danh từ",
    meaning:
      "sức mạnh có thể tạo nên một tác động nhất định: lực lượng vật chất * lực lượng tinh thần",
    example: "lực lượng vật chất * lực lượng tinh thần",
  },
  {
    word: "lực lượng",
    part_of_speech: "danh từ",
    meaning:
      "sức mạnh của con người được tổ chức nhau lại tạo ra để sử dụng vào các hoạt động của mình: lực lượng cảnh sát * đào tạo lực lượng vận động viên trẻ",
    example: "lực lượng cảnh sát * đào tạo lực lượng vận động viên trẻ",
  },
  {
    word: "lực",
    part_of_speech: "danh từ",
    meaning:
      "sức, sức mạnh: không đủ lực để làm * lực học trung bình * lực bất tòng tâm (tng)",
    example:
      "không đủ lực để làm * lực học trung bình * lực bất tòng tâm (tng)",
  },
  {
    word: "lực",
    part_of_speech: "danh từ",
    meaning:
      "tác dụng làm biến đổi chuyển động hoặc hình dạng của các vật: lực đẩy * tác dụng một lực lên vật",
    example: "lực đẩy * tác dụng một lực lên vật",
  },
  {
    word: "lực lưỡng",
    part_of_speech: "tính từ",
    meaning:
      "có vóc dáng to khoẻ, tỏ ra có sức mạnh thể lực (thường nói về đàn ông): thân hình lực lưỡng",
    example: "thân hình lực lưỡng",
  },
  {
    word: "lừng",
    part_of_speech: "động từ",
    meaning: "(mùi thơm) toả ra mạnh và rộng: mùi hoa lan thơm lừng",
    example: "mùi hoa lan thơm lừng",
  },
  {
    word: "lừng",
    part_of_speech: "động từ",
    meaning:
      '(tiếng tăm) vang xa, ai cũng biết: "Bấy lâu nghe biết tiếng nàng, Bên anh nức tiếng đồn vang đã lừng." (ca dao)',
    example:
      'Bấy lâu nghe biết tiếng nàng, Bên anh nức tiếng đồn vang đã lừng." (ca dao)',
  },
  {
    word: "lưng",
    part_of_speech: "danh từ",
    meaning:
      "phần phía sau của cơ thể người hoặc phần phía trên của cơ thể động vật có xương sống, đối với ngực và bụng: khom lưng cấy * cưỡi trên lưng ngựa * thắt lưng buộc bụng (tng)",
    example: "khom lưng cấy * cưỡi trên lưng ngựa * thắt lưng buộc bụng (tng)",
  },
  {
    word: "lưng",
    part_of_speech: "danh từ",
    meaning:
      "dải hoặc bao dài bằng vải buộc ngang lưng cho đẹp, hoặc (thời trước) để đựng tiền; thường dùng để chỉ tiền riêng, tiền vốn: lần lưng lấy tiền * dành dụm được ít tiền giắt lưng",
    example: "lần lưng lấy tiền * dành dụm được ít tiền giắt lưng",
  },
  {
    word: "lưng",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) cạp (quần): nhét lựu đạn ở lưng quần",
    example: "nhét lựu đạn ở lưng quần",
  },
  {
    word: "lưng",
    part_of_speech: "danh từ",
    meaning: "phần ghế để tựa lưng khi ngồi: ngả người vào lưng ghế",
    example: "ngả người vào lưng ghế",
  },
  {
    word: "lưng",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận phía sau của một số vật: lưng quân bài * nhà quay lưng ra hồ",
    example: "lưng quân bài * nhà quay lưng ra hồ",
  },
  {
    word: "lưng",
    part_of_speech: "danh từ",
    meaning:
      "khoảng ở giữa, không ở trên cao, cũng không ở dưới thấp: cánh diều lơ lửng trên lưng trời",
    example: "cánh diều lơ lửng trên lưng trời",
  },
  {
    word: "lưng",
    part_of_speech: "danh từ",
    meaning:
      'lượng chứa chỉ chiếm khoảng nửa vật đựng: thóc còn lưng bồ * "Đói lòng ăn nửa trái sim, Uống lưng bát nước đi tìm người thương." (ca dao)',
    example:
      'thóc còn lưng bồ * "Đói lòng ăn nửa trái sim, Uống lưng bát nước đi tìm người thương." (ca dao)',
  },
  {
    word: "lưng",
    part_of_speech: "tính từ",
    meaning:
      'không đầy, chưa đầy do còn thiếu một ít nữa: đong lưng * "Đêm khuya thắp đĩa dầu vừng, Biết lấy ai than thở cho lưng đĩa dầu." (ca dao)',
    example:
      'đong lưng * "Đêm khuya thắp đĩa dầu vừng, Biết lấy ai than thở cho lưng đĩa dầu." (ca dao)',
  },
  {
    word: "lửng",
    part_of_speech: "tính từ",
    meaning:
      "ở mức nửa chừng, chứ không đủ, không trọn: quần lửng đến đầu gối * bỏ lửng câu nói",
    example: "quần lửng đến đầu gối * bỏ lửng câu nói",
  },
  {
    word: "lực sĩ",
    part_of_speech: "danh từ",
    meaning:
      "người có sức mạnh thể lực đặc biệt (thường nói về đàn ông): lực sĩ thể hình * khoẻ như lực sĩ",
    example: "lực sĩ thể hình * khoẻ như lực sĩ",
  },
  {
    word: "lựng",
    part_of_speech: "tính từ",
    meaning:
      "(mùi vị) đậm đà, tác động mạnh nhưng dễ chịu đến giác quan (thường nói về mùi thơm): mùi mít chín thơm lựng * khoai ngọt lựng",
    example: "mùi mít chín thơm lựng * khoai ngọt lựng",
  },
  {
    word: "lựng",
    part_of_speech: "tính từ",
    meaning: "(màu sắc) đậm nhưng sáng, trông đẹp mắt: mặt trời đỏ lựng",
    example: "mặt trời đỏ lựng",
  },
  {
    word: "lừng danh",
    part_of_speech: "động từ",
    meaning:
      "nổi tiếng, được nhiều người biết đến: thám tử lừng danh * lừng danh trong làng điện ảnh",
    example: "thám tử lừng danh * lừng danh trong làng điện ảnh",
  },
  {
    word: "lửng dạ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ở trạng thái không còn đói nữa nhưng cũng chưa đủ no: sáng ăn rồi nên giờ vẫn còn lửng dạ",
    example: "sáng ăn rồi nên giờ vẫn còn lửng dạ",
  },
  {
    word: "lửng khửng",
    part_of_speech: "tính từ",
    meaning:
      "không rõ ràng, nửa thế này nửa thế kia, muốn thế nào cũng được: ăn nói lửng khửng",
    example: "ăn nói lửng khửng",
  },
  {
    word: "lừng khà lừng khừng",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) rất lừng khừng: thái độ lừng khà lừng khừng",
    example: "thái độ lừng khà lừng khừng",
  },
  {
    word: "lừng khừng",
    part_of_speech: "",
    meaning:
      "ngần ngừ, không dứt khoát, không dám hoặc không muốn có hành động tích cực: trả lời lừng khừng * thái độ lừng khừng",
    example: "trả lời lừng khừng * thái độ lừng khừng",
  },
  {
    word: "lừng chừng",
    part_of_speech: "tính từ",
    meaning:
      "do dự, không dứt khoát ngả về phía nào: thái độ lừng chừng * còn lừng chừng chưa dám quyết",
    example: "thái độ lừng chừng * còn lừng chừng chưa dám quyết",
  },
  {
    word: "lưng chừng",
    part_of_speech: "danh từ",
    meaning:
      "khoảng đại khái ở giữa, không ở trên cao cũng không ở dưới thấp: nhà ở lưng chừng núi * nước dâng lưng chừng nhà",
    example: "nhà ở lưng chừng núi * nước dâng lưng chừng nhà",
  },
  {
    word: "lưng chừng",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) (làm việc gì) chỉ nửa chừng, không làm cho xong, cho trọn: làm lưng chừng rồi bỏ",
    example: "làm lưng chừng rồi bỏ",
  },
  {
    word: "lựng khựng",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) (dáng đi đứng) chậm chạp, khó khăn, không đều bước, bước đi bước dừng: ông lão lựng khựng bước lên thềm",
    example: "ông lão lựng khựng bước lên thềm",
  },
  {
    word: "lững chững",
    part_of_speech: "động từ",
    meaning: "(trẻ em) đi từng bước, chưa vững: em bé đã lững chững biết đi",
    example: "em bé đã lững chững biết đi",
  },
  {
    word: "lừng lẫy",
    part_of_speech: "",
    meaning:
      "vang lừng tới mức khắp nơi ai cũng biết: danh tiếng lừng lẫy * chiến công lừng lẫy",
    example: "danh tiếng lừng lẫy * chiến công lừng lẫy",
  },
  {
    word: "lửng lơ",
    part_of_speech: "tính từ",
    meaning: "như lơ lửng (ng1): quả bóng bay lửng lơ giữa trời",
    example: "quả bóng bay lửng lơ giữa trời",
  },
  {
    word: "lửng lơ",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái nửa vời, không hẳn là gì, không hẳn ra sao: ăn nói lửng lơ * ốm lửng lơ",
    example: "ăn nói lửng lơ * ốm lửng lơ",
  },
  {
    word: "lừng lững",
    part_of_speech: "tính từ",
    meaning:
      "to lớn và như từ đâu hiện ra, án ngữ ngay trước mặt, gây ấn tượng đáng sợ: ngọn núi cao lừng lững * người lừng lững như cái cột đình",
    example: "ngọn núi cao lừng lững * người lừng lững như cái cột đình",
  },
  {
    word: "lừng lững",
    part_of_speech: "tính từ",
    meaning:
      "(di chuyển) chậm chạp, lặng lẽ và nặng nề, gây ấn tượng đáng sợ hoặc khó chịu: chiếc xe tăng lừng lững tiến vào",
    example: "chiếc xe tăng lừng lững tiến vào",
  },
  {
    word: "lững thững",
    part_of_speech: "tính từ",
    meaning:
      "từ gợi tả dáng đi thong thả, chậm rãi từng bước một: lững thững dạo phố",
    example: "lững thững dạo phố",
  },
  {
    word: "lưng lửng",
    part_of_speech: "tính từ",
    meaning:
      'như lửng (nhưng ý mức độ ít): "Hề đồng theo bốn năm thằng, Thơ ninh ních túi, rượu lưng lửng bầu." (NĐM)',
    example:
      'Hề đồng theo bốn năm thằng, Thơ ninh ních túi, rượu lưng lửng bầu." (NĐM)',
  },
  {
    word: "lưng lửng dạ",
    part_of_speech: "tính từ",
    meaning: "hơi lửng dạ: ăn từ sáng tới giờ vẫn còn lưng lửng dạ",
    example: "ăn từ sáng tới giờ vẫn còn lưng lửng dạ",
  },
  {
    word: "lững lờ",
    part_of_speech: "tính từ",
    meaning:
      "(di chuyển) chậm chạp và êm ả, trông tựa như vẫn đứng yên: dòng nước lững lờ trôi * đàn cá bơi lững lờ",
    example: "dòng nước lững lờ trôi * đàn cá bơi lững lờ",
  },
  {
    word: "lững lờ",
    part_of_speech: "tính từ",
    meaning:
      'tỏ vẻ không thiết tha hoặc không rõ ràng dứt khoát: thái độ lững lờ * "Công tôi đi đợi về chờ, Sao người ăn nói lững lờ như không!" (ca dao)',
    example:
      'thái độ lững lờ * "Công tôi đi đợi về chờ, Sao người ăn nói lững lờ như không!" (ca dao)',
  },
  {
    word: "lược",
    part_of_speech: "danh từ",
    meaning: "đồ dùng để chải tóc, có nhiều răng đều nhau: chiếc lược ngà",
    example: "chiếc lược ngà",
  },
  {
    word: "lược",
    part_of_speech: "động từ",
    meaning:
      "bớt đi những chi tiết không thật cần thiết, để chỉ giữ lại cái chính, cái cơ bản: bài viết bị lược một đoạn * lược kể một vài chi tiết * lược trích một tác phẩm",
    example:
      "bài viết bị lược một đoạn * lược kể một vài chi tiết * lược trích một tác phẩm",
  },
  {
    word: "lược",
    part_of_speech: "động từ",
    meaning:
      "khâu sơ những đường chính để giữ nếp vải: lược trước rồi mới máy * khâu lược",
    example: "lược trước rồi mới máy * khâu lược",
  },
  {
    word: "lược dịch",
    part_of_speech: "động từ",
    meaning: "dịch những ý chính, bỏ qua các chi tiết: lược dịch bài phát biểu",
    example: "lược dịch bài phát biểu",
  },
  {
    word: "lưng vốn",
    part_of_speech: "danh từ",
    meaning: "vốn riêng để buôn bán, làm ăn: lưng vốn cũng kha khá",
    example: "lưng vốn cũng kha khá",
  },
  {
    word: "lược giắt trâm cài",
    part_of_speech: "",
    meaning:
      '(cũ, văn chương) tả sự trang điểm cẩn thận của người phụ nữ thời xưa: "Trên đầu lược giắt trâm cài, Tảo tần khuya sớm chưa ai chung tình." (ca dao)',
    example:
      'Trên đầu lược giắt trâm cài, Tảo tần khuya sớm chưa ai chung tình." (ca dao)',
  },
  {
    word: "lược khảo",
    part_of_speech: "động từ",
    meaning:
      "nghiên cứu một cách khái quát về những cái chính, không đi vào chi tiết: lược khảo về thần thoại Việt Nam",
    example: "lược khảo về thần thoại Việt Nam",
  },
  {
    word: "lược đồ",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như sơ đồ: bản lược đồ * lược đồ mạng điện",
    example: "bản lược đồ * lược đồ mạng điện",
  },
  {
    word: "lược thao",
    part_of_speech: "danh từ",
    meaning:
      '(cũ) như thao lược: "Đường đường một đấng anh hào, Côn quyền hơn sức, lược thao gồm tài." (TKiều)',
    example:
      'Đường đường một đấng anh hào, Côn quyền hơn sức, lược thao gồm tài." (TKiều)',
  },
  {
    word: "lược thuật",
    part_of_speech: "động từ",
    meaning:
      "trình bày tóm tắt (thường bằng văn viết): lược thuật nội dung chính của cuốn tiểu thuyết",
    example: "lược thuật nội dung chính của cuốn tiểu thuyết",
  },
  {
    word: "lưới",
    part_of_speech: "danh từ",
    meaning:
      "đồ đan bằng các loại sợi, có nhiều hình dáng và công dụng khác nhau, thường dùng để ngăn chắn, để đánh bắt cá, chim, v.v.: thả lưới đánh cá * rào bằng lưới mắt cáo * đưa bóng vào lưới",
    example: "thả lưới đánh cá * rào bằng lưới mắt cáo * đưa bóng vào lưới",
  },
  {
    word: "lưới",
    part_of_speech: "danh từ",
    meaning:
      "hệ thống tổ chức để vây bắt: sa lưới pháp luật * giăng lưới phục kích",
    example: "sa lưới pháp luật * giăng lưới phục kích",
  },
  {
    word: "lười",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái không thích, ngại làm việc, ít chịu cố gắng: lười học * lười suy nghĩ * con bé lười quá, chẳng chịu làm lụng gì!",
    example:
      "lười học * lười suy nghĩ * con bé lười quá, chẳng chịu làm lụng gì!",
  },
  {
    word: "lược thưa",
    part_of_speech: "danh từ",
    meaning:
      'lược có răng thưa, dùng để chải tóc; phân biệt với lược bí: "Nhớ ai lơ lửng đầu cầu, Lược thưa biếng chải, gương tàu biếng soi." (ca dao)',
    example:
      'Nhớ ai lơ lửng đầu cầu, Lược thưa biếng chải, gương tàu biếng soi." (ca dao)',
  },
  {
    word: "lười biếng",
    part_of_speech: "tính từ",
    meaning: "lười (nói khái quát): quen thói lười biếng",
    example: "quen thói lười biếng",
  },
  {
    word: "lưỡi",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận mềm trong miệng, dùng để đón và nếm thức ăn, và ở người còn dùng để phát âm: lắc đầu lè lưỡi * lưỡi không xương nhiều đường lắt léo (tng)",
    example: "lắc đầu lè lưỡi * lưỡi không xương nhiều đường lắt léo (tng)",
  },
  {
    word: "lưỡi",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận mỏng và sắc ở một số dụng cụ dùng để cắt, rạch, v.v.: lưỡi gươm * dao bị mẻ lưỡi * rèn một lưỡi a bằng ba lưỡi hái (tng)",
    example:
      "lưỡi gươm * dao bị mẻ lưỡi * rèn một lưỡi a bằng ba lưỡi hái (tng)",
  },
  {
    word: "lưỡi không xương",
    part_of_speech: "",
    meaning:
      "ví người nay nói thế này, mai lại nói thế khác một cách rất dễ dàng (ví như lưỡi không có xương muốn uốn thế nào cũng được): lưỡi không xương nhiều đường lắt léo (tng)",
    example: "lưỡi không xương nhiều đường lắt léo (tng)",
  },
  {
    word: "lưỡi lê",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận của súng, đầu nhọn thường lắp ở đầu nòng, dùng để đâm: lắp lưỡi lê vào nòng súng * lưỡi lê tuốt trần",
    example: "lắp lưỡi lê vào nòng súng * lưỡi lê tuốt trần",
  },
  {
    word: "lưới điện",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) hệ thống dây tải điện của thành phố hay quốc gia: lưới điện quốc gia * lưới điện 110 kilovolt",
    example: "lưới điện quốc gia * lưới điện 110 kilovolt",
  },
  {
    word: "lưỡi liềm",
    part_of_speech: "danh từ",
    meaning:
      "(trăng) hình cong giống như cái lưỡi liềm, vào những ngày đầu tháng và cuối tháng âm lịch: trăng lưỡi liềm",
    example: "trăng lưỡi liềm",
  },
  {
    word: "lười nhác",
    part_of_speech: "tính từ",
    meaning: "như lười biếng: hay đau yếu nên sinh lười nhác",
    example: "hay đau yếu nên sinh lười nhác",
  },
  {
    word: "lưới lửa",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) hoả lực dày đặc phủ lên một mục tiêu nào đó (trông như tấm lưới bằng lửa): vượt qua lưới lửa đại bác",
    example: "vượt qua lưới lửa đại bác",
  },
  {
    word: "lưỡi trai",
    part_of_speech: "danh từ",
    meaning: "bộ phận cứng chìa ra phía trước của một số loại mũ: mũ lưỡi trai",
    example: "mũ lưỡi trai",
  },
  {
    word: "lượm lặt",
    part_of_speech: "động từ",
    meaning:
      "nhặt mỗi chỗ, mỗi nơi một ít rồi gom góp lại (nói khái quát): lượm lặt từng cành củi",
    example: "lượm lặt từng cành củi",
  },
  {
    word: "lườm nguýt",
    part_of_speech: "động từ",
    meaning: "lườm và nguýt (nói khái quát): đưa mắt lườm nguýt chồng",
    example: "đưa mắt lườm nguýt chồng",
  },
  {
    word: "lươn",
    part_of_speech: "danh từ",
    meaning:
      "cá nước ngọt, thân tròn và dài như rắn, mắt nhỏ, da trơn có nhớt, màu nâu vàng, sống chui rúc trong bùn: cháo lươn * ti hí mắt lươn",
    example: "cháo lươn * ti hí mắt lươn",
  },
  {
    word: "lượm",
    part_of_speech: "động từ",
    meaning:
      "gom những bông lúa đã cắt và bó lại thành từng bó, thường vừa một chét tay: lượm lúa * lúa mới ngả chứ chưa lượm",
    example: "lượm lúa * lúa mới ngả chứ chưa lượm",
  },
  {
    word: "lượm",
    part_of_speech: "danh từ",
    meaning: "lượng bông lúa đã được lượm thành bó: một lượm lúa",
    example: "một lượm lúa",
  },
  {
    word: "lượm",
    part_of_speech: "động từ",
    meaning: "(Nam) nhặt: lượm được của rơi * đi lượm củi khô",
    example: "lượm được của rơi * đi lượm củi khô",
  },
  {
    word: "lượn lờ",
    part_of_speech: "động từ",
    meaning:
      "lượn đi lượn lại mãi một chỗ, không chịu rời: đàn bướm lượn lờ quanh khóm hoa * máy bay địch lượn lờ",
    example: "đàn bướm lượn lờ quanh khóm hoa * máy bay địch lượn lờ",
  },
  {
    word: "lườm",
    part_of_speech: "động từ",
    meaning:
      "đưa mắt nhìn ngang ai đó, tỏ ý tức giận, trách móc, đe doạ: đưa mắt lườm",
    example: "đưa mắt lườm",
  },
  {
    word: "lươn khươn",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) lôi thôi, không đứng đắn, không dứt khoát: ăn nói lươn khươn * làm ăn lươn khươn",
    example: "ăn nói lươn khươn * làm ăn lươn khươn",
  },
  {
    word: "lươn khươn",
    part_of_speech: "",
    meaning:
      "dây dưa, cố tình kéo dài, trì hoãn việc đáng phải làm ngay: lươn khươn mãi không chịu trả nợ",
    example: "lươn khươn mãi không chịu trả nợ",
  },
  {
    word: "lượn",
    part_of_speech: "danh từ",
    meaning:
      "lối hát đối đáp giữa trai và gái của dân tộc Tày, làn điệu phong phú: hát lượn",
    example: "hát lượn",
  },
  {
    word: "lượn",
    part_of_speech: "động từ",
    meaning:
      "di chuyển bằng cách chao nghiêng thân hoặc uốn mình theo đường vòng: rợp trời chim én lượn * máy bay lượn trên bầu trời * dòng sông lượn vòng chân núi",
    example:
      "rợp trời chim én lượn * máy bay lượn trên bầu trời * dòng sông lượn vòng chân núi",
  },
  {
    word: "lượn",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) đi qua qua lại lại một nơi nào đó, không dừng lại lúc nào cả: lượn phố * mấy kẻ lạ mặt cứ lượn qua lượn lại ngôi nhà ấy",
    example: "lượn phố * mấy kẻ lạ mặt cứ lượn qua lượn lại ngôi nhà ấy",
  },
  {
    word: "lượn",
    part_of_speech: "danh từ",
    meaning: "làn (sóng): bơi vượt qua từng lượn sóng",
    example: "bơi vượt qua từng lượn sóng",
  },
  {
    word: "lườn",
    part_of_speech: "danh từ",
    meaning:
      "khối cơ dày ở hai bên cột sống hoặc ở hai bên sườn: lườn gà * miếng thịt lườn * áo mặc hở lườn",
    example: "lườn gà * miếng thịt lườn * áo mặc hở lườn",
  },
  {
    word: "lườn",
    part_of_speech: "danh từ",
    meaning: "phần hông chìm dưới nước của thuyền, tàu: lườn thuyền",
    example: "lườn thuyền",
  },
  {
    word: "lươn lẹo",
    part_of_speech: "tính từ",
    meaning: "gian dối, lắt léo: ăn nói lươn lẹo * một kẻ lươn lẹo",
    example: "ăn nói lươn lẹo * một kẻ lươn lẹo",
  },
  {
    word: "lương",
    part_of_speech: "danh từ",
    meaning:
      "hàng dệt mỏng bằng tơ, ngày trước thường dùng để may áo dài đàn ông: áo lương",
    example: "áo lương",
  },
  {
    word: "lương",
    part_of_speech: "danh từ",
    meaning:
      "cái ăn dự trữ, thường là ngũ cốc như gạo, ngô, khoai, sắn...: kho lương * mang theo lương ăn đường",
    example: "kho lương * mang theo lương ăn đường",
  },
  {
    word: "lương",
    part_of_speech: "danh từ",
    meaning:
      "tiền công trả định kì cho người lao động: làm công ăn lương * được tăng lương",
    example: "làm công ăn lương * được tăng lương",
  },
  {
    word: "lương",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) người không theo đạo Kitô (nói khái quát); phân biệt với giáo: đoàn kết lương giáo",
    example: "đoàn kết lương giáo",
  },
  {
    word: "lương",
    part_of_speech: "tính từ",
    meaning: "Cái tốt, cái đẹp: lương tâm, lương thiện",
    example: "lương tâm, lương thiện",
  },
  {
    word: "lượng",
    part_of_speech: "danh từ",
    meaning:
      "mức độ nhiều ít, có thể xác định được bằng con số cụ thể: lượng mưa hằng năm * chở một lượng hàng lớn",
    example: "lượng mưa hằng năm * chở một lượng hàng lớn",
  },
  {
    word: "lượng",
    part_of_speech: "danh từ",
    meaning:
      "phạm trù triết học chỉ các thuộc tính của sự vật và hiện tượng trong thế giới khách quan về mặt khối lượng, kích thước, tốc độ, v.v.; phân biệt với chất: sự thay đổi về lượng dẫn đến sự thay đổi về chất",
    example: "sự thay đổi về lượng dẫn đến sự thay đổi về chất",
  },
  {
    word: "lượng",
    part_of_speech: "động từ",
    meaning:
      'tính toán, cân nhắc điều kiện chủ quan và khách quan để quyết định hành động cho phù hợp, cho có thể đạt được kết quả mong muốn: lượng sức mà làm * "Biết ai đặng gửi má đào, Biển sông dễ lượng, lòng sâu khó dò." (ca dao)',
    example:
      'lượng sức mà làm * "Biết ai đặng gửi má đào, Biển sông dễ lượng, lòng sâu khó dò." (ca dao)',
  },
  {
    word: "lượng",
    part_of_speech: "danh từ",
    meaning:
      "(phương ngữ) lạng (thường dùng nói về khối lượng của vàng, bạc): một lượng vàng",
    example: "một lượng vàng",
  },
  {
    word: "lượng",
    part_of_speech: "danh từ",
    meaning:
      "lòng bao dung, sẵn sàng tha thứ đối với kẻ có sai lầm, tội lỗi: mở lượng hải hà * lượng cả ơn sâu",
    example: "mở lượng hải hà * lượng cả ơn sâu",
  },
  {
    word: "lường",
    part_of_speech: "động từ",
    meaning:
      "đong chất rời, chất lỏng bằng một đồ đựng bất kì được chọn làm đơn vị: lường dầu * lường một yến gạo",
    example: "lường dầu * lường một yến gạo",
  },
  {
    word: "lường",
    part_of_speech: "động từ",
    meaning:
      "liệu tính trước, thường là điều không hay: lường hết mọi khả năng * biến hoá khôn lường",
    example: "lường hết mọi khả năng * biến hoá khôn lường",
  },
  {
    word: "lương dân",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người dân lành, lương thiện (nói khái quát): quân giặc giết hại lương dân",
    example: "quân giặc giết hại lương dân",
  },
  {
    word: "lưỡng cư",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như lưỡng thê: ếch nhái là động vật lưỡng cư",
    example: "ếch nhái là động vật lưỡng cư",
  },
  {
    word: "lương bổng",
    part_of_speech: "danh từ",
    meaning:
      "lương của quan lại, viên chức nhà nước (nói khái quát): lương bổng cũng kha khá",
    example: "lương bổng cũng kha khá",
  },
  {
    word: "lương duyên",
    part_of_speech: "danh từ",
    meaning: "(cũ, văn chương) tình duyên tốt đẹp: mối lương duyên",
    example: "mối lương duyên",
  },
  {
    word: "lưỡng dụng",
    part_of_speech: "tính từ",
    meaning:
      "có đồng thời hai tác dụng: nhà nổi lưỡng dụng ở đồng bằng sông Cửu Long",
    example: "nhà nổi lưỡng dụng ở đồng bằng sông Cửu Long",
  },
  {
    word: "lượng giác",
    part_of_speech: "danh từ",
    meaning: "lượng giác học (nói tắt): môn lượng giác",
    example: "môn lượng giác",
  },
  {
    word: "lượng giác",
    part_of_speech: "tính từ",
    meaning: "thuộc về lượng giác học: hàm số lượng giác",
    example: "hàm số lượng giác",
  },
  {
    word: "lương khoán",
    part_of_speech: "danh từ",
    meaning:
      "lương trả theo khối lượng và chất lượng công việc được giao, không tính theo thời gian: ăn lương khoán",
    example: "ăn lương khoán",
  },
  {
    word: "lượng hoá",
    part_of_speech: "động từ",
    meaning:
      "làm cho cụ thể ra bằng số lượng những đơn vị xác định để có thể đo đếm được: mức độ hư hại của tài sản có thể lượng hoá thành tiền",
    example: "mức độ hư hại của tài sản có thể lượng hoá thành tiền",
  },
  {
    word: "lưỡng khả",
    part_of_speech: "tính từ",
    meaning: "có đồng thời hai khả năng: hiện tượng lưỡng khả trong phát âm",
    example: "hiện tượng lưỡng khả trong phát âm",
  },
  {
    word: "lương lậu",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) lương (nói khái quát; thường hàm ý chê): lương lậu chẳng đáng là bao",
    example: "lương lậu chẳng đáng là bao",
  },
  {
    word: "lương khô",
    part_of_speech: "danh từ",
    meaning:
      "thức ăn làm sẵn, ở dạng khô, có thể dự trữ để ăn dần: đem lương khô đi ăn đường * bánh lương khô",
    example: "đem lương khô đi ăn đường * bánh lương khô",
  },
  {
    word: "lưỡng phân",
    part_of_speech: "động từ",
    meaning:
      "(từ một) phân ra thành hai theo những nét đối lập: phương pháp lưỡng phân",
    example: "phương pháp lưỡng phân",
  },
  {
    word: "lương hướng",
    part_of_speech: "danh từ",
    meaning: "(cũ, khẩu ngữ) như lương bổng: lương hướng chẳng được là bao",
    example: "lương hướng chẳng được là bao",
  },
  {
    word: "lưỡng lự",
    part_of_speech: "động từ",
    meaning:
      "còn đang suy tính xem nên hay không nên, chưa biết quyết định như thế nào cho đúng: còn lưỡng lự chưa biết nên đi hay ở",
    example: "còn lưỡng lự chưa biết nên đi hay ở",
  },
  {
    word: "lương tâm",
    part_of_speech: "danh từ",
    meaning:
      "yếu tố nội tâm tạo cho mỗi người khả năng tự đánh giá hành vi của mình về mặt đạo đức, và do đó tự điều chỉnh mọi hành vi của mình: lương tâm nghề nghiệp * lương tâm cắn rứt * kẻ vô lương tâm",
    example: "lương tâm nghề nghiệp * lương tâm cắn rứt * kẻ vô lương tâm",
  },
  {
    word: "lưỡng quyền",
    part_of_speech: "danh từ",
    meaning: "hai gò má: lưỡng quyền nhô cao",
    example: "lưỡng quyền nhô cao",
  },
  {
    word: "lưỡng thê",
    part_of_speech: "danh từ",
    meaning:
      "động vật có xương sống sinh ra ở nước nhưng sống ở trên cạn, như ếch, nhái, v.v.: động vật lưỡng thê * loài lưỡng thê",
    example: "động vật lưỡng thê * loài lưỡng thê",
  },
  {
    word: "lượng thứ",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) lấy sự rộng lượng ra mà bỏ qua cho (thường dùng trong lời xin lỗi với ý khiêm nhường): có gì sơ suất xin được lượng thứ",
    example: "có gì sơ suất xin được lượng thứ",
  },
  {
    word: "lượng tình",
    part_of_speech: "động từ",
    meaning: "xét đến tình cảm mà có sự châm chước: lượng tình tha thứ",
    example: "lượng tình tha thứ",
  },
  {
    word: "lương thiện",
    part_of_speech: "tính từ",
    meaning:
      "tốt lành, không làm điều gì trái với đạo đức và pháp luật: làm ăn lương thiện * sống lương thiện * người lương thiện",
    example: "làm ăn lương thiện * sống lương thiện * người lương thiện",
  },
  {
    word: "lương tri",
    part_of_speech: "danh từ",
    meaning:
      "khả năng hiểu biết, nhận thức đúng đắn điều phải trái, đúng sai hình thành ở con người qua thực tiễn cuộc sống: một kẻ thiếu lương tri * thức tỉnh lương tri",
    example: "một kẻ thiếu lương tri * thức tỉnh lương tri",
  },
  {
    word: "lướng vướng",
    part_of_speech: "tính từ",
    meaning:
      "cảm thấy có gì vướng víu, không thật thoải mái, tự nhiên: quần dài quá, đi lướng vướng * lòng còn lướng vướng nhiều điều",
    example: "quần dài quá, đi lướng vướng * lòng còn lướng vướng nhiều điều",
  },
  {
    word: "lượng tử",
    part_of_speech: "danh từ",
    meaning:
      "lượng hữu hạn và nhỏ nhất của năng lượng mà hệ vi mô có thể hấp thu hoặc phát ra: lí thuyết lượng tử",
    example: "lí thuyết lượng tử",
  },
  {
    word: "lượt",
    part_of_speech: "danh từ",
    meaning: "hàng tơ mỏng, dệt thưa: quần là áo lượt",
    example: "quần là áo lượt",
  },
  {
    word: "lượt",
    part_of_speech: "danh từ",
    meaning:
      "lần làm một việc gì: đọc mấy lượt mới hiểu * dạo qua một lượt * nhìn khắp lượt",
    example: "đọc mấy lượt mới hiểu * dạo qua một lượt * nhìn khắp lượt",
  },
  {
    word: "lượt",
    part_of_speech: "danh từ",
    meaning:
      "lần mỗi người làm cùng một loại việc theo thứ tự trước sau hoặc luân phiên: cắt lượt trực nhật * đợi gọi đến lượt mình",
    example: "cắt lượt trực nhật * đợi gọi đến lượt mình",
  },
  {
    word: "lượt",
    part_of_speech: "danh từ",
    meaning:
      "lớp vật mỏng trải đều trên khắp bề mặt một vật khác: bôi một lượt phấn * áo may hai lượt vải",
    example: "bôi một lượt phấn * áo may hai lượt vải",
  },
  {
    word: "lương thực",
    part_of_speech: "danh từ",
    meaning:
      "thức ăn có chất bột như gạo, ngô, khoai, sắn, v.v. (nói khái quát): dự trữ lương thực cho mùa lũ * lúa là cây lương thực chính của người Việt",
    example:
      "dự trữ lương thực cho mùa lũ * lúa là cây lương thực chính của người Việt",
  },
  {
    word: "lương y",
    part_of_speech: "danh từ",
    meaning: "thầy thuốc giỏi: bậc lương y",
    example: "bậc lương y",
  },
  {
    word: "lương y",
    part_of_speech: "danh từ",
    meaning:
      "thầy thuốc chữa bệnh bằng các phương pháp y học cổ truyền dân tộc hoặc bằng bài thuốc gia truyền: mời lương y đến chữa bệnh",
    example: "mời lương y đến chữa bệnh",
  },
  {
    word: "lượt đi",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) trận thi đấu đầu tiên (trong tổng số hai trận phải đấu) giữa hai đội bóng thuộc khuôn khổ vòng loại của một giải bóng đá; phân biệt với lượt về: trận lượt đi được đá trên sân nhà",
    example: "trận lượt đi được đá trên sân nhà",
  },
  {
    word: "lượt là",
    part_of_speech: "",
    meaning:
      'như là lượt: "Xưa kia em cũng lượt là, Bây giờ nó rách, nó ra thân tàn." (ca dao)',
    example:
      'Xưa kia em cũng lượt là, Bây giờ nó rách, nó ra thân tàn." (ca dao)',
  },
  {
    word: "lướt",
    part_of_speech: "động từ",
    meaning:
      "di chuyển một cách rất nhanh và nhẹ, ở sát ngay bên cạnh hoặc trên bề mặt: gió lướt qua những ngọn cỏ * thuyền lướt sóng ra khơi * một bóng người lướt qua",
    example:
      "gió lướt qua những ngọn cỏ * thuyền lướt sóng ra khơi * một bóng người lướt qua",
  },
  {
    word: "lướt",
    part_of_speech: "động từ",
    meaning:
      "làm rất nhanh, không dừng lại ở chi tiết, không kĩ: đọc lướt qua một lượt * nhìn lướt qua",
    example: "đọc lướt qua một lượt * nhìn lướt qua",
  },
  {
    word: "lướt",
    part_of_speech: "tính từ",
    meaning:
      "có vẻ yếu ớt, không khoẻ, không chắc, dễ bị ngã rạp xuống: cây lúa bị lướt * da xanh lướt",
    example: "cây lúa bị lướt * da xanh lướt",
  },
  {
    word: "lướp tướp",
    part_of_speech: "tính từ",
    meaning:
      "ở tình trạng bị rách tả tơi ra thành nhiều mảnh nhỏ, trông thảm hại: nón lá rách lướp tướp",
    example: "nón lá rách lướp tướp",
  },
  {
    word: "lướt sóng",
    part_of_speech: "",
    meaning:
      "môn thể thao dùng ván lướt đi trên sóng nhờ vào lực đẩy của sóng biển: vận động viên lướt sóng",
    example: "vận động viên lướt sóng",
  },
  {
    word: "lướt mướt",
    part_of_speech: "tính từ",
    meaning:
      "(ướt, khóc) nhiều đến mức đầm đìa những nước: khóc lướt mướt * câu chuyện tình lướt mướt",
    example: "khóc lướt mướt * câu chuyện tình lướt mướt",
  },
  {
    word: "lướt thướt",
    part_of_speech: "tính từ",
    meaning:
      "(quần áo) dài quá mức, trông không gọn, không đẹp: váy dài lướt thướt * quần áo lướt thướt",
    example: "váy dài lướt thướt * quần áo lướt thướt",
  },
  {
    word: "lướt thướt",
    part_of_speech: "tính từ",
    meaning:
      "(người) ướt đẫm, khiến cho nước từ trên tóc tai hoặc quần áo chảy xuống ròng ròng: người ướt lướt thướt",
    example: "người ướt lướt thướt",
  },
  {
    word: "lượt thượt",
    part_of_speech: "tính từ",
    meaning:
      "như lướt thướt (ng1; nhưng nghĩa mạnh hơn): bài diễn văn dài lượt thượt * váy áo lượt thượt",
    example: "bài diễn văn dài lượt thượt * váy áo lượt thượt",
  },
  {
    word: "lựu",
    part_of_speech: "danh từ",
    meaning:
      "cây nhỏ, lá mọc đối, hoa màu đỏ, quả chứa nhiều hạt mọng nước, ăn được, vỏ rễ dùng làm thuốc: quả lựu",
    example: "quả lựu",
  },
  {
    word: "lựu",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ, khẩu ngữ) lựu đạn (nói tắt): ném lựu",
    example: "ném lựu",
  },
  {
    word: "lưu",
    part_of_speech: "động từ",
    meaning:
      "ở lại hoặc giữ lại thêm một thời gian, chưa rời khỏi hoặc chưa để rời khỏi: ở lưu lại ít hôm * lưu khách ở lại * lưu hàng lại đợi giá cao",
    example: "ở lưu lại ít hôm * lưu khách ở lại * lưu hàng lại đợi giá cao",
  },
  {
    word: "lưu",
    part_of_speech: "động từ",
    meaning:
      "giữ lại, để lại lâu dài về sau, không mất đi hoặc không để mất đi: lưu công văn, giấy tờ * lưu đoạn văn bản vừa nhập * dấu chân còn lưu trên đất",
    example:
      "lưu công văn, giấy tờ * lưu đoạn văn bản vừa nhập * dấu chân còn lưu trên đất",
  },
  {
    word: "lưu chiểu",
    part_of_speech: "động từ",
    meaning:
      "(cơ quan nhà nước) lưu giữ lại theo quy định một số bản của mỗi tác phẩm đã phát hành để làm căn cứ đối chiếu, so sánh: sách nộp lưu chiểu",
    example: "sách nộp lưu chiểu",
  },
  {
    word: "lưu ban",
    part_of_speech: "động từ",
    meaning:
      "(học sinh) học lại lớp cũ vì sức học kém: học sinh lưu ban * bị lưu ban một năm",
    example: "học sinh lưu ban * bị lưu ban một năm",
  },
  {
    word: "lượt về",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) trận thi đấu cuối cùng (trong tổng số hai trận phải đấu) giữa hai đội bóng thuộc khuôn khổ vòng loại của một giải bóng đá; phân biệt với lượt đi: giành chiến thắng ở cả trận lượt đi và lượt về",
    example: "giành chiến thắng ở cả trận lượt đi và lượt về",
  },
  {
    word: "lưu cữu",
    part_of_speech: "động từ",
    meaning:
      "lưu lại, tích lại quá lâu ngày cái lẽ ra phải được xử lí, giải quyết từ lâu: món nợ lưu cữu từ đời này sang đời khác",
    example: "món nợ lưu cữu từ đời này sang đời khác",
  },
  {
    word: "lưu chuyển",
    part_of_speech: "động từ",
    meaning:
      "chuyển từ nơi này sang nơi khác theo một quá trình đều đặn và liên tục: lưu chuyển hàng hoá * lưu chuyển thông tin * tốc độ lưu chuyển",
    example: "lưu chuyển hàng hoá * lưu chuyển thông tin * tốc độ lưu chuyển",
  },
  {
    word: "lưu danh",
    part_of_speech: "động từ",
    meaning: "để lại tên tuổi và tiếng thơm sau khi chết: lưu danh thiên cổ",
    example: "lưu danh thiên cổ",
  },
  {
    word: "lưu bút",
    part_of_speech: "danh từ",
    meaning:
      "bút tích thể hiện những suy nghĩ, tình cảm, được giữ lại làm kỉ niệm trước khi chia tay: viết lưu bút * tập lưu bút thời học trò",
    example: "viết lưu bút * tập lưu bút thời học trò",
  },
  {
    word: "lưu đày",
    part_of_speech: "động từ",
    meaning:
      "(cũ) đày đi giam giữ, chịu khổ sai ở nơi xa (một hình phạt thời phong kiến): bị lưu đày ra vùng biên ải",
    example: "bị lưu đày ra vùng biên ải",
  },
  {
    word: "lưu diễn",
    part_of_speech: "động từ",
    meaning:
      "biểu diễn lưu động: chuyến lưu diễn xuyên Việt * ban nhạc đang lưu diễn ở châu âu",
    example: "chuyến lưu diễn xuyên Việt * ban nhạc đang lưu diễn ở châu âu",
  },
  {
    word: "lưu hành",
    part_of_speech: "động từ",
    meaning:
      "đưa ra sử dụng rộng rãi từ người này, nơi này qua người khác, nơi khác trong xã hội: lưu hành tiền giấy * cuốn sách bị cấm lưu hành",
    example: "lưu hành tiền giấy * cuốn sách bị cấm lưu hành",
  },
  {
    word: "lưu học sinh",
    part_of_speech: "danh từ",
    meaning: "học sinh ăn học ở nước ngoài: lưu học sinh Việt Nam ở Nhật Bản",
    example: "lưu học sinh Việt Nam ở Nhật Bản",
  },
  {
    word: "lựu đạn",
    part_of_speech: "danh từ",
    meaning:
      "vũ khí có vỏ cứng trong chứa chất nổ hoặc chất hoá học và bộ phận gây nổ, thường ném bằng tay: giật chốt lựu đạn * ném lựu đạn",
    example: "giật chốt lựu đạn * ném lựu đạn",
  },
  {
    word: "lưu động",
    part_of_speech: "động từ",
    meaning:
      "không ở nguyên một chỗ mà luôn luôn di chuyển, thay đổi địa bàn hoạt động: đoàn kịch lưu động * bán hàng lưu động",
    example: "đoàn kịch lưu động * bán hàng lưu động",
  },
  {
    word: "lưu giữ",
    part_of_speech: "động từ",
    meaning:
      "giữ lại lâu dài (để khi cần có thể sử dụng được): lưu giữ hồ sơ * lưu giữ bảo vật",
    example: "lưu giữ hồ sơ * lưu giữ bảo vật",
  },
  {
    word: "lưu giữ",
    part_of_speech: "động từ",
    meaning:
      "chuyển dữ liệu từ bộ nhớ tạm thời của máy tính đến một thiết bị lưu trữ lâu dài như đĩa cứng, đĩa quang, đĩa CD, v.v.: lưu giữ dữ liệu",
    example: "lưu giữ dữ liệu",
  },
  {
    word: "lưu lạc",
    part_of_speech: "động từ",
    meaning:
      'trôi dạt nay đây mai đó ở nơi xa lạ: sống lưu lạc * quãng đời lưu lạc * "Từ con lưu lạc quê người, Bèo trôi sóng vỗ, chốc mười lăm năm." (TKiều)',
    example:
      'sống lưu lạc * quãng đời lưu lạc * "Từ con lưu lạc quê người, Bèo trôi sóng vỗ, chốc mười lăm năm." (TKiều)',
  },
  {
    word: "lưu không",
    part_of_speech: "tính từ",
    meaning:
      "(khoảng đất) để trống ở xung quanh một công trình xây dựng, nhằm mục đích bảo vệ hoặc để tạo cảnh quan môi trường: đất lưu không để bảo vệ đê",
    example: "đất lưu không để bảo vệ đê",
  },
  {
    word: "lưu không",
    part_of_speech: "tính từ",
    meaning: "như khống chỉ: kí lưu không",
    example: "kí lưu không",
  },
  {
    word: "lưu li",
    part_of_speech: "danh từ",
    meaning: "ngọc quý có màu xanh biếc: viên ngọc lưu li",
    example: "viên ngọc lưu li",
  },
  {
    word: "lưu li",
    part_of_speech: "động từ",
    meaning:
      '(cũ, văn chương) lìa bỏ quê hương và phải trôi dạt nay đây mai đó ở nơi xa lạ do gặp cảnh ngộ ngang trái: "Ngọn bèo chân sóng lạc loài, Nghĩ mình vinh hiển, thương người lưu li." (TKiều)',
    example:
      'Ngọn bèo chân sóng lạc loài, Nghĩ mình vinh hiển, thương người lưu li." (TKiều)',
  },
  {
    word: "lưu loát",
    part_of_speech: "tính từ",
    meaning:
      "dễ dàng khi diễn đạt, không có chỗ nào ngập ngừng hoặc vấp váp: nói năng lưu loát * lời văn lưu loát",
    example: "nói năng lưu loát * lời văn lưu loát",
  },
  {
    word: "lưu ly",
    part_of_speech: "danh từ",
    meaning: "ngọc quý có màu xanh biếc: viên ngọc lưu li",
    example: "viên ngọc lưu li",
  },
  {
    word: "lưu ly",
    part_of_speech: "động từ",
    meaning:
      '(cũ, văn chương) lìa bỏ quê hương và phải trôi dạt nay đây mai đó ở nơi xa lạ do gặp cảnh ngộ ngang trái: "Ngọn bèo chân sóng lạc loài, Nghĩ mình vinh hiển, thương người lưu li." (TKiều)',
    example:
      'Ngọn bèo chân sóng lạc loài, Nghĩ mình vinh hiển, thương người lưu li." (TKiều)',
  },
  {
    word: "lưu niên",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái kéo dài hoặc được giữ lại từ năm này sang năm khác: đói lưu niên * cây ăn quả lưu niên",
    example: "đói lưu niên * cây ăn quả lưu niên",
  },
  {
    word: "lưu luyến",
    part_of_speech: "động từ",
    meaning:
      "không muốn xa rời hoặc dứt bỏ ngay vì còn thấy mến, thấy tiếc: buổi chia tay đầy lưu luyến",
    example: "buổi chia tay đầy lưu luyến",
  },
  {
    word: "lưu nhiệm",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) giữ lại để tiếp tục làm nhiệm vụ sau khi đã mãn hạn: đến tuổi nghỉ hưu nhưng được lưu nhiệm",
    example: "đến tuổi nghỉ hưu nhưng được lưu nhiệm",
  },
  {
    word: "lưu lượng",
    part_of_speech: "danh từ",
    meaning:
      "lượng chất lỏng, chất khí, điện, v.v. đi qua một nơi trong một đơn vị thời gian: lưu lượng nước * lưu lượng máu qua phổi bị giảm",
    example: "lưu lượng nước * lưu lượng máu qua phổi bị giảm",
  },
  {
    word: "lưu lượng",
    part_of_speech: "danh từ",
    meaning:
      "số lượng người, vật đi qua hay vận chuyển qua một nơi nào đó trong một khoảng thời gian nhất định: lưu lượng người và xe qua cầu ngày một lớn",
    example: "lưu lượng người và xe qua cầu ngày một lớn",
  },
  {
    word: "lưu manh",
    part_of_speech: "danh từ",
    meaning:
      "kẻ lười lao động, chuyên sống bằng trộm cắp, lừa đảo: kẻ lưu manh",
    example: "kẻ lưu manh",
  },
  {
    word: "lưu manh",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) xảo trá, lừa đảo theo cách của kẻ lưu manh: giở giọng lưu manh * thằng cha lưu manh lắm",
    example: "giở giọng lưu manh * thằng cha lưu manh lắm",
  },
  {
    word: "lưu niệm",
    part_of_speech: "động từ",
    meaning: "giữ lại để làm kỉ niệm: quà lưu niệm * sổ tay lưu niệm",
    example: "quà lưu niệm * sổ tay lưu niệm",
  },
  {
    word: "lưu tâm",
    part_of_speech: "động từ",
    meaning:
      "chú ý đến một cách đặc biệt: lưu tâm đến việc học hành của con cái * vấn đề không đáng lưu tâm",
    example:
      "lưu tâm đến việc học hành của con cái * vấn đề không đáng lưu tâm",
  },
  {
    word: "lưu tồn",
    part_of_speech: "động từ",
    meaning: "lưu lại, còn giữ được: sự giàu có không lưu tồn mãi mãi",
    example: "sự giàu có không lưu tồn mãi mãi",
  },
  {
    word: "lưu thông",
    part_of_speech: "động từ",
    meaning:
      "di chuyển thông suốt không bị ứ đọng, ngưng trệ: xe cộ lưu thông * vận động cơ thể cho máu dễ lưu thông",
    example: "xe cộ lưu thông * vận động cơ thể cho máu dễ lưu thông",
  },
  {
    word: "lưu thông",
    part_of_speech: "động từ",
    meaning:
      "trao đổi, lưu chuyển hàng hoá, dùng tiền tệ làm môi giới: lưu thông hàng hoá * hàng lậu lưu thông trên thị trường",
    example: "lưu thông hàng hoá * hàng lậu lưu thông trên thị trường",
  },
  {
    word: "lưu tốc",
    part_of_speech: "danh từ",
    meaning: "tốc độ của dòng chảy: lưu tốc nước lũ",
    example: "lưu tốc nước lũ",
  },
  {
    word: "lưu trú",
    part_of_speech: "động từ",
    meaning:
      "ở lại một thời gian, không ở hẳn: khách nước ngoài lưu trú ở Việt Nam * hết thời hạn lưu trú",
    example: "khách nước ngoài lưu trú ở Việt Nam * hết thời hạn lưu trú",
  },
  {
    word: "lưu thuỷ",
    part_of_speech: "danh từ",
    meaning: "một điệu ca cổ, nhịp điệu khoan thai: điệu hành vân, lưu thuỷ",
    example: "điệu hành vân, lưu thuỷ",
  },
  {
    word: "lưu vong",
    part_of_speech: "",
    meaning:
      "(cũ, hiếm) sống xa hẳn quê hương, do nghèo đói phải tha phương cầu thực.",
    example: "sống lưu vong ở nước ngoài * một chính khách lưu vong",
  },
  {
    word: "lưu trữ",
    part_of_speech: "động từ",
    meaning:
      "cất giữ và sắp xếp, hệ thống hoá tài liệu để tiện tra cứu, khai thác: lưu trữ hồ sơ * lưu trữ thông tin * kho lưu trữ",
    example: "lưu trữ hồ sơ * lưu trữ thông tin * kho lưu trữ",
  },
  {
    word: "lưu truyền",
    part_of_speech: "động từ",
    meaning:
      "truyền rộng ra trong nhiều người, hoặc truyền lại cho đời sau (thường nói về sự tích, tác phẩm văn học): câu chuyện lưu truyền trong dân gian * tiếng thơm lưu truyền sử sách",
    example:
      "câu chuyện lưu truyền trong dân gian * tiếng thơm lưu truyền sử sách",
  },
  {
    word: "lỵ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) kiết lị (nói tắt): ăn uống thiếu vệ sinh dễ sinh ra đi lị",
    example: "ăn uống thiếu vệ sinh dễ sinh ra đi lị",
  },
  {
    word: "lưu vực",
    part_of_speech: "danh từ",
    meaning:
      "vùng đất đai chịu ảnh hưởng của một con sông hoặc một hệ thống sông ngòi chảy qua: lưu vực sông Hồng * địa bàn dân cư ở vùng lưu vực",
    example: "lưu vực sông Hồng * địa bàn dân cư ở vùng lưu vực",
  },
  {
    word: "lưu ý",
    part_of_speech: "động từ",
    meaning:
      "để ý đến để xem xét, theo dõi hoặc giải quyết: vấn đề rất đáng lưu ý",
    example: "vấn đề rất đáng lưu ý",
  },
  {
    word: "lưu ý",
    part_of_speech: "động từ",
    meaning:
      "nhắc gợi, yêu cầu, làm cho người khác phải quan tâm chú ý đến: xin lưu ý các bạn về điều đó",
    example: "xin lưu ý các bạn về điều đó",
  },
  {
    word: "ly dị",
    part_of_speech: "động từ",
    meaning: "như li hôn: làm đơn li dị * hai vợ chồng đã li dị nhau",
    example: "làm đơn li dị * hai vợ chồng đã li dị nhau",
  },
  {
    word: "ly gián",
    part_of_speech: "động từ",
    meaning:
      "gây chia rẽ trong nội bộ đối phương: dùng kế li gián * tung tin xấu để li gián hai người",
    example: "dùng kế li gián * tung tin xấu để li gián hai người",
  },
  {
    word: "lý do",
    part_of_speech: "danh từ",
    meaning:
      "điều làm căn cứ được dùng để giải thích một việc nào đó: nghỉ học có lí do * viện đủ lí do để từ chối * tuyên bố lí do cuộc họp",
    example:
      "nghỉ học có lí do * viện đủ lí do để từ chối * tuyên bố lí do cuộc họp",
  },
  {
    word: "lý giải",
    part_of_speech: "động từ",
    meaning:
      "hiểu rõ, chỉ rõ ra cái lẽ của sự vật, sự việc: sự việc khó lí giải * lí giải sự hình thành và tồn tại của sự sống",
    example:
      "sự việc khó lí giải * lí giải sự hình thành và tồn tại của sự sống",
  },
  {
    word: "ly hôn",
    part_of_speech: "động từ",
    meaning:
      "(vợ chồng) bỏ nhau một cách hợp pháp: đơn li hôn * ra toà xin li hôn",
    example: "đơn li hôn * ra toà xin li hôn",
  },
  {
    word: "ly khai",
    part_of_speech: "động từ",
    meaning:
      "tách mình ra khỏi, lìa bỏ khỏi một tổ chức hay những tư tưởng, quan điểm chính trị nào đó: các phần tử li khai * một nước nhỏ li khai khỏi liên bang",
    example: "các phần tử li khai * một nước nhỏ li khai khỏi liên bang",
  },
  {
    word: "lý lẽ",
    part_of_speech: "danh từ",
    meaning:
      "điều nêu ra làm căn cứ để quyết định đúng sai, phải trái (nói khái quát): không đủ lí lẽ để bác bỏ lập luận đó",
    example: "không đủ lí lẽ để bác bỏ lập luận đó",
  },
  {
    word: "lý lịch",
    part_of_speech: "danh từ",
    meaning:
      "lai lịch và nói chung những điều cần biết về quá khứ của một người hay vật nào đó (nói tổng quát): bản lí lịch * thẩm tra lí lịch",
    example: "bản lí lịch * thẩm tra lí lịch",
  },
  {
    word: "ly tán",
    part_of_speech: "động từ",
    meaning: "rời xa nhau, phân tán mỗi người một ngả: cảnh gia đình li tán",
    example: "cảnh gia đình li tán",
  },
  {
    word: "lý luận",
    part_of_speech: "danh từ",
    meaning:
      "hệ thống những tư tưởng được khái quát từ kinh nghiệm thực tiễn, có tác dụng chỉ đạo thực tiễn: lí luận đi đôi với thực tiễn",
    example: "lí luận đi đôi với thực tiễn",
  },
  {
    word: "lý luận",
    part_of_speech: "danh từ",
    meaning:
      "những kiến thức được khái quát và hệ thống hoá trong một lĩnh vực nào đó (nói tổng quát): lí luận văn học * lí luận quân sự",
    example: "lí luận văn học * lí luận quân sự",
  },
  {
    word: "lý luận",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nói lí luận, giải thích bằng lí luận (thường hàm ý chê): chỉ giỏi lí luận",
    example: "chỉ giỏi lí luận",
  },
  {
    word: "lý sự cùn",
    part_of_speech: "tính từ",
    meaning:
      "(cũ, hiếm) rất vụ lợi trong quan hệ với mọi người, làm việc gì, với ai cũng tính toán về tiền nong, sao cho có lợi cho mình: con người lí tài",
    example: "con người lí tài",
  },
  {
    word: "ly kỳ",
    part_of_speech: "tính từ",
    meaning:
      "có những tình tiết lạ lùng, hấp dẫn, khêu gợi tính hiếu kì: câu chuyện li kì * một vụ án li kì, lắt léo",
    example: "câu chuyện li kì * một vụ án li kì, lắt léo",
  },
  {
    word: "lý sự",
    part_of_speech: "danh từ",
    meaning: "lí lẽ đưa ra chỉ cốt để tranh cãi: giở lí sự ra tranh cãi",
    example: "giở lí sự ra tranh cãi",
  },
  {
    word: "lý sự",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nói lí, nói lẽ, chỉ cốt để cãi: tính hay lí sự * chỉ giỏi lí sự",
    example: "tính hay lí sự * chỉ giỏi lí sự",
  },
  {
    word: "ly tâm",
    part_of_speech: "động từ",
    meaning: "hướng từ tâm của vòng tròn ra ngoài: lực li tâm",
    example: "lực li tâm",
  },
  {
    word: "ly thân",
    part_of_speech: "động từ",
    meaning:
      "(vợ chồng) không còn có quan hệ tình cảm và tình dục, do bất hoà: vợ chồng sống li thân",
    example: "vợ chồng sống li thân",
  },
  {
    word: "lý thuyết",
    part_of_speech: "danh từ",
    meaning:
      "kiến thức về lí luận (nói khái quát): lí thuyết phải gắn liền với thực tế * lí thuyết suông * thi lí thuyết",
    example:
      "lí thuyết phải gắn liền với thực tế * lí thuyết suông * thi lí thuyết",
  },
  {
    word: "lý thuyết",
    part_of_speech: "danh từ",
    meaning:
      "công trình xây dựng có hệ thống của trí tuệ, có tính chất giả thuyết và tổng hợp, nhằm giải thích một loại hiện tượng nào đó: lí thuyết về vụ nổ lớn của vũ trụ * lí thuyết lượng tử * lí thuyết tương đối",
    example:
      "lí thuyết về vụ nổ lớn của vũ trụ * lí thuyết lượng tử * lí thuyết tương đối",
  },
  {
    word: "lý số",
    part_of_speech: "danh từ",
    meaning:
      "các môn học của nhà nho xưa khảo sát lẽ biến hoá và việc bói toán (nói tổng quát); thường chỉ việc bói toán: đoán lí số",
    example: "đoán lí số",
  },
  {
    word: "lý liệu pháp",
    part_of_speech: "danh từ",
    meaning:
      "phương pháp phòng chữa bệnh bằng cách sử dụng các yếu tố vật lí như: ánh sáng, nhiệt, điện, và dùng xoa bóp, thể dục, v.v.: chữa bệnh bằng vật lí trí liệu",
    example: "chữa bệnh bằng vật lí trí liệu",
  },
  {
    word: "lý thú",
    part_of_speech: "tính từ",
    meaning:
      "có tác dụng làm cho người ta thấy thú vị và có ý nghĩa: trò chơi lí thú * câu chuyện thật lí thú",
    example: "trò chơi lí thú * câu chuyện thật lí thú",
  },
  {
    word: "lý trí",
    part_of_speech: "danh từ",
    meaning:
      "khả năng nhận thức sự vật bằng suy luận, khác với cảm giác, tình cảm: rèn luyện lí trí * sống có lí trí * hành động theo lí trí",
    example: "rèn luyện lí trí * sống có lí trí * hành động theo lí trí",
  },
  {
    word: "lý tính",
    part_of_speech: "danh từ",
    meaning:
      "giai đoạn cao của nhận thức, dựa trên sự suy luận để nắm bản chất và quy luật của sự vật; phân biệt với cảm tính: nhận thức lí tính",
    example: "nhận thức lí tính",
  },
  {
    word: "lý tưởng hoá",
    part_of_speech: "động từ",
    meaning:
      "làm cho trở nên hoàn hảo, tốt đẹp như trong tưởng tượng, trong khi sự thật không hoặc chưa được như vậy: lí tưởng hoá cuộc sống",
    example: "lí tưởng hoá cuộc sống",
  },
  {
    word: "lý tưởng",
    part_of_speech: "danh từ",
    meaning:
      "mục đích cao nhất, tốt đẹp nhất mà người ta muốn đạt tới: sống có lí tưởng * hi sinh cho một lí tưởng cao đẹp",
    example: "sống có lí tưởng * hi sinh cho một lí tưởng cao đẹp",
  },
  {
    word: "lý tưởng",
    part_of_speech: "tính từ",
    meaning:
      "hoàn hảo, tốt đẹp như được hình dung hoặc như trên lí thuyết: một hình mẫu lí tưởng * con người lí tưởng * độ bền lí tưởng",
    example: "một hình mẫu lí tưởng * con người lí tưởng * độ bền lí tưởng",
  },
  {
    word: "mã",
    part_of_speech: "danh từ",
    meaning:
      "đám lông đẹp, óng mượt ở cổ và gần đuôi của gà, chim trống trong thời kì thành thục sinh dục: gà mới trổ mã",
    example: "gà mới trổ mã",
  },
  {
    word: "mã",
    part_of_speech: "danh từ",
    meaning:
      '(Khẩu ngữ) vẻ bên ngoài, cái hình thức phô ra bên ngoài: mã nó thì làm được gì! * "Con gà tốt mã vì lông, Răng đen vì thuốc rượu nồng vì men." (Cdao)',
    example:
      'mã nó thì làm được gì! * "Con gà tốt mã vì lông, Răng đen vì thuốc rượu nồng vì men." (Cdao)',
  },
  {
    word: "mã",
    part_of_speech: "danh từ",
    meaning:
      "đồ làm bằng giấy giả như những đồ dùng thật, để đốt cúng cho người chết, theo tín ngưỡng dân gian: đốt mã",
    example: "đốt mã",
  },
  {
    word: "mã",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi một quân trong cờ tướng, cờ vua hay trong bài tam cúc, lấy hình con ngựa làm biểu tượng: ăn đôi mã * bộ ba xe, pháo, mã",
    example: "ăn đôi mã * bộ ba xe, pháo, mã",
  },
  {
    word: "mã",
    part_of_speech: "danh từ",
    meaning: "mã cân (nói tắt): mới cân được hai mã",
    example: "mới cân được hai mã",
  },
  {
    word: "mã",
    part_of_speech: "danh từ",
    meaning:
      "hệ thống kí hiệu quy ước, dùng vào việc truyền tin: giải mã * lập mã",
    example: "giải mã * lập mã",
  },
  {
    word: "mạ",
    part_of_speech: "danh từ",
    meaning:
      "cây lúa non được gieo ở ruộng riêng (ruộng mạ), sau một thời gian nhất định sẽ được nhổ lên để cấy lại: gieo mạ * nhổ mạ * màu xanh lá mạ",
    example: "gieo mạ * nhổ mạ * màu xanh lá mạ",
  },
  {
    word: "mạ",
    part_of_speech: "động từ",
    meaning:
      "phủ lên bề mặt một sản phẩm nào đó một lớp mỏng, thường là kim loại, để trang trí hoặc chống gỉ, chống ăn mòn: gáy sách mạ vàng * mạ kền * chuôi dao mạ bạc",
    example: "gáy sách mạ vàng * mạ kền * chuôi dao mạ bạc",
  },
  {
    word: "mà",
    part_of_speech: "danh từ",
    meaning:
      "hang của một số loài như cua, ếch, lươn, v.v.: ếch nằm mà * mà cua",
    example: "ếch nằm mà * mà cua",
  },
  {
    word: "mà",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là không phù hợp với điều vừa nói đến: nói mà không làm * mệt mà không được nghỉ * khó thế mà vẫn làm được",
    example:
      "nói mà không làm * mệt mà không được nghỉ * khó thế mà vẫn làm được",
  },
  {
    word: "mà",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là một mặt khác, bổ sung cho điều vừa nói đến: tốt mà rẻ * chẳng hay mà cũng chẳng dở",
    example: "tốt mà rẻ * chẳng hay mà cũng chẳng dở",
  },
  {
    word: "mà",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là mục đích của việc vừa nói đến: tìm việc mà làm * nói cho mà hiểu * đau chân nhưng phải cố mà đi",
    example: "tìm việc mà làm * nói cho mà hiểu * đau chân nhưng phải cố mà đi",
  },
  {
    word: "mà",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là kết quả, hậu quả của điều vừa nói đến: nhờ chăm chỉ mà học hành tiến bộ * thấy mà ghét * ai nói gì mà nó tự ái",
    example:
      "nhờ chăm chỉ mà học hành tiến bộ * thấy mà ghét * ai nói gì mà nó tự ái",
  },
  {
    word: "mà",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là giả thiết, nêu lên để từ đó rút ra một kết luận, một nhận định: bây giờ mà đến thì cũng muộn rồi * tôi mà là anh tôi sẽ nói khác",
    example: "bây giờ mà đến thì cũng muộn rồi * tôi mà là anh tôi sẽ nói khác",
  },
  {
    word: "mà",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra là nội dung thuyết minh cho ý vừa nói đến: dễ gì mà hiểu hết * may mà đã chuẩn bị đầy đủ cả * cố gắng mà học cho giỏi",
    example:
      "dễ gì mà hiểu hết * may mà đã chuẩn bị đầy đủ cả * cố gắng mà học cho giỏi",
  },
  {
    word: "mà",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị điều sắp nêu ra thuyết minh đối tượng, sự vật, sự việc vừa nói đến: người mà tôi sắp kể là một nhà văn nổi tiếng",
    example: "người mà tôi sắp kể là một nhà văn nổi tiếng",
  },
  {
    word: "mà",
    part_of_speech: "trợ từ",
    meaning:
      "(Khẩu ngữ) từ dùng ở cuối câu trong lối nói lửng, biểu thị ý khẳng định - thuyết phục hoặc giải thích, với một hàm ý để cho người đối thoại tự suy ra: đã bảo mà! * chỉ một chốc là xong thôi mà!",
    example: "đã bảo mà! * chỉ một chốc là xong thôi mà!",
  },
  {
    word: "mả",
    part_of_speech: "danh từ",
    meaning: "(Khẩu ngữ) mộ: bốc mả * mồ yên mả đẹp",
    example: "bốc mả * mồ yên mả đẹp",
  },
  {
    word: "mả",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) khả năng làm được việc gì đó hay xảy ra việc gì đó, được coi là do tác động của thế đất nơi đặt mồ mả tổ tiên, theo mê tín: nhà này có mả làm quan",
    example: "nhà này có mả làm quan",
  },
  {
    word: "mả",
    part_of_speech: "tính từ",
    meaning: "(Khẩu ngữ) tài, giỏi: con mèo bắt chuột rất mả",
    example: "con mèo bắt chuột rất mả",
  },
  {
    word: "má",
    part_of_speech: "danh từ",
    meaning:
      "phần hai bên mặt, từ mũi và miệng đến tai và ở phía dưới mắt: má lúm đồng tiền * gò má cao * đánh phấn hồng lên hai gò má",
    example: "má lúm đồng tiền * gò má cao * đánh phấn hồng lên hai gò má",
  },
  {
    word: "má",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận của một số vật, thường phẳng và có vị trí đối xứng nhau ở hai bên: má phanh * má giày",
    example: "má phanh * má giày",
  },
  {
    word: "ma ăn cỗ",
    part_of_speech: "",
    meaning:
      "ví việc làm vụng trộm khéo léo đến mức không để lại dấu vết gì, khiến người khác khó mà biết được: ai biết được ma ăn cỗ",
    example: "ai biết được ma ăn cỗ",
  },
  {
    word: "ma",
    part_of_speech: "danh từ",
    meaning: "người đã chết, đã thuộc về cõi âm: đi đưa ma",
    example: "đi đưa ma",
  },
  {
    word: "ma",
    part_of_speech: "danh từ",
    meaning:
      "sự hiện hình của người chết, theo mê tín: trẻ con hay sợ ma * đi đêm lắm có ngày gặp ma (tng)",
    example: "trẻ con hay sợ ma * đi đêm lắm có ngày gặp ma (tng)",
  },
  {
    word: "ma",
    part_of_speech: "danh từ",
    meaning:
      '(khẩu ngữ) người bất kì nào đó: chẳng có ma nào ở đấy hết * "Bực mình chẳng dám nói ra, Muốn đi ăn cỗ chẳng ma nào mời." (ca dao)',
    example:
      'chẳng có ma nào ở đấy hết * "Bực mình chẳng dám nói ra, Muốn đi ăn cỗ chẳng ma nào mời." (ca dao)',
  },
  {
    word: "ma",
    part_of_speech: "tính từ",
    meaning:
      "không có thật, chỉ có trên sổ sách hoặc báo cáo do bịa ra, nhằm che giấu điều gì: những con số ma trong sổ sách, chứng từ * lập công ti ma để mua bán hoá đơn",
    example:
      "những con số ma trong sổ sách, chứng từ * lập công ti ma để mua bán hoá đơn",
  },
  {
    word: "ma chê quỷ hờn",
    part_of_speech: "",
    meaning:
      "ví người xấu xí đến mức ma quỷ cũng phải chê, phải sợ (thường nói về người phụ nữ): xấu đến ma chê quỷ hờn",
    example: "xấu đến ma chê quỷ hờn",
  },
  {
    word: "ma chay",
    part_of_speech: "danh từ",
    meaning:
      "lễ chôn cất và cúng người chết, theo phong tục cổ truyền (nói khái quát): lo liệu việc ma chay",
    example: "lo liệu việc ma chay",
  },
  {
    word: "mã cân",
    part_of_speech: "danh từ",
    meaning:
      "khối lượng được cân trong một lần cân (thường nói về khối lượng lớn): để riêng từng mã cân",
    example: "để riêng từng mã cân",
  },
  {
    word: "ma chê quỉ hờn",
    part_of_speech: "",
    meaning:
      "ví người xấu xí đến mức ma quỷ cũng phải chê, phải sợ (thường nói về người phụ nữ): xấu đến ma chê quỷ hờn",
    example: "xấu đến ma chê quỷ hờn",
  },
  {
    word: "má đào",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) má hồng như hoa đào; dùng để chỉ người con gái đẹp: "Bấy lâu nghe tiếng má đào, Mắt xanh chẳng để ai vào, có không?" (TKiều)',
    example:
      'Bấy lâu nghe tiếng má đào, Mắt xanh chẳng để ai vào, có không?" (TKiều)',
  },
  {
    word: "ma giáo",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) xảo trá, bịp bợm: giở trò ma giáo",
    example: "giở trò ma giáo",
  },
  {
    word: "mã hoá",
    part_of_speech: "động từ",
    meaning:
      "chuyển thành mã để truyền, xử lí hoặc lưu trữ tin: mã hoá bức điện mật",
    example: "mã hoá bức điện mật",
  },
  {
    word: "má hồng",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) má đỏ hồng; dùng để chỉ người con gái đẹp: phận má hồng * "Lạ gì bỉ sắc tư phong, Trời xanh quen thói má hồng đánh ghen." (TKiều)',
    example:
      'phận má hồng * "Lạ gì bỉ sắc tư phong, Trời xanh quen thói má hồng đánh ghen." (TKiều)',
  },
  {
    word: "mã hiệu",
    part_of_speech: "danh từ",
    meaning:
      "kí hiệu quy ước dùng cho từng loại sản phẩm công nghiệp: loại máy mang mã hiệu CH-5",
    example: "loại máy mang mã hiệu CH-5",
  },
  {
    word: "ma két",
    part_of_speech: "danh từ",
    meaning: "mẫu vẽ hoặc mô hình của vật sẽ chế tạo: vẽ ma két",
    example: "vẽ ma két",
  },
  {
    word: "ma két",
    part_of_speech: "danh từ",
    meaning: "mẫu dự kiến về hình thức trình bày một bản in: lên ma két báo",
    example: "lên ma két báo",
  },
  {
    word: "ma lem",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) con ma bẩn thỉu, xấu xí; thường dùng để ví người xấu hoặc bẩn quá: xấu như ma lem * người lấm như ma lem",
    example: "xấu như ma lem * người lấm như ma lem",
  },
  {
    word: "ma lực",
    part_of_speech: "danh từ",
    meaning:
      "sức cám dỗ, lôi cuốn mạnh mẽ, dường như có gì thần bí, khiến người ta có cảm giác như bị mê hoặc khó cưỡng lại được: bị quyến rũ bởi ma lực của đồng tiền * một người đàn bà có ma lực",
    example:
      "bị quyến rũ bởi ma lực của đồng tiền * một người đàn bà có ma lực",
  },
  {
    word: "ma mị",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như ma giáo: ánh mắt ma mị",
    example: "ánh mắt ma mị",
  },
  {
    word: "ma lanh",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) khôn ranh, có nhiều mánh khoé, mưu mẹo để xoay xở tìm lợi thế hoặc lợi lộc riêng cho mình (hàm ý chê): anh chàng cũng ma lanh lắm đấy!",
    example: "anh chàng cũng ma lanh lắm đấy!",
  },
  {
    word: "mà lại",
    part_of_speech: "",
    meaning: "như mà (ngII): đã bảo thôi mà lại!",
    example: "đã bảo thôi mà lại!",
  },
  {
    word: "mà lại",
    part_of_speech: "",
    meaning:
      "tổ hợp dùng cuối câu để biểu thị ý đã nói đến trước đó hoặc sẽ nói ngay sau đó là điều tất nhiên, không có gì lạ cả: chuyện, học đêm học ngày mà lại, làm gì không đỗ!",
    example: "chuyện, học đêm học ngày mà lại, làm gì không đỗ!",
  },
  {
    word: "mã lực",
    part_of_speech: "danh từ",
    meaning: "đơn vị đo công suất cũ, bằng 736 watt: động cơ 10 mã lực",
    example: "động cơ 10 mã lực",
  },
  {
    word: "ma men",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) rượu, sức cám dỗ ghê gớm của rượu, ví như một con ma: làm bạn với ma men",
    example: "làm bạn với ma men",
  },
  {
    word: "ma mộc",
    part_of_speech: "danh từ",
    meaning: "ma ở trong gỗ, theo mê tín: bị ma mộc đè",
    example: "bị ma mộc đè",
  },
  {
    word: "ma mút",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) con ma có mặt mũi rất khó coi; thường dùng để ví người trông xấu xí quá mức: xấu như ma mút * trông chẳng khác gì con ma mút",
    example: "xấu như ma mút * trông chẳng khác gì con ma mút",
  },
  {
    word: "ma mãnh",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) ma (nói khái quát; hàm ý coi thường): không tin chuyện ma mãnh",
    example: "không tin chuyện ma mãnh",
  },
  {
    word: "ma mãnh",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) tinh ranh, quỷ quyệt: kẻ ma mãnh * giở thói ma mãnh",
    example: "kẻ ma mãnh * giở thói ma mãnh",
  },
  {
    word: "má phanh",
    part_of_speech: "danh từ",
    meaning:
      "vật có thể điều khiển cho áp sát vào một bộ phận của vật đang chuyển động để làm ngừng hoặc làm chậm lại: má phanh xe đạp * má phanh đã bị mòn",
    example: "má phanh xe đạp * má phanh đã bị mòn",
  },
  {
    word: "mã não",
    part_of_speech: "danh từ",
    meaning:
      "đá quý có nhiều vân màu đẹp, rất cứng, dùng làm đồ trang sức, làm cối giã trong phòng thí nghiệm: vòng mã não",
    example: "vòng mã não",
  },
  {
    word: "ma quái",
    part_of_speech: "danh từ",
    meaning: "ma và quái vật (nói khái quát): loài ma quái * chuyện ma quái",
    example: "loài ma quái * chuyện ma quái",
  },
  {
    word: "ma quái",
    part_of_speech: "tính từ",
    meaning:
      "có tính chất bí ẩn, có vẻ khó hiểu đến mức đáng sợ: thủ đoạn ma quái",
    example: "thủ đoạn ma quái",
  },
  {
    word: "má phấn",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) má có đánh phấn; dùng để chỉ sắc đẹp của người phụ nữ hoặc để chỉ người con gái đẹp: "Quyết ngay biện bạch một bề, Dạy cho má phấn lại về lầu xanh!" (TKiều)',
    example:
      'Quyết ngay biện bạch một bề, Dạy cho má phấn lại về lầu xanh!" (TKiều)',
  },
  {
    word: "ma sát",
    part_of_speech: "danh từ",
    meaning:
      "tính cản trở sự chuyển động của các vật dọc theo bề mặt tiếp xúc của các vật đó: lực ma sát * làm giảm ma sát",
    example: "lực ma sát * làm giảm ma sát",
  },
  {
    word: "ma tà",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như tà ma: trừ ma tà",
    example: "trừ ma tà",
  },
  {
    word: "mã tà",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ, cũ) lính cảnh sát thời Pháp thuộc: lính mã tà",
    example: "lính mã tà",
  },
  {
    word: "mã tấu",
    part_of_speech: "danh từ",
    meaning:
      "dao dài, to bản, lưỡi cong, cán ngắn, dùng làm khí giới: cây mã tấu",
    example: "cây mã tấu",
  },
  {
    word: "mã số",
    part_of_speech: "danh từ",
    meaning:
      "kí hiệu bằng chữ số dùng trong một hệ thống sắp xếp, phân loại: hòm thư mang mã số E-85",
    example: "hòm thư mang mã số E-85",
  },
  {
    word: "mã thượng",
    part_of_speech: "tính từ",
    meaning:
      "(văn chương) có tư thế hiên ngang (như của kị sĩ ngồi trên lưng ngựa): một trang mã thượng",
    example: "một trang mã thượng",
  },
  {
    word: "ma thuật",
    part_of_speech: "danh từ",
    meaning:
      "sức mạnh thần bí của con người có thể tác động lên sự vật để tạo ra những phép lạ (như làm mưa, làm gió, làm phúc, gây hoạ, v.v.), theo niềm tin của hình thái tôn giáo nguyên thuỷ.",
    example: "ma thuật của thầy phù thuỷ * trò ma thuật",
  },
  {
    word: "ma tuý",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi chung các chất kích thích, gây trạng thái ngây ngất, đờ đẫn, dùng quen thành nghiện như thuốc phiện, heroin, v.v.: nghiện ma tuý * phạm tội buôn bán ma tuý",
    example: "nghiện ma tuý * phạm tội buôn bán ma tuý",
  },
  {
    word: "ma xó",
    part_of_speech: "danh từ",
    meaning:
      "ma thờ ở xó nhà ở một số địa phương miền núi, được coi là có thể biết rõ mọi chuyện trong nhà.",
    example: "thằng ma xó ấy thì cái gì chả biết!",
  },
  {
    word: "mác",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, hoặc kng) nhãn hiệu: đồng hồ mác Thuỵ Sĩ * dán mác của nước ngoài",
    example: "đồng hồ mác Thuỵ Sĩ * dán mác của nước ngoài",
  },
  {
    word: "mác",
    part_of_speech: "danh từ",
    meaning:
      "con số đặc trưng cho chỉ tiêu dùng để xếp loại (ở một số loại sản phẩm): xi măng mác 500",
    example: "xi măng mác 500",
  },
  {
    word: "mạc",
    part_of_speech: "động từ",
    meaning: "(cũ, hiếm) viết hay vẽ phỏng theo bản chính: mạc chữ * mạc tranh",
    example: "mạc chữ * mạc tranh",
  },
  {
    word: "mạch lạc",
    part_of_speech: "danh từ",
    meaning:
      "trật tự hợp lí giữa các ý, các phần trong nội dung diễn đạt: câu cú lộn xộn, chẳng có mạch lạc gì!",
    example: "câu cú lộn xộn, chẳng có mạch lạc gì!",
  },
  {
    word: "mạch lạc",
    part_of_speech: "tính từ",
    meaning:
      "(cách diễn đạt) có từng đoạn, từng ý rành mạch và gãy gọn: văn viết không mạch lạc * sắp xếp lại các ý cho mạch lạc",
    example: "văn viết không mạch lạc * sắp xếp lại các ý cho mạch lạc",
  },
  {
    word: "mạch",
    part_of_speech: "danh từ",
    meaning:
      "đường ống dẫn máu ở động vật hay dẫn nhựa ở thực vật: mạch máu * mạch gỗ",
    example: "mạch máu * mạch gỗ",
  },
  {
    word: "mạch",
    part_of_speech: "danh từ",
    meaning:
      "nhịp đập của động mạch do những đợt máu bơm liên tiếp từ tim tạo ra, có thể sờ mà nhận biết được: mạch đập chậm * bắt mạch kê đơn",
    example: "mạch đập chậm * bắt mạch kê đơn",
  },
  {
    word: "mạch",
    part_of_speech: "danh từ",
    meaning: "đường nước chảy ngầm dưới đất: mạch nước * mạch ngầm",
    example: "mạch nước * mạch ngầm",
  },
  {
    word: "mạch",
    part_of_speech: "danh từ",
    meaning:
      "hệ thống các thiết bị điện được nối với nhau bằng dây dẫn để dòng điện có thể đi qua: mạch điện xoay chiều * ngắt mạch * đóng mạch điện",
    example: "mạch điện xoay chiều * ngắt mạch * đóng mạch điện",
  },
  {
    word: "mạch",
    part_of_speech: "danh từ",
    meaning: "đường vữa giữa các viên gạch xây: mạch vữa * trát không kín mạch",
    example: "mạch vữa * trát không kín mạch",
  },
  {
    word: "mạch",
    part_of_speech: "danh từ",
    meaning: "đường tạo thành khi cưa: mạch cưa * lưỡi cưa bị mắc trong mạch",
    example: "mạch cưa * lưỡi cưa bị mắc trong mạch",
  },
  {
    word: "mạch",
    part_of_speech: "danh từ",
    meaning:
      "đường chạy dài liên tục hình thành do vật nối tiếp nhau không đứt đoạn: mạch than * mạch giao thông * mạch núi chạy dài",
    example: "mạch than * mạch giao thông * mạch núi chạy dài",
  },
  {
    word: "mạch",
    part_of_speech: "danh từ",
    meaning:
      "hệ thống ý được phát triển liên tục thành chuỗi, thành dòng: mạch văn * tiếng nổ làm dứt hẳn mạch suy nghĩ",
    example: "mạch văn * tiếng nổ làm dứt hẳn mạch suy nghĩ",
  },
  {
    word: "mách",
    part_of_speech: "động từ",
    meaning:
      "nói cho người khác biết điều đối với người đó là cần thiết, có lợi: mách cho một nước cờ hay",
    example: "mách cho một nước cờ hay",
  },
  {
    word: "mách",
    part_of_speech: "động từ",
    meaning:
      "(Nam méc) nói cho người trên biết lỗi của người dưới: mách cô giáo * doạ sẽ mách mẹ",
    example: "mách cô giáo * doạ sẽ mách mẹ",
  },
  {
    word: "mạch lươn",
    part_of_speech: "danh từ",
    meaning:
      "nhọt ở đầu trẻ con ăn luồn dưới da thành những đường hầm dài: cháu bé bị lên mạch lươn",
    example: "cháu bé bị lên mạch lươn",
  },
  {
    word: "mách lẻo",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) nói cho người này biết chuyện riêng của người khác một cách không cần thiết, thường là với dụng ý không tốt: tính hay ngồi lê mách lẻo * đôi co mách lẻo",
    example: "tính hay ngồi lê mách lẻo * đôi co mách lẻo",
  },
  {
    word: "mạch máu",
    part_of_speech: "danh từ",
    meaning: "ống dẫn máu trong cơ thể động vật: tắc mạch máu",
    example: "tắc mạch máu",
  },
  {
    word: "mách bảo",
    part_of_speech: "động từ",
    meaning:
      "mách cho, nói cho biết điều cần thiết (nói khái quát): được bạn bè mách bảo * linh cảm mách bảo",
    example: "được bạn bè mách bảo * linh cảm mách bảo",
  },
  {
    word: "mạch ngầm",
    part_of_speech: "danh từ",
    meaning:
      "mạch nước đi ngầm dưới lòng đất hoặc công trình xây dựng, thường gây hại cho công trình: phát hiện nhiều mạch ngầm trong thân đê",
    example: "phát hiện nhiều mạch ngầm trong thân đê",
  },
  {
    word: "mách qué",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có tính chất thiếu đứng đắn, thiếu nghiêm túc đến mức đáng khinh (thường dùng nói về cách nói năng): ăn nói mách qué * giở những trò mách qué",
    example: "ăn nói mách qué * giở những trò mách qué",
  },
  {
    word: "mạch sủi",
    part_of_speech: "danh từ",
    meaning:
      "mạch nước ngầm sủi lên ở thành hoặc đáy các công trình xây dựng, do áp lực nước quá lớn, thường gây hại cho công trình: chân đê xuất hiện nhiều mạch sủi",
    example: "chân đê xuất hiện nhiều mạch sủi",
  },
  {
    word: "mách nước",
    part_of_speech: "động từ",
    meaning:
      "chỉ cho ai đó cách làm có lợi, thường là để gỡ thế bí, giải quyết khó khăn: mách nước một thế cờ",
    example: "mách nước một thế cờ",
  },
  {
    word: "mãi",
    part_of_speech: "phụ từ",
    meaning:
      "một cách liên tục, kéo dài ra như không muốn ngừng, không muốn dứt: trời cứ mưa mãi * nghĩ mãi vẫn không ra * nói mãi mà nó vẫn không hiểu",
    example:
      "trời cứ mưa mãi * nghĩ mãi vẫn không ra * nói mãi mà nó vẫn không hiểu",
  },
  {
    word: "mãi",
    part_of_speech: "phụ từ",
    meaning:
      "ở tận một địa điểm nào đó khá xa hoặc đến tận một thời điểm nào đó sau một khoảng thời gian khá lâu sự việc mới xảy ra hoặc mới kết thúc: mãi hôm qua chị ấy mới đi * nhà ở mãi cuối làng * mãi gần sáng mới ngủ được",
    example:
      "mãi hôm qua chị ấy mới đi * nhà ở mãi cuối làng * mãi gần sáng mới ngủ được",
  },
  {
    word: "mài",
    part_of_speech: "động từ",
    meaning:
      "làm cho nhẵn, cho sắc hay có kích thước chính xác hơn bằng cách cho cọ xát vào vật rất cứng: mài dao kéo * có công mài sắt có ngày nên kim (tng)",
    example: "mài dao kéo * có công mài sắt có ngày nên kim (tng)",
  },
  {
    word: "mái",
    part_of_speech: "danh từ",
    meaning:
      "phần che phủ phía trên cùng của ngôi nhà: mái ngói * xây nhà mái bằng * nhà bị tốc mái",
    example: "mái ngói * xây nhà mái bằng * nhà bị tốc mái",
  },
  {
    word: "mái",
    part_of_speech: "danh từ",
    meaning:
      "phần mặt đất có hình dốc thoai thoải, từ đỉnh trở xuống trông giống như mái nhà: mái đê * mái núi * bạt mái ta luy",
    example: "mái đê * mái núi * bạt mái ta luy",
  },
  {
    word: "mái",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ ngôi nhà, về mặt là nơi ăn ở, sinh sống của mọi người trong một gia đình: mái ấm gia đình",
    example: "mái ấm gia đình",
  },
  {
    word: "mái",
    part_of_speech: "danh từ",
    meaning:
      '(văn chương) phần tóc ở trên đầu: "Những là đắp nhớ, đổi sầu, Tuyết sương nhuốm nửa mái đầu hoa râm." (TKiều)',
    example:
      'Những là đắp nhớ, đổi sầu, Tuyết sương nhuốm nửa mái đầu hoa râm." (TKiều)',
  },
  {
    word: "mái",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như chèo: xuôi chèo mát mái (tng)",
    example: "xuôi chèo mát mái (tng)",
  },
  {
    word: "mái",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) chum: mấy mái nước đầy ắp",
    example: "mấy mái nước đầy ắp",
  },
  {
    word: "mái",
    part_of_speech: "tính từ",
    meaning: "(chim, gà) thuộc giống cái; phân biệt với trống: gà mái",
    example: "gà mái",
  },
  {
    word: "mái",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) con gà mái: nuôi mấy mái đẻ",
    example: "nuôi mấy mái đẻ",
  },
  {
    word: "mái",
    part_of_speech: "tính từ",
    meaning: "(nước da) xám xanh như màu chì, vẻ ốm yếu, bệnh tật: da xanh mái",
    example: "da xanh mái",
  },
  {
    word: "mai",
    part_of_speech: "danh từ",
    meaning:
      "cây cùng loại với tre, gióng dài, thành dày, đốt lặn, lá rất to, thường được dùng làm nhà, làm ống đựng nước, v.v.",
    example: "mai vàng",
  },
  {
    word: "mai",
    part_of_speech: "danh từ",
    meaning:
      "cây nhỏ, hoa màu vàng hoặc trắng, thường trồng làm cảnh: mai vàng",
    example: "mai rùa * mai đồi mồi * lột mai cua",
  },
  {
    word: "mai",
    part_of_speech: "danh từ",
    meaning:
      "lớp vỏ cứng bảo vệ cơ thể của một số loài động vật: mai rùa * mai đồi mồi * lột mai cua",
    example: "mai thuyền",
  },
  {
    word: "mai",
    part_of_speech: "danh từ",
    meaning: "mái khum trên thuyền, trên cáng (hình giống mai rùa): mai thuyền",
    example: "mai dài hơn thuổng (tng)",
  },
  {
    word: "mai",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ gồm một lưỡi sắt nặng, to và phẳng, tra vào cán dài, dùng để đào, xắn đất: mai dài hơn thuổng (tng)",
    example: "bà mai * nhờ người làm mai",
  },
  {
    word: "mai",
    part_of_speech: "danh từ",
    meaning: "(Nam) mối: bà mai * nhờ người làm mai",
    example: "giọt sương mai * nắng mai",
  },
  {
    word: "mai",
    part_of_speech: "danh từ",
    meaning: "lúc sáng sớm: giọt sương mai * nắng mai",
    example: "mai mới làm * tối mai tôi sẽ đến nhà anh chơi",
  },
  {
    word: "mai",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) ngày mai (nói tắt): mai mới làm * tối mai tôi sẽ đến nhà anh chơi",
    example: "nay đây mai đó",
  },
  {
    word: "mải",
    part_of_speech: "động từ",
    meaning:
      "tập trung tâm trí vào một việc nào đó đến mức không còn biết gì đến xung quanh hoặc quên hết những việc khác: mải chơi, không chịu học * đang mải nghĩ không nghe thấy tiếng gọi",
    example:
      "mải chơi, không chịu học * đang mải nghĩ không nghe thấy tiếng gọi",
  },
  {
    word: "mại bản",
    part_of_speech: "tính từ",
    meaning:
      "(tư sản) chuyên làm môi giới buôn bán giữa những người kinh doanh trong nước với tư bản nước ngoài: giai cấp tư sản mại bản",
    example: "giai cấp tư sản mại bản",
  },
  {
    word: "mại dâm",
    part_of_speech: "động từ",
    meaning:
      "hoạt động làm thoả mãn nhu cầu tình dục cho kẻ khác để kiếm tiền (nói khái quát): xoá bỏ tệ nạn mại dâm * gái mại dâm",
    example: "xoá bỏ tệ nạn mại dâm * gái mại dâm",
  },
  {
    word: "mài dũa",
    part_of_speech: "động từ",
    meaning:
      "làm cho sắc bén hơn qua rèn luyện, thử thách: mài giũa ý chí đấu tranh",
    example: "mài giũa ý chí đấu tranh",
  },
  {
    word: "mài dũa",
    part_of_speech: "động từ",
    meaning:
      "sửa đi sửa lại nhiều lần cho đẹp hơn, hay hơn: mài giũa từng chi tiết của bức tượng * câu chữ được mài giũa cẩn thận",
    example:
      "mài giũa từng chi tiết của bức tượng * câu chữ được mài giũa cẩn thận",
  },
  {
    word: "mai đây",
    part_of_speech: "danh từ",
    meaning:
      "một ngày gần đây, sắp tới đây (nói khái quát): mai đây mỗi người một ngả",
    example: "mai đây mỗi người một ngả",
  },
  {
    word: "mai kia",
    part_of_speech: "danh từ",
    meaning:
      "ngày mai hoặc ngày kia, thời gian sắp tới: độ mai kia thì lên đường",
    example: "độ mai kia thì lên đường",
  },
  {
    word: "mài giũa",
    part_of_speech: "động từ",
    meaning:
      "làm cho sắc bén hơn qua rèn luyện, thử thách: mài giũa ý chí đấu tranh",
    example: "mài giũa ý chí đấu tranh",
  },
  {
    word: "mài giũa",
    part_of_speech: "động từ",
    meaning:
      "sửa đi sửa lại nhiều lần cho đẹp hơn, hay hơn: mài giũa từng chi tiết của bức tượng * câu chữ được mài giũa cẩn thận",
    example:
      "mài giũa từng chi tiết của bức tượng * câu chữ được mài giũa cẩn thận",
  },
  {
    word: "mãi lộ",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) tiền phải nộp cho bọn cướp đường để được đi qua: đòi tiền mãi lộ",
    example: "đòi tiền mãi lộ",
  },
  {
    word: "mải mê",
    part_of_speech: "động từ",
    meaning:
      "ở trạng thái tâm trí tập trung cao độ vào một việc nào đó, đến mức như không còn biết gì khác nữa: mải mê với công việc * mải mê ngắm mình trong gương",
    example: "mải mê với công việc * mải mê ngắm mình trong gương",
  },
  {
    word: "mái hiên",
    part_of_speech: "danh từ",
    meaning:
      "phần mái phía trên thềm hoặc hiên nhà: đứng trú mưa dưới mái hiên",
    example: "đứng trú mưa dưới mái hiên",
  },
  {
    word: "mai mái",
    part_of_speech: "tính từ",
    meaning: "(nước da) hơi mái: nước da mai mái",
    example: "nước da mai mái",
  },
  {
    word: "mai mốt",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) mai kia: mai mốt mời anh qua chỗ tôi chơi",
    example: "mai mốt mời anh qua chỗ tôi chơi",
  },
  {
    word: "mãi lực",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) sức mua trên thị trường: mãi lực của thị trường thời trang trong nước ngày càng cao",
    example: "mãi lực của thị trường thời trang trong nước ngày càng cao",
  },
  {
    word: "mai mỉa",
    part_of_speech: "động từ",
    meaning: "như mỉa mai: bị người đời mai mỉa",
    example: "bị người đời mai mỉa",
  },
  {
    word: "mài miệt",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như miệt mài: làm việc mài miệt",
    example: "làm việc mài miệt",
  },
  {
    word: "mải miết",
    part_of_speech: "động từ",
    meaning:
      "ở trạng thái tâm trí tập trung liên tục vào một việc làm cụ thể nào đó đến mức không để ý gì đến xung quanh: mải miết đi * dòng sông mải miết trôi",
    example: "mải miết đi * dòng sông mải miết trôi",
  },
  {
    word: "mai một",
    part_of_speech: "động từ",
    meaning:
      "mất dần hoặc mất hẳn, không còn ai biết đến, do không được phát huy, sử dụng (thường dùng để nói về những giá trị tinh thần): tài năng bị mai một",
    example: "tài năng bị mai một",
  },
  {
    word: "mải mốt",
    part_of_speech: "",
    meaning:
      "tỏ ra vội, phải tập trung chú ý vào một việc làm cụ thể nào đó cho kịp, cho chóng xong, không còn để ý gì đến xung quanh: mải mốt dệt vải * bước đi mải mốt",
    example: "mải mốt dệt vải * bước đi mải mốt",
  },
  {
    word: "mai mối",
    part_of_speech: "động từ",
    meaning:
      "làm mai, làm mối trong việc hôn nhân (nói khái quát): nhờ người mai mối cho một đám",
    example: "nhờ người mai mối cho một đám",
  },
  {
    word: "mai sau",
    part_of_speech: "danh từ",
    meaning:
      'thời gian tương đối xa về sau này: hi vọng ở mai sau * "Mai sau ở chẳng như lời, Trên đầu có bóng mặt trời rạng soi." (TKiều)',
    example:
      'hi vọng ở mai sau * "Mai sau ở chẳng như lời, Trên đầu có bóng mặt trời rạng soi." (TKiều)',
  },
  {
    word: "mai phục",
    part_of_speech: "động từ",
    meaning:
      "đem quân giấu ở chỗ kín đáo để chờ đối phương đến thì chặn đánh một cách bất ngờ: bị lọt vào trận địa mai phục",
    example: "bị lọt vào trận địa mai phục",
  },
  {
    word: "mai táng",
    part_of_speech: "động từ",
    meaning: "(Trang trọng) như an táng",
    example: "mai táng tại nghĩa trang",
  },
  {
    word: "mái tóc",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ tóc trên đầu, nói chung: mái tóc dài óng ả * mái tóc màu hạt dẻ",
    example: "mái tóc dài óng ả * mái tóc màu hạt dẻ",
  },
  {
    word: "mái vẩy",
    part_of_speech: "danh từ",
    meaning:
      "mái che nhỏ, được làm thêm ra từ mái nhà chính: dẹp bỏ các mái che, mái vẩy để bảo đảm mĩ quan đường phố",
    example: "dẹp bỏ các mái che, mái vẩy để bảo đảm mĩ quan đường phố",
  },
  {
    word: "màn ảnh",
    part_of_speech: "danh từ",
    meaning:
      "bề mặt để tiếp nhận các tia sáng từ máy chiếu phim hoặc máy vô tuyến truyền hình và làm hiện lên hình ảnh: phim màn ảnh rộng * du lịch qua màn ảnh nhỏ",
    example: "phim màn ảnh rộng * du lịch qua màn ảnh nhỏ",
  },
  {
    word: "mạn",
    part_of_speech: "danh từ",
    meaning:
      "vùng, miền được xác định một cách đại khái dựa theo một hướng nào đó: sống ở mạn ngược",
    example: "sống ở mạn ngược",
  },
  {
    word: "mạn",
    part_of_speech: "danh từ",
    meaning: "thành tàu hoặc thuyền: sóng vỗ mạn thuyền",
    example: "sóng vỗ mạn thuyền",
  },
  {
    word: "màn bạc",
    part_of_speech: "danh từ",
    meaning:
      "màn ảnh chiếu phim; thường dùng để chỉ điện ảnh: ngôi sao màn bạc * minh tinh màn bạc",
    example: "ngôi sao màn bạc * minh tinh màn bạc",
  },
  {
    word: "màn bạc",
    part_of_speech: "danh từ",
    meaning: "sàn thuyền ở ngoài khoang thuyền: lên mạn thuyền hóng gió",
    example: "lên mạn thuyền hóng gió",
  },
  {
    word: "mãn",
    part_of_speech: "động từ",
    meaning:
      'đã hết, đã trọn một quá trình, một thời hạn xác định: mãn tang * mãn hạn tù * "Chờ chàng xuân mãn hè qua, Bông lan đã nở, sao mà vắng tin!" (ca dao)',
    example:
      'mãn tang * mãn hạn tù * "Chờ chàng xuân mãn hè qua, Bông lan đã nở, sao mà vắng tin!" (ca dao)',
  },
  {
    word: "mám",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) bám, không chịu nhả: cá mám câu (cắn câu) * mám mồi",
    example: "cá mám câu (cắn câu) * mám mồi",
  },
  {
    word: "mám",
    part_of_speech: "tính từ",
    meaning:
      "(khai, nói) không đúng sự thật nhằm giấu giếm, lừa dối: can tội khai man",
    example: "can tội khai man",
  },
  {
    word: "màn",
    part_of_speech: "danh từ",
    meaning:
      "(Nam mùng) đồ dùng làm bằng vải dệt thưa đều, mắc trùm quanh giường để ngăn ruồi muỗi: mắc màn * giăng màn * màn cá nhân * màn tuyn",
    example: "mắc màn * giăng màn * màn cá nhân * màn tuyn",
  },
  {
    word: "màn",
    part_of_speech: "danh từ",
    meaning:
      "(cũng rèm) đồ dùng làm bằng vải để che chắn: màn trên sân khấu từ từ hạ xuống * kéo tấm màn cửa lên",
    example: "màn trên sân khấu từ từ hạ xuống * kéo tấm màn cửa lên",
  },
  {
    word: "màn",
    part_of_speech: "danh từ",
    meaning:
      "lớp che phủ, bao phủ, ví như bức màn: cảnh vật chìm trong màn mưa * màn đêm buông xuống",
    example: "cảnh vật chìm trong màn mưa * màn đêm buông xuống",
  },
  {
    word: "màn",
    part_of_speech: "danh từ",
    meaning:
      "phần của vở kịch trong đó sự việc diễn ra tại một địa điểm nhất định từ lúc mở đến lúc đóng màn: vở kịch đã đến màn chót",
    example: "vở kịch đã đến màn chót",
  },
  {
    word: "man dại",
    part_of_speech: "tính từ",
    meaning: "có tính chất dã man, thiếu tính người: tiếng cười man dại",
    example: "tiếng cười man dại",
  },
  {
    word: "mạn đàm",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng, hoặc kc) trao đổi ý kiến xung quanh một vấn đề nào đó dưới hình thức nói chuyện thân mật, thoải mái: buổi mạn đàm về văn hoá ứng xử",
    example: "buổi mạn đàm về văn hoá ứng xử",
  },
  {
    word: "man khai",
    part_of_speech: "động từ",
    meaning:
      "(cũ) khai không đúng sự thật nhằm mục đích lừa dối: man khai lí lịch",
    example: "man khai lí lịch",
  },
  {
    word: "màn kịch",
    part_of_speech: "danh từ",
    meaning:
      "toàn bộ sự việc được sắp đặt sao cho diễn ra y như thật, nhằm che giấu một sự thật khác bên trong: màn kịch của hai tên lừa đảo",
    example: "màn kịch của hai tên lừa đảo",
  },
  {
    word: "màn hình",
    part_of_speech: "danh từ",
    meaning:
      "bề mặt của một số máy, trên đó làm hiện lên các hình ảnh: màn hình máy tính * màn hình của vô tuyến bị hỏng",
    example: "màn hình máy tính * màn hình của vô tuyến bị hỏng",
  },
  {
    word: "mãn khai",
    part_of_speech: "động từ",
    meaning:
      "(văn chương) (hoa) nở rộ, ở vào độ đẹp nhất: hoa mai mãn khai khi xuân về",
    example: "hoa mai mãn khai khi xuân về",
  },
  {
    word: "mãn kiếp",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) suốt đời, cho đến tận lúc chết (thường nói về việc không hay): ngồi tù mãn kiếp * mãn kiếp lầm than!",
    example: "ngồi tù mãn kiếp * mãn kiếp lầm than!",
  },
  {
    word: "mãn khoá",
    part_of_speech: "động từ",
    meaning:
      '(cũ) kết thúc khoá học, khoá thi: "Mới rồi mãn khoá thi hương, Ngựa điều võng tía qua đường những ai?" (NgBính; 1)',
    example:
      'Mới rồi mãn khoá thi hương, Ngựa điều võng tía qua đường những ai?" (NgBính; 1)',
  },
  {
    word: "mạn phép",
    part_of_speech: "động từ",
    meaning:
      "(trang trọng) chưa được phép mà đã làm (thường dùng trong lời nói xin lỗi người bề trên một cách lịch sự): mạn phép cụ, tôi xin có ý kiến!",
    example: "mạn phép cụ, tôi xin có ý kiến!",
  },
  {
    word: "mãn nguyện",
    part_of_speech: "động từ",
    meaning:
      "hoàn toàn bằng lòng, thoả mãn với những gì mình có được, không đòi hỏi gì hơn: nụ cười mãn nguyện * con cái thành đạt là cha mẹ đã mãn nguyện",
    example: "nụ cười mãn nguyện * con cái thành đạt là cha mẹ đã mãn nguyện",
  },
  {
    word: "man mác",
    part_of_speech: "tính từ",
    meaning:
      '(cảnh vật, màu sắc, v.v.) có cảm giác như lan toả ra trong một khoảng không gian bao la nhưng vắng lặng, gợi tâm trạng cô đơn: lạnh man mác * "Buồn trông ngọn nước mới sa, Hoa trôi man mác biết là về đâu?" (TKiều)',
    example:
      'lạnh man mác * "Buồn trông ngọn nước mới sa, Hoa trôi man mác biết là về đâu?" (TKiều)',
  },
  {
    word: "man mác",
    part_of_speech: "tính từ",
    meaning:
      "có tâm trạng lâng lâng đượm buồn: tâm hồn man mác * lòng man mác buồn",
    example: "tâm hồn man mác * lòng man mác buồn",
  },
  {
    word: "man mát",
    part_of_speech: "tính từ",
    meaning: "hơi mát, gợi cảm giác rất dễ chịu: hương thơm man mát",
    example: "hương thơm man mát",
  },
  {
    word: "man rợ",
    part_of_speech: "tính từ",
    meaning:
      "ở tình trạng chưa có văn minh, đời sống con người còn mông muội, có nhiều mặt gần với đời sống thú vật: con người man rợ * thời kì man rợ",
    example: "con người man rợ * thời kì man rợ",
  },
  {
    word: "man rợ",
    part_of_speech: "tính từ",
    meaning:
      "tàn ác đến cực độ, không còn tính người: những đòn tra tấn man rợ",
    example: "những đòn tra tấn man rợ",
  },
  {
    word: "mãn tính",
    part_of_speech: "tính từ",
    meaning:
      "(bệnh) có tính chất kéo dài và khó chữa: viêm phế quản mãn tính * viêm gan mãn tính",
    example: "viêm phế quản mãn tính * viêm gan mãn tính",
  },
  {
    word: "man trá",
    part_of_speech: "tính từ",
    meaning:
      "giả dối, không thật, nhằm giấu giếm hoặc đánh lừa: thói man trá * thủ đoạn man trá",
    example: "thói man trá * thủ đoạn man trá",
  },
  {
    word: "mãn nhiệm",
    part_of_speech: "động từ",
    meaning: "hết nhiệm kì: thủ tướng mãn nhiệm",
    example: "thủ tướng mãn nhiệm",
  },
  {
    word: "màn trời chiếu đất",
    part_of_speech: "",
    meaning:
      "tả cảnh sống không nhà không cửa, phải chịu cảnh dãi dầu mưa nắng: sống trong cảnh màn trời chiếu đất",
    example: "sống trong cảnh màn trời chiếu đất",
  },
  {
    word: "mang",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) hoẵng: tiếng mang tác",
    example: "tiếng mang tác",
  },
  {
    word: "mang",
    part_of_speech: "danh từ",
    meaning:
      "cơ quan hô hấp của một số động vật ở dưới nước như cá, cua, tôm, v.v.: cá thở bằng mang",
    example: "cá thở bằng mang",
  },
  {
    word: "mang",
    part_of_speech: "danh từ",
    meaning: "phần ở cổ rắn có thể phình to ra được: rắn bạnh mang",
    example: "rắn bạnh mang",
  },
  {
    word: "mang",
    part_of_speech: "động từ",
    meaning:
      "giữ cho lúc nào cũng đi theo với mình: không mang hành lí đi theo * nhớ mang theo sách vở",
    example: "không mang hành lí đi theo * nhớ mang theo sách vở",
  },
  {
    word: "mang",
    part_of_speech: "động từ",
    meaning:
      "lồng vào, đeo vào để che giữ một bộ phận nào đó của cơ thể: chân mang bít tất * mang kính râm * mang găng tay",
    example: "chân mang bít tất * mang kính râm * mang găng tay",
  },
  {
    word: "mang",
    part_of_speech: "động từ",
    meaning:
      "có ở trên người, trên mình, ở một vị trí nhất định nào đó: mang gông * mang thai * mang trên mình nhiều vết thương",
    example: "mang gông * mang thai * mang trên mình nhiều vết thương",
  },
  {
    word: "mang",
    part_of_speech: "động từ",
    meaning:
      "được gắn cho một tên gọi, một kí hiệu riêng nào đó: cầu thủ mang áo số 6 * thành phố mang tên Bác",
    example: "cầu thủ mang áo số 6 * thành phố mang tên Bác",
  },
  {
    word: "mang",
    part_of_speech: "động từ",
    meaning:
      "nhận lấy để phải chịu lâu dài về sau: mang tiếng * mang công mắc nợ * mang ơn",
    example: "mang tiếng * mang công mắc nợ * mang ơn",
  },
  {
    word: "mang",
    part_of_speech: "động từ",
    meaning:
      "có trong mình cái làm thành đặc trưng, tính chất riêng: món ăn mang đậm bản sắc dân tộc * mang phong cách trẻ trung",
    example: "món ăn mang đậm bản sắc dân tộc * mang phong cách trẻ trung",
  },
  {
    word: "mang",
    part_of_speech: "động từ",
    meaning:
      "lấy ra, đưa ra để làm gì đó: mang quần áo ra giặt * mang hết tâm sức ra làm việc",
    example: "mang quần áo ra giặt * mang hết tâm sức ra làm việc",
  },
  {
    word: "mang",
    part_of_speech: "động từ",
    meaning:
      "tạo ra và đưa đến (nói về cái trừu tượng): mang lại niềm vui lớn cho gia đình * mang vinh quang về cho tổ quốc",
    example:
      "mang lại niềm vui lớn cho gia đình * mang vinh quang về cho tổ quốc",
  },
  {
    word: "mạng",
    part_of_speech: "danh từ",
    meaning: "thân sống của con người: đền ơn cứu mạng * chết uổng mạng",
    example: "đền ơn cứu mạng * chết uổng mạng",
  },
  {
    word: "mạng",
    part_of_speech: "danh từ",
    meaning:
      "vật mỏng và thưa làm bằng những sợi đan chéo nhau: mạng che mặt * mạng đèn măng sông",
    example: "mạng che mặt * mạng đèn măng sông",
  },
  {
    word: "mạng",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) mạng lưới (nói tắt): mạng điện * mạng thông tin bị nghẽn",
    example: "mạng điện * mạng thông tin bị nghẽn",
  },
  {
    word: "mạng",
    part_of_speech: "động từ",
    meaning:
      "đan hay móc bằng chỉ để làm kín chỗ rách, chỗ thủng trên mặt hàng dệt: mạng bít tất * mạng quần áo",
    example: "mạng bít tất * mạng quần áo",
  },
  {
    word: "máng",
    part_of_speech: "danh từ",
    meaning:
      "vật có hình một nửa của một ống dài chẻ đôi, dùng để hứng và dẫn nước: bắc máng nước",
    example: "bắc máng nước",
  },
  {
    word: "máng",
    part_of_speech: "danh từ",
    meaning: "đường dẫn nước nhỏ và lộ thiên: đào máng dẫn nước vào ruộng",
    example: "đào máng dẫn nước vào ruộng",
  },
  {
    word: "máng",
    part_of_speech: "danh từ",
    meaning:
      "đồ đựng thức ăn cho gia súc, gia cầm, thường đóng bằng gỗ, có hình của một ống dài chẻ đôi, ngăn kín hai đầu: máng cho lợn ăn * cạn tàu ráo máng (tng)",
    example: "máng cho lợn ăn * cạn tàu ráo máng (tng)",
  },
  {
    word: "máng",
    part_of_speech: "động từ",
    meaning:
      "(Phương ngữ) treo hoặc mắc vật gì vào một điểm: máng chiếc nón lên tường",
    example: "máng chiếc nón lên tường",
  },
  {
    word: "mảng",
    part_of_speech: "danh từ",
    meaning:
      "bè nhỏ, dùng làm phương tiện để vận chuyển trên mặt nước: kết mảng vượt sông",
    example: "kết mảng vượt sông",
  },
  {
    word: "mảng",
    part_of_speech: "danh từ",
    meaning:
      "phần của một vật bị tách rời ra, có diện tích hoặc khối lượng đáng kể: lớp vữa trên tường bong ra từng mảng * tróc một mảng da",
    example: "lớp vữa trên tường bong ra từng mảng * tróc một mảng da",
  },
  {
    word: "mảng",
    part_of_speech: "động từ",
    meaning:
      '(Từ cũ) mải: "Tay cầm bầu rượu nắm nem, Mảng vui quên hết lời em dặn dò." (Cdao)',
    example:
      'Tay cầm bầu rượu nắm nem, Mảng vui quên hết lời em dặn dò." (Cdao)',
  },
  {
    word: "mảng",
    part_of_speech: "động từ",
    meaning:
      '(Từ cũ) nghe, nghe thấy: "Mảng tin xiết nỗi kinh hoàng, Băng mình lẻn trước đài trang tự tình." (TKiều)',
    example:
      'Mảng tin xiết nỗi kinh hoàng, Băng mình lẻn trước đài trang tự tình." (TKiều)',
  },
  {
    word: "màng",
    part_of_speech: "danh từ",
    meaning: "lớp mô mỏng bọc ngoài: màng óc * tràn dịch màng phổi",
    example: "màng óc * tràn dịch màng phổi",
  },
  {
    word: "màng",
    part_of_speech: "danh từ",
    meaning: "lớp mỏng kết trên bề mặt một chất lỏng: cốc sữa đã nổi màng",
    example: "cốc sữa đã nổi màng",
  },
  {
    word: "màng",
    part_of_speech: "danh từ",
    meaning:
      "lớp mỏng, đục, che tròng đen của mắt khi mắt bị một số bệnh: mắt kéo màng",
    example: "mắt kéo màng",
  },
  {
    word: "màng",
    part_of_speech: "động từ",
    meaning:
      'nghĩ đến, tưởng đến: không màng danh lợi * "Phải duyên áo rách cũng màng, Chẳng duyên, áo nhiễu nút vàng không ham." (Cdao)',
    example:
      'không màng danh lợi * "Phải duyên áo rách cũng màng, Chẳng duyên, áo nhiễu nút vàng không ham." (Cdao)',
  },
  {
    word: "mãng cầu",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) na: trái mãng cầu",
    example: "trái mãng cầu",
  },
  {
    word: "màng lưới",
    part_of_speech: "danh từ",
    meaning: "võng mạc",
    example:
      "màng lưới giao thông chằng chịt * mở rộng màng lưới cộng tác viên",
  },
  {
    word: "mạng mỡ",
    part_of_speech: "danh từ",
    meaning: "phần ở hai bên bụng, ngang với thắt lưng: đánh trúng mạng mỡ",
    example: "đánh trúng mạng mỡ",
  },
  {
    word: "mạng lưới",
    part_of_speech: "danh từ",
    meaning:
      "hệ thống những đường đan nối vào nhau có một chức năng chung: mạng lưới giao thông * mạng lưới điện thoại nội tỉnh",
    example: "mạng lưới giao thông * mạng lưới điện thoại nội tỉnh",
  },
  {
    word: "mạng lưới",
    part_of_speech: "danh từ",
    meaning:
      "hệ thống tổ chức gồm nhiều cá nhân hoặc đơn vị có cùng một chức năng cụ thể: mạng lưới cộng tác viên",
    example: "mạng lưới cộng tác viên",
  },
  {
    word: "mang máng",
    part_of_speech: "tính từ",
    meaning:
      "(nhận thức) có phần lờ mờ, không được rõ lắm, không thật chính xác: nghe mang máng * chỉ nhớ mang máng",
    example: "nghe mang máng * chỉ nhớ mang máng",
  },
  {
    word: "mang máng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ, hiếm) hiểu, nhớ một cách lờ mờ, không thật chính xác: mang máng là đã gặp nó ở đâu rồi",
    example: "mang máng là đã gặp nó ở đâu rồi",
  },
  {
    word: "màng màng",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) màng mỏng ở trên bề mặt một chất lỏng: nổi màng màng",
    example: "nổi màng màng",
  },
  {
    word: "màng nhĩ",
    part_of_speech: "danh từ",
    meaning:
      "màng mỏng ngăn cách tai ngoài và tai giữa, rung lên khi có tác động của âm thanh: thủng màng nhĩ",
    example: "thủng màng nhĩ",
  },
  {
    word: "màng tang",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) thái dương: thấy nhức hai bên màng tang",
    example: "thấy nhức hai bên màng tang",
  },
  {
    word: "mang tai",
    part_of_speech: "danh từ",
    meaning:
      "phần ở hai bên mặt, ở sau và dưới tai người: giắt cái bút chì vào mang tai",
    example: "giắt cái bút chì vào mang tai",
  },
  {
    word: "mang tiếng",
    part_of_speech: "động từ",
    meaning:
      "chịu tiếng xấu, bị dư luận chê bai: mang tiếng là hư hỏng * sợ mang tiếng",
    example: "mang tiếng là hư hỏng * sợ mang tiếng",
  },
  {
    word: "mang tiếng",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) có được cái tiếng, được dư luận cho là (nhưng sự thật thì không được như vậy): mang tiếng là học giỏi mà bài này cũng không làm được",
    example: "mang tiếng là học giỏi mà bài này cũng không làm được",
  },
  {
    word: "máng xối",
    part_of_speech: "danh từ",
    meaning:
      "máng hứng và dẫn nước mưa, thường làm ở chỗ đầu mép dưới của mái nhà: nước ào ào theo máng xối chảy vào bể",
    example: "nước ào ào theo máng xối chảy vào bể",
  },
  {
    word: "mãng xà",
    part_of_speech: "danh từ",
    meaning:
      "trăn sống lâu năm thành tinh, chuyên làm hại người, trong các truyện cổ: con mãng xà",
    example: "con mãng xà",
  },
  {
    word: "mánh",
    part_of_speech: "",
    meaning:
      "(Khẩu ngữ) mánh khoé (nói tắt): giở đủ mánh hòng đè bẹp đối phương",
    example: "giở đủ mánh hòng đè bẹp đối phương",
  },
  {
    word: "mánh",
    part_of_speech: "",
    meaning:
      "(Khẩu ngữ) vụ làm ăn hoặc cuộc môi giới giữa các bên để kiếm lợi (thường không chính đáng): trúng mánh * bị bể mánh",
    example: "trúng mánh * bị bể mánh",
  },
  {
    word: "mành",
    part_of_speech: "danh từ",
    meaning:
      "vật được đan, kết bằng tre trúc, dùng để che cửa hoặc trang trí, có thể cuộn lên, buông xuống hoặc kéo gọn sang hai bên: mành trúc",
    example: "mành trúc",
  },
  {
    word: "mành",
    part_of_speech: "tính từ",
    meaning:
      'mảnh, nhỏ, dễ đứt: tơ mành * "Đôi ta duyên nợ không thành, Cũng do Nguyệt Lão chỉ mành xe lơi." (Cdao)',
    example:
      'tơ mành * "Đôi ta duyên nợ không thành, Cũng do Nguyệt Lão chỉ mành xe lơi." (Cdao)',
  },
  {
    word: "mảnh",
    part_of_speech: "danh từ",
    meaning:
      "phần rất nhỏ và mỏng của một vật nào đó bị chia tách ra: mảnh bát * mảnh gương vỡ * mảnh vụn",
    example: "mảnh bát * mảnh gương vỡ * mảnh vụn",
  },
  {
    word: "mảnh",
    part_of_speech: "danh từ",
    meaning:
      "từ chỉ từng đơn vị đám đất nhỏ hoặc vật hình tấm mỏng, thường coi là nhỏ bé hơn so với những vật cùng loại: mảnh vườn sau nhà * mảnh ván * mảnh bằng tốt nghiệp",
    example: "mảnh vườn sau nhà * mảnh ván * mảnh bằng tốt nghiệp",
  },
  {
    word: "mảnh",
    part_of_speech: "tính từ",
    meaning:
      "có dáng thanh, nhỏ, trông có vẻ yếu: dáng người mảnh * mảnh như sợi chỉ * vót một cái que thật mảnh",
    example: "dáng người mảnh * mảnh như sợi chỉ * vót một cái que thật mảnh",
  },
  {
    word: "mảnh",
    part_of_speech: "phụ từ",
    meaning:
      "(làm việc gì) riêng một mình hoặc với một, hai người, không để cho tập thể biết hoặc tham gia: bàn mảnh với nhau * đi ăn mảnh",
    example: "bàn mảnh với nhau * đi ăn mảnh",
  },
  {
    word: "mạnh bạo",
    part_of_speech: "tính từ",
    meaning:
      "không sợ, dám nghĩ dám làm những việc thấy là đáng làm, tuy biết đó là việc người ta thường e ngại: nói năng mạnh bạo * đưa ra một quyết định mạnh bạo",
    example: "nói năng mạnh bạo * đưa ra một quyết định mạnh bạo",
  },
  {
    word: "mạnh",
    part_of_speech: "tính từ",
    meaning:
      "có sức lực, tiềm lực lớn, có khả năng vượt đối phương: một đội tuyển mạnh * có thế mạnh về du lịch * mạnh vì gạo, bạo vì tiền (tng)",
    example:
      "một đội tuyển mạnh * có thế mạnh về du lịch * mạnh vì gạo, bạo vì tiền (tng)",
  },
  {
    word: "mạnh",
    part_of_speech: "tính từ",
    meaning:
      "có mức độ, năng lực hoặc tác dụng tương đối lớn so với các mặt, các phương diện khác: gió ngày càng mạnh * phát huy mặt mạnh, khắc phục mặt yếu",
    example: "gió ngày càng mạnh * phát huy mặt mạnh, khắc phục mặt yếu",
  },
  {
    word: "mạnh",
    part_of_speech: "tính từ",
    meaning:
      "có khả năng tác động trên mức bình thường đến các giác quan: rượu mạnh * loại thuốc có tác dụng mạnh",
    example: "rượu mạnh * loại thuốc có tác dụng mạnh",
  },
  {
    word: "mạnh",
    part_of_speech: "tính từ",
    meaning:
      "có cử chỉ, hành động dứt khoát, không rụt rè, không e ngại: bước mạnh chân * đừng có mạnh mồm!",
    example: "bước mạnh chân * đừng có mạnh mồm!",
  },
  {
    word: "mạnh",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) không ốm đau, bệnh tật gì: mọi người vẫn mạnh",
    example: "mọi người vẫn mạnh",
  },
  {
    word: "manh",
    part_of_speech: "danh từ",
    meaning:
      'từ chỉ đơn vị vật mỏng, mềm dùng để che thân, để đắp (thường hàm ý coi như không đáng kể): manh chiếu rách * "Hơn nhau tấm áo manh quần, Thả ra bóc trần, ai cũng như ai." (ca dao)',
    example:
      'manh chiếu rách * "Hơn nhau tấm áo manh quần, Thả ra bóc trần, ai cũng như ai." (ca dao)',
  },
  {
    word: "manh",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) thếp (giấy): mua vài manh giấy",
    example: "mua vài manh giấy",
  },
  {
    word: "mạnh dạn",
    part_of_speech: "tính từ",
    meaning:
      "không rụt rè, sợ sệt, dám làm những việc mà người khác thường e ngại: nói năng mạnh dạn",
    example: "nói năng mạnh dạn",
  },
  {
    word: "mảnh dẻ",
    part_of_speech: "tính từ",
    meaning:
      "gầy và mảnh, trông có vẻ yếu: dáng người mảnh dẻ * nhành cây mảnh dẻ",
    example: "dáng người mảnh dẻ * nhành cây mảnh dẻ",
  },
  {
    word: "mánh khoé",
    part_of_speech: "danh từ",
    meaning:
      "lối đánh lừa người để mưu lợi cho mình một cách không đàng hoàng, không chính đáng: mánh khoé làm ăn",
    example: "mánh khoé làm ăn",
  },
  {
    word: "mánh khoé",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có nhiều lối lừa lọc một cách khôn khéo, tinh vi: bọn chúng cũng mánh khoé lắm!",
    example: "bọn chúng cũng mánh khoé lắm!",
  },
  {
    word: "manh động",
    part_of_speech: "động từ",
    meaning:
      "hành động phiêu lưu, có phần liều lĩnh khi điều kiện chủ quan và khách quan chưa chín muồi, dễ dẫn đến thất bại: không được manh động",
    example: "không được manh động",
  },
  {
    word: "mạnh giỏi",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) mạnh khoẻ (thường dùng trong lời chúc, lời thăm hỏi): anh đi mạnh giỏi!",
    example: "anh đi mạnh giỏi!",
  },
  {
    word: "mạnh khoẻ",
    part_of_speech: "tính từ",
    meaning:
      "có sức khoẻ như mong muốn, không bị ốm đau: cả nhà đều mạnh khoẻ * chúc bác và gia đình mạnh khoẻ!",
    example: "cả nhà đều mạnh khoẻ * chúc bác và gia đình mạnh khoẻ!",
  },
  {
    word: "mãnh hổ",
    part_of_speech: "danh từ",
    meaning:
      "hổ dữ; thường dùng để ví người có hành động dũng cảm và sức mạnh phi thường: viên tướng như con mãnh hổ xông pha giữa trận tiền",
    example: "viên tướng như con mãnh hổ xông pha giữa trận tiền",
  },
  {
    word: "mánh lới",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) cách khôn khéo đánh lừa người khác để đạt một mục đích nào đó: mánh lới làm ăn * dùng mánh lới để mua chuộc",
    example: "mánh lới làm ăn * dùng mánh lới để mua chuộc",
  },
  {
    word: "mánh lới",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ, hiếm) khôn khéo, có mánh lới: muốn làm được vụ này phải mánh lới một chút",
    example: "muốn làm được vụ này phải mánh lới một chút",
  },
  {
    word: "mãnh liệt",
    part_of_speech: "tính từ",
    meaning: "mạnh mẽ và dữ dội: niềm tin mãnh liệt * sức sống mãnh liệt",
    example: "niềm tin mãnh liệt * sức sống mãnh liệt",
  },
  {
    word: "mảnh khảnh",
    part_of_speech: "tính từ",
    meaning:
      "cao, gầy và mảnh, trông yếu: dáng người mảnh khảnh * nét chữ mảnh khảnh",
    example: "dáng người mảnh khảnh * nét chữ mảnh khảnh",
  },
  {
    word: "mảnh mai",
    part_of_speech: "tính từ",
    meaning:
      "mảnh, trông có vẻ yếu nhưng ưa nhìn: dáng điệu mảnh mai * thân hình mảnh mai",
    example: "dáng điệu mảnh mai * thân hình mảnh mai",
  },
  {
    word: "mãnh lực",
    part_of_speech: "danh từ",
    meaning:
      "(hiếm) sức mạnh lớn lao, ghê gớm (thường là về tinh thần): mãnh lực của tình yêu",
    example: "mãnh lực của tình yêu",
  },
  {
    word: "mành mành",
    part_of_speech: "danh từ",
    meaning:
      'bức mành, tấm mành: "Gió đâu sịch bức mành mành, Tỉnh ra mới biết là mình chiêm bao." (TKiều)',
    example:
      'Gió đâu sịch bức mành mành, Tỉnh ra mới biết là mình chiêm bao." (TKiều)',
  },
  {
    word: "manh mối",
    part_of_speech: "danh từ",
    meaning:
      "điểm từ đó có thể lần ra để tìm hiểu toàn bộ sự việc: lần ra manh mối * manh mối của vụ án mạng",
    example: "lần ra manh mối * manh mối của vụ án mạng",
  },
  {
    word: "manh mối",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ, hiếm) như mối manh: nhờ người manh mối",
    example: "nhờ người manh mối",
  },
  {
    word: "mạnh mẽ",
    part_of_speech: "tính từ",
    meaning: "có nhiều sức lực, tiềm lực (nói khái quát): sức sống mạnh mẽ",
    example: "sức sống mạnh mẽ",
  },
  {
    word: "mạnh mẽ",
    part_of_speech: "tính từ",
    meaning:
      "có cường độ lớn, đem lại tác dụng và hiệu quả cao (nói khái quát): có tác động mạnh mẽ * kinh tế phát triển mạnh mẽ",
    example: "có tác động mạnh mẽ * kinh tế phát triển mạnh mẽ",
  },
  {
    word: "mạnh mẽ",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) tỏ ra có nhiều sức mạnh về thể chất hoặc tinh thần: bước đi mạnh mẽ * một chàng trai mạnh mẽ",
    example: "bước đi mạnh mẽ * một chàng trai mạnh mẽ",
  },
  {
    word: "mạnh mồm",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) dám nói những điều người khác e ngại, nhưng thường lại không làm được như đã nói (hàm ý chê): chỉ được cái mạnh mồm!",
    example: "chỉ được cái mạnh mồm!",
  },
  {
    word: "mánh mung",
    part_of_speech: "",
    meaning:
      "(Khẩu ngữ) mánh khoé làm ăn (nói khái quát): bàn chuyện mánh mung",
    example: "bàn chuyện mánh mung",
  },
  {
    word: "manh mún",
    part_of_speech: "tính từ",
    meaning:
      "ở tình trạng bị chia cắt thành những mảnh, những phần nhỏ và rời rạc (nói khái quát): kiểu làm ăn manh mún * ruộng đất bị chia xẻ manh mún",
    example: "kiểu làm ăn manh mún * ruộng đất bị chia xẻ manh mún",
  },
  {
    word: "mãnh thú",
    part_of_speech: "danh từ",
    meaning: "thú dữ: con mãnh thú",
    example: "con mãnh thú",
  },
  {
    word: "manh nha",
    part_of_speech: "động từ",
    meaning: "mới có mầm mống, mới nảy sinh: manh nha tư tưởng chống đối",
    example: "manh nha tư tưởng chống đối",
  },
  {
    word: "manh tâm",
    part_of_speech: "",
    meaning: "mưu mô làm điều xấu xa, bất lương: manh tâm làm loạn",
    example: "manh tâm làm loạn",
  },
  {
    word: "mạnh tay",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) dám làm, và làm một cách mạnh bạo những việc người khác thường phải đắn đo, e ngại: mạnh tay trừng trị * chi tiêu rất mạnh tay",
    example: "mạnh tay trừng trị * chi tiêu rất mạnh tay",
  },
  {
    word: "mạnh thường quân",
    part_of_speech: "danh từ",
    meaning:
      "người nước Tề thời Chiến Quốc ở Trung Quốc xưa, rất giàu có, yêu trọng hiền tài và hay dùng tiền bạc để làm việc nghĩa; dùng để chỉ người giúp đỡ về mặt tài chính cho một công việc chung, một tổ chức, v.v.: Mạnh Thường Quân của đội bóng * được sự tài trợ của nhiều Mạnh Thường Quân",
    example:
      "Mạnh Thường Quân của đội bóng * được sự tài trợ của nhiều Mạnh Thường Quân",
  },
  {
    word: "maníp",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ đóng, ngắt mạch điện, dùng để tạo tín hiệu điện báo: gõ maníp",
    example: "gõ maníp",
  },
  {
    word: "mãnh tướng",
    part_of_speech: "danh từ",
    meaning: "(cũ) viên tướng dũng mãnh: bậc mãnh tướng",
    example: "bậc mãnh tướng",
  },
  {
    word: "mào",
    part_of_speech: "danh từ",
    meaning: "phần lông hay thịt mọc nhô cao trên đầu một số loài vật: mào gà",
    example: "mào gà",
  },
  {
    word: "mạo",
    part_of_speech: "động từ",
    meaning:
      "làm giả để đánh lừa, nhằm cho có vẻ hợp pháp: mạo chữ kí * mạo tên người khác",
    example: "mạo chữ kí * mạo tên người khác",
  },
  {
    word: "mão",
    part_of_speech: "danh từ",
    meaning:
      "(thường viết hoa) kí hiệu thứ tư trong địa chi (lấy mèo làm tượng trưng; sau dần, trước thìn), dùng trong phép đếm thời gian cổ truyền của Trung Quốc và một số nước châu á, trong đó có Việt Nam: năm Kỉ Mão * tuổi Mão * giờ Mão (từ 5 đến 7 giờ sáng)",
    example: "năm Kỉ Mão * tuổi Mão * giờ Mão (từ 5 đến 7 giờ sáng)",
  },
  {
    word: "mạo nhận",
    part_of_speech: "động từ",
    meaning: "nhận càn, nhận bừa (thường để đánh lừa): mạo nhận là công an",
    example: "mạo nhận là công an",
  },
  {
    word: "mao dẫn",
    part_of_speech: "động từ",
    meaning:
      "(hiện tượng chất lỏng) dâng lên hay tụt xuống theo những ống hết sức nhỏ do tác động qua lại giữa các phân tử của chất lỏng và các phân tử của chất rắn: hiện tượng mao dẫn",
    example: "hiện tượng mao dẫn",
  },
  {
    word: "mào gà",
    part_of_speech: "danh từ",
    meaning:
      "cây thân cỏ, lá nhỏ và dài, hoa màu đỏ tía, trông giống như mào con gà, thường được trồng làm cảnh: hoa mào gà",
    example: "hoa mào gà",
  },
  {
    word: "mào đầu",
    part_of_speech: "động từ",
    meaning:
      "nói dẫn dắt mấy lời trước khi vào nội dung chính: lời mào đầu * mào đầu câu chuyện",
    example: "lời mào đầu * mào đầu câu chuyện",
  },
  {
    word: "mao mạch",
    part_of_speech: "danh từ",
    meaning: "mạch máu nhỏ nối liền động mạch và tĩnh mạch: tắc mao mạch",
    example: "tắc mao mạch",
  },
  {
    word: "mạo muội",
    part_of_speech: "động từ",
    meaning:
      "(cũ, hoặc kc) đánh liều làm việc biết có thể là dại dột, dễ gây sơ suất (thường dùng ở đầu câu bày tỏ ý kiến với người bề trên để tỏ ý khiêm tốn, nhún nhường): xin mạo muội có một vài ý kiến",
    example: "xin mạo muội có một vài ý kiến",
  },
  {
    word: "mạo từ",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng phụ cho danh từ trong một số ngôn ngữ để phân biệt giống, số, tính xác định và tính không xác định: ,  *  là những mạo từ trong tiếng Anh",
    example: ",  *  là những mạo từ trong tiếng Anh",
  },
  {
    word: "mạo hiểm",
    part_of_speech: "",
    meaning:
      "liều lĩnh làm một việc biết là nguy hiểm, có thể mang lại hậu quả rất tai hại: hành động phiêu lưu, mạo hiểm * mạo hiểm xông vào đám cháy cứu người",
    example:
      "hành động phiêu lưu, mạo hiểm * mạo hiểm xông vào đám cháy cứu người",
  },
  {
    word: "mạo danh",
    part_of_speech: "động từ",
    meaning:
      "mạo tên người khác (thường để làm việc mờ ám): mạo danh nhà chức trách * mạo danh nhà báo",
    example: "mạo danh nhà chức trách * mạo danh nhà báo",
  },
  {
    word: "marxist",
    part_of_speech: "tính từ",
    meaning: "theo chủ nghĩa Marx: người marxist * quan điểm marxist",
    example: "người marxist * quan điểm marxist",
  },
  {
    word: "marketing",
    part_of_speech: "danh từ",
    meaning:
      "việc nghiên cứu một cách có hệ thống những điều kiện tốt nhất tiêu thụ hàng hoá (nghiên cứu về thị trường, về quảng cáo, về yêu cầu, thị hiếu của người tiêu dùng, v.v.): một chuyên gia trong lĩnh vực marketing",
    example: "một chuyên gia trong lĩnh vực marketing",
  },
  {
    word: "mao quản",
    part_of_speech: "danh từ",
    meaning: "ống rất nhỏ.",
    example: "tắc mao quản",
  },
  {
    word: "mao quản",
    part_of_speech: "danh từ",
    meaning: "(cũ): tắc mao quản",
    example: "nước mưa ngấm xuống đất theo các mao quản",
  },
  {
    word: "mạo xưng",
    part_of_speech: "động từ",
    meaning:
      "(hiếm) xưng giả tên một người nào đó để đánh lừa làm việc gì: mạo xưng là nhà báo",
    example: "mạo xưng là nhà báo",
  },
  {
    word: "mát",
    part_of_speech: "danh từ",
    meaning:
      "hiện tượng mất cách điện không mong muốn, khiến điện có thể truyền ra vỏ máy: cái quạt bị mát điện",
    example: "cái quạt bị mát điện",
  },
  {
    word: "mát",
    part_of_speech: "tính từ",
    meaning:
      "có nhiệt độ vừa phải, không nóng, nhưng cũng không lạnh, gây cảm giác dễ chịu: gió mát * hóng mát * nước mát lạnh * đi dạo mát * nghỉ mát",
    example: "gió mát * hóng mát * nước mát lạnh * đi dạo mát * nghỉ mát",
  },
  {
    word: "mát",
    part_of_speech: "tính từ",
    meaning:
      "có cảm giác khoan khoái dễ chịu, không nóng bức: tắm mát * lụa mềm, sờ thấy mát tay",
    example: "tắm mát * lụa mềm, sờ thấy mát tay",
  },
  {
    word: "mát",
    part_of_speech: "tính từ",
    meaning:
      "có tác dụng làm cho cơ thể không bị nhiệt, không bị rôm sảy, mụn nhọt: ăn đồ mát * một vị thuốc mát",
    example: "ăn đồ mát * một vị thuốc mát",
  },
  {
    word: "mát",
    part_of_speech: "tính từ",
    meaning:
      "có vẻ như dịu nhẹ, nhưng thật ra là mỉa mai, chê trách, hờn dỗi: nói mát * cười mát * chửi mát",
    example: "nói mát * cười mát * chửi mát",
  },
  {
    word: "mát",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (cân đong) hơi thiếu hụt so với khối lượng thật một chút: nửa cân hơi mát",
    example: "nửa cân hơi mát",
  },
  {
    word: "mạt",
    part_of_speech: "danh từ",
    meaning:
      "vụn nhỏ của gỗ, sắt, đá, v.v. rơi ra khi cưa, giũa, đập: mạt cưa * mạt sắt * bắp chân bám đầy mạt than",
    example: "mạt cưa * mạt sắt * bắp chân bám đầy mạt than",
  },
  {
    word: "mạt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ở vào mức đạt được thấp nhất, tồi nhất: mạt lắm cũng kiếm được mấy chục nghìn",
    example: "mạt lắm cũng kiếm được mấy chục nghìn",
  },
  {
    word: "mạt",
    part_of_speech: "tính từ",
    meaning:
      "(hạng) thấp, kém, đáng coi thường, coi khinh: đốn mạt * rẻ mạt * mạt hạng",
    example: "đốn mạt * rẻ mạt * mạt hạng",
  },
  {
    word: "mạt",
    part_of_speech: "tính từ",
    meaning:
      "ở vào giai đoạn cuối cùng và suy tàn: thời Lê mạt * đã đến lúc mạt thời",
    example: "thời Lê mạt * đã đến lúc mạt thời",
  },
  {
    word: "mạt chược",
    part_of_speech: "danh từ",
    meaning:
      "trò chơi với những quân bài làm bằng sừng, ngà hay nhựa, do bốn người chơi: đánh mạt chược",
    example: "đánh mạt chược",
  },
  {
    word: "mát dạ",
    part_of_speech: "tính từ",
    meaning: "như mát lòng: được câu nói cũng thấy mát dạ",
    example: "được câu nói cũng thấy mát dạ",
  },
  {
    word: "mạt cưa",
    part_of_speech: "danh từ",
    meaning: "vụn gỗ nhỏ rơi ra khi cưa, xẻ: đun bếp bằng mùn cưa",
    example: "đun bếp bằng mùn cưa",
  },
  {
    word: "mát dịu",
    part_of_speech: "tính từ",
    meaning:
      "có tác dụng tạo nên cảm giác mát mẻ, êm dịu, dễ chịu: tiết trời mát dịu * màu xanh non mát dịu",
    example: "tiết trời mát dịu * màu xanh non mát dịu",
  },
  {
    word: "mạt đời",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) như mạt kiếp (ng1): khổ mạt đời",
    example: "khổ mạt đời",
  },
  {
    word: "mạt kì",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như hậu kì: mạt kì nhà Lê",
    example: "mạt kì nhà Lê",
  },
  {
    word: "mạt hạng",
    part_of_speech: "tính từ",
    meaning:
      "(hạng) thấp kém nhất, không có chút giá trị: nghề mạt hạng * đồ mạt hạng!",
    example: "nghề mạt hạng * đồ mạt hạng!",
  },
  {
    word: "mạt cưa mướp đắng",
    part_of_speech: "",
    meaning:
      'chỉ hai hạng người đều là những kẻ chuyên lừa lọc, đáng khinh như nhau (lại gặp nhau): "Tình cờ, chẳng hẹn mà nên, Mạt cưa mướp đắng, đôi bên một phường." (TKiều)',
    example:
      'Tình cờ, chẳng hẹn mà nên, Mạt cưa mướp đắng, đôi bên một phường." (TKiều)',
  },
  {
    word: "mạt kiếp",
    part_of_speech: "tính từ",
    meaning:
      "cho đến tận cuối đời (vẫn chỉ là cái không hay, cái đáng nguyền rủa): nghèo đến mạt kiếp * mạt kiếp cũng không khá lên được!",
    example: "nghèo đến mạt kiếp * mạt kiếp cũng không khá lên được!",
  },
  {
    word: "mạt kiếp",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) đốn mạt, đáng nguyền rủa (dùng làm tiếng rủa): quân mạt kiếp!",
    example: "quân mạt kiếp!",
  },
  {
    word: "mạt kỳ",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như hậu kì: mạt kì nhà Lê",
    example: "mạt kì nhà Lê",
  },
  {
    word: "mát mắt",
    part_of_speech: "tính từ",
    meaning:
      "có cảm giác dễ chịu, ưa thích khi nhìn thấy, do có ánh sáng và màu sắc êm dịu: đồng cỏ non xanh trông mát mắt",
    example: "đồng cỏ non xanh trông mát mắt",
  },
  {
    word: "mát lành",
    part_of_speech: "tính từ",
    meaning:
      "có tác dụng tốt lành và gây cảm giác dễ chịu: dòng sữa mát lành * không khí mát lành của buổi ban mai",
    example: "dòng sữa mát lành * không khí mát lành của buổi ban mai",
  },
  {
    word: "mát lòng",
    part_of_speech: "tính từ",
    meaning:
      "hả hê, vui thích trong lòng do được thoả ý: con cái học giỏi cha mẹ cũng mát lòng",
    example: "con cái học giỏi cha mẹ cũng mát lòng",
  },
  {
    word: "mát mặt",
    part_of_speech: "tính từ",
    meaning:
      "cảm thấy có phần dễ chịu về mặt đời sống vật chất: nhà ấy trước nghèo rớt, giờ cũng được mát mặt",
    example: "nhà ấy trước nghèo rớt, giờ cũng được mát mặt",
  },
  {
    word: "mát mặt",
    part_of_speech: "tính từ",
    meaning:
      "cảm thấy có sự tự hào, hãnh diện trước mặt những người khác: con cái đỗ đạt khiến cha mẹ được mát mặt",
    example: "con cái đỗ đạt khiến cha mẹ được mát mặt",
  },
  {
    word: "mát mẻ",
    part_of_speech: "tính từ",
    meaning:
      "mát, gây cảm giác dễ chịu (nói khái quát): trời thu mát mẻ * không khí mát mẻ dễ chịu",
    example: "trời thu mát mẻ * không khí mát mẻ dễ chịu",
  },
  {
    word: "mát mẻ",
    part_of_speech: "tính từ",
    meaning:
      "(nói) mát, có vẻ như nhẹ nhàng nhưng thật ra là có ý mỉa mai, chê trách, hờn dỗi (nói khái quát): buông lời mát mẻ * giọng mát mẻ",
    example: "buông lời mát mẻ * giọng mát mẻ",
  },
  {
    word: "mạt sát",
    part_of_speech: "động từ",
    meaning:
      "dùng những lời lẽ quá đáng để nhằm hạ thấp giá trị của người khác: bị mạt sát nặng nề * lớn tiếng mạt sát",
    example: "bị mạt sát nặng nề * lớn tiếng mạt sát",
  },
  {
    word: "mạt vận",
    part_of_speech: "tính từ",
    meaning: "hết thời: một thương gia đã đến ngày mạt vận",
    example: "một thương gia đã đến ngày mạt vận",
  },
  {
    word: "mát tay",
    part_of_speech: "tính từ",
    meaning:
      "có vẻ như thích hợp hoặc rất khéo tay nên dễ thành công, đạt được kết quả tốt trong những công việc cụ thể (như chữa bệnh, trồng trọt, chăn nuôi, v.v.): một bà đỡ mát tay",
    example: "một bà đỡ mát tay",
  },
  {
    word: "mát ruột",
    part_of_speech: "tính từ",
    meaning:
      "có cảm giác dễ chịu, khoan khoái trong người do như vợi bớt được cái nóng trong ruột: húp bát canh cho mát ruột",
    example: "húp bát canh cho mát ruột",
  },
  {
    word: "mát rượi",
    part_of_speech: "tính từ",
    meaning:
      "mát đến mức có cảm giác như hơi lạnh một chút nhưng rất dễ chịu: nước mát rượi * hàng cây che bóng mát rượi",
    example: "nước mát rượi * hàng cây che bóng mát rượi",
  },
  {
    word: "mát tính",
    part_of_speech: "tính từ",
    meaning:
      "không hay nóng nảy, cáu gắt khi gặp việc trái ý: anh ấy rất mát tính, không cáu gắt với ai bao giờ",
    example: "anh ấy rất mát tính, không cáu gắt với ai bao giờ",
  },
  {
    word: "máu",
    part_of_speech: "danh từ",
    meaning:
      "chất lỏng màu đỏ chảy trong các mạch của người và động vật, có vai trò quan trọng đối với sự sống của cơ thể: một giọt máu đào hơn ao nước lã (tng)",
    example: "một giọt máu đào hơn ao nước lã (tng)",
  },
  {
    word: "máu",
    part_of_speech: "danh từ",
    meaning:
      "cái có vai trò quan trọng trong sự sống của con người, được coi là cái quý nhất của mỗi người: tránh đổ máu vô ích * món nợ máu",
    example: "tránh đổ máu vô ích * món nợ máu",
  },
  {
    word: "máu",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) đặc trưng tâm lí có tính chất cá nhân, khiến con người ta dễ hướng về một hoạt động nào đó một cách không còn biết suy nghĩ gì nữa: có máu cờ bạc * máu tham * máu làm giàu",
    example: "có máu cờ bạc * máu tham * máu làm giàu",
  },
  {
    word: "mau",
    part_of_speech: "tính từ",
    meaning:
      "có thời gian ngắn hơn bình thường để quá trình kết thúc hoặc hoạt động đạt kết quả: vết thương mau lành * cái xe mau hỏng * đàn lợn mau lớn",
    example: "vết thương mau lành * cái xe mau hỏng * đàn lợn mau lớn",
  },
  {
    word: "mau",
    part_of_speech: "tính từ",
    meaning:
      "có tốc độ, nhịp độ trên mức bình thường nên chỉ cần tương đối ít thời gian để hoạt động đạt kết quả: dậy mau kẻo muộn! * làm mau cho kịp * đi mau lên!",
    example: "dậy mau kẻo muộn! * làm mau cho kịp * đi mau lên!",
  },
  {
    word: "mau",
    part_of_speech: "tính từ",
    meaning:
      "có khoảng cách (giữa các yếu tố, các đơn vị) ngắn hơn bình thường: mưa mau hạt * lúa cấy mau hàng",
    example: "mưa mau hạt * lúa cấy mau hàng",
  },
  {
    word: "màu",
    part_of_speech: "danh từ",
    meaning:
      "chất dinh dưỡng có trong đất để nuôi cây trồng: đất bạc màu * ruộng nhiều màu",
    example: "đất bạc màu * ruộng nhiều màu",
  },
  {
    word: "màu",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) hoa màu (nói tắt): trồng màu * ruộng màu (ruộng trồng cây hoa màu)",
    example: "trồng màu * ruộng màu (ruộng trồng cây hoa màu)",
  },
  {
    word: "màu",
    part_of_speech: "danh từ",
    meaning:
      "thuộc tính của vật thể hiện ra nhờ tác động của ánh sáng và nhận biết được bằng mắt, giúp phân biệt vật này với vật khác: màu tím hoa sim * men màu cánh gián * bộ áo dài màu phấn hồng",
    example: "màu tím hoa sim * men màu cánh gián * bộ áo dài màu phấn hồng",
  },
  {
    word: "màu",
    part_of_speech: "danh từ",
    meaning: "chất dùng để tô thành các màu khi vẽ: pha màu * hộp màu",
    example: "pha màu * hộp màu",
  },
  {
    word: "màu",
    part_of_speech: "danh từ",
    meaning:
      "màu, không kể trắng và đen (nói khái quát): bút chì màu * phấn màu * ảnh màu * ti vi màu",
    example: "bút chì màu * phấn màu * ảnh màu * ti vi màu",
  },
  {
    word: "màu",
    part_of_speech: "danh từ",
    meaning:
      'toàn bộ những biểu hiện bên ngoài tạo nên cảm giác có một tính chất nào đó: không khí đượm màu tang tóc * "Chuộng chuối, chuối lại cao tàu, Chuộng em, em lại ra màu làm cao." (ca dao)',
    example:
      'không khí đượm màu tang tóc * "Chuộng chuối, chuối lại cao tàu, Chuộng em, em lại ra màu làm cao." (ca dao)',
  },
  {
    word: "máu cam",
    part_of_speech: "danh từ",
    meaning: "máu chảy từ mũi ra (mà không phải do chấn thương): chảy máu cam",
    example: "chảy máu cam",
  },
  {
    word: "màu cờ sắc áo",
    part_of_speech: "",
    meaning:
      "màu sắc của lá cờ tổ quốc và trang phục thi đấu của các cầu thủ, biểu trưng cho danh dự, thể diện và tinh thần dân tộc trong thể thao: thi đấu hết mình vì màu cờ sắc áo",
    example: "thi đấu hết mình vì màu cờ sắc áo",
  },
  {
    word: "mau chóng",
    part_of_speech: "tính từ",
    meaning:
      "nhanh, chỉ trong một khoảng thời gian ngắn là hoàn thành, là đạt kết quả: làm mau chóng cho xong * bồi dưỡng cho mau chóng lại sức",
    example: "làm mau chóng cho xong * bồi dưỡng cho mau chóng lại sức",
  },
  {
    word: "màu da",
    part_of_speech: "danh từ",
    meaning:
      "màu của da người, vàng, trắng, đen hay đỏ, coi như là đặc trưng để phân biệt các giống người khác nhau trên Trái Đất: không phân biệt chủng tộc, màu da",
    example: "không phân biệt chủng tộc, màu da",
  },
  {
    word: "máu ghen",
    part_of_speech: "danh từ",
    meaning:
      'thói hay ghen tuông: "Bây giờ mới rõ tăm hơi, Máu ghen, đâu có lạ đời nhà ghen!" (TKiều)',
    example:
      'Bây giờ mới rõ tăm hơi, Máu ghen, đâu có lạ đời nhà ghen!" (TKiều)',
  },
  {
    word: "máu huyết",
    part_of_speech: "danh từ",
    meaning: "máu của con người (nói khái quát): anh em cùng máu huyết",
    example: "anh em cùng máu huyết",
  },
  {
    word: "mau lẹ",
    part_of_speech: "tính từ",
    meaning: "nhanh và gọn: ứng biến mau lẹ",
    example: "ứng biến mau lẹ",
  },
  {
    word: "mau mắn",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) tỏ ra nhanh nhẹn, tháo vát: dáng điệu mau mắn",
    example: "dáng điệu mau mắn",
  },
  {
    word: "máu lửa",
    part_of_speech: "danh từ",
    meaning:
      "máu và lửa (nói khái quát); thường dùng để chỉ sự khốc liệt của chiến tranh, của sự đàn áp, khủng bố: chặng đường máu lửa * phong trào yêu nước đã bị dìm trong máu lửa",
    example:
      "chặng đường máu lửa * phong trào yêu nước đã bị dìm trong máu lửa",
  },
  {
    word: "máu mê",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) ham mê các trò chơi, thường là cờ bạc, đến mức không còn biết gì đến những việc khác: máu mê cờ bạc",
    example: "máu mê cờ bạc",
  },
  {
    word: "màu mè",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) có cái đẹp nhờ tô vẽ nhiều màu sắc (thường hàm ý chê): trang trí rất màu mè",
    example: "trang trí rất màu mè",
  },
  {
    word: "màu mè",
    part_of_speech: "tính từ",
    meaning:
      "(cách nói năng, cư xử) có tính chất hình thức, khách sáo, không chân thật: ăn nói màu mè * lối sống chân chất, không màu mè",
    example: "ăn nói màu mè * lối sống chân chất, không màu mè",
  },
  {
    word: "màu mẽ",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như màu mè: cách nói văn hoa màu mẽ",
    example: "cách nói văn hoa màu mẽ",
  },
  {
    word: "máu me",
    part_of_speech: "danh từ",
    meaning: "máu đổ ra, dây ra nhiều (nói khái quát): máu me bê bết",
    example: "máu me bê bết",
  },
  {
    word: "mau miệng",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) nhanh nhẹn trong đối đáp, nói năng: mau miệng hỏi trước",
    example: "mau miệng hỏi trước",
  },
  {
    word: "màu mỡ",
    part_of_speech: "tính từ",
    meaning:
      "(ruộng đất) giàu chất dinh dưỡng, thuận lợi cho cây trồng phát triển: đất đai màu mỡ * cánh đồng màu mỡ",
    example: "đất đai màu mỡ * cánh đồng màu mỡ",
  },
  {
    word: "máu mủ",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ mối quan hệ giữ những người có cùng dòng máu (nói khái quát): tình máu mủ * quan hệ máu mủ",
    example: "tình máu mủ * quan hệ máu mủ",
  },
  {
    word: "máu mủ",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để ví công sức, tinh lực của người lao động đã bỏ ra để làm nên của cải vật chất: đem mồ hôi máu mủ để kiếm sống * hút máu hút mủ (bóc lột một cách thậm tệ)",
    example:
      "đem mồ hôi máu mủ để kiếm sống * hút máu hút mủ (bóc lột một cách thậm tệ)",
  },
  {
    word: "màu nước",
    part_of_speech: "danh từ",
    meaning:
      "chất liệu hội hoạ có dạng dẻo, dùng pha với nước để vẽ: tranh màu nước",
    example: "tranh màu nước",
  },
  {
    word: "máu nóng",
    part_of_speech: "danh từ",
    meaning: "như nhiệt huyết: bầu máu nóng * hun sôi máu nóng của tuổi trẻ",
    example: "bầu máu nóng * hun sôi máu nóng của tuổi trẻ",
  },
  {
    word: "máu xương",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như xương máu: kinh nghiệm máu xương",
    example: "kinh nghiệm máu xương",
  },
  {
    word: "màu sắc",
    part_of_speech: "danh từ",
    meaning: "các màu nói chung: bức tranh có nhiều màu sắc * màu sắc rực rỡ",
    example: "bức tranh có nhiều màu sắc * màu sắc rực rỡ",
  },
  {
    word: "màu sắc",
    part_of_speech: "danh từ",
    meaning: "tính chất đặc thù: màu sắc dân tộc * màu sắc tôn giáo",
    example: "màu sắc dân tộc * màu sắc tôn giáo",
  },
  {
    word: "máu thịt",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để ví mối quan hệ xã hội gắn bó thân thiết, không thể tách rời: gắn bó máu thịt * quan hệ máu thịt giữa các dân tộc anh em",
    example: "gắn bó máu thịt * quan hệ máu thịt giữa các dân tộc anh em",
  },
  {
    word: "máu thịt",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để chỉ phần tình cảm sâu sắc nhất ở mỗi con người: thói quen đã ngấm vào máu thịt",
    example: "thói quen đã ngấm vào máu thịt",
  },
  {
    word: "mày",
    part_of_speech: "danh từ",
    meaning: "(văn chương) lông mày (nói tắt): mặt ủ, mày chau",
    example: "mặt ủ, mày chau",
  },
  {
    word: "mày",
    part_of_speech: "danh từ",
    meaning:
      "lá bắc ở hoa các cây như ngô, lúa, về sau tồn tại dưới dạng hai vảy nhỏ ở gốc quả (loại quả này thường được gọi quen là hạt): mày ngô * mày thóc",
    example: "mày ngô * mày thóc",
  },
  {
    word: "mày",
    part_of_speech: "đại từ",
    meaning:
      "từ dùng để gọi người ngang hàng hoặc hàng dưới khi nói với người ấy, tỏ ý thân mật hoặc coi thường, coi khinh: mai mày đến tao chơi * không thầy đố mày làm nên (tng)",
    example: "mai mày đến tao chơi * không thầy đố mày làm nên (tng)",
  },
  {
    word: "máy",
    part_of_speech: "danh từ",
    meaning:
      "vật được chế tạo gồm nhiều bộ phận, thường là phức tạp, dùng để thực hiện chính xác hoặc hàng loạt một công việc chuyên môn nào đó: máy cày * máy phát điện",
    example: "máy cày * máy phát điện",
  },
  {
    word: "máy",
    part_of_speech: "tính từ",
    meaning:
      "được làm bằng máy, qua xử lí bằng máy: thêu máy * nước máy * cày máy",
    example: "thêu máy * nước máy * cày máy",
  },
  {
    word: "máy",
    part_of_speech: "động từ",
    meaning: "(Khẩu ngữ) may bằng máy khâu: máy quần áo * máy rèm cửa",
    example: "máy quần áo * máy rèm cửa",
  },
  {
    word: "máy",
    part_of_speech: "động từ",
    meaning:
      "(mắt, môi, v.v.) tự nhiên thấy giật, thấy rung động khẽ: máy mắt * cái thai trong bụng đã bắt đầu máy",
    example: "máy mắt * cái thai trong bụng đã bắt đầu máy",
  },
  {
    word: "máy",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) ra hiệu ngầm bảo hoặc báo cho nhau biết hay làm điều gì: máy nhau lẻn đi * máy nhau không nói",
    example: "máy nhau lẻn đi * máy nhau không nói",
  },
  {
    word: "mảy",
    part_of_speech: "danh từ",
    meaning:
      "phần, lượng rất nhỏ, không đáng kể: mảy gạo * không sướt một mảy da",
    example: "mảy gạo * không sướt một mảy da",
  },
  {
    word: "may",
    part_of_speech: "danh từ",
    meaning: "(văn chương) heo may (nói tắt): hơi may hiu hắt",
    example: "hơi may hiu hắt",
  },
  {
    word: "may",
    part_of_speech: "danh từ",
    meaning:
      "điều tốt lành tình cờ đưa đến đúng lúc: gặp may * dịp may hiếm có * cầu may * may ít rủi nhiều",
    example: "gặp may * dịp may hiếm có * cầu may * may ít rủi nhiều",
  },
  {
    word: "may",
    part_of_speech: "tính từ",
    meaning:
      "ở vào tình hình gặp được điều tốt lành: số may * gặp chuyện không may",
    example: "số may * gặp chuyện không may",
  },
  {
    word: "may",
    part_of_speech: "động từ",
    meaning:
      "dùng kim chỉ kết các mảnh vải, lụa, v.v. thành quần áo hoặc đồ dùng: thợ may * may rèm cửa",
    example: "thợ may * may rèm cửa",
  },
  {
    word: "máu tham",
    part_of_speech: "danh từ",
    meaning:
      'thói hay tham lam: nổi máu tham * "Mụ càng tô lục chuốt hồng, Máu tham hễ thấy hơi đồng là mê." (TKiều)',
    example:
      'nổi máu tham * "Mụ càng tô lục chuốt hồng, Máu tham hễ thấy hơi đồng là mê." (TKiều)',
  },
  {
    word: "máy ảnh",
    part_of_speech: "danh từ",
    meaning: "dụng cụ dùng để chụp ảnh: máy ảnh kĩ thuật số",
    example: "máy ảnh kĩ thuật số",
  },
  {
    word: "máy bơm",
    part_of_speech: "danh từ",
    meaning:
      "máy chạy bằng động cơ (thường là động cơ điện), dùng để bơm nước hoặc chất lỏng từ nơi này đến nơi khác: trạm máy bơm",
    example: "trạm máy bơm",
  },
  {
    word: "máy chữ",
    part_of_speech: "danh từ",
    meaning:
      "dụng cụ dùng để in chữ bằng cách đập những chữ đúc nổi lên giấy qua một băng tẩm mực, có thể có được nhiều bản trong một lúc bằng cách lót giấy than giữa các tờ giấy trắng: đánh máy chữ",
    example: "đánh máy chữ",
  },
  {
    word: "may công nghiệp",
    part_of_speech: "động từ",
    meaning:
      "may theo quy trình dây chuyền khép kín với các thiết bị, máy móc hiện đại: sản phẩm may công nghiệp",
    example: "sản phẩm may công nghiệp",
  },
  {
    word: "mày đay",
    part_of_speech: "danh từ",
    meaning:
      "chứng nổi từng đám trên mặt da, gây ngứa ngáy, thường do dị ứng: chân tay nổi đầy mày đay",
    example: "chân tay nổi đầy mày đay",
  },
  {
    word: "may đo",
    part_of_speech: "động từ",
    meaning:
      "may quần áo theo kích thước cụ thể của từng người (nói khái quát); phân biệt với may sẵn: cửa hàng may đo",
    example: "cửa hàng may đo",
  },
  {
    word: "máy in",
    part_of_speech: "danh từ",
    meaning:
      "máy dùng để in các văn bản, tài liệu, hình ảnh ra giấy: máy in màu * máy in kim",
    example: "máy in màu * máy in kim",
  },
  {
    word: "máy huyền vi",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) từ dùng để chỉ tạo hoá: "Kìa thế cục như in giấc mộng, Máy huyền vi mở đóng khôn lường." (CO)',
    example:
      'Kìa thế cục như in giấc mộng, Máy huyền vi mở đóng khôn lường." (CO)',
  },
  {
    word: "máy lạnh",
    part_of_speech: "danh từ",
    meaning: "máy làm lạnh nhân tạo: hệ thống máy lạnh của xe chở hàng hải sản",
    example: "hệ thống máy lạnh của xe chở hàng hải sản",
  },
  {
    word: "máy lạnh",
    part_of_speech: "danh từ",
    meaning:
      "(Nam) máy điều hoà nhiệt độ (về mặt làm mát không khí): phòng ngủ có lắp máy lạnh",
    example: "phòng ngủ có lắp máy lạnh",
  },
  {
    word: "máy liên hợp",
    part_of_speech: "danh từ",
    meaning:
      "tổ hợp máy gồm nhiều máy, thực hiện đồng thời nhiều loại công việc khác nhau: máy liên hợp gặt - đập",
    example: "máy liên hợp gặt - đập",
  },
  {
    word: "may mặc",
    part_of_speech: "động từ",
    meaning:
      "may quần áo, trang phục để phục vụ cho việc ăn mặc (nói khái quát): hàng may mặc * ngành may mặc",
    example: "hàng may mặc * ngành may mặc",
  },
  {
    word: "may mà",
    part_of_speech: "",
    meaning:
      "tổ hợp biểu thị điều sắp nói đến là một thực tế đã xảy ra, và đó là điều may mắn: may mà anh ấy đến kịp * xe đổ, may mà không ai bị thương",
    example: "may mà anh ấy đến kịp * xe đổ, may mà không ai bị thương",
  },
  {
    word: "mảy may",
    part_of_speech: "danh từ",
    meaning:
      "phần, lượng rất nhỏ, hoàn toàn không đáng kể (thường dùng để nhấn mạnh ý phủ định): không một chút mảy may thương xót * hết sạch, chẳng còn một mảy may",
    example:
      "không một chút mảy may thương xót * hết sạch, chẳng còn một mảy may",
  },
  {
    word: "máy móc",
    part_of_speech: "danh từ",
    meaning:
      "máy (nói khái quát): máy móc vẫn hoạt động tốt * nhà máy được trang bị máy móc hiện đại",
    example:
      "máy móc vẫn hoạt động tốt * nhà máy được trang bị máy móc hiện đại",
  },
  {
    word: "máy móc",
    part_of_speech: "tính từ",
    meaning:
      "thiếu linh hoạt, sáng tạo, chỉ biết nói, làm theo đúng những gì đã có sẵn, đã quy định: áp dụng một cách máy móc * cách làm việc máy móc",
    example: "áp dụng một cách máy móc * cách làm việc máy móc",
  },
  {
    word: "mày mò",
    part_of_speech: "động từ",
    meaning:
      "dò tìm một cách kiên nhẫn, tỉ mỉ để làm việc gì: mày mò mãi rồi cũng làm được",
    example: "mày mò mãi rồi cũng làm được",
  },
  {
    word: "mày mặt",
    part_of_speech: "danh từ",
    meaning: "(hiếm) như mặt mày: cái tát làm tối tăm cả mày mặt",
    example: "cái tát làm tối tăm cả mày mặt",
  },
  {
    word: "mày ngài",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, văn chương) tả lông mày đẹp của người phụ nữ, nhỏ, dài và cong như râu con ngài; cũng dùng để chỉ người con gái đẹp: mắt phượng, mày ngài",
    example: "mắt phượng, mày ngài",
  },
  {
    word: "mày ngài",
    part_of_speech: "danh từ",
    meaning:
      'tả lông mày rậm của bậc trượng phu, to và cong như con tằm: "Râu hùm, hàm én, mày ngài, Vai năm tấc rộng, thân mười thước cao." (TKiều)',
    example:
      'Râu hùm, hàm én, mày ngài, Vai năm tấc rộng, thân mười thước cao." (TKiều)',
  },
  {
    word: "may mắn",
    part_of_speech: "tính từ",
    meaning: "may (nói khái quát): chúc lên đường may mắn! * cơ hội may mắn",
    example: "chúc lên đường may mắn! * cơ hội may mắn",
  },
  {
    word: "máy nói",
    part_of_speech: "danh từ",
    meaning: "(cũ, khẩu ngữ) điện thoại: trực máy nói",
    example: "trực máy nói",
  },
  {
    word: "máy nước",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, hoặc ph) chỗ có lắp vòi nước để lấy nước máy nơi công cộng: máy nước công cộng",
    example: "máy nước công cộng",
  },
  {
    word: "mày râu",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, hoặc kng) lông mày và râu (nói khái quát); dùng để chỉ giới đàn ông, cho là phải có khí phách, khác với giới phụ nữ yếu ớt: phái mày râu",
    example: "phái mày râu",
  },
  {
    word: "may rủi",
    part_of_speech: "",
    meaning:
      "chỉ tuỳ thuộc vào ngẫu nhiên, vào sự may hay rủi mà được hay không được (nói khái quát): phó mặc cho may rủi",
    example: "phó mặc cho may rủi",
  },
  {
    word: "may ra",
    part_of_speech: "",
    meaning:
      "tổ hợp biểu thị ý hi vọng một kết quả tốt đẹp có thể xảy ra: ngần này may ra thì đủ",
    example: "ngần này may ra thì đủ",
  },
  {
    word: "may sao",
    part_of_speech: "",
    meaning:
      "may mắn làm sao mà: may sao vừa kịp giờ * cứ tưởng thi trượt, may sao lại vừa đủ điểm đỗ",
    example:
      "may sao vừa kịp giờ * cứ tưởng thi trượt, may sao lại vừa đủ điểm đỗ",
  },
  {
    word: "máy thu hình",
    part_of_speech: "danh từ",
    meaning:
      "thiết bị điện có màn hình, trên đó có thể xem các chương trình có âm thanh và hình ảnh chuyển động: cái ti vi màu * loại ti vi 21 inch * chương trình ti vi (= phát trên ti vi)",
    example: "cái ti vi màu * loại ti vi 21 inch *",
  },
  {
    word: "may sẵn",
    part_of_speech: "động từ",
    meaning:
      "may quần áo hàng loạt, theo những cỡ nhất định chứ không theo kích thước cụ thể của từng người (nói khái quát); phân biệt với may đo: quần áo may sẵn * toàn mua đồ may sẵn",
    example: "quần áo may sẵn * toàn mua đồ may sẵn",
  },
  {
    word: "máy tay",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tiện tay làm một cách tự nhiên, ngoài ý định: thấy hoa đẹp, máy tay ngắt một bông",
    example: "thấy hoa đẹp, máy tay ngắt một bông",
  },
  {
    word: "máy tính",
    part_of_speech: "danh từ",
    meaning:
      "máy thực hiện tự động các phép tính: thí sinh được phép mang máy tính vào phòng thi",
    example: "thí sinh được phép mang máy tính vào phòng thi",
  },
  {
    word: "máy tính",
    part_of_speech: "danh từ",
    meaning:
      "máy vi tính (nói tắt): các thông tin được lưu trữ trong bộ nhớ của máy tính",
    example: "các thông tin được lưu trữ trong bộ nhớ của máy tính",
  },
  {
    word: "may vá",
    part_of_speech: "động từ",
    meaning: "may và vá quần áo (nói khái quát): học cách may vá",
    example: "học cách may vá",
  },
  {
    word: "mắc",
    part_of_speech: "động từ",
    meaning:
      "móc vào để treo, giữ: mắc màn * mắc võng * mắc tờ lịch vào cái đinh",
    example: "mắc màn * mắc võng * mắc tờ lịch vào cái đinh",
  },
  {
    word: "mắc",
    part_of_speech: "động từ",
    meaning:
      "bị giữ lại, bị cản trở hoạt động đến mức khó gỡ ra, khó thoát khỏi: mắc mưu * đang định đi lại mắc mưa * như gà mắc tóc",
    example: "mắc mưu * đang định đi lại mắc mưa * như gà mắc tóc",
  },
  {
    word: "mắc",
    part_of_speech: "động từ",
    meaning: "dàn sợi ra và quấn vào trục cho đủ số sợi dệt một khổ vải.",
    example: "đang mắc, chưa đi được * Tao mắc học rồi, không đi chơi được.",
  },
  {
    word: "mắc",
    part_of_speech: "động từ",
    meaning:
      "(Nam) vướng vào một công việc nào đó, khiến cho không hoạt động dễ dàng, tự do được như bình thường: đang mắc, chưa đi được * Tao mắc học rồi, không đi chơi được.",
    example: "mang công, mắc nợ * mắc chị ấy một khoản tiền",
  },
  {
    word: "mắc",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) nợ, thiếu nợ: mang công, mắc nợ * mắc chị ấy một khoản tiền",
    example: "mắc tiểu",
  },
  {
    word: "mắc",
    part_of_speech: "danh từ",
    meaning: "mắc áo (nói tắt): treo áo lên mắc",
    example: "treo áo lên mắc",
  },
  {
    word: "mắc",
    part_of_speech: "tính từ",
    meaning: "(Nam) (giá cả) đắt: giá mắc quá!",
    example: "giá mắc quá!",
  },
  {
    word: "mặc",
    part_of_speech: "động từ",
    meaning:
      "khoác quần áo vào để che thân mình: học sinh mặc đồng phục đến trường * mặc thêm áo ấm",
    example: "học sinh mặc đồng phục đến trường * mặc thêm áo ấm",
  },
  {
    word: "mặc",
    part_of_speech: "động từ",
    meaning:
      "để tuỳ ý, không can thiệp vào hoặc không biết gì đến: để mặc, không đả động gì đến * nó muốn đi đâu, mặc nó",
    example: "để mặc, không đả động gì đến * nó muốn đi đâu, mặc nó",
  },
  {
    word: "mặc",
    part_of_speech: "động từ",
    meaning:
      'không để ý đến, coi như không có: dư luận thế nào cũng mặc, không để ý đến * "Trời mưa thì mặc trời mưa, Chồng tôi đi bừa đã có áo tơi." (ca dao)',
    example:
      'dư luận thế nào cũng mặc, không để ý đến * "Trời mưa thì mặc trời mưa, Chồng tôi đi bừa đã có áo tơi." (ca dao)',
  },
  {
    word: "mặc cảm",
    part_of_speech: "",
    meaning:
      "thầm nghĩ rằng mình không được bằng người nên cảm thấy buồn tủi trong lòng: mặc cảm tội lỗi * xoá hết mọi mặc cảm",
    example: "mặc cảm tội lỗi * xoá hết mọi mặc cảm",
  },
  {
    word: "mắc cạn",
    part_of_speech: "động từ",
    meaning:
      "(tàu, thuyền) bị vướng vào chỗ nước cạn không đi được nữa: thuyền bị mắc cạn",
    example: "thuyền bị mắc cạn",
  },
  {
    word: "mặc cả",
    part_of_speech: "động từ",
    meaning:
      "(Nam trả giá) trả giá thêm bớt từng ít một để mong mua được rẻ: cửa hàng bán theo giá niêm yết, miễn mặc cả",
    example: "cửa hàng bán theo giá niêm yết, miễn mặc cả",
  },
  {
    word: "mặc cả",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) thảo luận thêm bớt từng điều kiện chi tiết, với ý tính toán thiệt hơn, trước khi thoả thuận: cuộc mặc cả chính trị giữa hai phe phái",
    example: "cuộc mặc cả chính trị giữa hai phe phái",
  },
  {
    word: "mắc công",
    part_of_speech: "động từ",
    meaning:
      "bỏ thời gian và công sức ra làm việc gì một cách vô ích, không có hiệu quả: mất công tìm kiếm * nó không về đâu, đợi làm gì (cho) mất công",
    example: "mất công tìm kiếm * nó không về đâu, đợi làm gì (cho) mất công",
  },
  {
    word: "mắc công",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) để tránh chuyện không hay nêu ra sau đó; kẻo: Đừng chửi nó nhiều, mất công nó nghĩ quẩn bỏ nhà đi. * Nói với bà ấy một tiếng, mất công bà ấy trách! * Tao làm luôn rồi, mất công mày nói này nói nọ!",
    example:
      "Đừng chửi nó nhiều, mất công nó nghĩ quẩn bỏ nhà đi. * Nói với bà ấy một tiếng, mất công bà ấy trách! * Tao làm luôn rồi, mất công mày nói này nói nọ!",
  },
  {
    word: "mắc cửi",
    part_of_speech: "động từ",
    meaning:
      'mắc sợi trên khung cửi; thường dùng để ví hoạt động qua lại đông đúc và nhiều chiều, không lúc nào ngớt: xe chạy như mắc cửi * "Phồn hoa thứ nhất Long Thành, Phố giăng mắc cửi, đường quanh bàn cờ." (ca dao)',
    example:
      'xe chạy như mắc cửi * "Phồn hoa thứ nhất Long Thành, Phố giăng mắc cửi, đường quanh bàn cờ." (ca dao)',
  },
  {
    word: "mặc kệ",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) để cho tuỳ ý và tự chịu trách nhiệm lấy, coi như không biết gì, không can thiệp gì đến: nó làm gì mặc kệ nó",
    example: "nó làm gì mặc kệ nó",
  },
  {
    word: "mặc kệ",
    part_of_speech: "động từ",
    meaning:
      "không để ý đến, coi như chẳng ảnh hưởng đến việc mình làm: trời nắng hay mưa cũng mặc kệ, cứ đi",
    example: "trời nắng hay mưa cũng mặc kệ, cứ đi",
  },
  {
    word: "mắc dịch",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ, khẩu ngữ) bị mắc dịch bệnh mà chết; thường dùng làm tiếng chửi rủa: tụi lính mắc dịch * đồ mắc dịch!",
    example: "tụi lính mắc dịch * đồ mắc dịch!",
  },
  {
    word: "mắc cười",
    part_of_speech: "động từ",
    meaning: "(phương ngữ, khẩu ngữ) buồn cười: cái mặt hắn mắc cười quá hà!",
    example: "cái mặt hắn mắc cười quá hà!",
  },
  {
    word: "mắc cỡ",
    part_of_speech: "động từ",
    meaning:
      "cảm thấy hổ thẹn khi thấy mình có lỗi hoặc kém cỏi trước người khác: xấu hổ vì đã nói dối * con hư làm cha mẹ xấu hổ",
    example: "xấu hổ vì đã nói dối * con hư làm cha mẹ xấu hổ",
  },
  {
    word: "mắc cỡ",
    part_of_speech: "động từ",
    meaning: "ngượng ngùng, e thẹn: tính hay xấu hổ * mặt đỏ bừng vì xấu hổ",
    example: "tính hay xấu hổ * mặt đỏ bừng vì xấu hổ",
  },
  {
    word: "mặc dù",
    part_of_speech: "kết từ",
    meaning:
      "từ biểu thị quan hệ trái ngược giữa điều kiện và sự việc, để nhấn mạnh sự việc dù sao vẫn xảy ra: mặc dù trời mưa, nó vẫn đi",
    example: "mặc dù trời mưa, nó vẫn đi",
  },
  {
    word: "mặc định",
    part_of_speech: "động từ",
    meaning:
      "định sẵn các thông số, giá trị ở mức phổ biến để có thể sử dụng ngay được (thường dùng trong máy tính): ảnh nền mặc định * mặc định phông chữ",
    example: "ảnh nền mặc định * mặc định phông chữ",
  },
  {
    word: "mặc lòng",
    part_of_speech: "",
    meaning:
      'tổ hợp biểu thị điều vừa nói đến cũng không có tác động gì làm cho có sự thay đổi đối với việc làm sắp nêu ra: "Còn duyên kẻ đón người đưa, Hết duyên đi sớm về trưa mặc lòng." (ca dao)',
    example:
      'Còn duyên kẻ đón người đưa, Hết duyên đi sớm về trưa mặc lòng." (ca dao)',
  },
  {
    word: "mặc khách",
    part_of_speech: "danh từ",
    meaning: "(cũ, văn chương) khách văn chương: một trang phong lưu mặc khách",
    example: "một trang phong lưu mặc khách",
  },
  {
    word: "mắc lỡm",
    part_of_speech: "động từ",
    meaning: "bị lỡm: bị mắc lỡm",
    example: "bị mắc lỡm",
  },
  {
    word: "mắc kẹt",
    part_of_speech: "động từ",
    meaning:
      'bị kẹt ở giữa không thoát ra, không qua được: mắc kẹt giữa đám đông * "Chớ nghe lời phỉnh tiếng phờ, Thò tay vào lờ mắc kẹt cái hom." (ca dao)',
    example:
      'mắc kẹt giữa đám đông * "Chớ nghe lời phỉnh tiếng phờ, Thò tay vào lờ mắc kẹt cái hom." (ca dao)',
  },
  {
    word: "mắc lừa",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) bị lừa, bị đánh lừa: khôn ngoan thế mà vẫn bị mắc lừa",
    example: "khôn ngoan thế mà vẫn bị mắc lừa",
  },
  {
    word: "mắc mỏ",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) đắt đỏ: giá cả mắc mỏ",
    example: "giá cả mắc mỏ",
  },
  {
    word: "mắc mứu",
    part_of_speech: "động từ",
    meaning:
      "cảm thấy có điều làm cho phải băn khoăn, phải suy nghĩ: còn mắc mứu về cách giải quyết",
    example: "còn mắc mứu về cách giải quyết",
  },
  {
    word: "mắc mứu",
    part_of_speech: "danh từ",
    meaning:
      "điều cảm thấy còn băn khoăn, thường không lớn nhưng kéo dài: giải quyết dứt điểm những mắc mứu trong công việc",
    example: "giải quyết dứt điểm những mắc mứu trong công việc",
  },
  {
    word: "mặc nhiên",
    part_of_speech: "phụ từ",
    meaning:
      "tự hiểu ngầm với nhau là như vậy, không cần nói rõ bằng lời: không phản đối là mặc nhiên đồng ý",
    example: "không phản đối là mặc nhiên đồng ý",
  },
  {
    word: "mặc nhiên",
    part_of_speech: "tính từ",
    meaning:
      "(hiếm) không tỏ một thái độ nào cả, coi như là việc chẳng có quan hệ gì đến mình: chuyện đến thế mà vẫn mặc nhiên như không",
    example: "chuyện đến thế mà vẫn mặc nhiên như không",
  },
  {
    word: "mắc mớ",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ) có quan hệ đến, có dính dáng đến (thường là điều không hay): chuyện của tụi tao, mắc mớ chi tới mày mà xía vô?",
    example: "chuyện của tụi tao, mắc mớ chi tới mày mà xía vô?",
  },
  {
    word: "mắc mớ",
    part_of_speech: "danh từ",
    meaning:
      "điều không hay có dính dáng đến: giải quyết những mắc mớ nhỏ nhặt",
    example: "giải quyết những mắc mớ nhỏ nhặt",
  },
  {
    word: "mắc mưu",
    part_of_speech: "động từ",
    meaning: "bị lừa, bị trúng mưu kế (của ai đó): bị mắc mưu kẻ gian",
    example: "bị mắc mưu kẻ gian",
  },
  {
    word: "mặc niệm",
    part_of_speech: "động từ",
    meaning:
      "tưởng nhớ người đã mất trong tư thế nghiêm trang, lặng lẽ: cúi đầu mặc niệm * dành một phút mặc niệm những người đã khuất",
    example: "cúi đầu mặc niệm * dành một phút mặc niệm những người đã khuất",
  },
  {
    word: "mắc ói",
    part_of_speech: "tính từ",
    meaning: "ở trạng thái cảm thấy muốn nôn: chóng mặt, buồn nôn",
    example: "chóng mặt, buồn nôn",
  },
  {
    word: "mặc sức",
    part_of_speech: "phụ từ",
    meaning:
      "một cách hoàn toàn tuỳ thích, không bị ngăn trở, hạn chế: mặc sức tung hoành",
    example: "mặc sức tung hoành",
  },
  {
    word: "mặc xác",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) như mặc kệ (hàm ý coi khinh): nó muốn sống thế nào thì mặc xác nó",
    example: "nó muốn sống thế nào thì mặc xác nó",
  },
  {
    word: "mặc thây",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) như mặc (ng1; hàm ý coi khinh): muốn đi đâu thì đi, mặc thây nó",
    example: "muốn đi đâu thì đi, mặc thây nó",
  },
  {
    word: "măm",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) ăn (chỉ nói về trẻ còn bé, răng chưa đủ): cho bé măm",
    example: "cho bé măm",
  },
  {
    word: "mặc tình",
    part_of_speech: "phụ từ",
    meaning: "(phương ngữ) mặc sức: được mặc tình bay nhảy",
    example: "được mặc tình bay nhảy",
  },
  {
    word: "mắm",
    part_of_speech: "danh từ",
    meaning:
      "cây nhỡ mọc ở vùng đầm lầy ven biển, rễ trồi lên khỏi mặt bùn; thường được trồng để bảo vệ đê ở vùng nước mặn: rừng mắm",
    example: "rừng mắm",
  },
  {
    word: "mắm",
    part_of_speech: "danh từ",
    meaning:
      "thức ăn làm bằng tôm cá sống ướp muối và để lâu ngày cho ngấu: mắm tôm * mắm cá cơm * mắm tép chưng thịt * liệu cơm gắp mắm (tng)",
    example:
      "mắm tôm * mắm cá cơm * mắm tép chưng thịt * liệu cơm gắp mắm (tng)",
  },
  {
    word: "mắm",
    part_of_speech: "danh từ",
    meaning: "cá đã ướp muối làm mắm: người gầy như con mắm",
    example: "người gầy như con mắm",
  },
  {
    word: "mắm",
    part_of_speech: "động từ",
    meaning:
      "ngậm chặt môi, miệng lại cố nén sự tức giận hay đang gắng hết sức để làm việc gì: mắm môi nín nhịn * mắm môi mắm lợi kéo chiếc xe lên dốc",
    example: "mắm môi nín nhịn * mắm môi mắm lợi kéo chiếc xe lên dốc",
  },
  {
    word: "mặc ý",
    part_of_speech: "động từ",
    meaning:
      "để mặc cho tuỳ ý, muốn thế nào cũng được: mặc ý lo liệu * mày muốn làm gì mặc ý mày",
    example: "mặc ý lo liệu * mày muốn làm gì mặc ý mày",
  },
  {
    word: "mắm muối",
    part_of_speech: "danh từ",
    meaning:
      "mắm và muối (nói khái quát); cũng dùng để ví phần thêm vào câu chuyện kể cho đỡ nhạt nhẽo hoặc cho được đậm đà: câu chuyện được thêm mắm thêm muối cho hấp dẫn",
    example: "câu chuyện được thêm mắm thêm muối cho hấp dẫn",
  },
  {
    word: "mắm tôm",
    part_of_speech: "danh từ",
    meaning:
      "mắm có màu nâu sẫm, làm bằng loại tôm biển nhỏ (gọi là moi) để thật ngấu, có mùi rất đặc biệt: gắt như mắm tôm (tng)",
    example: "gắt như mắm tôm (tng)",
  },
  {
    word: "mặn",
    part_of_speech: "tính từ",
    meaning:
      "có vị như vị của muối biển: nước mặn * khử mặn cho đất * vị mặn của muối",
    example: "nước mặn * khử mặn cho đất * vị mặn của muối",
  },
  {
    word: "mặn",
    part_of_speech: "tính từ",
    meaning:
      "(thức ăn) có độ mặn trên mức bình thường: nồi cá kho hơi mặn * đời cha ăn mặn, đời con khát nước (tng)",
    example: "nồi cá kho hơi mặn * đời cha ăn mặn, đời con khát nước (tng)",
  },
  {
    word: "mặn",
    part_of_speech: "tính từ",
    meaning:
      "(ăn uống) có thịt, cá hay những thức ăn có nguồn gốc động vật, nói chung; phân biệt với chay: tiệc mặn * ăn mặn nói ngay còn hơn ăn chay nói dối (tng)",
    example: "tiệc mặn * ăn mặn nói ngay còn hơn ăn chay nói dối (tng)",
  },
  {
    word: "mặn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có tình cảm nồng nàn, tha thiết: mặn tình * không mặn chuyện",
    example: "mặn tình * không mặn chuyện",
  },
  {
    word: "mắn",
    part_of_speech: "tính từ",
    meaning:
      "(người) dễ chửa đẻ và chửa đẻ nhiều lần, lần sau cách lần trước chỉ một thời gian ngắn: mắn đẻ",
    example: "mắn đẻ",
  },
  {
    word: "mằn",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) nắn: mằn các khớp xương",
    example: "mằn các khớp xương",
  },
  {
    word: "mặn miệng",
    part_of_speech: "tính từ",
    meaning:
      "mặn vừa phải, ngon miệng và có tác dụng kích thích muốn ăn thêm: bữa cơm có mắm chưng, ăn thấy mặn miệng",
    example: "bữa cơm có mắm chưng, ăn thấy mặn miệng",
  },
  {
    word: "mẳn",
    part_of_speech: "danh từ",
    meaning:
      'mảnh hạt, thường là hạt tấm rất nhỏ, vụn: ăn tấm, ăn mẳn * "Tiếc công vãi mẳn cho cu, Cu ăn, cu lớn, cu gù nhau đi." (ca dao)',
    example:
      'ăn tấm, ăn mẳn * "Tiếc công vãi mẳn cho cu, Cu ăn, cu lớn, cu gù nhau đi." (ca dao)',
  },
  {
    word: "mặn mòi",
    part_of_speech: "tính từ",
    meaning:
      "(phương ngữ) như mặn mà: thịt kho mặn mòi * vẻ đẹp mặn mòi, chất phác",
    example: "thịt kho mặn mòi * vẻ đẹp mặn mòi, chất phác",
  },
  {
    word: "măn mẳn",
    part_of_speech: "tính từ",
    meaning: "(hiếm) như mằn mặn: nồi cá kho hơi măn mẳn",
    example: "nồi cá kho hơi măn mẳn",
  },
  {
    word: "mằn mặn",
    part_of_speech: "tính từ",
    meaning: "có vị hơi mặn: bát canh mằn mặn",
    example: "bát canh mằn mặn",
  },
  {
    word: "mằn thắn",
    part_of_speech: "danh từ",
    meaning:
      "món ăn làm bằng thịt giã hoặc băm nhỏ bao trong bột, ăn với nước dùng: mì mằn thắn",
    example: "mì mằn thắn",
  },
  {
    word: "mặn chát",
    part_of_speech: "tính từ",
    meaning: "mặn đến mức cảm thấy như chát ở lưỡi: canh mặn chát",
    example: "canh mặn chát",
  },
  {
    word: "mắng",
    part_of_speech: "động từ",
    meaning:
      "dùng những lời nói nặng, to tiếng để nêu ra lỗi của người dưới: mắng con * mắng như tát nước vào mặt (tng)",
    example: "mắng con * mắng như tát nước vào mặt (tng)",
  },
  {
    word: "mặn nồng",
    part_of_speech: "tính từ",
    meaning:
      '(văn chương) (tình cảm, tình nghĩa) đậm đà, thắm thiết: tình cảm mặn nồng * "Chờ chờ đợi đợi trông trông, Bao nhiêu chờ đợi, mặn nồng bấy nhiêu." (ca dao)',
    example:
      'tình cảm mặn nồng * "Chờ chờ đợi đợi trông trông, Bao nhiêu chờ đợi, mặn nồng bấy nhiêu." (ca dao)',
  },
  {
    word: "mặn mà",
    part_of_speech: "tính từ",
    meaning: "mặn vừa phải, ăn thấy vừa miệng và ngon: món cá kho rất mặn mà",
    example: "món cá kho rất mặn mà",
  },
  {
    word: "mặn mà",
    part_of_speech: "tính từ",
    meaning:
      'dễ ưa, dễ mến, và càng nghe, càng nhìn, càng thấy ưa, thấy mến: ăn nói mặn mà, có duyên * "Bóng hồng nhác thấy nẻo xa, Xuân lan, thu cúc, mặn mà cả hai." (TKiều)',
    example:
      'ăn nói mặn mà, có duyên * "Bóng hồng nhác thấy nẻo xa, Xuân lan, thu cúc, mặn mà cả hai." (TKiều)',
  },
  {
    word: "mặn mà",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra có tình cảm chân thật và thắm thiết đối với ai đó: cuộc tiếp đón mặn mà * cách nói chuyện tỏ ra không mấy mặn mà",
    example: "cuộc tiếp đón mặn mà * cách nói chuyện tỏ ra không mấy mặn mà",
  },
  {
    word: "măng",
    part_of_speech: "danh từ",
    meaning:
      "mầm tre, vầu, v.v. mới mọc từ gốc lên, có thể dùng làm rau ăn: vịt xáo măng * tre già măng mọc (tng)",
    example: "vịt xáo măng * tre già măng mọc (tng)",
  },
  {
    word: "mắng nhiếc",
    part_of_speech: "động từ",
    meaning:
      "mắng và nhiếc móc bằng những lời nặng nề làm cho phải nhục nhã, khổ tâm: mắng nhiếc thậm tệ",
    example: "mắng nhiếc thậm tệ",
  },
  {
    word: "mắng mỏ",
    part_of_speech: "động từ",
    meaning: "mắng (nói khái quát): lớn tiếng mắng mỏ * mắng mỏ con cái",
    example: "lớn tiếng mắng mỏ * mắng mỏ con cái",
  },
  {
    word: "măng sông",
    part_of_speech: "danh từ",
    meaning:
      "mạng bằng loại sợi không cháy có tẩm một thứ muối kim loại, dùng bọc quanh ngọn lửa đèn để tăng độ sáng: thay măng sông đèn",
    example: "thay măng sông đèn",
  },
  {
    word: "măng sông",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) đèn măng sông (nói tắt): ngọn măng sông sáng loà",
    example: "ngọn măng sông sáng loà",
  },
  {
    word: "măng sông",
    part_of_speech: "động từ",
    meaning: "nối lồng hai đầu săm vào nhau: măng sông lại chiếc săm xe đạp",
    example: "măng sông lại chiếc săm xe đạp",
  },
  {
    word: "măng sét",
    part_of_speech: "danh từ",
    meaning:
      "phần tên riêng của một tờ báo được in ở đầu trang nhất, thường được trình bày dưới dạng chữ lớn theo những cách thức nhất định: măng sét của tờ báo được trình bày khá bắt mắt",
    example: "măng sét của tờ báo được trình bày khá bắt mắt",
  },
  {
    word: "măng sét",
    part_of_speech: "danh từ",
    meaning:
      "cửa tay áo sơ mi có lót thêm lớp vải dính cho cứng, phẳng: áo sơ mi tay măng sét",
    example: "áo sơ mi tay măng sét",
  },
  {
    word: "măng non",
    part_of_speech: "danh từ",
    meaning:
      "măng mới nhú; thường dùng để nói về lứa tuổi thiếu niên, nhi đồng: thế hệ măng non",
    example: "thế hệ măng non",
  },
  {
    word: "măng sữa",
    part_of_speech: "tính từ",
    meaning: "bé dại, thơ dại: tuổi còn măng sữa",
    example: "tuổi còn măng sữa",
  },
  {
    word: "măng tơ",
    part_of_speech: "tính từ",
    meaning: "(hiếm) non, trẻ: khuôn mặt măng tơ",
    example: "khuôn mặt măng tơ",
  },
  {
    word: "mắt bão",
    part_of_speech: "danh từ",
    meaning:
      "khu vực ở trung tâm cơn bão, có bán kính hàng chục kilomet, nơi gió thường yếu và trời quang mây: nằm trong khu vực mắt bão * vùng gần mắt bão",
    example: "nằm trong khu vực mắt bão * vùng gần mắt bão",
  },
  {
    word: "mắt",
    part_of_speech: "danh từ",
    meaning:
      "cơ quan để nhìn của người hay động vật, giúp phân biệt được màu sắc, hình dáng; thường được coi là biểu tượng của cái nhìn của con người: mắt sáng long lanh * nhìn tận mắt * trông không được đẹp mắt * có con mắt tinh đời",
    example:
      "mắt sáng long lanh * nhìn tận mắt * trông không được đẹp mắt * có con mắt tinh đời",
  },
  {
    word: "mắt",
    part_of_speech: "danh từ",
    meaning:
      "chỗ lồi lõm giống như hình con mắt, mang chồi, ở một số loài cây: mắt tre * mắt mía",
    example: "mắt tre * mắt mía",
  },
  {
    word: "mắt",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận giống hình những con mắt ở ngoài vỏ một số loại quả: mắt dứa * na mở mắt",
    example: "mắt dứa * na mở mắt",
  },
  {
    word: "mắt",
    part_of_speech: "danh từ",
    meaning: "lỗ hở, khe hở đều đặn ở các đồ đan: mắt lưới * rổ đan thưa mắt",
    example: "mắt lưới * rổ đan thưa mắt",
  },
  {
    word: "mắt",
    part_of_speech: "danh từ",
    meaning:
      "mắt xích (nói tắt): xích xe đạp quá chùng nên phải chặt bỏ bớt hai mắt",
    example: "xích xe đạp quá chùng nên phải chặt bỏ bớt hai mắt",
  },
  {
    word: "mặt biển",
    part_of_speech: "danh từ",
    meaning: "bề mặt của biển: những con thuyền nhấp nhô trên mặt biển",
    example: "những con thuyền nhấp nhô trên mặt biển",
  },
  {
    word: "mặt",
    part_of_speech: "danh từ",
    meaning:
      "phần phía trước, từ trán đến cằm của người, hay phần phía trước của đầu con thú, nơi có các bộ phận như mắt, mũi, mồm: rửa mặt * vẻ mặt hồng hào * mặt vuông chữ điền",
    example: "rửa mặt * vẻ mặt hồng hào * mặt vuông chữ điền",
  },
  {
    word: "mặt",
    part_of_speech: "danh từ",
    meaning:
      "những nét trên mặt người, biểu hiện thái độ, tâm tư, tình cảm (nói tổng quát): mặt lạnh như tiền * tay bắt mặt mừng",
    example: "mặt lạnh như tiền * tay bắt mặt mừng",
  },
  {
    word: "mặt",
    part_of_speech: "danh từ",
    meaning:
      "mặt người, để phân biệt người này với người khác; dùng để chỉ từng cá nhân khác nhau: tổ chức gặp mặt cuối năm * ba mặt một lời * vắng mặt",
    example: "tổ chức gặp mặt cuối năm * ba mặt một lời * vắng mặt",
  },
  {
    word: "mặt",
    part_of_speech: "danh từ",
    meaning:
      "mặt con người, được coi là biểu trưng cho thể diện, danh dự, phẩm giá: ngượng mặt * lên mặt * làm xấu mặt cha mẹ",
    example: "ngượng mặt * lên mặt * làm xấu mặt cha mẹ",
  },
  {
    word: "mặt",
    part_of_speech: "danh từ",
    meaning:
      "phần phẳng ở phía trên hoặc phía ngoài của vật, phân biệt với phần bên dưới hoặc bên trong: mặt bàn * sờ mặt vải * viết kín hai mặt giấy",
    example: "mặt bàn * sờ mặt vải * viết kín hai mặt giấy",
  },
  {
    word: "mặt",
    part_of_speech: "danh từ",
    meaning:
      "phía nào đó trong không gian, trong quan hệ với một vị trí xác định: bao vây bốn mặt * mặt trước của ngôi nhà",
    example: "bao vây bốn mặt * mặt trước của ngôi nhà",
  },
  {
    word: "mặt",
    part_of_speech: "danh từ",
    meaning:
      "phần được trừu tượng hoá khỏi chỉnh thể để xem xét, phân biệt với phần đối lập hoặc những phần còn lại: không nên chỉ chú ý đến mặt hình thức * cố gắng khắc phục những mặt hạn chế",
    example:
      "không nên chỉ chú ý đến mặt hình thức * cố gắng khắc phục những mặt hạn chế",
  },
  {
    word: "mặt",
    part_of_speech: "danh từ",
    meaning:
      "hình được vẽ bởi một điểm mà vị trí phụ thuộc liên tục vào hai tham số: mặt phẳng * mặt tròn xoay",
    example: "mặt phẳng * mặt tròn xoay",
  },
  {
    word: "mặt",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) bên phải: nhà phía bên tay mặt * quẹo bên mặt",
    example: "nhà phía bên tay mặt * quẹo bên mặt",
  },
  {
    word: "mặt bằng",
    part_of_speech: "danh từ",
    meaning:
      "khu đất dùng để xây dựng: giải phóng mặt bằng * diện tích mặt bằng là 200 hecta",
    example: "giải phóng mặt bằng * diện tích mặt bằng là 200 hecta",
  },
  {
    word: "mặt bằng",
    part_of_speech: "danh từ",
    meaning:
      "diện tích nhà, xưởng dùng vào mục đích sản xuất, kinh doanh: cho thuê mặt bằng sản xuất * mặt bằng của cửa hàng rất nhỏ",
    example: "cho thuê mặt bằng sản xuất * mặt bằng của cửa hàng rất nhỏ",
  },
  {
    word: "mặt bằng",
    part_of_speech: "danh từ",
    meaning:
      "mức ngang nhau chung cho một khu vực, một lĩnh vực: mức lương cao hơn so với mặt bằng * mặt bằng dân trí",
    example: "mức lương cao hơn so với mặt bằng * mặt bằng dân trí",
  },
  {
    word: "mắt cáo",
    part_of_speech: "danh từ",
    meaning: "lỗ đan thưa: lưới mắt cáo",
    example: "lưới mắt cáo",
  },
  {
    word: "mặt chữ",
    part_of_speech: "danh từ",
    meaning:
      "hình dáng của chữ cái hoặc chữ viết nói chung: chưa thuộc hết mặt chữ",
    example: "chưa thuộc hết mặt chữ",
  },
  {
    word: "mặt cân",
    part_of_speech: "danh từ",
    meaning: "mặt ghi số của cái cân: nhìn mặt cân",
    example: "nhìn mặt cân",
  },
  {
    word: "mặt cắt",
    part_of_speech: "danh từ",
    meaning:
      "bề mặt của một vật, nơi nó bị cắt đôi ra: mặt cắt của khúc gỗ * kiểm tra bằng hiển vi mặt cắt của một mô xương",
    example:
      "mặt cắt của khúc gỗ * kiểm tra bằng hiển vi mặt cắt của một mô xương",
  },
  {
    word: "mặt cắt",
    part_of_speech: "danh từ",
    meaning:
      "mặt cắt tưởng tượng của một vật theo một chiều nào đó, cho thấy cấu trúc bên trong của nó: bản vẽ mặt cắt đứng của ngôi nhà * mặt cắt dọc của con tàu",
    example: "bản vẽ mặt cắt đứng của ngôi nhà * mặt cắt dọc của con tàu",
  },
  {
    word: "mặt dạn mày dày",
    part_of_speech: "",
    meaning:
      'tả bộ mặt trơ trẽn đến mức không còn biết xấu hổ là gì: "Khéo là mặt dạn mày dày, Kiếp người đã đến thế này thì thôi!" (TKiều)',
    example:
      'Khéo là mặt dạn mày dày, Kiếp người đã đến thế này thì thôi!" (TKiều)',
  },
  {
    word: "mặt dày",
    part_of_speech: "danh từ",
    meaning: "bộ mặt trơ trẽn, không biết xấu hổ: đồ mặt dày!",
    example: "đồ mặt dày!",
  },
  {
    word: "mặt đối mặt",
    part_of_speech: "",
    meaning:
      "ở tư thế đứng trước mặt nhau, thường là trong quan hệ đối địch: mặt đối mặt với kẻ thù",
    example: "mặt đối mặt với kẻ thù",
  },
  {
    word: "mặt đường",
    part_of_speech: "danh từ",
    meaning: "như mặt phố: nhà mặt đường nên bán rất được giá",
    example: "nhà mặt đường nên bán rất được giá",
  },
  {
    word: "mặt hoa da phấn",
    part_of_speech: "",
    meaning:
      "(cũ, văn chương) tả người phụ nữ có vẻ đẹp mượt mà, tươi tắn: một người con gái mặt hoa da phấn",
    example: "một người con gái mặt hoa da phấn",
  },
  {
    word: "mặt đất",
    part_of_speech: "danh từ",
    meaning:
      "bề mặt của đất, trên đó người và các loài sinh vật đi lại, sinh sống: cỏ lan trên mặt đất * phi thuyền đáp xuống mặt đất",
    example: "cỏ lan trên mặt đất * phi thuyền đáp xuống mặt đất",
  },
  {
    word: "mặt hàng",
    part_of_speech: "danh từ",
    meaning:
      "loại hoặc thứ hàng, nói trong lĩnh vực sản xuất, kinh doanh: mặt hàng tiêu dùng * gạo là một mặt hàng chiến lược",
    example: "mặt hàng tiêu dùng * gạo là một mặt hàng chiến lược",
  },
  {
    word: "mặt khác",
    part_of_speech: "",
    meaning:
      "tổ hợp biểu thị điều sắp nêu ra có ý nghĩa bổ sung về mặt nào đó cho điều vừa được nói đến: cần chú trọng ở nội dung, mặt khác cũng phải cải tiến hình thức",
    example: "cần chú trọng ở nội dung, mặt khác cũng phải cải tiến hình thức",
  },
  {
    word: "mắt kính",
    part_of_speech: "danh từ",
    meaning:
      "miếng kính nhỏ để mắt nhìn qua, lắp vào kính đeo mắt hay vào một số dụng cụ: bị vỡ mắt kính",
    example: "bị vỡ mắt kính",
  },
  {
    word: "mắt la mày lét",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tả bộ dạng lấm la lấm lét, không dám nhìn thẳng, vẻ vụng trộm, không đàng hoàng: đi đâu cũng mắt la mày lét",
    example: "đi đâu cũng mắt la mày lét",
  },
  {
    word: "mặt mẹt",
    part_of_speech: "danh từ",
    meaning:
      "(thông tục) chỉ kẻ đáng khinh, đáng ghét (thường dùng làm tiếng chửi): đồ mặt mẹt!",
    example: "đồ mặt mẹt!",
  },
  {
    word: "mặt mày",
    part_of_speech: "danh từ",
    meaning:
      "mặt của con người, nhìn một cách tổng quát: mặt mày hốc hác * cái tát làm tối tăm cả mặt mày",
    example: "mặt mày hốc hác * cái tát làm tối tăm cả mặt mày",
  },
  {
    word: "mặt ngang mũi dọc",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) mặt mũi của một người nào đó mà mình chưa được thấy (dùng với ý coi thường): chưa biết mặt ngang mũi dọc của nó ra sao",
    example: "chưa biết mặt ngang mũi dọc của nó ra sao",
  },
  {
    word: "mặt mo",
    part_of_speech: "danh từ",
    meaning:
      "(thông tục) chỉ kẻ trơ trẽn, đáng khinh (thường dùng làm tiếng chửi): có là mặt mo thì mới làm như vậy * đồ mặt mo!",
    example: "có là mặt mo thì mới làm như vậy * đồ mặt mo!",
  },
  {
    word: "mắt mũi",
    part_of_speech: "danh từ",
    meaning:
      "mắt (nói khái quát; thường với hàm ý chê): mắt mũi kèm nhèm * mắt mũi để đâu mà va cả vào tường thế?",
    example: "mắt mũi kèm nhèm * mắt mũi để đâu mà va cả vào tường thế?",
  },
  {
    word: "mặt nặng mày nhẹ",
    part_of_speech: "",
    meaning:
      "từ gợi tả vẻ mặt nặng nề, biểu hiện thái độ khó chịu, bực bội hoặc tức tối với ai đó: hơi khó nhọc một tí là mặt nặng mày nhẹ",
    example: "hơi khó nhọc một tí là mặt nặng mày nhẹ",
  },
  {
    word: "mặt người dạ thú",
    part_of_speech: "",
    meaning:
      "tả người có vẻ bề ngoài trông thì tử tế nhưng trong lòng dạ lại độc ác, thâm hiểm chẳng khác gì thú dữ: đồ mặt người dạ thú!",
    example: "đồ mặt người dạ thú!",
  },
  {
    word: "mặt nạ",
    part_of_speech: "danh từ",
    meaning:
      "mặt giả, đeo để che giấu mặt thật: tên cướp đeo mặt nạ * chiếc mặt nạ da người",
    example: "tên cướp đeo mặt nạ * chiếc mặt nạ da người",
  },
  {
    word: "mặt nạ",
    part_of_speech: "danh từ",
    meaning:
      "cái bề ngoài giả dối nhằm che đậy bản chất xấu xa bên trong: lột mặt nạ của kẻ giả nhân giả nghĩa",
    example: "lột mặt nạ của kẻ giả nhân giả nghĩa",
  },
  {
    word: "mặt nạ",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng đeo ở đầu và mặt để tránh tác hại của chất độc, chất phóng xạ: mang mặt nạ chống hơi độc * mặt nạ phòng cháy chữa cháy",
    example: "mang mặt nạ chống hơi độc * mặt nạ phòng cháy chữa cháy",
  },
  {
    word: "mặt nạ",
    part_of_speech: "danh từ",
    meaning:
      "lớp chất thường ở dạng kem được đắp phủ lên da mặt, lên tóc, có tác dụng nuôi dưỡng, làm cho da, tóc đẹp hơn: đắp mặt nạ",
    example: "đắp mặt nạ",
  },
  {
    word: "mặt nạc đóm dày",
    part_of_speech: "",
    meaning:
      '(khẩu ngữ) ví người ngu độn, không làm nên trò trống gì: "Những người mặt nạc đóm dày, Mo nang trôi sấp biết ngày nào khôn!" (ca dao)',
    example:
      'Những người mặt nạc đóm dày, Mo nang trôi sấp biết ngày nào khôn!" (ca dao)',
  },
  {
    word: "mặt mũi",
    part_of_speech: "danh từ",
    meaning: "như mặt mày: mặt mũi khôi ngô",
    example: "mặt mũi khôi ngô",
  },
  {
    word: "mặt mũi",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) mặt của con người (nói khái quát), coi là biểu trưng cho thể diện, danh dự: xấu hổ, không còn mặt mũi nào nhìn mọi người nữa",
    example: "xấu hổ, không còn mặt mũi nào nhìn mọi người nữa",
  },
  {
    word: "mắt nhắm mắt mở",
    part_of_speech: "",
    meaning:
      "ở tình trạng vừa mới bừng mắt dậy, chưa tỉnh hẳn (đã làm việc gì): mắt nhắm mắt mở đã vội đi ngay",
    example: "mắt nhắm mắt mở đã vội đi ngay",
  },
  {
    word: "mặt rồng",
    part_of_speech: "danh từ",
    meaning:
      '(cũ, văn chương) mặt vua: "Ta đây một tấm lòng trung, Quyết đem giãi trước mặt rồng có phen." (NĐM)',
    example:
      'Ta đây một tấm lòng trung, Quyết đem giãi trước mặt rồng có phen." (NĐM)',
  },
  {
    word: "mặt nước",
    part_of_speech: "danh từ",
    meaning: "bề mặt của nước: cỏ rác nổi trên mặt nước",
    example: "cỏ rác nổi trên mặt nước",
  },
  {
    word: "mặt nước cánh bèo",
    part_of_speech: "",
    meaning:
      '(cũ, văn chương) như cánh bèo: "Nghĩ mình mặt nước cánh bèo, Đã nhiều lưu lạc, lại nhiều gian truân." (TKiều)',
    example:
      'Nghĩ mình mặt nước cánh bèo, Đã nhiều lưu lạc, lại nhiều gian truân." (TKiều)',
  },
  {
    word: "mặt số",
    part_of_speech: "danh từ",
    meaning:
      "mặt có khắc độ, ghi chữ số của một số loại máy móc, đồ dùng cân đo: mặt số của đồng hồ",
    example: "mặt số của đồng hồ",
  },
  {
    word: "mặt phố",
    part_of_speech: "danh từ",
    meaning:
      "phía nhìn ra đường phố, nơi có cửa trước của các ngôi nhà: nhà ở ngay mặt phố",
    example: "nhà ở ngay mặt phố",
  },
  {
    word: "mặt sưng mày sỉa",
    part_of_speech: "",
    meaning:
      "mặt mày sưng sỉa, lộ vẻ rất bực tức (thường hàm ý chê): con gái con đứa gì mà suốt ngày mặt sưng mày sỉa",
    example: "con gái con đứa gì mà suốt ngày mặt sưng mày sỉa",
  },
  {
    word: "mắt thần",
    part_of_speech: "",
    meaning:
      "(Khẩu ngữ) bộ phận phóng ra tia hồng ngoại dùng để bắt tín hiệu trong các thiết bị điện tử: mắt thần của ti vi bị hỏng",
    example: "mắt thần của ti vi bị hỏng",
  },
  {
    word: "mặt tiền",
    part_of_speech: "danh từ",
    meaning:
      "mặt trước của ngôi nhà, thường là mặt nhìn ra đường: ngôi nhà có mặt tiền rộng",
    example: "ngôi nhà có mặt tiền rộng",
  },
  {
    word: "mặt trái",
    part_of_speech: "danh từ",
    meaning:
      "phần không được tốt đẹp và thường không được bộc lộ ra ngoài của người, vật, sự việc: mặt trái của cuộc sống * mặt trái của nền kinh tế thị trường",
    example: "mặt trái của cuộc sống * mặt trái của nền kinh tế thị trường",
  },
  {
    word: "mắt thấy tai nghe",
    part_of_speech: "",
    meaning:
      "trực tiếp nhìn thấy, nghe thấy (hàm ý hoàn toàn chính xác): chuyện mắt thấy tai nghe hẳn hoi",
    example: "chuyện mắt thấy tai nghe hẳn hoi",
  },
  {
    word: "mặt trận",
    part_of_speech: "danh từ",
    meaning:
      "nơi diễn ra các cuộc chiến đấu, các trận đánh lớn: hành quân ra mặt trận * mặt trận đã im tiếng súng",
    example: "hành quân ra mặt trận * mặt trận đã im tiếng súng",
  },
  {
    word: "mặt trận",
    part_of_speech: "danh từ",
    meaning:
      "lĩnh vực hoạt động, nơi đang diễn ra những cuộc đấu tranh gay go, quyết liệt: mặt trận ngoại giao * đấu tranh trên mặt trận văn hoá tư tưởng",
    example: "mặt trận ngoại giao * đấu tranh trên mặt trận văn hoá tư tưởng",
  },
  {
    word: "mặt trận",
    part_of_speech: "danh từ",
    meaning:
      "tổ chức rộng rãi gồm nhiều giai cấp, tầng lớp, tổ chức hoặc nhiều nước liên minh với nhau để đấu tranh cho một mục đích chung: mặt trận giải phóng dân tộc",
    example: "mặt trận giải phóng dân tộc",
  },
  {
    word: "mặt trận",
    part_of_speech: "danh từ",
    meaning:
      "(thường viết hoa) mặt trận Tổ quốc Việt Nam (nói tắt): cán bộ Mặt trận * công tác Mặt trận",
    example: "cán bộ Mặt trận * công tác Mặt trận",
  },
  {
    word: "mặt trăng",
    part_of_speech: "danh từ",
    meaning:
      "(viết hoa khi nói về mặt là một thiên thể) vệ tinh tự nhiên của Trái Đất, phản chiếu ánh sáng của Mặt Trời và chiếu sáng Trái Đất về ban đêm, có hình dạng nhìn thấy thay đổi dần từng ngày theo chu kì từ khuyết đến tròn và ngược lại: đêm rằm, mặt trăng tròn như cái đĩa * tàu vũ trụ đổ bộ xuống Mặt Trăng",
    example:
      "đêm rằm, mặt trăng tròn như cái đĩa * tàu vũ trụ đổ bộ xuống Mặt Trăng",
  },
  {
    word: "mặt trời",
    part_of_speech: "danh từ",
    meaning:
      "(viết hoa khi nói về mặt là một thiên thể) thiên thể nóng sáng, ở xa Trái Đất, là nguồn chiếu sáng và sưởi ấm chủ yếu cho Trái Đất: mặt trời dần dần khuất sau dãy núi * Trái Đất quay quanh Mặt Trời",
    example:
      "mặt trời dần dần khuất sau dãy núi * Trái Đất quay quanh Mặt Trời",
  },
  {
    word: "mắt tròn mắt dẹt",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tả vẻ nhớn nhác do hết sức ngạc nhiên hay sợ hãi: nghe xong câu chuyện, ai nấy đều mắt tròn mắt dẹt",
    example: "nghe xong câu chuyện, ai nấy đều mắt tròn mắt dẹt",
  },
  {
    word: "mắt xanh",
    part_of_speech: "danh từ",
    meaning:
      '(văn chương) con mắt; thường dùng để nói cái nhìn của người phụ nữ trong việc đánh giá hay lựa chọn người yêu: lọt vào mắt xanh của nàng * "Bấy lâu nghe tiếng má đào, Mắt xanh chẳng để ai vào có không?" (TKiều)',
    example:
      'lọt vào mắt xanh của nàng * "Bấy lâu nghe tiếng má đào, Mắt xanh chẳng để ai vào có không?" (TKiều)',
  },
  {
    word: "mặt ủ mày chau",
    part_of_speech: "",
    meaning:
      'tả vẻ mặt buồn rầu, đau khổ: "Nàng càng mặt ủ mày chau, Càng nghe mụ nói, càng đau như dần." (TKiều)',
    example:
      'Nàng càng mặt ủ mày chau, Càng nghe mụ nói, càng đau như dần." (TKiều)',
  },
  {
    word: "mắt trước mắt sau",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) tả vẻ lấm lét nhìn trước nhìn sau, liệu chừng để đi khỏi càng nhanh càng tốt do có điều gì đang thấp thỏm lo sợ: chỉ mắt trước mắt sau là chuồn mất",
    example: "chỉ mắt trước mắt sau là chuồn mất",
  },
  {
    word: "mắt xích",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận đồng nhất với nhau, móc nối vào nhau tạo thành dây xích, dây chuyền: chặt bớt một mắt xích",
    example: "chặt bớt một mắt xích",
  },
  {
    word: "mắt xích",
    part_of_speech: "danh từ",
    meaning:
      "từng bộ phận của một hệ thống, về mặt có quan hệ chặt chẽ với các bộ phận khác: một mắt xích quan trọng của vụ án",
    example: "một mắt xích quan trọng của vụ án",
  },
  {
    word: "mầm",
    part_of_speech: "danh từ",
    meaning:
      "bộ phận mới nhú ra từ hạt, củ hoặc cành để về sau lớn lên thành cây, thành cành: thóc nảy mầm * ươm mầm * gieo những mầm xanh hi vọng (b)",
    example: "thóc nảy mầm * ươm mầm * gieo những mầm xanh hi vọng (b)",
  },
  {
    word: "mâm",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng thường có một mặt phẳng, hình tròn, dùng để bày bát đũa, thức ăn: mâm đồng * bưng mâm cơm * mâm cao cỗ đầy (tng)",
    example: "mâm đồng * bưng mâm cơm * mâm cao cỗ đầy (tng)",
  },
  {
    word: "mâm",
    part_of_speech: "danh từ",
    meaning:
      "từ chỉ từng tập hợp những người cùng ngồi ăn một mâm: mỗi mâm có sáu người",
    example: "mỗi mâm có sáu người",
  },
  {
    word: "mâm",
    part_of_speech: "danh từ",
    meaning: "vật có hình giống như chiếc mâm: mâm pháo",
    example: "mâm pháo",
  },
  {
    word: "mẫm",
    part_of_speech: "tính từ",
    meaning: "béo tròn, đầy đặn: ngón tay béo mẫm",
    example: "ngón tay béo mẫm",
  },
  {
    word: "mẩm",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) tin chắc theo nhận định chủ quan, và có ý mừng thầm: mẩm là việc sẽ thành công",
    example: "mẩm là việc sẽ thành công",
  },
  {
    word: "mầm non",
    part_of_speech: "danh từ",
    meaning:
      "mầm cây non mới mọc; thường dùng để nói về lứa tuổi thiếu niên, nhi đồng: thế hệ mầm non là tương lai của đất nước",
    example: "thế hệ mầm non là tương lai của đất nước",
  },
  {
    word: "mầm non",
    part_of_speech: "danh từ",
    meaning:
      "bậc đầu tiên trong hệ thống giáo dục, thực hiện việc nuôi dưỡng, chăm sóc, giáo dục trẻ dưới sáu tuổi (tuổi bắt đầu vào học lớp một): giáo viên mầm non * trường mầm non",
    example: "giáo viên mầm non * trường mầm non",
  },
  {
    word: "mấn",
    part_of_speech: "danh từ",
    meaning:
      '(phương ngữ) váy: "Mấn thâm ơi hỡi mấn thâm, Cái đọi không rửa, cái mâm không chùi." (ca dao)',
    example: "Mấn thâm ơi hỡi mấn thâm, Cái đọi không rửa, cái mâm không chùi.",
  },
  {
    word: "mần",
    part_of_speech: "động từ",
    meaning:
      '(Phương ngữ) làm: mần ăn * "Thương em nỏ biết mần răng, Mười đêm ra đứng trông trăng cả mười." (Cdao)',
    example:
      'mần ăn * "Thương em nỏ biết mần răng, Mười đêm ra đứng trông trăng cả mười." (Cdao)',
  },
  {
    word: "mầm mống",
    part_of_speech: "danh từ",
    meaning:
      "cái mới xuất hiện, mới nảy sinh, làm cơ sở cho sự phát triển sau này (nói khái quát): diệt trừ mầm mống của dịch bệnh",
    example: "diệt trừ mầm mống của dịch bệnh",
  },
  {
    word: "mận",
    part_of_speech: "danh từ",
    meaning:
      "(Bắc) cây ăn quả cùng họ với đào, lá dài, mép lá có răng cưa nhỏ, hoa trắng, quả có vỏ màu đỏ tía hay lục nhạt, vị chua, ngọt, được trồng nhiều ở vùng miền núi phía Bắc",
    example: "trái mận",
  },
  {
    word: "mân",
    part_of_speech: "động từ",
    meaning: "sờ và vê nhẹ bằng các đầu ngón tay: tay mân từng sợi tóc",
    example: "tay mân từng sợi tóc",
  },
  {
    word: "mẫn cán",
    part_of_speech: "tính từ",
    meaning: "siêng năng, tận tuỵ và rất được việc: một người cán bộ mẫn cán",
    example: "một người cán bộ mẫn cán",
  },
  {
    word: "mẩn",
    part_of_speech: "",
    meaning:
      "có nhiều nốt nhỏ nổi lên trên mặt da, thường gây ngứa, khó chịu: bị muỗi đốt nổi mẩn lên * người đầy mẩn đỏ",
    example: "bị muỗi đốt nổi mẩn lên * người đầy mẩn đỏ",
  },
  {
    word: "mân mê",
    part_of_speech: "động từ",
    meaning: "sờ, nắn nhẹ, vê nhẹ và lâu bằng các đầu ngón tay: mân mê tà áo",
    example: "mân mê tà áo",
  },
  {
    word: "mẫn cảm",
    part_of_speech: "danh từ",
    meaning: "sự nhạy bén, nhạy cảm: mối mẫn cảm * dựa vào mẫn cảm để suy xét",
    example: "mối mẫn cảm * dựa vào mẫn cảm để suy xét",
  },
  {
    word: "mập mạp",
    part_of_speech: "tính từ",
    meaning: "mập (nói khái quát): chân tay mập mạp * thân hình mập mạp",
    example: "chân tay mập mạp * thân hình mập mạp",
  },
  {
    word: "mập",
    part_of_speech: "tính từ",
    meaning: "béo và có vẻ chắc, khoẻ: chồi cây rất mập * thằng bé mập lắm!",
    example: "chồi cây rất mập * thằng bé mập lắm!",
  },
  {
    word: "mẫn tiệp",
    part_of_speech: "tính từ",
    meaning:
      "(cũ, hiếm) linh lợi, có khả năng ứng phó nhanh: một người mẫn tiệp * có tài mẫn tiệp",
    example: "một người mẫn tiệp * có tài mẫn tiệp",
  },
  {
    word: "mấp mé",
    part_of_speech: "động từ",
    meaning: "ở gần sát một mức giới hạn nào đó: nước mấp mé mặt đê",
    example: "nước mấp mé mặt đê",
  },
  {
    word: "mấp máy",
    part_of_speech: "động từ",
    meaning:
      "(môi, mắt) cử động rất khẽ và liên tiếp: đôi mi mấp máy * cặp môi mấp máy nhưng không thành tiếng",
    example: "đôi mi mấp máy * cặp môi mấp máy nhưng không thành tiếng",
  },
  {
    word: "mấp mô",
    part_of_speech: "tính từ",
    meaning: "có nhiều mô nhỏ nổi lên không đều trên bề mặt: mặt đường mấp mô",
    example: "mặt đường mấp mô",
  },
  {
    word: "mập mờ",
    part_of_speech: "tính từ",
    meaning: "lờ mờ hoặc lúc tỏ lúc mờ, nên không thể thấy rõ: ánh sáng mập mờ",
    example: "ánh sáng mập mờ",
  },
  {
    word: "mập mờ",
    part_of_speech: "tính từ",
    meaning:
      "tỏ ra không rõ ràng, nửa nọ nửa kia, khiến người ta khó biết rõ, hiểu rõ là như thế nào: thái độ mập mờ * kiểu làm ăn mập mờ",
    example: "thái độ mập mờ * kiểu làm ăn mập mờ",
  },
  {
    word: "mất",
    part_of_speech: "động từ",
    meaning:
      "không có, không thấy, không tồn tại nữa: mất điện * mất vui * biến mất",
    example: "mất điện * mất vui * biến mất",
  },
  {
    word: "mất",
    part_of_speech: "động từ",
    meaning:
      "không còn là của mình, thuộc về mình nữa (cái vẫn tiếp tục tồn tại): mất cái ví * mất cắp * mất tiền",
    example: "mất cái ví * mất cắp * mất tiền",
  },
  {
    word: "mất",
    part_of_speech: "động từ",
    meaning:
      "không còn ở mình nữa: người thương binh mất một chân * nghỉ mất sức * mất danh dự",
    example: "người thương binh mất một chân * nghỉ mất sức * mất danh dự",
  },
  {
    word: "mất",
    part_of_speech: "động từ",
    meaning:
      "dùng hết bao nhiêu thời gian, công sức hoặc tiền của vào việc gì: phải mất một hai hôm nữa mới làm xong * mất rất nhiều công sức * mất thời gian vô ích",
    example:
      "phải mất một hai hôm nữa mới làm xong * mất rất nhiều công sức * mất thời gian vô ích",
  },
  {
    word: "mất",
    part_of_speech: "động từ",
    meaning:
      "không còn sống nữa, chết (một cách nói giảm, nói tránh; hàm ý thương tiếc): bố mẹ đều mất sớm * ông cụ mất đã được mấy năm",
    example: "bố mẹ đều mất sớm * ông cụ mất đã được mấy năm",
  },
  {
    word: "mất",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý tiếc về điều không hay đã xảy ra hoặc có thể xảy ra: quên bẵng đi mất * thế là lại muộn mất rồi! * lỡ mất cơ hội",
    example: "quên bẵng đi mất * thế là lại muộn mất rồi! * lỡ mất cơ hội",
  },
  {
    word: "mất",
    part_of_speech: "trợ từ",
    meaning:
      "từ biểu thị ý nhấn mạnh về mức độ của một tình cảm mà mình cảm thấy không sao kìm giữ được: buồn quá đi mất! * sướng phát điên lên mất!",
    example: "buồn quá đi mất! * sướng phát điên lên mất!",
  },
  {
    word: "mật báo",
    part_of_speech: "động từ",
    meaning:
      "bí mật báo cho biết, thường là tin quan trọng: nhận được tin mật báo",
    example: "nhận được tin mật báo",
  },
  {
    word: "mất ăn mất ngủ",
    part_of_speech: "",
    meaning:
      "phải lo lắng, nghĩ ngợi nhiều về việc gì đến mức ăn không ngon, ngủ không yên: mất ăn mất ngủ vì những lời đồn đại * lo mất ăn mất ngủ",
    example: "mất ăn mất ngủ vì những lời đồn đại * lo mất ăn mất ngủ",
  },
  {
    word: "mập ú",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) béo tròn: người mập ú",
    example: "người mập ú",
  },
  {
    word: "mật",
    part_of_speech: "danh từ",
    meaning: "nước màu vàng do gan tiết ra, giúp cho sự tiêu hoá chất mỡ.",
    example: "cái mật cá",
  },
  {
    word: "mật",
    part_of_speech: "danh từ",
    meaning:
      "chất có vị ngọt do các tuyến ở đáy một số loài hoa tiết ra: ong hút mật",
    example: "ong hút mật",
  },
  {
    word: "mật",
    part_of_speech: "danh từ",
    meaning: "nước mía đã cô đặc: nấu mật",
    example: "nấu mật",
  },
  {
    word: "mật",
    part_of_speech: "tính từ",
    meaning: "cần được giữ bí mật: tin mật * tài liệu mật * hộp thư mật",
    example: "tin mật * tài liệu mật * hộp thư mật",
  },
  {
    word: "mất cắp",
    part_of_speech: "động từ",
    meaning: "bị kẻ gian lấy cắp: bị mất cắp tiền",
    example: "bị mất cắp tiền",
  },
  {
    word: "mất cả chì lẫn chài",
    part_of_speech: "",
    meaning:
      "mất hết, đã không thu được chút lợi gì mà còn mất cả vốn bỏ ra: phải tính toán cho kĩ, không khéo lại mất cả chì lẫn chài",
    example: "phải tính toán cho kĩ, không khéo lại mất cả chì lẫn chài",
  },
  {
    word: "mất công toi",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) mất công một cách hoàn toàn vô ích: thật là mất công toi, phải lội bộ mấy cây số lên mà hắn lại không có nhà",
    example:
      "thật là mất công toi, phải lội bộ mấy cây số lên mà hắn lại không có nhà",
  },
  {
    word: "mất công",
    part_of_speech: "động từ",
    meaning:
      "bỏ thời gian và công sức ra làm việc gì một cách vô ích, không có hiệu quả: mất công tìm kiếm * nó không về đâu, đợi làm gì (cho) mất công",
    example: "mất công tìm kiếm * nó không về đâu, đợi làm gì (cho) mất công",
  },
  {
    word: "mất công",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) để tránh chuyện không hay nêu ra sau đó; kẻo: Đừng chửi nó nhiều, mất công nó nghĩ quẩn bỏ nhà đi. * Nói với bà ấy một tiếng, mất công bà ấy trách! * Tao làm luôn rồi, mất công mày nói này nói nọ!",
    example:
      "Đừng chửi nó nhiều, mất công nó nghĩ quẩn bỏ nhà đi. * Nói với bà ấy một tiếng, mất công bà ấy trách! * Tao làm luôn rồi, mất công mày nói này nói nọ!",
  },
  {
    word: "mật độ",
    part_of_speech: "danh từ",
    meaning:
      "số lượng trung bình trên một đơn vị diện tích: mật độ dân số tăng nhanh ở các thành phố lớn * mật độ xe cộ ngày càng đông",
    example:
      "mật độ dân số tăng nhanh ở các thành phố lớn * mật độ xe cộ ngày càng đông",
  },
  {
    word: "mật hiệu",
    part_of_speech: "danh từ",
    meaning:
      "dấu hiệu bí mật được quy ước cho một nhóm người nhận biết và thông tin cho nhau: ra mật hiệu với nhau",
    example: "ra mật hiệu với nhau",
  },
  {
    word: "mật đàm",
    part_of_speech: "động từ",
    meaning:
      "họp bàn bí mật giữa các bên về những vấn đề quan trọng: hai bên đã mật đàm về kế hoạch rút quân",
    example: "hai bên đã mật đàm về kế hoạch rút quân",
  },
  {
    word: "mất dạy",
    part_of_speech: "tính từ",
    meaning: "(thông tục) hư đốn, thiếu giáo dục: đồ mất dạy! * ăn nói mất dạy",
    example: "đồ mất dạy! * ăn nói mất dạy",
  },
  {
    word: "mất gốc",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) không còn giữ được bản chất tốt đẹp vốn có của mình: đồ mất gốc!",
    example: "đồ mất gốc!",
  },
  {
    word: "mật danh",
    part_of_speech: "danh từ",
    meaning:
      "kí hiệu quy ước hoặc tên dùng thay cho tên thật để giữ bí mật: mật danh của đơn vị * điệp viên mang mật danh 007",
    example: "mật danh của đơn vị * điệp viên mang mật danh 007",
  },
  {
    word: "mất giá",
    part_of_speech: "động từ",
    meaning: "không còn giá trị như trước: giá cả leo thang, đồng tiền mất giá",
    example: "giá cả leo thang, đồng tiền mất giá",
  },
  {
    word: "mất hút",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) không còn một chút bóng dáng nào trong tầm mắt, hoàn toàn không còn nhìn thấy đâu nữa: chiếc xe mất hút trên con đường dài",
    example: "chiếc xe mất hút trên con đường dài",
  },
  {
    word: "mật khẩu",
    part_of_speech: "danh từ",
    meaning:
      "lời hỏi hoặc đáp ngắn gọn đã được quy ước làm mật hiệu để những người trong cùng một tổ chức nhận ra nhau: trả lời sai mật khẩu * nhớ kĩ mật khẩu để liên lạc",
    example: "trả lời sai mật khẩu * nhớ kĩ mật khẩu để liên lạc",
  },
  {
    word: "mật khẩu",
    part_of_speech: "danh từ",
    meaning:
      "chuỗi kí tự hoặc chữ số bí mật của cá nhân sử dụng để truy cập hợp pháp vào hệ thống dịch vụ điện tử hoặc chương trình máy tính được bảo vệ: đặt mật khẩu",
    example: "đặt mật khẩu",
  },
  {
    word: "mất mạng",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) chết: suýt nữa thì mất mạng * đùa với lửa thì mất mạng như chơi!",
    example: "suýt nữa thì mất mạng * đùa với lửa thì mất mạng như chơi!",
  },
  {
    word: "mất hồn",
    part_of_speech: "động từ",
    meaning:
      "ở trạng thái như mất hết khả năng suy nghĩ, cảm giác, do quá lo buồn, sợ hãi, v.v.: đờ đẫn như kẻ mất hồn",
    example: "đờ đẫn như kẻ mất hồn",
  },
  {
    word: "mật mã",
    part_of_speech: "danh từ",
    meaning:
      "mã thông tin được giữ bí mật, dùng riêng trong một số ngành: dịch mật mã",
    example: "dịch mật mã",
  },
  {
    word: "mất mát",
    part_of_speech: "",
    meaning:
      "tổn thất, mất đi (nói khái quát): của cải mất mát dần * chiến tranh đã gây biết bao hi sinh, mất mát",
    example:
      "của cải mất mát dần * chiến tranh đã gây biết bao hi sinh, mất mát",
  },
  {
    word: "mật lệnh",
    part_of_speech: "danh từ",
    meaning: "mệnh lệnh bí mật: thi hành mật lệnh của cấp trên",
    example: "thi hành mật lệnh của cấp trên",
  },
  {
    word: "mất mặn mất nhạt",
    part_of_speech: "",
    meaning:
      "thô bạo trong đối xử, không nể nang, không kể gì đến tình nghĩa: mắng cho một trận mất mặn mất nhạt",
    example: "mắng cho một trận mất mặn mất nhạt",
  },
  {
    word: "mất lòng",
    part_of_speech: "động từ",
    meaning:
      "làm cho người khác không bằng lòng, không hài lòng vì một hành vi, thái độ không phải nào đó: thuốc đắng đã tật, sự thật mất lòng (tng)",
    example: "thuốc đắng đã tật, sự thật mất lòng (tng)",
  },
  {
    word: "mất mặt",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) biệt đi một thời gian, không ai thấy đâu cả (thường hàm ý trách mắng): đi mất mặt * mồm cứ leo lẻo hẹn đến, thế mà mất mặt!",
    example: "đi mất mặt * mồm cứ leo lẻo hẹn đến, thế mà mất mặt!",
  },
  {
    word: "mất mặt",
    part_of_speech: "động từ",
    meaning:
      "không còn thể diện, uy tín gì nữa: mắng cho mất mặt * bị mất mặt trước đám đông",
    example: "mắng cho mất mặt * bị mất mặt trước đám đông",
  },
  {
    word: "mất nết",
    part_of_speech: "tính từ",
    meaning:
      "hư hỏng, không ngoan ngoãn, nết na như trước (thường nói về người còn ít tuổi với hàm ý trách mắng): được chiều quá đâm ra mất nết!",
    example: "được chiều quá đâm ra mất nết!",
  },
  {
    word: "mất ngủ",
    part_of_speech: "động từ",
    meaning:
      "ở trạng thái không sao ngủ được, thường do thần kinh bị căng thẳng quá hoặc do bị bệnh: mắc chứng mất ngủ",
    example: "mắc chứng mất ngủ",
  },
  {
    word: "mất mùa",
    part_of_speech: "động từ",
    meaning:
      "thu hoạch mùa màng rất kém, có ảnh hưởng lớn tới đời sống: đói kém vì mất mùa",
    example: "đói kém vì mất mùa",
  },
  {
    word: "mất tích",
    part_of_speech: "động từ",
    meaning:
      "không còn thấy tung tích đâu nữa, cũng không rõ còn hay mất: bỏ nhà đi mất tích * bị mất tích",
    example: "bỏ nhà đi mất tích * bị mất tích",
  },
  {
    word: "mật thám",
    part_of_speech: "danh từ",
    meaning:
      "cơ quan chuyên dò xét và đàn áp phong trào cách mạng ở các nước đế quốc, thuộc địa: sở mật thám",
    example: "sở mật thám",
  },
  {
    word: "mật thám",
    part_of_speech: "danh từ",
    meaning: "nhân viên mật thám: bị mật thám theo dõi",
    example: "bị mật thám theo dõi",
  },
  {
    word: "mất tăm",
    part_of_speech: "động từ",
    meaning:
      "không hề thấy tăm hơi đâu cả: đi mất tăm * tên lừa đảo đã biến mất tăm",
    example: "đi mất tăm * tên lừa đảo đã biến mất tăm",
  },
  {
    word: "mất tiêu",
    part_of_speech: "động từ",
    meaning:
      "(phương ngữ, khẩu ngữ) mất đi hẳn, không còn thấy đâu nữa: quên mất tiêu * số tiền đó đã bị ai lấy mất tiêu rồi!",
    example: "quên mất tiêu * số tiền đó đã bị ai lấy mất tiêu rồi!",
  },
  {
    word: "mất trắng",
    part_of_speech: "động từ",
    meaning:
      "mất hết, không thu lại được tí nào: mùa màng mất trắng * bao nhiêu vốn liếng bị mất trắng cả",
    example: "mùa màng mất trắng * bao nhiêu vốn liếng bị mất trắng cả",
  },
  {
    word: "mất sức",
    part_of_speech: "động từ",
    meaning:
      "ở trạng thái sức khoẻ bị giảm sút do một tác động trực tiếp nào đó: sau trận ốm nặng, mất sức trông thấy",
    example: "sau trận ốm nặng, mất sức trông thấy",
  },
  {
    word: "mất sức",
    part_of_speech: "động từ",
    meaning:
      "không còn đủ sức khoẻ để làm việc, tuy đang còn ở trong tuổi lao động: làm đơn xin nghỉ mất sức",
    example: "làm đơn xin nghỉ mất sức",
  },
  {
    word: "mật thiết",
    part_of_speech: "tính từ",
    meaning:
      "có quan hệ gắn bó chặt chẽ với nhau: gắn bó mật thiết * hai vấn đề có liên quan mật thiết với nhau",
    example: "gắn bó mật thiết * hai vấn đề có liên quan mật thiết với nhau",
  },
  {
    word: "mất toi",
    part_of_speech: "động từ",
    meaning:
      "(thông tục) mất đi một cách hoàn toàn vô ích: mất toi cả buổi chiều * mất toi cả mấy sào lúa vì úng ngập",
    example: "mất toi cả buổi chiều * mất toi cả mấy sào lúa vì úng ngập",
  },
  {
    word: "mất trí",
    part_of_speech: "động từ",
    meaning:
      "mất hết khả năng hoạt động trí óc, khả năng nhận thức; điên (lối nói kiêng tránh): nói năng như một kẻ mất trí",
    example: "nói năng như một kẻ mất trí",
  },
  {
    word: "mất vía",
    part_of_speech: "động từ",
    meaning:
      "sợ hãi đến mức mất hết tinh thần, không còn hồn vía nữa: sợ mất vía * bị một phen mất vía",
    example: "sợ mất vía * bị một phen mất vía",
  },
  {
    word: "mầu",
    part_of_speech: "tính từ",
    meaning:
      "tài tình và có cái gì đó cao siêu, huyền diệu không thể giải thích, nắm bắt được, vì ngoài sức hiểu biết của con người: phép mầu * chước mầu",
    example: "phép mầu * chước mầu",
  },
  {
    word: "mẩu",
    part_of_speech: "danh từ",
    meaning:
      "phần rất nhỏ còn lại hoặc bị tách rời ra từ một vật, một chỉnh thể nào đó: mẩu bánh mì * một mẩu tin ngắn * kể một mẩu chuyện vui",
    example: "mẩu bánh mì * một mẩu tin ngắn * kể một mẩu chuyện vui",
  },
  {
    word: "mấu",
    part_of_speech: "danh từ",
    meaning:
      "phần trồi lên thành khối gồ nhỏ trên bề mặt của vật: mấu đòn gánh * mặt vải có nhiều mấu",
    example: "mấu đòn gánh * mặt vải có nhiều mấu",
  },
  {
    word: "mấu",
    part_of_speech: "danh từ",
    meaning: "chỗ lá dính vào thân cây hoặc cành cây: mấu lá",
    example: "mấu lá",
  },
  {
    word: "mất trộm",
    part_of_speech: "động từ",
    meaning:
      "bị lấy mất của cải trong lúc đêm hôm hoặc lúc vắng vẻ: bị mất trộm xe máy * khai báo mất trộm",
    example: "bị mất trộm xe máy * khai báo mất trộm",
  },
  {
    word: "mậu",
    part_of_speech: "danh từ",
    meaning:
      "(thường viết hoa) kí hiệu thứ năm trong thiên can, sau đinh trước kỉ: năm Mậu Thân",
    example: "năm Mậu Thân",
  },
  {
    word: "mấu chốt",
    part_of_speech: "danh từ",
    meaning:
      "cái chủ yếu nhất, có ý nghĩa quyết định nhất trong toàn bộ vấn đề, toàn bộ hệ thống: mấu chốt của vấn đề",
    example: "mấu chốt của vấn đề",
  },
  {
    word: "mấu chốt",
    part_of_speech: "tính từ",
    meaning:
      "chủ yếu nhất, có tính chất quyết định nhất: vấn đề mấu chốt * điểm mấu chốt",
    example: "vấn đề mấu chốt * điểm mấu chốt",
  },
  {
    word: "mẫu",
    part_of_speech: "danh từ",
    meaning:
      "cái theo đó có thể tạo ra hàng loạt những cái khác cùng một kiểu: mẫu thiết kế * thực hiện những động tác mẫu * vẽ theo mẫu",
    example: "mẫu thiết kế * thực hiện những động tác mẫu * vẽ theo mẫu",
  },
  {
    word: "mẫu",
    part_of_speech: "danh từ",
    meaning:
      "cái có thể cho người ta hiểu biết về hàng loạt những cái khác cùng một kiểu: hàng bày mẫu * một mẫu nhân vật điển hình",
    example: "hàng bày mẫu * một mẫu nhân vật điển hình",
  },
  {
    word: "mậu dịch",
    part_of_speech: "động từ",
    meaning:
      "mua bán, trao đổi hàng hoá giữa các vùng, các nước: quan hệ mậu dịch giữa hai nước",
    example: "quan hệ mậu dịch giữa hai nước",
  },
  {
    word: "mậu dịch",
    part_of_speech: "danh từ",
    meaning: "mậu dịch quốc doanh (nói tắt): giá mậu dịch * cửa hàng mậu dịch",
    example: "giá mậu dịch * cửa hàng mậu dịch",
  },
  {
    word: "mẫu mã",
    part_of_speech: "danh từ",
    meaning:
      "quy cách, hình thức bên ngoài của hàng hoá: hàng hoá phong phú, mẫu mã đa dạng",
    example: "hàng hoá phong phú, mẫu mã đa dạng",
  },
  {
    word: "mẫu giáo",
    part_of_speech: "danh từ",
    meaning:
      "bậc giáo dục mầm non, nuôi dạy trẻ từ ba tuổi đến sáu tuổi (tuổi bắt đầu vào học lớp một): lớp mẫu giáo",
    example: "lớp mẫu giáo",
  },
  {
    word: "mẫu hệ",
    part_of_speech: "danh từ",
    meaning:
      "chế độ gia đình thời đại thị tộc nguyên thuỷ, trong đó quyền thừa kế của cải và tên họ thuộc dòng của người mẹ; phân biệt với phụ hệ: theo chế độ mẫu hệ",
    example: "theo chế độ mẫu hệ",
  },
  {
    word: "mẫu mực",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) mẫu để theo đó có thể tạo ra hàng loạt những cái khác (nói khái quát): hàng làm ra không theo một mẫu mực nào cả",
    example: "hàng làm ra không theo một mẫu mực nào cả",
  },
  {
    word: "mẫu mực",
    part_of_speech: "danh từ",
    meaning:
      "người, cái có tác dụng làm gương cho mọi người noi theo: cha mẹ làm mẫu mực cho con cái",
    example: "cha mẹ làm mẫu mực cho con cái",
  },
  {
    word: "mẫu mực",
    part_of_speech: "tính từ",
    meaning:
      "có đủ những phẩm chất tốt đẹp, có tác dụng làm mẫu, làm gương: một người cha mẫu mực",
    example: "một người cha mẫu mực",
  },
  {
    word: "mẫu số chung",
    part_of_speech: "danh từ",
    meaning:
      "bội số chung của các mẫu số của các phân số đã cho: 6 là mẫu số chung nhỏ nhất của hai phân số L và M",
    example: "6 là mẫu số chung nhỏ nhất của hai phân số L và M",
  },
  {
    word: "mầu nhiệm",
    part_of_speech: "tính từ",
    meaning:
      "tài tình đến mức như có phép lạ, không thể hiểu được bằng lẽ thường: một phương thuốc mầu nhiệm",
    example: "một phương thuốc mầu nhiệm",
  },
  {
    word: "mẫu số",
    part_of_speech: "danh từ",
    meaning:
      "số viết dưới vạch ngang của phân số, chỉ đơn vị được chia ra bao nhiêu phần bằng nhau; phân biệt với tử số: quy đồng mẫu số",
    example: "quy đồng mẫu số",
  },
  {
    word: "mẩy",
    part_of_speech: "tính từ",
    meaning: "to và chắc hạt, chắc thịt: hạt thóc mẩy * cua mẩy",
    example: "hạt thóc mẩy * cua mẩy",
  },
  {
    word: "mâu thuẫn",
    part_of_speech: "danh từ",
    meaning:
      "tình trạng xung đột, đối chọi trực tiếp với nhau: nội bộ có mâu thuẫn * mâu thuẫn cá nhân",
    example: "nội bộ có mâu thuẫn * mâu thuẫn cá nhân",
  },
  {
    word: "mâu thuẫn",
    part_of_speech: "danh từ",
    meaning:
      "tình trạng trái ngược nhau, phủ định nhau về một mặt nào đó: cách lập luận có nhiều mâu thuẫn * trong lòng đầy mâu thuẫn",
    example: "cách lập luận có nhiều mâu thuẫn * trong lòng đầy mâu thuẫn",
  },
  {
    word: "mâu thuẫn",
    part_of_speech: "danh từ",
    meaning:
      "tình trạng hai mặt đối lập phát triển theo chiều trái ngược nhau ở bên trong sự vật, làm cho sự vật biến đổi, phát triển: sự thống nhất của mâu thuẫn",
    example: "sự thống nhất của mâu thuẫn",
  },
  {
    word: "mâu thuẫn",
    part_of_speech: "động từ",
    meaning: "xung đột, chống chọi phủ định nhau: mâu thuẫn gay gắt với nhau",
    example: "mâu thuẫn gay gắt với nhau",
  },
  {
    word: "mẫu tử",
    part_of_speech: "danh từ",
    meaning: "mẹ con, về mặt quan hệ máu mủ: tình mẫu tử thiêng liêng",
    example: "tình mẫu tử thiêng liêng",
  },
  {
    word: "mẫu vật",
    part_of_speech: "danh từ",
    meaning:
      "vật dùng làm mẫu hoặc có tính chất như vật làm mẫu, giúp hiểu biết về hàng loạt những cái khác cùng loại: phân loại các mẫu vật",
    example: "phân loại các mẫu vật",
  },
  {
    word: "mấy",
    part_of_speech: "danh từ",
    meaning:
      "từ chỉ một số lượng nào đó không rõ, nhưng thường không nhiều, không lâu: chỉ còn mấy tháng nữa là Tết * mua mấy thứ lặt vặt",
    example: "chỉ còn mấy tháng nữa là Tết * mua mấy thứ lặt vặt",
  },
  {
    word: "mấy",
    part_of_speech: "danh từ",
    meaning:
      'từ chỉ một số lượng nào đó không rõ hoặc không cần nói rõ, nhưng không phải chỉ có một vài, mà được coi là tương đối nhiều: đến mấy lần mà không gặp * "Sự đời nghĩ cũng nực cười, Một con cá lội mấy người buông câu!" (ca dao)',
    example:
      'đến mấy lần mà không gặp * "Sự đời nghĩ cũng nực cười, Một con cá lội mấy người buông câu!" (ca dao)',
  },
  {
    word: "mấy",
    part_of_speech: "đại từ",
    meaning:
      "từ dùng để hỏi về một số lượng nào đó không rõ, nhưng thường là không nhiều: bây giờ là mấy giờ? * năm nay cháu lên mấy?",
    example: "bây giờ là mấy giờ? * năm nay cháu lên mấy?",
  },
  {
    word: "mấy",
    part_of_speech: "đại từ",
    meaning:
      'từ chỉ một số lượng hoặc mức độ nào đó không cần xác định, nhưng được coi là đáng kể: nói mấy cũng không hiểu * "Yêu nhau mấy núi cũng trèo, Mấy sông cũng lội mấy đèo cũng qua." (ca dao)',
    example:
      'nói mấy cũng không hiểu * "Yêu nhau mấy núi cũng trèo, Mấy sông cũng lội mấy đèo cũng qua." (ca dao)',
  },
  {
    word: "mấy",
    part_of_speech: "trợ từ",
    meaning: "(phương ngữ, khẩu ngữ) như với: cứu tôi mấy! * cho em chơi mấy!",
    example: "cứu tôi mấy! * cho em chơi mấy!",
  },
  {
    word: "mây",
    part_of_speech: "danh từ",
    meaning:
      "đám hạt nước hoặc hạt băng nhỏ li ti do hơi nước trong khí quyển ngưng lại, lơ lửng trên bầu trời: mây đen kéo mù trời * đám mây",
    example: "mây đen kéo mù trời * đám mây",
  },
  {
    word: "mây",
    part_of_speech: "danh từ",
    meaning:
      "cây leo, lá xẻ thuỳ sâu, cuống lá có gai, thân dài và mềm, thường dùng để buộc hoặc đan các đồ dùng trong nhà: ghế mây * roi mây",
    example: "ghế mây * roi mây",
  },
  {
    word: "mấy chốc",
    part_of_speech: "",
    meaning:
      '(khẩu ngữ) như chẳng mấy chốc: cứ đà này thì mấy chốc mà giàu * "Buồng không lần lữa hôm mai, Đầu xanh mấy chốc da mồi tóc sương." (ca dao)',
    example:
      'cứ đà này thì mấy chốc mà giàu * "Buồng không lần lữa hôm mai, Đầu xanh mấy chốc da mồi tóc sương." (ca dao)',
  },
  {
    word: "mấy ai",
    part_of_speech: "",
    meaning: "chẳng có mấy người: người như thế, mấy ai bì kịp",
    example: "người như thế, mấy ai bì kịp",
  },
  {
    word: "mấy đời",
    part_of_speech: "",
    meaning:
      '(khẩu ngữ) đời nào, chẳng bao giờ: "Mấy đời bánh đúc có xương, Mấy đời dì ghẻ có thương con chồng." (ca dao)',
    example:
      'Mấy đời bánh đúc có xương, Mấy đời dì ghẻ có thương con chồng." (ca dao)',
  },
  {
    word: "mây khói",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) mây và khói; dùng để ví cái bỗng chốc tan tành, không còn gì nữa: bao nhiêu hi vọng đều tan thành mây khói",
    example: "bao nhiêu hi vọng đều tan thành mây khói",
  },
  {
    word: "mấy khi",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) như chẳng mấy khi: mấy khi anh em được gặp nhau * đi suốt, mấy khi ở nhà đâu",
    example: "mấy khi anh em được gặp nhau * đi suốt, mấy khi ở nhà đâu",
  },
  {
    word: "mấy nỗi",
    part_of_speech: "",
    meaning: "(khẩu ngữ) như chẳng mấy nỗi: của ấy thì mấy nỗi mà hỏng",
    example: "của ấy thì mấy nỗi mà hỏng",
  },
  {
    word: "mây xanh",
    part_of_speech: "danh từ",
    meaning:
      "khoảng không trên trời cao, nơi chỉ nhìn thấy một màu xanh: sợ quá, hồn vía bay lên mây xanh",
    example: "sợ quá, hồn vía bay lên mây xanh",
  },
  {
    word: "mấy nả",
    part_of_speech: "",
    meaning:
      "(phương ngữ, khẩu ngữ) chẳng được bao lâu, bao nhiêu: sức nó thì chịu được mấy nả",
    example: "sức nó thì chịu được mấy nả",
  },
  {
    word: "mây mưa",
    part_of_speech: "danh từ",
    meaning:
      '(Từ cũ, Văn chương) mây và mưa; dùng để chỉ thú vui xác thịt: "Bóng gương lấp ló trong mành, Cỏ cây cũng muốn nổi tình mây mưa." (CO)',
    example:
      'Bóng gương lấp ló trong mành, Cỏ cây cũng muốn nổi tình mây mưa." (CO)',
  },
  {
    word: "mấy mươi",
    part_of_speech: "",
    meaning:
      '(khẩu ngữ) số lượng, mức độ không xác định, nhưng cũng là đáng kể: công việc phải qua mấy mươi khâu * "Công trình kể biết mấy mươi, Vì ta khăng khít cho người dở dang." (TKiều)',
    example:
      'công việc phải qua mấy mươi khâu * "Công trình kể biết mấy mươi, Vì ta khăng khít cho người dở dang." (TKiều)',
  },
  {
    word: "mấy lại",
    part_of_speech: "kết từ",
    meaning:
      "(khẩu ngữ) như với lại: tôi không đi đâu, mấy lại cũng đã tối rồi",
    example: "tôi không đi đâu, mấy lại cũng đã tối rồi",
  },
  {
    word: "mè",
    part_of_speech: "danh từ",
    meaning: "(khẩu ngữ) cá mè (nói tắt)",
    example: "dầu mè",
  },
  {
    word: "mẹ",
    part_of_speech: "danh từ",
    meaning:
      "người phụ nữ có con, trong quan hệ với con (cũng dùng để xưng gọi): cha sinh mẹ dưỡng * sắp được làm mẹ * con lại đây với mẹ",
    example: "cha sinh mẹ dưỡng * sắp được làm mẹ * con lại đây với mẹ",
  },
  {
    word: "mẹ",
    part_of_speech: "danh từ",
    meaning:
      "con vật cái thuộc thế hệ trước, trong quan hệ với những con vật thuộc thế hệ sau và do nó trực tiếp sinh ra: gà mẹ * con bò mẹ",
    example: "gà mẹ * con bò mẹ",
  },
  {
    word: "mẹ",
    part_of_speech: "danh từ",
    meaning:
      "cái xuất phát, cái từ đó sinh ra những cái khác: bom mẹ * lãi mẹ đẻ lãi con",
    example: "bom mẹ * lãi mẹ đẻ lãi con",
  },
  {
    word: "mẹ",
    part_of_speech: "danh từ",
    meaning:
      "từ dùng để gọi người phụ nữ đáng bậc mẹ (hàm ý coi trọng): mẹ chiến sĩ * mẹ Việt Nam anh hùng",
    example: "mẹ chiến sĩ * mẹ Việt Nam anh hùng",
  },
  {
    word: "mẹ",
    part_of_speech: "danh từ",
    meaning:
      "(Thông tục) từ dùng trong tiếng chửi rủa: mất mẹ nó cả ngày! * hỏng mẹ nó quyển sách! * kệ mẹ nó!",
    example: "mất mẹ nó cả ngày! * hỏng mẹ nó quyển sách! * kệ mẹ nó!",
  },
  {
    word: "mẻ",
    part_of_speech: "danh từ",
    meaning:
      "chất chua làm bằng cơm nguội để lên men, dùng làm gia vị khi nấu thức ăn: chua như mẻ * món ốc nấu mẻ",
    example: "chua như mẻ * món ốc nấu mẻ",
  },
  {
    word: "mẻ",
    part_of_speech: "danh từ",
    meaning:
      "tổng thể nói chung những vật cùng loại được làm ra, sản xuất ra trong cùng một lần, một đợt: rang vài mẻ lạc * mẻ gạch này bị non * một mẻ lưới nặng",
    example: "rang vài mẻ lạc * mẻ gạch này bị non * một mẻ lưới nặng",
  },
  {
    word: "mẻ",
    part_of_speech: "tính từ",
    meaning:
      "(vật rắn) bị mất đi một mảnh nhỏ ở rìa, ở cạnh: lưỡi dao bị mẻ * cái bát mẻ",
    example: "lưỡi dao bị mẻ * cái bát mẻ",
  },
  {
    word: "mẽ",
    part_of_speech: "danh từ",
    meaning:
      "(khẩu ngữ) dáng, vẻ bề ngoài của con người (hàm ý chê, coi thường): chỉ được cái mẽ!",
    example: "chỉ được cái mẽ!",
  },
  {
    word: "mẽ",
    part_of_speech: "danh từ",
    meaning:
      "vẻ tốt đẹp cố ý phô bày ra ngoài, thường là giả tạo: khoe mẽ * chỉ hỏi lấy mẽ thôi!",
    example: "khoe mẽ * chỉ hỏi lấy mẽ thôi!",
  },
  {
    word: "me",
    part_of_speech: "danh từ",
    meaning: "lối đánh bạc thời trước, giống như lú: hốt me (đánh me)",
    example: "hốt me (đánh me)",
  },
  {
    word: "me",
    part_of_speech: "danh từ",
    meaning:
      '(Phương ngữ) bê: thịt me * "Ra đường quần lĩnh áo the, Về nhà không có con me mà cày." (Cdao)',
    example:
      'thịt me * "Ra đường quần lĩnh áo the, Về nhà không có con me mà cày." (Cdao)',
  },
  {
    word: "mé",
    part_of_speech: "danh từ",
    meaning:
      "phần ở phía ngoài cùng, ở mép của bề mặt một vật, một khu vực: nhà ở mé rừng * con đường chạy sát mé biển",
    example: "nhà ở mé rừng * con đường chạy sát mé biển",
  },
  {
    word: "mé",
    part_of_speech: "danh từ",
    meaning:
      'phía ở về nơi không xa lắm: mé sau nhà * "Hàn gia ở mé tây thiên, Dưới dòng nước chảy, bên trên có cầu." (TKiều)',
    example:
      'mé sau nhà * "Hàn gia ở mé tây thiên, Dưới dòng nước chảy, bên trên có cầu." (TKiều)',
  },
  {
    word: "mé",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) chặt, tỉa bớt: mé cành tỉa nhánh",
    example: "mé cành tỉa nhánh",
  },
  {
    word: "mẹ đĩ",
    part_of_speech: "danh từ",
    meaning:
      "(cũ, khẩu ngữ) từ dùng ở nông thôn thời trước để gọi người đàn bà (còn trẻ) có con gái đầu lòng (thường là chồng gọi vợ hoặc cha mẹ gọi con gái, con dâu): mẹ đĩ nhà tôi",
    example: "mẹ đĩ nhà tôi",
  },
  {
    word: "mẹ gà con vịt",
    part_of_speech: "",
    meaning:
      'ví quan hệ mẹ con chỉ có tính hình thức, không cùng máu mủ ruột thịt, không có tình cảm thật sự (thường dùng để nói cảnh mẹ ghẻ đối xử tệ bạc với con chồng): "Mẹ gà con vịt chắt chiu, Mấy đời dì ghẻ nâng niu con chồng." (Ca dao)',
    example:
      'Mẹ gà con vịt chắt chiu, Mấy đời dì ghẻ nâng niu con chồng." (Ca dao)',
  },
  {
    word: "mẹ ghẻ",
    part_of_speech: "danh từ",
    meaning: "như dì ghẻ: cảnh mẹ ghẻ con chồng",
    example: "cảnh mẹ ghẻ con chồng",
  },
  {
    word: "mẹ kiếp",
    part_of_speech: "",
    meaning:
      "(thông tục) tiếng rủa, thường để biểu thị ý giận mình, giận đời: mẹ kiếp, nó lại định chơi cả mình!",
    example: "mẹ kiếp, nó lại định chơi cả mình!",
  },
  {
    word: "mè xửng",
    part_of_speech: "danh từ",
    meaning:
      "kẹo dẻo, màu hơi vàng và trong, lớp ngoài bọc vừng, được cắt thành miếng: mè xửng là một đặc sản của xứ Huế",
    example: "mè xửng là một đặc sản của xứ Huế",
  },
  {
    word: "mè nheo",
    part_of_speech: "động từ",
    meaning:
      "nói nhiều và dai dẳng để nài xin, phàn nàn hoặc trách móc, khiến người nghe thấy khó chịu: tính hay mè nheo",
    example: "tính hay mè nheo",
  },
  {
    word: "megabyte",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị đo độ lớn của thông tin hoặc bộ nhớ của máy tính, bằng 1.048.576 byte: ổ cứng 40 megabyte",
    example: "ổ cứng 40 megabyte",
  },
  {
    word: "mèm",
    part_of_speech: "phụ từ",
    meaning:
      "(khẩu ngữ) (say hoặc đói) đến mức như bủn rủn cả chân tay: bụng đói mèm * uống rượu say mèm",
    example: "bụng đói mèm * uống rượu say mèm",
  },
  {
    word: "méc",
    part_of_speech: "động từ",
    meaning: "(Nam, khẩu ngữ) mách: Em méc mẹ cho coi!",
    example: "Em méc mẹ cho coi!",
  },
  {
    word: "men sứ",
    part_of_speech: "danh từ",
    meaning: "lớp men tráng trên bề mặt các sản phẩm làm bằng sứ: gạch men sứ",
    example: "gạch men sứ",
  },
  {
    word: "mèng",
    part_of_speech: "tính từ",
    meaning:
      "(thông tục) tồi, kém: học không đến nỗi mèng * mèng ra một ngày cũng kiếm được dăm chục",
    example:
      "học không đến nỗi mèng * mèng ra một ngày cũng kiếm được dăm chục",
  },
  {
    word: "men",
    part_of_speech: "danh từ",
    meaning:
      "tên gọi thông thường của enzym (thường nói về mặt có tác dụng gây nên quá trình gọi là lên men): men giấm * men rượu * men tiêu hoá",
    example: "men giấm * men rượu * men tiêu hoá",
  },
  {
    word: "men",
    part_of_speech: "danh từ",
    meaning:
      "rượu, về mặt có tác dụng gây hưng phấn hoặc làm say: say men * hơi men nồng nặc",
    example: "say men * hơi men nồng nặc",
  },
  {
    word: "men",
    part_of_speech: "danh từ",
    meaning:
      "lớp mỏng được tráng lên trên bề mặt các loại sản phẩm như gốm, sứ, sắt, v.v. có tác dụng làm tăng độ bền và vẻ đẹp, bóng: nền nhà lát gạch men * men sứ * bát sắt tráng men",
    example: "nền nhà lát gạch men * men sứ * bát sắt tráng men",
  },
  {
    word: "men",
    part_of_speech: "danh từ",
    meaning:
      "lớp bọc ngoài răng, trong suốt và cứng có tác dụng bảo vệ răng: bị hỏng men răng",
    example: "bị hỏng men răng",
  },
  {
    word: "men",
    part_of_speech: "động từ",
    meaning: "di chuyển lần theo phía bên hoặc mé ngoài: men bờ sông về làng",
    example: "men bờ sông về làng",
  },
  {
    word: "méo",
    part_of_speech: "tính từ",
    meaning:
      "không có, không còn hình dáng tròn hoặc cân đối như phải có, vốn có: vung nồi bị méo * cái nón méo * cố tình bóp méo sự thật (b)",
    example: "vung nồi bị méo * cái nón méo * cố tình bóp méo sự thật (b)",
  },
  {
    word: "méo",
    part_of_speech: "tính từ",
    meaning:
      "(âm thanh phát ra từ một dụng cụ nào đó) bị biến đổi, không tự nhiên, không bình thường: băng ghi âm bị méo tiếng",
    example: "băng ghi âm bị méo tiếng",
  },
  {
    word: "meo",
    part_of_speech: "danh từ",
    meaning: "(Phương ngữ) rêu: chân tường nổi meo",
    example: "chân tường nổi meo",
  },
  {
    word: "meo",
    part_of_speech: "danh từ",
    meaning: "mốc bám thành mảng: vại cà bị lên meo",
    example: "vại cà bị lên meo",
  },
  {
    word: "meo",
    part_of_speech: "tính từ",
    meaning:
      "(Khẩu ngữ) đói đến mức thấy như không có tí gì trong bụng: mặt phờ bụng meo * nhịn meo một bữa",
    example: "mặt phờ bụng meo * nhịn meo một bữa",
  },
  {
    word: "meo",
    part_of_speech: "động từ",
    meaning: "từ mô phỏng tiếng kêu của mèo: con mèo kêu meo meo",
    example: "con mèo kêu meo meo",
  },
  {
    word: "mẹo",
    part_of_speech: "danh từ",
    meaning:
      "cách khôn ngoan, thông minh được nghĩ ra trong một hoàn cảnh nhất định để giải quyết một việc khó: lập mẹo đánh lừa * mẹo học ngoại ngữ",
    example: "lập mẹo đánh lừa * mẹo học ngoại ngữ",
  },
  {
    word: "mén",
    part_of_speech: "tính từ",
    meaning: "(động vật nhỏ) mới sinh, mới nở: chấy mén * rận mén * đỉa mén",
    example: "chấy mén * rận mén * đỉa mén",
  },
  {
    word: "mèo",
    part_of_speech: "danh từ",
    meaning:
      "thú nhỏ thuộc nhóm ăn thịt, leo trèo rất giỏi, nuôi trong nhà để bắt chuột hoặc để làm cảnh: mèo mướp * chó treo, mèo đậy (tng) * mỡ để miệng mèo (tng)",
    example: "mèo mướp * chó treo, mèo đậy (tng) * mỡ để miệng mèo (tng)",
  },
  {
    word: "méo mặt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) tỏ ra hết sức lo lắng, khổ sở, thể hiện rõ trên vẻ mặt: nhà đông con, chỉ chạy ăn cũng đủ méo mặt!",
    example: "nhà đông con, chỉ chạy ăn cũng đủ méo mặt!",
  },
  {
    word: "méo xẹo",
    part_of_speech: "tính từ",
    meaning: "(phương ngữ) méo xệch: mặt mũi méo xẹo * miệng méo xẹo như mếu",
    example: "mặt mũi méo xẹo * miệng méo xẹo như mếu",
  },
  {
    word: "méo mó",
    part_of_speech: "tính từ",
    meaning: "như méo (nhưng nghĩa mạnh hơn): cái nồi méo mó",
    example: "cái nồi méo mó",
  },
  {
    word: "méo mó",
    part_of_speech: "tính từ",
    meaning:
      "không đúng như thật, mà sai lệch đi: phản ánh sự thật một cách méo mó * cách nhìn méo mó",
    example: "phản ánh sự thật một cách méo mó * cách nhìn méo mó",
  },
  {
    word: "mẹp",
    part_of_speech: "tính từ",
    meaning: "(nằm) áp gí mình xuống: con trâu nằm mẹp trong vũng bùn",
    example: "con trâu nằm mẹp trong vũng bùn",
  },
  {
    word: "mét",
    part_of_speech: "danh từ",
    meaning: "đơn vị cơ bản đo độ dài: mua hai mét vải",
    example: "mua hai mét vải",
  },
  {
    word: "mét",
    part_of_speech: "tính từ",
    meaning:
      "(nước da) nhợt nhạt, đến mức như không còn chút máu: mặt mày tái mét * nước da mét như người có bệnh",
    example: "mặt mày tái mét * nước da mét như người có bệnh",
  },
  {
    word: "méo xệch",
    part_of_speech: "tính từ",
    meaning:
      "méo lệch hẳn đi về một bên, trông xấu: cái cười méo xệch * mồm méo xệch ra, chực khóc",
    example: "cái cười méo xệch * mồm méo xệch ra, chực khóc",
  },
  {
    word: "mê",
    part_of_speech: "danh từ",
    meaning:
      "đồ đan bằng tre nứa thường có vành tròn và đã hỏng cạp: cái mê rổ * nón mê * lành làm thúng, thủng làm mê (tng)",
    example: "cái mê rổ * nón mê * lành làm thúng, thủng làm mê (tng)",
  },
  {
    word: "mê",
    part_of_speech: "động từ",
    meaning:
      'ở trạng thái cơ thể chỉ còn một phần hoặc mất hẳn khả năng nhận biết và đáp ứng với các kích thích: gây mê * "Sinh vừa tựa án thiu thiu, Giở chiều như tỉnh, giở chiều như mê." (TKiều)',
    example:
      'gây mê * "Sinh vừa tựa án thiu thiu, Giở chiều như tỉnh, giở chiều như mê." (TKiều)',
  },
  {
    word: "mê",
    part_of_speech: "động từ",
    meaning: "(phương ngữ) mơ: đêm ngủ hay mê",
    example: "đêm ngủ hay mê",
  },
  {
    word: "mê",
    part_of_speech: "động từ",
    meaning:
      "ham thích tới mức như bị cuốn hút hoàn toàn vào, không còn biết đến những cái khác: mê đá bóng * mê xem phim chưởng",
    example: "mê đá bóng * mê xem phim chưởng",
  },
  {
    word: "mép",
    part_of_speech: "danh từ",
    meaning:
      "chỗ hai đầu môi liền với nhau, tạo thành khoé miệng: cười nhếch mép * để ria mép * nói vã cả bọt mép",
    example: "cười nhếch mép * để ria mép * nói vã cả bọt mép",
  },
  {
    word: "mép",
    part_of_speech: "danh từ",
    meaning:
      "(Khẩu ngữ) môi, miệng con người, coi là biểu tượng của sự nói nhiều, nói hay, nhưng chỉ là ngoài miệng chứ không thực lòng hoặc không làm như đã nói: đồ bẻm mép * chỉ giỏi nói mép",
    example: "đồ bẻm mép * chỉ giỏi nói mép",
  },
  {
    word: "mép",
    part_of_speech: "danh từ",
    meaning:
      "phần phía ngoài cùng của bề mặt của vật có hình tấm: mép giường * quyển vở bị quăn mép * đi men theo mép nước",
    example: "mép giường * quyển vở bị quăn mép * đi men theo mép nước",
  },
  {
    word: "mét vuông",
    part_of_speech: "danh từ",
    meaning:
      "đơn vị đo diện tích, bằng diện tích của một hình vuông có cạnh là 1 mét: căn phòng rộng 25 mét vuông",
    example: "căn phòng rộng 25 mét vuông",
  },
  {
    word: "mề",
    part_of_speech: "danh từ",
    meaning:
      "phần dạ dày của các loài chim ăn hạt, vách rất dày, có tác dụng nghiền thức ăn: mề gà",
    example: "mề gà",
  },
  {
    word: "mế",
    part_of_speech: "danh từ",
    meaning:
      "mẹ (theo cách gọi của một số dân tộc thiểu số ở miền Bắc Việt Nam): một bà mế người Mường",
    example: "một bà mế người Mường",
  },
  {
    word: "mê cuồng",
    part_of_speech: "động từ",
    meaning:
      "say mê đến mức mất hết sáng suốt, không còn ý thức được phải trái, đúng sai nữa: cơn mê cuồng",
    example: "cơn mê cuồng",
  },
  {
    word: "mệ",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ) mẹ (chỉ dùng để xưng gọi).",
    example:
      'Của đời ông mệ để cho, Mần không ăn có của kho cũng rồi." (ca dao)',
  },
  {
    word: "mệ",
    part_of_speech: "danh từ",
    meaning:
      '(Trung) bà: "Của đời ông mệ để cho, Mần không ăn có của kho cũng rồi." (ca dao)',
    example: "các mệ ở Huế",
  },
  {
    word: "mễ",
    part_of_speech: "danh từ",
    meaning:
      "đồ dùng để kê đỡ, làm bằng một phiến gỗ dài, hẹp, có chân ở hai đầu: mễ phản * kê hòm lên hai cái mễ",
    example: "mễ phản * kê hòm lên hai cái mễ",
  },
  {
    word: "mê cung",
    part_of_speech: "danh từ",
    meaning:
      "hệ thống lối đi được ngăn cách bằng những bức tường hoặc hàng rào, thường là do tưởng tượng, rất phức tạp và khó phân biệt, đã vào trong thì khó tìm được lối ra: chốn mê cung * bị lọt vào mê cung",
    example: "chốn mê cung * bị lọt vào mê cung",
  },
  {
    word: "mê li",
    part_of_speech: "tính từ",
    meaning:
      "có tác dụng làm thích thú đến mức say sưa, đắm đuối: giọng hát mê li * sướng mê li",
    example: "giọng hát mê li * sướng mê li",
  },
  {
    word: "mê hoặc",
    part_of_speech: "động từ",
    meaning:
      "làm cho mất tỉnh táo, mất sáng suốt, mù quáng tin theo: bị tà thuyết làm cho mê hoặc",
    example: "bị tà thuyết làm cho mê hoặc",
  },
  {
    word: "mề gà",
    part_of_speech: "danh từ",
    meaning:
      "túi nhỏ hình giống cái mề con gà, thường dùng để đựng tiền: để tiền trong cái mề gà",
    example: "để tiền trong cái mề gà",
  },
  {
    word: "mê đắm",
    part_of_speech: "động từ",
    meaning:
      'say mê đến mức đắm đuối: cảnh đẹp làm mê đắm lòng người * "(...) không biết bao nhiêu lần chị Sứ lặng lẽ ngồi nhìn con mình một cách mê đắm như thế." (AĐức; 16)',
    example:
      'cảnh đẹp làm mê đắm lòng người * "(...) không biết bao nhiêu lần chị Sứ lặng lẽ ngồi nhìn con mình một cách mê đắm như thế." (AĐức; 16)',
  },
  {
    word: "mê hồn",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) có sức hấp dẫn đến mức làm say mê, đắm đuối: đẹp mê hồn * câu chuyện có sức cuốn hút mê hồn",
    example: "đẹp mê hồn * câu chuyện có sức cuốn hút mê hồn",
  },
  {
    word: "mê lú",
    part_of_speech: "",
    meaning:
      "ở trạng thái gần như lú lẫn đi, không còn nhớ, không còn biết gì hết: đầu óc như mê lú",
    example: "đầu óc như mê lú",
  },
  {
    word: "mê mải",
    part_of_speech: "động từ",
    meaning: "như mải mê: mê mải đọc sách",
    example: "mê mải đọc sách",
  },
  {
    word: "mê man",
    part_of_speech: "",
    meaning: "mê kéo dài: nằm li bì, mê man * sốt mê man",
    example: "nằm li bì, mê man * sốt mê man",
  },
  {
    word: "mê man",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) say mê làm việc gì tới mức dường như quên cả thực tại: mê man trong công việc * người thầy mê man giảng giải",
    example: "mê man trong công việc * người thầy mê man giảng giải",
  },
  {
    word: "mê mẩn",
    part_of_speech: "động từ",
    meaning:
      "mê đi và không còn có ý thức về những điều mình nói, mình làm: cơn mê mẩn",
    example: "cơn mê mẩn",
  },
  {
    word: "mê mẩn",
    part_of_speech: "động từ",
    meaning:
      'say sưa thích thú đến mức như không còn biết gì nữa: thích đến mê mẩn * "Lại càng mê mẩn tâm thần, Lại càng đứng lặng tần ngần chẳng ra." (TKiều)',
    example:
      'thích đến mê mẩn * "Lại càng mê mẩn tâm thần, Lại càng đứng lặng tần ngần chẳng ra." (TKiều)',
  },
  {
    word: "mê muội",
    part_of_speech: "",
    meaning:
      "ở trạng thái mất tỉnh táo, mất sáng suốt đến mức không còn ý thức được đâu là phải trái, đúng sai: đầu óc mê muội",
    example: "đầu óc mê muội",
  },
  {
    word: "mê ngủ",
    part_of_speech: "động từ",
    meaning:
      "ngủ mê; thường dùng để ví trạng thái tạm thời mất ý thức về thực tại do bị tác động mạnh đến tâm lí: cứ như người mê ngủ",
    example: "cứ như người mê ngủ",
  },
  {
    word: "mê ly",
    part_of_speech: "tính từ",
    meaning:
      "có tác dụng làm thích thú đến mức say sưa, đắm đuối: giọng hát mê li * sướng mê li",
    example: "giọng hát mê li * sướng mê li",
  },
  {
    word: "mê lộ",
    part_of_speech: "danh từ",
    meaning:
      "đường đi lạc, khó tìm được lối ra; thường dùng với sắc thái văn chương để ví con đường lầm lạc: lạc vào mê lộ",
    example: "lạc vào mê lộ",
  },
  {
    word: "mê mệt",
    part_of_speech: "động từ",
    meaning:
      "thiếp đi với vẻ mệt mỏi: ngủ mê mệt * nằm mê mệt như không biết gì",
    example: "ngủ mê mệt * nằm mê mệt như không biết gì",
  },
  {
    word: "mê mệt",
    part_of_speech: "động từ",
    meaning:
      "say mê đến mức không giữ được trạng thái tình cảm, tinh thần thăng bằng: yêu mê mệt * ham thích đến mê mệt",
    example: "yêu mê mệt * ham thích đến mê mệt",
  },
  {
    word: "mê tín",
    part_of_speech: "động từ",
    meaning:
      "tin một cách mù quáng vào thần thánh, ma quỷ, số mệnh, và những điều huyền hoặc: bài trừ các tệ nạn mê tín, dị đoan",
    example: "bài trừ các tệ nạn mê tín, dị đoan",
  },
  {
    word: "mê tín",
    part_of_speech: "động từ",
    meaning:
      "(Khẩu ngữ) ưa chuộng, tin tưởng một cách mù quáng, thiếu suy xét: mê tín hàng ngoại * mê tín thuốc tây",
    example: "mê tín hàng ngoại * mê tín thuốc tây",
  },
  {
    word: "mê say",
    part_of_speech: "động từ",
    meaning: "như say mê: mê say quyền lực",
    example: "mê say quyền lực",
  },
  {
    word: "mê sảng",
    part_of_speech: "động từ",
    meaning: "mê và nói lảm nhảm: mê sảng vì sốt cao",
    example: "mê sảng vì sốt cao",
  },
  {
    word: "mê tít",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) mê, thích đến mức không còn biết gì khác nữa: anh chàng mê tít cô ta",
    example: "anh chàng mê tít cô ta",
  },
  {
    word: "mếch lòng",
    part_of_speech: "động từ",
    meaning:
      "có điều không vừa lòng, vì cảm thấy bị chạm tự ái (trong quan hệ giữa những người ít nhiều có sự gần gũi, nhưng thường không phải là thân thiết ruột thịt): không làm mếch lòng ai bao giờ",
    example: "không làm mếch lòng ai bao giờ",
  },
  {
    word: "mềm lòng",
    part_of_speech: "động từ",
    meaning:
      "trở nên yếu đuối trước tác động tình cảm hoặc trước khó khăn: phút giây mềm lòng * bị mềm lòng vì nước mắt của phụ nữ",
    example: "phút giây mềm lòng * bị mềm lòng vì nước mắt của phụ nữ",
  },
  {
    word: "mềm",
    part_of_speech: "tính từ",
    meaning:
      "dễ biến dạng dưới tác dụng của lực cơ học: mềm như bún * ngâm nước cho sợi miến mềm ra * lạt mềm buộc chặt (tng)",
    example:
      "mềm như bún * ngâm nước cho sợi miến mềm ra * lạt mềm buộc chặt (tng)",
  },
  {
    word: "mềm",
    part_of_speech: "tính từ",
    meaning:
      "có khả năng làm những động tác nào đó và chuyển đổi động tác một cách rất dễ dàng, tự nhiên: động tác rất mềm * tay múa mềm",
    example: "động tác rất mềm * tay múa mềm",
  },
  {
    word: "mềm",
    part_of_speech: "tính từ",
    meaning:
      "dễ dàng có những nhân nhượng tuỳ theo hoàn cảnh, trong quan hệ đối xử: đấu tranh cũng phải có lúc mềm lúc cứng",
    example: "đấu tranh cũng phải có lúc mềm lúc cứng",
  },
  {
    word: "mềm",
    part_of_speech: "tính từ",
    meaning: "(khẩu ngữ) (giá) rẻ, dễ được chấp nhận: mua được với giá rất mềm",
    example: "mua được với giá rất mềm",
  },
  {
    word: "mê tơi",
    part_of_speech: "động từ",
    meaning:
      "(khẩu ngữ) ở trạng thái như mê mẩn đi vì được thoả mãn thích thú đến cao độ: thích mê tơi * sướng mê tơi",
    example: "thích mê tơi * sướng mê tơi",
  },
  {
    word: "mê tơi",
    part_of_speech: "động từ",
    meaning:
      "choáng váng không còn biết gì do bị tác động mạnh và dồn dập: bị đánh một trận mê tơi",
    example: "bị đánh một trận mê tơi",
  },
  {
    word: "mềm dẻo",
    part_of_speech: "tính từ",
    meaning:
      "có khả năng thực hiện mọi động tác một cách mềm mại, nhịp nhàng: đôi tay mềm dẻo",
    example: "đôi tay mềm dẻo",
  },
  {
    word: "mềm dẻo",
    part_of_speech: "tính từ",
    meaning:
      "biết thay đổi, điều chỉnh ít nhiều cách đối xử cụ thể cho hợp hoàn cảnh hoặc đối tượng: thái độ mềm dẻo",
    example: "thái độ mềm dẻo",
  },
  {
    word: "mềm mại",
    part_of_speech: "tính từ",
    meaning:
      "mềm và gợi cảm giác dễ chịu khi sờ đến: tấm lụa mềm mại * đôi bàn tay mềm mại",
    example: "tấm lụa mềm mại * đôi bàn tay mềm mại",
  },
  {
    word: "mềm mại",
    part_of_speech: "tính từ",
    meaning:
      "có dáng, nét lượn cong tự nhiên, trông đẹp mắt: dáng đi mềm mại * nét chữ mềm mại",
    example: "dáng đi mềm mại * nét chữ mềm mại",
  },
  {
    word: "mềm mại",
    part_of_speech: "tính từ",
    meaning:
      "có âm điệu uyển chuyển, nhẹ nhàng, dễ nghe: giọng nói dịu dàng, mềm mại * đọc với giọng mềm mại",
    example: "giọng nói dịu dàng, mềm mại * đọc với giọng mềm mại",
  },
  {
    word: "mền",
    part_of_speech: "danh từ",
    meaning:
      "(Nam mền) đồ dùng bằng vải, len, dạ, v.v. may, dệt thành tấm để đắp cho ấm: chăn len * đắp chăn",
    example: "chăn len *",
  },
  {
    word: "mền",
    part_of_speech: "động từ",
    meaning:
      "đưa gia súc, gia cầm đi kiếm ăn và trông nom chúng: chăn bò * chăn ngỗng * trẻ chăn trâu",
    example: "chăn bò * chăn ngỗng * trẻ chăn trâu",
  },
  {
    word: "mềm mỏng",
    part_of_speech: "tính từ",
    meaning:
      "khéo léo, nhẹ nhàng trong cách nói năng, trong thái độ đối xử, biết cách làm người ta không phật ý: thái độ mềm mỏng * nói năng mềm mỏng",
    example: "thái độ mềm mỏng * nói năng mềm mỏng",
  },
  {
    word: "mềm nhũn",
    part_of_speech: "tính từ",
    meaning: "mềm đến mức như nhũn ra: quả chuối chín rục, mềm nhũn",
    example: "quả chuối chín rục, mềm nhũn",
  },
  {
    word: "mềm nhũn",
    part_of_speech: "tính từ",
    meaning:
      "ở trạng thái hoàn toàn không còn sức cử động như ý muốn, không giữ được tư thế bình thường nữa: sợ quá, người mềm nhũn đi * hai đầu gối mềm nhũn, tưởng đứng không vững",
    example:
      "sợ quá, người mềm nhũn đi * hai đầu gối mềm nhũn, tưởng đứng không vững",
  },
  {
    word: "mềm môi",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) ví trường hợp uống rượu vui miệng cứ uống mãi, không muốn thôi: uống rượu mềm môi",
    example: "uống rượu mềm môi",
  },
  {
    word: "mến",
    part_of_speech: "động từ",
    meaning:
      "có cảm tình, thích gần gũi vì thấy hợp ý mình: giàu lòng mến khách * một người dễ mến",
    example: "giàu lòng mến khách * một người dễ mến",
  },
  {
    word: "mềm yếu",
    part_of_speech: "tính từ",
    meaning:
      "dễ để cho tình cảm chi phối mà trở nên mềm lòng, thiếu kiên quyết: tình cảm mềm yếu * tính mềm yếu, nhu nhược",
    example: "tình cảm mềm yếu * tính mềm yếu, nhu nhược",
  },
  {
    word: "mền mệt",
    part_of_speech: "tính từ",
    meaning: "cảm thấy hơi mệt: thấy trong người có vẻ mền mệt",
    example: "thấy trong người có vẻ mền mệt",
  },
  {
    word: "mến thương",
    part_of_speech: "",
    meaning: "có tình cảm thương yêu, gắn bó: bạn bè mến thương",
    example: "bạn bè mến thương",
  },
  {
    word: "mên mến",
    part_of_speech: "động từ",
    meaning: "cảm thấy có phần hơi mến: hai người đã mên mến nhau",
    example: "hai người đã mên mến nhau",
  },
  {
    word: "mến phục",
    part_of_speech: "động từ",
    meaning:
      "có cảm tình yêu mến và kính phục: một vị tướng được nhiều người mến phục",
    example: "một vị tướng được nhiều người mến phục",
  },
  {
    word: "mệnh",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) lời truyền bảo của người trên (thường là của vua) đối với người dưới: vâng mệnh vua",
    example: "vâng mệnh vua",
  },
  {
    word: "mệnh",
    part_of_speech: "danh từ",
    meaning:
      "những điều sướng, khổ đã định sẵn một cách thần bí cho từng người trong cuộc đời, không cưỡng lại được, theo quan niệm duy tâm: mệnh yểu * sao chiếu mệnh * hồng nhan bạc mệnh",
    example: "mệnh yểu * sao chiếu mệnh * hồng nhan bạc mệnh",
  },
  {
    word: "mệnh",
    part_of_speech: "danh từ",
    meaning: "(phương ngữ, cũ) mạng: coi mệnh người như cỏ rác",
    example: "coi mệnh người như cỏ rác",
  },
  {
    word: "mệnh chung",
    part_of_speech: "động từ",
    meaning: "(cũ, trang trọng) chết: mệnh chung nơi đất khách quê người",
    example: "mệnh chung nơi đất khách quê người",
  },
  {
    word: "mến mộ",
    part_of_speech: "",
    meaning: "có tình cảm yêu mến và hâm mộ: mến mộ tài năng",
    example: "mến mộ tài năng",
  },
  {
    word: "mệnh danh",
    part_of_speech: "động từ",
    meaning:
      "mang tên là (thường để nêu một đặc trưng nào đó): động Hương Tích được mệnh danh là 'thiên Nam đệ nhất động'",
    example: "động Hương Tích được mệnh danh là 'thiên Nam đệ nhất động'",
  },
  {
    word: "mệnh giá",
    part_of_speech: "danh từ",
    meaning:
      "giá trị của một loại tiền, chứng khoán, cổ phiếu,? được in sẵn trên từng loại khi phát hành: loại tiền có mệnh giá một trăm ngàn đồng",
    example: "loại tiền có mệnh giá một trăm ngàn đồng",
  },
  {
    word: "mệnh hệ",
    part_of_speech: "danh từ",
    meaning:
      "(trang trọng) mối quan hệ trực tiếp đe doạ đến tính mạng: nếu anh có mệnh hệ nào thì tôi ân hận lắm",
    example: "nếu anh có mệnh hệ nào thì tôi ân hận lắm",
  },
  {
    word: "mệnh lệnh",
    part_of_speech: "danh từ",
    meaning:
      "lệnh bắt buộc phải thi hành, chấp hành (nói khái quát): chấp hành mệnh lệnh của cấp trên",
    example: "chấp hành mệnh lệnh của cấp trên",
  },
  {
    word: "mệnh lệnh",
    part_of_speech: "tính từ",
    meaning:
      "(tác phong lãnh đạo) chỉ thích dùng biện pháp ra lệnh, bắt buộc người dưới phải làm theo: tác phong quan liêu, mệnh lệnh",
    example: "tác phong quan liêu, mệnh lệnh",
  },
  {
    word: "mênh mông",
    part_of_speech: "tính từ",
    meaning:
      'rộng lớn đến mức như không có giới hạn: đồng ruộng mênh mông * "Núi cao biển rộng mênh mông, Cù lao chín chữ ghi lòng con ơi!" (ca dao)',
    example:
      'đồng ruộng mênh mông * "Núi cao biển rộng mênh mông, Cù lao chín chữ ghi lòng con ơi!" (ca dao)',
  },
  {
    word: "mênh mang",
    part_of_speech: "tính từ",
    meaning:
      "rộng lớn đến mức gây cảm giác mung lung, mờ mịt: trời biển mênh mang * buồn mênh mang",
    example: "trời biển mênh mang * buồn mênh mang",
  },
  {
    word: "mệt mỏi",
    part_of_speech: "",
    meaning:
      "mệt đến mức không còn muốn làm gì nữa, thường do kiệt sức: tay chân mệt mỏi * đấu tranh không mệt mỏi",
    example: "tay chân mệt mỏi * đấu tranh không mệt mỏi",
  },
  {
    word: "mệt lử",
    part_of_speech: "tính từ",
    meaning:
      "mệt đến mức người như rã rời, không còn hơi sức nào nữa: người mệt lử vì đi nắng * mệt lử cả người",
    example: "người mệt lử vì đi nắng * mệt lử cả người",
  },
  {
    word: "mênh mông bể sở",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) rộng mênh mông, không biết đâu là giới hạn: vùng đất rộng mênh mông bể sở",
    example: "vùng đất rộng mênh mông bể sở",
  },
  {
    word: "mết",
    part_of_speech: "động từ",
    meaning: "(khẩu ngữ) say mê, đắm đuối: cô cậu ấy mết nhau rồi",
    example: "cô cậu ấy mết nhau rồi",
  },
  {
    word: "mệnh trời",
    part_of_speech: "danh từ",
    meaning:
      "số phận do trời quyết định, theo quan niệm mê tín: tin ở mệnh trời * không cưỡng được mệnh trời",
    example: "tin ở mệnh trời * không cưỡng được mệnh trời",
  },
  {
    word: "mệt",
    part_of_speech: "tính từ",
    meaning:
      "có cảm giác sức lực bị tiêu hao quá mức, muốn nghỉ ngơi: mệt bở hơi tai * nghĩ làm gì cho mệt óc",
    example: "mệt bở hơi tai * nghĩ làm gì cho mệt óc",
  },
  {
    word: "mệt",
    part_of_speech: "tính từ",
    meaning:
      "ốm, không được khoẻ (lối nói kiêng tránh): bà cụ mệt đã mấy hôm rồi",
    example: "bà cụ mệt đã mấy hôm rồi",
  },
  {
    word: "mệt",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) không phải đơn giản, dễ dàng, mà còn phải bỏ nhiều sức lực, thời gian hơn nữa: còn mệt mới xong! * có thành công thì cũng còn mệt!",
    example: "còn mệt mới xong! * có thành công thì cũng còn mệt!",
  },
  {
    word: "mệt nghỉ",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) (làm, tiếp nhận cái gì) liên tục, thả sức, đến lúc nào mệt thì nghỉ vì còn hoặc có rất nhiều chứ không hạn chế: thịt gà thì ăn mệt nghỉ * phải uống một trận mệt nghỉ mới thôi!",
    example: "thịt gà thì ăn mệt nghỉ * phải uống một trận mệt nghỉ mới thôi!",
  },
  {
    word: "mệt nhoài",
    part_of_speech: "tính từ",
    meaning:
      "(khẩu ngữ) mệt đến mức như chỉ muốn được nằm dài ra: người mệt nhoài vì phải cuốc bộ cả buổi",
    example: "người mệt nhoài vì phải cuốc bộ cả buổi",
  },
  {
    word: "mệnh phụ",
    part_of_speech: "danh từ",
    meaning:
      "(cũ) người đàn bà được phong phẩm tước do chồng là vương hầu hoặc làm quan to thời phong kiến: mệnh phụ phu nhân",
    example: "mệnh phụ phu nhân",
  },
  {
    word: "mệt xác",
    part_of_speech: "",
    meaning:
      "(khẩu ngữ) mệt, tốn công sức một cách vô ích, không đáng: nghĩ làm gì cho mệt xác!",
    example: "nghĩ làm gì cho mệt xác!",
  },
  {
    word: "mệt nhọc",
    part_of_speech: "tính từ",
    meaning:
      "mệt vì phải bỏ nhiều sức lực (nói khái quát): một ngày lao động mệt nhọc",
    example: "một ngày lao động mệt nhọc",
  },
  {
    word: "mếu máo",
    part_of_speech: "động từ",
    meaning:
      "từ gợi tả dáng miệng bị méo xệch đi khi đang khóc hoặc muốn khóc: miệng mếu máo chực khóc",
    example: "miệng mếu máo chực khóc",
  },
  {
    word: "mếu",
    part_of_speech: "động từ",
    meaning: "(miệng) méo đi chực khóc: cười như mếu * khóc dở mếu dở (tng)",
    example: "cười như mếu * khóc dở mếu dở (tng)",
  },
  {
    word: "mĩ",
    part_of_speech: "tính từ",
    meaning: "đẹp: cái chân, cái thiện, cái mĩ",
    example: "cái chân, cái thiện, cái mĩ",
  },
];
export default words;
